(function () {
  'use strict';

  angular
    .module('phenix', [


        /*=============================================
        =               Shared modules               =
        =============================================*/
        'phenix.core'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('ConsultTmController', ConsultTmController);

  /** @ngInject */
  function ConsultTmController($modalInstance, modalOpts) {
    var vm = this;


    function init() {
      vm.cancel = cancelGeneric;
      vm.add = add;
      vm.tm = modalOpts.tm;
      vm.mainCategoryTM = modalOpts.category;
      vm.subCategoryTM = findSubCategoryTM(vm.tm, modalOpts.category);
      vm.copyTM = angular.copy(modalOpts.tm);
      vm.isForfait = vm.copyTM.time ? false : true;
      vm.userConnectedToDMS = modalOpts.profil.dmsConnected;
    }


    // Close a modal, passing a result
    function add(callBackValue) {
      if(modalOpts.addTmToTarget) {
        modalOpts.addTmToTarget(vm.copyTM);
      }
      $modalInstance.close(callBackValue);
    }


    function findSubCategoryTM(tm, mainCategory) {
      return _.find(mainCategory.subCategories, _.flow(
        _.property('tms'),
        _.partialRight(_.some, { identifier: tm.identifier })
      ));
    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }


    // Recalculates and positions the top position of the modal
    //TODO delete if nerver used
    // function repositionGeneric() {
    //   $modalInstance.reposition();
    // }


    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('AddTmFavouriteCtrl', AddTmFavouriteCtrl);

  /** @ngInject */
  function AddTmFavouriteCtrl($modalInstance, modalOpts,FavsConstant, FavsMetierService,ConfigMetierService, CacheService, CacheConstants) {
    var vm = this;
    vm.showSecondPart = false;
    vm.isTmBusiness= false;


    //constant ids of categories
    var constId = {
      flatRate: {
        id: "1"
      },
      mechanic: {
        id: "2",
        subCateg: {
          motor: "1",
          transmission: "2",
          mechanism: "3",
          airConditioning: "4",
          electric: "5"
        }
      },
      coachWork: {
        id: "3",
        subCateg: {
          bodyWork: "1",
          accessories: "2",
          impermeability: "3",
          trim: "4"
        }
      },
      paint: {
        id: "4"
      }
    };

    //constant back for technical
    vm.constTech = {
      normal: 'N',
      high: 'T',
      veryHigh: 'H'
    };

    function init() {

      vm.cancel = cancelGeneric;
      vm.submit = submit;
      vm.onSelectCategory = onSelectCategory;
      vm.onSelectSubCategory = onSelectSubCategory;
      vm.onSelectTechnical = onSelectTechnical;
      vm.isFlatRate = isFlatRate;

      vm.categories = modalOpts.categories;
      vm.disableTechnical = false;


      var profil = CacheService.getObject(CacheConstants.profil);
      if(profil.isManageDealer){
        vm.isManageBusiness=true;
      }else{
        vm.isManageBusiness=false;
      }

      vm.copyTm = angular.copy(modalOpts.tm) || {};
      if(vm.copyTm.type && vm.copyTm.type === FavsConstant.DEALER_TYPE){
        vm.isTmBusiness = true;
      }else{
        vm.copyTm.type = FavsConstant.USER_TYPE;
      }

      //if modification
      if(modalOpts.tm) {
        vm.catSelected = modalOpts.catSelected;
        vm.subCatSelected = modalOpts.subCatSelected;
        vm.isModification = true;
        vm.showSecondPart = true;
        if(modalOpts.tm.type === FavsConstant.DEALER_TYPE){
        vm.isTmBusiness=true;
        }
        else if(modalOpts.tm.type === FavsConstant.USER_TYPE){
          vm.isTmBusiness=false;
        }
      }
      var config = ConfigMetierService.getSettings();
      if (config) {
        vm.currency =config.localization.currency;
      }

    }

    /**
     * Call on choose category in select dropdown
     */
    function onSelectCategory() {
      if(vm.catSelected.id === constId.flatRate.id) {
        vm.disableTechnical = true;
        vm.showSecondPart = true;
        vm.copyTm.technicality = null;
        vm.copyTm.id = createId();
      } else if(vm.catSelected.id === constId.paint.id) {
        vm.copyTm.technicality = vm.constTech.high;
        vm.disableTechnical = true;
        vm.showSecondPart = true;
        vm.copyTm.id = createId();
      } else {
        vm.disableTechnical = false;
        vm.showSecondPart = false;
      }
    }


    function onSelectSubCategory() {
      if(vm.copyTm.technicality) {
        vm.copyTm.id = createId();
        vm.showSecondPart = true;
      }
    }


    function onSelectTechnical() {
      if(vm.subCatSelected) {
        vm.copyTm.id = createId();
        vm.showSecondPart = true;
      }
    }

    function isFlatRate() {
      if(vm.catSelected) {
        return vm.catSelected.id === constId.flatRate.id
      }
      return false;
    }

    function sendTmBack(categId, subCategId, tmRequest) {
      FavsMetierService.createTmBack(categId, subCategId, tmRequest).then(function (response) {
        if(response.errorCode) {
          $modalInstance.dismiss('error');
        } else {
          okGeneric(response);
        }
      })
    }

    function updateTmBack(categId, subCategId, tmRequest) {
      FavsMetierService.updateTmBack(categId, subCategId, tmRequest).then(function (response) {
        if(response.errorCode) {
          $modalInstance.dismiss('error');
        } else {
          mergeOriginalAndCopy(modalOpts.tm, vm.copyTm);
          okGeneric(response);
        }
      })
    }

    function submit() {
      if(vm.isTmBusiness){
        vm.copyTm.type = FavsConstant.DEALER_TYPE;
      }else{
        vm.copyTm.type = FavsConstant.USER_TYPE;
      }
      if(vm.copyTm.designation && (vm.copyTm.priceExclTaxes || vm.copyTm.time)) {
        //var tmRequest = createTm();
        var subCategId = vm.subCatSelected? vm.subCatSelected.id : '';
        if(vm.isModification) {
          if(!subCategId){
            subCategId = findCategAndSub(vm.catSelected.id, subCategId, vm.copyTm);
          }
          updateTmBack(vm.catSelected.id, subCategId, vm.copyTm);
        } else {
          sendTmBack(vm.catSelected.id, subCategId, vm.copyTm);
        }

      }
    }

    function findCategAndSub(categId, subCategId, tm){
      var indexCat;
      var indexSubCat;
      var indexTm;
      if(vm.categories){
        for(indexCat = 0; indexCat < vm.categories.length; indexCat++){
          if(vm.categories[indexCat]){
            if(vm.categories[indexCat].subCategories){
              for(indexSubCat = 0; indexSubCat < vm.categories[indexCat].subCategories.length; indexSubCat++){
                if(vm.categories[indexCat].subCategories[indexSubCat]){
                  if(vm.categories[indexCat].subCategories[indexSubCat].tms){
                    for(indexTm = 0; indexTm < vm.categories[indexCat].subCategories[indexSubCat].tms.length; indexTm++){
                      if(vm.categories[indexCat].subCategories[indexSubCat].tms[indexTm].identifier === tm.identifier){
                        categId = vm.categories[indexCat].id;
                        subCategId = vm.categories[indexCat].subCategories[indexSubCat].id;
                        return subCategId;
                      }
                    }
                  }
                }
              }
            }
          }
        }

      }

    }

    function mergeOriginalAndCopy(original, copy) {
      original.id = copy.id;
      original.designation =  copy.designation;
      original.technicality = copy.technicality;
      original.specialty = copy.specialty;
      original.description = copy.description;
      /*copy.type = FavsConstant.DEALER_TYPE;*/
      original.type= copy.type;

      if(isFlatRate()) {
        original.priceExclTaxes = copy.priceExclTaxes;
      } else {
        original.time = copy.time;
      }
    }


    function createId() {
      var categoryId = vm.catSelected.id;
      if(categoryId === constId.flatRate.id) {
        return "0999";
      } else if(categoryId === constId.paint.id) {
        return "9499";
      } else {
        var subCategoryId = vm.subCatSelected.id;
        var beginCode = addCategoryCode(categoryId, subCategoryId)
        var endCode = addTechnicalCode(vm.copyTm.technicality);
        return beginCode + endCode;
      }
    }


    function addCategoryCode(categoryId, subCategoryId) {
      var code;
      if(categoryId === constId.mechanic.id) {
        if(subCategoryId === constId.mechanic.subCateg.motor) {
          code = '1';
        } else if(subCategoryId === constId.mechanic.subCateg.transmission) {
          code = '2';
        } else if(subCategoryId === constId.mechanic.subCateg.mechanism) {
          code = '3';
        }else if(subCategoryId === constId.mechanic.subCateg.airConditioning) {
          code = '6';
        } else if(subCategoryId === constId.mechanic.subCateg.electric) {
          code = '8';
        } else {
          code = '';
        }
      } else if(categoryId === constId.coachWork.id) {
        if(subCategoryId === constId.coachWork.subCateg.bodyWork) {
          code = '4';
        } else if(subCategoryId === constId.coachWork.subCateg.accessories) {
          code = '5';
        }else if(subCategoryId === constId.coachWork.subCateg.impermeability) {
          code = '6';
        }else if(subCategoryId === constId.coachWork.subCateg.trim) {
          code = '7';
        } else {
          code = '';
        }
      }
      return code;
    }

    function addTechnicalCode(technical) {
      if(technical === vm.constTech.normal) {
        return "999";
      } else if(technical === vm.constTech.high) {
        return "888";
      } else if(technical === vm.constTech.veryHigh){
        return "777";
      } else {
        return '';
      }
    }

    // Close a modal, passing a result
    function okGeneric(callBackValue) {
      var toasterMessage=vm.isModification?"FAV_ADD_TM_MODIF_SUCCESS":"FAV_ADD_TM_SUCCESS";
      if(modalOpts.okAction) {
        modalOpts.okAction(toasterMessage);
      }
      $modalInstance.close(callBackValue);
    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }


    // Recalculates and positions the top position of the modal
    //TODO delete if nerver used
    // function repositionGeneric() {
    //   $modalInstance.reposition();
    // }


    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('carMaintenanceProgramWsService', carMaintenanceProgramWsService);

  /** @ngInject */
  function carMaintenanceProgramWsService(
    CacheService,
    CarSearchConstants,RestUpgrade,
    CacheConstants, $q,UtilsMetierService
  ) {
    this.getVinRep = getVinRep;
    this.getVinOperation = getVinOperation;
    this.getVinMileage = getVinMileage;
    
    const mileageCache = {};

    function getVinRep(restVinReP) {

      // list of languages available in REP Web Service
      var countriesCode = ['cs', 'de', 'da', 'es', 'fi', 'en', 'el', 'hr', 'hu', 'it', 'nl', 'no', 'pl', 'pt',
        'ro', 'ru', 'sv', 'sl', 'sk', 'tr', 'fr', 'et', 'lt', 'lv', 'bg', 'uk', 'br'];

      var user = CacheService.getObject(CacheConstants.profil);
      // the default english is English
      var countryCode = 'en';
      // select language
      if (user.documentationFirstLanguage) {
        countryCode = user.documentationFirstLanguage.code.includes("-") && (countriesCode.indexOf(user.documentationFirstLanguage.code.substr(3, 2).toLowerCase()) != -1) ? user.documentationFirstLanguage.code.substr(3, 2).toLowerCase() : ((countriesCode.indexOf(user.documentationFirstLanguage.code != -1) ? user.documentationFirstLanguage.code : 'en'));
      }
      else if (user.documentationSecondLanguage) {
        countryCode = user.documentationSecondLanguage.code.includes("-") && (countriesCode.indexOf(user.documentationSecondLanguage.code.substr(3, 2).toLowerCase()) != -1) ? user.documentationSecondLanguage.code.substr(3, 2).toLowerCase() : ((countriesCode.indexOf(user.documentationSecondLanguage.code != -1) ? user.documentationSecondLanguage.code : 'en'));
      }

      var urls = [];
      var isShowPlannedAssistance = UtilsMetierService.isPlannedAssistance();
      if (isShowPlannedAssistance) {
        urls = [CarSearchConstants.restVinReP + "/" + restVinReP.vin + "?lang=" + countryCode, CarSearchConstants.vinOperationControllerV2 +  restVinReP.vin + CarSearchConstants.vinOperationOperationV2 + "?preferredLanguage=" + countryCode + "&defaultLanguage=en", CarSearchConstants.vinMileageNewV2 + restVinReP.vin + "/mileage"]
      } else {
        urls = [CarSearchConstants.restVinReP + "/" + restVinReP.vin + "?lang=" + countryCode]

      }
      var promises = urls.map(function (url) {
        return RestUpgrade.one(url).get().catch(function (e) { return null })
      })
        , all = $q.all(promises).then(function (data) {
          if (isShowPlannedAssistance && data[2]) {
            mileageCache[restVinReP.vin] = data[2];
          }
          return data
        })
      return all;
    }

    function getVinOperation(requestVinOperatin) {
      var url = CarSearchConstants.vinOperationControllerV2 +  requestVinOperatin.vin + CarSearchConstants.vinOperationOperationV2;
      if (parseInt(requestVinOperatin.mileage, 10))
        url = url + '?mileage=' + requestVinOperatin.mileage
      return RestUpgrade.one(url).get();
    }
    function getVinMileage(requestVinMileage) {

      if (mileageCache[requestVinMileage.vin]) {
        return $q.resolve(mileageCache[requestVinMileage.vin]);
      }

      var url = CarSearchConstants.vinMileage + "/" + requestVinMileage.vin + "/mileage";
      return RestUpgrade.one(url).get().then(function(response) {
        mileageCache[requestVinMileage.vin] = response;
        return response;
      });
    }

  }
})();



(function () {
    'use strict';

    angular
        .module('phenix')
        .service('carMaintenanceProgramMetierService', carMaintenanceProgramMetierService);

    /** @ngInject */
    function carMaintenanceProgramMetierService(
       

        carMaintenanceProgramWsService,

        CacheService

        
    ) {

            /*=============================================
            =                  VARIABLES                  =
            =============================================*/

            this.getVehicleVin = getVehicleVin;
            this.getVinRep = getVinRep;
            this.getVinOperation = getVinOperation;
            this.getVinMileage = getVinMileage;
            
            /*=============================================
            =                  FUNCTIONS                  =
            =============================================*/

            /**
             * @name getTechnical
             * @desc get the Vin information of the vehicule
            
             */
            function getVehicleVin() {
                var carContext = CacheService.getCarContext();

                var payload = {
                    carContext: carContext,
                    vin: carContext.vehicle.vin
                }
               
                return payload;
            }
    
            function getVinRep() {
                var user = CacheService.getUserContext();
                var contextCar = CacheService.getCarContext();
    
              
    
                var requestVinrep = {
                    vin: contextCar.vin
                   
                };
                return carMaintenanceProgramWsService.getVinRep(requestVinrep).then(function (response) {
                   
                   
                    return response
                });
            }

            function getVinOperation(mileage) {
                var contextCar = CacheService.getCarContext();
                var requestVinOperatin = {
                    vin: contextCar.vin,
                    mileage: mileage
                };
                return carMaintenanceProgramWsService.getVinOperation(requestVinOperatin).then(function (response) {  
                    return response
                });
            }
            function getVinMileage() {
                var contextCar = CacheService.getCarContext();
                var requestVinMileage = {
                    vin: contextCar.vin                 
                };
                return carMaintenanceProgramWsService.getVinMileage(requestVinMileage).then(function (response) {  
                    return response
                });
            }
           

            /*=============================================
            =                  TOOLS                      =
            =============================================*/
    }

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('CarTechnicalCriteriaWsService', CarTechnicalCriteriaWsService);

  /** @ngInject */
  function CarTechnicalCriteriaWsService(
    RestUpgrade, CarTechnicalFeaturesConstants
    ) {

    this.getTechnical = getTechnical;

    function getTechnical(TechnicalSearch){
      var url = CarTechnicalFeaturesConstants.getTechnical;
      return RestUpgrade.all(url).post(TechnicalSearch)
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('CarTechnicalCriteriaMetierService', CarTechnicalCriteriaMetierService);

    /** @ngInject */
    function CarTechnicalCriteriaMetierService(
        $translate,

        CarTechnicalCriteriaWsService,

        CacheService,

        CarTechnicalFeaturesConstants,
        CacheConstants) {

            /*=============================================
            =                  VARIABLES                  =
            =============================================*/

            this.getTechnical = getTechnical;

            /*=============================================
            =                  FUNCTIONS                  =
            =============================================*/

            /**
             * @name getTechnical
             * @desc get technical objects of each categories for the current user context and car context
             * @desc add Paint type object after Tainte caisse (141) if user is connected dms
             * @param {Boolean} isDmsConnected - true if user is connected to DMS, false else
             * @return {Promise}
             * translatedTC: {
             *      codeObject: '001',
             *      labelObject: 'famille',
             *      codeCriteria: 'X85',
             *      labelCriteria: 'CLIO 3',
             *      languageCriteria: fr
             * }
             */
            function getTechnical(isDmsConnected) {
                var userContext = CacheService.getUserContext();
                var carContext = CacheService.getCarContext();

                var payload = {
                    userContext: userContext,
                    carContext: carContext
                }
                var dmsPainType= '';
                var dmsResponse = {};

                return CarTechnicalCriteriaWsService.getTechnical(payload)
                    .then(function(response){
                        var translatedTC = [];
                        response.translatedTC.forEach(function(item){
                            translatedTC.push(item);
                            if(isBodyTintAndDmsConnected(item.codeObject, isDmsConnected)){
                                dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                                if(dmsResponse){
                                    dmsPainType= dmsResponse.vehicle.paintType;
                                }
                                translatedTC.push(addPaintType(dmsPainType));
                            }
                        });
                        response.translatedTC = translatedTC;
                        return response;
                    });
            }

            /*=============================================
            =                  TOOLS                      =
            =============================================*/

            /**
             * @name addPaintType
             * @desc add Paint Type Object using dms's paint Type value
             * @param {String} paintType
             * "paintType":"O", "V", "N","S",""
             * @return {Object}
             * {
             *      "codeObject": "DmsPaintType",
             *      "labelObject": "PAINT_TYPE",
             *      "labelCriteria": "OPAQUE_COLOR"
             * }
             */
            function addPaintType(paintType){
                var color = "";
                var paintTypeObject= {};
                switch(paintType){
                    case 'O':
                        color = 'TM_TYPE_PAINT_1';
                        break;
                    case 'V':
                        color = 'TM_TYPE_PAINT_2';
                        break;
                    case 'N':
                        color = 'TM_TYPE_PAINT_3';
                        break;
                    case 'S':
                        color = 'TM_TYPE_PAINT_4';
                        break;
                }

                paintTypeObject.labelObject = $translate.instant("PAINT_TYPE");
                paintTypeObject.labelCriteria = $translate.instant(color);
                paintTypeObject.codeObject = "DmsPaintType";

                return paintTypeObject;
            }

            /**
             * @name isBodyTintAndDmsConnected
             * @desc check if user is connected dms and if the current object is bodyTint(141)
            function isBodyTintAndDmsConnected(codeObject, isDmsConnected){
             * @param {String} translatedCriteriaItem
             * @param {String} isDmsConnected
             */
            function isBodyTintAndDmsConnected(codeObject, isDmsConnected){
                return codeObject === CarTechnicalFeaturesConstants.bodyTint && isDmsConnected;
            }

    }

})();

(function () {
    'use strict';
    angular.module('phenix').service('CarOtsWsService', CarOtsWsService);


    function CarOtsWsService(
        $q,
        RestUpgrade,
        CarSearchConstants) {

        this.getOts = getOts;
        this.getOtsLink = getOtsLink;
        this.getOtsInformation = getOtsInformation;

        function getOts(requestOts) {
            var queryParam = requestOts.language + '_' + requestOts.country

            return RestUpgrade.one(CarSearchConstants.restCarOts + '' + requestOts.vin)
                .get({ locale: queryParam })
                .then(function (response) {
                    return response
                }).catch(function(){
                    return $q.reject({})
                });
        }

        function getOtsLink(user, BT, list, nextUrl) {
            if (!list) {
                list = []
            }
            var endpoint = (nextUrl) ? nextUrl : CarSearchConstants.technicalBulletins ;

            return RestUpgrade
                .one(endpoint)
                .post('', { userContext: user, BT: BT })
                .then(function (response) {
                    if (response.errors) {
                        // TODO reject something;
                        return $q.reject({})
                    }

                    list = list.concat(response.BT);
                    if (response.nextUrl) {
                        return getOtsLink(user, BT, list, response.nextUrl);
                    } else {
                        return list;
                    }
                });
        }

        function getOtsInformation(vin, queryParams) {
            let apiPath = CarSearchConstants.restCarOtsInformations + '/' + vin + '/ots-informations';
            
            return RestUpgrade.one(apiPath)
                .get(queryParams || {})
                .then(function (response) {
                    return response;
                }).catch(function(error) {
                    return $q.reject(error);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('CarOtsMetierService', CarOtsMetierService);

    /** @ngInject */
    function CarOtsMetierService(
        CacheService,

        CarOtsWsService,

        CarOtsConstants,$q,$filter) {

        this.getOts = getOts;
        this.getOtsWithLink = getOtsWithLink;
        this.getOtsInformation = getOtsInformation;

        function getOts() {
            var user = CacheService.getUserContext();
            var contextCar = CacheService.getCarContext();
            var userProfile = CacheService.getUserProfile();

            var langOts = CarOtsConstants.languages.filter(function (language) {
                return user.language === language;
            })

            if (!langOts.length) {
                langOts = CarOtsConstants.languages.filter(function (language) {
                    return user.substitutionLanguage === language;
                });
            }

            if (!langOts.length) {
                langOts = [CarOtsConstants.defaultLang];
            }

            var requestOts = {
                vin: contextCar.vin,
                language: langOts[0],
                country: (userProfile && userProfile.country) ? userProfile.country : ""
            };
            return CarOtsWsService.getOts(requestOts).then(function (response) {
                var otsList = (response && response.data && !_.isEmpty(response.data)) ? response.data : [];
                otsList = otsList.map(function (ots) {
                    var ma = ots.agreement == 1 ? "COMMON_YES" : "COMMON_NO";
                    var fullTechnicalNoteId = ots.technicalNoteNumber;
                    if(ots.technicalNoteNumber && ots.technicalNoteNumber != 'NA'){
                      var technicalNoteId = ots.technicalNoteNumber.toString();
                        var lastChar = technicalNoteId.substring(technicalNoteId.length - 1, technicalNoteId.length);
                        if (isNaN(parseInt(lastChar, 10))) {
                            technicalNoteId = technicalNoteId.substring(0, technicalNoteId.length - 1);
                        }
                    }                
                    return {
                        id: ots.code,
                        colorCode: ots.colorCode,
                        designation: ots.label,
                        technicalNoteId: technicalNoteId ? technicalNoteId : null,
                        mandatoryApproval: ma,
                        description: ots.description,
                        fullTechnicalNoteId: fullTechnicalNoteId ? fullTechnicalNoteId : null
                    }
                });
                otsList = $filter('filter')(otsList, function (value) {
                    if(value.colorCode === 'R' || value.colorCode === 'B')
                    return value;
                }); 
                return otsList
            }).catch(function(err){
                return $q.reject()
            });
        }

        /*
            On recupere tous les BT de chaque OTS pour les envoyer a un service
            qui va nous renvoyer le lien vers la documentation qui est soit :
                * PDF
                * XML

            On fait le nappage entre la list OTS et le retour du service.
            Si jamais le service renvoit une erreur, je retourne la liste d'ots sans les liens
        */
        function getOtsWithLink(otsList) {
            var user = CacheService.getUserContext();
            var BT = otsList.map(function(ots) {
                return ots.technicalNoteId;
            })
            return CarOtsWsService.getOtsLink(user, BT).then(function (response) {
                return otsList.map(function(ots) {
                    ots.link = _.find(response, function (BT) {
                        return BT.name == ots.technicalNoteId
                    })
                    return ots;
                })
            }, function () {
                return otsList;
            })

        }

        function getOtsInformation(vin, queryParams){
            return CarOtsWsService.getOtsInformation(vin, queryParams).then(function (response) {
                return response.data  ?  response.data : [];
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('vehicleMaintenanceHistoryWsService', vehicleMaintenanceHistoryWsService);

  /** @ngInject */
  function vehicleMaintenanceHistoryWsService(
    CacheService,
    CarSearchConstants,
    CacheConstants,
    PanierConstants,
    configConstantes,
    RestUpgrade,
    $translate, toastr
  ) {
    this.getVinRep = getVinRep;
    this.getOperationDetail = getOperationDetail;
    this.getInterventionData = getInterventionData;
    this.updateOperationInformation = updateOperationInformation;
    this.deleteOperation = deleteOperation;

    function getVinRep(restVinReP) {
      var user = CacheService.getObject(CacheConstants.profil);

      // the default language is English
      var countryCode = 'en_GB';

      // select language
      if (user.documentationFirstLanguage) {
        countryCode = user.documentationFirstLanguage.code + "_" + user.documentationFirstLanguage.countryCode;
      }
      else if (user.documentationSecondLanguage) {
        countryCode = user.documentationFirstLanguage.code + "_" + user.documentationFirstLanguage.countryCode;
      }
      var url = CarSearchConstants.restOperationsVin + "/" + restVinReP.vin + "?locale=" + countryCode;
      
        return RestUpgrade.one(url).get().catch(function(e){return null});
     
    }


    function getOperationDetail(id,refType, refModule) {
      var user = CacheService.getObject(CacheConstants.profil);

      // the default language is English
      var countryCode = 'en_GB';

      // select language
      if (user.documentationFirstLanguage) {
        countryCode = user.documentationFirstLanguage.code + "_" + user.documentationFirstLanguage.countryCode;
      }
      else if (user.documentationSecondLanguage) {
        countryCode = user.documentationFirstLanguage.code + "_" + user.documentationFirstLanguage.countryCode;
      }
      var url = CarSearchConstants.restOperationDetail + "/" + id + "?refType="+ refType + "&refModule=" + refModule + "&locale=" + countryCode;
      return RestUpgrade.one(url).get();
    }

    function getInterventionData(vin,operationId){
      var url;
      if(operationId)
        url = PanierConstants.operationDetails + vin + PanierConstants.operations + '/' +operationId;
      else
        url = PanierConstants.operationDetails + vin + PanierConstants.operations;
      
      return RestUpgrade.one(url).get().catch(function(e){return null});
    }

    function updateOperationInformation(vin, operationId, updateData) {
      var url = PanierConstants.operationDetails + vin + PanierConstants.operations + '/' + operationId;
      return RestUpgrade.one(url).customPUT(updateData).then(function (response) {
        return response;
      }).catch(function () {
        toastr.error($translate.instant('ERROR'));
      });
    }

    function deleteOperation(vin, operationId) {
      const url = PanierConstants.operationDetails + vin + PanierConstants.operations + '/' + operationId;
      return RestUpgrade.one(url).remove().then(function (response) {
        return response;
      }).catch(function () {
        toastr.error($translate.instant('ERROR'));
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('vehicleMaintenanceHistoryMetierService', vehicleMaintenanceHistoryMetierService);

    /** @ngInject */
    function vehicleMaintenanceHistoryMetierService(
        vehicleMaintenanceHistoryWsService,
        CacheService
    ) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.getVehicleVin = getVehicleVin;
        this.getVinRep = getVinRep;
        this.getOperationDetail = getOperationDetail;
        this.getInterventionData = getInterventionData;
        this.updateOperationInformation = updateOperationInformation;
        this.deleteOperation = deleteOperation;
        /*=============================================
        =                  FUNCTIONS                  =
        =============================================*/

        /**
         * @name getTechnical
         * @desc get the Vin information of the vehicule
        
         */
        function getVehicleVin() {
            var carContext = CacheService.getCarContext();

            var payload = {
                carContext: carContext,
                vin: carContext.vehicle.vin
            }

            return payload;
        }

        function getVinRep() {
            var user = CacheService.getUserContext();
            var contextCar = CacheService.getCarContext();
            var requestVinrep = {
                vin: contextCar.vin
            };
            return vehicleMaintenanceHistoryWsService.getVinRep(requestVinrep).then(function (response) {
                return response
            });
        }

        function getOperationDetail(id, refType, refModule){
            return vehicleMaintenanceHistoryWsService.getOperationDetail(id,refType,refModule).then(function (response) {
                return response
            });
        }
        function getInterventionData(vin, operationId){
            return vehicleMaintenanceHistoryWsService.getInterventionData(vin,operationId).then(function (response) {
                return response;
            }).catch(function(error){
                return error;
            });
        }

        function updateOperationInformation(vin, operationId, updateData) {
            return vehicleMaintenanceHistoryWsService.updateOperationInformation(vin, operationId, updateData).then(function (response) {
                return response;
            });
        }

        function deleteOperation(vin, operationId) {
            return vehicleMaintenanceHistoryWsService.deleteOperation(vin, operationId).then(function (response) {
                return response;
            });
        }
    }

})();

(function() {
    'use strict';

    /**
     * @desc filters tm directive that can be used anywhere across the tm module
     * @param {array} tmDocuments used to display in the tm panel
     * @param {array} tmOperations used to display operations in the filters section
     * @param {array} tmElements used to display elements in the filters section
     * @param {array} selectedFilters used to show the filters (elements and operations) to apply to Tm list
     * @example <tm-filters tm-documents='tmDocumentsCtrl.listOfTMDocuments' tm-operations='tmDocumentsCtrl.listTMOperations'
     *  tm-elements='tmDocumentsCtrl.listTMElements'
     * selected-filters='tmDocumentsCtrl.selectedFilters'></tm-filters>
     */

    angular
        .module('phenix')
        .directive('tmFilters', tmFilters);

    /** @ngInject */
    function tmFilters() {
        var directive = {
            templateUrl : "app/components/products/documents/tm/tmFilters/tmFilters.template.html",
            controller: 'tmFiltersController',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            scope: {
                list: '=tmDocuments',
                elements: '=tmElements',
                operations: '=tmOperations',
                selectedFilters: '=selectedFilters'
            }

        };
        return directive;

    }

})();

/**
 * tmFiltersController Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('tmFiltersController', tmFiltersController);

    /**
     * @namespace tmFiltersController
     * @desc manage filters section (elements, operations)
     * @memberOf Controllers
     */

    /* @ngInject */
    function tmFiltersController($scope, $rootScope,$filter) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.filtersSection = {};
        vm.list = $scope.list;
        vm.operations = $scope.operations;
        vm.elements = $scope.elements;
        vm.selectedFilters = $scope.selectedFilters;




        vm.onChangeElement = onChangeElement;
        vm.onChangeOperation = onChangeOperation;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name activate
         * @desc get operations list, elements list,
         * operations list for each element, elements list foreach operation
         * @memberOf Controllers.onChangeElement
         */
        $scope.$watch('vm.list', function () {
            if (vm.list)
                activate();
        })
        function activate() {
            if (vm.list) {
                var filtersResult = [];
                vm.atLeastOneTMDocument = (vm.list && vm.list.length > 0);

                vm.operationsList = rafinateOperationsInfos(vm.operations);
                vm.elementsList = rafinateElementsInfos(vm.elements);
                filtersResult = getFiltersInfos(vm.list);

                vm.operationsKeyValue = $filter('objectKeyValue')(vm.operationsList);
                vm.elementsKeyValue = $filter('objectKeyValue')(vm.elementsList);

                if (filtersResult["operationsByElements"]){
                    vm.operationsListByElements = filtersResult["operationsByElements"];
                }
                if (filtersResult["elementsByOperations"]){
                    vm.elementsListByOperation = filtersResult["elementsByOperations"];
                }
                if (filtersResult["filters"]){
                    vm.filtersSection = filtersResult["filters"];
                }
            }
        }
        $rootScope.$on("filterReset", function(){
            vm.selectedFilters = {
                operation: "",
                element: ""
            };
            activate();
        }) 
        /**
         * @name onChangeElement
         * @desc filter TM list and operations list in filter section using selected element from filters
         * this action trigger when the user change element from filter section
         * @param {string} item selected TM element's value
         * @returns {array} operations applicated to the selected element in filter tab
         * @memberOf Controllers.onChangeElement
         */
        function onChangeElement(item){
            vm.selectedFilters.element = item;
            vm.filtersSection.operations = vm.operationsListByElements[item];
        }


        /**
         * @name onChangeOperation
         * @desc filter TM list and elements list in filter section using selected operation from filters
         * this action trigger when the user change operation from filter section
         * @param {string} item selected TM operation's value
         * @returns {array} elements applicated to the selected operation in filter tab
         * @memberOf Controllers.onChangeOperation
         */
        function onChangeOperation(item){
            vm.selectedFilters.operation = item;
            vm.filtersSection.elements = vm.elementsListByOperation[item];
        }


        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //rafinate operations info using operations list recieved by the service
        //we use this function to display operations filter in html
        function rafinateOperationsInfos(operationsList){
            var operationsInfos  = [];
            var sortableOperations = [];

            for (var operationElement in operationsList) {
                sortableOperations.push([operationElement, operationsList[operationElement].label]);
            }

            sortableOperations.sort(function(operationCode, operationLabel) {
                return (operationCode[1] < operationLabel[1]) ? -1 : (operationCode[1] > operationLabel[1]) ? 1 : 0;
            });

            operationsInfos[""] = "CAR_DOC_RESULT_FILTER_OPE";
            sortableOperations.forEach(function(element){
                operationsInfos[element[0]] = element[1];
            });

            return operationsInfos;
        }



        // rafinate elements infos using elements list recieved by the service
        // we use this function to display elements filter in html

        function rafinateElementsInfos(elementsList) {
            var sortableElements = [];

            for (var element in elementsList) {
                sortableElements.push({
                    prop: element,
                    label: elementsList[element].label
                });
            }

            var elementsSorted = sortableElements.sort(function (a, b) {
                return (a.label < b.label) ? -1 : (a.label > b.label) ? 1 : 0;
            }).reduce(function(acc, element) {
                acc[element.prop] = element.label;
                return acc;
            }, {})

            return _.extend({
                "" : "CAR_DOC_RESULT_FILTER_ELT"
            }, elementsSorted);
        }

        //get elements and operations filters
        //get all operations by selected element, we use it in onChangeElement function
        //get all elements by selected operation, we use it in onChangeOperation function
        function getFiltersInfos(listTMDocuments){

            var filterResult = [];
            var filtersSection = {
                operations: [],
                elements: []
            }
            var operationsListByElements = {};
            var elementsListByOperation = {};

            if (listTMDocuments && listTMDocuments.length > 0) {
                listTMDocuments.forEach(function (currentTMDocument) {
                    currentTMDocument.show = false;
                    currentTMDocument.detailLoaded = false;
                    operationsListByElements[currentTMDocument.element] = [];
                    elementsListByOperation[currentTMDocument.operation] = [];

                    if (filtersSection.operations.indexOf(currentTMDocument.operation) == -1) {
                        filtersSection.operations.push(currentTMDocument.operation);
                    }
                    if (filtersSection.elements.indexOf(currentTMDocument.elemnt) == -1) {
                        filtersSection.elements.push(currentTMDocument.element);
                    }
                });

                operationsListByElements[""] = filtersSection.operations;;
                elementsListByOperation[""] = filtersSection.elements;

                listTMDocuments.forEach(function (currentTMDocument) {
                    if (elementsListByOperation[currentTMDocument.operation].indexOf(currentTMDocument.element) == -1) {
                        elementsListByOperation[currentTMDocument.operation].push(currentTMDocument.element);
                    }

                    if (operationsListByElements[currentTMDocument.element].indexOf(currentTMDocument.operation) == -1) {
                        operationsListByElements[currentTMDocument.element].push(currentTMDocument.operation);
                    }
                });
            }

            filterResult['filters'] = filtersSection;
            filterResult['operationsByElements'] = operationsListByElements;
            filterResult['elementsByOperations'] = elementsListByOperation;

            return filterResult;
        }

    }
})();

(function() {
    'use strict';

    /**
     * @desc get tm information (code, title, ...)
     * @param {array} currentTm current tm object
     * @example <tm-data current-tm='document'></tm-data>
     */

    angular
        .module('phenix')
        .directive('tmData', tmData);

    /** @ngInject */
    function tmData() {
        var directive = {
            templateUrl : "app/components/products/documents/tm/tmData/tmData.template.html",
            controller: 'tmDataController',
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                currentTm: '=currentTm',
                prTm: '=prTm'
            },
            bindToController: true
        };
        return directive;

    }

})();

/**
 * tmDataController Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('tmDataController', tmDataController);

    /**
     * @namespace tmDataController
     * @desc display tm data
     * @memberOf Controllers
     */

    /* @ngInject */
    function tmDataController(CacheService, CacheConstants, DocumentsMetierService, DealerManagerSystemeService,
         $mdDialog, toastr, blockUI,configConstantes,MainMetierService, DmsConstants, $q,
         DocPrivMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.notIncluded = [];
        vm.additionalTo = [];
        var siesByGiesList = [];
        vm.isUserDms = DealerManagerSystemeService.getHookResult();
        vm.isNewSearch = CacheService.getObject(CacheConstants.isSearchEngine);
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.hideDetail = hideDetail;
        vm.showDetail = showDetail;
        vm.showAttachedIllustration = showAttachedIllustration;
        vm.getAbsoluteUrl = getAbsoluteUrl;
        vm.redirectToPlatesCatalogue = redirectToPlatesCatalogue;
        vm.setOpenedTmDetails = setOpenedTmDetails;


        /**
         * @name hideDetail
         * @desc hide current TM element's details
         * this action trigger when the user click on the + icon
         * @param {array} currentTM current TM informations
         * @returns {boolean} current TM is hidden
         * @memberOf Controllers.tmDataController
         */
        function hideDetail(currentTM) {
            currentTM.show = false;
        }

        /**
         * @name showDetail
         * @desc show current TM element's details, having - in the start of the TM line
         * this action trigger when the user click on the - icon
         * @param {array} currentTM current TM informations
         * @returns {boolean} current TM is shown
         * @memberOf Controllers.tmDataController
         */
        function showDetail(currentTM) {
            var gieNotIncluded = [];
            var gieAdditionalTo = [];

            siesByGiesList = CacheService.getSiesByGiesHistory();

            //get gies for current item (not included and additional)
            gieNotIncluded = currentTM.detail.NotIncluded;
            gieAdditionalTo = currentTM.detail.AdditionalTo;

            var tmDetails = DocPrivMetierService.getLabourTimeResposne();

            var selTM = _.find(tmDetails.TM, function(item){
                if(!_.isEmpty(item) && !_.isEmpty(item.id) && !_.isEmpty(currentTM) && !_.isEmpty(currentTM.id) && !_.isEmpty(item.technicalId) && !_.isEmpty(currentTM.technicalId)){
                    return item.id === currentTM.id && item.technicalId == currentTM.technicalId;
                }
            })

            if(selTM && _.has(selTM,'additionalToData') || _.has(selTM,'notIncludedData')){
                vm.notIncluded = selTM.notIncludedData;
                vm.additionalTo = selTM.additionalToData;
                currentTM.show = true;
            }else{

            if (gieNotIncluded.length > 0 && gieAdditionalTo.length > 0) {
                blockUI.start();
                getSieByGie(gieNotIncluded, siesByGiesList).then(function (siesList) {
                    vm.notIncluded = resolveTm(siesList, currentTM.detail.NotIncluded);
                    getSieByGie(gieAdditionalTo, siesByGiesList).then(function (siesList) {
                        vm.additionalTo = resolveTm(siesList, currentTM.detail.AdditionalTo);
                    }).finally(function () {
                        setOpenedTmDetails(currentTM);
                        currentTM.show = true;
                        blockUI.stop();
                    });
                });
            }
            else if (gieNotIncluded.length > 0 && gieAdditionalTo.length == 0) {
                blockUI.start();
                getSieByGie(gieNotIncluded, siesByGiesList).then(function (siesList) {
                    vm.notIncluded = resolveTm(siesList, currentTM.detail.NotIncluded);
                }).finally(function () {
                    setOpenedTmDetails(currentTM);
                    currentTM.show = true;
                    blockUI.stop();
                });
            }
            else if (gieNotIncluded.length == 0 && gieAdditionalTo.length > 0) {
                blockUI.start();
                getSieByGie(gieAdditionalTo, siesByGiesList).then(function (siesList) {
                    vm.additionalTo = resolveTm(siesList, currentTM.detail.AdditionalTo);
                }).finally(function () {
                    setOpenedTmDetails(currentTM);
                    currentTM.show = true;
                    blockUI.stop();
                });
            }
            else {
                currentTM.show = true;
            }
        }

        }    
       
        /**
         * @name showAttachedIllustration
         * @desc show modal with the attached illustration
         * this action trigger when the user click on the attachement icon
         * @param {array} event event object
         * @param {array} attachment containing informations about attachment (partNumber, href and sectionalView)
         * @returns {modal} modal with the corresponding attachment
         * @memberOf Controllers.tmDataController
         */
        function showAttachedIllustration(event, attachment) {
            function DialogController($scope, $mdDialog) {
                if (attachment) {
                    $scope.sectionalView = attachment.sectionalView || null;
                    $scope.href = attachment.href || null;
                    $scope.partNumber = attachment.partNumber || null;
                }

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
            }

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/components/products/documents/tm/tmAttachment.template.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
        };

        /**
         * @name getAbsoluteUrl
         * @desc get illustration's absolute url
         * this action trigger when the user click on the attachement icon
         * @param {string} RelativeUrl
         * @returns {string} absolute url of the attachment
         * @memberOf Controllers.tmDataController
         */
        function getAbsoluteUrl(relativeUrl) {
            return configConstantes.baseUrlBack + relativeUrl;
        }




        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //resolve tm
        //using siesList: resolved gie
        //tmSecion: NotIncluded or Additional
        function resolveTm(siesList, tmSection) {
            var result = [];
            if (siesList.TM && siesList.TM.length > 0) {
                result = siesList;
            }
            else {
                result = tmSection;
            }
            return result;
        }


        //get sies by gie
        //using gieResult, gie list for not included or addtional
        function getSieByGie(gieResult, siesByGiesList) {
            var documents = [];
            var listGieNotResolved = [];

            gieResult.forEach(function (gieItem) {
                if (siesByGiesList[gieItem.element+","+gieItem.operation] && siesByGiesList[gieItem.element+","+gieItem.operation].length > 0) {

                    siesByGiesList[gieItem.element+","+gieItem.operation].forEach(function (sieItem) {

                        var currentDocument = sieItem.id;

                        documents.push(currentDocument);
                    });
                }
                else {
                    var gieNotResolved = {};
                    gieNotResolved.designation = gieItem.designationElemOpe;

                    listGieNotResolved.push(gieNotResolved);
                }          
            });            
            
            if(documents && documents.length > 0){
                return DocumentsMetierService.returnTmDocuments(documents).then(function (response) {
                
                    if (response.error) {
                        toastr.error(response.error.value, response.error.type);
                    }

                    if (listGieNotResolved && listGieNotResolved.length > 0) {
                        response.TM = response.TM.concat(listGieNotResolved);
                    }
                    response.TM = removeDmsTM(response);
                    return response;
                });
            }else{
                var tempResponse = $q.resolve();
                return tempResponse.then(function(){
                    if (listGieNotResolved && listGieNotResolved.length > 0) {
                        tempResponse = {
                            TM: listGieNotResolved
                        }
                    }
                    tempResponse.TM = removeDmsTM(tempResponse);
                    return tempResponse;
                })
            }
        }

        function removeDmsTM(response) {
            return response.TM.filter(function (tm) {
                return (tm.subType != DmsConstants.dms && tm.subType != DmsConstants.dms_Ots);
            });
        }

        //display toastr configuration
        //we use this function to display toast message
        function displayToastr(messageToast, tm, iconClass) {
            toastr.info(messageToast, tm.designation, {
                iconClass: iconClass,
                messageClass: 'toast-estimate-message',
                titleClass: 'toast-estimate-title',
                timeOut: 1500
            });
        }
        function redirectToPlatesCatalogue(selectedTM){
            DocumentsMetierService.filterSelectedIds(selectedTM, 'TM');            
        }

        function setOpenedTmDetails(currentTM){

            var tmDetails = DocPrivMetierService.getLabourTimeResposne();   

            if(tmDetails && tmDetails.TM && tmDetails.TM.length > 0){
                _.map(tmDetails.TM, function(tmItem){
                    if(!_.isEmpty(tmItem)){
                        if(tmItem.id === currentTM.id && tmItem.technicalId === currentTM.technicalId){
                            _.assign(tmItem, 
                                {
                                    additionalToData : vm.additionalTo,
                                    notIncludedData : vm.notIncluded
                                }
                            )
                            return tmItem;
                        }
                    }
                })
                DocPrivMetierService.setLabourTimeResposne(tmDetails); 
            }


        }
            
    }
})();

(function() {
    'use strict';

    /**
     * @desc get tm information (code, title, ...)
     * @param {array} itemTm item tm object
     * @example <tm-details item-tm='row'></tm-details>
     */

    angular
        .module('phenix')
        .directive('tmDetails', tmDetails);

    /** @ngInject */
    function tmDetails() {
        var directive = {
            templateUrl : "app/components/products/documents/tm/tmDetails/tmDetails.template.html",
            controller: 'tmDetailsController',
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                itemTm: '=itemTm',
                prTm: '=prTm',
                isHorseUser: '=isHorseUser'
            },
            bindToController: true
        };
        return directive;

    }

})();

/**
 * tmDetailsController Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('tmDetailsController', tmDetailsController);

    /**
     * @namespace tmDetailsController
     * @desc display tm details
     * @memberOf Controllers
     */

    /* @ngInject */
    function tmDetailsController(CacheService, CacheConstants, DocumentsMetierService, DealerManagerSystemeService, $mdDialog, toastr, 
        $translate, blockUI, ConfigMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.isUserDms = DealerManagerSystemeService.getHookResult();
        vm.isNewSearch = CacheService.getObject(CacheConstants.isSearchEngine);
        vm.showAttachedIllustration = showAttachedIllustration;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name showAttachedIllustration
         * @desc show modal with the attached illustration
         * this action trigger when the user click on the attachement icon
         * @param {array} event event object
         * @param {array} attachment containing informations about attachment (partNumber, href and sectionalView)
         * @returns {modal} modal with the corresponding attachment
         * @memberOf Controllers.showAttachedIllustration
         */
        function showAttachedIllustration(event, attachment) {
            function DialogController($scope, $mdDialog) {
                if (attachment) {
                    $scope.sectionalView = attachment.sectionalView || null;
                    $scope.href = attachment.href || null;
                    $scope.partNumber = attachment.partNumber || null;
                }

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
            }

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/components/products/documents/tm/tmAttachment.template.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
        };



        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //display toastr configuration
        //we use this function to display toast message
        function displayToastr(messageToast, tm, iconClass) {
            toastr.info(messageToast, tm.designation, {
                iconClass: iconClass,
                messageClass: 'toast-estimate-message',
                titleClass: 'toast-estimate-title',
                timeOut: 1500
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.documentMD, {
            url: '/documentMD/{id}/plate/:plateIndex/ref/:refIndex',
            templateUrl: 'app/components/products/documents/md/mdDocuments/mdDocumentsDetails.template.html',
            controller: 'MdDocumentDetailsCtrl',
            controllerAs: 'vm'
        });
    }

})();

(function () {
    'use strict';

    /* CE CONTROLLER SERA SUREMENT A REFACTO */
    angular
        .module('phenix')
        .controller('MdDocumentDetailsCtrl', MrDocumentDetailsCtrl);

    function MrDocumentDetailsCtrl(DocumentsMetierService,CacheService, NavigationSieService, CacheConstants, $scope, $rootScope, blockUI, $state, RoutesConstants, CarSearchResultConstants, $sce, $window, toastr, $translate, $mdDialog,$q, MainMetierService) {

        /*****************
         *  VARIABLE
         ****************/
        var vm = this;
        vm.contentMD = {
            title: null,
            content: null
        };
        vm.listMD = null;
        vm.documentsHistory = [];
        vm.isNewTab = false;

        init();

        /*********************
         *  FUNCTIONS
         ********************/
        vm.backToPreviousDocument = backToPreviousDocument;
        vm.goToListPiece = goToListPiece;
        vm.onClickedLink = onClickedLink;
        vm.onClickedWdLink = onClickedWdLink;
        vm.onClickedWdurlLink=onClickedWdurlLink;
        vm.onClickedNodeLink = onClickedNodeLink;



        function backToPreviousDocument() {
            NavigationSieService.backToPreviousDocument();
        }

        function goToListPiece() {
            NavigationSieService.goToFirstElement();
        }

        /**
         * init.
         * @param {}.
         * @return void
         * usage init()
         */
        function init() {

            if($state.$current.name === RoutesConstants.newTabMD){
                vm.isNewTab = true;
            }

            var documentId = $state.params.id || '';

            var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
            vm.isMDInNewTab = localStorage.getItem('isMDInNewTab');
            localStorage.removeItem('isMDInNewTab');
            
            if(vm.isMDInNewTab){
                $rootScope.$broadcast("isMDInNewTab", vm.isMDInNewTab);
            }
            
            if (!tabIndex) {
                var selectedMd = {
                    id: RoutesConstants.listPieceIndexMD,
                    data: { 'myRef': $state.params.id }
                };

                //set cache tabIndex
                CacheService.setObject(CacheConstants.tabIndex, selectedMd);
            }

            if(!vm.isNewTab){
                //updateDocumentsHistory
                vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'MD', $state.params.plateIndex, $state.params.refIndex);
            }
            

            //get documentation
            getMDDocumentation(documentId);

        }
        function onClickedWdurlLink(cpc,lc,csc)
        { 
            if(vm.isMDInNewTab){
                localStorage.setItem('isMDInNewTab', true);
            }
            
            $state.go(RoutesConstants.carSearchResult, {
                tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                isUserComingFromMD: true,
                id: cpc,
                idOptional: csc,
                WDT: "SCH",
                LC: lc,
                isFromWDUrlLink: true
            }).finally(function () {
                blockUI.stop();
            });

     }

     function onClickedNodeLink(node1, node2, node3){
         $state.go(RoutesConstants.carSearchResult, {
            tab: CarSearchResultConstants.searchTypes.searchByArbo,
            isUserComingFromMD: false,
            node1: node1,
            node2: node2,
            node3: node3,
            isnodeLinkNavigation: true

        }).finally(function () {
            blockUI.stop();
        });
     } 

        function onClickedWdLink(level, wdList) {
            
            if (level && level == 1 && !_.isEmpty(wdList.functionId)) { 
                var data = {
                    nodeOneID : wdList.functionId
                }
                $rootScope.nodeId = data;

                $state.go(RoutesConstants.carSearchResult,
                    {
                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                        isUserComingFromClip: false,
                        functionId: wdList.functionId
                    });
            }
            else if (level && level == 2 && !_.isEmpty(wdList.functionId) && !_.isEmpty(wdList.subFunctionId)) {
                var data = {
                    nodeOneID : wdList.functionId,
                    nodeTwoID : wdList.subFunctionId
                }
                $rootScope.nodeId = data;

                $state.go(RoutesConstants.carSearchResult,
                    {
                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                        isUserComingFromClip: false,
                        functionId: wdList.functionId,
                        subFunctionId: wdList.subFunctionId
                    });
            }
            else if (level && level == 3 && !_.isEmpty(wdList.functionId) && !_.isEmpty(wdList.subFunctionId) && !_.isEmpty(wdList.titleId)) {
                var data = {
                    nodeOneID : wdList.functionId,
                    nodeTwoID : wdList.subFunctionId,
                    nodeThreeID : wdList.titleId
                }
                $rootScope.nodeId = data;

                $state.go(RoutesConstants.carSearchResult,
                    {
                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                        isUserComingFromClip: false,
                        functionId: wdList.functionId,
                        subFunctionId: wdList.subFunctionId,
                        titleId: wdList.titleId
                    });
            }
        }

        function onClickedLink(MDList,popinTitle, isNewtab) {
            vm.isNewtabMD = isNewtab;
            var numberOfMD = MDList.length;
            if (!numberOfMD) {
                vm.listMD = [];
            } else if (numberOfMD > 1 || (numberOfMD === 1 && MDList[0].residual && MDList[0].residual.length)) {

                $mdDialog.show({
                    contentElement: '#myStaticDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true
                });
                vm.listMD = MDList;
                vm.popinTitle = popinTitle;
            } else {
                var id = MDList[0].reference;
                var type = MDList[0].type;
                if (type === 'MR') {
                    if (isNewtab) {
                        localStorage.setItem('isMRInNewTab', true);
                        var url = $state.href(RoutesConstants.documentMR, { id: id });
                        $window.open(url, '_blank');
                    } else {
                        $state.go(RoutesConstants.documentMR, { id: id });
                    }
                }
                else if (type === 'MD') {
                    if(isNewtab) {
                        localStorage.setItem('isMDInNewTab', true);
                        var url = $state.href(RoutesConstants.documentMD, { id: id });
                        $window.open(url, '_blank');
                    } else {
                        vm.isMDInNewTab = false;
                        $state.go(RoutesConstants.documentMD, { id: id });
                    }
                }
            }
        }
        function getMDDocumentation(id) {
            blockUI.start();

            DocumentsMetierService.returnMDDetail(id).then(function (result) {
                vm.contentMD.title = result.title;
                vm.contentMD.content = result.content;
                var contextData = CacheService.getObject(CacheConstants.contextCarRequest);
                dynaMdDataTracking(contextData,id);
            }, function (msg) {
                toastr.error($translate.instant(msg.error.value));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function dynaMdDataTracking(data,id){
            return $q.resolve().then(function(){
                var item = data.model + ', ' + data.motorisation;
                var identity = dtrum.enterAction("trackingmddata", "click", dtrum.now())||0;
                dtrum.addActionProperties(identity, null, null, {"ppx_trackingvehicledata":{
                    value:item
                }});
                dtrum.addActionProperties(identity, null, null, {"ppx_vinnumber":{value:data.vin}}, null);
               dtrum.addActionProperties(identity, null, null, {"ppx_mdid":{value:id}}, null);
               dtrum.leaveAction(identity, dtrum.now());
                     return;
                     }).catch(function(err) {
                         return $q.resolve(data);
                     });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('mdDocuments', mdDocuments);

    /** @ngInject */
    function mdDocuments() {
        // Usage: <mdDocuments docs="vm.listOfMDDocuments"> </mdDocuments>
        //
        // Creates: SmartTable with all the table features
        //
        var directive = {
            templateUrl : "app/components/products/documents/md/mdDocuments/mdDocuments.template.html",
            controller: 'mdDocumentsController',
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                listOfMDDocuments : '=docs',
                hideFilter: '@'
            },
            bindToController: true
        };
        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('mdDocumentsController', mdDocumentsController);

    /* @ngInject */
    function mdDocumentsController($scope, $state, RoutesConstants, CacheService, CacheConstants, DocumentsMetierService, $window, $mdDialog, toastr, $translate,$rootScope,$q,configConstantes) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var typeVehicle = CacheService.getCarContext().typeMD;        
        var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
       
        vm.selectedMD = "";
        vm.selectedMDPdf = "";
        // vm.listOfMDDocuments = $scope.listOfMDDocuments;
        vm.hideFilter = $scope.hideFilter;

        vm.displayMdDetails = displayMdDetails;
        vm.checkTypeMD = checkTypeMD;
        vm.isByArbo = checkLocation(window.location.href);
        vm.isByDefect = false;
        vm.isBySymptom = false;
        vm.isByDTC = false;
        vm.user = CacheService.getUserProfile();
        vm.isRightClick = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        this.$onInit = function () {
            activate();
        };
                

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
       var filterMDReset = $rootScope.$on("filterMDReset", function(event,data){
            vm.listOfMDDocuments = data;
            if (!_.isEmpty(vm.listOfMDDocuments)) {
                vm.listOfMDDocuments = _.sortBy(vm.listOfMDDocuments, [
                    function(item) { return item.ref ? item.ref : '~'; },
                    'subType'
                ]);
            }
            if(vm.listOfMDDocuments && !_.isEmpty(vm.listOfMDDocuments)){
                vm.filtered = vm.listOfMDDocuments
            }
        
            activate();
        });

        $scope.$on('$destroy', filterMDReset);

        function activate() {
            
            if(vm.listOfMDDocuments && !_.isEmpty(vm.listOfMDDocuments)){
                vm.filtered = vm.listOfMDDocuments
            }

            //if tabIndex exists in cache && tabIndex is equal to listPieceIndexMD's index
            if (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexMD && tabIndex.data) {
                vm.selectedMD = tabIndex.data.myRef;
                //remove tabIndex from Cache after getting the selected MD
                CacheService.removeObject(CacheConstants.tabIndex);
            }
            if (!vm.isByArbo) {
                var code = CacheService.getObject(CacheConstants.requestDiagnostic).code;

                if (code.indexOf("DF") > - 1) {
                    vm.isByDefect = true;
                } else if (code.indexOf(" - ") > - 1) {
                    vm.isBySymptom = true;
                } else {
                    vm.isByDTC = true;
                }               
            }
        }    

        /*
        **  B2 = Afichage PDF
        **  B3 = Affichage de la documentation XML || ou modal dont le contenu contient les SIE MD (on réutilise la même directive pour le tableau)
        */

        function displayMdDetails(id, signet, paramUrl, type, pageNum, md, isRightClick) {

            vm.isRightClick = isRightClick;

            var mdType = type ? type.split("-") : null;
            
            if (signet != null && !vm.isRightClick) {
                vm.selectedMDPdf = signet;
                vm.selectedMD = paramUrl;
            }

            if (type == "B2") {
                DocumentsMetierService.returnSiePdfContent(id, 'SIE_MD')
                    .then(function (result) {
                        var url = result.contentUrl;
                        if (pageNum != null) {
                            url += "#page=" + pageNum, '_blank';
                        }
                        var contextData = CacheService.getObject(CacheConstants.contextCarRequest);
                        dynaMdDataTracking(contextData, id);
                        $window.open(url, '_blank');
                    });
            } else {
                displayMdDocumentation(md, paramUrl)
            }
        }
        function dynaMdDataTracking(data,id){
            return $q.resolve().then(function(){
                var item = data.model + ', ' + data.motorisation;
                var identity = dtrum.enterAction("trackingmddata", "click", dtrum.now())||0;
                dtrum.addActionProperties(identity, null, null, {"ppx_trackingvehicledata":{
                    value:item
                }});
                dtrum.addActionProperties(identity, null, null, {"ppx_vinnumber":{value:data.vin}}, null);
               dtrum.addActionProperties(identity, null, null, {"ppx_mdid":{value:id}}, null);
               dtrum.leaveAction(identity, dtrum.now());
                     return;
                     }).catch(function(err) {
                         return $q.resolve(data);
                     });
        }


        function displayMdDocumentation(md, paramUrl) {
            if (md.gateway === "N") {
                if(vm.isRightClick){
                    var url = $state.href(RoutesConstants.newTabMD, { id: paramUrl });
                    $window.open(url, '_blank');
                }else{
                    $state.go(RoutesConstants.documentMD, { id: paramUrl });
                }
                
            } else if (md.gateway === "Y") {
                md.gateway_sies = md.gateway_sies || [];

                var siesLength = md.gateway_sies.length;
                var residual = (siesLength) ? md.gateway_sies[0].residual : null;
                if (!siesLength) {
                    toastr.info($translate.instant('DOCUMENT_NOT_ASSOCIATED'));
                } else if (siesLength === 1) {
                    if(vm.isRightClick){
                        var url = $state.href(RoutesConstants.newTabMD, { id: md.gateway_sies[0].reference });
                        $window.open(url, '_blank');
                    }else{
                        $state.go(RoutesConstants.documentMD, { id: md.gateway_sies[0].reference });
                    }
                } else {
                    $mdDialog.show({
                        templateUrl: 'app/components/products/documents/md/mdDocuments/dialog-md.template.html',
                        parent: angular.element(document.body),
                        controller: 'dialogMdController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            listOfMDDocuments: md.gateway_sies
                        }
                    });
                }
            } else {
                $mdDialog.hide();
                if(vm.isRightClick){
                    var url = $state.href(RoutesConstants.newTabMD, { id: paramUrl, plateIndex: $state.params.plateIndex, refIndex: $state.params.refIndex });
                    $window.open(url, '_blank');
                }else{
                    $state.go(RoutesConstants.documentMD, { id: paramUrl, plateIndex: $state.params.plateIndex, refIndex: $state.params.refIndex });
                }
                
            }
        }

        ////////////////////////

        function checkTypeMD(type) {       
            return typeVehicle === type;
        }

        function checkLocation(url){          
            if(url.indexOf("listePiece") > -1){
                return true;
            }else return false;
        }


    }
})();

(function() {

    angular.module('phenix').controller('dialogMdController', function($mdDialog) {
        var vm = this;

        vm.listOfMDDocuments = formatData(vm.listOfMDDocuments);
        vm.close = close;

        function close() {
            $mdDialog.hide();
        }

        // Reformatage des champs, en fonction des services le meme champ n'a pas forcement le meme nom ...
        // Restructuration de la donnees pour que ca colle a la liste des MD
        function formatData(MDList) {
            return MDList.map(function (md) {
                md.gateway = "Z";
                md.ref = md.reference;
                md.paramURL = md.reference;
                return md
            })
        }


    })
})();

(function () {
    'use strict';

    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.documentBTListDoc, {
            url: '/documentBTListDoc/{id}',
            params : {symptomNumbers : null},
            templateUrl: 'app/components/products/documents/bt/btDocuments/btListDoc.template.html',
            controller: 'BtListDocCtrl',
            controllerAs: 'vm'
        });
    }

})();

(function () {
    'use strict';

    /* CE CONTROLLER SERA SUREMENT A REFACTO */
    angular
        .module('phenix')
        .controller('BtListDocCtrl', BtListDocCtrl);

    /** @ngInject */
        function BtListDocCtrl(DocumentsMetierService, NavigationSieService, CacheService,
            CacheConstants, $scope, $rootScope, blockUI, $state, RoutesConstants, $sce, $window, toastr, $translate, $mdDialog, $document,$timeout) {

        /*****************
         *  VARIABLE
         ****************/
        var vm = this;
        vm.contentBT = {
            title: null,
            content: null
        };
        vm.listBT = null;
        vm.documentsHistory = [];
        vm.btDocumentDetails = null;
        vm.downloadPdf = downloadPdf;

        init();

        /*********************
         *  FUNCTIONS
         ********************/
        vm.backToPreviousDocument = backToPreviousDocument;
        vm.onClickedLink = onClickedLink;
        vm.goToListPiece = goToListPiece;
        



        function backToPreviousDocument() {
            //NavigationSieService.backToPreviousDocument();
            $window.history.back();
        }

        function goToListPiece() {
            NavigationSieService.goToFirstElement();
        }

        function init() {


            //if paramater exists
            if ($state.params.id) {
               
                var documentId = $state.params.id || '';

               var documentDetails = CacheService.getBtListDocumentsHistory();

                //getBTDocumentation details if exists, send error if not
                getBTDocumentation(documentId,documentDetails);
                

            }
        }


        function onClickedLink(BTList) {
            var numberOfMD = BTList.length;
            if (!numberOfMD) {
                vm.listBT = [];
            } else if (numberOfMD > 1 || (numberOfMD === 1 && BTList[0].residual && BTList[0].residual.length)) {

                $mdDialog.show({
                    contentElement: '#myStaticDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true
                });
                vm.listBT = BTList;
            } else {
                var id = BTList[0].reference;
                var type = BTList[0].type;
                if (type === 'MR')
                    $state.go(RoutesConstants.documentMR, { id: id });
                else if (type === 'MD')
                    $state.go(RoutesConstants.documentMD, { id: id });
                else if (type === 'BT')
                    $state.go(RoutesConstants.documentBT, { id: id });
            }
        }

        function getBTDocumentation(id, details) {
            blockUI.start();
            vm.btDocumentDetails = details;
            DocumentsMetierService.returnBTDetail(id, details).then(function (result) {
                vm.contentBT.title = result.title;
                vm.contentBT.content = result.content;
                vm.contentBT.status = result.status;
                vm.contentBT.sieVersion = result.sieVersion;
                vm.contentBT.sieName = result.sieName;
                vm.canPrint = true;
            }, function (msg) {
                toastr.error($translate.instant(msg.error.value));
                vm.canPrint = false;
            }).finally(function () {
                blockUI.stop();
            });
        }

        function downloadPdf() {
            const PDF_URL_REVOKE_DELAY_MS = 60000;
            blockUI.start();

            const documentId = $state.params.id || '';
            const documentDetails = vm.btDocumentDetails;

            DocumentsMetierService.getBTPdf(documentId, {
                btDocumentDetails: documentDetails,
                renderedContent: vm.contentBT.content,
                documentTitle: vm.contentBT.title
            }).then(function (pdfBlob) {
                blockUI.stop();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                $window.open(pdfUrl, '_blank');

                $timeout(function () {
                    URL.revokeObjectURL(pdfUrl);
                }, PDF_URL_REVOKE_DELAY_MS);
            }, function (_error) {
                blockUI.stop();
                toastr.error($translate.instant('ERROR'));
            });
        }


    }
})();

(function () {
    'use strict';

    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.documentBT, {
            url: '/documentBT/{id}',
            params : {symptomNumbers : null, previousPageDetails : null},
            templateUrl: 'app/components/products/documents/bt/btDocuments/btDocumentsDetails.template.html',
            controller: 'BtDocumentDetailsCtrl',
            controllerAs: 'vm'
        });
    }

})();

(function () {
    'use strict';

    /* CE CONTROLLER SERA SUREMENT A REFACTO */
    angular
        .module('phenix')
        .controller('BtDocumentDetailsCtrl', BtDocumentDetailsCtrl);

    /** @ngInject */
        function BtDocumentDetailsCtrl(DocumentsMetierService, NavigationSieService, CacheService,
            CacheConstants, $scope, $rootScope, blockUI, $state, RoutesConstants, $sce, $window, toastr, 
            $translate, $mdDialog,$timeout) {

        /*****************
         *  VARIABLE
         ****************/
        var vm = this;
        vm.contentBT = {
            title: null,
            status: null,
            sieVersion: null,
            sieName: null,
            content: null
        };
        vm.listBT = null;
        vm.documentsHistory = [];
        vm.btDocumentDetails = null;
        vm.isNewTab = false;
        vm.isSameTab = false;
        vm.downloadPdf = downloadPdf;

        init();

        /*********************
         *  FUNCTIONS
         ********************/
        vm.backToPreviousDocument = backToPreviousDocument;
        vm.onClickedLink = onClickedLink;
        vm.goToListPiece = goToListPiece;

        function backToPreviousDocument() {
            NavigationSieService.backToPreviousDocument();
            //$window.history.back();
        }

        function goToListPiece() {
            NavigationSieService.goToFirstElement();
        }

        function init() {
            if($state.$current.name === RoutesConstants.newTabBT){
                if($state.params.docDetails){
                    vm.isSameTab = true;
                }else{
                    vm.isNewTab = true;
                }
                
            }

            //if paramater exists
            if ($state.params.id) {
                var documentDetails = $state.params.symptomNumbers; 
                var documentId = $state.params.id || '';
                var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
                var plateIndex = $state.params.plateIndex || '0';
                var refIndex = $state.params.refIndex || '0';
                var documentType = 'BT';
                var tabName = '';
                vm.isBTInNewTab = localStorage.getItem('isBTInNewTab');
                localStorage.removeItem('isBTInNewTab');
                if (vm.isBTInNewTab)
                    $rootScope.$broadcast("isBTInNewTab", vm.isBTInNewTab);

                if($state.params.previousPageDetails && !_.isEmpty($state.params.previousPageDetails)){
                    documentType = $state.params.previousPageDetails.documentType;
                    plateIndex = $state.params.previousPageDetails.plateIndex;
                    refIndex = $state.params.previousPageDetails.refIndex;
                    tabName = $state.params.previousPageDetails.tabName;
                }

                if (!tabIndex) {
                    var selectedBT = {
                        id: RoutesConstants.listPieceIndexBT,
                        data: { 'myRef': $state.params.id }
                    }

                    //set cache tabIndex
                    CacheService.setObject(CacheConstants.tabIndex, selectedBT);
                }

                if(vm.isNewTab){
                    var channel = new BroadcastChannel("bt-symptoms-channel");
                    channel.addEventListener("message", function(e) {
                        documentDetails = e.data;
                        //getBTDocumentation details if exists, send error if not
                        getBTDocumentation(documentId,documentDetails);
                    });
                } else if(vm.isSameTab){
                    getBTDocumentation(documentId,documentDetails);
                } else{
                        //retrieve data from cache for btsymptoms and lupnumber
                        var cacheDataBt = CacheService.getSieDocumentsHistory();
                        if(cacheDataBt != null){
                            cacheDataBt.forEach( function(element) {
                                if(element.type == "BT" && element.data.myRef == documentId && element.data.docDetails != null){
                                    documentDetails = element.data.docDetails;
                                    plateIndex = element.data.plateIndex;
                                    refIndex = element.data.refIndex;
                                }
                            });
                        } 
                        
                        //documentDetails i.e symptoms and Lup Number passed to store in cache 
                        //updateDocumentsHistory
                        vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, documentType ,plateIndex,refIndex,null,documentDetails,tabName);
                        

                        //getBTDocumentation details if exists, send error if not
                        getBTDocumentation(documentId,documentDetails);
                
                
                }
                
             
            }
        }

        angular.element($window).bind("scroll", function () {
            var pipVideo = document.getElementsByTagName('video');
            for (var i=0; i< pipVideo.length;i++){
                if (pipVideo[i].currentTime > 0 && !pipVideo[i].paused && !pipVideo[i].ended && pipVideo[0].readyState > 2){
                    pipVideo[i].requestPictureInPicture().catch(function(error) { 
                    });
                }
            }
            

        });

        function onClickedLink(BTList,popinTitle, isNewtab) {
            localStorage.removeItem('isBTInNewTab');
            localStorage.removeItem('isMRInNewTab');
            localStorage.removeItem('isMDInNewTab');
            var numberOfMD = BTList.length;
            if (!numberOfMD) {
                vm.listBT = [];
            } else if (numberOfMD > 1 || (numberOfMD === 1 && BTList[0].residual && BTList[0].residual.length)) {

                $mdDialog.show({
                    contentElement: '#myStaticDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true
                });
                vm.listBT = BTList;
                vm.popinTitle = popinTitle;
            } else {
                var id = BTList[0].reference;
                var type = BTList[0].type;
                if (type === 'MR') {
                    if (isNewtab) {
                        localStorage.setItem('isMRInNewTab', true);
                        var url = $state.href(RoutesConstants.documentMR, { id: id });
                        $window.open(url, '_blank');
                    } else {
                        $state.go(RoutesConstants.documentMR, { id: id });
                    }
                }
                else if (type === 'MD'){
                    if(isNewtab) {
                        localStorage.setItem('isMDInNewTab', true);
                        var url = $state.href(RoutesConstants.documentMD, { id: id });
                        $window.open(url, '_blank');
                    } else {
                        $state.go(RoutesConstants.documentMD, { id: id });
                    }
                }
                else if (type === 'BT'){
                if(isNewtab) {
                        localStorage.setItem('isBTInNewTab', true);
                        var url = $state.href(RoutesConstants.documentBT, { id: id });
                        $window.open(url, '_blank');
                    } else {
                        $state.go(RoutesConstants.documentBT, { id: id });
                    }
                }
            }
        }
        function getBTDocumentation(id,details) {
            blockUI.start();
            vm.btDocumentDetails = details;

            DocumentsMetierService.returnBTDetail(id,details).then(function (result) {
                vm.contentBT.title = result.title;
                vm.contentBT.status = result.status;
                vm.contentBT.sieVersion = result.sieVersion;
                vm.contentBT.sieName = result.sieName;
                vm.contentBT.content = result.content;
                vm.canPrint = true;
            }, function (msg) {
                toastr.error($translate.instant(msg.error.value));
                vm.canPrint = false; 
            }).finally(function () {
                blockUI.stop();
            });
        } 
        
        function downloadPdf() {
            const PDF_URL_REVOKE_DELAY_MS = 60000;
            blockUI.start();

            const documentId = $state.params.id || '';
            const documentDetails = vm.btDocumentDetails;

            DocumentsMetierService.getBTPdf(documentId, {
                btDocumentDetails: documentDetails,
                renderedContent: vm.contentBT.content,
                documentTitle: vm.contentBT.title
            }).then(function (pdfBlob) {
                blockUI.stop();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                $window.open(pdfUrl, '_blank');
                $timeout(function () {
                    URL.revokeObjectURL(pdfUrl);
                }, PDF_URL_REVOKE_DELAY_MS);
            }, function (_error) {
                blockUI.stop();
                toastr.error($translate.instant('ERROR'));
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('btDocuments', btDocuments);

    /** @ngInject */
    function btDocuments() {
        // Usage: <btDocuments docs="vm.listOfMDDocuments"> </btDocuments>
        //
        // Creates: SmartTable with all the table features
        //
        var directive = {
            templateUrl : "app/components/products/documents/bt/btDocuments/btDocuments.template.html",
            controller: 'btDocumentsController',
            bindToController: true,
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                listOfBTDocuments : '=docs',
                fromSearch: '='
            }
        };
        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('btDocumentsController', btDocumentsController);

    /* @ngInject */
    function btDocumentsController($scope, $state, RoutesConstants, CacheService, CacheConstants, configConstantes,
        DocumentsMetierService, $window,$mdDialog, $location) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.listOfBTDocuments = $scope.listOfBTDocuments;
        vm.fromSearch = $scope.fromSearch;
        vm.selectedBT = "";
        var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
        vm.displayBtDetails = displayBtDetails;
        vm.sortBy = sortBy;
        vm.handleIconOrder = handleIconOrder;
        vm.expandBTRow = expandBTRow;
        vm.isRightClick = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);


        activate();


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function activate() {
            //if tabIndex exists in cache && tabIndex is equal to listPieceIndexBT's index
            if (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexBT && tabIndex.data) {
                vm.selectedBT = tabIndex.data.myRef;

                //remove tabIndex from Cache after getting the selected BT
                CacheService.removeObject(CacheConstants.tabIndex);
            }
            if(!_.isEmpty(vm.listOfBTDocuments)){
                _.map(vm.listOfBTDocuments, function(){
                    _.assign(item,{isExpand: false})
                })
            }            
        }
        function expandBTRow(index){
            vm.listOfBTDocuments[index].isExpand = !vm.listOfBTDocuments[index].isExpand;
        }

        /////////////////////////
        function sortBy(propertyName) {
            vm.reversePR = (vm.propertyNamePR === propertyName) ? !vm.reversePR : false;
            vm.propertyNamePR = propertyName;
        }
        function handleIconOrder(columnName){
            if(vm.propertyNamePR != columnName){
                return "sortable";
              }
              if(!vm.reversePR){
                return  "st-sort-ascent";
                
              }
              if(vm.reversePR){
              return "st-sort-descent";
              }
        }
        function displayBtDetails(id, isPdf, document,isRightClick) {
            vm.isRightClick = isRightClick;
            var previousPageDetails;
            if(vm.fromSearch){
                $mdDialog.hide();
                if($location.path().includes('listePiece')){
                    previousPageDetails = {
                        documentType: $state.params.documentType,
                        plateIndex: $state.params.plateIndex,
                        refIndex: $state.params.refIndex,
                        tabName: $state.params.tabName
                    }
                }
            }
            if(isPdf === false){
                var formattedDate;
                if(document.updateDate){
                    formattedDate = moment(document.updateDate).format('YYYYMMDD');
                }
                var dtcData = "";
                if(document.details && document.details.DTCList){
                    document.details.DTCList =  _.uniq(document.details.DTCList.sort())
                    var data = document.details.DTCList.toString();
                    dtcData = data.split(",").join(", ");
                }
                var BtnumbersAndSymptomsDetails = {
                    lupNumber: document.LUPNumber,
                    nitgNumber: document.NITGNumber,
                    dtcCode: dtcData,
                    creationDate: document.creationDate,
                    updateDate: formattedDate,
                    colorCode : document.colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : document.colorCode
                };
            if(document.details){
                var symptomCodeAndLabels = [];
                var symptoms = document.details.symptomList;
                if(symptoms != null){
                symptoms.forEach( function(element){
                    if(element && element.includes('-')){
                        var shortCode = element.substr(0,element.indexOf('-')-1);
                        var label = element.substr(element.indexOf('-')+2,element.length);
                        symptomCodeAndLabels.push({"shortCode":shortCode,"label":label});
                    } 
                 });
                  _.extend(BtnumbersAndSymptomsDetails,{
                         symptoms : symptomCodeAndLabels
                     })
                }
            }
                if(vm.isRightClick){
                    
                    var url = $state.href(RoutesConstants.newTabBT, {id : id, symptomNumbers : BtnumbersAndSymptomsDetails});
                    var openedWindow = $window.open(url, '_blank');
                    openedWindow.onload  = function(){
                        var channel = new BroadcastChannel("bt-symptoms-channel");
                        channel.postMessage(BtnumbersAndSymptomsDetails);
                    }
                    
                }else{
                    $state.go(RoutesConstants.documentBT, {id : id, symptomNumbers : BtnumbersAndSymptomsDetails, previousPageDetails: previousPageDetails});
                }
            }
            else{
                DocumentsMetierService.returnSiePdfContent(id, 'SIE_BT')
                 .then(function (result) {
                    $window.open(result.contentUrl, '_blank');
                });

            }
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('ModifRefModalCtrl', ModifRefModalCtrl);

  /** @ngInject */
  function ModifRefModalCtrl($modalInstance, modalOpts, CacheConstants, CacheService, FavsMetierService, $translate, FavsConstant, toastr, $q) {
    var vm = this;

    function init() {
      /*vm.categoryActive = modalOpts.categoryActive;
      vm.subCategoryActive = modalOpts.subCategoryActive;*/
      vm.cancel = cancelGeneric;
      vm.reposition = repositionGeneric;
      vm.saveRef = saveRef;
      vm.isEditable = isEditable;
      vm.type = modalOpts.type;
      vm.categories = modalOpts.categories;
      vm.enablePrice = modalOpts.enablePrice;

      var labelTitle;
      var okButtonLabel;
      var translationDatas;

      vm.referencesSelected = modalOpts.referencesSelected;
      vm.categorieSelected = modalOpts.categorie;
      vm.subCategSelected = modalOpts.subCategorie;

      if (vm.type === FavsConstant.refModalEdition) {
        vm.reference = modalOpts.reference;
        vm.copyRef = angular.copy(modalOpts.reference);
        labelTitle = 'FAV_MODAL_MODIF_REF_TITLE';
        okButtonLabel = 'FAV_MODAL_MODIF_REF_SAVE';
        if(!vm.reference && vm.referencesSelected) {
          labelTitle = 'FAV_MODAL_MODIF_REFS_TITLE';
          okButtonLabel = 'FAV_REF_MOVE';
          translationDatas = {nbReferencesSelected: vm.referencesSelected.length};
        }
      }
      else {
        vm.isCreation = true;
        vm.isAddExistingRef = modalOpts.addExistingRef;

        okButtonLabel = 'FAV_MODAL_MODIF_REF_SAVE_TO';
        if(modalOpts.addExistingRef) {
          labelTitle = 'FAV_MODAL_ADD_REF_EXIST_TITLE';
          vm.reference = modalOpts.reference;

          if(!vm.reference.designationFav ){
            vm.reference.designationFav = vm.reference.designation;
          }

        } else {
          labelTitle = 'FAV_MODAL_ADD_REF_CREATE_TITLE';
        }
      }

      $translate(labelTitle, translationDatas).then(function (text) {
        vm.title = text;
        return $translate(okButtonLabel);
      })
      .then(function(okButtonLabelTranslated) {
        vm.okButtonLabel = okButtonLabelTranslated;
      }).catch(function () {
        toastr.error('Translation error');
      });


    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      if (vm.type === FavsConstant.refModalEdition && vm.copyRef) {
        vm.reference.designationFav = vm.copyRef.designationFav;
        vm.reference.priceExclTaxes = vm.copyRef.priceExclTaxes;
        vm.reference.reference = vm.copyRef.reference;
      }
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }

    // Close a modal, passing a result
    function okGeneric(callBackValue) {
      modalOpts.okAction(callBackValue);
      $modalInstance.close('ok');
    }


    function isEditable() {
      return (((vm.isEdition && FavsMetierService.isManagableCateg(modalOpts.categorie)) || vm.isCreation) && vm.enablePrice);
    }



    function displayFieldsProblems() {
      if(vm.reference) {
        vm.displayErrorLibelle = !vm.reference.designationFav? true : false;
        vm.displayErrorRef = (!vm.reference.reference || vm.reference.reference.length != 10)? true : false;
        var catToCheck = vm.categorieSelected || vm.defaultCategorie;
        if (vm.isCreation) {
          vm.displayErrorRefExists = FavsMetierService.checkIfFavouriteExistsInCategory(catToCheck, vm.reference.reference);
        }

        return (vm.displayErrorLibelle || vm.displayErrorRef || vm.displayErrorRefExists);
      }
      return false;
    }



    function moveRefToCategorie() {

      if(vm.isCreation && !vm.isAddExistingRef) {
        vm.reference.isLocal = true;
      }

      if(displayFieldsProblems()) {
        return;
      }

      var promises = [$translate('FAV_DEFAULT_SUB_CATEGORY'), $translate('FAV_DEFAULT_DEALER_CATEGORY'), $translate('FAV_DEFAULT_USER_CATEGORY')];
      $q.all(promises).then(function(translatedText){

        if(vm.categorieSelected) {
          FavsMetierService.getCategoryContent(vm.categorieSelected.id).then(function(response){

            //soit on pointe sur la meme categorie (si c'est la meme); soit on recupere la categorie depuis WS
            if(!modalOpts.categorie || (vm.categorieSelected.id != modalOpts.categorie.id)) {
              vm.categorieSelected = response;
            }
            if(vm.subCategSelected && vm.subCategSelected.id) {
              vm.subCategSelected = _.find(vm.categorieSelected.subCategories, function(sCateg) {
                return sCateg.id == vm.subCategSelected.id; //on recupere la sous categorie par reference
              });
              if(vm.reference) {
                FavsMetierService.moveOneReferenceToSelectedCategory(vm.reference, vm.subCategSelected, vm.type);
              } else {
                for (var i = vm.referencesSelected.length - 1; i >= 0; i--) {
                  FavsMetierService.moveOneReferenceToSelectedCategory(vm.referencesSelected[i], vm.subCategSelected, vm.type);
                }
              }
            } else {
              FavsMetierService.insertInDefaultSubcategory(vm.categorieSelected, translatedText, vm.type, vm.reference, vm.referencesSelected);
            }

            FavsMetierService.updateCategory(vm.categorieSelected, vm.type, modalOpts.categorie)
            .then(okGeneric, function (error) {
              console.error(error);
            });

          });
        } else {

            if(!vm.defaultCategorie) {
              var profil = CacheService.getObject(CacheConstants.profil);
              var nameDefaultCategorie = profil.manageDealerFavourites? translatedText[1] : translatedText[2]
              var categoryType = profil.manageDealerFavourites ? FavsConstant.DEALER_TYPE : FavsConstant.USER_TYPE;
              var newSubCateg = FavsMetierService.createNewSubcategory(translatedText, vm.reference, vm.type, vm.referencesSelected);
              vm.defaultCategorie = {name: nameDefaultCategorie, isDefault: true, subCategories: [newSubCateg], type: categoryType};
            } else {
              FavsMetierService.insertInDefaultSubcategory(vm.defaultCategorie, translatedText, vm.type, vm.reference, vm.referencesSelected);
            }

            FavsMetierService.updateCategory(vm.defaultCategorie, vm.type)
            .then(okGeneric, function (error) {
              console.error(error);
            });
        }

      });
    }



    function saveRef() {
      if(vm.isCreation) {
        vm.reference = vm.reference || {};
      }

      var catDefault = _.find(vm.categories, function(obj) {
        return obj.isDefault === true;
      });

      if(catDefault) {
        FavsMetierService.getCategoryContent(catDefault.id).then(function(response){
          vm.defaultCategorie = response;
          moveRefToCategorie();
        });
      } else {
        moveRefToCategorie();
      }

    }


    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('ModifKitModalCtrl', ModifKitModalCtrl);

  /** @ngInject */
  function ModifKitModalCtrl($modalInstance, modalOpts, CacheConstants, CacheService, FavsMetierService, $translate, FavsConstant, $q) {
    var vm = this;

    function init() {
      vm.type = modalOpts.type;
      vm.categories = modalOpts.categories;
      vm.categActif = modalOpts.categorie;
      vm.subCategActif = modalOpts.subCategorie;

      vm.cancel = cancelGeneric;
      vm.reposition = repositionGeneric;
      vm.searchRef = searchRef;
      vm.increaseRatio = increaseRatio;
      vm.decreaseRatio = decreaseRatio;
      vm.saveKit = saveKit;
      vm.removeReference = removeReference;

      if (vm.type === FavsConstant.refModalEdition) {
        vm.kit = modalOpts.kit;
      }
      else {
        vm.isCreation = true;
        vm.kit = {included:[]};
      }

    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      if (vm.type === FavsConstant.refModalEdition) {
        modalOpts.cancelAction();
      }
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }

    // Close a modal, passing a result
    function okGeneric(callBackValue) {
      modalOpts.okAction(callBackValue);
      $modalInstance.close('ok');
    }

    function searchRef() {
      if(vm.refSearched.length === 10) {
        FavsMetierService.getReference(vm.refSearched).then(function(response) {
          if(response.reference) {
            response.ratio = 1;
            vm.kit.included.push(response);
            vm.refSearched = '';
           vm.haveRef= true;
          } else if(!modalOpts.isUserConnectToDms) {
            var reference = {
              reference: angular.copy(vm.refSearched),
              ratio: 1,
              isLocal: true
            };
            vm.kit.included.push(reference);
            vm.refSearched = '';
          } else {
            vm.translationDatas = { referenceNumber: vm.refSearched};
            vm.errorUnknownRef = true;
          }
        });
      }
    }

    function increaseRatio(ref) {
      ref.ratio++;
    }

    function decreaseRatio(ref) {
      if(ref.ratio > 1) {
        ref.ratio--;
      }
    }


    function displayFieldsProblems() {
      if(vm.kit) {
        vm.displayErrorLibelle = !vm.kit.designationFav? true : false;
        vm.displayErrorRef = (!vm.kit.reference )? true : false;
        /*var catToCheck = vm.categorieSelected || vm.defaultCategorie;
        if (vm.isCreation) {
          vm.displayErrorRefExists = FavsMetierService.checkIfFavouriteExistsInCategory(catToCheck, vm.kit.reference);
        }*/

        return (vm.displayErrorLibelle || vm.displayErrorRef || vm.displayErrorRefExists);
      }
      return false;
    }


    function moveKitToCategory(defaultCategorie) {
      var promises = [$translate('FAV_DEFAULT_SUB_CATEGORY'), $translate('FAV_DEFAULT_DEALER_CATEGORY'), $translate('FAV_DEFAULT_USER_CATEGORY')];
      $q.all(promises).then(function(translatedText){
        if(vm.categActif) {
          FavsMetierService.getCategoryContent(vm.categActif.id).then(function(response){

            //si la categorie selectionnee n'est pas la meme que celle de depart
            if(!modalOpts.categorie || (vm.categActif.id != modalOpts.categorie.id)) {
              vm.categActif = response;
            }
            if(vm.subCategActif && vm.subCategActif.id) {
              vm.subCategActif = _.find(vm.categActif.subCategories, function(sCateg) {
                return sCateg.id == vm.subCategActif.id; //on recupere la sous categorie par reference
              });
              FavsMetierService.moveOneReferenceToSelectedCategory(vm.kit, vm.subCategActif, vm.type);
            } else {
              FavsMetierService.insertInDefaultSubcategory(vm.categActif, translatedText, vm.type, vm.kit);
            }

            FavsMetierService.updateCategory(vm.categActif, vm.type, modalOpts.categorie)
            .then(okGeneric, function (error) {
              console.error(error);
            });

          });
        } else {
          if(!defaultCategorie) {
              var profil = CacheService.getObject(CacheConstants.profil);
              var nameDefaultCategorie = profil.manageDealerFavourites? translatedText[1] : translatedText[2]
              var categoryType = profil.manageDealerFavourites ? FavsConstant.DEALER_TYPE : FavsConstant.USER_TYPE;
              var newSubCateg = FavsMetierService.createNewSubcategory(translatedText, vm.kit, vm.type);
              defaultCategorie = {name: nameDefaultCategorie, isDefault: true, subCategories: [newSubCateg], type: categoryType};
            } else {
              FavsMetierService.insertInDefaultSubcategory(defaultCategorie, translatedText, vm.type, vm.kit);
            }

            FavsMetierService.updateCategory(defaultCategorie, vm.type)
            .then(okGeneric, function (error) {
              console.error(error);
            });
        }
      });
    }



    function saveKit() {

      if(displayFieldsProblems()) {
        return;
      }

      var catDefault = _.find(vm.categories, function(obj) {
        return obj.isDefault === true;
      });

      if(catDefault) {
        FavsMetierService.getCategoryContent(catDefault.id).then(function(response){
          moveKitToCategory(response);
        });
      } else {
        moveKitToCategory();
      }
    }

    function removeReference(reference) {
      _.remove(vm.kit.included, function (ref) {
        return ref === reference;
      });
    }


    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('FavouriteModalDeleteCategoryCtrl', FavouriteModalDeleteCategoryCtrl);

  /** @ngInject */
  function FavouriteModalDeleteCategoryCtrl(RoutesConstants, $state, $modalInstance, modalOpts, $translate) {
    var vm = this;

    function init() {
      vm.category = modalOpts.category;
      vm.cancel = cancelGeneric;
      vm.delete = deleteCategory;

      $translate('FAV_MODAL_DELETE_CATEGORY_PART1').then(
        function (text) {
          vm.messagePart1 = text;
          $translate('FAV_MODAL_DELETE_CATEGORY_SUB').then(
            function (text) {
              vm.messageSub = text;
              $translate('FAV_MODAL_DELETE_CATEGORY_PART2',
                {s: (vm.category.number > 1 ? 's' : ''),
                  sub : (vm.category.isSubCateg && vm.messageSub ? vm.messageSub : '')
              }).then(
                function (text) {
                  vm.messagePart2 = text;
                }
              )
            }
          )
        }
      )

    }

    function deleteCategory() {
      modalOpts.category.toDelete = true;
      $modalInstance.close('ok');
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }

    init();
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('AjoutRefModalCtrl', AjoutRefModalCtrl);

  /** @ngInject */
  function AjoutRefModalCtrl($modalInstance, modalOpts,$modal,FavsConstant, FavsMetierService, blockUI, toastr, $translate) {
    var vm = this;

    function init() {
      vm.cancel = cancelGeneric;
      vm.reposition = repositionGeneric;
      vm.addRef = addRef;
      vm.openModalAddOrModifRef = openModalAddOrModifRef;
      vm.openModalAddOrModifKit = openModalAddOrModifKit;
      vm.categories = modalOpts.categories;
      vm.isUserConnectToDms = modalOpts.isUserConnectToDms;
    }

    function addRef() {

      if(vm.refDesignation && vm.refDesignation.length === 10) {
        blockUI.start();
        FavsMetierService.getReference(vm.refDesignation).then(function(response) {
            if (response.errorCode) { // if error
              toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
            } else {
              if(response.reference || !modalOpts.isUserConnectToDms) {
                openModalAddOrModifRef(true, response);
              } else {
                vm.errorUnknownRef = true;
              }
            }
            vm.refDesignation = '';
            blockUI.stop();
          }, function () {
            blockUI.stop();
            $translate("FAV_ERROR_REF_NOT_EXITS", {referenceNumber: vm.refDesignation}).then(function (text) {
              toastr.error(text);
            });
          })
        ;
      }
    }

    function openModalAddOrModifRef(isExistingRefSelected, referenceObject) {
      $modal.open({
        templateUrl: 'app/components/favourites/modal/modif_reference.html',
        controller: 'ModifRefModalCtrl',
        controllerAs: 'vm',
        windowClass: 'modalAjoutRef',
        backdrop: 'static',
        resolve: {
          modalOpts: function () {
            return {
              categories: modalOpts.categories,
              type: FavsConstant.refModalCreation,
              okAction: modalOpts.okAction,
              categorie: modalOpts.categoryActive,
              subCategorie: modalOpts.subCategoryActive,
              reference: referenceObject,
              addExistingRef: isExistingRefSelected,
              enablePrice:false
            };
          }
        }
      });
    }

    function openModalAddOrModifKit() {
      $modal.open({
        templateUrl: 'app/components/favourites/modal/modif_kit.html',
        controller: 'ModifKitModalCtrl',
        controllerAs: 'vm',
        windowClass: 'modalAjoutKit',
        backdrop: 'static',
        resolve: {
          modalOpts: function () {
            return {
              categories: modalOpts.categories,
              isUserConnectToDms: modalOpts.isUserConnectToDms,
              type: FavsConstant.refModalCreation,
              okAction: modalOpts.okAction
            };
          }
        }
      });
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }

    init();
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('FavouriteModalCtrl', FavouriteModalCtrl);

  /** @ngInject */
  function FavouriteModalCtrl($modalInstance, modalOpts, FavsMetierService, $stateParams) {
    var vm = this;

    function init() {
      vm.isTM = ($stateParams.nav === 'TM') ? true : false;
      vm.title = modalOpts.title;
      vm.reference = modalOpts.reference;

      vm.cancel = cancelGeneric;
      vm.reposition = repositionGeneric;
      if (modalOpts.type === "categ") {
        vm.delete = deleteCateg;
      } else if (vm.reference) {
        if (vm.isTM || vm.reference.length === 4) {
          vm.delete = deleteTM;
        } else {
          vm.delete = deleteReference;
        }

      } else {
        vm.referencesSelected = modalOpts.referencesSelected;
        vm.translationDatas = {nbReferencesSelected: vm.referencesSelected.length};
        vm.delete = deleteReferences;
      }
    }

    function deleteCateg() {
      modalOpts.okAction(modalOpts.category);
      $modalInstance.dismiss('cancel');
    }


    /**
     * Delete current reference
     * @return {[type]} [description]
     */
    function deleteReference() {
      vm.reference.toDelete = true;
      FavsMetierService.deleteReferences(modalOpts.category).then(function () {
        okGeneric();
      });
    }

    /**
     * Delete current tm
     * @return {[type]} [description]
     */
    function deleteTM() {
      var cat = modalOpts.category;
      var idSubCat;
      var find = false;
      if(cat && cat.subCategories){
        for(var index in cat.subCategories) {
          if (cat.subCategories[index] && cat.subCategories[index].tms) {
            for (var indexTm in cat.subCategories[index].tms) {
              if (cat.subCategories[index].tms[indexTm].identifier === vm.reference.identifier) {
                idSubCat = cat.subCategories[index].id;
                find = true;
                break;
              }
            }
            if(find){
              break;
            }
          }
        }
      }

      var tm = {
        identifier : vm.reference.identifier
      };
      FavsMetierService.deleteTM(tm, cat.id, idSubCat).then(function () {
        okGeneric();
      });
    }


    /**
     * Deletes all references given
     */
    function deleteReferences() {
      for (var i = vm.referencesSelected.length - 1; i >= 0; i--) {
        vm.referencesSelected[i].toDelete = true;
      }
      FavsMetierService.deleteReferences(modalOpts.category).then(function () {
        okGeneric();
      });
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }

    // Close a modal, passing a result
    function okGeneric(callBackValue) {
      modalOpts.okAction(callBackValue);
      $modalInstance.close('ok');
    }


    init();

  }
})();

(function () {
  'use strict';

  angular.module('phenix').service('FavsWsService', FavsWsService);
  function FavsWsService(FavsConstant, $q, ProductSearchConstants, toastr,
    $translate,RestUpgrade
  ) {
    this.getCategories = getCategories;
    this.getCategoryContent = getCategoryContent;
    this.updateCategories = updateCategories;
    this.updateCategoriesTm = updateCategoriesTm;
    this.referencesSearchWsBack = referencesSearchWsBack;
    this.createTMNotCodified = createTMNotCodified;
    this.updateTMNotCodified = updateTMNotCodified;

    function getCategories(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.categories).post('', request).then(
        function (response) {
          defer.resolve(response.plain());
        }, function (error) {
          defer.reject(error);
        }
      );
      return defer.promise;
    }

    function getCategoryContent(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.categContent).post('', request).then(
        function (response) {
          defer.resolve(response);
        }, function (error) {
          defer.reject(error);
        }
      );
      return defer.promise;
    }

    function updateCategories(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.categories).customPUT(request).then(
        function (response) {
          defer.resolve(response);
        }, function (error) {
          defer.reject(error);
        }
      );
      return defer.promise;
    }
    function updateCategoriesTm(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.deleteTm).post('', request).then(
        function (response) {
          defer.resolve(response);
        }, function (error) {
          defer.reject(error);
        }
      );
      return defer.promise;
    }

    function referencesSearchWsBack(request) {
      var defer = $q.defer();
      RestUpgrade.one(ProductSearchConstants.documentationProducts).post('', request).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }

    function createTMNotCodified(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.tmNotCodified).post('', request).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }

    function updateTMNotCodified(request) {
      var defer = $q.defer();
      RestUpgrade.one(FavsConstant.tmNotCodified).customPUT(request).then(
        function (response) {
          response = response.plain ? response.plain() : response;
          defer.resolve(response);
        }, function (error) {
          defer.reject(error);
        }
      );
      return defer.promise;
    }


  }
})();

(function () {

    angular
        .module('phenix')
        .controller('paintQuoteModal', function ($mdDialog) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;

            vm.selected;
            vm.onClose = onClose;
            vm.onSelectPaint = onSelectPaint;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            function onClose() {
                $mdDialog.cancel();
            }

            /**
             * @param {string} paint
             */

            function onSelectPaint(paintCode) {
                $mdDialog.hide(paintCode);
            }
    });

})();

(function() {

    angular.module('phenix').controller('deleteReferenceModal', function($mdDialog) {
        var vm = this;

        vm.onConfirm = function () {
            $mdDialog.hide();
        }

        vm.onCancel = function () {
            $mdDialog.cancel();
        }
    });

})();

(function () {

    angular.module('phenix').controller('actisFicModal', function ($mdDialog) {
        var vm = this;

        vm.onConfirm = function () {
            $mdDialog.hide();
        }

        vm.onCancel = function () {
            $mdDialog.cancel();
        }
    });

})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("quoteListDraftController", quoteListDraftController);

    /* @ngInject */
    function quoteListDraftController(
        $state,
        $q,
        blockUI,
        toastr,
        $translate,
        $rootScope,

        QuoteMetierService,
        CarSearchMetierService,
        CacheService,
        filterListService,

        CarSearchConstants,
        CacheConstants,
        globalConstant,
        RoutesConstants,
        QuoteConstants,$log
    ) {
        /*=============================================
        =                 INTERNAL STATE              =
        =============================================*/

        var networkProfil = CacheService.getNetworkProfile();
        var _options = {
            filter: {
                status: QuoteConstants.draftStatus,
                type: networkProfil
            },
            sort: {
                by: "DATE",
                order: QuoteConstants.sort.desc
            },
            pagination: {
                limit: QuoteConstants.pagination.limit,
                offset: 1
            }
        };

        var userProfile = CacheService.getUserProfile();
        var _searchBy = QuoteConstants.searchBy;

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.dataLoaded = false;
        vm.filterValues = {};
        vm.currentPage = 1;

        vm.onCheck = onCheck;
        vm.onDelete = onDelete;
        vm.globalConstant = globalConstant;
        vm.onSearch = onSearch;
        vm.onUpdatePagination = onUpdatePagination;
        vm.onUnlock = onUnlock;
        vm.onSelect = onSelect;
        vm.onSort = onSort;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name initComponents
         * @desc initialize the attribute fields of the filterList component
         * @desc headers and actions othe containerList component
         */
        this.$onInit = function () {

            //set _options to state.params.quoteListOptions
            //and filterValues to init filter component
            if ($state.params.quoteListOptions) {
                _options = $state.params.quoteListOptions;
                vm.filterValues = _options.filter;
            }

            blockUI.start();
            getQuoteList().finally(function () {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        };

        $rootScope.$on('resetPagination', function () {
            var pagination = {
                limit: QuoteConstants.pagination.limit,
                offset: 1
            }
            _options.pagination = pagination;
        });

        /**
         * @name onCheck
         * @desc check if user is allowed to open selected quote
         * @param {Object} currentQuote
         */
        function onCheck(currentQuote) {
            if (!QuoteMetierService.isUserAllowedToOpenQuote(userProfile.ipn, currentQuote.userLock)) {
                currentQuote.checked = false;
                toastr.error(
                    $translate
                        .instant("ESTIMATE_MSG_LOCK")
                        .replace("#1", currentQuote.number)
                        .replace("#2", currentQuote.userLock)
                );
            }
        }

        /**
         * @name onSort
         * @desc sort quotes list
         * @param {String} header - column name (ID, ACCOUNT_NUMBER, DATE)
         * @param {Integer} order - order value (-1 or 1)
         */
        function onSort(header, order) {
            var sort = _options.sort;
            var filter = _options.filter;
            var pagination = _options.pagination;

            sort.by = header;
            if (order) {
                sort.order = order;
            }

            blockUI.start();
            getQuoteList(filter, sort, pagination).finally(function() {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        }

        /**
         * @name onDelete
         * @desc delete quotes list
         * @param {Array} listIds
         */
        function onDelete(listIds) {
            blockUI.start();
            QuoteMetierService.deleteQuoteLogic(listIds)
                .then(getQuoteList)
                .finally(function() {
                    vm.dataLoaded = true;
                    blockUI.stop();
                });
        }

        /**
         * @name onSearch
         * @desc get filtered quote list according to filters
         * @param {Object} filter
         */
        function onSearch(filter) {

            // reset pagination
            _options.pagination = {
                limit: QuoteConstants.pagination.limit,
                offset: 1
            };

            filter.status = QuoteConstants.draftStatus;
            _options.filter = filter;

            blockUI.start();
            return getQuoteList(filter, null, _options.pagination).finally(function() {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        }

        /**
         * @name onUnlock
         * @desc unloc current quote
         * @param {Object} currentQuote
         */
        function onUnlock(currentQuote){
            blockUI.start();
            QuoteMetierService.unlockQuoteLogic()
            .then(function(){
                currentQuote.lockedByUser = !currentQuote.lockedByUser;
            })
            .then(function(){
                QuoteMetierService.closeQuote(currentQuote.id);
            })
            .catch(function(){
                toastr.error($translate.instant("ERROR"));
            })
            .finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @name onSelect
         * @desc load context car if user is allowed to open selected quote
         * @param {Object} currentQuote
         */
        function onSelect(currentQuote){
            var getCartMetadata;
            if (QuoteMetierService.isUserAllowedToOpenQuote(userProfile.ipn, currentQuote.userLock)){

                blockUI.start()

                switch (currentQuote.searchBy) {
                    case _searchBy.vin:
                        getCartMetadata = CarSearchMetierService.initSearchCar({ vin: currentQuote.vin }, true).then(function(){
                            CarSearchMetierService.getBannerData();
                        }).catch(function(err){
                            if(err && err.status){
                                return $q.reject("-2");
                            }else{
                                //reject -1 for vehicle unkown bvm
                                return $q.reject("-1")
                            }
                        });
                        break;
                    case _searchBy.registrationNumber:
                        getCartMetadata = CarSearchMetierService.initSearchCar({ imat: currentQuote.registrationNumber }, true).then(function(){
                            CarSearchMetierService.getBannerData();
                        }).catch(function(err){
                            if(err && err.status){
                                return $q.reject("-2");
                            }else{
                                //reject -1 for vehicle unkown bvm
                                toastr.error($translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE'));
                                return $q.reject("-1");
                            }
                        })
                        break;
                    case _searchBy.model:
                        getCartMetadata = CarSearchMetierService.searchCarModel(createModelPayload(currentQuote)).then(function(){
                            CarSearchMetierService.getBannerData();
                        })
                        break;
                    default:
                        getCartMetadata = $q.resolve();
                        break;
                }

                getCartMetadata.then(function () {
                    CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, false);
                    //get quote informations, set them to cache
                    //and redirect user to quote page with current options (filters, pagination, sort)
                    // QuoteMetierService.cleanDataFromCalculate();
                    QuoteMetierService.findAndSetCurrentQuote(currentQuote.id).then(function () {
                       $state.go(RoutesConstants.dmsQuote, {
                           quoteListOptions: _options
                       });
                    }).catch(function(){
                        $log.debug($translate.instant('ERROR'));
                    })
                })
                .catch(function (error) {
                    //manage case vehcile unkown bvm
                    if(error === "-1"){
                        var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                        var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);
                       
                        //set car context for unkown bvm vehicle
                        if (dmsResponse) {
                            CarSearchMetierService.setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache);
                            CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                            //call find service to get quote informations
                            QuoteMetierService.findAndSetCurrentQuote(currentQuote.id).then(function () {
                                //redirect user to quote page informations
                                $state.go(RoutesConstants.dmsQuote, {
                                    quoteListOptions: _options
                                });
                             });

                        } else {
                            var carNotBvmAndDms = {
                                "vin": currentQuote.vin,
                                "imat": currentQuote.registrationNumber
                            }
                             //set car context for unkown bvm and dms vehicle
                            CarSearchMetierService.setCarContextVehicleNotKnownBvmAndDms(carNotBvmAndDms);
                            CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                            //call find service to get quote informations
                            QuoteMetierService.findAndSetCurrentQuote(currentQuote.id).then(function () {
                                //redirect user to quote page informations
                                $state.go(RoutesConstants.dmsQuote, {
                                    quoteListOptions: _options
                                });
                             });
                        }
                    }
                    else if (error.errors && Array.isArray(error.errors)) {
                        error.errors.forEach(function (error) {
                            toastr.error(error.msg);
                        })
                    } else if(error !== '-2'){
                        toastr.error($translate.instant('ERROR'));
                    }
                })
                .finally(function(){
                    blockUI.stop();
                })
            }
            else{
                toastr.error($translate.instant('ESTIMATE_MSG_LOCK').replace('#1', currentQuote.number).replace('#2', currentQuote.userLock));
            }

        }

        /**
         * @name onUpdatePagination
         * @desc get quote list for the selected page
         * @param {int} page
         */
        function onUpdatePagination(page) {
            _options.pagination = {
                limit: _options.pagination.limit,
                offset: page
            };

            blockUI.start();
            getQuoteList(_options.filter, null, _options.pagination).finally(function() {
                blockUI.stop();
            });
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name getQuoteList
         * @desc get quote list
         * @param {Object} filter
         * @param {Object} sort
         * @param {Number} pagination
         */
        function getQuoteList(filter, sort, pagination) {

            //get options
            if (!filter) {
                filter = _options.filter;
            }
            if (!sort) {
                sort = _options.sort;
            }
            if (!pagination) {
                pagination = _options.pagination;
            }

            //get current page
            vm.currentPage = pagination && pagination.offset ? pagination.offset : vm.currentPage;

            //get list using options (filters, sort and pagination)
            return QuoteMetierService.quoteServiceListLogic(filter, sort, pagination)
                .then(function (response) {
                    vm.quoteList = response.quotes;
                    vm.count = response.totalCount;
                })
                .catch(function (err) {
                    console.log(err);
                    toastr.error($translate.instant("ERROR"));
                });
        }

        /**
         * @name createModelPayload
         * @desc Create payload for carSearchByModel request
         * @param {Oject} cart see getCartsList in CartViewListService
         * @return {Object} See below
         */
        function createModelPayload(cart) {
            return {
                fixedCriterias: {
                    '007': cart.familyVehicle,
                    '008': cart.bodyType,
                    '336': cart.brand,
                    '997': cart.gearboxType,
                    '999': cart.engineType
                }
            }
        }

    }
})();

(function () {
    angular.module('phenix').controller('quoteListValidatedController', quoteListValidatedController);

    function quoteListValidatedController(
        $translate,
        $state,
        $q,
        toastr,
        blockUI,

        CacheService,
        CarSearchMetierService,
        QuoteMetierService,
        DmsMetierService,
        filterListService,
        CacheConstants,
        CarSearchConstants,

        PartRequisitionConstants,
        QuoteConstants,
        globalConstant,
        RoutesConstants,
        $rootScope
    ) {

        /*=============================================
        =                 INTERNAL STATE              =
        =============================================*/

        var networkProfil = CacheService.getNetworkProfile();
        var _defaultFilter = {
            status: PartRequisitionConstants.validatedStatus,
            type: networkProfil
        };
        var _defaultPagination = {
            limit: PartRequisitionConstants.pagination.limit,
            offset: 1
        };
        var _options = {
            filter: _defaultFilter,
            pagination: _defaultPagination,
            sort: {
                by: 'DATE', // UPDATE
                order: PartRequisitionConstants.sort.desc
            }
        };

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.globalConstant = globalConstant;
        vm.quoteList = [];
        vm.dataLoaded = false;
        vm.filterValues = {};
        vm.currentPage = 1;

        vm.onSelect = onSelect;
        vm.onUpdatePagination = onUpdatePagination;
        vm.onSort = onSort;
        vm.onSearch = onSearch;
        var _searchBy = QuoteConstants.searchBy;
        var userProfile = CacheService.getUserProfile();

        /**
         *  @desc Fetch validated quote
         */
        this.$onInit = function () {
            vm.networkProfile = CacheService.getNetworkProfile();

            //set _options to state.params.quoteListOptions
            //and filterValues to init filter component
            if ($state.params.quoteListOptions) {
                _options = $state.params.quoteListOptions;
                vm.filterValues = _options.filter;
            }

            blockUI.start();
            getAndStoreValidatedQuoteList().finally(function () {
                blockUI.stop();
                vm.dataLoaded = true;
            }).catch(function () {
                toastr.error($translate.instant("ERROR"));
            });
            $state.redirectedFrom = $rootScope.previousState;
        }

        /**
         *  @desc Event trigger by container-list
         */
        function onSort(by, order) {
            blockUI.start();

            _options.sort = {
                by: by,
                order: order
            }

            getAndStoreValidatedQuoteList(null, _options.sort).finally(function () {
                blockUI.stop();
            })
        }

        /**
         *  @desc Event trigger by pagination-list component
         */
        function onUpdatePagination(page) {
            blockUI.start();

            _.assign(_options.pagination, { offset: page })
            getAndStoreValidatedQuoteList(null, null, _options.pagination).finally(function () {
                blockUI.stop();
            })
        }


        /**
         * @desc  Event trigger by filter-list component
         */
        function onSearch(filter) {
            blockUI.start();

            _options.filter = _.extend(filter, _defaultFilter);
            _options.pagination = _defaultPagination;

            getAndStoreValidatedQuoteList(_options.filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @desc  Event trigger when an user select a quote
         */
        function onSelect(validatedQuote) {
            var getCartMetadata;
                blockUI.start()

                switch (validatedQuote.searchBy) {
                    case _searchBy.vin:
                        getCartMetadata = CarSearchMetierService.initSearchCar({ vin: validatedQuote.vin }, true).then(function(){
                            CarSearchMetierService.getBannerData();
                        }).catch(function(err){
                            if(err && err.status){
                                return $q.reject("-2");
                            }else{
                                //reject -1 for vehicle unkown bvm
                                return $q.reject("-1")
                            }
                        });
                        break;
                    case _searchBy.registrationNumber:
                        getCartMetadata = CarSearchMetierService.initSearchCar({ imat: validatedQuote.registrationNumber }, true).then(function(){
                            CarSearchMetierService.getBannerData();
                        }).catch(function(err){
                            if(err && err.status){
                                return $q.reject("-2");
                            }else{
                                //reject -1 for vehicle unkown bvm
                                toastr.error($translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE'));
                                return $q.reject("-1");
                            }
                        })
                        break;
                    case _searchBy.model:
                        getCartMetadata = CarSearchMetierService.searchCarModel(createModelPayload(validatedQuote)).then(function(){
                            CarSearchMetierService.getBannerData();
                        })
                        break;
                    default:
                        getCartMetadata = $q.resolve();
                        break;
                }

                getCartMetadata.then(function () {
                            $state.go(RoutesConstants.validatedQuote, {
                                quoteId: validatedQuote.id,
                                id: validatedQuote.id,
                                data: {
                                    backToPrevious: true
                                }
                            });
                        }) .catch(function (error) {
                            //manage case vehcile unkown bvm
                            if(error === "-1"){
                                var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                                var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);
                               
                                //set car context for unkown bvm vehicle
                                if (dmsResponse) {
                                    CarSearchMetierService.setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache);
                                    CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                                    $state.go(RoutesConstants.validatedQuote, {
                                        quoteId: validatedQuote.id,
                                        id: validatedQuote.id,
                                        data: {
                                            backToPrevious: true
                                        }
                                    });
                                } else {
                                    var carNotBvmAndDms = {
                                        "vin": validatedQuote.vin,
                                        "imat": validatedQuote.registrationNumber
                                    }
                                     //set car context for unkown bvm and dms vehicle
                                    CarSearchMetierService.setCarContextVehicleNotKnownBvmAndDms(carNotBvmAndDms);
                                    CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                                    $state.go(RoutesConstants.validatedQuote, {
                                        quoteId: validatedQuote.id,
                                        id: validatedQuote.id,
                                        data: {
                                            backToPrevious: true
                                        }
                                    });
                                }
                            }
                            else if (error.errors && Array.isArray(error.errors)) {
                                error.errors.forEach(function (error) {
                                    toastr.error(error.msg);
                                })
                            } else if(error !== '-2'){
                                toastr.error($translate.instant('ERROR'));
                            }
                        })
                        .finally(function(){
                                 blockUI.stop();
                             })
                  }


                  function createModelPayload(cart) {
                    return {
                        fixedCriterias: {
                            '007': cart.familyVehicle,
                            '008': cart.bodyType,
                            '336': cart.brand,
                            '997': cart.gearboxType,
                            '999': cart.engineType
                        }
                    }
                }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name getAndStoreValidatedQuoteList
         * @desc get validate quote list
         * @param {Object} filter
         * @param {Object} sort
         * @param {Number} pagination
         */
        function getAndStoreValidatedQuoteList(filter, sort, pagination) {

            //get options
            if (!filter) {
                filter = _options.filter;
            }
            if (!sort) {
                sort = _options.sort;
            }
            if (!pagination) {
                pagination = _options.pagination;
            }

            //get current page
            vm.currentPage = pagination && pagination.offset ? pagination.offset : vm.currentPage;

            //get list using options (filters, sort, pagination)
            return QuoteMetierService.quoteServiceListLogic(filter, sort, pagination).then(function (response) {
                vm.quoteList = response.quotes;
                vm.count = response.totalCount;                
            });
        }

    }
})();

/**
 * shoppingCartQuote
 * @namespace Components
 */

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('oneClickOnly', [  
            '$parse', '$compile','$rootScope', function($parse, $compile, $rootScope) {
              return {
                restrict: 'A',
                scope: false, // get the parent scope directly
                compile: function(element, attr) {
                  var fn = $parse(attr['oneClickOnly']);
                  return {
                    pre: function(scope, element, attr) {
                      scope.oneClickOnly = scope.oneClickOnly || {}
                      scope.oneClickOnly[attr.id] = scope.oneClickOnly[attr.id] || {}
                      scope.oneClickOnly[attr.id].fn = function(value) {
                        scope.oneClickOnly[attr.id].val = value;
                      }
                      
                        $rootScope.$on('on-close-draft-list', function() {
                            scope.oneClickOnly[attr.id].val = false;
                            });
                      var clickingCallback = function(e) {
                        if(scope.oneClickOnly 
                          && scope.oneClickOnly[attr.id]
                          && scope.oneClickOnly[attr.id].val) {
                          return
                        }              
                        scope.oneClickOnly[attr.id].fn(true)
                        fn(scope, { $event: e });
                      };
                      element.bind("click", clickingCallback)
                    }
                  }
                }
              }
            }
          ])
        .component('shoppingCartQuote', {
            bindings: {
                // mainPiece: '<', // MUST BE DEFINE if type ===f 'PPS'
                piece: '=', // Object
                from: '@',  // PR | TM
                type: '@',   // PPS | UNDEFINED
                page: '@',
                landscape: '<'
            },
            controller: ShoppingCartQuoteController,
            templateUrl: 'app/components/dms/quote/components/shoppingCart/shoppingCartQuote.template.html'
        })

    function ShoppingCartQuoteController(
        ShoppingCartPartsService,
        QuoteMetierService,
        CacheService,
        globalConstant,
        QuoteConstants,
        ShoppingCartServiceConstant,
        configConstantes,
        CacheConstants,
        CodesConstants,
        $q,
        $translate,
        $mdDialog,
        BasketTools,
        listOfDraftModalService,
        $rootScope,
        toastr,
        blockUI) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var _actions = ShoppingCartServiceConstant.actions;
        var vm = this;
        var _VOI = [];
        this.canAddToQuote = true;
        var _carContext = CacheService.getObject(CacheConstants.contextCarSearch);
        var _networkProfile = null;
        var _essai = ShoppingCartServiceConstant.essai;
        vm.isQuoteCalculated = false;
        this.addToShoppingCart = addToShoppingCart;
        this.addOne = addOne;
        this.reduceOne = reduceOne;
        this.updateFromInput = updateFromInput;
        this.updateFromInputSecond = updateFromInputSecond;
        this.getVOI = getVOI;
        this.unsetCalcul = unsetCalcul;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {


            if (vm.from === 'TM') {
                vm.piece.reference = vm.piece.technicalId;
            }

            if (vm.from == 'PR' && vm.landscape && vm.landscape !== undefined) {
                var profil = CacheService.getObject(CacheConstants.profil);
                if (profil.isLandscape && profil.isLandscape != null) {
                    vm.isLandscape = true;
                }
            }

            vm._computedPiece = vm.piece;
            _VOI = getVOI(vm.piece.simplifiedResidual);


            _networkProfile = CacheService.getNetworkProfile();
            if (!_carContext && _networkProfile === CacheConstants.workshop) {
                vm.canAddToQuote = false;
            }
        }

        function unsetCalcul() {
            if (vm.isQuoteCalculated) {
                var dmsQuote = CacheService.getDmsQuote();
                vm.quote.isUncalculatedParts = false;
                vm.isQuoteCalculated = false;
                dmsQuote.isCalculated = false;
                CacheService.setDmsQuote(dmsQuote);
            }
        }

        /**
         * @namespace
         * @desc add item to part requisition basket, send it to the back
         * @desc increment the the piece quantity, the pps quantities
         * @desc and display pps if piece having pps
         */

        function addToShoppingCart() {
            if (vm.canAddToQuote) {
                var quote = QuoteMetierService.getQuoteData();
                var prExist = _.find(quote && quote.shoppingCart.PR, function (prItem) { return prItem.reference == vm.piece.reference && !prItem.interventionId});
    
                if(vm.from == 'PR' && quote && quote.shoppingCart.PR.length >= 99 && !prExist){
                    toastr.error($translate.instant('MAX_LIMIT_REACHED_ERROR'));
                    return;
                }

                $q.resolve().then(function () {
                    if (quote) {
                        return;
                    }
                    var body = angular.element(document.body);
                    var modalParams = {
                        body: body,
                        typeOfSuperCart: globalConstant.quote,
                        title: "NEW_ESTIMATE",
                        subtitle: "ESTIMATE_NO_ACTIVE_DRAFT",
                        showList: true,
                        showActifPartRequisition: false
                    }
                    return listOfDraftModalService.showModal(modalParams).then(function (superCartId) {
                        var promise = null;
                        if (superCartId.item) {
                            promise = QuoteMetierService.findAndSetCurrentQuote(superCartId.item);
                        } else {
                            promise = QuoteMetierService.instanciateNewQuote();
                        }
                        return promise;
                    });
                }).then(function (result) {
                    var promise = result;
                    if (_VOI.length) {
                        var parentEl = angular.element(document.body);
                        return $mdDialog.show({
                            locals: {
                                VOIList: _VOI
                            },
                            parent: parentEl,
                            templateUrl: 'app/components/basket/shoppingCart/modal-voi.template.html',
                            clickOutsideToClose: true,
                            controller: 'modalVoi',
                            bindToController: true,
                            controllerAs: 'vm'
                        }).catch(function () {
                            return $q.reject();
                        });
                    }
                    return promise;
                }).then(function () {
                    //open modal paintType choice only once per carcontext and if paint is not set
                    var DMSVehicle = CacheService.getObject(CacheConstants.dmsResponse);
                    var PAINT_NO_SET = !DMSVehicle || !DMSVehicle.vehicle.paintType;
                    var quote = QuoteMetierService.getQuoteData();
                    var IS_PAINT_TM = vm.from === 'TM' && parseFloat(vm.piece.businessSpecificities.painting.replace(",", ".")) > 0;
                    if (IS_PAINT_TM && PAINT_NO_SET) {
                        return $mdDialog.show({
                            templateUrl: 'app/components/dms/quote/modals/paintQuoteModal/paintQuoteModal.template.html',
                            controller: 'paintQuoteModal',
                            bindToController: true,
                            controllerAs: 'vm',
                            clickOutsideToClose: true
                        }).catch(function () {
                            return $q.reject(1);
                        }).then(function (paintID) {
                            blockUI.start();
                            //set paintType in dms response cache
                            if (DMSVehicle) {
                                DMSVehicle.vehicle = _.assign(DMSVehicle.vehicle, {
                                    paintType: paintID
                                });
                            } else {
                                DMSVehicle = {
                                    vehicle: {
                                        paintType: paintID
                                    }
                                }
                            }
                            //set paintType in cache
                            CacheService.setObject(CacheConstants.dmsResponse, DMSVehicle);
                            //save paintType (send request to estimate's save service)
                            var payload = {id: quote.id, paintType: paintID};
                            return QuoteMetierService.saveQuote(payload);
                        }).finally(function () {
                            blockUI.stop();
                        });
                    }
                }).then(function () {
                    var payload = buildPayload(vm._computedPiece, vm.from, _actions.ADD_PIECE);
                    vm.quote = QuoteMetierService.getQuoteData();
                    vm.prExist = _.find(vm.quote && vm.quote.shoppingCart.PR, function (prItem) { return prItem.reference == vm.piece.reference });
                    var tmExist = _.find(vm.quote && vm.quote.shoppingCart.TM, function (tmItem) { return tmItem.opecod == vm.piece.id && !tmItem.interventionId });
                    var item = {};
                    if(vm.from == 'PR'){
                        if((vm.quote && vm.quote.shoppingCart.PR.length < 99) || vm.prExist){
                            return QuoteMetierService.updateQuotePart(_actions.ADD_PIECE, payload);
                        }
                        else {
                            toastr.error($translate.instant('MAX_LIMIT_REACHED_ERROR'));
                            return QuoteMetierService.updateQuotePart(_actions.REDUCE_ONE, payload);
                        }
                    } 
                    if (vm.from == 'TM') {
                        if (payload.piece && payload.piece.id) {
                            _.extend(payload.piece, { isTestOpcode: Object.values(_essai).includes(payload.piece.id) ? true : false });
                        }
                        if(!tmExist){
                            return QuoteMetierService.updateQuotePart(_actions.ADD_PIECE, payload);
                        }
                        else{
                            blockUI.start();
                            //update quote tm quantity
                            item = {
                                reference: tmExist.reference,
                                designation: tmExist.designation,
                                quantity: tmExist.quantity + 1,
                                opecod: vm.piece.id,
                                essay: vm.piece.essay,
                                id: vm.piece.id
                            }
                            return QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                                piece: item,
                                type: 'TM'
                            }).then(function () {
                                tmExist.quantity = tmExist.quantity + 1;
                                vm.reference = "";
                                unsetCalcul();
                            }).catch(function (err) {
                                if (err != 2) {
                                    toastr.error($translate.instant('DOCUMENT_NO_TM_FOUND'));
                                }
                                else {
                                   return $q.reject();
                                }
                            }).finally(function () {
                                blockUI.stop();
                            });
                        }
                    }
                }).then(function () {
                  if(vm.from == 'TM' || ((vm.from == 'PR' && vm.quote && vm.quote.shoppingCart.PR.length < 99) || vm.prExist)){
                    if (vm.piece.dmsInformations && !vm.piece.dmsInformations.priceExclTaxes) {
                        toastr.info($translate.instant('COMMON_ERROR_REF_DMS'), '', {
                            timeOut: 2000
                        });
                    }
                    vm.piece.estimateQuantity = 1;
                    updatePPSQuantity();
                    displayPPS();
                  }
                }).catch(function (err) {
                    // 1 === cancel from modal
                    if (err === undefined) {
                        return;
                    } else if (err !== 1 && err !== 2 && err !== 3) {
                        handleError();
                    }else if (err == 2) {
                        vm.piece.estimateQuantity = 1;
                    }
                }).finally(function () {
                    blockUI.stop();
                })
            }
        }

        /**
         *  @desc get all VOI data from fixe residual
         *  @param {Array<Object>} [{
         *      fixe: [{
         *          codeObj: string
         *      }]
         *  }]
         *  @return {Array<Object>} [{
         *      codeObj: string,
         *      labelObj: string,
         *      langueObj: string,
         *      listCrit: [{
         *          codeCrit: string,
         *          labelCrit: string,
         *          langueCrit: string
         *      }]
         *  }]
         */

        function getVOI(residual) {
            if (!residual) {
                return [];
            }
            return residual.reduce(function (acc, applicability) {
                return applicability.fixe ? acc.concat(applicability.fixe) : acc;
            }, []).map(function (line) {
                return (line.codeObj == CodesConstants.VOI) ? line : null;
            }).filter(function (VOI) {
                return VOI;
            });
        }

        /**
         * @namespace addOne
         * @desc update item to part requisition basket, send it to the back
         * @desc increment the the piece quantity and the pps quantities if exists
         */
        function addOne() {
            var payload = buildPayload(vm._computedPiece, vm.from, _actions.ADD_QUANTITY);
            var dmsQuote = CacheService.getDmsQuote();
            blockUI.start();
            QuoteMetierService.updateQuotePart(_actions.ADD_ONE, payload).then(function () {
                vm.piece.estimateQuantity = parseInt(vm.piece.estimateQuantity) + 1;
                updatePPSQuantity();
            }, handleError).finally(function () {
                blockUI.stop();
            });
        }


        /**
         * @namespace reduceOne
         * @desc update item to part requisition basket, send it to the back
         * @desc decrement the the piece quantity and the pps quantities if exists
         */
        function reduceOne() {
            var payload = buildPayload(vm._computedPiece, vm.from, _actions.REDUCE_QUANTITY);
            QuoteMetierService.updateQuotePart(_actions.REDUCE_ONE, payload).then(function () {

                    if (vm.piece.estimateQuantity.toString().indexOf(',') != -1) {
                        if (parseInt(vm.piece.estimateQuantity.toString().split(',')[0]) > 0) {
                            vm.piece.estimateQuantity = parseInt(vm.piece.estimateQuantity.toString().split(',')[0]);
                        }
                    } else if (vm.piece.estimateQuantity > 0) {
                        if (vm.piece.estimateQuantity.toString().indexOf('.') != -1) {
                            vm.piece.estimateQuantity = parseInt(vm.piece.estimateQuantity);
                        } else {
                            vm.piece.estimateQuantity = vm.piece.estimateQuantity - 1;
                        }
                    }

                    updatePPSQuantity();
                }
                ,
                handleError
            ).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @namespace updateFromInput
         * @desc update item to part requisition basket, send it to the back
         * @desc update the the piece quantity and the pps quantities if exists
         */
        function updateFromInput(oldQuantity) {
            if (vm.piece.estimateQuantity.toString().indexOf(',') != -1) {
                vm.piece.estimateQuantity = parseFloat(vm.piece.estimateQuantity.toString().replace(",", "."));
            }
            var number = vm.piece.estimateQuantity;// = parseInt(vm.piece.estimateQuantity);
            var copyComputed = angular.copy(vm.piece);
            var payload = {}
            if (isNaN(number)) {
                // RETURN ERROR
                return
            }

            copyComputed.estimateQuantity = oldQuantity;
            payload = buildPayload(copyComputed, vm.from, _actions.REPLACE_QUANTITY, vm.piece.estimateQuantity);

            blockUI.start();
            QuoteMetierService.updateQuotePart(_actions.REPLACE_QUANTITY, payload).then(function () {
                updatePPSQuantity();
            }, handleError).finally(function () {
                blockUI.stop();
            });
        }

        function updateFromInputSecond(oldQuantity) {
            if (this.piece.estimateQuantity == 0) {
                var msg = $translate.instant('ERROR_QUANTITY');
                toastr.error(msg);
                this.piece.estimateQuantity = 1;
                return;
            }
            updateFromInput(oldQuantity);
        }

        /*=============================================
        =                  TOOLS                      =
        =============================================*/

        /**"
         * update pps quantity according to ratio
         */
        function updatePPSQuantity() {
            if (vm.piece.additional) {
                vm.piece.additional.forEach(function (pps) {
                    pps.estimateQuantity = vm.piece.estimateQuantity * pps.ratio;

                })
            }

            if (vm.piece.pps) {
                vm.piece.pps.forEach(function (pps) {
                    pps.estimateQuantity = vm.piece.estimateQuantity * pps.ratio;

                })
            }
        }

        /**
         * display pps items
         */
        function displayPPS() {
            if (vm.piece.additional) {
                vm.piece.showAdd = true;
            }
        }

        /**
         * handle error
         */
        function handleError() {
            var msgError = $translate.instant('ERROR');
            toastr.error(msgError);
        }

        /**
         * Build payload according to the piece, type, action and quantity
         */
        function buildPayload(piece, type, action, quantity) {
            if (quantity != undefined) {
                if (quantity.toString().indexOf('.') != -1) {
                    quantity = parseFloat(quantity);
                } else if (quantity.toString().indexOf(',') != -1) {
                    quantity = parseFloat(quantity.toString().replace(",", "."));
                    //  quantity = 999;
                } else {
                    quantity = parseInt(quantity);
                }
            }
            var payload = {};
            // deep copy of piece to avoid mutation on other side
            piece = updatePartData(piece, type);

            switch (action) {
                case _actions.ADD_PIECE: {
                    payload = {
                        piece: piece,
                        type: type
                    }
                    break;
                }
                case _actions.ADD_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type
                    }
                    break;
                }
                case _actions.REDUCE_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type
                    }
                    break;
                }
                case _actions.REPLACE_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type,
                        quantity: quantity
                    }
                }
            }

            return payload;
        }


        /**
         *
         * @param {*} piece
         */

        function updatePartData(piece, type) {
            var copy = angular.copy(piece);
            copy.quantity = piece.estimateQuantity;
            copy.type = type;
            if (copy.additional) {
                copy.additional.forEach(function (part) {
                    part.quantity = part.estimateQuantity;
                    part.type = type;
                });
            }
            return copy;
        }

    }
})();

(function () {
    'use strict';

    /**
     *  @desc This component is only used in quote.template.html
     */

    angular
        .module('phenix')
        .component('shoppingCartQuotePage', {
            bindings: {
                piece: '=', // Object
                type: '=',
                page: '='
            },
            controller: ShoppingCartQuotePageController,
            templateUrl: 'app/components/dms/quote/components/shoppingCartQuotePage/shoppingCartQuotePage.template.html'
        })

    function ShoppingCartQuotePageController(
        QuoteMetierService,
        ShoppingCartServiceConstant,
        $translate,
        toastr,
        blockUI) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        this.addOne = addOne;
        this.reduceOne = reduceOne;
        this.updateFromInput = updateFromInput;
        this.updateFromInputSecond = updateFromInputSecond;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace addOne
         * @desc update item to part requisition basket, send it to the back
         * @desc increment the the piece quantity and the pps quantities if exists
         */

        function addOne() {
            blockUI.start();
            
            const piecePayload = {
                reference: vm.piece.reference,
                quantity: Number.parseFloat(vm.piece.quantity),
                interventionId: vm.piece.interventionId,
                type: vm.type
            };
            
            if (vm.piece.genericPart !== undefined) {
                piecePayload.genericPart = vm.piece.genericPart;
            }
            if (vm.piece.opecod !== undefined) {
                piecePayload.opecod = vm.piece.opecod;
            }
            
            QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_ONE, {
                piece: piecePayload,
                type: vm.type
            }).then(function () {
                vm.piece.quantity = parseInt(vm.piece.quantity) + 1;
            }).catch(handleError)
                .finally(function () {
                    blockUI.stop();
                })
        }


        /**
         * @namespace reduceOne
         * @desc update item to part requisition basket, send it to the back
         * @desc decrement the the piece quantity and the pps quantities if exists
         */

        function reduceOne() {
            if (vm.piece.quantity == 1) {
                if (vm.nbPiece === 1) {
                    deleteReference();
                }
                return;
            }
            
            const piecePayload = {
                reference: vm.piece.reference,
                quantity: vm.piece.quantity,
                interventionId: vm.piece.interventionId,
                type: vm.type
            };
            
            if (vm.piece.genericPart !== undefined) {
                piecePayload.genericPart = vm.piece.genericPart;
            }
            if (vm.piece.opecod !== undefined) {
                piecePayload.opecod = vm.piece.opecod;
            }
            
            const payload = {
                piece: piecePayload,
                type: vm.type
            };
            
            blockUI.start();
            QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.REDUCE_ONE, payload).then(function () {
                if (vm.piece.quantity.toString().indexOf(',') != -1) {
                    if (parseInt(vm.piece.quantity.toString().split(',')[0]) > 0) {
                        vm.piece.quantity = parseInt(vm.piece.quantity.toString().split(',')[0]);
                    }
                } else if (vm.piece.quantity > 0) {
                    if (vm.piece.quantity.toString().indexOf('.') != -1) {
                        vm.piece.quantity = parseInt(vm.piece.quantity);
                    } else {
                        vm.piece.quantity--;
                    }

                } 
                // updatePPSQuantity();
            }).catch(handleError)
                .finally(function () {
                    blockUI.stop();
                })
        }

        /**
         * @namespace updateFromInput
         * @desc update item to part requisition basket, send it to the back
         * @desc update the the piece quantity and the pps quantities if exists
         */
        function updateFromInput(oldQuantity) {
            if (vm.piece.quantity.toString().indexOf(',') != -1) {
                vm.piece.quantity = Number.parseFloat(vm.piece.quantity.toString().replace(",", "."));
            }
            const number = vm.piece.quantity;

            const piecePayload = {
                reference: vm.piece.reference,
                quantity: oldQuantity,
                interventionId: vm.piece.interventionId,
                type: vm.type
            };
            
            if (vm.piece.genericPart !== undefined) {
                piecePayload.genericPart = vm.piece.genericPart;
            }
            if (vm.piece.opecod !== undefined) {
                piecePayload.opecod = vm.piece.opecod;
            }

            blockUI.start();
            QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.REPLACE_QUANTITY, {
                piece: piecePayload,
                quantity: number,
                type: vm.type
            }).catch(function () {
                vm.piece.quantity = oldQuantity;
                handleError();
            })
                .finally(function () {
                    blockUI.stop();
                })
        }

        //TODO: know why use this
        function updateFromInputSecond(oldQuantity) {
            if (this.piece.quantity == 0) {
                var msg = $translate.instant('ERROR_QUANTITY');
                toastr.error(msg);
                this.piece.quantity = 1;
                return;
            }
            updateFromInput(oldQuantity);
        }

        /*=============================================
        =                  TOOLS                      =
        =============================================*/


        /**
         * handle error
         */

        function handleError() {
            var msgError = $translate.instant('ERROR');
            toastr.error(msgError);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ResultSearchByDiagnosticWsService', ResultSearchByDiagnosticWsService);

    /** @ngInject */
    function ResultSearchByDiagnosticWsService($q, $log, ResultSearchByDiagnosticConstants, ficViewListConstants, CacheConstants,RestUpgrade,
        CacheService) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.searchBTByDiagnostic = searchBTByDiagnostic;
        this.searchMDByDiagnostic = searchMDByDiagnostic;
        this.getAllCodes = getAllCodes;
        this.getCarSymptomsList = getCarSymptomsList;
        this.getAllSymptoms = getAllSymptoms;
        this.getQemotionThematics = getQemotionThematics;
        this.getSymptomsAIResult = getSymptomsAIResult;
        this.getQemotionVerbatim = getQemotionVerbatim;
        this.getRemoteDiagList = getRemoteDiagList;
        this.addRegistrationNumber = addRegistrationNumber;
        this.getBatteryCrashHistory = getBatteryCrashHistory;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function searchBTByDiagnostic(requestDiagnostic, listBT, next_url) {
            // ResultSearchByDiagnosticConstants.documentationSearchBT + "?offset=0&limit=25&sort=ID"
            // we can sort by ID, BTNumber, Date
            // offset = start
            // limit = numb of documents by request

            var url = (!next_url) ? ResultSearchByDiagnosticConstants.documentationSearchBT : '/proxy/apidh/rest/v1/' + next_url;
            return RestUpgrade.one(url).post('', requestDiagnostic).then(function (response) {
                listBT = listBT.concat(response.BT);
                if (response.next_url) {
                    return searchBTByDiagnostic(requestDiagnostic, listBT, response.next_url);
                } else {
                    return { BT: listBT };
                }
            }, function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);
            });
        }
        function searchMDByDiagnostic(requestDiagnostic) {
            return RestUpgrade.one(ResultSearchByDiagnosticConstants.documentationSearchMD).post('', requestDiagnostic).then(function (response) {
                return response;
            }, function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);
            });
        }

        /**
         * Get all longCodes of the symptoms applicable to the vehicle (irrespective of the presence of the doc) from dfps service
         * and inject them into symptoms service to retrieve corresponding shortCodes and labels
         */

        function getAllSymptoms(data) {

            return RestUpgrade.all(ResultSearchByDiagnosticConstants.documentationDiagnosticSymptoms).post(data).then(function (response) {
                var itemObject;
                var symptomsNodeIds = [];
                if (response && response.dfpsNodes && response.dfpsNodes.length > 0) {
                    _.filter(response.dfpsNodes, function (item) {
                        if(item.state == "P") {
                            itemObject = {};
                            if (item.nodeType == "SYMPTOM") {
                                itemObject['nodeId'] = item.nodeId;
                                symptomsNodeIds.push(itemObject);
                            }
                        }
                    });
                }

                var nodeIds = [];
                for (var i = 0; i < symptomsNodeIds.length; i++) {
                    var id = symptomsNodeIds[i].nodeId;
                    nodeIds.push(id);
                }

                var ids = {};

                ids['nodeId'] = nodeIds;

                var body = {
                    userContext: data.userContext,
                    carContext: data.carContext,
                    symptomsLongIds: ids.nodeId
                }

                var items;
                var shortAndLongCodes = [];
                
                return RestUpgrade.all(ficViewListConstants.endpoint.symptoms).post(body).then(function (resp) {
                    angular.forEach(resp.symptoms, function (item) {
                        items = {};
                        items['shortCode'] = item.shortCode;
                        items['longCode'] = item.longCode;
                        items['label'] = item.label;
                        items['id'] = item.id;
                        items['docType'] = item.docType;
                        shortAndLongCodes.push(items);
                    })
                    var symptomsShortAndLongCodes = {};
                    symptomsShortAndLongCodes['symptoms'] = shortAndLongCodes;
                    return symptomsShortAndLongCodes;
                });
            
            

            }).catch(function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);                
            });
        }

        function getAllCodes(requestGetAllCodes, listOfCodes, next_url) {
            if (!listOfCodes) {
                listOfCodes = {
                    'documents': []
                }
            }

                var endpoint = (!next_url) ? ResultSearchByDiagnosticConstants.documentationDiagnostic +'?limit=1000' : '/proxy/apidh/rest/v1/' + next_url;

                return RestUpgrade.all(endpoint).post(requestGetAllCodes).then(function (response) {
                if (response.documents) {
                    listOfCodes.documents = listOfCodes.documents.concat(response.documents);
                }

                if (response.next_url != null) {
                    return getAllCodes(requestGetAllCodes, listOfCodes, response.next_url);
                } else {
                    return listOfCodes;
                }
            }).catch(function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);                
            });
        }

        /**
         *  @desc Used to call symptoms-baskets API in order to get car's symptoms list.
         *  Example url = https:/xxxx.apigee.url/vehicles/v2/VF1JMRG0629761835/symptoms-baskets?locale=fr_FR&from=27%2F09%2F2017
         *
         *  @param body<Object> {
         *      vin: string
         *      locale: string
         *      from: date
         *      }
         *
         *  @return symptoms<Object> {
         *      Array<{
         *          symptomCode: string,
         *          symptomLongLabel: label,
         *          date: date
         *      }> || Array<empty>         *
         *
         */
        function getCarSymptomsList(body) {
            var url = ResultSearchByDiagnosticConstants.restListSymptoms + body.vin + "/symptoms-baskets?locale=" + body.locale + "&locale2=" + body.locale2 + "&from=" + body.from;
            return RestUpgrade.one(url).get();
        }

        function getQemotionThematics(payload){
              return RestUpgrade.all(ResultSearchByDiagnosticConstants.qemotionThematics).post(payload).then(function(res){
                return res;
              }).catch(function(msg){
                return $q.reject(msg);
            });
        }

        function getSymptomsAIResult(payload) {
            return RestUpgrade.all(ResultSearchByDiagnosticConstants.symptomsAI).post(payload).then(function (res) {
                return res;
            }).catch(function (msg) {
                return $q.reject(msg);
            });
        }

         function getQemotionVerbatim(payload){
            return RestUpgrade.all(ResultSearchByDiagnosticConstants.qemotionVerbatim).post(payload).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getRemoteDiagList(){
             var url = ResultSearchByDiagnosticConstants.diagList;
             return RestUpgrade.one(url).get().then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function addRegistrationNumber(payload){
            var url = ResultSearchByDiagnosticConstants.addRegistrationNumber;
            return RestUpgrade.all(url).post(payload).then(function(res){
                return res;
            }).catch(function(msg){
                return $q.reject(msg);
            });
        }

        function getBatteryCrashHistory(isBinSearched,binVinVal){
            var url = null;
            if(isBinSearched)
                url = ResultSearchByDiagnosticConstants.batteryCrashHistoryBinVin + "/bin/";
            else 
                url = ResultSearchByDiagnosticConstants.batteryCrashHistoryBinVin + "/vin/";
            return RestUpgrade.one(url+binVinVal).get().then(function(res){
               return res;
             }).catch(function(){
               return $q.reject();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ResultSearchByDiagnosticMetierService', ResultSearchByDiagnosticMetierService);

    /** @ngInject */
    function ResultSearchByDiagnosticMetierService(ResultSearchByDiagnosticWsService, $q, CacheService,CarOtsMetierService, $rootScope, 
        CacheConstants, ResultSearchByDiagnosticConstants,CodesConstants, $filter, UtilsMetierService, MainMetierService) {


        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.getBTList = getBTList;
        this.getAllCodes = getAllCodes;
        this.getCarSymptomsList = getCarSymptomsList;
        this.getAllSymptoms = getAllSymptoms;
        this.createDataObject = createDataObject;
        this.getBtListFixedCriterias = getBtListFixedCriterias;
        this.getQemotionThematics = getQemotionThematics;
        this.getSymptomsAIResult = getSymptomsAIResult;
        this.getQemotionVerbatim = getQemotionVerbatim;
        this.getRemoteDiagList = getRemoteDiagList; 
        this.addRegistrationNumber = addRegistrationNumber;
        this.getBatteryCrashHistory = getBatteryCrashHistory;      

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         *  @desc Permet de recuperer les diagnostiques liés aux véhicules.
         *  Au retour de la requete il y'a un traitement pour recuperer la liste de
         *  dtc, codes defaults, symptomes, un trie et suppression des doublons.
         *
         *  /!\ Les symptomes sont differents car ils ont differents type de label,
         *  il faut les afficher sous cette forme `code court - label`. `codes.symptoms` est
         *  un tableau qui contient une liste d'objet contenant un label, et un `longCode`
         *  qui servira à matcher le symptome avec un document.
         *
         *  symptomsList est un objet qui nous permet de retrouver le code court, label,
         *  ou long d'un symptome grace à son code long qu'on passera en prop.
         *
         *  @return Promise<Object {
         *      dtcCodes: Array<string> || Array<empty>
         *      defects : Array<string> || Array<empty>
         *      symptoms: Array<{
         *          longCode: string,
         *          label: label
         *      }> || Array<empty>
         *      documents: Array<Object>
         *  }>
         *
         */

        function getAllCodes(data) {

            return ResultSearchByDiagnosticWsService.getAllCodes(data)
                .then(function (response) {
                    var codes = {
                        dtcCodes: [],
                        defects: [],
                        documents: response.documents
                    };

                    response.documents.forEach(function (document) {
                        var tags = document.indexationsTags;
                        if (!tags) {
                            return null;
                        }

                        if (tags.DTC) {
                            codes.dtcCodes = codes.dtcCodes.concat(tags.DTC);
                        }

                        if (tags.defects) {
                            codes.defects = codes.defects.concat(tags.defects);
                        }
                    });

                    codes.dtcCodes = $filter('orderBy')(codes.dtcCodes);
                    codes.defects = $filter('orderBy')(codes.defects);

                    ["dtcCodes", "defects"].forEach(function (type) {
                        codes[type] = _.sortedUniq(codes[type]);
                    });

                    return codes;
                });
        }

        /**
         * Get all symptoms applicable to the vehicle (irrespective of the presence of the doc) from dfps service
         */

        function getAllSymptoms() {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);

            var data = {
                userContext: userContext,
                carContext: carContext
            };

            return ResultSearchByDiagnosticWsService.getAllSymptoms(data)
                .then(function (response) {

                    var codes = {
                        symptoms: []
                    };

                    if (response && response.symptoms && response.symptoms.length > 0) {
                        var symptoms = response.symptoms.map(function (item) {
                            var longCode = item.longCode;
                            var label = item.label;
                            var shortCode = item.shortCode;

                            if (longCode) {
                                label = item.shortCode + ' - ' + item.label;
                            }

                            return {
                                shortCode: shortCode,
                                longCode: longCode,
                                label: label
                            }
                        });
                        codes.symptoms = codes.symptoms.concat(symptoms);
                    }

                    codes.symptoms = $filter('orderBy')(codes.symptoms, 'label');

                    codes["symptoms"] = _.sortedUniqBy(codes["symptoms"], function (diag) {
                        return diag.label
                    });

                    return codes;
                });
        }


        /**
         *  @desc Used to call WS service symptoms-baskets API in order to get car's symptoms list.
         *  Creates the requestBody <Object>{vin, locale, from} to be sent to ResultSearchByDiagnosticWsService
         *  to get all car's symptoms for last 180 days.
         *
         *  @return symptoms<Object> {
         *      Array<{
         *          symptomCode: string,
         *          symptomLongLabel: label,
         *          date: date
         *      }> || Array<empty>         *
         *
         */
        function getCarSymptomsList() {
            var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
            var userContext = CacheService.getUserContext();
            var vin = carContext ? carContext.vehicle.vin || '' : '';
            let locale = userContext.language + '_' + userContext.countryCode || '';
            let locale2 = userContext.substitutionLanguage + '_' + userContext.countryCode || '';
            var from = getMaxDateEncoded() || '';
            var symptoms;
            var defer = $q.defer();

            var requestBody = {
                vin: vin,
                locale: locale,
                locale2: locale2,
                from: from
            };

            return ResultSearchByDiagnosticWsService.getCarSymptomsList(requestBody);

            //     defer.resolve(resp);
            //
            // }, function (error) {
            //     defer.reject(error);
            // });
            //
            // return defer.promise;
        };


        /*=============================================
        =                 HELPERS                   =
        =============================================*/

        /**
         *
         * @param BTList Array<string>
         * @return Promise<Object {
         *      BTInformation: Object
         * }>
         *
         */
        function getBTList(BTList) {
           var userContext = CacheService.getUserContext();
           var carContext = CacheService.getCarContext();
            const noColorBTList = (BTList || []).filter(function (bt) {
                return bt.subType === 'NO_COLOR';
            }).map(function (bt) {
                return bt.id;
            });
            const withColorBTList = (BTList || []).filter(function (bt) {
                 return bt.subType !== 'NO_COLOR';
            }).map(function (bt) {
                return bt.id;
            });

            function buildPayload(btColorTypeList, clearVariableCriteria) {
                const payloadCarContext = clearVariableCriteria ? angular.copy(carContext) : carContext;

                if (clearVariableCriteria && payloadCarContext) {
                    payloadCarContext.variableCriterias = {};
                }

                return {
                    userContext: userContext,
                    carContext: payloadCarContext,
                    BT: btColorTypeList
                };
            }

            const requests = [];

            if (noColorBTList.length > 0) {
                requests.push(ResultSearchByDiagnosticWsService.searchBTByDiagnostic(buildPayload(noColorBTList, false), []));
            }

            if (withColorBTList.length > 0) {
                requests.push(ResultSearchByDiagnosticWsService.searchBTByDiagnostic(buildPayload(withColorBTList, true), []));
            }

            return $q.all(requests).then(function (responses) {
                const BTInformation = {
                    BT: []
                };

                responses.forEach(function (response) {
                    if (response && response.BT && response.BT.length > 0) {
                        BTInformation.BT = BTInformation.BT.concat(response.BT);
                    }
                });

                BTInformation.BT.forEach(function (BT) {
                    BT.details.symptomList = BT.details.symptomList.map(function (symptom) {
                        return symptom.shortCode + ' - ' + symptom.label;
                    });
                });

                const btsWithOts = BTInformation.BT.filter(function(bt) {
                    return bt.ots && bt.ots.trim() !== '' && bt.colorCode !== 'NO_COLOR';
                });

                if (btsWithOts.length > 0) {
                    const vin = carContext ? carContext.vin : '';
                    const locale = userContext.language + '_' + userContext.countryCode || 'fr_FR';
                    
                    const queryParams = {
                        colorCodes: 'R,B,J,V,S,I,O',
                        local: locale
                    };
                    
                    return CarOtsMetierService.getOtsInformation(vin, queryParams)
                        .then(function(response) {
                            var otsData = [];
                            if (response && response.length > 0) {
                                otsData = response.map(function(ots) {
                                    return {
                                        id: ots.code
                                    };
                                });
                                
                                // CacheService.setObject(CacheConstants.listOts, otsData);
                            } else {
                                // CacheService.setObject(CacheConstants.listOts, []);
                                otsData = [];
                            }
                            
                            return {
                                BTInformation: filterBTsWithOTS(otsData, BTInformation.BT)
                            };
                        })
                        .catch(function(_error) {
                            // CacheService.setObject(CacheConstants.listOts, []);
                            return {
                                BTInformation: filterBTsWithOTS([], BTInformation.BT)
                            };
                        });
                } else {
                    return {
                        BTInformation: BTInformation.BT
                    };
                }
            });
        }

        /**
         * Filter BTs based on OTS data
         * Only show BTs that exist in both technicalBulletins result and OTS result
         * @param {Array} btList - List of BTs from technicalBulletins
         * @returns {Array} - Filtered list of BTs
         */
        function filterBTsWithOTS(otsData, btList) {
                if (!otsData || !Array.isArray(otsData) || otsData.length === 0) {
                    return btList.filter(function(bt) {
                        return !bt.ots || bt.ots.trim() === '' || bt.ots.trim() === null;
                    });
                }

                const btsWithOts = btList.filter(function(bt) {
                    return bt.ots && bt.ots.trim() !== '';
                });

                if (btsWithOts.length === 0) {
                    return btList;
                }

                const otsIds = {};
                otsData.forEach(function(otsItem) {
                    if (otsItem.id) {
                        otsIds[otsItem.id] = true;
                    }
                });
                return btList.filter(function(bt) {
                    if (!bt.ots || bt.ots.trim() === '') {
                        return true;
                    }
                    return otsIds[bt.ots];
                });
        }

        /**
         *  creates the data object to be sent to ResultSearchByDiagnosticWsService to get all codes and symptoms
         */
        function createDataObject(symptom, dtc, defaultCode) {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
            var userProfil = CacheService.getUserProfile();
            var isIndependentUser = MainMetierService.isIndependantUser(userProfil.roles);

            if (symptom === "") {
                symptom = [];
            }
            if (dtc === "") {
                dtc = [];
            }
            if (defaultCode === "") {
                defaultCode = [];
            }

            var docBt = {
                "BT": {
                    "subType": isIndependentUser ? ResultSearchByDiagnosticConstants.BTListAsom : ResultSearchByDiagnosticConstants.BTList,
                    "symptom": symptom,
                    "dtc": dtc,
                    "defaultCode": defaultCode
                }
            }

            var docMd = {
                "MD": {
                    "subType": ResultSearchByDiagnosticConstants.MDList,
                    "symptom": symptom,
                    "dtc": dtc,
                    "defaultCode": defaultCode
                }
            };

            var docTypeParam = {};

            if (
                isIndependentUser &&
                userProfil.isAsomValidDocAccess === 'true'
            ) {
                if ($rootScope.asomDocList && $rootScope.asomDocList.MD) docTypeParam.MD = docMd.MD;
                if ($rootScope.asomDocList && $rootScope.asomDocList.BT) docTypeParam.BT = docBt.BT;
             if ($rootScope.asomDocList) {
                if ($rootScope.asomDocList['MD-REMOTE']) {
                    docTypeParam.MD = docMd.MD;
                }
                if ($rootScope.asomDocList['BT-TECHLINE']) {
                    docTypeParam.BT = docBt.BT;
                }  
             }
            }
            else{
                docTypeParam.MD = docMd.MD;
                docTypeParam.BT = docBt.BT;
            }

            // if (carContext.typeMD === "B2") {
            //     docTypeParam.MD = ResultSearchByDiagnosticConstants.MDB2List;
            // } else if (carContext.typeMD === "B2-3") {
            //     docTypeParam.MD = docTypeParam.MD.subType.concat(ResultSearchByDiagnosticConstants.MDB2List);
            // }

            if (carContext.typeMD === "B2" || carContext.typeMD === "B2-3") {
                docTypeParam.MD.subType = docTypeParam.MD.subType.concat(ResultSearchByDiagnosticConstants.MDB2List.subType);
            }

            var data = {
                userContext: userContext,
                carContext: carContext,
                docType: docTypeParam
            };

            return data;
        }


        /**
         *  creates the encoded date = now - 180 days for API url
         */
        function getMaxDateEncoded() {
            var startdate = moment().subtract(ResultSearchByDiagnosticConstants.MAX_NUMBER_OF_DAYS, "days").format("DD/MM/YYYY");
            return encodeDate(startdate);
        }

        /**
         *  to encode date (Ex: 2018/07/17 -> 2018%2F07%2F17)
         */
        function encodeDate(date) {
            return encodeURIComponent(date);
        }

        function getBtListFixedCriterias() {
            var carContext = CacheService.getCarContext();
            if (carContext) {
                var btListFixedCriterias = {
                    "007": carContext.fixedCriterias["007"],
                    "008": carContext.fixedCriterias["008"],
                    "999": carContext.fixedCriterias["999"],
                    "998": carContext.fixedCriterias["998"],
                    "997": carContext.fixedCriterias["997"],
                    "996": carContext.fixedCriterias["996"],
                    "968": carContext.fixedCriterias["968"],
                    "966": carContext.fixedCriterias["966"]
                };
            }

            return btListFixedCriterias;
        }

        function getSymptomsAIResult(searchText) {
            var code = CodesConstants;
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
            var symptomsCodesList = CacheService.getObject(CacheConstants.getAllSymptoms);
            var symptomsList = symptomsCodesList && symptomsCodesList.symptoms ? symptomsCodesList.symptoms : [];
            var symptomCodes = symptomsList && symptomsList.length > 0 ? symptomsList.map(function(symptom) { 
                return symptom.shortCode;
            }) : [];
            var requestBody = {
                "clientVerbatim": searchText,
                "projectCode": (carContext && carContext.families && !_.isEmpty(carContext.families) && carContext.families.familyVehicle && !_.isEmpty(carContext.families.familyVehicle) && carContext.families.familyVehicle.length > 0) ? carContext.families.familyVehicle[0] : "",
                "languageCode": UtilsMetierService.getQemotionLang(),
                "applicableSymptomCodes": symptomCodes ? symptomCodes : [],
                "vin": carContext ? carContext.vin : "",
                "engineType": carContext ? carContext.fixedCriterias[code.engineType] : "",
                "gearboxType": carContext ? carContext.fixedCriterias[code.gearBoxType] : "",
                "maxResultNumber": 5
            }
            return ResultSearchByDiagnosticWsService.getSymptomsAIResult(requestBody);
        }

        function getQemotionThematics(searchText){
            var requestBody = {
                "text": searchText,
                "lang": UtilsMetierService.getQemotionLang()
            };
            return ResultSearchByDiagnosticWsService.getQemotionThematics(requestBody);
        }

        function getQemotionVerbatim(searchText,selectedSymptom){
             var  requestBody = {
                "text": searchText,
                "lang": UtilsMetierService.getQemotionLang(),
                "creation_date": moment(new Date()).format("YYYY-MM-DD"),
                "author": ResultSearchByDiagnosticConstants.qemotionClient,
                "filters": {
                    "ShortCode": selectedSymptom.shortCode
                }
             }
            return ResultSearchByDiagnosticWsService.getQemotionVerbatim(requestBody);
        }

        function getRemoteDiagList(){
            return ResultSearchByDiagnosticWsService.getRemoteDiagList();
        }

        function addRegistrationNumber(vin,registrationNumber){
            const payload = {
                vin: vin,
                registrationNumber: registrationNumber
            };
            return ResultSearchByDiagnosticWsService.addRegistrationNumber(payload);
        }

        function getBatteryCrashHistory(isBinSearched,binVinVal){
           return ResultSearchByDiagnosticWsService.getBatteryCrashHistory(isBinSearched,binVinVal);
       }

    }

})();

'use strict';

angular.module('phenix').constant('UsageCountryList', {
    fr: [
{"value":"AF","label":"Afghanistan"},
{"value":"ZA","label":"Afrique du Sud"},
{"value":"AX","label":"Åland (Îles)"},
{"value":"AL","label":"Albanie"},
{"value":"DZ","label":"Algérie"},
{"value":"DE","label":"Allemagne"},
{"value":"AD","label":"Andorre"},
{"value":"AO","label":"Angola"},
{"value":"AI","label":"Anguilla"},
{"value":"AQ","label":"Antarctique"},
{"value":"AG","label":"Antigua-et-Barbuda"},
{"value":"SA","label":"Arabie saoudite"},
{"value":"AR","label":"Argentine"},
{"value":"AM","label":"Arménie"},
{"value":"AW","label":"Aruba"},
{"value":"AU","label":"Australie"},
{"value":"AT","label":"Autriche"},
{"value":"AZ","label":"Azerbaïdjan"},
{"value":"BS","label":"Bahamas"},
{"value":"BH","label":"Bahreïn"},
{"value":"BD","label":"Bangladesh"},
{"value":"BB","label":"Barbade"},
{"value":"BE","label":"Belgique"},
{"value":"BZ","label":"Belize"},
{"value":"BJ","label":"Bénin"},
{"value":"BM","label":"Bermudes"},
{"value":"BT","label":"Bhoutan"},
{"value":"BY","label":"Biélorussie"},
{"value":"BO","label":"Bolivie"},
{"value":"BQ","label":"Bonaire  Saint-Eustache et Saba"},
{"value":"BA","label":"Bosnie-Herzégovine"},
{"value":"BW","label":"Botswana"},
{"value":"BV","label":"Bouvet (Île)"},
{"value":"BR","label":"Brésil"},
{"value":"BN","label":"Brunei"},
{"value":"BG","label":"Bulgarie"},
{"value":"BF","label":"Burkina Faso"},
{"value":"BI","label":"Burundi"},
{"value":"KY","label":"Caïmans (Îles)"},
{"value":"KH","label":"Cambodge"},
{"value":"CM","label":"Cameroun"},
{"value":"CA","label":"Canada"},
{"value":"CV","label":"Cap-Vert"},
{"value":"CF","label":"Centrafricaine (République)"},
{"value":"CL","label":"Chili"},
{"value":"CN","label":"Chine"},
{"value":"CY","label":"Chypre"},
{"value":"CX","label":"Christmas (Île)"},
{"value":"CC","label":"Cocos (Îles)"},
{"value":"CO","label":"Colombie"},
{"value":"KM","label":"Comores"},
{"value":"CG","label":"Congo (République)"},
{"value":"CD","label":"Congo (République démocratique)"},
{"value":"CK","label":"Cook (Îles)"},
{"value":"KP","label":"Corée du Nord"},
{"value":"KR","label":"Corée du Sud"},
{"value":"CR","label":"Costa Rica"},
{"value":"CI","label":"Côte d'Ivoire"},
{"value":"HR","label":"Croatie"},
{"value":"CU","label":"Cuba"},
{"value":"CW","label":"Curaçao"},
{"value":"DK","label":"Danemark"},
{"value":"DJ","label":"Djibouti"},
{"value":"DM","label":"Dominique"},
{"value":"EG","label":"Égypte"},
{"value":"AE","label":"Émirats arabes unis"},
{"value":"EC","label":"Équateur"},
{"value":"ER","label":"Érythrée"},
{"value":"ES","label":"Espagne"},
{"value":"EE","label":"Estonie"},
{"value":"SZ","label":"Eswatini"},
{"value":"US","label":"États-Unis"},
{"value":"ET","label":"Éthiopie"},
{"value":"FK","label":"Falkland (Îles / Malouines)"},
{"value":"FO","label":"Féroé (Îles)"},
{"value":"FJ","label":"Fidji"},
{"value":"FI","label":"Finlande"},
{"value":"FR","label":"France"},
{"value":"GA","label":"Gabon"},
{"value":"GM","label":"Gambie"},
{"value":"GE","label":"Géorgie"},
{"value":"GS","label":"Géorgie du Sud-et-les Îles Sandwich du Sud"},
{"value":"GH","label":"Ghana"},
{"value":"GI","label":"Gibraltar"},
{"value":"GR","label":"Grèce"},
{"value":"GD","label":"Grenade"},
{"value":"GL","label":"Groenland"},
{"value":"GP","label":"Guadeloupe"},
{"value":"GU","label":"Guam"},
{"value":"GT","label":"Guatemala"},
{"value":"GG","label":"Guernesey"},
{"value":"GN","label":"Guinée"},
{"value":"GW","label":"Guinée-Bissau"},
{"value":"GQ","label":"Guinée équatoriale"},
{"value":"GY","label":"Guyana"},
{"value":"GF","label":"Guyane française"},
{"value":"HT","label":"Haïti"},
{"value":"HM","label":"Heard-et-Îles MacDonald (Îles)"},
{"value":"HN","label":"Honduras"},
{"value":"HK","label":"Hong Kong"},
{"value":"HU","label":"Hongrie"},
{"value":"IM","label":"Île de Man"},
{"value":"IN","label":"Inde"},
{"value":"ID","label":"Indonésie"},
{"value":"IQ","label":"Irak"},
{"value":"IR","label":"Iran"},
{"value":"IE","label":"Irlande"},
{"value":"IS","label":"Islande"},
{"value":"IL","label":"Israël"},
{"value":"IT","label":"Italie"},
{"value":"JM","label":"Jamaïque"},
{"value":"JP","label":"Japon"},
{"value":"JE","label":"Jersey"},
{"value":"JO","label":"Jordanie"},
{"value":"KZ","label":"Kazakhstan"},
{"value":"KE","label":"Kenya"},
{"value":"KG","label":"Kirghizistan"},
{"value":"KI","label":"Kiribati"},
{"value":"KW","label":"Koweït"},
{"value":"LA","label":"Laos"},
{"value":"LS","label":"Lesotho"},
{"value":"LV","label":"Lettonie"},
{"value":"LB","label":"Liban"},
{"value":"LR","label":"Libéria"},
{"value":"LY","label":"Libye"},
{"value":"LI","label":"Liechtenstein"},
{"value":"LT","label":"Lituanie"},
{"value":"LU","label":"Luxembourg"},
{"value":"MO","label":"Macao"},
{"value":"MK","label":"Macédoine du Nord"},
{"value":"MG","label":"Madagascar"},
{"value":"MY","label":"Malaisie"},
{"value":"MW","label":"Malawi"},
{"value":"MV","label":"Maldives"},
{"value":"ML","label":"Mali"},
{"value":"MT","label":"Malte"},
{"value":"MP","label":"Mariannes du Nord (Îles)"},
{"value":"MA","label":"Maroc"},
{"value":"MH","label":"Marshall (Îles)"},
{"value":"MQ","label":"Martinique"},
{"value":"MU","label":"Maurice"},
{"value":"MR","label":"Mauritanie"},
{"value":"YT","label":"Mayotte"},
{"value":"MX","label":"Mexique"},
{"value":"FM","label":"Micronésie"},
{"value":"MD","label":"Moldavie"},
{"value":"MC","label":"Monaco"},
{"value":"MN","label":"Mongolie"},
{"value":"ME","label":"Monténégro"},
{"value":"MS","label":"Montserrat"},
{"value":"MZ","label":"Mozambique"},
{"value":"MM","label":"Myanmar (Birmanie)"},
{"value":"NA","label":"Namibie"},
{"value":"NR","label":"Nauru"},
{"value":"NP","label":"Népal"},
{"value":"NI","label":"Nicaragua"},
{"value":"NE","label":"Niger"},
{"value":"NG","label":"Négéria"},
{"value":"NU","label":"Niué"},
{"value":"NF","label":"Norfolk (Île)"},
{"value":"NO","label":"Norvège"},
{"value":"NC","label":"Nouvelle-Calédonie"},
{"value":"NZ","label":"Nouvelle-Zélande"},
{"value":"IO","label":"Océan Indien (Territoire britannique)"},
{"value":"OM","label":"Oman"},
{"value":"UG","label":"Ouganda"},
{"value":"UZ","label":"Ouzbékistan"},
{"value":"PK","label":"Pakistan"},
{"value":"PW","label":"Palaos"},
{"value":"PS","label":"Palestine"},
{"value":"PA","label":"Panama"},
{"value":"PG","label":"Papouasie-Nouvelle-Guinée"},
{"value":"PY","label":"Paraguay"},
{"value":"NL","label":"Pays-Bas"},
{"value":"PE","label":"Pérou"},
{"value":"PH","label":"Philippines"},
{"value":"PN","label":"Pitcairn"},
{"value":"PL","label":"Pologne"},
{"value":"PF","label":"Polynésie française"},
{"value":"PR","label":"Porto Rico"},
{"value":"PT","label":"Portugal"},
{"value":"QA","label":"Qatar"},
{"value":"RE","label":"Réunion (Île de la)"},
{"value":"RO","label":"Roumanie"},
{"value":"GB","label":"Royaume-Uni"},
{"value":"RU","label":"Russie"},
{"value":"RW","label":"Rwanda"},
{"value":"EH","label":"Sahara occidental"},
{"value":"BL","label":"Saint-Barthélemy"},
{"value":"KN","label":"Saint-Christophe-et-Niévès"},
{"value":"SM","label":"Saint-Marin"},
{"value":"MF","label":"Saint-Martin (Antilles françaises)"},
{"value":"SX","label":"Saint-Martin (Royaume des Pays-Bas)"},
{"value":"PM","label":"Saint-Pierre-et-Miquelon"},
{"value":"VC","label":"Saint-Vincent-et-les-Grenadines"},
{"value":"SH","label":"Sainte-Hélène Ascension et Tristan da Cunha"},
{"value":"LC","label":"Sainte-Lucie"},
{"value":"SB","label":"Salomon (Îles)"},
{"value":"WS","label":"Samoa"},
{"value":"AS","label":"Samoa américaines"},
{"value":"ST","label":"Sao Tomé-et-Principe"},
{"value":"SN","label":"Sénégal"},
{"value":"RS","label":"Serbie"},
{"value":"SC","label":"Seychelles"},
{"value":"SL","label":"Sierra Leone"},
{"value":"SG","label":"Singapour"},
{"value":"SK","label":"Slovaquie"},
{"value":"SI","label":"Slovénie"},
{"value":"SO","label":"Somalie"},
{"value":"SD","label":"Soudan"},
{"value":"SS","label":"Soudan du Sud"},
{"value":"LK","label":"Sri Lanka"},
{"value":"SE","label":"Suède"},
{"value":"CH","label":"Suisse"},
{"value":"SR","label":"Suriname"},
{"value":"SJ","label":"Svalbard et Jan Mayen"},
{"value":"SY","label":"Syrie"},
{"value":"TJ","label":"Tadjikistan"},
{"value":"TW","label":"Taïwan"},
{"value":"TZ","label":"Tanzanie"},
{"value":"TD","label":"Tchad"},
{"value":"CZ","label":"Tchéquie"},
{"value":"TF","label":"Terres australes et antarctiques françaises"},
{"value":"TH","label":"Thaïlande"},
{"value":"TL","label":"Timor oriental"},
{"value":"TK","label":"Tokelau"},
{"value":"TO","label":"Tonga"},
{"value":"TT","label":"Trinité-et-Tobago"},
{"value":"TN","label":"Tunisie"},
{"value":"TM","label":"Turkménistan"},
{"value":"TC","label":"Turques-et-Caïques (Îles)"},
{"value":"TR","label":"Turquie"},
{"value":"TV","label":"Tuvalu"},
{"value":"UA","label":"Ukraine"},
{"value":"UY","label":"Uruguay"},
{"value":"VU","label":"Vanuatu"},
{"value":"VA","label":"Vatican"},
{"value":"VE","label":"Venezuela"},
{"value":"VN","label":"Viêt Nam"},
{"value":"VG","label":"Vierges britanniques (Îles)"},
{"value":"VI","label":"Vierges des États-Unis (Îles)"},
{"value":"WF","label":"Wallis-et-Futuna"},
{"value":"YE","label":"Yémen"},
{"value":"ZM","label":"Zambie"},
{"value":"ZW","label":"Zimbabwe"}
],
    en: [
    {"value":"AF","label":"Afghanistan"},
{"value":"AX","label":"Åland Islands"},
{"value":"AL","label":"Albania"},
{"value":"DZ","label":"Algeria"},
{"value":"AS","label":"American Samoa"},
{"value":"AD","label":"Andorra"},
{"value":"AO","label":"Angola"},
{"value":"AI","label":"Anguilla"},
{"value":"AQ","label":"Antarctica"},
{"value":"AG","label":"Antigua and Barbuda"},
{"value":"AR","label":"Argentina"},
{"value":"AM","label":"Armenia"},
{"value":"AW","label":"Aruba"},
{"value":"AU","label":"Australia"},
{"value":"AT","label":"Austria"},
{"value":"AZ","label":"Azerbaijan"},
{"value":"BS","label":"Bahamas"},
{"value":"BH","label":"Bahrain"},
{"value":"BD","label":"Bangladesh"},
{"value":"BB","label":"Barbados"},
{"value":"BY","label":"Belarus"},
{"value":"BE","label":"Belgium"},
{"value":"BZ","label":"Belize"},
{"value":"BJ","label":"Benin"},
{"value":"BM","label":"Bermuda"},
{"value":"BT","label":"Bhutan"},
{"value":"BO","label":"Bolivia, Plurinational State of"},
{"value":"BQ","label":"Bonaire, Sint Eustatius and Saba"},
{"value":"BA","label":"Bosnia and Herzegovina"},
{"value":"BW","label":"Botswana"},
{"value":"BV","label":"Bouvet Island"},
{"value":"BR","label":"Brazil"},
{"value":"IO","label":"British Indian Ocean Territory"},
{"value":"BN","label":"Brunei Darussalam"},
{"value":"BG","label":"Bulgaria"},
{"value":"BF","label":"Burkina Faso"},
{"value":"BI","label":"Burundi"},
{"value":"CV","label":"Cabo Verde"},
{"value":"KH","label":"Cambodia"},
{"value":"CM","label":"Cameroon"},
{"value":"CA","label":"Canada"},
{"value":"KY","label":"Cayman Islands"},
{"value":"CF","label":"Central African Republic"},
{"value":"TD","label":"Chad"},
{"value":"CL","label":"Chile"},
{"value":"CN","label":"China"},
{"value":"CX","label":"Christmas Island"},
{"value":"CC","label":"Cocos (Keeling) Islands"},
{"value":"CO","label":"Colombia"},
{"value":"KM","label":"Comoros"},
{"value":"CG","label":"Congo"},
{"value":"CD","label":"Congo, Democratic Republic of the"},
{"value":"CK","label":"Cook Islands"},
{"value":"CR","label":"Costa Rica"},
{"value":"CI","label":"Côte d'Ivoire"},
{"value":"HR","label":"Croatia"},
{"value":"CU","label":"Cuba"},
{"value":"CW","label":"Curaçao"},
{"value":"CY","label":"Cyprus"},
{"value":"CZ","label":"Czechia"},
{"value":"DK","label":"Denmark"},
{"value":"DJ","label":"Djibouti"},
{"value":"DM","label":"Dominica"},
{"value":"DO","label":"Dominican Republic"},
{"value":"EC","label":"Ecuador"},
{"value":"EG","label":"Egypt"},
{"value":"SV","label":"El Salvador"},
{"value":"GQ","label":"Equatorial Guinea"},
{"value":"ER","label":"Eritrea"},
{"value":"EE","label":"Estonia"},
{"value":"SZ","label":"Eswatini"},
{"value":"ET","label":"Ethiopia"},
{"value":"FK","label":"Falkland Islands (Malvinas)"},
{"value":"FO","label":"Faroe Islands"},
{"value":"FJ","label":"Fiji"},
{"value":"FI","label":"Finland"},
{"value":"FR","label":"France"},
{"value":"GF","label":"French Guiana"},
{"value":"PF","label":"French Polynesia"},
{"value":"TF","label":"French Southern Territories"},
{"value":"GA","label":"Gabon"},
{"value":"GM","label":"Gambia"},
{"value":"GE","label":"Georgia"},
{"value":"DE","label":"Germany"},
{"value":"GH","label":"Ghana"},
{"value":"GI","label":"Gibraltar"},
{"value":"GR","label":"Greece"},
{"value":"GL","label":"Greenland"},
{"value":"GD","label":"Grenada"},
{"value":"GP","label":"Guadeloupe"},
{"value":"GU","label":"Guam"},
{"value":"GT","label":"Guatemala"},
{"value":"GG","label":"Guernsey"},
{"value":"GN","label":"Guinea"},
{"value":"GW","label":"Guinea-Bissau"},
{"value":"GY","label":"Guyana"},
{"value":"HT","label":"Haiti"},
{"value":"HM","label":"Heard Island and McDonald Islands"},
{"value":"VA","label":"Holy See"},
{"value":"HN","label":"Honduras"},
{"value":"HK","label":"Hong Kong"},
{"value":"HU","label":"Hungary"},
{"value":"IS","label":"Iceland"},
{"value":"IN","label":"India"},
{"value":"ID","label":"Indonesia"},
{"value":"IR","label":"Iran, Islamic Republic of"},
{"value":"IQ","label":"Iraq"},
{"value":"IE","label":"Ireland"},
{"value":"IM","label":"Isle of Man"},
{"value":"IL","label":"Israel"},
{"value":"IT","label":"Italy"},
{"value":"JM","label":"Jamaica"},
{"value":"JP","label":"Japan"},
{"value":"JE","label":"Jersey"},
{"value":"JO","label":"Jordan"},
{"value":"KZ","label":"Kazakhstan"},
{"value":"KE","label":"Kenya"},
{"value":"KI","label":"Kiribati"},
{"value":"KP","label":"Korea, Democratic People's Republic of"},
{"value":"KR","label":"Korea, Republic of"},
{"value":"KW","label":"Kuwait"},
{"value":"KG","label":"Kyrgyzstan"},
{"value":"LA","label":"Lao People's Democratic Republic"},
{"value":"LV","label":"Latvia"},
{"value":"LB","label":"Lebanon"},
{"value":"LS","label":"Lesotho"},
{"value":"LR","label":"Liberia"},
{"value":"LY","label":"Libya"},
{"value":"LI","label":"Liechtenstein"},
{"value":"LT","label":"Lithuania"},
{"value":"LU","label":"Luxembourg"},
{"value":"MO","label":"Macao"},
{"value":"MG","label":"Madagascar"},
{"value":"MW","label":"Malawi"},
{"value":"MY","label":"Malaysia"},
{"value":"MV","label":"Maldives"},
{"value":"ML","label":"Mali"},
{"value":"MT","label":"Malta"},
{"value":"MH","label":"Marshall Islands"},
{"value":"MQ","label":"Martinique"},
{"value":"MR","label":"Mauritania"},
{"value":"MU","label":"Mauritius"},
{"value":"YT","label":"Mayotte"},
{"value":"MX","label":"Mexico"},
{"value":"FM","label":"Micronesia, Federated States of"},
{"value":"MD","label":"Moldova, Republic of"},
{"value":"MC","label":"Monaco"},
{"value":"MN","label":"Mongolia"},
{"value":"ME","label":"Montenegro"},
{"value":"MS","label":"Montserrat"},
{"value":"MA","label":"Morocco"},
{"value":"MZ","label":"Mozambique"},
{"value":"MM","label":"Myanmar"},
{"value":"NA","label":"Namibia"},
{"value":"NR","label":"Nauru"},
{"value":"NP","label":"Nepal"},
{"value":"NL","label":"Netherlands"},
{"value":"NC","label":"New Caledonia"},
{"value":"NZ","label":"New Zealand"},
{"value":"NI","label":"Nicaragua"},
{"value":"NE","label":"Niger"},
{"value":"NG","label":"Nigeria"},
{"value":"NU","label":"Niue"},
{"value":"NF","label":"Norfolk Island"},
{"value":"MK","label":"North Macedonia"},
{"value":"MP","label":"Northern Mariana Islands"},
{"value":"NO","label":"Norway"},
{"value":"OM","label":"Oman"},
{"value":"PK","label":"Pakistan"},
{"value":"PW","label":"Palau"},
{"value":"PS","label":"Palestine, State of"},
{"value":"PA","label":"Panama"},
{"value":"PG","label":"Papua New Guinea"},
{"value":"PY","label":"Paraguay"},
{"value":"PE","label":"Peru"},
{"value":"PH","label":"Philippines"},
{"value":"PN","label":"Pitcairn"},
{"value":"PL","label":"Poland"},
{"value":"PT","label":"Portugal"},
{"value":"PR","label":"Puerto Rico"},
{"value":"QA","label":"Qatar"},
{"value":"RE","label":"Réunion"},
{"value":"RO","label":"Romania"},
{"value":"RU","label":"Russian Federation"},
{"value":"RW","label":"Rwanda"},
{"value":"BL","label":"Saint Barthélemy"},
{"value":"SH","label":"Saint Helena, Ascension and Tristan da Cunha"},
{"value":"KN","label":"Saint Kitts and Nevis"},
{"value":"LC","label":"Saint Lucia"},
{"value":"MF","label":"Saint Martin (French part)"},
{"value":"PM","label":"Saint Pierre and Miquelon"},
{"value":"VC","label":"Saint Vincent and the Grenadines"},
{"value":"WS","label":"Samoa"},
{"value":"SM","label":"San Marino"},
{"value":"ST","label":"Sao Tome and Principe"},
{"value":"SA","label":"Saudi Arabia"},
{"value":"SN","label":"Senegal"},
{"value":"RS","label":"Serbia"},
{"value":"SC","label":"Seychelles"},
{"value":"SL","label":"Sierra Leone"},
{"value":"SG","label":"Singapore"},
{"value":"SX","label":"Sint Maarten (Dutch part)"},
{"value":"SK","label":"Slovakia"},
{"value":"SI","label":"Slovenia"},
{"value":"SB","label":"Solomon Islands"},
{"value":"SO","label":"Somalia"},
{"value":"ZA","label":"South Africa"},
{"value":"GS","label":"South Georgia and the South Sandwich Islands"},
{"value":"SS","label":"South Sudan"},
{"value":"ES","label":"Spain"},
{"value":"LK","label":"Sri Lanka"},
{"value":"SD","label":"Sudan"},
{"value":"SR","label":"Suriname"},
{"value":"SJ","label":"Svalbard and Jan Mayen"},
{"value":"SE","label":"Sweden"},
{"value":"CH","label":"Switzerland"},
{"value":"SY","label":"Syrian Arab Republic"},
{"value":"TW","label":"Taiwan, Province of China"},
{"value":"TJ","label":"Tajikistan"},
{"value":"TZ","label":"Tanzania, United Republic of"},
{"value":"TH","label":"Thailand"},
{"value":"TL","label":"Timor-Leste"},
{"value":"TG","label":"Togo"},
{"value":"TK","label":"Tokelau"},
{"value":"TO","label":"Tonga"},
{"value":"TT","label":"Trinidad and Tobago"},
{"value":"TN","label":"Tunisia"},
{"value":"TR","label":"Türkiye"},
{"value":"TM","label":"Turkmenistan"},
{"value":"TC","label":"Turks and Caicos Islands"},
{"value":"TV","label":"Tuvalu"},
{"value":"UG","label":"Uganda"},
{"value":"UA","label":"Ukraine"},
{"value":"AE","label":"United Arab Emirates"},
{"value":"GB","label":"United Kingdom"},
{"value":"UM","label":"United States Minor Outlying Islands"},
{"value":"US","label":"United States of America"},
{"value":"UY","label":"Uruguay"},
{"value":"UZ","label":"Uzbekistan"},
{"value":"VU","label":"Vanuatu"},
{"value":"VE","label":"Venezuela, Bolivarian Republic of"},
{"value":"VN","label":"Viet Nam"},
{"value":"VG","label":"Virgin Islands (British)"},
{"value":"VI","label":"Virgin Islands (U.S.)"},
{"value":"WF","label":"Wallis and Futuna"},
{"value":"EH","label":"Western Sahara"},
{"value":"YE","label":"Yemen"},
{"value":"ZM","label":"Zambia"},
{"value":"ZW","label":"Zimbabwe"}
]
});
(function() {
    angular.module("phenix").constant(
        "trainingMock",
        {
            trainingOffersWithoutFr: [
                {
                    productName: "Kontaktuppgifter till Dialogys_se",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/Kontaktuppgifter till Dialogys_se.pdf",
                    countryCode: "SE"
                },
                {
                    productName: "RENAULT UK Training Path 2019_gb",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/RENAULT UK Training Path 2019_gb.pdf",
                    countryCode: "GB"
                }
            ],
            trainingOffersWithFr: [
                {
                    productName: "Kontaktuppgifter till Dialogys_se",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/Kontaktuppgifter till Dialogys_se.pdf",
                    countryCode: "SE"
                },
                {
                    productName: "RENAULT UK Training Path 2019_gb",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/RENAULT UK Training Path 2019_gb.pdf",
                    countryCode: "GB"
                },
                {
                    productName: "Training R3-French",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/Training R3-French.pdf",
                    countryCode: "FR"
                }
            ], expectedResponseIfFinded:   [
                {
                    productName: "Training R3-French",
                    contentUrl:
                        "https://cdn-re7.asdh.aws.renault.com/trainingOffer/Training R3-French.pdf",
                    countryCode: "FR"
                }
            ], expectedResponseIfNotFinded:   [

            ]
        }
    );
})();

(function () {
    angular
        .module("phenix")
        .service("TrainingWsService", function (
            RestUpgrade, $http,
            trainingConstants
        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/
            this.calltrainingOffersService = calltrainingOffersService;
            this.getProjectList = getProjectList;
            this.getReleaseLinks = getReleaseLinks;
            this.getElucidatLaunchLink = getElucidatLaunchLink;
            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            function calltrainingOffersService(){
                return RestUpgrade.one(trainingConstants.trainingOfferService).get();
            }

            function getProjectList() {
                return $http.get(trainingConstants.elucidatConnectionURL).then(function (response) {
                    return response;
                })
            }

            function getReleaseLinks(payload) {
                return $http.post(trainingConstants.elucidatConnectionURL,payload).then(function (response) {
                    return response;
                })
            }

            function getElucidatLaunchLink(payload) {
                return $http.post(trainingConstants.elucidatConnectionURL,payload).then(function (response) {
                    return response;
                })
            }
        });
})();

(function () {
    angular
        .module("phenix")
        .service("TrainingMetierService", function (
            $http,
            TrainingWsService, UtilsMetierService

        ) {
              /*=============================================
            =                  VARIABLES                  =
            =============================================*/
              this.calltrainingOffersService = calltrainingOffersService;
              this.matchTrainingbyUserCountry = matchTrainingbyUserCountry;
              this.getProjectList = getProjectList;
              this.getReleaseLinks = getReleaseLinks;
              this.getElucidatLaunchLink = getElucidatLaunchLink;
              /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
              function calltrainingOffersService() {
                  return TrainingWsService.calltrainingOffersService();
              }

              function getReleaseLinks(projectCode) {
                  var payload = {
                      projectCode: projectCode
                  }
                  return TrainingWsService.getReleaseLinks(payload);
              }

              function getProjectList() {
                  return TrainingWsService.getProjectList();
              }
              /**
               * @desc this function filter the response from service and return a new array if the user country match with the training offers country
               */
              function matchTrainingbyUserCountry(responseFromServiceOffers) {
                  var profile = UtilsMetierService.getProfile();

                  var filteredArray = _.filter(
                      responseFromServiceOffers,
                      function(offer) {
                          return (
                              offer.countryCode === profile.country
                          );
                      }
                  );
                  return filteredArray;
              }

            function getElucidatLaunchLink(code) {
                var profile = UtilsMetierService.getProfile();
                var payload = {
                    releaseCode: code,
                    ipn: profile.ipn,
                    name: profile.firstName + ' '+profile.lastName
                }
                return TrainingWsService.getElucidatLaunchLink(payload);
            }
          });
})();

(function () {
    angular
        .module("phenix")
        .service("RenaultTechWsService", function (
            RestUpgrade,
            renaultTechConstants
        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/
            this.callTransformedProductsService = callTransformedProductsService;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            function callTransformedProductsService(){
                return RestUpgrade.one(renaultTechConstants.transformedProducts).get();
            }
            
        });
})();

(function () {
    angular
        .module("phenix")
        .service("RenaultTechMetierService", function (
            RenaultTechWsService

        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/
            this.callTransformedProductsService = callTransformedProductsService; 

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            function callTransformedProductsService(){
                return RenaultTechWsService.callTransformedProductsService();
            }
            
        });
})();

(function () {
    angular
        .module("phenix")
        .service("OldRangeDocumentsWsService", function (
            RestUpgrade,
            oldRangeDocumentsConstants
        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/
            this.getOldRangeDocumentationService = getOldRangeDocumentationService;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            function getOldRangeDocumentationService(){
                return RestUpgrade.one(oldRangeDocumentsConstants.OldRangeDocuments).get();
            }

        });
})();

(function () {
    angular
        .module("phenix")
        .service("OldRangeDocumentsMetierService", function (
            OldRangeDocumentsWsService

        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/
            this.getOldRangeDocumentation = getOldRangeDocumentation;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            function getOldRangeDocumentation(){
                return OldRangeDocumentsWsService.getOldRangeDocumentationService();
            }

        });
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('carMaintenanceProgram', {
            bindings: {
                isCarContextChanged: '<'
            },
            controller: carMaintenanceProgram,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/features/components/carMaintenanceProgram/carMaintenanceProgram.template.html'
        });

    function carMaintenanceProgram(
        $scope, $q, $rootScope, $timeout,
        CacheService,
        CacheConstants,
        CarTechnicalFeaturesConstants,
        blockUI,
        toastr,
        carMaintenanceProgramMetierService,
        CarTechnicalCriteriaMetierService,
        DealerManagerSystemeService,
        $translate,
        FeaturesConstants,
        printPdfModalService,
        configConstantes, $log, $mdDialog, MainMetierService, ShoppingCartService, CarSearchMetierService, UtilsMetierService,$state,RoutesConstants,CarSearchResultConstants
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.showContent = false;
        vm.CAR_OTS_TYPE = '';
        vm.VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM_ABSENT = '';
        vm.CAR_FEATURE_AVERAGE_CAPACITY = '';
        vm.ALERTS_LEVEL_ALERTS_STANDARD = '';
        vm.primaryOperations = null;
        vm.secondaryOperations = null;
        vm.thirdTabOperations = null;
        vm.groups = [];
        vm.maintenanceProgram = {};
        vm.showPrintButton = false;
        vm.isMilesDisplay = false;
        vm.mileageData = null;
        vm.vinOperationData = null;
        vm.getVinResponse = null;
        vm.isPlannedAssistance = false;

        vm.getUniquegrade = getUniquegrade;
        vm.shouldShowCatalogIcon = shouldShowCatalogIcon;
        vm.getPrimaryOperations = getPrimaryOperations;
        vm.getSecondaryOperations = getSecondaryOperations;
        vm.getThirdTabOperations = getThirdTabOperations;
        vm.printMaintenanceProgram = printMaintenanceProgram;
        vm.toMultiLines = toMultiLines;
        vm.formatText = formatText;
        vm.printPdf = printPdf;
        $scope.parseFloat = parseFloat;
        vm.milesKmDisplayUpdate = milesKmDisplayUpdate;
        vm.declareToRenault = declareToRenault;
        vm.userProfil = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.userProfil.roles);
        vm.showTiresInfo = showTiresInfo;
        vm.checkFieldsOfTires = checkFieldsOfTires;
        vm.tiresData = tiresData;
        vm.saveMileage = saveMileage;
        vm.getConvertedMileage = getConvertedMileage;
        vm.oldMaintenanceTab = false;
        vm.setVariables = setVariables;
        vm.removeVariables = removeVariables;
        vm.kmToMileData = kmToMileData; 
        vm.lastMileageDisplay = false;
        vm.hoverSearchIndex = null;
        vm.hoverYearIndex = null;
        vm.showNoDataFound = false;
        vm.yearColumn =[];
        vm.goToCatalogPLate = goToCatalogPLate;
        vm.newUiEnable = configConstantes.newHeaderMenu;
        for (var i = 1; i <= 12; i++) {
            vm.yearColumn.push(i + "\n" + $translate.instant("ACTIS_VEHICLE_YEAR")); 
          }
        var pictoImage = {
            "RENAULT": { src: convertImgToBase64("/assets/images/renaultgroup.png", "RENAULT") },
            "TRIMAN": { src: convertImgToBase64("/assets/images/triman.png", "TRIMAN") }
        }
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {

            vm.user = CacheService.getObject(CacheConstants.profil);
            var isShowPlannedAssistance = UtilsMetierService.isPlannedAssistance();
            if (isShowPlannedAssistance) {
                vm.isPlannedAssistance = true;
            }
            vm.isVisibleResetTechnicalCriteria = CacheService.getObject(CarTechnicalFeaturesConstants.isContextCarChanged);
            CacheService.setObject(CacheConstants.mileage, null)
            //get the current language
            var currentLanguage = $translate.use();
            //update cureent language
            $translate.use(getCarMaintenanceDocumentationLanguage())
                .then(function (languageId) {
                    //translate variables for the detect language
                    vm.CAR_OTS_TYPE = $translate.instant('CAR_OTS_TYPE');
                    vm.VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM_ABSENT = $translate.instant('VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM_ABSENT');
                    vm.CAR_FEATURE_AVERAGE_CAPACITY = $translate.instant('CAR_FEATURE_AVERAGE_CAPACITY');
                    vm.ALERTS_LEVEL_ALERTS_STANDARD = $translate.instant('ALERTS_LEVEL_ALERTS_STANDARD');

                    //reset the translate language by the default language
                    $translate.use(currentLanguage);
                });

            var deregisterListener = $scope.$on('phx-opentabmaintenanceProgramTab', function () {
                getMaintenanceProgram();
            });
            
            if ($state.params && $state.params.tabName === 'maintenanceProgramTab') {
                $timeout(function() {
                    getMaintenanceProgram();
                }, 100);
            }
            
            $scope.$on('$destroy', function() {
                if (deregisterListener) {
                    deregisterListener();
                }
            });

        }
        // filtering header
        function filterHeader(headerArr, numLib) {
            var headerObject;
            if (headerArr) {
                headerObject = _.find(headerArr.PgmEntLibFix, function (o) { return o.numLib === numLib; }).libelleFix;
            }
            return headerObject;

        }

        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }

        function showTiresInfo(tires) {
            vm.tiresInfo = tires;
            if (!_.isEmpty(vm.tiresInfo)) {
                vm.isTyre = true;
                $mdDialog.show({
                    templateUrl: 'app/components/products/documents/tiresInformation/tiresInformationPopup.template.html',
                    controller: 'TiresInformationController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    size: 'lg',
                    skipHide: true,
                    multiple: true,
                    windowClass: 'tiresInformation',
                    locals: {
                        isTyre: vm.isTyre,
                        tiresInfo: vm.tiresInfo
                    }
                })
            }
        }

        function declareToRenault() {
            vm.maintenanceProgramTab = true;

            var body = angular.element(document.body);
            $mdDialog.show({
                parent: body,
                templateUrl: 'app/components/basket/declareToRenault.html',
                controller: 'panierCtrl',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    maintenanceProgram: vm.maintenanceProgramTab
                },

            }).then(function (confirm) {
                blockUI.start();
                ShoppingCartService.sendOperationDetails(confirm).then(function (response) {
                    if (response) {
                        toastr.success($translate.instant('OPERATION_RECORDED_SUCCESSFULLY'));
                    }
                }).catch(function (err) {
                    toastr.error(err);
                }).finally(function () {
                    blockUI.stop();
                })
            })
        }
        // checking the revisions avaiable for removing the check mark Divs if empty
        function CheckRevisionsAvaiable(response) {
            vm.checkRevisions = false;
            vm.checkFirstRevision = false;
            vm.checkSecondRevision = false;

            var firstTypeComboM = getTypeComboMotherData(0);
            var secondTypeComboM = getTypeComboMotherData(1);

            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.revisions) {
                vm.checkRevisions = true;
                vm.checkFirstRevision = true;
                vm.checkSecondRevision = true;
                var codeRevision = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.revisions.PgmEntRev;
                var firstTypeComboArr = [];
                var secondTypeComboArr = [];
                var uniqueCodeRevisions = [];
                //mapping the first codeRevison and second codeRevison to check Mark for Secondary Table

                // since the object returned can be a single object and not an array of objects, we make sure that we have an array of object to be iterated on
                if (!Array.isArray(codeRevision)) {
                    var tempCodeRevision = codeRevision;
                    codeRevision = [];
                    codeRevision.push(tempCodeRevision);
                }

                codeRevision.forEach(function (key) {
                    uniqueCodeRevisions.push(key.codeRevision)
                    if (key.codeRevision == firstTypeComboM) {
                        firstTypeComboArr.push(key.codeComposantSec)
                    }
                    if (key.codeRevision == secondTypeComboM) {
                        secondTypeComboArr.push(key.codeComposantSec)
                    }
                }
                );
                if (!firstTypeComboM) {
                    vm.checkFirstRevision = false

                }
                if (!secondTypeComboM) {
                    vm.checkSecondRevision = false

                }

                uniqueCodeRevisions = _.uniq(uniqueCodeRevisions);
                if ((_.indexOf(uniqueCodeRevisions, firstTypeComboM) == -1) && (_.indexOf(uniqueCodeRevisions, secondTypeComboM) == -1)) {
                    vm.checkRevisions = false

                }
                vm.firstTypeComboArr = firstTypeComboArr;
                vm.secondTypeComboArr = secondTypeComboArr;




            }

        }

        function removeVariables(){
            vm.hoverSearchIndex = null;
            vm.hoverYearIndex = null
        }

        function setVariables(index, year){
            vm.hoverSearchIndex = index
            vm.hoverYearIndex = year
        }

        // getting primarytab array
        function getPrimaryOperations(response) {
            var pgmEntMereAndPrimary;
            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.merePrimary) {
                vm.showContent = true;

                pgmEntMereAndPrimary = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.merePrimary.PgmEntMereAndPrimary;
                var isKmPresent = _.filter(pgmEntMereAndPrimary, function (o) { 
                    if(o.km_Apartir){
                    return (JSON.stringify(o.km_Apartir) !== '0' && o.km_Apartir !== null) ; 
                    }
                });
                if(!_.isEmpty(isKmPresent)){
                    vm.oldMaintenanceTab = true;
                }
                //first two revisions filtered with sorting
                var revisionArr = _.filter(pgmEntMereAndPrimary, function (o) { return o.typeCompo == 'M'; });
                revisionArr = _.orderBy(revisionArr, ['libLibelle'], ['asc']);
                var typeComboP = _.filter(pgmEntMereAndPrimary, function (o) { return o.typeCompo == 'P'; });
                //filtered typecompo P and sorted the collection
                var pgmEntMereAndPrimaryResult = _.sortBy(typeComboP, ['km_Apartir', 'distan_Apartir', 'period_Km_Toutes', 'period_Distan_Toutes']);

            }
            else{
                vm.showNoDataFound = true;
            }
            var primaryOperations = {
                header1: {
                    title: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 27),
                    from: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 50),
                    then: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 51),
                    all: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 40)

                },
                header2: {
                    title: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 26),
                    km1: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, vm.isMilesDisplay ? 18 : 16),
                    year1: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 52),
                    km2Display: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, vm.isMilesDisplay ? 18 : 16),
                    km2: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 16),
                    miles2: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 18),
                    year2: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 52)
                },
                primaryFooter: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 49),
                primaries: pgmEntMereAndPrimaryResult,
                revisions: revisionArr

            };
            return primaryOperations;

        }


        //getMotherdata from primaries
        function getTypeComboMotherData(index) {
            //filter first two codeCompo which having typeCompo ===M
            var codeCompo;  //filter first two codeCompo which having typeCompo ===M
            if (vm.primaryOperations.revisions) {
                var typeComboM = vm.primaryOperations.revisions;
                if (typeComboM[index]) {
                    codeCompo = typeComboM[index].codeCompo;
                }
            }
            return codeCompo;
        }

        //check Motherdata  coderevision  in primaries for SecondaryTab
        function CheckCoderevision(typeCOmbo, index) {

            if (vm.checkRevisions) {



                if (index === 0) {
                    return _.indexOf(vm.firstTypeComboArr, typeCOmbo) != -1;
                }
                else {
                    return _.indexOf(vm.secondTypeComboArr, typeCOmbo) != -1;

                }


            }
            else {
                return false;
            }



        }

        //getting Third ,fourth,fifth tab operations
        function getThirdTabOperations(response) {
            var frein = null;
            var refroidissement = null;
            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.frein) {
                vm.showContent = true;
                frein = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.frein.PgmEntFrein;
            }
            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.refro) {
                vm.showContent = true;
                refroidissement = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.refro.PgmEntRefro;
            }
            var standardData = getStandardData(response);

            var thirdTabOperations = {
                //getting standarData with grades and temprature mapping
                standardData: standardData,
                headers:
                {    //getting HUILE MOTEUR header for third tab
                    huileMoteurHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 30),
                    //getting fulides title for third tab
                    fluidesHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 29),
                    //getting header  for  preconise title for third  table
                    preconiseHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 33),
                    //getting header  for grades and temprature table
                    gradesHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 36),
                    //getting header  for freinHeader for fourth table
                    freinHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 31),
                    //getting header  for refroidissementHeader for fifth table
                    refroidissementHeader: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 37)

                },
                //getting footer  for   third table
                footer: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 39),
                //getting cotent  for fourth table
                freins: frein,
                //getting cotent  for fifth table
                refroidissement: refroidissement
            }
            return thirdTabOperations;
        }

        //getting secondary tab data
        function getSecondaryOperations(response) {
            var secondaryTabData;

            var infoSpecial = [];
            var infoSpecialObj;

            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.infoSpecial) {
                infoSpecialObj = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.infoSpecial.PgmEntInfoSpecial

                if (!Array.isArray(infoSpecialObj)) {
                    infoSpecial.push(infoSpecialObj);
                }
                else {
                    infoSpecial = infoSpecialObj;
                }
            }
            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.secondary) {
                vm.showContent = true;

                secondaryTabData = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.secondary.PgmEntSecondary;

                var i;
                //forming collection for checking coderevision for secondary table
                for (i = 0; i < secondaryTabData.length; i++) {
                    if (CheckCoderevision(secondaryTabData[i].codeCompo, 0)) {
                        secondaryTabData[i].FirstIndicator = 1
                    }
                    else {
                        secondaryTabData[i].FirstIndicator = 0;
                    }
                    if (CheckCoderevision(secondaryTabData[i].codeCompo, 1)) {
                        secondaryTabData[i].SecondIndicator = 1;
                    }
                    else {
                        secondaryTabData[i].SecondIndicator = 0;
                    }

                }
            }

            var seCondaryOperations = {
                header: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 28),


                footer: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 43),

                infospecial: infoSpecial,
                secondaries: secondaryTabData
            }
            return seCondaryOperations;

        }

        //mapping normes and grades to temparature

        function getUniquegrade(key) {

            return Object.keys(key).join(" ");

        }

        function shouldShowCatalogIcon(temperature, gradeObj) {
            
            const tempMap = vm.thirdTabOperations && vm.thirdTabOperations.standardData && 
                         vm.thirdTabOperations.standardData.temparatureMap;
            
            if (!tempMap) {
                return false;
            }
            const tempStr = String(temperature).trim();
            const isMinus15 = (tempStr === '-15');
            const gradesAt15 = tempMap[' -15'];
            if (gradesAt15) {
        
                if (isMinus15) {
                    return true;
                }
               
                let gradesAt15List = [];
                Object.keys(gradesAt15).forEach(function(normKey) {
                    const gradeKeys = Object.keys(gradesAt15[normKey]);
                    gradesAt15List = gradesAt15List.concat(gradeKeys);
                });
                
                const currentGradeKeysAt15 = Object.keys(gradeObj);
                let allExistIn15 = true;
                currentGradeKeysAt15.forEach(function(gradeKey) {
                    if (gradesAt15List.indexOf(gradeKey) === -1) {
                        allExistIn15 = false;
                    }
                });
                
                return !allExistIn15;
            }
            

            let allOtherGrades = [];
            Object.keys(tempMap).forEach(function(tempKey) {
                if (tempKey !== temperature) {
                    const tempData = tempMap[tempKey];
                    Object.keys(tempData).forEach(function(normKey) {
                        const gradeKeys = Object.keys(tempData[normKey]);
                        allOtherGrades = allOtherGrades.concat(gradeKeys);
                    });
                }
            });
            
        
            const currentGradeKeys = Object.keys(gradeObj);
            let hasUniqueGrade = false;
            currentGradeKeys.forEach(function(gradeKey) {
                if (allOtherGrades.indexOf(gradeKey) === -1) {
                    hasUniqueGrade = true;
                }
            });
            
            return hasUniqueGrade;
        }

        function goToCatalogPLate(node3){
        var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
        if(contextCarSearch && contextCarSearch.treeNodes){
                var dataArboLevelOne = angular.copy(contextCarSearch.treeNodes.levelOne);
                var level2 = angular.copy(contextCarSearch.treeNodes.otherLevel);
                dataArboLevelOne.nodes.forEach(function(node1){
                    if(node1.nodeId == "N-33909"){
                         vm.node1 = node1.nodeId;
                    }
                })
                level2.nodes.forEach(function(node2){
                    if(node2.nodeId == "N-33926"){
                         vm.node2 = node2.nodeId;
                    }
                    node2.childNodes.forEach(function(node3Value){
                        if(node3Value.label == node3){
                             vm.node3 = node3Value.nodeId;
                        }
                    })
                })
         $state.go(RoutesConstants.carSearchResult, {
            tab: CarSearchResultConstants.searchTypes.searchByArbo,
            isUserComingFromMD: false,
            node1: vm.node1 ? vm.node1 : "",
            node2: vm.node2 ? vm.node2 : "",
            node3: vm.node3 ? vm.node3 : "",
            isnodeLinkNavigation: false,
            maintenanceProgLinkNavigate: true

        })
    }
     } 

        //gettingStandard and temparaturemap for thirdtab content
        function getStandardData(response) {
            var huile;
            var standardData;
            var standardValue;
            var temparatureMap = [];

            var capMoy;
            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.huile) {
                vm.showContent = true;
                vm.showHuileContent = true;


                huile = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.huile.PgmEntHuile;
            }

            if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.capMoy) {

                if (response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.capMoy.PgmEntCapMoy) {
                    capMoy = response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.capMoy.PgmEntCapMoy.capMoy;
                }
            }
            if (huile) {

                // for getting unique norm and map unique grades with  outside temperatures to display in the the third Table
                //for the header Grades � utiliser selon la temp�rature ext�rieure :

                var temparatureMap = _(huile)
                    .groupBy('temper')
                    .mapValues(function (groupedByTemper) {
                        return _(groupedByTemper)
                            .groupBy('norme')
                            .mapValues(function (groupedByNormeAndgrade) {
                                return _.groupBy(groupedByNormeAndgrade, 'grade');
                            })
                            .value();
                    })
                    .value();
                //sorted map based on the temparature
                var ordered = {};
                _(temparatureMap).keys().sort().each(function (key) {
                    ordered[key] = temparatureMap[key];
                });

                var groups = Object.keys(ordered);

                temparatureMap = ordered;
                //for displaying headers(standards) in the grades table
                vm.headCells = _.keys(_.groupBy(huile, function (item) { return item.norme }));

                // PDF - Temp Grade data
                var tempGrade = [];
                Object.keys(ordered).forEach(function (key) {
                    var grade = []
                    Object.keys(ordered[key]).forEach(function (key1) {
                        grade.push(getUniquegrade(ordered[key][key1]));
                    }
                    );
                    var tempGradeData =
                    {
                        temp: key,
                        grade: grade
                    }
                    tempGrade.push(tempGradeData);
                });

                vm.groups = tempGrade;

                //for maintaining rowspan
                vm.temparatureMapLength = Object.keys(temparatureMap).length;

                standardValue = vm.headCells.join(',');

            }
            standardData =
            {
                value: standardValue,
                averageCapacity: capMoy,
                temparatureMap: temparatureMap,
                unit: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 21),
                label: filterHeader(response.getApvGetDonPgmEntVinFullV2Response.getApvGetDonPgmEntVinFullV2Return.pgmEnt.libFix, 38)
            }
            return standardData;

        }

        function checkFieldsOfTires(tyresInfo) {
            return (tyresInfo && !_.isEmpty(tyresInfo) && (_.has(tyresInfo[0], 'axleInfo') && !_.isEmpty(tyresInfo[0].axleInfo)
                || _.has(tyresInfo[0], 'tyres') && !_.isEmpty(tyresInfo[0].tyres)));
        }

        function tiresData() {
            var isDmsConnected = DealerManagerSystemeService.getHookResult();
            $q.all([
                CarTechnicalCriteriaMetierService.getTechnical(isDmsConnected)
            ]).then(function (response) {
                var tyresData = response[0];
                CarSearchMetierService.setLocalizedData(true, tyresData);
                var tyresInfo = tyresData && tyresData.tyresInfo ? tyresData.tyresInfo : null;
                vm.tiresInfo = tyresData.tyresInfo[0];
                vm.checkTiresData = checkFieldsOfTires(tyresInfo);
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
        }

        /**
         * @name getMaintenanceProgram
         * @desc get car technical criteria's vin
         */
        function getMaintenanceProgram() {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var vin = contextCarSearch.vehicle.vin;
            var contextCar = CacheService.getCarContext();
            vm.brandComputed = contextCar.brandComputed;
            if (vm.countryCode == 'ro' && (vm.brandComputed == 'APL05' || vm.brandComputed == 'BRA05')) {
                vm.brand = true;
            }
            else {
                vm.brand = false;
            }
            //var registrationNumber = contextCarSearch.vehicle.registrationNumber;
            if (vin) {
                blockUI.start();
                tiresData();
                carMaintenanceProgramMetierService.getVinRep().then(function (response) {
                    vm.getVinResponse = response && response[0] ? response[0] : null;
                    vm.mileageData = response && response[2] ? response[2].mileage : null;
                    vm.vinOperationData = (response && response[1] && response[1]._embedded && response[1]._embedded.operations) ?  response[1]._embedded.operations : null;
                    CacheService.setObject(CacheConstants.mileage, vm.mileageData)
                    if (vm.getVinResponse) {
                        vm.isMilesDisplay = checkMilesOrKm();
                        if (vm.mileageData && vm.isMilesDisplay) {
                            vm.mileageData = Math.floor(vm.mileageData * FeaturesConstants.milesConstant);
                        }
                        vm.primaryOperations = getPrimaryOperations(vm.getVinResponse);
                        if(!vm.primaryOperations.primaries && !vm.primaryOperations.revisions){
                            vm.showNoDataFound = true;
                        }
                        CheckRevisionsAvaiable(vm.getVinResponse);
                        if (vm.primaryOperations && vm.vinOperationData) {
                            vm.vinOperationData.forEach(function (operationKey) {
                                if (vm.primaryOperations.primaries) {
                                    vm.primaryOperations.primaries.forEach(function (key) {
                                        var code = key.codeAction + key.codeLibelle
                                        if (operationKey.name == key.libelle || parseInt(operationKey.code, 10) == code) {
                                            _.assign(key, { 
                                                isOpen: JSON.stringify(operationKey.isOpen) ? JSON.stringify(operationKey.isOpen) : null , 
                                                nextMileage: operationKey.nextMileage ? operationKey.nextMileage : null,
                                                nextDate: operationKey.nextDate ? operationKey.nextDate : null
                                            });    
                                            
                                        }

                                    });
                                }
                                if (vm.primaryOperations.revisions) {
                                    vm.primaryOperations.revisions.forEach(function (revisionskey) {
                                        var code = revisionskey.codeAction + revisionskey.codeLibelle
                                        if (operationKey.name == revisionskey.libelle || parseInt(operationKey.code, 10) == code) {
                                            _.assign(revisionskey, { 
                                                isOpen: JSON.stringify(operationKey.isOpen) ? JSON.stringify(operationKey.isOpen) : null ,
                                                nextMileage: operationKey.nextMileage ? operationKey.nextMileage : null,
                                                nextDate: operationKey.nextDate ? operationKey.nextDate : null
                                            });   
                                        }
                                    });
                                }
                            });
                        }
                        var isOpenTotalData = [];
                        isOpenTotalData = vm.primaryOperations && vm.primaryOperations.primaries ? _.concat(isOpenTotalData, vm.primaryOperations.primaries) : [];
                        isOpenTotalData = vm.primaryOperations && vm.primaryOperations.revisions ? _.concat(isOpenTotalData, vm.primaryOperations.revisions) : [];
                        vm.OperationTobeCarried = _.filter(isOpenTotalData, function (o) { return o.isOpen == '1'; });
                        vm.upcomingOperation = _.filter(isOpenTotalData, function (o) { return o.isOpen == '0'; });
                        vm.operationDelayed = _.filter(isOpenTotalData, function (o) { return o.isOpen == '2'; });
                        vm.upcomingOperation = _.orderBy(vm.upcomingOperation, [
                            function (op) {                              
                                return (op.nextDate) || new Date(8640000000000000);                               
                            }, function (op) {
                                return (op.nextMileage )|| Infinity;
                            }], ['asc', 'asc']);
                        vm.OperationTobeCarried = _.orderBy(vm.OperationTobeCarried, [
                            function (op) {
                                return (op.nextDate ) || new Date(8640000000000000);
                            }, function (op) {
                                return (op.nextMileage ) || Infinity;
                            }], ['asc', 'asc']);
                        vm.secondaryOperations = getSecondaryOperations(vm.getVinResponse);
                        vm.thirdTabOperations = getThirdTabOperations(vm.getVinResponse);
                        hoverCheck(vm.primaryOperations.primaries, vm.primaryOperations.revisions );
                        var maintenanceProgram = {
                            primaryOperations: vm.primaryOperations,
                            secondaryOperations: vm.secondaryOperations,
                            thirdTabOperations: vm.thirdTabOperations
                        };

                        maintenanceProgram.showContent = vm.showContent;
                        broadcastMileageEvent(vm.mileageData, vm.isMilesDisplay);
                        CacheService.setObject(CacheConstants.maintenanceProgram, maintenanceProgram);
                    }
                    CacheService.setObject(CacheConstants.contextCarRequest, contextCar);
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                }).finally(function () {
                    vm.loading = false;
                    blockUI.stop();
                })
            }

        }

        function hoverCheck() {
            for (var data in vm.primaryOperations) {
                if (vm.primaryOperations.hasOwnProperty(data)) {
                    if (Array.isArray(vm.primaryOperations[data])) {
                        vm.primaryOperations[data].forEach(function (item) {
                            var tempArr = [];
                            vm.yearColumn.forEach(function (yrItem, index) {
                                if (!_.isEmpty(item)) {
                                    var clearDistanString = item.distan_Apartir ? item.distan_Apartir.replace(/\s/g, "") : null;
                                    var clearPeriodString = item.period_Distan_Toutes ? item.period_Distan_Toutes.replace(/\s/g, "") : null;
                                    if ((JSON.stringify(item.km_Apartir) === '0' || item.km_Apartir === null) && (clearDistanString === '0.0' || clearDistanString === null)) {
                                        if (clearPeriodString === "1.0") {
                                            tempArr.push(index)
                                            return true;
                                        } else {
                                            if ((index + 1) % clearPeriodString === 0) {
                                                tempArr.push(index)
                                                return true;
                                            }
                                        }
                                    }
                                    else {
                                        if (((index + 1) - clearDistanString) % clearPeriodString === 0 && (index + 1) >= clearDistanString) {
                                            tempArr.push(index)
                                            return true;
                                        }
                                    }
                                }
                            })
                            _.extend(item, { tempArr: tempArr })

                        })
                    }
                }
            }
        }

        function checkMilesOrKm() {

            if (vm.user && vm.user.country && CarTechnicalFeaturesConstants.milesDisplayCountries.includes(vm.user.country)) {
                return true;
            }

            return false;
        }

        function milesKmDisplayUpdate() {
            vm.primaryOperations.header2.km2Display = vm.isMilesDisplay ? vm.primaryOperations.header2.miles2 : vm.primaryOperations.header2.km2;
            vm.primaryOperations.header2.km1 = vm.isMilesDisplay ? vm.primaryOperations.header2.miles2 : vm.primaryOperations.header2.km2;
            vm.mileageData = getConvertedMileage();
            var maintenanceProgram = CacheService.getObject(CacheConstants.maintenanceProgram);
            maintenanceProgram.primaryOperations = vm.primaryOperations;
            broadcastMileageEvent(vm.mileageData, vm.isMilesDisplay);
            CacheService.setObject(CacheConstants.maintenanceProgram, maintenanceProgram);
        }

        function getCarMaintenanceDocumentationLanguage() {
            // list of languages available in REP Web Service
            var countriesCode = ['cs', 'de', 'da', 'es', 'fi', 'en', 'el', 'hr', 'hu', 'it', 'nl', 'no', 'pl', 'pt',
                'ro', 'ru', 'sv', 'sl', 'sk', 'tr', 'fr', 'et', 'lt', 'lv', 'bg', 'uk', 'br'];

            var user = CacheService.getObject(CacheConstants.profil);
            // the default english is English
            var countryCode = 'en';
            // select language
            if (user.documentationFirstLanguage) {
                countryCode = user.documentationFirstLanguage.code.includes("-") && (countriesCode.indexOf(user.documentationFirstLanguage.code.substr(3, 2).toLowerCase()) != -1) ? user.documentationFirstLanguage.code : ((countriesCode.indexOf(user.documentationFirstLanguage.code != -1) ? user.documentationFirstLanguage.code : 'en'));
            }
            else if (user.documentationSecondLanguage) {
                countryCode = user.documentationSecondLanguage.code.includes("-") && (countriesCode.indexOf(user.documentationSecondLanguage.code.substr(3, 2).toLowerCase()) != -1) ? user.documentationSecondLanguage.code : ((countriesCode.indexOf(user.documentationSecondLanguage.code != -1) ? user.documentationSecondLanguage.code : 'en'));
            }
            vm.countryCode = countryCode;
            return countryCode;
        }

        function printMaintenanceProgram() {
            blockUI.start();

            try {
                printPdf();
            }
            catch (error) {
                console.log("PDF Error : " + error);
                toastr.error($translate.instant('ERROR'));
            }
            blockUI.stop();
        }

        function toMultiLines(text, n) {
            text = text.replace(/\t/gi, ' ');
            text = text.replace(/\n/gi, '<p>');
            var lines = [];
            var newText = formatText(text, n);
            if (newText.indexOf('<p>') != -1) {
                lines = newText.split('<p>');
            }
            return lines;
        }

        function formatText(text, n) {
            var length = text.length;
            var lines = [];
            var newText = "";
            var index = 0;
            var endOfLine = n;
            if (length > n) {
                while (length > n) {
                    if ((text.substring(index, index + n).lastIndexOf('<p>') == -1) && (text[endOfLine] === ' ') || (text[endOfLine] === '.') || (text[endOfLine] === ',')) {
                        newText = newText + text.substring(index, index + endOfLine) + '<p>';
                        length = length - endOfLine;
                        index = index + endOfLine;
                        endOfLine = index;
                    } else {
                        var lastIndex = text.substring(index, index + n).lastIndexOf(' ');
                        newText = newText + text.substring(index, index + lastIndex) + '<p>';
                        length = length - lastIndex;
                        index = index + lastIndex;
                        endOfLine = index + lastIndex;
                    }
                }
                if (length > 0) {
                    newText = newText + text.substring(index, text.length);
                }
            } else {
                newText = newText + text + '<p>';
            }
            return newText;
        }

        function printPdf() {
            vm.maintenanceProgram = CacheService.getObject(CacheConstants.maintenanceProgram);

            vm.maintenanceProgram.language = vm.user.portal.label;
            vm.maintenanceProgram.isDaciaOil = false;
            var contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);

            var translatedLabels = {
                type: $translate.instant('CAR_OTS_TYPE'),
                averageCapacity: $translate.instant("CAR_FEATURE_AVERAGE_CAPACITY"),
                norme: $translate.instant("NORME"),
                maintenanceProgram: $translate.instant("VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM")
            };

            var profile = CacheService.getObject(CacheConstants.profil);

            var primaryOperations = [];
            var primaryOperations1 = [];
            var primaryOperationsPrimaries = [];

            var secondaryOperationsSecondariesC1 = [];
            var secondaryOperationsSecondariesC2 = [];
            var secondaryOpertationsFooter = [];
            var infospecial = [];

            var secondaryOperationsH1 = [];
            var secondaryOperationsH2 = [];
            var secondaryOperationsWidth = ['*'];

            var std = [];
            var oilImage = [];
            var temp = [];
            var operationDelayedHeader =[];
            var operationDelayedContent =[];           
            var currentOperationHeader =[];
            var currentOperationContent =[];
            var upcomingOperationHeader =[];
            var upcomingOperationContent =[];
            var plannedAssitBox =[];
            var newMaintenancePdf1 =[]
            var newMaintenancePdf2 =[]
            var newMaintenancePdfLast =[]

            var friens = [];
            var friensValue;
            var refroidissement = [];

            var tempWidth;
            if(vm.oldMaintenanceTab){

            primaryOperations.push(
                { text: vm.maintenanceProgram.primaryOperations.header2.title, border: [true, true, true, false] },
                { text: vm.maintenanceProgram.primaryOperations.header2.km1.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false] },
                { text: vm.maintenanceProgram.primaryOperations.header2.year1.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false] },
                { text: vm.maintenanceProgram.primaryOperations.header2.km2Display.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false] },
                { text: vm.maintenanceProgram.primaryOperations.header2.year2.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false] }
            );
        }else{
                newMaintenancePdf1.push(
                    { text: vm.maintenanceProgram.primaryOperations.header2.title, border: [true, true, true, false] },
                    { text: vm.maintenanceProgram.primaryOperations.header2.km1.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false] },
                    {
                        text: "", border: [true, true, true, false],
                        table: {
                            widths: Array(12).fill(10),
                            body: [
                                [
                                    { text: $translate.instant("ACTIS_VEHICLE_YEAR"), colSpan: 12, alignment: 'center', border: [false, false, false, true], margin: [0, 0, 0, 0] },
                                    ...Array(11).fill({})
                                ],
                            ]
                        }
                        , layout: {
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                            }
                        },
                    }
                );
                var yearData = [];
                vm.yearColumn.forEach(function (id) {
                    yearData.push({ text: id.split("\n")[0], alignment: 'center', border: [true, false, true, true], margin: [0, 0, 0, 0] })
                })
                newMaintenancePdf1[2].table.body.push(yearData)
            }

            if (vm.maintenanceProgram.primaryOperations.revisions && vm.maintenanceProgram.primaryOperations.revisions.length > 0) {
                for (var i = 0; i < vm.maintenanceProgram.primaryOperations.revisions.length; i++) {
                    var index = i + 1;
                    var col = [];
                    if(vm.oldMaintenanceTab) {

                    if (vm.isMilesDisplay) {
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.revisions[i].libelle, border: [true, true, true, false] },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].periodMlApatir != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].periodMlApatir : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].distan_Apartir != 0.0 ? vm.maintenanceProgram.primaryOperations.revisions[i].distan_Apartir : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].periodMlToutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].periodMlToutes : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].period_Distan_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].period_Distan_Toutes : ''), border: [true, true, true, false], alignment: 'center' },
                        ]
                    } else {
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.revisions[i].libelle, border: [true, true, true, false] },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].km_Apartir != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].km_Apartir : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].distan_Apartir != 0.0 ? vm.maintenanceProgram.primaryOperations.revisions[i].distan_Apartir : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].period_Km_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].period_Km_Toutes : ''), border: [true, true, true, false], alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.revisions[i].period_Distan_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].period_Distan_Toutes : ''), border: [true, true, true, false], alignment: 'center' },
                        ]
                    }
                    primaryOperations1.push(col);
                }else{
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.revisions[i].libelle, border: [true, true, true, false] },
                            { text: (vm.isMilesDisplay ? (vm.maintenanceProgram.primaryOperations.revisions[i].periodMlToutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].periodMlToutes : '') : (vm.maintenanceProgram.primaryOperations.revisions[i].period_Km_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.revisions[i].period_Km_Toutes : '')), alignment: 'center', border: [true, true, true, false] },
                            {
                                text: "", border: [false, true, true, false],
                                table: {
                                    widths: Array(12).fill(10),
                                    body: []
                                },
                                layout: {
                                    vLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                                    },
                                },
                            }
                        ]
                        var yearData = [];
                        vm.yearColumn.forEach(function (id, index) {
                            yearData.push({
                                image: vm.maintenanceProgram.primaryOperations.revisions[i].tempArr.includes(index) ? 'Active' : 'Inactive', width: 7, alignment: 'center', border: [true, false, true, false],margin: [0, 2, 0, 2],
                            })
                        })
                        col[2].table.body.push(yearData)
                        newMaintenancePdf2.push(col);
                    }
                    
                    var col2 = []
                    // Index explanations removed as per F01_US76_RG03
                    secondaryOpertationsFooter.push(col2);
                }


            }
            else {
                if(vm.oldMaintenanceTab){
                var col = [
                    { text: '', border: [false, true, false, false] },
                    { text: '', border: [false, true, false, false] },
                    { text: '', border: [false, true, false, false] },
                    { text: '', border: [false, true, false, false] },
                    { text: '', border: [false, true, false, false] }
                ]
            }
                primaryOperations1.push(col);

                var col2 = [
                    { text: '' }
                ]
                secondaryOpertationsFooter.push(col2);

            }

            if (vm.maintenanceProgram.primaryOperations.primaries && vm.maintenanceProgram.primaryOperations.primaries.length > 0) {
                for (var i = 0; i < vm.maintenanceProgram.primaryOperations.primaries.length; i++) {
                    var col = [];
                    if(vm.oldMaintenanceTab){
                    if (vm.isMilesDisplay) { 
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.primaries[i].libelle },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].periodMlApatir != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].periodMlApatir : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].distan_Apartir != 0.0 ? vm.maintenanceProgram.primaryOperations.primaries[i].distan_Apartir : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].periodMlToutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].periodMlToutes : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].period_Distan_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].period_Distan_Toutes : ''), alignment: 'center' },

                        ]
                    } else {
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.primaries[i].libelle },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].km_Apartir != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].km_Apartir : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].distan_Apartir != 0.0 ? vm.maintenanceProgram.primaryOperations.primaries[i].distan_Apartir : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].period_Km_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].period_Km_Toutes : ''), alignment: 'center' },
                            { text: (vm.maintenanceProgram.primaryOperations.primaries[i].period_Distan_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].period_Distan_Toutes : ''), alignment: 'center' },

                        ]
                    }
                    primaryOperationsPrimaries.push(col);
                }
                    else {
                        col = [
                            { text: vm.maintenanceProgram.primaryOperations.primaries[i].libelle, border: [true, true, true, true] },
                            { text: (vm.isMilesDisplay ? (vm.maintenanceProgram.primaryOperations.primaries[i].periodMlToutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].periodMlToutes : '') : (vm.maintenanceProgram.primaryOperations.primaries[i].period_Km_Toutes != 0 ? vm.maintenanceProgram.primaryOperations.primaries[i].period_Km_Toutes : '')), alignment: 'center', border: [true, true, true, true] },
                            {
                                table: {
                                    widths: Array(12).fill(10),
                                    body: []
                                }, layout: {
                                    vLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                                    }
                                }
                            }
                        ]
                        var yearData = [];
                        vm.yearColumn.forEach(function (id, index) {
                            yearData.push({
                                image: vm.maintenanceProgram.primaryOperations.primaries[i].tempArr.includes(index) ? 'Active' : 'Inactive', width: 7, alignment: 'center', border: [true, false, true, false],margin: [0, 2, 0, 2]
                            })
                        })
                        col[2].table.body.push(yearData)
                        newMaintenancePdfLast.push(col);
                    }

                }
            }
            else {
                var col = [
                    { text: '', border: [false, false, false, false] },
                ]
                primaryOperationsPrimaries.push(col);

            }
            if(vm.isPlannedAssistance){
                var printMileage = (!vm.isMilesDisplay ? vm.oldMileageValue : kmToMileData(vm.oldMileageValue));
            plannedAssitBox.push(
                { text:  $translate.instant("PLANNED_ASSIT_MILEAGE") + (vm.mileageData ? vm.mileageData : "") + '\n\n' + (vm.lastMileageDisplay ? ($translate.instant("LATEST_MILEAGE") + (printMileage ? (printMileage + vm.maintenanceProgram.primaryOperations.header2.km1.toLocaleUpperCase()) : "") + '\n\n') : "") + $translate.instant("PLANNED_ASSIT_MSG"), alignment: 'center', border: [true, true, true, true]}
            );
        }


            if(vm.isPlannedAssistance) {
            operationDelayedHeader.push(
                { text:  $translate.instant("OPERATIONS_DELAYED"), alignment: 'center', border: [true, true, true, false]}
            );
            if (vm.operationDelayed && vm.operationDelayed.length > 0) {
                for (var i = 0; i < vm.operationDelayed.length; i++) {
                    var index = i + 1;
                    var col = [];

                    
                        col = [
                            { text: vm.operationDelayed[i].libelle},
                        ]
                        operationDelayedContent.push(col);           
                }
            }
            else {
                var col = [
                    { text: '-', alignment: 'center'},
                ]
                operationDelayedContent.push(col);
            }
        }

        if(vm.isPlannedAssistance) {
            currentOperationHeader.push(
                { text:  $translate.instant("CURRENT_OPERATIONS"), alignment: 'center', border: [true, true, true, false]},
                { text:  $translate.instant("MAINTENANCE_DUE_DATE"), alignment: 'center', border: [true, true, true, false]},
                { text:  vm.maintenanceProgram.primaryOperations.header2.km1.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false]}
            );

            if (vm.OperationTobeCarried && vm.OperationTobeCarried.length > 0) {
                for (var i = 0; i < vm.OperationTobeCarried.length; i++) {
                    var index = i + 1;
                    var col = [];

                    
                        col = [
                            { text: vm.OperationTobeCarried[i].libelle},
                            { text: vm.OperationTobeCarried[i].nextDate ? vm.OperationTobeCarried[i].nextDate : "-" },
                            { text: !vm.isMilesDisplay ? (vm.OperationTobeCarried[i].nextMileage ? vm.OperationTobeCarried[i].nextMileage : "-") : kmToMileData(vm.OperationTobeCarried[i].nextMileage) },
                        ]
                        currentOperationContent.push(col);           
                }
            }
            else {
                var col = [
                    { text: '-', alignment: 'center'},
                    { text: '-', alignment: 'center'},
                    { text: '-', alignment: 'center'},
                ]
                currentOperationContent.push(col);
            }
        }

        if(vm.isPlannedAssistance)  {
            upcomingOperationHeader.push(
                { text:  $translate.instant("UPCOMING_OPERATIONS"), alignment: 'center', border: [true, true, true, false]},
                { text:  $translate.instant("MAINTENANCE_DUE_DATE"), alignment: 'center', border: [true, true, true, false]},
                { text:  vm.maintenanceProgram.primaryOperations.header2.km1.toLocaleUpperCase(), alignment: 'center', border: [true, true, true, false]}
            );

            if (vm.upcomingOperation && vm.upcomingOperation.length > 0) {
                for (var i = 0; i < vm.upcomingOperation.length; i++) {
                    var index = i + 1;
                    var col = [];

                    
                        col = [
                            { text: vm.upcomingOperation[i].libelle},
                            { text: vm.upcomingOperation[i].nextDate ? vm.upcomingOperation[i].nextDate : "-" },
                            { text: !vm.isMilesDisplay ? (vm.upcomingOperation[i].nextMileage ? vm.upcomingOperation[i].nextMileage : "-") : kmToMileData(vm.upcomingOperation[i].nextMileage)},
                        ]
                        upcomingOperationContent.push(col);           
                }
            }
            else {
                var col = [
                    { text: '-', alignment: 'center'},
                    { text: '-', alignment: 'center'},
                    { text: '-', alignment: 'center'},
                ]
                upcomingOperationContent.push(col);
            }
        }

            if (!_.isEmpty(vm.maintenanceProgram.secondaryOperations.secondaries)) {
                var t1 = vm.maintenanceProgram.secondaryOperations.secondaries.length % 2 == 0 ? vm.maintenanceProgram.secondaryOperations.secondaries.length / 2 : (Math.round(vm.maintenanceProgram.secondaryOperations.secondaries.length / 2));

                if (vm.checkFirstRevision && vm.checkSecondRevision) {
                    secondaryOperationsH1 = [
                        { text: '', border: [false, false, false, false] },
                        { text: ' A', alignment: 'center', border: [false, false, false, false] },
                        { text: ' B', alignment: 'center', border: [false, false, false, false] }
                    ]
                    secondaryOperationsH2 = angular.copy(secondaryOperationsH1);
                    secondaryOperationsWidth = ['*', 15, 15];
                }
                else if (vm.checkFirstRevision && !vm.checkSecondRevision) {
                    secondaryOperationsH1 = [
                        { text: '', border: [false, false, false, false] },
                        { text: ' A', alignment: 'center', border: [false, false, false, false] }
                    ]

                    secondaryOperationsH2 = angular.copy(secondaryOperationsH1);
                    secondaryOperationsWidth = ['*', 15];
                }
                else if (!vm.checkFirstRevision && vm.checkSecondRevision) {
                    secondaryOperationsH1 = [
                        { text: '', },
                        { text: ' B', alignment: 'center', border: [false, false, false, false] }
                    ]
                    secondaryOperationsH2 = angular.copy(secondaryOperationsH1);
                    secondaryOperationsWidth = ['*', 15];
                }
                else if (!vm.checkFirstRevision && !vm.checkSecondRevision) {
                    secondaryOperationsH1 = [
                        { text: '', border: [false, false, false, false] }
                    ]
                    secondaryOperationsH2 = angular.copy(secondaryOperationsH1);
                    secondaryOperationsWidth = ['*'];
                }

                for (var i = 0; i < t1; i++) {
                    var col = [];

                    if (vm.checkFirstRevision && vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary, },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].FirstIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].SecondIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                        ]

                    }
                    else if (vm.checkFirstRevision && !vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].FirstIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                        ]
                    }
                    else if (!vm.checkFirstRevision && vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].SecondIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                        ]
                    }
                    else if (!vm.checkFirstRevision && !vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary }
                        ]
                    }

                    secondaryOperationsSecondariesC1.push(col);
                }

                for (var i = t1; i < vm.maintenanceProgram.secondaryOperations.secondaries.length; i++) {
                    var col = [];

                    if (vm.checkFirstRevision && vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].FirstIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].SecondIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0],alignment: 'center'},
                        ]
                    }
                    else if (vm.checkFirstRevision && !vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].FirstIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                        ]
                    }
                    else if (!vm.checkFirstRevision && vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary },
                            { image: vm.maintenanceProgram.secondaryOperations.secondaries[i].SecondIndicator == 1 ? 'Active' : 'Inactive', width: 10, margin: [0, 3, 0, 0], alignment: 'center' },
                        ]
                    }
                    else if (!vm.checkFirstRevision && !vm.checkSecondRevision) {
                        col = [
                            { text: vm.maintenanceProgram.secondaryOperations.secondaries[i].labelSecondary }
                        ]
                    }

                    secondaryOperationsSecondariesC2.push(col);
                }

                if (vm.maintenanceProgram.secondaryOperations.secondaries.length % 2 != 0) {
                    var col = [];
                    if (vm.checkRevisions) {
                        if (vm.checkFirstRevision && !vm.checkSecondRevision) {
                            col = [
                                { text: '', colSpan: 2, border: [false, false, false, false] }
                            ]
                        }
                        else if (vm.checkFirstRevision && vm.checkSecondRevision) {
                            col = [
                                { text: '', colSpan: 3, border: [false, false, false, false] }
                            ]
                        }

                    }
                    else {
                        col = [
                            { text: '', border: [false, false, false, false] },
                        ]
                    }

                    secondaryOperationsSecondariesC2.push(col);
                }
            }
            else {
                secondaryOperationsSecondariesC1.push([{ text: '', border: [false, false, false, false] }]);
                secondaryOperationsSecondariesC2.push([{ text: '', border: [false, false, false, false] }]);
            }

            if (vm.maintenanceProgram.secondaryOperations.infospecial && vm.maintenanceProgram.secondaryOperations.infospecial.length > 0) {
                for (var i = 0; i < vm.maintenanceProgram.secondaryOperations.infospecial.length; i++) {
                    var col =
                        { text: vm.maintenanceProgram.secondaryOperations.infospecial[i].libInfoSpe + "\n", border: [false, false, false, false], alignment: 'justify', fontSize: 6 }

                    infospecial.push(col);
                }
            }
            else {
                infospecial.push('')
            }

            if (!_.isEmpty(vm.maintenanceProgram.thirdTabOperations.standardData.temparatureMap)) {
                tempWidth = '*';
                var col = [
                    { text: translatedLabels.norme + " : " + vm.maintenanceProgram.thirdTabOperations.standardData.value },

                    { text: translatedLabels.averageCapacity + "" + vm.maintenanceProgram.thirdTabOperations.standardData.averageCapacity + " " + vm.maintenanceProgram.thirdTabOperations.standardData.unit },

                ];
                std.push(col);

                if (vm.brand) {
                    oilImage =
                        [
                            { text: vm.maintenanceProgram.thirdTabOperations.headers.preconiseHeader, margin: [0, 7, 0, 0] },
                            { image: 'Dacia', width: 100, height: 25 }
                        ]
                }
                else {
                    oilImage =
                        [
                            { text: vm.maintenanceProgram.thirdTabOperations.headers.preconiseHeader, margin: [0, 7, 0, 0] },
                            { image: 'Castrol', width: 100, height: 25 }
                        ]
                }

                var len = vm.groups.length + 1;
                var height = len * 5;
                temp.push([
                    { text: vm.maintenanceProgram.thirdTabOperations.standardData.label, rowSpan: len, alignment: 'center', border: [true, true, true, true], margin: [0, height, 0, 0] },
                    { text: "0 °C", alignment: 'center' }
                ]);

                for (var i = 0; i < vm.headCells.length; i++) {
                    temp[0].push(
                        { text: vm.headCells[i], alignment: 'center' }
                    )

                }

                for (var i = 0; i < vm.groups.length; i++) {
                    temp.push([
                        { text: '', border: [true, true, true, true] },
                        { text: vm.groups[i].temp + " °C", border: [true, true, true, true], alignment: 'center' }
                    ])
                    for (var j = 0; j < vm.headCells.length; j++) {
                        temp[i + 1].push(
                            { text: vm.groups[i].grade[j], border: [true, true, true, true], alignment: 'center' }
                        )
                    }
                }

            }
            else {
                tempWidth = 0;
                std.push('');
                temp.push('');
            }

            if (vm.maintenanceProgram.thirdTabOperations.freins != null) {

                friensValue = Object.keys(vm.maintenanceProgram.thirdTabOperations.freins).map(function (e) {
                    return vm.maintenanceProgram.thirdTabOperations.freins[e]
                });

                if (friensValue.length == 1) {
                    var col = [
                        { text: translatedLabels.type },
                        { text: friensValue[0] }
                    ]
                    friens.push(col);
                }
                else {
                    for (var i = 0; i < friensValue.length; i++) {
                        var col = [
                            { text: translatedLabels.type },
                            { text: friensValue[i].typeLiqFrein }
                        ]
                        friens.push(col);
                    }
                }
            }
            else {
                friens.push([{ text: '\t\t\t\t\t i', preserveLeadingSpaces: true, color: 'white' }]);
            }

            if (vm.maintenanceProgram.thirdTabOperations.refroidissement != null) {
                var col = [
                    { text: translatedLabels.type },
                    { text: vm.maintenanceProgram.thirdTabOperations.refroidissement.typeLiqRefro }
                ]
                refroidissement.push(col);
            }
            else {
                refroidissement.push([{ text: '\t\t\t\t\t i', preserveLeadingSpaces: true, color: 'white' }]);
            }

            var dd = {
                //pageMargins: [30, 30, 30, 30],
                info: {
                    title: translatedLabels.maintenanceProgram,
                }, header: {
                    columns: [
                        {
                            image: pictoImage.RENAULT.value,
                            alignment: "left",
                            width: 50,
                            margin: [30, 15, 0, 10],
                        }]
                },
                footer: {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 20,
                            bold: false,
                        },
                        {
                            type: 'none',
                            text: moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                            alignment: 'right',
                            margin: [0, 5, 15, 0],
                            fontSize: 10
                        },

                    ]

                },
                content: [
                    {
                        style: 'tableHeaderVehicle',
                        table: {
                            widths: [200, '*', 200],
                            heights: 40,
                            body: [
                                [
                                    {
                                        border: [true, true, true, true],
                                        text: contextVehicle.vehicle.model + "," + contextVehicle.vehicle.motorisation + "," + contextVehicle.vehicle.gearBoxType + "," + contextVehicle.vehicle.color + '\n\n' + contextVehicle.vehicle.vin + (contextVehicle.vehicle.registrationNumber != null ? " | " + contextVehicle.vehicle.registrationNumber : ''),
                                    },
                                    {
                                        border: [false, false, false, false],
                                        fillColor: '',
                                        text: ''
                                    },
                                    {
                                        border: profile.header ? [true, true, true, true] : [false, false, false, false],
                                        text: profile.header,
                                    }
                                ],

                            ]
                        },
                    },

                    {
                        style: 'tableHeaderWithMargin',
                        table: {
                            widths: ['*'],
                            heights: 10,
                            body: [
                                [
                                    {
                                        border: [true, true, true, true],
                                        text: translatedLabels.maintenanceProgram.toLocaleUpperCase(),
                                        alignment: 'center'
                                    },

                                ],

                            ]
                        },
                    },
                    {
                        style: 'tableHeader',
                        columns: [
                            {
                                text: "\n" + vm.primaryOperations.header1.title,
                                width: '*',
                            },
                            {
                                text: vm.oldMaintenanceTab ? ("\n" + vm.primaryOperations.header1.from) : "",
                                width:  70
                            },
                            {
                                text: vm.oldMaintenanceTab ? ("\n" + vm.primaryOperations.header1.then + " "+ vm.primaryOperations.header1.all) :"",
                                width: 70,
                            }, 

                        ].filter(col => col !== null),
                    },
                    {
                        table: {
                            widths:  vm.oldMaintenanceTab ? ['*', 35, 35, 35, 35] :[210, 50, '*'],
                            body: vm.oldMaintenanceTab ? [primaryOperations] : [newMaintenancePdf1],
                        },
                        layout: '',
                    },
                    {
                        table: {
                            widths: vm.oldMaintenanceTab ?  ['*', 35, 35, 35, 35] :[210, 50, '*'],
                            body: vm.oldMaintenanceTab ? primaryOperations1 : newMaintenancePdf2,
                        },
                    },
                    {
                        table: {
                            widths: vm.oldMaintenanceTab ?  ['*', 35, 35, 35, 35] : [210, 50, '*'],
                            body: vm.oldMaintenanceTab ? primaryOperationsPrimaries : newMaintenancePdfLast,
                        },
                    },
                    {
                        style: 'delayedHeaderVehicle',
                        table: {
                            widths:  ['*'],
                            body: [plannedAssitBox],
                        },
                        layout: ''
                    },
                    {
                        style: 'delayedHeaderVehicle',
                        table: {
                            widths: ['*'],
                            body: [operationDelayedHeader],
                        },
                        layout: ''
                    },
                    
                    ...(vm.isPlannedAssistance ? [{
                        table: {
                            widths: ['*'],
                            body: operationDelayedContent,
                        },
                        }] : []),
                        {
                        style: 'delayedHeaderVehicle',
                        table: {
                            widths:  ['*', 70, 50],
                            body: [currentOperationHeader],
                        },
                        layout: ''
                    },
                    ...(vm.isPlannedAssistance ? [{
                        table: {
                            widths: ['*', 70, 50],
                            body: currentOperationContent,
                        },
                    }] : [] ),
                    {
                        style: 'delayedHeaderVehicle',
                        table: {
                            widths:  ['*', 70, 50],
                            body:[upcomingOperationHeader],
                        },
                        layout: ''
                    },
                    ...(vm.isPlannedAssistance ? [{
                        table: {
                            widths: ['*', 70, 50],
                            body:upcomingOperationContent,
                        },
                    }] : []),
                    {
                        style: 'tableHeader',
                        text: "\n" + vm.maintenanceProgram.secondaryOperations.header,
                    },
                    {
                        columns: [
                            {
                                widths: ['*'],
                                stack: [
                                    {
                                        table: {
                                            widths: secondaryOperationsWidth,
                                            body: [secondaryOperationsH1],
                                        }
                                    },
                                    {
                                        table: {
                                            heights: 15,
                                            widths: secondaryOperationsWidth,
                                            body: secondaryOperationsSecondariesC1,
                                        }
                                    }
                                ]
                            },
                            {
                                stack: [
                                    {
                                        table: {
                                            widths: secondaryOperationsWidth,
                                            body: [secondaryOperationsH2],
                                        }
                                    },
                                    {
                                        table: {
                                            heights: 15,
                                            widths: secondaryOperationsWidth,
                                            body: secondaryOperationsSecondariesC2,
                                        }
                                    }
                                ]
                            },
                        ],
                        columnGap: 5,
                    },
                    {
                        text: secondaryOpertationsFooter
                    },
                    {
                        text: vm.maintenanceProgram.secondaryOperations.footer, fontSize: 6
                    },
                    {
                        text: infospecial
                    },
                    {
                        unbreakable: true,
                        stack: [
                            {
                                style: 'tableHeader',
                                text: "\n" + vm.maintenanceProgram.thirdTabOperations.headers.fluidesHeader + "\n",
                                margin: [0, 25, 0, 0]
                            },
                            {

                                columns: [
                                    {
                                        width: tempWidth,
                                        stack: [
                                            {
                                                text: (!_.isEmpty(vm.maintenanceProgram.thirdTabOperations.standardData.temparatureMap)) ? "\n" + vm.maintenanceProgram.thirdTabOperations.headers.huileMoteurHeader : '', bold: true
                                            },
                                            {
                                                table: {
                                                    body: std,
                                                }
                                            },

                                            {
                                                unbreakable: true,
                                                stack: [
                                                    { text: (!_.isEmpty(vm.maintenanceProgram.thirdTabOperations.standardData.temparatureMap)) ? "\n" + vm.maintenanceProgram.thirdTabOperations.headers.gradesHeader + "\n" : '', bold: true },
                                                    {
                                                        table: {
                                                            body: temp,
                                                        },
                                                    },
                                                    {
                                                        margin: [0, 1, 0, 0],
                                                        table: {
                                                            body: [oilImage],
                                                        }
                                                    },
                                                ]

                                            },

                                        ]

                                    },
                                    {
                                        width: '*',
                                        stack: [

                                            { text: "\n" + vm.maintenanceProgram.thirdTabOperations.headers.freinHeader, bold: true },
                                            {
                                                table: {
                                                    body: friens,
                                                }
                                            },
                                            { text: "\n" + vm.maintenanceProgram.thirdTabOperations.headers.refroidissementHeader, bold: true },
                                            {
                                                table: {
                                                    body: refroidissement,
                                                }
                                            }
                                        ]
                                    },
                                ]
                            },
                            {
                                lineHeight: 1,
                                text: (!_.isEmpty(vm.maintenanceProgram.thirdTabOperations.standardData.temparatureMap)) ? vm.maintenanceProgram.thirdTabOperations.footer : ''
                            }
                        ]
                    },


                ],
                images: {
                    Active: 'data:image/png;base64,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',
                    Inactive: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAySURBVEhL7c2hAQAgDMTAL/vv3CJYITXkTGSqryw7r6ucopyinKKcopyinKKcon6ZJgOoGgQuXoK3agAAAABJRU5ErkJggg==',
                    Castrol: 'data:image/png;base64,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',
                    Dacia: 'data:image/png;base64,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'

                },
                styles: {
                    tableHeader: {
                        bold: true,
                        fontSize: 7,
                        alignment: 'left',
                    },
                    tableHeaderVehicle: {
                        bold: true,
                        fontSize: 7,
                        alignment: 'left',
                        margin: [0, 30, 0, 0]
                    },
                    delayedHeaderVehicle: {
                        bold: true,
                        fontSize: 7,
                        alignment: 'left',
                        margin: [0, 15, 0, 0]
                    },
                    tableHeaderWithMargin: {
                        bold: true,
                        fontSize: 7,
                        margin: [0, 50, 0, 0]
                    },
                },
                defaultStyle: {
                    bold: false,
                    fontSize: 7,
                    alignment: 'left'
                }

            }

            var pdfDocGenerator = pdfMake.createPdf(dd);
            pdfDocGenerator.getBuffer(function (buffer) {
                var file = new Blob([buffer], { type: 'application/pdf' });

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;

                if (isIE || isEdge) {
                    //FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + ".pdf");
                    pdfDocGenerator.download(translatedLabels.maintenanceProgram + '.pdf');
                } else {
                    printPdfModalService.encode64Base(file).then(function (response) {
                        var modalParams = {
                            data: response
                        }
                        return printPdfModalService.showModal(modalParams).catch(function () {
                            $log.debug($translate.instant('ERROR'));
                        });
                    }).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                    });
                }
            });

        }

        function saveMileage() {
            vm.lastMileageDisplay = true;     
            var mileage = CacheService.getObject(CacheConstants.mileage);
            vm.oldMileageValue = mileage;
            var convertedMileage = vm.isMilesDisplay ? vm.mileageData * FeaturesConstants.kilometerConstant : vm.mileageData;

            if (Math.floor(convertedMileage) < mileage) {
                toastr.error($translate.instant("MILEAGE_ERROR"));
                return;
            }
            carMaintenanceProgramMetierService.getVinOperation(Math.floor(convertedMileage)).then(function (response) {
                var operationResponse= (response  && response._embedded && response._embedded.operations) ?  response._embedded.operations : "";
                if (vm.primaryOperations && operationResponse) {
                    operationResponse.forEach(function (operationKey) {
                        if (vm.primaryOperations.primaries) {
                            vm.primaryOperations.primaries.forEach(function (key) {
                                var code = key.codeAction + key.codeLibelle
                                if (operationKey.name == key.libelle || parseInt(operationKey.code, 10) == code) {
                                    _.assign(key, { 
                                        isOpen: JSON.stringify(operationKey.isOpen) ? JSON.stringify(operationKey.isOpen) : null ,
                                        nextMileage: operationKey.nextMileage ? operationKey.nextMileage : null,
                                        nextDate: operationKey.nextDate ? operationKey.nextDate : null
                                    });
                                }

                            });
                        }
                        if (vm.primaryOperations.revisions) {
                            vm.primaryOperations.revisions.forEach(function (revisionskey) {
                                var code = revisionskey.codeAction + revisionskey.codeLibelle
                                if (operationKey.name == revisionskey.libelle || parseInt(operationKey.code, 10) == code) {
                                    _.assign(revisionskey, { 
                                        isOpen: JSON.stringify(operationKey.isOpen) ? JSON.stringify(operationKey.isOpen) : null ,
                                        nextMileage: operationKey.nextMileage ? operationKey.nextMileage : null,
                                        nextDate: operationKey.nextDate ? operationKey.nextDate : null
                                    });    
                                }
                            });
                        }
                    });
                    var maintenanceProgram = {
                        primaryOperations: vm.primaryOperations,
                        secondaryOperations: vm.secondaryOperations,
                        thirdTabOperations: vm.thirdTabOperations
                    };
                    var isOpenTotalData = [];
                    isOpenTotalData = vm.primaryOperations && vm.primaryOperations.primaries ? _.concat(isOpenTotalData, vm.primaryOperations.primaries) : [];
                    isOpenTotalData = vm.primaryOperations && vm.primaryOperations.revisions ? _.concat(isOpenTotalData, vm.primaryOperations.revisions) : [];
                    vm.OperationTobeCarried = _.filter(isOpenTotalData, function (o) { return o.isOpen == '1'; });
                    vm.upcomingOperation = _.filter(isOpenTotalData, function (o) { return o.isOpen == '0'; });
                    vm.operationDelayed = _.filter(isOpenTotalData, function (o) { return o.isOpen == '2'; });
                    vm.upcomingOperation = _.orderBy(vm.upcomingOperation, [
                            function (op) {                              
                                return (op.nextDate) || new Date(8640000000000000);                               
                            }, function (op) {
                                return (op.nextMileage )|| Infinity;
                            }], ['asc', 'asc']);
                        vm.OperationTobeCarried = _.orderBy(vm.OperationTobeCarried, [
                            function (op) {
                                return (op.nextDate ) || new Date(8640000000000000);
                            }, function (op) {
                                return (op.nextMileage ) || Infinity;
                            }], ['asc', 'asc']);
                    CacheService.setObject(CacheConstants.maintenanceProgram, maintenanceProgram);
                    broadcastMileageEvent(vm.mileageData, vm.isMilesDisplay);
                    toastr.success($translate.instant("DATA_UPDATE_SUCCESS"));
                }
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
            
        }

        function getConvertedMileage() {
            var conversionFactor = vm.isMilesDisplay ? FeaturesConstants.milesConstant : FeaturesConstants.kilometerConstant;
            return Math.floor(vm.mileageData * conversionFactor);
        }
        function kmToMileData(kmValue){
            var conversionFactor = vm.isMilesDisplay ? FeaturesConstants.milesConstant : FeaturesConstants.kilometerConstant;
            return Math.floor(kmValue * conversionFactor); 
        }

        function broadcastMileageEvent(mileageData, isMilesDisplay) {
            blockUI.start()
            carMaintenanceProgramMetierService.getVinMileage().then(function(response) {
                vm.vinMileageResponse = response;
            }).catch(function(error) {
                toastr.error(error);
            }).finally(function() {
                blockUI.stop();
                var data = {
                    mileage: mileageData,
                    mileageUnits: isMilesDisplay ? vm.primaryOperations.header2.miles2 : vm.primaryOperations.header2.km2,
                    vinMileageResponse: vm.vinMileageResponse ? vm.vinMileageResponse.mileageUnit : null
                };
                $rootScope.$broadcast('mileage', data);
            });
        }

    }
})();

'use strict';

angular
    .module('phenix').constant('CarTechnicalFeaturesConstants',{
        bodyTint: '141',
        getTechnical: '/proxy/apidh/rest/v1/carContexts/localized',
        listeCriteresT: [

            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_Configuration",
                codeObjet: ['007', '008', 'APVDT1', 'APVNM1', '013', '383','956', '018', '629',
                    '003', '528', '900', '901', '985', 'A50', '005',
                    '299', '313', '324', '750', '770', '773', '917',
                    '162', '331', '460', '513', '913', '117', '336',
                    '523', '864', '865', '869']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_BODYWORK",
                codeObjet: ['002', '010', '011', '015', '447', '448', '480', '725',
                    '769', '016', '017', '020', '006', '519', '720', '872',
                    'B02', '446', 'D93', 'A03', 'C50', '559', 'G38', 'G32',
                    '152', '153', '051', '458', '054', '089', '359', '432',
                    'E57', '053', '179', '791', '073', '950', '951', '952',
                    '346', '728', 'A22', 'B16', 'B18', 'B20', 'C44', '052',
                    '055', '424', '567', '845', 'A75', 'D95', '856', '241',
                    '382', '863', 'B76', '014', '050', '445', '044', '757',
                    '402', '342', 'B26', 'C75', 'C77', 'C79', 'C81', 'C83',
                    'D27', 'D29', 'D31', 'D33', 'D35', 'E59', 'E61', 'E63',
                    'F11', '403', 'F29', '344', '381', '861', 'C96', 'C98',
                    'E32', 'D48', 'D50', 'E66', '012', '139', '451', '141','DmsPaintType',
                    '541', 'E86', 'E88', '245', '808', '809', '442', 'G01',
                    '752', 'D56'
                ]
            },



            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE",
                codeObjet: ['999', '998', 'APVDT2', 'APVNM2', '803', '802', '450',
                    '873', '975', 'A54', 'E01', 'E03', 'E07', 'E09', 'E11',
                    '805', '806', 'A80', 'D64', '040', '463', '469', '522', '526',
                    '556', '849', '850', '866', '883', 'B28', 'C04', 'D78', 'E52',
                    'E54', 'F77', 'F82', 'G74', '282', '325', '373', '475', '617',
                    '623', '847', '862', '973', 'A91', 'B01', 'C03', 'D03', 'D79',
                    'E05', 'G20', '019', '267', '272', '321', '340', '404', '848',
                    '859', 'D05', 'F31', 'F96', '214', '387', '431', '517', '801',
                    '622', '734', '748', '857', 'D46', 'D63', 'E02', 'E50', 'G24',
                    'G88', '201', '247', '527', 'C11', 'C25',
                ]
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE_2",
                codeObjet: ['948', '946', '942', 'APVDT5', 'APVNM5', 'APV005']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION",
                codeObjet: ['997', '996', 'APVDT3', 'APVNM3', '033', '036', '427', '524',
                    '525', '218', '034', '035', '782', '023', '037',
                    '633', '868', '870', '871', '895', '963', '965',
                    'A52', 'A53', 'A61', 'B36', 'B85', 'C09', '625',
                    '743', '753', 'A01', 'A82', 'A84', 'C12', 'C14',
                    'C53', '281', '540', 'C05', 'C66']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION",
                codeObjet: ['972', '968', '966', 'APVDT4', 'APVNM4', '958', '959', '962',
                    'F48', 'F95', '957', '417', '474', 'C69', '550',
                    'A59', 'D55', 'F57', 'F89', '269', 'E04', 'E60',
                    'E80', 'F36', 'F67', 'F93', 'F84', 'H02']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_ADAPTATION",
                codeObjet: ['027', '029', 'D28', '148', '326', '327', '435', '539',
                    '026', '159', '328', '393', '413', '547', '555', '751',
                    '800', '024', '025', '119', '140', '291', '095', '097',
                    '114', '120', '265', '284', '495', '500', '613', '650',
                    '664', '820', '980', 'A51', 'A99', 'B54', 'B90', 'C10',
                    'C34', 'C52', 'C54', 'C56', 'C68', 'C74', 'C82', 'D04',
                    'D18', 'D21', 'D22', 'D24', 'D30', 'D51', 'D62', 'D92',
                    'D94', 'E08', 'E14', 'E38', 'E58', 'E96', 'F13', 'F46',
                    'F52', 'F74', 'G30', 'G76', 'G85']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_AXLE_ASSEMBLIES",
                codeObjet: ['009', '038', '061', '251', '357', '358', '443',
                    'D44', 'A33', '257', 'B91', 'C39', '453', '042',
                    '039', '206', '259', '345', '410', '558', '826',
                    'G33', 'D90', '258', '877', 'B87', 'D60', '566',
                    '619', '739', '041', '096', '188', '211', '212',
                    '285', '301', '310', '449', '457', '756', '787',
                    '854', '855', '860', '881', '884', '989', 'B98',
                    'C17', 'C57', 'D09', 'E75', 'E77', 'E79', '810',
                    '852', '853', 'C88', '087', '143', '144', '145',
                    '197', '219', '223', '237', '312', '375', '376',
                    '470', '497', '504', '740', 'B04', 'C90', 'C92',
                    'C94', 'E81', 'F01', '028', '473', '818', '876']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_HEATING",
                codeObjet: ['046', '418', 'A56', '322', '049', '230', '554',
                    'A87', '293', '352', 'D81', 'D83', '303', '719',
                    '918', 'A30', '772', 'D98', '412', '416', '455',
                    '867', '788', 'D15', 'D17', 'D76', 'D85', '774',
                    'F92']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_DASH_BOARD",
                codeObjet: ['123', '124', '178', '294', '347', '350', '351',
                    '372', '395', '396', '398', '467', '815', 'A55',
                    'A71', 'B12', 'B14', 'B22', 'B24', 'B30', 'B48',
                    'B50', 'B71', 'C07', 'C21', 'C23', 'C41', 'C49',
                    'C67', 'D80', 'F38', 'F71', 'G28', '100', '101',
                    '102', '146', '166', '311', '354', '355', '389',
                    '459', '886', 'A68', 'A69', 'A90', 'A92', 'B32',
                    'B34', 'B52', 'C06', 'C08', 'C87', 'C89', 'D45',
                    'D58', 'E23', 'E28', 'E36', 'E46', 'E70', 'E84',
                    'E91', 'E97', 'F09', 'F47', 'F54', 'F59', 'F62',
                    'F70', 'F98', 'G35', 'G50', '067', '098', '099',
                    '104', '105', '177', '304', '305', '309', '323',
                    '408', '425', '730', '786', 'A06', 'A18', 'A19',
                    'A34', 'A45', 'A66', 'C95', 'C97', 'D01', 'D11',
                    'D13', 'D84', 'E65', 'G18', 'G19', 'G72', 'A07',
                    'A31', 'A37', 'C99', 'E10', 'F79', 'G21']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_SEATS",
                codeObjet: ['111', '121', '122', '131', '213', '228', '232',
                    '314', '379', '436', '462', '777', '779', '781',
                    '817', '819', '953', '961', 'A13', 'A32', 'B08',
                    'B10', 'B38', 'B40', 'B42', 'B44', 'C24', 'C26',
                    'C71', 'E18', 'E47', 'E73', 'G78', '090', '112',
                    '126', '128', '129', '130', '132', '135', '137',
                    '138', '192', '198', '231', '239', '308', '317',
                    '318', '319', '320', '361', '362', '363', '364',
                    '365', '705', '758', '759', '760', '761', '762',
                    '763', '764', '766', '767', 'A08', 'A09', 'A12',
                    'C18', 'E20', 'E29', 'E31', 'E33', 'E41', 'E82',
                    '113', '127', '133', '255', '440', '444', '765',
                    '768', '921', '923', '925', '927', '929', '931',
                    '933', '935', '955', 'A04', 'A46', 'A57', 'A67',
                    'A73', 'B06', 'E35', 'E37', 'E39', 'E43', 'E45',
                    '134', '256', '438', '490', 'C27', 'C31', 'C33',
                    'A14', 'B83', 'A95']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_LIGHTING",
                codeObjet: ['254', '406', '423', '080', '084', '217', '360',
                    'A21', 'B70', 'G70', 'E30', '081', 'D74', '343',
                    '082', '631', 'F37', '083', 'A26', '205', 'G86',
                    'B86', '079', 'A78', 'E62', '388', 'E13', 'F03',
                    '065', 'B60', '286', 'C15', 'G17', '068', '349',
                    '264', '071', '353', '464', '069', 'C84', '377',
                    '828', '991', 'B81', 'S55', 'S57']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_WINDOWS",
                codeObjet: ['056', '057', '059', '060', '207', '279', '426',
                    '793', '797', 'E83', 'E85', '062', '063', '064',
                    '070', '072', '300', '306', '307', '380', '439',
                    '492', '493', '531', '771', '780', 'A02', 'A35',
                    'B03', 'B94', '058', '437', '795', 'A36', 'B56',
                    'B88', 'C64', 'E87', '047', '048', '076', '077',
                    '078', '233', '292', '298', '302', '348', '371',
                    '875', '915', 'A15', 'A16', 'A17', 'A48', 'A94',
                    'B82', 'B92', '263', 'A25', 'C37', 'C91', 'C93',
                    'E40', 'F05', 'F07', 'G13', 'G82', 'G84']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_SAFETY",
                codeObjet: ['091', '092', '093', '094', '185', '226', '227',
                    '234', '235', '405', '511', '776', '783', '937',
                    '939', '941', '943', '945', '947', '977', 'C29',
                    'C35', 'C51', 'D37', 'E71', 'F27', '116', '253',
                    '261', '262', '411', '420', '456', '486', '518',
                    '560', '627', '718', 'B80', 'D47', '422', '616',
                    '620', '785', '799', 'B84', 'C19', 'D97', 'E12',
                    'F40', 'F68', 'F75', 'F86', '196', '390', '538',
                    '840', '846', '874', '882', '949', 'C59', 'C72',
                    'D41', 'G22', '506', 'A39', 'A60', 'C01', 'D86',
                    'D96', 'E94', 'E95', 'F91', 'G80', '238', '334',
                    '476']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_LOCKING",
                codeObjet: ['074', '075', '200', '296', '386', 'A29',
                    'A89', 'B74', 'B78', 'C58', 'D66', 'E55',
                    'E90', '271', '568', 'A77', 'D14', 'F69',
                    'H08', '045', '186', '187', '356', '428',
                    '545', '546', 'F60', '789', 'D91', 'E15',
                    'E48']
            },
            {
                categorie: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_EQUIPEMENTS",
                codeObjet: ['136', '176', '191', '195', '199', '220', '229',
                    '240', '242', '243', '249', '287', '333', '337',
                    '338', '339', '366', '367', '368', '369', '384',
                    '385', '397', '407', '433', '434', '465', '466',
                    '484', '491', '505', '509', '520', '521', '529',
                    '530', '536', '537', '543', '549', '557', '561',
                    '565', '630', '712', '738', '742', '744', '811',
                    '812', '832', '879', '880', '908', '967', '969',
                    'A10', 'A11', 'A28', 'A38', 'A40', 'A41', 'A42',
                    'A43', 'A49', 'A62', 'A63', 'A65', 'A70', 'A72',
                    'A76', 'A83', 'A85', 'A93', 'A96', 'A98', 'B46',
                    'B58', 'B62', 'B64', 'B75', 'B93', 'B99', 'C16',
                    'C22', 'C45', 'C47', 'C65', 'C70', 'C85', 'D39',
                    'D42', 'D57', 'D59', 'D61', 'D68', 'D72', 'D75',
                    'E19', 'E49', 'E51', 'E64', 'E89', 'E92', 'E93',
                    'F14', 'F15', 'F17', 'F19', 'F21', 'F23', 'F24',
                    'F25', 'F28', 'F30', 'F41', 'F44', 'F45', 'F50',
                    'F64', 'F72', 'F83', 'F85', 'F94', 'G03', 'G08',
                    'G14', 'G15', 'G23', 'G25', 'G26', 'G27', 'G29',
                    'G31', 'G34', 'G36', 'G42', 'G52', 'G68', '043',
                    '086', '088', '106', '107', '125', '150', '194',
                    '215', '224', '246', '260', '283', '329', '330',
                    '332', '341', '399', '414', '415', '461', '472',
                    '512', '516', '535', '542', '569', '618', '726',
                    '851', '858', '878', '885', 'A23', 'A27', 'A47',
                    'A58', 'A74', 'A79', 'B66', 'B68', 'B97', 'C28',
                    'C32', 'C40', 'C46', 'C62', 'C76', 'C86', 'D12',
                    'D16', 'D19', 'D43', 'D53', 'D65', 'D67', 'D69',
                    'D73', 'D82', 'D99', 'E16', 'E17', 'E25', 'E34',
                    'F02', 'F04', 'F06', 'F08', 'F10', 'F12', 'F16',
                    'F18', 'F20', 'F22', 'F26', 'F32', 'F33', 'F34',
                    'F35', 'F39', 'F43', 'F49', 'F51', 'F55', 'F99',
                    'G06', 'G09', 'G44', 'G46', 'G48', '154', '167',
                    '180', '189', '209', '270', '315', '316', '430',
                    '482', '503', '736', '798', '807', '813', 'D71',
                    'E06', 'E24', 'E26', 'E42', 'E44', 'E72', 'E76',
                    'E78', 'F42', 'G04', 'G10', 'G11']
            }],
        categorieVarious: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS",
        Mode:{
            Read: 'Read',
            Write: 'Write'
        },
        NonModifiableCriteria:['007', '141', '336', '999', '997', '008'],
        isContextCarChanged: "isContextCarChanged",
        notLightFilteringObjCodes: ['336','007','008','999','997',
                                    '968','948'],
        isLightFiltering : 'isLightFiltering',
        milesDisplayCountries: ['GB','AU']
    });

(function(){
    'use strict';

    angular
        .module('phenix')
        .component('carTechnicalCriteria',{
            bindings: {
                isCarContextChanged: '<',
                isLightFilterChanged: '=',
                showTechCritTab: '='
            },
            controller: CarTechnicalCriteria,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/features/components/carTechnicalCriteria/carTechnicalCriteria.template.html'
    });

    function CarTechnicalCriteria(
        $scope,
        $location,
        blockUI,
        toastr,
        $translate ,

        CacheService,
        CarSearchMetierService,
        DealerManagerSystemeService,
        CarTechnicalCriteriaMetierService,
        UtilsMetierService,

        CacheConstants,configConstantes,
        CarTechnicalFeaturesConstants,$rootScope,RecapCarMetierService
    ){

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.recapCarAPI = null;
        vm.categoryMode = CarTechnicalFeaturesConstants.Mode;
        vm.copyCatgories = [];
        vm.isVisibleResetTechnicalCriteria = false;
        vm.isLightFiltering = CacheService.getObject(CarTechnicalFeaturesConstants.isLightFiltering) ?
                CacheService.getObject(CarTechnicalFeaturesConstants.isLightFiltering) : false;
        vm.updatedItems = [];
        vm.carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);
        
        // Backup for cancel functionality
        vm.copyStandardExchange = {};
        
        // Use UtilsMetierService for standard exchange validation
        var standardExchangeValidation = UtilsMetierService.getStandardExchangeValidation(vm.carContextRequest);
        vm.hasStandardExchange = standardExchangeValidation.hasStandardExchange;
        vm.hasAPVNM2 = standardExchangeValidation.hasAPVNM2;
        vm.hasAPVNM3 = standardExchangeValidation.hasAPVNM3;
        vm.hasAPVNM4 = standardExchangeValidation.hasAPVNM4;
        vm.hasAPV002 = standardExchangeValidation.hasAPV002;
        vm.hasAPV003 = standardExchangeValidation.hasAPV003;
        vm.hasAPV004 = standardExchangeValidation.hasAPV004;
        
        vm.isIndependentUser = UtilsMetierService.isIndependentUser();
        var recapCar = RecapCarMetierService.getCarInfos();
        vm.isSearchByModel = (recapCar && recapCar.vehicle && !recapCar.vehicle.vin && !recapCar.vehicle.registrationNumber);
    

        vm.onResetTechnicalCriteria = onResetTechnicalCriteria;
        vm.goToSelectedCategory = goToSelectedCategory;
        vm.onEditCategoryItems = onEditCategoryItems;
        vm.onCancelCategoryItems = onCancelCategoryItems;
        vm.onResetItem = onResetItem;
        vm.onSaveCategoryItems = onSaveCategoryItems;
        vm.setCarTechnicalCriterias = setCarTechnicalCriterias;
        vm.isEditableItem = isEditableItem;
        vm.getItemValue = getItemValue;
        vm.getItemWarnings = getItemWarnings;
        vm.onLightFiltering = onLightFiltering;
        vm.processLocalizedData = processLocalizedData;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function(){

            vm.user = CacheService.getObject(CacheConstants.profil);
            vm.isVisibleResetTechnicalCriteria = CacheService.getObject(CarTechnicalFeaturesConstants.isContextCarChanged);

			$scope.$on('phx-scrollTop', function () {
				vm.scrolled = false;
            });

			setCarTechnicalCriterias();
        }

        var watchDestroy = $rootScope.$on('resetLightFiltering', function () {
            vm.isLightFilterChanged = true;
            onResetTechnicalCriteria(true);
        });

        $scope.$on('$destroy', watchDestroy);

        /**
         * @name onResetTechnicalCriteria
         * @desc this action is fired when user click on reset button (for all categories)
         */
        function onResetTechnicalCriteria(isReset){
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var getCarContext;

            //call search car with immat if exist, vin else
            if(contextCarRequest.registrationNumber){
                getCarContext = CarSearchMetierService.searchCar({ imat: contextCarRequest.registrationNumber }).then(function(){
                    CarSearchMetierService.getBannerData();
                });
            }
            else if(contextCarRequest.vin){
                getCarContext = CarSearchMetierService.searchCar({ vin: contextCarRequest.vin }).then(function(){
                    CarSearchMetierService.getBannerData();
                });
            }

            blockUI.start();
            getCarContext.then(function(data){

                var setpopup = true;
                var updatedcontextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
                var data = {};
                data.carContext = updatedcontextCarRequest;  
                CarSearchMetierService.setLocalizedData(false,null);
                if (vm.copyCatgories[0] && vm.copyCatgories[0].codes) {
                    _.find(vm.copyCatgories[0].codes, function (item) {
                        if ((item.codeObject === '901' || item.codeObject === '900') && !item.codeCriteria) {
                            setpopup = false;
                        }
                    });
                } 
                if (setpopup && data && data.carContext && data.carContext.fixedCriterias && (data.carContext.typeMD === "B2-3" || data.carContext.typeMD === "B3-ADT") && (!_.has(data.carContext.fixedCriterias, '901') || !_.has(data.carContext.fixedCriterias, '900'))) {
                    CarSearchMetierService.getPhasemillesimDetails(data).then(function (result) {
                        if (result) {
                            setCarTechnicalCriterias(isReset);
                        }
                    });
                }
                else {
                    setCarTechnicalCriterias(isReset);
                }

            }).finally(function(){

                vm.isCarContextChanged = false;

                if(!vm.isCarContextChanged){
                    vm.isVisibleResetTechnicalCriteria = false;
                }

                vm.isLightFiltering = false;
                CacheService.setObject(CarTechnicalFeaturesConstants.isContextCarChanged, vm.isVisibleResetTechnicalCriteria);

                $rootScope.$broadcast(CarTechnicalFeaturesConstants.isLightFiltering, vm.isLightFiltering);

                blockUI.stop();
            })
        }

        /**
         * @name goToSelectedCategory
         * @desc navigate to selected category's details
         * @param {String} selectedCategory - the name of the seleted category
         */
        function goToSelectedCategory(selectedCategory) {
			$location.hash(selectedCategory);
        }

        /**
         * @name onEditCategoryItems
         * @desc this action is fired when user click on edit button (category bar)
         * @param {Object} category
         */
        function onEditCategoryItems(category) {
            // Backup standard exchange values before editing
            if (vm.carContextRequest && vm.carContextRequest.standardExchange) {
                vm.copyStandardExchange = angular.copy(vm.carContextRequest.standardExchange);
            }
            setCategoryMode(category, vm.categoryMode.Write);
        }

        /**
         * @name onCancelCategoryItems
         * @desc this action is fired when user clik on cancel button (category bar)
         * @param {Object} category
         */
		function onCancelCategoryItems(category) {
            var indexCategory = _.findIndex(vm.categories, category);
            vm.categories[indexCategory] = vm.copyCatgories[indexCategory];
            
            // Restore standard exchange values
            if (vm.copyStandardExchange && vm.carContextRequest && vm.carContextRequest.standardExchange) {
                vm.carContextRequest.standardExchange = angular.copy(vm.copyStandardExchange);
                // Refresh validation flags using service
                var standardExchangeValidation = UtilsMetierService.getStandardExchangeValidation(vm.carContextRequest);
                vm.hasStandardExchange = standardExchangeValidation.hasStandardExchange;
                vm.hasAPVNM2 = standardExchangeValidation.hasAPVNM2;
                vm.hasAPVNM3 = standardExchangeValidation.hasAPVNM3;
                vm.hasAPVNM4 = standardExchangeValidation.hasAPVNM4;
                vm.hasAPV002 = standardExchangeValidation.hasAPV002;
                vm.hasAPV003 = standardExchangeValidation.hasAPV003;
                vm.hasAPV004 = standardExchangeValidation.hasAPV004;
            }
            
            setCategoryMode(vm.categories[indexCategory], vm.categoryMode.Read);
            vm.copyCatgories = angular.copy(vm.categories);
            resetUpdatedItems();
        }

        /**
         * @name onResetItem
         * @desc this action is fired when user click on the x button in the front of every code criteria
         * @param {*} item
         */
        function onResetItem(item){
            item.codeCriteria = "";
            item.labelCriteria = "";


            vm.updatedItems.push(item.codeObject);
        }

        /**
         * @name onSaveCategoryItems
         * @desc this action is fired when user click on save button (category bar)
         * @desc update car context categories in cache
         * @param {Object} category
         */
		function onSaveCategoryItems(category) {
            var indexCategory = _.findIndex(vm.categories, category);
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

            //update car context request on cache
            updateCarContextRequest(contextCarRequest, vm.updatedItems);

            resetUpdatedItems();

            //update categories in car context cache
            //set tree nodes to null in car context cache (to call fixed filterd tree service)
            updateCarContextSearch(contextCarSearch, vm.categories);


            vm.copyCatgories = angular.copy(vm.categories);
            setCategoryMode(vm.categories[indexCategory], vm.categoryMode.Read);
        }

        /**
         * @name isEditableItem
         * @desc check if current is not in non modifiable criteria array
         * @param {Object} item
         */
		function isEditableItem(item) {
            return (!_.includes(CarTechnicalFeaturesConstants.NonModifiableCriteria, item.codeObject) && item.labelCriteria != "");
        }

        /**
         * @name getItemValue
         * @desc get current item 's value
         * @param {Object} item
         */
        function getItemValue(item){
            var itemValue = item.labelCriteria;
            if(item.codeCriteria){
                itemValue += " (" + item.codeCriteria + ")";
            }
            return itemValue;
        }

        /**
         * @name getItemWarnings
         * @desc get current item 's value
         * @param {Object} item
         */
        function getItemWarnings(item){
            var itemValue = "";
            if(item.warningLabel){
               return itemValue += item.warningLabel;
            }
            return itemValue;
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name setCarTechnicalCriterias
         * @desc set car technical criterias from carContext cache if exist
         * @desc or call localized service to get them
         */
        function setCarTechnicalCriterias(isReset) {
			var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var isDmsConnected = DealerManagerSystemeService.getHookResult();

            //if current car don't have categories
			if (contextCarSearch.vehicle.categories.length == 0) {

                var localizedData = CarSearchMetierService.getLocalizedData();
                if(localizedData && localizedData.hasData && localizedData.data && !_.isEmpty(localizedData.data)
                        && _.has(localizedData.data,'translatedTC') && localizedData.data.translatedTC){
                        processLocalizedData(localizedData.data,isReset);
                }else{

                    //call localized service to get technical criteria for the current car (codeCriteria, labelCriteria, labelObject)
                    blockUI.start();
                    CarTechnicalCriteriaMetierService.getTechnical(isDmsConnected).then(function (response) {
                        if (response.translatedTC) {
                            processLocalizedData(response,isReset);
                        }
                    },function (error) {
                        toastr.error('Error BACK : '+ error.backError, 'Error');
                    }).finally(function(){
                        blockUI.stop();
                    });
                }
                
            }
            //if current car have categories
            //get categories from car context
            else if (contextCarSearch.vehicle.categories) {
                vm.categories = contextCarSearch.vehicle.categories;

				for (var i = 0; i < vm.categories.length; i++) {
                    setCategoryMode(vm.categories[i], vm.categoryMode.Read);
					setCategoryEmpty(vm.categories[i]);
                }

                vm.copyCatgories = angular.copy(vm.categories);
            }
        }


        function processLocalizedData(response, isReset){

            //map service's response to get items foreach category
            vm.categories = getCategoryItems(response);
            //parse categories list to set mode to read as deafult
            //and set empty attribut
            for (var i = 0; i < vm.categories.length; i++) {
                setCategoryMode(vm.categories[i], vm.categoryMode.Read);
                setCategoryEmpty(vm.categories[i]);
            }
            
            //set car technical criteria in cache
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            contextCarSearch.vehicle.categories = vm.categories;
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);

            if(isReset) {
                CacheService.removeObject(CacheConstants.otsCheck);
                CacheService.removeObject(CacheConstants.maintenanceIconCheck);
                $rootScope.$broadcast('callOts',{}); 
            }
        }

        /**
         * @name getCategoryItems
         * @desc parse localized service's response to get items foreach category
         * @param {Array} localizedResponse
         * @returns {Array}
         * codes: [
            {
                "codeObject": "007",
                "labelObject": "FAMILLE",
                "languageObject": "fr",
                "codeCriteria": "X95",
                "labelCriteria": "MEGANE 3 / SCENIC 3",
                "languageCriteria": "fr"
            },
            {
                "codeObject": "008",
                "labelObject": "TYPE DE CARROSSERIE",
                "languageObject": "fr",
                "codeCriteria": "J95",
                "labelCriteria": "MONOCORPS 5-PORTES(GRAND SCENIC 3)",
                "languageCriteria": "fr"
            },
            empty: false
            name: "VEHICLE_TECHNICAL_CRITERION_CATEGORY_Configuration"
         ]
         */
        function getCategoryItems(localizedResponse) {
			var documents = [];
			var various = {
				"name": CarTechnicalFeaturesConstants.categorieVarious,
				"codes": []
            };

            //parse categories list containing items elements
			CarTechnicalFeaturesConstants.listeCriteresT.forEach(function (currentCategory) {
				var category = {
					"name": currentCategory.categorie,
					"codes": []
				};
				currentCategory.codeObjet.forEach(function (code) {
					localizedResponse.translatedTC.forEach(function (trad) {
                        if (code == trad.codeObject) {
                            category.codes.push(trad);
                        }
					});
                });
                documents.push(category);
                if (category.name === "VEHICLE_TECHNICAL_CRITERION_CATEGORY_Configuration" && category.codes && category.codes.length) {
                    var index = 0;
                    if (localizedResponse.tyresInfo) {
                        localizedResponse.tyresInfo.forEach(function (item) {
                            if (item.nrce) {
                                var itemObject = {};

                                itemObject['codeObject'] = "nrce";
                                itemObject['labelObject'] = $translate.instant("COMMUNITY_RECEPTION_CODE");
                                itemObject['labelCriteria'] = item.nrce != '' ? item.nrce : "-";
                                category.codes.push(itemObject);

                            }
                        });
                    }

                    var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                    if (contextCarSearch && contextCarSearch.vehicle) {
                        var itemObject = {};
                        itemObject['codeObject'] = "TAPV";
                        itemObject['labelObject'] = "TAPV";
                        itemObject['labelCriteria'] = contextCarSearch.vehicle.tapv ? contextCarSearch.vehicle.tapv : "-";
                        category.codes.push(itemObject);
                    }
                }


                /*Used to add information regarding the 'Tyres' in the 'Axle Assemblies' category on Technical Criteria page
                and check if there are codes present in the categories or not
                */
                if (category.name === "VEHICLE_TECHNICAL_CRITERION_CATEGORY_AXLE_ASSEMBLIES" && category.codes && category.codes.length) {
                    var index = 0;
                    category.codes.forEach(function () {
                        //add tyresInfo at the bottom of category codes
                        if (index === category.codes.length -1 && localizedResponse.tyresInfo && localizedResponse.tyresInfo.length) {
                            var hasStarItemObjectFrontOpt = false;
                            var hasStartItemObjectRearOpt = false;
                            var itemObjectFront;
                            var itemObjectRear;
                            var itemObjectFrontOpt;
                            var itemObjectRearOpt;
                            localizedResponse.tyresInfo.forEach(function (item) {
                                //Checks if the API returns any 'Mandatory Tyres'
                                if (item.tyres) {
                                    itemObjectFront = {};
                                    itemObjectRear = {};

                                    itemObjectFront['codeObject'] = "103";
                                    itemObjectFront['labelObject'] = $translate.instant("BASE_FRONT_TYRES");
                                    itemObjectFront['labelCriteria'] = item.tyres.front;

                                    itemObjectRear['codeObject'] = "108";
                                    itemObjectRear['labelObject'] = $translate.instant("BASE_REAR_TYRES");
                                    itemObjectRear['labelCriteria'] = item.tyres.rear;

                                    category.codes.push(itemObjectFront);
                                    category.codes.push(itemObjectRear);
                                }
                                //Checks if the API returns any 'Optional Tyres'
                                if (item.optionalTyres && item.optionalTyres.length) {
                                    itemObjectFrontOpt = {};
                                    itemObjectRearOpt = {};

                                    itemObjectFrontOpt['codeObject'] = "109";
                                    itemObjectFrontOpt['labelObject'] = $translate.instant("OPTIONAL_FRONT_TYRES");

                                    itemObjectRearOpt['codeObject'] = "110";
                                    itemObjectRearOpt['labelObject'] = $translate.instant("OPTIONAL_REAR_TYRES");

                                    itemObjectFrontOpt['labelCriteria'] = item.optionalTyres.map(function (optionalItem) {
                                        // we verify if the object has special mounting directives
                                        if(optionalItem.rear.length >= 2  && optionalItem.front[optionalItem.front.length -2] === '*') {
                                            hasStarItemObjectFrontOpt = true;
                                        }
                                        return optionalItem.front;
                                    }).join("\n");

                                    itemObjectRearOpt['labelCriteria'] = item.optionalTyres.map(function (optionalItem) {
                                        if(optionalItem.rear.length >= 2  && optionalItem.rear[optionalItem.rear.length -2] === '*') {
                                            hasStartItemObjectRearOpt = true;
                                        }
                                        return optionalItem.rear;
                                    }).join("\n");
                                    // we append the mounting directives if needed
                                    if(hasStarItemObjectFrontOpt){
                                        itemObjectFrontOpt.warningLabel = "\n(*) Montes soumises à conditions techniques, veuillez vous reporter \n     à la documentation du véhicule ";
                                    }
                                    if(hasStartItemObjectRearOpt){
                                        itemObjectRearOpt.warningLabel = "\n(*) Montes soumises à conditions techniques, veuillez vous reporter \n     à la documentation du véhicule ";
                                    }
                                    category.codes.push(itemObjectFrontOpt);
                                    category.codes.push(itemObjectRearOpt);
                                }
                            })
                        }
                        index++;
                    });
                }
            });
			localizedResponse.translatedTC.forEach(function (trad) {
				if (!trad.error) {
					var b = true;
					documents.forEach(function (currentDoc) {
						currentDoc.codes.forEach(function (codes) {
							if (codes.codeObject == trad.codeObject) {
								b = false;
							}
						});
					});
					if (b) {
						various.codes.push(trad);
					}
				}
            });
            documents.push(various);
            vm.copyCatgories = angular.copy(documents);
			return documents;
        }

        /**
         * @name setCategoryMode
         * @desc set mode to current category (Read / Write)
         * @param {Object} category
         * @param {String} mode
         */
        function setCategoryMode(category, mode){
            category.mode = mode;
        }

        /**
         * @name setCategoryEmpty
         * @desc set category empty attribute (True / False)
         * @param {Object} category
         */
        function setCategoryEmpty(category){
            if (category.codes.length > 0) {
                category.empty = false;
            }
            else {
                category.empty = true;
            }
        }

        /**
         * @name resetUpdatedItems
         * @desc set updatedItems to []
         */
        function resetUpdatedItems(){
            vm.updatedItems = [];
        }

        /**
         * @name updateCarContextRequest
         * @desc update car context request in cache
         * @param {*} carContextRequest
         * @param {*} updatedItems
         */
        function updateCarContextRequest(carContextRequest, updatedItems){

            //get array with keys values
            var itemsFixedCriteria = Object.keys(carContextRequest.fixedCriterias);
            var itemsVariablesCriteria = Object.keys(carContextRequest.variableCriterias);
            var itemsContextBLMSFixedCriteria = Object.keys(carContextRequest.contextBLMS.dataCrit);
            var itemsContextBLMSVariablesCriteria = Object.keys(carContextRequest.contextBLMS.dataCritVar);

            //parse updated items on the current categories
            //check if updated item exits in fixed criteria object, or variables criteria
            updatedItems.forEach(function(updatedItem){
                //reset item value in fixed criteria object if exist
                if(itemsFixedCriteria.length > 0){
                    if(_.includes(itemsFixedCriteria, updatedItem)){
                        delete carContextRequest.fixedCriterias[updatedItem];
                        vm.isCarContextChanged = true;
                        vm.isVisibleResetTechnicalCriteria = true;
                    }
                }
                //reset item value in variables criteria object if exist
                if(itemsVariablesCriteria.length > 0){
                    if(_.includes(itemsVariablesCriteria, updatedItem)){
                        delete carContextRequest.variableCriterias[updatedItem];
                        vm.isCarContextChanged = true;
                        vm.isVisibleResetTechnicalCriteria = true;
                    }
                }
                //reset item value in contextBLMS.dataCrit if exist
                if(itemsContextBLMSFixedCriteria.length > 0){
                    if(_.includes(itemsContextBLMSFixedCriteria, updatedItem)){
                        delete carContextRequest.contextBLMS.dataCrit[updatedItem];
                        vm.isCarContextChanged = true;
                        vm.isVisibleResetTechnicalCriteria = true;
                    }
                }
                //reset item value in contextBLMS.dataCritVar if exist
                if(itemsContextBLMSVariablesCriteria.length > 0){
                    if(_.includes(itemsContextBLMSVariablesCriteria, updatedItem)){
                        delete carContextRequest.contextBLMS.dataCritVar[updatedItem];
                        vm.isCarContextChanged = true;
                        vm.isVisibleResetTechnicalCriteria = true;
                    }
                }

                if (updatedItem == 'TAPV'){
                    delete carContextRequest.tapv;
                    vm.isCarContextChanged = true;
                    vm.isVisibleResetTechnicalCriteria = true;
                }

                if (updatedItem == 'nrce'){
                    vm.isCarContextChanged = true;
                    vm.isVisibleResetTechnicalCriteria = true;
                }
            });

            //set context car search to change if true
            CacheService.setObject(CarTechnicalFeaturesConstants.isContextCarChanged, vm.isCarContextChanged);

            //update car context request on cache
            CacheService.setObject(CacheConstants.contextCarRequest,carContextRequest);
        }

        /**
         * @name updateCarContextSearch
         * @desc update car context search
         * @param {*} contextCarSearch
         * @param {*} categories
         */
        function updateCarContextSearch(contextCarSearch, categories){
            //set categories to new values and tree nodes to null
            contextCarSearch.vehicle.categories = categories;
            contextCarSearch.treeNodes = null;
            CacheService.setObject(CacheConstants.contextCarSearch,contextCarSearch);
        }

        function onLightFiltering(){

            vm.isLightFilterChanged = true;

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var contextCarRequestCopy = angular.copy(contextCarRequest);
            contextCarRequestCopy.fixedCriterias = {};

            //get array with keys values
            var itemsFixedCriteria = Object.keys(contextCarRequest.fixedCriterias);
            var itemsVariablesCriteria = Object.keys(contextCarRequest.variableCriterias);

            CarTechnicalFeaturesConstants.notLightFilteringObjCodes.forEach(function(updatedItem){
                if(itemsFixedCriteria.length > 0){
                    if(_.includes(itemsFixedCriteria,updatedItem)){
                        contextCarRequestCopy.fixedCriterias[updatedItem] = contextCarRequest.fixedCriterias[updatedItem];
                        vm.isLightFiltering = true; 
                    }
                }
            });

            if(itemsVariablesCriteria.length > 0){
                itemsVariablesCriteria.forEach(function(updatedItem){
                    delete contextCarRequestCopy.variableCriterias[updatedItem];
                        vm.isLightFiltering = true; 
                })
            }

            contextCarRequest = angular.copy(contextCarRequestCopy);

            vm.categories.forEach(function(categorie){
                categorie.codes.forEach(function(code){
                    if(!_.includes(CarTechnicalFeaturesConstants.notLightFilteringObjCodes,code.codeObject)){
                        code.codeCriteria = "";
                        code.labelCriteria = "";
                    }
                })
            })

            updateCarContextSearch(contextCarSearch, vm.categories);

            vm.copyCatgories = angular.copy(vm.categories);

            //set context car search to change if true
            CacheService.setObject(CarTechnicalFeaturesConstants.isContextCarChanged, vm.isCarContextChanged);

            //update car context request on cache
            CacheService.setObject(CacheConstants.contextCarRequest,contextCarRequest);

            $rootScope.$broadcast(CarTechnicalFeaturesConstants.isLightFiltering, vm.isLightFiltering);


        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('vehicleMaintenanceHistory', {
            bindings: {
                isCarContextChanged: '<'
            },
            controller: vehicleMaintenanceHistory,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/features/components/vehicleMaintenanceHistory/vehicleMaintenanceHistory.template.html'
        });

    function vehicleMaintenanceHistory(
        $scope,
        CacheService,
        CacheConstants,
        blockUI,
        toastr,FileSaver,
        printPdfModalService,
        vehicleMaintenanceHistoryMetierService,
        $translate,$q,PanierConstants,$log,PDFViewService,UtilsMetierService,
        DeleteModalService,$filter,$state
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.showContent = false;
        vm.operationsList = [];
        vm.showOperationDetail = false;
        vm.noOperationDetail = false;
        vm.isInterventionView = false;
        vm.operation = [];
        vm.operationDetailsList = [];
        vm.laborAndPartsList = [];
        vm.carContext = null;
        vm.operationsOrigin = '';
        vm.maxOccurrence = '';
        vm.showOperations = false;
        vm.isIndependentUser = UtilsMetierService.isIndependentUser();
        vm.userProfil = CacheService.getUserProfile();
        vm.isEditMode = false;
        vm.originalLaborAndPartsList = [];
        vm.showEditIcon = false;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.getOperationDetail = getOperationDetail;
        this.getInterventionData = getInterventionData;
        this.getInterventionDetails = getInterventionDetails;
        this.goBack = goBack;
        this.printMaintenance = printMaintenance;
        this.showDetail = showDetail;
        this.getOperations = getOperations;
        this.toggleEditMode = toggleEditMode;
        this.saveDescriptions = saveDescriptions;
        this.deleteOperation = deleteOperation;

        var pictoImage = {            
            "RENAULT":{src:convertImgToBase64("/assets/images/renaultgroup.png","RENAULT")},
            "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")}
        }

        this.$onInit = function () {

            vm.user = CacheService.getObject(CacheConstants.profil);
            vm.carContext = CacheService.getObject(CacheConstants.contextCarSearch);
            vm.operationsOrigin = PanierConstants.origin;
            $scope.$on('phx-opentabvehicleMaintenanceHistoryTab', function () {
                loadVehicleMaintenanceHistory();
            });

            if ($state && $state.params && $state.params.tabName === 'vehicleMaintenanceHistoryTab') {
                loadVehicleMaintenanceHistory();
            }

        }

        function loadVehicleMaintenanceHistory() {
            vm.operationsList = [];
            vm.showOperationDetail = false;
            getVehicleMaintenanceHistory();
        }

        function getVehicleMaintenanceHistory() {
            var vin = (vm.carContext && vm.carContext.vehicle) ? vm.carContext.vehicle.vin : null;
            if (vin) {
                blockUI.start();
                    $q.all([
                        vehicleMaintenanceHistoryMetierService.getVinRep(),
                        vehicleMaintenanceHistoryMetierService.getInterventionData(vin,null)
                    ]).then(function (response) {
                        return response;
                    }).then(function (response) {
                        if(!_.isEmpty(response)){
                            if(response[0] && response[0].data){
                                response[0].data.forEach(function (item) {
                                    item.show = false;
                                    item.repairOrderDate = item.repairOrderDate.split('.').reverse().join('.').replace(/\./g,'-');

                                    if(!item.category || item.category == ""){
                                        vm.getOperations(item);
                                    }
                                });
                            }
                            vm.getInterventionData(response);
                        }
                    }).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                    }).finally(function () {
                        vm.loading = false;
                        blockUI.stop();
                    })
                
            }
        }

        function getOperationDetail(operation, fromEditIcon){
            blockUI.start();
            vm.showEditIcon = fromEditIcon === true;
            
            if(operation.customerComplaint && operation.customerComplaint[0].code === vm.operationsOrigin){
                vm.operation = operation;
                vm.getInterventionDetails(operation.operationId);
            } else {
                vehicleMaintenanceHistoryMetierService.getOperationDetail(operation.operationId, operation.refType, operation.refModule).then(function (response){                
                    return response;
                }).then( function (response){
                    vm.isInterventionView = false;
                    vm.showOperationDetail = true;
                    vm.operation = operation;
                    vm.operationDetailsList = response;
                    vm.laborAndPartsList = [];
                    if(response.fixedPriceList && !_.isEmpty(response.fixedPriceList)){
                        vm.isInterventionView = true;
                        response.fixedPriceList.forEach(function(item){
                            if(item.fixedPriceLaborList && !_.isEmpty(item.fixedPriceLaborList)){
                                item.fixedPriceLaborList.forEach(function(laborItem){
                                    vm.laborAndPartsList.push({
                                        ref: laborItem.ref,
                                        time : laborItem.time + " h",
                                        label : item.label+" - "+laborItem.label
                                    });
                                });
                            }
                        })
                    }
                    if (response.laborList){
                        for(var i=0; i< response.laborList.length; i++){
                            vm.laborAndPartsList.push({
                                ref: response.laborList[i].ref,
                                time : response.laborList[i].time + " h",
                                label : response.laborList[i].label
                            })
                        }
                    }
                    if(response.fixedPriceList && !_.isEmpty(response.fixedPriceList)){
                        response.fixedPriceList.forEach(function(item){
                            if(item.fixedPricePartsList && !_.isEmpty(item.fixedPricePartsList)){
                                item.fixedPricePartsList.forEach(function(partItem){
                                    partItem.label = item.label +" - "+partItem.label;
                                    vm.laborAndPartsList.push(partItem);
                                })
                            }
                        })
                    }
                    if (response.partsList){
                        for (var j=0; j< response.partsList.length; j++){
                            vm.laborAndPartsList.push(response.partsList[j]);
                        }
                    }
                }).catch(function () {
                    vm.showContent = false;
                    vm.noOperationDetail = true;
                }).finally( function(){
                    blockUI.stop();
                })
            }
        }
        function getInterventionData(maintenanceResp){ 
            vm.showContent = true;
            if(maintenanceResp[1] && maintenanceResp[1].operations){
                maintenanceResp[1].operations.forEach(function(item){
                    if(item.basketNumber){
                    vm.operationsList.push({ 
                        operationId: item.operationId, 
                        repairOrderDate: item.operationDate, 
                        mileageValue: item.mileage? parseInt(item.mileage): null, 
                        customerComplaint: [{ code: item.origin }], 
                        symptom: null, 
                        label: ' - ' + item.basketNumber + ' - ' + item.invoiceNumber, 
                        basketNumber: item.basketNumber,
                        ipn: item.ipn
                    })
                    }
                    else{
                        vm.operationsList.push({ 
                            operationId: item.operationId, 
                            repairOrderDate: item.operationDate, 
                            mileageValue: item.mileage? parseInt(item.mileage): null, 
                            customerComplaint: [{ code: item.origin }], 
                            symptom: null, 
                            label: item.title + ' / ' + 'Functions:' + item.levelOne + ' , ' + item.levelTwo, 
                            title: item.title,
                            ipn: item.ipn
                        })    
                    }
                })
            }
            if(maintenanceResp[0] && maintenanceResp[0].data)
                vm.operationsList = vm.operationsList.concat(maintenanceResp[0].data);
            vm.operationsList = _.orderBy(vm.operationsList,['repairOrderDate','mileageValue'],['desc','desc']);
        }
        function goBack(){
            if (vm.isEditMode) {
                vm.isEditMode = false;
            }
            vm.showOperationDetail = false;
            vm.showContent = true;
            vm.showEditIcon = false;
        }
        function getInterventionDetails(id, isInlineExpansion){
            var vin = (vm.carContext && vm.carContext.vehicle) ? vm.carContext.vehicle.vin : null;
            vm.laborAndPartsList = [];
            if (isInlineExpansion) {
                vm.newLaborAndPartsList = [];
            }
            if(vin){
                vehicleMaintenanceHistoryMetierService.getInterventionData(vin,id).then(function (response) {
                    vm.isInterventionView = true;
                    if (!isInlineExpansion) {
                        vm.showOperationDetail = true;
                    }
                    if (!_.isEmpty(response.laborTimes)){
                        response.laborTimes.forEach(function(opecode){
                            let item = {
                                ref: opecode.opecod,
                                time : opecode.laborTime + " h",
                                label : opecode.designation
                            };
                            vm.laborAndPartsList.push(item);
                            if (isInlineExpansion) {
                                vm.newLaborAndPartsList.push(item);
                            }
                        })
                    }
                    if (!_.isEmpty(response.parts)){
                        response.parts.forEach(function(parts){
                            let item = {
                                ref: parts.reference,
                                quantity : parts.quantity,
                                label : parts.designation
                            };
                            vm.laborAndPartsList.push(item);
                            if (isInlineExpansion) {
                                vm.newLaborAndPartsList.push(item);
                            }
                        })
                    }
                    if(!_.isEmpty(response.operationDescription)){
                        let item = {
                            operationDesc : response.operationDescription,
                            isOperationDesc: true
                        };
                        vm.laborAndPartsList.push(item);
                        if (isInlineExpansion) {
                            vm.newLaborAndPartsList.push(item);
                        }
                    };
                }).catch(function(error){
                    vm.showContent = false;
                    vm.noOperationDetail = true;
                    toastr.error($translate.instant('ERROR'));
                }).finally(function () {
                    blockUI.stop();
                })
            }
        }
        function printMaintenance(){
            downloadPdf().then(function(response){
                pdfMake.tableLayouts = {
                        otherTableLayout: {
                            hLineWidth: function () {
                                return 1;
                            },
                            vLineWidth: function () {
                                return 1;
                            }
                        }
                    };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });
                    var isIE = false || !!document.documentMode;
                    var isEdge = !isIE && !!window.StyleMedia;
                        if (isIE || isEdge) { 
                            FileSaver.saveAs(file, "Maintenance_history.pdf");
                        }else {             
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }                                    
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                 });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                })
            });
        }
        function downloadPdf() {
            var cartToPrint = {
                pdfMetaData: vm.operation,
                metaDataDetails: [{header:$translate.instant("VEHICLE_MAINTENANCE_HISTORY_SYMPTOM"),value:(vm.operation.symptom && !_.isEmpty(vm.operation.symptom)) ? vm.operation.symptom[0].label : null},{header:$translate.instant("VEHICLE_MAINTENANCE_HISTORY_CUSTOMER_COMPLAINT"),value: (vm.operation.customerComplaint && !_.isEmpty(vm.operation.customerComplaint)) ? vm.operation.customerComplaint[0].label : null},{header:$translate.instant("VEHICLE_MAINTENANCE_HISTORY_CUSTOMER_RECORD"),value: vm.operationDetailsList.customerFeedback},{header:$translate.instant("VEHICLE_MAINTENANCE_HISTORY_REPAIR_DIAGNOSTIC"),value:vm.operationDetailsList.repairDiagnostic}],
                referencesList: vm.laborAndPartsList,
                middletable: (vm.operation.symptom || vm.operation.customerComplaint || vm.operationDetailsList.customerFeedback || vm.operationDetailsList.repairDiagnostic),
                translatedLabels: {
                    emptyLabel: '',
                    historyDate: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_DATE"),
                    historyMileage: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_KM"),
                    historySymptom: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_SYMPTOM"),
                    historyDesc: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_DESCRIPTION"),
                    renaultIncident: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_RENAULT_INCIDENT"),
                    historyDreu: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_DREU"),
                    historySigma: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_SIGMA"),
                    historyDealership: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_DEALERSHIP"),
                    historyOther: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_OTHER"),
                    vehicleOTS: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_OTS_NO"),
                    refTitle: $translate.instant("VIEWED_DOC_REF"),
                    designationLabel: $translate.instant("COMMON_DESIGNATION"),
                    complementaryInfo: $translate.instant("DOCUMENT_PR_COMPLEMENTARY_INFO"),
                    operationDetail: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_CODE"),
                    historyTime: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_TIME"),
                    quantity: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_QUANTITY"),
                    operationDesc: $translate.instant("VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_DESCRIPTION")
                }
            };
            
            return formatDataToPrint(cartToPrint);
        }
        function formatDataToPrint(data) {

            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            var vehicle = CacheService.getObject(CacheConstants.contextCarSearch).vehicle;
            var firstObj = { type: "columns", values:{0: [vehicle.model+", "+vehicle.motorisation+", "+vehicle.gearBoxType+", "+vehicle.color]}, styles: "textStyle" };
            if (vehicle) {
                dataArray.push(firstObj);
            }
            if(vehicle.vin || vehicle.registrationNumber){
                var vinObj = { type: "columns", values:{0: [vehicle.vin+ (vehicle.registrationNumber ? (vehicle.vin ? " | " :"")+vehicle.registrationNumber : "")],1:["\n"]}, styles: "textPlainStyle" };
                dataArray.push(vinObj);
            }
            var operationDetailObj = { type: "columns", values:{0: [ $translate.instant("VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL") ]}, styles: "textStyle" };
            dataArray.push(operationDetailObj);
            
            if(!vm.isInterventionView){
                var firstTable = [];
                firstTable.push(data.pdfMetaData);

                var filteredData = firstTable.map(function (item) {
                    var tableData = [];               
                
                    tableData[data.translatedLabels.historyDate] =
                    {
                        data: item.repairOrderDate,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historyMileage] =
                    {
                        data: item.mileageValue,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.vehicleOTS] =
                    {
                        data: item.otsNumber,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historyDesc] =
                    {
                        data: item.label,
                        alignment: "center"
                    }; 
                    tableData[data.translatedLabels.renaultIncident] =
                    {
                        data: item.coverageRateREN+"%",
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historyDreu] =
                    {
                        data: item.coverageRateDREU+"%",
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historySigma] =
                    {
                        data: item.coverageRateRCI+"%",
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historyDealership] =
                    {
                        data: item.coverageRateDealer+"%",
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.historyOther] =
                    {
                        data: item.coverageRateOther+"%",
                        alignment: "center"
                    };
                    return tableData;
                })
                
                var thirdObj = {};

                thirdObj = {
                    type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: [45,30,30,130,40,40,40,40,40]
                };
                
                dataArray.push(thirdObj);

                var secondTable = data.metaDataDetails;

                var filteredData = secondTable.map(function (item) {
                    var tableData = [];               
                
                    tableData[data.translatedLabels.emptyLabel] =
                    {
                        data: item.header,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.emptyLabel+' '] =
                    {
                        data: item.value,
                        alignment: "left"
                    };                   
                    return tableData;
                })
                
                var fourthObj = {};

                fourthObj = {
                    type: "table", values: getTableData(filteredData, false), styles: "tableStyle",
                    layout: "otherTableLayout", widths: [100,300]
                };
                if(data.middletable)
                    dataArray.push(fourthObj);
            }
            var thirdTable = data.referencesList;

            var filteredData = thirdTable.map(function (item) {
                if(item.ref && item.ref.length == 10){
                   item.ref =  $filter('filterFormatRef')(item.ref)
                }
                var tableData = [];               
               
                tableData[data.translatedLabels.operationDetail] =
                {
                    data: item.ref,
                    alignment: "center"
                };
                tableData[data.translatedLabels.historyTime] =
                {
                    data: (item.time && item.time!=undefined)? item.time :'',
                    alignment: "center"
                };
                tableData[data.translatedLabels.quantity] =
                {
                    data: item.quantity ? item.quantity : '',
                    alignment: "center"
                };
                tableData[data.translatedLabels.operationDesc] =
                {
                    data: item.label? item.label : item.operationDesc ? item.operationDesc:'',
                    alignment: "center"
                };                 
                return tableData;
            })
            
            var fifthObj = {};

            fifthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: [120,50,50,260]
            };

            dataArray.push(fifthObj);            
            
            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,true,false,false);
            
            var docDefinition = {
                info: {
                    title: $translate.instant("VEHICLE_MAINTENANCE_HISTORY")+"-"+vm.operation.operationId,
                },
                header: {
                    columns: [
                        {
                        image: pictoImage.RENAULT.value,
                        alignment: "left",
                        width: 50,
                        margin: [40, 15, 0, 10],
                    }]
                },
                footer:{
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        },
                        {
                            type: 'none',
                            text: moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                            alignment: 'right',
                            margin: [0, 5, 5, 0]
                        },                       
                       
                    ]
                    
                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 30, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                        bold: true
                    },
                    textPlainStyle:{
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [0, 5, 0, 0]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "left",
                        fontSize: 8,
                        bold: true
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }

        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }
                
        function showDetail(operation) {
            vm.operationsList.map(function (data) {
                if (data.operationId == operation.operationId) {
                    data.show = !data.show;
                    vm.showOperations = data.show;
                    vm.getOperations(data, true); 
                }

                else {
                     data.show = false;
                     vm.showOperations = data.show;
                }

                return data;

            });

        }

        function getOperations(operation, isInlineExpansion) {
            blockUI.start();
            if(operation.customerComplaint && operation.customerComplaint[0].code === vm.operationsOrigin){                
                vm.getInterventionDetails(operation.operationId, isInlineExpansion);
            } 
            
            else {
                vehicleMaintenanceHistoryMetierService.getOperationDetail(operation.operationId, operation.refType, operation.refModule).then(function (response){                
                    return response;
                }).then( function (response){
                    vm.isInterventionView = false;
                    vm.showOperationDetail = false;
                    vm.operation = operation;
                    vm.operationDetailsList = response;
                    vm.newLaborAndPartsList = [];
                    vm.maxOccurenceLabel = '';

                    if(response.fixedPriceList && !_.isEmpty(response.fixedPriceList)){
                        vm.isInterventionView = true;
                        response.fixedPriceList.forEach(function(item){ 
                            if(item.fixedPriceLaborList && !_.isEmpty(item.fixedPriceLaborList)){
                                if((operation.category || operation.category != "") || operation.show == true){                         
                                item.fixedPriceLaborList.forEach(function(laborItem){
                                    vm.newLaborAndPartsList.push({
                                        ref: laborItem.ref,
                                        time : laborItem.time + " h",
                                        label : item.label+" - "+laborItem.label
                                    });
                                });
                            }

                            else {
                                item.fixedPriceLaborList.forEach(function(laborItem){
                                    vm.newLaborAndPartsList.push({
                                        ref: laborItem.ref,
                                        time : laborItem.time,
                                        label : laborItem.label
                                    });
                                });
                            }

                            }
                        
                        });

                        if(!operation.category || operation.category == "" && !_.isEmpty(vm.newLaborAndPartsList)){
                            vm.maxOccurrence = Math.max.apply( 
                            Math,
                            vm.newLaborAndPartsList.map(function (data) {
                                return data.time;
                            }));
 
                            vm.newLaborAndPartsList.forEach(function (laborLabel) {
                                if (laborLabel.time == vm.maxOccurrence) {
                                    vm.maxOccurenceLabel = laborLabel.label;
                                }
                            });

                            if(vm.maxOccurrence){
                                vm.maxOccurenceLabel = vm.maxOccurenceLabel.substring(3);
                                operation.label = vm.maxOccurenceLabel;
                            }
                        }

                    }

                    if (response.laborList){
                        for(var i=0; i< response.laborList.length; i++){
                            vm.newLaborAndPartsList.push({
                                ref: response.laborList[i].ref,
                                time : response.laborList[i].time + " h",
                                label : response.laborList[i].label
                            })
                        }
                    }

                    if(response.fixedPriceList && !_.isEmpty(response.fixedPriceList)){
                        response.fixedPriceList.forEach(function(item){
                            if(item.fixedPricePartsList && !_.isEmpty(item.fixedPricePartsList)){
                                item.fixedPricePartsList.forEach(function(partItem){
                                    partItem.label = item.label +" - "+partItem.label;
                                    vm.newLaborAndPartsList.push(partItem);
                                })
                            }
                        })
                    }

                    if (response.partsList){
                        for (var j=0; j< response.partsList.length; j++){
                            vm.newLaborAndPartsList.push(response.partsList[j]);
                        }
                    }
                }).catch(function () {
                    vm.showContent = false;
                    vm.noOperationDetail = false;
                    vm.showOperationDetail = false;                       
                }).finally( function(){
                    blockUI.stop();
                })
            } 
        }

        function toggleEditMode() {
            if (!vm.isEditMode) {
                vm.originalLaborAndPartsList = angular.copy(vm.laborAndPartsList);
            } else {
                vm.laborAndPartsList = angular.copy(vm.originalLaborAndPartsList);
                toastr.info($translate.instant('VEHICLE_MAINTENANCE_HISTORY_CHANGES_CANCELLED'));
            }
            vm.isEditMode = !vm.isEditMode;
        }

        function saveDescriptions() {
            var vin = (vm.carContext && vm.carContext.vehicle) ? vm.carContext.vehicle.vin : null;
            var operationId = vm.operation ? vm.operation.operationId : null;
            
            if (!vin || !operationId) {
                toastr.error($translate.instant('ERROR'));
                return;
            }

            var parts = [];
            var laborTimes = [];
            var operationDescription = '';
            var hasEmptyFields = false;

            vm.laborAndPartsList.forEach(function(item) {
                item.refError = false;
                item.timeError = false;
                item.quantityError = false;
                item.labelError = false;
            });

            vm.laborAndPartsList.forEach(function(item, index) {
                if (item.isOperationDesc) {
                    operationDescription = item.operationDesc || '';
                    if (!operationDescription || operationDescription.trim() === '') {
                        hasEmptyFields = true;
                        item.labelError = true;
                    }
                } else {
                    var originalItem = vm.originalLaborAndPartsList[index];

                    if (!item.ref || item.ref.trim() === '') {
                        item.refError = true;
                        hasEmptyFields = true;
                    }

                    if (originalItem && originalItem.time) {
                        if (!item.time || item.time.toString().trim() === '') {
                            item.timeError = true;
                            hasEmptyFields = true;
                        }
                    }

                    if (originalItem && (originalItem.quantity !== undefined && originalItem.quantity !== null && originalItem.quantity !== '')) {
                        if (item.quantity === undefined || item.quantity === null || item.quantity.toString().trim() === '') {
                            item.quantityError = true;
                            hasEmptyFields = true;
                        }
                    }

                    if (!item.label || item.label.trim() === '') {
                        item.labelError = true;
                        hasEmptyFields = true;
                    }

                    if (!item.refError && !item.timeError && !item.quantityError && !item.labelError) {
                        if (originalItem && (originalItem.quantity !== undefined && originalItem.quantity !== null && originalItem.quantity !== '')) {
                            parts.push({
                                reference: item.ref,
                                quantity: item.quantity,
                                designation: item.label
                            });
                        } else if (originalItem && originalItem.time) {
                            laborTimes.push({
                                opecod: item.ref,
                                laborTime: parseFloat(item.time.replace(' h', '')),
                                designation: item.label
                            });
                        }
                    }
                }
            });

    
            if (hasEmptyFields) {
                return;
            }

            var updateData = {
                parts: parts,
                laborTimes: laborTimes,
                operationDescription: operationDescription
            };

            blockUI.start();
            vehicleMaintenanceHistoryMetierService.updateOperationInformation(vin, operationId, updateData)
                .then(function() {
                    vm.isEditMode = false;
                    vm.originalLaborAndPartsList = angular.copy(vm.laborAndPartsList);
                    toastr.success($translate.instant('OPERATION_UPDATE_SUCCESS'));
                })
                .catch(function() {
                    toastr.error($translate.instant('ERROR'));
                })
                .finally(function() {
                    blockUI.stop();
                });
        }

        function deleteOperation(operation) {
            const vin = (vm.carContext && vm.carContext.vehicle) ? vm.carContext.vehicle.vin : null;
            const operationId = operation ? operation.operationId : null;
            
            if (!vin || !operationId) {
                toastr.error($translate.instant('ERROR'));
                return;
            }

            const modalParams = {
                body: angular.element(document.body),
                title: $translate.instant('CONFIRM_DELETE'),
                isList: true,
                rows: [
                    { number: $translate.instant('CONFIRM_DELETE_MESSAGE') }
                ],
                centerTitle: true
            };

            DeleteModalService.showModal(modalParams).then(function () {
                blockUI.start();
                vehicleMaintenanceHistoryMetierService.deleteOperation(vin, operationId)
                    .then(function() {
                        toastr.success($translate.instant('FAV_TOASTR_SUCCESS_DELETE'));
                        vm.operationsList = vm.operationsList.filter(function(op) {
                            return op.operationId !== operationId;
                        });
                    })
                    .catch(function() {
                        toastr.error($translate.instant('ERROR'));
                    })
                    .finally(function() {
                        blockUI.stop();
                    });
            }).catch(function() {
                toastr.info($translate.instant('VEHICLE_MAINTENANCE_HISTORY_CHANGES_CANCELLED'));
            });
        }

    }
})();

'use strict';

angular
    .module('phenix')
    .constant('CarOtsConstants', {
        languages: ["cs", "de", "es", "fi", "fr", "en", "hr", "hu", "it", "nl", "pl", "pt", "ro", "ru", "sv", "sl", "tr"],
        defaultLang: "en"
    });

(function(){
    'use strict';

    angular
        .module('phenix')
        .component('carOts', {
            bindings: {

            },
            controller: CarOtsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/features/components/carOts/carOts.template.html'
        });

    function CarOtsController(
        blockUI,
        toastr,
        $window,
        $state,

        CarOtsMetierService,
        CacheService,
        DocumentsMetierService,
        CacheConstants,
        RoutesConstants,
        $q,$scope

    ){
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.onBTClick = onBTClick;
        vm.activeTabOts = activeTabOts;
        vm.isBTCreatedWithinLastThirtyDays = isBTCreatedWithinLastThirtyDays;
        vm.isBTUpdatedWithinLastThirtyDays = isBTUpdatedWithinLastThirtyDays;
        vm.formatDate = formatDate;

        vm.loading = true;
        vm.showContent = false;
        vm.otsFront = [];
        vm.ots_techid = 'ots_techid';

        /*=============================================
        =                 functions                   =
        =============================================*/

        this.$onInit = function(){
                activeTabOts();
        }

        $scope.$on('callOts', function (techcrit) {
            activeTabOts(techcrit);
        });

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        function activeTabOts(techcrit) {
            var otsCheck = CacheService.getObject(CacheConstants.otsCheck);
            const listOts = CacheService.getObject(CacheConstants.listOts);

            return $q.resolve().then(function () {
                blockUI.start();
                if (!otsCheck) {
                   return CarOtsMetierService.getOts().then(function (response) {
                           return response;
                        });
                }else if(listOts){
                    return $q.resolve(listOts);
                } else {
                    return $q.resolve(null);
                }

            }).then(function(response){
                if(response && !_.isEmpty(response)){
                    CacheService.setObject(CacheConstants.otsCheck,true);
                    return CarOtsMetierService.getOtsWithLink(response).then(function(otsWithLink){
                        vm.otsFront = otsWithLink;
                        vm.showContent = otsWithLink.length;

                        CacheService.setObject(CacheConstants.listOts, otsWithLink);
                    });
                }
            }).catch(function () {
                if(!techcrit){
                    toastr.error('Error BACK : CARSEARCH_BVM_ERROR', 'Error');
                }
            }).finally(function () {
                vm.loading = false;
                blockUI.stop();
                
            })
        }

        function isBTCreatedWithinLastThirtyDays(creationDate) {
            if (!creationDate) {
                return false;
            }
            const year = parseInt(creationDate.substring(0, 4), 10);
            const month = parseInt(creationDate.substring(4, 6), 10) - 1;
            const day = parseInt(creationDate.substring(6, 8), 10);
            const createdDate = new Date(year, month, day);
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

            return createdDate >= thirtyDaysAgo;
        }

        function isBTUpdatedWithinLastThirtyDays(updateDate) {
            if (!updateDate) {
                return false;
            }
            const year = parseInt(updateDate.substring(0, 4), 10);
            const month = parseInt(updateDate.substring(4, 6), 10) - 1;
            const day = parseInt(updateDate.substring(6, 8), 10);
            const updateDateObj = new Date(year, month, day);
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

            return updateDateObj >= thirtyDaysAgo;
        }

        function formatDate(dateString) {
            if (!dateString) {
                return '';
            }
            const year = parseInt(dateString.substring(0, 4), 10);
            const month = parseInt(dateString.substring(4, 6), 10);
            const day = parseInt(dateString.substring(6, 8), 10);
            return `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
        }

        function onBTClick(ots) {
            var link = ots.link;

            if (!link) {
                return null;
            }
            var BtnumbersAndSymptomsDetails = {
                colorCode : link.colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : link.colorCode,
                creationDate: link.creationDate,
                updateDate: link.updateDate
            }
            if (link.pdfContent) {
                $window.open(link.contentUrl, '_blank');
            } else {
                DocumentsMetierService.displayBtDetails(link.paramURL, link.pdfContent,BtnumbersAndSymptomsDetails, 'otsTab');
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('phenix').service('StoppedRangeWSService',StoppedRangeWSService);

  function StoppedRangeWSService($q, RestUpgrade, $log,ProductSearchConstants){
    this.getCatalog=getCatalog;

    function getCatalog(id) {
      var defer = $q.defer();
      RestUpgrade.one(ProductSearchConstants.stoppedRangeCatalog).get({id:id}).then(function (response) {
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }
  }

})();

(function () {
  'use strict';

  angular.module('phenix').service('StoppedRangeMetierService',StoppedRangeMetierService);

  function StoppedRangeMetierService(StoppedRangeWSService,$log,$q){
    this.getCatalog=getCatalog;

    function  getCatalog(id){
      var defer = $q.defer();
      StoppedRangeWSService.getCatalog(id).then(function (response) {
        defer.resolve(response)
      }, function (error) {
        defer.reject(error)
      });
      return defer.promise;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ProductWsService', ProductWsService);

    /** @ngInject */
    function ProductWsService($q,
        $log,
        RestUpgrade,
        ProductSearchConstants,
        errorsConstant,toastr,
        $translate
    ) {

        this.getReferenceInformation = getReferenceInformation;
        this.getConvertedCadNewUrl = getConvertedCadNewUrl;
        var _errors = errorsConstant;

        /**
         * @desc On envoit la reference pour recevoir la fiche produit
         * en fonction des parametres de l'utilisateur (langue)
         * @param {string} reference est la valeur selectionné dans la liste des PR
         * @param {object} body contient 2 champs userContext, et initialReference <-
         * @returns {promise}
         */
        function getReferenceInformation(reference, body) {
            return RestUpgrade.one(ProductSearchConstants.documentationProducts).post(reference, body).then(function (res) {
                if (!res) {
                    return $q.reject(_errors.UNKNOW_REFERENCE);
                }

                return res;
            });
        }
        function getConvertedCadNewUrl(url,payload){
          return RestUpgrade.one(url).post('',payload);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ProductMetierService', ProductMetierService);

    /** @ngInject */
    function ProductMetierService(ProductWsService, $q, CacheService, CacheConstants, DmsMetierService, ProductSearchConstants,configConstantes) {

        this.getReferenceInformation = getReferenceInformation;
        this.getReferenceInformationRaw = getReferenceInformationRaw;
        this.canShowingProductAdd = canShowingProductAdd;
        this.getElementsFromArray = getElementsFromArray;
        this.canShowingDocument = canShowingDocument;
        this.canShowingElement = canShowingElement;
        this.canShowingMotrio = canShowingMotrio;
        this.checkCountryAutorisation = checkCountryAutorisation;
        this.canShowingStandardExchange = canShowingStandardExchange;
        this.canShowingCharacteristics = canShowingCharacteristics;
        this.getDocumentsUrl = getDocumentsUrl;
        this.canShowingTechnical = canShowingTechnical;
        this.canShowingStock = canShowingStock;
        this.canShowingLocal = canShowingLocal;
        this.canShowingUnavailable = canShowingUnavailable;
        this.canShowingAdditional = canShowingAdditional;
        this.isDmsConnected = isDmsConnected;
        this.getCodifiedSign = getCodifiedSign;
        this.matchReferencesInformation = matchReferencesInformation;
        this.getReferenceInformationFromDMS = getReferenceInformationFromDMS;
        this.addInformationsOnSuperSessions = addInformationsOnSuperSessions;
        this.getReferencesFromSuperSessions = getReferencesFromSuperSessions;
        this.getDMSPartData = getDMSPartData;
        this.isTechnicalCollectionRestrained = isTechnicalCollectionRestrained;
        this.getConvertedNewCad = getConvertedNewCad;
        this.setThreeDResp = setThreeDResp;
        this.getThreeDResp = getThreeDResp;
        var threeDResp = null;
        /*=============================================
        =                FUNCTIONS                    =
        =============================================*/


        /**
         * check if car have additionaal
         * @param {object} additional
         * @returns {boolean}
         */
        function canShowingAdditional(additional) {
            return additional;
        }
        /**
        * add DMS information to Product informations
        * @param {object} dmsResponse dms response
        * @param {object} productReponse central response
        * @returns {object} productReponse enriches with DMS
         */
        function matchReferencesInformation(productReponse, dmsResponse) {
            if (dmsResponse.response.parts[0]) {
                productReponse.dmsInformations = {
                    priceExclTaxes: dmsResponse.response.parts[0].priceExclTaxes,
                    priceInclTaxes: dmsResponse.response.parts[0].priceInclTaxes,
                    cort: dmsResponse.response.parts[0].cort
                };
                var availabilities = dmsResponse.response.parts[0].availabilities;
                if (availabilities) {
                    _.extend(productReponse.dmsInformations, {
                        locker: availabilities[0].location,
                        quantity: availabilities[0].quantity
                    });
                }
            } else {
                productReponse.dmsInformations = {};
            }
            return productReponse;
        }

        /**
        * add DMS information to Product informations
        * @param {object} dmsResponse dms response
        * @param {object} productReponse central response
        * @returns {object} productReponse enriches with DMS
         */
        function getDMSPartData(partsDMS, reference) {
            var dmsInformations = {};

            var partDMS = _.find(partsDMS, function (part) {
                return part.reference === reference;
            })

            if (partDMS) {
                dmsInformations = {
                    description: partDMS.description,
                    priceExclTaxes: partDMS.priceExclTaxes,
                    priceInclTaxes: partDMS.priceInclTaxes,
                    cort: partDMS.cort
                };
                if(partDMS.status == 2){
                    _.extend(dmsInformations,{
                        quantity : 0
                    });
                }
                var availabilities = partDMS.availabilities;
                if (availabilities && availabilities.length) {
                    _.extend(dmsInformations, {
                        locker: availabilities[0].location,
                        quantity: availabilities[0].quantity,
                        availabilities: availabilities
                    });
                }
            }
            return dmsInformations
        }

        /**
         *  call DMS service references
         *  @param {object} reference to find
         *  @returns {object} DMS response
         */

        function getReferenceInformationFromDMS(reference) {
            var payload = Array.isArray(reference) ? reference : [reference];
            return DmsMetierService.getReferencesDms(payload)
        }

        /**
         *  check if canShowingProductAdd
         *  @returns {boolean}
         */

        function canShowingProductAdd() {
            var user = CacheService.getObject(CacheConstants.profil);
            return user.dmsConnected;
        }



        /**
         *  check if DMS is connected
         *  @returns {boolean}
         */

        function isDmsConnected() {
            var user = CacheService.getObject(CacheConstants.profil);
            return user.dmsConnected;
        }

        /**
         *  @param {Object} partDMSInfo
         *  @return {number | '-'}
         *
         */

        function getQuantityOnReplacement(partDMSInfo) {
            var quantity = _.get(partDMSInfo, ['availabilities', '0', 'quantity']);

            if (_.isNumber(quantity)) {
                return quantity;
            }

            return '-';
        }

        /**
         *
         *  @desc Add quantity on every part, PPS (additional) inside superSessions
         *
         *  @param {Array<Object>} superSessions
         *  @param {ArrayObject>} partsDataDMS
         *
         */

        function setQuantityOnEveryReplacementPart(superSessions, partsDataDMS) {
            return superSessions.map(function (superSession) {

                var replacement = _.assign({}, superSession);
                var partDMSInfo = _.find(partsDataDMS, function (part) {
                    return part.reference === replacement.mainReference
                });

                var quantity = getQuantityOnReplacement(partDMSInfo);
                var additional = replacement.additional;

                if (Array.isArray(additional) && additional.length) {
                    additional = additional.map(function (pps) {
                        var partDMSInfoPPS = _.find(partsDataDMS, function (part) {
                            return part.reference === pps.additionalReference
                        });
                        var PPSquantity = getQuantityOnReplacement(partDMSInfoPPS);
                        return _.assign({}, pps, {
                            quantity: PPSquantity
                        })
                    });
                }

                return _.assign(replacement, {
                    quantity: quantity,
                    additional: additional
                });
            });
        }

        /**
         *  Set a part as best replacement in replacement list
         *
         *  @param {Array<Object>} superSessions
         *  @return {Array<Object>}
         */

        function setBestReplacement(superSessions) {
            var bestReplacementIsSet = false;

            return superSessions.map(function (superSession, index, list) {
                var session = _.assign({}, superSession, {
                    bestReplacementDMS: false
                });

                var isLastItem = index === list.length - 1;

                // superSession can contain only 1 ref.
                // So the first is the last too. It can't be the bestReplacement in this case
                if (index !== 0 && !bestReplacementIsSet && superSession.quantity > 0) {
                    bestReplacementIsSet = true;
                    return _.extend(session, {
                        bestReplacementDMS: true
                    });
                }

                // if we are on the last item and on previous parts we didnt set any best replacement
                // so the last one is the best Replacement by default
                if (index !== 0 && isLastItem && !bestReplacementIsSet) {
                    _.extend(session, {
                        bestReplacementDMS: true
                    })
                }

                return session;
            });
        }


        /**
         *  This function doesn't mutate superSessions Array/Object
         *
         *  @param {array<Object>} superSessions
         *  @param {array<Object>} partsDataDMS
         *  @return {Array<Object>} which contains superSessions more 2 fields in Object : {
         *      quantity: number
         *      bestReplacementDMS: boolean
         *  }
         */

        function addInformationsOnSuperSessions(superSessions, partsDataDMS) {
            var superSessionIsEmpty = !Array.isArray(superSessions);
            var partsDataDMSIsEmpty = !Array.isArray(partsDataDMS);

            if (superSessionIsEmpty || partsDataDMSIsEmpty) {
                return superSessions;
            }

            // yes, this can be done with 1 function but i think it's more readable if we split
            // in multiples functions
            // First    : we set quantity on every part inside superSessions, PPS as well
            // Second   : tag a part as a best replacement
            // Third    : Assign local replacement on every part, PPS as well

            superSessions = setQuantityOnEveryReplacementPart(superSessions, partsDataDMS);
            superSessions = setBestReplacement(superSessions);
            superSessions = setSupersedingPart(superSessions, partsDataDMS);
            return superSessions;
        }

        /**
         *
         *  @desc   This function add supersedingPart field on every items in superSessions
         *          supersedingPart contains local replacement, quantity, avaibilities etc...
         *
         *  @param {Array<Object>} superSessions
         *  @param {Array<Object>} partsDataDMS
         *  @return {Array<Object>}
         */

        function setSupersedingPart(superSessions, partsDataDMS) {
            return superSessions.map(function (superSession) {
                var updatedSuperSession = _.assign({}, superSession);
                var dmsPartS = _.find(partsDataDMS, function(part) {
                    return part.reference === superSession.mainReference;
                });

                if (dmsPartS && !_.isEmpty(dmsPartS.supersedingPart)) {
                    _.assign(updatedSuperSession, { supersedingPart : dmsPartS.supersedingPart });
                }

                // superSession contains PPS, don't forget to add superseding too
                if (Array.isArray(superSession.additional)) {
                    superSession.additional = superSession.additional.map(function (pps) {
                        var updatedPPS = _.assign({}, pps);
                        var dmsPart = _.find(partsDataDMS, function(part) {
                            return part.reference === pps.additionalReference;
                        });

                        if (dmsPart) {
                            _.assign(updatedPPS, { additionalDesignation: dmsPart.description });
                            if (!_.isEmpty(dmsPart.supersedingPart)) {
                                _.assign(updatedPPS, { supersedingPart : dmsPart.supersedingPart });
                            }
                        }

                        return updatedPPS;
                    });
                }
                return updatedSuperSession;
            });
        }

        /**
         *  @desc   Return all reference from superSession, a superSession
         *          can contain additional field which has reference too
         *  @param {Array<Object>}
         *  @return {Array<String>}
         */

        function getReferencesFromSuperSessions(superSessions) {
            return superSessions.reduce(function (acc, part) {
                acc = acc.concat(part.mainReference);
                var hasPPS = Array.isArray(part.additional) && part.additional.length;

                if (hasPPS) {
                    var PPSReferences = part.additional.map(function (partPPS) {
                        return partPPS.additionalReference;
                    });
                    acc = acc.concat(PPSReferences);
                }
                return acc;
            }, [])
        }


        /**
         * @desc Appelle le service qui va nous recuperer la fiche produit
         * On fait un traitement sur ce qu'on recoit pour avoir
         * une logique plus simple coté HTML
         *
         * @param {string} reference
         * @param {string} initialReference
         * @returns {promise}
         */

        function getReferenceInformation(reference, initialReference) {
            var userContext = CacheService.getUserContext();
            var body = {
                supersessionRootReference: initialReference || null,
                userContext: userContext
            };

            return ProductWsService.getReferenceInformation(reference, body).then(function (res) {
                res.fullDesignation = filterMarketingInformations(res.fullDesignations).join(', ');
                res.images = filterIllustrationsInformations(res.illustrations);
                var newImgUrls = [];
                res.images.map(function (item) {
                    newImgUrls.push (item.value);
                });
                res.images = newImgUrls;
                res.partLinks = reorderPartLinks(res.partLinks);
                
                var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
                if (carContext) {
                    var vehicle = carContext.vehicle
                    if (!vehicle.displayMotrio) {
                        res.partLinks = res.partLinks.filter(function (link) {

                                return _.includes(link.types,ProductSearchConstants.motrio) ? false : true;
                            
                        });
                    }
                }

                if (res.supersessionRootReference) {
                    res.supersessions = [{
                        mainReference: res.supersessionRootReference,
                        mainDesgination: res.supersessionRootDesgination,
                        originalReference: true
                    }].concat(res.supersessions);

                    res.supersessions.forEach(function (session) {
                        // rename quantity by ratio
                        session.ratio = session.quantity;
                        delete session['quantity'];
                        if (session.additional && session.additional.length) {
                            session.additionalList = true;
                            session.additional.forEach(function (additional) {
                                // rename quantity by ratio
                                additional.ratio = additional.quantity;
                                delete additional['quantity'];
                                if (additional.infos === 'HasSuperSession') {
                                    additional.additional = true;
                                }
                            });
                        }
                        return session;
                    });
                } else {
                    res.supersessions = [{
                        mainReference: res.originalPartReference,
                        mainDesgination: res.designation,
                        originalReference: true
                    }];
                }

                return res;
            });
        }


        function getReferenceInformationRaw(id) {
            var userContext = CacheService.getUserContext();
            var body = {
                userContext: userContext
            }
            return ProductWsService.getReferenceInformation(id, body).then(function (res) {
                if (!res) {
                    return $q.reject('')
                }
                return res;
            });
        }

        function filterMarketingInformations(informations) {
            if (!informations) {
                return [];
            }

            var toFilter = [];

            if (informations["part"].length) {
                toFilter = informations["part"];
            } else if (informations["model"].length) {
                toFilter = informations["model"];
            } else if (informations["family"].length) {
                toFilter = informations["family"];
            }

            return toFilter.map(function (item) {
                return item.value;
            })
        }

        /**
         * @description Used to filter the incoming illustrations data only if
         * there is data for 'part' and not for 'family' or 'model'
         * @param {*} illustrations
         */

        function filterIllustrationsInformations(illustrations) {
            if (!illustrations) {
                return [];
            }

            var toFilter = [];
            if (illustrations["part"].length) {
                toFilter = illustrations["part"];
            }

            return toFilter.filter(function (item) {
                if (!_.isEmpty(item) && (_.includes(item.value, 'small') || _.includes(item.value, 'mediumx2'))) {
                    return item.value;
                }
            })
        }

        function reorderPartLinks(partLinks) {
            if (!partLinks) {
                return [];
            }

            var renault = [];
            var motrio = [];
            var standardExchange = [];

            partLinks.forEach(function (link) {
                switch (link.linkType) {
                    case 'motrio':
                        motrio.push(link);
                        break;
                    case 'standardExchange':
                        standardExchange.push(link);
                        break;
                    default:
                        renault.push(link);
                        break;
                }
            });

            return renault.concat(motrio, standardExchange);
        }




        /**
        * getElementsFromArray (first and second parts of the array)
        * @param {object} e
        * @returns {elementsPart}
        */
        function getElementsFromArray(e, part) {
            var elementsPart = [];
            var impair = 0;
            if (e) {
                if (e.length % 2 == 0) {
                    impair = 0;
                }
                else {
                    impair = 1;
                }

                if (part === 1) {
                    for (var i = 0; i < truncate(e.length / 2) + impair; i++) {
                        elementsPart[i] = e[i];
                    }
                } else {
                    var j = 0;


                    for (i = truncate(e.length / 2) + impair; i < e.length; i++) {
                        elementsPart[j] = e[i];
                        j++;
                    }
                }
            }


            return elementsPart;
        }

        /**
         * canShowingTechnical
         * @param {object} technical
         * @returns {boolean}
         */
        function canShowingTechnical(technical) {
            return technical ? true : false;
        }




        /**
         * canShowingDocument
         * @param {object} documents
         * @param {string} condition
         * @returns {boolean}
         */
        function canShowingDocument(documents, condition) {
            if (documents) {
                for (var i = 0; i < documents.length; i++) {
                    if (documents[i].type === condition) {
                        return true;
                    }
                }
            }

            return false;
        }




        /**
         * canShowingCharacteristics
         * @param {object} characteristics
         * @returns {boolean}
         */
        function canShowingCharacteristics(characteristics) {
            return characteristics ? true : false;
        }




        /**
         * canShowingElement
         * @param {object} element
         * @returns {boolean}
         */
        function canShowingElement(element) {
            return element ? true : false;
        }




        /**
         * check if we show/hide the MOTRIO icon on list/detail Product
         * @param brand
         * @returns {boolean}
         */
        function canShowingMotrio(brand) {
            return (brand && brand.toUpperCase() === 'motrio'.toUpperCase()) ? true : false;
        }




        /**
         * check if we show/hide the STANDARD EXCHANGE icon on list/detail Product
         * @param {object} standardExchange
         * @returns {boolean}
         */
        function canShowingStandardExchange(standardExchange) {
            return standardExchange ? true : false;
        }




        /**
         * Return document's url
         * @param {object} documents
         * @param {integer} key
         * @returns {object}
         */
        function getDocumentsUrl(documents, key) {
            if (documents) {
                for (var i = 0; i < documents.length; i++) {
                    if (documents[i].type === key) {
                        return documents[i].url;
                    }
                }
            }
            return '';
        }




        /**
         * truncate
         * @param {object} documents
         * @param {integer} key
         * @returns {object}
         */
        function truncate(number) {
            return number > 0
                ? Math.floor(number)
                : Math.ceil(number);
        }



        /**
         *
         *  @param {*String} countryCode the country code set in the user context
         *  @returns {boolean}
         * function called to check if the user is allowed to see an info
         */
        function checkCountryAutorisation(countryCode) {
            var isAllowed = false;
            var allowedCountry = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "ES", "FI", "FR", "DE", "EL", "HU", "IR", "IT", "LT",
                "LV", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "SW", "GB", "NO", "IS", "LI", "CH"];
            angular.forEach(allowedCountry, function (value) {
                if (value == countryCode) {
                    isAllowed = true;
                }
            });
            return isAllowed;
        }

        /**
         * can showing stocks
         * @param {object} stock
         * @returns {boolean}
         */
        function canShowingStock(stock) {
            if (stock && stock.stockType) {
                return true;
            }
            else {
                return false;
            }
        }



        /**
         * can showing local
         * @param {object} stock
         * @returns {boolean}
         */
        function canShowingLocal(stock) {
            if (stock && stock.localType) {
                return true;
            }
            else {
                return false;
            }
        }

        /**
        * canShowingUnavailable
        * @param {object} stock
        * @returns {boolean}
        */
        function canShowingUnavailable(stock) {

            if (!stock || (stock && stock.unavailableType)) {
                return true;
            }
            else {
                return false;
            }
        }



        /**
        * getCodifiedSign
        * @param {object} codifiedSigns
        * @returns {object} codifiedSignsValues
        */
        function getCodifiedSign(codifiedSigns) {
            var codifiedSignsValues = [];
            var marCode = "";
            var isMarquage = false;
            if (codifiedSigns) {
                for (var j = 0; j < codifiedSigns.length; j++) {
                    if (codifiedSigns[j].sigcod != "000MAR") {
                        codifiedSignsValues.push(codifiedSigns[j].desfr);
                    } else {
                        isMarquage = true;
                        marCode += (codifiedSigns[j].value + " - ");
                    }
                }
                if (marCode) {
                    if (isMarquage) {
                        marCode = "Marquages : " + marCode;

                    }
                    marCode = marCode.substr(0, marCode.length - 3);
                    codifiedSignsValues.push(marCode);
                }
            }
            return codifiedSignsValues;
        }

        /**
         * We verify if the familyCode obtained from the response is part of the restrictive list
         * @param response
         * @returns {boolean}
         */
        function isTechnicalCollectionRestrained(response) {
            var familyCode = _.isEmpty(response.familyCode) ? "" : response.familyCode;
            var technicalCollectionFamilyRestriction = ProductSearchConstants.technicalCollectionFamilyRestriction;
            var isFamilyCodeResctricted = false;

            angular.forEach(technicalCollectionFamilyRestriction, function (value) {
                if (familyCode.indexOf(value) > -1 && !isFamilyCodeResctricted) {
                    isFamilyCodeResctricted = true;
                }
            });
            return isFamilyCodeResctricted;
        }

        function getConvertedNewCad(payload){
            var defer = $q.defer();
            var url = ProductSearchConstants.getConvertedCadNewUrl + ProductSearchConstants.newUrlVariableCad;
            ProductWsService.getConvertedCadNewUrl(url,payload).then(function (res) {
                 if(res ){
                    defer.resolve(res);
                 }else{
                     defer.reject();
                 }
            }).catch(function(err){
                defer.reject(err)
            })
            return defer.promise;
        }


        function setThreeDResp(resp){
            threeDResp = resp;
        }
        function getThreeDResp(){
            return threeDResp;
        }

    }

})();

/**
 * TmDocuments Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('TMDocumentsCtrl', TMDocumentsCtrl);

    /**
     * @namespace TmDocumentsController
     * @desc Display TM informations (code, title, time, details, ...)
     * @memberOf Controllers
     */

    /* @ngInject */
    function TMDocumentsCtrl(DocumentsMetierService, AlertsService, $scope,$mdDialog,
        CacheService, CacheConstants, configConstantes, blockUI, $state, UtilsMetierService, searchByTextsIdsMertierService,toastr, $rootScope, $window, DocumentSearchConstants,DocPrivMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var giesList = [];

        vm.atLeastOneTMDocument = false;
        vm.isTmAuthorized = false;
        vm.popin = {};
        vm.tmListData = [];
        vm.listOfTMDocuments = {};
        vm.selectedFilters = {
            operation: "",
            element: ""
        };
        vm.siesByGies = [];
        vm.loading = true;
        vm.openAlertsPopin = openAlertsPopin;
        vm.capturedImage = null;
        var arraySortOrder = DocumentSearchConstants.opecodeSortOrder;
        vm.captureScreenshot = captureScreenshot;
        vm.close= close;
        vm.onOk = onOk;
        vm.checkTMListPattern = checkTMListPattern;
        vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
        vm.isRedButtonAuthorized = false;
    
        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name init
         * @desc Get TM documents, filters section (elements TM and operations)
         * this action trigger when the user click on the TM panel
         * @returns {array} list of TM documents, elements and operations
         * @memberOf Controllers.TmDocumentsController
         */
        function init() {
            vm.isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            vm.isRedButtonAuthorized = vm.isTraceEnabled;            
            if(!vm.isSearchEngine){
                if ($state.params.searchText) {
                    vm.tmListData = $state.params.searchList;
                } else if (CacheService.getNodeSearchTmList()) {
                    vm.tmListData = CacheService.getNodeSearchTmList().split(',');
                }
                if (vm.tmListData.length != 0) {
                    var tmIDList = vm.tmListData;
                    blockUI.start();
                    DocumentsMetierService.returnTmDocumentsByOpeCode(tmIDList).then(function (response) {
                        processTMResponse(response);
                    }).finally(function () {
                        blockUI.stop();
                        vm.loading = false;
                        if (vm.listOfTMDocuments) {
                            vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                        }
                    });
                }
                /**Event on click ==>fired by a tab change**/
                $scope.$on('phx-init-listTM', function (event, tmIDList) {
                    resetFilters();
                    if (tmIDList && tmIDList.length) {
                       vm.laborTimePresent = DocPrivMetierService.getLabourTimeResposne();
                       if(!vm.laborTimePresent || _.isEmpty(vm.laborTimePresent)){
                        blockUI.start();
                        DocumentsMetierService.returnTmDocuments(tmIDList).then(function (response) {
                            DocPrivMetierService.setLabourTimeResposne(response);
                            processTMResponse(response);
                        }).finally(function () {
                            blockUI.stop();
                            vm.loading = false;
                            if (vm.listOfTMDocuments) {
                                vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                            }
                        });
                    }
                        else {
                            processTMResponse(vm.laborTimePresent);
                            vm.loading = false;
                            if (vm.listOfTMDocuments) {
                                vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                            }
                        }
                    }
                });
                showTmTitle();
                vm.screenshotButtonVisibility = AlertsService.getScreenshotButtonVisibility();
            } else{
                $scope.$on('phx-init-listTM', function (event, tmIDList,isNoData) {
                    resetFilters();
                    var types = ['TM'];    
                    vm.inputFilterText = CacheService.getObject(CacheConstants.motCle); 
                    vm.docType = 'TM';
                    if (vm.checkTMListPattern() && vm.inputFilterText.length == 4 ){
                        tmIDList = [];
                        tmIDList.push(vm.inputFilterText.toUpperCase());
                        blockUI.start();
                        DocumentsMetierService.returnTmDocumentsByOpeCode(tmIDList).then(function (response) {
                            processTMResponse(response);
                        }).finally(function () {
                            blockUI.stop();
                            vm.loading = false;
                            if (vm.listOfTMDocuments) {
                                vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                            }
                        });

                    }
                    else if(!_.isEmpty(tmIDList)){
                        searchEngineTM(tmIDList);
                    }else{
                        if(isNoData){
                            vm.listOfTMDocuments = [];
                            vm.atLeastOneTMDocument = false;
                            vm.loading = false;
                        } else{
                            searchByTextsIdsMertierService.getSearchEngineDocs(vm.inputFilterText,types).then(function(response){
                                if(!_.isEmpty(response)){                      
                                    searchEngineTM(response);   
                                }
                            })
                        }
                    }
                });
            }
        }
        function checkTMListPattern() {
            var regex = /^(([0-9a-zA-Z]{4})[,])*([0-9a-zA-Z]{4})$/;
            return (vm.inputFilterText.length > 0) ? regex.test(vm.inputFilterText) : true;
        }
        function resetFilters(){            
            vm.selectedFilters = {
                operation: "",
                element: ""
            };                    
            $rootScope.$broadcast("filterReset");  
        }
        function processTMResponse(response){
            vm.laborTimePresent = DocPrivMetierService.getLabourTimeResposne();           
            initDocuments(response);
            giesList = getGiesTM(response.TM);
            giesList = _.uniqWith(giesList,_.isEqual);
            if(giesList && giesList.length >0){
                if(vm.laborTimePresent && _.isEmpty(vm.laborTimePresent.elemOpe)){
                getSIesByGies(giesList).then(function (reponse) {
                    CacheService.setSiesByGiesHistory(reponse);
                });
            }
                else {
                    CacheService.setSiesByGiesHistory(vm.laborTimePresent.elemOpe);
                }
            }
            vm.popin.data = getLegendsEssai();
            
            var searchRedirectDetails = CacheService.getObject(CacheConstants.searchEngineDetails); 
            if(searchRedirectDetails && searchRedirectDetails.reference)
                scrollToNode(searchRedirectDetails.reference);
        }
        function searchEngineTM(tmElementList){ 
            if(!_.isEmpty(tmElementList)){
                vm.searchEngineData = DocPrivMetierService.getSearchEngineMd(); 
                if(!vm.searchEngineData || _.isEmpty(vm.searchEngineData.TmData)){
                blockUI.start();
                DocumentsMetierService.getIDsBySieElemOpe(tmElementList,["TM"]).then(function(resp){
                    _.assign(vm.searchEngineData, { TmData: resp })
                    DocPrivMetierService.setSearchEngineMd(vm.searchEngineData);
                    tmValidation(resp);
                }).finally(function () {
                    blockUI.stop();
                })
                }
                else {
                    tmValidation(vm.searchEngineData.TmData);
                }
            }
            showTmTitle();
            vm.screenshotButtonVisibility = AlertsService.getScreenshotButtonVisibility();
        }

        function tmValidation(resp){
            var tmIdList = [];
            if(!_.isEmpty(resp)){
                resp.forEach(function(item){
                    if(item.docs && !_.isEmpty(item.docs)){
                        item.docs.forEach(function(TMids){
                            if(TMids.subType === 'STANDARD' || TMids.subType === 'OTS'){
                                tmIdList.push(TMids.id);
                            }
                            
                        })
                    }
                })
            }
            if(!_.isEmpty(tmIdList)){
                vm.laborTimePresent = DocPrivMetierService.getLabourTimeResposne();
                if(!vm.laborTimePresent || _.isEmpty(vm.laborTimePresent)){
                blockUI.start();
                DocumentsMetierService.returnTmDocuments(tmIdList).then(function(response){
                    DocPrivMetierService.setLabourTimeResposne(response);
                    if(response){
                        processTMResponse(response);
                    }
                }).finally(function(){
                    vm.loading = false;
                    blockUI.stop();
                    if (vm.listOfTMDocuments) {
                        vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                    }
                })
                }
                else {
                    processTMResponse(vm.laborTimePresent);
                    vm.loading = false;
                    if (vm.listOfTMDocuments) {
                        vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                    }
                }
            } else{
                vm.listOfTMDocuments = [];
            }
        }

        
        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //get list TM documents, iconsEssai, operations list, elements list
        //using the TM list recieved by the service
        function initDocuments(list) {
            var sampleData = _.groupBy(list.TM, 'id');
            var tempList = [];
            var idFromArray = [];
            for (var i in arraySortOrder){
                if(sampleData[arraySortOrder[i]]){
                    idFromArray.push(arraySortOrder[i]);
                    tempList.push(sampleData[arraySortOrder[i]][0]);
                }
            }
            if(!_.isEmpty(idFromArray)){
                list.TM.forEach(function(item,index){                
                    if(idFromArray.includes(item.id))
                        delete list.TM[index];
                })
            }
            if(!_.isEmpty(tempList)){
                list.TM = tempList.concat(list.TM);
            }
            vm.listOfTMDocuments = list.TM;
            vm.listTMElements = list.elements;
            vm.listTMOperations = list.operations;
        }

        //get gies tm from NotIncluded and AdditionalTo Section foreach item in tm list
        //using the tm list
        function getGiesTM(tmList) {
            var giesList = [];
            if (tmList && tmList.length > 0) {
                tmList.forEach(function (tmItem) {
                    if(tmItem.detail.NotIncluded.length >0)
                        giesList = addToGieList(giesList, tmItem.detail.NotIncluded);
                    if(tmItem.detail.AdditionalTo.length >0)
                        giesList = addToGieList(giesList, tmItem.detail.AdditionalTo);
                });
            }

            return giesList;
        }

        //add gie to list if it doesn't exist in gieList
        //using giesList and NotIncluded or AdditionalTo sections
        function addToGieList(giesList, tmDetails) {
            var gieResult = giesList;
            if (tmDetails && tmDetails.length > 0) {
                tmDetails.forEach(function (tmItemDetail) {                    
                        gieResult.push({"element":tmItemDetail.element,"operation":tmItemDetail.operation});
                });
            }
            return gieResult;
        }

        //get sies by gies
        //using gies list
        function getSIesByGies(gies) {
            var newResp = {};
            return DocumentsMetierService.returnSiesByGies(gies).then(function (response) {
                if (response.error) {
                    toastr.error(response.error.value, response.error.type);
                }
                if (response && response.length > 0) {
                                   
                    response.forEach(function(item){
                        newResp[item.element+","+item.operation]=item.docs;
                    })
                    if (!_.isEmpty(vm.laborTimePresent)) {
                        vm.laborTimePresent.elemOpe = newResp;
                        DocPrivMetierService.setLabourTimeResposne(vm.laborTimePresent);
                    }
                    return newResp;
                } else{
                    return response;
                }
            });
        }

        //get icons essai
        //we use this cons to have a legend in Test column when survoling the column
        function getLegendsEssai() {
            var popinInfos = {};
            popinInfos.data = [{
                class: 'fa fa-play triangle positionIcon',
                txt: 'DOCUMENT_TM_FONCTIONNAL_TRY',
                opcode: '0145',
                time: 0.3,
            }, {
                class: 'fa fa-square positionIcon',
                txt: 'DOCUMENT_TM_SIMPLE_TRY',
                opcode: '0129',
                time: 0.5,
            }, {
                class: 'fa fa-square positionIcon outline-icon',
                txt: 'DOCUMENT_TM_EXTEND_TRY',
                opcode: '0130',
                time: 0.8
            }, {
                class: 'fa fa-circle positionIcon outline-icon',
                txt: 'DOCUMENT_TM_ON_BENCH',
            }];

            return popinInfos.data;
        }

        //we use this function to adjust the position of tm title when scrolling
        function showTmTitle() {
            $(window).scroll(function () {
                var position = $(window).scrollTop();
                var activateAtY = "360";

                if (position >= activateAtY) {
                    $('#tmTabView .documents-row-title').addClass('documents-scroll-in');
                }
                else {
                    $('#tmTabView .documents-row-title').removeClass('documents-scroll-in');
                }
            });
        }

        function openAlertsPopin(checkDocType) {
            var body = angular.element(document.body);
            $mdDialog.show({
                parent: body,
                templateUrl: 'app/components/products/documents/mr/documentaryAlertPop.template.html',
                controller: 'TMDocumentsCtrl',
                bindToController: true,
                controllerAs: 'vm',
            }).then(function (){
                AlertsService.setPopinVisibility(true, checkDocType, vm.listOfTMDocuments, vm.isTraceEnabled);

                if (AlertsService.getPopinVisibility().status == true) {
                    changeLinkColor("#TM_DOCUMENTARY_ERROR");
                }
            })
        }
        function close() {
            $mdDialog.cancel();
        }
        function onOk(){
            $mdDialog.hide();
             }
        function changeLinkColor(id) {
            $(id).css({
                'color': '#666666'
            });
        }

        function captureScreenshot() {
            blockUI.start();
            var node = document.body;
            html2canvas(node, {
                x: window.scrollX,
                y: window.scrollY,
                type: 'view'
            }).then(function (canvas) {
                vm.capturedImage = canvas.toDataURL();
                blockUI.stop();
                $mdDialog.show({
                    templateUrl: 'app/components/alerts/modal/screenShotModel/captureScreenshot.html',
                    controller: 'captureScreenshotController',
                    bindToController: true,
                    controllerAs: 'vm',
                    size: 'lg',
                    locals: {
                        capturedImage: vm.capturedImage
                    }
                });
            }).catch(function (error) {
                console.log("Error in htmlcanvas (tmDocumentsController):" + error);
            });
        }

        $scope.$on("$destroy", function () {
            AlertsService.setScreenshotButtonVisibility(false);
        });
        function scrollToNode(id) {
            setTimeout(function(){
                var selectedElement = $window.document.getElementById("TM_"+id);
                if (selectedElement) {
                    var container = selectedElement.getElementsByClassName('code');
                    var item = container[0].getElementsByClassName('code-text');
                    angular.element(item).addClass('landmark');
                }
                var anchor = selectedElement && $(selectedElement).length !== 0 ? $(selectedElement).offset().top - 50 : 0;
                $('html, body').animate({ scrollTop: anchor  }, 300);
            },300)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('tiresInformation', tiresInformation);

    /** @ngInject */
    function tiresInformation() {
        var directive = {
            templateUrl:'app/components/products/documents/tiresInformation/tiresInformation.template.html',
            controller: "TiresInformationController",
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                isTyre: '=',
                tiresInfo: '=tiresInfo'
            },
            bindToController: true,
        };
        return directive;
    }

})();
/**
 * Tires Information Controller
 * @namespace Controllers
 */
 (function () {
    'use strict';

    angular
        .module('phenix')
        .controller('TiresInformationController', TiresInformationController);

        function TiresInformationController($state,$mdDialog,$window,
            CacheService,CacheConstants){

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var levelsDoc = CacheService.getObject(CacheConstants.levelsDoc);
        vm.tiresInfo = (levelsDoc && !_.isEmpty(levelsDoc) &&
                            _.has(levelsDoc,'tyresInfo') && !_.isEmpty(levelsDoc.tyresInfo)) 
                            ? levelsDoc.tyresInfo[0] : [];
        vm.originalTiresInfo = [];
        vm.tyresData = angular.copy(vm.isTyre);

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.openImage = openImage;
        vm.openImageInNewTab = openImageInNewTab;
        vm.onClose = onClose;

        this.$onInit = function () {
            if(vm.tyresData){
                vm.tiresInfo = vm.locals && vm.locals.tiresInfo ? vm.locals.tiresInfo : '';
            }
            if($state.params.data){
                vm.tyresData = false;
                vm.tiresInfo = $state.params.data.tyresInfo[0];
            }

                if(vm.tiresInfo && !_.isEmpty(vm.tiresInfo) && _.has(vm.tiresInfo, 'axleInfo') && !_.isEmpty(vm.tiresInfo.axleInfo)){

                    if(_.has(vm.tiresInfo.axleInfo, 'sameTyre') && !_.isEmpty(vm.tiresInfo.axleInfo.sameTyre)){
                        vm.originalTiresInfo.push(
                            {
                            tireSize : _.has(vm.tiresInfo,'tyres') ? (_.has(vm.tiresInfo.tyres,'front') ? vm.tiresInfo.tyres.front : (_.has(vm.tiresInfo.tyres,'rear') ? vm.tiresInfo.tyres.rear : null)) : null,
                            parts : vm.tiresInfo.axleInfo.sameTyre.parts,
                            axle : vm.tiresInfo.axleInfo.sameTyre.axle

                        });
                    }else{
                        vm.originalTiresInfo.push(
                            {
                            tireSize : _.has(vm.tiresInfo,'tyres') ? (_.has(vm.tiresInfo.tyres,'front') ? vm.tiresInfo.tyres.front : null) : null,
                            parts : (_.has(vm.tiresInfo.axleInfo,'front')  && _.has(vm.tiresInfo.axleInfo.front,'parts') && !_.isEmpty(vm.tiresInfo.axleInfo.front.parts)) ? vm.tiresInfo.axleInfo.front.parts : [],
                            axle : (_.has(vm.tiresInfo.axleInfo,'front')  && _.has(vm.tiresInfo.axleInfo.front,'axle')) ? vm.tiresInfo.axleInfo.front.axle : null

                        });

                        vm.originalTiresInfo.push(
                            {
                            tireSize : _.has(vm.tiresInfo,'tyres') ? (_.has(vm.tiresInfo.tyres,'rear') ? vm.tiresInfo.tyres.rear : null) : null,
                            parts : (_.has(vm.tiresInfo.axleInfo,'rear')  && _.has(vm.tiresInfo.axleInfo.rear,'parts') && !_.isEmpty(vm.tiresInfo.axleInfo.rear.parts)) ? vm.tiresInfo.axleInfo.rear.parts : [],
                            axle : (_.has(vm.tiresInfo.axleInfo,'rear')  && _.has(vm.tiresInfo.axleInfo.rear,'axle')) ? vm.tiresInfo.axleInfo.rear.axle : null

                        });
                    }
                }
            

        }

        function onClose() {
            $mdDialog.hide();
        }

        function openImage(url, isTyre){
            var body = angular.element(document.body);
            $mdDialog.show({
                parent: isTyre ? document.getElementsByClassName('md-dialog-container') : body,
                skipHide: true,
                multiple:true,
                template:'<img src='+url+ ' height="350" width="350" alt=""/>',
                clickOutsideToClose: true
            });
        }

        function openImageInNewTab(url){
           var wdw =  $window.open('', '_blank');
           wdw.document.write(
               ' <html> ' +
               ' <head> ' +
               ' </head> ' +
               ' <body> ' +
                   ' <img src='+url+' alt="" height="100%" width="500" style="margin-left:auto;margin-right:auto;display:block;"> ' +
               ' </body> ' +
               ' </html> ' 
            );
        }





    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('PDFViewService', PDFViewService);

    /** @ngInject */
    function PDFViewService() {
        var vm = this;
        vm.getTableData = getTableData;
        vm.getProcessedDataArray = getProcessedDataArray;
        function getTableData(tableData, isHeader) {
            var columns = [];
            var finalData = [];
            for (var key in tableData[0]) {
                columns.push({ text: key, style: "tableHeader" });
            }
            if (isHeader) {
                finalData.push(columns);
            }
            angular.forEach(tableData, function (row) {
                var tableBody = [];
                columns.forEach(function (column) {
                    if (row[column.text].type == 'image') {
                        var dummyArray = [];
                        if (!_.isEmpty(row[column.text].data)) {
                            row[column.text].data.forEach(function (img) {
                                dummyArray.push({ image: img.value, width: 15, style: "tableIconStyle" });

                            })
                            if (dummyArray.length <= 3) {
                                tableBody.push({ ul: [{ columns: _.slice(dummyArray, 0, 3), columnGap: 4 }] });
                            } else {
                                tableBody.push({ ul: [{ columns: _.slice(dummyArray, 0, 3), columnGap: 4 }, { columns: _.slice(dummyArray, 3, dummyArray.length), columnGap: 4 }] })
                            }
                            //tableBody.push({columns:dummyArray,columnGap:4})
                        }
                        else
                            tableBody.push({ text: '', style: "tableTextStyle", alignment: 'left' });
                    }else if (row[column.text].type == 'list') {
                        var columnList = [];
                        if (row[column.text].data.codifiedSigns) {
                            columnList.push({ ul: row[column.text].data.codifiedSigns, type: 'none', style: "tableTextStyle" });
                        }
                        if (!_.isEmpty(row[column.text].data.simplifiedResidual)) {
                            row[column.text].data.simplifiedResidual.forEach(function (item) {
                                columnList.push({ text: item.label, style: "tableListTextStyle", alignment: 'left' });
                                columnList.push({ ul: item.value, style: "tableTextStyle" });
                            })
                        }
                        tableBody.push({ ul: columnList, type: 'none' })
                    } else if (row[column.text].type == 'bigImage') {
                        tableBody.push({ image: row[column.text].data, width: 70, style: "tableIconStyle" });
                    } else if (row[column.text].type == 'smallImage') {
                        tableBody.push({ image: row[column.text].data, width: 15, style: "tableIconStyle" });
                    } else {
                        tableBody.push({ text: row[column.text].data, style: "tableTextStyle", alignment: row[column.text].alignment, colSpan: row[column.text].colspan, rowSpan: row[column.text].rowSpan });
                    }
                })
                finalData.push(tableBody);
            })
            return finalData;
        }
        function getProcessedDataArray(finalArr, dataArray, isSpecialTool, isVehicleMaint,isListePiece,isWDImage,isDocpriv) {
            angular.forEach(dataArray, function (item) {
                switch (item.type) {
                    case 'columns':
                        if(isVehicleMaint){
                            angular.forEach(item.values, function (k, v) {
                                var firstArr = [];
                                firstArr.push({ text: k[0], width: 400, style: item.styles });
                                firstArr.push({ text: k[1], width: '*', style: item.styles });
                                finalArr.push({ columns: firstArr })
                            });
                        } else if (isWDImage){
                            angular.forEach(item.values, function (k, v) {
                                var firstArr = [];
                                firstArr.push({ text: k[0], width: 600, style: item.styles });
                                finalArr.push({ columns: firstArr });
                            });
                        } else if (isListePiece) {
                            if (item && item.values && Object.keys(item.values).length == "2") {
                                var firstArr = [];

                                firstArr.push({ text: item.values[0].toString(), width: '*', style: "textStyle3" },
                                    { text: item.values[1].toString(), width: '*', style: item.styles });

                                finalArr.push({ columns: firstArr });
                            }
                            else {

                                angular.forEach(item.values, function (k, v) {
                                    var firstArr = [];
                                    firstArr.push({ text: k[0], width: '*', style: item.styles });
                                    finalArr.push({ columns: firstArr });
                                });
                            }

                        } else {
                            angular.forEach(item.values, function (k, v) {
                                var firstArr = [];
                                firstArr.push({ text: k[0], width:'*' , style: item.styles });
                                firstArr.push({ text: k[1], width:'*' , style: item.styles });
                                finalArr.push({ columns: firstArr });
                            });    
                        }
                        break;
                    case 'imageColumns':
                            var firstArr = [];
                            firstArr.push({ image: item.values[0][0], width: 50, style: item.styles });
                            firstArr.push({ text: item.values[1][0], alignment: 'right', style: item.styles });
                            finalArr.push({ columns: firstArr })
                        break;
                    case 'componentTable':
                        finalArr.push({
                            table: { widths: item.widths, body: item.values, dontBreakRows: true }, style: item.styles,
                            layout: item.layout
                        });
                        break;
                    case 'table':
                       if(isDocpriv || isListePiece) {
                            finalArr.push({
                                table: { widths: item.widths, body: item.values, dontBreakRows: false }, style: item.styles,
                                layout: item.layout
                            });
                        } else {
                            finalArr.push({
                                table: { widths: item.widths, body: item.values, dontBreakRows: true }, style: item.styles,
                                layout: item.layout
                            });
                        }
                        break;
                    case 'image':
                        if(isListePiece){
                            finalArr.push({ svg: item.values.outerHTML, fit: [500, 500], alignment: 'center' });
                        }
                        else {
                            if(item.isOuterHtml)
                                finalArr.push({ svg: item.values.outerHTML, width: 400, alignment: 'center', margin: [0, 5, 0, 5] });
                            else
                                finalArr.push({ svg: item.values, width: 400, alignment: 'center', margin: [0, 5, 0, 5] });
                        }
                        break;
                    case 'componentImage':
                            finalArr.push({ image: item.values, alignment: 'center', width:item.width});
                        break;
                    case 'wdimage':
                        finalArr.push({ svg: item.values.outerHTML, fit: [650], alignment: 'left' }); break;
                    case 'wdimagebig':
                        finalArr.push({ svg: item.values, fit: [650], alignment: 'left' }); break;
                    case 'pngimage':
                        finalArr.push({image:item.values,width:80,margin: [0,-37, 0, 0],alignment:'right'});
                        break;
                    case 'pngimagecomponent':
                        finalArr.push({image:item.values,width:500,alignment:'left'});
                        break;
                    case 'rgpd':
                        angular.forEach(item.values, function (k, v) {
                            var firstArr = [];
                            firstArr.push({ text: k[0], width: '500', style: item.styles });
                            finalArr.push({ columns: firstArr });
                        }); 
                        break;
                    case 'text':
                        finalArr.push({ text: item.values, style: item.styles });
                        break;
                    default:
                        break;
                }
            });
            return finalArr;
        }
    }

})();

/**
 * NavigationSie Service
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('NavigationSieService', NavigationSieService);

    /**
     * @namespace NavigationSieService
     * @desc Navigation between SIE documents (MR, MD or BT)
     * @memberOf Services
     */
    function NavigationSieService(CacheService, RoutesConstants,$window, CacheConstants, $rootScope, $state,$timeout) {

        /*********************
         *  FUNCTIONS
         ********************/
        this.updateDocumentsHistory = updateDocumentsHistory;
        this.backToPreviousDocument = backToPreviousDocument;
        this.goToFirstElement = goToFirstElement;
        this.backToPrevious = backToPrevious;
  

        /**
         * @name updateDocumentsHistory
         * @desc Update documents histroy while navigate between sie documents
         * @param {String} id document sie's identifier
         * @param {String} sieType document sie's type, could be MR, MD or BT
         * @returns {array} history of sie navigation
         * @memberOf Services.NavigationSieService
         */
        function updateDocumentsHistory(id, sieType, plateIndex, refIndex, prMRLinked, docDetails, tabName) {
            var documents = CacheService.getSieDocumentsHistory() || [];
            /*var selectedSie ={
               type: sieType,
               data: { 'myRef': id , "plateIndex": plateIndex, "refIndex": refIndex},
               origin: $rootScope.previousState
            };*/

            var previousRef = getPreviousReference(documents);
            var data = {};
            data.myRef= id;
            var previousElement = documents[documents.length - 1];
            if(previousRef ==  data.myRef ){
            {
                 previousRef = previousElement.previousDocument;
            }
           return previousRef;
        }
            if(plateIndex && refIndex){
                data.plateIndex = plateIndex;
                data.refIndex = refIndex;
            }

            if(docDetails){
                data.docDetails = docDetails;
            }
            
            var selectedSie = {
                type: (prMRLinked && sieType != "INT_REPAIR") ? "PR" : sieType,
                data: data,
                origin: $rootScope.previousState,
                previousDocument: previousRef,
                tabName: tabName
            };

             if (!checkSieExist(documents, selectedSie)) {
                 documents.push(selectedSie);
         }
         
            CacheService.setSieDocumentsHistory(documents);

            return documents;
        }

        /**
         * @name backToPreviousDocument
         * @desc redirect the user to the previous sie document and delete the last document form cache
         * @returns {array} history of sie navigation updated
         * @memberOf Services.NavigationSieService
         */
        function backToPreviousDocument() {

            var documents = CacheService.getSieDocumentsHistory() || [];
            var systemDocDetails = CacheService.getObject(CacheConstants.systemDocDetails);
            var treeInformations = {};
            if (documents.length > 1) {
                var lastVisitedDocument = documents.pop();
                if (lastVisitedDocument) {
                    CacheService.setSieDocumentsHistory(documents);
                    if($rootScope.isIndependentUser){
                        window.history.back();
                    }else if(lastVisitedDocument && lastVisitedDocument.origin === RoutesConstants.product){
                        treeInformations = getPlateAndReference(documents);
                        $state.go(lastVisitedDocument.origin, { reference: lastVisitedDocument.previousDocument, plateIndex: treeInformations.plateIndex, refIndex: treeInformations.refIndex });
                    }else{
                        let targetDocument = documents[documents.length - 1];
                        let stateParams = { id: lastVisitedDocument.previousDocument };
                        if (targetDocument && targetDocument.data && !_.isNil(targetDocument.data.docDetails)) {
                                stateParams.symptomNumbers = targetDocument.data.docDetails;
                        }
                        $state.go(lastVisitedDocument.origin, stateParams);
                    }
                }
            }
            
            else if (documents.length == 1) {
                treeInformations = getPlateAndReference(documents);

                var lastVisitedDocument = documents.pop();
                if (lastVisitedDocument) {
                    CacheService.cleanSieDocumentsHistory();
                    if (lastVisitedDocument && lastVisitedDocument.origin === RoutesConstants.carSearchResult && systemDocDetails && systemDocDetails.isSystemDocEnable) {
                        $state.go(lastVisitedDocument.origin, { data: { traficDiagSymp: true } });
                    }else if(lastVisitedDocument && (lastVisitedDocument.origin === RoutesConstants.product || lastVisitedDocument.origin === RoutesConstants.documentBTListDoc)){
                        $window.history.back(); 
                    }
                    else {
                        $state.go(lastVisitedDocument.origin, { documentType: lastVisitedDocument.type, plateIndex: treeInformations.plateIndex, refIndex: treeInformations.refIndex, tabName: lastVisitedDocument.tabName });
                    }
                }
            }
        }




        function backToPrevious() {
            if( $state.params.plateIndex != null &&  $state.params.refIndex != null){
                var documents = CacheService.getSieDocumentsHistory() || [];
                var treeInformations = {};
                if (documents.length > 1) {
                    var lastVisitedDocument = documents.pop();
                    if (lastVisitedDocument) {
                        CacheService.setSieDocumentsHistory(documents);
                        $state.go(lastVisitedDocument.origin, { reference: lastVisitedDocument.previousDocument });
                    }
                }
            
                else if (documents.length == 1) {
                    treeInformations = getPlateAndReference(documents);
                    if(CacheService.getObject(CacheConstants.searchEngineDetails)){
                        $state.go(RoutesConstants.listePieceViews, {
                            data : CacheService.getObject(CacheConstants.levelsDoc)
                        });
                    }
                    else{
                        var lastVisitedDocument = documents.pop();
                        if (lastVisitedDocument) {
                            CacheService.cleanSieDocumentsHistory();
                            $state.go(lastVisitedDocument.origin, { documentType: lastVisitedDocument.type, plateIndex: treeInformations.plateIndex, refIndex: treeInformations.refIndex });                    
                        }
                    }
                }
            } else if($state.params.isFromDocPriv){
                $state.go(RoutesConstants.docprivData,{isFromProductSheet : true});
            }
            else{
                $window.history.back(); 
            
            }
        }
    
       
        /********************
         *      TOOLS
         *******************/

        //Redirect the user to the first selected sie
        //and delete the sie history navigation from cache
        function goToFirstElement() {

            var documents = CacheService.getSieDocumentsHistory() || [];
            var systemDocDetails = CacheService.getObject(CacheConstants.systemDocDetails); 
            var treeInformations = {};
            if (documents.length >= 1) {
                var firstElement = documents[0];
                if (firstElement) {
                    treeInformations = getPlateAndReference(documents);
                    CacheService.cleanSieDocumentsHistory();
                    if (systemDocDetails && systemDocDetails.isSystemDocEnable) {
                        $state.go(firstElement.origin, { data: { traficDiagSymp: true } });
                    } else if(firstElement.origin === RoutesConstants.product){
                        $state.go(firstElement.origin, { reference: firstElement.previousDocument, plateIndex: treeInformations.plateIndex, refIndex: treeInformations.refIndex });
                    }else {
                        $state.go(firstElement.origin, { documentType: firstElement.type, plateIndex: treeInformations.plateIndex, refIndex: treeInformations.refIndex });
                    }
                }
            }
        }
 

        //get current plate and reference
        function getPlateAndReference(documents) {
            var result = {};
            if (documents[0] && documents[0].data && documents[0].data.plateIndex) {
                result.plateIndex = documents[0].data.plateIndex;
                result.refIndex = documents[0].data.refIndex;
            }
            return result;
        }

        //Check if document sie exist
        //we have to get once the same reference with the same type
        function checkSieExist(documents, selectedSie) {

            var sieExist = false;

            if (documents.length > 0) {
                documents.forEach(function (document) {
                    if (document.data.myRef == selectedSie.data.myRef && document.type == selectedSie.type && document.type != 'PR') {
                        sieExist = true;
                    }
                });
            }

            return sieExist;

        }

        //Get previous document sie's reference
        function getPreviousReference(documents) {

            var previousRef = null;
            if (documents.length >= 1) {
                var previousElement = documents[documents.length - 1];
                previousRef = previousElement.data.myRef;
            }

            return previousRef;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DocumentsWsService', DocumentsWsService);

    /** @ngInject */
    function DocumentsWsService($http, $q, CarSearchConstants,
        DocumentSearchConstants, CacheService, RestUpgrade,
        $translate, UtilsMetierService, CloudFrontUrlHelper) {

        this.getPRlight = getPRlight;
        this.getNodePR = getNodePR;
        this.getNodeProducts = getNodeProducts;
        this.getDocument = getDocument;
        this.getLabourTime = getLabourTime;
        this.getSVG = getSVG;
        this.getMRList = getMRList;
        this.getSVG2 = getSVG2;
        this.getWDSVG = getWDSVG;
        this.getMRDetail = getMRDetail;
        this.getMDList = getMDList;
        this.getMDListFromArbo = getMDListFromArbo;
        this.getMDDetail = getMDDetail;
        this.getBTDetail = getBTDetail;
        this.getBTPdf = getBTPdf;
        this.getSiePdfContent = getSiePdfContent;
        this.getSiePdfContentFromClip = getSiePdfContentFromClip;
        this.getSiesByGies = getSiesByGies;
        this.getTmDocuments = getTmDocuments;
        this.getTmDocumentsByOpeCode = getTmDocumentsByOpeCode;
        this.getBTByRef = getBTByRef;
        this.getNTByRef = getNTByRef;
        this.getNodePlates = getNodePlates;
        this.getPlateLines = getPlateLines;
        this.plateLines = {};
        this.getElementsByGenericParts=getElementsByGenericParts;
        this.getIDsBySieElemOpe=getIDsBySieElemOpe;
        this.getPartsByGenericParts=getPartsByGenericParts;

        /**
         * getLabourTime.
         * @param {request} request.
         * @return {promise}
         * usage getLabourTime(request)
         */
        function getLabourTime(request) {
            var defer = $q.defer();
            RestUpgrade.one(DocumentSearchConstants.labourTime).post('', request).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        /**
         * getNode.
         * @param {request} request.
         * @return {promise}
         * usage getNode(request)
         */
        function getNodePR(body) {
            var endpoint = CarSearchConstants.documentationNode;

            return RestUpgrade.all(endpoint).post(body);
        }

        /**
         * getNodePlates.
         * @param {request} request.
         * @return {promise}
         * usage getNodePlates(request)
         */
        function getNodePlates(body) {
            var defer = $q.defer();
            var endpoint = CarSearchConstants.platesNode;

            RestUpgrade.all(endpoint).post(body).then(function(res){

                defer.resolve(res);

            }).catch(function(){

                defer.reject($translate.instant('PR_SERVICE_ERROR'));

            });

            return defer.promise;
        }

        /**
         * getPlateLines.
         * @param {request} request.
         * @return {promise}
         * usage getPlateLines(request)
         */
        function getPlateLines(body) {

            var defer = $q.defer();
            const self = this;

            var endpoint = CarSearchConstants.plateLines;

            RestUpgrade.all(endpoint).post(body).then(function(res){

                defer.resolve(res);
                self.plateLines = res;

            }).catch(function(){

                defer.reject($translate.instant('LINES_SERVICE_ERROR'));

            });

            return defer.promise;
        }


        function getElementsByGenericParts(body) {


            var defer = $q.defer();

            var endpoint = CarSearchConstants.elementsByGenericParts;

            RestUpgrade.all(endpoint).post(body).then(function(res){

                defer.resolve(res);

            }).catch(function(error){

                defer.reject(error);

            });

            return defer.promise;
        
            
        }
        function getIDsBySieElemOpe(body) {


            var defer = $q.defer();

            var url = DocumentSearchConstants.Elemope;

            RestUpgrade.all(url).post(body).then(function(res){

                defer.resolve(res);

            }).catch(function(error){

                defer.reject(error);

            });

            return defer.promise;
        
            
        }
        function getPartsByGenericParts(request) {
            var defer = $q.defer();
            RestUpgrade.one(DocumentSearchConstants.partsByGenericParts).post('', request).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getNodeProducts(body) {
            var endpoint = CarSearchConstants.productsNode;

            return RestUpgrade.all(endpoint).post(body);
        }

      //get paged and transeversalProducts
        function getNodeProducts(transeversalPartsReq, gradePartsReq, functionalId) {
            var defer = $q.defer();
            if(!_.isEmpty(transeversalPartsReq.documentsId) && functionalId){
                $q.all([
                    getTranseversalProducts(transeversalPartsReq,functionalId)
                ]).then( function(response){
                    defer.resolve(response)
                }).catch(function(error){
                    defer.reject(error);
                });
                return defer.promise;
            }
            if(!_.isEmpty(gradePartsReq) && gradePartsReq.paginationStartAfterId && gradePartsReq.paginationStartAfterId.technicalId != 'ENDOFLIST') {
                $q.all([getPagedProducts(gradePartsReq)
                ]).then(function(response){
                    defer.resolve(response)
                }).catch(function(error){
                    defer.reject(error);
                });
                return defer.promise;
            }

            if (!_.isEmpty(transeversalPartsReq.documentsId)) {
                $q.all([
                    getTranseversalProducts(transeversalPartsReq),
                    getPagedProducts(gradePartsReq)
                ]).then(function (response) {
                    defer.resolve(response);
                }).catch(function(error){
                    defer.reject(error);
                });

                return defer.promise;
            }
            else {
                $q.all([
                    getPagedProducts(gradePartsReq)
                ]).then(function (response) {
                    defer.resolve(response);
                }).catch(function(error){
                    defer.reject(error);
                });

                return defer.promise;
            }
        }

        function getPagedProducts(body) {
            var endpoint = CarSearchConstants.productsNode;

            return RestUpgrade.all(endpoint).post(body);
        }


        function getTranseversalProducts(body, functionalId) {
            
            var endpoint = !functionalId ? CarSearchConstants.transeversalNodes+"?limit=200" : CarSearchConstants.transeversalNodes+"?lastId="+functionalId+"&limit=200";

            return RestUpgrade.all(endpoint).post(body);
        }
      
        /**
         * getDocument.
         * @param {request} request.
         * @return {promise}
         * usage getNode(request)
         */
        function getDocument(request) {
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.document).post('', request).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }


        /**
         * getSVG.
         * @param {request} request.
         * @param {id}
         * @return {promise}
         * usage getNode(request)
         */
        function getSVG(id, request) {
            return $http.get(request, {
                withCredentials: true
            })
        }

        /**
         * selectTab.
         * @param {string} url.
         * @return {data}
         * usage getSVG2(url)
         */
        function getSVG2(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (res) {
                return res.data;
            });
        }

        function getWDSVG(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (res) {
                const size = res.headers('Content-Length');
                return {
                    data: res.data,
                    size: size
                };
            });
        }

        /**
         * selectTab.
         * @param {string} request.
         * @return {data}
         * usage getMRList(request)
         */
        function getMRList(params) {
            //var url = DocumentSearchConstants.MRDocumentList;
            var listMr = [];
            return getResultMr(listMr, params);
        }

        function getResultMr(listMr, params, url){
            var endpoint = (!url) ? DocumentSearchConstants.MRDocumentList +'?limit=20' : '/proxy/apidh/rest/v1/' + url;
            return RestUpgrade.all(endpoint).post(params).then(function (response) {
                listMr = listMr.concat(response.MR);
                if (response.errors) {
                    return $q.reject(response.errors);
                } else if (response.next_url) {
                    return getResultMr(listMr, params, response.next_url);
                }
                else{
                    return listMr;
                }
            }).catch(function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);                
            });
        }

        function getTmDocuments(request) {
            var url = DocumentSearchConstants.labourTimes;
            return RestUpgrade.all(url).post(request);
        }

        function getTmDocumentsByOpeCode(request) {
            var url = DocumentSearchConstants.opeCode;
            return RestUpgrade.all(url).post(request);
        }

        /**
         * @desc Fetch array of PR by ID
         * @param {Object} bodyRequest
         * @return {Promise<Array<Object>}
         */

        function getPRlight(bodyRequest) {
            var endpoint = DocumentSearchConstants.prLight
            return RestUpgrade.all(endpoint).post(bodyRequest).then(function(response) {
                return response.PRODUCTS
            });
        }

        function getBTByRef(request) {
            var url = CarSearchConstants.technicalBulletins;
            return RestUpgrade.all(url).post(request);
        }

        function getNTByRef(request) {
            var url = CarSearchConstants.technicalNotes;
            return RestUpgrade.all(url).post(request);
        }

        /**
         * getMRDetail.
         * @param {string} idMr.
         * @param {String} request.
         * @return {promise}
         * usage getMRDetail(request)
         */
        function getMRDetail(idMr) {
            var url = DocumentSearchConstants.MRDocumentDetail;
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            return RestUpgrade.one(url + idMr).post('', { carContext: carContext, userContext: userContext }).then(function (response) {
                if (response) {
                    if (response.content) {
                        response.content = CloudFrontUrlHelper.sanitizeContent(response.content);
                    }
                    return response;
                } else {
                    return $q.reject({
                        error: {
                            value: 'DOCUMENT_NOT_FOUND',
                            type: 'warning'
                        }
                    });
                }
            }, function () {
                return $q.reject({
                    error: {
                        value: 'DOCUMENT_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });
        }


        /**
        * Get List of MD
        * @param {Object} params - List of subTypes used to filter MDs
        * @returns {Object} - list of MD corresponding to the search params
        */
        function getMDList(params, listMD) {
            var typeMD = CacheService.getCarContext().typeMD;
            var url;

            if (typeMD === "B3" || typeMD === "ADT") {
                url = DocumentSearchConstants.MDDocumentList;
                return getResultMd(url, listMD, params);
            } else if (typeMD === "B2") {
                url = DocumentSearchConstants.MDBookmarksDocumentList;
                return getResultMd(url, listMD, params);
            } else if (typeMD === "B2-3") {
                url = DocumentSearchConstants.MDDocumentList;
                return getResultMd(url, listMD, params).then(function (res) {
                    url = DocumentSearchConstants.MDBookmarksDocumentList;
                    return getResultMd(url, listMD, params).then(function (response2) {
                        var tab = { MD: res.MD.concat(response2.MD)};
                        return tab;
                    });
                });
            }
        }

        function getResultMd(url,listMD, params){

            return RestUpgrade.one(url).post('', params).then(function (response) {
                listMD = listMD.concat(response.MD);
                if (response.errors) {
                    return $q.reject(response.errors);
                } else if (response.next_url) {
                    return getResultMd('/proxy/apidh/rest/v1/' + response.next_url, listMD, params);
                } else {
                    return { MD: listMD };
                }
            }).catch(function (msg) {
                return $q.reject(msg.data.errors[0].errorMessage);                
            });
        }

        /**
        *   DEPRECATED COULD BE REMOVE
        * Get List of MD
        * @param {Object} params - List of subTypes used to filter MDs
        * @returns {Object} - list of MD corresponding to the search params
        */
        function getMDListFromArbo(params, node) {
            var url = DocumentSearchConstants.MDDocumentList;
            return RestUpgrade.one(url).post('', params).then(function (response) {
                if (response) {
                    return response;
                } else {
                    return $q.reject();
                }
            }, function (error) {
                return error;
            });
        }

        /**
        * getMDDetail.
        * @param {string} idMd.
        * @return {promise}
        * usage getMDDetail(request)
        */
        function getMDDetail(idMd, request) {
            var url = DocumentSearchConstants.MDDocumentDetail;
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            return RestUpgrade.one(url + idMd).post('' , { carContext: carContext, userContext: userContext }).then(function (response) {
                if (response) {
                    if (response.content) {
                        response.content = CloudFrontUrlHelper.sanitizeContent(response.content);
                    }
                    return response;
                } else {
                    return $q.reject({
                        error: {
                            value: 'DOCUMENT_NOT_FOUND',
                            type: 'warning'
                        }
                    });
                }
            }, function (error) {
                return $q.reject({
                    error: {
                        value: 'DOCUMENT_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });

        }

        function getBTDetail(idBT,request){
            var url = DocumentSearchConstants.BTDocumentDetail;
            const userContext = CacheService.getUserContext();
            const carContext = CacheService.getCarContext();
            const btDetails = (request && request.btDocumentDetails) ? request.btDocumentDetails : null;
            return RestUpgrade.one(url + idBT).post('', { carContext: carContext, userContext: userContext ,btDetails : btDetails}).then(function (response) {
                if (response) {
                    return response;
                }
            }, function (error) {
                return $q.reject({
                    error: {
                        value: 'DOCUMENT_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });
        }

        function getBTPdf(idBT, request) {
            const url = `${DocumentSearchConstants.BTDocumentDetail}${idBT}/pdf`;
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var btDetails = (request && request.btDocumentDetails) ? request.btDocumentDetails : null;
            
            return RestUpgrade.one(url).withHttpConfig({
                responseType: 'arraybuffer',
                headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            }).post('', { 
                carContext,
                userContext,
                btDetails
            }).then(function (response) {
                return new Blob([new Uint8Array(response)], { type: 'application/pdf' });
            }, function (_error) {
                return $q.reject({
                    error: {
                        value: 'ERROR',
                        type: 'error'
                    }
                });
            });
        }

        function getSiePdfContent(id, request){
            var url = DocumentSearchConstants.SieDocumentContentPdf;
            
            return RestUpgrade.one(url).post('', request).then(function (response) {
                if (response) {
                    return response;
                }
            }, function (error) {
                return $q.reject({
                    error: {
                        value: 'DOCUMENT_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });
        }

        /**
         * @name getSiePdfContentFromClip
         * @desc call sie pdf content from clip
         * @param {object} request
         */
        function getSiePdfContentFromClip(request){
            var url = DocumentSearchConstants.SieDocumentContentPdfClip;

            return RestUpgrade.one(url).post('', request).then(function (response) {
                if (response) {
                    return response;
                }
            }, function (error) {
                return $q.reject({
                    error: {
                        value: 'DOCUMENT_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });
        }

        function getSiesByGies(request){
            var url = DocumentSearchConstants.Elemope;

            return RestUpgrade.one(url).post('', request).then(function (response) {
                if (response) {
                    return response;
                }
            }, function (error) {
                return $q.reject({
                    error: {
                        value: 'SIES_NOT_FOUND',
                        type: 'warning'
                    }
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DocumentsMetierService', DocumentsMetierService);

    /** @ngInject */
    function DocumentsMetierService(
        $q,
        $rootScope,
        $state,
        $window,
        searchByTextsIdsMertierService,
        toastr,
        $translate,

        DocumentsWsService,
        DealerManagerSystemeService,
        ProductWsService,
        CacheService,
        DmsMetierService,

        DmsConstants,
        RoutesConstants,
        CacheConstants,
        configConstantes,
        ListPieceConstants,
        CarSearchConstants,
        MainMetierService,
        $location,DocPrivConstants) {

        this.getPRLight = getPRLight;
        this.getPR = getPR;
        this.getProducts = getProducts;
        this.returnSIEDocuments = returnSIEDocuments;
        this.getNodeInCache = getNodeInCache;
        this.getLabourTimeFromID = getLabourTimeFromID;
        this.returnSVG = returnSVG;
        this.returnMRDetail = returnMRDetail;
        this.getMDList = getMDList;
        this.getMDListFromArbo = getMDListFromArbo;
        this.returnMDDetail = returnMDDetail;
        this.returnBTDetail = returnBTDetail;
        this.getBTPdf = getBTPdf;
        this.returnSiePdfContent = returnSiePdfContent;
        this.returnSiePdfContentFromClip = returnSiePdfContentFromClip;
        this.returnSiesByGies = returnSiesByGies;
        this.returnTmDocuments = returnTmDocuments;
        this.returnTmDocumentsByOpeCode = returnTmDocumentsByOpeCode;
        this.returnBTByRef = returnBTByRef;
        this.returnNTByRef = returnNTByRef;
        this.displayBtDetails = displayBtDetails;
        this.displayBtListDetails = displayBtListDetails;
        this.displayBtDetailsRds = displayBtDetailsRds;
        this.displayNtDetails = displayNtDetails;
        this.createMDParams = createMDParams;
        this.getReferencesInformations = getReferencesInformations;
        this.getTmInformation = getTmInformation;
        this.getPlates = getPlates;
        this.getPlateLines = getPlateLines;
        this.getElementsByGenericParts=getElementsByGenericParts;
        this.getIDsBySieElemOpe=getIDsBySieElemOpe;
        this.customCompareBrands = customCompareBrands;
        this.brandAgeAcceptable = brandAgeAcceptable;
        this.getPartsByGenericParts=getPartsByGenericParts;
        this.filterSelectedIds = filterSelectedIds;
        this.displayBtDetailsDab = displayBtDetailsDab;


        /**
         * @name getReferencesInformations
         * @desc call dms / datahub to get reference informations
         */
        function getReferencesInformations(references) {
            //call dms response (reference.v1)
            //add isCompleted field foreach piece to check if it is know or not by dms
            return DmsMetierService.getReferencesDms(references).then(function (dmsResponse) {
                var data = [];
                if (dmsResponse.returnCode === 0 && dmsResponse.response && dmsResponse.response.parts.length > 0) {
                    data = dmsResponse.response.parts.map(function (partItem) {
                        var stock = "-";
                        var cort = "-";
                        var isKnownDms = false;
                        var isLocalPiece = false;
                        if (partItem.availabilities && partItem.availabilities.length > 0) {
                            stock = partItem.availabilities[0].quantity;
                        }
                        if (partItem.cort) {
                            cort = partItem.cort.slice(-1);
                            isKnownDms = true;
                        }
                        var isCompleted = false;
                        if (partItem.description != "" && partItem.priceExclTaxes != "") {
                            isCompleted = true;
                        }

                        //we add this proprety to know if we let user to go to product page (if local, he can't)
                        if (partItem.reference >= DmsConstants.localPiece.min && partItem.reference <= DmsConstants.localPiece.max) {
                            isLocalPiece = true;
                        }
                        return {
                            reference: partItem.reference,
                            designation: partItem.description,
                            price: partItem.priceExclTaxes,
                            stock: stock,
                            cort: cort,
                            isLocalPiece: isLocalPiece,
                            isCompleted: isCompleted,
                            isKnownDms: isKnownDms,
                            isDeposit : partItem.depositReference != "" ? true : false,
                            depositReference: partItem.depositReference, 
                            dmsInformations: {
                                quantity: stock,
                                priceExclTaxes: partItem.priceExclTaxes
                            },
                            // dmsInformations : this property is required for shoppingCartQuote component
                        }
                    });
                }

                return data;
            }).then(function (dmsResponse) {
                //search only references with not completed informations (designation or price don't exist)
                //and call datahub for them (isCompleted is equal to false)
                var notCompletedReferences = _.filter(dmsResponse, ['isCompleted', false]).map(function (notCompletedItem) {
                    return notCompletedItem.reference;
                });
                //if we have not completed references
                //call datahub with references
                //and replace not existing designation or price by datahub informations
                if (notCompletedReferences.length > 0) {
                    return getPRLight(notCompletedReferences).then(function (datahubResponse) {
                        var data = dmsResponse.map(function (currentItem) {
                            if (currentItem.isCompleted || _.isEmpty(datahubResponse)) {
                                return {
                                    reference: currentItem.reference,
                                    designation: currentItem.designation,
                                    price: currentItem.price,
                                    stock: currentItem.stock,
                                    cort: currentItem.cort,
                                    isLocalPiece: currentItem.isLocalPiece,
                                    isKnownDms: currentItem.isKnownDms,
                                    isDeposit : currentItem.depositReference != "" ? true : false,
                                    depositReference: currentItem.depositReference, 
                                    dmsInformations: currentItem.dmsInformations
                                }
                            }
                            else {

                                var datahubReferenceInformations = _.find(datahubResponse, { reference: currentItem.reference });

                                var designation = currentItem.designation;
                                var price = currentItem.price;

                                if (datahubReferenceInformations && datahubReferenceInformations.designation && _.isEmpty(designation)) {
                                    designation = datahubReferenceInformations.designation;
                                }
                                if (datahubReferenceInformations && datahubReferenceInformations.priceExclTaxes && _.isEmpty(price)) {
                                    price = datahubReferenceInformations.priceExclTaxes;
                                }
                                return {
                                    reference: currentItem.reference,
                                    designation: designation,
                                    price: price,
                                    stock: currentItem.stock,
                                    cort: currentItem.cort,
                                    isLocalPiece: currentItem.isLocalPiece,
                                    isKnownDms: currentItem.isKnownDms,                                    
                                    isDeposit : currentItem.depositReference != "" ? true : false,
                                    depositReference: currentItem.depositReference,
                                    dmsInformations: currentItem.dmsInformations
                                }
                            }
                        })

                        return data;
                    });
                }
                //return dmsResponse without isCompleted attribute
                else {
                    return dmsResponse.map(function (currentItem) {
                        return _.omit(currentItem, ['isCompleted']);
                    })
                }
            })
        }

        function getTmInformation(opeCode) {
            return returnTmDocumentsByOpeCode(opeCode).then(function (opeCodeResponse) {
                //if the service provide only 1 TM and the subtype is standard, return the document
                //else return -1
                if (opeCodeResponse.TM.length == 1) {
                    var document = opeCodeResponse.TM[0];
                    if (document.subType === "STANDARD") {
                        return document;
                    }
                    else {
                        return -1;
                    }
                }
                else if (opeCodeResponse.TM.length > 1) {
                    var exist = false;
                    var index = 0;
                    var occurences = 0;
                    var indexStandard = 0;

                    //parse TM to get occurences of standard type
                    //and the first index of standard type
                    opeCodeResponse.TM.forEach(function (item) {
                        if (item.subType === "STANDARD") {
                            if (!exist) {
                                indexStandard = index;
                            }
                            exist = true;
                            occurences++;
                        }
                        index++;
                    });

                    //return -1 if we don't have occurences
                    //return document if we have an occurence
                    //return -2 if we have more than one occurence
                    if (occurences == 0) {
                        return -1;
                    }
                    else if (occurences == 1) {
                        document = opeCodeResponse.TM[indexStandard];
                    }
                    else if (occurences > 1) {
                        return -2;
                    }
                } else {
                    return -1;
                }
            });
        }


        function getLabourTimeFromID(id) {
            var defer = $q.defer();
            var user = CacheService.getObject(RoutesConstants.profil);

            var request = {
                "userId": user.userId,
                "userType": user.userType,
                "country": user.country,
                "language": user.language,
                "dealerId": user.dealerId,
                "id": id
            };

            DocumentsWsService.getLabourTime(request).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

        function getNodeInCache() {
            return CacheService.getObject(CacheConstants.nodeFromSearchArbo);
        }

        function returnSVG(id, url) {
            var defer = $q.defer();

            DocumentsWsService.getSVG(id, url).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getPR(prIDList) {

            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var brandComputed = carContext.brandComputed;
            var brand = carContext.fixedCriterias["336"];
            var Aplbrand = ['APL03', 'APL05', 'APL06', 'APL08', 'APL10', 'APL17', 'APL18'];
            var Brabrand = ['BRA03', 'BRA05', 'BRA08', 'BRA17', 'BRA18', 'BRA20', 'BRA22'];
             
            if(brandComputed){
                if (brandComputed.substr(0,3) === 'APL' && !Aplbrand.includes(brandComputed)){
                    carContext.brandComputed = 'APL03';
                }
                else if (brandComputed.substr(0,3) === 'BRA'  && !Brabrand.includes(brandComputed)){
                    carContext.brandComputed = 'BRA03';
                }
            }
            
            if(brand){
                if(brand.substr(0,3) === 'APL' && !Aplbrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'APL03';
                }else if (brand.substr(0,3) === 'BRA' && !Brabrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'BRA03';
                }
            } 

            var singleton = CacheService.getObject(CacheConstants.contextCarSearch);

            var body = {
                userContext: userContext,
                carContext: carContext,
                PR: prIDList,
                partFilter: singleton.vehicle.displayMotrio ? 'ALLPARTS' : 'NOMOTRIO'
            }

            return DocumentsWsService.getNodePR(body).then(function (res) {
                return res.PR;
            })
        }

        /**
         * @desc service call to get only plate details
         * @param {Array<string>} prIDList 
         * @return {Array<Object>}
         */
        function getPlates(prIDList, isDocpriv) {

            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var user = CacheService.getObject(RoutesConstants.profil);
            var brandComputed = carContext.brandComputed;
            var brand = carContext.fixedCriterias["336"];
            if (user.userType === "RNET" && user.roles && user.roles.includes('PPX_NETWORK_USER') && !user.roles.includes('PPX_CORPORATE_USER')) {
            var Aplbrand = ['APL03', 'APL05', 'APL06', 'APL08', 'APL10', 'APL17', 'APL18'];
            var Brabrand = ['BRA03', 'BRA05', 'BRA08', 'BRA17', 'BRA18', 'BRA20', 'BRA22'];
             
            if(brandComputed){
                if (brandComputed.substr(0,3) === 'APL' && !Aplbrand.includes(brandComputed)){
                    carContext.brandComputed = 'APL03';
                }
                else if (brandComputed.substr(0,3) === 'BRA'  && !Brabrand.includes(brandComputed)){
                    carContext.brandComputed = 'BRA03';
                }
            }
            
            if(brand){
                if(brand.substr(0,3) === 'APL' && !Aplbrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'APL03';
                }else if (brand.substr(0,3) === 'BRA' && !Brabrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'BRA03';
                }
            } 
        }

            var singleton = CacheService.getObject(CacheConstants.contextCarSearch);            

            if (isDocpriv && userContext && userContext.userProfiles && user) {
                if (user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)) {
                    userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());
                }
                else if (user.roles && user.roles.includes(CarSearchConstants.ppxIndependentUser) && user.accountType === 'Partner') {
                    userContext.userProfiles.push(CarSearchConstants.ppxIndependentUser.toLowerCase());
                }
            }

            var body = {
                userContext: userContext,
                carContext: carContext,
                documentsId: prIDList,
                partFilter: singleton.vehicle.displayMotrio ? 'ALLPARTS' : 'NOMOTRIO'
            }
            var defer = $q.defer();
                 DocumentsWsService.getNodePlates(body).then(function (res) {
                     if(res && res.plates){
                        defer.resolve(res.plates);
                     }else{
                         defer.reject();
                     }
                }).catch(function(err){
                    defer.reject(err)
                })

           return defer.promise;
        }

        /**
         * @desc service call to fetch reference details of a particular plate
         * @param {Object} plateInfo 
         * @return {Object}
         */
        function getPlateLines(plateInfo) {

            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var brandComputed = carContext.brandComputed;
            var brand = carContext.fixedCriterias["336"];
            var Aplbrand = ['APL03', 'APL05', 'APL06', 'APL08', 'APL10', 'APL17', 'APL18'];
            var Brabrand = ['BRA03', 'BRA05', 'BRA08', 'BRA17', 'BRA18', 'BRA20', 'BRA22'];
            var user = CacheService.getObject(RoutesConstants.profil);

            if (user.userType === "RNET" && user.roles && user.roles.includes('PPX_NETWORK_USER') && !user.roles.includes('PPX_CORPORATE_USER')) {
                
            if(brandComputed){
                if (brandComputed.substr(0,3) === 'APL' && !Aplbrand.includes(brandComputed)){
                    carContext.brandComputed = 'APL03';
                }
                else if (brandComputed.substr(0,3) === 'BRA'  && !Brabrand.includes(brandComputed)){
                    carContext.brandComputed = 'BRA03';
                }
            }
            
            if(brand){
                if(brand.substr(0,3) === 'APL' && !Aplbrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'APL03';
                }else if (brand.substr(0,3) === 'BRA' && !Brabrand.includes(brand)){
                    carContext.fixedCriterias["336"] = 'BRA03';
                }
            }
        } 

            var singleton = CacheService.getObject(CacheConstants.contextCarSearch);
            if (userContext && userContext.userProfiles && user) {
                if (user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)) {
                    userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());
                }
                else if (user.roles && user.roles.includes(CarSearchConstants.ppxIndependentUser) && user.accountType === 'Partner') {
                    userContext.userProfiles.push(CarSearchConstants.ppxIndependentUser.toLowerCase());
                }
            }

            var body = {
                userContext: userContext,
                carContext: carContext,
                plate: plateInfo.id,
                partFilter: singleton.vehicle.displayMotrio ? 'ALLPARTS' : 'NOMOTRIO'
            }

            var lsrInfo = CacheService.getObject(CacheConstants.bvaApigee) ? 
                                CacheService.getObject(CacheConstants.bvaApigee).partsList : [];

            if(lsrInfo && !_.isEmpty(lsrInfo)){
                var genericPartsFromPlates = plateInfo.genericParts ? plateInfo.genericParts : [];

                var lsrForLines;
                if(genericPartsFromPlates && !_.isEmpty(genericPartsFromPlates)){
                    lsrForLines = _.filter(lsrInfo, function(item){
                        if(_.includes(genericPartsFromPlates, item.spareGenericPart)){
                            return item;
                        }
                    })
                }

                if(lsrForLines && !_.isEmpty(lsrForLines)){

                    _.map(lsrForLines,function(lsrItems){
                        if(lsrItems && lsrItems.additionalSpareParts && !_.isEmpty(lsrItems.additionalSpareParts)){
                            var additionalParts = [];
                            _.map(lsrItems.additionalSpareParts,function(item){
                                _.map(item.lvaSparePartList, function(parts){
                                    additionalParts.push(parts);
                                })
                                
                            });
                            _.assign(lsrItems,{additionalSpareParts : additionalParts});
                        }
                    
                    });

                    _.extend(body,
                        {herculesInputs:lsrForLines})
                }
            }

            var defer = $q.defer();

            DocumentsWsService.getPlateLines(body).then(function (res) {
                    if(res){
                        defer.resolve(res);
                    }else{
                        defer.reject();
                    }
                }).catch(function(err){
                    defer.reject(err)
            })

             return defer.promise;
        }

        function getElementsByGenericParts(genericPartIds) {

            var body = {
                genericParts: genericPartIds
               
            };
           
            var defer = $q.defer();
                 DocumentsWsService.getElementsByGenericParts(body).then(function (res) {
                     if(res && res.elements){
                        defer.resolve(res.elements);
                     }else{
                         defer.reject();
                     }
                }).catch(function(err){
                    defer.reject(err)
                })

           return defer.promise;
        }
        function getIDsBySieElemOpe(elementIDs,docTypes) {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

           var ids=[];
           for(var i=0;i<elementIDs.length;i++)
           {
            if(_.isArray(elementIDs[i]) && elementIDs[i].length > 1){
                angular.forEach(elementIDs[i], function(value){
                    var tempObj={
                        element:value
                    }
                    ids.push(tempObj);
                })
            }else if(_.isArray(elementIDs[i]) && elementIDs[i].length <= 1){
               var tempObj={
                   element:elementIDs[i][0]
               }
               ids.push(tempObj);
           }else if(!_.isArray(elementIDs[i])){
            var tempObj={
                element:elementIDs[i]
            }
            ids.push(tempObj);
           }
        }
            var body = {
                userContext: userContext,
                carContext: carContext,
                docTypes:docTypes,
                elemOpes: ids
               
            };
           
            var defer = $q.defer();
                 DocumentsWsService.getIDsBySieElemOpe(body).then(function (res) {
                     if(res ){
                        defer.resolve(res);
                     }else{
                         defer.reject();
                     }
                }).catch(function(err){
                    defer.reject(err)
                })

           return defer.promise;
        }

        /**
         *   @desc Call a service to fetch all PR from the IDList
         *   @param {Array<string>} IDlist
         *   @return {Array<Object>}
         */
        function getPRLight(IDList) {
            var userContext = CacheService.getUserContext();
            var bodyRequest = {
                documentsId: IDList,
                userContext: userContext
            }
            return DocumentsWsService.getPRlight(bodyRequest);
        }



            function getProducts(nodeId, technicalId, functionalId) {
                var isUserDms = DealerManagerSystemeService.getHookResult();
                var userContext = CacheService.getUserContext();
                var carContext = CacheService.getCarContext();
                var fields = {
                    treeNode: [nodeId],
                    type: ["PRODUCTS"]
                }
                  
    
                    var documentsId=CacheService.getObject(CacheConstants.transeversalPartsIds);
    
    
                    var trsnsversBdy={
                        userContext:userContext,
                        carContext: carContext,
                        documentsId:documentsId
                    }
                var body = {
                    userContext: userContext,
                    carContext: carContext,
                    textCriterias: "",
                    fields: fields,
                    paginationLimit: 50,
                    paginationOrder: ["MODEL"]
                }
                if (technicalId) {
                    body.paginationStartAfterId = {
                        technicalId: technicalId,
                        documentType: "PRODUCTS"
                    }
    
                }
    
    
                return DocumentsWsService.getNodeProducts(trsnsversBdy,body,functionalId).then(function (res) {
                    if (res.length == 2 || res[0].TransversalParts) {
                        res = combinedPagedandTransversalParts(res);
                    }
                    if (res.length == 1) {
                        res = res[0];
                    }
                    if (!isUserDms) {

                        return res;
                    }
    
    
                    var refIDList = res.results.map(function (result) {
                        return _.get(result, ['content', 'reference']);
                    });
    
                    return DmsMetierService.getReferencesDms(refIDList).then(function (response) {
                        var dmsData = DmsMetierService.buildDataFromDms(response.response.parts);
                        var productsList = res.results.map(function (result) {
                            return _.get(result, ['content']);
                        }).filter(function (e) {
                            return e;
                        });
                        if (productsList.length) {
                            // this method gonna res.results (productsList) mutate by adding a new prop on every object;
                            DmsMetierService.matchReferenceFromDms(productsList, dmsData);
                        }
                        return res;
                    }).catch(function () {
                        return res;
                    });
                })
    
    
            }

        function returnBTByRef(ref) {
            var userContext = CacheService.getUserContext();
            var data = {
                userContext: userContext,
                BT: [ref]
            }
            return DocumentsWsService.getBTByRef(data);
        }

        function returnNTByRef(ref) {
            var userContext = CacheService.getUserContext();
            var data = {
                userContext: userContext,
                NT: [ref]
            }
            return DocumentsWsService.getNTByRef(data);
        }

        /**
        * returnSIEDocuments
        * @param {string} type
        * @returns {Service} getTMDetail - MR's HTML content
        */

        function returnSIEDocuments(mrIDList) {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            var request = {
                userContext: userContext,
                carContext: carContext,
                documentsId: mrIDList
            }

            return DocumentsWsService.getMRList(request);
        }


        function returnTmDocuments(tmIDList) {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            var request = {
                userContext: userContext,
                documentsId: tmIDList,
                carContext: carContext
            };

            return DocumentsWsService.getTmDocuments(request);
        }

        /**
         * Get List of TM (Labourtime) by opecode
         * @param tmOpeCodeList
         * @returns {Object} - list of LabourTime TM corresponding to the search params
         */

        function returnTmDocumentsByOpeCode(tmOpeCodeList) {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var request = {
                userContext: userContext,
                opeCode: tmOpeCodeList.map(function(x){ return x.toUpperCase(); })
            };



            if (carContext != null && !carContext.hasOwnProperty('isKnown')) {
                request = {
                    userContext: userContext,
                    opeCode: tmOpeCodeList.map(function(x){ return x.toUpperCase(); }),
                    carContext: carContext
                };
            }



            return DocumentsWsService.getTmDocumentsByOpeCode(request).then(function (response) {
                if (!response) {
                    return $q.reject('');
                } else if (response.error) {
                    return $q.reject('');
                }
                return response;
            })
        }


        /**
         * Get List of MD
         * @param {Object} MDList - List of subTypes used to filter MDs
         * @param {String} code - optional, defect code from B2
         * @returns {Object} - list of MD corresponding to the search params
         */
        function getMDList(MDList, code) {
            var params = {
                "userContext": CacheService.getUserContext(),
                "carContext": CacheService.getCarContext(),
                "MD": MDList
            };
            if (code) {
                params.defectCode = code;
            }
            return DocumentsWsService.getMDList(params, [], null);
        }


        /**
         * Get selected MR's details
         * @param {string} idMr - the id of the selected MR
         * @returns {Service} getMRDetail - MR's HTML content
         */
        function returnMRDetail(idMr) {
            var user = CacheService.getObject(RoutesConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

            var request = {

                userContext: user,
                carContext: contextCarRequest
            };

            return DocumentsWsService.getMRDetail(idMr, request);
        }

        function returnBTDetail(idBt, detailsBt) {
            var user = CacheService.getObject(RoutesConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

            var request = {

                userContext: user,
                carContext: contextCarRequest,
                btDocumentDetails: detailsBt
            };

            return DocumentsWsService.getBTDetail(idBt, request);
        }

        function getBTPdf(idBt, detailsBt) {
            const user = CacheService.getObject(RoutesConstants.profil);
            const contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            const btDocumentDetails = detailsBt && detailsBt.btDocumentDetails !== undefined
                ? detailsBt.btDocumentDetails
                : detailsBt;

            const request = {
                userContext: user,
                carContext: contextCarRequest,
                btDocumentDetails
            };

            return DocumentsWsService.getBTPdf(idBt, request);
        }

        function returnSiePdfContent(id, type) {

            var user = CacheService.getUserContext();
            var request = {
                userContext: user,
                sieNumber: id,
                type: type
            };

            return DocumentsWsService.getSiePdfContent(id, request);
        }

        /**
       * Display BT details
       * @param {id} id
       * @param {isPdf} isPdf
       */
        function displayBtDetails(id, isPdf, BtnumbersAndSymptomsDetails,tabName) {
            var previousPageDetails = {};
            if($location.path().includes('listePiece')){
                previousPageDetails = {
                    documentType: $state.params.documentType,
                    plateIndex: $state.params.plateIndex,
                    refIndex: $state.params.refIndex
                }
            }else if($location.path().includes('otsTab')){
                previousPageDetails = {
                    tabName: tabName
                }
            }
            if (isPdf === false) {
                if (tabName === "InfoSec") {
                    var url = $state.href(RoutesConstants.documentBTListDoc, { id: id, symptomNumbers: BtnumbersAndSymptomsDetails });
                    window.open(url, '_blank');
                } else {
                    $state.go(RoutesConstants.documentBT, { id: id, symptomNumbers: BtnumbersAndSymptomsDetails, previousPageDetails: previousPageDetails });
                }
            }
            else {
                returnSiePdfContent(id, 'SIE_BT')
                    .then(function (result) {
                        $window.open(result.contentUrl, '_blank');
                    });
            }
        }

        /**
       * Display BT List Doc details
       * @param {id} id
       * @param {isPdf} isPdf
       */
        function displayBtListDetails(id, isPdf, BtnumbersAndSymptomsDetails) {
            if (isPdf === false) {



                var url = $state.href(RoutesConstants.documentBTListDoc, { id: id, symptomNumbers: BtnumbersAndSymptomsDetails });
              

              
               
                window.open(url, '_blank');


            }
            else {
                returnSiePdfContent(id, 'SIE_BT')
                    .then(function (result) {
                        $window.open(result.contentUrl, '_blank');
                    });
            }
        }
        /**
       * Display BT details for RDS
       * @param {id} id
       * @param {isPdf} isPdf
       */
        function displayBtDetailsRds(id, isPdf, btDetails) {
            if (isPdf === false) {
                $state.go(RoutesConstants.documentBT, { id: id, symptomNumbers : btDetails });
            }
            else {
                returnSiePdfContent(id, 'SIE_BT')
                    .then(function (result) {
                        $state.go(RoutesConstants.carSearch);
                        $window.open(result.contentUrl, '_blank');

                    });
            }
        }

        function displayBtDetailsDab(id, isPdf){
            if (isPdf === false) {
                $state.go(RoutesConstants.newTabBT, { id: id, docDetails : true});
            }
            else {
                returnSiePdfContent(id, 'SIE_BT')
                    .then(function (result) {
                        $window.open(result.contentUrl, '_self');

                    });
            }
        }

        /**
         * Download PDF containing NT details
         * @param {id} id
         * @param {contentUrl} contentUrl
         */

        function displayNtDetails(id, contentUrl) {
            $window.open(contentUrl, '_blank');
        }

        /**
         * @name returnSiePdfContentFromClip
         * @desc return sie pdf content for clip
         * @param {string} mrId - manual number of reperation (mandatory)
         * @param {string} ecuId - calculator identifier (mandatory)
         * @param {string} codeDef - renault default code "signet" (optional)
         */
        function returnSiePdfContentFromClip(mrId, ecuId, codeDef) {
            var user = CacheService.getUserContext();
            var request = {
                userContext: user,
                mrId: mrId,
                ecuId: ecuId,
                codeDef: codeDef
            };
            return DocumentsWsService.getSiePdfContentFromClip(request);
        }

        /**
         * Get selected MD's details
         * @param {string} idMd - the id of the selected MD
         * @returns {Service} getMDDetail - MR's HTML content
         */
        function returnMDDetail(idMd) {

            var user = CacheService.getObject(RoutesConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

            var request = {

                userContext: user,
                carContext: contextCarRequest
            };

            return DocumentsWsService.getMDDetail(idMd, request);
        }




        /**
        * Get List of MD from arbo
        * @param {Object} params - List of subTypes used to filter MDs
        * @returns {Object} - list of MD corresponding to the search params
        */
        function getMDListFromArbo(params) {
            return DocumentsWsService.getMDList(params, [], null);
        }


        //TODO Test dans spec
        /**
         * go through the list of references returned by the back to extract all the reference(principal,additional, alternative
         * @return array of string
         * @param list
         * @returns {Array}
         */
        function getReferencesStringArray(list) {
            var referencesList = [];
            for (var i = 0; i < list.length; i++) {
                referencesList.push(list[i].reference);

                if (list[i].additional) {
                    for (var j = 0; j < list[i].additional.length; j++) {
                        if (list[i].additional[j]) {
                            referencesList.push(list[i].additional[j].reference);
                        }
                    }
                }
            }
            return referencesList;
        }

        function mergePRList(listRefBack, listRefDms) {

            for (var i = 0; i < listRefBack.length; i++) {

                if (listRefBack[i]) {
                    //merge additional ref
                    if (listRefBack[i].additional) {

                        for (var k = 0; k < listRefBack[i].additional.length; k++) {
                            var additionalDms = findReference(listRefDms, listRefBack[i].additional[k]);
                            if (additionalDms) {
                                var mergedRef = mergeReference(listRefBack[i].additional[k], additionalDms, listRefBack.stocks);
                                listRefBack[i].additional[k] = mergedRef;
                            }
                        }
                    }
                }

                //merge principal reference
                var referenceDms = findReference(listRefDms, listRefBack[i]);
                if (referenceDms) {
                    var mergedReference = mergeReference(listRefBack[i], referenceDms, listRefBack.stocks);
                    listRefBack[i] = mergedReference;
                }
            }
            return listRefBack;
        }

        function getAvailabilities(dmsRef, userStocks) {
            var dispoPlaque;
            var dispoPrincipal;
            var availabilities = undefined;
            if (dmsRef.availabilities) {
                for (var i = 0; i < dmsRef.availabilities.length; i++) {
                    if (dmsRef.availabilities[i].quantity > 0) {
                        if (dmsRef.availabilities[i].siteId === userStocks[0].siteId) {
                            dispoPrincipal = dmsRef.availabilities[i];
                        }
                        else {
                            dispoPlaque = dmsRef.availabilities[i];
                        }
                        break;
                    }
                }
            }

            availabilities = dispoPrincipal ? dispoPrincipal : dispoPlaque;
            if (availabilities) {
                availabilities.isStockPrincipal = dispoPrincipal ? true : false;
            }
            return availabilities;
        }

        //TODo Test spec
        function mergeReference(backRef, dmsRef, stocks) {
            var jsonReferencesFromDms = {};
            jsonReferencesFromDms.designation = dmsRef.description || backRef.designation;
            jsonReferencesFromDms.description = dmsRef.description || backRef.designation;
            jsonReferencesFromDms.cort = dmsRef.cort || backRef.cort;
            jsonReferencesFromDms.priceExclTaxes = dmsRef.priceExclTaxes || backRef.priceExclTaxes;
            jsonReferencesFromDms.priceInclTaxes = dmsRef.priceInclTaxes || backRef.priceInclTaxes;
            jsonReferencesFromDms.priceCode = dmsRef.priceCode || backRef.priceCode;
            jsonReferencesFromDms.familyCode = dmsRef.familyCode || backRef.familyCode;
            jsonReferencesFromDms.status = dmsRef.status;
            jsonReferencesFromDms.availabilities = getAvailabilities(dmsRef, stocks);
            jsonReferencesFromDms.supersedingPart = dmsRef.supersedingPart;


            var jsonReferences = _.assign(backRef, jsonReferencesFromDms);
            return jsonReferences;
        }

        //TODO Test dans spec
        function findReference(list, ref) {
            return _.find(list, function (o) {
                return o.reference === ref.reference;
            });
        }

        function returnSiesByGies(gies) {

            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            var request = {
                userContext: userContext,
                carContext: carContext,
                elemOpes: gies
            };

            return DocumentsWsService.getSiesByGies(request);
        }
//merging paged and transversalParts
        function combinedPagedandTransversalParts(resp) {
            var trnsvlPartsResults = [];
            var trnsvlParts = resp[0].TransversalParts;
            for (var i = 0; i < trnsvlParts.length; i++) {

                var content = {
                    "reference": trnsvlParts[i].partReference,
                    "designation": trnsvlParts[i].designation,
                    "designationLanguage": trnsvlParts[i].designationLanguage,
                    "priceExclTaxes": trnsvlParts[i].priceWithoutTaxes,
                    "currency": trnsvlParts[i].currency,
                    "discountCode": trnsvlParts[i].discountCode,
                    "taxCode": trnsvlParts[i].taxCode,
                    "safetyFlag": trnsvlParts[i].safetyFlag,
                    "codifiedSigns": trnsvlParts[i].codifiedSigns,
                    "familyCode": trnsvlParts[i].familyCode,
                    "codeEpui": trnsvlParts[i].codeEpui,
                    "corporate": trnsvlParts[i].corporate,


                    "productModelCode": trnsvlParts[i].productModelCode


                }
                var productObj = {
                    "technicalId": trnsvlParts[i].partReference,
                    "documentType": "transversalParts",
                    "content": content
                }
                trnsvlPartsResults.push(productObj);
            }

            var productsList =
            {
                count: trnsvlPartsResults.length,
                results: trnsvlPartsResults
            }
            if (resp[0].paginationLastId) {
                _.extend(productsList, {
                    trnsvlPartsPagination: resp[0].paginationLastId
                });
            }
            if (resp[1]) {
                var pagedResults = resp[1].results;
                _.extend(productsList, {
                    count: resp[1].count + trnsvlPartsResults.length,
                    paginationLastId: resp[1].paginationLastId,
                    results: trnsvlPartsResults.concat(pagedResults)
                });
            }

            return productsList;
        }

        function createMDParams(MDList) {
            var params = {
                "userContext": CacheService.getUserContext(),
                "carContext": CacheService.getCarContext(),
                "MD": MDList
            };
            return params;
        }

        /**
         * @desc to sort the parts in a specific order of brands
         * @param {*} types 
         */
        function customCompareBrands(types){

            return function(a,b){

                var user = CacheService.getObject(RoutesConstants.profil);
                var sort_order = (user && (user.userType == 'ARCA' || user.userType == 'RNET')) ? ListPieceConstants.brandList : ListPieceConstants.indeBrandList;
                var firstData,secondData;

                if(!a.hasOwnProperty(types)){
                    firstData = sort_order.indexOf(ListPieceConstants.brandList[0]);
                }else{
                    a[types].forEach(function(item){
                        firstData = sort_order.indexOf(item);
                    })
                    
                }
                if(!b.hasOwnProperty(types)){
                    secondData = sort_order.indexOf(ListPieceConstants.brandList[0]);
                }else{
                    b[types].forEach(function(item){
                        secondData = sort_order.indexOf(item);
                    })
                }

                return firstData - secondData;

            }
        }
        function getPartsByGenericParts(genericParts) {
            var ref = [];
            var ref1 = [];
            var referenceList = {references:[]};
            var filter = CacheService.getObject(CacheConstants.filter);
            var userContext = CacheService.getUserContext();
            const user = CacheService.getObject(CacheConstants.profil);
            const hasUserProfiles = userContext && userContext.userProfiles;
            const hasDocPrivRole = user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile);
            if(hasUserProfiles && hasDocPrivRole){
                userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());      
            }
            var carContext = CacheService.getCarContext();
            var body = {
                userContext: userContext,
                carContext: carContext,
                listOfGenericParts: genericParts
            }
            var lsrInfo = CacheService.getObject(CacheConstants.bvaApigee) ? 
                                CacheService.getObject(CacheConstants.bvaApigee).partsList : [];

            if(lsrInfo && !_.isEmpty(lsrInfo)){
                var genericPartsFromPlates = genericParts ? genericParts : [];

                var lsrForLines;
                if(genericPartsFromPlates && !_.isEmpty(genericPartsFromPlates)){
                    lsrForLines = _.filter(lsrInfo, function(item){
                        if(_.includes(genericPartsFromPlates, item.spareGenericPart)){
                            return item;
                        }
                    })
                }

                if(lsrForLines && !_.isEmpty(lsrForLines)){

                    _.map(lsrForLines,function(lsrItems){
                        if(lsrItems && lsrItems.additionalSpareParts && !_.isEmpty(lsrItems.additionalSpareParts)){
                            var additionalParts = [];
                            _.map(lsrItems.additionalSpareParts,function(item){
                                _.map(item.lvaSparePartList, function(parts){
                                    additionalParts.push(parts);
                                })
                                
                            });
                            _.assign(lsrItems,{additionalSpareParts : additionalParts});
                        }
                    
                    });

                    _.extend(body,
                        {herculesInputs:lsrForLines})
                }
            }
        
              return DocumentsWsService.getPartsByGenericParts(body).then(function (res) {
               if(filter.id === "PR" && res.references.length != 1) {
                   var identList = CacheService.getObject(CacheConstants.identifierList); 
                    res.references =_.groupBy(res.references, 'genericPart');
                        for(var i in res.references){
                            if(res.references[i].length > 1){
                                res.references[i].forEach(function(item){
                                var compare = item.initialReference ? item.initialReference : item.reference;
                                    if(identList && identList.includes(compare)){
                                        ref.push(item);
                                    }
                                    else{
                                        ref1.push(item);
                                    }
                                    res.references[i] = ref.concat(ref1); 
                                });
                                ref = []; ref1 = [];
                            } 
                        }
                        _.map(res.references,function(item){
                            item.forEach(function(r){
                            referenceList.references.push(r);
                            });
                        });
                       
                    return referenceList;
                }
                 return res;
            })
        }
        /**
         * @desc to display parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=4
         * and for the brand APL05/BRA05 and age >= 3
         */
        function brandAgeAcceptable(renoAge,daciaAge){

            var carContext = CacheService.getCarContext();

            if(carContext && !_.isEmpty(carContext)  && carContext.fixedCriterias && !_.isEmpty(carContext.fixedCriterias)){
                if(((carContext.fixedCriterias["336"] === 'APL03'|| carContext.fixedCriterias["336"] === 'BRA03' || carContext.fixedCriterias["336"] === 'APL06'|| carContext.fixedCriterias["336"] === 'BRA06') && (_.isNull(carContext.ageComputed) || carContext.ageComputed >= renoAge)) ||
                ((carContext.fixedCriterias["336"] === 'APL05'|| carContext.fixedCriterias["336"] === 'BRA05') && (_.isNull(carContext.ageComputed) || carContext.ageComputed >= daciaAge))){
                    return true;
                }else{
                    return false;
                }
            }
            return true;
        }

        function filterSelectedIds(selectedItem, documentType, isPlateSearch,isFromEasyBasket,isTextSearchRedirect,isComingFromDiagFileDetails){
            CacheService.setObject(CacheConstants.isSearchEngine, false);
            var selectedCatalogPlate = [];
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            
            if (isFromEasyBasket){
                var selectedId = selectedItem.catalogPlates[0].id;
                var filterChoosen = { id: documentType  }
                CacheService.setObject(CacheConstants.filter, filterChoosen);
            }else{
                var selectedId = (documentType == 'PR') ? selectedItem.catalogPlates[0].id : selectedItem.technicalId;
            }

            if(contextCarSearch.treeNodes){
                var dataArboLevelOne = angular.copy(contextCarSearch.treeNodes.levelOne);
                var level2 = angular.copy(contextCarSearch.treeNodes.otherLevel);
                var selectedNode1, selectedNode2, selectedNode3;
                var selectedNode1Array = [], selectedNode2Array = [], selectedNode3Array = [];
                    
                for(var i =level2.nodes.length - 1;i >= 0;i--){
                    var node2 = level2.nodes[i];
                    for(var j =node2.childNodes.length - 1;j >= 0;j--){
                        var node3 = node2.childNodes[j];
                        //filtering only level 3 nodes as level 2 contains plate ids of all its level 3 nodes
                        if(node3.idsDocumentsByType && node3.idsDocumentsByType[documentType] && 
                            node3.idsDocumentsByType[documentType].includes(selectedId)){

                                if(_.indexOf(selectedNode3Array,{nodeId:node3.nodeId}) === -1){
                                    selectedNode3Array.push(node3);
                                }
                            
                        }else{

                            node2.childNodes.splice(j,1);
                        }

                    }

                    if(node2.childNodes.length === 0){
                        level2.nodes.splice(i,1);
                    }else{
                        if(_.indexOf(selectedNode2Array,{nodeId:node2.nodeId}) === -1){
                            selectedNode2Array.push(node2);
                        }
                    }
                };

                dataArboLevelOne.nodes.forEach(function(node1){
                    selectedNode2Array.forEach(function(node2){
                        if(node1.nodeId === node2.codeParent){
                            selectedNode1Array.push(node1);
                        }
                    })
                })

                if(selectedNode2Array && !_.isEmpty(selectedNode2Array)){
                    selectedNode2Array =  _.uniq(selectedNode2Array,'nodeId');
                    var idParent = _.filter(selectedNode1Array,function(item){
                        return item.rang == 1;
                    });
                    if(idParent && !_.isEmpty(idParent)){

                        var selectedNode2Array = _.filter(selectedNode2Array,function(item){
                            return item.codeParent != idParent[0].nodeId;
                        })

                        for(var i = selectedNode2Array.length - 1;i >= 0;i--){
                            for(var j = selectedNode3Array.length - 1;j >= 0;j--){
                                if(selectedNode3Array[j].codeParent == selectedNode2Array[i].nodeId){
                                    selectedNode3Array.splice(j,1);
                                }
                            }
                        }

                        
                    }

                }
                

                if(selectedNode1Array && !_.isEmpty(selectedNode1Array)){
                    selectedNode1Array = _.uniq(selectedNode1Array,'nodeId');
                    selectedNode1Array = _.filter(selectedNode1Array,function(item){
                        return item.rang != 1;
                    })
                }

            if(!_.isEmpty(selectedNode1Array) && !_.isEmpty(selectedNode2Array) && !_.isEmpty(selectedNode3Array)){
                if(selectedNode1Array.length > 1 || selectedNode2Array.length > 1 || selectedNode3Array.length >1){
                        var filter = CacheService.getObject(CacheConstants.filter);
                        var motCle = CacheService.getObject(CacheConstants.motCle); 

                        contextCarSearch.filteredTree = {
                            filterChoosen: {
                                "$$hashKey": filter.$$hashKey,
                                "id": filter.id,
                                "label": filter.label
                            },
                            level1: {"nodes" : selectedNode1Array },
                            level2: { "nodes": selectedNode2Array },
                            criteria: motCle,
                            selectedId: selectedId

                        };

                        CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);

                        var resultDocumentsArbo = searchByTextsIdsMertierService.getDocumentsArbo(contextCarSearch.treeNodes.otherLevel.nodes);
                        resultDocumentsArbo.documents = filterDocumentsArboByType(resultDocumentsArbo.documents, filter.id);

                        var formattedFilteredDocuments = searchByTextsIdsMertierService.searchFilteredDocuments(resultDocumentsArbo.documentsCodeParents, selectedNode2Array,selectedNode3Array, documentType);
                        searchByTextsIdsMertierService.getFilteredDocumentsByType(formattedFilteredDocuments);
                        searchByTextsIdsMertierService.filterArboLevel1(formattedFilteredDocuments, dataArboLevelOne, motCle);

                        $state.go(RoutesConstants.carSearchResult, {
                        }, { notify: true, reload: true, inherit: false });
                        if(documentType == 'PR')
                            selectedCatalogPlate.push(selectedId);                       
                        var searchRedirection = {
                            isRedirectFromSearchEngine: false,
                            catalogPlate: selectedCatalogPlate,
                            documentType: documentType,
                            singleNode: false,
                            reference: (documentType == 'TM') ? selectedItem.id : selectedItem.reference
                        }
                        CacheService.setObject(CacheConstants.searchEngineDetails, searchRedirection);
                        CacheService.removeObject(CacheConstants.filter);
                    }else{ 

                        selectedNode1 = selectedNode1Array[0];
                        selectedNode2 = selectedNode2Array[0];
                        selectedNode3 = selectedNode3Array[0];

                        var selectedNode = selectedNode3 ? selectedNode3 : selectedNode2;

                        if (selectedNode && selectedNode.documents && !isFromEasyBasket) {
                            selectedNode.documentsByType = selectedNode.idsDocumentsByType || {
                                BT: [],
                                MD: {},
                                MR: [],
                                NI: [],
                                TM: [],
                                PRODUCTS: [],
                                PR: [],
                                TM_BY_TYPE: {}
                            };
                        }

                        if (selectedNode && selectedNode.documents && isFromEasyBasket) {
                            selectedNode.documentsByType = selectedNode.idsDocumentsByType || {
                                BT: [],
                                MD: {},
                                MR: [],
                                NI: [],
                                TM: [],
                                PRODUCTS: [],
                                PR: [],
                                TM_BY_TYPE: {}
                            };
                            selectedNode.documentsByType.PR = [];
                            selectedNode.documentsByType.PR.push(selectedItem.catalogPlates[0].id);
                        }

                        var data = {
                            node1: selectedNode1,
                            node2: selectedNode2,
                            node3: selectedNode3,
                            selectedNode: selectedNode,
                        };
            
                        $state.go(RoutesConstants.listePieceViews, {
                            data : data,
                            documentType: documentType,
                            plateIndex: 0,
                            refIndex: 0,
                            isRedirectFromSearchEngine: isPlateSearch ? false : true,
                            selectedReference: selectedItem.reference,
                            isComingFromDiagFileDetails: isComingFromDiagFileDetails,
                            isTextSearchRedirect: isTextSearchRedirect
                        });
            
                        if(documentType == 'PR' && !isFromEasyBasket)                       
                            selectedCatalogPlate.push(selectedItem.catalogPlates[0].id);
                        var searchRedirection = {
                            isRedirectFromSearchEngine: isPlateSearch ? false : true,
                            catalogPlate: selectedCatalogPlate,
                            documentType: documentType,
                            singleNode: true,
                            reference: (documentType == 'TM') ? selectedItem.id : selectedItem.reference
                        }
                    

                        
                        CacheService.setObject(CacheConstants.searchEngineDetails, searchRedirection);
                    }
                }else{
                    toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                }
    
  
            }
        }
        
        function filterDocumentsArboByType(resultDocumentsArbo, type) {
            var FilteredListDocumentsByType = [];

            if(resultDocumentsArbo && resultDocumentsArbo.length >0){
                angular.forEach(resultDocumentsArbo, function (value) {
                    if (value.documentType === type) {
                        FilteredListDocumentsByType.push(value);
                    }
                });
            }
            return FilteredListDocumentsByType;
        }

        
    }

})();

/**
 * productsDocs Controller
 * @namespace
 *
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('ProductsDocsCtrl', ProductsDocsCtrl);

    /**
     * @namespace ProductsDocsController
     * @desc Display products informations
     */

    /* @ngInject */
    function ProductsDocsCtrl(
        DocumentsMetierService,
        DealerManagerSystemeService,
        UtilsMetierService,
        RoutingService,
        CacheService,
        ScrollService,
        ReferenceMetierService,
        StorageService,
        configConstantes,

        $scope,
        $translate,
        $state,
        $timeout,
        $window,

        blockUI,
        toastr,
        ListPieceConstants,DocPrivMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.loading = true;
        vm.user = CacheService.getUserProfile();

        vm.showHideAppl = showHideAppl;
        vm.showHideAdd = showHideAdd;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.getPriceToDisplay = getPriceToDisplay;
        vm.quantityFontColor = quantityFontColor;

        vm.loadMoreProducts = loadMoreProducts;
        vm.goToProduct = goToProduct;
        vm.copyToClipboard = copyToClipboard;
        vm.filterNonValuePlusParts = filterNonValuePlusParts;
        

        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name init
         * @desc
         * @returns {array} list of products
         * @memberOf Controllers.ProductsDocsController
         */

        function init() {
            vm.isUserDms = DealerManagerSystemeService.getHookResult();
            if ($state.params.product) {
                vm.loading = false;
                vm.selectedProduct = $state.params.product.reference;
                vm.products = StorageService.getItem("products");
                vm.nodeId = StorageService.getItem("nodeId");
                vm.technicalId = StorageService.getItem("technicalId");

                $timeout(function () {
                    goToElement(vm.selectedProduct);
                }, 0);


            } else {
                vm.scrolled = false;
                /**Event on click ==>fired by a tab change**/
                $scope.$on('phx-init-listPRODUCT', function (event, nodeId) {
                    vm.nodeId = nodeId;
                    vm.productResponsePresent = DocPrivMetierService.getProductResposne();
                    if(!vm.productResponsePresent || _.isEmpty(vm.productResponsePresent)) {   
                    blockUI.start();
                    DocumentsMetierService.getProducts(nodeId).then(function (productList) {
                        DocPrivMetierService.setProductResposne(productList);
                        productValidations(productList);
                    }).catch(function () {
                        toastr.error($translate.instant("ERROR"));
                    }).finally(function () {
                        vm.loading = false;
                        blockUI.stop();
                    })
                    }
                    else {
                        productValidations(vm.productResponsePresent);
                    }
                });
            }
        }

        function productValidations(productList) {
            vm.products = productList.results;

            vm.products = filterNonValuePlusParts(vm.products);

            vm.technicalId = productList.paginationLastId.technicalId;
            if (productList.trnsvlPartsPagination && productList.trnsvlPartsPagination.functionalId) {
                vm.functionalId = productList.trnsvlPartsPagination.functionalId;
            }
            StorageService.setItem("nodeId", vm.nodeId);
            StorageService.setItem("products", vm.products);
            StorageService.setItem("technicalId", vm.technicalId);
            initializeScroll();
            vm.loading = false;
        }

        /**
         * @desc filter the parts which are not value plus for the display
         * @param {array} products 
         */
        function filterNonValuePlusParts(products){

            for(var i =products.length - 1;i >= 0;i--){

                if(products[i].content && products[i].content.types && products[i].content.types.length > 0 &&
                    _.includes(products[i].content.types,ListPieceConstants.types.valuePlus)){
                        products.splice(i,1);
                }
            }

            return products;

        }

        function filterEcoValueParts(products){
            if(!UtilsMetierService.showEcoValueParts && products && products.length > 0){
                for(let i = products.length - 1; i >= 0; i--){
                    if(products[i].content && products[i].content.types && products[i].content.types.length > 0 && _.includes(products[i].content.types,ListPieceConstants.types.ecoValue)){
                            products.splice(i,1);
                    }
                }
            }
            return products;
        }


        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //get list TM documents, iconsEssai, operations list, elements list
        //using the TM list recieved by the service

        function showHideAppl(piece) {
            ReferenceMetierService.showHideAppl(piece);
        }

        /**
         * @param {*} technicalId is the last id return by getProducts Service in order
         * to load 50 more products
         */

        function loadMoreProducts(technicalId) {
            blockUI.start();
            DocumentsMetierService.getProducts(vm.nodeId, technicalId, vm.functionalId).then(function (response) {
                if(response.paginationLastId) {
                vm.technicalId = response.paginationLastId.technicalId;
                }
                if(response.trnsvlPartsPagination && response.trnsvlPartsPagination.functionalId) {
                    vm.functionalId = response.trnsvlPartsPagination.functionalId;
                }
                if(!response.trnsvlPartsPagination) {
                    vm.functionalId = undefined;
                 }
                vm.products = vm.products.concat(response.results);

                vm.products = filterNonValuePlusParts(vm.products);
                vm.products = filterEcoValueParts(vm.products);
                StorageService.setItem("products", vm.products);
                StorageService.setItem("technicalId", vm.technicalId);
            }).catch(function () {
                toastr.error($translate.instant("ERROR"));
            }).finally(function () {
                blockUI.stop();
            })
        }

        function showHideAdd(piece) {
            if (piece.showAdd) {
                piece.showAdd = !piece.showAdd;
            } else {
                if (!piece.payment) {
                    delete piece.payment;
                    piece.payment = angular.copy(piece);
                }
                piece.showAdd = true;
            }
        }

        function goToProduct(piece) {
            RoutingService.goToProductPage({
                path: {
                    reference: piece.content.reference
                }
            });
        }
        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        function initializeScroll() {
            angular.element($window).bind("scroll", function () {
                if (this.pageYOffset > 225) {
                    vm.scrolled = true;
                    vm.scrollToTopButtonClass = 'scrollToTopButtonShow';
                } else {
                    vm.scrolled = false;
                    vm.scrollToTopButtonClass = '';
                }
                $scope.$apply();
            });
        }

        /**
         *  Format the string with price and currency to be displayed
         *  @param piece
         *  @returns {string}
         */

        function getPriceToDisplay(item) {
            var price = UtilsMetierService.getPriceToDisplay(
                item.priceExclTaxes,
                !item.dmsInformations ? null : item.dmsInformations.priceExclTaxes
            );
            return price;
        }

        /**
         *  @name getCurrencyForItem
         *  @desc get curency to diaplay
         *  @returns {string}
         */

        function getCurrencyForItem(piece) {
            if (piece && piece.dmsInformations && piece.dmsInformations.isKnowFromDms) {
                return UtilsMetierService.getCurrencyForItem(piece.dmsInformations.isKnowFromDms)
            } else {
                return UtilsMetierService.getCurrencyForItem()
            }
        }


        function quantityFontColor(number) {
            if (_.isNumber(number)) {
                if (number > 0) {
                    return 'stockDispo'
                } else {
                    return 'stockIndispo'
                }
            } else {
                return '';
            }
        }

        function goToElement(loc) {
            ScrollService.animateTo('#' + loc, 150);
        }

    }
})();


/**
 * TmDocuments Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('PrTmLinkCntrl', PrTmLinkCntrl);

    /**
     * @namespace PrTmLinkController
     * @desc Display TM informations (code, title, time, details, ...)
     * @memberOf Controllers
     */

    /* @ngInject */
    function PrTmLinkCntrl(DocumentsMetierService, $mdDialog,
        CacheService,blockUI,toastr) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var giesList = [];

        vm.atLeastOneTMDocument = false;
        vm.popin = {};
        vm.tmListData = [];
        vm.listOfTMDocuments = {};
        vm.selectedFilters = {
            operation: "",
            element: ""
        };
        vm.siesByGies = [];
        vm.loading = false;
        vm.close= close;
       
    
        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name init
         * @desc Get TM documents, filters section (elements TM and operations)
         * this action trigger when the user click on the TM panel
         * @returns {array} list of TM documents, elements and operations
         * @memberOf Controllers.TmDocumentsController
         */
        function init() {
            if(vm.tmdocids&&vm.tmdocids.length)
            {
               
                blockUI.start();
             vm.loading = true;
             DocumentsMetierService.returnTmDocuments(vm.tmdocids).then(function (response) {
                 initDocuments(response);
     
                 //get gie list
                 giesList = getGiesTM(response.TM);
     
                 giesList = _.uniqWith(giesList,_.isEqual);
                 //get sies list by gies and put them in cache
                 if(giesList && giesList.length >0){
                     getSIesByGies(giesList).then(function (reponse) {
                         CacheService.setSiesByGiesHistory(reponse);
                     });
                 }
     
                 vm.popin.data = getLegendsEssai();
             }).finally(function () {
                 blockUI.stop();
                 vm.loading = false;
     
                 if (vm.listOfTMDocuments) {
                     vm.atLeastOneTMDocument = (vm.listOfTMDocuments && vm.listOfTMDocuments.length > 0);
                 }
             });
             
             
            }           
            
            showTmTitle();
        }



        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //get list TM documents, iconsEssai, operations list, elements list
        //using the TM list recieved by the service
        function initDocuments(list) {
            vm.listOfTMDocuments = list.TM;
            if(!_.isEmpty(vm.listOfTMDocuments)){
            vm.listOfTMDocuments.forEach(function(item){                
                    _.assign(item,{prTMReference: vm.tmreference})
                })
            }
            vm.listTMElements = list.elements;
            vm.listTMOperations = list.operations;
        }

        //get gies tm from NotIncluded and AdditionalTo Section foreach item in tm list
        //using the tm list
        function getGiesTM(tmList) {
            var giesList = [];
            if (tmList && tmList.length > 0) {
                tmList.forEach(function (tmItem) {
                    if(tmItem.detail.NotIncluded.length >0)
                        giesList = addToGieList(giesList, tmItem.detail.NotIncluded);
                    if(tmItem.detail.AdditionalTo.length >0)
                        giesList = addToGieList(giesList, tmItem.detail.AdditionalTo);
                });
            }

            return giesList;
        }

        //add gie to list if it doesn't exist in gieList
        //using giesList and NotIncluded or AdditionalTo sections
        function addToGieList(giesList, tmDetails) {
            var gieResult = giesList;
            if (tmDetails && tmDetails.length > 0) {
                tmDetails.forEach(function (tmItemDetail) {                    
                        gieResult.push({"element":tmItemDetail.element,"operation":tmItemDetail.operation});
                });
            }
            return gieResult;
        }

        //get sies by gies
        //using gies list
        function getSIesByGies(gies) {
            var newResp = {};
            return DocumentsMetierService.returnSiesByGies(gies).then(function (response) {
                if (response.error) {
                    toastr.error(response.error.value, response.error.type);
                }
                if(response && response.length > 0){                    
                    response.forEach(function(item){
                        newResp[item.element+","+item.operation]=item.docs;
                    })
                    return newResp;
                } else{
                    return response;
                }
            });
        }

        //get icons essai
        //we use this cons to have a legend in Test column when survoling the column
        function getLegendsEssai() {
            var popinInfos = {};
            popinInfos.data = [{
                class: 'fa fa-play triangle positionIcon',
                txt: 'DOCUMENT_TM_FONCTIONNAL_TRY',
                opcode: '0145',
                time: 0.3,
            }, {
                class: 'fa fa-square positionIcon',
                txt: 'DOCUMENT_TM_SIMPLE_TRY',
                opcode: '0129',
                time: 0.5,
            }, {
                class: 'fa fa-square positionIcon outline-icon',
                txt: 'DOCUMENT_TM_EXTEND_TRY',
                opcode: '0130',
                time: 0.8
            }, {
                class: 'fa fa-circle positionIcon outline-icon',
                txt: 'DOCUMENT_TM_ON_BENCH',
            }];

            return popinInfos.data;
        }

        //we use this function to adjust the position of tm title when scrolling
        function showTmTitle() {
            $(window).scroll(function () {
                var position = $(window).scrollTop();
                var activateAtY = "360";

                if (position >= activateAtY) {
                    $('#tmTabView .documents-row-title').addClass('documents-scroll-in');
                }
                else {
                    $('#tmTabView .documents-row-title').removeClass('documents-scroll-in');
                }
            });
        }

       
        function close() {
            $mdDialog.cancel();
        }
      

        

    }
})();


/**
 * MRDocuments Controller
 * @namespace Controllers
 */
(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('PrMrLinkCtrl', PrMrLinkCtrl);

    /* @ngInject */
    function PrMrLinkCtrl(DocumentsMetierService, $mdDialog, mrDocumentsMetierService,
        blockUI, toastr, RoutesConstants, $state, $window, CacheService, CacheConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.atLeastOneMRDocument = false;
        vm.popin = {};
        vm.mrListData = [];
        vm.listOfMRDocuments = {};
        vm.loading = false;
        vm.close = close;

        init();

        vm.displayMrDetails = displayMrDetails;

        function init() {
            if (!_.isEmpty(vm.mrdocids)) {
                blockUI.start();
                vm.loading = true;
                vm.atLeastOneMRDocument = false;
                mrDocumentsMetierService.getInitialSieDocuments(vm.mrdocids).then(function (mrDocuments) {
                    vm.listOfMRDocuments = mrDocuments;
                    vm.listOfMRDocuments.forEach(function (item) {
                        if(vm.interventionMrDetails){
                      var differenceList =[];
                      differenceList = compareDesignation(item)
                      if(differenceList && !_.isEmpty(differenceList)) {
                        item.sameValueLength = differenceList.length.toString();
                      }else{
                        item.sameValueLength = "0";
                      }  
                    }                    
                        _.assign(item, { prMRReference: vm.mrreference })
                    })
                }, function (error) {
                    toastr.error(error, 'Error');
                }).finally(function () {
                    vm.loading = false;
                    if (vm.listOfMRDocuments) {
                        vm.atLeastOneMRDocument = (vm.listOfMRDocuments && vm.listOfMRDocuments.length > 0);
                    }
                    if(vm.interventionMrDetails){
                    vm.listOfMRDocuments = _.orderBy(vm.listOfMRDocuments,['sameValueLength'],['desc']);
                    }
                    else{
                        vm.listOfMRDocuments = _.orderBy(vm.listOfMRDocuments,['designation']);
                    }
                    blockUI.stop();
                });
            }
        }
        function compareDesignation(item){      
            var splitedValue = vm.interventionMrDetails.designation.split(':');
            var itemDesig = item.designation.split(':')
            var interventionDesignation = splitedValue[0].toLocaleLowerCase();
            var mrDesignation = itemDesig[0].toLocaleLowerCase();
            mrDesignation = mrDesignation.replace(/\s\s+/g, ' ').trim()
            return interventionDesignation.match(new RegExp(mrDesignation.split(" ").join('|'), "g"))

        }
        function close() {
            $mdDialog.cancel();
        }
        function displayMrDetails(id, isPdf) {
            var selectedInterventionId = CacheService.getObject(CacheConstants.selectedInterventionId);
            $mdDialog.cancel();
            if (isPdf == "false") {
                if(vm.interventionMrDetails){
                $mdDialog.cancel();
                }
                $state.go(RoutesConstants.documentMR, {
                    id: id,
                    plateIndex: $state.params.plateIndex,
                    refIndex: $state.params.refIndex,
                    prMRLinked: true,
                    interventionId: selectedInterventionId ? selectedInterventionId.id : ""
                });
            }
            else {
                DocumentsMetierService.returnSiePdfContent(id, 'SIE_MR')
                    .then(function (result) {
                        var url = result.contentUrl;
                        $window.open(url, '_blank');
                    });
            }
            clearSelected();
        }
        function clearSelected() {
            angular.element(document.querySelectorAll(".documents-row")).removeClass("selected");
        }
    }
})();

(function () {
  angular.module('phenix').directive('resizePr', ['$window', behavior]);
  function behavior($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {

        var debounceResize = _.debounce(function() {
          resizeDiv();
        }, 1000)

        resizeDiv();

        angular.element($window).bind('resize', debounceResize)

        function resizeDiv() {
          var elementHeight = element[0].offsetHeight;
          var elementWidth = element[0].offsetWidth;
          var elementList = ['.infoNode', 'dl', '.plancheNex'];

          if (!elementHeight && attr.container === 'svg')
            return;
          else if (attr.container === 'explodedView') {
            elementList = ['.btnShowExplodedView'];
          }
          var windowHeight = window.innerHeight;
          var windowWidth = window.innerWidth;
          var heightList = elementList.map(function (element) {
            var selectedElement = document.querySelector(element);
            if (!selectedElement)
              return 0;
            var styles = window.getComputedStyle(selectedElement);
            var heightElement = selectedElement.offsetHeight || parseFloat(styles['height'])
            var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
            return margin + heightElement;
          })
          var totalHeight = heightList.reduce(function (a, b) {
            return a + b;
          }, 0);
          var restHeight = windowHeight - totalHeight;
          if (windowHeight < windowWidth) {
            if (attr.container === 'list') {
              (restHeight < 600) ? element.css('height', (restHeight - 10) + 'px') : element.css('height', '590px');
            } else if (restHeight < 600) {
              element.css('height', (restHeight - 10) + 'px')
            } else {
              element.css('height', '590px')
            }
          } else {
            element.css('height', elementWidth - 90 + 'px')
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('phenix')
  .directive('pictoList', behavior);

  function behavior() {
    return {
      restrict: 'E',
      scope: {
        equivalentTypes: '=',
        familyCode: '='
      },
      templateUrl: 'app/components/products/documents/pr/pictoList.template.html',
      controllerAs: 'vm',
      controller: controller,
      bindToController: true,
    }
  }

  function controller(ListPieceConstants,UtilsMetierService) {

    var vm = this;

    vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();
    vm.isValuePlus = isValuePlus;
    vm.isMotrio = isMotrio;
    vm.isStandardExchange = isStandardExchange;
    vm.isRemanufacturedMotrio = isRemanufacturedMotrio;
    vm.isEcoValueUsers = UtilsMetierService.showEcoValueParts();
    vm.isEcoValue = isEcoValue;
    vm.isTractionBattery = isTractionBattery;

    function isValuePlus(){
      return _.includes(vm.equivalentTypes,ListPieceConstants.types.valuePlus);
      
    }

    function isMotrio(){
      return _.includes(vm.equivalentTypes,ListPieceConstants.types.motrio);
    }

    function isStandardExchange(){
      return _.includes(vm.equivalentTypes,ListPieceConstants.types.standardExchange);
    }

    function isTractionBattery(){
      return vm.familyCode === ListPieceConstants.tractionBatteryFamilyCode;
    }

    function isRemanufacturedMotrio(){
      var isMotrioPart = _.includes(vm.equivalentTypes,ListPieceConstants.types.motrio);
      var hasRemanFamilyCode = vm.familyCode && _.includes(ListPieceConstants.remanufacturedFamilyCodes, vm.familyCode);
      return isMotrioPart && hasRemanFamilyCode;
    }
    function isEcoValue(){
      const isEcoValuePart = _.includes(vm.equivalentTypes,ListPieceConstants.types.ecoValue);
      return vm.isEcoValueUsers && isEcoValuePart;
    }
  }

})();
(function () {
  angular
    .module('phenix')
    .directive('mtcLine', behavior);

  function behavior() {
    return {
      restrict: 'E',
      scope: {
        mtcList: '=',
        codifiedSigns: '='
      },
      templateUrl: 'app/components/products/documents/pr/mtcLine.template.html',
      controller: controller,
      controllerAs: 'ctrl',
      bindToController: true
    }
  }

    function controller() {
        this.$onInit = function () {
            var formatedCodifiedSigns = {};
            if(this.codifiedSigns) {
              this.codifiedSigns.forEach(function (elem) {
                if (formatedCodifiedSigns[elem.value]) {
                    formatedCodifiedSigns[elem.value].textAssociated += "| " + elem.textAssociated;
                } else {
                    formatedCodifiedSigns[elem.value] = { "designation": elem.designation, "textAssociated": elem.textAssociated };
                }
            })
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('listePieceSearchParts', listePieceSearchParts);

    /** @ngInject */
    function listePieceSearchParts() {
        var directive = {
            templateUrl: 'app/components/products/documents/pr/listePieceSearchParts.template.html',
            restrict: 'E',
            replace: false,
            controller: 'ListePieceCtrl',
            controllerAs: 'vm',
            bindToController: true,
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('listePieceParts', listePieceParts);

    /** @ngInject */
    function listePieceParts() {
        var directive = {
            templateUrl: 'app/components/products/documents/pr/listePieceParts.template.html',
            restrict: 'E',
            replace: false,
            controller: 'ListePieceCtrl',
            controllerAs: 'vm',
            bindToController: true,
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('ListePieceCtrl', ListePieceCtrl);

    /** @ngInject */
    function ListePieceCtrl(

        /**
         * ANGULAR SERVICES
         */
        $filter,
        $state,
        $timeout,
        $compile,
        $scope,
        $location,
        $anchorScroll,
        $window,
        $q,
        $translate,
        $rootScope,
        /**
        *  SERVICES
        */
        RoutingService,
        CacheService,
        PaymentModalMetierService,
        DealerManagerSystemeService,
        ReferenceMetierService,
        ProductMetierService,
        AlertsLocationService,
        DocumentsMetierService,
        DmsMetierService,
        AlertsService,
        EventConstants,
        ActisConstantes,
        CacheConstants,
        CodesConstants,
        UtilsMetierService,
        ListPieceConstants,
        RoutesConstants,
        /**
        * External module
        */
        toastr,
        $modal,
        blockUI,
        $mdDialog,
        ShoppingCartService,
        printPdfModalService,
        mrDocumentsMetierService,
        configConstantes,
        FileSaver, $log, PDFViewService, $http, MainMetierService, ProfilMetierService,DocPrivMetierService,
        QuoteConstants, PartRequisitionConstants, ShoppingCartServiceConstant
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var i;
        var runningDmsReferencesRequestNumber = 0;
        var centralStockQuantitySnapshot = {};
        var centralStockRefreshTimer = null;
        vm.listOfPieces = [];
        vm.loading = true;
        vm.isHtlAutorised = true;
        vm.isLoadingDMSData = false;
        vm.isLoadingPrTmLink = false;
        vm.isLoadingPrMrLink = false;
        vm.isDisplayPlatesGroupNeeded = true;
        vm.isLandscapeZoomed = false;
        var cacheProfile = CacheService.getObject(CacheConstants.profil);
        vm.frCountry = cacheProfile ? cacheProfile.country : null;
        vm.isCountrySparc = UtilsMetierService.isUserFromSparcCountry();
        vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();
        vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
        vm.isR2aStockCountry = UtilsMetierService.isR2aStockCountry();
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        var pictoImage = {
            "HERCULES_HOLE": { src: convertImgToBase64("/assets/images/Hole.png", 'HERCULES_HOLE') },
            "HERCULES_DUALITY": { src: convertImgToBase64("/assets/images/Duality.png", "HERCULES_DUALITY") },
            "HERCULES_NEW": { src: convertImgToBase64("/assets/images/NewHercule.png", "HERCULES_NEW") },
            "SAME_HERCULES": { src: convertImgToBase64("/assets/images/SameHercule.png", "SAME_HERCULES") },
            "HERCULES_DECLINED": { src: convertImgToBase64("/assets/images/Declined.png", "HERCULES_DECLINED") },
            "REACH": { src: convertImgToBase64("/assets/svg/reach.svg", "REACH") },
            "SUPERSESSION": { src: convertImgToBase64("/assets/images/supersession-pdf.png", "SUPERSESSION") },
            "MEMO": { src: convertImgToBase64("/assets/images/memo-pdf.jpg", "MEMO") },
            "KIT": { src: convertImgToBase64("/assets/images/kit-pdf.png", "KIT") },
            "STANDARD_EXCHANGE": { src: convertImgToBase64("/assets/images/renative_reman.png", "STANDARD_EXCHANGE") },
            "WARNING": { src: convertImgToBase64("/assets/images/warning-pdf.png", "WARNING") },
            "CHAIN_LOCALE": { src: convertImgToBase64("/assets/images/supersession-locale.jpg", "CHAIN_LOCALE") },
            "MOTRIO": { src: convertImgToBase64("/assets/images/motrio.png", "MOTRIO") },
            "MOTRIO_REMAN": { src: convertImgToBase64("/assets/images/motrio_reman.png", "MOTRIO_REMAN") },
            "VALUE_PLUS": { src: convertImgToBase64("/assets/images/value+.png", "VALUE_PLUS") },
            "ECO_VALUE": { src: convertImgToBase64("/assets/images/renative.png", "ECO_VALUE") },
            "RENATIVE": { src: convertImgToBase64("/assets/images/renative.png", "RENATIVE") },
            "RENAULT": { src: convertImgToBase64("/assets/images/renaultgroup.png", "RENAULT") },
            "TRIMAN": { src: convertImgToBase64("/assets/images/triman.png", "TRIMAN") }
        }
        var tranformMatrixValue = "matrix(1.93238, 0, 0, 1.93238, 19.7651, 0)";
        vm.prevSelectedIndex = '';
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.plateList = '';
        vm.isCountryChina = UtilsMetierService.isCountryTargeted('CN');
        vm.isCountryIndia = UtilsMetierService.isCountryTargeted('IN');
        vm.showCatalogPlate = false;
        vm.isMaxExceeded = false;
        vm.isAsomValidDocAccess = UtilsMetierService.checkAsomValidDocAcess();

        vm.goToProduct = goToProduct;
        vm.copyToClipboard = copyToClipboard;
        vm.onVignetteClick = onVignetteClick;
        vm.onNextPlanche = onNextPlanche;
        vm.onPrevPlanche = onPrevPlanche;
        vm.scrollVignette = scrollVignette;
        vm.HorizontalScrollVignette = HorizontalScrollVignette;
        vm.getStockClass = getStockClass;
        vm.openAlertsPopin = openAlertsPopin;
        $scope.getPriceToDisplay = getPriceToDisplay;
        $scope.getPriceToCheck = getPriceToCheck;
        vm.checkGenericPart = checkGenericPart;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.printSVG = printSVG;
        vm.getMotriosRefernces = getMotriosRefernces;
        vm.checkMotrioPlate = checkMotrioPlate;
        vm.displayComplementaryInformation = displayComplementaryInformation;
        vm.manageDisplayingMotrioParts = manageDisplayingMotrioParts;

        // NG CLASS
        vm.isBorderVignette = isBorderVignette;
        vm.isLineVignette = isLineVignette;
        vm.yellowBorder = yellowBorder;
        vm.showHideAppl = showHideAppl;
        vm.showHideAdd = showHideAdd;
        vm.updateCatalogue = updateCatalogue;
        vm.displayPPSApplicabilities = displayPPSApplicabilities;
        vm.getQuantityClass = getQuantityClass;
        vm.getStockCellClass = getStockCellClass;
        vm.isIndependentBorderVignette = isIndependentBorderVignette;
        vm.isEBBorderVignette = isEBBorderVignette;

        vm.getCodifiedSigns = getCodifiedSigns;
        vm.gotoSvg = gotoSvg;
        vm.checkHtlAutorisation = checkHtlAutorisation;
        vm.currentGroupedPlates = currentGroupedPlates;
        vm.checkGroupPlates = checkGroupPlates;
        vm.selectedPlateFromGroupPlates = selectedPlateFromGroupPlates;
        vm.gotoPrTmLink = gotoPrTmLink;
        vm.gotoPrMrLink = gotoPrMrLink;
        vm.mapPrtmLinkData = mapPrtmLinkData;
        vm.checkBrandAge = checkBrandAge;
        vm.manageDisplayingValuePlusParts = manageDisplayingValuePlusParts;
        vm.checkcatalogPlate = checkcatalogPlate;
        vm.onSelectTechnicalFamily = onSelectTechnicalFamily;
        vm.gotoCatalogPlate = gotoCatalogPlate;
        vm.isFullScreen = false;
        vm.switchLandscape = switchLandscape;
        vm.switchPRFormat = switchPRFormat;
        vm.zoomIn = zoomIn;
        vm.zoomOut = zoomOut;
        vm.resetZoom = resetZoom;
        vm.fullOrReducedScreen = fullOrReducedScreen;
        vm.openFullscreen = openFullscreen;
        vm.exitFullscreen = exitFullscreen;
        vm.applySvgPanZoom = applySvgPanZoom;
        vm.showComplementaryInfo = showComplementaryInfo;
        // Safe resize handler with SVG matrix validation
        vm.resize = _.debounce(function () {
            try {
                if (!vm.svgPanZoom) {
                    return;
                }
                const svgElement = document.getElementById('svgPanImage');
                if (!svgElement) {
                    return;
                }
                const rect = svgElement.getBoundingClientRect();
                if (rect.width <= 0 || rect.height <= 0) {
                    return;
                }
                vm.svgPanZoom.resize();
                const SVG_RESET_DELAY = 50;
                $timeout(function() {
                    try {
                        vm.svgPanZoom.resetZoom();
                        vm.svgPanZoom.center();
                    } catch (error) {
                        try {
                            vm.svgPanZoom.fit();
                        } catch (recoveryError) {
                        }
                    }
                }, SVG_RESET_DELAY);
            } catch (error) {
            }
        }, 100); 
        vm.close = close;
        vm.navigateToPlate = navigateToPlate;
        vm.currency = CacheService.getObject(CacheConstants.currency);
        ///////////////////////////////////////////////


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function isCentralStockPilot(user) {
            if (!user || !user.dealerId) {
                return false;
            }
            var isRnet = MainMetierService.isRnetUserType(user.userType);
            return isRnet && _.includes(ListPieceConstants.centralStockPilotDealers, user.dealerId);
        }

        function registerCentralStockQuantityListeners() {
            if (!vm.isCentralStockPilot) { return; }
            var events = [
                QuoteConstants.quoteUpdatedEvent,
                PartRequisitionConstants.partsRequisitionCreatedEvent,
                PartRequisitionConstants.partsRequisitionUpdatedEvent,
                ShoppingCartServiceConstant.events.cartUpdated
            ];
            var unregisterFns = _.map(events, function (eventName) {
                return $rootScope.$on(eventName, scheduleCentralStockRefresh);
            });
            $scope.$on('$destroy', function () {
                angular.forEach(unregisterFns, function (unregister) { unregister(); });
                if (centralStockRefreshTimer) { $timeout.cancel(centralStockRefreshTimer); }
            });
        }

        function scheduleCentralStockRefresh() {
            if (centralStockRefreshTimer) { $timeout.cancel(centralStockRefreshTimer); }
            centralStockRefreshTimer = $timeout(refreshCentralStockForChangedQuantities, 400);
        }

        function shouldPreventEventExecution(event, filter, isDialogContext) {
            const isRepairPage = _.includes($window.location.href, 'INT_REPAIR');
            const isSearchResultPage = _.includes($window.location.href, 'carSearchResult');
            const hasExistingScope = !_.isEmpty($scope.vm);
            
            const condition1 = !event.defaultPrevented && isRepairPage && filter.id !== "PR";
            const condition2 = !isDialogContext && hasExistingScope && !isRepairPage && !isSearchResultPage;
            
            return condition1 || condition2;
        }
        
        function shouldFetchNewPlates(initialRes, isInterventionExpand, listOfPlate) {
            if (!initialRes) {
                return true;
            }
            
            const hasCatalogPlateClick = !_.isEmpty(initialRes) && 
                                         isInterventionExpand && 
                                         isInterventionExpand.catalogPlateClick;
            if (hasCatalogPlateClick) {
                return true;
            }
            
            return _.isEmpty(initialRes.plates2) && _.isEmpty(listOfPlate);
        }
        
        function shouldUpdateInitialRes(initialRes, isInterventionExpand) {
            if (!initialRes) {
                return true;
            }
            
            if (initialRes && _.isEmpty(initialRes.plates2)) {
                return true;
            }
            
            return isInterventionExpand && !isInterventionExpand.catalogPlateClick;
        }

        this.$onInit = function () {
            // check if user is DMS connected
            
            vm.user = CacheService.getObject(CacheConstants.profil);
            vm.isLandscape = vm.user.isLandscape;
            vm.isPRFormat = vm.user.isPRFormat;
            vm.isShowCatalogue = vm.user.showCatalogue;
            vm.userContext = CacheService.getUserContext();
            vm.isUserDms = DealerManagerSystemeService.getHookResult();
            if (vm.user && vm.user.dmsConfig && vm.user.dmsConfig.userDms) {
                vm.isUserDms = true;
            }
            vm.isCentralStockPilot = isCentralStockPilot(vm.user);
            registerCentralStockQuantityListeners();
            checkHtlAutorisation();
            vm.isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            if (!vm.isSearchEngine) {
                // used for display the total of plate
                vm.numberOfPlates = 0;
                // store the current
                vm.currentIndexPlate = 0;
                vm.maxIndexPlates = 0;
                // used for display the catalog ref
                vm.currentRefCatalogPlanche = "";
                // used for display the current plate
                vm.currentPlateStd = "";

                vm.currentIndexPlanches = 0;
                vm.maxIndexPlanches = 0;
                vm.node = DocumentsMetierService.getNodeInCache();


                vm.currentRefCatalogPlanche = "";
                vm.currentPlateStd = "";

                vm.currentIndexPlate = 0;
                // get parameters from url
                if ($state.params.plateIndex) {
                    if (typeof $state.params.plateIndex === 'number') {
                        vm.currentIndexPlate = $state.params.plateIndex;
                    }
                    else {
                        vm.currentIndexPlate = parseInt($state.params.plateIndex);
                    }
                }
                // TODO remove when all previous button are manage by url parameters
                //clean sie documents history
                //while the user could click on the previous button from the browser
                //we didn't have control on this action
                CacheService.cleanSieDocumentsHistory();
                // CacheService.removeObject(CacheConstants.tabIndex);
                
                $scope.$on('phx-init-listPR', function (event, platesIDList, selectedReference, EbRefList, data) {
                    vm.isInterventionExpand = data;

                    if (!platesIDList || _.isEmpty(platesIDList)) {
                        vm.loading = false;
                        return;
                    }
                    
                    const filter = CacheService.getObject(CacheConstants.filter);
                    const isDialogContext = data && data.catalogPlateClick;

                    if (shouldPreventEventExecution(event, filter, isDialogContext)) {
                        $state.params.refIndex = 0;
                        event.preventDefault();
                        $state.params.selectedReference = '';
                        return;
                    }
                    
                    vm.ebRefList = EbRefList;
                    if (selectedReference && !_.isEmpty(selectedReference)) {
                        $state.params.selectedReference = selectedReference;
                    }

                    vm.initialRes = DocPrivMetierService.getPrResponse();
                    
                    if (shouldFetchNewPlates(vm.initialRes, vm.isInterventionExpand, vm.listOfPlate)) {
                        blockUI.start();

                        DocumentsMetierService.getPlates(platesIDList, true).then(function (platesList) {
                            if (shouldUpdateInitialRes(vm.initialRes, vm.isInterventionExpand)) {
                                vm.initialRes = {};
                                _.assign(vm.initialRes, { plates2: platesList });
                                DocPrivMetierService.setPrResponse(vm.initialRes);
                            }
                            prTabCalls(platesList);

                        }).catch(function (error) {
                            if (error) {
                                toastr.error(error);
                            }
                        }).finally(function () {
                            blockUI.stop();
                        });
                    } else {
                        prTabCalls(vm.initialRes.plates2);
                    }

                });

                $scope.$on('onSvgLoad', function (event) {
                    if(!vm.isLandscape || !vm.isFullScreen){
                        applySvgPanZoom();
                    }
                });

                $scope.$on(EventConstants.selectReferencesFromPlanche, function (event, index) {
                    if (vm.prevSelectedIndex != index) {
                        var selectedItem = _.find(vm.listOfPieces,function(item){
                            return item.index == index;
                        })
                        $state.params.selectedReference = selectedItem.reference;
                        selectedMark(index,true);
                    }
                    goToElement(index);
                });
            }
            else {
                vm.listOfPiecesCopy = [];
                $scope.$on('phx-init-listPR', function (event, searchGenericParts, isNoData) {
                    if (isNoData) {
                        vm.listOfPieces = [];
                        vm.loading = false;
                        return;
                    }
                    vm.inputFilterText = CacheService.getObject(CacheConstants.motCle);
                    if (!searchGenericParts || _.isEmpty(searchGenericParts)) {
                        vm.loading = false;
                        return;
                    }
                    vm.initialRes = DocPrivMetierService.getPrResponse();
                    if(!vm.initialRes || _.isEmpty(vm.initialRes.partsGeneric) || (!_.isEmpty(vm.initialRes) && vm.isInterventionExpand && vm.isInterventionExpand.catalogPlateClick)){
                    blockUI.start();
                    DocumentsMetierService.getPartsByGenericParts(searchGenericParts).then(function (response) {
                        if(!vm.initialRes || _.isEmpty(vm.initialRes.partsGeneric) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                        var newSearchRes ={};
                        _.assign(newSearchRes, { partsGeneric:response })
                        DocPrivMetierService.setPrResponse(newSearchRes);
                        }
                        listPieceProcessing(response);
                    });
                    }
                    else {
                        listPieceProcessing(vm.initialRes.partsGeneric);
                    }
                });
            }

        }

        function prTabCalls(platesList){
            platesList = RefinePlates(platesList);
            var catalogsList = groupPlates(platesList);

            vm.plateList = catalogsList;
            setPlatesListInformation(catalogsList);

            if (vm.currentIndexPlate >= vm.maxIndexPlates) {
                vm.currentIndexPlate = 0;
            }
            setActivePlate(catalogsList, vm.currentIndexPlate);

        }

        function listPieceProcessing(response) {
            getIntialListPiecePromise(response).then(function (filteredPieces) {

                //parse list piece to get motrios References in aletrnatives attribute
                if (!_.isEmpty(filteredPieces)) {
                    var promises = [];
                    filteredPieces.forEach(function (pieceItem) {
                        if (pieceItem && pieceItem.alternative && pieceItem.alternative.length > 0) {
                            var motrioList = getMotriosRefernces(pieceItem.alternative);
                            var centralMotrioParts = [];
                            var localMotriosParts = [];
                            var partsMotrios = {
                                central: centralMotrioParts,
                                local: localMotriosParts
                            };
                            vm.initialRes = DocPrivMetierService.getPrResponse();
                            if(!vm.initialRes || _.isEmpty(vm.initialRes.parts)){
                            if (motrioList && motrioList.length > 0) {
                                //parse motrio list to return promise for each plate
                                motrioList.forEach(function (motrioItem) {
                                    promises.push(checkMotrioPlate(motrioItem, partsMotrios).then(function (partsMotriosResponse) {
                                        if (partsMotriosResponse && partsMotriosResponse.central && partsMotriosResponse.local && ((partsMotriosResponse.central.length + partsMotriosResponse.local.length) === motrioList.length)) {
                                            pieceItem.alternative = manageDisplayingMotrioParts(pieceItem.alternative, partsMotrios);
                                            return pieceItem.alternative;
                                        }
                                    }));
                                })
                            }
                        }
                        else{
                            if (vm.initialRes.parts && vm.initialRes.parts.central && vm.initialRes.parts.local && ((vm.initialRes.parts.central.length + vm.initialRes.parts.local.length) === motrioList.length)) {
                                pieceItem.alternative = manageDisplayingMotrioParts(pieceItem.alternative, partsMotrios);
                                return pieceItem.alternative;
                            }  
                        }

                            if (vm.isCountrySparc && pieceItem.alternative.length > 0) {
                                pieceItem.alternative = manageDisplayingValuePlusParts(pieceItem.alternative);
                            }
                            if(!UtilsMetierService.showEcoValueParts() && pieceItem.alternative.length > 0){
                                pieceItem.alternative = manageDisplayingEcoPlusParts(pieceItem.alternative);
                            }
                        }
                        if (!_.isEmpty(pieceItem.additional)) {
                            pieceItem.additional.forEach(function (item) {
                                _.assign(item, { ratio: item.ratio || 1 })
                            })
                        }
                    })
                    return Promise.all(promises).then(function() {
                        return filteredPieces;
                    });
                }       
            }).then(function (listPiecesUpdated) {
                // if user is connected to a DMS we fill the stock status for each line
                CacheService.setObject(CacheConstants.listOfPiece, listPiecesUpdated);
                if (vm.isUserDms && !_.isEmpty(listPiecesUpdated)) {
                    vm.isLoadingDMSData = true;
                    runningDmsReferencesRequestNumber++;
                    var references = DmsMetierService.getSupersedingList(listPiecesUpdated);

                    vm.initialRes = DocPrivMetierService.getPrResponse();
                    if(!vm.initialRes || _.isEmpty(vm.initialRes.dmsReference) || (!_.isEmpty(vm.initialRes) && vm.isInterventionExpand && vm.isInterventionExpand.catalogPlateClick)){
                    DmsMetierService.getReferencesDms(references).then(function (response) {
                        if(!vm.initialRes || _.isEmpty(vm.initialRes.dmsReference) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                        _.assign(vm.initialRes, { dmsReference:response })
                        DocPrivMetierService.setPrResponse(vm.initialRes);
                        }
                        dmsCalls(response, listPiecesUpdated); 

                    }).catch(function () {
                        vm.isLoadingDMSData = false;
                    }).finally(function () {
                        // Always execute this on both error and success
                        runningDmsReferencesRequestNumber--;
                    });
                }
                else{
                    dmsCalls(vm.initialRes.dmsReference, listPiecesUpdated);   
                }
                }
                else if (vm.isCentralStockPilot && !_.isEmpty(listPiecesUpdated)) {
                    callCentralStockForPilot(listPiecesUpdated, null);
                }

                vm.technicalFamilyList = [];

                _.map(vm.listOfPieces, function (item) {
                    if (item.familyCode) {
                        var technicalFamily = {
                            familyCodeLabel: item.familyCodeLabel ? item.familyCodeLabel : 'NA',
                            familyCode: item.familyCode
                        }
                        vm.technicalFamilyList.push(technicalFamily);
                    }
                })
                vm.technicalFamilyList.unshift({ familyCodeLabel: $translate.instant('SELECT_ALL_RESULTS'), familyCode: '001' });
                vm.technicalFamilyList = _.uniqBy(vm.technicalFamilyList, 'familyCode');
                angular.copy(vm.listOfPieces, vm.listOfPiecesCopy);

                // to sort parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=5
                // and for the brand APL05/BRA05 and age >= 3
                if (!_.isEmpty(vm.listOfPieces)) {
                    vm.listOfPieces.forEach(function (ref) {
                        if (ref.alternative && ref.alternative.length > 0) {
                            ref.alternative = ref.alternative.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.equivalentTypesField));
                        }
                    })
                }

                CacheService.setObject(CacheConstants.listOfPiece, vm.listOfPieces);

            }).catch(function (error) {
                if (error) {
                    toastr.error(error);
                }
            }).finally(function () {
                vm.loading = false;
                var searchRedirectDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
                if (searchRedirectDetails && searchRedirectDetails.reference) {
                    vm.listOfPieces.forEach(function (ref) {
                        if (ref.reference === searchRedirectDetails.reference) {
                            $scope.$broadcast(EventConstants.selectReferencesFromPlanche, ref.index);
                        }
                    })
                }

                mapPrtmLinkData();
                vm.showCatalogPlate = true;
                blockUI.stop();
            });

        }

        function dmsCalls(response, listPiecesUpdated){
            var r2aSuperseedingList = [];
            var dmsData = DmsMetierService.buildDataFromDms(response.response.parts);
            DmsMetierService.matchReferenceFromDmsforSuperSeding(listPiecesUpdated, dmsData);
            // maintain isLoadingDMSData to true if a request is running
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            var selectedDealer = '';
            if (cachedetail && !_.isEmpty(cachedetail.dealers))
                selectedDealer = cachedetail.dealers[0].dealerId;
            if (vm.isCentralStockPilot) {
                callCentralStockForPilot(listPiecesUpdated, dmsData);
            } else if (vm.isR2aStockCountry && selectedDealer != '') {
                var r2areferences = DmsMetierService.getNoLocalStockSupersedingList(listPiecesUpdated);
                if (!_.isEmpty(r2areferences)) {
                    r2areferences = _.uniqWith(r2areferences, _.isEqual);
                    ShoppingCartService.getCentralStockDetails(r2areferences, cachedetail, selectedDealer).then(function (response) {
                        r2aSuperseedingList = DmsMetierService.matchReferenceFromR2AforSuperSeding(listPiecesUpdated, response);
                        var r2aByIndex = _.groupBy(r2aSuperseedingList, 'index');
                        if (!_.isEmpty(r2aSuperseedingList)) {
                            angular.forEach(r2aSuperseedingList, function (r2aItem) {
                                if (!r2aItem.originalPart) {
                                    ProductMetierService.getReferenceInformation(r2aItem.reference, r2aItem.reference).then(function (partResponse) {
                                        for (var y = vm.listOfPieces.length - 1; y >= 0; y--) {
                                            if (r2aItem.index == vm.listOfPieces[y].index && r2aByIndex[r2aItem.index].length == 1) {
                                                angular.forEach(vm.listOfPieces[y].superSessionDetails, function (item) {
                                                    mapR2AValues(item, partResponse, vm.listOfPieces[y], dmsData, y);
                                                })
                                            } else if (r2aItem.index == vm.listOfPieces[y].index && r2aByIndex[r2aItem.index].length > 1) {
                                                mapR2AValues(vm.listOfPieces[y].superSessionDetails[vm.listOfPieces[y].superSessionDetails.length - 1], partResponse, vm.listOfPieces[y], dmsData, y);
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            }
            if (runningDmsReferencesRequestNumber <= 1) {
                vm.isLoadingDMSData = false;
            }
            vm.listOfPieces = listPiecesUpdated;
            showComplementaryInfo();
            if (vm.isCountrySparc) {
                vm.listOfPieces.forEach(function (ref, index) {
                    checkSuperseding(ref, index);
                })
                vm.listOfPieces.forEach(function (ref) {
                    checkAlternativePrice(ref);
                })
            }

            CacheService.setObject(CacheConstants.listOfPiece, listPiecesUpdated);
            runningDmsReferencesRequestNumber--;
        }

        function callCentralStockForPilot(listPiecesUpdated, dmsData) {
            var dealer = resolveCentralStockDealer();
            if (!dealer) { return; }
            var cachedetail = dealer.cachedetail;
            var selectedDealer = dealer.dealerId;

            var stockRefs = DmsMetierService.getAllReferencesForStock(listPiecesUpdated);
            if (_.isEmpty(stockRefs)) { return; }

            vm.isLoadingDMSData = true;
            ShoppingCartService.getCentralStockDetails(stockRefs, cachedetail, selectedDealer).then(function (stockResponse) {
                DmsMetierService.attachCentralStockInfo(listPiecesUpdated, stockResponse, vm.isUserDms);
                if (dmsData) {
                    applyR2ASupersessionSwap(listPiecesUpdated, stockResponse, dmsData);
                }
                snapshotCentralStockQuantities();
            }).finally(function () {
                vm.isLoadingDMSData = false;
            });
        }

        function resolveCentralStockDealer() {
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            if (cachedetail && !_.isEmpty(cachedetail.dealers)) {
                return { cachedetail: cachedetail, dealerId: cachedetail.dealers[0].dealerId };
            }
            if (vm.user && vm.user.dealerId) {
                return { cachedetail: { r1: false }, dealerId: vm.user.dealerId };
            }
            return null;
        }

        function getCentralStockQuantity(part) {
            var quote = parseInt(part.estimateQuantity, 10);
            var requisition = parseInt(part.quantity, 10);
            return Math.max(quote > 0 ? quote : 0, requisition > 0 ? requisition : 0);
        }

        function forEachCentralStockPart(callback) {
            angular.forEach(vm.listOfPieces, function (piece) {
                callback(piece);
                angular.forEach(piece.additional, callback);
                angular.forEach(piece.alternative, function (alt) {
                    callback(alt);
                    angular.forEach(alt.additional, callback);
                });
            });
        }

        function snapshotCentralStockQuantities() {
            centralStockQuantitySnapshot = {};
            forEachCentralStockPart(function (part) {
                if (part && part.reference) {
                    centralStockQuantitySnapshot[part.reference] = getCentralStockQuantity(part);
                }
            });
        }

        function refreshCentralStockForChangedQuantities() {
            if (!vm.isCentralStockPilot || _.isEmpty(vm.listOfPieces)) { return; }

            var changedParts = [];
            var quantityByRef = {};
            forEachCentralStockPart(function (part) {
                if (!part || !part.reference) { return; }
                var current = getCentralStockQuantity(part);
                if (centralStockQuantitySnapshot[part.reference] === current) { return; }
                centralStockQuantitySnapshot[part.reference] = current;
                quantityByRef[part.reference] = current;
                changedParts.push(part);
            });
            if (_.isEmpty(changedParts)) { return; }

            var dealer = resolveCentralStockDealer();
            if (!dealer) { return; }

            var stockRefs = DmsMetierService.getAllReferencesForStock(changedParts, quantityByRef);
            if (_.isEmpty(stockRefs)) { return; }

            ShoppingCartService.getCentralStockDetails(stockRefs, dealer.cachedetail, dealer.dealerId)
                .then(function (stockResponse) {
                    DmsMetierService.attachCentralStockInfo(vm.listOfPieces, stockResponse, vm.isUserDms, true);
                });
        }

        function applyR2ASupersessionSwap(listPiecesUpdated, stockResponse, dmsData) {
            var r2aSuperseedingList = DmsMetierService.matchReferenceFromR2AforSuperSeding(listPiecesUpdated, stockResponse);
            if (_.isEmpty(r2aSuperseedingList)) { return; }
            var r2aByIndex = _.groupBy(r2aSuperseedingList, 'index');
            angular.forEach(r2aSuperseedingList, function (r2aItem) {
                if (r2aItem.originalPart) { return; }
                ProductMetierService.getReferenceInformation(r2aItem.reference, r2aItem.reference).then(function (partResponse) {
                    for (var y = vm.listOfPieces.length - 1; y >= 0; y--) {
                        if (r2aItem.index == vm.listOfPieces[y].index && r2aByIndex[r2aItem.index].length == 1) {
                            angular.forEach(vm.listOfPieces[y].superSessionDetails, function (item) {
                                mapR2AValues(item, partResponse, vm.listOfPieces[y], dmsData, y);
                            });
                        } else if (r2aItem.index == vm.listOfPieces[y].index && r2aByIndex[r2aItem.index].length > 1) {
                            mapR2AValues(vm.listOfPieces[y].superSessionDetails[vm.listOfPieces[y].superSessionDetails.length - 1], partResponse, vm.listOfPieces[y], dmsData, y);
                        }
                    }
                    DmsMetierService.attachCentralStockInfo(vm.listOfPieces, stockResponse, vm.isUserDms);
                });
            });
        }

        function mapR2AValues(item, partResponse, listePieceItem, dmsData, index) {
            if (partResponse.supersessions.length > 0)
                item.replacement = true;
            if (item.initialReference == null)
                item.initialReference = item.reference;
            item.alternative = listePieceItem.alternative;
            //item.catalogPlate = listePieceItem.catalogPlate;
            //item.catalogNumber = listePieceItem.catalogNumber;
            //item.plateNumber = listePieceItem.plateNumber;

            // item.catalogPlate = listePieceItem.id;
            // var arr = listePieceItem.id.split("_");
            // item.catalogNumber = arr[0];
            // item.plateNumber = arr[1];
            item.currency = listePieceItem.currency;
            var currentDmsItem = _.filter(dmsData, function (dmsItem) {
                if (item.reference == dmsItem.reference)
                    return dmsItem
            })
            item.priceExclTaxes = currentDmsItem[0].priceExclTaxes;
            item.description = currentDmsItem[0].description;
            item.dmsInformations = {
                cort: currentDmsItem[0].cort,
                isKnowFromDms: true,
                location: currentDmsItem[0].location,
                priceExclTaxes: currentDmsItem[0].priceExclTaxes,
                quantity: currentDmsItem[0].stockQuantity,
                siteId: currentDmsItem[0].siteId,
                siteLabel: currentDmsItem[0].siteLabel,
                stockId: currentDmsItem[0].stockId,
                stockLabel: currentDmsItem[0].stockLabel
            }
            vm.listOfPieces.splice(index, 1, item);
            CacheService.setObject(CacheConstants.listOfPiece, vm.listOfPieces);
        }
        function getIntialListPiecePromise(response) {
            var defer = $q.defer();
            if (response) {
                vm.listOfPieces = (response && response.references) ? response.references : [];
                showComplementaryInfo();
                if (response.id && !_.isEmpty(response.id)) {
                    vm.listOfPieces.forEach(function (ref) {
                        ref.plateId = response.id;
                    })
                }

                // to display parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=5
                // and for the brand APL05/BRA05 and age >= 3
                if (!_.isEmpty(vm.listOfPieces)) {
                    vm.listOfPieces.forEach(function (ref) {
                        ref.alternative = checkBrandAge(ref.alternative);

                    })
                }

                // catalogPlates
                if (vm.isSearchEngine) {
                    if (!_.isEmpty(vm.listOfPieces)) {
                        vm.listOfPieces.forEach(function (ref) {
                            var catalogPlate = checkcatalogPlate(ref.catalogPlates);
                            if (catalogPlate != null || catalogPlate != undefined || catalogPlate == '') {
                                ref.catalogPlate = catalogPlate.id;
                                //  ref.catalogNumber=catalogPlate.catalogNumber;
                                //  ref.plateNumber=catalogPlate.plateNumber;

                                var arr = catalogPlate.id.split("_");
                                ref.catalogNumber = arr[0];
                                ref.plateNumber = arr[1];


                                _.filter(catalogPlate.lines, function (item) {
                                    ref.repereNumber = item.repereNumber;
                                })
                                var indexCategory = vm.listOfPieces.indexOf(ref);
                                ref.indexOfMainArray = indexCategory;
                            }
                            else {
                                ref.catalogPlate = '-';

                            }
                        })

                        vm.listOfPieces = _.orderBy(vm.listOfPieces, 'reference', 'asc');
                        for (var i = 0; i < vm.listOfPieces.length; i++) {
                            if (i === 0 || (i > 0 && vm.listOfPieces[i].reference !== vm.listOfPieces[i - 1].reference)) {
                                vm.listOfPieces[i].alternativePlates = [];
                                for (var j = i + 1; j < vm.listOfPieces.length; j++) {
                                    if (vm.listOfPieces[i].reference === vm.listOfPieces[j].reference && vm.listOfPieces[j].catalogPlate !== vm.listOfPieces[i].catalogPlate) {
                                        var nextItem = angular.copy(vm.listOfPieces[j]);
                                        vm.listOfPieces[i].alternativePlates.push(nextItem);
                                    }
                                }
                                vm.listOfPieces[i].alternativePlates = _.uniqBy(vm.listOfPieces[i].alternativePlates, 'catalogPlate');
                            }
                        }
                        var refrenceGrouped = [];
                        var newlyCommited = [];
                        refrenceGrouped = _.groupBy(vm.listOfPieces, 'reference');
                        for (var i in refrenceGrouped) {
                            if (refrenceGrouped[i].length > 1) {
                                var sameRef = true;
                                var newSuperssionArray = [];
                                _.filter(refrenceGrouped[i], function (item) {
                                    if (item.superSessionDetails && !_.isEmpty(item.superSessionDetails)) {
                                        sameRef = false;
                                        newSuperssionArray.push(item);
                                    }
                                })
                                newSuperssionArray = _.uniqBy(newSuperssionArray, 'reference');
                                newlyCommited = _.concat(newlyCommited, newSuperssionArray)
                                if (sameRef) {
                                    var newArray = [];
                                    refrenceGrouped[i].forEach(function (item4) {
                                        newArray.push(item4);
                                    })
                                    newArray = _.uniqBy(newArray, 'reference');
                                    newlyCommited = _.concat(newlyCommited, newArray)
                                }
                            }
                            if (refrenceGrouped[i].length == 1) {
                                _.filter(refrenceGrouped[i], function (item) {
                                    newlyCommited.push(item);
                                })
                            }
                        }
                        vm.listOfPieces = newlyCommited;
                        showComplementaryInfo();

                        if (vm.isCountrySparc) {
                            var catalogGrouping = [];
                            var byReperNumber = [];
                            catalogGrouping = _.groupBy(vm.listOfPieces, 'catalogPlate');
                            byReperNumber = _.map(catalogGrouping, function (array) {
                                return _.groupBy(array, 'repereNumber')
                            });

                            var mainArray = [];
                            byReperNumber.forEach(function (item1) {
                                for (var i in item1) {
                                    var tempArray = [];
                                    var noPriceAtAll = true;
                                    item1[i].forEach(function (item2) {
                                        if (item2.priceExclTaxes) {
                                            noPriceAtAll = false;
                                            tempArray.push(item2)
                                        } else {
                                            if (!_.isEmpty(item2.superSessionDetails) && !_.isEmpty(item2.supersedingList)) {
                                                for (var i = item2.supersedingList.length - 1; i >= 0; i--) {
                                                    for (var j = 0; j < item2.superSessionDetails.length; j++) {
                                                        if (item2.superSessionDetails[j].reference == item2.supersedingList[i]) {
                                                            if (item2.superSessionDetails[j].priceExclTaxes) {
                                                                item2.superSessionDetails[j].replacement = true;
                                                                if (item2.superSessionDetails[j].initialReference == null) {
                                                                    item2.superSessionDetails[j].initialReference = item2.superSessionDetails[j].reference;
                                                                }
                                                                item2.superSessionDetails[j].alternative = item2.alternative;
                                                                item2.superSessionDetails[j].catalogPlate = item2.catalogPlate;
                                                                item2.superSessionDetails[j].catalogNumber = item2.catalogNumber;
                                                                item2.superSessionDetails[j].plateNumber = item2.plateNumber;
                                                                item2.superSessionDetails[j].indexOfMainArray = item2.indexOfMainArray;
                                                                noPriceAtAll = false;
                                                                tempArray.push(item2.superSessionDetails[j]);
                                                            }
                                                        }
                                                    }

                                                }
                                            }
                                        }
                                    })

                                    if (noPriceAtAll) {
                                        item1[i].forEach(function (item4) {
                                            tempArray.push(item4);
                                        })
                                    }
                                    mainArray = _.concat(mainArray, tempArray)
                                }
                            })
                            vm.listOfPieces = mainArray;
                            showComplementaryInfo();
                            vm.listOfPieces = _.orderBy(vm.listOfPieces, 'indexOfMainArray', 'asc');
                        }
                    }
                } else {
                    vm.listOfPieces = _.orderBy(vm.listOfPieces, 'reference', 'asc');
                }

                if (!_.isEmpty(vm.listOfPieces) && vm.isCountrySparc && !vm.isUserDms) {
                    vm.listOfPieces.forEach(function (ref, index) {
                        checkSuperseding(ref, index);
                    })
                    vm.listOfPieces.forEach(function (ref) {
                        checkAlternativePrice(ref);
                    })

                }

                vm.userType = UtilsMetierService.getUserType();

                var hasHerculesAccess = (vm.userType == "ARCA") ||
                    (vm.userType == "ASOM" && $rootScope.asomDocList && $rootScope.asomDocList['PR-HERCULES']);
                if (hasHerculesAccess) {
                    vm.HERCULES_GREEN = 0;
                    vm.HERCULES_RED_BLUE = 0;
                    vm.HERCULES_GRAY = 0;
                    if (!_.isEmpty(vm.listOfPieces)) {
                        vm.listOfPieces.forEach(function (ref, index) {
                            displayLSRPicto(ref);
                        })
                    }
                }
                //filter by codified signs
                if (!_.isEmpty(vm.listOfPieces)) {
                    vm.listOfPieces.forEach(function (ref, index) {
                        filterCodifiedSigns(ref);
                    })

                }
                
                vm.groupedByPlateArray = _(vm.listOfPieces)
                    .groupBy('catalogPlate')
                    .map(function (pieces, plate) {
                        return {
                            plate: plate,
                            piece: pieces[0],
                            pieces: flattenPieces(pieces)
                        };
                    })
                    .value();

                defer.resolve(vm.listOfPieces);




            } else {
                defer.reject();
            }

            return defer.promise;

        }
        function flattenPieces(pieces) {
            let result = [];
            pieces.forEach(function (piece) {
                result.push(piece);
                if (Array.isArray(piece.alternative) && piece.alternative.length > 0) {
                    result = result.concat(piece.alternative);
                }
            });
            return result;
        }
        function applySvgPanZoom() {
            function safeInitializeSvgPanZoom() {
                try {
                    const svgElement = document.getElementById('svgPanImage');
                    if (!svgElement) {
                        return;
                    }
                    const rect = svgElement.getBoundingClientRect();
                    if (rect.width <= 0 || rect.height <= 0) {
                        $timeout(safeInitializeSvgPanZoom, 100);
                        return;
                    }
                    vm.svgPanZoom = svgPanZoom('#svgPanImage', {
                        dblClickZoomEnabled: false,
                        zoomEnabled: false,
                        fit: true,
                        center: true,
                        minZoom: 1,
                        maxZoom: 4,
                        zoomScaleSensitivity: 0.2,
                        controlIconsEnabled: false,
                        onError() {
                            toastr.error($translate.instant("ERROR"));
                        }
                    });
                } catch (error) {
                }
            }
            
            function handleWheelEvent(event, target, isCtrlDown) {
                if (!isCtrlDown) {
                    event.preventDefault();
                    return;
                }
                
                event.preventDefault();
                const rect = target.getBoundingClientRect();
                
                if (rect.width <= 0 || rect.height <= 0) {
                    return;
                }
                
                const offsetX = event.clientX - rect.left;
                const offsetY = event.clientY - rect.top;
                const originX = offsetX / rect.width;
                const originY = offsetY / rect.height;

                try {
                    if (event.deltaY < 0) {
                        vm.svgPanZoom.zoomIn();
                    } else {
                        vm.svgPanZoom.zoomOut();
                    }
                    vm.svgPanZoom.zoomAtPoint(originX, originY);
                } catch (zoomError) {
                }
            }
            
            function setupEventHandlers() {
                try {
                    const target = document.getElementById('svgPanImage');
                    let isCtrlDown = false;
                    
                    window.addEventListener('keydown', function (e) {
                        if (e.key === 'Control') {
                            isCtrlDown = true;
                        }
                    });

                    window.addEventListener('keyup', function (e) {
                        if (e.key === 'Control') {
                            isCtrlDown = false;
                        }
                    });
                    
                    if (target) {
                        target.addEventListener('wheel', function (event) {
                            handleWheelEvent(event, target, isCtrlDown);
                        }, { passive: false });
                    }
                    angular.element($window).on('resize', vm.resize);
                } catch (error) {
                }
            }
            
            $timeout(safeInitializeSvgPanZoom, 0);
            $timeout(setupEventHandlers, 0);
        };

        function switchLandscape(isLandscape) {
            vm.isLandscape = isLandscape;
            var cacheProfile = CacheService.getObject(CacheConstants.profil);
            cacheProfile.isLandscape = isLandscape;
            CacheService.setObject(CacheConstants.profil, cacheProfile);
            ProfilMetierService.updateLandscapeMode(isLandscape);
            var index = vm.currentIndexPlate;
            if (vm.listOfPlate && !_.isEmpty(vm.listOfPlate)) {
                initSVG(vm.listOfPlate[index]);
            }
            $rootScope.$broadcast("isLandscape", vm.isLandscape);
        }
        function switchPRFormat(isPRFormat) {
            vm.isPRFormat = isPRFormat;
            const profilData = CacheService.getObject(CacheConstants.profil);
            profilData.isPRFormat = isPRFormat;
            CacheService.setObject(CacheConstants.profil, profilData);
            ProfilMetierService.updatePRFormat(isPRFormat).then(function () {
                $rootScope.$applyAsync();
            });
        }

        function updateCatalogue(isCatalogue) {
            ProfilMetierService.updateCatalogueMode(isCatalogue).then(function () {
            vm.isShowCatalogue = isCatalogue;
            var cacheProfile = CacheService.getObject(CacheConstants.profil);
            cacheProfile.showCatalogue = isCatalogue;
            CacheService.setObject(CacheConstants.profil, cacheProfile);
            })
        .catch(function (error) {
            console.error("Failed to update catalogue mode:", error);
            });
        }

        function zoomIn() {
            if(vm.isLandscape && !vm.isFullScreen){
                vm.isLandscapeZoomed = true;
                const currentZoom = vm.svgPanZoom.getZoom();
                const tempMaxZoom = 5;
            
                if (currentZoom < tempMaxZoom) {
                    vm.svgPanZoom.setMaxZoom(tempMaxZoom);
                    vm.svgPanZoom.zoomIn();
                    vm.svgPanZoom.center();
                }
                vm.svgPanZoom.setMaxZoom(5);
            }
            else{
                vm.isLandscapeZoomed = false;
                vm.svgPanZoom.zoomIn();
            }
        }

        function zoomOut() {
            vm.svgPanZoom.zoomOut();
            resizeSvg();
        }

        function resetZoom() {
            try {
                if (!vm.svgPanZoom) {
                    return;
                }
                const svgElement = document.getElementById('svgPanImage');
                if (!svgElement) {
                    return;
                }
                const rect = svgElement.getBoundingClientRect();
                if (rect.width <= 0 || rect.height <= 0) {
                    return;
                }
                if (svgElement.offsetParent === null) {
                    return;
                }
                vm.svgPanZoom.resetZoom();
                vm.svgPanZoom.center();
                resizeSvg();

            } catch (error) {
                try {
                    vm.svgPanZoom.fit();
                } catch (recoveryError) {
                }
            }
        }

        function fullOrReducedScreen() {
            if (vm.isFullScreen) {
                vm.exitFullscreen();
            } else {
                vm.openFullscreen();
            }
        }

        function openFullscreen() {
            vm.isFullScreen = true;
            var element = document.getElementById("divSvgContent")
            var newDivision = document.createElement("div");
            newDivision.classList.add("newElement");
            var newSpan = document.createElement("span");
            var newButton = document.createElement("p");
            newButton.classList.add("custom-material-icons", "material-icons", "material-icons-fullscreen-svg");
            newButton.setAttribute('id', 'logo');
            newButton.onclick = function () {
                exitFullscreen();
            };
            newSpan.appendChild(newButton);
            newDivision.appendChild(newSpan);
            element.appendChild(newDivision);
            vm.elemToZoomContainer = document.getElementById('divSvgContent');
            $rootScope.$broadcast("exitFullScreen", vm.isFullScreen);
            if (vm.elemToZoomContainer.requestFullscreen) {
                vm.elemToZoomContainer.requestFullscreen();
            } else if (vm.elemToZoomContainer.mozRequestFullScreen) { /* Firefox */
                vm.elemToZoomContainer.mozRequestFullScreen();
            } else if (vm.elemToZoomContainer.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                vm.elemToZoomContainer.webkitRequestFullscreen();
            } else if (vm.elemToZoomContainer.msRequestFullscreen) { /* IE/Edge */
                vm.elemToZoomContainer.msRequestFullscreen();
            }
            if (vm.selectedIndexForFS) {
                vm.listOfPieces.forEach(function (item) {
                    if (item.index == vm.selectedIndexForFS) {
                        $scope.$emit("showRefDesg", item);
                    }
                })
            }
        }

        document.addEventListener("fullscreenchange", function (event) {
            if (document && !document.fullscreenElement) {
                exitFullscreen();
            }
        });
        function exitFullscreen() {
            vm.isFullScreen = false;
            var list = document.getElementById("divSvgContent");
            $timeout(function () {
                var exitScreen = document.getElementsByClassName("svg-pan-zoom_viewport");
                if (!_.isEmpty(exitScreen)) {
                    if(!vm.isLandscape){
                        exitScreen[0].attributes.transform.nodeValue = tranformMatrixValue;
                        exitScreen[0].style.transform = tranformMatrixValue;
                    }
                    else{
                        exitScreen[0].attributes.transform.nodeValue = "matrix(1.91379, 0, 0, 1.91379, 8.85098e-06, 16.1121)";
                        exitScreen[0].style.transform = "matrix(1.91379, 0, 0, 1.91379, 8.85098e-06, 16.1121)";
                    }
                    if (list && list.children.length > 0) {
                        list.children[0].appendChild(exitScreen[0]);
                    }
                }
            }, 1000);
        
            if (list && list.children && list.children.length >= 2) {
                while (list.children.length > 1) {
                    list.removeChild(list.lastChild);
                }
            }
        
            try {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                    vm.svgPanZoom.resize(); 
                    vm.svgPanZoom.resetZoom();
                    vm.svgPanZoom.center();
                    vm.svgPanZoom.fit();                    
                }
                $rootScope.$broadcast("exitFullScreen", vm.isFullScreen);
            } catch (error) {
                console.error("Error exiting fullscreen:", error);
            }
        }

        function resizeSvg() {
            var list = document.getElementById("divSvgContent");
            $timeout(function () {
                var resizeScreen = document.getElementsByClassName("svg-pan-zoom_viewport");
                if (!_.isEmpty(resizeScreen) && resizeScreen[0].style.transform.includes('matrix(2.04598, 0, 0') && !resizeScreen[0].style.transform.includes('matrix(1.93238, 0, 0, 1.93238, 19.7651, 0')) {
                    resizeScreen[0].attributes.transform.nodeValue = tranformMatrixValue;
                    resizeScreen[0].style.transform = tranformMatrixValue;
                    list.children[0].appendChild(resizeScreen[0]);
                }
            }, 100);
        }

        function compare(a, b) {
            var arrA = a.id.split("_");
            var arrB = b.id.split("_");
            var catalogNumberA = arrA[0];
            var plateNumberA = arrA[1];
            var catalogNumberB = arrB[0];
            var plateNumberB = arrB[1];

            if (catalogNumberA === "NA" || catalogNumberB === "NA") {
                return -1;
            }
            return a.catalogNumber - b.catalogNumber || a.plateNumber - b.plateNumber;
            // if (a.catalogNumber === "NA" ||  b.catalogNumber === "NA") {
            //     return -1;
            // }
            // return a.catalogNumber - b.catalogNumber || a.plateNumber - b.plateNumber;

        }
        /**
         *  Return class for quantity field in case of stock = 0 or stock > 0 or no stock available
         *  @param {*} quantity
         */

        function getQuantityClass(quantity) {
            var quantityClass = "";

            if (_.isNumber(quantity)) {
                if (quantity > 0) {
                    quantityClass += "stockDispo"
                } else {
                    quantityClass += "stockIndispo";
                }
            } else {
                quantityClass += "noStock";
                if (vm.controllerAs == "vm") {
                    quantityClass += " noStockEB";
                }
            }

            return quantityClass;
        }

        function getStockCellClass(quantity, legacyOffsetClass) {
            if (!vm.isCentralStockPilot) {
                return [legacyOffsetClass || '', getQuantityClass(quantity)];
            }
            return vm.isLandscape
                ? ['central-stock-cell', 'central-stock-cell--landscape']
                : ['central-stock-cell'];
        }

        this.$onDestroy = function () {
            angular.element($window).off('resize', vm.resize);
        };

        function convertImgToBase64(url, objVal) {
            if((!vm.nissanUserURL) || (vm.nissanUserURL && objVal === "TRIMAN")){
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.onload = function () {
                    canvas.height = img.height;
                    canvas.width = img.width;
                    ctx.drawImage(img, 0, 0);
                    var dataURL = canvas.toDataURL('image/png');
                    pictoImage[objVal].value = dataURL;
                    canvas = null;
                };
                img.src = url;
            }
        }
        /**
        * @description Used to download electrical schema in context
        * @param {*} locationURL
        */
        function printSVG(locationURL) {
            setTimeout(function () {
                var noImagePrint = false;
                if (locationURL != 'assets/svg/no_image.svg') {
                    var SVGDomElement = document.querySelector('svg#svgPanImage');
                    var SVGDomElement1 = SVGDomElement.cloneNode(true);
                    var selectedSvgRef = SVGDomElement1.querySelectorAll('svg');
                    if (selectedSvgRef && selectedSvgRef.length > 0) {
                        angular.forEach(selectedSvgRef, function (svgTag) {
                            svgTag.remove();
                        })
                    }
                    SVGDomElement1.setAttribute("viewBox", "0 0 715 600");
                    //var serializedSVG = new XMLSerializer().serializeToString(SVGDomElement1);
                    var serializedSVG = SVGDomElement1;
                } else {
                    noImagePrint = true;
                }
                downloadPdf(serializedSVG, noImagePrint).then(function (response) {
                    pdfMake.tableLayouts = {
                        otherTableLayout: {
                            hLineWidth: function () {
                                return 1;
                            },
                            vLineWidth: function () {
                                return 1;
                            }
                        }
                    };
                    var pdfDocGenerator = pdfMake.createPdf(response.data);
                    pdfDocGenerator.getBuffer(function (buffer) {
                        var file = new Blob([(buffer)], { type: 'application/pdf' });
                        var isIE = false || !!document.documentMode;
                        var isEdge = !isIE && !!window.StyleMedia;
                        if (isIE || isEdge) {
                            FileSaver.saveAs(file, $translate.instant("LOCATION_CATA") + ".pdf");
                        } else {
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                    })
                });
            }, 100)
        }

        function openAlertsPopin() {
            if (!AlertsService.getPopinVisibility().status) {
                var incident = AlertsLocationService.getAlerts();
                // AlertsWSService.getIncidentAlerts(incident).then(function (response) {
                //     AlertsService.buildIncidentNature(response);
                // });
            }
            AlertsService.setPopinVisibility(true,'PR',null, false);
            AlertsLocationService.setCurrentPlate(vm.currentRefCatalogPlanche);
        }

        function checkHtlAutorisation() {
            var carContext = CacheService.getCarContext();
            var profil = CacheService.getObject(CacheConstants.profil);

            if (!carContext || !profil || (carContext && !carContext.vin && !carContext.registrationNumber) || !profil.dealerLogisticIds || profil.dealerLogisticIds === "rejected") {
                vm.isHtlAutorised = false;
            }
        }

        function isBorderVignette(id) {
            if (id == vm.currentIndexPlate) {
                return 'phx-img-ratio-1-1-vignette_border';
            }
            return 'phx-img-ratio-1-1-vignette_noborder';
        }

        function isIndependentBorderVignette(id) {
            if (id == vm.currentIndexPlate) {
                return 'phx-div-ratio-1-1-vignette_border';
            }
            return 'phx-div-ratio-1-1-vignette_noborder';
        }

        function isEBBorderVignette(id) {
            if (id == vm.currentIndexPlate) {
                return 'phx-div-ratio-1-1-EB-vignette_border';
            }
            return 'phx-div-ratio-1-1-EB-vignette_noborder';
        }

        function isLineVignette(id) {
            if (id === vm.currentIndexPlate && checkGroupPlates()) {
                return 'line';
            }
            return '';
        }

        function yellowBorder() {
            if (checkGroupPlates())
                return 'verticalYellowBorder';
            return 'verticalTransparentBorder';
        }

        /**
         * Navigation to product page
         * @param {*} piece
         */
        function goToProduct(piece, tabToRedirect) {
            $state.transitionTo($state.$current.name, { refIndex: piece.index, plateIndex: vm.currentIndexPlate }, {
                location: "replace",
                inherit: true,
                relative: $state.$current,
                notify: false,
            })
            angular.element(function () {
                var path = {
                    reference: piece.reference,
                    mainReference: piece.initialReference,
                    refIndex: piece.index,
                    plateIndex: vm.currentIndexPlate
                }
                // here we check if the function has a second parameter. In this case we call the service to return the correct index
                if (tabToRedirect) {
                    _.extend(path, UtilsMetierService.extendPathWithTabToRedirect(tabToRedirect));
                }
                RoutingService.goToProductPage({
                    path: path
                })
            });
        }
        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        //#region Scroll managment to display the current active Plate (Vignette)

        /**
         * @name scrollToVignette
         * @desc scroll to the active vignette
         * @param {int} index index of active plate
         */
        function scrollToVignette(index) {
            angular.element(function () {
                var vignetteElement = angular.element(document.querySelector("#vignette_" + index));
                var scrollElement = document.getElementById("scrollVignetteContainer");
                if (scrollElement) {
                    scrollElement.scrollTop = -220 + (220 * index);
                }
            });
        }

        /**
         * @name scrollVignette
         * @desc scroll down to vignette
         * @param direction direction of scroll available values ['left', 'right']
         */
        function HorizontalScrollVignette(direction) {
            var elmnt = document.getElementById("HorizontalScrollVignetteContainer");
            var scrollValue = 75;
            if (direction === "left") {
                elmnt.scrollLeft -= scrollValue;
            } else {
                elmnt.scrollLeft += scrollValue;
            }
        }

        /**
         * @name scrollVignette
         * @desc scroll down to vignette
         * @param direction direction of scroll available values ['up', 'down']
         */
        function scrollVignette(direction) {
            var elmnt = document.getElementById("scrollVignetteContainer");
            var scrollValue = 75;
            if (direction === "up") {
                elmnt.scrollTop -= scrollValue;
            }
            else {
                elmnt.scrollTop += scrollValue;
            }
        }
        //#endregion

        function gotoCatalogPlate(piece) {
            DocumentsMetierService.filterSelectedIds(piece, 'PR');
        }

        function onSelectTechnicalFamily(selectedTechnicalFamily) {
            angular.copy(vm.listOfPiecesCopy, vm.listOfPieces);
            var filterdListOfPieces = [];
            if (selectedTechnicalFamily && selectedTechnicalFamily.familyCode) {
                vm.listOfPieces.forEach(function (item) {
                    if (selectedTechnicalFamily.familyCode === item.familyCode && selectedTechnicalFamily.familyCodeLabel === item.familyCodeLabel) {
                        filterdListOfPieces.push(item);
                    }
                    if (item.familyCodeLabel === null && selectedTechnicalFamily.familyCode === item.familyCode && selectedTechnicalFamily.familyCodeLabel === "NA") {
                        filterdListOfPieces.push(item);
                    }
                });
                vm.listOfPieces = filterdListOfPieces;
                showComplementaryInfo();
            }
            vm.groupedByPlateArray = _(vm.listOfPieces)
                .groupBy('catalogPlate')
                .map(function (pieces, plate) {
                    return {
                        plate: plate,
                        piece: pieces[0],
                        pieces: flattenPieces(pieces)
                    };
                })
                .value();
        }

        function onVignetteClick(id) {
            DocPrivMetierService.removePrResponse();
            vm.isDisplayPlatesGroupNeeded = true;

            for (i = 0; i < vm.listOfPlate.length; i++) {
                if (id === vm.listOfPlate[i].id) {
                    vm.currentIndexPlate = i;
                }
            }
            vm.initialRes ={}
            _.assign(vm.initialRes, { plates2:vm.listOfPlate })
            DocPrivMetierService.setPrResponse(vm.initialRes);
            setActivePlate(vm.listOfPlate, vm.currentIndexPlate);
            scrollTop();
            // Replace the value of the plateIndex parameter in the url to ensure back button to work
            // with set refIndex to 0 to ensure that a new active plate have not repere selectioned
            $state.transitionTo($state.$current.name, { plateIndex: vm.currentIndexPlate, refIndex: 0 }, {
                location: "replace",
                inherit: true,
                relative: $state.$current,
                notify: false
            });
        }

        function scrollTop() {
            if ($('#listePiece').offset()) {
                $('html, body').animate({ scrollTop: $('#listePiece').offset().top }, 100);
            }
        }

        function onNextPlanche() {
           DocPrivMetierService.removePrResponse();
            var index = vm.currentIndexPlate + 1;
            if (index < vm.maxIndexPlates) {
                scrollTop();
                onVignetteClick(vm.listOfPlate[index].id);
                scrollToVignette(vm.currentIndexPlate);
            }
        }

        function onPrevPlanche() {
            DocPrivMetierService.removePrResponse();
            var index = vm.currentIndexPlate - 1;
            if (index >= 0) {
                scrollTop();
                onVignetteClick(vm.listOfPlate[index].id);
                scrollToVignette(vm.currentIndexPlate);
            }
        }

        function scrollToHash(hash) {
            $timeout(function () {
                $location.hash(hash);
                $anchorScroll();
            }, 0, false);
        }


        function displayPPSApplicabilities(pps) {
            pps.forEach(function (ref) {
                ref.displayPPS = angular.isUndefined(ref.displayPPS) ? true : !ref.displayPPS;
            });
        }

        function currentGroupedPlates() {
            if (!vm.listOfPlate)
                return [];
            return vm.listOfPlate[vm.currentIndexPlate].groupPlatesStd;
        }

        function checkGroupPlates() {
            if (!vm.listOfPlate || !vm.isDisplayPlatesGroupNeeded)
                return false;

            var residual = vm.listOfPlate[vm.currentIndexPlate].residual
            return residual.length > 0 ? true : false;
        }

        function selectedPlateFromGroupPlates(plate, repere) {
            vm.isDisplayPlatesGroupNeeded = false;
            scrollTop();
            var newPlate = _.extend({}, plate);
            var index = vm.currentIndexPlate;
            newPlate.groupPlatesStd = vm.listOfPlate[index].groupPlatesStd;
            vm.listOfPlate[index] = newPlate;
            vm.currentRefCatalogPlanche = getCurrentRefCatalogPlanche(index, vm.listOfPlate);

            if (vm.listOfPlate[index] && vm.listOfPlate[index].id) {
                getPlateLines(vm.listOfPlate[index]);
            }

        }

        function groupPlates(list) {
            var deletedIndex = [];
            function condition(item, index) {
                return {
                    residual: item.residual && item.residual.length,
                    exist: deletedIndex.indexOf(index) === -1
                }
            }

            function search(index, catalogPlateItem) {
                var samePlates = [];
                for (; list[index]; index++) {
                    var item = list[index];
                    var c = condition(item, index);
                    var catalogPlate = item.id.split("_");
                    var listCP = catalogPlateItem.id.split("_");
                    var samePlateStd = catalogPlateItem.gieNumber === item.gieNumber &&
                        listCP[0] === catalogPlate[0];

                    // var samePlateStd = catalogPlateItem === item.standardCatalogPlate;

                    if (c.exist && c.residual && samePlateStd) {
                        deletedIndex.push(index);
                        samePlates.push(_.extend({}, item));
                    }
                }
                return samePlates;
            }

            return list.map(function (item, index) {
                item = _.extend({}, item);
                // var standardCatalogPlate = item.standardCatalogPlate;
                var c = condition(item, index);
                if (c.exist && c.residual) {
                    // item.groupPlatesStd = search(index, standardCatalogPlate);
                    item.groupPlatesStd = search(index, item);
                    return item;
                } else if (c.exist) {
                    item.groupPlatesStd = [_.extend({}, item)];
                    return item;
                }
                return null;
            }).filter(function (item) { return item });
        }

        function getCurrentRefCatalogPlanche(index, list) {
            return list[index].id.split("_").join(" / ");
            // return list[index].catalogNumber + " / " + list[index].plateNumber;
        }

        function getCurrentPlateStd(index, list) {
            var catalogPlate = list[index].id.split('_');
            return catalogPlate[0] + ' / ' + list[index].gieNumber;
            // return list[index].catalogNumber + ' / ' + list[index].standardPlate;
        }

        /**
         *
         * @param {*} listOfPieces
         * @param {*} indexPR
         */
        function setPlatesListInformation(catalogsList) {
            if (!catalogsList.length) {
                return;
            }
            vm.numberOfPlate = catalogsList.length;


            /* TEMPORAIRE */
            $scope.$emit('updatedCountTab', { "documentType": 'PR', 'count': catalogsList.length });

            vm.listOfPlate = catalogsList;
            vm.maxIndexPlates = catalogsList.length;
        }

        /**
         * load and display all product reference for a plate
         */
        function setActivePlate(catalogsList, indexPR) {
            if (!catalogsList.length)
                return
            if (!indexPR)
                indexPR = 0;


            vm.currentRefCatalogPlanche = getCurrentRefCatalogPlanche(indexPR, catalogsList);
            vm.currentPlateStd = getCurrentPlateStd(indexPR, catalogsList);

            scrollToVignette(indexPR);

            if (!checkGroupPlates() && catalogsList[indexPR] && catalogsList[indexPR].id) {

                getPlateLines(catalogsList[indexPR]);

            }

        }

        function getPlateLines(plate) {
                vm.initialRes = DocPrivMetierService.getPrResponse();
                if(!vm.initialRes || _.isEmpty(vm.initialRes.lines) || (!_.isEmpty(vm.initialRes) && vm.isInterventionExpand && vm.isInterventionExpand.catalogPlateClick)){
            blockUI.start();
            DocumentsMetierService.getPlateLines(plate).then(function (response) {
                if(!vm.initialRes || _.isEmpty(vm.initialRes.lines) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                _.assign(vm.initialRes, { lines:response })
               DocPrivMetierService.setPrResponse(vm.initialRes);
                }
                linesCall(response,plate)
            }
            ).catch(function (error) {
                if (error) {
                    toastr.error(error);
                }
                initSVG(plate);
                vm.listOfPieces = [];
                blockUI.stop();
            });
        }
        else{
            linesCall(vm.initialRes.lines,plate)
        }
        }

        function linesCall(response,plate){
            vm.selectedIndexForFS = 0;
            var redirectedIndex;
            if ((typeof $state.params.selectedReference == 'string' && $state.params.selectedReference != '') || (vm.selectedReference)) {
                redirectedIndex = response.references.filter(function (item) {
                    return $state.params.selectedReference == item.reference || vm.selectedReference == item.reference;
                })
            }
            (redirectedIndex && !_.isEmpty(redirectedIndex)) ? initSVG(plate, redirectedIndex[0].index) : initSVG(plate);
            listPieceProcessing(response);
        }


        // to display parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=4
        // and for the brand APL05/BRA05 and age >= 3
        function checkBrandAge(ref) {

            if (ref && ref.length > 0) {
                for (var i = ref.length - 1; i >= 0; i--) {
                    var currentAlternativePart = ref[i];
                    if (currentAlternativePart && (_.includes(currentAlternativePart.equivalentTypes, ListPieceConstants.types.motrio) ||
                        _.includes(currentAlternativePart.equivalentTypes, ListPieceConstants.types.valuePlus)) && !(DocumentsMetierService.brandAgeAcceptable("4", "3"))) {

                        ref.splice(i, 1);
                    }
                }
            }
            return ref;
        }


        function checkcatalogPlate(ref) {
            var catalogPlate;
            if (ref && ref.length > 0) {
                catalogPlate = ref[0];
            }
            return catalogPlate;
        }

        function manageDisplayingValuePlusParts(alternativeItems) {


            for (var i = alternativeItems.length - 1; i >= 0; i--) {

                if (_.includes(alternativeItems[i].equivalentTypes, ListPieceConstants.types.valuePlus) &&
                    !alternativeItems[i].priceExclTaxes) {
                    alternativeItems.splice(i, 1);
                }
            }

            return alternativeItems;
        }

        function manageDisplayingEcoPlusParts(alternativeItems) {
            for (let x = alternativeItems.length - 1; x >= 0; x--) {
                if (_.includes(alternativeItems[x].equivalentTypes, ListPieceConstants.types.ecoValue)) {
                    alternativeItems.splice(x, 1);
                }
            }
            return alternativeItems;
        }

        //map tm docids to references
        function mapPrtmLinkData() {
            if (!_.isEmpty(vm.listOfPieces)) {

                vm.genericPartList = _.omitBy(_.map(vm.listOfPieces, 'genericPart'), (_.isEmpty || _.isNull));
                vm.genericPartList = _.filter(vm.genericPartList, function (item) {
                    return item && item.charAt(0) != "L";
                })
                vm.listOfPieces.forEach(function (ref, index) {
                    ref.docIds = [];
                    ref.MRdocIds = [];
                })
                if (!_.isEmpty(vm.genericPartList)) {
                    vm.initialRes = DocPrivMetierService.getPrResponse();
                    if(!vm.initialRes || _.isEmpty(vm.initialRes.elementsGeneric) || (!_.isEmpty(vm.initialRes) && vm.isInterventionExpand && vm.isInterventionExpand.catalogPlateClick)){
                    DocumentsMetierService.getElementsByGenericParts(vm.genericPartList).then(function (res) {
                        if(!vm.initialRes || _.isEmpty(vm.initialRes.elementsGeneric) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                        _.assign(vm.initialRes, { elementsGeneric:res })
                        DocPrivMetierService.setPrResponse(vm.initialRes);
                        }
                        genericCallFilter(res)
                    }).catch(function (error) {
                        if (error) {
                            vm.isLoadingPrTmLink = false;
                            vm.isLoadingPrMrLink = false;
                            toastr.error(error);
                        }
                    });
                }
                else{
                    genericCallFilter(vm.initialRes.elementsGeneric)
                }
                }
            }
        }
        function genericCallFilter(res){
            var mapelements = []
            var mapTmIds = [];
            vm.isLoadingPrTmLink = true;
            vm.isLoadingPrMrLink = true;
            if (res) {
                vm.elements = res;
                for (var i = 0; i < vm.elements.length; i++) {
                    mapelements[vm.elements[i].genericPart] = vm.elements[i].elements;
                }
                var elementsOpe = Object.keys(mapelements).map(function (key) { return mapelements[key]; })
                if (!_.isEmpty(elementsOpe)) {
                    var docTypes = ["TM", "MR"];
                    vm.initialRes = DocPrivMetierService.getPrResponse();
                    if(!vm.initialRes || _.isEmpty(vm.initialRes.elemOpe) || (!_.isEmpty(vm.initialRes) && vm.isInterventionExpand && vm.isInterventionExpand.catalogPlateClick)){
                    DocumentsMetierService.getIDsBySieElemOpe(elementsOpe, docTypes).then(function (res) {
                        if(!vm.initialRes || _.isEmpty(vm.initialRes.elemOpe) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                        _.assign(vm.initialRes, { elemOpe:res })
                        DocPrivMetierService.setPrResponse(vm.initialRes);
                        }
                        elemOpeFilter(res,mapTmIds, mapelements)
                    }).catch(function (error) {
                        if (error) {
                            vm.isLoadingPrTmLink = false;
                            vm.isLoadingPrMrLink = false;
                            toastr.error(error);
                        }
                    }).finally(function () {
                        angular.copy(vm.listOfPieces, vm.listOfPiecesCopy);
                    });
                }
                else{
                    elemOpeFilter(vm.initialRes.elemOpe,mapTmIds, mapelements) 
                }
                }
                else {
                    vm.isLoadingPrTmLink = false;
                    vm.isLoadingPrMrLink = false;
                }
            }
        }

        function elemOpeFilter(res,mapTmIds, mapelements){
            vm.genericElementList = mapelements;
            const excludedElements = ['ELEM-004674', 'ELEM-346616'];            
            vm.laborttimeIds = res;
                        if (vm.laborttimeIds && !_.isEmpty(vm.laborttimeIds)) {
                            for (var i = 0; i < vm.laborttimeIds.length; i++) {
                                mapTmIds[vm.laborttimeIds[i].element] = vm.laborttimeIds[i].docs ? vm.laborttimeIds[i].docs : [];
                            }
                            Object.keys(mapelements).forEach(function (key) {
                                vm.listOfPieces.forEach(function (ref, index) {
                                    if (ref.genericPart === key) {
                                        if (mapelements[key].length > 1) {
                                            mapelements[key].forEach(function (value) {
                                                if (!_.isEmpty(mapTmIds[value])) {
                                                    mapTmIds[value].forEach(function (item) {
                                                        if (item.type == 'TM')
                                                            ref.docIds.push(item.id);
                                                        else if (item.type == 'MR')
                                                            ref.MRdocIds.push(item.id);
                                                    })
                                                }
                                            })
                                        } else {
                                            if (!_.isEmpty(mapTmIds[mapelements[key]])) {
                                                mapTmIds[mapelements[key]].forEach(function (item) {
                                                    if (item.type == 'TM')
                                                        ref.docIds.push(item.id);
                                                    else if (item.type == 'MR')
                                                        ref.MRdocIds.push(item.id);
                                                })
                                            }
                                        }
                                        
                                        const hasTmDocIds = ref.docIds.length > 0;
                                        const hasMrDocIds = ref.MRdocIds.length > 0;
                                        var hasOnlyExcludedElements = false;
                                        var hasOtherElements = false;
                                        
                                        if (mapelements[key] && mapelements[key].length > 0) {
                                            hasOnlyExcludedElements = mapelements[key].every(function(element) {
                                                return excludedElements.includes(element);
                                            });
                                            hasOtherElements = mapelements[key].some(function(element) {
                                                return !excludedElements.includes(element);
                                            });
                                        }
                                        ref.hideGrayPictoWhenEmpty = !hasTmDocIds && hasOnlyExcludedElements && !hasOtherElements;
                                        ref.hideMrGrayPictoWhenEmpty = !hasMrDocIds && hasOnlyExcludedElements && !hasOtherElements;
                                    }
                                })
                            });
                        }
                        vm.isLoadingPrTmLink = false;
                        vm.isLoadingPrMrLink = false;
        }
        /**
         * @name getMotriosRefernces
         * @desc get motrios references list
         * @param {Array} alternativeParts
         */
        function getMotriosRefernces(alternativeParts) {
            var listMotrioReferences = [];
            if (alternativeParts && alternativeParts.length > 0) {
                angular.forEach(alternativeParts, function (currentAlternativePart) {
                    if (currentAlternativePart && (_.includes(currentAlternativePart.equivalentTypes, ListPieceConstants.types.motrio))) {
                        listMotrioReferences.push(currentAlternativePart.reference);
                    }
                })
            }
            return listMotrioReferences;
        }

        /**
         * @name checkMotrioPlate
         * @desc call parts service for motrio item and return updated partsMotrios object (local or central)
         * @param {String} motrioItem
         * @param {Object} partsMotrios
         */
        function checkMotrioPlate(motrioItem, partsMotrios) {
            return ProductMetierService.getReferenceInformationRaw(motrioItem).then(function (partResponse) {
        
                if (isCentralMotrioPart(partResponse)) {
                    partsMotrios.central.push(motrioItem);
                }
                else if (isLocalMotrioPart(partResponse)) {
                    partsMotrios.local.push(motrioItem);
                }
                if(!vm.initialRes || _.isEmpty(vm.initialRes.parts) || vm.isInterventionExpand && !vm.isInterventionExpand.catalogPlateClick){
                _.assign(vm.initialRes, { parts:partsMotrios })
                DocPrivMetierService.setPrResponse(vm.initialRes);
                }
                return partsMotrios;
            });
        }

        /**
         * @name isLocalMotrioPart
         * @desc check if current part is local motrio
         * @param {Object} partResponse
         */
        function isLocalMotrioPart(partResponse) {
            return partResponse.corporate === ListPieceConstants.motrioType.local;
        }

        /**
         * @name isCentralMotrioPart
         * @desc check if current part is central motrio
         * @param {Object} partResponse
         */
        function isCentralMotrioPart(partResponse) {
            return partResponse.corporate === ListPieceConstants.motrioType.central.Yes || partResponse.corporate === ListPieceConstants.motrioType.central.NotSure;
        }

        /**
         * @name manageDisplayingMotrioParts
         * @desc display alternatives motrio using their type (central, local)
         * @param {Array} aletrantiveItems
         * @param {Object} partsMotrios
         */
        function manageDisplayingMotrioParts(aletrantiveItems, partsMotrios) {
            var aletrenativeItemsLength = aletrantiveItems.length;
            if (partsMotrios && partsMotrios.central && partsMotrios.local) {
                //manage case having only central and no local
                if (partsMotrios.central.length >= 1 && partsMotrios.local.length == 0) {
                    aletrantiveItems = checkMotrioPart(partsMotrios.central, aletrantiveItems);
                }
                //manage case having only local and no central
                else if (partsMotrios.local.length >= 1 && partsMotrios.central.length == 0) {
                    aletrantiveItems = checkMotrioPart(partsMotrios.local, aletrantiveItems);
                }
                //manage case having central and local
                else if (partsMotrios.local.length >= 1 && partsMotrios.central.length >= 1) {
                    aletrantiveItems = checkMotrioPart(partsMotrios.local, aletrantiveItems);
                    if (aletrantiveItems.length === (aletrenativeItemsLength - partsMotrios.local.length)) {
                        //check centrals motrio if we dont't have any priced local motrio
                        aletrantiveItems = checkMotrioPart(partsMotrios.central, aletrantiveItems);
                    }
                    else {
                        //delete all central motrio if we have at least one priced local motrio
                        partsMotrios.central.forEach(function (currentCentralMotrio) {
                            var index = _.findIndex(aletrantiveItems, function (o) { return o.reference == currentCentralMotrio; });
                            aletrantiveItems.splice(index, 1);
                        })
                    }
                }
            }

            return aletrantiveItems;
        }

        /**
         * @name checkMotrioPart
         * @desc delete motrio part
         * @param {Object} partsMotrios
         * @param {Array} aletrantiveItems
         */
        function checkMotrioPart(partsMotrios, aletrantiveItems) {
            var userProfil = CacheService.getUserProfile();
            if (userProfil && !userProfil.roles.includes(ActisConstantes.ppx_import_parts_manager)) {
                partsMotrios.forEach(function (partMotrioItem) {
                    var existingPart = getMotrioPartNotPriced(aletrantiveItems, partMotrioItem);
                    if (existingPart) {
                        aletrantiveItems = deleteMotrioPart(aletrantiveItems, existingPart);
                    }
                });
            }
            return aletrantiveItems;
        }

        /**
         * @name deleteMotrioPart
         * @desc delete existing part from alternative items
         * @param {Array} aletrantiveItems
         * @param {Object} existingPart
         */
        function deleteMotrioPart(aletrantiveItems, existingPart) {
            var index = _.findIndex(aletrantiveItems, function (o) { return o.reference == existingPart.reference; });
            aletrantiveItems.splice(index, 1);
            return aletrantiveItems;
        }

        /**
         * @name getMotrioPartNotPriced
         * @desc return not price motrio part Object
         * @param {*} aletrantiveItems
         * @param {*} partMotrioItem
         */
        function getMotrioPartNotPriced(aletrantiveItems, partMotrioItem) {
            return _.find(aletrantiveItems, function (alternativeItem) { return isMotrioPartNotPriced(partMotrioItem, alternativeItem); });
        }

        /**
         * @name isMotrioPartNotPriced
         * @desc check if motrio part have price (datahub or dms)
         * @param {Integer} partMotrioItem
         * @param {Object} alternativeItem
         */
        function isMotrioPartNotPriced(partMotrioItem, alternativeItem) {
            return (partMotrioItem === alternativeItem.reference) && (!alternativeItem.priceExclTaxes || _.isEmpty(alternativeItem.priceExclTaxes.toString())) && (!alternativeItem.dmsInformations || !alternativeItem.dmsInformations.priceExclTaxes || _.isEmpty(alternativeItem.dmsInformations.priceExclTaxes.toString() || alternativeItem.dmsInformations.priceExclTaxes.toString() == "0"));
        }

        /**
         * display the correct price (DMS or Datahub) with two decimal
         * @param part
         * @returns {string}
         */
        function getPriceToDisplay(part) {
            var price = UtilsMetierService.getPriceToDisplay(
                part.priceExclTaxes, !part.dmsInformations ? null : part.dmsInformations.priceExclTaxes);
            return $filter('number')(price, 2);
        }
        /**
         * Get the correct price (DMS or Datahub) without currency formatting
         * @param part
         * @returns {string}
         */
        function getPriceToCheck(part) {
            var price = UtilsMetierService.getPriceToDisplay(
                part.priceExclTaxes, !part.dmsInformations ? null : part.dmsInformations.priceExclTaxes);
            return price;
        }
        function checkGenericPart(part) {
            if (part && part.genericPart && part.genericPart.charAt(0) != "L") {
                return true;
            }
        }

        /**
         * @name getCurrencyForItem
         * @desc get curency to diaplay
         * @returns {string}
         */
        function getCurrencyForItem(piece) {
            if (piece && piece.dmsInformations && piece.dmsInformations.isKnowFromDms) {
                return UtilsMetierService.getCurrencyForItem(piece.dmsInformations.isKnowFromDms)
            } else {
                return UtilsMetierService.getCurrencyForItem()
            }
        }

        function initSVG(piece, repere) {
            var urlSvg = piece.pictureUrl;
            if (urlSvg) {
                blockUI.start();  
                //$http .get('../../assets/captures.svg').then(function (response){
                DocumentsMetierService.returnSVG(piece.id, urlSvg).then(function (response) {
                    var svg = response.data;
                    if (document.getElementById("divSvgContent")) {
                        var element = document.getElementById("divSvgContent")
                        element.innerHTML = svg;
                        element.setAttribute("svg-handler", "");
                        $compile(element)($scope);
                    }
                    if (document.getElementById("divEbSvgContent")) {
                        var element = document.getElementById("divEbSvgContent")
                        element.innerHTML = svg;
                        element.setAttribute("svg-handler", "");
                        $compile(element)($scope);
                    }
                    // Wait dom ready
                    // Need to reopen svg with the selected node (on init)
                    $timeout(function () {
                        scrollTop();
                        var refIndex = repere ? repere : $state.params.refIndex;
                        if (refIndex && refIndex != 0) {
                            gotoSvg(refIndex);
                        }
                    }, 0)

                }, function (error) {
                    if (error)
                        toastr.error(error, 'Error');
                }).finally(function () {
                    blockUI.stop();
                });


            } else {
                var element = document.getElementById("divSvgContent");
                element.innerHTML = "";
                element.removeAttribute("svg-handler");
                $compile(element)($scope);
            }
        }

        function gotoSvg(index) {
            var selectedItem = _.find(vm.listOfPieces,function(item){
                return item.index == index;
            })
            $state.params.selectedReference = selectedItem.reference;
            $('text').removeClass("active-repere");
            $('.rid_' + index).addClass('active-repere');
            var elem = document.getElementById("listePiece");
            var anchor = elem && $(elem).length !== 0 ? $(elem).offset().top : 0;
            $('html, body').animate({ scrollTop: anchor }, 300);
            selectedMark(index,true);
        }
        var tmpIndex = 1;

        function selectedMark(repereIndex,fromPlanche) {
            vm.prevSelectedIndex = repereIndex;
            var selectedElement = document.getElementById(tmpIndex)
            vm.selectedIndexForFS = repereIndex;
            var container;
            if(fromPlanche){
                vm.listOfPieces.forEach(function(item){
                    if (document.querySelector(`[id="${item.index}"]`)) {
                        container = document.querySelector(`[id="${item.index}" ]`).getElementsByClassName('textIndex-div');
                        angular.element(container).removeClass('landmark');
                        angular.element(container).removeClass('ebLandmark');
                        $('svg line, svg polyline, svg path').removeClass("active-line");
                    }
                })
            }
            if (document.getElementById("divEbSvgContent")) {

                if (document.querySelectorAll(`[id="${tmpIndex}" ]`).length > 1) {
                    if (document.querySelectorAll(`[id="${tmpIndex}" ]`)[1]) {
                        container = document.querySelectorAll(`[id="${tmpIndex}" ]`)[1].getElementsByClassName('textIndex-div');
                        angular.element(container).removeClass('landmark');
                        angular.element(container).removeClass('ebLandmark');
                        $('svg line, svg polyline, svg path').removeClass("active-line");
                    }
                }
                else {
                    if (document.querySelector(`[id="${tmpIndex}" ]`)) {
                        container = document.querySelector(`[id="${tmpIndex}" ]`).getElementsByClassName('textIndex-div');
                        angular.element(container).removeClass('landmark');
                        angular.element(container).removeClass('ebLandmark');
                        $('svg line, svg polyline, svg path').removeClass("active-line");
                    }

                }
                $('svg>svg').remove();
                $('g>svg').remove();
                tmpIndex = repereIndex;
                vm.ebRefIndexList = [];
                vm.listOfPieces.forEach(function(item){
                    if(vm.ebRefList.includes(item.reference)){
                        vm.ebRefIndexList.push(item.index);
                        if(item.reference == $state.params.selectedReference){
                            if (document.querySelectorAll(`[id="${item.index}" ]`).length > 1) {
                                container = document.querySelectorAll(`[id="${item.index}" ]`)[1].getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('landmark');
                            } else {        
                                container = document.querySelector(`[id="${item.index}" ]`).getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('landmark');
                            }
                        } else {
                            if (document.querySelectorAll(`[id="${item.index}" ]`).length > 1) {
                                container = document.querySelectorAll(`[id="${item.index}" ]`)[1].getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('ebLandmark');
                            } else {        
                                container = document.querySelector(`[id="${item.index}" ]`).getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('ebLandmark');
                            }
                        }
                    } else {
                        if(item.reference == $state.params.selectedReference){
                            if (document.querySelectorAll(`[id="${item.index}" ]`).length > 1) {
                                container = document.querySelectorAll(`[id="${item.index}" ]`)[1].getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('landmark');
                            } else {        
                                container = document.querySelector(`[id="${item.index}" ]`).getElementsByClassName('textIndex-div');
                                angular.element(container).addClass('landmark');
                            }
                        }
                    }
                })
                if (document.querySelectorAll(`[id="${repereIndex}" ]`).length > 1) {
                    container = document.querySelectorAll(`[id="${repereIndex}" ]`)[1].getElementsByClassName('textIndex-div');
                    angular.element(container).addClass('landmark');
                } else {

                    container = document.querySelector(`[id="${repereIndex}" ]`).getElementsByClassName('textIndex-div');
                    angular.element(container).addClass('landmark');
                }

                if (document.getElementById("r" + repereIndex) != null) {
                    //BUG-1878
                    var parent = document.getElementById("r" + repereIndex).parentNode;
                    var selectedItem = _.find(vm.listOfPieces,function(item){
                        return item.index == repereIndex;
                    })
                    var tempselectedItem = _.filter(vm.listOfPieces, function(item){
                        return item.reference == selectedItem.reference;
                    })
                    var selectedIndexes = [];
                    selectedIndexes = _.map(tempselectedItem,'index');
                    var repereGroups = getRepereGroupElements();
                    if (repereGroups.length > 1) {
                        if (repereGroups[1]) {
                            var listSvg = repereGroups[1].getElementsByTagName("g");

                            angular.forEach(listSvg, function (value, key) {
                                if ($(value).text().trim() == repereIndex) {
                                    applySelectionPlateFull(repereIndex, value);
                                }
                            });
                            if(selectedIndexes.length > 1){
                                selectedIndexes.forEach(function(selIndex){
                                    if(selIndex != repereIndex){
                                        angular.forEach(listSvg, function (value, key) {
                                            if ($(value).text().trim() == selIndex) {
                                                applySelectionPlateFull(selIndex, value);
                                            }
                                        });
                                    }
                                })
                            }
                            if(!_.isEmpty(vm.ebRefList)){
                                vm.ebRefIndexList.forEach(function(ebItem){
                                    if(!selectedIndexes.includes(ebItem)){
                                        angular.forEach(listSvg, function (value, key) {
                                            if ($(value).text().trim() == ebItem) {
                                                applySelectionPlateFull(ebItem, value, true);
                                            }
                                        });
                                    }
                                })
                            }
                        } else {
                            var listText = document.getElementsByTagName("text");
                            angular.forEach(listText, function (value, key) {
                                if ($(value).text().trim() == repereIndex) {
                                    applySelectionPlateLite(repereIndex, value);
                                }
                            });
                        }
                    }
                    else {
                        if (repereGroups[0]) {
                            var listSvg = repereGroups[0].getElementsByTagName("g");

                            angular.forEach(listSvg, function (value, key) {
                                if ($(value).text().trim() == repereIndex) {
                                    applySelectionPlateFull(repereIndex, value);
                                }
                            });
                            if(selectedIndexes.length > 1){
                                selectedIndexes.forEach(function(selIndex){
                                    if(selIndex != repereIndex){
                                        angular.forEach(listSvg, function (value, key) {
                                            if ($(value).text().trim() == selIndex) {
                                                applySelectionPlateFull(selIndex, value);
                                            }
                                        });
                                    }
                                })
                            }
                            if(!_.isEmpty(vm.ebRefList)){
                                vm.ebRefIndexList.forEach(function(ebItem){
                                    if(!selectedIndexes.includes(ebItem)){
                                        angular.forEach(listSvg, function (value, key) {
                                            if ($(value).text().trim() == ebItem) {
                                                applySelectionPlateFull(ebItem, value, true);
                                            }
                                        });
                                    }
                                })
                            }
                        } else {
                            var listText = document.getElementsByTagName("text");
                            angular.forEach(listText, function (value, key) {
                                if ($(value).text().trim() == repereIndex) {
                                    applySelectionPlateLite(repereIndex, value);
                                }
                            });
                        }
                    }

                }

            }
            else {

                if (selectedElement) {
                    container = selectedElement.getElementsByClassName('textIndex-div');
                    angular.element(container).removeClass('landmark');
                    $('svg line, svg polyline, svg path').removeClass("active-line");
                }
                $('svg>svg').remove();
                $('g>svg').remove();
                if (document.getElementById(repereIndex)) {
                    container = document.getElementById(repereIndex).getElementsByClassName('textIndex-div');
                    angular.element(container).addClass('landmark');
                }


                tmpIndex = repereIndex;
                if (document.getElementById("r" + repereIndex) != null) {
                    //BUG-1878
                    var parent = document.getElementById("r" + repereIndex).parentNode;
                    var repereGroup = getRepereGroupElement();
                    if (repereGroup) {
                        var listSvg = repereGroup.getElementsByTagName("g");

                        angular.forEach(listSvg, function (value, key) {

                            if ($(value).text().trim() == repereIndex) {

                                applySelectionPlateFull(repereIndex, value);
                            }
                        });
                    } else {
                        var listText = document.getElementsByTagName("text");
                        angular.forEach(listText, function (value, key) {
                            if ($(value).text().trim() == repereIndex) {
                                applySelectionPlateLite(repereIndex, value);
                            }
                        });
                    }
                }
            }
            // Replace the value of the plateIndex parameter in the url to ensure back button to work
            if (!_.includes($window.location.href, 'INT_REPAIR')) {

                $state.transitionTo($state.$current.name, { refIndex: repereIndex }, {
                    location: "replace",
                    inherit: true,
                    relative: $state.$current,
                    notify: false,
                });
            }
            if (vm.isFullScreen) {
                var list = document.getElementById("divSvgContent");
                if (list !== null && list !== undefined && list.hasChildNodes() && list.children.length > 2) {
                    list.removeChild(list.children[3]);
                    list.removeChild(list.children[2]);
                }
                vm.listOfPieces.forEach(function (item) {
                    if (item.index == repereIndex) {
                        $scope.$emit("showRefDesg", item);
                    }
                })
            }
        }
        $scope.$on('addPRInFullScreen', function (event) {
            if (vm.isFullScreen) {
                exitFullscreen();
            }
        })
        $scope.$on('showRefDesg', function (event, data) {
            var element = document.getElementById("divSvgContent");
            var newDivision1 = document.createElement("div");
            newDivision1.classList.add("newElement1");
            var newDivision2 = document.createElement("div");
            newDivision2.classList.add("newElement2");
            var newSpan1 = document.createElement("span");
            var newSpan2 = document.createElement("span");
            var newDesg = document.createElement("p");
            newDesg.classList.add("fullScreenDesignation");
            newDesg.innerHTML = (data.designation != '') ? data.designation : 'NA';
            var newRef = document.createElement("p");
            newRef.classList.add("fullScreenReference");
            newRef.innerHTML = $filter('filterFormatRef')(data.reference);
            var newCart = null;
            if (vm.isUserDms)
                newCart = document.createElement("shopping-cart-parts-requisition");
            else {
                newCart = document.createElement("shopping-cart");
                newCart.setAttribute('style', "left: 0px;position: absolute;");
            }
            newCart.setAttribute('from', 'PR');
            newCart.setAttribute('piece', JSON.stringify(data));
            if (vm.isUserDms) {
                var optionsN1 = { mainPart: data };
                newCart.setAttribute('options', JSON.stringify(optionsN1));
            }
            newCart.innerHTML = data.reference;
            newSpan1.appendChild(newDesg);
            newSpan2.appendChild(newRef);
            if (!vm.isHorseUser) {
                newSpan2.appendChild(newCart);
            }
            newDivision1.appendChild(newSpan1);
            newDivision1.appendChild(newSpan2);
            element.appendChild(newDivision1);
            element.appendChild(newDivision2);
            vm.elemToZoomContainer = document.getElementById('divSvgContent');
            $rootScope.$broadcast("exitFullScreen", vm.isFullScreen);
            $compile(element)($scope);
        });
        function applySelectionPlateFull(repereIndex, node, isEasyBasket) {

            var findLine = highlightLeaderShapes(node);
            if (!findLine || findLine.length === 0) {
                highlightNearestLeaderLine(node);
            }
            var positions = node.getElementsByTagName("text");

            var y;
            var x;
            if(isEasyBasket){
                $.each(positions, function (index, node) {
                    if (repereIndex <= 9) {
                        y = (node.getAttribute("y")) - 6;
                        x = (node.getAttribute("x")) - 1;
                        $("<svg><rect height='7' width='6' style='stroke:var(--renaultPrimaryColor);' y='"
                            + y + "' x='" + x + "' /></svg>").insertBefore(node);

                    } else {
                        y = (node.getAttribute("y")) - 6;
                        x = (node.getAttribute("x")) - 0.5;
                        $("<svg><rect height='7' width='9' style='stroke:var(--renaultPrimaryColor);' y='"
                            + y + "' x='" + x + "' /></svg>").insertBefore(node);
                    };
                });
            } else{
                $.each(positions, function (index, node) {
                    if (repereIndex <= 9) {
                        y = (node.getAttribute("y")) - 6;
                        x = (node.getAttribute("x")) - 1;
                        $("<svg><rect height='7' width='6' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                            + y + "' x='" + x + "' /></svg>").insertBefore(node);

                    } else {
                        y = (node.getAttribute("y")) - 6;
                        x = (node.getAttribute("x")) - 0.5;
                        $("<svg><rect height='7' width='9' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                            + y + "' x='" + x + "' /></svg>").insertBefore(node);
                    };
                });
            }
        }

        function applySelectionPlateLite(repereIndex, node) {
            highlightNearestLeaderLine(node);
            var y = node.getAttribute("y");
            var x = node.getAttribute("x");
            if (repereIndex <= 9) {
                y -= 6;
                x -= 1;
                $("<svg><rect height='7' width='6' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                    + y + "' x='" + x + "' /></svg>").insertBefore(node);
            } else {
                y -= 6;
                x -= 0.5;
                $("<svg><rect height='7' width='9' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                    + y + "' x='" + x + "' /></svg>").insertBefore(node);
            };
        }

        function getRepereGroupElement() {
            return document.getElementById("Repères") || document.getElementById("Reperes");
        }

        function getRepereGroupElements() {
            var groups = document.querySelectorAll('[id="Repères"], [id="Reperes"]');
            return groups ? groups : [];
        }

        function highlightLeaderShapes(node) {
            return $(node).find('line, polyline, path').addClass('active-line');
        }

        function highlightNearestLeaderLine(markerNode) {
            var markerCenter = getSvgNodeCenter(markerNode);
            if (!markerCenter) {
                return;
            }

            var lineSelectors = '#divSvgContent svg line, #divEbSvgContent svg line';
            var lines = document.querySelectorAll(lineSelectors);
            if (!lines || lines.length === 0) {
                return;
            }

            var nearestLine = null;
            var nearestDistance = Number.POSITIVE_INFINITY;

            angular.forEach(lines, function (lineNode) {
                var lineCenter = getSvgNodeCenter(lineNode);
                if (!lineCenter) {
                    return;
                }

                var deltaX = markerCenter.x - lineCenter.x;
                var deltaY = markerCenter.y - lineCenter.y;
                var distance = (deltaX * deltaX) + (deltaY * deltaY);
                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nearestLine = lineNode;
                }
            });

            if (nearestLine) {
                angular.element(nearestLine).addClass('active-line');
            }
        }

        function getSvgNodeCenter(node) {
            if (!node || !node.getBBox) {
                return null;
            }

            try {
                var bbox = node.getBBox();
                return {
                    x: bbox.x + (bbox.width / 2),
                    y: bbox.y + (bbox.height / 2)
                };
            } catch (e) {
                return null;
            }
        }

        /**
         * suppress signs.
         * @param {el} object - the piece object.
         * @return {piece} Get piece.
         * usage supressSigns(el)
         */
        function supressSigns(el) {
            if (el && el.codifiedSigns && el.codifiedSigns.length > 0) {
                el.codifiedSigns = el.codifiedSigns.filter(function (signs) {
                    return signs.value != "SC000ERP" && signs.value != "SC000BRP"
                })
            }
        }


        /**
         * Filter codified pieces.
         * @param {ref} object - the piece object.
         * @return {piece} Get piece.
         * usage filterCodifiedSigns(ref)
         */
        function filterCodifiedSigns(ref) {
            if (!ref)
                return;

            supressSigns(ref);

            // check additional
            if (ref && ref.additional && ref.additional.length > 0)
                ref.additional.forEach(function (el) {
                    filterCodifiedSigns(el);
                })

            // check alternative
            if (ref && ref.alternative && ref.alternative.length > 0)
                ref.alternative.forEach(function (el) {
                    filterCodifiedSigns(el);
                })
            //return ref;
        }

        function checkSuperseding(ref, index) {


            if (!ref)
                return;

            if (!ref.priceExclTaxes) {
                if (ref.superSessionDetails.length > 0 && ref.supersedingList.length > 0) {
                    for (var i = ref.supersedingList.length - 1; i >= 0; i--) {
                        for (var j = 0; j < ref.superSessionDetails.length; j++) {
                            if (ref.superSessionDetails[j].reference == ref.supersedingList[i]) {
                                if (ref.superSessionDetails[j].priceExclTaxes) {
                                    ref.superSessionDetails[j].replacement = true;
                                    if (ref.superSessionDetails[j].initialReference == null) {
                                        ref.superSessionDetails[j].initialReference = ref.superSessionDetails[j].reference;
                                    }
                                    ref.superSessionDetails[j].alternative = ref.alternative;
                                    ref.superSessionDetails[j].herculesCase = ref.herculesCase;
                                    ref.superSessionDetails[j].herculesProposal = ref.herculesProposal;
                                    // ref.superSessionDetails[j].catalogPlate = ref.catalogPlate;
                                    // var catalogPlate = ref.id.split('_');
                                    // ref.superSessionDetails[j].catalogNumber = catalogPlate[0];
                                    // ref.superSessionDetails[j].plateNumber = catalogPlate[1];

                                    // ref.superSessionDetails[j].catalogNumber = ref.catalogNumber;
                                    // ref.superSessionDetails[j].plateNumber = ref.plateNumber;
                                    vm.listOfPieces.splice(index, 1, ref.superSessionDetails[j]);
                                    return;
                                }
                            }
                        }

                    }
                }
            }
        }

        function displayLSRPicto(ref) {
            if (ref.herculesCase != null) {
                ref.displayPicto = true;
                switch (ref.herculesCase) {
                    case 'CASE1:HOLE': vm.HERCULES_GREEN++; break;
                    case 'CASE2: DUALITY': vm.HERCULES_RED_BLUE++; break;
                    case 'CASE3: NEW PROPOSAL': vm.HERCULES_RED_BLUE++; break;
                    case 'CASE4: SAME PROPOSAL': vm.HERCULES_GRAY++; break;
                    default: break;
                }
            }
        }

        function checkAlternativePrice(alt) {
            if (alt.alternative && alt.alternative.length > 0) {
                alt.alternative.forEach(function (ref, index) {
                    if (!ref.priceExclTaxes) {
                        if (ref.superSessionDetails.length > 0 && ref.supersedingList.length > 0) {
                            for (var i = ref.supersedingList.length - 1; i >= 0; i--) {
                                for (var j = 0; j < ref.superSessionDetails.length; j++) {
                                    if (ref.superSessionDetails[j].reference == ref.supersedingList[i]) {
                                        if (ref.superSessionDetails[j].priceExclTaxes) {
                                            ref.superSessionDetails[j].replacement = true;
                                            if (ref.superSessionDetails[j].initialReference == null) {
                                                ref.superSessionDetails[j].initialReference = ref.superSessionDetails[j].reference;
                                            }
                                            alt.alternative.splice(index, 1, ref.superSessionDetails[j]);
                                            return;
                                        }
                                    }
                                }

                            }
                        }
                    }
                })
            }

        }

        /**
         * Check vignette and planche image.
         * @param {piece} object - the piece object.
         * @return {piece} Get piece with default image for vignette and planche is empty or undefined.
         * usage checkVignetteAndPlancheImage(pieces)
         */
        function checkVignetteAndPlancheImage(ref) {
            if (ref && ref.thumbnailUrl == "" || angular.isUndefined(ref.thumbnailUrl))
                ref.thumbnailUrl = "assets/images/no_image_vignette.png";
            if (ref && ref.pictureUrl == "" || angular.isUndefined(ref.pictureUrl))
                ref.pictureUrl = "assets/svg/no_image.svg";
        }

        /**
         * Rafine pieces.
         * @param {list} object - the pieces object.
         * @return {pieces} Get pieces after applying filter codified signs and check vignette and planche.
         * usage RafinatePieces(pieces)
         */
        function RefinePlates(list) {

            list.forEach(function (plate) {

                checkVignetteAndPlancheImage(plate);
            })

            return list;
        }

        Element.prototype.documentOffsetTop = function () {
            return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
        };

        Element.prototype.scrollIntoViewCenter = function () {
            window.scrollTo(0, this.documentOffsetTop() - (window.innerHeight / 2));
        };

        /**
         *  @desc   Check if we want to display residual
         *          If the residual contain only VOI, we don't display it
         *  @param  {object} simplifiedResidual
         *  @return {boolean}
         */

        function displayComplementaryInformation(simplifiedResidual) {
            var show = false;
            if (!simplifiedResidual || !simplifiedResidual.length) {
                show = false;
            } else {
                if (simplifiedResidual && simplifiedResidual.length > 0) {
                    show = simplifiedResidual.some(function (residual) {
                        // type can be fixe/variable/?
                        var display = false;

                        for (var type in residual) {
                            if (residual[type] && residual[type].length > 0) {
                                display = residual[type].some(function (line) {
                                    return line.codeObj !== CodesConstants.VOI;
                                });
                            }
                            if (display === true) {
                                break;
                            } else {
                                if (residual.fixe && residual.fixe.length > 0) {
                                    display = residual.fixe.some(function (line) {
                                        return line.codeObj == CodesConstants.VOI;
                                    })
                                }
                            }
                        }
                        return display;
                    })
                }
            }
            return show;
        }

        function goToElement(loc) {
            var element = document.getElementById(loc);
            if (element)
                element.focus();
            document.activeElement.scrollIntoViewCenter();
        }

        function getStockClass(piece) {
            if ((piece.dmsInformations) && (piece.dmsInformations.quantity > 0)) {
                return 'stockDispo';
            } else {
                return 'stockIndispo';
            }
        }

        //Estimation
        function openPopinVOI(vois) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/products/modal/ref_consigne.html',
                controller: 'refConsignCtrl',
                controllerAs: 'SearchAdminCtrl',
                windowClass: 'modalRefConsigne',
                resolve: {
                    modalOpts: function () {
                        return {
                            vois: vois
                        };
                    }

                }
            });

            return modalInstance.result;
        }

        function showHideAppl(piece) {
            ReferenceMetierService.showHideAppl(piece);
        }

        function showHideAdd(piece) {
            if (piece && piece.showAdd) {
                piece.showAdd = !piece.showAdd;
            }
            else {
                if (piece && !piece.payment) {
                    delete piece.payment;
                    piece.payment = angular.copy(piece);
                }
                piece.showAdd = true;
            }

        }

        function displayToastr(messageToast, piece, iconClass) {
            toastr.info(messageToast, piece, {
                iconClass: iconClass,
                messageClass: 'toast-estimate-message',
                titleClass: 'toast-estimate-title',
                timeOut: 1500
            });
        }

        function gotoPrTmLink(tmdocids, tmreference) {
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/components/products/documents/pr-tmlink/prTmLink.template.html',
                controller: 'PrTmLinkCntrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                windowClass: 'my-modal-popup',
                locals: {
                    tmdocids: tmdocids,
                    tmreference: tmreference
                }
            });
        }
        function gotoPrMrLink(mrDocids, mrReference) {
            if (!_.isEmpty(mrDocids) && mrDocids.length > 1) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/components/products/documents/pr-mrlink/prMrLink.template.html',
                    controller: 'PrMrLinkCtrl',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    size: 'lg',
                    windowClass: 'my-modal-popup',
                    locals: {
                        mrdocids: mrDocids,
                        mrreference: mrReference
                    }
                });
            } else if (!_.isEmpty(mrDocids) && mrDocids.length == 1) {
                mrDocumentsMetierService.getInitialSieDocuments(mrDocids).then(function (mrDocuments) {
                    if (!_.isEmpty(mrDocuments)) {
                        mrDocuments[0].prMRReference = mrReference;
                        if (mrDocuments[0].pdfContent == "false") {
                            $state.go(RoutesConstants.documentMR, {
                                id: mrDocuments[0].sieRef,
                                plateIndex: $state.params.plateIndex,
                                refIndex: $state.params.refIndex,
                                prMRLinked: true
                            });
                        }
                        else {
                            DocumentsMetierService.returnSiePdfContent(mrDocuments[0].sieRef, 'SIE_MR').then(function (result) {
                                var url = result.contentUrl;
                                $window.open(url, '_blank');
                            });
                        }
                    }
                }, function (error) {
                    toastr.error(error, 'Error');
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }
        function getCodifiedSigns(piece) {
            return ProductMetierService.getCodifiedSign(piece.codifiedSigns);
        }
        function downloadPdf(svgImage, noImagePrint) {
            var newArray = [];
            var referenceList = [];
            angular.copy(vm.listOfPieces, referenceList);
            referenceList = _.sortBy(referenceList, ["index"]);
            referenceList.forEach(function (refItem) {
                refItem = getImageDetails(refItem);
                newArray.push(refItem);
                if (!_.isEmpty(refItem.additional)) {
                    refItem.additional.forEach(function (addItem) {
                        _.assign(addItem, { isAdditional: true });
                        addItem = getImageDetails(addItem);
                        newArray.push(addItem);
                    })
                }
                if (!_.isEmpty(refItem.alternative)) {
                    refItem.alternative.forEach(function (altItem) {
                        _.assign(altItem, { isAlternative: true });
                        altItem = getImageDetails(altItem);
                        if (getPriceToCheck(altItem) != '-')
                            newArray.push(altItem);
                        if (!_.isEmpty(altItem.additional)) {
                            altItem.additional.forEach(function (addItem) {
                                _.assign(addItem, { isAdditional: true });
                                addItem = getImageDetails(addItem);
                                if (getPriceToCheck(addItem) != '-')
                                    newArray.push(addItem);
                            })
                        }
                    })
                }
            })

            var cartToPrint = {
                pdfMetaData: newArray,
                pdfPlateData: vm.listOfPlate,
                printPdfData: {
                    presentDateTime: moment(new Date()).format("YYYY/MM/DD"),
                    currentPlateIndex: vm.currentIndexPlate
                },
                translatedLabels: {
                    emptyLabel: '',
                    refTitle: $translate.instant("VIEWED_DOC_REF"),
                    designationLabel: $translate.instant("COMMON_DESIGNATION"),
                    complementaryInfo: $translate.instant("DOCUMENT_PR_COMPLEMENTARY_INFO")
                }
            };

            return formatDataToPrint(cartToPrint, svgImage, noImagePrint);
        }
        function formatDataToPrint(data, svgImage, noImagePrint) {

            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            if (!noImagePrint) {
                var imageObj = {
                    type: "image", values: svgImage
                }
                dataArray.push(imageObj);
            } else {
                var imgObj = { type: "columns", values: { 0: ["Plate image not available"] }, styles: "textStyle" };
                dataArray.push(imgObj);
            }

            var secondObj = { type: "columns", values: { 0: [data.pdfPlateData[data.printPdfData.currentPlateIndex].id ? data.pdfPlateData[data.printPdfData.currentPlateIndex].id.replace('_', ' / ') : ""] }, styles: "textDataStyle" };
            if (data.pdfPlateData) {
                dataArray.push(secondObj);
            }

            var fourthTable = data.pdfMetaData;

            var filteredData = fourthTable.map(function (item) {
                var tableData = [];

                tableData[data.translatedLabels.emptyLabel] =
                {
                    data: (!item.isAdditional && !item.isAlternative) ? item.index : (item.isAdditional ? '+' : ''),
                    alignment: "center"
                };
                tableData[data.translatedLabels.refTitle] =
                {
                    data: $filter('filterFormatRef')(item.reference),

                    alignment: "center"
                };
                tableData[data.translatedLabels.designationLabel] =
                {
                    data: UtilsMetierService.replaceEmptyString(item.designation, "-"),
                    alignment: "left"
                };
                tableData[data.translatedLabels.complementaryInfo] =
                {
                    data: (!_.isEmpty(item.codifiedSigns) || !_.isEmpty(item.simplifiedResidual)) ? getCodifiedValue(item,12) : [],
                    alignment: "left",
                    type: "list"
                };
                tableData[data.translatedLabels.emptyLabel + " "] =
                {
                    data: item.pdfImage,
                    alignment: "right",
                    type: "image"
                };
                return tableData;
            })

            var fourthObj = {};

            fourthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: [15, 55, 140, 200, 65]
            };

            var thirdObj = { type: "columns", values: { 0: [$translate.instant('MAX_COMP_INFO_EXCEEDED')] }, styles: "textWarningStyle" };

            if(vm.isMaxExceeded){
                dataArray.push(thirdObj);
                vm.isMaxExceeded = false;
            }

            dataArray.push(fourthObj);
            dataArray = PDFViewService.getProcessedDataArray(finalArr, dataArray, false, false, true, false);

            var docDefinition = {
                info: {
                    title: data.pdfPlateData[data.printPdfData.currentPlateIndex].id ? data.pdfPlateData[data.printPdfData.currentPlateIndex].id : $translate.instant("LOCATION_CATA"),
                },
                header: {
                    style: "header",
                    columns: [
                        {
                            image: pictoImage.RENAULT.value,
                            width: 50,
                        }]
                },
                footer: {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        },
                        {
                            type: 'none',
                            text: moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                            alignment: 'right',
                            margin: [0, 5, 5, 0]
                        },

                    ]

                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 12
                    },
                    header: {
                        margin: [40, 15, 0, 10],
                    },
                    textDataStyle: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 12,
                    },
                    textWarningStyle: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8,
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableListTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8,
                        bold: true
                    },
                    tableStyle: {
                        margin: [0, 5, 0, 0]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    },
                    tableIconStyle: {
                        margin: [0, 1.5, 0, 1.5],
                        alignment: "center"
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }

function getCodifiedValue(piece, maxItems) {
    var compInfoList = [];
    var simpleResList = [];
    maxItems = maxItems || 12;

    if (!_.isEmpty(piece.codifiedSigns)) {
        piece.codifiedSigns.forEach(function (item) {
                compInfoList.push(item.designation + " " + item.textAssociated);
        });
    }
    if (!_.isEmpty(piece.simplifiedResidual)) {
        piece.simplifiedResidual.forEach(function (res) {
            var varFixe = (res.variable && res.fixe) ? _.concat(res.variable, res.fixe) : res.variable ? res.variable : res.fixe;
            if (!_.isEmpty(varFixe)) {
                varFixe.forEach(function (crit) {
                    var residualCritList = [];
                    if (!_.isEmpty(crit.listCrit)) {
                        crit.listCrit.forEach(function (listCrit) {
                            var critText = '';
                            if (listCrit.langueCrit != 'NONTRANSLATED') {
                                critText += listCrit.labelCrit;
                                if (listCrit.codeCrit)
                                    critText += " " + listCrit.codeCrit;
                            } else {
                                critText += listCrit.codeCrit;
                            }
                                residualCritList.push(critText);
                        });
                    }
                        simpleResList.push({ label: crit.labelObj, value: residualCritList });
                });
            }
        });
    }
    
    if (compInfoList.length > maxItems){
        vm.isMaxExceeded = true;
        compInfoList = [];
    } 
    if (simpleResList.length > maxItems) {
        vm.isMaxExceeded = true;
        simpleResList = [];
    } 

    return { "codifiedSigns": vm.isMaxExceeded ? [] : compInfoList, "simplifiedResidual": vm.isMaxExceeded ? [] : simpleResList };
}
        function getImageDetails(item) {
            item.pdfImage = [];
            if (!_.isEmpty(item.supersedingList)) {
                item.pdfImage.push(pictoImage['SUPERSESSION'])
            }
            if (item.fds)
                item.pdfImage.push(pictoImage['WARNING'])
            if (item.displayPicto) {
                switch (item.herculesCase) {
                    case 'CASE1:HOLE': item.pdfImage.push(pictoImage['HERCULES_HOLE']); break;
                    case 'CASE2: DUALITY': item.pdfImage.push(pictoImage['HERCULES_DUALITY']); break;
                    case 'CASE3: NEW PROPOSAL': item.pdfImage.push(pictoImage['HERCULES_NEW']); break;
                    case 'CASE4: SAME PROPOSAL': item.pdfImage.push(pictoImage['SAME_HERCULES']); break;
                    case 'CASE5: PROPOSAL DECLINED': item.pdfImage.push(pictoImage['HERCULES_DECLINED']); break;
                    default: break;
                }
            }
            if (item.isKit)
                item.pdfImage.push(pictoImage['KIT'])
            if (item.reach)
                item.pdfImage.push(pictoImage['REACH'])
            if (!_.isEmpty(item.equivalentTypes)) {
                if (_.includes(item.equivalentTypes, ListPieceConstants.types.valuePlus))
                    item.pdfImage.push(pictoImage['VALUE_PLUS'])
                if (_.includes(item.equivalentTypes, ListPieceConstants.types.ecoValue)){
                    item.pdfImage.push(pictoImage['ECO_VALUE'])
                }
                if (_.includes(item.equivalentTypes, ListPieceConstants.types.motrio) && 
                    item.familyCode && _.includes(ListPieceConstants.remanufacturedFamilyCodes, item.familyCode))
                    item.pdfImage.push(pictoImage['MOTRIO_REMAN'])
                else if (_.includes(item.equivalentTypes, ListPieceConstants.types.motrio))
                    item.pdfImage.push(pictoImage['MOTRIO'])
                if (_.includes(item.equivalentTypes, ListPieceConstants.types.standardExchange)) {
                    if (item.familyCode === ListPieceConstants.tractionBatteryFamilyCode) {
                        item.pdfImage.push(pictoImage['RENATIVE'])
                    } else {
                        item.pdfImage.push(pictoImage['STANDARD_EXCHANGE'])
                    }
                }
            }
            return item;
        }

        function close() {
            $mdDialog.cancel();
        }

        function navigateToPlate() {
            $mdDialog.cancel();
            $rootScope.$broadcast('closeOperation');
            DocPrivMetierService.removePrResponse();
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removeProductResposne();
            DocPrivMetierService.removeInterventionResposne();
            var arr = [];
            var obj = {};
            arr.push({ 'id': vm.currentRefCatalogPlanche.replace(' / ', '_') });

            var isReferenceFind = _.find(vm.listOfPieces, function (item) {
                return item.index === vm.prevSelectedIndex;
            })
            obj = { 'catalogPlates': arr, "reference": (isReferenceFind && !_.isEmpty(isReferenceFind)) ? isReferenceFind.reference : null };
            DocumentsMetierService.filterSelectedIds(obj, 'PR', true, true);


        }

        function showComplementaryInfo(){
            for (const piece of vm.listOfPieces) {
                setComplementaryInfoFlags(piece);
            }
        }

        function setComplementaryInfoFlags(piece) {
            piece.showComplementaryInfo = hasComplementaryInfo(piece);            
            if (piece.additional && piece.additional.length > 0) {
                setAdditionalComplementaryInfo(piece.additional);
            }            
            if (piece.alternative && piece.alternative.length > 0) {
                setAlternativeComplementaryInfo(piece.alternative);
            }
        }

        function setAdditionalComplementaryInfo(additionalItems) {
            for (const additional of additionalItems) {
                additional.showAdditionalComplementaryInfo = hasComplementaryInfo(additional);
            }
        }

        function setAlternativeComplementaryInfo(alternativeItems) {
            for (const alternative of alternativeItems) {
                alternative.showAlternativeComplementaryInfo = hasComplementaryInfo(alternative);                
                if (alternative.additional && alternative.additional.length > 0) {
                    setAlternativeAdditionalComplementaryInfo(alternative.additional);
                }
            }
        }

        function setAlternativeAdditionalComplementaryInfo(altAdditionalItems) {
            for (const altAdditional of altAdditionalItems) {
                altAdditional.showAltAdditionalComplementaryInfo = hasComplementaryInfo(altAdditional);
            }
        }

        function hasComplementaryInfo(item) {
            return displayComplementaryInformation(item.simplifiedResidual) || 
                   (item.codifiedSigns && item.codifiedSigns.length > 0);
        }
    }
})();

"use strict";

angular.module("phenix").constant("ListPieceConstants", {
    alternativePartBrand: {
        motrio: "Motrio",
        centralWithMotrio: "CentraleWithMotrio"
    },
    types: {
        centrale: "Centrale",
        motrio: "motrio",
        valuePlus: "valuePlus",
        standardExchange: "standardExchange",
        remanufacturedMotrio: "remanufacturedMotrio",
        ecoValue: "ecoValue"
    },
    motrioType:{
        local: "No",
        central:{
            Yes: "Yes",
            NotSure: "Not Sure"
        }
    },
    remanufacturedFamilyCodes: ['538K', '655K', '656K', '567K'],
    tractionBatteryFamilyCode: '281R',
    brandList : ['centrale','valuePlus','standardExchange','motrio','ecoValue'],
    indeBrandList : ['centrale','motrio','standardExchange','valuePlus','ecoValue'],
    equivalentTypesField: 'equivalentTypes',
    typesField: "types",
    motrioFilterRpartsProfile: "IRN-66997:documentateur",
    centralStockPilotDealers: ['00900001', '27618553', '00029236', '00001258', '05600492'],
    centralStockIcons: {
        MY_STOCK:     { asset: './assets/svg/central-stock/dealership.svg',  color: '#C373A3' },
        R1:           { asset: './assets/svg/central-stock/van-compact.svg', color: '#5CBA63' },
        REGIONAL:     { asset: './assets/svg/central-stock/warehouse.svg',   color: '#4B9BF5' },
        CENTRAL:      { asset: './assets/svg/central-stock/warehouse.svg',   color: '#4B9BF5' },
        COUNTRY:      { asset: './assets/svg/central-stock/warehouse.svg',   color: '#4B9BF5' },
        WW:           { asset: './assets/svg/central-stock/planet.svg',      color: '#4B9BF5' },
        RESTOCKING:   { asset: './assets/svg/central-stock/timer.svg',       color: '#FFBD69' },
        OUT_OF_STOCK: { asset: './assets/svg/central-stock/decline.svg',     color: '#CB4B32' }
    }
});

(function () {
  angular
    .module('phenix')
    .directive('groupPlates', behavior);

  function behavior() {
    return {
      scope: {
        'vignettes': '=',
        'selectedPlate': '=',
      },
      restrict: 'E',
      templateUrl: 'app/components/products/documents/pr/groupPlates.template.html',
      controller: controller,
      controllerAs: 'ctrl',
      bindToController: true,
    }
  }

  function controller($scope) {
  }
})();
(function () {
    'use strict';

    angular.module('phenix').directive('centralStockIcon', behavior);

    function behavior() {
        return {
            restrict: 'E',
            scope: {
                piece: '=',
                mode: '@'
            },
            templateUrl: 'app/components/products/documents/pr/centralStockIcon.template.html',
            controllerAs: 'vm',
            bindToController: true,
            controller: controller
        };
    }

    /** @ngInject */
    function controller(ListPieceConstants, $translate) {
        var vm = this;

        vm.getIconStyle = getIconStyle;
        vm.getTextStyle = getTextStyle;
        vm.getLineText = getLineText;
        vm.isFullMode = isFullMode;
        vm.hasData = hasData;

        function hasData() {
            return !!(vm.piece && vm.piece.centralStock && vm.piece.centralStock.iconKey);
        }

        function isFullMode() {
            return vm.mode === 'full';
        }

        function getIconEntry(iconKey) {
            return iconKey ? ListPieceConstants.centralStockIcons[iconKey] : null;
        }

        function getIconStyle(iconKey) {
            var entry = getIconEntry(iconKey);
            if (!entry) { return {}; }
            var url = 'url("' + entry.asset + '")';
            return {
                '-webkit-mask-image': url,
                'mask-image': url,
                'background-color': entry.color
            };
        }

        function getTextStyle(iconKey) {
            var entry = getIconEntry(iconKey);
            return entry ? { color: entry.color } : {};
        }

        function getLineText(line) {
            if (!line || !line.tooltipKey) { return ''; }
            var params = _.isNumber(line.qty) ? { qty: line.qty } : undefined;
            return $translate.instant(line.tooltipKey, params);
        }
    }
})();

(function() {
  angular.module('phenix').directive('additionalLine', behavior)

  function behavior () {
    return {
      restrict: 'E',
      scope: {
        additional: '=',
        showAdd: '='
      },
      controllerAs: 'ctrl',
      templateUrl: 'app/components/products/documents/pr/additionalLine.template.html',
      controller: controller,
      bindToController: true
    }
  }

  function controller() {

  }
})();
(function () {
    "use strict";

    angular.module('phenix').directive('ndsDoc', ndsDoc);

    function ndsDoc($compile) {
        var directive = {
            restrict: 'E',
            scope: {
                documentApp: '@'
            },
            link: function (scope, element, attrs, controller) {
                if (controller.documentApp) {
                    element.children().addClass('nds-doc-container');
                    var docAppl = '<nds-doc-residual residual-raw=\'' + controller.documentApp + '\'/>';

                    // i don't know why angular need to compile dom element before inject to the dom;
                    var content = $compile(docAppl)(scope);

                    element.children().prepend(content);
                }

            },
            controller: controller,
            bindToController: true,
            controllerAs: 'vm'
        };
        return directive;
    }


    function controller() {
    }

})();

(function () {

    angular.module('phenix').component('ndsDocResidual', {
        bindToController: true,
        controllerAs: 'vm',
        controller: ndsDocResidualController,
        templateUrl: 'app/components/products/documents/mr/nds-doc-residual.template.html',
        bindings: {
            residualRaw: '@' // string
        }
    });

    function ndsDocResidualController() {

        /********************************
         *          VARIABLES           *
         ********************************/

        var vm = this;
        vm.residual = [];

        /*******************************
         *          FUNCTIONS          *
         ******************************/

        vm.computedResidual = computedResidual;

        /**
         *  @desc
         *          - Format residual data for view
         */

        this.$onInit = function () {
            var residualJSON = JSON.parse(vm.residualRaw);
            vm.residual = computedResidual(residualJSON);
        }


        /**
         *  @desc ResidualRaw is an Array<Array<Object>>
         *
         * [
         *      [
         *          {
         *              labelObj: string
         *              listCrit: [{
         *                  labelCrit: string
         *                  // and more
         *              }]
         *              // and more
         *          }
         *      ]
         *  ]
         *
         *  => Updated to Array<string> (look at .spec of this component)
         *
         */

        function computedResidual(residualRaw) {
            var flattenResidualRaw = residualRaw.reduce(function (acc, currentValue) {
                return acc.concat(currentValue);
            }, [])

            return flattenResidualRaw.map(function (residual) {
                var labelObj = residual.labelObj;
                var labelCrit = '';
                if (Array.isArray(residual.listCrit)) {
                    labelCrit = residual.listCrit.map(function (crit) {
                        return crit.labelCrit
                    }).join(' | ');
                }
                return labelObj + ' : ' + labelCrit;
            })
        }
    }

})();

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .controller('mrVideoCtrl', mrVideoCtrl);
  
    /** @ngInject */
    function mrVideoCtrl($sce) {
      var vm = this;
      vm.videoUrl = { src: vm.url };
      function init() {
        vm.trustedSrc = trustedSrc;
  
      }
      function trustedSrc(src) {
        return $sce.trustAsResourceUrl(src);
      }
      init();
    }
  })();
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('mrDocumentsMetierService', mrDocumentsMetierService);

    /** @ngInject */
    function mrDocumentsMetierService(
        DocumentsMetierService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        this.getInitialSieDocuments = getInitialSieDocuments;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name getInitialSieDocuments
         * @desc get sie documents
         * @param {Array} mrIDList list of MR Ids
         */
        function getInitialSieDocuments(mrIDList) {
            return DocumentsMetierService.returnSIEDocuments(mrIDList).then(function (mrDocuments) {
                return formatResidual(mrDocuments);
            });
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name formatResidual
         * @desc parse mr documents and add applicabilities object
         * @param {Array} list
         * [{
                "pdfContent": "false",
                "id": "59c2e6ce26c24500dcd5444a",
                "sieRef": "RDE-000048765",
                "designationLanguage": "fr",
                "designation": "huile moteur : caractéristiques",
                "contentPath": "SIE/MR/Content/RDE-000048765.xml",
                "residual": [],
                "applicabilities": []
            }]
         * @return {Array}
         */
        function formatResidual(list) {
            return list.map(function (elem) {
                elem.residual = (elem.residual) ? elem.residual : [];
                elem.applicabilities = [];
                elem.residual.forEach(function (residual) {
                    residual.fixe = (residual.fixe) ? residual.fixe : [];
                    residual.variable = (residual.variable) ? residual.variable : [];
                    residual.fixe.forEach(function (fixe) {
                        elem.applicabilities.push({
                            label: fixe.labelObj,
                            list: fixe.listCrit.map(function (crit) {
                                return crit.labelCrit + ' (' + crit.codeCrit + ')';
                            })
                        })
                    });
                    residual.variable.forEach(function (variable) {
                        elem.applicabilities.push({
                            label: variable.labelObj,
                            list: variable.listCrit.map(function (crit) {
                                return crit.labelCrit + ' (' + crit.codeCrit + ')';
                            })
                        });
                    });
                });
                return elem;
            });
        }
    }

})();

/**
 * MRDocumentsCtrl Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('MRDocumentsCtrl', MRDocumentsCtrl);

    /**
     * @namespace MRDocumentsCtrl
     * @desc display MR data
     * @memberOf Controllers
     */

    function MRDocumentsCtrl(
        toastr,
        blockUI,
        $scope,
        $state,
        $window,
        $mdDialog,
        CacheConstants,
        RoutesConstants,
        $translate,
        $filter,

        CacheService,
        DocumentsMetierService,
        mrDocumentsMetierService,
        AlertsService,
        UtilsMetierService,
        searchByTextsIdsMertierService,
        CarSearchMetierService,
        configConstantes,$log, $q,DocPrivMetierService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.listofMrDocs = [];
        vm.listOfMRDocuments = [];
        vm.loading = true;
        vm.tempMRDocuments = [];
        vm.orgMRDocuments = [];
        vm.orgMRelements = [];
        vm.orgMRoperations = [];
        
        vm.selectedFilterElement = "";
        vm.selectedFilterOperation = "";
        vm.translatedElementLabel = "";
        vm.translatedOperationLabel = "";
        vm.selectedMR = "";
        vm.element = "Element";
        vm.operation = "Operation";
        vm.displayMrDetails = displayMrDetails;
        vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
        vm.isRedButtonAuthorized = false;
        vm.openAlertsPopin=openAlertsPopin;
        vm.close = close;
        vm.onOk = onOk;
        vm.initDocuments = initDocuments;
        vm.onChangeElement = onChangeElement;
        vm.onChangeOperation = onChangeOperation;
        vm.user = CacheService.getUserProfile();
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        init(); 

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {
            /**Event on click ==>fired by a tab change**/
            vm.isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            vm.translatedElementLabel = $translate.instant('CAR_DOC_RESULT_FILTER_ELT');
            vm.translatedOperationLabel = $translate.instant('CAR_DOC_RESULT_FILTER_OPE');
            vm.isRedButtonAuthorized = vm.isTraceEnabled;
            if(!vm.isSearchEngine){
                $scope.$on('phx-init-listMR', function (event, mrIDList) {                   

                    if (!mrIDList || !mrIDList.length) {
                        vm.loading = false;
                        return null;
                    }
                    vm.mrResponse = DocPrivMetierService.getRepairManuals();
                    if(!vm.mrResponse || _.isEmpty(vm.mrResponse)){
                        blockUI.start();
                    mrDocumentsMetierService.getInitialSieDocuments(mrIDList).then(function (mrDocuments) {
                        DocPrivMetierService.setRepairManuals(mrDocuments);
                        processMRResponse(mrDocuments);                                            
                    }, function (error) {
                        toastr.error(error, 'Error');
                    }).finally(function () {
                        vm.loading = false;
                        blockUI.stop();
                    });
                }
                else{
                    processMRResponse(vm.mrResponse);
                    vm.loading = false;
                }
                });
                vm.screenshotButtonVisibility = AlertsService.getScreenshotButtonVisibility();
                vm.captureScreenshot = captureScreenshot;
            } else {
                $scope.$on('phx-init-listMR', function (event, mrIDList, isNoData) {
                    var types = ['MR'];           
                    vm.inputFilterText = CacheService.getObject(CacheConstants.motCle); 
                    vm.docType = 'MR';
                    if(!_.isEmpty(mrIDList)){
                        searchEngineMR(mrIDList);
                    }else{
                        if(isNoData) {
                            vm.listOfMRDocuments = [];
                            vm.listofMrDocs = [];
                            vm.loading = false;
                        } else {                      
                            blockUI.start();
                            searchByTextsIdsMertierService.getSearchEngineDocs(vm.inputFilterText,types).then(function(response){
                                if(!_.isEmpty(response)){                      
                                    searchEngineMR(response);   
                                }     
                            }).finally(function(){
                                vm.loading = false;
                                blockUI.stop();
                            })
                        }
                    }
                });
            }

        }

        function processMRResponse(mrDocuments){
            vm.selectedFilterElement =  vm.translatedElementLabel;
            vm.selectedFilterOperation = vm.translatedOperationLabel;
            angular.copy(mrDocuments,vm.listofMrDocs);
            initDocuments(mrDocuments);
            var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
            if (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexMR && tabIndex.data) {
                getSelectedMr();
                removeSelectedMr();
            }                    

            vm.listOfMRDocuments = mrDocuments;
            angular.copy(vm.listOfMRDocuments,vm.orgMRDocuments);
            angular.copy(vm.listMRelements, vm.orgMRelements);
            angular.copy(vm.listMRoperations, vm.orgMRoperations);
        }
        
        function searchEngineMR(mrElementList){
            if(!_.isEmpty(mrElementList)){
                vm.searchEngineData = DocPrivMetierService.getSearchEngineMd(); 
                if(!vm.searchEngineData || _.isEmpty(vm.searchEngineData.MrData)) {
                blockUI.start();
                DocumentsMetierService.getIDsBySieElemOpe(mrElementList,["MR"]).then(function(resp){      
                    _.assign(vm.searchEngineData,{MrData: resp})
                    DocPrivMetierService.setSearchEngineMd(vm.searchEngineData);   
                    mrValidation(resp);         
                }).finally(function(){
                    blockUI.stop();
                })
            }
            else{
                mrValidation(vm.searchEngineData.MrData);
            }
            }         
        }
       function mrValidation(resp){
        var mrIdList = [];
        if(!_.isEmpty(resp)){
            resp.forEach(function(item){
                if(item.docs && !_.isEmpty(item.docs)){
                    item.docs.forEach(function(MRids){
                        mrIdList.push(MRids.id);
                    })
                }
            })
        }
        if(!_.isEmpty(mrIdList)){
            vm.mrResponse = DocPrivMetierService.getRepairManuals();
            if(!vm.mrResponse || _.isEmpty(vm.mrResponse)){
            blockUI.start();
            mrDocumentsMetierService.getInitialSieDocuments(mrIdList).then(function(mrDocuments){
                if(mrDocuments){
                    DocPrivMetierService.setRepairManuals(mrDocuments);
                    processMRResponse(mrDocuments); 
                    searchMrFiltering(mrDocuments);                             
                }
            }).finally(function(){
                blockUI.stop();
            })
        }
        else{
            processMRResponse(vm.mrResponse); 
            searchMrFiltering(vm.mrResponse);
        }
        } else{
            vm.listOfMRDocuments = [];
            if($state.params.clipRedirect){
                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                CacheService.removeObject(CacheConstants.isSearchEngine);
                $state.go(RoutesConstants.carSearchResult);
            }
        }
       }

       function searchMrFiltering(mrDocuments){
        if(!_.isEmpty(mrDocuments) && mrDocuments.length == 1 && $state.params.clipRedirect){
            if (mrDocuments[0].pdfContent == "false") {
                $state.go(RoutesConstants.documentMR, {
                    id: mrDocuments[0].sieRef,
                    plateIndex: $state.params.plateIndex,
                    refIndex: $state.params.refIndex,
                    prMRLinked: true
                });
            }
            else {
                DocumentsMetierService.returnSiePdfContent(mrDocuments[0].sieRef, 'SIE_MR').then(function (result) {
                    var url = result.contentUrl;
                    $window.open(url, '_blank');
                });
            }
        } else if($state.params.clipRedirect){
            CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
        }
       }
        /**
         * @name displayMrDetails
         * @desc display xml page or pdf page
         * this action trigger when the user click on the mr row
         * @param {array} id MR id
         * @param {bool} isPdf used to redirect the user to xml route op open new pdf
         * @memberOf Controllers.MRDocumentsCtrl
         */
        function displayMrDetails(id, isPdf) {
            if (isPdf == "false") {
                $state.go(RoutesConstants.documentMR, {
                    id: id,
                    plateIndex: $state.params.plateIndex,
                    refIndex: $state.params.refIndex
                });
            }
            else {
                DocumentsMetierService.returnSiePdfContent(id, 'SIE_MR')
                    .then(function (result) {
                        var url = result.contentUrl;
                        var contextData = CacheService.getObject(CacheConstants.contextCarRequest);
                        dynaMrDataTracking(contextData,id);
                        $window.open(url, '_blank');
                    });
            }
            clearSelected();
        }
        function dynaMrDataTracking(data,id){
            return $q.resolve().then(function(){
                var item = data.model + ', ' + data.motorisation;
                var identity = dtrum.enterAction("trackingtestdata", "click", dtrum.now())||0;
                dtrum.addActionProperties(identity, null, null, {"ppx_trackingtestdata":{
                    value:item
                }});
                dtrum.addActionProperties(identity, null, null, {"ppx_vinnumber":{value:data.vin}}, null);
                dtrum.addActionProperties(identity, null, null, {"ppx_mrid":{value:id}}, null);
               dtrum.leaveAction(identity, dtrum.now());
                     return;
                     }).catch(function(err) {
                         return $q.resolve(data);
                     });
    
        }
        
        function initDocuments(list) {
            vm.listOfMRDocuments = list;
            vm.listMRelements = [];
            vm.listMRoperations = [];
            for(var i=0; i < list.length; i++){
                var elemOper = list[i].designation.split(': ');
                if (elemOper.length == 2){
                    vm.listMRelements.push(elemOper[0].trim());
                    vm.listMRoperations.push(elemOper[1].trim());

                    _.extend(list[i],{element : elemOper[0].trim()});
                    _.extend(list[i],{operation : elemOper[1].trim()});
                }
                else{
                    _.extend(list[i],{element : ""});
                    _.extend(list[i],{operation : ""});
                }
            }

            angular.copy(vm.listOfMRDocuments,vm.tempMRDocuments);

            vm.listMRelements = _.uniq(vm.listMRelements);
            vm.listMRoperations = _.uniq(vm.listMRoperations);

            vm.listMRelements= $filter('orderBy')(vm.listMRelements,'', false);
            vm.listMRoperations= $filter('orderBy')(vm.listMRoperations,'', false);
            vm.listMRelements.unshift(vm.translatedElementLabel);
            vm.listMRoperations.unshift(vm.translatedOperationLabel);
        }

        function onChangeElement(item){
            vm.selectedFilterElement = item;

            if (item == vm.translatedElementLabel && vm.selectedFilterOperation == vm.translatedOperationLabel){
                angular.copy(vm.orgMRDocuments, vm.listOfMRDocuments);
                angular.copy(vm.orgMRelements, vm.listMRelements);
                angular.copy(vm.orgMRoperations, vm.listMRoperations);
            }
            else if (item != vm.translatedElementLabel && vm.selectedFilterOperation != vm.translatedOperationLabel){
                getElementOperationList(vm.tempMRDocuments,item,vm.element);
            }
            else if (item != vm.translatedElementLabel && vm.selectedFilterOperation == vm.translatedOperationLabel){
                getElementOperationList(vm.orgMRDocuments,item,vm.element);
                angular.copy(vm.orgMRelements,vm.listMRelements);
            }
            else if (item == vm.translatedElementLabel && vm.selectedFilterOperation != vm.translatedOperationLabel){
                getElementOperationList(vm.orgMRDocuments,vm.selectedFilterOperation,vm.operation);
                angular.copy(vm.orgMRoperations,vm.listMRoperations);
            }

        }

        function onChangeOperation(item){
            vm.selectedFilterOperation = item;

            if (item == vm.translatedOperationLabel && vm.selectedFilterElement == vm.translatedElementLabel){
                angular.copy(vm.orgMRDocuments, vm.listOfMRDocuments);
                angular.copy(vm.orgMRelements, vm.listMRelements);
                angular.copy(vm.orgMRoperations, vm.listMRoperations);
            }
            else if (item != vm.translatedOperationLabel && vm.selectedFilterElement != vm.translatedElementLabel ){
                getElementOperationList(vm.tempMRDocuments,item,vm.operation);
            }
            else if (item != vm.translatedOperationLabel && vm.selectedFilterElement == vm.translatedElementLabel ){
                getElementOperationList(vm.orgMRDocuments,item,vm.operation);
                angular.copy(vm.orgMRoperations,vm.listMRoperations);
            }
            else if (item == vm.translatedOperationLabel && vm.selectedFilterElement != vm.translatedElementLabel ){                
                getElementOperationList(vm.orgMRDocuments,vm.selectedFilterElement,vm.element);
                angular.copy(vm.orgMRelements,vm.listMRelements);
            }
            
        }

        function getElementOperationList(list,item,option){
            var elemOperList = [];
            if (option == "Element" ){
                for(var i = 0; i < list.length; i++){
                    if (list[i].element.includes(item) && list[i].element.length == item.length){
                        elemOperList.push(list[i]);
                    }
                }
            }
            else{
                for(var i = 0; i < list.length; i++){
                    if (list[i].operation.includes(item) && list[i].operation.length == item.length){
                        elemOperList.push(list[i]);
                    }
                }
            } 
            
            vm.listOfMRDocuments = elemOperList;
            initDocuments(vm.listOfMRDocuments);

        }

        function openAlertsPopin(checkDocType) {
            var body = angular.element(document.body);
            $mdDialog.show({
                 parent: body,
                templateUrl: 'app/components/products/documents/mr/documentaryAlertPop.template.html',
               controller: 'MRDocumentsCtrl',
               bindToController: true,
               controllerAs: 'vm',
             }).then(function (){
                AlertsService.setPopinVisibility(true, checkDocType, vm.listOfMRDocuments, vm.isTraceEnabled);

                if (AlertsService.getPopinVisibility().status == true) {
                    changeLinkColor("#TM_DOCUMENTARY_ERROR");
                }
             });
         }
      
        function close() {
            $mdDialog.cancel();
        }
        function onOk(){
            $mdDialog.hide();
    }
        function changeLinkColor(id) {
            $(id).css({
                'color': '#666666'
            });
        }
        function captureScreenshot() {
            blockUI.start();
            var node = document.body;
            html2canvas(node, {
                x: window.scrollX,
                y: window.scrollY,
                type: 'view'
            }).then(function (canvas) {
                vm.capturedImage = canvas.toDataURL();
                blockUI.stop();
                $mdDialog.show({
                    templateUrl: 'app/components/alerts/modal/screenShotModel/captureScreenshot.html',
                    controller: 'captureScreenshotController',
                    bindToController: true,
                    controllerAs: 'vm',
                    size: 'lg',
                    locals: {
                        capturedImage: vm.capturedImage
                    }
                });
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
        }

        $scope.$on("$destroy", function () {
            AlertsService.setScreenshotButtonVisibility(false);
        });
        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //get selected MR Object from Cache
        function getSelectedMr(){
            vm.selectedMR = CacheService.getObject(CacheConstants.tabIndex).data.myRef;
        }

        //remove selected MR Object
        function removeSelectedMr(){
            CacheService.removeObject(CacheConstants.tabIndex);
        }


        //clear selected item from the current tab
        //this function is used to delete selected MR
        //when we select MR first, we click on back from documentation and choose pdf later
        function clearSelected() {
            angular.element(document.querySelectorAll(".documents-row")).removeClass("selected");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('MrDocumentDetailsCtrl', MrDocumentDetailsCtrl);

    /** @ngInject */
    function MrDocumentDetailsCtrl(DocumentsMetierService,
                                   CacheService,
                                   NavigationSieService,
                                   CacheConstants,
                                   blockUI,
                                   $state,
                                   RoutesConstants,
                                   $mdDialog,
                                   $window,
                                   toastr,
                                   $translate,
                                   SearchSpecializedToolBusinessService,
                                   ClipService,
                                   ClipConstants,
                                   RdsConstants,
                                   CarSearchMetierService,
                                   $sce,$q,
                                   $timeout,$rootScope,
                                   configConstantes,MainMetierService,$log,$document) {
                                       
        var vm = this;

        /*****************
         *  VARIABLE
         ****************/

        vm.MR = {
            title: null,
            content: null
        };
        vm.listMR = null;
        vm.popinTitle = null;
        vm.documentsHistory = [];
        vm.slectedSpecialTool = {};
        vm.removeChildMr = removeChildMr;
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.isRnetUser = MainMetierService.isRnetUserType();
        vm.newDataDisplay = false;
        vm.backButtonHide = false;
        vm.initialTitle = null;
        vm.isFirstLoad = true;
        vm.isInitialTitle = true;

        /**********************
         *  INITIALISATION
         *********************/

         /**         **/

         $rootScope.$on('newDisplayBack', function (event, val) {
            var documents = CacheService.getSieDocumentsHistory() || [];
            var btData = _.filter(documents, function (item) {
                return item.type === 'BT'
            })
            var mdData = _.filter(documents, function (item) {
                return item.type === 'MD'
            })
            if(!_.isEmpty(btData) || !_.isEmpty(mdData)){
                vm.backButtonHide = false;
            }else{
                vm.backButtonHide = val;
            }
            
        });

        (function init() {
            var documentId = $state.params.id || '';
            var filter = CacheService.getObject(CacheConstants.filter);

            var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
            
            vm.isMRInNewTab = localStorage.getItem('isMRInNewTab');
            localStorage.removeItem('isMRInNewTab');
            if(vm.isMRInNewTab)
                $rootScope.$broadcast("isMRInNewTab", vm.isMRInNewTab);
            if (filter.id != "INT_REPAIR"){
                if(!tabIndex){
                    var selectedMr = {
                        id: RoutesConstants.listPieceIndexMR,
                        data: { 'myRef': $state.params.id }
                    };

                    CacheService.setObject(CacheConstants.tabIndex, selectedMr);
                    vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'MR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                }
                else{
                    vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'MR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                }
            }
           
            if(filter.id == "INT_REPAIR"){
                if(!tabIndex){
                    var selectedMr = {
                        id: RoutesConstants.listPieceIndexINT,
                        data: { 'myRef': $state.params.interventionId }
                    };
    
                    CacheService.setObject(CacheConstants.tabIndex, selectedMr);
                    vm.documentsHistory = NavigationSieService.updateDocumentsHistory($state.params.interventionId, 'INT_REPAIR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                
                }
                else{
                    vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'INT_REPAIR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                }
            }

            //updateDocumentsHistory
            getMRDocumentation($state.params.id);
        })();


        /*********************
         *  FUNCTIONS
         ********************/


        vm.onClickedLink = onClickedLink;
        vm.backToPreviousDocument = backToPreviousDocument;
        vm.goToListPiece = goToListPiece;
        vm.onClickedOutilSpeLink = onClickedOutilSpeLink;
        vm.openVideo = openVideo;


        function removeChildMr() {
            var tags = $document.find('sieref');
            angular.forEach(tags, function (tag) {
                if (tag.querySelector("#childMr")) {
                    tag.querySelector("#childMr").remove();
                    angular.element(tag.querySelector("#childMr")).removeClass('newlyAddedBorder');
                    vm.newDataDisplay = false;
                }
                vm.MR.title = vm.initialTitle;
            })
        }

        function openVideo(id){
            $mdDialog.show({
                templateUrl: 'app/components/products/documents/mr/mrVideo.template.html',
                controller: 'mrVideoCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                  url: id
                }
              })
        }

        angular.element($window).bind("scroll", function () {
            var pipVideo = document.getElementsByTagName('video');
            for (var i=0; i< pipVideo.length;i++){
                if (pipVideo[i].currentTime > 0 && !pipVideo[i].paused && !pipVideo[i].ended && pipVideo[0].readyState > 2){
                    pipVideo[i].requestPictureInPicture().catch(function(error) { 
                    });
                }
            }
            

        });

        function goToListPiece() {
            NavigationSieService.goToFirstElement();
        }
        function backToPreviousDocument() {
            var interventionIdList = CacheService.getObject(CacheConstants.interventionIdList);
            if(!_.isEmpty(interventionIdList) && !interventionIdList.isIntTabClick ){
                $state.go(RoutesConstants.carSearchResult);
             
            }
            else{
                NavigationSieService.backToPreviousDocument(vm.backButtonHide);
            }
        }

        function onClickedLink(MRList, popinTitle,isNewtab,isNewTabOpen) {
            localStorage.removeItem('isMRInNewTab');
            if (isNewtab) {
                var id = MRList[0].reference;
                var type = MRList[0].type;
                if (type === 'MD') {
                    $state.go(RoutesConstants.documentMD, { id: id });
                } else {
                    var url = $state.href('.', {id:id});
                    localStorage.setItem('isMRInNewTab',isNewtab);
                    $window.open(url, '_blank');
                }
            } else {
                if (isNewTabOpen) {
                    vm.isMRInNewTab = true;
                }
                else {
                vm.isMRInNewTab = false;
            }
                var numberOfMR = MRList.length;
                var cacheDataMr = CacheService.getSieDocumentsHistory();
                _.map(cacheDataMr, function (item) {
                    if (item && item.data && item.data.myRef === $state.params.id) {
                        _.assign(item.data, { scrollY: parseInt(window.scrollY) });
                    }
                })
                CacheService.setSieDocumentsHistory(cacheDataMr);
                if (!numberOfMR) {
                    vm.listMR = [];
                } else if (numberOfMR > 1 || (numberOfMR === 1 && MRList[0].residual && MRList[0].residual.length)) {
                    $mdDialog.show({
                        contentElement: '#myStaticDialog',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true
                    });
                    vm.listMR = MRList;
                    vm.popinTitle = popinTitle;
                } else {
                    var id = MRList[0].reference;
                    var type = MRList[0].type;
                    if(type === 'MD'){
                        $state.go(RoutesConstants.documentMD,{id:id});
                    } else{
                        if(vm.isArcaUser || vm.isRnetUser){
                        vm.newDataDisplay = true;
                        var documentId = id || '';
                        var filter = CacheService.getObject(CacheConstants.filter);
                        var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
                            if (isNewTabOpen) {
                                vm.isMRInNewTab = true;
                            }
                            else{                 

                        vm.isMRInNewTab = localStorage.getItem('isMRInNewTab');
                        localStorage.removeItem('isMRInNewTab');
                            }                          
                        if (vm.isMRInNewTab)
                            $rootScope.$broadcast("isMRInNewTab", vm.isMRInNewTab);
                        if (filter.id != "INT_REPAIR") {
                            if (!tabIndex) {
                                var selectedMr = {
                                    id: RoutesConstants.listPieceIndexMR,
                                    data: { 'myRef': $state.params.id }
                                };

                                CacheService.setObject(CacheConstants.tabIndex, selectedMr);
                                vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'MR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                            }
                            else {
                                vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'MR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                            }
                        }

                        if (filter.id == "INT_REPAIR") {
                            if (!tabIndex) {
                                var selectedMr = {
                                    id: RoutesConstants.listPieceIndexINT,
                                    data: { 'myRef': $state.params.interventionId }
                                };
                                CacheService.setObject(CacheConstants.tabIndex, selectedMr);
                                vm.documentsHistory = NavigationSieService.updateDocumentsHistory($state.params.interventionId, 'INT_REPAIR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                            }
                            else {
                                vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'INT_REPAIR', $state.params.plateIndex, $state.params.refIndex, $state.params.prMRLinked);
                            }
                        }
                        getMRDocumentation(documentId);
                    }
                    else{
                        $state.go('.', { id: id });
                    }
                    }
                }
            }
        }

        function onClickedOutilSpeLink(outilSpeId) {
            if (_.isNil(outilSpeId) || _.isEmpty(outilSpeId) || outilSpeId === 'undefined' || vm.isLoadingSpecialTool) {
                return;
            }
            vm.isLoadingSpecialTool = true;
            blockUI.start();

            var specialToolsPayload = {
                userContext: CacheService.getUserContext(),
                carContext: CacheService.getCarContext(),
                documentIds: [outilSpeId.replace(/\s/g, '')]
            };

            SearchSpecializedToolBusinessService.specialTools(specialToolsPayload).then(function (response) {

                if (!_.isEmpty(response.specialTools)) {
                    vm.slectedSpecialTool = response.specialTools[0];
                    var pictogramHtml = '';
                    if (vm.slectedSpecialTool.essential) {
                        if (!vm.slectedSpecialTool.validated && !vm.slectedSpecialTool.commercialized) {
                            pictogramHtml = '<i class="fa fa-stop-circle fa-2x" style="color: red;"></i>';
                        } else {
                            pictogramHtml = '<i class="fa fa-star fa-2x" style="color: var(--renaultPrimaryColor);"></i>';
                        }
                    } else if (!vm.slectedSpecialTool.essential && !vm.slectedSpecialTool.commercialized) {
                        pictogramHtml = '<i class="fa fa-stop-circle fa-2x" style="color: red;"></i>';
                    }

                    vm.pictogram = $sce.trustAsHtml(pictogramHtml);
                    //vm.pictogram = vm.displayPictogram(vm.slectedSpecialTool);
                    $mdDialog.show({
                        templateUrl: 'app/components/car/searchSpecializedTool/selectedTool/specializedToolSelection.template.html',
                        controller: 'specializedToolSelectionController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            identifier: vm.slectedSpecialTool.identifier,
                            reference: vm.slectedSpecialTool.reference,
                            designation: vm.slectedSpecialTool.designation,
                            comment: vm.slectedSpecialTool.comment,
                            supplier: vm.slectedSpecialTool.supplier,
                            pictureUrl: vm.slectedSpecialTool.pictureUrl,
                            pictogram: vm.pictogram
                        }
                    });
                }else {
                    toastr.warning($translate.instant('ERROR_DOCUMENT_NOT_FOUND'));
                }
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
                vm.isLoadingSpecialTool = false;
            });
        }

            /********************
         *      TOOLS
         *******************/

        function getMRDocumentation(id) {
            if((vm.isArcaUser || vm.isRnetUser) && vm.newDataDisplay){
                var documents = CacheService.getSieDocumentsHistory() || [];  
                if (documents.length > 1) {
                    var lastVisitedDocument = documents.pop();
                    if (lastVisitedDocument) {
                        CacheService.setSieDocumentsHistory(documents);
                    }
                }
            }
            var cacheDataMr = CacheService.getSieDocumentsHistory();
            blockUI.start();
            DocumentsMetierService.returnMRDetail(id).then(function (result) { 
                vm.enableWatch = true;
                if( cacheDataMr &&  !_.isEmpty(cacheDataMr)){
                    var filteredArray = _.filter(cacheDataMr, function(item){
                        if(item && item.data && item.data.myRef){
                        return item.data.myRef === id;
                        }
                    })
                    $timeout(function() {
                        if(!_.isEmpty(filteredArray)){
                        window.scrollBy(0,filteredArray[0].data.scrollY);
                        delete filteredArray[0].data.scrollY;
                        }
                        CacheService.setSieDocumentsHistory(cacheDataMr);
                    }, 50); 
                } 
                vm.MR.title = result.title;
                vm.isInitialTitle = false;
                vm.MR.content = result.content;
                if (vm.isFirstLoad) {
                    vm.initialTitle = vm.MR.title;
                    vm.isFirstLoad = false;
                }
                var contextData = CacheService.getObject(CacheConstants.contextCarRequest);
                dynaMrDataTracking(contextData,id);
                //var clipParameters = ClipService.getParameters(ClipConstants.clipCookieName);
                var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
                var clipParameters = MainMetierService.getClipParameters();
                if(!_.isEmpty(clipParameters) || !_.isEmpty(commonParameters)){
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                }
            }, function (msg) {
                toastr.error($translate.instant(msg.error.value));
            }).finally(function () {
                blockUI.stop();
                // ClipService.removeParameters(ClipConstants.clipCookieName);
                MainMetierService.setClipParameters(null);
                ClipService.removeParameters(ClipConstants.commonCookieName);
            });
        }

        function dynaMrDataTracking(data,id){
            return $q.resolve().then(function(){
                var item = data.model + ', ' + data.motorisation;
                var identity = dtrum.enterAction("trackingtestdata", "click", dtrum.now())||0;
                dtrum.addActionProperties(identity, null, null, {"ppx_trackingtestdata":{
                    value:item
                }});
                dtrum.addActionProperties(identity, null, null, {"ppx_vinnumber":{value:data.vin}}, null);
                dtrum.addActionProperties(identity, null, null, {"ppx_mrid":{value:id}}, null);
               dtrum.leaveAction(identity, dtrum.now());
                     return;
                     }).catch(function(err) {
                         return $q.resolve(data);
                     });
    
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('phenix')
        .config(routerConfig);


     /** @ngInject */
     function routerConfig($stateProvider, RoutesConstants) {

        $stateProvider.state(RoutesConstants.documentMR, {
            url: '/documentMR/{id}/plate/:plateIndex/ref/:refIndex',
            templateUrl: 'app/components/products/documents/mr/mrDocumentDetails.template.html',
            controller: 'MrDocumentDetailsCtrl',
            controllerAs: 'vm',
            params: {
                prMRLinked: null,
                interventionId: null
            }
        });

    }

})();

(function () {
    "use strict";

    angular.module('phenix').directive('mrAppl', mrAppl);

    function mrAppl($compile, $translate) {
        var directive = {
            restrict: 'E',
            scope: {
                documentApp: '@'
            },
            link: function (scope, element, attrs, controller) {
                controller.documentApp = controller.documentApp.replace(/\|/g, " - ");

                var documentAppText = $translate.instant('DOCUMENT_APPLIES_TO');
                var docAppl = '<b class="mr-doc-appl">' + documentAppText + controller.documentApp + '</b><br>';
                var content = $compile(docAppl)(scope);
                element.append(content);
            },
            controller: controller,
            bindToController: true,
            controllerAs: 'vm'
        };
        return directive;
    }


    function controller() {
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('MDController', MDController);

    function MDController(CacheService,CacheConstants, DocPrivMetierService, DocumentsMetierService, $scope, blockUI, searchByTextsIdsMertierService,$rootScope,$translate,toastr,$timeout,configConstantes) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.node = DocumentsMetierService.getNodeInCache();
        vm.atLeastOneMDDocument = false;
        vm.loading = true;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {
            vm.isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            resetFilter();
            if(!vm.isSearchEngine){
                /**This means that MD list is the first to be displayed**/
                $scope.$on('phx-init-listMD', function (event, mdIDList) {
                    if (mdIDList && mdIDList.length) {
                    resetFilter();
                    initDocuments(mdIDList);
                    }
                });
            } else {
                $scope.$on('phx-init-listMD', function (event, mdIdList, isNoData) {
                    var types = ['MD'];           
                    vm.inputFilterText = CacheService.getObject(CacheConstants.motCle); 
                    vm.docType = 'MD';
                    resetFilter();
                    blockUI.start();
                    if(!_.isEmpty(mdIdList)){
                        searchEngineMD(mdIdList);
                    }else{
                        if(isNoData){
                            vm.listOfMDDocuments = [];
                            vm.atLeastOneMDDocument = false;
                            vm.loading = false;
                            blockUI.stop();
                        } else {
                            searchByTextsIdsMertierService.getSearchEngineDocs(vm.inputFilterText,types).then(function(response){
                                if(!_.isEmpty(response)){                      
                                    searchEngineMD(response);   
                                }
                            }).finally(function(){
                                vm.loading = false;
                                blockUI.stop();
                            })
                        }
                    }                   
                });
            }
        }
        
        function resetFilter(){
            var resetDiv = angular.element(document.querySelector('#docFilterReset'));
            angular.element(resetDiv).triggerHandler('click');
            $rootScope.$broadcast("filterMDReset",vm.listOfMDDocuments);
        }
        function searchEngineMD(mdElementList){
            if(!_.isEmpty(mdElementList)){ 
                vm.searchEngineData = DocPrivMetierService.getSearchEngineMd(); 
            if(!vm.searchEngineData || _.isEmpty(vm.searchEngineData.MdData)){
                DocumentsMetierService.getIDsBySieElemOpe(mdElementList,["MD"]).then(function(resp){   
                   _.assign(vm.searchEngineData,{MdData: resp})
                    DocPrivMetierService.setSearchEngineMd(vm.searchEngineData);         
                    mdValidation(resp);
                }).finally(function(){
                    blockUI.stop();
                })
            }
            else{
                mdValidation(vm.searchEngineData.MdData);
                blockUI.stop();
            }
            } else{
                blockUI.stop();
            }
        }

        function mdValidation(resp){
            var mdIdList = [];
            if(!_.isEmpty(resp)){
                resp.forEach(function(item){
                    if(item.docs && !_.isEmpty(item.docs)){
                        item.docs.forEach(function(MDids){
                            mdIdList.push(MDids.id);
                        })
                    }
                })
            }
            if(!_.isEmpty(mdIdList)){
                initDocuments(mdIdList);
            } else{
                vm.listOfMDDocuments = [];
            }
        }

        function boreneo3ServiceCalls(result){
            vm.listOfMDDocuments = result.MD;
            vm.filtered = vm.listOfMDDocuments;
          $timeout(function(){
            $rootScope.$broadcast("filterMDReset",vm.filtered);
          },100)
   
            if (vm.listOfMDDocuments) {
                vm.atLeastOneMDDocument = result.MD.length > 0;
            }
            if(result.MD && result.MD.length > 200){
                toastr.info($translate.instant('MD_RESULTS_INFO'));
            }
        }

        function initDocuments(mdIDList) {
            vm.mdData = DocPrivMetierService.getBorneo3Resposne();
            if(!vm.mdData || _.isEmpty(vm.mdData)){
                blockUI.start();
            DocumentsMetierService.getMDListFromArbo(DocumentsMetierService.createMDParams(mdIDList))
                .then(function (result) {
                    if(!_.isEmpty(result)){
                        DocPrivMetierService.setBorneo3Resposne(result);
                        boreneo3ServiceCalls(result);
                    }
                }) .finally(function () {
                    vm.loading = false;                    
                    blockUI.stop();
               });
            }
            else{
                boreneo3ServiceCalls(vm.mdData);
                vm.loading = false;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('EBCtrl', EBCtrl);

    function EBCtrl($scope, SearchArboTextualMetierService, blockUI, $mdDialog,CacheService,CacheConstants,DocPrivMetierService) {

        var vm = this;
        vm.isModal = true;
        vm.onCancel = onCancel;
        init();
        function init() {
            var destroyRoute = $scope.$on('phx-init-listINT_REPAIR', function (event, ebData, isFromIntTab, labelNode1, isIntTabClicked) {
                vm.isModal = false;
                if(isFromIntTab){
                    CacheService.removeObject(CacheConstants.interventionIdList);
                    CacheService.removeObject(CacheConstants.intNodeSelected);
                    CacheService.removeObject(CacheConstants.selectedInterventionId);
                    var interventionIdList = ebData;
                    CacheService.setObject(CacheConstants.interventionIdList, {interventionIds: interventionIdList, intLabel: isFromIntTab.label, intNodeId: isFromIntTab.nodeId, intNodeSelect: labelNode1, isIntClick: false, isIntTabClick: isIntTabClicked});    
                }
                checkInterventions(ebData);
            })
            $scope.$on('$destroy',destroyRoute);
        }
        function checkInterventions(SIEIds) {
            vm.isInterventionPresent = DocPrivMetierService.getInterventionResposne();
            if(!vm.isInterventionPresent || _.isEmpty(vm.isInterventionPresent)){
            blockUI.start();
            SearchArboTextualMetierService.getInterventionById(SIEIds).then(function (response) {
                if(!_.isEmpty(response)){
                DocPrivMetierService.setInterventionResposne(response);
                }
                vm.interventionData = angular.copy(response);
            }).catch(function (error) {
                // show error toastr
            }).finally(function () {
                blockUI.stop();
            })
        }
        else{
            vm.interventionData = vm.isInterventionPresent;
        }
        }
        function onCancel(){
            CacheService.removeObject(CacheConstants.interventionIdList);
            CacheService.removeObject(CacheConstants.selectedInterventionId);
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('BTController', BTController);

    /* @ngInject */
    function BTController(CacheService, CacheConstants, $state, RoutesConstants, DocumentsMetierService, $scope) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.atLeastOneBTDocument = false;
        vm.node = DocumentsMetierService.getNodeInCache();

        init();


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {


            /**This means that BT list is the first to be displayed**/
            $scope.$on('phx-init-listBT', function (event, data) {
                initDocuments(data.list);
            });

            /**Event on click ==>fired by a tab change**/
            $scope.$on('phx-click-listBT', function (event, data) {
                initDocuments(data);
            });

            function initDocuments(list) {
                vm.listOfBTDocuments = list;
                if (vm.listOfBTDocuments) {
                    vm.atLeastOneBTDocument = (vm.listOfBTDocuments && vm.listOfBTDocuments.length > 0);
                }
            }
        }

    }
})();

angular.module('phenix')
    .controller('btNtDocumentsController', btNtDocumentsController);
btNtDocumentsController.$inject = ['$mdDialog', 'btNamesAndLabels', 'DocumentsMetierService'];

/**
 * Controller for displaying BT and NT details
 * @param {$mdDialog} $mdDialog 
 * @param {btNamesAndLabels} btNamesAndLabels 
 * @param {DocumentsMetierService} DocumentsMetierService 
 */
function btNtDocumentsController($mdDialog, btNamesAndLabels, DocumentsMetierService) {
    var vm = this;
    vm.onClose = onClose;
    vm.btNamesAndLabels = btNamesAndLabels;
    vm.displayBtDetails = DocumentsMetierService.displayBtDetails;
    vm.displayNtDetails = DocumentsMetierService.displayNtDetails;

    function onClose() {
        $mdDialog.hide();
    }
}
(function () {
    angular.module('phenix').service('ArticlesDocumentsWSService',
        function (RestUpgrade, ficViewListConstants) {

            /*************************
             *      VARIABLE         *
             ************************/

            /************************
             *      FUNCTIONS       *
             ***********************/

            this.getArticlesList = getArticlesList;
            this.getNewArticlesList = getNewArticlesList;
            this.getNewArticlesListByUrl = getNewArticlesListByUrl;
            this.getArticleDetail = getArticleDetail;

            function getArticlesList(dealerId) {
                var url = ficViewListConstants.endpoint.listCase + dealerId + "/articles";
                return RestUpgrade.one(url).get().then( function(response)  {
                    return response;
                }).catch( function(err) {
                    return err;
                });
            }
            function getNewArticlesList(payload, itemsPerPage) {
                const urlArticles = ficViewListConstants.endpoint.articles + "?limit=" + itemsPerPage;
                return RestUpgrade.all(urlArticles).post(payload).then( function(response)  {
                    return response;
                }).catch( function(err) {
                    return err;
                });
            }

            function getNewArticlesListByUrl(nextUrl, payload) {
                const url = "/proxy/apidh/rest/" + nextUrl;
                return RestUpgrade.one(url).post('', payload).then( function(response)  {
                    return response;
                }).catch( function(err) {
                    return err;
                });
            }

            function getArticleDetail(dealerId, articleNo, articleId) {
                var url = ficViewListConstants.endpoint.listCase + dealerId + "/articles/" + articleNo + "/?articleId=" + articleId;
                return RestUpgrade.one(url).get().then( function(response)  {
                    return response;
                }).catch( function(err) {
                    return err;
                });
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('articlesDocuments', articlesDocuments);

    /** @ngInject */
    function articlesDocuments() {
        var directive = {
            templateUrl : "app/components/products/documents/articles/articlesDocuments.template.html",
            controller: 'articlesDocumentsController',
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
            }
        };
        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('articlesDocumentsController', articlesDocumentsController);

    /* @ngInject */
    function articlesDocumentsController(CacheService, CacheConstants, ArticlesDocumentsService, ArticleDocumentsConstants,blockUI, toastr,$rootScope,$sce, configConstantes) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.expend = false;
        vm.listArticles = [];
        vm.languageList = [];
        vm.selectedLang = '';
        vm.masterArticles = [];
        vm.currentPage = 1;
        vm.itemsPerPage = 100;
        vm.remainingDocuments = 0;
        vm.nextUrl = null;
        var DTC = false;
        var MCS = false;
        var dtcMcsList = [];
        var newArticlesContext = {};
        
        const excludedBackgroundColors = ['#ffffff'];

        vm.getArticleDetail = getArticleDetail;
        vm.changeLanguage = changeLanguage;
        vm.getTotalPages = getTotalPages;
        vm.nextPage = nextPage;
        vm.previousPage = previousPage;
        vm.hasNextPage = hasNextPage;
        vm.lang = ArticleDocumentsConstants.languageList;
        vm.newArticlesEnabled = JSON.parse(configConstantes.isNewArticles);
        const contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
        const userContextData = CacheService.getUserContext();
        if (vm.newArticlesEnabled) {
            activateNewArticles();
        } else {
            activate();
        }
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function filterStylesByBackgroundColor(htmlContent, colorsToExclude) {
            if (!htmlContent || typeof htmlContent !== 'string') {
                return htmlContent;
            }
            const excludeColors = colorsToExclude || excludedBackgroundColors;
            
            return htmlContent.replaceAll(/style\s*=\s*["']([^"']*)["']/gi, function(match, styleContent) {
                const bgColorMatch = styleContent.match(/background-color\s*:\s*([^;]+)/i);
                
                if (bgColorMatch) {
                    const extractedBgColor = bgColorMatch[1].trim();
                    
                    let shouldExclude = false;
                    for (const excludeColor of excludeColors) {
                        if (extractedBgColor === excludeColor) {
                            shouldExclude = true;
                            break;
                        }
                    }
                    
                    if (!shouldExclude) {
                        return `style="background-color: ${extractedBgColor};"`;
                    }
                }
                
                return '';
            });
        }
        function activate() {
            var userProfil = CacheService.getUserProfile();
            var dealerId = userProfil.dealerId;
            var contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var code = CacheService.getObject(CacheConstants.requestDiagnostic) ? CacheService.getObject(CacheConstants.requestDiagnostic).code : null;
            blockUI.start();

           ArticlesDocumentsService.getArticlesList(dealerId).then(function (response) {
                try {
                    processArticlesList(response.result, code, contextSearchedSymptom);
                } catch (error) {
                    toastr.error(error);
                } finally {
                    blockUI.stop();
                }
            }, function (error){
                toastr.error(error);
                blockUI.stop();
            })
        }

        function activateNewArticles() {
            const code = CacheService.getObject(CacheConstants.requestDiagnostic) ? CacheService.getObject(CacheConstants.requestDiagnostic).code : null;
            const contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
            const symptomCode = contextSearchedSymptom ? contextSearchedSymptom.code : null;
            const isSymptomCode = symptomCode && symptomCode.length === 4;
            const payload = {
                "carContext": contextCarRequest,
                "userContext": userContextData,
                "dtcCodes": isSymptomCode ? [] : (symptomCode ? [symptomCode.toUpperCase()] : []),
                "articleNumbers": [],
                "symptomCodes": isSymptomCode ? [symptomCode.toUpperCase()] : []
            }
            blockUI.start();
            ArticlesDocumentsService.getNewArticlesList(payload,vm.itemsPerPage).then(function (response) {
                try {
                    newArticlesContext = { code: code, contextSearchedSymptom: contextSearchedSymptom, payload: payload };
                    vm.remainingDocuments = response.remainingDocuments || 0;
                    vm.nextUrl = response.next_url || null;
                    processArticlesList(response.articles, code, contextSearchedSymptom);
                } catch (error) {
                    toastr.error(error);
                } finally {
                    blockUI.stop();
                }
            }, function (error){
                toastr.error(error);
                blockUI.stop();
            })
        }
        vm.formatProjectCode = function(projectCode) {
            return Array.isArray(projectCode) ? projectCode.join(', ') : projectCode;
        };
        function processArticlesList(responseResult, code, contextSearchedSymptom, isAppend) {            
            if (responseResult && !_.isEmpty(responseResult)) {
                dtcMcsList = [];
                vm.symptoms = vm.newArticlesEnabled ? 'symptomCodes' : 'MCS';
                vm.dtcCodes = vm.newArticlesEnabled ? 'dtcCodes' : 'DTC';
                vm.systemInfo = vm.newArticlesEnabled ? 'systemInfo' : 'SystemInfo';
                vm.article = vm.newArticlesEnabled ? 'article' : 'Article';
                vm.attachments = vm.newArticlesEnabled ? 'attachments' : 'Attachments';
                vm.solution = vm.newArticlesEnabled ? 'solution' : 'Solution';
                vm.articleId = vm.newArticlesEnabled ? 'articleId' : 'Id';
                vm.attachmentUrl = vm.newArticlesEnabled ? 'attachmentName' : 'attachementURL';
                if(!vm.newArticlesEnabled) {
                if (code == contextSearchedSymptom.code) {
                    DTC = true;
                    MCS = false;
                    _.map(responseResult, function(list){
                            if (list && list[vm.systemInfo] != null && (list[vm.systemInfo][vm.dtcCodes] == null || (list[vm.systemInfo][vm.dtcCodes] != null && list[vm.systemInfo][vm.dtcCodes].split('/').includes(contextSearchedSymptom.code)))){
                                dtcMcsList.push(list);
                        }
                    });                    
                }
                else {
                    DTC = false;
                    MCS = true;
                    _.map(responseResult, function(list){
                        
                            if (list && list[vm.systemInfo] != null && (list[vm.systemInfo][vm.symptoms] == null || (list[vm.systemInfo][vm.symptoms] != null && list[vm.systemInfo][vm.symptoms].split('/').includes(contextSearchedSymptom.code)))){
                                dtcMcsList.push(list);
                            }
                    });
                    
                }  
            }              
                if (!vm.newArticlesEnabled && !_.isEmpty(dtcMcsList)) {
                    dtcMcsList.forEach(function (item) {
                        //getFixedCriteriaForCarContext(item, contextCarRequest);
                        let carContextCriteriaCheck, carCtxtWithFixedCriteriaCheck;
                            if (item && item.CarContext != null) {
                                vm.carCriteria = {
                                    battery: item.CarContext.battery != null ? item.CarContext.battery.split('/').includes(contextCarRequest.fixedCriterias["968"]) : true,
                                    batteryIndex: item.CarContext.batteryIndex != null ? item.CarContext.batteryIndex.split('/').includes(contextCarRequest.fixedCriterias["966"]) : true,
                                    engine: item.CarContext.engine != null ? item.CarContext.engine.split('/').includes(contextCarRequest.fixedCriterias["999"]) : true,
                                    engineIndex: item.CarContext.engineIndex != null ? item.CarContext.engineIndex.split('/').includes(contextCarRequest.fixedCriterias["998"]) : true,
                                    gearbox: item.CarContext.gearbox != null ? item.CarContext.gearbox.split('/').includes(contextCarRequest.fixedCriterias["997"]) : true,
                                    gearboxIndex: item.CarContext.gearboxIndex != null ? item.CarContext.gearboxIndex.split('/').includes(contextCarRequest.fixedCriterias["996"]) : true
                                };
                                carContextCriteriaCheck = (!item.CarContext.battery && !item.CarContext.batteryIndex && !item.CarContext.engine && !item.CarContext.engineIndex && !item.CarContext.gearbox && !item.CarContext.gearboxIndex);
                            }                        
                            carCtxtWithFixedCriteriaCheck = vm.carCriteria && vm.carCriteria.battery && vm.carCriteria.batteryIndex && vm.carCriteria.engine && vm.carCriteria.engineIndex && vm.carCriteria.gearbox && vm.carCriteria.gearboxIndex;
                        var mcsDtcCriteriaCheck = item && item[vm.systemInfo] != null && (!item[vm.systemInfo][vm.symptoms] && !item[vm.systemInfo][vm.dtcCodes]);
                        if (item && item[vm.article] != null && (!item[vm.article].projectCode && mcsDtcCriteriaCheck && carContextCriteriaCheck)) {
                            vm.masterArticles.push(item);
                            if(!vm.languageList.includes(vm.lang[item[vm.article].language])){
                                vm.languageList.push(vm.lang[item[vm.article].language]);
                            }
                        }
                        else if (item && item[vm.article] != null && (!item[vm.article].projectCode && (MCS || DTC) && carCtxtWithFixedCriteriaCheck)){
                            vm.masterArticles.push(item);
                            if(!vm.languageList.includes(vm.lang[item[vm.article].language])){
                                vm.languageList.push(vm.lang[item[vm.article].language]);
                            }
                        }
                        else if (item && item[vm.article] != null && (item[vm.article].projectCode ? item[vm.article].projectCode.includes(contextCarRequest.families.familyVehicle[0]) && mcsDtcCriteriaCheck && carContextCriteriaCheck: false)){
                            vm.masterArticles.push(item);
                            if(!vm.languageList.includes(vm.lang[item[vm.article].language])){
                                vm.languageList.push(vm.lang[item[vm.article].language]);
                            }
                        }
                        else if(item && item[vm.article] != null && (item[vm.article].projectCode ? item[vm.article].projectCode.includes(contextCarRequest.families.familyVehicle[0]) && (MCS || DTC) && carCtxtWithFixedCriteriaCheck : false)) {
                            vm.masterArticles.push(item);
                            if(!vm.languageList.includes(vm.lang[item[vm.article].language])){
                                vm.languageList.push(vm.lang[item[vm.article].language]);
                            }
                        }
                    });
                }
                if(vm.newArticlesEnabled){
                     _.map(responseResult, function(list){
                                vm.masterArticles.push(list);
                                  if(!vm.languageList.includes(vm.lang[list[vm.article].language])){
                                vm.languageList.push(vm.lang[list[vm.article].language]);
                            }
                            
                    });      
                }
                vm.masterArticles = _.uniq(vm.masterArticles);
                vm.languageList = _.uniq(vm.languageList);
                vm.masterArticles.forEach(function (item) {
                    _.extend(item, {
                        expend: false, country: vm.lang[item[vm.article].language]
                    });
                });
                angular.copy(vm.masterArticles, vm.listArticles);
                if (!isAppend) {
                    vm.currentPage = 1;
                }
                $rootScope.$broadcast('articleDocumentsDisplay',vm.masterArticles.length);
            }
        }

        function getLoadedPages() {
            return Math.ceil(vm.listArticles.length / vm.itemsPerPage) || 1;
        }

        function getTotalPages() {
            return Math.ceil((vm.listArticles.length + vm.remainingDocuments) / vm.itemsPerPage) || 1;
        }

        function hasNextPage() {
            return vm.currentPage < getLoadedPages() || vm.remainingDocuments > 0;
        }

        function previousPage() {
            if (vm.currentPage > 1) {
                vm.currentPage--;
            }
        }

        function nextPage() {
            if (vm.currentPage < getLoadedPages()) {
                vm.currentPage++;
            } else if (vm.remainingDocuments > 0 && vm.nextUrl) {
                loadNextPage();
            }
        }

        function loadNextPage() {
            blockUI.start();
            ArticlesDocumentsService.getNewArticlesListByUrl(vm.nextUrl, newArticlesContext.payload).then(function (response) {
                try {
                    vm.remainingDocuments = response.remainingDocuments || 0;
                    vm.nextUrl = response.next_url || null;
                    processArticlesList(response.articles, newArticlesContext.code, newArticlesContext.contextSearchedSymptom, true);
                    if (vm.currentPage < getLoadedPages()) {
                        vm.currentPage++;
                    }
                } catch (error) {
                    toastr.error(error);
                } finally {
                    blockUI.stop();
                }
            }, function (error){
                toastr.error(error);
                blockUI.stop();
            })
        }
        function getArticleDetail(articleNo, articleId, article) {
            var userProfil = CacheService.getUserProfile();
            var dealerId = userProfil.dealerId;
            article.expend = !article.expend;
            const payloadVal = {
                "carContext": contextCarRequest,
                "userContext": userContextData,
                "dtcCodes": [],
                "articleNumbers": [articleNo],
                "symptomCodes": []
            }
            if (article.expend && !vm.newArticlesEnabled) {
                ArticlesDocumentsService.getArticleDetail(dealerId, articleNo, articleId, payloadVal, vm.newArticlesEnabled).then(function (response) {
                    var resp = response.result;
                    getArticlesDetailsCommon(resp, article);
                }).catch(function (error){
                    toastr.error(error);
                })
            } else if(article.expend && vm.newArticlesEnabled) {
                const matchedArticle = _.find(vm.listArticles, function (item) {
                    return item[vm.article] && item[vm.article].articleNumber === articleNo;
                });
                if (matchedArticle) {
                    getArticlesDetailsCommon([matchedArticle], matchedArticle);
                }
            }
        }

        function getArticlesDetailsCommon(article, targetArticle){
            const articleData = article[0];
            const displayArticle = targetArticle || articleData;
            
            _.extend(article, {
                [vm.solution]: articleData[vm.solution],
                [vm.attachments]: articleData[vm.attachments],
            }) 
            if (article[vm.systemInfo] && article[vm.systemInfo].description) {
                const filteredDescription = filterStylesByBackgroundColor(article[vm.systemInfo].description);
                article[vm.systemInfo].description = $sce.trustAsHtml(filteredDescription);
            }
            if (article[vm.solution] && article[vm.solution].solution) {
                const filteredSolution = filterStylesByBackgroundColor(article[vm.solution].solution);
                const trustedHtml = $sce.trustAsHtml(filteredSolution);
                articleData.solutionHtml = trustedHtml;
                displayArticle.solutionHtml = trustedHtml;
            }
            if (article[vm.attachments] && article[vm.attachments][vm.attachmentUrl]) {
                let attachmentValue = article[vm.attachments][vm.attachmentUrl];
                if (Array.isArray(attachmentValue)) {
                    attachmentValue = attachmentValue.filter(function(val) {
                        return val && typeof val === 'string' && val.trim() !== '';
                    }).join('<br>');
                }
                
                if (attachmentValue && typeof attachmentValue === 'string' && attachmentValue.trim() !== '') {
                    const filteredAttachments = filterStylesByBackgroundColor(attachmentValue);
                    if (filteredAttachments && typeof filteredAttachments === 'string') {
                        const trustedHtml = $sce.trustAsHtml(filteredAttachments);
                        articleData.attachmentHtml = trustedHtml;
                        displayArticle.attachmentHtml = trustedHtml;
                        
                    } else {
                        articleData.attachmentHtml = '';
                        displayArticle.attachmentHtml = '';
                    }
                } else {
                    articleData.attachmentHtml = '';
                    displayArticle.attachmentHtml = '';
                }
            } else {
                articleData.attachmentHtml = '';
                displayArticle.attachmentHtml = '';
            }
        }

        function changeLanguage(selectedLang) {
           
            vm.selectedLang = selectedLang;
            vm.listArticles = [];
            var langList = [];

            if (selectedLang != "") {
                vm.listArticles = _.filter(vm.masterArticles, function (item) {
                    selectedLang.forEach( function (lang){
                        if (item.country == lang) {
                            langList.push(item);
                        }

                    })                    
                })
                vm.listArticles = langList;
            }
            else {
                angular.copy(vm.masterArticles, vm.listArticles);
            }
            vm.currentPage = 1;

        }
    }
})();

(function () {
    angular.module('phenix').service('ArticlesDocumentsService',
        function (ArticlesDocumentsWSService) {
            this.getArticlesList = getArticlesList;
            this.getNewArticlesList = getNewArticlesList;
            this.getNewArticlesListByUrl = getNewArticlesListByUrl;
            this.getArticleDetail = getArticleDetail;
            
            function getArticlesList(dealerId) {
                return ArticlesDocumentsWSService.getArticlesList(dealerId);
            }
            function getNewArticlesList(payload, itemsPerPage) {
                return ArticlesDocumentsWSService.getNewArticlesList(payload, itemsPerPage);
            }
            function getNewArticlesListByUrl(nextUrl, payload) {
                return ArticlesDocumentsWSService.getNewArticlesListByUrl(nextUrl, payload);
            }
            function getArticleDetail(dealerId, articleNo, articleId, payload, newArticlesEnabled) {
                if (newArticlesEnabled) {
                    return ArticlesDocumentsWSService.getNewArticlesList(payload);
                } else {
                    return ArticlesDocumentsWSService.getArticleDetail(dealerId, articleNo, articleId);
                }
            }
        }
    )
})();

angular.module('phenix').constant('ArticleDocumentsConstants', {

    languageList :
        {
            "en_US": "english",
            "en_GB": "english",
            "en-US": "english",
            "en-GB": "english",
            "fr": "français",
            "fr_CH": "français",
            "fr-CH": "français",
            "de": "deutsch",
            "de_CH": "deutsch",
            "de-CH": "deutsch",
            "it": "italiano",
            "it_CH": "italiano",
            "it-CH": "italiano",
            "es": "español",
            "es_MX": "español",
            "es-MX": "español",
            "hr":"hrvatski",
            "cs":"čeština",
            "da":"dansk",
            "nl_NL":"nederlands",
            "nl-NL":"nederlands",
            "hu":"magyar",
            "pl":"polski",
            "pt_PT":"português",
            "pt-PT":"português",
            "ro":"română",
            "ru":"pусский",
            "sh":"cрпски",
            "sk":"slovensky",	
            "sl":"slovenščina",
            "sv":"svenska",
            "tr":"türkçe",
            "uk":"yкраїнська-мова"
            
        }     
});
/**
 * TmDocuments Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('TmListDocumentCtrl', TmListDocumentCtrl);

    /**
     * @namespace TmListDocumentCtrl
     * @desc Display sie tab (TM List)
     * @memberOf Controllers
     */


    /* @ngInject */
    function TmListDocumentCtrl($rootScope,
        DocumentsMetierService,
        $state,
        toastr,
        $window,
        RoutesConstants,
        $translate,
        CacheService,
        CacheConstants,
        blockUI,
        $q,
        $timeout,
        $scope,
        mrDocumentsMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.searchedTMList = [];
        vm.recapCarAPI = null;
        vm.tmListSearchText ;
        vm.tmListResponse;
        vm.foundDocuments;
        vm.notFoundDocuments;
        vm.loading;
        vm.tempArr;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        vm.goToHome = goToHome;
        this.$onInit = function () {

            vm.foundDocuments = 0;
            vm.notFoundDocuments = 0;
            if($state.params.searchText){
                vm.tmListSearchText = $state.params.searchText;
                vm.tempArr = $state.params.searchText.split(',');
            }else{
                vm.tmListSearchText = CacheService.getNodeSearchTmList();
                vm.tempArr = CacheService.getNodeSearchTmList().split(',');
            }
            vm.tempArr.map(function (val) {
                vm.searchedTMList.push({ 'tmCode': val })
            });
            vm.searchedTMList.forEach(function (item) {
                item.isTmDoc = false;
            })
            DocumentsMetierService.returnTmDocumentsByOpeCode(vm.tempArr).then(function (response) {
                vm.tmListResponse = response;
                $state.go(RoutesConstants.listePieceTMContent, { searchList: vm.tempArr, tmListData: response });
                vm.searchedTMList.forEach(function (item2) {
                    vm.tmListResponse.TM.forEach(function (item) {
                        if (item2.tmCode == item.id) {
                            return item2.isTmDoc = true;
                        }
                    })
                });
                vm.searchedTMList.forEach(function (item) {
                    if (!item.isTmDoc) {
                        vm.notFoundDocuments++;
                    } else {
                        vm.foundDocuments++;
                    }
                })
            })
            
            
        }
        function goToHome() {
            CacheService.cleanNodeSearchTmList();
            $state.go(RoutesConstants.carSearchResult, { docTypeSelected: vm.tmListSearchText });
        }
    }
})();

/**
 * @desc display modal containing link(s) to sie documents
 * @param {Json} listSie sie list to display in modal
 * @param {Event} onClickedLink event fired when clicked on sie element
 * @param {String} sieTitle modal's title
 * @example <dialog-documentation-sie list-sie="vm.listMR" on-clicked-link="vm.onClickedLink" sie-title="vm.popinTitle"></dialog-documentation-sie>
 */
(function () {
    'use strict';

    angular.module('phenix')
    .directive('dialogDocumentationSie', dialogDocumentationSie);

    /** @ngInject */
    function dialogDocumentationSie() {

        var directive = {
            restrict: 'E',
            scope: {
                listSie: '=',
                onClickedLink: '=',
                sieTitle: '='
            },
            templateUrl: 'app/components/products/directives/dialog-documentation-sie/dialog-documentation-sie.template.html',
            controllerAs: 'vm',
            controller: controller,
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function controller($mdDialog,configConstantes) {
            var vm = this;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

            vm.closeDialog = closeDialog;
            vm.selectedSie = selectedSie;
            vm.externalMRIconClick = externalMRIconClick;

            /* Action performed when user clicked on sie link from modal */
            function selectedSie(id) {
                id.residual = null;
                id = [id];
                vm.onClickedLink(id);
                $mdDialog.hide();
            }

            function externalMRIconClick($event,id,newTab){
                $event.stopPropagation(); 
                id.residual = null;
                id = [id];
                vm.onClickedLink(id,'',newTab);
                var childMrElement = document.querySelector("#childMr");
                if (childMrElement) {
                    childMrElement.remove();
                }
                $mdDialog.hide();
            }

            /* Action performed when user close modal */
            function closeDialog() {
                // Clean up childMr elements when dialog closes
                var childMrElement = document.querySelector("#childMr");
                if (childMrElement) {
                    childMrElement.remove();
                }
                $mdDialog.hide();
            }
        }


    }

})();

(function () {
  'use strict';

  angular.module('phenix').config(routerConfig);

  /** ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
      $stateProvider.state(RoutesConstants.validatedPartRequisition, {
          url: '/validatedPartRequisition/:id',
          templateUrl: 'app/components/partRequisition/shoppingCart/validate/validatedPartRequisition.html',
          controller: 'ValidPartRequisitionCtrl',
          controllerAs: 'vm',
          params: {
            data: null,
          //  customer: null,
            carContext: null,
            isBackButtonExist: false,
            partsRequisitionOptions: null
          }
      });
  }

})();


(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("ValidPartRequisitionCtrl", ValidPartRequisitionCtrl);

    /** @ngInject */
    function ValidPartRequisitionCtrl(
        $state,
        $window,
        // $scope,
        CacheService,
        UtilsMetierService,
        CacheConstants,
        RoutesConstants,
        CarSearchMetierService,
        printPdfModalService,
        PartRequisitionMetierService,
        $translate,
        SuperCartMetierService,
        DmsMetierService,
        $rootScope,
        $q,
        toastr,
        blockUI,
        globalConstant,
        FileSaver,$log
    ) {
        var vm = this;
        vm.onEditPartRequisitionMode = onEditPartRequisitionMode;
        vm.sortBy = sortBy;
        vm.backToPrevious = backToPrevious;
        vm.onCustomerFilledCallback = onCustomerFilledCallback;
        vm.closePartsRequisition = closePartsRequisition;
        vm.printPartRequisition = printPartRequisition;
        // $scope.getCurrencyForItem = getCurrencyForItem;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.constant = CacheConstants;
        var countryExceptionArray = globalConstant.countryCurrencyException;

        $rootScope.$on('bannerDataLoaded', function () {
            vm.bannerData = CarSearchMetierService.getBannerDetails();
        });
        /**
         * @name init
         * @desc instantiate when a new part Req is selected from dropdown in mainController
         */
        this.$onInit = function() {

            vm.networkProfile = CacheService.getNetworkProfile();

            if ($state.params.data) {
                vm.partsRequisition = $state.params.data.partRequisition;
                vm.currentCustomer = $state.params.data.customer;
                vm.vehicle = $state.params.data.carContext;
                vm.partsRequisition.validatorInfos = getPartRequisitionValidatorInfos(
                    vm.partsRequisition
                );
                angular.forEach(vm.partsRequisition.items, function(value) {
                    value.orderTypeToDisplay = setRealValueOfOrderType(value);
                });
            }

            else {
                $state.redirectedFrom = $rootScope.previousState;



                blockUI.start();

                PartRequisitionMetierService.findPartRequisitionLogic($state.params.id).then(function (res) {

                    //parser res.items pour modifier la valeur de price par la basis
                    // res.items.map(function(item){
                    //     item.price = item.basis;
                    //     return item;
                    // })
                    
                    //get vehicle informations
                    if (res.vin || res.brand) {
                        vm.vehicle = {
                            vin: res.vin,
                            registrationNumber: res.registrationNumber,
                            engineDesignation: res.engineDesignation,
                            gearBoxType: res.gearboxType,
                            model: res.vehicleDesignation,
                        }
                    }
                    vm.bannerData = CarSearchMetierService.getBannerDetails();
                    vm.partsRequisition = res;
                    vm.partsRequisition.validatorInfos = getPartRequisitionValidatorInfos(
                        vm.partsRequisition
                    );
                    angular.forEach(vm.partsRequisition.items, function(value) {
                        value.orderTypeToDisplay = setRealValueOfOrderType(value);
                    });



                    if ($state.params.customer) {
                        // when we are comming from quote controller
                        return $q.resolve($state.params.customer);
                    } else if (res.accountNumber) {
                        // when we are comming from
                        return DmsMetierService.getUserByAccount({
                            accountNumber: res.accountNumber
                        }).then(function (userAccountResponse) {
                            var error = userAccountResponse.returnCode;
                            if (error) {
                                return $q.reject('error');
                            }
                            return userAccountResponse.response.customer;
                        });
                    }

                    return $q.resolve();
                }).then(function (customer) {
                    if (customer) {
                        vm.currentCustomer = customer;
                    }
                }).catch(function(err) {
                    if(!err.status){
                         toastr.error($translate.instant('ERROR'));
                    }
                }).finally(function () {
                    vm.isLoading= true;
                    blockUI.stop();
                });
            }

            vm.isBackButtonExist = $state.params.isBackButtonExist;

            // if (!$state.params.id) {
            //     toastr.error($translate.instant('ERROR'));
            //     return ;
            // }

            //
        };


        /**
         *  @desc Will call the business service layer (metier.service.js) in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  @param  vm.quote : list of TM and PR entries that we want to display in the pdf
         *  @param  vm.vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         *  response {
         *      data : blob type for the pdf file
         *  }
         */
        function printPartRequisition(isDownload) {
            blockUI.start();

            var type = globalConstant.partRequisition;
            var status = globalConstant.validated;

            var partRequisitionToPrint = PartRequisitionMetierService.buildClientForPrintPayload(vm.partsRequisition, vm.currentCustomer);
            partRequisitionToPrint.items = PartRequisitionMetierService.formatItemsForPrintPayload(vm.partsRequisition.items);

            var isKnownByDms = _.find(partRequisitionToPrint.items, function(item) {
                return item.dmsInformations;
            })
            if (isKnownByDms) {
                var currency = UtilsMetierService.getCurrencyForItem(isKnownByDms);
            } else {
                var currency =  UtilsMetierService.getCurrencyForItem();
            }
            PartRequisitionMetierService.addTranslatedOrderTypeToItems(partRequisitionToPrint.items);
            if (currency) {
                partRequisitionToPrint.currency = currency;
                partRequisitionToPrint.items.forEach(function (item) {
                    if (item.price != 0) {
                        item.currency = partRequisitionToPrint.currency;
                    } else if (item.price == 0) {
                        item.currency = "-";
                    }
                });
            }

            SuperCartMetierService.downloadPdf(partRequisitionToPrint, partRequisitionToPrint.items, vm.vehicle, type, status).then(function (response) {
                pdfMake.tableLayouts = {
                    descTableLayout:{
                        hLineWidth: function () {
                            return 0.1;
                        },
                        vLineWidth: function () {
                            return 0.1;
                        },
                        hLineColor: function () {
                            return 'gray';
                        },
                        vLineColor: function () {
                            return 'gray';
                        },
                    },
                        secondTableLayout:{
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 3 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                            }
                    },
                    thirdTableLayout:{
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 2 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                        }
                    },
                    otherTableLayout:{
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    }
                
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                var file = new Blob([(buffer)], { type: 'application/pdf' });

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;
                if (isDownload){
                    FileSaver.saveAs(file, $translate.instant("COMMON_PARTLIST_PRINT_BUTTON") + "-" + partRequisitionToPrint.number + ".pdf");
                }else{
                    if (isIE || isEdge) {
                        FileSaver.saveAs(file, $translate.instant("COMMON_PARTLIST_PRINT_BUTTON") + "-" + partRequisitionToPrint.number + ".pdf");
                    } else {
                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }
                            return printPdfModalService.showModal(modalParams).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });
                        }).catch(function (err) {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
                }
            });

            }).catch(function (err) {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }



        function setRealValueOfOrderType(value) {
            var correctValueToDisplay;
            switch (value.orderType) {
                case 0:
                    correctValueToDisplay = "-";
                    break;
                case 1:
                    correctValueToDisplay = "0";
                    break;
                case 2:
                    correctValueToDisplay = "1";
                    break;
                case 3:
                    correctValueToDisplay = "2";
                    break;
                case 4:
                    correctValueToDisplay = "3";
                    break;
                default:
                    correctValueToDisplay = "-";
                    break;
            }
            return correctValueToDisplay;
        }

        function onCustomerFilledCallback(value) {
            vm.isCustomerFilled = value;
        }

        /**
         * @name getCurrencyForItem
         * @desc get curency to diaplay
         */
        function getCurrencyForItem(piece) {
            var country = vm.currentCustomer.countryCode;
            var countryExceptionArray = globalConstant.countryCurrencyException;
            if ((countryExceptionArray.indexOf(country) != -1)) {
                return "";
            } else {

            return CacheService.getObject(CacheConstants.currency)
            }
        }

        /**
         * @namespace onEditPartRequisitionMode
         * @desc set variables for the edit mode
         */
        function onEditPartRequisitionMode() {
            vm.isSearchCustomerMode = false;
        }

        /**
         * @name closePartsRequisition
         * @desc close current parts requisition
         */
        function closePartsRequisition(){
            var carContext = CacheService.getCarContext();
            //if we have context car, redirect to arbo page
            //redirect to home page else if Renault car
            if(carContext !== null && carContext.bvmExtraFields) {
                $state.go(RoutesConstants.carSearchResult);
            }
            // test if the vehicle is unknown BVM & DMS and redirect to the the correct arbo
            else if (carContext) {
                $state.go(RoutesConstants.carSearchResultNoCarContext);
            }
            else {
                $state.go(RoutesConstants.carSearch);
            }
        }

        function backToPrevious() {
            //back to partsRequisitionListDraft page if we come from quoteListDraft with options list (filters, sort, pagination)
            //back to previous page else
            if(!$state.params.partsRequisitionOptions){
                $window.history.back();
            }
            else{
                $state.go(RoutesConstants.partRequisitionListValidated, {
                    partsRequisitionOptions: $state.params.partsRequisitionOptions
                });
            }
        }

        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

           /**
         *      @desc   Restore client information if we have it
         *              1) From cache (stored when customer information is updated)
         *              2) From accountNumber (partRequisition)
         */



        function getPartRequisitionValidatorInfos(partRequisitionInformations) {
            var partRequisitionValidatorInfos =
                partRequisitionInformations.validatorIPN;
            if (
                partRequisitionInformations.dmsLoginInformations &&
                partRequisitionInformations.dmsLoginInformations.username != ""
            ) {
                partRequisitionValidatorInfos =
                    partRequisitionValidatorInfos +
                    " / " +
                    partRequisitionInformations.dmsLoginInformations.username;
            }
            return partRequisitionValidatorInfos;
        }
    }
})();

(function () {
    angular.module('phenix').service('TypeOrderTools', function ($mdDialog) {
        this.checkDMSStock = checkDMSStock;
        this.displayOrderTypeModal = displayOrderTypeModal;
        this.getPartsNotEnoughtStock = getPartsNotEnoughtStock;

        function checkDMSStock(partsList, quantity) {
            return partsList.some(function (part, index) {
                var partQuantity = quantity;
                // the first is a mainReference
                if (index > 1) {
                    partQuantity = parseInt(part.ratio ? part.ratio : 1) * quantity;
                }
                var inStock = checkQuantity(part.dmsInformations, partQuantity);
                return !inStock;
            });
        }

        function getPartsNotEnoughtStock(partsList, quantity) {
            return partsList.filter(function (part, index) {
                var partQuantity = quantity;
                // the first is a mainReference
                if (index > 1) {
                    partQuantity = parseInt(part.ratio) * quantity;
                }
                var inStock = checkQuantity(part.dmsInformations, partQuantity);
                return !inStock;
            });

        }

        function checkQuantity(DMSData, wantedQuantity) {
            if (!DMSData || !DMSData.quantity) {
                return false;
            }

            if (typeof DMSData.quantity === 'string') {
                return false;
            }

            if (DMSData.quantity < wantedQuantity) {
                return false;
            }

            return true;
        }

        function displayOrderTypeModal(isSelectionOutOfStock) {
            return $mdDialog.show({
                templateUrl:
                    "app/components/partRequisition/shoppingCart/modal/modalOrderType.template.html",
                controller: "modalOrderType",
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: false,
                locals: {
                    isSelectionOutOfStock: isSelectionOutOfStock
                }
            })
        }

    });
})();

/**
 * ShoppingCartPartsRequisitionWSService
 * @namespace Services
 */
(function() {
    'use strict';

    angular
        .module('phenix')
        .service('ShoppingCartPartsRequisitionWSService', ShoppingCartPartsRequisitionWSService)

    /** @ngInject */
    function ShoppingCartPartsRequisitionWSService(RestUpgrade, ShoppingCartConstants) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.updateItem = updateItem;
        this.deleteItem = deleteItem;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace ShoppingCartPartsRequisitionWSService
         * @desc send car informations and items to update to the back service
         * @param requestBody containing car context informations, and items updated by the user
         * @example IN
         * {
            "vin": null,
            "imat": null,
            "brand": "APL03",
            "model": "X76",
            "modelType": "K76",
            "engine": "5EE",
            "gearbox": "RW0",
            "designation": null,
            "items": [
                {
                "reference": "7701471205",
                "quantity": 1,
                "price": null,
                "currency": null
                },
                {
                "reference": "7700870877",
                "quantity": 1,
                "price": null,
                "currency": null,
                "mainItem": "7701471205"
                },
                {
                "reference": "7703602272",
                "quantity": 2,
                "price": 1.1,
                "currency": "EUR",
                "mainItem": "7701471205"
                },
                {
                "reference": "7701041348",
                "quantity": 1,
                "price": 23.35,
                "currency": "EUR",
                "mainItem": "7701471205"
                }
            ],
            "id": "7aca3b22-a33a-4679-bd1d-914c13b82be9"
            }
         * @memberOf Services.ShoppingCartPartsRequisitionWSService
         */
        function updateItem(requestBody) {
            return RestUpgrade.all(ShoppingCartConstants.updateItem).post(requestBody);
        }

        function deleteItem(cartID, referenceID) {
            return RestUpgrade.one('/partsRequisitions', cartID).one('/items', referenceID).remove();
        }
    }
})();

/**
 * ShoppingCartPartsService
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ShoppingCartPartsService', function (CacheService, BasketTools, $rootScope, ShoppingCartPartsRequisitionWSService,ShoppingCartConstants,
             PartRequisitionConstants, $translate, toastr, $q) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var _basketTools = BasketTools;
        var _actions = ShoppingCartConstants.actions;

        this.setShoppingCart = setShoppingCart;
        this.updateShoppingCart = updateShoppingCart;
        this.getShoppingCart = getShoppingCart;
        this.onUpdateUnusableSale = onUpdateUnusableSale;
        this.onUpdateAdditionalDiscount = onUpdateAdditionalDiscount;
        this.restorePartRequisition = restorePartRequisition;
        this.updateSplit = updateSplit;

        this.updateTypeOrder = updateTypeOrder;
        this.deleteItem = deleteItem;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace ShoppingCartPartsService
         * @desc Update shopping cart by passing action and payload
         * @param {string} action action to be performed on the selected item
         * @param {action} payload set of item with or without pps
         * @memberOf Services.ShoppingCartPartsService
         */

        function updateShoppingCart(action, payload) {
            switch (action) {

                case _actions.ADD_ONE:
                    _basketTools.onAddOneInQuantity(payload.piece, payload.type, payload.existingQuantity);
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                    break;
                case _actions.ADD_PIECE:
                    _basketTools.onAddQuantity(payload.piece, payload.type, payload.existingQuantity);
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                    break;
                case _actions.ADD_QUANTITY:
                    _basketTools.onAddQuantity(payload.piece, payload.type);
                    break;
                case _actions.ADD_SPECIFIC_QUANTITY:
                    _basketTools.addSpecificQuantity(payload.piece, payload.type);
                    break;
                case _actions.REDUCE_QUANTITY:
                    _basketTools.onReduceQuantity(payload.piece);
                    break;
                case _actions.REDUCE_ONE:
                    _basketTools.onReduceOneInQuantity(payload.piece);
                    break;
                case _actions.REPLACE_QUANTITY:
                    _basketTools.onInputQuantity(payload.piece, payload.quantity, payload.type);
                    break;
                case _actions.DELETE_PIECE:
                    _basketTools.deletePiece(payload.referenceId);
                    break;
            }
            return getShoppingCart();
        }

        /**
         * @namespace ShoppingCartPartsService
         * @desc Get shopping cart's items
         * @memberOf Services.ShoppingCartPartsService
         */
        function getShoppingCart() {
            return _basketTools.getShoppingCart();
        }
        /**
         * @desc Delete an item in cart
         * @param {id} string
         * @return {void}
         */

        function deletePieceFromCache(id) {
            var currentPartRequisition = CacheService.getObject(PartRequisitionConstants.bs);
            var index = _.findIndex(currentPartRequisition.items, function (piece) {
                return piece.id === id;
            });

            if (index !== _actions.NOTFOUND) {
                index === 0 ? currentPartRequisition.items.shift() : currentPartRequisition.items.splice(index, 1);
                updatePartsRequisitionInCache(currentPartRequisition);
            }
        }



        /**
         * @namespace updatePartsRequisitionInCache
         * @desc set shopping cart
         * @memberOf Services.ShoppingCartPartsService
         */
        function updatePartsRequisitionInCache(partReq){
            CacheService.setObject(PartRequisitionConstants.bs, partReq);
        }



        /**
         * @namespace ShoppingCartPartsService
         * @desc set shopping cart
         * @memberOf Services.ShoppingCartPartsService
         */
        function setShoppingCart(state) {
            _basketTools.replaceShoppingCart(state);
        }

         /**
         * @namespace ShoppingCartPartsService
         * @desc used when user update unusable sale
         * @memberOf Services.ShoppingCartPartsService
         */
        function onUpdateUnusableSale(piece){

            var bs = CacheService.getObject(PartRequisitionConstants.bs);
            var items = [];

            var currentItem = {
                reference: piece.reference,
                unusualSale: piece.unusualSale
            };

            items.push(currentItem);
            var requestBody = {
                "id": bs.id,
                "items": items
            }

            return updateItemsBs(requestBody);
        }



        /**
         * @namespace ShoppingCartPartsService
         * @desc used when user update additional discount
         * @memberOf Services.ShoppingCartPartsService
         */
        function onUpdateAdditionalDiscount(piece){
            var bs = CacheService.getObject(PartRequisitionConstants.bs);
            var items = [];

            var currentItem = {
                reference: piece.reference,
                additionalDiscount: piece.additionalDiscount
            };

            items.push(currentItem);
            var requestBody = {
                "id": bs.id,
                "items": items
            }

            return updateItemsBs(requestBody);
        }

        function updateTypeOrder(partsList, orderType) {
            var _shoppingCart = _basketTools.getShoppingCart();
            var parts = _.intersectionWith(_shoppingCart, partsList, function(cart, part) {
                return cart.reference === part.reference;
            });
            parts.forEach(function(part) {
                part.orderType = orderType;
            });
            _basketTools.replaceShoppingCart(_shoppingCart);
        }


        function updateSplit(partsList, split) {
            var _shoppingCart = _basketTools.getShoppingCart();
            var parts = _.intersectionWith(_shoppingCart, partsList, function(cart, part) {
                return cart.reference === part.reference;
            });
            parts.forEach(function(part) {
                part.interventionId = split.splitId;
                part.interventionLabel = split.splitLabel;
            });
            _basketTools.replaceShoppingCart(_shoppingCart);
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * This function is used to send request to nd-services
         * and display toastrs success for adding to part list, updating to part list and deleted to partlist
         * or display toastr error while manage part list item
         */
        function updateItemsBs(requestBody){
            //var isDeleted = isItemsDeleted(requestBody.items);
            return ShoppingCartPartsRequisitionWSService.updateItem(requestBody).catch(function () {
                toastr.error($translate.instant('TOASTER_ERROR_ADD_TO_PARTLIST'), {timeout: ShoppingCartConstants.timeoutToastr});
                return $q.reject("Error");
            });

        }

        /**
         *  @desc Restore partRequisition data on cache/app
         *  @param {Object} partRequisition
         */
        function restorePartRequisition(partRequisition) {
            CacheService.setObject(PartRequisitionConstants.bs, partRequisition);
            // reset data from partRequisition
            CacheService.savePartRequisitionCustomer(null);
            setShoppingCart(partRequisition.items || []);
            $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
        }

         /**
         *  @desc Call ws service to remove from postgre the selected item
         *  @param {string} partsRequisitionId  id of the current part requisition
         *  @param {string} itemId   id of the selected item
         *  @memberOf Services.ShoppingCartPartsService
         */
        function deleteItem(partsRequisitionId, itemId){
            return ShoppingCartPartsRequisitionWSService.deleteItem(partsRequisitionId, itemId)
                .then(function(result){
                    deletePieceFromCache(itemId);
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionUpdatedEvent);
                    return result;
                });
        }

    })
})();

/**
 * modalOnCloseFicController
 * @namespace Controller
 */
(function () {
    angular.module("phenix").controller("modalOrderType", modalOrderType);

    function modalOrderType($mdDialog, $window, $translate) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.ordersType = [];
        vm.selectedOrderType = {};
        vm.isOrderTypeSelected = false;

        vm.onCancel = onCancel;
        vm.onValidate = onValidate;
        vm.onSelectOrderType = onSelectOrderType;

        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {
            vm.ordersType = [
                { id: 1, name: $translate.instant('PARTLIST_MODAL_TYPEORDER_PVI') },
                { id: 2, name: $translate.instant('PARTLIST_MODAL_TYPEORDER_Urgence1') },
                { id: 3, name: $translate.instant('PARTLIST_MODAL_TYPEORDER_Urgence2') },
                { id: 4, name: $translate.instant('PARTLIST_MODAL_TYPEORDER_MISSSELL') }
            ];

            // if selected product is out of stock, put default placeholder of dropdown list to "1 - Urgent", activate validate button and put the value in the array sent to PR
            if(vm.isSelectionOutOfStock){
                var tmpType = _.find(vm.ordersType, ["name", $translate.instant('PARTLIST_MODAL_TYPEORDER_Urgence1')]);
                vm.defaultPlaceholder = tmpType.name;
                vm.selectedOrderType = tmpType;
                onSelectOrderType();
            }
        }

        /**
         * @name onSelectOrderType
         * @desc on select order type
         */
        function onSelectOrderType() {
            vm.isOrderTypeSelected = true;
        }

        /**
         * @name onValidate
         * @desc on click on validate
         */
        function onValidate() {
            $mdDialog.hide(vm.selectedOrderType.id);
        }

        /**
         * @name onCancel
         * @desc on click on cancel
         */
        function onCancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("partRequisitionListDraftController", partRequisitionListDraftController);

    /* @ngInject */
    function partRequisitionListDraftController(
        $state,
        $translate,
        $q,
        $rootScope,

        blockUI,
        toastr,

        CarSearchConstants,
        RoutesConstants,
        PartRequisitionConstants,
        CacheConstants,
        globalConstant,

        CacheService,
        DmsMetierService,
        filterListService,
        PartRequisitionMetierService,
        CarSearchMetierService, $log) {

        /*=============================================
        =                 INTERNAL STATE              =
        =============================================*/
        var networkProfil = CacheService.getNetworkProfile();
        var _options = {
            filter: {
                status: PartRequisitionConstants.draftStatus,
                type: networkProfil
            },
            sort: {
                by: 'DATE',
                order: PartRequisitionConstants.sort.desc
            },
            pagination: {
                limit: PartRequisitionConstants.pagination.limit,
                offset: 1
            }
        };
        var _searchBy = PartRequisitionConstants.searchBy;

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var userProfile = CacheService.getUserProfile();

        var vm = this;
        vm.dataLoaded = false;
        vm.partRequisitionList = [];
        vm.filterValues = {};
        vm.currentPage = 1;
        vm.count = 0;
        vm.globalConstant = globalConstant;

        vm.onSelect = onSelect;
        vm.onSearch = onSearch;
        vm.onSort = onSort;
        vm.onUpdatePagination = onUpdatePagination;
        vm.onDelete = onDelete;
        vm.onUnlock = onUnlock;
        vm.onCheck = onCheck;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            //set _options to state.params.partsRequisitionOptions
            //and filterValues to init filter component
            if ($state.params.partsRequisitionOptions) {
                _options = $state.params.partsRequisitionOptions;
                vm.filterValues = _options.filter;
                vm.currentPage = _options.pagination && _options.pagination.offset ? _options.pagination.offset : vm.currentPage;
            }

            blockUI.start();
            getPartRequisitionList().finally(function () {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        };

        $rootScope.$on('resetPagination', function () {
            var pagination = {
                limit: PartRequisitionConstants.pagination.limit,
                offset: 1
            }
            _options.pagination = pagination;
        })


        /**
         * @name onSelect
         * @desc load context car if user is allowed to open selected part requisition
         * @param {Object} currentPartRequisition
         */
        function onSelect(currentPartRequisition) {
            var getCartMetadata;
            if (PartRequisitionMetierService.isUserAllowedToOpenPartRequisition(userProfile.ipn, currentPartRequisition.userLock)) {
                blockUI.start()
                switch (currentPartRequisition.searchBy) {

                    case _searchBy.vin:
                        getCartMetadata = CarSearchMetierService
                            .initSearchCar({ vin: currentPartRequisition.vin }, true).then(function(){
                                CarSearchMetierService.getBannerData();
                            }).catch(function(err){
                                if(err && err.status){
                                    return $q.reject("-2");
                                }else{
                                //reject -1 for vehicle unkown bvm
                                    return $q.reject("-1");
                                }
                            })
                        break;
                    case _searchBy.registrationNumber:
                        getCartMetadata = CarSearchMetierService.initSearchCar({ imat: currentPartRequisition.registrationNumber }, true).then(function(){
                            CarSearchMetierService.getBannerData();
                        }).catch(function(err){
                            if(err && err.status){
                                return $q.reject("-2");
                            }else{
                                //reject -1 for vehicle unkown bvm
                                toastr.error($translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE'));
                                return $q.reject("-1");
                            }
                        })
                        break;
                    case _searchBy.model:
                        getCartMetadata = CarSearchMetierService.searchCarModel(createModelPayload(currentPartRequisition)).then(function(){
                            CarSearchMetierService.getBannerData();
                        })
                        break;
                    default:
                        getCartMetadata = $q.resolve();
                        break;
                }

                getCartMetadata
                /* .then(function () {
                    if (currentPartRequisition.orderNumber) {
                        refreshSplitsFromSelectedOrderNumber(currentPartRequisition.orderNumber);
                    }
                }) */
                .then(function () {
                    CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, false);
                    //CacheService.setObject(PartRequisitionConstants.bs, currentPartRequisition);
                    return PartRequisitionMetierService.findAndSetPartRequisitionCustomer(currentPartRequisition)
                        .catch(function(err){
                            return $q.reject("-2");
                        }); //find and set part requisition customer in cache
                    
                }).then(function () {
                    CacheService.setObject(PartRequisitionConstants.bs, currentPartRequisition);
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                    $state.go(RoutesConstants.partRequisition, {
                        view: 'list',
                        partsRequisitionOptions: _options
                    });
                }).catch(function (error) {
                    if(error === "-1"){
                        var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                        var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);
                    
                        //manage case vehcile unkown bvm
                        if (dmsResponse) {
                            //set car context for unkown bvm vehcile
                            CarSearchMetierService.setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache);
                            CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);

                            //call find service to get parts requisition informations
                            $q.resolve()
                            /* .then(function(){
                                if (currentPartRequisition.orderNumber) {
                                    refreshSplitsFromSelectedOrderNumber(currentPartRequisition.orderNumber);
                                }
                            }) */
                            .then(function () {
                                CacheService.setObject(PartRequisitionConstants.bs, currentPartRequisition);
                                $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                                return PartRequisitionMetierService.findAndSetPartRequisitionCustomer(currentPartRequisition)
                                    .catch(function(){
                                        return $q.reject();
                                    });
                            }).then(function () {
                                //redirect user to parts requisition page
                                $state.go(RoutesConstants.partRequisition, {
                                    view: 'list',
                                    partsRequisitionOptions: _options
                                });
                            }).catch(function(){
                                $log.debug($translate.instant('ERROR'));
                            })
                        }

                        //manage case vehicle unkown bvm and dms
                        else {
                            var carNotBvmAndDms = {
                                "vin": currentPartRequisition.vin,
                                "imat": currentPartRequisition.registrationNumber
                            }
                             //set car context for unkown bvm and dms vehicle 
                             CarSearchMetierService.setCarContextVehicleNotKnownBvmAndDms(carNotBvmAndDms);
                             CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, false);
 
                             //call find service to get parts requisition informations
                             $q.resolve().then(function () {
                                 CacheService.setObject(PartRequisitionConstants.bs, currentPartRequisition);
                                 $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                                 return PartRequisitionMetierService.findAndSetPartRequisitionCustomer(currentPartRequisition)
                                    .catch(function(){
                                        return $q.reject();
                                    });
                             }).then(function () {
                                 //redirect user to parts requisition page
                                 $state.go(RoutesConstants.partRequisition, {
                                     view: 'list',
                                     partsRequisitionOptions: _options
                                 });
                             }).catch(function(){
                                $log.debug($translate.instant('ERROR'));
                             });
                        }
                    }
                    else if (error.errors && Array.isArray(error.errors)) {
                        error.errors.forEach(function (error) {
                            toastr.error(error.msg);
                        })
                    } else if(error !== '-2'){
                        toastr.error($translate.instant('ERROR'));
                    }
                })
                .finally(function () {
                    blockUI.stop();
                })
            }
            else {
                toastr.error($translate.instant('PART_REQUISITION_MSG_LOCK').replace('#1', currentPartRequisition.number).replace('#2', currentPartRequisition.userLock));
            }

        }

        /**
         *
         * @param {String} or is the order number
         * @desc Call order.v1 service and then refresh the split option in select from the response
         */
        function refreshSplitsFromSelectedOrderNumber(or) {
            DmsMetierService.getOrderByNumber(or)
                .then(function (response) {
                    var returnCode = response.returnCode;
                    //set response in cache wehn passed
                    if (response.response && returnCode === 0) {
                        return CacheService.setObject(CacheConstants.dmsResponse, response.response);
                    }
                    //clean splits lists when request is failed
                    else {
                        $rootScope.$emit('clean');
                        return CarSearchMetierService.handleErrorFromDmsOrder(returnCode);

                    }
                }).then(function () {
                    //get splits for the selected order number
                    CarSearchMetierService.refreshSplitOnChangeOrderNumber();
                    //$rootScope.$emit('reload');
                })
        }

        /**
         * @name onSearch
         * @desc get filtered parts requisitions list
         * @param {Object} filter
         */
        function onSearch(filter) {
            blockUI.start();

            // reset pagination
            _options.pagination = {
                limit: PartRequisitionConstants.pagination.limit,
                offset: 1
            }

            filter.status = PartRequisitionConstants.draftStatus;
            _options.filter = filter;

            getPartRequisitionList(filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            });
        }


        function onSort(header, order) {
            var sort = _options.sort;
            var pagination = _options.pagination;
            var filter = _options.filter;

            sort.by = header;
            if (order) {
                sort.order = order;
            }

            // reset pagination
            pagination.offset = 1;

            blockUI.start();
            getPartRequisitionList(filter, null, pagination).finally(function () {
                blockUI.stop();
            });

        }

        /**
         * @name onUpdatePagination
         * @desc get parts requisitions list for the selected page
         * @param {int} page
         */
        function onUpdatePagination(page) {

            blockUI.start();
            _options.pagination = {
                limit: _options.pagination.limit,
                offset: page
            }

            getPartRequisitionList(_options.filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @name onDelete
         * @desc delete parts requsitions
         * @param {Array} listIds
         */
        function onDelete(listIds) {
            blockUI.start();

            PartRequisitionMetierService
                .deletePartRequisitionLogic(listIds)
                .then(getPartRequisitionList)
                .finally(function () {
                    blockUI.stop();
                })
        }

        /**
        * @name onUnlock
        * @desc unloc parts requsitions
        * @param {Object} currentPartRequisition
        */
        function onUnlock(currentPartRequisition) {
            blockUI.start();
            PartRequisitionMetierService.unlockPartRequisitionLogic()
                .then(function () {
                    currentPartRequisition.lockedByUser = !currentPartRequisition.lockedByUser;
                })
                .then(function () {
                    PartRequisitionMetierService.closePartRequsitionLogic(currentPartRequisition.id);
                })
                .catch(function () {
                    toastr.error($translate.instant("ERROR"));
                })
                .finally(function () {
                    blockUI.stop();
                })
        }

        /**
        * @name onCheck
        * @desc check part requsition if user is allowed to open selected part requisition
        * @param {Object} currentPartRequisition
        */
        function onCheck(currentPartRequisition) {
            if (!PartRequisitionMetierService.isUserAllowedToOpenPartRequisition(userProfile.ipn, currentPartRequisition.userLock)) {
                currentPartRequisition.checked = false;
                toastr.error($translate.instant('PART_REQUISITION_MSG_LOCK').replace('#1', currentPartRequisition.number).replace('#2', currentPartRequisition.userLock));
            }
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/
        /**
         * @name getPartRequisitionList
         * @desc get part requisition list
         * @param {Object} filter
         * @param {Object} sort
         * @param {Number} pagination
         */
        function getPartRequisitionList(filter, sort, pagination) {

            //get options
            if (!filter) {
                filter = _options.filter;
            }
            if (!sort) {
                sort = _options.sort;
            }
            if (!pagination) {
                pagination = _options.pagination;
            }

            return PartRequisitionMetierService.partRequisitionListLogic(filter, sort, pagination)
                .then(function (response) {
                    vm.partRequisitionList = response.partsRequisitions;
                    vm.count = response.totalCount;
                }).catch(function () {
                    toastr.error($translate.instant("ERROR"));
                });
        }

        /**
         * @name createModelPayload
         * @desc Create payload for carSearchByModel request
         * @param {Oject} cart see getCartsList in CartViewListService
         * @return {Object} See below
         */
        function createModelPayload(cart) {
            return {
                fixedCriterias: {
                    '007': cart.familyVehicle,
                    '008': cart.bodyType,
                    '336': cart.brand,
                    '997': cart.gearboxType,
                    '999': cart.engineType
                }
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("partRequisitionListValidatedController", partRequisitionListValidatedController);

    /* @ngInject */
    function partRequisitionListValidatedController(
        $state,
        $translate,
        $q,
        $rootScope,

        blockUI,
        toastr,
        CacheConstants,
        RoutesConstants,
        PartRequisitionConstants,
        CarSearchConstants,
        filterListService,
        CacheService,
        CarSearchMetierService,
        globalConstant,
        DmsMetierService,
        PartRequisitionMetierService) {

        /*=============================================
        =                 INTERNAL STATE              =
        =============================================*/
        var networkProfil = CacheService.getNetworkProfile();
        var _options = {
            filter: {
                status: PartRequisitionConstants.validatedStatus,
                type: networkProfil
            },
            sort: {
                by: 'VALIDATED_DATE',
                order: PartRequisitionConstants.sort.desc
            },
            pagination: {
                limit: PartRequisitionConstants.pagination.limit,
                offset: 1
            }
        };

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.dataLoaded = false;
        vm.filterValues = {};
        vm.partRequisitionList = [];
        vm.count = 0;
        vm.currentPage = 1;

        vm.onSelect = onSelect;
        vm.onSearch = onSearch;
        vm.onSort = onSort;
        vm.onUpdatePagination = onUpdatePagination;
        vm.globalConstant = globalConstant;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            //set _options to state.params.partsRequisitionOptions
            //and filterValues to init filter component
            if ($state.params.partsRequisitionOptions) {
                _options = $state.params.partsRequisitionOptions;
                vm.filterValues = _options.filter;
                vm.currentPage = _options.pagination && _options.pagination.offset ? _options.pagination.offset : vm.currentPage;
            }

            initComponents();

            blockUI.start();

            getPartRequisitionList().finally(function () {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        };


        function onSelect(currentPartRequisition) {
            if (currentPartRequisition.vehicleDesignation !== 'ESA' || currentPartRequisition.vehicleDesignation === null) {
                vm.carInformations = {};

                var payload = {};
                payload.accountNumber = currentPartRequisition.accountNumber;

                blockUI.start();
                CarSearchMetierService.getCartContextFromSomeCart(currentPartRequisition)
                    .then(function (response) {
                        vm.carInformations = response;
                        return vm.carInformations;
                    })
                    .then(function () {
                        if (payload.accountNumber && payload.accountNumber != 0) {
                            return DmsMetierService.getUserByAccount(payload).then(function (userAccountResponse) {

                                var error = userAccountResponse.returnCode;
                                if (error) {
                                    return $q.reject('error');
                                }
                                return userAccountResponse.response.customer;
                            })
                        }
                    })
                    .then(function (customer) {
                        return PartRequisitionMetierService
                            .findPartRequisitionLogic(currentPartRequisition.id)
                            .then(function (partRequisition) {
                                return _.assign({}, {
                                    carContext: vm.carInformations,
                                    customer: customer,
                                    partRequisition: partRequisition
                                })
                            })
                    })
                    .then(function (data) {
                        $state.go(RoutesConstants.validatedPartRequisition,{
                            data: data,
                            isBackButtonExist: true,
                            partsRequisitionOptions:  _options
                        });
                    })
                    .catch(function (err) {

                        if(err.msg){
                            //reject -1 for vehicle unkown bvm
                            toastr.error($translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE'));

                            var carInfo = {
                                "vin": currentPartRequisition.vin,
                                "imat": currentPartRequisition.registrationNumber
                            }

                            if (payload.accountNumber && payload.accountNumber != 0) {
                                DmsMetierService.getUserByAccount(payload).then(function (userAccountResponse) {
    
                                    var error = userAccountResponse.returnCode;
                                    if (error) {
                                       return $q.reject('error');
                                    }
                                    var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                                    var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);
                                    if(dmsResponse){
                                        CarSearchMetierService.setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache);
                                        CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                                    }else{
                                        return $q.reject('error');
                                    }
                                    
                                   return userAccountResponse.response.customer;
                                }).then(function (customer) {
                                    return PartRequisitionMetierService
                                        .findPartRequisitionLogic(currentPartRequisition.id)
                                        .then(function (partRequisition) {
                                            return _.assign({}, {
                                                carContext: carInfo,
                                                customer: customer,
                                                partRequisition: partRequisition
                                            })
                                        })
                                })
                                .then(function (data) {
                                    $state.go(RoutesConstants.validatedPartRequisition,{
                                        data: data,
                                        isBackButtonExist: true,
                                        partsRequisitionOptions:  _options
                                    });
                                }).catch(function(err){
                                    if(err === 'error'){
                                        var carNotBvmAndDms = {
                                                    "vin": currentPartRequisition.vin,
                                                    "imat": currentPartRequisition.registrationNumber
                                                }
                                        CarSearchMetierService.setCarContextVehicleNotKnownBvmAndDms(carNotBvmAndDms);
                                        CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);
                                        $state.go(RoutesConstants.validatedPartRequisition,{
                                            validatorIPN: currentPartRequisition.validatorIPN,
                                            id: currentPartRequisition.id,
                                            isBackButtonExist: true,
                                        });
                                    }

                                })
                            }else{
                                toastr.error($translate.instant("PART_REQUISITION_CONSULT_ERROR"));
                            }

                        }else if(!err.status){
                            toastr.error($translate.instant("PART_REQUISITION_CONSULT_ERROR"));
                        }
                    })
                    .finally(function () {
                        blockUI.stop();
                    });
            }

            else {
                $state.go(RoutesConstants.validatedPartRequisition,{
                    validatorIPN: currentPartRequisition.validatorIPN,
                    id: currentPartRequisition.id,
                    isBackButtonExist: true,
                });
            }
        }

        /**
         * @name onSearch
         * @desc get filtered parts requisitions list
         * @param {Object} filter
         */

        function onSearch(filter) {
            blockUI.start();

            // reset pagination
            _options.pagination = {
                limit: PartRequisitionConstants.pagination.limit,
                offset: 1
            }
            filter.status = PartRequisitionConstants.validatedStatus;
            _options.filter = filter;

            getPartRequisitionList(filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @name onSort
         * @desc get sorted parts requisitions list
         * @param {string} by
         * @param {string} order
         */
        function onSort(by, order) {
            blockUI.start();

            _options.sort = {
                by: by,
                order: order
            }

            getPartRequisitionList(null, _options.sort).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @name onUpdatePagination
         * @desc get parts requisitions list for the selected page
         * @param {int} page
         */
        function onUpdatePagination(page) {
            blockUI.start();
            _options.pagination = {
                limit: _options.pagination.limit,
                offset: page
            }

            getPartRequisitionList(_options.filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            })
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name initComponents
         * @desc initialize the attribute fields of the filterList component
         * @desc headers and actions othe containerList component
         */
        function initComponents() {
            vm.filterFields = [
                { 'label': 'COMMON_NUMBER_ID', 'name': 'number', 'value': '', 'class': 'icon-icons_basket icon-position' },
                { 'label': 'COMMON_NUMCLIENT_LABEL', 'name': 'accountNumber', 'value': '', 'class': 'icon-icons_vehicle_search_panier icon-position' },
                { 'label': 'ADMIN_IPN', 'name': 'validatorIpn', 'value': '', 'class': 'icon-icons_people_search_basket icon-position' }
            ];

            vm.containerHeaders = [
                { 'label': 'COMMON_NUMBER_ID', 'class': 'small-3 columns inner_cell pointer', 'filter': 'ID' },
                { 'label': 'COMMON_NUMCLIENT_LABEL', 'class': 'small-4 columns inner_cell', 'filter': 'ACCOUNT_NUMBER' },
                { 'label': 'VALIDATION_DATE', 'class': 'small-3 columns inner_cell pointer', 'filter': 'DATE' }
            ];

            vm.containerActions = [];
        }

        /**
         * @name getPartRequisitionList
         * @desc get part requisition list
         * @param {Object} filter
         * @param {Object} sort
         * @param {Number} pagination
         */
        function getPartRequisitionList(filter, sort, pagination) {

            //get options
            if (!filter) {
                filter = _options.filter;
            }
            if (!sort) {
                sort = _options.sort;
            }
            if (!pagination) {
                pagination = _options.pagination;
            }

            //get list using options (filters, sort, pagination)
            return PartRequisitionMetierService.partRequisitionListLogic(filter, sort, pagination)
                .then(function (response) {
                    vm.partRequisitionList = response.partsRequisitions;
                    vm.count = response.totalCount;                    
                }).catch(function () {
                    toastr.error($translate.instant("ERROR"));
                });
        }

    }
})();

// (function () {
//
//   'use strict';
//
//   angular.module('phenix').config(routerConfig);
//   /** @ngInject */
//   function routerConfig($stateProvider, RoutesConstants) {
//     $stateProvider
//     // for nested views, you have to write a ste: 'stateParent.myState'
//       .state(RoutesConstants.favourites, {
//         url: '/favourites',
//         templateUrl: 'app/components/favourites/favourites.html',
//         controller: 'FavsController',
//         controllerAs: 'favsCtrl',
//         authenticate: true,
//         params: {
//           nav: null,
//           data:null
//         }
//       });
//
//   }
// })();

'use strict';

angular.module('phenix').constant('FavsConstant', {

  categories: 'favourites',
  categContent: 'favourites/detail',
  tmNotCodified: 'tmnotcodified',
  deleteTm: '/tmnotcodified/delete',
  refModalEdition: 'EDITION',
  refModalCreation: 'CREATION',
  USER_TYPE: 'USER',
  DEALER_TYPE: 'DEALER'

});

(function () {

    angular.module('phenix').controller('updateNoCodifiedTM', function ($mdDialog) {
        var vm = this;

        this.$onInit = function() {
            vm.viewPrice = !!vm.tm.price;
            vm.viewTime = !!vm.tm.time;
        }

        vm.onUpdate = function(form) {
            if (form.$valid) {
                $mdDialog.hide(vm.tm);
            } else {
                return;
            }
        }

        vm.onClose = function() {
            $mdDialog.cancel();
        }
    });

})();

// /**
//  * MenuFavouritesComponent
//  * @namespace Components
//  */
// (function () {
//         'use strict';
//
//         angular
//             .module('phenix')
//             .component('menuFavourites', {
//                 bindings: {
//                     isMenuActive : '<'
//                 },
//                 controller: MenuFavouritesComponent,
//                 controllerAs: 'vm',
//                               app/components/favourites/components/menu-favourites.template.html
//                 templateUrl: 'app/components/favourites/components/menu-favourites.template.html'
//             });
//
//
//         function MenuFavouritesComponent() {
//
//             var vm = this;
//
//
//
//         }
//     }
//
// )();



(function () {
    angular.module('phenix').controller('deleteNonCodifiedTMController', function ($mdDialog) {

        this.onDelete = function() {
            $mdDialog.hide();
        }

        this.onCancel = function() {
            $mdDialog.cancel();
        }
    });
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('consultNonCodifiedTMController', consultNonCodifiedTMController)

    /* @ngInject */
    function consultNonCodifiedTMController(
        CacheService,


        CacheConstants,


        $mdDialog
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.displayPrice = false;
        vm.displayTime = false;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.closeModal = closeModal;
        vm.onConfirm = onConfirm;

        this.$onInit = function () {
            vm.currency = CacheService.getObject(CacheConstants.currency);
            vm.displayPrice = !!vm.payload.price;
            vm.displayTime = !!vm.payload.time;
        };

        function onConfirm () {
            $mdDialog.hide(vm.payload);
        }

        /**
         * @name closeModal
         * @desc action fired when user click on close button
         */

        function closeModal() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('addNonCodifiedTMController', addNonCodifiedTMController)

    /* @ngInject */
    function addNonCodifiedTMController(
        $mdDialog,
        toastr,
        $translate,
        $scope,

        blockUI,

        CacheService,
        FavoitMetierService,

        CacheConstants
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.currency = CacheService.getObject(CacheConstants.currency);
        vm.form = {};
        vm.isSubmitted = false;

        var selectedCategory = {};
        var selectedSubCategory = {};

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.onChangeCategory = onChangeCategory;
        vm.onChangeSubcategory = onChangeSubcategory;
        vm.onChangeTechnicality = onChangeTechnicality;
        vm.getNormalTechnicalityClass = getNormalTechnicalityClass;
        vm.getHighTechnicalityClass = getHighTechnicalityClass;
        vm.getVeryHighTechnicalityClass = getVeryHighTechnicalityClass;
        vm.closeModal = closeModal;
        vm.addTM = addTM;


        this.$onInit = function () {
            vm.isSubCategoriesDisabled = true;
            vm.isNormalTechnicalityDisabled = true;
            vm.isHighTechnicalityDisabled = true;
            vm.isVeryHighTechnicalityDisabled = true;
            vm.isReferenceVisible = false;
            vm.isDesignationVisible = false;
            vm.isPriceVisible = false;
            vm.isTimeVisible = false;
            vm.isDescriptionVisible = false;
            vm.subCategories = [];
            vm.technicalities = [];
            vm.isActionsVisible = false;
        };

        /**
         * @name onChangeCategory
         * @desc action fired when user change the category
         * @param {String} categoryName
         */

        function onChangeCategory(categoryName) {
            vm.isSubmitted = false;
            selectedCategory = _.find(vm.categories, { name: categoryName });
            vm.subCategories = selectedCategory.subCategories;
            vm.isSubCategoriesDisabled = vm.subCategories.length > 0 ? false : true;

            vm.technicalities = [];
            vm.form.technicality = "";
            vm.form.reference = "";
            vm.form.designation = "";
            vm.form.time = "";
            vm.form.price = "";
            vm.form.description = "";
            vm.form.subCategory = "";
            vm.isActionsVisible = false;
            vm.isPriceVisible = false;
            vm.isTimeVisible = false;
            vm.isReferenceVisible = false;
            vm.isDesignationVisible = false;
            vm.isDescriptionVisible = false;
            vm.isNormalTechnicalityDisabled = true;
            vm.isHighTechnicalityDisabled = true;
            vm.isVeryHighTechnicalityDisabled = true;

            if (selectedCategory.name === "TM_NOCODIF_CAT_FIXPRICE") {
                vm.isActionsVisible = true;
                vm.isPriceVisible = true;
                vm.isTimeVisible = false;
                vm.isReferenceVisible = true;
                vm.isDesignationVisible = true;
                vm.isDescriptionVisible = true;
                vm.form.reference = selectedCategory.code;

            } else if (selectedCategory.name === "TM_NOCODIF_CAT_PAINTING") {
                vm.isActionsVisible = true;
                vm.isPriceVisible = false;
                vm.isTimeVisible = true;
                vm.isReferenceVisible = true;
                vm.isDesignationVisible = true;
                vm.isDescriptionVisible = true;
                vm.isHighTechnicalityDisabled = false;
                vm.form.technicality = "TM_NOCODIF_TECH_HIGH";
                vm.form.reference = selectedCategory.technicalities[0].code;
            }
        }

        /**
         * @name onChangeSubcategory
         * @desc action fired when user change sub category
         * @param {*} subCategoryName
         */
        function onChangeSubcategory(subCategoryName) {
            vm.isSubmitted = false;
            selectedSubCategory = _.find(selectedCategory.subCategories, { name: subCategoryName });
            vm.technicalities = [];
            vm.form.technicality = "";
            vm.form.reference = "";
            vm.form.designation = "";
            vm.form.time = "";
            vm.form.price = "";
            vm.form.description = "";
            vm.isNormalTechnicalityDisabled = true;
            vm.isHighTechnicalityDisabled = true;
            vm.isVeryHighTechnicalityDisabled = true;

            if (selectedSubCategory && selectedSubCategory.technicalities) {
                vm.technicalities = selectedSubCategory.technicalities;
                vm.isNormalTechnicalityDisabled = _.find(vm.technicalities, { "name": "TM_NOCODIF_TECH_NORMAL" }) ? false : true;
                vm.isHighTechnicalityDisabled = _.find(vm.technicalities, { "name": "TM_NOCODIF_TECH_HIGH" }) ? false : true;
                vm.isVeryHighTechnicalityDisabled = _.find(vm.technicalities, { "name": "TM_NOCODIF_TECH_VERY_HIGH" }) ? false : true;
            }
        }

        /**
         * @name onChangeTechnicality
         * @desc action fired when user change technicality
         * @param {*} technicality
         */
        function onChangeTechnicality(technicality) {
            if (technicality != "") {
                var subCategoryInformations = _.find(selectedSubCategory.technicalities, { "name": technicality });
                vm.isActionsVisible = true;
                vm.isTimeVisible = true;
                vm.isReferenceVisible = true;
                vm.isDesignationVisible = true;
                vm.isDescriptionVisible = true;
                vm.form.reference = subCategoryInformations.code;
            }
        }

        /**
         * @name getNormalTechnicalityClass
         * @desc get normal technicality class
         */
        function getNormalTechnicalityClass() {
            return vm.isNormalTechnicalityDisabled == false ? "color-black" : "color-grey";
        }

        /**
         * @name getHighTechnicalityClass
         * @desc get high technicality class
         */
        function getHighTechnicalityClass() {
            return vm.isHighTechnicalityDisabled == false ? "color-black" : "color-grey";
        }

        /**
         * @name getVeryHighTechnicalityClass
         * @desc get very high technicality class
         */
        function getVeryHighTechnicalityClass() {
            return vm.isVeryHighTechnicalityDisabled == false ? "color-black" : "color-grey";
        }

        /**
         * @name closeModal
         * @desc action fired when user click on close button
         */
        function closeModal() {
            $mdDialog.cancel();
        }

        /**
         * @name addTM
         * @desc action fired when user click on add TM button
         */
        function addTM(data) {
            vm.isSubmitted = true;
            if($scope.nonCodedTMForm.$valid){
                blockUI.start();
                FavoitMetierService.addNonCodedTmLogic(data).then(function(){
                    $mdDialog.hide(data);
                }).catch(function(e){
                    if(e.data && e.data.errors && e.data.errors[0]){
                        toastr.error($translate.instant(e.data.errors[0].errorMessage));
                    }
                    else{
                        toastr.error($translate.instant("ERROR"));
                    }
                }).finally(function() {
                    blockUI.stop();
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('moveReferenceController', moveReferenceController);

    /* @ngInject */
    function moveReferenceController(
        $mdDialog,
        FavoitMetierService,
        $translate,
        $state,
        $scope,
        blockUI,
        toastr,
        $q
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        var selectedCategory = {};
        var selectedSubCategory = {};
        vm.selectedCategoryIndex = -1;
        vm.selectedSubCategoryIndex = -1;
        vm.disableButtons = onChangeCategory.selectedCategory;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.closeModal = closeModal;
        vm.moveSelectedRefs = moveSelectedRefs;
        vm.onChangeCategory = onChangeCategory;
        vm.onChangeSubcategory = onChangeSubcategory;

        function init() {
            vm.transmitData = $translate.instant('FAV_MODAL_MODIF_REFS_TITLE').replace('#1', FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList));
            vm.disableButtons = onChangeCategory.selectedCategory;

            vm.favoritesProduct = vm.categories;
            vm.favoritesProduct.categories = setShowDetails(vm.favoritesProduct.categories);
      
        }
        init();

        /**
        * @name closeModal
        * @desc close modal move-Reference by clicking button Cancel
        */
        function closeModal() {
            $mdDialog.cancel();
        }

        /**
        * @name moveSelectedRef
        * @desc move selected individual or multiple references to another category/subcategory
        * @param {String} categoryName
        * @param {String} subCategoryName
        */
        function moveSelectedRefs(categoryKey, subCategoryKey) {
            vm.isSubmitted = true; //message d'erreur sur le champ concerné dans le html "md-is-error", si la donnée est incorrecte
            if ($scope.moveRefForm.$valid) {
                blockUI.start();
                angular.forEach(vm.productIds, function (productId) {
                    var isProductPresent = false;

                    if (categoryKey && selectedCategory.products && !subCategoryKey) {
                        isProductPresent = selectedCategory.products.includes(productId) ? true : false;
                    }
                    else if (subCategoryKey && categoryKey && selectedSubCategory && selectedSubCategory.products) {
                        isProductPresent = selectedSubCategory.products.includes(productId) ? true : false;
                    }
                    if (isProductPresent) {
                        toastr.error($translate.instant('PRODUCT_ALREADY_PRESENT_IN_FAVORITES'));
                        blockUI.stop();
                    }
                    else if(vm.selectedCategory) {
                        FavoitMetierService.deleteReferencesFromCategoryOrSubcategory(vm.selectedCategory, vm.selectedSubCategory, productId).catch(function (e) {
                            if (e.data && e.data.errors && e.data.errors[0]) {
                                toastr.error($translate.instant(e.data.errors[0].errorMessage));
                            }
                            else {
                                toastr.error($translate.instant("ERROR"));
                            }
                        }).then(function () {
                            FavoitMetierService.addReferencesToCategoryorSubcategory(categoryKey, subCategoryKey, productId).then(function (response) {
                                vm.data = {
                                    category: vm.selectedCategoryIndex,
                                    subCategory: vm.selectedSubCategoryIndex
                                };
                                $mdDialog.hide(vm.data);
                                if(response && response.status === 204) {
                                    return $q.reject(response);
                                }
                                if (vm.productIds.indexOf(productId) === vm.productIds.length - 1 && response.status === 200) {
                                    toastr.success($translate.instant('FAV_MOVE_REFERENCE_SUCCESS'));
                                }
                            }).catch(function (e) {
                                if (e.data && e.data.errors && e.data.errors[0]) {
                                    toastr.error($translate.instant(e.data.errors[0].errorMessage));
                                }
                                else {
                                    toastr.error($translate.instant("ERROR"));
                                }
                            }).finally(function () {
                                blockUI.stop();
                            });

                        })
                    }
                });
            }
            vm.favoritesPRList = [];
        }

        /**
        * @name setShowDetails
        * @desc reset showDetails of categories/subCategories except notChangedCategorie
        * @param {Array} categories
        */
        function setShowDetails(categories) {
            if (categories && categories != null) {
                return categories.map(function (item) {
                    item.showDetails = false;
                    return item;
                });
            }
            else {
                return categories;
            }
        }

        /**
        * @name onChangeCategory
        * @desc action fired when user change the category
        * @param {String} categoryName
        */
        function onChangeCategory(categoryKey) {
            // var selectedItem= {};
            vm.isSubmitted = false;

            //Retrieve selected category and its subCategories based on the name
            selectedCategory = _.find(vm.favoritesProduct.categories, { 'categoryKey': categoryKey });
            vm.subCategories = selectedCategory.subCategories;
            if(vm.subCategories){
                vm.isSubCategoriesDisabled = vm.subCategories.length > 0 ? false : true;
            }else{
                vm.isSubCategoriesDisabled = true;
            }
            vm.selectedCategoryIndex = _.findIndex(vm.favoritesProduct.categories, function (o) { return o.categoryKey == categoryKey; });      
        }

        /**
         * @name onChangeSubcategory
         * @desc action fired when user change sub category
         * @param {*} subCategoryName
         */
        function onChangeSubcategory(subcategoryKey) {
            vm.isSubmitted = false;
            selectedSubCategory = _.find(selectedCategory.subCategories, { 'subcategoryKey': subcategoryKey });
            vm.selectedSubCategoryIndex = _.findIndex(selectedCategory.subCategories, function (o) { return o.subcategoryKey == subcategoryKey; });
        }
    }
})();
(function () {
    'use strict';

    angular
      .module('phenix.core', [

           /*=============================================
          =               Angular modules               =
          =============================================*/

          'ngAnimate',
          'ngCookies',
          'ngSanitize',
          'ngMessages',
          'ngAria',
          'ui.router',
          'ngMaterial',

          /*=============================================
          =              3rd Party Modules              =
          =============================================*/

          'restangular',
          'mm.foundation',
          'toastr',
          'LocalStorageModule',
          'pascalprecht.translate',
          'validation',
          'validation.rule',
          'angularSpinners',
          'angulartics',
          'smart-table',
          'ngFileSaver',
          'ngFileUpload',
          'hc.marked'

      ]);

  })();

(function () {
    "use strict";

    angular
        .module("phenix.core")
        .controller("DeleteRefModalCtrl", DeleteRefModalCtrl);

    /** @ngInject */
    function DeleteRefModalCtrl(
        $mdDialog,
        FavoitMetierService,
        toastr,
        $translate,
        $q,
        blockUI) {

        var vm = this;

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name onConfirm
         * @desc action fired when user confirm the deletion
         */
        function onConfirm() {
            blockUI.start();
            ///parse selected products id
            angular.forEach(vm.productIds, function (productId) {
                if (vm.selectedCategory) {
                    FavoitMetierService.deleteReferencesFromCategoryOrSubcategory(vm.selectedCategory, vm.selectedSubCategory, productId).then(function (response) {
                        $mdDialog.hide();
                        if(response && response.status === 204) {
                            return $q.reject(response);
                        }
                        if (vm.productIds.indexOf(productId) === vm.productIds.length - 1 && response && response.status === 200) {
                            toastr.success($translate.instant('FAV_DEL_REFERENCE_SUCCESS'));
                        }
                        
                    }).catch(function (e) {
                        if (e.data && e.data.errors && e.data.errors[0]) {
                            toastr.error($translate.instant(e.data.errors[0].errorMessage));
                        }
                        else {
                            toastr.error($translate.instant("ERROR"));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
                }
            });
            vm.favoritesPRList = [];
        }

        function onCancel() {
            $mdDialog.cancel();
        }
    }
})();

/**
 * FavouritesProduct Controller
 * @namespace Controller
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('AddFavoritPRController', AddFavoritPRController);

    /* @ngInject */
    function AddFavoritPRController(
        $mdDialog,
        toastr,
        $translate,
        CacheConstants,
        FavouriteConstantes,
        DmsMetierService,
        DocumentsMetierService,
        $q,
        CacheService,
        FavoitMetierService,
        UtilsMetierService,
        globalConstant,
        blockUI,
        $scope,$filter,MainMetierService
    ) {

        /*=============================================
       =                 VARIABLES                   =
       =============================================*/

        var vm = this;
        vm.currency = CacheService.getObject(CacheConstants.currency);
        vm.form = {};
        var selectedCategory = {};
        var selectedSubCategory = {};
        vm.listCategories = [];
        vm.subCategories = [];
        vm.isReferenceVisible = false;
        vm.isActionsVisible = false;
        vm.isProductExists = false;
        var countryExceptionArray = globalConstant.countryCurrencyException;
        vm.products = [];
        vm.changedCategoryIndex = -1;
        vm.changedSubCategoryIndex = -1;
        vm.isFirst = false;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        vm.onChangeCategory = onChangeCategory;
        vm.onChangeSubcategory = onChangeSubcategory;
        vm.closeModal = closeModal;
        vm.addPR = addPR;
        vm.getReferenceInformation = getReferenceInformation;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.formatReferenceInput = formatReferenceInput;

        /**
         * @description basic fonctionalities to displayData : provding safecopy
         * @param response
         * @param filterBy
         * return {*} nothing
         */
        this.$onInit = function () {
            vm.userProfile = CacheService.getUserProfile();
            vm.changedCategoryIndex = vm.selectedCategoryIndex;
            vm.changedSubCategoryIndex = vm.selectedSubCategoryIndex;
        };

        /**
        * @name closeModal
        * @desc action fired when user click on close button
        */
        function closeModal() {
            $mdDialog.cancel();
        }

        /**
         * @name onChangeCategory
         * @desc action fired when user change the category
         * @param {String} categoryKey
         */
        function onChangeCategory(categoryKey) {
            vm.isSubmitted = false;
            vm.isReferenceVisible = !_.isEmpty(categoryKey);
            vm.isActionsVisible = !_.isEmpty(categoryKey);
            selectedCategory = _.find(vm.categories, { categoryKey: categoryKey });
            vm.subCategories = _.has(selectedCategory, 'subCategories') ? selectedCategory.subCategories : "";
            vm.isSubCategoriesDisabled = (vm.subCategories && vm.subCategories.length > 0) ? false : true;
            vm.products = _.has(selectedCategory, 'products') ? selectedCategory.products : "";
            vm.isProductExists = (vm.products && vm.products.length > 0) ? true : false;

            vm.changedCategoryIndex = _.findIndex(vm.categories, function (o) { return o.categoryKey == categoryKey; });
            selectedSubCategory = {};
            //to get the selected sub category index from parent controller on first load of pop in
            if (!vm.isFirst) {
                vm.isFirst = true;
            } else {
                vm.changedSubCategoryIndex = -1;
            }


        }

        function formatReferenceInput() {
            vm.form.reference =  MainMetierService.formatReferenceInput(vm.form.reference);
           
        }

        /**
         * @name onChangeSubcategory
         * @desc action fired when user change the subcategory
         * @param {String} subcategoryKey
         */
        function onChangeSubcategory(subcategoryKey) {
            vm.isSubmitted = false;
            selectedSubCategory = _.find(selectedCategory.subCategories, { subcategoryKey: subcategoryKey });
            vm.changedSubCategoryIndex = _.findIndex(selectedCategory.subCategories, function (o) { return o.subcategoryKey == subcategoryKey; });
        }

        /**
         * @name addPR
         * @desc action fired when user click on add PR button from the modal
         */ 
        function addPR(data) {
            vm.isSubmitted = true;
            if ($scope.PRForm.$valid && data && data.form.designation && data.form.price) {
                blockUI.start();
                var isProductPresent = false;
        
                if(selectedCategory && selectedCategory.products && data.changedCategoryIndex >= 0 && data.changedSubCategoryIndex < 0){
                    isProductPresent = selectedCategory.products.includes(((data.form && data.form.reference) || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10)) ? true : false;
                }
                else if (selectedSubCategory && selectedSubCategory.products && data.changedCategoryIndex >= 0 && data.changedSubCategoryIndex >= 0){
                    isProductPresent = selectedSubCategory.products.includes(((data.form && data.form.reference) || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10)) ? true : false;
                }

                if(isProductPresent){
                    toastr.error($translate.instant('PRODUCT_ALREADY_PRESENT_IN_FAVORITES'));
                    blockUI.stop();
                }
                else {
                     data.form.reference = ((data.form && data.form.reference) || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
                    return FavoitMetierService.updatePRLogic(data.form,data.categories,data.changedCategoryIndex,data.changedSubCategoryIndex).then(function (response) {
                        return response;
                    }).then(function (response) {
                        $mdDialog.hide(data);
                        if(response && response.status === 200) {
                            toastr.success($translate.instant('PRODUCT_ADD_TO_FAVORITES'))
                        }
                        if(response && response.status === 204) {
                            return $q.reject(response);
                        }
                    }).catch(function () {
                        toastr.error($translate.instant("ERROR"));
                    }).finally(function () {
                        blockUI.stop();
                    });
                }
            }
        }

        /**
         * @description function that permit to not display currency if the user is roumanian
         * @param PrList
         */

        function getCurrencyForItem() {
            var country = vm.userProfile.country;
            if (countryExceptionArray.indexOf(country) == -1) {
                return UtilsMetierService.getCurrencyForItem()
            }
            return "";
        }

        /**
         * @name getReferenceInformation
         * @desc action fired when user enter a reference in the input. It search and display price and designation's product
         */
        function getReferenceInformation(ref) {
             ref = (ref || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
            if (ref != "") {
                var data = {};
                blockUI.start()
                return $q.resolve()
                    .then(function () {
                        return DmsMetierService.getReferencesDms([ref])
                            .then(function (response) {
                                // call DMS
                                var part = response.response.parts[0];
                                if (part.description) {
                                    data = {
                                        designation: part.description,
                                        price: part.priceExclTaxes,
                                        fromDMS: true
                                    }
                                }
                                return data;
                            }).catch(function(){
                                return $q.reject("-1");
                            })
                    })
                    .then(function (data) {
                        if (!data.fromDMS) {
                            // call DH
                            return DocumentsMetierService.getPRLight([ref])
                                .then(function (products) {
                                    var part = products[0];
                                    if (part.designation) {
                                        data = {
                                            designation: part.designation,
                                            price: part.priceExclTaxes,
                                            fromDH: true
                                        }
                                    }
                                    return data;
                                })
                        }
                        return data;
                    })
                    .then(function (data) {
                        vm.form.designation = data.designation;
                        vm.form.price = data.price;
                        if (!data.fromDMS) {
                            toastr.info($translate.instant("COMMON_ERROR_REF_DMS"));
                        }
                        if (!data.fromDMS && !data.fromDH) {
                            vm.form.designation = "";
                            vm.form.price = "";
                            toastr.error($translate.instant('ALERTS_UNKNOWN_PART'));
                        }

                    }).catch(function (err) {
                        vm.form.reference = "";
                        vm.form.designation = "";
                        vm.form.price = "";
                        if(err !== '-1'){
                            toastr.error($translate.instant('ALERTS_UNKNOWN_PART'));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
            }
        }
    }
})();

(function () {

    angular
        .module('phenix')
        .controller('manageFavourtieModal', function ($mdDialog) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;

            vm.selected;
            vm.onClose = onClose;
            vm.onSelectPaint = onSelectPaint;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            function onClose() {
                $mdDialog.cancel();
            }

            /**
             * @param {string} paint
             */

            function onSelectPaint(paintCode) {
                $mdDialog.hide(paintCode);
            }
    });

})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("validatedQuoteCtrl", validatedQuoteCtrl);

    /** @ngInject */
    function validatedQuoteCtrl(
        $state,
        $filter,
        CacheService,
        CacheConstants,
        QuoteMetierService,
        UtilsMetierService,
        CarSearchMetierService,
        DealerManagerSystemeService,
        DmsMetierService,
        printPdfModalService,
        PartRequisitionMetierService,
        FileSaver,
        RoutesConstants,
        globalConstant,
        SettingsConstants,
        $rootScope,
        blockUI,
        toastr,

        $translate,
        $window,
        $q,
        $scope,
        $timeout,
        $document,$log
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.sortBy = sortBy;
        vm.prButton = false;
        vm.isShowPR = false;
        vm.isShowTM = false;

        vm.backToPrevious = backToPrevious;
        vm.onEditPartRequisitionMode = onEditPartRequisitionMode;
        vm.setHeaderPRorTMVisibility = setHeaderPRorTMVisibility;
        vm.getTMDuration = getTMDuration;
        vm.putQuoteItemsToPartRequisition = putQuoteItemsToPartRequisition;
        vm.getCreatePartRequisitionFromQuoteClass = getCreatePartRequisitionFromQuoteClass;
        vm.closeQuote = closeQuote;
        vm.filterTaxes = filterTaxes;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.printQuote = printQuote;
        var countryExceptionArray = globalConstant.countryCurrencyException;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        $rootScope.$on('bannerDataLoaded', function () {
            vm.bannerData = CarSearchMetierService.getBannerDetails();
        });
        /**
         * @name init
         * @desc instantiate when a new part Req is selected from dropdown in mainController
         */

        this.$onInit = function () {
            if (!$state.params.id) {
                toastr.error($translate.instant('ERROR'));
                return;
            }

            $state.redirectedFrom = $rootScope.previousState;

            if ($state.params.data) {
                vm.authorizeToBack = $state.params.data.backToPrevious;
            }

            vm.userProfile = CacheService.getUserProfile();
            if(vm.userProfile){
                vm.isWorkshop = DealerManagerSystemeService.isWorkshop(vm.userProfile);
                vm.isPartshop = DealerManagerSystemeService.isPartshop(vm.userProfile);
            }
            blockUI.start();

            QuoteMetierService.findQuote($state.params.id).then(function (res) {

                //res.items.map(function (item) {
                //    item.price = item.basis;
                //    return item;
                //})
				
                //parser res.items pour modifier la valeur de price par la basis
                //get vehicle informations
                if (res.vin || res.brand) {
                    vm.vehicle = {
                        vin: res.vin,
                        registrationNumber: res.registrationNumber,
                        model: res.vehicleDesignation,
                        engineDesignation: res.engineDesignation,
                        gearBoxType: res.gearboxType
                    }
                }
                vm.bannerData = CarSearchMetierService.getBannerDetails();
                vm.quote = splitType(res);
                vm.quote.validatorInfos = getValidatorInfos(vm.quote);

                // Action fired if german users are connected => change mention value and disable textarea field
                if (vm.userProfile.country.toUpperCase() === "DE") {
                    vm.quote.mentions = SettingsConstants.mentionsTextForDE;
                }

                // taxes is not the good terme to define what we get.
                vm.taxesReturned = filterTaxes(getTaxesReturned(res));
                vm.interItemsTax = res.operationTotal;
                vm.quote.interItemsTax = vm.interItemsTax;
                vm.taxesReturnedPrTm = calculatePrTMTotal(vm.quote);
                setHeaderPRorTMVisibility();

                vm.showDiscountRateColumn = checkIfDiscountExist();
                vm.showDiscountRateTMColumn = checkIfDiscountTMExist();

                // var carContextPromise = CarSearchMetierService.loadCarContextAndStoreIt(res);
                // arrayPromise = arrayPromise.concat([carContextPromise, quoteDataPromise]);

                if ($state.params.customer) {
                    // when we are comming from quote controller
                    return $q.resolve($state.params.customer);
                } else if (res.accountNumber) {
                    // when we are comming from
                    return DmsMetierService.getUserByAccount({
                        accountNumber: res.accountNumber
                    }).then(function (userAccountResponse) {
                        var error = userAccountResponse.returnCode;
                        if (error) {
                            return $q.reject('error');
                        }
                        return userAccountResponse.response.customer;
                    });
                }

                return $q.resolve();
            }).then(function (customer) {
                if (customer) {
                    vm.currentCustomer = customer;
                }
            }).catch(function (err) {
                if(!err.status){
                    toastr.error($translate.instant('ERROR'));
                }
            }).finally(function () {
                vm.isLoading = true;
                blockUI.stop();
            });



            $scope.$on("$mdMenuOpen", function () {
                $timeout(function () {
                    var menuContentContainer = angular.element(
                        $document[0].getElementById("menuContent")
                    );
                    menuContentContainer
                        .parent()
                        .addClass("drop-down-menu-position");
                });
            });

            function checkIfDiscountTMExist() {
                if (vm && vm.quote && vm.quote.items) {
                    return _.some(vm.quote.items, function (el) {
                        if (el.type == "TM") {
                            return el.discountRate != null;
                        }
                    });
                }
            }

            function checkIfDiscountExist() {
                if (vm && vm.quote && vm.quote.items) {
                    return _.some(vm.quote.items, function (field) {
                        if (field.type == "PR") {
                            return field.discountRate != null;
                        }
                    });
                }
            }
        }

        /**
         *
         * @param {*} quote
         */

        function getTaxesReturned(quote) {
            var taxesReturned = {
                global: {
                    exclTaxes: quote.exclTaxes,
                    taxes: quote.taxes,
                    basis: quote.basis,
                    total: quote.total
                },
                parts: {
                    basis: quote.prSummary.basis,
                    exclTaxes: quote.prSummary.exclTaxes,
                    taxes: quote.prSummary.taxes,
                    total: quote.prSummary.total
                },
                labourTimes: {
                    basis: quote.tmSummary.basis,
                    exclTaxes: quote.tmSummary.exclTaxes,
                    taxes: quote.tmSummary.taxes,
                    total: quote.tmSummary.total
                },
                totalPaintAmount: quote.totalPaintAmount,
                paintTime: quote.paintTime,
                basisSuppliesAmount: quote.basisSuppliesAmount,
                totalSuppliesAmount: quote.totalSuppliesAmount
            }

            if (quote.recyclingTotal || quote.recyclingExclTaxes) {
                taxesReturned.recycling = {
                    total: quote.recyclingTotal,
                    exclTaxes: quote.recyclingExclTaxes
                };
            }

            return taxesReturned;
        }



        /**
         * @name getCurrencyForItem
         * @desc get curency to diaplay
         * @returns {String} currency
         */

        function getCurrencyForItem() {
            var country = vm.userProfile.country;
            if (countryExceptionArray.indexOf(country) == -1) {
                return UtilsMetierService.getCurrencyForItem()
            }
            return "";
        }

        /**
         * @namespace onEditPartRequisitionMode
         * @desc set variables for the edit mode
         */

        function onEditPartRequisitionMode() {
            vm.isSearchCustomerMode = false;
        }

        /**
         *  @desc   Return a new object without nested objet
         *          which have all value as null/undefined
         *
         *  @in {
         *      x: {a: null, b: null}
         *      y: {a: 1, b: null}
         *  }
         *
         *  @out {
         *      y: {a: 1, b: null}
         *  }
         */

        function filterTaxes(taxes) {
            return _.reduce(taxes, function (acc, value, key) {
                if (typeof value === 'object') {
                    var isTaxExist = _.some(value, function (price) {
                        return price;
                    });
                    if (isTaxExist) {
                        acc[key] = value;
                    }
                } else if (value !== undefined && value !== null) {
                    acc[key] = value;
                }

                return acc;
            }, {});
        }

        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        /**
         * @name setHeaderPRorTMVisibility
         * @desc change header visibility (PR/TM) based on item list
         */

        function setHeaderPRorTMVisibility() {
            if (vm.quote.items && vm.quote.items.length > 0) {
                var isPr = false;
                var isTM = false;
                vm.quote.items.forEach(function (item) {
                    if (item.type == "PR") {
                        isPr = true;
                    } else if (item.type == "TM") {
                        isTM = true;
                    }
                });
                vm.isShowPR = isPr;
                vm.prButton = isPr ? true : false;
                vm.isShowTM = isTM;
            } else {
                vm.isShowPR = false;
                vm.isShowTM = false;
            }
            if (vm.quote.inter && vm.quote.inter.length > 0) {
                for (var inter of vm.quote.inter) {
                    if (inter.PR && inter.PR.length > 0) {
                        vm.prButton = true;
                    }
                }
            }
        }

        /**
         * @name getTMDuration
         * @desc get tm's labor tom
         * @param {Object} tm
         */
        function getTMDuration(tm) {
            return tm.laborTime ? tm.laborTime : "-";
        }

        /**
         * @name putQuoteItemsToPartRequisition
         * @desc put quote items to part requsition
         */
        function putQuoteItemsToPartRequisition() {
            QuoteMetierService.putQuoteItemsToPartRequisition(vm.quote);
        }


        /**
         * @name backToPrevious
         * @desc back to previous state
         */
        function backToPrevious() {
            //back to quoteListDraft page if we come from quoteListDraft with options list (filters, sort, pagination)
            //back to previous page else

            if (!$state.params.quoteListOptions) {
                $window.history.back();
            }
            else {
                $state.go(RoutesConstants.quoteListValidated, {
                    quoteListOptions: $state.params.quoteListOptions
                });
            }
        }

        /**
         * @name getCreatePartRequisitionFromQuoteClass
         * @desc activate part requisition when having at least 1 PR, desactivate it else
         */
        function getCreatePartRequisitionFromQuoteClass() {
            var createPartRequisitionFromQuoteClass = "verserBonServiceEstimation";
            if (!vm.prButton) {
                createPartRequisitionFromQuoteClass += " inactif";
            }
            return createPartRequisitionFromQuoteClass;
        }

        /**
         * @name closeQuote
         * @desc close current quote
         */
        function closeQuote() {
            var carContext = CacheService.getCarContext();
            //if we have context car, redirect to arbo page
            //redirect to home page else if Renault car
            if (carContext && carContext.bvmExtraFields) {
                $state.go(RoutesConstants.carSearchResult);
            }
            // test if the vehicle is unknown BVM & DMS and redirect to the the correct arbo
            else if (carContext) {
                $state.go(RoutesConstants.carSearchResultNoCarContext);
            }
            else {
                $state.go(RoutesConstants.carSearch);
            }
        }

        /**
         *  @desc Will call the business service layer (metier.service.js) in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  @param  vm.quote : list of TM and PR entries that we want to display in the pdf
         *  @param  vm.vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         *  response {
         *      data : blob type for the pdf file
         *  }
         */

        function printQuote(showRef,isDownload) {
            blockUI.start();
            var type = globalConstant.quote;
            var status = globalConstant.validated;

            vm.quoteToPrint = PartRequisitionMetierService.buildClientForPrintPayload(vm.quote, vm.currentCustomer, true, vm.showDiscountRateColumn, vm.showDiscountRateTmColumn);
            vm.quote.quoteStatus = "CalculatedQuote";
            
            vm.quoteToPrint.calculedQuoteData = [];
            vm.quoteToPrint.totalCalculatedQuote = [];
            if (vm.taxesReturned.parts) {
                var parts = {};
                parts.type = $translate.instant("CAR_SEARCH_RESULT_FILTER_PR");
                parts.genericType = "PR";
                parts.basis = vm.taxesReturned.parts.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.basis,2) : "-";
                parts.exclTaxes = vm.taxesReturned.parts.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.exclTaxes,2) : "-";
                parts.taxes = vm.taxesReturned.parts.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.taxes,2) : "-";
                parts.total = vm.taxesReturned.parts.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.total,2) : "-";
                vm.quoteToPrint.calculedQuoteData.push(parts);
            }
            if (vm.taxesReturned.labourTimes) {
                var labourTimes = {};
                labourTimes.type = $translate.instant("CAR_SEARCH_RESULT_FILTER_TM");
                labourTimes.genericType = "TM";
                labourTimes.basis = vm.taxesReturned.labourTimes.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.basis,2) : "-";
                labourTimes.exclTaxes = vm.taxesReturned.labourTimes.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.exclTaxes,2) : "-";
                labourTimes.taxes = vm.taxesReturned.labourTimes.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.taxes,2) : "-";
                labourTimes.total = vm.taxesReturned.labourTimes.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.total,2) : "-";
                vm.quoteToPrint.calculedQuoteData.push(labourTimes);
            }
            if (vm.taxesReturned.totalPaintAmount) {
                var paint = {};
                paint.type = $translate.instant("ESTIMATE_MO_PAINT_LABEL");
                paint.basis = "-";
                paint.exclTaxes = "-";
                paint.taxes = "-";
                paint.genericType = "";
                paint.total = vm.taxesReturned.totalPaintAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.totalPaintAmount,2) : "-";
                vm.quoteToPrint.calculedQuoteData.push(paint);
            }
            if (vm.taxesReturned.recycling) {
                var recycling = {};
                recycling.type = $translate.instant("ESTIMATE_MO_RECYCLE_LABEL");
                recycling.genericType = "";
                recycling.basis = vm.taxesReturned.recycling.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.basis,2) : "-";
                recycling.exclTaxes = vm.taxesReturned.recycling.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.exclTaxes,2) : "-";
                recycling.taxes = vm.taxesReturned.recycling.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.taxes,2) : "-";
                recycling.total = vm.taxesReturned.recycling.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.total,2) : "-";
                vm.quoteToPrint.calculedQuoteData.push(recycling);
            }
            if (vm.taxesReturned.basisSuppliesAmount) {
                var suppliesAmount = {};
                suppliesAmount.genericType = "";
                suppliesAmount.type = $translate.instant("ESTIMATE_MO_SUPPLY_LABEL");
                suppliesAmount.basis = "-";
                suppliesAmount.exclTaxes = vm.taxesReturned.basisSuppliesAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.basisSuppliesAmount,2) : "-";
                suppliesAmount.taxes = "-";
                suppliesAmount.total = vm.taxesReturned.totalSuppliesAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.totalSuppliesAmount,2) : "-";
                vm.quoteToPrint.calculedQuoteData.push(suppliesAmount);
            }
            if (vm.taxesReturned.global) {
                var global = {
                    basis: {
                        type: $translate.instant('ESTIMATE_TOTAL_BRUTHT'),
                        index: 0
                    },
                    exclTaxes: {
                        type: $translate.instant('ESTIMATE_TOTAL_NETHT'),
                        index: 1
                    },
                    taxes: {
                        type: $translate.instant('ESTIMATE_TOTAL_TAXES'),
                        index: 2
                    },
                    total: {
                        type: $translate.instant('ESTIMATE_TOTAL_TTC'),
                        index: 3
                    }
                }
                // add total for each properties in global
                angular.forEach(vm.taxesReturned.global, function (value, key) {
                    vm.quoteToPrint.totalCalculatedQuote.push(_.extend(global[key], {
                        total: value
                    }));
                })
                vm.quoteToPrint.totalCalculatedQuote.sort(compare);
            }
            if (vm.itemsReturned) {
                formatReturnedItemsToFitPrintPayload(vm.itemsReturned);
            }

            var isKnownByDms = _.find(vm.quoteToPrint.items, function (item) {
                return item.dmsInformations;
            });
            if (isKnownByDms) {
                vm.quoteToPrint.currency = UtilsMetierService.getCurrencyForItem(isKnownByDms);
            } else {
                vm.quoteToPrint.currency = UtilsMetierService.getCurrencyForItem();
            }

            //update payload
            vm.quoteToPrint.items.map(function (currentItem) {
                _.omit(currentItem, 'codeTaxe');
                if (currentItem.exclTaxes != 0) {
                    currentItem.totalPriceExclTaxes = $filter('number')(currentItem.exclTaxes, 2);
                }
                return currentItem;
            })
            QuoteMetierService.downloadPdf(showRef, vm.quoteToPrint, vm.quoteToPrint.items, vm.vehicle, type, status).then(function (response) {
                pdfMake.tableLayouts = {
                    descTableLayout: {
                        hLineWidth: function () {
                            return 0.1;
                        },
                        vLineWidth: function () {
                            return 0.1;
                        },
                        hLineColor: function () {
                            return 'gray';
                        },
                        vLineColor: function () {
                            return 'gray';
                        },
                    },
                    secondTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 3 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                        }
                    },
                    thirdTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 2 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                        }
                    },
                    otherTableLayout: {
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    },
                    noBorderTableLayout: {
                        hLineWidth: function () {
                            return 0;
                        },
                        vLineWidth: function () {
                            return 0;
                        }
                    }
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });

                    // Internet Explorer 6-11
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;

                    // Edge 20+
                    var isEdge = !isIE && !!window.StyleMedia;
                    if (isDownload){                        
                        FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + "-" + vm.quoteToPrint.number + ".pdf");
                    }
                    else{
                        if (isIE || isEdge) {
                            FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + "-" + vm.quoteToPrint.number + ".pdf");
                        } else {
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                    }
                })
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }




        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name getValidatorInfos
         * @desc get quote validator label (ipn and username if exist)
         * @param {Object} quoteInformations
         * @returns {String} - validatorIpn or validatorIpn / userName
         */
        function getValidatorInfos(quoteInformations) {
            var quoteValidatorLabel = quoteInformations.validatorIPN;
            if (quoteInformations.estimateUserId) {
                quoteValidatorLabel = quoteValidatorLabel + " / " + quoteInformations.estimateUserId;
            }
            return quoteValidatorLabel;
        }
        function calculatePrTMTotal(quote) {
            var prTmTotal = {};
            if (quote && quote.items && quote.items.length > 0) {
                var tmList = _.filter(quote.items, { type: "TM" });
                var prList = _.filter(quote.items, { type: "PR" });
                if (prList) {
                    var prPrice = 0;
                    for (var x of prList) {
                        prPrice += x.price;
                    }
                    prTmTotal.pr = prPrice;
                }
                if (tmList) {
                    var tmPrice = 0;
                    for (var x of tmList) {
                        tmPrice += x.exclTaxes;
                    }
                    prTmTotal.tm = tmPrice;
                }
            }
            return prTmTotal;
        }

        function splitType(quote) {
            var pr = [];
            var tm = [];
            var tmList = _.filter(quote.items, function (item) {
                if (item.type === "TM") {
                    return !item.interventionId;
                }
            });

            var prList = _.filter(quote.items, function (list) {
                if (list.type === "PR") {
                    return !list.interventionId;
                }
            });
            var inter = [];
            var interList = _.filter(quote.items, function (item) { return item.interventionDesignation != null });
            var list = _.groupBy(interList, 'interventionDesignation');

            for (var x in list) {
                var y = { designation: x, PR: [], TM: [] };
                list[x].forEach(function (item) {
                    switch (item.type) {
                        case "TM":
                            y.TM.push(item);
                            break;
                        default:
                            y.PR.push(item);
                            break;
                    }
                });
                inter.push(y);
            }
            angular.forEach(quote.items, function (value) {
                if (!value.interventionDesignation || value.interventionDesignation == null) {
                    switch (value.type) {
                        case "TM":
                            tm = tmList;
                            break;
                        default:
                            pr = prList;
                            break;
                    }
                }
            });

            quote.items = [];
            quote.items = prList.concat(tmList);
            quote.inter = inter;
            return quote;
        }

        function compare(a, b) {
            if (a.index < b.index)
                return -1;
            if (a.index > b.index)
                return 1;
            return 0;
        }
        function formatReturnedItemsToFitPrintPayload(items) {
            angular.forEach(items.PR, function (value) {
                var structuredItem = {
                    priceHT: value.amount.basis,
                    cort: value.cort,
                    designation: value.designation,
                    exclTaxes: value.amount.exclTaxes,
                    reference: value.reference,
                    totalPriceExclTaxes: value.amount.total,
                    type: "PR",
                    quantity: null
                }
                vm.quoteToPrint.items.push(structuredItem);
            });

            angular.forEach(items.TM, function (value) {
                var structuredItem = {
                    opecod: value.code,
                    totalPriceExclTaxes: value.amount.exclTaxes,
                    type: "TM"
                }
                vm.quoteToPrint.items.push(structuredItem);
            });
        }
    }
})();

(function() {
    angular.module("phenix").constant("referenceResponseMock", {
        "returnCode":1020,"message":"Liste des rÃ©fÃ©rences non renseignÃ©e"})
})();

(function () {
    angular.module('phenix').service('QuoteWSService', function ($q, QuoteEndpointConstant, DmsConstants, RestUpgrade,CarSearchConstants) {
        this.createQuote = createQuote;
        this.closeQuote = closeQuote;
        this.saveQuote = saveQuote;
        this.findQuote = findQuote;
        this.updateQuoteTable = updateQuoteTable;
        this.validateQuote = validateQuote;
        this.findQuoteList = findQuoteList;
        this.deleteQuote = deleteQuote;
        this.unlockQuote = unlockQuote;
        this.interventionQuoteDelete = interventionQuoteDelete;
        // this.updateEstimateNumber = updateEstimateNumber;

        // function updateEstimateNumber(payload) {
        //     return RestUpgrade.all(CarSearchConstants.partRequisitionEstimateNumber).post(payload);
        // }

        function createQuote(body) {
            return RestUpgrade.all(QuoteEndpointConstant.create).post(body || {});
        }

        function closeQuote(body) {
            return RestUpgrade.all(QuoteEndpointConstant.close).post(body);
        }

        function saveQuote(body) {
            return RestUpgrade.all(QuoteEndpointConstant.save).post(body);
        }

        function findQuote(body) {
            return RestUpgrade.one(QuoteEndpointConstant.find, body.id).get();
        }

        function updateQuoteTable(body) {
              for (var key in body.items) {
                if (body.items[key]) {
                    if (body.items[key].quantity % 1 != 0) {
                        body.items[key].quantity = parseFloat(body.items[key].quantity).toFixed(4);
                    }
                }
            }
            return RestUpgrade.all(QuoteEndpointConstant.updateItems).post(body);
        }

        function validateQuote(body) {
            return RestUpgrade.all(QuoteEndpointConstant.validate).post(body).then(function (res) {
                if (!res) {
                    return $q.reject(DmsConstants.errors.EMPTY_RESPONSE);
                }
                return res;
            });
        }

        function findQuoteList(payload) {
            return RestUpgrade.all(QuoteEndpointConstant.quoteList).post(payload);
        }

        function deleteQuote(requestBody) {
            return RestUpgrade.all(QuoteEndpointConstant.delete).post(requestBody);
        }
        function interventionQuoteDelete(estimateId, interventionId, payload){
            return RestUpgrade.one('/estimate', interventionId).one(estimateId).post('', payload);
         
        }   

        function unlockQuote() {
            return RestUpgrade.all(QuoteEndpointConstant.unlock).post();
        }

    });
})();

(function () {
    angular
        .module("phenix")
        .service("QuoteMetierService", function (
            $q,
            $rootScope,
            toastr,
            $translate,
            $state,
            blockUI,
            $filter,
            $mdDialog,
            $timeout,

            CacheService,
            QuoteWSService,
            BasketTools,
            BasketTools2,
            DocumentsMetierService,
            listOfDraftModalService,
            DmsMetierService,
            PartRequisitionMetierService,
            ShoppingCartPartsService,
            UtilsMetierService,
            DealerManagerSystemeService,
            SuperCartWsService,
            RoutesConstants,
            CacheConstants,
            CodesConstants,
            SuperCartDraftListModalConstants,
            globalConstant,
            CarSearchConstants,
            ShoppingCartServiceConstant,
            QuoteConstants,
            ShoppingCartConstants,
            PartRequisitionConstants,
            PDFViewService,
            ShoppingCartService
        ) {
            /*=============================================
            =                  VARIABLES                  =
            =============================================*/

            // contain quote ID, and other things
            // list of object
            // handle update of _quoteItem;
            var _actions = ShoppingCartServiceConstant.actions;
            var _essai = ShoppingCartServiceConstant.essai;
            var _basketTools = BasketTools2;
            var dataHolded = {};
            var profil = CacheService.getUserProfile();
            var _testTime = ShoppingCartServiceConstant.testTime;
            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            this.getMileage = getMileage;
            this.getQuoteData = getQuoteData;
            this.saveAndCloseCurrentQuote = saveAndCloseCurrentQuote;

            // UPDATE DATA
            this.findAndSetCurrentQuote = findAndSetCurrentQuote;
            this.saveQuoteInformations = saveQuoteInformations;
            this.getQuoteDataAfterCalculate = getQuoteDataAfterCalculate;
            this.saveQuoteAfterCalculate = saveQuoteAfterCalculate;
            this.updateQuotePart = updateQuotePart;
            this.updateMileage = updateMileage;
            this.updateOrderNumber = updateOrderNumber;
            this.eraseQuote = eraseQuote;
            this.cleanDataFromCalculate = cleanDataFromCalculate;
            this.isUserAllowedToOpenQuote = isUserAllowedToOpenQuote;
            this.addItemByRef = addItemByRef;
            this.addLocalItem = addLocalItem;

            this.restoreStructQuoteValidate = restoreStructQuoteValidate;

            // CALL ND_SERVICE FOR POSTGRES UPDATE
            this.createQuote = createQuote;
            this.getPayload = getPayload;
            this.getMention = getMention;
            this.deleteQuoteLogic = deleteQuoteLogic;
            this.saveQuote = saveQuote;
            this.findQuote = findQuote;
            this.closeQuote = closeQuote;
            this.updateQuoteTable = updateQuoteTable;
            this.getHourlyRate = getHourlyRate;
            this.validateQuote = validateQuote;
            this.quoteServiceListLogic = quoteServiceListLogic;
            this.unlockQuoteLogic = unlockQuoteLogic;
            this.addQuotesInformations = addQuotesInformations;
            this.instanciateNewQuote = instanciateNewQuote;
            this.putQuoteItemsToPartRequisition = putQuoteItemsToPartRequisition;
            // this.updateEstimateNumber = updateEstimateNumber;
            this.dynaTracking = dynaTracking;
            this.deleteQuoteIntervention = deleteQuoteIntervention;
            this.downloadPdf = downloadPdf;
            this.getPR = getPR;
            this.getTM = getTM;

            /**
             * @name createQuote
             * @desc create quote
             * @param
             */
            function createQuote() {
                var payload = getPayload();
                return QuoteWSService.createQuote(payload).then(function (response) {
                    var customer = null;
                    if (response.accountNumber) {
                        customer = CacheService.getObject(CacheConstants.dmsResponse).customer;
                    }
                    initQuoteInCache(response, customer);
                    $rootScope.$emit(QuoteConstants.quoteCreatedEvent);
                    return response;
                });
            }

            /**
             *      @desc This function is used in 2 cases
             *            - when we create a new quote
             *            - when we reload a draft quote
             */

            function initQuoteInCache(data, customer) {
                var quote = {
                    id: data.id,
                    number: data.number,
                    vin: data.vin,
                    registrationNumber: data.registrationNumber
                };

                if (customer) {
                    quote.customer = customer;
                    // insert accountNumber field in customer for dms customer component
                    quote.customer.accountNumber = data.accountNumber;
                }

                var shoppingCart = {
                    PR: getPR(data.items),
                    TM: getTM(data.items)
                }

                if (data.orderNumber) {
                    shoppingCart['orderNumber'] = data.orderNumber;
                }

                _.extend(quote, { shoppingCart: shoppingCart });
                CacheService.setDmsQuote(quote);
            }

            function updateQuoteItemsCache(items) {
                var quote = CacheService.getDmsQuote();
                
                //set PR and TM
                quote.shoppingCart.PR = getPR(items);
                quote.shoppingCart.TM = getTM(items);
                //set is calculated to false
                quote.isCalculated = false;
                
                CacheService.setDmsQuote(quote);

            }
            function dynaTracking(quote){
                return $q.resolve().then(function(){
                         var item = quote;
                         dtrum.addActionProperties(1, null, null, {"prquotation":item}, null);
                         return;
                         }).catch(function(err) {
                             return $q.resolve(quote);
                         });
        
            }
        
            /**
             * @namespace QuoteMetierService
             * @name findAndSetCurrentQuote
             * @desc find quote from database and set in the quote in cache
             * @param {*} quoteId
             */

            function findAndSetCurrentQuote(quoteId) {
                return findQuote(quoteId).then(function (res) {
                    //if account number exist, call account.v1 dms request
                    if (!_.isEmpty(res.accountNumber)) {
                        return DmsMetierService.getUserByAccount({
                            accountNumber: res.accountNumber
                        }).then(function (customer) {
                            return {
                                quote: res,
                                customer: customer.response.customer
                            };
                        }).catch(function(err){
                            return $q.reject(err);
                        });
                    }
                    //else return quote and customer to null
                    else {
                        return {
                            quote: res,
                            customer: null
                        };
                    }
                }).then(function (response) {
                    initQuoteInCache(response.quote, response.customer);
                    return response;
                });
            }

            function getTM(items) {
                return items.filter(function (item) {
                    return item.type === 'TM';
                }).map(function (i) {
                    return {
                        quantity: i.quantity,
                        opecod: i.opecod, // reference or opecod property name ?
                        reference: i.reference,
                        designation: i.designation,
                        essay: i.essay,
                        laborTime: i.laborTime,
                        duration: i.duration,
                        interventionId: i.interventionId
                    }
                })
            }

            function getPR(items) {
                return items.filter(function (item) {
                    return item.type === 'PR';
                }).map(function (i) {
                    return {
                        quantity: i.quantity,
                        reference: i.reference,
                        designation: i.designation,
                        genericPart: i.genericPart,
                        type: i.type,
                        interventionId: i.interventionId
                    }
                });
            }
            function deleteQuoteIntervention(estimateId, interventionId, payload){

                return QuoteWSService.interventionQuoteDelete(estimateId,interventionId, payload).then(function(res){
                    updateQuoteItemsCache(res.items);
                    $rootScope.$emit('quoteCount', res);
                    $rootScope.$emit(QuoteConstants.quoteUpdatedEvent);
                    return res;
                })
            }

            /**
             * @description add an item on the quote
             * @param ref
             * @returns {*}
             */

            function addItemByRef(ref, typeOfRef, TM) {
                var quote = getQuoteData();
                if (typeOfRef === 'TM') {
                    var item = _.find(quote.items, function (item) {
                        return item.opecod === ref;
                    });
                } else {
                    item = _.find(quote.items, function (item) {
                        return item.reference === ref;
                    });
                }

                return $q.resolve().then(function () {
                    if (item) {
                        updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                            piece: item,
                            type: typeOfRef
                        });
                        item.quantity += 1;
                        return item;
                    } else {
                        if (typeOfRef === 'PR') {
                            return DocumentsMetierService.getPRLight([ref]).then(function (products) {
                                // call DH
                                if (!products || !products.length) {
                                    return null;
                                }
                                return products[0];
                            }, function () {
                                return null;
                            }).then(function (RefInformations) {
                                // return a promise which contains DMS/DH informations on user reference input
                                return DmsMetierService.getReferencesDms([ref]).then(function (response) {
                                    // call DMS
                                    var error = response.response.returnCode;
                                    var part = response.response.parts[0];
                                    var DMSRefInformations;

                                    if (error || !part.priceExclTaxes) {
                                        DMSRefInformations = null;
                                    } else {
                                        DMSRefInformations = part;
                                    }
                                    return {
                                        fromDMS: DMSRefInformations,
                                        fromDH: RefInformations
                                    };
                                }, function () {
                                    return {
                                        fromDMS: null,
                                        fromDH: RefInformations
                                    };
                                });
                            }).then(updateShoppingCartState);
                        } else {

                            updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                                piece: TM.TM[0],
                                type: 'TM'
                            });

                            return TM.TM[0];

                        }


                    }

                }).then(function (item) {
                    return updateQuoteTable([item]).then(function () {
                        return item;
                    })
                });
            }

            /**
             * @name addLocalItem
             * @desc add local item to quote
             * @param {String} ref
             */
            function addLocalItem(quoteItems, ref) {

                var item = _.find(quoteItems, function (item) {
                    return item.reference === ref;
                });
                var cort = '-';

                return $q.resolve().then(function () {
                    if (item) {
                        var payload = {
                            reference: item.reference,
                            quantity: item.quantity + 1
                        }
                        updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                            piece: payload,
                            type: 'PR'
                        });
                        //update quantity
                        item.quantity = item.quantity + 1;

                        return quoteItems;
                    } else {
                        return DmsMetierService.getReferencesDms([ref]).then(function (response) {

                            var part = response.response.parts[0];
                            var dmsLocalInformations = null;

                            if (response.returnCode != 0) {
                                return $q.reject(QuoteConstants.errors.partNotFound);
                            } else if (part.status === QuoteConstants.status.unknownPieceDMS) {
                                return $q.reject(QuoteConstants.errors.partNotFound);
                            } else {
                                dmsLocalInformations = part;
                            }

                            return dmsLocalInformations;

                        }).then(function (dmsLocalInformations) {
                            //get cort
                            if (dmsLocalInformations.cort) {
                                cort = dmsLocalInformations.cort.slice(-1);
                            }

                            //build local item's structure
                            var localItemInformations = getLocalItemInformations(dmsLocalInformations);

                            //update shopping cart
                            updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                                piece: localItemInformations,
                                type: 'PR'
                            });


                            _.extend(localItemInformations,
                                {
                                    currency: UtilsMetierService.getCurrencyForItem(),
                                    orderTypeObject: { id: 0 },
                                    dmsInformations: {
                                        isKnowFromDms: true,
                                        isLocalPiece: true
                                    },
                                    cort: cort,
                                    type: "PR"
                                });


                            // return localItemInformations;
                            quoteItems.push(localItemInformations);

                            return quoteItems;
                        });
                    }

                });
            }

            /**
             * @name getLocalItemInformations
             * @desc build local item reference
             * @param {Object} dmsLocalInformations
             */
            function getLocalItemInformations(dmsLocalInformations) {

                var localItemInformations = {
                    reference: dmsLocalInformations.reference,
                    designation: dmsLocalInformations.description,
                    price: dmsLocalInformations.priceExclTaxes,
                    // currency: UtilsMetierService.getCurrencyForItem(),
                    // orderTypeObject: {
                    //     id: 0
                    // },
                    quantity: 1
                    // dmsInformations: {
                    //     isKnowFromDms: true,
                    //     isLocalPiece: true
                    // }
                };

                if (dmsLocalInformations.availabilities[0]) {
                    _.extend(localItemInformations.dmsInformations, {
                        quantity: dmsLocalInformations.availabilities[0].quantity,
                        priceExclTaxes: dmsLocalInformations.priceExclTaxes,
                        location: dmsLocalInformations.availabilities[0].location,
                        stockId: dmsLocalInformations.availabilities[0].stockId,
                        siteId: dmsLocalInformations.availabilities[0].siteId,
                        stockLabel: dmsLocalInformations.availabilities[0].stockLabel
                    });
                }

                if (dmsLocalInformations.cort) {
                    _.extend(localItemInformations.dmsInformations, {
                        cort: dmsLocalInformations.cort.slice(-1)
                    });
                }

                return localItemInformations;
            }

            /**
             *  @desc   Update part requisition shopping cart state
             *          Display error toastr when we only have data from DH
             *  @param {Object} refInfo {
             *      fromDH  : Object
             *      fromDMS : Object
             *  }
             *  @return {object} return DH/DMS/ or both inside a same object
             */
            function updateShoppingCartState(refInfo) {
                // UPDATE SHOPPING CART SERVICE
                if (!refInfo.fromDMS && !refInfo.fromDH) {
                    return $q.reject(QuoteConstants.errors.partNotFound);
                }

                if (!refInfo.fromDMS && refInfo.fromDH) {
                    toastr.info($translate.instant('COMMON_ERROR_REF_DMS'));
                    updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                        piece: refInfo.fromDH,
                        type: 'PR'
                    });
                    return formatPart(refInfo.fromDH);
                } else if (refInfo.fromDMS && !refInfo.fromDH) {
                    updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                        piece: refInfo.fromDMS,
                        type: 'PR'
                    });
                    return formatPart(refInfo.fromDMS);
                } else {
                    updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                        piece: refInfo.fromDH,
                        type: 'PR'
                    });
                    return mergeData(refInfo.fromDH, refInfo.fromDMS);
                }
            }

            /**
             *  @desc Return a new struct of part
             *  @param {object} part
             *  @return {object}
             */

            function formatPart(part) {
                return {
                    reference: part.reference,
                    designation: part.designation || part.description,
                    price: part.priceExclTaxes,
                    reach: part.reach,
                    quantity: 1,
                    orderType: 0,
                    codeTaxe: part.taxCode,
                    orderTypeObject: { id: 0 },
                    currency: part.currency
                };
            }

            /**
             * @desc Merge data from DH/DMS to one
             * @param {object} DHRef
             * @param {object} DMSRef
             * @return {object}
             */
            function mergeData(DHRef, DMSRef) {
                var DMSData = DmsMetierService.buildDataFromDms([DMSRef]);
                DmsMetierService.addDmsInformationToCurrentPiece(DHRef, DMSData);
                // DHRef is mutated inside addDmsInformationToCurrentPiece
                DHRef.orderTypeObject = { id: 0 };
                DHRef.quantity = 1;
                return DHRef;
            }

            function addOperations(payload) {
                var quote = getQuoteData();
                var quotePartList = (quote && quote.shoppingCart && quote.shoppingCart.PR) ? quote.shoppingCart.PR : [];
                var quoteTmList = (quote && quote.shoppingCart && quote.shoppingCart.TM) ? quote.shoppingCart.TM : [];
                var interventionId = payload.INT[0].id;
                var interventionDesignation = payload.INT[0].designation;
                var interventionSieVersion = payload.INT[0].version;
                var interventionQuantity = payload.INT[0].interventionQuantity;
                var tmList = payload.INT[0].basketContent.labourTimes ? payload.INT[0].basketContent.labourTimes : [];
                var partList = payload.INT[0].basketContent.parts ? payload.INT[0].basketContent.parts : [];
                var ingredientList = payload.INT[0].basketContent.ingredients ? payload.INT[0].basketContent.ingredients : [];
                var interventionList = [];
                var quoteList = quotePartList.concat(quoteTmList);
                var interventionElements = tmList.concat(partList, ingredientList);
                if (!_.isEmpty(interventionElements)) {
                    interventionElements.map(function (element) {
                        element.interventionId = interventionId;
                        var plateId = ShoppingCartService.checkcatalogPlateId(element); 
                        var index = ShoppingCartService.checkPartIndex(element);
                        var part = _basketTools.onAddQuantity(
                            element,
                            element.type,
                            element.genericPart
                        );
                        if(part[0].type === "PR"){
                        part[0].plateId = plateId ? plateId : null;
                        part[0].herculesCase = element.herculesCase ? element.herculesCase : null;
                        part[0].index = index ? index : null;
                        }
                        part[0].interventionId = interventionId;
                        part[0].interventionDesignation = interventionDesignation;
                        part[0].interventionSieVersion = interventionSieVersion;
                        part[0].quantity = element.quantity;
                        part[0].designation = element.designation;
                        part[0].suggestedQuantity = element.defaultQuantity;
                        part[0].interventionQuantity = interventionQuantity ? parseInt(interventionQuantity) : "";
                        part[0].genericPart = element.genericPart ? element.genericPart : '';
                        part[0].price = element.price;
                        part[0].type = element.type;
                        if(part[0].type === "TM"){
                            part[0].reference = element.technicalId || element.reference;
                            element.reference = part[0].reference;
                            // opecod comes from element.opecod (labourTimesForQuote items) or falls back to element.id
                            part[0].opecod = element.opecod || element.id || part[0].opecod;
                            part[0].element = element.element;
                            // preserve laborTime when createNewStructOfPiece couldn't derive it from duration
                            if (part[0].laborTime == null && element.laborTime != null) {
                                part[0].laborTime = element.laborTime;
                            }
                        }
                        else{
                            part[0].reference = element.reference;
                        }
                        delete part[0].essay;
                        if (!_.isEmpty(quoteList)) {
                            quoteList.forEach(function (item) {
                                                                var sameGenericPart = (item.genericPart || '') === (element.genericPart || '');
                                                                if (item.reference === element.reference && item.interventionId == element.interventionId &&
                                                                        (element.type === "TM" || (sameGenericPart && item.quantity > 0 && element.type === "PR"))) {
                                                                    part[0].quantity = (Number(item.quantity) || 0) + (Number(element.quantity) || 0);
                                }
                            });
                        }
                        // deduplicate within the same operation batch to avoid sending identical items to the server
                        var dupKey = part[0].type + '_' + part[0].interventionId + '_' + (part[0].reference || part[0].designation);
                        var existingItem = _.find(interventionList, function (i) {
                            return (i.type + '_' + i.interventionId + '_' + (i.reference || i.designation)) === dupKey;
                        });
                        if (existingItem) {
                            existingItem.quantity = (existingItem.quantity || 0) + (part[0].quantity || 0);
                        } else {
                            interventionList.push(part[0]);
                        }
                    })
                }
                return interventionList;
            }

            /**
             * @desc Return mention from the user profile
             * @return mentions
             */
            function getMention() {
                var userProfile = CacheService.getObject(CacheConstants.profil);
                return userProfile.mentions;
            }

            function getPayload() {
                var carInformations = getCarInformations();
                var networkProfile = CacheService.getNetworkProfile();

                var payload = _.assign({}, carInformations, {
                    type: networkProfile
                });

                var carSearchContext = CacheService.getCarSearchContext();
                if (carSearchContext && carSearchContext.vehicle) {
                    _.extend(payload, {
                        vin: carSearchContext.vehicle.vin
                    });
                    _.extend(payload, {
                        mileAge: carSearchContext.vehicle.mileAge
                    });
                    _.extend(payload, {
                        registrationNumber: carSearchContext.vehicle ? carSearchContext.vehicle.registrationNumber : carInformations.registrationNumber
                    });

                    _.extend(payload, {
                        engineDesignation: carSearchContext.vehicle.motorisation
                    },
                        {
                            gearboxType: carSearchContext.vehicle.gearBoxType
                        });

                    if (!payload.vehicleDesignation) {
                        payload.vehicleDesignation = carSearchContext.vehicle.model;
                    }
                }

                // if workshop user
                if (networkProfile === CarSearchConstants.networkProfileWorkshop) {

                    var orderAndSplits = getOrdersAndSplits();



                    var accountNumber = getAccountNumber();
                    _.extend(payload, {
                        accountNumber: accountNumber
                    })

                    if (orderAndSplits && orderAndSplits.openOrderFlag == CodesConstants.ONE_ORDER_TYPE) {
                        _.extend(payload, {
                            orderNumber: orderAndSplits.orderNumber
                        });
                    }
                }

                var mentions = getMention();
                if (mentions) {
                    _.extend(payload, {
                        mentions: mentions
                    })
                }
                return payload;
            }

            function getQuoteInformations() {
                return CacheService.getDmsQuote();
            }

            /**
             * @namespace QuoteMetierService
             * @name QuoteLogic
             * @desc delete quote
             * @param {array} quoteIds
             */
            function deleteQuoteLogic(quoteIds) {
                var requestBody = {
                    estimateIds: quoteIds
                };
                return QuoteWSService.deleteQuote(requestBody);
            }

            /**
             * @namespace QuoteMetierService
             * @name isUserAllowedToOpenQuoteService
             * @desc check if current user is allowed to open current quote
             * @param {Array} QuoteList
             */
            function isUserAllowedToOpenQuote(userIpn, currentQuoteIpn) {
                return userIpn == currentQuoteIpn || currentQuoteIpn === null;
            }

            function saveQuote(payload) {
                return QuoteWSService.saveQuote(payload);
            }

            function validateQuote(data) {
                var payload = buildValidatePayload(data);
                return QuoteWSService.validateQuote(payload).then(function (response) {
                    return response;
                });
            }

            function findQuote(id) {
                var payload = {
                    id: id
                };
                return QuoteWSService.findQuote(payload).then(function (result) {
                    $rootScope.$emit(QuoteConstants.quoteUpdatedEvent);
                    return result;
                });

            }

            /**
             * @name saveAndCloseQuote
             * @param {*} currentQuote
             */

            function saveAndCloseCurrentQuote(quote) {
                //save current quote
                return closeQuote(quote.id).then(function () {
                    return 0;
                })
            }

            function closeQuote(id) {
                return QuoteWSService.closeQuote(id).then(function () {
                    CacheService.deleteDmsQuote();
                    $rootScope.$emit(QuoteConstants.quoteClosedEvent);
                });
            }

            /**
             * @namespace QuoteMetierService
             * @name quoteListLogic
             * @desc get quote list
             * @param {Object} filter
             * @param {Object} sort
             * @param {Object} pagination
             */
            function quoteServiceListLogic(filter, sort, pagination) {
                if (filter && filter.status) {
                    // status is the same on quote
                    if (filter.status === PartRequisitionConstants.draftStatus) {
                        filter = _.assign(_.omit(filter, 'ipn'), { lastModifierIpn: filter.ipn });
                    } else if (filter.status === PartRequisitionConstants.validatedStatus) {
                        filter = _.assign(_.omit(filter, 'ipn'), { validatorIpn: filter.ipn });
                    }
                }

                var requestBody = {
                    filter: filter || undefined,
                    sort: sort,
                    pagination: pagination
                };

                return QuoteWSService.findQuoteList(requestBody).then(function (response) {

                    return {
                        quotes: addQuotesInformations(response.estimates),
                        totalCount: response.totalCount
                    };
                });
            }


            function updateMileage(mileage) {
                var quoteInformations = getQuoteInformations();
                quoteInformations.mileAge = mileage;
                saveQuoteInformations(quoteInformations);
            }

            function updateOrderNumber(orderNumber) {
                var quoteInformations = getQuoteInformations();
                quoteInformations.orderNumber = orderNumber;
                saveQuoteInformations(quoteInformations);
            }


            /**
             * @desc return mileAge of the vehicle
             * @return {number}
             */
            function getMileage() {
                return getQuoteInformations().mileAge;
            }


            function updateQuoteTable(parts,action) {
                blockUI.start();
                var quote = getQuoteInformations();
                
                var pieceEssay = parts[0].essay;
                delete parts[0]['essay'];
                var payload = {
                    id: quote.id,
                    items: parts
                };
                
                return QuoteWSService.updateQuoteTable(payload).then(function (res) {
                    res.items.forEach(function (item) {
                        if (quote.shoppingCart.TM.length > 0) {
                            quote.shoppingCart.TM.forEach(function (quoteItem) {
                                if (item.opecod === quoteItem.opecod && item.interventionId === quoteItem.interventionId) {
                                    item.essay = quoteItem.essay;
                                }
                            })
                        }
                        if (item.opecod === parts[0].opecod && item.interventionId === parts[0].interventionId) {
                                item.essay = pieceEssay;
                        }
                    });

                        updateQuoteItemsCache(res.items);
                        $rootScope.$emit('quoteCount', res);
                        $rootScope.$emit(QuoteConstants.quoteUpdatedEvent);
                        if(action == 'ADD_OPERATIONS'){
                        $rootScope.$emit('loadIntervention', res);
                        }
                        return res;
                }).finally(function () {
                    blockUI.stop();
                });
            }

            /**
             *    @desc If a quote was open, we close it, and create a new one
             *    @return Promise<void>
             */
            function instanciateNewQuote() {
                var dmsQuote = CacheService.getDmsQuote();
                //if exist actif quote, close it and open new quote
                if (dmsQuote) {
                    return closeQuote(dmsQuote.id).then(createQuote);
                }
                //create only new quote else
                else {
                    return createQuote();
                }
            }

            /**
             * @name putQuoteItemsToPartRequisition
             * @desc put quote items to part requisition (create new part, put on actif part requsition, put on selected part requisition)
             * @param {Object} currentQuote
             */
            function putQuoteItemsToPartRequisition(currentQuote) {
                /*   for (var key in currentQuote.items) {
                       if (currentQuote.items[key].quantity % 1 != 0) {
                           currentQuote.items[key].quantity = parseInt(currentQuote.items[key].quantity) + 1;
                       }
                   }*/

                //superCartDraftModalList modal's params
                var modalParams = {
                    typeOfSuperCart: globalConstant.partRequisition,
                    title: "NEW_PARTLIST",
                    subtitle: "PARTLIST_NO_ACTIVE_DRAFT",
                    showList: true,
                    showActifPartRequisition: true
                }

                //show list of draft modal
                //according to action:
                //put quote items to new part requisition if action is createNewSuperCart,
                //put quote items to actif part requisition if action is addToActifPartRequisition,
                //put quote items to selected part requisition if action is addToSelectedSuperCart
                return listOfDraftModalService.showModal(modalParams).then(function (response) {
                    if (currentQuote && currentQuote.inter && !_.isEmpty(currentQuote.inter)) {
                        for (var items of currentQuote.inter) {
                            if (items && items.PR && !_.isEmpty(items.PR)) {
                                for (var pr of items.PR) {
                                    if (currentQuote.items) {
                                        var itemExist = _.find(currentQuote.items, function (existingPr) {
                                            return existingPr.reference === pr.reference;
                                        });
                                        if (itemExist) {
                                            itemExist.quantity += pr.quantity;
                                        } else {
                                            currentQuote.items.push(pr);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (response.action) {
                        switch (response.action) {
                            case SuperCartDraftListModalConstants.actions.addToSelectedSuperCart: {
                                putInSelectedPartRequisition(currentQuote, response.item);
                                break;
                            }
                            case SuperCartDraftListModalConstants.actions.addToActifPartRequisition: {
                                putInCurrentPartRequisition(currentQuote);
                                break;
                            }
                            case SuperCartDraftListModalConstants.actions.createNewSuperCart: {
                                putInNewPartRequisition(currentQuote);
                                break;
                            }
                        }
                    }
                });
            }

            // function updateEstimateNumber(payload){
            //     return QuoteWSService.updateEstimateNumber(payload).then(function (response) {
            //         return response;
            //     });
            // }

            function addTestOpeCod(payload) {
                var defer = $q.defer();

                var quoteList = getQuoteData();
                var quoteTM = quoteList.shoppingCart.TM;
                
                if (payload && payload.piece && payload.piece.isTestOpcode) {
                    if (quoteTM && !_.isEmpty(quoteTM)) {
                        var quoteTestTmList = [];
                        quoteTM.forEach(function (tm) {
                            if (Object.values(_essai).includes(tm.opecod)) {
                                quoteTestTmList.push(tm);
                            }
                        })
                        if (quoteTestTmList && !_.isEmpty(quoteTestTmList)) {
                            var isLowerTm = false;
                            quoteTestTmList.forEach(function (tm) {
                                var tmDuration = payload.piece.duration ? (typeof payload.piece.duration === 'string' ? parseFloat(payload.piece.duration.replace(",", ".")) : payload.piece.duration) : 0;
                                if (tmDuration < tm.laborTime) {
                                    isLowerTm = true;
                                }
                            })

                            $mdDialog.show({
                                templateUrl: 'app/components/basket/shoppingCart/testOpcodPopup.template.html',
                                controller: 'testOpcodPopupController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: false,
                                locals: {
                                    lowerTm: isLowerTm,
                                    opecod: payload.piece.id,
                                    message: "EST"
                                }
                            }).then(function () {
                                // on confirm
                                var parts = _basketTools.onAddQuantity(
                                    payload.piece,
                                    'TM'
                                );
                                updateQuoteTable(parts).then(function () {
                                    defer.resolve();
                                })
                            }).catch(function () {
                                // on cancel
                                if (!isLowerTm) {
                                    var deleteTestTm = [];
                                    if (quoteTestTmList && !_.isEmpty(quoteTestTmList)) {
                                        for (var i in quoteTestTmList) {
                                            var opeCod = _basketTools.onInputQuantity(
                                                quoteTestTmList[i],
                                                0,
                                                'TM'
                                            )
                                            deleteTestTm.push(opeCod);
                                        }
                                        if (deleteTestTm && !_.isEmpty(deleteTestTm)) {
                                            deleteTestTm.forEach(function (piece) {
                                                updateQuoteTable(piece).then(function () {
                                                });
                                            })
                                        }
                                    }
                                    var parts = _basketTools.onAddQuantity(
                                        payload.piece,
                                        'TM'
                                    );
                                    updateQuoteTable(parts).then(function () {
                                        defer.resolve();
                                    })
                                    defer.reject(2);
                                } else {
                                    defer.reject(3);
                                }
                            })
                        } else {
                            var parts = _basketTools.onAddQuantity(
                                payload.piece,
                                'TM'
                            );
                            updateQuoteTable(parts).then(function () {
                                defer.resolve();
                            })
                        }
                    } else {
                        var parts = _basketTools.onAddQuantity(
                            payload.piece,
                            'TM'
                        );
                        updateQuoteTable(parts).then(function () {
                            defer.resolve();
                        }) 
                    }
                } else {
                    var checkTestOpCode = false;
                    var request = [];
                    if (!payload.piece.essay) {

                        var addPiece = _.find(quoteTM, function (item) {
                            if (item.opecod == payload.piece.opecod) {
                                return true;
                            }
                        })
                        payload.piece.essay = addPiece.essay;
                    }

                    Object.keys(_essai).forEach(function (key) {
                        if (payload.piece.essay == key && payload.type == 'TM') {
                            request = [_essai[key]];
                            quoteTM.forEach(function (item) {
                                if (item.opecod == request) {
                                    checkTestOpCode = true;
                                }
                            });
                        }
                    })

                    if (request && !_.isEmpty(request) && !checkTestOpCode) {
                        blockUI.start();
                        DocumentsMetierService.returnTmDocumentsByOpeCode(request).then(function (response) {
                            blockUI.stop();
                            var part = _basketTools.onAddQuantity(
                                response.TM[0],
                                'TM'
                            );
                            var isTestOpecodExists = [];
                            var isTestOpcode = false;
                            quoteTM.forEach(function (piece) {
                                if (Object.values(_essai).includes(piece.opecod)) {
                                    isTestOpecodExists.push(piece);
                                }
                            })

                            if (isTestOpecodExists && !_.isEmpty(isTestOpecodExists) && isTestOpecodExists != null) {
                                var deletedTM = [];
                                if (isTestOpecodExists.length > 1) {
                                    for (var index = 0; index < isTestOpecodExists.length; index++) {
                                        if (isTestOpecodExists[index].laborTime < part[0].laborTime && isTestOpecodExists[index + 1].laborTime < part[0].laborTime) {
                                            for (var i in isTestOpecodExists) {
                                                var opeCod = _basketTools.onInputQuantity(
                                                    isTestOpecodExists[i],
                                                    0,
                                                    'TM'
                                                )
                                                deletedTM.push(opeCod);
                                            }
                                            break;
                                        } else if (isTestOpecodExists[index].laborTime < part[0].laborTime || isTestOpecodExists[index + 1].laborTime < part[0].laborTime) {
                                            var deleteOpcod = isTestOpecodExists[index].laborTime < part[0].laborTime ? isTestOpecodExists[index] : isTestOpecodExists[index + 1];
                                            var opeCod = _basketTools.onInputQuantity(
                                                deleteOpcod,
                                                0,
                                                'TM'
                                            )
                                            deletedTM.push(opeCod);
                                            isTestOpcode = true;
                                            break;
                                        }
                                    }
                                } else if (isTestOpecodExists[0].laborTime < part[0].laborTime) {
                                    var opeCod = _basketTools.onInputQuantity(
                                        isTestOpecodExists[0],
                                        0,
                                        'TM'
                                    )
                                    deletedTM.push(opeCod);
                                }
                                if (deletedTM && !_.isEmpty(deletedTM)) {
                                    deletedTM.forEach(function (piece) {
                                        updateQuoteTable(piece).then(function () {
                                        });
                                    })
                                    if (!isTestOpcode) {
                                        updateQuoteTable(part).then(function () {
                                            if (!payload.hideTestOpecodToaster) {
                                                toastr.success($translate.instant('TEST_OPECOD_' + part[0].opecod + '_QUOTE_UPDATE', { duration: '(' + part[0].laborTime + 'h)' }), { messageClass: 'toast-opecod-message' });
                                            }
                                        })
                                    }
                                }

                            } else {
                                updateQuoteTable(part).then(function () {
                                    if (!payload.hideTestOpecodToaster) {
                                        toastr.success($translate.instant('TEST_OPECOD_' + part[0].opecod + '_ADD', { duration: '(' + part[0].laborTime + 'h)' }), { messageClass: 'toast-opecod-message' });
                                    }
                                })
                            }
                            defer.resolve();
                        });
                    } else {
                        defer.resolve();
                    }
                }
                return defer.promise;
            }


            /*******************************
             *       MANAGE QUOTE ITEM     *
             ******************************/

            /**
             *  @desc
             *
             *  @param {String} action
             *  @param {Object} payload
             */

            function updateQuotePart(action, payload, genericPart) {
                const defer = $q.defer();
                let part;
                let intervention = [];
                
                const quote = CacheService.getDmsQuote();
                const isCalculated = quote && quote.isCalculated;
                
                switch (action) {
                    case _actions.ADD_ONE:
                        if (isCalculated) {
                            part = [{
                                reference: payload.piece.reference,
                                quantity: payload.piece.quantity + 1,
                                designation: payload.piece.designation,
                                genericPart: payload.piece.genericPart,
                                interventionId: payload.piece.interventionId,
                                type: payload.type
                            }];
                        } else {
                            part = _basketTools.onAddOneInQuantity(
                                payload.piece,
                                payload.type,
                                genericPart
                            );
                        }
                        break;
                    case _actions.REDUCE_ONE:
                        if (isCalculated) {
                            part = [{
                                reference: payload.piece.reference,
                                quantity: payload.piece.quantity - 1,
                                designation: payload.piece.designation,
                                genericPart: payload.piece.genericPart,
                                interventionId: payload.piece.interventionId,
                                type: payload.type
                            }];
                        } else {
                            part = _basketTools.onReduceOneInQuantity(
                                payload.piece,
                                payload.type
                            );
                        }
                        break;
                    case _actions.ADD_PIECE:
                    case _actions.ADD_QUANTITY:
                        if (payload.type == 'PR') {
                            part = _basketTools.onAddQuantity(
                                payload.piece,
                                payload.type,
                                genericPart
                            );
                       }
                        else if (payload.type == 'TM') {
                            part = _basketTools.onAddQuantity(
                                payload.piece,
                                payload.type
                            );
                        }
                        break;
                    case _actions.ADD_OPERATIONS:
                        intervention = addOperations(payload);
                        break;
                    case _actions.REDUCE_QUANTITY:
                        part = _basketTools.onReduceQuantity(
                            payload.piece,
                            payload.type
                        );
                        break;
                    case _actions.REPLACE_CART:
                        part = _basketTools.replaceShoppingCart(
                            payload
                        );
                        break;
                    case _actions.REPLACE_QUANTITY:
                        if (isCalculated) {
                            part = [{
                                reference: payload.piece.reference,
                                quantity: payload.quantity,
                                designation: payload.piece.designation,
                                genericPart: payload.piece.genericPart,
                                interventionId: payload.piece.interventionId,
                                type: payload.type
                            }];
                        } else {
                            part = _basketTools.onInputQuantity(
                                payload.piece,
                                payload.quantity,
                                payload.type
                            );
                        }
                        break;
                    default:
                        part = {};
                        break;
                }
                if (part && action && action !== 'ADD_OPERATIONS') {
                    if (part[0] == undefined) {
                        part[0] = {
                            reference: payload.piece.reference,
                            quantity: payload.quantity
                        };
                    }
                    _.extend(part[0], {
                        "index": payload.piece.index ? payload.piece.index : payload.piece.indexOfMainArray,
                        "herculesCase": payload.piece.herculesCase,
                        "plateId": payload.piece.plateId ? payload.piece.plateId : payload.piece.catalogPlate,
                        "type": payload.type
                    });
                    if (!payload.piece.isTestOpcode) {
                        updateQuoteTable(part)
                    }
                }
                else if (!_.isEmpty(intervention)) {
                  updateQuoteTable(intervention, action).then(function(){
                    if (action == 'ADD_OPERATIONS') {
                        if (payload) {
                            var tmList = payload.INT[0] && payload.INT[0].basketContent && payload.INT[0].basketContent.labourTimes ? payload.INT[0].basketContent.labourTimes : [];
                            if (tmList && !_.isEmpty(tmList)) {
                                var testMainTm = null;
                                var testTmTime = 0;
                                // essay type 3 has no opecod and wins over every other type: nothing is added automatically
                                var hasManualEssay = _.some(tmList, function (tm) {
                                    return tm.essay === '3';
                                });
                                if (!hasManualEssay) {
                                    tmList.forEach(function (tm) {
                                        if (tm.essay && Object.keys(_essai).includes(tm.essay)) {
                                            if (_testTime[tm.essay] > testTmTime) {
                                                testTmTime = _testTime[tm.essay];
                                                testMainTm = tm;
                                            }
                                        }
                                    })
                                }
                                if (testMainTm) {
                                    // the test TM is implicit when a whole intervention is added, so no toaster
                                    var testTmPayload = { piece: testMainTm, type: "TM", hideTestOpecodToaster: true };
                                    return addTestOpeCod(testTmPayload);
                                }
                            }
                        }
                    }
                  })
                }

                payload.piece.essay = (payload.piece && payload.piece.essay) ? payload.piece.essay : Object.keys(_essai).filter(function (key) { return _essai[key] === payload.piece.opecod })[0];

                if (action && (action === 'ADD_PIECE' || action === 'ADD_QUANTITY') && payload && payload.type === 'TM' && payload.piece && payload.piece.essay && payload.piece.essay !== '5' && payload.piece.essay !== '3') {
                    return addTestOpeCod(payload)
                }
                else {
                    defer.resolve();
                    return defer.promise;
                }
            }

            /**
             * @name getHourlyRate
             * @desc get hourly rate of each TM row
             * @param {Object} currentTM - TM row
             * @param {Object} hourlyRatesDMS - hourlyRates values getting by calling Hourly Rate
             */
            function getHourlyRate(currentTM, hourlyRatesDMS) {
                currentTM.hourlyRate = null;
                if (currentTM.businessSpecificities && parseFloat(currentTM.businessSpecificities.electricity.replace(",", ".")) > 0 || currentTM.businessSpecificities && parseFloat(currentTM.businessSpecificities.mechanics.replace(",", ".")) > 0) {
                    switch (currentTM.technicality) {
                        case "N":
                            currentTM.hourlyRate = hourlyRatesDMS.values.mechanicalHourlyRate;
                            break;
                        case "T":
                            currentTM.hourlyRate = hourlyRatesDMS.values.hightTechMechHourlyRate;
                            break;
                        case "H":
                            currentTM.hourlyRate = hourlyRatesDMS.values.veryHightTechMechHourlyRate;
                            break;
                    }
                } else if (currentTM.businessSpecificities && parseFloat(currentTM.businessSpecificities.trim.replace(",", ".")) > 0 || currentTM.businessSpecificities && parseFloat(currentTM.businessSpecificities.panelwork.replace(",", ".")) > 0) {
                    switch (currentTM.technicality) {
                        case "N":
                            currentTM.hourlyRate = hourlyRatesDMS.values.bodyWorkHourlyRate;
                            break;
                        case "T":
                            currentTM.hourlyRate = hourlyRatesDMS.values.hightTechBodyWHourlyRate;
                            break;
                        case "H":
                            currentTM.hourlyRate = hourlyRatesDMS.values.veryHightTechBodyWHourlyRate;
                            break;
                    }
                } else if (currentTM.businessSpecificities && parseFloat(currentTM.businessSpecificities.painting.replace(",", ".")) > 0) {
                    switch (currentTM.technicality) {
                        case "N":
                            currentTM.hourlyRate = hourlyRatesDMS.values.paintWorkHourlyRate;
                            break;
                        case "T":
                            currentTM.hourlyRate = hourlyRatesDMS.values.hightTechPaintWHourlyRate;
                            break;
                        case "H":
                            currentTM.hourlyRate = hourlyRatesDMS.values.veryHightTechPaintWHourlyRate;
                            break;
                    }
                }

                return currentTM;
            }


            /*******************************
             *          SETTER             *
             ******************************/

            function saveQuoteInformations(data) {
                if (data) {
                    data.items = _basketTools.getShoppingCart();
                    CacheService.setObject(QuoteConstants.quote, data);
                }
                return data;
            }

            function eraseQuote() {
                CacheService.removeObject(QuoteConstants.quote);
                _basketTools.clearAll();
                return getQuoteInformations();
            }

            function saveQuoteAfterCalculate(items, taxes, itemsReturned, customer, unknowPartsNotCalculated) {
                dataHolded = {
                    items: items,
                    taxes: taxes,
                    itemsReturned: itemsReturned,
                    customer: customer,
                    unknowPartsNotCalculated: unknowPartsNotCalculated
                }
                return dataHolded;
            }

            function cleanDataFromCalculate() {
                return dataHolded = {};
            }

            /*******************************
             *          GETTER             *
             ******************************/

            function getQuoteData() {
                return CacheService.getDmsQuote();
                // return angular.copy({
                //     informations: getQuoteInformations(),
                //     items: _basketTools.getShoppingCart()
                // });
            }

            function getQuoteDataAfterCalculate() {
                return angular.copy(
                    dataHolded
                );
            }


            /*******************************
             *          TOOLS             *
             ******************************/

            function getCarInformations() {
                var code = CodesConstants;
                var car = CacheService.getCarContext();
                var DMSVehicle = CacheService.getObject(CacheConstants.dmsResponse);

                var PAINT_TYPE_IS_SET = DMSVehicle && DMSVehicle.vehicle && DMSVehicle.vehicle.paintType;
                var payload = null;

                if (car) {
                    payload = {
                        vin: car.vin,
                        registrationNumber: DMSVehicle && DMSVehicle.vehicle.registrationNumber ? DMSVehicle.vehicle.registrationNumber : car.registrationNumber,
                        vehicleDesignation: car.model,
                        brand: car.fixedCriterias ? car.fixedCriterias[code.brand] : null,
                        familyVehicle: car.fixedCriterias ? car.fixedCriterias[code.familyVehicle] : null,
                        bodyType: car.fixedCriterias ? car.fixedCriterias[code.bodyType] : null,
                        engineType: car.fixedCriterias ? car.fixedCriterias[code.engineType] : null,
                        gearboxType: car.fixedCriterias ? car.fixedCriterias[code.gearboxType] : null,
                        batteryType: car.fixedCriterias ? car.fixedCriterias[code.batteryType] : null
                    }
                    if (PAINT_TYPE_IS_SET) {
                        _.assign(payload, {
                            paintType: DMSVehicle.vehicle.paintType
                        });
                    }
                }

                return payload;
            }

            /**
             * @name putInSelectedPartRequisition
             * @desc put quote items in selected part requisition
             * @param {Object} quote
             * @param {String} partRequisitionId
             */
            function putInSelectedPartRequisition(quote, partRequisitionId) {
                // format PR items
                var formattedItems = formatPRItems(quote.items);
                //quoteData (accountNumber, orderNumber) will be sent
                var quoteData = {
                    accountNumber: quote.accountNumber,
                    orderNumber: quote.orderNumber
                };

                //check if we have actif part requsition
                var currentPartRequisition = PartRequisitionMetierService.getCurrentPartRequisition();

                blockUI.start();
                $q.resolve().then(function () {
                    //if we have part requsition and the selected part requisition is different to the actif part requsition,
                    // save, unlock and close it
                    if (currentPartRequisition && currentPartRequisition.id != partRequisitionId) {
                        return PartRequisitionMetierService.saveAndCloseCurrentPartRequisition(currentPartRequisition).then(function () {
                            return PartRequisitionMetierService.unlockPartRequisitionLogic()
                        });
                    }
                }).then(function () {
                    //open the selected part requsition
                    return PartRequisitionMetierService.findPartRequisitionLogic(partRequisitionId);
                }).then(function () {
                    //get selected part requisition informations
                    var currentPartRequisition = CacheService.getObject(PartRequisitionConstants.bs);

                    //put items to part requisition
                    return putItemsToPartRequsition(currentPartRequisition, quoteData, formattedItems);
                }).then(function () {
                    //redirect to selected part requisition informations
                    $state.go(RoutesConstants.partRequisition, { view: 'list' });
                }).catch(function () {
                    toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                }).finally(function () {
                    blockUI.stop();
                });
            }

            /**
             * @name putInNewPartRequisition
             * @desc put quote items to a new part requisition
             * @param {Object} quote
             */
            function putInNewPartRequisition(quote) {
                //quoteData (accountNumber, orderNumber) will be sent
                var quoteData = {
                    accountNumber: quote.accountNumber,
                    orderNumber: quote.orderNumber
                };

                //format PR items
                var formattedItems = formatPRItems(quote.items, SuperCartDraftListModalConstants.actions.createNewSuperCart);

                //if not having part requisition, create a new part requisition using quote's PR items
                var currentPartRequisition = PartRequisitionMetierService.getCurrentPartRequisition();

                blockUI.start();
                $q.resolve().then(function () {
                    //if having part requisition, save and close it
                    if (currentPartRequisition) {
                        return PartRequisitionMetierService.saveAndCloseCurrentPartRequisition(currentPartRequisition).then(function () {
                            return PartRequisitionMetierService.unlockPartRequisitionLogic();
                        })
                    }
                }).then(function () {
                    //create a new part requisition using quote's PR items
                    return PartRequisitionMetierService.initPartRequisition(formattedItems, quoteData);
                })
                /*.then(function () {
                    const pr = CacheService.getObject(PartRequisitionConstants.bs);
                    if (pr && pr.id && quote.number) {
                        return updateEstimateNumber({ id: pr.id, estimateNumber: quote.number });
                    }
                })*/
                .then(function () {
                    //redirect to created part requisition informations
                    $state.go(RoutesConstants.partRequisition, { view: 'list' });
                }).catch(function () {
                    toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                }).finally(function () {
                    blockUI.stop();
                });

            }

            /**
             * @name putInCurrentPartRequisition
             * @desc put quote items to the current part requsition items
             * @param {Object} quote
             */
            function putInCurrentPartRequisition(quote) {

                //format PR items
                var formattedItems = formatPRItems(quote.items);

                //quoteData (accountNumber, orderNumber) will be sent
                var quoteData = {
                    accountNumber: quote.accountNumber,
                    orderNumber: quote.orderNumber
                };

                //get current part requisition
                var currentPartRequisition = CacheService.getObject(PartRequisitionConstants.bs);

                blockUI.start();
                $q.resolve().then(function () {
                    //put items to part requisition
                    return putItemsToPartRequsition(currentPartRequisition, quoteData, formattedItems);
                })
                /*.then(function () {
                    const pr = CacheService.getObject(PartRequisitionConstants.bs);
                    if (pr && pr.id && quote.number) {
                        return updateEstimateNumber({ id: pr.id, estimateNumber: quote.number });
                    }
                })*/
                .then(function () {
                    //redirect to actif part requisition informations
                    $state.go(RoutesConstants.partRequisition, { view: 'list' });
                }).catch(function () {
                    toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                }).finally(function () {
                    blockUI.stop();
                });

            }

            /**
             * @name putItemsToPartRequsition
             * @desc put items to part requsiition
             * @param {Object} PRItems
             * @param {Object} quote
             * @param {Object} partRequisition
             */

            function putItemsToPartRequsition(partRequisition, quote, PRItems) {
                var currentRefs = [];

                //parse all PR items
                PRItems.forEach(function (item) {

                    //check if quote PR item exist in part requsition items
                    var itemExist = _.find(partRequisition.items, function (currentItemFromPartRequisition) {
                        return currentItemFromPartRequisition.reference === item.reference;
                    });

                    //if quote PR item exist in part requisition items,
                    //replace quantity with the calculated quantity
                    if (itemExist) {
                        item.quantity += itemExist.quantity;
                        ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.REPLACE_QUANTITY, {
                            piece: item,
                            quantity: item.quantity,
                            type: 'PR'
                        });
                    }

                    //if quote PR item doesn't exist in part requisition items,
                    //add new piece with the quantity
                    else {
                        ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                            piece: item,
                            type: 'PR',
                            existingQuantity: item.quantity
                        });
                    }

                    //add item to list
                    currentRefs.push(item.reference);
                });

                //update bs items
                return PartRequisitionMetierService.onUpdateCart(PRItems, quote);
            }


            /**
             * @namespace QuoteMetierService
             * @name addQuotesInformations
             * @desc add context car vehicle informations
             * @param {Array} quoteList
             */
            function addQuotesInformations(quoteList) {

                var _searchBy = QuoteConstants.searchBy;
                quoteList.map(function (currentPartRequisition) {
                    var vehiculeLabel = '';
                    var searchBy = 0;

                    if (currentPartRequisition.vin) {
                        vehiculeLabel = currentPartRequisition.vin
                        searchBy = _searchBy.vin;
                        if (currentPartRequisition.registrationNumber) {
                            vehiculeLabel += ' | ' + currentPartRequisition.registrationNumber
                        }
                    } else if (currentPartRequisition.registrationNumber) {
                        vehiculeLabel = currentPartRequisition.registrationNumber
                        searchBy = _searchBy.registrationNumber;
                    } else if (currentPartRequisition.brand) {
                        vehiculeLabel = currentPartRequisition.familyVehicle + ', ' + currentPartRequisition.bodyType + ', ' + currentPartRequisition.engineType + ', ' + currentPartRequisition.gearboxType
                        searchBy = _searchBy.model;
                    }

                    currentPartRequisition.vehiculeLabel = vehiculeLabel;
                    currentPartRequisition.searchBy = searchBy;

                    /* const linkedPR = currentPartRequisition.partsRequisitions &&
                        currentPartRequisition.partsRequisitions.find(function (pr) { return pr.rpsOrderId; });
                    currentPartRequisition.rpsOrderId = linkedPR ? linkedPR.rpsOrderId : null;*/
                    return currentPartRequisition;
                });
                return quoteList;
            }


            function buildValidatePayload(data) {
                var payload = {
                    id: data.quote.id,
                    dmsEstimateId: data.quote.dmsEstimateId,
                    estimateUserId: data.quote.estimateUserId,
                    mileAge: data.quote.mileAge,
                    basis: data.taxesReturned.global.basis,
                    exclTaxes: data.taxesReturned.global.exclTaxes,
                    taxes: data.taxesReturned.global.taxes,
                    total: data.taxesReturned.global.total,
                    isUncalculatedParts: data.quote.isUncalculatedParts,
                    totalPaintAmount: data.taxesReturned.totalPaintAmount,
                    paintTime: data.taxesReturned.paintTime,
                    basisSuppliesAmount: data.taxesReturned.basisSuppliesAmount,
                    totalSuppliesAmount: data.taxesReturned.totalSuppliesAmount,
                    recyclingExclTaxes: data.taxesReturned.recycling ? data.taxesReturned.recycling.exclTaxes : null,
                    recyclingTotal: data.taxesReturned.recycling ? data.taxesReturned.recycling.total : null,
                    items: formatItemsForBack(data.quote.items, data.itemsReturned, data.quote.inter),
                    operationTotal: data.quote.interItemsTax ? data.quote.interItemsTax : null
                }

                if (data.quote.userScale) {
                    _.extend(payload, {
                        userScale: data.quote.userScale
                    })
                }
                if (data.taxesReturned.labourTimes) {
                    _.extend(payload, {
                        tmSummary: {
                            total: data.taxesReturned.labourTimes.total, //tm total
                            exclTaxes: data.taxesReturned.labourTimes.exclTaxes, //tm exlTaxes
                            taxes: data.taxesReturned.labourTimes.taxes, //tm taxes
                            basis: data.taxesReturned.labourTimes.basis //tm basis
                        }
                    });
                } else {
                    _.extend(payload, {
                        tmSummary: {
                            total: null, //tm total
                            exclTaxes: null, //tm exlTaxes
                            taxes: null, //tm taxes
                            basis: null //tm basis
                        }
                    });
                }

                if (data.taxesReturned.parts) {
                    _.extend(payload, {
                        prSummary: {
                            total: data.taxesReturned.parts.total, //estimate total
                            exclTaxes: data.taxesReturned.parts.exclTaxes, //estimate exlTaxes
                            taxes: data.taxesReturned.parts.taxes, //estimate taxes
                            basis: data.taxesReturned.parts.basis //estimate basis
                        }
                    });
                } else {
                    _.extend(payload, {
                        prSummary: {
                            total: null, //estimate total
                            exclTaxes: null, //estimate exlTaxes
                            taxes: null, //estimate taxes
                            basis: null //estimate basis
                        }
                    });
                }


                return payload;
            }

            function restoreStructQuoteValidate(quote) {
                var recycling = {
                    total: quote.recyclingTotal,
                    exclTaxes: quote.recyclingExclTaxes
                }

                var items = formatItemsForFront(quote.items)

                // hack to avoid items inside obj.quote.informations, see below
                delete quote.items;

                var obj = {
                    quote: {
                        items: items,
                        informations: quote
                    },
                    taxesReturned: {
                        global: {
                            exclTaxes: quote.exclTaxes,
                            taxes: quote.taxes,
                            basis: quote.basis,
                            total: quote.total
                        },
                        parts: {
                            basis: quote.prSummary.basis,
                            exclTaxes: quote.prSummary.exclTaxes,
                            taxes: quote.prSummary.taxes,
                            total: quote.prSummary.total
                        },
                        labourTimes: {
                            basis: quote.tmSummary.basis,
                            exclTaxes: quote.tmSummary.exclTaxes,
                            taxes: quote.tmSummary.taxes,
                            total: quote.tmSummary.total
                        },
                        totalPaintAmount: quote.totalPaintAmount,
                        paintTime: quote.paintTime,
                        mileage: quote.mileage,
                        basisSuppliesAmount: quote.basisSuppliesAmount,
                        totalSuppliesAmount: quote.totalSuppliesAmount
                    }
                }

                if (recycling.total || recycling.exclTaxes) {
                    obj.taxesReturned.recycling = recycling;
                }

                return obj;
            }


            /**
             * @namespace QuoteMetierService
             * @name unlockQuoteLogic
             * @desc unlock parts requisitions updated by the current user
             */
            function unlockQuoteLogic() {
                return QuoteWSService.unlockQuote().then(function (response) {
                    if (response.status === 200) {
                        return response.unlockCarts;
                    }
                })
            }

            /**
             * @name getAccountNumber
             * @desc get user accountNumber's
             * @return {number | null}
             */

            function getAccountNumber() {
                var carSearchContext = CacheService.getCarSearchContext();
                if (carSearchContext && carSearchContext.accountNumber) {
                    return carSearchContext.accountNumber;
                }


                return null;
            }

            function getOrdersAndSplits() {
                var carSearchContext = CacheService.getCarSearchContext();

                if (carSearchContext && carSearchContext.ordersAndSplits) {
                    return carSearchContext.ordersAndSplits;
                }

                return null;
            }


            function formatItemsForFront(items) {
                return items.map(function (item) {
                    if (item.type === 'TM') {
                        return {
                            type: "TM",
                            reference: item.reference,
                            opecod: item.opecod,
                            designation: item.designation,
                            laborTime: item.laborTime,
                            hourlyRate: item.hourlyRate,
                            totalPriceExclTaxes: item.exclTaxes,
                            quantity: item.quantity,
                            discountRate: item.discountRate
                        }
                    } else if (item.type === 'PR') {
                        return {
                            type: "PR",
                            reference: item.reference,
                            designation: item.designation,
                            quantity: item.quantity,
                            discountRate: item.discountRate,
                            dmsInformations: {
                                priceExclTaxes: item.price,
                                cort: item.codeTaxe
                            },
                            totalPriceExclTaxes: item.exclTaxes
                        }
                    }
                })
            }

            /**
             * @desc function in order to format the items to meet the expectations of the back end
             * @param {*} items the list of items added to the estimate
             * @param {*} newItems the list of additionnal items returned by dms after estimate request
             * @param {*} inter the list of intervention items 
             */
            function formatItemsForBack(items, newItems, inter) {

                var formatedItemsCompiled = [];
                angular.forEach(items, function (value) {
                    var item = {
                        type: value.type,
                        designation: value.designation,
                        laborTime: parseFloat(value.laborTime),
                        hourlyRate: value.hourlyRate,
                        basis: value.basis ? value.basis : value.price,
                        exclTaxes: value.totalPriceExclTaxes,
                        taxes: value.taxes,
                        reference: value.reference,
                        total: value.total,
                        codeTaxe: value.cort,
                        price: value.price,
                        id: value.id,
                        isDeposit: false,
                        interventionId: value.interventionId
                    }

                    // if (value.dmsInformations) {
                    //     item.codeTaxe = value.dmsInformations.cort;
                    //     item.price = value.dmsInformations.priceExclTaxes;
                    // }

                    if (item.type === 'TM') {
                        item.opecod = value.opecod;
                    }
                    if (value.discountRate) {
                        item.discountRate = value.discountRate;
                    }

                    formatedItemsCompiled.push(item)

                });

                angular.forEach(newItems.PR, function (value) {
                    var item = {
                        type: "PR",
                        reference: value.reference,
                        quantity: value.quantity,
                        designation: value.designation,
                        codeTaxe: value.cort,
                        basis: value.amount.basis,
                        exclTaxes: value.amount.exclTaxes,
                        taxes: value.amount.taxes,
                        total: value.amount.total,
                        id: value.id,
                        isDeposit: true,
                        interventionId: value.interventionId
                    }
                    formatedItemsCompiled.push(item)
                });

                angular.forEach(inter, function (data) {
                    if(!_.isEmpty(data.itemsReturnedPR)){
                        data.itemsReturnedPR.forEach(function (value){
                            var item = {
                                type: "PR",
                                reference: value.reference,
                                quantity: value.quantity,
                                designation: value.designation,
                                codeTaxe: value.cort,
                                basis: value.amount.basis,
                                exclTaxes: value.amount.exclTaxes,
                                taxes: value.amount.taxes,
                                total: value.amount.total,
                                id: value.id,
                                isDeposit: true,
                                interventionId: value.depositInterId,
                                interventionDesignation : value.interventionDesignation    
                            }
                            formatedItemsCompiled.push(item)
    
                        })
                    }                    
                });

                angular.forEach(newItems.TM, function (value) {
                    var item = {
                        type: "TM",
                        reference: value.code,
                        quantity: value.quantity,
                        designation: value.designation,
                        laborTime: parseFloat(value.laborTime),
                        basis: value.amount.basis,
                        exclTaxes: value.amount.exclTaxes,
                        taxes: value.amount.taxes,
                        total: value.amount.total,
                        id: value.id,
                        isDeposit: true,
                        interventionId: value.interventionId
                    }
                    formatedItemsCompiled.push(item)
                });
                return formatedItemsCompiled;
            }

            /**
             * @name formatPRItems
             * @desc format PR items
             * @param {Array} quotesItems
             */
            function formatPRItems(quotesItems, action) {

                var formattedItemsQuotes = quotesItems.filter(getPRItems).map(function (item) {

                    var itemPartsRequisition = {
                        "currency": item.currency,
                        "designation": item.designation,
                        "price": item.priceHT,
                        "quantity": item.quantity,
                        "reference": item.reference,
                        "reach": item.reach

                    };
                    //add order type attribut when action is create new parts requisition
                    if (action === SuperCartDraftListModalConstants.actions.createNewSuperCart) {
                        var ENOUGH_QUANTITY = _.isNumber(_.get(item, 'dmsInformations.quantity')) && item.dmsInformations.quantity >= item.quantity;
                        if (ENOUGH_QUANTITY) {
                            itemPartsRequisition.orderType = 0;
                        } else {
                            itemPartsRequisition.orderType = 2;
                        }
                    }

                    return itemPartsRequisition;
                })
                return formattedItemsQuotes;
            }

            /**
             * @name getPRItems
             * @desc get only PR items
             * @param {*} item
             */
            function getPRItems(item) {
                if (item.type === "PR" && !item.isDeposit) {
                    return item;
                }
            }


            /**
                    *  @desc Will call the service layer in order to generate the pdf file based on information included in the
                    *  vm.cartMetadata, vm.panier and vm.vehicle
                    *  Basically those contains almost every data that are display in the list basket page
                    *
                    *  We construct the payload that we will send to the backend controller
                    *  cartToPrint will contain the content of the parameters such as cartMetadata, basket, vehicle
                    *  but we also add translatedLabels, those are the translated label that we can see in the view and that we
                    *  want to display in the pdf
                    *
                    *  @param  cartMetadata : information regarding the basket (creation, modification date ...)
                    *  @param  basket : list of TM and PR entries that we want to display in the pdf
                    *  @param  vehicle : information regarding the vehicle such as VIN, plante number, model ...
                    *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
                    *  @param  {String} status : the status of the superCart (draft, validated)
                    *  @return promise
                    */
        
            function downloadPdf(showRef, cartMetadata, basket, vehicle, type, status) {
                var cartToPrint = {

                    cartMetaData: cartMetadata,
                    superCartNode: {
                        superCart: basket,
                        type: type,
                        statut: status
                    },
                    vehicle: vehicle,
                    translatedLabels: {
                        documentTmTime: $translate.instant("DOCUMENT_TM_TIME"),
                        documentTmlabourTimes: $translate.instant("COMMON_COLUMN_HRATE_TITLE"),
                        columnRef: $translate.instant("COMMON_COLUMN_REF_TITLE"),
                        columnDesignation: $translate.instant("COMMON_DESIGNATION"),
                        columnQuantity: $translate.instant("COMMON_COLUMN_QTE_TITLE"),
                        codeTm: $translate.instant("CODE_TM"),
                        columnPUBHT: $translate.instant("COMMON_COLUMN_PUBHT_TITLE"),
                        documentTmTitle: $translate.instant("COMMON_COLUMN_LABEL_TITLE"),
                        documentTmQuantity: $translate.instant("COMMON_COLUMN_QTE_TITLE"),
                        columnMNHT: $translate.instant("COMMON_COLUMN_MNT_NETHT_TITLE"),
                        columnCT: $translate.instant("COMMON_COLUMN_CT_TITLE"),
                        category: $translate.instant("ESTIMATE_CATEGORY_LABEL"),
                        brutHT: $translate.instant("ESTIMATE_CATEGORY_BRUTHT"),
                        netHT: $translate.instant("ESTIMATE_CATEGORY_NETHT"),
                        totalTaxe: $translate.instant("ESTIMATE_TOTAL_TAX"),
                        totalTTC: $translate.instant("ESTIMATE_TOTAL_TTC"),
                        documentBasketTitle: $translate.instant("LOCATION_ESTIM"),
                        isNonCalculatedParts: $translate.instant("WARNING_CALCULATED"),
                        userScale: $translate.instant("ADMIN_FAMILY_CLIENT") + " : ",
                        itemTotal: $translate.instant("COMMON_TOTAL_HT"),
                        discountRate: $translate.instant("COMMON_COLUMN_REMISE_TITLE")
                    }
                };

                var userProfile = CacheService.getObject(CacheConstants.profil);
                var creationDateTime = moment(cartMetadata.creationDateTime).format("YYYY/MM/DD");
                var lastModificationDateTime = moment(cartMetadata.lastModificationDateTime).format("YYYY/MM/DD");

                var pr = _.filter(basket, function (item) {
                    if (item.type === "PR") {
                        if (item.dmsInformations) {
                            // item.cort = item.dmsInformations.cort;
                            item.priceHT = item.dmsInformations.priceExclTaxes
                                ? item.dmsInformations.priceExclTaxes
                                : item.priceHT;
                        }
                        if (item.codeTaxe) {
                            item.cort = item.codeTaxe;
                        }
                        return item;
                    }
                });
                var tm = _.filter(basket, function (item) {
                    if (item.type === "TM") {
                        return item;
                    }
                });

                basket = {};
                basket.pr = pr;
                basket.tm = tm;
                basket.inter = cartToPrint.cartMetaData.inter;
                basket.taxesReturnedPrTm = calculatePrTMTotal(cartMetadata);
                cartToPrint.superCartNode.superCart = basket;

                var userContext = CacheService.getUserContext();
                if (userContext && userContext.countryCode) {
                    _.extend(cartToPrint.cartMetaData, {
                        countryCode: userContext.countryCode
                    });
                }
                var header = userProfile.header;
                if (header) {
                    _.extend(cartToPrint.cartMetaData, {
                        header: header
                    });
                }

                if (cartToPrint.cartMetaData.status === "VALID") {
                    var validationDateTime = $filter('localTimeFilter')(cartToPrint.cartMetaData.validationDateTime);
                    _.extend(cartToPrint.cartMetaData, {
                        validationDateTime: validationDateTime
                    });

                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber: $translate.instant("LABEL_NUM_ESTIMATE") + " " + cartMetadata.number +" / "+cartMetadata.dmsEstimateId,
                        superCartValidationDate: $translate.instant("ESTIMATE_VALIDATED_DATE") + " " + cartMetadata.validationDateTime +
                            " " + $translate.instant("ACTION_BY") + " " + cartMetadata.creatorIPN
                    });

                } else {
                    _.extend(cartToPrint.cartMetaData, {
                        creationDateTime: creationDateTime,
                        lastModificationDateTime: lastModificationDateTime
                    });

                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber: $translate.instant("LABEL_NUM_ESTIMATE") + " " + cartMetadata.number,
                        superCartCreationDate: $translate.instant("ESTIMATION_CREATE_DATE") + " " + cartMetadata.creationDateTime +
                            " " + $translate.instant("ACTION_BY") + " " + cartMetadata.creatorIPN,
                        superCartLastModificationDate: $translate.instant("ESTIMATION_UPDATE_DATE") + " " + cartMetadata.lastModificationDateTime +
                            " " + $translate.instant("ACTION_BY") + " " + cartMetadata.creatorIPN
                    });
                }

                // else {
                //     var currency = UtilsMetierService.getCurrencyForItem();
                //     if (currency) {
                //         cartToPrint.cartMetaData.currency = currency;
                //     }

                //     var sortedBasket = {};
                //     sortedBasket.pr = basket.pr;
                //     sortedBasket.tm = basket.tm;
                //     cartToPrint.superCartNode.superCart = sortedBasket;
                // }
                formatItemsToFitPrintPayload(cartToPrint.superCartNode.superCart);
                if (cartMetadata.quoteStatus === "CalculatedQuote") {
                    formatCalculedDataToFitPrintPayload(cartMetadata.calculedQuoteData);
                    formatCalculedDataToFitPrintPayload(cartMetadata.totalCalculatedQuote);
                }
                return formatDataToPrint(cartToPrint, showRef);
            }

            function formatItemsToFitPrintPayload(items) {
                angular.forEach(items.pr, function (value) {
                    if (value.priceHT && typeof value.priceHT === "number") {
                        value.priceHT = value.priceHT.toFixed(2)
                    } else if (value.price && typeof value.price === "number") {
                        value.priceHT = value.price.toFixed(2)
                    }
                    value.price = value.priceHT;
                    // else if(value.exclTaxes  && typeof value.exclTaxes === "number"){
                    //     value.priceHT = value.exclTaxes.toFixed(2);
                    // }
                    if (value.total && typeof value.total === "number") {
                        value.total = value.total.toFixed(2)
                    }
                    if (value.taxes && typeof value.taxes === "number") {
                        value.taxes = value.taxes.toFixed(2)
                    }
                    if (value.totalPriceExclTaxes && typeof value.totalPriceExclTaxes === "number") {
                        value.totalPriceExclTaxes = value.totalPriceExclTaxes.toFixed(2)
                    }
                });
                angular.forEach(items.tm, function (value) {
                    if (value.priceHT && typeof value.priceHT === "number") {
                        value.priceHT = value.priceHT.toFixed(2)
                    }
                    if (value.total && typeof value.total === "number") {
                        value.total = value.total.toFixed(2)
                    }
                    if (value.taxes && typeof value.taxes === "number") {
                        value.taxes = value.taxes.toFixed(2)
                    }
                    if (value.totalPriceExclTaxes && typeof value.totalPriceExclTaxes === "number") {
                        value.totalPriceExclTaxes = value.totalPriceExclTaxes.toFixed(2)
                    }
                });
            }

            function formatCalculedDataToFitPrintPayload(items) {
                angular.forEach(items, function (value) {
                    if (value.basis && typeof value.basis === "number") {
                        value.basis = value.basis.toFixed(2)
                    }
                    if (value.exclTaxes && typeof value.exclTaxes === "number") {
                        value.exclTaxes = value.exclTaxes.toFixed(2)
                    }
                    if (value.taxes && typeof value.taxes === "number") {
                        value.taxes = value.taxes.toFixed(2)
                    }

                    if (value.total && typeof value.total === "number") {
                        value.total = value.total.toFixed(2)
                    }
                });
            }
            function formatDataToPrint(data, showRef) {

                var deferred = $q.defer();
                var dataArray = [];
                var finalArr = [];

                var firstObj = { type: "columns", values: {}, styles: "textStyle" };

                var headers = data.cartMetaData.header ? data.cartMetaData.header.split("\n") : [];

                var secondArr = [];
                secondArr.push("\n");
                secondArr.push(data.translatedLabels.superCartNumber);
                if (data.cartMetaData.status === "DRAFT") {
                    secondArr.push(data.translatedLabels.superCartCreationDate);
                    secondArr.push(data.translatedLabels.superCartLastModificationDate);
                } else if (data.cartMetaData.status === "VALID") {
                    secondArr.push(data.translatedLabels.superCartValidationDate);
                }
                secondArr.push("\n");
                secondArr.push(data.cartMetaData.client);
                secondArr.push(data.cartMetaData.clientAdress);
                secondArr.push(data.cartMetaData.clientAdressEnd);
                secondArr.push(data.cartMetaData.clientAdressPhoneAndMail);

                if(data.cartMetaData.userScale && data.cartMetaData.userScale != ''){
                    secondArr.push(data.translatedLabels.userScale+" "+data.cartMetaData.userScale);
                }

                var whichArray = secondArr.length > headers.length ? secondArr : headers;

                angular.forEach(whichArray, function (val, i) {
                    firstObj.values[i] = [secondArr[i] ? secondArr[i] : "", headers[i] ? headers[i] : ""];
                })

                dataArray.push(firstObj);

                var descTable = [
                    {
                        column1: {
                            data: data.cartMetaData.description ? data.cartMetaData.description : ""
                        }
                    }
                ]

                var descObj = {
                    type: "table", values: getTableData(descTable, false), styles: "descTableStyle",
                    layout: "descTableLayout", widths: [480]
                };

                if (data.cartMetaData.description) {
                    dataArray.push(descObj);
                }

                
                
                var mentionsTable = [
                    {
                        column1: {
                            data: data.cartMetaData.mentions ? data.cartMetaData.mentions : ""
                        }
                    }
                ]

                var mentionsObj = {
                    type: "table", values: getTableData(mentionsTable, false), styles: "descTableStyle",
                    layout: "descTableLayout", widths: [480]
                };

                if (data.cartMetaData.mentions) {
                    dataArray.push(mentionsObj);
                }

                var rgpdObj = { type: "rgpd", values:{0: [ $translate.instant("RGPD_MESSAGE") ]}, styles: "rgpdStyle"};

                dataArray.push(rgpdObj);

                
                var columnData1 = data.vehicle ? dataConcatenation(data.vehicle.model, data.vehicle.engineDesignation, " , ") : "";

                columnData1 = data.vehicle ? dataConcatenation(columnData1, data.vehicle.motorisation, " , ") : "";

                columnData1 = data.vehicle ? dataConcatenation(columnData1, data.vehicle.gearBoxType, " , ") : "";

                var columnData2 = data.vehicle ? dataConcatenation(data.vehicle.vin, data.vehicle.registrationNumber, " | ") : "";

                var columnData3 = dataConcatenation(data.cartMetaData.mileAge ? data.cartMetaData.mileAge +" Km/Miles": '', (data.cartMetaData.orderNumber != '-'? data.cartMetaData.orderNumber: ''), " | ");

                var secondTable = [
                    {
                        column1: {
                            data: columnData1,
                            alignment: "left"
                        },
                        column2: {
                            data: columnData2,
                            alignment: "left"
                        },
                        column3: {
                            data: columnData3,
                            alignment: "left"
                        }
                    }
                ];

                var secondObj = {
                    type: "table", values: getTableData(secondTable, false), styles: "secondTableHeader",
                    layout: "secondTableLayout", widths: [160, 150, 150]
                };

                if (data.vehicle || data.cartMetaData.orderNumber) {
                    dataArray.push(secondObj);
                }

                var interList = data.superCartNode.superCart.inter;

                if (interList && interList.length > 0) {

                    var operTable = [
                        {
                            column1: {
                                data: "Operation"
                            }
                        }
                    ]
                    var operObj = {
                        type: "table", values: getTableData(operTable, false), styles: "tableStyle",
                        layout: "thirdTableLayout", widths: [480]
                    };


                    dataArray.push(operObj);


                    interList.forEach(function (inter) {

                        var operHeader = [
                            {
                                column1: {
                                    data: inter.designation
                                }
                            }
                        ]
                        var operHeaderObj = {
                            type: "table", values: getTableData(operHeader, false), styles: "tableStyle",
                            layout: "thirdTableLayout", widths: [480]
                        };

                        dataArray.push(operHeaderObj);

                        if (inter.PR.length > 0) {



                            var operPR = [
                                {
                                    column1: {
                                        data: 'PR'
                                    }
                                }
                            ]
                            var operPRHeader = {
                                type: "table", values: getTableData(operPR, false), styles: "tableStyle",
                                layout: "thirdTableLayout", widths: [480]
                            };

                            dataArray.push(operPRHeader);

                            var filteredData = inter.PR.map(function (item) {
                                var tableData = [];
                                tableData[data.translatedLabels.columnRef] =
                                {
                                    data: showRef ? $filter('filterFormatRef')(item.reference) : '',
                                    alignment: "left"
                                };
                                tableData[data.translatedLabels.columnDesignation] =
                                {
                                    data: UtilsMetierService.replaceEmptyString(item.designation, "-"),
                                    alignment: "left"
                                };
                                tableData[data.translatedLabels.columnCT] =
                                {
                                    data: item.cort ? item.cort : item.codeTaxe,
                                    alignment: "center"
                                };
                                tableData[data.translatedLabels.columnPUBHT] =
                                {
                                    data: currencyConcat(item.priceHT ? item.priceHT : item.price, data.cartMetaData.currency),
                                    alignment: "right"
                                };
                                tableData[data.translatedLabels.columnQuantity] =
                                {
                                    data: item.quantity,
                                    alignment: "center"
                                };
                                if (data.cartMetaData.calculedQuoteData && data.cartMetaData.showDiscountRatePR) {
                                    tableData[data.translatedLabels.discountRate] =
                                    {
                                        data: (item.discountRate) ? "" + item.discountRate + ".00%" : '-',
                                        alignment: "center"
                                    };
                                }
                                tableData[data.translatedLabels.columnMNHT] =
                                {
                                    data: currencyConcat(item.totalPriceExclTaxes ? item.totalPriceExclTaxes : item.exclTaxes, data.cartMetaData.currency),
                                    alignment: "right"
                                };

                                return tableData;
                            })
                            var operPRObj = []

                            operPRObj = {
                                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                                layout: "otherTableLayout", widths: (data.cartMetaData.calculedQuoteData && data.cartMetaData.showDiscountRatePR) ? [70, 140, 50, 40, 40, 40, 50] : [70, 160, 50, 50, 50, 60]
                            };

                            dataArray.push(operPRObj);

                            if (inter.itemsReturnedPR && inter.itemsReturnedPR.length > 0){
                                
                                var filteredData = inter.itemsReturnedPR.map(function (item) {
                                    var tableData = [];
                                    tableData[data.translatedLabels.columnRef] =
                                    {
                                        data: showRef ? $filter('filterFormatRef')(item.reference) : '',
                                        alignment: "left"
                                    };
                                    tableData[data.translatedLabels.columnDesignation] =
                                    {
                                        data: UtilsMetierService.replaceEmptyString(item.designation, "-"),
                                        alignment: "left"
                                    };
                                    tableData[data.translatedLabels.columnCT] =
                                    {
                                        data: item.cort ? item.cort : item.codeTaxe,
                                        alignment: "center"
                                    };
                                    tableData[data.translatedLabels.columnPUBHT] =
                                    {
                                        data: currencyConcat(item.priceExclTaxes, data.cartMetaData.currency),
                                        alignment: "right"
                                    };
                                    tableData[data.translatedLabels.columnQuantity] =
                                    {
                                        data: item.quantity,
                                        alignment: "center"
                                    };
                                    if (data.cartMetaData.calculedQuoteData && data.cartMetaData.showDiscountRatePR) {
                                        tableData[data.translatedLabels.discountRate] =
                                        {
                                            data: (item.discountRate) ? "" + item.discountRate + ".00%" : '-',
                                            alignment: "center"
                                        };
                                    }
                                    tableData[data.translatedLabels.columnMNHT] =
                                    {
                                        data: currencyConcat(item.priceExclTaxes, data.cartMetaData.currency),
                                        alignment: "right"
                                    };
    
                                    return tableData;
                                })

                                var operPRItemReturned = [];
                                operPRItemReturned = _.flatMap(getTableData(filteredData, false));
                                operPRObj.values.push(operPRItemReturned);
                            }
                            

                        }

                        if (inter.TM.length > 0) {

                            var fifthTable = [
                                {
                                    column1: {
                                        data: "TM"
                                    }
                                }
                            ]

                            var fifthObj = {
                                type: "table", values: getTableData(fifthTable, false), styles: "tableStyle",
                                layout: "thirdTableLayout", widths: [480]
                            };


                            dataArray.push(fifthObj);

                            var operTm = inter.TM;

                            var tmFilteredData = operTm.map(function (item) {
                                var tableData = [];
                                tableData[data.translatedLabels.codeTm] =
                                {
                                    data: UtilsMetierService.replaceEmptyString(item.opecod, ""),
                                    alignment: "left"
                                };
                                tableData[data.translatedLabels.documentTmTitle] =
                                {
                                    data: UtilsMetierService.replaceEmptyString(item.designation, ""),
                                    alignment: "left"
                                };
                                tableData[data.translatedLabels.documentTmTime] =
                                {
                                    data: (item.laborTime && item.laborTime != '-') ? item.laborTime : "-",
                                    alignment: "center"
                                };
                                tableData[data.translatedLabels.documentTmlabourTimes] =
                                {
                                    data: currencyConcat((!item.hourlyRate ? item.exclTaxes : item.hourlyRate), data.cartMetaData.currency),
                                    alignment: "right"
                                };
                                tableData[data.translatedLabels.columnQuantity] =
                                {
                                    data: item.quantity,
                                    alignment: "center"
                                };
                                tableData[data.translatedLabels.columnMNHT] =
                                {
                                    data: currencyConcat(item.totalPriceExclTaxes ? item.totalPriceExclTaxes : item.exclTaxes, data.cartMetaData.currency),
                                    alignment: "right"
                                };

                                return tableData;
                            })

                            var sixthObj = {};

                            sixthObj = {
                                type: "table", values: getTableData(tmFilteredData, true), styles: "tableStyle",
                                layout: "otherTableLayout", widths: [70, 160, 50, 50, 50, 60]
                            };

                            dataArray.push(sixthObj);

                        }


                    })
                    if (data.superCartNode.superCart.inter && data.superCartNode.superCart.inter.length > 0 && data.cartMetaData.interItemsTax) {
                        var interTotal = [];
                        interTotal.push({
                            column1: {
                                data: data.translatedLabels.itemTotal + " " + data.cartMetaData.interItemsTax.toFixed(2) + " " + data.cartMetaData.currency,
                                        alignment: "right"
                                    }
                                })
                        var subTotalInterObj = {
                            type: "table", values: getTableData(interTotal, false), styles: "withoutMargin",
                            layout: "otherTableLayout", widths: [485]
                        };
                        
                            dataArray.push(subTotalInterObj);
                    }
                }

                var thirdTable = [
                    {
                        column1: {
                            data: "PR"
                        }
                    }
                ]

                var thirdObj = {
                    type: "table", values: getTableData(thirdTable, false), styles: "tableStyle",
                    layout: "thirdTableLayout", widths: [480]
                };
                if (data.superCartNode.superCart.pr.length > 0)
                    dataArray.push(thirdObj);

                var fourthTable = data.superCartNode.superCart.pr;

                var filteredData = fourthTable.map(function (item) {
                    var tableData = [];
                    tableData[data.translatedLabels.columnRef] =
                    {
                        data: showRef ? $filter('filterFormatRef')(item.reference) : '',
                        alignment: "left"
                    };
                    tableData[data.translatedLabels.columnDesignation] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.designation, "-"),
                        alignment: "left"
                    };
                    tableData[data.translatedLabels.columnCT] =
                    {
                        data: item.cort,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.columnPUBHT] =
                    {
                        data: currencyConcat(item.priceHT, data.cartMetaData.currency),
                        alignment: "right"
                    };
                    tableData[data.translatedLabels.columnQuantity] =
                    {
                        data: item.quantity,
                        alignment: "center"
                    };
                    if(data.cartMetaData.calculedQuoteData && data.cartMetaData.showDiscountRatePR){
                        tableData[data.translatedLabels.discountRate] =
                        {
                            data: (item.discountRate)? ""+item.discountRate+".00%": '-',
                            alignment: "center"
                        };
                    }
                    tableData[data.translatedLabels.columnMNHT] =
                    {
                        data: currencyConcat( ( item.quantity !=null ? item.totalPriceExclTaxes : item.exclTaxes), data.cartMetaData.currency),
                        alignment: "right"
                    };

                    return tableData;
                })

                var fourthObj = {};

                fourthObj = {
                    type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: (data.cartMetaData.calculedQuoteData && data.cartMetaData.showDiscountRatePR)?[70, 140, 50, 40, 40, 40, 50] : [70, 160, 50, 50, 50, 60]
                };

                dataArray.push(fourthObj);
                if (data.superCartNode.superCart.taxesReturnedPrTm) {
                    var subTotalPR = [];
                    var prTotalExists = false;
                    if (data.superCartNode.superCart.taxesReturnedPrTm.pr && data.superCartNode.superCart.taxesReturnedPrTm.pr != 0){
                            prTotalExists = true;
                            subTotalPR.push({
                                column1: {
                                    data: data.translatedLabels.itemTotal + " " + data.superCartNode.superCart.taxesReturnedPrTm.pr + " " + data.cartMetaData.currency,
                                    alignment: "right"
                                }
                            })
                        }
                    var subTotalPRObj = {
                        type: "table", values: getTableData(subTotalPR, false), styles: "withoutMargin",
                        layout: "otherTableLayout", widths: [485]
                    };
                    if(prTotalExists)
                        dataArray.push(subTotalPRObj);
                }
                var fifthTable = [
                    {
                        column1: {
                            data: "TM"
                        }
                    }
                ]

                var fifthObj = {
                    type: "table", values: getTableData(fifthTable, false), styles: "tableStyle",
                    layout: "thirdTableLayout", widths: [480]
                };

                if (data.superCartNode.superCart.tm.length > 0)
                    dataArray.push(fifthObj);

                var sixthTable = data.superCartNode.superCart.tm;

                var tmFilteredData = sixthTable.map(function (item) {
                    var tableData = [];
                    tableData[data.translatedLabels.codeTm] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.opecod, ""),
                        alignment: "left"
                    };
                    tableData[data.translatedLabels.documentTmTitle] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.designation, ""),
                        alignment: "left"
                    };
                    tableData[data.translatedLabels.documentTmTime] =
                    {
                        data:(item.laborTime && item.laborTime !='-')? item.laborTime: "-",
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.documentTmlabourTimes] =
                    {
                        data: currencyConcat((!item.hourlyRate ? item.exclTaxes : item.hourlyRate), data.cartMetaData.currency),
                        alignment: "right"
                    };
                    tableData[data.translatedLabels.columnQuantity] =
                    {
                        data: item.quantity,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.columnMNHT] =
                    {
                        data: currencyConcat(item.totalPriceExclTaxes, data.cartMetaData.currency),
                        alignment: "right"
                    };

                    return tableData;
                })

                var sixthObj = {};

                sixthObj = {
                    type: "table", values: getTableData(tmFilteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: [70, 160, 50, 50, 50, 60]
                };

                dataArray.push(sixthObj);
                if (data.superCartNode.superCart.taxesReturnedPrTm) {
                    var subTotalTM = [];
                    var tmTotalExists = false;

                    if (data.superCartNode.superCart.taxesReturnedPrTm.tm && data.superCartNode.superCart.taxesReturnedPrTm.tm != 0) {
                            tmTotalExists = true;
                            subTotalTM.push({
                                column1: {
                                    data: data.translatedLabels.itemTotal + " " + data.superCartNode.superCart.taxesReturnedPrTm.tm + " " + data.cartMetaData.currency,
                                    alignment: "right"
                                }
                            })
                        }

                    var subTotalTMObj = {
                        type: "table", values: getTableData(subTotalTM, false), styles: "withoutMargin",
                        layout: "otherTableLayout", widths: [485]
                    };
                    if(tmTotalExists)
                        dataArray.push(subTotalTMObj);
                }
                if (data.cartMetaData.calculedQuoteData && data.cartMetaData.calculedQuoteData.length > 0) {
                    var calcLeftTable = [];
                    calcLeftTable = data.cartMetaData.calculedQuoteData;
                    var calcLeftData = calcLeftTable.map(function (item) {
                        var tableData = [];
                        tableData[data.translatedLabels.category] =
                        {
                            data: UtilsMetierService.replaceEmptyString(item.type, ""),
                            alignment: "left"
                        };
                        tableData[data.translatedLabels.brutHT] =
                        {
                            data: currencyConcat(item.basis, data.cartMetaData.currency),
                            alignment: "right"
                        };
                        tableData[data.translatedLabels.netHT] =
                        {
                            data: currencyConcat(item.exclTaxes, data.cartMetaData.currency),
                            alignment: "right"
                        };
                        tableData[data.translatedLabels.totalTaxe] =
                        {
                            data: currencyConcat(item.taxes, data.cartMetaData.currency),
                            alignment: "right"
                        };
                        tableData[data.translatedLabels.totalTTC] =
                        {
                            data: currencyConcat(item.total, data.cartMetaData.currency),
                            alignment: "right"
                        };

                        return tableData;
                    })

                    var calcLeftObj = {};

                    calcLeftObj = {
                        type: "table", values: getTableData(calcLeftData, true), styles: "tableStyle",
                        layout: "otherTableLayout", widths: [70, 50, 50, 50, 50]
                    };
                }

                if (data.cartMetaData.totalCalculatedQuote && data.cartMetaData.totalCalculatedQuote.length > 0) {
                    var calcRightTable = [];
                    calcRightTable = data.cartMetaData.totalCalculatedQuote;
                    var calcRightData = calcRightTable.map(function (item) {
                        var tableData = [];
                        tableData['left'] =
                        {
                            data: item.type,
                            alignment: "left"
                        };
                        tableData['right'] =
                        {
                            data: currencyConcat(item.total, data.cartMetaData.currency),
                            alignment: "right"
                        };

                        return tableData;
                    })

                    var calcRightObj = {};

                    calcRightObj = {
                        type: "table", values: getTableData(calcRightData, false), styles: "tableStyle",
                        layout: "TablerightLayout", widths: [100, 40]
                    };

                }

                if (calcLeftTable && calcLeftTable.length > 0 && calcRightTable && calcRightTable.length > 0) {
                    var total1Obj = { table: { body: getTableData(calcLeftData, true) }, widths: [80, 90, 90, 90, 70] };
                    var total2Obj = [{ table: { body: getTableData(calcRightData, false) }, widths: [80, 60] }];
                    if(data.cartMetaData.isUncalculatedParts){
                        total2Obj.push({"text":data.translatedLabels.isNonCalculatedParts,"color":"red","layout":"otherTableLayout",style:"textStyle","hLineWidth":1})
                    }
                    var totalTable = [
                    ];
                    //using double array for nested tables
                    var totalTable2 = [];
                    totalTable.push(total1Obj);
                    totalTable.push(total2Obj);
                    totalTable2.push(totalTable);
                    var totalObj = {
                        type: "table", values: totalTable2, styles: "tableStyle",
                        layout: "noBorderTableLayout", widths: [290, 185]
                    };
                    dataArray.push(totalObj);
                }
                dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,false,false,false);

                var docDefinition = {
                    info: {
                        title: data.translatedLabels.superCartNumber,
                    },
                    content: [
                        finalArr
                    ],
                    styles: {
                        textStyle: {
                            margin: [0, 3, 0, 3],
                            alignment: "left",
                            fontSize: 8
                        },
                        rgpdStyle: {
                            margin: [0, 8, 0, 8],
                            fontSize: 7
                        },
                        tableTextStyle: {
                            margin: [0, 0, 0, 3],
                            fontSize: 8
                        },
                        tableStyle: {
                            margin: [0, 5, 0, 0]
                        },
                        descTableStyle: {
                            margin: [0, 5, 0, 5]
                        },
                        tableHeader: {
                            margin: [0, 3, 0, 3],
                            alignment: "center",
                            fontSize: 8,
                            bold: true
                        },
                        secondTableHeader: {
                            margin: [0, 3, 0, 10],
                            alignment: "center",
                            fontSize: 8,
                            bold: true
                        },
                        withoutMargin: {
                            bold: false
                        }
                    }
                };

                deferred.resolve({
                    data: docDefinition
                });
                return deferred.promise;
            }

            function calculatePrTMTotal(quote) {
                var prTmTotal = {};
                if (quote && quote.items && quote.items.length > 0) {
                    var tmList = _.filter(quote.items, { type: "TM" });
                    var prList = _.filter(quote.items, { type: "PR" });
                    if (prList) {
                        var prPrice = 0;
                        for (var x of prList) {
                            if (x.quantity !=null){
                                x.totalPriceExclTaxes = x.totalPriceExclTaxes && typeof x.totalPriceExclTaxes === 'string' ? parseFloat(x.totalPriceExclTaxes.replace(" ", "")) : x.totalPriceExclTaxes ? x.totalPriceExclTaxes : 0;
                                prPrice += x.totalPriceExclTaxes;
                            }
                            
                        }
                        prTmTotal.pr = prPrice ? prPrice.toFixed(2) : prPrice;
                    }
                    if (tmList) {
                        var tmPrice = 0;
                        for (var x of tmList) {
                            x.totalPriceExclTaxes = x.totalPriceExclTaxes && typeof x.totalPriceExclTaxes === 'string' ? parseFloat(x.totalPriceExclTaxes.replace(" ", "")) : x.totalPriceExclTaxes ? x.totalPriceExclTaxes : 0;
                            tmPrice += x.totalPriceExclTaxes;
                        }
                        prTmTotal.tm = tmPrice ? tmPrice.toFixed(2) : tmPrice;
                    }
                }
                return prTmTotal;
            }

            function getTableData(tableData, isHeader) {
                return PDFViewService.getTableData(tableData, isHeader);
            }
            function currencyConcat(data1, currency) {
                if (!data1 || data1 === 0 || data1 === '-') {
                    return '-';
                } else {
                    return data1.toString().concat(' ').concat(currency);
                }
            }
            function dataConcatenation(data1, data2, separator) {
                return UtilsMetierService.isEmpty(data1) ?
                    (UtilsMetierService.isEmpty(data2) ? "" : data2) :
                    (UtilsMetierService.isEmpty(data2) ? data1 :
                        data1.toString().concat(separator).concat(data2));
            }
        });
})();

(function() {
    angular.module('phenix').constant('QuoteEndpointConstant', {
        create: 'estimate/create',
        save: 'estimate/save',
        find: '/estimate',
        close: 'estimate/close',
        delete: 'estimate/delete',
        validate: 'estimate/validate',
        updateItems: 'estimate/updateItem',
        workshop: 'WORKSHOP',
        partshop: 'PARTSHOP',
        quoteList: '/estimate/list',
        unlock:  '/estimate/unlock',
        pdfExport: 'estimate/pdfExport'
    })
})();

(function() {
    angular.module("phenix").constant("estimateResponseMock", {
            "returnCode": 2,
            "response": {
              "totalPaintAmount": 0,
              "labourTimes": {
                "total": {
                  "total": 2269.49,
                  "exclTaxes": 1891.24,
                  "taxes": 378.25,
                  "basis": 1891.24
                },
                "detail": [
                  {
                    "amount": {
                      "total": 174.58,
                      "exclTaxes": 145.48,
                      "taxes": 29.1,
                      "basis": 145.48
                    },
                    "code": "3116"
                  },
                  {
                    "amount": {
                      "total": 261.86,
                      "exclTaxes": 218.22,
                      "taxes": 43.64,
                      "basis": 218.22
                    },
                    "code": "3117"
                  },
                  {
                    "amount": {
                      "total": 436.44,
                      "exclTaxes": 363.7,
                      "taxes": 72.74,
                      "basis": 363.7
                    },
                    "code": "3118"
                  },
                  {
                    "amount": {
                      "total": 436.44,
                      "exclTaxes": 363.7,
                      "taxes": 72.74,
                      "basis": 363.7
                    },
                    "code": "3111"
                  },
                  {
                    "amount": {
                      "total": 785.59,
                      "exclTaxes": 654.66,
                      "taxes": 130.93,
                      "basis": 654.66
                    },
                    "code": "3112"
                  },
                  {
                    "amount": {
                      "total": 174.58,
                      "exclTaxes": 145.48,
                      "taxes": 29.1,
                      "basis": 145.48
                    },
                    "code": "3113"
                  }
                ]
              },
              "dmsEstimateId": "117969",
              "basisSuppliesAmount": -1,
              "parts": {
                "total": {
                  "total": 889.71,
                  "exclTaxes": 741.43,
                  "taxes": 148.28,
                  "basis": 741.43
                },
                "detail": [
                  {
                    "reference": "8200588482",
                    "amount": {
                      "total": 271.69,
                      "exclTaxes": 226.41,
                      "taxes": 45.28,
                      "basis": 226.41
                    }
                  },
                  {
                    "reference": "8200473363",
                    "amount": {
                      "total": 11.11,
                      "exclTaxes": 9.26,
                      "taxes": 1.85,
                      "basis": 9.26
                    }
                  },
                  {
                    "reference": "403170002N",
                    "amount": {
                      "total": 36.36,
                      "exclTaxes": 30.3,
                      "taxes": 6.06,
                      "basis": 30.3
                    }
                  },
                  {
                    "reference": "8200043899",
                    "amount": {
                      "total": 19.19,
                      "exclTaxes": 15.99,
                      "taxes": 3.2,
                      "basis": 15.99
                    }
                  },
                  {
                    "reference": "403008703R",
                    "amount": {
                      "total": 279.67,
                      "exclTaxes": 233.06,
                      "taxes": 46.61,
                      "basis": 233.06
                    }
                  },
                  {
                    "reference": "403008558R",
                    "amount": {
                      "total": 271.69,
                      "exclTaxes": 226.41,
                      "taxes": 45.28,
                      "basis": 226.41
                    }
                  }
                ]
              },
              "estimate": {
                "total": 3159.2,
                "exclTaxes": 2632.67,
                "taxes": 526.53,
                "basis": 2632.67
              },
              "paintTime": 0,
              "totalSuppliesAmount": -1
            },
            "message": " Tout travail fini exceptÃ© l'Ã©dition"
    });
})();

(function() {
    angular.module("phenix").constant("createQuoteMock", {
        payload: {
            vin: "VF1CNBA0544210258",
            registrationNumber: "BD424XX",
            vehicleDesignation: "Twingo II (C44)",
            brand: "APL03",
            familyVehicle: "X44",
            bodyType: "C44",
            engineType: "D4F",
            paintType: "O",
            accountNumber: "20999",
            orderNumber: null,
            type: "WORKSHOP",
            mileAge: 1000
        },
        carContext: {
            vin: "VF1CNBA0544210258",
            registrationNumber: "BD424XX",
            millesim: "20060",
            fixedCriterias: {
                "106": "CCHBAM",
                "116": "AIRBA1",
                "120": "SERIE",
                "121": "DRA",
                "122": "DRAP10",
                "123": "HARM04",
                "126": "ATAV01",
                "127": "ATAR",
                "130": "SGAV02",
                "133": "SGAR02",
                "141": "TED69",
                "143": "BANAL",
                "146": "KM",
                "164": "SAN164",
                "166": "SCTMOT",
                "224": "SSDECA",
                "242": "SSBAC",
                "253": "SABLAV",
                "257": "SSESP",
                "263": "SRDPRO",
                "264": "SALEVA",
                "270": "SSPTPR",
                "271": "SOP03C",
                "272": "SPRGAZ",
                "294": "VLMOUS",
                "302": "RETC",
                "306": "LVAVEL",
                "312": "RSEC01",
                "317": "SGSCHA",
                "336": "APL03",
                "341": "SAILAR",
                "343": "SRUNLI",
                "346": "PLAT03",
                "425": "RAD01A",
                "427": "BVM5",
                "430": "SSCPKS",
                "456": "SSABAR",
                "497": "RNORM",
                "503": "PRLOO1",
                "511": "ISOFIX",
                "513": "SAN513",
                "521": "SNSTAP",
                "527": "SANFLT",
                "537": "SANACF",
                "555": "TLFRAN",
                "566": "SPRODI",
                "577": "SAN577",
                "578": "SAN578",
                "579": "SAN579",
                "580": "SAN580",
                "581": "SAN581",
                "582": "SAN582",
                "583": "SAN583",
                "584": "SAN584",
                "585": "SAN585",
                "586": "SAN586",
                "587": "SAN587",
                "588": "SAN588",
                "589": "SAN589",
                "590": "SAN590",
                "591": "SAN591",
                "592": "SAN592",
                "593": "SAN593",
                "613": "SAN613",
                "618": "SACEXT",
                "650": "SINCTQ",
                "715": "VNOR",
                "773": "SSAPEX",
                "778": "PRUPT",
                "800": "CEE1",
                "801": "E04A",
                "808": "BCTC",
                "882": "SSTRGL",
                "900": "PE2006",
                "901": "PHAS1",
                "913": "SAN913",
                "970": "VEC456",
                "971": "X441BI",
                "996": "525",
                "997": "JB1",
                "998": "772",
                "999": "D4F",
                "58C": "SAN58C",
                "58E": "SAN58E",
                "58G": "SAN58G",
                F20: "SANF20",
                F22: "SANF22",
                "58J": "SAN58J",
                "58L": "SAN58L",
                "071": "EVC",
                "58N": "SAN58N",
                "074": "CPETIR",
                "58Q": "SAN58Q",
                "078": "RET07",
                "58Y": "SAN58Y",
                "082": "PROJAB",
                "087": "RTOL14",
                "089": "SANCUS",
                "002": "STANDA",
                "007": "X44",
                "008": "C44",
                "095": "SANCL",
                "013": "EZ3",
                "018": "MA",
                "019": "ESS",
                "026": "FRAN",
                "027": "DG",
                "029": "TEMP",
                "038": "DA",
                "039": "AFURGE",
                D30: "SSTRFV",
                A55: "CDVOL1",
                "040": "SSRV",
                "042": "ABS",
                APV001: "APV001_Y",
                APV002: "APV002_F",
                "046": "CHAUFO",
                APV003: "APV003_S",
                F02: "SANF02",
                D48: "PREM02",
                F04: "SANF04",
                "050": "TN",
                F06: "SANF06",
                F08: "SANF08",
                "059": "VITLAR",
                F10: "SANF10",
                D58: "SAND58",
                F14: "SANF14",
                F18: "SANF18",
                "067": "SPRTEL",
                "58A": "SAN58A"
            },
            variableCriterias: {
                APVDT1: "2010-09-16",
                APVNM1: "Y492888",
                APVNM2: "F255489",
                APVNM3: "S170247"
            },
            contextBLMS: { dataCrit: {}, dataCritVar: {} },
            tapv: "CN0A",
            families: {
                familyEngine: ["DXX"],
                familyBattery: [""],
                familyVehicle: ["X44"],
                familyGearbox: ["JBX"]
            },
            extraFamilies: {
                "007G": "JBX",
                "007E": "DXX",
                "007V": "X44",
                "007B": ""
            },
            brandComputed: "APL03",
            ageComputed: 7,
            typeMD: "B2",
            bvmExtraFields: {
                marqCom: "RENAULT",
                ligne3P12: "TED69  DRAP10 HARM04",
                ligne4P12: "TLFRAN LCFV   YA2A",
                marqCon: "RENAULT",
                calibrInj: "SOF1109586",
                refBoi: "7701723426",
                marqDis: "RENAULT",
                refInj: "8200774747",
                ligne2P12: "EZ3    SAN913 SAN513",
                paysImmat: "FR",
                refMot: "8200855984",
                abgCalc: "1024500876",
                marqFab: "RENAULT"
            },
            model: "Twingo II (C44)",
            urlImage:
                "https://cdn-dev.asdh.aws.renault.com/carStickers/twingo2.png",
            color: "TED69",
            colorCode: "TED69",
            motorisation: "MOTEUR D4F",
            gearboxType: "BOITE MECA 5 RAPP. JB1"
        },
        DMSVehicle: {
            payCash: true,
            isKnown: false,
            ordersAndSplits: {
                orderNumber: "",
                orderNumbers: ["376649", "376653"],
                openOrderFlag: 2,
                isSplittingRequired: false,
                team: "",
                defaultSplitFlag: 0
            },
            accountNumber: "20999",
            customer: {
                city: "PARIS",
                mainPhone: "0154678790",
                title: "M",
                bisTer: "",
                commercialAgreement: false,
                poCity: "",
                streetName: "RUE SUGER",
                faxAgreement: false,
                preferredMedia: 0,
                countryCode: "FR",
                fax: "",
                email: "",
                phoneAgreement: false,
                dmsCustomerId: "20999",
                poBoxNumber: "",
                address3: "",
                streetNumber: "10",
                address2: "",
                address1: "",
                provinceCode: "",
                message: "",
                emailAgreement: false,
                firstName: "HUGO",
                roadType: "",
                postAgreement: false,
                poPostCode: "",
                mobilePhone: "0676227948",
                smsAgreement: false,
                name: "DI CESARE",
                postCode: "75006",
                workPhone: ""
            },
            vehicle: {
                bodyType: "",
                engineNumber: "",
                paintType: "O",
                engineType: "D4F",
                body: "",
                fabricationNumber: "Y492888",
                version: "",
                afterSalesType: "CN0A",
                gearBoxType: "JB1",
                energyType: "0",
                fiscalPower: "00",
                batteryId2: "",
                registrationNumber: "",
                batteryId1: "",
                vin: "VF1CNBA0544210258",
                model: "",
                colorCode: "",
                deliveryDate: "20101221",
                brand: "REN",
                gearBoxNumber: "S170247",
                mileage: 1000
            }
        },
        carSearchContext: {
            vehicle: {
                displayMotrio: true,
                vin: "VF1CNBA0544210258",
                registrationNumber: "BD424XX",
                model: "Twingo II (C44)",
                color: "TED69",
                motorisation: "MOTEUR D4F",
                millesim: "20060",
                categories: [],
                searchTypeByOR: false,
                isGemStopped: false,
                family: "",
                engineSuffix: "772",
                gearboxSuffix: "525",
                steeringWheelLocation: "DG",
                vehiculeVersion: "EZ3",
                equipmentLevel: "SAN513",
                heatingSystem: "CHAUFO",
                gearBoxType: "JB1",
                gas: "ESS",
                pr: [],
                mr: [],
                md: [],
                nt: [],
                urlImage:
                    "https://cdn-dev.asdh.aws.renault.com/carStickers/twingo2.png",
                contextBlms: {},
                tapv: "CN0A",
                typeMD: "B2",
                mileAge: 1000
            },
            isKnown: false,
            payCash: true,
            ordersAndSplits: {
                team: "",
                openOrderFlag: 2,
                isSplittingRequired: false,
                defaultSplitFlag: 0,
                orderNumber: "",
                orderNumbers: ["376649", "376653"]
            },
            team: "",
            searchTypeByOR: false,
            accountNumber: "20999",
            customer: {
                city: "PARIS",
                mainPhone: "0154678790",
                title: "M",
                bisTer: "",
                commercialAgreement: false,
                poCity: "",
                streetName: "RUE SUGER",
                faxAgreement: false,
                preferredMedia: 0,
                countryCode: "FR",
                fax: "",
                email: "",
                phoneAgreement: false,
                dmsCustomerId: "20999",
                poBoxNumber: "",
                address3: "",
                streetNumber: "10",
                address2: "",
                address1: "",
                provinceCode: "",
                message: "",
                emailAgreement: false,
                firstName: "HUGO",
                roadType: "",
                postAgreement: false,
                poPostCode: "",
                mobilePhone: "0676227948",
                smsAgreement: false,
                name: "DI CESARE",
                postCode: "75006",
                workPhone: ""
            },
            treeNodes: {
                levelOne: {
                    nodes: [
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21347",
                            label: "Entretien courant",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 1,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21947.svg",
                            nodeId: "N-21947",
                            label: "Moteur et périphérie",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21947.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 2,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-22009.svg",
                            nodeId: "N-22009",
                            label: "Embrayage - Boîte - Transmission",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-22009.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 3,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21921.svg",
                            nodeId: "N-21921",
                            label: "Liaison au sol",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21921.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 4,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21871.svg",
                            nodeId: "N-21871",
                            label: "Chauffage - Climatisation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21871.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 5,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21581_X44.svg",
                            nodeId: "N-21581",
                            label: "Carrosserie - Ouvrants - Vitrage",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21581_X44.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 6,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21643_X44.svg",
                            nodeId: "N-21643",
                            label:
                                "Eclairage extérieur - Visibilité - Signalisation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21643_X44.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 7,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21657.svg",
                            nodeId: "N-21657",
                            label: "Habitacle - Sellerie - Coffre",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21657.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 8,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21883.svg",
                            nodeId: "N-21883",
                            label: "Instrumentation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21883.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 9,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21901.svg",
                            nodeId: "N-21901",
                            label: "Câblage et Gestion électrique",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21901.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 10,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21493",
                            label: "Généralités",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 11,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21397",
                            label: "Accessoires - Produits dérivés",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 12,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21446",
                            label:
                                "Matériel - Outillage - Consommables - Peinture",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 13,
                            codeParent: "ROOT",
                            childNodes: null
                        }
                    ]
                }
            }
        },
        profile: {
            dmsConfig: {
                dmsLoginRequired: null,
                userDmsId: null,
                ipAddress: null,
                networkProfile: "WORKSHOP",
                workshopPartshopId: "903nay0001",
                url: "https://Kheops-re7.dms.dcs2.renault.com:8463/DMSGateway/rest/",
                stocks: null
            },
            lastName: "fr_admin_corporate",
            country: "FR",
            documentationSecondLanguage: {
                code: "en",
                countryCode: "GB",
                active: true,
                label: "English"
            },
            roles: ["PPX_CORPORATE_USER"],
            language: "fr",
            rolesActis: [],
            activeNotification: false,
            password: null,
            documentationFirstLanguage: {
                code: "fr",
                countryCode: "FR",
                active: true,
                label: "French"
            },
            roleActive: null,
            distanceMeasure: null,
            portal: {
                code: "fr",
                countryCode: "FR",
                active: true,
                label: "French"
            },
            dealerName: "testDealerName",
            ipn: "FR11111118",
            dealerId: "testdealer",
            costCenter: null,
            profiles: ["Reseau_et_importateur"],
            manageDealerFavourites: false,
            userId: "FR",
            firstName: "admin_corporate",
            dmsConnected: null,
            emailAlerte: null,
            isManageDealer: null,
            userType: "RNET",
            isHTLCountry: true,
            dealerLogisticIds: "rejected"
        },
        items: [{"type":"X","reference":"8200588482","quantity":1},{"type":"X","reference":"8200473363","quantity":1},{"type":"X","reference":"403170002N","quantity":1},
        {"type":"X","reference":"8200043899","quantity":1},{"type":"X","reference":"403008703R","quantity":1},{"type":"X","reference":"403008558R","quantity":1},
        {"type":"F","code":"3116","time":2},{"type":"F","code":"3117","time":3},{"type":"F","code":"3118","time":5},{"type":"F","code":"3111","time":5},{"type":"F","code":"3112","time":9},
        {"type":"F","code":"3113","time":2}],
        newQuote: {
            "id": "1e306736-5b46-46bf-8c2b-4b3a57ae3a3b",
            "dealerId": "testdealer",
            "number": "ND000811",
            "description": null,
            "creationDateTime": "2018-10-16T13:34Z",
            "lastModificationDateTime": "2018-10-16T13:34Z",
            "validationDateTime": null,
            "creatorIPN": "FR11111118",
            "lastModifierIPN": "FR11111118",
            "validatorIPN": null,
            "vin": "VF1CNBA0544210258",
            "registrationNumber": "BD424XX",
            "vehicleDesignation": "Twingo II (C44)",
            "brand": "APL03",
            "familyVehicle": "X44",
            "bodyType": "C44",
            "engineType": "D4F",
            "gearboxType": null,
            "batteryType": null,
            "accountNumber": "20999",
            "status": "DRAFT",
            "mentions": null,
            "mileAge": 1000,
            "orderNumber": null,
            "paintType": "O",
            "dmsEstimateId": null,
            "basis": null,
            "exclTaxes": null,
            "taxes": null,
            "total": null,
            "totalPaintAmount": null,
            "paintTime": null,
            "totalSuppliesAmount": null,
            "basisSuppliesAmount": null,
            "recyclingExclTaxes": null,
            "recyclingTotal": null,
            "type": "WORKSHOP",
            "estimateUserId": null,
            "userLock": "FR11111118",
            "lockedByUser": false,
            "items": []
        },
        dmsReferencesResponse: {
            "returnCode": 0,
            "response": {
                "parts": [
                    {
                        "reference": "8200257642",
                        "cort": "1422",
                        "priceCode": "12",
                        "familyCode": "501",
                        "availabilities": [
                            {
                                "stockLabel": "",
                                "quantity": 53,
                                "stockId": 0,
                                "siteId": "00900011",
                                "location": "",
                                "siteLabel": "RE7 RLT NANCY"
                            },
                            {
                                "stockLabel": "NANCY",
                                "quantity": 52,
                                "stockId": 1,
                                "siteId": "00900011",
                                "location": "0020214",
                                "siteLabel": "RE7 RLT NANCY"
                            },
                            {
                                "stockLabel": "R.M.S NANCY",
                                "quantity": 1,
                                "stockId": 2,
                                "siteId": "00900011",
                                "location": "stsamed",
                                "siteLabel": "RE7 RLT NANCY"
                            },
                            {
                                "stockLabel": "Pneumatiques NANCY",
                                "quantity": 0,
                                "stockId": 3,
                                "siteId": "00900011",
                                "location": "",
                                "siteLabel": "RE7 RLT NANCY"
                            }
                        ],
                        "description": "FILTRE HUILE",
                        "priceExclTaxes": 13.98,
                        "priceInclTaxes": 16.78,
                        "status": 0,
                        "depositReference": ""
                    }
                ]
            }
        }
    });
})();

/**
 * CreateQuoteController
 * @namespace Controller
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('DMSQuoteController', DMSQuoteController);

    /* @ngInject */
    function DMSQuoteController(
        blockUI,
        toastr,
        $window,
        $scope,
        $translate,
        $q,
        $timeout,
        $rootScope,
        $state,
        $mdDialog,
        $filter,
        FileSaver,
        QuoteMetierService,
        RoutingService,
        CacheService,
        DealerManagerSystemeService,
        DmsMetierService,
        SettingsMetierService,
        DocumentsMetierService,
        DeleteModalService,
        UtilsMetierService,
        warningModalCustomerService,
        SuperCartValidateService,
        CarSearchMetierService,
        PartRequisitionMetierService,
        printPdfModalService,
        ShoppingCartServiceConstant,
        globalConstant,
        CodesConstants,
        DmsCustomerConstants,
        QuoteConstants,
        RoutesConstants,
        CacheConstants,
        SettingsConstants,
        // PartRequisitionConstants,
        FavoitMetierService,$log,MainMetierService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var dmsQuote = CacheService.getDmsQuote();
        var dmsVehicleResponse = CacheService.getObject(CacheConstants.dmsResponse);
        var userProfil = CacheService.getObject(CacheConstants.profil);
        var hourlyRates = {};
        var _errors = {
            emptyClient: 15,
            emptyMileage: 16,
            emptyQuote: 17
        }

        var _essai = ShoppingCartServiceConstant.essai;
        var countryExceptionArray = globalConstant.countryCurrencyException;

        var matchHourlyRateArray = [
            {
                "opecode": 1999,
                "hourlyRate": "mechanicalHourlyRate"
            },
            {
                "opecode": 1888,
                "hourlyRate": "hightTechMechHourlyRate"
            },
            {
                "opecode": 1777,
                "hourlyRate": "veryHightTechMechHourlyRate"
            },
            {
                "opecode": 2999,
                "hourlyRate": "mechanicalHourlyRate"
            },
            {
                "opecode": 2888,
                "hourlyRate": "hightTechMechHourlyRate"
            },
            {
                "opecode": 2777,
                "hourlyRate": "veryHightTechMechHourlyRate"
            },
            {
                "opecode": 3999,
                "hourlyRate": "mechanicalHourlyRate"
            },
            {
                "opecode": 3888,
                "hourlyRate": "hightTechMechHourlyRate"
            },
            {
                "opecode": 3777,
                "hourlyRate": "veryHightTechMechHourlyRate"
            },
            {
                "opecode": 8999,
                "hourlyRate": "mechanicalHourlyRate"
            },
            {
                "opecode": 8888,
                "hourlyRate": "hightTechMechHourlyRate"
            },
            {
                "opecode": 8777,
                "hourlyRate": "veryHightTechMechHourlyRate"
            },
            {
                "opecode": 4999,
                "hourlyRate": "bodyWorkHourlyRate"
            },
            {
                "opecode": 4888,
                "hourlyRate": "hightTechBodyWHourlyRate"
            },
            {
                "opecode": 4777,
                "hourlyRate": "veryHightTechBodyWHourlyRate"
            },
            {
                "opecode": 5999,
                "hourlyRate": "bodyWorkHourlyRate"
            },
            {
                "opecode": 5888,
                "hourlyRate": "hightTechBodyWHourlyRate"
            },
            {
                "opecode": 5777,
                "hourlyRate": "veryHightTechBodyWHourlyRate"
            },
            {
                "opecode": 7999,
                "hourlyRate": "bodyWorkHourlyRate"
            },
            {
                "opecode": 7888,
                "hourlyRate": "hightTechBodyWHourlyRate"
            },
            {
                "opecode": 7777,
                "hourlyRate": "veryHightTechBodyWHourlyRate"
            },
            {
                "opecode": 9499,
                "hourlyRate": "hightTechPaintWHourlyRate"
            },

            {
                "opecode": 6888,
                "multipleChoice": [{
                    "category": "TM_NOCODIF_CAT_MECHANICAL",
                    "subCategory": "TM_NOCODIF_SCAT_AIR_CONDITIONNER",
                    "technicality": "TM_NOCODIF_TECH_HIGH",
                    "hourlyRate": "hightTechMechHourlyRate"
                },
                {
                    "category": "TM_NOCODIF_CAT_AUTO_BODY",
                    "subCategory": "TM_NOCODIF_SCAT_SEALING",
                    "technicality": "TM_NOCODIF_TECH_HIGH",
                    "hourlyRate": "hightTechBodyWHourlyRate"
                }]
            },
            {
                "opecode": 6999,
                "multipleChoice": [
                    {
                        "category": "TM_NOCODIF_CAT_MECHANICAL",
                        "subCategory": "TM_NOCODIF_SCAT_AIR_CONDITIONNER",
                        "technicality": "TM_NOCODIF_TECH_NORMAL",
                        "hourlyRate": "mechanicalHourlyRate"
                    },
                    {
                        "category": "TM_NOCODIF_CAT_AUTO_BODY",
                        "subCategory": "TM_NOCODIF_SCAT_SEALING",
                        "technicality": "TM_NOCODIF_TECH_NORMAL",
                        "hourlyRate": "bodyWorkHourlyRate"
                    }
                ]
            },
            {
                "opecode": 6777,
                "multipleChoice": [
                    {
                        "category": "TM_NOCODIF_CAT_MECHANICAL",
                        "subCategory": "TM_NOCODIF_SCAT_AIR_CONDITIONNER",
                        "technicality": "DOCUMENT_TM_TECHNICALITY_H",
                        "hourlyRate": "veryHightTechMechHourlyRate"
                    },
                    {
                        "category": "TM_NOCODIF_CAT_AUTO_BODY",
                        "subCategory": "TM_NOCODIF_SCAT_SEALING",
                        "technicality": "DOCUMENT_TM_TECHNICALITY_H",
                        "hourlyRate": "veryHightTechBodyWHourlyRate"
                    }
                ]

            }

        ];
        var mileageInputId = "#mileageInput";


        var vm = this;

        vm.initCustomer = null;
        vm.orderNumber = '-';
        vm.orderList = ['-'];
        vm.quote = {};
        vm.prItems = {};
        vm.itemsReturned = [];
        vm.prButton = false;
        vm.isShowPR = false;
        vm.isShowTM = false;
        vm.customer = null;
        vm.isQuoteCalculated = false;
        vm.dmsLoginRequired = false;
        vm.dmsLoginContainer = {};
        vm.dmsLoginContainer.username = "";
        vm.dmsLoginContainer.password = "";
        vm.networkProfile = null;
        vm.isWorkshop = false;
        vm.isPartshop = false;
        vm.userProfile = null;
        vm.isHourlyRatesLoaded = false;
        vm.currency = UtilsMetierService.getCurrencyFromItems(vm.quote.items);
        vm.detectedError = null;
        vm.maxItemsLimit = 99 + " " + "max";
        vm.interItemsTax = "";
        vm.prDetails = [];
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.goToProduct = goToProduct;
        vm.copyToClipboard = copyToClipboard;
        vm.backToPrevious = backToPrevious;
        vm.saveQuote = saveQuote;
        vm.closeQuote = closeQuote;
        vm.getStockClass = getStockClass;
        vm.reference = "";
        vm.onChangeDescription = onChangeDescription;
        vm.onChangeMentions = onChangeMentions;
        vm.onChangeKM = onChangeKM;
        vm.onChangeUsername = onChangeUsername;
        vm.onChangePassword = onChangePassword;
        vm.onChangeOrderNumber = onChangeOrderNumber;
        vm.deleteReference = deleteReference;
        vm.deleteByDesignation = deleteByDesignation;
        vm.deletedDesignation = deletedDesignation;
        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;
        vm.resetCustomerCallback = resetCustomerCallback;
        vm.onUpdateCustomerCallback = onUpdateCustomerCallback;
        vm.addReference = addReference;
        vm.getReferenceClass = getReferenceClass;
        vm.getDesignationClass = getDesignationClass;
        vm.onChangeCustomerGroup = onChangeCustomerGroup;
        vm.onSetCustomerDetails = onSetCustomerDetails;

        vm.sortPRBy = sortPRBy;
        vm.sortTMBy = sortTMBy;
        vm.getTMDuration = getTMDuration;

        // search-dms-customer component callback events
        vm.onSelectCustomerCallback = onSelectCustomerCallback;
        vm.onNewCustomerCallback = onNewCustomerCallback;
        vm.onCustomerFilledCallback = onCustomerFilledCallback;
        vm.dmsCustomerConstants = DmsCustomerConstants;
        vm.onValidateQuote = onValidateQuote;
        $scope.getPriceToDisplay = getPriceToDisplay;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.putQuoteItemsToPartRequisition = putQuoteItemsToPartRequisition;
        vm.getCreatePartRequisitionFromQuoteClass = getCreatePartRequisitionFromQuoteClass;
        vm.printQuote = printQuote;
        vm.isPositifNumber = isPositifNumber;
        vm.onCalculQuote = onCalculQuote;
        vm.getQuoteInformations = getQuoteInformations;
        vm.getPrItems = getPrItems;
        vm.checkInter = checkInter;
        vm.initQuoteFocus = initQuoteFocus;
        vm.isValidatingQuote = false;
        vm.isCalculating = false;
        vm.formatReferenceInput = formatReferenceInput;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        $rootScope.$on('bannerDataLoaded', function () {
            vm.bannerData = CarSearchMetierService.getBannerDetails();
        });
        /**
         * @name init
         * @desc instantiate when a new quote is selected from dropdown in mainController
         */
        this.$onInit = function () {
            initQuoteFocus();
            vm.isCustomerFilled = false;
            vm.networkProfile = CacheService.getNetworkProfile();
            vm.userProfile = CacheService.getUserProfile();
            vm.redirectCarBrandCheck = MainMetierService.redirectCarBrandCheck(vm.contextCarBrandCheck);
            if(vm.userProfile){
                vm.isWorkshop = DealerManagerSystemeService.isWorkshop(vm.userProfile);
                vm.isPartshop = DealerManagerSystemeService.isPartshop(vm.userProfile);
            }
            //show/hide dms login bloc
            vm.dmsLoginRequired = userProfil.dmsConfig.dmsLoginRequired;
            getQuoteInformations().catch(function () {
                $log.debug($translate.instant('ERROR'));
            });

            //get car informations
            var carSearchContext = CacheService.getCarSearchContext();
            if (carSearchContext) {
                if (carSearchContext.hasOwnProperty('ordersAndSplits')) {
                    var openOrderFlag = carSearchContext.ordersAndSplits.openOrderFlag;
                    if (openOrderFlag == CodesConstants.ONE_ORDER_TYPE) {
                        vm.orderList = vm.orderList.concat(carSearchContext.ordersAndSplits.orderNumber);
                    } else if (openOrderFlag == CodesConstants.MULTIPLES_ORDERS_TYPES) {
                        vm.orderList = vm.orderList.concat(carSearchContext.ordersAndSplits.orderNumbers);
                    }
                }
                /* else {
                    vm.dataFromCarContext = CacheService.getObject(CacheConstants.contextCarSearch)
                    vm.vehicle = vm.dataFromCarContext ? vm.dataFromCarContext.vehicle : null;
                } */
                if (carSearchContext.vehicle) {
                    vm.vehicle = carSearchContext.vehicle;
                    vm.bannerData = CarSearchMetierService.getBannerDetails();
                }
            }
            //set customer informations
            vm.currentCustomer = dmsQuote.customer;

            //set isQuoteCalculated to false when quoteUpdatedEvent is triggered
            $rootScope.$on(QuoteConstants.quoteUpdatedEvent, function () {
                vm.isQuoteCalculated = false;
            });
            $rootScope.$on(QuoteConstants.quoteSpread, function (event, data) {
                vm.quote = data;
            });    
        };

        /**
         * @name isPositifNumber
         * @param {*} number
         */
        function isPositifNumber(number) {
            if (!_.isNumber(number)) {
                return false;
            }
            return number > 0;
        }

        function formatReferenceInput() {

           var formattedVal =  MainMetierService.formatReferenceInput(vm.reference);
            vm.reference = formattedVal;
        };

        function initQuoteFocus() {
            $timeout(function () {
                var inputBox = document.getElementById('inputReference');
                if (inputBox) {
                    var partReqInputBox = angular.element(inputBox);
                    partReqInputBox[0].focus();
                } else {
                    initQuoteFocus();
                }
            }, 3000);
        }
        

        function matchTheHourlyRates(response) {
            var objectOfEachValue = {};
            matchHourlyRateArray.forEach(function (key) {
                if (key.opecode == response.opeCode) {
                    if (key.multipleChoice) {
                        key.multipleChoice.forEach(function (el) {
                            if ((el.category == response.category) && (el.subCategory == response.subCategory) && (el.technicality == response.technicality)) {
                                vm.isHourlyRatesLoaded = true;
                                objectOfEachValue.ref = response.ref;
                                objectOfEachValue.hourlyRate = el.hourlyRate;
                            }
                        })
                    } else {
                        vm.isHourlyRatesLoaded = true;
                        objectOfEachValue.hourlyRate = key.hourlyRate;
                        objectOfEachValue.ref = response.ref;
                    }
                }
            })
            return objectOfEachValue;
        }


        /**
         *  @desc  getReferencesInformations function overide price if the part is unknow from dms
         *         but we don't want that in this page, so i change that with that function
         *
         *         We fetch some data from spark and DMS and merge it
         *  @param {Array<String>} referencesPR
         */

        function getReferencesInformations(referencesPR) {
            return DocumentsMetierService.getReferencesInformations(referencesPR).then(function (references) {
                references.forEach(function (reference) {
                    if (reference && reference.dmsInformations && !reference.dmsInformations.priceExclTaxes) {
                        reference.price = 0;
                    }
                });
                return references;
            });
        }

        /**
         * @name onChangeCustomerGroup
         * @desc action fired when user change customers group
         */
        function onChangeCustomerGroup() {
            //set payload
            var payload = { id: vm.quote.id, userScale: vm.quote.userScale };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).then(function () {
                unsetCalcul();
            }).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @name onSetCustomerDetails
         * @param {Object} currentCustomer
         */
        function onSetCustomerDetails(currentCustomer) {
            //set current customer vm.currentCustomer and quote cache
            vm.currentCustomer = currentCustomer;
            dmsQuote.customer = currentCustomer;
            CacheService.setDmsQuote(dmsQuote);
        }

        /**
         *  @desc Will call the business service layer (metier.service.js) in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  @param  vm.quote : list of TM and PR entries that we want to display in the pdf
         *  @param  vm.vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         *  response {
         *      data : blob type for the pdf file
         *  }
         */

        function printQuote(showRef,isDownload) {
            blockUI.start();

            var type = globalConstant.quote;
            var status = globalConstant.draft;
            vm.quoteToPrint = PartRequisitionMetierService.buildClientForPrintPayload(vm.quote, vm.currentCustomer, true, vm.showDiscountRatePrColumn, vm.showDiscountRateTmColumn);
            if (vm.isQuoteCalculated) {
                vm.quoteToPrint.quoteStatus = "CalculatedQuote";
                vm.quoteToPrint.calculedQuoteData = [];
                vm.quoteToPrint.totalCalculatedQuote = [];
                if (vm.itemsReturned) {
                    formatReturnedItemsToFitPrintPayload(vm.itemsReturned);
                }
                if (vm.taxesReturned){
                    if (vm.taxesReturned.parts) {
                        var parts = {};
                        parts.type = $translate.instant("CAR_SEARCH_RESULT_FILTER_PR");
                        parts.genericType = "PR";
                        parts.basis = vm.taxesReturned.parts.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.basis,2) : "-";
                        parts.exclTaxes = vm.taxesReturned.parts.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.exclTaxes,2) : "-";
                        parts.taxes = vm.taxesReturned.parts.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.taxes,2): "-";
                        parts.total = vm.taxesReturned.parts.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.parts.total,2) : "-";
                        vm.quoteToPrint.calculedQuoteData.push(parts);
                    }
                    if (vm.taxesReturned.labourTimes) {
                        var labourTimes = {};
                        labourTimes.type = $translate.instant("CAR_SEARCH_RESULT_FILTER_TM");
                        labourTimes.genericType = "TM";
                        labourTimes.basis = vm.taxesReturned.labourTimes.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.basis,2) : "-";
                        labourTimes.exclTaxes = vm.taxesReturned.labourTimes.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.exclTaxes,2) : "-";
                        labourTimes.taxes = vm.taxesReturned.labourTimes.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.taxes,2) : "-";
                        labourTimes.total = vm.taxesReturned.labourTimes.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.labourTimes.total,2) : "-";
                        vm.quoteToPrint.calculedQuoteData.push(labourTimes);
                    }
                    if (vm.taxesReturned.totalPaintAmount) {
                        var paint = {};
                        paint.type = $translate.instant("ESTIMATE_MO_PAINT_LABEL");
                        paint.genericType = "";
                        paint.basis = "-";
                        paint.exclTaxes = "-";
                        paint.taxes = "-";
                        paint.total = vm.taxesReturned.totalPaintAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.totalPaintAmount,2) : "-";
                        vm.quoteToPrint.calculedQuoteData.push(paint);
                    }
                    if (vm.taxesReturned.recycling) {
                        var recycling = {};
                        recycling.type = $translate.instant("ESTIMATE_MO_RECYCLE_LABEL");
                        recycling.genericType = "";
                        recycling.basis = vm.taxesReturned.recycling.basis ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.basis,2) : "-";
                        recycling.exclTaxes = vm.taxesReturned.recycling.exclTaxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.exclTaxes,2) : "-";
                        recycling.taxes = vm.taxesReturned.recycling.taxes ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.taxes,2) : "-";
                        recycling.total = vm.taxesReturned.recycling.total ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.recycling.total,2) : "-";
                        vm.quoteToPrint.calculedQuoteData.push(recycling);
                    }
                    if (vm.taxesReturned.basisSuppliesAmount) {
                        var suppliesAmount = {};
                        suppliesAmount.type = $translate.instant("ESTIMATE_MO_SUPPLY_LABEL");
                        suppliesAmount.genericType = "";
                        suppliesAmount.basis = "-";
                        suppliesAmount.exclTaxes = vm.taxesReturned.basisSuppliesAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.basisSuppliesAmount,2) : "-";
                        suppliesAmount.taxes = "-";
                        suppliesAmount.total = vm.taxesReturned.totalSuppliesAmount ? UtilsMetierService.fixedToDecimal(vm.taxesReturned.totalSuppliesAmount,2) : "-";
                        vm.quoteToPrint.calculedQuoteData.push(suppliesAmount);
                    }
                    if (vm.taxesReturned.global) {
                        var global = {
                            basis: {
                                type: $translate.instant('ESTIMATE_TOTAL_BRUTHT'),
                                index: 0
                            },
                            exclTaxes: {
                                type: $translate.instant('ESTIMATE_TOTAL_NETHT'),
                                index: 1
                            },
                            taxes: {
                                type: $translate.instant('ESTIMATE_TOTAL_TAXES'),
                                index: 2
                            },
                            total: {
                                type: $translate.instant('ESTIMATE_TOTAL_TTC'),
                                index: 3
                            }
                        }
                        // add total for each properties in global
                        angular.forEach(vm.taxesReturned.global, function (value, key) {
                            vm.quoteToPrint.totalCalculatedQuote.push(_.extend(global[key], {
                                total: value
                            }));
                        })
                        vm.quoteToPrint.totalCalculatedQuote.sort(compare);
                    }
                }
            } else {
                vm.quoteToPrint.quoteStatus = "nonCalculatedQuote";
                vm.quoteToPrint.isUncalculatedParts = false;

                if(vm.quoteToPrint && vm.quoteToPrint.items){
                    vm.quoteToPrint.items = vm.quoteToPrint.items.map(function (currentItem) {
                        if (currentItem.totalPriceExclTaxes) {
                            currentItem = _.omit(currentItem, ['totalPriceExclTaxes', 'hourlyRate']);
                        }
                        return currentItem;
                    })
                }
            }

            var isKnownByDms = _.find(vm.quoteToPrint.items, function (item) {
                return item.dmsInformations;
            })
            if (isKnownByDms) {
                vm.quoteToPrint.currency = UtilsMetierService.getCurrencyForItem(isKnownByDms);
            } else {
                vm.quoteToPrint.currency = UtilsMetierService.getCurrencyForItem();
            }
            if (vm.isQuoteCalculated) {
                if(vm.quoteToPrint.items){
                    vm.quoteToPrint.items.map(function (currentItem) {
                        //existing item
                        if (currentItem.id) {
                            if (currentItem.totalPriceExclTaxes != 0) {
                                currentItem.totalPriceExclTaxes = $filter('number')(currentItem.totalPriceExclTaxes, 2);
                            }
                        }
                        //new item
                        else {
                            if (!currentItem.totalPriceExclTaxes) {
                                currentItem.totalPriceExclTaxes = $filter('number')(currentItem.exclTaxes, 2);
                            }
                        }
                        return currentItem;
                    })
                }
            }

            if (vm.quoteToPrint && vm.quoteToPrint.dmsEstimateId) {
                vm.quoteToPrint = _.omit(vm.quoteToPrint, "dmsEstimateId");
            }
            //blockUI.start();
            QuoteMetierService.downloadPdf(showRef, vm.quoteToPrint, vm.quoteToPrint.items, vm.vehicle, type, status).then(function (response) {
                pdfMake.tableLayouts = {
                    descTableLayout: {
                        hLineWidth: function () {
                            return 0.1;
                        },
                        vLineWidth: function () {
                            return 0.1;
                        },
                        hLineColor: function () {
                            return 'gray';
                        },
                        vLineColor: function () {
                            return 'gray';
                        },
                    },
                    secondTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 3 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                        }
                    },
                    thirdTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 2 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                        }
                    },
                    otherTableLayout: {
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    },
                    noBorderTableLayout: {
                        hLineWidth: function () {
                            return 0;
                        },
                        vLineWidth: function () {
                            return 0;
                        }
                    }
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });

                    // Internet Explorer 6-11
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;

                    // Edge 20+
                    var isEdge = !isIE && !!window.StyleMedia;
                    if (isDownload){
                        FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + "-" + vm.quoteToPrint.number + ".pdf");
                    }else{
                        if (isIE || isEdge) {
                            FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + "-" + vm.quoteToPrint.number + ".pdf");
                        }else {
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }

                    }
                })

            }).catch(function (err) {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }


        /**
         * display the correct price (DMS or Datahub)
         * @returns {string}
         * @param item
         */
        function getPriceToDisplay(item) {
            var price = UtilsMetierService.getPriceToDisplay(
                item.priceHT, !item.dmsInformations ? null : item.dmsInformations.priceExclTaxes);
            return price;
        }

        /**
         * @name getCurrencyForItem
         * @desc get currency to display
         * @returns {string}
         */
        function getCurrencyForItem() {
            var country = vm.userProfile.country;
            if (countryExceptionArray.indexOf(country) == -1) {
                return UtilsMetierService.getCurrencyForItem()
            }
            return "";
        }

        /**
        * @name getReferenceClass
        * @desc get reference class (not clickable if local)
        * @param {boolean} isLocal
        */
        function getReferenceClass(isLocal) {
            var referenceClass = "small-1 columns";
            if (isLocal) {
                referenceClass += " nonClickable";
            }
            return referenceClass;
        }

        /**
         * @name getDesignationClass
         * @desc get designation class (not clickable if local)
         * @param {boolean} isLocal
         */
        function getDesignationClass(isLocal) {
            var referenceClass = "small-2 columns";
            if (isLocal) {
                referenceClass += " nonClickable";
            }
            return referenceClass;
        }

        //#region search-dms-customer component callback

        /**
         * @namespace onSelectCustomerCallback
         * @desc save the customer accountNumber  related to current quote
         * @param {*} customer  quote to update with accountNumber
         */
        function onSelectCustomerCallback(customer) {
            //TODO: verify why use isCustomerChoosen
            vm.isCustomerChoosen = true;
            vm.quote.accountNumber = customer.accountNumber;

            //set payload
            var payload = { id: vm.quote.id, accountNumber: vm.quote.accountNumber };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).then(function () {
                //change customer on cache
                dmsQuote.customer = customer;
                CacheService.setDmsQuote(dmsQuote);
            }).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         *  @desc This function is trigger only when the customer is updated from user input
         *  @param {object} customer
         */
        function onUpdateCustomerCallback(customer) {
            // accountNumber can be reset as an empty string
            if (customer.accountNumber !== vm.quote.accountNumber) {
                vm.quote.accountNumber = customer.accountNumber;
            }

            vm.quote.accountNumber = customer.accountNumber

            //set payload
            var payload = { id: vm.quote.id, accountNumber: vm.quote.accountNumber };

            //call save quote service
            QuoteMetierService.saveQuote(payload).then(function () {
                //change customer in cache
                dmsQuote.customer = customer;
                dmsQuote.isCustomerUpdated = true;
                CacheService.setDmsQuote(dmsQuote);
                unsetCalcul();
            }).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            });
        }

        /**
         * @name resetCustomerCallback
         * @desc action fired when user click on change customer
         */
        function resetCustomerCallback() {
            if (vm.quote.accountNumber) {
                vm.quote.accountNumber = "";
            }

            //set payload
            var payload = { id: vm.quote.id, accountNumber: vm.quote.accountNumber };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).then(function () {
                //change customer on cache
                dmsQuote.customer = {};
                CacheService.setDmsQuote(dmsQuote);
                unsetCalcul();
            }).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }


        /**
         * @namespace onNewCustomerCallback
         * @desc erase the customer accountNumber  related to current quote
         */
        function onNewCustomerCallback() {
            if (vm.isQuoteCalculated) {
                $rootScope.$emit(QuoteConstants.quoteUpdatedEvent);
            }
            vm.isCustomerChoosen = false;
            vm.quote.accountNumber = null;
            saveQuote(vm.quote);
        }

        /**
         * @name onCustomerFilledCallback
         * @param {*} value
         */
        function onCustomerFilledCallback(value) {
            vm.isCustomerFilled = value;
        }
        //#endregion

        function onChangePassword(passwordInput) {
            if (passwordInput === "") {
                UtilsMetierService.setErrorFrame("#identifiantPasswordEstimation");
                return -1;
            }
            UtilsMetierService.resetErrorFrame("#identifiantPasswordEstimation");
            return 0;
        }

        function onChangeUsername(usernameInput) {
            if (usernameInput === "") {
                UtilsMetierService.setErrorFrame("#identifiantLoginEstimation");
                return -1;
            }
            UtilsMetierService.resetErrorFrame("#identifiantLoginEstimation");
            return 0;
        }

        /**
         * @name onValidateQuote
         * @desc action fired when user click on validate button
         */
        function onValidateQuote() {
            if (vm.isValidatingQuote) {
                return;
            }
            vm.isValidatingQuote = true;
            var isUsernameEmpty = 0;
            var isPasswordEmpty = 0;
            var workFlag = 2;

            var dmsQuote = CacheService.getDmsQuote();
            CacheService.saveQuoteCustomer(dmsQuote.customer);
            //check if username or password are set when dms login option is checked
            if (vm.dmsLoginRequired) {
                isUsernameEmpty = vm.onChangeUsername(vm.dmsLoginContainer.username);
                isPasswordEmpty = vm.onChangePassword(vm.dmsLoginContainer.password);
                if (isUsernameEmpty === -1 || isPasswordEmpty === -1) {
                    toastr.error($translate.instant("COMMON_ERROR_MISSING_FIELD"));
                    vm.isValidatingQuote = false;
                    return;
                }
            }

            blockUI.start();
            onChangeDescription(vm.quote);
            onChangeMentions(vm.quote);
            //calcul quote
            onCalculQuote(workFlag).then(function (quoteCalculResponse) {
                //if user click on validate and return code is not in validated code quotes
                if (quoteCalculResponse.response){
                    if (SuperCartValidateService.isQuoteValidate(quoteCalculResponse.returnCode) < 0) {
                        var error = {};
                        //return object error with message and return code from dms
                        error.message = quoteCalculResponse.message;
                        error.returnCode = quoteCalculResponse.returnCode;
                        return $q.reject(error);
                    }
                } else {
                    for (var calculResponse of quoteCalculResponse) {
                        if (SuperCartValidateService.isQuoteValidate(calculResponse.returnCode) < 0) {
                            var error = {};
                            //return object error with message and return code from dms
                            error.message = quoteCalculResponse.message;
                            error.returnCode = quoteCalculResponse.returnCode;
                            return $q.reject(error);
                        }
                    }
                }
                var data = {};
                data.quote = vm.quote;


                //get taxes returned
                if (vm.taxesReturned) {
                    data.taxesReturned = vm.taxesReturned;
                }

                //get estimate user id
                data.quote.estimateUserId = vm.dmsLoginContainer.username;

                //get customer informations
                data.customer = vm.currentCustomer;

                //vehicle informations to display once open validated controller
                if (vm.vehicle) {
                    data.gearBoxType = vm.vehicle.gearBoxType;
                    data.engineDesignation = vm.vehicle.motorisation;
                }
                //get items returned
                data.itemsReturned = vm.itemsReturned;
                if (data.itemsReturned && data.itemsReturned.PR && data.itemsReturned.PR.length > 0) {
                    return getDmsInformationsForPrItemsReturned(data.itemsReturned.PR).then(function (prDmsItemsReturned) {
                        //set items returnd PR informations
                        data.itemsReturned.PR = prDmsItemsReturned;
                        return data;
                    })
                }                
                return data;
            }).then(function (data){
                if (vm.quote.inter.length > 0) {
                    var promiseArray = _.map(vm.quote.inter, function(val){
                    var isadditionaldms = _.find(val.PR, function (list) { return list.isDeposit == true });
                    if(isadditionaldms){
                        var ref = isadditionaldms.reference;
                        var refPR = _.filter(vm.prDetails,function(list){ return list.reference == isadditionaldms.depositReference})
                        
                        val.itemsReturnedPR = addNewPrAfterCalcul(ref, refPR);
                        if(val.itemsReturnedPR && val.itemsReturnedPR.length > 0){
                            return getDmsInformationsForPrItemsReturned(val.itemsReturnedPR, isadditionaldms).then(function (prDmsItemsReturned) {
                                //set items returnd PR informations
                                val.itemsReturnedPR = prDmsItemsReturned;                                
                            })                  
                        
                        }
                    }
                    
                })
                return $q.all(promiseArray).then(function () {                                                  
                    return data;                        
                })
            }
                return data;
            }).then(function (data) {
                //filter non codified items
                _.filter(data.quote.items, { codified: false, type: 'TM' }).map(function (tmNOnCodifiedItem) {
                    tmNOnCodifiedItem.price = tmNOnCodifiedItem.exclTaxes;
                    return tmNOnCodifiedItem;
                });
                if (data.quote.inter && data.quote.inter.length > 0) {
                    for (var inter of data.quote.inter) {
                        if (inter.PR && inter.PR.length > 0) {
                            for (var pr of inter.PR) {
                                data.quote.items.push(pr);
                            }
                        }
                        if (inter.TM && inter.TM.length > 0) {
                            for (var tm of inter.TM) {
                                data.quote.items.push(tm);
                            }
                        }
                    }
                }
                return QuoteMetierService.validateQuote(data).then(function () {
                    CacheService.deleteDmsQuote();
                    $state.go(RoutesConstants.validatedQuote, {
                        id: data.quote.id,
                        customer: vm.currentCustomer
                    });
                })
            }).catch(function (error) {
                //if error object contains typeError having quoteNotValidate value
                //display error message and code error from DMS
                //NB: we use decodeURIComponent(escape()) to decode message from dms
                if (error.message && error.returnCode) {

                    var errorMessage = $translate.instant("DMS_RESPONSE_LABEL") + " : ";

                    //in case of string is not uri (example No hablo español), display original message
                    //else decode and escape uri
                    try {
                        errorMessage += decodeURIComponent(escape(error.message));
                    } catch (e) {
                        errorMessage += error.message;
                    }

                    errorMessage += " (" + error.returnCode + ")";

                    toastr.error(errorMessage);
                }
            }).finally(function () {    
                blockUI.stop();
                vm.isValidatingQuote = false;
            });
        }

        /**
         * @name onCalculQuote
         * @desc action fired when user clik on calcul button
         */
        function onCalculQuote(workFlag) {
            if (vm.isCalculating) {
                return $q.reject('Calculation already in progress');
            }            
            vm.isCalculating = true;
            
            //dmsQuote = CacheService.getDmsQuote(); to correct the count in parts popup
            //reset milageInput
            UtilsMetierService.resetErrorFrame(mileageInputId);
            //check if customer informations are set
            vm.isCustomerChoosen = false;
            if (vm.isCustomerFilled && (vm.currentCustomer.name != "" && vm.currentCustomer.accountNumber != "")) {
                vm.isCustomerChoosen = true;
            }

            //check customer, mileAge are set and have at least one item
            var error = runVerifications([checkClient, checkMileage, checkQuoteItems], handleError);
            if (error) {
                vm.isCalculating = false;
                return $q.reject(vm.detectedError);
            }

            //get Inter PR & TM references
            var interPR = [];
            var interTM = [];

            if (vm.quote.inter.length > 0){
                vm.quote.inter.forEach(function (item){
                    if(item.PR.length > 0){
                        item.PR.forEach(function (list){
                            interPR.push(list.reference);
                        })
                    }
                    if(item.TM.length > 0){
                        item.TM.forEach(function (list){
                            interTM.push(list.opecod);
                        })
                    }
                });
            }            

            //get PR references
            var referencesPR = _.filter(vm.quote.items, { type: "PR" }).map(function (prITem) {
                return prITem.reference;
            });

            referencesPR = referencesPR.concat(interPR);
            
            //get TM references
            var referencesTM = _.filter(vm.quote.items, { type: "TM" }).map(function (tmITem) {
                return tmITem.opecod;
            });
            referencesTM = referencesTM.concat(interTM);

            //add paintType if exist to quote
            if (dmsVehicleResponse && dmsVehicleResponse.vehicle && dmsVehicleResponse.vehicle.paintType) {
                vm.quote.paintType = dmsVehicleResponse.vehicle.paintType;
            }

            //if we have PR, call references.v1 to get PR informations
            //and replace pr items response by the old one
            blockUI.start();
            return $q.resolve().then(function () {
                //if quote contains at least one PR, call references.v1 request to update values
                if (referencesPR && referencesPR.length > 0) {
                    return getReferencesInformations(referencesPR).then(function (quotePRInformations) {
                        if (quotePRInformations && quotePRInformations.length > 0) {
                            //parse response, replace each pr with refrences.v1 value
                            quotePRInformations.forEach(function (prItemResponse) {
                                var prItemIndex = _.findIndex(vm.quote.items, { reference: prItemResponse.reference });
                                //replace current item value by references.v1 response value
                                if (prItemIndex >= 0) {
                                    vm.quote.items[prItemIndex].price = prItemResponse.price;
                                    vm.quote.items[prItemIndex].designation = prItemResponse.designation;
                                    vm.quote.items[prItemIndex].stock = prItemResponse.stock;
                                    vm.quote.items[prItemIndex].cort = prItemResponse.cort;
                                    vm.quote.items[prItemIndex].isKnownDms = prItemResponse.isKnownDms;
                                    vm.quote.items[prItemIndex].isDeposit = prItemResponse.isDeposit;
                                    vm.quote.items[prItemIndex].depositReference = prItemResponse.depositReference;
                                }
                                
                                if(vm.quote.inter.length > 0){

                                    vm.quote.inter.forEach(function (item){
                                        if(item.PR.length > 0){
                                            var prItemIndex = _.findIndex(item.PR, function(prItem) { return prItem.reference == prItemResponse.reference && prItem.quantity > 0 });
                                            //dont assign isknowndms for pR with quantity 0
                                            //replace current item value by references.v1 response value
                                            if (prItemIndex >= 0) {
                                                item.PR[prItemIndex].price = prItemResponse.price;
                                                item.PR[prItemIndex].designation = prItemResponse.designation;
                                                item.PR[prItemIndex].stock = prItemResponse.stock;
                                                item.PR[prItemIndex].cort = prItemResponse.cort;
                                                item.PR[prItemIndex].isKnownDms = prItemResponse.isKnownDms;
                                                item.PR[prItemIndex].isDeposit = prItemResponse.isDeposit;
                                                item.PR[prItemIndex].depositReference = prItemResponse.depositReference;
                                            }
                                        }
                                    });
                                }


                            })
                            return vm.quote;
                        }
                    });
                } else if (referencesTM && referencesTM.length > 0) {
                    return getReferencesInformations(referencesTM).then(function (quoteTMInformations) {
                        if (quoteTMInformations && quoteTMInformations.length > 0) {
                            //parse response, replace each pr with refrences.v1 value
                            quoteTMInformations.forEach(function (tmItemResponse) {
                                var tmItemIndex = _.findIndex(vm.quote.items, { reference: tmItemResponse.reference });
                                //replace current item value by references.v1 response value
                                if (tmItemIndex >= 0) {
                                    vm.quote.items[tmItemIndex].price = tmItemResponse.price;
                                    vm.quote.items[tmItemIndex].designation = tmItemResponse.designation;
                                    vm.quote.items[tmItemIndex].stock = tmItemResponse.stock;
                                    vm.quote.items[tmItemIndex].cort = tmItemResponse.cort;
                                    vm.quote.items[tmItemIndex].isKnownDms = tmItemResponse.isKnownDms;
                                }

                                if(vm.quote.inter.length > 0){

                                    vm.quote.inter.forEach(function (item){
                                        if(item.TM.length > 0){
                                            var tmItemIndex = _.findIndex(item.TM, { reference: tmItemResponse.reference });
                                            //replace current item value by references.v1 response value
                                            if (tmItemIndex >= 0) {
                                                item.TM[tmItemIndex].price = tmItemResponse.price;
                                                item.TM[tmItemIndex].designation = tmItemResponse.designation;
                                                item.TM[tmItemIndex].stock = tmItemResponse.stock;
                                                item.TM[tmItemIndex].cort = tmItemResponse.cort;
                                                item.TM[tmItemIndex].isKnownDms = tmItemResponse.isKnownDms;
                                            }
                                        }
                                    });
                                }
                            });
                            return vm.quote;
                        }
                    });
                }
            }).then(function (quoteInformations) {
                //call estimate.v1 request

                //if OrderNumber equals to '-', we delete orederNUmber attribut
                if (quoteInformations && quoteInformations.orderNumber === '-') {
                    delete quoteInformations.orderNumber;
                }
                var tempPrList = _.filter(vm.quote.items, function(val) { return val.type == 'PR'}); 
                var tempTMList = _.filter(vm.quote.items, function(val) { return val.type == 'TM'}); 
                if (vm.quote.inter.length > 0 && vm.quote.items.length > 0 && (vm.isWorkshop || (vm.isPartshop && tempPrList.length > 0))){
                    return $q.all([
                        DmsMetierService.calculQuote(quoteInformations, vm.currentCustomer, 1, vm.dmsLoginContainer,"INT"),
                        DmsMetierService.calculQuote(quoteInformations, vm.currentCustomer, 1, vm.dmsLoginContainer,"PRTM"),
                        DmsMetierService.calculQuote(quoteInformations, vm.currentCustomer, workFlag, vm.dmsLoginContainer,"ALL")
    
                    ]).then(function (calculResponse){
                        if (calculResponse.length < 3) {
                            return $q.reject(calculResponse);
                        }
                        return calculResponse;
    
                    })
                } else if ((vm.isWorkshop && vm.quote.inter.length > 0 && vm.quote.items.length == 0) || ((vm.isPartshop && vm.quote.inter.length > 0 && vm.quote.items.length == 0) || (vm.isPartshop && vm.quote.inter.length > 0 && tempTMList.length > 0 && tempPrList.length == 0))){
                    return DmsMetierService.calculQuote(quoteInformations, vm.currentCustomer, workFlag, vm.dmsLoginContainer, "INT").then(function (calculResponse) {
                        if (!calculResponse.response) {
                            return $q.reject(calculResponse);
                        }
                        return calculResponse;
                    });
                }
                else {
                    return DmsMetierService.calculQuote(quoteInformations, vm.currentCustomer, workFlag, vm.dmsLoginContainer,"PRTM").then(function (calculResponse) {
                        if (!calculResponse.response) {
                            return $q.reject(calculResponse);
                        }
                        return calculResponse;
                    });
                }
            }).then(function (quoteCalculResponse) {
                
                var quoteCalculResponseBody = quoteCalculResponse.length > 1 ? quoteCalculResponse[1].response :quoteCalculResponse.response;
                //set quote to calculated
                vm.unknowPartsNotCalculated = false;
                dmsQuote.isCalculated = true;
                CacheService.setDmsQuote(dmsQuote);
                vm.isQuoteCalculated = true;                

                //set quote status
                vm.quote.quoteStatus = "CalculatedQuote";

                //set dms estimate id
                vm.quote.dmsEstimateId = quoteCalculResponseBody.dmsEstimateId || null;

                if (vm.quote.items.length > 0 ) {

                    var prDetails = quoteCalculResponseBody.parts ? quoteCalculResponseBody.parts.detail : false;
                    angular.copy(prDetails,vm.prDetails);
                    if (prDetails) {
                        vm.itemsReturned.PR = [];
                        //add pr calcul details
                        vm.quote.items = addPrCalculInformations(vm.quote.items, prDetails);

                        //add pr items returned after calcul
                        vm.itemsReturned.PR = addNewPrAfterCalcul(referencesPR, prDetails);
                    }


                    var tmDetails = quoteCalculResponseBody.labourTimes ? quoteCalculResponseBody.labourTimes.detail : false;
                    if (tmDetails) {
                        //add tm calcul details
                        vm.quote.items = addTmCalculInformations(vm.quote.items, tmDetails);

                        //add new tm items returned after calcul
                        vm.itemsReturned.TM = addNewTmAfterCalcul(referencesTM, tmDetails);
                    }

                    //get taxes
                    vm.taxesReturned = getTaxes(quoteCalculResponseBody);                    

                    //get unkown pr whil calcul
                    vm.unknowPartsNotCalculated = vm.quote.items.some(function (item) {
                        return (item.type === 'PR' && !item.isKnownDms)
                    });
                    //set isUncalculatedParts for quote
                    vm.quote.isUncalculatedParts = vm.unknowPartsNotCalculated;

                    //only for PR items, whe need to get the code taxe and designation
                    if (vm.itemsReturned.PR && vm.itemsReturned.PR.length > 0) {
                        return getDmsInformationsForPrItemsReturned(vm.itemsReturned.PR).then(function (prDmsItemsReturned) {
                            //set items returnd PR informations
                            vm.itemsReturned.PR = prDmsItemsReturned;
                            return quoteCalculResponse;
                        })
                    }
                }
                
                return quoteCalculResponse;
            }).then(function (quoteCalculResponse) {
                
                var quoteCalculResponseBody = quoteCalculResponse.length > 1 ? quoteCalculResponse[1].response :quoteCalculResponse.response;
                
                if (vm.quote.inter.length > 0) {
                    var tempPrList = _.filter(vm.quote.items, function(val) { return val.type == 'PR'});
                    var quoteCalculResponseBody = ((vm.isWorkshop && vm.quote.items.length > 0) || (vm.isPartshop && vm.quote.items.length > 0 && tempPrList.length > 0)) ? quoteCalculResponse[0].response : quoteCalculResponse.response;

                    var prDetails = quoteCalculResponseBody.parts ? quoteCalculResponseBody.parts.detail : false;
                    angular.copy(prDetails, vm.prDetails);
                    if (prDetails) {
                        for(var i=0;i< vm.quote.inter.length; i++){
                            vm.quote.inter[i].PR = addPrCalculInformations(vm.quote.inter[i].PR, prDetails);
                        }
                    }


                    var tmDetails = quoteCalculResponseBody.labourTimes ? quoteCalculResponseBody.labourTimes.detail : false;
                    if (tmDetails) {
                        //add tm calcul details
                        for(var i=0;i<vm.quote.inter.length; i++){
                            vm.quote.inter[i].TM = addTmCalculInformations(vm.quote.inter[i].TM, tmDetails);
                        }
                        //add new tm items returned after calcul
                        vm.itemsReturned.TM = addNewTmAfterCalcul(referencesTM, tmDetails);
                    }

                    //get taxes
                    var tempTMList = _.filter(vm.quote.items, function(val) { return val.type == 'TM'});
                    var tempPRList = _.filter(vm.quote.items, function(val) { return val.type == 'PR'});
                    if (vm.quote.items.length == 0 || (vm.isPartshop && tempTMList.length > 0 && tempPRList.length == 0)) {
                        vm.taxesReturned = getTaxes(quoteCalculResponse.response);
                    } else {
                        vm.taxesReturned = getTaxes(quoteCalculResponse[2].response);
                        vm.taxesReturnedPrTm = getTaxes(quoteCalculResponse[1].response);
                    }
                    //get unkown pr whil calcul
                    var interUnknowPart = false;
                    for (var i = 0; i < vm.quote.inter.length; i++) {
                        vm.quote.inter[i].PR = _.orderBy(vm.quote.inter[i].PR, 'quantity', 'asc'); //to make sure quantity 0 are iterated initially 
                        interUnknowPart = vm.quote.inter[i].PR.some(function (item) {
                            return (item.type === 'PR' && item.quantity != 0 && !item.isKnownDms)
                        });
                    }

                    //set isUncalculatedParts for quote
                    vm.unknowPartsNotCalculated = vm.unknowPartsNotCalculated ? vm.unknowPartsNotCalculated : interUnknowPart;
                    vm.quote.isUncalculatedParts = vm.unknowPartsNotCalculated;

                    // FOD INT-only: estimate absent, fall back to labourTimes.total for interItemsTax
                    if (quoteCalculResponseBody.estimate) {
                        vm.interItemsTax = quoteCalculResponseBody.recycling ? quoteCalculResponseBody.estimate.exclTaxes - quoteCalculResponseBody.recycling.exclTaxes : quoteCalculResponseBody.estimate.exclTaxes;
                    } else {
                        var fodTotal = (quoteCalculResponseBody.labourTimes && quoteCalculResponseBody.labourTimes.total) || {};
                        vm.interItemsTax = quoteCalculResponseBody.recycling ? (fodTotal.exclTaxes || 0) - (quoteCalculResponseBody.recycling.exclTaxes || 0) : (fodTotal.exclTaxes || 0);
                    }
                    vm.quote.interItemsTax = vm.interItemsTax;

                    var promiseArray =_.map(vm.quote.inter, function(data){
                        var isadditionaldms = _.find(data.PR, function (list) { return list.isDeposit == true });
                        if(isadditionaldms){
                            var ref = isadditionaldms.reference;
                            var refPR = _.filter(prDetails,function(list){ return list.reference == isadditionaldms.depositReference})
                            
                            data.itemsReturnedPR = addNewPrAfterCalcul(ref, refPR);
                            if(data.itemsReturnedPR && data.itemsReturnedPR.length > 0){
                       
                                return getDmsInformationsForPrItemsReturned(data.itemsReturnedPR).then(function (prDmsItemsReturned) {
                                //set items returnd PR informations
                                data.itemsReturnedPR = prDmsItemsReturned;          
                                })
                            }
                        }
                        
                    })
                    return $q.all(promiseArray).then(function () {                                                  
                        return quoteCalculResponse;                        
                    })
                }
                
                return quoteCalculResponse;
            }).then(function (quoteCalculResponse) {
                if (referencesTM.length > 0) {
                    var opeCodesResponse = [];
                    //call tm documents by code to extend tm items by (technicality and businessSpecifities object)                    
                        return DocumentsMetierService.returnTmDocumentsByOpeCode(referencesTM).then(function (response) {

                            opeCodesResponse = response.TM;
                            return DmsMetierService.getHourlyRatesLogic().then(function (hourlyRatesResponse) {
                                if (hourlyRatesResponse.returnCode === 0) {
                                    hourlyRates.values = hourlyRatesResponse.response;
                                    vm.isHourlyRatesLoaded = true;

                                    if(vm.quote.inter.length > 0){
                                        var interTM = [];
                                        vm.quote.inter.forEach( function (item){
                                            var listtm = _.filter(item.TM, function (list){
                                                return list.type == "TM";
                                            })
                                            interTM.push(listtm);
                                        })
                                        interTM.push(vm.quote.items);
                                        interTM = interTM.flat();
    
                                        getTmHourlyRates(interTM, opeCodesResponse);
                                        var tempTMList = _.filter(vm.quote.items, function(val) { return val.type == 'TM'});

                                        if (vm.quote.items.length == 0 || (vm.isPartshop && tempTMList.length > 0)) {
                                            quoteCalculResponse.hourlyRates = hourlyRates;
                                        } else {
                                            quoteCalculResponse[1].hourlyRates = hourlyRates;
                                        }
                                    }else{
                                        getTmHourlyRates(vm.quote.items, opeCodesResponse);
                                        quoteCalculResponse.hourlyRates = hourlyRates;
                                    }
                                }
                                return quoteCalculResponse;
                            })
                                .then(function (quoteCalculResponse) {
                                    var referencesNoncodifiedTM = _.filter(vm.quote.items, function (item) {
                                        return item.codified == false && !item.exclTaxes;
                                    }).map(function (tmITem) {
                                        return tmITem.reference;
                                    });
                                    if (referencesNoncodifiedTM && referencesNoncodifiedTM.length > 0) {
                                        var TMNonCodifiedList = [];
                                        var fillTheTMNonCodifiedList = referencesNoncodifiedTM.map(function (ref) {
                                            return FavoitMetierService.getNonCodedTmByRefByCacheDealerId(ref).then(function (response) {
                                                response.ref = ref;
                                                !_.isEmpty(matchTheHourlyRates(response)) ? TMNonCodifiedList.push(matchTheHourlyRates(response)) : '';
                                                return TMNonCodifiedList;
                                            });
                                        })
                                        return $q.all(fillTheTMNonCodifiedList).then(function () {
                                            TMNonCodifiedList.forEach(function (val) {
                                                var temp = val.hourlyRate;
                                                var matchReferences = _.find(vm.quote.items, ["reference", val.ref]);
                                                if (matchReferences && quoteCalculResponse.hourlyRates && quoteCalculResponse.hourlyRates.values) {
                                                    matchReferences.hourlyRate = quoteCalculResponse.hourlyRates.values[temp];
                                                }
                                                quoteCalculResponse.matchReferences = matchReferences;
                                            })
                                            return quoteCalculResponse;
                                        })
                                    }
                                    return quoteCalculResponse;
                                });
                        });                    
                }
                return quoteCalculResponse;
            }).catch(function (error) {
                unsetCalcul();
                /* if (error.returnCode && error.message) {
                    var errorMessage = $translate.instant("DMS_RESPONSE_LABEL") + " : ";
 
                    //in case of string is not uri (example No hablo español), display original message
                    //else decode and escape uri
                    try {
                        errorMessage += decodeURIComponent(escape(error.message));
                    } catch (e) {
                        errorMessage += error.message;
                    }
 
                    errorMessage += " (" + error.returnCode + ")";
 
                    toastr.error(errorMessage);
                }
                else if(error.status != 200){
                    toastr.error($translate.instant("DMS_ERROR_VALIDATION"));
                } */

            }).finally(function () {
                blockUI.stop();
                vm.isCalculating = false;
            })
        }

        /**
         * @name putQuoteItemsToPartRequisition
         * @desc put quote items to part requisition
         */
        function putQuoteItemsToPartRequisition() {
            var dmsQuote = CacheService.getDmsQuote();
            CacheService.saveQuoteCustomer(dmsQuote.customer);
            const shallowCopyOfQuote = angular.copy(vm.quote);
            QuoteMetierService.putQuoteItemsToPartRequisition(shallowCopyOfQuote).then(function () {
                getQuoteInformations();
            })
        }

        /**
         * @name getCreatePartRequisitionFromQuoteClass
         * @desc activate part requisition when having at least 1 PR, desactivate it else
         */
        function getCreatePartRequisitionFromQuoteClass() {
            var transformQuoteToPartRequisitionClass = "verserBonServiceEstimation";
            if (!vm.prButton) {
                transformQuoteToPartRequisitionClass += " inactif";
            }
            return transformQuoteToPartRequisitionClass;
        }

        function getTaxes(quoteResponse) {
            var structuredTaxes = {};
            var labourTimesTotal = quoteResponse.labourTimes ? quoteResponse.labourTimes.total : null;
            // estimate is absent for INT-only calculate; fall back to labourTimes.total so global totals render
            structuredTaxes.global = quoteResponse.estimate || labourTimesTotal;
            structuredTaxes.labourTimes = labourTimesTotal;
            structuredTaxes.parts = quoteResponse.parts ? quoteResponse.parts.total : null;
            structuredTaxes.totalPaintAmount = quoteResponse.totalPaintAmount;
            structuredTaxes.basisSuppliesAmount = quoteResponse.basisSuppliesAmount;
            structuredTaxes.totalSuppliesAmount = quoteResponse.totalSuppliesAmount;
            structuredTaxes.recycling = quoteResponse.recycling;
            return structuredTaxes;
        }

        /**
         *  @desc Display modal, and delete if the user confirms the suppression
         *  @param {object} item
         */
        function onConfirm () {
            var closed = $mdDialog.hide();
            closed.then(function () {
                deletedDesignation(vm.item);
            })
        }

        function onCancel () {
            $mdDialog.hide();
        }
        function deleteByDesignation(item,isDelete){
            var parent = angular.element(document.body);
             $mdDialog.show({
                 parent: parent,
                 templateUrl:
                     "app/components/basket/delete-dialog.template.html",
                     controller: "deleteReferenceModal",
                     locals: {
                         item: item,
                         designation: item.designation,
                         isDelete: isDelete
                     },
                     bindToController: true,
                     controllerAs: "vm",
                     clickOutsideToClose: true
                 
                 }).then(function () {
                         blockUI.start();
                         deletedDesignation(item).catch(function () {
                                     toastr.error($translate.instant('ERROR'));
                                 }).finally(function () {
                                     blockUI.stop();
                                 });
                     }) 
         }

         function deletedDesignation(basketData) {
            var prList = basketData.PR ? basketData.PR : [];
            var tmList = basketData.TM ? basketData.TM : [];
            var interventionItem = prList[0] || tmList[0];
            var interventionIds = interventionItem && interventionItem.interventionId;
            if (!interventionIds) {
                return $q.reject('Missing intervention ID');
            }
            var interventionList = tmList.concat(prList);
            var referenceList = [];
            if (!_.isEmpty(interventionList)) {
                interventionList.forEach(function (item) {
                    var reference = _.get(item, 'reference');
                    referenceList.push(reference);
                });
            }
            var payload = {
                references:_.uniq(referenceList),
                isDelete: true
            };
            QuoteMetierService.deleteQuoteIntervention(vm.quote.id, interventionIds, payload).then(function (response) {
                if(!_.isEmpty(response)){
                    vm.quote.inter.forEach(function(item){
                        if(item && !_.isEmpty(item.PR)){
                          item.interventionId = (item.PR[0] && item.PR[0].interventionId) ? item.PR[0].interventionId : null;
                        }
                        if(item && !_.isEmpty(item.TM)){
                            item.interventionId = (item.TM[0] && item.TM[0].interventionId) ? item.TM[0].interventionId : null;
                          }
                    })
                    var list = (response && response.items ) ? _.groupBy(response.items, 'interventionId') : "";
                    if(list && _.isEmpty(list)){
                        _.remove(vm.quote.inter);
                    }
                    else{
                        var quoteGroup = _.groupBy(vm.quote.inter, 'interventionId');
                var interFilter = Object.keys(list).map(function (keyNew) {
                    if(keyNew && keyNew != "null" && quoteGroup[keyNew]){
                    return quoteGroup[keyNew]
                    }
                });
                var finalFilteredArray =[];
                interFilter.forEach(function(data){
                    if(data && !_.isEmpty(data)){
                        data.forEach(function(data2){
                            finalFilteredArray.push(data2)
                        })
                     
                    }
                })
                vm.quote.inter = finalFilteredArray;  
            }    
                $timeout(function () {
                    $rootScope.$emit(QuoteConstants.quoteSpread, vm.quote);
                }, 1000);
            }   
              }).catch(handleError).finally(function () {
                blockUI.stop();
              })  
        }
        function deleteReference(item) {
            //get modal parameters
            var reference = item.type === 'TM' ? item.opecod : item.reference;
            var body = angular.element(document.body);
            var designation = item.designation;
            var modalParams = {
                body: body,
                designation: designation,
                isList: false,
                title: "ESTIMATE_DELETE_REF",
                ref: reference
            };


            //open modal Yes/No
            DeleteModalService.showModal(modalParams).then(function () {
                blockUI.start();
                //call service to delete part
                QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.REPLACE_QUANTITY, {
                    piece: item,
                    quantity: 0,
                    type: item.type
                }).then(function () {
                    if(item.interventionId !=null){
                        vm.quote.inter.forEach(function (list){
                            if(list.PR.length > 0 && item.type == "PR"){                                
                                _.remove(list.PR, { reference: item.reference, interventionId : item.interventionId});
                            }
                            else if(list.TM.length > 0 && item.type == "TM"){
                                _.remove(list.TM, { opecod: item.opecod });                                
                            }
                        })
                    }
                    //update quote items
                    else{
                        _.remove(vm.quote.items, { reference: item.reference });
                    }                    
                    vm.prItems =  vm.getPrItems();
                    //show/hide PR block
                    vm.isShowPR = _.filter(vm.quote.items, { type: "PR" }).length == 0 ? false : true;
                    vm.prButton = vm.isShowPR || vm.prItems.length > 0 ? true : false;
                    //show/hide TM block
                    vm.isShowTM = _.filter(vm.quote.items, { type: "TM" }).length == 0 ? false : true;
                    vm.checkInter();
                    unsetCalcul();
                }).catch(function () {
                    toastr.error($translate.instant('ERROR'));
                }).finally(function () {
                    blockUI.stop();
                });
            })
        }

        function checkInter(){
            for (var i=0; i <vm.quote.inter.length; i++){
                if(vm.quote.inter[i].PR.length == 0 & vm.quote.inter[i].TM.length == 0){
                  vm.quote.inter.splice(i,1);
                }
            }
            return !_.isEmpty(vm.quote.inter);
        }

        /**
         * @name goToProduct
         * @desc navigate to product file for PR reference
         * @param {Object} piece
         */
        function goToProduct(piece) {
            var path = {
                reference: piece.reference,
                mainReference: piece.initialReference,
                genericPart: piece.genericPart,
                quantity: piece.quantity
            };

            RoutingService.goToProductPage({
                path: path
            });
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        function getPrItems(){
            var pr = [];
            if (vm.quote.inter && vm.quote.inter.length > 0){
                vm.quote.inter.forEach(function (item){
                    pr.push(item.PR)
                })
                pr = pr.flat();
            }            
            
            var temp = _.filter(vm.quote.items, { type: "PR" });
            pr = pr.concat(temp);            
            return pr;

        }

        /**
         *      @desc function called when the user want to insert a new ref
         *      @param ref string
         */
        function addReference(reference) {
            var nonCodifiedTm = ['0999', '1999', '1888', '1777', '2999', '2888', '2777', '3999', '3888', '3777', '6999', '6888', '6777', '8999', '8888', '8777', '4999', '4888', '4777', '5999', '5888', '5777', '6999', '6888', '6777', '7999', '7888', '7777', '9499'];
            if (!reference) {
                return;
            }
            reference = reference.replace(/\s/g, '');
            if ((reference.length !== QuoteConstants.PRLength && reference.length !== QuoteConstants.TMLength)) {
                toastr.error($translate.instant('COMMON_ERROR_INVALID_FORMAT_PRTM'));
                return;
            }
            else if (_.indexOf(nonCodifiedTm, reference) >= 0) {
                toastr.error($translate.instant('DOCUMENT_NO_TM_FOUND'));
                return;
            }
            reference = reference.toUpperCase();

            //manage TM case
            if (reference.length === QuoteConstants.TMLength) {
                var tmItems = _.filter(vm.quote.items, { type: "TM" });
                var tmExist = _.find(tmItems, function (tmItem) { return tmItem.opecod == reference && tmItem.interventionId == null });
                var item = {};
                //if tm exist
                if (tmExist) {
                    var quote = QuoteMetierService.getQuoteData();
                    var quoteTmExist = _.find(quote && quote.shoppingCart.TM, function (tmItem) { return tmItem.opecod == reference });
                    //set payload
                    item = {
                        reference: tmExist.reference,
                        designation: tmExist.designation,
                        quantity: tmExist.quantity + 1,
                        opecod: reference,
                        id: tmExist.opecod,
                        essay: quoteTmExist && quoteTmExist.essay ? quoteTmExist.essay : tmExist.essay
                    }

                    blockUI.start();
                    //update quote tm quantity
                    QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                        piece: item,
                        type: 'TM'
                    }).then(function () {
                        //update tm quantity
                        tmExist.quantity = Number(tmExist.quantity) + 1;

                        if (!Object.values(_essai).includes(item.id) && item.essay && item.essay !== '5' && item.essay !== '3') {
                            //add tm to quote items
                            var testOpcode;
                            Object.keys(_essai).forEach(function (key) {
                                if (item.essay == key) {
                                    testOpcode = _essai[key];
                                }
                            })

                            var tmItems = _.filter(vm.quote.items, { type: "TM" });
                            var tmOpcodExist = _.find(tmItems, function (tmItem) { return tmItem.opecod == testOpcode });
                           if (tmOpcodExist) {
                               tmOpcodExist.quantity = tmOpcodExist.quantity;
                            }
                            else {
                                blockUI.start();
                                DocumentsMetierService.returnTmDocumentsByOpeCode([testOpcode]).then(function (response) {
                                    var responseData = response.TM[0];
                                    var testTmInformations = {
                                        designation: responseData.designation,
                                        laborTime: responseData.duration,
                                        opecod: testOpcode,
                                        quantity: 1,
                                        reference: responseData.technicalId,
                                        id: response.id,
                                        type: "TM",
                                        element: responseData.element,
                                        operation: responseData.operation,
                                        essay: responseData.essay
                                    };

                                    var isTestOpecodExists = [];
                                    var isTestOpcode = false;
                                    tmItems.forEach(function (piece) {
                                        if (Object.values(_essai).includes(piece.opecod)) {
                                            isTestOpecodExists.push(piece);
                                        }
                                    })

                                    if (isTestOpecodExists && !_.isEmpty(isTestOpecodExists) && isTestOpecodExists != null) {
                                        var deletedTM = [];
                                        var testOpecodTime = isTestOpecodExists[0].laborTime ? (typeof isTestOpecodExists[0].laborTime === 'string' ? parseFloat(isTestOpecodExists[0].laborTime.replace(",", ".")) : isTestOpecodExists[0].laborTime) : 0;

                                        var tmLaborTime = testTmInformations.laborTime ? (typeof testTmInformations.laborTime === 'string' ? parseFloat(testTmInformations.laborTime.replace(",", ".")) : testTmInformations.laborTime) : 0;

                                        if (isTestOpecodExists.length > 1) {
                                            for (var index = 0; index < isTestOpecodExists.length; index++) {
                                                var indexOne = isTestOpecodExists[index].laborTime ? (typeof isTestOpecodExists[index].laborTime === 'string' ? parseFloat(isTestOpecodExists[index].laborTime.replace(",", ".")) : isTestOpecodExists[index].laborTime) : 0;
                                                var indexTwo = isTestOpecodExists[index + 1].laborTime ? (typeof isTestOpecodExists[index + 1].laborTime === 'string' ? parseFloat(isTestOpecodExists[index + 1].laborTime.replace(",", ".")) : isTestOpecodExists[index + 1].laborTime) : 0;

                                                if (indexOne < tmLaborTime && indexTwo < tmLaborTime) {
                                                    for (var i in isTestOpecodExists) {
                                                        deletedTM.push(isTestOpecodExists[i]);
                                                    }
                                                    break;
                                                } else if (indexOne < tmLaborTime || indexTwo < tmLaborTime) {
                                                    var deleteOpcod = indexOne < tmLaborTime ? isTestOpecodExists[index] : isTestOpecodExists[index + 1];

                                                    deletedTM.push(deleteOpcod);

                                                    isTestOpcode = true;
                                                    break;
                                                }
                                            }
                                        } else if (testOpecodTime < tmLaborTime) {
                                            deletedTM.push(isTestOpecodExists[0]);
                                        }
                                        else {
                                            isTestOpcode = true;
                                        }
                                        if (deletedTM && !_.isEmpty(deletedTM)) {
                                            deletedTM.forEach(function (piece) {
                                                _.remove(vm.quote.items, { opecod: piece.opecod });
                                            })
                                            if (!isTestOpcode) {
                                                vm.quote.items.push(testTmInformations);
                                            }
                                        }
                                    } else {
                                        vm.quote.items.push(testTmInformations);
                                    }
                                })
                            }
                        }

                        vm.reference = "";
                        unsetCalcul();
                        blockUI.stop();
                    }).catch(function (err) {
                        if (err != 2) {
                            toastr.error($translate.instant('DOCUMENT_NO_TM_FOUND'));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
                }
                //if tm doesn' exist
                else {
                    blockUI.start();
                    DocumentsMetierService.getTmInformation([reference]).then(function (tmResponse) {
                        switch (tmResponse) {
                            case -1:
                                toastr.error($translate.instant('DOCUMENT_NO_TM_FOUND'));
                                break;
                            case -2:
                                toastr.info($translate.instant('DOCUMENT_TM_MULTIPLE_RESULT_RETRY'));
                                break;
                            default: {
                                //TODO: add paint type to TM
                                // selectPaintTypeIfNoSetAndAddTm(typeOfRef, opeCodeResponse, ref);

                                //set payload to send
                                _.extend(item, { reference: tmResponse.technicalId }, { designation: tmResponse.designation }, { operation: tmResponse.operation }, { element: tmResponse.element }, { quantity: 1 }, { id: tmResponse.id }, { duration: tmResponse.duration }, { essay: tmResponse.essay });

                                //set tm item to push
                                var itemTmInformations = {
                                    designation: tmResponse.designation,
                                    laborTime: tmResponse.duration,
                                    opecod: reference,
                                    quantity: 1,
                                    reference: tmResponse.technicalId,
                                    id: tmResponse.id,
                                    type: "TM",
                                    element:tmResponse.element,
                                    operation: tmResponse.operation,
                                    essay: tmResponse.essay
                                };
                                if (tmResponse && tmResponse.id) {
                                    _.extend(item, { isTestOpcode: Object.values(_essai).includes(tmResponse.id) ? true : false });
                                }
                                //update quote tm quantity
                                QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                                    piece: item,
                                    type: 'TM'
                                }).then(function () {
                                    if (!Object.values(_essai).includes(item.id) && item.essay !== '5' && item.essay !== '3') {
                                        //add tm to quote items
                                        vm.quote.items.push(itemTmInformations);
                                        var testOpcode;
                                        Object.keys(_essai).forEach(function (key) {
                                            if (item.essay == key) {
                                                testOpcode = _essai[key];
                                            }
                                        })
                                        var tmItems = _.filter(vm.quote.items, { type: "TM" });
                                        var tmExist = _.find(tmItems, function (tmItem) { return tmItem.opecod == testOpcode });
                                        if (tmExist) {
                                            tmExist.quantity = tmExist.quantity;
                                        }
                                        else {
                                            blockUI.start();
                                            DocumentsMetierService.returnTmDocumentsByOpeCode([testOpcode]).then(function (response) {
                                                var responseData = response.TM[0];
                                                var testTmInformations = {
                                                    designation: responseData.designation,
                                                    laborTime: responseData.duration,
                                                    opecod: testOpcode,
                                                    quantity: 1,
                                                    reference: responseData.technicalId,
                                                    id: response.id,
                                                    type: "TM",
                                                    element: responseData.element,
                                                    operation: responseData.operation,
                                                    essay: responseData.essay
                                                };

                                                var isTestOpecodExists = [];
                                                var isTestOpcode = false;
                                                tmItems.forEach(function (piece) {
                                                    if (Object.values(_essai).includes(piece.opecod)) {
                                                        isTestOpecodExists.push(piece);
                                                    }
                                                })

                                                if (isTestOpecodExists && !_.isEmpty(isTestOpecodExists) && isTestOpecodExists != null) {
                                                    var deletedTM = [];
                                                    var testOpecodTime = isTestOpecodExists[0].laborTime ? (typeof isTestOpecodExists[0].laborTime === 'string' ? parseFloat(isTestOpecodExists[0].laborTime.replace(",", ".")) : isTestOpecodExists[0].laborTime) : 0;

                                                    var tmLaborTime = testTmInformations.laborTime ? (typeof testTmInformations.laborTime === 'string' ? parseFloat(testTmInformations.laborTime.replace(",", ".")) : testTmInformations.laborTime) : 0;

                                                    if (isTestOpecodExists.length > 1) {
                                                        for (var index = 0; index < isTestOpecodExists.length; index++) {
                                                            var indexOne = isTestOpecodExists[index].laborTime ? (typeof isTestOpecodExists[index].laborTime === 'string' ? parseFloat(isTestOpecodExists[index].laborTime.replace(",", ".")) : isTestOpecodExists[index].laborTime) : 0;
                                                            var indexTwo = isTestOpecodExists[index + 1].laborTime ? (typeof isTestOpecodExists[index + 1].laborTime === 'string' ? parseFloat(isTestOpecodExists[index + 1].laborTime.replace(",", ".")) : isTestOpecodExists[index + 1].laborTime) : 0;

                                                            if (indexOne < tmLaborTime && indexTwo < tmLaborTime) {
                                                                for (var i in isTestOpecodExists) {
                                                                    deletedTM.push(isTestOpecodExists[i]);
                                                                }
                                                                break;
                                                            } else if (indexOne < tmLaborTime || indexTwo < tmLaborTime) {
                                                                var deleteOpcod = indexOne < tmLaborTime ? isTestOpecodExists[index] : isTestOpecodExists[index + 1];

                                                                deletedTM.push(deleteOpcod);

                                                                isTestOpcode = true;
                                                                break;
                                                            }
                                                        }
                                                    } else if (testOpecodTime < tmLaborTime) {
                                                        deletedTM.push(isTestOpecodExists[0]);
                                                    }
                                                    if (deletedTM && !_.isEmpty(deletedTM)) {
                                                        deletedTM.forEach(function (piece) {
                                                            _.remove(vm.quote.items, { opecod: piece.opecod });
                                                        })
                                                        if (!isTestOpcode) {
                                                            vm.quote.items.push(testTmInformations);
                                                        }
                                                    }
                                                    
                                                } else {
                                                    vm.quote.items.push(testTmInformations);
                                                }
                                                vm.isShowTM = _.filter(vm.quote.items, { type: "TM" }).length == 0 ? false : true;
                                                vm.reference = "";
                                                unsetCalcul();
                                                blockUI.stop();
                                            })
                                        }
                                    } else if (Object.values(_essai).includes(itemTmInformations.opecod)) {
                                            vm.quote.items.push(itemTmInformations);
                                    }else{
                                        vm.quote.items.push(itemTmInformations);
                                    }

                                        //show/hide TM block
                                        vm.isShowTM = _.filter(vm.quote.items, { type: "TM" }).length == 0 ? false : true;
                                        vm.reference = "";
                                        unsetCalcul();
                                }).catch(function (err) {
                                    if (err == 2) {
                                        var removeTM = [];

                                        vm.quote.items.forEach(function (piece) {
                                            if (Object.values(_essai).includes(piece.opecod)) {
                                                removeTM.push(piece);
                                            }
                                        })
                                        removeTM.forEach(function (tm) {
                                            _.remove(vm.quote.items, { opecod: tm.opecod });
                                        })

                                        vm.quote.items.push(itemTmInformations);

                                        //show/hide TM block
                                        vm.isShowTM = _.filter(vm.quote.items, { type: "TM" }).length == 0 ? false : true;
                                        vm.reference = "";
                                        unsetCalcul();
                                    } else if (err == 3) {
                                        vm.isShowTM = _.filter(vm.quote.items, { type: "TM" }).length == 0 ? false : true;
                                        vm.reference = "";
                                        unsetCalcul();
                                    }
                                    else {
                                        toastr.error($translate.instant('DOCUMENT_NO_TM_FOUND'));
                                    }
                                    
                                }).finally(function () {
                                    blockUI.stop();
                                });
                            }
                        }


                    }).catch(function (err) {

                    }).finally(function () {
                        blockUI.stop();
                    });
                }
            }
            
            vm.prItems = vm.getPrItems();
            var prExist = _.find(vm.prItems, function (prItem) { return prItem.reference == reference && prItem.interventionId == null });
            if(vm.prItems && vm.prItems.length >= 99 && vm.reference.length == 10){

                if(!prExist){
                    toastr.error($translate.instant('MAX_LIMIT_REACHED_ERROR'));
                    return;
                }
                else {
                    item = {
                        reference: reference
                    }
                    _.extend(item, { quantity: 1 });
                    blockUI.start();
                    //update quantity
                    QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                        piece: item,
                        type: 'PR'
                    }).then(function () {
                        //refresh pr quantity
                        prExist.quantity = Number(prExist.quantity) + 1;
                        vm.reference = "";
                        unsetCalcul();
                    }).catch(function () {
                        toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                    }).finally(function () {
                        blockUI.stop();
                    });
                }
            }

            //manage PR case
            else if (reference.length === QuoteConstants.PRLength) {
                //manage case local piece
                if (reference >= QuoteConstants.localPiece.min && reference <= QuoteConstants.localPiece.max) {
                    blockUI.start();
                    QuoteMetierService.addLocalItem(vm.quote.items, reference).then(function (localPieceInformations) {
                        vm.isShowPR = true;
                        vm.prButton = true;
                        vm.quote.items = localPieceInformations;
                    }).catch(function (err) {
                        if (!err.status) {
                            switch (err) {
                                case QuoteConstants.errors.partNotFound:
                                    toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                                    break;
                                default:
                                    toastr.error($translate.instant('ERROR'));
                                    break;
                            }
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
                }
                //manage case central piece
                else {
                    var prItems = vm.getPrItems();
                    var prExist = _.find(prItems, function (prItem) { return prItem.reference == reference && prItem.interventionId == null });
                    item = {
                        reference: reference
                    }

                    //case pr don't exist
                    if (!prExist) {
                        blockUI.start();
                        //call references.v1 (dms) and product (datahub) to get informations
                        DocumentsMetierService.getReferencesInformations([reference]).then(function (prResponse) {
                            if (_.isEmpty(prResponse[0].designation) && prResponse[0].price == 0) {
                                return $q.reject("UNKOWN");
                            }

                            else if (!prResponse[0] || !prResponse[0].isKnownDms) {
                                toastr.info($translate.instant('COMMON_ERROR_REF_DMS'), '', {
                                    timeOut: 2000
                                });
                            }

                            return prResponse;

                        }).then(function (prResponse) {
                            if (prResponse.length == 1) {
                                //set payload to send
                                _.extend(item, { quantity: 1 }, { designation: prResponse[0].designation });

                                //set PR item to push
                                var itemPrInformations = _.extend(item,
                                    { type: "PR" },
                                    { cort: prResponse[0].cort },
                                    { price: prResponse[0].isKnownDms ? prResponse[0].price : null },
                                    { isLocalPiece: false },
                                    { stock: prResponse[0].stock });


                                //add new piece
                                return QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_PIECE, {
                                    piece: item,
                                    type: 'PR'
                                }).then(function () {
                                    vm.quote.items.push(itemPrInformations);
                                    vm.prItems = vm.getPrItems();
                                    //show/hide PR block
                                    vm.isShowPR = _.filter(vm.quote.items, { type: "PR" }).length == 0 ? false : true;
                                    vm.prButton = vm.isShowPR || vm.prItems.length > 0 ? true : false;
                                    vm.reference = "";
                                    unsetCalcul();
                                });
                            }
                            else {
                                $q.reject("COMMON_ERROR_UNKNOWN_REFERENCE");
                            }

                        }).catch(function (err) {
                            if (!err.status) {
                                toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                            }
                        }).finally(function () {
                            blockUI.stop();
                        });
                    }
                    //case pr exist
                    else {
                        _.extend(item, { quantity: 1 }, {type: "PR"});
                        blockUI.start();
                        //update quantity
                        QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.ADD_QUANTITY, {
                            piece: item,
                            type: 'PR'
                        }).then(function () {
                            //refresh pr quantity
                            prExist.quantity = Number(prExist.quantity) + 1;
                            vm.reference = "";
                            unsetCalcul();
                        }).catch(function () {
                            toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                        }).finally(function () {
                            blockUI.stop();
                        });
                    }
                }
            }

        }


        /**
         * @name backToPrevious
         * @desc back to previous state
         */
        function backToPrevious() {
            //back to quoteListDraft page if we come from quoteListDraft with options list (filters, sort, pagination)
            //back to previous page else
            if (!$state.params.quoteListOptions) {
                $window.history.back();
            } else {
                $state.go(RoutesConstants.quoteListDraft, {
                    quoteListOptions: $state.params.quoteListOptions
                });
            }
        }

        /**
         * @name getTMDuration
         * @desc get tm's labor tom
         * @param {Object} tm
         */
        function getTMDuration(tm) {
            if (_.isNumber(tm.exclTaxes) && tm.exclTaxes >= 0) {
                return '-';
            }

            return tm.laborTime ? tm.laborTime : "XXXX";
        }


        /**
         * @name saveQuote
         * @desc saves the user's changes / deletions and the quote remains active.
         * @param {Object} quote the current bs
         * @param {bool} hidePopin display the popin or not when the request is done
         */
        function saveQuote(quote) {
            //send only quote without items
            quote = _.omit(quote, ['items', 'inter','interItemsTax']);

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(quote).then(function () {
                toastr.success($translate.instant("ESTIMATION_SAVE_SUCCESS") + " (" + quote.number + ")");
            }).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }


        /**
         * @name closeQuote
         * @desc registers the quote and is added to the user's draft quote list. The quote is no longer active.
         * @param {object} quote the id of current bs
         * @param {Boolean} isFromInit Hack to call the backToPrevious function only when needed
         */
        function closeQuote(quote, isFromInit) {
            if (!quote) {
                return;
            }

            //send only quote without items
            quote = _.omit(quote, 'items');

            $q.resolve().then(function () {
                if (dmsQuote && dmsQuote.isCustomerUpdated) {
                    return warningModalCustomerService.displayModal();
                }
            }).then(function () {
                return QuoteMetierService.saveAndCloseCurrentQuote(quote).then(function () {
                    toastr.success($translate.instant("ESTIMATION_CLOSE_SUCCESS") + " (" + quote.number + ")");
                    if (!isFromInit) {
                        backToPrevious();
                    }
                });
            }).catch(function (err) {
                if (err === globalConstant.cancelModal) {
                    // handle cancel from modal, catch to avoid warning on browser
                } else {
                    toastr.success($translate.instant("ESTIMATION_CLOSE_FAILURE"));
                }
            });


        }


        function getStockClass(piece) {
            if ((piece.dmsInformations) && (piece.dmsInformations.quantity > 0) && (piece.quantity <= piece.dmsInformations.quantity)) {
                return 'stockDispo';
            } else {
                return 'stockIndispo';
            }
        }

        /**
         *  @name onChangeDescription
         *  @desc save quote's mention once changed
         *  @return {void}
         *
         */
        function onChangeDescription() {
            //create payload to update description
            var payload = { id: vm.quote.id, description: vm.quote.description };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
                // We lost focus on textarea cause of blockUI, we force back it
                // without $timeout is not working well :/
                $timeout(function () {
                    angular.element(document.getElementById("description")).focus();
                }, 0);
            });
        }

        /**
         * @name onChangeMention
         * @desc save quote's mention once changed
         */
        function onChangeMentions() {
            //create payload to update mention
            var payload = { id: vm.quote.id, mentions: vm.quote.mentions };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @name onChangeKM
         * @desc save quote's km once changed
         */
        function onChangeKM(kmInput) {
            //parse value to int
            var mileAge = kmInput ? parseInt(kmInput) : 0;

            //create payload to update mention
            var payload = { id: vm.quote.id, mileAge: mileAge };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function onChangeOrderNumber(orderNumber) {
            if (orderNumber === '-') {
                orderNumber = '';
            }
            //create payload to update order number
            var payload = { id: vm.quote.id, orderNumber: orderNumber };

            //call save quote service
            blockUI.start();
            QuoteMetierService.saveQuote(payload).catch(function () {
                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @name sortPRBy
         * @desc sort PR by (ascendant or descandant)
         */
        function sortPRBy(propertyName) {
            vm.reversePR = (vm.propertyNamePR === propertyName) ? !vm.reversePR : false;
            vm.propertyNamePR = propertyName;
        }

        /**
         * @name sortTMBy
         * @desc sort TM by (ascendant or descandant)
         */
        function sortTMBy(propertyName) {
            vm.reverseTM = (vm.propertyNameTM === propertyName) ? !vm.reverseTM : false;
            vm.propertyNameTM = propertyName;
        }

        /*=============================================
        =                 TOOLS                      =
        =============================================*/

        function unsetCalcul() {
            if (vm.isQuoteCalculated) {
                vm.quote.isUncalculatedParts = false;
                vm.isQuoteCalculated = false;
                dmsQuote.isCalculated = false;
                CacheService.setDmsQuote(dmsQuote);
            }
        }
        /**
         * @name updateCartMetadataOnTM
         * @desc parse items to get only TM and get hourly rate of each row
         * @param {Array} items
         * @param opeCodesResponse - the response of returnTmDocumentsByOpeCode service to add technicality and bussiness specifities
         */
        function getTmHourlyRates(items, opeCodesResponse) {
            vm.isLoadingDMSData = true;
            var tmList = items.filter(function (item) {
                return item.type === 'TM';
            })
            tmList.forEach(function (currentTM) {
                opeCodesResponse.filter(function (item) {
                    if (item.id == currentTM.opecod) {
                        currentTM.businessSpecificities = item.businessSpecificities;
                        currentTM.technicality = item.technicality;
                    }
                });
                currentTM = QuoteMetierService.getHourlyRate(currentTM, hourlyRates);
                vm.isLoadingDMSData = false;
            });
        }

        /**
         * @name runVerifications
         * @param {array<function>} verifications
         * @return {bool}
         */
        function runVerifications(verifications, callback) {
            if (typeof callback !== 'function') {
                throw new TypeError('ERROR : 12340');
            }

            return verifications.some(function (verification) {
                var error = verification();
                if (error) {
                    callback(error);
                    return true;
                }
                return false;
            });
        }

        /**
         *  @desc Check client if it's already set, if not, check currentCustumer
         *  @return {number}
         */
        function checkClient() {
            return vm.isCustomerChoosen ? 0 : vm.detectedError = _errors.emptyClient;
        }

        /**
         *  @desc Check mileage, it's must be set if we have a car context
         *  @return     {number}
         */
        function checkMileage() {
            var carContext = CacheService.getCarContext();
            if (carContext) {
                var mileage = vm.quote.mileAge;
                if ((!mileage || mileage == 0) && vm.isWorkshop) {
                    return vm.detectedError == _errors.emptyMileage;
                }
            }
            return 0;
        }

        /**
         *  @desc checkQuoteItems
         *  @return {number}
         */
        function checkQuoteItems() {
            if (!vm.quote.items || !vm.quote.items.length) {
                return vm.detectedError == _errors.emptyQuote;
            }
            return 0;
        }

        function handleError(codeError) {
            if (codeError === _errors.emptyClient) {
                $rootScope.$emit('CUSTOMER_NOT_SELECTED');
                toastr.error($translate.instant('UNSELECTED_CLIENT'));
                UtilsMetierService.scrollTop("#lastNameInput");
            } else if (codeError === _errors.emptyMileage) {

                UtilsMetierService.setErrorFrame(mileageInputId);
                toastr.error($translate.instant('ESTIMATE_ERROR_MILEAGE_MISS'));
                UtilsMetierService.scrollTop(mileageInputId);
            } else if (codeError === _errors.emptyQuote) {
                toastr.error($translate.instant('ESTIMATE_ITEMS_MISSING'));
            }
            else {

                toastr.error($translate.instant('ERROR'));
            }
        }

        function compare(a, b) {
            if (a.index < b.index) {
                return -1;
            }
            else if (a.index > b.index) {
                return 1;
            }
            return 0;
        }

        function formatReturnedItemsToFitPrintPayload(items) {
            angular.forEach(items.PR, function (value) {
                var structuredItem = {
                    priceHT: parseFloat(value.amount.basis).toFixed(2),
                    cort: value.cort,
                    designation: value.designation,
                    exclTaxes: parseFloat(value.amount.exclTaxes).toFixed(2),
                    reference: value.reference,
                    totalPriceExclTaxes: parseFloat(value.amount.total).toFixed(2),
                    type: "PR",
                    quantity: null
                };
                vm.quoteToPrint.items.push(structuredItem);
            });

            angular.forEach(items.TM, function (value) {
                var structuredItem = {
                    opecod: value.code,
                    totalPriceExclTaxes: parseFloat(value.amount.exclTaxes).toFixed(2),
                    type: "TM"
                };
                vm.quoteToPrint.items.push(structuredItem);
            });
        }

        function addPrCalculInformations(quoteItems, prCalculItems) {
            //parse parts details to add informations to PR items
            prCalculItems.forEach(function (prDetailsItem) {
                var prItem = _.find(quoteItems, function(prItem) { return prItem.reference == prDetailsItem.reference && prItem.quantity > 0 })
                if (prItem) {
                    prItem.totalPriceExclTaxes = prDetailsItem.amount.exclTaxes;
                    prItem.basis = prDetailsItem.amount.basis;
                    prItem.taxes = prDetailsItem.amount.taxes;
                    prItem.total = prDetailsItem.amount.total;

                    if (_.has(prDetailsItem.amount,'discountRate')) {
                        vm.showDiscountRatePrColumn = true;
                        prItem.discountRate = prDetailsItem.amount.discountRate;
                    }
                }
            });

            return quoteItems;
        }

        function addTmCalculInformations(quoteItems, tmCalculItems) {
            quoteItems.forEach(function (item) {
                item.isCalculated = false;
            });

            //parse parts details to add informations to PR items
            tmCalculItems.forEach(function (tmDetailsItem) {
                var tmItem = _.find(quoteItems, { opecod: tmDetailsItem.code, isCalculated: false });


                if (tmItem) {
                    tmItem.isCalculated = true;
                    tmItem.totalPriceExclTaxes = tmDetailsItem.amount.exclTaxes;
                    tmItem.basis = tmDetailsItem.amount.basis;
                    tmItem.taxes = tmDetailsItem.amount.taxes;
                    tmItem.total = tmDetailsItem.amount.total;

                    if (_.has(tmDetailsItem.amount,'discountRate')) {
                        vm.showDiscountRateTmColumn = true;
                        tmItem.discountRate = tmDetailsItem.amount.discountRate;
                    }
                }
            });

            return quoteItems;
        }

        function addNewPrAfterCalcul(referencesPR, prCalculItems) {
            var newPrItems = [];
            //parse parts details to add informations to PR items
            prCalculItems.forEach(function (prDetailsItem) {
                var prItem = _.indexOf(referencesPR, prDetailsItem.reference);
                if (prItem === -1) {
                    newPrItems.push(prDetailsItem);
                }
            });

            return newPrItems;
        }

        function addNewTmAfterCalcul(referencesTM, tmCalculItems) {
            var newTmItems = [];
            //parse parts details to add informations to PR items
            tmCalculItems.forEach(function (tmDetailsItem) {
                var tmItem = _.indexOf(referencesTM, tmDetailsItem.code);
                if (tmItem === -1) {
                    newTmItems.push(tmDetailsItem);
                }
            });

            return newTmItems;
        }

        function getDmsInformationsForPrItemsReturned(prNewItems) {
            var prRefs = prNewItems.map(function (reference) {
                return reference.reference;
            });
            var prItemsreturnedDmsInformations = [];
            return DmsMetierService.getReferencesDms(prRefs).then(function (dmsResponse) {
                if (dmsResponse.returnCode === 0 && dmsResponse.response.parts.length > 0) {

                    prItemsreturnedDmsInformations = dmsResponse.response.parts.map(function (partItem) {
                        var prDetails = _.filter(prNewItems, function (prNewItem) {
                            return prNewItem.reference === partItem.reference;
                        });

                        _.extend(partItem, {
                            designation: partItem.description,
                            cort: partItem.cort.slice(-1)
                        });

                        if (prDetails[0] && prDetails[0].amount) {
                            _.extend(partItem, {
                                amount: prDetails[0].amount
                            });

                            _.remove(prNewItems, prDetails[0]);
                        }

                        _.map(vm.quote.inter, function (item) { 
                            if (item.itemsReturnedPR && item.itemsReturnedPR.length > 0 && item.PR[0].depositReference == partItem.reference) {
                                _.extend(partItem, {
                                    depositInterId : item.PR[0].interventionId,
                                    interventionDesignation : item.PR[0].interventionDesignation
                                });
                            }
                        }) 

                        return partItem;
                    });
                }
                return prItemsreturnedDmsInformations;
            });
        }

        function splitType(quote) {
            var pr = [];
            var tm = [];
            var tmList = _.filter(quote.items, function (item) {
                if (item.type === "TM") {
                    return !item.interventionId;
                }
            });
            
            var prList = _.filter(quote.items, function (list) {
                if (list.type === "PR") {
                    return !list.interventionId;
                }
            });
            var inter = [];
            var interList = _.filter(quote.items, function (item) { return item.interventionDesignation != null });
            var list = _.groupBy(interList, 'interventionDesignation');

            for(var x in list){
                var y = { designation: x, interQuantity: list[x][0].interventionQuantity, PR: [], TM : []};
                list[x].forEach(function(item){
                    switch (item.type) {
                        case "TM":
                            y.TM.push(item);
                            break;
                        default:
                            y.PR.push(item);
                            break;
                    }
                });
                inter.push(y);
            }
            angular.forEach(quote.items, function (value) {
                if(!value.interventionDesignation || value.interventionDesignation == null){
                    switch (value.type) {
                        case "TM":
                            tm = tmList;
                            break;
                        default:
                            pr = prList;
                            break;
                    }
                } 
            });

            quote.items = [];
            quote.items = prList.concat(tmList);
            quote.inter = inter;
            return quote;            
        }

        function getQuoteInformations() {
            //get quote informations if id is set in cache
            if (dmsQuote && dmsQuote.id && dmsQuote.id != "") {
                blockUI.start();
                return QuoteMetierService.findQuote(dmsQuote.id).then(function (quoteResponse) {
                    vm.isQuoteCalculated = dmsQuote.isCalculated;
                    //assigin quote,
                    //set quote.items to empty (wait for formatting)
                    vm.quote = splitType(quoteResponse);
                    vm.prItems = vm.getPrItems();
                    // Action fired if german users are connected : change mention value and disable textarea field
                    if (vm.userProfile && vm.userProfile.country.toUpperCase() === "DE") {
                        vm.quote.mentions = SettingsConstants.mentionsTextForDE;
                        document.getElementsByClassName("changeMentionifDE")[0].setAttribute("disabled", "");
                    }

                    if (!vm.quote.orderNumber) {
                        // default value for select
                        vm.quote.orderNumber = '-';
                    }
                    var quoteItems = angular.copy(vm.quote);
                    vm.quote.items = [];

                    if (quoteItems && quoteItems.items.length > 0) {
                        var tmItems = _.filter(quoteItems.items, { type: "TM" }).map(function (tmItem) {
                            vm.quote.items.push(tmItem);
                        });
                        if (tmItems.length > 0) {
                            vm.isShowTM = true;
                        }
                    }

                    return quoteItems;
                }).then(function (quoteItems) {
                    var referencesPR = [];
                    var interPR = [];

                    referencesPR = _.filter(quoteItems.items, { type: "PR" }).map(function (prITem) {
                        return prITem.reference;
                    });

                    if(quoteItems.inter.length > 0){
                        quoteItems.inter.forEach(function (item){
                            if (item.PR.length > 0) {
                                vm.prButton = true;
                                item.PR.forEach(function (list){
                                    interPR.push(list.reference);
                                })
                            }
                        });
                        if(referencesPR.length > 0){
                            vm.isShowPR = true;
                            vm.prButton = true;
                        }
                        referencesPR = referencesPR.concat(interPR);
                        if(referencesPR && referencesPR.length > 0){
                            return getReferencesInformations(referencesPR).then(function (quotePRInformations) {
                                _.filter(quoteItems.items, { type: "PR" }).forEach(function (prItem) {
                                    var currentItem = {};

                                    quotePRInformations.forEach(function (obj) {
                                        if (obj.reference === prItem.reference) {
                                            _.extend(prItem, {
                                                cort: obj.cort, price: obj.price, stock: obj.stock, totalPriceExclTaxes: obj.totalPriceExclTaxes,
                                                discountRate: obj.discountRate
                                            })
                                        }
                                    });

                                    vm.quote.items.push(_.extend(currentItem, { quantity: prItem.quantity }, { type: "PR" }, { id: prItem.id },
                                        { genericPart: prItem.genericPart }, { reference: prItem.reference },
                                        { interventionId: prItem.interventionId }, { suggestedQuantity: prItem.suggestedQuantity }, { designation: prItem.designation },
                                        { creationDateTime: prItem.creationDateTime }, { creator: prItem.creator }, { herculesCase: prItem.herculesCase },
                                        { sbomId: prItem.sbomId }));

                                });

                                quoteItems.inter.forEach(function (item) {
                                    if (item.PR.length > 0) {
                                        item.PR.forEach(function (prItem) {
                                            quotePRInformations.forEach(function (obj) {
                                                if (obj.reference === prItem.reference) {
                                                    _.extend(prItem, {
                                                        cort: obj.cort, price: obj.price, stock: obj.stock, totalPriceExclTaxes: obj.totalPriceExclTaxes,
                                                        discountRate: obj.discountRate
                                                    })
                                                }
                                            });
                                        })
                                    }
                                });

                                vm.quote = quoteItems;

                            });
                        }
                    }
                    
                    else if (referencesPR.length > 0) {
                        vm.isShowPR = true;
                        vm.prButton = true;
                        return getReferencesInformations(referencesPR).then(function (quotePRInformations) {
                            _.filter(quoteItems.items, { type: "PR" }).forEach(function (prItem) {
                                var currentItem = {}; 
                                quotePRInformations.forEach(function(obj){
                                    if(obj.reference === prItem.reference){
                                        _.assign(currentItem,{ cort: obj.cort, price: obj.price, stock: obj.stock, totalPriceExclTaxes: obj.totalPriceExclTaxes,
                                                discountRate: obj.discountRate })
                                    }
                                });
                                vm.quote.items.push(_.extend(currentItem, { quantity: prItem.quantity }, { type: "PR" }, { id: prItem.id }, 
                                {genericPart: prItem.genericPart}, {reference: prItem.reference},
                                {interventionId: prItem.interventionId}, {suggestedQuantity: prItem.suggestedQuantity}, {designation: prItem.designation},
                                {creationDateTime: prItem.creationDateTime}, {creator: prItem.creator}, {herculesCase: prItem.herculesCase}, 
                                {sbomId: prItem.sbomId}));
                            });

                        });
                    }
                
                }).then(function () {
                    _.map(vm.quote.items, function(item){
                        return QuoteMetierService.updateQuotePart(ShoppingCartServiceConstant.actions.REPLACE_QUANTITY, {
                            piece: item,
                            quantity: item.quantity,
                            type: item.type
                        })
                    })
                    
                    //get customers group
                    return SettingsMetierService.getCustomersGroup();
                }).then(function (customersGroup) {
                    //set customers group list
                    vm.customersGroup = customersGroup;
                }).then(function () {
                    //get calcul if isCalculated is true
                    if (dmsQuote.isCalculated) {
                        return onCalculQuote(1);
                    }
                }).finally(function () {
                    blockUI.stop();
                });
            }
            else {
                $window.history.back();
            }
        }

        $scope.$on('$destroy', function() {                
            $rootScope.$broadcast("on-close-quote");
        });
    }
})();

'use strict';

angular.module('phenix.core').constant('DmsCustomerConstants', {
    SEARCH_MODE: "SEARCH_MODE",
    EDIT_MODE: "EDIT_MODE",
    CONSULTATION_MODE: "CONSULTATION_MODE",
    SET_DEFAULT_CUSTOMER_EVENT: "SET_DEFAULT_CUSTOMER_EVENT"
});

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('dmsCustomer', {
            bindings: {
                onNewCustomerCallback: '<?',
                onCustomerFilledCallback: '<',
                onSetCustomerDetails: '<?',
                onSelectCustomerCallback: '=',
                currentCustomer: '=',
                // callback trigger when the currentCustomer is changed
                onUpdatedCustomerCallback: '<?',
                // callback trigger when user choose default customer (client passant)
                onResetCustomerCallback: '<?',
                sendDmsRequest: '<',
                view: '@'
            },
            controller: DmsCustomerController,
            controllerAs: 'vm',
            //here we use template instead of templateUrl because we load the template using a binding value
            //we have an issue when generate the package to deploy using templateUrl
            template: '<div ng-include="vm.templateUrl">'
        })

    // This component displays 3 mode
    // Search mode => changeCustomerAction
    // Fill a new customer mode => addNewCustomerAction

    function DmsCustomerController(
        toastr,
        blockUI,
        $translate,
        $rootScope,
        $scope,
        DmsMetierService,
        DmsConstants,
        DmsCustomerConstants,
        CacheService,
        CacheConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/


        var vm = this;
        vm.dmsCustomerConstants = DmsCustomerConstants;
        vm.displayMode = DmsCustomerConstants.EDIT_MODE;
        vm.isSearchResult = false;
        vm.isDefaultCustomerSet = false;
        vm.index = 0;

        vm.onNewCustomer = onNewCustomer;
        vm.onChangeCustomer = onChangeCustomer;
        vm.onSearchCustomer = onSearchCustomer;
        vm.onSelectCustomer = onSelectCustomer;
        vm.onPrevClientSearch = onPrevClientSearch;
        vm.onNextClientSearch = onNextClientSearch;
        vm.switchState = switchState;
        vm.isCustomerDataLoading = false;
        // vm.$onChanges = onChanges;


        // We use debounce to avoid to much call, this function is called on user input after the last keys press -> 300 MS delay
        vm.onUpdatedCustomer = _.debounce(function () {
            if (vm.onUpdatedCustomerCallback) {
                // && customer passant
                vm.onUpdatedCustomerCallback(vm.currentCustomer);
                // fire $digest because it's triggered BEFORE debounce timer, and not AFTER;
                // DOM is not updated without it
                // debounce use setTimeout, and not $timeout from angularJS service
                $scope.$apply();
            }
        }, 300);

        vm.onResetCustomer = function () {
            vm.currentCustomer = {};
            if (vm.onResetCustomerCallback) {
                vm.onResetCustomerCallback();
            }
        }

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            var isCustomerExist = false;

            //check if customer exist
            //if exist, set isCustomerExist to true
            if (!vm.currentCustomer || _.isEmpty(vm.currentCustomer)) {
                resetCustomer();
            } else {
                isCustomerExist = true;
            }

            // // initialization
            // vm.currentBS = {};
            // // get the current bs stored in the cache
            // vm.currentBS = CacheService.getCurrentBS();

            // case when access by link and bs draft
            // if ((!vm.currentBS.accountNumber || _.isEmpty(vm.currentBS)) && location.search.match(/accountid=([^&]*)/i)) {
            if (location.search.match(/accountid=([^&]*)/i)) {
                vm.currentCustomer.accountNumber = location.search.match(/accountid=([^&]*)/i)[1];
                onSearchCustomer();
                getDmsCustomerInformations(vm.currentCustomer);
                setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
            } else if (vm.view == "standard") {
                if (isCustomerExist) {

                    setDisplayMode(vm.dmsCustomerConstants.EDIT_MODE);
                    if (vm.sendDmsRequest) {
                        getDmsCustomerInformations(vm.currentCustomer);
                    }
                    // if we have a bs in the cache we display the client
                }
                // else if (vm.currentBS.accountNumber) {
                //     vm.currentCustomer = {};
                //     vm.currentCustomer.accountNumber = vm.currentBS.accountNumber;
                //     onSearchCustomer();
                //     getDmsCustomerInformations(vm.currentCustomer);
                //     setDisplayMode(vm.dmsCustomerConstants.EDIT_MODE);
                // }
                else {
                    vm.currentCustomer = {};
                    setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
                }

            }
            //if view is consultation, set consult mode
            else {
                setDisplayMode(vm.dmsCustomerConstants.CONSULTATION_MODE);
            }


        }

        this.$onChanges = function () {
            if (vm.view === "standard") {
                vm.templateUrl = 'app/components/dms/components/dms-customer/dms-customer.template.html';
            } else {
                vm.templateUrl = 'app/components/dms/components/dms-customer/dms-customer-consult.template.html';
            }
        }

        /**
         * @name onNewCustomer
         * @desc display new customer's form when user click on the link
         */
        function onNewCustomer() {
            resetCustomer();
            setDisplayMode(vm.dmsCustomerConstants.EDIT_MODE);
            if (vm.onNewCustomerCallback) {
                vm.onNewCustomerCallback();
            }
        }

        /**
         * @name onChangeCustomer
         * @desc display customer's form (fields with search button) when user click on the link
         */
        function onChangeCustomer() {
            resetCustomer();
            vm.onResetCustomer();
            setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
        }


        /**
         * @name onPrevClientSearch
         * @desc display previous customer list when user click on <
         */
        function onPrevClientSearch() {
            var client = buildCustomerRequest(-1);

            vm.currentClientSearchPage = vm.currentClientSearchPage - 1;

            DmsMetierService.getUsersListByCustomers(client).then(function (result) {
                vm.customersList = result.response.customers;
                vm.numOfClientResult = result.response.numberOfCustomers;
                vm.index = client.index;

            }).catch(function () {
                toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMERS'));
            });
        }

        /**
         * @name onNextClientSearch
         * @desc display next customer list when user click on >
         */
        function onNextClientSearch() {
            var client = buildCustomerRequest(1);
            vm.currentClientSearchPage = vm.currentClientSearchPage + 1;
            DmsMetierService.getUsersListByCustomers(client).then(function (result) {
                vm.customersList = result.response.customers;
                vm.index = client.index;
            }).catch(function () {
                toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMERS'));
            });
        }

        /**
         * @name onSearchCustomer
         * @desc search customer by (last name, first name and account number)
         */
        function onSearchCustomer() {
            if (!vm.currentCustomer) {
                resetCustomer();
            }
            setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
            var detectedError = false;

            if (!vm.currentCustomer.name && !vm.currentCustomer.accountNumber) {

                invalidForm('#lastNameInput');
                invalidForm('#accountNumberInput');
                detectedError = true;
            }

            if (detectedError) {
                return;
            }
            if (vm.currentCustomer.name && !vm.currentCustomer.accountNumber) {
                standardForm('#accountNumberInput');
                validForm('#lastNameInput');
            }
            if (vm.currentCustomer.accountNumber && !vm.currentCustomer.name) {
                standardForm('#lastNameInput');
                validForm('#accountNumberInput');
            }

            vm.index = 0;
            vm.currentClientSearchPage = vm.index + 1;
            vm.customersList = [];
            vm.numOfClientResult = 1;
            vm.maximumPageNext = 1;

            var customer = buildCustomerRequest(0);

            if (customer.accountNumber) {
                blockUI.start();
                DmsMetierService.getUserByAccount(customer).then(function (result) {
                    var customer = result.response.customer;
                    if (customer) {
                        setDisplayMode(vm.dmsCustomerConstants.EDIT_MODE);
                        setCustomerDetails(customer);
                        vm.onSelectCustomerCallback(customer);
                    }
                }).catch(function () {
                    vm.numOfClientResult = 0;
                    //toastr.error($translate.instant('PART_REQUISITION_UNKNOW_CUSTOMER_ACOUNT'));
                }).finally(function () {
                    blockUI.stop();
                });
            } else {
                setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
                vm.showNextPrev = true;
                blockUI.start();
                DmsMetierService.getUsersListByCustomers(customer).then(function (result) {
                    vm.customersList = result.response.customers;
                    vm.numOfClientResult = result.response.numberOfCustomers;
                    vm.maximumPageNext = Math.ceil(vm.numOfClientResult / DmsConstants.maximumNumberOfreturnUsersDms);
                    vm.isSearchResult = true;
                }).catch(function () {
                    vm.numOfClientResult = 0;
                    //toastr.error($translate.instant('PART_REQUISITION_UNKNOW_CUSTOMER'));
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        /**
         * @name onSelectCustomer
         * @desc display selected customer's informations
         * @param {object} customer
         */
        function onSelectCustomer(customer) {
            setDisplayMode(vm.dmsCustomerConstants.EDIT_MODE);
            if (customer.accountNumber) {
                blockUI.start();
                DmsMetierService.getUserByAccount(customer).then(function (result) {
                    setCustomerDetails(result.response.customer);
                    vm.onSelectCustomerCallback(result.response.customer);
                    vm.currentCustomer = result.response.customer;
                }).catch(function () {
                    toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMER_INFORMATIONS'));
                }).finally(function () {
                    blockUI.stop();
                });
            } else {
                vm.currentCustomer = customer;
                vm.onSelectCustomerCallback(customer);
            }
        }


        /**
         * @name switchState
         * @desc hide fields (first name and last name) when user click on account number
         * @param {string} fiels
         */
        function switchState(field) {

            if (vm.currentCustomer) {
                if (field === "accountNumber") {
                    vm.currentCustomer.accountNumber = "";
                } else {
                    vm.currentCustomer.name = "";
                    vm.currentCustomer.firstName = "";
                }
            }
        }

        $rootScope.$on('CUSTOMER_NOT_SELECTED', function () {
            scrollTop();
            var detectedError = false;

            if (!vm.currentCustomer || (!vm.currentCustomer.name && !vm.currentCustomer.accountNumber)) {
                invalidForm('#lastNameInput');
                invalidForm('#accountNumberInput');
                detectedError = true;
            }
            if (detectedError) {
                return;
            }
            if (vm.currentCustomer.name && !vm.currentCustomer.accountNumber) {
                standardForm('#accountNumberInput');
                validForm('#lastNameInput');
            }
            if (vm.currentCustomer.accountNumber && !vm.currentCustomer.name) {
                standardForm('#lastNameInput');
                validForm('#accountNumberInput');
            }
        });


        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name resetCustomer
         * @desc reset customer informations
         */
        function resetCustomer() {
            vm.currentCustomer = {};
            vm.currentCustomer.name = "";
            vm.currentCustomer.firstName = "";
            vm.currentCustomer.accountNumber = "";
            vm.currentCustomer.streetNumber = "";
            vm.currentCustomer.streetName = "";
            vm.currentCustomer.bisTer = "";
            vm.currentCustomer.postCode = "";
            vm.currentCustomer.city = "";
            vm.currentCustomer.mainPhone = "";
            vm.currentCustomer.email = "";
        }

        /**
         * @name setDisplayMode
         * @desc set display mode
         * @param {*} mode
         */
        function setDisplayMode(mode) {
            switch (mode) {
                case vm.dmsCustomerConstants.SEARCH_MODE:
                    // hide results
                    vm.isSearchResult = false;
                    vm.onCustomerFilledCallback(false);

                    vm.displayMode = vm.dmsCustomerConstants.SEARCH_MODE;
                    break;
                case vm.dmsCustomerConstants.EDIT_MODE:
                    vm.onCustomerFilledCallback(true);
                    vm.displayMode = vm.dmsCustomerConstants.EDIT_MODE;
                    break;
                default:
                    vm.displayMode = vm.dmsCustomerConstants.CONSULTATION_MODE;
                    break;
            }
        }


        /**
         * load customer data from dms
         * @param {*} customer
         */
        function getDmsCustomerInformations(customer) {
            var payload = {};
            var accountNumber = customer.accountNumber;

            if (accountNumber && accountNumber != 0) {

                payload.accountNumber = accountNumber;
                blockUI.start();
                DmsMetierService.getUserByAccount(payload).then(function (result) {
                    // setting currentCustomer broadcast event to dms-customer component
                    setCustomerDetails(result.response.customer);
                }).catch(function () {
                    vm.currentCustomer = {};
                    setDisplayMode(vm.dmsCustomerConstants.SEARCH_MODE);
                    toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMER_INFORMATIONS'));
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }


        /**
         * Scroll function go to customer bloc
         */
        function scrollTop() {
            $('html, body').animate({ scrollTop: $('.headerCustomer').offset().top }, 100);
        }

        //show customer details
        function setCustomerDetails(customer) {
            vm.currentCustomer = customer;
            vm.onSetCustomerDetails(vm.currentCustomer);
        }

        //build customer request
        function buildCustomerRequest(index) {
            var customerRequest = {
                name: vm.currentCustomer.name,
                firstName: vm.currentCustomer.firstName,
                index: vm.index + index,
                accountNumber: vm.currentCustomer.accountNumber
            };
            return customerRequest;
        }

        function invalidForm(id) {
            $(id).css({
                'border-color': 'red',
                'border-width': '2px'
            });
        }

        function validForm(id) {
            $(id).css({
                'border-color': 'green',
                'border-width': '2px'
            });
        }

        function standardForm(id) {
            $(id).css({
                'border-color': '#cccccc',
                'border-width': '1px'
            });
        }

    }
})();

(function () {

    angular.module('phenix').controller('updateFamilyLabel', function ($mdDialog) {
        var vm = this;

        vm.onCancel = function() {
            $mdDialog.cancel();
        }

        vm.onConfirm = function() {
            $mdDialog.hide(vm.label);
        }
    });

})();

(function () {

    angular.module('phenix').controller('confirmDeleteFamilyLabel', function ($mdDialog) {
        var vm = this;

        vm.onCancel = function() {
            $mdDialog.cancel();
        }

        vm.onConfirm = function() {
            $mdDialog.hide();
        }
    });

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('ProfilWsService', ProfilWsService);

  /** @ngInject */
  function ProfilWsService($q, ProfilConstants, RestUpgrade) {

    this.createProfil = createProfil;
    this.updateProfil = updateProfil;
    this.getLanguages = getLanguages;
    this.updateLandscapeMode = updateLandscapeMode;
    this.updatePRFormat = updatePRFormat;
    this.updateCatalogue = updateCatalogue;

    function createProfil(profil) {
      var defer = $q.defer();

      RestUpgrade.one('users').post('', {
          userId: profil.userId,
          password: profil.password,
          lastName: profil.lastName,
          firstName: profil.firstName,
          userType: profil.userType,
          portal:profil.portal,
          documentationFirstLanguage:profil.documentationFirstLanguage,
          documentationSecondLanguage:profil.documentationSecondLanguage,
          emailAlerte:profil.emailAlerte,
          ipn:profil.ipn,
          roleActive:profil.roleActive,
          roles: profil.roles,
          language: profil.language,
          country: profil.country,
          dealerId: profil.dealerId,
          dmsConnected: profil.dmsConnected,
          activeNotification: profil.activeNotification,
          isManageDealer:profil.isManageDealer,
          dmsConfig: {
            url: profil.dmsConfig.url,
            userDms: profil.dmsConfig.userDms,
            workshopPartshopId: profil.dmsConfig.workshopPartshopId,
            stocks: profil.dmsConfig.stocks
          }
        }
      ).then(function (response) {
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }




    function updateProfil(profile) {
        var defer = $q.defer();


      RestUpgrade.one(ProfilConstants.updateProfile).post('', profile)
          .then(function (response) {
          defer.resolve(response);
        }, function (error) {
          defer.reject(error);
        });
      return defer.promise;
    }



    function getLanguages() {
        var defer = $q.defer();

        RestUpgrade.one(ProfilConstants.languages).get()
        .then(function (response) {
            defer.resolve(response);
          }, function (error) {
            defer.reject(error);
          });
        return defer.promise;
    }

    function updateLandscapeMode(isLandscapeMode) {
          var defer = $q.defer();
          RestUpgrade.one(ProfilConstants.updateLandscapeMode).post('', {
              isLandscape: isLandscapeMode
          })
              .then(function (response) {
                  defer.resolve(response);
              }, function (error) {
                  defer.reject(error);
              });
          return defer.promise;
    }
    function updatePRFormat(isPRFormat) {
          const defer = $q.defer();
          RestUpgrade.one(ProfilConstants.updatePRFormat).post('', {
              isPRFormat: isPRFormat
          }).then(function (response) {
              defer.resolve(response);
          }, function (error) {
              defer.reject(error);
          });
          return defer.promise;
    }
    
    function updateCatalogue(isCatalogueMode){
        var defer = $q.defer();
        RestUpgrade.one(ProfilConstants.updateCatalogueMode).post('', {
            isCatalogue: isCatalogueMode
        })
            .then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('ProfilMetierService', ProfilMetierService);

  /** @ngInject */
  function ProfilMetierService(ProfilWsService, $q) {

    this.createProfil = createProfil;
    this.updateProfil = updateProfil;
    this.getLanguages = getLanguages;
    this.updateLandscapeMode = updateLandscapeMode;
    this.updatePRFormat = updatePRFormat;
    this.updateCatalogueMode = updateCatalogueMode;

    ////////////


    function createProfil(profil) {
      var defer = $q.defer();
      ProfilWsService.createProfil(profil).then(function (response) {
        var data = response;
        defer.resolve(data);
      }, function (response) {
        defer.reject(response);
      });
      return defer.promise;
    }


    ////////////


    function updateProfil(profil) {
      var defer = $q.defer();
      ProfilWsService.updateProfil(profil).then(function (response) {
        var data = response;
        defer.resolve(data);
      }, function (response) {
        defer.reject(response);
      });
      return defer.promise;
    }


    ////////////


    function getLanguages() {
        var defer = $q.defer();
        ProfilWsService.getLanguages().then(function (response) {
          var data = response;
          defer.resolve(data);
        }, function (response) {
          defer.reject(response);
        });
        return defer.promise;
      }
  

    function updateLandscapeMode(isLandscapeMode) {
        var defer = $q.defer();
        ProfilWsService.updateLandscapeMode(isLandscapeMode).then(function (response) {
            var data = response;
            defer.resolve(data);
        }, function (response) {
            defer.reject(response);
        });
        return defer.promise;
    }
    function updatePRFormat(isPRFormat) {
        const defer = $q.defer();
        ProfilWsService.updatePRFormat(isPRFormat).then(function (response) {
            const data = response;
            defer.resolve(data);
        }, function (error) {
            defer.reject(error);
        });
        return defer.promise;
    }
    
    function updateCatalogueMode(isCatalogue){
      var defer = $q.defer();
      ProfilWsService.updateCatalogue(isCatalogue).then(function (response) {
        var data = response;
        defer.resolve(data);
      }, function (response) {
        defer.reject(response);
      });
      return defer.promise;
    }
      }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .constant('ProfilConstants', {
            updateProfile: '/user/updateProfil',
            languages: '/languages/active',
            storeLastModificationDate: '/user/updateDate',
            getLastModificationDate: '/user/getLastModificationDate',
            updateLandscapeMode: '/user/updateLandscapeMode',
            updateCatalogueMode: '/user/updateCatalogue',
            updatePRFormat: '/user/updatePRFormat'
        });

  })();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('InfoClientMetierService', InfoClientMetierService);

  /** @ngInject */
  function InfoClientMetierService(CarSearchConstants, CacheService) {
    this.getInfoClient = getInfoClient;

    function getInfoClient(){
      var contextCarSearch = CacheService.getObject(CarSearchConstants.contextCarSearch);
      return contextCarSearch;
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('SearchSpecializedToolWsService', SearchSpecializedToolWsService);

    /** @ngInject */
    function SearchSpecializedToolWsService($q, SearchSpecializedToolConstants,RestUpgrade, CloudFrontUrlHelper) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.fixedFiltered2 = fixedFiltered2;
        vm.specialTools = specialTools;
        vm.advancedFiltered = advancedFiltered;

        function signSpecialToolUrls(response) {
            if (response && response.specialTools && Array.isArray(response.specialTools)) {
                response.specialTools.forEach(function(tool) {
                    if (tool.pictureUrl) {
                        tool.pictureUrl = CloudFrontUrlHelper.appendCloudFrontParams(tool.pictureUrl);
                    }
                    if (tool.thumbnailUrl) {
                        tool.thumbnailUrl = CloudFrontUrlHelper.appendCloudFrontParams(tool.thumbnailUrl);
                    }
                });
            }
            return response;
        }

        /**
         * @name getSpecializedToolsIds
         * @desc calls fixedFiltered2 service to return all specialized tools related to a car
         * @param {payload}, represents userContext, carContext and document type
         */

        function fixedFiltered2(payload) {
            return RestUpgrade.all(SearchSpecializedToolConstants.fixedFiltered2).post(payload);
        }

        /**
         * @name getSpecializedToolsDataFromId
         * @desc calls specialTools service to return all the information related to a special tool
         * @param {payload}, represents userContext, carContext and document ids
         */

        function specialTools(payload) {
            var url = SearchSpecializedToolConstants.specialTools;
            if(payload.isFromNewSpecialTools){
                var allStData = { specialTools: []};
                return showAllStData(allStData, url, payload);
            }
            else {
                return RestUpgrade.all(url).post(payload).then(function(response) {
                    return signSpecialToolUrls(response);
                });
            }
        }

        function showAllStData(allStData, url, payload) {
            return RestUpgrade.all(url).post(payload).then(function (res) {
                if (res && res.specialTools && Array.isArray(res.specialTools)) {
                    res.specialTools.forEach(function (tool) {
                        if (tool.pictureUrl) {
                            tool.pictureUrl = CloudFrontUrlHelper.appendCloudFrontParams(tool.pictureUrl);
                        }
                        if (tool.thumbnailUrl) {
                            tool.thumbnailUrl = CloudFrontUrlHelper.appendCloudFrontParams(tool.thumbnailUrl);
                        }
                    });
                }

                allStData.specialTools = allStData.specialTools.concat(res.specialTools);
                res.specialTools = allStData.specialTools;

                if (res && res.next_url) {
                    url = "/proxy/apidh/rest/v1" + res.next_url;
                    return showAllStData(allStData, url, payload);
                } else {
                    return res;
                }
            })
        }

        function advancedFiltered (payload) {
            var stlist = [];
            var url = SearchSpecializedToolConstants.advancedFiltered;
            return getAdvanceStList(stlist, url, payload);
        }

        function getAdvanceStList(stlist, url, payload) {
            return RestUpgrade.all(url).post(payload).then(function (res) {
                stlist = res;
                if (res && res.next_url) {
                    url = "/proxy/apidh/rest/v1" + res.next_url;
                    return getAdvanceStList(stlist, url, payload);
                } else {
                    return stlist;
                }
            })
        }

    }
})();

'use strict';

(function () {
    angular.module('phenix').constant('SearchSpecializedToolConstants', {
        fixedFiltered2: '/proxy/apidh/rest/v1/applicabilities/fixedFiltered2',
        specialTools: '/proxy/apidh/rest/v1/specialTools',
        advancedFiltered: '/proxy/apidh/rest/v1/applicabilities/advancedFiltered',
        loadCdnFiles: '/ndReleases/getCdnFiles',
        specialToolsAllSubTypes: {
            "SPECIALTOOLS": {
                "subType":
                    [
                        "BAT",
                        "BVI",
                        "CAR",
                        "DIR",
                        "ELE",
                        "EMB",
                        "FRE",
                        "MOT",
                        "MS",
                        "ROU",
                        "SUS",
                        "TAR",
                        "TAV"
                    ]
            }
        },
        specialToolsMenu: [
            {
                id: 0,
                label: 'SPECIALIZED_TOOL_MENU_ALL_SUBTYPES',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "BAT",
                                "BVI",
                                "CAR",
                                "DIR",
                                "ELE",
                                "EMB",
                                "FRE",
                                "MOT",
                                "MS",
                                "ROU",
                                "SUS",
                                "TAR",
                                "TAV"
                            ]
                    }
                }
            },
            {
                id: 1,
                label: 'SPECIALIZED_TOOL_MENU_TRACTION_BATTERY',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "BAT"
                            ]
                    }
                }
            },
            {
                id: 2,
                label: 'SPECIALIZED_TOOL_MENU_GEARBOX',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "BVI"
                            ]
                    }
                }
            },
            {
                id: 3,
                label: 'SPECIALIZED_TOOL_MENU_CAR_BODY',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "CAR"
                            ]
                    }
                }
            },
            {
                id: 4,
                label: 'SPECIALIZED_TOOL_MENU_STEERING',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "DIR"
                            ]
                    }
                }
            },
            {
                id: 5,
                label: 'SPECIALIZED_TOOL_MENU_POWER_SUPPLY',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "ELE"
                            ]
                    }
                }
            },
            {
                id: 6,
                label: 'SPECIALIZED_TOOL_MENU_CLUTCH',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "EMB"
                            ]
                    }
                }
            },
            {
                id: 7,
                label: 'SPECIALIZED_TOOL_MENU_BRAKE',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "FRE"
                            ]
                    }
                }
            },
            {
                id: 8,
                label: 'SPECIALIZED_TOOL_MENU_ENGINE',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "MOT"
                            ]
                    }
                }
            },
            {
                id: 9,
                label: 'SPECIALIZED_TOOL_MENU_SPECIALIZED_EQUIPMENT',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "MS"
                            ]
                    }
                }
            },
            {
                id: 10,
                label: 'SPECIALIZED_TOOL_MENU_WHEELS_AND_HUBS',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "ROU"
                            ]
                    }
                }
            },
            {
                id: 11,
                label: 'SPECIALIZED_TOOL_MENU_SUSPENSION',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "SUS"
                            ]
                    }
                }
            },
            {
                id: 12,
                label: 'SPECIALIZED_TOOL_MENU_REAR_END',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "TAR"
                            ]
                    }
                }
            },
            {
                id: 13,
                label: 'SPECIALIZED_TOOL_MENU_FRONT_AXLE',
                docType: {
                    "SPECIALTOOLS": {
                        "subType":
                            [
                                "TAV"
                            ]
                    }
                }
            }
        ],
        icons: [
            {
                id: 1,
                value: 'Essentiel',
                icon: '<i class="fa fa-star fa-2x" style="color: var(--renaultPrimaryColor);"></i>'
            },
            {
                id: 2,
                value: 'Valide',
                icon: ''
            },
            {
                id: 3,
                value: 'Arrêté',
                icon: '<i class="fa fa-stop-circle fa-2x" style="color: red;"></i>'
            }
        ]
    });
})();

(function () {

    'use strict';

    /* @ngInject */
    angular.module('phenix').service('SearchSpecializedToolBusinessService', function (SearchSpecializedToolWsService) {

        var vm = this;

        vm.fixedFiltered2 = fixedFiltered2;
        vm.specialTools = specialTools;
        vm.advancedFiltered = advancedFiltered;

        /**
         * @name fixedFiltered2
         * @desc calls fixedFiltered2 service to return all specialized tools related to a car
         * @param {*}
         */

        function fixedFiltered2(payload) {
            return SearchSpecializedToolWsService.fixedFiltered2(payload);
        }


        /**
         * @name specialTools
         * @desc calls specialTools service to return all the information related to a special tool
         * @param {*}
         */

        function specialTools(payload) {
            return SearchSpecializedToolWsService.specialTools(payload);
        }

        function advancedFiltered (payload) {
            return SearchSpecializedToolWsService.advancedFiltered(payload);
        }

    });
})();

(function () {
    'use strict';

    angular
        .module('phenix').controller('specializedToolSelectionController', specializedToolSelectionController);

    /** @ngInject */
    function specializedToolSelectionController(

        $q,
        $mdDialog, configConstantes) {


        // VARIABLES

        var vm = this;

        // FUNCTIONS
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.closePopIn = closePopIn;

        this.$onInit = function () {

            vm.referenceReformatted = !_.isEmpty(vm.reference) ? vm.reference.split(' ').join('') :'';

        };

        function closePopIn() {
            $mdDialog.hide();
        }

    }

})();

/**
 * searchElectricalSchemaWsService
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('searchElectricalSchemaWsService', searchElectricalSchemaWsService);

    /** @ngInject */
    function searchElectricalSchemaWsService(RestUpgrade,
        $q,

        searchElectricalSchemaConstant,
        ResultSearchByDiagnosticConstants) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        // fixed criteria kept by CacheService.getFixedCriteriasForWd for a VIN based WD search
        var _lightCriteriaCodes = ["027", "427", "336", "901", "007", "008", "019", "APV001", "956"];

        this.getApplicabilitiesTree = getApplicabilitiesTree;
        this.getWiringDiagramByIds = getWiringDiagramByIds;
        this.getIdsWiringDiagramsAndPartHarness = getIdsWiringDiagramsAndPartHarness;
        this.getComponentDetailsById = getComponentDetailsById;
        this.getCanAndDocIds = getCanAndDocIds;
        this.getComponentsAndSignals = getComponentsAndSignals;
        this.getComponentsAndSignalsRecursively = getComponentsAndSignalsRecursively;
        this.getByComponentIdLite = getByComponentIdLite;
        this.getBySignalIdLite = getBySignalIdLite;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function getApplicabilitiesTree(payload) {
            var url = searchElectricalSchemaConstant.getApplicabilitiesTree;
            return RestUpgrade.all(url).post(payload);
        }
        function getWiringDiagramByIds(payload) {
            var deferred = $q.defer();
            var responseArray = [];
            var url = searchElectricalSchemaConstant.getWiringDiagramByIds;
            getWiringDiagramsAndPartHarnessRecursively(url, payload, deferred, responseArray);
            return deferred.promise;
        }

        function getIdsWiringDiagramsAndPartHarness(payload) {
            var deferred = $q.defer();
            var responseArray = [];
            var url = ResultSearchByDiagnosticConstants.documentationDiagnostic;
            getWiringDiagramsAndPartHarnessRecursively(url, payload, deferred, responseArray);
            return deferred.promise;
        }

        /**
         * @description Used to get the FixedFiltered2 service results recursively if there exists a next_url when limit > 2000
         * @param {*} url 
         * @param {*} payload 
         * @param {*} deferred 
         * @param {*} responseArray 
         */
        function getWiringDiagramsAndPartHarnessRecursively(url, payload, deferred, responseArray) {
            var requestPayload = url.split('?')[0] === ResultSearchByDiagnosticConstants.documentationDiagnostic
                ? getPayloadForLightCriterias(payload)
                : payload;

            RestUpgrade.all(url).post(requestPayload).then(function (res) {
                responseArray.push(res);
                if (res.next_url) {
                    var stringUrl = res.next_url.split('?').pop();
                    if (res.documents) {
                        url = ResultSearchByDiagnosticConstants.documentationDiagnostic + '?' + stringUrl;
                    } else if (res.WIRING_DIAGRAMS) {
                        url = searchElectricalSchemaConstant.getWiringDiagramByIds + '?' + stringUrl;
                    }
                    getWiringDiagramsAndPartHarnessRecursively(url, payload, deferred, responseArray);
                }
                else {
                    deferred.resolve(responseArray);
                }
            }).catch(function(){
                deferred.reject();
            }); 
        }

        function getPayloadForLightCriterias(payload) {
            var carContext = payload && payload.carContext;
            var fixedCriterias = carContext && carContext.fixedCriterias;

            if (_.isEmpty(fixedCriterias)) {
                return payload;
            }

            var isLightCriterias = Object.keys(fixedCriterias).every(function (codeObj) {
                return _lightCriteriaCodes.indexOf(codeObj) !== -1;
            });

            if (!isLightCriterias) {
                return payload;
            }

            return angular.extend({}, payload, {
                carContext: angular.extend({}, carContext, {
                    vin: null
                })
            });
        }

        function getComponentDetailsById(payload) {
            var url = searchElectricalSchemaConstant.getComponentDetailsById;
            return RestUpgrade.all(url).post(payload);
        }

        /**
         * @description Get the Ids for the CAN and Document
         * @param {*} payload
         */
        function getCanAndDocIds(payload) {
            var deferred = $q.defer();
            var responseArray = [];
            var url = ResultSearchByDiagnosticConstants.documentationDiagnostic;
            getWiringDiagramsAndPartHarnessRecursively(url, payload, deferred, responseArray);
            return deferred.promise;
        }

        /**
         * @description Get the Ids and label for Components and Signals
         * @param {*} payload
         */
        function getComponentsAndSignals(payload) {
            var url = searchElectricalSchemaConstant.getComponentsAndSignals;
            return RestUpgrade.all(url).post(payload);
        }

        function getComponentsAndSignalsRecursively(url, payload, deferred, responseArray) {
            RestUpgrade.all(url).post(payload).then(function (res) {
                responseArray.push(res);
                if (res.next_url) {
                    var stringUrl = res.next_url.split('?').pop();
                    var isComp = res.next_url.split('/')[2].includes("byComponentIdLite");
                    if (isComp) {
                        url = searchElectricalSchemaConstant.getByComponentIdLite + '?' + stringUrl;
                    } else {
                        url = searchElectricalSchemaConstant.getBySignalIdLite + '?' + stringUrl;
                    }
                    getComponentsAndSignalsRecursively(url, payload, deferred, responseArray);
                }
                else {
                    deferred.resolve(responseArray);
                }
            })
        }

        function getByComponentIdLite(payload) {
            var deferred = $q.defer();
            var responseArray = [];
            var url = searchElectricalSchemaConstant.getByComponentIdLite;
            getComponentsAndSignalsRecursively(url, payload, deferred, responseArray);
            return deferred.promise;
        }

        function getBySignalIdLite(payload) {
            var deferred = $q.defer();
            var responseArray = [];
            var url = searchElectricalSchemaConstant.getBySignalIdLite;
            getComponentsAndSignalsRecursively(url, payload, deferred, responseArray);
            return deferred.promise;
        }

    }
})();

/**
 * searchElectricalSchemaMetierService
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('searchElectricalSchemaMetierService', searchElectricalSchemaMetierService);

    /** @ngInject */
    function searchElectricalSchemaMetierService(
        searchElectricalSchemaWsService,
        CacheService,
        $q,
        $state,
        $mdDialog,
        ResultSearchByDiagnosticConstants,
        searchElectricalSchemaConstant,
        CacheConstants,
        DocPrivConstants,
        CarSearchConstants,
        $rootScope,
        RoutesConstants,
        CarSearchResultConstants,$log,$translate,CloudFrontUrlHelper) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        vm.sharedWdPartHarnessAndWiringData = [];
        vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals = [];
        vm.idAndLabelComp = [];
        vm.idAndLabelSignal = [];

        this.getAllWiringDiagramsAndPartHarness = getAllWiringDiagramsAndPartHarness;
        this.getApplicabilitiesTree = getApplicabilitiesTree;
        this.getWiringDiagramByIds = getWiringDiagramByIds;
        this.getWiringDiagramByIdsWithFullContext = getWiringDiagramByIdsWithFullContext;
        this.getComponentDetailsById = getComponentDetailsById;

        this.getCanAndDocIds = getCanAndDocIds,
        this.getAndSaveCan_Doc = getAndSaveCan_Doc;
        this.getComponentsAndSignalsData = getComponentsAndSignalsData;
        this.getAndSaveComponents_Signals = getAndSaveComponents_Signals;
        this.getByIdLiteWithFullContext = getByIdLiteWithFullContext;
        this.getByIdLite = getByIdLite;
        this.getHarnessLayoutDetails = getHarnessLayoutDetails;

        this.sortComponentsListById = sortComponentsListById;
        this.formatResidual = formatResidual;
        this.formatVariableResidualForRawMTC = formatVariableResidualForRawMTC;
        this.filterCriteriasFromMTC = filterCriteriasFromMTC;
        this.displayCanAndFusesDocuments = displayCanAndFusesDocuments;
        this.formatResidualDoc_Can = formatResidualDoc_Can;
        this.removeDuplicateValue = removeDuplicateValue;
        this.convertArrayWDResponseToObject = convertArrayWDResponseToObject;
        this.updateUserContextProfiles = updateUserContextProfiles;
        this.signWiringDiagramUrls = signWiringDiagramUrls;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function signWiringDiagramUrls(wiringDiagram) {
            if (!wiringDiagram) {
                return wiringDiagram;
            }

            if (wiringDiagram.location) {
                wiringDiagram.location = CloudFrontUrlHelper.appendCloudFrontParams(wiringDiagram.location);
            }

            if (wiringDiagram.thumbnailLocation) {
                wiringDiagram.thumbnailLocation = CloudFrontUrlHelper.appendCloudFrontParams(wiringDiagram.thumbnailLocation);
            }

            if (wiringDiagram.displayedThumbnail) {
                wiringDiagram.displayedThumbnail = CloudFrontUrlHelper.appendCloudFrontParams(wiringDiagram.displayedThumbnail);
            }

            return wiringDiagram;
        }
        
        function signWiringDiagramsInResponse(response) {
            if (response && Array.isArray(response)) {
                response.forEach(function(item) {
                    if (item.WIRING_DIAGRAMS && Array.isArray(item.WIRING_DIAGRAMS)) {
                        item.WIRING_DIAGRAMS.forEach(function(diagram) {
                            signWiringDiagramUrls(diagram);
                        });
                    }
                });
            }
            return response;
        }

        /**
         * @desc    this service provide all the node of electrical schema
         */

        function getApplicabilitiesTree(isObjCritSelected,wdObjectCriteria) {
            var userContext = CacheService.getUserContextForElectricalSchema();
            var carContextDefault = CacheService.getCarContext();
            updateUserContextProfiles(userContext)
            var carContext;
            if(isObjCritSelected){
                carContext = CacheService.getFixedCriteriasForWd(carContextDefault,isObjCritSelected,wdObjectCriteria);
            }else{
                carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
            }

            var payload = {
                userContext: userContext,
                carContext: carContext,
                treeId: searchElectricalSchemaConstant.defaultTreeId,
                docType: {
                    WD: []
                }
            }

            return searchElectricalSchemaWsService.getApplicabilitiesTree(payload).then(function (response) {
                if (!response || !Array.isArray(response.nodes) || !response.nodes.length) {
                    return $q.reject(searchElectricalSchemaConstant.errors.NO_TREE_RETURNED)
                }
                if (response.nodes) {
                    response.nodes.sort(function (a, b) {
                        return a.nodeId - b.nodeId;
                    })

                    response.nodes.forEach(function (node) {
                        if (node && node.childNodes && node.childNodes.length) {
                            node.childNodes.sort(function (c, d) {
                                return c.nodeId - d.nodeId;
                            })
                        }
                    })

                    response.nodes.forEach(function (node1) {
                        if (node1 && node1.childNodes && node1.childNodes.length) {
                            node1.childNodes.forEach(function (node2) {
                                node2.childNodes.sort(function (c, d) {
                                    return c.nodeId - d.nodeId;
                                })
                            })
                        }
                    })
                }

                return response.nodes;
            });
        }


        /**
         * @description display Can, Fuses and other Documents from cache.
         * If one document is returned, it is directly opened in a new tab.
         * If several documents are returned, their applicability are displayed in a pop-in
         */

        function displayCanAndFusesDocuments(WDList_CanDocument, typeOfDoc) {
            var electricalSchemaPdfClass ='electrical-schema-pdf';
            var eSchemacanFusibleDocResidualList = 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemaCanFusibleDocResidualList.template.html';

            if (WDList_CanDocument) {
                vm.documentToDisplay = [];
                switch (typeOfDoc) {
                    case 'CAN':
                        if (WDList_CanDocument.can && WDList_CanDocument.can.length > 0) {
                            WDList_CanDocument.can.forEach(function (item) {
                                if (item.subType === typeOfDoc) {
                                    formatResidualDoc_Can(item);
                                    if (item.location) {
                                        item.location = CloudFrontUrlHelper.appendCloudFrontParams(item.location);
                                    }
                                }
                            });
                        }

                        if (WDList_CanDocument.can && WDList_CanDocument.can.length === 1) {
                            var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(WDList_CanDocument.can[0].location);
                            window.open(signedUrl);
                        } else {

                            // IE hack, as this browser puts PDF directive above current mdDialog

                            var pdfDirective = angular.element(document.getElementsByTagName(electricalSchemaPdfClass));
                            pdfDirective.addClass("doNotDisplayPdfFile");
                            vm.isPopInActive = true;

                            $mdDialog.show({
                                templateUrl: eSchemacanFusibleDocResidualList,
                                controller: 'electricalSchemaCanFusibleDocResidualListController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: false,
                                locals: {
                                    documentToDisplay: WDList_CanDocument.can,
                                    isPopInActive: vm.isPopInActive
                                }
                            }).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });

                        }
                        break;
                    case 'DOCUMENT':
                        if (WDList_CanDocument.fusible && WDList_CanDocument.fusible.length > 0) {
                            WDList_CanDocument.fusible.forEach(function (item) {
                                if (item.subType === typeOfDoc) {
                                    formatResidualDoc_Can(item);
                                    if (item.location) {
                                        item.location = CloudFrontUrlHelper.appendCloudFrontParams(item.location);
                                    }
                                }
                            });
                        }

                        if (WDList_CanDocument.fusible && WDList_CanDocument.fusible.length === 1) {
                            var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(WDList_CanDocument.fusible[0].location);
                            window.open(signedUrl);
                        } else {

                            // IE hack, as this browser puts PDF directive above current mdDialog

                            var pdfDirective = angular.element(document.getElementsByTagName(electricalSchemaPdfClass));
                            pdfDirective.addClass("doNotDisplayPdfFile");
                            vm.isPopInActive = true;

                            $mdDialog.show({
                                templateUrl: eSchemacanFusibleDocResidualList,
                                controller: 'electricalSchemaCanFusibleDocResidualListController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: false,
                                locals: {
                                    documentToDisplay: WDList_CanDocument.fusible,
                                    isPopInActive: vm.isPopInActive
                                }
                            }).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });

                        }
                        break;
                    case 'DOCUMENT':
                        if (WDList_CanDocument.otherDocs && WDList_CanDocument.otherDocs.length > 0) {
                            WDList_CanDocument.otherDocs.forEach(function (item) {
                                if (item.subType === typeOfDoc) {
                                    formatResidualDoc_Can(item);
                                    if (item.location) {
                                        item.location = CloudFrontUrlHelper.appendCloudFrontParams(item.location);
                                    }
                                }
                            });
                        }

                        if (WDList_CanDocument.otherDocs && WDList_CanDocument.otherDocs.length === 1) {
                            var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(WDList_CanDocument.otherDocs[0].location);
                            window.open(signedUrl);
                        } else {

                            // IE hack, as this browser puts PDF directive above current mdDialog

                            var pdfDirective = angular.element(document.getElementsByTagName(electricalSchemaPdfClass));
                            pdfDirective.addClass("doNotDisplayPdfFile");
                            vm.isPopInActive = true;

                            $mdDialog.show({
                                templateUrl: eSchemacanFusibleDocResidualList,
                                controller: 'electricalSchemaCanFusibleDocResidualListController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: false,
                                locals: {
                                    documentToDisplay: WDList_CanDocument.otherDocs,
                                    isPopInActive: vm.isPopInActive
                                }
                            }).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });

                        }
                        break;
                        default:
                            break;
                }
            }
        }

        /**
         * @description Used to convert incoming array into an object
         * @param {*} res
         */
        function convertArrayResponseToObject(res) {
            var result = {
                documents: []
            }

            if (res && res.length) {
                res.forEach(function (item) {
                    result.documents.push.apply(result.documents, item.documents);
                });
            }

            return result;
        }

        /**
         * @description Used to convert incoming array into an object
         * @param {*} res
         */
        function convertArrayWDResponseToObject(res) {
            var result = {
                WIRING_DIAGRAMS: []
            }

            if (res && res.length) {
                res.forEach(function (item) {
                    result.WIRING_DIAGRAMS.push.apply(result.WIRING_DIAGRAMS, item.WIRING_DIAGRAMS);
                });
            }
            return result;
        }

        /**
         *  @desc   Fetch all wiringDiagrams and part harness applicable to our car context;
         *  @return {Object}
         */

        function getAllWiringDiagramsAndPartHarness() {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            var carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
            updateUserContextProfiles(userContext);
            var payload = {
                userContext: userContext,
                carContext: carContext,
                docType: {
                    WD: {
                        subType: [
                            "WIRING",
                            "PART_HARNESS",
                            "CAN",
                            "DOCUMENT"
                        ]
                    }
                }
            };
            return searchElectricalSchemaWsService
                .getIdsWiringDiagramsAndPartHarness(payload)
                .then(function (res) {
                    res = convertArrayResponseToObject(res);
                    // document contains IDS
                    if (!res || !res.documents || !res.documents.length) {
                        return $q.reject(searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_IDS)
                    }
                    return res.documents.map(function (doc) {
                        return doc.id;
                    });
                })
                .then(function (WD_PH_IDS) {
                    return getWiringDiagramByIds(WD_PH_IDS).then(function (res) {
                        res = convertArrayWDResponseToObject(res);
                        if (!res || !res.WIRING_DIAGRAMS || !res.WIRING_DIAGRAMS.length) {
                            return $q.reject(searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_DOCUMENTS);
                        }

                        var wdCan = [];
                        var wdOtherDocuments = [];
                        var wdFusibles = [];
                        var wdPartHarness_Wiring = [];

                        res.WIRING_DIAGRAMS.forEach(function (item) {
                            if (item.subType === "CAN") {  //CAN Button
                                wdCan.push(item);
                            } else if (item.subType === "DOCUMENT" && item.name.includes("PLATFUSI")) { //Fusible et relai button
                                wdFusibles.push(item);
                            } else if (item.subType === "DOCUMENT" && !item.name.includes("PLATFUSI")) { // Other document button
                                wdOtherDocuments.push(item);
                            } else if (item.subType === "PART_HARNESS" || item.subType === "WIRING") {
                                wdPartHarness_Wiring.push(item);
                            }
                        });

                        var wdCanFusibleOthers = {};
                        wdCanFusibleOthers.can = wdCan;
                        wdCanFusibleOthers.fusible = wdFusibles;
                        wdCanFusibleOthers.otherDocs = wdOtherDocuments;

                        if (wdCanFusibleOthers.can && Array.isArray(wdCanFusibleOthers.can)) {
                            wdCanFusibleOthers.can.forEach(function(item) {
                                signWiringDiagramUrls(item);
                            });
                        }
                        if (wdCanFusibleOthers.fusible && Array.isArray(wdCanFusibleOthers.fusible)) {
                            wdCanFusibleOthers.fusible.forEach(function(item) {
                                signWiringDiagramUrls(item);
                            });
                        }
                        if (wdCanFusibleOthers.otherDocs && Array.isArray(wdCanFusibleOthers.otherDocs)) {
                            wdCanFusibleOthers.otherDocs.forEach(function(item) {
                                signWiringDiagramUrls(item);
                            });
                        }

                        CacheService.saveCAN_Document(wdCanFusibleOthers);
                        vm.sharedWdPartHarnessAndWiringData = wdPartHarness_Wiring;
                        return wdPartHarness_Wiring;
                    });
                });
        }

        /**
         *  @desc   Response from getAllWiringDiagramsAndPartHarness contains ALL
         *          data to display wiring diagrams, part harness, and others.
         *          It takes time so we store in cache to avoid unecessary call
         */


        /**
         *  @desc This service provides the list of CAN & Document via Fixedfiltered2
         */
        function getCanAndDocIds(isObjCritSelected,wdObjectCriteria) {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            updateUserContextProfiles(userContext);
            var carContext;
            if(isObjCritSelected){
                carContext = CacheService.getFixedCriteriasForWd(carContextDefault,isObjCritSelected,wdObjectCriteria);
            }else{
                carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
            }
            var payload = {
                userContext: userContext,
                carContext: carContext,
                docType: {
                    WD: {
                        subType: [
                            "CAN",
                            "DOCUMENT"
                        ]
                    }
                }
            };
            return searchElectricalSchemaWsService
                .getCanAndDocIds(payload)
                .then(function (res) {
                    res = convertArrayResponseToObject(res);
                    if (!res || !res.documents || !res.documents.length) {
                        //return $q.reject(searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_IDS)
                    }
                    return res.documents.map(function (doc) {
                        return doc.id;
                    });
                })
                .then(function (WD_DOC) {
                    var wdCan = [];
                    var wdOtherDocuments = [];
                    var wdFusibles = [];
                    var wdPartHarness_Wiring = [];
                    var wdCanFusibleOthers = {};

                    if (!_.isEmpty(WD_DOC)){
                        return getWiringDiagramByIds(WD_DOC,isObjCritSelected,wdObjectCriteria).then(function (res) {
                            res = convertArrayWDResponseToObject(res);
                            if (!res || !res.WIRING_DIAGRAMS || !res.WIRING_DIAGRAMS.length) {
                                return $q.reject(searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_DOCUMENTS);
                            }                            
    
                            res.WIRING_DIAGRAMS.forEach(function (item) {
                                if (item.subType === "CAN") {  //CAN Button
                                    wdCan.push(item);
                                } else if (item.subType === "DOCUMENT" && item.name.includes("PLATFUSI")) { //Fusible et relai button
                                    wdFusibles.push(item);
                                } else if (item.subType === "DOCUMENT" && !item.name.includes("PLATFUSI")) { // Other document button
                                    wdOtherDocuments.push(item);
                                } else if (item.subType === "PART_HARNESS" || item.subType === "WIRING") {
                                    wdPartHarness_Wiring.push(item);
                                }
                            });    
                            
                            wdCanFusibleOthers.can = wdCan;
                            wdCanFusibleOthers.fusible = wdFusibles;
                            wdCanFusibleOthers.otherDocs = wdOtherDocuments;
                            
                            if (wdCanFusibleOthers.can && Array.isArray(wdCanFusibleOthers.can)) {
                                wdCanFusibleOthers.can.forEach(function(item) {
                                    signWiringDiagramUrls(item);
                                });
                            }
                            if (wdCanFusibleOthers.fusible && Array.isArray(wdCanFusibleOthers.fusible)) {
                                wdCanFusibleOthers.fusible.forEach(function(item) {
                                    signWiringDiagramUrls(item);
                                });
                            }
                            if (wdCanFusibleOthers.otherDocs && Array.isArray(wdCanFusibleOthers.otherDocs)) {
                                wdCanFusibleOthers.otherDocs.forEach(function(item) {
                                    signWiringDiagramUrls(item);
                                });
                            }
                            
                            CacheService.saveCAN_Document(wdCanFusibleOthers);
                            return wdCanFusibleOthers;                           
                        });
                    }
                    else {
                        return wdCanFusibleOthers;
                    }       

                });
        }

        /**
         *  @desc Cache the response of CAN & Document and store it.
         */
        function getAndSaveCan_Doc(isObjCritSelected,wdObjectCriteria) {
            var CAN_DOC = CacheService.getCAN_Document();

            if (CAN_DOC) {
                return $q.resolve(CAN_DOC);
            }

            return getCanAndDocIds(isObjCritSelected,wdObjectCriteria).then(function (doc) {
                CacheService.saveCAN_Document(doc);
                return doc;
            });
        }

        /**
         *  @desc
         *  Call the new service ComponentsAndSignals to get the label and ids of components & signals
         */
        function getComponentsAndSignalsData() {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            var carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
            updateUserContextProfiles(userContext);
            var payload = {
                userContext: userContext,
                carContext: carContext
            };
            return searchElectricalSchemaWsService
                .getComponentsAndSignals(payload)
                .then(function (result) {
                    var wd_signals = result.signals;
                    var wd_components = result.components;
                    vm.idAndLabelSignal = [];
                    vm.idAndLabelComp = [];

                    if (wd_signals && wd_signals.length) {
                        wd_signals.forEach(function (item) {
                            vm.idAndLabelSignal.push(item);
                        });
                        vm.idAndLabelSignal.sort(sortComponentsListById);
                    }

                    if (wd_components && wd_components.length) {
                        wd_components.forEach(function (item) {
                            vm.idAndLabelComp.push(item);
                        });
                        vm.idAndLabelComp.sort(sortComponentsListById);
                    }

                    vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals = vm.idAndLabelComp.concat(vm.idAndLabelSignal);
                    return vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals;
                });

        }

        /**
         *  @desc Cache the response of Components & Signals data and store it.
         */
        function getAndSaveComponents_Signals() {
            var WD_Comp_Signals = CacheService.getComponentsAndSignals();

            if (WD_Comp_Signals) {
                vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals = WD_Comp_Signals;
                return $q.resolve(WD_Comp_Signals);
            }

            return getComponentsAndSignalsData().then(function (components_signals) {
                CacheService.saveComponentsAndSignals(components_signals);
                if(_.isEmpty(vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals)){
                    vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals = components_signals;
                }
                return components_signals;
            });
        }

        /**
         *  @desc   This service provide all the node of electrical schema
         */

        function getWiringDiagramByIds(wdArray,isObjCritSelected,wdObjectCriteria) {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            var carContext = CacheService.getFixedCriteriasForWd(carContextDefault,isObjCritSelected,wdObjectCriteria);
            updateUserContextProfiles(userContext);
            var payload = {
                userContext: userContext,
                carContext: carContext,
                wdIds: wdArray
            }
            return searchElectricalSchemaWsService.getWiringDiagramByIds(payload)
                .then(signWiringDiagramsInResponse);
        }

        function getWiringDiagramByIdsWithFullContext(wdArray) {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            updateUserContextProfiles(userContext)
            var payload = {
                userContext: userContext,
                carContext: carContextDefault,
                wdIds: wdArray
            }
            return searchElectricalSchemaWsService.getWiringDiagramByIds(payload)
                .then(signWiringDiagramsInResponse);
        }

        function getComponentDetailsById(componentId,isObjCritSelected,wdObjectCriteria) {
            var userContext = CacheService.getUserContext();
            var carContextDefault = CacheService.getCarContext();
            var carContext = CacheService.getFixedCriteriasForWd(carContextDefault,isObjCritSelected,wdObjectCriteria);
            updateUserContextProfiles(userContext);
            var payload = {
                "userContext": userContext,
                "carContext": carContext,
                "wdIds": componentId,
                "subType": ["CONNECTOR"] //alway CONNECTOR for this case
            };

            return searchElectricalSchemaWsService.getWiringDiagramByIds(payload)
                .then(signWiringDiagramsInResponse);
        }        

        function getByIdLiteWithFullContext(Id, type, isObjCritSelected, wdObjectCriteria) {
            if (type == "WD_COMPONENT") {
                var userContext = CacheService.getUserContext();
                var carContextDefault = CacheService.getCarContext();
                updateUserContextProfiles(userContext);
                if (wdObjectCriteria && wdObjectCriteria.length > 0){
                    var carContext = CacheService.getFixedCriteriasForWd(carContextDefault, isObjCritSelected, wdObjectCriteria);
                    var payload = {
                        "userContext": userContext,
                        "carContext": carContext,
                        "componentIds": [Id],
                        "subType": ["GROUND_HARNESS", "PART_HARNESS", "CONNECTOR", "WIRING"]
                    };
                }
                else{
                    var payload = {
                        "userContext": userContext,
                        "carContext": carContextDefault,
                        "componentIds": [Id],
                        "subType": ["GROUND_HARNESS", "PART_HARNESS", "CONNECTOR", "WIRING"]
                    };
                }
                

                return searchElectricalSchemaWsService.getByComponentIdLite(payload)
                    .then(signWiringDiagramsInResponse);
            }

            else if (type == "WD_SIGNAL") {
                var userContext = CacheService.getUserContext();
                var carContextDefault = CacheService.getCarContext();
                updateUserContextProfiles(userContext);
                var payload = {
                    "userContext": userContext,
                    "carContext": carContextDefault,
                    "signalIds": [Id],
                    "subType": ["GROUND_HARNESS", "PART_HARNESS", "CONNECTOR", "WIRING"]
                };

                return searchElectricalSchemaWsService.getBySignalIdLite(payload)
                    .then(signWiringDiagramsInResponse);
            }

        }

        function getByIdLite(Id, type, subType,isObjCritSelected,wdObjectCriteria) {
            if (type == "WD_COMPONENT") {
                var userContext = CacheService.getUserContext();
                var carContextDefault = CacheService.getCarContext();
                var carContext = CacheService.getFixedCriteriasForWd(carContextDefault,isObjCritSelected,wdObjectCriteria);
                updateUserContextProfiles(userContext)
                var payload = {
                    "userContext": userContext,
                    "carContext": carContext,
                    "componentIds": [Id],
                    "subType": subType
                };

                return searchElectricalSchemaWsService.getByComponentIdLite(payload)
                    .then(signWiringDiagramsInResponse);
            }

            else if (type == "WD_SIGNAL") {
                var userContext = CacheService.getUserContext();
                var carContextDefault = CacheService.getCarContext();
                var carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
                updateUserContextProfiles(userContext);
                var payload = {
                    "userContext": userContext,
                    "carContext": carContext,
                    "signalIds": [Id],
                    "subType": subType
                };

                return searchElectricalSchemaWsService.getBySignalIdLite(payload)
                    .then(signWiringDiagramsInResponse);
            }

        }

        function getHarnessLayoutDetails(id){
            var userContext = CacheService.getUserContext();
                var carContextDefault = CacheService.getCarContext();
                var carContext = CacheService.getFixedCriteriasForWd(carContextDefault);
                updateUserContextProfiles(userContext)
                var payload = {
                    "userContext": userContext,
                    "carContext": carContext,
                    "componentIds": id,
                    "subType": ["GROUND_HARNESS", "PART_HARNESS"]
                };

                return searchElectricalSchemaWsService.getByComponentIdLite(payload)
                    .then(signWiringDiagramsInResponse);

        }


        /**
         * @description extract residual applicability from WD item and store all the information in a String.
         * This String will be bound to a pop-in.
         */

        function formatResidualDoc_Can(item) {

            var labelObj = '';
            item.applicabilityResidual = [];
            if (!_.isEmpty(item.residual) && !_.isEmpty(item.residual[0].fixe)) {

                item.applicabilityResidualChain = '';

                item.residual[0].fixe.forEach(function (residualFixe) {
                    var applicabilityResidualInformation = '';
                    labelObj = residualFixe.labelObj;

                    var listCritIndex = 0;
                    var listCritSize = residualFixe.listCrit.length;
                    residualFixe.listCrit.forEach(function (crit) {
                        var objAndCodeCritLabelData = "<span class='labelObjectDisplay'>" + labelObj + '</span> '+ "<span class='labelObjectDisplay'> : </span> " + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                        if (listCritSize === 1) {
                            applicabilityResidualInformation += objAndCodeCritLabelData;

                        } else {
                            if (listCritIndex === 0) {
                                applicabilityResidualInformation = objAndCodeCritLabelData;

                            } else {
                                applicabilityResidualInformation += "<span class='labelAndCodeCritDisplay'>,</span> <span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                            }
                        }
                        listCritIndex++;
                    });
                    item.applicabilityResidual.push(applicabilityResidualInformation);
                });

                item.applicabilityResidualChain = item.applicabilityResidual.join('<br>');

            }

            if (!_.isEmpty(item.residual) && !_.isEmpty(item.residual[0].variable)) {

                item.residual[0].variable.forEach(function (residualVariable) {
                    var applicabilityResidualInformation = '';
                    labelObj = residualVariable.labelObj;

                    var listCritIndex = 0;
                    var listCritSize = residualVariable.listCrit.length;
                    residualVariable.listCrit.forEach(function (crit) {
                        var objAndCodeCritLabelData = "<span class='labelObjectDisplay'>" + labelObj + ': </span>' + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                        if (listCritSize === 1) {
                            applicabilityResidualInformation += objAndCodeCritLabelData;

                        } else {
                            if (listCritIndex === 0) {
                                applicabilityResidualInformation = objAndCodeCritLabelData;

                            } else {
                                applicabilityResidualInformation += "<span class='labelAndCodeCritDisplay'>,</span> <span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                            }
                        }
                        listCritIndex++;
                    });
                    item.applicabilityResidual.push(applicabilityResidualInformation);
                });

                item.applicabilityResidualChain = item.applicabilityResidual.join('<br>');

            }
        }

        /**
         *  @desc   Add new field on each element of residualApplication => computedResiduel: Array<string>
         *  @param {Object} residualApplicabilities node containing the residual applicability
         *  @return {array<{}>} return the formated residual array
         */
        function formatResidual(residualApplicabilities) {
            var tmp = [];
            var name;
            if (residualApplicabilities) {
                name = residualApplicabilities.name;
            }
            if (residualApplicabilities.residual && residualApplicabilities.residual.length) {
                return residualApplicabilities.residual.reduce(function (acc, obj) {

                    if (Array.isArray(obj.variable)) {
                        obj.variable.name = name;
                        tmp = tmp.concat(obj.variable);
                    }

                    if (Array.isArray(obj.fixe)) {
                        tmp = tmp.concat(obj.fixe);
                    }

                    var residual = tmp.map(function (v) {
                        var labelObj = v.labelObj;
                        var labelCrit = '';
                        var codeCrit = '';
                        var label = [];
                        var labelToString = '';

                        if (Array.isArray(v.listCrit)) {
                            labelCrit = '';
                            codeCrit = '';
                            v.listCrit.map(function (crit) {
                                var itemObject = {};
                                var checkCodeCritDate = isValidDate(crit.codeCrit);
                                if (checkCodeCritDate && crit.labelCrit == crit.codeCrit) {
                                    itemObject = crit.labelCrit;
                                } else {
                                    itemObject = crit.labelCrit + ' (' + crit.codeCrit + ')';
                                }
                                label.push(itemObject);
                            });

                            labelToString = label.join(' | ');
                        }
                        return labelObj + ' : ' + labelToString;
                    });
                    var title = acc.concat(name, residual)[0];
                    var infos = acc.concat(name, residual).slice(1);
                    return acc.concat(title, infos)
                }, []);
            }
            return [name];
        }

        /**
         * @description Check if the codeCrit is a date or not
         * @param {*} dateString
         */
        function isValidDate(dateString) {
            var regEx = /^\d{4}[/]\d{2}[/]\d{2}$/;
            var regEx1 = /^\d{2}[/]\d{2}[/]\d{2}$/;
            return (dateString.match(regEx) != null || dateString.match(regEx1) != null);
        }


        /**
         *  @desc   Add new field on each element of residualApplication => computedResidual: Array<string>
         *  @param {Object} residualApplicabilities node containing the variable residual applicability
         *  @return {array<{}>} return the formated variable residual array
         */
        function formatVariableResidualForRawMTC(residualApplicabilities) {
            if (residualApplicabilities && residualApplicabilities.length) {
                return residualApplicabilities.reduce(function (acc, obj) {
                    var tmp = [];
                    tmp = tmp.concat(obj);

                    var residual = tmp.map(function (v) {
                        var labelObj = v.labelObj;
                        var labelCrit = '';
                        var codeCrit = '';
                        var label = [];
                        var labelToString = '';
                        if (Array.isArray(v.listCrit)) {
                            labelCrit = '';
                            codeCrit = '';
                            v.listCrit.map(function (crit) {
                                var itemObject = {};
                                itemObject = crit.labelCrit + ' (' + crit.codeCrit + ')';
                                label.push(itemObject);
                            });

                            labelToString = label.join(' | ');

                        }
                        return labelObj + ' : ' + labelToString;
                    });
                    return acc.concat(residual);
                }, []);
            }
        }


        /**
         * @name sortComponentsListById
         * @desc sort array of components by id
         * @param {String}, {String}
         * @returns {String}
         */

        function sortComponentsListById(a, b) {

            var regex = /^([a-z]*)(\d*)/i;

            var _a = a.id.match(regex);
            var _b = b.id.match(regex);

            // if the alphabetic part of a is less than that of b => -1
            if (_a[1] < _b[1]) return -1;
            // if the alphabetic part of a is greater than that of b => 1
            if (_a[1] > _b[1]) return 1;

            // if the alphabetic parts are equal, check the number parts
            if (_a[2] != '' && _b[2] != '') {
                var _n = parseInt(_a[2]) - parseInt(_b[2]);
                if (_n == 0) { // if the number parts are equal start a recursive test on the rest

                    return function () {
                        var _aa = _a.replace(/-/g, '');
                        var _bb = _b.replace(/-/g, '');

                        // if the alphabetic part of a is less than that of b => -1
                        if (_aa[1] < _bb[1]) return -1;
                        // if the alphabetic part of a is greater than that of b => 1
                        if (_aa[1] > _bb[1]) return 1;
                    };
                } else {
                    // else, just sort using the numbers parts
                    return _n;
                }
            }
        }


        /**
         * @name filterCriteriasFromMTC
         * @desc filters criterias APL0x and APV001 from rawMTC returned by wiringDiagrams service
         * @param {String}
         * @returns {String}
         */

        function filterCriteriasFromMTC(MTCString) {

            if (MTCString == "" || MTCString == undefined) {
                return '';
            } else {
                var tmpArray = [];

                MTCString.forEach(function (item) {
                    var itemObject = {};
                    var arrayOfApplicability = item.split("/");
                    arrayOfApplicability.forEach(function (subItem, index) {
                        if (subItem.indexOf(',') > -1) {
                            var subArrayOfApplicability = subItem.split(",");
                            subArrayOfApplicability.forEach(function (subArrayItem, index) {
                                if (subArrayItem.indexOf("APL") === -1 && subArrayItem.indexOf("APV001") === -1) {
                                    if (index === (subArrayOfApplicability.length - 1)) {
                                        subArrayItem = subArrayItem + "/";
                                    }
                                    tmpArray.push(subArrayItem);
                                }
                            });
                        } else {
                            if (subItem.indexOf("APL") === -1 && subItem.indexOf("APV001") === -1) {
                                if (index !== (arrayOfApplicability.length - 1)) {
                                    subItem = subItem + "/";
                                }
                                tmpArray.push(subItem);
                            }
                        }
                    });
                });

                tmpArray = tmpArray.toString();
                tmpArray = tmpArray.replace(/\/,/g, '/');
                return tmpArray;
            }
        }

        /**
         * @description Used to remove the duplicate entries (components) from the wiring diagram component data
         * @param {*} myArray
         */
        function removeDuplicateValue(myArray) {
            var newArray = [];
            angular.forEach(myArray, function (value, key) {
                var exists = false;
                angular.forEach(newArray, function (val2, key) {
                    if (angular.equals(value.code, val2.code)) {
                        exists = true
                    };
                });
                if (exists == false && value.code != "") {
                    newArray.push(value);
                }
            });
            return newArray;
        }

        function updateUserContextProfiles(userContext) {
            var user = CacheService.getObject(RoutesConstants.profil);
            if (userContext && userContext.userProfiles && user){
                if(user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)){
                    userContext.userProfiles.push(DocPrivConstants.ppxConfidentialPayload.toLowerCase());
                }
                else if(user.roles && user.roles.includes(CarSearchConstants.ppxIndependentUser) && user.accountType === 'Partner' && $rootScope.asomDocList.DOCPRIV){
                    userContext.userProfiles.push(CarSearchConstants.ppxIndependentUser.toLowerCase());
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix').controller('SelectedFilterCtrl', SelectedFilterCtrl);

        /** @ngInject */
    function SelectedFilterCtrl($mdDialog,CacheService, CacheConstants,configConstantes
        ) {

            var vm = this;
            vm.residual = [];
            var wdObjectCriteria = vm.selObjCrit = CacheService.getObject(CacheConstants.wdObjectCriteria);
            vm.selObjCrit = wdObjectCriteria ? wdObjectCriteria.currentnodeList : [];
            vm.updateObjCrit = updateObjCrit;
            vm.onCancel = onCancel;
            vm.onConfirm = onConfirm;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);


            init();

            function init() {
                    if(vm.selObjCrit && vm.wiringDiagrams && vm.wiringDiagrams.length >=1){
                        var objCrit = [];
                        _.map(vm.selObjCrit,function(obj){
                            if(_.findIndex(objCrit,{'codeObj':obj.codeObj}) === -1){
                                objCrit.push(
                                    {
                                        codeObj: obj.codeObj,
                                        labelObj: obj.labelObj
                                    }
                                )
                            }
                            _.map(objCrit, function(item){

                                if(item.codeObj === obj.codeObj){
                                    if(!_.has(item,'listCrit')){
                                        _.extend(item, {listCrit: obj.listCrit})
                                    }else {
                                        _.map(obj.listCrit,function(objListCrit){
                                            var isListCrit = _.find(item.listCrit,objListCrit);
                                            if(!isListCrit){
                                                item.listCrit.push(objListCrit);
                                            }
                                        })
                                    }
                                }
                            })
                        })

                        vm.selObjCrit.forEach(function(item){
                            if(item.codeObj !== "APVAP1" && item.codeObj !== "956" && item.codeObj !== "901"){
                                vm.residual.push(item);
                            }
                        })
                    }
            }

            function updateObjCrit(selObj,selCrit){
                if(selCrit && !_.isEmpty(selCrit)){

                    var index = _.findIndex(vm.selObjCrit, function(item){
                        return item.codeObj === selObj.codeObj;
                    })
                    if (index > -1) {
                        var code = _.find(vm.selObjCrit[index].listCrit, function (item) {
                            return item.labelCrit === selObj.labelCrit
                        })
                        vm.selObjCrit[index].codeCrit = code.codeCrit;
                        vm.selObjCrit[index].labelCrit = selObj.labelCrit;
                    }
                    else{
                        vm.selObjCrit.push({
                            codeObj: selObj.codeObj,
                            labelObj: selObj.labelObj,
                            codeCrit: selObj.labelCrit,
                            labelCrit: selCrit,
                            listCrit: selObj.listCrit
                        })
                    }

                }else{
                    var idx = _.findIndex(vm.selObjCrit,function(item){
                        return item.codeObj === selObj.codeObj;
                    })
                    delete(vm.selObjCrit[idx].codeCrit);
                    delete(vm.selObjCrit[idx].labelCrit);
                }
            }

            function onConfirm(){
                if(vm.selObjCrit && !_.isEmpty(vm.selObjCrit)){
                    var headerSelObjCrit = [];
                    if(wdObjectCriteria && !_.isEmpty(wdObjectCriteria)){
                        headerSelObjCrit = wdObjectCriteria.header;
                    }

                    if (headerSelObjCrit && !_.isEmpty(headerSelObjCrit)) {
                        headerSelObjCrit = headerSelObjCrit.concat(vm.selObjCrit);
                    } else {
                        headerSelObjCrit = vm.selObjCrit
                    }

                    headerSelObjCrit = _.uniqBy(headerSelObjCrit,'codeCrit');
                    var updateWdObjectCriteria = {
                        header : headerSelObjCrit,
                        currentnodeList : vm.selObjCrit
                    }
                    
                    wdObjectCriteria.currentnodeList = vm.selObjCrit;
                    CacheService.setObject(CacheConstants.wdObjectCriteria, wdObjectCriteria);
                }
                $mdDialog.hide(updateWdObjectCriteria);
            }

            function onCancel(){
                vm.selObjCrit = [];
                $mdDialog.cancel();

            }

        };

})();

(function () {
    'use strict';

    angular
        .module('phenix').controller('ObjectCriteriaModalCtrl', ObjectCriteriaModalCtrl);

        /** @ngInject */
    function ObjectCriteriaModalCtrl($mdDialog,CacheService, CacheConstants,configConstantes,$document, $scope) 
         {

            var vm = this;
            vm.residual = [];
            vm.selObjCrit = [];
            var wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria);
            vm.selObjCrit = wdObjectCriteria ? wdObjectCriteria.currentnodeList : [];
            vm.updateObjCrit = updateObjCrit;
            vm.onCancel = onCancel;
            vm.onConfirm = onConfirm;
            vm.dropdownOpen = false;
            vm.iswdObjectCriteriaLoaded = CacheService.getObject(CacheConstants.wdObjectCriteria) ? true : false;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

            init();

            function init() {
                
                var objCrit = [];
                _.map(vm.wiringDiagrams,function(wd){
                    _.map(wd.residual,function(residual){
                        _.map(residual.fixe,function(obj){

                            if(_.findIndex(objCrit,{'codeObj':obj.codeObj}) === -1){
                                objCrit.push(
                                    {
                                        codeObj: obj.codeObj,
                                        labelObj: obj.labelObj
                                    }
                                )
                            }

                            _.map(objCrit, function(item){

                                if(item.codeObj === obj.codeObj){
                                    if(!_.has(item,'listCrit')){
                                        _.extend(item, {listCrit: obj.listCrit})
                                    }else {
                                        _.map(obj.listCrit,function(objListCrit){
                                            var isListCrit = _.find(item.listCrit,objListCrit);
                                            if(!isListCrit){
                                                item.listCrit.push(objListCrit);
                                            }
                                        })
                                        
                                    }
                                }

                            })
                                
                        })

                        
                        _.map(residual.variable,function(obj){

                            if(_.findIndex(objCrit,{'codeObj':obj.codeObj}) === -1){
                                if (obj.codeObj == "APVAP1")
                                {
                                    objCrit.push(
                                        {
                                            codeObj: obj.codeObj,
                                            labelObj: obj.labelObj
                                        }
                                    )
                                }
                                
                            }

                            _.map(objCrit, function(item){

                                if(item.codeObj === obj.codeObj){
                                    if(!_.has(item,'listCrit')){
                                        _.extend(item, {listCrit: obj.listCrit})
                                    }else {
                                        _.map(obj.listCrit,function(objListCrit){
                                            var isListCrit = _.find(item.listCrit,objListCrit);
                                            if(!isListCrit){
                                                item.listCrit.push(objListCrit);
                                            }
                                        })
                                        
                                    }
                                }

                            })
                                
                        })                        
                            
                    })
                })
                if (vm.iswdObjectCriteriaLoaded){
                    objCrit.forEach(function(item){
                        if(item.codeObj != "APVAP1" && item.codeObj != "956" && item.codeObj !== "901"){
                            vm.residual.push(item);
                        }
                    })

                }
                else{
                    vm.residual = objCrit;
                }
                
                angular.copy(vm.residual,vm.selObjCrit);
            }
        vm.toggleDropdown = function (obj) {
            vm.residual.forEach(function (item) {
                item.dropdownOpen = false;
            });
            obj.dropdownOpen = !obj.dropdownOpen;
        };

        vm.selectItem = function (obj, selectedValue) {
            obj.labelCrit = selectedValue;
            vm.updateObjCrit(obj, selectedValue);
            obj.dropdownOpen = false;
        };
        $document.on('click', function (event) {
            var isClickInside = event.target.closest('.custom-dropdown');
            if (!isClickInside) {
                $scope.$apply(function () {
                    vm.residual.forEach(function (item) {
                        item.dropdownOpen = false;
                    });
                });
            }
        });
        $scope.$on('$destroy', function () {
            $document.off('click');
        });

            function updateObjCrit(selObj,selCrit){
                if(selCrit && !_.isEmpty(selCrit)){

                    var index = _.findIndex(vm.selObjCrit, function(item){
                        return item.codeObj === selObj.codeObj;
                    })
                    if (index > -1 ){
                        var code =  _.find(vm.selObjCrit[index].listCrit,function (item){
                                return item.labelCrit === selObj.labelCrit
                            })
                        vm.selObjCrit[index].codeCrit = code.codeCrit;
                        vm.selObjCrit[index].labelCrit = selObj.labelCrit;
                    }
                    else{
                        if(!vm.selObjCrit){
                            vm.selObjCrit = [];
                        }
                        var codeCrit = _.find(selObj.listCrit, function (item){
                            return item.labelCrit === selObj.labelCrit;
                        })
                        vm.selObjCrit.push({
                            codeObj: selObj.codeObj,
                            labelObj: selObj.labelObj,
                            codeCrit: codeCrit.codeCrit,
                            labelCrit: selCrit,
                            listCrit: selObj.listCrit
                        })
                    }

                }else{
                    var idx = _.findIndex(vm.selObjCrit,function(item){
                        return item.codeObj === selObj.codeObj;
                    })
                    delete(vm.selObjCrit[idx].codeCrit);
                    delete(vm.selObjCrit[idx].labelCrit);
                }
            }

            function onConfirm(){
                if (vm.selObjCrit && !_.isEmpty(vm.selObjCrit)) {
                    var headerSelObjCrit = [];
                    var tempSelObjCrit = [];

                    if (wdObjectCriteria && !_.isEmpty(wdObjectCriteria)) {
                        headerSelObjCrit = wdObjectCriteria.header;
                    }

                    if (headerSelObjCrit && !_.isEmpty(headerSelObjCrit)) {
                        headerSelObjCrit = headerSelObjCrit.concat(vm.selObjCrit);
                    } else {
                        headerSelObjCrit = vm.selObjCrit
                    }
                    headerSelObjCrit.forEach( function (item){
                        if(item.codeCrit){
                            tempSelObjCrit.push(item)

                        }
                    })
                    

                    if (wdObjectCriteria && !_.isEmpty(wdObjectCriteria)) {
                        var updateCacherCurrentList = {};
                        updateCacherCurrentList.currentnodeList = vm.selObjCrit;
                        if (wdObjectCriteria && wdObjectCriteria.header && !_.isEmpty(wdObjectCriteria.header)) {
                            updateCacherCurrentList.header = wdObjectCriteria.header;
                        }else{
                            delete(wdObjectCriteria.isObjCriteriaAvailable);
                            updateCacherCurrentList.header = updateCacherCurrentList.currentnodeList;
                        }
                        CacheService.setObject(CacheConstants.wdObjectCriteria, updateCacherCurrentList);

                        wdObjectCriteria.header = tempSelObjCrit;
                        wdObjectCriteria.currentnodeList = vm.selObjCrit;
                    } else {
                        var updatewdObjectCriteria = {
                            header: tempSelObjCrit,
                            currentnodeList: vm.selObjCrit
                        }

                        var updateCacheList = {};
                        updateCacheList.currentnodeList = vm.selObjCrit;
                        CacheService.setObject(CacheConstants.wdObjectCriteria, updateCacheList);
                        $mdDialog.hide(updatewdObjectCriteria);
                        return;
                    }
                }
                $mdDialog.hide(wdObjectCriteria);
            }

            function onCancel(){
                var headerList = [];
                if (wdObjectCriteria && !_.isEmpty(wdObjectCriteria)) {
                    wdObjectCriteria.currentnodeList = vm.selObjCrit;
                    headerList = wdObjectCriteria.header;
                    CacheService.setObject(CacheConstants.wdObjectCriteria, wdObjectCriteria);
                }
                else {
                    var UpdatedObjectCriteria = {};
                    UpdatedObjectCriteria.currentnodeList = vm.selObjCrit;
                    headerList = UpdatedObjectCriteria.header;
                    CacheService.setObject(CacheConstants.wdObjectCriteria, UpdatedObjectCriteria);
                }

                var onHidepopup = { isObjCriteriaAvailable: false, header : headerList }
                if (vm.selObjCrit && !_.isEmpty(vm.selObjCrit)) {
                    onHidepopup.isObjCriteriaAvailable = true;
                }
                $mdDialog.hide(onHidepopup);

            }

        };

})();

(function() {
  angular.module('phenix').directive('imageonload', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                    scope.$apply(attrs.imageonload)(true);
                });
                element.bind('error', function(){
                  scope.$apply(attrs.imageonload)(false);
                });
            }
        };
    })
})();

(function () {

    angular
        .module('phenix.core')
        .directive('electricalSvg', behavior);

    function behavior($compile, $rootScope) {
        return {
            restrict: 'E',
            scope: {
                appSvg: '<',
                location: '<',
                data: '='
            },
            templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSvg.template.html',
            link: {
                pre: function (scope, element, attrs, controller) {
                    //     // Create dynamic SVG

                    var content = $compile(controller.appSvg)(scope);

                    content.attr('id', 'electrical-svg');
                    content.attr('class', 'borderThumb');
                    if(controller.nissanUserURL){
                        content.attr('class','borderThumb nissanBorder');
                    }
                    //this svg contains some event we want to clean
                    content.attr('onclick', '');
                    content.attr('onmouseover', '');
                    content.attr('onmouseout', '');
                    content.attr('onload', '');

                    content = $compile(content)(scope);

                    var svg = _.find(content, function (elem) {
                        return elem['ng339'];
                    });

                    if (_.isUndefined(svg)) {
                        svg = _.find(content, function (elem) {
                            return elem['localName'] === 'svg';
                        });
                    }

                    if (_.isUndefined(svg)) {
                        svg = _.find(content, function (elem) {
                            return elem['localName'] === 'svg';
                        });
                    }

                    element[0].querySelector('#electrical-svg-container').appendChild(svg);
                    var svgTextTags = svg.getElementsByTagName("text");
                    var dataSplitForDesc = _.groupBy(controller.data.components, 'id');
                    // Used to add ng-click to all the text Tags of the svg file
                    for (var i = 0; i < svgTextTags.length; i++) {
                        var e = angular.element(svgTextTags[i]);
                        e.attr("id", svgTextTags[i].textContent);
                        if(dataSplitForDesc[svgTextTags[i].textContent] && dataSplitForDesc[svgTextTags[i].textContent][0] && dataSplitForDesc[svgTextTags[i].textContent][0].subType != 'unknown'){
                            var tooltipItem = document.createElement("md-tooltip");
                            tooltipItem.innerHTML = dataSplitForDesc[svgTextTags[i].textContent][0].label;
                            e.append(tooltipItem);
                        }
                        try {
                            var id = e[0].id;
                            // Add ng-click to components of part harness and wiring diagram SVG
                            if ($rootScope.isPartHarnessSelected) {
                                e.attr("ng-click", "loadSelectedPartHarnessSchema("+"\""+id+"\""+")");
                            } else {
                                e.attr("ng-click", "loadRelatedElectricalSchema("+"\""+id+"\""+")");
                            }
                        } catch (error) {

                        }
                        $compile(e)(scope);
                    }

                    // Used to add ng-click to all the polyline Tags of the svg file (for Links/Signals)
                    var svgPolylineTags = element[0].getElementsByTagName("polyline");
                    for (var i = 0; i < svgPolylineTags.length; i++) {
                        var poly = angular.element(svgPolylineTags[i]);
                        var polyParent = $(poly).parent();
                        var parentId;
                        if (polyParent[0].id) {
                            poly.attr("id", polyParent[0].id);
                            poly.attr("class", "svg-class");
                            poly.attr("stroke-width","1.0");
                            parentId = polyParent[0].id;
                            // Add ng-click to signals of wiring Diagram SVG
                            poly.attr("ng-click", "loadLinkRelatedElectricalSchema("+"\""+parentId+"\""+")");
                        }
                        $compile(poly)(scope);
                    }

                    // This function is called when a polyLine (link/signal) is clicked on an SVG
                    scope.loadLinkRelatedElectricalSchema = function(id) {
                        $rootScope.loadSignalRelatedElectricalSchema(id);
                    }

                    //Used to load the selected component and the corresponding thumbnails and electrical schema
                    scope.loadRelatedElectricalSchema = function (id) {
                        $rootScope.loadSchemaDiagrams(id);
                    }

                    //Used to load the selected component and the corresponding thumbnails and electrical schema as per the selected component on the part harness SVG
                    scope.loadSelectedPartHarnessSchema = function (id) {
                        $rootScope.loadAndColorPartHarnessSchema(id);
                    }
                },
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: function ($window, $timeout, configConstantes) {
                var vm = this;
                vm.elemToZoomContainer = document.getElementById('electrical-svg-container');
                vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
                vm.isFullScreen = false;
                vm.zoomIn = zoomIn;
                vm.zoomOut = zoomOut;
                vm.resetZoom = resetZoom;
                vm.fullOrReducedScreen = fullOrReducedScreen;
                vm.openFullscreen = openFullscreen;
                vm.exitFullscreen = exitFullscreen;
                vm.resize = _.debounce(function () {
                    vm.svgPanZoom.resize();
                    vm.svgPanZoom.resetZoom();
                    vm.svgPanZoom.center();
                }, 0);

                vm.applySvgPanZoom = function () {
                    // hack for IE
                    // image is loaded but not on the DoM
                    // wait for it and apply svgPanZoom
                    $timeout(function() {
                        var beforePan;
                        beforePan = function (oldPan, newPan) {
                            var sizes = this.getSizes()
                                , gutterWidth = sizes.width
                                , gutterHeight = sizes.height
                                , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
                                , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
                                , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
                                , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
                            var customPan = {};
                            var positionOnX = vm.svgPanZoom.getPan().x;
                            // if svg is in last zoom out position, center svg. Else, normal behavior.
                            if (positionOnX > 0) {
                                customPan.x = 79.17568037852106;
                                customPan.y = 0;
                            } else {
                                customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
                                customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
                            }
                            return customPan;
                        };

                        vm.svgPanZoom = svgPanZoom('#electrical-svg', {
                            dblClickZoomEnabled: false,
                            minZoom: 1,
                            maxZoom: 15,
                            zoomScaleSensitivity: 1
                            //beforePan: beforePan  - commented to move the diagram draggable
                        });

                        angular.element($window).on('resize', vm.resize);
                    }, 0);
                };

                this.$onDestroy = function () {
                    angular.element($window).off('resize', vm.resize);
                };

                function zoomIn() {
                    vm.svgPanZoom.zoomIn();
                }

                function zoomOut() {
                    vm.svgPanZoom.zoomOut();
                }

                function resetZoom() {
                    vm.svgPanZoom.resetZoom();
                    vm.svgPanZoom.center();
                }

                function fullOrReducedScreen() {
                    if (vm.isFullScreen) {
                        vm.exitFullscreen();
                    } else {
                        vm.openFullscreen();
                    }
                }

                function openFullscreen() {
                    vm.isFullScreen = true;
                    $rootScope.$broadcast("exitFullScreen",vm.isFullScreen);
                    if (vm.elemToZoomContainer.requestFullscreen) {
                        vm.elemToZoomContainer.requestFullscreen();
                    } else if (vm.elemToZoomContainer.mozRequestFullScreen) { /* Firefox */
                        vm.elemToZoomContainer.mozRequestFullScreen();
                    } else if (vm.elemToZoomContainer.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                        vm.elemToZoomContainer.webkitRequestFullscreen();
                    } else if (vm.elemToZoomContainer.msRequestFullscreen) { /* IE/Edge */
                        vm.elemToZoomContainer.msRequestFullscreen();
                    }
                }

                function exitFullscreen() {
                    vm.isFullScreen = false;
                    document.getElementById("WDTooltip").style.display = "none";
                    $rootScope.$broadcast("exitFullScreen",vm.isFullScreen);
                    if (document.fullscreen) {
                        document.exitFullscreen();
                    } else if(document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if(document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                }
                vm.elemToZoomContainer.addEventListener('click', function (event) {
                        if(event.target.id == "electrical-svg-container" || event.target.id == "electrical-svg"){
                            document.getElementById("WDTooltip").style.display = "none";
                            event.stopPropagation();
                        }
                });
                document.addEventListener("fullscreenchange", function(event) {
                        if(document && !document.fullscreenElement){
                            exitFullscreen();
                        }
                });

                $rootScope.$on('resetSvgZoom', function(){
                    vm.resetZoom();
                })
            }
        }
    }

})();

(function () {
    angular.module('phenix').directive('electricalSchemaPdf', function ($compile) {
        return {
            restrict: 'E',
            link(scope, element, attrs) {
                try {
                    const docAppl =
                        `<object data="${attrs.data}" width="987px" height="750px" type="application/pdf">` +
                        `<p>PDF cannot be displayed.</p>` +
                        `</object>`;
                    // i don't know why angular need to compile dom element before inject to the dom;
                    const content = $compile(docAppl)(scope);
                    
                    // Use Angular jqLite instead of jQuery for better compatibility
                    if (element && element.length) {
                        element.prepend(content);
                    }
                } catch (error) {
                    console.info('Error in electricalSchemaPdf directive:', error);
                }

                attrs.$observe('data', function (value) {
                    $("object").remove();
                    const newDocAppl =
                        `<object data="${value}" width="987px" height="750px" type="application/pdf">` +
                        `<p>PDF cannot be displayed.</p>` +
                        `</object>`;
                    const newContent = $compile(newDocAppl)(scope);
                    element.prepend(newContent);
                    return value;
                });
            }


        };
    })
})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .controller(
            "electricalSchemaLevel3SingleController",
            electricalSchemaLevel3SingleController
        );

    /** @ngInject */
    function electricalSchemaLevel3SingleController(
        $scope,
        $state,
        $timeout,
        RoutesConstants,
        CarSearchResultConstants,
        searchElectricalSchemaConstant,
        CacheService,
        DocumentsWsService,
        ScrollService,
        searchElectricalSchemaMetierService,
        blockUI,
        $mdDialog,
        CacheConstants,
        $rootScope,
        $http,
        toastr,
        $translate,
        $q,
        $filter,
        configConstantes,
        CarSearchMetierService,
        $window,$log, printPdfModalService, FileSaver,PDFViewService,MainMetierService,CloudFrontUrlHelper,SearchArboTextualMetierService
    ) {


        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        /***
        *      SVG
        */

        vm.svg = null;
        vm.saveState = prepareSaveState;

        /**
        *
        */
        vm.isFullScreen = false;
        vm.showHightlightAll = true;
        vm.nodes = [];
        vm.selectedComponent = {};
        vm.previousComponentId = '';
        vm.relatedElectricalSchemasArray = [];
        vm.relatedElectricalSchema = {};
        vm.phObject = {};
        vm.componentSvgObject = [];
        vm.isComponentSelected = false;
        vm.searchComponent = '';
        vm.flag = false;
        vm.selectedComponentId = '';
        vm.isThumbnailSelected = false;
        vm.selected = undefined;
        vm.currentElectricalSchema = {};
        vm.isLinkVisible = false;
        vm.WDList = null;
        vm.componentDetailsList = [];
        vm.isPopInActive = false;
        vm.selectedComponentColoredLabel = null;
        vm.isUserComingFromClip = false;
        vm.onlyOneDocReturnedByClip = false;
        vm.isNodeHighlight = false;

        vm.WDList = [];
        vm.WD_CAN_DOC = [];
        vm.otherDocumentsList = [];
        vm.isWDCan = false;
        vm.isWDFusible = false;
        vm.isWDOtherDocument = false;
        vm.canExist = false;
        vm.isPrintSVGButtonActivated = false;
        vm.idAndLabelComp = [];
        vm.idAndLabelSignal = [];
        vm.isSignalSelected = false;
        vm.selectedSignalId = '';
        vm.isDetailsAvailable = false;
        vm.isFromSearch = false;
        vm.connectorList = [];
        vm.WDConnectors = [];
        vm.count = 0;
        vm.result = [];
        vm.isComponentExists = false;
        vm.maxCount = 0;
        vm.prevSignalId = [];
        vm.prevCompId = [];
        vm.wdFromCompSelectedList = [];
        vm.displayTitleOnly = false;
        vm.displayComponent = false;
        vm.isRelatedElectricalSchemaWdNode = false;
        vm.ndDocumentsUrl = configConstantes.ndDocumentsUrl;
        vm.wdDocuments = "/wdDocuments/";
        vm.generalInfoFileName = 'General_Information';
        vm.isHarnessSelected = false;
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.isWDComponentNameList = JSON.parse(configConstantes.isWDComponentNameList);
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        var wdImageBig = false;
        var svgMaxSizeToPreview = 3 * 1024 * 1024;
       
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function hasFileExtension(url, extension) {
            if (!url || !extension) return false;
            var urlWithoutParams = url.split('?')[0];
            var fileExtension = urlWithoutParams.split('.').pop().toLowerCase();
            return fileExtension === extension.toLowerCase();
        }

        vm.displayListData = displayListData;
        vm.displayDataClip = displayDataClip;
        vm.displayThumbnailOnClick = displayThumbnailOnClick;
        vm.activateSelectedComponent = activateSelectedComponent;
        vm.displaySelectedSchema = displaySelectedSchema;
        vm.updateBreadcrumb = updateBreadcrumb;
        vm.colorElectricalSchemaComponents = colorElectricalSchemaComponents;
        vm.goToArbo = goToArbo;
        vm.openComponentDetails = openComponentDetails;
        vm.formatResidual = formatResidual;
        vm.sortByPinCodes = sortByPinCodes;
        vm.colorPartHarnessSchemaComponents = colorPartHarnessSchemaComponents;
        vm.handleComposantAutoCompleteClick = handleComposantAutoCompleteClick;
        vm.selectorInputAutoCompleteComponent = '#autoCompleteComposantSE input';
        vm.displayCanAndFusesDocuments = displayCanAndFusesDocuments;
        vm.setCanDocButtonState = setCanDocButtonState;
        vm.enableOtherDocumentsList = enableOtherDocumentsList;
        vm.displayResidualFromDocumentName = displayResidualFromDocumentName;
        vm.setOtherDocumentsWidthValue = setOtherDocumentsWidthValue;
        vm.checkDetails = checkDetails;
        vm.displayWDFullScreen = displayWDFullScreen;
        vm.openPdfInFullScreen = openPdfInFullScreen;
        vm.user = CacheService.getObject(CacheConstants.profil);
        vm.backToprevious=backToprevious;
        vm.downloadPdf = downloadPdf;
        vm.highlightAllLines = highlightAllLines;
        vm.showPreviousWDFromComp = showPreviousWDFromComp;
        vm.checkSignalId = checkSignalId;
        vm.checkBlackWhiteLine = checkBlackWhiteLine;
        vm.formatNodeLabel = formatNodeLabel;
        var pictoImage = {            
            "RENAULT":{src:convertImgToBase64("/assets/images/renaultgroup.png","RENAULT")},
            "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")}
        }
        vm.WDNamelist = [];
        vm.isBlackWhite = false;
        vm.isCPCPresent = false;
        vm.isCSCPresent = false;

        function formatNodeLabel(label, level) {
            if (!label) {
                return label;
            }

            var nodeOne = vm.nodes && vm.nodes[0];
            var nodeTwo = vm.nodes && vm.nodes[1];
            var nodeTwoData = nodeTwo && !_.isEmpty(nodeTwo.node) ? nodeTwo.node : nodeTwo;
            var isNetworkDiagnosisCanCommunication =
                nodeOne && String(nodeOne.nodeId) === '2011' &&
                nodeTwoData && String(nodeTwoData.nodeId) === '3090';

            var formattedLabel = $filter('toCamelCase')(label);

            if (isNetworkDiagnosisCanCommunication  && level === 3) {
                return formattedLabel.toUpperCase();
            }
            return formattedLabel.replace(/\b(can|lis)\b/gi, function (match) {
                return match.toUpperCase();
            });
        }

        this.$onInit = function () {
            //here we bind data from $state in order to load the breadcrum
            vm.nodes = $state.params.node;
            vm.WDList = $state.params.WDList;
            vm.fromHarness = $state.params.fromHarness;
            vm.wdFromCompSelectedList = [];
            vm.isSieDocumentsExists=CacheService.getSieDocumentsHistory();
            $rootScope.isPartHarnessSelected = false;
            if($state.params.isHarness){
                vm.isHarnessSelected = true;
            }
            if (vm.nodes && vm.nodes.length) {
                vm.labelNode1 = vm.nodes[0].label;
                vm.labelNode2 =  (!_.isEmpty(vm.nodes[1].node)) ? vm.nodes[1].node.label : vm.nodes[1].label ;
                vm.labelNode3 = vm.nodes[2].label;
            }

            vm.componentCode = $state.params.componentCode;
            if (!vm.componentCode && $state.params.chosenComponent) {
                vm.componentCode = $state.params.chosenComponent.code;
            }
            vm.componentLabel = $state.params.componentLabel;
            vm.selectedComponent.type = $state.params.componentType;
            if (!vm.componentLabel && $state.params.chosenComponent) {
                vm.componentLabel = $state.params.chosenComponent.label;
            }
            vm.chosenComponent = $state.params.chosenComponent;

            vm.isComponentSelected = true;
            vm.showComponentDropDownList = false;
            vm.showElectricalSVGFile = true;
            vm.isUserComingFromClip = $state.params.isUserComingFromClip;
            
            const fromStateParam = $state.params.isFromWDUrlLink === true || $state.params.isFromWDUrlLink === 'true';
            const fromCache = CacheService.getObject('isFromWDUrlLink') === true;
            vm.isFromWDUrlLink = fromStateParam || fromCache;
            
            vm.originallyFromWDUrlLink = vm.isFromWDUrlLink;
            if (fromCache) {
                CacheService.removeObject('isFromWDUrlLink');
            }

            vm.isMDInNewTab = localStorage.getItem('isMDInNewTab');
            localStorage.removeItem('isMDInNewTab');

            vm.WD_CAN_DOC = CacheService.getCAN_Document();
            vm.setCanDocButtonState();
            vm.enableOtherDocumentsList();
            vm.isSignalSelected = false;

            vm.displayTitleOnly = (vm.labelNode1 != null && vm.labelNode2 == null && vm.labelNode3 != null) ? true : false;
            vm.wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria) ? CacheService.getObject(CacheConstants.wdObjectCriteria).header : [];
            vm.isObjCritSelected = vm.wdObjectCriteria ? true : false;

            if ($state.params.WD) {
                vm.wiringDiagram = $state.params.WD;
                vm.showComponentLabel = false;
                vm.isUserComingFromClip = false;
                if (vm.chosenComponent) {
                    vm.selectedComponentColoredLabel = vm.chosenComponent;
                }
            } else if ($state.params.wiringDiagramData && $state.params.wiringDiagramData.length) {
                // When a component is selected and no node is selected
                vm.isComponentSelected = false;
                vm.isUserComingFromClip = false;
                vm.displayComponentButton = true;
                vm.showComponentLabel = true;
                vm.showElectricalSVGFile = false;
                vm.isDetailsAvailable = $state.params.isDetailsAvailable;
                vm.connectorList = $state.params.connectorList;
                vm.wiringDiagramData = $state.params.wiringDiagramData;
                vm.wiringDiagram = vm.wiringDiagramData;
                vm.wiringDiagram.location = vm.wiringDiagram[0].thumbNailLoc[0];
                if ($state.params.thumbnailData) {
                    vm.componentSvgObject = $state.params.thumbnailData;
                }
            } else if ($state.params.thumbnailData) {
                vm.isComponentSelected = false;
                vm.isUserComingFromClip = $state.params.isUserComingFromClip;
                vm.displayComponentButton = true;
                vm.showComponentLabel = true;
                vm.showElectricalSVGFile = false;
                vm.componentSvgObject = $state.params.thumbnailData;
                if ($state.params.thumbnailData.length === 1 && vm.isUserComingFromClip) {
                    vm.onlyOneDocReturnedByClip = true;
                }
                if (vm.onlyOneDocReturnedByClip) {
                    vm.showElectricalSVGFile = true;
                    vm.wiringDiagram.location = vm.componentSvgObject[0].location;
                }
            } else if ($state.params.CPCAndCSCElecSchemaWiringDiagram || $state.params.CPCAndCSCElecSchemaThumbnailData ||
                $state.params.onlySignalElecSchemaWiringDiagram) {

                // This boolean variable will be used when CLIP request returns only one document
                if ((!_.isEmpty($state.params.CPCAndCSCElecSchemaWiringDiagram) && $state.params.CPCAndCSCElecSchemaWiringDiagram.length === 1)
                    || (!_.isEmpty($state.params.CPCAndCSCElecSchemaThumbnailData) && $state.params.CPCAndCSCElecSchemaThumbnailData.length === 1)
                    || (!_.isEmpty($state.params.onlySignalElecSchemaWiringDiagram) && $state.params.onlySignalElecSchemaWiringDiagram.length === 1)) {
                    vm.onlyOneDocReturnedByClip = true;
                }

                var wiringDiagramClipData = $state.params.CPCAndCSCElecSchemaWiringDiagram || $state.params.CPCAndCSCElecSchemaThumbnailData ||
                    $state.params.onlySignalElecSchemaWiringDiagram;
                var thumbnailLocationClip = wiringDiagramClipData[0].thumbNailLoc;
                if (!thumbnailLocationClip) {
                    thumbnailLocationClip = wiringDiagramClipData[0].thumbnailLocation;
                }

                // Update the wiring diagram data
                var WD_PH = {};
                WD_PH.forEach(function (comp) {
                    if (comp.thumbnailLocation == thumbnailLocationClip) {
                        var cacheData = comp;
                        if (cacheData.components && cacheData.components.length) {
                            cacheData.components.map(function (item) {
                                var itemObject = {};
                                itemObject['id'] = item.id;
                                itemObject['label'] = item.label;
                                itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                                itemObject['type'] = item.type;
                                vm.idAndLabelComp.push(itemObject);
                            });
                            vm.idAndLabelComp.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                        }

                        if (cacheData.signals && cacheData.signals.length) {
                            cacheData.signals.map(function (item) {
                                cacheData.signals.map(function (item) {
                                    var itemObject = {};
                                    itemObject['id'] = item.id;
                                    itemObject['label'] = item.label;
                                    itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                                    itemObject['type'] = item.type;
                                    vm.idAndLabelSignal.push(itemObject);
                                });
                            });
                            vm.idAndLabelSignal.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                        }

                        cacheData.components = vm.idAndLabelComp;
                        cacheData.signals = vm.idAndLabelSignal;

                        CacheService.setObject(CacheConstants.currentElectricalSchemaInfo, cacheData);
                    }
                });

                vm.isUserComingFromClip = true;
                vm.isComponentSelected = false;
                vm.displayComponentButton = false;
                vm.showComponentLabel = true;
                vm.showElectricalSVGFile = false;
                vm.showComponentDropDownList = false;
                if ($state.params.CPCAndCSCElecSchemaWiringDiagram && $state.params.CPCAndCSCElecSchemaWiringDiagram.length) {
                    $state.params.CPCAndCSCElecSchemaWiringDiagram.forEach(function (obj) {
                        if (_.isEmpty(obj.residualInfo)) {
                            var itemObject = {};
                            itemObject['displayedThumbnail'] = obj.thumbnailLocation;
                            itemObject['residual'] = obj.residual;
                            itemObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(obj);
                            obj.residualInfo.push(itemObject);
                        }
                    })
                    vm.wiringDiagramData = $state.params.CPCAndCSCElecSchemaWiringDiagram;
                    vm.wiringDiagram = vm.wiringDiagramData;

                    if (vm.onlyOneDocReturnedByClip) {
                        vm.showElectricalSVGFile = true;
                        if (!vm.wiringDiagram[0].location) {
                            vm.wiringDiagramData[0].thumbnailLocation = vm.wiringDiagramData[0].loc;
                            vm.wiringDiagram.location = vm.wiringDiagramData[0].thumbnailLocation[0].toString();
                        } else if (vm.wiringDiagram[0].location) {
                            vm.wiringDiagram.location = vm.wiringDiagram[0].location;
                        }
                    }
                }

                if ($state.params.CPCAndCSCElecSchemaThumbnailData && $state.params.CPCAndCSCElecSchemaThumbnailData.length) {
                    vm.componentSvgObject = $state.params.CPCAndCSCElecSchemaThumbnailData;
                    vm.isUserComingFromClip = true;
                    $rootScope.isPartHarnessSelected = true;

                    if (vm.onlyOneDocReturnedByClip) {
                        vm.showElectricalSVGFile = true;
                        vm.wiringDiagram.location = vm.componentSvgObject[0].location;
                    }
                }

                if ($state.params.onlySignalElecSchemaWiringDiagram && $state.params.onlySignalElecSchemaWiringDiagram.length) {
                    $state.params.onlySignalElecSchemaWiringDiagram.forEach(function (obj) {
                        if (_.isEmpty(obj.residualInfo)) {
                            var itemObject = {};
                            itemObject['displayedThumbnail'] = obj.thumbnailLocation;
                            itemObject['residual'] = obj.residual;
                            itemObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(obj);
                            obj.residualInfo.push(itemObject);
                        }
                    })
                    vm.wiringDiagramData = $state.params.onlySignalElecSchemaWiringDiagram;
                    vm.wiringDiagram = vm.wiringDiagramData;

                    if (vm.onlyOneDocReturnedByClip) {
                        vm.showElectricalSVGFile = true;
                        if (!vm.wiringDiagram[0].location) {
                            vm.wiringDiagramData[0].thumbnailLocation = vm.wiringDiagramData[0].loc;
                            vm.wiringDiagram.location = vm.wiringDiagramData[0].thumbnailLocation[0].toString();
                        } else if (vm.wiringDiagram[0].location) {
                            vm.wiringDiagram.location = vm.wiringDiagram[0].location;
                        }
                    }
                }

            } else if ($state.params.isDetailMainComponentRequired && $state.params.isUserComingFromClip && !$state.params.idOptional) {
                vm.isComponentSelected = false;
                vm.displayComponentButton = false;
                vm.showComponentLabel = true;
                vm.showElectricalSVGFile = false;
                vm.showComponentDropDownList = false;
                vm.wiringDiagram = {};
                vm.wiringDiagramData = [];
                vm.onlyOneDocReturnedByClip = false;

                var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                    return item.id == $state.params.id;
                });

                if (getComponent[0] != null || getComponent[0] != undefined) {
                    vm.componentCode = getComponent[0].id;
                    vm.componentLabel = getComponent[0].label;
                    displayListData(getComponent[0]);
                }
                else {
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                    toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                    if (vm.isSieDocumentsExists) {
                        backToprevious();
                    }
                    else {
                        $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                    }
                }
            }

            else if ($state.params.isDetailMainComponentRequired && $state.params.isUserComingFromClip && $state.params.idOptional != null) {

                vm.result = [];
                vm.wiringDiagram = {};
                vm.displayComponentButton = false;
                vm.showComponentLabel = true;
                vm.showComponentDropDownList = false;
                vm.isComponentSelected = false;

                vm.wiringDiagramData = [];

                var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                    return item.id == $state.params.id;
                });

                if (getComponent[0] != null || getComponent[0] != undefined) {
                    vm.componentCode = getComponent[0].id;
                    vm.componentLabel = getComponent[0].label;
                    vm.isCPCPresent = true;
                }

                var getComponent1 = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                    return item.id == $state.params.idOptional;
                });

                if (getComponent1[0] != null || getComponent1[0] != undefined) {
                    vm.componentCode = getComponent1[0].id;
                    vm.componentLabel = getComponent1[0].label;
                    vm.isCSCPresent = true;
                }

                if (vm.isCPCPresent && vm.isCSCPresent) {
                    vm.componentCode = getComponent[0].id;
                    vm.componentLabel = getComponent[0].label;
                    vm.maxCount = 2;
                    var defer = $q.defer();
                    $q.all([
                        displayDataClip(getComponent[0]),
                        displayDataClip(getComponent1[0])
                    ]).then(function (response) {
                        defer.resolve(response);
                    });
                }
                else if (vm.isCPCPresent && !vm.isCSCPresent) {
                    vm.componentCode = getComponent[0].id;
                    vm.componentLabel = getComponent[0].label;
                    vm.maxCount = 1;
                    displayDataClip(getComponent[0]);
                }
                else if (!vm.isCPCPresent && vm.isCSCPresent) {
                    vm.componentCode = getComponent1[0].id;
                    vm.componentLabel = getComponent1[0].label;
                    vm.maxCount = 1;
                    displayDataClip(getComponent1[0]);
                }
                else {
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                    toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                    if (vm.isSieDocumentsExists) {
                        backToprevious();
                    }
                    else {
                        $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                    }
                }
            }

            if (vm.wiringDiagram && vm.wiringDiagram.components) {
                vm.idAndLabelComp = [];
                vm.wiringDiagram.components.map(function (item) {
                    var itemObject = {};
                    itemObject['id'] = item.id;
                    itemObject['label'] = item.label;
                    itemObject['subType'] = item.subType;
                    itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                    itemObject['type'] = item.type;
                    vm.idAndLabelComp.push(itemObject);
                });
                vm.idAndLabelComp.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                vm.wiringDiagram.components = vm.idAndLabelComp;
            }

            if (vm.wiringDiagram && vm.wiringDiagram.signals) {
                vm.idAndLabelSignal = [];
                vm.wiringDiagram.signals.map(function (item) {
                    var itemObject = {};
                    itemObject['id'] = item.id;
                    itemObject['label'] = item.label;
                    itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                    itemObject['type'] = item.type;
                    vm.idAndLabelSignal.push(itemObject);
                });
                vm.idAndLabelSignal.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                vm.wiringDiagram.signals = vm.idAndLabelSignal;
            }

            if (!vm.isUserComingFromClip) {
                CacheService.setObject(CacheConstants.currentElectricalSchemaInfo, vm.wiringDiagram);
            }


            if (vm.wiringDiagram && vm.wiringDiagram.location) {
                vm.wiringDiagram.isPDF = hasFileExtension(vm.wiringDiagram.location, 'pdf');
                vm.wiringDiagram.isPNG = hasFileExtension(vm.wiringDiagram.location, 'png');
                vm.isPrintSVGButtonActivated = hasFileExtension(vm.wiringDiagram.location, 'svg');
            }

            blockUI.start();
            vm.isWDBigSize = false;
            if (vm.wiringDiagram && !vm.wiringDiagram.isPDF && !vm.wiringDiagram.isPNG && vm.wiringDiagram.location) {
                DocumentsWsService.getWDSVG(vm.wiringDiagram.location).then(function (svg) {
                    vm.svg = svg.data;
                    // Check if svg.size is defined and above 3MB (3 * 1024 * 1024 bytes)
                    if (svg.size && svg.size > svgMaxSizeToPreview) {
                        vm.isWDBigSize = true;
                    }
                }).then(function () {
                    $timeout(function () {
                        ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                        if (vm.isUserComingFromClip && vm.onlyOneDocReturnedByClip && $state.params.id) {
                            $rootScope.loadSchemaDiagrams($state.params.id);
                            $rootScope.loadAndColorPartHarnessSchema($state.params.id);
                        } else if (vm.isUserComingFromClip && vm.onlyOneDocReturnedByClip && $state.params.idOptional && !$state.params.id) {
                            $rootScope.loadSchemaDiagrams($state.params.idOptional);
                            $rootScope.loadAndColorPartHarnessSchema($state.params.idOptional);
                        }
                    }, 0);
                }).finally(function () {
                    if (vm.chosenComponent && vm.chosenComponent != null && $state.params.WD) {
                        if (vm.chosenComponent && vm.chosenComponent.id && vm.chosenComponent.label) {
                            vm.chosenComponent.idAndLabel = vm.chosenComponent.idAndLabel ? vm.chosenComponent.idAndLabel : vm.chosenComponent.id + ' - ' + vm.chosenComponent.label;
                        }
                        displayListData(vm.chosenComponent);
                        vm.selectedComponentColoredLabel = vm.chosenComponent;
                    }

                    blockUI.stop();
                });
            } else {
                $timeout(function () {
                    blockUI.stop();
                    ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                }, 0);
            }

            if (vm.wiringDiagram && vm.wiringDiagram.location) {
                vm.currentElectricalSchema = vm.wiringDiagram.location;
            }

            //If there's already a chosen component, so we have to add it to the last selected component variable
            if (vm.chosenComponent) {
                vm.lastComponent = vm.chosenComponent.code + ' - ' + vm.chosenComponent.label;
            }
            if (!vm.chosenComponent && $state.params.thumbnailData){
                vm.goToArbo();
            }

            //Display print button only if the document is an SVG
            if (vm.wiringDiagram && vm.wiringDiagram.location && vm.wiringDiagram.location.toUpperCase().endsWith('SVG')) {
                vm.isPrintSVGButtonActivated = true;
            }
            $scope.isOpen = false;
            if (vm.fromHarness) {
                $rootScope.loadSchemaDiagrams($state.params.selectedComponent.id);
            } else if ($state.params.isComponentSelected) {
                vm.displayComponent = true;
                vm.isRelatedElectricalSchemaWdNode = true;
            } else {
                vm.displayComponent = true;
            }
        };

        // show yellow border of div WD if PDF
        var readyStateCheckInterval = setInterval(function () {
            if (document.readyState === "complete") {
                clearInterval(readyStateCheckInterval);
                if (vm.wiringDiagram != null || vm.wiringDiagram != undefined) {
                    if (vm.wiringDiagram.isPDF) {
                        document.getElementById("WDContainer").classList.add("borderThumb");
                    }
                }
            }
        }, 100);

        function displayWDFullScreen() {
            window.open(vm.wiringDiagram.location);
        }
        $rootScope.$on("exitFullScreen", function(event,data){
            vm.isFullScreen = data;
        })

        function openPdfInFullScreen(){
            window.open(vm.wiringDiagram.location);
        }
        /**
        * @description use jQuery attribute functions to set custom width to md-menu-content
        */

        function setOtherDocumentsWidthValue() {
            SearchArboTextualMetierService.setConnectedServicesAuditData('WD_Other_Document').then(function () {});
            $("#otherDocumentsMenu").removeAttr("width");
            $("#otherDocumentsMenu").css("padding-bottom", "0px");
            $('#otherDocumentsMenu').find('*').css("font-size", "10px");
            $('#otherDocumentsMenu').find('md-menu-item').children().css("margin-left", "0px");
            $('#otherDocumentsMenu').find('md-menu-item').children().css("margin-right", "0px");
            $('#otherDocumentsMenu').find('md-menu-item').children().css("padding-left", "8px");
            $('#otherDocumentsMenu').find('md-menu-item').children().css("padding-right", "8px");
        }

        function prepareSaveState() {
            vm.isSignalSelected = false;

            var params = $state.params;
            if (!params.node) {
                return params;
            }
            else {
                params.WD = vm.wiringDiagram; //The currently selected wiring diagram.
                params.WDList = null;
                params.node = vm.nodes;
                if (vm.selectedComponentColoredLabel && vm.selectedComponentColoredLabel != null) {

                    var outItem;
                    // Set the Label in the drop down for the corresponding component selected on the document
                    var list1 = CacheService.getObject(CacheConstants.currentElectricalSchemaInfo);
                    if (!list1.components) {
                        list1 = list1[0];
                    }
                    if (list1.components && list1.components.length) {
                        list1.components.forEach(function (item) {
                            if (item.id == vm.selectedComponent.id) {
                                outItem = item;
                            }
                        });
                    }

                    var component = outItem || vm.selectedComponentColoredLabel;
                    params.componentCode = component.id;
                    params.componentLabel = component.label;
                    params.chosenComponent = component;
                    params.isComponentSelected = true;
                }
                else {
                    params.componentCode = null;
                    params.componentLabel = null;
                    params.chosenComponent = null;
                    params.isComponentSelected = false;
                }

                return params;
            }
        }


        /**
        * @description set the stage of the button CAN, DOCUMENT and Other Document
        */

        function setCanDocButtonState() {
            var WD_CAN_DOC = CacheService.getCAN_Document();
            vm.isWDOtherDocument = true;

            if (WD_CAN_DOC && WD_CAN_DOC.can && WD_CAN_DOC.can.length > 0) {
                vm.isWDCan = true;
            }

            if (WD_CAN_DOC && WD_CAN_DOC.fusible && WD_CAN_DOC.fusible.length > 0) {
                vm.isWDFusible = true;
            }   
            
        }


        /**
        * @desc set the state of otherDocumentList *dropdown
        */

        function enableOtherDocumentsList() {
            var WD_CAN_DOC = CacheService.getCAN_Document();
            vm.otherDocumentsList = [];
            if (WD_CAN_DOC && WD_CAN_DOC.otherDocs && WD_CAN_DOC.otherDocs.length > 0) {
                for (var i = 0; i < WD_CAN_DOC.otherDocs.length; i++) {
                    if (WD_CAN_DOC.otherDocs[i].name && WD_CAN_DOC.otherDocs[i].name.length > 0) {
                        vm.otherDocumentsList.push(WD_CAN_DOC.otherDocs[i].name);
                    }
                }
            }

            vm.otherDocumentsList = _.uniq(vm.otherDocumentsList);
            vm.otherDocumentsList.push('GENERAL_INFORMATION');
        }


        /**
        * @description get Other Documents from Cache, filter them by name, and return corresponding names in array
        */
        function displayResidualFromDocumentName(documentName) {

            var WD_CAN_DOC = CacheService.getCAN_Document();
            var tmpArray = [];

            vm.otherDocumentsList.forEach(function (item) {
                var nameItem = item;
                if (item === documentName) {
                    WD_CAN_DOC.otherDocs.forEach(function (obj) {
                        if (nameItem === obj.name) {
                            searchElectricalSchemaMetierService.formatResidualDoc_Can(obj);
                            tmpArray.push(obj);
                        }
                    })
                }
            });
            if (tmpArray.length == 0){
                var langList = [ 'cs', 'de', 'en', 'es', 'fa','fi','fr', 'he', 'hr', 'hu', 'it', 'ja', 'ko', 'le', 'nl', 'pl', 'pt', 'ro', 'ru', 'sl', 'sv', 'tr'];
                var url = '';
                if (langList.includes(vm.user.documentationFirstLanguage.code)){
                    url = vm.ndDocumentsUrl + vm.wdDocuments + vm.generalInfoFileName + '_' + vm.user.documentationFirstLanguage.code + '.pdf';
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(url);
                    window.open(signedUrl,'_blank');
                }
                else{
                    url = vm.ndDocumentsUrl + vm.wdDocuments + vm.generalInfoFileName + '_en.pdf';
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(url);
                    window.open(signedUrl,'_blank');
                }
                
            }
            else {

                var numberOfResidualLines = 0;

                tmpArray.forEach(function (item) {
                    if (item.residual && item.residual.length > 0) {
                        numberOfResidualLines++;
                    }
                });

                if (numberOfResidualLines === 1 || tmpArray.length === 1) {
                    window.open(tmpArray[0].location);
                } else {

                    // IE hack, as this browser puts PDF directive above current mdDialog

                    var pdfDirective = angular.element(document.getElementsByTagName('electrical-schema-pdf'));
                    pdfDirective.addClass("doNotDisplayPdfFile");
                    vm.isPopInActive = true;

                    $mdDialog.show({
                        templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemaCanFusibleDocResidualList.template.html',
                        controller: 'electricalSchemaCanFusibleDocResidualListController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: false,
                        locals: {
                            documentToDisplay: tmpArray,
                            isPopInActive: vm.isPopInActive
                        }
                    }).catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
                }
            }
        }


        /**
        * @description Call function to display Can, Fuses and other Documents from cache.
        * If one document is returned, it is directly opened in a new tab.
        * If several documents are returned, their applicability are displayed in a pop-in
        */

        function displayCanAndFusesDocuments(WDList, typeOfDoc) {
            const logType = typeOfDoc === 'CAN' ? 'WD_CAN_Network' : 'WD_Fuse_Relay';
            SearchArboTextualMetierService.setConnectedServicesAuditData(logType).then(function () {});
            searchElectricalSchemaMetierService.displayCanAndFusesDocuments(vm.WD_CAN_DOC, typeOfDoc);
        }

        // Used to first remove the color from the previously selected link (if any) and then color the current selected link in 'red'
        $rootScope.loadSignalRelatedElectricalSchema = function (selectedSignalId, isNotSignalId) {
            vm.selectedComponentColoredLabel = '';
            vm.isSignalSelected = true;
            var getlist = CacheService.getComponentsAndSignals();
            var getSignal = _.filter(vm.wiringDiagram.lines, function (item) {
                return item.id == selectedSignalId;
            });

            var getLineList = _.filter(getlist, function (list) {
                if(!_.isEmpty(getSignal) && !_.isEmpty(getSignal[0]) && getSignal[0].signal){
                    return list.id == getSignal[0].signal;
                }
            });

            if(!_.isEmpty(getLineList) && !_.isEmpty(getLineList[0]) && getLineList[0].label && vm.isFullScreen){
                var WDFullscreenPops = document.getElementById("WDTooltip");
                var isHighLabel = _.find(searchElectricalSchemaConstant.canHigh  ,function(high){
                    return getLineList[0].label.toUpperCase().includes(high);
                });

                if(!_.isEmpty(isHighLabel) && _.isEmpty(isLowLabel)){
                    WDFullscreenPops.innerHTML = searchElectricalSchemaConstant.canHigh[1];
                    WDFullscreenPops.style.display = "block";
                }

                var isLowLabel = _.find(searchElectricalSchemaConstant.canLow  ,function(low){
                    return getLineList[0].label.toUpperCase().includes(low);
                });

                if(!_.isEmpty(isLowLabel) && _.isEmpty(isHighLabel)){
                    WDFullscreenPops.innerHTML = searchElectricalSchemaConstant.canLow[1];
                    WDFullscreenPops.style.display = "block";
                }

                else if(_.isEmpty(isHighLabel) && _.isEmpty(isLowLabel)){
                    WDFullscreenPops.innerHTML = "";
                    WDFullscreenPops.style.display = "none";
                }
            }
            if (vm.relatedElectricalSchema && vm.relatedElectricalSchema.nodes && vm.relatedElectricalSchema.nodes.wdNode) {
                vm.relatedElectricalSchema.nodes.wdNode = [];
            }
            vm.displayComponentButton = false;
            
            signalHighlight(selectedSignalId, isNotSignalId);

            
        }

        function applySignalColors(signalId){
            var lines = CacheService.getObject(CacheConstants.currentElectricalSchemaInfo);
            var strokeColor = "#FFA500";
            var colorcode = _.find(lines.lines,function(x){
                if (x.id == signalId){
                    return x;
                }
            });
            switch(colorcode.colour){
                case "BA":
                case "WH":
                case "CY":
                    strokeColor = "#dadada";
                    break;
                case "BE":
                case "BL":
                    strokeColor = "#0000FF";
                    break;
                case "BJ":
                    strokeColor = "#F4A460";
                    break;
                case "GR":
                case "LG":
                    strokeColor = "#696969";
                    break;
                case "JA":
                case "YL":
                    strokeColor = "#FFFF00";
                    break;
                case "MA":
                case "BR":
                    strokeColor = "#8B4513";
                    break;
                case "NO":
                case "BK":
                    strokeColor = "#000000";
                    break;
                case "OR":
                    strokeColor = "#FF8C00";
                    break;
                case "RG":
                case "RD":
                    strokeColor = "#FF0000";
                    break;
                case "SA":
                    strokeColor = "#FA8072";
                    break;
                case "GN":
                case "VE":
                    strokeColor = "#008000";
                    break;
                case "VI":
                case "PU":
                    strokeColor = "#EE82EE";
                    break;
                default:
                    strokeColor = "#FFCC33";
                    break;
            }
            return {
                strokeColor : strokeColor,
            }
        }

        /**
        * @description Used to get all the polyLine tags with the same id to color them in red
        * @param {*} svg
        * @param {*} selectedSignalId
        */
        function getPolyLineTagsList(svg, selectedSignalId) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(svg, "text/html");
            var polyLineTags = xmlDoc.getElementsByTagName("polyline");
            var svg_polyLineLinks = [];
            for (var i = 0; i < polyLineTags.length; i++) {
                var element = angular.element(polyLineTags[i]);
                var polyParent = $(element).parent();
                var polyParentId = polyParent[0].id;
                if (polyParentId) {
                    $(element).attr("id", polyParentId);
                }
            }

            var polyLineElementsWithId = document.getElementsByTagName("polyline");
            for (var x = 0; x < polyLineElementsWithId.length; x++) {
                var elementWithId = angular.element(polyLineElementsWithId[x]);
                var polyParentWithId = $(elementWithId).parent();
                var polyParentElementId = polyParentWithId[0].id;
                if (polyParentElementId && (polyParentElementId === selectedSignalId)) {
                    $(elementWithId).attr("id", polyParentElementId);
                    var elem = angular.element(elementWithId);
                    svg_polyLineLinks.push(elem);
                }
            }

            return svg_polyLineLinks;
        }

        // Used to clean (white color) to the previously selected components on the Electrical Schema document
        $rootScope.loadSchemaDiagrams = function (selectedComponentId) {
            var getlist = CacheService.getComponentsAndSignals();
            var getComponent = _.filter(getlist, function (item) {
                return item.id == selectedComponentId;
            });
            if(getComponent[0].label && vm.isFullScreen){
                var WDFullscreenPops = document.getElementById("WDTooltip");
                WDFullscreenPops.innerHTML = getComponent[0].label;
                WDFullscreenPops.style.display = "block";
            }
            vm.isHarnessSelected = false;
            if(!vm.isHarnessSelected){
                vm.isComponentSelected = false;
                vm.showComponentLabel = true;
                vm.showComponentDropDownList = true;
            }

            if (getComponent[0].type == "WD_COMPONENT") {
                vm.isSignalSelected = false;
                vm.displayComponentButton = true;
                clearPreviousEletricalSchemaTags();
                clearPreviousPartHarnessTags();
            }
            else if (getComponent[0].type == "WD_SIGNAL") {
                $rootScope.loadSignalRelatedElectricalSchema(selectedComponentId, true);        
            }
            try {
                if (_.isEmpty(vm.selectedComponentId)) {
                    vm.selectedComponent.id = selectedComponentId;
                    vm.selectedComponent.label = getComponent[0].label;
                }

                vm.selectedComponent.id = selectedComponentId;
                vm.onlyOneDocReturnedByClip = false;

                var comp = vm.selectedComponent;
                comp.id = vm.selectedComponent.id;
                comp.label = vm.selectedComponent.label;
                comp.idAndLabel = vm.selectedComponent.id + ' - ' + vm.selectedComponent.label;
                vm.selectedComponentColoredLabel = comp.idAndLabel;
                comp.type = getComponent[0].type;
                displayListData(comp);

            } catch (error) {

            }
        };

        function getNodeandWdList() {
            if (vm.nodes != null && !_.isEmpty(vm.nodes)) {
                vm.labelNode1 = vm.nodes.function ? vm.nodes.function.label : null;
                vm.labelNode2 = vm.nodes.subFunction ? vm.nodes.subFunction.label : null;
                vm.labelNode3 = vm.nodes.title ? vm.nodes.title.label : null;
                vm.code1 = vm.nodes[0].nodeId;
                vm.code2 = (!_.isEmpty(vm.nodes[1].node)) ? vm.nodes[1].node.nodeId : vm.nodes[1].nodeId;
                vm.code3 = vm.nodes[2].nodeId;
                vm.wdId = [];
                vm.selectedNode = [];
                var wdNode = vm.wiringDiagramData && vm.wiringDiagramData.length != 0 ? vm.wiringDiagramData : (vm.relatedElectricalSchema && vm.relatedElectricalSchema.nodes && vm.relatedElectricalSchema.nodes.wdNode && vm.relatedElectricalSchema.nodes.wdNode.length != 0) ? vm.relatedElectricalSchema.nodes.wdNode : null;
                if (!_.isEmpty(wdNode)) {
                    wdNode.forEach(function (wdNode) {
                        if (wdNode.subNode && wdNode.subNode.function && wdNode.subNode.function.code && wdNode.subNode.subFunction && wdNode.subNode.subFunction.code && wdNode.subNode.title && wdNode.subNode.title.code) {
                            if (wdNode.subNode.function.code === vm.code1 && wdNode.subNode.subFunction.code === vm.code2 && wdNode.subNode.title.code === vm.code3) {
                                if (!_.isEmpty(wdNode.residualInfo)) {
                                    wdNode.residualInfo.forEach(function (wd) {
                                        if (wd.id) {
                                            vm.wdId.push(wd.id);
                                        }
                                    })
                                }
                            }
                        }
                    })

                    if (vm.wdId && !_.isEmpty(vm.wdId)) {
                        vm.selectedNode = vm.nodes;
                    } else {
                        if (wdNode[0].residualInfo && wdNode[0].residualInfo.length != 0) {
                            wdNode[0].residualInfo.forEach(function (wd) {
                                vm.wdId.push(wd.id);
                            })
                            var subNode = wdNode[0].subNode ? wdNode[0].subNode : null;
                            if (subNode && subNode.function && subNode.subFunction && subNode.title) {
                                vm.selectedNode.push(subNode.function);
                                vm.selectedNode.push(subNode.subFunction);
                                vm.selectedNode.push(subNode.title);
                            }
                        }
                    }
                    if (vm.selectedNode && !_.isEmpty(vm.selectedNode)) {
                        vm.labelNode1 = vm.selectedNode[0].label;
                        vm.labelNode2 = (!_.isEmpty(vm.selectedNode[1].node)) ? vm.selectedNode[1].node.label : vm.selectedNode[1].label;
                        vm.labelNode3 = vm.selectedNode[2].label;
                    }        
                }
                vm.isRelatedElectricalSchemaWdNode = false;
            }else {
                vm.isRelatedElectricalSchemaWdNode = true;
             }
        }

        function clearPreviousPartHarnessTags() {
            if (vm.previousPartHarnessTags && vm.previousPartHarnessTags.length) {
                for (var j = 0; j < vm.previousPartHarnessTags.length; j++) {
                    $(vm.previousPartHarnessTags[j]).attr("fill", "white");
                    $(vm.previousPartHarnessTags[j]).removeAttr("id");
                }
            }

            if (vm.previousSignalTags && vm.previousSignalTags.length) {
                for (var j = 0; j < vm.previousSignalTags.length; j++) {
                    $(vm.previousSignalTags[j]).attr("stroke", "#000000");
                    $(vm.previousSignalTags[j]).removeAttr("id");
                    $(vm.previousSignalTags[j]).attr("stroke-width", "1.0");
                }
            }
        }

        /**
        * @description Used to clean the previous selected components (if any)
        *              and color the selected components (yellow) on Part Harness selected schema
        *              and update the thumbnails, displayed code and label and list of components
        */
        $rootScope.loadAndColorPartHarnessSchema = function (selectedComponentId) {
            vm.isSignalSelected = false;
            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                return item.id == selectedComponentId;
            });

            clearPreviousPartHarnessTags();
            if (getComponent[0] != null){
                var svg_partHarnessElement = getPartHarnessComponentsToColor(vm.svg);
            vm.previousPartHarnessTags = svg_partHarnessElement;
            if (svg_partHarnessElement && svg_partHarnessElement.length) {
                for (var x = 0; x < svg_partHarnessElement.length; x++) {
                    $(svg_partHarnessElement[x]).attr("fill", "#FFCC33");
                    $(svg_partHarnessElement[x]).removeAttr("id");
                    vm.displayComponentButton = true;
                    vm.isComponentSelected = true;
                    vm.onlyOneDocReturnedByClip = false;
                }
            }

            vm.selectedComponent.id = selectedComponentId;


            var comp = vm.selectedComponent;
            comp.id = getComponent[0].id;
            comp.label = getComponent[0].label;
            comp.idAndLabel = comp.id + ' - ' + comp.label;
            vm.selectedComponentColoredLabel = comp.idAndLabel;
            comp.type = getComponent[0].type;
            displayListData(comp);
            }
            else{
                toastr.error($translate.instant("ELECTRICAL_SCHEMAS_NO_COMPONENT_DETAILS"));
            }
            
        };

        function handleBlurComposantAutoComplete(event) {

            $timeout(function () {
                //if click event has releated target, it means we don't have to handle it.
                if (event.relatedTarget == null || $(event.relatedTarget).is("div")) {
                    vm.selectedComponentColoredLabel = vm.lastComponent.idAndLabel || vm.lastComponent;
                }
            }, 0);
        }

        var stopHandleSelectedChangeEvent;
        function handleComposantAutoCompleteClick(event) {

            var eventSource = event.target || event.srcElement;

            //If the event came from the autocomplet input, so we mark it as not handle, so that the selectedChanged of the autocomple is not going to erase the schema data.
            if ($(eventSource).is("input") && $(vm.selectorInputAutoCompleteComponent).val() != "" && vm.selectedComponentColoredLabel != '') {
                stopHandleSelectedChangeEvent = true;
            }
            else {
                stopHandleSelectedChangeEvent = false;
            }

            return stopHandleSelectedChangeEvent;
        }

        function handleAutoCompleteInputKeyDown() {
            if (vm.lastComponent && vm.lastComponent != '' && vm.lastComponent != null && $(vm.selectorInputAutoCompleteComponent).val() != (vm.lastComponent.idAndLabel || vm.lastComponent)) {

                //if the component text has changed on keydown, I handle the clearing of the SVG selected tags and the component selection itself.
                //The timeout function is called here to handle the scope apply implicitly.
                $timeout(function () {

                    vm.lastComponent = "";
                    vm.selectedComponentColoredLabel = null; //Assignig null to this variable prevents the

                    clearPreviousPartHarnessTags();
                    clearPreviousEletricalSchemaTags();
                }, 0);
            }
        }

        function attachAutoCompleteEvents() {
            $(vm.selectorInputAutoCompleteComponent).on("blur", handleBlurComposantAutoComplete);
            $(vm.selectorInputAutoCompleteComponent).on("keyup", handleAutoCompleteInputKeyDown);
        }

        function detachAutoCompleteEvents() {
            $(vm.selectorInputAutoCompleteComponent).off("blur", handleBlurComposantAutoComplete);
            $(vm.selectorInputAutoCompleteComponent).off("keyup", handleAutoCompleteInputKeyDown);
        }

        /**
        * @description Used to convert incoming array into an object
        * @param {*} res
        */
        function convertArrayWDResponseToObject(res) {
            var result = {
                WIRING_DIAGRAMS: []
            }

            if (res && res.length) {
                res.forEach(function (item) {
                    result.WIRING_DIAGRAMS.push.apply(result.WIRING_DIAGRAMS, item.WIRING_DIAGRAMS);
                });
            }
            return result;
        }

        /**
        * @name displayListData
        * @desc displays thumbnails related to selected component
        * @param {object} component
        * @returns {Array}
        */
        function displayListData(component,fromDropDown) {

            var first_call = [];
            var sec_res = [];
            var final_res = [];
            var WD_PH = [];
            var WD_GH = [];
            var WD_Conn = [];
            var WD_Wiring = [];
            var subType = ["WIRING"];
            var isCalled = false;

            try {
                detachAutoCompleteEvents();
                if ((component.label == '' || component == '') && stopHandleSelectedChangeEvent) {

                    //Write the latest value to the autocomplete (It's not anymore under the control the mdautocomplete)
                    $(vm.selectorInputAutoCompleteComponent).val(vm.lastComponent);

                    //Attach the onblur and keyup events so that we will populate the input text again when the input loses focus.
                    attachAutoCompleteEvents();

                    return;
                }
                else {

                    if ((component.label || component) != "" && vm.selectedComponentColoredLabel) {
                        vm.lastComponent = component.idAndLabel || component;
                        vm.displayComponentButton = true;
                        if (component.label != undefined) {
                            vm.selectedComponent = $.extend({}, component);
                        }
                        else {
                            isCalled = true;
                            component = $.extend({}, vm.selectedComponent);
                        }
                    }
                    else {
                        vm.lastComponent = "";
                        vm.wiringDiagramData = [];
                        vm.WDNamelist = [];
                        vm.componentSvgObject = [];
                        vm.displayComponentButton = false;
                        vm.isDetailsAvailable = false;
                    }

                    if (!vm.isSignalSelected) {
                        //Clear the previous partness tags so that it will not be marked down when selecting a new one.
                        clearPreviousPartHarnessTags();
                        if (!vm.selectedComponentColoredLabel) {
                        clearPreviousEletricalSchemaTags();
                        }
                    }
                }
            }
            finally {
                stopHandleSelectedChangeEvent = false;
            }

            if (!vm.isSignalSelected) {
                vm.displayComponentButton = true;
            }
            if (vm.selectedComponentColoredLabel == null) {
                vm.displayComponentButton = false;
            }
            vm.changesDetected = true;
            if (!$state.params.isUserComingFromClip) {
                vm.isUserComingFromClip = false;
            }

            if (!isCalled && component.id != null) {
                vm.componentCode = component.id;
                vm.componentLabel = component.label;

                if (component.type == undefined || component.type == null) {
                    var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                        return item.id == component.id;
                    })
                    component.type = getComponent[0].type;
                }

                blockUI.start();
                const promise = searchElectricalSchemaMetierService.getByIdLiteWithFullContext(
                    component.id,
                    component.type,
                    vm.isObjCritSelected,
                    vm.wdObjectCriteria
                );

                if (!promise || typeof promise.then !== 'function') {
                    blockUI.stop();
                    return;
                }

                return promise.then(function (res) {
                    res = convertArrayWDResponseToObject(res);

                    WD_PH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                        return item.subType == "PART_HARNESS";
                    });

                    WD_GH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                        return item.subType == "GROUND_HARNESS";
                    });

                    WD_Conn = _.filter(res.WIRING_DIAGRAMS, function (item) {
                        return item.subType == "CONNECTOR";
                    });

                    WD_Wiring = _.filter(res.WIRING_DIAGRAMS, function (item) {
                        return item.subType == "WIRING";
                    });

                    WD_PH.length == 0 ? subType.push("PART_HARNESS") : first_call.push(WD_PH);
                    WD_GH.length == 0 ? subType.push("GROUND_HARNESS") : first_call.push(WD_GH);
                    WD_Conn.length == 0 ? subType.push("CONNECTOR") : first_call.push(WD_Conn);

                    vm.connectorList = WD_Conn;

                }).then(function () {
                    if (WD_PH.length == 0 || WD_GH.length == 0 || WD_Conn.length == 0) {
                        return searchElectricalSchemaMetierService.getByIdLite(component.id, component.type, subType, vm.isObjCritSelected,vm.wdObjectCriteria).then(function (res) {
                            res = convertArrayWDResponseToObject(res);
                            sec_res = res.WIRING_DIAGRAMS;

                            var sec_wiring = _.filter(sec_res, function (item) {
                                return item.subType == "WIRING";
                            });

                            var final_wd = _.filter(sec_res, function (item) {
                                return item.subType == "WIRING";
                            });

                            var subtype = _.filter(sec_res, function (item) {
                                return item.subType != "WIRING";
                            });
                            if (subtype.length > 0) {
                                final_res = subtype;
                                first_call.push(subtype);
                            }



                            for (var i = 0; i < WD_Wiring.length; i++) {
                                for (var j = 0; j < sec_wiring.length; j++) {
                                    if ((WD_Wiring[i].nodes.WD_TREE[0]['code'] == sec_wiring[j].nodes.WD_TREE[0]['code']) &&
                                        (WD_Wiring[i].nodes.WD_TREE[1]['code'] == sec_wiring[j].nodes.WD_TREE[1]['code']) &&
                                        (WD_Wiring[i].nodes.WD_TREE[2]['code'] == sec_wiring[j].nodes.WD_TREE[2]['code'])) {
                                        var getindex = _.findIndex(final_wd, sec_wiring[j]);
                                        if (getindex > -1) {
                                            final_wd.splice(getindex, 1);
                                        }
                                    }

                                }

                            }

                            for (var k = 0; k < WD_Wiring.length; k++) {
                                final_wd.push(WD_Wiring[k]);
                            }

                            if (WD_PH.length == 0) {
                                WD_PH = _.filter(final_res, function (item) {
                                    return item.subType == "PART_HARNESS";
                                });
                            }

                            if (WD_Conn.length == 0) {
                                WD_Conn = _.filter(final_res, function (item) {
                                    return item.subType == "CONNECTOR";
                                });
                                vm.connectorList = WD_Conn;
                            }

                            if (vm.connectorList.length > 0) {
                                vm.isDetailsAvailable = true;
                            }
                            else {
                                vm.isDetailsAvailable = false;
                            }

                            displayPartHarnessAndWiringDiagram(WD_PH, final_wd, component.type, component.id, component.label,fromDropDown);

                        });

                    }
                    else {
                        displayPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, component.type, component.id, component.label,fromDropDown);
                    }

                }).finally(function () {
                    blockUI.stop();
                });
            }

        }

        function displayDataClip(ids) {
            var first_call = [];
            var sec_res = [];
            var final_res = [];
            var WD_PH = [];
            var WD_GH = [];
            var WD_Conn = [];
            var WD_Wiring = [];
            var subType = ["WIRING"];

            searchElectricalSchemaMetierService.getByIdLiteWithFullContext(ids.id, ids.type).then(function (res) {
                res = convertArrayWDResponseToObject(res);

                WD_PH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "PART_HARNESS";
                });

                WD_GH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "GROUND_HARNESS";
                });

                WD_Conn = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "CONNECTOR";
                });

                WD_Wiring = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "WIRING";
                });

                WD_PH.length == 0 ? subType.push("PART_HARNESS") : first_call.push(WD_PH);
                WD_GH.length == 0 ? subType.push("GROUND_HARNESS") : first_call.push(WD_GH);
                WD_Conn.length == 0 ? subType.push("CONNECTOR") : first_call.push(WD_Conn);

                vm.WDConnectors.push(WD_Conn);

            }).then(function () {
                if (WD_PH.length == 0 || WD_GH.length == 0 || WD_Conn.length == 0) {
                    searchElectricalSchemaMetierService.getByIdLite(ids.id, ids.type, subType).then(function (res) {
                        res = convertArrayWDResponseToObject(res);
                        sec_res = res.WIRING_DIAGRAMS;

                        var sec_wiring = _.filter(sec_res, function (item) {
                            return item.subType == "WIRING";
                        });

                        var final_wd = _.filter(sec_res, function (item) {
                            return item.subType == "WIRING";
                        });

                        var subtype = _.filter(sec_res, function (item) {
                            return item.subType != "WIRING";
                        });
                        if (subtype.length > 0) {
                            final_res = subtype;
                            first_call.push(subtype);
                        }

                        for (var i = 0; i < WD_Wiring.length; i++) {
                            for (var j = 0; j < sec_wiring.length; j++) {

                                if ((WD_Wiring[i].nodes.WD_TREE[0]['code'] == sec_wiring[j].nodes.WD_TREE[0]['code']) &&
                                    (WD_Wiring[i].nodes.WD_TREE[1]['code'] == sec_wiring[j].nodes.WD_TREE[1]['code']) &&
                                    (WD_Wiring[i].nodes.WD_TREE[2]['code'] == sec_wiring[j].nodes.WD_TREE[2]['code'])) {
                                    var getindex = _.findIndex(final_wd, sec_wiring[j]);
                                    if (getindex > -1) {                                        
                                    final_wd.splice(getindex, 1);
                                    }
                                }
                            }
                        }

                        for(var k=0; k< WD_Wiring.length; k++){
                            final_wd.push(WD_Wiring[k]);
                        }

                        if (WD_PH.length == 0) {
                            WD_PH = _.filter(final_res, function (item) {
                                return item.subType == "PART_HARNESS";
                            });
                        }

                        if (WD_Conn.length == 0) {
                            WD_Conn = _.filter(final_res, function (item) {
                                return item.subType == "CONNECTOR";
                            });
                            vm.WDConnectors.push(WD_Conn);
                        }

                        if (!(WD_PH.length == 0 && final_wd.length == 0)) {
                            vm.result.push(WD_PH, final_wd);
                        }

                        displayClipPartHarnessAndWiringDiagram(WD_PH, final_wd, ids.type, ids.id);

                    });

                }
                else {
                    if (!(WD_PH.length == 0 && WD_Wiring.length == 0)) {
                        vm.result.push(WD_PH, WD_Wiring);
                    }
                    displayClipPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, ids.type, ids.id);
                }

            });

        }


        /**
         * @description Used to display PartHarness And Wiring Diagram
         * @param {*} res
         */
        function displayPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, type, id, label, fromDropDown) {

            vm.componentSvgObject = [];

            vm.phObject = {};
            var rawMTCdata = '';

            vm.relatedElectricalSchema = {};
            vm.relatedElectricalSchema.id = '';
            vm.relatedElectricalSchema.thumbnailLocation = '';
            vm.relatedElectricalSchema.nodes = {};
            vm.relatedElectricalSchema.nodes.wdNode = [];

            for (var i = 0; i < WD_PH.length; i++) {
                vm.phObject['id'] = WD_PH[i].id;
                vm.phObject['thumbnailLocation'] = WD_PH[i].thumbnailLocation;
                vm.phObject['residual'] = WD_PH[i].residual;
                vm.phObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(WD_PH[i]);
                if (WD_PH[i].residual && WD_PH[i].residual.length) {
                    vm.phObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(WD_PH[i].residual[0].variable);
                }
                vm.phObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(rawMTCdata);
                vm.componentSvgObject.push(vm.phObject);
                vm.phObject = {};
            }

            for (var i = 0; i < WD_Wiring.length; i++) {
                var thumbNailLoc = WD_Wiring[i].thumbnailLocation;
                if (true) {
                    var nodeFunction = [];
                    var nodeSubFunction = [];
                    var nodeTitle = [];
                    if (WD_Wiring[i].nodes !== undefined) {
                        WD_Wiring[i].nodes.WD_TREE.forEach(function (node) {
                            if (node.type === "FUNCTION") {
                                nodeFunction.push(node);
                            } else if (node.type === "SUBFUNCTION") {
                                nodeSubFunction.push(node);
                            } else if (node.type === "TITLE") {
                                nodeTitle.push(node);
                            }
                        });

                        var subNode = {};
                        subNode.thumbNailLoc = [thumbNailLoc];
                        nodeFunction.forEach(function (nodeFunctionElement) {
                            var currentNode = {};
                            currentNode.function = nodeFunctionElement;
                            nodeSubFunction.forEach(function (subFunction) {
                                currentNode.subFunction = subFunction;
                                nodeTitle.forEach(function (title) {
                                    currentNode.title = title;
                                    subNode.subNode = angular.copy(currentNode);
                                    vm.relatedElectricalSchema.nodes.wdNode.push(subNode);
                                });
                            });
                        });

                        nodeFunction = [];
                    } else {
                        vm.relatedElectricalSchema.nodes.wdNode.push(WD_Wiring[i]);
                    }
                }
            }
            

            var myArray = null;
            var myFilteredArr = [];            
            myArray = angular.copy(vm.relatedElectricalSchema.nodes.wdNode);
            var filteredSubNodes = _.groupBy(myArray, 'subNode.title.code');
            _.forEach(filteredSubNodes, function(node){
                if(node.length > 1){
                    var tempThumbNailLoc = [].concat.apply([], (_.map(node,'thumbNailLoc')))
                    myFilteredArr.push({subNode: node[0].subNode, thumbNailLoc: _.uniq(tempThumbNailLoc)})
                } else{
                    myFilteredArr.push(node[0])
                }
            })       
            myFilteredArr.sort(function (a, b) {
                if (a.subNode && b.subNode) {
                    return a.subNode.function.code - b.subNode.function.code ||
                        a.subNode.subFunction.code - b.subNode.subFunction.code ||
                        a.subNode.title.code - b.subNode.title.code;
                }
            });

            vm.relatedElectricalSchema.nodes.wdNode = myFilteredArr;

            if ($rootScope.isPartHarnessSelected) {
                vm.WDList = null;
            }
            vm.relatedElectricalSchema.nodes.wdNode.forEach(function (item) {

                item.residualInfo = [];
                //BUG-1851 foreach exception resolved   
                if (item.thumbNailLoc !== undefined) {
                    item.thumbNailLoc.forEach(function (thumb) {
                        WD_Wiring.forEach(function (obj) {
                            if (obj.thumbnailLocation === thumb) {
                                var itemObject = {};
                                itemObject['displayedThumbnail'] = obj.thumbnailLocation;
                                itemObject['residual'] = obj.residual;
                                itemObject['id'] = obj.id;
                                if (obj.residual && obj.residual.length) {
                                    itemObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(obj.residual[0].variable);
                                }
                                itemObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(obj);
                                itemObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(obj.rawMTC);
                                // vm.componentSvgObject.push(itemObject);
                                item.residualInfo.push(itemObject);
                            }
                        });
                    });
                }
            });
            

            if (!vm.wiringDiagram.isPDF && !vm.wiringDiagram.isPNG && vm.wiringDiagram.location) {
                //vm.wiringDiagram.location = '../../assets/captures (2).svg';
                DocumentsWsService.getSVG2(vm.wiringDiagram.location).then(function (svg) {
                    vm.svg = svg;

                    if (type == "WD_COMPONENT") {
                        if (vm.selectedComponentColoredLabel) {
                            colorElectricalSchemaComponents(vm.svg);
                            colorPartHarnessSchemaComponents(vm.svg);
                        } else {
                            var svg_firstRect = getRectangleTagsToColor(vm.svg);
                            if (svg_firstRect && svg_firstRect.length) {
                                for (var x = 0; x < svg_firstRect.length; x++) {
                                    $(svg_firstRect[x]).attr("fill", "white");
                                    $(svg_firstRect[x]).removeAttr("id");
                                }
                            }

                            // Clean the previous selected component (if any) when the Cross button is clicked in drop down
                            var svg_partHarnessColoredElements = getPartHarnessComponentsToColor(vm.svg);
                            if (svg_partHarnessColoredElements && svg_partHarnessColoredElements.length) {
                                for (var x = 0; x < svg_partHarnessColoredElements.length; x++) {
                                    $(svg_partHarnessColoredElements[x]).attr("fill", "white");
                                    $(svg_partHarnessColoredElements[x]).removeAttr("id");
                                }
                            }
                        }
                    }
                    else if (type == "WD_SIGNAL") {

                        if(fromDropDown){
                            signalHighlight(id, fromDropDown);
                           
                        }else{
                            var svg_polyLineTags = getPolyLineTagsList(vm.svg, id);
                             vm.previousSignalTags = svg_polyLineTags;
                            if (svg_polyLineTags && svg_polyLineTags.length) {
                                for (var x = 0; x < svg_polyLineTags.length; x++) {
                                    $(svg_polyLineTags[x]).attr("stroke", "#FFA500");
                                    $(svg_polyLineTags[x]).attr("stroke-width", "1");
                                }
                            }
                        }

                        
                        
                       
                    }


                }).then(function () {
                    $timeout(function () {
                        ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                    }, 0)
                }).finally(function () {
                    //blockUI.stop();
                });
            }
            if(vm.isHorseUser){
                vm.relatedElectricalSchema.nodes.wdNode = _.filter(vm.relatedElectricalSchema.nodes.wdNode, function(item){
                    return item && item.subNode && item.subNode.function && item.subNode.function.code &&
                           CarSearchResultConstants.node2WDHorseList.includes(item.subNode.function.code);
                })
            }
            vm.wiringDiagramData = vm.relatedElectricalSchema.nodes.wdNode;
            vm.WDNamelist = [];
            if(!_.isEmpty(vm.wiringDiagramData) && vm.wiringDiagramData.length > 1){
                vm.wiringDiagramData.forEach(function(item){
                    if(!_.isEmpty(item.residualInfo)){
                        item.residualInfo.forEach(function(item2){
                            vm.WDNamelist.push({name:item2.formattedResidual[0].replace(/\d+/g,'').replaceAll('_',' '), displayedThumbnail: item2.displayedThumbnail, id: item2.id, subNode: item.subNode})
                            if($state.params.WD && $state.params.WD.id == item2.id){
                                vm.wdFromCompSelectedList.push({thumbNailLoc: item.thumbNailLoc,residualInfo:item.residualInfo, subNode: item.subNode, id: item2.id, displayedThumbnail: item2.displayedThumbnail,name:item2.formattedResidual[0]  })
                            }
                        })
                    }                
                })
            }

            getNodeandWdList();
            vm.componentCode = id;
            vm.componentLabel = label;
            
            blockUI.stop();

            if ($state.params.isUserComingFromClip) {
                $state.params.isUserComingFromClip = false;

                if(WD_PH.length === 0 && WD_Wiring.length === 0){
                    toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                    backToprevious();
                }

                if($state.params.WDT == 'SCH' && $state.params.LC == $state.params.id){
                    vm.selectedSignalId = $state.params.id;
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                }
                else if ($state.params.WDT == "PC") {
                    displayThumbnailOnClick(vm.componentSvgObject[0]);
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                }
                else if ($state.params.WDT == "NOM") {
                    var comp = {};
                    comp.id = vm.componentCode;
                    comp.label = vm.componentLabel;
                    openComponentDetails(comp);
                }
                else{
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                }
            }

        }

        function checkSignalId(selSignal){
            vm.wiringDiagram.signals.map(function (signs) {
                if(!_.isEmpty(selSignal)){
                    if(!_.isEmpty(signs)){
                        if(signs.id == selSignal.signal){
                            if(!_.isEmpty(signs.label)){
                                var isHighLabel = _.find(searchElectricalSchemaConstant.canHigh, function(high){
                                    vm.isBlackWhite = true;
                                    return signs.label.toUpperCase().includes(high);
                                });

                                var isLowLabel = _.find(searchElectricalSchemaConstant.canLow  ,function(low){
                                    vm.isBlackWhite = true;
                                    return signs.label.toUpperCase().includes(low);
                                });

                                if(_.isEmpty(isHighLabel) && _.isEmpty(isLowLabel)){
                                    vm.isBlackWhite = false;
                                }
                            }
                        }
                    }
                }
            });
        }

        function checkBlackWhiteLine(isBlackWhite, svg_polyLineTags, strokeColor){
            if(!vm.isNodeHighlight){
                $(svg_polyLineTags).addClass("blinking");
            }
            if(isBlackWhite){
                $(svg_polyLineTags).attr("stroke-linecap", "square").attr("stroke", "black").attr("stroke-dasharray", "none").attr("stroke-width", "5"); 
                $(svg_polyLineTags).clone().attr("stroke", "white").attr("stroke-dasharray", "3,10").attr("stroke-linecap", "square").attr("stroke-width", "3").addClass("cloned-line").appendTo($(svg_polyLineTags).parent());

            }
            else{
                $(svg_polyLineTags).attr("stroke", strokeColor);
                $(svg_polyLineTags).attr("stroke-width", "4");
            }
        }

        function signalHighlight(signalId, isNotSignalId){
           // vm.selectedSignalId = '';
            vm.isNodeHighlight = false;
            for (var i = 0; i < vm.prevSignalId.length; i++) {
                var svg_polyLineTags = getPolyLineTagsList(vm.svg, vm.prevSignalId[i]);
                if (svg_polyLineTags && svg_polyLineTags.length) {
                    for (var x = 0; x < svg_polyLineTags.length; x++) {
                        $(svg_polyLineTags[x]).attr("stroke", "#000000");
                        $(svg_polyLineTags[x]).attr("stroke-width", "1.0");
                        $(svg_polyLineTags[x]).removeAttr("stroke-dasharray");
                        $(svg_polyLineTags[x]).removeAttr("stroke-linecap");
                        $(svg_polyLineTags[x]).removeAttr("class", ".blinking");
                        $(".cloned-line").remove();
                        $(svg_polyLineTags[x]).removeAttr("id");
                    }
                }
            }

            if (vm.previousRectTags && vm.previousRectTags.length) {
                for (var j = 0; j < vm.previousRectTags.length; j++) {
                    for (var k = 0; k < vm.previousRectTags[j].length; k++) {
                        $(vm.previousRectTags[j][k]).attr("fill", "white");
                        $(vm.previousRectTags[j][k]).removeAttr("id");
                        $(vm.previousRectTags[j][k]).removeAttr("stroke-dasharray");
                        $(vm.previousRectTags[j][k]).removeAttr("stroke-linecap");
                        $(vm.previousRectTags[j][k]).removeAttr("class", ".blinking");
                    }
                    $(vm.previousRectTags[j]).attr("fill", "white");
                    $(vm.previousRectTags[j]).removeAttr("id");
                    $(vm.previousRectTags[j]).removeAttr("stroke-dasharray");
                    $(vm.previousRectTags[j]).removeAttr("stroke-linecap");
                    $(vm.previousRectTags[j]).removeAttr("class", ".blinking");
                }
            }
            if (vm.previousPartHarnessTags && vm.previousPartHarnessTags.length) {
                for (var j = 0; j < vm.previousPartHarnessTags.length; j++) {
                    $(vm.previousPartHarnessTags[j]).attr("fill", "white");
                    $(vm.previousPartHarnessTags[j]).removeAttr("id");
                    $(vm.previousPartHarnessTags[j]).removeAttr("stroke-dasharray");
                    $(vm.previousPartHarnessTags[j]).removeAttr("stroke-linecap");
                    $(vm.previousPartHarnessTags[j]).removeAttr("class", ".blinking");
                }
            }

            if (vm.previousSignalTags && vm.previousSignalTags.length) {
                for (var j = 0; j < vm.previousSignalTags.length; j++) {
                    $(vm.previousSignalTags[j]).attr("stroke", "#000000");
                    $(vm.previousSignalTags[j]).removeAttr("id");
                    $(vm.previousSignalTags[j]).attr("stroke-width", "1.0");
                    $(vm.previousSignalTags[j]).removeAttr("stroke-dasharray");
                    $(vm.previousSignalTags[j]).removeAttr("stroke-linecap");
                    $(vm.previousSignalTags[j]).removeAttr("class", ".blinking");
                }
            }

            vm.prevSignalId = [];
            vm.prevCompId = [];
            vm.previousRectTags = [];
            vm.previousPartHarnessTags = [];
            vm.previousSignalTags = [];
            var addComp = [];
            var selSignalIds = vm.wiringDiagram.lines.filter(function(item){
                return isNotSignalId ? (item.signal === signalId) : (item.id === signalId);
            })

            if(selSignalIds && !_.isEmpty(selSignalIds)){
                for(var i =0;i<selSignalIds.length;i++){
                    checkSignalId(selSignalIds[i]);
                    var svg_polyLineTags = getPolyLineTagsList(vm.svg, selSignalIds[i].id);
                    addComp.push(selSignalIds[i].components);
                    var style = applySignalColors(selSignalIds[i].id);
                    var strokeColor = style.strokeColor;
                    vm.previousSignalTags = svg_polyLineTags;
                    if (svg_polyLineTags && svg_polyLineTags.length) {
                        for (var x = 0; x < svg_polyLineTags.length; x++) {
                            checkBlackWhiteLine(vm.isBlackWhite, svg_polyLineTags[x], strokeColor);
                            vm.prevSignalId.push(selSignalIds[i].id);
                        }
                    }

                }

                if(!isNotSignalId){

                    var lines = vm.wiringDiagram.lines;
                    var isExist = _.find(lines, function (item) {
                        return item.id == selSignalIds[0].id;
                    });

                    if (isExist != null) {
                        var comp = isExist.components;
                        var addedLines = isExist.addedLines;
                        if (addedLines != null) {
                            for (var j = 0; j < addedLines.length; j++) {
                                var addedLineValue = _.find(lines, function (item) {
                                    return item.id == addedLines[j].id;
                                });
                                var childAddedLines = addedLineValue.addedLines;
                                if (childAddedLines != null) {
                                    for (var i = 0; i < childAddedLines.length; i++) {
                                        var svg_polyLineTags = getPolyLineTagsList(vm.svg, childAddedLines[i].id);
                                        var style = applySignalColors(childAddedLines[i].id);
                                        var strokeColor = style.strokeColor;
                                        vm.previousSignalTags.push(svg_polyLineTags);
                                        if (svg_polyLineTags && svg_polyLineTags.length) {
                                            for (var x = 0; x < svg_polyLineTags.length; x++) {
                                                checkBlackWhiteLine(vm.isBlackWhite, svg_polyLineTags[x], strokeColor);
                                            }
                                        }
                                        vm.prevSignalId.push(childAddedLines[i].id);
                                    }
                                }

                                checkSignalId(addedLines[j]);
                                var svg_polyLineTags = getPolyLineTagsList(vm.svg, addedLines[j].id);
                                var style = applySignalColors(addedLines[j].id);
                                var strokeColor = style.strokeColor;
                                vm.previousSignalTags.push(svg_polyLineTags);
                                if (svg_polyLineTags && svg_polyLineTags.length) {
                                    for (var x = 0; x < svg_polyLineTags.length; x++) {
                                        checkBlackWhiteLine(vm.isBlackWhite, svg_polyLineTags[x], strokeColor);
                                    }
                                }
                                vm.prevSignalId.push(addedLines[j].id);
                                vm.prevSignalId = _.uniq(vm.prevSignalId);
                                vm.prevSignalId.forEach(function (id) {
                                    var newComp = _.find(lines, function (item) {
                                        return item.id == id;
                                    });
                                    addComp.push(newComp.components);

                                }) 
                                addComp = _.uniq(addComp);
                            }

                        }

                        if(comp && comp != null){
                            for (var i = 0; i < comp.length; i++) {
                                vm.prevCompId.push(comp[i]);
                            }
                        }

                    }

                }

                for (var j = 0; j < addComp.length; j++) {
                    for (var k = 0; k < addComp[j].length; k++) {
                        vm.prevCompId.push(addComp[j][k]);
                    }
                }
                vm.prevCompId = _.uniq(vm.prevCompId);
                $timeout(function () {
                for (var i = 0; i < vm.prevCompId.length; i++) {
                    vm.componentCode = vm.prevCompId[i];
                    vm.selectedComponent.id = vm.prevCompId[i];

                    var svg_firstRect = getRectangleTagsToColor(vm.svg);
                    if(!vm.previousRectTags){
                        vm.previousRectTags = svg_firstRect;
                    }else{
                        vm.previousRectTags[i] = svg_firstRect;
                    }
                    
                    if (svg_firstRect && svg_firstRect.length) {
                        for (var x = 0; x < svg_firstRect.length; x++) {
                            $(svg_firstRect[x]).attr("fill", "#FFCC33");                    
                            $(svg_firstRect[x]).addClass("blinking");             
                            $(svg_firstRect[x]).removeAttr("id");
                        }
                    }
                }
            }, 10)
            }



        }

        function displayClipPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, type, id) {
            var wd_ph = [];
            var wd = [];
            vm.count++;
            if (vm.result != null && vm.result.length > 0) {
                for (var i = 0; i < vm.result.length; i++) {
                    for (var j = 0; j < vm.result[i].length; j++) {
                        if (vm.result[i][j].subType == "PART_HARNESS") {
                            wd_ph.push(vm.result[i][j]);
                        }
                        if (vm.result[i][j].subType == "WIRING") {
                            wd.push(vm.result[i][j]);
                        }
                    }
                }
                vm.isComponentExists = true;
            }
            else {
                vm.isComponentExists = false;
            }

            if (vm.count == vm.maxCount) {



                vm.componentSvgObject = [];

                vm.phObject = {};
                var rawMTCdata = '';

                vm.relatedElectricalSchema = {};
                vm.relatedElectricalSchema.id = '';
                vm.relatedElectricalSchema.thumbnailLocation = '';
                vm.relatedElectricalSchema.nodes = {};
                vm.relatedElectricalSchema.nodes.wdNode = [];

                WD_PH = [];
                WD_Wiring = [];

                if (vm.result.length > 2) {
                    for (var a = 0; a < wd_ph.length; a++) {
                        for (var b = a + 1; b < wd_ph.length; b++) {
                            if (wd_ph[b].id == wd_ph[a].id) {
                                WD_PH.push(wd_ph[a]);
                            }
                        }
                    }

                    for (var k = 0; k < wd.length; k++) {
                        for (var l = k + 1; l < wd.length; l++) {
                            if (wd[l].id == wd[k].id) {
                                WD_Wiring.push(wd[k]);
                            }
                        }
                    }
                }
                else {
                    WD_PH = wd_ph;
                    WD_Wiring = wd;
                }

                for (var i = 0; i < WD_PH.length; i++) {
                    vm.phObject['id'] = WD_PH[i].id;
                    vm.phObject['thumbnailLocation'] = WD_PH[i].thumbnailLocation;
                    vm.phObject['residual'] = WD_PH[i].residual;
                    vm.phObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(WD_PH[i]);
                    if (WD_PH[i].residual && WD_PH[i].residual.length) {
                        vm.phObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(WD_PH[i].residual[0].variable);
                    }
                    vm.phObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(rawMTCdata);
                    vm.componentSvgObject.push(vm.phObject);
                    vm.phObject = {};
                }

                for (var i = 0; i < WD_Wiring.length; i++) {
                    var thumbNailLoc = WD_Wiring[i].thumbnailLocation;
                    if (true) {
                        var nodeFunction = [];
                        var nodeSubFunction = [];
                        var nodeTitle = [];
                        if (WD_Wiring[i].nodes !== undefined) {
                            WD_Wiring[i].nodes.WD_TREE.forEach(function (node) {
                                if (node.type === "FUNCTION") {
                                    nodeFunction.push(node);
                                } else if (node.type === "SUBFUNCTION") {
                                    nodeSubFunction.push(node);
                                } else if (node.type === "TITLE") {
                                    nodeTitle.push(node);
                                }
                            });

                            var subNode = {};
                            subNode.thumbNailLoc = [thumbNailLoc];
                            nodeFunction.forEach(function (nodeFunctionElement) {
                                var currentNode = {};
                                currentNode.function = nodeFunctionElement;
                                nodeSubFunction.forEach(function (subFunction) {
                                    currentNode.subFunction = subFunction;
                                    nodeTitle.forEach(function (title) {
                                        currentNode.title = title;
                                        subNode.subNode = angular.copy(currentNode);
                                        vm.nodes = subNode.subNode;
                                        vm.relatedElectricalSchema.nodes.wdNode.push(subNode);
                                    });
                                });
                            });

                            nodeFunction = [];
                        } else {
                            vm.relatedElectricalSchema.nodes.wdNode.push(WD_Wiring[i]);
                        }
                    }
                }

                var myArray = null;
                var myFilteredArr = [];            
                myArray = angular.copy(vm.relatedElectricalSchema.nodes.wdNode);
                var filteredSubNodes = _.groupBy(myArray, 'subNode.title.code');
                _.forEach(filteredSubNodes, function(node){
                    if(node.length > 1){
                        var tempThumbNailLoc = [].concat.apply([], (_.map(node,'thumbNailLoc')))
                        myFilteredArr.push({subNode: node[0].subNode, thumbNailLoc: _.uniq(tempThumbNailLoc)})
                    } else{
                        myFilteredArr.push(node[0])
                    }
                })       
                myFilteredArr.sort(function (a, b) {
                    if (a.subNode && b.subNode) {
                        return a.subNode.function.code - b.subNode.function.code ||
                            a.subNode.subFunction.code - b.subNode.subFunction.code ||
                            a.subNode.title.code - b.subNode.title.code;
                    }
                });

                vm.relatedElectricalSchema.nodes.wdNode = myFilteredArr;

                if(vm.isHorseUser){
                    vm.relatedElectricalSchema.nodes.wdNode = _.filter(vm.relatedElectricalSchema.nodes.wdNode, function(item){
                        return item && item.subNode && item.subNode.function && item.subNode.function.code &&
                               CarSearchResultConstants.node2WDHorseList.includes(item.subNode.function.code);
                    })
                }
                
                myArray = angular.copy(vm.relatedElectricalSchema.nodes.wdNode);

                vm.relatedElectricalSchema.nodes.wdNode.forEach(function (item) {

                    item.residualInfo = [];
                    //BUG-1851 foreach exception resolved   
                    if (item.thumbNailLoc !== undefined) {
                        item.thumbNailLoc.forEach(function (thumb) {
                            WD_Wiring.forEach(function (obj) {
                                if (obj.thumbnailLocation === thumb) {
                                    var itemObject = {};
                                    itemObject['displayedThumbnail'] = obj.thumbnailLocation;
                                    itemObject['residual'] = obj.residual;
                                    itemObject['id'] = obj.id;
                                    if (obj.residual && obj.residual.length) {
                                        itemObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(obj.residual[0].variable);
                                    }
                                    itemObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(obj);
                                    itemObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(obj.rawMTC);
                                    // vm.componentSvgObject.push(itemObject);
                                    item.residualInfo.push(itemObject);
                                }
                            });
                        });
                    }
                });

                var sorted_WD = [];
                if (!_.isEmpty(myArray) && myArray[0] && myArray[0].thumbNailLoc && myArray[0].thumbNailLoc.length > 0) {
                    sorted_WD = _.filter(WD_Wiring, function (item) {
                        return item.thumbnailLocation == myArray[0].thumbNailLoc[0];
                    });
                }

                blockUI.stop();
                vm.count = 0;
                if ($state.params.isUserComingFromClip) {
                    $state.params.isUserComingFromClip = false;

                    if ($state.params.id != null && vm.isCPCPresent) {
                        for (var i = 0; i < vm.WDConnectors.length; i++) {

                            if (vm.WDConnectors[i].length > 0 && vm.WDConnectors[i]['0']['name'].includes($state.params.id)) {
                                vm.connectorList = angular.copy(vm.WDConnectors[i]);
                                vm.isDetailsAvailable = true;
                                vm.isRelatedElectricalSchemaWdNode = true;
                                break;
                            }
                        }
                    }
                    else if ($state.params.idOptional != null && vm.isCSCPresent) {
                        for (var i = 0; i < vm.WDConnectors.length; i++) {

                            if (vm.WDConnectors[i].length > 0 && vm.WDConnectors[i]['0']['name'].includes($state.params.idOptional)) {
                                vm.connectorList = angular.copy(vm.WDConnectors[i]);
                                vm.isDetailsAvailable = true;
                                vm.isRelatedElectricalSchemaWdNode = true;
                                break;
                            }
                        }
                    }

                    if ($state.params.WDT == "SCH") {
                        if (sorted_WD[0] != null) {
                            if($state.params.id == $state.params.LC){
                                vm.selectedSignalId = $state.params.id;
                            }
                            vm.wiringDiagram = sorted_WD[0];
                            vm.wiringDiagramData = vm.relatedElectricalSchema.nodes.wdNode;
                            displaySelectedSchema(vm.wiringDiagram.thumbnailLocation, vm.wiringDiagram.id);
                            CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                        }
                        else {
                            CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                            toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                            if (vm.isSieDocumentsExists) {
                                backToprevious();
                            } else {
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                            }
                        }
                    }
                    else if ($state.params.WDT == "PC") {
                        vm.wiringDiagram = sorted_WD[0];
                        vm.wiringDiagramData = vm.relatedElectricalSchema.nodes.wdNode;
                        displayThumbnailOnClick(vm.componentSvgObject[0]);
                        CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                    }
                    else if ($state.params.WDT == "NOM") {
                        vm.wiringDiagram = sorted_WD[0];
                        vm.wiringDiagramData = vm.relatedElectricalSchema.nodes.wdNode;
                        vm.showElectricalSVGFile = false;
                        var comp = {};
                        comp.id = vm.componentCode;
                        comp.label = vm.componentLabel;
                        openComponentDetails(comp);
                    }
                    else {
                        CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                        toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                        if (vm.isSieDocumentsExists) {
                            backToprevious();
                        } else {
                            $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                        }
                    }
                }

            }

        }


        /**
        * @name activateSelectedComponent
        * @desc highlights selected row
        * @param {id} row id in displayed table
        * @returns {*}
        */

        function activateSelectedComponent(id) {
            vm.selected = id;
        }


        /**
        * @name displayThumbnailOnClick
        * @desc displays selected thumbnail in PDF directive
        * @param {string} selected thumbnail's thumbnail
        * @returns {string}
        */

        function displayThumbnailOnClick(component) {
            vm.isComponentSelected = true;
            vm.showElectricalSVGFile = true;
            vm.isThumbnailSelected = true;
            vm.isUserComingFromClip = false;
            vm.displayComponentButton = true;
            vm.isNodeHighlight = false;
            vm.showHightlightAll = false;

            if (_.isEmpty(vm.selectedComponentColoredLabel)) {
                vm.selectedComponentColoredLabel = vm.componentCode + ' - ' + vm.componentLabel;
                vm.showComponentLabel = true;
                vm.isComponentSelected = false;
                vm.showComponentDropDownList = true;
            }

            var Wd_id = [component.id];
            vm.svg = null;

            blockUI.start();

            return searchElectricalSchemaMetierService.getWiringDiagramByIds(Wd_id).then(function (res) {
                vm.wiringDiagram = res[0].WIRING_DIAGRAMS[0];

                vm.wiringDiagram.isPDF = null;
                vm.wiringDiagram.isPNG = null;


                if (vm.wiringDiagram.components && vm.wiringDiagram.components.length) {
                    vm.idAndLabelComp = [];
                    vm.wiringDiagram.components.map(function (item) {
                        var itemObject = {};
                        itemObject['id'] = item.id;
                        itemObject['label'] = item.label;
                        itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                        itemObject['type'] = item.type;
                        vm.idAndLabelComp.push(itemObject);
                    });
                    vm.idAndLabelComp.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                    vm.wiringDiagram.components = vm.idAndLabelComp;
                }

                if (vm.wiringDiagram && vm.wiringDiagram.location) {
                    vm.wiringDiagram.isPDF = hasFileExtension(vm.wiringDiagram.location, 'pdf');
                    vm.wiringDiagram.isPNG = hasFileExtension(vm.wiringDiagram.location, 'png');
                    vm.isPrintSVGButtonActivated = hasFileExtension(vm.wiringDiagram.location, 'svg');
                }


                if (!vm.wiringDiagram.isPDF && !vm.wiringDiagram.isPNG) {
                    DocumentsWsService.getSVG2(vm.wiringDiagram.location).then(function (svg) {
                        vm.svg = svg;
                        $rootScope.isPartHarnessSelected = true;
                        getNodeandWdList();
                    }).then(function () {
                        $timeout(function () {
                            ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                        }, 0)
                    }).finally(function () {
                        blockUI.stop();
                        $timeout(function () {
                            if (vm.selectedComponentColoredLabel) {
                                // Color the selected component
                                vm.colorPartHarnessSchemaComponents(vm.svg);
                            }
                        }, 0);
                    });
                } else {
                    $timeout(function () {
                        blockUI.stop();
                        ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                    }, 0)
                }

            })


        }


        /**
        * @name displaySelectedSchema
        * @desc displays selected electrical schema among all
        * @desc schemas related to current component
        * @param {string} selected electrical schema's URL
        * @returns {string}
        */

        function displaySelectedSchema(schema, id) { 
            vm.isComponentSelected = true;
            vm.showComponentLabel = false;
            vm.wiringDiagram.thumbnailLocation = schema;
            vm.isLinkVisible = false;
            vm.wiringDiagram.isPDF = null;
            vm.wiringDiagram.isPNG = null;
            vm.showElectricalSVGFile = true;
            vm.isUserComingFromClip = false;
            vm.displayTitleOnly = false;
            vm.selected = null;
            vm.showHightlightAll = true;
            
            if (_.isEmpty(vm.selectedComponentColoredLabel)) {
                vm.selectedComponentColoredLabel = vm.componentCode + ' - ' + vm.componentLabel;
                vm.displayComponentButton = true;
            } else {
                vm.showComponentDropDownList = false;
            }
            var WD_id = [id];
            blockUI.start();

            return searchElectricalSchemaMetierService.getWiringDiagramByIds(WD_id).then(function (res) {
                CacheService.removeObject(CacheConstants.currentElectricalSchemaInfo);
                var WD_Wiring = res[0].WIRING_DIAGRAMS;
                CacheService.setObject(CacheConstants.currentElectricalSchemaInfo,WD_Wiring[0]);
                vm.nodes = angular.copy(WD_Wiring[0].nodes.WD_TREE);
                for (var i = 0; i < WD_Wiring[0].nodes.WD_TREE.length; i++) {
                    if (WD_Wiring[0].nodes.WD_TREE[i].type == "FUNCTION") {
                        vm.nodes[0].label = WD_Wiring[0].nodes.WD_TREE[i].label;
                        vm.nodes[0].nodeId = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[0].code = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[0].type = "FUNCTION";
                        vm.labelNode1 = WD_Wiring[0].nodes.WD_TREE[i].label;
                    }
                    else if (WD_Wiring[0].nodes.WD_TREE[i].type == "SUBFUNCTION") {
                        vm.nodes[1].label = WD_Wiring[0].nodes.WD_TREE[i].label;
                        vm.nodes[1].nodeId = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[1].code = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[1].type = "SUBFUNCTION";
                        vm.labelNode2 = WD_Wiring[0].nodes.WD_TREE[i].label;
                    }
                    else if (WD_Wiring[0].nodes.WD_TREE[i].type == "TITLE") {
                        vm.nodes[2].label = WD_Wiring[0].nodes.WD_TREE[i].label;
                        vm.nodes[2].nodeId = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[2].code = WD_Wiring[0].nodes.WD_TREE[i].code;
                        vm.nodes[2].type = "TITLE";
                        vm.labelNode3 = WD_Wiring[0].nodes.WD_TREE[i].label;
                    }
                }
                vm.wiringDiagram = WD_Wiring[0];

                if (vm.wiringDiagram.components && vm.wiringDiagram.components.length) {
                    vm.idAndLabelComp = [];
                    vm.wiringDiagram.components.map(function (item) {
                        var itemObject = {};
                        itemObject['id'] = item.id;
                        itemObject['label'] = item.label;
                        itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                        itemObject['type'] = item.type;
                        vm.idAndLabelComp.push(itemObject);
                    });
                    vm.idAndLabelComp.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                    vm.wiringDiagram.components = vm.idAndLabelComp;
                }
                if (vm.wiringDiagram.signals && vm.wiringDiagram.signals.length) {
                    vm.idAndLabelSignal = [];
                    vm.wiringDiagram.signals.map(function (item) {
                        var itemObject = {};
                        itemObject['id'] = item.id;
                        itemObject['label'] = item.label;
                        itemObject['idAndLabel'] = item.id + ' - ' + item.label;
                        itemObject['type'] = item.type;
                        vm.idAndLabelSignal.push(itemObject);
                    });

                    vm.idAndLabelSignal.sort(searchElectricalSchemaMetierService.sortComponentsListById);
                    vm.wiringDiagram.signals = vm.idAndLabelSignal;
                }
                vm.wiringDiagram.location = WD_Wiring[0]['location'];

                vm.currentElectricalSchema = vm.wiringDiagram.location;

                if (vm.wiringDiagram.location) {
                    vm.wiringDiagram.isPDF = hasFileExtension(vm.wiringDiagram.location, 'pdf');
                    vm.wiringDiagram.isPNG = hasFileExtension(vm.wiringDiagram.location, 'png');
                    vm.isPrintSVGButtonActivated = hasFileExtension(vm.wiringDiagram.location, 'svg');
                }

                vm.svg = null;
                vm.isRelatedElectricalSchemaWdNode = false;
                
                if (!vm.wiringDiagram.isPDF && !vm.wiringDiagram.isPNG) {
                    DocumentsWsService.getSVG2(vm.wiringDiagram.location).then(function (svg) {
                        vm.svg = svg;
                        $rootScope.isPartHarnessSelected = false;
                    }).then(function () {
                        $timeout(function () {
                            ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                        }, 0)
                    }).finally(function () {
                        blockUI.stop();
                        $timeout(function () {
                            if(vm.selectedSignalId && !_.isEmpty(vm.selectedSignalId)){
                                signalHighlight(vm.selectedSignalId,true);
                            }else
                            if (vm.selectedComponentColoredLabel) {
                                colorElectricalSchemaComponents(vm.svg);
                                if(_.isObject(vm.selectedComponentColoredLabel)){
                                    vm.chosenComponent = vm.selectedComponentColoredLabel;
                                }else{
                                    var selComp = _.includes(vm.selectedComponentColoredLabel,' - ') ? _.split(vm.selectedComponentColoredLabel,' - ') : '';
                                    if (selComp.length >= 2) {
                                        vm.chosenComponent = vm.chosenComponent || {}; 
                                        if (selComp[0] !== vm.chosenComponent.id) {
                                            vm.chosenComponent.id = selComp[0];
                                            vm.chosenComponent.label = selComp[1];
                                            vm.chosenComponent.idAndLabel = selComp[0] + ' - ' + selComp[1];
                                            vm.chosenComponent.type = '';
                                        }
                                    }
                                }
                                var comp = vm.chosenComponent;
                                comp.id = vm.chosenComponent.id;
                                comp.label = vm.chosenComponent.label;
                                comp.idAndLabel = vm.chosenComponent.id + ' - ' + vm.chosenComponent.label;
                                comp.type = vm.chosenComponent.type ? vm.chosenComponent.type : '';
                                displayListData(comp,true);
                            } else {
                                var svg_firstRect = getRectangleTagsToColor(vm.svg);
                                if (svg_firstRect && svg_firstRect.length) {
                                    for (var x = 0; x < svg_firstRect.length; x++) {
                                        $(svg_firstRect[x]).attr("fill", "white");
                                        $(svg_firstRect[x]).removeAttr("id");
                                    }
                                }
                            }
                        }, 0);


                    });
                } else {
                    $timeout(function () {
                        blockUI.stop();
                        ScrollService.animateTo('#electricalSchemaSelectedSingleNode');
                    }, 0)
                }
            }).catch(function () {
                blockUI.stop();
            });

        }

        /**
        * @description Used to color the selected component on Part Harness SVG
        * @param {*} svg
        */
        function colorPartHarnessSchemaComponents(svg) {
            vm.isNodeHighlight = false;
            var svg_partHarnessComponents = getPartHarnessComponentsToColor(svg);
            vm.previousPartHarnessTags = svg_partHarnessComponents;
            if (svg_partHarnessComponents && svg_partHarnessComponents.length) {
                for (var x = 0; x < svg_partHarnessComponents.length; x++) {
                    $(svg_partHarnessComponents[x]).attr("fill", "#FFCC33");
                    $(svg_partHarnessComponents[x]).addClass("blinking"); 
                    $(svg_partHarnessComponents[x]).removeAttr("id");
                }
            }
        }

        function clearPreviousEletricalSchemaTags() {
            if (vm.previousRectTags && vm.previousRectTags.length) {
                for (var j = 0; j < vm.previousRectTags.length; j++) {

                    if (vm.previousRectTags[j] && vm.previousRectTags[j].length) {
                        for (var k = 0; k < vm.previousRectTags[j].length; k++) {
                            $(vm.previousRectTags[j][k]).attr("fill", "white");
                            $(vm.previousRectTags[j][k]).removeAttr("id");
                            $(vm.previousRectTags[j][k]).removeAttr("class", ".blinking");
                        }
                    }
                    $(vm.previousRectTags[j]).attr("fill", "white");
                    $(vm.previousRectTags[j]).removeAttr("id");
                    $(vm.previousRectTags[j]).removeAttr("class", ".blinking");
                }
            }

            for (var i = 0; i < vm.prevSignalId.length; i++) {
                var svg_polyLineTags = getPolyLineTagsList(vm.svg, vm.prevSignalId[i]);

                if (svg_polyLineTags && svg_polyLineTags.length) {
                    for (var x = 0; x < svg_polyLineTags.length; x++) {
                        $(svg_polyLineTags[x]).attr("stroke", "#000000");
                        $(svg_polyLineTags[x]).attr("stroke-width", "1.0");
                        $(svg_polyLineTags[x]).removeAttr("id");
                    }
                }
            }
        }

        /**
        * @description Used to color the selected components on the Electrical Schema document
        * @param {*} svg
        */
        function colorElectricalSchemaComponents(svg) {

            clearPreviousEletricalSchemaTags();

            var svg_firstRect = getRectangleTagsToColor(svg);
            vm.previousRectTags = svg_firstRect;
            if (svg_firstRect && svg_firstRect.length) {
                for (var x = 0; x < svg_firstRect.length; x++) {
                    $(svg_firstRect[x]).attr("fill", "#FFCC33");
                    $(svg_firstRect[x]).addClass("blinking");
                    $(svg_firstRect[x]).removeAttr("id");
                }
            }
        }

        /**
        * @description Used to get all the required components so as to add color to them
        * @param {*} svg
        */
        function getPartHarnessComponentsToColor(svg) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(svg, "text/html");
            var textTags = xmlDoc.getElementsByTagName("text");
            var prevElementTags = [];
            if (_.isEmpty(vm.selectedComponent.id) && vm.componentCode) {
                vm.selectedComponent.id = vm.componentCode;
            }
            for (var i = 0; i < textTags.length; i++) {
                var element = textTags[i];
                $(element).attr("id", textTags[i].textContent);
                element = angular.element(element);
                if (textTags[i].textContent && vm.selectedComponent.id && vm.selectedComponent.id == textTags[i].textContent) {
                    var svg_text = document.getElementsByTagName('text');
                    for (var e = 0; e < svg_text.length; e++) {
                        if (svg_text[e].textContent == vm.selectedComponent.id) {
                            var elem = svg_text[e];
                            var prevElem = $(elem).prev();
                            prevElementTags.push(prevElem);
                        }
                    }
                }
            }
            return prevElementTags;
        }

        /**
        * @description Used to select and return the correct rectangle tags for the color to be changed (or removed)
        * @param {*} svg
        */
        function getRectangleTagsToColor(svg) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(svg, "text/html");
            var textTags = xmlDoc.getElementsByTagName("text");
            var parent;
            var svg_firstRect;
            for (var i = 0; i < textTags.length; i++) {
                var element = textTags[i];
                $(element).attr("id", textTags[i].textContent);
                element = angular.element(element);
                if (_.isEmpty(vm.selectedComponent) && vm.chosenComponent) {
                    vm.selectedComponent = $.extend({}, vm.chosenComponent);
                }
                if (_.isEmpty(vm.selectedComponent.id) && vm.componentCode) {
                    vm.selectedComponent.id = vm.componentCode;
                }
                if (textTags[i].textContent && vm.selectedComponent && vm.selectedComponent.id &&
                    vm.selectedComponent.id == textTags[i].textContent) {
                    vm.previousComponentId = vm.selectedComponent.id;
                    var svg_text = document.getElementsByTagName('text');
                    for (var e = 0; e < svg_text.length; e++) {
                        if (svg_text[e].textContent == vm.selectedComponent.id) {
                            var elem = svg_text[e];
                            parent = $(elem).parent();
                            $(parent).attr("id", vm.selectedComponent.id);
                            var parentTags = angular.element(parent);
                            var textList = parentTags[0].querySelectorAll('text');
                            for (var j = 0; j < textList.length; j++) {
                                if (textList[j].textContent == vm.selectedComponent.id) {
                                    if (textList[j].textContent == 1440) {
                                        if (svg_firstRect && svg_firstRect.length) {
                                            var rectElement = $(textList[j]).prevAll('rect').first().prevAll('rect').first();
                                            svg_firstRect.push(rectElement);
                                        } else {
                                            svg_firstRect = $(textList[j]).prevAll('rect').first().prevAll('rect').first();
                                        }
                                    } else {
                                        if (svg_firstRect && svg_firstRect.length) {
                                            var rectElem = $(textList[j]).prevAll('rect');
                                            if (_.isEmpty(rectElem)) {
                                                rectElem = $(textList[j]).prevAll('g');
                                                rectElem = rectElem.children();
                                                svg_firstRect.push(rectElem);
                                            }
                                        } else {
                                            svg_firstRect = $(textList[j]).prevAll('rect');
                                            if (_.isEmpty(svg_firstRect)) {
                                                svg_firstRect = $(textList[j]).prevAll('g');
                                                svg_firstRect = svg_firstRect.children();
                                            }
                                        }
                                    }
                                }
                            }
                            var rectList = parentTags[0].querySelectorAll('rect');
                            if (rectList) {
                                var firstRectElement = $(rectList);
                                svg_firstRect.push(firstRectElement);
                            }
                        }
                    }
                }
            }

            return svg_firstRect;
        }


        /**
        * @name updateBreadcrumb
        * @desc displays selected electrical schema's breadcrumb
        * @param {string} selected electrical schema's thumbnail URL
        * @returns {string}
        */

        function updateBreadcrumb(path, backCompSelected) {

            if (path.subNode) {
                vm.labelNode1 = path.subNode.function.label;
                vm.codeNode1 = path.subNode.function.code;
                vm.labelNode2 = path.subNode.subFunction.label;
                vm.codeNode2 = path.subNode.subFunction.code;
                vm.labelNode3 = path.subNode.title.label;
                vm.codeNode3 = path.subNode.title.code;
            }

            else if (vm.nodes) {
                vm.nodes[0].nodeId = path.subNode.function.code;
                vm.nodes[0].label = path.subNode.function.label;
                vm.nodes[1].nodeId = path.subNode.subFunction.code;
                vm.nodes[1].label = path.subNode.subFunction.label;
                vm.nodes[2].nodeId = path.subNode.title.code;
                vm.nodes[2].label = path.subNode.title.label;
            } else if (_.isEmpty(vm.nodes)) {
                /** Set the nodes data according to the selected wiring diagram and levels of node
                so that the selected level node gets higlighted on when we go back to Arbo page
                */
                vm.nodes = [];
                var nodes = CacheService.getObject(CacheConstants.treeContainingNodes);
                if (nodes && nodes.length) {
                    nodes.forEach(function (tree1) {
                        if (vm.labelNode1 === tree1.label || (_.isEmpty(vm.labelNode1) && vm.codeNode1 === tree1.nodeId)) {
                            if (tree1.childNodes && tree1.childNodes.length) {
                                tree1.childNodes.forEach(function (tree2) {
                                    if (vm.labelNode2 === tree2.label || (_.isEmpty(vm.labelNode2) && vm.codeNode2 === tree2.nodeId)) {
                                        if (tree2.childNodes && tree2.childNodes.length) {
                                            tree2.childNodes.forEach(function (tree3) {
                                                if (vm.labelNode3 === tree3.label || (_.isEmpty(vm.labelNode3) && vm.codeNode3 === tree3.nodeId)) {
                                                    vm.nodes.push(tree1);
                                                    vm.nodes.push(tree2);
                                                    vm.nodes.push(tree3);
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        }
                    })

                }
            }
            else if (vm.nodes['function']) {
                vm.nodes = path.subNode;
            }
            if(!backCompSelected)
                vm.wdFromCompSelectedList.push(path);
        }
        function showPreviousWDFromComp(){
            var selectedItem = null;
            if(!_.isEmpty(vm.wdFromCompSelectedList)){
               selectedItem = vm.wdFromCompSelectedList[vm.wdFromCompSelectedList.length-2];
               vm.wdFromCompSelectedList.splice(vm.wdFromCompSelectedList.length-2,1);
            }
            if(selectedItem){
                vm.displaySelectedSchema(selectedItem.displayedThumbnail,selectedItem.id);
                vm.updateBreadcrumb(selectedItem,true);
            }
        }
        function backToLevel3MultiOrSingle(WDList) {
            if (WDList && WDList.length > 1) {
                $state.go(RoutesConstants.electricalSchemaLevel3Multi, {
                    WDList: WDList,
                    node: vm.selectedNode,
                    selectedComponent: vm.selectedComponent,
                    fromHarness: true,
                });
            } else if (WDList && WDList.length == 1) {
                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                    node: vm.selectedNode, WDList: WDList, WD: WDList[0], selectedComponent: vm.selectedComponent, fromHarness: true
                });
            }

        }

        /**
        *      @desc           Retrieve necessary data to restore electrical schema tree,
        *                      and send by route params
        *      @param {int}    node
        */

        function goToArbo(node) {
            var data = {};

            switch (node) {
                case 1:
                    if (vm.nodes['function']) {
                        _.extend(data, {
                            nodeOneID: vm.nodes.function.code
                        });
                    } else {
                        _.extend(data, {
                            nodeOneID: vm.nodes[0].nodeId
                        });
                    }

                    break;
                case 2:
                    if (vm.nodes['function']) {
                        _.extend(data, {
                            nodeOneID: vm.nodes.function.code,
                            nodeTwoID: vm.nodes.subFunction.code
                        });
                    } else if (vm.nodes[0].nodeId != undefined && vm.nodes[0].nodeId != null && !vm.nodes[0].type) { 
                        _.extend(data, {
                            nodeOneID: vm.nodes[0].nodeId,
                            nodeTwoID: vm.nodes[1].node.nodeId
                        });
                    } else if (vm.nodes[0].code != undefined && vm.nodes[0].code != null && vm.nodes[0].type) {
                        var nodeOne = _.filter(vm.nodes, function (item) {
                            return item.type == "FUNCTION";
                        });
                        var nodeTwo = _.filter(vm.nodes, function (item) {
                            return item.type == "SUBFUNCTION";
                        });
                        _.extend(data, {
                            nodeOneID: nodeOne[0].code,
                            nodeTwoID: nodeTwo[0].code
                        });
                    }
                    break;
                default:
                    break;
            }
            
            if (node === 3 && $rootScope.isPartHarnessSelected) {
                var WDList = [];
                if (vm.wdId && !_.isEmpty(vm.wdId)) {
                    if (!vm.WDList) {
                        blockUI.start();
                        searchElectricalSchemaMetierService.getWiringDiagramByIds(vm.wdId).then(function (res) {
                            WDList = res[0].WIRING_DIAGRAMS;
                            backToLevel3MultiOrSingle(WDList);
                            vm.WDList = WDList;
                        }).finally(function () {
                            blockUI.stop();
                        });
                    } else {
                        WDList = vm.WDList && vm.WDList.length != 0 ? vm.WDList : [];
                        backToLevel3MultiOrSingle(WDList);
                    }
                }
                
            } else if (node === 3 && vm.WDList) {
                if (vm.WDList.length > 1) {
                    $state.go(RoutesConstants.electricalSchemaLevel3Multi, {
                        WDList: vm.WDList,
                        node: vm.nodes
                    });
                } else if(vm.WDList.length == 1) {
                    $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                        WDList: vm.WDList,
                        node: vm.nodes
                    });
                }
            } else{
                $state.go(RoutesConstants.carSearchResult, {
                    tab: CarSearchResultConstants.searchTypes.consultElectricalShema,   
                    data: Object.keys(data).length ? data : null,
                    isFromWDUrlLink: vm.originallyFromWDUrlLink
                });
            }
        
        }

        function checkDetails() {

            var component = vm.selectedComponent;

            if (_.isEmpty(component) && $state.params.componentCode && $state.params.componentLabel) {
                component.id = $state.params.componentCode;
                component.label = $state.params.componentLabel;
            }
        }

        function backToprevious()
            {
                if (vm.isFromWDUrlLink || vm.originallyFromWDUrlLink) {
                    vm.isFromWDUrlLink = vm.originallyFromWDUrlLink;
                    goToArbo();
                } 
                else {
                    $window.history.go(-2);
                }

            }

        function openComponentDetails(component) {
            SearchArboTextualMetierService.setConnectedServicesAuditData('WD_Connector_Details').then(function () {});
            //Set the component id and label if no part harness or wiring diagram is selected for the first time
            if (_.isEmpty(component) && $state.params.componentCode && $state.params.componentLabel) {
                component.id = $state.params.componentCode;
                component.label = $state.params.componentLabel;
            }
            if (component.id == null || component.label == null) {
                component.id = vm.componentCode;
                component.label = vm.componentLabel;
            }

            var compDetail = [];
            for (var i = 0; i < vm.connectorList.length; i++) {
                compDetail.push(vm.connectorList[i].id);
            }

            blockUI.start();
            searchElectricalSchemaMetierService.getComponentDetailsById(compDetail,vm.isObjCritSelected,vm.wdObjectCriteria).then(function (response) {

                if (_.isEmpty(response[0])) {                  
                    
                    searchElectricalSchemaMetierService.getComponentDetailsById(compDetail,false,null).then(function (res) {
                        diaplayComponentDetails(res[0],component.id,component.label);
                    })

                } else {
                    diaplayComponentDetails(response[0],component.id,component.label);
                }

            }).catch(function () {
                toastr.error($translate.instant("ELECTRICAL_SCHEMAS_NO_COMPONENT_DETAILS"));
                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
            }).finally(function () {
                blockUI.stop();
            });
        }

        function diaplayComponentDetails(response,id,label){
            vm.componentDetailsList = response;
                    var labelObj = '';

                    vm.componentDetailsList.WIRING_DIAGRAMS.forEach(function (item) {

                        if (!_.isEmpty(item.pinsUse) && !_.isEmpty(item.pinsUse[0].list)) {
                            vm.sortByPinCodes(item.pinsUse[0].list);
                        } else {
                            item.pinsUse = [];
                        }

                        item.applicabilityResidual = [];
                        item.applicabilityResidualChain = '';

                        if (!_.isEmpty(item.residual) && _.isEmpty(item.rawMTC)) { 
                         for(var i = 0; i < item.residual.length; i++){
                          if(item.residual.length >= 1) {
                            if (!_.isEmpty(item.residual[i].fixe)) {
                                item.residual[i].fixe.forEach(function (residualFixe) {
                                    var applicabilityResidualInformation = '';
                                    labelObj = residualFixe.labelObj;

                                    var listCritIndex = 0;
                                    var listCritSize = residualFixe.listCrit.length;
                                    residualFixe.listCrit.forEach(function (crit) {
                                        if (listCritSize === 1) {
                                            applicabilityResidualInformation += "<span class='labelObjectDisplay'>" + labelObj + '</span> '+  "<span class='labelObjectDisplay'> : </span> " + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                                        } 
                                        else {
                                            if (listCritIndex === 0) {
                                                applicabilityResidualInformation = "<span class='labelObjectDisplay'>" + labelObj + '</span> '+"<span class='labelObjectDisplay'> : </span> " + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';

                                            } else {
                                                applicabilityResidualInformation += "<span class='labelAndCodeCritDisplay'>,</span> <span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                                            }
                                        }
                                        listCritIndex++;
                                    });
                                    item.applicabilityResidual.push(applicabilityResidualInformation);
                                });
                            }

                            if (!_.isEmpty(item.residual[i].variable)) {

                                item.residual[i].variable.forEach(function (residualVariable) {
                                    var applicabilityResidualInformation = '';
                                    labelObj = residualVariable.labelObj;

                                    var listCritIndex = 0;
                                    var listCritSize = residualVariable.listCrit.length;
                                    residualVariable.listCrit.forEach(function (crit) {
                                        if (listCritSize === 1) {
                                            applicabilityResidualInformation += "<span class='labelObjectDisplay'>" + labelObj + ' : </span>' + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';

                                        } else {
                                            if (listCritIndex === 0) {
                                                applicabilityResidualInformation = "<span class='labelObjectDisplay'>" + labelObj + ' : </span>:' + "<span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                                            }
                                            else {
                                                applicabilityResidualInformation += "<span class='labelAndCodeCritDisplay'>,</span> <span class='labelAndCodeCritDisplay'>" + crit.labelCrit + ' (' + crit.codeCrit + ')</span>';
                                            }
                                        }
                                        listCritIndex++;
                                    });
                                    item.applicabilityResidual.push(applicabilityResidualInformation);
                                });
                            }
                        }
                            if(item.residual.length == 1) {
                                item.applicabilityResidualChain = item.applicabilityResidual.join('<br>');
                            }
                            else {
                                item.applicabilityResidual.push("<hr class='hrLine'>");
                                item.applicabilityResidualChain = item.applicabilityResidual.join('<br>');
                            }
                        };
                    }

                    else if (!_.isEmpty(item.rawMTC)) {

                            item.applicabilityResidual = [];
                            item.applicabilityResidualChain = '';

                            item.rawMTC.forEach(function (crit) {
                                var rawMTCdata = '';
                                rawMTCdata = "<span  class='rawMTCDataDisplay'>" + crit + '</span>';
                                item.applicabilityResidual.push(rawMTCdata);
                            });

                            item.applicabilityResidualChain = item.applicabilityResidual.join('<br>');
                        }

                    });

                


                // IE hack, as this browser puts PDF directive above current mdDialog
                if (vm.isUserComingFromClip) {
                    $state.params.isUserComingFromClip = false;
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                }
                var pdfDirective = angular.element(document.getElementsByTagName('electrical-schema-pdf'));
                pdfDirective.addClass("doNotDisplayPdfFile");
                vm.isPopInActive = true;

                $mdDialog.show({
                    templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemaComponentDetails.template.html',
                    controller: 'electricalSchemaComponentDetailsController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: false,
                    locals: {
                        componentDetailsList: vm.componentDetailsList,
                        componentCode: id,
                        componentLabel: label,
                        isPopInActive: vm.isPopInActive
                    }
                });
                return vm.componentDetailsList;
        }


        /**
        *  @desc   Add new field on each element of residualApplication => computedResiduel: Array<string>
        *  @param {Object} residualApplicabilities node containing the residual applicability
        *  @return {array<{}>} return the formated residual array
        */

        function formatResidual(residualApplicabilities) {
            return searchElectricalSchemaMetierService.formatResidual(residualApplicabilities);
        }


        /**
        *  @desc   Sort pinsUse array by pin code attribute in ascending order
        *  @param {Array} pinsUse array
        *  @return {array<{}>} return the newly sorted array
        */

        function sortByPinCodes(object) {
            object.sort(function (a, b) {
                return a.pinCode.localeCompare(b.pinCode, undefined, { numeric: true, sensitivity: 'base' });
            });
        }

        function downloadPdf(){
            $rootScope.$broadcast('resetSvgZoom');
            pdfMake.tableLayouts = {
                otherTableLayout: {
                    hLineWidth: function () {
                        return 1;
                    },
                    vLineWidth: function () {
                        return 1;
                    }
                },secondTableLayout: {
                    hLineWidth: function () {
                        return 0;
                    },
                    vLineWidth: function () {
                        return 0;
                    }
                },
                thirdTableLayout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                    }
                },
            };
            removeRectComponents();
            if(!_.isEmpty(vm.prevSignalId) && !vm.isNodeHighlight){
                for (var i = 0; i < vm.prevSignalId.length; i++) {
                    var svg_polyLineTags = getPolyLineTagsList(vm.svg, vm.prevSignalId[i]);
                    if (svg_polyLineTags && svg_polyLineTags.length) {
                        for (var x = 0; x < svg_polyLineTags.length; x++) {
                            $(svg_polyLineTags[x]).attr("stroke", "#000000");
                            $(svg_polyLineTags[x]).attr("stroke-width", "1.0");
                            $(svg_polyLineTags[x]).removeAttr("id");
                        }
                    }
                }
    
                if (vm.previousSignalTags && vm.previousSignalTags.length) {
                    for (var j = 0; j < vm.previousSignalTags.length; j++) {
                        $(vm.previousSignalTags[j]).attr("stroke", "#000000");
                        $(vm.previousSignalTags[j]).removeAttr("id");
                        $(vm.previousSignalTags[j]).attr("stroke-width", "1.0");
                    }
                }
            }
            $timeout(function () {
                downloadPdfData().then(function(response){
                    var pdfDocGenerator = pdfMake.createPdf(response.data);
                    pdfDocGenerator.getBuffer(function (buffer) {
                        var file = new Blob([(buffer)], { type: 'application/pdf' });
                        var isIE = false || !!document.documentMode;
                        var isEdge = !isIE && !!window.StyleMedia;
                        if (isIE || isEdge || wdImageBig) {
                            FileSaver.saveAs(file,'Electrical schema' +".pdf");
                        }else {
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                    });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                    })
                });
            },100)
        }

        function downloadPdfData(){
            var deferred = $q.defer();
            var serializedSVG = null;
            var SVGDomElement = document.querySelector("#electrical-svg");
            var SVGDomElement1 = SVGDomElement.cloneNode(true);
            var selectedSvgRef = SVGDomElement1.querySelectorAll('svg'); 
            var svgWidth = parseInt(SVGDomElement1.getAttribute('width'));
            var imageObj = null;
            var dataArray = [];
            var finalArr = [];
            var imgObj = { type: "columns", values: {0: [vm.labelNode1 + (vm.labelNode2 ? ' > ':'') + vm.labelNode2 + (vm.labelNode3 ? ' > ':'') + vm.labelNode3]}, styles: "tableTextStyle" };
                dataArray.push(imgObj);
            if(!svgWidth) {
                SVGDomElement1.removeAttribute("viewBox")
                if (!SVGDomElement1.getAttribute("viewBox")) {
                    SVGDomElement1.setAttribute("viewBox", "0 0 1200 800");
                }
                serializedSVG = new XMLSerializer().serializeToString(SVGDomElement1);
                imageObj = {
                    type: "wdimagebig", values: serializedSVG
                }
                dataArray.push(imageObj);
                wdImageBig = true;
            }
            else {
                if (selectedSvgRef && selectedSvgRef.length > 0) {
                    angular.forEach(selectedSvgRef, function (svgTag) {
                        svgTag.remove();
                    })
                }
                
                var targetG = SVGDomElement1.querySelector("g.svg-pan-zoom_viewport");
                
                    if (svgWidth <= 900) {
                        SVGDomElement1.setAttribute("viewBox", "0 0 900 700");
                    } else if (svgWidth <= 1400) {
                        SVGDomElement1.setAttribute("viewBox", "0 0 1400 1000");
                    } else {
                        SVGDomElement1.setAttribute("viewBox", "0 0 2100 1500");
                        SVGDomElement1.removeAttribute("width");
                        SVGDomElement1.removeAttribute("height");
                        if (targetG) {
                            targetG.removeAttribute("transform");
                            targetG.removeAttribute("style");
                        }
                    }     
                serializedSVG = new XMLSerializer().serializeToString(SVGDomElement1);                 
                imageObj = {
                    type: "wdimage", values: SVGDomElement1
                }
                dataArray.push(imageObj);
            }
            
            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,false,false,true);
            var headerDefinition = !vm.nissanUserURL ? {
                columns: [
                    {
                        image: pictoImage.RENAULT.value,
                        alignment: "left",
                        width: 50,
                        margin: [40, 15, 0, 10],
                    }
                ]
            } : '';

            var docDefinition = {
                info: {
                    title: $translate.instant("HEADER_DOCUMENTS_DIAGRAMS"),
                },
                header: headerDefinition,
                footer: {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        },
                        {
                            type: 'none',
                            text: moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                            alignment: 'right',
                            margin: [0, 0, 10, 0]
                        }
                    ]
                },
                pageOrientation: 'landscape',
                content: [
                    finalArr
                ],
                styles: {
                    tableTextStyle: {
                        margin: [0, 20, 0, 15],
                        fontSize: 10
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }
        function highlightAllLines(){
            if(vm.isNodeHighlight){
                if(!_.isEmpty(vm.wiringDiagram.lines)){
                    vm.wiringDiagram.lines.forEach(function(item){
                        checkSignalId(item);
                        var svg_polyLineTags = getPolyLineTagsList(vm.svg, item.id);
                        var style = applySignalColors(item.id);
                        var strokeColor = style.strokeColor;
                        vm.previousSignalTags = svg_polyLineTags;
                        if (svg_polyLineTags && svg_polyLineTags.length) {
                            for (var x = 0; x < svg_polyLineTags.length; x++) {
                                checkBlackWhiteLine(vm.isBlackWhite, svg_polyLineTags[x], strokeColor);
                                vm.prevSignalId.push(item.id);
                            }
                        }
                    })
                    removeRectComponents();
                }
            } else {
                if(!_.isEmpty(vm.wiringDiagram.lines)){
                    for (var i = 0; i < vm.prevSignalId.length; i++) {
                        var svg_polyLineTags = getPolyLineTagsList(vm.svg, vm.prevSignalId[i]);
                        if (svg_polyLineTags && svg_polyLineTags.length) {
                            for (var x = 0; x < svg_polyLineTags.length; x++) {
                                $(svg_polyLineTags[x]).attr("stroke", "#000000");
                                $(svg_polyLineTags[x]).attr("stroke-width", "1.0");
                                $(svg_polyLineTags[x]).removeAttr("stroke-dasharray");
                                $(svg_polyLineTags[x]).removeAttr("stroke-linecap");
                                $(".cloned-line").remove();
                                $(svg_polyLineTags[x]).removeAttr("id");
                            }
                        }
                    }
                }
                removeRectComponents();
            }
           
        }
        function removeRectComponents(){
            if (vm.previousRectTags && vm.previousRectTags.length) {
                for (var j = 0; j < vm.previousRectTags.length; j++) {
                    for (var k = 0; k < vm.previousRectTags[j].length; k++) {
                        $(vm.previousRectTags[j][k]).attr("fill", "white");
                        $(vm.previousRectTags[j][k]).removeAttr("id");
                    }
                    $(vm.previousRectTags[j]).attr("fill", "white");
                    $(vm.previousRectTags[j]).removeAttr("id");
                }
            }
            if (vm.previousPartHarnessTags && vm.previousPartHarnessTags.length) {
                for (var j = 0; j < vm.previousPartHarnessTags.length; j++) {
                    $(vm.previousPartHarnessTags[j]).attr("fill", "white");
                    $(vm.previousPartHarnessTags[j]).removeAttr("id");
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('electricalSchemaLevel3MultiController', electricalSchemaLevel3MultiController);

    /** @ngInject */
    function electricalSchemaLevel3MultiController(
        $state,

        CacheService,
        ScrollService,
        searchElectricalSchemaMetierService,
        configConstantes,
        CarSearchResultConstants,
        RoutesConstants,
        CacheConstants,
        $translate,
        toastr,
        $filter,
        $timeout,
        $mdDialog,blockUI,$window, $log) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.nodes = [];
        vm.displayTitleOnly = false;
        var popupResult= [];
        vm.displayElectricalSchema = displayElectricalSchema;
        vm.formatResidual = formatResidual;
        vm.saveState = prepareSaveState;
        vm.goToArbo = goToArbo;
        vm.selectObjectCriteria = selectObjectCriteria;
        vm.wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria);
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        if(vm.wdObjectCriteria && !_.isEmpty(vm.wdObjectCriteria) && vm.wdObjectCriteria.currentnodeList) {
            vm.wdObjectCriteria = vm.wdObjectCriteria.currentnodeList
        }
        
        vm.selectFilter = selectFilter;
        vm.backToprevious=backToprevious;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        this.$onInit = function () {
            vm.formatNodeLabel = formatNodeLabel;
            vm.fromHarness = $state.params.fromHarness;
            vm.nodes = $state.params.node;
            vm.wiringDiagrams = $state.params.WDList;
            vm.isLiteApplicability = $state.params.isLiteApplicability;
            vm.idlist = $state.params.idlist;
            vm.isSieDocumentsExists=CacheService.getSieDocumentsHistory();
            vm.originallyFromWDUrlLink = $state.params.originallyFromWDUrlLink;
            vm.isFromWDUrlLink = $state.params.isFromWDUrlLink;
            vm.labelNode1 = vm.nodes[0].label;
            vm.labelNode2 =  (!_.isEmpty(vm.nodes[1].node)) ? vm.nodes[1].node.label : vm.nodes[1].label ;
            vm.labelNode3 = vm.nodes[2].label;
            vm.displayTitleOnly = (vm.labelNode1 != null && vm.labelNode2 == null && vm.labelNode3 != null) ? true : false;
            if(vm.isLiteApplicability && vm.wiringDiagrams.length >= 4){
                selectObjectCriteria();
            }
            $timeout(function () {
                ScrollService.animateTo('#electricalSchemaSelectedNode');
            }, 0)
           
        }
        function selectFilter(){
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/objectCriteriaModal.template.html',
                controller: 'SelectedFilterCtrl',
                clickOutsideToClose: false,
                escapeToClose: false,
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    wiringDiagrams: vm.wiringDiagrams,
                }
            }).then(function(result){

                if(result && !_.isEmpty(result)){

                    blockUI.start();
                    popupResult = result;
                    return searchElectricalSchemaMetierService.getWiringDiagramByIds(vm.idlist,true,result.header).then(function (res) {
                        if(res && res.length === 1 &&  !_.isEmpty(res[0])){
                            vm.wiringDiagrams = res[0].WIRING_DIAGRAMS;
                            if(vm.wiringDiagrams.length === 1){
                                CacheService.setObject(CacheConstants.wdObjectCriteria,result);
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, { node: vm.nodes, WD: vm.wiringDiagrams[0] });
                            }
                        }else{
                            toastr.error($translate.instant('CRITERIA_TOASTER'));
                            selectFilter();
                        }
                    });
                }
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            }).finally(function(){
                blockUI.stop();
            })
    
        }

        function selectObjectCriteria(){
            
                var parent = angular.element(document.body);
                $mdDialog.show({
                    parent: parent,
                    templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/objectCriteriaModal.template.html',
                    controller: 'ObjectCriteriaModalCtrl',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    bindToController: true,
                    controllerAs: 'vm',
                    locals: {
                        wiringDiagrams: vm.wiringDiagrams,
                    }
                }).then(function(result){

                    if(result && result.isObjCriteriaAvailable && !result.header) {
                        vm.wdObjectCriteria = true;
                    }
                    else if(result && !_.isEmpty(result)){
                        popupResult = result;
                        vm.selObjCrit = result.currentnodeList;

                        blockUI.start();

                        return searchElectricalSchemaMetierService.getWiringDiagramByIds(vm.idlist,true,result.header).then(function (res) {
                            if(res && res.length === 1 &&  !_.isEmpty(res[0])){
                                vm.wiringDiagrams = res[0].WIRING_DIAGRAMS;
                                vm.wdObjectCriteria = result;
                                if(vm.wiringDiagrams.length === 1) {
                                    CacheService.setObject(CacheConstants.wdObjectCriteria,result);
                                    $state.go(RoutesConstants.electricalSchemaLevel3Single, { node: vm.nodes, WD: vm.wiringDiagrams[0] });
                                }
                            }else{
                                toastr.error($translate.instant('CRITERIA_TOASTER'));
                                selectObjectCriteria()
                            }
                        });
                    
                    }
                }).catch(function(){
                    $log.debug($translate.instant('ERROR'));
                }).finally(function(){
                    blockUI.stop();
                })
        }

        /**
         *  @desc Display electrical schema on another controller/view
         *  @param {object} wiringDiagrams
         */

        function displayElectricalSchema(wiringDiagram) {
            if(popupResult && !_.isEmpty(popupResult)) {
            CacheService.setObject(CacheConstants.wdObjectCriteria,popupResult);
            }
            $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                node: vm.nodes,
                WD: wiringDiagram,
                WDList: vm.wiringDiagrams,
                fromHarness: vm.fromHarness,
                selectedComponent: $state.params.selectedComponent
            });
            CacheService.setObject(CacheConstants.currentElectricalSchemaInfo, wiringDiagram);
        }

        function prepareSaveState() {

            var params = $state.params;
            params.WD = vm.wiringDiagrams; //The currently selected wiring diagram.
            //params.WDList = null;
            params.node = vm.nodes;
            if (vm.selectedComponentColoredLabel && vm.selectedComponentColoredLabel != null) {

                var outItem;
                // Set the Label in the drop down for the corresponding component selected on the document
                var list1 = CacheService.getObject(CacheConstants.currentElectricalSchemaInfo);
                if (!list1.components) {
                    list1 = list1[0];
                }
                if (list1.components && list1.components.length) {
                    list1.components.forEach(function (item) {
                        if (item.id == vm.selectedComponent.id) {
                            outItem = item;
                        }
                    });
                }
                var component = outItem || vm.selectedComponentColoredLabel;
                params.componentCode = component.id;
                params.componentLabel = component.label;
                params.chosenComponent = component;
                params.isComponentSelected = true;
            }
            else {
                params.componentCode = null;
                params.componentLabel = null;
                params.chosenComponent = null;
                params.isComponentSelected = false;
            }

            return params;
        }

        /**
         *  @desc   Add new field on each element of residualApplication => computedResiduel: Array<string>
         *  @param {Object} residualApplicabilities node containing the residual applicability
         *  @return {array<{}>} return the formated residual array
         */

        function formatResidual(residualApplicabilities) {
            return searchElectricalSchemaMetierService.formatResidual(residualApplicabilities);
        }

        /**
         *      @desc           Retrieve necessary data to restore electrical schema three,
         *                      and send by route params
         *      @param {int}    node
         */
         function backToprevious()
         {
             if (vm.isFromWDUrlLink) {
                $state.go(RoutesConstants.electricalSchemaLevel3Multi);
             } else if (vm.originallyFromWDUrlLink) {
                $state.go(RoutesConstants.electricalSchemaLevel3Multi);
             } else {
                 $window.history.go(-2);
             }

         }

        function goToArbo(node) {
            var data = {};

            switch (node) {
                case 1:
                    _.extend(data, {
                        nodeOneID: vm.nodes[0].nodeId
                    });
                    break;
                case 2:
                    _.extend(data, {
                        nodeOneID: vm.nodes[0].nodeId,
                        nodeTwoID: vm.nodes[1].node.nodeId
                    });
                    break;
                default:
                    break;
            }            
            $state.go(RoutesConstants.carSearchResult, {
                tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                data: Object.keys(data).length ? data : null
            });
        
        }
        function formatNodeLabel(label, level) {
            if (!label) {
                return label;
            }

            var nodeOne = vm.nodes && vm.nodes[0];
            var nodeTwo = vm.nodes && vm.nodes[1];
            var nodeTwoData = nodeTwo && !_.isEmpty(nodeTwo.node) ? nodeTwo.node : nodeTwo;
            var isNetworkDiagnosisCanCommunication =
                nodeOne && String(nodeOne.nodeId) === '2011' &&
                nodeTwoData && String(nodeTwoData.nodeId) === '3090';

            var formattedLabel = $filter('toCamelCase')(label);

            if (isNetworkDiagnosisCanCommunication  && level === 3) {
                return formattedLabel.toUpperCase();
            }
             return formattedLabel.replace(/\b(can|lis)\b/gi, function (match) {
                return match.toUpperCase();
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('phenix').controller('electricalSchemaHarnessController', electricalSchemaHarnessController);

    /** @ngInject */
    function electricalSchemaHarnessController(
        RoutesConstants,
        blockUI,
        toastr,
        $translate,
        $state,
        CarSearchResultConstants,
        searchElectricalSchemaMetierService) {

        // VARIABLES

        var vm = this;
        vm.componentSvgObject = [];
        vm.phObject = {};

        // FUNCTIONS
        vm.goToArbo = goToArbo;
        vm.displayThumbnailOnClick = displayThumbnailOnClick;

        this.$onInit = function () {
            var data = $state.params.data;

            data.forEach(function (item) {

                var thumbNailLoc = item.thumbnailLocation;
                var loc = item.location;
                var rawMTCdata = '';
                var residual = [];

                if (item.rawMTC) {
                    rawMTCdata = item.rawMTC;
                }
                if (item.residual) {
                    residual = item.residual;
                }

                vm.phObject['id'] = item.id;
                vm.phObject['location'] = loc;
                vm.phObject['thumbnailLocation'] = thumbNailLoc;
                vm.phObject['residual'] = residual;
                vm.phObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(item);
                if (residual && residual.length) {
                    vm.phObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(residual[0].variable);
                }
                vm.phObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(rawMTCdata);
                vm.componentSvgObject.push(vm.phObject);
                vm.phObject = {};

            });
            vm.wiringDiagramData = vm.componentSvgObject;

        };

        function goToArbo() {
            var data = {};
            $state.go(RoutesConstants.carSearchResult, {
                tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                data: Object.keys(data).length ? data : null
            });

        }
        function displayThumbnailOnClick(id) {
            var idlist = [];
            var WDList = [];
            blockUI.start();
            idlist.push(id);

            return searchElectricalSchemaMetierService.getWiringDiagramByIdsWithFullContext(idlist).then(function (res) {

                WDList = res[0].WIRING_DIAGRAMS;
                if (WDList == undefined) {
                }
                else if (WDList.length === 1) {
                    $state.go(RoutesConstants.electricalSchemaLevel3Single, { WD: WDList[0], isHarness: true });
                }

            }).then(function () {
                if (WDList == undefined) {
                    return searchElectricalSchemaMetierService.getWiringDiagramByIds(idlist, true, vm.wdObjectCriteria).then(function (res) {
                        WDList = res[0].WIRING_DIAGRAMS;
                        if (WDList == undefined) {
                            toastr.error($translate.instant('CRITERIA_TOASTER'));
                        }
                        else if (WDList.length === 1) {
                            $state.go(RoutesConstants.electricalSchemaLevel3Single, { WD: WDList[0], isHarness: true });
                        }
                    })
                }
            }).finally(function () {
                blockUI.stop();
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix').controller('electricalSchemaComponentDetailsController', electricalSchemaComponentDetailsController);

    /** @ngInject */
    function electricalSchemaComponentDetailsController(
        toastr,
        $translate,
        $q, $timeout, $log,
        CacheConstants,
        CacheService,
        $mdDialog, PDFViewService, printPdfModalService, configConstantes, FileSaver, RestUpgrade, SearchSpecializedToolConstants) {


        // VARIABLES

        var vm = this;

        // FUNCTIONS

        vm.closePopIn = closePopIn;
        vm.isImage = isImage;
        vm.isPDF = isPDF;
        vm.downloadPdf = downloadPdf;
        vm.printComponent = printComponent;
        vm.isPrintComponentEnable = JSON.parse(configConstantes.isPrintComponentEnable);
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        var pictoImage = {

            "RENAULT": { src: convertImgToBase64("/assets/images/renaultgroup.png", "RENAULT") },
            "TRIMAN": { src: convertImgToBase64("/assets/images/triman.png", "TRIMAN") },
            //"WIRINGDIAG": {}

        }

        this.$onInit = function () {
            angular.forEach(vm.componentDetailsList.WIRING_DIAGRAMS, function (componentGroup) {
                componentGroup.isImage = vm.isImage(componentGroup.location);
                componentGroup.isPDF = vm.isPDF(componentGroup.location);
                _.assign(componentGroup, { isWDCompOpen: false })

            });

        };

        function closePopIn() {

            var pdfDirective = angular.element(document.getElementsByTagName('electrical-schema-pdf'));
            pdfDirective.removeClass("doNotDisplayPdfFile");

            $mdDialog.hide();
            vm.isPopInActive = false;

            $timeout(function () {
                var scope = angular.element(document.getElementsByTagName('electrical-schema-pdf')).scope();
                if (scope && scope.$parent && scope.$parent.vm && scope.$parent.vm.wiringDiagram && scope.$parent.vm.wiringDiagram.isPDF) {
                    var currentLocation = scope.$parent.vm.wiringDiagram.location;
                    scope.$parent.vm.wiringDiagram.location = '';
                    $timeout(function () {
                        scope.$parent.vm.wiringDiagram.location = currentLocation;
                    });
                }
            });
        }

        function isPDF(src) {
            var urlWithoutParams = src.split('?')[0];
            return (urlWithoutParams.split('.').pop().toLowerCase() === 'pdf');
        }

        function isImage(src) {
            var urlWithoutParams = src.split('?')[0];
            var ext = ['jpeg', 'jpg', 'gif', 'png'];
            if (ext.indexOf(urlWithoutParams.split('.').pop().toLowerCase()) > -1) {
                return true;
            }
            return false;
        }

        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }

        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }

        function printComponent() {
            var residualData = null;
            if (vm.componentDetailsList.WIRING_DIAGRAMS.length == 1) {
                residualData = vm.componentDetailsList.WIRING_DIAGRAMS[0]
            } else {

                residualData = _.find(vm.componentDetailsList.WIRING_DIAGRAMS, function (item) {
                    return item.isWDCompOpen === true
                })
                if (_.isEmpty(residualData)) {
                    toastr.info($translate.instant("WIRING_COMPONENT_PDFMSG"));
                    return;
                }
            }
            $timeout(function () {
                downloadPdf(residualData).then(function (response) {
                    pdfMake.tableLayouts = {
                        otherTableLayout: {
                            hLineWidth: function () {
                                return 1;
                            },
                            vLineWidth: function () {
                                return 1;
                            },
                            keepWithHeaderRows: 1,
                            dontBreakRows: true
                        }
                    };
                    var pdfDocGenerator = pdfMake.createPdf(response.data);
                    pdfDocGenerator.getBuffer(function (buffer) {
                        var file = new Blob([(buffer)], { type: 'application/pdf' });
                        var isIE = false || !!document.documentMode;
                        var isEdge = !isIE && !!window.StyleMedia;

                        if (isIE || isEdge) {
                            var todaysDate = moment(new Date()).format('"YYYY/MM/DD"');
                            FileSaver.saveAs(file, todaysDate + '_' + $translate.instant('PDF_NAME') + '.pdf');
                        } else {

                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }
                                return printPdfModalService.showModal(modalParams);
                            }).then(function () {
                                closePopIn();
                            }).catch(function (error) {
                                closePopIn();
                            })
                        }

                    })

                });
            }, 100)
        }

        function downloadPdf(residualData) {
            var LabelObj = '';
            var tempContent = [];
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);

            if (!_.isEmpty(residualData.residual)) {
                for (var i = 0; i < residualData.residual.length; i++) {
                    if (residualData.residual) {
                        if (!_.isEmpty(residualData.residual[i].fixe)) {
                            residualData.residual[i].fixe.forEach(function (residualFixe) {
                                LabelObj = residualFixe.labelObj;
                                var tempcontent = "";
                                residualFixe.listCrit.forEach(function (crit) {
                                    tempcontent += crit.labelCrit + "(" + crit.codeCrit + ")" + ",";
                                })
                                tempContent.push({ "label": residualFixe.labelObj, "content": tempcontent })
                            })

                        }
                    }
                }
            }

            var printComponentDetails = {
                pdfHead: residualData.title,
                code: vm.componentCode,
                label: vm.componentLabel,
                residualContent: tempContent,
                vin: contextCarSearch.vehicle.vin,
                registrationNumber: contextCarSearch.vehicle.registrationNumber ? contextCarSearch.vehicle.registrationNumber : '',
                model: contextCarSearch.vehicle.model,
                motorisation: contextCarSearch.vehicle.motorisation,
                gearBoxType: contextCarSearch.vehicle.gearBoxType,
                color: contextCarSearch.vehicle.color,

            }
            return formatDatatoPrint(printComponentDetails, residualData);
        }

        function formatDatatoPrint(printComponentDetails, residualData) {
            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];

            var vehicleBanner = {
                type: "columns",
                values: {
                    0: [
                        printComponentDetails.model + "," +
                        printComponentDetails.motorisation + "," +
                        printComponentDetails.gearBoxType + 
                        (printComponentDetails.color ? "," + printComponentDetails.color : "")
                    ]
                },
                styles: "textStyle"
            };
            dataArray.push(vehicleBanner);

            if (printComponentDetails.vin) {
                dataArray.push({
                    type: "columns",
                    values: {
                        0: [
                            printComponentDetails.vin +
                            (printComponentDetails.registrationNumber ? " | " + printComponentDetails.registrationNumber : "")
                        ]
                    },
                    styles: "textStyle"
                });
            }



            var codeLabel = { type: "columns", values: { 0: [{ text: '\n' + $translate.instant('ELECTRICAL_SCHEMAS_COMPONENT_DETAILS') + " : " + printComponentDetails.code + "-" + printComponentDetails.label, bold: true }] }, styles: "textStyle1" };
            dataArray.push(codeLabel);

            var comApplicabilityHeader = { type: "columns", values: { 0: [{ text: '\n' + $translate.instant('CRITERIA') + " : " + '\n' + printComponentDetails.pdfHead, bold: true }] }, styles: "textStyle1" };
            dataArray.push(comApplicabilityHeader);

            printComponentDetails.residualContent.forEach(function (data, index) {
                data.content = data.content.replace(/,+$/, '');
                var isLastItem = index === printComponentDetails.residualContent.length - 1;
                var comApplicabilities = { type: "columns", values: { 0: [data.label + ' : ' + data.content] }, styles: isLastItem ? "textStyle3WithSpacing" : "textStyle3" };
                dataArray.push(comApplicabilities);

            })

            RestUpgrade.one(SearchSpecializedToolConstants.loadCdnFiles).withHttpConfig({
                responseType: 'text',
                transformResponse: function (data) {
                    return data;
                }
            }).get({ url: residualData.location })
                .then(function (response) {
                    if (!response || typeof response !== 'string' || response.trim() === '') {
                        return Promise.reject(new Error('Invalid response data'));
                    }
                    var image64 = "data:image/png;base64," + response;
                    return new Promise(function (resolve, reject) {
                        var img = new Image();
                        img.src = image64;
                        img.onload = function () {
                            var imgWidth = img.width;
                            var imageObj = {
                                type: 'componentImage',
                                values: image64,
                                width: imgWidth > 500 ? 500 : imgWidth
                            };
                            dataArray.push(imageObj);
                            resolve();
                        };
                        img.onerror = function (error) {
                            reject(error);
                        };
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    toastr.error($translate.instant('ERROR'));
                })
                .finally(function () {


                    var firstTable = [];
                    firstTable = residualData.pinsUse[0].list;

                    var filteredData = firstTable.map(function (item) {
                        var tableData = [];

                        tableData[$translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_PIN_CODE")] =
                        {
                            data: item.pinCode
                        };
                        tableData[$translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_WIRE_CROSS_SECTION")] =
                        {
                            data: item.wireCrossSection
                        };
                        tableData[$translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL")] =
                        {
                            data: item.signal
                        };
                        tableData[$translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_CONNECTOR_CODE")] =
                        {
                            data: item.connectorCode
                        };
                        tableData[$translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL_LABEL")] =
                        {
                            data: item.signalLabel
                        };

                        return tableData;
                    })

                    var tableValues = getTableData(filteredData, true);

                    tableValues[0].forEach(cell => {
                        cell.style = 'tableHeader';
                        cell.alignment = 'center';
                        cell.bold = true;
                    });
                    tableValues.slice(1).forEach(row => {
                        for (let colIndex = 0; colIndex <= 3; colIndex++) {
                            row[colIndex].alignment = 'center';
                        }
                    });

                    var secondObj = {};
                    secondObj = {
                        type: "componentTable", values: tableValues, styles: "tableStyle",
                        layout: "otherTableLayout", widths: [90, 90, 90, 90, 104],
                        unbreakable: true
                    };
                    dataArray.push(secondObj);

                    dataArray = PDFViewService.getProcessedDataArray(finalArr, dataArray, false, false, true, false);
                    var headerDefinition = !vm.nissanUserURL ? {
                        columns: [
                            {
                                image: pictoImage.RENAULT.value,
                                alignment: "left",
                                width: 50,
                                margin: [30, 10, 0, 10],
                            }
                        ]
                    } : '';
                    var docDefinition = {

                        info: {
                            title: $translate.instant("ELECTRICAL_SCHEMAS_COMPONENT_DETAILS")
                        }, header: headerDefinition,
                        footer: {
                            columns: [
                                {
                                    image: pictoImage.TRIMAN.value,
                                    margin: [10, 10, 0, 10],
                                    width: 25,
                                    bold: false
                                },
                                {
                                    type: 'none',
                                    text: moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                                    alignment: 'right',
                                    margin: [0, 0, 10, 0]
                                },

                            ]

                        },
                        content: [
                            finalArr
                        ],
                        styles: {
                            textStyle: {
                                margin: [0, 1, 0, 1],
                                alignment: "left",
                                fontSize: 11
                            },
                            header: {
                                margin: [0, 10, 10, 20],
                            },
                            textStyle1: {
                                margin: [0, 1, 0, 1],
                                alignment: "left",
                                fontSize: 10
                            },
                            tableStyle: {
                                margin: [0, 15, 0, 0],
                                border: [false, true, false, true]
                            },
                            textStyle3: {
                                margin: [0, 1, 0, 1],
                                alignment: "left",
                                fontSize: 9
                            },
                            textStyle3WithSpacing: {
                                margin: [0, 1, 0, 10],
                                alignment: "left",
                                fontSize: 9
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 10,
                                alignment: 'center',
                            },
                            tableTextStyle: {
                                fontSize: 9
                            }
                        }
                    };

                    deferred.resolve({
                        data: docDefinition
                    });
                });
            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix').controller('electricalSchemaCanFusibleDocResidualListController', electricalSchemaCanFusibleDocResidualListController);

    /** @ngInject */
    function electricalSchemaCanFusibleDocResidualListController(
        RoutesConstants,
        blockUI,
        toastr,
        $translate,
        $scope,
        CacheConstants,
        configConstantes,
        CacheService,
        $mdDialog) {


        // VARIABLES

        var vm = this;

        // FUNCTIONS

        vm.closePopIn = closePopIn;
        vm.openPdfFileInNewTab = openPdfFileInNewTab;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        function closePopIn() {

            var pdfDirective = angular.element(document.getElementsByTagName('electrical-schema-pdf'));
            pdfDirective.removeClass("doNotDisplayPdfFile");

            $mdDialog.hide();
            vm.isPopInActive = false;
        }

        function openPdfFileInNewTab(url) {
            return window.open(url);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('stNumberRange', stNumberRange);

    /** @ngInject */
    function stNumberRange($timeout) {
        return {
            restrict: 'E',
            require: '^stTable',
            scope: {
                diagFile: "=",
                column: "="
            },
            template: '<input type="number" ng-model="numericInput" onwheel="this.blur()" ng-change="onchange(numericInput)"/>',
            bindToController: true,
            controller: NumberRangeController,
            controllerAs: 'vm',
            link: function (scope, element, attr, table) {

                scope.onchange = function (item) {
                    var query = {};

                    if (item) {
                        query.numericInput = item;
                    }

                    $timeout(function () {
                        scope.$apply(function () {
                            table.search(query, scope.vm.column)
                        });
                    }, 0);
                };

            }
        };

        /* @ngInject */
        function NumberRangeController($scope) {

        };


    }

})();

(function () {
    angular
    .module('phenix').filter('stCustomFilter', function ($filter) {
        return function(array, expression) {
            return $filter('filter')(array, expression, function(actual, expected) {
                var numericInput = expected.numericInput;
                var selectedCheckboxes = expected.selectedCheckboxes;

                if (_.isObject(expected)) {
                    //number range
                    if (numericInput) {

                        if (actual === 'NA') {
                            return true;
                        }
                        if (actual < numericInput) {
                            return false;
                        }

                        return true;
                    } else if (selectedCheckboxes && !_.isEmpty(selectedCheckboxes)) {

                        return _.includes(selectedCheckboxes, actual)

                    }
                    return true;

                }
                return ('' + actual).toLowerCase().indexOf(('' + expected).toLowerCase()) > -1;
            });

            
        };
    })
})();

 (function () {
    'use strict';

    angular
        .module('phenix')
        .directive('stClearFilter', stClearFilter);

        /** @ngInject  **/
    function stClearFilter($timeout) {
        return {
            restrict: 'EA',
            require: '^stTable',
            link: function(scope, element, attrs, table) {
                return element.bind('click', function() {
                    $timeout(function () {
                    return scope.$apply(function() {
                    var tableState;
                    tableState = table.tableState();
                    tableState.search.predicateObject = {};
                    tableState.sort.predicate = scope.defaultSortColumn ? scope.defaultSortColumn.predicate : {};
                    tableState.sort.reverse = scope.defaultSortColumn ? scope.defaultSortColumn.reverse : {};
                    tableState.pagination.start = 0;
                    return table.pipe();
                    });
                }, 0);
                });
          
            }
          };

    }

})(); 
(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('stCheckBox', stCheckBox);

    /** @ngInject */
    function stCheckBox($timeout, $translate) {
        return {
            restrict: 'E',
            require: '^stTable',
            scope: {
                column: "=",
                diagFile: "=",
                displayArray: '=',
                defaultFilterValues: "="
            },
            templateUrl: 'app/components/car/searchByDiagnostic/stCustomFilter/stCheckBox.template.html',
            bindToController: true,
            controller: CheckBoxController,
            controllerAs: 'vm',
            link: function (scope, element, attr, table) {

                scope.onCheckBoxClick = function (item) {

                    if(_.has(item,'newData')){

                        var statusIDs = scope.vm.statusArray.indexOf(item.newData);

                        if(statusIDs > -1){
                            scope.vm.statusArray.splice(statusIDs,1);
                            //break;
                        }else{
                            scope.vm.statusArray.push(item.newData);
                            //break;
                        }
                        scope.vm.selStatus = scope.vm.statusArray.toString();

                    }
                   
                    var selectedIDs = scope.vm.filteredArray.indexOf(item.data);
                     // Is currently selected
                     if (selectedIDs > -1) {
                        scope.vm.filteredArray.splice(selectedIDs, 1);
                    }

                    // Is newly selected
                    else {
                        scope.vm.filteredArray.push(item.data);
                    }
                    scope.vm.checkSelected = scope.vm.filteredArray;
                    var checkboxes = document.getElementsByClassName(scope.vm.column);
                    angular.element(checkboxes).css('display', 'none');
                    scope.vm.expanded = false;

                    var query = {};

                    var updatedArray = (scope.vm.checkSelected && !_.isEmpty(scope.vm.checkSelected) 
                                        && scope.vm.defaultFilterValues && !_.isEmpty(scope.vm.defaultFilterValues))
                             ? _.concat(scope.vm.filteredArray,scope.vm.defaultFilterValues)
                             : scope.vm.filteredArray;

                    if (updatedArray && !_.isEmpty(updatedArray)) {
                            query.selectedCheckboxes = updatedArray;
                    }

                    $timeout(function () {
                        scope.$apply(function () {
                            table.search(query, scope.vm.column)
                        });
                    }, 0);
                }


            }
        };

        /* @ngInject */
        function CheckBoxController() {
            var vm = this;
            vm.expanded = false;
            vm.filteredArray = [];
            vm.statusArray = [];
            vm.selStatus = '';
            vm.showCheckboxes = showCheckboxes;

            function showCheckboxes() {
                var checkboxes = document.getElementsByClassName(vm.column);
                if (!vm.expanded) {
                    angular.element(checkboxes).css('display', 'block');
                    vm.expanded = true;
                } else {
                    angular.element(checkboxes).css('display', 'none');
                    vm.expanded = false;
                }
            }

        };


    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('selectAllCheckBox', selectAllCheckBox);

    /** @ngInject */
    function selectAllCheckBox($rootScope) {
        return {
            restrict: 'E',
            scope: {
                filterArray: "=",
                firstFilter: "=",
                secondFilter: "=",
                thirdFilter: "=",
                onExpandAll: "<",
                expandAll: "=",
                fullDataFilter: "=",
                expandAllEnable: "=",
            },
            templateUrl: 'app/components/car/searchByDiagnostic/stCustomFilter/selectAllCheckBox.template.html',
            bindToController: true,
            controller: SelectAllCheckBoxController,
            controllerAs: 'vm',
        };

        /* @ngInject */
        function SelectAllCheckBoxController(configConstantes) {
            var vm = this;

            //Variables

            //Functions
            vm.showCheckboxes = showCheckboxes;
            vm.onCheckBoxClick = onCheckBoxClick;
            vm.selectAllCheckBox = selectAllCheckBox;
            vm.unSelectAll = unSelectAll;
            vm.expandCollapse = expandCollapse;
            vm.selectOnInput = selectOnInput;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
            this.$onInit = function () {
                _.map(vm.filterArray, function(item){
                        _.assign(item, { expanded: false});
                })
            }

            function expandCollapse(expand){
                if(expand){
                    vm.firstFilter = [];
                    vm.secondFilter = [];
                    vm.thirdFilter = [];
                }
                vm.onExpandAll(expand);
            }

            function showCheckboxes(key,isExpanded, index) {
                var tableElement = document.getElementsByClassName('filterTable')[0];
                var checkboxes = tableElement.getElementsByClassName(key);
                
                if (!isExpanded) { 
                    closeAllDropdowns();  
                    angular.element(checkboxes).css('display', 'block');
                } else {
                    angular.element(checkboxes).css('display', 'none');
                }
                vm.filterArray[index].expanded = !isExpanded;
            }
            function closeAllDropdowns(){
                vm.filterArray.forEach(function(item){
                    if(item.checkBox){
                        var tableElement = document.getElementsByClassName('filterTable')[0];
                        var checkboxes = tableElement.getElementsByClassName(item.key);
                        angular.element(checkboxes).css('display', 'none');
                    }
                    item.expanded = false;
                })
            }
            
            function selectAllCheckBox(detailedData) {
                var selKey = detailedData.key;
                var custom = detailedData.hasOwnProperty('custom') ? detailedData.custom : '';
                var isSelectAll = detailedData.selectAll;
                if(detailedData.hasOwnProperty('filterData') && detailedData.filterData){
                    vm.fullDataFilter = createObject(vm.fullDataFilter,selKey,custom);
                    vm.fullDataFilter = mapSelectAllObjects(vm.fullDataFilter,selKey,isSelectAll);
                }else{
                    if (selKey.includes(".")) {
                        var splittedKeys = selKey.split(".");
                        if(splittedKeys.length === 2){
                            vm.secondFilter = createObject(vm.secondFilter,_.last(splittedKeys),custom);
                            vm.secondFilter = mapSelectAllObjects(vm.secondFilter,selKey,isSelectAll);
                        }else{
                            vm.thirdFilter = createObject(vm.thirdFilter,_.last(splittedKeys),custom);
                            vm.thirdFilter = mapSelectAllObjects(vm.thirdFilter,selKey,isSelectAll);
                        }
                    } else {
                        vm.firstFilter = createObject(vm.firstFilter,selKey,custom);
                        vm.firstFilter = mapSelectAllObjects(vm.firstFilter,selKey,isSelectAll);
                    }
        
                }

                
            }

            function mapSelectAllObjects(object,key,isSelectAll){

                var fullKey = key;
                var selKey;

                if (key.includes(".")) {
                    var splittedKeys = key.split(".");
                    selKey = _.last(splittedKeys);
                }else{
                    selKey = key;
                }

                _.map(vm.filterArray, function (item) {
        
                    if (_.isEqual(item.key, fullKey)) {

                        _.map(object, function (filters) {

                            if (filters[selKey]) {
                                filters[selKey] = [];

                                item.values.forEach(function (obj) {

                                    if (isSelectAll) {
                                        filters[selKey].push(obj.data);
                                    } else {
                                        filters[selKey] = [];
                                    }

                                    obj.selected = isSelectAll;

                                })
                            }

                        })

                    }

                })

                selectedData(selKey);

                return object;
            }

            function unSelectAll(selKey, selData) {

                _.map(vm.filterArray, function (item) {

                    var splittedKeys;

                    if (item.key.includes(".")) {
                        splittedKeys = _.last(item.key.split("."));
                    }else{
                        splittedKeys = item.key;
                    }
    
                    if (_.isEqual(splittedKeys, selKey)) {
    
                        if (item.values.length === selData.length) {
                            item.selectAll = true;
                        } else {
                            item.selectAll = false;
                        }
    
                    }
    
                })

                selectedData(selKey);
    
            }
            function selectOnInput(){
                closeAllDropdowns();                
            }
            function onCheckBoxClick(detailedData, selValue, isCheckBox) {
                var selKey = detailedData.key;
                var custom = detailedData.hasOwnProperty('custom') ? detailedData.custom : '';
                if(detailedData.hasOwnProperty('filterData') && detailedData.filterData){
                    if(selKey.includes(",")) {
                        var splittedKeys = selKey.split(",")
                        splittedKeys.forEach(function(key){
                        vm.fullDataFilter = createObject(vm.fullDataFilter,key,"",splittedKeys);
                        vm.fullDataFilter = mapCheckedObjects(vm.fullDataFilter,key,selValue,isCheckBox);
                        })
                    }
                    else {
                    vm.fullDataFilter = createObject(vm.fullDataFilter,selKey);
                    vm.fullDataFilter = mapCheckedObjects(vm.fullDataFilter,selKey,selValue,isCheckBox);
                    }
                }else{
                    if(selKey.includes(",")) {
                        var splittedKeys = selKey.split(",")
                        splittedKeys.forEach(function (key) {
                            if (key.includes(".")) {
                                var newSplitKeys = key.split(".");
                                if(newSplitKeys.length === 2){
                                    vm.secondFilter = createObject(vm.secondFilter,_.last(newSplitKeys),custom, splittedKeys);
                                    vm.secondFilter = mapCheckedObjects(vm.secondFilter,_.last(newSplitKeys),selValue,isCheckBox);
                                }else{
                                    vm.thirdFilter = createObject(vm.thirdFilter,_.last(newSplitKeys),custom, splittedKeys);
                                    vm.thirdFilter = mapCheckedObjects(vm.thirdFilter,_.last(newSplitKeys),selValue,isCheckBox);
                                }
                            }
                            else{
                                vm.firstFilter = createObject(vm.firstFilter, key, custom, splittedKeys);
                                vm.firstFilter = mapCheckedObjects(vm.firstFilter, key, selValue, isCheckBox);
                            }
                        })
                    } else {
                        if (selKey.includes(".")) {
                            var splittedKeys = selKey.split(".");
                            if(splittedKeys.length === 2){
                                vm.secondFilter = createObject(vm.secondFilter,_.last(splittedKeys),custom);
                                vm.secondFilter = mapCheckedObjects(vm.secondFilter,_.last(splittedKeys),selValue,isCheckBox);
                            }else{
                                vm.thirdFilter = createObject(vm.thirdFilter,_.last(splittedKeys),custom);
                                vm.thirdFilter = mapCheckedObjects(vm.thirdFilter,_.last(splittedKeys),selValue,isCheckBox);
                            }
                        }
                        else{
                            vm.firstFilter = createObject(vm.firstFilter,selKey,custom);
                            vm.firstFilter = mapCheckedObjects(vm.firstFilter,selKey,selValue,isCheckBox);
                        }
        
                    }
                }
                
            }

            function selectedData(key){

                var arr = [];

                _.map(vm.filterArray, function(item){
                    var splittedKeys;
                    if (item.key.includes(".")) {
                        splittedKeys = _.last(item.key.split("."));
                    }else{
                        splittedKeys = item.key;
                    }
                    if(splittedKeys === key){
                        _.map(item.values, function(obj){
                            if(obj.selected){
                                if(item.hasOwnProperty('custom') && item.custom === 'class'){
                                    arr.push(obj.displayData);
                                }
                                else if(item.hasOwnProperty('custom') && item.custom === 'json'){
                                    arr.push(obj.json);
                                }
                                else{
                                    arr.push(obj.data);
                                }
                            }
                            
                        });
    
                        _.assign(item, {selectedValues : arr.toString()})
                    }
                    
                })

                
            }

            function mapCheckedObjects(object,key,value,isCheckBox){
                _.map(object, function (item) {
                    
                    if (item[key]) {
                        if(isCheckBox){
                            var selID = item[key].indexOf(value);
                            if (selID > -1) {
                                item[key].splice(selID, 1);
                            } else {
                                item[key].push(value);
                            }
                            item['isCheck'] = isCheckBox;
                            unSelectAll(key, item[key]);
                        }else{
                            if((typeof value === 'number' && !_.isNaN(value)) || !_.isEmpty(value)){
                                if ((typeof item[key] === 'number' && !_.isNaN(item[key])) || _.isEmpty(item[key])) {
                                    item[key].push(value);
                                } else {
                                    item[key].splice(0, 1, value);
                                }
                            }else{
                                item[key] = [];
                            }
                            
    
                            item['isCheck'] = isCheckBox;
                        }
                        
                    }
                })
                selectedData(key);
                return object;
            }

            function createObject(object,key,custom,splittedKeys){

                if (!object || _.isEmpty(object)) {
                    var data = {};
                    data[key] = [];
                    data['isCheck'] = true;
                    
                    if(splittedKeys && !_.isEmpty(splittedKeys)){
                        data['isMultipleKeys'] = splittedKeys;
                    }
                    if(custom && !_.isEmpty(custom)){
                        data['custom'] = custom;
                    }
                    object.push(data);
                } else {

                    var isProp = [];

                    isProp = _.filter(object, function (item) {

                        return item.hasOwnProperty(key);

                    });

                    if (_.isEmpty(isProp)) {
                        var data = {};
                        data[key] = [];
                        data['isCheck'] = true;
                        if(splittedKeys && !_.isEmpty(splittedKeys)){
                            data['isMultipleKeys'] = splittedKeys;
                        }
                        if(custom && !_.isEmpty(custom)){
                            data['custom'] = custom;
                        }
                        object.push(data);
                    }
                }

                return object;
            }

        };


    }

})();

(function () {
    angular.module('phenix')
    .directive('paginationControl', [function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/car/searchByDiagnostic/stCustomFilter/pagination.template.html',
            controller: ['$scope', PaginationController],
            scope: {
                dataperPage: '=',
                pageChange: '&',
                currentPage: "=",
                totalCount: "=",
                isSolution: "=",
                loadPagination: "=",
                isLastPage: "="
            },
            link: function(scope) {
                scope.$watch('currentPage', function() {
                    scope.setPage(false,scope.currentPage);
                });
                scope.$watch('loadPagination', function() {
                    scope.setNextPage();
                });
              }
        };
    }]);

    function PaginationController($scope) {

        $scope.setPage = function (disable,currentPage) {
            if(!disable){                
                $scope.nextPage = ($scope.totalCount < $scope.dataperPage && $scope.totalCount > 0) ? ((($scope.currentPage - 1) * $scope.dataperPage) + $scope.totalCount) : ($scope.currentPage * $scope.dataperPage);
                $scope.pageChange({page:currentPage});
            }
        };

        $scope.setNextPage = function(){
            $scope.nextPage = ($scope.totalCount < $scope.dataperPage && $scope.totalCount > 0) ? ((($scope.currentPage - 1) * $scope.dataperPage) + $scope.totalCount) : ($scope.currentPage * $scope.dataperPage);
        }

        $scope.setPage(false,$scope.currentPage);

    }    
})();
(function () {
    angular
        .module('phenix').filter('customNestedFilter', function () {
            return function (array, filterParams) {

                if (array && !_.isEmpty(array) && filterParams && !_.isEmpty(filterParams)) {

                    var val = array.filter(function (item) {

                        var selected = false;

                        for (var i = 0; i < filterParams.length; i++) {

                            var obj = filterParams[i];

                            if (obj.isCheck) {

                                var key = '';
                                var value = '';
                                var customFilter = '';

                                _.forIn(obj, function (v, k) {
                                    if (k !== 'isCheck' && k !== 'custom') {
                                        key = k;
                                        value = v;
                                    }

                                    if(k === 'custom'){
                                        customFilter = v;
                                    }
                                })


                                if (_.isEmpty(value)) {
                                    selected = true;
                                } else if(customFilter && !_.isEmpty(customFilter) && customFilter === 'substring'){
                                    selected = _.includes(value, _.get(item, key).substring(0, 3));
                                } else {
                                    selected = _.includes(value, _.get(item, key));
                                }

                                if (!selected) {
                                    break;
                                }

                            } else {

                                var key = '';
                                var value = '';
                                var customFilter = '';
                                var isMultipleKeys = [];
                                
                                _.forIn(obj, function (v, k) {
                                    if (k !== 'isCheck' && k !== 'custom' && k !== 'isMultipleKeys') {
                                        key = k;
                                        value = v;
                                    }

                                    if(k === 'custom'){
                                        customFilter = v;
                                    }
                                    if(k === 'isMultipleKeys'){
                                        isMultipleKeys = v;
                                    }
                                })

                                if(customFilter && !_.isEmpty(customFilter) && customFilter === 'numeric'){

                                    if(_.isEmpty(value) || _.get(item, key) === 'NA' || parseInt(_.get(item, key)) >= parseInt(value)){
                                        selected = true;
                                    }else{
                                        selected = false;
                                    }
                                }else{
                                    if (_.isEmpty(value)) {
                                        selected = true;
                                    } else {
                                        if (isMultipleKeys && !_.isEmpty(isMultipleKeys)) {
                                            var selectedKey = [];
                                            for (var j = 0; j < isMultipleKeys.length; j++) {
                                                var isMultipleKeysCheck = _.get(item, isMultipleKeys[j].includes(".") ? _.last(isMultipleKeys[j].split(".")) : isMultipleKeys[j]);
                                                selectedKey.push(_.includes((isMultipleKeysCheck ? isMultipleKeysCheck.toString().toLowerCase() : ""), value.toString().toLowerCase()));
                                            }

                                            selected = _.includes(selectedKey,true) ? true : false;
                                        }
                                        else {
                                            var code = _.get(item, key);
                                            code = code ? (code.substr(0, 3) == 'DTC' ? code.substr(3) : code) : '';
                                            selected = _.includes(code.toString().toLowerCase(), value.toString().toLowerCase());
                                        }
                                    }
                                }

                                

                                if (!selected) {
                                    break;
                                }

                            }

                        }

                        return selected;
                    })

                    return val;

                }

                return array;




            }
        });
}
)();

(function() {
    'use strict';

    angular
        .module('phenix')
        .service('CustomFilterSortService', CustomFilterSortService);

    /* @ngInject */
    function CustomFilterSortService($filter,DiagFileDetailsNewConstants,$translate,$http) {

        var vm = this;

        //Functions
        vm.clearSort = clearSort;
        vm.getDropdownArray =getDropdownArray;
        vm.getFilterItems = getFilterItems;


        function clearSort(className,defaultSortField){

            var removeSort = angular.element(document.querySelector('.'+className));
            var sortAscent = 'st-sort-ascent';
            var sortDescent = 'st-sort-descent';
            Array.from(removeSort[0].children).forEach(function (it) {
                if (it.tagName.toLowerCase() === 'thead') {
                    Array.from(it.children).forEach(function (trItem) {
                        if (trItem.tagName.toLowerCase() === 'tr') {
                            Array.from(trItem.children).forEach(function (thItem) {
                                if (thItem.tagName.toLowerCase() === 'th') {
                                    if (_.includes(thItem.firstElementChild.classList, 'sortable')) {
                                        var elem = angular.element(thItem.firstElementChild);
                                        if (!defaultSortField || (defaultSortField && thItem.firstElementChild.id !== defaultSortField)) {
                                            $(elem).removeClass(sortAscent);
                                            $(elem).removeClass(sortDescent);
                                        } else if(defaultSortField === 'ecuLabel') {
                                            $(elem).removeClass(sortDescent);
                                            $(elem).addClass(sortAscent);
                                        } else {
                                            $(elem).removeClass(sortAscent);
                                            $(elem).addClass(sortDescent);
                                        }
                                    }


                                }
                            })
                        }
                    })
                }
            })

        }

        /**
         * to form the data in the filter dropdown
         * @param {Object} object //to be in some format
         */
        function getDropdownArray(object,list) {

            var displayArray = [];

            var displayData = [];

            var uniqueElements = $filter('unique')(list, object.column);

            uniqueElements.forEach(function (item) {
                displayData.push(item[object.column]);
                if(object.addColumn){
                    object.values[item[object.column]] ? object.values[item[object.column]].push(item[object.addColumn]) : '';
                }
            })
            displayData = displayData.sort().reverse();

            displayData.forEach(function (it) {

                if(!object.addColumn && it){
                    var label = $translate.instant('COMMON_'+it);
                    object.values[it].push(label);
                }
                displayArray.push({
                    data: it,
                    class: object.values && object.values[it] ? object.values[it][0] : '',
                    newData: object.values && object.values[it] ? object.values[it][1] : ''
                })
            })

            return displayArray;
        }

        function getFilterItems(fullData,dataToFilter,visibility,filterArray,systemFilter){
            var visibleData = _.filter(fullData, function (item) {
                return item[visibility];
            })

            var hiddenData = _.filter(fullData, function (item) {
                return !item[visibility];
            })

            if (systemFilter && fullData && fullData.systemDocExpanded) {
                var visibleData = fullData;
                var hiddenData = [];
            }
            if(visibleData && !_.isEmpty(visibleData)){
                filterArray = addFilterData(fullData,dataToFilter,visibleData,hiddenData,filterArray);
            }else{
                _.map(filterArray,function(item){
                    if(!item.filterData){
                        item.values = [];
                        item.selectAll = false;
                        item.selectedValues = "";
                    }
                    

                })

            }

            return filterArray;
        }

        function addFilterData(fullData,dataToFilter,selData,toBeDeletedData,filterArray){

            if(selData && !_.isEmpty(selData)){

            _.map(filterArray, function (emptyArray) {

                var dataToDel = [];
                var uniqueElements = [];
                var uniqueElementstoDel = [];
                var classData = [];
                if (emptyArray.hasOwnProperty('filterData') && emptyArray.filterData) {
                    if (emptyArray.key.includes(",")) {
                        var splitKeys = emptyArray.key.split(",")
                        splitKeys.forEach(function (key) {
                            var uniqueArray = $filter('unique')(fullData, key);
                            _.map(uniqueArray, function (obj) {
                                uniqueElements.push(obj[key]);
                            })
                        })
                    }
                    else {
                        var uniqueArray = $filter('unique')(fullData, emptyArray.key);
                        _.map(uniqueArray, function (obj) {
                            uniqueElements.push(obj[emptyArray.key]);
                        })
                    }
                }else{
                   
                    if (emptyArray.key.includes(",")) {
                        var splitKeys = emptyArray.key.split(",")
                        var uniqueElementsNew, uniqueElementstoDelNew;
                        splitKeys.forEach(function (key) {
                            if(key.includes(".")){
                                var splitNewKeys = key.split(".");
                                uniqueElementsNew = nestedObjectToArray(selData,dataToFilter,splitNewKeys);
                                uniqueElementstoDelNew = nestedObjectToArray(toBeDeletedData,dataToFilter,splitNewKeys);
                            }
                            else{
                                 uniqueElementsNew = objectToArray(selData, dataToFilter, key);
                                 uniqueElementstoDelNew = objectToArray(toBeDeletedData, dataToFilter, key);                                
                            }

                            uniqueElementsNew.forEach(function (item) {
                                uniqueElements.push(item);
                            })
                            uniqueElementstoDelNew.forEach(function (item) {
                                uniqueElementstoDel.push(item);
                            })
                            
                        })
                        classData = getClassData(selData, dataToFilter, uniqueElements, emptyArray);
                    } else {
                        if (emptyArray.key.includes(".")) {

                            var splitKeys = emptyArray.key.split(".");
        
                             uniqueElements = nestedObjectToArray(selData,dataToFilter,splitKeys);
                             uniqueElementstoDel = nestedObjectToArray(toBeDeletedData,dataToFilter,splitKeys);
                        }
                        else {
                         uniqueElements = objectToArray(selData,dataToFilter,emptyArray.key);
                         uniqueElementstoDel = objectToArray(toBeDeletedData,dataToFilter,emptyArray.key);
                         classData = getClassData(selData,dataToFilter,uniqueElements,emptyArray);
                        }
                    }
                }
                

                    dataToDel = _.filter(uniqueElementstoDel,function(obj){
                         return !_.includes(uniqueElements,obj);
                            
                    })

                    dataToDel.forEach(function (item) {

                        var idx = _.findIndex(emptyArray.values,{data:item});

                        if(idx > -1){
                            emptyArray.values.splice(idx,1);
                        }
                        
                    })

                    uniqueElements.forEach(function (item) {

                        var dataFound = _.find(emptyArray.values,{data:item});

                        if(!dataFound){
                            if(emptyArray.hasOwnProperty('custom')){

                                if(emptyArray.custom === 'class'){
                                    var displayClassData = '';
                                     _.forIn(classData,function(value,key){
                                        if(key === item){
                                          displayClassData = value;
                                        }
                                    });

                                    emptyArray.values.push(
                                        {
                                            data: item,
                                            selected: false,
                                            class: (DiagFileDetailsNewConstants.filter12Data[item] && DiagFileDetailsNewConstants.filter12Data[item][0]) || null,
                                            displayData: displayClassData
                                        }
                                    );
                                }else if(emptyArray.custom === 'substring'){

                                    var selID = _.findIndex(emptyArray.values,{'data':item.substring(0,emptyArray.noOfChar)});
                                    if(selID < 0){
                                        emptyArray.values.push(
                                            {
                                                data: item.substring(0,emptyArray.noOfChar),
                                                selected: false
                                            }
                                        );
                                    }
                                    
                                }
                                else if(emptyArray.custom === 'json'){
                                    return $http.get('../../app/components/car/searchByDiagnostic/DiagnosticNvPreparation/diagNvPreparation.json').then(function (response){
                                        return response.data;
                                    }).then( function(response){
                                        var filteredItem;
                                    _.forIn(response,function(value, key){
                                        if(key === item){
                                            filteredItem = value;
                                        }
                                    });
                                    emptyArray.values.push(
                                        {
                                            data: item,
                                            selected: false,
                                            json: filteredItem
                                        }
                                    );
                                    
                                });
                                }
                                else{
                                    emptyArray.values.push(
                                        {
                                            data: item,
                                            selected: false
                                        }
                                    );
                                }
                                    
                            }else{
                                emptyArray.values.push(
                                    {
                                        data: item,
                                        selected: false
                                    }
                                );
                            }
                            
                        }
                        
                    })

            })
        }

                return filterArray;

        }

        function objectToArray(array,key,subKey){

            var arr = [];
            var expArr = [];

            _.map(array, function (item) {

                if (!arr || _.isEmpty(arr)) {
                    arr = item[key];
                } else {
                    arr = (item[key] && !_.isEmpty(item[key])) ? arr.concat(item[key]) : arr;
                }
            })

            var uniqueElements = $filter('unique')(arr, subKey);
            _.map(uniqueElements,function(obj){
                expArr.push(obj[subKey]);
            })
                   
            return expArr;

        }

        function nestedObjectToArray(array,key,splitKeys){

            var arr = [];
            var expArr = [];
            var tempArr = [];

            _.map(array, function (item) {

                _.map(item[key], function (it) {

                    for(var i =0; i< splitKeys.length;i++){

                        if(i !== splitKeys.length -1 && i === 0){

                            var data = it[splitKeys[i]];

                            if (_.isArray(data)) {
        
                                if (!tempArr || _.isEmpty(tempArr)) {
                                    tempArr = data;
                                } else {
                                    tempArr = (data && !_.isEmpty(data)) ?  tempArr.concat(data) : tempArr;
                                }
                            }

                        }else if(i !== splitKeys.length -1){

                            var temp = [];

                            _.map(tempArr, function(obj){

                                var tempData = obj[splitKeys[i]]; 

                                if (_.isArray(tempData)) {
        
                                    if (!temp || _.isEmpty(temp)) {
                                        temp = tempData;
                                    } else {
                                        temp = (tempData && !_.isEmpty(tempData)) ?  temp.concat(tempData) : temp;
                                    }
                                }
                            })
                        }else if(i === splitKeys.length -1){

                            temp = splitKeys.length === 2 ? tempArr : temp;

                            _.map(temp, function(obj){

                                var tempData = obj[splitKeys[i]]; 

                                if (_.isArray(tempData)) {
        
                                    if (!arr || _.isEmpty(arr)) {
                                        arr = tempData;
                                    } else {
                                        arr = (tempData && !_.isEmpty(tempData)) ?  arr.concat(tempData) : arr;
                                    }
                                }else{

                                    var val = {};
                                    val[splitKeys[i]] = tempData;

                                    if (!arr || _.isEmpty(arr)) {
                                        arr.push(val)
                                    } else {
                                        arr = (tempData && !_.isEmpty(tempData)) ?  arr.concat(val) : arr;
                                    }
                                    
                                }
                            })
                        }

                        
                    }

                    // var data = it[_.head(splitKeys)];

                    // if (_.isArray(data)) {

                    //     if (!arr || _.isEmpty(arr)) {
                    //         arr = data;
                    //     } else {
                    //         arr = (data && !_.isEmpty(data)) ?  arr.concat(data) : arr;
                    //     }
                    // }

                })
            })

            var uniqueElements = $filter('unique')(arr, _.last(splitKeys));
            _.map(uniqueElements,function(obj){
                expArr.push(obj[_.last(splitKeys)]);
            })

            return expArr;

        }

        function getClassData(selData,key,uniqueElements,emptyArray){

            var classData = {};

            if(emptyArray.hasOwnProperty('custom') && emptyArray.custom === 'class'){

                var arr = {};

                _.map(selData, function (item) {

                    if (!arr || _.isEmpty(arr)) {
                        arr = item[key];
                    } else {
                        arr = (item[key] && !_.isEmpty(item[key])) ? arr.concat(item[key]) : arr;
                    }
                })

                _.map(uniqueElements, function(item){

                        _.map(arr, function(obj){
                            if(obj[emptyArray.key] === item && _.findIndex(classData,{item:obj[emptyArray.classKey]}) < 0){
                                classData[item] = obj[emptyArray.classKey];
                            }
                        })

                })
            }

            return classData;

        }

    }
    })();
(function () {
    angular
    .module('phenix').filter('customDateTime', function () {

        return function (value) {
            var date = '';
            if(value && !_.isEmpty(value)){
                date = moment(value, ['DD/MM/YYYY HH:mm:ss', 'ddd MMM DD HH:mm:ss UTC YYYY', 'YYYY-MM-DD HH:mm:ss']).format("DD/MM/YYYY HH:mm");
            }
            
            return date;
        }


    })
})();
/**
 * system documentation
 * @namespace Components
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('systemDoc', {
            bindings: {
                data: '=',
                selectedSystemDoc: '='
            },
            controller: systemDocController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchByDiagnostic/SystemDocumentation/systemDocumentation.template.html',

        }).controller('systemDocController', systemDocController);

    /* @inject */
    function systemDocController(ResultSearchByDiagnosticMetierService, blockUI, toastr, DocumentsMetierService, $state,
        CacheService, CustomFilterSortService, RoutesConstants, CacheConstants, systemDocumentationConstants,
        $scope, $q, $translate, $mdDialog,DiagFileDetailsNewConstants, RestUpgrade,configConstantes) {

        var vm = this;
        vm.systemTab = false;
        vm.elementTab = false;
        vm.dtcTab = false;
        vm.elementTabEnabled = false;
        vm.systemTabEnabled=false
        vm.dtcTabEabled = false
        vm.firstFilterElement = [];
        vm.firstFilterSystem = [];
        vm.firstFilterDtc = [];
        vm.fullDataFilterElement = [];
        vm.fullDataFilterDtc= [];
        vm.expandAllElement = false;
        vm.expandAllDtc = false;
        vm.typeMD = CacheService.getCarContext().typeMD;
        vm.mdList = [];
        vm.filterLoader = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        vm.filterArraySystem = [
            {label:'MD / '+$translate.instant('ALERTS_DESCRIPTION'), key:'ref,designation', values: [], selectAll:false,checkBox:false,filterData:false},
            {label:'DOCUMENT_MD_TYPE', key:'type', values: [], selectAll:false,checkBox:true,filterData:false},
        ]

        if (vm.typeMD === "ADT") {
            vm.filterArrayElement = [
                { label: 'MD / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'contributor,longLabel', values: [], selectAll: false, checkBox: false, filterData: true },
                { label: 'ECU', key: 'ecuDomain', values: [], selectAll: false, checkBox: true, filterData: true },
                { label: 'DOCUMENT_MD_TYPE', key: 'type', values: [], selectAll: false, checkBox: true, filterData: false }
            ]
            vm.filterArrayDtc = [
                { label: 'DTC / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'dtcNumber,dtcLabel', values: [], selectAll: false, checkBox: false, filterData: true },
                { label: 'MD / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'ref,designation', values: [], selectAll: false, checkBox: false, filterData: false },
                { label: 'ECU', key: 'ecuDomain', values: [], selectAll: false, checkBox: true, filterData: true, class: "width15margin", valuesStyle: "width9margin" },
                { label: 'DTC_CATEGORY', key: 'priorityClass', values: [], selectAll: false, checkBox: true, filterData: true },
                { label: 'DOCUMENT_MD_TYPE', key: 'type', values: [], selectAll: false, checkBox: true, filterData: false }
            ]
        } else if (vm.typeMD === "B3") {
            vm.filterArrayElement = [
                { label: 'MD / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'contributor,longLabel', values: [], selectAll: false, checkBox: false, filterData: true },
                { label: 'DOCUMENT_MD_TYPE', key: 'type', values: [], selectAll: false, checkBox: true, filterData: false }
            ]
            vm.filterArrayDtc = [
                { label: 'DTC / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'dtcNumber,dtcLabel', values: [], selectAll: false, checkBox: false, filterData: true },
                { label: 'MD / '+$translate.instant('ALERTS_DESCRIPTION'), key: 'ref,designation', values: [], selectAll: false, checkBox: false, filterData: false },
                { label: 'DOCUMENT_MD_TYPE', key: 'type', values: [], selectAll: false, checkBox: true, filterData: false }

            ]
        }

        vm.systemDocExpanded = systemDocExpanded;
        vm.displayMdDetails = displayMdDetails;
        vm.showElement = showElement;
        vm.showDtc = showDtc;
        vm.showSystemFunction = showSystemFunction;
        vm.elementsDocExpanded = elementsDocExpanded;
        vm.dtcDocExpanded = dtcDocExpanded;
        vm.getMDDocumentsList = getMDDocumentsList;
        vm.checkElementAndDtcTab = checkElementAndDtcTab;
        vm.onExpandAllElement = onExpandAllElement;
        vm.onExpandAllDtc = onExpandAllDtc;
        vm.getMDDocument = getMDDocuments;
        vm.getMDDocumentsIdList = getMDDocumentsIdList;
        vm.goToElement = goToElement;
        vm.goToDtc = goToDtc;
        vm.getSystemDocumentationFilter = getSystemDocumentationFilter;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            vm.typeMD = CacheService.getCarContext().typeMD;

            vm.systemDocResponse = vm.data;
            if(vm.systemDocResponse.systems && vm.systemDocResponse.systems.length > 0){
                _.map(vm.systemDocResponse.systems, function (item) {
                    _.extend(item, { systemDocExpanded: false })
                })
                if(vm.typeMD !== 'B3')
                {
                     vm.systemTabEnabled=true;
                      vm.systemTab = true;
                     }
                else if(vm.typeMD === 'B3')
                 {  if(vm.selectedSystemDoc.system.substr(-3) === '000')
                         {
                               vm.systemTabEnabled=true;
                                 vm.systemTab = true;
                         }else
                         {
                          vm.elementTab = true;
                            }
                        }
            }
            else{
                vm.systemTab = false;
            }
        };

        $scope.$watch('vm.selectedSystemDoc', function () {

            _.map(vm.filterArraySystem, function (item) {
                item.selectedValues = "";
                item.values = [];
            })
            if (vm.typeMD === "B3" || vm.typeMD === "ADT") {
                if (vm.dtcTab) {
                    if (!_.has(vm.selectedSystemDoc,'hasDTCMdDoc') || (_.has(vm.selectedSystemDoc,'hasDTCMdDoc') && !vm.selectedSystemDoc.hasDTCMdDoc)){
                        getMDDocumentsIdList(1);
                    }
                    else{
                        showDtc();
                    }

                }
                else if (vm.elementTab) {
                    if (!_.has(vm.selectedSystemDoc,'hasElementMdDoc') || (_.has(vm.selectedSystemDoc,'hasElementMdDoc') && !vm.selectedSystemDoc.hasElementMdDoc)){
                        getMDDocumentsIdList(0);
                    }
                    else{
                        showElement();
                    }
                }
            }
            
            checkElementAndDtcTab();
        })

        function goToElement() {
            if (!vm.selectedSystemDoc.hasElementMdDoc) {
                getMDDocumentsIdList(0);
            }
            else {
                showElement();
            }
        }

        function goToDtc() {

            if (!vm.selectedSystemDoc.hasDTCMdDoc) {
                getMDDocumentsIdList(1);
            }
            else {
                showDtc();
            }
        }

        function onExpandAllElement(expandAllElement) {
            if (!expandAllElement && vm.selectedSystemDoc.contributors) {
                vm.selectedSystemDoc.contributors.forEach(function (element) {
                    element.elementExpanded = false;
                })
            } else {
                vm.selectedSystemDoc.contributors.forEach(function (element) {
                    element.elementExpanded = true;
                })
            }
            if (vm.selectedSystemDoc && vm.selectedSystemDoc.contributors && !_.isEmpty(vm.selectedSystemDoc.contributors)) {
                var promiseArray = _.map(vm.selectedSystemDoc.contributors, function (element) {
                    elementsDocExpanded(element,true)
                })
                $q.all(promiseArray).then(function(){
                    var payload = {
                        fullData: vm.selectedSystemDoc.contributors,
                        dataToFilter: 'mdDocuments',
                        visibility:'elementExpanded',
                        filterArray: vm.filterArrayElement,
                        systemFilter: ''
                    }
                    return getSystemDocumentationFilter(payload).then(function (data) {
                        vm.filterArrayElement = data;
                        return;
                    });
                })
                
            }
            vm.expandAllElement = !vm.expandAllElement
        }

        function onExpandAllDtc() {
            if(!vm.expandAllDtc && vm.selectedSystemDoc.dtcs){
                vm.selectedSystemDoc.dtcs.forEach(function(dtc){
                    dtc.dtcExpanded = false;
                })
            }
            else{
                vm.selectedSystemDoc.dtcs.forEach(function(dtc){
                    dtc.dtcExpanded = true;
                })
            }
            if (vm.selectedSystemDoc && vm.selectedSystemDoc.dtcs && !_.isEmpty(vm.selectedSystemDoc.dtcs)) {
                var promiseArray = _.map(vm.selectedSystemDoc.dtcs, function (dtc) {
                    dtcDocExpanded(dtc,true)
                })
                $q.all(promiseArray).then(function(){
                    var payload = {
                        fullData: vm.selectedSystemDoc.dtcs,
                        dataToFilter: 'mdDocuments',
                        visibility:'dtcExpanded',
                        filterArray: vm.filterArrayDtc,
                        systemFilter: ''
                    }
                    return getSystemDocumentationFilter(payload).then(function (data) {
                        vm.filterArrayDtc = data;
                        return;
                    });
                })
            }
            vm.expandAllDtc = !vm.expandAllDtc;
        }

        function checkElementAndDtcTab(){
            if (vm.systemDocResponse && vm.systemDocResponse.systems) {
                _.find(vm.systemDocResponse.systems, function (item) {
                    if (item.system === vm.selectedSystemDoc.system) {
                        if (item.contributors && item.contributors.length > 0) {
                            vm.elementTabEnabled = true;
                        }
                        else {
                            vm.elementTabEnabled = false;
                        }
                        if (item.dtcs && item.dtcs.length > 0) {
                            vm.dtcTabEabled = true;
                        }
                        else {
                            vm.dtcTabEabled = false;
                        }
                    }
                });
            }
            else {
                vm.elementTabEnabled = false;
                vm.dtcTabEabled = false;
            }
        }
        /**
         * @desc to get list of MD related to system id
         */
        function systemDocExpanded(system, sideMenuClick) {
            $q.resolve().then(function(){
            var contributor = [];
            var systemList = [];
            showSystemFunction();

            if (system && system.system) {
                systemList.push(system.system);
            }

            vm.systemDocResponse.systems.map(function (item) {
                if (system.system == item.system && !sideMenuClick || sideMenuClick && item.systemDocExpanded == false) {
                    item.systemDocExpanded = !item.systemDocExpanded;
                }
            })

                if (system.systemDocExpanded === true && !system.mdDocuments) {
                    return getMDDocumentsIdList(-1, systemList).then(function (returnData) {
                        return returnData;
                    }).then(function (returnData) {
                        if (returnData && !_.isEmpty(returnData)) {
                            return getMDDocuments(returnData).then(function (response) {
                                if (response && response.MD) {
                                    response.MD = _.sortBy(response.MD, ["ref"]);
                                    _.extend(vm.selectedSystemDoc, {
                                        mdDocuments: response
                                    })
                                }
                                return;
                            });
                        }
                        return;

                    })
                }
        }).then(function(){
            vm.firstFilterSystem = [];
            if (!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.mdDocuments) && !_.isEmpty(vm.selectedSystemDoc.mdDocuments.MD)) {
                vm.selectedSystemDoc.mdDocuments.MD = _.sortBy(vm.selectedSystemDoc.mdDocuments.MD, [
                    function(item) { return item.ref ? item.ref : '~'; },
                    'subType'
                ]);
            }
            var payload = {
                fullData: vm.selectedSystemDoc,
                dataToFilter: 'MD',
                visibility:'systemDocExpanded',
                filterArray: vm.filterArraySystem,
                systemFilter: true
            }
            getSystemDocumentationFilter(payload).then(function (data) {
                vm.filterArraySystem = data;
            });
        })
        }

        /**
         * @desc to get list of MD related to element contributors
         */
        function elementsDocExpanded(elements,isExpandAll) {

            return $q.resolve().then(function () {

            var system = [];
            var contributor = [];
            if (elements.contributor) {
                contributor.push(elements.contributor);
            }

            vm.selectedElement = elements;
            vm.selectedSystemDoc.contributors.map(function (item) {
                if (item.contributor === elements.contributor) {
                    item.elementExpanded = !item.elementExpanded;
                }
            })
            if (!_.isEmpty(elements) && !_.isEmpty(elements.mdDocuments)) {
                elements.mdDocuments = _.sortBy(elements.mdDocuments, [
                    function(item) { return item.ref ? item.ref : '~'; },
                    'subType'
                ]);
            }
            if (elements.elementExpanded === true && !elements.mdDocuments) {
                if(!elements.mdId && !isExpandAll){
                    return getMDDocumentsIdList(0).then(function(returnData){
                        return ;
                    }).then(function(){
                        var returnData ;
                        vm.selectedSystemDoc.contributors.map(function (item) {
                            if (item.contributor === elements.contributor) {
                                returnData = item.mdId;
                            }
                        })
                        if(returnData && !_.isEmpty(returnData)){
                            return getMDDocuments(returnData).then(function (response) {
                                if (response && response.MD) {
                                    response = _.sortBy(response.MD, ["type"])
                                    _.map(vm.selectedSystemDoc.contributors,function(item){
                                        if(item.contributor == elements.contributor){
                                            _.extend(item,{mdDocuments: response})
                                        }
                                    })
                                }

                                return;
                            }).then(function(){
                                showElement();
                                return;
                            });;
                        }
                        return;

                    })
                }else if(elements.mdId){
                    return getMDDocuments(elements.mdId).then(function (response) {
                        if (response && response.MD) {
                            response = _.sortBy(response.MD, ["type"])
                            _.map(vm.selectedSystemDoc.contributors,function(item){
                                if(item.contributor == elements.contributor){
                                    _.extend(item,{mdDocuments: response})
                                }
                            })
                        }
                        showElement();
                        return;
                    });
                }
            }
            else if(!isExpandAll){
            var payload = {
                fullData: vm.selectedSystemDoc.contributors,
                dataToFilter: 'mdDocuments',
                visibility:'elementExpanded',
                filterArray: vm.filterArrayElement,
                systemFilter: ''
            }
            return getSystemDocumentationFilter(payload).then(function (data) {
                vm.filterArrayElement = data;
                return;
            });
            }

        });

        }

        /**
         * @desc to get list of MD realted to dtc
         */
        function dtcDocExpanded(dtcDoc,isExpandAll) {

            return $q.resolve().then(function () {

            var system = [];
            var contributor = [];
            var dtcNumber = []
            if(dtcDoc.dtcNumber) {
                dtcNumber.push(dtcDoc.dtcNumber);
            }

            vm.selectedDtc = dtcDoc;
            vm.selectedSystemDoc.dtcs.map(function(item){
                if(item.dtcNumber === vm.selectedDtc.dtcNumber){
                    item.dtcExpanded = !item.dtcExpanded;
                }
            });
            if (!_.isEmpty(dtcDoc) && !_.isEmpty(dtcDoc.mdDocuments)) {
                dtcDoc.mdDocuments = _.sortBy(dtcDoc.mdDocuments, [
                    function(item) { return item.ref ? item.ref : '~'; },
                    'subType'
                ]);
            }
            if (dtcDoc.dtcExpanded === true && !dtcDoc.mdDocuments) {
              
                if(!dtcDoc.mdId && !isExpandAll){
                    return getMDDocumentsIdList(1).then(function(returnData){
                        return;
                    }).then(function(){
                        var returnData;
                        vm.selectedSystemDoc.dtcs.map(function(item){
                            if(item.dtcNumber === vm.selectedDtc.dtcNumber){
                                returnData = item.mdId;
                            }
                        });

                        if(returnData && !_.isEmpty(returnData)){
                            return getMDDocuments(returnData).then(function (response) {
                                if (response && response.MD) {
                                    response = _.sortBy(response.MD, ["ref"]);
                                    _.map(vm.selectedSystemDoc.dtcs,function(item){
                                        if(item.dtcNumber === dtcDoc.dtcNumber) {
                                            _.extend(item, {mdDocuments: response})
                                        }
                                    })
                                }

                                return;
                            }).then(function(){
                                showDtc();
                                return;
                            });
                        }else{
                            return;
                        }
                        

                    })
                }else if(dtcDoc.mdId){

                    return getMDDocuments(dtcDoc.mdId).then(function (response) {
                        if (response && response.MD) {
                            response = _.sortBy(response.MD, ["ref"]);
                            _.map(vm.selectedSystemDoc.dtcs,function(item){
                                if(item.dtcNumber === dtcDoc.dtcNumber) {
                                    _.extend(item, {mdDocuments: response})
                                }
                            })
                        }
                        showDtc();
                        return;
                    });
                }
            

            } else if(!isExpandAll){
                var payload = {
                    fullData: vm.selectedSystemDoc.dtcs,
                    dataToFilter: 'mdDocuments',
                    visibility:'dtcExpanded',
                    filterArray: vm.filterArrayDtc,
                    systemFilter: ''
                }
                return getSystemDocumentationFilter(payload).then(function (data) {
                    vm.filterArrayDtc = data;
                    return;
                });
            }
        });

        }

        function getMDDocumentsList(system, contributor,dtc,dtcDoc) {

            blockUI.start();
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
            var subType = [];
            if (contributor && !_.isEmpty(contributor)) {
                subType = systemDocumentationConstants.elementSubType;
            }
            if(dtc && !_.isEmpty(dtc)){
                subType = systemDocumentationConstants.dtcSubType;
            }
            var docTypeParam = {
                "MD": {
                    "subType": subType,
                    "systems": system,
                    "contributors": contributor,
                    "dtc": dtc
                }
            };
            var inputBody = {
                userContext: userContext,
                carContext: carContext,
                docType: docTypeParam
            };
            return ResultSearchByDiagnosticMetierService.getAllCodes(inputBody).then(function (response) {
                var mdList = [];
                if (dtc && !_.isEmpty(dtc)) {
                    response.documents.forEach(function (doc) {
                        if(vm.typeMD === 'B3')
                        {
                           if (doc.indexationsTags.DTC&& doc.indexationsTags.DTC.includes(dtcDoc.dtcNumber)) {
                                var id = doc.id
                                mdList = mdList.concat(id);
                            }
                         }
                        else{
                            if (doc.indexationsTags.LabelDTC && doc.indexationsTags.LabelDTC.includes(dtcDoc.dtcLabel)) {
                                var id = doc.id
                                mdList = mdList.concat(id);
                            }
                        }

                 })
                }
                else {
                    response.documents.forEach(function (doc) {
                        var id = doc.id
                        mdList = mdList.concat(id);
                    })
                }
                return mdList;

            }).then(function (response){
                if (response && !_.isEmpty(response)) {
                    return DocumentsMetierService.getMDList(response).then(function (result) {
                        return result;
                    });
                }
                else {
                    var result = {
                        "MD": []
                    };
                    return result;
                }
            }).catch(function (error) {
                toastr.error(error);
            }).finally(function () {
                blockUI.stop();
                CacheService.removeObject(CacheConstants.systemDocDetails);
            });
        }

        function getMDDocumentsIdList(selectedTab,systemList){

            return $q.resolve().then(function(){

                blockUI.start();
                var userContext = CacheService.getUserContext();
                var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
                var subType = [];
                var contributor = [];
                var dtc = [];
                var system = [];
                var mdList = [];

                if(selectedTab === 0){

                    vm.selectedSystemDoc.contributors.map(function (item) {
                        contributor.push(item.contributor);
                    });

                    if (contributor && !_.isEmpty(contributor)) {
                        subType = systemDocumentationConstants.elementSubType;
                    }
                }else if(selectedTab === 1){

                    vm.selectedSystemDoc.dtcs.map(function (item) {
                        dtc.push(item.dtcNumber);
                    });

                    if(dtc && !_.isEmpty(dtc)){
                        subType = systemDocumentationConstants.dtcSubType;
                    }

                }else if(selectedTab === -1){
                    system = systemList;
                }

                var docTypeParam = {
                    "MD": {
                        "subType": subType,
                        "systems": system,
                        "contributors": contributor,
                        "dtc": dtc
                    }
                };
                var inputBody = {
                    userContext: userContext,
                    carContext: carContext,
                    docType: docTypeParam
                };
                return ResultSearchByDiagnosticMetierService.getAllCodes(inputBody).then(function (response) {
                    if (dtc && !_.isEmpty(dtc)) {
                        response.documents.forEach(function (doc) {
                            mdList.push(doc.id);
                            var idx = _.findIndex(vm.selectedSystemDoc.dtcs,function(item){
                                if(vm.typeMD === 'B3'){
                                    return doc.indexationsTags.DTC.includes(item.dtcNumber);
                                }else{
                                    return doc.indexationsTags.LabelDTC.includes(item.dtcLabel);
                                }

                            })

                                if(idx !== -1){
                                    if(_.has(vm.selectedSystemDoc.dtcs[idx],'mdId')){
                                        vm.selectedSystemDoc.dtcs[idx].mdId.push(doc.id);
                                    }else{
                                        _.extend(vm.selectedSystemDoc.dtcs[idx], {
                                            mdId: [doc.id]
                                        })
                                    }
                                }
                        })

                    }
                    else {
                        response.documents.forEach(function (doc) {
                            mdList.push(doc.id);
                            var idx = _.findIndex(vm.selectedSystemDoc.contributors,function(item){
                                return item.contributor === doc.contributor;
                            })
                            if(idx !== -1){
                                if(_.has(vm.selectedSystemDoc.contributors[idx],'mdId')){
                                    vm.selectedSystemDoc.contributors[idx].mdId.push(doc.id);
                                }else{
                                    _.extend(vm.selectedSystemDoc.contributors[idx], {
                                        mdId: [doc.id]
                                    })
                                }
                            }

                        });

                    }

                    if(vm.typeMD === 'ADT'){
                        if (vm.selectedSystemDoc.dtcs && !_.isEmpty(vm.selectedSystemDoc.dtcs))
                        { vm.selectedSystemDoc.dtcs.forEach(function(item){
                        if (!item.mdId){
                        response.documents.forEach(function (doc){
                        if(doc.indexationsTags.LabelDTC.includes(item.dtcLabel)){
                        _.extend(item,{
                        mdId: [doc.id]
                        })
                      }
                     })
                    }
                 })
               }
            }

                    return mdList;
                })
            }).then(function (mdData){
                    var mdList = [];

                if (selectedTab === 1) {
                    vm.selectedSystemDoc.dtcs.forEach(function (element) {
                    if (element.mdId){
                        mdList = mdList.concat(element.mdId);
                    }
                    });
                }
                else if (selectedTab === 0 ){
                    vm.selectedSystemDoc.contributors.forEach(function (element) {
                    if (element.mdId){
                        mdList = mdList.concat(element.mdId);
                    }
                    });
                }
                else if (selectedTab === -1){
                    mdList = mdList.concat(mdData);
                }
                if(mdList && !_.isEmpty(mdList)){ 
                    return getMDDocuments(mdList).then(function (response) {
                    if (response && response.MD) {

                        if (selectedTab === 1){
                            response = _.sortBy(response.MD, ["ref"]);
                            _.map(vm.selectedSystemDoc.dtcs,function(item){
                                var mdDocs = [];
                                if (item.mdId && item.mdId.length > 0){
                                    item.mdId.forEach(function(items){
                                        response.forEach(function (resp){
                                            if(items === resp.id){
                                                mdDocs.push(resp);
                                            }
                                        })
                                    })
                                    _.extend(item,{mdDocuments : mdDocs})

                                }

                            })
                            _.extend(vm.selectedSystemDoc,{hasDTCMdDoc : true});
                            showDtc();
                        }

                        else if (selectedTab === 0){
                            response = _.sortBy(response.MD, ["ref"]);
                            _.map(vm.selectedSystemDoc.contributors,function(item){
                                var mdDocs = [];
                                if (item.mdId && item.mdId.length > 0){
                                    item.mdId.forEach(function(items){
                                        response.forEach(function (resp){
                                            if(items == resp.id){
                                                mdDocs.push(resp);
                                            }
                                        })
                                    })
                                    _.extend(item,{mdDocuments : mdDocs})

                                }

                            })
                            _.extend(vm.selectedSystemDoc,{hasElementMdDoc : true});
                            showElement();
                        }
                        else if (selectedTab === -1){
                            response.MD = _.sortBy(response.MD, ["ref"]);
                            _.extend(vm.selectedSystemDoc, {
                                mdDocuments: response
                            })
                        }

                    }

                    return;
                });
            }
             }).then(function(){

                if (vm.selectedSystemDoc && !_.isEmpty(vm.selectedSystemDoc)) {
                    var sideMenuClick = true;
                    var selectedSystemDocDetails = CacheService.getObject(CacheConstants.systemDocDetails);
                    if (selectedSystemDocDetails && selectedSystemDocDetails.contributor && vm.selectedSystemDoc.contributors) {
                        _.find(vm.selectedSystemDoc.contributors, function (item) {
                            if (item.contributor === selectedSystemDocDetails.contributor) {
                                elementsDocExpanded(item,false);
                            }
                        })
                    }
                    else if(selectedSystemDocDetails && selectedSystemDocDetails.dtcNumber && vm.selectedSystemDoc.dtcs){
                        _.find(vm.selectedSystemDoc.dtcs,function(item){
                            if(item.dtcNumber === selectedSystemDocDetails.dtcNumber){
                                dtcDocExpanded(item,false);
                            }
                        });
                    }
                    else {
                        if (vm.typeMD !== 'B3' && vm.typeMD !== "ADT") {
                            systemDocExpanded(vm.selectedSystemDoc, sideMenuClick);
                        } else if (vm.typeMD === 'B3') {
                            if (vm.selectedSystemDoc.system.substr(-3) === '000') {
                                systemDocExpanded(vm.selectedSystemDoc, sideMenuClick);
                            }
                        }
    
                    }
                }

            }).catch(function (error) {
                toastr.error(error);
            }).finally(function () {
                blockUI.stop();
                CacheService.removeObject(CacheConstants.systemDocDetails);
            });

        }

        function getMDDocuments(mdIdList){

            blockUI.start();

            return $q.resolve().then(function(){

                return DocumentsMetierService.getMDList(mdIdList).then(function (result) {
                    return result;
                });


            }).catch(function (error) {
                toastr.error(error);
                return $q.reject();
            }).finally(function () {
                blockUI.stop();
                
            });

        }


        function showSystemFunction() {

            if (vm.typeMD !== 'B3') {
                vm.systemTabEnabled = true;
                vm.systemTab = true;
                vm.elementTab = false;
                vm.dtcTab = false;
            }
            else if (vm.typeMD === 'B3') {
                if (vm.selectedSystemDoc.system.substr(-3) === '000') {
                    vm.systemTabEnabled = true;
                    vm.systemTab = true;
                    vm.elementTab = false;
                    vm.dtcTab = false;
                } else {
                    vm.elementTab = true;
                }
            }
        }

        function showElement() {
            vm.fullDataFilterElement = [];
            vm.firstFilterElement = [];
            _.map(vm.filterArrayElement, function(item){
                item.selectedValues = "";
                item.values = [];
            })
            var payload = {
                fullData: vm.selectedSystemDoc.contributors,
                dataToFilter: 'mdDocuments',
                visibility:'elementExpanded',
                filterArray: vm.filterArrayElement,
                systemFilter: ''
            }
            vm.systemTab = false;
            vm.elementTab = true;
            vm.dtcTab = false;

            getSystemDocumentationFilter(payload).then(function (data) {
                vm.filterArrayElement = data;
            });
        }

        function showDtc() {
            vm.fullDataFilterDtc= [];
            vm.firstFilterDtc = [];
            _.map(vm.filterArrayDtc,function(item){
                item.selectedValues = "";
                item.values = [];
            })
            var payload = {
                fullData: vm.selectedSystemDoc.dtcs,
                dataToFilter: 'mdDocuments',
                visibility:'dtcExpanded',
                filterArray: vm.filterArrayDtc,
                systemFilter: ''
            }
            vm.systemTab = false;
            vm.elementTab = false;
            vm.dtcTab = true;

            getSystemDocumentationFilter(payload).then(function (data) {
                vm.filterArrayDtc = data;
            });
        }

        function displayMdDetails(md) {

            var systemDocDetails = {
                "isSystemDocEnable": true,
                "systemId": vm.selectedSystemDoc.system
            };
            if (vm.elementTab) {
                _.extend(systemDocDetails, {
                    contributor: md.ref
                })
            }
            if(vm.dtcTab) {
                _.extend(systemDocDetails,{
                    dtcNumber: vm.selectedDtc.dtcNumber
                });
            }
            CacheService.setObject(CacheConstants.systemDocDetails, systemDocDetails);
            if(md.gateway === "Y"){
                var siesLength = md.gateway_sies.length;
                if (!siesLength) {
                    toastr.info($translate.instant('DOCUMENT_NOT_ASSOCIATED'));
                } else if (siesLength === 1) {                    
                    $state.go(RoutesConstants.documentMD, { id: md.gateway_sies[0].reference });
                } else {
                    $mdDialog.show({
                        templateUrl: 'app/components/products/documents/md/mdDocuments/dialog-md.template.html',
                        parent: angular.element(document.body),
                        controller: 'dialogMdController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            listOfMDDocuments: md.gateway_sies
                        }
                    });
                }
            }else{
                $state.go(RoutesConstants.documentMD, { id: md.paramURL });
            }            
        }

        function getSystemDocumentationFilter(payload){
            vm.filterLoader = true;
            return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU).post(payload)
            .then(function (response) {
                if (response) {
                    return response;
                } else {
                    toastr.error($translate.instant("FILTER_ERROR"));
                }
            })
            .finally(function () {
                vm.filterLoader = false; 
            });
        }

    }

})();

'use strict';

angular.module('phenix').constant('systemDocumentationConstants',{
    elementSubType: ["101","102","108","110","111","501","502"],
    dtcSubType: ["104","106","109"],
    adtVinSearchUrl: "https://diag.dcs2.renault.com/adt-viewer?ref=%7B%22vehicleId%22%3A%22",
    adtVinUrl: "%22%7D*",
    adtModelSearchUrl: "https://diag.dcs2.renault.com/adt-viewer/#/start",
    adtFeedbackUrl: "https://diag.dcs2.renault.com/adt-feedback/?vehicleId="
});
/**
 * symptomBasketDetails
 * @namespace Components
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('symptomBasketDetails', {
            bindings: {
                data: '=',
                selectedSympBasketId: '=',
                goToResultByDiagnostic: '<',
                symptomsBasketList: '=',
                isSymptomsDisplayed: '='
            },
            controller: SymptomBasketDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchByDiagnostic/SymptomBasketDetails/symptomBasketDetails.template.html',

        }).controller('SymptomBasketDetailsController',SymptomBasketDetailsController);

    function SymptomBasketDetailsController($scope,blockUI,
        ResultSearchByDiagnosticMetierService,DiagFileDetailsNewConstants,toastr,
        CacheService,CacheConstants,CustomFilterSortService, $q){

        var vm = this;

        //variables
        vm.filteredSymptomBaskets = [];
        vm.btDisplayArray = [];
        vm.mdDisplayArray = [];
        vm.techBulletinList = [];
        //required for smart table default sort
        $scope.defaultSortColumn = {predicate:'basketcreationdate',reverse:true};

        //functions
        vm.filterSymptomBaskets = filterSymptomBaskets;
        vm.getBTAndMDAvailability = getBTAndMDAvailability;
        vm.setBTAndMDAvailability = setBTAndMDAvailability;
        vm.setDropDownData = setDropDownData;
        vm.redirectToDocPage = redirectToDocPage;
        vm.displaySymptomData = displaySymptomData;

        vm.sortedField = {
            isBTAvailable: function (value) {
                //sort symptoms by BT availability. Yes goes first
                if (value.isBTAvailable === DiagFileDetailsNewConstants.YES) {
                    return -1;
                }
                return 1;
            },
            isMDAvailable: function (value) {
                //sort symptoms by MD availability. Yes goes first
                if (value.isMDAvailable === DiagFileDetailsNewConstants.YES) {
                    return -1;
                }
                return 1;
            }
        };


        $scope.$watch('vm.selectedSympBasketId', function () {

            vm.filteredSymptomBaskets = [];
            $scope.basketcreationdate = '';
            $scope.symptomCode = '';
            $scope.symptomLongLabel = '';
            vm.btDisplayArray = [];
            vm.mdDisplayArray = [];
            vm.techBulletinList = [];
            //trigger the click of the div to reset the filter
            var resetDiv = angular.element(document.querySelector('#resetFilter'));
            angular.element(resetDiv).triggerHandler('click');

            if(vm.selectedSympBasketId && !_.isEmpty(vm.selectedSympBasketId)){
                filterSymptomBaskets(vm.selectedSympBasketId);
            }

        });

        /**
         * set the data in the filter dropdown
         */
        function setDropDownData() {

            vm.btDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.isBTAvailable,
                values: DiagFileDetailsNewConstants.filterYesNoData
            },vm.filteredSymptomBaskets);

            vm.mdDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.isMDAvailable,
                values: DiagFileDetailsNewConstants.filterYesNoData
            },vm.filteredSymptomBaskets);

        }

        /**
         * To filter the symptoms based on the date selected
         * @param {Object} selSympBasket 
         */
        function filterSymptomBaskets(selSympBasket){

            vm.filteredSymptomBaskets = selSympBasket.symptomBasketDetails;

            //clear the previous sort while changing the dates
            CustomFilterSortService.clearSort('symp-table','basketcreationdate');

            getBTAndMDAvailability().catch(function(err){
                toastr.error(err);
            })


        }
        function getValidBtDocuments(documents){
            var defer = $q.defer();
            var btList = [];
            vm.btDtcCombined = [];
            if(!_.isEmpty(documents)){
                documents.forEach(function(item){
                    if(item.type == DiagFileDetailsNewConstants.documentBT){
                        if(!_.isEmpty(item.indexationsTags.symptoms)){
                            item.indexationsTags.symptoms.forEach(function(value){
                                vm.btDtcCombined.push({code:value,id:item.id})
                            })
                        }                        
                        btList.push({
                            id: item.id,
                            subType: item.subType
                        });
                    }   
                })
                if(!_.isEmpty(btList)){
                    _.map(vm.filteredSymptomBaskets,function(item){
                        _.assign(item, {
                            isBTLoading : true
                        })
                    })
                    ResultSearchByDiagnosticMetierService.getBTList(btList).then(function(response){
                        if(response && !_.isEmpty(response.BTInformation) && !_.isEmpty(vm.btDtcCombined)){
                            response.BTInformation.forEach(function(item){
                                vm.btDtcCombined.forEach(function(value){
                                    if(item.id == value.id)
                                        vm.techBulletinList.push(value);
                                })
                            })
                        }
                    }).finally(function(){
                        _.map(vm.filteredSymptomBaskets,function(item){
                            _.assign(item, {
                                isBTLoading : false
                            })
                        })
                        defer.resolve(vm.data);
                    })
                }
            }
            return defer.promise;
        }
        /**
         * get BT & MD details of the symptoms
         */
        function getBTAndMDAvailability(){

            if(vm.filteredSymptomBaskets && !_.isEmpty(vm.filteredSymptomBaskets)){

                var symptomList = [];

                angular.forEach(vm.filteredSymptomBaskets, function(item){
                    symptomList.push(item.symptomId);
                })

                if(symptomList && !_.isEmpty(symptomList)){

                    blockUI.start();

                    var dataBody = ResultSearchByDiagnosticMetierService.createDataObject(symptomList, '', '');

                    return ResultSearchByDiagnosticMetierService.getAllCodes(dataBody)
                        .then(function (response) {
                            vm.data = response;
                            getValidBtDocuments(vm.data.documents).then(function(){
                                setBTAndMDAvailability();
                                return vm.data;
                            });
                        }, function (err) {
                            toastr.error(err);
                        }).finally(function () {
                            blockUI.stop();
                        });
                }

            }

        }

        /**
         * integrate the BT & MD details in the symptom basket
         */
        function setBTAndMDAvailability(){

            _.map(vm.filteredSymptomBaskets, function (item) {
                _.extend(item, {
                    isBTAvailable: DiagFileDetailsNewConstants.NO,
                    isMDAvailable: DiagFileDetailsNewConstants.NO
                });
            })

            if (vm.data.documents && !_.isEmpty(vm.data.documents)) {

                vm.data.documents.forEach(function (data) {

                    data.indexationsTags.symptoms.forEach(function (symptoms) {

                        _.map(vm.filteredSymptomBaskets, function(sympDetails) {

                            if(sympDetails.symptomId.toUpperCase() === symptoms.toUpperCase()){
                                if(!_.isEmpty(vm.techBulletinList)){
                                    vm.techBulletinList.forEach(function(value){
                                        if(sympDetails.symptomId.toUpperCase() == value.code.toUpperCase())
                                           sympDetails.isBTAvailable = DiagFileDetailsNewConstants.YES;
                                        if(data.type === DiagFileDetailsNewConstants.documentMD){
                                            sympDetails.isMDAvailable = DiagFileDetailsNewConstants.YES;
                                        }
                                    })
                                }
                            }
                        })

                    })

                })
            }

            setDropDownData();

        }

        function redirectToDocPage(selSymptom){

            var data = {
                code:selSymptom.symptomCode,
                label:selSymptom.symptomLongLabel
            }

            var symptom = selSymptom.symptomCode + ' - ' + selSymptom.symptomLongLabel;
            CacheService.setObject(CacheConstants.searchedSymptom, data);
            vm.goToResultByDiagnostic(symptom, 3, symptom);

        }

        function displaySymptomData(){
            vm.isSymptomsDisplayed = !vm.isSymptomsDisplayed;
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider,RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.resultSearchByDiagnostic, {
        url: '/resultSearchByDiagnostic',
        params: {
          data: null,
          code: null,
          searchAiText:null,
          codeNumber:null
        },
        templateUrl: 'app/components/car/searchByDiagnostic/ResultSearchByDiagnostic/resultSearchByDiagnostic.html',
        controller: 'ResultSearchByDiagnosticCtrl',
        controllerAs: 'vm'
      });
  }
})();

/**
 * resultSearchByDiagnostic Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('ngRightClick', function($parse) {
            return function(scope, element, attrs) {
                var fn = $parse(attrs.ngRightClick);
                element.bind('contextmenu', function(event) {
                    scope.$apply(function() {
                        event.preventDefault();
                        fn(scope, {$event:event});
                    });
                });
            };
        })
        .controller('ResultSearchByDiagnosticCtrl', ResultSearchByDiagnosticCtrl);

    /**
     * @namespace resultSearchByDiagnosticController
     * @desc display result of search by diag
     * @memberOf Controllers
     */

    /** @ngInject */
    function ResultSearchByDiagnosticCtrl(DocumentsMetierService, timeOutRecapCar, ResultSearchByDiagnosticMetierService, CacheService,
         $state, toastr, RoutesConstants, CacheConstants, ActisConstantes, $timeout, blockUI, $translate, MainMetierService,
         $rootScope,$scope, UtilsMetierService, CryptoService,configConstantes, $mdDialog) {


        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.loading = true;
        vm.code = null;
        vm.numberOfBT = 0;
        vm.numberOfMD = 0;
        vm.listOfBTDocuments = null;
        vm.MDTabState = null;
        vm.BTTabState = null;
        vm.ArticleTabState = null;
        vm.typeMD = null;
        vm.isActisProfil = false;
        vm.istechLinerProfil = false;
        var tabIndex = null;
        var requestDiagnostic = null;

        vm.backArbo = backArbo;
        vm.selectTab = selectTab;
        vm.createFIC = createFIC;
        vm.goToBtlist = goToBtlist;
        vm.msgUserNotAllowed = "";
        vm.isIndependentUser = UtilsMetierService.isIndependentUser();
        vm.hasAsomOTSDocAccess = UtilsMetierService.hasAsomDocumentAccess('OTS', vm.isIndependentUser);
        vm.isArticleTabVisible = false;
        vm.displayArticlesList = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        const newArticlesEnabled = JSON.parse(configConstantes.isNewArticles);
        vm.showDiagNoise = showDiagNoise;
        vm.goToDiagNoise = goToDiagNoise;

        init();


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {


            //clean sie documents history
            //while the user could click on the previous button from the browser
            //we didn't have control on this action
            CacheService.cleanSieDocumentsHistory();

            requestDiagnostic = $state.params;

            //get selected tabIndex (MD or BT) from cache
            //if we navigate to MD or BT
            tabIndex = CacheService.getObject(CacheConstants.tabIndex);

            //get type md (borneo 2 or 3)
            vm.typeMD = CacheService.getCarContext().typeMD;

            //set request Diagnostic (BT list and MD list) in cache
            //we use it to get MD and/or BT list
            if (requestDiagnostic.data) {
                CacheService.setObject(CacheConstants.requestDiagnostic, requestDiagnostic);
            }
            else {
                requestDiagnostic = CacheService.getObject(CacheConstants.requestDiagnostic);
            }

            //clean sie documents history
            //while the user could click on the previous button from the browser
            //we didn't have control on this action
            CacheService.cleanSieDocumentsHistory();


            vm.code = requestDiagnostic.code;
            vm.carContext = CacheService.getCarContext();
            vm.isCirSentVin = vm.carContext ? MainMetierService.isCirSentVin(vm.carContext.vin):null;
            vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
            var userProfile = CacheService.getUserProfile();
            if(userProfile&&userProfile.roles&&!_.isEmpty(userProfile.roles)&&MainMetierService.isIndependantUser(userProfile.roles))
            {
                if (vm.isAsomValidDocAccess == "false" && vm.isCirSentVin){
                    vm.accessToBtMd = true;
                }
                else {
                    vm.accessToBtMd = false;
                }
            }
            vm.checkIndependentUser=userProfile ? MainMetierService.isIndependantUser( userProfile.roles): null;
            vm.isSupportAccess = MainMetierService.isSupportAccess();
            var userContext = CacheService.getObject(CacheConstants.profil);
            vm.isActisProfil = MainMetierService.isActisProfil();  
            vm.isDisplayCreateFIC = UtilsMetierService.getTokenBalance();          
            var userRoles = _.map(userContext.roles, function (item) {
                return item;
            });
            if(newArticlesEnabled){
                if (!vm.nissanUserURL && (userContext.userType != 'ASOM' || (userContext.userType === 'ASOM' && $rootScope.asomDocList.BT))){
                    vm.isArticleTabVisible = true;
                }
            } else {
                if ((vm.isActisProfil) || (userRoles && !_.isEmpty(userRoles) && userRoles.includes(ActisConstantes.ppx_assist_tech_n1) || userRoles.includes(ActisConstantes.ppx_assist_tech_n2))){
                    vm.isArticleTabVisible = true;
                }
            }
            
            //get MD and BT after disagnostic search
            getBtAndMdList(requestDiagnostic.data, vm.code);

            
            vm.istechLinerProfil = MainMetierService.isBTListProfile();
            getMessageUserNotAllowed();
            if ((CacheService.getObject(CacheConstants.tokenBalance))){
                var decrypted = CryptoService.AES.decrypt((CacheService.getObject(CacheConstants.tokenBalance)), CacheConstants.encryptedValue);
                vm.tokenBalance =  parseInt((decrypted.toString(CryptoService.enc.Utf8)));
            }
            
            $rootScope.$on('articleDocumentsDisplay', function(e,obj){
                if (obj > 0){                        
                    vm.displayArticlesList = true;
                }                       
                
            })
            

        }

        function goToDiagNoise() {
            var carcontext = CacheService.getCarContext();
            var family = carcontext && carcontext.fixedCriterias && carcontext.fixedCriterias['007'] ? carcontext.fixedCriterias['007'] : '';
            var bodyType = carcontext && carcontext.fixedCriterias && carcontext.fixedCriterias['008'] ? carcontext.fixedCriterias['008'] : '';
            var diagNoise = configConstantes.diagNoiseLink;
            if ($state.params.searchAiText) {
                var url = diagNoise + 'symptomCode=' + vm.searchedSymptom.code + '&customerExplanation=' + $state.params.searchAiText + '&modelCode=' + family + '&bodyType=' + bodyType;
            } else {
                var url = diagNoise + 'symptomCode=' + vm.searchedSymptom.code + '&modelCode=' + family + '&bodyType=' + bodyType
            }
            window.open(url, '_blank');
        }

        function showDiagNoise(){
        var isValidSymptomCode = false;
        vm.requestDiagnosticCode = CacheService.getObject(CacheConstants.requestDiagnostic);
        if(((vm.requestDiagnosticCode && vm.requestDiagnosticCode.codeNumber == "3") || $state.params.codeNumber == "3") && vm.searchedSymptom && vm.searchedSymptom.code && vm.searchedSymptom.code.charAt(0) == "B"){
             isValidSymptomCode = true;
        }
        return isValidSymptomCode &&  UtilsMetierService.diagNoiseAccess();
      
        }

        function getMessageUserNotAllowed(){
            if(!vm.isActisProfil){
                vm.msgUserNotAllowed = $translate('ACTIS_USER_NOT_ALLOWED').then(function(text){
                    vm.msgUserNotAllowed =text;
                });
            }
        }

        function goToBtlist() {
            CacheService.setObject('btListDiagnosticEntry', { createdAt: Date.now() });
            MainMetierService.goToDesyre('btList');
        }


        /**
         * @name selectTab
         * @desc navigate between BT and MD
         * this action trigger when the user click MD or BT
         * @param {string} currentTab the selectd tab (BT or MD)
         * @memberOf Controllers.resultSearchByDiagnosticController
         */
        function selectTab(currentTab) {
            if (currentTab == "BT") {
                angular.element(document.querySelectorAll('table tbody tr.documents-row')).removeClass('selected');
            }
            else {
                angular.element(document.querySelector('.documents-row')).removeClass('selected');
            }
            if (currentTab == "ARTICLES") {
                $rootScope.$on('articleDocumentsDisplay', function (e, obj) {
                    if (obj > 0) {
                        vm.displayArticlesList = true;
                    }
                })
            }
        }

        /**
         * @name backArbo
         * @desc back to list piece page
         * this action trigger when the user click on back button
         * @memberOf Controllers.resultSearchByDiagnosticController
         */
        function backArbo() {
            var binData = CacheService.getBinData();

            CacheService.removeObject(CacheConstants.requestDiagnostic);
            CacheService.removeObject(CacheConstants.searchedSymptom);
            CacheService.removeObject(CacheConstants.systemDocDetails);

            if (binData) {
                CacheService.setObject('binData', {
                    binValue: binData.binValue,
                    showBINContent: binData.showBINContent
                });
            }
            $state.go(RoutesConstants.carSearchResult, { data: { traficDiagSymp: true } });
        }

        function createFIC() {
            CacheService.removeObject(CacheConstants.consultationFIC);
            const userProfile = CacheService.getUserProfile();
            var showNoiseDialog = vm.showDiagNoise && vm.showDiagNoise();
            var afterDialog = function () {
                CacheService.setObject(CacheConstants.isActisFromDiag, true);
                if(userProfile && userProfile.userType !== 'ASOM' && JSON.parse(configConstantes.isActisNew)){
                    MainMetierService.goToDesyre('actis/create');
                } else if(userProfile && userProfile.userType === 'ASOM' && JSON.parse(configConstantes.isActisNew)){
                    MainMetierService.goToDesyre('actis/cirCreation', 'Technical Assistance CIRs');
                }
                else {
                    $state.go(RoutesConstants.manageFIC, {});
                }
            };
            if (showNoiseDialog) {
                $mdDialog.show({
                    template:
                        '<md-dialog class="noise-info-popin" style="min-width:30rem;max-width:40rem;padding:24px 32px;font-family: newRenaultGroupRegular;">' +
                        '  <div style="display:flex;justify-content:flex-end;">' +
                        '    <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close" style="font-size:22px; top: -1rem; left: 2rem;">' +
                        '      <em class="fa fa-close"></em>' +
                        '    </md-button>' +
                        '  </div>' +
                        '  <div style="margin-top:-2.5rem;font-size:16px;line-height:1.5;">' +
                        '    <span ng-bind-html="dialogMessage"></span><br>' +
                        '    <a href="#" ng-click="goToDiagNoise(); $event.preventDefault();" style="cursor:pointer;">{{linkText}}</a>' +
                        '  </div>' +
                        '</md-dialog>',
                    controller: function ($scope, $mdDialog, $translate, $sce) {
                        $scope.dialogMessage = $sce.trustAsHtml($translate.instant('CIR_NOISE_DIALOG_MESSAGE'));
                        $scope.linkText = $translate.instant('DIAG_NOISES');
                        $scope.goToDiagNoise = vm.goToDiagNoise;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    },
                    clickOutsideToClose: true,
                    escapeToClose: true
                }).then(afterDialog)
                    .catch(function () {
                        afterDialog();
                    });
            } else {
                afterDialog();
            }
        }

        /*=============================================
        =                   TOOLS                     =
        =============================================*/

        //get BT and MD list by passing bt ids and md ids
        //and defect code (used for borneo 2)
        function getBtAndMdList(requestDiagnostic, defectCode) {
            //if we have BT and MD after diag search
            vm.searchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
            if (requestDiagnostic.BT.length > 0 && requestDiagnostic.BTWithColorType.length > 0 && requestDiagnostic.MD.length > 0){
                blockUI.start();
                ResultSearchByDiagnosticMetierService.getBTList(requestDiagnostic.BTWithColorType).then(function (response) {

                    vm.listOfBTDocuments = response.BTInformation;
                    vm.numberOfBT = vm.listOfBTDocuments ? vm.listOfBTDocuments.length : 0;
                    vm.listOfBTDocuments = formatBt(vm.listOfBTDocuments);

                    DocumentsMetierService.getMDList(requestDiagnostic.MD, defectCode).then(function (result) {
                        vm.listOfMDDocuments = [];
                        if(vm.searchedSymptom.documentationCode){
                            if(result.MD && !_.isEmpty(result.MD)){
                                result.MD.forEach(function(item){
                                    if(_.isEmpty(item.labelDtc) || (!_.isEmpty(item.labelDtc) && item.labelDtc.includes(vm.searchedSymptom.documentationCode))) {
                                        vm.listOfMDDocuments.push(item)
                                    }
                                })
                            }
                        } else{
                            vm.listOfMDDocuments = result.MD;
                        }

                        vm.numberOfMD = vm.listOfMDDocuments.length ? vm.listOfMDDocuments.length : 0;

                        //if selected item is in MD List
                        if (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexMD) {
                            openTab(vm.numberOfMD, vm.numberOfBT, true);
                        }

                        //if selected item is in BT List or tabIndex doens't exist
                        else if ((tabIndex && tabIndex.id == RoutesConstants.listPieceIndexBT) || !tabIndex) {
                            openTab(vm.numberOfMD, vm.numberOfBT, false);
                        }
                        vm.filtered = vm.listOfMDDocuments;
                        $timeout(function(){
                          $rootScope.$broadcast("filterMDReset",vm.filtered);
                        },100)
                    }, function (err) {
                        toastr.error('Error BACK : ' + err, 'Error');
                    });
                }, function (msg) {
                    msg.errors.forEach(function (error) {
                        toastr.error('Error BACK : ' + error.message, 'Error');
                    });
                }).finally(function () {
                    blockUI.stop();
                    vm.loading = false;
                });
            }

            //if we have only BT after diag search
            else if (requestDiagnostic.BT.length > 0 && requestDiagnostic.BTWithColorType.length > 0 && requestDiagnostic.MD.length == 0) {
                blockUI.start();
                ResultSearchByDiagnosticMetierService.getBTList(requestDiagnostic.BTWithColorType).then(function (response) {

                    vm.listOfBTDocuments = response.BTInformation;
                    vm.numberOfBT = vm.listOfBTDocuments ? vm.listOfBTDocuments.length : 0;
                    vm.listOfBTDocuments = formatBt(vm.listOfBTDocuments);

                    //open always BT
                    if (!tabIndex || (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexMD)) {
                        openTab(0, vm.numberOfBT, false);
                    }
                }, function (msg) {
                    msg.errors.forEach(function (error) {
                        toastr.error('Error BACK : ' + error.message, 'Error');
                    });
                }).finally(function () {
                    blockUI.stop();
                    vm.loading = false;
                });
            }
            //if we have only MD after diag search
            else if (requestDiagnostic.BT.length == 0 && requestDiagnostic.BTWithColorType.length == 0 && requestDiagnostic.MD.length > 0) {
                blockUI.start();
                DocumentsMetierService.getMDList(requestDiagnostic.MD, defectCode).then(function (result) {
                    vm.listOfMDDocuments = [];
                    if(vm.searchedSymptom.documentationCode){
                        if(result.MD && !_.isEmpty(result.MD)){
                            result.MD.forEach(function(item){
                                if(_.isEmpty(item.labelDtc) || (!_.isEmpty(item.labelDtc) && item.labelDtc.includes(vm.searchedSymptom.documentationCode))) {
                                    vm.listOfMDDocuments.push(item);
                                }
                            })
                        }
                    } else{
                        vm.listOfMDDocuments = result.MD;
                    }
                    vm.numberOfMD = vm.listOfMDDocuments.length ? vm.listOfMDDocuments.length : 0;

                    if (!tabIndex || (tabIndex && tabIndex.id == RoutesConstants.listPieceIndexMD)) {
                        openTab(vm.numberOfMD, 0, true);
                    }
                    vm.filtered = vm.listOfMDDocuments;
                    $timeout(function(){
                      $rootScope.$broadcast("filterMDReset",vm.filtered);
                    },100)

                }, function (err) {
                    toastr.error('Error BACK : ' + err, 'Error');
                }).finally(function () {
                    blockUI.stop();
                    vm.loading = false;
                });
            }

            else if (requestDiagnostic.BT.length == 0 && requestDiagnostic.BTWithColorType.length == 0 && requestDiagnostic.MD.length == 0) {
                vm.loading = false;
                openTab(0, 0, false);
            }
        }

        //select which tab will be open
        //by passing md, bt number and boolean (true if tab MD will be shown, false if Bt tab be shown)
        function openTab(numberOfMD, numberOfBT, isMDFirst) {

            if (isMDFirst) {
                if (numberOfMD) {
                    vm.MDTabState = true;
                }
                else if (numberOfBT) {
                    vm.BTTabState = true;
                }
            }
            else {
                if (numberOfBT) {
                    vm.BTTabState = true;
                }
                else if (numberOfMD) {
                    vm.MDTabState = true;
                }
                else if (numberOfBT === 0 && numberOfMD === 0 && vm.isArticleTabVisible) {
                    vm.ArticleTabState = true;
                    vm.selectTab('ARTICLES');                    
                }
            }
        }

        //parse bt elements and format date them
        //if date length is equal to 8
        //return bt list after format date
        function formatBt(btList){
            var formattedBt = [];
            //parse BT documents and format date
            angular.forEach(btList, function (btElement) {
                if (btElement.updateDate.length === 8 ) {
                    btElement.updateDate = formatDate(btElement.updateDate);
                }
                if(!vm.hasAsomOTSDocAccess && btElement.ots != null){
                    btList.splice(btList.indexOf(btElement),1);
                }

                formattedBt.push(btElement);
            });

            return formattedBt;
        }

        //format date by passing an integer sequence
        //example (input: 20171130 => output: 2017/11/30)
        function formatDate(date) {
            var year = date.substr(0, 4);
            var month = date.substr(4, 2);
            var day = date.substr(6, 2);

            var formattedDate = year + ("/").concat(month) + ("/").concat(day);

            return formattedDate;
        }
    }
})();

'use strict';

angular.module('phenix').constant('ResultSearchByDiagnosticConstants', {

    documentationSearchBT: '/proxy/apidh/rest/v1/technicalBulletins',
    documentationSearchMD: '/proxy/apidh/rest/v1/diagnosticManuals/borneo3',
    documentationDiagnostic: '/proxy/apidh/rest/v1/applicabilities/fixedFiltered2',
    documentationDiagnosticSymptoms: '/proxy/apidh/rest/v1/dfps',
    qemotionThematics: '/proxy/extern/projects/thematics',
    qemotionVerbatim: '/proxy/extern/projects/verbatims',
    symptomsAI: '/proxy/apigee/aic/symptoms/v1/symptoms',
    batteryCrashHistoryBinVin: 'proxy/apigee/bms/v1/batteries/',
    diagList: 'vehicleDiag/diagList',
    addRegistrationNumber: 'vehicleDiag/updateRegistrationNumber',
    BTList: ["YELLOW", "GREEN", "NO_COLOR"],
    BTListAsom: ["GREEN", "NO_COLOR"],
    MDList : ["104", "106", "109", "401", "402","403"],
    MDB2List : {"subType" : ["B2"]},
    requiredSymptomBasketFields : ['basketcreationdate','symptomCode','symptomLongLabel','basketno','symptomId','symptomContexts'],
    // Car symptoms list constants
    MAX_NUMBER_OF_DAYS: 180,
    //restListSymptoms: '/proxy/apigee/vehicles/v2/' /*VF1JMRG0629761835/symptoms-baskets?locale=fr_FR&from=27%2F09%2F2017*/
    restListSymptoms: '/proxy/apigee/mcs/v1/vehicles/', /*VF1JMRG0629761835/symptoms-baskets?locale=fr_FR&from=27%2F09%2F2017*/
    qemotionClient: 'NDFrontClient',
});

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagNetwork', diagNetwork);

    /** @ngInject */
    function diagNetwork() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/NetworkDiagnosis/diagNetwork.template.html',
            restrict: 'E',
            replace: false,
            controller: 'NetworkDiagnosisController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "="
            },
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('NetworkDiagnosisController', NetworkDiagnosisController);

    /* @inject */
    function NetworkDiagnosisController(CacheService, CacheConstants, DiagFileBusinessService,
        blockUI, DiagFileDetailsNewConstants, $translate, $q,CustomFilterSortService,$rootScope,toastr, $scope, RestUpgrade) {

        var vm = this;

        //Variables
        vm.diagFiles = CacheService.getObject(CacheConstants.diagFilesList);
        vm.diagFile = {};
        vm.firstFilter = [];
        vm.secondFilter = [];
        vm.filterArray = [];
        vm.initialList = [];
        vm.expandAll = false;
        vm.filterLoader = false;

        //Functions
        vm.displayNetwork = displayNetwork;
        vm.getNetworkDetails = getNetworkDetails;
        vm.initialCategory = initialCategory;
        vm.onExpandAll = onExpandAll;
        vm.getNetworkFilter = getNetworkFilter;
        vm.displayAndFilterNetwork = displayAndFilterNetwork;
          

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            


            if (vm.diagFiles && !_.isEmpty(vm.diagFiles)) {
                _.map(vm.diagFiles, function (item) {
                    _.extend(item, { networkVisible: false })
                })

                if(vm.typeMD === 'B3' || vm.typeMD === 'B2'){
                    vm.initialList = _.filter(vm.diagFiles,function(it){
                        return _.includes(DiagFileDetailsNewConstants.initialCategory,it.category);
                    })
                    vm.filterArray = [
                        { label: 'NETWORK_LABEL', key: 'name', values: [], selectAll: false, checkBox: true },
                        { label: 'ECU', key: 'ecus.label', values: [], selectAll: false, checkBox: true },
                        { label: 'COMMON_STATUS', key: 'ecus.status', values: [], selectAll: false, checkBox: true }
                    ];
                }else if(vm.typeMD === 'ADT'){
                    vm.initialList = vm.diagFiles;
                    vm.filterArray = [
                        { label: 'NETWORK_LABEL', key: 'name', values: [], selectAll: false, checkBox: true },
                        { label: 'ECU', key: 'ecus.domainLabel', values: [], selectAll: false, checkBox: true },
                        { label: 'COMMON_STATUS', key: 'ecus.status', values: [], selectAll: false, checkBox: true }
                    ];
                }

                
                
                if (vm.initialList && vm.initialList.length > 0){
                    if(vm.typeMD != 'ADT')
                        if(!_.isEmpty(vm.initialList) && vm.initialList.length > 0){
                            displayAndFilterNetwork(vm.initialList[0].id,false);
                        }
                }
                
            }


        };

        function onExpandAll(expand) {

            if (vm.diagFiles && !_.isEmpty(vm.diagFiles)) {
                var promiseArray = _.map(vm.diagFiles, function (item) {
                    return displayNetwork(item.id, expand);
                });
                $q.all(promiseArray).then(function () {
                    getNetworkFilter();
                })
            }

        }

        function displayAndFilterNetwork(id, networkVisible) {
            displayNetwork(id, networkVisible).then(function () {
                getNetworkFilter();
            });
        }

        function initialCategory(item) {
            if(vm.typeMD === 'B3' || vm.typeMD === 'B2-3'){
                return _.includes(DiagFileDetailsNewConstants.initialCategory, item.category) ||
            _.includes(DiagFileDetailsNewConstants.ticketMaintenanceCategory, item.category) ;
            }
            else if(vm.typeMD === 'ADT'|| vm.typeMD === 'B2'){
                return item;
            }
             else if(vm.typeMD === 'B3-ADT'){
                const categoryLower = item.category ? item.category.toLowerCase() : item.category;
                return _.includes(DiagFileDetailsNewConstants.initialCategory, categoryLower) || 
                       _.includes(DiagFileDetailsNewConstants.healthCheckCategory, categoryLower) ||
                       _.includes(DiagFileDetailsNewConstants.ticketMaintenanceCategory, categoryLower);
            }
            else{
                return item;    
                
            }
        }


        $scope.$on('getPaginatedData', function (event,fromScreen,data) {
            if(fromScreen === DiagFileDetailsNewConstants.network){
                vm.diagFiles = data;
                vm.initialList = vm.diagFiles;

                if(!_.isEmpty(vm.initialList) && vm.initialList.length > 0){
                    displayAndFilterNetwork(vm.initialList[0].id, false);
                }
            }
            
        });

        var deregisterDiagDataFound = $rootScope.$on('diagDataFound', function (event,fromScreen) {
            if(fromScreen === DiagFileDetailsNewConstants.network){
                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                if(!_.isEmpty(vm.initialList) && vm.initialList.length > 0){
                    displayAndFilterNetwork(vm.initialList[0].id, false);
                }
            }
            
        });

        $scope.$on('$destroy', function () {
            if (typeof deregisterDiagDataFound === 'function') {
                deregisterDiagDataFound();
            }
        });


        function displayNetwork(id, networkVisible) {

            return $q.resolve().then(function () {

                var userContext = CacheService.getObject(CacheConstants.profil);
                var preferredLanguage = userContext.documentationFirstLanguage.code;
                var defaultLanguage = userContext.documentationSecondLanguage.code;

                var networkDataFromCache = getNetworkDetails(id);
                if (!networkVisible) {

                    if (!networkDataFromCache) {

                        blockUI.start();
                        return DiagFileBusinessService.getDiagFileById(id, preferredLanguage, defaultLanguage).then(function (
                            diagFileByIdResponse
                        ) {
                            vm.diagFile = diagFileByIdResponse;
                            var indexOfSelectedDoc;
                            _.map(vm.diagFiles, function (item,index) {
                                if (item.id === id) {
                                    indexOfSelectedDoc = index;
                                    _.extend(item, { networks: vm.diagFile.networks, networkVisible: true })
                                }
                            })

                            if (vm.typeMD === "B3" || vm.typeMD === 'B2') {
                                sortByEcu(indexOfSelectedDoc,"label");
                            } else if (vm.typeMD === "ADT") {
                                sortByEcu(indexOfSelectedDoc,"domainLabel");
                            }

                            return;
                        });
                    } else {
                        var selectedIndex;
                        _.map(vm.diagFiles, function (item,index) {
                            if (item.id === id) {
                                selectedIndex = index;
                                _.extend(item, { networks: item.networks, networkVisible: true })
                            }
                        })
                        if (vm.typeMD === "B3" || vm.typeMD === 'B2') {
                            sortByEcu(selectedIndex,"label");
                        } else if (vm.typeMD === "ADT") {
                            sortByEcu(selectedIndex,"domainLabel");
                        }

                        return;
                    }
                }
                else {
                    _.map(vm.diagFiles, function (item) {
                        if (item.id === id) {
                            _.extend(item, { networks: item.networks, networkVisible: false });
                        }

                    })

                    return;
                }


            }).then(function () {

                _.map(vm.diagFiles, function (item) {
                    if(vm.typeMD === 'ADT'){
                        if(item.mileage){
                            var mileageData = item.mileage.split(" ");
                            if(mileageData.length === 2){
                                var mileage = parseInt(mileageData[0]);
                                _.assign(item, { mileage: mileage+" " +mileageData[1]})
                            }
                            
                        }
                    }
                })
                
                if(vm.typeMD != 'ADT')
                    CacheService.setObject(CacheConstants.diagFilesList, vm.diagFiles);

            }).catch(function(err){
                if(err && err.status && err.status != 200){
                    toastr.error($translate.instant("DIAG_FILE_SEVICE_ERROR"));
                }else{
                    toastr.error($translate.instant("ERROR"));
                }
            }).finally(function(){
                blockUI.stop(); 
            })




        }

        function sortByEcu(indexOfSelectedDoc,label) {
            vm.diagFiles[indexOfSelectedDoc].networks.forEach(function (item) {
                item.ecus.sort(function (a, b) {
                    let aValue = a[label] || ""; 
                    let bValue = b[label] || "";
                    if (aValue.length === 0) {
                        return 1;
                    } else if (bValue.length === 0) {
                        return -1;
                    } else {
                        return aValue.localeCompare(bValue);
                    }
                })
            })
        }
        function getNetworkFilter() {
            vm.filterLoader = true;

            var isExpanded = _.filter(vm.diagFiles, function(item){
                return !item.networkVisible;
            })

            var isAllCollapsed = _.filter(vm.diagFiles, function(item){
                return item.networkVisible;
            }) 

            if(!isAllCollapsed || _.isEmpty(isAllCollapsed)){
                vm.firstFilter = [];
                vm.secondFilter = [];
            }

            if(isExpanded && !_.isEmpty(isExpanded)){
                vm.expandAll = false;
            }else{
                vm.expandAll = true;
            }
             var payload = {
                fullData: vm.diagFiles,
                dataToFilter: 'networks',
                visibility:'networkVisible',
                filterArray: vm.filterArray,
                systemFilter: ''
            }
            return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU).post(payload)
                .then(function (response) {
                    if (response) {
                        vm.filterArray = response;
                    } else {
                        toastr.error($translate.instant("FILTER_ERROR"));
                    }
                }).finally(function(){
                    vm.filterLoader = false; 
                })
        }

        function getNetworkDetails(id) {

            var diagFile = _.find(vm.diagFiles, { id: id });

            if (diagFile && !_.isEmpty(diagFile)) {
                return diagFile.networks;
            }

            return '';
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagUserJourney', diagUserJourney);

    /** @ngInject */
    function diagUserJourney() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/DiagnosticUserJourney/diagUserJourney.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagUserJourneyController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "="
            },
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')        
        .controller('diagUserJourneyController', diagUserJourneyController);

    /* @inject */
    function diagUserJourneyController(CacheService,CacheConstants,DiagFileBusinessService,
        blockUI,DiagFileDetailsNewConstants,$q,CustomFilterSortService,$rootScope,toastr,$scope,
        $translate ,$filter,RestUpgrade ) {

        var vm = this;
        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
        vm.diagFile = {};
        vm.collapssed = false;
        vm.diagFileFinalList = {};
        vm.firstFilter = [];
        vm.expandAll = false;
        vm.filterLoader = false;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.displayUserJourney = displayUserJourney;
        vm.finalCategory = finalCategory;
        vm.onExpandAll = onExpandAll;
        vm.getUserJourneyFilter = getUserJourneyFilter;
        vm.displayAndFilterUserJourney = displayAndFilterUserJourney;

        this.$onInit = function () {
            _.map(vm.diagFilesList, function (item) {                
                _.extend(item, { userJourneyVisible: false })
            })
            if(vm.typeMD === 'B3'){

                vm.filterArray = [
                    { label: 'ACTION_TYPE', key: 'code', values: [], selectAll: false, checkBox: true, filterData: false, custom: 'substring', noOfChar:3 },
                    { label: 'ALERTS_DESCRIPTION', key: 'name', values: [], selectAll: false, checkBox: false, filterData: false }
                ];
                vm.diagFileFinalList = _.filter(vm.diagFilesList,function(it){
                    return _.includes(DiagFileDetailsNewConstants.finalCategory,it.category.toLowerCase());
                })
            }else if(vm.typeMD === 'ADT'){
                vm.filterArray = [
                    { label: 'ALERTS_DESCRIPTION', key: 'code', values: [], selectAll: false, checkBox: false, filterData: false },
                    { label: 'COMMON_STATUS', key: 'status', values: [], selectAll: false, checkBox: true, filterData: false }
                ];
                vm.diagFileFinalList = vm.diagFilesList;
            }
            
            if (vm.diagFileFinalList && !_.isEmpty(vm.diagFileFinalList)){
                if(vm.typeMD != 'ADT')
                    if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                        displayAndFilterUserJourney(vm.diagFileFinalList[0].id,false);
                    }
            }

        };

        function finalCategory(item){
            if(vm.typeMD === 'B3' || vm.typeMD === 'B2-3'){
                return _.includes(DiagFileDetailsNewConstants.finalCategory,item.category);
            }
            else if(vm.typeMD === 'ADT' || vm.typeMD === 'B2'){
                return item;
            }
            else if(vm.typeMD === 'B3-ADT'){
                return _.includes(DiagFileDetailsNewConstants.finalCategory,item.category);
            }
            else{
                return item;
            }
        }

        function onExpandAll(expand) {

            if (vm.diagFileFinalList && !_.isEmpty(vm.diagFileFinalList)) {
                var promiseArray = _.map(vm.diagFileFinalList, function (item) {
                    return displayUserJourney(item.id, expand);
                });
                $q.all(promiseArray).then(function () {
                    getUserJourneyFilter();
                })
            }

        }

        function displayAndFilterUserJourney(id, userJourneyVisible) {
            displayUserJourney(id, userJourneyVisible).then(function () {
                getUserJourneyFilter();
            });
        }

        $scope.$on('getPaginatedData', function (event,fromScreen,data) {
            if(fromScreen === DiagFileDetailsNewConstants.userJourney){
                vm.diagFilesList = data;
                vm.diagFileFinalList = vm.diagFilesList;

                if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                    displayAndFilterUserJourney(vm.diagFileFinalList[0].id, false);
                }
            }
            
        });

        var deregisterDiagDataFound = $rootScope.$on('diagDataFound', function (event,fromScreen) {
            if(fromScreen === DiagFileDetailsNewConstants.userJourney){
                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                    displayAndFilterUserJourney(vm.diagFileFinalList[0].id, false);
                }
            }
            
        });

        $scope.$on('$destroy', function () {
            if (typeof deregisterDiagDataFound === 'function') {
                deregisterDiagDataFound();
            }
        });

        
        function displayUserJourney(id,userJourneyVisible) {

            return $q.resolve().then(function () {
                var userContext = CacheService.getObject(CacheConstants.profil);
                var preferredLanguage = userContext.documentationFirstLanguage.code;
                var defaultLanguage = userContext.documentationSecondLanguage.code;
                if (!userJourneyVisible){
                
                    for (var i=0; i< vm.diagFilesList.length; i++){
                        if (vm.diagFilesList[i].id == id){
                            if (!vm.diagFilesList[i].userjourney){
                                blockUI.start();
                                return DiagFileBusinessService.getDiagFileById(id, preferredLanguage, defaultLanguage).then(function(
                                    diagFileByIdResponse
                                ) {
                                    vm.diagFile = diagFileByIdResponse;
                                    return sortActivities(vm.diagFile.activities,id,true).then(function(){
                                        return;
                                    });
                                                                   
                                });
                            }
                            else{
                                return sortActivities(vm.diagFilesList[i].userjourney,id,false).then(function(){
                                    return;
                                });
                            }
                            
                        }
                        
                    }
                }
                else{
                    _.find(vm.diagFilesList,function (item){
                        if (item.id == id){
                            item.userJourneyVisible = false;
                        }

                    }) 

                    return;
                }
            }).catch(function(err){
                if(err && err.status && err.status != 200){
                    toastr.error($translate.instant("DIAG_FILE_SEVICE_ERROR"));
                }else{
                    toastr.error($translate.instant("ERROR"));
                }
            }).finally(function(){
                blockUI.stop(); 
            })
            
        }

        function getUserJourneyFilter(){
            vm.filterLoader = true;
            var isExpanded = _.filter(vm.diagFileFinalList, function(item){
                return !item.userJourneyVisible;
            })

            if(isExpanded && !_.isEmpty(isExpanded)){
                vm.expandAll = false;
            }else{
                vm.expandAll = true;
            }

            var isAllCollapsed = _.filter(vm.diagFileFinalList, function(item){
                return item.userJourneyVisible;
            }) 

            if(!isAllCollapsed || _.isEmpty(isAllCollapsed)){
                vm.firstFilter = [];
            }
            var payload = {
                fullData: vm.diagFilesList,
                dataToFilter: 'userjourney',
                visibility:'userJourneyVisible',
                filterArray: vm.filterArray,
                systemFilter: ''
            }
            return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU).post(payload)
            .then(function (response) {
                if (response) {
                    vm.filterArray = response;
                } else {
                    toastr.error($translate.instant("FILTER_ERROR"));
                }
            }).finally(function(){
                vm.filterLoader = false; 
            })
        }

        function sortActivities(activities,id,isCalled) {

            return $q.resolve().then(function () {
                var sortedActivities = [];
                sortedActivities = activities;
                
                if (isCalled){
                    sortedActivities.reverse();
                }
                if(vm.typeMD === 'ADT' && !_.isEmpty(sortedActivities)){
                    sortedActivities.forEach(function(element) {
                        var newDate = element.startDateTime ? element.startDateTime :(element.endDateTime ? element.endDateTime: -1) ;
                        _.extend(element, { refinedDate: newDate})
                    });                    
                    sortedActivities = $filter('orderBy')(sortedActivities,'refinedDate', ['desc']);
                }
                _.map(vm.diagFilesList, function (item) {

                    if(vm.typeMD === 'ADT'){
                        if(item.mileage){
                            var mileageData = item.mileage.split(" ");
                            if(mileageData.length === 2){
                                var mileage = parseInt(mileageData[0]);
                                _.assign(item, { mileage: mileage+" " +mileageData[1]})
                            }
                            
                        }
                    }

                    if (item.id === id) {
                        _.extend(item, { userjourney: sortedActivities, userJourneyVisible : true })
                    } 
                    
                })

                if(vm.typeMD != 'ADT')
                    CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);
                return;
            })
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('diagFileReprogramming', diagFileReprogramming);

    /** @ngInject */
    function diagFileReprogramming() {

        var directive = {
            templateUrl: 'app/components/car/searchByDiagnostic/DiagnosticReprogramming/diagFileReprogramming.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagFileReprogrammingController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('diagFileReprogrammingController', diagFileReprogrammingController);

    /* @inject */
    function diagFileReprogrammingController(CacheService, DiagFileBusinessService, blockUI, DiagFileReprogrammingConstants, $translate, $filter, CacheConstants, ActisFicModalService) {
        var vm = this;
        vm.pageSize = 20;
        vm.currentTablePage = 1;
        vm.getTableData = getTableData;
        vm.openDetails = openDetails;
        vm.colourCheckVespa = colourCheckVespa;
        vm.colourCheckDiag = colourCheckDiag;
        vm.selectCsvVespa = selectCsvVespa;
        vm.csvShowVespa = false;
        vm.buttonPopUp = false;
        //vm.handlePopUp = handlePopUp;
        var carContext = CacheService.getCarContext();
        var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
        vm.currentDate = $filter('date')(new Date(), 'yyyyMMdd');
        
        vm.headerValue = {};
        vm.columnValue = [];
        vm.noData = false;
        this.$onInit = function () {
            getReprogrammingHistoryList();
        }

        function getReprogrammingHistoryList() {
            if (carContext && carContext.vin) {
                blockUI.start();
                DiagFileBusinessService.getReprogrammingHistory(carContext.vin, vm.currentTablePage,vm.pageSize).then(function (response) {
                    if (response && !_.isEmpty(response)) {
                        vm.reprogrammingHistory = angular.copy(response);
                        var numberOfElements = vm.reprogrammingHistory.totalElements / vm.pageSize;
                        var isNumber = isInteger(numberOfElements);
                        if (isNumber) {
                            vm.numberOfPagesToDisplay = numberOfElements;
                        } else {
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfElements);
                        }
                        if (vm.reprogrammingHistory.traceabilityInformation) {
                            vm.traceabilityInformationResponse = vm.reprogrammingHistory.traceabilityInformation;
                            vm.traceabilityInformationResponse.forEach(function(item){
                                _.assign(item, { isAdditionalinfo: false })
                            })
                        }
                        vm.headerValue = {
                            'vin': "Vin",
                            'requestType': $translate.instant('VESPA_REQUEST_TYPE'),
                            'country': $translate.instant('VESPA_COUNTRY'),
                            'requestReceptionDate': $translate.instant('VESPA_REQUEST_RECEPTION_DATE'),
                            'vehicleFamily': $translate.instant('VESPA_VEHICLE_FAMILY'),
                            'originTool': $translate.instant('VESPA_ORGIN_TOOL'),
                            'vespaReturnCode': $translate.instant('VESPA_RETURN_CODE'),
                            'ecuAddress': $translate.instant('VESPA_ECU_ADDRESS'),
                            'ecuFlashingNetwork': $translate.instant('VESPA_ECU_FLASHING_NETWORK'),
                            'diagToolResultCode': $translate.instant('VESPA_DIAG_TOOL_RESULT_CODE'),
                            'transactionId': $translate.instant('VESPA_TRANSACTION_ID'),
                            'asRefVehicleBase':$translate.instant('AS_REF_VEHICLE_BASE'),
                            'ecuReferenece':$translate.instant('ECU_REFERNCE'),
                            'ecuHwRefA':$translate.instant('ECU_HW_RFEF_A'),
                            'plantRefVehicleBase':$translate.instant('PLANT_REF_IN_VEHICLE_BASE'),
                            'plantRcuVehicleBase':$translate.instant('PLANT_RCU_VEHICLE_BASE'),
                            'plantConfigFile':$translate.instant('PLANT_CONFIG_FILE'),
                            'ecuRuc':$translate.instant('ECU_RUC'),
                            'dealerNumber':$translate.instant('DEALER_NUMBER'),
                            'userId':$translate.instant('USER_ID'),
                            'duration':$translate.instant('DURATION'),
                            'confFileNo':$translate.instant('CONFIG_FILE_NUMBER_USED'),
                            'ecupartNumber':$translate.instant('ECU_PART_NUMBER'),'fileDownloadDuration':$translate.instant('FILE_DOWNLOADING_DURATION'),
                            'reprogFileNumber':$translate.instant('REPROG_FILE_NUMBER_USED'),
                            'finalsoftware':$translate.instant('FINAL_SOFTWARE_REFERENCE_READ'),'ecuSerialNumber':$translate.instant('ECU_SERIAL_NUMBER'),'lastFailedQuery':$translate.instant('LAST_FAILED_QUERY_FRAME'),'ecuSparepartNo':$translate.instant('ECU_SPARE_PART_NUMBER'),'newEcuRuc':$translate.instant('NEW_ECU_RUC'),
                            'previousecuFingerprint':$translate.instant('PREVIOUS_ECU_FINGERPRINT'),
                            'previousecuHarshread':$translate.instant('PREVIOUS_ECU_HASH_READ'),
                            'vinCheck':$translate.instant('VIN_CHECK'),
                            'vinUnused':$translate.instant('VIN_UNUSED'),
                            'vespaReturnTracebility':$translate.instant('VESPA_RETURN_TRACEABILITY_CODE'), 'vespaBaseCode':$translate.instant('VESPA_BASE_TRACEABILITY_RESPONSE'), 'bvaTracebiltyResponse':$translate.instant('BVA_TRACEABILITY_RESPONSE'),
                        }

                        vm.columnValue = [];
                        vm.traceabilityInformationResponse.forEach(function (item) {
                            vm.columnValueList = {
                                'vin': carContext.vin,
                                'requestType': $translate.instant(item.requestType) ,
                                'country': item.diagnosticToolRequest.toolLocationArea ? item.diagnosticToolRequest.toolLocationArea :'',
                                'requestReceptionDate': item.diagnosticToolRequest.requestReceptionDate ? item.diagnosticToolRequest.requestReceptionDate :'',
                                'vehicleFamily': item.diagnosticToolRequest.vehicleFamily ? item.diagnosticToolRequest.vehicleFamily:'',
                                'originTool': item.diagnosticToolRequest.toolOrigin ? item.diagnosticToolRequest.toolOrigin:'',
                                'vespaReturnCode': vespaCode(item)? vespaCode(item):'',
                                'ecuAddress': item.diagnosticToolRequest.ecuAddress ? item.diagnosticToolRequest.ecuAddress :'',
                                'ecuFlashingNetwork': item.diagnosticToolRequest.ecuNetworkAccessType ? item.diagnosticToolRequest.ecuNetworkAccessType :'',
                                'diagToolResultCode': diagCode(item)? diagCode(item):'', 
                                'transactionId': item.diagnosticToolRequest.transactionID ? item.diagnosticToolRequest.transactionID:'',
                                'asRefVehicleBase': item.reprogrammingFileRequestResult.afterSalesEcuReferenceInVehiclebase ? item.reprogrammingFileRequestResult.afterSalesEcuReferenceInVehiclebase:'',
                                'ecuReferenece': item.diagnosticToolRequest.ecuReference ? item.diagnosticToolRequest.ecuReference:'',
                                'ecuHwRefA': item.diagnosticToolRequest.ecuHardwareRefa ?item.diagnosticToolRequest.ecuHardwareRefa:'',
                                'plantRefVehicleBase': item.reprogrammingFileRequestResult.plantEcuReferenceInVehiclebase ? item.reprogrammingFileRequestResult.plantEcuReferenceInVehiclebase:'',
                                'plantRcuVehicleBase': item.configurationFileRequestResult.ecuKm0ConfigFileReferenceLink ?item.configurationFileRequestResult.ecuKm0ConfigFileReferenceLink:'',
                                'plantConfigFile': item.configurationFileRequestResult.ecuKm0ConfigFileNumber ? item.configurationFileRequestResult.ecuKm0ConfigFileNumber:'',
                                'ecuRuc': item.diagnosticToolRequest.ecuConfigurationFileReferenceLink ?item.diagnosticToolRequest.ecuConfigurationFileReferenceLink:'',
                                'dealerNumber':item.diagnosticToolRequest.dealerNumber ? item.diagnosticToolRequest.dealerNumber:'',
                                'userId':item.diagnosticToolRequest.toolUserId ? item.diagnosticToolRequest.toolUserId:'',
                                'duration':item.diagnosticToolRequest.duration ? item.diagnosticToolRequest.duration:'',
                               'confFileNo':item.diagToolConfigResult.ecuconfigFileNumber ? item.diagToolConfigResult.ecuconfigFileNumber:'',
                                'ecupartNumber':item.diagToolConfigResult.vehicleManufacturerSparePartNumber ? item.diagToolConfigResult.vehicleManufacturerSparePartNumber:'',
                                'fileDownloadDuration':item.diagToolReprogResult.reprogFileDownloadingTime ? item.diagToolReprogResult.reprogFileDownloadingTime:'',
                                'reprogFileNumber':item.diagToolReprogResult.ecuReprogFileNumber ? item.diagToolReprogResult.ecuReprogFileNumber:'',
                                'finalsoftware': item.diagToolReprogResult.ecuSoftwareReference ? item.diagToolReprogResult.ecuSoftwareReference:'', 
                                'ecuSerialNumber': item.diagToolReprogResult.ecuSerialNumber ?item.diagToolReprogResult.ecuSerialNumber:'', 
                                'lastFailedQuery': item.diagToolReprogResult.ecuReprogLastFrame ? item.diagToolReprogResult.ecuReprogLastFrame:'', 
                                'ecuSparepartNo': item.diagToolReprogResult.vehicleManufacturerSparePartNumber ? item.diagToolReprogResult.vehicleManufacturerSparePartNumber:'', 
                                'newEcuRuc': item.diagToolReprogResult.ecuConfigurationFileReferenceLink ? item.diagToolReprogResult.ecuConfigurationFileReferenceLink:'',
                                'previousecuFingerprint': item.diagToolReprogResult.ecuFingerprint ? item.diagToolReprogResult.ecuFingerprint:'',
                                'previousecuHarshread': item.diagToolReprogResult.ecuHashRead ?item.diagToolReprogResult.ecuHashRead:'',
                                'vinCheck': item.diagToolReprogResult.vinCheck ? item.diagToolReprogResult.vinCheck:'',
                                'vinUnused': item.diagToolReprogResult.vinUnused ? item.diagToolReprogResult.vinUnused:'',
                                'vespaReturnTracebility': item.traceabilityRequestResult.vespaTraceabilityReturnCode ?item.traceabilityRequestResult.vespaTraceabilityReturnCode:'', 
                                'vespaBaseCode': item.traceabilityRequestResult.vehicleBaseTraceabilityResponse ? item.traceabilityRequestResult.vehicleBaseTraceabilityResponse:'', 
                                'bvaTracebiltyResponse': item.traceabilityRequestResult.bvatraceabilityReturnCode ? item.traceabilityRequestResult.bvatraceabilityReturnCode:''

                            };
                            vm.columnValue.push(vm.columnValueList);
                        })
                        if (vm.traceabilityInformationResponse.length > 80000) {
                            vm.buttonPopUp = true;
                        } else {
                            vm.csvShowVespa = true;
                        }
                    } else {
                        vm.noData = true;
                    }
                }).catch(function (error) {

                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        function vespaCode(item) {
            var vespaReturnCode
            switch (item.requestType) {
                case 'Reprogramming':
                    vespaReturnCode = item.reprogrammingFileRequestResult.returnCode;
                    break;
                case 'Configuration':
                    vespaReturnCode = item.configurationFileRequestResult.returnCode;
                    break;
                case 'Traceability':
                    vespaReturnCode = item.traceabilityRequestResult.vespaTraceabilityReturnCode;
                    break;
                case 'TRACEABILITY_CONFIG_TRACE':
                    vespaReturnCode = item.traceabilityRequestResult.vespaTraceabilityReturnCode;
                    break;
            }
            return vespaReturnCode;
        }

        function diagCode(item) {
            var diagToolResultcode
            switch (item.requestType) {
                case 'Reprogramming':
                    diagToolResultcode = item.diagToolReprogResult.reprogrammingResult;
                    break;
                case 'Configuration':
                    diagToolResultcode = item.diagToolReprogResult.reprogrammingResult;
                    break;
                case 'Traceability':
                    diagToolResultcode = item.diagToolReprogResult.reprogrammingResult;
                    break;
                case 'TRACEABILITY_CONFIG_TRACE':
                    diagToolResultcode = item.diagToolConfigResult.configurationResult;
                    break;
            }
            return diagToolResultcode;

        }
        // function handlePopUp() {
        //     var body = angular.element(document.body);
        //     var modalParams = {
        //         body: body,
        //         designation: '',
        //         isList: false,
        //         title: "VESPA_EXPORT_MSG",
        //         ref: ''
        //     };
        //     ActisFicModalService.showModal(modalParams)
        // }

        function openDetails(element, type) {
            var index = _.findIndex(vm.traceabilityInformationResponse, function (item) {
                return item.diagnosticToolRequest == element.diagnosticToolRequest;

            })
            vm.traceabilityInformationResponse.forEach(function (item, index1) {
                if (index != index1) {
                    _.assign(item, { isAdditionalinfo: false })
                }
            })
            vm.traceabilityInformationResponse[index].isAdditionalinfo = !vm.traceabilityInformationResponse[index].isAdditionalinfo;
            vm.detailObj = [];
            var tempObj = [];
            var request = DiagFileReprogrammingConstants.requestTypes;
            var ecuData = '';

            if (vm.traceabilityInformationResponse[index].requestType == 'Reprogramming') {
                var data = vm.traceabilityInformationResponse[index].reprogrammingFileRequestResult.ecuDependencies;
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        if (ecuData == '')
                            ecuData = data[i].ecuType;
                        else
                            ecuData = ecuData + ';' + data[i].ecuType;
                    }
                }
            }
            DiagFileReprogrammingConstants[request[type]].forEach(function (item) {
                var dataCheck = _.get(vm.traceabilityInformationResponse[index], item.data) ? _.get(vm.traceabilityInformationResponse[index], item.data) : '';
                tempObj.push(
                    { label: item.header, value: dataCheck })
            })
            if (vm.traceabilityInformationResponse[index].requestType == 'Reprogramming') {
                tempObj.push(
                    { label: $translate.instant('ECU_DEPENDENCY'), value: ecuData }
                )
            }
            var temp = [];
            tempObj.forEach(function (item, index) {
                temp.push(item);
                if ((index + 1) % 6 == 0) {
                    vm.detailObj.push(temp);
                    temp = [];
                } else if ((index + 1) == tempObj.length && (index + 1) % 6 != 0) {
                    vm.detailObj.push(temp);
                }
            })

        }

        function colourCheckVespa(item) {
            var colourVespaReprogramming = DiagFileReprogrammingConstants.reprogVespaColour;
            var colourVespaConfiguration = DiagFileReprogrammingConstants.configVespaColour;
            var colourVespaConfigTracebility = DiagFileReprogrammingConstants.configTraceVespaColour;
            var colourVespaTracebility = DiagFileReprogrammingConstants.traceVespaColour;
            var colourClassVespa = '';

            switch (item.requestType) {
                case 'Reprogramming':
                    if (colourVespaReprogramming.includes(item.reprogrammingFileRequestResult.returnCode)){
                        colourClassVespa = 'bgGreen'
                    }else if(!item.reprogrammingFileRequestResult.returnCode){
                        colourClassVespa = '' 
                    }
                    else{
                        colourClassVespa = 'bgRed'
                    }
                    break;
                case 'Configuration':
                    if (colourVespaConfiguration.includes(item.configurationFileRequestResult.returnCode)) {
                        colourClassVespa = 'bgGreen'
                    }else if(!item.configurationFileRequestResult.returnCode){
                        colourClassVespa = ''
                    }
                    else{
                        colourClassVespa = 'bgRed'
                    }
                    break;
                case 'TRACEABILITY_CONFIG_TRACE':
                    if (colourVespaConfigTracebility.includes(item.traceabilityRequestResult.vespaTraceabilityReturnCode)) {
                        colourClassVespa = 'bgGreen'
                    }else if(!item.traceabilityRequestResult.vespaTraceabilityReturnCode){
                        colourClassVespa = ''
                    }
                    else{
                        colourClassVespa = 'bgRed'
                    }
                    break;
                case 'Traceability':
                    if (colourVespaTracebility.includes(item.traceabilityRequestResult.vespaTraceabilityReturnCode)) {
                        colourClassVespa = 'bgGreen'
                    }else if(!item.traceabilityRequestResult.vespaTraceabilityReturnCode){
                        colourClassVespa = '' 
                    }
                    else{
                        colourClassVespa = 'bgRed'
                    }
                    break;
                default:
                    colourClassVespa = ''
                    break;
            }

            return colourClassVespa

        }

        function colourCheckDiag(item) {
            var colourDiagTracebility = DiagFileReprogrammingConstants.traceDiagColour;
            var colourDiagConfigTracebility = DiagFileReprogrammingConstants.configTraceDiagColour;
            var colourClass = '';
            switch (item.requestType) {
                case 'Traceability':
                    if (colourDiagTracebility.includes(item.diagToolReprogResult.reprogrammingResult)) {
                        colourClass = 'bgGreen'
                    } else if (item.diagToolReprogResult.reprogrammingResult == 'V001') {
                        colourClass = 'bgGray'
                    } else if(!item.diagToolReprogResult.reprogrammingResult){
                        colourClass = ''
                    }
                    else{
                        colourClass = 'bgRed'
                    }
                    
                    break;
                case 'TRACEABILITY_CONFIG_TRACE':
                    if (colourDiagConfigTracebility.includes(item.diagToolConfigResult.configurationResult)) {
                        colourClass = 'bgGreen'
                    }else if(!item.diagToolConfigResult.configurationResult){
                        colourClass = ''
                    }
                    else{
                        colourClass = 'bgRed'
                    }
                    break;
                  default:
                    colourClass = ''
                    break;

            }

            return colourClass
        }

        function selectCsvVespa() {
            vm.csvShowVespa = true;
        }



        function getTableData(page) {
            if (page != vm.currentTablePage) {
                vm.currentTablePage = page;
                vm.csvShowVespa = false;
                getReprogrammingHistoryList();
            }
        }

        function isInteger(totalItems) {
            return (typeof totalItems === 'number') && (totalItems % 1 === 0);
        }

    }
    }) ();

angular.module('phenix').constant('DiagFileReprogrammingConstants', {


    requestTypes : {'Reprogramming': 'reprogData','Traceability':'traceData','Configuration':'configData','TRACEABILITY_CONFIG_TRACE':'configTraceabilityData'},
    // will be added in the future {'Unlocking':'unlockData','Nissan Unlocking':'nissanunlockData'}

    reprogVespaColour: ['R062','R063','R064','R065','R066','R069','R070'],
    traceVespaColour: ['T000'],
    configVespaColour: ['C000'],
    configTraceVespaColour:['T000'],

    traceDiagColour: ['R000','R045','0046','R066','R069','R070'],
    configTraceDiagColour: ['C000','C045'],

    traceData: [

        {header : 'DEALER_NUMBER', data : 'diagnosticToolRequest.dealerNumber'},
        {header : 'USER_ID', data : 'diagnosticToolRequest.toolUserId'},
        {header : 'VESPA_REQUEST_RECEPTION_DATE', data : 'diagnosticToolRequest.requestReceptionDate'},
        {header:'DURATION', data:'diagnosticToolRequest.duration'},
        {header : 'FILE_DOWNLOADING_DURATION',data :'diagToolReprogResult.reprogFileDownloadingTime' },
        {header : 'ECU_WRITING_DURATION',data : 'diagToolReprogResult.reprogFileWritingECUTime'},
        {header : 'REPROG_FILE_NUMBER_USED', data : 'diagToolReprogResult.ecuReprogFileNumber'},
        {header : 'DIAG_TOOL_RESULT_CODE', data : 'diagToolReprogResult.reprogrammingResult'},
        {header : 'FINAL_SOFTWARE_REFERENCE_READ', data : 'diagToolReprogResult.ecuSoftwareReference'},
        {header : 'ECU_SERIAL_NUMBER', data : 'diagToolReprogResult.ecuSerialNumber'},
        {header : 'LAST_FAILED_QUERY_FRAME', data : 'diagToolReprogResult.ecuReprogLastFrame'},
        {header : 'ECU_SPARE_PART_NUMBER', data : 'diagToolReprogResult.vehicleManufacturerSparePartNumber'},
        {header : 'NEW_ECU_RUC',data:'diagToolReprogResult.ecuConfigurationFileReferenceLink'},
        {header : 'PREVIOUS_ECU_FINGERPRINT', data : 'diagToolReprogResult.ecuFingerprint'},
        {header : 'PREVIOUS_ECU_HASH_READ', data : 'diagToolReprogResult.ecuHashRead'},
        {header : 'VIN_CHECK', data : 'diagToolReprogResult.vinCheck'},
        {header : 'VIN_UNUSED', data : 'diagToolReprogResult.vinUnused'},
        {header : 'VESPA_RETURN_TRACEABILITY_CODE ', data : 'traceabilityRequestResult.vespaTraceabilityReturnCode'},
        {header : 'VESPA_BASE_TRACEABILITY_RESPONSE ', data : 'traceabilityRequestResult.vehicleBaseTraceabilityResponse'},
        {header : 'BVA_TRACEABILITY_RESPONSE ', data : 'traceabilityRequestResult.bvatraceabilityReturnCode'}
    ],

    reprogData: [

        {header:'DEALER_NUMBER', data:'diagnosticToolRequest.dealerNumber'},
        {header:'USER_ID', data:'diagnosticToolRequest.toolUserId'},
        {header:'VESPA_REQUEST_RECEPTION_DATE', data:'diagnosticToolRequest.requestReceptionDate'},
        {header:'DURATION', data:'diagnosticToolRequest.duration'},
        {header:'REPAIR_ORDER', data:'diagnosticToolRequest.repairOrder'},
        {header:'RCC_FILED_IN',data:'diagnosticToolRequest.rccFilled'},
        {header:'TRANSFER_RULE',data:'diagnosticToolRequest.transferRule'},
        {header:'RELEASED_FILLED_IN', data:'diagnosticToolRequest.multiEcuRelease'},
        {header:'VEHICLE_FAMILY', data:'diagnosticToolRequest.vehicleFamily'},
        {header:'ECU_ADDRESS', data:'diagnosticToolRequest.ecuAddress'},
        {header:'ECU_FLASING_NETWORK', data:'diagnosticToolRequest.ecuNetworkAccessType'},
        {header:'ECU_REFERNCE', data:'diagnosticToolRequest.ecuReference'},
        {header:'ECU_HW_RFEF_A', data:'diagnosticToolRequest.ecuHardwareRefa'},
        {header:'ECU_FAMILY_ID',data:'reprogrammingFileRequestResult.ecuFamilyID'},
        {header:'VEHICLE_BASE_REF_RESPONSE',data:'reprogrammingFileRequestResult.vehicleBaseRefResponse'},
        {header:'PLANT_REF_IN_VEHICLE_BASE',data:'reprogrammingFileRequestResult.plantEcuReferenceInVehiclebase'},
        {header:'AS_REF_VEHICLE_BASE',data:'reprogrammingFileRequestResult.afterSalesEcuReferenceInVehiclebase'},
        {header:'REFERNCE_USED_IDENTIFY_RCC',data:'reprogrammingFileRequestResult.referenceUsedToIdentifyEcuReprogCompatibilityCriteria'},
        {header:'VEHICLE_BASE_MTC_RESPONSE',data:'reprogrammingFileRequestResult.vehicleBaseMTCResponse'},
        {header:'VESPA_REPROGRAMING_RESPONSE_CODE',data:'reprogrammingFileRequestResult.returnCode'},
        {header:'RCC_NAME',data:'reprogrammingFileRequestResult.ecuCompatibilityCriteriaName'},
        {header:'ECU_REFERENCE_CATEGORY', data:'reprogrammingFileRequestResult.ecuReferenceCategory'},
        {header:'ECU_TYPE', data:'reprogrammingFileRequestResult.ecuType'},
        {header:'FILE_TYPE', data:'reprogrammingFileRequestResult.fileType'},
        {header:'FILE_NAME',data:'reprogrammingFileRequestResult.ecuReprogFileNumber'},
        {header:'FILE_SIZE',data:'reprogrammingFileRequestResult.ecuReprogFileSize'},
        {header:'SW_DISTANCE', data:'reprogrammingFileRequestResult.ecuSwDistance'},
        {header:'SW_LIST', data:'reprogrammingFileRequestResult.ecuSwList'}
    ],

    configData: [
        {header:'DEALER_NUMBER', data:'diagnosticToolRequest.dealerNumber'},
        {header:'USER_ID', data:'diagnosticToolRequest.toolUserId'},
        {header:'VESPA_REQUEST_RECEPTION_DATE', data:'diagnosticToolRequest.requestReceptionDate'},
        {header:'DURATION', data:'diagnosticToolRequest.duration'},
        {header:'ECU_ADDRESS', data:'diagnosticToolRequest.ecuAddress'},
        {header:'RELEASED_FILLED_IN', data:'diagnosticToolRequest.multiEcuRelease'},
        {header:'ECU_FAMILY_ID',data:'configurationFileRequestResult.ecuFamilyID'},
        {header:'VEHICLE_BASE_RESPONSE',data:'configurationFileRequestResult.vehicleBaseResponse'},
        {header:'PLANT_RCU_VEHICLE_BASE',data:'configurationFileRequestResult.ecuKm0ConfigFileReferenceLink'},
        {header:'PLANT_CONFIG_FILE',data:'configurationFileRequestResult.ecuKm0ConfigFileNumber'},
        {header:'ECU_RUC',data:'diagnosticToolRequest.ecuConfigurationFileReferenceLink'},
        {header:'VESPA_CONFIGURATION_RETURN_CODE',data:'configurationFileRequestResult.returnCode'},
        {header:'CCC_Name',data:'configurationFileRequestResult.ecuCompatibilityCriteriaName'},
        {header:'FILE_NAME',data:'configurationFileRequestResult.ecuTargetConfigFileNumber'}
    ],

    unlockData:[
       {header:'DEALER_NUMBER', data:'diagnosticToolRequest.dealerNumber'},
       {header:'USER_ID', data:'diagnosticToolRequest.toolUserId'},
       {header:'VESPA_REQUEST_RECEPTION_DATE', data:'diagnosticToolRequest.requestReceptionDate'},
       {header:'DURATION',data:'diagnosticToolRequest.durationSeconds'},
       {header:'UNLOCK_TYPE',data:'securityAccess.unlocktype'},
       {header:'VESPA_UNLOCKING_RETURN_CODE',data:'securityAccess.unlockReturnCode'},
       {header:'PUBLICSRV_DATA',data:'securityAccess.ecuPublicServiceData'},
       {header:'CLIENT_APPLICATION',data:'securityAccess.clientApplication'}
    ],

    nissanunlockData:[
       {header:'DEALER_NUMBER', data:'diagnosticToolRequest.dealerNumber'},
       {header:'USER_ID', data:'diagnosticToolRequest.toolUserId'},
       {header:'VESPA_REQUEST_RECEPTION_DATE', data:'diagnosticToolRequest.requestReceptionDate'},
       {header:'FILE_DOWNLOADING_DURATION', data:'diagToolReprogResult.fileDownloadTime'},
       {header:'ALGO_TYPE',data:'nissanInfo.algoType'},
       {header:'VESPA_UNLOCKING_RETURN_CODE',data:'securityAccess.unlockReturnCode'},
       {header:'NISSAN_DATA',data:'nissanInfo.nissanData'}
    ],

    configTraceabilityData: [
       {header:'DEALER_NUMBER', data:'diagnosticToolRequest.dealerNumber'},
       {header:'USER_ID', data:'diagnosticToolRequest.toolUserId'},
       {header:'VESPA_REQUEST_RECEPTION_DATE', data:'diagnosticToolRequest.requestReceptionDate'},
       {header:'DURATION', data:'diagnosticToolRequest.duration'},
       {header:'CONFIG_FILE_NUMBER_USED', data:'diagToolConfigResult.ecuconfigFileNumber'},
       {header : 'DIAG_TOOL_RESULT_CODE', data : 'diagToolConfigResult.configurationResult'},
       {header:'ECU_ADDRESS', data:'diagnosticToolRequest.ecuAddress'},
       {header : 'ECU_SERIAL_NUMBER', data : 'diagToolConfigResult.ecuserialNumber'},
       {header : 'ECU_PART_NUMBER', data : 'diagToolConfigResult.vehicleManufacturerSparePartNumber'},
       {header : 'VIN_CHECK', data : 'diagToolConfigResult.vinCheck'},
       {header : 'VIN_UNUSED', data : 'diagToolConfigResult.vinUnused'},
       {header : 'VESPA_RETURN_TRACEABILITY_CODE ', data : 'traceabilityRequestResult.vespaTraceabilityReturnCode'},
       {header : 'VESPA_BASE_TRACEABILITY_RESPONSE ', data : 'traceabilityRequestResult.vehicleBaseTraceabilityResponse'},

    ]

  
  });
(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagNvPreparation', diagNvPreparation);

    /** @ngInject */
    function diagNvPreparation() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/DiagnosticNvPreparation/diagNvPreparation.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagNvPreparationController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "="
            },
            bindToController: true
        };
        return directive;
    }

})();
(function () {
    'use strict';

    angular
        .module('phenix')        
        .controller('diagNvPreparationController', diagNvPreparationController);

    /* @inject */
    function diagNvPreparationController(CacheService, CacheConstants, DiagFileBusinessService,
        blockUI, DiagFileDetailsNewConstants, $q, CustomFilterSortService, $rootScope, toastr, $scope, $http,
        $translate, RestUpgrade) {

        var vm = this;      

        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
        vm.diagFile = {};
        vm.ecuLabelList = {};
        vm.collapssed = false;
        vm.diagFileFinalList = [];
        vm.firstFilter = [];
        vm.secondFilter = [];
        vm.thirdFilter = [];
        vm.fullDataFilter = [];
        vm.filterArray = [];
        vm.expandAll = false;
        vm.filterLoader = false;
       

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.displayNvPreparation = displayNvPreparation;
        vm.showEcuLabelValue = showEcuLabelValue;
        vm.initialCategory = initialCategory;
        vm.onExpandAll = onExpandAll;
        vm.getNvFilter = getNvFilter;
        vm.displayAndFilterNv = displayAndFilterNv;

        this.$onInit = function () {

            if (vm.diagFilesList && !_.isEmpty(vm.diagFilesList)) {
            _.map(vm.diagFilesList, function (item) {                
                _.extend(item, { nvPreparationVisible: false })
            })

            if(vm.typeMD === 'B3'){

                showEcuLabelValue();

                vm.diagFileFinalList = _.filter(vm.diagFilesList,function(it){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,it.category.toLowerCase());
                });

                vm.filterArray = [
                    { label: 'ECU_DOMAIN_ID', key: 'ocvDetails.ecuDomainId', values: [], selectAll: false, checkBox: true, custom: 'json' },
                    { label: 'CODE_TM', key: 'ocvDetails.values.code', values: [], selectAll: false, checkBox: true }
                ];
            }
            else if(vm.typeMD === 'ADT'){

                vm.diagFileFinalList = _.filter(vm.diagFilesList,function(it){
                    return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,it.category.toLowerCase());
                });

                vm.filterArray = [
                    { label: 'ECU_ID', key: 'ocvDetails.ecuId', values: [], selectAll: false, checkBox: true },
                    { label: 'CODE_TM', key: 'ocvDetails.values.code', values: [], selectAll: false, checkBox: true }
                ];
                
            }

            if (vm.diagFileFinalList && !_.isEmpty(vm.diagFileFinalList)){
                if(vm.typeMD != 'ADT')
                    if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                        displayAndFilterNv(vm.diagFileFinalList[0].id,false);
                    }
            }
           }

        };

        function showEcuLabelValue(){
            $http.get('../../app/components/car/searchByDiagnostic/DiagnosticNvPreparation/diagNvPreparation.json').then(function (response){
                vm.ecuLabelList = response.data;
            });
          }

        function onExpandAll(expand) {

            if (vm.diagFilesList && !_.isEmpty(vm.diagFilesList)) {
                var promiseArray = _.map(vm.diagFilesList, function (item) {
                    return displayNvPreparation(item.id, expand);
                });
                $q.all(promiseArray).then(function(){
                    getNvFilter();
                })
            }

        }
        function displayAndFilterNv(id,nvPreparationVisible){
            displayNvPreparation(id, nvPreparationVisible).then(function(){
                getNvFilter();
            });
        }

        function initialCategory(item){
            if(vm.typeMD === 'B3') {
                return _.includes(DiagFileDetailsNewConstants.initialCategory,item.category);
            }

            else if(vm.typeMD === 'ADT'){
                return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category ? item.category.toLowerCase() : item.category);
            }
            else if(vm.typeMD === 'B3-ADT'){
                const categoryLower = item.category ? item.category.toLowerCase() : item.category;
                return _.includes(DiagFileDetailsNewConstants.initialCategory, categoryLower) || 
                       _.includes(DiagFileDetailsNewConstants.healthCheckCategory, categoryLower);
            }
            else{
                return item;
            }
        }

        $scope.$on('getPaginatedData', function (event,fromScreen,data) {
            if(fromScreen === DiagFileDetailsNewConstants.OCV){
                vm.diagFilesList = data;
                vm.diagFileFinalList = vm.diagFilesList;

                if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                    displayAndFilterNv(vm.diagFileFinalList[0].id, false);
                }
            }
        });

        var deregisterDiagDataFound = $rootScope.$on('diagDataFound', function (event,fromScreen) {
            if(fromScreen === DiagFileDetailsNewConstants.OCV){
                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                if(!_.isEmpty(vm.diagFileFinalList) && vm.diagFileFinalList.length > 0){
                    displayAndFilterNv(vm.diagFileFinalList[0].id, false);
                }
            }
        });

        $scope.$on('$destroy', function () {
            if (typeof deregisterDiagDataFound === 'function') {
                deregisterDiagDataFound();
            }
        });

        function getNvFilter(){
            vm.filterLoader = true;

            var isExpanded = _.filter(vm.diagFilesList, function(item){
                return !item.nvPreparationVisible;
            });

            var isAllCollapsed = _.filter(vm.diagFilesList, function(item){
                return item.nvPreparationVisible;
            });

            if(!isAllCollapsed || _.isEmpty(isAllCollapsed)){
                vm.firstFilter = [];
                vm.secondFilter = [];
                vm.thirdFilter = [];
            }

            if(isExpanded && !_.isEmpty(isExpanded)){
                vm.expandAll = false;
            }

            else{
                vm.expandAll = true;
            }

            var payload = {
                fullData: vm.diagFilesList,
                dataToFilter: 'configurableData',
                visibility:'nvPreparationVisible',
                filterArray: vm.filterArray,
                systemFilter: ''
            }

            if (vm.typeMD !== 'ADT' || vm.typeMD === 'ADT') {
                return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU)
                    .post(payload)
                    .then(function (response) {
                        if (response) {
                            vm.filterArray = response;
                        } else {
                            toastr.error($translate.instant("FILTER_ERROR"));
                        }
                    })
                    .finally(function () {
                        vm.filterLoader = false; 
                    });
            }
        }
        function displayNvPreparation(id,nvPreparationVisible) {

            return $q.resolve().then(function () {
                var userContext = CacheService.getObject(CacheConstants.profil);
                var preferredLanguage = userContext.documentationFirstLanguage.code;
                var defaultLanguage = userContext.documentationSecondLanguage.code;
                if (!nvPreparationVisible){
                
                    for (var i=0; i< vm.diagFilesList.length; i++){
                        if (vm.diagFilesList[i].id == id){
                            if (!vm.diagFilesList[i].configurableData){
                                blockUI.start();
                                return DiagFileBusinessService.getDiagFileById(id, preferredLanguage, defaultLanguage).then(function(
                                    diagFileByIdResponse
                                ) {
                                    vm.diagFile = diagFileByIdResponse;
                                    var indexOfSelectedDoc;

                                    _.map(vm.diagFilesList, function (item,index) {
                                        if (item.id === id) {
                                            indexOfSelectedDoc = index;
                                            _.extend(item, { configurableData: vm.diagFile.configurableData, nvPreparationVisible: true });
                                        }
                                    });
                                    blockUI.stop();
                                    
                                    
                                    return;                               
                                });
                            }

                            else {
                                var selectedIndex;
                                _.map(vm.diagFilesList, function (item,index) {
                                    if (item.id === id) {
                                        selectedIndex = index;
                                        _.extend(item, { configurableData: item.configurableData, nvPreparationVisible: true });
                                    }                                
                                });
                                return;
                            }

                        }

                    }
                }
  
                else {
                    _.map(vm.diagFilesList, function (item) {
                        if (item.id === id) {
                            _.extend(item, { configurableData: item.configurableData, nvPreparationVisible: false });
                        }
                    })

                    return;
                }
            }).then(function () {
                _.map(vm.diagFilesList, function (item) {
                    if(vm.typeMD === 'ADT'){
                        if(item.mileage){
                            var mileageData = item.mileage.split(" ");
                            if(mileageData.length === 2){
                                var mileage = parseInt(mileageData[0]);
                                _.assign(item, { mileage: mileage+" " +mileageData[1]});
                            }
                            
                        }
                    }
                });

                if(vm.typeMD != 'ADT')
                CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);
            })
            
        }

    }

})();
/**
 * diagFileHelp
 * @namespace Components
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('diagFileHelp', {
            bindings: {
                data: '=',
                selectedDiagFileId: '=',
                diagFilesList: '=',
                typeMD: '=',
                binSearched: '='
            },
            controller: DiagFileHelpController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchByDiagnostic/DiagnosticHelp/diagFileHelp.template.html',

        }).controller('DiagFileHelpController', DiagFileHelpController);

    function DiagFileHelpController(
        CacheConstants,
        CacheService,
        DiagFileBusinessService, MainMetierService, $scope,
        blockUI, toastr, $translate, DiagFileDetailsNewConstants, SearchbyDiagnosticConstants, configConstantes, $mdDialog, ScrollService) {

        var vm = this;

        //Variables
        var userProfil = CacheService.getUserProfile();
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.isRnetUserType = userProfil ? MainMetierService.isRnetUserType(userProfil.userType): null;
        vm.selectedSymptom = [];
        vm.partLabourTimes = [];
        vm.dtcs = [];
        vm.adtTechrole = false;
        vm.choosenPatterns = new Map();
        var userContext = CacheService.getObject(CacheConstants.profil);
        var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
        var preferredLanguage = userContext.documentationFirstLanguage.code;
        var defaultLanguage = userContext.documentationSecondLanguage.code;
        var borderBottomStyle = "4px solid var(--renaultPrimaryColor)";
        var rgbBackgroundStyle = "rgba(255, 204, 51, 0.1)";
        //Functions
        vm.getBorderBottom = getBorderBottom;
        vm.rowSpanCount = rowSpanCount;
        vm.setRowStyle = setRowStyle;
        vm.getLabelToDisplay = getLabelToDisplay;
        vm.getTypeToDisplay = getTypeToDisplay;
        vm.getConfidenceRatio = getConfidenceRatio;
        vm.openCommentsHubPopin = openCommentsHubPopin;
        vm.redirectToContextPage = redirectToContextPage;
        vm.showExtendedAndSnapshot = showExtendedAndSnapshot;

        if ((vm.isRnetUserType || vm.isArcaUser) && userProfil && userProfil.roles.includes(SearchbyDiagnosticConstants.adtTechRole)) {
            vm.adtTechrole = true;
        }
        
        $scope.$watch('vm.selectedDiagFileId', function () {
            vm.diagFile = '';
            var diagDetailsFromCache = getDiagFileDetails();
            if (!diagDetailsFromCache) {
                getDiagFileById(vm.selectedDiagFileId);
                getDiagFilePatterns(vm.selectedDiagFileId);
            } else {
                vm.diagFile = diagDetailsFromCache;
                if(!vm.diagFile.dtcs || _.isEmpty(vm.diagFile.dtcs)){                    
                    getDiagFileById(vm.selectedDiagFileId);
                }else{
                    var selectedDtc = vm.diagFile.dtcs;
                    var dtcsIso = null;
                    if(carContext && carContext.vehicle){
                        if(carContext.vehicle.typeMD == 'B2' || carContext.vehicle.typeMD == 'B3'){
                            dtcsIso = mapDtcWithUce(selectedDtc); 
                        } else if(carContext.vehicle.typeMD == 'ADT'){
                            dtcsIso = mapDtcWithUceADT(selectedDtc);
                        }    
                    }           
                    getPredictions(vm.selectedDiagFileId, preferredLanguage, dtcsIso, vm.selectedSymptom, vm.diagFile.vin);
                }
                getDiagFilePatterns(vm.selectedDiagFileId);
            }
        })
        function getDiagFileDetails() {
            vm.diagFilesHelpList = angular.copy(vm.diagFilesList);
            var diagFile = _.find(vm.diagFilesHelpList, { id: vm.selectedDiagFileId });
            if (diagFile && !_.isEmpty(diagFile)) {
                return diagFile;
            }
            return '';
        }
        function openCommentsHubPopin(dtc) {
            $mdDialog.show({
                templateUrl:
                    "app/components/vdh/commentsHubPopin/commentsHubPopin.template.html",
                clickOutsideToClose: true,
                controller: "commentsHubPopinCtrl",
                locals: {
                    dtc: dtc,
                    groupedPatterns: vm.choosenPatterns
                }
            });
        }
        function getDiagFileById(diagFileId) {
            blockUI.start();
            DiagFileBusinessService.getDiagFileById(diagFileId, preferredLanguage, defaultLanguage).then(function (
                diagFileByIdResponse
            ) {
                if (diagFileByIdResponse && !_.isEmpty(diagFileByIdResponse)) {
                    var filteredResponse = _.pick(diagFileByIdResponse, DiagFileDetailsNewConstants.requiredDiagFileDetailsFields);
                    vm.diagFile = filteredResponse;
                    vm.dtcs = vm.diagFile.dtcs;
                    var dtcsIso = null;
                    if(carContext && carContext.vehicle){
                        if(carContext.vehicle.typeMD == 'B2' || carContext.vehicle.typeMD == 'B3'){
                            dtcsIso = mapDtcWithUce(vm.dtcs); 
                        } else if(carContext.vehicle.typeMD == 'ADT'){
                            dtcsIso = mapDtcWithUceADT(vm.dtcs);
                        }    
                    }
                    _.map(vm.diagFilesHelpList, function (item) {
                        if (item.id === vm.selectedDiagFileId) {

                            if(vm.typeMD === 'ADT'){
                                if(item.mileage){
                                    var mileageData = vm.diagFile.mileage.split(" ");
                                    if(mileageData.length === 2){
                                        var mileage = parseInt(mileageData[0]);
                                        _.assign(vm.diagFile, { mileage: mileage+" " +mileageData[1]})
                                    }
                                    
                                }
                            }
        
                            _.forIn(vm.diagFile, function(value,key){
                                item[key] = value;
                            })
                        } else {
                            delete item['dtcs'];
                        }
                    })
                    // CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesHelpList);
                    getPredictions(vm.selectedDiagFileId, preferredLanguage, dtcsIso, vm.selectedSymptom, vm.diagFile.vin);
                }
            }).catch(function (error) {
                toastr.error(error);

            }).finally(function () {
                blockUI.stop();
            });
        }
        function compare(a, b) {
            if (a.mileage === "NA") {
                return -1;
            }
            if (parseInt(a.mileage) > parseInt(b.mileage)) return -1;
            if (parseInt(b.mileage) > parseInt(a.mileage)) return 1;
            return 0;
        }
        function getPredictions(diagFileId, preferredLanguage, scopeFaults, symptoms, vin) {
            blockUI.start();
            DiagFileBusinessService.getPredictions(diagFileId, preferredLanguage, scopeFaults, symptoms, vin).then(function (
                diagFilePredictionsResponse
            ) {
                vm.partLabourTimes = diagFilePredictionsResponse.partsLabourTimes;
            })
                .catch(function (error) {
                    toastr.error($translate.instant("PREDICTIONS_ERROR"));
                }).finally(function () {
                    blockUI.stop();
                });
        }
        function mapDtcWithUceADT(dtcs) {
            var isoDtcs = [];
            var data = _.groupBy(vm.diagFile.ecus,'label')
            angular.forEach(dtcs, function (dtc) {
                if(data[dtc.ecuLabel] && data[dtc.ecuLabel][0].ecuDomainName){
                    isoDtcs.push(data[dtc.ecuLabel][0].ecuDomainName + (data[dtc.ecuLabel][0].ecuDomainName ?'-':'') + (dtc["code"].length == 5 ? (dtc["code"]+dtc["type"]): dtc["code"]));
                } else {
                    isoDtcs.push(dtc["code"].length == 5 ? (dtc["code"]+dtc["type"]): dtc["code"]);
                }
            });
            return isoDtcs;            
        }
        function mapDtcWithUce(dtcs) {
            var isoDtcs = [];
            var referenceCode = new Map();
            referenceCode.set("0", "P0");
            referenceCode.set("1", "P1");
            referenceCode.set("2", "P2");
            referenceCode.set("3", "P3");
            referenceCode.set("4", "C0");
            referenceCode.set("5", "C1");
            referenceCode.set("6", "C2");
            referenceCode.set("7", "C3");
            referenceCode.set("8", "B0");
            referenceCode.set("9", "B1");
            referenceCode.set("A", "B2");
            referenceCode.set("B", "B3");
            referenceCode.set("C", "U0");
            referenceCode.set("D", "U1");
            referenceCode.set("E", "U2");
            referenceCode.set("F", "U3");
            angular.forEach(dtcs, function (dtc) {
                angular.forEach(vm.diagFile.dtcs, function (diagFileDtc) {
                    if (dtc["code"] === diagFileDtc["code"]) {
                        angular.forEach(vm.diagFile.ecus, function (uce) {
                            if (uce["label"] === diagFileDtc["ecuLabel"]) {
                                var firstChar = dtc["code"].substring(3, 4);
                                if (referenceCode.get(firstChar) != null) {
                                    var charToReplace = referenceCode.get(firstChar);
                                    isoDtcs.push(uce["domainId"] + '-' + charToReplace + dtc["code"].substring(4, dtc["code"].length));
                                }
                            }
                        });
                    }
                });
            });
            return isoDtcs;
        }
        function redirectToContextPage(dtcItem){
            if(dtcItem.context && ((dtcItem.context.extendedData && !_.isEmpty(dtcItem.context.extendedData)) ||  (dtcItem.context.snapshot && !_.isEmpty(dtcItem.context.snapshot)))){
                vm.showExtendedAndSnapshot(dtcItem);
            }
        }
        function showExtendedAndSnapshot(dtc){
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl:
                    "app/components/car/searchByDiagnostic/DiagnosticFileDetails/dtcContextDialog.template.html",
                controller: "DiagFileDetailsController",
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true,
                locals: {
                    dtc: dtc
                }
            });
            
        }
        function getDiagFilePatterns(diagFileId) {
            blockUI.start();

            DiagFileBusinessService.getDiagFilePatterns(diagFileId, preferredLanguage, defaultLanguage).then(function (
                diagFilePatternsResponse
            ) {
                vm.dtcs = [];
                vm.diagFilePatterns = diagFilePatternsResponse;
                if(!_.isEmpty(vm.diagFilePatterns)){
                    groupDtcsByPattern();
                    vm.dtcs = vm.dtcs.sort(compare);
                    _.map(vm.dtcs, function (item) {

                        if(vm.typeMD === 'ADT'){
                            _.assign(item, {
                                code: (item.code && item.type) ? item.code.concat(item.type) : item.code
                            });
                        }
                        _.assign(item, {
                            mileage : item.mileage ? (item.mileage !== 'NA' ? parseInt(item.mileage) : item.mileage) : '',
                            occurrences : item.occurrences ? (item.occurrences !== 'NA' ? parseInt(item.occurrences) : item.occurrences) : '',
                            statusCode: item.statusCode ? item.statusCode : item.status,
                            isFFDAvailable: (item.context &&
                                ((item.context.extendedData && !_.isEmpty(item.context.extendedData)) ||
                                    (item.context.snapshot && !_.isEmpty(item.context.snapshot)))) ?
                                DiagFileDetailsNewConstants.YES : DiagFileDetailsNewConstants.NO
                        });
                    })
                }else{
                    vm.dtcs = vm.diagFile.dtcs;
                }
                if(vm.typeMD === 'ADT'){
                    if(vm.diagFile.mileage){
                        var mileageData = vm.diagFile.mileage.split(" ");
                        if(mileageData.length === 2){
                            var mileage = parseInt(mileageData[0]);
                            _.assign(vm.diagFile, { mileage: mileage+" " +mileageData[1]})
                        }
                        
                    }
                }
                for(var i = 0 ; i < vm.diagFilesHelpList.length ; i++){
                    if(vm.diagFilesHelpList[i].id == diagFileId){
                        vm.diagFilesHelpList[i].dtcs = vm.dtcs 
                    }
                }
                // CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesHelpList);


                ScrollService.animateTo('.diag-file-details-new', 500);
                //vm.dtcsAsc = vm.dtcs.slice().reverse();
            }).catch(function (error) {
                vm.dtcs = vm.diagFile.dtcs;
                //toastr.error($translate.instant("RECOMMENDATION_ERROR"));
            }).finally(function () {
                blockUI.stop();
            });
        }
        function groupDtcsByPattern() {
            if (!_.isEmpty(vm.diagFilePatterns.noMileageDtcs)) {
                angular.forEach(vm.diagFilePatterns.noMileageDtcs, function (
                    dtc
                ) {
                    if((vm.typeMD === 'ADT' && dtc.description && !_.isEmpty(dtc.description)) || vm.typeMD === 'B3')
                        vm.dtcs.push(dtc);
                });
            }
            if (!_.isEmpty(vm.diagFilePatterns.noPatternDtcs)) {
                angular.forEach(vm.diagFilePatterns.noPatternDtcs, function (
                    dtc
                ) {
                    if((vm.typeMD === 'ADT' && dtc.description && !_.isEmpty(dtc.description)) || vm.typeMD === 'B3')
                        vm.dtcs.push(dtc);
                });
            }
            var groupedPatternsByMileage = groupByMileage(vm.diagFilePatterns.patterns);
            if (!_.isEmpty(groupedPatternsByMileage)) {
                angular.forEach(groupedPatternsByMileage, function (patterns, mileage) {
                    var patternWithBiggerImpact;
                    var maxOccurrence = Math.max.apply(
                        Math,
                        patterns.map(function (pattern) {
                            return pattern.impactNumber;
                        }));
                    angular.forEach(patterns, function (pattern) {
                        if (pattern.impactNumber == maxOccurrence) {
                            patternWithBiggerImpact = pattern;
                        }
                    });
                    vm.choosenPatterns.set(parseInt(mileage), patternWithBiggerImpact);
                    patterns.splice(patterns.indexOf(patternWithBiggerImpact), 1);

                    angular.forEach(patterns, function (pattern) {
                        angular.forEach(pattern.dtcs, function (dtc) {
                            var dtcIndex = indexOfDtc(patternWithBiggerImpact.dtcs, dtc);
                            if (dtcIndex !== -1) {
                                pattern.dtcs.splice(indexOfDtc(pattern.dtcs, dtc), 1);
                            }
                            if (indexOfDtc(vm.dtcs, dtc) === -1) {
                                vm.dtcs.push(dtc);
                            }
                        })
                    });
                });
            }
            if (!_.isEmpty(vm.choosenPatterns)) {
                angular.forEach(vm.choosenPatterns, function (choosenPattern, key) {
                    angular.forEach(choosenPattern.dtcs, function (dtc) {
                        dtc.id = choosenPattern.id;
                        dtc.familyId = choosenPattern.familyId;
                        dtc.commentNumber = choosenPattern.commentNumber;
                        dtc.impactNumber = choosenPattern.impactNumber;
                        if (parseInt(dtc.mileage) - parseInt(key) >= 1 || parseInt(key) - parseInt(dtc.mileage) >= 1) {
                            dtc.realMileage = dtc.mileage;
                            dtc.mileage = key;
                        }
                        vm.dtcs.push(dtc);
                    });
                });
            }
        }
        function groupByMileage(patterns) {
            var groupedPatternsByMileage = new Map();
            if (!_.isEmpty(patterns)) {
                angular.forEach(patterns, function (pattern) {
                    var list = [];
                    if (
                        groupedPatternsByMileage.get(Number(pattern.dtcs[0].mileage)) &&
                        groupedPatternsByMileage.get(Number(pattern.dtcs[0].mileage))
                            .length > 0
                    ) {
                        list = groupedPatternsByMileage.get(
                            Number(pattern.dtcs[0].mileage)
                        );
                        list.push(pattern);
                    } else {
                        list.push(pattern);
                        groupedPatternsByMileage.set(
                            Number(pattern.dtcs[0].mileage),
                            list
                        );
                    }
                });
            }
            return groupedPatternsByMileage;
        }
        function indexOfDtc(dtcs, dtc) {
            for (var i = 0; i < dtcs.length; i++) {
                if (dtcs[i].code == dtc.code && dtcs[i].ecuLabel == dtc.ecuLabel) {
                    return i;
                }
            }
            return -1;
        }
        function getBorderBottom(row) {
            var borderBottom = {
                "border-bottom": borderBottomStyle
            };
            if (row.id) {
                return borderBottom;
            }
            return {};
        }
        function setRowStyle(row) {
            var noPattern = {
                "background-color": "white"
            };

            var noPatternAfterPattern = {
                "background-color": "white",
                "border-top": borderBottomStyle
            };

            var initialPattern = {
                "background-color": rgbBackgroundStyle,
                "border-top": borderBottomStyle,
                "border-left": borderBottomStyle,
                "border-right": borderBottomStyle
            };

            var lastPattern = {
                "background-color": rgbBackgroundStyle,
                "border-left": borderBottomStyle,
                "border-right": borderBottomStyle,
                "border-bottom": borderBottomStyle
            };

            var midlePattern = {
                "background-color": rgbBackgroundStyle,
                "border-left": borderBottomStyle,
                "border-right": borderBottomStyle
            };
            if (
                vm.dtcs.indexOf(row) - 1 > 0 &&
                vm.dtcs[vm.dtcs.indexOf(row) - 1].id &&
                vm.dtcs[vm.dtcs.indexOf(row)] &&
                vm.dtcs[vm.dtcs.indexOf(row)].id === undefined
            ) {
                return noPatternAfterPattern;
            }
            if (row.id === undefined) {
                return noPattern;
            } else {
                if (
                    (vm.dtcs.indexOf(row) == 0 &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id) ||
                    (vm.dtcs.indexOf(row) - 1 == 0 &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id &&
                        !vm.dtcs[vm.dtcs.indexOf(row) - 1].id) ||
                    (vm.dtcs.indexOf(row) - 1 > 0 &&
                        vm.dtcs[vm.dtcs.indexOf(row) - 1].id ===
                        undefined &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id) ||
                    (vm.dtcs.indexOf(row) - 1 > 0 &&
                        vm.dtcs[vm.dtcs.indexOf(row) - 1].id &&
                        vm.dtcs[vm.dtcs.indexOf(row) + 1] !==
                        undefined &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id &&
                        vm.dtcs[vm.dtcs.indexOf(row) + 1].id &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id ===
                        vm.dtcs[vm.dtcs.indexOf(row) + 1]
                            .id &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id !==
                        vm.dtcs[vm.dtcs.indexOf(row) - 1].id)
                ) {
                    return initialPattern;
                } else if (
                    (vm.dtcs.indexOf(row) + 1 == vm.dtcs.length &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id) ||
                    vm.dtcs[vm.dtcs.indexOf(row)].id !=
                    vm.dtcs[vm.dtcs.indexOf(row) + 1].id ||
                    (vm.dtcs[vm.dtcs.indexOf(row) + 1].id ===
                        undefined &&
                        vm.dtcs[vm.dtcs.indexOf(row)].id)
                ) {
                    return lastPattern;
                } else {
                    return midlePattern;
                }
            }
        }
        function rowSpanCount(id) {
            var rowspanCount = 1;
            rowspanCount = _.filter(vm.dtcs, function (dtc) {
                if (dtc.id && dtc.id == id) {
                    return true;
                }
                return false;
            }).length;
            if (rowspanCount > 0) {
                return rowspanCount;
            }
            return 1;
        }
        function getLabelToDisplay(row) {
            if(row && !_.isEmpty(row.partRootCause)) {
                return row.partRootCause.label;
            }
            else {
                if(row && row.labourTimes && row.labourTimes.length > 0){
                    row.labourTimes.map(function (item) {
                        if(item && item.label){
                            row.labourTimeLabel = item.label;
                        }
                    });
                    return row.labourTimeLabel;
                }
            }
        }
        function getTypeToDisplay(row) {
            if (row && row.contributors.length > 0) {
                return 'Operation';
            }
            if(row && !_.isEmpty(row.partRootCause)) {
                return 'Part';
            }
            else{
                if(row && row.labourTimes && row.labourTimes.length > 0){
                    row.labourTimes.map(function (item) {
                        if(item && item.label){
                            row.Opetype = 'Operation';
                        }
                    });
                    return row.Opetype;
                }
            }
        }
        function getConfidenceRatio(row) {
            if (row.confidenceRatio) {
                var ratio = (parseFloat(row.confidenceRatio * 100)).toFixed(2) + ' %';
                ratio = ratio.replace(".", ",");
                return ratio;
            }
            return row.confidenceRatio;
        }
    }

})();

'use strict';

angular.module('phenix').constant('DiagFileDetailsNewConstants', {

    documentBT : 'BT',
    documentMD : 'MD',
    requiredDiagFileFields: ['category','origin','captureDateTime', 'id','mileage','dealerId','tootVersion'],
    requiredDiagFileDetailsFields: ['category','origin','mileage','dealerId','tootVersion','dtcs','ecus','vin','networks','id'],
    initialCategory: ['B2','Initiale','INITIALE','initiale','INITIAL','Initial','initial'],
    finalCategory: ['FINAL','Final','final'],
    healthCheckCategory: ['healthcheck'],
    customerReportCategory: ['customerreport'],
    ticketMaintenanceCategory:['ticket maintenance'],
    connectedVehicleOrigin:['stive', 'STIVE','STIVE front','STIVE batch','DDP','dbb'],
    YES: 'YES',
    NO: 'NO',
    filterYesNoData : { 'YES': ['fa fa-check'], 'NO': ['fa fa-times-circle'] },
    filterCameraData : { 'YES': ['fa fa-camera'], 'NO': ['fa fa-times-circle'] },
    filter12Data : { '1': ['red-dot'], '2': ['orange-dot'] },
    isBTAvailable: 'isBTAvailable',
    isMDAvailable: 'isMDAvailable',
    isFFDAvailable: 'isFFDAvailable',
    statusCode: 'statusCode',
    status: 'status',
    ECU: 'ECU',
    DTC: 'DTC',
    userJourney: 'userJourney',
    network: 'network',
    healthCheck: 'HealthCheck',
    customerReport: 'CustomerReport',
    nvPreparation: 'nvPreparation',
    OCV: 'OCV',
    diagnewFilter:'&blockName=activities&isBlockNull=true',
    alerts: 'alert',
    filterECU: 'diagCustom/filter',
    preDiagList: ['XCB','XHN','XJB/PHAS2','X1310','X1316','X1317', 'XDD', 'XJA','XJL', 'X10'],
    getPredictionVotes: '/carts/getPredictionVotes',
    alertPredictions: 'PREDICTION',
    alertPredictionTitle: "Prediction feedback",
    alertVersionLabel: "Version",
    alertPredictionLabel: "Prédictions",
    alertUserLabel: "User",
    alertCommentLabel: "Comment",
    alertPredictionInDefaultLabel: "Prédiction in default",
    alertDiagFileLabel: "Diag File"

});

/**
 * diagFileDetails
 * @namespace Components
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('diagFileDetails', {
            bindings: {
                data: '=',
                contextVehicle: '=',
                selectedDiagFileId: '=',
                goToResultByDiagnostic: '<',
                diagFilesList: '=',
                typeMD: '=',
                systemDocSubMenu: '=',
                systemDocResponse:'='
            },
            controller: DiagFileDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchByDiagnostic/DiagnosticFileDetails/diagFileDetailsNew.template.html',

        }).controller('DiagFileDetailsController',DiagFileDetailsController);
        angular.module('phenix').filter('dtcslice',function(){
            return function(text){
                return text ? (text.substr(0,3) == 'DTC' ? text.substr(3):text) : '';
            }            
        });

    function DiagFileDetailsController(
        CacheConstants,
        configConstantes,
        CacheService,
        DiagFileBusinessService, MainMetierService, $scope,$rootScope,
        ResultSearchByDiagnosticMetierService,AlertsService,SearchArboTextualMetierService,
        blockUI, toastr, DiagFileDetailsNewConstants, $q,CarSearchMetierService,
        ScrollService,$mdDialog,CustomFilterSortService,UtilsMetierService,$translate,searchByTextsIdsMertierService,DocumentsMetierService,$state,RoutingService) {

        var vm = this;

        //Variables
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.btDisplayArray = [];
        vm.mdDisplayArray = [];
        vm.ffdDisplayArray = [];
        vm.statusDisplayArray = [];
        vm.techBulletinList = [];
        //required for smart table default sort
        $scope.defaultSortColumn = {predicate:'ecuLabel',reverse:false};
        vm.partLabourTimes = {data : []};
        var user = CacheService.getUserProfile();
        vm.showPreDiag = UtilsMetierService.showPredictions();
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.isTechProfile = UtilsMetierService.isTechProfil();
        vm.isIndependentUser = UtilsMetierService.isIndependentUser(); 
        vm.isLiked = null;
        vm.diagPredictionsForAlert = {};
        vm.isDiagPredictLoading = false;
        vm.isFromDiagFileDetails = ($state.params && $state.params.isFromDiagFileDetails);
        // If returning from product page, restore diagFilesList and selectedDiagFileId from cache
        if (vm.isFromDiagFileDetails) {
            var cachedDiagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
            var cachedSelectedId = CacheService.getObject(CacheConstants.selectedDiagFileId);           
                if (cachedSelectedId && cachedDiagFilesList && cachedDiagFilesList.length > 0) {
                    vm.diagFilesList = cachedDiagFilesList;
                    vm.selectedDiagFileId = cachedSelectedId;
                }
        }
        
        //Functions
        vm.getDiagFileById = getDiagFileById;
        vm.getBTAndMDAvailability = getBTAndMDAvailability;
        vm.setBTAndMDavailability = setBTAndMDavailability;
        vm.redirectToDtcPage = redirectToDtcPage;
        vm.redirectToContextPage = redirectToContextPage;
        vm.showExtendedAndSnapshot = showExtendedAndSnapshot;
        vm.getDiagFileDetails = getDiagFileDetails;
        vm.setDropDownData = setDropDownData;
        vm.onClose = onClose;
        vm.openAlertPopIn = openAlertPopIn;
        vm.savePredictionVotes = savePredictionVotes;
        vm.goToProduct = goToProduct;
        vm.goToTextSearch = goToTextSearch;

        /**
         * customised sorting for few fields
         */
        vm.sortedField = {
            mileage: function (value) {
                //sort dtc by mileage. NA goes first
                if (value.mileage === "NA") {
                    return 99999999;
                }
                return parseInt(value.mileage);
            },
            occurrences: function (value) {
                //sort dtc by occurrences. NA goes first
                if (value.occurrences === "NA") {
                    return 99999999;
                }
                return parseInt(value.occurrences);
            },
            isFFDAvailable: function (value) {
                //sort dtc by FFD availability. Yes goes first
                if (value.isFFDAvailable === DiagFileDetailsNewConstants.YES) {
                    return -1;
                }
                return 1;
            },
            isBTAvailable: function (value) {
                //sort dtc by BT availability. Yes goes first
                if (value.isBTAvailable === DiagFileDetailsNewConstants.YES) {
                    return -1;
                }
                return 1;
            },
            isMDAvailable: function (value) {
                //sort dtc by MD availability. Yes goes first
                if (value.isMDAvailable === DiagFileDetailsNewConstants.YES) {
                    return -1;
                }
                return 1;
            },
            status: function (value) {
                //sort status by PRESENT status first
                if (value.statusCode.length === 1) {
                    return parseInt(value.statusCode);
                }else if(value.statusCode.length > 1){
                    return 1.5;
                }
                return 1;
            }
        };

        function compare(a, b) {
            if(a.ecuLabel > b.ecuLabel) return -1;
            if(a.ecuLabel < b.ecuLabel) return 1;

            if (a.mileage === "NA") {
                return -1;
            }
            if (b.mileage === "NA") {
                return 1;
            }
            if (parseInt(a.mileage) > parseInt(b.mileage)) return -1;
            if (parseInt(b.mileage) > parseInt(a.mileage)) return 1;
            return 0;
        }

        /**
         * arrays for filter dropdown with images
         */
        function setDropDownData() {

            vm.btDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.isBTAvailable,
                values: DiagFileDetailsNewConstants.filterYesNoData
            },vm.diagFile.dtcs);

            vm.mdDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.isMDAvailable,
                values: DiagFileDetailsNewConstants.filterYesNoData
            },vm.diagFile.dtcs);
            vm.ffdDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.isFFDAvailable,
                values: DiagFileDetailsNewConstants.filterCameraData
            },vm.diagFile.dtcs);
            vm.statusDisplayArray = CustomFilterSortService.getDropdownArray({
                column: DiagFileDetailsNewConstants.statusCode,
                values: DiagFileDetailsNewConstants.filter12Data,
                addColumn: DiagFileDetailsNewConstants.status
            },vm.diagFile.dtcs);

            //array to have the default values in the filter
            vm.defaultFilterValues = [];
            vm.statusDisplayArray.forEach(function(item){
                if(!item.class){
                    vm.defaultFilterValues.push(item.data);
                }
            })
        }

        $scope.$watch('vm.selectedDiagFileId', function () {

            vm.diagFile = '';
            $scope.code = '';
            $scope.description = '';
            $scope.ecuLabel = '';
            vm.btDisplayArray = [];
            vm.mdDisplayArray = [];
            vm.ffdDisplayArray = [];
            vm.statusDisplayArray = [];
            
            if (vm.selectedDiagFileId && !_.isEmpty(vm.selectedDiagFileId)) {
                var diagDetailsFromCache = getDiagFileDetails();
                vm.techBulletinList = [];
                if ((!diagDetailsFromCache || (diagDetailsFromCache && !diagDetailsFromCache.dtcs)) || (_.isEmpty(diagDetailsFromCache) || (!_.isEmpty(diagDetailsFromCache) && _.isEmpty(diagDetailsFromCache.dtcs)))) {
                    getDiagFileById(vm.selectedDiagFileId);
                } else {
                    vm.diagFile = diagDetailsFromCache;
                    if (vm.diagFile.predictionData && vm.diagFile.predictionData.length > 0) {
                        var ruleItem = vm.diagFile.predictionData.find(function(item) {
                            return item.isRulePresent === true;
                        });
                        if (ruleItem && ruleItem.dtcRuleLabel) {
                            vm.dtcRule = ruleItem.dtcRuleLabel;
                        }
                    }
                    setDropDownData();

                    vm.data = vm.contextVehicle.diagDocuments ? vm.contextVehicle.diagDocuments : getBTAndMDAvailability();

                }
            }
        })

        function getDiagFileDetails() {

            var diagFile = _.find(vm.diagFilesList, { id: vm.selectedDiagFileId });

            if (diagFile && !_.isEmpty(diagFile)) {
                return diagFile;
            }

            return '';

        }


        function getDiagFileById(diagFileId) {
            blockUI.start();
            var userContext = CacheService.getObject(CacheConstants.profil);
            var preferredLanguage = userContext.documentationFirstLanguage.code;
            var defaultLanguage = userContext.documentationSecondLanguage.code;

            DiagFileBusinessService.getDiagFileById(diagFileId, preferredLanguage, defaultLanguage).then(function (
                diagFileByIdResponse
            ) {
                if (diagFileByIdResponse && !_.isEmpty(diagFileByIdResponse)) {

                    var filteredResponse = _.pick(diagFileByIdResponse, DiagFileDetailsNewConstants.requiredDiagFileDetailsFields);

                    vm.diagFile = filteredResponse;
                    if(!_.isEmpty(vm.diagFile.dtcs) || (!_.isEmpty(vm.diagFile.ecus) && _.isEmpty(vm.diagFile.dtcs))){

                        vm.diagFile.dtcs = vm.diagFile.dtcs.filter(function(item){
                            return (item.description != "null" && !_.isEmpty(item.description));
                        })
                        
                        vm.diagFile.dtcs = vm.diagFile.dtcs.sort(compare);

                        _.map(vm.diagFile.dtcs, function (item) {
                            
                            if(vm.typeMD === 'ADT' || (vm.typeMD === 'B3' && vm.diagFile.origin === 'dbb')){
                                _.assign(item, {
                                    code: (item.code && item.type) ? item.code.concat(item.type) : item.code
                                })
                            }

                            _.assign(item, {
                                mileage : item.mileage ? (item.mileage !== 'NA' ? parseInt(item.mileage) : item.mileage) : '',
                                occurrences : item.occurrences ? (item.occurrences !== 'NA' ? parseInt(item.occurrences) : item.occurrences) : '',
                                statusCode: item.statusCode ? item.statusCode : item.status,
                                isFFDAvailable: (item.context &&
                                    ((item.context.extendedData && !_.isEmpty(item.context.extendedData)) || 
                                    (item.context.snapshot && !_.isEmpty(item.context.snapshot)))) ? 
                                    DiagFileDetailsNewConstants.YES : DiagFileDetailsNewConstants.NO
                            });
                        })
                        for(var i = 0 ; i < vm.diagFilesList.length ; i++){
                            if(vm.diagFilesList[i].id == vm.diagFile.id){
                                vm.diagFilesList[i].dtcs = vm.diagFile.dtcs;
                                vm.diagFilesList[i].ecus = vm.diagFile.ecus
                            }
                        }
                        CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);

                        //to make the view to the table due to screen scroll issue in filter
                        ScrollService.animateTo('.diag-file-details-new', 500);

                        //clear the previous sort while changing the diag file
                        CustomFilterSortService.clearSort('dtcs-table','ecuLabel');

                        getBTAndMDAvailability();
                    }
                }
            }).catch(function (error) {
                toastr.error(error);

            }).finally(function () {
                blockUI.stop();
                var carContext = CacheService.getCarContext();  
                var vehFamily = carContext.fixedCriterias['007']; 
                var vehPhase = carContext.fixedCriterias['901'];  
                var vehFamilyPhase =  vehFamily === 'XJB' ?  (vehFamily + '/' + vehPhase) : vehFamily;
                if(vm.showPreDiag && DiagFileDetailsNewConstants.preDiagList.includes(vehFamilyPhase)){
                    vm.diagFile.noPreDiagFamily = false;
                    setDiagFileDetailsInCache();
                    callDiagPrediction(carContext.fixedCriterias['007']);
                } else {
                    vm.diagFile.noPreDiagFamily = true;
                    vm.diagFile.preDiagMessage = $translate.instant("NO_PREDICTION_SERVICE");
                    setDiagFileDetailsInCache();
                }
            });
        }
        function callDiagPrediction(vehFamily){
            var tempDiagList = _.groupBy(vm.diagFilesList,'id');
            var selectedDtc = tempDiagList[vm.selectedDiagFileId][0].dtcs;
            var selectedEcus = tempDiagList[vm.selectedDiagFileId][0].ecus;
            var dtcsIso = null;

            if(vm.contextVehicle && vm.contextVehicle.vehicle){
                if(vm.contextVehicle.vehicle.typeMD == 'B3' && vm.diagFilesList.origin !== 'dbb'){
                    // RG P31_US14c_01b - CLIP transformation (with filtering)
                    var selectedDiagFile = tempDiagList[vm.selectedDiagFileId][0];
                    dtcsIso = mapDtcWithUceB3(selectedDtc, selectedEcus, selectedDiagFile); 
                } else {
                    // RG P31_US14c_01c - ADT format (for B3 with dbb origin and all other vehicles)
                    dtcsIso = mapDtcWithUce(tempDiagList);
                }    
            }
      
            getPredictions(vehFamily, dtcsIso);
        }
        function mapDtcWithUce(tempDiagList) {
            // RG P31_US14c_01c - ADT format: code + type + ecuDomainName
            var isoDtcs = [];
            var selectedDiagFile = tempDiagList[vm.selectedDiagFileId][0];
            var dtcs = filterDTCs(tempDiagList[vm.selectedDiagFileId][0].dtcs, selectedDiagFile);
            var ecus = tempDiagList[vm.selectedDiagFileId][0].ecus;
            var data = _.groupBy(ecus, 'label');
            
            angular.forEach(dtcs, function (dtc) {
                // For ADT and B3 with dbb, code is already concatenated during display processing
                var dtcCode = dtc.code;                
                if(data[dtc.ecuLabel] && data[dtc.ecuLabel][0].ecuDomainName){
                    // Add ecuDomainName with "-" (P31_US14c_01c)
                    isoDtcs.push(data[dtc.ecuLabel][0].ecuDomainName + '-' + dtcCode);
                } else {
                    isoDtcs.push(dtcCode);
                }
            });
            return isoDtcs;            
        }

        function filterDTCs(dtcs, selectedDiagFile) {
            function getMileageValue(mileageString) {
                if (typeof mileageString === "string") {
                    if (mileageString === "NA") {
                        return null;
                    }
                    const numericValue = parseInt(mileageString.replace(/[^\d.]/g, ''), 10);
                    return isNaN(numericValue) ? null : numericValue;
                }
                return null;
            }
        
            const selectedMileage = getMileageValue(selectedDiagFile.mileage);
        
            // First, filter out DTCs whose type starts with "8"
            var filteredDTCs = dtcs.filter(function(dtc) {
                return !String(dtc.type).startsWith('8');
            });
        
            // Then, apply the status and mileage logic
            filteredDTCs = filteredDTCs.filter(function(dtc) {
                // Include DTCs with status code "1"
                if (dtc.statusCode === "1") return true;
        
                // Filter with status code "2" DTCs based on mileage
                if (dtc.statusCode === "2") {
                    const dtcMileage = getMileageValue((dtc.mileage).toString());
                    var diagFileMileage = selectedMileage;
                    if (selectedMileage === null) {
                        // If selectedMileage is null, find the highest DTC mileage under 300000
                        const validDtcs = filteredDTCs
                            .map(function(dtc) {
                                const dtcMil = getMileageValue((dtc.mileage || '').toString());
                                return dtcMil !== null && dtcMil <= 300000 ? dtcMil : null;
                            })
                            .filter(function(mileage) {
                                return mileage !== null;
                            });
                        if (validDtcs.length === 0) {
                            return false; // No valid mileage to compare
                        }
                        diagFileMileage = Math.max.apply(null, validDtcs);
                    }
                    return dtcMileage !== null && dtcMileage !== 0 && (dtcMileage <= diagFileMileage && dtcMileage >= diagFileMileage - 5000);
                }
        
                return false; // Exclude other statuses
            });
        
            return filteredDTCs;
        }
        function mapDtcWithUceB3(dtcs, ecus, selectedDiagFile) {
            // Apply RG P31_US14c_02b filtering rules for all vehicles using prediction
            var filteredDtcs = filterDTCs(dtcs, selectedDiagFile);
            
            var isoDtcs = [];
            var referenceCode = new Map();
            referenceCode.set("0", "P0");
            referenceCode.set("1", "P1");
            referenceCode.set("2", "P2");
            referenceCode.set("3", "P3");
            referenceCode.set("4", "C0");
            referenceCode.set("5", "C1");
            referenceCode.set("6", "C2");
            referenceCode.set("7", "C3");
            referenceCode.set("8", "B0");
            referenceCode.set("9", "B1");
            referenceCode.set("A", "B2");
            referenceCode.set("B", "B3");
            referenceCode.set("C", "U0");
            referenceCode.set("D", "U1");
            referenceCode.set("E", "U2");
            referenceCode.set("F", "U3");
                angular.forEach(filteredDtcs, function (diagFileDtc) {
                    angular.forEach(ecus, function (uce) {
                        if (uce["label"] === diagFileDtc["ecuLabel"]) {
                            var firstChar = diagFileDtc["code"].substring(3, 4);
                            if (referenceCode.get(firstChar) != null) {
                                var charToReplace = referenceCode.get(firstChar);
                                isoDtcs.push(uce["domainId"] + '-' + charToReplace + diagFileDtc["code"].substring(4, diagFileDtc["code"].length));
                            }
                        }
                    });
                });
            return isoDtcs;
        }


        function getPredictions(vehFamily,scopeFaults) {
            vm.currentPredictRequestId = (vm.currentPredictRequestId || 0) + 1;
            const thisRequestId = vm.currentPredictRequestId;
            vm.isDiagPredictLoading = true;
            var tempInstances = [];
            if(!_.isEmpty(scopeFaults)){
                _.map(scopeFaults, function(item){
                    tempInstances.push({'faults':item, 'diagFileId':vm.selectedDiagFileId})
                })
            }
            DiagFileBusinessService.getPredictions(vehFamily, tempInstances, vehFamily).then(function (diagFilePredictionsResponse) {
                if(diagFilePredictionsResponse && !_.isEmpty(diagFilePredictionsResponse.errors) && diagFilePredictionsResponse.errors[0].errorCode == 200){
                    vm.diagFile.preDiagMessage = diagFilePredictionsResponse.errors[0].errorMessage;
                    setDiagFileDetailsInCache();
                } else {
                    vm.diagFile.preDiagMessage = '';
                    vm.partLabourTimes = diagFilePredictionsResponse;
                    vm.partLabourTimes.data = [];
                    if(!_.isEmpty(diagFilePredictionsResponse.predictions)){
                        diagFilePredictionsResponse.predictions = _.sortBy(diagFilePredictionsResponse.predictions);
                        vm.diagPredictionsForAlert = diagFilePredictionsResponse.predictions[0];

                        if (diagFilePredictionsResponse.predictions[0]['rule'].partLabel != 'N/A' && diagFilePredictionsResponse.predictions[0]['rule'].partLabel != '') {
                            diagFilePredictionsResponse.predictions[0]['rule'].isRulePresent = true;
                            if(diagFilePredictionsResponse.predictions[0].dtcRule){
                                vm.dtcRule = diagFilePredictionsResponse.predictions[0].dtcRule.replace(/[{}']/g, "");
                            }
                            if (!vm.dtcRule || vm.dtcRule.trim() === "") {
                                vm.dtcRule = "-";
                            }
                            diagFilePredictionsResponse.predictions[0]['rule'].dtcRuleLabel = vm.dtcRule;
                            vm.partLabourTimes.data.push(diagFilePredictionsResponse.predictions[0]['rule']);
                            _.extend(vm.diagFile, {
                                predictionData: vm.partLabourTimes.data,
                            });
                            setDiagFileDetailsInCache(true);
                        }
                        var predObj = diagFilePredictionsResponse.predictions[0];
                        if (predObj && typeof predObj === 'object') {
                            var keys = Object.keys(predObj).filter(function(k) {
                                return ['top1', 'top2', 'top3'].includes(k);
                            });
                            if (_.isEqual(keys.sort(), ['top1','top2','top3'].sort())) {
                                diagFilePredictionsResponse.predictions[0] = _.orderBy(
                                    [predObj.top1, predObj.top2, predObj.top3],
                                    'proba',
                                    'desc'
                                );
                            }
                        }

                        if ((['XHN', 'XJB', 'X1310', 'X1316', 'X1317','XDD', 'XJA', 'XJL','X10'].includes(vehFamily) && diagFilePredictionsResponse.predictions[0][0].proba >= 0.5) ||
                            (vehFamily == 'XCB' && diagFilePredictionsResponse.predictions[0][0].proba >= 0.3)) {

                            _.map(diagFilePredictionsResponse.predictions[0], function (item) {
                                vm.partLabourTimes.data.push(item);
                            });

                            _.extend(vm.diagFile, {
                                predictionData: vm.partLabourTimes.data,
                            });
                            var searchGenericParts = [];
                            vm.partLabourTimes.data.forEach(function(item){
                                if(item.pgId && item.pgId !== 'N/A' && item.pgId !== ''){
                                    searchGenericParts.push(item.pgId);
                                }
                            })
                            
                            _.each(vm.partLabourTimes.data, function (item) {
                                if (item.pgId !== 'N/A' && item.pgId !== '' && item !== diagFilePredictionsResponse.predictions[0]['rule']) {
                                    var text = item.pgId;
                                    var type = ["PR"];
                                    var userContext = CacheService.getObject(CacheConstants.profil);
                                    var lang = (userContext && userContext.documentationFirstLanguage && userContext.documentationFirstLanguage.code === 'fr') ? 'fr' : 'en';
                                    var additionalCountry = (userContext && userContext.documentationFirstLanguage && userContext.documentationFirstLanguage.code === 'fr') ? 'FR' : 'GB';
                                    searchByTextsIdsMertierService.getSearchEngineDocs(text, type,
                                        null, lang, additionalCountry).then(function (searchEngineDocsResponse) {
                                            if (searchEngineDocsResponse && searchEngineDocsResponse.documents && searchEngineDocsResponse.documents.length > 0) {
                                                item.partLabel = searchEngineDocsResponse.documents[0].label;
                                            }
                                        });
                                }
                            });
                        _.extend(vm.diagFile, {
                            mlmodelDisplayName: diagFilePredictionsResponse.mlmodelDisplayName,
                            mlmodelVersionId: diagFilePredictionsResponse.mlmodelVersionId
                        });
                        vm.diagFile.predictionData
                        .forEach(function(item) {
                            if (item.pgId && item.pgId !== 'N/A' && item.pgId !== '') {
                                _.extend(item, {
                                    partNumberLoading: true,
                                    cataloguePlateLoading: true
                                });
                            }
                        });
                         DocumentsMetierService.getPartsByGenericParts(searchGenericParts).then(function (response) {
                            if(response){
                                vm.diagFile.predictionData.forEach(function(item){
                                    response.references.forEach(function(responseData){
                                        if(item.pgId === responseData.genericPart){
                                            _.extend(item,{
                                                partNumber: responseData.reference,
                                                partLabel: responseData.designation,
                                                cataloguePlate: !_.isEmpty(responseData.catalogPlates) ? responseData.catalogPlates[0].id : null
                                            })
                                        } 
                                    })     
                                })
                                setDiagFileDetailsInCache(true);
                            }
                        }).finally(function(){
                            vm.diagFile.predictionData.forEach(function(item) {
                                _.extend(item, {
                                    partNumberLoading: false,
                                    cataloguePlateLoading: false
                                });
                            });
                            setDiagFileDetailsInCache(true);
                        })
                        var payload = {
                            docId: vm.diagFile.id,
                            docType: DiagFileDetailsNewConstants.alertPredictions,
                            vin: vm.diagFile.vin,
                            predictionVersion: vm.diagFile.mlmodelDisplayName + ' - ' + vm.diagFile.mlmodelVersionId
                        };
                        DiagFileBusinessService.getPredictionVotes(payload).then(function (response) {

                            _.extend(vm.diagFile, {
                                isDiagPredictLiked: response ? response.predictionLiked : ''
                            });

                        }).catch(function () {
                            toastr.error($translate.instant("ERROR"));
                        }).finally(function () {
                            setDiagFileDetailsInCache(true);
                        });
                    }

                        if (vm.partLabourTimes.data.length == 0 || vm.partLabourTimes.data.length == 1) {
                            _.extend(vm.diagFile, {
                            mlmodelDisplayName: diagFilePredictionsResponse.mlmodelDisplayName,
                            mlmodelVersionId: diagFilePredictionsResponse.mlmodelVersionId
                        });
                            vm.diagFile.preDiagMessage = $translate.instant("NO_DIAG_PREDICTION");
                            setDiagFileDetailsInCache(true);
                        }


                    } else {
                        _.extend(vm.diagFile, {
                            mlmodelDisplayName: diagFilePredictionsResponse.mlmodelDisplayName,
                            mlmodelVersionId: diagFilePredictionsResponse.mlmodelVersionId
                        });
                        vm.diagFile.preDiagMessage = $translate.instant("NO_PREDICTIONS_DIAG");
                        setDiagFileDetailsInCache(true);
                    }                    
                }
            }).catch(function (error) {
                if(vm.currentPredictRequestId === thisRequestId){
                    vm.diagFile.preDiagMessage = $translate.instant("NO_DIAG_PREDICTION");
                    setDiagFileDetailsInCache();
                }
                
            }).finally(function (fin) {
                // Only reset loading if this is the latest request
                if (vm.currentPredictRequestId === thisRequestId) {
                    vm.isDiagPredictLoading = false;
                }
            });
        }
          function goToProduct(piece) {
            CacheService.setObject(CacheConstants.selectedDiagFileId, vm.selectedDiagFileId);
            angular.element(function () {
                var path = {
                    reference: piece.partNumber,
                    isFromDiagFileDetails: true,
                    systemDocSubMenu:vm.systemDocSubMenu,
                    systemDocResponse:vm.systemDocResponse

                }                
                RoutingService.goToProductPage({
                    path: path
                })
            });
        }
        function goToTextSearch(item,refCataloguePlate){
            CacheService.setObject(CacheConstants.selectedDiagFileId, vm.selectedDiagFileId);
            angular.element(function () {
                var path = {
                    reference: refCataloguePlate == 'ref' ?  item.partNumber : item.cataloguePlate,
                    systemDocSubMenu:vm.systemDocSubMenu,
                    systemDocResponse:vm.systemDocResponse
                }                
                RoutingService.goToTextSearchPage({
                    path: path
                })
            });
        }
        function setDiagFileDetailsInCache(setAdditionalDetails){
            var index = _.findIndex(vm.diagFilesList,function(item){
                    return item.id == vm.selectedDiagFileId;
                });
            if(setAdditionalDetails){
                _.extend(vm.diagFilesList[index],{noPreDiagFamily: vm.diagFile.noPreDiagFamily, preDiagMessage: vm.diagFile.preDiagMessage,predictionData: vm.diagFile.predictionData,mlmodelDisplayName: vm.diagFile.mlmodelDisplayName, mlmodelVersionId: vm.diagFile.mlmodelVersionId, isDiagPredictLiked: vm.diagFile.isDiagPredictLiked});
            } else {
                _.extend(vm.diagFilesList[index],{noPreDiagFamily: vm.diagFile.noPreDiagFamily, preDiagMessage: vm.diagFile.preDiagMessage});
            }            
            CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);
        }
        /**
         * to get the BT & MD details of all DTCs
         */
        function getBTAndMDAvailability() {

            if(vm.typeMD === 'ADT'){
                if(vm.diagFile.mileage){
                    var mileageData = vm.diagFile.mileage.split(" ");
                    if(mileageData.length === 2){
                        var mileage = parseInt(mileageData[0]);
                        _.assign(vm.diagFile, { mileage: mileage+" " +mileageData[1]})
                    }
                    
                }
            }

            if (vm.diagFile.dtcs && !_.isEmpty(vm.diagFile.dtcs)) {
                var dtcCodes = [];
                angular.forEach(vm.diagFile.dtcs, function (item) {
                    if(item.code && !_.isEmpty(item.code)){
                        var dtc = item.code ? item.code.substring(0,3) === 'DTC' ? item.code.substr(3): item.code : '';
                        dtcCodes.push(dtc);
                    }
                })

                if (dtcCodes && !_.isEmpty(dtcCodes)) {
                    blockUI.start();
                    var dataBody = ResultSearchByDiagnosticMetierService.createDataObject('', dtcCodes, '');

                    return ResultSearchByDiagnosticMetierService.getAllCodes(dataBody)
                        .then(function (response) {
                            vm.data = response;
                            getValidBtDocuments(vm.data.documents).then(function(){
                                vm.contextVehicle.diagDocuments = vm.data;
                                CacheService.setObject(CacheConstants.contextCarSearch, vm.contextVehicle);
                                setBTAndMDavailability();
                                return response;
                            });
                        }, function (err) {
                            toastr.error(err);
                        }).finally(function () {
                            blockUI.stop();
                        });
                }else{
                    return $q.resolve();
                }
            }else{
                return $q.resolve();
            }
        }
        function getValidBtDocuments(documents){
            var defer = $q.defer();
            var btList = [];
            vm.btDtcCombined = [];
            if(!_.isEmpty(documents)){
                documents.forEach(function(item){
                    if(item.type == DiagFileDetailsNewConstants.documentBT){
                        if(!_.isEmpty(item.indexationsTags.DTC)){
                            item.indexationsTags.DTC.forEach(function(value){
                                vm.btDtcCombined.push({code:value,id:item.id})
                            })
                        }                        
                        btList.push({
                            id: item.id,
                            subType: item.subType
                        });
                    }   
                })
                if(!_.isEmpty(btList)){
                    _.map(vm.diagFile.dtcs,function(item){
                        _.assign(item, {
                            isBTLoading : true
                        })
                    })
                    ResultSearchByDiagnosticMetierService.getBTList(btList).then(function(response){
                        if(response && !_.isEmpty(response.BTInformation) && !_.isEmpty(vm.btDtcCombined)){
                            vm.btDtcCombined = _.groupBy(vm.btDtcCombined,'id');
                            response.BTInformation.forEach(function(item){
                                vm.btDtcCombined[item.id].forEach(function(value){
                                    if(item.id == value.id)
                                        vm.techBulletinList.push(value);
                                })
                            })
                        }
                    }).finally(function(){
                        _.map(vm.diagFile.dtcs,function(item){
                            _.assign(item, {
                                isBTLoading : false
                            })
                        })
                        defer.resolve(vm.data);
                    })
                } else{
                    vm.contextVehicle.diagDocuments = vm.data;
                    CacheService.setObject(CacheConstants.contextCarSearch, vm.contextVehicle);
                    setBTAndMDavailability();
                }
            }
            return defer.promise;
        }
        /**
         * integrate the BT & MD details in the dtc
         */
        function setBTAndMDavailability() {

            _.map(vm.diagFile.dtcs, function (item) {
                _.extend(item, {
                    isBTAvailable: DiagFileDetailsNewConstants.NO,
                    isMDAvailable: DiagFileDetailsNewConstants.NO
                });
            })

            if (vm.data.documents && !_.isEmpty(vm.data.documents)) {

                vm.data.documents.forEach(function (data) {

                    data.indexationsTags.DTC.forEach(function (dtc) {

                        _.map(vm.diagFile.dtcs, function(dtcDetails) {
                            var dtcData = dtcDetails.code ? dtcDetails.code.substring(0,3) === 'DTC' ? dtcDetails.code.substr(3): dtcDetails.code : '';
                            if(data.type === DiagFileDetailsNewConstants.documentMD){
                                if(dtcDetails.documentationCode && dtcDetails.documentationCode != '' && !_.isEmpty(data.indexationsTags.LabelDTC)){
                                    if(dtcData.toUpperCase() === dtc.toUpperCase() && data.indexationsTags.LabelDTC.includes(dtcDetails.documentationCode)){        
                                        dtcDetails.isMDAvailable = DiagFileDetailsNewConstants.YES;
                                    }
                                }
                                else if(dtcData.toUpperCase() === dtc.toUpperCase()){
                                    dtcDetails.isMDAvailable = DiagFileDetailsNewConstants.YES;
                                }
                            }

                            if(data.type === DiagFileDetailsNewConstants.documentBT && dtcData.toUpperCase() === dtc.toUpperCase()){
                                if(!_.isEmpty(vm.techBulletinList)){
                                    vm.techBulletinList.forEach(function(value){
                                        if(dtcData.toUpperCase() == value.code.toUpperCase())
                                            dtcDetails.isBTAvailable = DiagFileDetailsNewConstants.YES;
                                    })
                                }
                            }
                        })
                    })
                })
            }

            setDropDownData();

            _.map(vm.diagFilesList, function (item) {
                if (item.id === vm.selectedDiagFileId) {

                    _.forIn(vm.diagFile, function(value,key){
                        item[key] = value;
                    })
                } else {
                    delete item['dtcs'];
                }
            })
            CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);

        }

        function redirectToDtcPage(dtcDetails) {

            var dtc = dtcDetails.code ? dtcDetails.code.substring(0,3) === 'DTC' ? dtcDetails.code.substr(3): dtcDetails.code : '';
            var data = {
                code:dtc,
                label:'',
                documentationCode:(dtcDetails.documentationCode && dtcDetails.documentationCode != '') ? dtcDetails.documentationCode : null,
                docDescription:dtcDetails.description,
                ecuLabel:(dtcDetails.ecuLabel && dtcDetails.ecuLabel != '') ? dtcDetails.ecuLabel : null
            }
            CacheService.setObject(CacheConstants.searchedSymptom, data);
            vm.goToResultByDiagnostic(dtc, 2, dtc);
        }

        function redirectToContextPage(dtcItem){
            if(dtcItem.context && ((dtcItem.context.extendedData && !_.isEmpty(dtcItem.context.extendedData)) ||  (dtcItem.context.snapshot && !_.isEmpty(dtcItem.context.snapshot)))){
                vm.showExtendedAndSnapshot(dtcItem);
            }
        }
        function showExtendedAndSnapshot(dtc){
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl:
                    "app/components/car/searchByDiagnostic/DiagnosticFileDetails/dtcContextDialog.template.html",
                controller: "DiagFileDetailsController",
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true,
                locals: {
                    dtc: dtc
                }
            });
            
        }
        function onClose() {
            $mdDialog.hide();
        } 

        function openAlertPopIn(isLiked){

            vm.isLiked = isLiked;

            var carContext = CacheService.getCarContext();  
            var vehFamily = carContext.fixedCriterias['007']; 
            var data = {
                vehicleInfo: vehFamily + ' - ' + carContext.vin,
                vehFamily: vehFamily,
                version : vm.diagFile.mlmodelDisplayName + " - " + vm.diagFile.mlmodelVersionId,
                concernedDocument : vm.diagFile.id,
                predictionDetails : vm.diagPredictionsForAlert
            }
            AlertsService.setPopinVisibility(true, DiagFileDetailsNewConstants.alertPredictions, data);
            
        }


        var destroyHandler = $rootScope.$on('savePrediagVote', function(event, data) {
            savePredictionVotes(vm.isLiked);
        });

        $scope.$on('$destroy', destroyHandler);

        function savePredictionVotes(isLiked) {

            var payload = {
                            docId: vm.diagFile.id,
                            docType: DiagFileDetailsNewConstants.alertPredictions,
                            vin: vm.diagFile.vin,
                            predictionVersion: vm.diagFile.mlmodelDisplayName + ' - ' + vm.diagFile.mlmodelVersionId,
                            isLiked: isLiked
                        };
            SearchArboTextualMetierService.getBasketVotes(payload).then(function (response) {
                _.extend(vm.diagFile, {
                    isDiagPredictLiked: response ? response.predictionLiked : ''
                });
            }).catch(function () {
                toastr.error($translate.instant("ERROR"));
            }).finally(function () {
                setDiagFileDetailsInCache(true);
            });

        }

    }

})();
(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagFileCompare', diagFileCompare);

    /** @ngInject */
    function diagFileCompare() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/DiagnosticFileCompare/diagFileCompare.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagFileCompareController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "=",
                diagFirstId: "=",
                diagSecondId: "=",
                firstSelectedDiagFile: "=",
                secondSelectedDiagFile: "=",
                diagFilesList: "=",
                secondDiagFilesList: "="
            },
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict'

    angular
        .module('phenix')
        .controller('diagFileCompareController', diagFileCompareController)
        .filter('dtcslice', function () {
            return function (text) {
                return text ? (text.substr(0, 3) == 'DTC' ? text.substr(3) : text) : '';
            }
        });

    /** @ngInject */
    function diagFileCompareController(
        CacheConstants,
        CacheService,
        DiagFileBusinessService, UtilsMetierService,
        blockUI, toastr, DiagFileDetailsNewConstants, $q,$rootScope) {

        var vm = this;

        //Variables

        vm.isNewDtcsVisible = true;
        vm.isChangedDtcsVisible = false;
        vm.isSameDtcsVisible = false;
        vm.isOldDtcsVisible = false;
        vm.isCompareDataVisible = false;
        vm.compareButton = false;

        //Functions

        vm.compareDiagfiles = compareDiagfiles;
        vm.newDtcsVisible = newDtcsVisible;
        vm.changedDtcsVisible = changedDtcsVisible;
        vm.sameDtcsVisible = sameDtcsVisible;
        vm.oldDtcsVisible = oldDtcsVisible;
        vm.isTechProfile = UtilsMetierService.isTechProfil();

        this.$onInit = function () {
            vm.firstSelectedDiagFile = "";
            vm.secondSelectedDiagFile = "";
            _.map(vm.diagFilesList, function(item){
                _.assign(item,{isDisabled : false,ischecked:false});
            });
            _.map(vm.secondDiagFilesList, function(item){
                _.assign(item,{isDisabled : false,ischecked:false});
            });

        }

        $rootScope.$on('buttonColorchange', function (event,data) {
            if(data){ 
                vm.compareButton = true;
                
            }else{
                vm.compareButton = false;
            }
                vm.isCompareDataVisible = false;
                vm.isNewDtcsVisible = false;
                vm.isChangedDtcsVisible = false;
                vm.isSameDtcsVisible = false;
                vm.isOldDtcsVisible = false;
        });
        
        function compareDiagfiles() {
            vm.isNewDtcsVisible = true;
            if (vm.diagFirstId != null && vm.diagSecondId != null) {

                blockUI.start();
                var userContext = CacheService.getObject(CacheConstants.profil);
                var preferredLanguage = userContext.documentationFirstLanguage.code;
                var defaultLanguage = userContext.documentationSecondLanguage.code;
                var firstdiagResp = [];
                var seconddiagResp = [];
                var filtered = [];
                vm.newDtcs = [];
                vm.oldDtcs = [];
                vm.sameDtcs = [];
                vm.changedDtcs = [];

                $q.all([
                    DiagFileBusinessService.getDiagFileById(vm.diagFirstId, preferredLanguage, defaultLanguage),
                    DiagFileBusinessService.getDiagFileById(vm.diagSecondId, preferredLanguage, defaultLanguage)

                ]).then(function (response) {

                    if (response.length == 2) {
                        vm.isCompareDataVisible = true;
                        if(!_.isEmpty(response[0]) && !_.isEmpty(response[1])){
                            filtered.push(response[0], response[1]);
                            filtered = _.orderBy(filtered, 'captureDateTime', 'desc');
                        }

                        firstdiagResp = _.sortBy(processResponse(filtered[0]), 'code');
                        seconddiagResp = _.sortBy(processResponse(filtered[1]), 'code');
                        vm.newDtcs = angular.copy(firstdiagResp);
                        vm.oldDtcs = angular.copy(seconddiagResp);

                        if (firstdiagResp.length > 0 && seconddiagResp.length > 0) {

                            for (var i = 0; i < firstdiagResp.length; i++) {
                                for (var j = 0; j < seconddiagResp.length; j++) {

                                    if ((firstdiagResp[i].code == seconddiagResp[j].code) && ((firstdiagResp[i].statusCode != seconddiagResp[j].statusCode) || (firstdiagResp[i].occurrences != seconddiagResp[j].occurrences) || (firstdiagResp[i].mileage != seconddiagResp[j].mileage))) {
                                        _.extend(seconddiagResp[j], {
                                            oldStatusCode: firstdiagResp[i].statusCode,
                                            oldMileage: firstdiagResp[i].mileage,
                                            oldOccurences: firstdiagResp[i].occurrences
                                        })
                                        vm.changedDtcs.push(seconddiagResp[j]);
                                    }

                                    else if ((firstdiagResp[i].code == seconddiagResp[j].code) && (firstdiagResp[i].statusCode == seconddiagResp[j].statusCode) && (firstdiagResp[i].occurrences == seconddiagResp[j].occurrences) && (firstdiagResp[i].mileage == seconddiagResp[j].mileage)) {
                                        vm.sameDtcs.push(seconddiagResp[j]);
                                    }

                                }
                            }

                            vm.newDtcs = _.uniq(vm.newDtcs);
                            vm.changedDtcs = _.uniq(vm.changedDtcs);
                            vm.sameDtcs = _.uniq(vm.sameDtcs);
                            vm.oldDtcs = _.uniq(vm.oldDtcs);                            

                            processdtcs(vm.changedDtcs);
                            processdtcs(vm.sameDtcs);

                        }
                    }

                }).catch(function () {
                    toastr.error(error);
                }).finally(function () {
                    blockUI.stop();
                });
            }

        }

        function processResponse(diagFileByIdResponse) {


            var filteredResponse = _.pick(diagFileByIdResponse, DiagFileDetailsNewConstants.requiredDiagFileDetailsFields);

            if (!_.isEmpty(filteredResponse.dtcs)) {

                filteredResponse.dtcs = filteredResponse.dtcs.filter(function (item) {
                    return (item.description != "null" && !_.isEmpty(item.description));
                })

                filteredResponse.dtcs = filteredResponse.dtcs.sort(compare);

                _.map(filteredResponse.dtcs, function (item) {

                    if (vm.typeMD === 'ADT' || (vm.typeMD === 'B3' && filteredResponse.origin === 'dbb')) {
                        _.assign(item, {
                            code: (item.code && item.type) ? item.code.concat(item.type) : item.code
                        })
                    }

                    _.assign(item, {
                        mileage: item.mileage ? (item.mileage !== 'NA' ? parseInt(item.mileage) : item.mileage) : '',
                        occurrences: item.occurrences ? (item.occurrences !== 'NA' ? parseInt(item.occurrences) : item.occurrences) : '',
                        statusCode: item.statusCode ? item.statusCode : item.status,
                        isFFDAvailable: (item.context &&
                            ((item.context.extendedData && !_.isEmpty(item.context.extendedData)) ||
                                (item.context.snapshot && !_.isEmpty(item.context.snapshot)))) ?
                            DiagFileDetailsNewConstants.YES : DiagFileDetailsNewConstants.NO
                    });
                })
            }
            return filteredResponse.dtcs;
        }

        function compare(a, b) {
            if (a.ecuLabel > b.ecuLabel) return -1;
            if (a.ecuLabel < b.ecuLabel) return 1;

            if (a.mileage === "NA") {
                return -1;
            }
            if (b.mileage === "NA") {
                return 1;
            }
            if (parseInt(a.mileage) > parseInt(b.mileage)) return -1;
            if (parseInt(b.mileage) > parseInt(a.mileage)) return 1;
            return 0;
        }

        function processdtcs(items) {
            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    var newindex = _.findIndex(vm.newDtcs, function (item) {
                        return item.code == items[i].code;
                    });
                    if (newindex != -1) {
                        vm.newDtcs.splice(newindex, 1)
                    }

                    var oldindex = _.findIndex(vm.oldDtcs, function (item) {
                        return item.code == items[i].code;
                    });
                    if (oldindex != -1) {
                        vm.oldDtcs.splice(oldindex, 1)
                    }
                }
            }

        }

        function newDtcsVisible(){
            vm.isNewDtcsVisible = !vm.isNewDtcsVisible;
        }

        function changedDtcsVisible(){
            vm.isChangedDtcsVisible = !vm.isChangedDtcsVisible;
        }

        function sameDtcsVisible(){
            vm.isSameDtcsVisible = !vm.isSameDtcsVisible;
        }

        function oldDtcsVisible(){
            vm.isOldDtcsVisible = !vm.isOldDtcsVisible;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagEcu', diagEcu);

    /** @ngInject */
    function diagEcu() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/DiagnosticEcu/diagEcu.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagEcuController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "="
            },
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('diagEcuController', diagEcuController);

    /* @inject */
    function diagEcuController(CacheService,CacheConstants, $scope,$rootScope,DiagFileBusinessService,blockUI,$q,
        $translate,CustomFilterSortService,toastr,DiagFileDetailsNewConstants, RestUpgrade) {

        var vm = this;
        $scope.diagFile = {};
        $scope.ecus = [];
        vm.collapssed = false; 
        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);

        vm.fullDataFilter = [];
        vm.firstFilter = [];
        vm.secondFilter = [];
        
        vm.filterArray = [
            { label: 'ESTIMATE_CATEGORY_LABEL', key: 'category', values: [], selectAll: false, checkBox: true, filterData: true },
            { label: 'ECU', key: 'label', values: [], selectAll: false, checkBox: true, filterData: false },
            { label: 'ADMIN_IPN_PARAMETER', key: 'contexts.code,contexts.value,contexts.description', values: [], selectAll: false, checkBox: false, filterData: false }
        ];
        vm.expandAll = false;
        vm.filterLoader = false;
        vm.displayECU = displayECU;
        vm.onExpandAll = onExpandAll;
        vm.getECUfilter = getECUfilter;
        vm.displayAndFilterECU = displayAndFilterECU;
               

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            if (!_.isEmpty(vm.diagFilesList)) {
                _.map(vm.diagFilesList, function (item) {
                    _.extend(item, { ecuVisible: false })
                })
                if(vm.typeMD != 'ADT')
                    if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                        displayAndFilterECU(vm.diagFilesList[0].id, false);
                    }
            }

        };

        $scope.$on('getPaginatedData', function (event,fromScreen,data) {
            if(fromScreen === DiagFileDetailsNewConstants.ECU){
                vm.diagFilesList = data;
                if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                    displayAndFilterECU(vm.diagFilesList[0].id, false);
                }
            } 
        });

        var deregisterDiagDataFound = $rootScope.$on('diagDataFound', function (event,fromScreen) {
            if(fromScreen === DiagFileDetailsNewConstants.ECU){
                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                    displayAndFilterECU(vm.diagFilesList[0].id, false);
                }
            }
            
        });

        $scope.$on('$destroy', function () {
            if (typeof deregisterDiagDataFound === 'function') {
                deregisterDiagDataFound();
            }
        });

        function onExpandAll(expand) {

            if (vm.diagFilesList && !_.isEmpty(vm.diagFilesList)) {
                var promiseArray = _.map(vm.diagFilesList, function (item) {
                    return displayECU(item.id, expand);
                });
                $q.all(promiseArray).then(function(){
                    getECUfilter();
                })
            }

        }

        function displayAndFilterECU(id,ecuVisible){
            displayECU(id, ecuVisible).then(function(){
                getECUfilter();
            });
        }

        
        function displayECU(id,ecuVisible) {

           return $q.resolve().then(function () {
            var userContext = CacheService.getObject(CacheConstants.profil);
            var preferredLanguage = userContext.documentationFirstLanguage.code;
            var defaultLanguage = userContext.documentationSecondLanguage.code;
            if (!ecuVisible){
               
                for (var i=0; i< vm.diagFilesList.length; i++){
                    if (vm.diagFilesList[i].id == id){
                        if (!vm.diagFilesList[i].ecus){
                            blockUI.start();
                           return DiagFileBusinessService.getDiagFileById(id, preferredLanguage, defaultLanguage).then(function(
                                diagFileByIdResponse
                            ) {
                                $scope.diagFile = diagFileByIdResponse;
                                                               
                                return sortEcus($scope.diagFile.ecus,id).then(function(){
                                    return;
                                });
                                                                
                            });
                        }
                        else{
                            return sortEcus(vm.diagFilesList[i].ecus,id).then(function(){
                                return;
                            });
                        }
                        
                    }
                    
                }
            }
            else{
                _.find(vm.diagFilesList,function (item){
                    if (item.id == id){
                        item.ecuVisible = false;
                    }

                }) 

                return;
            }
        }).catch(function(err){
            if(err && err.status && err.status != 200){
                toastr.error($translate.instant("DIAG_FILE_SEVICE_ERROR"));
            }else{
                toastr.error($translate.instant("ERROR"));
            }
        }).finally(function(){
            // vm.filterLoader = false;
            blockUI.stop(); 
        })
            
        }

        function getECUfilter(){
            vm.filterLoader = true;
            
            var isExpanded = _.filter(vm.diagFilesList, function(item){
                return !item.ecuVisible;
            })

            if(isExpanded && !_.isEmpty(isExpanded)){
                vm.expandAll = false;
            }else{
                vm.expandAll = true;
            }

            var isAllCollapsed = _.filter(vm.diagFilesList, function(item){
                return item.ecuVisible;
            }) 

            if(!isAllCollapsed || _.isEmpty(isAllCollapsed)){
                vm.firstFilter = [];
                vm.secondFilter = [];
            }

            var payload = {
                fullData: vm.diagFilesList,
                dataToFilter: 'ecus',
                visibility:'ecuVisible',
                filterArray: vm.filterArray,
                systemFilter: ''
            }
            return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU).post(payload)
            .then(function (response) {
                if (response) {
                    vm.filterArray = response;  
                } else {
                    toastr.error($translate.instant("FILTER_ERROR"));
                }
            }).finally(function(){
                vm.filterLoader = false; 
            })
        }

        function sortEcus(ecus,id) {

           return $q.resolve().then(function () {
                var sortedEcus = [];
                
                angular.forEach(ecus, function(ecu, key){
                    if (ecu.contexts && ecu.contexts.length > 0) {
                        sortedEcus.push(ecu);
                    }
                });
                sortedEcus.sort(function(a, b) {
                    return a.contexts.length > b.contexts.length
                        ? 1
                        : a.contexts.length < b.contexts.length
                        ? -1
                        : 0;
                });
                sortedEcus = _.orderBy(sortedEcus,'label');
                if(!_.isEmpty(sortedEcus)){
                angular.forEach(sortedEcus, function(ecu){
                    if(ecu && !_.isEmpty(ecu.contexts) && ecu.domainId && ecu.domainId === "77"){
                        _.remove(ecu.contexts, function (item) {
                            return item.code === "ID012" || item.code === "ID013" || item.code === "ID032" || item.code === "ID039";
                        });
                    }                  
                });
            }
                $scope.ecus = sortedEcus;
                            
                _.map(vm.diagFilesList, function (item) {

                    if(vm.typeMD === 'ADT'){
                        if(item.mileage){
                            var mileageData = item.mileage.split(" ");
                            if(mileageData.length === 2){
                                var mileage = parseInt(mileageData[0]);
                                _.assign(item, { mileage: mileage+" " +mileageData[1]})
                            }
                            
                        }
                    }

                    if (item.id === id) {
                        _.extend(item, { ecus: sortedEcus, ecuVisible : true })
                    } 
                    
                })

                if(vm.typeMD != 'ADT')
                    CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);
                return;
            })
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('diagDtcHistory', diagDtcHistory);

    /** @ngInject */
    function diagDtcHistory() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/DiagnosticDtcHistory/diagDtcHistory.template.html',
            restrict: 'E',
            replace: false,
            controller: 'diagDtcHistoryController',
            controllerAs: 'vm',
            scope: {
                typeMD: '=',
                isArcaUser: "=",
                isAdtTechrole:"=",
                currentPage: "=",
                dataperPage: "=",
                loadPagination: "="
            },
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('diagDtcHistoryController', diagDtcHistoryController);

    /* @inject */
    function diagDtcHistoryController(CacheService, CacheConstants, $q, DiagFileBusinessService, blockUI, $mdDialog,$scope,
        DiagFileDetailsNewConstants,CustomFilterSortService,$rootScope,toastr,
        $translate,RestUpgrade, UtilsMetierService) {

        var vm = this;
        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
        vm.diagfile = {};
        vm.firstFilter = [];
        vm.expandAll = false;
        vm.filterLoader = false;
        vm.displayDtcHistory = displayDtcHistory;
        vm.redirectToContextPage = redirectToContextPage;
        vm.showExtendedAndSnapshot = showExtendedAndSnapshot;
        vm.onExpandAll = onExpandAll;
        vm.getDtcFilter = getDtcFilter;
        vm.displayAndFilterDtc = displayAndFilterDtc;
        vm.isTechProfile = UtilsMetierService.isTechProfil();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.$onInit = function () {
            if (!_.isEmpty(vm.diagFilesList)) {
                _.map(vm.diagFilesList, function (item) {
                    _.extend(item, { isDtcHistoryVisible: false });
                })
                if(vm.typeMD != 'ADT')
                    if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                        displayAndFilterDtc(vm.diagFilesList[0].id, false);
                    }
            }
           if(vm.typeMD === 'ADT') {
            vm.filterArray = [
                { label: 'COMMON_STATUS', key: 'statusCode', values: [], selectAll: false, checkBox: true, filterData: false, custom: 'class', classKey:'status', class:"width10margin", valuesStyle:"width6margin" },
                { label: 'ECU', key: 'ecuLabel', values: [], selectAll: false, checkBox: true, filterData: false, class:"width15margin", valuesStyle:"width9margin" },
                { label: 'DTC', key: 'code', values: [], selectAll: false, checkBox: false, filterData: false, class:"width15margin" },
                { label: 'ALERTS_DESCRIPTION', key: 'description', values: [], selectAll: false, checkBox: false, filterData: false, class:"width20" },
                { label: 'FAV_CAT', key: 'category', values: [], selectAll: false, checkBox: false, filterData: false, class:"width10margin" },
                { label: 'KM', key: 'mileage', values: [], selectAll: false, checkBox: false, filterData: false, custom: 'numeric', class:"width10margin" },
                { label: 'OCCURRENCES_LABEL', key: 'occurrences', values: [], selectAll: false, checkBox: false, filterData: false, custom: 'numeric', class:"width10margin" }
            ];
           } else if(vm.typeMD === 'B3' || vm.typeMD === 'B2'){
            vm.filterArray = [
                { label: 'COMMON_STATUS', key: 'statusCode', values: [], selectAll: false, checkBox: true, filterData: false, custom: 'class', classKey:'status', class:"width10margin", valuesStyle:"width6margin" },
                { label: 'ECU', key: 'ecuLabel', values: [], selectAll: false, checkBox: true, filterData: false, class:"width15margin", valuesStyle:"width9margin" },
                { label: 'DTC', key: 'code', values: [], selectAll: false, checkBox: false, filterData: false, class:"width15margin" },
                { label: 'ALERTS_DESCRIPTION', key: 'description', values: [], selectAll: false, checkBox: false, filterData: false, class:"width20" },
                { label: 'KM', key: 'mileage', values: [], selectAll: false, checkBox: false, filterData: false, custom: 'numeric', class:"width15margin" },
                { label: 'OCCURRENCES_LABEL', key: 'occurrences', values: [], selectAll: false, checkBox: false, filterData: false, custom: 'numeric', class:"width10margin" }
            ];
           }
        };

        function onExpandAll(expand) {

            if (vm.diagFilesList && !_.isEmpty(vm.diagFilesList)) {
                var promiseArray = _.map(vm.diagFilesList, function (item) {
                    return displayDtcHistory(item.id, expand);
                });
                $q.all(promiseArray).then(function () {
                    getDtcFilter();
                })
            }

        }

        function displayAndFilterDtc(id, isDtcHistoryVisible) {
            displayDtcHistory(id, isDtcHistoryVisible).then(function () {
                getDtcFilter();
            });
        }

        $scope.$on('getPaginatedData', function (event,fromScreen,data) {
            if(fromScreen === DiagFileDetailsNewConstants.DTC){
                vm.diagFilesList = data;
                if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                    displayAndFilterDtc(vm.diagFilesList[0].id, false);
                }
            }
        });

        var deregisterDiagDataFound = $rootScope.$on('diagDataFound', function (event,fromScreen) {
            if(fromScreen === DiagFileDetailsNewConstants.DTC){ 
                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                if(!_.isEmpty(vm.diagFilesList) && vm.diagFilesList.length > 0){
                    displayAndFilterDtc(vm.diagFilesList[0].id, false);
                }
            }
        });

        $scope.$on('$destroy', function () {
            if (typeof deregisterDiagDataFound === 'function') {
                deregisterDiagDataFound();
            }
        });

        function displayDtcHistory(id, isDtcHistoryVisible) {

            return $q.resolve().then(function () {
                var userContext = CacheService.getObject(CacheConstants.profil);
                var preferredLanguage = userContext.documentationFirstLanguage.code;
                var defaultLanguage = userContext.documentationSecondLanguage.code;

                if (!isDtcHistoryVisible) {

                    var isDtcHistoryLoadedForId = _.find(vm.diagFilesList, { id: id })
                    
                    if (!isDtcHistoryLoadedForId.dtcs) {

                        blockUI.start();
                    return DiagFileBusinessService.getDiagFileById(id, preferredLanguage, defaultLanguage).then(function (response) {
                            vm.diagfile = response;

                            if(vm.typeMD === 'ADT'){
                                vm.diagfile.dtcs = vm.diagfile.dtcs.filter(function(item){
                                    return item.description != null && !_.isEmpty(item.description);
                                })
                            }

                            if (vm.diagfile && !_.isEmpty(vm.diagfile.dtcs)) {
                                vm.diagfile.dtcs = vm.diagfile.dtcs.sort(compare);
                            }
                            _.map(vm.diagfile.dtcs, function (item) {

                                if(vm.typeMD === 'ADT' || (vm.typeMD === 'B3' && vm.diagfile.origin === 'dbb')){
                                    _.assign(item, {
                                        code: (item.code && item.type) ? item.code.concat(item.type) : item.code
                                    })
                                }

                                _.assign(item, {
                                    mileage : item.mileage ? (item.mileage !== 'NA' ? parseInt(item.mileage) : item.mileage) : '',
                                    occurrences : item.occurrences ? (item.occurrences !== 'NA' ? parseInt(item.occurrences) : item.occurrences) : ''
                                })
                                
                                _.extend(item, {
                                    isFFDAvailable: (item.context &&
                                        ((item.context.extendedData && !_.isEmpty(item.context.extendedData)) ||
                                            (item.context.snapshot && !_.isEmpty(item.context.snapshot)))) ?
                                        DiagFileDetailsNewConstants.YES : DiagFileDetailsNewConstants.NO
                                })
                            })

                            _.map(vm.diagFilesList, function (item) {
                                if (item.id === id) {
                                    _.extend(item, {
                                        dtcs: vm.diagfile.dtcs,
                                        isDtcHistoryVisible: true
                                    })
                                }
                            })

                            return;

                        });
                    }
                    else {
                        _.find(vm.diagFilesList, function (item) {
                            if (item.id == id) {
                                item.isDtcHistoryVisible = true;
                            }
                        })

                        return;
                    }
                } else {
                    _.find(vm.diagFilesList, function (item) {
                        if (item.id == id) {
                            item.isDtcHistoryVisible = false;
                        }
                    })

                    return;
                }
            }).then(function(){

                _.map(vm.diagFilesList, function (item) {
                    if(vm.typeMD === 'ADT'){
                        if(item.mileage){
                            var mileageData = item.mileage.split(" ");
                            if(mileageData.length === 2){
                                var mileage = parseInt(mileageData[0]);
                                _.assign(item, { mileage: mileage+" " +mileageData[1]})
                            }
                            
                        }
                    }
                })
                if(vm.typeMD != 'ADT')
                    CacheService.setObject(CacheConstants.diagFilesList, vm.diagFilesList);
            }).catch(function(err){
                if(err && err.status && err.status != 200){
                    toastr.error($translate.instant("DIAG_FILE_SEVICE_ERROR"));
                }else{
                    toastr.error($translate.instant("ERROR"));
                }
            }).finally(function(){
                blockUI.stop(); 
            })

        }
        function getDtcFilter(){
            vm.filterLoader = true;
            var isExpanded = _.filter(vm.diagFilesList, function(item){
                return !item.isDtcHistoryVisible;
            })

            var isAllCollapsed = _.filter(vm.diagFilesList, function(item){
                return item.isDtcHistoryVisible;
            }) 

            if(!isAllCollapsed || _.isEmpty(isAllCollapsed)){
                vm.firstFilter = [];
            }
            if(isExpanded && !_.isEmpty(isExpanded)){
                vm.expandAll = false;
            }else{
                vm.expandAll = true;
            }
            var payload = {
                fullData: vm.diagFilesList,
                dataToFilter: 'dtcs',
                visibility:'isDtcHistoryVisible',
                filterArray: vm.filterArray,
                systemFilter: ''
            }
            return RestUpgrade.all(DiagFileDetailsNewConstants.filterECU).post(payload)
                .then(function (response) {
                    if (response) {
                        vm.filterArray = response;
                    } else {
                        toastr.error($translate.instant("FILTER_ERROR"));
                    }
                }).finally(function(){
                    vm.filterLoader = false; 
                })
        }
        function compare(a, b) {
            if(a.ecuLabel > b.ecuLabel) return 1;
            if(a.ecuLabel < b.ecuLabel) return -1;

            if (a.mileage === "NA") {
                return -1;
            }
            if (parseInt(a.mileage) > parseInt(b.mileage)) return -1;
            if (parseInt(b.mileage) > parseInt(a.mileage)) return 1;
            return 0;
        }

        function redirectToContextPage(dtcItem) {
            if(dtcItem.context && ((dtcItem.context.extendedData && !_.isEmpty(dtcItem.context.extendedData)) ||  (dtcItem.context.snapshot && !_.isEmpty(dtcItem.context.snapshot)))) {
                vm.showExtendedAndSnapshot(dtcItem);
            }
        }

        function showExtendedAndSnapshot(dtc) {
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl:
                    "app/components/car/searchByDiagnostic/DiagnosticFileDetails/dtcContextDialog.template.html",
                controller: "DiagFileDetailsController",
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true,
                locals: {
                    dtc: dtc
                }
            });

        }

    }
})();

(function () {
    'use strict';
    angular
        .module('phenix')
        .directive('batteryCrashHistory', batteryCrashHistory);

    /** @ngInject */
    function batteryCrashHistory() {

        var directive = {
            templateUrl: 'app/components/car/searchByDiagnostic/CrashHistory/batteryCrashHistory.template.html',
            restrict: 'E',
            replace: false,
            controller: 'batteryCrashHistoryController',
            controllerAs: 'vm',
            scope: {
            },
            bindToController: true
        };
        return directive;
    }
})();

(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('batteryCrashHistoryController', batteryCrashHistoryController);

    /* @inject */
    function batteryCrashHistoryController(CacheService, CacheConstants, blockUI, toastr, $scope, $translate, $filter, RestUpgrade,ResultSearchByDiagnosticMetierService,$mdDialog) {
        var vm = this;
        vm.batteryCrashHistoryData = [];
        vm.showConsentPrint = showConsentPrint;
        vm.showPrint = false;
        vm.carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);   
        vm.user = CacheService.getUserProfile();
        var binSearched = CacheService.getObject(CacheConstants.binData);
        vm.dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
        this.$onInit = function () {
            getBatteryCrashHistory();
        }
        function getBatteryCrashHistory(){
            blockUI.start();            
            var carSearchContext = CacheService.getCarContext();
            var diagData = CacheService.getObject(CacheConstants.diagFilesList);
            if(!_.isEmpty(diagData)){
                diagData = diagData.filter(function(item) {
                    return item.category === 'EndOfSession';
                });
            }
            var binVinData = null;
            var isBinSearched = false;
            if(binSearched && binSearched.showBINContent){
                if(binSearched.binValue.length == 17){
                    binVinData = binSearched.binValue;
                } else if(binSearched.binValue.length == 18){
                    binVinData = binSearched.binValue.substr(0,10)+binSearched.binValue.substr(11);
                }
                isBinSearched = true;
            } else {
                binVinData = carSearchContext.vin;
            }
            vm.batteryCrashHistoryData = [];
            ResultSearchByDiagnosticMetierService.getBatteryCrashHistory(isBinSearched,binVinData).then(function(response){
                if(isBinSearched){
                    if(!_.isEmpty(response)){
                        if(_.isEmpty(response.reuseFlag)){
                            vm.showPrint = false;
                        } else {
                            vm.showPrint = true;
                            vm.batteryStatus = response.reuseFlag
                        }
                        var results = '';
                        if(!_.isEmpty(diagData)){
                            diagData = diagData.filter(function(item1) {
                                var date1 = moment(item1.captureDateTime, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "yyyy/MM/dd"]);
                                var date2 = moment(response.reuseFlagDate, ["YYYYMMDDHHmmss", "YYYY-MM-DD", "yyyy/MM/dd"]);
                                return date1.isValid() && date2.isValid() && date1.format("YYYY-MM-DD") === date2.format("YYYY-MM-DD");
                            });
                        }                        
                        if(_.isEmpty(response.reuseFlag)){
                            results = $translate.instant('LABEL_NO_CRASH_KNOWN');
                        }
                        vm.batteryCrashHistoryData.push({vin: response.vin ? response.vin : '-', bin: response.bin ? response.bin : '-',interventionData: response.reuseFlagDate ? moment(response.reuseFlagDate, "YYYYMMDDHHmmss").format("YYYY-MM-DD") : '-', reuseFlag: response.reuseFlag, dealerId: (diagData && diagData.length > 0) ? diagData[0].dealerId : '-', result: results, class: _.isEmpty(response.reuseFlag) ? 'color-gray-italics' : ''})
                    } else {
                        _.assign(vm.batteryCrashHistoryData,{vin:'-',bin:'-',interventionData:'-',dealerId:'-',result: $translate.instant('LABEL_NO_CRASH_KNOWN'),class:'color-gray-italics'})
                    }
                } else {
                    if(response && !_.isEmpty(response.data)){
                        response.data = _.orderBy(response.data, ['reuseFlagDate'], ['desc']);   
                        if(_.isEmpty(response.data[0].reuseFlag)){
                            vm.showPrint = false;
                        } else {
                            vm.showPrint = true;
                            vm.batteryStatus = response.data[0].reuseFlag
                        }                 
                        _.map(response.data,function(item){
                            var results = '';
                            if(!_.isEmpty(diagData)){
                                diagData = diagData.filter(function(item1) {
                                    var date1 = moment(item1.captureDateTime, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "yyyy/MM/dd"]);
                                    var date2 = moment(item.reuseFlagDate, ["YYYYMMDDHHmmss", "YYYY-MM-DD", "yyyy/MM/dd"]);
                                    return date1.isValid() && date2.isValid() && date1.format("YYYY-MM-DD") === date2.format("YYYY-MM-DD");
                                });
                            }                        
                            if(_.isEmpty(item.reuseFlag)){
                                results = $translate.instant('LABEL_NO_CRASH_KNOWN');
                            }
                            vm.batteryCrashHistoryData.push({vin: item.vin ? item.vin : '-', bin: item.bin ? item.bin : '-',interventionData: item.reuseFlagDate ? moment(item.reuseFlagDate, "YYYYMMDDHHmmss").format("YYYY-MM-DD") : '-', reuseFlag: item.reuseFlag, dealerId: (diagData && diagData.length > 0) ? diagData[0].dealerId : '-', result: results, class: _.isEmpty(item.reuseFlag) ? 'color-gray-italics' : ''})
                        })
                    } else if(response.data.length == 0){
                        vm.batteryCrashHistoryData.push({vin:'-',bin:'-',interventionData:'-',dealerId:'-',result: $translate.instant('LABEL_NO_CRASH_KNOWN'),class:'color-gray-italics'})
                    } else {
                        vm.batteryCrashHistoryData.push({vin:'-',bin:'-',interventionData:'-',dealerId:'-',result: $translate.instant('LABEL_BLMS_INFO_NOT_AVAILABLE'),class: 'color-orange'});
                    }
                }
            }).catch(function(){
                vm.batteryCrashHistoryData.push({vin:'-',bin:'-',interventionData:'-',dealerId:'-',result: $translate.instant('LABEL_BLMS_INFO_NOT_AVAILABLE'),class: 'color-orange'});
            }).finally(function(){
                blockUI.stop();
            })
        }
        function showConsentPrint(type){
            if(type == 'consent'|| (type == 'print' && vm.showPrint)){
                $mdDialog.show({
                    templateUrl: 'app/components/car/rLinkCar/restartingServices/restartingServices.template.html',
                    controller: 'RestartingServicesCtrl',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    size: 'lg',
                    windowClass: 'restartingServiceModalPopup',
                    locals: {
                        vin: vm.carContextRequest.vin,
                        userInfo: vm.user,
                        dmsCustInfo: (vm.dmsResponse && vm.dmsResponse.customer) ? vm.dmsResponse.customer : "",
                        offerList: [],
                        catalogResp: [],
                        display: false,
                        isBatteryCrash: true,
                        printConsent: type,
                        bin: vm.carContextRequest.bin,
                        orNumber: (vm.dmsResponse && vm.dmsResponse.orderNumber) ? vm.dmsResponse.orderNumber : "",
                        registrationNumber: vm.carContextRequest.registrationNumber ? vm.carContextRequest.registrationNumber : null,
                        batteryStatus: vm.batteryStatus,
                        reuseFlagDate: vm.batteryCrashHistoryData.length > 0 ? vm.batteryCrashHistoryData[0].interventionData : null           
                    }
                }).catch(function () {

                });
            }
        }
    }
}) ();
(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('alertFileDetails', alertFileDetails);

    /** @ngInject */
    function alertFileDetails() {
        var directive = {
            templateUrl: 'app/components/car/searchByDiagnostic/AlertDetails/alertFileDetails.template.html',
            restrict: 'E',
            replace: false,
            controller: 'alertFileDetailsController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('alertFileDetailsController', alertFileDetailsController);

    /* @inject */
    function alertFileDetailsController(CacheService, CacheConstants, CarSearchMetierService, blockUI) {
        var vm = this;
        vm.proactiveAlerts = proactiveAlerts;
        vm.activeAlertsList = [];
        vm.closedAlertsList = [];
        vm.activeAlerts = false;
        vm.closedAlerts = false;
        this.$onInit = function () {
            proactiveAlerts();
        }

        function getCreationDate(alerts) {
            for (var i in alerts) {
                if (alerts[i].creationDateTime) {
                    var creationDate = alerts[i].creationDateTime.split("T");
                    alerts[i].creationDateTime = creationDate[0];
                }
            }
        }

        function proactiveAlerts() {
            var activeParam = {
                status: 1,
                fields: true
            }
            blockUI.start();
            CarSearchMetierService.getProactiveAlert(activeParam).then(function (response) {
                if (response && !_.isEmpty(response)) {
                    getCreationDate(response);
                    response = _.orderBy(response, 'creationDateTime', 'desc');
                    vm.activeAlertsList = response;
                }
                else {
                    vm.activeAlerts = true;
                }
            }).finally(function () {
                blockUI.stop();
            });

            var historyParam = {
                status: 0,
                fields: true
            }
            blockUI.start();
            CarSearchMetierService.getProactiveAlert(historyParam).then(function (resp) {
                if (resp && !_.isEmpty(resp)) {
                    getCreationDate(resp);
                    resp = _.orderBy(resp, 'creationDateTime', 'desc');
                    vm.closedAlertsList = resp;
                } else {
                    vm.closedAlerts = true;
                }

            }).finally(function () {
                blockUI.stop();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .factory('activeVinService', activeVinService);

    /* @ngInject */
    function activeVinService() {
        var service = {
            setActiveData: setActiveData,
            getActiveData: getActiveData,
            setAlertData: setAlertData,
            getAlertData: getAlertData,
            getVinDiag: getVinDiag,
            setVinDiag: setVinDiag,
            getFeatureData: getFeatureData,
            setFeatureData: setFeatureData,
            getRemoteConsult: getRemoteConsult,
            setRemoteConsult: setRemoteConsult
        };
        var isActive = false;
        var isAlert = false;
        var isVinDiag = false;
        var featuresData;
        var isConsult = false;
        return service;


        function setActiveData(active) {
            isActive = active;
        }

        function getActiveData() {
            return isActive;
        }

        function setAlertData(alert) {
            isAlert = alert;
        }

        function getAlertData() {
            return isAlert;
        }
        function setVinDiag(diag){
            isVinDiag =  diag;
        }

        function getVinDiag(){
            return isVinDiag;
        }

        function setFeatureData(features){
            featuresData = features;
        }

        function getFeatureData(){
            return featuresData;
        }

         function setRemoteConsult(diag){
           isConsult = diag;
        }

        function getRemoteConsult(){
            return isConsult;
        }
    }

})();


(function () {
    angular.module('phenix').constant('searchTreeMock', {
        "input": {
            "emptyDocumentsIdsCriterias": {
                "documentsIds": [],
                "criteria": "",
                "language": "fr"
            },
            "emptyDocumentsIds": {
                "documentsIds": [],
                "criteria": "test",
                "language": "fr"
            },
            "emptyCriteria": {
                "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }],
                "criteria": "",
                "language": "fr"
            },
            "notEmpty": {
                "emptyCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "",
                    "language": "fr"
                },
                "tmCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "TM",
                    "language": "fr"
                },
                "btCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "BT",
                    "language": "fr"
                },
                "mrCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "MR",
                    "language": "fr"
                },
                "mdCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "MD",
                    "language": "fr"
                },
                "prCrieria": {
                    "documentsIds": [{ 'documentType': 'MR', 'functionnalId': '101' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '107' }, { 'documentType': 'TM', 'functionnalId': '108' }, { 'documentType': 'MR', 'functionnalId': '109' }, { 'documentType': 'PR', 'functionnalId': '103' }, { 'documentType': 'MD', 'functionnalId': '107' }, { 'documentType': 'MD', 'functionnalId': '106' }, { 'documentType': 'MD', 'functionnalId': '105' }, { 'documentType': 'BT', 'functionnalId': '107' }, { 'documentType': 'BT', 'functionnalId': '110' }],
                    "criteria": "PR",
                    "language": "fr"
                }
            }
        },

        "treeNodes": {
            "emptyNodes": { "nodes": [] },
            "nodesWithoutDocs": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 0,
                                "TM": 0,
                                "MR": 0,
                                "BT": 0,
                                "MD": 0,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 0,
                                "MD_102": 0,
                                "MD_104": 0,
                                "MD_106": 0,
                                "MD_109": 0,
                                "MD_108": 0,
                                "MD_110": 0,
                                "MD_111": 0,
                                "MD_501": 0,
                                "MD_502": 0,
                                "MD_B2": 0
                            },
                        "idsDocumentsByType":
                            {
                                "PR": [],
                                "TM": [],
                                "MR": [],
                                "BT": [],
                                "MD": {
                                    "MD_101": [],
                                    "MD_102": [],
                                    "MD_104": [],
                                    "MD_106": [],
                                    "MD_109": [],
                                    "MD_108": [],
                                    "MD_110": [],
                                    "MD_111": [],
                                    "MD_501": [],
                                    "MD_502": [],
                                    "MD_B2": []
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    }
                    ]
            },
            "nodesSameCodeParentWithoutMD": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 1,
                                "TM": 1,
                                "MR": 1,
                                "BT": 1,
                                "MD": 0,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 0,
                                "MD_102": 0,
                                "MD_104": 0,
                                "MD_106": 0,
                                "MD_109": 0,
                                "MD_108": 0,
                                "MD_110": 0,
                                "MD_111": 0,
                                "MD_501": 0,
                                "MD_502": 0,
                                "MD_B2": 0
                            },
                        "idsDocumentsByType":
                            {
                                "PR": ["PR_DOC01"],
                                "TM": ["TM_DOC01"],
                                "MR": ["MR_DOC01"],
                                "BT": ["BT_DOC01"],
                                "MD": {
                                    "MD_101": [],
                                    "MD_102": [],
                                    "MD_104": [],
                                    "MD_106": [],
                                    "MD_109": [],
                                    "MD_108": [],
                                    "MD_110": [],
                                    "MD_111": [],
                                    "MD_501": [],
                                    "MD_502": [],
                                    "MD_B2": []
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    }
                    ]
            },
            "nodesV3": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 1,
                                "TM": 1,
                                "MR": 1,
                                "BT": 1,
                                "MD": 0,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 0,
                                "MD_102": 0,
                                "MD_104": 0,
                                "MD_106": 0,
                                "MD_109": 0,
                                "MD_108": 0,
                                "MD_110": 0,
                                "MD_111": 0,
                                "MD_501": 0,
                                "MD_502": 0,
                                "MD_B2": 0
                            },
                        "idsDocumentsByType":
                            {
                                "PR": ["PR_DOC01"],
                                "TM": ["TM_DOC01"],
                                "MR": ["59e480bda1de1800dceb64e9"],
                                "BT": ["BT_DOC01"],
                                "MD": {
                                    "MD_101": [],
                                    "MD_102": [],
                                    "MD_104": [],
                                    "MD_106": [],
                                    "MD_109": [],
                                    "MD_108": [],
                                    "MD_110": [],
                                    "MD_111": [],
                                    "MD_501": [],
                                    "MD_502": [],
                                    "MD_B2": []
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    }
                    ]
            },
            "nodesSameCodeParentWithMD": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 0,
                                "TM": 0,
                                "MR": 0,
                                "BT": 0,
                                "MD": 11,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 1,
                                "MD_102": 1,
                                "MD_104": 1,
                                "MD_106": 1,
                                "MD_109": 1,
                                "MD_108": 1,
                                "MD_110": 1,
                                "MD_111": 1,
                                "MD_501": 1,
                                "MD_502": 1,
                                "MD_B2": 1
                            },
                        "idsDocumentsByType":
                            {
                                "PR": [],
                                "TM": [],
                                "MR": [],
                                "BT": [],
                                "MD": {
                                    "MD_101": ["MD_101"],
                                    "MD_102": ["MD_102"],
                                    "MD_104": ["MD_104"],
                                    "MD_106": ["MD_106"],
                                    "MD_109": ["MD_109"],
                                    "MD_108": ["MD_108"],
                                    "MD_110": ["MD_110"],
                                    "MD_111": ["MD_111"],
                                    "MD_501": ["MD_501"],
                                    "MD_502": ["MD_502"],
                                    "MD_B2": ["MD_B2"]
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    }
                    ]
            },
            "nodesSameCodeParentAllTypes": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 2,
                                "TM": 3,
                                "MR": 1,
                                "BT": 1,
                                "MD": 11,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 1,
                                "MD_102": 1,
                                "MD_104": 1,
                                "MD_106": 1,
                                "MD_109": 1,
                                "MD_108": 1,
                                "MD_110": 1,
                                "MD_111": 1,
                                "MD_501": 1,
                                "MD_502": 1,
                                "MD_B2": 1
                            },
                        "idsDocumentsByType":
                            {
                                "PR": ["PR_01", "PR_02"],
                                "TM": ["TM_01", "TM_02", "TM_03"],
                                "MR": ["MR_01"],
                                "BT": ["BT_01"],
                                "MD": {
                                    "MD_101": ["MD_101"],
                                    "MD_102": ["MD_102"],
                                    "MD_104": ["MD_104"],
                                    "MD_106": ["MD_106"],
                                    "MD_109": ["MD_109"],
                                    "MD_108": ["MD_108"],
                                    "MD_110": ["MD_110"],
                                    "MD_111": ["MD_111"],
                                    "MD_501": ["MD_501"],
                                    "MD_502": ["MD_502"],
                                    "MD_B2": ["MD_B2"]
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    }
                    ]
            },
            "nodesDifferentCodeParentAllTypes": {
                "nodes":
                    [{
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 2,
                                "TM": 3,
                                "MR": 1,
                                "BT": 1,
                                "MD": 11,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 1,
                                "MD_102": 1,
                                "MD_104": 1,
                                "MD_106": 1,
                                "MD_109": 1,
                                "MD_108": 1,
                                "MD_110": 1,
                                "MD_111": 1,
                                "MD_501": 1,
                                "MD_502": 1,
                                "MD_B2": 1
                            },
                        "idsDocumentsByType":
                            {
                                "PR": ["PR_01", "PR_02"],
                                "TM": ["TM_01", "TM_02", "TM_03"],
                                "MR": ["MR_01"],
                                "BT": ["BT_01"],
                                "MD": {
                                    "MD_101": ["MD_101"],
                                    "MD_102": ["MD_102"],
                                    "MD_104": ["MD_104"],
                                    "MD_106": ["MD_106"],
                                    "MD_109": ["MD_109"],
                                    "MD_108": ["MD_108"],
                                    "MD_110": ["MD_110"],
                                    "MD_111": ["MD_111"],
                                    "MD_501": ["MD_501"],
                                    "MD_502": ["MD_502"],
                                    "MD_B2": ["MD_B2"]
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": []
                    },
                    {
                        "urlVignette": "image.jpg",
                        "urlExplodedView": null,
                        "nodeId": "N-21371",
                        "label": "Huile",
                        "documents": true,
                        "nbrDocumentsByType":
                            {
                                "PR": 1,
                                "TM": 1,
                                "MR": 1,
                                "BT": 1,
                                "MD": 11,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 1,
                                "MD_102": 1,
                                "MD_104": 1,
                                "MD_106": 1,
                                "MD_109": 1,
                                "MD_108": 1,
                                "MD_110": 1,
                                "MD_111": 1,
                                "MD_501": 1,
                                "MD_502": 1,
                                "MD_B2": 1
                            },
                        "idsDocumentsByType":
                            {
                                "PR": ["PR_12"],
                                "TM": ["TM_12"],
                                "MR": ["MR_12"],
                                "BT": ["BT_12"],
                                "MD": {
                                    "MD_101": ["MD_201"],
                                    "MD_102": ["MD_202"],
                                    "MD_104": ["MD_204"],
                                    "MD_106": ["MD_206"],
                                    "MD_109": ["MD_209"],
                                    "MD_108": ["MD_208"],
                                    "MD_110": ["MD_210"],
                                    "MD_111": ["MD_211"],
                                    "MD_501": ["MD_2501"],
                                    "MD_502": ["MD_2502"],
                                    "MD_B2": ["MD_2B2"]
                                },
                                "PRODUCTS": [],
                                "NI": ["N-21370.png"]
                            },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21348",
                        "childNodes": []
                    }
                    ]
            },

        },

        "documentsArbo": {
            "empty": [],
            "NotemptyV1": [{ "functionalId": "59e480bda1de1800dceb64e9", "documentType": "MR", "codeParent": "N-21347" }],
            "NotemptyV2": [{ "functionalId": "59e480bda1de1800dceb64e5", "documentType": "MR", "codeParent": "N-21347" }, { "functionalId": "59e480bda1de1800dceb6435", "documentType": "TM", "codeParent": "N-21347" }],
            "NotemptyV3": [{ "functionalId": "59e480bda1de1800dceb64e5", "documentType": "MR", "codeParent": "N-21347" }, { "functionalId": "59e480bda1de1800dceb6435", "documentType": "TM", "codeParent": "N-21347" }, { "functionalId": "59e480bda1de1800dceb64e5", "documentType": "MR", "codeParent": "N-21348" }],
            "NotemptyV4": [{ "functionalId": "3334", "documentType": "MR", "codeParent": "N-21347" },
            { "functionalId": "3334", "documentType": "TM", "codeParent": "N-21347" },
            { "functionalId": "3334", "documentType": "MD", "codeParent": "N-21348" },
            { "functionalId": "3334", "documentType": "PR", "codeParent": "N-21348" }],
            "NotemptyV5": [{ "functionalId": "3334", "documentType": "MR", "codeParent": "N-21347" },
            { "functionalId": "3334", "documentType": "TM", "codeParent": "N-21347" },
            { "functionalId": "3335", "documentType": "TM", "codeParent": "N-21347" },
            { "functionalId": "3334", "documentType": "MD", "codeParent": "N-21348" },
            { "functionalId": "3334", "documentType": "PR", "codeParent": "N-21348" }]
        },

        "filteredDocs": {
            "empty": [],
            "NotemptyV1": [{ "documentId": { "functionalId": "59ee0d06adbe1d00dcf4bbc0", "documentType": "TM" } }],
            "NotemptyV2": [{ "documentId": { "functionalId": "59e480bda1de1800dceb64e5", "documentType": "MR" } }],
            "NotemptyV3": [{ "documentId": { "functionalId": "59e480bda1de1800dceb64e5", "documentType": "MR" } }]
        },

        "level2Data": {
            "empty":
                [
                    {
                        "node": {
                            "urlVignette": "test.png",
                            "urlExplodedView": null,
                            "nodeId": "N-21370",
                            "label": "Moteur et périphérie",
                            "documents": true,
                            "nbrDocumentsByType": {
                                "PR": 0,
                                "TM": 0,
                                "MR": 0,
                                "BT": 0,
                                "MD": 0,
                                "PRODUCTS": 0,
                                "NI": 0,
                                "MD_101": 0,
                                "MD_102": 0,
                                "MD_104": 0,
                                "MD_106": 0,
                                "MD_109": 0,
                                "MD_108": 0,
                                "MD_110": 0,
                                "MD_111": 0,
                                "MD_501": 0,
                                "MD_502": 0,
                                "MD_B2": 0
                            },
                            "idsDocumentsByType": {
                                "PR": [
                                ],
                                "TM": [
                                ],
                                "MR": [
                                ],
                                "BT": [],
                                "MD": {
                                    "MD_101": [],
                                    "MD_102": [],
                                    "MD_104": [],
                                    "MD_106": [],
                                    "MD_109": [],
                                    "MD_108": [
                                    ],
                                    "MD_110": [],
                                    "MD_111": [],
                                    "MD_501": [],
                                    "MD_502": [],
                                    "MD_B2": [
                                    ]
                                },
                                "PRODUCTS": [],
                                "NI": [
                                    "N-21370.png"
                                ]
                            },
                            "level": 2,
                            "rang": 1,
                            "codeParent": "N-21347",
                            "childNodes": [
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21392",
                                    "label": "Filtre à huile",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 0,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 2,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [
                                        ],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": []
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 1,
                                    "codeParent": "N-21370",
                                    "childNodes": null,
                                    "$$hashKey": "object:226"
                                },
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21393",
                                    "label": "Filtre à air",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 1,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 2,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [
                                        ],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": []
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 2,
                                    "codeParent": "N-21370",
                                    "childNodes": null
                                },
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21394",
                                    "label": "Filtre à carburant",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 0,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 0,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [],
                                        "TM": [
                                        ],
                                        "MR": [],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": []
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 3,
                                    "codeParent": "N-21370",
                                    "childNodes": null
                                },
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21395",
                                    "label": "Tendeur - Courroie",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 0,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 0,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [
                                        ],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": []
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 4,
                                    "codeParent": "N-21370",
                                    "childNodes": null
                                },
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21396",
                                    "label": "Allumage",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 0,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 1,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": [
                                            ]
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 5,
                                    "codeParent": "N-21370",
                                    "childNodes": null,
                                    "$$hashKey": "object:228"
                                }
                            ]
                        },
                        "arrays": [
                            [
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21392",
                                    "label": "Filtre à huile",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 0,
                                        "TM": 0,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 0,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [
                                        ],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": []
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 1,
                                    "codeParent": "N-21370",
                                    "childNodes": null,
                                    "$$hashKey": "object:226"
                                }
                            ],
                            [
                                {
                                    "urlVignette": "",
                                    "urlExplodedView": null,
                                    "nodeId": "N-21396",
                                    "label": "Allumage",
                                    "documents": true,
                                    "nbrDocumentsByType": {
                                        "PR": 2,
                                        "TM": 3,
                                        "MR": 0,
                                        "BT": 0,
                                        "MD": 0,
                                        "PRODUCTS": 0,
                                        "NI": 0,
                                        "MD_101": 0,
                                        "MD_102": 0,
                                        "MD_104": 0,
                                        "MD_106": 0,
                                        "MD_109": 0,
                                        "MD_108": 0,
                                        "MD_110": 0,
                                        "MD_111": 0,
                                        "MD_501": 0,
                                        "MD_502": 0,
                                        "MD_B2": 0
                                    },
                                    "idsDocumentsByType": {
                                        "PR": [
                                        ],
                                        "TM": [
                                        ],
                                        "MR": [],
                                        "BT": [],
                                        "MD": {
                                            "MD_101": [],
                                            "MD_102": [],
                                            "MD_104": [],
                                            "MD_106": [],
                                            "MD_109": [],
                                            "MD_108": [
                                            ],
                                            "MD_110": [],
                                            "MD_111": [],
                                            "MD_501": [],
                                            "MD_502": [],
                                            "MD_B2": [
                                            ]
                                        },
                                        "PRODUCTS": [],
                                        "NI": []
                                    },
                                    "level": 3,
                                    "rang": 5,
                                    "codeParent": "N-21370",
                                    "childNodes": null,
                                    "$$hashKey": "object:228"
                                }
                            ],
                            []
                        ],
                        "$$hashKey": "object:218"
                    }
                ],
            "notEmptyV1": [
                {
                    "node": {
                        "urlVignette": "test.png",
                        "urlExplodedView": null,
                        "nodeId": "N-21370",
                        "label": "Moteur et périphérie",
                        "documents": true,
                        "nbrDocumentsByType": {
                            "PR": 1,
                            "TM": 1,
                            "MR": 1,
                            "BT": 0,
                            "MD": 3,
                            "PRODUCTS": 0,
                            "NI": 0,
                            "MD_101": 1,
                            "MD_102": 1,
                            "MD_104": 1,
                            "MD_106": 0,
                            "MD_109": 0,
                            "MD_108": 0,
                            "MD_110": 0,
                            "MD_111": 0,
                            "MD_501": 0,
                            "MD_502": 0,
                            "MD_B2": 0
                        },
                        "idsDocumentsByType": {
                            "PR": ["PR01"
                            ],
                            "TM": ["TM01"
                            ],
                            "MR": ["MR01"
                            ],
                            "BT": [],
                            "MD": {
                                "MD_101": ["MD101"],
                                "MD_102": ["MD102"],
                                "MD_104": ["MD104"],
                                "MD_106": [],
                                "MD_109": [],
                                "MD_108": [
                                ],
                                "MD_110": [],
                                "MD_111": [],
                                "MD_501": [],
                                "MD_502": [],
                                "MD_B2": [
                                ]
                            },
                            "PRODUCTS": [],
                            "NI": [
                                "N-21370.png"
                            ]
                        },
                        "level": 2,
                        "rang": 1,
                        "codeParent": "N-21347",
                        "childNodes": [
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21392",
                                "label": "Filtre à huile",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 1,
                                    "TM": 1,
                                    "MR": 1,
                                    "BT": 0,
                                    "MD": 3,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 1,
                                    "MD_102": 1,
                                    "MD_104": 1,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 2,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": ["PR01"
                                    ],
                                    "TM": ["TM01"
                                    ],
                                    "MR": ["MR01"
                                    ],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": ["MD101"],
                                        "MD_102": ["MD102"],
                                        "MD_104": ["MD104"],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": []
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 1,
                                "codeParent": "N-21370",
                                "childNodes": null,
                                "$$hashKey": "object:226"
                            },
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21393",
                                "label": "Filtre à air",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 1,
                                    "TM": 0,
                                    "MR": 0,
                                    "BT": 0,
                                    "MD": 0,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 0,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": [
                                    ],
                                    "TM": [
                                    ],
                                    "MR": [
                                    ],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": [],
                                        "MD_102": [],
                                        "MD_104": [],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": []
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 2,
                                "codeParent": "N-21370",
                                "childNodes": null
                            },
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21394",
                                "label": "Filtre à carburant",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 0,
                                    "TM": 0,
                                    "MR": 0,
                                    "BT": 0,
                                    "MD": 0,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 0,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": [],
                                    "TM": [
                                    ],
                                    "MR": [],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": [],
                                        "MD_102": [],
                                        "MD_104": [],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": []
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 3,
                                "codeParent": "N-21370",
                                "childNodes": null
                            },
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21395",
                                "label": "Tendeur - Courroie",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 0,
                                    "TM": 0,
                                    "MR": 0,
                                    "BT": 0,
                                    "MD": 0,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 0,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": [
                                    ],
                                    "TM": [
                                    ],
                                    "MR": [
                                    ],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": [],
                                        "MD_102": [],
                                        "MD_104": [],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": []
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 4,
                                "codeParent": "N-21370",
                                "childNodes": null
                            },
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21396",
                                "label": "Allumage",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 0,
                                    "TM": 0,
                                    "MR": 0,
                                    "BT": 0,
                                    "MD": 0,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 1,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": [
                                    ],
                                    "TM": [
                                    ],
                                    "MR": [],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": [],
                                        "MD_102": [],
                                        "MD_104": [],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": [
                                        ]
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 5,
                                "codeParent": "N-21370",
                                "childNodes": null,
                                "$$hashKey": "object:228"
                            }
                        ]
                    },
                    "arrays": [
                        [
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21392",
                                "label": "Filtre à huile",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 1,
                                    "TM": 1,
                                    "MR": 1,
                                    "BT": 0,
                                    "MD": 3,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 0,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": ["PR01"
                                    ],
                                    "TM": ["TM01"
                                    ],
                                    "MR": ["MR01"
                                    ],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": ["MD101"],
                                        "MD_102": ["MD102"],
                                        "MD_104": ["MD104"],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": []
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 1,
                                "codeParent": "N-21370",
                                "childNodes": null,
                                "$$hashKey": "object:226"
                            }
                        ],
                        [
                            {
                                "urlVignette": "",
                                "urlExplodedView": null,
                                "nodeId": "N-21396",
                                "label": "Allumage",
                                "documents": true,
                                "nbrDocumentsByType": {
                                    "PR": 2,
                                    "TM": 3,
                                    "MR": 0,
                                    "BT": 0,
                                    "MD": 0,
                                    "PRODUCTS": 0,
                                    "NI": 0,
                                    "MD_101": 0,
                                    "MD_102": 0,
                                    "MD_104": 0,
                                    "MD_106": 0,
                                    "MD_109": 0,
                                    "MD_108": 0,
                                    "MD_110": 0,
                                    "MD_111": 0,
                                    "MD_501": 0,
                                    "MD_502": 0,
                                    "MD_B2": 0
                                },
                                "idsDocumentsByType": {
                                    "PR": [
                                    ],
                                    "TM": [
                                    ],
                                    "MR": [],
                                    "BT": [],
                                    "MD": {
                                        "MD_101": [],
                                        "MD_102": [],
                                        "MD_104": [],
                                        "MD_106": [],
                                        "MD_109": [],
                                        "MD_108": [
                                        ],
                                        "MD_110": [],
                                        "MD_111": [],
                                        "MD_501": [],
                                        "MD_502": [],
                                        "MD_B2": [
                                        ]
                                    },
                                    "PRODUCTS": [],
                                    "NI": []
                                },
                                "level": 3,
                                "rang": 5,
                                "codeParent": "N-21370",
                                "childNodes": null,
                                "$$hashKey": "object:228"
                            }
                        ],
                        []
                    ],
                    "$$hashKey": "object:218"
                }
            ]
        }
    });
})();


(function () {
    angular
        .module('phenix')
        .service('SvgCache', behavior);

    function behavior() {
        var self = this;
        var container = {};

        self.addSVG = addSVG;
        self.getSVG = getSVG;

        /*
            Get filename from url, and store it as prop
        */
        function addSVG(svg, url) {
            var prop = getIndexFromUrl(url);
            container[prop] = svg;
        }

        function getSVG(url) {
            var prop = getIndexFromUrl(url);
            return container[prop];
        }

        function getIndexFromUrl(url) {
            var reg = /[-_A-Za-z0-9]*.svg/
            var find = url.match(reg);
            var condition = find && find.length === 1;

            if (condition)
                return find[0];
            return null;
        }
    }

})();

/**
 * SearchByTextsIdsWSService
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('searchByTextsIdsWsService', searchByTextsIdsWsService);

    /** @ngInject */
    function searchByTextsIdsWsService(CarSearchResultConstants,RestUpgrade) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.returnArboByTextsIds = returnArboByTextsIds;
        this.returnAutoCompleteList = returnAutoCompleteList;
        this.getSearchEngineDocs=getSearchEngineDocs;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace SearchByTextsIdsWSService
         * @desc Get documents ids list existing in  criterias
         * @param {Array} request set of documents ids, criterias and language
         * @example IN {"documentsIds":[{"documentType": "MR", "functionnalId": "101"},{"documentType": "TM", "functionnalId": "107"}],"criteria":"TM moteur","language": "fr"}
         * @example OUT {"documentsIds":[{"documentType": "MR", "functionnalId": "101"}]}
         * @memberOf Services.SearchByTextsIdsWSService
         */
        function returnArboByTextsIds(request) {
            return RestUpgrade.all(CarSearchResultConstants.searchByTextsIds).post(request);
        }
        function returnAutoCompleteList(request) {
            return RestUpgrade.all(CarSearchResultConstants.autoCompleteList).post(request);
        }
        function getSearchEngineDocs(request,isOtherLang) {
            var url = isOtherLang ? CarSearchResultConstants.searchEngineDocs + '?limit=10' : CarSearchResultConstants.searchEngineDocs + '?limit=20'; 
                return RestUpgrade.all(url).post(request);
            
        }



    }
})();

/**
 * SearchByTextsIdsMertierService
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('searchByTextsIdsMertierService', searchByTextsIdsMertierService);

    /** @ngInject */
    function searchByTextsIdsMertierService(searchByTextsIdsWsService, $q, CacheConstants, CacheService,  $translate, toastr) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var level1Result = [];
        var filteredDocs = [];
        var documentsArbo = [];

        this.formatArboByTextsIds = formatArboByTextsIds;
        this.formatFilteredDocuments = formatFilteredDocuments;
        this.filterArboLevel1 = filterArboLevel1;
        this.filterArboLevel2 = filterArboLevel2;
        this.getFilteredDocumentsByType = getFilteredDocumentsByType;
        this.getDocumentsArbo = getDocumentsArbo;
        this.getFilteredLevel1 = getFilteredLevel1;
        this.getFilterdDocs = getFilterdDocs;
        this.getDocuments = getDocuments;
        this.getAutoCompleteList = getAutoCompleteList;
        this.getSearchEngineDocs=getSearchEngineDocs;
        this.searchFilteredDocuments = searchFilteredDocuments;


        function getFilteredLevel1(){
            return level1Result;
        }

        function getFilterdDocs(){
            return filteredDocs;
        }

        function getDocuments(){
            return documentsArbo;
        }

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace formatArboByTextsIds
         * @desc Get documents ids list existing in  criterias
         * @param {Array} request set of documents ids, criterias and language
         * @example IN {"documentsIds":[{"documentType": "MR", "functionalId": "101"},{"documentType": "TM", "functionalId": "107"}],"criteria":"TM moteur","language": "fr"}
         * @example OUT {"documentsIds":[{"documentType": "MR", "functionalId": "101"}]}
         * @memberOf Services.SearchByTextsIdsWSService
         */
        function formatArboByTextsIds(documentsArboByType, motClef) {
            var userContext = CacheService.getUserContext();
            var request = {
                "documentsIds": documentsArboByType,
                "criteria": motClef,
                "language": userContext.language
            }

            return searchByTextsIdsWsService.returnArboByTextsIds(request).then(function (response) {
                return response;
            });
        }

        function getAutoCompleteList(text,types){
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var payload = {
                "userContext": userContext,
                "carContext": carContext,
                "domainTypes":types,
                "text": text
            };
            return searchByTextsIdsWsService.returnAutoCompleteList(payload).then(function(response){
                return response;
            }).catch(function(){
                toastr.error($translate.instant("ELEM_SEARCH_ERROR"));
            });
        }

        function getSearchEngineDocs(text,types,isOtherLang,lang, additionalCountry){
            var userContext = CacheService.getUserContext();

            if (lang) {
                userContext.countryReferenceLanguage = additionalCountry;
                userContext.language = lang;
            }

            var carContext = CacheService.getCarContext();
            var payload = {
                "userContext": userContext,
                "carContext": carContext,
                "domainTypes":types,
                "text": text.toUpperCase()
            };
            return searchByTextsIdsWsService.getSearchEngineDocs(payload,isOtherLang).then(function(response){
                if(isOtherLang || lang){
                    return response;
                }else{
                    var elementPartsList = [];
                    var elementIdentifierList = [];
                    if(response && response.documents && !_.isEmpty(response.documents)){
                        response.documents.forEach(function(item){
                            if(!_.isEmpty(item.source)){
                                item.source.forEach(function(item2){
                                    if(!_.isEmpty(item2.ids)){
                                        item2.ids.forEach(function(elemIds){
                                            elementPartsList.push(elemIds);
                                        })
                                    }
                                    
                                    item2.domainTypes.forEach(function (type) {
                                        if(type === "PR"){
                                            if(!_.isEmpty(item2.identifiers)){
                                                item2.identifiers.forEach(function(identify){
                                                    elementIdentifierList.push(identify);
                                                })
                                                CacheService.setObject(CacheConstants.identifierList, elementIdentifierList);
                                            }
                                        }
                                        else {
                                            CacheService.removeObject(CacheConstants.identifierList);
                                        }
                                    });
                                })                            
                            } 
                        }) 
                    } 
                    return _.uniq(elementPartsList);
                }
                               
            }).catch(function(){
                toastr.error($translate.instant("ELEM_SEARCH_ERROR"));
            });
        }
        /**
         * @namespace getDocumentsArbo
         * @desc get filtered documents by type
         * @param {Array} nodesArbo set of node
         * @returns {Object} - lists of documents with and without code parents
         * @example OUT {"result":{"documents": [{"documentType": "MR", "functionalId": "101"}], "documentsCodeParents": [{"documentType": "MR", "functionalId": "101", "codeParent": "338"}]}
         * @memberOf Services.getFilteredDocumentsByType
         */
        function getDocumentsArbo(nodesArbo){
            var documents = [];
            var documentsCodeParents = [];
            var result = {};
            angular.forEach(nodesArbo, function(value, key){
                //get MR docuemnts
                result = getDocumentByType(documents, documentsCodeParents, value.codeParent, value.idsDocumentsByType, "MR");
                //get TM documents
                result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType, "TM");
                //get PR documents
                result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType, "PR");
                //get MD 101 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_101");
                }
                //get MD 102 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_102");
                }
                //get MD 104 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_104");
                }
                //get MD 106 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_106");
                }
                //get MD 108 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_108");
                }
                //get MD 109 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_109");
                }
                //get MD 110 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_110");
                }
                //get MD 111 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_111");
                }
                //get MD 501 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_501");
                }
                //get MD 502 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_502");
                }
                //get MD B2 documents
                if (value.idsDocumentsByType){
                    result = getDocumentByType(result.documents, result.documentsCodeParents, value.codeParent, value.idsDocumentsByType.MD, "MD_B2");
                }
            });

            documentsArbo =result;
            return result;
        }

        /**
         * @namespace formatFilteredDocuments
         * @desc Add parent code to each document send by the service
         * @param {Array} documentsArbo set of documents ids, functional ids and code parent
         * @param {Array} filteredDocuments set of documents ids and functional ids
         * @returns {Array} set of documents ids, functional ids and code parent
         * @memberOf Services.formatFilteredDocuments
         */
        function formatFilteredDocuments(documentsArbo, filteredDocuments){
            var formatFilteredDocuments = [];
            var resultFormattedFilteredDocuments = [];
            angular.forEach(filteredDocuments, function(value, key){
                var documentInformations = {};
                documentInformations.documentType = value.documentId.documentType;
                documentInformations.functionalId = value.documentId.functionalId;
                formatFilteredDocuments.push(documentInformations);
            });

            angular.forEach(documentsArbo, function(documentItem){
                angular.forEach(formatFilteredDocuments, function(formatItem){
                    if(_.isEqual(documentItem.documentType, formatItem.documentType)
                        && _.isEqual(documentItem.functionalId, formatItem.functionalId)){
                            resultFormattedFilteredDocuments.push(documentItem);
                    }
                });
            });

            //resultFormattedFilteredDocuments = _.intersectionWith(documentsArbo, formatFilteredDocuments, customComparator);
            return resultFormattedFilteredDocuments;
        }


        function searchFilteredDocuments(documentsArbo, node2, node3, documentType){
            var resultFormattedFilteredDocuments = [];
           

            angular.forEach(documentsArbo, function(documentItem){
                angular.forEach(node2, function(formatItem){
                    if(_.isEqual(documentItem.codeParent, formatItem.codeParent) &&
                    formatItem.idsDocumentsByType && formatItem.idsDocumentsByType[documentType] && formatItem.idsDocumentsByType[documentType].includes(documentItem.functionalId)){
                            resultFormattedFilteredDocuments.push(documentItem);
                    }
                });

                angular.forEach(node3, function(formatItem){
                    if(_.isEqual(documentItem.codeParent, formatItem.codeParent) && 
                    formatItem.idsDocumentsByType && formatItem.idsDocumentsByType[documentType] && formatItem.idsDocumentsByType[documentType].includes(documentItem.functionalId)){
                            resultFormattedFilteredDocuments.push(documentItem);
                    }
                });
            });

            return resultFormattedFilteredDocuments;
        }

        // function customComparator(a, b){
        //     return a.functionalId == b.functionalId && a.documentType == b.documentType;
        // }

        /**
         * @namespace filterArboLevel1
         * @desc filter arbo level 1
         * @param {Array} filteredDocuments set of documents ids, functional ids and code parents
         * @param {Array} level1Data all nodes level 1
         * @param {String} textSearch text entered by the user
         * @returns {Array} - list of level1 nodes
         * @memberOf Services.filterArboLevel1
         */
        function filterArboLevel1(filteredDocuments, level1Data, textSearch){
            var documentsArbo = [];
            var codeParents = [];
            //get parents ids (node 1 to display)
            codeParents = getParentsIds(filteredDocuments);
            //filter data arbo level 1
            level1Data.nodes = filterNode1(level1Data["nodes"], codeParents);
            level1Result = level1Data;
            return level1Data;
        }

         /**
         * @namespace filterArboLevel2
         * @desc filter arbo level 1
         * @param {Array} level2Data set of documents ids, functional ids and code parents
         * @param {Array} documentsPR documents PR corresponding to the enetered keyword
         * @param {Array} documentsMR documents MR corresponding to the enetered keyword
         * @param {Array} documentsMD tdocuments MD corresponding to the enetered keyword
         * @param {Array} documentsTM documents TM corresponding to the enetered keyword
         * @returns {Object} containing filtered level 2 and level 3
         * @memberOf Services.filterArboLevel2
         */
        function filterArboLevel2(level2Data, documentsPR, documentsMR, documentsMD, documentsTM){
            var filteredNode2 = [];
            var filteredArbo= [];
            var filteredNode3 = [];

            //filter data arbo level 2
            filteredNode2 = filterNode2(level2Data, documentsPR, documentsMR, documentsMD, documentsTM);
            //filter data arbo level 3
            angular.forEach(filteredNode2, function(value, key){

                //get filtered node 3 columns 0, 1 and 2
                value.arrays[0] = filterNode3(value.arrays[0], documentsPR, documentsMR, documentsMD, documentsTM);
                value.arrays[1] = filterNode3(value.arrays[1], documentsPR, documentsMR, documentsMD, documentsTM);
                value.arrays[2] = filterNode3(value.arrays[2], documentsPR, documentsMR, documentsMD, documentsTM);


                //reorginize columns in level 3
                filteredNode3 = reorginzeFilteredNode3(value.arrays);
                value.arrays[0] = filteredNode3["resultLevel3Column1"];
                value.arrays[1] = filteredNode3["resultLevel3Column2"];
                value.arrays[2] = filteredNode3["resultLevel3Column3"];
            });
            return filteredNode2;
        }

        /**
         * @namespace getFilteredDocumentsByType
         * @desc get filtered documents by type
         * @param {Array} filteredDocuments set of documents ids and functional ids
         * @returns {Object} - list of PR, MR, MD and TM
         * @memberOf Services.getFilteredDocumentsByType
         */
        function getFilteredDocumentsByType(filteredDocuments){
            var filteredDocumentsByType = [];
            var documentsPR = [];
            var documentsMR = [];
            var documentsMD = [];
            var documentsTM = [];

            //parse documents
            angular.forEach(filteredDocuments, function(value, key){
                if(value["documentType"] == "PR"){
                    documentsPR.push(value["functionalId"]);
                }
                if(value["documentType"] == "MR"){
                    documentsMR.push(value["functionalId"]);
                }
                if(value["documentType"] == "MD"){
                    documentsMD.push(value["functionalId"]);
                }
                if(value["documentType"] == "TM"){
                    documentsTM.push(value["functionalId"]);
                }
            });

            filteredDocumentsByType = {"PR": documentsPR, "MR": documentsMR,
                "MD": documentsMD, "TM": documentsTM};

            filteredDocs = filteredDocumentsByType;
            return filteredDocumentsByType;
        }

        /*=============================================
        =                 TOLLS                       =
        =============================================*/

        //get object with documents with and without code parents
        function getDocumentByType(documents, documentsCodeParents, codeParent, documentsType, type){

            var result = {};
            if (documentsType && documentsType[type] && documentsType[type].length > 0){
                angular.forEach(documentsType[type], function(value, key){
                    if (type != "PR" && type != "MR" && type != "TM"){
                        type = "MD";
                    }
                    var documentInformations = {};
                    var documentsParents = {};

                    documentInformations["functionalId"] = value;
                    documentInformations["documentType"] = type;
                    documents.push(documentInformations);

                    documentsParents["functionalId"] = value;
                    documentsParents["documentType"] = type;
                    documentsParents["codeParent"] = codeParent;
                    documentsCodeParents.push(documentsParents);
                });
            }
            result = {"documents": documents, "documentsCodeParents": documentsCodeParents}
            return result;
        }

        //reorginze node 3 columns 0, columns 1 and columns 2
        function reorginzeFilteredNode3(level3Columns){
            var tempLevel3Columns = [];
            var resultLevel3Column1 = [];
            var resultLevel3Column2 = [];
            var resultLevel3Column3 = [];
            var resultLevel3 = [];
            var currentIndex = 0;
            var startIndexColumn1 = 0;
            var startIndexColumn2 = 1;
            var startIndexColumn3 = 2;



            tempLevel3Columns = tempLevel3Columns.concat(level3Columns[0]);
            tempLevel3Columns = tempLevel3Columns.concat(level3Columns[1]);
            tempLevel3Columns = tempLevel3Columns.concat(level3Columns[2]);

            while(currentIndex < tempLevel3Columns.length){
                if (startIndexColumn1 == currentIndex){
                    resultLevel3Column1.push(tempLevel3Columns[currentIndex]);
                    startIndexColumn1 = startIndexColumn1 + 3;
                }
                else if (startIndexColumn2 == currentIndex){
                    resultLevel3Column2.push(tempLevel3Columns[currentIndex]);
                    startIndexColumn2 = startIndexColumn2 + 3;
                }
                else if (startIndexColumn3 == currentIndex){
                    resultLevel3Column3.push(tempLevel3Columns[currentIndex]);
                    startIndexColumn3 = startIndexColumn3 + 3;
                }
                currentIndex++;
            }

            resultLevel3 = {"resultLevel3Column1": resultLevel3Column1, "resultLevel3Column2": resultLevel3Column2, "resultLevel3Column3": resultLevel3Column3};
            return resultLevel3;
        }

        //get parents ids of the documents ids
        function getParentsIds(documentsIds){
            var codeParents = [];
            angular.forEach(documentsIds, function(value, key){
                if (codeParents.indexOf(value["codeParent"]) == -1){
                    codeParents.push(value["codeParent"]);
                }
            });
            return codeParents;
        }

        function filterNode1(nodesLevel1, codeParents){
            var filteredNode1 = [];
            angular.forEach(nodesLevel1, function(value, key){
                if (codeParents.indexOf(value["nodeId"]) > -1){
                    filteredNode1.push(value);
                }
            });
            return filteredNode1;
        }

        function filterNode2(nodesLevel2, documentsPR, documentsMR, documentsMD, documentsTM){
            var filteredNode2 = [];
            filteredNode2 = filterDocumentsType(nodesLevel2, 2, documentsPR, documentsMR, documentsMD, documentsTM);
            return filteredNode2;
        }

        function filterNode3(nodesLevel3, documentsPR, documentsMR, documentsMD, documentsTM){
            var filteredNode3 = [];
            filteredNode3 = filterDocumentsType(nodesLevel3, 3, documentsPR, documentsMR, documentsMD, documentsTM);
            return filteredNode3;
        }

        function filterDocumentsType(nodeInformations, level, documentsPR, documentsMR, documentsMD, documentsTM){
            var filteredDocuments = [];
            var temp = [];
            var filteredDocumentsByType = [];
            angular.forEach(nodeInformations, function(value, key){
                var levelData = value;
                if (level == 2){
                    levelData = value.node;
                }

                //parse PR
                filteredDocumentsByType = getDocumentsByType(levelData, value, temp, filteredDocuments, documentsPR, "PR");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MR list
                filteredDocumentsByType = getDocumentsByType(levelData, value, temp, filteredDocuments, documentsMR, "MR");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list
                filteredDocumentsByType = getDocumentsByType(levelData, value, temp, filteredDocuments, documentsMD, "MD");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD 101 list
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_101");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 102
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_102");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 104
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_104");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 106
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_106");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 108
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_108");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 109
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_109");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 110
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_110");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 111
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_111");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list 501
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_501");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }


                //parse MD list 502
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_502");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }

                //parse MD list B2
                filteredDocumentsByType = getDocumentsMdByType(levelData, value, temp, filteredDocuments, documentsMD, "MD_B2");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }


                //parse TM list
                filteredDocumentsByType = getDocumentsByType(levelData, value, temp, filteredDocuments, documentsTM, "TM");
                if (filteredDocumentsByType["filteredDocuments"] && filteredDocumentsByType["temp"]){
                    filteredDocuments = filteredDocumentsByType["filteredDocuments"];
                    temp = filteredDocumentsByType["temp"];
                }
            });

            return filteredDocuments
        }

        function getDocumentsByType(levelData, valueNode, temp, filteredDocuments, documents, documentType){
            var filteredDocumentsByType = [];
            if (levelData.idsDocumentsByType && levelData.idsDocumentsByType[documentType].length > 0 && documents.length > 0){
                for (var i = 0; i < levelData.idsDocumentsByType[documentType].length; i++) {
                    if (levelData.idsDocumentsByType && documents.indexOf(levelData.idsDocumentsByType[documentType][i]) > -1
                      && temp.indexOf(levelData.nodeId) == -1){
                        filteredDocuments.push(valueNode);
                        temp.push(levelData.nodeId);
                    }
                }
            }
            filteredDocumentsByType = {"filteredDocuments": filteredDocuments, "temp": temp};
            return filteredDocumentsByType;
        }

        function getDocumentsMdByType(levelData, valueNode, temp, filteredDocuments, documents, documentMdType){
            var filteredDocumentsByType = [];
            if (levelData.idsDocumentsByType && levelData.idsDocumentsByType.MD[documentMdType] && levelData.idsDocumentsByType.MD[documentMdType].length > 0 && documents.length > 0){
                for (var i = 0; i < levelData.idsDocumentsByType.MD[documentMdType].length; i++) {
                    if (documents.indexOf(levelData.idsDocumentsByType.MD[documentMdType][i]) > -1
                    && temp.indexOf(levelData.nodeId) == -1){
                        filteredDocuments.push(valueNode);
                        temp.push(levelData.nodeId);
                    }
                }
            }
            filteredDocumentsByType = {"filteredDocuments": filteredDocuments, "temp": temp};
            return filteredDocumentsByType;
        }

    }
})();

(function () {
    'use strict';
    angular.module('phenix').service('SearchArboTextualWsService', SearchArboTextualWsService);


    function SearchArboTextualWsService($q, $log, CarSearchConstants,MainMetierService,PanierConstants,RestUpgrade,FileSaver, blockUI) {
        this.getNodes = getNodes;
        this.getDocumentsElectricals = getDocumentsElectricals;
        this.getLastViewedDocuments = getLastViewedDocuments;
        this.filterDocsVar = filterDocsVar;
        this.getInterventionByIDs = getInterventionByIDs;
        this.getBasketByInterventionByIDs = getBasketByInterventionByIDs;
        this.getBasketByVotes = getBasketByVotes;
        this.getCountVotes = getCountVotes;
        this.setConnectedServicesAuditData = setConnectedServicesAuditData;
        this.getAllAuditData = getAllAuditData;
        function getDocumentsElectricals(dealerId) {
            var defer = $q.defer();
            $log.debug("historization Vehicle load  ");
            RestUpgrade.one(CarSearchConstants.documentsElectrical + '?dealerId=' + dealerId).get().then(function (response) {
                response = (response && response.plain) ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }


        function getLastViewedDocuments(dealerId) {
            var defer = $q.defer();
            $log.debug("historization Vehicle load  ");
            RestUpgrade.one(CarSearchConstants.documentsViewed + '?dealerId=' + dealerId).get().then(function (response) {
                response = (response && response.plain) ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }



        function getNodes(requestNodes) {
            var contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
            if (requestNodes.nodeId && !contextCarBrandCheck) {
                var  urls = [CarSearchConstants.restSearchArboTextual, CarSearchConstants.restTransversalPartsTree]
                    , promises = urls.map(function (url) {
                        if (url == CarSearchConstants.restTransversalPartsTree) {
                            if (requestNodes && requestNodes.docType) {
                                requestNodes = _.omit(requestNodes, ["docType"]);
                            }
                        }
                        return RestUpgrade.all(url).post(requestNodes).catch(function(e){return null})
                    })
                    , all = $q.all(promises).then(function(data){
                        return data.filter(function(d){return !!d}) // filter out empty, null results
                    })
                return all;
            }
            else {
                return $q.all([
                    RestUpgrade.all(CarSearchConstants.restSearchArboTextual).post(requestNodes),
                ]);
            }
        }

        function filterDocsVar(data) {
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.applicabilityVar).post("", data).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;

        }

        function getInterventionByIDs(data){
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.getInterventionId).post("", data).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getBasketByInterventionByIDs(data){
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.basketByIntId).post("", data).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getBasketByVotes(data){
            var defer = $q.defer();
            var url = PanierConstants.saveVotes;
            RestUpgrade.all(url).post(data).then(function(response){
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getCountVotes(data){
            var defer = $q.defer();
            var url = PanierConstants.getVotes;
            RestUpgrade.all(url).post(data).then(function(response){
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function setConnectedServicesAuditData(data, isConnectedService){
            var defer = $q.defer();
            const url = isConnectedService 
                ? CarSearchConstants.connectedServicesAudit 
                : CarSearchConstants.userTrackingAudit;
            RestUpgrade.all(url).post(data).then(function(response){
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function getAllAuditData() {
            var url = CarSearchConstants.auditData;
            blockUI.start();
            return RestUpgrade
                .one(url).withHttpConfig({ responseType: 'arraybuffer' })
                .get()
                .then(function (response) {
                    var file = new Blob([new Uint8Array(response)], { type: 'application/zip' });
                    FileSaver.saveAs(file, 'audit_chunks.zip');
                    blockUI.stop();
                })
                .catch(function (error) {
                    console.error('Error downloading audit data:', error);
                    blockUI.stop();
                });
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('SearchArboTextualMetierService', SearchArboTextualMetierService);

    /** @ngInject */
    function SearchArboTextualMetierService(CacheService, CacheConstants, RoutesConstants, $q, SearchArboTextualWsService, $state, searchElectricalSchemaMetierService, CarSearchResultConstants, MainMetierService, configConstantes,DocPrivConstants, CarSearchConstants, $rootScope) {
        this.getNodes = getNodes;

        this.saveNodeInCache = saveNodeInCache;
        this.searchNodebyRef = searchNodebyRef;
        this.getDocumentsElectricals = getDocumentsElectricals;
        this.getLastViewedDocuments = getLastViewedDocuments;
        this.filterDocsOnVarApplicability = filterDocsOnVarApplicability;
        this.getInterventionById = getInterventionById;
        this.getBasketByInterventionId = getBasketByInterventionId;
        this.getBasketVotes = getBasketVotes;
        this.getCountVotes = getCountVotes;
        this.setConnectedServicesAuditData = setConnectedServicesAuditData;
        // Electrical Shema
        function getDocumentsElectricals() {
            var defer = $q.defer();
            var user = CacheService.getObject(RoutesConstants.profil);
            SearchArboTextualWsService.getDocumentsElectricals(user.dealerId).then(function (response) {
                defer.resolve(response);
            }, function (response) {
                defer.reject(response);
            });
            return defer.promise;
        }
        // Viewed Doc
        function getLastViewedDocuments() {
            var defer = $q.defer();
            var user = CacheService.getObject(RoutesConstants.profil);
            SearchArboTextualWsService.getLastViewedDocuments(user.dealerId).then(function (response) {
                defer.resolve(response);
            }, function (response) {
                defer.reject(response);
            });
            return defer.promise;
        }
        function saveNodeInCache(node) {
            CacheService.setObject(CacheConstants.nodeFromSearchArbo, node);
        }
        /**
         * Get nodes for repair tree
         */
        function getNodes(requestNodesFromCtrl) { 
            var defer = $q.defer();
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var userContextRequest = CacheService.getUserContext();
            var user = CacheService.getObject(RoutesConstants.profil);
            var brandComputed = contextCarRequest.brandComputed;
            var brand = contextCarRequest.fixedCriterias["336"];
            
            if (user.userType === "RNET" && user.roles && user.roles.includes('PPX_NETWORK_USER') && !user.roles.includes('PPX_CORPORATE_USER')) {
                var Aplbrand = ['APL03', 'APL05', 'APL06', 'APL08', 'APL10', 'APL17', 'APL18'];
                var Brabrand = ['BRA03', 'BRA05', 'BRA08', 'BRA17', 'BRA18', 'BRA20', 'BRA22'];
                 
                if(brandComputed){
                    if (brandComputed.substr(0,3) === 'APL' && !Aplbrand.includes(brandComputed)){
                        contextCarRequest.brandComputed = 'APL03';
                    }
                    else if (brandComputed.substr(0,3) === 'BRA'  && !Brabrand.includes(brandComputed)){
                        contextCarRequest.brandComputed = 'BRA03';
                    }
                }
                
                if(brand){
                    if(brand.substr(0,3) === 'APL' && !Aplbrand.includes(brand)){
                        contextCarRequest.fixedCriterias["336"] = 'APL03';
                    }else if (brand.substr(0,3) === 'BRA' && !Brabrand.includes(brand)){
                        contextCarRequest.fixedCriterias["336"] = 'BRA03';
                    }
                }
            }            
            if (userContextRequest && userContextRequest.userProfiles && user) {
                if (user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)) {
                    userContextRequest.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());
                }
                else if (user.roles && user.roles.includes(CarSearchConstants.ppxIndependentUser) && user.accountType === 'Partner') {
                    userContextRequest.userProfiles.push(CarSearchConstants.ppxIndependentUser.toLowerCase());
                }
            }
            var requestNodes = {
                
                userContext: _.extend(userContextRequest, { language: user.portal.code.includes("-") ? user.portal.code.substr(0,2) : user.portal.code, countryReferenceLanguage : user.portal.countryCode }),
                carContext: contextCarRequest
            }

            if (requestNodesFromCtrl) {
                requestNodes.nodeId = requestNodesFromCtrl.nodeId;

                    var docType = {
                        "PR": [],
                        "MD": [],
                        "MR": [],
                        "TM": [],
                        "NI": [],
                        "INT_REPAIR": []
                    };
                    requestNodes.docType = docType;
                
            }
            
           SearchArboTextualWsService.getNodes(requestNodes).then(function (response) {
                defer.resolve(response);
            }
                , function (response) {
                    defer.reject(response);
                });
            return defer.promise;   
        }

        function searchNodebyRef(reference, filter) {
            var defer = $q.defer();
            var userContextRequest = CacheService.getUserContext();
            var user = CacheService.getObject(RoutesConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var requestNodes = {
                userContext : userContextRequest,
                filter: reference,
                filterType: filter.id,
                childNodes: true,
                carContext: contextCarRequest
            };

            SearchArboTextualWsService.getNodes(requestNodes).then(function (response) {
                defer.resolve(response);
            }
                , function (response) {
                    defer.reject(response);
                });
            return defer.promise;
        }

        function filterDocsOnVarApplicability(data) {
            var defer = $q.defer();
            var infos = data;
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var userContextRequest = CacheService.getUserContext();
            data.carContext = contextCarRequest;
            data.userContext = userContextRequest;
            SearchArboTextualWsService.filterDocsVar(data).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }

        function getInterventionById(SIEIds){
            var defer = $q.defer();
            var payload = {
                carContext : CacheService.getCarContext(),
                userContext : CacheService.getUserContext(),
                documentsId : SIEIds
            }
            SearchArboTextualWsService.getInterventionByIDs(payload).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }


        function getBasketByInterventionId(selectedItem){
            var defer = $q.defer();
            var selectedSIEID = [];
            selectedSIEID.push(selectedItem.id);
            var isArcaUser = MainMetierService.isArcaUser();

            const userContext = CacheService.getUserContext();
            const user = CacheService.getObject(CacheConstants.profil);
            const hasUserProfiles = userContext && userContext.userProfiles;
            const hasDocPrivRole = user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile);
            if(hasUserProfiles && hasDocPrivRole){
                userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());      
            }

            var payload = {
                userContext,
                carContext : CacheService.getObject(CacheConstants.contextCarRequest),
                documentsId : selectedSIEID
            }
            if(isArcaUser){
                _.extend(payload,
                    { sieIntReport: true })           
            }

            var lsrInfo = CacheService.getObject(CacheConstants.bvaApigee) ?
            CacheService.getObject(CacheConstants.bvaApigee).partsList : [];
        if (lsrInfo && !_.isEmpty(lsrInfo)) {
            var genericPartsFromPlates = selectedItem.genericParts ? selectedItem.genericParts : [];

            var lsrForLines;
            if (genericPartsFromPlates && !_.isEmpty(genericPartsFromPlates)) {
                lsrForLines = _.filter(lsrInfo, function (item) {
                    if (_.includes(genericPartsFromPlates, item.spareGenericPart)) {
                        return item;
                    }
                })
            }

            if (lsrForLines && !_.isEmpty(lsrForLines)) {
                 _.map(lsrForLines, function (lsrItems) {
                    if (lsrItems && lsrItems.additionalSpareParts && !_.isEmpty(lsrItems.additionalSpareParts)) {
                        var additionalParts = [];
                        _.map(lsrItems.additionalSpareParts, function (item) {
                            _.map(item.lvaSparePartList, function (parts) {
                                additionalParts.push(parts);
                            })

                        });
                        _.assign(lsrItems, { additionalSpareParts: additionalParts });
                    }

                });

                _.extend(payload,
                    { herculesInputs: lsrForLines })
            }
        }
            SearchArboTextualWsService.getBasketByInterventionByIDs(payload).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }

        function getBasketVotes(doc){
            var defer = $q.defer();
            SearchArboTextualWsService.getBasketByVotes(doc).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }

        function setConnectedServicesAuditData(logType){
            const contextVehicle = CacheService.getObject(CacheConstants.contextCarRequest);
            const connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            const usageCountry = connectedPlatform && connectedPlatform.country;
            
            // Define connected services log types that should go to ccs_audit table
            const connectedServicesLogTypes = [
                'CONTRACT_AND_SERVICES',
                'DATA_CONSISTENCY',
                'CONNECTED_SERVICES_USER_GUIDE',
                'CONNECTED_SERVICES_OFFERS',
                'MOTA_FOTA',
                'EHORIZON',
                'REMOTE_SERVICE',
                'PNC',
                'V2G',
                'V2GNew',
                'SMART_CHARGING',
                'VIN_SEARCH',
                'JWT_CONFIG',
                'CSR_PORTAL',
                'Usage mode',
                'Deactivation 204',
                'SERVICE_SYNCHRONIZATION',
                'VIRTUAL KEY B2C',
                'VIRTUAL KEY B2B',
                'PNC repair',
                'V2G repair',
                'EV_SETTING',
                'HERE_NAVIGATION',
                'MAPS',
                'Inventory',
                'Map_Inventory',
            ];
            
            let payload;
            if (contextVehicle) {
                payload = {
                    vin: contextVehicle.vin,
                    brand: contextVehicle.bvmExtraFields.marqCom,
                    country: usageCountry ? usageCountry : '',
                    model: contextVehicle.model,
                    isConnectedVehicle: $rootScope.isConnectedVehicle || false,
                    logType
                }
            }
            
            var defer = $q.defer();
            
            const isConnectedService = connectedServicesLogTypes.indexOf(logType) !== -1;
            
            SearchArboTextualWsService.setConnectedServicesAuditData(payload, isConnectedService).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }

        function getCountVotes(docDetail){
            var defer = $q.defer();
            SearchArboTextualWsService.getCountVotes(docDetail).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        }
        

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('virtualKey', {
            bindings: {
                data: '<',
                isVirtualTab: '<'
            },
            controller: VirtualKeyComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/virtualKey/virtualKey.template.html'
        });

/** @ngInject */
    function VirtualKeyComponent(
        $scope,
        $rootScope,
        $translate,
        RLinkCarUtils,
        CacheService,
        configConstantes,
        CacheConstants,
        RLinkCarMetierService,
        toastr,
        $mdDialog,
        UtilsMetierService,
        rLinkConstant,
        blockUI
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.userProfile = CacheService.getObject(CacheConstants.profil);
        vm.isEasyLink = (vm.connectedPlatform !== null && (vm.connectedPlatform.platform === "EASYLINK" || vm.connectedPlatform.platform === 'AVN' || vm.connectedPlatform.platform === 'CVC' || vm.connectedPlatform.platform === 'RGDC'));
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        vm.virtualKey = rLinkConstant.virtualKey,
        vm.blmEcu = rLinkConstant.blmEcu;
		vm.bva = rLinkConstant.bva;
        vm.vkm = rLinkConstant.vkm;
        vm.uidTitle = '';
        vm.virtualServiceActivated = false;
        vm.virtualB2B592ServiceActivated = false;
        vm.isVirtualNoneActivated = false;
        vm.accordions = {virtualKey:{}};
        vm.copyToClipboard = copyToClipboard;
        vm.blmsData = blmsData;
        vm.rightsData = rightsData;
        vm.blmsUserRoles = blmsUserRoles;
        vm.refreshData = refreshData;
        vm.refreshActivation = refreshActivation;
        vm.showConfirmationPopup = showConfirmationPopup;
        vm.getRightsKeys = getRightsKeys;
        vm.virtualBlmsRoleDelagateData = virtualBlmsRoleDelagateData;
        vm.launchVirtualRoleDelegationModal = launchVirtualRoleDelegationModal;
        vm.showRoleDelegationStatusModal = showRoleDelegationStatusModal;
        vm.showRightDescriptionModal = showRightDescriptionModal;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.blmTabOpen = true;
        vm.listTabOpen = true;
        vm.roleTabOpen = true;
        
        $rootScope.$on('virtualInfoData', function(event, info) {
            vm.virtualKeyInfo = info.virtualKeyData;
            vm.accordions.virtualKey.isOpen = info.isVirtualKey;
            vm.uidTitle = info.uidTitle;
            vm.blmTabOpen = true;
            vm.listTabOpen = true;
            vm.roleTabOpen = true;

            if(!_.isEmpty(vm.virtualKeyInfo)){
                blmsData(vm.virtualKeyInfo.fixResponseOne);
                blmsUserRoles(vm.virtualKeyInfo.fixResponseTwo.usersRolesDelegated);
                rightsData(vm.virtualKeyInfo.fixResponseThree.data);
            }
        });
        this.$onInit = function () {
            if(!_.isEmpty(vm.data) && !_.isEmpty(vm.data.subscriptions) && !_.isEmpty(vm.data.subscriptions.commercialServices)){
                vm.data.subscriptions.commercialServices.forEach(function (sidData) {
                    if (!_.isEmpty(sidData) && !_.isEmpty(sidData.sid) && (sidData.sid === '20000591')) {
                        if(!_.isEmpty(sidData.status)){
                            sidData.status === 'ACTIVATED' ? (vm.virtualServiceActivated = true) : (vm.virtualServiceActivated = false);
                        }
                    }
                    if(!_.isEmpty(sidData) && !_.isEmpty(sidData.sid) && (sidData.sid === '20000556')){
                        if(!_.isEmpty(sidData.features)){
                            sidData.features.forEach(function (feature) {
                                if(feature && !_.isEmpty(feature.status)){
                                    feature.status === 'ACTIVATED' ? (vm.virtualB2B592ServiceActivated = true) : (vm.virtualB2B592ServiceActivated = false);
                                }
                            });
                        }
                    }
                    else{
                        vm.isVirtualNoneActivated = true;
                    }
                });
            }
            
            refreshData();
            if(vm.isVirtualTab){
                virtualBlmsRoleDelagateData();
                getRightsKeys();
            }
        }

        function copyToClipboard(id) {
            UtilsMetierService.copyToClipboard(id);
        }

        function blmsData(info){
            if(!_.isEmpty(info.serialNumber)){
                vm.bvaSn = !_.isEmpty(info.serialNumber.bvaSn) ? info.serialNumber.bvaSn : '-';
                vm.vkSn = !_.isEmpty(info.serialNumber.vkSn) ? info.serialNumber.vkSn : '-';
                if (vm.bvaSn === null || vm.vkSn === null || vm.bvaSn === '-' || vm.vkSn === '-') {
                    vm.isBlmBootstrapped = false; 
                } else if (vm.bvaSn !== vm.vkSn) {
                    vm.isBlmBootstrapped = false; 
                } else {
                    vm.isBlmBootstrapped = true;
                }
            } else {
                vm.bvaSn = '-';
                vm.vkSn = '-';
                vm.isBlmBootstrapped = false; 
            }
            vm.id = !_.isEmpty(info.id) ? info.id : '-';
            vm.swVersion = !_.isEmpty(info.swVersion) ? info.swVersion : '-';
            vm.blmsCreationDate = !_.isEmpty(info.creationDate) ? info.creationDate : '-';
        }
        function rightsData(keyData){
            if(!_.isEmpty(keyData)){
                vm.availableKeys = keyData.map(function (item) {
                    return {
                        keyId: item.id,
                        startDate: item.attributes.startDate,
                        endDate: item.attributes.endDate,
                        right: item.attributes.rights,
                        status: item.attributes.state
                    };
                });
            }else {
                vm.availableKeys = [];
            }
            vm.displayedKeys = [].concat(vm.availableKeys);
        }
        function blmsUserRoles(user){
            if(!_.isEmpty(user)){
                user.forEach(function(data){
                    if(!_.isEmpty(data) && !_.isEmpty(data.roles)){
                        data.userRoles = data.roles.map(function (role) {
                            return role
                        }).join(', ');
                    }
                    !_.isEmpty(data.usedKeys) ? (data.usedKeys = _.orderBy(data.usedKeys, 'startDate', 'desc').slice(0, 4)) : "";
                    !_.isEmpty(data.sharedKeys) ? (data.sharedKeys = _.orderBy(data.sharedKeys, 'startDate', 'desc').slice(0, 1)) : "";
                });
            }

            vm.usersRolesDelegated = user;
        }

        function refreshData(showLoader){
            if (showLoader) {
                blockUI.start();
            }
            RLinkCarMetierService.getVirtualBlmsDetails().then(function (data) {
                if (!_.isEmpty(data)) {
                    blmsData(data);
                }
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                if (showLoader) {
                    blockUI.stop();
                }
            });
        }

        function refreshActivation(){
            blockUI.start();
            RLinkCarMetierService.getRefreshActivation().then(function (response) {
                refreshData(false);
            }).finally(function () {
                blockUI.stop();
            });
        }
        function showConfirmationPopup() {
            $mdDialog.show({
                template: '<div class = "popinInfo "style = "padding:20px">'+'<div><strong>{{"RLINK_CONFIRMATION_POPUP_MESSAGE" | translate }}' +'<div><strong>'+ $translate.instant("CONFIRM_SYNC_MESSAGE") +'<div><strong><div style="margin:5% 35% 0 35%"> <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="confirmSync(true)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_YES"|translate}}</div></button>       <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="closePopup(false)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_NO"|translate}}</div></button></div> </div>',
                controller: ['$scope',ConfirmationPopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    nissanUserURL: vm.nissanUserURL
                }
            });
        };

        function ConfirmationPopupController($scope) {
            const vm = this;
            $scope.nissanUserURL = vm.nissanUserURL;
            $scope.confirmSync = function () {
                $mdDialog.hide();
                refreshActivation(); 
            };

            $scope.closePopup = function () {
                $mdDialog.hide();
            };
        }
        function getRightsKeys(){
            blockUI.start();
            RLinkCarMetierService.getRights().then(function (data) {
                if (!_.isEmpty(data)) {
                    rightsData(data);
               }
            }).catch(function () {
                // toastr.error($translate.instant('NO_DATA_FOUND'));
            }).finally(function () {
               blockUI.stop();
            });
        }
        function virtualBlmsRoleDelagateData(){
            blockUI.start();
            RLinkCarMetierService.getVirtualUserRolesDelegation().then(function (data) {
                if (!_.isEmpty(data) && !_.isEmpty(data.usersRolesDelegated)) {
                    blmsUserRoles(data.usersRolesDelegated);
               }
            }).catch(function () {
                //toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function launchVirtualRoleDelegationModal(){
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/virtualKey/popup/virtualRoleDelegationPopup.template.html',
                controller: ["$scope", virtualRoleDelegationPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg',
            });
        }

        function showRoleDelegationStatusModal(){
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/virtualKey/popup/virtualStatusRolesPopup.template.html',
                controller: ["$scope", virtualRoleDelegationPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg'
            });
        }

        function showRightDescriptionModal(){
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/virtualKey/popup/virtualRightDescriptionPopup.template.html',
                controller: ["$scope", virtualRoleDelegationPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg'
            });
        }

        function virtualRoleDelegationPopupController($scope){
            var vm = this;
            $scope.isContractsSynchronization = vm.isContractsSynchronization;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('vehicleInformations', {
            bindings: {
                vehicle: '<',
                refreshPrivacyData: '<',
                simInfo:'<',
                showBatteryInhibition: '<',
                inhibitionStatus: '<',
                inhibitionLastUpdateDateTime: '<'
            },
            controller: VehicleInformations,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/vehicleInformations/vehicleInformations.template.html'
        })
        .filter('underscoreToSpace', function () {
            return function (input) {
                if (!input) { return input; }
                return input.replace(/_/g, ' ');
            };
        });

    function VehicleInformations (
        $filter,
        $translate,
        $state,
        $rootScope,
        RoutesConstants,
        ActisConstantes,
        CacheService,
        CacheConstants,
        $mdDialog,
        $window,
        $scope,
        RLinkCarMetierService,
        UtilsMetierService,SearchArboTextualMetierService,$timeout,
        configConstantes,rLinkConstant,UsageCountryList,blockUI,toastr,CarSearchMetierService       
    ) {


        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.pushPushButtonStatus = pushPushButtonStatus;
        vm.pboRequestInfoStatus = pboRequestInfoStatus;
        vm.getRadioInformation = getRadioInformation;
        vm.getSimInformation = getSimInformation;
        vm.getHeadUnitInformation = getHeadUnitInformation;
        vm.getTcuInformation = getTcuInformation;
        vm.getStorageInformation = getStorageInformation;
        vm.goToDiagnosis = goToDiagnosis;
        vm.showBootstrapHistory = showBootstrapHistory;
        vm.forcePBO = forcePBO;
        vm.openPBOHistoryModal = openPBOHistoryModal;
        vm.dataPrivacyModal = dataPrivacyModal;
        vm.openReplacement = openReplacement;
        vm.isChangeUsageCountryAuthorized = false;
        vm.getTcuServiceReactivationVisibility = getTcuServiceReactivationVisibility;
        //vm.getHeadUnitTarget = getHeadUnitTarget;
        vm.principalStorage = null;
        vm.mapStorage = null;
        var provisioningServiceActivationTypeIVC = rLinkConstant.partReplacementIVC;
        var provisioningServiceActivationTypeIVI = rLinkConstant.partReplacementIVI;
        var serviceReactivation = rLinkConstant.serviceReactivation;
        const MAX_DATE_DIFF_DAYS = 60;
        vm.storage = {mounts:{}};
        vm.noTcu = false;
        vm.noHu = false;
        vm.accordions = {vehicleInformation:{},connectivity:{}, batteryInformation:{}, HU: {}, TCU:{}, storage: {}, sim: {}, process: {}, usageMode: {}};
        vm.showPopin = false;
        vm.batteryPopUpCheck = false;

        vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

        var deregisterConnectedPlatform = $rootScope.$on(
            "connectedPlatformUpdated",
            function () {
                vm.connectedPlatform = CacheService.getObject(
                    CacheConstants.connectedPlatform
                );
            }
        );
        $scope.$on("$destroy", deregisterConnectedPlatform);

        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        var platform = vm.connectedPlatform !== null ? vm.connectedPlatform.platform : null;
        var architecture = vm.connectedPlatform && vm.connectedPlatform.architecture ? vm.connectedPlatform.architecture.toUpperCase() : null;
        if(platform === 'EASYLINK' || platform === 'AVN' || platform === 'CVC' || platform === 'RGDC'){
            if (architecture === 'CCS1' || architecture === 'CCS2' || architecture === 'CCS3'){
                vm.vehicleInfoHeader = $rootScope.commercialLabelValue || (vm.connectedPlatform && vm.connectedPlatform.commercialLabel ? vm.connectedPlatform.commercialLabel : null);
            } else {
                vm.vehicleInfoHeader = 'Open R Evo';
            }
        }
        var deregisterCommercialLabel = $rootScope.$on('commercialLabelResolved', function(event, commercialLabel) {
            vm.vehicleInfoHeader = commercialLabel;
        });
        $scope.$on('$destroy', deregisterCommercialLabel);
        vm.isCCS3Vehicle = (architecture === 'CCS3');
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        
        
        vm.csrButtonShow = UtilsMetierService.csrButtonShow(vm.user);
        vm.isEasyLink = (platform === 'EASYLINK' || platform === 'AVN' || platform === 'CVC' || platform === 'RGDC');
        vm.isAuthorized = false;
        var csrPortalLink = rLinkConstant.csrPortalLink;
        vm.csrPortalLabel = rLinkConstant.csrPortalLabel;
        vm.dataOff = rLinkConstant.dataOff;
        vm.dataOn = rLinkConstant.dataOn;
        vm.goToCsrPortal = goToCsrPortal;
        vm.refreshData = refreshData;
        vm.refreshDataElectronicFile = refreshDataElectronicFile;
        vm.openBlmsInfo = openBlmsInfo;
        vm.batteryInfoDispaly = batteryInfoDispaly;
        vm.onlyBlms = false;
        vm.vnext = rLinkConstant.vnext;
        vm.cvc = rLinkConstant.cvc;

        var localCodeCriteria = ['SAN956','NOHYB','SSHYB'];
        var batterDisplayCriteria = ['ELECX','ELEC'];
        var batteryHybridCriteria = ['HYB05','HYB06','HYB07'];
        const SIM_INFO_DELAY_MS = 500;
        vm.vcps = rLinkConstant.vcps;
        vm.usageMode = "";
        vm.isUsageModeEnabled = false;
        vm.connectivityMediaStatusPopup = connectivityMediaStatusPopup;
        vm.isErpCharge = false;
        vm.inhibitionStatus = false;
        vm.countrySearch = '';
        vm.isCountryDropdownOpen = false;
        vm.selectCountry = selectCountry;
        vm.filteredCountries = filteredCountries;
        vm.usageCountries = vm.user && vm.user.language && vm.user.language.toLowerCase() === 'fr' ?
            UsageCountryList.fr : UsageCountryList.en;
        vm.openChangeUsageCountryModal = openChangeUsageCountryModal;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            $timeout(function () { 
            if(_.isEmpty(vm.simInfo)){
                vm.displaySimInfo = false;
            } else{
                vm.displaySimInfo = true;
            }
            }, SIM_INFO_DELAY_MS);

            vm.localizedData = CarSearchMetierService.getLocalizedData();
            vm.isChangeUsageCountryAuthorized = UtilsMetierService.isChangeUsageCountryAuthorized();
            var tempLocalData = [];
            if (vm.localizedData && vm.localizedData.data && vm.localizedData.data['translatedTC']) {
                tempLocalData = vm.localizedData.data['translatedTC'].filter(function (localData) {
                    if (localData.codeObject === '956' && !localCodeCriteria.includes(localData.codeCriteria)) {
                        return localData.labelCriteria;
                    }
                    if(localData.codeObject === '425'){
                        return localData.labelCriteria;
                    }
                });
            }
            vm.newLocalizedData = tempLocalData[1];
            vm.localizedSystemVal = tempLocalData[0];
            vm.vehicle.tcuInformation.present = (vm.vehicle && vm.vehicle.tcuInformation.present === 'YES') ? 'YES' :'NO'
            vm.vehicle.headUnitInformation.present =  (architecture === 'CCS1' || architecture === 'CCS2' || architecture === 'CCS3') ? 'YES' : (vm.vehicle && vm.vehicle.headUnitInformation.present === 'YES') ? 'YES' :'NO'
            vm.usageMode = ((vm.vehicle && vm.vehicle.vehicleInformation && vm.vehicle.vehicleInformation.usageMode) || '-').split('_')[0];
            vm.isErpCharge = vm.vehicle && vm.vehicle.vehicleInformation && vm.vehicle.vehicleInformation.privacyType === 'GRANULAR_PRIVACY' &&
                Array.isArray(vm.vehicle.vehicleInformation.granularDataPrivacy) &&
                vm.vehicle.vehicleInformation.granularDataPrivacy.some(function(e) {
                    return e.category === 'RED_III_ERP' || e.category === 'RED_III_CHARGE';
                });
            if (vm.user && vm.user.userType === "ARCA" && !_.isEmpty(vm.user.roles)) {
                var requiredRoles = [
                    ActisConstantes.ppx_assist_tech_n1,
                    ActisConstantes.ppx_assist_tech_n2,
                    ActisConstantes.ppx_assist_tech_corp
                ];
                vm.isUsageModeEnabled = vm.user.roles.some(function(role) {
                    return requiredRoles.includes(role);
                });
            }
            if(vm.isEasyLink) {
                getConnectivityInformations();
            } else {
                getRadioInformation()
                getSimInformation();
                getHeadUnitInformation();
                getTcuInformation();
                getStorageInformation();
                pushPushButtonStatus();
                pboRequestInfoStatus();
            }
            configureAccordions();
            vm.isAuthorized = RLinkCarMetierService.isAuthorizedUser();

            if(!_.isEmpty(vm.vehicle.subscriptionInformation) && !_.isEmpty(vm.vehicle.subscriptionInformation.technicalServices) && vm.vehicle.subscriptionInformation.technicalServices.length > 0){
                vm.batteryPopUpInfo = vm.vehicle.subscriptionInformation.technicalServices[0].features.forEach(function (uidData) {
                    if (uidData.uid === '345') {
                        vm.batteryUidData = uidData;
                        vm.batteryPopUpCheck = true;
                    }
                });
            }
        }

        function selectCountry(country) {
            vm.usageCountry = country;
            vm.countrySearch = "";
            vm.isCountryDropdownOpen = false;
        }

        function filteredCountries() {
            if (!vm.countrySearch) {
                return vm.usageCountries;
            }

            var search = vm.countrySearch.toLowerCase();

            return vm.usageCountries.filter(function (country) {
                return (
                    country.label.toLowerCase().includes(search) ||
                    country.value.toLowerCase().includes(search)
                );
            });
        }

        function openChangeUsageCountryModal() {
            const vin =
                vm.contextCarRequest && vm.contextCarRequest.vin
                    ? vm.contextCarRequest.vin
                    : null;
            $mdDialog.show({
                templateUrl:
                    "app/components/car/rLinkCar/vehicleInformations/popup/changeUsageCountryPopup.template.html",
                controller: ["$scope", changeUsageCountryPopupController],
                controllerAs: "vm",
                bindToController: true,
                clickOutsideToClose: true,
                size: "sm",
                locals: {
                    usageCountries: vm.usageCountries,
                    usageCountry: vm.usageCountry,
                    vin,
                },
            });
        }

        function changeUsageCountryPopupController() {
            var vm = this;
            vm.countrySearch = "";

            vm.filteredCountries = function () {
                if (!vm.countrySearch) {
                    return vm.usageCountries;
                }
                var search = vm.countrySearch.toLowerCase();
                return vm.usageCountries.filter(function (country) {
                    return (
                        country.label.toLowerCase().includes(search) ||
                        country.value.toLowerCase().includes(search)
                    );
                });
            };

            vm.close = function () {
                $mdDialog.hide();
            };

            vm.confirm = function () {
                $mdDialog.hide();
                openUsageCountryConfirmPopup(vm.usageCountry, vm.vin);
            };
        }

        function openUsageCountryConfirmPopup(selectedUsageCountry, vin) {
            $mdDialog.show({
                templateUrl:
                    "app/components/car/rLinkCar/vehicleInformations/popup/usageCountryConfirmPopup.template.html",
                controller: ["$scope", usageCountryConfirmPopupController],
                controllerAs: "vm",
                bindToController: true,
                clickOutsideToClose: true,
                size: "sm",
                locals: {
                    usageCountry: selectedUsageCountry,
                    vin,
                },
            });
        }

        function usageCountryConfirmPopupController() {
            var vm = this;

            vm.updateUsageCountry = function () {
                CarSearchMetierService.updateUsageCountry(vm.vin, {
                    usageCountry: vm.usageCountry,
                })
                    .then(function () {
                        var connectedPlatform = CacheService.getObject(
                            CacheConstants.connectedPlatform
                        );
                        CacheService.setObject(
                            CacheConstants.connectedPlatform,
                            angular.extend({}, connectedPlatform, {
                                country: vm.usageCountry
                            })
                        );
                        $rootScope.$broadcast('connectedPlatformUpdated');
                        SearchArboTextualMetierService.setConnectedServicesAuditData(
                            "Change_User_Country"
                        )
                            .then(function () {
                                CarSearchMetierService.getConnectedPlatform();
                            })
                            .catch(function () {
                                toastr.error('Audit failed');
                            });
                    })
                    .catch(function () {
                        toastr.error('Failed to update usage country');
                    });
                $mdDialog.hide();
            };

            vm.onCancel = function () {
                $mdDialog.hide();
            };
        }

        function connectivityMediaStatusPopup(isStatusPop){
            var isMultimediaStatusPopup = isStatusPop;
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/vehicleInformations/popup/connectivityMediaStatusPopup.template.html',
                controller: ["$scope", connectivityMediaPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg',
                locals:{
                    isMultimediaStatusPopup: isMultimediaStatusPopup,
                    isCCS3Vehicle: vm.isCCS3Vehicle
                }
            })
        }

        function connectivityMediaPopupController($scope){
            var vm = this;
            $scope.isMultimediaStatusPopup = vm.isMultimediaStatusPopup;
            $scope.isCCS3Vehicle = vm.isCCS3Vehicle;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function batteryInfoDispaly() {
            var newBatteryData = false;
            var onlyBlms = false;
            if (vm.localizedData && vm.localizedData.data && vm.localizedData.data['translatedTC']) {
                var batteryData = vm.localizedData.data['translatedTC'].filter(function (localData) {
                    if ((localData.codeObject === '019' && batterDisplayCriteria.includes(localData.codeCriteria)) || (localData.codeObject === '956' && batteryHybridCriteria.includes(localData.codeCriteria))) {
                        newBatteryData = true;
                    }
                    if (localData.codeObject === '956' && localData.codeCriteria === 'HYB05') {
                        onlyBlms = true;
                    }
                })
            }
            vm.onlyBlms = onlyBlms;
            return newBatteryData;
        }

        function openBlmsInfo() {
            if (!_.isEmpty(vm.vehicle) && !_.isEmpty(vm.vehicle.batteryResponse)) {
                $mdDialog.show({
                    templateUrl: 'app/components/car/rLinkCar/batteryCertificate/batteryCertificate.template.html',
                    controller: 'batteryCertificateCtrl',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    size: 'lg',
                    skipHide: true,
                    multiple: true,
                    windowClass: 'batteryDetailsPopup',
                    locals: {
                        batteryVin: vm.vehicle.batteryResponse,
                        batteryCheck: vm.batteryPopUpCheck,
                        batteryUidData : vm.batteryUidData
                    }
                });
            }
        }

        function goToCsrPortal(){
            if(vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') { 
                SearchArboTextualMetierService.setConnectedServicesAuditData('CSR_PORTAL')
                .then(function () { })
            }
            window.open(csrPortalLink,'_blank');
        }

        function refreshData(){
            blockUI.start();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                if (!_.isEmpty(data)) {
                     vm.vehicle.simInformation.lastCommunication = data && data.sim && data.sim.lastCommunication ? getLastComStatus(data.sim.lastCommunication) : "-";
                     vm.vehicle.tcuInformation.lastCommunication = data && data.tcu && data.tcu.lastCommunication ? getLastComStatus(data.tcu.lastCommunication) : "-";
                     vm.vehicle.headUnitInformation.lastCommunication = data && data.headUnit && data.headUnit.lastCommunication ? getLastComStatus(data.headUnit.lastCommunication) : "-";
                     vm.usageMode = ((data.vehicle && data.vehicle.usageMode) || "-").split('_')[0];
                     vm.vehicle.vehicleInformation = data.vehicle;
                     vm.isErpCharge = data.vehicle && data.vehicle.privacyType === 'GRANULAR_PRIVACY' &&
                         Array.isArray(data.vehicle.granularDataPrivacy) &&
                         data.vehicle.granularDataPrivacy.some(function(e) {
                             return e.category === 'RED_III_ERP' || e.category === 'RED_III_CHARGE';
                         });
                }
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function refreshDataElectronicFile(){
            blockUI.start();
            RLinkCarMetierService.getVehicleSerialNumber(true).then(function(){
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function configureAccordions() {

            var userType = CacheService.getUserProfile().userType;
            // Techliner
            if(userType === 'ARCA') {
                vm.accordions.vehicleInformation.isOpen = true;
                vm.accordions.connectivity.isOpen = true;
                vm.accordions.batteryInformation.isOpen = true;
                vm.accordions.HU.isOpen = true;
                vm.accordions.TCU.isOpen = true;
                vm.accordions.storage.isOpen = true;
                vm.accordions.sim.isOpen = true;
                vm.accordions.process.isOpen = true;
                vm.accordions.usageMode.isOpen = true;
            }

            // Cotech
            if(userType === 'RNET') {
                vm.accordions.vehicleInformation.isOpen = true;
                vm.accordions.connectivity.isOpen = true;
                vm.accordions.batteryInformation.isOpen = true;
                vm.accordions.HU.isOpen = true;
                vm.accordions.TCU.isOpen = true;
                vm.accordions.storage.isOpen = true;
                vm.accordions.sim.isOpen = false;
                vm.accordions.process.isOpen = false;
                vm.accordions.usageMode.isOpen = false;
            }

            if(userType === 'ASOM' && $rootScope.asomDocList['CS']) {
                vm.accordions.vehicleInformation.isOpen = true;
                vm.accordions.connectivity.isOpen = true;
                vm.accordions.batteryInformation.isOpen = true;
                vm.accordions.HU.isOpen = true;
                vm.accordions.TCU.isOpen = true;
                vm.accordions.storage.isOpen = true;
                vm.accordions.sim.isOpen = false;
                vm.accordions.process.isOpen = false;
                vm.accordions.usageMode.isOpen = false;
            }

            // if(userType === 'RNET' && vm.nissanUserURL){
            //     vm.accordions.vehicleInformation.isOpen = true;
            //     vm.accordions.connectivity.isOpen = true;
            //     vm.accordions.batteryInformation.isOpen = true;
            //     vm.accordions.HU.isOpen = true;
            //     vm.accordions.TCU.isOpen = true;
            //     vm.accordions.storage.isOpen = true;
            //     vm.accordions.sim.isOpen = true;
            //     vm.accordions.process.isOpen = true;
            //     vm.accordions.usageMode.isOpen = true;
            // }
        }

        // force PBO
        function forcePBO() {
            vm.canForce = false;
            RLinkCarMetierService.forcePBO();
        }

        function goToDiagnosis(){
            $state.go(RoutesConstants.diagnosis);
        }

        function pushPushButtonStatus() {
            if (vm.vehicle.pboInformations) {
                vm.pushButtonActivated = vm.vehicle.pboInformations.pushButtonActivated;
                vm.pushButtonAutoRequested = vm.vehicle.pboInformations.pushButtonAutoRequested;
                vm.pushButtonRequested = vm.vehicle.pboInformations.pushButtonRequested;
            }
        }

        function pboRequestInfoStatus() {
            if (vm.vehicle.pboRequestInfo) {
                vm.pboRequestDone = vm.vehicle.pboRequestInfo.pboRequestDone;
            }
        }

        function getRadioInformation() {
            if (vm.vehicle.radioInformation) {
                vm.bose = vm.vehicle.radioInformation.bose;
                vm.dab = vm.vehicle.radioInformation.dab;
            }
        }

        function getSimInformation() {
            if (vm.vehicle.simInformation) {
                vm.simTable = vm.vehicle.simInformation.simLastExchanges;
                vm.simStatus = vm.vehicle.simInformation.simStatus;
            }
        }

        function getHeadUnitInformation() {
            if (vm.vehicle.headUnitInformation) {
                vm.huTable = vm.vehicle.headUnitInformation.substitutionHistory;
                var radioRange = vm.vehicle.headUnitInformation.radioRange;
                vm.radioRange = radioRange != null ? radioRange.toUpperCase() : null;
                var curSoft = $filter('rlinkformat')(vm.vehicle.headUnitInformation.currentSoftwareVersion);
                var lastDate = $filter('rlinkformat')(vm.vehicle.headUnitInformation.lastFingerprintDate, 'date');
                var sync = $translate.instant('RLINKCAR_SYNC_POINT') + ' : ';
                vm.software =  curSoft + ' ('+ sync + lastDate  + ')';
            }
        }

        function getTcuInformation() {
            if(vm.vehicle.tcuInformation){
                vm.tcuInformation = vm.vehicle.tcuInformation;
                vm.tcuTable = vm.vehicle.tcuInformation.substitutionHistory;
                vm.noTcu = checkIfNoTcu(vm.tcuInformation);
            }
        }

        function getStorageInformation() {
            if (vm.vehicle.headUnitInformation){
                vm.storage = vm.vehicle.headUnitInformation.storage;
            }
            if (vm.storage.mounts != null && vm.storage.mounts.length > 0) {
                vm.storage.mounts.forEach(function (item) {

                    if (item.id === "/map") {
                        vm.mapStorage = item;
                    }
                    else if (item.id === "/data") {
                        vm.principalStorage = item;
                    }
                });
            }
        }

        function checkIfNoTcu(data){
            return !data.present;
        }

        function getConnectivityInformations() {
            if (vm.vehicle.pboInformations) {
                vm.pushButtonActivated = vm.vehicle.pboInformations.pushButtonActivated;
            }

            if(vm.vehicle.tcuInformation) {
                vm.noTcu = checkIfNoTcu(vm.vehicle.tcuInformation);
                vm.TCUStatus = vm.vehicle.tcuInformation.bootstrap ? vm.vehicle.tcuInformation.bootstrap.done : "-";
                setTcuTable(vm.vehicle.tcuInformation);
            }

            if (vm.vehicle.headUnitInformation) {
                vm.noHu = checkIfNoTcu(vm.vehicle.headUnitInformation);
                vm.HUStatus = vm.vehicle.headUnitInformation.bootstrap ? vm.vehicle.headUnitInformation.bootstrap.done : "-";
                setHuTable(vm.vehicle.headUnitInformation);
            }

            if (vm.vehicle.simInformation && vm.vehicle.simInformation.simStatus) {
                vm.simStatus = vm.vehicle.simInformation.simStatus.toUpperCase();
            }

            vm.OTPStatus = vm.vehicle.owner.otpPairing;
            if(vm.vehicleInformationDisplay){
                vm.lastCommunications = [ 
                    {
                        from: 'vNext',
                        to: 'SIM',
                        date: vm.vehicle.simInformation.lastCommunication,
                        status: ''
                    }                  
                ]
                if(vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === 'YES'){
                    vm.lastCommunications.push({
                        from: 'vNext',
                        to: 'IVC',
                        date: vm.vehicle.tcuInformation.lastCommunication,
                        status: getLastComStatus(vm.vehicle.tcuInformation.lastCommunication)
                    });
                }
                if(vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === 'YES'){
                    vm.lastCommunications.push({
                        from: 'vNext',
                        to: vm.isCCS3Vehicle ? 'CDC' : 'IVI',
                        date: vm.vehicle.headUnitInformation.lastCommunication,
                        status: getLastComStatus(vm.vehicle.headUnitInformation.lastCommunication)
                    });
                }

                if (vm.vehicle && vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === 'YES') {
                    const redbendRow = {
                        from: 'Redbend',
                        to: 'IVC',
                        date: '-',
                        status: ''
                    };
                    vm.lastCommunications.push(redbendRow);

                    const redbendVin = vm.contextCarRequest && vm.contextCarRequest.vin ? vm.contextCarRequest.vin : null;
                    if (redbendVin) {
                        RLinkCarMetierService.lastSeenVehActivities(redbendVin).then(function(response) {
                            let fotaDate = '-';
                            if (response && response._embedded && response._embedded.lastSeenVehicleActivites) {
                                const fotaActivities = response._embedded.lastSeenVehicleActivites.filter(function(a) {
                                    return a.activityType === 'FOTA';
                                });
                                if (fotaActivities.length > 0) {
                                    fotaActivities.sort(function(a, b) {
                                        return new Date(b.activityDateTime) - new Date(a.activityDateTime);
                                    });
                                    fotaDate = fotaActivities[0].activityDateTime;
                                }
                            }
                            redbendRow.date = fotaDate;
                            redbendRow.status = getLastComStatus(redbendRow.date);
                        }).catch(function() {
                            redbendRow.date = '-';
                            redbendRow.status = '';
                        });
                    }
                }
            }
            else{
                vm.lastCommunications = [
                    {
                        from: 'vNext',
                        to: 'SIM',
                        date: vm.vehicle.simInformation.lastCommunication,
                        status: ''
                    },
                    {
                        from: 'vNext',
                        to: 'TCU',
                        date: vm.vehicle.tcuInformation.lastCommunication,
                        status: getLastComStatus(vm.vehicle.tcuInformation.lastCommunication)
                    },
                    {
                        from: 'vNext',
                        to: 'HU',
                        date: vm.vehicle.headUnitInformation.lastCommunication,
                        status: getLastComStatus(vm.vehicle.headUnitInformation.lastCommunication)
                    }
                ]
            }

            if(vm.noHu) {
                vm.lastCommunications = vm.lastCommunications.filter(function (item) {
                    return item.to !== 'HU' && item.to !== 'IVI' && item.to !== 'CDC';
                });
            }

        }

        function getLastComStatus(date) {
            var todays = moment(new Date());
            var lastCom = moment(date);
            var difference = todays.diff(lastCom, 'days');

            var status = (difference <= 2) ? 'OK' : 'WARNING';
            return status;
        }

        /* function getHeadUnitTarget() {
            return vm.isCCS3Vehicle ? 'CDC' : 'IVI';
        } */

        function setHuTable(huInfo) {
            var originPart = huInfo.huId.bvmFactory;
            var replacementPart = huInfo.huId.bvmAfterSales;
            var isOriginalPart = (originPart === replacementPart);

            var originStatus = isOriginalPart ? 'ACTIVE' : 'INACTIVE';
            var replacementStatus = isOriginalPart ? 'INACTIVE': 'ACTIVE';

            var replacementInfos = {
                huid:  replacementPart,
                model: 'REPLACEMENT',
                sources: 'BVM',
                status: replacementStatus,
                date: null
            };

            vm.huTable = [
                {
                    huid:  originPart,
                    model: 'ORIGIN',
                    sources: 'BVM',
                    status: originStatus,
                    date: null
                }
            ];

            if (!isOriginalPart) {
                vm.huTable.push(replacementInfos);
            }
        }

        function setTcuTable(tcuInfo) {
            var originPart = tcuInfo.tcuId.bvmFactory;
            var replacementPart = tcuInfo.tcuId.bvmAfterSales;
            var isOriginalPart = (originPart === replacementPart);

            var originStatus = isOriginalPart ? 'ACTIVE' : 'INACTIVE';
            var replacementStatus = isOriginalPart ? 'INACTIVE': 'ACTIVE';

            var replacementInfos = {
                tcuid:  replacementPart,
                model: 'REPLACEMENT',
                sources: 'BVM',
                status: replacementStatus,
                date: null
            };

            vm.tcuTable = [
                {
                    tcuid:  originPart,
                    model: 'ORIGIN',
                    sources: 'BVM',
                    status: originStatus,
                    date: null
                }
            ];

            if (!isOriginalPart) {
                vm.tcuTable.push(replacementInfos);
            }
        }

        function showBootstrapHistory(type) {
            var data;
            if(type === 'hu') {
                data = vm.vehicle.headUnitInformation.bootstrap.history;
            }
            if(type === 'tcu') {
                data = vm.vehicle.tcuInformation.bootstrap.history;
            }
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/vehicleInformations/EasyLink/bootstrapHistoryModal.html',
                controller: ["$scope",bootstrapHistoryController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalHistory',
                backdrop: 'static',
                locals: {
                    data: data
                }
            });
        }

        function bootstrapHistoryController($scope) {
            var vm = this;
            $scope.bootstrapHistory = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function openPBOHistoryModal() {

            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/vehicleInformations/forcePushButtonHistoryModal.html',
                controller: ["$scope", modalForcePushButtonHistoryController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalContractAndServices',
                backdrop: 'static',
                locals: {
                    data: vm.forcePushButtonHistory
                }
            });
        }

        function modalForcePushButtonHistoryController($scope){
            var vm = this;
            $scope.forcePushButtonHistory = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function dataPrivacyModal(){

            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/vehicleInformations/EasyLink/dataPrivacyPopup.html',
                controller: ["$scope", dataPrivacyPopupController],                
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    data: vm.vehicle.vehicleInformation,
                    isErpCharge : vm.isErpCharge
                }
            })
        }

        function dataPrivacyPopupController($scope){
            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function confirmPatchUsageModePopupController($scope){
            var vm = this;
            $scope.usageMode = vm.usageMode;
            $scope.onCancel = function(){
                toastr.error($translate.instant("ACTION_NOT_SENT"));
                $mdDialog.hide();
            }
            $scope.onConfirm = function(){
                toastr.info($translate.instant("ACTION_SENT"));
                $mdDialog.hide();
                blockUI.start();
                $window.scrollTo({ top: 0, behavior: 'smooth' });
                var data = {
                    usageMode: (vm.usageMode === 'B2B') ? 'B2C' : 'B2B_WITHOUTPAIRING'
                };
                SearchArboTextualMetierService.setConnectedServicesAuditData("Usage mode").then(function () { });
                RLinkCarMetierService.patchUsageMode(data).then(function (response) {
                    if (response.status.toLowerCase() === "successful operation") {
                        vm.usageMode = data.usageMode.split('_')[0];
                        toastr.success($translate.instant('MODE_CHANGE_TAKEN_INTO_ACCOUNT'));
                    } else {
                        toastr.error($translate.instant('MODE_CHANGE_NOT_TAKEN_INTO_ACCOUNT'));
                    }
                }).catch(function (error) {
                    toastr.error($translate.instant('MODE_CHANGE_NOT_TAKEN_INTO_ACCOUNT'));
                }).finally(function () {
                    refreshData()
                    blockUI.stop();
                });
            }
        }

        vm.patchUsageMode = function (usageMode) {
            $mdDialog.show({
                template: '<div class = "popinInfo "style = "padding:20px;font-family:var(--renaultFontRegular);">' +'<div><strong>'+ $translate.instant("CONFIRM_USAGE_MESSAGE") +'<div><strong><div style="margin:5% 35% 0 35%"> <button class="buttonWithIcon" ng-click="onConfirm(true)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_YES"|translate}}</div></button>       <button class="buttonWithIcon" ng-click="onCancel(false)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_NO"|translate}}</div></button></div> </div>',
                controller: ['$scope',confirmPatchUsageModePopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    usageMode: usageMode
                }
            });
        };

        vm.currentStatusPopup = function (usageMode) {
            $mdDialog.show({
                template: '<div class = "popinInfo "style = "padding:20px;font-family:\'newRenaultGroupRegular\';">' +'<div>'+ $translate.instant("B2C_WITH_PAIRING") +'</div><br><div>'+ $translate.instant("B2B_WITHOUT_PAIRING") +'</div></div>',
                controller: ['$scope',confirmPatchUsageModePopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    usageMode: usageMode
                }
            });
        };

        function getTcuServiceReactivationVisibility() {
            // Hide service reactivation section for CCS3 architecture
            /* if (vm.isCCS3Vehicle) {
                return 'hidden';
            } */
            
            if (!vm.tcuServiceReactivation || (vm.tcuServiceReactivation && !vm.tcuServiceReactivation.isServiceReactivation)) {
                return 'visible';
            }
            
            if (vm.tcuServiceReactivation && vm.tcuServiceReactivation.isServiceReactivation && 
                vm.tcuServiceReactivation.sourceSystem === 'CVC') {
                return 'visible';
            }
            return 'hidden';
        }
        function setLoadingState(itemVal, isLoading) {
            if (itemVal === 'IVC') {
                vm.vehicle.tcuLoadingData = isLoading;
            } else {
                vm.vehicle.huLoadingData = isLoading;
            }
        }
        function setServiceReactivationLoadingState(itemVal, data){
            if (itemVal === 'IVC') {
                vm.tcuServiceReactivation = data;
            } else {
                vm.huServiceReactivation = data;
            }
        }
        function dateComparison(itemVal, creationDate){
            const yearFormat = "YYYY-MM-DD";
            const comparisonDate = itemVal === 'IVC' ? vm.vehicle.tcuInformation.bootstrap.history[0].datetime : vm.vehicle.headUnitInformation.bootstrap.history[0].datetime;            
            const dateDiff = Math.abs(moment(comparisonDate).diff(moment(creationDate), 'days'));
            return moment(creationDate).format(yearFormat) === moment(comparisonDate).format(yearFormat) || dateDiff <= MAX_DATE_DIFF_DAYS;
        }
        
        function processProvisioningResponseContent(response, itemVal, isServiceReactivation) {
            if (!response || _.isEmpty(response.content)) {
                return false;
            }
            
            response.content = _.orderBy(response.content, ['creationDate'], ['desc']);
            const matchedObjects = _.filter(response.content, function(item){
                return dateComparison(itemVal, item.creationDate);
            });
            
            const selectedObj = matchedObjects.length > 0 ? matchedObjects[0] : null;
            
            if (selectedObj && isServiceReactivation) {
                _.assign(selectedObj, {isServiceReactivation: true});
            }
            
            setServiceReactivationLoadingState(itemVal, selectedObj);
            return selectedObj !== null;
        }

        function processProvisioningResponse(response, itemVal) {
            return processProvisioningResponseContent(response, itemVal, false);
        }

        function handleSecondaryProvisioningRequest(itemVal) {
            const secondParams = {
                vin: vm.contextCarRequest.vin,
                provisioningProcessType: serviceReactivation
            };
            return RLinkCarMetierService.getProvisioningRequestList(secondParams).then(function (responseSR) {
                processProvisioningResponseContent(responseSR, itemVal, true);
            });
        }

        function handleRecallProvisioningRequest(itemVal) {
            const recallParams = {
                vin: vm.contextCarRequest.vin,
                provisioningProcessType: serviceReactivation
            };
            return RLinkCarMetierService.getProvisioningRequestList(recallParams).then(function (recallResponse) {
                processProvisioningResponseContent(recallResponse, itemVal, true);
            });
        }

        function openReplacement(isOpen,openItem,itemVal){                        
            if (!isOpen || openItem.model !== 'REPLACEMENT') {
                return Promise.resolve();
            }            
            const params = {
                vin: vm.contextCarRequest.vin,
                provisioningProcessType: itemVal === 'IVC' ? provisioningServiceActivationTypeIVC : provisioningServiceActivationTypeIVI
            };
            
            setLoadingState(itemVal, true);
            setServiceReactivationLoadingState(itemVal,null);            
            return RLinkCarMetierService.getProvisioningRequestList(params).then(function (response) {
                const hasContent = processProvisioningResponse(response, itemVal);                
                if (hasContent && !vm.tcuServiceReactivation && itemVal === 'IVC') {
                    return handleSecondaryProvisioningRequest(itemVal)
                        .finally(function(){
                            setLoadingState(itemVal, false);
                        });
                }                
                if (!hasContent && itemVal === 'IVC') {
                    return handleRecallProvisioningRequest(itemVal)
                        .finally(function(){
                            setLoadingState(itemVal, false);
                        });
                }                
                return Promise.resolve();
            }).finally(function(){
                setLoadingState(itemVal, false);
            });
        }        
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('softAndApplications', {
            bindings: {
                data:'<'
            },
            controller: SoftAndApplicationsComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/softAndApplications/softAndApplications.template.html'
        });

/** @ngInject */
    function SoftAndApplicationsComponent(
        $scope,
        $rootScope,
        $translate,
        RLinkCarUtils,
        CacheService,
        CacheConstants,
        configConstantes,
        RLinkCarMetierService,
        toastr,
        $mdDialog,
        UtilsMetierService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.getMapsValues = getMapsValues;
        vm.getMapMusStatus = getMapMusStatus;
        vm.geCoyoteValues = geCoyoteValues;

        vm.getMapEasyLink = getMapEasyLink;
        vm.getSystemType = getSystemType;
        vm.showHistory = showHistory;
        vm.showVersionsHistory = showVersionsHistory;
        vm.updateFavoriteCountry = updateFavoriteCountry;
        vm.selectedRegion = selectedRegion;

        vm.mapDetails = [];
        vm.coyote = [];

        vm.accordions = {maps:{}, application: {}, updateCountry: {}, inventory: {}};

        var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.isEasyLink = (connectedPlatform !== null && (connectedPlatform.platform === "EASYLINK" || connectedPlatform.platform === 'AVN' || connectedPlatform.platform === 'CVC' || connectedPlatform.platform === 'RGDC'));
        var isEasyLink = vm.isEasyLink;
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        var userType = CacheService.getUserProfile().userType;
        vm.userType = userType;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        $scope.region = '';

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            if(!isEasyLink) {
                vm.getMapsValues();
                vm.geCoyoteValues();
            } else {
                vm.getMapEasyLink();
                vm.getSystemType();
            }

            configureAccordions();
        }

        function configureAccordions() {

            var userType = CacheService.getUserProfile().userType;

            // Techliner
            if(userType === 'ARCA') {
                vm.accordions.maps.isOpen = true;
                vm.accordions.application.isOpen = true;
                vm.accordions.updateCountry.isOpen = true;
                vm.accordions.inventory.isOpen = true;
            }

            // Cotech
            if(userType === 'RNET') {
                vm.accordions.maps.isOpen = true;
                vm.accordions.application.isOpen = true;
                vm.accordions.updateCountry.isOpen = true;
                vm.accordions.inventory.isOpen = true;
            }

            if(userType === 'ASOM' && $rootScope.asomDocList['CS']) {
                vm.accordions.maps.isOpen = true;
                vm.accordions.application.isOpen = true;
                vm.accordions.updateCountry.isOpen = true;
                vm.accordions.inventory.isOpen = true;
            }
        }

        function getMapEasyLink() {
            if(vm.data && vm.data.map) {
                vm.map = vm.data.map || [];
                var availableRegions = vm.data.map.availableRegions;
                var favouriteIndex = 0;
                if(!_.isEmpty(availableRegions)){
                    for (var i = 0; i < availableRegions.length; i++) {
                        if(availableRegions[i].isFavourite === true) {
                            favouriteIndex = i;
                        }
                    }
                }
                $scope.region = !_.isEmpty(availableRegions) ? availableRegions[favouriteIndex] : "";
            }
        }
        function selectedRegion(region) {
            vm.selectedId = region.regionIds;
            vm.selectedCountry = region.regionSetLabel;

        }
        function getSystemType() {
            vm.systemType = vm.data ? vm.data.radnavSystemType : "-";
        }

        function showHistory() {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/softAndApplications/easyLink/historyModal.html',
                controller: ["$scope", historyController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalHistory',
                backdrop: 'static',
                locals: {
                    data: vm.data.map.favouriteRegionHistory
                }
            });
        }

        function historyController($scope) {
            var vm = this;
            $scope.history = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

    function showVersionsHistory() {        
        $mdDialog.show({
            templateUrl: 'app/components/car/rLinkCar/softAndApplications/easyLink/versionsHistoryModal.html',
            controller: ["$scope", versionsHistoryController],
            bindToController: true,
            controllerAs: 'vm',
            windowClass: 'modalHistory',
            backdrop: 'static',
            locals: {
                data: vm.data.map.versionsHistory
            }
        });
    }

    function versionsHistoryController($scope) {
        var vm = this;
        $scope.versionsHistory = vm.data;

        $scope.close = function(){
            $mdDialog.hide();
        }
    }

        function updateFavoriteCountry() {
            vm.regionCheck = vm.selectedId ? vm.selectedId : $scope.region.regionIds;
            var regionUpdateParameters = {
                updateRegionsIds: [vm.regionCheck],
                updateRegionSetLabel: vm.selectedCountry ? vm.selectedCountry : $scope.region.regionSetLabel
            }
            RLinkCarMetierService.setFavouriteRegion(regionUpdateParameters).then(
                function (response) {
                    if (response) {
                        toastr.success($translate.instant('COUNTRY_UPDATE_MSG'));
                    }
                }
            );
        }

        function getMapsValues(){
            if(vm.data && vm.data.map)
                vm.mapDetails = vm.data.map;
        }

        function geCoyoteValues(){
            if(vm.data && vm.data.coyote)
                vm.coyote = vm.data.coyote;
        }

        function getMapMusStatus(val){
            return RLinkCarUtils.getMapMusStatus(val);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('updateCampaigns', {
            bindings: {
                data: '<',
                vehicle:'<'
            },
            controller: UpdateCampaignsComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/updateCampaigns/updateCampaigns.template.html'
        });

    /** @ngInject */
    function UpdateCampaignsComponent(
        $scope,
        $translate,
        $filter, UtilsMetierService,SearchArboTextualMetierService, CacheService, RLinkCarMetierService, RLinkCarUtils, ActisConstantes, blockUI, toastr,CacheConstants,configConstantes,$mdDialog
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.sortBy = sortBy;

        vm.accordions = {fota:{}, mota:{}, vehInvent: {}, mapInventCamp: {}, inventCamp: {}};
        vm.showPopin = false;

        vm.updateCampaignsMota = [];
        vm.updateCampaignsFota = [];
        vm.updateCampaignsSoftware = [];
        vm.updateCampaignsVehInventory = [];
        vm.updateCampaignsInventoryCampaigns = [];
        vm.updateCampaignsMapInventoryCampaigns = [];

        vm.updateCampaignsFota.ongoing = [];
        vm.updateCampaignsFota.future = [];
        vm.updateCampaignsFota.expired = [];
        vm.updateCampaignsMota.first = [];
        vm.updateCampaignsSoftware.second = [];
        vm.updateCampaignsInventoryCampaigns.third = [];
        vm.updateCampaignsMapInventoryCampaigns.fourth = [];
        vm.updateCampaignsFota.second = [];

        vm.updateCampaignsMota.ongoing = [];
        vm.updateCampaignsMota.future = [];
        vm.updateCampaignsMota.expired = [];

        var user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(user);
        vm.refreshData = refreshData;
        vm.openEcusInfo = openEcusInfo;
        vm.updateCampaignsEasyLinkData = updateCampaignsEasyLinkData;
        vm.copyToClipboard = copyToClipboard;
        vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.hasCcsArch = vm.connectedPlatform && vm.connectedPlatform.architecture && vm.connectedPlatform.architecture.toLowerCase() === 'ccs1';
        vm.isCCS3 = vm.connectedPlatform && vm.connectedPlatform.architecture === 'CCS3';
        vm.canStartInventory = vm.vehicleInformationDisplay && user && user.roles && user.roles.some(function (profile) {
            profile = profile.toUpperCase();
            return profile === ActisConstantes.ppx_assist_tech_n1 || profile === ActisConstantes.ppx_assist_tech_n2;
        }) && vm.connectedPlatform && ['CCS1', 'CCS2', 'CCS3'].indexOf(vm.connectedPlatform.architecture.toUpperCase()) !== -1;
        vm.inventoryStartDisabled = false;
        vm.startInventory = startInventory;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.pageSize = 10;
        vm.currentPage = 1;
        vm.mapInventoryCurrentPage = 1;
        vm.fotaPageSize = 10;
        vm.fotaCurrentPage = 1;
        vm.motaPageSize = 10;
        vm.motaCurrentPage = 1;

        this.$onInit = function () {
            vm.pageChange(1);
            vm.pageChange(1, 'mapInventoryCampaigns');
            vm.fotaPageChange(1);
            vm.motaPageChange(1);
            
            configureAccordions();
            if (vm.data && !_.isEmpty(vm.data)) {
                processUpdateCampaigns(vm.data);
            }
        }
        
        this.$onChanges = function(changes) {
            if (changes.data && changes.data.currentValue) {
                processUpdateCampaigns(changes.data.currentValue);
            }
        }
        
        function processUpdateCampaigns(data) {
            vm.updateCampaignsVehInventory = data.vehInventory;
            
            if(vm.vehicleInformationDisplay){
                if(!_.isEmpty(data.mota)){
                    getUpdateCampaigns('Mota', data.mota);
                }
                if(!_.isEmpty(data.mapInvent)){
                    getUpdateCampaigns('MapInventoryCampaigns', data.mapInvent);
                }
                if(!_.isEmpty(data.softwareCampaigns)){
                    getUpdateCampaigns('Software', data.softwareCampaigns);
                }
                if(!_.isEmpty(data.inventoryCampaigns)){
                    getUpdateCampaigns('InventoryCampaigns', data.inventoryCampaigns);
                }
            }
            else{
                if(!_.isEmpty(data.fota)){
                    getUpdateCampaigns('Fota', data.fota);
                }
                if(!_.isEmpty(data.mota)){
                    getUpdateCampaigns('Mota', data.mota);
                }
            }
        }

        // Pagination Logic for Inventory Campaign
        vm.getTotalPages = function (campaignType) {
            var campaigns = campaignType === 'mapInventoryCampaigns'
                ? vm.updateCampaignsMapInventoryCampaigns.fourth
                : vm.updateCampaignsInventoryCampaigns.third;

            return Math.ceil(((campaigns && campaigns.length) ? campaigns.length : 0) / vm.pageSize);
        };

        vm.pageChange = function (page, campaignType) {
            if (page >= 1 && page <= vm.getTotalPages(campaignType)) {
                if (campaignType === 'mapInventoryCampaigns') {
                    vm.mapInventoryCurrentPage = page;
                    vm.paginatedMapInventoryCampaigns = vm.updateCampaignsMapInventoryCampaigns.fourth.slice(
                        (vm.mapInventoryCurrentPage - 1) * vm.pageSize,
                        vm.mapInventoryCurrentPage * vm.pageSize
                    );
                    return;
                }

                vm.currentPage = page;
                vm.paginatedInventoryCampaigns = vm.updateCampaignsInventoryCampaigns.third.slice(
                    (vm.currentPage - 1) * vm.pageSize,
                    vm.currentPage * vm.pageSize
                );
            }
        };
       // Pagination Logic for FOTA
        vm.getFotaTotalPages = function () {
            return Math.ceil((vm.updateCampaignsSoftware.second ? vm.updateCampaignsSoftware.second.length : 0) / vm.fotaPageSize);
        };

        vm.fotaPageChange = function (page) {
            if (page >= 1 && page <= vm.getFotaTotalPages()) {
                vm.fotaCurrentPage = page;
                vm.paginatedFotaCampaigns = vm.updateCampaignsSoftware.second.slice(
                    (vm.fotaCurrentPage - 1) * vm.fotaPageSize,
                    vm.fotaCurrentPage * vm.fotaPageSize
                );
            }
        };
        // pagination Logic for MOTA
        vm.getMotaTotalPages = function () {
            return Math.ceil((vm.updateCampaignsMota.first ? vm.updateCampaignsMota.first.length : 0) / vm.motaPageSize);
        };

        vm.motaPageChange = function (page) {
            if (page >= 1 && page <= vm.getMotaTotalPages()) {
                vm.motaCurrentPage = page;
                vm.paginatedMotaCampaigns = vm.updateCampaignsMota.first.slice(
                    (vm.motaCurrentPage - 1) * vm.motaPageSize,
                    vm.motaCurrentPage * vm.motaPageSize
                );
            }
        };

        function openEcusInfo() {
            
                $mdDialog.show({
                    templateUrl: 'app/components/car/rLinkCar/updateCampaigns/ecuInventory.template.html',
                    controller: 'ecuInventoryCtrl',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    size: 'lg',
                    skipHide: true,
                    multiple: true,
                    locals: {
                        ecuData:vm.vehicle
                    }
                });
            
        }

        function startInventory() {
            var vin = RLinkCarUtils.getVin();
            var architecture = vm.connectedPlatform.architecture.toUpperCase();
            if (!vin || vm.inventoryStartDisabled) {
                return;
            }

            if (architecture === 'CCS1') {
                $mdDialog.show({
                    template:
                        '<div class="popinInfo" style="padding:20px; min-width:320px; font-family:var(--renaultFontRegular); font-size:var(--renaultMediumFont);">' +
                        '<div style="margin-bottom:15px;">{{"START_INVENTORY_SELECT_TYPE" | translate}}</div>' +
                        '<div style="display:flex; justify-content:center; gap:40px; margin-bottom:15px;">' +
                        '<label style="display:flex; align-items:center; cursor:pointer;" ng-click="select(\'INVENTORY\')">' +
                        '<input type="checkbox" ng-checked="inventoryType === \'INVENTORY\'" style="margin:0 8px 0 0;"> {{"START_INVENTORY_TYPE_INVENTORY" | translate}}</label>' +
                        '<label style="display:flex; align-items:center; cursor:pointer;" ng-click="select(\'MAP_INVENTORY\')">' +
                        '<input type="checkbox" ng-checked="inventoryType === \'MAP_INVENTORY\'" style="margin:0 8px 0 0;"> {{"START_INVENTORY_TYPE_MAP_INVENTORY" | translate}}</label>' +
                        '</div>' +
                        '<div style="text-align:center;">' +
                        '<button class="buttonWithIcon" ng-click="confirm()" style="margin-right:10px;">{{"ACTIS_SAVE_INFORMATIONS_YES" | translate}}</button>' +
                        '<button class="buttonWithIcon" ng-click="cancel()">{{"ACTIS_SAVE_INFORMATIONS_NO" | translate}}</button>' +
                        '</div></div>',
                    controller: ['$scope', function ($scope) {
                        $scope.inventoryType = 'INVENTORY';
                        $scope.select = function (type) { $scope.inventoryType = type; };
                        $scope.confirm = function () { $mdDialog.hide($scope.inventoryType); };
                        $scope.cancel = function () { $mdDialog.cancel(); };
                    }],
                    clickOutsideToClose: true
                }).then(function (inventoryType) {
                    if (inventoryType) {
                        submitInventory(vin, inventoryType);
                    }
                });
                return;
            }

            $mdDialog.show({
                template:
                    '<div class="popinInfo" style="padding:20px; min-width:320px; font-family:var(--renaultFontRegular); font-size:var(--renaultMediumFont);">' +
                    '<div style="margin-bottom:15px;">{{"START_INVENTORY_CONFIRM" | translate}}</div>' +
                    '<div style="text-align:center;">' +
                    '<button class="buttonWithIcon" ng-click="confirm()" style="margin-right:10px;">{{"ACTIS_SAVE_INFORMATIONS_YES" | translate}}</button>' +
                    '<button class="buttonWithIcon" ng-click="cancel()">{{"ACTIS_SAVE_INFORMATIONS_NO" | translate}}</button>' +
                    '</div></div>',
                controller: ['$scope', function ($scope) {
                    $scope.confirm = function () { $mdDialog.hide('INVENTORY'); };
                    $scope.cancel = function () { $mdDialog.cancel(); };
                }],
                clickOutsideToClose: true
            }).then(function (inventoryType) {
                if (inventoryType) {
                    submitInventory(vin, inventoryType);
                }
            });
        }

        function submitInventory(vin, inventoryType) {
            var campaignName = 'Newdialogys_' + vin;
            var campaigns = inventoryType === 'MAP_INVENTORY'
                ? vm.updateCampaignsMapInventoryCampaigns.fourth
                : vm.updateCampaignsInventoryCampaigns.third;
            var hasPendingCampaign = (campaigns || []).some(function (campaign) {
                var operationResult = campaign && campaign.operationResult;
                return campaign && campaign.name && campaign.name.includes(campaignName) &&
                    (campaign.status === 'Pending' || campaign.status === 'Pending:OperationResult.Pending' ||
                        campaign.status === 'Preparation:Planned' ||
                        operationResult === 'Pending' || (operationResult && operationResult.status === 'Pending'));
            });

            if (hasPendingCampaign) {
                $mdDialog.show({
                    template:
                        '<div class="popinInfo" style="padding:2rem 1rem 1rem; min-width:330px; font-family:var(--renaultFontRegular); font-size:var(--renaultMediumFont); position:relative;">' +
                        '<i class="fa fa-times" ng-click="close()" style="position:absolute; top:10px; right:15px; cursor:pointer;"></i>' +
                        '<div style="margin-bottom:15px;">{{"START_INVENTORY_ALREADY_IN_PROGRESS" | translate}}</div>' +
                        '</div>',
                    controller: ['$scope', function ($scope) {
                        $scope.close = function () { $mdDialog.hide(); };
                    }],
                    clickOutsideToClose: true
                });
                return;
            }

            vm.inventoryStartDisabled = true;
            var uniqueCampaignName = campaignName + '_' + crypto.randomUUID();
            RLinkCarMetierService.startInventoryCampaign({
                name: uniqueCampaignName,
                creator: 'Newdialogys',
                type: inventoryType,
                status: 'Active',
                meta: { step: 5, autoSubmit: true, campaignCalculateOnly: false, isEditAsSourceChecked: false },
                vehicles: { vins: [vin] }
            }).then(function () {
                SearchArboTextualMetierService.setConnectedServicesAuditData(inventoryType === 'MAP_INVENTORY' ? 'Map_Inventory' : 'Inventory');
                toastr.info($translate.instant('ACTION_SENT'));
            }).catch(function () {
                vm.inventoryStartDisabled = false;
                toastr.error($translate.instant('ACTION_NOT_SENT'));
            });
        }

        function configureAccordions() {
            vm.accordions.fota.isOpen = true;
            vm.accordions.mota.isOpen = true;
            vm.accordions.vehInvent.isOpen = true;
            vm.accordions.mapInventCamp.isOpen = true;
            vm.accordions.inventCamp.isOpen = true;
        }

        function refreshData(value){
            blockUI.start();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            if (value === 'vehicle') {
                RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                    vm.updateCampaignsEasyLinkData(data, value);
                }).catch(function () {
                    toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                }).finally(function () {
                    blockUI.stop();
                });
            } else {
                RLinkCarMetierService.getUpdateCampaignsCCS().then(function (data) {
                    vm.updateCampaignsEasyLinkData(data, value);
                }).catch(function () {
                    toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        function updateCampaignsEasyLinkData(data, value){
            if(value == 'map'){
                var motaData = data.map && data.map.updateCampaigns ? data.map.updateCampaigns : null;
                if(!_.isEmpty(motaData)){
                    getUpdateCampaigns('Mota', motaData);
                }
            }
            if(value == 'MapInvent'){
                var mapInventData = data.map && data.map.inventoryCampaigns ? data.map.inventoryCampaigns : null;
                if(!_.isEmpty(mapInventData)){
                    getUpdateCampaigns('MapInventoryCampaigns', mapInventData);
                }
            }
            if(value == 'software'){
                var softwareData = data.softwareCampaigns || null;
                if(!_.isEmpty(softwareData)){
                    getUpdateCampaigns('Software', softwareData);
                }
            }
            if (value == 'vehicle') {
                if (!vm.updateCampaignsVehInventory) {
                    vm.updateCampaignsVehInventory = {};
                }

                $scope.$applyAsync(function () {
                    if (data.radnavSystemType || data.calibrationFile || data.softwareVersion) {
                        angular.extend(vm.updateCampaignsVehInventory, {
                            huPresent: data.present === true ? 'YES' : 'NO',
                            huPartNo: data.partNumber || '',
                            huConfigFile: data.configFile || '',
                            huCalibrationFile: data.calibrationFile || '',
                            huRadnavSysTypeDesc: data.radnavSystemType && data.radnavSystemType.description ? data.radnavSystemType.description : '',
                            huMtcCriteria: data.radnavSystemType && data.radnavSystemType.mtcCriteria ? data.radnavSystemType.mtcCriteria : '',
                            huName: data.radnavSystemType && data.radnavSystemType.name ? data.radnavSystemType.name : ''
                        });
                    }
                    if (data.type || data.tcuId) {
                        angular.extend(vm.updateCampaignsVehInventory, {
                            tcuPresent: data.present === true ? 'YES' : 'NO',
                            tcuPartNo: data.partNumber || '',
                            tcuConfigFile: data.configFile || '',
                            tcuType: data.type || ''
                        });
                    }
                });
            }
            if(value == 'inventory'){
                var inventoryData = data.inventoryCampaigns || (data.map && data.map.inventoryCampaigns) || null;
                if(!_.isEmpty(inventoryData)){
                    getUpdateCampaigns('InventoryCampaigns', inventoryData);
                }
            }
        }

        function getUpdateCampaigns(type, data) {
            if(vm.vehicleInformationDisplay){
                vm['updateCampaigns' + type].first = [];
                vm['updateCampaigns' + type].second = [];
                vm['updateCampaigns' + type].third = [];
                vm['updateCampaigns' + type].fourth = [];

                if(type == 'Mota'){
                    vm['updateCampaigns' + type].first = $filter('filter')(data, function (campaign) {
                        if(campaign && campaign.creationDateTime !== null){
                            return campaign.creationDateTime;
                        }
                    });
                    vm.motaPageChange(1);
                }
                if(type == 'MapInventoryCampaigns'){
                    vm['updateCampaigns' + type].fourth = $filter('filter')(data, function (campaign) {
                        if(campaign && campaign.creationDateTime !== null){
                            return campaign.creationDateTime;
                        }
                    });
                    vm.pageChange(1, 'mapInventoryCampaigns');
                }
                if(type == 'Software'){
                    vm['updateCampaigns' + type].second = $filter('filter')(data, function (campaign) {
                        if(campaign && campaign.type !== null){
                            return campaign.type;
                        }
                    });
                    vm.fotaPageChange(1);
                }
                if(type == 'InventoryCampaigns'){
                    vm['updateCampaigns' + type].third = $filter('filter')(data, function (campaign) {
                        if(campaign && campaign.type !== null){
                            return campaign.type;
                        }
                    });
                    vm.pageChange(1);
                }

                // Sort by startDateTime
                vm['updateCampaigns' + type].first.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                });
                vm['updateCampaigns' + type].second.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                });
                vm['updateCampaigns' + type].third.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                });
                vm['updateCampaigns' + type].fourth.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                });
            }
            else{
                vm['updateCampaigns' + type].ongoing = [];
                vm['updateCampaigns' + type].future = [];
                vm['updateCampaigns' + type].expired = [];

                vm['updateCampaigns' + type].ongoing = $filter('filter')(data, function (campaign) {
                    return campaign.category === 'ONGOING';
                });

                vm['updateCampaigns' + type].future = $filter('filter')(data, function (campaign) {
                    return campaign.category === 'FUTURE';
                });

                vm['updateCampaigns' + type].expired = $filter('filter')(data, function (campaign) {
                    return campaign.category === 'EXPIRED';
                });

                // Sort by startDateTime
                vm['updateCampaigns' + type].ongoing.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                })
                vm['updateCampaigns' + type].future.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                })
                vm['updateCampaigns' + type].expired.sort(function (a, b) {
                    return new Date(b.startDatetime) - new Date(a.startDatetime);
                })
            }
        }


        $scope.propertyName = 'startDatetime';
        $scope.campaigns = 'updateCampaignsMota';
        $scope.reverse = null;

        vm.updateCampaignsFota.ongoing = $filter('orderBy')(vm.updateCampaignsFota.ongoing, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsFota.future = $filter('orderBy')(vm.updateCampaignsFota.future, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsFota.expired = $filter('orderBy')(vm.updateCampaignsFota.expired, $scope.propertyName, $scope.reverse);

        vm.updateCampaignsMota.ongoing = $filter('orderBy')(vm.updateCampaignsMota.ongoing, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsMota.future = $filter('orderBy')(vm.updateCampaignsMota.future, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsMota.expired = $filter('orderBy')(vm.updateCampaignsMota.expired, $scope.propertyName, $scope.reverse);

        vm.updateCampaignsMota.data = $filter('orderBy')(vm.updateCampaignsMota.data, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsSoftware.data = $filter('orderBy')(vm.updateCampaignsSoftware.data, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsVehInventory.data = $filter('orderBy')(vm.updateCampaignsVehInventory, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsInventoryCampaigns.data = $filter('orderBy')(vm.updateCampaignsInventoryCampaigns.data, $scope.propertyName, $scope.reverse);
        vm.updateCampaignsMapInventoryCampaigns.data = $filter('orderBy')(vm.updateCampaignsMapInventoryCampaigns.data, $scope.propertyName, $scope.reverse);

        function sortBy(propertyName, campaigns, status) {
            $scope.reverse = (
                (propertyName !== null || campaigns !== null || status !== null) &&
                ($scope.propertyName === propertyName || $scope.campaigns === campaigns || $scope.status === status)
            )
                ? !$scope.reverse : false;
            $scope.propertyName = propertyName;
            $scope.campaigns = campaigns;
            $scope.status = status;

            vm[campaigns][status] = $filter('orderBy')(vm[campaigns][status], $scope.propertyName, $scope.reverse);
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference);
        }

    }
})();

/**
 * vehicle ecu inventory Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('ecuInventory', {
            bindings: {
                ecuData: '<'
            },
            controller: ecuInventoryCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/updateCampaigns/ecuInventory.template.html'
        })
        .controller('ecuInventoryCtrl', ecuInventoryCtrl);

    function ecuInventoryCtrl(
        CacheService,
        CacheConstants,$mdDialog
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.hideCalibration = false;
        vm.hideConfigurationFile = false;
        vm.hideSoftwareVersion = false;
        vm.hidePartNumber = false;
        vm.hideSerialNumber = false;
        vm.hideConfigRef = false;
        vm.closePopIn = closePopIn;
        vm.ecuResponseData = [];
        vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        if (!_.isEmpty(vm.ecuData) && !_.isEmpty(vm.ecuData.electronicEcuVehicleData) && !_.isEmpty(vm.ecuData.electronicEcuVehicleData.response)
            && !_.isEmpty(vm.ecuData.electronicEcuVehicleData.response.ecuReport) && !_.isEmpty(vm.ecuData.electronicEcuVehicleData.response.ecuReport.electronicControlUnits)) {
            vm.ecuData.electronicEcuVehicleData.response.ecuReport.electronicControlUnits.forEach(function (feature) {
                var ecuDataObject = {};
                if (!_.isEmpty(feature)) {

                    if (feature.part && feature.part.partNumber) {
                        _.assign(ecuDataObject, { partNumber: feature.part.partNumber })
                    }else{
                        _.assign(ecuDataObject, { hidePartNumber: true })
                    }
                    if (feature.part && feature.part.partSerialNumber) {
                        _.assign(ecuDataObject, { serialNumber: feature.part.partSerialNumber.serialNumber })
                    }else{
                        _.assign(ecuDataObject, { hideSerialNumber: true })
                    }
                    if (feature.uniqueConfigurationReference && feature.uniqueConfigurationReference.partNumber) {
                        _.assign(ecuDataObject, { uniqueConfigurationRef: feature.uniqueConfigurationReference.partNumber })
                    }else{
                        _.assign(ecuDataObject, { hideConfigRef: true })
                    }
                    if (feature.configurationFiles && feature.configurationFiles[0]) {
                        _.assign(ecuDataObject, { configurationFile: feature.configurationFiles[0].partNumber })
                    }else{
                        _.assign(ecuDataObject, { hideConfigurationFile: true })
                    }
                    if (feature.ecuName == "NAV") {
                        _.assign(ecuDataObject, {
                            ecuName: vm.connectedPlatform && vm.connectedPlatform.architecture && vm.connectedPlatform.architecture.toLowerCase() === 'ccs3' ? "CDC" : "IVI"
                        })
                        if (feature.operationalReference && feature.operationalReference.CAN && feature.operationalReference.CAN) {
                            _.assign(ecuDataObject, { calibrationFile: feature.operationalReference.CAN.partNumber })
                        }else{
                            _.assign(ecuDataObject, { hideCalibration: true })
                        }
                        if (feature.operationalReference && feature.operationalReference.USB && feature.operationalReference.USB.partNumber) {
                            _.assign(ecuDataObject, { softwareVersion: feature.operationalReference.USB.partNumber })
                        }else{
                            _.assign(ecuDataObject, { hideSoftwareVersion: true })
                        }
                        if (feature.data && feature.data.visualPack && feature.data.visualPack.value) {
                            _.assign(ecuDataObject, { visualPackRef: feature.data.visualPack.value })
                        }
                    }
                    else if (feature.ecuName == "TCU") {
                        _.assign(ecuDataObject, { ecuName: "IVC" })
                        if (feature.calibrationFiles && feature.calibrationFiles[0] ) {
                            _.assign(ecuDataObject, { calibrationFile: feature.calibrationFiles[0].partNumber })
                        }else{
                            _.assign(ecuDataObject, { hideCalibration: true })
                        }
                        
                        if (vm.connectedPlatform && vm.connectedPlatform.architecture && (vm.connectedPlatform.architecture.toLowerCase() === 'ccs1')) {
                            if (feature.operationalReference && feature.operationalReference.USB) {
                                _.assign(ecuDataObject, { softwareVersion: feature.operationalReference.USB.partNumber })
                            }else{
                                _.assign(ecuDataObject, { hideSoftwareVersion: true })
                            }
                        }
                        else if (vm.connectedPlatform && vm.connectedPlatform.architecture && (vm.connectedPlatform.architecture.toLowerCase() === 'ccs2')) {
                            if (feature.operationalReference && feature.operationalReference.CAN) {
                                _.assign(ecuDataObject, { softwareVersion: feature.operationalReference.CAN.partNumber })
                            }else{
                                _.assign(ecuDataObject, { hideSoftwareVersion: true })
                            }
                        }
                    }
                    else {
                        _.assign(ecuDataObject, { ecuName: feature.ecuName })
                        if (feature.calibrationFiles && feature.calibrationFiles[0] ) {
                            _.assign(ecuDataObject, { calibrationFile: feature.calibrationFiles[0].partNumber })
                        }else{
                            _.assign(ecuDataObject, { hideCalibration: true })
                        }
                        if (feature.operationalReference && feature.operationalReference.CAN) {
                            _.assign(ecuDataObject, { softwareVersion: feature.operationalReference.CAN.partNumber })
                        }else{
                            _.assign(ecuDataObject, { hideSoftwareVersion: true })
                        }
                    }
                    vm.ecuResponseData.push(ecuDataObject)
                }
            })
        }
        function closePopIn() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';
    angular.module('phenix').service('RLinkCarWSService', RLinkCarWSService);

    function RLinkCarWSService(
        $q,
        rLinkConstant,
        SearchbyDiagnosticConstants,
        RestRLink,CacheService,UtilsMetierService, configConstantes,RestUpgradeRLink,RestUpgrade,RestUpgradeRaw,blockUI
    ){
        this.getRlinkCarData = getRlinkCarData;
        this.getEasyLinkCarData = getEasyLinkCarData;
        this.getRemoteDiagData = getRemoteDiagData;
        this.getRemoteDiagStatus = getRemoteDiagStatus;
        this.getFeatureId = getFeatureId;
        this.checkId = checkId;
        this.getListDiagnosis = getListDiagnosis;
        this.getNextDiagnosis = getNextDiagnosis;
        this.setFavouriteRegion = setFavouriteRegion;
        this.synchronizeContract = synchronizeContract;
        this.forcePBO = forcePBO;
        this.callRoutine = callRoutine;
        this.getDiagHistory = getDiagHistory;
        this.saveDiag = saveDiag;
        this.applicabilityService = applicabilityService;
        this.diagCertificateInfo = diagCertificateInfo;
        this.getCertificatesDiagnostic = getCertificatesDiagnostic;
        this.getVehicleSerialNumber = getVehicleSerialNumber;
        this.patchSeriveSyncronization = patchSeriveSyncronization;
        this.getDelegation = getDelegation;
        this.getCalendar = getCalendar;
        this.getSoc = getSoc;
        this.updateRemoteDiagId = updateRemoteDiagId;
        this.updateRemoteDiagStatus = updateRemoteDiagStatus;
        this.getVehicleInformationDataCCS = getVehicleInformationDataCCS;
        this.getUpdateCampaignsCCS = getUpdateCampaignsCCS;
        this.startInventoryCampaign = startInventoryCampaign;
        this.patchUsageMode = patchUsageMode;
        this.getCurrentOffersData = getCurrentOffersData;
        this.getAcquisitions = getAcquisitions;
        this.getCatalogHardwareSnapshot = getCatalogHardwareSnapshot;
        this.getEligibleHardware = getEligibleHardware;
        this.createAcquisition = createAcquisition;
        this.getCurrentOffersSearchData = getCurrentOffersSearchData;
        this.getSubscriptionOfferDetails = getSubscriptionOfferDetails;
        this.getEligibleOffers = getEligibleOffers;
        this.getvinSubscription = getvinSubscription;
        this.restartSerialStartUsage = restartSerialStartUsage;
        this.getConnectedAdasEhorizonDetails = getConnectedAdasEhorizonDetails;
        this.getVehicleInformationDataCCSNew = getVehicleInformationDataCCSNew;
        this.getBasketInterventionDocuments = getBasketInterventionDocuments;
        this.getSiesByGies = getSiesByGies;
        var baseReq = RestUpgradeRLink.one(rLinkConstant.restATWS);
        var baseReqNew = RestUpgradeRLink.one(rLinkConstant.restATWSNew); 
        var vinOfferUrl = rLinkConstant.vinSearchOffer;
        var offerDetailsUrl = rLinkConstant.offerDetails;
        var catalogUrl = rLinkConstant.catalog;
        var restartSerialUrl = rLinkConstant.restartSerialUrl;
        var user = CacheService.getUserProfile();
        var vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(user);
        this.getBatteryInformation = getBatteryInformation;
        this.getBatteryStatus = getBatteryStatus;
        this.getBatteryInhibition = getBatteryInhibition;
        this.evManagerCalendarInfo = evManagerCalendarInfo;
        this.launchInstallation = launchInstallation;
        this.provisioningRequest = provisioningRequest;
        this.getProvisioningRequestVehicles = getProvisioningRequestVehicles;
        this.getProvisioningRequests = getProvisioningRequests;
        this.getRemoteCommandHistory = getRemoteCommandHistory;
        this.getRemoteCommand = getRemoteCommand;
        this.refreshJwtConfig = refreshJwtConfig;
        this.getVirtualBlmsDetails = getVirtualBlmsDetails;
        this.getRefreshActivation = getRefreshActivation;
        this.getRights = getRights;
        this.getVirtualUserRolesDelegation = getVirtualUserRolesDelegation;
        this.getPrivacySettings = getPrivacySettings;
        this.getMultipleSubsOfferDetails = getMultipleSubsOfferDetails;
        this.deactivateService = deactivateService;
        this.getProvisioningRequestList = getProvisioningRequestList;
        this.getEvSettingsData = getEvSettingsData;
        this.getEvSettingsSoc = getEvSettingsSoc;
        this.getV2gSubscription = getV2gSubscription;
        this.getCertificatesStatus = getCertificatesStatus;
        this.getSimStatusData = getSimStatusData;
        this.getHereNaviStatus =getHereNaviStatus;
        this.getHereNaviSubscription = getHereNaviSubscription;
        this.getMapData = getMapData;
        this.lastSeenVehActivities = lastSeenVehActivities;

        /* =============================================
           =                FUNCTIONS                  =
           ============================================= */

        function getBasketInterventionDocuments(payload) {
            return RestUpgradeRaw.all(rLinkConstant.basketInterventionDocuments).post(payload).then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function getSiesByGies(payload) {
            return RestUpgradeRaw.all(rLinkConstant.siesByGies).post(payload).then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });

            // Mock response for multiple SIEINTs
            /*
            var mockResponse = {
                "GIEINT-0000000722": [
                    {
                        "type": "INT_REPAIR",
                        "id": "SIEINT-0000005708",
                        "subType": "FOD",
                        "designation": "mobile device inductive charger: fitting",
                        "reference": null,
                        "residual": []
                    },
                    {
                        "type": "INT_REPAIR",
                        "id": "SIEINT-0000005709",
                        "subType": "FOD",
                        "designation": "mobile device inductive charger: fitting",
                        "reference": null,
                        "residual": []
                    }
                ]
            };
            return $q.resolve(mockResponse);
            */
        }

        function getCurrentOffersData(payload) {
            var req = catalogUrl;
            return RestUpgradeRaw.all(req).post(payload).then(function(response){
                if(response && response.data){
                    return response.data;
                }
                }).catch( function() {
                    return $q.reject();
                });
        }

        function getAcquisitions(vin) {
            var url = rLinkConstant.acquisitionsUrl + vin;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function getCatalogHardwareSnapshot(payload) {
            var url = rLinkConstant.catalogHardwareSnapshot;
            return RestUpgradeRaw.all(url).post(payload).then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function getEligibleHardware(vin, channel) {
            var url = rLinkConstant.eligibleHardwareUrl + vin + '/eligible-hardware?channel=' + channel;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function createAcquisition(payload) {
            var url = rLinkConstant.createAcquisitionUrl;
            return RestUpgradeRaw.all(url).post(payload).then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function getVirtualBlmsDetails(vin) {
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.virtualBlmDetails;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }
        function getRefreshActivation(vin) {
            var url = rLinkConstant.refreshActivationBase + vin + rLinkConstant.association;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }
        function getRights(vin){
            var url = rLinkConstant.rightsBase + vin + rLinkConstant.rights;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }

        function getPrivacySettings(vin) {
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.privacySettings;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }

        function getVirtualUserRolesDelegation(vin) {
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.virtualKeyUserRole;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }

        function provisioningRequest(payload){
            var reqUrl = rLinkConstant.restATWSNew + rLinkConstant.provisioningReq;
            return RestUpgradeRaw.all(reqUrl).post(payload).then(function(response){
                if(response && response.data && !_.isEmpty(response.data)){
                    return response.data;
                }
            }).catch( function(error) {
                    return $q.reject(error);
            });
        }

        function getProvisioningRequestList(params) {
            var url = rLinkConstant.deactivateService + rLinkConstant.provisioningReq;
            return RestUpgradeRLink
                .one(url)
                .get(params)
                .then(function (response) {
                    if (response && !_.isEmpty(response)) {
                        return response;
                    }
                }).catch(function (error) {
                    return $q.reject(error);
                });
        }
        function getProvisioningRequestVehicles(vin) {
            var url = rLinkConstant.restATWSNew + rLinkConstant.provisioningReqVeh + vin;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }

        function getProvisioningRequests(reqId) {
            var url = rLinkConstant.restATWSNew + rLinkConstant.provisioningReq + rLinkConstant.provisioningRequests + reqId;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                if(response && response && !_.isEmpty(response)){
                    return response;
                }
                }).catch( function(error) {
                    return $q.reject(error);
                });
        }

        function restartSerialStartUsage(payload, vin){
            var url = restartSerialUrl + vin;
            return RestUpgradeRaw.all(url).post(payload).then(function(response){
                if(response && response.status == 200){
                    return response;
                }
            }).catch( function(err) {
                return $q.reject(err.data);
            });
        }

        function getCurrentOffersSearchData(payload){
            var url = vinOfferUrl;
           
            return RestUpgradeRaw.all(url).post(payload).then(function(response){
                if(response && response.status == 200){
                    return response;
                }
            }).catch( function(err) {
                return $q.reject(err.data);
            });

        }

        function getSubscriptionOfferDetails(id){
            var url = offerDetailsUrl + id;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return $q.reject();
                });
        }

        function getMultipleSubsOfferDetails(urls){
            var promises = urls.map(function (url) {
                return RestUpgradeRLink.one(offerDetailsUrl + url).get().catch(function (e) { return null })
            }), all = $q.all(promises).then(function (data) {
                return data
            })
            return all;
        }

        function getEligibleOffers(vin, subscriptionChannel){
            var eligibleOffer = rLinkConstant.eligibleOffer;
            var url = eligibleOffer + '?vin=' + vin + '&subscriptionChannel=' +subscriptionChannel ;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function(err) {
                    return $q.reject(err.data);
                });
        }

        function getvinSubscription(payload){
                var vinSubscriptionUrl = rLinkConstant.vinsubscription;
                return RestUpgradeRaw.all(vinSubscriptionUrl).post(payload).then(function(response){
                    if(response && response.data){
                        return response.data;
                    }
                    })
        }

        function getEvSettingsData(vin) {
            var evSettingsUrl = rLinkConstant.settingsApi + vin + rLinkConstant.settingsEV;
            return RestUpgradeRLink
                .one(evSettingsUrl)
                .get().then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error.data);
                });
        }

        function getEvSettingsSoc(vin){
            var evSettingsSocUrl = rLinkConstant.settingsApi + vin + rLinkConstant.settingsSocLevels;
            return RestUpgradeRLink
                .one(evSettingsSocUrl)
                .get().then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error.data);
                });
        }

        function getBatteryStatus(vin) {
            var batteryStatusUrl = rLinkConstant.batteryApi + vin + rLinkConstant.batteryStatus;

            return RestUpgradeRLink
                .one(batteryStatusUrl)
                .get().then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error.data);
                });
        }

        function getBatteryInhibition(vin){
            var batteryInhibitionUrl = rLinkConstant.batteryInhibition + vin + rLinkConstant.batteryInhibitorChange;
            return RestUpgradeRLink
                .one(batteryInhibitionUrl)
                .get().then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error.data);
                });
        }

        function getBatteryInformation(vin){
            var batteryInfoUrl = rLinkConstant.batteryInfo + vin;
                       
                return RestUpgradeRLink
                    .one(batteryInfoUrl)
                    .get().then( function(response) {
                        return response;
                    }).catch( function() {
                        return $q.reject();
                    });
    }
      
        function getRlinkCarData(vin, lan) {
            var req = baseReqNew.one(rLinkConstant.vehc, vin).one(rLinkConstant.preDiag);
            return executeRequest('get', req);
        }

        function getFeatureId(vin) {
            var url = rLinkConstant.asap + rLinkConstant.vehc + vin;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status == 200) {
                    return response.data;
                }
            }).catch(function () {
                return $q.reject();
            });
        }
        function getVehicleInformationDataCCS(vin) {
            const url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.vehicleInformationLinkCCS;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return $q.reject();
                });
        }

        function getVehicleInformationDataCCSNew(vin) {
            const url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.vehicleInformationLinkCCS;
            const urlCS = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.vehicleInformationLinkContractsService;

            let vehicleInfoRequest = RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return $q.reject();
                });

            let contractsServiceRequest = RestUpgradeRLink
                .one(urlCS)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return null;
                });

            return $q.all([vehicleInfoRequest, contractsServiceRequest]).then(function (responses) {
                let vehicleInfoResponse = responses[0];
                let contractsServiceResponse = responses[1];
                if (contractsServiceResponse !== null && contractsServiceResponse.subscriptions && vehicleInfoResponse) {
                    vehicleInfoResponse.subscriptions = contractsServiceResponse.subscriptions;
                } else {
                    vehicleInfoResponse.subscriptions = null;
                }
                return vehicleInfoResponse;
            });
        }

        function getUpdateCampaignsCCS(vin) {
            var url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.updateCampaignsCCS;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return $q.reject();
                });
        }

        function startInventoryCampaign(payload) {
            return RestUpgradeRaw.all(rLinkConstant.campaignManagement).post(payload)
                .then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error);
                });
        }

        function patchUsageMode(data, vin) {
            var url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.usageMode;
            return RestUpgradeRLink
                .one(url)
                .patch(data)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function getEasyLinkCarData(vin, region) {
            var url = rLinkConstant.restATWS + rLinkConstant.vehc + vin + '/regions/' + region + '/' + rLinkConstant.preDiagEasyLink;
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                }).catch( function() {
                    return $q.reject();
                });
        }
        function checkId(vin){
            var url = SearchbyDiagnosticConstants.checkId + vin;
            return RestUpgradeRaw.one(url).get().then(function(response){
                if(response && response.status == 200){
                    return response.data;
                }else if(response.status === 204){
                    return null;
                }
            }).catch( function() {
                return $q.reject();
            });

        }

        function updateRemoteDiagId(vin, diagId, payload){
            var url = SearchbyDiagnosticConstants.updateRemoteDiagId + vin + "/" + diagId;
            return RestUpgradeRaw.all(url).post(payload).then(function(response){
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch( function() {
                return $q.reject();
            });

        }

        function deactivateService(payload){
            var url = rLinkConstant.deactivateService + rLinkConstant.provisioningReq;
            return RestUpgradeRaw.all(url).post(payload).then(function (response) {
                if (response && response.status == 201) {
                    return response.data;
                }
            }).catch(function () {
                return $q.reject();
            });
        }

        function updateRemoteDiagStatus(vin, diagId,diagStatus) {
            var url = SearchbyDiagnosticConstants.updateRemoteDiagStatus + vin + "/" + diagId;
            var payload = diagStatus;
            return RestUpgradeRaw.all(url).post(payload).then(function (response) {
                if (response && response.status == 200) {
                    return response.data;
                }
            }).catch(function () {
                return $q.reject();
            });

        }

        function getRemoteDiagData(payload) {
            var url =  rLinkConstant.remoteDiagVCPS;
            return RestUpgradeRaw.all(url).post(payload).then( function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error);
            })
        }
        function getRemoteDiagStatus(id) {
            var url =  rLinkConstant.remoteDiagVCPS;
            url = url + '/' + id + rLinkConstant.remoteDiagStatus;
            return RestUpgradeRaw.one(url).get().then(function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }

        // setFavouriteRegion(string, string, object)
        // vin: url parameter
        // region: url parameter
        // parameters: request payload
        function setFavouriteRegion(vin, parameters) {
            var url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + '/ccs' + '/connected-services/' + 'favourite-region';
            return RestRLink
                .one(url)
                .customPUT(parameters)
                .then( function(response) {
                    return response;
                });
        }

        function synchronizeContract(vin, contractNumber) {
            var url = rLinkConstant.restATWS + rLinkConstant.vehc + vin + rLinkConstant.synchronizeContract + '/' + contractNumber;
            return RestRLink
                .one(url)
                .put()
                .then( function(response) {
                    return response;
                });
        }

        function forcePBO(vin) {
            var url = rLinkConstant.restATWS + rLinkConstant.vehc + vin + rLinkConstant.startPBO;
            return RestRLink
                .one(url)
                .put()
                .then( function(response) {
                    return response;
                });
        }

        function getListDiagnosis(lan, tag) {
            var req = baseReqNew.all(rLinkConstant.diagList);
            return executeRequest('list', req, lan, tag);
        }

        function getNextDiagnosis(idDiag, idStep, lan){
            var req = baseReqNew.one(rLinkConstant.diagList, idDiag).one(rLinkConstant.nodes, idStep);
            return executeRequest('get', req, lan);
        }

        function callRoutine(vin, routine, input, lan){
            var req = baseReqNew.one(rLinkConstant.diagRoutine,vin);
            if(input != null){
                req = req.one(input);
            }
            req = req.one(routine);
            return executeRequest('get', req, lan);
        }

        function getDiagHistory(vin, lan){
            var url = rLinkConstant.histoDiag + vin;
            var req = baseReqNew.several(rLinkConstant.histoDiag, vin);
            return executeRequest('list', req, lan);
        }

        function saveDiag(data, lan){
            var req = baseReqNew.all(rLinkConstant.histoDiag + '?language=' + lan).post(data);
            return executeRequest('save', req);
        }

        function applicabilityService(vin){
            var url = rLinkConstant.applicabilityService + vin + rLinkConstant.applicabilityServiceParams;
            var requestBody = {};
            return RestUpgradeRLink
                    .all(url)
                    .post(requestBody).then( function(response) {
                        return response;
                    }).catch( function() {
                        return $q.reject(error.data);
                    });
        }

        function diagCertificateInfo(vin){
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.certificatesDiagnostic;
            return RestUpgradeRaw.one(url).get().then(function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }

        function getCertificatesStatus(vin) {
            const url = rLinkConstant.certificateInfo + vin + rLinkConstant.certStatus;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status === 200) {
                     return response.data;
                }
            }).catch(function (error) {
                return $q.reject(error.data);
            })
        }

        function getCertificatesDiagnostic(vin){
            var url = rLinkConstant.certificateInfo + vin + rLinkConstant.partsInfo;
            return RestUpgrade.one(url).get().then(function(response) {
                return response;
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }

        function getV2gSubscription(vin) {
            const url = rLinkConstant.v2gSubscriptions + vin;
            return RestUpgradeRLink
                .one(url)
                .get()
                .then(function (response) {
                    return response && !_.isEmpty(response) ? response : null;
                })
                .catch(function (error) {
                    return $q.reject(error.data);
                });
        }


        function getVehicleSerialNumber(vin, isParamPresent){
            if(isParamPresent){
                var url = rLinkConstant.vehicleInfo + rLinkConstant.vehicle+'?vin='+vin+'&isRealtime='+isParamPresent;
            }
            else{
                var url = rLinkConstant.vehicleInfo + rLinkConstant.vehicle+'?vin='+vin;
            }
            return RestUpgradeRaw.one(url).get().then(function (response) {
                return response;
            })
            .catch(function (error) {
                return $q.reject(error);
            });
        }

        function getHereNaviSubscription(vin){
             const url = rLinkConstant.hereStatus +vin + rLinkConstant.hereSubscription;
            
            return RestUpgradeRaw.one(url).get().then(function (response) {
                return response;
            })
            .catch(function (error) {
                return $q.reject(error);
            });
        }

        function getHereNaviStatus(vin){
                const url = rLinkConstant.hereStatus +vin + rLinkConstant.remoteDiagStatus;
            
            return RestUpgradeRaw.one(url).get().then(function (response) {
                return response;
            })
            .catch(function (error) {
                return $q.reject(error);
            });
        }

        function getSimStatusData(vin){
            const url = rLinkConstant.simInfoUrl + vin;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                return response;
            })
            .catch(function (error) {
                return $q.reject(error);
            });
        }

        function patchSeriveSyncronization(vin){
            var url = rLinkConstant.certificateInfo + vin + rLinkConstant.partsSynchronization;
            return RestUpgradeRLink.one(url).patch().then(function (response) {
                    return response;
            })
            .catch(function (error) {
                return $q.reject(error);
            });
        }

        function getDelegation(vin){
            var url = rLinkConstant.restSmartCharge + rLinkConstant.vehc  + vin + rLinkConstant.delegation;
            return RestUpgradeRaw.one(url).get().then(function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }
        function getCalendar(vin){
            var url = rLinkConstant.restSmartCharge + rLinkConstant.vehc  + vin + rLinkConstant.calendar;
            return RestUpgradeRaw.one(url).get().then(function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }

        function getSoc(vin){
            var url = rLinkConstant.evManagerCalendar + vin + rLinkConstant.soc;
            return RestUpgradeRaw.one(url).get().then(function(response) {
                if(response && response.status == 200){
                    return response.data;
                }
            }).catch(function(error){
                return $q.reject(error.data);
            })
        }

        function evManagerCalendarInfo(vin) {
            var delegateUrl = rLinkConstant.evManagerCalendar + vin + rLinkConstant.delegation;
            var calendarUrl = rLinkConstant.evManagerCalendar + vin + rLinkConstant.calendar;
            var socUrl = rLinkConstant.evManagerCalendar + vin + rLinkConstant.soc;
        
            return RestUpgradeRaw.one(delegateUrl).get()
                .then(function(response) {
                    var delegationData = response.data;
                    var data = { isDelegated: delegationData };
        
                    // If delegation is activated, make other calls
                    if (delegationData && delegationData.activated) {
                        // catch individually so a calendar/soc failure doesn't discard the already-confirmed delegation status
                        var promise1 = RestUpgradeRaw.one(calendarUrl).get().catch(function () { return null; });
                        var promise2 = RestUpgradeRaw.one(socUrl).get().catch(function () { return null; });
        
                        // Wait for all promises to resolve
                        return $q.all([promise1, promise2])
                            .then(function(responses) {
                                data.calendarData = responses[0] ? responses[0].data : null;
                                data.socTarget = responses[1] ? responses[1].data : null;
                                return data;
                            });
                    }
                    return data;
                })
                .catch(function(error) {
                    return $q.reject(error.data);
                });
        }
        
        

        function executeRequest(type, req, lan, tag){
            if(req != null){
                var options = lan != null ? {"language":lan} : null;

                var tags = tag != null ? {"tag": tag} : null;

                var params = Object.assign({}, options, tags);

                var finalReq = null;
                switch(type){
                    case 'get' :
                         finalReq = req.get(options);
                        break;
                    case 'list' :
                        finalReq = req.getList(params);
                        break;
                    default :
                        finalReq = req;
                        break;
                }

                if(finalReq != null){
                    var defer = $q.defer();
                    finalReq.then(function (response) {
                        response = response.plain ? response.plain() : response;
                        defer.resolve(response);
                    }, function (error) {
                        defer.reject(error);
                    });
                    return defer.promise;
                }
            }
        }

        function getConnectedAdasEhorizonDetails(vin) {
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.adasEhorizon;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status == 200) {
                    return response.data;
                }
            }).catch(function (error) {
                return $q.reject(error.data);
            });
        }
        
        function launchInstallation(certificateType, vin) {
            var url = rLinkConstant.launchInstallation + vin + rLinkConstant.certificates + certificateType + '/repair';

            return RestUpgradeRaw
                .one(url)
                .post()
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    return $q.reject(error.data);
                });
        }

        function getRemoteCommandHistory(pagination, vin, startDate, endDate) {
            var queryParams = {
                page: pagination.page,
                pageSize: pagination.pageSize
            };
            if (startDate) {
                queryParams.startDate = startDate;
            }
            if (endDate) {
                queryParams.endDate = endDate;
            }
            var queryString = new URLSearchParams(queryParams).toString();
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.remoteCommandsHistory + '?' + queryString
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status == 200) {
                    return response.data;
                }
            }).catch(function (error) {
                return $q.reject(error);
            })
        }

        function getRemoteCommand(commandId) {
            var url = rLinkConstant.remoteCommand + commandId;
            return RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status == 200) {
                    return response.data;
                }
            }).catch(function (error) {
                return $q.reject(error.data);
            })
        }

        function refreshJwtConfig(vin) {
            var url = rLinkConstant.adasEhorizonExternalCall + vin + rLinkConstant.refreshJwtConfig;
            var requestBody = {};
            return RestUpgradeRaw.one(url).post(null,requestBody).then(function (response) {
                return response;

            }).catch(function (error) {
                return $q.reject(error.data);
            })
        }

        function getMapData(vin){
            const url = rLinkConstant.restATWSNew + rLinkConstant.vehc + vin + rLinkConstant.vehicleInformationLinkCCS + rLinkConstant.mapData;
            const defer = $q.defer();
            RestUpgradeRaw.one(url).get().then(function (response) {
                if (response && response.status === 200) {
                    defer.resolve(response.data);
                }
            }).catch(function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function lastSeenVehActivities(vin){
            var lastSeenVehActivitiesUrl = rLinkConstant.lastSeenVehActivities + vin + rLinkConstant.activities;
            return RestUpgradeRLink
                .one(lastSeenVehActivitiesUrl)
                .get().then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(error.data);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('phenix').service('RLinkCarUtils', RLinkCarUtilsServices);

    /** @ngInject */
    function RLinkCarUtilsServices(
        $translate,
        CacheService,
        CacheConstants,ActisConstantes
    ) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.getVin = getVin;
        vm.getLanguage = getLanguage;
        vm.getRegion = getRegion;
        vm.getUserId = getUserId;
        vm.resetAllCss = resetAllCss;
        vm.hasClass = hasClass;
        vm.addClass = addClass;
        vm.removeClass = removeClass;
        vm.resetThCss = resetThCss;
        vm.applyCss = applyCss;
        vm.sort = sort;
        vm.copyToClipboard = copyToClipboard;
        vm.formatText = formatText;
        vm.getMapMusStatus = getMapMusStatus;
        vm.getUserName = getUserName;
        vm.getUserIPN = getUserIPN;
        vm.getUserProfile = getUserProfile;
        vm.getUserInfo = getUserInfo;
        vm.isEligibleUser = isEligibleUser;
        vm.getConnectedPlatform = getConnectedPlatform;

        function getLanguage(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null && user.documentationFirstLanguage != null && user.documentationSecondLanguage){
                var firstLan = user.documentationFirstLanguage.code;
                var secondLan = user.documentationSecondLanguage.code;

                return firstLan + ',' + secondLan;
            }
        }

        function getRegion() {
            var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            if(connectedPlatform != null && connectedPlatform.region != null ) {
                return connectedPlatform.region;
            }
        }

        function getUserId(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null){
//                return user.ipn;
                return user.dealerId;
            }
        }

        function getVin(){
            return CacheService.getCarSearchContext().vehicle.vin;
        }

        function resetAllCss(id){
            for(var i = 1 ; i <= 10; i++){
                resetThCss(id+i);
            }
        }

        function hasClass(el, className){
            var flag = !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
            return flag;
        }

        function addClass(el, className){
            if (!hasClass(el, className))
                el.className += " " + className;
        }

        function removeClass(el, className){
            if (hasClass(el, className)){
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                el.className = el.className.replace(reg, ' ');
            }
        }

        function resetThCss(id){
            var el1 = document.getElementById(id);
            if(el1 != null){
                removeClass(el1, 'st-asc');
                removeClass(el1, 'st-des');
                addClass(el1, 'sort');
            }
        }

        function applyCss(id, des){
            var el1 = document.getElementById(id);
            if(el1 != null){
                addClass(el1, des ? 'st-des':'st-asc');
            }
        }

        function sort(id, key, sortHelp){
            sortHelp[id].reverse = !sortHelp[id].reverse;
            resetAllCss(key);
            var reverse = sortHelp[id].reverse ? '-':'+';
            var field = sortHelp[id].name;
            applyCss(key+id,sortHelp[id].reverse);

            return {field:field, reverse:reverse};
        }

        function copyToClipboard(id, data){
            var el = document.createElement('textarea');
            el.value = formatText(data);
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }

        function formatText(input){
            if(input != null){
                return input.split('\n').join('<br/>');
            }
        }

        function getMapMusStatus(val){
            switch(val){
                case 'EXPIRED' :
                    return $translate.instant('RLINKCAR_MAP_MUS_STATUS_EXPIRED');
                case 'TERMINATED' :
                    return $translate.instant('RLINKCAR_MAP_MUS_STATUS_TERMINATED');
                case 'SUSPENDED' :
                    return $translate.instant('RLINKCAR_MAP_MUS_STATUS_SUSPENDED');
                default :
                    return val;
            }
        }

        function getUserName(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null){
                return user.firstName + ' ' + user.lastName;
            }
        }

        function getUserIPN(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null){
                return user.ipn;
            }
        }

        function getUserProfile(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null){
                return user.profiles[0];
            }
        }

        function getUserInfo(){
            var name = getUserName();
            var ipn = getUserIPN();
            var profile = getUserProfile();
            return {name:name, ipn:ipn, profile:profile};
        }

        function getUserRoles(){
            var user = CacheService.getObject(CacheConstants.profil);
            if(user != null){
                return user.roles;
            }
        }

        function isEligibleUser(){
            var roles = getUserRoles();
            for(var i = 0; i < roles.length ; i++){
                var r = roles[i];
                if(r == ActisConstantes.ppx_assist_tech_n1 || r == ActisConstantes.ppx_assist_tech_n2){
                    return true;
                }
            }
            return false;
        }

        function getConnectedPlatform() {
            return CacheService.getObject(CacheConstants.connectedPlatform).platform.toLowerCase();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('RLinkCarMetierService', RLinkCarMetierService);

    /** @ngInject */
    function RLinkCarMetierService(
        CacheService,
        CacheConstants,
        CodesConstants,
        RLinkCarWSService,
        RLinkCarUtils,
        $q,
        CarSearchMetierService,
        configConstantes
    ){

        var adasTabDisplay = null;
        var evTabData = null;
        var hideHeader = false;
        const lastSeenVehActivitiesCacheByVin = {};
        const lastSeenVehActivitiesPendingByVin = {};
        this.getRlinkCarData = getRlinkCarData;
        this.getEasyLinkCarData = getEasyLinkCarData;
        this.getVehicleInformationDataCCS = getVehicleInformationDataCCS;
        this.getUpdateCampaignsCCS = getUpdateCampaignsCCS;
        this.startInventoryCampaign = startInventoryCampaign;
        this.patchUsageMode = patchUsageMode;
        this.getRemoteDiagData = getRemoteDiagData;
        this.checkId = checkId;
        this.getRemoteDiagStatus = getRemoteDiagStatus;
        this.getAllDiagnosis = getAllDiagnosis;
        this.getNextDiagnosis = getNextDiagnosis;
        this.getFeatureId = getFeatureId;
        this.setFavouriteRegion = setFavouriteRegion;
        this.synchronizeContract = synchronizeContract;
        this.forcePBO = forcePBO;
        this.callRoutine = callRoutine;
        this.getDiagHistory = getDiagHistory;
        this.saveDiag = saveDiag;
        this.applicabilityService = applicabilityService;
        this.diagCertificateInfo = diagCertificateInfo;
        this.getCertificatesDiagnostic = getCertificatesDiagnostic;
        this.getCertificatesStatus = getCertificatesStatus;
        this.getVehicleSerialNumber = getVehicleSerialNumber;
        this.patchSeriveSyncronization = patchSeriveSyncronization;
        this.getDelegation = getDelegation;
        this.getCalendar = getCalendar;
        this.getSoc = getSoc;
        this.isAuthorizedUser = isAuthorizedUser;
        this.updateRemoteDiagId = updateRemoteDiagId;
        this.updateRemoteDiagStatus = updateRemoteDiagStatus;
        this.getCurrentOffersSearchData = getCurrentOffersSearchData;
        this.restartSerialStartUsage = restartSerialStartUsage;
        this.evManagerCalendarInfo = evManagerCalendarInfo;
        this.launchInstallation = launchInstallation;
        this.getAdasData = getAdasData;
        this.setAdasData = setAdasData;
        this.provisioningRequest = provisioningRequest;
        this.getProvisioningRequestVehicles = getProvisioningRequestVehicles;
        this.getProvisioningRequests = getProvisioningRequests;
        this.getRemoteServices = getRemoteServices;
        this.refreshJwtConfig = refreshJwtConfig;
        this.getVirtualBlmsDetails = getVirtualBlmsDetails;
        this.getRefreshActivation = getRefreshActivation;
        this.getRights = getRights;
        this.getVirtualUserRolesDelegation = getVirtualUserRolesDelegation;
        this.getPrivacySettings = getPrivacySettings;
        this.setEvServicesTab = setEvServicesTab;
        this.getEvServicesTab = getEvServicesTab;
        this.deactivateService = deactivateService;
        this.getProvisioningRequestList = getProvisioningRequestList;
        this.getEvSettingsData = getEvSettingsData;
        this.getEvSettingsSoc = getEvSettingsSoc;
        this.getV2gSubscription = getV2gSubscription;
        this.getSimStatusData = getSimStatusData;
        this.getHereNaviStatus = getHereNaviStatus;
        this.getHereNaviSubscription = getHereNaviSubscription;
        this.getMapData = getMapData;
        this.lastSeenVehActivities = lastSeenVehActivities;

        this.setHideHeader = function(value) {
            hideHeader = value;
        };
        this.getHideHeader = function() {
            return hideHeader;
        };

        function setEvServicesTab(data){
             evTabData = data;
        }

        function getEvServicesTab() {
            return evTabData;
        }

        function getAdasData() {
            return adasTabDisplay
        }

        function setAdasData(data) {
            adasTabDisplay = data;
        }

        function setFavouriteRegion(parameters) {
            return RLinkCarWSService.setFavouriteRegion(RLinkCarUtils.getVin(), parameters).then(function (response) {
                return response;
            });
        }

        function getRlinkCarData() {
            return RLinkCarWSService.getRlinkCarData(RLinkCarUtils.getVin(), RLinkCarUtils.getLanguage()).then(function (response) {
                return response;
            });
        }

        function getVirtualBlmsDetails(){
            return RLinkCarWSService.getVirtualBlmsDetails(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function getRefreshActivation(){
            return RLinkCarWSService.getRefreshActivation(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }
        function getRights(){
            return RLinkCarWSService.getRights(RLinkCarUtils.getVin()).then(function (ressponse)
        {
            return ressponse;
        });
        }

        function getVirtualUserRolesDelegation(){
            return RLinkCarWSService.getVirtualUserRolesDelegation(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function getPrivacySettings(){
            return RLinkCarWSService.getPrivacySettings(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function provisioningRequest(payload){
            return RLinkCarWSService.provisioningRequest(payload).then(function (response) {
                return response;
            });
        }

        function getProvisioningRequestList(params){
            return RLinkCarWSService.getProvisioningRequestList(params).then(function (response) {
                return response;
            });
        }

        function getProvisioningRequestVehicles(vin){
            return RLinkCarWSService.getProvisioningRequestVehicles(vin).then(function (response) {
                return response;
            });
        }

        function getProvisioningRequests(reqId){
            return RLinkCarWSService.getProvisioningRequests(reqId).then(function (response){
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function restartSerialStartUsage(payload, vin){
            return RLinkCarWSService.restartSerialStartUsage(payload,vin).then(function (response) {
                return response;
            });
        }

        function getEasyLinkCarData() {
            return RLinkCarWSService.getEasyLinkCarData(RLinkCarUtils.getVin(), RLinkCarUtils.getRegion()).then(function (response) {
                return response;
            });
        }
        function getCurrentOffersSearchData(){
            var carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);   
            var payload = {
                vin: (carContextRequest && carContextRequest.vin) ? carContextRequest.vin : null
            }     
            return  RLinkCarWSService.getCurrentOffersSearchData(payload).then(function (response) {
                return response;
            })
        }

        function getVehicleInformationDataCCS() {
            if (JSON.parse(configConstantes.isNewContractService)) {
                return RLinkCarWSService.getVehicleInformationDataCCSNew(RLinkCarUtils.getVin()).then(function (response) {
                    return response;
                });
            } else {
                return RLinkCarWSService.getVehicleInformationDataCCS(RLinkCarUtils.getVin()).then(function (response) {
                    return response;
                });
            }
        }

        function getUpdateCampaignsCCS() {
            return RLinkCarWSService.getUpdateCampaignsCCS(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function startInventoryCampaign(payload) {
            return RLinkCarWSService.startInventoryCampaign(payload).then(function (response) {
                return response;
            });
        }

        function patchUsageMode(data){
            return RLinkCarWSService.patchUsageMode(data,RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function synchronizeContract(contractNumber) {
            return RLinkCarWSService.synchronizeContract(RLinkCarUtils.getVin(), contractNumber).then(function (response) {
                return response;
            });
        }

        function forcePBO() {
            return RLinkCarWSService.forcePBO(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        }

        function getAllDiagnosis() {
            return RLinkCarWSService.getListDiagnosis(RLinkCarUtils.getLanguage(), RLinkCarUtils.getConnectedPlatform()).then(function (response) {
                return response;
            });
        }

        function getNextDiagnosis(idDiag, idStep){
            return RLinkCarWSService.getNextDiagnosis(idDiag, idStep, RLinkCarUtils.getLanguage()).then(function (response) {
                return response;
            });
        }

        function callRoutine(routine, input){
            return RLinkCarWSService.callRoutine(RLinkCarUtils.getVin(), routine, input, RLinkCarUtils.getLanguage()).then(function (response) {
                return response;
            });
        }

        function deactivateService(data){
            return RLinkCarWSService.deactivateService(data).then(function (response) {
                return response;
            });
        }

        function getDiagHistory() {
            return RLinkCarWSService.getDiagHistory(RLinkCarUtils.getVin(), RLinkCarUtils.getLanguage()).then(function (response) {
                return response;
            });
        }

        function saveDiag(data){
            return RLinkCarWSService.saveDiag(data, RLinkCarUtils.getLanguage()).then(function (response) {
                return response;
            });
        }

        function applicabilityService(){
            return RLinkCarWSService.applicabilityService(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function diagCertificateInfo(){
            return RLinkCarWSService.diagCertificateInfo(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function evManagerCalendarInfo(){
            return RLinkCarWSService.evManagerCalendarInfo(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getCertificatesDiagnostic(){
            return RLinkCarWSService.getCertificatesDiagnostic(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getCertificatesStatus(){
            return RLinkCarWSService.getCertificatesStatus(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getV2gSubscription() {
            const vin = RLinkCarUtils.getVin();
            return RLinkCarWSService.getV2gSubscription(vin)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }


        function getVehicleSerialNumber(isParamPresent) {
            return RLinkCarWSService.getVehicleSerialNumber(RLinkCarUtils.getVin(), isParamPresent).then(function (response) {
                return response;
            }).catch(function () {
                return $q.reject();
            });

        }

        function getHereNaviSubscription(){
             return RLinkCarWSService.getHereNaviSubscription(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch(function () {
                return $q.reject();
            });
        }

        function getHereNaviStatus(){
            return RLinkCarWSService.getHereNaviStatus(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch(function () {
                return $q.reject();
            });
        }

        function getSimStatusData(){
            return RLinkCarWSService.getSimStatusData(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch(function () {
                return $q.reject();
            }); 
        }

        function patchSeriveSyncronization(){
            return RLinkCarWSService.patchSeriveSyncronization(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            });
        } 

        function getDelegation(){
            return RLinkCarWSService.getDelegation(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }
        function getCalendar(){
            return RLinkCarWSService.getCalendar(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getSoc(){
            return RLinkCarWSService.getSoc(RLinkCarUtils.getVin()).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function isAuthorizedUser() {

            // UPPERCASE IPN ONLY
            var arcaTesters = ['A184715', 'A007158', 'P102940', 'P108574', 'A023212'];
            var rnetTesters = ['ZZ01454', 'D168114', 'D118836'];
            var user = CacheService.getUserProfile();

            // ARCA
            var isARCAUser = (user && user.userType) ? user.userType.toUpperCase() === 'ARCA' : false;
            var isARCAAuthorized = (user && user.ipn) ? arcaTesters.indexOf(user.ipn.toUpperCase()) : -1;

            // RNET
            var isRNETUser = (user && user.userType) ? user.userType.toUpperCase() === 'RNET' : false;
            var isRNETAuthorized = (user && user.ipn) ? rnetTesters.indexOf(user.ipn.toUpperCase()) : -1;

            var isAuthorized = (isARCAUser && isARCAAuthorized !== -1) || (isRNETUser && isRNETAuthorized !== -1);
            return isAuthorized;
        }

        function checkId(vin){
            
            return RLinkCarWSService.checkId(vin).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }
        function getRemoteDiagData(vinNumber) {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var vin = (typeof vinNumber === 'undefined')
                ? ((contextCarRequest && contextCarRequest.vin) ? contextCarRequest.vin : null)
                : vinNumber;
            if (vin) {
                var payload = {
                    "vin": vin
                }
                return RLinkCarWSService.getRemoteDiagData(payload).then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject({
                        serviceId: 1,
                        response: error
                    });

                });
            }

        }

        function getRemoteDiagStatus(id) {
            
            return RLinkCarWSService.getRemoteDiagStatus(id).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getEvSettingsData(vin){
            return RLinkCarWSService.getEvSettingsData(vin).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getEvSettingsSoc(vin){ 
            return RLinkCarWSService.getEvSettingsSoc(vin).then(function (response) {
                return response;
            }).catch( function() {
                return $q.reject();
            });
        }

        function getFeatureId(vin) {
            return RLinkCarWSService.getFeatureId(vin).then(function (response) {
                return response;
            });
        }

        function updateRemoteDiagId(diagId, vehDataPrivacy, vinNumber) {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var vin = vinNumber || (contextCarRequest && contextCarRequest.vin) || null;

            if (!vin) return;

            function buildPayload(criterias) {
                return {
                    brand: criterias && criterias[CodesConstants.brand] ? criterias[CodesConstants.brand] : "",
                    bodyType: criterias && criterias[CodesConstants.bodyType] ? criterias[CodesConstants.bodyType] : "",
                    dataPrivacy: vehDataPrivacy || ""
                };
            }

            function handleUpdate(criterias) {
                var payload = buildPayload(criterias);
                return RLinkCarWSService.updateRemoteDiagId(vin, diagId, payload)
                    .then(function (response) {
                        return response;
                    })
                    .catch(function (error) {
                        return $q.reject({
                            serviceId: 2,
                            response: error
                        });
                    });
            }

            if (vinNumber) {
                return CarSearchMetierService.searchCar({ vin: vinNumber }, true)
                    .then(function (result) {
                        var criterias = result && result.carContext && result.carContext.fixedCriterias
                            ? result.carContext.fixedCriterias
                            : null;
                        return handleUpdate(criterias);
                    });
            } else {
                var vehicle = CacheService.getCarContext();
                var criterias = vehicle && vehicle.fixedCriterias ? vehicle.fixedCriterias : null;
                return handleUpdate(criterias);
            }
        }


        function updateRemoteDiagStatus(diagId,diagStatus,vinNumber) {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var vin = (typeof vinNumber === 'undefined')
                ? ((contextCarRequest && contextCarRequest.vin) ? contextCarRequest.vin : null)
                : vinNumber;
            if (vin) {
                return RLinkCarWSService.updateRemoteDiagStatus(vin, diagId, diagStatus).then(function (response) {
                    return response;
                }).catch(function (error) {
                    return $q.reject(
                        {
                            serviceId: 2,
                            response: error
                        }
                    );
                });
            }
        }

        function launchInstallation(certificateType) {
            var vin = RLinkCarUtils.getVin();

            return RLinkCarWSService.launchInstallation(certificateType, vin)
                .then(function (response) {
                    return response;
                });
        }  
        
        function getRemoteServices(pagination, startDate, endDate) {
            var vin = RLinkCarUtils.getVin();  
            var rsData = {
                commands: []
            };
        
            return RLinkCarWSService.getRemoteCommandHistory(pagination, vin, startDate, endDate)
                .then(function (response) {
                    rsData.totalCount = response.totalElements;
        
                    var commandPromises = response.data.map(function (item) {
                        return RLinkCarWSService.getRemoteCommand(item.vcpsCommandId)
                            .then(function (commandResponse) {
                                return commandResponse; 
                            })
                            .catch(function (error) {
                                return undefined;
                            });
                    });
        
                    return $q.all(commandPromises).then(function (commands) {
                        
                        rsData.commands = commands.filter(function(command) {
                            return command;
                        });
                        return rsData; 
                    });
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function refreshJwtConfig() {
            var vin = RLinkCarUtils.getVin();

            return RLinkCarWSService.refreshJwtConfig(vin)
                .then(function (response) {
                    return response;
                });
        }

        function getMapData(){
            const vin = RLinkCarUtils.getVin();
            return RLinkCarWSService.getMapData(vin)
                .then(function (response) {
                    return response;
                 }).catch(function (error) {
                    return $q.reject(error);
                 });
        }

        function lastSeenVehActivities(vin){
            if (!vin) {
                return $q.when(null);
            }

            if (lastSeenVehActivitiesCacheByVin[vin]) {
                return $q.when(lastSeenVehActivitiesCacheByVin[vin]);
            }

            if (lastSeenVehActivitiesPendingByVin[vin]) {
                return lastSeenVehActivitiesPendingByVin[vin];
            }

            lastSeenVehActivitiesPendingByVin[vin] = RLinkCarWSService.lastSeenVehActivities(vin)
                .then(function (response) {
                    lastSeenVehActivitiesCacheByVin[vin] = response;
                    return response;
                }).catch(function () {
                    return $q.reject();
                }).finally(function () {
                    delete lastSeenVehActivitiesPendingByVin[vin];
                });

            return lastSeenVehActivitiesPendingByVin[vin];
        }  
 
    }

})();

/**
 * Restarting Services Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('RestartingServicesCtrl', RestartingServicesCtrl);

    /* @ngInject */
    function RestartingServicesCtrl(RLinkCarMetierService, $mdDialog, $translate,blockUI,toastr,FileSaver,printPdfModalService,$log,PDFViewService, $q,CacheService,CacheConstants,configConstantes,RLinkCarWSService,rLinkConstant) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.getVin = getVin;
        vm.contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
        vm.close = close;
        vm.onValidate = onValidate;
        vm.removeTextAreaColors = removeTextAreaColors;
        vm.radioButtonChange = radioButtonChange;
        vm.downloadBatteryCrashPdf = downloadBatteryCrashPdf;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.today = new Date();
        vm.enableFiveDaysFromToday = 5;
        vm.minDate = new Date(vm.today.getFullYear()-1,vm.today.getMonth(),vm.today.getDate());
        vm.maxDate = new Date(vm.today.getFullYear(),vm.today.getMonth(),vm.today.getDate() + vm.enableFiveDaysFromToday);
        init();
        var pictoImage ={
                    "RENAULT": { src: convertImgToBase64("/assets/svg/renault.svg", "RENAULT") },
                    "RENAULTGROUP": { src: convertImgToBase64("/assets/images/renaultgroup.png", "RENAULTGROUP") },
                    "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")},
                    "DACIA": { src: convertImgToBase64("/assets/svg/dacia.svg", "DACIA") },
                    "ALPINE": { src: convertImgToBase64("/assets/svg/alpine.svg", "ALPINE") },

        };
        
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function init() {
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
            if (carContext && !_.isEmpty(carContext.brandComputed) && (carContext.brandComputed == "APL03" || carContext.brandComputed == "BRA03")) {
                vm.logoClicked = "Renault"
            }
            else if (carContext && !_.isEmpty(carContext.brandComputed) && (carContext.brandComputed == "APL18" || carContext.brandComputed == "BRA18")) {
                vm.logoClicked = "Alpine"
            }
            else if (carContext && !_.isEmpty(carContext.brandComputed) && (carContext.brandComputed == "APL05" || carContext.brandComputed == "BRA05")) {
                vm.logoClicked = "Dacia"
            }
            else {
                vm.logoClicked = "Renault"
            }
            vm.dealerName = !_.isEmpty(vm.userInfo) && !_.isEmpty(vm.userInfo.userContext) ? vm.userInfo.userContext.siteName : '';
            vm.dealerId = !_.isEmpty(vm.userInfo) && !_.isEmpty(vm.userInfo.userContext) ? vm.userInfo.userContext.siteSourceId : '';

            vm.custFirstName = !_.isEmpty(vm.dmsCustInfo) && !_.isEmpty(vm.dmsCustInfo.firstName) ? vm.dmsCustInfo.firstName : '';
            vm.custLastName = !_.isEmpty(vm.dmsCustInfo) && !_.isEmpty(vm.dmsCustInfo.name) ? vm.dmsCustInfo.name : '';
            vm.custZipCode = !_.isEmpty(vm.dmsCustInfo) && !_.isEmpty(vm.dmsCustInfo.postCode) ? vm.dmsCustInfo.postCode : '';
            vm.custCity = !_.isEmpty(vm.dmsCustInfo) && !_.isEmpty(vm.dmsCustInfo.city) ? vm.dmsCustInfo.city : '';
            vm.customerAddress = !_.isEmpty(vm.dmsCustInfo) && !_.isEmpty(vm.dmsCustInfo.streetNumber) ? (vm.dmsCustInfo.streetNumber + " " + vm.dmsCustInfo.streetName) : '';  
            vm.vehicleImat = !_.isEmpty(vm.registrationNumber) ? vm.registrationNumber : '';
            vm.vehicleRO = !_.isEmpty(vm.orNumber) ? vm.orNumber : '';
            //Changes to be kept for CNR - Start date must correspond to the customer delivery date
            // vm.startDate = vm.contextCarRequest.bvmExtraFields.customerDeliveryDate ? vm.contextCarRequest.bvmExtraFields.customerDeliveryDate : !_.isEmpty(vm.startDate) ? moment(vm.startDate).toISOString() : '';
            vm.startDate = !_.isEmpty(vm.startDate) ? moment(vm.startDate).toISOString() : '';
            if(vm.isBatteryCrash){
                vm.startDateBattery = moment(vm.today).format("YYYY-MM-DD");
                vm.statusClicked = vm.batteryStatus;            }
            var batteryDetails = CacheService.getObject(CacheConstants.batteryCrashPrintData);
            if(vm.isBatteryCrash && batteryDetails && !_.isEmpty(batteryDetails)){
                vm.vin = batteryDetails.vin;
                vm.bin = batteryDetails.bin;
                vm.vehicleImat = batteryDetails.registrationNumber;
                vm.vehicleRO = batteryDetails.orNumber;
                vm.statusClicked = batteryDetails.batteryStatus;
                vm.dealerName = batteryDetails.dealerName;
                vm.dealerId = batteryDetails.dealerId;
                vm.dealerAddress = batteryDetails.dealerAddress;
                vm.dealerZipCode = batteryDetails.dealerZipCode;
                vm.dealerCity = batteryDetails.dealerCity;
                vm.custFirstName = batteryDetails.custFirstName;
                vm.custLastName = batteryDetails.custLastName;
                vm.customerAddress = batteryDetails.customerAddress;
                vm.custZipCode = batteryDetails.custZipCode;
                vm.custCity = batteryDetails.custCity;
                vm.startDateBattery = batteryDetails.date ? batteryDetails.date : vm.today;
            }
        }
        function radioButtonChange(logoName) {
            vm.logoClicked = logoName;
        }
        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }
        function getVin(val) {
            vm.vin = val;
        }

        function close() {
            saveAllPrintConsentData();
            $mdDialog.hide();
        }
        function saveAllPrintConsentData(){
            var printConsentData = {
                vin: vm.vin,
                bin: vm.bin,
                registrationNumber: vm.vehicleImat,
                orNumber: vm.vehicleRO,
                date: vm.startDateBattery,
                batteryStatus: vm.statusClicked,
                dealerName: vm.dealerName,
                dealerId: vm.dealerId,
                dealerAddress: vm.dealerAddress,
                dealerZipCode: vm.dealerZipCode,
                dealerCity: vm.dealerCity,
                custFirstName: vm.custFirstName,
                custLastName: vm.custLastName,
                customerAddress: vm.customerAddress,
                custZipCode: vm.custZipCode,
                custCity: vm.custCity
            }
            CacheService.setObject(CacheConstants.batteryCrashPrintData, printConsentData);
        }
        function formValidation(allFieldsFilled) {
            var isFormValid = false;
            var invalidFields;
            invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, ng-invalid"));
            if (invalidFields && invalidFields.length == 0) {
                isFormValid = true;
            } else {
                isFormValid = false;
            }
            var itemObject = {};
            itemObject['isFormValid'] = isFormValid;
            itemObject['invalidFields'] = invalidFields;
            return itemObject;
        }

        /**
         * @description Used to color the mandatory fields while sending a FIC
        */
        function colorMandatoryFields() {
            if (vm.requiredFields && vm.requiredFields.length) {
                var reqFields = Array.prototype.slice.call(vm.requiredFields);
                reqFields.forEach(function (item) {
                    var element = angular.element(item);
                    if (element[0].tagName === 'TEXTAREA') {
                        var label = $(element).parent().parent().children().first();
                        var e = angular.element(label);
                        e.addClass('changeTextColorToRed');
                        var parent = $(element).parent().parent();
                        parent.addClass('md-input-invalid');
                    } else if (element[0].tagName === 'INPUT' || element[0].tagName === 'MD-DATEPICKER') {
                        var label = $(element).parent();
                        var first = $(label).children().first();
                        var e = angular.element(first);
                        e.addClass('changeTextColorToRed');
                        label.addClass('md-input-invalid');
                    }
                    if (element[0].tagName === 'TEXTAREA' || element[0].tagName === 'INPUT') {
                        element.addClass('backgroundColorRequiredFields');
                    }
                })
            }
        }
        /**
         * @description Used to remove css when the field is populated
         * @param {*} elementName 
         */
        function removeTextAreaColors(elementName) {
            var element;
            if (elementName === 'vin') {
                element = document.getElementById("vin");
            } else if (elementName === 'dealerShipName') {
                element = document.getElementById("dealerShipName");
            }
            else if (elementName === 'dealerId') {
                element = document.getElementById("dealerId");
            }
            else if (elementName === 'dealerAddress') {
                element = document.getElementById("dealerAddress");
            }
            else if (elementName === 'dealerZipCode') {
                element = document.getElementById("dealerZipCode");
            }
            else if (elementName === 'dealerCity') {
                element = document.getElementById("dealerCity");
            }
            else if (elementName === 'custFirstName') {
                element = document.getElementById("custFirstName");
            }
            else if (elementName === 'custLastName') {
                element = document.getElementById("custLastName");
            }
            else if (elementName === 'custAddress') {
                element = document.getElementById("custAddress");
            }
            else if (elementName === 'custZipCode') {
                element = document.getElementById("custZipCode");
            }
            else if (elementName === 'custCity') {
                element = document.getElementById("custCity");
            } 
            else if (elementName === 'vehicleBin') {
                element = document.getElementById("vehicleBin");
            }
            else if (elementName === 'vehicleImat') {
                element = document.getElementById("vehicleImat");
            }
            else if (elementName === 'vehicleRO') {
                element = document.getElementById("vehicleRO");
            }
            var elem = angular.element(element);
            $(elem).removeClass('backgroundColorRequiredFields');
            $(elem).removeClass('changeTextColorToRed');
            var label = $(element).parent().parent().children().first();
            var e = angular.element(label);
            e.removeClass('changeTextColorToRed');
            var parent = $(element).parent().parent();
            parent.removeClass('md-input-invalid');
        }

        function onValidate(vin,display){
            if(vm.isBatteryCrash){
                saveAllPrintConsentData();
                if(vm.vin && vm.bin && vm.vehicleImat && vm.vehicleRO && vm.dealerName && vm.dealerId && vm.dealerAddress && vm.dealerZipCode && vm.dealerCity && vm.custFirstName && vm.custLastName && vm.customerAddress && vm.custZipCode && vm.custCity && vm.startDateBattery){
                    vm.allFieldsFilled = true;
                }
                else{
                    vm.allFieldsFilled = false;
                }
                var responseFormValidation = formValidation(vm.allFieldsFilled);
                vm.isFormValid = responseFormValidation.isFormValid;
                vm.requiredFields = responseFormValidation.invalidFields;
                if(vm.allFieldsFilled){
                    downloadBatteryCrashPdf(vm.printConsent,vm.startDateBattery);
                } else {
                    toastr.error($translate.instant("COMMON_ERROR_MISSING_MANDATORY_DATA"));
                    colorMandatoryFields();
                }
            } else {
                if(vm.vin && vm.dealerName && vm.dealerId && vm.dealerAddress && vm.dealerZipCode && vm.dealerCity && vm.custFirstName && vm.custLastName && vm.customerAddress && vm.custZipCode && vm.custCity && vm.startDate){
                    vm.allFieldsFilled = true;
                }
                else {
                    vm.allFieldsFilled = false;
                }
                var responseFormValidation = formValidation(vm.allFieldsFilled);
                vm.isFormValid = responseFormValidation.isFormValid;
                vm.requiredFields = responseFormValidation.invalidFields;    
                var startDateFormat = vm.startDate ? moment(vm.startDate).toISOString() : '';
                if(vm.allFieldsFilled){
                    var payload = {
                        startUsageDateTime: startDateFormat
                    };
                    blockUI.start();
                    RLinkCarMetierService.restartSerialStartUsage(payload, vin).then(function (response) {
                        toastr.success($translate.instant('SUBSCRIPTION_SUCCESS_TOASTER'));
                        restartServices(display, vm.startDate);
                    }).catch(function (error) {
                        if(error && !_.isEmpty(error.errors)){
                            if((error.errors[0].errorCode == 'SERIAL_SUBSCRIPTION_STILL_CONFIRMED') || (error.errors[0].errorCode == 'NO_SERIAL_SUBSCRIPTION_FOUND') || (error.errors[0].errorCode == 'INCOMPATIBLE_STATUS')){
                                toastr.error($translate.instant("NO_SERIAL_SUBSCRIPTION_FOUND"));
                            }
                            else if((error.errors[0].errorCode == 'MAX_NUMBER_REACHED')){
                                toastr.error($translate.instant("MAX_NUMBER_REACHED"));
                            }
                            else if((error.errors[0].errorCode == 'INVALID_DATE')){
                                toastr.error($translate.instant("INVALID_DATE"));
                            }
                            else{
                                toastr.error($translate.instant("NO_SERIAL_SUBSCRIPTION_FOUND"));
                            }
                        }
                    }).finally(function(){
                        $mdDialog.hide();
                        blockUI.stop();
                    });
                }
                else if(!vm.allFieldsFilled && !display){
                    if(vm.vin && vm.dealerName && vm.dealerId && vm.dealerAddress && vm.dealerZipCode && vm.dealerCity && vm.custFirstName && vm.custLastName && vm.customerAddress && vm.custZipCode){
                        restartServices(display, vm.startDate);
                    }
                    else{
                        toastr.error($translate.instant("COMMON_ERROR_MISSING_MANDATORY_DATA"));
                        colorMandatoryFields();
                    }                    
                }
                else{
                    toastr.error($translate.instant("COMMON_ERROR_MISSING_MANDATORY_DATA"));
                    colorMandatoryFields();
                }
            }
        }
        
        function restartServices(display, startDate){
            
                    
                        downloadPdf(display, startDate).then(function(response){                
                            pdfMake.tableLayouts = {
                                    otherTableLayout: {
                                        hLineWidth: function () {
                                            return 1;
                                        },
                                        vLineWidth: function () {
                                            return 1;
                                        }
                                    }
                                };
                            var pdfDocGenerator = pdfMake.createPdf(response.data);
                            pdfDocGenerator.getBuffer(function (buffer) {
                                var file = new Blob([(buffer)], { type: 'application/pdf' });
                                var isIE = false || !!document.documentMode;
                                var isEdge = !isIE && !!window.StyleMedia;
                                    if (isIE || isEdge) { 
                                        FileSaver.saveAs(file, $translate.instant("HEADER_DOCUMENT_ASSISTANCE")+'-'+vm.vin);
                                    }else {             
                                        printPdfModalService.encode64Base(file).then(function (response) {
                                            var modalParams = {
                                                data: response
                                            }                                    
                                            return printPdfModalService.showModal(modalParams).catch(function () {
                                                $log.debug($translate.instant('ERROR'));
                                            });
                                        }).catch(function () {
                                            toastr.error($translate.instant('ERROR'));
                                        });
                                    }
                            })
                        });
                
        
        }
        function downloadPdf(display, startDate) {
            var cartToPrint = { 
                translatedLabels: {
                    emptyLabel: '',
                    connectedServicesTC: $translate.instant("CONNECTED_SERVICES_TC"),
                    connectedServicesTCGeneral: $translate.instant("CONNECTED_SERVICES_TC_GENERAL"),
                    connectedServicesConsult: $translate.instant("CONNECTED_SERVICES_CONSULT"),
                    connectedServicesConsultDacia: $translate.instant("CONNECTED_SERVICES_CONSULT_DACIA"),
                    connectedServicesConsultAlpine: $translate.instant("CONNECTED_SERVICES_CONSULT_ALPINE"),
                    mobileNetworkMention: $translate.instant("CONNECTED_SERVICES_MOBILE_NETWORK_MENTION"),
                    customerSign: $translate.instant("CUSTOMER_SIGN"),
                    listHeader: $translate.instant("LABEL_NAME_PACK"),
                    dateLabel: $translate.instant("RLINKCAR_DIAG_HISTO_DATE"),
                    durationLabel: $translate.instant("DURATION_IN_MONTHS"),
                }
            };            
            return formatDataToPrint(cartToPrint,display, startDate);
        }
        function formatDataToPrint(data,display, startDate) {

            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            var imgObj = null;
            var hasEmergencyCallLifetime = false;

            function isEmergencyCallService(item) {
                return rLinkConstant.emergencyCallServiceIds.indexOf(String(item.genericOfferId)) !== -1;
            }

            if (vm.logoClicked == "Renault") {
                var valuesObj = {
                    1: [vm.dealerName + '' + (vm.dealerAddress ? ('\n' + vm.dealerAddress + '\n') : '') + '' + (vm.dealerZipCode ? vm.dealerZipCode + (vm.dealerCity ? ' / ' + vm.dealerCity + '\n' : '') : '') + '' + (vm.dealerId ? vm.dealerId : '')]
                };
                if (!vm.nissanUserURL) {
                    valuesObj[0] = [pictoImage.RENAULT.value];
                }
                imgObj = {
                    type: "imageColumns",
                    values: valuesObj,
                    styles: "textStyle"
                };

            }
            else if (vm.logoClicked == "Alpine") { 
                 var valuesObj = {
                    1: [vm.dealerName + '' + (vm.dealerAddress ? ('\n' + vm.dealerAddress + '\n') : '') + '' + (vm.dealerZipCode ? vm.dealerZipCode + (vm.dealerCity ? ' / ' + vm.dealerCity + '\n' : '') : '') + '' + (vm.dealerId ? vm.dealerId : '')]
                };
                if (!vm.nissanUserURL) {
                    valuesObj[0] = [pictoImage.ALPINE.value];
                }
                imgObj = {
                    type: "imageColumns",
                    values: valuesObj,
                    styles: "textStyle"
                };            
            }
            else if (vm.logoClicked == "Dacia") { 
                var valuesObj = {
                    1: [vm.dealerName + '' + (vm.dealerAddress ? ('\n' + vm.dealerAddress + '\n') : '') + '' + (vm.dealerZipCode ? vm.dealerZipCode + (vm.dealerCity ? ' / ' + vm.dealerCity + '\n' : '') : '') + '' + (vm.dealerId ? vm.dealerId : '')]
                };
                if (!vm.nissanUserURL) {
                    valuesObj[0] = [pictoImage.DACIA.value];
                }
                imgObj = {
                    type: "imageColumns",
                    values: valuesObj,
                    styles: "textStyle"
                };          
            }

            if(imgObj.values && imgObj.values[0]){
                dataArray.push(imgObj);
            }

            var custName = { type: "text", values:vm.custLastName + ((vm.custLastName && vm.custFirstName)?' - ':'') + vm.custFirstName, styles: "textAddStyle" };
            dataArray.push(custName);

            if(vm.customerAddress){
                var streetNumber = { type: "text", values:vm.customerAddress, styles: "textAddStyle" };
                dataArray.push(streetNumber);
            }

            if(vm.custZipCode || vm.custCity){
                var cityZip = { type: "text", values:vm.custCity + ((vm.custCity && vm.custZipCode)? ' , ':'') + vm.custZipCode, styles: "textAddStyle" };
                dataArray.push(cityZip);
            }
            
            if(vm.vin){
                var vinNumber = { type: "text", values:vm.vin, styles: "textAddStyle" };
                dataArray.push(vinNumber);
            }
            
            var connectedServiceTC = { type: "text", values:data.translatedLabels.connectedServicesTC, styles: "textStyle" };

            dataArray.push(connectedServiceTC);

            var connectedServiceTCgeneral = { type: "text", values: data.translatedLabels.connectedServicesTCGeneral , styles: "textPlainStyle" };
            
            dataArray.push(connectedServiceTCgeneral);
            if(!_.isEmpty(vm.newOfferList)){
                var firstTable = [];
                firstTable = _.filter(vm.newOfferList, function(item){
                    return ((item.status == 'ACTIVE' || item.status == 'CONFIRMED') && !_.isEmpty(item.distributionChannel))
                });
                var filteredData = firstTable.map(function (item) {
                    var tableData = [];               
                    var displayAsterisk = isEmergencyCallService(item);
                    var currentOffer = _.find(vm.offerList, function (offer) {
                        return offer.subscriptionId === item.subscriptionId;
                    });
                    var currentOfferDuration = currentOffer && currentOffer.isVehicleLifetime
                        ? currentOffer.duration
                        : item.duration;
                    var duration = displayAsterisk
                        ? $translate.instant("VEHICLE_LIFETIME_WITHOUT_ASTERISK")
                        : (currentOfferDuration === null || currentOfferDuration === undefined || currentOfferDuration === 'null'
                            ? '---'
                            : currentOfferDuration);
                
                    tableData[data.translatedLabels.listHeader] =
                    {
                        data: item.name,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.durationLabel] =
                    {
                        data: duration + (displayAsterisk ? ' *' : ''),
                        alignment: "center"
                    };
                    if (displayAsterisk) {
                        hasEmergencyCallLifetime = true;
                    }
                    return tableData;
                })                
                var thirdObj = {};
                thirdObj = {
                    type: "table", values: PDFViewService.getTableData(filteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: [300,150]
                };                
                dataArray.push(thirdObj);
            }

            if (vm.logoClicked == "Renault") {
                var connectedServicesConsult = { type: "text", values: data.translatedLabels.connectedServicesConsult, styles: "textPlainStyle" };

                dataArray.push(connectedServicesConsult);
            }
            else if (vm.logoClicked == "Alpine") {
                var connectedServicesConsult = { type: "text", values: data.translatedLabels.connectedServicesConsultAlpine, styles: "textPlainStyle" };

                dataArray.push(connectedServicesConsult);                
            }
            else if (vm.logoClicked == "Dacia") {
                var connectedServicesConsult = { type: "text", values: data.translatedLabels.connectedServicesConsultDacia, styles: "textPlainStyle" };

                dataArray.push(connectedServicesConsult);
            }

            if (hasEmergencyCallLifetime) {
                var mobileNetworkMention = { type: "text", values: data.translatedLabels.mobileNetworkMention, styles: "textPlainStyle" };
                dataArray.push(mobileNetworkMention);
            }

            var customerSign = { type: "text", values:data.translatedLabels.customerSign +' :', styles: "textPlainStyle" };

            dataArray.push(customerSign);

            var dateLabel = { type: "text", values:data.translatedLabels.dateLabel+' :', styles: "textPlainStyle" };

            dataArray.push(dateLabel);  
                             
            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,false,false,false);
            var cacheProfile = CacheService.getObject(CacheConstants.profil);
            var countryCode = cacheProfile.country;

            var docDefinition = {
                info: {
                    title: $translate.instant("HEADER_DOCUMENT_ASSISTANCE")+'-'+vm.vin,
                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 20, 30, 10],
                        alignment: "left",
                        fontSize: 12,
                        bold: true
                    },
                    custTextStyle: {
                        margin: [0, 20, 10, 10],
                        alignment: "left",
                        fontSize: 12
                    },
                    textAddStyle: {
                        margin: [0, 0, 0, 3],
                        alignment: "left",
                        fontSize: 10,
                        bold: false
                    },
                    textPlainStyle:{
                        margin: [0, 0, 30,10],
                        alignment: "left",
                        fontSize: 10,
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [0, 5, 20, 20]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8
                    }
                }
            };

            if(countryCode.toLowerCase()==='fr'){
                docDefinition.footer = {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        }
                    ]
                }
            }

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }
        function downloadBatteryCrashPdf(pdfType,startDate){
            downloadPdfPostCrashInfo(pdfType,startDate).then(function(response){
              pdfMake.tableLayouts = {
                    secondTableLayout: {
                        hLineWidth: function () { return 0.5; },
                        vLineWidth: function () { return 0.5; },
                    },
                    thirdTableLayout: {
                        hLineWidth: function () { return 0.5; },
                        vLineWidth: function () { return 0.5; },
                    },
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });
                    var isIE = false || !!document.documentMode;
                    var isEdge = !isIE && !!window.StyleMedia;
                        if (isIE || isEdge) { 
                            FileSaver.saveAs(file, "Battery Post-Crash Information.pdf");
                        }else {             
                            printPdfModalService.encode64Base(file).then(function (response) {
                                var modalParams = {
                                    data: response
                                }                                    
                                return printPdfModalService.showModal(modalParams).catch(function () {
                                    $log.debug($translate.instant('ERROR'));
                                 });
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                })
            });

        }
        function downloadPdfPostCrashInfo(pdfType, startDate) {
            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            var carSplitsDateLabel = $translate.instant('CAR_SPLITS_DATE');
            carSplitsDateLabel = carSplitsDateLabel.charAt(0).toUpperCase() + carSplitsDateLabel.slice(1).toLowerCase();
            var profil = CacheService.getObject(CacheConstants.profil);

            if (pdfType === 'print') {
                var printTitle = [
                    {
                        column1: {
                            data: $translate.instant("PRINT_TITLE_ONE")
                        }
                    }
                ]
                var thirdObj = {
                    type: "table", values: getTableData(printTitle, false), styles: "tableStyleHeaderPrint",
                    layout: "secondTableLayout", widths: [490]
                };
                dataArray.push(thirdObj);

                var printBoldTitle = [
                    {
                        column1: {
                            data: $translate.instant("PRINT_TITLE_BOLD")
                        }
                    }
                ]
                var boldObj = {
                    type: "table", values: getTableData(printBoldTitle, false), styles: "tableStyleHeader",
                    layout: "secondTableLayout", widths: [490]
                };
                dataArray.push(boldObj);

                if (vm.statusClicked === "OK") {
                    var printSubTitle = [
                        {
                            column1: {
                                data:
                                    '\u2022 ' + $translate.instant("PRINT_SUBTITLE_ONE") + '\n' +
                                    '\u2022 ' + $translate.instant("PRINT_SUBTITLE_TWO"),
                                alignment: "left",
                                font: 'Courier'
                            }
                        }
                    ];
                    var subTitleObj = {
                        type: "table",
                        values: getTableData(printSubTitle, false),
                        styles: "tableStyle",
                        layout: "secondTableLayout",
                        widths: [490],
                        margin: [0, 0, 0, 0]
                    };
                    dataArray.push(subTitleObj);

                    var firstTable = [
                        {
                            column1: {
                                data: [
                                    { text: $translate.instant('PRINT_CUSTOMER_TITLE') + '\n' ,bold: true},
                                    {
                                        text: (vm.custFirstName ? vm.custFirstName + ' ' : '') +
                                            (vm.custLastName ? vm.custLastName : '') + '\n' +
                                            (vm.customerAddress ? vm.customerAddress : '') + '\n' +
                                            (vm.custZipCode ? vm.custZipCode : '') + '\n' +
                                            (vm.custCity ? vm.custCity : ''), bold: false
                                    }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: $translate.instant('CONSENT_WORKSHOP_NUMBER') + '\n',bold: true },
                                    {
                                        text: (vm.dealerName ? vm.dealerName : '') + '\n' +
                                            (vm.dealerId ? vm.dealerId : '') + '\n' +
                                            (vm.dealerAddress ? vm.dealerAddress : '') + '\n' +
                                            (vm.dealerZipCode ? vm.dealerZipCode : '') + '\n' +
                                            (vm.dealerCity ? vm.dealerCity : ''), bold: false
                                    }
                                ],
                                alignment: "left"
                            }
                        },
                        {
                            column1: {
                                data: [
                                    { text: $translate.instant('ACTIS_VEHICLE_IMMAT') + ': ', bold: true },
                                    { text: (vm.vehicleImat ? vm.vehicleImat : ''), bold: false }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: 'BIN: ', bold: true },
                                    { text: (vm.bin ? vm.bin : ''), bold: false }
                                ],
                                alignment: "left"
                            }
                        },
                        {
                            column1: {
                                data: [
                                    { text: 'VIN: ', bold: true },
                                    { text: (vm.vin ? vm.vin : ''), bold: false }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: $translate.instant('PRINT_DIAGNOSTIC_DATE'), bold: true },
                                    { text: (vm.reuseFlagDate ? moment(vm.reuseFlagDate).format("YYYY-MM-DD") : ''), bold: false }
                                ],
                                alignment: "left"
                            }
                        },
                    ];

                    var firstObj = {
                        type: "table",
                        values: getTableData(firstTable, false),
                        styles: "secondTableHeader",
                        layout: "secondTableLayout",
                        widths: [240, 240],
                        margin: [0, 20, 0, 0]
                    };

                    dataArray.push(firstObj);



                    var bottomContent1 = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_OK_ONE'),
                        styles: "centeredText"
                    };
                    dataArray.push(bottomContent1);

                    var bottemContent2 = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_OK_TWO'),
                        styles: "centeredText"
                    };
                    dataArray.push(bottemContent2);

                    var boldSubContentTitle = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_OK_BOLDTEXT'),
                        styles: "boldLeftAlignedText"
                    };
                    dataArray.push(boldSubContentTitle);

                    var lastContent = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_OK_BOTTOMTEXT'),
                        styles: "centeredTextPrint"
                    };
                    dataArray.push(lastContent);


                } else if (vm.statusClicked === "KO") {
                     var printSubTitle = [
                        {
                            column1: {
                                data:
                                    '\u2022 ' + $translate.instant("PRINT_SUBTITLE_ONE") + '\n' +
                                    '\u2022 ' + $translate.instant("PRINT_SUBTITLE_TWO"),
                                alignment: "left",
                                font: 'Courier'
                            }
                        }
                    ];
                    var subTitleObj = {
                        type: "table",
                        values: getTableData(printSubTitle, false),
                        styles: "tableStyle",
                        layout: "secondTableLayout",
                        widths: [490],
                        margin: [0, 0, 0, 0]
                    };
                    dataArray.push(subTitleObj);

                    var firstTable = [
                        {
                            column1: {
                                data: [
                                    { text: $translate.instant('PRINT_CUSTOMER_TITLE') + '\n' ,bold: true},
                                    {
                                        text: (vm.custFirstName ? vm.custFirstName + ' ' : '') +
                                            (vm.custLastName ? vm.custLastName : '') + '\n' +
                                            (vm.customerAddress ? vm.customerAddress : '') + '\n' +
                                            (vm.custZipCode ? vm.custZipCode : '') + '\n' +
                                            (vm.custCity ? vm.custCity : ''), bold: false
                                    }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: $translate.instant('CONSENT_WORKSHOP_NUMBER') + '\n',bold: true },
                                    {
                                        text: (vm.dealerName ? vm.dealerName : '') + '\n' +
                                            (vm.dealerId ? vm.dealerId : '') + '\n' +
                                            (vm.dealerAddress ? vm.dealerAddress : '') + '\n' +
                                            (vm.dealerZipCode ? vm.dealerZipCode : '') + '\n' +
                                            (vm.dealerCity ? vm.dealerCity : ''), bold: false
                                    }
                                ],
                                alignment: "left"
                            }
                        },
                        {
                            column1: {
                                data: [
                                    { text: $translate.instant('ACTIS_VEHICLE_IMMAT') + ': ', bold: true },
                                    { text: (vm.vehicleImat ? vm.vehicleImat : ''), bold: false }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: 'BIN: ', bold: true },
                                    { text: (vm.bin ? vm.bin : ''), bold: false }
                                ],
                                alignment: "left"
                            }
                        },
                        {
                            column1: {
                                data: [
                                    { text: 'VIN: ', bold: true },
                                    { text: (vm.vin ? vm.vin : ''), bold: false }
                                ],
                                alignment: "left"
                            },
                            column2: {
                                data: [
                                    { text: $translate.instant('PRINT_DIAGNOSTIC_DATE'), bold: true },
                                    { text: (vm.reuseFlagDate ? moment(vm.reuseFlagDate).format("YYYY-MM-DD") : ''), bold: false }
                                ],
                                alignment: "left"
                            }
                        },
                    ];

                    var firstObj = {
                        type: "table",
                        values: getTableData(firstTable, false),
                        styles: "secondTableHeader",
                        layout: "secondTableLayout",
                        widths: [240, 240],
                        margin: [0, 20, 0, 0]
                    };

                    dataArray.push(firstObj);

                    var bottomContent1 = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_KO'),
                        styles: "centeredText"
                    };
                    dataArray.push(bottomContent1);

                    var boldSubContentTitle = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_KO_BOLDTEXT'),
                        styles: "boldLeftAlignedText"
                    };
                    dataArray.push(boldSubContentTitle);


                    var bottomContent1 = {
                        type: "text",
                        values: $translate.instant('PRINT_BATTERYSTATUS_KO_BOTTOMTEXT'),
                        styles: "integrityContentText"
                    };
                    dataArray.push(bottomContent1);

                }

                var repairOrderText = {
                    type: "text",
                    values: $translate.instant('PRINT_REPAIR_ORDER_NUMBER') + (vm.vehicleRO ? vm.vehicleRO : ''),
                    styles: "boldLeftAlignedText"
                };
                dataArray.push(repairOrderText);


                var dateAndSignatureContent = {
                    type: "text",
                    values: carSplitsDateLabel + ' : ' + (startDate ? moment(startDate).format("DD/MM/YYYY") : ''),
                    styles: "rightAlignedText"
                };
                dataArray.push(dateAndSignatureContent);

                var stampAndDealerContent = {
                    type: "text",
                    values: $translate.instant('PRINT_DEALER_STAMP'),
                    styles: "rightAlignedTextPrint"
                };
                dataArray.push(stampAndDealerContent);

                var bottomContent1 = {
                    type: "text",
                    values: $translate.instant('PRINT_BOTTOMTEXT_ONE'),
                    styles: "italicText1"
                };
                dataArray.push(bottomContent1);

                var bottomContent2 = {
                    type: "text",
                    values: $translate.instant('PRINT_BOTTOMTEXT_TWO'),
                    styles: "italicText2"
                };
                dataArray.push(bottomContent2);

            } else if (pdfType === 'consent') {

                var consentFormTable = [
                    {
                        column1: {
                            data: $translate.instant("CONSENT_TITLE")
                        }
                    }
                ]
                var thirdObj = {
                    type: "table", values: getTableData(consentFormTable, false), styles: "tableStyleHeader",
                    layout: "secondTableLayout", widths: [490]
                };
                dataArray.push(thirdObj);

                var diagnosticInstructionsTable = [
                    {
                        column1: {
                            data:
                                ((profil.language !== 'pl') ? '\u2022 ' : '') +
                                $translate.instant("CONSENT_SUBTITLE_ONE") +
                                ((profil.language !== 'pl') ? ('\n' + '\u2022 ' + $translate.instant("CONSENT_SUBTITLE_TWO")) : ''),
                            alignment: "left",
                            font: 'Courier'
                        }
                    }
                ];
                var diagnosticInstructionsObj = {
                    type: "table",
                    values: getTableData(diagnosticInstructionsTable, false),
                    styles: "tableStyle",
                    layout: "secondTableLayout",
                    widths: [490],
                    margin: [0, 0, 0, 0]
                };
                dataArray.push(diagnosticInstructionsObj);

                var secondTable = [
                    {
                        column1: {
                            data: [
                                { text: $translate.instant('CONSENT_CUSTOMER_DETAIL') + '\n' ,bold: true },
                                { text: $translate.instant('COMMON_FNAME_LNAME') + '\n' },
                                
                                { text: $translate.instant('COMMON_ADDRESS') + '\n' },
                                
                                { text: $translate.instant('COMMON_ZIP_CODE') + '\n' },
                                
                                { text: $translate.instant('COMMON_CITY') }
                                
                            ],
                            alignment: "left"
                        },
                        column2: {
                            data: [
                                { text : '' + '\n'},
                                {
                                    text: ((vm.custFirstName ? ('  '+ vm.custFirstName) : '') + (vm.custLastName ? ('  '+ vm.custLastName): '')) + '\n'
                                        
                                },
                                {
                                    text: (vm.customerAddress ? ('  '+ vm.customerAddress): '') + '\n'
                                },
                                {
                                    text: (vm.custZipCode ? ('  '+ vm.custZipCode): '') + '\n'
                                },
                                {
                                    text: (vm.custCity ? ('  '+ vm.custCity): '') + '\n'
                                }

                            ],
                            alignment: "left"
                        },
                        column3: {
                            data: [
                                { text: $translate.instant('CONSENT_DEALER_DETAILS')+ '\n' ,bold: true },
                               
                                { text: $translate.instant('COMMON_NAME') + '\n' },
                                
                                { text: $translate.instant('COMMON_CODE') + '\n'},
                                
                                { text: $translate.instant('COMMON_ADDRESS') + '\n' },
                                
                                { text: $translate.instant('COMMON_ZIP_CODE') + '\n'},
                                
                                { text: $translate.instant('COMMON_CITY') },
                                
                            ],
                            alignment: "left",
                        },
                         column4: {
                            data: [
                                { text : '' + ((profil && profil.language === 'pl') ? ('\n' + '\n') : '\n')},
                                {
                                    text: (vm.dealerName ? ('  '+ vm.dealerName) : '') + '\n'
                                },
                                {
                                    text: (vm.dealerId ? ('  '+ vm.dealerId) : '') + '\n'
                                },
                                {
                                    text: (vm.dealerAddress ? ('  '+ vm.dealerAddress) : '') + '\n'
                                },
                                {
                                    text: (vm.dealerZipCode ? ('  '+ vm.dealerZipCode) : '') + '\n'
                                },
                                {
                                    text: (vm.dealerCity ? ('  '+ vm.dealerCity) : '')
                                }

                            ],
                            alignment: "left"
                        },
                    },
                    {
                        column1: {
                            data: [
                                { text: carSplitsDateLabel + ':', bold: true }
                                
                            ],
                            alignment: "left"
                        },
                        column2: {
                            data: [
                                { text: (startDate ? moment(startDate).format("DD/MM/YYYY") : '')}
                            ],
                            alignment: "left",
                            bold: false
                        },
                        column3: {
                            data: [
                                { text: $translate.instant('CONSENT_SIGNATURE'), bold: true }
                            ],
                            alignment: "left",
                            bold: false,
                            rowSpan: 3,
                            colspan : 2

                        },
                        column4: {
                            data: '',
                            alignment: "left",
                            bold: false,
                            rowSpan: 3,
                            colspan : 2
                        }
                    },
                    {
                        column1: {
                            data: [
                                { text: $translate.instant('CONSENT_REGISTRATION_NUMBER'), bold: true }
                                
                            ],
                            alignment: "left",
                            bold: false
                        },
                        column2: {
                            data: [
                                { text: (vm.vehicleImat ? vm.vehicleImat : '')}
                            ],
                            alignment: "left",
                            bold: false,
                        },
                        column3: {
                            data: '',
                            alignment: "left",
                            bold: false,
                        },
                        column4: {
                            data: '',
                            alignment: "left",
                            bold: false
                        }
                        
                    },
                    {
                        column1: {
                            data: [
                                { text: $translate.instant('CONSENT_REPAIRORDER_NUMBER') , bold: true }
                            ],
                            alignment: "left",
                            bold: false
                        },
                        column2: {
                            data: [
                                { text: (vm.vehicleRO ? vm.vehicleRO : '') }
                            ],
                            alignment: "left",
                            bold: false
                        },
                        column3: {
                            data: '',
                            alignment: "left",
                            bold: false
                        },
                        column4: {
                            data: '',
                            alignment: "left",
                            bold: false
                        }
                    },
                ];
                var secondObj = {
                    type: "table",
                    values: getTableData(secondTable, false),
                    styles: "secondTableHeader",
                    layout: "secondTableLayout",
                    widths: [120, 120, 120, 105],
                    margin: [0, 0, 0, 0]
                };

                dataArray.push(secondObj);

                var diagnosticInstructions3 = {
                    type: "text",
                    values: $translate.instant('CONSENT_BIGCONTENT_TITLE'),
                    styles: "boldLeftAlignedText"
                };
                dataArray.push(diagnosticInstructions3);

                var diagnosticInstructions4 = {
                    type: "text",
                    values:
                        $translate.instant('CONSENT_BIGCONTENT_ONE') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_TWO') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_THREE') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_FOUR') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_FIVE') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_SIX') + '\n' + '\n' +
                        $translate.instant('CONSENT_BIGCONTENT_SEVEN'),
                    styles: "leftText"
                };
                dataArray.push(diagnosticInstructions4);

                var bottomContent1 = {
                    type: "text",
                    values: $translate.instant('CONSENT_BOTTOMCONTENT_ONE'),
                    styles: "italicText1"
                };
                dataArray.push(bottomContent1);

                var bottomContent2 = {
                    type: "text",
                    values: $translate.instant('CONSENT_BOTTOMCONTENT_TWO'),
                    styles: "italicText2"
                };
                dataArray.push(bottomContent2);

                if(profil.language == 'pl'){
                    var bottomContent3 = {
                        type: "text",
                        values:  $translate.instant('CONSENT_BOTTOMCONTENT_THREE') + '\n' + '\n',
                        styles: "leftText"
                    };
                    dataArray.push(bottomContent3);

                    var bottomContent4Table = [
                        {
                            column1: {
                                data: $translate.instant("CONSENT_BOTTOMCONTENT_FOUR")
                            }
                        }
                    ]

                    var bottomContent4 = {
                        type: "table",
                        values: getTableData(bottomContent4Table, false),
                        styles: ["secondTableHeader", "boldText"],
                        layout: "secondTableLayout",
                        widths: [490],
                    };

                    dataArray.push(bottomContent4);
                }

                var dateContent = {
                    type: "text",
                    values: carSplitsDateLabel + ' : ' + (startDate ? moment(startDate).format("DD/MM/YYYY") : ''),
                    styles: "leftTextDate"
                };
                dataArray.push(dateContent);

                var signatureContent = {
                    type: "text",
                    values: $translate.instant('CONSENT_CUSTOMER_SIGNATURE'),
                    styles: "leftTextDate1"
                };
                dataArray.push(signatureContent);
            }

            dataArray = PDFViewService.getProcessedDataArray(finalArr, dataArray, false, false, false, false);
            var docDefinition = {
                info: {
                    title: "Battery Post-Crash Information"
                },

                header: {
                    stack: [
                        {
                            columns: [
                                {
                                    image: pictoImage.RENAULTGROUP.value,
                                    width: 70,
                                    margin: [10, 10, 0, 0]
                                },
                            ]
                        }
                    ]
                },
                footer: {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        },
                        {
                            type: 'none',
                            text: $translate.instant('CONSENT_VERSION') + " " + "-" + " " + moment(new Date()).format("DD/MM/YYYY"),
                            alignment: 'right',
                            margin: [0, 5, 5, 0],
                            fontSize : (profil && profil.language === 'pl' && pdfType === 'consent') ? 6 : 8
                        },
                    ]
                },
                content: [
                    finalArr
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    secondTableHeader: {
                        margin: [0, 0, 0, 3],
                        alignment: "center",
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 9 : 10,
                    },
                    leftAlignedText: {
                        fontSize: 12,
                        alignment: "left",
                        margin: [0, 5, 10, 0]
                    },
                    italicText1: {
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 9 : 10,
                        italics: true,
                        alignment: "left",
                        margin: [0, 5, 0, 0]
                    },
                    italicText2: {
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 9 : 10,
                        italics: true,
                        alignment: "left",
                        margin: [0, 5, 0, 0]
                    },
                    leftText: {
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 10 : 11,
                        alignment: "left",
                        margin: [0, 5, 10, 0]
                    },
                    leftTextDate: {
                        fontSize:  (profil && profil.language === 'pl' && pdfType === 'consent') ? 10 : 11,
                        alignment: "left",
                        bold: true,
                        margin: [0, 10, 10, 0]
                    },
                    leftTextDate1: {
                        fontSize:  (profil && profil.language === 'pl' && pdfType === 'consent') ? 10 :  11,
                        alignment: "left",
                        bold: true,
                        margin: [300, -11, 90, 0]
                    },
                    tableStyle: {
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 10 : 11,
                        margin: [0, 10, 0, 0],
                        alignment: "center"
                    },
                    tableStyleHeader: {
                        fontSize: (profil && profil.language === 'pl' && pdfType === 'consent') ? 12 : 13,
                        margin: [0, 10, 0, 2],
                        alignment: "center",
                        bold: true
                    },
                    tableStyleHeaderPrint: {
                        fontSize: 14,
                        margin: [0, 10, 0, 2],
                        alignment: "center",
                    },
                    centeredText: {
                        fontSize: 12,
                        alignment: "left",
                        margin: [0, 20, 0, 0]
                    },
                    centeredTextPrint: {
                        fontSize: 12,
                        alignment: "left",
                        margin: [0, 10, 0, 0]
                    },
                    integrityContentText: {
                        fontSize: 12,
                        alignment: "left",
                        margin: [0, 0, 0, 0],
                        lineHeight: 1.5
                    },
                    rightAlignedText: {
                        alignment: "right",
                        margin: [0, 20, 167, 0],
                        bold: true,
                        fontSize: 12
                    },
                    rightAlignedTextPrint: {
                        alignment: "right",
                        margin: [0, 0, 117, 100],
                        bold: true,
                        fontSize: 12
                    },
                    boldLeftAlignedText: {
                        fontSize:  (profil && profil.language === 'pl' && pdfType === 'consent') ? 10 : 11,
                        bold: true,
                        alignment: "left",
                        margin: [0, 10, 0, 5]
                    },
                    boldText:{
                       bold: true 
                    }
                }
            };
            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }
        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('remoteServices', {
            controller: remoteServicesCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/remoteServices/remoteServices.template.html'
        });

    function remoteServicesCtrl(
        blockUI,
        $filter,
        $scope,
        $document,
        toastr,
        $translate,
        $mdDialog,
        RLinkCarMetierService,
        CacheService,
        ActisConstantes,
        configConstantes,
        SearchArboTextualMetierService,$rootScope
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.protocolData = {};
        vm.currentPage = 1;
        vm.pageSize = 15;
        vm.totalCount = 0;
        vm.today = new Date();
        vm.minDate = new Date(vm.today.getFullYear() - 1, vm.today.getMonth(), vm.today.getDate());
        vm.maxDate = vm.today;
        vm.startDate = new Date(vm.today.getTime() - (7 * 24 * 60 * 60 * 1000));
        vm.endDate = vm.today;
        vm.showPopup = false;
        vm.remoteServicesData = [];
        vm.showPopin = false;
        vm.user = CacheService.getUserProfile();
        vm.isRmpEnabled = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        const nissanCalendarClass = 'nissan-remote-services-theme';

     
        if (vm.nissanUserURL) {
            $document[0].body.classList.add(nissanCalendarClass);
        }

        $scope.$on('$destroy', function () {
            $document[0].body.classList.remove(nissanCalendarClass);
        });

        if (vm.user && vm.user.userType === "ARCA" && !_.isEmpty(vm.user.roles)) {
            var requiredRoles = [
                ActisConstantes.ppx_assist_tech_n1,
                ActisConstantes.ppx_assist_tech_n2,
                ActisConstantes.ppx_assist_tech_corp
            ];
            vm.isRmpEnabled = vm.user.roles.some(function (role) {
                return requiredRoles.includes(role);
            });
        }

        /*=============================================
        =                FUNCTION BINDINGS            =
        =============================================*/
        vm.getRemoteServicesPopup = getRemoteServicesPopup;
        vm.togglePopin = togglePopin;
        vm.openConfirmationPopup = openConfirmationPopup;
        vm.closePopup = closePopup;
        vm.refreshJwtConfig = refreshJwtConfig;
        vm.loadPage = loadPage;
        vm.toggleExpand = toggleExpand;
        vm.getTotalPages = getTotalPages;
        vm.pageChange = pageChange;
        vm.getTranslatedMessage = getTranslatedMessage;

        /*=============================================
        =               FUNCTION DEFINITIONS          =
        =============================================*/

        // Toggles the popin for each row
        function togglePopin(item) {
            vm.remoteServicesData.forEach(function (row) {
                row.showPopin = false;
            });
            item.showPopin = !item.showPopin;
        }

        // Open confirmation popup
        function openConfirmationPopup() {
            vm.showPopup = true;
        }

        // Close confirmation popup
        function closePopup() {
            vm.showPopup = false;
        }

        // Refresh JWT configuration and handle responses
        function refreshJwtConfig() {
            SearchArboTextualMetierService.setConnectedServicesAuditData('JWT_CONFIG')
            .then(function () { })
            RLinkCarMetierService.refreshJwtConfig()
                .then(function (response) {
                    vm.closePopup();
                    if (response.status === 204) {
                        toastr.success($translate.instant('ACTION_SENT'));
                    } else {
                        toastr.error($translate.instant('ACTION_NOT_SENT'));
                    }
                })
                .catch(function () {
                    toastr.error($translate.instant('ACTION_NOT_SENT'));
                    vm.closePopup();
                });
        }

        // Load data for the given page 
        function loadPage(page) {
            $rootScope.$broadcast('enableLoader', true);
            var pagination = { page: (page - 1), pageSize: vm.pageSize };
            var formattedStartDate = $filter('date')(vm.startDate, 'yyyy-MM-dd');
            var formattedEndDate = $filter('date')(vm.endDate, 'yyyy-MM-dd');

           // blockUI.start();
            return RLinkCarMetierService.getRemoteServices(pagination, formattedStartDate, formattedEndDate)
                .then(function (rsData) {
                    vm.totalCount = rsData.totalCount;
                    var excludedCommands = ['remote-diagnostic', 'soc-level', 'manage-ivi-logs', 'bosch-sfde'];
                    vm.remoteServicesData = rsData.commands.filter(function(service) {
                        return excludedCommands.indexOf(service.commandName) === -1;
                    });
                    sortActionLifeCycles(vm.remoteServicesData);
                    vm.currentPage = page;
                })
                .catch(function (error) {
                    $rootScope.$broadcast('enableLoader', false);
                    if (!error || error.status !== 404) {
                        toastr.error($translate.instant('NO_DATA_FOUND'));
                    }
                })
                .finally(function () {
                    $rootScope.$broadcast('enableLoader', false);
                  //  blockUI.stop();
                });
        }

        // Toggles the expanded state for a row
        function toggleExpand(item) {
            item.isExpanded = !item.isExpanded;
        }

        // Calculates the total number of pages based on totalCount and pageSize
        function getTotalPages() {
            return Math.ceil(vm.totalCount / vm.pageSize);
        }

        function getTranslatedMessage(prefix, errorCode, fallbackMessage) {
            if (!errorCode || !fallbackMessage) {
                return '';
            }

            if (prefix === "RS_RP_ECODE_") {
                errorCode = mapRepairActionErrorCode(errorCode);
            }

            var translationKey = prefix + errorCode;
            var translatedValue = $translate.instant(translationKey);

            return translatedValue !== translationKey ? translatedValue : fallbackMessage;
        }

        function mapRepairActionErrorCode(errorCode) {
            errorCode = parseInt(errorCode, 10);

            const errorCodesToMapToZero = new Set([0, 1, 4, 5, 10, 11, 12, 13, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 77, 78, 79]);
            const errorCodesToMapTo68 = new Set([68, 69, 70, 71, 72, 73, 74]);
            const errorCodesToMapTo9 = new Set([9, 75, 76]);

            if (errorCodesToMapToZero.has(errorCode)) {
                return 0;
            }
            if (errorCodesToMapTo9.has(errorCode)) {
                return 9;
            }
            if (errorCodesToMapTo68.has(errorCode)) {
                return 68;
            }

            if (errorCode === 3) {
                return 2;
            }
            if (errorCode === 8) {
                return 7;
            }
            return errorCode;
        }

        // Handles page change events
        function pageChange(newPage) {
            if (newPage >= 1 && newPage <= vm.getTotalPages()) {
                vm.loadPage(newPage);
            }
        }

        // Function to handle the initialization logic
        this.$onInit = function () {
            $rootScope.$broadcast('enableLoader', true);
            //blockUI.start();
            return RLinkCarMetierService.getVehicleInformationDataCCS()
                .then(function (data) {
                    $rootScope.$broadcast('enableLoader', false);
                   // blockUI.stop();
                    if (data && data.vehicle && data.vehicle.remoteSecurityProtocol) {
                        vm.protocolData = data.vehicle.remoteSecurityProtocol;
                    }
                })
                .catch(function (error) {
                    blockUI.stop();
                    //toastr.error(error);
                });
        };

        // Show the remote services popup
        function getRemoteServicesPopup(popupWindow) {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/remoteServices/popup/remoteServicesPopup.html',
                controller: ["$scope", remoteServicesPopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    popupWindow: popupWindow
                }
            });
        }

        // Remote services popup controller
        function remoteServicesPopupController($scope) {
            $scope.close = function () {
                $mdDialog.hide();
            };
        }

        // Sorts action life cycles by creation date in descending order
        function sortActionLifeCycles(data) {
            if (Array.isArray(data)) {
                data.forEach(function (command) {
                    if (Array.isArray(command.actionLifeCycle)) {
                        command.actionLifeCycle.sort(function (a, b) {
                            return new Date(b.creationDateTime) - new Date(a.creationDateTime);
                        });
                    }
                });
            }
        }

        // Load the first page initially
        vm.loadPage(vm.currentPage);
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('hereNavigation', {
             bindings: {
                vehicle: '<',
                serviceApplicable:'<'
            },
            controller: hereNavigationCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/hereNavigation/hereNavigation.template.html'
        });

    function hereNavigationCtrl(
        $translate
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        const hereNavigationUidCandidates = ['4025', '4026', '4027', '4028', '4029'];
        vm.protocolData = {};
        vm.herePlatformDetails = {};
        vm.hereSubscriptionDetails = {};
        vm.herePlatformRow = {};
        vm.hereSubscriptionRow = {};
        vm.getHerePlatformStatus = getHerePlatformStatus;
        vm.isHerePlatformGreen = isHerePlatformGreen;
        vm.getHerePlatformLabel = getHerePlatformLabel;
        vm.getHereSubscriptionState = getHereSubscriptionState;
        vm.getHereSubscriptionColor = getHereSubscriptionColor;
        vm.getHereSubscriptionLabel = getHereSubscriptionLabel;
        vm.getHereActivationColor = getHereActivationColor;
        vm.getHereActivationLabel = getHereActivationLabel;


        // Keep onInit lightweight to avoid runtime issues in this static UI component.
        this.$onInit = function () {
            syncHereNavigationRows();
        };

        function syncHereNavigationRows() {
            const hereNavigationState = getHereNavigationState();
            const hereSubscriptionData = getHereSubscriptionData();

            vm.herePlatformRow = {
                vinState: hereNavigationState.status || '-',
                hereId: hereNavigationState.uniqueId || '-',
                creationDate: hereNavigationState.createdAt || '-',
                lastStatusUpdate: hereNavigationState.updatedAt || '-'

            };

            vm.hereSubscriptionRow = {
                subscriptionId: hereSubscriptionData.subscriptionId || '-',
                state: hereSubscriptionData.state || '-',
                contractDuration: hereSubscriptionData.contractDuration || '-',
                startDate: hereSubscriptionData.startDate || '-',
                expirationDate: hereSubscriptionData.expirationDate || '-',
                lastConnectionDate: hereSubscriptionData.lastConnectionDate || '-'
            };

            vm.hereNavigationUIDs = buildHereNavigationUIDs();
        }

        function getHereNavigationState() {
            return vm.vehicle &&
                vm.vehicle.hereNavigationStatus &&
                vm.vehicle.hereNavigationStatus.response || {};
        }

        function getHereSubscriptionData() {
            const subscriptions = vm.vehicle &&
                vm.vehicle.hereNavigationSubscription &&
                vm.vehicle.hereNavigationSubscription.response &&
                vm.vehicle.hereNavigationSubscription.response.subscriptions;
            
            const subscription = subscriptions && subscriptions[0] || {};
            
            const platformState = getHereNavigationState();
            const contractDuration = platformState.subscriptionPlan && platformState.subscriptionPlan.planDurationMonths
                ? platformState.subscriptionPlan.planDurationMonths 
                : '-';
            
            return {
                subscriptionId: subscription.id || '-',
                state: subscription.state || '-',
                contractDuration: contractDuration,
                startDate: subscription.starts || '-',
                expirationDate: subscription.expires || '-',
                lastConnectionDate: (vm.vehicle && vm.vehicle.hereNavigationSubscription && vm.vehicle.hereNavigationSubscription.response && vm.vehicle.hereNavigationSubscription.response.lastConnected) || '-',
            };
        }

        function buildHereNavigationUIDs() {
            const uidDefinitions = [
                { uid: '4025', label: $translate.instant('HERE_NAVIGATION_UID') },
                { uid: '4026', label: $translate.instant('HERE_NAVIGATION_ERP') },
                { uid: '4027', label: $translate.instant('HERE_NAVIGATION_LCV_ROUTING') },
                { uid: '4028', label: $translate.instant('HERE_NAVIGATION_ERP_LCV_ROUTING') },
                { uid: '4029', label: $translate.instant('HERE_NAVIGATION_LITE') }
            ];

            const feature = getHereApplicableUidFeature();
            if (!feature) {
                return [];
            }

            const featureUid = String(feature.uid);
            const uidDefinition = uidDefinitions.find(function (uidDef) {
                return uidDef.uid === featureUid;
            });
            if (!uidDefinition) {
                return [];
            }

            const status = feature.status ? String(feature.status).toUpperCase() : 'DEACTIVATED';
            const isActive = status === 'ACTIVE' || status === 'ACTIVATED';
            const lastUpdate = vm.herePlatformRow && vm.herePlatformRow.lastStatusUpdate ? vm.herePlatformRow.lastStatusUpdate : '-';

            return [{
                uid: uidDefinition.uid,
                label: uidDefinition.label,
                status: isActive ? 'Activated' : 'Deactivated',
                isActive: isActive,
                color: isActive ? 'green' : 'red',
                lastStatusUpdate: lastUpdate
            }];
        }

        function getHerePlatformStatus() {
            const status = getHereNavigationState().status;
            return (status || '').toString().toUpperCase();
        }

        function isHerePlatformGreen() {
            const status = getHerePlatformStatus();
            return status === 'REGISTERED' || status === 'ACTIVATED';
        }

        function getHerePlatformLabel() {
            const status = getHerePlatformStatus();
            if (status === 'ACTIVATED') {
                return $translate.instant('VEHICLE_ACTIVATED_AT_HERE_PLATFORM');
            }
            if (status === 'REGISTERED') {
                return $translate.instant('VEHICLE_REGISTERED_AT_HERE_PLATFORM');
            }
            // APPLICABLE and any unknown status fallback.
            return $translate.instant('VEHICLE_UNKNOWN_STATUS_AT_HERE_PLATFORM');
        }

        function getHereSubscriptionState() {
            const subscriptions = vm.vehicle && vm.vehicle.hereNavigationSubscription && vm.vehicle.hereNavigationSubscription.response && vm.vehicle.hereNavigationSubscription.response.subscriptions;
            const state = subscriptions && subscriptions[0] && subscriptions[0].state;
            return (state || '').toString().toLowerCase();
        }

        function getHereSubscriptionColor() {
            const state = getHereSubscriptionState();
            if (state === 'active') {
                return 'green';
            }
            if (state === 'pending') {
                return 'orange';
            }
            return 'red';
        }

        function getHereSubscriptionLabel() {
            const state = getHereSubscriptionState();
            if (state === 'active') {
                return $translate.instant('SUBSCRIPTION_HERE_DONE');
            }
            if (state === 'pending') {
                return $translate.instant('SUBSCRIPTION_HERE_IN_PROGRESS');
            }
            if (state === 'expired') {
                return $translate.instant('SUBSCRIPTION_HERE_EXPIRED');
            }
            if (state === 'canceled') {
                return $translate.instant('SUBSCRIPTION_HERE_CANCELED');
            }

            return $translate.instant('SUBSCRIPTION_HERE_CANCELED');
        }

        function getHereApplicableUidFeature() {
            const subscriptionInfo = vm.vehicle && vm.vehicle.subscriptionInformation;
            if (!subscriptionInfo) {
                return null;
            }

            const allServices = [];
            if (Array.isArray(subscriptionInfo.commercialServices)) {
                allServices.push.apply(allServices, subscriptionInfo.commercialServices);
            }
            if (Array.isArray(subscriptionInfo.technicalServices)) {
                allServices.push.apply(allServices, subscriptionInfo.technicalServices);
            }

            for (let i = 0; i < allServices.length; i++) {
                const service = allServices[i];
                const features = service && Array.isArray(service.features) ? service.features : [];
                for (let j = 0; j < features.length; j++) {
                    const feature = features[j];
                    const uid = feature && feature.uid !== undefined && feature.uid !== null ? String(feature.uid) : '';
                    if (hereNavigationUidCandidates.indexOf(uid) !== -1) {
                        return feature;
                    }
                }
            }

            return null;
        }

        function isHereUidActive() {
            const feature = getHereApplicableUidFeature();
            const status = feature && feature.status ? String(feature.status).toUpperCase() : '';
            return status === 'ACTIVE' || status === 'ACTIVATED';
        }

        function getHereActivationUid() {
            const feature = getHereApplicableUidFeature();
            return feature && feature.uid !== undefined && feature.uid !== null ? String(feature.uid) : '.....';
        }

        function getHereActivationColor() {
            return isHereUidActive() ? 'green' : 'red';
        }

        function getHereActivationLabel() {
            const uid = getHereActivationUid();
            if (isHereUidActive()) {
              return  $translate.instant('SERVICE_ACTIVATED') + ' (UID ' + uid + ')';
              
            }
            return $translate.instant('SERVICE_INACTIVATED') + ' (UID ' + uid + ')';
            
        }     
    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('plugAndCharge', {
            bindings: {
                data: '<',
                evServicesTab: '<'
            },
            controller: PlugAndChargeComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/evServices/plugAndCharge.template.html'
        });

    /** @ngInject */
    function PlugAndChargeComponent(blockUI,RLinkCarMetierService,CacheService,CarSearchMetierService,rLinkConstant,RLinkCarUtils,$scope,$rootScope,$mdDialog,$sce,toastr,$translate,$timeout,configConstantes,CacheConstants,SearchArboTextualMetierService){
        var vm = this;
        vm.tabOpen = true;
        vm.serviceEligible = false;
        vm.showMobilizeSmart = false;
        vm.serviceActivated = false;
        vm.serviceSubscribed = false;
        vm.isDelegated = false;
        vm.calendarData = {};
        vm.durationData = {};
        vm.socTarget = null;
        vm.socTimeStamp = null;
        vm.mappingStatusDetails = {};
        vm.mappingInfo = {};
        vm.mappingStatus = 'NOK';
        vm.evServiceModal = evServiceModal;
        vm.restartService = restartService;
        vm.launchInstallation = launchInstallation;
        vm.formatDate = formatDate;
        vm.isActionNotPossible = false;
        vm.isV2gLaunchEnabled = true;
        vm.isPncLaunchEnabled = true;
        vm.contractToDisplay = {};
        vm.servicePackToDisplay = {};
        vm.getDisplayContract = getDisplayContract;
        vm.getTableData = getTableData;
        vm.serviceSync = serviceSync;
        vm.serviceSyncPopup = serviceSyncPopup;
        vm.refreshEvSettings = refreshEvSettings;
        vm.refreshSocLevels = refreshSocLevels;
        vm.packOfServicesVisible = false;
        vm.bva = rLinkConstant.bva;
        vm.vcps = rLinkConstant.vcps;
        vm.vcpsData = '';
        vm.bvaData = '';
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.language = CacheService.getObject(CacheConstants.profil).language;
        vm.userType = CacheService.getObject(CacheConstants.profil).userType;
        vm.uid955Data = null; 
        vm.socLevelsValid = false; 
        vm.socLevelsErrorMessage = ''; 
        vm.showV2GWarning = false; 
        vm.v2gWarningMessage = ''; 
        vm.showInstantaneousCharge = false;
        vm.smartChargingLabel = '';
        
        
        $scope.$on('EVTabDetails', function (event, data) {
            eVDetails(data);
        });
        
        $scope.$on('uid955Data', function (event, data) {
            vm.uid955Data = data;
        });
        
        this.$onInit = function () {
            getTableData();
            var evServiceTab = RLinkCarMetierService.getEvServicesTab();
            loadSmartChargingLabel();
            if(evServiceTab){
                eVDetails(evServiceTab);
            }
        }

        function loadSmartChargingLabel() {
            RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                if (data && data.subscriptions && data.subscriptions.contracts) {
                    checkSmartChargingSubscription(data.subscriptions.contracts);
                    $rootScope.$broadcast('smartChargingLabelUpdated', vm.smartChargingLabel);
                }
            }).catch(function (error) {
            });
        }

        function checkSmartChargingSubscription(contracts) {
            vm.smartChargingLabel = '';
            vm.serviceSubscribed = false;
            
            if (!_.isArray(contracts)) {
                return;
            }
            
            const ongoingContracts = contracts.filter(function (contract) {
                return rLinkConstant.statusOnGoing.indexOf(contract.status) !== -1;
            });

            ongoingContracts.forEach(function (contract) {
                if (contract.servicePacks && _.isArray(contract.servicePacks)) {
                    contract.servicePacks.forEach(function (servicePack) {
                        if (servicePack && rLinkConstant.targetServiceSids.indexOf(servicePack.sid) !== -1) {
                            vm.serviceSubscribed = true;
                            if (servicePack.sid === rLinkConstant.sidSmartChargingB2B) {
                                vm.smartChargingLabel = rLinkConstant.smartChargingB2B;
                            } else if (servicePack.sid === rLinkConstant.sidSmartChargingJedlix) {
                                vm.smartChargingLabel = rLinkConstant.smartChargingJedlix;
                            } else if (servicePack.sid === rLinkConstant.sidSmartChargingB2C) {
                                vm.smartChargingLabel = rLinkConstant.smartChargingB2C;
                            }
                        }
                    });
                }
            });
        }

        function eVDetails(service) {
            processResponse();
            vm.tabOpen = true;
            vm.serviceEligible = false;
            vm.serviceActivated = false;
            vm.serviceSubscribed = false;
            vm.isDelegated = false;
            vm.pnCTab = false;
            vm.v2GTab = false;
            vm.v2GTabNew = false;
            vm.sCTab = false;
            vm.oemDetails = {};
            vm.contractDetails = {};
            vm.evSettings = false;
            vm.evSettingsTab = false;
            vm.isDeleg = false;
            var featureId = (service && service === "plugAndCharge") ? 743 : (service && service === "vehicleToGrid") ? 701 : (service && service === "vehicleToGridNew") ? 
            976 : (service && service === "smartCharging") ? 
            364 : (service && service === "evSettings") ? 955 : null;

            if (featureId) {
                vm.pnCTab = featureId === 743;
                vm.v2GTab = featureId === 701;
                vm.v2GTabNew = featureId === 976;
                vm.sCTab = featureId === 364;
                vm.isActionNotPossible = false;
                vm.evSettings = featureId === 955;

                if(vm.evSettings){
                    RLinkCarMetierService.getEvSettingsData(RLinkCarUtils.getVin()).then(function (data) {
                        if (data) {
                            vm.evSettingsData = data;
                            if (vm.evSettingsData.chargeDuration) {
                                vm.evSettingsData.chargeDurationHours = convertToHoursMinutes(vm.evSettingsData.chargeDuration);
                            }
                            if (vm.evSettingsData.chargeTimeStart && vm.evSettingsData.chargeDuration) {
                                vm.evSettingsData.chargeEndTime = calculateChargeEndTime(vm.evSettingsData.chargeTimeStart, vm.evSettingsData.chargeDuration);
                            }
                            checkProgramsStatus(data);
                        }
                    }).catch(function (_error) {
                        vm.evSettingsData = null;
                        vm.showNoDataFound = true;
                        toastr.error($translate.instant('ERROR'));
                    });

                    RLinkCarMetierService.getEvSettingsSoc(RLinkCarUtils.getVin()).then(function (data) {
                        if (data) {
                            vm.evSettingsSocData = data;
                            validateSocLevels(data);
                        }
                    }).catch(function (_error) {
                        vm.socLevelsValid = false;
                        vm.socLevelsErrorMessage = $translate.instant('SOC_LEVEL_NOT_SET');
                        toastr.error($translate.instant('ERROR'));
                    });

                    RLinkCarMetierService.getDelegation().then(function (delegationData) {
                        if (delegationData && !_.isEmpty(delegationData) && delegationData.activated === true) {
                            vm.isDeleg = true;
                        }
                    }).catch(function (_error) {
                        vm.isDeleg = false;
                        toastr.error($translate.instant('ERROR'));
                    });
                }
                
                const findSubscriptionStatus = function(v2gSubscriptionData) {
                    if (!v2gSubscriptionData || !Array.isArray(v2gSubscriptionData)) {
                        return null;
                    }
                    return v2gSubscriptionData.find(function (sub) {
                        return sub.subscriptionStatus;
                    });
                };

                const findReadinessStatus = function(v2gSubscriptionData) {
                    if (!v2gSubscriptionData || !Array.isArray(v2gSubscriptionData)) {
                        return null;
                    }
                    return v2gSubscriptionData.find(function (sub) {
                        return sub.readinessStatus;
                    });
                };

                const processV2GSubscription = function(data) {

                    if (data && data._embedded && data._embedded.subscriptions && Array.isArray(data._embedded.subscriptions)) {
                        vm.v2gSubscriptionData = data._embedded.subscriptions;

                        const subscription = findSubscriptionStatus(vm.v2gSubscriptionData);
                        if (subscription) {
                            vm.subscriptionStatus = subscription.subscriptionStatus;
                        }

                        const readiness = findReadinessStatus(vm.v2gSubscriptionData);
                        if (readiness) {
                            vm.readinessStatus = readiness.readinessStatus;
                        }
                    }
                };

                if (vm.v2GTab || vm.v2GTabNew) {
                    RLinkCarMetierService.getV2gSubscription()
                        .then(processV2GSubscription)
                        .catch(function (_error) {
                            toastr.error($translate.instant('ERROR'));
                        });
                }

                if (vm.v2GTab) {
                    RLinkCarMetierService.getVehicleInformationDataCCS().then(function (prediag) {
                        if (prediag && prediag.subscriptions && prediag.subscriptions.commercialServices && Array.isArray(prediag.subscriptions.commercialServices)) {
                            prediag.subscriptions.commercialServices.forEach(function (service) {
                                if (service.sid === '20000602' && Array.isArray(service.features)) {
                                    var v2gFeature = service.features.find(function (f) {
                                        return String(f.uid) === '701';
                                    });
                                    if (v2gFeature) {
                                        if (v2gFeature.status === 'ACTIVATED') {
                                            vm.serviceActivatedV2GTab = true;
                                        } else if (v2gFeature.status === 'DEACTIVATED') {
                                            vm.serviceActivatedV2GTab = false;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                var adasData = RLinkCarMetierService.getAdasData();
                if (!_.isEmpty(adasData) && adasData.features) {
                    adasData.features.forEach(function (feature) {
                        if (feature.featureId === featureId) {
                            vm.serviceEligible = true;
                            if (featureId == '364') {
                            vm.showMobilizeSmart = true;
                        }
                        }
                    });
                }

                if (vm.serviceEligible && (vm.pnCTab || vm.v2GTab || vm.v2GTabNew)) {
                    $rootScope.$broadcast('enableLoader', true);
                  //  blockUI.start();
                    return RLinkCarMetierService.diagCertificateInfo().then(function (data) {
                        if (!_.isEmpty(data)) {
                            vm.mappingStatusDetails = data.plcInformation;
                            
                            RLinkCarMetierService.getCertificatesStatus().then(function(certStatusData) {
                                processCertificateStatusData(certStatusData);
                            }).catch(function(error) {
                                console.info('Error fetching certificate status', error);
                            });
                            vm.mappingStatusDetails.vin = RLinkCarUtils.getVin();
                            if (vm.mappingStatusDetails && !_.isEmpty(vm.mappingStatusDetails)) {
                                return RLinkCarMetierService.getCertificatesDiagnostic().then(function (data) {
                                    vm.mappingInfo = data && data.length > 0 ? data[0] : null;
                                    if (vm.mappingStatusDetails.mappingStatus && vm.mappingStatusDetails.mappingStatus.toLowerCase() === 'ok') {
                                        if (vm.mappingInfo && vm.mappingInfo.serialNumber 
                                            && vm.mappingStatusDetails.serialNumber === vm.mappingInfo.serialNumber) {
                                            vm.mappingStatus = 'OK';
                                        } else {
                                            vm.mappingStatus = 'NOK';
                                        }
                                    }
                                });
                            }
                        }
                    }).then(function () {
                        return CarSearchMetierService.getVinAlertsStatus(featureId).then(function (data) {
                            if (!_.isEmpty(data) && data.status && data.status.toLowerCase() === 'activated') {
                                vm.serviceActivated = true;
                            }
                        });
                    }).catch(function (error) {
                       // toastr.error(error);
                    }).finally(function () {
                        $rootScope.$broadcast('enableLoader', false);
                       // blockUI.stop();
                    });
                }

                if (vm.serviceEligible && vm.sCTab) {
                    $rootScope.$broadcast('enableLoader', true);
                   // blockUI.start();
                    return RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                        if (data && data.subscriptions) {
                            checkPrerequisitesActivation(data);
                            if (_.isArray(data.subscriptions.contracts)) {
                                checkSmartChargingSubscription(data.subscriptions.contracts);
                            }
                        }

                        vm.contractToDisplay = getDisplayContract(data);
                        if (vm.contractToDisplay && vm.contractToDisplay.servicePacks) {
                            vm.servicePackToDisplay = _.find(vm.contractToDisplay.servicePacks, function(servicePack) {
                                return rLinkConstant.targetServiceSids.indexOf(servicePack.sid) !== -1;
                            }) || {};
                        }

                        if (vm.serviceSubscribed) {
                            return CarSearchMetierService.getVinAlertsStatus(featureId).then(function (data) {
                                if (!_.isEmpty(data) && data.status && data.status.toLowerCase() === 'activated') {
                                    vm.serviceActivated = true;
                                    vm.restartService('evManager');
                                }
                            });
                        }
                    }).catch(function (error) {
                       // toastr.error(error);
                    }).finally(function () {
                       // blockUI.stop();
                       $rootScope.$broadcast('enableLoader', false);
                    });
                }
            }
        }
        

        function processCertificateStatusData(certStatusData) {
            if (!certStatusData || !Array.isArray(certStatusData) || _.isEmpty(certStatusData)) {
                return;
            }

            certStatusData.forEach(function(group) {
                if (!group.group_id || !group.certificates) {
                    return;
                }

                const groupId = group.group_id.toLowerCase();
                
                if (vm.pnCTab && groupId === 'pnc') {
                    vm.pnCCertificatesStatus = group.certificates;
                    processPncCertificates(group.certificates);
                } else if ((vm.v2GTab || vm.v2GTabNew) && groupId === 'v2g') {
                    vm.v2GCertificatesStatus = group.certificates;
                    processV2gCertificates(group.certificates);
                }
            });
        }

        function processPncCertificates(certificates) {
            if (_.isEmpty(certificates)) {
                return;
            }
            
            certificates.forEach(function(cert) {
                if (!cert || !cert.certificate_type) return;
                
                const certType = cert.certificate_type.toLowerCase();
                if (certType === 'oem_provisioning') {
                    vm.oemDetails = cert;
                } else if (certType === 'contract_certificate') {
                    vm.contractDetails = cert;
                }
            });
        }

        function processV2gCertificates(certificates) {
            if (_.isEmpty(certificates)) return;
            
            certificates.forEach(function(cert) {
                if (cert && cert.certificate_type && 
                    cert.certificate_type.toLowerCase() === 'vehicle_certificate') {
                    vm.oemDetails = cert;
                }
            });
        }

        function restartService(tab){
            if(tab && tab =="mappingStatus"){
                $rootScope.$broadcast('enableLoader', true);
                //blockUI.start();
                RLinkCarMetierService.diagCertificateInfo().then(function(data){
                            if(!_.isEmpty(data)){
                                vm.mappingStatusDetails = data.plcInformation;
                            }
                            vm.mappingStatusDetails.vin = RLinkCarUtils.getVin();
                RLinkCarMetierService.getCertificatesDiagnostic().then(function(data){
                    vm.mappingInfo = data && data.length > 0 ? data[0] : null;
                    if (vm.mappingStatusDetails.mappingStatus && vm.mappingStatusDetails.mappingStatus.toLowerCase() === 'ok') {
                        if (vm.mappingInfo && vm.mappingInfo.serialNumber
                            && vm.mappingStatusDetails.serialNumber === vm.mappingInfo.serialNumber) {
                            vm.mappingStatus = 'OK';
                        } else {
                            vm.mappingStatus = 'NOK';
                        }
                    }
                });
                }).finally(function () {
                    $rootScope.$broadcast('enableLoader', false);
                    //blockUI.stop();
                });
            }else if(tab && tab == rLinkConstant.certificate){
                $rootScope.$broadcast('enableLoader', true);
                RLinkCarMetierService.getCertificatesStatus().then(function(certStatusData) {
                    processCertificateStatusData(certStatusData);
                }).catch(function(error) {
                    console.info('Error fetching certificate status:', error);
                }).finally(function () {
                    $rootScope.$broadcast('enableLoader', false);
                });
            } else if (tab && tab == "smartCharge") {
                $rootScope.$broadcast('enableLoader', true);
                //blockUI.start();

                var adasData = RLinkCarMetierService.getAdasData();
                if (!_.isEmpty(adasData) && adasData.features) {
                    adasData.features.forEach(function (feature) {
                        if (feature.featureId === '364') {
                            vm.serviceEligible = true;
                        }
                    });
                }

                if (vm.serviceEligible) {
                    RLinkCarMetierService.getVehicleInformationDataCCS().then(function (ccsData) {
                        if (ccsData && ccsData.subscriptions && _.isArray(ccsData.subscriptions.contracts)) {
                            checkSmartChargingSubscription(ccsData.subscriptions.contracts);
                        }

                        if (vm.serviceSubscribed) {
                            return CarSearchMetierService.getVinAlertsStatus('364').then(function (vinAlertData) {
                                if (!_.isEmpty(vinAlertData) && vinAlertData.status && vinAlertData.status.toLowerCase() === 'activated') {
                                    vm.serviceActivated = true;
                                }

                                if (vm.serviceActivated) {
                                    return RLinkCarMetierService.getDelegation().then(function (delegationData) {
                                        if (!_.isEmpty(delegationData) && delegationData.activated && delegationData.activated == true) {
                                            vm.isDelegated = true;
                                        }

                                        if (vm.isDelegated) {
                                            return RLinkCarMetierService.getCalendar().then(function (calenderData) {
                                                if (!_.isEmpty(calenderData) && calenderData.activated && calenderData.activated == true) {
                                                    vm.calendarData.activated = true;
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }).finally(function () {
                        $rootScope.$broadcast('enableLoader', false);
                       // blockUI.stop();
                    });
                } else {
                    $rootScope.$broadcast('enableLoader', false);
                }
            } else if (tab && tab == "evManager") {
                $rootScope.$broadcast('enableLoader', true);
                //blockUI.start();
                RLinkCarMetierService.evManagerCalendarInfo().then(function (evData) {
                    if (evData && !_.isEmpty(evData)) {
                        vm.calendarData = evData.calendarData ? evData.calendarData : {};
                        vm.isDelegated = evData.isDelegated && evData.isDelegated.activated;
                        vm.socTarget = evData.socTarget ?  evData.socTarget.socTarget : null;
                        vm.socTimeStamp = evData.socTarget ? evData.socTarget.lastEnergyUpdateTimestamp : null;
                        vm.durationData = evData.calendarData ? evData.calendarData.chargeDuration :{};
                    }
                    processResponse(vm.durationData);
                }).finally(function () {
                    $rootScope.$broadcast('enableLoader', false);
                    //blockUI.stop();
                });
            } else if (tab && tab == "contracts") {
                $rootScope.$broadcast('enableLoader', true);
               // blockUI.start();
                RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                    vm.contractToDisplay = getDisplayContract(data);
                    if (vm.contractToDisplay && vm.contractToDisplay.servicePacks) {
                        vm.servicePackToDisplay = _.find(vm.contractToDisplay.servicePacks, function(servicePack) {
                            return rLinkConstant.targetServiceSids.indexOf(servicePack.sid) !== -1;
                        }) || {};
                    }
                }).finally(function () {
                    $rootScope.$broadcast('enableLoader', false);
                    //blockUI.stop();
                });
            }
        }

        function checkPrerequisitesActivation(data) {
            if (!data || !data.subscriptions || !data.subscriptions.commercialServices) {
                vm.prerequisitesActivated = false;
                vm.deactivatedUidMessage = '';
                return;
            }

            const commercialServices = data.subscriptions.commercialServices;
            const uidsStatus = {
                '12': false,
                '362': false,
                '726': false,
                '955': false
            };
            const deactivatedUids = [];
            commercialServices.forEach(function (service) {
                if (service.features && Array.isArray(service.features)) {
                    service.features.forEach(function (feature) {
                        if (uidsStatus.hasOwnProperty(feature.uid)) {
                            uidsStatus[feature.uid] = feature.status === 'ACTIVATED';
                            if (feature.status === 'DEACTIVATED' && deactivatedUids.indexOf(feature.uid) === -1) {
                                deactivatedUids.push(feature.uid);
                            }
                        }
                    });
                }
            });
            if (uidsStatus['12'] && uidsStatus['362'] && (uidsStatus['726'] || uidsStatus['955'])) {
                vm.prerequisitesActivated = true;
                vm.deactivatedUidMessage = '';
            } else {
                vm.prerequisitesActivated = false;
                if (deactivatedUids.length > 0) {
                    vm.deactivatedUidMessage = `UID ${deactivatedUids.join(' & ')} ${$translate.instant('SMARTCHARGE_DEACTIVATED')}`;
                }
            }
        }

       function formatDate(date){
            var mapDateTime = date.split('T');
            if(mapDateTime && mapDateTime.length > 1){
               var mapDate = mapDateTime[0];
               var mapTime = mapDateTime[1].split(':');
               return (mapDate && mapTime[0] && mapTime[1]) ? (mapDate + ' ' + mapTime[0] +':'+ mapTime[1]) : date;
            }else {
                return date;
            }
        }

        function evServiceModal(map){
            var menu = map ? "mappingStatus" : vm.pnCTab ? "P2C" : vm.v2GTab ? "V2G" : vm.v2GTabNew ? "V2GNew" : vm.sCTab ? "smartCharging": null;

            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/evServices/popup/evServicePopup.html',
                controller: ["$scope", evServicePopupController],                
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    menu: menu
                }
            })
        }

        function evServicePopupController($scope){
            var refreshColor = vm.nissanUserURL ? '#FF8E8F' : 'var(--renaultPrimaryColor)';
            var refreshIcon = "<i class='fa fa-refresh' style='color: " + refreshColor + ";'></i>";

            $scope.v2gPopupMsg = $sce.trustAsHtml($translate.instant('V2G_NEW_POPUPMSG').replaceAll('[REFRESH_ICON]', refreshIcon));
            $scope.v2gPopupMsgNew = $sce.trustAsHtml($translate.instant('V2G_NEW_POPUPMSG').replaceAll('[REFRESH_ICON]', refreshIcon));
            $scope.p2cPopupMsg = $sce.trustAsHtml($translate.instant('P2C_POPUP_MSG').replace('[REFRESH_ICON]',refreshIcon))
            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function launchInstallation(certificateType) {
            restartService(rLinkConstant.certificate);
            var certificateTypes = {
                "OEM_PROVISIONING": "isPncLaunchEnabled",
                "VEHICLE_CERTIFICATE": "isV2gLaunchEnabled"
            };
            if (vm.oemDetails && vm.oemDetails.status && (vm.oemDetails.status === "INSTALLATION_ERROR" || vm.oemDetails.status === "PROVISIONING_ERROR" || vm.oemDetails.status === "PROVISIONED")) {
                blockUI.start();
                var auditData = certificateType === "OEM_PROVISIONING" ? "PNC repair" : "V2G repair";
                SearchArboTextualMetierService.setConnectedServicesAuditData(auditData).then(function () { });
                RLinkCarMetierService.launchInstallation(certificateType).then(function (data) {
                    if (certificateTypes[certificateType]) {
                        vm[certificateTypes[certificateType]] = false;
                    }
                    if (data && data.result === true) {
                        toastr.success($translate.instant('ACTION_TAKEN_INTO_ACCOUNT'));
                    } else {
                        toastr.error($translate.instant('ACTION_NOT_TAKEN_INTO_ACCOUNT'));
                    }
                }).finally(function () {
                    blockUI.stop();
                    restartService(rLinkConstant.certificate);
                    setTimeout(function () {
                        restartService(rLinkConstant.certificate);
                        if (certificateTypes[certificateType]) {
                            vm[certificateTypes[certificateType]] = true;
                        }
                        $scope.$apply();
                    }, 600000); // 10 minutes
                });

            } else {
                vm.isActionNotPossible = true;
            }
        }

        function getDisplayContract(data) {

            if (!data || !data.subscriptions || !data.subscriptions.contracts) {
                return null;
            }

            var contracts = data.subscriptions.contracts;
            var relevantContracts = _.filter(contracts, function (contract) {
                return _.some(contract.servicePacks, function(servicePack) {
                    return rLinkConstant.targetServiceSids.indexOf(servicePack.sid) !== -1;
                });
            });
            var activeContract = _.find(relevantContracts, function (contract) {
                return contract.status === 'ACTIVE';
            });

            var mostRecentContract = _.maxBy(relevantContracts, function (contract) {
                return new Date(contract.subscriptionDatetime);
            });

            return activeContract || mostRecentContract;

        }

        vm.togglePackOfServices = function () {
            vm.packOfServicesVisible = !vm.packOfServicesVisible;
        };

        function getTableData(){
            if(vm.evServicesTab){
                blockUI.start();
                RLinkCarMetierService.getCertificatesDiagnostic().then(function(data){
                    if(data && data.length > 0){
                        vm.vcpsData = data[0].serialNumber;
                        RLinkCarMetierService.getVehicleSerialNumber(false).then(function(bvaData){
                            if(bvaData && bvaData.data && bvaData.data.ecuReport){
                                if(bvaData.data.ecuReport.electronicControlUnits && bvaData.data.ecuReport.electronicControlUnits.length > 0){
                                    bvaData.data.ecuReport.electronicControlUnits.forEach(function (feature) {
                                        if(feature.ecuName == 'CPLC' || feature.ecuName == 'CPL'){
                                            if(feature.part && feature.part.partSerialNumber){
                                                vm.bvaData = feature.part.partSerialNumber.serialNumber;
                                            }
                                        }
                                    });
                                }
                            }
                        }).catch(function (error) {
                            //toastr.error(error);
                        });
                    }
                }).catch(function (error) {
                    //toastr.error(error);
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        function serviceSync(){
            blockUI.start();
            RLinkCarMetierService.patchSeriveSyncronization().then(function(data){
                if(data){
                    RLinkCarMetierService.getCertificatesDiagnostic().then(function(vcpsData){
                        if(vcpsData && vcpsData.length > 0){
                            vm.vcpsData = vcpsData[0].serialNumber;
                        }
                    }).catch(function (error) {
                       // toastr.error(error);
                    })
                }
            }).catch(function (error) {
                toastr.error(error.data.errors[0].errorMessage);
            }).finally(function () {
                blockUI.stop();
            });
        }

        function serviceSyncPopup(){
            $mdDialog.show({
                template: '<div class = "popinInfo "style = "padding:20px">'+'<div><strong>{{"RLINK_CONFIRMATION_POPUP_MESSAGE" | translate }}' +'\n<div><strong>'+ $translate.instant("CONFIRM_SYNC_MESSAGE") +'<div><strong><div style="margin:5% 35% 0 35%"> <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="onConfirm(true)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_YES"|translate}}</div></button>       <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="onCancel(false)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_NO"|translate}}</div></button></div> </div>',
                controller: ['$scope',confirmSyncMessagePopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    nissanUserURL: vm.nissanUserURL
                }
            })
        }

        function confirmSyncMessagePopupController($scope){
            $scope.nissanUserURL = vm.nissanUserURL;
            $scope.onCancel = function(){
                $mdDialog.hide();
            }
            $scope.onConfirm = function(){
                $mdDialog.hide();
                serviceSync();
            }
        }

        function refreshEvSettings() {
            $rootScope.$broadcast('enableLoader', true);

            RLinkCarMetierService.getEvSettingsData(RLinkCarUtils.getVin()).then(function (data) {

                vm.evSettingsData = data;
                if (vm.evSettingsData.chargeDuration) {
                    vm.evSettingsData.chargeDurationHours = convertToHoursMinutes(vm.evSettingsData.chargeDuration);
                }
                if (vm.evSettingsData.chargeTimeStart && vm.evSettingsData.chargeDuration) {
                    vm.evSettingsData.chargeEndTime = calculateChargeEndTime(vm.evSettingsData.chargeTimeStart, vm.evSettingsData.chargeDuration);
                }
                checkProgramsStatus(data);
                toastr.success($translate.instant('DATA_REFRESHED_SUCCESSFULLY'));

            }).catch(function (error) {
                vm.evSettingsData = null;
                vm.showNoDataFound = true;
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                $rootScope.$broadcast('enableLoader', false);
            });
        }

        function refreshSocLevels() {
            $rootScope.$broadcast('enableLoader', true);

            RLinkCarMetierService.getEvSettingsSoc(RLinkCarUtils.getVin()).then(function (data) {
                vm.evSettingsSocData = data;
                validateSocLevels(data);
                toastr.success($translate.instant('DATA_REFRESHED_SUCCESSFULLY'));
            }).catch(function (error) {
                vm.socLevelsValid = false;
                vm.socLevelsErrorMessage = 'SOC level is not set';
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                $rootScope.$broadcast('enableLoader', false);
            });
        }

        
        function validateSocLevels(data) {
            var socMinInvalid = !data || data.socMin === null || data.socMin === undefined || data.socMin === '' || data.socMin === 'unknown';
            var socTargetInvalid = !data || data.socTarget === null || data.socTarget === undefined || data.socTarget === '' || data.socTarget === 'unknown';

            if (socMinInvalid && socTargetInvalid) {
                vm.socLevelsValid = false;
                vm.socLevelsErrorMessage = $translate.instant('SOC_LEVEL_NOT_SET');
            } else {
                vm.socLevelsValid = true;
                vm.socLevelsErrorMessage = '';
            }
        }

        
        function checkProgramsStatus(data) {
            vm.showV2GWarning = false;
            vm.v2gWarningMessage = '';
            vm.showInstantaneousCharge = false;
            vm.showNoDataFound = false;
            
            if (!data) return;
            
          
            if (data.chargeModeRq === 'SCHEDULED') {
                if (!data.programs || !Array.isArray(data.programs) || data.programs.length === 0) {
                    vm.showInstantaneousCharge = true;
                    return; 
                }
            }
            
           
            if (data.chargeModeRq === 'V2G') {
                if (data.programs && Array.isArray(data.programs) && data.programs.length > 0) {
                    var allProgramsInactive = data.programs.every(function (program) {
                        return program.programActivationStatus === false;
                    });

                    if (allProgramsInactive) {
                        vm.showV2GWarning = true;
                        vm.v2gWarningMessage = $translate.instant('EV_SETTINGS_V2G_WARNING');
                    }
                }
            }
            
            
            if (data.chargeModeRq !== 'SCHEDULED') {
                if (!data.programs || !Array.isArray(data.programs) || data.programs.length === 0) {
                    vm.showNoDataFound = true;
                }
            }
        }

        vm.processedChargeDuration = "";

        function convertToHoursMinutes(minutes) {
            if (!minutes || isNaN(minutes)) return '0 hours';
            let hours = Math.floor(minutes / 60);
            let mins = minutes % 60;
            return mins === 0 ? `${hours} hours` : `${hours} hours ${mins} min`;
        }

        function calculateChargeEndTime(startTime, durationMinutes) {
            if (!startTime || !durationMinutes) return '-';
            try {
                var timeParts = startTime.split(':');
                if (timeParts.length < 1) return '-';
                
                var startHours = parseInt(timeParts[0], 10);
                var startMinutes = timeParts.length >= 2 ? parseInt(timeParts[1], 10) : 0;
                
                if (isNaN(startHours) || isNaN(startMinutes)) return '-';
                
                var totalMinutes = startHours * 60 + startMinutes + parseInt(durationMinutes, 10);
                
                var endHours = Math.floor(totalMinutes / 60) % 24;
                var endMinutes = totalMinutes % 60;
                
                return (endHours < 10 ? '0' : '') + endHours + ':' + (endMinutes < 10 ? '0' : '') + endMinutes;
            } catch (e) {
                return '-';
            }
        };

        function processResponse(response) {
            if (response) {
                vm.processedChargeDuration = convertToHoursMinutes(parseInt(response));
            } else {
                vm.processedChargeDuration = "-";
            }
        };

    }
})();

(function() {
    'use strict';
    angular.module('phenix.core').directive('waitingResponse', directiveWaitingResponse);
    /* @ngInject */
    function directiveWaitingResponse() {
        return {
            restrict: 'E',
            templateUrl:'app/components/car/rLinkCar/directives/waitingResponse.template.html',
            controller: controllerWaitingResponse,
            controllerAs: 'vm',
            scope:{
                show: '='
            }
        }
    }

    /* @ngInject */
    function controllerWaitingResponse ($scope) {
        var vm = this;
        vm.show = $scope.show;
    }
})();

(function() {
    'use strict';

    angular.module('phenix.core').directive('tableDataManager', directiveTableDataManager);

    /* @ngInject */
    function directiveTableDataManager() {
        return {
            restrict: 'A',
            templateUrl:'app/components/car/rLinkCar/directives/tableDataManager.template.html',
            controller: controllerTableDataManager,
            controllerAs: 'vm',
            scope:{
                data: '=',
                nbrColumn:'@',
                noTcuData:'@',
                noHuData:'@'
            }
        }
    }

    /* @ngInject */
    function controllerTableDataManager ($scope, $document, CacheService, CacheConstants, UtilsMetierService) {
        var vm = this;
        vm.nbrColumn = $scope.nbrColumn;
        vm.noTcuData = $scope.noTcuData;
        vm.getIteration = getIteration;
        vm.showError = $scope.data == null;
        vm.showEmpty = !vm.showError ? $scope.data.length == 0 : false;
        var user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(user);
        const connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.isCCS3 = connectedPlatform && connectedPlatform.architecture === 'CCS3';

        function getIteration(){
            return parseInt(vm.nbrColumn);
        };
    }

    angular.module('phenix.core').directive('tableWidth', ['rLinkConstant', function(rLinkConstant){
        return {
            restrict: 'A',
            scope:{
                data: '=',
                short: '=',
                custom: '='
            },
            link: function postLink(scope, element) {
                var arg0 = '';
                var size = scope.data != null ? scope.data.length : 0;
                var tmpLine = 0;
                if(scope.custom != null){
                    tmpLine = scope.custom;
                }else{
                    tmpLine = scope.short ? -1 : rLinkConstant.tableLine;
                }

                if(size > tmpLine){
                    arg0 = 'list-width';
                }else{
                    arg0 = 'full-width';
                }
                element.addClass(arg0);
            }
        }
    }]);

    angular.module('phenix.core').directive('dateTitle', ['$translate', 'rLinkConstant', function($translate, rLinkConstant){
        return {
            restrict: 'A',
            link: function (scope, element) {
                var msg = $translate.instant('RLINKCAR_DATE_FORMAT') + ' : '+ rLinkConstant.dateFormat.toUpperCase();
                 element[0].title = msg;
            }
        }
    }]);
})();

(function() {
    'use strict';
    angular.module('phenix.core').directive('rlinkTip', directiveRlinkTip);
    /* @ngInject */
    function directiveRlinkTip() {
        return {
            restrict: 'EA',
            templateUrl:'app/components/car/rLinkCar/directives/rlinkTip.template.html',
            controller: controllerRlinkTip,
            controllerAs: 'vm',
            scope:{
                tipValue:'@',
                tipTitle: '@',
                tipClass: '@'
            }
        }
    }

    /* @ngInject */
    function controllerRlinkTip ($scope, $translate, rLinkConstant, CacheService, CacheConstants) {
        var vm = this;

        vm.tipValue = $scope.tipValue;
        vm.tipTitle = getTitle();
        vm.tipClass = $scope.tipClass;


        function getTitle(){
            vm.language = CacheService.getObject(CacheConstants.profil).language;
            var dateFormat =  vm.language === 'fr' ? 'dd/MM/yyyy' : rLinkConstant.dateFormat;

            if ($scope.tipTitle === 'date') {
                return $translate.instant('RLINKCAR_DATE_FORMAT') + ' : '+ dateFormat;
            } else {
                return $scope.tipTitle;
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('phenix.core').directive('rlinkHeader', directiveRlinkHeader);
    /* @ngInject */
    function directiveRlinkHeader() {
        return {
            restrict: 'EA',
            templateUrl:'app/components/car/rLinkCar/directives/rlinkHeader.template.html',
            controller: controllerRlinkHeader,
            controllerAs: 'vm',
            scope:{
                type:'=',
                bose: '=',
                dab:'=',
                carPlay:'=',
                HU: '=',
                TCU: '='
            }
        }
    }

    /* @ngInject */
    function controllerRlinkHeader ($rootScope, $scope, CacheService, CacheConstants, $mdDialog, RLinkCarMetierService, configConstantes,CarSearchMetierService) {
        var vm = this;

        vm.bose = $scope.bose;
        vm.dab = $scope.dab;
        vm.type = $scope.type;
        vm.carPlay = $scope.carPlay;
        vm.path = $scope.path;
        vm.HU = $scope.HU;
        vm.TCU = $scope.TCU;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.isBodyType = false;
        vm.userProfil = CacheService.getUserProfile();
        vm.dataPrivacy = $scope.dataPrivacy;
        vm.privacyMode = $scope.privacyMode;
        vm.hideHeader = RLinkCarMetierService.getHideHeader();
        vm.importantInfoPopup = importantInfoPopup;

        $scope.$watch(function() {
            return RLinkCarMetierService.getHideHeader();
        }, function(newVal) {
            vm.hideHeader = newVal;
        });

        $rootScope.$on("path", function(event, name) {
            vm.path = name;
        });

        $rootScope.$on("bose", function(event, name) {
          vm.bose = name;
        });

        $rootScope.$on("dab", function(event, name) {
          vm.dab = name;
        });

        $rootScope.$on("type", function(event, name) {
          vm.type = name;
        });

        $rootScope.$on("carPlay", function(event, name) {
          vm.carPlay = name === 'SPMIR';
        });

        $rootScope.$on("HU", function(event, value) {
            vm.HU = value;
        });

        $rootScope.$on("TCU", function(event, value) {
            vm.TCU = value;
        });

        $rootScope.$on("dataPrivacy", function(event, value){
            vm.dataPrivacy = value;
        });

        $rootScope.$on("privacyMode", function(event, value){
            vm.privacyMode = value;
        });

        $rootScope.$on("easyLinkDataLoaded", function(event, value){
            vm.ready = value;
        });

        $rootScope.$on("privacyType", function(event, value){
            vm.privacyType = value;
        });


        var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        var platform = connectedPlatform !== null ? connectedPlatform.platform : null;
        var architecture = connectedPlatform !== null ? connectedPlatform.architecture : null;
        vm.architecture = architecture;
        var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
        var validBodyTypes = ['BCB', 'HHN', 'RHN', 'HCB', 'DHN', 'X1310','XDD', 'XDE'];
        if(carContext && !_.isEmpty(carContext) && carContext.fixedCriterias && !_.isEmpty(carContext.fixedCriterias) && (validBodyTypes.includes(carContext.fixedCriterias['008'])||validBodyTypes.includes(carContext.fixedCriterias['007']))){
          vm.isBodyType = true;
         }
        if(platform === 'EASYLINK' || platform === 'AVN' || platform === 'CVC' || platform === 'RGDC'){
            if (architecture === 'CCS1' || architecture === 'CCS2' || architecture === 'CCS3'){
                getCommercialLabel().then(function(commercialLabel) {
                    if(commercialLabel!==null && commercialLabel!==undefined && commercialLabel !== ''){
                        vm.rLinkHeader = commercialLabel;
                        CacheService.setObject(
                            CacheConstants.connectedPlatform,
                            Object.assign({}, connectedPlatform, {
                                commercialLabel: commercialLabel
                            })
                        );
                    }
                    else{
                        if (architecture === 'CCS2') {
                            vm.rLinkHeader = 'openRlink';
                            CacheService.setObject(
                                CacheConstants.connectedPlatform,
                                Object.assign({}, connectedPlatform, {
                                    commercialLabel: "openRlink",
                                })
                            );
                        } else if (architecture === 'CCS3') {
                            vm.rLinkHeader = 'Open R evo';
                            CacheService.setObject(
                                CacheConstants.connectedPlatform,
                                Object.assign({}, connectedPlatform, {
                                    commercialLabel: "Open R evo",
                                })
                            );
                        } else {
                            vm.rLinkHeader = "EasyLink";
                            CacheService.setObject(
                                CacheConstants.connectedPlatform,
                                Object.assign({}, connectedPlatform, {
                                    commercialLabel: "EasyLink",
                                })
                            );
                        }
                    }
                    $rootScope.commercialLabelValue = vm.rLinkHeader;
                    $rootScope.$broadcast('commercialLabelResolved', vm.rLinkHeader);
                });
            }
            else {
                vm.rLinkHeader = 'EasyLink';
            }
            vm.isEasyLink = true;
        }
        else if(platform === 'rlink2' && (connectedPlatform.vehicle && connectedPlatform.vehicle === 'rlink1')){
            vm.rLinkHeader = vm.isBodyType ? 'openRlink' : 'R-Link1';
            vm.isEasyLink = false;
        }
        else{
            vm.rLinkHeader = vm.isBodyType ? 'openRlink' : 'R-Link2';
            vm.isEasyLink = false;
        }

        function importantInfoPopup(isInfoPop){
            var isInfoStatusPopup = isInfoPop;
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/vehicleInformations/popup/importantInfoPopup.template.html',
                controller: ["$scope", infoPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg',
                locals:{
                    isInfoStatusPopup: isInfoStatusPopup,
                    userLanguage: vm.userProfil.language.toLowerCase()
                }
            })
        }
        function infoPopupController($scope){
            var vm = this;
            $scope.isInfoStatusPopup = vm.isInfoStatusPopup;
            $scope.userLanguage = vm.userLanguage;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }
        
        function getCommercialLabel() {
            var params = {
                linkName: "MU2-R0002",
                lang: "fr",
                date: "ALL",
                page: 1,
                pageSize: 1000
            };
            var body = {
                targetCriterias: [
                    {
                        apiTechnicalId: "family",
                        values: [carContext.families.familyVehicle[0]],
                        language: "non_translatable",
                    },
                    {
                        apiTechnicalId: "idBrand",
                        values: [carContext.brandComputed],
                        language: "non_translatable",
                    },
                    {
                        apiTechnicalId: "425menominc",
                        values: [carContext.fixedCriterias["425"]],
                        language: "non_translatable",
                    },
                ],
                operator: "AND",
            };
            return CarSearchMetierService.getConnectedPlatformCommercialLabel(
                params,
                body
            ).then(function (response) {
                var commercialNameLabel = response && response._embedded && response._embedded.linesMappingList && response._embedded.linesMappingList[0] && response._embedded.linesMappingList[0].sourceAttributesData && response._embedded.linesMappingList[0].sourceAttributesData.commercialNameLabel ? response._embedded.linesMappingList[0].sourceAttributesData.commercialNameLabel : {};
                return (commercialNameLabel['fr'] || '').toUpperCase();
            });
        }
    }
})();
(function() {
    'use strict';
    angular.module('phenix.core').directive('diskSpace', directiveDiskSpace);
    /* @ngInject */
    function directiveDiskSpace() {
        return {
            restrict: 'EA',
            templateUrl:'app/components/car/rLinkCar/directives/diskSpace.template.html',
            controller: controllerDiskSpace,
            controllerAs: 'vm',
            scope:{
                total: '=',
                empty:'='
            }
        }
    }

    /* @ngInject */
    function controllerDiskSpace ($scope, configConstantes) {
        var vm = this;
        vm.total = $scope.total;
        vm.empty = $scope.empty;
        vm.filled = $scope.total - $scope.empty;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.getWidth = getWidthPercent;

        function getWidthPercent(){
            var percent = (vm.filled * 100) / vm.total;
            return percent.toFixed(2);
        };
    }
})();

angular.module('phenix.core').filter('reverse', ['$filter', function($filter) {
    var vm = this;
    return function (items) {
        return items ? items.slice().reverse() : [];
    };
}]).filter('emptyToEnd', function() {
    return function (array, key) {
        if(!angular.isArray(array)) return;
        var present = array.filter(function (item) {
            return item[key];
        });
        var empty = array.filter(function (item) {
            return !item[key]
        });
        return present.concat(empty);
    }
}).filter('rlinkOrderBy', ['$filter', function($filter) {
    return function (items) {
        var arg = arguments[1];
        var order = arguments[2]
        var result = $filter('orderBy')(items, order+arg);
        var finalOrder = $filter('emptyToEnd')(result, arg);
        return finalOrder;
    };
}]);

angular.module('phenix.core')
    .filter('rlinkformat',
                    ['$filter','$translate','rLinkConstant', 'CacheConstants', 'CacheService',
            function($filter, $translate, rLinkConstant, CacheConstants, CacheService) {
    var vm = this;
    vm.convertSize = convertSize;
    vm.translateStatus = translateStatus;
    vm.language = CacheService.getObject(CacheConstants.profil).language;
    return function (input) {
        var type = arguments[1];
        if(angular.isUndefined(input) || input === null || input === ""){
            return '-';
        }

        var dateFormat = rLinkConstant.dateFormat;
        var dateYearFormat = rLinkConstant.dateYearFormat;

        var d;
        switch (type) {
            case 'date':
                d = ("" + input).replace('@', 'T');
                // Check if date has no time component (date-only format like "2024-07-17")
                var hasTime = d.indexOf('T') !== -1 && d.split('T')[1] && d.split('T')[1].trim() !== '';
                if (!hasTime) {
                    // For date-only strings, parse without UTC to avoid timezone offset issues
                    var dateParts = d.split('-');
                    if (dateParts.length === 3) {
                        var localDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
                        return $filter('date')(localDate, dateFormat);
                    }
                }
                return $filter('date')(d, dateFormat, 'UTC');
            case 'full-date':
                d = ("" + input).replace('@', 'T');
                return $filter('date')(d, dateFormat + ' HH:mm', 'UTC');
            case 'time-seconds':
                d = ("" + input).replace('@', 'T');
                return $filter('date')(d, 'HH:mm:ss', 'UTC');
            case 'full-date-seconds':
                d = ("" + input).replace('@', 'T');
                return $filter('date')(d, dateFormat + ' HH:mm:ss', 'UTC');
            case 'full-date-year-new':
                var inputDate = new Date(input);
                var utcDate = new Date(inputDate.getTime() + inputDate.getTimezoneOffset() * 60000);
                var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' };
                var formattedDate = new Intl.DateTimeFormat('en-CA', options).format(utcDate);
                return formattedDate.replace(',', '');
            case 'full-date-year':
                d = ("" + input).replace('@', 'T');
                // Check if date has no time component
                var hasTimeYear = d.indexOf('T') !== -1 && d.split('T')[1] && d.split('T')[1].trim() !== '';
                if (!hasTimeYear) {
                    // For date-only strings, parse without UTC to avoid timezone offset issues
                    var datePartsYear = d.split('-');
                    if (datePartsYear.length === 3) {
                        var localDateYear = new Date(parseInt(datePartsYear[0]), parseInt(datePartsYear[1]) - 1, parseInt(datePartsYear[2]));
                        return $filter('date')(localDateYear, dateYearFormat);
                    }
                }
                return $filter('date')(d, dateYearFormat, 'UTC');
            case 'tcu':
                var arg = input.substr(3);
                return arg;
            case 'convert':
                return vm.convertSize(input);
            case 'status':
                return vm.translateStatus(input);

            default:
                return input;
        }
    };

    function convertSize(aSize){
    	aSize = Math.abs(parseInt(aSize, 10));
    	var def = [[1, 'Octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];
    	for(var i=0; i<def.length; i++){
    		if(aSize<def[i][0]){
    		    return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1];
    		}
    	}
    }

    function translateStatus(value) {
        var tmp = 'CONNECTED_SERVICES_' + value + '_STATUS';
        var translate = $translate.instant(tmp);
        if(translate.includes('STATUS')) {
            return value;
        }
        return translate;
    }
}]);

(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('DiagnosisController', DiagnosisController)
        .config(['markedProvider', function (markedProvider) {
          markedProvider.setOptions({
              gfm: true,
              breaks: true
          });
        }]);

    /* @inject */
    function DiagnosisController(
        $window,
        $state,
        $translate,
        $stateParams,
        $filter,
        usersProfile,
        RLinkCarMetierService,
        RLinkCarUtils,
        CacheService,
        RoutesConstants,
        CacheConstants,
        configConstantes,
        toastr,
        blockUI,
        $mdDialog
    ) {

        /** VARIABLES */
        var vm = this;
        var services = RLinkCarUtils;

        vm.recapCarAPI = null;
        vm.diagnosis = null;
        vm.currentDiagnosis = null;
        vm.diagList = [];
        vm.routineResponse = null;
        vm.diagAnswers = [];
        vm.showLoading = false;
        vm.isAutoStep = false;
        vm.isEndStep = false;
        vm.isReadOnly = false;
        vm.isSimpleStep = false;
        vm.isInputStep = false;
        vm.fatalError = false;
        vm.showColumns = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        vm.goToVehicleInformation = goToVehicleInformation;
        vm.startDiagnosis = startDiagnosis;
        vm.goToSelectDiag = goToSelectDiag;
        vm.nextStep = nextStep;
        vm.previousNode = previousNode;
        vm.showNextBtn = showNextBtn;
        vm.showCloseBtn = showCloseBtn;
        vm.showHelp = showHelp;
        vm.endDiagnosis = endDiagnosis;
        vm.callRoutine = callRoutine;
        vm.formatText = formatText;
        vm.showNavigationBtn = showNavigationBtn;
        vm.copyToClipboard = copyToClipboard;
        vm.storeReport = storeReport;
        vm.getUserType = getUserType;
        vm.sort = sort;
        vm.showUserType = showUserType;
        vm.field = 'datetime';
        vm.reverse = '-';
        vm.diagHistory = [];
        vm.diagResume = [];
        vm.showTable = true;
        var sortHelp = {
            1: {title: 'type', reverse: false},
            2: {name: 'userId.ipn', reverse: false},
            3: {name: 'userId.name', reverse: false},
            4: {name: 'userId.profile', reverse: false},
            5: {name: 'datetime', reverse: false}
        };

        var tagHisto = CacheConstants.histoyDiagnosis;
        var tagReport = CacheConstants.reportDiagnosis;
        vm.navBar = CacheService.getObject(tagHisto);
        vm.report = CacheService.getObject(tagReport);

        vm.isDiagnosis = $stateParams.isDiagnosis;
        vm.typeDiag = $stateParams.type;
        vm.idDiag = $stateParams.idDiag;
        vm.idNode = $stateParams.idNode;

        this.$onInit = function () {
            if (vm.isDiagnosis) {
                initDiagnosis();
            } else {
                vm.pageSelectDiag = true;
                initSelection();
            }
        }

        function initDiagnosis() {
            blockUI.start();
            RLinkCarMetierService.getNextDiagnosis(vm.idDiag, vm.idNode).then(function (data) {
                if (angular.equals(data, {})) {
                    toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                }
                vm.currentDiagnosis = data;
                vm.diagAnswers = angular.copy(vm.currentDiagnosis.transitions);

                manageNavigationView();
                manageTypeDiag();
                vm.mapDiags = {};

                // Prefill
                if (vm.isInputStep) {
                    var params = vm.currentDiagnosis.routine.parameters;
                    vm.input = (getInputValue(params) !== undefined) ? getInputValue(params) : '';
                }
                if (vm.isAutoStep && !vm.isInputStep) {
                    callRoutine();
                }
                if (!vm.fatalError && vm.isEndStep) {
                    storeReport(true);
                }
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                vm.fatalError = true;
                storeReport(false);
            }).finally(function () {
                blockUI.stop();
            });
        }

        function initSelection() {
            resetHistory();
            vm.diagList = CacheService.getObject(CacheConstants.diagList);
            getDiagHistory();
            vm.showColumns = services.isEligibleUser();
        }

        function setInputValue(params, answer) {
            for (var i = 0; i < params.length; i++) {
                if (params[i].name !== 'vin') {
                    vm.mapDiags[params[i].name] = answer;
                    CacheService.setObject(CacheConstants.mapDiags, vm.mapDiags);
                }
            }
        }

        function getInputValue(params) {
            for (var i = 0; i < params.length; i++) {
                var mapDiags = CacheService.getObject(CacheConstants.mapDiags);

                if(mapDiags !== null && params[i].name !== 'vin') {
                    return mapDiags[params[i].name];
                }
            }
        }

        function callRoutine() {
            vm.showLoading = true;
            if (vm.fatalError) {
                vm.fatalError = false;
            }
            var input = vm.input != null ? vm.input.trim() : null;
            var params = vm.currentDiagnosis.routine.parameters;
            var nameRoutine = vm.currentDiagnosis.routine.kebabName;
            RLinkCarMetierService.callRoutine(nameRoutine, input).then(function (response) {
                vm.routineResponse = extractResult(response);
                if (vm.routineResponse) {
                    vm.diagAnswers = $filter("filter")(vm.currentDiagnosis.transitions, vm.routineResponse);
                    vm.showLoading = false;
                    setInputValue(params, input);
                    nextStep();
                }
            }).catch(function () {
                vm.showLoading = false;
                vm.fatalError = true;
                storeReport(false);
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                //There was a problem with your request. Please try again later.
            });
        }

        function getDiagHistory() {
            RLinkCarMetierService.getDiagHistory().then(function (response) {
                vm.diagHistory = response;
                sort(5);
            }).catch(function () {
                toastr.error('Can not load diagnosis history');
            });
        }

        function manageNavigationView() {
            if (vm.navBar == null) {
                vm.navBar = [];
            }
            var lastDiag = (vm.navBar !== null) ? vm.navBar[vm.navBar.length - 1] : null;
            if (lastDiag == null || vm.currentDiagnosis.id !== lastDiag.id) {
                vm.navBar.push({id: vm.currentDiagnosis.id, name: vm.currentDiagnosis.title});
                CacheService.setObject(tagHisto, vm.navBar);
            }
        }

        function manageReport(to, response) {
            if (vm.report == null) {
                vm.report = [];
            }

            var lastReport = vm.report[vm.report.length - 1];
            if (lastReport == null || vm.currentDiagnosis.id !== lastReport.id) {
                vm.report.push({id: vm.currentDiagnosis.id, to: to, response: response});
                CacheService.setObject(tagReport, vm.report);
            }
        }

        function storeReport(success) {
            if (vm.report == null) {
                vm.report = [];
            }

            var userInfo = services.getUserInfo();
            userInfo.type = getUserType();
            vm.finalReport = {
                datetime: new Date(),
                path: [],
                title: vm.typeDiag,
                userId: userInfo,
                vin: services.getVin(),
                success: success
            };

            vm.report.forEach(function (item) {
                var tmp = {
                    destinationNode: item.to,
                    response: item.response,
                    sourceNode: item.id
                };
                vm.finalReport.path.push(tmp);
            });

            RLinkCarMetierService.saveDiag(vm.finalReport).then(function (data) {
                vm.diagResume = data;
            });
        }

        function goToVehicleInformation() {
            CacheService.setObject(CacheConstants.fromDiagnosis, true);
            resetHistory();
            $state.go(RoutesConstants.carSearchResult);
        }

        function goToSelectDiag() {
            resetHistory();
            $state.go(RoutesConstants.diagnosis);
        }

        function previousNode() {
            vm.navBar.splice(-1, 1);
            CacheService.setObject(tagHisto, vm.navBar);
            vm.report.splice(-1, 1);
            CacheService.setObject(tagReport, vm.report);
            $window.history.back();
        }

        function startDiagnosis() {
            if (vm.diagnosis.startingNode != null) {
                goToDiagnosisProcess(vm.diagnosis.startingNode.id);
            } else {
                toastr.error("Starting node not found !");
            }
        }

        function goToDiagnosisProcess(id) {
            $state.go(RoutesConstants.diagnosisProcess, {
                idDiag: vm.diagnosis.id,
                idNode: id,
                type: vm.diagnosis.title
            });
        }

        function nextStep(item) {
            var to = null;
            var answer = null;

            if (item == null) {
                to = vm.isAutoStep ? vm.diagAnswers[0].destinationNodeId : vm.currentDiagnosis.transitions[0].destinationNodeId;
                answer = vm.isAutoStep ? vm.diagAnswers[0].code : vm.currentDiagnosis.transitions[0].code;
            } else {
                to = item.destinationNodeId;
                answer = item.code;
            }
            if (to == null) {
                toastr.error("Unknown node destination !");
                vm.fatalError = true;
                storeReport(false);
                return;
            }
            manageReport(to, answer);
            $state.go(RoutesConstants.diagnosisProcess, {idDiag: vm.idDiag, idNode: to, type: vm.typeDiag});
        }

        function endDiagnosis() {
            goToVehicleInformation();
        }

        function showNextBtn() {
            if (vm.fatalError) {
                return false;
            }

            if (!vm.isAutoStep) {
                return vm.currentDiagnosis !== null && vm.currentDiagnosis.transitions.length === 1;
            }
        }

        function showHelp() {
            return vm.currentDiagnosis !== null && vm.currentDiagnosis.detail !== null && vm.currentDiagnosis.detail !== "";
        }

        function showCloseBtn() {
            return vm.fatalError || vm.isEndStep;
        }

        function manageTypeDiag() {
            var transition = vm.currentDiagnosis.transitions;
            vm.isAutoStep = vm.currentDiagnosis.routine != null;
            vm.isEndStep = transition.length === 0;
            vm.isSimpleStep = !vm.isAutoStep && transition.length > 1;
            vm.isReadOnly = transition.length === 1;
            vm.isInputStep = vm.isAutoStep && vm.currentDiagnosis.routine.parameters.length > 1;
        }

        function resetHistory() {
            CacheService.removeObject(tagHisto);
            resetReport();
        }

        function resetReport() {
            CacheService.removeObject(tagReport);
            CacheService.removeObject(CacheConstants.mapDiags);
        }

        function extractResult(data) {
            var keys = Object.keys(data);
            var result = data[keys[0]];
            return result;
        }

        function formatText(input) {
            return services.formatText(input);
        }

        function showNavigationBtn() {
            return vm.fatalError || vm.isInputStep || vm.isReadOnly || vm.isSimpleStep || vm.isEndStep;
        }

        function sort(id) {
            var result = services.sort(id, 'exth', sortHelp);
            vm.field = result['field'];
            vm.reverse = result['reverse'];
        }

        vm.showHistoDiag = showHistoDiag;

        function showHistoDiag(item) {
            openReport(item);
        }

        // MODAL
        function openReport(report) {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/diagnosis/report.html',
                controller: ["$scope", modalController],
                bindToController: true,
                controllerAs: 'vm',
                size: 'lg',
                locals: {
                    diagReport: report,
                    nissanUserURL: vm.nissanUserURL
                }
            });
        }

        function modalController($scope) {
            var vm = this;
            $scope.close = function () {
                $mdDialog.hide();
            }
            $scope.typeDiag = vm.diagReport.title;
            $scope.dateDiag = vm.diagReport.datetime;
            $scope.nissanUserURL = vm.nissanUserURL;
            var keys = extractDiagResponseKey(vm.diagReport.jsonReport);
            var hasReport = vm.diagReport.report !== "" && checkData(vm.diagReport.report) !== null;

            var report = hasReport ? vm.diagReport.report : keys;
            $scope.report = formatDiagReport(report);
        }

        // Regex to check multiple newline without content
        function checkData(data) {
            var regex = /\w+/gm;
            return data.match(new RegExp(regex));
        }

        // Extract keys when no translations available
        function extractDiagResponseKey(data) {
            var responses = JSON.parse(data).path;
            var keys = '';
            for (var i = 0; i < responses.length; i++) {
                if (i !== responses.length - 1) {
                    keys += responses[i].response + '\n';
                } else {
                    keys += responses[i].response;
                }
            }
            return keys;
        }

        function formatDiagReport(data) {
            return (data != null && data !== "") ? data.split('\n') : null;
        }

        function copyToClipboard(id) {
            return services.copyToClipboard(id, vm.diagResume.report);
        }

        function showUserType(userId) {
            var userProfile = userId.profile !== undefined ? convertUserProfileToUserType(userId.profile) : '-';
            var userType = userId.type !== undefined ? userId.type : userProfile;
            return userType;
        }

        function convertUserProfileToUserType(userProfile) {
            var type = '';
            var profile = userProfile.toLowerCase();
            if (profile === usersProfile.reseau_et_importateur || profile === usersProfile.réseau_et_importateur) {
                type = 'CONNECTED_SERVICES_USER_PROFILE_NETWORK';
            }
            if (profile === usersProfile.assistance_technique_N1 || profile === usersProfile.assistance_technique_N2 || profile === '') {
                type = 'CONNECTED_SERVICES_USER_PROFILE_CORPORATE';
            }
            return $translate.instant(type);
        }

        function getUserType() {
            var userType = CacheService.getUserProfile().userType;
            var type = '';
            if (userType === 'ARCA') {
                type = 'CONNECTED_SERVICES_USER_PROFILE_CORPORATE';
            }
            if (userType === 'RNET') {
                type = 'CONNECTED_SERVICES_USER_PROFILE_NETWORK';
            }

            return $translate.instant(type);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('contractsAndServices', {
            bindings: {
                data: '<'
            },
            controller: ContractsAndServicesComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/contractsAndServices/contractsAndServices.template.html'
        });

    function ContractsAndServicesComponent(
        $mdDialog,
        $scope,
        $filter,
        $rootScope,
        $state,
        CacheService,
        CacheConstants,
        RLinkCarMetierService,
        UtilsMetierService,
        configConstantes,
        blockUI,
        $q,
        $log,
        $translate,
        toastr,
        rLinkConstant,
        MainMetierService,
        SearchArboTextualMetierService,
        $window
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.getCarSubscriptions = getCarSubscriptions;
        vm.openExtendedView = openExtendedView;
        vm.launchSynchronizeModal = launchSynchronizeModal;
        vm.launchTechnicalSynchronizeModal = launchTechnicalSynchronizeModal;
        vm.openSynchronizationHistoryModal = openSynchronizationHistoryModal;
        vm.synchronizeContract = synchronizeContract;
        vm.openHistoryOfRetryModal = openHistoryOfRetryModal;
        vm.selectTab = selectTab;
        vm.isSelected = isSelected;
        vm.showTable = false;
        vm.showTerminatedTable = false;
        vm.showNoHistoryMessage = false;
        vm.subscriptions = [];

        vm.subscriptionsOnGoing = [];
        vm.subscriptionsTerminated = [];
        vm.subscriptionsCancelled = [];
        vm.subscriptionsConfirmed = [];

        vm.allServiceIds = [];
        vm.allFeatureIds = [];

        vm.subTerminated = [];
        vm.allSubscriptions = [];
        $scope.field = 'atcproductName';
        $scope.fieldTerminated = 'subscriptionEndDate';
        $scope.sort = '+';
        $scope.sortTerminated = '-';
        vm.sortBy = sortBy;
        vm.overrideAccordionOpening = overrideAccordionOpening;
        vm.contextCarRequest = CacheService.getCarContext();
        vm.vin = vm.contextCarRequest && !_.isEmpty(vm.contextCarRequest) && vm.contextCarRequest.vin ? vm.contextCarRequest.vin : ""


        vm.accordions = {contractsAccordion:{}, commercialServicesAccordion:{}, technicalServicesAccordion:{}};
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.language = CacheService.getObject(CacheConstants.profil).language;
        var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.isEasyLink = (connectedPlatform !== null && (connectedPlatform.platform === "EASYLINK" || connectedPlatform.platform === 'AVN' || connectedPlatform.platform === 'CVC' || connectedPlatform.platform === 'RGDC'));
        var isEasyLink = vm.isEasyLink;
        vm.user = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.user.roles);
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        vm.todayDate = new Date(); 

        vm.isAuthorized = false;
        vm.selectedAll = false;
        vm.allContractsSelected = false;
        vm.hideDeactivateBtn = false;
        vm.isDdpServiceDeactivated = UtilsMetierService.ddpServiceDeactivatedDisplay(vm.user);
        vm.firstData = [];
        vm.contactsServicesHistory = [];
        vm.fixResponseOne = [];
        vm.fixResponseTwo = [];
        vm.fixResponseThree = [];
        vm.toggleAllTechCheckBoxes = toggleAllTechCheckBoxes;
        vm.onIndividualTechnicalSelect = onIndividualTechnicalSelect;
        vm.onIndividualContractsSelect = onIndividualContractsSelect;
        vm.contractsServiceSync = contractsServiceSync;
        vm.contractsServiceSyncHistory = contractsServiceSyncHistory;
        vm.deActivateFeature = deActivateFeature;
        vm.refreshData = refreshData;
        vm.refreshTechData = refreshTechData;

        var datas = [];
        var status = '';

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            getCarSubscriptions();
            configureAccordions();
            vm.isAuthorized = RLinkCarMetierService.isAuthorizedUser();
        }

        function contractsServiceSyncHistory(isFromContOrTech, contractHistory, nissanUserURL){           
            contractsServiceSync(isFromContOrTech, contractHistory, nissanUserURL);
        }

        function refreshData(){
            blockUI.start();
            $window.scrollTo({ top: 0, behavior: 'smooth' });
            RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                if (!_.isEmpty(data)) {
                    if(!_.isEmpty(data.subscriptions) && !_.isEmpty(data.subscriptions.technicalServices) && !_.isEmpty(data.subscriptions.technicalServices[0])){
                        vm.technicalServices = !_.isEmpty(data.subscriptions.technicalServices[0].features) ? data.subscriptions.technicalServices[0].features : [];
                    }
                }
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function showHistorySyncPopup(isFromContOrTech) {
            if (!_.isEmpty(vm.fixResponseTwo.content)) {
                vm.contactsServicesHistory = [];
                vm.firstData = [];

                if (!_.isEmpty(vm.fixResponseTwo) && vm.fixResponseTwo.content) {
                    vm.fixResponseTwo.content.forEach(function (item) {
                        if (!_.isEmpty(item)) {
                            var secondDataDetails = [];
                            if(item.provisioningDetails){
                                var serviceStatusBeforeSync = item.provisioningDetails.serviceStatusBeforeSync;
                                var currentStatusBeforeSync = item.provisioningDetails.currentServiceStatus; 
                                if (isFromContOrTech === 'isContract') {
                                    secondDataDetails = callServiceOrFeature('services', 'sid', serviceStatusBeforeSync, currentStatusBeforeSync);
                                } else {
                                    secondDataDetails = callServiceOrFeature('features', 'uid', serviceStatusBeforeSync, currentStatusBeforeSync);
                                }    
                            }                   
                            var serviceStatus = $translate.instant('CONNECTED_SERVICES_' + item.status + '_STATUS');
                            var translatedProvisioningType = (item.provisioningProcessType == rLinkConstant.provisioningRealignmentType) ? $translate.instant('SYNCHRONIZATION_REALIGNMENT') : $translate.instant('SYNCHRONIZATION_SERVICE_ACTIVATION');                           
                            vm.firstData.push({
                                provisioningRequestId: item.provisioningRequestId,
                                status: serviceStatus,
                                reqStatus: item.status,
                                creationDate: item.creationDate,
                                endDate: item.endDate,
                                provisioningProcessType: translatedProvisioningType,
                                originalProvisioningProcessType: item.provisioningProcessType,
                                secondData: secondDataDetails,
                                sids:item.sids,
                                uids:item.uids
                            });
                        }
                    });

                    vm.contactsServicesHistory = vm.firstData.filter(function(item) {
                        var hasNonEmptySids = !_.isEmpty(item.sids) && item.sids.some(function(sid) { 
                            return sid && sid !== ""; 
                        });
                        var hasNonEmptyUids = !_.isEmpty(item.uids) && item.uids.some(function(uid) { 
                            return uid && uid !== ""; 
                        });

                        if (item.originalProvisioningProcessType === 'REALIGNMENT') {
                            return true;
                        }
                        
                        if (item.originalProvisioningProcessType === 'SERVICES_ACTIVATION') {
                            if (isFromContOrTech === 'isContract') {
                                var shouldShow = hasNonEmptySids;
                                return shouldShow;
                            } else if (isFromContOrTech === 'isTech') {
                                var shouldShow = hasNonEmptyUids;
                                return shouldShow;
                            }
                        }
                        
                        return false;
                    });

                    vm.showNoHistoryMessage = _.isEmpty(vm.contactsServicesHistory);

                    $mdDialog.show({
                        templateUrl: 'app/components/car/rLinkCar/contractsAndServices/popup/synchronizationHistoryPopup.template.html',
                        controller: ["$scope", synchronizationHistoryPopupController],
                        controllerAs: 'vm',
                        bindToController: true,
                        clickOutsideToClose: true,
                        size: 'lg',
                        locals: {
                            isFromContOrTech: isFromContOrTech,
                            contactsServicesHistory: vm.contactsServicesHistory,
                            error: false,
                            showNoHistoryMessage: vm.showNoHistoryMessage
                        }
                    });
                }
            }
        }
        function callServiceOrFeature(type, idVal, serviceStatusBeforeSync, currentStatusBeforeSync) {
            var secondData = [];
            serviceStatusBeforeSync[0][type].forEach(function (serviceData) {
                currentStatusBeforeSync[0][type].forEach(function (current) {
                    if (current[idVal] === serviceData[idVal]) {
                        secondData.push({
                            sid: serviceData[idVal],
                            name: serviceData.name,
                            status: serviceData.status,
                            syncStatus: current.status,
                            updatedAt: current.updatedAt
                        });
                    }
                })
            })
            return secondData;
        }

        function synchronizationHistoryPopupController($scope){
            var vm = this;
            $scope.isFromContOrTech = vm.isFromContOrTech;
            $scope.contactsServicesHistory = vm.contactsServicesHistory;
            vm.itemsPerPage = 5;
            vm.currentPage = 1;

            vm.getTotalPages = function () {
                return Math.ceil(vm.contactsServicesHistory.length / vm.itemsPerPage) || 1;
            };

            vm.pageChange = function (page) {
                if (page < 1 || page > vm.getTotalPages()) return;
                vm.currentPage = page;
                updatePagedHistory();
            };

            function updatePagedHistory() {
                var start = (vm.currentPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.pagedContactsServicesHistory = vm.contactsServicesHistory.slice(start, end);
            }
            updatePagedHistory();

            $scope.isArrayEmpty = function(arr) {
                return !arr || arr.length === 0 || (arr.length === 1 && arr[0] === "");
            };

            $scope.close = function(){
                $mdDialog.hide();
            }
            $scope.refreshSyncData = function(){
                allProvisioningSyncServices(null,$scope.isFromContOrTech,true,false);
            }
        }
        
        function showsynPopAndResetChecks(contractHistory,isFromContOrTech,resetChecks){
            if(contractHistory && !_.isEmpty(vm.fixResponseTwo)){ 
                showHistorySyncPopup(isFromContOrTech);
            }
            if(isFromContOrTech == 'isContract' && resetChecks){
                if(!_.isEmpty(vm.subscriptionsOnGoing)){
                    vm.subscriptionsOnGoing.forEach(function(item){ 
                        item.isSyncSelected = false;                          
                        vm.toggleAllTechCheckBoxes(item, 'isContract')
                    })
                }
                if(!_.isEmpty(vm.subscriptionsCancelled)){
                    vm.subscriptionsCancelled.forEach(function(item){
                        item.isSyncSelected = false;
                        vm.toggleAllTechCheckBoxes(item, 'isContract')
                    })
                }
                if(!_.isEmpty(vm.subscriptionsTerminated)){
                    vm.subscriptionsTerminated.forEach(function(item){
                        item.isSyncSelected = false;
                        vm.toggleAllTechCheckBoxes(item, 'isContract')
                    })
                }
            } else if(resetChecks) {
                vm.isSyncSelected = false;
                if(!_.isEmpty(vm.technicalServices)){
                    vm.toggleAllTechCheckBoxes(vm.technicalServices, 'isTech')
                }
            }
        }
        
        function allProvisioningSyncServices(body, isFromContOrTech, contractHistory, resetChecks, params) {
            blockUI.start();
            document.getElementById('Background_color').style.height = "700%";
            if (body && body.features) {
                body.features = body.features.filter(feature => feature.featureId !== "494");
            }
            if (!contractHistory) {
                if (params) {
                    // Realignment GET
                    RLinkCarMetierService.getProvisioningRequestList(params).then(function (response) {
                        showsynPopAndResetChecks(contractHistory, isFromContOrTech, resetChecks);
                        toastr.info($translate.instant("ACTION_SENT"));
                        blockUI.stop();
                    }).catch(function (err) {
                        $log.debug($translate.instant(err));
                        blockUI.stop();
                    });
                } else if (body) {
                    // Activation POST
                    RLinkCarMetierService.provisioningRequest(body).then(function (response) {
                        showsynPopAndResetChecks(contractHistory, isFromContOrTech, resetChecks);
                        blockUI.stop();
                    }).catch(function (err) {
                        $log.debug($translate.instant(err));
                        blockUI.stop();
                    });
                }
            } else {
                vinAndRequestIdCalls(vm.vin, isFromContOrTech, contractHistory, resetChecks);
            }
        }
        function vinAndRequestIdCalls(vin, isFromContOrTech, contractHistory, resetChecks){
            RLinkCarMetierService.getProvisioningRequestVehicles(vin).then(function (response) {
                vm.fixResponseTwo = response;
                if (!_.isEmpty(vm.fixResponseTwo) && !_.isEmpty(vm.fixResponseTwo.content)) {
                    vm.fixResponseTwo.content = _.orderBy(vm.fixResponseTwo.content, 'creationDate', 'desc');
                    var tempProvisioningIds = _.map(vm.fixResponseTwo.content, 'provisioningRequestId');
                    var promiseArray = _.map(tempProvisioningIds, function (item) {
                        return RLinkCarMetierService.getProvisioningRequests(item).then(function (resp) {
                            return resp;
                        }).catch(function () {
                            return null;
                        })
                    })
                    $q.all(promiseArray).then(function (arrItem) {
                        if (!_.isEmpty(arrItem)) {
                            arrItem.forEach(function (item) {
                                if(item){
                                    vm.fixResponseTwo.content.forEach(function (item2) {
                                        if (item.provisioningRequestId == item2.provisioningRequestId) {
                                            _.assign(item2, { 'provisioningDetails': item });
                                        }
                                    })
                                }
                            })
                        }
                        showsynPopAndResetChecks(contractHistory, isFromContOrTech, resetChecks);
                        blockUI.stop();
                    })
                }
            }).catch(function (err) {
                $mdDialog.show({
                    templateUrl: 'app/components/car/rLinkCar/contractsAndServices/popup/synchronizationHistoryPopup.template.html',
                    controller: ["$scope", synchronizationHistoryPopupController],
                    controllerAs: 'vm',
                    bindToController: true,
                    clickOutsideToClose: true,
                    size: 'lg',
                    locals: {
                        error:true
                    }
                });
                $log.debug($translate.instant(err));
                blockUI.stop();
            })
        }
        function deActivateFeature(isFromContOrTech){
            var contextCarRequest = CacheService.getCarContext();
            var isVin = contextCarRequest && !_.isEmpty(contextCarRequest) && contextCarRequest.vin ? contextCarRequest.vin : "";
            $mdDialog.show({
                template: '<div class = "popinInfo "style = "padding:20px">' +'<div><strong>'+ $translate.instant("DEACTIVATION_CONFIRM_SERVICE") +'<div><strong><div style="margin:5% 35% 0 35%"> <button class="buttonWithIcon" ng-click="onConfirm(true)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_YES"|translate}}</div></button>       <button class="buttonWithIcon" ng-click="onCancel(false)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_NO"|translate}}</div></button></div> </div>',
                controller: ['$scope',confirmDeactivateServicePopupController],
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals:{
                    isFromContOrTech: isFromContOrTech,
                    isVin: isVin,
                    isDdpServiceDeactivated: vm.isDdpServiceDeactivated,
                    hideDeactivateBtn: vm.hideDeactivateBtn
                }
            })
        }
        function confirmDeactivateServicePopupController($scope){
            var vm = this;
            $scope.isFromContOrTech = vm.isFromContOrTech;
            $scope.isVin = vm.isVin;
            $scope.isDdpServiceDeactivated = vm.isDdpServiceDeactivated;
            $scope.hideDeactivateBtn = vm.hideDeactivateBtn;
            $scope.onCancel = function(){
                toastr.error($translate.instant("ACTION_NOT_SENT"));
                $mdDialog.hide();
            }
            $scope.onConfirm = function(){
                $mdDialog.hide();
                blockUI.start();
                var deactivateServiceExtId = Math.floor((Date.now()-Math.random()) * 100);
                var data = {
                    externalId: deactivateServiceExtId.toString(),
                    provisioningProcessType: 'SERVICES_DEACTIVATION',
                    vins: [vm.isVin],
                    features: [{
                        featureId: rLinkConstant.featureCapId
                      }]
                };
                $q.all([
                    RLinkCarMetierService.deactivateService(data),
                    RLinkCarMetierService.getVehicleInformationDataCCS()
                ]).then(function (response) {
                    if (!_.isEmpty(response[0]) && !_.isEmpty(response[0].status) && response[0].status.toLowerCase() === "created") {
                        toastr.info($translate.instant("ACTION_SENT"));
                    }
                    if (!_.isEmpty(response[1])) {
                        refreshTechData(response[1]);
                    }
                }).catch(function (err) {
                    $log.debug($translate.instant(err));
                }).finally(function () {
                    blockUI.stop();
                });
    
                SearchArboTextualMetierService.setConnectedServicesAuditData('Deactivation 204')
                    .then(function () { });                
            }
        }

        function refreshTechData(techData){
            vm.hideDeactivateBtn = true;
            if(!_.isEmpty(techData.subscriptions) && !_.isEmpty(techData.subscriptions.technicalServices) && !_.isEmpty(techData.subscriptions.technicalServices[0])){
                vm.technicalServices = !_.isEmpty(techData.subscriptions.technicalServices[0].features) ? techData.subscriptions.technicalServices[0].features : [];
            }
        }

        function contractsServiceSync(isFromContOrTech, contractHistory, nissanUserURL){
            if(!contractHistory){
                $mdDialog.show({
                    template: '<div class = "popinInfo "style = "padding:20px;font-family:var(--renaultFontRegular);">' +'<div><strong>'+ $translate.instant("CONFIRM_SYNC_MESSAGE") +'<div><strong><div style="margin:5% 35% 0 35%"> <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="onConfirm(true)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_YES"|translate}}</div></button>       <button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="onCancel(false)"> <div class="btnText">{{"ACTIS_SAVE_INFORMATIONS_NO"|translate}}</div></button></div> </div>',
                    controller: ['$scope',confirmSyncMessagePopupController],
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals:{
                        nissanUserURL: nissanUserURL,
                        isFromContOrTech: isFromContOrTech,
                        contractHistory: contractHistory
                    }
                })
            } else {
                callProvisioningServices(isFromContOrTech,contractHistory,false)
            }          
        }
        
        function showFeasibilityCheckPopup() {
            $mdDialog.show({
                template:
                    '<div class="popinInfo" style="padding:20px; min-width:320px; text-align:center;">' +
                    '<div style="font-weight:500; font-size:20px; margin-bottom:20px;">{{"SYNCHRONIZATION_FEASIBILITY_MSG"|translate}}</div>' +
                    '<div><img src="../assets/images/primaryLoader.gif" width="24px" alt="Loading"></div>' +
                    '</div>',
                clickOutsideToClose: false,
                escapeToClose: false
            });
        }

        function callProvisioningServices(isFromContOrTech, contractHistory, resetChecks) {
            var provisioningServiceActivationType = rLinkConstant.provisioningServiceActivationType;
            var provisioningRealignType = rLinkConstant.provisioningRealignmentType;
            var provisioningActiveType = rLinkConstant.provisioningActivationType;
            var isFeatureOrService = (isFromContOrTech === 'isContract') ? vm.allServiceIds : vm.allFeatureIds;

            if (contractHistory) {
                allProvisioningSyncServices(null, isFromContOrTech, contractHistory, resetChecks);
                return;
            }
            showFeasibilityCheckPopup();
            if (_.isEmpty(isFeatureOrService)) {
                var params = {
                    vin: vm.vin,
                    provisioningProcessType: provisioningRealignType
                };
                RLinkCarMetierService.getProvisioningRequestList(params).then(function (response) {
                    $mdDialog.hide();
                    var resultArray = response.data || response.content || response;
                    var hasRealignmentInProgress = resultArray.some(function (r) {
                        return r.provisioningProcessType === 'REALIGNMENT' && r.status === 'IN_PROGRESS';
                    });
                    if (hasRealignmentInProgress) {
                        showErrorPopup();
                        return;
                    }else if(!hasRealignmentInProgress && params.provisioningProcessType === 'REALIGNMENT'){
                        var realignBody = {
                            provisioningProcessType: provisioningRealignType,
                            vins: [vm.vin]
                        };
                        RLinkCarMetierService.provisioningRequest(realignBody).then(function () {
                        }).catch(function (err) {
                            $log.debug($translate.instant(err));
                        });
                    }
                    var allList = [];
                    if (isFromContOrTech === 'isContract') {
                        allList = resultArray.map(function (r) { return { serviceId: r.serviceId }; });
                    } else {
                        allList = resultArray.map(function (r) { return { featureId: r.featureId }; });
                    }
                    if (allList.length === 0) {
                        return;
                    }
                    toastr.info($translate.instant("ACTION_SENT"));
                }).catch(function (err) {
                    $mdDialog.hide();
                    $log.debug($translate.instant(err));
                    toastr.error($translate.instant("ACTION_NOT_SENT"));
                    });
                return;
            }
            var params = {
                vin: vm.vin,
                provisioningProcessType: provisioningServiceActivationType
            };

            RLinkCarMetierService.getProvisioningRequestList(params).then(function (response) {
                $mdDialog.hide();

                var resultArray = response.content || response.data || response;

                if (isFromContOrTech === 'isContract') {
                    var inProgressServiceIds = [];
                    resultArray.forEach(function (item) {
                        if (item.status === 'IN_PROGRESS' && Array.isArray(item.services)) {
                            item.services.forEach(function (service) {
                                inProgressServiceIds.push(service.serviceId);
                            });
                        }
                    });
                    var filteredList = vm.allServiceIds.filter(function (item) {
                        return !inProgressServiceIds.some(function (id) {
                            return id == item.serviceId;
                        });
                    });
                } else {
                    var inProgressFeatureIds = [];
                    resultArray.forEach(function (item) {
                        if (item.status === 'IN_PROGRESS' && Array.isArray(item.features)) {
                            item.features.forEach(function (feature) {
                                inProgressFeatureIds.push(feature.featureId);
                            });
                        }
                    });
                    var filteredList = vm.allFeatureIds.filter(function (item) {
                        return !inProgressFeatureIds.some(function (id) {
                            return id == item.featureId;
                        });
                    });
                }
                if (filteredList.length === 0) {
                    showErrorPopup();
                    return;
                }
                showConfirmationPopup(
                    filteredList,
                    isFromContOrTech,
                    provisioningActiveType,
                    contractHistory,
                    resetChecks,
                    true
                );
            }).catch(function(err) {
                $mdDialog.hide();
                $log.debug($translate.instant(err));
                toastr.error($translate.instant("ACTION_NOT_SENT"));
            });
        }




        function showConfirmationPopup(list, isFromContOrTech, processType, contractHistory, resetChecks, withCancel) {
            $mdDialog.show({
                template:
                    '<div class="popinInfo" style="padding:20px; min-width:320px;">' +
                    '<div style="font-weight:bold; margin-bottom:10px;">' +
                    '<span ng-if="' + (isFromContOrTech === 'isContract') + '">{{"SYNCHRONIZATION_CONFIRMATION_MSG_SID"|translate}}</span>' +
                    '<span ng-if="' + (isFromContOrTech === 'isTech') + '">{{"SYNCHRONIZATION_CONFIRMATION_MSG_UID"|translate}}</span>' +
                    '</div>' +
                    '<div style="margin-bottom:10px;">' +
                    '<div ng-repeat="item in syncList" style="margin-bottom:5px;">{{item.' +
                    (isFromContOrTech === 'isContract' ? 'serviceId' : 'featureId') + '}}</div>' +
                    '<div ng-if="!syncList.length">-----</div>' +
                    '</div>' +
                    '<div style="display:flex; justify-content:center; gap:20px; margin-bottom:20px;">' +
                    '<button class="buttonWithIcon" ng-click="onOk()" style="min-width:80px;">OK</button>' +
                    (withCancel ? '<button class="buttonWithIcon" ng-click="onCancel()" style="min-width:80px;">CANCEL</button>' : '') +
                    '</div>' +
                    '<div style="color:#888; font-size:13px; font-style:italic;">' +
                    '{{"SYNCHRONIZATION_CONFIRMATION_BOTTOMMSG"|translate}}' +
                    '</div>' +
                    '</div>',
                controller: ['$scope', function ($scope) {
                    $scope.syncList = list;
                    $scope.onOk = function () {
                        $mdDialog.hide();
                        var body = { provisioningProcessType: processType, vins: [vm.vin] };
                        if (isFromContOrTech === 'isContract') body.services = list;
                        else body.features = list;
                        allProvisioningSyncServices(body, isFromContOrTech, contractHistory, resetChecks);
                        if (list && list.length > 0) {
                            toastr.info($translate.instant("ACTION_SENT"));
                        }
                    };
                    $scope.onCancel = function () { $mdDialog.hide(); };
                }],
                clickOutsideToClose: true
            });
        }

        function showErrorPopup() {
            $mdDialog.show({
                template:
                    '<div class="popinInfo" ' +
                    'style="padding:20px; min-width:320px; position:relative; text-align:center; font-family:Arial, sans-serif;">' +
                    '<button ng-click="close()" ' +
                    'style="position:absolute; top:12px; right:12px; background:transparent; border:none; cursor:pointer; padding:0;">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<line x1="18" y1="6" x2="6" y2="18"></line>' +
                    '<line x1="6" y1="6" x2="18" y2="18"></line>' +
                    '</svg>' +
                    '</button>' +
                    '<div style="margin-top:30px; margin-bottom:10px; line-height:1.4;">' +
                    '<span style="color:#FFA726; font-weight:bold;">{{"ACTION_NOT_POSSIBLE"|translate}}:</span>' +
                    '<span style="color:#222; font-weight:normal;"> {{"SYNCHRONIZATION_ERROR_MSG"|translate}}.</span>' +
                    '</div>' +
                    '</div>',
                controller: ['$scope', function ($scope) {
                    $scope.close = function () { $mdDialog.hide(); };
                }],
                clickOutsideToClose: true
            });
        }
   
        function confirmSyncMessagePopupController($scope){
            var vm = this;
            $scope.nissanUserURL = vm.nissanUserURL;
            $scope.contractHistory = vm.contractHistory;
            $scope.isFromContOrTech = vm.isFromContOrTech;
            $scope.onCancel = function(){
                toastr.error($translate.instant("ACTION_NOT_SENT"));
                $mdDialog.hide();
            }
            $scope.onConfirm = function(){
                // toastr.info($translate.instant("ACTION_SENT"));
                $mdDialog.hide();
                callProvisioningServices(vm.isFromContOrTech,vm.contractHistory,true)
                SearchArboTextualMetierService.setConnectedServicesAuditData('SERVICE_SYNCHRONIZATION')
                    .then(function () { })
            }
        }

        function toggleAllTechCheckBoxes(allChecked, isFromTechOrContract){
            if(allChecked && isFromTechOrContract && isFromTechOrContract == "isTech"){
                allChecked.forEach(function (item) {
                    if(!_.isEmpty(item)){
                        item.checked = vm.isSyncSelected;
                        if (item.checked === true ) {
                            if(_.isEmpty(vm.allFeatureIds)){
                                if(!_.isEmpty(item.uid)){
                                    vm.allFeatureIds.push({featureId: item.uid});
                                }
                            }
                            else{
                                _.map(vm.allFeatureIds, function (ids) {
                                    if(!_.isEmpty(ids) && !_.isEmpty(ids.featureId) && !ids.featureId.includes(item.uid)){
                                        if(!_.isEmpty(item.uid)){
                                            vm.allFeatureIds.push({featureId: item.uid});
                                        }  
                                    }
                                });
                            }
                        } else if (item.checked === false) {
                            allChecked.isSyncSelected = false;
                            if(!_.isEmpty(vm.allFeatureIds)){
                                _.map(vm.allFeatureIds, function (data) {
                                    var removeUnSelected = vm.allFeatureIds.indexOf(item.uid) !== -1;
                                    vm.allFeatureIds.splice(removeUnSelected, 1);
                                });
                            }
                        }
                    }
                });
                vm.allFeatureIds = _.uniqBy(vm.allFeatureIds, 'featureId');
            }
            else if(allChecked && !_.isEmpty(allChecked.servicePacks) && isFromTechOrContract && isFromTechOrContract == "isContract"){
                allChecked.servicePacks.forEach(function (item) {
                    if(!_.isEmpty(item)){
                        item.checked = allChecked.isSyncSelected;
                        if (item.checked === true ) {
                            if(_.isEmpty(vm.allServiceIds)){
                                if(!_.isEmpty(item.sid)){
                                    vm.allServiceIds.push({serviceId: item.sid});
                                }
                            }
                            else{
                                _.map(vm.allServiceIds, function (ids) {
                                    if(!ids.serviceId.includes(item.sid)){
                                        if(!_.isEmpty(item.sid)){
                                            vm.allServiceIds.push({serviceId: item.sid});
                                        }  
                                    }
                                });
                            }
                        } else if (item.checked === false) {
                            allChecked.isSyncSelected = false;
                            if(!_.isEmpty(vm.allServiceIds)){
                                _.map(vm.allServiceIds, function (data) {
                                    if(!_.isEmpty(data) && !_.isEmpty(data.serviceId) && _.includes(data.serviceId, item.sid)){
                                        var removeUnSelected = vm.allServiceIds.indexOf(item.sid) !== -1;
                                        vm.allServiceIds.splice(removeUnSelected, 1);
                                    }
                                });
                            }
                        }
                    }
                });
                vm.allServiceIds = _.uniqBy(vm.allServiceIds, 'serviceId');
            }
        }

        function onIndividualContractsSelect(contracts, contractId) {
            if (!_.isEmpty(contracts) && contractId) {
                contracts.forEach(function (item) {
                    var hasServiceId = _.some(vm.allServiceIds, function (obj) {
                        return obj.serviceId === item.sid;
                    });
                    if (item && item.checked === true && !hasServiceId) {
                        vm.allServiceIds.push({ serviceId: item.sid });
                    }
                    if (item && item.checked === false && hasServiceId) {
                        _.remove(vm.allServiceIds, function (obj) {
                            return obj.serviceId === item.sid;
                        });
                    }
                    vm.allServiceIds = _.uniq(vm.allServiceIds);
                });
            }
        }

        function onIndividualTechnicalSelect(technicalData, techId) {
            if (!_.isEmpty(technicalData) && techId) {
                technicalData.forEach(function (item) {
                    var hasFeatureId = _.some(vm.allFeatureIds, function (obj) {
                        return obj.featureId === item.uid;
                    });
                    if (item && item.checked === true && !hasFeatureId) {
                        vm.allFeatureIds.push({ featureId: item.uid });
                    }
                    if (item && item.checked === false && hasFeatureId) {
                        _.remove(vm.allFeatureIds, function (obj) {
                            return obj.featureId === item.uid;
                        });
                    }
                    vm.allFeatureIds = _.uniqBy(vm.allFeatureIds, 'featureId');
                });
            }
        }


        function launchSynchronizeModal(contract){
            var isContractsSynchronization = contract;
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/contractsAndServices/popup/synchronizationPopup.template.html',
                controller: ["$scope", synchronizationPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg',
                locals:{
                    isContractsSynchronization: isContractsSynchronization
                }
            })
        }

        function synchronizationPopupController($scope){
            var vm = this;
            $scope.isContractsSynchronization = vm.isContractsSynchronization;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function launchTechnicalSynchronizeModal(tech){
            var isTechnicalSynchronization = tech;
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/contractsAndServices/popup/synchronizationPopup.template.html',
                controller: ["$scope", synchronizationTechPopupController],                
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                size: 'lg',
                locals:{
                    isTechnicalSynchronization: isTechnicalSynchronization
                }
            })
        }

        function synchronizationTechPopupController($scope){
            var vm = this;
            $scope.isTechnicalSynchronization = vm.isTechnicalSynchronization;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        function selectTab(tab) {
            vm.selectedTab = tab;
        }

        function isSelected(tab) {
            if (vm.selectedTab == 'terminated') {
                vm.selectedTab = 'terminated';
                return vm.selectedTab === tab;
            }else if (vm.selectedTab == 'cancelled') {
                vm.selectedTab = 'cancelled';
                return vm.selectedTab === tab;
            }else if (vm.selectedTab == 'confirmed') {
                vm.selectedTab = 'confirmed';
                return vm.selectedTab === tab;
            }
            else {
                vm.selectedTab = 'onGoing';
                return vm.selectedTab === tab;
            }
        }


        function configureAccordions() {
            var userType = CacheService.getUserProfile().userType;
            // Techliner
            if(userType === 'ARCA') {
                vm.accordions.contractsAccordion.isOpen = true;
                vm.accordions.commercialServicesAccordion.isOpen = true;
                vm.accordions.technicalServicesAccordion.isOpen = true;
            }

            // Cotech
            if(userType === 'RNET') {
                vm.accordions.contractsAccordion.isOpen = true
                vm.accordions.commercialServicesAccordion.isOpen = true;
                vm.accordions.technicalServicesAccordion.isOpen = true;
            }

             if(userType === 'ASOM' && $rootScope.asomDocList['CS']) {
                vm.accordions.contractsAccordion.isOpen = true
                vm.accordions.commercialServicesAccordion.isOpen = true;
                vm.accordions.technicalServicesAccordion.isOpen = true;
            }
        }

        $scope.propertyName = 'atcproductName';
        $scope.contracts = 'subscriptions';
        $scope.reverse = null;
        vm.subscriptions = $filter('orderBy')(vm.subscriptions, $scope.propertyName, $scope.reverse);
        vm.subTerminated = $filter('orderBy')(vm.subTerminated, $scope.propertyName, $scope.reverse);
        vm.allSubscriptions = $filter('orderBy')(vm.data, $scope.propertyName, $scope.reverse);

        function sortBy(propertyName, contracts) {
            $scope.reverse = (
                (propertyName !== null || contracts !== null) &&
                ($scope.propertyName === propertyName || $scope.contracts === contracts)
            )
                ? !$scope.reverse : false;
            $scope.propertyName = propertyName;
            $scope.contracts = contracts;

            vm[contracts] = $filter('orderBy')(vm[contracts], $scope.propertyName, $scope.reverse);
            $scope.allSubscriptions = $filter('orderBy')(vm.allSubscriptions, $scope.propertyName, $scope.reverse);
        }

        // Override Accordion opening
        function overrideAccordionOpening(item, $event) {
            if(item.services === '') {
                $event.stopPropagation();
                $event.preventDefault();
            }
        }

        function toggleContractsChecked(contracts){
            _.map(contracts, function (item) {
                _.assign(item, { checked: false });
            });
        }

        function hasActivatedService(servicePacks) {
            if (!servicePacks || !Array.isArray(servicePacks)) {
                return false;
            }
            return servicePacks.some(function (srv) {
                return srv.activationStatus === 'DEACTIVATED';
            });
        }

        function processContractServicePacks(contract, checkActivatedService) {
            if (_.isEmpty(contract) || _.isEmpty(contract.servicePacks)) {
                return;
            }
            toggleContractsChecked(contract.servicePacks);
            if (checkActivatedService) {
                contract.hasActivatedService = hasActivatedService(contract.servicePacks);
            }
        }

        function setContractConfirmationFlag(contract, isConfirmed, checkActivatedService) {
            processContractServicePacks(contract, checkActivatedService);
            contract.isSubscriptionConfirmed = isConfirmed;
        }

        function getCarSubscriptions() {
            if(!_.isEmpty(vm.data)){
            if(isEasyLink) {
                // KMR Services
                vm.commercialServices = vm.data.commercialServices !== null ? vm.data.commercialServices : [];
                vm.technicalServices = vm.data.technicalServices !== null ? vm.data.technicalServices[0].features : [];

                // Synchronization history
                vm.synchronisationHistory = vm.data.synchronisationHistory;
                var statusTerminated = ['TERMINATED', 'REJECTED'];
                var statusCancelled = ['CANCELLED'];
                var statusConfirmed = ['CONFIRMED'];

                vm.subscriptionsOnGoing = $filter('filter')(vm.data.contracts, function (contract) {
                    const isOngoing = rLinkConstant.statusOnGoing.indexOf(contract.status) !== -1;
                    if (isOngoing) {
                        setContractConfirmationFlag(contract, false, true);
                    }
                    return isOngoing;
                });

                vm.subscriptionsTerminated = $filter('filter')(vm.data.contracts, function (contract) {
                    const isTerminated = statusTerminated.indexOf(contract.status) !== -1;
                    if (isTerminated) {
                        setContractConfirmationFlag(contract, false, false);
                    }
                    return isTerminated;
                });

                vm.subscriptionsCancelled = $filter('filter')(vm.data.contracts, function (contract) {
                    const isCancelled = statusCancelled.indexOf(contract.status) !== -1;
                    if (isCancelled) {
                        setContractConfirmationFlag(contract, false, false);
                    }
                    return isCancelled;
                });

                vm.subscriptionsConfirmed = $filter('filter')(vm.data.contracts, function (contract) {
                    const isConfirmed = statusConfirmed.indexOf(contract.status) !== -1;
                    if (isConfirmed) {
                        setContractConfirmationFlag(contract, true, false);
                    }
                    return isConfirmed;
                });

                // Sort
                if(vm.subscriptionsOnGoing !== null) {
                    vm.subscriptionsOnGoing.sort(function(a, b) {
                        return new Date(b.subscriptionDatetime) - new Date(a.subscriptionDatetime);
                    });
                }

                if(vm.subscriptionsTerminated !== null) {
                    vm.subscriptionsTerminated.sort(function (a, b) {
                        return new Date(b.subscriptionDatetime) - new Date(a.subscriptionDatetime);
                    });
                }

                if(vm.subscriptionsCancelled !== null) {
                    vm.subscriptionsCancelled.sort(function (a, b) {
                        return new Date(b.subscriptionDatetime) - new Date(a.subscriptionDatetime);
                    });
                }

                if(vm.subscriptionsConfirmed !== null) {
                    vm.subscriptionsConfirmed.sort(function (a, b) {
                        return new Date(b.subscriptionDatetime) - new Date(a.subscriptionDatetime);
                    });
                }


                vm.allSubscriptions = getDataSorted(vm.data.contracts, 'status');
                status = 'status';

            } else {
                vm.subscriptions = $filter('filter')(vm.data, function (value) {
                    return value.subscriptionStatus !== 'TERMINATED';
                });
                vm.subTerminated = $filter('filter')(vm.data, function (value) {
                    return value.subscriptionStatus === 'TERMINATED';
                });

                // Sort
                if(vm.subscriptions !== null) {
                    vm.subscriptions.sort(function (a, b) {
                        return new Date(b.subscriptionStartDate) - new Date(a.subscriptionStartDate);
                    });
                }

                if(vm.subTerminated !== null) {
                    vm.subTerminated.sort(function (a, b) {
                        return new Date(b.subscriptionStartDate) - new Date(a.subscriptionStartDate);
                    });
                }

                vm.allSubscriptions = getDataSorted(vm.data, 'subscriptionStatus');
                status = 'subscriptionStatus';

                vm.showTable = vm.subscriptions != null && vm.subscriptions.length > 0;
                vm.showTerminatedTable = vm.subTerminated != null && vm.subTerminated.length > 0;
            }

            datas = vm.allSubscriptions;
            }
        }

        function getDataSorted(data, status) {
            // Quick exit
            if(data === null) return [];
            var tmpActivated = [];
            var tmpTerminated = [];
            var sort = '';

            if(!isEasyLink) {
                tmpActivated = filterData(data, {subscriptionStatus:'ACTIVATED'});
                tmpTerminated = filterData(data, {subscriptionStatus:'TERMINATED'});
                sort = 'subscriptionStartDate';
            } else {
                tmpActivated = $filter('filter')(data, function(value) {
                    return value[status] === 'ACTIVATED';
                });
                tmpTerminated = $filter('filter')(data, function(value) {
                    return value[status] === 'TERMINATED';
                });
                sort = 'subscriptionDatetime';
            }
            var tmpOther = $filter('filter')(data, function(value) {
                return value[status] !== 'TERMINATED' && value[status] !== 'ACTIVATED';
            });

            var finalArr = (tmpTerminated.concat(tmpOther)).concat(tmpActivated);
            finalArr.sort(function(a, b) {
                return new Date(b[sort]) - new Date(a[sort]);
            });
            return finalArr;
        }

        function filterData(array, key){
            var nullDate = $filter('filter')($filter('filter')(array, key), function(value){ return value.subscriptionEndDate == null;});
            var notNullDate = $filter('filter')($filter('filter')(array, key), function(value){ return value.subscriptionEndDate != null;});
            var result = $filter('rlinkOrderBy')(notNullDate, 'subscriptionEndDate','+');
            return nullDate.concat(result);
        }

        // Synchronization of contract
        function synchronizeContract(contract) {
            for(var i = 0; i < vm.data.length; i++) {
                if(vm.data[i].atcContractNumber === contract.atcContractNumber) {
                    vm.data[i].canRetry = false;
                    RLinkCarMetierService.synchronizeContract(contract.atcContractNumber);
                }
            }
        }

        // Model Synchronization history
        function openSynchronizationHistoryModal(item) {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/contractsAndServices/easyLink/synchronizationHistoryModal.html',
                controller: ["$scope", synchronizationHistoryController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalSynchronizationHistory',
                backdrop: 'static',
                locals: {
                    data: vm.synchronisationHistory
                }
            });
        }

        function synchronizationHistoryController($scope) {
            var vm = this;
            $scope.synchronizations = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }

        // MODAL
        function openExtendedView() {
            var templateUrl = '';
            if(!isEasyLink) {
                templateUrl = 'app/components/car/rLinkCar/contractsAndServices/subscriptionExtendedView.html';
            } else {
                templateUrl = 'app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionExtendedView.html';
            }

            $mdDialog.show({
                templateUrl: templateUrl,
                controller: ["$scope", modalController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalContractAndServices',
                backdrop: 'static',
                locals: {
                    data: getDataSorted(datas, status)
                }
            });
        }

        function modalController($scope){
            var vm = this;
            $scope.allSubscriptions = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }

            $scope.sortBy = function(propertyName){
                $scope.reverse = (
                    (propertyName !== null ) &&
                    ($scope.propertyName === propertyName)
                )
                    ? !$scope.reverse : false;
                $scope.propertyName = propertyName;

                $scope.allSubscriptions = $filter('orderBy')($scope.allSubscriptions, $scope.propertyName, $scope.reverse);
            }
        }

        function openHistoryOfRetryModal(item) {
            var templateUrl = 'app/components/car/rLinkCar/contractsAndServices/historyOfRetryModal.html';
            $mdDialog.show({
                templateUrl: templateUrl,
                controller: ["$scope", modalHistoryController],
                bindToController: true,
                controllerAs: 'vm',
                windowClass: 'modalContractAndServices',
                backdrop: 'static',
                locals: {
                    data: item.retryHistory
                }
            });
        }

        function modalHistoryController($scope){
            var vm = this;
            $scope.retryHistory = vm.data;

            $scope.close = function(){
                $mdDialog.hide();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('dataConsistencies', {
            bindings: {
            },
            controller: DataConsistenciesComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/dataConsistencies/dataConsistencies.template.html'
        });

    /** @ngInject */
    function DataConsistenciesComponent(
        $translate,CacheService,CacheConstants,UtilsMetierService,rLinkConstant,configConstantes
    ) {
        var vm = this;
        var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.isEasyLink = (connectedPlatform !== null && (connectedPlatform.platform === "EASYLINK" || connectedPlatform.platform === 'AVN' || connectedPlatform.platform === 'CVC' || connectedPlatform.platform === 'RGDC'));
        vm.ccs3Architecture = connectedPlatform && connectedPlatform.architecture && connectedPlatform.architecture.toLowerCase() === 'ccs3';
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        vm.vcps = rLinkConstant.vcps;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
               
        this.$onInit = function () {
        }     

    }
})();
/**
 * offerSubscribeCtrl Controller
 * @namespace Controllers
 */
(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('offerSubscribeCtrl', offerSubscribeCtrl);

    /* @ngInject */
    function offerSubscribeCtrl($mdDialog,CacheConstants,CacheService,RLinkCarWSService,$translate,toastr,blockUI,$rootScope,rLinkConstant,MainMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;      
        vm.onCancel = onCancel;
        vm.onSubscribe = onSubscribe;
        vm.user = CacheService.getUserProfile();
        var isSubscribing = false;
        
        vm.showOfferWarning = function() {
            return vm.selectedOffer && 
                   vm.selectedOffer.price && !_.isEmpty(vm.selectedOffer.price) && vm.selectedOffer.price !== 0.00 && vm.selectedOffer.price !== '0.00' &&
                   vm.user && 
                   vm.user.roles && 
                   MainMetierService.hasDealerRole();
        };

        function onCancel() {
            $mdDialog.cancel();
        }

        function onSubscribe() {
            if (isSubscribing) {
                return;
            }
            
            isSubscribing = true;
           
            var contextualOfferData ={
                id: (vm.selectedOffer && vm.selectedOffer.contextualOfferId) ? vm.selectedOffer.contextualOfferId : null,
                version: (vm.offerDetails && vm.offerDetails.offerVersion) ? vm.offerDetails.offerVersion : null

            }
            var payload ={};
            var getCarContextReq = CacheService.getObject(CacheConstants.contextCarRequest);
            if (!_.isEmpty(vm.user.roles)) {
                vm.user.roles = vm.user.roles.map(function (e) {
                    return e.toUpperCase()
                });
            }
            var subscriptionChannel = vm.user.roles.includes(rLinkConstant.arcaCnrCustomerCare) || vm.user.roles.includes(rLinkConstant.rnetCnrCustomerCare) ? rLinkConstant.customerCare : rLinkConstant.network;
            _.assign(payload,{
                'vin':  (getCarContextReq && getCarContextReq.vin) ? getCarContextReq.vin : null,
                'subscriptionChannel': subscriptionChannel,
                'contextualOffer':contextualOfferData

            })
            if (vm.user.roles.includes(rLinkConstant.rnetCnrDealer)) {
                payload['dealerCode'] = vm.user.dealerId;
            }
            blockUI.start();
            RLinkCarWSService.getvinSubscription(payload).then(function (response) {
                if(response ){
                    toastr.success($translate.instant('SUBSCRIPTION_SUCCESS_TOASTER'));
                    $rootScope.$broadcast('ConnectedServicesOffers', true, 'isEnableTab');
                    blockUI.stop();
                    isSubscribing = false;
                $mdDialog.cancel();
          
        }
        }).catch(function (error) {
            blockUI.stop();
            isSubscribing = false;
            $mdDialog.cancel();
            if(error && error.data && !_.isEmpty(error.data.errors)){
            toastr.error(error.data.errors[0].errorMessage);
            }
        })
        }
       
    }
})();

/**
 * InterventionSelectionPopinCtrl Controller
 * Lets the user pick one SIEINT among several returned for the same GIEINT
 * @namespace Controllers
 */
(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('InterventionSelectionPopinCtrl', InterventionSelectionPopinCtrl);

    /* @ngInject */
    function InterventionSelectionPopinCtrl($mdDialog) {
        var vm = this;

        vm.sieEntries = vm.sieEntries || [];
        vm.selectedSie = vm.sieEntries[0] || null;
        vm.onCancel = onCancel;
        vm.onValidate = onValidate;

        function onCancel() {
            $mdDialog.cancel();
        }

        function onValidate() {
            if (!vm.selectedSie) { return; }
            $mdDialog.hide(vm.selectedSie);
        }
    }
})();

/**
 * interventionPopinCtrl Controller
 * @namespace Controllers
 */
(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('interventionPopinCtrl', interventionPopinCtrl);

    /* @ngInject */
    function interventionPopinCtrl($scope, $mdDialog, UtilsMetierService,
        mrDocumentsMetierService, DocumentsMetierService, RoutesConstants,
        $state, $window, $rootScope, $timeout, CacheService, CacheConstants, blockUI, toastr,
        QuoteMetierService, ShoppingCartService, listOfDraftModalService, globalConstant,
        DmsMetierService, $q) {

        var vm = this;
        vm.onClose = onClose;
        vm.copyReference = copyReference;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.gotoMrLink = gotoMrLink;
        vm.gotoCatalogPlate = gotoCatalogPlate;
        vm.handleBulkAdd = handleBulkAdd;
        vm.handleBasketAdd = handleBasketAdd;
        vm.deleteBasketIntervention = deleteBasketIntervention;
        vm.goToQuoteFromBadge = goToQuoteFromBadge;
        vm.deleteQuoteIntervention = deleteQuoteIntervention;
        vm.goToQuote = goToQuote;
        vm.calculateEstimate = calculateEstimate;

        activate();

        function activate() {
            var offer = vm.selectedOffer || {};
            vm.title = offer.offerName || offer.name || '';
            vm.totalAmount = offer.price || '';
            // default to EUR when basket parts carry no currency (e.g. TM-only FOD)
            vm.currency = offer.currency || (offer.price ? 'EUR' : '');
            vm.parts = offer.parts || [];
            vm.tmCodes = offer.tmCodes || [];
            vm.mrDocumentIds = offer.mrDocumentIds && offer.mrDocumentIds.length
                ? offer.mrDocumentIds
                : (offer.documentsId || []);
            // showMrLink distinguishes FOD popups (where MR was looked up) from other uses of this controller
            vm.showMrLink = offer.mrDocumentIds !== undefined;
            vm.labourTimesForQuote = offer.labourTimesForQuote || [];
            vm.customer = offer.customer || null;
            vm.dmsParts = offer.dmsParts || null;
            vm.interventionMeta = {
                id: offer.interventionId || '',
                designation: offer.name || '',
                version: offer.interventionVersion || '',
                interventionQuantity: offer.interventionQuantity || null
            };
            vm.isDmsProfile = !!CacheService.getObject('dms');
            vm.quoteItemsNumber = 0;
            vm.quoteItems = null;
            vm.quotePopinTitle = '';
            vm.quotePopinSubtitle = '';
            vm.quoteAdded = false;
            vm.quoteUpdatePending = false;
            vm.basketAdded = false;
            vm.basketUpdatePending = false;
            vm.basketItemsNumber = 0;
            vm.basketInterventionId = null;
            vm.flattenCart = [];
            vm.cartMetadata = {};
            var quoteUpdatedDeregister = $rootScope.$on('quoteUpdatedEvent', function () {
                if (vm.quoteUpdatePending) {
                    setQuotePreview();
                    vm.quoteItemsNumber = getQuoteItemsNumber();
                    vm.quoteAdded = true;
                    vm.quoteUpdatePending = false;
                    $rootScope.$emit('fodQuoteUpdated');
                }
            });
            $scope.$on('$destroy', quoteUpdatedDeregister);
            vm.estimating = false;
            // auto-calculate on open when price was not pre-computed before the popup was shown
            if (vm.isDmsProfile && !vm.totalAmount && !offer.estimateAlreadyCalculated) {
                calculateEstimate();
            }
        }

        function calculateEstimate() {
            if (vm.estimating) { return; }
            vm.estimating = true;
            // build TM items: prefer labourTimesForQuote (has opecod); fall back to tmCodes
            var tmItems = vm.labourTimesForQuote.length ? vm.labourTimesForQuote :
                vm.tmCodes.map(function (tm) {
                    return { opecod: tm.code, designation: tm.designation || '', laborTime: tm.time || 0, quantity: 1, codified: true };
                });
            var references = vm.parts.map(function (p) { return p.reference; }).filter(Boolean);
            var dmsRefPromise = vm.dmsParts
                ? $q.resolve({ parts: vm.dmsParts })
                : references.length
                ? DmsMetierService.getReferencesDms(references)
                : $q.resolve(null);
            dmsRefPromise.then(function (dmsResp) {
                var dmsParts = dmsResp && (dmsResp.parts || (dmsResp.response && dmsResp.response.parts));
                if (dmsParts) {
                    var dmsMap = {};
                    dmsParts.forEach(function (dmsPart) { dmsMap[dmsPart.reference] = dmsPart; });
                    vm.parts.forEach(function (part) {
                        var dmsPart = dmsMap[part.reference];
                        if (dmsPart) {
                            var dmsQuantity = dmsPart.availabilities && dmsPart.availabilities.length
                                ? dmsPart.availabilities[0].quantity
                                : undefined;
                            part.dmsInformations = {
                                isKnowFromDms: true,
                                quantity: dmsQuantity
                            };
                            part.stockAvailability = dmsQuantity > 0;
                        }
                    });
                }
                return DmsMetierService.calculateFodEstimate(vm.parts, tmItems, vm.customer);
            }).then(function (estimateResp) {
                if (estimateResp && estimateResp.response && estimateResp.response.estimate) {
                    vm.totalAmount = estimateResp.response.estimate.total;
                    vm.currency = vm.currency || 'EUR';
                }
            }).catch(function () {
                toastr.error('FOD estimate failed');
            }).finally(function () {
                vm.estimating = false;
            });
        }

        function getCurrencyForItem(part) {
            return UtilsMetierService.getCurrencyForItem(part && part.dmsInformations && part.dmsInformations.isKnowFromDms);
        }

        function gotoMrLink() {
            var selectedInterventionId = CacheService.getObject(CacheConstants.selectedInterventionId);
            var interventionId = (selectedInterventionId && selectedInterventionId.id) ? selectedInterventionId.id : vm.interventionMeta.id;
            if (vm.mrDocumentIds && vm.mrDocumentIds.length > 1) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/components/products/documents/pr-mrlink/prMrLink.template.html',
                    controller: 'PrMrLinkCtrl',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    skipHide: true,
                    multiple: true,
                    locals: {
                        mrdocids: vm.mrDocumentIds,
                        interventionMrDetails: null,
                        interventionId: interventionId
                    }
                });
                return;
            }
            blockUI.start();
            // empty mrDocumentIds still hits repairManuals/?limit=20 and returns the vehicle's related MR documents
            mrDocumentsMetierService.getInitialSieDocuments(vm.mrDocumentIds || []).then(function (mrDocuments) {
                if (_.isEmpty(mrDocuments)) {
                    toastr.info('No MR documents available for this intervention');
                    return;
                }
                if (mrDocuments.length > 1) {
                    $mdDialog.show({
                        parent: angular.element(document.body),
                        templateUrl: 'app/components/products/documents/pr-mrlink/prMrLink.template.html',
                        controller: 'PrMrLinkCtrl',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        skipHide: true,
                        multiple: true,
                        locals: {
                            mrdocids: mrDocuments.map(function (doc) { return doc.sieRef || doc.id; }),
                            interventionMrDetails: null,
                            interventionId: interventionId
                        }
                    });
                    return;
                }
                var doc = mrDocuments[0];
                if (doc.pdfContent === 'false') {
                    $mdDialog.cancel();
                    $state.go(RoutesConstants.documentMR, {
                        id: doc.sieRef,
                        prMRLinked: true,
                        interventionId: interventionId
                    });
                } else {
                    DocumentsMetierService.returnSiePdfContent(doc.sieRef, 'SIE_MR').then(function (result) {
                        $window.open(result.contentUrl, '_blank');
                    });
                }
            }, function (error) {
                toastr.error(error, 'Error');
            }).finally(function () {
                blockUI.stop();
            });
        }

        function handleBulkAdd() {
            if (vm.quoteAdded) { goToQuote(); return; }
            var hasParts = vm.parts.length > 0;
            var hasTm = vm.labourTimesForQuote.length > 0 || vm.tmCodes.length > 0;
            if (!hasParts && !hasTm) { return; }
            var interventionItems = buildInterventionItems();
            var quote = QuoteMetierService.getQuoteData();
            // if a quote is already open, add directly without showing the draft-list modal
            if (quote) {
                vm.quoteUpdatePending = true;
                QuoteMetierService.updateQuotePart(ShoppingCartService.constants.ADD_OPERATIONS, interventionItems);
                vm.quoteAdded = true;
                return;
            }
            listOfDraftModalService.showModal({
                body: angular.element(document.body),
                typeOfSuperCart: globalConstant.quote,
                title: 'NEW_ESTIMATE',
                subtitle: 'ESTIMATE_NO_ACTIVE_DRAFT',
                isEasyBasket: true,
                isEasyBasketHeader: 'EASY_BASKET_HEADER',
                isEasyBasketFooter: 'EASY_BASKET_FOOTER',
                prYesButton: 'PR_POPUP_YESBUTTON',
                tmYesButton: 'TM_POPUP_YESBUTTON',
                prPopupHeader: 'PR_POPUP_HEADER',
                tmPopupHeader: 'TM_POPUP_HEADER',
                prPopUp: !hasParts,
                tmPopUp: !hasTm,
                showList: true,
                showActifPartRequisition: false
            }).then(function (superCartId) {
                return superCartId && superCartId.item
                    ? QuoteMetierService.findAndSetCurrentQuote(superCartId.item)
                    : QuoteMetierService.instanciateNewQuote();
            }).then(function () {
                vm.quoteUpdatePending = true;
                QuoteMetierService.updateQuotePart(ShoppingCartService.constants.ADD_OPERATIONS, interventionItems);
                vm.quoteAdded = true;
            });
        }

        function getQuoteItemsNumber() {
            var quote = CacheService.getDmsQuote();
            if (!quote || !quote.shoppingCart) { return 0; }
            var prCount = _.filter(quote.shoppingCart.PR || [], function (item) {
                return item.quantity != 0;
            }).length;
            var tmCount = _.filter(quote.shoppingCart.TM || [], function (item) {
                return item.quantity != 0;
            }).length;
            return prCount + tmCount;
        }

        function handleBasketAdd() {
            if (vm.basketUpdatePending) { return; }
            if (vm.basketAdded) {
                goToBasket();
                return;
            }
            var hasParts = vm.parts.length > 0;
            var hasTm = vm.labourTimesForQuote.length > 0 || vm.tmCodes.length > 0;
            if (!hasParts && !hasTm) { return; }

            var interventionItems = buildInterventionItems();
            var interventionReferences = interventionItems.INT[0].basketContent.parts.concat(
                interventionItems.INT[0].basketContent.labourTimes
            ).map(function (item) { return item.reference; }).filter(Boolean);
            var modalParams = {
                body: angular.element(document.body),
                title: 'DOCUMENT_PR_INCREASE_BASKET',
                isEasyBasket: true,
                isEasyBasketHeader: 'EASY_BASKET_HEADER_BASKET',
                isEasyBasketFooter: 'EASY_BASKET_FOOTER_BASKET',
                prYesButton: 'PR_POPUP_YESBUTTON',
                tmYesButton: 'TM_POPUP_YESBUTTON',
                prPopupHeader: 'PR_POPUP_HEADER',
                tmPopupHeader: 'TM_POPUP_HEADER',
                showList: true,
                showActifPartRequisition: false,
                prPopUp: !hasParts,
                tmPopUp: !hasTm
            };

            vm.basketUpdatePending = true;
            listOfDraftModalService.showModal(modalParams)
                .then(function () {
                    return ShoppingCartService.updateShoppingCart(
                        ShoppingCartService.constants.ADD_OPERATIONS,
                        interventionItems
                    );
                })
                .then(function () {
                    return ShoppingCartService.onUpdateCart();
                })
                .then(function () {
                    var shoppingCart = ShoppingCartService.getShoppingCart() || [];
                    vm.flattenCart = _.filter(shoppingCart, function (item) {
                        return item.quantity != 0;
                    });
                    var addedItem = _.find(vm.flattenCart, function (item) {
                        return item.interventionId && _.includes(interventionReferences, item.reference);
                    });
                    vm.basketInterventionId = addedItem
                        ? addedItem.interventionId
                        : vm.interventionMeta.id;
                    vm.cartMetadata = ShoppingCartService.getCartMedatadata();
                    vm.basketItemsNumber = vm.flattenCart.length;
                    vm.basketAdded = true;
                })
                .catch(function () {
                    toastr.error('An error occurred');
                })
                .finally(function () {
                    vm.basketUpdatePending = false;
                });
        }

        function goToBasket() {
            var profile = CacheService.getObject(CacheConstants.profil);
            var basket = CacheService.getObject(CacheConstants.panier);
            if (profile && !profile.dmsConnected) {
                if (!basket) {
                    CacheService.setObject(CacheConstants.panier, []);
                }
                $mdDialog.hide();
                $state.go(RoutesConstants.panier);
            }
        }

        function deleteBasketIntervention() {
            if (!vm.basketAdded || vm.basketUpdatePending) { return; }
            var interventionItems = buildInterventionItems();
            var items = interventionItems.INT[0].basketContent.parts.concat(
                interventionItems.INT[0].basketContent.labourTimes,
                interventionItems.INT[0].basketContent.ingredients
            );
            var payload = {
                references: items.map(function (item) { return item.reference; }).filter(Boolean)
            };
            var interventionIds = vm.basketInterventionId ? [vm.basketInterventionId] : [];
            if (!interventionIds.length || !payload.references.length) { return; }

            vm.basketUpdatePending = true;
            ShoppingCartService.deleteIntervention(interventionIds, payload)
                .then(function (response) {
                    var shoppingCart = response && response.items ? response.items : [];
                    ShoppingCartService.setShoppingCart(shoppingCart);
                    vm.flattenCart = [];
                    vm.cartMetadata = ShoppingCartService.getCartMedatadata();
                    vm.basketItemsNumber = 0;
                    vm.basketAdded = false;
                    vm.basketInterventionId = null;
                    ShoppingCartService.emitCartUpdated();
                })
                .catch(function () {
                    toastr.error('An error occurred');
                })
                .finally(function () {
                    vm.basketUpdatePending = false;
                });
        }

        function setQuotePreview() {
            var quote = QuoteMetierService.getQuoteData();
            if (!quote) { return; }
            vm.quoteItems = quote.shoppingCart;
            vm.quotePopinTitle = quote.number || '';
            vm.quotePopinSubtitle = quote.vin || '';
            if (quote.registrationNumber) {
                vm.quotePopinSubtitle += (vm.quotePopinSubtitle ? ' | ' : '') + quote.registrationNumber;
            }
        }

        function deleteQuoteIntervention() {
            if (!vm.quoteAdded && !vm.quoteUpdatePending) { return; }
            var quote = QuoteMetierService.getQuoteData();
            var interventionId = vm.interventionMeta.id;
            if (!quote || !quote.id || !interventionId) { return; }
            var interventionItems = buildInterventionItems();
            var items = interventionItems.INT[0].basketContent.parts.concat(
                interventionItems.INT[0].basketContent.labourTimes,
                interventionItems.INT[0].basketContent.ingredients
            );
            var payload = {
                references: items.map(function (item) { return item.reference; }).filter(Boolean)
            };
            blockUI.start();
            QuoteMetierService.deleteQuoteIntervention(quote.id, [interventionId], payload)
                .then(function () {
                    vm.quoteAdded = false;
                    vm.quoteUpdatePending = false;
                    vm.quoteItems = null;
                    vm.quoteItemsNumber = getQuoteItemsNumber();
                })
                .catch(function () {
                    toastr.error($translate.instant('ERROR'));
                })
                .finally(function () {
                    blockUI.stop();
                });
        }

        function buildInterventionItems() {
            var prItems = vm.parts.map(function (p) {
                var quantity = Number(p.quantity);
                return {
                    reference: p.reference,
                    designation: p.designation,
                    quantity: isNaN(quantity) ? 1 : quantity,
                    //defaultQuantity: p.quantity || 1,
                    type: 'PR',
                   // genericPart: p.genericPart || '',
                    catalogPlates: p.catalogPlates
                };
            });
            // fall back to tmCodes when value-level items were not available from the basket
            var labourTimes = vm.labourTimesForQuote.length ? vm.labourTimesForQuote :
                vm.tmCodes.map(function (tm) {
                    return { opecod: tm.code, designation: tm.designation || '', laborTime: tm.time || 0, quantity: 1, defaultQuantity: 1, type: 'TM', reference: tm.reference || tm.code, technicalId: tm.reference || tm.code, codified: true };
                });
            // mirror listIntervention.getProcessedPRTM: ensure reference is set from technicalId before updateQuotePart
            labourTimes.forEach(function (tm) {
                tm.reference = tm.reference || tm.technicalId || tm.opecod;
                tm.technicalId = tm.technicalId || tm.reference || tm.opecod;
                tm.defaultQuantity = tm.defaultQuantity != null ? tm.defaultQuantity : (tm.quantity || 1);
            });
            return {
                INT: [{
                    id: vm.interventionMeta.id,
                    designation: vm.interventionMeta.designation,
                    version: vm.interventionMeta.version,
                    interventionQuantity: vm.interventionMeta.interventionQuantity,
                    basketContent: {
                        parts: prItems,
                        labourTimes: labourTimes,
                        ingredients: []
                    }
                }]
            };
        }

        function goToQuote() {
            var quote = QuoteMetierService.getQuoteData();
            if (!_.isEmpty(quote)) {
                $mdDialog.hide();
                $state.go(RoutesConstants.dmsQuote);
            }
        }

        function goToQuoteFromBadge(event) {
            event.stopPropagation();
            goToQuote();
        }

        function gotoCatalogPlate(part) {
            var plateid = part.catalogPlates && part.catalogPlates.length
                ? _.map(part.catalogPlates, 'id')
                : '-';
            part.catalogPlateClick = true;
            if (plateid === '-') { return; }
            // collect sibling references that share the same plate so the catalog highlights them all
            var newPartList = _.uniq(
                vm.parts
                    .filter(function (p) { return p.catalogPlates && p.catalogPlates.length; })
                    .filter(function (p) { return plateid.includes(_.map(p.catalogPlates, 'id')[0]); })
                    .map(function (p) { return p.reference; })
            );
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/components/car/carSearchResult/easyBasket/catalogPlate.template.html',
                controller: 'ListePieceCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                skipHide: true,
                multiple: true,
                windowClass: 'my-modal-popup',
                locals: {
                    plateId: plateid,
                    selectedReference: part.reference
                },
                resolve: {
                    disconnect: function () {
                        $timeout(function () {
                            $rootScope.$broadcast('phx-init-listPR', plateid, part.reference, newPartList, part);
                        }, 300);
                    }
                }
            });
        }

        function copyReference(reference) {
            UtilsMetierService.copyToClipboard(reference);
        }

        function onClose() {
            $mdDialog.cancel();
        }
    }
})();

/**
 * fodSubscribePopinCtrl Controller
 * @namespace Controllers
 */
(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('fodSubscribePopinCtrl', fodSubscribePopinCtrl);

    /* @ngInject */
    function fodSubscribePopinCtrl($mdDialog, toastr, $translate, RLinkCarWSService, CacheService, CacheConstants, rLinkConstant, $rootScope, blockUI) {

        var vm = this;
        vm.onCancel = onCancel;
        vm.onSubscribe = onSubscribe;

        function onCancel() {
            $mdDialog.cancel();
        }

        function onSubscribe() {
            if (vm.offerType !== 'hardware') {
                toastr.info($translate.instant('SOFTWARE_SUBSCRIPTION_NOT_IMPLEMENTED'));
                return;
            }

            var getCarContextReq = CacheService.getObject(CacheConstants.contextCarRequest);
            var vin = (getCarContextReq && getCarContextReq.vin) ? getCarContextReq.vin : null;
            vm.user = CacheService.getUserProfile();
            var dealerCode = (vm.user && vm.user.dealerId) ? vm.user.dealerId : null;

            if (!vin) {
                toastr.error($translate.instant('VIN_NOT_FOUND_ERROR_MESSAGE'));
                return;
            }

            var payload = {
                vin: vin,
                contextualHardware: {
                    id: vm.selectedOffer.contextualOfferId,
                    version: vm.selectedOffer.version || "1.0.0"
                },
                channel: rLinkConstant.network,
                dealerCode: dealerCode || "",
            };

            blockUI.start();

            RLinkCarWSService.createAcquisition(payload)
                .then(function (response) {
                blockUI.stop();
        
                    var getCarContextReq = CacheService.getObject(CacheConstants.contextCarRequest);
                    var subscriptionData = {
                        commandId: response.commandId || "temp-" + Date.now(),
                        contextualHardwareId: vm.selectedOffer.contextualOfferId,
                        genericHardwareId: vm.selectedOffer.genericHardwareId,
                        version: vm.selectedOffer.version || "1.0.0",
                        channel: rLinkConstant.network,
                        dealerCode: payload.dealerCode,
                        vin: getCarContextReq ? getCarContextReq.vin : null
                    };
                    $rootScope.$broadcast('addPendingHardwareSubscription', subscriptionData);
                    
                    toastr.success($translate.instant('FOD_SUBSCRIPTION_SUCCESS_TOASTER'));
                    $mdDialog.hide();
                    
                    $rootScope.$broadcast('ConnectedServicesOffers', false, 'isCurrentOffer');
                    
                    setTimeout(function() {
                        $rootScope.$broadcast('refreshCurrentOffers');
                    }, 500);
             })
                .catch(function (error) {
                    blockUI.stop();
                    if (error && error.errors && error.errors[0] && error.errors[0].errorMessage) {
                        toastr.error(error.errors[0].errorMessage);
                    } else {
                        toastr.error($translate.instant('SUBSCRIPTION_ERROR_TOASTER'));
                    }
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('fodCustomerPopinCtrl', fodCustomerPopinCtrl);

    /** @ngInject */
    function fodCustomerPopinCtrl($mdDialog, CacheService, DmsMetierService, DmsConstants, blockUI, toastr, $translate) {
        var vm = this;

        vm.currentCustomer = CacheService.getFodCustomer() || {};
        vm.customerId = '';
        vm.customers = [];
        vm.searchDone = false;
        vm.page = 1;
        vm.pageCount = 1;
        vm.search = search;
        vm.selectById = selectById;
        vm.selectCustomer = selectCustomer;
        vm.previousPage = previousPage;
        vm.nextPage = nextPage;
        vm.onSelectCustomer = onSelectCustomer;
        vm.cancel = cancel;

        function selectById() {
            if (!vm.customerId) { return; }
            blockUI.start();
            DmsMetierService.getUserByAccount({ accountNumber: vm.customerId }).then(function (result) {
                var customer = result && result.response && result.response.customer;
                if (customer) {
                    onSelectCustomer(customer);
                } else {
                    vm.customers = [];
                    vm.searchDone = true;
                }
            }).catch(function () {
                vm.customers = [];
                vm.searchDone = true;
                toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMER_INFORMATIONS'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function search() {
            if (!vm.lastName && !vm.firstName && !vm.accountNumber) { return; }
            vm.page = 1;
            loadResults(0);
        }

        function loadResults(index) {
            var request = {
                name: vm.lastName || '',
                firstName: vm.firstName || '',
                accountNumber: vm.accountNumber || '',
                index: index
            };
            blockUI.start();
            DmsMetierService.getUsersListByCustomers(request).then(function (result) {
                var response = result && result.response || {};
                vm.customers = response.customers || [];
                vm.resultCount = response.numberOfCustomers || 0;
                vm.pageCount = Math.max(1, Math.ceil(vm.resultCount / DmsConstants.maximumNumberOfreturnUsersDms));
                vm.searchDone = true;
            }).catch(function () {
                vm.customers = [];
                vm.resultCount = 0;
                vm.searchDone = true;
                toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMERS'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function selectCustomer(customer) {
            if (customer && customer.accountNumber) {
                selectByAccount(customer.accountNumber);
            } else {
                onSelectCustomer(customer);
            }
        }

        function selectByAccount(accountNumber) {
            blockUI.start();
            DmsMetierService.getUserByAccount({ accountNumber: accountNumber }).then(function (result) {
                onSelectCustomer(result && result.response && result.response.customer);
            }).catch(function () {
                toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMER_INFORMATIONS'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function previousPage() {
            if (vm.page > 1) {
                vm.page -= 1;
                loadResults((vm.page - 1) * DmsConstants.maximumNumberOfreturnUsersDms);
            }
        }

        function nextPage() {
            if (vm.page < vm.pageCount) {
                vm.page += 1;
                loadResults((vm.page - 1) * DmsConstants.maximumNumberOfreturnUsersDms);
            }
        }

        function onSelectCustomer(customer) {
            if (customer && (customer.accountNumber || customer.dmsCustomerId)) {
                CacheService.saveFodCustomer(customer);
                $mdDialog.hide(customer);
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('EligibleOffersPopinCtrl', EligibleOffersPopinCtrl);

    /** @ngInject */
    function EligibleOffersPopinCtrl($mdDialog, offers) {
        var vm = this;
        vm.offers = offers || [];
        vm.close = close;
        vm.selectOffer = selectOffer;
        
        function close() {
            $mdDialog.hide();
        }

        function selectOffer(offer) {
            $mdDialog.hide(offer);
        }
    }
})();
let currentOffersCachePromise = null;
let catalogCachePromise = null;
let acquisitionsCachePromise = null;
let multipleSubsOfferDetailsCachePromise = null;
let multipleSubsOfferDetailsCacheKey = null;
let currentOffersNewOfferListCache = [];
let vinNotFoundToastActive = false; 
let isEligibleOffersLoading = false;
let lastCallTime = 0;
const CALL_DEBOUNCE_TIME = 2000;
let pendingHardwareSubscriptions = [];
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('connectedServicesOffers', {
            bindings: {
                loader: '<'
            },
            controller: ConnectedServicesOffersComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/connectedServicesOffers.template.html'
        });

    /** @ngInject */
    function ConnectedServicesOffersComponent(
        $scope,
        $translate,
        $filter, $rootScope, $mdDialog,configConstantes,
        RLinkCarWSService, toastr, blockUI, RLinkCarMetierService, CacheService, CacheConstants, rLinkConstant, MainMetierService, $timeout, $q,
        DmsMetierService, DocumentsMetierService, DocPrivConstants
    ) {
        var vm = this;
        var fodCalculationResults = {};
        function isVehicleLifetimeDuration(duration) {
            return _.isNil(duration) || String(duration).trim().toLowerCase() === 'null' || String(duration).trim() === '360';
        }

        function isSsaDistributionChannel(distributionChannel) {
            var channels = Array.isArray(distributionChannel) ? distributionChannel : [distributionChannel];
            return channels.some(function (channel) {
                return channel !== null && channel !== undefined && String(channel).trim().toUpperCase() === rLinkConstant.SSA;
            });
        }

        vm.currentOffer = false;
        vm.eligibleOffer = false;
        vm.enableSubscribeButton = false;
        vm.disableRestartOffers = false;
        vm.dealerOffers = false;
        vm.switchOffers = switchOffers;
        vm.subscribe = subscribe;
        vm.plusIconEnabled = plusIconEnabled;
        vm.openRestartingServices = openRestartingServices;
        vm.carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);   
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        vm.user = CacheService.getUserProfile();
        vm.dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
        vm.isDmsProfile = !!CacheService.getObject('dms');
        vm.subscriptionChannel = rLinkConstant.network;
        vm.lifeTime = rLinkConstant.lifeTime;
        vm.cnrData = false;
        vm.newOfferList = _.cloneDeep(currentOffersNewOfferListCache);
        // On-Demand (FOD) sections
        vm.softwareOnDemandList = [];
        vm.hardwareOnDemandList = [];
        vm.softwareEligibleList = [];
        vm.hardwareEligibleList = [];
        vm.softwareOnDemandCollapsed = false;
        vm.hardwareOnDemandCollapsed = false;
        vm.softwareEligibleCollapsed = false;
        vm.hardwareEligibleCollapsed = false;
        vm.subscribeFod = subscribeFod;
        vm.calculateFod = calculateFod;
        vm.resetCustomerAccount = resetCustomerAccount;
        vm.removeHardwareOnDemand = removeHardwareOnDemand;
        vm.openInterventionPopup = openInterventionPopup;
        vm.openFodEasyBasket = openFodEasyBasket;
        let vinNotFoundErrorShown = false; 
        vm.isFodEnable = JSON.parse(configConstantes.isFodEnable);
        vm.getAcquisitions = getAcquisitions;
        vm.hardwareFeaturesOnDemandList = [];
        vm.eligibleHardwareData = [];
        vm.isRLinkNoEligibleOffers = false;

        function isRLinkArchitectureVehicle() {
            var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            var platform = connectedPlatform && connectedPlatform.platform ? connectedPlatform.platform.toUpperCase() : '';
            return platform === 'RLINK1' || platform === 'RLINK2';
        }

            $scope.$on("ConnectedServicesOffers", function (event, value, isFromCurrentOrEnableTab) {
                
            if(isFromCurrentOrEnableTab == 'isCurrentOffer'){
                vm.currentOffer = true;
                vm.eligibleOffer = value;
            }
            else if(isFromCurrentOrEnableTab == 'isEnableTab'){
                vm.currentOffer = false;
                vm.eligibleOffer = value;
            }
            currentOfferEnable();
            });
            
            $rootScope.$on("switchToEligibleOffers", function (event, data) {
                
                if (!data || !data.isEligible) return;
                
                if (data.forceSwitch) {
                    vm.currentOffer = false;
                    vm.eligibleOffer = true;
                    
                    // Use $timeout for proper digest cycle in production
                    $timeout(function() {
                        switchOffers('eligible');
                    }, 300);
                    return;
                }
                
                if (isEligibleOffersLoading) {
                    return;
                }
                
                var currentTime = Date.now();
                if (currentTime - lastCallTime < CALL_DEBOUNCE_TIME) {
                    return;
                }
                
                lastCallTime = currentTime;
                
                // Use $timeout for proper digest cycle in production
                $timeout(function() {
                    if (!isEligibleOffersLoading) {
                        switchOffers('eligible');
                    }
                }, 350);
            });
            
            $rootScope.$on('refreshCurrentOffers', function () {
                currentOffersCachePromise = null;
                catalogCachePromise = null;
                acquisitionsCachePromise = null;
                currentOfferEnable();
            });
            
            $rootScope.$on('addPendingHardwareSubscription', function (event, subscriptionData) {
                pendingHardwareSubscriptions.push(subscriptionData);
            });
            
            $scope.$on('$destroy', function () {
                currentOffersCachePromise = null;
                catalogCachePromise = null;
                acquisitionsCachePromise = null;
                multipleSubsOfferDetailsCachePromise = null;
                multipleSubsOfferDetailsCacheKey = null;
                isEligibleOffersLoading = false;
                lastCallTime = 0;
                vinNotFoundToastActive = false;
                pendingHardwareSubscriptions = [];
                // customer account/prices must not survive navigation away from this page
                CacheService.removeFodCustomer();
            });
        this.$onInit = function () {
            vm.isRLinkArchitecture = isRLinkArchitectureVehicle();

            if (vm.user) {
                if (!_.isEmpty(vm.user.roles)) {
                    vm.user.roles = vm.user.roles.map(function (e) {
                        return e.toUpperCase()
                    });
                }
                if (vm.user.roles.includes(rLinkConstant.arcaCnrCustomerCare) || vm.user.roles.includes(rLinkConstant.rnetCnrCustomerCare)) {
                    vm.enableSubscribeButton = true;
                    vm.subscriptionChannel = rLinkConstant.customerCare;
                } else if (vm.user.roles.includes(rLinkConstant.rnetCnrDealer) || vm.isPpxLightUser) {
                    vm.enableSubscribeButton = true;
                }
            }
            
        };

        function fetchAndProcessOffers(vin, channel, contextualOffersDataKey, filteredContextualKey) {
            var eligibleOffersPromise = RLinkCarWSService.getEligibleOffers(vin, channel);
            var eligibleHardwarePromise;
            if(vm.isFodEnable){
             eligibleHardwarePromise = RLinkCarWSService.getEligibleHardware(vin, channel);
            }
            
            return $q.all({
                offers: eligibleOffersPromise,
                hardware: vm.isFodEnable ? eligibleHardwarePromise : $q.resolve({hardwareList: []})
            }).then(function (results) {
              
                if (results.offers && results.offers.contextualOffers) {
                    vm.eligibleOfferData = results.offers.contextualOffers;
                }
         
                if (results.hardware && results.hardware.hardwareList) {
                    vm.eligibleHardwareData = results.hardware.hardwareList;
                    
                    var catalogHardwarePayload = {
                        contextualHardwares: [],
                        genericHardwares: []
                    };
                    
                    vm.eligibleHardwareData.forEach(function(hardware) {
                        if (hardware.contextualHardwareId) {
                            catalogHardwarePayload.contextualHardwares.push({
                                contextualHardwareId: hardware.contextualHardwareId,
                                version: hardware.genericHardwareVersion || "1.0.0"
                            });
                        }
                        if (hardware.genericHardwareId) {
                            catalogHardwarePayload.genericHardwares.push({
                                genericHardwareId: hardware.genericHardwareId,
                                version: hardware.genericHardwareVersion || "1.0.0"
                            });
                        }
                    });
                    
                    catalogHardwarePayload.contextualHardwares = _.uniqWith(catalogHardwarePayload.contextualHardwares, _.isEqual);
                    catalogHardwarePayload.genericHardwares = _.uniqWith(catalogHardwarePayload.genericHardwares, _.isEqual);
    
                    if (!_.isEmpty(catalogHardwarePayload.contextualHardwares) || !_.isEmpty(catalogHardwarePayload.genericHardwares)) {
                        RLinkCarWSService.getCatalogHardwareSnapshot(catalogHardwarePayload).then(function(catalogResponse) {
                            if (catalogResponse) {
                                vm.eligibleHardwareCatalog = catalogResponse;
                               
                                mapEligibleHardware(vm.eligibleHardwareData, catalogResponse);
                            }
                        }).catch(function(error) {
                        });
                    }
                }
                
                var payload = [];
                if (!_.isEmpty(vm.eligibleOfferData)) {
                    _.map(vm.eligibleOfferData, function (item) {
                        if (item) {
                            var data = {};
                            _.assign(data, {
                                'contextualOfferId': item.id ? item.id : null,
                                'version': item.version ? item.version : null
                            });
                            payload.push(data);
                        }
                    });
                }
                payload = _.uniq(payload);
                return RLinkCarWSService.getCurrentOffersData({ "contextualOffers": payload }).then(function (resp) {
                    if (resp && resp.offers && !_.isEmpty(resp.offers)) {
                        vm[contextualOffersDataKey] = resp.offers;
                        vm[contextualOffersDataKey].forEach(function (item) {
                            var dataArray = [];
                            if (!_.isEmpty(vm.eligibleOfferData) && !_.isEmpty(item.contextualOffers)) {
                                item.contextualOffers.forEach(function (contextualOffer) {
                                    vm.eligibleOfferData.forEach(function (eligibleOffer) {
                                        if (contextualOffer.contextualOfferId == eligibleOffer.id) {
                                            dataArray.push(contextualOffer);
                                        }
                                    });
                                });
                                _.assign(item, { [filteredContextualKey]: dataArray });
                            }
                        });
                    }
                });
            });
        }
        function switchOffers(tab) {
            if (isEligibleOffersLoading) {
                return;
            }
            
            vm.currentOffer = tab == 'current' ? true : false;
            vm.eligibleOffer = tab == 'eligible' ? true : false;
            
            if (vm.currentOffer) {
                currentOfferEnable();
                return;
            }
            
            if (!vm.eligibleOffer) {
                return;
            }

            vm.isRLinkNoEligibleOffers = isRLinkArchitectureVehicle();
            if (vm.isRLinkNoEligibleOffers) {
                // R-Link architecture (R-Link1 & R-Link2) never has eligible offers, so skip the API call
                return;
            }

            isEligibleOffersLoading = true;
            blockUI.start();
            
            var getCarContextReq = CacheService.getObject(CacheConstants.contextCarRequest);
            var vin = (getCarContextReq && getCarContextReq.vin) ? getCarContextReq.vin : null;
            
            // Validate VIN before proceeding
            if (!vin) {
                blockUI.stop();
                isEligibleOffersLoading = false;
                vm.currentOffer = true;
                vm.eligibleOffer = false;
                toastr.error($translate.instant('VIN_NOT_FOUND_ERROR_MESSAGE'));
                return;
            }
            fetchAndProcessOffers(vin, vm.subscriptionChannel, 'contextualOffersData', 'filteredContextual')
                .then(function () {
                    if (vm.user.roles && (vm.user.roles.includes(rLinkConstant.arcaCnrCustomerCare) || vm.user.roles.includes(rLinkConstant.rnetCnrCustomerCare))) {
                        vm.dealerOffers = true;
                        return fetchAndProcessOffers(vin, "Network", 'contextualOffersData1', 'filteredContextual1');
                    }
                })
                .catch(function (errorMsg) {
                    if (errorMsg && errorMsg.errors && errorMsg.errors[0] && errorMsg.errors[0].errorMessage) {
                        toastr.error(errorMsg.errors[0].errorMessage);
                    } else {
                        toastr.error($translate.instant('ERROR'));
                    }
                })
                .finally(function () {
                    blockUI.stop();
                    isEligibleOffersLoading = false;
                });
        }
        function subscribe(offer, dataArray) {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/offerSubscribe.template.html',
                controller: 'offerSubscribeCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                windowClass: 'my-modal-popup',
                locals: {
                    offerDetails: offer,
                    selectedOffer: dataArray

                }
            });
           
        }

        function subscribeFod(offer, type) {
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/fodSubscribePopin.template.html',
                controller: 'fodSubscribePopinCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                windowClass: 'my-modal-popup',
                locals: {
                    selectedOffer: offer,
                    offerType: type
                }
            });
        }
        function getInterventionUserContext() {
            var userContext = CacheService.getUserContext();
            var user = CacheService.getUserProfile();
            var docPrivRole = DocPrivConstants.docPrivPopinVinProfile.toLowerCase();
            if (user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile) &&
                userContext && userContext.userProfiles && userContext.userProfiles.indexOf(docPrivRole) === -1) {
                userContext.userProfiles.push(docPrivRole);
            }
            return userContext;
        }
        function getContextCustomer() {
            var carContext = CacheService.getCarContext();
            var customer = carContext && carContext.customer;
            if (customer && (customer.accountNumber || customer.dmsCustomerId)) {
                return customer;
            }
            return CacheService.getFodCustomer() || null;
        }

        function getOrSelectFodCustomer() {
            var contextCustomer = getContextCustomer();
            if (contextCustomer) {
                return $q.resolve(contextCustomer);
            }
            return $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/fodCustomerPopin.template.html',
                controller: 'fodCustomerPopinCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false,
                locals: {}
            });
        }

        function calculateFod(offer) {
            if (!vm.isDmsProfile || !offer || offer.isCalculating) { return; }
            getOrSelectFodCustomer().then(function (customer) {
                calculateFodForCustomer(offer, customer);
            }).catch(angular.noop);
        }

        function resetCustomerAccount() {
            CacheService.removeFodCustomer();
            fodCalculationResults = {};
            (vm.hardwareEligibleList || []).forEach(function (offer) {
                offer.price = null;
                offer.currency = null;
                offer.showPrice = false;
                offer.isCalculating = false;
            });
        }

        function calculateFodForCustomer(offer, customer) {
            if (!offer || offer.isCalculating) { return; }
            offer.isCalculating = true;
            var currency = null;
            var documentsId = [offer.gieIntervention];
            //var documentsId = ["SIEINT-0000005707_UNOFFICIAL"];
            var dhPayload = {
                carContext: CacheService.getCarContext(),
                userContext: getInterventionUserContext(),
                documentsId: documentsId
            };
            // BR3: fetch basket, enrich with DMS reference.v1, then estimate.v1 (clientEstimateId=FOD00000, workFlag=1)
            var basketPromise = documentsId && documentsId.length
                ? RLinkCarWSService.getBasketInterventionDocuments(dhPayload)
                : $q.resolve(null);
            basketPromise
                .then(function (response) {
                    var parts = [];
                    var tmItems = [];
                    if (response && response.INT && response.INT[0] && response.INT[0].basketContent) {
                        var partsItems = response.INT[0].basketContent.partsItems;
                        if (partsItems) {
                            partsItems.forEach(function (item) {
                                if (item.parts) {
                                    item.parts.forEach(function (part) {
                                        parts.push({
                                            reference: part.reference,
                                            designation: part.designation,
                                            quantity: part.quantity,
                                        });
                                        if (!currency && part.currency) {
                                            currency = part.currency;
                                        }
                                    });
                                }
                            });
                        }
                        var labourTimeItems = response.INT[0].basketContent.labourTimeItems;
                        if (labourTimeItems) {
                            labourTimeItems.forEach(function (item) {
                                if (item.labourTimes) {
                                    item.labourTimes.forEach(function (tm) {
                                        // value[] sub-items are absent without sieIntReport; map directly from labourTimes level
                                        if (tm.value && tm.value.length) {
                                            tm.value.forEach(function (v) { tmItems.push(v); });
                                        } else if (tm.id) {
                                            tmItems.push({
                                                opecod: tm.id,
                                                designation: tm.title || tm.designation || '',
                                                laborTime: tm.duration || 0,
                                                quantity: 1,
                                                codified: true
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                    var references = parts.map(function (p) { return p.reference; }).filter(Boolean);
                    var dmsRefPromise = references.length
                        ? DmsMetierService.getReferencesDms(references)
                        : $q.resolve(null);
                    return dmsRefPromise.then(function (dmsResp) {
                        var dmsParts = dmsResp && (dmsResp.parts || (dmsResp.response && dmsResp.response.parts));
                        if (dmsParts) {
                            var dmsMap = {};
                            dmsParts.forEach(function (dmsPart) {
                                dmsMap[dmsPart.reference] = dmsPart;
                            });
                            parts.forEach(function (part) {
                                if (dmsMap[part.reference]) {
                                    // required by calculateFodEstimate to select item type 'R' in estimate payload
                                    part.dmsInformations = { isKnowFromDms: true };
                                }
                            });
                        }
                        return DmsMetierService.calculateFodEstimate(parts, tmItems, customer);
                    });
                })
                .then(function (estimateResp) {
                    if (!estimateResp || !estimateResp.response || !estimateResp.response.estimate) {
                        return $q.reject();
                    }

                    offer.price = estimateResp.response.estimate.total;
                    offer.currency = offer.currency || currency;
                    offer.showPrice = true;
                    offer.isCalculating = false;
                    fodCalculationResults[getFodCalculationKey(offer)] = {
                        price: offer.price,
                        currency: offer.currency
                    };
                })
                .catch(function () {
                    offer.isCalculating = false;
                    toastr.error($translate.instant('ERROR'));
                });
        }

        function openFodEasyBasket(fod) {
            if (!fod) { return; }
            if (!vm.isDmsProfile) {
                openFodEasyBasketForCustomer(fod, null);
                return;
            }
            getOrSelectFodCustomer().then(function (customer) {
                openFodEasyBasketForCustomer(fod, customer);
            }).catch(angular.noop);
        }

        // GIEINT-to-SIEINT lookup: DH basket-interventions/documents only accepts SIEINT ids
        function getFodSieEntries(gieId) {
            var payload = {
                gies: [gieId],
                carContext: CacheService.getCarContext(),
                userContext: getInterventionUserContext()
            };
            return RLinkCarWSService.getSiesByGies(payload).then(function (response) {
                var entries = (response && response[gieId]) || [];
                return entries.filter(function (entry) {
                    return entry && entry.id && entry.id.indexOf('SIEINT') === 0;
                });
            });
        }

        function selectFodSieIntervention(sieEntries) {
            return $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/interventionSelectionPopin.template.html',
                controller: 'InterventionSelectionPopinCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: { sieEntries: sieEntries }
            });
        }

        function openFodEasyBasketForCustomer(fod, customer) {
            if (!fod || !fod.gieIntervention) { return; }
            blockUI.start();
            getFodSieEntries(fod.gieIntervention)
                .then(function (sieEntries) {
                    if (!sieEntries.length) {
                        blockUI.stop();
                        toastr.info($translate.instant('FOD_NO_EASY_BASKET_AVAILABLE'));
                        // business case: no SIEINT for this GIE, not a technical error
                        return $q.reject({ handled: true });
                    }
                    if (sieEntries.length === 1) {
                        return sieEntries[0].id;
                    }
                    blockUI.stop();
                    return selectFodSieIntervention(sieEntries).then(function (selectedSie) {
                        blockUI.start();
                        return selectedSie.id;
                    }, function () {
                        return $q.reject({ handled: true });
                    });
                })
                .then(function (sieIntId) {
                    return loadFodEasyBasketIntervention(fod, customer, [sieIntId]);
                })
                .catch(function (error) {
                    blockUI.stop();
                    if (!error || !error.handled) {
                        toastr.error($translate.instant('ERROR'));
                    }
                });
        }

        function loadFodEasyBasketIntervention(fod, customer, documentsId) {
            var payload = {
                carContext: CacheService.getCarContext(),
                userContext: getInterventionUserContext(),
                sieIntReport: true,
                documentsId: documentsId
            };
            return RLinkCarWSService.getBasketInterventionDocuments(payload)
                .then(function (response) {
                    var parts = [];
                    var tmCodes = [];
                    var labourTimesForQuote = [];
                    var interventionId = '';
                    var interventionVersion = '';
                    var interventionQuantity = null;
                    if (response && response.INT && response.INT[0] && response.INT[0].basketContent) {
                        var int0 = response.INT[0];
                        interventionId = int0.id || '';
                        interventionVersion = int0.version || '';
                        interventionQuantity = int0.interventionQuantity || null;
                        var basketContent = int0.basketContent;
                        if (basketContent.partsItems) {
                            basketContent.partsItems.forEach(function (item) {
                                if (item.parts) {
                                    item.parts.forEach(function (part) {
                                        parts.push({
                                            reference: part.reference,
                                            designation: part.designation,
                                            quantity: part.quantity,
                                            price: part.priceExclTaxes,
                                            currency: part.currency,
                                            inStock: part.inStock,
                                            catalogPlates: part.catalogPlates
                                        });
                                    });
                                }
                            });
                        }
                        var elementList = [];
                        if (basketContent.labourTimeItems) {
                            basketContent.labourTimeItems.forEach(function (item) {
                                if (item.labourTimes) {
                                    item.labourTimes.forEach(function (tm) {
                                        var tmDesignation = tm.title || tm.designation;
                                        tmCodes.push({
                                            code: tm.id,
                                            designation: tmDesignation,
                                            plateNumber: tm.plateNumber,
                                            time: tm.duration,
                                            type: tmDesignation ? tmDesignation.substring(0, 2) : '',
                                            reference:tm.technicalId
                                        });
                                        // collect element at parent level for MR lookup when value[] is absent
                                        if (tm.element && !_.includes(elementList, tm.element)) {
                                            elementList.push(tm.element);
                                        }
                                        if (tm.value && tm.value.length) {
                                            tm.value.forEach(function (v) {
                                                // value[] is the operation level required by ADD_OPERATIONS; labourTimes[] is display only
                                                var tmItem = angular.copy(v);
                                                tmItem.type = 'TM';
                                                tmItem.designation = tmDesignation;
                                                tmItem.opecod = tmItem.opecod || tmItem.id || tm.id;
                                                tmItem.reference = tmItem.technicalId || tmItem.id || tm.id;
                                                // laborTime is required by calculateFodEstimate; duration uses comma as decimal separator
                                                tmItem.laborTime = tmItem.duration ? parseFloat(tmItem.duration.toString().replace(/,/, '.')) : 0;
                                                // FOD TMs are not in the DMS catalog; use non-codified "V" path so DMS prices by hourly rate * time
                                                if (tmItem.codified !== true) { tmItem.codified = false; }
                                                labourTimesForQuote.push(tmItem);
                                                if (v.element && !_.includes(elementList, v.element)) {
                                                    elementList.push(v.element);
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                    // DMS reference.v1 and MR lookup run in parallel; MR failure is silenced to never block the popup
                    var references = parts.map(function (p) { return p.reference; }).filter(Boolean);
                    var dmsRefPromise = vm.isDmsProfile && references.length
                        ? DmsMetierService.getReferencesDms(references)
                        : $q.resolve(null);
                    var mrPromise = elementList.length
                        ? DocumentsMetierService.getIDsBySieElemOpe(elementList, ['MR']).catch(function () { return []; })
                        : $q.resolve([]);
                    return $q.all([dmsRefPromise, mrPromise]).then(function (results) {
                        var dmsResp = results[0];
                        var mrResults = results[1];
                        var dmsParts = dmsResp && (dmsResp.parts || (dmsResp.response && dmsResp.response.parts));
                        if (dmsParts) {
                            var dmsMap = {};
                            dmsParts.forEach(function (dmsPart) {
                                dmsMap[dmsPart.reference] = dmsPart;
                            });
                            parts.forEach(function (part) {
                                var dms = dmsMap[part.reference];
                                if (dms) {
                                    // BR2: override DH price and stock with DMS reference.v1 values
                                    part.price = dms.priceExclTaxes;
                                    var dmsQuantity = dms.availabilities && dms.availabilities.length
                                        ? dms.availabilities[0].quantity
                                        : undefined;
                                    part.dmsStock = dmsQuantity;
                                    part.dmsInformations = {
                                        isKnowFromDms: true,
                                        quantity: dmsQuantity
                                    };
                                    part.stockAvailability = dmsQuantity > 0;
                                }
                            });
                        }
                        var mrDocumentIds = [];
                        if (!_.isEmpty(mrResults)) {
                            mrResults.forEach(function (item) {
                                if (item.docs && !_.isEmpty(item.docs)) {
                                    item.docs.forEach(function (doc) {
                                        var documentId = doc.sieRef || doc.id;
                                        if (documentId) { mrDocumentIds.push(documentId); }
                                    });
                                }
                            });
                            mrDocumentIds = _.uniq(mrDocumentIds.filter(Boolean));
                        }
                        if (!mrDocumentIds.length) {
                            mrDocumentIds = documentsId.slice();
                        }
                        var currency = parts.length && parts[0].currency ? parts[0].currency : '';
                        blockUI.stop();
                        $mdDialog.show({
                                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/interventionPopin.template.html',
                                controller: 'interventionPopinCtrl',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: true,
                                multiple: true,
                                skipHide: true,
                                locals: {
                                    selectedOffer: {
                                        name: fod.name,
                                        parts: parts,
                                        tmCodes: tmCodes,
                                        price: null,
                                        currency: currency,
                                        mrDocumentIds: mrDocumentIds,
                                        labourTimesForQuote: labourTimesForQuote,
                                        customer: customer,
                                        documentsId: documentsId,
                                        dmsParts: dmsParts || [],
                                        interventionId: interventionId,
                                        interventionVersion: interventionVersion,
                                        interventionQuantity: interventionQuantity
                                    }
                                }
                        });
                    });
                });
        }

        function openInterventionPopup(offer) {
            return $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/interventionPopin.template.html',
                controller: 'interventionPopinCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                windowClass: 'my-modal-popup',
                locals: {
                    selectedOffer: offer
                }
            }).catch(function () {

            });
        }

        function removeHardwareOnDemand(offer, index) {
            if (vm.hardwareOnDemandList && index > -1) {
                vm.hardwareOnDemandList.splice(index, 1);
            }
        }

        function showVinNotFoundToasterOnce() {
            if (!vinNotFoundToastActive) {
                var messageKey = isRLinkArchitectureVehicle() ? 'CURRENT_OFFERS_RLINK_VIN_NOT_FOUND_MESSAGE' : 'VIN_NOT_FOUND_ERROR_MESSAGE';
                toastr.error($translate.instant(messageKey));
                vinNotFoundToastActive = true;
                $timeout(function() { vinNotFoundToastActive = false; }, 2000);
            }
        }

        function mapEligibleHardware(eligibleHardwareData, catalogData) {
            vm.hardwareEligibleList = [];
            
            if (!eligibleHardwareData || !catalogData) {
                return;
            }
            
            eligibleHardwareData.forEach(function(hardware) {
                var mappedItem = {
                    name: '-',
                    contextualOfferId: hardware.contextualHardwareId || '-',
                    genericHardwareId: hardware.genericHardwareId,
                    version: hardware.genericHardwareVersion || '-',
                    duration: 'Lifetime', // Always show "Lifetime" as per requirement
                    country: '-',
                    price: null,
                    currency: null,
                    showPrice: false
                };
                
                var contextualHw;
                var genericHw;
                if (hardware.contextualHardwareId && catalogData.contextualHardwares) {
                    contextualHw = catalogData.contextualHardwares.find(function(hw) {
                        return String(hw.contextualHardwareId || hw.id) === String(hardware.contextualHardwareId);
                    });
                }
                if (hardware.genericHardwareId && catalogData.genericHardwares) {
                    genericHw = catalogData.genericHardwares.find(function(hw) {
                        return String(hw.genericHardwareId || hw.id) === String(hardware.genericHardwareId);
                    });
                }

                mappedItem.name = (contextualHw && contextualHw.name) || (genericHw && genericHw.name) || '-';
                mappedItem.country = (contextualHw && contextualHw.country) || (genericHw && genericHw.country) || '-';
                mappedItem.version = (contextualHw && contextualHw.hardwareVersion) || (genericHw && genericHw.hardwareVersion) || hardware.genericHardwareVersion || '-';
                mappedItem.gieIntervention = hardware.gieIntervention ||
                    (contextualHw && contextualHw.gieIntervention) ||
                    (genericHw && genericHw.gieIntervention) || null;

                var calculationResult = fodCalculationResults[getFodCalculationKey(mappedItem)];
                if (calculationResult) {
                    mappedItem.price = calculationResult.price;
                    mappedItem.currency = calculationResult.currency;
                    mappedItem.showPrice = true;
                }

                vm.hardwareEligibleList.push(mappedItem);
            });
        }

        function getFodCalculationKey(offer) {
            return [offer.contextualOfferId, offer.genericHardwareId, offer.version].join('|');
        }

        function mapHardwareFeaturesOnDemand(acquisitionsData, catalogData) {
           
            vm.hardwareFeaturesOnDemandList = [];
            
            if (!acquisitionsData || !acquisitionsData.acquisitions || !catalogData) {
                return;
            }
            
            acquisitionsData.acquisitions.forEach(function(acquisition) {
                var mappedItem = {
                    // From ACR (acquisitions)
                    status: acquisition.status || '-',
                    subscriptionDate: acquisition.acquisitionDate || '-',
                    installationDate: acquisition.installationDate || '-',
                    acquisitionId: acquisition.acquisitionId || '',
                    acquisitionChannel: acquisition.acquisitionChannel || '',
                    dealerCode: acquisition.dealerCode || '',
                    // Default values that will be filled from catalog
                    offerCountry: '-',
                    genericOffer: '-',
                    country: '-'
                };
                
                // Find matching contextual hardware from catalog
                if (acquisition.contextualHardware && acquisition.contextualHardware.id && catalogData.contextualHardwares) {
                    var contextualHw = catalogData.contextualHardwares.find(function(hw) {
                        return hw.contextualHardwareId === acquisition.contextualHardware.id;
                    });
                    
                    if (contextualHw) {
                        mappedItem.offerCountry = contextualHw.name || '-'; // "Country offer" = contextual hardware name
                        mappedItem.country = contextualHw.country || '-';
                    }
                }
                
                // Find matching generic hardware from catalog
                if (acquisition.genericHardware && acquisition.genericHardware.id && catalogData.genericHardwares) {
                    var genericHw = catalogData.genericHardwares.find(function(hw) {
                        return hw.genericHardwareId === acquisition.genericHardware.id;
                    });
                    
                    if (genericHw) {
                        mappedItem.genericOffer = genericHw.name || '-'; // "Generic offer" = generic hardware name
                    }
                }
                
                vm.hardwareFeaturesOnDemandList.push(mappedItem);
            });
            
        }

        function getAcquisitions() {
            if (!acquisitionsCachePromise) {
                var getCarContextReq = CacheService.getObject(CacheConstants.contextCarRequest);
                var vin = (getCarContextReq && getCarContextReq.vin) ? getCarContextReq.vin : null;
                if (vin) {
                    acquisitionsCachePromise = RLinkCarWSService.getAcquisitions(vin).then(function (acquisitionsData) {
                        if (pendingHardwareSubscriptions && pendingHardwareSubscriptions.length > 0 && acquisitionsData) {
                            if (!acquisitionsData.acquisitions) {
                                acquisitionsData.acquisitions = [];
                            }
                            pendingHardwareSubscriptions.forEach(function(pendingSub) {
                                acquisitionsData.acquisitions.push({
                                    acquisitionId: pendingSub.commandId || "pending-" + Date.now(),
                                    acquisitionDate: new Date().toISOString(),
                                    installationDate: null,
                                    cancellationDate: null,
                                    status: "PENDING",
                                    genericHardware: {
                                        id: pendingSub.genericHardwareId || 1012,
                                        version: pendingSub.version || "1.0.0"
                                    },
                                    contextualHardware: {
                                        id: pendingSub.contextualHardwareId
                                    },
                                    acquisitionChannel: pendingSub.channel || "Network",
                                    dealerCode: pendingSub.dealerCode || ""
                                });
                            });
                            pendingHardwareSubscriptions = [];
                        }
                        if (acquisitionsData) {
                            vm.acquisitionsData = acquisitionsData;
                            
                            // Call catalog hardware snapshot with acquisitions data
                            if (acquisitionsData.acquisitions && acquisitionsData.acquisitions.length > 0) {
                                var catalogPayload = {
                                    contextualHardwares: [],
                                    genericHardwares: []
                                };
                                
                                acquisitionsData.acquisitions.forEach(function(acquisition) {
                                    if (acquisition.contextualHardware && acquisition.contextualHardware.id) {
                                        catalogPayload.contextualHardwares.push({
                                            contextualHardwareId: acquisition.contextualHardware.id,
                                            version: acquisition.genericHardware && acquisition.genericHardware.version ? acquisition.genericHardware.version : "1.0.0"
                                        });
                                    }
                                    if (acquisition.genericHardware && acquisition.genericHardware.id) {
                                        catalogPayload.genericHardwares.push({
                                            genericHardwareId: acquisition.genericHardware.id,
                                            version: acquisition.genericHardware.version ? acquisition.genericHardware.version : "1.0.0"
                                        });
                                    }
                                });
                                
                                // Remove duplicates
                                catalogPayload.contextualHardwares = _.uniqWith(catalogPayload.contextualHardwares, _.isEqual);
                                catalogPayload.genericHardwares = _.uniqWith(catalogPayload.genericHardwares, _.isEqual);
                                
                                RLinkCarWSService.getCatalogHardwareSnapshot(catalogPayload).then(function(catalogResponse) {
                                    if (catalogResponse) {
                                        vm.catalogHardwareSnapshot = catalogResponse;
                                        mapHardwareFeaturesOnDemand(acquisitionsData, catalogResponse);
                                    }
                                }).catch(function(error) {
                                });
                            }
                        }
                        return acquisitionsData;
                    }).catch(function (error) {
                        return $q.reject(error);
                    });
                }
            }
            return acquisitionsCachePromise;
        }

        function currentOfferEnable() {
            showVinNotFoundToasterOnce.called = false; // Reset flag at start of each run
            $rootScope.$broadcast('enableLoader', true);
            vm.disableRestartOffers = true;
            vinNotFoundErrorShown = false; // Reset flag at start of each run

            if (!currentOffersCachePromise) {
                currentOffersCachePromise = RLinkCarMetierService.getCurrentOffersSearchData();
            }


            if(vm.isFodEnable) {
                getAcquisitions();
            }

            currentOffersCachePromise.then(function (response) {
                    if (response && response.data && response.data.values) {
                        vm.currentOffersList = response.data.values;
                        vm.cnrData = true;
                    } else {
                        vm.currentOffersList = [];
                        vm.cnrData = false;
                    }
                    if (!_.isEmpty(currentOffersNewOfferListCache)) {
                        vm.newOfferList = _.cloneDeep(currentOffersNewOfferListCache);
                    }
                    if (_.isEmpty(currentOffersNewOfferListCache) && _.isEmpty(vm.newOfferList)) {
                        vm.newOfferList = [];
                    }
                    var payload = [];
                    if (!_.isEmpty(vm.currentOffersList)) {
                        _.map(vm.currentOffersList, function (item) {
                            if (item.genericOffer) {
                                payload.push({
                                    'genericOfferId': item.genericOffer.id,
                                    'version': item.genericOffer.version
                                });
                            }
                        });
                    }
                    payload = _.uniq(payload);
                    if (!catalogCachePromise) {
                        catalogCachePromise = RLinkCarWSService.getCurrentOffersData({ "genericOffers": payload });
                    }
                    return catalogCachePromise;
                })
                .then(function (resp) {
                    if (resp && resp.offers && !_.isEmpty(resp.offers)) {
                        vm.catalogResponse = resp.offers;
                        vm.offerNameList = _.groupBy(resp.offers, 'genericOfferId');
                        if (vm.currentOffersList && !_.isEmpty(vm.currentOffersList)) {
                            _.map(vm.currentOffersList, function (item) {
                                var genericOffer = vm.offerNameList[item.genericOffer.id][0];
                                var contextualOffer = !_.isEmpty(genericOffer.contextualOffers)
                                    ? genericOffer.contextualOffers[0]
                                    : null;
                                var duration = contextualOffer && contextualOffer.duration;
                                var distributionChannel = contextualOffer && contextualOffer.distributionChannel;
                                if (distributionChannel === undefined) {
                                    distributionChannel = genericOffer.distributionChannel;
                                }
                                var validityEnd = item.genericOffer && item.genericOffer.validityEnd;
                                if (validityEnd === undefined) {
                                    validityEnd = genericOffer.validityEnd;
                                }
                                var hasNullValidityEnd = validityEnd === null ||
                                    (typeof validityEnd === 'string' && validityEnd.toLowerCase() === 'null');
                                var isVehicleLifetime = isVehicleLifetimeDuration(duration) && isSsaDistributionChannel(distributionChannel);
                                var isNonSsaFiniteDuration = !isVehicleLifetimeDuration(duration) && !isSsaDistributionChannel(distributionChannel);
                                var shouldHideEndDate = hasNullValidityEnd && isNonSsaFiniteDuration;
                                _.assign(item, {
                                    'name': genericOffer.name,
                                    'duration': isVehicleLifetime
                                        ? $translate.instant('VEHICLE_LIFETIME_WITHOUT_ASTERISK')
                                        : (duration === null || duration === undefined || duration === 'null' ? ' ' : duration),
                                    'distributionChannel': distributionChannel,
                                    'hasNullValidityEnd': hasNullValidityEnd,
                                    'hideEndDate': isVehicleLifetime || shouldHideEndDate,
                                    'isVehicleLifetime': isVehicleLifetime
                                });
                            });

                            vm.offerList = vm.currentOffersList;
                            let urls = vm.offerList.map(function(item){
                                return item.subscriptionId;
                            });
                            const refreshedNewOfferList = [];
                            urls = _.compact(urls);
                            if (!_.isEmpty(urls)) {
                                const urlsCacheKey = _.sortBy(urls).join('|');
                                if (!multipleSubsOfferDetailsCachePromise || multipleSubsOfferDetailsCacheKey !== urlsCacheKey) {
                                    multipleSubsOfferDetailsCacheKey = urlsCacheKey;
                                    multipleSubsOfferDetailsCachePromise = RLinkCarWSService.getMultipleSubsOfferDetails(urls);
                                }

                                multipleSubsOfferDetailsCachePromise.then(function(response){
                                    if(!_.isEmpty(response)){
                                        vm.multipleSubsOfferDetails = response;
                                        $q.resolve().then(function(){
                                            return response.forEach(function(item){
                                                if(item){
                                                    item.contextualOffers = _.groupBy(item.contextualOffers, 'id');
                                                    if(!_.isEmpty(vm.catalogResponse)){
                                                        return vm.catalogResponse.forEach(function(catItem){
                                                            if(!_.isEmpty(catItem.contextualOffers)){
                                                                return catItem.contextualOffers.forEach(function(contItem){
                                                                    if(item.contextualOffers[contItem.contextualOfferId]){
                                                                        var subscriptionOffer = item.contextualOffers[contItem.contextualOfferId][0];
                                                                        var currentOffer = _.find(vm.currentOffersList, function (offer) {
                                                                            return offer.subscriptionId === item.subscriptionId;
                                                                        });
                                                                        var validityEnd = currentOffer && currentOffer.genericOffer
                                                                            ? currentOffer.genericOffer.validityEnd
                                                                            : undefined;
                                                                        var catalogDuration = contItem.duration;
                                                                        var subscriptionDuration = subscriptionOffer && subscriptionOffer.duration;
                                                                        var duration = catalogDuration === null || catalogDuration === undefined || catalogDuration === 'null'
                                                                            ? subscriptionDuration
                                                                            : catalogDuration;
                                                                        var distributionChannel = contItem.distributionChannel;
                                                                        if (_.isEmpty(distributionChannel)) {
                                                                            distributionChannel = subscriptionOffer && subscriptionOffer.distributionChannel;
                                                                        }
                                                                        // this contextual offer is the subscription's actual one, so correct the End Date flag here instead of waiting for plusIconEnabled
                                                                        if (currentOffer && isVehicleLifetimeDuration(duration) && isSsaDistributionChannel(distributionChannel)) {
                                                                            _.assign(currentOffer, {
                                                                                'duration': $translate.instant('VEHICLE_LIFETIME_WITHOUT_ASTERISK'),
                                                                                'hideEndDate': true,
                                                                                'isVehicleLifetime': true
                                                                            });
                                                                        }
                                                                        if (currentOffer && currentOffer.isVehicleLifetime) {
                                                                            duration = currentOffer.duration;
                                                                        }
                                                                        refreshedNewOfferList.push({
                                                                            name: contItem.name,
                                                                            serviceId: contItem.contextualOfferId,
                                                                            genericOfferId: currentOffer && currentOffer.genericOffer
                                                                                ? currentOffer.genericOffer.id
                                                                                : null,
                                                                            duration: duration,
                                                                            validityEnd: validityEnd,
                                                                            status: item.status,
                                                                            distributionChannel: distributionChannel,
                                                                            subscriptionId: item.subscriptionId
                                                                        });
                                                                        return;
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    }
                                                }
                                            });
                                        }).finally(function () {
                                            if (!_.isEmpty(refreshedNewOfferList)) {
                                                vm.newOfferList = _.uniqWith(refreshedNewOfferList, _.isEqual);
                                                currentOffersNewOfferListCache = _.cloneDeep(vm.newOfferList);
                                            }
                                            if (_.isEmpty(refreshedNewOfferList) && _.isEmpty(vm.newOfferList) && !_.isEmpty(currentOffersNewOfferListCache)) {
                                                vm.newOfferList = _.cloneDeep(currentOffersNewOfferListCache);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                })
                .catch(function (errorMsg) {
                    if (errorMsg && !_.isEmpty(errorMsg.errors) && errorMsg.errors[0] && errorMsg.errors[0].errorMessage != '') {
                        if (errorMsg.errors[0].errorCode == 'VIN_NOT_FOUND') {
                            showVinNotFoundToasterOnce();
                        } else {
                            toastr.error(errorMsg.errors[0].errorMessage);
                        }
                    }
                })
                .finally(function () {
                    blockUI.stop();
                    $rootScope.$broadcast('enableLoader', false);
                    vm.disableRestartOffers = false;
                });
        }

            function openRestartingServices(vin, user, dmsResponse,display){
            $mdDialog.show({
                templateUrl: 'app/components/car/rLinkCar/restartingServices/restartingServices.template.html',
                controller: 'RestartingServicesCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                windowClass: 'restartingServiceModalPopup',
                locals: {
                    vin: vin,
                    userInfo: user,
                    dmsCustInfo: (dmsResponse && dmsResponse.customer) ? dmsResponse.customer : "",
                    offerList: vm.currentOffersList,
                    catalogResp: vm.catalogResponse,
                    newOfferList: !_.isEmpty(vm.newOfferList)
                        ? vm.newOfferList
                        : currentOffersNewOfferListCache,
                    display: display
                }
            }).catch(function () {

            });
        }

        function plusIconEnabled(offer, index) {
            if (offer && !offer.subscriptionDetails) {
            blockUI.start();
            RLinkCarWSService.getSubscriptionOfferDetails(offer.subscriptionId).then(function (response) {
                // generic offer may have no contextual offers in the catalog; still resolve gracefully
                var contextualOffers = (response && response.contextualOffers) || [];
                contextualOffers.forEach(function (data) {
                    if(!_.isEmpty(vm.catalogResponse)){
                        vm.catalogResponse.forEach(function (catalogData) {
                            if(catalogData && !_.isEmpty(catalogData.contextualOffers)) {
                            catalogData.contextualOffers.forEach(function (catalogOffer) {
                                if (catalogOffer.contextualOfferId == data.id) {
                                    var duration = catalogOffer.duration;
                                    var isVehicleLifetime = isVehicleLifetimeDuration(duration) &&
                                        isSsaDistributionChannel(catalogOffer.distributionChannel);
                                    if (isVehicleLifetime) {
                                        _.assign(vm.currentOffersList[index], {
                                            'duration': $translate.instant('VEHICLE_LIFETIME_WITHOUT_ASTERISK'),
                                            'hideEndDate': true,
                                            'isVehicleLifetime': true
                                        });
                                    }
                                    _.assign(data, {
                                        'duration': isVehicleLifetime ? $translate.instant('VEHICLE_LIFETIME_WITHOUT_ASTERISK') : (duration || ""),
                                        'price': (catalogOffer && catalogOffer.price) ? catalogOffer.price : "",
                                        'country': (catalogOffer && catalogOffer.country) ? catalogOffer.country : "",
                                        'currency': (catalogOffer && catalogOffer.currency) ? catalogOffer.currency : "",
                                        'designation': (catalogOffer && catalogOffer.name) ? catalogOffer.name : "",
                                    })
                                }
                            })
                        }
                        })
                    }
                })

                _.assign(vm.currentOffersList[index], { 'subscriptionDetails': contextualOffers })
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }
    }
    }
})();

/**
 * Battery Certificate Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .component('batteryCertificate', {
            bindings: {
                batteryVin: '<',
                batteryCheck:'<',
                batteryUidCheck:'<'
            },
            controller: batteryCertificateCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/batteryCertificate/batteryCertificate.template.html'
        })
        .controller('batteryCertificateCtrl', batteryCertificateCtrl);

    function batteryCertificateCtrl(
        $rootScope,
        $translate,
        rLinkConstant,
        CacheService,
        UtilsMetierService,
        $mdDialog,
        printPdfModalService,
        CacheConstants,$q,
        PDFViewService,
        configConstantes
        ) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
    
            var vm = this;
            vm.user = CacheService.getUserProfile();
            vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
            vm.closePopIn = closePopIn;
            vm.batteryCertifDetails = batteryCertifDetails;
            vm.downloadPdf = downloadPdf;
            vm.formatDatatoPrint = formatDatatoPrint;
            vm.soh = rLinkConstant.soh;
            vm.centralPurchase = rLinkConstant.central;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

            var pictoImage = {
            
                "RENAULT":{src:convertImgToBase64("/assets/images/renaultgroup.png","RENAULT")},
                "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")}
            }
            
        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }

        function getTableData(tableData) {
            return PDFViewService.getTableData(tableData);
        }

        function closePopIn() {
            $mdDialog.hide();
        }

        function batteryCertifDetails() {
            downloadPdf().then(function (response) {
                pdfMake.tableLayouts = {
                    otherTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 0 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                        },
                        
                    }
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });
                    var isIE = false || !!document.documentMode;
                    var isEdge = !isIE && !!window.StyleMedia;

                    if (isIE || isEdge) {
                        var todaysDate = moment(new Date()).format('"YYYY/MM/DD"');
                        FileSaver.saveAs(file, todaysDate + '_' + $translate.instant('PDF_NAME') + '.pdf');
                    } else {

                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }
                            return printPdfModalService.showModal(modalParams).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });
                        }).catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
                })
            });
        }



        function downloadPdf() {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var todaysDate = moment(new Date()).format('YYYY-MM-DD');
            var batteryDetails = {
                carDetails: {
                    Type: contextCarRequest.model ?
                        contextCarRequest.model : '', VIN: contextCarRequest.vin, DATE:todaysDate
                },
                translatedLabels: {
                    batteryTitle: 'BATTERY CERTIFICATE BLMS INFO',
                    analysisOfVechile: $translate.instant("ANALYSIS_OF_YOUR_VEHICLE"),
                    infoList1: $translate.instant("INFO_BATTERY_CERTIFICATE"),
                    infoList2: $translate.instant("INFO_CLIENT_PAID"),
                    infoList3: $translate.instant("INFO_CLIENT_DOWNLOADED"),
                    infoList4: $translate.instant("INFO_DISPLAY_ISSUE"),
                    infoList5: $translate.instant("INFO_NO_DATA_DISPLAYED"),
                    uidStatus1: $translate.instant("BLMS_POPUP_TEXT1"),
                    uidStatus2: $translate.instant("BLMS_POPUP_TEXT2"),
                    uidStatus3: $translate.instant("BLMS_POPUP_TEXT3"),
                    sohstatus1 : $translate.instant("SOH_DOWNLOADED_CONTENT"),
                    sohstatus2 : $translate.instant("SOH_VALUE_DISPLAYED_CONTENT"),
                    sohstatus3 : $translate.instant("SOH_ENERGY_STORAGE_CONTENT"),
                    sohstatus4 : $translate.instant("SOH_BATTERY_CERTIFICATE_CONTENT"),
                    sohstatus5 : $translate.instant("SOH_VEHICLE_MILEAGE_CONTENT"),
                    batteryStatus: $translate.instant("SOH_VIN_BIN_CONTENT"),
                    binVinContent1 : $translate.instant("VEHICLE_PRODUCTION_CONTENT"),
                    binVinContent2 : $translate.instant("PURCHASE_MODE_LEASE_CONTENT"),
                    purchaseStatus : $translate.instant("BLMS_PURCHASE_BUY"),
                    pdfName: $translate.instant("PDF_NAME"),
                    uid : $translate.instant("EASYLINK_VEHICLE_UID"),
                    uidName :$translate.instant("UID_NAME"),
                    uidStatus :$translate.instant("SERVICE_ACTIVATION_STATUS"),
                    sohDate : $translate.instant("SOH_LAST_UPDATE_DATE"),
                    vehicleMilage : $translate.instant("BLMS_VEHICLE_MILEAGE"),
                    vehicleMilageDate : $translate.instant("BLMS_VEHICLE_MILEAGE_DATE"),
                    batMileage :$translate.instant("BLMS_BATTERY_MILEAGE"),
                    batMilageDate : $translate.instant("BLMS_BATTERY_MILEAGE_DATE"),
                    binVinAssociateDate :$translate.instant("BLMS_BIN_VIN_DATE"),
                    purchaseModeLabel : $translate.instant("BLMS_PURCHASE_MODE")
                },
                batteryUidInfo : vm.batteryUidData,
                batteryVin : vm.batteryVin
            };
            return formatDatatoPrint(batteryDetails);
        }


        function formatDatatoPrint(batteryDetails) {
            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            
            
            var batteryTitle = { type: "columns", values: { 0: [batteryDetails.translatedLabels.batteryTitle] }, styles: "titleStyle" };
            dataArray.push(batteryTitle);

            var batteryDetailObj = { type: "columns", values: { 0: ['\n' + batteryDetails.translatedLabels.analysisOfVechile] }, styles: "textStyle1" };
            dataArray.push(batteryDetailObj);
            
            
            var batteryDetailsObj1 = { type: "columns", values: { 0: ['\n'+'Date : '], 1:['\n'+batteryDetails.carDetails.DATE ] }, styles: "textStyle2" };
            dataArray.push(batteryDetailsObj1);

            var batteryDetailsObj2 = { type: "columns", values: { 0: ['\n'+'Type : '], 1:['\n'+batteryDetails.carDetails.Type ] }, styles: "textStyle2" };
            dataArray.push(batteryDetailsObj2);

            var batteryDetailsObj3 = { type: "columns", values: { 0: ['\n'+'VIN : '], 1: ['\n'+batteryDetails.carDetails.VIN] }, styles: "textStyle2" };
            dataArray.push(batteryDetailsObj3);

            var batteryInfoList1 = {type: "columns",values: {0: ['\n\n• ' + batteryDetails.translatedLabels.infoList1]},
            styles: "infoListStyle"
            };
            dataArray.push(batteryInfoList1);

            var batteryInfoList2 = {type: "columns",values: {0: ['• ' + batteryDetails.translatedLabels.infoList2]},
            styles: "infoListStyle"
            };
            dataArray.push(batteryInfoList2);

            var batteryInfoList3 = {type: "columns",values: {0: ['• ' + batteryDetails.translatedLabels.infoList3]},
            styles: "infoListStyle"
            };
            dataArray.push(batteryInfoList3);

            var batteryInfoList4 = {type: "columns",values: {0: ['• ' + batteryDetails.translatedLabels.infoList4]},
            styles: "infoListStyle"
            };
            dataArray.push(batteryInfoList4);

            var batteryInfoList5 = {type: "columns",values: {0: ['• ' + batteryDetails.translatedLabels.infoList5]},
            styles: "infoListStyle"
            };
            dataArray.push(batteryInfoList5);


            var firstTable = [
                
                (vm.batteryCheck && batteryDetails.batteryUidInfo)
                ? {type: 'uid', uid: batteryDetails.batteryUidInfo.uid, name: batteryDetails.batteryUidInfo.name, status: batteryDetails.batteryUidInfo.status, staticInfo: '• ' + batteryDetails.translatedLabels.uidStatus1 +'\n'+'• ' + batteryDetails.translatedLabels.uidStatus2+'\n'+'• ' + batteryDetails.translatedLabels.uidStatus3 } : null,

                {type: 'soh', soh: batteryDetails.batteryVin.soheRef , sohLastUpdateDate: batteryDetails.batteryVin.soheRefLud , staticInfo: '• ' + batteryDetails.translatedLabels.sohstatus1 +'\n'+'• ' + batteryDetails.translatedLabels.sohstatus2+'\n'+'• ' + batteryDetails.translatedLabels.sohstatus3+'\n'+'• ' + batteryDetails.translatedLabels.sohstatus4},

                {type: 'vehicle', vehMileage: batteryDetails.batteryVin.evDstTot , vehMileageDate: batteryDetails.batteryVin.evDstTotLud, staticInfo: '• ' + batteryDetails.translatedLabels.sohstatus5 },

                { type: 'battery',batteryMileage: batteryDetails.batteryVin.packMileage , batteryDate: batteryDetails.batteryVin.packMileageLud, staticInfo: '• ' + batteryDetails.translatedLabels.batteryStatus },

                {type: 'vinBin', binVindate: batteryDetails.batteryVin.binVinDateLnk , purchaseMode: batteryDetails.translatedLabels.purchaseStatus, staticInfo: '• ' + batteryDetails.translatedLabels.binVinContent1+'\n'+'• ' + batteryDetails.translatedLabels.binVinContent2 },
            ];

            if (!vm.batteryCheck) {
                firstTable.splice(0, 1);
            }

            
            var filteredData = firstTable.map(function (item) {
                var tableData = {};

                var firstColumnData = [];
                switch (item.type) {
                    case 'uid':
                        
                        firstColumnData.push(batteryDetails.translatedLabels.uid +':\n'+(item.uid ? item.uid : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.uidName+':\n' + (item.name ? item.name : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.uidStatus +':\n'+ (item.status ? item.status : '-'));
                        break;
                    case 'soh':
                        firstColumnData.push("SOH: \n" + (item.soh ? item.soh + '%' : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.sohDate +':\n'+ (item.sohLastUpdateDate ? item.sohLastUpdateDate  : '-'));
                        break;
                    case 'vehicle':
                        firstColumnData.push(batteryDetails.translatedLabels.vehicleMilage +':\n' + (item.vehMileage ? item.vehMileage : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.vehicleMilageDate +':\n' + (item.vehMileageDate ? item.vehMileageDate : '-'));
                        break;
                    case 'battery':
                        firstColumnData.push(batteryDetails.translatedLabels.batMileage +':\n' + (item.batteryMileage ? item.batteryMileage : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.batMilageDate +':\n' + (item.batteryDate ? item.batteryDate : '-'));
                        break;
                    case 'vinBin':
                        firstColumnData.push(batteryDetails.translatedLabels.binVinAssociateDate +':\n' + (item.binVindate ? item.binVindate : '-'));
                        firstColumnData.push(batteryDetails.translatedLabels.purchaseModeLabel +':\n' + (batteryDetails.translatedLabels.purchaseStatus));
                        break; 

                }

                tableData[''] = {
                    data: firstColumnData.join("\n\n"), 
                    alignment: "left",
                };

                var secondColumnData = [];
                secondColumnData.push(item.staticInfo);
                

                tableData['  '] = {
                    data: secondColumnData.join("\n\n"), 
                    alignment: "left",
                };

                return tableData;
            });

            var fifthObj = {};

            fifthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: [200, 200], headerRows: 0,showHeaders: false,  
            };
            dataArray.push(fifthObj);


            
            dataArray = PDFViewService.getProcessedDataArray(finalArr, dataArray, false, false, true, false);
            var headerDefinition = !vm.nissanUserURL ? {
                style: "header",
                columns: [
                    {},
                    {
                        image: pictoImage.RENAULT.value,
                        width: 50,
                    }
                ]
            } : '';
            var docDefinition = {

                info: {
                    title: 'BATTERY CERTIFICATE BLMS INFO'
                }, 
                header: headerDefinition,
                footer: {
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [10, 10, 0, 10],
                            width: 25,
                            bold: false
                        },

                    ]

                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 13
                    },
                    header:{
                        margin: [0, 10, 10, 20],
                    },
                    textStyle1: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 11, 
                        color: "#8f8f8f"
                    },
                    dateTextStyle:{
                        margin: [-231, 11, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    textStyle2: {
                        margin: [-231, 1, 0, 1],
                        bold: true,
                        alignment: "left",
                        fontSize: 9,
                    },
                    textStyle3:{
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 9,
                        color: "#8f8f8f"
                    },
                    infoListStyle: {
                        margin: [23, 0, 0, 0],
                         alignment: "left",
                        fontSize: 10,
                    },
                    titleStyle:{
                        fontSize: 12,
                        bold: true,
                        margin: [23, 20, 0, 20],
                        alignment: "center"
                     
                    },
                    textPlainStyle: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [10, 30, 0, 0],
                        border:[false,false,false,false],
                        fontSize: 25,
                        
                    },
                    tableIconStyle: {
                        margin: [0, 1.5, 0, 1.5],
                        alignment: "center"
                    },
                    secondTableHeader: {
                        margin: [0, 3, 0, 10],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    },
                    secondTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 3 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                        }
                    }
                }
               
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

        

      




    }
    })();

(function(){
    'use strict';

    angular
        .module('phenix')
        .config(trainingRouterConfig);

    /* @ngInject */
    function trainingRouterConfig($stateProvider, RoutesConstants){
        $stateProvider.state(RoutesConstants.training, {
            url: '/training',
            templateUrl: 'app/components/car/features/training/training.template.html',
            controller: 'TrainingController',
            controllerAs: 'vm'
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("TrainingController", TrainingController);

    /* @ngInject */
    function TrainingController(TrainingMetierService, UtilsMetierService, trainingConstants, toastr, $translate, blockUI) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.getTrainingOffer = getTrainingOffer;
        vm.openLink = openLink;
        vm.trainingOffers = [];
        vm.elucidatProjectList = [];
        vm.releaseLinks = [];
        vm.releasesListObject = {};
        vm.isReleaseEmpty = false;
        vm.techicalTraining = techicalTraining;
        vm.launchElucidat = launchElucidat;
        vm.getElucidatReleaseLinks = getElucidatReleaseLinks;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
            getTrainingOffer();
            if (!UtilsMetierService.isIndependentUser()) {
                getElucidatProjectList();
            }
        };

        /**
         * @desc This function is lunch at the init in order to call the TrainingMetierService to get a list of training offer.
         * The method matchTrainingbyUserCountry will ensure that the user country is concerned by an offer.
         */
        function getTrainingOffer() {

            TrainingMetierService.calltrainingOffersService()
            .then(function(response){
                vm.trainingOffers =  TrainingMetierService.matchTrainingbyUserCountry(response.trainingOffers);
            })
            .catch(function(error) {
                toastr.error($translate.instant('ERROR'));
                console.log("error: ", error);
            });
        }

        function openLink(url){

            window.open(url);
        }
        function techicalTraining(){
            window.open(trainingConstants.techicalTraining);
        }
        function getElucidatProjectList() {
            blockUI.start();
            TrainingMetierService.getProjectList().then(function (response) {
                if (response && response.data && _.isArray(response.data)) {
                    vm.elucidatProjectList = response.data;
                    if (!_.isEmpty(vm.elucidatProjectList)) {
                        _.map(vm.elucidatProjectList, function (item) {
                            _.extend(item, { isReleaseLink: false });
                        })
                    }
                }
            }).catch(function (error) {

            }).finally(function () {
                blockUI.stop();
            });
        }
        function getElucidatReleaseLinks(projectCode,isReleaseLink) {  
            if (isReleaseLink) {
                _.find(vm.elucidatProjectList, function (item) {
                    if (item.project_code == projectCode) {
                        item.isReleaseLink = false;
                    }
                })
                vm.releaseLinks = [];
            } else {
                var releases = [];
                if (!_.isEmpty(vm.releasesListObject)) {
                    for (let key in vm.releasesListObject) {
                        if (key == projectCode) {
                            releases = vm.releasesListObject[key];
                        }
                    }
                }
                if (_.isEmpty(releases)) {
                    blockUI.start();
                    TrainingMetierService.getReleaseLinks(projectCode).then(function (response) {                       
                        if (response && response.data && _.isArray(response.data)) {
                            vm.releaseLinks = response.data;
                            if (!_.isEmpty(vm.releaseLinks)) {
                                vm.isReleaseEmpty = false;
                                vm.releasesListObject[projectCode] = vm.releaseLinks;
                                _.find(vm.elucidatProjectList, function (item) {
                                    if (item.project_code == projectCode) {
                                        item.isReleaseLink = true;
                                    }
                                })
                            } else {
                                vm.isReleaseEmpty = true;
                                _.find(vm.elucidatProjectList, function (item) {
                                    if (item.project_code == projectCode) {
                                        item.isReleaseLink = true;
                                    }
                                })
                            }
                        }
                    }).catch(function (error) {

                    }).finally(function () {
                        blockUI.stop();
                    });
                } else {
                    vm.isReleaseEmpty = false;
                    vm.releaseLinks = releases;
                    _.find(vm.elucidatProjectList, function (item) {
                        if (item.project_code == projectCode) {
                            item.isReleaseLink = true;
                        }
                    })
                }
               if (!_.isEmpty(vm.elucidatProjectList)) {
                   for (var project in vm.elucidatProjectList) {
                       if (vm.elucidatProjectList[project].project_code != projectCode) {
                           vm.elucidatProjectList[project].isReleaseLink = false;
                        }
                    }
                }
            }
        }

        function launchElucidat(code) {
            blockUI.start();
            TrainingMetierService.getElucidatLaunchLink(code).then(function (response) {
                if (response && response.data && response.data.url) {
                    window.open(response.data.url);
                }
            }).catch(function (error) {

            }).finally(function () {
                blockUI.stop();
            });
        }
        /*=============================================
        =                 TOOLS                       =
        =============================================*/


    }
})();

'use strict';

angular
    .module('phenix').constant('trainingConstants', {
        trainingOfferService: 'proxy/apidh/rest/v1/trainingOffer',
        techicalTraining:'https://learning.elucidat.com/course/62333b9f407cb-62334c0d25b00',
        countries : ["AT","BE","LU","DE","HU","IT","NL","NO","PL","SK","CH","EE","LV","LT","DZ","MA","DK","SE","ES","IL","LB","ZA","NA","TN","GP","GF","MQ","RE","PF","AU","HK","JP","NC","NZ","BG","RO","TR","HR","CY","FI","GR","IS","IE","MT","PT","SI","GB","RS"],
        elucidatConnectionURL: './elucidatConnect.php'
    });

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
      $stateProvider.state(RoutesConstants.specialTools, {
          url: '/listComponents',
          templateUrl: 'app/components/car/features/specialTools/specialTools.template.html',
          controller: 'specialToolsController',
          controllerAs: 'vm'
        });
    }
  })();
  
(function () {
    'use strict';

    angular.module('phenix')
        .component('specialTools', {
            controller: specialToolsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/features/specialTools/specialTools.template.html'
        }).controller('specialToolsController', specialToolsController)
        .directive('focusToInput', function () {
            return {
                restrict: 'A',
                require: ['^mdSelect'],
                link: function (scope, element) {
                    var currentElement = element
                    scope.$watch(function () {
                        while (!currentElement.hasClass('md-select-menu-container')) {
                            currentElement = currentElement.parent();
                        }
                        return currentElement.hasClass('md-active');
                    }, function (selected) {
                        if (selected)
                            element.focus();
                    })
                }
            }
        });

    function specialToolsController(
            blockUI,
            toastr,
            $translate,
            CacheService,
            $rootScope,
            $q,
            CarSearchMetierService,
            ResultSearchByDiagnosticMetierService,
            btListMetierService
            ) {
            var vm = this;
            vm.globalSearch = {
                vehicle_family : "",
                engine_type : "",
                gearbox_type : "",
                battery_type : ""
            }
            vm.selectedCategory = "";
            vm.searchText = "";
            vm.specialToolsList = [];
            vm.userContext = CacheService.getUserContext();

            init();
            vm.btListFixedCriterias = ResultSearchByDiagnosticMetierService.getBtListFixedCriterias();

            vm.removeDuplicatesFromArray = removeDuplicatesFromArray;
            vm.resetSelectedFields = resetSelectedFields;
            vm.divSelected = divSelected;
            vm.mapFieldsToSearch = mapFieldsToSearch;
            vm.specialToolsSearchAdvanced = specialToolsSearchAdvanced;
            vm.reset = reset;
            vm.clearCategories = clearCategories;
            vm.scrollTop = scrollTop;
            vm.optionSelect = optionSelect;
            

            function init() {
                vm.isSpecialToolsDocz = true;
                var firstRowFields = [
                    {
                        key: 'vehicle_family',
                        code: '007',
                        defaultOption: 'VEHICLE_FAMILY',
                        required: true,
                    },
                    {
                        key: 'engine_type',
                        code: '999',
                        defaultOption: 'ENGINE_TYPE',
                        required: true,
                    },
                    {
                        key: 'gearbox_type',
                        code: '997',
                        defaultOption: 'GEARBOX_TYPE',
                        required: true,
                    },
                    {
                        key: 'battery_type',
                        code: '968',
                        defaultOption: 'BATTERY_TYPE',
                        required: true
                    }
                ];
    
                vm.selectFields = firstRowFields;
                blockUI.start();
                CarSearchMetierService.getTapvmbFilterList().then(function (response){
                    vm.selectFields = btListMetierService.buildFields2(firstRowFields, response);
                }).then(function(){
                    CarSearchMetierService.getBrandModelList().then(function(response){
                        vm.vehicleFamilyResponse = response;
                        vm.selectFields = btListMetierService.buildVehFamilyAndType(response,vm.selectFields);
                    }).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                    }).finally(function () {
                        blockUI.stop();
                    })
                }).catch(function () {
                    toastr.error($translate.instant('ERROR'));
                }).finally(function () {
                    blockUI.stop();
                }); 
                vm.specialToolsList = [
                    {id:'0', subType:$translate.instant('SPECIALIZED_TOOL_MENU_ALL_SUBTYPES')},
                    {id:'BAT', subType:$translate.instant('SPECIALIZED_TOOL_MENU_TRACTION_BATTERY')},
                    {id:'BVI', subType:$translate.instant('SPECIALIZED_TOOL_MENU_GEARBOX')},
                    {id:'CAR', subType:$translate.instant('SPECIALIZED_TOOL_MENU_CAR_BODY')},
                    {id:'DIR', subType:$translate.instant('SPECIALIZED_TOOL_MENU_STEERING')},
                    {id:'ELE', subType:$translate.instant('SPECIALIZED_TOOL_MENU_POWER_SUPPLY')},
                    {id:'EMB', subType:$translate.instant('SPECIALIZED_TOOL_MENU_CLUTCH')},
                    {id:'FRE', subType:$translate.instant('SPECIALIZED_TOOL_MENU_BRAKE')},
                    {id:'MOT', subType:$translate.instant('SPECIALIZED_TOOL_MENU_ENGINE')},
                    {id:'MS', subType:$translate.instant('SPECIALIZED_TOOL_MENU_SPECIALIZED_EQUIPMENT')},
                    {id:'ROU', subType:$translate.instant('SPECIALIZED_TOOL_MENU_WHEELS_AND_HUBS')},
                    {id:'SUS', subType:$translate.instant('SPECIALIZED_TOOL_MENU_SUSPENSION')},
                    {id:'TAR', subType:$translate.instant('SPECIALIZED_TOOL_MENU_REAR_END')},
                    {id:'TAV', subType:$translate.instant('SPECIALIZED_TOOL_MENU_FRONT_AXLE')}];
    
                    vm.specialToolsList.forEach(function (item) {
                        if(item.id == '0') {
                            item.label = item.subType;
                        }
                        else {
                            item.label = item.id + ' ' + item.subType;
                        }
                    });
            }
            function optionSelect(list, field){
                var payload={};
                var fixedCriterias = {
                    "familyCode": (field && field.defaultOption ==="VEHICLE_FAMILY") ? list : null || vm.globalSearch.vehicle_family ? vm.globalSearch.vehicle_family: null,
                    "engineType": (field && field.defaultOption ==="ENGINE_TYPE") ?  list: null || vm.globalSearch.engine_type ? vm.globalSearch.engine_type: null,
                    "batteryType":(field && field.defaultOption ==="BATTERY_TYPE") ?  list: null || vm.globalSearch.battery_type ? vm.globalSearch.battery_type: null,
                    "gearboxType":(field && field.defaultOption ==="GEARBOX_TYPE") ? list : null || vm.globalSearch.gearbox_type ? vm.globalSearch.gearbox_type: null,
                }
                var finalCriteriaList = filterEmptyFields(fixedCriterias);
                _.extend(payload,
                     {
                        criteria: finalCriteriaList,
                        specialTools: true 
                    }
                     )
               
                CarSearchMetierService.getTapvmbFilterList(payload).then(function (response){
                vm.selectFields = btListMetierService.buildFields2(vm.selectFields, response);
                 }).then(function(){
                    vm.selectFields = btListMetierService.buildVehFamilyAndType(vm.vehicleFamilyResponse,vm.selectFields);
                 })
            }
            function removeDuplicatesFromArray(arr) {
                return arr.filter(function (item, index) {
                    return arr.indexOf(item) >= index;
                });
            }
            function divSelected(key) {
                var elemSelected = document.getElementById(key);
                var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
                var topContainer;
    
                if (positionOfElem < 200 && (key == 'vehicle_family' || key == 'engine_type' || key == 'gearbox_type' || key == 'battery_type')) {
                    topContainer = positionOfElem + 42 + "px";
                } 
                else if (positionOfElem < 200 && vm.selectedCategory) {
                    topContainer = positionOfElem - 53 + "px";
                }
                else {
                    topContainer = positionOfElem + 28 + "px";
                }
                setTimeout(function () {
                    $(".my-container").css({ 'top': topContainer });
                }, 100);
            };
            function mapFieldsToSearch(key, value) {
                vm.globalSearch[key] = value;
            }    
            function resetSelectedFields(key, value) {
                vm.globalSearch[key] = "";
                vm.selectFields.map(function (item) {
                    if (item.key === key) {
                        item.value = "";
                    }
                })
                optionSelect();
            }
            function filterEmptyFields(criterias) {
                for (var check in criterias) {
                    if (criterias[check] == null || criterias[check] == undefined || criterias[check] == '') {
                        delete criterias[check];
                    }
                }
                return criterias;
            }
            function specialToolsSearchAdvanced() {
                $rootScope.stListSearched = vm.displayed;
                vm.displayed = null;
                vm.newDocType = {"SPECIALTOOLS":{"subType":["BAT","BVI","CAR","DIR","ELE","EMB","FRE","MOT","MS","ROU","SUS","TAR","TAV"]}};

                if (vm.searchText && (vm.searchText.length < 3 || vm.searchText.length > 13)) {
                    return toastr.error($translate.instant('INVALID_SEARCH'));
                }

                var fixedCriterias = {
                    "007": vm.globalSearch.vehicle_family.toUpperCase(),
                    "968": vm.globalSearch.battery_type.toUpperCase(),
                    "997": vm.globalSearch.gearbox_type.toUpperCase(),
                    "999": vm.globalSearch.engine_type.toUpperCase()
                }
                vm.carContext = {
                    "fixedCriterias": filterEmptyFields(fixedCriterias)
                }
                var advancedFilteredPayload = {
                    userContext: vm.userContext,
                    carContext: vm.carContext,
                    docType: vm.newDocType
                };

                var isNumber = /^[0-9\s]*$/.test(vm.searchText);
                // var isNumber = /^[0-9]+$/.test(vm.searchText);
                if(vm.searchText != null && isNumber) {
                    if(advancedFilteredPayload.docType.SPECIALTOOLS.identifier){
                        delete advancedFilteredPayload.docType.SPECIALTOOLS['identifier'];
                    }
                    vm.searchText ? (_.extend(advancedFilteredPayload.docType.SPECIALTOOLS, {reference: replaceSearchText()})) : "";
                }
                else if(vm.searchText != null && !isNumber){
                    if(advancedFilteredPayload.docType.SPECIALTOOLS.reference){
                        delete advancedFilteredPayload.docType.SPECIALTOOLS['reference'];
                    }
                    vm.searchText ? (_.extend(advancedFilteredPayload.docType.SPECIALTOOLS, {identifier: replaceSearchText()})) : "";
                }
                vm.searchText = replaceSearchText();
               $rootScope.$broadcast('advancedFilteredPayload', advancedFilteredPayload);            
            }
            function replaceSearchText(){
                if(vm.searchText)
                    vm.searchText = vm.searchText.replace(/(\d{2})(\d{2})(\d{3})(\d{3})/,"$1 $2 $3 $4");
                return vm.searchText;
            }
            function reset() {
                vm.globalSearch = {
                    vehicle_family : "",
                    engine_type : "",
                    gearbox_type : "",
                    battery_type : ""
                }
                vm.searchText = "";
                vm.selectedCategory = "";
                $rootScope.$broadcast('resetSTData', vm.globalSearch, vm.selectedCategory, vm.searchText);
                $rootScope.stListSearched = vm.displayed;
                vm.displayed = null;
                vm.selectFields.forEach(function(item){
                    item.value = null;
                });
                optionSelect();
            }
            function clearCategories(selectedItem){
                if(selectedItem && !vm.globalSearch.vehicle_family && !vm.globalSearch.engine_type && !vm.globalSearch.gearbox_type && !vm.globalSearch.battery_type){
                    if(selectedItem === vm.selectedCategory){
                        if(!vm.searchText){
                            vm.selectedCategory = null;
                            $rootScope.$broadcast('resetSTData', vm.globalSearch, vm.selectedCategory, vm.searchText);
                        }
                        else {
                            vm.selectedCategory = null;
                        }
                    }
                    else if(selectedItem === vm.searchText){
                        if(!vm.selectedCategory){
                            vm.searchText = null;
                            $rootScope.$broadcast('resetSTData', vm.globalSearch, vm.selectedCategory, vm.searchText);
                        }
                        else {
                            vm.searchText = null;
                        }
                    }
                   
                }
                else {
                    if(selectedItem === vm.selectedCategory){
                        vm.selectedCategory = null;
                        $rootScope.$broadcast('resetSTData', vm.globalSearch, vm.selectedCategory, vm.searchText);
                    } 
                    if(selectedItem === vm.searchText){
                        vm.searchText = null;
                        $rootScope.$broadcast('resetSTData', vm.globalSearch, vm.selectedCategory, vm.searchText);
                    }
                }
            }
            function scrollTop() {
                if ($('#specialToolsDocz').offset()) {
                    $('html, body').animate({ scrollTop: $('#specialToolsDocz').offset().top }, 300);
                }
            }
            
        }
    })();
(function(){
    'use strict';

    angular
        .module('phenix')
        .config(renaultTechRouterConfig);

    /* @ngInject */
    function renaultTechRouterConfig($stateProvider, RoutesConstants){
        $stateProvider.state(RoutesConstants.qstomize, {
            url: '/qstomize',
            templateUrl: 'app/components/car/features/renaultTech/renaultTech.template.html',
            controller: 'RenaultTechController',
            controllerAs: 'vm',
            params: {
                docType: null
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("RenaultTechController", RenaultTechController);

    /* @ngInject */
    function RenaultTechController(RenaultTechMetierService,$rootScope,$state,$translate,renaultTechConstants,UtilsMetierService) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.profile = UtilsMetierService.getProfile();
        vm.getRenaultTechDocumentation = getRenaultTechDocumentation;
        vm.downloadZip = downloadZip;
        vm.docType = '';
        vm.docHeader = '';
        vm.afterSalesContactsupportUrl = renaultTechConstants.apvUrl;
        vm.gpCatLink = gpCatLink;
        vm.gpCatPilote = renaultTechConstants.gpCatUrl;
        vm.spaceNomadeLink = renaultTechConstants.spaceNomadeUrl;
        vm.displayLink = false;
        

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
            if ($state.params && $state.params.docType){
                vm.docType =  $state.params.docType;
            }
           getRenaultTechDocumentation();
           gpCatLink()
        };

        function getRenaultTechDocumentation() {
            var docList =[];
            RenaultTechMetierService.callTransformedProductsService()
                .then(function(response) {
                    if (vm.docType == "QSTOMIZE_"){
                        vm.docHeader = $translate.instant("COMMON_QSTOMIZE_DOC");
                        for(var i=0; i< response.transformedProducts.length; i++){
                            if (response.transformedProducts[i].productName.includes("QSTOMIZE_",0)){
                                docList.push({
                                    productName :response.transformedProducts[i].productName.substr(9),
                                    contentUrl :response.transformedProducts[i].contentUrl });
                            }
                        }
                    }
                    else if (vm.docType == "MICRO_"){
                        vm.docHeader = $translate.instant("COMMON_RENAULT_MICRO-MOBILITY");
                        for(var i=0; i< response.transformedProducts.length; i++){
                            if (response.transformedProducts[i].productName.includes("MICRO_",0)){
                                docList.push({
                                    productName :response.transformedProducts[i].productName.substr(6),
                                    contentUrl :response.transformedProducts[i].contentUrl });
                            }
                        }
                    }
                    else if (vm.docType == "MOBILIZE_"){
                        vm.docHeader = $translate.instant("COMMON_RENAULT_MOBILIZE");
                        for(var i=0; i< response.transformedProducts.length; i++){
                            if (response.transformedProducts[i].productName.includes("MOBILIZE_",0)){
                                docList.push({
                                    productName :response.transformedProducts[i].productName.substr(9),
                                    contentUrl :response.transformedProducts[i].contentUrl });
                            }
                        }
                    }
                    else if (vm.docType == ""){
                        vm.docHeader = $translate.instant("COMMON_RENAULT_CONVERTED_PRODUCTS");
                        for(var i=0; i< response.transformedProducts.length; i++){
                            if (!response.transformedProducts[i].productName.includes("MICRO_",0) && !response.transformedProducts[i].productName.includes("QSTOMIZE_",0)&& !response.transformedProducts[i].productName.includes("MOBILIZE_",0)
                            && !response.transformedProducts[i].productName.includes("RTECH_",0)){
                                docList.push(response.transformedProducts[i]);
                            }
                        }
                    }
                    vm.transformedProducts = docList;
                })
                .catch(function(error) {
                    console.log("error: ", error);
                });
        }

        function gpCatLink(){
            if(renaultTechConstants.countryList.includes(vm.profile.country)){
                vm.displayLink = true;
            } else{
                vm.displayLink = false;
            }
        }
        function downloadZip(link){
            window.open(link);
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/
               
    }
})();

'use strict';

angular
    .module('phenix').constant('renaultTechConstants',{
        transformedProducts: 'proxy/apidh/rest/v1/transformedProducts',
        apvUrl: "https://newdialogys.renault.com/",
        countryList:['FR', 'DE', 'BE', 'CH', 'AT', 'DK'],
        gpCatUrl: "http://parts.pilote.fr/accueil.php",
        spaceNomadeUrl: "https://sway.office.com/q0gusdk6XcBfdstD?ref=Link"
    });             

(function(){
    'use strict';

    angular
        .module('phenix')
        .config(sdpRouterConfig);

    /* @ngInject */
    function sdpRouterConfig($stateProvider, RoutesConstants){
        $stateProvider.state(RoutesConstants.sdp, {
            url: '/sdp',
            templateUrl: 'app/components/car/features/sdp/sdpDocuments.template.html',
            controller: 'SdpDocumentsController',
            controllerAs: 'vm'
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("SdpDocumentsController", SdpDocumentsController);

    /* @ngInject */
    function SdpDocumentsController(configConstantes,RestUpgrade,CacheService,CacheConstants,FeaturesConstants,$translate,UtilsMetierService,blockUI
        ,$log,DocumentsWsService) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.getSdpDocuments=getSdpDocuments;
        vm.user = CacheService.getObject(CacheConstants.profil);
        vm.sdpDocumentsUrl = configConstantes.ndHelpUrl +'/otherTools.json';
        vm.sdpList = [];
        vm.openLink = openLink;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
          getSdpDocuments();         
        };
        function getSdpDocuments() {
            blockUI.start();
            var profile = UtilsMetierService.getProfile();
            DocumentsWsService.getSVG2(vm.sdpDocumentsUrl).then(function (response) {
                if (response && response.otherTools) {                    
                    var responseData = response.otherTools;
                    var langcode=profile.language;
                    var data = [];
                    for(let i=0;i<responseData.length;i++){                        
                        if(responseData[i].language == langcode.toUpperCase()) {
                            responseData[i].document = configConstantes.ndHelpUrl + responseData[i].document;
                            data.push(responseData[i]);
                        }
                    }
                    if(data.length == 0){
                       data =  _.filter(responseData, function(offer) {
                                if( offer.language == 'EN' ){
                                    offer.document = configConstantes.ndHelpUrl + offer.document;
                                    return offer;
                                }
                        });
                    }
                    vm.sdpList = data;                                      
                }  
            }).catch(function() {
                $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        function openLink(link){
            window.open(link)
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('phenix')
        .config(releasesRouterConfig);

    /* @ngInject */
    function releasesRouterConfig($stateProvider, RoutesConstants){
        $stateProvider.state(RoutesConstants.releases, {
            url: '/releases',
            templateUrl: 'app/components/car/features/releases/releases.template.html',
            controller: 'ReleasesController',
            controllerAs: 'vm',
            params: {
                docType: null
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("ReleasesController", ReleasesController);

    /* @ngInject */
    function ReleasesController(configConstantes,$sce,blockUI,toastr,$translate,CacheService,CacheConstants,FeaturesConstants,RestUpgrade,DocumentsWsService) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.releaseExpanded=releaseExpanded;
        vm.getReleasesContent=getReleasesContent;
        vm.openReleaseFile=openReleaseFile;
        vm.parseS3ReleaseContent=parseS3ReleaseContent;
        vm.user = CacheService.getObject(CacheConstants.profil);
        vm.ndS3ReleasesUrl = configConstantes.ndHelpUrl +'/newReleases/';


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
           
          parseS3ReleaseContent();         
        };
      function parseS3ReleaseContent() {
        blockUI.start();

        getReleasesContent().then(function (response) {
          if (response) {
            vm.releasesContent = response;
            if (vm.releasesContent && vm.releasesContent.releases.latestReleases.length >=8) {
              var releases = vm.releasesContent.releases.latestReleases.slice(0, 12);
              releases.forEach(function(item){
              item.url = vm.ndS3ReleasesUrl + item.url;
              })
              vm.releases = releases;
            }
            else {
              var releases = vm.releasesContent.releases.latestReleases;
              releases.forEach(function(item){
                item.url = vm.ndS3ReleasesUrl + item.url;
              })
              vm.releases = releases;
            }
            blockUI.stop();

          }
        }
        ).catch(function () {
          toastr.error($translate.instant('ERROR'));
          blockUI.stop();

        }).finally(function () {
          blockUI.stop();

        });

      }
        function getReleasesContent(){
          var lang=vm.user.language;
          var s3Url = '';
          if (FeaturesConstants.langList.includes(lang)){
             s3Url=vm.ndS3ReleasesUrl+lang+FeaturesConstants.newreleases+lang.toUpperCase()+FeaturesConstants.json;
          }
          else{
            s3Url=vm.ndS3ReleasesUrl+FeaturesConstants.defaultLangFile;
          }
          return DocumentsWsService.getSVG2(s3Url);
        }
      
      function openReleaseFile(link) {
        window.open(link);
      }
      function releaseExpanded(month) {
        var selectedMonth = month.monthHeader;
        vm.releases.map(function (item) {
          if (selectedMonth === item.monthHeader) {
            item.defaultEnable = !item.defaultEnable;
          }
        })
      }    
       
    }
})();

(function(){
    'use strict';

    angular
        .module('phenix')
        .config(oldRangeDocumentsRouterConfig);

    /* @ngInject */
    function oldRangeDocumentsRouterConfig($stateProvider, RoutesConstants){
        $stateProvider.state(RoutesConstants.oldRangeDocuments, {
            url: '/oldRangeDocuments',
            templateUrl: 'app/components/car/features/oldRangeDocuments/oldRangeDocuments.template.html',
            controller: 'OldRangeDocumentsController',
            controllerAs: 'vm'
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("OldRangeDocumentsController", OldRangeDocumentsController);

    /* @ngInject */
    function OldRangeDocumentsController(OldRangeDocumentsMetierService,$rootScope) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.getOldRangeDocumentation = getOldRangeDocumentation;
        vm.downloadZip = downloadZip;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
           getOldRangeDocumentation();
        };

        function getOldRangeDocumentation() {
            OldRangeDocumentsMetierService.getOldRangeDocumentation()
                .then(function(response) {
                    vm.oldModelDocuments = response;
                })
                .catch(function(error) {
                    console.log("error: ", error);
                });
        }

        function downloadZip(link){
            window.open(link);
        }
        /*=============================================
        =                 TOOLS                       =
        =============================================*/
    }
})();

'use strict';

angular
    .module('phenix').constant('oldRangeDocumentsConstants',{
        OldRangeDocuments: 'proxy/apidh/rest/v1/oldModelDocuments'
    });

(function () {
  'use strict';

  angular
    .module('phenix')
    .directive('listIntervention', listIntervention)
    .controller('listInterventionController', listInterventionController);

  function listIntervention($mdDialog) {
    var directive = {
      restrict: 'E',
      scope: {
        listData: '=',
        isModal: '=',
        intTitle: '=',
        nodeId: '='
      },
      templateUrl: 'app/components/car/carSearchResult/easyBasket/listIntervention.template.html',
      controllerAs: 'vm',
      controller: listInterventionController,
      bindToController: true,
    }
    return directive;

  }

  function listInterventionController(blockUI, SearchArboTextualMetierService,
    $mdDialog, ShoppingCartService, MainMetierService, CacheService, QuoteMetierService,
    $q, listOfDraftModalService, globalConstant, $translate, toastr, UtilsMetierService,
    DealerManagerSystemeService, DmsMetierService, $rootScope, DocumentsMetierService,
    ListPieceConstants, RoutingService, RoutesConstants, $log,$state,CacheConstants,
    RecapCarMetierService,listInterventionConstant, $timeout,$scope, AlertsService,
    mrDocumentsMetierService,$window,configConstantes, ShoppingCartServiceConstant) {

    var vm = this;

    var _essai = ShoppingCartServiceConstant.essai;
    var _testTime = ShoppingCartServiceConstant.testTime;
    // essay type without opecod: the test bench TM has to be added manually by the user
    var _essayTestBench = '3';

    vm.interventionList = [];
    vm.interventionDetails = {};
    vm.initialInterventionDetails = {};
    vm.essayTmLine = null;
    vm.isArcaUser = MainMetierService.isArcaUser();
    vm.isDmsProfile = CacheService.getObject('dms');
    vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
    vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();
    vm.isUserDms = DealerManagerSystemeService.getHookResult();
    vm.isCountrySparc = UtilsMetierService.isUserFromSparcCountry();
    vm.isDisplayBrandButtons = false;
    vm.brandButtonArray = [];
    vm.isHorseUser = MainMetierService.isHorseUser();
    vm.isCountryChina = UtilsMetierService.isCountryTargeted('CN');
    vm.isCountryIndia = UtilsMetierService.isCountryTargeted('IN');
    vm.isCountrySparc  = UtilsMetierService.isUserFromSparcCountry();
    var cacheProfile = CacheService.getObject(CacheConstants.profil);
    vm.frCountry= cacheProfile ? cacheProfile.country : null;
    vm.isInterventionAccess = UtilsMetierService.isInterventionAccess();
    vm.isShowIcon = cacheProfile.userType == 'RNET' && vm.isInterventionAccess;
    
    vm.showDetail = showDetail;
    vm.calculateFod = calculateFod;
    vm.updateFromInput = updateFromInput;
    vm.goToBasket = goToBasket;
    vm.goToQuote = goToQuote;
    vm.handleFirstAdd = handleFirstAdd;
    vm.handleBulkAdd = handleBulkAdd;
    vm.disableSwitch = disableSwitch;
    vm.bulkBasketDelete = bulkBasketDelete;
    vm.changeTMtoggle = changeTMtoggle;
    vm.goToProduct = goToProduct;
    vm.goToProductPage = goToProductPage;
    vm.getImageUrl = getImageUrl;
    vm.getStyle = getStyle;
    vm.selectCsv = selectCsv;
    vm.alterSwitchEnable = alterSwitchEnable;
    vm.isStandardExchange =isStandardExchange;
    vm.isTractionBattery = isTractionBattery;
    vm.selectBrandParts = selectBrandParts;
    vm.additionalSwitchEnable = additionalSwitchEnable;
    vm.getPriceToDisplay = getPriceToDisplay;
    vm.getCurrencyForItem = getCurrencyForItem;
    vm.checkCatalogPlateId = checkCatalogPlateId;
    vm.gotoCatalogPlate = gotoCatalogPlate;
    vm.openAlertsPopin = openAlertsPopin;
    vm.close = close;
    vm.onOk = onOk;
    vm.gotoMrLink = gotoMrLink;
    vm.isCatalogPlateAllowedForHorse = isCatalogPlateAllowedForHorse;
    vm.goToProductNewPage = goToProductNewPage;
    vm.copyToClipboard = copyToClipboard;
    vm.availableCount = 0;
    vm.unavailableCount = 0;
    vm.availableIconClick = availableIconClick;
    vm.unavailableIconClick = unavailableIconClick;
    vm.activeButton = null;
    vm.partTemp = [];
    vm.getItemCount = 0;
    vm.getQuoteCount = 0;
    vm.quote = {};
    vm.quotePopinTitle;
    vm.quotePopinSubtitle;
    vm.flattenCart = [];
    vm.cartMetadata = {};
    this.$onInit = function () {
      var selectedInterventionId = CacheService.getObject(CacheConstants.selectedInterventionId);
      vm.interventionList = vm.listData ? vm.listData.INT : [];
      _.map(vm.interventionList, function (item) {
        _.assign(item, { showBasketDetails: false, showCsvFile: false })
      })
      $rootScope.interventionListData = vm.interventionList;
      $(window).on('click', function (e) {

        if (!e.target.matches('.clickItem')) {

          var dropdowns = document.getElementsByClassName("interventionDropdown-content");
          var i;
          for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains("show")) {
              openDropdown.classList.remove('show');
              _.map($rootScope.interventionListData, function (item) {
                if (item.designation === $rootScope.selectedItemDetailsNew[5]) {
                  item.showCsvFile = false;
                  item.showPrCsvFile = false;
                }
              })
            }
          }
        }
      });
      
      if(selectedInterventionId){
        showDetail(selectedInterventionId, false);
      }
      vm.screenshotButtonVisibility = AlertsService.getScreenshotButtonVisibility();
      vm.captureScreenshot = captureScreenshot;
    }
    $rootScope.$on('loadIntervention', function (event, data) {
      if (data) {
        vm.bulkQuoteAdditionDone = data
        angular.forEach(vm.interventionList, function (list) {
          angular.forEach(vm.interventionDetails.INT, function (item) {
            if (list.id === item.id) {
              list.bulkQuoteAdditionDone = true;
            }
          })
        })
        disableSwitch(vm.interventionDetails,true);
      }
    });
    $rootScope.$on('quoteCount', function (event, data) {
      if (data) {
        var calPrCount = 0;
        var calTmCount = 0;

        var quote = QuoteMetierService.getQuoteData();
        vm.quote.items = quote ? quote.shoppingCart : null;
        if (vm.quote && vm.quote.items && vm.quote.items.PR) {
          calPrCount = _.filter(vm.quote.items.PR, function (item) {
            return item.quantity != 0;
          }).length;
        }
        if (vm.quote && vm.quote.items && vm.quote.items.TM) {
          calTmCount = _.filter(vm.quote.items.TM, function (item) {
            return item.quantity != 0;
          }).length;
        }
    vm.getQuoteCount = calPrCount + calTmCount;
        vm.quotePopinTitle = quote.number;
        vm.quotePopinSubtitle = "";
        if (quote.vin) {
          vm.quotePopinSubtitle += quote.vin;
        }

        if (quote.registrationNumber) {
          vm.quotePopinSubtitle += " | " + quote.registrationNumber;
        }
      }
    });
    function isStandardExchange(types){
      return _.includes(types,ListPieceConstants.types.standardExchange);
    }

    function isTractionBattery(familyCode){
      return familyCode === ListPieceConstants.tractionBatteryFamilyCode;
    }
     
    function getPriceToDisplay(part){
      var price = UtilsMetierService.getPriceToDisplay(
        part.priceExclTaxes, !part.dmsInformations ? null : part.dmsInformations.priceExclTaxes);
        return price;
    }
    function getCurrencyForItem(part) {
      if (part && part.dmsInformations && part.dmsInformations.isKnowFromDms) {
          return UtilsMetierService.getCurrencyForItem(part.dmsInformations.isKnowFromDms)
      } else {
          return UtilsMetierService.getCurrencyForItem()
      }
  }

    function showDetail(selectedItem, isClicked) {
      if (selectedItem.showBasketDetails) {
        if(isClicked){
          var selectedInterventionId = selectedItem;
          CacheService.setObject(CacheConstants.selectedInterventionId, selectedInterventionId);
        }
        vm.interventionList = _.map(vm.interventionList, function (item) {
          if (item.id === selectedItem.id) {
            _.assign(item, { showBasketDetails: true, showCsvFile:false, showPrCsvFile: false })
          } else {
            _.assign(item, { showBasketDetails: false })
          }
          return item;
        })
        blockUI.start();
        vm.isDisplayBrandButtons = false;
        vm.brandButtonArray = [];
        vm.essayTmLine = null;
        var partsArray = [];
        vm.atLeastOnePR = false;
        vm.atLeastOneTM = false;
        SearchArboTextualMetierService.getBasketByInterventionId(selectedItem).then(function (response) {
          if(response && !_.isEmpty(response.INT) && response.INT[0]){
            for (var i in response.INT[0].basketContent) {
              if(i == 'partsItems' || i == 'labourTimeItems'){
                response.INT[0].basketContent[i].forEach(function(item){
                  if(i == 'partsItems' && item.parts.length > 0){
                    vm.atLeastOnePR = true;
                    item.parts.forEach(function(list){
                      if(list.additional != null && list.additional.length > 0){
                        _.assign(list, {showAddPart : true});
                      }
                    })
                  }
                  if(i == 'partsItems' && item.parts){
                    if(item.parts.length > 1 && item.parts.length == 2){
                      item.parts.forEach(function(ref){
                        if(ref.types.includes(ListPieceConstants.types.standardExchange)){
                          _.assign(item, { containsStdExcPart: true});
                        }
                      });
                    }
                  }
                  if(i == 'labourTimeItems' && item.labourTimes.length > 0){
                    vm.atLeastOneTM = true;
                  }
                  _.assign(item,{'itemGroupLabel':parseInt(item.itemGroup)})                
                })
                response.INT[0].basketContent[i] = _.sortBy(response.INT[0].basketContent[i],'itemGroupLabel')
              }
              response.INT[0].basketContent.partsItems.forEach( function(ref){
                ref.parts.forEach( function(partsItems){
                  if(partsItems.priceExclTaxes == null && !partsItems.types.includes(ListPieceConstants.types.standardExchange) && partsItems.types.length > 0){
                    ref.parts.splice(partsItems);
                  }
                })
              })            
            }
            var objOrder = {'partsItems': null, 'labourTimeItems': null,  'parts': null, 'ingredients': null, 'labourTimes': null };
            if (response && !_.isEmpty(response.INT)) {
              angular.forEach(vm.interventionList, function (list) {
                _.map(response.INT, function (item) {
                  if (list.id === item.id) {
                    item.designation = list.designation;
                  }
                })
              })
              response.INT[0].basketContent = Object.assign(objOrder, response.INT[0].basketContent);
              if (!_.isEmpty(response.INT[0].basketContent.labourTimeItems)) {
                vm.largestGovalue = [];
                response.INT[0].basketContent.labourTimeItems.forEach(function (list) {
                  if(list.labourTimes && list.labourTimes.length > 0){
                    list.labourTimes.forEach(function (item){
                      _.assign(item, { itemGroup: list.itemGroup, quantity: 1, defaultQuantity: 1, type: "TM", hideTM: true, toggleTM: false, infoIcon: false })                                 
                    })  
                    if (list.labourTimes && list.labourTimes.length == 1) {
                      if (list.labourTimes[0].operationType == "2") {
                        list.labourTimes[0].hideTM = false;
                        list.labourTimes[0].toggleTM = true;
                      }
                    }
                    list.labourTimes = performTmOperation(list.labourTimes)
                    if (list.labourTimes && list.labourTimes.length > 1) {
                      var iconDisplay = _.filter(list.labourTimes, ['infoitem', true])
                      if (iconDisplay && !_.isEmpty(iconDisplay)) {
                        list.labourTimes.forEach(function (item, index) {
                          if (index == 0) {
                            item.infoitem = true;
                          } else {
                            item.infoitem = false;
                          }
                        })

                      }
                    }
                    list.labourTimes.forEach(function (tm) {
                      var goListNew = _.filter(tm.value, ['operationType', "1"]);
                      vm.largestGovalue = vm.largestGovalue.concat(goListNew);
                    })
                  }

                })
                if (!_.isEmpty(vm.largestGovalue)) {
                  var mainGo = vm.largestGovalue.reduce(function (prev, current) {
                    return (prev.duration > current.duration) ? prev : current
                  })
                }
                response.INT[0].basketContent.labourTimeItems.forEach(function (item) {
                  if (!_.isEmpty(mainGo) && item.itemGroup === mainGo.itemGroup) {
                    item.labourTimes.forEach(function (laborTime) {
                      if (laborTime.title === mainGo.title) {
                        var goValueCheck = _.filter(laborTime.value, ['operationType', "1"]);
                        if(goValueCheck.length == 1){
                          laborTime.value.forEach(function (valueList) {
                            if (valueList.technicalId === mainGo.technicalId && valueList.duration === mainGo.duration) {
                              valueList.hideTM = false;
                              valueList.toggleTM = true;
                              valueList.quantity = 1;
                            }
                          })

                        }
                      
                      }
                    })
                  }
                })
                response.INT[0].basketContent.labourTimeItems.forEach(function (items) {
                  if(items.labourTimes.length == 1){
                  items.labourTimes.forEach(function (laborTimes) {
                    var soData = _.filter(laborTimes.value, ['operationType', "2"]);
                    var goData = _.filter(laborTimes.value, ['operationType', "1"]);
                    if (soData && soData.length == 1 && goData && !_.isEmpty(goData)) {
                      var highestGoData = _.filter(goData, ['toggleTM', true]);
                      if (_.isEmpty(highestGoData)) {
                        laborTimes.value.forEach(function (item) {
                          soData.forEach(function (soValue) {
                            if (soValue.technicalId == item.technicalId && soValue.title == item.title) {
                              item.hideTM = false;
                              item.toggleTM = true;
                              item.quantity = 1;
                            }
                          })
                        })
                      }
                    }
                  })
                }
                else{
                  if(items.labourTimes.length > 1){
                    var tmToggledData =[];
                    items.labourTimes.forEach(function (laborTimes) {
                      var tmToggled = _.filter(laborTimes.value, ['toggleTM', true]); 
                      tmToggledData = tmToggledData.concat(tmToggled);  
                    })
                    if(tmToggledData && _.isEmpty(tmToggledData)){
                      items.labourTimes.forEach(function (laborTimes) {
                        var soData = _.filter(laborTimes.value, ['operationType', "2"]);
                        var goData = _.filter(laborTimes.value, ['operationType', "1"]);
                        if (soData && soData.length == 1 && goData && !_.isEmpty(goData)) {
                          var highestGoData = _.filter(goData, ['toggleTM', true]);
                          if (_.isEmpty(highestGoData)) {
                            laborTimes.value.forEach(function (item) {
                              soData.forEach(function (soValue) {
                                if (soValue.technicalId == item.technicalId && soValue.title == item.title) {
                                  item.hideTM = false;
                                  item.toggleTM = true;
                                  item.quantity = 1;
                                }
                              })
                            })
                          }
                        }
                      })
                    }
                  }
                }
                })
                
                response.INT[0].basketContent.labourTimeItems.forEach(function (items) {
                  items.labourTimes.forEach(function (laborTimes) {
                    var toggleSelected = _.filter(laborTimes.value, ['toggleTM', true]);
                   if(toggleSelected && !_.isEmpty(toggleSelected) && laborTimes.value && laborTimes.value.length  > 1){
                    laborTimes.infoitem = false;

                   }
                  })
                })
              }
              vm.initialInterventionDetails =  angular.copy(response);
              var filteredArray =[];
              if (!_.isEmpty(response.INT[0].basketContent.partsItems)) {
                var groupItemGroup = _.groupBy(response.INT[0].basketContent.partsItems, 'itemGroup');
                for (var i in groupItemGroup) {
                  if (groupItemGroup[i][0].parts.length > 1) {
                    groupItemGroup[i][0].parts.forEach(function (data) {
                      _.assign(data, { itemGroup: groupItemGroup[i][0].itemGroup })
                    })
                    var groupReferenceItem = _.groupBy(groupItemGroup[i][0].parts, 'reference');
                    for (var j in groupReferenceItem) {
                      if (groupReferenceItem[j].length > 1) {

                        var differentGenericPart = false;
                        var differentQuantity = false;
                        groupReferenceItem[j].forEach(function (referenceGroup, index) {
                          groupItemGroup[i][0].parts.forEach(function (itemGroup, index) {
                            if (referenceGroup.reference == itemGroup.reference && referenceGroup.genericPart != itemGroup.genericPart) {
                              differentGenericPart = true;

                              if (referenceGroup.quantity != itemGroup.quantity) {
                                differentQuantity = true;
                              }
                            }
                          })
                        })
                        if (!differentGenericPart) {

                          filteredArray = filteredArray.concat(groupReferenceItem[j][0]);

                        } else if (!differentQuantity) {

                          filteredArray = filteredArray.concat(groupReferenceItem[j][0]);
                        }
                        else if (differentQuantity && differentGenericPart) {
                          filteredArray = filteredArray.concat(groupReferenceItem[j]);
                        }

                      }
                      else {
                        filteredArray = filteredArray.concat(groupReferenceItem[j]);

                      }

                    }
                  }
                }
                var groupItemGroupOne = _.groupBy(filteredArray, 'itemGroup');
                for (var i in groupItemGroupOne) {
                  response.INT[0].basketContent.partsItems.forEach(function (item) {
                    if (item.itemGroup == i) {
                      item.parts = groupItemGroupOne[i] ? groupItemGroupOne[i] : [];
                    }
                  })
                }
                for (var i in groupItemGroup) {
                  if (groupItemGroup[i][0].parts.length == 1) {
                    var SinglegroupReferenceItem = _.groupBy(groupItemGroup[i][0].parts, 'reference');
                    for (var j in SinglegroupReferenceItem) {
                      if (SinglegroupReferenceItem[j].length == 1) {  
                        SinglegroupReferenceItem[j].forEach(function (referenceGroup, index) {
                          response.INT[0].basketContent.partsItems.forEach(function (item) {
                            if (item.itemGroup != groupItemGroup[i][0].itemGroup && item.parts.length == 1 && item.defaultValue == "on" && groupItemGroup[i][0].defaultValue == "on") {

                              item.parts.forEach(function (items) {
                                if (items.reference == referenceGroup.reference) {
                                  referenceGroup.defQuantity= parseInt(items.quantity);
                                  referenceGroup.quantity = parseInt(referenceGroup.quantity) + parseInt(items.quantity);
                                  var idx = item.parts.indexOf(items);
                                  item.parts[idx].defaultQuantity = parseInt(item.parts[idx].quantity);
                                  item.parts[idx].quantity = 0;
                                  item.parts[idx].type = 'PR';
                                  if(item.parts[idx].initialReference!=null){
                                    item.parts[idx].reference =  item.parts[idx].initialReference;
                                  }
                                  vm.partTemp.push(item.parts[idx]);
                                  item.parts.splice(idx, 1);
                                }
                              })

                            }
                          })
                        })
                      }
                    }

                  }
                  groupItemGroup[i][0].parts.forEach(function (item, index) {
                    if (index == 0) {
                      _.extend(item, { "isBlueLine": "blueleftLine" });
                    }
                    else if (index == (groupItemGroup[i][0].parts.length - 1)) {
                      _.extend(item, { "isBlueLine": "blueleftLine1" });
                    }
                  });
                }
                response.INT[0].basketContent.partsItems.forEach(function (item, index) {
                  if(!_.isEmpty(item.parts)){
                    item.parts = groupItemGroup[item.itemGroup][0].parts;
                  }
                });
                response.INT[0].basketContent.partsItems.forEach(function (item, index) {
                  item.parts.forEach(function(data){
                    _.assign(data, { itemGroup: item.itemGroup, quantity: parseInt(data.quantity), defaultQuantity: data.defQuantity ? data.defQuantity : parseInt(data.quantity), type: "PR", hideTM: false })
                    item.parts = setSwitchEnable(item.parts);
                    partsArray.push(data);
                    if (data.alternative.length >= 1 && DocumentsMetierService.brandAgeAcceptable("4", "3")){
                      _.assign(data, {itemGroup: item.itemGroup});                                 
                    }
                    else{
                      data.alternative = [];
                    }

                    if(data.additional != null && data.additional.length > 0){
                      data.additional.forEach(function(list){
                        if(!_.isEmpty(item.ratio)){
                          _.assign(list,{ quantity: parseInt(data.quantity) * parseInt(list.ratio), defaultQuantity: parseInt(data.quantity) * parseInt(list.ratio), type: "PR" })
                        }else{
                          _.assign(list,{ quantity: parseInt(data.quantity), defaultQuantity: parseInt(data.quantity), type: "PR" })
                        }
                        
                      })                      
                    }
                    if (!_.isEmpty(data.superSessionDetails)) {
                      data.superSessionDetails.forEach(function (supItem) {
                        _.assign(supItem, { quantity: parseInt(data.quantity), defaultQuantity: parseInt(data.quantity), type: "PR"})
                      })
                    }                  
                  });
                });
                if (vm.isCountrySparc) {
                  if (!vm.isUserDms) {
                    var promiseArray = _.map(partsArray,function(ref, index){
                      // setOrgAndStdBrandArrays(ref);
                      return checkSuperseding(ref, index, partsArray).then(function(){
                        setOrgAndStdBrandArrays(ref);
                        if(!_.isEmpty(ref.alternative)){
                          ref.alternative.forEach(function(altItem){
                            _.assign(altItem, { quantity: parseInt(ref.quantity), defaultQuantity: parseInt(ref.quantity), type: "PR" });
                            setPriceAvailability(altItem);
                            // defineAltFiltering(altItem);
                          })
                          // ref.alternative = ref.alternative.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.equivalentTypesField));
                          // vm.brandButtonArray.sort(brandSortFunc);
                        
                        var isAltAtleastOnePrice = _.filter(ref.alternative, function(item){
                          return item.priceAvailability;
                        })                            
                        if(isAltAtleastOnePrice && isAltAtleastOnePrice.length == 0){
                          ref.alternative = [];
                        } else {
                          for(var i=0 ; i < ref.alternative.length > 0; i++){
                            if(!ref.alternative[i].priceAvailability)
                              ref.alternative.splice(i,1);
                          }
                        }

                        ref.alternative.forEach(function(altItem){
                          defineAltFiltering(altItem);
                        });

                        ref.alternative = ref.alternative.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.equivalentTypesField));
                        vm.brandButtonArray.sort(brandSortFunc);

                        return;
                      }

                      });
                      
                    }); 
                    //set brand buttons after processing partsArray above
                    // partsArray.forEach(function(ref, index){    
                    //   setOrgAndStdBrandArrays(ref);
                    // });

                    $q.all(promiseArray).then(function () {
                      response = resetPartItems(partsArray, response);
                      if(vm.brandButtonArray.length > 0){
                        // vm.brandButtonArray.sort(brandSortFunc);
                        vm.isDisplayBrandButtons = true;
                      }
                      vm.interventionDetails = angular.copy(response);
                    })
                    
                  } else {
                    var temp = [];
                    response.INT[0].basketContent.partsItems.forEach(function (ref) {
                        if(!_.isEmpty(ref.parts)){
                          temp = temp.concat(ref.parts);
                        }
                    });
                    var references = DmsMetierService.getSupersedingList(temp);
                    if(!_.isEmpty(references)){
                      DmsMetierService.getReferencesDms(references).then(function (resp) {
                        var dmsData = DmsMetierService.buildDataFromDms(resp.response.parts);
                        DmsMetierService.matchReferenceFromDmsforSuperSeding(temp, dmsData);
                        response = resetPartItems(temp, response);
                        var promiseArray = _.map(response.INT[0].basketContent.partsItems,function (ref) {
                          if(!_.isEmpty(ref.parts)){
                           return _.map(ref.parts,function(data, index){
                              return checkSuperseding(data, index, response).then(function(){
                                setStockAvailability(data);
                                setOrgAndStdBrandArrays(data);
                                if(!_.isEmpty(data.alternative)){
                                  data.alternative.forEach(function(altItem){
                                    _.assign(altItem, { quantity: parseInt(data.quantity), defaultQuantity: parseInt(data.quantity), type: "PR" });
                                    setStockAvailability(altItem);
                                    // defineAltFiltering(altItem);
                                  })
                                  // data.alternative = data.alternative.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.equivalentTypesField));
                                  // vm.brandButtonArray.sort(brandSortFunc);

                                  var isAltAtleastOneStock = _.filter(data.alternative, function(item){
                                    return item.stockAvailability;
                                  })                            
                                  if(isAltAtleastOneStock && isAltAtleastOneStock.length == 0){
                                    data.alternative = [];
                                  } else {
                                    for(var i=0 ; i < data.alternative.length > 0; i++){
                                      if(!data.alternative[i].stockAvailability)
                                        data.alternative.splice(i,1);
                                    }
                                  }

                                  data.alternative.forEach(function(altItem){
                                    defineAltFiltering(altItem);
                                  })
                                  data.alternative = data.alternative.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.equivalentTypesField));
                                  vm.brandButtonArray.sort(brandSortFunc);

                                  return;
                                }
                              
                              })
                            });
                          }
                        });
                        $q.all(promiseArray).then(function () {
                          if(vm.brandButtonArray.length > 0){
                            vm.isDisplayBrandButtons = true;
                          }
                          vm.interventionDetails = angular.copy(response);
                        });
                      })
                    }
                  }
                } else if (vm.isUserDms) {
                  var temp = [];
                  response.INT[0].basketContent.partsItems.forEach(function (ref) {
                    if(!_.isEmpty(ref.parts)){
                      temp = temp.concat(ref.parts);
                    }
                  });
                  var references = DmsMetierService.getSupersedingList(temp);
                  if(!_.isEmpty(references)){
                    DmsMetierService.getReferencesDms(references).then(function (resp) {
                      var dmsData = DmsMetierService.buildDataFromDms(resp.response.parts);
                      DmsMetierService.matchReferenceFromDmsforSuperSeding(temp, dmsData);
                      response = resetPartItems(temp, response);
                      response.INT[0].basketContent.partsItems.forEach(function (ref) {
                        if(!_.isEmpty(ref.parts)){
                          ref.parts.forEach(function(data){
                            setStockAvailability(data);
                            if(!_.isEmpty(data.additional)){
                              data.additional.forEach(function(addItem){
                                setStockAvailability(addItem);
                              });
                            }
                          });
                        }
                      });
                      vm.interventionDetails = angular.copy(response);
                    });
                  }
                }
              }
              vm.interventionDetails = angular.copy(response);
              var docDetail = {
                docId: vm.initialInterventionDetails.INT[0].id
            };
              SearchArboTextualMetierService.getCountVotes(docDetail).then(function (response){
                vm.availableCount = response.like;
                vm.unavailableCount = response.disLike;
                vm.activeButton = response && response.status ? response.status:null;
             });
              prArrayCheck();
              tmArrayCheck();
              updateEssayTm();
           }
          }
          if (selectedItem.bulkAdditionDone){
            disableSwitch(response,true);
          }
          else if (selectedItem.bulkQuoteAdditionDone) {
            disableSwitch(vm.interventionDetails,true);
          }
        }).catch(function (error) {
          $log.debug(error);
        }).finally(function () {       
          mrLinkData(vm.initialInterventionDetails);
          blockUI.stop();
        })
      }
    }
    function mrLinkData(response){
      if(response && !_.isEmpty(response.INT) && response.INT[0]){
        var elementList = [];
        if(!_.isEmpty(response.INT[0].basketContent.labourTimeItems)){
          response.INT[0].basketContent.labourTimeItems.forEach(function(item){
            if(item.labourTimes && item.labourTimes.length > 0){
              item.labourTimes.forEach(function(lt){
                if(lt.value && lt.value.length > 0){
                  lt.value.forEach(function(v){
                    if(v.element && !_.includes(elementList, v.element)){
                      elementList.push(v.element);
                    }
                  });
                }
              });
            }
          });
        }
        if(!_.isEmpty(elementList)){
          DocumentsMetierService.getIDsBySieElemOpe(elementList, ["MR"]).then(function(resp){
            var mrIds = [];
            if(!_.isEmpty(resp)){
              resp.forEach(function(item){
                if(item.docs && !_.isEmpty(item.docs)){
                  item.docs.forEach(function(doc){
                    mrIds.push(doc.id);
                  });
                }
              });
            }
            vm.initialInterventionDetails.INT[0].mrDocumentIds = _.uniq(mrIds);
          });
        } else {
          vm.initialInterventionDetails.INT[0].mrDocumentIds = [];
        }
      }
    }

    function gotoMrLink(interventionDetails) {
      var selectedInterventionId = CacheService.getObject(CacheConstants.selectedInterventionId);
      if(!_.isEmpty(interventionDetails.INT[0].mrDocumentIds) && interventionDetails.INT[0].mrDocumentIds.length > 1){
          $mdDialog.show({
              parent: angular.element(document.body),
              templateUrl: 'app/components/products/documents/pr-mrlink/prMrLink.template.html',
              controller: 'PrMrLinkCtrl',
              bindToController: true,
              controllerAs: 'vm',
              clickOutsideToClose: true,
              size: 'lg',
              skipHide: true,
              multiple: true,
              windowClass: 'my-modal-popup',
              locals: {
                  mrdocids: interventionDetails.INT[0].mrDocumentIds,
                  interventionMrDetails: interventionDetails.INT[0],
                  interventionId: selectedInterventionId.id
              }
          })
      } else if(!_.isEmpty(interventionDetails.INT[0].mrDocumentIds) && interventionDetails.INT[0].mrDocumentIds.length == 1) {
          mrDocumentsMetierService.getInitialSieDocuments(interventionDetails.INT[0].mrDocumentIds).then(function (mrDocuments) {
              if(!_.isEmpty(mrDocuments)){
                  if (mrDocuments[0].pdfContent == "false") {
                   
                    $mdDialog.cancel();
                     $state.go(RoutesConstants.documentMR, {
                            id: mrDocuments[0].sieRef,
                            plateIndex: $state.params.plateIndex,
                            refIndex: $state.params.refIndex,
                            prMRLinked: true,
                            interventionId: selectedInterventionId ? selectedInterventionId.id : ""
                        });   
                  }
                 
                  else {
                      DocumentsMetierService.returnSiePdfContent(mrDocuments[0].sieRef, 'SIE_MR').then(function (result) {
                          var url = result.contentUrl;
                          $window.open(url, '_blank');
                      });
                  }
              }
          }, function (error) {
              toastr.error(error, 'Error');
          }).finally(function () {
              blockUI.stop();
          });
      }      
    }

    function checkCatalogPlateId(ref) {
      var catalogPlate = [];
      if (!ref.catalogPlates || ref.catalogPlates.length === 0) {
        return "-";
      }
      if (vm.isHorseUser) {
        var allowedPrDocuments = getAllowedPrDocumentsForHorse();
        angular.forEach(ref.catalogPlates, function (item) {
          if (allowedPrDocuments.indexOf(item.id) !== -1) {
            catalogPlate.push(item.id);
          }
        });
        return catalogPlate.length > 0 ? catalogPlate : "-";
      } else {
        angular.forEach(ref.catalogPlates, function (item) {
          catalogPlate.push(item.id);
        });
        return catalogPlate;
      }
    }

    function isCatalogPlateAllowedForHorse(part) {
      if (!vm.isHorseUser) {
        return true;
      }

      if (!part.catalogPlates || part.catalogPlates.length === 0) {
        return false;
      }

      var allowedPrDocuments = getAllowedPrDocumentsForHorse();

      for (var i = 0; i < part.catalogPlates.length; i++) {
        if (allowedPrDocuments.indexOf(part.catalogPlates[i].id) !== -1) {
          return true;
        }
      }

      return false;
    }

    function getAllowedPrDocumentsForHorse() {

      if (!vm.isHorseUser) {
        return [];
      }

      var cachedData = CacheService.getObject(CacheConstants.allowedPrDocumentsForHorse);

      if (cachedData && cachedData.allowedPrDocuments) {
        return cachedData.allowedPrDocuments;
      }

      return [];
    }

    function setOrgAndStdBrandArrays(ref){
      if (vm.brandButtonArray.length === 0 || _.findIndex(vm.brandButtonArray, { brand: 'ORG' }) === -1) {
        vm.brandButtonArray.push(
          {
            brand: 'ORG',
            isSelBrand: true
          }
        )
      }
      if (ref.types.includes(ListPieceConstants.types.standardExchange) && _.findIndex(vm.brandButtonArray, { brand: 'STDEX' }) === -1) {
        vm.brandButtonArray.push(
          {
            brand: 'STDEX',
            isSelBrand: false
          }
        )
      }
    }
    function setSwitchEnable(val){
      val.forEach(function(data){
        if(val.length == 1){
          _.extend(data, {switchEnable: true});
          if(data.additional != null && data.additional.length > 0){
            data.additional.forEach(function (list){
              _.extend(list, {switchEnable: true});
            })
          }
        } else if(!_.isEmpty(val) && val.length == 2){
          var filteredSTDPart = _.filter(val, function (alt) {
            return alt.types.includes(ListPieceConstants.types.standardExchange);
          })
          var filteredORGPart = _.filter(val, function (alt) {
            return alt.brand == ListPieceConstants.types.centrale;
          })
          if(filteredSTDPart.length == 1 && filteredORGPart.length == 1){
            if(filteredORGPart[0].reference == data.reference){
              _.extend(data, {switchEnable: true});
			  if(data.additional != null && data.additional.length > 0){
				data.additional.forEach(function (list){
				_.extend(list, {switchEnable: true});
				})
			  }
            } else{
              _.extend(data, {switchEnable: false});
            }
          } else{
            _.extend(data, {switchEnable: false});
          }
        }
        else{
          _.extend(data, {switchEnable: false});
          if(data.additional != null && data.additional.length > 0){
            data.additional.forEach(function (list){
              _.extend(list, {switchEnable: false});
            })
          }
        }
        if (!_.isEmpty(data.alternative)) {
          data.alternative.forEach(function(altItem){
            _.extend(altItem, {switchEnable: false});
          })
        }
      })
      return val;
    }
    function makeORGSwitchOff(){
      vm.interventionDetails.INT[0].basketContent.partsItems.forEach(function (item) {
        if(!_.isEmpty(item.parts)){
          item.parts = setSwitchEnable(item.parts);
        }
      })
    }
    function defineAltFiltering(altitem){
      if (altitem.equivalentTypes.includes(ListPieceConstants.types.valuePlus) && _.findIndex(vm.brandButtonArray, { brand: 'VAL' }) === -1 && ((!vm.isUserDms && altitem.priceAvailability) || (vm.isUserDms && altitem.stockAvailability))) {
        vm.brandButtonArray.push(
          {
            brand: 'VAL',
            isSelBrand: false,
          }
        )
      } else if (altitem.equivalentTypes.includes(ListPieceConstants.types.motrio) && _.findIndex(vm.brandButtonArray, { brand: 'MOT' }) === -1 && ((!vm.isUserDms && altitem.priceAvailability) || (vm.isUserDms && altitem.stockAvailability))) {
        vm.brandButtonArray.push(
          {
            brand: 'MOT',
            isSelBrand: false,
          }
        )
      }      
    }
    /* function checkIfPRTMExists(){
      for (var i in vm.interventionDetails.INT[0].basketContent) {
        var atLeastOnePR = false;
        var atLeastOneTM = false;
        if(i == 'partsItems' || i == 'labourTimeItems'){
          vm.interventionDetails.INT[0].basketContent[i].forEach(function(item){ 
            if(i == 'partsItems' && item.parts.length > 0){
              atLeastOnePR  = true;
            }
            if(i == 'labourTimeItems' && item.labourTimes && item.labourTimes.length >0 ){
              atLeastOneTM = true;
            }        
          })
          vm.interventionDetails.INT[0].basketContent.atLeastOnePR = atLeastOnePR;
          vm.interventionDetails.INT[0].basketContent.atLeastOneTM = atLeastOneTM;
        }            
      }
    } */
       

    function prArrayCheck() {
      vm.prPopUp = true;
      for (var i in vm.interventionDetails.INT[0].basketContent) {
        if (i == 'partsItems') {
          vm.interventionDetails.INT[0].basketContent[i].forEach(function (item) {
            if (i == 'partsItems' && item.parts.length > 0) {
              item.parts.forEach(function (partsdata) {
                if (partsdata.switchEnable === true) {
                  vm.prPopUp = false;
                  return vm.prPopUp;
                }
                if (partsdata.alternative.length > 0) {
                  partsdata.alternative.forEach(function (alterdata) {
                    if (alterdata.switchEnable === true) {
                      vm.prPopUp = false;
                      return vm.prPopUp;
                    }
                  })
                }
              })

            }

          })
        }
      }
      return vm.prPopUp;
    }


    function tmArrayCheck() {
      vm.tmPopUp = true;
      for (var i in vm.interventionDetails.INT[0].basketContent) {
        if (i == 'labourTimeItems') {
          vm.interventionDetails.INT[0].basketContent[i].forEach(function (item) {
            if (i == 'labourTimeItems' && item.labourTimes && item.labourTimes.length > 0) {
              item.labourTimes.forEach(function (tmData) {
                if (tmData.value.length > 0) {
                  tmData.value.forEach(function (tmValue) {
                    if (tmValue.toggleTM === true) {
                      vm.tmPopUp = false;
                      return vm.tmPopUp;
                    }
                  })
                }

              })
            }
          })

        }
      }
      return vm.tmPopUp;
    }





    function brandSortFunc(a, b) {
      var sortingArr = ['ORG','STDEX','VAL', 'MOT'];
      return sortingArr.indexOf(a.brand) - sortingArr.indexOf(b.brand);
    }

    function performTmOperation(list){
      if (!_.isEmpty(list)) {
        var duplicateTm = [];
        var newTmResponse = [];
        var labourTimesResponse = list;
        var labourTimes = angular.copy(list);
        labourTimes.forEach(function (tm) {
          tm.duration = tm.duration ? parseFloat(tm.duration.replace(",", ".")) : 0;
        })
        labourTimesResponse.forEach(function (item) {
          var temp = [];
          temp = item.designation ? item.designation.split(':') : '';
          _.extend(item, { 'title': (temp[1] ? temp[1].trim() : '' )+ " : " + ( temp[2] ? temp[2].trim(): ''), 'tmType': item.designation.substring(0, 2), tmDuration: item.duration ? parseFloat(item.duration.replace(",", ".")) : 0 })
        })
        var tmList = _.groupBy(labourTimes, function (item) {
          return [item['element'], item['operation']];
        });
        if (!_.isEmpty(tmList)) {
          var genericList = [];
          var displayTMList = [];
          for (var key in tmList) {
            var goList = _.filter(tmList[key], ['operationType', "1"]);
            var soList = _.filter(tmList[key], ['operationType', "2"]);
            if (!_.isEmpty(goList)) {
              goList.forEach(function (item) {
                genericList.push(item);
              })
              if (goList.length > 1) {
                goList.forEach(function (tm) {
                  tm.technicalId ? duplicateTm.push(tm.technicalId) : null;
                })
              }
            }
            if (!_.isEmpty(soList)) {
              if (soList.length > 1) {
                soList.forEach(function (tm) {
                  tm.technicalId ? duplicateTm.push(tm.technicalId) : null;
                })
              }
            }
          }
          if (!_.isEmpty(genericList)) {
            var mainGo = genericList.reduce(function (prev, current) {
              return (prev.duration > current.duration) ? prev : current
            })
          }
          var mainGoKey = mainGo && mainGo.element && mainGo.operation ? mainGo.element + "," + mainGo.operation : null;
          for (var key in tmList) {
            // Display check for mainGO
            if (mainGoKey && key == mainGoKey) {
              mainGo.technicalId ? displayTMList.push(mainGo.technicalId) : null;

              if (tmList[key].length > 1) {
                var mainGroupList = _.filter(tmList[key], ['operationType', "1"]);
                if (!_.isEmpty(mainGroupList)) {
                  mainGroupList.forEach(function (item) {
                    item.characteristics.quantity = item.characteristics && item.characteristics.quantity ? item.characteristics.quantity : "0";
                  })
                  var mainGoQuantityList = [];
                  mainGo.characteristics && mainGo.characteristics.quantity ? mainGoQuantityList.push(mainGo.characteristics.quantity) : null;
                  mainGroupList.forEach(function (item) {
                    !_.isNull(item.characteristics.quantity) && !_.isNull(mainGo.characteristics.quantity) && !_.includes(mainGoQuantityList, item.characteristics.quantity) && item.characteristics.quantity != mainGo.characteristics.quantity ? (displayTMList.push(item.technicalId), mainGoQuantityList.push(item.characteristics.quantity)) : null;
                  })
                }
              }
            }
            else {
              //to display the other group SO
              var otherSoList = _.filter(tmList[key], ['operationType', "2"]);
              if (!_.isEmpty(otherSoList)) {
                otherSoList.forEach(function (item) {
                  item.technicalId ? displayTMList.push(item.technicalId) : null;
                })
              } else {
                //to display GO for the non SO check
                var otherGoList = _.filter(tmList[key], ['operationType', "1"]);
                if (!_.isEmpty(otherGoList)) {
                  otherGoList.forEach(function (item) {
                    displayTMList.push(item.technicalId);
                  })
                }
              }
            }
          }
        }
        var removeTmList = labourTimesResponse.filter(function (item) {
          return !displayTMList.includes(item.technicalId);
        })

        removeTmList.forEach(function (item) {
          var tmHide = labourTimesResponse.find(function (tm) {
            return tm.technicalId == item.technicalId;
          })

          _.assign(tmHide, { quantity: 0, hideTM: true, toggleTM: false })
        })
        duplicateTm.forEach(function (item) {
          var displayTooltip = labourTimesResponse.find(function (tm) {
            return tm.technicalId == item;
          })
          _.assign(displayTooltip, { quantity: 0, hideTM: true, toggleTM: false, infoIcon: true })
        })

        // Reverse the list by duration
        list = _.sortBy(labourTimesResponse, [function (tm) {
          return [tm.element, tm.operation, tm.tmDuration];
        }]).reverse();

        // Sort the list by type
        list = _.sortBy(list, [function (tm) {
          return [tm.tmType];
        }]);

        list = _.groupBy(list, 'title');              
        
        for (var val in list) {
          var temp = [];
          temp = _.find(list[val], function (item) { return item.infoIcon == true })
          if (temp) {
            newTmResponse.push({ title: val, value: list[val], infoitem: true })
          }
          else {
            newTmResponse.push({ title: val, value: list[val], infoitem: false })
          }
        }
      }
      return newTmResponse;
    }

    function resetPartItems(ref, response){
      ref = _.groupBy(ref, 'itemGroup');
      response.INT[0].basketContent.partsItems.forEach(function (item) {
        item.parts = ref[item.itemGroup] ? ref[item.itemGroup] : [];
        item.parts = setSwitchEnable(item.parts);
      });
      return response;
    }

    function setStockAvailability(ref){
      if(ref.dmsInformations && ref.dmsInformations.quantity > 0){
        ref.stockAvailability = true;
      } else {
        ref.stockAvailability = false;
      }
    }
    function returnCarDetailsFromJson(carsDetail) {
      var carDetails = '';
      carDetails += conditionCheck(carsDetail.model) ? (carsDetail.model + ', ') : '';
      carDetails += conditionCheck(carsDetail.motorisation) ? (carsDetail.motorisation) : '';
      carDetails += (carsDetail.motorisation || carsDetail.model) ? ', ' : '';
      carDetails += conditionCheck(carsDetail.gearBoxType) ? carsDetail.gearBoxType : '';
      carDetails += ((carsDetail.motorisation || carsDetail.model) && (carsDetail.colorCode || carsDetail.color)) ? ', ' : '';
      carDetails +=  conditionCheck(carsDetail.colorCode) ? (carsDetail.colorCode + ' ') : (conditionCheck(carsDetail.color) ? (carsDetail.color + ' ') : '');
      return carDetails;
  }
  function conditionCheck(item){
    if(item != null && item !== undefined && item != '')
    {
      return true;
    }
    else{
      return false;
    }

  }
    function setPriceAvailability(ref){
      if(ref.priceExclTaxes){
        ref.priceAvailability = true;
      } else {
        ref.priceAvailability = false;
      }
    }
    function changeTMtoggle(part) {
      var goTMconfirm = false;
      var temp = [];
      part.quantity = part.toggleTM == true ? part.defaultQuantity : 0;
      part.hideTM = part.toggleTM == true ? false : true;

      var tempIndex =  _.findIndex(vm.interventionDetails.INT[0].basketContent.labourTimeItems, function (list){
        return list.itemGroup == part.itemGroup
      })
      vm.interventionDetails.INT[0].basketContent.labourTimeItems.forEach(function (item,itemIndex){
        if (item.labourTimes && item.labourTimes.length > 0){
          item.labourTimes.forEach(function (itemList){
            if (tempIndex == itemIndex){
              itemList.value.forEach(function(list){
                if(list.id != part.id ){
                  list.toggleTM = false;
                  list.hideTM = true;
                }
  
              })
            }
            temp = temp.concat(itemList.value);
          })
        } 

      })

      // for (var prop in vm.interventionDetails.INT[0].basketContent.labourTimes) {
      //   temp = temp.concat(vm.interventionDetails.INT[0].basketContent.labourTimes[prop].value);
      // }
      var tmList = _.groupBy(temp, function (item) {
        return [item['element'], item['operation']];
      });
      var partKey = part && part.element && part.operation ? part.element + "," + part.operation : null;
      for (var key in tmList) {
        if (partKey && partKey == key && part.toggleTM == true) {
          tmList[key].forEach(function (tm) {
            if (part.technicalId != tm.technicalId) {
              tm.toggleTM = false;
              tm.hideTM = true;
              tm.quantity = 0;
            }
          })
        } else if (part.operationType == '1' && partKey != key && part.toggleTM == true) {
          tmList[key].forEach(function (tm) {
            if (tm.operationType == '1' && tm.quantity == 1 && tm.toggleTM) {
              goTMconfirm = true;
            }
          })
        }
      }
      if (goTMconfirm) {
        var body = angular.element(document.body);
        $mdDialog.show({
          parent: vm.isModal ? document.getElementsByClassName('md-dialog-container') : body,
          templateUrl: 'app/components/orderModule/orderModeClosePopup.html',
          controller: 'orderModeClosePopupController',
          bindToController: true,
          controllerAs: "vm",
          clickOutsideToClose: false,
          skipHide: true,
          multiple: true,
          locals: {
            message: $translate.instant("MULTIPLE_GO_SELECTED"),
            message2: $translate.instant("ADD_MULTIPLE_GO_SELECTED"),
            confirmMessage: $translate.instant("ORDER_CONFIRM"),
            cancelMessage: $translate.instant("ACTIS_HEADER_CANCEL"),
            interventionTmPop: true
          }
        }).then(function (result) {
          if (result && result.isOrderModeEnabled) {
            part.quantity = part.defaultQuantity;
            part.toggleTM = true;
            part.hideTM = false;
          } else {
            part.quantity = 0;
            part.toggleTM = false;
            part.hideTM = true;
          }
        }).catch(function () {
        });
      }
      tmArrayCheck();
      prArrayCheck();
      updateEssayTm();

    }

    /**
     * Resolves the single "essay" TM linked to the currently selected TMs.
     * Priority: type 3 (no opecod, manual) > type 2 (0130) > type 1 (0129) > type 4 (0145). Type 5 is ignored.
     */
    function updateEssayTm() {
      var basketContent = vm.interventionDetails && vm.interventionDetails.INT && vm.interventionDetails.INT[0] ?
        vm.interventionDetails.INT[0].basketContent : null;
      var labourTimeItems = basketContent ? basketContent.labourTimeItems : null;
      var essayTypes = [];
      if (!_.isEmpty(labourTimeItems)) {
        labourTimeItems.forEach(function (labourTimeItem) {
          if (!_.isEmpty(labourTimeItem.labourTimes)) {
            labourTimeItem.labourTimes.forEach(function (labourTime) {
              if (!_.isEmpty(labourTime.value)) {
                labourTime.value.forEach(function (tm) {
                  if (tm.toggleTM && tm.essay) {
                    essayTypes.push(tm.essay);
                  }
                })
              }
            })
          }
        })
      }
      essayTypes = _.uniq(essayTypes);
      if (_.includes(essayTypes, _essayTestBench)) {
        vm.essayTmLine = { isManual: true, title: $translate.instant('INTERVENTION_ESSAY_TEST_BENCH') };
        return;
      }
      var selectedEssayType = null;
      essayTypes.forEach(function (essayType) {
        if (_testTime[essayType] && (!selectedEssayType || _testTime[essayType] > _testTime[selectedEssayType])) {
          selectedEssayType = essayType;
        }
      })
      if (!selectedEssayType) {
        vm.essayTmLine = null;
        return;
      }
      var essayOpecod = _essai[selectedEssayType];
      if (vm.essayTmLine && !vm.essayTmLine.isManual && vm.essayTmLine.id === essayOpecod) {
        return;
      }
      vm.essayTmLine = null;
      DocumentsMetierService.returnTmDocumentsByOpeCode([essayOpecod]).then(function (response) {
        var essayTm = response && !_.isEmpty(response.TM) ? response.TM[0] : null;
        if (essayTm) {
          vm.essayTmLine = {
            isManual: false,
            id: essayTm.id,
            title: essayTm.designation,
            tmType: essayTm.designation ? essayTm.designation.substring(0, 2) : '',
            duration: essayTm.duration
          };
        }
      }).catch(function (error) {
        $log.debug(error);
      })
    }

    function getImageUrl(isSelBrand, brand) {
      if (brand === 'STDEX') {
        return './assets/images/renative_reman.png';
      }
      return (brand === 'MOT') ? (isSelBrand ? './assets/images/motrio_black.png' : './assets/images/motrio.png') :
        (isSelBrand ? './assets/images/value+black.png' : './assets/images/value+.png');
    }

    
    function getStyle(isSelBrand, brand) {
      return (brand === 'MOT') ? (isSelBrand ? { 'color': '#fff', 'background-color': 'var(--renaultPrimaryColor)' } : { 'color': 'red', 'background-color': '#e2ddd0' }) :
        (isSelBrand ? { 'color': '#fff', 'background-color': 'var(--renaultPrimaryColor)' } : { 'background-color': '#e2ddd0' });

    }
    function selectBrandParts(selBrand) {
      if (selBrand === 'STDEX') {
        vm.interventionDetails.INT[0].basketContent.partsItems = _.map(vm.interventionDetails.INT[0].basketContent.partsItems, function (item) {
          var filteredSTDPart = _.filter(item.parts, function (alt) {
            return alt.types.includes(ListPieceConstants.types.standardExchange);
          })
          var filteredORGPart = _.filter(item.parts, function (alt) {
            return alt.brand == ListPieceConstants.types.centrale;
          })
          item.parts.forEach(function(partItem){
            if(filteredSTDPart.length == 1 && filteredORGPart.length == 1){
              partItem.switchEnable = false;              
              if(!_.isEmpty(partItem.additional)){
                partItem.additional.forEach(function (list){
                  list.switchEnable = false;
                })
              }
              partItem.alternative.forEach(function (alt) {
                alt.switchEnable = false;
              });
              if(partItem.types.includes(ListPieceConstants.types.standardExchange)){
                partItem.switchEnable = true;
              }
            } else if(filteredSTDPart.length == 1 && item.parts.length == 1){
              partItem.switchEnable = true;
            }
            return partItem;
          })
          return item;
        });
      } else if (selBrand === 'VAL' || selBrand === 'MOT') {
        vm.interventionDetails.INT[0].basketContent.partsItems = _.map(vm.interventionDetails.INT[0].basketContent.partsItems, function (item) {         
          if(item.parts.length == 1){
            var filteredMotPart = _.filter(item.parts[0].alternative, function (alt) {
              return ((selBrand === 'VAL' && alt.equivalentTypes.includes(ListPieceConstants.types.valuePlus)) || (selBrand === 'MOT' && alt.equivalentTypes.includes(ListPieceConstants.types.motrio)));
            })
            if(filteredMotPart.length == 1){
              item.parts[0].switchEnable = false;
              if(!_.isEmpty(item.parts[0].additional)){
                item.parts[0].additional.forEach(function (list){
                  list.switchEnable = false;
                })
              }
              item.parts[0].alternative.forEach(function(alt){
                alt.switchEnable = false;
                if(alt.reference == filteredMotPart[0].reference){
                  alt.switchEnable = true;
                }
                return alt;
              })
            } else if(filteredMotPart.length != 0){
              item.parts[0].switchEnable = false;
              if(!_.isEmpty(item.parts[0].additional)){
                item.parts[0].additional.forEach(function (list){
                  list.switchEnable = false;
                })
              }
              item.parts[0].alternative.forEach(function(alt){
                alt.switchEnable = false;
                if(alt.reference == filteredMotPart[0].reference){
                  alt.switchEnable = true;
                }
                return alt;
              })
            } else {
              item.parts[0].switchEnable = true;
              if(!_.isEmpty(item.parts[0].additional)){
                item.parts[0].additional.forEach(function (list){
                  list.switchEnable = true;
                })
              }
              item.parts[0].alternative.forEach(function(alt){
                alt.switchEnable = false;
                return alt;
              })
            }
          } else if(item.parts.length > 1){
            var tempArray = [];
            item.parts.forEach(function(multiPart){
              multiPart.switchEnable = false;
              var filteredMotPart = _.filter(multiPart.alternative, function (alt) {
                return ((selBrand === 'VAL' && alt.equivalentTypes.includes(ListPieceConstants.types.valuePlus)) || (selBrand === 'MOT' && alt.equivalentTypes.includes(ListPieceConstants.types.motrio)));
              })
              if(!_.isEmpty(filteredMotPart) && !_.isEmpty(multiPart.alternative)){
                tempArray.push(multiPart)
              }
            })
            if(tempArray.length == 1){
              item.parts.forEach(function(multiPart){
                if(multiPart.reference == tempArray[0].reference){
                  var filteredMotPart = _.filter(multiPart.alternative, function (alt) {
                    return ((selBrand === 'VAL' && alt.equivalentTypes.includes(ListPieceConstants.types.valuePlus)) || (selBrand === 'MOT' && alt.equivalentTypes.includes(ListPieceConstants.types.motrio)));
                  })

                  multiPart.switchEnable = false;
                  if(!_.isEmpty(multiPart.additional)){
                    multiPart.additional.forEach(function (list){
                      list.switchEnable = false;
                    })
                  }
                  multiPart.alternative.forEach(function(alt){
                    alt.switchEnable = false;
                    if(alt.reference == filteredMotPart[0].reference){
                      alt.switchEnable = true;
                    }
                    return alt;
                  })
                }
                return multiPart;
              })
            }
          }
          return item;
        })
      } else if(selBrand === 'ORG'){
        makeORGSwitchOff();
      }
      vm.brandButtonArray = _.map(vm.brandButtonArray, function (brandArr) {
        if (brandArr.brand === selBrand) {
          brandArr.isSelBrand = true;
          return brandArr;
        } else {
          brandArr.isSelBrand = false;
          return brandArr;
        }
      })
      prArrayCheck();
      tmArrayCheck();
    }
    function alterSwitchEnable(isEnable,itemGroupIndex,mainIndex,altIndex){
      
      if(altIndex == -1 && isEnable){
        if(!_.isEmpty( vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts)){
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts.forEach(function(mainpart){
            mainpart.switchEnable = false;
            mainpart.alternative.forEach(function(altpart){
              altpart.switchEnable = false;
            })
            if( !_.isEmpty(mainpart.additional)){
              mainpart.additional.forEach(function(addpart){
                addpart.switchEnable = false;
              })
            }            
          })
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts[mainIndex].switchEnable = true;
          if( !_.isEmpty(vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts[mainIndex].additional)){
            vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts[mainIndex].additional.forEach(function(addpart){
              addpart.switchEnable = true;
            })
          }
        }
      }
      if(altIndex != -1 && isEnable){
        if(!_.isEmpty(vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts)){
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts.forEach(function(mainpart){
            mainpart.switchEnable = false;
            mainpart.alternative.forEach(function(altpart){
              altpart.switchEnable = false;
            })
            if( !_.isEmpty(mainpart.additional)){
              mainpart.additional.forEach(function(addpart){
                addpart.switchEnable = false;
              })
            }
          })
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts[mainIndex].alternative[altIndex].switchEnable = true;
        }
      } 
      if(altIndex == -1 && !isEnable){
        if(!_.isEmpty(vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts)){
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts.forEach(function(mainpart){
            mainpart.switchEnable = false;
            if( !_.isEmpty(mainpart.additional)){
              mainpart.additional.forEach(function(addpart){
                addpart.switchEnable = false;
              })
            }
          })
          vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts[mainIndex].switchEnable = false;
        }
      } 
      prArrayCheck();
      tmArrayCheck();    
    }

    function additionalSwitchEnable(itemGroupIndex){
      if(!_.isEmpty(vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts)){
        vm.interventionDetails.INT[0].basketContent.partsItems[itemGroupIndex].parts.forEach(function(mainpart){
          if (mainpart.switchEnable == false){
            if( !_.isEmpty(mainpart.additional)){
              mainpart.additional.forEach(function(addpart){
                addpart.switchEnable = false;
              })
            }
          }
          
        })
      }
      prArrayCheck();
      tmArrayCheck(); 
    }

    function selectCsv(selectedItem) {
      document.getElementById("myDropdown").classList.toggle("show");
      selectedItem.showCsvFile = !selectedItem.showCsvFile
      selectedItem.showPrCsvFile = !selectedItem.showPrCsvFile;

      var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
      vm.selectedItemDetails = [];
      $rootScope.selectedItemDetailsNew =[];
      var recapCar = RecapCarMetierService.getCarInfos();
      if (recapCar && recapCar.vehicle) {
        vm.carDetailModel = returnCarDetailsFromJson(recapCar.vehicle);
      }
      vm.selectedItemDetails.push(carContext && carContext.vin ? carContext.vin : "");
      vm.selectedItemDetails.push(vm.carDetailModel ? vm.carDetailModel : "");
      var fixedCriterias = {
        "007": carContext && carContext.fixedCriterias["007"] ? carContext.fixedCriterias["007"] + '/' : "",
        "008": carContext && carContext.fixedCriterias["008"] ? carContext.fixedCriterias["008"] + '/' : "",
        "901": carContext && carContext.fixedCriterias["901"] ? carContext.fixedCriterias["901"] + '/' : "",
        "336": carContext && carContext.fixedCriterias["336"] ? carContext.fixedCriterias["336"] + '/' : "",
        "999": carContext && carContext.fixedCriterias["999"] ? carContext.fixedCriterias["999"] + '/' : "",
        "998": carContext && carContext.fixedCriterias["998"] ? carContext.fixedCriterias["998"] + '/' : "",
        "997": carContext && carContext.fixedCriterias["997"] ? carContext.fixedCriterias["997"] + '/' : "",
        "996": carContext && carContext.fixedCriterias["996"] ? carContext.fixedCriterias["996"] : ""
      };
      var fullCriteria = fixedCriterias["007"] + fixedCriterias["008"] + fixedCriterias["901"] + fixedCriterias["336"] + fixedCriterias["999"] + fixedCriterias["998"] + fixedCriterias["997"] + fixedCriterias["996"];
      vm.selectedItemDetails.push(fullCriteria);
      var dateFab = carContext && carContext.variableCriterias && carContext.variableCriterias.APVDT1 ? carContext.variableCriterias.APVDT1 : "";
      var dateTrad = $translate.instant('DATE_FAB');
      vm.selectedItemDetails.push(dateTrad + ';' + dateFab);
      vm.selectedItemDetails.push("");
      vm.selectedItemDetails.push(selectedItem && selectedItem.designation ? selectedItem.designation : "");
      vm.selectedItemDetails.push("sieNumber" + ';' + (selectedItem && selectedItem.id ? selectedItem.id : ""));
      var versionTrad = $translate.instant('RLINKCAR_VERSION');
      vm.selectedItemDetails.push(versionTrad + ';' + selectedItem.version);
      vm.selectedItemDetails.push("gieNumber" + ';' + (selectedItem && selectedItem.gieNumber ? selectedItem.gieNumber : ""));
      vm.selectedItemDetails.push("codeARDS" + ';' + (selectedItem && selectedItem.codeARDS ? selectedItem.codeARDS : ""));
      vm.selectedItemDetails.push("maturity" + ';' + (selectedItem && selectedItem.maturity ? selectedItem.maturity : ""));
      vm.selectedItemDetails.push("quantity" + ';' + (selectedItem && selectedItem.quantity ? selectedItem.quantity : ""));
      vm.selectedItemDetails.push("BTNumbers" + ';' + (selectedItem && selectedItem.BTNumbers ? selectedItem.BTNumbers : ""));
      $rootScope.selectedItemDetailsNew = vm.selectedItemDetails;
      vm.headerPr = {};
      if (vm.initialInterventionDetails && vm.initialInterventionDetails.INT[0] && vm.initialInterventionDetails.INT[0].basketContent && vm.initialInterventionDetails.INT[0].basketContent.partsItems) {
        vm.headerPr = listInterventionConstant.headerPr;
        vm.filteredParts = [];
        vm.initialInterventionDetails.INT[0].basketContent.partsItems.forEach(function (partsArray) {
          if(partsArray && !_.isEmpty(partsArray.notApplicablePgs)){
          partsArray.notApplicablePgs.forEach(function(item){
            var notApplicableData = {};
            _.assign(notApplicableData, { itemGroup: partsArray.itemGroup, type: "PR", genericPart:item, applicable: "N"})
            vm.filteredParts.push(notApplicableData);  
          })
        }
          partsArray.parts.forEach(function (item) {
            _.assign(item, { itemGroup: partsArray.itemGroup, type: "PR", applicable: "Y" })   
            vm.filteredParts.push(item);
            if (item.alternative && !_.isEmpty(item.alternative)) {
              item.alternative.forEach(function (altItem) {
                if(!_.includes(altItem.equivalentTypes, ListPieceConstants.types.motrio) && !_.includes(altItem.equivalentTypes, ListPieceConstants.types.valuePlus)){
                  _.assign(altItem, { itemGroup: partsArray.itemGroup, type: "PR", applicable: "Y" })   
                  vm.filteredParts.push(altItem);
                }
              })
            }
          })
        })

        vm.columnValuePr = [];

        _.map(vm.filteredParts, function (item) {
          vm.inputPrList = {}
          var catalogPlate = checkcatalogPlate(item.catalogPlates);
          _.extend(vm.inputPrList, {
            'validated': "",
            'type': item.type ? item.type : "",
            'itemGroup': item.itemGroup ? item.itemGroup : "",
            'genericPart': item.genericPart ? item.genericPart : "",
            'applicable':item.applicable ? item.applicable : "",
            'designation': item.designation ? item.designation.replace(',', '-'): "",
            'proposedReference': item.reference ? item.reference : "",
            'initialReference': item.initialReference ? item.initialReference : "",
            'sbomId': item.sbomId ? item.sbomId : "",
            'quantity': item.quantity ? item.quantity : "",
            'herculesCase': item.herculesCase ? item.herculesCase : "",
            'catalogPlates': catalogPlate && catalogPlate.id ? catalogPlate.id : "",
            'brand': item.brand ? item.brand : ""
          })
          vm.columnValuePr.push(vm.inputPrList);
        })
      }
      vm.headerTm = {};
      if (vm.initialInterventionDetails && vm.initialInterventionDetails.INT[0] && vm.initialInterventionDetails.INT[0].basketContent && vm.initialInterventionDetails.INT[0].basketContent.labourTimeItems) {
        vm.headerTm = listInterventionConstant.headerTm;
        vm.columnValueTm = [];
        _.map(vm.initialInterventionDetails.INT[0].basketContent.labourTimeItems, function (laborTimeArray) {
          vm.notApplicableArray =[];
          if(laborTimeArray && !_.isEmpty(laborTimeArray.notApplicableGieTms)){
          laborTimeArray.notApplicableGieTms.forEach(function(data){
            var notApplicableData = {};
            _.assign(notApplicableData, { itemGroup: laborTimeArray.itemGroup, type: "TM", gie:data, applicable: "N" })
            vm.notApplicableArray.push(notApplicableData); 
          })
        }
          _.map(vm.notApplicableArray, function (item) {
            vm.inputNonApplicability ={}
            _.extend(vm.inputNonApplicability, {
              'validated': "",
              'type': item.type ? item.type : "",
              'itemGroup': item.itemGroup ? item.itemGroup : "",
              'elementOpe':  "",
              'designation': "",
              'gieTm': item.gie ? item.gie : "",
              'applicable':item.applicable ? item.applicable : "",
              'opecod':  "",
              'duration':  "",
              'quantity':"",
              'essay': "",
              'precision':"",
              'Included':  "",
              'notIncluded':  "",
              'additionalTo': ""
            })
            vm.columnValueTm.push(vm.inputNonApplicability);
          })
          _.map(laborTimeArray.labourTimes, function (laborTime) {
            _.map(laborTime.value, function (item) {
              vm.inputTmList = {}
              var includedValue = [];
              var notIncludedValue = [];
              var elementOpeValue = (item.element ? item.element : "") + "_" + (item.operation ? item.operation : "");
              if (item.detail && item.detail.Included && !_.isEmpty(item.detail.Included)) {
                _.map(item.detail.Included, function (includedVal) {
                  var fullItem = (includedVal.gie ? includedVal.gie + "-" : "") + (includedVal.designation ? includedVal.designation : "")
                  includedValue.push(fullItem)
                })
              }
              if (item.detail && item.detail.NotIncluded && !_.isEmpty(item.detail.NotIncluded)) {
                _.map(item.detail.NotIncluded, function (notincludedVal) {
                  var notincludedValFull = (notincludedVal.gie ? notincludedVal.gie + "-" : "") + (notincludedVal.designation ? notincludedVal.designation : "")
                  notIncludedValue.push(notincludedValFull)
                })
              }
              var precisionValue = (item.characteristics && item.characteristics.additionalLabel ? item.characteristics.additionalLabel : "") +
                (item.characteristics && item.characteristics.elementPrecision ? item.characteristics.elementPrecision : "") +
                (item.characteristics && item.characteristics.quantity ? $translate.instant("TM_CHARACTERISTICS_QUANTITY") + ":" + item.characteristics.quantity : "") +
                (item.characteristics && item.characteristics.paintType ? $translate.instant("TM_CHARACTERISTICS_PAINTTYPE") + ":" + item.characteristics.paintType : "") +
                (item.characteristics && item.characteristics.paintClass ? $translate.instant("TM_CHARACTERISTICS_PAINTCLASS") + ":" + item.characteristics.paintClass : "")
              _.extend(vm.inputTmList, {
                'validated': "",
                'type': item.type ? item.type : "",
                'itemGroup': item.itemGroup ? item.itemGroup : "",
                'elementOpe': elementOpeValue ? elementOpeValue : "",
                'designation': item.designation ? item.designation : "",
                'gieTm': item.gie ? item.gie : "",
                'applicable':"Y",
                'opecod': item.id ? item.id : "",
                'duration': item.duration ? item.duration.replace(',', '.') : "",
                'quantity': item.quantity ? item.quantity : "",
                'essay': item.essay ? item.essay : "",
                'precision': precisionValue ? precisionValue : "",
                'Included': includedValue && !_.isEmpty(includedValue) ? (includedValue.toString()).split(',')
                  .join('/') : "",
                'notIncluded': notIncludedValue && !_.isEmpty(notIncludedValue) ? (notIncludedValue.toString()).split(',')
                  .join('/') : "",
                'additionalTo': item.AdditionalTo ? item.AdditionalTo : ""
              })
              vm.columnValueTm.push(vm.inputTmList);
            })
          })
        })
      }
    }
    function checkcatalogPlate(ref){ 
      var catalogPlate;
      if (ref && ref.length > 0) {
         catalogPlate=ref[0];
      }
      return catalogPlate;
  }
    function updateFromInput(part) {
      if (part.quantity >= 1) {
        part.hideTM = false;
      } 

    }
    function disableSwitch(responseArray,isDisable){
      if ((responseArray && responseArray.INT[0] && responseArray.INT[0].basketContent && responseArray.INT[0].basketContent.partsItems)) {
        responseArray.INT[0].basketContent.partsItems.forEach(function (pr) {
          if (pr.parts) {
            pr.parts.forEach(function (prData) {
              _.assign(prData, { toggleDisable: isDisable })
            })
          }
          if (pr.parts.alternative) {
            pr.parts.alternative.forEach(function (altData) {
              _.assign(altData, { toggleDisable: isDisable })
            })
          }
          if (pr.parts.additional) {
            pr.parts.additional.forEach(function (addData) {
              _.assign(addData, { toggleDisable: isDisable })
            })
          }
        });
      }
      if (responseArray && responseArray.INT[0] && responseArray.INT[0].basketContent && responseArray.INT[0].basketContent.labourTimeItems) {
        responseArray.INT[0].basketContent.labourTimeItems.forEach(function (item) {
          item.labourTimes.forEach(function (labour) {
            labour.value.forEach(function (val) {
              _.assign(val, { toggleDisable: isDisable })
            })
          })
        })
      }
    }
    function calculateFod(item) {
      item.fodCalculating = true;
      var enabledParts = [];
      vm.interventionDetails.INT[0].basketContent.partsItems.forEach(function (ref) {
        if(!_.isEmpty(ref.parts)){
          ref.parts.forEach(function(part){
            if(part.switchEnable && part.quantity > 0){
              enabledParts.push(part);
            }
          });
        }
      });
      if(!_.isEmpty(vm.interventionDetails.INT[0].basketContent.labourTimeItems)){
        var enabledTm = [];
        var labourTimeItems = vm.interventionDetails.INT[0].basketContent.labourTimeItems;
        if (labourTimeItems) {
            labourTimeItems.forEach(function (item) {
                if (item.labourTimes) {
                    item.labourTimes.forEach(function (tm) {
                        if (tm.value) { tm.value.forEach(function (v) { enabledTm.push(v); }); }
                    });
                }
            });
        }
        DmsMetierService.calculateFodEstimate(enabledParts, enabledTm).then(function(estimateResp){
          if(estimateResp && estimateResp.response && estimateResp.response.estimate){
            item.fodEstimateTotal = estimateResp.response.estimate;
          }
          item.fodCalculating = false;
        }, function(){
          item.fodCalculating = false;
        });
      } else {
        item.fodCalculating = false;
      }
    }
    function handleBulkAdd(item) {
      if (!(vm.prPopUp && vm.tmPopUp)) {
        prArrayCheck();
        tmArrayCheck();
        if (!item.bulkQuoteAdditionDone) {
          var quote = QuoteMetierService.getQuoteData();
          var interventionList = vm.interventionDetails.INT[0].basketContent.ingredients ? vm.interventionDetails.INT[0].basketContent.ingredients : null;
          var ingredientCount = !_.isNull(interventionList) ? interventionList.length : 0;
          var temp = [];
          vm.interventionDetails.INT[0].basketContent.partsItems.forEach(function (ref) {
            if (!_.isEmpty(ref.parts)) {
              temp = temp.concat(ref.parts);
            }
          });
          var prCount = temp.length ? temp.length : 0;
          if (quote && (quote.shoppingCart.PR.length >= 99 || quote.shoppingCart.PR.length + prCount + ingredientCount >= 99)) {
            toastr.error($translate.instant('MAX_LIMIT_REACHED_ERROR'));
            return;
          }
          if (quote && !vm.prPopUp && !vm.tmPopUp) {
            var action = ShoppingCartService.constants.ADD_OPERATIONS;
            var interventionItems = angular.copy(vm.interventionDetails);
            interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
            basketContentdisplay(interventionItems);
            QuoteMetierService.updateQuotePart(action, interventionItems);
            disableSwitch(vm.interventionDetails,true);
            return;
          } else {
            $q.resolve().then(function () {
              var body = angular.element(document.body);
              var modalParams = {
                body: body,
                typeOfSuperCart: globalConstant.quote,
                title: "NEW_ESTIMATE",
                subtitle: "ESTIMATE_NO_ACTIVE_DRAFT",
                isEasyBasket: true,
                isEasyBasketHeader: "EASY_BASKET_HEADER",
                isEasyBasketFooter: "EASY_BASKET_FOOTER",
                prYesButton: "PR_POPUP_YESBUTTON",
                tmYesButton: "TM_POPUP_YESBUTTON",
                prPopupHeader: "PR_POPUP_HEADER",
                tmPopupHeader: "TM_POPUP_HEADER",
                prPopUp: vm.prPopUp,
                tmPopUp: vm.tmPopUp,
                showList: !quote ? true : false,
                showActifPartRequisition: false
              }
              return listOfDraftModalService.showModal(modalParams).then(function (superCartId) {
                if (quote) {
                  var action = ShoppingCartService.constants.ADD_OPERATIONS;
                  var interventionItems = angular.copy(vm.interventionDetails);
                  interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
                  basketContentdisplay(interventionItems);
                  QuoteMetierService.updateQuotePart(action, interventionItems);
                  return;
                }
                else {
                  var promise = null;
                  if (superCartId.item) {
                    promise = QuoteMetierService.findAndSetCurrentQuote(superCartId.item);
                  } else {
                    promise = QuoteMetierService.instanciateNewQuote();
                  }
                  return promise;
                }
              });
            }).then(function () {
              var action = ShoppingCartService.constants.ADD_OPERATIONS;
              var interventionItems = angular.copy(vm.interventionDetails);
              interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
              basketContentdisplay(interventionItems);
              QuoteMetierService.updateQuotePart(action, interventionItems);
            })
          }
        }
      }
    }
    function goToQuote() {
      var quoteData = QuoteMetierService.getQuoteData();
      if (!_.isEmpty(quoteData)) {
        $mdDialog.hide();
        $state.go(RoutesConstants.dmsQuote);
      }
    }
    function goToBasket() {
      var profil = CacheService.getObject(CacheConstants.profil);
      var panier = CacheService.getObject(CacheConstants.panier);
      if (profil && !profil.dmsConnected) {
          if (!panier) {
              CacheService.setObject(CacheConstants.panier, []);
          }
          var interventionIdList = CacheService.getObject(CacheConstants.interventionIdList);
          if(interventionIdList && _.has(interventionIdList, 'isIntClick')){
            interventionIdList.isIntClick = true;
            CacheService.setObject(CacheConstants.interventionIdList, interventionIdList);
          }
          $mdDialog.hide();
          $state.go(RoutesConstants.panier);
      }
  }

    function handleFirstAdd(item) {
      vm.getItemCount = 0;
      if (!(vm.prPopUp && vm.tmPopUp)) {
        prArrayCheck();
        tmArrayCheck();
        if (!item.bulkAdditionDone) {
          var body = angular.element(document.body);
          var modalParams = {
            body: body,
            title: "DOCUMENT_PR_INCREASE_BASKET",
            isEasyBasket: true,
            isEasyBasketHeader: "EASY_BASKET_HEADER_BASKET",
            isEasyBasketFooter: "EASY_BASKET_FOOTER_BASKET",
            prYesButton: "PR_POPUP_YESBUTTON",
            tmYesButton: "TM_POPUP_YESBUTTON",
            prPopupHeader: "PR_POPUP_HEADER",
            tmPopupHeader: "TM_POPUP_HEADER",
            showList: true,
            showActifPartRequisition: false,
            prPopUp: vm.prPopUp,
            tmPopUp: vm.tmPopUp
          }

          return listOfDraftModalService.showModal(modalParams).then(function () {
            var action = ShoppingCartService.constants.ADD_OPERATIONS;
            var interventionItems = angular.copy(vm.interventionDetails);
            interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
            basketContentdisplay(interventionItems);
            ShoppingCartService.updateShoppingCart(action, interventionItems).then(function () {
              ShoppingCartService.onUpdateCart().then(function (response) {
                if (response) {
                  vm.bulkAdditionDone = response
                  vm.flattenCart = ShoppingCartService.getShoppingCart();
                  vm.cartMetadata = ShoppingCartService.getCartMedatadata();
                  if(!_.isEmpty(vm.flattenCart)){
                    _.remove(vm.flattenCart, { quantity: 0 });
                }
                  vm.getItemCount = vm.flattenCart.length;
                  angular.forEach(vm.interventionList, function (list) {
                    angular.forEach(vm.interventionDetails.INT, function (item) {
                      if (list.id === item.id) {
                        list.bulkAdditionDone = true;
                      }
                    disableSwitch(vm.interventionDetails,true);
                    })

                  })
                }
              })
            })
          });
        }
      }
    }



    function getProcessedPRTM(interventionItems,partTemp) {
      partTemp.forEach(function(list){
        if(list.id)
        delete list.id;
      })
      var tempPartsArr = [];
      var origPart = [];
      if (!_.isEmpty(interventionItems.INT[0].basketContent.partsItems)) {
        interventionItems.INT[0].basketContent.partsItems.forEach(function (item) {
          if (!_.isEmpty(item.parts)) {
            item.parts.forEach(function(data){
              if (data.switchEnable) {
                tempPartsArr.push(data)
              }
              if (!_.isEmpty(data.alternative)) {
                var filteredAltPart = _.filter(data.alternative, function (alt) {
                  return alt.switchEnable
                })
                if (!_.isEmpty(filteredAltPart) && filteredAltPart[0].quantity != 0) {
                  tempPartsArr.push(filteredAltPart[0])
                }
              }
              if (!_.isEmpty(data.additional)) {
                var filteredAddPart = _.filter(data.additional, function (add) {
                  return add.switchEnable;
                })
                if (!_.isEmpty(filteredAddPart) && filteredAddPart[0].quantity != 0) {
                  tempPartsArr.push(filteredAddPart[0]);
                }
              }
            });
          }
        });
      }
      interventionItems.INT[0].basketContent.parts = angular.copy(tempPartsArr);
      var temp = [];
      vm.interventionDetails.INT[0].basketContent.labourTimes = [];
      if (vm.interventionDetails.INT[0].basketContent.labourTimeItems.length > 0){
        vm.interventionDetails.INT[0].basketContent.labourTimeItems.forEach(function (item){
          if(item.labourTimes && item.labourTimes.length > 0){
            item.labourTimes.forEach(function(list){
              if (list.value.length > 0){
                list.value.forEach(function (listItem){
                  if (listItem.toggleTM){
                    listItem.reference = listItem.reference ? listItem.reference : listItem.technicalId;
                    vm.interventionDetails.INT[0].basketContent.labourTimes.push(listItem);
                  }
                })
              }
            })
          }
        })
        interventionItems.INT[0].basketContent.labourTimes = vm.interventionDetails.INT[0].basketContent.labourTimes;
      }
      if (!_.isEmpty(interventionItems.INT[0].basketContent.parts)) {
        interventionItems.INT[0].basketContent.parts.forEach(function (item) {
          if (item.reference && item.quantity != 0) {
            origPart.push(item.reference);
          }

        }

        )
        vm.partTemp = partTemp.filter(function (item) {
          if (!_.isEmpty(origPart)) {
            return origPart.some(function (reference) {
              return item.reference === reference;
            });
          }
        });

      };
      return interventionItems;
    }

      function interventionDeletePayload(payload) {
          var tmList = payload.INT[0].basketContent.labourTimes ? payload.INT[0].basketContent.labourTimes : [];
          var partList = payload.INT[0].basketContent.parts ? payload.INT[0].basketContent.parts : [];
          var ingredientList = payload.INT[0].basketContent.ingredients ? payload.INT[0].basketContent.ingredients : [];
          var interventionList = tmList.concat(partList, ingredientList);
          var referenceList = [];
          if (!_.isEmpty(interventionList)) {
              interventionList.forEach(function (item) {
                  var reference = _.get(item, 'reference');
                  referenceList.push(reference);
              })
          }
          return referenceList;
      }

    function bulkBasketDelete(basketData) {
      var interventionIds = [];
      if (!vm.isDmsProfile) {
        if (vm.bulkAdditionDone && vm.bulkAdditionDone.items) {
          _.filter(vm.bulkAdditionDone.items, function (item) {
            if (item.interventionId == basketData.id) {
              interventionIds.push(item.interventionId);
            }
          });
        }
        interventionIds = _.uniq(interventionIds);
        blockUI.start();
        var interventionItems = angular.copy(vm.interventionDetails);
        interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
        var payload = {
            references: interventionDeletePayload(interventionItems)
        };
        ShoppingCartService.deleteIntervention(interventionIds, payload).then(function (response) {
          if (response) {
            /* to be deleted and handled in DB*/
            if(!_.isEmpty(vm.interventionList) && !_.isEmpty(response.items)){
              vm.interventionList.forEach(function(item){
                response.items.forEach(function(respItem){
                  if(respItem.interventionId == item.id){
                    _.assign(respItem,{interventionQuantity:item.interventionQuantity})
                  }
                disableSwitch(vm.interventionDetails,false);
                  if(respItem.type == 'PR'){
                    _.assign(respItem,{'priceHT':respItem.price});
                  } else {
                    _.assign(respItem,{duration:respItem.laborTime.toString().replace('.',',')});
                  }
                })
              })
            }
            /**/
            vm.flattenCart = [];
            ShoppingCartService.setShoppingCart(response.items);
            vm.flattenCart = ShoppingCartService.getShoppingCart().filter(function (item) {
              return item.quantity > 0;
            });
            vm.getItemCount = ShoppingCartService.getShoppingCart().filter(function (item) {
              return item.quantity > 0;
            }).length;
            ShoppingCartService.emitCartUpdated();
            basketData.bulkAdditionDone = false;
          }
        }).catch(handleError).finally(function () {
            blockUI.stop();
        })
      } else {
        if (vm.bulkQuoteAdditionDone && !_.isEmpty(vm.bulkQuoteAdditionDone.items)) {
          _.filter(vm.bulkQuoteAdditionDone.items, function (item) {
            if (item.interventionId == basketData.id) {
              interventionIds.push(item.interventionId);
            }
          });
        }
        interventionIds = _.uniq(interventionIds);
          blockUI.start();
          var interventionItems = angular.copy(vm.interventionDetails);
          interventionItems = getProcessedPRTM(interventionItems,vm.partTemp);
          var payload = {
              references: interventionDeletePayload(interventionItems)
          };
          QuoteMetierService.deleteQuoteIntervention(vm.bulkQuoteAdditionDone.id, interventionIds, payload).then(function (response) {
          // intervention quantity to be added for each item
          if (response) { 
            disableSwitch(vm.interventionDetails,false);
            basketData.bulkQuoteAdditionDone = false;
          }
        }).catch(handleError).finally(function () {
            blockUI.stop();
        })

      }
    }
    function handleError() {
      var msgError = $translate.instant("ERROR");
      toastr.error(msgError);
    }

    function goToProduct(parts) {
      var path = {
        reference: parts.reference,
        mainReference: parts.initialReference
      };

      RoutingService.goToProductPage({
        path: path
      });
      $mdDialog.hide();
    }

    function goToProductPage(ref) {
      $state.go(RoutesConstants.product, { reference: ref })

    }

    function checkSuperseding(ref, index, response) {

      if (!ref)
        return $q.resolve();

      if (!ref.priceExclTaxes && ref.superSessionDetails.length > 0 && ref.supersedingList.length > 0) {
        var count = 0;
          for (var i = ref.supersedingList.length - 1; i >= 0; i--) {
            count++;
            for (var j = 0; j < ref.superSessionDetails.length; j++) {
              if (ref.superSessionDetails[j].reference == ref.supersedingList[i] && ref.superSessionDetails[j].priceExclTaxes) {
                  ref.superSessionDetails[j].replacement = true;
                  if (ref.superSessionDetails[j].initialReference == null) {
                    ref.superSessionDetails[j].initialReference = ref.superSessionDetails[j].reference;
                  }
                  ref.superSessionDetails[j].alternative = ref.alternative;
                  ref.superSessionDetails[j].herculesCase = ref.herculesCase;
                  ref.superSessionDetails[j].herculesProposal = ref.herculesProposal;
                  ref.superSessionDetails[j].itemGroup = ref.itemGroup;
                  response.splice(index, 1, ref.superSessionDetails[j]);
                  // return;
                  return $q.resolve(ref);
              }
            }
          }
          if(count === ref.supersedingList.length){
            return $q.resolve(ref);
          }
      }
      else{
        return $q.resolve(ref);
      }
    }

    function gotoCatalogPlate(part,index,data,valData){

      var plateid = checkCatalogPlateId(part);
      part.catalogPlateClick = true;
      if(plateid != '-'){
        var tempPRArray = _.map(valData, 'parts');
        var tempMergedArr = [];
        tempPRArray.forEach(function(item){
          if(!_.isEmpty(item)){
            tempMergedArr = tempMergedArr.concat(item);
          }
        })
        var newPartList = [];
        if(!_.isEmpty(tempMergedArr)){
          tempMergedArr.forEach(function(dat){
            var catPlateList = _.map(dat.catalogPlates,'id');
            if(plateid.includes(catPlateList[0])){
              newPartList.push(dat.reference);
            }
          })
        }
        newPartList = _.uniq(newPartList);
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: 'app/components/car/carSearchResult/easyBasket/catalogPlate.template.html',
          controller: 'ListePieceCtrl',
          bindToController: true,
          controllerAs: 'vm',
          clickOutsideToClose: true,
          size: 'lg',
          skipHide: true,
          multiple: true,
          windowClass: 'my-modal-popup',
          locals: {
              plateId: plateid,
              selectedReference: part.reference
          },
          resolve: {
                disconnect: function () {
                  $timeout(function () {
                    $rootScope.$broadcast('phx-init-listPR', plateid, part.reference,newPartList, part);
                }, 300)
                }
              }
        });
        
      }
      
    }

    function openAlertsPopin(checkDocType) {
      if(!vm.isModal){
        var nodeInfo = CacheService.getObject(CacheConstants.nodeFromSearchArbo);
        vm.intTitle = nodeInfo.label;
        vm.nodeId = nodeInfo.nodeId;
      }
      var data = {
        title : vm.intTitle,
        nodeId : vm.nodeId,
        intId : vm.interventionDetails.INT[0].id,
        intDesignation : vm.interventionDetails.INT[0].designation,
      }
      AlertsService.setPopinVisibility(true, checkDocType, data,vm.isTraceEnabled);
      if (AlertsService.getPopinVisibility().status == true) {
        changeLinkColor("#TM_DOCUMENTARY_ERROR");
      }
      
  }
  function close() {
      $mdDialog.cancel();
  }
  function onOk(){
      $mdDialog.hide();
       }
  function changeLinkColor(id) {
      $(id).css({
          'color': '#666666'
      });
  }

    function captureScreenshot() {
      blockUI.start();
      var node = document.body;

      html2canvas(node, {
        height: node.scrollHeight,
        width: node.scrollWidth,
      }).then(function (canvas) {
        vm.capturedImage = canvas.toDataURL();
        blockUI.stop();
        const body = angular.element(document.body);
        $mdDialog.show({
          parent: vm.isModal ? document.getElementsByClassName('md-dialog-container') : body,
          templateUrl: 'app/components/alerts/modal/screenShotModel/captureScreenshot.html',
          controller: 'captureScreenshotController',
          bindToController: true,
          controllerAs: 'vm',
          size: 'lg',
          skipHide: 'true',
          multiple: 'true',
          locals: {
            capturedImage: vm.capturedImage
          }
        });
      }).catch(function (error) {
        console.log("Error in htmlcanvas (listInterventionController):" + error);
      });

    }

    $scope.$on("$destroy", function () {
      AlertsService.setScreenshotButtonVisibility(false);
    });

    function goToProductNewPage(partNumber,tabToRedirect) {       
      if(!_.isEmpty(partNumber.supersedingList) && tabToRedirect ){
        vm.currentIndexPlate = 0;
        angular.element(function () {
          _.extend(partNumber, UtilsMetierService.extendPathWithTabToRedirect(tabToRedirect));
          var url = $state.href(RoutesConstants.product,{tab: partNumber.tab, reference: partNumber.reference, mainReference: partNumber.initialReference, refIndex: partNumber.index, plateIndex: vm.currentIndexPlate}); 
          $window.open(url, '_blank');
        });
      }
      else{
        var url = $state.href(RoutesConstants.product,{ reference: partNumber.reference,mainReference : partNumber.initialReference});      
        var openedWindow = $window.open(url, '_blank');
        openedWindow.onload  = function(){
            var channel = new BroadcastChannel("isFromDocPriv");
            channel.postMessage(true);
        }
      }  
    }

    function copyToClipboard(reference) {
      UtilsMetierService.copyToClipboard(reference)
    }

    function availableIconClick(){
      if (vm.activeButton == 'active') {
        vm.activeButton = null;
      }
      else {
        vm.activeButton = 'active';
      }
      var payload = {
        docId: vm.initialInterventionDetails.INT[0].id,
        docType: 'INT',
        isLiked: vm.activeButton == null ? null : true
      };
      SearchArboTextualMetierService.getBasketVotes(payload).then(function (response) {
        vm.availableCount = response.like;
        vm.unavailableCount = response.disLike;
        vm.activeButton = vm.activeButton == null ? null : 'active';
      }).catch(function () {
        toastr.error($translate.instant("ERROR"));
      });
    }

    function unavailableIconClick(){      
      if (vm.activeButton == 'inactive') {
        vm.activeButton = null;
      }
      else {
        vm.activeButton = 'inactive';
      }

      var payload = {
        docId: vm.initialInterventionDetails.INT[0].id,
        docType: 'INT',
        isLiked: vm.activeButton == null ? null : false
      };
      SearchArboTextualMetierService.getBasketVotes(payload).then(function (response) {
        vm.unavailableCount = response.disLike;
        vm.availableCount = response.like;
        vm.activeButton = vm.activeButton == null ? null : 'inactive';
        if(vm.activeButton=='inactive'){
          vm.openAlertsPopin('INT');
        }
        
      }).catch(function () {
        toastr.error($translate.instant("ERROR"));
      });      
    }

    function basketContentdisplay(interventionItems){
      if (interventionItems.hasOwnProperty('INT') && Array.isArray(interventionItems.INT)) {
        interventionItems.INT.forEach(function(intObj ){
            if (intObj.hasOwnProperty('basketContent') && intObj.basketContent.hasOwnProperty('parts') && Array.isArray(vm.partTemp)) {

                intObj.basketContent.parts = intObj.basketContent.parts.concat(vm.partTemp);
            }
        });
    }
   
    }
  }

})();


angular.module('phenix').constant('listInterventionConstant', {
  headerPr:{
    'validated':"Validated",
    'type':"Type",
    'itemGroup': "Item Group",
    'genericPart': "Generic Part",
    'applicable': "Applicable",
    'designation':"Designation Proposed Reference",
    'proposedReference': "Proposed Reference",
    'initialReference':"Initial Reference",
    'sbomId': "SbomId",
    'quantity':"Quantity",
    'herculesCase': "Hercules Case",
    'catalogPlates':"Catalog Plates",
    'brand': "Brand"
  },
  headerTm: {   
        'validated':"Validated",
        'type':"Type",
        'itemGroup': "Item Group",
        'elementOpe': "Element-ope",
        'designation':"Designation",
        'gieTm': "Gietm",
        'applicable': "Applicable",
        'opecod':"Opecod",
        'duration': "Duration",
        'quantity':"Quantity",
        'essay': "Essay",
        'precision':"Precision",
        'Included': "Included",
        'notIncluded': "Not Included",
        'additionalTo': "Additional To"
  }

});

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive("csvDownload", function ($log) {
            return {
                restrict: "A",
                scope: { 
                    columnHeader: "=", 
                    inputArray: "=", 
                    details: "=", 
                    isIntervention: "=",
                    onComplete: "&" 
                },
                link: function (scope, element) {
                    var getHeader = function () {
                            if (scope.columnHeader) return scope.columnHeader;
                            scope.columnHeader = [];
                           
                            for (var i in scope.inputArray) {
                                var keys = Object.keys(scope.inputArray[i]);
                                for (var j in keys) {
                                    var key = keys[j];
                                    scope.columnHeader[key] = key;
                                }
                            }
                            return scope.columnHeader;
                        },
                        convertArrayOfObjectsToCSV = function () {
                            var result,
                                ctr,
                                keys,
                                columnDelimiter,
                                lineDelimiter,
                                header = getHeader() || null;
                            return null === header
                                ? null
                                : ((columnDelimiter = ";"),
                                  (lineDelimiter = "\n"),
                                  (keys = Object.keys(header)),
                                  (result = ""),
                                  scope.details ? scope.details.forEach(function(value){
                                    var intervention = value;
                                    void 0 === intervention && (intervention = ""), (result += '"' + intervention + '"' + lineDelimiter);
                                   
                                  }) : '',     
                                  result += scope.isIntervention ? "\n\n" : "",
                                  keys.forEach(function (key) {
                                      var dataVal = header[key];
                                  
                                      void 0 === dataVal && (dataVal = ""), (result += '"' + dataVal + '"' + columnDelimiter);
                                   
                                  }),
                                  (result += lineDelimiter),

                                  scope.inputArray.forEach(function (item) {
                                      (ctr = 0),
                                          keys.forEach(function (key) {
                                              ctr > 0 && (result += columnDelimiter);
                                              var dataVal = item[key];
                                              void 0 === dataVal && (dataVal = ""), (result += '"' + dataVal + '"'), ctr++;
                                          }),
                                          (result += lineDelimiter);
                                  }),
                                  result);
                        },
                       
                        generateCSVLink = function () {
                            var universalBOM = "\uFEFF";
                            var csv = convertArrayOfObjectsToCSV();
                            if (null !== csv) {
                                csv.match(/^data:text\/csv/i) || (csv = "data:text/csv;charset=utf-8," + (universalBOM + csv));
                                element[0].href = encodeURI(csv);
                                scope.onComplete();
                            }
                        };
                    element.on('click', generateCSVLink);
                },
            };  
        })
})();
(function () {
    angular.module("phenix").constant("dataMocked", {
        carContext: {
            vin: "VF1CNBA0544210258",
            registrationNumber: "BD424XX",
            millesim: "20060",
            fixedCriterias: {
                "106": "CCHBAM",
                "116": "AIRBA1",
                "120": "SERIE",
                "121": "DRA",
                "122": "DRAP10",
                "123": "HARM04",
                "126": "ATAV01",
                "127": "ATAR",
                "130": "SGAV02",
                "133": "SGAR02",
                "141": "TED69",
                "143": "BANAL",
                "146": "KM",
                "164": "SAN164",
                "166": "SCTMOT",
                "224": "SSDECA",
                "242": "SSBAC",
                "253": "SABLAV",
                "257": "SSESP",
                "263": "SRDPRO",
                "264": "SALEVA",
                "270": "SSPTPR",
                "271": "SOP03C",
                "272": "SPRGAZ",
                "294": "VLMOUS",
                "302": "RETC",
                "306": "LVAVEL",
                "312": "RSEC01",
                "317": "SGSCHA",
                "336": "APL03",
                "341": "SAILAR",
                "343": "SRUNLI",
                "346": "PLAT03",
                "425": "RAD01A",
                "427": "BVM5",
                "430": "SSCPKS",
                "456": "SSABAR",
                "497": "RNORM",
                "503": "PRLOO1",
                "511": "ISOFIX",
                "513": "SAN513",
                "521": "SNSTAP",
                "527": "SANFLT",
                "537": "SANACF",
                "555": "TLFRAN",
                "566": "SPRODI",
                "577": "SAN577",
                "578": "SAN578",
                "579": "SAN579",
                "580": "SAN580",
                "581": "SAN581",
                "582": "SAN582",
                "583": "SAN583",
                "584": "SAN584",
                "585": "SAN585",
                "586": "SAN586",
                "587": "SAN587",
                "588": "SAN588",
                "589": "SAN589",
                "590": "SAN590",
                "591": "SAN591",
                "592": "SAN592",
                "593": "SAN593",
                "613": "SAN613",
                "618": "SACEXT",
                "650": "SINCTQ",
                "715": "VNOR",
                "773": "SSAPEX",
                "778": "PRUPT",
                "800": "CEE1",
                "801": "E04A",
                "808": "BCTC",
                "882": "SSTRGL",
                "900": "PE2006",
                "901": "PHAS1",
                "913": "SAN913",
                "970": "VEC456",
                "971": "X441BI",
                "996": "525",
                "997": "JB1",
                "998": "772",
                "999": "D4F",
                "58C": "SAN58C",
                "58E": "SAN58E",
                "58G": "SAN58G",
                F20: "SANF20",
                F22: "SANF22",
                "58J": "SAN58J",
                "58L": "SAN58L",
                "071": "EVC",
                "58N": "SAN58N",
                "074": "CPETIR",
                "58Q": "SAN58Q",
                "078": "RET07",
                "58Y": "SAN58Y",
                "082": "PROJAB",
                "087": "RTOL14",
                "089": "SANCUS",
                "002": "STANDA",
                "007": "X44",
                "008": "C44",
                "095": "SANCL",
                "013": "EZ3",
                "018": "MA",
                "019": "ESS",
                "026": "FRAN",
                "027": "DG",
                "029": "TEMP",
                "038": "DA",
                "039": "AFURGE",
                D30: "SSTRFV",
                A55: "CDVOL1",
                "040": "SSRV",
                "042": "ABS",
                APV001: "APV001_Y",
                APV002: "APV002_F",
                "046": "CHAUFO",
                APV003: "APV003_S",
                F02: "SANF02",
                D48: "PREM02",
                F04: "SANF04",
                "050": "TN",
                F06: "SANF06",
                F08: "SANF08",
                "059": "VITLAR",
                F10: "SANF10",
                D58: "SAND58",
                F14: "SANF14",
                F18: "SANF18",
                "067": "SPRTEL",
                "58A": "SAN58A"
            },
            variableCriterias: {
                APVDT1: "2010-09-16",
                APVNM1: "Y492888",
                APVNM2: "F255489",
                APVNM3: "S170247"
            },
            contextBLMS: { dataCrit: {}, dataCritVar: {} },
            tapv: "CN0A",
            families: {
                familyEngine: ["DXX"],
                familyBattery: [""],
                familyVehicle: ["X44"],
                familyGearbox: ["JBX"]
            },
            extraFamilies: {
                "007G": "JBX",
                "007E": "DXX",
                "007V": "X44",
                "007B": ""
            },
            brandComputed: "APL03",
            ageComputed: 7,
            typeMD: "B2",
            bvmExtraFields: {
                marqCom: "RENAULT",
                ligne3P12: "TED69  DRAP10 HARM04",
                ligne4P12: "TLFRAN LCFV   YA2A",
                marqCon: "RENAULT",
                calibrInj: "SOF1109586",
                refBoi: "7701723426",
                marqDis: "RENAULT",
                refInj: "8200774747",
                ligne2P12: "EZ3    SAN913 SAN513",
                paysImmat: "FR",
                refMot: "8200855984",
                abgCalc: "1024500876",
                marqFab: "RENAULT"
            },
            model: "Twingo II (C44)",
            urlImage:
                "https://cdn-dev.asdh.aws.renault.com/carStickers/twingo2.png",
            color: "TED69",
            colorCode: "TED69",
            motorisation: "MOTEUR D4F",
            gearboxType: "BOITE MECA 5 RAPP. JB1"
        },
        DMSVehicle: {
            payCash: true,
            isKnown: false,
            ordersAndSplits: {
                orderNumber: "",
                orderNumbers: ["376649", "376653"],
                openOrderFlag: 2,
                isSplittingRequired: false,
                team: "",
                defaultSplitFlag: 0
            },
            accountNumber: "20999",
            customer: {
                city: "PARIS",
                mainPhone: "0154678790",
                title: "M",
                bisTer: "",
                commercialAgreement: false,
                poCity: "",
                streetName: "RUE SUGER",
                faxAgreement: false,
                preferredMedia: 0,
                countryCode: "FR",
                fax: "",
                email: "",
                phoneAgreement: false,
                dmsCustomerId: "20999",
                poBoxNumber: "",
                address3: "",
                streetNumber: "10",
                address2: "",
                address1: "",
                provinceCode: "",
                message: "",
                emailAgreement: false,
                firstName: "HUGO",
                roadType: "",
                postAgreement: false,
                poPostCode: "",
                mobilePhone: "0676227948",
                smsAgreement: false,
                name: "DI CESARE",
                postCode: "75006",
                workPhone: ""
            },
            vehicle: {
                bodyType: "",
                engineNumber: "",
                paintType: "O",
                engineType: "D4F",
                body: "",
                fabricationNumber: "Y492888",
                version: "",
                afterSalesType: "CN0A",
                gearBoxType: "JB1",
                energyType: "0",
                fiscalPower: "00",
                batteryId2: "",
                registrationNumber: "",
                batteryId1: "",
                vin: "VF1CNBA0544210258",
                model: "",
                colorCode: "",
                deliveryDate: "20101221",
                brand: "REN",
                gearBoxNumber: "S170247",
                mileage: 1000
            }
        },
        carSearchContext: {
            vehicle: {
                displayMotrio: true,
                vin: "VF1CNBA0544210258",
                registrationNumber: "BD424XX",
                model: "Twingo II (C44)",
                color: "TED69",
                motorisation: "MOTEUR D4F",
                millesim: "20060",
                categories: [],
                searchTypeByOR: false,
                isGemStopped: false,
                family: "",
                engineSuffix: "772",
                gearboxSuffix: "525",
                steeringWheelLocation: "DG",
                vehiculeVersion: "EZ3",
                equipmentLevel: "SAN513",
                heatingSystem: "CHAUFO",
                gearBoxType: "JB1",
                gas: "ESS",
                pr: [],
                mr: [],
                md: [],
                nt: [],
                urlImage:
                    "https://cdn-dev.asdh.aws.renault.com/carStickers/twingo2.png",
                contextBlms: {},
                tapv: "CN0A",
                typeMD: "B2",
                mileAge: 1000
            },
            isKnown: false,
            payCash: true,
            ordersAndSplits: {
                team: "",
                openOrderFlag: 2,
                isSplittingRequired: false,
                defaultSplitFlag: 0,
                orderNumber: "",
                orderNumbers: ["376649", "376653"]
            },
            team: "",
            searchTypeByOR: false,
            accountNumber: "20999",
            customer: {
                city: "PARIS",
                mainPhone: "0154678790",
                title: "M",
                bisTer: "",
                commercialAgreement: false,
                poCity: "",
                streetName: "RUE SUGER",
                faxAgreement: false,
                preferredMedia: 0,
                countryCode: "FR",
                fax: "",
                email: "",
                phoneAgreement: false,
                dmsCustomerId: "20999",
                poBoxNumber: "",
                address3: "",
                streetNumber: "10",
                address2: "",
                address1: "",
                provinceCode: "",
                message: "",
                emailAgreement: false,
                firstName: "HUGO",
                roadType: "",
                postAgreement: false,
                poPostCode: "",
                mobilePhone: "0676227948",
                smsAgreement: false,
                name: "DI CESARE",
                postCode: "75006",
                workPhone: ""
            },
            treeNodes: {
                levelOne: {
                    nodes: [
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21347",
                            label: "Entretien courant",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 1,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21947.svg",
                            nodeId: "N-21947",
                            label: "Moteur et périphérie",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21947.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 2,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-22009.svg",
                            nodeId: "N-22009",
                            label: "Embrayage - Boîte - Transmission",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-22009.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 3,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21921.svg",
                            nodeId: "N-21921",
                            label: "Liaison au sol",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21921.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 4,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21871.svg",
                            nodeId: "N-21871",
                            label: "Chauffage - Climatisation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21871.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 5,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21581_X44.svg",
                            nodeId: "N-21581",
                            label: "Carrosserie - Ouvrants - Vitrage",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21581_X44.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 6,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21643_X44.svg",
                            nodeId: "N-21643",
                            label:
                                "Eclairage extérieur - Visibilité - Signalisation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21643_X44.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 7,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21657.svg",
                            nodeId: "N-21657",
                            label: "Habitacle - Sellerie - Coffre",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21657.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 8,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21883.svg",
                            nodeId: "N-21883",
                            label: "Instrumentation",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21883.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 9,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView:
                                "https://cdn-dev.asdh.aws.renault.com/nodesComputed/N-21901.svg",
                            nodeId: "N-21901",
                            label: "Câblage et Gestion électrique",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                TM_STANDARD: 0,
                                TM_OTS: 0,
                                TM_DMS: 0,
                                TM_DMS_OTS: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 1,
                                MD_101: 0,
                                MD_102: 0,
                                MD_104: 0,
                                MD_106: 0,
                                MD_109: 0,
                                MD_108: 0,
                                MD_110: 0,
                                MD_111: 0,
                                MD_501: 0,
                                MD_502: 0,
                                MD_B2: 0
                            },
                            idsDocumentsByType: {
                                PR: [""],
                                TM: [""],
                                TM_STANDARD: [""],
                                TM_OTS: [""],
                                TM_DMS: [""],
                                TM_DMS_OTS: [""],
                                MR: [""],
                                BT: [""],
                                MD: [""],
                                PRODUCTS: [""],
                                NI: ["N-21901.svg"],
                                MD_101: [""],
                                MD_102: [""],
                                MD_104: [""],
                                MD_106: [""],
                                MD_109: [""],
                                MD_108: [""],
                                MD_110: [""],
                                MD_111: [""],
                                MD_501: [""],
                                MD_502: [""],
                                MD_B2: [""]
                            },
                            level: 1,
                            rang: 10,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21493",
                            label: "Généralités",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 11,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21397",
                            label: "Accessoires - Produits dérivés",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 12,
                            codeParent: "ROOT",
                            childNodes: null
                        },
                        {
                            urlVignette: null,
                            urlExplodedView: null,
                            nodeId: "N-21446",
                            label:
                                "Matériel - Outillage - Consommables - Peinture",
                            documents: true,
                            nbrDocumentsByType: {
                                PR: 0,
                                TM: 0,
                                MR: 0,
                                BT: 0,
                                MD: 0,
                                PRODUCTS: 0,
                                NI: 0
                            },
                            idsDocumentsByType: null,
                            level: 1,
                            rang: 13,
                            codeParent: "ROOT",
                            childNodes: null
                        }
                    ]
                }
            }
        },
        profile: {
            dmsConfig: {
                dmsLoginRequired: null,
                userDmsId: null,
                ipAddress: null,
                networkProfile: "WORKSHOP",
                workshopPartshopId: "903nay0001",
                url: "https://Kheops-re7.dms.dcs2.renault.com:8463/DMSGateway/rest/",
                stocks: null
            },
            lastName: "fr_admin_corporate",
            country: "FR",
            documentationSecondLanguage: {
                code: "en",
                countryCode: "GB",
                active: true,
                label: "English"
            },
            roles: ["PPX_CORPORATE_USER"],
            language: "fr",
            rolesActis: [],
            activeNotification: false,
            password: null,
            documentationFirstLanguage: {
                code: "fr",
                countryCode: "FR",
                active: true,
                label: "French"
            },
            roleActive: null,
            distanceMeasure: null,
            portal: {
                code: "fr",
                countryCode: "FR",
                active: true,
                label: "French"
            },
            dealerName: "testDealerName",
            ipn: "FR11111118",
            dealerId: "testdealer",
            costCenter: null,
            profiles: ["Reseau_et_importateur"],
            manageDealerFavourites: false,
            userId: "FR",
            firstName: "admin_corporate",
            dmsConnected: null,
            emailAlerte: null,
            isManageDealer: null,
            userType: "RNET",
            isHTLCountry: true,
            dealerLogisticIds: "rejected"
        },
        dmsOrderResponseWithAwaitingOrder: {
            defaultSplitFlag: 2,
            orderNumber: 376657
        },
        dmsOrderResponseWithoutAwaitingOrder: {
            defaultSplitFlag: 0,
            orderNumber: 376657
        }

    });
})();

(function () {
    'use strict';
    angular.module('phenix').service('CarSearchWsService', CarSearchWsService);

    function CarSearchWsService(
        $q,
        CarSearchConstants,
        errorsConstant,
        CacheConstants,
        $log,
        $filter,
        toastr,
        RestLSR,
        RestUpgradeLSR,
        $translate,
        rLinkConstant,RestUpgrade,RestUpgradeRLink,
        RestRLink,CacheService,configConstantes
    ) {
        var isHerculeCorrection = JSON.parse(configConstantes.isHerculeCorrection);
        this.carSearchImatWsBack = carSearchImatWsBack;
        this.carSearchByVin = carSearchByVin;
        this.carSearchByModel = carSearchByModel;
        this.historizationVehicleSaveWs = historizationVehicleSaveWs;
        this.historizationVehicleLoadWs = historizationVehicleLoadWs;
        this.getVehicleTreeFilter = getVehicleTreeFilter;
        this.getVehicleTapvmbFilter = getVehicleTapvmbFilter;
        this.getVehicleLexiqueFilter = getVehicleLexiqueFilter;
        this.getGemStopped = getGemStopped;
        //service de recherche modele vehicule: vignette et designation ccial
        this.carSearchWsSticker = carSearchWsSticker;
        //service de recherche des label des donnes critères
        this.carSearchWsLabel = carSearchWsLabel;
        //service appel Blms
        this.carSearchWsBms = carSearchWsBms;
        this.getBreakingNews = getBreakingNews;
        this.getStickerData = getStickerData;
        this.getSparePartsDetails = getSparePartsDetails;
        // Connected plateform
        this.getConnectedPlatform = getConnectedPlatform;
        this.admireCommerciaLabel = admireCommerciaLabel;
        this.updateUsageCountry = updateUsageCountry;
        this.getVinAlertsStatus = getVinAlertsStatus;
        this.getCapVinAlertsStatus = getCapVinAlertsStatus;
        this.getProactiveAlert = getProactiveAlert;
        this.getEnggInfoForParts = getEnggInfoForParts;
        this.getVinOrangeStatus = getVinOrangeStatus;

        function getVinOrangeStatus(vin) {
            var url = CarSearchConstants.customerFocusStatus + '/' + encodeURIComponent(vin);

            return RestUpgrade.one(url).get({ index: 'TP' });
        }

        function getConnectedPlatform(params) {
            var url;
            url = rLinkConstant.restATWSNew + rLinkConstant.vehc + params.vin + '/' + rLinkConstant.connectedPlateform;
            
            return RestUpgradeRLink
                .one(url)
                .get().then( function(response) {
                    return response;
                })
                .catch(function(error) {
                    console.error('getConnectedPlatform', error.data.errors[0]);
                });
        }

        function admireCommerciaLabel(params,body){
            var url;
            url = rLinkConstant.admireCommerciaLabel + 'linkName=' + params.linkName + '&language=' + params.lang + '&date=ALL' + '&page=1' + '&pageSize=1000'

            return RestUpgrade.all(url).post(body).then( function(response) {
                    return response;
                })
                .catch(function(error) {
                    console.error('getConnectedPlatform', error.data.errors[0]);
                });
        }

        function updateUsageCountry(vin, body) {
            var url = rLinkConstant.updateUsageCountry + vin + rLinkConstant.usageCountries;

            return RestUpgrade.all(url).patch(body).then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    console.error('updateUsageCountry', error.data.errors[0]);
                });
        }

        function getVinAlertsStatus(params) {
            var url = rLinkConstant.asap + rLinkConstant.vehc + params.vin + '/' + rLinkConstant.features + params.featureId;
            
            return RestUpgradeRLink
                .one(url)
                .get().then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.resolve(null);
                });
        }

        function getCapVinAlertsStatus(params) {
            var url = rLinkConstant.asap + rLinkConstant.vehc + params.vin + '/' + rLinkConstant.features + rLinkConstant.featureCapId;
            
            return RestUpgradeRLink
                .one(url)
                .get().then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.resolve(null);
                });
        }

        function getProactiveAlert(vin, params) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            var preferredLanguage = userContext.documentationFirstLanguage.code;
            var defaultLanguage = userContext.documentationSecondLanguage.code;
            var url = rLinkConstant.alerts + vin;
            var payload = {
                status: params.status,
                fields: params.fields,
                preferredLanguage: preferredLanguage,
                defaultLanguage: defaultLanguage
            };
            return RestUpgradeRLink
                .one(url)
                .get(payload).then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject();
                });
        }

        function getSparePartsDetails(payload){

            const carContext = CacheService.getCarContext();
            const vin = carContext && carContext.vin ? carContext.vin : '';
            const family = carContext && carContext.fixedCriterias && carContext.fixedCriterias['007'] ? carContext.fixedCriterias['007'] : '';

            if(vin === '' || family === ''){
                return $q.reject();
            }

            const url = CarSearchConstants.sparePartsHercule + vin + CarSearchConstants.sparePartsFamily + family;

            return RestUpgrade.all(url).post(payload).then( function(response) {
               return response;
            }).catch(function(){
                return $q.reject();
            });
        }

        function carSearchByVin(vim) {
            return RestUpgrade.one(CarSearchConstants.restCarSearchByVin, vim).get()
                .catch(function (e) {
                    if (e.status === 503) {
                        return $q.reject(errorsConstant.SERVICE_UNVAILABLE);
                    }
                    return $q.reject(e);
                });
        }

        function carSearchImatWsBack(license) {
           
                return RestUpgrade.one(CarSearchConstants.carSearchByNewRegistrationUrl, license).get();
            
        }

        function carSearchByModel(carSearch) {
            return RestUpgrade.all(CarSearchConstants.restCarSearchByModel).post(carSearch)
        }

        function carSearchWsSticker(dataReq) {
            return RestUpgrade.one(CarSearchConstants.restCarSearchSticker, dataReq.family).one('', dataReq.bodyType)
                .get({ manufactuerId: dataReq.manufactuerId, engineType: dataReq.engineType }).then(function (response) {
                    if (!response) {
                        return $q.reject(errorsConstant.NOT_AUTHORIZED);
                    }
                    return response;
                }, function (error) {
                    $q.reject(error);
                })
        }

        function carSearchWsLabel(codeCriteria, codeLanguage) {
            // $log.debug("Car carSearchWsLabel" + JSON.stringify(CarSearch));
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.restCarSearchLabel, codeCriteria).one('', codeLanguage).get().then(function (response) {
                response = response.plain ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

        function getStickerData(codeCriteria,codeLanguage,dataReq){
            var  urls = [CarSearchConstants.restCarSearchLabel+ codeCriteria+"/"+codeLanguage, CarSearchConstants.restCarSearchSticker+"/"+dataReq.family+"/"+dataReq.bodyType+"?engineType="+dataReq.engineType+"&manufactuerId="+dataReq.manufactuerId]
                    , promises = urls.map(function(url){
                        return RestUpgrade.one(url).get().catch(function(e){return null})
                    })
                    , all = $q.all(promises).then(function(data){
                        return data.filter(function(d){return !!d}) // filter out empty, null results
                    })
                return all;
        }
        function getGemStopped() {
            var defer = $q.defer();
            $log.debug("Car Search Back Gem Stopped");
            RestUpgrade.one(CarSearchConstants.getGemStopped).get("1").then(function (response) {
                response = response.plain ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function carSearchWsBms(vin) {
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.restCarSearchBms, vin).get().then(function (response) {
                response = response.plain ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function historizationVehicleSaveWs(UserVehicle) {
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.restHistorizationVehiclesSB).post('', UserVehicle).then(function (response) {
                response = (response && response.plain) ? response.plain() : response;
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function historizationVehicleLoadWs() {
            var defer = $q.defer();
            RestUpgrade.one(CarSearchConstants.restHistorizationVehicles).get()
                .then(function (response) {
                    response = (response && response.plain) ? response.plain() : response;
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        }

        function getVehicleTreeFilter(payload) {
            return RestUpgrade.all(CarSearchConstants.restCarSearchBrandFilter).post(payload);
        }
        
        function getVehicleTapvmbFilter(payload) {
            return RestUpgrade.all(CarSearchConstants.restCarSearchTapvmbFilter).post(payload);
        }

        function getVehicleLexiqueFilter(payload) {
            var codes = ["013", "027", "046", "513", "427", "019","901","900"];
            _.extend(payload, { objectCodes: codes });

            return RestUpgrade.all(CarSearchConstants.restCarSearchLexiqueFilter).post(payload);
        }

        function getBreakingNews(payload) {
            return RestUpgrade.all(CarSearchConstants.breakingNewsSB).post(payload);
        }
        function getEnggInfoForParts(params) {
            var url = CarSearchConstants.enggInfoPart + CarSearchConstants.partId + params + CarSearchConstants.managingCompanyLabel + CarSearchConstants.horseProfile;
            return RestUpgrade.one(url).get()
                .catch(function (e) {
                    return $q.reject(e);
                });
        }

    }
})();

(function () {

    angular
        .module('phenix')
        .service('CarSearchMetierService', CarSearchMetierService);

    /** @ngInject */
    function CarSearchMetierService(
        $q,
        CacheService,
        CarSearchConstants,
        CodesConstants,
        globalConstant,
        CacheConstants,
        CarSearchWsService,
        RoutesConstants,
        profil,
        blockUI,
        $translate,
        toastr,
        UtilsMetierService,
        DmsMetierService,
        $filter,
        YesNoModaleService,
        $mdDialog,
        $state,
        errorsConstant,
        $rootScope,
        configConstantes, DocPrivConstants
    ) {
        var vm = this;
        var _searchBy = globalConstant.searchBy;
        vm.initSearchCar = initSearchCar;
        vm.searchCar = searchCar;
        vm.mergeObjects = mergeObjects;
        vm.historizationVehicleSave = historizationVehicleSave;
        vm.historizationVehicleLoad = historizationVehicleLoad;
        vm.getVehicleContext = getVehicleContext;
        vm.handleErrorFromWSBack = handleErrorFromWSBack;
        vm.getBannerData = getBannerData;
        vm.refreshSplitOnChangeOrderNumber = refreshSplitOnChangeOrderNumber;
        vm.handleErrorFromDmsOrder = handleErrorFromDmsOrder;
        vm.mergeCarSearchWithDmsResponseFromOrder = mergeCarSearchWithDmsResponseFromOrder;

        vm.loadCarContextAndStoreIt = loadCarContextAndStoreIt;
        vm.getCartContextFromSomeCart = getCartContextFromSomeCart;

        // search by models
        vm.getBrandModelList = getBrandModelList;
        vm.getTapvmbFilterListByBodyType = getTapvmbFilterListByBodyType;
        vm.getTapvmbFilterListByFamilyType = getTapvmbFilterListByFamilyType;
        vm.getTapvmbFilterList = getTapvmbFilterList;
        vm.getLexiqueFilterList = getLexiqueFilterList;
        vm.searchCarModel = searchCarModel;
        vm.customService = customService;
        //partList
        vm.transformWaintingPartListData = transformWaintingPartListData;
        vm.showPopinIfOrderIsWaiting = showPopinIfOrderIsWaiting;
        vm.addPieceAndChilds = addPieceAndChilds;
        vm.createNonBVMCarContext = createNonBVMCarContext;

        vm.setCarContextVehicleNotKnownBvm = setCarContextVehicleNotKnownBvm;
        vm.setCarContextVehicleNotKnownBvmAndDms = setCarContextVehicleNotKnownBvmAndDms;
        vm.getBreakingNews = getBreakingNews;
        vm.phaseMillesimPopup = phaseMillesimPopup;
        vm.getBannerDetails = getBannerDetails;
        vm.getPhasemillesimDetails = getPhasemillesimDetails;
        vm.getSparePartsDetails = getSparePartsDetails;

        vm.getConnectedPlatform = getConnectedPlatform;
        vm.getConnectedPlatformCommercialLabel = getConnectedPlatformCommercialLabel;
        vm.updateUsageCountry = updateUsageCountry;
        vm.getVinAlertsStatus = getVinAlertsStatus;
        vm.getCapVinAlertsStatus = getCapVinAlertsStatus;
        vm.getProactiveAlert = getProactiveAlert;
        vm.getVinOrangeStatus = getVinOrangeStatus;
        vm.changeLinkColor = changeLinkColor;
        vm.changeNormalcolor = changeNormalcolor;

        vm.setLocalizedData = setLocalizedData;
        vm.getLocalizedData = getLocalizedData;

        vm.getEnggInfoForParts = getEnggInfoForParts;

        vm.setCareAlertData = setCareAlertData;
        vm.getCareAlertData = getCareAlertData;
        vm.openCareAlertPopup = openCareAlertPopup;

        var backObjectFromWS = {};
        var dmsObjectFromWS = {};
        vm.multipleCarsWithSameReg = [];
        vm.localizedData = {};
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        function getVinOrangeStatus(vin) {
            return CarSearchWsService.getVinOrangeStatus(vin);
        }

        function searchCarWithVinAlert(carSearchForm, vinAlertPromise) {
            return searchCar(carSearchForm).then(function (data) {
                return vinAlertPromise.then(function (vinAlert) {
                    if (data && vinAlert) {
                        var vinIsRedReason = vinAlert.vinIsRedReasons && vinAlert.vinIsRedReasons.length ? vinAlert.vinIsRedReasons[0] : {};
                        data.vinIsRed = vinAlert.vinIsRed;
                        data.vinIsRedReasons = vinAlert.vinIsRedReasons;
                        data.codeLabelFr = vinAlert.codeLabelFr || vinIsRedReason.codeLabelFr;
                        data.codeLabelEn = vinAlert.codeLabelEn || vinIsRedReason.codeLabelEn;
                    }
                    return data;
                });
            });
        }

        function initSearchCar(carSearchForm, isDmsConnected) {
            var or = carSearchForm.or;
            var vin = carSearchForm.vin;
            var imat = carSearchForm.imat;
            CacheService.removeObject(CacheConstants.dmsResponse);

            var userProfile = CacheService.getUserProfile();
            var userType = userProfile && userProfile.userType ? userProfile.userType.toUpperCase() : '';
            var isArcaOrRnetUser = userType === 'ARCA' || userType === 'RNET';
            var isCareAlertEnabled = JSON.parse(configConstantes.isCareAlertEnabled);

            var vinAlertPromise = vin && isArcaOrRnetUser && isCareAlertEnabled ? getVinOrangeStatus(vin).catch(function () {
                    return null;
                }) : $q.resolve(null);

            if (isDmsConnected) {
                if (or) {
                    return DmsMetierService.getOrderByNumber(or).then(function (response) {
                        var returnCode = response.returnCode;
                        if (response.response && returnCode === 0) {
                            CacheService.setObject(CacheConstants.isOrSearchCar,true);
                            return setDmsResponseOnCache(carSearchForm, response.response, vinAlertPromise);
                        }
                        else {
                            return $q.reject();
                            //return handleErrorFromDmsOrder(returnCode);
                        }

                    }).then(function () {

                        mergeCarSearchWithDmsResponseFromOrder();
                    });
                }
                if (vin) {
                    return DmsMetierService.getVehicleByVin(vin).then(function (response) {
                        var returnCode = response.returnCode;
                        if(!returnCode && response.data){
                            returnCode = response.data.returnCode;
                        }
                        if (response.response && returnCode === 0) {
                            if (response.response.vehicle.vin) {
                                return setDmsResponseOnCache(carSearchForm, response.response, vinAlertPromise).then(function () {
                                    mergeCarSearchWithDmsResponseFromVehicle();
                                });
                            }
                            else {
                                //toastr.info($translate.instant('CARSEARCH_ERROR_VEHICLE_NOT_FOUND'));
                                return searchCarWithVinAlert(carSearchForm, vinAlertPromise);
                            }

                        }
                        else {
                            //toastr.info($translate.instant('CARSEARCH_ERROR_VEHICLE_NOT_FOUND'));
                            // if vehicle vin not found in DMS, send to mainCtrl for setting boolean to true
                            if(returnCode === 2){
                                $rootScope.$emit("VehicleNotFoundInDMS");
                            }
                            return searchCarWithVinAlert(carSearchForm, vinAlertPromise);
                        }

                    });
                }
                if (imat) {
                    return DmsMetierService.getVehicleByRegistrationNumber(imat).then(function (response) {
                        var returnCode = response.returnCode;
                        if (response.response && returnCode === 0) {
                            if (response.response.vehicle.vin) {
                                return setDmsResponseOnCache(carSearchForm, response.response, vinAlertPromise).then(function () {

                                    mergeCarSearchWithDmsResponseFromVehicle();
                                });
                            }
                            else {
                                //toastr.info($translate.instant('CARSEARCH_ERROR_VEHICLE_NOT_FOUND'));
                                return searchCarWithVinAlert(carSearchForm, vinAlertPromise);

                            }

                        }
                        else {
                            //toastr.info($translate.instant('CARSEARCH_ERROR_VEHICLE_NOT_FOUND'));
                            return searchCarWithVinAlert(carSearchForm, vinAlertPromise);
                        }
                    })

                }

            }
            else {
                return searchCarWithVinAlert(carSearchForm, vinAlertPromise);
            }
        }

        function getConnectedPlatform(){
            var contextCar = CacheService.getCarContext();
            var params = {
                vin: contextCar.vin,
                region: 'EU'
            };
            return CarSearchWsService.getConnectedPlatform(params);
        }

        function getConnectedPlatformCommercialLabel(params,body){
            return CarSearchWsService.admireCommerciaLabel(params,body);
        }

        function updateUsageCountry(vin, body) {
            return CarSearchWsService.updateUsageCountry(vin, body);
        }

        function getVinAlertsStatus(id) {
            var contextCar = CacheService.getCarContext();
            var vin = contextCar && contextCar.vin ? contextCar.vin : null;
            var params = {
                vin: vin,
                featureId: id
            };
            return CarSearchWsService.getVinAlertsStatus(params);
        }

        function getCapVinAlertsStatus() {
            var contextCar = CacheService.getCarContext();
            var vin = contextCar && contextCar.vin ? contextCar.vin : null;
            var params = {
                vin: vin
            };
            return CarSearchWsService.getCapVinAlertsStatus(params);
        }

        function getProactiveAlert(param) {
            var contextCar = CacheService.getCarContext();
            var vin = contextCar && contextCar.vin ? contextCar.vin : null;
            return CarSearchWsService.getProactiveAlert(vin,param);
        }

        function changeLinkColor(id) {
            $(id).css({
                  'width': '100%',
                  'height': '100%',
                  'opacity': '0.2'
            });
        }
        function changeNormalcolor(id) {
            $(id).css({
              
                    'width': '100%',
                    'height': '100%',
                    'opacity': '1',
                    });
        }

        function showPopinIfOrderIsWaiting() {
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
            if (dmsResponse && (dmsResponse.defaultSplitFlag === 2 || dmsResponse.defaultSplitFlag === 3)) {

                var modalParams = {

                    header: "LISTPART_MODAL_TITLE",
                    title: "LISTPART_MODAL_TEXT1",
                    subtitle: "LISTPART_MODAL_TEXT2",
                    or: dmsResponse.orderNumber
                }
                YesNoModaleService.showModal(modalParams);

            }
            else {
                $rootScope.$broadcast('confirmPendingClicked',false);
                return $q.reject(-1);
            }
        }

        function setDmsResponseOnCache(carSearchForm, response, vinAlertPromise) {
            carSearchForm.vin = response.vehicle.vin;
            carSearchForm.imat = response.vehicle.registrationNumber;
            CacheService.setObject(CacheConstants.dmsResponse, response);
            return searchCarWithVinAlert(carSearchForm, vinAlertPromise || $q.resolve(null));
        }

        function mergeCarSearchWithDmsResponseFromOrder() {

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);


            setCommonDmsFields(contextCarSearch, dmsResponse);
            setOrdersAndSplits(contextCarSearch, dmsResponse);

            contextCarSearch.searchTypeByOR = dmsResponse.orderNumber ? true : false;
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
        }
        /**
         * @desc Called when the order number is changed in order to refresh the splits
         *
         */
        function refreshSplitOnChangeOrderNumber() {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
            if(dmsResponse){
                contextCarSearch.ordersAndSplits.splits = dmsResponse.splits;
                contextCarSearch.ordersAndSplits.orderNumber = dmsResponse.orderNumber;
            }
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
        }

        function mergeCarSearchWithDmsResponseFromVehicle() {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);

            if (contextCarSearch === null || contextCarSearch === undefined) {
                if (dmsResponse.orderNumber) {
                    contextCarSearch = createNonBVMCarContext(
                        dmsResponse.vehicle.vin,
                        dmsResponse.vehicle.registrationNumber,
                        dmsResponse.orderNumber,
                        true
                    );
                } else {
                    contextCarSearch = createNonBVMCarContext(
                        dmsResponse.vehicle.vin,
                        dmsResponse.vehicle.registrationNumber,
                        null,
                        false
                    );
                }
            }

            setCommonDmsFields(contextCarSearch, dmsResponse);
            if (dmsResponse.ordersAndSplits) {
                setOrdersAndSplits(contextCarSearch, dmsResponse.ordersAndSplits);
            }
            contextCarSearch.searchTypeByOR = false;
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
        }

        /**
         * @name setCarContextVehicleNotKnownBvm
         * @desc set car context on cache for unkown bvm vehicle
         * @param {*} dmsResponse
         * @param {*} carInfosFromCache
         */
        function setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache) {
            if (dmsResponse && dmsResponse.orderNumber) {
                carInfosFromCache = createNonBVMCarContext(
                    dmsResponse.vehicle.vin,
                    dmsResponse.vehicle.registrationNumber,
                    dmsResponse.orderNumber,
                    true
                );
            } else {
                carInfosFromCache = createNonBVMCarContext(
                    dmsResponse.vehicle.vin,
                    dmsResponse.vehicle.registrationNumber,
                    null,
                    false
                );
            }

            carInfosFromCache.customer = dmsResponse.customer;


            /**
            * Here we reconstruct the object in the cache so that it respects the controller code if it's an otherbrand car
            */
            if (dmsResponse) {
                carInfosFromCache.ordersAndSplits = {};
                carInfosFromCache.ordersAndSplits.defaultSplitFlag = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.defaultSplitFlag : dmsResponse.defaultSplitFlag;
                carInfosFromCache.ordersAndSplits.isSplittingRequired = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.isSplittingRequired : dmsResponse.isSplittingRequired;
                carInfosFromCache.ordersAndSplits.openOrderFlag = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.openOrderFlag || CodesConstants.ONE_ORDER_TYPE : dmsResponse.openOrderFlag || CodesConstants.ONE_ORDER_TYPE;
                carInfosFromCache.ordersAndSplits.orderNumber = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.orderNumber : dmsResponse.orderNumber;
                carInfosFromCache.ordersAndSplits.orderNumbers = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.orderNumbers : dmsResponse.orderNumbers;
                carInfosFromCache.ordersAndSplits.splits = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.splits : dmsResponse.splits;
                carInfosFromCache.ordersAndSplits.team = dmsResponse.ordersAndSplits ? dmsResponse.ordersAndSplits.team : dmsResponse.team;

                if(dmsResponse.ordersAndSplits && dmsResponse.ordersAndSplits.accountNumber){
                    carInfosFromCache.accountNumber = dmsResponse.ordersAndSplits.accountNumber;
                }else if(dmsResponse.customer){
                    carInfosFromCache.accountNumber = dmsResponse.customer.dmsCustomerId;
                }
            }


            carInfosFromCache.vehicle = dmsResponse.vehicle;
            if (dmsResponse.vehicle.mileage) {
                carInfosFromCache.vehicle.mileAge = dmsResponse.vehicle.mileage;
            }


            CacheService.setObject(CarSearchConstants.contextCarSearch, carInfosFromCache);
            CacheService.setObject(CarSearchConstants.contextCarRequest, carInfosFromCache);
        }
        /**
         * @name setCarContextVehicleNotKnownBvmAndDms
         * @desc set car context on cache for unkown bvm & dms vehicle
         * @param {*} carSearchForm
         * @param {*} unknownCarInfos
         */
        function setCarContextVehicleNotKnownBvmAndDms(carSearchForm){
            if (carSearchForm) {
                carSearchForm = createNonBVMCarContext(
                    carSearchForm.vin,
                    carSearchForm.imat,
                    null,
                    false
                );
            }
           CacheService.setObject(CarSearchConstants.contextCarSearch, carSearchForm);
           CacheService.setObject(CarSearchConstants.contextCarRequest, carSearchForm);
        }


        function createNonBVMCarContext(vin, imat, orNumber, isSearchTypeByOr) {

            var carContext = {
                "vehicle": {
                    "displayMotrio": false,
                    "vin": vin,
                    "registrationNumber": imat,
                    "model": "",
                    "color": "",
                    "motorisation": "",
                    "millesim": "",
                    "categories": [],
                    "searchTypeByOR": false,
                    "isGemStopped": false,
                    "family": "",
                    "engineSuffix": "",
                    "gearboxSuffix": "",
                    "steeringWheelLocation": "",
                    "vehiculeVersion": "",
                    "equipmentLevel": "",
                    "heatingSystem": "",
                    "gearBoxType": "",
                    "gas": "",
                    "pr": [],
                    "mr": [],
                    "md": [],
                    "nt": [],
                    "urlImage": "",
                    "contextBlms": {},
                    "tapv": "",
                    "typeMD": "B2"
                },
                "isKnown": "",
                "payCash": "",
                "ordersAndSplits": {},
                "team": "",
                "searchTypeByOR": isSearchTypeByOr,
                "treeNodes": {}
            };

            return carContext;
        }

        function setCommonDmsFields(contextCarSearch, dmsResponse) {
            contextCarSearch.accountNumber = dmsResponse.accountNumber;
            contextCarSearch.customer = dmsResponse.customer;
            contextCarSearch.isKnown = dmsResponse.isKnown;
            contextCarSearch.payCash = dmsResponse.payCash;
            contextCarSearch.vehicle.mileAge = dmsResponse.vehicle.mileage;
            contextCarSearch.ordersAndSplits.team = dmsResponse.team;
        }

        /**
         * @desc    Save DMS response from vehicle.v1 or order.v1 request
         *          On vehicle.v1 openOrderFlag is returned, but not on order.v1 so we set by default at 0
         *
         *          0 = ONLY 1 ORDER TYPE, so orderNumber is fill
         *          1 = MULTIPLE ORDER TYPE, so orderNumber[s] is fill
         *
         * @param {object} contextCarSearch
         * @param {object} dmsResponse
         */

        function setOrdersAndSplits(contextCarSearch, ordersAndSplits) {
            contextCarSearch.ordersAndSplits.openOrderFlag = ordersAndSplits.openOrderFlag || CodesConstants.ONE_ORDER_TYPE;
            contextCarSearch.ordersAndSplits.team = ordersAndSplits.team;
            contextCarSearch.ordersAndSplits.isSplittingRequired = ordersAndSplits.isSplittingRequired;
            contextCarSearch.ordersAndSplits.defaultSplitFlag = ordersAndSplits.defaultSplitFlag;
            contextCarSearch.ordersAndSplits.splits = ordersAndSplits.splits;
            contextCarSearch.ordersAndSplits.orderNumbers = ordersAndSplits.orderNumbers;
            contextCarSearch.ordersAndSplits.orderNumber = ordersAndSplits.orderNumber;
        }

        /**
         *  @desc   En fonction des champs on fera une recherche par vim ou imat
         *          On va chercher le context du vehicule, et d'autres informations.
         *          Sauvegarde dans le cache :
         *              context + banniere + divers champs
         *              context vehicule
         *
         *          En parametre l'objet contient 2 champs : {
         *              vin: string,
         *              imat: string
         *          }
         *
         *  @param {object} carSearchForm
         *  @return {void}
         */

        function searchCar(carSearchForm,searchValue) {
            var vim = carSearchForm.vin;

            // Allow the user to fill the registration number in different formats
            if (carSearchForm.imat) {
                var rawImat = carSearchForm.imat
                var imat = rawImat.split(' ').join('');
                imat = imat.split('-').join('');
            }

            var promise = carSearchForm.vin ?
                CarSearchWsService.carSearchByVin(vim) :
                CarSearchWsService.carSearchImatWsBack(imat);

            return promise.then(function (res) {
                var itemObject;
                if (res && res.vehicles && res.vehicles.length > 1 && res.returnCode === "0160") {
                    var multipleCarsWithSameReg = [];
                    angular.forEach(res.vehicles, function (item) {
                        itemObject = {};
                        itemObject['labelizedBrandCode'] = item.labelizedBrandCode;
                        itemObject['commercialDesignation'] = item.commercialDesignation;
                        itemObject['engine'] = item.engine;
                        itemObject['vin'] = item.vin;
                        itemObject['registrationCountryCode'] = item.registrationCountryCode;

                        multipleCarsWithSameReg.push(itemObject);
                    });

                    vm.multipleCarsWithSameReg = multipleCarsWithSameReg;
                    if(!searchValue){
                    $mdDialog.show({
                        templateUrl: 'app/components/car/carSearch/carSearchByRegistration.template.html',
                        controller: 'carSearchVinModelController',
                        controllerAs: 'vm',
                        bindToController: true,
                        clickOutsideToClose: true,
                        locals: {
                            multipleCarsWithSameReg: vm.multipleCarsWithSameReg
                        }
                    });
                }
                }
                else {
                    var codeError = parseInt(res.returnCode);
                    // if vehicle vin not found in BVM, send to mainCtrl for setting boolean to true
                    if(codeError === 100){
                        $rootScope.$emit("VehicleNotFoundInBVM");
                    }
                    if ((codeError !== 160 && res && res.vehicles && res.vehicles.length > 1) || codeError === 100 || codeError === 150 || codeError === 500) {
                        return $q.reject({ msg: handleErrorFromWSBack(codeError) })
                    }
                    //calling banner data from car search controller
                    var vinIsRedReason = res.vinIsRedReasons && res.vinIsRedReasons.length ? res.vinIsRedReasons[0] : {};
                    return {
                        carContext: res.carContext,
                        vinIsRed: res.vinIsRed,
                        vinIsRedReasons: res.vinIsRedReasons,
                        codeLabelFr: res.codeLabelFr || vinIsRedReason.codeLabelFr,
                        codeLabelEn: res.codeLabelEn || vinIsRedReason.codeLabelEn
                    }
                }
            }).then(function (data) {
                /* Regle metier pour l'affichage du motrio dans PR lors d'une recherche par vim */
                if (data && data.carContext) {
                    if(data.carContext.fixedCriterias && !_.has(data.carContext.fixedCriterias,'336') && !data.carContext.brandComputed){
                       var brand = 'APL03';
                        data.carContext.fixedCriterias["336"]= brand;
                    }
                    else if(data.carContext.fixedCriterias && !_.has(data.carContext.fixedCriterias,'336') && data.carContext.brandComputed){
                       var brand = data.carContext.brandComputed;
                        data.carContext.fixedCriterias["336"]= brand;
                    }
                    else if(data.carContext.fixedCriterias && _.has(data.carContext.fixedCriterias,'336') && (data.carContext.fixedCriterias["336"] ==='SSAPL' || data.carContext.fixedCriterias["336"] ==='SAN336') && data.carContext.brandComputed){
                         data.carContext.fixedCriterias["336"]= data.carContext.brandComputed;
                    }
                    else if(data.carContext.fixedCriterias && _.has(data.carContext.fixedCriterias,'336') && (data.carContext.fixedCriterias["336"] ==='SSAPL' || data.carContext.fixedCriterias["336"] ==='SAN336') && !data.carContext.brandComputed){
                        data.carContext.fixedCriterias["336"]= 'APL03';
                   }


                    var displayMotrio = motrioCondition(data.carContext.ageComputed, data.carContext.brandComputed);
                    saveContext(data, displayMotrio,searchValue);
                    return data;
                }
            })
        }

        function getPhasemillesimDetails(data) {
            blockUI.start()
            return getLexiqueFilterList(data.carContext.families.familyVehicle[0]).then(function (response) {
                blockUI.reset();
                if (response) {
                    return phaseMillesimPopup(data, response).then(function (result) {
                        if (result) {
                            var carContext = {
                                "fixedCriterias": result.carContext.fixedCriterias
                            }
                            blockUI.start();
                            //get only typemd for updated fixed criterias from carSearchByModel
                            return CarSearchWsService.carSearchByModel(carContext).then(function (res) {
                                if (res && res.carContext) {
                                    var typeMD = res.carContext.typeMD;
                                    var updatecontextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
                                    var updatecontextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch)
                                    updatecontextCarRequest.typeMD = typeMD;
                                    updatecontextCarRequest.fixedCriterias = data.carContext.fixedCriterias;
                                    updatecontextCarSearch.vehicle.typeMD = typeMD;
                                    CacheService.setObject(CacheConstants.contextCarRequest, updatecontextCarRequest);
                                    CacheService.setObject(CacheConstants.contextCarSearch, updatecontextCarSearch);
                                    return true;
                                } else {
                                    return false;
                                }
                            }).catch(function (error) {
                                toastr.error(error);
                                return ;
                            }).finally(function () {
                                blockUI.stop();
                            });
                        } else {
                            return false;
                        }
                    });
                } else {
                    return false;
                }
            });
        }

        function phaseMillesimPopup(data, listCriterias) {
            var phase = [], millesim = [];
            if (!_.has(data.carContext.fixedCriterias, '901')) {
                phase = _.filter(listCriterias, function (item) {
                    return item.objectCode === '901'
                })
            }
            if (!_.has(data.carContext.fixedCriterias, '900')) {
                millesim = _.filter(listCriterias, function (item) {
                    return item.objectCode === '900'
                })
            }
            return $mdDialog.show({
                templateUrl: 'app/components/car/carSearch/phaseMillesim.html',
                controller: 'phaseMillesimController',
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: false,
                locals: {
                    phaseList: phase,
                    millesimList: millesim
                }
            }).then(function (result) {
                //for modal search update phase/millesim in cache fieldsFromCarSearchModel
                var fieldsFromCarSearchModel = CacheService.getObject(CarSearchConstants.fieldSearchModel)
                if (fieldsFromCarSearchModel && fieldsFromCarSearchModel.fields4) {
                    if (result.phase) {
                        fieldsFromCarSearchModel.fields4[0].value = result.phase
                    }
                    if (result.millesim) {
                        fieldsFromCarSearchModel.fields4[1].value = result.millesim
                    }
                    CacheService.setObject(CarSearchConstants.fieldSearchModel, fieldsFromCarSearchModel);
                }
                if (result) {
                    if (data && !_.has(data.carContext.fixedCriterias, '901') && result.phase) {
                        _.extend(data.carContext.fixedCriterias,
                            { '901': result.phase.criteriaCode })
                    }
                    if (data && !_.has(data.carContext.fixedCriterias, '900') && result.millesim) {
                        _.extend(data.carContext.fixedCriterias,
                            { '900': result.millesim.criteriaCode })
                    }
                    return data;
                }
                else{
                    return ;
                }
            });
        }

        /**
        * @desc function return message by return code from DMS
        * @param {*} error
        */
        function handleErrorFromDmsOrder(error) {
            switch (error) {
                case 1: return $q.reject({ msg: $translate.instant('CARSEARCH_ERROR_ORDER_NOT_FOUND') });
                case 2: return $q.reject({ msg: $translate.instant('CARSEARCH_ERROR_ORDER_NOT_USED') });
                default: return $q.reject({ msg: $translate.instant('CARSEARCH_ERROR_ORDER_DMS') });
            }
        }

        /**
         *  Cette function est utilisée par searchCar
         *  @desc   Retourne une erreur spécifique en fonction du code envoyé
         *
         *  @param  {integer} error
         *  @return {string}
         */

        function handleErrorFromWSBack(error) {
            switch (error) {
                case 150:
                case 160:
                    return $translate.instant("CARSEARCH_BVM_ERROR_MULTIPLE_VEHICLE");
                case 100:
                    return $translate.instant("CARSEARCH_BVM_ERROR_NO_VEHICLE");
                case 500:
                    return $translate.instant("CARSEARCH_BVM_ERROR_NO_VEHICLE");
                default:
                    return $translate.instant("CARSEARCH_BVM_ERROR");
            }
        }



        /**
         *  Cette fonction est utilisée par searchCar et searchCarModel
         *  @desc   On recoit en parametre une liste de critères et la "marque résolu" pour recuperer divers
         *          informations à afficher sur le bandeau qui se trouve juste en dessous du header
         *
         *
         *          Regle metier : On se base sur le critère 336 (marque), si celui ci contient
         *          les codes suivant :
         *          - SAN336 || SSAPL || null
         *          On le remplace par le brandComputer (marque résolu), si le brandComputer
         *          contient lui aussi ces champs on retournera une `promise reject`
         *          Certains véhicules ne doivent pas être rechercher (pas d'authorisation);
         *
         *  @param {array<string>} criterias
         *  @param {string} brand
         *  @return {promise}
         */

        function getBannerData(criterias, brandComputed) {
            var defer = $q.defer();
            var msg;
            var carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);        
            var carContext = getVehicleContext();
            if(!criterias) {
                criterias = carContextRequest.fixedCriterias;
            }
            if(!brandComputed) {
                brandComputed = carContextRequest.brandComputed;
                criterias['336'] = brandComputed;
            }
            var brand = criterias['336'];
            if (brand === 'SAN336' || brand === 'SSAPL' || !brand) {
                brand = brandComputed;
            }

            if (brand === 'SAN336' || brand === 'SSAPL' || !brand) {
                msg = $translate.instant('UNKNOW_VEHICLE');
                return $q.reject({ msg: msg });
            }

            var notAuthorized = ["APL09", "APL10", "APL13", "APL15", "APL16", "APL17",
                "APLSOU", "APLVAL", "BRA09", "BRA15", "BRA16", "BRA17", "BRA19", "BRA1A", "BRA20", "BRA22"]
                .some(function (brandVehicule) {
                    return brandVehicule === brand;
                })

            if (notAuthorized) {
                msg = $translate.instant('NOT_AUTHORIZED_RESEARCH');
                return $q.reject({ msg: msg });
            }

            var engineType = criterias['999'];
            var gearboxType = criterias['997'];

            // gearboxType = "PF6";
            var color = criterias['141'];
            var stickerData = {
                "family": criterias['007'],
                "bodyType": criterias['008'],
                "manufactuerId": brand,
                "engineType": criterias['999'],
                "engineSuffix": criterias['998'],
                "gearboxSuffix": criterias['996'],
                "batterySuffix": criterias['966'],
                "tractionBattery": criterias['968'],
                "steeringWheelLocation": criterias['027'],
                "vehiculeVersion": criterias['013'],
                "equipmentLevel": criterias['513'],
                "heatingSystem": criterias['046']
            }

            var user = CacheService.getObject(RoutesConstants.profil);
            CarSearchWsService.getStickerData(engineType, user.language,stickerData)
            .then(function(response){
                if(!_.isEmpty(response)){
                    var bannerText;
                    if(response.length == 2){
                        bannerText = _.merge(response[0],response[1])
                    }
                    else
                        bannerText =  _.merge([],response[0]);                
                    defer.resolve(bannerText)
                    var carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);    
                    if(carContextRequest){
                        _.assign(carContextRequest,{
                            motorisation: bannerText.label ? bannerText.label : null,
                            color: color ? color : null,
                            model: bannerText.commercialDesignation ? bannerText.commercialDesignation : null,
                            urlImage: bannerText.imageUrl ? bannerText.imageUrl : null,
                        })
                        CacheService.setObject(CacheConstants.contextCarRequest,carContextRequest);  
                    }                
                    if(carContext && carContext.vehicle){
                        _.assign(carContext.vehicle, {
                            motorisation: bannerText.label ? bannerText.label : null,
                            color: color ? color : null,
                            model: bannerText.commercialDesignation ? bannerText.commercialDesignation : null,
                            urlImage: bannerText.imageUrl ? bannerText.imageUrl : null,
                        });                        
                        CacheService.setObject(CacheConstants.contextCarSearch, carContext); 
                    }
                }
            }).catch(function(e){
                defer.reject(e);
            }).finally(function(){                                   
                $rootScope.$broadcast('bannerDataLoaded'); 
            })
            return defer.promise;
        }

        function getCartContextFromSomeCart(cart) {
            var getCarContext;

            if (!cart.searchBy) {
                return $q.resolve(null);
            }

            switch (cart.searchBy) {
                case _searchBy.vin:
                    getCarContext = CarSearchWsService.carSearchByVin(cart.vin);
                    break;
                case _searchBy.registrationNumber:
                    getCarContext = CarSearchWsService.carSearchImatWsBack(cart.imat);
                    break;
                case _searchBy.model:
                    var payload = {};
                    payload.fixedCriterias = {
                        '007': cart.familyVehicle,
                        '008': cart.bodyType,
                        '336': cart.brand,
                        '997': cart.gearboxType,
                        '999': cart.engineType
                    }
                    getCarContext = searchCarModel(payload.fixedCriterias);
                    break;
            }
            return getCarContext.then(function (response) {
                var codeError = parseInt(response.returnCode);
                if (codeError) {
                    return $q.reject({ msg: handleErrorFromWSBack(codeError) })
                }
                getBannerData(response.carContext.fixedCriterias, response.carContext.brandComputed);
                return {
                    vin: response.carContext.vin ? response.carContext.vin : null,
                    registrationNumber: response.carContext.registrationNumber ? response.carContext.registrationNumber : null
                }
            });
        }

        /**
         *      @desc
         */

        function loadCarContextAndStoreIt(cart) {
            var promise;

            if (cart.vin) {
                promise = initSearchCar({ vin: cart.vin }, false);
            } else if (cart.registrationNumber) {
                promise = initSearchCar({ imat: cart.registrationNumber }, false)
            } else if (cart.brand) {
                promise = searchCarModel({
                    fixedCriterias: {
                        '007': cart.familyVehicle,
                        '008': cart.bodyType,
                        '336': cart.brand,
                        '997': cart.gearboxType,
                        '999': cart.engineType
                    }
                });
            } else {
                promise = $q.resolve();
            }

            return promise;
        }

        /**
         *  @desc Cette fonction definie des regles metier pour l'affichage des motrio
         *  dans la liste des PR
         *
         *  On n'affiche les motrio uniquement dans les cas suivant (recherche par vim) :
         *
         *  Marque dacia (APL05), date de fabrication >= 3
         *  Marque renault (APL03), date de fabrication >= 4
         *
         *  En dehors de ca, on ne les affiche pas.
         *
         *  Ce qui est retourné par la fonction est utilisé dans le body de la requete qui permet
         *  de recuperer la liste des PR
         *
         *  @param {object} carContext
         *  @return {boolean} true || false
         */

        function motrioCondition(manufactureDate, brand) {
            if (brand === 'APL05' && manufactureDate >= 3) {
                return true;
            } else if (brand === 'APL03' && manufactureDate >= 4) {
                return true;
            }
            return false;
        }

        /**
         *  @desc Permet de recuperer un car context grace aux informations entrée dans
         *  marque modèle, le fonctionnement est le meme que par vin/immat
         *
         *  Pour l'instant la seule difference est qu'on affichera toujours les motrios
         *
         *  @param {object} carSearchForm
         *  @returns void
         */

        function searchCarModel(carSearchForm) {
            return CarSearchWsService.carSearchByModel(carSearchForm)
                .then(function (res) {
                    var codeError = parseInt(res.returnCode);
                    if (codeError) {
                        return $q.reject({ msg: handleErrorFromWSBack(codeError) })
                    }
                    return {
                        carContext: res.carContext
                    }
                    //calling banner data from model comp
                }).then(function (data) {

                    saveContext(data, 'ALLPARTS');
                     return data;
                });
        }
        function customService(payloadData){
            return CarSearchWsService.carSearchByModel(payloadData)
            .then(function (res) {
                return res;
            })
        }

        function saveContext(data, displayMotrio,searchValue) {
            var c = CodesConstants;
            var fixedCriterias = data.carContext.fixedCriterias;
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);

            var carContextAndBanner = _.extend({
                vin: data.carContext.vin,
                registrationNumber: dmsResponse && dmsResponse.vehicle.registrationNumber ? dmsResponse.vehicle.registrationNumber : data.carContext.registrationNumber,
                color: "",
                searchTypeByOR: false,
                isGemStopped: false,
                family: "",
                millesim: data.carContext.millesim,
                engineSuffix: fixedCriterias[c.engineSuffix],
                gearboxSuffix: fixedCriterias[c.gearboxSuffix],
                batterySuffix: fixedCriterias[c.batterySuffix],
                tractionBattery: fixedCriterias[c.tractionBattery],
                steeringWheelLocation: fixedCriterias[c.steeringWheelLocation],
                vehiculeVersion: fixedCriterias[c.vehiculeVersion],
                equipmentLevel: fixedCriterias[c.equipmentLevel],
                heatingSystem: fixedCriterias[c.heatingSystem],
                gearBoxType: fixedCriterias[c.gearBoxType],
                gas: fixedCriterias[c.gas],
                pr: [],
                mr: [],
                md: [],
                nt: [],
                categories: [],
                fixedCriterias: data.carContext.fixedCriterias,
                variableCriterias: data.carContext.variableCriterias,
                contextBlms: {},
                tapv: data.carContext.tapv,
                typeMD: data.carContext.typeMD,
                displayMotrio: displayMotrio
            }, data.banner);

            _.extend(data.carContext, data.banner);

            //* Ces 2 lignes proviennent d'atos, les traitements ne sont peut etre pas utilisés (?).
            //* Le carSearchContext contient le car context en plus de divers parametres rajoutés par default.
            var carSearchContext = mergeObjects(carContextAndBanner, dmsObjectFromWS);
            if (!searchValue) {
                addVehicleToPartList(carSearchContext);
                CacheService.setObject(CacheConstants.contextCarSearch, carSearchContext);
                CacheService.setObject(CacheConstants.contextCarRequest, data.carContext);
                CacheService.removeObject(CacheConstants.bvaApigee);
            }
            
        }

        function addVehicleToPartList(vehicleContext) {
            var user = CacheService.getObject(CacheConstants.profil);
            var userIsPartShop = UtilsMetierService.isPartShop(user);
            if (userIsPartShop) {
                var currentPartList = CacheService.getObject(CacheConstants.partList);
                if (currentPartList) {
                    currentPartList.vehicles = currentPartList.vehicles || [];
                    if (!carExistsInPartList(vehicleContext, currentPartList.vehicles)) {
                        currentPartList.vehicles.push(createStructVehicle(vehicleContext));
                        CacheService.setObject(CacheConstants.partList, currentPartList);
                    }
                }
            }
        }

        // Merge Back + Dms object
        //DmsObject propreties overwrite the BackObject propreties
        function mergeObjects(backObject, dmsObject) {

            var user = CacheService.getObject(profil);
            var isPartShop = UtilsMetierService.isPartShop(user);

            var jsonCarFromBack = {
                displayMotrio: backObject.displayMotrio,
                vin: backObject.vin,
                registrationNumber: backObject.registrationNumber,
                model: backObject.model,
                color: backObject.color,
                motorisation: backObject.motorisation,
                millesim: backObject.millesim,
                engineType: backObject.engineType,
                categories: backObject.categories,
                searchTypeByOR: backObject.searchTypeByOR,
                isGemStopped: backObject.isGemStopped,
                family: backObject.family,
                engineSuffix: backObject.engineSuffix,
                gearboxSuffix: backObject.gearboxSuffix,
                batterySuffix: backObject.batterySuffix,
                tractionBattery: backObject.tractionBattery,
                steeringWheelLocation: backObject.steeringWheelLocation,
                vehiculeVersion: backObject.vehiculeVersion,
                equipmentLevel: backObject.equipmentLevel,
                heatingSystem: backObject.heatingSystem,
                gearBoxType: backObject.gearBoxType,
                gas: backObject.gas,
                pr: backObject.pr,
                mr: backObject.mr,
                md: backObject.md,
                nt: backObject.nt,
                urlImage: backObject.urlImage,
                dataCrit: backObject.dataCrit,
                dataCritVar: backObject.dataCritVar,
                contextBlms: backObject.contextBlms,
                tapv: backObject.tapv,
                typeMD: backObject.typeMD
            };

            var jsonCarFromDMS = {};
            var jsonCustomer = {};
            var isKnown = '';
            var payCash = '';
            var team = '';
            var ordersAndSplits = {};
            if (user.dmsConnected && dmsObject && dmsObject.response) {
                jsonCarFromDMS = dmsObject.response.vehicle;
                jsonCustomer = dmsObject.response.customer;
                isKnown = dmsObject.response.isKnown;
                payCash = dmsObject.response.payCash;
                team = dmsObject.response.team;

                if (dmsObject.response.ordersAndSplits) {
                    ordersAndSplits = dmsObject.response.ordersAndSplits;
                } else {
                    ordersAndSplits.team = dmsObject.response.team;
                    ordersAndSplits.isSplittingRequired = dmsObject.response.isSplittingRequired;
                    ordersAndSplits.defaultSplitFlag = dmsObject.response.defaultSplitFlag;
                    ordersAndSplits.splits = dmsObject.response.splits;
                    ordersAndSplits.orderNumber = dmsObject.response.orderNumber;
                }

            }

            var jsonCar = _.assign(jsonCarFromBack, jsonCarFromDMS);

            //Le champ modèle du contexte doit être renseigné en priorité avec l’information de BVM. (Si le modèle est inconnu de BVM alors c’est le modèle du DMS qui sera pris en compte)"
            if (jsonCarFromBack.model) {
                jsonCar.model = jsonCarFromBack.model;
            } else {
                jsonCar.model = jsonCarFromDMS.model
            }

            var jsonMerged = {
                vehicle: jsonCar,
                isKnown: isKnown,
                payCash: payCash,
                ordersAndSplits: ordersAndSplits,
                team: team,
                accountNumber: dmsObject.response && dmsObject ? dmsObject.response.accountNumber : undefined,
                searchTypeByOR: jsonCarFromBack.searchTypeByOR
            };

            jsonMerged = mergeBvmDms(jsonMerged);

            return jsonMerged;
        }

        function mergeBvmDms(contextCarSearch) {
            var categories = contextCarSearch.vehicle.categories;
            if (categories) {
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    for (var j = 0; j < category.elements.length; j++) {
                        if (category.elements[j].code === "141" && category.elements[j].value) {
                            contextCarSearch.vehicle.colorCode = category.elements[j].value;
                            contextCarSearch.vehicle.color = category.elements[j].value;
                        }
                        if (category.elements[j].code === "999" && category.elements[j].value) {
                            contextCarSearch.vehicle.engineType = category.elements[j].value;
                        }
                        if (category.elements[j].code === "008" && category.elements[j].value) {
                            contextCarSearch.vehicle.model = category.elements[j].value;
                        }
                    }
                }
            }
            return contextCarSearch;
        }

        /**
         * Update context and add vehicle to part list (if needed)
         */
        function processAfter() {
            var vehicleContext = mergeObjects(backObjectFromWS, dmsObjectFromWS);
            CacheService.setObject(CacheConstants.contextCarSearch, vehicleContext);
            addVehicleToPartList(vehicleContext);
            var carContextRequest = createRequestContextCar(vehicleContext);
            CacheService.setObject(CacheConstants.contextCarRequest, carContextRequest);
        }







        function carExistsInPartList(vehicle, vehicles) {
            for (var v = 0; v < vehicles.length; v++) {
                if (vehicle.vin === vehicles[v].vin) {
                    return true;
                }
            }
            return false;
        }


        function createStructVehicle(context) {
            return {
                orderNumber: "",
                vehicle: {
                    vin: context.vehicle.vin,
                    registrationNumber: context.vehicle.registrationNumber,
                    model: context.vehicle.model,
                    afterSalesType: context.vehicle.afterSalesType,
                    color: context.vehicle.color,
                    engineType: context.vehicle.engineType,
                    mileage: context.vehicle.mileage,
                    pr: []
                }
            };
        }

        /**
         * Callback to set back result
         */
        function resultOfBack(value) {

            // retour apigee BVM
            /*
             * "getApvGetDetVehResponse": { "getApvGetDetVehReturn": { "detVeh": {
             * ..., "DataCrit":[...] ... }, "detVehInfoMsg": { "CodeRetour":
             * "0000", "MsgRetour": "RECHERCHE VALIDE, VEHICULE TROUVE" } } }
             */
            var infoMsg = value.getApvGetDetVehResponse.getApvGetDetVehReturn.detVehInfoMsg;

            var errorCode = {
                id: infoMsg.CodeRetour,
                label: infoMsg.MsgRetour
            };



            if ("0000" === infoMsg.CodeRetour) {
                var dataVeh = value.getApvGetDetVehResponse.getApvGetDetVehReturn.detVeh;
                var dataCrit = getDataCritereBvm(dataVeh, true);
                var dataCritVar = getDataCritereBvm(dataVeh, false);
                var dataCrit900 = $filter("filter")(dataCrit, { CodeObjet: "900" });
                var millesimVehicule = "00000";
                if (dataCrit900[0]) {
                    millesimVehicule = dataCrit900[0].Mnemonique; // enlever PE et  ajouter 0
                    millesimVehicule = millesimVehicule.replace("PE", "") + "0";
                }
                // var dataVehBvm = {
                //   anFab: dataVeh.AnFab,// A exploiter UNIQUEMENT si le champ DateTcmFab est vide et si le champ NFab est vide.
                //   dateBoit: dataVeh.DateBoi,// Date fabrication Boite
                //   dateMot: dataVeh.DateMot,// Date fabrication moteur
                //   dateFab: dataVeh.DateTcmFab, // /Date fabrication véhicule
                //   l1Po: dataVeh.L1Po,// ligne1 de la plaque ovale pour affichage non envohé au back
                //   ligne2P12: dataVeh.Ligne2P12,// ligne2 de la plaque ovale pour affichage
                //   ligne3P12: dataVeh.Ligne3P12,// ligne3 de la plaque ovale pour affichage
                //   ligne4P12: dataVeh.Ligne4P12,// ligne4 de la plaque ovale pour affichage
                //   numBoi: dataVeh.NBoi,// numéro de fabrication de la boite
                //   numFab: dataVeh.NFab,// numéro de fabrication du vehicule
                //   numMot: dataVeh.NMot,// numéro de fabrication du moteur
                //   paysImmat: dataVeh.PaysImmat,
                //   //tapv : dataVeh.Tapv,// Type après vente:a exploiter uniquement si l’un des 2 objets 008 ou 018 ne sont pas renseignés
                //   // Remplir dans le code objet APV003, avec un critère dont le mnemonique est ’APV003_ ‘ & la valeur.					usiBoi : dataVeh.UsiBoi,// Usine de montage Boite:A utiliser pour filtrer l'applicabilité variable (U=x) sur les familles organes boite.
                //   // Remplir dans le code objet APV002, avec un critère dont le mnemonique est ’APV002_ ‘ & la valeur
                //   usiMot: dataVeh.UsiMot,// Usine de montage Moteur:A utiliser pour filtrer l'applicabilité variable (U=x) sur les familles organes moteur.
                //   // Remplir dans le code objet APV001, avec un critère dont  le mnemonique est ’APV001_ ‘ & la valeur
                //   usiVeh: dataVeh.UsiVeh
                //   // Usine de montage Véhicule:A utiliser pour filtrer
                //   // l’applicabilité variable (U=x) sur les familles véhicule.
                // };
                backObjectFromWS = {
                    vin: dataVeh.Vin,
                    registrationNumber: dataVeh.NImmat,
                    model: dataVeh.LibModel,
                    color: "",
                    engineType: dataVeh.TypeMot,
                    searchTypeByOR: false,
                    isGemStopped: false,
                    family: "",
                    millesim: millesimVehicule,
                    pr: [],
                    mr: [],
                    md: [],
                    nt: [],
                    categories: [],// dataCrit avec libellés recupéres du datahub et classée par catégories
                    urlImage: "",// TODO vignette à via cdn
                    dataCrit: dataCrit,
                    // dataVehBvm: dataVehBvm,
                    dataCritVar: dataCritVar,
                    contextBlms: {},
                    tapv: dataVeh.Tapv
                };
            } else if ("0150" === infoMsg.CodeRetour || "0160" === infoMsg.CodeRetour) {
                // Multiple Vehicle Return
                backObjectFromWS = { errorCode: { label: "CARSEARCH_BVM_ERROR_MULTIPLE_VEHICLE" } };
            } else if ("0100" === infoMsg.CodeRetour) {
                // No vehicle Found
                backObjectFromWS = { errorCode: { label: "CARSEARCH_BVM_ERROR_NO_VEHICLE" } };
            } else {
                // Unknown response BVM Error
                backObjectFromWS = { errorCode: { label: "CARSEARCH_BVM_ERROR" } };
            }
            return backObjectFromWS
        }

        /**
         * Callback to set Dms result
         */
        function resultOfDMS(value) {
            dmsObjectFromWS = value;
        }

        /**
         * Get data crit fix and var from Blms
         */
        function getDataFromBlms(backObjectFromWS, isElectricOrHybrid) {
            // Response Blms
            var deferred = $q.defer();
            backObjectFromWS.contextBlms = {
                dataCritVar: {
                    "APVDT4": "",
                    "APVNM4": ""
                }
            };

            if (isElectricOrHybrid) {
                var promise = CarSearchWsService.carSearchWsBms(backObjectFromWS.vin);
                promise.then(function (respBms) {
                    var pack_type = respBms.putIDCardDataResponse.putIDCardDataResponse.PACK_TYPE;
                    var pack_idx = respBms.putIDCardDataResponse.putIDCardDataResponse.PACK_IDX;
                    var p_date = respBms.putIDCardDataResponse.putIDCardDataResponse.P_DATE;
                    var pack_no = respBms.putIDCardDataResponse.putIDCardDataResponse.PACK_NO;

                    var plantNum = (pack_no) ? pack_no.charAt(0) : null; //TODO

                    var dataCritFinal = {
                        "968": pack_type,
                        "966": pack_idx
                    }

                    if (plantNum) {
                        dataCritFinal["APV004"] = "APV004_" + plantNum;
                    }
                    var dataCritVarFinal = {
                        "APVDT4": p_date,
                        "APVNM4": pack_no
                    }

                    backObjectFromWS.contextBlms = {
                        dataCrit: dataCritFinal,
                        dataCritVar: dataCritVarFinal
                    }
                }).finally(function () {
                    deferred.resolve(backObjectFromWS);
                });
            } else {
                deferred.resolve(backObjectFromWS);
            }

            return deferred.promise;
        }


        /**
        * Get all data critere from BVM.
        */
        function getDataCritereBvm(dataVeh, isFixe) {
            var dataCrit = [];
            if (isFixe) {
                dataCrit = dataVeh.DataCrit;
                var dataCrit211 = $filter("filter")(dataCrit, { CodeObjet: "211" });
                var dataCrit212 = $filter("filter")(dataCrit, { CodeObjet: "212" });
                var dataCrit996 = $filter("filter")(dataCrit, { CodeObjet: "996" });
                var dataCrit998 = $filter("filter")(dataCrit, { CodeObjet: "998" });
                var dataCrit997 = $filter("filter")(dataCrit, { CodeObjet: "997" });
                var dataCrit999 = $filter("filter")(dataCrit, { CodeObjet: "999" });
                // Stress arrière:correspond au code objet 212, à compléter si non présent dans la liste des critères
                if (dataCrit212.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "212",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.Stressar,
                        "LibelleCritere": "Stress arrière"
                    })
                }
                // Stress avant:correspond au code objet 211, à compléter si non  présent dans la liste des critères
                if (dataCrit211.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "211",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.Stressav,
                        "LibelleCritere": "Stress avant"
                    })
                }
                // correspond au code objet 996, à compléter si non présent dans la liste des critères.
                if (dataCrit996.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "996",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.IndBoi,
                        "LibelleCritere": "Indice Boite "
                    })
                }
                // correspond au code objet 998, à compléter si non présent dans la liste des critères.
                if (dataCrit998.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "998",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.IndMot,
                        "LibelleCritere": "Indice Moteur"
                    })
                }
                // Type Moteur:correspond au code objet 999, à compléter si non // présent dans la liste des critères
                if (dataCrit999.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "999",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.TypeMot,
                        "LibelleCritere": "Type Moteur"
                    })
                }
                // Type Boite:correspond au code objet 997, à compléter si nonv présent dans la liste des critères.
                if (dataCrit997.length === 0) {
                    dataCrit.push({
                        "CodeObjet": "997",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.TypeBoi,
                        "LibelleCritere": "Type Boite"
                    })
                }

                // Remplir dans le code objet APV001, avec un critère dont le mnemonique est ’APV001_ ‘ & la valeur
                if (dataVeh.UsiVeh) {
                    dataCrit.push({
                        "CodeObjet": "APV001",
                        "CodeCritere": "",
                        "Mnemonique": "APV001_" + dataVeh.UsiVeh,
                        "LibelleCritere": "filtre applicabilité pour famille véhicule"
                    });
                }


                // Remplir dans le code objet APV003, avec un critère dont le mnemonique est ’APV003_ ‘ & la valeur.
                if (dataVeh.UsiBoi) {
                    dataCrit.push({
                        "CodeObjet": "APV003",
                        "CodeCritere": "",
                        "Mnemonique": "APV003_" + dataVeh.UsiBoi,
                        "LibelleCritere": "filtre applicabilité pour famille organe Boite"
                    })
                }

                // Remplir dans le code objet APV002, avec un critère dont le mnemonique est ’APV002_ ‘ & la valeur
                if (dataVeh.UsiMot) {
                    dataCrit.push({
                        "CodeObjet": "APV002",
                        "CodeCritere": "",
                        "Mnemonique": "APV002_" + dataVeh.UsiMot,
                        "LibelleCritere": "filtre applicabilité pour famille organe Moteur"
                    })
                }


            } else {

                if (dataVeh.DateTcmFab) {
                    dataCrit.push({
                        "CodeObjet": "APVDT1",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.DateTcmFab,
                        "LibelleCritere": "Date de fabrication du véhicule"
                    })
                } else if (dataVeh.AnFab) {
                    dataCrit.push({
                        "CodeObjet": "APVDT1",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.AnFab,
                        "LibelleCritere": "Date de fabrication du véhicule"
                    })
                }

                if (dataVeh.NFab) {
                    dataCrit.push({
                        "CodeObjet": "APVNM1",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.NFab,
                        "LibelleCritere": "Numéro de fabrication du véhicule"
                    })
                }
                if (dataVeh.DateMot) {
                    dataCrit.push({
                        "CodeObjet": "APVDT2",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.DateMot,
                        "LibelleCritere": "Date de fabrication du Moteur"
                    })
                }
                if (dataVeh.NMot) {
                    dataCrit.push({
                        "CodeObjet": "APVNM2",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.NMot,
                        "LibelleCritere": "Numéro de fabrication du Moteur"
                    })
                }
                if (dataVeh.DateBoi) {
                    dataCrit.push({
                        "CodeObjet": "APVDT3",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.DateBoi,
                        "LibelleCritere": "Date de fabrication de la boite"
                    })
                }
                if (dataVeh.NBoi) {
                    dataCrit.push({
                        "CodeObjet": "APVNM3",
                        "CodeCritere": "",
                        "Mnemonique": dataVeh.NBoi,
                        "LibelleCritere": "Numéro de fabrication de la boite"
                    })
                }
            }


            return dataCrit;
        }

        /**
         * create a car context object with vin, registrationNumber, fixes criterias and variables criterias
         */
        function createRequestContextCar(data) {
            var dataCritFixe = {};
            var dataCritVar = {};

            data.vehicle.dataCrit.forEach(function (entry) {
                var codeCrit = entry.Mnemonique;
                var codeObj = entry.CodeObjet;

                dataCritFixe[codeObj] = codeCrit;

            });
            data.vehicle.dataCritVar.forEach(function (entry) {
                var codeCrit = entry.Mnemonique;
                var codeObj = entry.CodeObjet;
                dataCritVar[codeObj] = codeCrit;

            });
            var carContext = {
                "vin": data.vehicle.vin,
                "registrationNumber": data.vehicle.registrationNumber,
                "millesim": data.vehicle.millesim,
                "fixedCriterias": dataCritFixe,
                "variableCriterias": dataCritVar,
                "contextBLMS": data.vehicle.contextBlms, //TODO
                "tapv": data.vehicle.tapv
            }
            return carContext;
        }


        function historizationVehicleSave(User) {
            var defer = $q.defer();
            var contextCarSearch = getVehicleContext();
            var userVehicle = {};

            //if vehicle known by bvm, send vehcile informations from local storage
            if (contextCarSearch) {
                userVehicle = {
                    "vin": contextCarSearch.vehicle.vin,
                    "registrationNumber": contextCarSearch.vehicle.registrationNumber,
                    "model": contextCarSearch.vehicle.model
                };

                CarSearchWsService.historizationVehicleSaveWs(userVehicle).then(function (response) {
                    defer.resolve(response);
                }, function (response) {
                    defer.reject(response);
                });
            }

            return defer.promise;
        }

        function getVehicleContext() {
            return CacheService.getObject(CarSearchConstants.contextCarSearch);
        }

        function historizationVehicleLoad(user) {
            var defer = $q.defer();

            // var params = {ipn: user.userId, userType: user.userType};
           // var params = { ipn: user.ipn };

            CarSearchWsService.historizationVehicleLoadWs().then(function (response) {
                defer.resolve(response);
            }, function (response) {
                defer.reject(response);
            });
            return defer.promise;
        }

        function getUserContext() {
            var userContext = CacheService.getUserContext();


            var payload = {
                userContext: userContext
            }

            return payload;
        }

        function getBrandModelList() {
            var backRequest = getUserContext();
            var user = CacheService.getObject(RoutesConstants.profil);
            if(backRequest && backRequest.userContext && backRequest.userContext.userProfiles && user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)){
                backRequest.userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());      
            }

            return CarSearchWsService.getVehicleTreeFilter(backRequest);
        }
        
        function getTapvmbFilterListByBodyType(bodyType,familyCode) {
            var payload = {
                bodyType: bodyType,
                familyCode: familyCode
            };
            return CarSearchWsService.getVehicleTapvmbFilter(payload);
        }

        function getTapvmbFilterListByFamilyType(family) {
            var payload = {
                familyCode: family
            };
            return CarSearchWsService.getVehicleTapvmbFilter(payload);
        }

        function getTapvmbFilterList(data) {
            if(data && data.specialTools){
                var payload = data.criteria;
            }
            payload ? payload : {};
            return CarSearchWsService.getVehicleTapvmbFilter(payload);
        }
        
        function getLexiqueFilterList(family) {
            var userContext = CacheService.getUserContext();
            var payload = {
                userContext: userContext,
                familyCode: family
            }
            return CarSearchWsService.getVehicleLexiqueFilter(payload);
        }

        /**
         * Create struct of kit (favourites) to have the same workflow that this page
         */
        function transformWaintingPartListData(references) {
            var kit = { included: [] };
            for (var i = 0; i < references.length; i++) {
                delete references[i]['splitLabel'];
                references[i].ratio = references[i].quantity;
                kit.included.push(references[i]);
            }
            return kit;
        }


        /**
         * Apply operation on master piece and all its children if exists for PartList
         * Piece.included has not ratio attributes beacause they are created like kit but they are not.
         * @param {[type]}  piece        [description]
         * @param {[type]}  partList     [description]
         * @param {[type]}  addPiece     [description]
         */
        function addPieceAndChilds(piece, partList, addPiece) {
            var defer = $q.defer();
            $translate('PARTLIST_DMS_ERROR_CANT_ADD').then(function (text) {
                if (piece.included && piece.included.length > 0) { // CAS DU KIT

                    /* for (var index = 0; index < piece.included.length; index++) {
                        for (var indexQte = 0; indexQte < piece.included[index].quantity; indexQte++) {
                            if (piece.included[index].returnCodeFromDMS !== -1) {
                                updatePieceCouponService(piece.included[index], partList, addPiece, true);
                            }
                        }
                    } */
                    for (var included = 0; included < piece.included.length; included++) {
                        if (piece.included[included].returnCodeFromDMS === -1) {
                            toastr.error(text[1]);
                        }
                    }
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * @desc get user and car contexts and call metier service to get news data
         */
        function getBreakingNews (){
            var userContext = CacheService.getUserContext();
            userContext.userProfiles.push("");
            var carContext = CacheService.getCarContext();
            carContext = (carContext && carContext.fixedCriterias) ? carContext : null;
            var payload = {
                userContext: userContext,
                carContext: carContext
            }
            return CarSearchWsService.getBreakingNews(payload);
        }
        function getBannerDetails(){
            var bannerData='';               
            var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
            if(carContext && carContext.vehicle){ 
               bannerData += (carContext.vehicle.model !== undefined && carContext.vehicle.model != '') ? (carContext.vehicle.model + ', ') : '';
               bannerData += (carContext.vehicle.motorisation !== undefined && carContext.vehicle.motorisation != '') ? (carContext.vehicle.motorisation) : '';
               bannerData += (carContext.vehicle.gearBoxType !== undefined && carContext.vehicle.gearBoxType !== '') ? (', ' + carContext.vehicle.gearBoxType) : '';
            }
            return bannerData;
        }
        function getSparePartsDetails(){
            var carContext = CacheService.getCarContext();
            var selectedPartNrList = [];       
            var selectedSerialNrList = [];
            var selectedPart = [];
            if( !_.isEmpty(carContext) && !_.isEmpty(carContext.bvmExtraFields) && !_.isEmpty(carContext.variableCriterias)){
                if(!_.isEmpty(carContext.bvmExtraFields.refMot)){
                    selectedPartNrList.push(carContext.bvmExtraFields.refMot);
                }
                if(!_.isEmpty(carContext.bvmExtraFields.refBoi)){
                    selectedPartNrList.push(carContext.bvmExtraFields.refBoi);
                }      
                if(!_.isEmpty(carContext.variableCriterias.APVNM2)){
                    selectedSerialNrList.push(carContext.variableCriterias.APVNM2);
                }
                if(!_.isEmpty(carContext.variableCriterias.APVNM3)){
                    selectedSerialNrList.push(carContext.variableCriterias.APVNM3);
                }   
            }
            if(!_.isEmpty(selectedPartNrList) && !_.isEmpty(selectedSerialNrList) && selectedPartNrList.length === 2 && selectedSerialNrList.length === 2){
                selectedPart = [                    
                    {
                        partNr: selectedPartNrList[0],
                        serialNr:  selectedSerialNrList[0]
                    },
                    {
                        partNr: selectedPartNrList[1],
                        serialNr:  selectedSerialNrList[1]
                    }
                ]
            } else if (!_.isEmpty(selectedPartNrList) && !_.isEmpty(selectedSerialNrList) &&  (selectedPartNrList.length === 1 || selectedSerialNrList.length === 1)){
                selectedPart = [
                    {
                        partNr: selectedPartNrList[0],
                        serialNr:  selectedSerialNrList[0]
                    }
                ]
            } else {
                selectedPart = [];
            }
            var payload = {
                parts: selectedPart
            }
            return CarSearchWsService.getSparePartsDetails(payload).then(function (response){
                return filterSparePartsData(response);
            })
        }

        function filterSparePartsData(responsePwt){

            return $q.resolve().then(function () {
                var initResponse = angular.copy(responsePwt);
                if (responsePwt && !_.isEmpty(responsePwt) && _.has(responsePwt,'partsList') && !_.isEmpty(responsePwt.partsList)){
                    responsePwt.partsList =  _.filter(responsePwt.partsList,function(obj){
                        if((_.has(obj,'spareGenericPart') && !_.isEmpty(obj.spareGenericPart)) &&
                            (_.has(obj,'sparePartNr') && !_.isEmpty(obj.sparePartNr)) &&
                            (_.has(obj,'carryOverFlag') && _.isBoolean(obj.carryOverFlag)) && 
                            _.has(obj,'additionalSpareParts')){
                                if(_.isEmpty(obj.additionalSpareParts)){
                                    return true;
                                }else if(!_.isEmpty(obj.additionalSpareParts) && _.isArray(obj.additionalSpareParts) && obj.additionalSpareParts.length > 0){
                                    var isValidAdditional;
                                    for(var i =0;i < obj.additionalSpareParts.length; i++){
                                        var additionalSpareParts = obj.additionalSpareParts[i];
                                        if(_.has(additionalSpareParts,'lvaSparePartList') && _.isArray(additionalSpareParts.lvaSparePartList) && additionalSpareParts.lvaSparePartList.length > 0){

                                            for(var j =0; j < additionalSpareParts.lvaSparePartList.length; j++){
                                                var lvaSparePartList = additionalSpareParts.lvaSparePartList[j];
                                                if((_.has(lvaSparePartList,'lvaPartNr') && !_.isEmpty(lvaSparePartList.lvaPartNr)) &&
                                                    (_.has(lvaSparePartList,'lvaPartQuantity') && _.isNumber(lvaSparePartList.lvaPartQuantity) && lvaSparePartList.lvaPartQuantity > 0)){
                                                        isValidAdditional = true;
                                                }else{
                                                        isValidAdditional = false;
                                                        break;
                                                }
                                            }

                                            if(!isValidAdditional){
                                                break;
                                            }
                                        }else{
                                            isValidAdditional = false;
                                            break;
                                        }
                                    }

                                    return isValidAdditional;
                                }
                            }else{
                                return false;
                            }

                    })
                    return responsePwt;
                }else{
                    return responsePwt;
                }
            
            }).catch(function(error){
                return $q.reject(error);
            });
        }


        function setLocalizedData(hasData,data){
            vm.localizedData = {
                hasData : hasData,
                data : data
            }

        }

        function getLocalizedData(){
            return vm.localizedData;
        }

        function getEnggInfoForParts(data){
            return CarSearchWsService.getEnggInfoForParts(data);
        }

        /**
         * @desc store the care alert data for the current vin, so the alert text
         * in recapCar can be shown and the popup opened on demand
         */
        function setCareAlertData(data) {
            CacheService.setObject(CacheConstants.careAlertData, data || null);
        }

        function getCareAlertData() {
            return CacheService.getObject(CacheConstants.careAlertData);
        }

        function openCareAlertPopup() {
            var data = getCareAlertData();
            if (!data) {
                return $q.resolve();
            }

            var isFrench = /^fr(?:-|$)/i.test($translate.use() || '');
            var reasons = Array.isArray(data.vinIsRedReasons) ? data.vinIsRedReasons : [];
            var reasonItems = reasons.map(function (reason) {
                var incidentLabel = isFrench ? reason.codeLabelFr : reason.codeLabelEn;
                return '<li>' + (incidentLabel || '') + '</li>';
            }).join('');

            return $mdDialog.show({
                template: '<md-dialog class="care-alert-dialog" aria-label="Care Alert">' +
                    '<div class="care-alert-header">' + $translate.instant('CARE_ALERT_TITLE') + '</div>' +
                    '<md-dialog-content class="care-alert-content">' +
                    '<div class="care-alert-question">' + $translate.instant('CARE_ALERT_QUESTION') + '</div>' +
                    '<ul class="care-alert-reason">' + reasonItems + '</ul>' +
                    '<p class="care-alert-confirmation">' + $translate.instant('CARE_ALERT_CONFIRMATION') + '</p>' +
                    '<md-button class="care-alert-button" ng-click="close()">' + $translate.instant('CARE_ALERT_UNDERSTOOD') + '</md-button>' +
                    '</md-dialog-content></md-dialog>',
                clickOutsideToClose: true,
                escapeToClose: false,
                controller: function ($scope) {
                    $scope.close = function () {
                        $mdDialog.hide();
                    };
                }
            });
        }
    }

})();

(function () {
angular
.module('phenix')
.constant('carSearchMock', {
    inputData:{
        VIN:"VF1BB0A0F22171627",
        brandComputed: "APL03"
    },

    inputData2:{
        VIN:"VF1BB0A0F22171627",
        brandComputed: "APL03",
        "336" : "APL03"
    },

    carContext:{
        fixedCriterianull:
        {
            VIN:"VF1BB0A0F22171627",
        brandComputed: "APL03",
        "336" : "APL03"
        },

        fixedCriteriapresent:
    {
        VIN:"VF1BB0A0F22171627",
        brandComputed: "APL03",
        "336" : "APL03"
        }
       
        
  },
  data: {
    carContext:
    {
      "vin": "9FBHSRAJNCM000016",
      "registrationNumber": null,
      "millesim": "00000",
      "fixedCriterias": {
        "007": "X79",
        "008": "U79",
        "336": "APL03",
        "900": "M2021",
        "901": "PHAS1",
        "996": "225",
        "997": "DP2",
        "999": "F4R"
      },
      "typeMD": "B2-3"
    }
  },
  listCriterias:
    [
      {
        "criteriaCode": "PHAS1",
        "objectCode": "901",
        "label": "PHASE DOCUMENTAIRE 1 (PHAS1)"
      },
      {
        "criteriaCode": "PHAS2",
        "objectCode": "901",
        "label": "PHASE DOCUMENTAIRE 2 (PHAS2)"
      },
      {
        "criteriaCode": "M2021",
        "objectCode": "900",
        "label": "PERIODE DOC. 2021 (M2021)"
      }
    ],
  fieldSearchModel: {
    "fields4": [
      {
        "key": "phase",
        "code": "901",
        "defaultOption": "VEHICLE_PHASE",
        "tmp": [

        ],
        "list": [
          {
            "objectCode": "901",
            "label": "DOCUMENTATION PHASE 1 (PHAS1)",
            "criteriaCode": "PHAS1"
          },
          {
            "objectCode": "901",
            "label": "DOCUMENTATION PHASE 2 (PHAS2)",
            "criteriaCode": "PHAS2"
          }
        ],
        "value": null
      },
      {
        "key": "Documentryperiod",
        "code": "900",
        "defaultOption": "VEHICLE_DOCUMENTRARY_PERIOD",
        "tmp": [

        ],
        "list": [
          {
            "objectCode": "900",
            "label": "DOCUMENTARY PERIOD 2021 (M2021)",
            "criteriaCode": "M2021"
          },
          {
            "objectCode": "900",
            "label": "DOCUMENTARY PERIOD 2021 (PE2021)",
            "criteriaCode": "PE2021"
          }
        ],
        "value": null
      }
    ]
  }
})
})();
(function() {

    angular
        .module('phenix')
        .service('CarSearchByModelService', CarSearchByModelService);

    /* @ngInject */
    function CarSearchByModelService() {
        this.defineRules = defineRules;

        ////////////////

        function defineRules(vm) {

            // If this unfamiliar to you, Object.defineProperties is a way to create
            // computed properties on an object.
            Object.defineProperties(vm.rules, {
                'brand': {
                    enumerable: true,
                    get: function () {
                        return false;
                    }
                },
                'familyCode': {
                    enumerable: true,
                    get: function () {
                        return vm.fields[0].value === null;
                    }
                },
                'modelType': {
                    enumerable: true,
                    get: function () {
                        if (vm.isFamilyCodeXTPorXRQ(vm.fields)) {
                            return true;
                        } else {
                            return vm.fields[1].value === null;
                        }
                    }
                },
                'engine': {
                    enumerable: true,
                    get: function () {
                        if (vm.isFamilyCodeXTPorXRQ(vm.fields)) {
                            return false;
                        } else {
                            return vm.fields[2] && vm.fields[2].value === null;
                        }
                    }
                },
                'gearbox': {
                    enumerable: true,
                    get: function () {
                        if (vm.isFamilyCodeXTPorXRQ(vm.fields)) {
                            return false;
                        } else {
                            return vm.fields[2] && vm.fields[2].value === null;
                        }
                    }
                },
                'tractionBattery': {
                    enumerable: true,
                    get: function () {
                        return vm.fields2[1].value === null;
                    }
                },
                'engineIndex': {
                    enumerable: true,
                    get: function () {
                        return vm.fields2[0].value === null || vm.fields2[1].value === null;
                    }
                },
                'gearboxIndex': {
                    enumerable: true,
                    get: function () {
                        return vm.fields2[0].value === null || vm.fields2[1].value === null;
                    }
                },
                'batteryIndex': {
                    enumerable: true,
                    get: function () {
                        return vm.fields2[0].value === null || vm.fields2[1].value === null;
                    }
                },
                'additionalFields': {
                    enumerable: true,
                    get: function () {
                        return vm.fields2[1].value === null || vm.fields2[0].value === null;
                    }
                }




            });
        }

    }
})();

(function () {
    angular.module('phenix').controller('modalInformationController', modalInformationController);

    function modalInformationController(
        LoginMetierService,
        CacheService,
        CacheConstants,
        information,
        $mdDialog, $scope,on_complete,on_consent) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.message = information;
        vm.dialogClosed = false;

        vm.onClose = onClose;
        vm.onConsent = onConsent;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        function onClose(){           
            CacheService.removeObject(CacheConstants.angularInfoServiceDetails);
            CacheService.removeObject(CacheConstants.informationServiceDetails);
            $mdDialog.hide();            
        }

        $scope.$on('$destroy', function() {
            var infoDetails = _.omit(CacheService.getObject(CacheConstants.informationMessage),'message');
            CacheService.setObject(CacheConstants.informationMessage,infoDetails);
            vm.dialogClosed = true;
            on_complete(vm.dialogClosed);
        });

        function onConsent(){           
            if (on_consent) {
                on_consent();
            }
            $mdDialog.hide();
            LoginMetierService.saveInfoConsent();
        }
    }

})();

(function () {
    angular.module('phenix').factory('customerListPaginationService', function (DmsMetierService, DmsConstants, $q,$log,$translate) {
        var vm = this;
        // var service = function () {
            vm.MAX_CUSTOMER_PER_PAGE = 10;
            vm.customerToLookFor;

            vm.DMSMaxPage = null;
            vm.DMSActualPage = 0;

            vm.page = 0;

            vm.customersRest = [];

            //  All customers fetched from DMS is stored inside vm variable
            //  It's used when the user click on previous
            vm.customersHistory = [];
        // }

        var service = {
            get: get,
            next: next,
            previous: previous,
            fetchMoreCustomers: fetchMoreCustomers,
            assignNextAndPrevious: assignNextAndPrevious,
            filterCostumers: filterCostumers,
            canFetchMoreCustomers: canFetchMoreCustomers
        }

        return service;

        /**
         *  vm pagination is specific cause the service doesnt filter user with vehicle or not
         *  so we need to handle it
         */

        /**
         *  @desc   vm function should be use on the first call when we search a customer
         *          If we need more use `next` function, in other way `previous` function
         *
         *          vm service returns a list of customers, and 2 booleans that informs
         *          if we can click on previous / next
         *
         *  @param {object} customerToLookFor {
         *      firstName: string
         *      lastName: string
         *  }
         *  @return {promise<Object>} {
         *      costumers: Array<Object>
         *      previous: boolean
         *      page: number
         *      next: boolean
         *  }
         */

        function get(customerToLookFor) {
            vm.customerToLookFor = customerToLookFor
            

            return DmsMetierService
                .getCustomers(customerToLookFor, 0)
                .then(function (res) {
                    // for the first call, we save the "limit" of pagination (total page)
                    //if(res){
                        if(res.numberOfCustomers > vm.MAX_CUSTOMER_PER_PAGE)
                            vm.DMSMaxPage = parseInt(res.numberOfCustomers / vm.MAX_CUSTOMER_PER_PAGE);
                        return res.customers;
                    /* }else{
                        return $q.reject();
                    } */
                }).then(filterCostumers).then(function (customers) {
                    if (canFetchMoreCustomers(customers.length)) {
                        return fetchMoreCustomers(customerToLookFor, customers);
                    }
                    return customers;
                }).then(function (customers) {
                    if (!customers.length) {
                        return $q.reject(DmsConstants.errors.NO_CUSTOMERS)
                    }
                    return customers;
                }).then(function (customers) {
                    vm.customersHistory = customers;
                    return customers;
                }).then(assignNextAndPrevious.bind(vm))
                .catch(function(err){
                    return $q.reject(err);
                })
        };


        /**
         *      @return {promise<Object>} {
         *          costumers: Array<Object>
         *          previous: boolean
         *          page: number
         *          next: boolean
         *      }
         */

        function next () {
            vm.page++;

            var start = vm.page * vm.MAX_CUSTOMER_PER_PAGE;
            var end = start + vm.MAX_CUSTOMER_PER_PAGE;

            // check if at vm index we have a customer, if it's the case so we recover from vm one
            if (vm.customersHistory[start]) {
                return $q.resolve(vm.customersHistory.slice(start, end)).then(assignNextAndPrevious.bind(vm));
            }

            var customers = vm.customersRest;
            vm.customersRest = [];

            return fetchMoreCustomers(vm.customerToLookFor, customers).then(function (customers) {
                vm.customersHistory = vm.customersHistory.concat(customers);
                return customers;
            }).then(assignNextAndPrevious.bind(vm));
        }

        /**
         *      @return {promise<Object>} {
         *          costumers: Array<Object>
         *          previous: boolean
         *          page: number
         *          next: boolean
         *      }
         */

         function previous() {
            vm.page--;

            var start = vm.page * vm.MAX_CUSTOMER_PER_PAGE;
            var end = start + vm.MAX_CUSTOMER_PER_PAGE;

            return $q.resolve(vm.customersHistory.slice(start, end)).then(assignNextAndPrevious.bind(vm));
        }

        /**
         *      @desc vm function is recursif, he call him vm until we have enough
         *            customers (vm.MAX_CUSTOMER_PER_PAGE)
         *
         *      @param {Array<Object>} costumerToLookFor {
         *          firstName: string
         *          lastName: string
         *      }
         *      @param {Array<Object>} _CUSTOMERS
         *      @return {Array<Object>}
         */

         function fetchMoreCustomers (costumerToLookFor, _CUSTOMERS) {
            vm.DMSActualPage++;
            return DmsMetierService.getCustomers(costumerToLookFor, vm.DMSActualPage).then(function (res) {
                return res.customers;
            }).then(filterCostumers).then(function (newCustomers) {
                var totalCustomers = newCustomers.length + _CUSTOMERS.length;
                var limit = vm.MAX_CUSTOMER_PER_PAGE - _CUSTOMERS.length;

                if (totalCustomers > vm.MAX_CUSTOMER_PER_PAGE) {
                    _CUSTOMERS = _CUSTOMERS.concat(newCustomers.slice(0, limit))
                    vm.customersRest = newCustomers.slice(limit, newCustomers.length);
                    return _CUSTOMERS;
                } else if (canFetchMoreCustomers(totalCustomers)) {
                    _CUSTOMERS = _CUSTOMERS.concat(newCustomers);
                    return fetchMoreCustomers(costumerToLookFor, _CUSTOMERS);
                } else {
                    _CUSTOMERS = _CUSTOMERS.concat(newCustomers);
                    return _CUSTOMERS;
                }
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            })
        };

        /**
         *      @desc vm service should return a list of customers, and 2 booleans that informs
         *            if we can click on previous / next
         *
         *      @param {array<Object>} _CUSTOMERS
         *      @return {object} {
         *          customers: Array<Object>,
         *          previous: boolean,
         *          next: boolean
         *          page: number
         *      }
         */

         function assignNextAndPrevious (_CUSTOMERS) {
            return {
                customers: _CUSTOMERS,
                previous: vm.page > 0,
                next: vm.DMSActualPage < vm.DMSMaxPage,
                page: vm.page
            }
        };



        /***************************
         *         TOOLS           *
         **************************/

        /**
         *      @desc Filter customers who only have a vehicle
         *
         *      @param {array<Object>} customers
         *      @return {array<Object>}
         */

         function filterCostumers(customers) {
            return customers.filter(function (customer) {
                return customer.vehicles && customer.vehicles.length;
            })
        }

        /**
         *      @desc check if we can fetch more customers
         *
         *      @param {number} numberOfCustomers
         *      @return {boolean}
         */

         function canFetchMoreCustomers (numberOfCustomers) {
            return numberOfCustomers < vm.MAX_CUSTOMER_PER_PAGE && vm.DMSActualPage < vm.DMSMaxPage
        }

        
    });
})();

(function () {
    angular.module('phenix').controller('bannerRGPDController', bannerRGPDController);

    function bannerRGPDController($mdDialog,CacheService, ProfilMetierService, CacheConstants,configConstantes) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.isBannerVisible = true;
        vm.isallowedFunctioningCookies = false;
        vm.isallowedAudienceCookies = true;
        vm.isManagingCookies = false;
        vm.functioningCookies = false;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        vm.toggleMenuManageCookies = toggleMenuManageCookies;
        vm.onAgree = onAgree;

        function toggleMenuManageCookies() {
            vm.functioningCookies = !vm.functioningCookies;
        }
        function onAgree() {
            vm.isBannerVisible = false;
            var profil = CacheService.getObject(CacheConstants.profil);
            // init payload to be sent to PostGre
            var payload = {
                'ipn': profil.ipn,
                'userId': profil.userId,
                'portal': profil.language,
                'documentationFirstLanguage': profil.documentationFirstLanguage,
                'documentationSecondLanguage': profil.documentationSecondLanguage,
                'mentions': profil.mentions,
                'header': profil.header,
                'isGdprAccepted': true,
                'gdprTimeOutDate': getVisitorCookiesTimeout(),
                'isLandscape': profil.isLandscape,
                'isPRFormat': profil.isPRFormat
            };

            // and save profile choices
            if (vm.isallowedAudienceCookies) {
                payload.isGdprAudienceAllowed = true;
            } else {
                //send gdpr cookies to PostGre
                payload.isGdprAudienceAllowed = false;
            }

            // send request to update user profile
            ProfilMetierService.updateProfil(payload);
            profil.isGdprAccepted = payload.isGdprAccepted;
            profil.isGdprAudienceAllowed = payload.isGdprAudienceAllowed;
            profil.gdprTimeOutDate = payload.gdprTimeOutDate;
            profil.isLandscape = payload.isLandscape;
            profil.isPRFormat = payload.isPRFormat;
            CacheService.setUserProfile(profil);
            $mdDialog.hide();
        }
        /**
         *  cookieTimeout 13 months in seconds
         * @returns
         */
        function getVisitorCookiesTimeout() {
            var dateNow = new Date();
            var dateNowInSeconds = Math.round(dateNow.getTime() / 1000);
            var cookieTimeout = 33696000;
            return (dateNowInSeconds + cookieTimeout);
        }
    }
})();

(function () {

    angular
        .module('phenix')
        .component('bannerRgpd', {
            bindings: {
                isBannerVisible: '='
            },
            controller: bannerRGPDCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/carSearch/components/bannerRGPD.template.html',
        });

    function bannerRGPDCtrl($rootScope, $window, CacheService, ProfilMetierService, CacheConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.banner = document.getElementById("rgpdMain");
        vm.isBannerVisible = true;
        vm.isallowedFunctioningCookies = false;
        vm.isallowedAudienceCookies = true;
        vm.isManagingCookies = false;
        var manageCookiesClass = ".menuManageCookies";

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        vm.toggleMenuManageCookies = toggleMenuManageCookies;
        vm.onAgree = onAgree;
        vm.onChangeAudienceCookiesAllowance = onChangeAudienceCookiesAllowance;

        vm.$onInit = function(){
            $(manageCookiesClass)[0].style.display = "none";
        };

        $(window).resize(function () {
            setBannerBlock();
        });

        window.onscroll = function () {
            setBannerBlock();
        };

        //handle hiding on click outside the menu manage cookies div
        $(window).on('click', function (e) {
            if ($(manageCookiesClass) && $(manageCookiesClass)[0] && $(manageCookiesClass)[0].style.display === "block") {
                var parentNodeX = e.target.parentNode;
                var idList = [];
                var isHideMenu = true;
                var isExceptionForButton = false;
                for (var i = 0; i < 5; i++) {
                    idList.push(parentNodeX.id);
                    parentNodeX = parentNodeX.parentNode;
                }

                angular.forEach(idList, function (id) {
                    if (id === "menuManageCookies") {
                        isHideMenu = false;
                    }
                    //exception : don't try to hide when clicking on button manage cookies
                    if (id === "manageCookiesBtn") {
                        isExceptionForButton = true;
                    }
                });

                if (isHideMenu && !isExceptionForButton) {
                    $(manageCookiesClass).hide();
                }
            }
        });

        /**
         * @desc Action fired on click button Manage cookies : menu manage cookies shows/hides
         */
        function toggleMenuManageCookies() {
            if ($(manageCookiesClass)[0].style.display === "none") {
                $(manageCookiesClass)[0].style.display = "block";
            } else {
                $(manageCookiesClass).hide();
            }
        }

        /**
         * @desc Action fired when clicking button "I agree" of banner GDPR
         */
        function onAgree() {
            vm.isBannerVisible = false;
            var profil = CacheService.getObject(CacheConstants.profil);
            // init payload to be sent to PostGre
            var payload = {
                "ipn": profil.ipn,
                "userId": profil.userId,
                "portal": profil.language,
                "documentationFirstLanguage": profil.documentationFirstLanguage,
                "documentationSecondLanguage": profil.documentationSecondLanguage,
                "mentions": profil.mentions,
                "header": profil.header,
                "isGdprAccepted": true,
                'isLandscape': profil.isLandscape,
                'isPRFormat': profil.isPRFormat,
                "gdprTimeOutDate": getVisitorCookiesTimeout()
            };

            // and save profile choices
            if (vm.isallowedAudienceCookies) {
                payload.isGdprAudienceAllowed = true;
            } else {
                //send gdpr cookies to PostGre
                payload.isGdprAudienceAllowed = false;
            }

            // send request to update user profile 
            ProfilMetierService.updateProfil(payload);

            // update cache
            profil.isGdprAccepted = payload.isGdprAccepted;
            profil.isGdprAudienceAllowed = payload.isGdprAudienceAllowed;
            profil.isLandscape = payload.isLandscape;
            profil.isPRFormat = payload.isPRFormat;
            profil.gdprTimeOutDate = payload.gdprTimeOutDate;
            CacheService.setUserProfile(profil);
        }

        /**
         * @desc Calculation of GDPR agreement time out
         */
        function getVisitorCookiesTimeout() {
            var dateNow = new Date();
            var dateNowInSeconds = Math.round(dateNow.getTime() / 1000);
            var cookieTimeout = 33696000; // 13 months in seconds
            var dateOfTimeout = dateNowInSeconds + cookieTimeout;
            return dateOfTimeout;
        }

        /**
         * @desc action fired when clicking button audience measurement
         */
        function onChangeAudienceCookiesAllowance() {
            vm.isallowedAudienceCookies = !vm.isallowedAudienceCookies;
        }

        /**
         * @desc set position where banner sticks to bottom and not to footer
         */
        function setBannerBlock() {
            vm.maxScroll = Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight) - window.innerHeight;

            var difference = vm.maxScroll - window.pageYOffset;
            if (difference < 5) {
                vm.banner.classList.add("banner-sticky");
            }
            else {
                vm.banner.classList.remove("banner-sticky");
            }
        }
    }
})();

(function () {
    angular.module('phenix').service('AxleGeometryWSService', AxleGeometryWSService);


    /* @ngInject */
    function AxleGeometryWSService(
        RestUpgrade,
        $q,

        ApplicabilitiesConstants
    ) {

        this.calculate = function (payload) {
            return RestUpgrade.all(ApplicabilitiesConstants.axleGeometryCalcule).post(payload);
        }

        this.getApplicabilities = function (payload) {
            return RestUpgrade.all(ApplicabilitiesConstants.axleGeometry).post(payload).then(function (res) {
                if (!res) {
                    return $q.reject();
                } else if (!Object.keys(res).length) {
                    return null;
                } else if (!res.axleGeometry.length) {
                    return null;
                }
                return res.axleGeometry;
            });
        }
    }
})();

(function () {

    /* @ngInject */
    angular.module('phenix').service('AxleGeometryService', function (AxleGeometryWSService,


        CacheService,

        $q
    ) {

        this.getApplicabilities = getApplicabilities;
        this.calculate = calculate;

        this.formatGeometry = formatGeometry;


        /**
         *  @desc get residual applicabilies from geometry service
         */

        function getApplicabilities() {
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();

            return AxleGeometryWSService.getApplicabilities({
                userContext: userContext,
                carContext: carContext
            })
        }

        /**
         *  @desc Send measures of wheels, and get the result
         *  @return {Array<string> or Object} Array on errors - Object on success
         */

        function calculate(id, sizes) {
            var payload = {
                id: id,
                wheelParams: {
                    frontRighthandWheel: {
                        distanceW: sizes.rightFrontW.value,
                        distanceR: sizes.rightFrontR.value
                    },
                    frontLefthandWheel: {
                        distanceW: sizes.leftFrontW.value,
                        distanceR: sizes.leftFrontR.value
                    },
                    rearRighthandWheel: {
                        distanceW: sizes.rightRearW.value,
                        distanceR: sizes.rightRearR.value
                    },
                    rearLefthandWheel: {
                        distanceW: sizes.leftRearW.value,
                        distanceR: sizes.leftRearR.value
                    }
                }
            }
            return AxleGeometryWSService.calculate(payload).then(function (res) {
                var errors = [];

                if (res.frontLefthandWheel.zk < res.zkLimit.minFront || res.frontLefthandWheel.zk > res.zkLimit.maxFront) {
                    errors = errors.concat(['leftFrontW', 'leftFrontR'])
                }

                if (res.frontRighthandWheel.zk < res.zkLimit.minFront || res.frontRighthandWheel.zk > res.zkLimit.maxFront) {
                    errors = errors.concat(['rightFrontW', 'rightFrontR'])
                }

                if (res.rearLefthandWheel.zk < res.zkLimit.minBack || res.rearLefthandWheel.zk > res.zkLimit.maxBack) {
                    errors = errors.concat(['leftRearW', 'leftRearR'])
                }

                if (res.rearRighthandWheel.zk < res.zkLimit.minBack || res.rearRighthandWheel.zk > res.zkLimit.maxBack) {
                    errors = errors.concat(['rightRearW', 'rightRearR'])
                }

                if (errors.length) {
                    return $q.reject(errors);
                }

                return res;
            }).then(function (res) {
                res.frontRighthandWheel = formatGeometry(res.frontRighthandWheel);
                res.frontLefthandWheel = formatGeometry(res.frontLefthandWheel);
                res.rearRighthandWheel = formatGeometry(res.rearRighthandWheel);
                res.rearLefthandWheel = formatGeometry(res.rearLefthandWheel);
                return res;
            });
        }

        /**
         *  @desc
         *          Receive something like :
         *
         *  @in
         *
         *  { x: 1.5 }
         *
         *  @out
         *
         *  { x: 1.5, x_ : 1° 3' }
         *
         *  @param  {Object}
         *  @return {Object} new Object
         *
         */

        function formatGeometry(res) {
            var computedRes = _.assign({}, res);

            for (var element in computedRes) {
                var data = computedRes[element].toString().split('.');

                if (data.length !== 2) {
                    continue;
                }

                var celcius = data[0];
                var time = Math.round(data[1] / 100 * 60);

                computedRes[element + '_'] = celcius + '° ' + time + '\'';
            }
            return computedRes;
        }

    });
})();

(function () {
    angular.module('phenix').constant('ApplicabilitiesX70Constants', {
        applicabilitiesLabelX70: {
            "de": [
                {
                    "id": "016",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder - 302148"
                },
                {
                    "id": "017",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder + 10 mm Unterlegscheibe - 059853/812459"
                },
                {
                    "id": "018",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder 10.7 - 314662/812456"
                },
                {
                    "id": "019",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder 10.7 + 45 mm Unterlegscheibe - 311071/812461"
                },
                {
                    "id": "020",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder 17 - 296353/812460"
                },
                {
                    "id": "021",
                    "label": "Fahrgestell kurz - Stahl-Einzelblattfeder 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Fahrgestell kurz - Verbundwerkstoff-Einzelblattfeder (weiß/transparent)"
                },
                {
                    "id": "023",
                    "label": "Fahrgestell lang - Doppelblattfeder - 302148"
                },
                {
                    "id": "024",
                    "label": "Fahrgestell lang - Doppelblattfeder + 10 mm Unterlegscheibe - 059853/812459"
                },
                {
                    "id": "025",
                    "label": "Fahrgestell lang - Stahl-Einzelblattfeder 10.7 - 314662/812456"
                },
                {
                    "id": "026",
                    "label": "Fahrgestell lang - Stahl-Einzelblattfeder 10.7 + 45 mm Unterlegscheibe - 311071/812461"
                },
                {
                    "id": "027",
                    "label": "Fahrgestell lang - Stahl-Einzelblattfeder 17 - 296353/812460"
                },
                {
                    "id": "028",
                    "label": "Fahrgestell lang - Stahl-Einzelblattfeder 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Fahrgestell lang - Verbundwerkstoff-Einzelblattfeder (weiß/transparent)"
                },
                {
                    "id": "030",
                    "label": "Standard-Fahrgestell - Doppelblattfeder - 302148"
                },
                {
                    "id": "031",
                    "label": "Standard-Fahrgestell - Doppelblattfeder + 10 mm Unterlegscheibe - 059853/812459"
                },
                {
                    "id": "032",
                    "label": "Standard-Fahrgestell - Stahl-Einzelblattfeder 10.7 - 314662/812456"
                },
                {
                    "id": "033",
                    "label": "Standard-Fahrgestell - Stahl-Einzelblattfeder 10.7 + 45 mm Unterlegscheibe - 311071/812461"
                },
                {
                    "id": "034",
                    "label": "Standard-Fahrgestell - Stahl-Einzelblattfeder 17 - 296353/812460"
                },
                {
                    "id": "035",
                    "label": "Standard-Fahrgestell - Stahl-Einzelblattfeder 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standard-Fahrgestell - Verbundwerkstoff-Einzelblattfeder (weiß/transparent)"
                }
            ],
            "el": [
                {
                    "id": "016",
                    "label": "Κοντό αμάξωμα - Διπλό έλασμα ελατηρίου - 302148"
                },
                {
                    "id": "017",
                    "label": "Κοντό αμάξωμα - Διπλό έλασμα ελατηρίου + αποστάτης 10mm - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Κοντό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Κοντό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 + αποστάτης 45mm - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Κοντό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Κοντό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Κοντό αμάξωμα - Σύνθετο μονό έλασμα ελατηρίου (λευκό/ημιδιαφανές)"
                },
                {
                    "id": "023",
                    "label": "Μακρύ αμάξωμα - Διπλό έλασμα ελατηρίου - 302148"
                },
                {
                    "id": "024",
                    "label": "Μακρύ αμάξωμα - Διπλό έλασμα ελατηρίου + αποστάτης 10mm - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Μακρύ αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Μακρύ αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 + αποστάτης 45mm - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Μακρύ αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Μακρύ αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Μακρύ αμάξωμα - Σύνθετο μονό έλασμα ελατηρίου (λευκό/ημιδιαφανές)"
                },
                {
                    "id": "030",
                    "label": "Κανονικό αμάξωμα - Διπλό έλασμα ελατηρίου - 302148"
                },
                {
                    "id": "031",
                    "label": "Κανονικό αμάξωμα - Διπλό έλασμα ελατηρίου + αποστάτης 10mm - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Κανονικό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Κανονικό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 10.7 + αποστάτης 45mm - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Κανονικό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Κανονικό αμάξωμα - Μονό χαλύβδινο έλασμα ελατηρίου 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Κανονικό αμάξωμα - Σύνθετο μονό έλασμα ελατηρίου (λευκό/ημιδιαφανές)"
                }
            ],
            "en": [
                {
                    "id": "016",
                    "label": "Short chassis - Dual leaf spring - 302148"
                },
                {
                    "id": "017",
                    "label": "Short chassis - Dual leaf spring + 10mm shim - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Short chassis - Steel single leaf spring 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Short chassis - Steel single leaf spring 10.7 + 45mm shim - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Short chassis - Steel single leaf spring 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Short chassis - Steel single leaf spring 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Short chassis - Composite single leaf spring (white/translucent)"
                },
                {
                    "id": "023",
                    "label": "Long chassis - Dual leaf spring - 302148"
                },
                {
                    "id": "024",
                    "label": "Long chassis - Dual leaf spring + 10mm shim - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Long chassis - Steel single leaf spring 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Long chassis - Steel single leaf spring 10.7 + 45mm shim - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Long chassis - Steel single leaf spring 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Long chassis - Steel single leaf spring 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Long chassis - Composite single leaf spring (white/translucent)"
                },
                {
                    "id": "030",
                    "label": "Standard chassis - Dual leaf spring - 302148"
                },
                {
                    "id": "031",
                    "label": "Standard chassis - Dual leaf spring + 10mm shim - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standard chassis - Steel single leaf spring 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standard chassis - Steel single leaf spring 10.7 + 45mm shim - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standard chassis - Steel single leaf spring 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standard chassis - Steel single leaf spring 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standard chassis - Composite single leaf spring (white/translucent)"
                }
            ],
            "es": [
                {
                    "id": "016",
                    "label": "Chasis corto - Ballesta doble - 302148"
                },
                {
                    "id": "017",
                    "label": "Chasis corto - Ballesta doble + cala de 10 mm - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Chasis corto - Ballesta simple de acero 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Chasis corto - Ballesta simple de acero 10.7 + cala de 45 mm - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Chasis corto - Ballesta simple de acero 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Chasis corto - Ballesta simple de acero 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Chasis corto - Ballesta simple de material compuesto (blanco/translúcido)"
                },
                {
                    "id": "023",
                    "label": "Chasis largo - Ballesta doble - 302148"
                },
                {
                    "id": "024",
                    "label": "Chasis largo - Ballesta doble + cala de 10 mm - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Chasis largo - Ballesta simple de acero 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Chasis largo - Ballesta simple de acero 10.7 + cala de 45 mm - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Chasis largo - Ballesta simple de acero 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Chasis largo - Ballesta simple de acero 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Chasis largo - Ballesta simple de material compuesto (blanco/translúcido)"
                },
                {
                    "id": "030",
                    "label": "Chasis de serie - Ballesta doble - 302148"
                },
                {
                    "id": "031",
                    "label": "Chasis de serie - Ballesta doble + cala de 10 mm - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Chasis de serie - Ballesta simple de acero 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Chasis de serie - Ballesta simple de acero 10.7 + cala de 45 mm - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Chasis de serie - Ballesta simple de acero 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Chasis de serie - Ballesta simple de acero 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Chasis de serie - Ballesta simple de material compuesto (blanco/translúcido)"
                }
            ],
            "fi": [
                {
                    "id": "016",
                    "label": "Lyhyt alusta - Kaksinkertainen lehtijousi - 302148"
                },
                {
                    "id": "017",
                    "label": "Lyhyt alusta - Kaksinkertainen lehtijousi + 10 mm kiila - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Lyhyt alusta - Yksinkertainen teräslehtijousi 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Lyhyt alusta - Yksinkertainen teräslehtijousi 10.7 + 45 mm kiila - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Lyhyt alusta - Yksinkertainen teräslehtijousi 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Lyhyt alusta - Yksinkertainen teräslehtijousi 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Lyhyt alusta - Yksinkertainen komposiittilehtijousi (valkoinen/läpinäkyvä)"
                },
                {
                    "id": "023",
                    "label": "Pidennetty alusta - Kaksinkertainen lehtijousi - 302148"
                },
                {
                    "id": "024",
                    "label": "Pidennetty alusta - Kaksinkertainen lehtijousi + 10 mm kiila - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Pidennetty alusta - Yksinkertainen teräslehtijousi 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Pidennetty alusta - Yksinkertainen teräslehtijousi 10.7 + 45 mm kiila - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Pidennetty alusta - Yksinkertainen teräslehtijousi 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Pidennetty alusta - Yksinkertainen teräslehtijousi 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Pidennetty alusta - Yksinkertainen komposiittilehtijousi (valkoinen/läpinäkyvä)"
                },
                {
                    "id": "030",
                    "label": "Vakioalusta - Kaksinkertainen lehtijousi - 302148"
                },
                {
                    "id": "031",
                    "label": "Vakioalusta - Kaksinkertainen lehtijousi + 10mm kiila - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Vakioalusta - Yksinkertainen teräslehtijousi 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Vakioalusta - Yksinkertainen teräslehtijousi 10.7 + 45 mm kiila - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Vakioalusta - Yksinkertainen teräslehtijousi 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Vakioalusta - Yksinkertainen teräslehtijousi 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Vakioalusta - Yksinkertainen komposiittilehtijousi (valkoinen/läpinäkyvä)"
                }
            ],
            "fr": [
                {
                    "id": "016",
                    "label": "Chassis court - Bilame de ressort - 302148"
                },
                {
                    "id": "017",
                    "label": "Chassis court - Bilame de ressort + cale 10mm - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Chassis court - Monolame de ressort acier 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Chassis court - Monolame de ressort acier 10.7 + cale 45mm - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Chassis court - Monolame de ressort acier 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Chassis court - Monolame de ressort acier 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Chassis court - Monolame de ressort composite (Couleur blanche/translucide)"
                },
                {
                    "id": "023",
                    "label": "Chassis long - Bilame de ressort - 302148"
                },
                {
                    "id": "024",
                    "label": "Chassis long - Bilame de ressort + cale 10mm - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Chassis long - Monolame de ressort acier 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Chassis long - Monolame de ressort acier 10.7 + cale 45mm - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Chassis long - Monolame de ressort acier 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Chassis long - Monolame de ressort acier 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Chassis long - Monolame de ressort composite (Couleur blanche/translucide)"
                },
                {
                    "id": "030",
                    "label": "Chassis standard - Bilame de ressort - 302148"
                },
                {
                    "id": "031",
                    "label": "Chassis standard - Bilame de ressort + cale 10mm - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Chassis standard - Monolame de ressort acier 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Chassis standard - Monolame de ressort acier 10.7 + cale 45mm - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Chassis standard - Monolame de ressort acier 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Chassis standard - Monolame de ressort acier 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Chassis standard - Monolame de ressort composite (Couleur blanche/translucide)"
                }
            ],
            "hr": [
                {
                    "id": "016",
                    "label": "Kratka šasija - Složena lisnata opruga - 302148"
                },
                {
                    "id": "017",
                    "label": "Kratka šasija - Složena lisnata opruga + 10mm podloga - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Kratka šasija - Čelična jednolisna opruga 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Kratka šasija - Čelična jednolisna opruga 10.7 + 45mm podloga - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Kratka šasija - Čelična jednolisna opruga 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Kratka šasija - Čelična jednolisna opruga 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Kratka šasija - Kompozitna jednolisna opruga (bijela/prozirna)"
                },
                {
                    "id": "023",
                    "label": "Produljena šasija - Složena lisnata opruga - 302148"
                },
                {
                    "id": "024",
                    "label": "Produljena šasija - Složena lisnata opruga + 10mm podloga - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Produljena šasija - Čelična jednolisna opruga 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Produljena šasija - Čelična jednolisna opruga 10.7 + 45mm podloga - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Produljena šasija - Čelična jednolisna opruga 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Produljena šasija - Čelična jednolisna opruga 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Produljena šasija - Kompozitna jednolisna opruga (bijela/prozirna)"
                },
                {
                    "id": "030",
                    "label": "Standardna šasija - Složena lisnata opruga - 302148"
                },
                {
                    "id": "031",
                    "label": "Standardna šasija - Složena lisnata opruga + 10mm podloga - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standardna šasija - Čelična jednolisna opruga 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standardna šasija - Čelična jednolisna opruga 10.7 + 45mm podloga - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standardna šasija - Čelična jednolisna opruga 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standardna šasija - Čelična jednolisna opruga 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standardna šasija - Kompozitna jednolisna opruga (bijela/prozirna)"
                }
            ],
            "hu": [
                {
                    "id": "016",
                    "label": "Rövid karosszéria - Dupla laprugó - 302148"
                },
                {
                    "id": "017",
                    "label": "Rövid karosszéria - Dupla laprugó + 10 mm-es alátét - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Rövid karosszéria - Egyszeres acél laprugó, 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Rövid karosszéria - Egyszeres acél laprugó, 10.7 + 45 mm-es alátét - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Rövid karosszéria - Egyszeres acél laprugó, 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Rövid karosszéria - Egyszeres acél laprugó, 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Rövid karosszéria - Egyszeres kompozit laprugó (fehér/áttetsző)"
                },
                {
                    "id": "023",
                    "label": "Hosszú karosszéria - Dupla laprugó - 302148"
                },
                {
                    "id": "024",
                    "label": "Hosszú karosszéria - Dupla laprugó + 10 mm-es alátét - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Hosszú karosszéria - Egyszeres acél laprugó, 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Hosszú karosszéria - Egyszeres acél laprugó, 10.7 + 45 mm-es alátét - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Hosszú karosszéria - Egyszeres acél laprugó, 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Hosszú karosszéria - Egyszeres acél laprugó, 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Hosszú karosszéria - Egyszeres kompozit laprugó (fehér/áttetsző)"
                },
                {
                    "id": "030",
                    "label": "Normál karosszéria - Dupla laprugó - 302148"
                },
                {
                    "id": "031",
                    "label": "Normál karosszéria - Dupla laprugó + 10 mm-es alátét - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Normál karosszéria - Egyszeres acél laprugó, 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Normál karosszéria - Egyszeres acél laprugó, 10.7 + 45 mm-es alátét - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Normál karosszéria - Egyszeres acél laprugó, 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Normál karosszéria - Egyszeres acél laprugó, 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Normál karosszéria - Egyszeres kompozit laprugó (fehér/áttetsző)"
                }
            ],
            "it": [
                {
                    "id": "016",
                    "label": "Telaio corto - balestra doppia - 302148"
                },
                {
                    "id": "017",
                    "label": "Telaio corto - balestra doppia + 10 mm distanziale - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Telaio corto - balestra in acciaio singola 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Telaio corto - balestra in acciaio singola 10.7 + 45 mm distanziale - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Telaio corto - balestra in acciaio singola 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Telaio corto - balestra in acciaio singola 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Telaio corto - balestra composta singola (bianco/traslucido)"
                },
                {
                    "id": "023",
                    "label": "Telaio lungo - balestra doppia - 302148"
                },
                {
                    "id": "024",
                    "label": "Telaio lungo - balestra doppia + 10 mm distanziale - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Telaio lungo - balestra in acciaio singola 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Telaio lungo - balestra in acciaio singola 10.7 + 45 mm distanziale - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Telaio lungo - balestra in acciaio singola 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Telaio lungo - balestra in acciaio singola 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Telaio lungo - balestra composta singola (bianco/traslucido)"
                },
                {
                    "id": "030",
                    "label": "Telaio standard - balestra doppia - 302148"
                },
                {
                    "id": "031",
                    "label": "Telaio standard - balestra doppia + 10 mm distanziale - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Telaio standard - balestra in acciaio singola 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Telaio standard - balestra in acciaio singola 10.7 + 45 mm distanziale - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Telaio standard - balestra in acciaio singola 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Telaio standard - balestra in acciaio singola 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Telaio standard - balestra composta singola (bianco/traslucido)"
                }
            ],
            "nl": [
                {
                    "id": "016",
                    "label": "Kort chassis - Dubbelblads veer - 302148"
                },
                {
                    "id": "017",
                    "label": "Kort chassis - Dubbelblads veer + 10mm vulblok - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Kort chassis - Stalen enkelblads veer 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Kort chassis - Stalen enkelblads veer 10.7 + 45mm vulblok - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Kort chassis - Stalen enkelblads veer 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Kort chassis - Stalen enkelblads veer 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Kort chassis - Composiet enkelblads veer (wit/doorzichtig)"
                },
                {
                    "id": "023",
                    "label": "Lang chassis - Dubbelblads veer - 302148"
                },
                {
                    "id": "024",
                    "label": "Lang chassis - Dubbelblads veer + 10mm vulblok - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Lang chassis - Stalen enkelblads veer 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Lang chassis - Stalen enkelblads veer 10.7 + 45mm vulblok - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Lang chassis - Stalen enkelblads veer 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Lang chassis - Stalen enkelblads veer 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Lang chassis - Composiet enkelblads veer (wit/doorzichtig)"
                },
                {
                    "id": "030",
                    "label": "Standaard chassis - Dubbelblads veer - 302148"
                },
                {
                    "id": "031",
                    "label": "Standaard chassis - Dubbelblads veer + 10mm vulblok - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standaard chassis - Stalen enkelblads veer 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standaard chassis - Stalen enkelblads veer 10.7 + 45mm vulblok - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standaard chassis - Stalen enkelblads veer 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standaard chassis - Stalen enkelblads veer 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standaard chassis - Composiet enkelblads veer (wit/doorzichtig)"
                }
            ],
            "pl": [
                {
                    "id": "016",
                    "label": "Krótkie podwozie - Podwójne pióro resora - 302148"
                },
                {
                    "id": "017",
                    "label": "Krótkie podwozie - Podwójne pióro resora + obręcz - 10mm - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Krótkie podwozie - Stalowe pojedyncze pióro resora 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Krótkie podwozie - Stalowe pojedyncze pióro resora 10.7 + obręcz 45mm - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Krótkie podwozie - Stalowe pojedyncze pióro resora 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Krótkie podwozie - Stalowe pojedyncze pióro resora 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Krótkie podwozie - Kompozytowe pojedyncze pióro resora (białe/przezroczyste)"
                },
                {
                    "id": "023",
                    "label": "Długie podwozie - Podwójne pióro resora - 302148"
                },
                {
                    "id": "024",
                    "label": "Długie podwozie - Podwójne pióro resora + obręcz - 10mm - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Długie podwozie - Stalowe pojedyncze pióro resora 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Długie podwozie - Stalowe pojedyncze pióro resora 10.7 + obręcz 45mm - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Długie podwozie - Stalowe pojedyncze pióro resora 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Długie podwozie - Stalowe pojedyncze pióro resora 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Długie podwozie - Kompozytowe - pojedyncze pióro resora (białe/przezroczyste)"
                },
                {
                    "id": "030",
                    "label": "Standardowe podwozie - Podwójne pióro resora - 302148"
                },
                {
                    "id": "031",
                    "label": "Standardowe podwozie - Podwójne pióro resora + obręcz - 10mm - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standardowe podwozie - Stalowe pojedyncze pióro resora 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standardowe podwozie - Stalowe pojedyncze pióro resora 10.7 + obręcz 45mm - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standardowe podwozie - Stalowe pojedyncze pióro resora 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standardowe podwozie - Stalowe pojedyncze pióro resora 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standardowe podwozie - Kompozytowe - pojedyncze pióro resora (białe/przezroczyste)"
                }
            ],
            "pt": [
                {
                    "id": "016",
                    "label": "Chassis curto - Lâmina dupla de mola - 302148"
                },
                {
                    "id": "017",
                    "label": "Chassis curto - Lâmina dupla de mola + 10 mm calço - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Chassis curto - Monolâmina de mola em aço 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Chassis curto - Monolâmina de mola em aço 10.7 + 45 mm calço - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Chassis curto - Monolâmina de mola em aço 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Chassis curto - Monolâmina de mola em aço 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Chassis curto - Monolâmina de mola composta (branca/translúcida)"
                },
                {
                    "id": "023",
                    "label": "Chassis longo - Lâmina dupla de mola - 302148"
                },
                {
                    "id": "024",
                    "label": "Chassis longo - Lâmina dupla de mola + 10 mm calço - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Chassis longo - Monolâmina de mola em aço 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Chassis longo - Monolâmina de mola em aço 10.7 + 45 mm calço - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Chassis longo - Monolâmina de mola em aço 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Chassis longo - Monolâmina de mola em aço 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Chassis longo - Monolâmina de mola composta (branca/translúcida)"
                },
                {
                    "id": "030",
                    "label": "Chassis normal - Lâmina dupla de mola - 302148"
                },
                {
                    "id": "031",
                    "label": "Chassis normal - Lâmina dupla de mola + 10 mm calço - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Chassis normal - Monolâmina de mola em aço 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Chassis normal - Monolâmina de mola em aço 10.7 + 45 mm calço - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Chassis normal - Monolâmina de mola em aço 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Chassis normal - Monolâmina de mola em aço 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Chassis normal - Monolâmina de mola composta (branca/translúcida)"
                }
            ],
            "ro": [
                {
                    "id": "016",
                    "label": "Şasiu scurt - Lamă arc dublă - 302148"
                },
                {
                    "id": "017",
                    "label": "Şasiu scurt - Lamă arc dublă + cală de 10 mm - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Şasiu scurt - Lamă arc din oţel simplă 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Şasiu scurt - Lamă arc din oţel simplă 10.7 + cală de 45 mm - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Şasiu scurt - Lamă arc din oţel simplă 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Şasiu scurt - Lamă arc din oţel simplă 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Şasiu scurt - Lamă arc din aliaj simplă (alb/translucid)"
                },
                {
                    "id": "023",
                    "label": "Şasiu lung - Lamă arc dublă - 302148"
                },
                {
                    "id": "024",
                    "label": "Şasiu lung - Lamă arc dublă + cală de 10 mm - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Şasiu lung - Lamă arc din oţel simplă 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Şasiu lung - Lamă arc din oţel simplă 10.7 + cală de 45 mm - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Şasiu lung - Lamă arc din oţel simplă 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Şasiu lung - Lamă arc din oţel simplă 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Şasiu lung - Lamă arc simplă din compozit (alb/translucid)"
                },
                {
                    "id": "030",
                    "label": "Şasiu standard - Lamă arc dublă - 302148"
                },
                {
                    "id": "031",
                    "label": "Şasiu standard - Lamă arc dublă + cală de 10 mm - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Şasiu standard - Lamă arc din oţel simplă 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Şasiu standard - Lamă arc din oţel simplă 10.7 + cală de 45 mm - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Şasiu standard - Lamă arc din oţel simplă 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Şasiu standard - Lamă arc din oţel simplă 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Şasiu standard - Lamă arc din aliaj simplă (alb/translucid)"
                }
            ],
            "ru": [
                {
                    "id": "016",
                    "label": "Короткобазное шасси - Двухлистовая рессора - 302148"
                },
                {
                    "id": "017",
                    "label": "Короткобазное шасси - Двухлистовая рессора + проставка 10 мм - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Короткобазное шасси - Стальная однолистовая рессора 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Короткобазное шасси - Стальная однолистовая рессора 10.7 + проставка 45 мм - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Короткобазное шасси - Стальная однолистовая рессора 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Короткобазное шасси - Стальная однолистовая рессора 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Короткобазное шасси - Композитная однолистовая рессора (белая/прозрачная)"
                },
                {
                    "id": "023",
                    "label": "Длиннобазное шасси - Двухлистовая рессора - 302148"
                },
                {
                    "id": "024",
                    "label": "Длиннобазное шасси - Двухлистовая рессора + проставка 10 мм - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Длиннобазное шасси - Стальная однолистовая рессора 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Длиннобазное шасси - Стальная однолистовая рессора 10.7 + проставка 45 мм - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Длиннобазное шасси - Стальная однолистовая рессора 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Длиннобазное шасси - Стальная однолистовая рессора 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Длиннобазное шасси - Композитная однолистовая рессора (белая/прозрачная)"
                },
                {
                    "id": "030",
                    "label": "Стандартное шасси - Двухлистовая рессора - 302148"
                },
                {
                    "id": "031",
                    "label": "Стандартное шасси - Двухлистовая рессора + проставка 10 мм - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Стандартное шасси - Стальная однолистовая рессора 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Стандартное шасси - Стальная однолистовая рессора 10.7 + проставка 45 мм - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Стандартное шасси - Стальная однолистовая рессора 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Стандартное шасси - Стальная однолистовая рессора 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Стандартное шасси - Композитная однолистовая рессора (белая/прозрачная)"
                }
            ],
            "sl": [
                {
                    "id": "016",
                    "label": "Krajše podvozje - Dvolistna vzmet - 302148"
                },
                {
                    "id": "017",
                    "label": "Krajše podvozje - Dvolistna vzmet + 10 mm podložka - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Krajše podvozje - Jeklena enolistna vzmet 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Krajše podvozje - Jeklena enolistna vzmet 10.7 + 45 mm podložka - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Krajše podvozje - Jeklena enolistna vzmet 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Krajše podvozje - Jeklena enolistna vzmet 19,5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Krajše podvozje - Enolistna vzmet iz kompozitnih materialov (bela/prosojna)"
                },
                {
                    "id": "023",
                    "label": "Podaljšano podvozje - Dvolistna vzmet - 302148"
                },
                {
                    "id": "024",
                    "label": "Podaljšano podvozje - Dvolistna vzmet + 10 mm podložka - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Podaljšano podvozje - Jeklena enolistna vzmet 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Podaljšano podvozje - Jeklena enolistna vzmet 10.7 + 45 mm podložka - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Podaljšano podvozje - Jeklena enolistna vzmet 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Podaljšano podvozje - Jeklena enolistna vzmet 19,5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Podaljšano podvozje - Enolistna vzmet iz kompozitnih materialov (bela/prosojna)"
                },
                {
                    "id": "030",
                    "label": "Standardno podvozje - Dvolistna vzmet - 302148"
                },
                {
                    "id": "031",
                    "label": "Standardno podvozje - Dvolistna vzmet + 10 mm podložka - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standardno podvozje - Jeklena enolistna vzmet 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standardno podvozje - Jeklena enolistna vzmet 10.7 + 45 mm podložka - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standardno podvozje - Jeklena enolistna vzmet 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standardno podvozje - Jeklena enolistna vzmet 19,5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standardno podvozje - Enolistna vzmet iz kompozitnih materialov (bela/prosojna)"
                }
            ],
            "sv": [
                {
                    "id": "016",
                    "label": "Kort chassie - Dubbel bladfjäder - 302148"
                },
                {
                    "id": "017",
                    "label": "Kort chassie - Dubbel bladfjäder + 10mm mellanlägg - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Kort chassie - Enkel stålbladfjäder 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Kort chassie - Enkel stålbladfjäder 10.7 + 45mm mellanlägg - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Kort chassie - Enkel stålbladfjäder 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Kort chassie - Enkel stålbladfjäder 19.5 - 308656"
                },
                {
                    "id": "022",
                    "label": "Kort chassie - Enkel kompositbladfjäder (vit/genomskinlig)"
                },
                {
                    "id": "023",
                    "label": "Långt chassie - Dubbel bladfjäder - 302148"
                },
                {
                    "id": "024",
                    "label": "Långt chassie - Dubbel bladfjäder + 10mm mellanlägg - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Långt chassie - Enkel stålbladfjäder 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Långt chassie - Enkel stålbladfjäder 10.7 + 45mm mellanlägg - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Långt chassie - Enkel stålbladfjäder 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Långt chassie - Enkel stålbladfjäder 19.5 - 308656"
                },
                {
                    "id": "029",
                    "label": "Långt chassie - Enkel kompositbladfjäder (vit/genomskinlig)"
                },
                {
                    "id": "030",
                    "label": "Standard chassie - Dubbel bladfjäder - 302148"
                },
                {
                    "id": "031",
                    "label": "Standard chassie - Enkel stålbladfjäder + 10mm mellanlägg - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Standard chassie - Enkel stålbladfjäder 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Standard chassie - Enkel stålbladfjäder 10.7 + 45mm mellanlägg - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standard chassie - Enkel stålbladfjäder 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standard chassie - Enkel stålbladfjäder 19.5 - 308656"
                },
                {
                    "id": "036",
                    "label": "Standard chassie - Enkel kompositbladfjäder (vit/genomskinlig)"
                }
            ],
            "tr": [
                {
                    "id": "016",
                    "label": "Kısa şasi - Çift lam - 302148"
                },
                {
                    "id": "017",
                    "label": "Kısa şasi - Çift lam + 10mm ayar pulu - 059853 / 812459"
                },
                {
                    "id": "018",
                    "label": "Kısa şasi - Çelik tek lam 10.7 - 314662 / 812456"
                },
                {
                    "id": "019",
                    "label": "Kısa şasi - Çelik tek lam 10.7 + 45mm ayar pulu - 311071 / 812461"
                },
                {
                    "id": "020",
                    "label": "Kısa şasi - Çelik tek lam 17 - 296353 / 812460"
                },
                {
                    "id": "021",
                    "label": "Kısa şasi - Çelik tek lam 19,5 - 308656 / 812460"
                },
                {
                    "id": "022",
                    "label": "Kısa şasi - Kompozit tek lam (beyaz/yarı saydam)"
                },
                {
                    "id": "023",
                    "label": "Uzun şasi - Çift lam - 302148"
                },
                {
                    "id": "024",
                    "label": "Uzun şasi - Çift lam + 10mm ayar pulu - 059853 / 812459"
                },
                {
                    "id": "025",
                    "label": "Uzun şasi - Çelik tek lam 10.7 - 314662 / 812456"
                },
                {
                    "id": "026",
                    "label": "Uzun şasi - Çelik tek lam 10,7 + 45mm ayar pulu - 311071 / 812461"
                },
                {
                    "id": "027",
                    "label": "Uzun şasi - Çelik tek lam 17 - 296353 / 812460"
                },
                {
                    "id": "028",
                    "label": "Uzun şasi - Çelik tek lam 19,5 - 308656 / 812460"
                },
                {
                    "id": "029",
                    "label": "Uzun şasi - Kompozit tek lam (beyaz/yarı saydam)"
                },
                {
                    "id": "030",
                    "label": "Standard şasi - Çift lam - 302148"
                },
                {
                    "id": "031",
                    "label": "Standart şasi - Çift lam + 10mm ayar pulu - 059853 / 812459"
                },
                {
                    "id": "032",
                    "label": "Kısa şasi - Çelik tek lam 10.7 - 314662 / 812456"
                },
                {
                    "id": "033",
                    "label": "Kısa şasi - Çelik tek lam 10.7 + 45mm ayar pulu - 311071 / 812461"
                },
                {
                    "id": "034",
                    "label": "Standart şasi - Çelik tek lam 17 - 296353 / 812460"
                },
                {
                    "id": "035",
                    "label": "Standart şasi - Çelik tek lam 19,5 - 308656 / 812460"
                },
                {
                    "id": "036",
                    "label": "Standart şasi - Kompozit tek lam (beyaz/yarı saydam)"
                }
            ]
        }
    });
})();

(function () {
    angular.module('phenix').constant('ApplicabilitiesConstants', {
        axleGeometry: '/proxy/apidh/rest/v1/applicabilities/axleGeometry',
        axleGeometryCalcule: '/proxy/apidh/rest/v1/axleGeometry'
    });
})();

(function () {

  angular
    .module('phenix')
    .directive('phxAlertsStep', phxAlertsStep);


  /* @ngInject */
  function phxAlertsStep() {
    var directive = {
      template: '<div class="alerts-popin_content" ng-include="vm.getTemplateUrl()"></div>',
      bindToController: true,
      controller: phxAlertsStepController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {
        step: '=',
        stepElem: '=',
        stepTemplateUrl: '=',
        isTraceEnabled: '='
      }
    };
    return directive;
  }

  /* @ngInject */
  function phxAlertsStepController(AlertsService, CacheService, CacheConstants, $rootScope,RoutesConstants,AlertsConstants,MainMetierService) {
    var vm = this;
    vm.recapCarAPI = null;
    var listOfPiece = CacheService.getObject(CacheConstants.listOfPiece);
    vm.maxSizedFiles = '1Mo';
    vm.natureIncident = AlertsService.getIncidentNature();
    vm.checkDocType = AlertsService.getDocumentType();
    vm.file = [];
    vm.hideScreenshot = !$rootScope.currentState.includes(RoutesConstants.carSearchResult);
    vm.alertRequestReasonSelected = AlertsConstants.requestReasons;
    /////////////

    vm.getTemplateUrl = getTemplateUrl;
    vm.deleteInArray = deleteInArray;
    vm.formatReferenceInput = formatReferenceInput;
    vm.takeScreenshot = takeScreenshot;
    vm.disableScreenshot = false;
    vm.displayDescription = displayDescription;
    vm.screenshotButtonColor = screenshotButtonColor;
    /////////////

    /**
     * @desc Dynamic template directive by step number
     */
    function getTemplateUrl() {
      var stepNumber = vm.stepTemplateUrl || 'list';
      return 'app/components/alerts/popin/steps/step-' + stepNumber + '.html';
    }

    function displayDescription(code) {
       const formattedVal =  MainMetierService.formatReferenceInput(code);
      vm.stepElem[1].alerteDocumentDetail.code = formattedVal;
      vm.stepElem[1].alerteDocumentDetail.description = assign("");
      if(code.length === 10){
        angular.forEach(listOfPiece, function (value) {
          if (value.reference === code) {
            vm.stepElem[1].alerteDocumentDetail.description = assign(value.designation);
          }else if(value.alternative){
            angular.forEach(value.alternative, function(alternative){
              if(alternative.reference === code){
                vm.stepElem[1].alerteDocumentDetail.description = assign(alternative.designation);
              }
            })
          }
        });
      }
    }


    /**
     * Assign if data
     * @param toAssign
     * @returns {*}
     */
    function assign(toAssign) {
      if (toAssign) {
        return toAssign;
      }
    }

    function formatReferenceInput(){
      vm.stepElem[vm.step - 1].alerteRequestObject.data.partAssociatedNumber =  MainMetierService.formatReferenceInput(vm.stepElem[vm.step - 1].alerteRequestObject.data.partAssociatedNumber);

    }

    function deleteInArray(array, index) {
      if (array[index].file.fileName == "screenshot_alert1") {
        vm.disableScreenshot = false;
        screenshotButtonColor('#TAKE_SCREENSHOT', 'var(--renaultPrimaryColor)');
      }
      array.splice(index, 1);
    }

    function takeScreenshot() {
      AlertsService.setHidePopin(false);
      AlertsService.setScreenshotButtonVisibility(true);
    }

    $rootScope.$on('addAlert', function (event, capturedImage) {
      var size = (((capturedImage.length - 814) / 1.37) / 1000).toFixed(2);

      var screenshotImage = {
        file: {
          name: "screenshot_alert1.png",
          humanSize: size + " Ko",
          fileName: "screenshot_alert1",
          fileType: "png",
          Alertsize: parseInt(size),
          data: {
            base64: capturedImage
          }
        }
      }
      vm.stepElem[1].alerteRequestObject.data.attachment.push(screenshotImage);
      screenshotButtonColor('#TAKE_SCREENSHOT', '#CCCCCC');
      vm.disableScreenshot = true;
    });

    function screenshotButtonColor(id, color) {
      $(id).css({
        'background-color': color
      })
    }
  }

})();

(function() {
    angular.module('phenix').service('ShoppingCartWSService', function(CarSearchConstants ,       
        PanierConstants,$q,$translate,RestUpgrade,RestUpgradeRaw) {
        
        this.getR2APriceStockDetails = getR2APriceStockDetails;
        this.sendOperationDetails = sendOperationDetails;
        this.placeOrder = placeOrder;
        this.rpsPlaceOrder = rpsPlaceOrder;
        this.updateRpsId = updateRpsId;
        this.updateRpsPartsTransfer = updateRpsPartsTransfer;
        this.declareCart = declareCart;
        this.getCentralStockDetails=getCentralStockDetails;
        this.getEstimateGroup = getEstimateGroup;
        this.getEstimateGroupById = getEstimateGroupById;

        this.update  = function(requestBody) {
            var endpoint = '/carts/save';
            return RestUpgrade.all(endpoint).post(requestBody);
        }

        this.delete  = function(cartID, referenceID) {
            return RestUpgrade.one('/carts', cartID).one('/items', referenceID).remove();
        }

        this.interventionDelete = function (cartID, interventionId, payload){
            return RestUpgrade.one('/carts', cartID).one(interventionId).post('', payload);
        }
        this.saveCart = function(requestBody){
            var endpoint = '/carts/saveCart';
            return RestUpgrade.all(endpoint).post(requestBody);
        }

        this.closeCart = function(requestBody){
            var endpoint = '/carts/close';
            return RestUpgrade.all(endpoint).post(requestBody);
        }

        function getR2APriceStockDetails(garageId, dealerId, productList, url, isUrgent, isR1){
            var payload = {
                "repository": CarSearchConstants.r2aRepo,
                "garageId": garageId,
                "dealerId": dealerId,                
                "products":productList
            };
            if(isUrgent && CarSearchConstants.r2aPriceTaxDiscount == url){
                _.assign(payload, {urgent:"yes"});
                if(isR1)
                    delete payload.garageId;
            }
            var defer = $q.defer();

            if(url != CarSearchConstants.r2aPriceTaxDiscount)
                RestUpgrade.all(url).withHttpConfig({timeout: 45000}).post(payload).then(function(response){
                    defer.resolve(response);
                }).catch(function(error){
                    defer.reject(error);
                })
            else
                RestUpgrade.all(url).post(payload).then(function(response){
                    defer.resolve(response);
                }).catch(function(error){
                    defer.reject(error);
                })

            return defer.promise;
        }

        function sendOperationDetails(body,vin){

            var defer = $q.defer();

            var url = PanierConstants.operationDetails+vin+PanierConstants.operations;
            RestUpgradeRaw.all(url).post(body).then(function(res){

                if(res.status === 201 || res.status === 200){
                    defer.resolve(res);
                }else if(res.status === 400){
                    defer.reject();
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE'));
                }

            }).catch(function(){
                defer.reject($translate.instant('ERROR_IN_DECLARE'));
            })

            return defer.promise;


        }


        function getCentralStockDetails(payload){
            var defer = $q.defer();
            var url = CarSearchConstants.r2aStock;    
            RestUpgrade.all(url).post(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            });
            return defer.promise;
        }
        function declareCart(body){

            var defer = $q.defer();

            var url = PanierConstants.declare_endpoint;
            RestUpgrade.all(url).post(body).then(function(response){
                if(response){
                    defer.resolve(response);
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE_SAVE'));
                }
            }).catch(function(){
                defer.reject($translate.instant('ERROR_IN_DECLARE_SAVE'));
            })

            return defer.promise;

        }

        function placeOrder(payload){ 
            var defer = $q.defer();
            var url = CarSearchConstants.r2aPlaceOrder;
            RestUpgrade.all(url).post(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
 
            return defer.promise;
        }
        function rpsPlaceOrder(payload){ 
            const defer = $q.defer();
            const url = CarSearchConstants.rpsPlaceOrder;
            RestUpgrade.all(url).post(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
 
            return defer.promise;
        }

        function updateRpsPartsTransfer(payload){
            const defer = $q.defer();
            const url = CarSearchConstants.partReqRpsPartsTransfer;
            RestUpgrade.all(url).post(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function updateRpsId(id, rpsId, url){
            var defer = $q.defer();
            var payload = {
                "id": id,
                "rpsOrderId": rpsId
            };
            RestUpgrade.all(url).post(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function getEstimateGroup(){
            const defer = $q.defer();
            const url = PanierConstants.getEstimateGroup;
            RestUpgrade.one(url).get().then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }
        function getEstimateGroupById(estimateGroupId){
            const defer = $q.defer();
            const url = PanierConstants.getEstimateGroup + '/' + estimateGroupId;
            RestUpgrade.one(url).get().then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }
  
    });
})();


(function () {

    angular.module('phenix').service('ShoppingCartService', function (ShoppingCartServiceConstant, CacheService, 
        MainMetierService, CodesConstants, ShoppingCartWSService, PanierConstants,
        CartViewListWSService, $q, $rootScope,$translate, toastr, CacheConstants,CarSearchConstants, DocumentsMetierService,UtilsMetierService,
        $mdDialog, blockUI) {

        /*****************************
         *      VARIABLES
         ****************************/

        var _shoppingCart = [];
        var _cartInformations = {};
        var _previousShoppingCart = [];
        var _actions = ShoppingCartServiceConstant.actions;
        var _enums = ShoppingCartServiceConstant.enums;
        var _essai = ShoppingCartServiceConstant.essai;
        var _testTime = ShoppingCartServiceConstant.testTime;
        this.event = ShoppingCartServiceConstant.events;
        this.constants = _actions;
         


        /*****************************
         *      FUNCTION

         ****************************/


        /** SETTEUR */
        this.replaceShoppingCart = replaceShoppingCart;
        this.setShoppingCart = setShoppingCart;
        this.setIDOnShoppingCart = setIDOnShoppingCart;
        this.reverseShoppingCart = reverseShoppingCart;
        this.updateShoppingCart = updateShoppingCart;
        this.lookingReferenceInCart = lookingReferenceInCart;

        /** CALLED BY UPDATE SHOPPING CART */
        this.onAddQuantity = onAddQuantity;
        this.onReduceQuantity = onReduceQuantity;
        this.onInputQuantity = onInputQuantity;
        this.adjustPPSQuantity = adjustPPSQuantity;

        /** GETTEUR */
        this.getShoppingCart = getShoppingCart;
        this.getCurrentCartID = getCurrentCartID;
        this.getCartMedatadata = getCartMedatadata;

        /** CALL ND FOR POSTGRES UPDATE */
        this.unlockCart = unlockCart;
        this.onUpdateCart = onUpdateCart;
        this.onUpdateCartWithEstimate = onUpdateCartWithEstimate;
        this.deleteReference = deleteReference;
        this.deleteIntervention = deleteIntervention;
        this.saveCart = saveCart;
        this.closeCart = closeCart;

        /** TOOLS */
        this.computedShoppingCart = computedShoppingCart;
        this.forEachElementInPiece = forEachElementInPiece;
        this.createNewStructureOfPieceByType = createNewStructureOfPieceByType;

        /** EMIT */
        this.emitCartUpdated = emitCartUpdated

        /** OPERATIONS */
        this.sendOperationDetails = sendOperationDetails;
        this.declareCart = declareCart;
        this.checkcatalogPlateId = checkcatalogPlateId;
        this.checkPartIndex = checkPartIndex;
        
        /** R2A services */
        this.getR2APriceStockDetails = getR2APriceStockDetails;
        this.r2aPlaceOrder = r2aPlaceOrder;
        this.rpsPlaceOrder = rpsPlaceOrder;
        this.updateRpsId = updateRpsId;
        this.updateRpsPartsTransfer = updateRpsPartsTransfer;
        this.getCentralStockDetails=getCentralStockDetails;
        
        /** Estimate Group services */
        this.getEstimateGroup = getEstimateGroup;
        this.getEstimateGroupById = getEstimateGroupById;
        function deletePieceInShoppingCart(id) {
            var index = _.findIndex(_shoppingCart, function (piece) {
                return piece.id === id
            })
            if (index !== _enums.NOTFOUND) {
                index === 0 ? _shoppingCart.shift() : _shoppingCart.splice(index, 1);
            }
        }

		function addTestOpeCod(payload) {
            var defer = $q.defer();
            if (payload && payload.piece && payload.piece.isTestOpcode) {
                if (_shoppingCart && !_.isEmpty(_shoppingCart)) {
                    var opeCodExist = _.find(_shoppingCart, function (piece) {
                        return piece.opecod === payload.piece.opecod
                    })
                    if (opeCodExist) {
                        onAddQuantity(payload.piece, payload.type);
                        defer.resolve();
                    } else {
                    var quoteTestTmList = [];
                    _shoppingCart.forEach(function (tm) {
                        if (Object.values(_essai).includes(tm.opecod) && payload.piece.opecod != tm.opecod) {
                            quoteTestTmList.push(tm);
                        }
                    })
                    if (quoteTestTmList && !_.isEmpty(quoteTestTmList)) {
                        var isLowerTm = false;
                        var tmDuration = payload.piece.duration ? (typeof payload.piece.duration === 'string' ? parseFloat(payload.piece.duration.replace(",", ".")) : payload.piece.duration) : 0;
                        quoteTestTmList.forEach(function (tm) {
                            var testTmDuration = tm.duration ? (typeof tm.duration === 'string' ? parseFloat(tm.duration.replace(",", ".")) : tm.duration) : 0;
                            if (tmDuration < testTmDuration) {
                                isLowerTm = true;
                            }
                        })
                        $mdDialog.show({
                            templateUrl: 'app/components/basket/shoppingCart/testOpcodPopup.template.html',
                            controller: 'testOpcodPopupController',
                            bindToController: true,
                            controllerAs: 'vm',
                            clickOutsideToClose: false,
                            locals: {
                                lowerTm: isLowerTm,
                                opecod: payload.piece.opecod,
                                message: "CART"
                            }
                        }).then(function () {
                            // on confirm
                            onAddQuantity(payload.piece, payload.type);
                            defer.resolve();
                        }).catch(function () {
                            // on cancel
                            if (!isLowerTm) {
                                var deleteTestTm = [];
                                if (quoteTestTmList && !_.isEmpty(quoteTestTmList)) {
                                    for (var i in quoteTestTmList) {
                                        deleteTestTm.push(quoteTestTmList[i]);
                                    }
                                    
                                    if (deleteTestTm && !_.isEmpty(deleteTestTm)) {
                                        var promiseArray = _.map(deleteTestTm,function (piece) {
                                            return deleteReference(piece.id);
                                            });
                                        $q.all(promiseArray).then(function () {
                                                onAddQuantity(payload.piece, payload.type);
                                                defer.resolve();
                                        })
                                    } 
                                }
                            } else {
                                defer.reject();
                            }
                        })
                    } else {
                        onAddQuantity(payload.piece, payload.type);
                        defer.resolve();
                    }
                 }
                } else {
                    onAddQuantity(payload.piece, payload.type);
                    defer.resolve();
                }
            } else {
                var checkTestOpCode = false;
                var request = [];
                Object.keys(_essai).forEach(function (key) {
                    if (payload.piece.essay == key && payload.type == 'TM') {
                        request = [_essai[key]];
                        _shoppingCart.forEach(function (item) {
                            if (item.opecod == request) {
                                checkTestOpCode = true;
                            }
                        });
                    }
                })

                if (request && !_.isEmpty(request) && !checkTestOpCode) {
                    blockUI.start();
                    DocumentsMetierService.returnTmDocumentsByOpeCode(request).then(function (response) {
                        blockUI.stop();
                        var cartpushData = createNewStructureOfPieceByType(response.TM[0], payload.type);
                        cartpushData.type = 'TM';
                        cartpushData.quantity = 1;

                        var isTestOpecodExists = [];
                        var isTestOpcode = false;
                        _shoppingCart.forEach(function (piece) {
                            if (Object.values(_essai).includes(piece.opecod)) {
                                isTestOpecodExists.push(piece);
                            }
                        })
                        var tmLaborTime = cartpushData.duration ? (typeof cartpushData.duration === 'string' ? parseFloat(cartpushData.duration.replace(",", ".")) : cartpushData.duration) : 0;
                        if (isTestOpecodExists && !_.isEmpty(isTestOpecodExists)) {
                            var testTmExistDuration = isTestOpecodExists[0].duration ? (typeof isTestOpecodExists[0].duration === 'string' ? parseFloat(isTestOpecodExists[0].duration.replace(",", ".")) : isTestOpecodExists[0].duration) : 0;
                            var deletedTM = [];
                            if (isTestOpecodExists.length > 1) {
                                for (var index = 0; index < isTestOpecodExists.length; index++) {
                                    var indexOneTm = isTestOpecodExists[index].duration ? (typeof isTestOpecodExists[index].duration === 'string' ? parseFloat(isTestOpecodExists[index].duration.replace(",", ".")) : isTestOpecodExists[index].duration) : 0;
                                    var indexTwoTm = isTestOpecodExists[index + 1].duration ? (typeof isTestOpecodExists[index + 1].duration === 'string' ? parseFloat(isTestOpecodExists[index + 1].duration.replace(",", ".")) : isTestOpecodExists[index + 1].duration) : 0;
                                    if (indexOneTm < tmLaborTime && indexTwoTm < tmLaborTime) {
                                        for (var i in isTestOpecodExists) {
                                            deletedTM.push(isTestOpecodExists[i]);
                                        }
                                        break;
                                    } else if (indexOneTm < tmLaborTime || indexTwoTm < tmLaborTime) {
                                        var deleteOpcod = indexOneTm < tmLaborTime ? isTestOpecodExists[index] : isTestOpecodExists[index + 1];
                                        deletedTM.push(deleteOpcod);
                                        isTestOpcode = true;
                                        break;
                                    }
                                }
                            } else if (testTmExistDuration < tmLaborTime) {
                                deletedTM.push(isTestOpecodExists[0]);
                            }
                            if (deletedTM && !_.isEmpty(deletedTM)) {
                                deletedTM.forEach(function (piece) {
                                    deleteReference(piece.id);
                                })
                                if (!isTestOpcode) {
                                    _shoppingCart.push(cartpushData);
                                    if (!payload.hideTestOpecodToaster) {
                                        toastr.success($translate.instant('TEST_OPECOD_' + cartpushData.opecod + '_UPDATE', { duration: '(' + tmLaborTime + 'h)' }), { messageClass: 'toast-opecod-message' });
                                    }
                                }
                            }
                        } else {
                            _shoppingCart.push(cartpushData);
                            if (!payload.hideTestOpecodToaster) {
                                toastr.success($translate.instant('TEST_OPECOD_' + cartpushData.opecod + '_ADD', { duration: '(' + tmLaborTime + 'h)' }), { messageClass: 'toast-opecod-message' });
                            }
                            defer.resolve();
                        }
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
            }
            return defer.promise;
        }

        /**
         *  @desc  Cart array can only be update with this function
         *         We send an action, and a payload, it will call a function which handle the modification
         *  @param {string} action
         *  @param {object} payload TODO DEFINE THIS OBJECT
         *  @return a deepcopy of shoppingCard to avoid mutatation from outside
         */

        function updateShoppingCart(action, payload, genericPart) {
            /** Added for upgrade migration fix */
            var panierData = $rootScope.panierData;
            if(panierData && panierData.items && panierData.items.length > 0){
                action = action ? action : "ADD_QUANTITY";
                _cartInformations.id = panierData.id || _cartInformations.id;
                angular.forEach(panierData.items, function (value) {
                    _shoppingCart.push(value)
                });
                _shoppingCart = _.uniq(_shoppingCart);
                $rootScope.panierData = '';
            }
            /**  */
            _previousShoppingCart = angular.copy(_shoppingCart);

            switch (action) {
                case _actions.ADD_OPERATIONS:                  
                    addOperations(payload);
                    break;
                case _actions.UPDATE_CARTMETADATA:
                    updateCartMetaData(payload.cartDescription);
                    break;
                case _actions.ADD_PIECE:
                    if (payload.type == 'TM' && !Object.values(_essai).includes(payload.piece.opecod)) {
                        onAddQuantity(payload.piece, payload.type);
                    }
                    else if (payload.type == 'PR') {
                        onAddQuantity(payload.piece, payload.type, genericPart);
                    }
                    break;
                case _actions.ADD_QUANTITY:
                    onAddQuantity(payload.piece, payload.type, genericPart);
                    break;
                case _actions.REDUCE_QUANTITY:
                    onReduceQuantity(payload.piece);
                    break;
                case _actions.REPLACE_QUANTITY:
                    onInputQuantity(payload.piece, payload.quantity, payload.type);
                    break;
                case _actions.DELETE_PIECE:
                    deletePieceToShoppingCart(payload.reference, payload.genericPart, payload.item);
                    break;


                /**
                 *  CLEAN EVERYTHING
                 */

                case _actions.CLEAN:
                    clean();
                    break;
            }
            if(payload && payload.cartDescription){
                updateCartMetaData(payload.cartDescription);
            }
            if (action && action !== "ADD_OPERATIONS") {
                _shoppingCart.forEach(function (item) {
                    if (!item.index && !item.herculesCase) {
                        if (payload.piece) {
                            _.extend(item, {
                                'index': payload.piece.index ? payload.piece.index : payload.piece.indexOfMainArray,
                                'herculesCase': payload.piece.herculesCase,
                                'plateId': payload.piece.plateId ? payload.piece.plateId : payload.piece.catalogPlate
                            });
                        }
                    }
                });
                angular.copy(_shoppingCart)
                emitCartUpdated();
                if (action && action === 'ADD_PIECE' && payload && payload.type === 'TM' && payload.piece && payload.piece.essay && payload.piece.essay !== '5' && payload.piece.essay !== '3') {
                    return addTestOpeCod(payload).then(function () {
                        angular.copy(_shoppingCart)
                        emitCartUpdated();
                        return;
                    }).catch(function (err) {
                        return $q.reject(err);
                    })
                }
                else {
                    return $q.resolve();
                }
            } else if (action == 'ADD_OPERATIONS') {
                    if (payload) {
                        var tmList = payload.INT[0] && payload.INT[0].basketContent && payload.INT[0].basketContent.labourTimes  ? payload.INT[0].basketContent.labourTimes : [];
                        if (tmList && !_.isEmpty(tmList)) {
                            var testMainTm = null;
                            var testTmTime = 0;
                            // essay type 3 has no opecod and wins over every other type: nothing is added automatically
                            var hasManualEssay = _.some(tmList, function (tm) {
                                return tm.essay === '3';
                            });
                            if (!hasManualEssay) {
                                tmList.forEach(function (tm) {
                                    if (tm.essay && Object.keys(_essai).includes(tm.essay)) {
                                        if (_testTime[tm.essay] > testTmTime) {
                                            testTmTime = _testTime[tm.essay];
                                            testMainTm = tm;
                                        }
                                    }
                                })
                            }
                            if (testMainTm) {
                                // the test TM is implicit when a whole intervention is added, so no toaster
                                var testTmPayload = { piece: testMainTm, type: "TM", hideTestOpecodToaster: true };
                                return addTestOpeCod(testTmPayload).then(function () {
                                    angular.copy(_shoppingCart)
                                    emitCartUpdated();
                                })
                            }
                        }
                        return $q.resolve();
                    }
                }
            }
        


        function addOperations(payload) {
            var interventionId = payload.INT[0].id;
            var interventionDesignation = payload.INT[0].designation;
            var interventionSieVersion = payload.INT[0].version;
            var interventionQuantity = payload.INT[0].interventionQuantity;
            var tmList = payload.INT[0].basketContent.labourTimes ? payload.INT[0].basketContent.labourTimes : [];
            var partList = payload.INT[0].basketContent.parts ? payload.INT[0].basketContent.parts : [];
            var ingredientList = payload.INT[0].basketContent.ingredients ? payload.INT[0].basketContent.ingredients : [];
            var interventionList = [];
            var existingIndex = [];
            var interventionList = tmList.concat(partList, ingredientList);
            if (!_.isEmpty(interventionList)) {
                interventionList.forEach(function (operation) {
                    if (operation.type === 'TM') {
                        var firstTimeTM = false;
                        if(!operation.opecod){
                            operation.opecod = operation.id;
                            firstTimeTM = true; 
                        }
                        operation.reference = operation.technicalId || operation.reference || operation.opecod;
                        if(firstTimeTM)
                            delete operation['id'];
                    }
                    operation.interventionId = interventionId;
                    operation.interventionDesignation = interventionDesignation;
                    operation.interventionSieVersion = interventionSieVersion;
                    operation.suggestedQuantity = operation.defaultQuantity != null
                        ? operation.defaultQuantity
                        : (operation.quantity || 1);
                    operation.interventionQuantity = interventionQuantity ? parseInt(interventionQuantity) : "";                  
                    operation.priceHT = operation.priceExclTaxes;
                    _shoppingCart.forEach(function (item) {
                       var checkDup = false;
                        if ((item.type === "TM" && (item.interventionId && item.interventionId !== null) && (item.reference === operation.reference) && (item.interventionId === operation.interventionId)) || (item.type === "PR" && (item.reference === operation.reference) && (item.interventionId && item.interventionId !== null) && (item.interventionId === operation.interventionId))) {
                            item.interventionId = interventionId;
                            item.interventionDesignation = interventionDesignation;
                            item.interventionSieVersion = interventionSieVersion;
                            item.suggestedQuantity = operation.defaultQuantity != null
                                ? operation.defaultQuantity
                                : (operation.quantity || 1);
                            item.interventionQuantity = interventionQuantity ? parseInt(interventionQuantity) : "";
                            if((item.type === "TM") || ((item.type === "PR") && ((item.genericPart === operation.genericPart) && (item.reference === operation.reference) )) ){
                                if(item.type === "PR" && (item.quantity!==0)){
                                    checkDup = true;
                                }
                                // avoid string concatenation when quantity arrives as a numeric string (e.g. FOD payloads)
                                item.quantity = (Number(item.quantity) || 0) + (Number(operation.quantity) || 0);
                            }
                            item.defaultQuantity = operation.defaultQuantity;
                            if(checkDup){
                                var index = _.findIndex(interventionList, function (piece) {
                                    return (piece.reference === item.reference&& piece.genericPart===item.genericPart)
                                });
                                existingIndex.push(index);
                            }else if(item.type === "TM"){
                                var index = _.findIndex(interventionList, function (piece) {
                                    return (piece.reference === item.reference)
                                });
                                existingIndex.push(index);
                            }
                          
                        }
                    });
                })
                if (!_.isEmpty(existingIndex)) {
                    existingIndex.slice().reverse().forEach(function (index) {
                        interventionList.splice(index, 1)
                    })
                }
                _shoppingCart = _shoppingCart.concat(interventionList);
            }
        }

        /**
         * @desc Update or Add items to shoppingCart, it's can be one or multiple items
         * @param {object} piece Look to createNewStructOfPiece
         * @param {string} type It's usefull when we need to make a difference PR/TM/ etc...
         * @return {void}
         */

        function onAddQuantity(piece, type, genericPart) {
            piece.genericPart && piece.genericPart !== undefined && !_.isEmpty(piece.genericPart) ? piece.genericPart : _.extend(piece, { "genericPart": genericPart});
            forEachElementInPiece(piece, function (newPiece, existingPiece) {
                var quantity;
                if (newPiece.additional && newPiece.additional.length === 0) {
                    if (newPiece.supersessions && newPiece.supersessions.length > 0) {
                        newPiece.supersessions.forEach (function (item) {
                            if (newPiece.originalPartReference === item.mainReference && item.ratio > 1) {
                                quantity = item.ratio;
                            } else {
                                quantity = 1;
                            }
                        })
                    }
                }
                else {
                    quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                }
                if (existingPiece) {
                    if (newPiece.detectAsPPS) {
                        adjustPPSQuantity(newPiece, existingPiece);
                    }
                    _.flow([addQuantity, checkMaxQuantity])(existingPiece, quantity)
                } else {
                    if (newPiece.detectAsPPS) {
                        quantity = newPiece.propertionnalQuantity + newPiece.ratio;
                    }
                    _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                }
            });
        }

        function adjustPPSQuantity(piece, existingPieceFromCart) {
            var actualQuantity = piece.quantity;
            var propertionnalQuantity = piece.propertionnalQuantity;
            if (actualQuantity > propertionnalQuantity) {
                var quantityToReduce = actualQuantity - propertionnalQuantity;
                _.flow([reduceQuantity, checkMinQuantity])(existingPieceFromCart, quantityToReduce);
            } else if (actualQuantity < propertionnalQuantity) {
                var quantityToAdd = propertionnalQuantity - actualQuantity;
                _.flow([addQuantity, checkMaxQuantity])(existingPieceFromCart, quantityToAdd);
            }
        }

        /**
         * @desc Reduce quantity of item in cart
         * @param {object} piece Look to createNewStructOfPiece
         * @param {string} type
         * @return {void}
         */

        function onReduceQuantity(piece, type) {
            forEachElementInPiece(piece, function (newPiece, existingPiece) {
                var quantity;
                if (newPiece.additional && newPiece.additional.length === 0) {
                    if (newPiece.supersessions && newPiece.supersessions.length > 0) {
                        newPiece.supersessions.forEach (function (item) {
                            if (newPiece.originalPartReference === item.mainReference && item.ratio > 1) {
                                quantity = item.ratio;
                            } else {
                                quantity = 1;
                            }
                        })
                    }
                }
                else {
                    quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                }
                if (existingPiece) {
                    if (newPiece.detectAsPPS) {
                        adjustPPSQuantity(newPiece, existingPiece);
                    }
                    _.flow([reduceQuantity, checkMinQuantity, deletePieceIfQuantityNull])(existingPiece, quantity);
                } else {
                    // It's only can be a PPS, because a mainReference can contain something like this (ratio: 1) :
                    // - REF quantity 2
                    //      - REF PPS 1 quantity 2
                    //      - REF PPS 2 quantity 0
                    // if user clicks on reduce, this gonna be :
                    // - REF quantity 1
                    //      - REF PPS 1 quantity 1
                    //      - REF PPS 1 quantity 1 << NEW PIECE
                    quantity = newPiece.propertionnalQuantity - newPiece.ratio;
                    if (quantity > 0){
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                    }
                }
            })
        }

        /**
         * @desc Update quantity from a given quantity
         * @param {object} piece Look to createNewStructOfPiece
         * @param {number} quantity
         * @param {string} type Wether the piece is PR/TM/ETC
         */

        function onInputQuantity(piece, quantity, type) {
            forEachElementInPiece(piece, function (newPiece, existingPiece) {
                var oldQuantity = newPiece.quantity;
                var newQuantity = newPiece.detectAsPPS ? quantity * (newPiece.ratio || 1) : quantity;
                var isInputQuantity = false;
                if (existingPiece) {
                    if (newQuantity > 0) {
                        isInputQuantity = true;
                        // clean old quantity
                        _.flow([reduceQuantity, checkMinQuantity])(existingPiece, oldQuantity, isInputQuantity);
                        // add new quantity
                        _.flow([addQuantity, checkMaxQuantity])(existingPiece, newQuantity, isInputQuantity);
                    } else {
                        // clean old quantity
                        _.flow([reduceQuantity, checkMinQuantity, deletePieceIfQuantityNull])(existingPiece, oldQuantity);
                    }
                } else {
                    if (newQuantity > 0) {
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, newQuantity);
                    }
                }
            })
        }



        /**
         *  @desc Clean items/metadata of cart
         *  @param {void}
         *  @return {void}
         */
        function clean() {
            _shoppingCart = [];
            _previousShoppingCart = [];
            _cartInformations = {};
        }

        /**
         * @desc Updated cart label and description
         * @param {object} cart {
         *      description: string,
         *      label: string
         * }
         * @return {void}
         */

        function updateCartMetaData(cart) {
            if(cart){
                _cartInformations.description = cart.description;
                _cartInformations.label = cart.label;
                _cartInformations.declared = cart.declared;
            }            
        }

        /**
         *  This function is used when the cart is updated by the user.
         *  It returns a formated cart wanted by nd-service which contains PPS and references
         *  in the same level.
         *
         *  A PPS contain mainItem property
         *
         *  @return {Array<Object>} Object {
         *      reference: string,
         *      type: string,
         *      quantity: number,
         *      id: string | undefined
         *      mainItem?: {
         *          reference: string
         *          id?: string | undefined
         *      }
         *  }
         */

        function computedShoppingCart() {
            
            var isInterventionAccess = UtilsMetierService.isInterventionAccess();
            const userProfil = CacheService.getUserProfile();
            var isIndependantUser = userProfil ? MainMetierService.isIndependantUser(userProfil.roles): null;
            var cart = _shoppingCart.map(function (piece) {
                var mainPiece = {
                    reference: piece.reference,
                    currency: piece.currency,
                    designation: piece.designation,
                    type: piece.type,
                    id: piece.id,
                    quantity: piece.quantity,
                    price:piece.priceHT,
                    genericPart:piece.genericPart,
                    sbomId:piece.sbomId,
                    index:piece.index,
                    herculesCase:piece.herculesCase,
                    tax:piece.tax,
                    discount:piece.discount
                };
                if(isInterventionAccess){
                    _.extend(mainPiece,{
                        "suggestedQuantity": piece.suggestedQuantity ? piece.suggestedQuantity : null,
                        "interventionId": piece.interventionId ? piece.interventionId : null,
                        "interventionDesignation": piece.interventionDesignation ? piece.interventionDesignation : null,
                        "interventionQuantity": piece.interventionQuantity ? piece.interventionQuantity : null,
                        "interventionSieVersion": piece.interventionSieVersion ? piece.interventionSieVersion : null
                    });
                }

                if(piece.type === 'PR'){
                    _.extend(mainPiece,{
                        "plateId": checkcatalogPlateId(piece),
                        "index": checkPartIndex(piece)
                    })
                }

                if (piece.type === 'TM') {
                    _.extend(mainPiece,{
                        "hourlyRate": piece.hourlyRate,
                    })
                    mainPiece.opecod = piece.opecod;
                    if(piece.duration)
                        mainPiece.laborTime = parseFloat(piece.duration.replace(",", "."));
                        
                        mainPiece.element=piece.element;
                        mainPiece.operation=piece.operation;
                        mainPiece.gie=piece.gie;
                }
                if((isIndependantUser && !$rootScope.asomDocList.PX===true))
                        mainPiece.price="";
                

                return mainPiece;
            });
            return cart;
        }
        function checkcatalogPlateId(ref) {
            var catalogPlate = []
            if (ref.catalogPlates && ref.catalogPlates.length > 0 && ref.catalogPlates[0].id) {
                catalogPlate.push(ref.catalogPlates[0].id);
                return catalogPlate.toString();
            } else {
                return null;
            }
        }

        function checkPartIndex(ref) {
            var indexValue = "";
            if (ref.catalogPlates && ref.catalogPlates.length > 0) {
                angular.forEach(ref.catalogPlates, function (item) {
                    item.lines.forEach(function (indexData) {
                        if (indexData && indexData.repereNumber) {
                            indexValue = indexData.repereNumber
                        }
                    })
                })
                return indexValue;
            } else {
                return null; 
            }
        }

        function emitCartUpdated() {
            $rootScope.$emit('CART_UPDATED');
        }
        /**
         *  Once we update the basket, we call nd-service.
         *  The return is handled by this function
         *
         *  We get diffents ID (id cart, id on each reference) to put them on the basket
         *  These IDs are needed by nd-service for the next update
         *
         *  shoppingCart    is modified
         *  shoppingCartID  is modified
         *
         *  @param {Object} cartInformation {
         *      id: string
         *      items: [Object]
         *  }
         */
        function setIDOnShoppingCart(cartInformation) {
            _shoppingCart.forEach(function (mainPiece) {
                if (!mainPiece.id) {
                    var findedReference;
                    if(cartInformation && !_.isEmpty(cartInformation.items)){
                        if(!mainPiece.interventionId){
                            findedReference = _.filter(cartInformation.items, function (pieceFromBack) {
                                if(pieceFromBack.reference === mainPiece.reference){
                                    if(!pieceFromBack.interventionId){
                                        mainPiece.id = pieceFromBack.id;
                                        mainPiece.creationDateTime = pieceFromBack.creationDateTime;
                                        mainPiece.creator = pieceFromBack.creator;
                                        mainPiece.lastModificationDateTime = pieceFromBack.lastModificationDateTime;
                                        mainPiece.lastModifier = pieceFromBack.lastModifier;
                                        mainPiece.sbomId = pieceFromBack.sbomId;
                                        mainPiece.suggestedQuantity = pieceFromBack.suggestedQuantity;
                                        return pieceFromBack;
                                    }
                                }
                            });
                        }
                        else{
                            findedReference = _.find(cartInformation.items, function (pieceFromBack) {                            
                                if (pieceFromBack.genericPart == mainPiece.genericPart && pieceFromBack.reference === mainPiece.reference && pieceFromBack.interventionId === mainPiece.interventionId ) {
                                   return pieceFromBack;
                                }
                            });
                        }
                    }
                    if(!_.isEmpty(findedReference) && mainPiece.interventionId){
                        mainPiece.id = findedReference.id;
                        mainPiece.interventionId = findedReference.interventionId;
                    }
                }
            });
        }

        /**
         *  @desc return current cart ID
         *  @return {string}
         */

        function getCurrentCartID() {
            return _cartInformations.id
        }

        /**
         * @desc Save some informations of cart received by nd-service
         * @param {Object} computedCartFromBack
         */

        function setInformationFromComputed(computedCartFromBack) {
            _cartInformations = {
                description: computedCartFromBack.description,
                lastModifier: computedCartFromBack.lastModifier,
                lastModificationDateTime: computedCartFromBack.lastModificationDateTime,
                creator: computedCartFromBack.creator,
                creationDateTime: computedCartFromBack.creationDateTime,
                label: computedCartFromBack.label,
                id: computedCartFromBack.id,
                declared: computedCartFromBack.declared
            }
        }



        /**
         *  @desc
         *  This function must be used after basket updating.
         *  Steps :
         *      - computed basket
         *      - send to nd-service
         *      - handle return
         *          - on success, put id on basket and return true
         *          - on failure, set the previous basket and return false
         */

        function onUpdateCart() {
            let computedCart = computedShoppingCart();
            const vehicleInformations = getVehiculeInformations();
            const requestBody = _.assign({
                label: _cartInformations.label || null,
                description: _cartInformations.description || null,
                id: _cartInformations.id || null,
                items: computedCart
            }, vehicleInformations);
            blockUI.start();
            return ShoppingCartWSService.update(requestBody).then(function (computedCartFromBack) {
                setInformationFromComputed(computedCartFromBack)
                setIDOnShoppingCart(computedCartFromBack);
                emitCartUpdated();
                return computedCartFromBack;
            }).catch(function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         *  @desc
         *  This function must be used after basket updating.
         *  Steps :
         *      - computed basket
         *      - send to nd-service
         *      - handle return
         *          - on success, put id on basket and return true
         *          - on failure, set the previous basket and return false
         */

        function saveCart(estimateGroupId, selectedOptionId) {
            var computedCart = computedShoppingCart();
            var vehicleInformations = getVehiculeInformations();
            var requestBody = _.assign({
                label: _cartInformations.label || null,
                description: _cartInformations.description || null,
                id: _cartInformations.id || null,
                items: computedCart
            }, vehicleInformations);
            
            if (estimateGroupId) {
                requestBody.estimateGroupId = estimateGroupId;
            }
            
            if (selectedOptionId) {
                requestBody.selectedEstimateGroupId = selectedOptionId;
            }

            return ShoppingCartWSService.saveCart(requestBody).then(function (computedCartFromBack) {
                setInformationFromComputed(computedCartFromBack)
                setIDOnShoppingCart(computedCartFromBack);
                emitCartUpdated();
                return { success: true, id: requestBody.id };
            }).catch(function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            });
        }
        
        function onUpdateCartWithEstimate(selectedOptionId) {
            let computedCart = computedShoppingCart();
            const vehicleInformations = getVehiculeInformations();
            const requestBody = _.assign({ 
                label: _cartInformations.label || null,
                description: _cartInformations.description || null,
                id: _cartInformations.id || null,
                items: computedCart
            }, vehicleInformations);
            
            if (selectedOptionId) {
                requestBody.selectedEstimateGroupId = selectedOptionId;
            }
            
            blockUI.start();
            return ShoppingCartWSService.update(requestBody).then(function (computedCartFromBack) {
                setInformationFromComputed(computedCartFromBack)
                setIDOnShoppingCart(computedCartFromBack);
                emitCartUpdated();
                return computedCartFromBack;
            }).catch(function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         *  Call nd-service for postgres update - delete item from cart
         *  @param {piece} object
         *  @return {Promise}
         */

        function deleteReference(piece) {
            return ShoppingCartWSService.delete(_cartInformations.id, piece).then(function () {
                deletePieceInShoppingCart(piece);
                emitCartUpdated();
                return true;
            }, function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            });
        }

        function deleteIntervention(referenceID,payload) {
            var interventionId = _.isArray(referenceID) ? referenceID[0] : referenceID;
            return ShoppingCartWSService.interventionDelete(_cartInformations.id, interventionId, payload).then(function (response) {
                emitCartUpdated();
                return response;
            }, function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            });
        }
        /**
         * @desc Replace shopping cart with new cart
         * @param {Object} cart
         * @return {void}
         */
        function replaceShoppingCart(cart) {
            setInformationFromComputed(cart);
            setShoppingCart(cart.items);
            emitCartUpdated();
        }

        /**
         * @desc Delete an item in cart
         * @param {reference} string
         * @return {void}
         */

        function deletePieceToShoppingCart(reference, genericPart, payload) {
            var index = _.findIndex(_shoppingCart, function (piece) {
                if(genericPart && genericPart !== undefined && !_.isEmpty(genericPart) && !piece.interventionId){
                    if(piece.reference === reference && piece.genericPart === genericPart){
                        return piece;
                    }
                }
                else{
                    if (payload && payload.interventionId && piece.interventionId){
                        return piece.reference === reference && piece.interventionId === payload.interventionId && piece.genericPart == payload.genericPart;
                    }
                    else if (payload && !piece.interventionId){
                        return piece.reference === reference;
                    }
                }
            });
            if (index !== _enums.NOTFOUND) {
                index === 0 ? _shoppingCart.shift() : _shoppingCart.splice(index, 1);
            }
        }


        /**
         *  @desc It's work like a forEach but for piece
         *  for each piece, and PPS, we call fn
         *  @param {object} piece look at createNewStructOfPiece
         *  @param {function} cb
         *  @return {void}
         */

        function forEachElementInPiece(piece, cb) {
            // piece.additional can be null, that why we need a filter
            var listPiece = [].concat([piece], piece.additional).filter(function (piece) {
                return piece;
            });
            listPiece.forEach(function (pieceFromListPiece, index) {
                var existingPiece = lookingReferenceInCart(pieceFromListPiece.reference, piece);
                // made a copy to avoir mutation
                var copy = angular.copy(pieceFromListPiece);
                // After the first piece, the following is necessarily a PPS;
                    copy.quantity = copy.quantity || 0;
                var isPPS = index > 0;
                if (isPPS) {
                    copy.ratio = parseInt(copy.ratio);
                    if (isNaN(copy.ratio)) {
                        copy.ratio = 1;
                    }
                    copy.propertionnalQuantity = (piece.quantity || 0) * copy.ratio;
                    copy.detectAsPPS = true;
                }
                cb(copy, existingPiece);
            })
        }

        /**
         *      @desc Return actual vehicle criteria
         *      @return {object} {} or {
         *          brand: string,
         *          familyVehicle: string,
         *          bodyType: string,
         *          engineType: string,
         *          gearboxType: string,
         *          batteryType: string
         *      }
         */

        function getVehiculeInformations() {
            var vehicle = CacheService.getCarContext();
            var informations = {
                brand: "",
                familyVehicle: "",
                bodyType: "",
                engineType: "",
                gearboxType: "",
                batteryType: "",
                vin: "",
                registrationNumber: "",
                model: ""
            }

            if (!vehicle) {
                return informations;
            }

            var criterias = vehicle.fixedCriterias;
            return {
                vin: vehicle.vin || "",
                registrationNumber: vehicle.registrationNumber || "",
                brand: criterias ? criterias[CodesConstants.brand] : "",
                familyVehicle: criterias ? criterias[CodesConstants.familyVehicle] : "",
                bodyType: criterias ? criterias[CodesConstants.bodyType] : "",
                engineType: criterias ? criterias[CodesConstants.engineType] : "",
                gearboxType: criterias ? criterias[CodesConstants.gearboxType] : "",
                batteryType: criterias ? criterias[CodesConstants.batteryType] : "",
                model: vehicle.model || ""
            }
        }

        /**
         *  @desc Filled shoppingcart by an array of piece
         *
         *  @param {Array<piece>} state
         *
         *  @return {void}
         */
        function setShoppingCart(state) {
            _shoppingCart = angular.copy(state);
        }

        function getShoppingCart() {
            return angular.copy(_shoppingCart);
        }

        function unlockCart(id) {
            return CartViewListWSService.unlockCart().then(function () {
                if (_cartInformations.id === id) {
                    clean();
                    emitCartUpdated();
                }
            });
        }

        function getCartMedatadata() {
            return angular.copy(_cartInformations);
        }

        /**
         * @desc Research inside _shoppingCart through an reference
         * @param {string} reference
         * @return {undefined | object<piece>}
         */

        function lookingReferenceInCart(reference, selectedPiece) {
            var index;
            if(selectedPiece.genericPart && !_.isEmpty(selectedPiece.genericPart)){
                if(!selectedPiece.interventionId){
                    index = _.findIndex(_shoppingCart, function (piece) {
                        if(!piece.interventionId && (piece.genericPart === selectedPiece.genericPart) && piece.reference && (piece.reference === reference)){
                            return piece.reference;
                        }
                    });
                }
                else{
                    index = _.findIndex(_shoppingCart, function (piece) {
                        if((piece.genericPart === selectedPiece.genericPart && selectedPiece.interventionId && piece.interventionId && piece.interventionId !== null && piece.interventionId === selectedPiece.interventionId )){
                            return piece.reference === reference;
                        }
                    });
                }
            }
            else{
                if(!selectedPiece.interventionId){
                    index = _.findIndex(_shoppingCart, function (piece) {
                        if((piece.reference === selectedPiece.reference) && !piece.interventionId){
                            return piece.reference;
                        }
                    });
                }
                else {
                    index = _.findIndex(_shoppingCart, function (piece) {
                     if(selectedPiece.interventionId && piece.interventionId && piece.interventionId !== null && piece.interventionId === selectedPiece.interventionId){
                        return piece.reference === reference;
                       }
                    });
                }
            }
            return _shoppingCart[index];
        }

        function reverseShoppingCart() {
            _shoppingCart = _previousShoppingCart;
        }

        /**
         * @desc Add an item inside shoppingCart
         * @param {object} piece
         * @return {void}
         */

        function addPieceToShoppingCart(piece) {
            _shoppingCart.push(piece);
        }


        /**
        *   @desc This function is used to create struct of piece for each type
        *   @return {object}
        */

        function createNewStructureOfPieceByType(piece, type) {
            if (type === 'TM') {
                return {
                    reference: piece.technicalId,
                    opecod: piece.id,
                    duration: piece.duration,
                    designation: piece.designation,
                    element:piece.element,
                    operation:piece.operation,
                    gie:piece.gie,
                    essay: piece.essay,
                    tax: 0,
                    discount: 0,
                    hourlyRate: 0
                }
            } else if (type === 'PR') {
                return {
                    reference: piece.originalPartReference,
                    designation: piece.designation,
                    priceExclTaxes: piece.priceWithoutTaxes,
                    currency: piece.currency,
                    reach: !!piece.reach,
                    tax: 0,
                    discount: 0
                }
            }
        }

        function createNewStructOfPiece(piece, type, quantity) {
            return {
                reference: piece.reference,
                quantity: quantity,
                type: type,
                designation: piece.designation,
                genericPart:piece.genericPart,
                sbomId:piece.sbomId,

                /** PR | PRODUCTS */
                reach: piece.reach,
                priceHT: piece.priceExclTaxes,
                currency: piece.currency,
                /** TM */
                opecod: piece.opecod,
                duration: piece.duration,
                element:piece.element,
                operation:piece.operation,
                gie:piece.gie
            }
        }

        function deletePieceIfQuantityNull(piece) {
            if (piece.quantity === 0) {
                deletePieceToShoppingCart(piece.reference)
            }
        }

        function addQuantity(piece, quantity, isInputQuantity) {

            if (isInputQuantity) {
                piece.quantity = parseFloat(piece.quantity || 0) + parseFloat(quantity || 0);
            } else {
                piece.quantity = parseInt(piece.quantity || 0) + parseInt(quantity || 0);
            }

            return piece;
        }

        function reduceQuantity(piece, quantity, isInputQuantity) {

            if (isInputQuantity) {
                piece.quantity = parseFloat(piece.quantity || 0) - parseFloat(quantity || 0);
            } else {
                var currentQuantity = piece.quantity || 0;
                var reductionAmount = parseInt(quantity || 0);
                
                // If current quantity is a decimal, just truncate to integer (don't subtract)
                if (currentQuantity.toString().indexOf('.') !== -1 || currentQuantity.toString().indexOf(',') !== -1) {
                    piece.quantity = parseInt(currentQuantity);
                } else {
                    // For integer quantities, perform normal reduction
                    piece.quantity = parseInt(currentQuantity) - reductionAmount;
                }
            }

            return piece;
        }

        function checkMaxQuantity(piece) {
            if (piece.quantity > _enums.QUANTITY_MAX) {
                piece.quantity = _enums.QUANTITY_MAX;
            }
            return piece;
        }

        function checkMinQuantity(piece) {
            if (piece.quantity < _enums.QUANTITY_MIN) {
                piece.quantity = _enums.QUANTITY_MIN;
            }
            return piece;
        }

        function sendOperationDetails(basketDetails){

            if(basketDetails.levelOneNode && !_.isEmpty(basketDetails.levelOneNode)){
                var formattedDate = moment(basketDetails.startDate).format("YYYY-MM-DD")
                var payload = {
                    operationDate: formattedDate,
                    mileage: basketDetails.operationalDetailsMileage ? basketDetails.operationalDetailsMileage :'',
                    factureNumber: basketDetails.operationalDetailsFacture ? basketDetails.operationalDetailsFacture:'',
                    levelOne : basketDetails.levelOneNode ? basketDetails.levelOneNode:'',
                    levelTwo : basketDetails.arrNodeslvl ? basketDetails.arrNodeslvl :'',
                    elementsOperations : basketDetails.arrNodesElm ? basketDetails.arrNodesElm:'',
                    operationDescription : basketDetails.operationalDetailsDescription ? basketDetails.operationalDetailsDescription:'',
                    title: basketDetails.operationalDetailsTitle ? basketDetails.operationalDetailsTitle:'',
                    origin: PanierConstants.origin,
                    ipn: basketDetails.cartMedatadata ? basketDetails.cartMedatadata.creator : '',
                }
            }
            else{
                var partsdetails = [];
            var tmDetails = [];

            if(basketDetails.panier && basketDetails.panier.pr && !_.isEmpty(basketDetails.panier.pr)){

                partsdetails = _.map(basketDetails.panier.pr,function(item){
                    return _.pick(item,PanierConstants.partDetailsForOperations);
                })
            }

            if(basketDetails.panier && basketDetails.panier.tm && !_.isEmpty(basketDetails.panier.tm)){

                tmDetails = _.map(basketDetails.panier.tm,function(item){
                    return _.pick(item,PanierConstants.tmDetailsForOperations);
                })
            }

            _.map(tmDetails, function(it){
                _.assign(it,{
                    laborTime:it.duration ? parseFloat(it.duration.replace(",", ".")) : 0
                });

                delete it['duration'];
            })

            var payload = {
                operationDate: basketDetails.formattedDate,
                mileage: basketDetails.operationalDetailsMileage,
                invoiceNumber: basketDetails.operationalDetailsInvoice,

                basketNumber: basketDetails.cartMedatadata ? basketDetails.cartMedatadata.id : '',
                ipn: basketDetails.cartMedatadata ? basketDetails.cartMedatadata.creator : '',
                origin: PanierConstants.origin,

                parts: partsdetails,
                laborTimes: tmDetails

            }
            }
            

            var vin = basketDetails.vehicle.vin;
            var defer = $q.defer();

            ShoppingCartWSService.sendOperationDetails(payload,vin).then(function(response){
                if(response){
                    defer.resolve(response);
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE'));
                }

            }).catch(function(err){
                if(err){
                    defer.reject(err);
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE'));
                }
            })

            return defer.promise;

        }

        function declareCart(basketDetails){

            var payload = {

                id: basketDetails.cartMedatadata ? basketDetails.cartMedatadata.id : '',
                declared: true
            }

            var defer = $q.defer();

            ShoppingCartWSService.declareCart(payload).then(function(response){
                if(response){
                    defer.resolve(response);
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE_SAVE'));
                }
            }).catch(function(err){
                if(err){
                    defer.reject(err);
                }else{
                    defer.reject($translate.instant('ERROR_IN_DECLARE_SAVE'));
                }
            })

            return defer.promise;
        }

        function getR2APriceStockDetails(garageId, dealerId, refQuantityList,url,panierList){

            var defer = $q.defer();

            var cacheProfile = CacheService.getObject(CacheConstants.profil);
            var countryCode = cacheProfile.country;

            ShoppingCartWSService.getR2APriceStockDetails(garageId, dealerId, refQuantityList,url,false,false).then(function(response){ 
                
                if(response && !_.isEmpty(panierList) && !_.isEmpty(response.products)){ 
                    panierList.forEach(function(pr){
                        response.products.forEach(function(ref){
                            if(pr.reference == ref.reference && !_.isEmpty(ref.warehouses) && ref.itemReturnCode === 'A000'){ 
                                var totalStockAvailable = 0, stockMCandDMS = 0, stock_CPD_ORDENAL = 0;
                                var stockDMS = 0, isDMSResponse = false;
                                var stockCDP = 0, isCDPResponse = false;
                                var stockORDENAL = 0, isORDENALResponse = false;
                                var stockMC = 0 , isMCResponse = false;
                                
                                ref.warehouses.forEach(function(item){
                                    const warehouseType = item.type ? item.type.toUpperCase() : null;
                                    const isValidWarehouseType = warehouseType === 'LOCAL' || warehouseType === 'REGION' || 
                                                                warehouseType === 'COUNTRY' || warehouseType === 'CENTRAL' || 
                                                                warehouseType === 'WW';
                                    
                                    if (!isValidWarehouseType) {
                                        pr.applicableClass = 'STOCK_PART_UNAVAILABLE';
                                        return;
                                    }

                                    switch(item["code"]) {
                                        case 'DMS' : 
                                            stockDMS = item.confirmedQuantity; 
                                            isDMSResponse = true;
                                            break;
                                        case 'CDP' :
                                            stockCDP = item.confirmedQuantity; 
                                            isCDPResponse=true;
                                            break;
                                        case 'ORDENAL' :
                                            stockORDENAL = item.confirmedQuantity; 
                                            isORDENALResponse= true;
                                            break;
                                        case 'SIGMPR' :
                                            stockMC = stockMC + item.confirmedQuantity; 
                                            isMCResponse = true;
                                            break;
                                    }

                                    if (countryCode === 'FR') {
                                        if (item["code"] === 'DMS' && item.confirmedQuantity >= ref.quantity) {
                                            pr.applicableClass = 'STOCK_AVAILABLE'
                                        } else if (item["code"] === 'MPR88' && isDMSResponse && stockDMS < ref.quantity) {
                                            totalStockAvailable = stockDMS + item.confirmedQuantity;
                                            if (totalStockAvailable >= ref.quantity) {
                                                pr.applicableClass = 'STOCK_AVAILABLE_D1'
                                            } else if (totalStockAvailable < ref.quantity && totalStockAvailable > 0) {
                                                pr.applicableClass = 'STOCK_PARTIAL'
                                            } else {
                                                pr.applicableClass = 'STOCK_PART_UNAVAILABLE'
                                            }
                                        } else if (item["code"] === 'MPR88' && !isDMSResponse) {
                                            if (item.confirmedQuantity >= ref.quantity) {
                                                pr.applicableClass = 'STOCK_CERGY'
                                            }else if (item.confirmedQuantity < ref.quantity && item.confirmedQuantity > 0) {
                                                pr.applicableClass = 'STOCK_PARTIAL'
                                            }else {
                                                pr.applicableClass = 'STOCK_PART_UNAVAILABLE'
                                            }
                                        } else if (item['code'] === 'DIFF') {
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        } else {
                                            pr.applicableClass = 'STOCK_PART_UNAVAILABLE'
                                        }
                                    }  else if(countryCode === 'IT') {
                                        if(item["code"] === 'DMS' && item.confirmedQuantity >= ref.quantity ){
                                            pr.applicableClass = 'STOCK_IT_ES_GREEN'
                                        }else if(item["code"] === 'SIGMPR' && isDMSResponse && stockDMS < ref.quantity) {
                                            stockMCandDMS = stockDMS + item.confirmedQuantity;
                                            if(stockMCandDMS >= ref.quantity)
                                                pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                        } else if(item["code"] === 'SIGMPR' && !isDMSResponse && item.confirmedQuantity >= ref.quantity) {
                                            pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                        }
                                        else if(item["code"] === 'MPR88' && isDMSResponse && isMCResponse && stockMCandDMS < ref.quantity){
                                            totalStockAvailable = stockMCandDMS + item.confirmedQuantity;
                                            if(totalStockAvailable >= ref.quantity){
                                                pr.applicableClass = 'STOCK_CERGY'
                                            }else {
                                                pr.applicableClass = 'STOCK_UNAVAILABLE'
                                            }
                                        }else if(item["code"] === 'MPR88' && !isDMSResponse && !isMCResponse && item.confirmedQuantity >= ref.quantity ){
                                            pr.applicableClass = 'STOCK_CERGY'
                                         } else if(item['code'] === 'DIFF') { 
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                         }
                                        else{
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        }
                                    } else if(countryCode === 'ES'){
                                        if(item["code"] === 'CDP' && item.confirmedQuantity >= ref.quantity ){
                                            pr.applicableClass = 'STOCK_IT_ES_GREEN'
                                        } else if(item["code"] === 'ORDENAL' && isCDPResponse && stockCDP < ref.quantity) {
                                            stock_CPD_ORDENAL = stockCDP + item.confirmedQuantity;
                                            if(stock_CPD_ORDENAL >= ref.quantity){
                                                pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                            }
                                         } else if(item["code"] === 'ORDENAL' && !isCDPResponse && item.confirmedQuantity >= ref.quantity) {
                                            pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                        } else if(item['code'] === 'DIFF') { 
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        } else if(item["code"] === 'ORDENAL' && item.confirmedQuantity < ref.quantity) {
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        } else {
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        }
                                    } 
                                    else {
                                        if(item["code"] === 'DMS' && item.confirmedQuantity >= ref.quantity )
                                            pr.applicableClass = 'STOCK_AVAILABLE'
                                        else if(item["code"] === 'SIGMPR' && isDMSResponse && stockDMS < ref.quantity) {
                                            stockMCandDMS = stockDMS + item.confirmedQuantity;
                                            if(stockMCandDMS >= ref.quantity)
                                                pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                        } else if(item["code"] === 'SIGMPR' && !isDMSResponse && item.confirmedQuantity >= ref.quantity) {
                                            pr.applicableClass = 'STOCK_IT_ES_YELLOW'
                                        }
                                        else if(item["code"] === 'MPR88' && isDMSResponse && isMCResponse && stockMCandDMS < ref.quantity){
                                            totalStockAvailable = stockMCandDMS + item.confirmedQuantity;
                                            if(totalStockAvailable >= ref.quantity){
                                                pr.applicableClass = 'STOCK_CERGY'
                                            }
                                            else {
                                                pr.applicableClass = 'STOCK_UNAVAILABLE'
                                            }
                                        }
                                        else if(item["code"] === 'MPR88' && !isDMSResponse && !isMCResponse && item.confirmedQuantity >= ref.quantity )
                                            pr.applicableClass = 'STOCK_CERGY'
                                        else if(item['code'] === 'DIFF') { 
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                         }
                                        else
                                            pr.applicableClass = 'STOCK_UNAVAILABLE'
                                        pr.applicableClass = ((countryCode === 'BE' && cacheProfile.language === 'fr' ) ? pr.applicableClass +'_BE':pr.applicableClass +'')    
                                    }
                                })
                            }
                            else if(pr.reference == ref.reference && ref.itemReturnCode === 'A001'){
                                pr.applicableClass = 'UNKNOWN_PARTS_RPARTS';
                            } else if(pr.reference == ref.reference && ref.itemReturnCode === 'A000' && _.isEmpty(ref.warehouses)){
                                pr.applicableClass = null;
                            }
                        })
                    })

                    defer.resolve(panierList);
                }
            }).catch(function(error){
                if(error && error.data && !_.isEmpty(error.data.errors[0]) && error.data.errors[0].errorCode.length == 4){
                    toastr.error($translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                }
                defer.reject();
            });

            return defer.promise;


        }

        function getCentralStockDetails(references,cachedetail,selectedDealer){
            var payload = {
                "repository": CarSearchConstants.r2aRepo,
                "dealerId": selectedDealer,                
                "products":references
            };
            if(cachedetail.r1){
                _.extend(payload,{
                    "garageId": cachedetail.garageId
                });
            }else{
                _.extend(payload,{
                    "central":true
                });
            }
          var defer = $q.defer();
          ShoppingCartWSService.getCentralStockDetails(payload).then(function (response) {
                defer.resolve(response);
            }).catch(function(error){
                if(error && error.data && !_.isEmpty(error.data.errors[0]) && error.data.errors[0].errorCode.length == 4){
                    toastr.error($translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                }
                defer.reject();
            });
            return defer.promise;     
        }

        function closeCart(estimateGroupId, selectedOptionId) { 

            var computedCart = computedShoppingCart();
            var vehicleInformations = getVehiculeInformations();
            var requestBody = _.assign({
                label: _cartInformations.label || null,
                description: _cartInformations.description || null,
                id: _cartInformations.id || null,
                items: computedCart
            }, vehicleInformations);
            
            if (estimateGroupId) {
                requestBody.estimateGroupId = estimateGroupId;
            }
            
            if (selectedOptionId) {
                requestBody.selectedEstimateGroupId = selectedOptionId;
            }
            return ShoppingCartWSService.closeCart(requestBody).then(function () {
                    clean();
                    emitCartUpdated();
                    return { id: requestBody.id };
            }).catch(function (err) {
                reverseShoppingCart();
                return $q.reject(err);
            });
        }
        
        function r2aPlaceOrder(dealer, ipn , productList,orderMark, comments, isUrgent,garageId){
            var defer = $q.defer();
            var payload = {                
                "dealerId": dealer.dealerId,
                "ipn" : ipn,            
                "repository": CarSearchConstants.r2aRepo,
                "clientCode" : dealer.clientCode.trim(),
                /*"dealerId": "75699080",//dealer.dealerId,
                "ipn" : "dh00901",//ipn,            
                "repository": "TRESOR", //CarSearchConstants.r2aRepo,   
                "clientCode" : "75699081",//dealer.clientCode.trim(),*/
                "products":productList,
                "mark":(orderMark && orderMark != '')? orderMark : '' ,
                "comment":(comments && comments != '')? comments : '',
                "garageId": garageId,
                "sia": "PPX"
            }
            if(isUrgent){
                _.assign(payload,{urgent:true})
            }
            ShoppingCartWSService.placeOrder(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }
        function rpsPlaceOrder(productList){
            const defer = $q.defer();
            const userProfil = CacheService.getUserProfile();
            const payload = {
                "sia": CarSearchConstants.ppxSia,
                "buyerId": userProfil.dealerId ? userProfil.dealerId : '',
                "repository": CarSearchConstants.r2aRepo,
                "products": productList
            }
            
            ShoppingCartWSService.rpsPlaceOrder(payload).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function updateRpsPartsTransfer(rpsTransferData){
            const defer = $q.defer();
            ShoppingCartWSService.updateRpsPartsTransfer(rpsTransferData).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function getEstimateGroup(){
            var defer = $q.defer();
            ShoppingCartWSService.getEstimateGroup().then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function getEstimateGroupById(estimateGroupId){
            var defer = $q.defer();
            ShoppingCartWSService.getEstimateGroupById(estimateGroupId).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }

        function updateRpsId(id, rpsId, url){
            var defer = $q.defer();
            ShoppingCartWSService.updateRpsId(id, rpsId, url).then(function(response){
                defer.resolve(response);
            }).catch(function(error){
                defer.reject(error);
            })
            return defer.promise;
        }
    })
})();

(function () {
    angular.module('phenix').constant('ShoppingCartServiceConstant', {
        actions: {
            ADD_PIECE: 'ADD_PIECE',
            ADD_QUANTITY: 'ADD_QUANTITY',
            ADD_OPERATIONS: 'ADD_OPERATIONS',
            REDUCE_QUANTITY: 'REDUCE_QUANTITY',
            REPLACE_QUANTITY: 'REPLACE_QUANTITY',
            DELETE_PIECE: 'DELETE_PIECE',
            UPDATE_CARTMETADATA: 'UPDATE_METADATA',
            CLEAN: 'CLEAN',
            REPLACE_CART: 'CLEAN',
            ADD_ONE: 'ADD_ONE',
            REDUCE_ONE: 'REDUCE_ONE'

        },
        events: {
            cartUpdated: 'CART_UPDATED'
        },
        enums : {
            NOTFOUND: -1,
            QUANTITY_MAX: 999,
            QUANTITY_MIN: 0
        },
        essai: {
            1: '0129',
            2: '0130',
            4: '0145'
        },
        testTime: {
            1: 0.5,
            2: 0.8,
            4: 0.3
        }
    })
})();

(function () {
    angular.module('phenix').service('CartViewListWSService', function (RestUpgrade, $q, $translate, cartViewListConstants) {

        /*************************
         *      VARIABLE         *
         ************************/

        var _endpoint = cartViewListConstants.endpoint;
        var _errors = cartViewListConstants.errors

        /************************
         *      FUNCTIONS       *
         ***********************/

        this.getCartsList = getCartsList;
        this.deleteCarts = deleteCarts;
        this.getCart = getCart;
        this.unlockCart = unlockCart;

        /**
         * @desc Get all cart from nd-service
         * @param {Object} body
         * @return {Promise<Object} {
         * carts : [{
         *       "creationDateTime": string,
         *       "creator": string,
         *       "label": string,
         *       "description": string,
         *       "vin": string,
         *       "registrationNumber": string,
         *       "brand": string,
         *       "familyVehicle": string,
         *       "bodyType": string,
         *       "engineType": string,
         *       "gearboxType": string,
         *       "batteryType": string,
         *       "lastModificationDateTime": string,
         *       "lastModifier": string,
         *       "dealerId": string,
         *       "costCenter": string,
         *       "lockedByUser": boolean,
         * }]
         * totalCount: number
         * }
         */

        function getCartsList(body) {
            return RestUpgrade.all(_endpoint.list).post(body).then(function (response) {
                if (!response) {
                    return $q.reject({}); // TODO REJECT SOMETHING?
                }
                return response;
            });
        }

        /**
         * @desc Get cart from nd-service
         * @param {string} id
         * @return {Promise<Object} {
         *   "id": number,
         *   "label" : string,
         *   "description" : string,
         *   "vin": string,
         *   "registrationNumber": string,
         *   "brand": string,
         *   "familyVehicle": string,
         *   "bodyType": string,
         *   "engineType": string,
         *   "gearboxType": string,
         *   "batteryType":string,
         *   "items" : [{
         *       "id": number,
         *       "reference" : string,
         *       "type" : string,
         *       "quantity": number
         *   }]
         *   "lockedByUser": boolean,
         *
         * }
         */

        function getCart(id) {
            return RestUpgrade.one(_endpoint.cart, id).get().then(function (response) {
                if (response.errors && Array.isArray(response.errors)) {
                    var errors = response.errors.map(function (error) {
                        var msg;
                        switch (error.code) {
                            case _errors.isLocked:
                                msg = $translate.instant('ERROR_LOCK_CART').replace('#1', id).replace('#2', error.data[0]);
                                break;
                            default:
                                msg = $translate.instant('ERROR');
                        }
                        return {
                            msg : msg
                        };
                    })
                    return $q.reject({ errors: errors })
                }
                return response;
            });
        }


        /**
         * @desc Call nd-service for delete some carts
         * @param {Array<string>} listID
         * @return {Promise<?>}
         */

        function deleteCarts(listID) {
            return RestUpgrade.all(_endpoint.delete).post(listID);
        }

        function unlockCart() {
            return RestUpgrade.all(_endpoint.unlock).post();
        }

    })
})();

(function () {
    angular.module('phenix').service('CartViewListService', function (cartViewListConstants, CartViewListWSService) {
        this.getCartsList = getCartsList;
        this.deleteCarts = deleteCarts;
        this.getCart = getCart;

        var _searchBy = cartViewListConstants.searchBy;

        /**
         *
         * @param {!Object} filter {
         *      !ipn : string
         *      !keyWord : string
         *      !number: string
         *      !registerNumber: string,
         *      !vim: string
         * }
         * @param {Object} sort {
         *      sort: string,
         *      order: number (1 || -1)
         * }
         * @param {Object} pagination {
         *      limit: number,
         *      offset: number
         * }
         * @return {Promise<Array<Object>>} See cartViewListWSService.getCartsList output + extend {
         *      vehiculeLabel: string,
         *      searchBy: number
         * }
         *
         */

        function getCartsList(filter, sort, pagination) {
            var requestBody = {
                cartFilter: filter || undefined,
                sort: sort,
                pagination: pagination
            }
            return CartViewListWSService.getCartsList(requestBody).then(function (response) {
                return {
                    carts: addCartsInformations(response.carts),
                    totalCount: response.totalCount
                }
            });
        }

        function getCart(id) {
            return CartViewListWSService.getCart(id);
        }

        /**
         * @desc Add informations inside cart
         *      + Format label of vehicle depend of vin/registrationNumber or research by model
         *      + searchBy
         *
         * @param {Array<Object>} cartsList See cartViewListWSService.getCartsList
         * @return {Object} cartsList + 2 fields en each object {
         *      vehiculeLabel: string,
         *      searchBy: number
         * }
         */

        function addCartsInformations(cartsList) {
            return cartsList.map(function (cart) {
                var vehiculeLabel = '';
                var searchBy = 0;

                if (cart.vin) {
                    vehiculeLabel = cart.vin;
                    searchBy = _searchBy.vin;
                    if (cart.registrationNumber) {
                        vehiculeLabel += ' | ' + cart.registrationNumber
                    }
                } else if (cart.registrationNumber) {
                    vehiculeLabel = cart.model;
                    searchBy = _searchBy.registrationNumber;
                } else if (cart.brand) {
                    vehiculeLabel =  '';
                    searchBy = _searchBy.model;
                }

                cart.vehiculeLabel = vehiculeLabel;
                cart.searchBy = searchBy;
                return cart;
            })
        }

        /**
         *
         * @param {Array<String>} listCartsID
         * @return {Promise<null>}
         */

        function deleteCarts(listCartsID) {
            var requestBody = {
                cartIds: listCartsID
            }
            return CartViewListWSService.deleteCarts(requestBody).then(function () {
                return null;
            })
        }
    })
})();

(function () {

    /*
     * ********* ! This is factory is used to mock data from server side - Will be removed once the API is ready ! ************
     */
    angular.module('phenix').factory('Resource', ['$q', '$filter', '$timeout', function ($q, $filter, $timeout) {

        //this would be the service to call your server, a standard bridge between your model an $http

        // the database (normally on the server)
        var randomsItems = [];

        function createRandomItem(id) {
            var createdBy = ['Batman',
                'Superman',
                'Robin',
                'Thor',
                'Hulk',
                'Niki Larson',
                'Stark',
                'Bob Leponge'];

            var model = [
                'Renault Clio R.S (B98)',
                'BMW 328 xi (B98)',
                'Peugeot 308 GTI (B98)',
                'Golf GTI Mk7 (B98)',
                'Mercedes CLA (B98)',
                'Audi S4 (B98)',
                'BMW M3 (B98)',
                'Mazda CX5 GT (B98)',
                'Mazda 3 GT (B98)'];

            var vin = [
                'VF1CNBA0544210258',
                'TYUCNBA0544210258',
                'TGHCNBA0544210258',
                'POICNBA0544210258',
                'LKOKNBA0544210258',
                'ERTCNBA0544210258'];

            var immat = [
                'ERT-121-AA',
                'DFE-101-EE',
                'GRX-4701',
                'EDF-134-UU',
                'GDF-346-LL',
                'GRT-123-XX'];

            var status = ['Fermé',
                'Abandoned',
                'Envoyé',
                'Brouillon',
                'À Traiter'];

            var symptom = [
                'G085 - Bruit/Vibration au démarrage ou à la coupure moteur : indifféremment',
                'S010 - Ceinture de sécurité : mauvais enroulement',
                'V232 - Lavage de la lunette : dysfonctionnement'];

            var created = ['2018/11/20',
                '2018/09/20',
                '2018/01/12',
                '2018/03/10',
                '2018/05/21'];

            var modified = ['2018/11/12',
                '2018/03/02',
                '2018/04/12',
                '2018/06/30',
                '2018/07/18',
                '2018/10/17',
                '2018/11/16',
                '2018/12/15',
                '2018/13/14'];

            return {
                id: id,
                or: Math.floor(Math.random() * 10000000 * id),
                status: status[Math.floor(Math.random() * 5)],
                vehicle: model[Math.floor(Math.random() * 3)]+' | '+
                    vin[Math.floor(Math.random() * 3)]+' | '+ immat[Math.floor(Math.random() * 3)],

                symptom: symptom[Math.floor(Math.random() * 3)],
                created: created[Math.floor(Math.random() * 3)],
                lastModified: modified[Math.floor(Math.random() * 2)],
                createdBy: createdBy[Math.floor(Math.random() * 3)]
            };

        }

        var orderStatus = ["Brouillon", "À Traiter", "Envoyé", "Fermé"];

        //Create x number of data and push them to randomsItems
        for (var i = 0; i < 80; i++) {
            randomsItems.push(createRandomItem(i));
        }

        randomsItems = _.sortBy(randomsItems, function(obj){
            return new Date(obj.lastModified);
        });

        randomsItems = _.sortBy(randomsItems, function(obj){
            return _.indexOf(orderStatus, obj.status);
        });

        //fake call to the server, normally this service would serialize table state to send it to the server
        // (with query parameters for example) and parse the response
        //in our case, it actually performs the logic which would happened in the server
        function getPage(start, number, params) {

            var deferred = $q.defer();

            var filtered = params.search.predicateObject ? $filter('filter')(randomsItems, params.search.predicateObject) : randomsItems;

            if (params.sort.predicate) {
                filtered = $filter('orderBy')(filtered, params.sort.predicate, params.sort.reverse);
            }

            var result = filtered.slice(start, start + number);

            $timeout(function () {
                //note, the server passes the information about the data set size
                deferred.resolve({
                    data: result,
                    numberOfPages: Math.ceil(filtered.length / number)
                });
            }, 1000);


            return deferred.promise;
        }

        return {
            getPage: getPage
        };

    }])
})();

(function () {
    angular.module('phenix').service('FicViewListWSService', function ($q, $translate, ficViewListConstants,ProfilConstants,RestUpgrade) {

        /*************************
         *      VARIABLE         *
         ************************/

        var _endpoint = ficViewListConstants.endpoint;

        /************************
         *      FUNCTIONS       *
         ***********************/

        this.getFicList = getFicList;
        this.getSymptomList = getSymptomList;
        this.convertStatusToND = convertStatusToND;
        this.showLastModificationDate = showLastModificationDate;
        
        function getFicList(dealerId, page, pageSize) {
            var url = ficViewListConstants.endpoint.listCase + dealerId + "/cases?page=" + page + "&pageSize=" + pageSize;
            return RestUpgrade.one(url).get();
        }


        function getSymptomList(symptomsPayload) {
            return RestUpgrade.all(ficViewListConstants.endpoint.symptoms).post(symptomsPayload);
        }

        function showLastModificationDate(responseDate) {
            var url = ProfilConstants.storeLastModificationDate;
            return RestUpgrade.all(url).post(responseDate).then(function () {
                return $q.resolve();
            }).catch(function () {
                return $q.reject();
            })
            
        }

        /**
         * @desc Convert the Salesforce status to New Dialogys Status
         * @param {object} status of the fic
         */
        function convertStatusToND (status) {
            switch (status) {
                case "Draft":
                    status = "ACTIS_DRAFT";
                    break;
                case "Closed":
                    status = "ACTIS_CLOSED";
                    break;
                case "Answered":
                    status = "ACTIS_ANSWERED";
                    break;
                case "New":
                    status = "ACTIS_NEW";
                    break;
                case "Waiting For Reply":
                    status = "ACTIS_WAIT_FOR_REPLY";
                    break;
                case "More Info Needed":
                    status = "ACTIS_MORE_INFO_NEEDED";
                    break;
                case "Back To Queue":
                    status = "ACTIS_BACK_TO_QUEUE";
                    break;
                case "In Progress":
                    status = "ACTIS_IN_PROGRESS";
                    break;
                case "Back":
                    status = "ACTIS_BACK";
                    break;
                case "Email Received":
                    status = "ACTIS_EMAIL_RECEIVED";
                    break;
                case "Waiting Expert Answer":
                    status = "ACTIS_WAITING_EXPERT_ANSWER";
                    break;
                case "Expert Answer Received":
                    status = "ACTIS_EXPERT_ANSWER_RECEIVED";
                    break;
                case "Draft In Queue":
                    status = "ACTIS_DRAFT_IN_QUEUE";
                    break;
                case "Waiting Email Answer":
                    status = "ACTIS_WAITING_EMAIL_ANSWER";
                    break;
                case "Abandoned":
                    status = "ACTIS_ABANDONED";
                    break;
                case "Reopen":
                    status = "ACTIS_REOPEN";
                    break;
                case "Resolved":
                    status = "ACTIS_PROPOSAL";
                    break;
            }

            return status;
        }
    });
})();

(function () {
    angular.module('phenix').service('FicViewListService', function (ficViewListConstants,
                                                                     FicViewListWSService,
                                                                     UtilsMetierService,
                                                                     $filter,
                                                                     $q,
                                                                     $translate) {

        /************************
         *      FUNCTIONS       *
         ***********************/
        this.getFicList = getFicList;
        this.smartTableMainFilters = smartTableMainFilters;
        this.dataTransformation = dataTransformation;
        this.getSymptomCodes = getSymptomCodes;
        this.showLastModificationDate = showLastModificationDate;                                                                  
        /*************************
         *      VARIABLE         *
         ************************/

        var _searchBy = ficViewListConstants.searchBy;


        /**
         *
         * @param dealerId
         * @param page
         * @param pageSize
         * @returns {*}
         */
        function getFicList(dealerId, page, pageSize) {
            return FicViewListWSService.getFicList(dealerId, page, pageSize);
        }

        /**
         *
         * @param responseResult
         * @param tableState
         * @param start
         * @param numberOfEntriesPerPage
         * @returns {*}
         */
        function smartTableMainFilters(listFics) {
            var filtered = listFics;
            var filteredStatusDraft = [];
            var filteredStatusAnswered = [];
            var filteredStatusProposal = [];
            var filteredStatusSent = [];
            var filteredStatusClosed = [];

            if (filtered && filtered.length) {
                filtered.forEach(function (item) {
                    if (item.CaseDetail.status === $translate.instant("ACTIS_DRAFT")) {
                        filteredStatusDraft.push(item);
                    } else if (item.CaseDetail.status === $translate.instant("ACTIS_ANSWERED")) {
                        filteredStatusAnswered.push(item);
                    } else if (item.CaseDetail.status === $translate.instant("ACTIS_PROPOSAL")) {
                        filteredStatusProposal.push(item);
                    } else if (item.CaseDetail.status === $translate.instant("ACTIS_SENT")) {
                        filteredStatusSent.push(item);
                    } else if (item.CaseDetail.status === $translate.instant("ACTIS_CLOSED")) {
                        filteredStatusClosed.push(item);
                    }
                });

                filtered = [];
                if (filteredStatusDraft.length){
                    filtered = filtered.concat(filteredStatusDraft);
                }
                if (filteredStatusAnswered.length){
                    filtered = filtered.concat(filteredStatusAnswered);
                }
                if (filteredStatusProposal.length){
                    filtered = filtered.concat(filteredStatusProposal);
                }
                if (filteredStatusSent.length){
                    filtered = filtered.concat(filteredStatusSent);
                }
                if (filteredStatusClosed.length){
                    filtered = filtered.concat(filteredStatusClosed);
                }
            }
                    

            return filtered;
        }


        /**
         * @desc get symptom codes and defines Array.from polyfill function (not supported on IE 11)
         * @param listFicFiltered
         * @returns {*}
         */

        function getSymptomCodes(listFicFiltered) {

            if (!Array.from) {
                UtilsMetierService.createArrayObject();
            }

            return Array.from(
                listFicFiltered
                    .sort()
                    .reduce(function (value, index) {
                        if (index != value[0]) {
                            value.unshift(index);
                        }
                        return value;
                    }, [])
                    .filter(function (value, index) {
                        var symptomCode = value.Request.symptomCode;
                        if (symptomCode) {
                            return symptomCode;
                        }
                        //no duplicates
                    }).map(function (value) {
                    return value.Request.symptomCode;
                }));
        }


        /**
         * If user has actis right we only dislay list fics that he created
         * Also we NEVER DISPLAY FICS with ABANDONED STATUS
         *
         * @param filteredSlicedFics : will need that for the pagination
         * @param lastName of the creator
         * @returns {*}
         */
        function applyActisUserRightFilter(filteredSlicedFics, lastName, isActisProfil) {
            return filteredSlicedFics.filter(function (value) {
                if (isActisProfil && value && value.Dealer && value.Dealer.contactLastName &&
                    lastName === value.Dealer.contactLastName.toUpperCase() &&
                    value.CaseDetail.status !== $translate.instant('ACTIS_ABANDONED')
                ) {
                    return value;
                } else if (value.CaseDetail.status !== $translate.instant('ACTIS_ABANDONED')) {
                    return value;
                }
            });
        }

        function showLastModificationDate(responseDate){
            return FicViewListWSService.showLastModificationDate(responseDate);
        }
        /**
         *
         * @param filteredSlicedFics
         * @param lastName
         * @param userContext
         * @param carContext
         */
        function dataTransformation(filteredSlicedFics, lastName, userContext, carContext, isActisProfil) {
            var listFicFiltered = applyActisUserRightFilter(filteredSlicedFics, lastName, isActisProfil);

            //Retrieve symptomsCode contains in the data we got form NAT Cases API (getListFic)
            var symptomCodes = getSymptomCodes(listFicFiltered);

            //Creation of the payload needed for /symptom API
            var symptomsPayload = {
                userContext: userContext,
                symptomsShortIds: symptomCodes
            };

            //In case there is no symptoms code we just return listFicFiltered
            if (symptomCodes && symptomCodes.length > 0) {

                return FicViewListWSService.getSymptomList(symptomsPayload).then(function (response) {

                    if (response.symptoms && response.symptoms.length != 0) {

                        // Create a dictionnary of the symptoms with their corresponding labels
                        var mapSymptoms = response.symptoms.reduce(function (map, obj) {
                            map[obj.shortCode.toString()] = obj.label;
                            return map;
                        }, {});

                        //for every entry we got from the API we concatenate the symptomCode with its corresponding label
                        if (mapSymptoms) {
                            for (var i = 0; i < listFicFiltered.length; i++) {
                                var listFicSymptom = listFicFiltered[i].Request.symptomCode;
                                if (listFicSymptom && mapSymptoms[listFicSymptom]) {
                                    listFicFiltered[i].Request.symptomCode = listFicSymptom + " - " + mapSymptoms[listFicSymptom];
                                }
                            }
                        }
                    }
                    return {
                        data: listFicFiltered
                    }

                });
            } else {
                var deferred = $q.defer();
                deferred.resolve({
                    data: listFicFiltered
                });
                return deferred.promise;
            }
        }
    })
})();

/**
 * @namespace CreateActisWSService
 * @desc send Actis informations and files to update/upload/download to the back service
 */

(function () {

    angular
        .module('phenix')
        .service('CreateActisWSService', CreateActisWSService)

    /** @ngInject */
    function CreateActisWSService(ActisConstantes, CacheService, CacheConstants, $http, $q, $httpParamSerializerJQLike, $translate,RestUpgrade) {

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.uploadFileToApi = uploadFileToApi;
        vm.createFic = createFic;
        vm.updateFic = updateFic;
        vm.getFicByIdNumber = getFicByIdNumber;
        vm.getAssistancetokens=getAssistancetokens;


        /**
         * @name uploadFileToApi
         * @desc sends file to R-DOC server. This function calls the API throughout a POST request. In the response, we'll get a temporary link that we'll
         * include in the next API call via sendTemporaryUrlToApi function.
         * @param {object} body
         * @returns {Promise}
         */

        function uploadFileToApi(body) {
                //TODO US R-DOC
        }

        /**
         * @name getFicByIdNumber
         * @desc Get FIC by CaseId and CaseNumber
         * @param {object} body
         * @returns {Promise}
         */
        function getFicByIdNumber(caseParameters) {
            var baseUrl = ActisConstantes.endpoint.natCase;
            var suffixCases = ActisConstantes.endpoint.suffixCases;
            var userProfile = CacheService.getObject(CacheConstants.profil);

            var dealerId = userProfile.dealerId;
            var caseNumber= caseParameters.caseNumber;
            var caseId  = caseParameters.caseId;
            var parameterEncoded = { caseId : caseId};

            return RestUpgrade.one(baseUrl, dealerId).one(suffixCases, caseNumber).get(parameterEncoded);
        }

        /**
         *  @name saveFic
         *  @desc saves current FIC. Calls NAT Cases API.
         *  If FIC is already created, the API call is a PUT which will update the FIC. If FIC isn't created, then the API call will be a POST request,
         *  and FIC status will be set as Draft.
         *  @param {object} body
         *  @return {promise}
         */

        function createFic(body) {
            var url = ActisConstantes.endpoint.natCase;
            var suffixCases = ActisConstantes.endpoint.suffixCases;

            return RestUpgrade.one(url, body.dealer.dealerId).all(suffixCases).post(body);
        }


        function getAssistancetokens(userId)
        {
         
 
         var url =  ActisConstantes.endpoint.assistanceTokens + userId + ActisConstantes.endpoint.assistanceTokensSuffix;
         return RestUpgrade.one(url).post();        
            }


        /**
         * @name sendFic
         * @desc sends current FIC. Calls NAT Cases API and set FIC status to New.
         * @param {object} mandatoryParameters
         * @param {object} dealerId
         * @returns {Promise}
         */
        function updateFic(mandatoryParameters, dataChanged, fic,btValue) {
          if (fic && fic.Request && fic.Request.tintname !== undefined) {
            dataChanged.tintName = fic.Request.tintname;
          }
          var url = ActisConstantes.endpoint.natCase;
            var suffixCases = ActisConstantes.endpoint.suffixCases;
            var userProfile = CacheService.getObject(CacheConstants.profil);

            var parameterEncoded = {
                caseId: mandatoryParameters.caseId,
                contactFirstName: mandatoryParameters.firstName,
                contactLastName: mandatoryParameters.lastName,
                status : mandatoryParameters.status
            };

            dataChanged.cirDemand1 = (fic && fic.Request && fic.Request.cirDemand1) ? fic.Request.cirDemand1 : "" ;
            dataChanged.cirDemand2 = (fic && fic.Request && fic.Request.cirDemand1) ? fic.Request.cirDemand2 : "";
            dataChanged.customerComplaint = (fic && fic.Request && fic.Request.customerComplaint) ? fic.Request.customerComplaint : "";
            /*Modify the format of the changed data being PUT to the NAT CASE API
            from 'x-www-form-urlencoded' to 'json'
            */
            var body = {
                "caseDetails": {
                  "comments": "",
                  "recordType": ""
                },
                "car": {
                  "isVehicleAccessories": false,
                  "bin": "",
                  "vin": "",
                  "brand": "",
                  "isVehicleImmobilised": false,
                  "isVehicleTransformed": false,
                  "mileageUnit": "",
                  "mileageValue": 0,
                  "model": "",
                  "registrationNumber": "",
                  "year": 0
                },
                "dealer": {
                  "phoneNumber": 0
                },
                "request": {
                  "colorCode": "",
                  "customerComplaint": "",
                  "isCustomerComplaintReproduced": false,
                  "diagnosticComment": "",
                  "isDocumentationConsulted": "",
                  "dtcCode1": "",
                  "dtcCode2": "",
                  "dtcCode3": "",
                  "goodSolution": "",
                  "cirDemand1": "",
                  "cirDemand2": "",
                  "grade": "",
                  "nonSatisfactionReason": "",
                  "orDate": "",
                  "orNumber": "",
                  "problemFrequency": "",
                  "problemFrequencyType": "",
                  "problemCharacteristics": "",
                  "productName": "",
                  "reference": "",
                  "satisfactionComment": "",
                  "symptomCode": "",
                  "tintName": "",
                  "tintNameCounterTyped": ""
                }
              };

          var newBody = {}

          if (fic) {
            newBody = {
              "caseDetails": {
                "recordType": fic.CaseDetail.recordType
              },
              "car": {
                "isVehicleAccessories": fic.Car&&fic.Car.isVehicleAccessories?fic.Car.isVehicleAccessories:"",
                "bin": fic.Car&&fic.Car.bin?fic.Car.bin:"",
                "vin": fic.Car&&fic.Car.vin?fic.Car.vin:"",
                "isVehicleImmobilised": fic.Car&&fic.Car.isVehicleImmobilised?fic.Car.isVehicleImmobilised:"",
                "mileageUnit": fic.Car&&fic.Car.mileageUnit?fic.Car.mileageUnit.toUpperCase():"",
                "mileageValue": fic.Car&&fic.Car.mileageValue?fic.Car.mileageValue:"",
                "model": fic.Car&&fic.Car.model?fic.Car.model:"",
                "registrationNumber": fic.Car&&fic.Car.registrationNumber?fic.Car.registrationNumber:"",
                "isVehicleTransformed": fic.Car&&fic.Car.isVehicleTransformed?fic.Car.isVehicleTransformed:""
              },
              "dealer": {
                "contactId":(userProfile && userProfile.hasOwnProperty('contactId') && userProfile.contactId !== null && userProfile.contactId !== undefined && userProfile.contactId !== '')
                                ? userProfile.contactId
                                : ((userProfile && userProfile.emailAlerte) ? userProfile.emailAlerte : '')
                        },
              "request": {
                "customerComplaint": fic.Request&&fic.Request.customerComplaint?fic.Request.customerComplaint:"",
                "isCustomerComplaintReproduced": fic.Request&&fic.Request.isCustomerComplaintReproduced?fic.Request.isCustomerComplaintReproduced:"",
                "diagnosticComment": fic.Request&&fic.Request.diagnosticComment?fic.Request.diagnosticComment:"",
                "isDocumentationConsulted": fic.Request&&fic.Request.isDocumentationConsulted?fic.Request.isDocumentationConsulted:"",
                "dtcCode1": fic.Request&&fic.Request.dtcCode1?fic.Request.dtcCode1:"",
                "dtcCode2": fic.Request&&fic.Request.dtcCode2?fic.Request.dtcCode2:"",
                "dtcCode3": fic.Request&&fic.Request.dtcCode3?fic.Request.dtcCode3:"",
                "orDate": fic.Request&&fic.Request.orDate?fic.Request.orDate:"",
                "orNumber": fic.Request&&fic.Request.orNumber?fic.Request.orNumber:"",
                "problemFrequency": fic.Request&&fic.Request.problemFrequency?fic.Request.problemFrequency:"",
                "problemFrequencyType": fic.Request&&fic.Request.problemFrequencyType?fic.Request.problemFrequencyType:"",
                "problemCharacteristics": fic.Request&&fic.Request.problemCharacteristics?fic.Request.problemCharacteristics:"",
                "symptomCode": fic.Request&&fic.Request.symptomCode?fic.Request.symptomCode:"",
                "cirDemand1": fic.Request && fic.Request.cirDemand1 ? fic.Request.cirDemand1: "",
                "cirDemand2": fic.Request && $translate.instant(fic.Request.cirDemand2) ? $translate.instant(fic.Request.cirDemand2): "",
                "tintName": fic.Request&&fic.Request.tintName?fic.Request.tintName:""
                
              }
            };
          } else {
            newBody = {
              "caseDetails": {

              },
              "car": {
              },
              "dealer": {

              },
              "request": {
              }
            };
          }

              for (var item in dataChanged) {
                  for (var key in body) {
                    if(angular.isDefined(body[key][item])){
                        newBody[key][item] = dataChanged[item];
                    }
                  }
              }

            return RestUpgrade.one(url, mandatoryParameters.dealerId).one(suffixCases, mandatoryParameters.caseNumber)
                .customPUT(
                    newBody,
                    undefined, //path
                    parameterEncoded,
                    {'Content-Type': "application/json"}
                );
        }

    }
})();

(function () {

    angular
        .module('phenix')
        .service('CreateActisBusinessService', CreateActisBusinessService);

    /** @ngInject */
    function CreateActisBusinessService(CreateActisWSService, ActisConstantes, $http, $translate,
        FileSaver,RestUpgrade) {


        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var vm = this;

        vm.uploadFileToApi = uploadFileToApi;
        vm.createFic = createFic;
        vm.updateFic = updateFic;
        vm.deepDiffApiResultVsDataActisView = deepDiffApiResultVsDataActisView;
        vm.findRelatedRecordTypeToFicType = findRelatedRecordTypeToFicType;
        vm.getFicByIdNumber = getFicByIdNumber;
        vm.findTypeFicById = findTypeFicById;
        vm.downloadPdf = downloadPdf;
        vm.close = close;
        vm.displayAttachments = displayAttachments;
        vm.getDataChangedVerification = getDataChangedVerification;
        vm.getDocInfoByRdocId = getDocInfoByRdocId;
        vm.getAssistancetokens=getAssistancetokens;
        vm.setOtsColorData = setOtsColorData;
        vm.getOtsColorData = getOtsColorData;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        /**
         * @name uploadFileToApi
         * @desc sends file to R-DOC server. This function calls the API throughout a POST request. In the response, we'll get a temporary link that we'll
         * include in the next API call via sendTemporaryUrlToApi function.
         * @param {object} body
         * @returns {Promise}
         */
        function uploadFileToApi(body) {
                //TODO RDOC US
        }

        /**
         * @name getFicByIdNumber
         * @desc Get FIC by CaseId and CaseNumber
         * @param {object} caseParameters contains parameter needed
         * @returns {Promise}
         */
        function getFicByIdNumber(caseParameters) {
            return CreateActisWSService.getFicByIdNumber(caseParameters);
        }

        /**
         * @description Used to download a file on click of its' name and display its' data
         * @param {*} url 
         */
        function downloadPdf(url) {
            RestUpgrade.one(url).get().then(function (response) {
                if (response.temporaryUrl) {
                    var downloadUrl = response.temporaryUrl;
                    $http({
                        method: 'GET',
                        url: downloadUrl,
                        responseType: 'blob'
                    }).then(function (data) {
                        var contentType = data.headers("content-type");
                        var file = new Blob([(data.data)], {type: contentType});
                        FileSaver.saveAs(file, response.fileName);
                    });
                }
            });
        }


        /**
         * @description Used to get info on specific doc by Id
         * @param {*} rDocId
         * @return api response
         */
        function getDocInfoByRdocId(rDocId) {
            var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
            return RestUpgrade.one(url).get();
        }

        /**
         * @description Used to call the Delete API and remove a file on click of 'Delete' button
         * @param {*} url 
         */
        function close(url) {
            return RestUpgrade.one(url).remove();
        }

        /**
         * @description Used to call the Search API and get the uploaded files
         * @param {*} url 
         */
        function displayAttachments(url) {
            return RestUpgrade.one(url).get();
        }

        /**
         *  @name createFic
         *  @desc create current FIC. Calls NAT Cases API.
         *  If FIC is already created, the API call is a PUT which will update the FIC.
         *  If FIC isn't created, then the API call will be a POST request,
         *  and FIC status will be set as Draft.
         *  @param {object} body
         *  @return {promise}
         */
        function createFic(fic) {

            var body = {
                "caseDetails": {
                    "recordType": fic.CaseDetail.recordType,
                    "status": fic.CaseDetail.status
                },
                "car": {
                    "vin": fic.Car ? fic.Car.vin : "",
                    "isVehicleAccessories": fic.Car ? fic.Car.isVehicleAccessories : "",//TODO will fix in V2 now we keep yes/no!!
                    "bin": fic.Car ? fic.Car.bin : "",
                    "brand": "", //TODO NATCASE V2
                    "isVehicleImmobilised": fic.Car ? fic.Car.isVehicleImmobilised : "",
                    "mileageUnit": fic.Car ? fic.Car.mileageUnit.toUpperCase() : "",
                    "mileageValue": fic.Car ? fic.Car.mileageValue : "",
                    "model": fic.Car ? fic.Car.model : "",
                    "registrationNumber": fic.Car ? fic.Car.registrationNumber : "",
                    "isVehicleTransformed": fic.Car ? fic.Car.isVehicleTransformed : "",
                    "year": ""//no data in the view yet //TODO NATCASE V2
                },
                "dealer": {
                    "contactFirstName":fic.Dealer.contactFirstName, // "Reno",//  for dealder 123456
                    "contactLastName": fic.Dealer.contactLastName,// "Nissan Misthu",//for dealer 123456
                    "phoneNumber": fic.Dealer.phoneNumber,
                    "dealerId": fic.Dealer.dealerId,
                    "contactId":fic.Dealer.contactId
                },
                "request": {
                    "colorCode": "", //TODO NATCASE V2
                    "customerComplaint": fic.Request ? fic.Request.customerComplaint : "",
                    "isCustomerComplaintReproduced": fic.Request ? fic.Request.isCustomerComplaintReproduced : "",
                    "diagnosticComment": fic.Request ? fic.Request.diagnosticComment : "",
                    "isDocumentationConsulted": fic.Request ? fic.Request.isDocumentationConsulted : "",
                    "dtcCodes": "", //TODO NATCASE V2
                    "dtcCode1": fic.Request ? fic.Request.dtcCode1 : "",
                    "dtcCode2": fic.Request ? fic.Request.dtcCode2 : "",
                    "dtcCode3": fic.Request ? fic.Request.dtcCode3 : "",
                    "orDate": fic.Request ? fic.Request.orDate : "",
                    "orNumber": fic.Request ? fic.Request.orNumber : "",
                    "problemFrequency": fic.Request ? fic.Request.problemFrequency : "",
                    "problemFrequencyType": fic.Request ? fic.Request.problemFrequencyType : "",
                    "problemCharacteristics": fic.Request ? fic.Request.problemCharacteristics : "",
                    "productName": "", //TODO NATCASE V2
                    "reference": fic.Request ? fic.Request.reference : "no", //TODO NATCASE V2
                    "symptomCode": fic.Request ? fic.Request.symptomCode : "",
                    "tintName": fic.Request.tintname ? fic.Request.tintname : "", // FIX: Map from tintname (lowercase), //TODO NATCASE V2
                    "tintNameCounterTyped": "" ,//TODO NATCASE V2
                    "cirDemand1": fic.Request ? fic.Request.cirDemand1 : "",
                     "cirDemand2": fic.Request ? fic.Request.cirDemand2 : ""
                   

                }
            };

            return CreateActisWSService.createFic(body);
        }


        /**
         * @name updateFic
         * @desc updateFic current FIC. Calls NAT Cases API and set FIC status to New.
         * @param {object} body
         * @param {object} dealerId
         * @returns {Promise}
         */
        function updateFic(userProfile, dealerId, responseApi, fic,btValue) {

            var dataChanged = deepDiffApiResultVsDataActisView(responseApi, fic);

            delete dataChanged.status;
            delete dataChanged.contactLastName;
            delete dataChanged.contactFirstName;

            var mandatoryParameters = {
                "dealerId": dealerId,//123456,
                "firstName": userProfile.firstName,//"Reno",//
                "lastName": userProfile.lastName,//"Nissan Misthu",//
                "caseId": responseApi.CaseDetail.caseId,
                "caseNumber": responseApi.CaseDetail.caseNumber,
                "status": fic.CaseDetail.status
            };

            return CreateActisWSService.updateFic(mandatoryParameters, dataChanged, fic, btValue);
        }

        /**
         * deep diff between two objects : oldData data that either come from POST or PUT Nat CASe and the current data
         * that is in the view (mainly the user modified data)
         * will return dataChanged that will contains the changed item
         * @param oldData
         * @param newData
         * return dataChanged
         */
        function deepDiffApiResultVsDataActisView(oldData, newData) {
            var dataChanged = {};

            for (var property in oldData) {

                if (newData && newData[property] && oldData[property]) {
                    var myModelKeys = Object.keys(oldData[property]);
                    var oldDataKeys = Object.keys(newData[property]);

                    _.intersection(myModelKeys, oldDataKeys).forEach(function (innerProp) {

                        if (oldData[property][innerProp] !== newData[property][innerProp]) {
                            dataChanged[innerProp] = newData[property][innerProp];
                        }

                    });
                }
            }
            return dataChanged;
        }

        /**
         * @description Used to Remove the unwanted fields from the changed data (between response and fic data)
         *              and remove the 'model', 'registrationNumber' and 'vin' fields
         * @param {*} dataChanged 
         */
        function getDataChangedVerification(dataChanged) {
            if (dataChanged) {
                angular.forEach(dataChanged, function (value, key) {
                    if (value === "" || angular.isUndefined(value) || key === 'model' || key === 'registrationNumber' || key === 'brand' || key === 'vin') {
                        delete dataChanged[key];
                    }
                })
            }
            return dataChanged;
        }

        /**
         * Find and set the type of fic by ficId
         * @param typeFicId
         */
        function findTypeFicById(typeFicId) {
            switch (typeFicId) {
                case ActisConstantes.type_technical_assistance:
                    vm.isTechnicalAssistance = true;
                    break;
                case ActisConstantes.type_accessoires:
                    vm.isAccessoires = true;
                    break;
                case ActisConstantes.type_painting:
                    vm.isPainting = true;
                    break;
                case ActisConstantes.type_approval:
                    vm.isApproval = true;
                    break;
                case ActisConstantes.type_ze_battery:
                    vm.isZeBattery = true;
                    break;
                case ActisConstantes.type_good_practise:
                    vm.isGoodPractise = true;
                    break;
                case ActisConstantes.type_alert:
                    vm.isAlert = true;
                    break;
                case ActisConstantes.type_calm:
                    vm.isCalm = true;
                    break;
                case ActisConstantes.type_administrative:
                    vm.isAdministrative = true;
                    break;
            }
        }


        /**
         * Give the currentype of fic
         * @returns {*}
         */
        function giveCurrentType() {
            var returnCurrentType;
            switch (true) {
                case vm.isTechnicalAssistance:
                    returnCurrentType = ActisConstantes.type_technical_assistance;
                    break;
                case vm.isAccessoires:
                    returnCurrentType = ActisConstantes.type_accessoires;
                    break;
                case vm.isPainting:
                    returnCurrentType = ActisConstantes.type_painting;
                    break;
                case vm.isApproval:
                    returnCurrentType = ActisConstantes.type_approval;
                    break;
                case vm.isZeBattery:
                    returnCurrentType = ActisConstantes.type_ze_battery;
                    break;
                case vm.isGoodPractise:
                    returnCurrentType = ActisConstantes.type_good_practise;
                    break;
                case vm.isAlert:
                    returnCurrentType = ActisConstantes.type_alert;
                    break;
                case vm.isCalm:
                    returnCurrentType = ActisConstantes.type_calm;
                    break;
                case vm.isAdministrative:
                    returnCurrentType = ActisConstantes.type_administrative;
                    break;
            }
            return returnCurrentType;
        }
   
        function getAssistancetokens(userId) {

           

            return CreateActisWSService.getAssistancetokens(userId);

           
        }

        /**
         * find Related RecordType adn return the FicType
         * @param recordType
         * @returns {{id: number, name: *}}
         */
        function findRelatedRecordTypeToFicType(recordType) {
            switch (recordType) {

                case ActisConstantes.accessories_CIRS:
                    return {
                        id: ActisConstantes.type_accessoires,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_accessoires])
                    };
                case ActisConstantes.agreement_CIRS:
                    return {
                        id: ActisConstantes.type_approval,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_approval])
                    };
                case ActisConstantes.goodPractise_CIRS:
                    return {
                        id: ActisConstantes.type_good_practise,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_good_practise])
                    };
                case ActisConstantes.painting_CIRS:
                    return {
                        id: ActisConstantes.type_painting,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_painting])
                    };
                case ActisConstantes.ze_battery_CIRS:
                    return {
                        id: ActisConstantes.type_ze_battery,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_ze_battery])
                    };
                case ActisConstantes.technical_CIRS:
                    return {
                        id: ActisConstantes.type_technical_assistance,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_technical_assistance])
                    };
                case ActisConstantes.alert_CIRS:
                    return {
                        id: ActisConstantes.type_alert,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_alert])
                    };
                case ActisConstantes.BRW_CIRS:
                    return {
                        id: ActisConstantes.type_brw,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_brw])
                    };
                case ActisConstantes.QSTOMIZE_CIRS:
                    return {
                        id: ActisConstantes.type_qstomize, 
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_qstomize])
                    };
                case ActisConstantes.ACTIS_PILOTE:
                    return {
                        id: ActisConstantes.type_pilote, 
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_pilote])
                    };
                case ActisConstantes.CALM_CIRS:
                    return {
                        id: ActisConstantes.type_calm,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_calm])
                    };
                case ActisConstantes.ADMINISTRATIVE_CIRS:
                    return {
                        id: ActisConstantes.type_administrative,
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_administrative])
                    };
            }
        }

        function setOtsColorData(data) {
            vm.otsColorData = data;
        }

        function getOtsColorData() {
            return vm.otsColorData;
        }
    }
})();

    angular.module('phenix').controller('modalYesNoConfirmController', function ($mdDialog,$rootScope) {
        var vm = this;

        vm.translationData = {
            orderNumber: "vm.or"

        };

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;

        function onConfirm() {
            $rootScope.$broadcast('confirmPendingClicked',true);
            $mdDialog.hide();
        }

        function onCancel() {
            $rootScope.$broadcast('confirmPendingClicked',false);
            $mdDialog.cancel();
        }

    });

(function () {
    angular.module('phenix').controller('modalOnDeleteCartsController', modalOnDeleteCartsController);

    function modalOnDeleteCartsController($mdDialog) {
        var vm = this;

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;

        function onConfirm() {
            $mdDialog.hide();
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    }

})();

/**
 * Created by A652379 on 04/01/2017.
 */
(function () {

  angular
    .module('phenix')
    .controller('DeleteAlertsCtrl', DeleteAlertsCtrl);

  /** @ngInject */
  function DeleteAlertsCtrl($modalInstance , modalOpts){
    var vm = this;

    function init() {
      vm.title = modalOpts.title;
      vm.delete = deleteElement;
      vm.cancel = cancelGeneric;
    }





    /**
     * Delete current element
     */
    function deleteElement() {
      if(modalOpts.okAction) {
        modalOpts.okAction();
      }
      $modalInstance.close('ok');
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }


    init();

  }
})();


(function () {

    angular
        .module('phenix')
        .controller('captureScreenshotController', captureScreenshotController);

    /**
     * @desc take screenshot of Tm Documents
     */
    /** @ngInject */
    function captureScreenshotController($mdDialog,AlertsService, $rootScope,CacheService,CacheConstants) {
        var vm = this;
        vm.cancel = cancel;
        vm.reCapture = reCapture;
        vm.addToAlert = addToAlert;
        function cancel() {
            $mdDialog.hide();
            AlertsService.setScreenshotButtonVisibility(false);
            AlertsService.setHidePopin(true);
            if(CacheService.getObject(CacheConstants.isOrderMode)){
                $rootScope.$broadcast('addAlert', null);
            }
        }

        function reCapture() {
            $mdDialog.hide('New Capture');
        }

        function addToAlert() {
            AlertsService.setHidePopin(true);
            AlertsService.setScreenshotButtonVisibility(false);
            $mdDialog.hide('add to alert');
            $rootScope.$broadcast('addAlert', vm.capturedImage);

        }

    }

})();
(function () {

  angular
    .module('phenix')
    .controller('ContextCarAlert', ContextCarAlert);

  /** @ngInject */
  function ContextCarAlert($mdDialog,AlertsService) {
    var vm = this;
    vm.finishAlerts = finishAlerts;
    vm.cancelGeneric = cancelGeneric;
    vm.checkDocType = AlertsService.getDocumentType(); 
    /** 
     * Delete current element
     */
    function finishAlerts() {
      $mdDialog.cancel();
      //redirect to current alert popup
      AlertsService.setHidePopin(true);
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $mdDialog.hide();
    }

  }
})();


(function () {

  angular
    .module('phenix')
    .controller('alertsRejectCtrl', alertsRejectCtrl);

  /** @ngInject */
  function alertsRejectCtrl($state, $mdDialog, $translate, RoutesConstants) {
    var vm = this;
    vm.cancel = cancel;
    vm.alertsListLocation = alertsListLocation;
    vm.dataError = vm.data || {};
    vm.code = vm.dataError.status;
    const errorData = vm.dataError && vm.dataError.data && vm.dataError.data.errors && vm.dataError.data.errors[0];
    vm.errorMessage = (errorData && errorData.errorMessage) ? errorData.errorMessage : $translate.instant('ALERTS_ERROR_HTL');
    function cancel() {
      $mdDialog.hide('cancel');
    }

    function alertsListLocation() {
      cancel();
      $state.go(RoutesConstants.listAlerts);
    }


  }
})();

(function () {

  angular
    .module('phenix')
    .controller('alertsConfirmCtrl', alertsConfirmCtrl);

  /** @ngInject */
  function alertsConfirmCtrl($state, RoutesConstants, $scope, $mdDialog, 
    configConstantes,UtilsMetierService,DiagFileDetailsNewConstants,$rootScope) {
    var vm = this;
    vm.cancel = cancel;
    vm.alertsListLocation = alertsListLocation;
    vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
    vm.isTraceEnabledINT = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
    if(vm.response)
      vm.response.documentType = vm.response.documentType ? vm.response.documentType : vm.docType;
    if(vm.response && !_.isEmpty(vm.response) && vm.response.documentType && (!vm.isTraceEnabled && (vm.response.documentType === 'MR' || vm.response.documentType === 'TM'))){
      vm.checkDocType = vm.response.documentType;
      vm.emailAddress = vm.response.userEmail != null ? vm.response.userEmail : "";
      vm.requestId = vm.response.requestId != null ? vm.response.requestId : "";
    
    }
    else if(vm.response && !_.isEmpty(vm.response) && vm.response.documentType && ((vm.isTraceEnabled && (vm.response.documentType === 'MR' || vm.response.documentType === 'TM')) || (vm.isTraceEnabledINT && vm.response.documentType === 'INT'))){
      vm.checkDocType = vm.response.documentType;
      $scope.translationData = {
        idAlerts: vm.response ? vm.response.request.number :''
      };
    }
    else{
      vm.checkDocType = vm.response ? vm.response.documentType : vm.docType;
      $scope.translationData = {
        idAlerts: (vm.response &&  vm.response.request) ? vm.response.request.number :''
      };
    }

    function cancel() {
      $mdDialog.hide('cancel');

      if(vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions){
        $rootScope.$broadcast('savePrediagVote');
      }
      // chage tm report link color
      $("#TM_DOCUMENTARY_ERROR").css({
        'color': 'black'
      });
    }

    function alertsListLocation() {
      cancel();
      $state.go(RoutesConstants.listAlerts);
    }


  }
})();

(function () {
    'use strict';

    angular.module('phenix.core').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, ErrorConstants) {
        $stateProvider.state(ErrorConstants.noDocumentFound, {
            url: '/documentNotFound',
            templateUrl: 'app/core/error/errorDocumentNotFound/errorDocumentNotFound.template.html',
            controller: 'DocumentNotFoundCtrl',
            controllerAs: 'vm'
        });
    }

})();

/**
 * DocumentNotFound Controller
 * @namespace Controllers
 */
(function() {
    "use strict";

    angular
        .module("phenix")
        .controller("DocumentNotFoundCtrl", DocumentNotFoundCtrl);

    /**
     * @namespace DocumentNotFoundCtrl
     * @desc Display error when document not found
     * @memberOf Controllers
     */

    /* @ngInject */
    function DocumentNotFoundCtrl(
        CacheService,
        LoginMetierService,
        CloudFrontService
    ) {
        init();

        /*=============================================
        =                 FUNCTIONS                    =
        =============================================*/

        function init() {
            LoginMetierService.logOut();
            CloudFrontService.removeAccessCookies();
            CacheService.clearAll();
        }
    }
})();

(function () {
  'use strict';

  angular.module('phenix.core').service('ConfigMetierService', ConfigMetierService);

  function ConfigMetierService() {
    this.getSettings = getSettings;

    function getSettings() {
      //var config = CacheService.getObject(CacheConstants.configuration);
      return {
            access: { searchByRegistrationNumber: true, ots: true },
            maximumVehiclesPerPage: 10
        };
    }

  }

})();

(function() {
    angular
        .module("phenix.core")
        .controller("superCartDraftListModalController", function(
            $mdDialog,
            toastr,
            $translate,
            $rootScope,
            $scope,
            DealerManagerSystemeService,
            PartRequisitionMetierService,
            QuoteMetierService,
            CacheService,

            CacheConstants,
            QuoteConstants,
            globalConstant,
            SuperCartDraftListModalConstants
        ) {
            /*=============================================
            =                 VARIABLES                   =
            =============================================*/

            var vm = this;
            vm.loading = true;
            vm.partRequisitionList = [];
            vm.quoteList = [];
            vm.count = 0;
            vm.userProfile = CacheService.getObject(CacheConstants.profil);
            vm.isDmsProfile = CacheService.getObject('dms');
            if(vm.userProfile){
                vm.isWorkshop = DealerManagerSystemeService.isWorkshop(vm.userProfile);
                vm.isPartshop = DealerManagerSystemeService.isPartshop(vm.userProfile);
            }
            $rootScope.$broadcast("isEasyBasket",vm.isEasyBasket);
            vm.networkProfile = vm.userProfile.dmsConfig ? vm.userProfile.dmsConfig.networkProfile : null;
            vm.currentPartRequisition = PartRequisitionMetierService.getCurrentPartRequisition();
            vm.actions = SuperCartDraftListModalConstants.actions;

            var contextCar = CacheService.getCarContext();
            var _options = {
                filter: {
                    type: vm.networkProfile,
                    status: QuoteConstants.draftStatus
                },
                sort: {
                    by: "DATE",
                    order: QuoteConstants.sort.desc
                },
                pagination: {
                    limit: QuoteConstants.pagination.limit,
                    offset: 1
                }
            };


            vm.selectSuperCart = selectSuperCart;
            vm.updatePagination = updatePagination;
            vm.close = close;
            vm.onCancel = onCancel;
            vm.onSort = onSort;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            /**
             *  @desc Fetch superCartList, and bind to HTML
             */
            this.$onInit = function() {
                fetchAndSavesuperCartList();
            };

            /**
             *  @desc Update superCartList depending of the page
             *  @param {int} page
             */
            function updatePagination(page) {
                fetchAndSavesuperCartList(page);
            }


            function onSort(by, order) {
                _options.sort = {
                    by: by,
                    order: order
                };
                _options.pagination = {
                    limit: _options.pagination.limit,
                    offset: 1
                };

                fetchAndSavesuperCartList();
            }


            /**
             *  @desc Fetch superCartList
             *  @param {number} page
             *  @return {promise}
             */
            function fetchAndSavesuperCartList(page) {
                var selectedPage = page || 0;
                switch (vm.typeOfSuperCart) {
                    case globalConstant.partRequisition:
                        getPartRequisitionDraftList(selectedPage)
                            .then(function(response) {
                                vm.list = response.partsRequisitions;
                                vm.count = response.totalCount;
                            }).finally(function() {
                                vm.loading = false;
                            });
                        break;
                    case globalConstant.quote:
                        getQuoteDraftList(selectedPage)
                            .then(function(response) {
                                vm.list = response.quotes;
                                vm.count = response.totalCount;
                            }).finally(function() {
                                vm.loading = false;
                            });
                        break;
                }
            }

            /*=============================================
            =                 TOOLS                       =
            =============================================*/

            /**
             * @name getPartRequisitionDraftList
             * @desc get part requsition draft list by passing filter, sort and pagination
             * @param {Integer} page
             * @returns {Promise}
             */
            function getPartRequisitionDraftList(page) {
                var requestListSuperCart = getRequestListSuperCart(page);

                return PartRequisitionMetierService.partRequisitionListLogic(
                    requestListSuperCart.filter,
                    requestListSuperCart.sort,
                    requestListSuperCart.pagination
                ).then(function(response) {
                    return response;
                }).catch(function() {
                    toastr.error($translate.instant("ERROR"));
                });
            }

            /**
             * @name getQuoteDraftList
             * @desc get quote draft list by passing filter, sort and pagination
             * @param {Integer} page
             * @returns {Promise}
             */
            function getQuoteDraftList(page) {
                var requestListSuperCart = getRequestListSuperCart(page);

                return QuoteMetierService.quoteServiceListLogic(
                    requestListSuperCart.filter,
                    requestListSuperCart.sort,
                    requestListSuperCart.pagination)
                    .then(function(response) {
                        return response;
                    }).catch(function() {
                        toastr.error($translate.instant("ERROR"));
                    });
            }

            /**
             * @name getRequestListSuperCart
             * @desc get quote request to send (filter, sort, pagination)
             * @param {Integer} page
             * @returns {Object}
             */
            function getRequestListSuperCart(page){
                var requestListSuperCart = {};

                requestListSuperCart.filter = _options.filter;
                requestListSuperCart.sort = _options.sort;
                requestListSuperCart.pagination = {
                    limit: _options.pagination.limit,
                    offset: page || _options.pagination.offset  
                };


                if (page) {
                    requestListSuperCart.pagination.offset = page;
                }
                if(contextCar){
                    requestListSuperCart.filter.vin = contextCar.vin
                }
                return requestListSuperCart;
            }

            /**
             *  @desc  This function is call when the user have selected a superCart.
             *          Send the ID, and close the modal
             *  @param {Object} superCart
             */
            function selectSuperCart(superCart, action) {
                if(vm.isDmsProfile){
                var payload = {
                    item: superCart,
                    action: action
                }
                $mdDialog.hide(payload);
                } else {  
                $mdDialog.hide();
            }
        }

            /**
             *  @desc  Close modal
             */
            function close() { 
                if(vm.isEasyBasket)  {
                    vm.isEasyBasket = false;
                    $rootScope.$broadcast("isEasyBasket",vm.isEasyBasket);
                } 
                $rootScope.$broadcast("on-close-draft-list");           
                $mdDialog.cancel();
            }
            function onCancel(){
                vm.isEasyBasket = false;
                $rootScope.$broadcast("isEasyBasket",vm.isEasyBasket);
                $mdDialog.cancel();
            }
            $scope.$on('$destroy', function() {                
                $rootScope.$broadcast("on-close-draft-list");
            });
        });
})();

'use strict';

angular.module('phenix.core').constant('SuperCartDraftListModalConstants',{
    actions:{
        addToSelectedSuperCart: 'AddToSelectedSuperCart',
        addToActifPartRequisition: 'AddToActifPartRequisition',
        createNewSuperCart: 'CreateNewSuperCart'
    }
});

(function(){
    'use strict';

    angular
        .module('phenix.core')
        .service('SuperCartValidateService', SuperCartValidateService);

    /** @ngInject */
    function SuperCartValidateService(

    ){
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.validateCodesQuote = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18 ];
        vm.validateCodesPartsRequisition = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18 ];

        vm.isQuoteValidate = isQuoteValidate;
        vm.isPartsRequisitionValidate = isPartsRequisitionValidate;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name isQuoteValidate
         * @desc check if dms response's return code is in validated codes
         * @desc returns -1 if is not in validated codes, > 0 else
         * @param {Integer} quoteResponseCode
         */
        function isQuoteValidate(quoteResponseCode){
            return vm.validateCodesQuote.indexOf(quoteResponseCode);
        }

        /**
         * @name isPartsRequisitionValidate
         * @param {*} partsRequisitionResponseCode
         * @desc check if dms response's return code is in validated codes
         * @desc returns -1 if is not in validated codes, > 0 else
         */
        function isPartsRequisitionValidate(partsRequisitionResponseCode){
            return vm.validateCodesPartsRequisition.indexOf(partsRequisitionResponseCode);
        }

    }
})();

'use strict';
angular.module('phenix.core').constant('SuperCartValidateConstants', {
    typeError: {
        partsRequisitionNotValidate: "partsRequisitionNotValidate",
        quoteNotValidate: "quoteNotValidate"
    }
});

(function() {

    angular.module('phenix.core').component('superCartPopin', {
        bindings: {
            items: '<',
            icon: '@',
            popinTitle: '<',
            popinSubtitle: '<',
            type: '@'
        },
        templateUrl: 'app/core/components/superCartPopin/superCartPopin.template.html',
        controller: superCartPopinController
    })

    function superCartPopinController() {
        var vm = this;
        vm.internalItems = [];
        vm.flattenCart = [];
        vm.cartMetadata = {};
        vm.pr = [];
        vm.tm = [];

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function() {
            bindItems(this.items);
        }

        function bindItems(items) {
            if (!_.isEmpty(items)) {
                if(vm.type == "quote"){
                    vm.pr = items.PR;
                    vm.tm = items.TM;
                }
                else{
                    vm.pr = items;
                }
            }
        }

        this.$onChanges = function (changes){
            var PR = [];
            var TM = [];
            if(vm.type == "quote"){
                PR = _.get(changes, ['items', 'currentValue', 'PR']);
                TM = _.get(changes, ['items', 'currentValue', 'TM']);
            }
            else{
                PR = _.get(changes, ['items', 'currentValue']);
            }
            if (PR && PR.length || TM && TM.length){
                bindItems(changes.items.currentValue);
            } else {
                vm.pr = [];
                vm.tm = [];
            }
        }
    }
})();

(function () {

    angular.module('phenix.core').controller('stockPopinCtrl', stockPopinCtrl)


    function stockPopinCtrl($mdDialog) {
        var vm = this;
        vm.closeModal = closeModal;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        function closeModal(){
            $mdDialog.cancel();
        }

    }
})();

(function() {

    angular.module('phenix.core').component('superCartBadge', {
        bindings: {
            cartLength: '<'
        },
        templateUrl: 'app/core/components/superCartBadge/superCartBadge.template.html',
        controller: cartBadgeController
    })

    function cartBadgeController(configConstantes) {
        var vm = this;
        vm.newHeaderMenu = JSON.parse(configConstantes.newHeaderMenu);
    }

})();

(function () {
    'use strict';
    angular
        .module('phenix')
        .controller('PdfModalController', PdfModalController);

    function PdfModalController() {
        var vm = this;
        vm.close = close;




    }
})();



(function () {
    angular.module('phenix.core').filter('trim', function() {
        return function(value) {
        if (!angular.isString(value)) {
            return value;
        }
        return value.replace(/^\s+|\s+$/g, '');
        };
    })
})();

(function () {
    angular
        .module('phenix.core')
        .component('basketClientInformations', {
            bindings: {
                client: '<'
            },
            controller: basketClientInformationsController,
            controllerAs: 'vm',
            templateUrl: 'app/core/components/basket-client-informations/basket-client-informations.template.html'
        })

    function basketClientInformationsController() {
    }

})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .factory('oneOpenTooltipService', oneOpenTooltipService);

  /* @ngInject */
  function oneOpenTooltipService() {
    var service = {
      setArrayPopin: setArrayPopin,
      getArrayPopin: getArrayPopin,
      deleteArrayPopin: deleteArrayPopin,
      getPreviousClick: getPreviousClick,
      setPreviousClick: setPreviousClick
    };
    var arrayPopin = [];
    var previousClick = '';

    return service;

    ////////////////

    /**
     * @desc Push popin in an array
     * @param popin
     */
    function setArrayPopin(popin) {
      arrayPopin.push(popin);
    }

    /**
     * @desc Return the array of ID popin
     * @returns {Array}
     */
    function getArrayPopin() {
      return arrayPopin;
    }

    /**
     * @desc Delete one element from the popin array
     * @param index
     */
    function deleteArrayPopin(index) {
      arrayPopin.splice(index, 1);
    }

    /**
     * @desc Return Previous click string
     * @returns {string}
     */
    function getPreviousClick(){
      return previousClick;
    }

    /**
     * @desc Set Previous click string to prevent double click
     * @param id
     */
    function setPreviousClick(id){
      previousClick = id;
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('oneOpenTooltip', oneOpenTooltip);

  function oneOpenTooltip() {
    var directive = {
      link: oneOpenTooltipLink,
      controller: oneOpenTooltipController,
      restrict: 'A'
    };
    return directive;

    function oneOpenTooltipLink(scope, element, attrs) {

      //on click on popin
      element.on('click', function () {
        scope.$apply(function () {
          scope.closeOthersPopinStock(attrs.id + '-tooltip');
        });
      });
    }
  }

  /** @ngInject */
  function oneOpenTooltipController($scope, $document, $timeout, oneOpenTooltipService) {

    var popinStock = oneOpenTooltipService.getArrayPopin();
    $scope.closeOthersPopinStock = closeOthersPopinStock;

    /**
     * Get and Set open popin in array
     * Trigger click event to keep one tooltip open
     * @param id
     */
    function closeOthersPopinStock(id) {
      var popinArray = angular.copy(popinStock);
      if (popinArray && popinArray.length > 0) {
        for (var i = 0; i < popinArray.length; i++) {
          //push if ID is different / splice if it the same
          if (id !== popinArray[i]) {
            oneOpenTooltipService.setArrayPopin(id);
            var previousClick = oneOpenTooltipService.getPreviousClick();
            // timeout to deal with the scope.apply
            $timeout(function () {
              //if user click on a different tooltip we delete the old id and trigger an event click to the close div
              if ($document[0].getElementById(popinArray[0]) && previousClick !== id) {
                oneOpenTooltipService.deleteArrayPopin(0);
                oneOpenTooltipService.setPreviousClick(popinArray[0]); // prevent the double click
                $('#' + popinArray[0]).find('.close').trigger('click'); // cause double click
              } else {
                oneOpenTooltipService.setPreviousClick(popinArray[0]);
                oneOpenTooltipService.deleteArrayPopin(1); // to not alterate the previous click
              }
            }, 0);
          } else {
            if (popinArray.length >= 1) {
              oneOpenTooltipService.deleteArrayPopin(0);
            }
          }
        }
      } else {
        //push in array if is the first tooltip open
        $timeout(function () {
          oneOpenTooltipService.setArrayPopin(id);
          oneOpenTooltipService.setPreviousClick(id);
        }, 0);
      }
    }
  }
})();


angular.module('phenix').service('AccessConfigService', function (AccessConfigConstants) {

    var vm = this;

    vm.userProfile = null;
    vm.docRights = null;
    vm.checkAccess = checkAccess;
    vm.getProfileFromCache = getProfileFromCache;
    vm.getDocRights = getDocRights;

    function getProfileFromCache(userProfile){
        vm.userProfile = userProfile;
    }

    function getDocRights(docRights){
        vm.docRights = docRights;
    }

    // Helper to check a single config item
    function checkConfigItem(configItem) {
        if (!configItem || !vm.userProfile || configItem.userType !== vm.userProfile.userType) return false;

        // ASOM userType: check docRights
        if (configItem.docRights && vm.userProfile.userType === AccessConfigConstants.userTypes.ASOM) {
            if (
                !Array.isArray(configItem.docRights) ||
                !vm.docRights ||
                !configItem.docRights.some(function(docRight) {
                    return vm.docRights && vm.docRights[docRight];
                })
            ) {
                return false;
            }
        }

        // Check roles for all userTypes
        if (
            configItem.roles &&
            (!Array.isArray(vm.userProfile.roles) ||
                !configItem.roles.some(function(role) {
                    return vm.userProfile.roles && vm.userProfile.roles.includes(role);
                }))
        ) {
            return false;
        }

        return true;
    }

    // Recursively check access for menuConfig (array or object)
    function checkMenuConfig(menuConfig) {
        if (Array.isArray(menuConfig)) {
            return menuConfig.some(checkConfigItem);
        } else if (menuConfig && typeof menuConfig === 'object') {
            return Object.keys(menuConfig).some(function(subKey) {
                return checkMenuConfig(menuConfig[subKey]);
            });
        }
        return false;
    }

    /**
     * Generic function to check access dynamically based on configuration and user profile.
     * @param {String} configKey - The key in `accessConfigConstants` to use as the configuration source.
     * @param {String} [menuKey] - Optional key in the configuration to check access for. If not provided, checks all keys.
     * @param {String} [subMenuKey] - Optional key for a sub-menu to check access for.
     * @returns {Boolean} - True if the user has access, false otherwise.
     */
    function checkAccess(configKey, menuKey, subMenuKey) {
        const config = AccessConfigConstants.menuAccess[configKey];
        if (!config && (!vm.userProfile || (vm.userProfile && vm.userProfile.userType == AccessConfigConstants.userTypes.ASOM && !vm.docRights))) {
            console.warn(`Configuration for key "${configKey}" not found.`);
            return false;
        }
        // If subMenuKey is provided, check access for sub-menu, and if true, return true for parent and grandparent
        if (menuKey && subMenuKey) {
            if (config[menuKey] && config[menuKey][subMenuKey]) {
                if (checkMenuConfig(config[menuKey][subMenuKey])) {
                    return true; // User has access to sub-menu, so also to menu and parent
                }
            }
            return false;
        }
        // If only menuKey is provided, check all sub-menus under menuKey
        if (menuKey) {
            if (config[menuKey]) {
                return checkMenuConfig(config[menuKey]);
            }
            return false;
        }
        // If neither is provided, check all menus under configKey
        return Object.values(config).some(function(cfg) {
            return checkMenuConfig(cfg);
        });
    }

});
var accessConfig = {};

accessConfig.roles = {

    ARCA: 'ARCA',
    RNET: 'RNET',
    ASOM: 'ASOM',
    ROLE_ACTIS: 'ACTIS',
    ROLE_ACTIS_USER: 'ACTIS_USER',
    ROLE_IRN_67591_FIC_MANAGEMENT: 'IRN-67591:FIC_MANAGEMENT',
    ROLE_RACTIS_FIC_MANAGEMENT: 'RACTIS_FIC_MANAGEMENT',
    ROLE_ASSISTANCE_TECHNIQUE_N1: "Assistance_Technique_N1",
    ROLE_PPX_ASSIST_TECH_CORP: "PPX_ASSIST_TECH_CORP",
    ROLE_PPX_ASSIST_TECH_N1: "PPX_ASSIST_TECH_N1",
    ROLE_PPX_ASSIST_TECH_N2: "PPX_ASSIST_TECH_N2",
    ROLE_DDP_ADMIN: 'PPX_DDP_ADMIN',
    ROLE_PPX_LIGHT: 'PPX_LIGHT',
    ROLE_RNET_CNR_CUSTOMER_CARE: 'IRN-74772:CNR_CUSTOMER_CAR',
    ROLE_RNET_CNR_DEALER: 'IRN-74772:CNR_DEALER',
    ROLE_PPX_CORPORATE_USER: 'PPX_CORPORATE_USER',
    ROLE_PPX_DOCPRIV_ASE: 'PPX_DOCPRIV_ASE',
    ROLE_PPX_DOCPRIV_STD: 'PPX_DOCPRIV_STD',
    ROLE_PPX_NETWORK_USER: 'PPX_NETWORK_USER',
    ROLE_PPX_DOCPRIV_COMMENT: 'PPX_DOCPRIV_COMMENT',
    ROLE_PPX_DOCPRIV_NISSAN: 'PPX_DOCPRIV_NISSAN',
    ROLE_PPX_DOCPRIV_QSTOMIZE: 'PPX_DOCPRIV_QSTOMIZE',
    ROLE_CNR_CUSTOMER_CARE: 'CNR_CUSTOMER_CARE',
    ROLE_IRN_67551_DIAGNOSIS: 'IRN-67551:DIAGNOSIS',
    ROLE_IRN_67551_TECH: 'IRN-67551:TECH',
    ROLE_PPX_INDEPENDENT_USER: 'PPX_INDEPENDENT_USER',
    ROLE_IRN_67551_IMMO: 'IRN-67551:IMMO',
    ROLE_IRN_67551_INDEPENDENT: 'IRN-67551:INDEPENDENT',
    ROLE_IRN_67551_REP: 'IRN-67551:REP',
    ROLE_IRN_67551_PM: 'IRN-67551:PM',
    ROLE_PPX_IMPORT_PARTS_MANAGER: 'PPX_IMPORT_PARTS_MANAGER',
    ROLE_IRN_67551_PTI: 'IRN-67551:PTI',
    ROLE_PPX_MMC: 'PPX_MMC',
    ROLE_PPX_NIS: 'PPX_NIS',
    ROLE_IRN_75245_TRACE_DEALER: 'IRN-75245:TRACE_DEALER',
    ROLE_IRN_66997_COMMANDE: 'irn-66997:commande',
    ROLE_IRN_6943_COMMANDE: 'irn-6943:commande',
    ROLE_IRN_72795_COMMANDE: 'irn-72795:commande',
    ROLE_PPX_DOC_PRIV: 'PPX_DOC_PRIV',
    ROLE_PPX_CONFIDENTIAL: 'PPX_CONFIDENTIAL',
    ROLE_NETWORK_PROFILE_WORKSHOP: 'WORKSHOP',
    ROLE_NETWORK_PROFILE_PARTSHOP: 'PARTSHOP',
    ROLE_WORKSHOP_PROFILE: 'DMS_WORKSHOP',
    ROLE_PARTSHOP_PROFILE: 'DMS_PARTSHOP',
    ROLE_HORSE_PROFILE: 'HORSE',
    ROLE_PPX_CARPARK_LPP: 'PPX_CARPARK_LPP'

};

accessConfig.docRights = {
    DOC_MD_DIAGFILES: 'MD-DIAGFILES',
    DOC_MD_REPROG: 'MD-REPROG',
    DOC_DOCPRIV: 'DOCPRIV',
    DOC_BT_TECHLINE: 'BT-TECHLINE'
    
}

accessConfig.userTypes = {
    ARCA: accessConfig.roles.ARCA,
    RNET: accessConfig.roles.RNET,
    ASOM: accessConfig.roles.ASOM
};

accessConfig.roleGroups = {
    assistTech: [
        accessConfig.roles.ROLE_PPX_ASSIST_TECH_CORP,
        accessConfig.roles.ROLE_PPX_ASSIST_TECH_N1,
        accessConfig.roles.ROLE_PPX_ASSIST_TECH_N2
    ]
};

accessConfig.menuAccess = {
    EXPERTS_DOC: {
        EBV: {
            REPAIR: [
                { userType: accessConfig.userTypes.ARCA, roles: [accessConfig.roles.ROLE_PPX_DOCPRIV_ASE] }
            ],
            OTS_BT_ACTIS: [
                { userType: accessConfig.userTypes.ARCA, roles: [accessConfig.roles.ROLE_PPX_ASSIST_TECH_N2] }
            ]
        },
        BTLIST: [
            { userType: accessConfig.userTypes.ARCA, roles: accessConfig.roleGroups.assistTech },
            { userType: accessConfig.userTypes.RNET, roles: accessConfig.roleGroups.assistTech },
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_BT_TECHLINE] }
        ],
        DOCPRIV: [
            { userType: accessConfig.userTypes.ARCA, roles: [accessConfig.roles.ROLE_PPX_DOCPRIV_ASE, accessConfig.roles.ROLE_PPX_DOCPRIV_STD] },
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_PPX_DOC_PRIV] },
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_DOCPRIV] }
        ],
        FACTORY_REWORK: [
            { userType: accessConfig.userTypes.ARCA, roles: accessConfig.roleGroups.assistTech },
            { userType: accessConfig.userTypes.RNET, roles: accessConfig.roleGroups.assistTech }
        ],
        CARPARK_CALCULATION: [
            { userType: accessConfig.userTypes.ARCA, roles: [accessConfig.roles.ROLE_PPX_CARPARK_LPP] }
        ]
    },
    HISTORY_INFORMATION: {
        ECU: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_IRN_67551_DIAGNOSIS, accessConfig.roles.ROLE_IRN_67551_TECH, accessConfig.roles.ROLE_IRN_67551_IMMO]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_DIAGFILES] }
        ],
        NETWORK_DIAGNOSIS: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_IRN_67551_DIAGNOSIS, accessConfig.roles.ROLE_IRN_67551_TECH, accessConfig.roles.ROLE_IRN_67551_IMMO]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_DIAGFILES] }
        ],
        DTC: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_IRN_67551_DIAGNOSIS, accessConfig.roles.ROLE_IRN_67551_TECH, accessConfig.roles.ROLE_IRN_67551_IMMO]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_DIAGFILES] }
        ],
        DTC_COMPARISON: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_IRN_67551_DIAGNOSIS, accessConfig.roles.ROLE_IRN_67551_TECH, accessConfig.roles.ROLE_IRN_67551_IMMO]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_DIAGFILES] }
        ],
        USER_JOURNEY: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roles.ROLE_IRN_67551_TECH]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_REPROG] }
        ],
        REPROGRAMMING_HISTORY: [
            { userType: accessConfig.userTypes.ARCA, roles: [accessConfig.roleGroups.assistTech]},
            { userType: accessConfig.userTypes.RNET, roles: [accessConfig.roleGroups.assistTech]},
            { userType: accessConfig.userTypes.ASOM, docRights: [accessConfig.docRights.DOC_MD_REPROG] }
        ],
        CRASH_HISTORY: [
            { userType: accessConfig.userTypes.ARCA},
            { userType: accessConfig.userTypes.RNET}
        ]
    }
};


angular.module('phenix').constant('AccessConfigConstants', accessConfig);
angular.module("phenix.core").filter("diagFileSearchFilter", function() {
    return function(diagFilesByFolder, searchDiagFile, selectedField) {
        if (!selectedField || !searchDiagFile) return diagFilesByFolder;
        var filtered = {};

        angular.forEach(diagFilesByFolder, function(diagFiles, folderId) {
            var filteredDiagFiles = diagFiles.filter(function(diagFile) {
                if (
                    selectedField == "dealer.id" &&
                    diagFile.dealerId.indexOf(searchDiagFile) !== -1
                ) {
                    return true;
                }
                return false;
            });
            if (!_.isEmpty(filteredDiagFiles)) {
                filtered[folderId] = filteredDiagFiles;
            }
            /*
                console.log('diagFile', diagFile);
                if (
                    selectedField === "dealer.id" && searchDiagFile.indexOf(diagFile.dealerId) !== -1
                ) {
                    filteredResult.push(diagFile);
                }
                if (
                    selectedField === "dealer.name" && searchDiagFile.indexOf(diagFile.dealerName) !== -1
                ) {
                    filteredResult.push(diagFile);
                }
                if (
                    selectedField === "dealer.country" && searchDiagFile.indexOf(diagFile.dealerCountry) !== -1
                ) {
                    filteredResult.push(diagFile);
                }
                if (
                    selectedField === "category" && searchDiagFile.indexOf(diagFile.dealerId) !== -1
                ) {
                    filteredResult.push(diagFile);
                }
                */
        });
        diagFilesByFolder = angular.toJson(filtered);
        return diagFilesByFolder;
    };
});

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DiagFileWsService', DiagFileWsService);

    /** @ngInject */
    function DiagFileWsService($http, $q, ActisConstantes, VdhConstants,$translate,RestUpgrade,DiagFileDetailsNewConstants) {
        this.getDiagFilesByVin = getDiagFilesByVin;
        this.getDiagFileById = getDiagFileById;
        this.getDealerById = getDealerById;
        this.getDiagFilePatterns = getDiagFilePatterns;
        this.getPhasesByFamilyId = getPhasesByFamilyId;
        this.getPredictions = getPredictions;
        this.getSymptoms = getSymptoms;
        this.getSystemDocuments = getSystemDocuments;
        this.getReprogrammingHistory = getReprogrammingHistory;
        this.getPredictionVotes = getPredictionVotes;

        /**
         * getDiagFilesByVin.
         * @param {request} request.
         * @return {promise}
         * usage getDiagFilesByVin(request)
         */
        function getDiagFilesByVin(params) {
            return RestUpgrade.one(VdhConstants.restDiagFileByVin+params).get();
        }

        /**
         * getDiagFileById
         * @param {*} diagFileId 
         * @return {promise}
         */
        function getDiagFileById(diagFileId, preferredLanguage, defaultLanguage){
            var url = VdhConstants.restDiagFileById + '/' + diagFileId + '?preferredLanguage='+preferredLanguage + '&defaultLanguage='+defaultLanguage;
            return RestUpgrade.one(url).get();
        }

        /**
         * @name getDealerById
         * @desc Get Dealer by dealerId
         * @param {object} body
         * @returns {Promise}
         */
        function getDealerById(dealerId) {
            var baseUrl = ActisConstantes.endpoint.natCase;
            return RestUpgrade.one(baseUrl, dealerId).get();
        }

        /**
         * @name getDiagFilePatterns
         * @param {*} diagFileId
         * @returns {Promise}
         */
        function getDiagFilePatterns(diagFileId, preferredLanguage, defaultLanguage){
            var url = VdhConstants.restPatternsByDiagFileId + '/' + diagFileId + '/patterns?preferredLanguage='+preferredLanguage + '&defaultLanguage='+defaultLanguage;
            return RestUpgrade.one(url).get();
            //return $http.get('/assets/json/diagFilePatterns.mock.json');
        }

        /**
         * @name getPhasesByFamilyId
         * @param {*} familyId
         * @returns {Promise}
         */
        function getPhasesByFamilyId(familyId){
            var url = VdhConstants.restPhasesByFamilies + '?familyId='+familyId;
            return RestUpgrade.one(url).get();
        }

        /**
         * @name getPredictions
         * @returns {Promise}
         */
        function getPredictions(vehFamily,scopeFaults){
            var self = this;
            
            // Cancel previous request if exists
            if (self.currentPredictionCanceller) {
                self.currentPredictionCanceller.resolve('New request initiated');
            }
            
            // Create new cancellation token
            var canceller = $q.defer();
            self.currentPredictionCanceller = canceller;
            
            var params = {
                    "familyId": vehFamily,
                    "instances": scopeFaults
            }
            var url = VdhConstants.restPredictions;
            var defer = $q.defer();
            
            // Use RestUpgrade with timeout for proper cancellation
            RestUpgrade.all(url).withHttpConfig({
                timeout: canceller.promise
            }).post(params).then(function(res){
                // Clear canceller on success
                if (self.currentPredictionCanceller === canceller) {
                    self.currentPredictionCanceller = null;
                }
                defer.resolve(res);
            }).catch(function(error){
                // Clear canceller on error
                if (self.currentPredictionCanceller === canceller) {
                    self.currentPredictionCanceller = null;
                }
                
                // Check if request was cancelled
                if (error.status === -1) {
                    defer.reject('cancelled');
                } else {
                    defer.reject($translate.instant('ERROR'));
                }
            });
            
            return defer.promise;
        }

        function getSymptoms(){
            return $http.get('/assets/json/symptoms.mock.json');
        }

        function getSystemDocuments(payload){
            var url = VdhConstants.restSysDoc;
            var defer = $q.defer();
            RestUpgrade.all(url).post(payload).then(function(res){
                defer.resolve(res);
            }).catch(function(){
                defer.reject($translate.instant('ERROR'));
            });
            return defer.promise;
        }

        function getReprogrammingHistory(vin, page, pageSize) {
            return RestUpgrade.one(VdhConstants.restReprogrammingHistory + vin + VdhConstants.traceabilityInfo + '?page=' + page + '&pageSize=' + pageSize).get();
        }
        
        function getPredictionVotes(payload){
            var url = DiagFileDetailsNewConstants.getPredictionVotes;
            var defer = $q.defer();
            RestUpgrade.all(url).post(payload).then(function(res){
                defer.resolve(res);
            }).catch(function(){
                defer.reject($translate.instant('ERROR'));
            });
            return defer.promise; 
        }
    }
})();

(function () {

    angular
        .module('phenix')
        .service('DiagFileBusinessService', DiagFileBusinessService);

    /** @ngInject */
    function DiagFileBusinessService(
        DiagFileWsService,CacheService,CacheConstants
    ) {
        this.getDiagFilesByVin = getDiagFilesByVin;
        this.getDealerById = getDealerById;
        this.getDiagFileById = getDiagFileById;
        this.getDiagFilePatterns = getDiagFilePatterns;
        this.getPredictions = getPredictions;
        this.getSymptoms = getSymptoms;
        this.getSystemDocuments = getSystemDocuments;
        this.getReprogrammingHistory = getReprogrammingHistory;
        this.getPredictionVotes = getPredictionVotes;

        function getDiagFilesByVin(vin){
            return DiagFileWsService.getDiagFilesByVin(vin);
        }

        function getDiagFileById(diagFileId, preferredLanguage, defaultLanguage){
            return DiagFileWsService.getDiagFileById(diagFileId, preferredLanguage, defaultLanguage);
        }

        function getDealerById(dealerId){
            return DiagFileWsService.getDealerById(dealerId);
        }

        function getDiagFilePatterns(diagFileId, preferredLanguage, defaultLanguage){
            return DiagFileWsService.getDiagFilePatterns(diagFileId, preferredLanguage, defaultLanguage);
        }

        function getPredictions(vehFamily,scopeFaults){
            return DiagFileWsService.getPredictions(vehFamily,scopeFaults);
        }

        function getSymptoms(){
            return DiagFileWsService.getSymptoms();
        }

        function getSystemDocuments(){
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var payload ={
                userContext:userContext,
                carContext:carContext
            }
            return DiagFileWsService.getSystemDocuments(payload);
        }

        function getReprogrammingHistory(vin,page,pageSize) {
            return DiagFileWsService.getReprogrammingHistory(vin, page, pageSize);
        }

        function getPredictionVotes(payload){
            return DiagFileWsService.getPredictionVotes(payload);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('CommentsWsService', CommentsWsService);

    /** @ngInject */
    function CommentsWsService($http, $q, RestUpgrade, VdhConstants) {
        this.getCommentsByPatternId = getCommentsByPatternId;
        this.addComment = addComment;
        this.updateComment = updateComment;
        this.deleteComment = deleteComment;
        this.addFeedback = addFeedback;
        this.updateFeedback = updateFeedback;
        this.removeFeedback = removeFeedback;

        /**
         * getCommentsByPatternId.
         * @param {request} request.
         * @return {promise}
         * usage getCommentsByPatternId(request)
         */
        function getCommentsByPatternId(patternId, preferredLanguage, defaultLanguage) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments?preferredLanguage='+preferredLanguage + '&defaultLanguage='+defaultLanguage;
            return RestUpgrade.one(url).get();
        }

         /**
         * updateComment.
         * @param {request} request.
         * @return {promise}
         * usage updateComment(request)
         */
        function updateComment(patternId, commentId, comment, validation) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments/' + commentId + '?validation='+validation;
            return RestUpgrade.all(url).customPUT(comment);
        }

        /**
         * add comment for a given pattern.
         * @param {request} request.
         * @return {promise}
         * usage addComment(request)
         */
        function addComment(patternId, comment) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments';
            return RestUpgrade.all(url).post(comment);
        }

        /**
         * delete comment for a given pattern.
         * @param {request} request.
         * @return {promise}
         * usage deleteComment(request)
         */
        function deleteComment(patternId, commentId) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments/' + commentId;
            return RestUpgrade.one(url).remove();
        }

        /**
         * addFeedback for a given comment.
         * @param {request} request.
         * @return {promise}
         * usage addFeedback(request)
         */
        function addFeedback(patternId, commentId, feedback) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments/' + commentId + '/feedbacks';
            return RestUpgrade.all(url).post(feedback);
        }

        /**
         * updateFeedback for a given comment.
         * @param {request} request.
         * @return {promise}
         * usage updateFeedback(request)
         */
        function updateFeedback(patternId, commentId, ipn, feedback) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments/' + commentId + '/feedbacks/'+ ipn;
            return RestUpgrade.all(url).customPUT(feedback);
        }

        /**
         * removeFeedback for a given comment.
         * @param {request} request.
         * @return {promise}
         * usage removeFeedback(request)
         */
        function removeFeedback(patternId, commentId, ipn) {
            var url = VdhConstants.restCommentsByPatternId + '/' + patternId + '/comments/' + commentId + '/feedbacks/' + ipn;
            return RestUpgrade.one(url).remove();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("commentsHubPopinCtrl", commentsHubPopinCtrl);

    /**  @ngInject */
    function commentsHubPopinCtrl(
        $scope,
        $state,
        $mdDialog,
        dtc,
        groupedPatterns,
        CommentsWsService,
        DiagFileWsService,
        CacheService,
        CacheConstants,
        SearchbyDiagnosticConstants,
        MainMetierService,
        toastr,
        blockUI, CarSearchConstants, ActisConstantes
    ) {
        $scope.id = $state.params.id;
        $scope.vin = $state.params.vin;
        $scope.dtc = dtc;
        $scope.groupedPatterns = groupedPatterns;
        $scope.rowCollection = $scope.dtc.contexts;
        $scope.patterns;
        $scope.comments = [];
        $scope.comment = Object.create(null);
        $scope.cancel = cancel;
        $scope.isAddComment = false;
        $scope.adtTechrole = false;
        var userProfil = CacheService.getUserProfile();
        $scope.isRnetUserType = userProfil ? MainMetierService.isRnetUserType(userProfil.userType): null;
        $scope.isArcaUserType = userProfil ? MainMetierService.isArcaUser(userProfil.userType): null;
        $scope.userIpn = userProfil.ipn;
        $scope.selectedDtcsCause = new Map();
        $scope.selectedDtcsPollution = new Map();
        this.selectedDtcCause = [];
        this.selectedDtcPollution = [];
        $scope.selectedPhase = "";
        $scope.displaycommentCreation = displaycommentCreation;
        $scope.dtcsCause = [];
        $scope.dtcsPollution = [];
        $scope.dtcs = [];
        $scope.familyId = dtc.familyId;
        $scope.phases = [];
        $scope.isOLVRole = isOLVRole;
        $scope.displayMenu = displayMenu;
        $scope.canEdit = canEdit;
        $scope.canDelete = canDelete;
        $scope.displayCommentEditor = displayCommentEditor;
        $scope.removeComment = removeComment;
        $scope.canValidate = canValidate;
        $scope.validateComment = validateComment;
        $scope.textarea= {
            commentUpdateText: ""
        };
        $scope.commentIndex = -1;
        $scope.checkIfLiked = checkIfLiked;
        $scope.checkIfDisliked = checkIfDisliked;
        $scope.likeComment = likeComment;
        $scope.dislikeComment = dislikeComment;
        $scope.cancelCreation = cancelCreation;
        $scope.commentText = "";
        $scope.deleteItemFromDtcs = deleteItemFromDtcs;
        $scope.updateDtc = updateDtc;
        $scope.addItemToDtcs = addItemToDtcs;
        $scope.removeDtc = removeDtc;
        $scope.createComment = createComment;
        $scope.initVariables = initVariables;
        $scope.cancelEdit = cancelEdit;
        $scope.updateComment = updateComment;
        $scope.setPhase = setPhase;
        $scope.searchTerm;
        $scope.clearSearchTerm = function () {
            $scope.searchTerm = "";
        };

        if (($scope.isRnetUserType || $scope.isArcaUserType) && userProfil && userProfil.roles.includes(SearchbyDiagnosticConstants.adtTechRole)) {
            $scope.adtTechrole = true;
        }

        function cancelEdit() {
            $scope.triggerValidation = false;
            $scope.emptyComment = false;
            $scope.isAddComment = false;
            $scope.commentIndex = -1;
        }
        function cancel() {
            $mdDialog.cancel();
        }
        function canEdit(comment) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            if (userContext.ipn == comment.creator.ipn) {
                return true;
            }
            return false;
        }
        function canDelete(comment) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            if (userContext.ipn == comment.creator.ipn) {
                return true;
            }
            return false;
        }

        function displayMenu() {
            return true;
        }
        function displaycommentCreation() {
            $scope.isAddComment = true;
            $scope.commentText = "";
        }

        function getCommentsByPatternId(patternId) {
            $scope.comments = [];
            var userContext = CacheService.getObject(CacheConstants.profil);
            var preferredLanguage = userContext.documentationFirstLanguage.code;
            var defaultLanguage = userContext.documentationSecondLanguage.code;

            CommentsWsService.getCommentsByPatternId(patternId, preferredLanguage, defaultLanguage).then(function (
                commentsByPatternIdResponse
            ) {
                if (commentsByPatternIdResponse.length > 0) {
                    var i = 0;
                    angular.forEach(commentsByPatternIdResponse, function (
                        comment
                    ) {
                        $scope.selectedDtcsCause.set(i, comment.causeDtcs);
                        $scope.selectedDtcsPollution.set(i, comment.dirtyDtcs);
                        comment = getReputation(comment);
                        $scope.comments.push(comment);
                        i += 1;
                    });
                    $scope.comments = $scope.comments.sort(sortComments);
                } else {
                    $scope.isAddComment = true;
                }
            });
        }

        function getReputation(comment) {
            if (comment && comment.commentFeedbacks) {
                var nbLikes = _.filter(comment.commentFeedbacks, function (
                    feed
                ) {
                    if (Number(feed.rating) === 1) {
                        return 1;
                    }
                }).length;
                var nbDislikes = _.filter(comment.commentFeedbacks, function (
                    feed
                ) {
                    if (Number(feed.rating) === -1) {
                        return 1;
                    }
                }).length;
                comment.like = nbLikes;
                comment.dislike = nbDislikes;
                comment.reputation = nbLikes - nbDislikes;
            }
            return comment;
        }

        function sortComments(comment1, comment2) {
            if (comment1.validated == "1" && comment2.validated == "0") {
                return -1;
            }
            if (comment1.validated == "0" && comment2.validated == "1") {
                return 1;
            }
        }

        function getPhasesByFamilyId(familyId) {
            DiagFileWsService.getPhasesByFamilyId(familyId).then(function (
                phasesByFamilyIdResponse
            ) {
                $scope.phases = phasesByFamilyIdResponse[familyId];
            });
        }

        function isOLVRole(comment) {
            if (
                comment &&
                comment.creatorProfile &&
                comment.creatorProfile.includes("VDH_QUALITY_OLV")
            ) {
                return true;
            }
            return false;
        }

        function displayCommentEditor(commentIndex, comment) {
            $scope.dtcsCause = Array.from($scope.dtcs);
            $scope.dtcsPollution = Array.from($scope.dtcs);
            $scope.comment.content = comment.content;
            $scope.comment.creatorFirstName = comment.creatorFirstName;
            $scope.comment.creatorLastName = comment.creatorLastName;
            $scope.comment.userIpn = comment.userIpn;
            $scope.comment.validated = comment.validated;
            $scope.comment.validatorProfile = comment.validatorProfile;
            $scope.textarea.commentUpdateText = comment.content;
            $scope.comment.phase = comment.phase;
            $scope.selectedPhase = comment.phase;
            if ($scope.commentIndex === commentIndex) {
                $scope.commentIndex = -1;
            } else {
                $scope.commentIndex = commentIndex;
            }
        }

        function removeComment(commentIndex, comment) {
            CommentsWsService.deleteComment(comment.patternId, comment.id)
                .then(function () {
                    $scope.initVariables();
                })
                .catch(function (error) {
                    $scope.initVariables();
                });
        }

        function canValidate(comment) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            if(comment && userContext && userContext.roles && userContext.ipn != comment.creator.ipn){
                if (userContext.roles.includes(ActisConstantes.ppx_assist_tech_n2) ||
                    userContext.roles.includes(ActisConstantes.ppx_assist_tech_n1) || 
                    userContext.roles.includes(CarSearchConstants.ppxCorporateUser)) {
                    return true;
                }
            }
            return false;
        }

        function updateComment(comment) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            var updatedComment = Object.create(null);
            if(userContext && comment){
                updatedComment.id = comment.id;
                updatedComment.patternId = comment.patternId;
                updatedComment.content = $scope.textarea.commentUpdateText;
                updatedComment.phase = $scope.selectedPhase;
                updatedComment.causeDtcs = this.selectedDtcCause;
                updatedComment.dirtyDtcs = this.selectedDtcPollution;
                updatedComment.currentUserIpn = userContext.ipn;
                updatedComment.currentUserProfile = userContext.roles[0];
                updatedComment.creator = comment.creator;
                updatedComment.creationDateTime = comment.creationDateTime;
                updatedComment.validated = comment.validated;
                updatedComment.validatorProfile = comment.validatorProfile;
                updatedComment.commentFeedbacks = comment.commentFeedbacks;
                blockUI.start();
                CommentsWsService.updateComment(
                    updatedComment.patternId,
                    updatedComment.id,
                    updatedComment,
                    0
                )
                    .then(function () {
                        $scope.cancelEdit();
                        $scope.initVariables();
                    })
                    .catch(function (error) {
                        $scope.cancelEdit();
                        $scope.initVariables();
                    }).finally(function () {
                        blockUI.stop();
                    });
            } else{
                $scope.cancelEdit();
                $scope.initVariables();
            }
            
        }

        function validateComment(commentIndex, comment) {
            var userContext = CacheService.getObject(CacheConstants.profil);
            comment.currentUserProfile = userContext.roles[0];
            comment.currentUserIpn = userContext.ipn;
            comment.validated = 1;
            comment.validatorProfile = userContext.roles[0];
            CommentsWsService.updateComment(
                comment.patternId,
                comment.id,
                comment,
                1
            )
                .then(function () {
                    $scope.initVariables();
                })
                .catch(function (error) {
                    $scope.initVariables();
                });
        }

        function checkIfLiked(comment) {
            // var userContext = CacheService.getObject(CacheConstants.profil);
            // var liked = false;
            var likedIcon = {
                color: "#009900",
            };
            // var greyStyle = {
            //     color: "#8080804d",
            // };

            // angular.forEach(comment.commentFeedbacks, function (feedback) {
            //     if(feedback.ipn == userContext.ipn){
            //         liked = true;
            //     }
            // });
            // if(liked == true){
            //     return likedIcon;
            // }
            return likedIcon;
        }

        function checkIfDisliked(comment) {
            // var userContext = CacheService.getObject(CacheConstants.profil);
            // var disliked = false;
            var dislikedIcon = {
                color: "red",
            };
            // var greyStyle = {
            //     color: "#8080804d",
            // };
            // angular.forEach(comment.commentFeedbacks, function (feedback) {
            //     if(feedback.ipn == userContext.ipn){
            //         disliked = true;
            //     }
            // });
            // if(disliked == true){
            //     return dislikedIcon;
            // }
            return dislikedIcon;        }

        function likeComment(comment) {
            var firstLike = true;
            var userContext = CacheService.getObject(CacheConstants.profil);
            if (comment.commentFeedbacks.length > 0) {
                for (var i = 0; i < comment.commentFeedbacks.length; i++) {
                    var feedback = comment.commentFeedbacks[i];
                    if (
                        feedback.ipn === userContext.ipn &&
                        feedback.rating === "1"
                    ) {
                        CommentsWsService.removeFeedback(
                            comment.patternId,
                            comment.id,
                            userContext.ipn
                        )
                            .then(function (response) {
                                $scope.initVariables();
                            })
                            .catch(function (error) {
                                $scope.initVariables();
                            });
                        firstLike = false;
                        break;
                    } else if (
                        feedback.ipn === userContext.ipn &&
                        feedback.rating === "-1"
                    ) {
                        feedback.rating = "1";
                        CommentsWsService.updateFeedback(
                            comment.patternId,
                            comment.id,
                            userContext.ipn,
                            feedback
                        )
                            .then(function (response) {
                                $scope.initVariables();
                            })
                            .catch(function (error) {
                                $scope.initVariables();
                            });
                        firstLike = false;
                        break;
                    } else {
                        firstLike = true;
                    }
                }
            }
            if (firstLike) {
                var currentFeedback = {};
                currentFeedback.ipn = userContext.ipn;
                currentFeedback.rating = "1";
                CommentsWsService.addFeedback(
                    comment.patternId,
                    comment.id,
                    currentFeedback
                )
                    .then(function (response) {
                        $scope.initVariables();
                    })
                    .catch(function (error) {
                        $scope.initVariables();
                    });
            }
        }

        function dislikeComment(comment) {
            var firstLike = true;
            var userContext = CacheService.getObject(CacheConstants.profil);
                if(comment.commentFeedbacks.length > 0){
                    for (var i = 0; i < comment.commentFeedbacks.length; i++) {
                        var feedback = comment.commentFeedbacks[i];
                        if (
                            feedback.ipn === userContext.ipn &&
                            feedback.rating === "-1"
                        ) {
                            CommentsWsService.removeFeedback(
                                comment.patternId,
                                comment.id,
                                userContext.ipn
                            )
                                .then(function (response) {
                                    $scope.initVariables();
                                })
                                .catch(function (error) {
                                    $scope.initVariables();
                                });
                            firstLike = false;
                            break;
                        } else if (
                            feedback.ipn === userContext.ipn &&
                            feedback.rating === "1"
                        ) {
                            feedback.rating = "-1";
                            CommentsWsService.updateFeedback(
                                comment.patternId,
                                comment.id,
                                userContext.ipn,
                                feedback
                            )
                                .then(function (response) {
                                    $scope.initVariables();
                                })
                                .catch(function (error) {
                                    $scope.initVariables();
                                });
                            firstLike = false;
                            break;
                        } else {
                            firstLike = true;
                        }
                    }
                }
            if (firstLike) {
                var currentFeedback = {};
                currentFeedback.ipn = userContext.ipn;
                currentFeedback.rating = "-1";
                CommentsWsService.addFeedback(
                    comment.patternId,
                    comment.id,
                    currentFeedback
                )
                    .then(function (response) {
                        $scope.initVariables();
                    })
                    .catch(function (error) {
                        $scope.initVariables();
                    });
            }
        }

        function cancelCreation() {
            $scope.isAddComment = false;
        }

        function updateDtc(dtc, dtcType) {
            /*
            if ("CAUSE" === dtcType) {
                // Cause case
                $scope.selectedDtcPollution.splice($scope.selectedDtcPollution.indexOf(dtc), 1);
            } else {
                // pollution case
                $scope.selectedDtcCause.splice($scope.selectedDtcCause.indexOf(dtc), 1);
            }
            */
        }

        function deleteItemFromDtcs(dtc) {
            $scope.dtcsCause.splice($scope.dtcsCause.indexOf(dtc), 1);
            $scope.dtcsPollution.splice($scope.dtcsPollution.indexOf(dtc), 1);
        }

        function removeDtc(dtcType, commentIndex, dtc) {
            if (dtcType === "CAUSE") {
                var listOfDtcCause = [];
                if ($scope.selectedDtcsCause.get(commentIndex)) {
                    listOfDtcCause = $scope.selectedDtcsCause.get(commentIndex);
                }
                $scope.addItemToDtcs(dtc);
                //listOfDtcCause.delete(dtc);
                listOfDtcCause.splice(listOfDtcCause.indexOf(dtc), 1);
                this.selectedDtcsCause.set(commentIndex, listOfDtcCause);
            } else {
                var listOfDtcPollution = [];
                if ($scope.selectedDtcsPollution.get(commentIndex)) {
                    listOfDtcPollution = $scope.selectedDtcsPollution.get(
                        commentIndex
                    );
                }
                $scope.addItemToDtcs(dtc);
                //listOfDtcPollution.delete(dtc);
                listOfDtcPollution.splice(listOfDtcPollution.indexOf(dtc), 1);
                $scope.selectedDtcsPollution.set(
                    commentIndex,
                    listOfDtcPollution
                );
            }
        }

        function addItemToDtcs(dtc) {
            $scope.dtcsCause.push(dtc);
            $scope.dtcsPollution.push(dtc);
        }

        function createComment() {
            var comment = Object.create(null);
            $scope.emptyComment = false;
            var userContext = CacheService.getObject(CacheConstants.profil);
            comment.creator = {};
            comment.creator.firstName = userContext.firstName;
            comment.creator.lastName = userContext.lastName;
            comment.currentUserProfile = userContext.roles[0];
            comment.currentUserIpn = userContext.ipn;
            comment.patternId = $scope.dtc.id;
            comment.phase = $scope.selectedPhase;
            if (
                $scope.commentText &&
                $scope.commentText.length > 0 &&
                $scope.selectedDtcsCause != null &&
                $scope.selectedDtcsPollution != null
            ) {
                if ($scope.commentText) {
                    comment.content = $scope.commentText;
                }
                if (this.selectedDtcCause) {
                    comment.causeDtcs = this.selectedDtcCause;
                }
                if (this.selectedDtcPollution) {
                    comment.dirtyDtcs = this.selectedDtcPollution;
                }
                blockUI.start();
                CommentsWsService.addComment(comment.patternId, comment)
                    .then(function () {
                        $scope.triggerValidation = false;
                        $scope.emptyComment = false;
                        $scope.isAddComment = false;
                        $scope.initVariables();
                    })
                    .catch(function (error) {
                        $scope.triggerValidation = false;
                        $scope.emptyComment = false;
                        $scope.isAddComment = false;
                        $scope.initVariables();
                    }).finally(function () {
                        blockUI.stop();
                    });
            } else {
                $scope.triggerValidation = true;
                $scope.emptyComment = true;
            }
        }

        function setPhase(phase){
            $scope.selectedPhase = phase;
        }

        function initVariables() {
            getCommentsByPatternId($scope.dtc.id);
            getPhasesByFamilyId($scope.familyId);
            $scope.patterns = $scope.groupedPatterns.get(
                Number($scope.dtc.mileage)
            );
            $scope.dtcs = [];
            angular.forEach($scope.patterns.dtcs, function (dtc) {
                $scope.dtcs.push(dtc.code);
            });
            $scope.dtcsCause = Array.from($scope.dtcs);
            $scope.dtcsPollution = Array.from($scope.dtcs);
        }
        this.$onInit = $scope.initVariables();
    }
})();

(function () {
  'use strict';
  angular.module('phenix').controller('StoppedRangeDocumentCtrl', StoppedRangeDocumentCtrl);

  function StoppedRangeDocumentCtrl($translate, RoutesConstants, $state, toastr,configConstantes) {
    var vm = this;

    function init() {
      vm.documentList = $state.params.documentList;
      vm.listType = $state.params.listType;
      vm.pageSize=10;
      vm.getDocumentUrl=getDocumentUrl;
      switch (vm.listType) {
        case "MR":
          vm.labelHead = "STOPPED_RANGE_MR_HEAD_ID";
          break;
        case "NT":
          vm.labelHead = "STOPPED_RANGE_NT_HEAD_ID";
          break;
        case "MD":
          vm.labelHead = "STOPPED_RANGE_MD_HEAD_ID";
          break;
        default:
      }
    }

    function getDocumentUrl(node){
      return configConstantes.baseUrlBack + node.url;
    }
    init();
  }

})();

(function () {

  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
    // for nested views, you have to write a ste: 'stateParent.myState'
      .state(RoutesConstants.stoppedRange, {
        url: '/products/stoppedRange',
        templateUrl: 'app/components/products/stoppedRange/stoppedRange.html',
        controller: 'StoppedRangeCtrl',
        controllerAs: 'stoppedRangeCtrl'
      })
      .state(RoutesConstants.stoppedRangeSelectCatalog, {
        views: {
          'pr': {
            templateUrl: 'app/components/products/stoppedRange/selectCatalog.html'
          }
        }
      })
      .state(RoutesConstants.stoppedRangePR, {
        views: {
          'pr': {
            templateUrl: 'app/components/products/stoppedRange/prCatalog.html',
            controller: 'PRCatalogCtrl',
            controllerAs: 'prCatalogCtrl'
          }
        },
        params: {
          catalog: null
        }
      })
      .state(RoutesConstants.stoppedRangeDocument, {
        views: {
          'document': {
            templateUrl: 'app/components/products/stoppedRange/stoppedRangeDocument.html',
            controller: 'StoppedRangeDocumentCtrl',
            controllerAs: 'stoppedRangeDocumentCtrl'

          }
        }, params: {
          documentList: null,
          listType: null
        }
      });
  }
})();

(function () {
  'use strict';
  angular.module('phenix').controller('StoppedRangeCtrl', StoppedRangeCtrl);

  function StoppedRangeCtrl($timeout, timeOutRecapCar, $translate, toastr, StoppedRangeMetierService, $scope, RoutesConstants, $state,CarSearchMetierService) {
    var vm = this;
    vm.recapCarAPI = null;

    function init() {

      vm.selectTabPR = selectTabPR;
      vm.selectTab = selectTab;
      vm.selectCatalog = selectCatalog;
      vm.vehicle= CarSearchMetierService.getVehicleContext().vehicle;

      /**Pagination**/
      vm.pageSize = 10;

      $timeout(function () {
        vm.recapCarAPI.showBtnInitContext(true);
        vm.recapCarAPI.enableLinkCarFeatures(true);
        vm.recapCarAPI.showBtnConsultPrDoc(false);
      }, timeOutRecapCar);

      if(vm.vehicle && vm.vehicle.pr && vm.vehicle.pr.list){
        vm.catalogs = vm.vehicle.pr.list;
      }

      if(vm.vehicle && vm.vehicle.mr){
        vm.mr = vm.vehicle.mr;
      }

      if(vm.vehicle && vm.vehicle.md){
        vm.md = vm.vehicle.md;
      }

      if(vm.vehicle && vm.vehicle.nt){
        vm.nt = vm.vehicle.nt;
      }
      initTabHeading();
    }

    init();

    function selectTabPR() {
      if (vm.selectedCatalog) {
        $state.go(RoutesConstants.stoppedRangePR, {catalog: vm.selectedCatalog});
        return;
      }
      if (vm.catalogs.length > 1) {
        $state.go(RoutesConstants.stoppedRangeSelectCatalog);
      }
      else {
        $state.go(RoutesConstants.stoppedRangePR, {catalog: vm.catalog[0]});
      }
    }

    function selectCatalog(catalog) {
      vm.selectedCatalog = catalog;
      $state.go(RoutesConstants.stoppedRangePR, {catalog: catalog});
    }

    function initTabHeading() {
      if (vm.vehicle && vm.vehicle.pr && vm.vehicle.pr.list.length > 2) {
        $translate('STOPPED_RANGE_PR_HEADING', {nbCatalog: vm.vehicle.pr.list.length}).then(function (text) {
          vm.labelPR = text;
        }, function (error) {
          toastr.error('Translation error');
        });
      }
      else {
        $translate('COMMON_TABLE_PR_TITLE').then(function (text) {
          vm.labelPR = text;
        }, function (error) {
          toastr.error('Translation error');
        });
      }
      $translate('COMMON_TABLE_MR_TITLE').then(function (text) {
        vm.labelMR = (vm.vehicle && vm.vehicle.mr && vm.vehicle.mr.list.length > 2) ? text + " (" + vm.vehicle.mr.list.length + ")" : text;
        ;
      }, function (error) {
        toastr.error('Translation error');
      });
      $translate('COMMON_TABLE_MD_TITLE').then(function (text) {
        vm.labelMD = (vm.vehicle && vm.vehicle.md && vm.vehicle.md.list.length > 2) ? text + " (" + vm.vehicle.md.list.length + ")" : text;
        ;
      }, function (error) {
        toastr.error('Translation error');
      });
      $translate('COMMON_TABLE_NT_TITLE').then(function (text) {
        vm.labelNT = (vm.vehicle && vm.vehicle.nt && vm.vehicle.nt.list.length > 2) ? text + " (" + vm.vehicle.nt.list.length + ")" : text;

      }, function (error) {
        toastr.error('Translation error');
      });
    }

    function selectTab(tab) {
      var documentList;
      var listType = tab;
      switch (tab) {
        case "MR":
          documentList = vm.vehicle.mr;
          break;
        case "NT":
          documentList = vm.vehicle.nt;
          break;
        case "MD":
          documentList = vm.vehicle.md;
          break;
        default:
      }
      $state.go(RoutesConstants.stoppedRangeDocument, {"documentList": documentList.list, "listType": listType});
    }
  }

})();

(function () {
  'use strict';
  angular.module('phenix').controller('PRCatalogCtrl', PRCatalogCtrl);

  function PRCatalogCtrl($state, RoutesConstants, StoppedRangeMetierService, configConstantes) {
    var vm = this;

    function init() {
      vm.catalog = $state.params.catalog;
      StoppedRangeMetierService.getCatalog(vm.catalog.id).then(function (response) {
        vm.prList = response.catalog;
        vm.listAutoComplete = vm.prList;
        showPr(0);
      });

      vm.getIconClass = getIconClass;
      vm.showPr = showPr;
      vm.getPrClass = getPrClass;
      vm.changeCatalog = changeCatalog;
      vm.isPrExpanded = isPrExpanded;
      vm.showImage = showImage;
      vm.autoComplete = autoComplete;
      vm.firstPr = firstPr;
      vm.nextPr = nextPr;
      vm.lastPr = lastPr;
      vm.previousPr = previousPr;
    }

    init();

    function getIconClass(pr) {
      return vm.activePr.id === pr.id ? 'icon-icons_arrow_dropdown' : 'icon-icons_arrow_link';
    }

    function showPr(index) {
      vm.activePr = vm.prList[index];
      vm.activePrIndex = index;
      showImage(vm.activePr);
    }

    function getPrClass(pr) {
      return vm.activePr.id === pr.id ? 'prActive' : '';
    }

    function changeCatalog() {
      $state.go(RoutesConstants.stoppedRangeSelectCatalog);
    }


    function isPrExpanded(pr) {
      return vm.activePr.id === pr.id;
    }

    function showImage(node) {
      vm.urlPlanche = configConstantes.baseUrlBack + node.url;
    }

    function autoComplete() {
      var index = _.findIndex(vm.prList, function (o) {
          return o.designation === vm.keyWord
        }
      )
      if (index > -1) {
        showPr(index);
      }


    };

    function firstPr() {
      showPr(0);
    }

    function previousPr() {
      if (vm.activePrIndex > 0) {
        showPr(--vm.activePrIndex);
      }
    }

    function nextPr() {
      if (vm.activePrIndex < vm.prList.length - 1) {
        showPr(++vm.activePrIndex);
      }
    }

    function lastPr() {
      showPr(vm.prList.length - 1);
    }

  }

})();

(function () {
  'use strict';

  angular.module('phenix').service('ReferenceMetierService', ReferenceMetierService);

  /** @ngInject */
  function ReferenceMetierService($translate,toastr) {
    this.getStockLabel = getStockLabel;
    this.showHideAppl = showHideAppl;
    this.setTaxCode = setTaxCode;

    var textStockDispo;
    var textStockIndispo;
    var textDispoPlaque;
    var translationError = 'Translation error';

    $translate('DOCUMENT_PR_STOCK').then(function (text) {
      textStockDispo = text;
    }, function () {
      toastr.error(translationError);
    });

    $translate('DOCUMENT_PR_INDISPO').then(function (text) {
      textStockIndispo = text;
    }, function () {
      toastr.error(translationError);
    });
    $translate('DOCUMENT_PR_DISPO_PLAQUE').then(function (text) {
      textDispoPlaque = text;
    }, function () {
      toastr.error(translationError);
    });


    function getStockLabel(piece) {
      if (piece.availabilities) {
        if (piece.availabilities.isStockPrincipal) {
          return piece.availabilities.quantity + textStockDispo;
        }
        return textDispoPlaque;
      }
      return textStockIndispo;

    }

    function showHideAppl(piece) {
      if (piece.showAppl) {
        piece.showAppl = !piece.showAppl;
      }
      else {
        piece.showAppl = true;
      }
      if (piece.alternative) {
        for (var i = 0; i < piece.alternative.length; i++) {
          if (piece.alternative[i].residual || (piece.alternative[i].codifiedSigns && piece.alternative[i].codifiedSigns.length)) {
            piece.alternative[i].showAppl = piece.showAppl;
          }
        }

      }

    }

    function setTaxCode(piece) {
      piece.taxCode = '';
      if (piece.cort) {
        var taille = piece.cort.length;
        piece.taxCode = piece.cort.substring(taille - 1, taille);
      }
    }
  }

})();

(function () {

    angular
        .module('phenix')
        .directive('threeDViewer', threeDViewer);


    /* @ngInject */
    function threeDViewer(blockUI, RestUpgrade, FeaturesConstants, $log, $translate, ProductMetierService, $mdDialog, toastr) {
        var directive = {
            templateUrl: 'app/components/products/product/threeDViewer.template.html',
            restrict: 'E',
            scope: {
                reference: '='
            },
            link: showThreeDImage
        };
        return directive;

        function showThreeDImage(scope) {
            blockUI.start();
            scope.isDataLoaded = false;
            var threedResp = ProductMetierService.getThreeDResp();
            fetch(threedResp)
                .then(function (response) {
                    return response.json();
                })
                .then(function (jsondata) {
                    scope.isDataLoaded = true;
                    scope.finalData = jsondata;
                    var iframe = document.getElementById("threeDViewerFrame")
                    var iframeHtml = '</script><script language="javascript">';
                    iframeHtml += '$(document).ready(function(){';
                    iframeHtml += 'var viewer = new CT_GLViewer(';
                    iframeHtml += JSON.stringify(scope.finalData);
                    iframeHtml += ',{buttons: true,';
                    iframeHtml += 'color: true,';
                    iframeHtml += 'view: "iso-z"});';
                    iframeHtml += '})';
                    var dataList = iframe.getAttribute("srcdoc").split("</script>");
                    dataList[1] += iframeHtml;
                    iframe.setAttribute("srcdoc", dataList.join("</script>"));
                    blockUI.stop();
                    scope.$apply();
                })
                .catch(function (error) {
                    $mdDialog.hide();
                    blockUI.stop();
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider
            .state(RoutesConstants.product, {
                url: '/product/:tab/:reference/:mainReference/plate/:plateIndex/ref/:refIndex',
                params: {
                    data: null,

                    /**
                     *   URL PATH
                     *
                     *   SQUASH TO AVOID '/'
                     */

                    reference: null,
                    mainReference: { value: null, squash: true },
                    plateIndex: null,
                    refIndex: null,
                    isFromDocPriv: false,
                    isFromDiagFileDetails: false,
                    systemDocSubMenu: null,
                    systemDocResponse:null
                },
                templateUrl: 'app/components/products/product/product.html',
                controller: 'ProductCtrl',
                controllerAs: 'productctrl'
            });
    }
})();

(function () {
    'use strict';


    angular
        .module('phenix')
        .controller('ProductCtrl', ProductCtrl);

    /** @ngInject */
    function ProductCtrl($scope, $q, ProductMetierService, blockUI, CacheService, $state, toastr,
        ProductSearchConstants, RoutingService, $translate, DealerManagerSystemeService, globalConstant,
        UtilsMetierService, $mdDialog, ListPieceConstants,CacheConstants,NavigationSieService,CarSearchResultConstants,
        RoutesConstants,DocumentsMetierService,ReferenceMetierService,MainMetierService,configConstantes,$log,$rootScope,
        DmsMetierService, ShoppingCartService, QuoteConstants, PartRequisitionConstants, ShoppingCartServiceConstant, $timeout) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        var characteristicIndex = 0;
        vm.loading = true;
        vm.user = {};
        vm.recapCarAPI = null;
        vm.product = null;
        vm.currentProduct = null;
        vm.canShowingFds = false;
        vm.canShowingReach = false;
        vm.sameRefOrKit = false; // TODO gestion reference equivalente et kits/collections
        vm.firstReference = null;
        vm.show3dDirective = false;
        vm.technicalOrderedCharacteristics = [];
        vm.isFamilyCodeRestricedForTechnicalCollection = false;
        var stockDetail;
        var centralStockQuantitySnapshot = 0;
        var centralStockRefreshTimer = null;
        vm.activeTab = 0;
        var countryExceptionArray = globalConstant.countryCurrencyException;
        vm.documentsHistory = [];
        vm.selectedPR = "";
        vm.is3DLoading = false;
        var cacheProfile = CacheService.getObject(CacheConstants.profil);
        vm.frCountry= cacheProfile ? cacheProfile.country : null;
        vm.isCountrySparc  = UtilsMetierService.isUserFromSparcCountry();
        vm.isUserDms = DealerManagerSystemeService.getHookResult();
        vm.isNDAssistantEnabled = UtilsMetierService.isNDChatBotEnabled();
        vm.isNavigatedfromDocPriv = false;
        vm.isAsomDocPrivUser = false;
       
        vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();      

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.search = search;
        vm.goToProductReplacement = goToProductReplacement;
        vm.getStockClassIconLocalReplacement = getStockClassIconLocalReplacement;
        vm.canShowingProductAdd = canShowingProductAdd;
        vm.getStockClass = getStockClass;
        vm.getStockClassIcon = getStockClassIcon;
        vm.getStockLabel = getStockLabel;
        vm.goToProduct = goToProduct;
        vm.goToProductFromPartLink = goToProductFromPartLink;
        vm.selectProductReplacement = selectProductReplacement;
        vm.tabSelected = tabSelected;
        vm.isDmsConnected = isDmsConnected;
        $scope.getPriceToDisplay = getPriceToDisplay;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.showDetailStock = showDetailStock;
        vm.showTheCort = showTheCort;
        vm.goToListPiece = goToListPiece;
        vm.backToPrevious = backToPrevious;
        vm.isMotrio = isMotrio;
        vm.isStandardExchange = isStandardExchange;
        vm.isTractionBattery = isTractionBattery;
        vm.isRemanufacturedMotrio = isRemanufacturedMotrio;
        vm.isValuePlus = isValuePlus;
        vm.isValuePlusPartNotPriced = isValuePlusPartNotPriced;
        vm.getSupersessionToolTip = getSupersessionToolTip;
        vm.getLocalSupersessionToolTip = getLocalSupersessionToolTip;
        vm.copyToClipboard = copyToClipboard;
        vm.isEcoValue = isEcoValue;
     

        /**
         *          BIND FOR TEST
         */

        vm.getSupersessionItems = getSupersessionItems;


        this.$onInit = function () {
            vm.user = CacheService.getUserProfile();
            vm.isIndependentUser = MainMetierService.isIndependantUser(vm.user.roles);
            vm.isDmsConnected = isDmsConnected();
            vm.isCentralStockPilot = isCentralStockPilot(vm.user);
            registerCentralStockQuantityListeners();
            $state.params.reference = ($state.params.reference || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
            var documentId = $state.params.reference || '';
            var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
            if (!tabIndex){
                var selectedPr = {
                    id: RoutesConstants.listPieceIndexPR,
                    data: { 'myRef': $state.params.reference, 'plateIndex': $state.params.plateIndex, 'refIndex': $state.params.refIndex }
                };

                CacheService.setObject(CacheConstants.tabIndex, selectedPr);
            }
            
           if( $state.params.plateIndex != null &&  $state.params.refIndex != null)
            {
                vm.documentsHistory = NavigationSieService.updateDocumentsHistory(documentId, 'PR', $state.params.plateIndex, $state.params.refIndex);
            }

            // set the active tab
            if ($state.params.tab) {
                vm.activeTab = $state.params.tab;
            }

            
			var channel = new BroadcastChannel("isFromDocPriv");
			channel.addEventListener("message", function(e) {
				vm.isNavigatedfromDocPriv = e.data;
                
			});
            
            vm.accessoriesPartWebsiteLink = getAccessoriesPartWebsiteLink;

            if ($state.params.data && $state.params.reference && $state.params.data.originalPartReference && ($state.params.reference === $state.params.data.originalPartReference)) {
                // came from product tab (user input)
                
                checkMotrio($state.params.data).then(function(response){
                    updateDataWithDMSData(response, $state.params.reference).then(function (res) {
                        copyResponseInControllerVar(res).finally(function () {
                            vm.loading = false;
                        });
    
    
                        vm.isFamilyCodeRestricedForTechnicalCollection = ProductMetierService.isTechnicalCollectionRestrained($state.params.data);
                        currentIndex();
                    })
                
                }).finally(function(){
                    if(cacheProfile.userType === "ARCA" || cacheProfile.userType === "RNET" || (cacheProfile.userType === "ASOM" && $rootScope.asomDocList['3D-ILL'])) {
                        call3DServices($state.params.reference);
                    }
                })
               
            } else {

                var reference = $state.params.reference;
                var mainReference = $state.params.mainReference;
                   
                blockUI.start();

                ProductMetierService.getReferenceInformation(reference, mainReference).then(function (response) {
                    return checkMotrio(response).then(function(res){
                        return updateDataWithDMSData(res, reference);
                    })
                    
                }).then(function (response) {
                    vm.isFamilyCodeRestricedForTechnicalCollection = ProductMetierService.isTechnicalCollectionRestrained(response);
                    return copyResponseInControllerVar(response).then(function () {
                        currentIndex();
                    });

                }).finally(function () {
                    if(cacheProfile.userType === "ARCA" || cacheProfile.userType === "RNET" || (cacheProfile.userType === "ASOM" && $rootScope.asomDocList['3D-ILL'])) {
                        call3DServices(reference);
                    }
                    if ($state.params.tab) {
                        var tabToRedirect = $state.params.tab;
                        tabSelected(tabToRedirect);
                    }
                    blockUI.stop();
                    vm.loading = false;
                }).catch(function () {
                    toastr.error($translate.instant('ERROR'));
                });
            }

        };

        
        function call3DServices(ref) {
            var cadUrl;
            var threeDArray = [];
            var threeDObj = {
                "partNumber": ref,
                "partRevisionLevel": "",
                "partVersion": "",
                "3dRepresentationFormat": "json",
                "levelOfGeometricDetail": "LOD0",
                "forceLargeConvertedCad": true,
            };
            threeDArray.push(threeDObj);
            var payLoad = {};
            _.assign(payLoad, { parts: threeDArray });
            vm.is3DLoading = true;
            
                ProductMetierService.getConvertedNewCad(payLoad).then(function (resp) {
                    if (resp && !_.isEmpty(resp.parts)) {
                        resp.parts.forEach(function (data) {
                            if (data.partNumber === ref) {
                                cadUrl = data['3dRepresentation'].convertedCad;
                            }
                        })
                    }
                    if (cadUrl) {
                        ProductMetierService.setThreeDResp(cadUrl);
                        if (vm.product.images) {
                            vm.product.images.unshift('../../../../assets/images/image3d.png');
                        } else {
                            vm.product.images = [];
                            vm.product.images.unshift('../../../../assets/images/image3d.png');
                        }
                        vm.index++;
                    } 
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                }).finally(function(){
                    vm.is3DLoading = false;
                })

            
        }
        
    
        function currentIndex(){
            if(vm.product && vm.product.illustrations && vm.product.illustrations.part){
                var idToSearch = "small";
                var newPictureFormat = "mediumx2";

                vm.index = _.findIndex(vm.product.images, function (piece) {

                    if (piece.includes(newPictureFormat)){               
                        return piece.includes(newPictureFormat);
                    }

                    else {
                        return piece.includes(idToSearch);
                    }
                   
                })
            }
        }

        function isMotrio(types){
            if(_.includes(types,ProductSearchConstants.motrio)){
                return true;
            }
            return false;
        }

        function isStandardExchange(types){
            if(_.includes(types,ProductSearchConstants.standardExchange)){
                return true;
            }
            return false;
        }

        function isTractionBattery(familyCode){
            return familyCode === ListPieceConstants.tractionBatteryFamilyCode;
        }

        function isValuePlus(types){
            if(_.includes(types,ProductSearchConstants.valuePlus)){
                return true;
            }
            return false;
        }

        function isEcoValue(types){
            return _.includes(types,ProductSearchConstants.ecoValue);
        }

        function isRemanufacturedMotrio(types, familyCode){
            var isMotrioPart = _.includes(types, ProductSearchConstants.motrio);
            var hasRemanFamilyCode = familyCode && _.includes(ListPieceConstants.remanufacturedFamilyCodes, familyCode);
            return isMotrioPart && hasRemanFamilyCode;
        }
        
        function goToListPiece() {
            NavigationSieService.goToFirstElement();
            if (CacheService.getObject(CacheConstants.tabIndex)) {
                getSelectedPr();
               removeSelectedPr();
           }
        }

        function backToPrevious() {
            if ($state.params.isFromDiagFileDetails) {
                const selectedDiagFileIdCache = CacheService.getObject(CacheConstants.selectedDiagFileId);

                $rootScope.$broadcast("isFromDiagFileDetails", {
                    tab: CarSearchResultConstants.searchTypes.searchByDiagnostic,
                    isFromDiagFileDetails: true,
                    selectedDiagFileId: selectedDiagFileIdCache,
                    systemDocSubMenu: $state.params.systemDocSubMenu,
                    systemDocResponse: $state.params.systemDocResponse
                });

                if (CacheService.getObject(CacheConstants.tabIndex)) {
                    removeSelectedPr();
                }
            }
            else {
                NavigationSieService.backToPrevious();
                if (CacheService.getObject(CacheConstants.tabIndex)) {
                    getSelectedPr();
                    removeSelectedPr();
                }
            }
        }

        function getSelectedPr(){
            vm.selectedPR = CacheService.getObject(CacheConstants.tabIndex).data.myRef;
        }
       
       function removeSelectedPr(){
           CacheService.removeObject(CacheConstants.tabIndex);
        }
        function checkMotrio(response){

                var partsMotrios = {
                    central: [],
                    local: []
                };

                var newPartLinks = [];
                if (response.partLinks && response.partLinks.length > 0) {
                    newPartLinks  = response.partLinks;
                    //parse motrio list to return promise for each plate
                    var promises = newPartLinks.map(function (partLinkPart) {
                        if( _.includes(partLinkPart.types,ProductSearchConstants.motrio)){
                            return checkMotrioPlate(partLinkPart.partNumber, partsMotrios).then(function (partsMotriosResponse) {

                                    var newPartLinksMotrio = _.filter(newPartLinks, function(item){
                                        return _.includes(item.types,ProductSearchConstants.motrio); 
                                    });
                                    if ((partsMotriosResponse.central.length + partsMotriosResponse.local.length) === newPartLinksMotrio.length) {
                                        newPartLinks = manageDisplayingMotrioParts(newPartLinks, partsMotriosResponse);
                                    }
                                
                                return partLinkPart;
                            });
                        }
                    })

                    return Promise.all(promises).then(function(data){
                        response.partLinks = newPartLinks;
                        return $q.resolve(response); 
                    })
                    
                
                }else{
                    return $q.resolve(response); 
                }
                
                

        }

        function checkMotrioPlate(motrioItem, partsMotrios) {
            return ProductMetierService.getReferenceInformationRaw(motrioItem).then(function (partResponse) {
                    if (isCentralMotrioPart(partResponse)) {
                    
                        partsMotrios.central.push(
                            {
                                reference: motrioItem,
                                priceExclTaxes: partResponse.priceWithoutTaxes,
                                currency: partResponse.currency,
                                familyCode: partResponse.familyCode
                            }
                        );
                    
                    }
                    else if (isLocalMotrioPart(partResponse)) {
                        
                        partsMotrios.local.push(
                            {
                                reference: motrioItem,
                                priceExclTaxes: partResponse.priceWithoutTaxes,
                                currency: partResponse.currency,
                                familyCode: partResponse.familyCode
                            }
                        );

                    
                    }
                return $q.resolve(partsMotrios);
            });
        }
        function checkMotrioPart(partsMotrios, partLinks) {
            partsMotrios.forEach(function (partMotrioItem) {
                var existingPart = getMotrioPartNotPriced(partLinks, partMotrioItem);
                if (existingPart) {
                    partLinks = deleteMotrioPart(partLinks, existingPart);
                }
            });
            return partLinks;
        }
        function getMotrioPartNotPriced(partLinks, partMotrioItem) {
            return _.find(partLinks, function (partLinks) { return isMotrioPartNotPriced(partMotrioItem, partLinks); });
        }
        function isMotrioPartNotPriced(partMotrioItem, partLinks) {
            return (partMotrioItem.reference === partLinks.partNumber) && (!partMotrioItem.priceExclTaxes ||
                 _.isEmpty(partMotrioItem.priceExclTaxes.toString()));
        }
        function deleteMotrioPart(partLinks, existingPart) {
            var index = _.findIndex(partLinks, function (o) { return o.partNumber == existingPart.partNumber; });
            partLinks.splice(index, 1);
            return partLinks;
        }

        function isLocalMotrioPart(partResponse) {
            return partResponse.corporate === ListPieceConstants.motrioType.local;
        }
        function isCentralMotrioPart(partResponse) {
            return partResponse.corporate === ListPieceConstants.motrioType.central.Yes || partResponse.corporate === ListPieceConstants.motrioType.central.NotSure;
        }
        function manageDisplayingMotrioParts(partLinks, partsMotrios) {
            var partLinksLength;

            var motrioLinkParts = _.filter(partLinks, function(item){
                return _.includes(item.types,ProductSearchConstants.motrio);
            });
            partLinksLength = motrioLinkParts.length;
            
            //manage case having only central and no local
            if (partsMotrios.central.length >= 1 && partsMotrios.local.length == 0) {
                partLinks = checkMotrioPart(partsMotrios.central, partLinks);
                
            }
            //manage case having only local and no central
            else if (partsMotrios.local.length >= 1 && partsMotrios.central.length == 0) {
                partLinks = checkMotrioPart(partsMotrios.local, partLinks);
              
            }
            //manage case having central and local
            else if (partsMotrios.local.length >= 1 && partsMotrios.central.length >= 1) {
                partLinks = checkMotrioPart(partsMotrios.local, partLinks);
                var motrioParts;
                    motrioParts = _.filter(partLinks, function(item){
                        return _.includes(item.types,ProductSearchConstants.motrio); 
                    });
                
                if (motrioParts.length === (partLinksLength - partsMotrios.local.length)) {
                    //check centrals motrio if we dont't have any priced local motrio
                    partLinks = checkMotrioPart(partsMotrios.central, partLinks);
                }
                else {
                    //delete all central motrio if we have at least one priced local motrio
                    partsMotrios.central.forEach(function (currentCentralMotrio) {
                        var index = _.findIndex(partLinks, function (o) { return o.partNumber == currentCentralMotrio.reference; });
                        if(index !== -1){
                            partLinks.splice(index, 1);
                        }
                    })
                }
            }

            return partLinks;
        }

        function updateDataWithDMSData(part, reference) {
            if (vm.isDmsConnected) {
                vm.loadingDMS = true;

                // all references should be in supersessions
                var payload = ProductMetierService.getReferencesFromSuperSessions(part.supersessions);
                return ProductMetierService.getReferenceInformationFromDMS(payload).then(function (DMSReponse) {
                    var partUpdated = _.assign({}, part);
                    var DMSInformations = ProductMetierService.getDMSPartData(DMSReponse.response.parts, reference);
                    partUpdated.corporateDesignation = partUpdated.designation;

                    if (DMSInformations.description) {
                        partUpdated.designation = DMSInformations.description;
                    }

                    if (DMSInformations.availabilities) {
                        stockDetail = angular.copy(DMSInformations.availabilities);
                        _.remove(stockDetail, function (item, indice) {
                            return item.stockId === 0 || item.quantity === 0 && indice > 0;
                        });
                    }
                    partUpdated.dmsInformations = DMSInformations;
                    // update replacementlist and add some informations on the current piece
                    if (Array.isArray(partUpdated.supersessions)) {
                        partUpdated.supersessions = ProductMetierService.addInformationsOnSuperSessions(partUpdated.supersessions, DMSReponse.response.parts);
                    }

                    // fill dmsInformation in each additional part
                    if (Array.isArray(partUpdated.additional)) {
                        partUpdated.additional = partUpdated.additional.map(function (part) {
                            var dmsData = ProductMetierService.getDMSPartData(DMSReponse.response.parts, partUpdated.reference);
                            var designation = part.designation;
                            // override part designation
                            if (dmsData) {
                                part.designation = dmsData.description;
                            }

                            return _.assign({}, part, {
                                dmsInformations: dmsData,
                                description: designation
                            });
                        });
                    }
                    return partUpdated;
                }).catch(function () {
                    vm.errorDMS = true;
                    return part;
                }).finally(function () {
                    vm.loadingDMS = false;
                });
            } else {
                return $q.resolve(part);
            }
        }

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function showTheCort() {
            var productCort;
            if (vm.product && vm.product.dmsInformations && vm.product.dmsInformations.cort) {
                productCort = vm.product.dmsInformations.cort;
            } else if (vm.product.taxCode || vm.product.discountCode) {
                productCort = "--" + (vm.product.discountCode || "-") + (vm.product.taxCode || "-");
            } else {
                productCort = "----";
            }
            return productCort;
        }

        function showDetailStock() {
            $mdDialog.show({
                controller: "stockPopinCtrl",
                templateUrl:
                    "app/core/components/stockPopin/stockPopin.template.html",
                clickOutsideToClose: true,
                locals: {
                    stockDetail: stockDetail
                },
                bindToController: true,
                controllerAs: "vm"
            });
        }

        function isDmsConnected() {
            return DealerManagerSystemeService.getHookResult();
        }

        function isCentralStockPilot(user) {
            if (!user || !user.dealerId) {
                return false;
            }
            var isRnet = MainMetierService.isRnetUserType(user.userType);
            return isRnet && _.includes(ListPieceConstants.centralStockPilotDealers, user.dealerId);
        }

        function fetchCentralStockForPilot() {
            if (!vm.isCentralStockPilot || !vm.product) { return; }
            var dealer = resolveCentralStockDealer();
            if (!dealer) { return; }

            var pieceLikeList = [vm.product];
            var stockRefs = DmsMetierService.getAllReferencesForStock(pieceLikeList);
            if (_.isEmpty(stockRefs)) { return; }

            vm.loadingCentralStock = true;
            ShoppingCartService.getCentralStockDetails(stockRefs, dealer.cachedetail, dealer.dealerId).then(function (stockResponse) {
                DmsMetierService.attachCentralStockInfo(pieceLikeList, stockResponse, vm.isDmsConnected);
                centralStockQuantitySnapshot = getCentralStockQuantity(vm.product);
            }).finally(function () {
                vm.loadingCentralStock = false;
            });
        }

        function resolveCentralStockDealer() {
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            if (cachedetail && !_.isEmpty(cachedetail.dealers)) {
                return { cachedetail: cachedetail, dealerId: cachedetail.dealers[0].dealerId };
            }
            if (vm.user && vm.user.dealerId) {
                return { cachedetail: { r1: false }, dealerId: vm.user.dealerId };
            }
            return null;
        }

        function getCentralStockQuantity(part) {
            if (!part) { return 0; }
            var quote = parseInt(part.estimateQuantity, 10);
            var requisition = parseInt(part.quantity, 10);
            return Math.max(quote > 0 ? quote : 0, requisition > 0 ? requisition : 0);
        }

        function registerCentralStockQuantityListeners() {
            if (!vm.isCentralStockPilot) { return; }
            var events = [
                QuoteConstants.quoteUpdatedEvent,
                PartRequisitionConstants.partsRequisitionCreatedEvent,
                PartRequisitionConstants.partsRequisitionUpdatedEvent,
                ShoppingCartServiceConstant.events.cartUpdated
            ];
            var unregisterFns = _.map(events, function (eventName) {
                return $rootScope.$on(eventName, scheduleCentralStockRefresh);
            });
            $scope.$on('$destroy', function () {
                angular.forEach(unregisterFns, function (unregister) { unregister(); });
                if (centralStockRefreshTimer) { $timeout.cancel(centralStockRefreshTimer); }
            });
        }

        function scheduleCentralStockRefresh() {
            if (centralStockRefreshTimer) { $timeout.cancel(centralStockRefreshTimer); }
            centralStockRefreshTimer = $timeout(refreshCentralStockForChangedQuantity, 400);
        }

        function refreshCentralStockForChangedQuantity() {
            if (!vm.isCentralStockPilot || !vm.product || !vm.product.reference) { return; }
            var current = getCentralStockQuantity(vm.product);
            if (current === centralStockQuantitySnapshot) { return; }
            centralStockQuantitySnapshot = current;

            var dealer = resolveCentralStockDealer();
            if (!dealer) { return; }

            var pieceLikeList = [vm.product];
            var quantityByRef = {};
            quantityByRef[vm.product.reference] = current;
            var stockRefs = DmsMetierService.getAllReferencesForStock(pieceLikeList, quantityByRef);
            if (_.isEmpty(stockRefs)) { return; }

            ShoppingCartService.getCentralStockDetails(stockRefs, dealer.cachedetail, dealer.dealerId)
                .then(function (stockResponse) {
                    DmsMetierService.attachCentralStockInfo(pieceLikeList, stockResponse, vm.isDmsConnected, true);
                });
        }

        function copyResponseInControllerVar(response) {
            vm.product = response;
            var promise;

            /**
             *    UPDATE PRODUCT
             */

            vm.product.reference = vm.product.originalPartReference;
            vm.product.designation = vm.product.designation;
            vm.product.priceExclTaxes = vm.product.priceWithoutTaxes;



            if (response.supersessions && response.supersessions != []) {
                vm.product.additional = getSupersessionItems(response.supersessions, vm.product.reference);
                vm.canShowingAdditional = vm.product.additional.length ? true : false;
            }

            /**
             *    Business rules to authorize data display
             */

            if (vm.product && vm.product.technicalInformations) {
                vm.canShowTechnical = showTechnicalInformations(vm.product.technicalInformations);
                if (vm.canShowTechnical) {
                    if (vm.product.technicalInformations.part && vm.product.technicalInformations.part.length > 0) {
                        vm.product.technicalInformations = vm.product.technicalInformations['part'];
                    } else if (vm.product.technicalInformations.model && vm.product.technicalInformations.model.length > 0) {
                        vm.product.technicalInformations = vm.product.technicalInformations['model'];
                    } else if (vm.product.technicalInformations.family && vm.product.technicalInformations.family.length > 0) {
                        vm.product.technicalInformations = vm.product.technicalInformations['family'];
                    }
                }
            }
            //BIPA Products Description
            if (vm.product && vm.product.productsDescription) {
                vm.canShowproductsDescription = showproductsDescription(vm.product.productsDescription);
                if (vm.canShowproductsDescription) {
                    if (vm.product.productsDescription.part && vm.product.productsDescription.part.length > 0) {
                        vm.product.productsDescriptions = vm.product.productsDescription['part'];
                    } else if (vm.product.productsDescription.model && vm.product.productsDescription.model.length > 0) {
                        vm.product.productsDescriptions = vm.product.productsDescription['model'];
                    } else if (vm.product.productsDescription.family && vm.product.productsDescription.family.length > 0) {
                        vm.product.productsDescriptions = vm.product.productsDescription['family'];
                    }
                }
            }
            

            if (vm.product && vm.product.technicalCharacteristics) {
                vm.canShowCharacteristics = showTechnicalCharacteristics(vm.product.technicalCharacteristics);
                 vm.showRenativePicto = checkRenativeCharacteristic(vm.product.technicalCharacteristics);
            }

            if (vm.product && vm.product.unitOfSales) {
                vm.canShowUnitOfSales = showTechnicalUnitOfSales(vm.product.unitOfSales);
            }

            if(vm.product && vm.product.laborTimeSparc){
                vm.canShowLaborTimeSparc = showLaborTimeSparc(vm.product.laborTimeSparc);
            }

            if (vm.product && vm.product.safetyFlag) {
                vm.canShowingFds = true;
                vm.fdsDocument = linkToFds();
            }

            if (vm.product && vm.product.reach) {
                vm.canShowingReach = true;
            }

            vm.codifiedSigns = filterValidCodifiedSigns(vm.product.codifiedSigns);
            vm.replacementList = vm.product.supersessions;


            // to display parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=4
            // and for the brand APL05/BRA05 and age >= 3

                if (vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV){
                    vm.isAsomDocPrivUser = true;
                    vm.product.partLinks = vm.product.partLinks.filter(function(item){
                        return item.types == "standardExchange";
                    })
                }

            if(!_.isEmpty(vm.product.partLinks) && vm.product.partLinks.length > 0){
                for(var i =vm.product.partLinks.length - 1;i >= 0;i--){
                    if((isMotrio(vm.product.partLinks[i].types) || isValuePlus(vm.product.partLinks[i].types))
                         && !(DocumentsMetierService.brandAgeAcceptable("4","3"))){
                        vm.product.partLinks.splice(i,1);
                    }
                }
            }

               return $q.resolve().then(function(){
                    // to filter by price for SPARC countries
                    if(vm.isCountrySparc && vm.product.partLinks.length > 0){
                        var promises = [];
                        for(var j =vm.product.partLinks.length - 1;j >= 0;j--){
                            if(_.includes(vm.product.partLinks[j].types,ProductSearchConstants.valuePlus) || _.includes(vm.product.partLinks[j].types,ProductSearchConstants.standardExchange)){
                                promises.push(isValuePlusPartNotPriced(vm.product.partLinks[j].partNumber));
                            }
                        }

                        return $q.all(promises).then(function(response){
                            response.forEach(function(item){
                                _.remove(vm.product.partLinks,function(ref){
                                    return ref.partNumber === item.partNumber && item.isNotPriced;
                                })
                            })
                            return;
                        })
                    }else{
                        return;
                    }
                }).then(function(){
                    
                    // to sort parts with Motrio & Value+ only for the brand APL03/BRA03 and age >=5
                    // and for the brand APL05/BRA05 and age >= 3
                    if(!_.isEmpty(vm.product.partLinks) && vm.product.partLinks.length > 0){
                    vm.product.partLinks = vm.product.partLinks.sort(DocumentsMetierService.customCompareBrands(ListPieceConstants.typesField));
                    }
                    fetchCentralStockForPilot();
                    promise = $q.resolve();
                    return promise;
                })
            
        }


        /**
         * @desc To get the price of the part from DH if not from DMS
         *       and return if part is having price or not
         * @param {*} partNumber 
         */
        function isValuePlusPartNotPriced(partNumber){

            return ProductMetierService.getReferenceInformationRaw(partNumber).then(function (partResponse) {

                var partDetails =  {
                    reference: partNumber,
                    priceExclTaxes: partResponse ? partResponse.priceWithoutTaxes : 0,
                    currency: partResponse ? partResponse.currency : ''
                };

                return partDetails;

            }).then(function(partDetails){

                if(!partDetails.priceExclTaxes || _.isEmpty(partDetails.priceExclTaxes.toString())){
                    return ProductMetierService.getReferenceInformationFromDMS(partNumber).then(function(dmsResponse){

                        if(dmsResponse && dmsResponse.returnCode === 0){
                            var dmsData = (dmsResponse.response && dmsResponse.response.parts && dmsResponse.response.parts.length > 0) ? dmsResponse.response.parts : null;
                            if(dmsData && !_.isEmpty(dmsData)){
                            dmsData.forEach(function(item){
                                if(item.reference === partDetails.reference){
                                    partDetails.priceExclTaxes = item.priceExclTaxes;
                                }
                            })
                            }
                            return {
                                partNumber : partNumber,
                                isNotPriced : !partDetails.priceExclTaxes || _.isEmpty(partDetails.priceExclTaxes.toString())
                            }
                        }
                            return {
                                partNumber : partNumber,
                                isNotPriced : true
                            }
                        
                    })
                }
                        
                return {
                    partNumber : partNumber,
                    isNotPriced : !partDetails.priceExclTaxes || _.isEmpty(partDetails.priceExclTaxes.toString())
                }; 

            })

               
        }
        /**
         *  @desc   replacementList is always fill with at least 1 element.
         *          When we have only 1 replacement, we must check whether
         *          supersedingPart field exist and on every object inside `additionnal`
         *          which may contains supersedingPart field too
         *          Otherwise, it's hidden
         *
         *
         *  @param {Array<object>} replacementList
         *  @return {boolean}
         */

        vm.displayReplacement = displayReplacement;

        function displayReplacement(replacementList) {
            if (_.isEmpty(replacementList) || !Array.isArray(replacementList)) {
                return false;
            }

            // If replacementList contains only 1 element, that means
            // we must check if they is an supersedingPart field inside it.
            // additionnal contains a list of part which may contains supersedingPart field too
            // otherwise it's hidden

            if (replacementList.length === 1) {
                var hasLocalReplacement = _.get(replacementList, ['0', 'supersedingPart']);
                var PPS = _.get(replacementList, ['0', 'additionnal']);
                var hasLocalReplacementOnPPS = Array.isArray(PPS) && !_.isEmpty(PPS) && PPS.some(function (pps) {
                    return pps.supersedingPart;
                });

                if (!hasLocalReplacement && !hasLocalReplacementOnPPS) {
                    return false;
                }
            }

            return true;
        }

        /**
         * Format the string with price and currency to be displayed
         * @param piece
         * @returns {string}
         */
        function getPriceToDisplay() {
            var price = UtilsMetierService.getPriceToDisplay(
                vm.product.priceExclTaxes, !vm.product.dmsInformations ? null : vm.product.dmsInformations.priceExclTaxes);
            return price;
        }

        /**
         * @name getCurrencyForItem
         * @desc get curency to diaplay
         * @returns {string}
         */
        function getCurrencyForItem() {
            var infoDms = _.get(vm.product, ['dmsInformations', 'description']);
            if (infoDms) {
                return UtilsMetierService.getCurrencyForItem(infoDms);
            } else {
                return UtilsMetierService.getCurrencyForItem();
            }
        }

        function checkRenativeCharacteristic(technicalCharacteristics) {
            if (!technicalCharacteristics || !Array.isArray(technicalCharacteristics)) {
                return false;
            }

            var renativeCharacteristic = _.find(technicalCharacteristics, function (characteristic) {
                return characteristic.codeTechnicalCharacteristic === "2842" &&
                    (characteristic.value.toLowerCase() === "yes" || characteristic.value.toLowerCase() === "oui");
            });

            return renativeCharacteristic;
        }

        /**
         * showTechnicalInformations
         * return true if any of the technicalinformation children are not empty
         * @param {object} technicalInformations
         * @returns {boolean}
         */
        function showTechnicalInformations(technicalInformations) {
            var show = false;
            for (var criteria in technicalInformations) {
                if (technicalInformations[criteria].length > 0) {
                    show = true;
                }
            }
            return show;
        }


        /**
        * showproductsDescription
        * return true if any of the productsDescription children are not empty
        * @param {object} productsDescription
        * @returns {boolean}
        */
        function showproductsDescription(productsDescription) {
            var show = false;
            for (var criteria in productsDescription) {
                if (productsDescription[criteria].length > 0) {
                    show = true;
                }
            }
            return show;
        }
        /**
         * showTechnicalUnitOfSales
         * return true if any of the technicalinformation children are not empty
         * @param {object} technicalInformations
         * @returns {boolean}
         */
        function showTechnicalUnitOfSales(unitOfSales) {
            var show = false;
            if (unitOfSales.length > 0) {
                show = true;
            }
            return show;
        }

        /**
         * showLaborTimeSparc
         * return true if laborTimeSparc is having hours other than 0,0 / empty / null
         * @param {object} laborTimeSparc 
         * @returns {boolean}
         */
        function showLaborTimeSparc(laborTimeSparc) {

            if(!_.isEmpty(laborTimeSparc) && typeof laborTimeSparc === 'string' && laborTimeSparc !== '0,0' && laborTimeSparc !== '0.0'){
                return true;
            }

            return false;
        }

        /**
         * Reorder incoming technicalCharacteristics base on business ruless
         * group every characteristics by groups of ordered array
         * Array with order = 0 value had to be at the end
         * @param technicalCharacteristics from datahub
         * @return newly ordered technicalOrderedCharacteristics
         * * usage productCharacteristicOrder(technicalCharacteristics);
         */
        function productCharacteristicOrder(technicalCharacteristics) {
            var newArray = [];
            var temp = [];
            var groups = _.groupBy(technicalCharacteristics, ProductSearchConstants.sortByOrder);
            for (var key in groups) {
                if (groups.hasOwnProperty(key)) {
                groups[key].sort(function (a, b) {
                    var x = a.label, y = b.label;
                    return x === y ? 0 : x < y ? -1 : 1;
                });
            }
        }

            for (var i = 0; i < Object.keys(groups).length; i++) {
                if (Object.keys(groups)[i] == 0 && Object.keys(groups).length === 1) {
                    newArray.push(groups[Object.keys(groups)[i]])
                }

                if (Object.keys(groups)[i] == 0) {
                    temp = groups[Object.keys(groups)[i]];
                    //groups.push(temp);
                    //delete groups(Object.keys(groups)[i]);
                } else {
                    if (i == Object.keys(groups).length - 1 && temp != undefined && temp.length !== 0) {
                        newArray.push(groups[Object.keys(groups)[i]]);
                        newArray.push(temp);
                    } else {
                        newArray.push(groups[Object.keys(groups)[i]]);
                    }
                }
            }
            return newArray;
        }

        /**
         * showTechnicalInformations
         * return true if technicalCharacteristics is not empty
         * @param {object} technicalCharacteristics
         * @returns {boolean}
         */
        function showTechnicalCharacteristics(technicalCharacteristics) {
            var show = false;

            if (technicalCharacteristics.length > 0) {
                show = true;
            }

            var orderedCharacteristics = productCharacteristicOrder(technicalCharacteristics);
            vm.technicalOrderedCharacteristics = flatten(orderedCharacteristics, []);

            //reset characteristicIndex
            characteristicIndex = 0;
            return show;
        }

        /**
         * flatten arrays to return only one array
         * add index as id to the new array
         * @param arrayToflatten, result
         * @return flattened array
         * *
         */
        function flatten(arrayToFlatten, result) {
            arrayToFlatten.map(function (value) {
                if (Array.isArray(value)) {
                    flatten(value, result);
                } else {
                    value.id = characteristicIndex;
                    result.push(value);
                    characteristicIndex++;
                }
            });
            return result;
        }

        /**
         * Return valid certified signs.
         * @param {codifiedSigns} object - The codifiedSigns object.
         * @return {object} Valid codified signs while value different SC000BRP and SC000ERP.
         * * usage filterValidCodifiedSigns(codifiedSigns);
         */
        function filterValidCodifiedSigns(codifiedSigns) {
            var acceptedCodifiedSigns = [];
            var formatedCodifiedSigns = {};


            if (codifiedSigns !== undefined && codifiedSigns.length > 0) {
                codifiedSigns.forEach(function (element) {
                    if (element.value !== 'SC000ERP' && element.value !== 'SC000BRP') {
                        acceptedCodifiedSigns.push(element);
                    }

                });
            }
            acceptedCodifiedSigns.forEach(function (elem) {
                if (formatedCodifiedSigns[elem.value]) {
                    formatedCodifiedSigns[elem.value].textAssociated += "| " + elem.textAssociated;
                } else {
                    formatedCodifiedSigns[elem.value] = { "designation": elem.designation, "textAssociated": elem.textAssociated };
                }
            })

            return formatedCodifiedSigns;
        }

        function tabSelected(tabIndex) {
            vm.activeTab = tabIndex;
            $state.transitionTo($state.$current.name, { tab: tabIndex }, {
                location: "replace",
                inherit: true,
                relative: $state.$current,
                notify: false
            });
        }

        /**
         * goToProduct
         * @param {object} piece
         * @returns {CacheService}
         */

        function goToProduct(piece) {
            var path = {
                reference: piece.reference.toUpperCase(),
                mainReference: null
            }
            RoutingService.goToProductPage({
                path: path
            });
        }

        /**
         * goToProduct
         * @param {object} piece
         */

        function goToProductReplacement(piece) {
            var reference = piece.reference.toUpperCase();
            var path = {
                reference: reference,
                mainReference: reference
            }
            RoutingService.goToProductPage({
                path: path
            });
        }


        /**
         * Utilisé pour les partLinks car la base de la piece n'est pas la meme.
         * Trouver une autre solution?
         *
         * goToProductFromPartLink
         * @param {object} partLink
         */
        function goToProductFromPartLink(partLink) {
            var path = {
                reference: partLink.partNumber,
                mainReference: null
            };
            RoutingService.goToProductPage({
                path: path
            });
        }

        /**
         * building and return an url to a fds doc
         */
        function linkToFds() {
            var urlBase = ProductSearchConstants.baseUrlToFds;
            var companyName = "Renault";
            var clientName = vm.user.ipn;
            var email = vm.user.emailAlerte;
            var view = "Pdf";
            var languages = checkLanguageAvailable(vm.user.documentationFirstLanguage.code);
            var consultLang = languages[0];
            var accountLang = languages[1];
            var idClient = vm.user.ipn;
            var idProduct = vm.product.reference;
            var plus = "";
            var spdf = "";
            var affOne = "N";
            var urlConstructed = urlBase + "NSoc=" + companyName + "&NCli=" + clientName + "&EMai=" + email
                + "&View=" + view + "&Lang=" + consultLang + "&NFou=" + accountLang + "&CCli=" + idClient
                + "&NPro=" + idProduct + "&Plus=" + plus + "&SPdf=" + spdf + "&AffOne=" + affOne;
            return urlConstructed;
        }


        function checkLanguageAvailable(docFirstLanguage) {
            var availableLang = ["de", "es", "fr", "en", "it", "nl", "pl", "pt", "ro", "tr"];
            var lang = vm.user.documentationSecondLanguage.code;
            var accountLang = "RENAULT_PI." + docFirstLanguage.toUpperCase();
            angular.forEach(availableLang, function (value) {
                if (value === docFirstLanguage) {
                    if (docFirstLanguage === "de") {
                        lang = "GR";
                    } else {
                        lang = docFirstLanguage.toUpperCase();
                    }
                }
            });
            return [lang, accountLang];
        }

        /**
         * search
         * @returns {state}
         */
        function search() {
            $state.go(RoutingService.carSearch);
        }

        /**
         * canShowingProductAdd
         * @returns {Service}
         */
        function canShowingProductAdd() {
            return ProductMetierService.canShowingProductAdd();
        }

        function selectProductReplacement(selectedReference) {
            blockUI.start();
            ProductMetierService.getReferenceInformation(selectedReference, vm.product.supersessionRootReference).then(function (response) {
                response.images = _.filter(response.images, function(item){
                return _.includes(item,'small');
                })
                return checkMotrio(response).then(function(res){
                    return updateDataWithDMSData(res, selectedReference);
                })
                
            }).then(copyResponseInControllerVar).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }


        /**
         * getStockClass
         * @param {object} additipieceonal
         * @returns {string}
         */
        function getStockClass(piece) {
            if ((piece.availabilities) && (vm.piece.availabilities.quantity > 0)) {
                return 'stockDispo';
            }
            return 'stockIndispo';
        }


        /**
         *  @param {int} quantity
         *  @returns {string}
         */
        function getStockClassIcon(quantity) {
            if (quantity > 0) {
                return 'icon-icons_stock_available';
            } else if (quantity === 0) {
                return 'icon-icons_stock_unavailable';
            }
            return '';
        }

        /**
         * 
         * @param {int} quantity 
         * @returns {string}
         */
        function getSupersessionToolTip(quantity){
            if (quantity > 0) {
                return $translate.instant('SUPERSESSION_STOCK_AVAILABLE');
            } else if (quantity === 0) {
                return $translate.instant('SUPERSESSION_STOCK_UNAVAILABLE');
            }
            return '';
        }

        /**
         *  @param {array} availabilities
         *  @return {string}
         */

        function getStockClassIconLocalReplacement(availabilities) {
            var localReplacementClass = "icon-icons_stock_unavailable"
            if (Array.isArray(availabilities) && !_.isEmpty(availabilities)) {
                // Quantity can be negatif
                if (_.isNumber(availabilities[0].quantity) && availabilities[0].quantity > 0) {
                    localReplacementClass = "icon-icons_stock_available";
                }
            } return localReplacementClass;
        }

        /**
         * 
         * @param {array} availabilities 
         * @returns {string}
         */
        function getLocalSupersessionToolTip(availabilities){

            var localStockAvailability = $translate.instant('SUPERSESSION_STOCK_UNAVAILABLE');
            if (Array.isArray(availabilities) && !_.isEmpty(availabilities)) {
                // Quantity can be negatif
                if (_.isNumber(availabilities[0].quantity) && availabilities[0].quantity > 0) {
                    localStockAvailability = $translate.instant('SUPERSESSION_STOCK_AVAILABLE');
                }
            } return localStockAvailability;

        }


        /**
         * getStockLabel
         * @param {object} piece
         * @returns {Service}
         */
        function getStockLabel(piece) {
            return ReferenceMetierService.getStockLabel(piece);
        }


        /**
         * getSupersessionItems
         * @param {array} pieces can contains additional object if have supersessions
         * @param {string} reference actual reference of product
         * @IN [
         {
                    "mainReference": "8200433519",
                    "originReference": true
                },
         {
                    "mainReference": "7703002599",
                    "quantity": 1,
                    "type": "PARTIAL",
                    "bestSupersession": false,
                    "additional": [
                        {
                            "quantity": 1,
                            "additionalReference": "8200826818",
                            "bestSupersession": true,
                            "rank": 2,
                            "type": "PARTIAL",
                            "additionalDesignation": "STEERING COLUMN",
                            "additionalDesignationLanguage": "en",
                            "$$hashKey": "object:41"
                        },
                        {
                            "quantity": 1,
                            "additionalReference": "8200751231",
                            "bestSupersession": true,
                            "rank": 3,
                            "type": "PARTIAL",
                            "additionalDesignation": "SEE TECHNICAL",
                            "additionalDesignationLanguage": "en",
                            "$$hashKey": "object:42"
                        }
                    ],
                    "mainDesignation": "FLGD EXT TORX SCREW  M8X125 10-9 SA3GS",
                    "mainDesignationLanguage": "en",
                    "additionalList": true
                },
         ]
         * @returns {array} supersessions items for the current reference
         * @OUT [
         {
                    "ratio": 1,
                    "reference": "8200826818",
                    "$$hashKey": "object:105"
                },
         {
                    "ratio": 1,
                    "reference": "8200751231",
                    "$$hashKey": "object:106"
                }
         ]
         */

        function getSupersessionItems(pieces, reference) {
            var supersessionsList = [];
            var isCurrentPiece = _.find(pieces, function (piece) {
                return piece.mainReference === reference;
            });


            if (isCurrentPiece && isCurrentPiece.additional && isCurrentPiece.additional.length) {
                supersessionsList = isCurrentPiece.additional.map(function (part) {
                    return {
                        designation: part.additionalDesignation,
                        reference: part.additionalReference,
                        ratio: part.ratio || 1
                    }
                });
            }
            return supersessionsList
        }
        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        function getAccessoriesPartWebsiteLink() {
            const language = vm.user.documentationFirstLanguage.code === 'fr' ? 'fr' : 'en';
            return `${ProductSearchConstants.accessoriesPartWebsiteLink}${language}/${vm.product.reference}`;
        }
    }
})();

'use strict';

angular.module('phenix').constant('ProductSearchConstants', {


    dmsReferences: '/references.v1',
    documentationProducts: '/proxy/apidh/rest/v1/parts',
    stoppedRangeCatalog: '/documentation/catalog',
    baseUrlToFds: 'https://www.quickfds.com/cmt_bin/wfds-afflist?',
    sortByOrder: 'order',
    technicalCollectionFamilyRestriction: [681, 870, 871],
    motrio: 'motrio',
    standardExchange: 'standardExchange',
    valuePlus: 'valuePlus',
    ecoValue: 'ecoValue',
    getConvertedCadNewUrl:"/proxy/apigee/engineering/converted-cad/v1/parts/best-3d-representation",
    newUrlVariableCad :"/converted-cad/search",
    accessoriesPartWebsiteLink:'https://web-accessories.renaultgroup.com/',  
});

/**
 * Created by A652379 on 23/12/2016.
 */
(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('remonterAlerteCtrl', remonterAlerteCtrl);

  /** @ngInject */
  function remonterAlerteCtrl($modalInstance) {
    var vm = this;


    function cancel() {
      $modalInstance.dismiss('cancel');


    }







    function init() {
      vm.cancel= cancel;



    }









    init();

  }
})();

/**
 * Created by A652379 on 23/12/2016.
 */
(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('refConsignCtrl', refConsignCtrl);

  /** @ngInject */
  function refConsignCtrl($modalInstance, modalOpts) {
    var vm = this;
    vm.cancel= cancel;
    vm.validate= validate;

    vm.vois = modalOpts.vois;


    function cancel() {
      $modalInstance.dismiss('cancel');
    }

    function validate() {
      $modalInstance.close('cancel');
    }

  }
})();

/**
 * TmDocuments Controller
 * @namespace Controllers
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('DocumentsMenuCtrl', DocumentsMenuCtrl);

    /**
     * @namespace DocumentsMenuCtrl
     * @desc Display sie tabs (PR, Products, TM, MR and MD)
     * @memberOf Controllers
     */


    /* @ngInject */
    function DocumentsMenuCtrl($rootScope,
                               DocumentsMetierService,
                               $state,
                               toastr,
                               $window,
                               RoutesConstants,
                               $translate,
                               CacheService,
                               CacheConstants,
                               blockUI,
                               $q,
                               $timeout,
                               $scope,
                               mrDocumentsMetierService,
                               AlertsService,
                               UtilsMetierService,
                               searchByTextsIdsMertierService,
                               CarSearchResultConstants,$log,configConstantes,MainMetierService,DocPrivMetierService,SearchArboTextualMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.recapCarAPI = null;
        vm.count = {};
        vm.isCountryKorea = UtilsMetierService.isCountryTargeted('KR');
        vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
        vm.isTireNodeSelected = false;
        vm.user = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.user.roles);
        vm.isNDAssistantEnabled = UtilsMetierService.isNDChatBotEnabled();

        vm.selectTab = selectTab;
        vm.goToArbo = goToArbo;
        vm.goToHome = goToHome;
        vm.goToSearchEngine = goToSearchEngine;
        vm.goToPreviousPage = goToPreviousPage;
        vm.countDocumentByType = countDocumentByType;
        vm.getMdList = getMdList;
        vm.divSelected=divSelected;
        vm.changeFilter=changeFilter;
        vm.onChangeMotCle=onChangeMotCle;
        vm.stateInputsForm = { motCle: { active: undefined } };
        vm.changeStyleFields=changeStyleFields;
        vm.switchState=switchState;
        vm.reinitSearch=reinitSearch;
        vm.onKeyPressed=onKeyPressed;
        vm.getItemfromAutocomplete=getItemfromAutocomplete;
        vm.showAutocomplete = false;
        vm.searchEngineDocs=searchEngineDocs;
        vm.searchOnPressEnter=searchOnPressEnter;
        vm.autocompleteList=[];
        var isSearchClicked = false;
        var phxInitListClass = 'phx-init-list';
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.isInterventionAccess = UtilsMetierService.isInterventionAccess();
        var filter = CacheService.getObject(CacheConstants.filter);
        vm.doctypes = [];
        if (vm.isIndependentUser){
            if($rootScope.asomDocList.PR){ vm.doctypes.push('PR')}
            if($rootScope.asomDocList.TM){ vm.doctypes.push('TM')}
            if($rootScope.asomDocList.MR){ vm.doctypes.push('MR')}
            if($rootScope.asomDocList.MD){ vm.doctypes.push('MD')}
        }
        var profile = CacheService.getObject(CacheConstants.profil);
        vm.isLandscape = profile.isLandscape;
        vm.isPRFormat = profile.isPRFormat;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        var mdPath = CacheService.getObject(CacheConstants.backButtonEnable);
        vm.backButtonEnable = (mdPath) ? mdPath : false;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            vm.isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            vm.searchEngineDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
            vm.isRedirectFromSearchEngine = vm.searchEngineDetails ? vm.searchEngineDetails.isRedirectFromSearchEngine: false;
            vm.filterChoosen = $state.params.filterChoosen;
            vm.motCle = $state.params.motCle;
            vm.documentType = $state.params.documentType || "PR";
            $rootScope.$on("isLandscape", function (event, data) {
                vm.isLandscape = data;
            })
            $rootScope.$on("isPRFormat", function (event, data) {
                vm.isPRFormat = data;
            })
           // if(!vm.isRedirectFromSearchEngine){
            if(!vm.isSearchEngine){
                try {
                    vm.documentType = $state.params.documentType || "PR";
                    if ($state.params.data) {
                        vm.node = $state.params.data.selectedNode;
                        vm.dataNode = $state.params.data;
                        CacheService.setObject(CacheConstants.levelsDoc, $state.params.data);
                    } else {
                        vm.dataNode = CacheService.getObject(CacheConstants.levelsDoc);
                        vm.node = DocumentsMetierService.getNodeInCache() != null ? DocumentsMetierService.getNodeInCache() : vm.dataNode.selectedNode;                        
                    }

                    switch (vm.node.level) {
                        case 2:
                            vm.labelNode1 = vm.dataNode.node1.label;
                            vm.labelNode2 = vm.dataNode.node2.label;
                            break;
                        case 3:
                            vm.labelNode1 = vm.dataNode.node1.label;
                            vm.labelNode2 = vm.dataNode.node2.label;
                            vm.labelNode3 = vm.dataNode.node3.label;
                            break;
                    }
                    /** They are multiples MD, we need to filter */
                    var MD = createMDList(vm.node);
                } catch (error) {
                    $state.go(RoutesConstants.carSearch);
                }

                if(vm.documentType !== 'tires'){
                    vm.node.nbrDocumentsByType["MD"] = MD ? MD.totalNbMD : null;
                    vm.node.documentsByType["MD"] = MD ? MD.MD : null;
                    vm.node.documentsByType["PRODUCT"] = vm.node.nodeId;

                    //get TM_STANDARD and TM_OTS
                    vm.node.documentsByType["TM"]=vm.node.documentsByType.TM_BY_TYPE["TM_STANDARD"]&&vm.node.documentsByType.TM_BY_TYPE["TM_OTS"]?
                    vm.node.documentsByType.TM_BY_TYPE["TM_STANDARD"].concat(vm.node.documentsByType.TM_BY_TYPE["TM_OTS"]):vm.node.documentsByType.TM_BY_TYPE["TM_STANDARD"];

                    //Load lis of MD and/OR MR if necessary
                    //case MR list exist call then MD if exist
                    //and opposit case if MD
                    var mrIDList = vm.node.documentsByType["MR"];
                    var mdIDList = vm.node.documentsByType["MD"];
                    //commenting to stop all document calls at once and call only specific
                    /*if (vm.node.nbrDocumentsByType["MR"] != 0) {
                        blockUI.start();
                        mrDocumentsMetierService.getInitialSieDocuments(mrIDList).then(function (mrDocuments) {
                            if (mrDocuments && mrDocuments.length != undefined) {
                                vm.node.nbrDocumentsByType["MR"] = mrDocuments.length;
                            }
                        }).catch(function (reason) {
                        }).finally(function () {
                            if (vm.node.nbrDocumentsByType["MD"] != 0) {
                                getMdList(DocumentsMetierService, mdIDList, vm, blockUI);
                            }else {
                                blockUI.stop();
                                countDocumentByType();
                            }
                        });

                    } else if (vm.node.nbrDocumentsByType["MD"] != 0) {
                        getMdList(DocumentsMetierService, mdIDList, vm, blockUI);
                    } else {
                        countDocumentByType();
                    }*/
                    countDocumentByType();

                    if (vm.searchEngineDetails && !_.isEmpty(vm.searchEngineDetails.catalogPlate)){
                        $timeout(function () {
                            $rootScope.$broadcast('phx-init-listPR', vm.searchEngineDetails.catalogPlate);
                            if(vm.searchEngineDetails.singleNode){
                                vm.searchEngineDetails.catalogPlate = [];
                                CacheService.setObject(CacheConstants.searchEngineDetails, vm.searchEngineDetails);
                            }
                        }, 0)

                        // $state.transitionTo($state.$current.name, {documentType: vm.documentType}, {
                        //     location: "replace",
                        //     inherit: true,
                        //     relative: $state.$current,
                        //     notify: false
                        // })
                    }
                    else{
                        $timeout(function () {
                            $rootScope.$broadcast(phxInitListClass+vm.documentType, vm.node.documentsByType[vm.documentType]);
                            },0);
                        }

                }else{
                    vm.isTireNodeSelected = true;
                    // The Tires page renders synchronously from state params; clear any
                    // outstanding blockUI counter left from arbo tree loading so the
                    // loading overlay does not persist after the page is ready.
                    blockUI.reset();
                }

                $state.transitionTo($state.$current.name, {documentType: vm.documentType}, {
                    location: "replace",
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                })
            }else{
                translate();
                vm.filterChoosen = CacheService.getObject(CacheConstants.filter);
                vm.documentType = vm.filterChoosen.id ? vm.filterChoosen.id : vm.filterChoosen;
                vm.motCle = CacheService.getObject(CacheConstants.motCle);
                vm.searchEngineIds = CacheService.getObject(CacheConstants.searchEngineIds);
                $timeout(function () {
                    $rootScope.$broadcast(phxInitListClass+vm.documentType, vm.searchEngineIds);
                },0);
            }
        /* }
        else if (vm.isRedirectFromSearchEngine){
            $timeout(function () {
                $rootScope.$broadcast('phx-init-listPR', searchEngineDetails.catalogPlate);
            }, 0)
        } */
        };
        function searchOnPressEnter(keyEvent) {
            if (keyEvent.which === 13) {
                searchEngineDocs();
            }
        }

        function onKeyPressed(event) {
            $timeout(function () {
                if (event.charCode == 13 && vm.motCle && vm.motCle != "") {
                    searchEngineDocs();
                }
            }, 100);
        }

        function goToPreviousPage(){
            CacheService.removeObject(CacheConstants.backButtonEnable);                  
            var mdPreviousTab = CacheService.getObject(CacheConstants.tabIndex);
            if(!_.isEmpty(mdPreviousTab) && !_.isEmpty(mdPreviousTab.data)){
                $state.go(RoutesConstants.documentMD, { id: mdPreviousTab.data.myRef }); 
            }        
        }
         function goToSearchEngineCatalogPage(){
            var types = [];
            types.push(vm.filterChoosen.id);
            CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
            getSearchEngineDocs(vm.motCle,types);

        }
        function getSearchEngineDocs (searchText, types,isSearchEngine){
            SearchArboTextualMetierService.setConnectedServicesAuditData('Search_' + (types && types[0] ? types[0] : '') + '_' + searchText).then(function () {});
            if(!isSearchEngine){
                DocPrivMetierService.removeBorneo3Resposne();
                DocPrivMetierService.removeRepairManuals();
                DocPrivMetierService.removeSearchEngineMd();
                DocPrivMetierService.removeLabourTimes();
                DocPrivMetierService.removePrResponse();
            }
            CacheService.setObject(CacheConstants.motCle, vm.motCle);
            vm.searchEngineData = DocPrivMetierService.getSearchEngineMd(); 
            if(!vm.searchEngineData || _.isEmpty(vm.searchEngineData[types[0]])){
            blockUI.start();
            searchByTextsIdsMertierService.getSearchEngineDocs(searchText,types).then( function (response){
              vm.searchEngineData[types[0]] = response;
                DocPrivMetierService.setSearchEngineMd(vm.searchEngineData);
                searchLimit(response, searchText, types, isSearchEngine);
            }).catch(function (e) {
                vm.searchEngineids = [];
            }).finally(function () {
                blockUI.stop();
            });
            }
            else {
                searchLimit(vm.searchEngineData[types[0]], searchText, types, isSearchEngine);
            }

        }

        function searchLimit(response,searchText,types,isSearchEngine){
            if (!_.isEmpty(response)){
                vm.searchEngineIds = response;
                vm.documentType = types[0];
                CacheService.setObject(CacheConstants.searchEngineIds, vm.searchEngineIds);
                $timeout(function () {
                    $rootScope.$broadcast(phxInitListClass+vm.documentType,vm.searchEngineIds);
                }, 0);
                $state.transitionTo($state.$current.name, {documentType: isSearchEngine && vm.documentType === 'PR' ? 'newSearch' : vm.documentType}, {
                    location: "replace",
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                })
            }
            else if (vm.motCle && vm.motCle != "" && vm.motCle.length == 4 && vm.filterChoosen.id == "TM" ){
                vm.documentType = types[0];
                CacheService.setObject(CacheConstants.searchEngineIds, vm.searchEngineIds);
                $timeout(function () {
                    $rootScope.$broadcast(phxInitListClass+vm.documentType,vm.searchEngineIds);
                }, 0);
                $state.transitionTo($state.$current.name, {documentType: vm.documentType}, {
                    location: "replace",
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                })
            }
            else{
                $rootScope.$broadcast(phxInitListClass+vm.documentType,[],true);
                toastr.error($translate.instant("CARSEARCH_NAME_NOT_RESULT_FOUND"));
            }
        }
        function switchState(indexInput, isFocused) {
            vm.showAutocomplete = false;
            changeStyleFields(indexInput, isFocused);
        }
        function reinitSearch() {
            if (!vm.isSearchEngine){
                vm.filterChoosen = { id: "ALL" };
            }
            vm.motCle = undefined;
            vm.showSearchRef = false;
            vm.isArboFiltered = false;
            vm.autocompleteList = [];
            if (vm.isSearchEngine){
                CacheService.setObject(CacheConstants.motCle, vm.motCle);
                CacheService.setObject(CacheConstants.searchEngineIds, []);
            }
        }

        function changeStyleFields(indexInput, isFocused) {
            var property;
            vm.stateInit = true;

            if (indexInput == "motCle") {
                for (property in vm.stateInputsForm) {
                    if (vm.stateInputsForm && vm.stateInputsForm.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputsForm[property].active = true;
                                vm.stateInit = false;
                            } else {
                                vm.stateInputsForm[property].active = false;
                            }

                        } else {
                            vm.stateInputsForm[property].active = undefined;
                        }
                    }
                }
            }
            else {
                for (property in vm.stateInputSearch) {
                    if (vm.stateInputSearch && vm.stateInputSearch.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputSearch[property].active = true;
                            } else {
                                vm.stateInputSearch[property].active = false;
                            }

                        } else {
                            vm.stateInputSearch[property].active = undefined;
                        }
                    }
                }
            }

        };

        function searchOnPressEnter(keyEvent) {
            if (keyEvent.which === 13) {
                vm.showAutocomplete = false;

                searchEngineDocs();
            }
        }


        function searchEngineDocs(isSearchBtnClick) {
            if (isSearchBtnClick) {
                isSearchClicked = true;
            } else {
                isSearchClicked = false;
            }
            if (vm.filterChoosen && vm.filterChoosen.id === "TM_LIST") {
                if (vm.motCle && vm.motCle.length <= 98) {
                    if (vm.checkTMListPattern()) {
                        CacheService.setNodeSearchTmList(vm.motCle);

                        $state.go(RoutesConstants.listePieceTMView, {
                            searchText: vm.motCle.toUpperCase()
                        });
                    }
                    else {
                        toastr.error($translate.instant('CAR_SEARCH_EXAMPLE_OF_TM_LIST'));
                    }
                }
                else {
                    toastr.error($translate.instant('TM_LIST_SEARCH_ERROR'));
                }
            } else {
                if (vm.motCle && vm.motCle != "") {

                        var regExp = /^([0-9]{4,})([\/]{1,})([0-9]{6,})$/;
                        var searchedIds = vm.motCle.split(" ").join("");
                        if(vm.filterChoosen.id === "PR" && searchedIds.length === 11 && regExp.test(searchedIds)){

                            CacheService.setObject(CacheConstants.isSearchEngine,true);
                            CacheService.setObject(CacheConstants.motCle, vm.motCle);
                            CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
                            CacheService.removeObject(CacheConstants.searchEngineDetails);
                            var arr = [];
                            var obj = {};
                            arr.push({'id':searchedIds.split('/').join('_')});
                            obj = {'catalogPlates':arr};
                            DocumentsMetierService.filterSelectedIds(obj, 'PR');

                        }else
                    if (vm.isSearchEngine && vm.motCle.length >= 3){
                        vm.showAutocomplete = false;

                        goToSearchEngineCatalogPage();
                    }

                }
                else{
                    CacheService.removeObject(CacheConstants.motCle);

                    goToHome();
                }

            }
        }

        function goToSearchEngineCatalogPage() {
            var types = [];
            types.push(vm.filterChoosen.id);
            getSearchEngineDocs(vm.motCle, types);

        }
        function switchState(indexInput, isFocused) {
            changeStyleFields(indexInput, isFocused);
        }
        function reinitSearch() {
            if (!vm.isSearchEngine) {
                vm.filterChoosen = { id: "ALL" };
            }

            vm.motCle = undefined;
            vm.showSearchRef = false;
            vm.isArboFiltered = false;
            vm.autocompleteList = [];


        }

        function changeStyleFields(indexInput, isFocused) {
            var property;
            vm.stateInit = true;

            if (indexInput == "motCle") {
                for (property in vm.stateInputsForm) {
                    if (vm.stateInputsForm && vm.stateInputsForm.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputsForm[property].active = true;
                                vm.stateInit = false;
                            } else {
                                vm.stateInputsForm[property].active = false;
                            }

                        } else {
                            vm.stateInputsForm[property].active = undefined;
                        }
                    }
                }
            }
            else {
                for (property in vm.stateInputSearch) {
                    if (vm.stateInputSearch && vm.stateInputSearch.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputSearch[property].active = true;
                            } else {
                                vm.stateInputSearch[property].active = false;
                            }

                        } else {
                            vm.stateInputSearch[property].active = undefined;
                        }
                    }
                }
            }
        }
        function divSelected(key) {
            var elemSelected = document.getElementById(key);
            var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
            var topContainer;
            positionOfElem + 15 + "px";
            if (positionOfElem < 200) {
                topContainer = positionOfElem + 25 + "px";
            } else {
                topContainer = positionOfElem + 10 + "px";
            }
            setTimeout(function () {
                $(".my-container").css({ 'top': topContainer });
            }, 50);
        }

        function onChangeMotCle() {
            //add condition specific to tm list
            vm.showAutocomplete = false;

            var regExp = /^([0-9]{4,})([\/]{1,})([0-9]{6,})$/;

            if (vm.isSearchEngine && vm.motCle && vm.motCle.length >= 3 &&vm.stateInputsForm['motCle'].active&& vm.filterChoosen.id !== "TM_LIST"){

                var searchedIds = vm.motCle.split(" ").join("");
                var isPlateSearch = vm.filterChoosen.id === "PR" && searchedIds.length === 11 && regExp.test(searchedIds);
                if(!isPlateSearch){

                    vm.showAutocomplete = true;
                    var types = [];
                    types.push(vm.filterChoosen.id);

                    getAutoCompleteList(vm.motCle,types);
                }
            }
        }
        function getAutoCompleteList(searchText, types){
            vm.autocompleteList = [];
            var isOtherLang = CacheService.getUserContext() ? CarSearchResultConstants.autoSearchLang.includes(CacheService.getUserContext().language) : false;
            if(isOtherLang){
                searchByTextsIdsMertierService.getSearchEngineDocs(searchText,types,isOtherLang).then( function (response){
                    if (response && response.documents){
                        vm.autocompleteList = response.documents;
                    }
                });
            }else{
                searchByTextsIdsMertierService.getAutoCompleteList(searchText,types).then( function (response){
                    if (response&&response.documents){
                        vm.autocompleteList = _.slice(response.documents,0,10);
                    }
                });
            }
        }

        function getItemfromAutocomplete(item){
            vm.motCle = item.label;
            var filter = CacheService.getObject(CacheConstants.filter);
            if (vm.isSearchEngine && vm.motCle.length >= 3&& vm.filterChoosen.id !== "TM_LIST"){
                searchEngineDocs();
            }
            vm.showAutocomplete = false;

        }
        function translate() {
            vm.initialFitlters = [];
            if (vm.isIndependentUser){
                if (vm.doctypes.length > 0){
                    vm.filterChoosen = filter ? filter : { id: vm.doctypes[0] };
                    vm.newSearchFilter =  (filter && filter.id != 'ALL') ? filter : { id: vm.doctypes[0] };
                for(var i=0; i < vm.doctypes.length;i++){
                    vm.initialFitlters.push({ "id":vm.doctypes[i], label: $translate.instant(CarSearchResultConstants.searchLabels[vm.doctypes[i]]) });
                }
                initFilter();
                }
                else{
                    vm.filterChoosen = null;
                    vm.newSearchFilter.id = null;
                    initFilter();
                }

            }
            else{

            
                var toTrad = [
                    $translate('CAR_SEARCH_RESULT_FILTER_PR'),
                    $translate('CAR_SEARCH_RESULT_FILTER_TM'),
                    $translate('CAR_SEARCH_RESULT_FILTER_MR'),
                    $translate('CAR_SEARCH_RESULT_FILTER_MD')
                ];
                if(vm.contextCarBrandCheck){
                    $q.all(toTrad).then(function (trads) {
                        vm.initialFitlters.push({ "id": "TM", label: trads[1] });
                        vm.initialFitlters.push({ "id": "MR", label: trads[2] });
                        vm.initialFitlters.push({ "id": "MD", label: trads[3] });
                        initFilter();
                    });
                }
                else{
                    $q.all(toTrad).then(function (trads) {
                        vm.initialFitlters.push({ "id": "PR", label: trads[0] });
                        vm.initialFitlters.push({ "id": "TM", label: trads[1] });
                        vm.initialFitlters.push({ "id": "MR", label: trads[2] });
                        vm.initialFitlters.push({ "id": "MD", label: trads[3] });
                        initFilter();
                    });
                }
            }

        }
        function initFilter() {
            //fixed this later
            //vm.selectedFilter = vm.initialFitlters[0];
            vm.selectedFilter = vm.filterChoosen.id;
            changeFilter(vm.selectedFilter);
        }
        function changeFilter(filter) {
            CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
            vm.showAutocomplete = false;
            vm.selectedFilter = filter;
            if (vm.isSearchEngine){
                vm.filterTypes = vm.initialFitlters;
            }
            else{
                vm.filterTypes = _.filter(vm.initialFitlters, function (n) {
                return n.id !== filter.id;
                });
            }
        }
        /**
         * @name selectTab
         * @desc Select another tab (PR, Products, TM, MR or MD)
         * this action trigger when user click on a tab
         * @param {string} tab tab name (PR, Products, TM, MR or MD)
         * @memberOf Controllers.DocumentsMenuCtrl
         */
        function selectTab(tab) {
            AlertsService.setScreenshotButtonVisibility(false);
            clearSelected();
            vm.documentType = tab;

            vm.filterChoosen = { id: tab }
            CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
            var isSearchEngine = CacheService.getObject(CacheConstants.isSearchEngine);
            if(!isSearchEngine){
                $rootScope.$broadcast(phxInitListClass + tab, vm.node.documentsByType[vm.documentType], vm.node, vm.labelNode1, true);
                $state.transitionTo($state.$current.name, {documentType: vm.documentType}, {
                    location: "replace",
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                })
            } else{
                 if(!vm.stateInputsForm['motCle'].active)
                {
                    vm.showAutocomplete = false;

                }
                getSearchEngineDocs(vm.motCle, [tab],isSearchEngine);
            }

        }

        /**
         * @name goToArbo
         * @desc Go to arbo page
         * this action trigger when user click on navigations link (node1, node2 or node3)
         * @param {array} node arbo node informations (node1, node2 or node3)
         * @returns {state} state to arbo page
         * @memberOf Controllers.DocumentsMenuCtrl
         */

        function goToArbo(node) {
            vm.dataNode.node = node;
            if ($state.params.data && $state.params.data.arbo) {
                vm.dataNode.arbo = $state.params.data.arbo;
            }

            CacheService.removeObject(CacheConstants.isSearchEngine);
            //CacheService.removeObject(CacheConstants.searchEngineDetails);
            //CacheService.removeObject(CacheConstants.searchEngineIds);
            //CacheService.removeObject(CacheConstants.nodeSelect);
            CacheService.removeObject(CacheConstants.levelsDoc);
            CacheService.removeObject(CacheConstants.nodeFromSearchArbo);

            var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
            if(!carContext.filteredTree){
                CacheService.removeObject(CacheConstants.filter);
                //CacheService.removeObject(CacheConstants.motCle);
            }

            $state.go(RoutesConstants.carSearchResult, { data: vm.dataNode });
        }

        /**
         * @name goToHome
         * @desc Go to arbo page
         * this action trigger when user click on return button
         * @returns {state} arbo page
         * @memberOf Controllers.DocumentsMenuCtrl
         */
        function goToHome() {
            // CacheService.removeObject(CacheConstants.searchEngineIds);
            CacheService.removeObject(CacheConstants.isSearchEngine);
            CacheService.removeObject(CacheConstants.listOfPiece);
            //CacheService.removeObject(CacheConstants.searchEngineDetails);
            CacheService.removeObject(CacheConstants.identifierList);
            if($state.params.documentType == "TM" || $state.params.documentType == "MD" || $state.params.documentType == "MR" || $state.params.documentType == "PRODUCT" || $state.params.documentType == "INT_REPAIR"){
                CacheService.removeObject(CacheConstants.interventionIdList);
                CacheService.removeObject(CacheConstants.intNodeSelected);
                CacheService.removeObject(CacheConstants.selectedInterventionId);
            }
            if($state.params.isTextSearchRedirect && $state.params.isComingFromDiagFileDetails){
                $state.go(RoutesConstants.carSearchResult,{
                    isFromDiagFileDetails: true,
                    isTextSearchRedirect: false
                })
            } else {
                $state.go(RoutesConstants.carSearchResult);
            }
        }

        /**
         * @desc Go to Search engine page
         */
         function goToSearchEngine(){
            var searchDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
            CacheService.setObject(CacheConstants.filter, {id: searchDetails.documentType});
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            CacheService.setObject(CacheConstants.isSearchEngine,true);

            if(searchDetails.reference){
                var selectedElement = $window.document.getElementById("TM_"+ searchDetails.reference);
                if (selectedElement) {
                    var container = selectedElement.getElementsByClassName('code');
                    var item = container[0].getElementsByClassName('code-text');
                    angular.element(item).removeClass('landmark');
                }
            }

            $state.go(RoutesConstants.listePieceViews, {
                isSearchEngine: true,
                documentType: ['newSearch'],
                plateIndex: 0,
                refIndex: 0,
                motCle:vm.motCle
            });
         }

        /*=============================================
         =                 TOOLS                       =
         =============================================*/


        function countDocumentByType() {
            if(vm.contextCarBrandCheck){
                vm.count = {
                    MD: vm.node.nbrDocumentsByType["MD"],
                    MR: vm.node.nbrDocumentsByType["MR"],
                    TM: vm.node.nbrDocumentsByType["TM_STANDARD"] || 0
                };
            }
            else{
                vm.count = {
                    PR: vm.node.nbrDocumentsByType["PR"],
                    MD: vm.node.nbrDocumentsByType["MD"],
                    MR: vm.node.nbrDocumentsByType["MR"],
                    TM: vm.node.nbrDocumentsByType["TM_STANDARD"] || 0,
                    PRODUCT: vm.node.nbrDocumentsByType["PRODUCTS"] || 0,
                    INT_REPAIR: vm.node.nbrDocumentsByType["INT_REPAIR"] || 0
                };
            }
            if(!vm.count['PRODUCT']) {
                var documentsId=CacheService.getObject(CacheConstants.transeversalPartsIds);
                if(documentsId){
                    vm.count['PRODUCT']=documentsId.length;
                }
            }

            $scope.$on('updatedCountTab', function (event, data) {
                event.stopPropagation();
                if (data.documentType === 'PR') {
                    vm.count['PR'] = data.count;
                }
            });
            /*** HACK : Waiting for children views to init before broadcast documents (array ID) */
            if(!vm.searchEngineDetails || (vm.searchEngineDetails && (vm.documentType == 'PR' && _.isEmpty(vm.searchEngineDetails.catalogPlate)) || vm.documentType == 'TM')){
                $timeout(function () {
                if(vm.count[vm.documentType] < 1){


                    if (vm.count['PR'] > 0)
                        vm.documentType = 'PR';

                    else if (vm.count['PR']< 1 && vm.count['PRODUCT'] > 0){
                        vm.documentType = 'PRODUCT';
                    }
                    else if (vm.count['PR']< 1 && vm.count['PRODUCT'] < 1 && vm.count['INT_REPAIR'] > 0){
                        vm.documentType = 'INT_REPAIR';
                    }
                    else if (vm.count['PR']< 1 && vm.count['PRODUCT'] < 1 && vm.count['INT_REPAIR'] < 1 && vm.count['TM'] > 0){
                        vm.documentType = 'TM';
                    }
                    else if (vm.count['PR']< 1 && vm.count['PRODUCT'] < 1 && vm.count['INT_REPAIR'] < 1 && vm.count['TM'] < 1 && vm.count['MR'] > 0){
                        vm.documentType = 'MR';
                    }
                    else if (vm.count['PR']< 1 && vm.count['PRODUCT'] < 1 && vm.count['INT_REPAIR'] < 1 && vm.count['TM'] < 1 && vm.count['MR'] < 1 && vm.count['MD'] > 0){
                        vm.documentType = 'MD';
                    }
                    vm.filterChoosen = { id: vm.documentType  }
                    CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
                }
                //$rootScope.$broadcast(phxInitListClass + vm.documentType, vm.node.documentsByType[vm.documentType]);
            }, 0);
            }
        }

        function getMdList(DocumentsMetierService, mdIDList, vm, blockUI) {
            DocumentsMetierService.getMDListFromArbo(DocumentsMetierService.createMDParams(mdIDList))
                .then(function (result) {
                    if (result.MD && result.MD.length != undefined) {
                        vm.node.nbrDocumentsByType["MD"] = result.MD.length;
                    }

                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
                countDocumentByType();
            });
        }

        //clear selected item from the current tab
        //this function is used to delete selected sie (MR, MD or BT)
        //when the user navigate between tabs (PR, Products, TM or MD)
        function clearSelected() {
            angular.element(document.querySelectorAll(".documents-row")).removeClass("selected");
        }

        //get MD List
        /**
         * filteredType contient la liste des MD que l'on ne souhaite pas afficher
         * nbDocs clône l'objet node.nbrDocumentsByType, il contient la liste des types de MD avec leurs quantité
         * nbDocs est affiné par la fonction filterByType()
         * filterByType() vient supprimer de l'objet nbDocs les types de MD que l'on ne souhaite pas afficher en
         * fonction du type de MD dans le car Context (B2, B3 ou B2-3)
         */
        function createMDList(node) {
            var nbDocs = jQuery.extend(true, {}, node.nbrDocumentsByType);
            var typeMD = CacheService.getCarContext().typeMD;
            var filteredType = getFiltredList(typeMD);
            var MD = {
                totalNbMD: 0,
                MD: [],
                node: node.nodeId
            }
            nbDocs = filterByType(nbDocs, typeMD);
            MD.totalNbMD = sum(nbDocs);
            for (var key in node.documentsByType.MD) {
                if (filteredType.indexOf(key) === -1) {
                    MD.MD = MD.MD.concat(node.documentsByType.MD[key]);
                }
            }

            return MD;
        }

        function filterByType(nbDocs, typeMD) {
            var filterMD = getFiltredList(typeMD);
            angular.forEach(filterMD, function (value, key) {
                delete nbDocs[value];
            })
            return nbDocs;
        }

        function getFiltredList(typeMD) {
            var filterMD = ['INT_REPAIR','BT', 'MR', 'PR', 'TM', 'TM_DMS', 'TM_DMS_OTS', 'TM_OTS', 'TM_STANDARD', 'PRODUCTS', 'NI', 'MD_104', 'MD_106', 'MD_109'];
            var filterB3 = ['MD_B2'];
            var filterB2 = ['MD', 'MD_102', 'MD_108', 'MD_110', 'MD_111', 'MD_501', 'MD_502'];

            if (typeMD == "B3") {
                filterMD = filterMD.concat(filterB3);
            } else if (typeMD == "B2") {
                filterMD = filterMD.concat(filterB2);
            }
            return filterMD;
        }

        function sum(obj) {
            var sum = 0;
            for (var key in obj) {
                sum += (obj[key]);
            }

            return sum;
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.listePiece, {
        url: '/listePiece/:documentType/plate/:plateIndex/ref/:refIndex', // url: '/listePiece/:documentType/plate/{plateIndex:int}/ref/{refIndex:int}', 
        templateUrl: 'app/components/products/documents/documents.html',
        abstract: true,
        controller: 'DocumentsMenuCtrl',
        controllerAs: 'documentsMenuCtrl',
        params: {
          data: null,
          searchGenericParts:null,
          isSearchEngine:false,
          filterChoosen:null,
          motCle:null,
          levels:null,
          product: null,
          documentType: 'PR',
          singleNode: null,
          selectedReference: null,
          clipRedirect: null,
          isComingFromDiagFileDetails: false,
          isTextSearchRedirect: false
        }
      })
      .state(RoutesConstants.listePieceTMView, {
        url: '/TM_LIST', 
        templateUrl: 'app/components/products/documents/TM_LIST/tmListDocuments.template.html',
        controller: 'TmListDocumentCtrl',
        controllerAs: 'tmListCtrl',
        params: {
          searchText: null
        }
      })
      .state(RoutesConstants.listePieceTMContent, {
        url: '/list', 
        templateUrl: 'app/components/products/documents/tm/tmDocuments.template.html',
        controller: 'TMDocumentsCtrl',
        controllerAs: 'tmDocumentsCtrl',
        params: {
          searchList: null,
          tmListData: null
        }

      })
      .state(RoutesConstants.listePieceViews, {
        url: "",
        views: {
          'pr': {
            templateUrl: 'app/components/products/documents/pr/listePiece.template.html'
          },
          'newSearch': {
            templateUrl: 'app/components/products/documents/pr/listePiece.template.html'
          },

          'products': {
            templateUrl: 'app/components/products/documents/productsDoc/productsDoc.template.html',
            params: {
              data: null
            }
          },
          'INT_REPAIR': {
            templateUrl: 'app/components/products/documents/easybasket/easyBasket.template.html'
          },
          'tm': {
            templateUrl: 'app/components/products/documents/tm/tmDocuments.template.html'
          },
          'mr': {
            templateUrl: 'app/components/products/documents/mr/mrDocuments.template.html'
          },
          'bt': {
            templateUrl: 'app/components/products/documents/bt/btDocuments.html'
          },
          'md': {
            templateUrl: 'app/components/products/documents/md/mdDocuments.html'
          },
          'tires': {
            templateUrl: 'app/components/products/documents/tiresInformation/tiresInformation.template.html',
            controller: 'TiresInformationController',
            controllerAs: 'vm',
            params: {
              data: null
            }
          }
        }
      });
  }
})();

"use strict";

angular.module("phenix").constant("DocumentSearchConstants", {
    proxyRest: "/proxy/apidh/rest/v1/",
    labourTimes: "/proxy/apidh/rest/v1/laborTimes",
    opeCode: "/proxy/apidh/rest/v1/laborTimes/opeCode",
    svgS3Path: "/proxy/apis3/", // +url s3
    MRDocumentList: "/proxy/apidh/rest/v1/repairManuals/",
    MRDocumentDetail: "/Document/MR/",
    MDDocumentDetail: "/Document/MD/",
    MDDocumentList: "/proxy/apidh/rest/v1/diagnosticManuals/borneo3",
    BTDocumentDetail: "/Document/BT/",
    MDBookmarksDocumentList: "/proxy/apidh/rest/v1/diagnosticManuals/borneo2",
    SieDocumentContentPdf: "/proxy/apidh/rest/v1/contents/urls",
    SieDocumentContentPdfClip:"/proxy/apidh/rest/v1/diagnosticManuals/borneo2/clip",
    SiesByGies: "/proxy/apidh/rest/v1/sies/gies",
    Elemope:"/proxy/apidh/rest/v1/sies/elemOpe",
    prLight: "/proxy/apidh/rest/v1/products",
    partsByGenericParts:"/proxy/apidh/rest/v1/parts/byGenericParts",
    opecodeSortOrder: ["RE01","RH01","RH02","RH03","R001","R002","R003","R004","R005","AAA1","AAA3","AAA5","AAA7","AAA2","AAA4","AAA6","AAA8","BBB1","BBB3","BBB5","BBB7", "BBB2","BBB4","BBB6","BBB8","AB01","AB03","AB02","AB04"]

});

/**
 * @desc display the sie's documentation
 * @param {String} documentation content sie to generate
 * @param {Event} onClickedLink event fired when clicked on sieref element in a content sie
 * @example <div generate-documentation-sie documentation="vm.contentBT.content" on-clicked-link="vm.onClickedLink"></div>
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('generateDocumentationSie', generateDocumentationSie);

    /** @ngInject */
    function generateDocumentationSie($compile, $document, ScrollService, toastr, $translate, CacheService, $rootScope,MainMetierService) {
        var directive = {
            restrict: 'A',
            scope: {
                documentation: '=',
                onClickedLink: '=',
                onClickedWdLink: '=', 
                onClickedOutilSpeLink: '=',
                onClickedWdurlLink:'=',
                onClickedNodeLink:'=',
                openVideo: '=',
                isNewTab: '=',
                newDisplay: '=',
                enableWatch: '=',
                docType:'=',
                isNewTabOpen:"=",
                newDataDisplay:"=",
                isInitialTitle:"="
            },
            controllerAs: 'vm',
            controller: controller,
            bindToController: true,
            link: link
        };

        return directive;

        /* Parse all sieref elements and give them a class using list attribute
        /* noDocumentation if empty, link documentation if one linked document and multipleLinkDocumentation if many
        Example: <sieref list="[]" class="noDocumentation">(VOIR, Connecteurs - Methodologie Generique)</sieref> */

        function link(scope, elements, attrs, controller) {            
        var carContext = CacheService.getCarContext();
        var isArcaUser = MainMetierService.isArcaUser();
        var isRnetUser = MainMetierService.isRnetUserType();
        if(isArcaUser || isRnetUser){
            if(controller.docType  == "MR") {
        scope.$watchGroup(['vm.documentation','vm.enableWatch'], function(firstVar) {
            if((isArcaUser || isRnetUser) && controller.enableWatch){
            if(firstVar[0] ||firstVar[1]){
                 var newDocumentation = controller.documentation;

                 controller.enableWatch = false      
            }                          
                try {
                    var content = $compile(newDocumentation)(scope);
                    elements.append(content);
                    var data = angular.element(document.querySelector('#'+controller.newref))
                    angular.element(data).append(content)
                } catch (err) {
                    toastr.error($translate.instant('TOASTERT_BASKET_GET_ERROR'), '415');
                }
                if (carContext) {
                    var tags = $document.find('sieref');
                    var functionId, subFunctionId, titleId;
                    var anchors = $document.find('a');

                    if (controller.isNewTab) {

                        angular.forEach(anchors, function (anchor) {
                            var href = angular.element(anchor).attr('href');
                            var click = angular.element(anchor).attr('ng-click');

                            if ((href && href.includes('history.go')) || (click && click.includes('onClickedWdurlLink')) || (click && click.includes('onClickedNodeLink'))) {
                                angular.element(anchor).addClass('noAnchor');
                                angular.element(anchor).removeAttr('href');
                                angular.element(anchor).removeAttr('ng-click');
                                angular.element(anchor).unbind('click');
                            }
                        })
                    }

                    else if ($rootScope.isIndependentUser) {
                        angular.forEach(anchors, function (anchor) {
                            var click = angular.element(anchor).attr('ng-click');
                            if (!$rootScope.asomDocList.WD && (click && click.includes('onClickedWdurlLink')) || (click && click.includes('onClickedNodeLink'))) {                                
                                angular.element(anchor).addClass('noAnchor');
                                angular.element(anchor).removeAttr('ng-click');
                                angular.element(anchor).removeAttr('href');
                                angular.element(anchor).unbind('click');
                            }
                        })
                    }

                    angular.forEach(tags, function (tag) {
                        var openInNewTab = false;
                        if(controller.isNewTab){
                            angular.element(tag).addClass('noDocumentation');
                        }else{
                            var node = angular.element(tag).attr('node');
                            var level = angular.element(tag).attr('level');
                            if (level) {
                                    if (level == 1) {
                                        functionId = node;
                                    }
                                    if (level == 2) {
                                        subFunctionId = node;
                                    }
                                    if (level == 3) {
                                        titleId = node;
                                    }
                                
                                var wiringids = {
                                    "functionId": functionId,
                                    "subFunctionId": subFunctionId,
                                    "titleId": titleId
                                }
                                angular.element(tag).addClass('linkDocumentation');
                                angular.element(tag).bind("click", function ($event) {
                                    if($event.currentTarget != $event.target && tag.querySelector("span") && tag.querySelector("span").classList.contains("newMRIcon")){
                                        controller.onClickedLink(sieref, tag.innerHTML,true);
                                    } else {
                                        controller.onClickedLink(sieref, tag.innerHTML,false);
                                    }
                                    scope.$apply();
                                });

                            }

                            var attr = angular.element(tag).attr('list');
                            if (!attr) {
                                return null;
                            }
                            var parsedAttr = JSON.parse(attr);
                            var sieref = rafinateSieApplicability(parsedAttr);
                            if (sieref && sieref.length == 0) {
                                angular.element(tag).addClass('noDocumentation');
                            } else {
                                if ($rootScope.isIndependentUser){
                                    if ((sieref[0].type == 'MD' && $rootScope.asomDocList.MD) || (sieref[0].type == 'MR' && $rootScope.asomDocList.MR) || (sieref[0].type == 'MR' && $rootScope.asomDocList.MR && $rootScope.asomDocList.MD)) {
                                        var numberOfDoc = sieref.length;
                                        if (numberOfDoc === 1) {
                                            angular.element(tag).addClass('linkDocumentation');
                                            angular.element(tag).addClass(sieref[0].reference);
                                        } else if (numberOfDoc > 1) {
                                            angular.element(tag).addClass('multipleLinkDocumentation');
                                            angular.element(tag).addClass(sieref[0].reference);
                                        }
                                        angular.element(tag).bind("click", function ($event) {
                                            if ($event.currentTarget != $event.target && tag.querySelector("span") &&
                                                (tag.querySelector("span").classList.contains("newMRIcon"))) {
                                                controller.onClickedLink(sieref, tag.innerHTML, true);
                                            } else {
                                                controller.onClickedLink(sieref, tag.innerHTML,false);
                                            }
                                            scope.$apply();
                                        });

                                    }else{
                                        angular.element(tag).addClass('noDocumentation');
                                    }
                                    
                                } else {
                                    var numberOfDoc = sieref.length;
                                    if (numberOfDoc === 1) {
                                        angular.element(tag).addClass('linkDocumentation');
                                        angular.element(tag).addClass(sieref[0].reference);
                                    } else if (numberOfDoc > 1) {
                                        angular.element(tag).addClass('multipleLinkDocumentation');
                                        angular.element(tag).addClass(sieref[0].reference);
                                    }
                                    $rootScope.$broadcast('newDisplayBack', controller.newDisplay);
                                    angular.element(tag).on("click", function ($event) {
                                        var isMRInNewTab = localStorage.getItem('isMRInNewTab');
                                        var isMDInNewTab = localStorage.getItem('isMDInNewTab');
                                        var isBTInNewTab = localStorage.getItem('isBTInNewTab');
                                        if ($(tag).closest('div#warning').length > 0 || $(tag).closest('div#caution').length > 0 || $(tag).closest('div#note').length > 0 || $(tag).closest('div#danger').length > 0) {
                                            openInNewTab = true;
                                        }
                                        if (((isMRInNewTab || isMDInNewTab || isBTInNewTab) && tag.querySelector("span") && tag.querySelector("span").classList.contains("newMRIcon")) || (!isMRInNewTab && !isMDInNewTab && !isBTInNewTab && $event.currentTarget != $event.target && $event.target.className.includes("newMRIcon") && !openInNewTab && tag.querySelector("span") && tag.querySelector("span").classList.contains("newMRIcon"))) {
                                            controller.onClickedLink(sieref, tag.innerHTML, true);
                                        }
                                                                               
                                        else if (openInNewTab && ($event.currentTarget == $event.target || $event.target.classList && $event.target.classList.contains("newMRIcon"))) {
                                            controller.onClickedLink(sieref, tag.innerHTML, true);
                                        } else if (!openInNewTab && tag.querySelector("#childMr") && $event.currentTarget == $event.target) {
                                            tag.querySelector("#childMr").remove();
                                            angular.element(tag).removeClass(sieref[0].reference);
                                            if (controller.newref === sieref[0].reference) {
                                                controller.newref = null;
                                            }
                                            var sierefs = $document.find('sieref');
                                            controller.newDataDisplay = Array.prototype.some.call(sierefs, function (sierefTag) {
                                                return sierefTag.querySelector('#childMr') !== null;
                                            });
                                            controller.isInitialTitle = true;
                                        }
                                        else if (!openInNewTab && !tag.querySelector("#childMr") && $event.currentTarget == $event.target) {
                                            if (controller.newDisplay && $(tag).parents().closest('sieref').length == 0) {
                                                angular.forEach(tags, function (tagList) {
                                                    if (tagList.querySelector("#childMr")) {
                                                        tagList.querySelector("#childMr").remove();
                                                        angular.element(tagList.querySelector("#childMr")).removeClass('newlyAddedBorder');
                                                    }
                                                })}
                                            angular.element(tag).append('<div id="childMr"><div id="noteId"><span class="close-icon" style="float:right;cursor:pointer;font-weight:bold;font-size:16px;">&times;</span><div id=' + sieref[0].reference + '></div></div></div>')
                                            angular.element(tag).addClass(sieref[0].reference);
                                            angular.element(tag.querySelector("#childMr")).addClass('newlyAddedBorder')
                                            angular.element(tag.querySelector("#childMr")).css("color", "black")
                                            //Click handler for close icon
                                            angular.element(tag.querySelector(".close-icon")).bind("click", function(event) {
                                                event.stopPropagation();
                                                tag.querySelector("#childMr").remove();
                                                angular.element(tag).removeClass(sieref[0].reference);
                                                if (controller.newref === sieref[0].reference) {
                                                    controller.newref = null;
                                                }
                                                var sierefs = $document.find('sieref');
                                                controller.newDataDisplay = Array.prototype.some.call(sierefs, function (sierefTag) {
                                                    return sierefTag.querySelector('#childMr') !== null;
                                                });
                                                controller.isInitialTitle = true;
                                                scope.$apply();
                                            });
                                            controller.newref = sieref[0].reference;
                                            controller.onClickedLink(sieref, tag.innerHTML, false, controller.isNewTabOpen)
                                        }
                                        scope.$apply();
                                        $event.stopImmediatePropagation();
                                });

                            }
                            }
                        }
                    });

                    var special = $document.find('img');   
                     angular.forEach(special, function (tag) {  
                        var attr = angular.element(tag).attr('linkvalue');
                        angular.element(tag).bind("click", function () {
                            controller.onClickedOutilSpeLink(attr);
                            scope.$apply();
                        });

                    });

                    var tagOutilSpe = $document.find('outilSpeRef');
                    angular.forEach(tagOutilSpe, function (tag) {
                        var attr = angular.element(tag).attr('outilSpeId');
                        if (!attr) {
                            return null;
                        }
                        angular.element(tag).addClass('linkDocumentation');

                        angular.element(tag).bind("click", function () {
                            controller.onClickedOutilSpeLink(attr, tag.innerHTML);
                            scope.$apply();
                        });

                    });
                } else {
                    var tags = $document.find('sieref');
                    angular.forEach(tags, function (tag) {
                        angular.element(tag).addClass('noDocumentation');
                    });
                }
            }            
            })
        }
        else{
            openMrDocument(scope, elements, attrs, controller);
        }
        }
        else{
            openMrDocument(scope, elements, attrs, controller);
        }
    }

        function openMrDocument(scope, elements, attrs, controller) {
            var carContext = CacheService.getCarContext();
            scope.$watch(function () {
                return controller.documentation;
            }, function (newDocumentation) {
                
                try {
                    var content = $compile(newDocumentation)(scope);
                    elements.append(content);
                } catch (err) {
                    toastr.error($translate.instant('TOASTERT_BASKET_GET_ERROR'), '415');
                }
                if (carContext) {
                    var tags = $document.find('sieref');
                    var functionId, subFunctionId, titleId;
                    var anchors = $document.find('a');

                    if (controller.isNewTab) {

                        angular.forEach(anchors, function (anchor) {
                            var href = angular.element(anchor).attr('href');
                            var click = angular.element(anchor).attr('ng-click');

                            if ((href && href.includes('history.go')) || (click && click.includes('onClickedWdurlLink'))) {
                                angular.element(anchor).addClass('noAnchor');
                                angular.element(anchor).removeAttr('href');
                                angular.element(anchor).removeAttr('ng-click');
                                angular.element(anchor).unbind('click');
                            }
                        })
                    }

                    else if ($rootScope.isIndependentUser) {
                        angular.forEach(anchors, function (anchor) {
                            var click = angular.element(anchor).attr('ng-click');
                            if (!$rootScope.asomDocList.WD && (click && click.includes('onClickedWdurlLink'))) {
                                angular.element(anchor).addClass('noAnchor');
                                angular.element(anchor).removeAttr('ng-click');
                                angular.element(anchor).removeAttr('href');
                                angular.element(anchor).unbind('click');
                            }
                        })
                    }
                    
                    angular.forEach(tags, function (tag) {

                        if (controller.isNewTab) {
                            angular.element(tag).addClass('noDocumentation');
                        } else {
                            var node = angular.element(tag).attr('node');
                            var level = angular.element(tag).attr('level');
                            if (level) {
                                if (level == 1) {
                                    functionId = node;
                                }
                                if (level == 2) {
                                    subFunctionId = node;
                                }
                                if (level == 3) {
                                    titleId = node;
                                }

                                var wiringids = {
                                    "functionId": functionId,
                                    "subFunctionId": subFunctionId,
                                    "titleId": titleId
                                }
                                angular.element(tag).addClass('linkDocumentation');
                                angular.element(tag).bind("click", function ($event) {
                                    if ($event.currentTarget != $event.target && tag.querySelector("span") &&
                                        tag.querySelector("span").classList.contains("newMRIcon")) {
                                        controller.onClickedLink(sieref, tag.innerHTML, true);
                                    } else {
                                        controller.onClickedLink(sieref, tag.innerHTML, false);
                                    }
                                    scope.$apply();
                                });

                            }

                            var attr = angular.element(tag).attr('list');
                            if (!attr) {
                                return null;
                            }
                            var parsedAttr = JSON.parse(attr);
                            var sieref = rafinateSieApplicability(parsedAttr);
                            if (sieref && sieref.length == 0) {
                                angular.element(tag).addClass('noDocumentation');
                            } else {
                                if ($rootScope.isIndependentUser) {
                                    if ((sieref[0].type == 'MD' && $rootScope.asomDocList.MD) || (sieref[0].type == 'MR' && $rootScope.asomDocList.MR) || (sieref[0].type == 'MR' && $rootScope.asomDocList.MR && $rootScope.asomDocList.MD)) {
                                        var numberOfDoc = sieref.length;
                                        if (numberOfDoc === 1) {
                                            angular.element(tag).addClass('linkDocumentation');
                                        } else if (numberOfDoc > 1) {
                                            angular.element(tag).addClass('multipleLinkDocumentation');
                                        }
                                        angular.element(tag).bind("click", function ($event) {
                                            if ($event.currentTarget != $event.target && tag.querySelector("span") &&
                                                (tag.querySelector("span").classList.contains("newMRIcon"))) {
                                                controller.onClickedLink(sieref, tag.innerHTML, true);
                                            } else {
                                                controller.onClickedLink(sieref, tag.innerHTML, false);
                                            }
                                            scope.$apply();
                                        });

                                    } else {
                                        angular.element(tag).addClass('noDocumentation');
                                    }

                                } else {
                                    var numberOfDoc = sieref.length;
                                    if (numberOfDoc === 1) {
                                        angular.element(tag).addClass('linkDocumentation');
                                    } else if (numberOfDoc > 1) {
                                        angular.element(tag).addClass('multipleLinkDocumentation');
                                    }
                                    angular.element(tag).bind("click", function ($event) {
                                        if ($event.currentTarget != $event.target && tag.querySelector("span") &&
                                            (tag.querySelector("span").classList.contains("newMRIcon"))) {
                                            controller.onClickedLink(sieref, tag.innerHTML, true);
                                        } else {
                                            controller.onClickedLink(sieref, tag.innerHTML, false);
                                        }
                                        scope.$apply();
                                    });
                                }
                            }
                        }
                    });

                   var special = $document.find('img');
                     angular.forEach(special, function (tag) {
                        var attr = angular.element(tag).attr('linkvalue');
                        angular.element(tag).bind("click", function () {
                            controller.onClickedOutilSpeLink(attr);
                            scope.$apply();
                        });

                    });

                    var tagOutilSpe = $document.find('outilSpeRef');
                    angular.forEach(tagOutilSpe, function (tag) {
                        var attr = angular.element(tag).attr('outilSpeId');
                        if (!attr) {
                            return null;
                        }
                        angular.element(tag).addClass('linkDocumentation');

                        angular.element(tag).bind("click", function () {
                            controller.onClickedOutilSpeLink(attr, tag.innerHTML);
                            scope.$apply();
                        });
                    });
                } else {
                    var tags = $document.find('sieref');
                    angular.forEach(tags, function (tag) {
                        angular.element(tag).addClass('noDocumentation');
                    });
                }
            });
        }
        /** @ngInject */
        function controller($scope, ScrollService, $window) {
            var vm = this;
            vm.isClickFromIcon = false;
            vm.onClick = function (id) {
                ScrollService.toHash(id);
                /**
                 *   Slightly scroll to top,
                 *   cause of static header
                 */
                var top = $window.pageYOffset;
                $window.scrollTo(top, top - 80);
            }
        }


    }
    /* Re-structure data to show applicability for pup */
    function rafinateSieApplicability(list) {
        return list.map(function (applicabilityElem) {
            applicabilityElem.residual = (applicabilityElem.residual) ? applicabilityElem.residual : [];
            applicabilityElem.residual.forEach(function (residual) {
                applicabilityElem.applicabilities = [];
                residual.fixe = (residual.fixe) ? residual.fixe : [];
                residual.variable = (residual.variable) ? residual.variable : [];

                residual.fixe.forEach(function (fixe) {
                    applicabilityElem.applicabilities.push({
                        label: fixe.labelObj,
                        list: fixe.listCrit.map(function (crit) {
                            return crit.labelCrit + ' (' + crit.codeCrit + ')';
                        })
                    });
                });
                residual.variable.forEach(function (variable) {
                    applicabilityElem.applicabilities.push({
                        label: variable.labelObj,
                        list: variable.listCrit.map(function (crit) {
                            return crit.labelCrit + ' (' + crit.codeCrit + ')';
                        })
                    });
                });
            });
            return applicabilityElem;
        });
    }


})();


/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */

(function () {
    "use strict";


    angular.module("phenix")
    .directive('oneClickOnly', [  
        '$parse', '$compile','$rootScope', function($parse, $compile, $rootScope) {
          return {
            restrict: 'A',
            scope: false, // get the parent scope directly
            compile: function(element, attr) {
              var fn = $parse(attr['oneClickOnly']);
              return {
                pre: function(scope, element, attr) {
                  scope.oneClickOnly = scope.oneClickOnly || {}
                  scope.oneClickOnly[attr.id] = scope.oneClickOnly[attr.id] || {}
                  scope.oneClickOnly[attr.id].fn = function(value) {
                    scope.oneClickOnly[attr.id].val = value;
                  }
                  
                    $rootScope.$on('on-close-draft-list', function() {
                        scope.oneClickOnly[attr.id].val = false;
                        });
                  var clickingCallback = function(e) {
                    if(scope.oneClickOnly 
                      && scope.oneClickOnly[attr.id]
                      && scope.oneClickOnly[attr.id].val) {
                        scope.oneClickOnly[attr.id].val = false;
                      return

                    }              
                    scope.oneClickOnly[attr.id].fn(true)
                    fn(scope, { $event: e });
                  };
                  element.bind("click", clickingCallback)
                }
              }
            }
          }
        }
      ])
    .component("shoppingCartPartsRequisition", {
        bindings: {
            mainPiece: "<", // MUST BE DEFINE if type === 'PPS'
            piece: "=", // Object
            from: "@", // PR | TM
            type: "@", // PPS | UNDEFINED
            page: "@",
            // options is used for orderType, they are on rule on it for PPS
            // If user set a orderType on a PPS, it's should be apply on the main reference and all his PPS
            options: '=',
            checkDealerList: "<",
            landscape: '<'
        },
        controller: ShoppingCartPartsRequisitionController,
        controllerAs: "vm",
        templateUrl:
            "app/components/partRequisition/shoppingCart/shoppingCartPartsRequisition.template.html"
    });


    function ShoppingCartPartsRequisitionController(
        ShoppingCartPartsService,
        PartRequisitionMetierService,
        CacheService,
        listOfDraftModalService,
        globalConstant,
        CodesConstants,
        TypeOrderTools,
        ShoppingCartConstants,
        configConstantes,
        PartRequisitionConstants,
        CacheConstants,
        OrderModuleConstants,
        $q,
        $rootScope,
        $translate,
        $mdDialog,
        toastr,
        blockUI
    ) {
        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        var _actions = ShoppingCartConstants.actions;
        var vm = this;
        vm.canAddToPartsrequisition = true;

        var _oldQuantity = 0;
        var _partsReference = [];
        var _parts = [];
        var _VOI = [];
        var _orderType = 0;
        var _networkProfile = null;
        var _carContext = CacheService.getObject(CacheConstants.contextCarSearch);

        this.addToShoppingCart = addToShoppingCart;
        this.addOne = addOne;
        this.reduceOne = reduceOne;
        this.updateFromInput = updateFromInput;
        this.updateFromInputSecond = updateFromInputSecond;
        this.getVOI = getVOI;
        this.getShoppingCartClass = getShoppingCartClass;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            vm._computedPiece = vm.piece;

            _networkProfile = CacheService.getNetworkProfile();

            if (!_carContext && _networkProfile === CacheConstants.workshop){
                vm.canAddToPartsrequisition = false;
            }
            if (vm.from == 'PR' && vm.landscape && vm.landscape !== undefined) {
                var profil = CacheService.getObject(CacheConstants.profil);
                if (profil.isLandscape && profil.isLandscape != null) {
                    vm.isLandscape = true;
                }
            }
            // piece has orderType in partRequisition page
            _orderType = vm.piece.orderType;
            _parts = [].concat([vm.piece], vm.piece.additional).filter(function (part) {
                return part;
            });

            _VOI = getVOI(vm.piece.simplifiedResidual);

            _partsReference = _parts.map(function (part) {
                return part.reference;
            });
        };

        /**
         * @desc    This function is called to add the part in the partRequisition
         *          1) Check if a partRequisition is open
         *          2) Check orderType
         *          3) Update partRequisition
         *          4) Call HTTP for update in table.
         * @param   {void}
         * @return  {void}
         */

        function addToShoppingCart() {
            // display modal !!
            // update data
            var partsRequisition = CacheService.getObject(PartRequisitionConstants.bs);
            if(partsRequisition && partsRequisition.items.length >= 99){
                toastr.error($translate.instant('PR_MAX_LIMIT_ERROR'));
                return;
            }

            $rootScope.$broadcast('addPRInFullScreen');
            $q.resolve().then(function () {
                return !partsRequisition || !partsRequisition.id ? initPartRequisition() : null;
            }).then(function(result){
                var promise = result;
                if (_VOI.length) {
                    var parentEl = angular.element(document.body);
                    return $mdDialog.show({
                        locals: {
                            VOIList: _VOI
                        },
                        parent: parentEl,
                        templateUrl: 'app/components/basket/shoppingCart/modal-voi.template.html',
                        clickOutsideToClose: true,
                        controller: 'modalVoi',
                        bindToController: true,
                        controllerAs: 'vm'
                    }).catch(function () {
                        return $q.reject();
                    });
                }
                return promise;
            })
            .then(function () {
                var partsRequisition = CacheService.getObject(PartRequisitionConstants.bs);
                if(partsRequisition && partsRequisition.items.length >= 99){
                    toastr.error($translate.instant('PR_MAX_LIMIT_ERROR'));
                    return $q.reject();
                }
                else {
                var QUANTITY = 1;
                return handleTypeOrder(QUANTITY);
                }
            }).then(function (orderType) {
                var payload = buildPayload(
                    vm._computedPiece,
                    vm.from,
                    _actions.ADD_PIECE
                );
                blockUI.start();
                ShoppingCartPartsService.updateShoppingCart(
                    _actions.ADD_PIECE,
                    payload
                );

                if (orderType !== null) {
                    var partsToSetOrderType = TypeOrderTools.getPartsNotEnoughtStock(_parts, 1);
                    ShoppingCartPartsService.updateTypeOrder(partsToSetOrderType, orderType);
                }

                var operation = PartRequisitionMetierService.getOrdersAndSplits();

                /**
                 *  Set split (operation/intervention), if user is workshop/flag as true
                 */

                if (_networkProfile === CacheConstants.workshop && operation.isSplittingRequired === true &&
                    (operation.defaultSplitFlag === 1 || operation.defaultSplitFlag === 3)) {
                    var split = operation.splits[0];
                    ShoppingCartPartsService.updateSplit(_parts, split);
                }

                return PartRequisitionMetierService.onUpdateCart(_parts, _actions.ADD_PIECE);
            }).then(function () {
                vm.piece.quantity = 1;
                _oldQuantity = vm.piece.quantity;
                var orderMode = CacheService.getObject(CacheConstants.isOrderMode);
                if(orderMode){
                    var orderList = CacheService.getObject(CacheConstants.orderModePartsList);
                    if(orderList && !_.isEmpty(orderList.items)){
                        orderList.items.forEach(function(item){
                            if(item.reference == vm.piece.reference)
                                item.quantity++;
                        })                        
                        CacheService.setObject(CacheConstants.orderModePartsList,orderList);
                    }
                }
                updatePPSQuantity();
                displayPPS();

            }).catch(handleError).finally(function () {
                blockUI.stop();
            })
        }

        /**
         *  @desc get all VOI data from fixe residual
         *  @param {Array<Object>} [{
         *      fixe: [{
         *          codeObj: string
         *      }]
         *  }]
         *  @return {Array<Object>} [{
         *      codeObj: string,
         *      labelObj: string,
         *      langueObj: string,
         *      listCrit: [{
         *          codeCrit: string,
         *          labelCrit: string,
         *          langueCrit: string
         *      }]
         *  }]
         */

        function getVOI(residual) {
            if (!residual) {
                return [];
            }

            return residual.reduce(function (acc, applicability) {
                return applicability.fixe ? acc.concat(applicability.fixe) : acc;
            }, []).map(function (line) {
                return (line.codeObj == CodesConstants.VOI) ? line : null;
            }).filter(function (VOI) {
                return VOI;
            });
        }

        function handleTypeOrder(quantity) {
            if (vm.page === 'partsRequisition') {
                return $q.resolve(null);
            }
            if (!vm.options || _orderType > 0) {

                return $q.resolve(null);
            }
            var typeOrderAlreadySet = vm.options.orderType;

            if (typeOrderAlreadySet) {
                return $q.resolve(vm.options.orderType)
            }

            var outOfStock = TypeOrderTools.checkDMSStock(_parts, quantity);
            if (outOfStock) {
                // Go to popup type of order to set the type, and attach boolean OutOfStock to set default placeholder of dropdown button
                return TypeOrderTools.displayOrderTypeModal(outOfStock).then(function (id) {
                    vm.options.orderType = id;
                    _orderType = id;
                    return id;
                }).catch(function () {
                    return $q.reject(null);
                });
            }
            return $q.resolve(null);
        }

        function addOne() {
            var expectedQuantity = vm._computedPiece.quantity + 1;
          
            handleTypeOrder(expectedQuantity).then(function (orderType) {
                var payload = buildPayload(
                    vm._computedPiece,
                    vm.from,
                    _actions.ADD_PIECE
                );
                blockUI.start();
                ShoppingCartPartsService.updateShoppingCart(
                    _actions.ADD_ONE,
                    payload
                );

                if (orderType !== null) {
                    var partsToSetOrderType = TypeOrderTools.getPartsNotEnoughtStock(_parts, expectedQuantity);
                    ShoppingCartPartsService.updateTypeOrder(partsToSetOrderType, orderType);
                }
                return PartRequisitionMetierService.onUpdateCart(_parts, _actions.ADD_PIECE)
            }).then(function () {
               // vm.piece.quantity += 1;
                vm.piece.quantity = parseInt(vm.piece.quantity) + 1;

                _oldQuantity = vm.piece.quantity;
                var orderMode = CacheService.getObject(CacheConstants.isOrderMode);
                if(orderMode){
                    var orderList = CacheService.getObject(CacheConstants.orderModePartsList);
                    if(orderList && !_.isEmpty(orderList.items)){
                        orderList.items.forEach(function(item){
                            if(item.reference == vm.piece.reference)
                                item.quantity++;
                        })                        
                        CacheService.setObject(CacheConstants.orderModePartsList,orderList);
                    }
                }
                updatePPSQuantity();
            }).then(function(){

                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true)
                }

            }).catch(handleError).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @name reduceOne
         * @desc update item to part requisition basket, send it to the back
         * @desc decrement the the piece quantity and the pps quantities if exists
         * @memberOf Components.shoppingCartPartsRequisition
         */
        function reduceOne() {
            var payload = buildPayload(
                vm._computedPiece,
                vm.from,
                _actions.REDUCE_QUANTITY
            );

            blockUI.start();
            ShoppingCartPartsService.updateShoppingCart(
                _actions.REDUCE_ONE,
                payload
            );
            PartRequisitionMetierService.onUpdateCart(
                _parts,
                _actions.REDUCE_ONE
            ).then(function () {
                if (vm.piece.quantity.toString().indexOf(',') != -1) {
                    if (parseInt(vm.piece.quantity.toString().split(',')[0]) > 0) {
                        vm.piece.quantity = parseInt(vm.piece.quantity.toString().split(',')[0]);
                    }
                } else if (vm.piece.quantity > 0) {
                    if (vm.piece.quantity.toString().indexOf('.') != -1) {
                        vm.piece.quantity = parseInt(vm.piece.quantity);
                    } else {
                        vm.piece.quantity--;
                    }
                }                _oldQuantity = vm.piece.quantity;
                updatePPSQuantity();
            }, handleError).then(function(){
                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true)
                }
            }).finally(function () {
                blockUI.stop();
            });
        }

        function updateFromInput(oldQuantity) {
            if (vm.piece.quantity.toString().indexOf(',') != -1) {
                vm.piece.quantity = parseFloat(vm.piece.quantity.toString().replace(",", "."));
            }
            var number = vm.piece.quantity;
            var copyComputed = angular.copy(vm.piece);

            copyComputed.quantity = parseFloat(oldQuantity);
            handleTypeOrder(number).then(function (orderType) {
                var payload = buildPayload(
                    copyComputed,
                    vm.from,
                    _actions.REPLACE_QUANTITY,
                    number
                );

                ShoppingCartPartsService.updateShoppingCart(
                    _actions.REPLACE_QUANTITY,
                    payload
                );
                if (orderType !== null) {
                    var partsToSetOrderType = TypeOrderTools.getPartsNotEnoughtStock(_parts, number);
                    ShoppingCartPartsService.updateTypeOrder(partsToSetOrderType, orderType);
                }

                return PartRequisitionMetierService.onUpdateCart(
                    _parts,
                    _actions.REPLACE_QUANTITY
                )
            }).then(function () {
                _oldQuantity = number;
                updatePPSQuantity();
            }).then(function(){
                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true)
                }
            }).catch(function (err) {
                vm.piece.quantity = _oldQuantity;
                handleError(err);
            }).finally(function () {
                blockUI.stop();
            });
        }

        function updateFromInputSecond(quantity) {
            if (this.piece.quantity == 0 || _.isEmpty(this.piece.quantity)) {
                var msg = $translate.instant("ERROR_QUANTITY");
                toastr.error(msg);
                this.piece.quantity = 1;
                return;
            }
            updateFromInput(quantity);
        }

        /**
         * update pps quantity according to ratio
         */
        function updatePPSQuantity() {
            if (vm.piece.additional) {
                vm.piece.additional.forEach(function (pps) {
                    pps.quantity = vm.piece.quantity * pps.ratio;
                });
            }

            if (vm.piece.pps) {
                vm.piece.pps.forEach(function (pps) {
                    pps.quantity = vm.piece.quantity * pps.ratio;
                });
            }
        }

        /**
         * display pps items
         */
        function displayPPS() {
            if (vm.piece.additional) {
                vm.piece.showAdd = true;
            }
        }

        /**
         * handle error
         */
        function handleError(err) {
            if (!err) {
                return;
            }
            var msgError = $translate.instant("ERROR");
            toastr.error(msgError);
        }

        /**
         * Build payload according to the piece, type, action and quantity
         */
        function buildPayload(piece, type, action, quantity) {
            if (quantity != undefined) {
                if (quantity.toString().indexOf('.') != -1) {
                    quantity = parseFloat(quantity);
                } else if (quantity.toString().indexOf(',') != -1) {
                    quantity = parseFloat(quantity.toString().replace(",", "."));
                     //quantity = 999;
                } else {
                    quantity = parseInt(quantity);
                }
                //piece.quantity=quantity;
            }

            var payload = {};
            switch (action) {
                case _actions.ADD_PIECE: {
                    payload = {
                        piece: piece,
                        type: type
                    };
                    break;
                }
                case _actions.ADD_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type
                    };
                    break;
                }
                case _actions.REDUCE_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type
                    };
                    break;
                }
                case _actions.REPLACE_QUANTITY: {
                    payload = {
                        piece: piece,
                        type: type,
                        quantity: quantity
                    };
                }
            }

            return payload;
        }


        /**
         *  @desc Display a modal which user can choose to create a new partRequisition
         *        or an old one.
         *        If he want to create a new one, we don't need to do anything
         *        If it's the old one, we recover and restore it
         *  @param {void}
         *  @return {Promise<void>}
         */


        function initPartRequisition() {
            var body = angular.element(document.body);
            var modalParams = {
                body : body,
                typeOfSuperCart : globalConstant.partRequisition,
                title : "NEW_PARTLIST",
                subtitle : "PARTLIST_NO_ACTIVE_DRAFT",
                showList: true,
                showActifPartRequisition: false
            }

          return  listOfDraftModalService.showModal(modalParams).then(function (partRequisition) {
                var promise = null;
                    if (partRequisition.item) {
                        promise = PartRequisitionMetierService
                            .findPartRequisitionLogic(partRequisition.item)
                            .then(ShoppingCartPartsService.restorePartRequisition);
                    }
                    return promise;

            }).finally(function () {
                //  blockUI.stop();

            })
        }

        /**
         * @name getShoppingCartClass
         * @desc set class for shopping part requisition
         * @desc shopping-cart float-right class when user have access, shopping-cart float-right shopping-cart-disabled else
         */
        function getShoppingCartClass(){
            var shoppingCartClass = "shopping-cart float-right";
            if(!vm.canAddToPartsrequisition){
                shoppingCartClass += " shopping-cart-disabled";
            }
            return shoppingCartClass;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .constant('ShoppingCartConstants', {
            updateItem: '/partsRequisitions/updateItem',
            actions: {
                ADD_ONE: 'ADD_ONE',
                REDUCE_ONE: 'REDUCE_ONE',
                ADD_PIECE: 'ADD_PIECE',
                REPLACE_CART: 'REPLACE_CART',
                ADD_QUANTITY: 'ADD_QUANTITY',
                REDUCE_QUANTITY: 'REDUCE_QUANTITY',
                ADD_SPECIFIC_QUANTITY: 'ADD_SPECIFIC_QUANTITY',
                REPLACE_QUANTITY: 'REPLACE_QUANTITY',
                DELETE_PIECE: 'DELETE_PIECE',
                NOTFOUND: -1
            },
            timeoutToastr: 2000,
            minQuantity: 0,
            maxQuantity: 999,
            PRType: 'PR',
            PRODUCTSType: 'PRODUCTS',
            car: {
                Brand: "336",
                Model: "007",
                ModelType: "008",
                Engine: "999",
                GearBox: "997",
                BatteryType: '968'
            }
        });
}());

/**
 * PartRequisitionWsService
 * @namespace Services
 */
(function(){
    'use strict';

    angular
        .module('phenix')
        .service('PartRequisitionWsService', PartRequisitionWsService)

    /** @ngInject */
    function PartRequisitionWsService(RestUpgrade, PartRequisitionConstants){
        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        this.createPartRequisition = createPartRequisition;
        this.savePartRequisition = savePartRequisition;
        this.closePartRequsition = closePartRequsition;
        this.findPartRequisition = findPartRequisition;
        this.validatePartRequsition = validatePartRequsition;
        this.partRequisitionList = partRequisitionList;
        this.deletePartRequisition = deletePartRequisition;
        this.unlockPartRequisition = unlockPartRequisition;
        this.findPartRequisitionList = findPartRequisitionList;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace createPartRequisition
         * @desc create new part requisition
         * @param {object} payload
         * @example IN {}
         * @example OUT {"partRequisition":{"id":"ND000001"}}
         * @memberOf Services.createPartRequisition
         */
        function createPartRequisition(payload) {
            return RestUpgrade.all(PartRequisitionConstants.create).post(payload);
        }

        /**
         * @namespace savePartRequisition
         * @desc save part requisition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.savePartRequisition
         */
        function savePartRequisition(partRequisition) {

            return RestUpgrade.all(PartRequisitionConstants.save).post(partRequisition);
        }

        /**
         * @namespace closePartRequsition
         * @desc CLOSE part requisition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.closePartRequsition
         */
        function closePartRequsition(id) {
            return RestUpgrade.all(PartRequisitionConstants.close + id +'/close').post();
        }

         /**
         * @namespace findPartRequisition
         * @desc FIND part requisition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.closePartRequsition
         */
        function findPartRequisition(id) {
            return RestUpgrade.one(PartRequisitionConstants.find, id).get();
        }

         /**
         * @namespace validatePartRequsition
         * @desc FIND part requisition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.closePartRequsition
         */
        function validatePartRequsition(partRequisition) {
            return RestUpgrade.all(PartRequisitionConstants.validate).post(partRequisition);
        }

         /**
         * @namespace partRequisitionList
         * @desc get le list of part requisition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.partRequisitionList
         */
        function partRequisitionList(partRequisition) {
            return RestUpgrade.all(PartRequisitionConstants.partRequisitionList).post(partRequisition);
        }

        /**
         * @namespace deletePartRequisition
         * @desc delete part requisition
         * @param {Object} requestBody
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.partRequisitionList
         */
        function deletePartRequisition(requestBody){
            return RestUpgrade.all(PartRequisitionConstants.delete).post(requestBody);
        }

        /**
         * @namespace partRequisitionList
         * @desc unlock part requsition
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.partRequisitionList
         */
        function unlockPartRequisition(){
            return RestUpgrade.all(PartRequisitionConstants.unlock).post();
        }
        /**
         * @namespace findPartRequisitionList
         * @desc Query part requisition list
         * @example IN {}
         * @example OUT {}
         * @memberOf Services.findPartRequisitionList
         */
         function findPartRequisitionList(payload) {
            return RestUpgrade.all(PartRequisitionConstants.partRequisitionList).post(payload);
         }
    }
}());

/**
 * PartRequisitionMetierService
 * @namespace Services
 */
(function () {
    "use strict";

    angular
        .module("phenix")
        .service("PartRequisitionMetierService", PartRequisitionMetierService);

    /** @ngInject */
    function PartRequisitionMetierService(
        PartRequisitionWsService,
        DmsMetierService,
        ShoppingCartPartsRequisitionWSService,

        ShoppingCartPartsService,
        CacheService,

        ShoppingCartConstants,
        CacheConstants,
        CarSearchConstants,
        PartRequisitionConstants,
        CodesConstants,

        toastr,

        $translate,
        $q,
        $rootScope
    ) {
        var _searchBy = PartRequisitionConstants.searchBy;

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.initPartRequisition = initPartRequisition;
        this.getCurrentPartRequisition = getCurrentPartRequisition;
        this.setCurrentPartRequisition = setCurrentPartRequisition;
        this.saveAndCloseCurrentPartRequisition = saveAndCloseCurrentPartRequisition;
        this.cleanPartRequisition = cleanPartRequisition;
        this.findAndSetPartRequisitionCustomer = findAndSetPartRequisitionCustomer;

        this.createPartRequisitionLogic = createPartRequisitionLogic;
        this.savePartRequisitionLogic = savePartRequisitionLogic;
        this.closePartRequsitionLogic = closePartRequsitionLogic;
        this.findPartRequisitionLogic = findPartRequisitionLogic;
        this.searchClientLogic = searchClientLogic;
        this.validatePartRequsitionLogic = validatePartRequsitionLogic;
        this.partRequisitionListLogic = partRequisitionListLogic;
        this.deletePartRequisitionLogic = deletePartRequisitionLogic;
        this.unlockPartRequisitionLogic = unlockPartRequisitionLogic;
        this.isUserAllowedToOpenPartRequisition = isUserAllowedToOpenPartRequisition;
        this.findPartRequisitionList = findPartRequisitionList;

        this.onUpdateCart = onUpdateCart;
        this.getOrdersAndSplits = getOrdersAndSplits;
        this.isSetCustomerInformations = isSetCustomerInformations;
        this.isSetOrderTypePartRequisitionItems = isSetOrderTypePartRequisitionItems;
        this.isSetInterventionsPartRequisitionItems = isSetInterventionsPartRequisitionItems;
        this.isSetOrderNumberPartRequisition = isSetOrderNumberPartRequisition;
        this.getPartListIdFromDmsResponse = getPartListIdFromDmsResponse;
        this.getPartRequisitionItemLocation = getPartRequisitionItemLocation;
        this.setPartRequisitionValidationInfos = setPartRequisitionValidationInfos;
        this.buildClientForPrintPayload = buildClientForPrintPayload;
        this.addTranslatedOrderTypeToItems = addTranslatedOrderTypeToItems;
        this.formatItemsForPrintPayload = formatItemsForPrintPayload;

        /**
         * @desc    Create a partRequisition and save context car with DMS
         *          information
         * @param {Object} quoteData - used when we create a part requisition from a quote (accountNumber and orderNumber)
         * @param   {Array<Object>} items
         * @return  Promise<{
         *              id: string,
         *              number: string
         *              ...
         *          }>
         */

        function initPartRequisition(items, quoteData) {
            var profile = CacheService.getNetworkProfile();
            var isWorkshop = profile === CarSearchConstants.networkProfileWorkshop;
            var DMSVehicle = CacheService.getObject(CacheConstants.dmsResponse);
            var accountNumber = getAccountNumber();
            var payload = {
                type: profile
            }

            // reset customer from old partRequisition
            // we may don't need to do this, it's here by safety
            CacheService.savePartRequisitionCustomer(null);

            if (accountNumber && isWorkshop) {
                _.extend(payload, {
                    accountNumber: accountNumber
                });
            }

            var carContext = CacheService.getCarContext();
            var carContextSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var vehicleKnownBvm = CacheService.getObject(CacheConstants.vehiclePresentInDMSbutNotInBVM);
            if (items) {
                _.extend(payload, {
                    items: items
                });
            }

            //if vehicle is not knwon by bvm, get car context
            if (vehicleKnownBvm) {
                carContext = carContext.vehicle;
            }

            if (carContext) {
                var car = {
                    "vin": carContext.vin,
                    "registrationNumber": carContext.registrationNumber,
                    "brand": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Brand] : null,
                    "familyVehicle": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Model] : null,
                    "bodyType": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.ModelType] : null,
                    "engineType": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Engine] : null,
                    "gearboxType": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.GearBox] : null,
                    "batteryType": carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.BatteryType] : null,
                    "vehicleDesignation": carContext.model ? carContext.model : null
                };

                if (DMSVehicle && DMSVehicle.registrationNumber && DMSVehicle.registrationNumber != "") {
                    car.registrationNumber = DMSVehicle.registrationNumber;
                }
                _.extend(payload, car);
            }

            var orderAndSplits = getOrdersAndSplits();
            var hasOnlyOneOrderNumber = orderAndSplits && orderAndSplits.openOrderFlag == CodesConstants.ONE_ORDER_TYPE;

            if (hasOnlyOneOrderNumber && isWorkshop) {
                _.extend(payload, {
                    orderNumber: orderAndSplits.orderNumber
                });
            }

            if (quoteData && quoteData.accountNumber) {
                _.extend(payload, {
                    accountNumber: quoteData.accountNumber
                })
            }

            if (quoteData && quoteData.orderNumber && isWorkshop) {
                _.extend(payload, {
                    orderNumber: quoteData.orderNumber
                })
            }
            return createPartRequisitionLogic(payload).then(function (partRequisition) {
                if (isWorkshop) {
                    // handle default customer in partRequisition page
                    var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                    if (dmsResponse && dmsResponse.customer) {
                        _.extend(dmsResponse.customer, {
                            accountNumber: dmsResponse.accountNumber
                        });
                        CacheService.savePartRequisitionCustomer({
                            value: dmsResponse.customer
                        });
                    }
                }


                CacheService.setObject(PartRequisitionConstants.bs, partRequisition);
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionCreatedEvent);
                return partRequisition;
            });
        }

        /**
         * @name getCurrentPartRequisition
         * @desc get current partRequisition
         */

        function getCurrentPartRequisition() {
            return CacheService.getObject(PartRequisitionConstants.bs);
        }

        /**
         * @name setCurrentPartRequisition
         * @desc set the current partRequisition
         * @param partRequisition
         */
        function setCurrentPartRequisition(partRequisition) {
            return CacheService.setObject(PartRequisitionConstants.bs, partRequisition);
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name createPartRequisitionLogic
         * @desc create new part requisition logic
         * @param {object} payload
         * @example OUT
         * @memberOf Services.createPartRequisitionLogic
         */
        function createPartRequisitionLogic(payload) {
            return PartRequisitionWsService.createPartRequisition(payload);
        }


        /**
            * @name getAccountNumber
            * @desc get user accountNumber's
            * @return {number | null}
            */
        function getAccountNumber() {
            var carSearchContext = CacheService.getCarSearchContext();
            if (carSearchContext && carSearchContext.accountNumber) {
                return carSearchContext.accountNumber;
            }
            return null;
        }

        /**
         *  @desc Get an object which contains a list of splits and the order number
         *  @return {Object}
         */

        function getOrdersAndSplits() {
            var carSearchContext = CacheService.getCarSearchContext();
            if (carSearchContext && carSearchContext.ordersAndSplits) {
                return carSearchContext.ordersAndSplits;
            }
            return null;
        }

        /**
         * @name saveAndClosePartRequisition
         * @param {*} currentQuote
         */
        function saveAndCloseCurrentPartRequisition(currentPartRequisition) {
            //save current part requisition
            return savePartRequisitionLogic(currentPartRequisition)
                .then(function (currentPartRequisition) {
                    if (!currentPartRequisition) {
                        return $q.reject(-1);
                    }
                    return currentPartRequisition;
                }).then(function (currentPartRequisition) {
                    //close current part requisition
                    return closePartRequsitionLogic(currentPartRequisition.id)
                        .catch(function () {
                            return $q.reject(-2);
                        });
                }).then(function () {
                    return 0;
                });
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name savePartRequisitionLogic
         * @desc save part requisition
         * @example IN
         * @example OUT
         * @memberOf Services.savePartRequisitionLogic
         */
        function savePartRequisitionLogic(partRequisition) {
            var car = getCarInformations();
            var quoteCustomer = CacheService.getQuoteCustomer();
            var carContextSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var DMSVehicle = CacheService.getObject(CacheConstants.dmsResponse);
            if (car) {
                _.extend(partRequisition, car);
                partRequisition.registrationNumber = carContextSearch.vehicle ? carContextSearch.vehicle.registrationNumber : car.registrationNumber;
                partRequisition.vin = carContextSearch.vehicle ? carContextSearch.vehicle.vin : car.vin;
            }

            if (DMSVehicle && DMSVehicle.vehicle && DMSVehicle.registrationNumber != "") {
                partRequisition.registrationNumber = DMSVehicle.vehicle.registrationNumber;
            }

            var customerData = CacheService.getPartRequisitionCustomer();
            if (customerData) {
                partRequisition.accountNumber = customerData.value.accountNumber;
            }
            else{
                partRequisition.accountNumber = quoteCustomer ? quoteCustomer.accountNumber : null;
            }

            return PartRequisitionWsService.savePartRequisition(partRequisition).then(function (result) {
                CacheService.setObject(PartRequisitionConstants.bs, result);
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionUpdatedEvent);
                return result;
            });
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name closePartRequsitionLogic
         * @desc close part requisition
         * @example IN
         * @example OUT
         * @memberOf Services.closePartRequsitionLogic
         */

        function closePartRequsitionLogic(id) {
            return PartRequisitionWsService.closePartRequsition(id).then(function (result) {
                cleanPartRequisition();
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionClosedEvent);
                return result;
            });
        }

        /**
         * @namespace ShoppingCartPartsService
         * @desc used after each user action on the part requisition
         * @desc it computed part requisition, send it to nd service
         * @desc and handle return (put id on part requisition on success, set the previous basket and return false on failure)
         * @param {Array} refs - refs to update
         * @param {Object} quote - exist if we put quote items to selected or actif part requisition
         * @memberOf Services.ShoppingCartPartsService
         */

        function onUpdateCart(refItems, quote) {

            var refs = refItems.map(function(part){ return part.reference})
            var _shoppingCart = ShoppingCartPartsService.getShoppingCart();
            _shoppingCart.forEach (function (item) {
                if(!item.index && !item.herculesCase){
                    refItems.forEach (function (ref) {
                        if(ref.reference === item.reference){
                    _.extend(item,{
                        "index":ref.index ? ref.index : ref.indexOfMainArray,
                        "herculesCase":ref.herculesCase,
                        "plateId":ref.plateId ? ref.plateId : ref.catalogPlate
                    });
                }
            })
                }
            })
            var items = _.intersectionWith(_shoppingCart, refs, function (itemShoppingCart, reference) {
                return itemShoppingCart.reference == reference;
            }).map(function (currentItem) {
                var refData = _.find(refItems,function(data){
                    if(data.reference === currentItem.reference){
                    _.assign(currentItem, { familyCode: data.familyCode });
                        return data;
                    }
                })
                var item = {
                    "reference": currentItem.reference,
                    "designation": currentItem.designation,
                    "reach": !!currentItem.reach,
                    "quantity": currentItem.quantity,
                    "price": currentItem.priceHT,
                    "currency": currentItem.currency,
                    "orderType": refData.orderType ? refData.orderType : currentItem.orderType,
                    "genericPart":currentItem.genericPart,
                    "sbomId":currentItem.sbomId,
                    "index":currentItem.index,
                    "herculesCase":currentItem.herculesCase,
                    "plateId":currentItem.plateId,
                    "familyCode": currentItem.familyCode 
                }
                if (currentItem.interventionId) {
                    _.extend(item, {
                        "interventionId": currentItem.interventionId,
                        "interventionLabel": currentItem.interventionLabel ? currentItem.interventionLabel.slice(0, 80) : ''
                    })
                }

                if(currentItem.lineNumber){
                    _.extend(item, {
                        "lineNumber": currentItem.lineNumber
                    })
                }
                return item
            });
            var DMSVehicle = CacheService.getObject(CacheConstants.dmsResponse);
            var carContextSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var carContext = CacheService.getCarContext();
            var bs = CacheService.getObject(PartRequisitionConstants.bs);



            if (!bs) {
                return initPartRequisition(items).catch(function () {
                    toastr.error($translate.instant('PART_REQUISITION_FAILURE', { timeout: ShoppingCartConstants.timeoutToastr }));
                    return $q.reject("Error");
                });
            } else {
                //add car context informations only if car context is set
                var requestBody = {
                    "designation": null,
                    "items": items
                };

                if (carContext !== null && carContext.vehicle) {
                    carContext = carContext.vehicle;
                }


                if (carContext) {
                    requestBody.vin = carContext.vin ? carContext.vin : null;
                    requestBody.registrationNumber = carContextSearch.vehicle.registrationNumber;
                    requestBody.brand = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Brand] : null;
                    requestBody.familyVehicle = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Model] : null;
                    requestBody.bodyType = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.ModelType] : null;
                    requestBody.engineType = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.Engine] : null;
                    requestBody.gearboxType = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.GearBox] : null;
                    requestBody.batteryType = carContext.fixedCriterias ? carContext.fixedCriterias[ShoppingCartConstants.car.BatteryType] : null;
                }

                if (DMSVehicle && DMSVehicle.registrationNumber && DMSVehicle.registrationNumber != "") {
                    requestBody.registrationNumber = requestBody.registrationNumber;
                }

                //set BS Id
                requestBody.id = bs.id;
                //update item bs
                for (var key in requestBody.items) {
                    if (requestBody.items[key]) {
                        if (requestBody.items[key].quantity % 1 != 0) {
                            requestBody.items[key].quantity = parseFloat(requestBody.items[key].quantity).toFixed(4);
                        }
                    }
                }

                return updateItemsBs(requestBody).then(function (partRequisition) {
                    //if put quote items in a part requisition and account number exist,
                    //part requisition's account number should be quote's account number
                    if (quote && quote.accountNumber) {
                        partRequisition.accountNumber = quote.accountNumber;
                    }

                    //if put quote items in a part requisition and order number exist,
                    //part requisition's order number should be quote's order number
                    if (quote && quote.orderNumber) {
                        partRequisition.orderNumber = quote.orderNumber;
                    }
                    updatePartsRequisitionInCache(partRequisition)
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionUpdatedEvent);
                    return partRequisition;
                });
            }
        }

        /**
         *
         * This function is used to send request to nd-services
         * and display toastrs success for adding to part list, updating to part list and deleted to partlist
         * or display toastr error while manage part list item
         *
         */

        function updateItemsBs(requestBody) {
            //var isDeleted = isItemsDeleted(requestBody.items);
            return ShoppingCartPartsRequisitionWSService.updateItem(requestBody).catch(function () {
                toastr.error($translate.instant('TOASTER_ERROR_ADD_TO_PARTLIST'), { timeout: ShoppingCartConstants.timeoutToastr });
                return $q.reject("Error");
            });
        }

        /**
         * @namespace updatePartsRequisitionInCache
         * @desc set shopping cart
         * @memberOf Services.ShoppingCartPartsService
         */

        function updatePartsRequisitionInCache(partReq) {
            CacheService.setObject(PartRequisitionConstants.bs, partReq);
        }

        function cleanPartRequisition() {
            CacheService.savePartRequisitionCustomer(null);
            CacheService.removeObject(PartRequisitionConstants.bs);
            ShoppingCartPartsService.setShoppingCart([]);
        }

        /**
         * @desc get customer data with partRequisition accountNumber and save it in the cache
         * @param {Object} partRequisitionCustomer
         */
        function findAndSetPartRequisitionCustomer(partRequisitionCustomer) {
            //if account number exist, call account.v1 dms request
            if (!_.isEmpty(partRequisitionCustomer.accountNumber)) {
                return DmsMetierService.getUserByAccount({
                    accountNumber: partRequisitionCustomer.accountNumber
                }).then(function (customerTmp) {
                    if(customerTmp && customerTmp.response){
                        CacheService.savePartRequisitionCustomer({
                            value: customerTmp.response.customer
                        });
                    }else{
                        return $q.reject();
                    }
                }).catch(function(err){
                    return $q.reject(err)
                });
            }
            //else return PartRequisitionCustomer to null
            else {
                CacheService.savePartRequisitionCustomer(null);
                return $q.resolve();
            }
        }


        /**
        * @namespace findPartRequsitionLogic
        * @desc find part requisition
        * @param {string} id
        * @return {promise}
        * @memberOf Services.closePartRequsitionLogic
        */

        function findPartRequisitionLogic(id) {
            return PartRequisitionWsService.findPartRequisition(id).then(function (partRequisition) {
                if (partRequisition.status !== 'VALID') {
                    CacheService.setObject(PartRequisitionConstants.bs, partRequisition);
                }
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionClosedEvent);
                return partRequisition;
            });
        }

        /**
         * @namespace findPartRequsitionLogic
         * @desc find part requisition
         * @param {number} offset (Pagination)
         * @return {promise}
         * @memberOf Services.closePartRequsitionLogic
         */
        function findPartRequisitionList(offset) {
            var carInformations = getCarInformations();
            var payload = {}

            if (carInformations) {
                payload = {
                    filter: carInformations
                }
            }

            _.extend(payload, {
                sort: {
                    by: "DATE",
                    order: -1
                },
                pagination: {
                    limit: PartRequisitionConstants.pagination.limit,
                    offset: offset
                }
            })

            return PartRequisitionWsService.findPartRequisitionList(payload);
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name searchClientLogic
         * @desc search client by name,surname,compte
         * @example IN
         * @example OUT
         * @memberOf Services.searchClientLogic
         * @param {*} client
         */
        function searchClientLogic(client) {
            //return BusinessWSService.getDmsData(client);
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name validatePartRequsitionLogic
         * @desc validate a part requisition
         * @example IN
         * @example OUT
         * @memberOf Services.searchClientLogic
         */
        function validatePartRequsitionLogic(partRequisition) {
            partRequisition.partsRequisitionUserId = partRequisition.dmsLoginInformations.username;
            return PartRequisitionWsService.validatePartRequsition(partRequisition).then(function (result) {
                CacheService.removeObject(PartRequisitionConstants.bs);
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionClosedEvent);
                return result;
            });
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name partRequisitionListLogic
         * @desc get part requisition list
         * @param {Object} filter
         * @param {Object} sort
         * @param {Object} pagination
         */

        function partRequisitionListLogic(filter, sort, pagination) {
            if (filter && filter.status) {
                if (filter.status === PartRequisitionConstants.draftStatus) {
                    filter = _.assign(_.omit(filter, 'ipn'), { lastModifierIpn: filter.ipn });
                } else if (filter.status === PartRequisitionConstants.validatedStatus) {
                    filter = _.assign(_.omit(filter, 'ipn'), { validatorIpn: filter.ipn });
                }
            }

            var requestBody = {
                filter: filter || undefined,
                sort: sort,
                pagination: pagination
            };

            return PartRequisitionWsService.partRequisitionList(requestBody).then(function (response) {
                return {
                    partsRequisitions: addPartsRequisitionsInformations(response.partsRequisitions),
                    totalCount: response.totalCount
                }
            });
        }


        /**
         * @namespace PartRequisitionMetierService
         * @name deletePartRequisitionLogic
         * @desc delete parts requisitions
         * @param {Object} partRequisitionIds
         */
        function deletePartRequisitionLogic(partRequisitionIds) {
            var requestBody = {
                partsRequisitionIds: partRequisitionIds
            };
            return PartRequisitionWsService.deletePartRequisition(requestBody).then(function (result) {
                $rootScope.$emit(PartRequisitionConstants.partsRequisitionClosedEvent);
                return result;
            });
        }

        /**
        * @namespace PartRequisitionMetierService
        * @name unlockPartRequisitionLogic
        * @desc unlock parts requisitions updated by the current user
        */
        function unlockPartRequisitionLogic() {
            return PartRequisitionWsService.unlockPartRequisition().then(function (response) {
                if (response.status === 200) {
                    CacheService.removeObject(PartRequisitionConstants.bs);
                    $rootScope.$emit(PartRequisitionConstants.partsRequisitionClosedEvent);
                    return response.unlockCarts;
                }
            })
        }

        /**
         * @name isSetCustomerInformations
         * @desc check if customer informations are set
         * @param {Object} customerInformations
         * @return {Boolean}
         */
        function isSetCustomerInformations(customerInformations) {
            return (customerInformations && (customerInformations.name != "" && customerInformations.accountNumber != ""));
        }

        /**
         * @name isSetOrderTypePartRequisitionItems
         * @desc check if order type is set for part requisition items
         * @param {Object} partRequisitionItems
         * @return {Boolean}
         */
        function isSetOrderTypePartRequisitionItems(partRequisitionItems) {
            var result = true;
            partRequisitionItems.some(function (part) {

                var orderTypeIsSet = part.orderType;

                if ((!part.dmsInformations || part.dmsInformations.quantity == 0) && !part.orderType) {
                    result = false;
                }

                if (part.dmsInformations && part.dmsInformations.quantity) {
                    var notEnoughQuantity = part.dmsInformations.quantity < part.quantity;
                    if (!orderTypeIsSet && notEnoughQuantity) {
                        result = false;
                    }
                }
            });
            return result;
        }

        /**
         * @name isSetInterventionsPartRequisitionItems
         * @desc check if interventions are set for part requisition items
         * @param {Object} partRequisitionItems
         * @return {Boolean}
         */
        function isSetInterventionsPartRequisitionItems(partRequisitionItems) {
            var result = true;
            partRequisitionItems.some(function (part) {
                if (part) {
                    var interventionIsSet = part.interventionId;
                    var intervention = getOrdersAndSplits();
                    if ((interventionIsSet === null || interventionIsSet === '-') && intervention.isSplittingRequired) {
                        result = false;
                    }
                }
            });
            return result;
        }

        /**
         * @name isSetOrderNumberPartRequisition
         * @desc check if order number is set for part requisition
         * @param {Object} partRequisition
         * @return {Boolean}
         */
        function isSetOrderNumberPartRequisition(partRequisition) {
            var result = true;
            if (!partRequisition || partRequisition.orderNumber === '-' || !partRequisition.orderNumber) {
                result = false;
            }
            return result;
        }

        /**
         * @name getPartListIdFromDmsResponse
         * @desc get part list id from dms response
         * @param {Object} dmsPartRequisitionResponse
         * @return {Int}
         */
        function getPartListIdFromDmsResponse(dmsPartRequisitionResponse) {
            var dmsPartListId = '';
            if (dmsPartRequisitionResponse && dmsPartRequisitionResponse.response && dmsPartRequisitionResponse.response.dmsPartListId) {
                dmsPartListId = dmsPartRequisitionResponse.response.dmsPartListId;
            }
            return dmsPartListId;
        }

        /**
         * @name getPartRequisitionItemLocation
         * @desc get location for each part requisition item
         * @param {Object} partRequisitionItems
         * @return {Array}
         */
        function getPartRequisitionItemLocation(partRequisitionItems) {
            angular.forEach(partRequisitionItems, function (partRequisitionItem) {
                if (partRequisitionItem.dmsInformations) {
                    partRequisitionItem.location = partRequisitionItem.dmsInformations.location;
                }
            });
            return partRequisitionItems;
        }

        /**
         * @name setPartRequisitionValidationInfos
         * @desc set validation infos for part requisition (status, validationInfos, validatorIPN)
         * @param {Object} partRequisition
         * @param {Object} partRequisitionValidationResponse
         * @return {Object}
         */
        function setPartRequisitionValidationInfos(partRequisition, partRequisitionValidationResponse) {
            partRequisition.status = partRequisitionValidationResponse.status;
            partRequisition.validationDateTime = partRequisitionValidationResponse.validationDateTime;
            partRequisition.validatorIPN = partRequisitionValidationResponse.validatorIPN;
            return partRequisition;
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @namespace PartRequisitionMetierService
         * @name addPartsRequisitionsInformations
         * @desc add context car vehicle informations
         * @param {Array} partRequisitionList
         */
        function addPartsRequisitionsInformations(partRequisitionList) {

            partRequisitionList.map(function (currentPartRequisition) {
                var vehiculeLabel = '';
                var searchBy = 0;

                if (currentPartRequisition.vin) {
                    vehiculeLabel = currentPartRequisition.vin
                    searchBy = _searchBy.vin;
                    if (currentPartRequisition.registrationNumber) {
                        vehiculeLabel += ' | ' + currentPartRequisition.registrationNumber
                    }
                }
                else if (currentPartRequisition.registrationNumber) {
                    vehiculeLabel = currentPartRequisition.registrationNumber
                    searchBy = _searchBy.registrationNumber;
                }
                else if (currentPartRequisition.brand) {
                    vehiculeLabel = currentPartRequisition.familyVehicle + ', ' + currentPartRequisition.bodyType + ', ' + currentPartRequisition.engineType + ', ' + currentPartRequisition.gearboxType
                    searchBy = _searchBy.model;
                }

                currentPartRequisition.vehiculeLabel = vehiculeLabel;
                currentPartRequisition.searchBy = searchBy;

                return currentPartRequisition;
            });
            return partRequisitionList;
        }

        /**
         * @namespace PartRequisitionMetierService
         * @name isUserAllowedToOpenPartRequisition
         * @desc check if current user is allowed to open current part requisition
         * @param {Array} partRequisitionList
         */
        function isUserAllowedToOpenPartRequisition(userIpn, currentRequisitionIpn) {
            return userIpn == currentRequisitionIpn || currentRequisitionIpn === null;
        }

        /**
         *  @desc Get car informations, with vin/or registrationNumber
         *  @param {void}
         *  @return {object}
         */

        function getCarInformations() {
            var code = CodesConstants;
            var car = CacheService.getCarContext();
            var vehicleKnownBvm = CacheService.getObject(CacheConstants.vehiclePresentInDMSbutNotInBVM);
            if (vehicleKnownBvm) {
                car = car.vehicle;
            }

            var payload = !car ? null : {
                vin: car.vin ? car.vin : null,
                registrationNumber: car.registrationNumber ? car.registrationNumber : null,
                brand: car.fixedCriterias ? car.fixedCriterias[code.brand] : null,
                familyVehicle: car.fixedCriterias ? car.fixedCriterias[code.familyVehicle] : null,
                bodyType: car.fixedCriterias ? car.fixedCriterias[code.bodyType] : null,
                engineType: car.fixedCriterias ? car.fixedCriterias[code.engineType] : null,
                gearboxType: car.fixedCriterias ? car.fixedCriterias[code.gearboxType] : null,
                batteryType: car.fixedCriterias ? car.fixedCriterias[code.batteryType] : null,
                vehicleDesignation: car.model ? car.model : null
            };

            return payload;
        }

        /**
         *      @desc   Receive an array of string, filter it, and join with a space
         *      @param  {array<string>} data
         *      @return {string}
         */

        function composeStr(data) {
            return data.filter(function (e) {
                return e;
            }).join(' ')
        }

        function buildClientForPrintPayload(printItem, currentCustomer, isQuote, prDiscount, tmDiscount) {

            var itemToBePrinted = angular.copy(printItem);
            
            if(itemToBePrinted && itemToBePrinted.inter){
                var interListDup = itemToBePrinted.inter;
                if(!_.isEmpty(interListDup)){
                    interListDup.forEach(function(inter){
                        var interArr = [];
                        if(inter.PR && !_.isEmpty(inter.PR)){
                            angular.forEach(inter.PR, function (value){
                                if(value.quantity > 0){
                                    interArr.push(value);
                                }
                            });
                        }
                        
                    var index = interListDup.indexOf(inter);
                    itemToBePrinted.inter[index].PR = interArr;
                    })
                }
               
            }

            var client = composeStr([
                currentCustomer.name,
                currentCustomer.firstName,
                currentCustomer.accountNumber ? "(" + currentCustomer.accountNumber + ")" : null
            ]);
            var clientAdress = composeStr([
                currentCustomer.streetNumber,
                currentCustomer.streetName
            ]);

            var clientAdressEnd = composeStr([
                currentCustomer.postCode,
                currentCustomer.city
            ]);

            var clientAdressPhoneAndMail = composeStr([
                currentCustomer.mainPhone,
                currentCustomer.email
            ]);
            itemToBePrinted.client = client;
            itemToBePrinted.clientAdress = clientAdress;
            itemToBePrinted.clientAdressEnd = clientAdressEnd;
            itemToBePrinted.clientAdressPhoneAndMail = clientAdressPhoneAndMail;
            if (isQuote) {
                itemToBePrinted.showDiscountRatePR = prDiscount ? prDiscount : false;
                itemToBePrinted.showDiscountRateTM = tmDiscount ? tmDiscount : false;

            }
            return itemToBePrinted;
        }


        function formatItemsForPrintPayload(items) {

            angular.forEach(items, function (value) {
                if (value.dmsInformations && value.dmsInformations.location) {
                    value.location = value.dmsInformations.location;
                }
                if (value.dmsInformations && value.dmsInformations.priceExclTaxes) {
                    value.price = value.dmsInformations.priceExclTaxes;
                }
            })
            return items;
        }

        function addTranslatedOrderTypeToItems(items) {
            angular.forEach(items, function (value) {
                var orderTypeLabel;
                var orderType = parseInt(value.orderType);
                switch (orderType) {
                    case 0:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_DEFAULT');
                        break;
                    case 1:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_PVI');
                        break;
                    case 2:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_Urgence1');
                        break;
                    case 3:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_Urgence2');
                        break;
                    case 4:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_MISSSELL');
                        break;
                    default:
                        orderTypeLabel = $translate.instant('PARTLIST_MODAL_TYPEORDER_DEFAULT');
                        break;
                }
                value.orderTypeLabel = orderTypeLabel;

            })
            return items;
        }
    }
})();

(function () {
    'use strict';
  
    angular.module('phenix').config(routerConfig);
  
    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.validatedOrder, {
            url: '/validatedOrder/:id',
            templateUrl: 'app/components/orderModule/validate/validatedOrder.template.html',
            controller: 'ValidatedOrderController',
            controllerAs: 'vm',
            params: {
              validatedOrder :null,
              vehicle : null,
              isCountryIndia :false,
              isCountryChina :false,
              isCountryRoumania :false,
              addOrderResponse : null,
              isBackButtonExist:false,
              validatorInfo: null
            }
        });
    }
  
  })();
  
  
(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("ValidatedOrderController", ValidatedOrderController);

    /** @ngInject */
    function ValidatedOrderController(
        $state, $window, CacheService,CacheConstants, RoutesConstants,toastr, $translate, $mdDialog, blockUI, $location,SuperCartMetierService,globalConstant,PartRequisitionMetierService,FileSaver,$q,UtilsMetierService
    ) {
        var vm = this;
        vm.isBackButtonExist = true;
        vm.showAllDiscountRate = false;
        vm.isDmsConnected = CacheService.getObject('dms');
        vm.vehicle = {};
        vm.addOrderResponse = null
        vm.validatorInfo = null;
        vm.validatedDateAndInfo = '';
        vm.backToPrevious = backToPrevious;
        vm.sortBy = sortBy;
        vm.displayDiscountRate = displayDiscountRate;
        vm.displayAllDiscountRate = displayAllDiscountRate;
        vm.printOrder = printOrder;
        vm.getPriceToDisplay = getPriceToDisplay;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.downloadCSV = downloadCSV;

        init();

        /* window.addEventListener('popstate', function (event) {
            backToPrevious();
        }); */
        function init() {
            blockUI.stop();
            if ($state.params) {
                vm.validatedOrder = $state.params.validatedOrder;
                vm.vehicle = $state.params.vehicle;
                vm.isCountryIndia = $state.params.isCountryIndia;
                vm.isCountryChina = $state.params.isCountryChina;
                vm.isCountryRoumania =  $state.params.isCountryRoumania;
                vm.addOrderResponse = $state.params.addOrderResponse;
                vm.validatorInfo = $state.params.validatorInfo;
                
            }
            if(vm.addOrderResponse && vm.addOrderResponse.orderNumber){
                toastr.success($translate.instant("ORDER_PLACED_SUCCESS"));
                var dealerId = CacheService.getObject(CacheConstants.profil) ? CacheService.getObject(CacheConstants.profil).dealerId : null;
                dynaOrderTracking(dealerId)
                //showOrderNotSavedInDbModal();
            }
            /* else{
                toastr.error($translate.instant("ORDER_PLACED_ERROR"));
                //showOrderNotSavedInDbModal();
            } */
            getValidatedDate();
        }

        function dynaOrderTracking(userDealerId){
            return $q.resolve().then(function(){
                     dtrum.sendSessionProperties(null,null,{"validatedorderdealerid":userDealerId},null);
                     return;
                     }).catch(function(err) {
                         return $q.resolve(userDealerId);
                     });
    
        }
    
        function getValidatedDate(){   
            var dataAndTime = vm.validatorInfo.dateAndTime.split(' ');         
           if(!_.isEmpty(dataAndTime) && vm.addOrderResponse){
                vm.validatedDateAndInfo = $translate.instant('ORDER_VALIDATED')+' '+$translate.instant('COMMON_ON')+ ' ' + dataAndTime[0] + ' '+$translate.instant('COMMON_AT') + ' ' + dataAndTime[1]+ ' ' +$translate.instant('ACTION_BY')+ ' ' +vm.validatorInfo.ipn;
            }
            return vm.validatedDateAndInfo;
        }
        function backToPrevious() {
            CacheService.removeObject(CacheConstants.isOrderMode);
            CacheService.removeObject(CacheConstants.newOrderStart);
            CacheService.removeObject(CacheConstants.newNonDmsOrderStart);
            if (!$state.params.partsRequisitionOptions) {
                $window.history.back();
            }
            else {
                $state.go(RoutesConstants.partRequisitionListValidated, {
                    partsRequisitionOptions: $state.params.partsRequisitionOptions
                });
            }
        }
        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }
        function displayDiscountRate(pr) {
            pr.isDiscountcodeVisible = (pr.isDiscountcodeVisible) ? false : true;
            if (vm.validatedOrder.items.length == 1)
                vm.showAllDiscountRate = false;
        }

        function displayAllDiscountRate() {
            if (vm.validatedOrder && !_.isEmpty(vm.validatedOrder.items)) {
                if (!vm.showAllDiscountRate) {
                    vm.validatedOrder.items.forEach(function (pr) {
                        pr.isDiscountcodeVisible = true;
                    })
                    vm.showAllDiscountRate = true;
                } else {
                    vm.validatedOrder.items.forEach(function (pr) {
                        pr.isDiscountcodeVisible = false;
                    })
                    vm.showAllDiscountRate = false;
                }
            }
        }
        function showOrderNotSavedInDbModal(){
            $mdDialog.show({
                templateUrl: 'app/components/orderModule/validate/orderModeSaveInDB.template.html',
                controller: 'orderModeSaveInDbController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    isOrderPlaced : (vm.addOrderResponse && vm.addOrderResponse.orderNumber) ? true : false
                }    
            }); 
        }
        function printOrder(isDownload){
            blockUI.start();

            var type = globalConstant.order;
            var status = globalConstant.validated;
            var orderToPrint ={};
            orderToPrint.items = PartRequisitionMetierService.formatItemsForPrintPayload(vm.validatedOrder.items);
            vm.validatedOrder.status = 'VALID';
            vm.validatedOrder.validationDateTime = vm.validatorInfo.dateAndTime;
            vm.validatedOrder.creatorIPN = vm.validatorInfo.ipn;
            vm.validatedOrder.responseData = vm.addOrderResponse;
            vm.validatedOrder.urgentOrder = vm.validatorInfo.urgentOrder;
            SuperCartMetierService.downloadPdf(vm.validatedOrder, orderToPrint.items, vm.vehicle, type, status, true).then(function (response) {
                pdfMake.tableLayouts = {
                    descTableLayout:{
                        hLineWidth: function () {
                            return 0.1;
                        },
                        vLineWidth: function () {
                            return 0.1;
                        },
                        hLineColor: function () {
                            return 'gray';
                        },
                        vLineColor: function () {
                            return 'gray';
                        },
                    },
                        secondTableLayout:{
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 3 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                            }
                    },
                    thirdTableLayout:{
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 2 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                        }
                    },
                    otherTableLayout:{
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    }
                
                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                var file = new Blob([(buffer)], { type: 'application/pdf' });

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;
                if (isDownload){
                    if(vm.validatedOrder.responseData && vm.validatedOrder.responseData.orderNumber)
                        FileSaver.saveAs(file, $translate.instant("LABEL_ORDER")+" - " + vm.validatedOrder.responseData.orderNumber + ".pdf");
                    else
                        FileSaver.saveAs(file, $translate.instant("LABEL_ORDER")+".pdf"); 
                }
                /*else{
                    if (isIE || isEdge) {
                        FileSaver.saveAs(file, $translate.instant("LABEL_ORDER")+" - " + vm.validatedOrder.number + ".pdf");
                    } else {
                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }
                            return printPdfModalService.showModal(modalParams).catch(function () {
    
                            });
                        }).catch(function (err) {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
                }*/
            });

            }).catch(function (err) {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
            }
            function getPriceToDisplay(item) {
                var price = UtilsMetierService.getPriceToDisplay(
                    item.price, !item.dmsInformations ? null : item.dmsInformations.priceExclTaxes);
                return price;
            }
    
            function getCurrencyForItem(piece) {
                if (piece && piece.dmsInformations && piece.dmsInformations.isKnowFromDms) {
                    return UtilsMetierService.getCurrencyForItem(piece.dmsInformations.isKnowFromDms)
                } else {
                    return UtilsMetierService.getCurrencyForItem()
                }
            }
            function downloadCSV() {
                blockUI.start();           
                
                _.map(vm.validatedOrder.items,function(item){
                    if(!_.isEmpty(item.applicableClass)){
                    _.extend(item,{
                        applicableClassTranslation : $translate.instant(item.applicableClass)
                    });
                }
                });
                
                var headersTranslations = {};
                headersTranslations.reference = $translate.instant('COMMON_COLUMN_REF_TITLE');
                headersTranslations.designation = $translate.instant('COMMON_DESIGNATION');
                headersTranslations.pubhtTitle = $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("WHOLESALER_GUP_TAX");
                headersTranslations.discountCode = $translate.instant('ORDERING_MODULE_DISCOUNT_CODE');
                headersTranslations.availability = $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("R1_AVAILABILITIES");                 
                headersTranslations.quantity = $translate.instant('COMMON_COLUMN_QTE_TITLE'); 
                headersTranslations.orderWithDefect = $translate.instant('ORDER_VALIDATED')+' '+ $translate.instant('ORDER_VALIDATED_WITH_DEFECT');
                headersTranslations.order = $translate.instant('LABEL_ORDER');
                headersTranslations.codeTm = $translate.instant('CODE_TM');
                headersTranslations.timeTm = $translate.instant('COMMON_COLUMN_TIME_TITLE');

                var inputbody = {};
                _.extend(inputbody,{
                    partsDetails: vm.validatedOrder.items,
                    headersTranslations: headersTranslations,
                    validatedInfo: { dateAndTimeIpn : vm.validatedDateAndInfo, orderNumber : vm.addOrderResponse ? vm.addOrderResponse.orderNumber : null }
                });
               
                SuperCartMetierService.downloadCSV(vm.validatorInfo.basketId, inputbody)
                    .then(function (response) {
                        var data = new Blob([response.data],{type:"text/plain;charset=UTF-8"});
                        FileSaver.saveAs(
                            data,(vm.addOrderResponse && vm.addOrderResponse.orderNumber) ?  $translate.instant('LABEL_ORDER')+"_"+vm.addOrderResponse.orderNumber+".csv" :  $translate.instant('LABEL_ORDER')+".csv" 
                        );
                    })
                    .catch(function () {
                        toastr.error($translate.instant("ERROR"));
                    })
                    .finally(function () {
                        blockUI.stop();
                    });
            }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('orderModeSaveInDbController', orderModeSaveInDbController);

    /** @ngInject */
    function orderModeSaveInDbController($mdDialog) {
        var vm = this;
       
        vm.onCancel = onCancel;

        function onCancel() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    angular
        .module('phenix')
        .service('TokenService', TokenService);

    /** @ngInject */
    function TokenService($state,
        $window,
        toastr,
        $translate,
        CacheService,
        CacheConstants,
        MainMetierService,
        UtilsMetierService,
        RoutesConstants,AccessConfigService,
        CloudFrontConstants,
        LoginMetierService,
        configConstantes,
        LoginConstants,
        $q,ClipConstants,$cookies,
        CryptoService) {

        var vm = this;
        var sessionStorage = $window.sessionStorage;

        /*****************
         * FUNCTION
         *****************/

        vm.getToken = getToken;
        vm.delToken = delToken;
        vm.setToken = setToken;
        vm.handleToken = handleToken;

        function getToken() {
           return sessionStorage.getItem('token');
        }

        function delToken() {
            sessionStorage.clear();
        }

        function setToken(token) {
            if (token) {
                token = token.replace(/ /g, '+');
                sessionStorage.setItem('token', token);
            }
        }

        /**
         *  @param {string} token
         *  @returns {Promise<Object || null>} userProfile
         */

        function handleToken(token) {
            if (!token) {
                var tokenFromSession = getToken();
                if (!tokenFromSession) {
                    return $q.resolve(null);
                } else {
                    return $q.resolve(CacheService.getUserProfile());
                }
            }
            var encryptedToken = token;
            var decryptedToken = UtilsMetierService.decryptAccessToken(encryptedToken);
            setToken(token);
            try {
                var localDEV = "samldisabled"
                var decode = token === localDEV ? LoginMetierService.mock() : $q.resolve($window.jwt_decode(decryptedToken));
                return decode.then(function (decoded_token) {
                    var userProfile = decoded_token.userContext;
                    userProfile = _.omit(userProfile, ['asomSubscriptions', 'tokenBalance']);
                    if(userProfile.userType == 'RNET'){
                        const selectedProfileValue = CacheService.getObject(CacheConstants.profil);
                        const functionCodes = selectedProfileValue && selectedProfileValue.selectedUserContext && selectedProfileValue.selectedUserContext.functionCodes;
                        if(userProfile.userContext && Array.isArray(functionCodes)){
                            userProfile.userContext.functionCodes = functionCodes;
                        } else if(userProfile.userContext && userProfile.userContext.code){
                            userProfile.userContext.functionCodes = [userProfile.userContext.code];
                        }
                        var oktaRnetProfil =  sessionStorage.getItem('oktaRnetProfil');
                        if(oktaRnetProfil){
                            var oktaRnetProfilValue = JSON.parse(oktaRnetProfil);
                            if(userProfile.userContext && Array.isArray(oktaRnetProfilValue.functionCodes)){
                                userProfile.userContext.functionCodes = oktaRnetProfilValue.functionCodes;
                            }
                            if(oktaRnetProfilValue.oktaTokenResponse && oktaRnetProfilValue.oktaTokenResponse.id_token){
                                var oktaToken = oktaRnetProfilValue.oktaTokenResponse.id_token;
                                var id_token = $window.jwt_decode(oktaToken);
                                userProfile.rootIpn = id_token.login;
                            }
                        }
                    }
                    CacheService.setUserProfile(userProfile);
                    AccessConfigService.getProfileFromCache(userProfile);
                    try {
                        dtrum.identifyUser(userProfile.ipn);
                        dtrum.sendSessionProperties(null, null, { "useripn": userProfile.ipn }, null);
                        if (userProfile && userProfile.userType != null) {
                            dtrum.sendSessionProperties(null, null, { "typeofuser": userProfile.userType }, null);
                        } else {
                            dtrum.sendSessionProperties(null, null, { "typeofuser": LoginConstants.independentUser }, null);
                        }
                    } catch (err) {
                        return $q.resolve(userProfile);
                    }
                    return userProfile;
                })
            } catch (err) {
                // HANDLE JWT DECODE ERROR
                return $q.reject(err);
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('phenix')
        .service('LoginWsService', LoginWsService);

    /** @ngInject */
    function LoginWsService($q, LoginConstants,UtilsMetierService,RestUpgrade) {

        this.loginWS = loginWS;
        this.callHTL = callHTL;
        this.displayInformations = displayInformations;
        this.saveInfoConsent = saveInfoConsent;
        this.storeUserConnection = storeUserConnection;
        this.openIdCallback = openIdCallback;
        this.callTrace = callTrace;
        this.updateUserContext = updateUserContext;
        this.nissanIndepLogin = nissanIndepLogin;

        function loginWS(credentials) {
            return RestUpgrade.one(LoginConstants.restAuthentification).post('', {
                userId: credentials.userId,
                password: credentials.password
            });
        }

        function callHTL() {
            var defer = $q.defer();
            var url = LoginConstants.logisticIds;
            RestUpgrade.one(url).get().then(function (response) {

                response = response.plain ? response.plain() : response;
                defer.resolve(response);

            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function displayInformations(langcode){
            var url=LoginConstants.informations+"?lang="+langcode; 
            return RestUpgrade.one(url).get();
        }
        
        function saveInfoConsent(){
            var url = LoginConstants.infoConsent;
    
            return RestUpgrade.all(url).post().then(function(response){
              if(!response){
                return $q.reject();
              }    
              return response;
            }).catch(function(){
                return $q.reject();
            });
        }

        function storeUserConnection(){  
            var url =   LoginConstants.storeUserconnection;
            var profile = UtilsMetierService.getProfile();
            var body = {};
            if(UtilsMetierService.isOktaAuthentication() && profile.userType == "RNET"){
                body = {"userIPN" : profile.rootIpn};
               
            }
            return RestUpgrade.all(url).post(body).then(function(){
                 $q.resolve();
            }).catch(function(){
                 return $q.reject();
            })
        }

        function openIdCallback(userType){
            var openidUrl = LoginConstants.openIdCallback + window.location.search;
            var body= {"userType" : userType}
            return RestUpgrade.all(openidUrl).post(body).then(function(response){                
                return response;
            }).catch( function(err) {
                return $q.reject(err.data);
            });
        }

        function updateUserContext(userContextList, oktaToken){
            var updateUserContextUrl = LoginConstants.updateUserContext;
            var body= {
                "userContextList" : userContextList,
                "oktaToken" : oktaToken
            }
            return RestUpgrade.all(updateUserContextUrl).post(body).then(function(response){
                return response;
            }).catch( function(err) {
                return $q.reject(err.data);
            });
        }

        function callTrace() {
            var defer = $q.defer();
            var url = LoginConstants.trace;
            RestUpgrade.one(url).get().then(function (response) {

                response = response.plain ? response.plain() : response;
                defer.resolve(response);

            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        }

        function nissanIndepLogin(token){
            var url = LoginConstants.nissanIndepLogin;
            var body = {"id_token": token};
            return RestUpgrade.all(url).post(body).then(function(response){
                return response;
            }).catch(function(err){
                return $q.reject(err.data);
            });
        }
    }
})();

(function() {
    "use strict";

    angular.module("phenix").service("LoginMetierService", LoginMetierService);

    /** @ngInject */
    function LoginMetierService(
        LoginWsService,
        CacheService,
        CacheConstants,
        UtilsMetierService,
        AlertsService,
        toastr,
        $translate,$log, UserKeyService
    ) {
        
        var vm = this;
        vm.isHtlAuthorized = false;
        this.mock = mock;
        this.logOut = logOut;
        this.checkHtl = checkHtl;
        this.checkTrace = checkTrace;
        this.addLogisticIdToUserProfil = addLogisticIdToUserProfil;
        this.displayInformationsLogic = displayInformationsLogic;
        this.saveInfoConsent = saveInfoConsent;
        this.storeUserConnection = storeUserConnection;
        this.openIdCallback = openIdCallback;
        this.updateUserContext = updateUserContext;
        this.nissanIndepLogin = nissanIndepLogin;

        function mock() {
            var credentials = {
                password: "fr",
                userId: "fr"
            };
            return LoginWsService.loginWS(credentials).then(function(response) {
                return {
                    userContext: response
                };
            });
        }

        function logOut() {
            // Clear user key on logout
            UserKeyService.clearUserKey();
            
            /*var estimate = CacheService.getObject(CacheConstants.estimate);
            if(estimate){
              EstimateMetierService.updateEstimate(estimate).then(function (response) {
                if (response.errorCode) { // if error
                  toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                  PartListNotifService.stop();
                  CacheService.clearAll();
                  return false;
                } else { // if success
                  PartListNotifService.stop();
                  CacheService.clearAll();
                  return true;
                }
              }).catch(function(response) {
                PartListNotifService.stop();
                CacheService.clearAll();
              });

            }*/
        }

        function checkHtl() {
            LoginWsService.callHTL()
                .then(function(response) {
                    vm.isHtlAuthorized = true;
                    return addLogisticIdToUserProfil(
                        response.dealerSiteIds,
                        vm.isHtlAuthorized
                    );
                })
                .catch(function() {
                        vm.isHtlAuthorized = false;
                        return addLogisticIdToUserProfil(
                            "rejected",
                            vm.isHtlAuthorized
                        );
                });
        }

        function checkTrace(){
            LoginWsService.callTrace()
                .then(function(response) {
                    if(response && response.siteIds && response.siteIds.length != 0){                         
                        var profile = UtilsMetierService.getProfile();
                        if(profile){
                            profile.traceKnownUser = true;
                            profile.traceSiteIDs = response.siteIds;
                            CacheService.setObject(CacheConstants.traceSiteIds,response.siteIds);
                            CacheService.setObject(CacheConstants.profil, profile);
                        }
                        AlertsService.setTraceDealerLogisticId();
                    }
                })
                .catch(function() {
                     $log.debug($translate.instant('ERROR'));
                });       
        }

        function addLogisticIdToUserProfil(dealerLogisticIds, isHtlAuthorized) {
            var profile = UtilsMetierService.getProfile();
            if(profile)
                profile.dealerLogisticIds = dealerLogisticIds;
            CacheService.setObject(CacheConstants.profil, profile);
            CacheService.setObject(CacheConstants.htlState, [
                dealerLogisticIds,
                isHtlAuthorized
            ]);
        }

        function displayInformationsLogic() {
            var profile = UtilsMetierService.getProfile();

            var langcode=profile.portal.code;
            return LoginWsService.displayInformations(langcode);
        }
        
        function saveInfoConsent() {
            return LoginWsService.saveInfoConsent();
        }
        
        function storeUserConnection() {
            return LoginWsService.storeUserConnection();
        }

        function openIdCallback(userType){
            return LoginWsService.openIdCallback(userType);
        }

        function updateUserContext(userContextList, oktaToken){
            return LoginWsService.updateUserContext(userContextList, oktaToken);
        } 
        
        function nissanIndepLogin(token){
            return LoginWsService.nissanIndepLogin(token);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .service("FavoitWsService", FavoitWsService);

    /** @ngInject */
    function FavoitWsService(
        CacheService,
        CacheConstants,
        FavouriteConstantes,
        RestUpgrade,RestUpgradeRaw,
        $q
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.addNonCodedTm = addNonCodedTm;
        vm.getNonCodedTm = getNonCodedTm;
        vm.updateNonCodedTm = updateNonCodedTm;
        vm.deleteNonCodedTm = deleteNonCodedTm;
        vm.getFavoritesProducts = getFavoritesProducts;
        vm.getCategories = getCategories;
        vm.addSubCategory = addSubCategory;
        vm.updateSubCategory = updateSubCategory;
        vm.deleteSubCategory = deleteSubCategory;
        vm.deleteReferencesInSubcategory = deleteReferencesInSubcategory;
        vm.deleteReferencesInCategory = deleteReferencesInCategory;
        vm.deleteReferencesInCategoryOrSubcategory = deleteReferencesInCategoryOrSubcategory,
        vm.addReferencesInSubcategory = addReferencesInSubcategory;
        vm.addReferencesInCategory = addReferencesInCategory;


        vm.addPR = addPR;
        vm.getPr = getPr;
        vm.updatePR = updatePR;
        vm.getNonCodedTMByRef = getNonCodedTMByRef;

        // vm.deletePR = deletePR;

        /**
         *  @param {Object} updatedTM
         */

        function updateNonCodedTm(updatedTM, laborTimeId) {
            var dealerId = CacheService.getObject(CacheConstants.profil).dealerId;

            return RestUpgrade.one(FavouriteConstantes.apigeeNonCodedLaborTimeUrl, dealerId).one(FavouriteConstantes.apigeeBaseLaborTimeService, laborTimeId).customPUT(updatedTM);
        }

        /**
         *  @param {String} laborTimeId
         */

        function deleteNonCodedTm(laborTimeId) {
            var dealerId = CacheService.getObject(CacheConstants.profil).dealerId;

            return RestUpgrade.one(FavouriteConstantes.apigeeNonCodedLaborTimeUrl, dealerId).one(FavouriteConstantes.apigeeBaseLaborTimeService, laborTimeId).remove();
        }

        /**
         * @name addNonCodedTm
         * @desc call service to add non coded TM
         * @param {Object} data - request body
         * @param {String} dealerId - dealer id
         */


        function addNonCodedTm(data, dealerId) {
            var url = FavouriteConstantes.apigeeNonCodedLaborTimeUrl + dealerId + FavouriteConstantes.apigeeAddNonCodedLaborTimeService;
            return RestUpgrade.all(url).post(data);
        }

        /**
         * @name getNonCededTm
         * @desc call service to get list of non coded TM
         * @param dealerId
         * @returns {*}
         */
        function getNonCodedTm(dealerId) {
            var url = FavouriteConstantes.apigeeNonCodedLaborTimeUrl + dealerId + FavouriteConstantes.apigeeAddNonCodedLaborTimeService;
            return RestUpgrade.one(url).get();
        }
 

        /**
         * @name getPr
         * @desc call service to get list of non coded TM
         * @param dealerId
         * @returns {*}
         */
        function getPr(dealerId) {
            return RestUpgrade.one(FavouriteConstantes.PRUrl, dealerId).getList(FavouriteConstantes.addPR);
        }

        /**
         * @name addPR
         * @desc call service to add PR
         * @param {Object} data - request body
         * @param {String} dealerId - dealer id
         */
        function addPR(data, dealerId) {
            var url = FavouriteConstantes.PRUrl + dealerId + FavouriteConstantes.addPR;
            return RestUpgrade.all(url).post(data);
        }

        /**
         * @name updatePR
         * @desc to update the product for the category or subCategory
         * @param {Object} data
         * @param {String} dealerId
         */
        function updatePR(data, dealerId) {
            var url = FavouriteConstantes.apigeeBaseDacaUrl + dealerId + FavouriteConstantes.apigeeGetFavoritesProducts;
            return RestUpgradeRaw.all(url).post(data);
        }

        /**
         * @name getCategories
         * @desc call daca service to get default categories and subcategories
         * @param {String} dealerId 
         */
        function getCategories(dealerId) {
            var language = CacheService.getObject(CacheConstants.profil).language;
            var url = FavouriteConstantes.apigeeBaseDacaUrl + dealerId + FavouriteConstantes.favoriteCategories+"?language="+ language;
            return RestUpgrade.one(url).get();
        }
        /**
         * @name getFavoritesProducts
         * @desc call daca service to get dealer's favorit product
         * @param {String} dealerId
         */
        function getFavoritesProducts(dealerId,categoryKey,networkProfile) {

            var language = CacheService.getObject(CacheConstants.profil).language;
            var url = FavouriteConstantes.apigeeBaseDacaUrl + dealerId + FavouriteConstantes.getFavoritesProducts + FavouriteConstantes.favoriteCategories +"/"+ categoryKey +"?language="+ language + "&profileType=" + networkProfile;
            return RestUpgrade.one(url).get();

            //TODO call DACA and delete mock
            // return $q.resolve({
            //     "categories": [
            //         {
            //             "categoryName": "PR_FAV_CAT_MISCELLANEOUS_LUBRICANTS",
            //             "products": ["8200257642", "117201362R"],
            //             "isDefault": true,
            //             "subCategories": [
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_1",
            //                     "products": ["117201362R"],
            //                     "isDefault": true
            //                 },
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_2",
            //                     "products": [],
            //                     "isDefault": true
            //                 }
            //             ]
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_TYRES",
            //             "products": [],
            //             "isDefault": true,
            //             "subCategories": [
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_3",
            //                     "products": [],
            //                     "isDefault": true
            //                 }
            //             ]
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_BATTERIES",
            //             "products": ["6901056869"],
            //             "isDefault": true,
            //             "subCategories": []
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_PAINT_CONSUMABLES",
            //             "subCategories": [],
            //             "products": ["690105678"],
            //             "isDefault": true
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_ACCESSORIES",
            //             "subCategories": [],
            //             "products": ["690105678"],
            //             "isDefault": true
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_SERVICING",
            //             "subCategories": [],
            //             "products": ["690105678"],
            //             "isDefault": true
            //         },
            //         {
            //             "categoryName": "PR_FAV_CAT_MISCELLANEOUS",
            //             "subCategories": [
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_1",
            //                     "products": ["6901056869", "5401056869"],
            //                     "isDefault": true
            //                 },
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_5",
            //                     "products": [],
            //                     "isDefault": true
            //                 },
            //                 {
            //                     "subCategoryName": "PR_FAV_SCAT_9",
            //                     "products": [],
            //                     "isDefault": true
            //                 }
            //             ],
            //             "products": ["690105678"],
            //             "isDefault": true
            //         }
            //     ]
            // });
        }

        function getNonCodedTMByRef(dealerId, ref){
            var url = FavouriteConstantes.apigeeNonCodedLaborTimeUrl + dealerId + FavouriteConstantes.apigeeAddNonCodedLaborTimeService;
            return RestUpgrade.all(url).get(ref);// ref
         }


        /**
         * @name addSubCategory
         * @desc To add the subCategory
         * @param {Object} category
         * @param {String} subCategoryName
         */
        function addSubCategory(dealerId, categoryKey, requestBody) {
        
           return RestUpgrade.one(FavouriteConstantes.apigeeBaseDacaUrl,dealerId).one(FavouriteConstantes.favoriteCategories,categoryKey).
           one(FavouriteConstantes.favoriteSubcategories).post('',requestBody);  
        }

        /**
         * @name updateSubCategory
         * @desc To update the subCategory name
         * @param {Object} category
         * @param {Object} editedSubCategory
         */
        function updateSubCategory(dealerId, categoryKey, subCategoryKey, requestBody) {

            return RestUpgrade.one(FavouriteConstantes.apigeeBaseDacaUrl,dealerId).one(FavouriteConstantes.favoriteCategories,categoryKey).
            one(FavouriteConstantes.favoriteSubcategories,subCategoryKey).customPUT(requestBody);

        }

        /**
         * @name deleteSubCategory
         * @desc To delete the Subcategory
         * @param {String} dealerId
         * @param {String} categoryName
         * @param {String} subCategoryName
         */
        function deleteSubCategory(dealerId, categoryKey, subCategoryKey) {

            return RestUpgrade.one(FavouriteConstantes.apigeeBaseDacaUrl,dealerId).one(FavouriteConstantes.favoriteCategories,categoryKey).
            one(FavouriteConstantes.favoriteSubcategories,subCategoryKey).remove();
        }

        /**
         * @name deleteReferencesInSubcategory
         * @desc To delete reference(s) from subcategory
         * @param {String} dealerId
         * @param {String} categoryOld
         * @param {String} subcategoryOld
         * @param {Array} productId
         */
        function deleteReferencesInSubcategory(dealerId, categoryOld, subcategoryOld, productId) {
            
            return RestUpgrade.one(FavouriteConstantes.baseDacaUrl, dealerId).one(categoryOld).one(subcategoryOld)
            .one(FavouriteConstantes.productIdParam, productId).remove();
        }

        /**
         * @name deleteReferencesInCategoryOrSubcategory
         * @desc To delete reference(s) from category or subcategory
         * @param {String} dealerId
         * @param {String} categoryOld
         * @param {String} productId
         */
        function deleteReferencesInCategoryOrSubcategory(dealerId, body, productId) {
            
            var url =  FavouriteConstantes.apigeeBaseDacaUrl + dealerId + FavouriteConstantes.apigeeGetFavoritesProducts + "/" + productId;
            return RestUpgrade.all(url).customOperation("remove",null,null,{'Content-Type': 'application/json'},body);
        }

        /**
         * @name deleteReferencesInCategory
         * @desc To delete reference(s) from category
         * @param {String} dealerId
         * @param {String} categoryOld
         * @param {String} productId
         */
        function deleteReferencesInCategory(dealerId, categoryOld, productId) {
            return RestUpgrade.one(FavouriteConstantes.baseDacaUrl, dealerId).one(categoryOld).one(FavouriteConstantes.productIdParamDaca, productId).remove();
        }

        /**
         * @name addReferencesInCategory
         * @desc To add reference(s) to selected category
         * @param {String} dealerId
         * @param {String} category
         * @param {String} productId
         */
        function addReferencesInCategory(dealerId, categoryNew, productId) {
            return RestUpgrade.one(FavouriteConstantes.baseDacaUrl, dealerId).one(categoryNew).one(productId).customPUT();
        }

        /**
         * @name addReferencesInSubcategory
         * @desc To add reference(s) to selected subcategory
         * @param {String} dealerId
         * @param {String} categoryNew
         * @param {String} SubcategoryNew
         * @param {String} productId
         */
        function addReferencesInSubcategory(dealerId, categoryNew, SubcategoryNew, productId) {
            return RestUpgrade.one(FavouriteConstantes.baseDacaUrl, dealerId).one(categoryNew)
                .one(SubcategoryNew).one(productId).customPUT();
        }


    }
})();

(function () {
    "use strict";
    angular
        .module("phenix")
        .service("FavoitMetierService", FavoitMetierService);

    /** @ngInject */
    function FavoitMetierService(
        CacheService,
        FavoitWsService,
        CacheConstants,$q
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.addNonCodedTmLogic = addNonCodedTmLogic;
        vm.addPRLogic = addPRLogic;
        vm.updatePRLogic = updatePRLogic;
        vm.getNonCodedTmByCacheDealerId = getNonCodedTmByCacheDealerId;
        vm.getNonCodedTmByRefByCacheDealerId = getNonCodedTmByRefByCacheDealerId;
        vm.getPrByCacheDealerId = getPrByCacheDealerId;
        vm.updateNonCodedTm = updateNonCodedTm;
        vm.deleteNonCodeTm = deleteNonCodeTm;
        vm.getFavoritesProductsByDealerId = getFavoritesProductsByDealerId;
        vm.getCategoriesByDealerId = getCategoriesByDealerId;
        vm.addSubCategory = addSubCategory;
        vm.updateSubCategory = updateSubCategory;
        vm.deleteSubCategory = deleteSubCategory;
        vm.getSelectedReferencesNumber = getSelectedReferencesNumber;
        vm.deleteReferencesFromCategoryOrSubcategory = deleteReferencesFromCategoryOrSubcategory;
        vm.deleteReferencesFromCategory = deleteReferencesFromCategory;
        vm.deleteReferencesFromSubCategory = deleteReferencesFromSubCategory;
        vm.addReferencesToCategoryorSubcategory = addReferencesToCategoryorSubcategory;
        vm.addReferencesToCategory = addReferencesToCategory;
        vm.addReferencesTosubCategory = addReferencesTosubCategory;


        /**
         *  @param {object} TM
         */

        function updateNonCodedTm(TM) {
            var payload = _.omit(TM, 'localLaborTimeId');

            return FavoitWsService.updateNonCodedTm(payload, TM.localLaborTimeId);
        }

        function getSelectedReferencesNumber(CheckedList) {
            var checkedCount = 0;
            angular.forEach(CheckedList, function (value, key) {
                if (value.isSelected === true) {
                    checkedCount += 1;
                }
            });
            return checkedCount;
        }

        /**
         * @param {string} laborTimeId
         */

        function deleteNonCodeTm(laborTimeId) {
            return FavoitWsService.deleteNonCodedTm(laborTimeId);
        }

        /**
         * @name addNonCodedTmLogic
         * @desc get profil and format data to send
         * @param {Object} data - request body
         */
        function addNonCodedTmLogic(data) {
            var profil = CacheService.getObject(CacheConstants.profil);

            var requestBody = [{
                opeCode: data.reference,
                label: data.designation,
                time: data.time,
                price: data.price,
                description: data.description,
                technicality: data.technicality,
                category: data.category,
                subCategory: data.subCategory,
                nonCoded: true
            }]
            return FavoitWsService.addNonCodedTm(requestBody, profil.dealerId);
        }

        /**
         * @name addPRLogic
         * @desc get profil and format data to send
         * @param {Object} data - request body
         */
        function addPRLogic(data) {
            var profil = CacheService.getObject(CacheConstants.profil);
            // changer pour mettre valeur selon l'appel getList true false : true si deja existante, false si créée par l'user
            var requestBody = {
                categories: [{
                    categoryName: data.category,
                    isDefault: true
                }]
            };
            //if subCategory exist, add reference to it
            if (data.subCategory) {
                requestBody.categories[0].subCategories = [{
                    subCategoryName: data.subCategory,
                    products: [data.reference]

                }];
            }
            //else add reference to the category
            else {
                requestBody.categories[0].products = [data.reference];
            }
            return FavoitWsService.addPR(requestBody, profil.dealerId);
        }

        /**
         * @name updatePRLogic
         * @desc format the data to update the product
         * @param {Object} data - form data from pop in
         */
        function updatePRLogic(data,categories,categoryIndex,subcategoryIndex) {
            var profil = CacheService.getObject(CacheConstants.profil);
            var postCategoryKey,postSubcategoryKey;

            if(categoryIndex >=0) {
                postCategoryKey = categories[categoryIndex].categoryKey;
            }
            if(categoryIndex >=0 && subcategoryIndex >= 0) {
                postSubcategoryKey = categories[categoryIndex].subCategories[subcategoryIndex].subcategoryKey;
            }
            var requestBody = {
                categoryKey : postCategoryKey,
                subcategoryKey : postSubcategoryKey,
                product : data.reference,
                profileType :  (profil && profil.dmsConfig) ? profil.dmsConfig.networkProfile : null
            }
            return FavoitWsService.updatePR(requestBody,profil.dealerId);
        }

        /**
         * @name getNonCodedTm
         * @desc call service to get list of non coded TM
         * @param dealerId
         * @returns {*}
         */
        function getNonCodedTmByCacheDealerId() {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.getNonCodedTm(profile.dealerId);
        }

         /**
         * @name getNonCodedTm
         * @desc call service to get list of non coded TM
         * @param dealerId
         * @returns {*}
         */
        function getNonCodedTmByRefByCacheDealerId(ref) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.getNonCodedTMByRef(profile.dealerId, ref);
        }

         /**
         * @name getPrByCacheDealerId
          * @desc call service to get list of non coded TM
         * @param dealerId
         * @returns {*}
         * */
        function getPrByCacheDealerId() {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.getPr(profile.dealerId);
        }

        /**
         * @name getCategoriesByDealerId
         * @desc call ws to get default categories
         */

         function getCategoriesByDealerId() {
             var profile = CacheService.getObject(CacheConstants.profil);
             return FavoitWsService.getCategories(profile.dealerId);
         }

        /**
         * @name getFavoritesProductsByDealerId
         * @desc call ws to get favorites products by dealer id
         */
        function getFavoritesProductsByDealerId(categoryKey) {
            var profile = CacheService.getObject(CacheConstants.profil);
           var profileType = (profile && profile.dmsConfig) ? profile.dmsConfig.networkProfile : null;
           return FavoitWsService.getFavoritesProducts(profile.dealerId, categoryKey, profileType);
           
        }

        /**
         * @name addSubCategory
         * @desc To add the subCategory
         * @param {Object} category 
         * @param {String} subCategoryName 
         */
        function addSubCategory(category, subCategoryName) {
            var profile = CacheService.getObject(CacheConstants.profil);
            
            var requestBody = {
                subCategoryName : subCategoryName,
                isDefault: false
            }

            return FavoitWsService.addSubCategory(profile.dealerId, category.categoryKey, requestBody).then(function (response) {
                if (response) {
                    if (category.subCategories) {
                        category.subCategories.push({
                            subcategoryKey: response.subcategoryKey,
                            subCategoryName: subCategoryName,
                            isDefault: false
                        })
                    } else {
                        var subCategory = {
                            subCategories: [{
                                subcategoryKey: response.subcategoryKey,
                                subCategoryName: subCategoryName,
                                isDefault: false
                            }]
                        };
                        _.assign(category, subCategory);
                    }
                }
                return response;
            });

        }

        /**
         * @name updateSubCategory
         * @desc To update the subCategory name
         * @param {Object} category 
         * @param {Object} editedSubCategory 
         */
        function updateSubCategory(category, editedSubCategory) {

            var profile = CacheService.getObject(CacheConstants.profil);
            
            var requestBody = {
                subCategoryName :editedSubCategory.newSubCategoryName,
                isDefault : false

            }
            return FavoitWsService.updateSubCategory(profile.dealerId, category.categoryKey, editedSubCategory.subcategoryKey,requestBody)
        }

        /**
         * @name deleteSubCategory
         * @desc To delete the Subcategory
         * @param {String} categoryName 
         * @param {String} subCategoryName 
         */
        function deleteSubCategory(category, subCategoryKey) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.deleteSubCategory(profile.dealerId, category.categoryKey, subCategoryKey)
        }

        /**
         * @name deleteReferencesFromSubCategory
         * @desc To delete the selected reference(s) from selected subcategory
         * @param {String} categoryOld 
         * @param {String} subCategoryOld 
         * @param {String} productId
         */
        function deleteReferencesFromSubCategory(categoryOld, subCategoryOld, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.deleteReferencesInSubcategory(profile.dealerId, categoryOld, subCategoryOld, productId);
        }


        /**
         * @name deleteReferencesFromCategoryOrSubcategory
         * @desc To delete the selected reference(s) from selected category or subcategory
         * @param {String} categoryOld  
         * @param {Array} productId
         */
        function deleteReferencesFromCategoryOrSubcategory(categoryOld, subCategoryOld, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            var requestBody = {
                categoryKey : categoryOld,
                subcategoryKey : subCategoryOld,
                profileType :  (profile && profile.dmsConfig) ? profile.dmsConfig.networkProfile : null

            }
            return FavoitWsService.deleteReferencesInCategoryOrSubcategory(profile.dealerId,requestBody,productId);
        }

        /**
         * @name deleteReferencesFromCategory
         * @desc To delete the selected reference(s) from selected category
         * @param {String} categoryOld  
         * @param {Array} productId
         */
        function deleteReferencesFromCategory(categoryOld, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.deleteReferencesInCategory(profile.dealerId, categoryOld, productId);
        }

        /**
         * @name addReferencesToCategoryorSubcategory
         * @desc To add one or more reference(s) to a category
         * @param {String} category 
         * @param {Array} productId 
         */
        function addReferencesToCategoryorSubcategory(categoryKey,subcategoryKey, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            var requestBody = {
                categoryKey : categoryKey,
                subcategoryKey : subcategoryKey,
                product : productId,
                profileType :  (profile && profile.dmsConfig) ? profile.dmsConfig.networkProfile : null
            }
            return FavoitWsService.updatePR(requestBody,profile.dealerId);
        }
        
        /**
         * @name addReferencesToCategory
         * @desc To add one or more reference(s) to a category
         * @param {String} category 
         * @param {Array} productId 
         */
        function addReferencesToCategory(categoryNew, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.addReferencesInCategory(profile.dealerId, categoryNew, productId);
        }

        /**
         * @name addReferencesTosubCategory
         * @desc To add one or more reference(s) to a subCategory
         * @param {String} categoryNew 
         * @param {String} SubcategoryNew
         * @param {Array} productId 
         */
        function addReferencesTosubCategory(categoryNew, SubcategoryNew, productId) {
            var profile = CacheService.getObject(CacheConstants.profil);
            return FavoitWsService.addReferencesInSubcategory(profile.dealerId, categoryNew, SubcategoryNew, productId);
        }


    }
})();


angular.module('phenix').filter('numberFilterCommaTM', function () {
    'use strict';
    return function (input, numberOfCommas, isCommaNeeded) {
        if (_.isNaN(parseInt(input))) {
            return "";
        }
        if (_.isNaN(parseInt(numberOfCommas))) {
            numberOfCommas = 1;
        }
        var value, res;
        if (isCommaNeeded) {
            value = Number(input.replace(",", "."));
            res = input.split(",");
            if (res.length === 1 || res[1].length < 3) {
                value = value.toFixed(numberOfCommas);
            }
            return value.replace(".", ",");

        } else {
            value = Number(input);
            res = input.split(",");
            if (res.length === 1 || res[1].length < 3) {
                value = value.toFixed(numberOfCommas);
            }
            return value.replace(",", ".");

        }
    };
});

/**
 * FavouritesController
 * @namespace Controller
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('FavouritesController', FavouritesController);

    /* @ngInject */
    function FavouritesController(
        $mdDialog,
        $translate,
        $q,

        listOfDraftModalService,
        QuoteMetierService,
        FavoitMetierService,
        UtilsMetierService,

        ShoppingCartServiceConstant,
        globalConstant,
        FavouriteConstantes,

        toastr,
        blockUI,
        CacheService,
        CacheConstants) {

        /*=============================================
       =                 VARIABLES                   =
       =============================================*/

        var vm = this;

        var _actions = ShoppingCartServiceConstant.actions;
        vm.addTMToShoppingCart = addTMToShoppingCart;
        vm.updateCategories = updateCategories;
        vm.increment = increment;
        vm.decrement = decrement;
        vm.activateSelectedTab = activateSelectedTab;
        vm.activateSelectedSubTab = activateSelectedSubTab;
        vm.inputQuantity = inputQuantity;
        vm.setSelectedCategoryTabAndSubTabByNameIfApplied = setSelectedCategoryTabAndSubTabByNameIfApplied;
        vm.addTM = addTM;
        vm.findSubCat = findSubCat;
        vm.consultCurrentTm = consultCurrentTm;
        vm.cancel = cancel;
        vm.characterCount = characterCount;
        vm.displayData = displayData;
        vm.getCurrentCurrency = getCurrentCurrency;
        vm.defaultTechnicalLevelNormal = '';
        vm.defaultTechnicalLevelHigh = '';
        vm.defaultTechnicalLevelVeryHigh = '';
        vm.defaultTechnicalLevel = '';
        vm.description = "";
        vm.time = '';
        vm.price = '';
        vm.label = '';
        vm.currency = '';
        vm.reference = '';
        vm.errorLabel = '';
        vm.errorPrice = '';
        vm.errorTime = '';
        vm.peintureSelected = false;
        vm.isSubCategorySelected = false;
        vm.isTechnicalitySelected = false;
        vm.technicalLevel = false;
        vm.isMenuActive = true;
        vm.quantity = 0;
        vm.selectedTab = null;
        vm.selectedSubTabName = '';
        vm.selectedSubTab = null;
        vm.showTab = false;
        vm.showSubTab = false;
        vm.activeTabFixedPrice = '';
        vm.categories = setShowDetails(FavouriteConstantes.nonCodifiedLaborTime.categories);
        vm.listCategories = [];
        vm.categoryMenuList = FavouriteConstantes.categoryMenuList;
        vm.displayedData = [];
        vm.safeData = [];
        vm.getCategoryIconClass = getCategoryIconClass;
        vm.canAddToQuote = true;
        vm._carContext = CacheService.getObject(CacheConstants.contextCarSearch);
        vm._networkProfile = null;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @description basic fonctionalities to displayData : provding safecopy
         * @param response
         * @param filterBy
         * return {*} nothing
         */

        function displayData(response, filterByFixedPrice) {
            vm.safeData = _.orderBy(response, ['opeCode'], ['asc']);

            if (filterByFixedPrice) {
                vm.selectedTab = 0;
                vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                    if (item.category === 'TM_NOCODIF_CAT_FIXPRICE') {
                        return item;
                    }
                });
            } else {
                vm.displayedData = angular.copy(vm.safeData);
            }

            vm.updateCategories(response);
        } 

        this.$onInit = function () {
            blockUI.start();
            vm._networkProfile = CacheService.getNetworkProfile();
            if (!  vm._carContext &&  vm._networkProfile === CacheConstants.workshop) {
                vm.canAddToQuote = false;
            }
            FavoitMetierService.getNonCodedTmByCacheDealerId().then(function (response) {
                vm.displayData(response.results, true);
            }).catch(function () {
                // It's a mock if the service fails.
                // we can display some TM with it
                // vm.displayData([{ "opeCode": "5777", "label": "Remplacement sapin parfumé", "time": "2,4", "description": "Remplacement de l'arbre magique parfum pomme verte", "technicality": "TM_NOCODIF_TECH_VERY_HIGH", "category": "TM_NOCODIF_CAT_AUTO_BODY", "subCategory": "TM_NOCODIF_SCAT_MECHANICS_AND_ACCESSOIRES", "nonCoded": true, "localLaborTimeId": "5ca4c88907518c00dcd55b33" }, { "opeCode": "1999", "label": "RÉPARATION MOTEUR 234234 qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe qwe", "time": "4", "description": "Réparation niveau 3", "technicality": "TM_NOCODIF_TECH_NORMAL", "category": "TM_NOCODIF_CAT_MECHANICAL", "subCategory": "TM_NOCODIF_SCAT_ENGINE", "nonCoded": true, "localLaborTimeId": "5ca5b9d707518c00dcd55b35" }, { "opeCode": "9499", "label": "Peinture Chloé", "time": "1,3", "description": "2", "technicality": "TM_NOCODIF_TECH_HIGH", "category": "TM_NOCODIF_CAT_PAINTING", "subCategory": "", "nonCoded": true, "localLaborTimeId": "5ca60a265d715600dc34782b" }, { "opeCode": "0999", "label": "Test", "price": "177.77", "description": "", "technicality": "", "category": "TM_NOCODIF_CAT_FIXPRICE", "subCategory": "", "nonCoded": true, "localLaborTimeId": "5cab59685f150300dc643278" }, { "opeCode": "6888", "label": "test OB1.21", "time": "5,5", "description": "1234567890 1234567890 1234567890 1234567890 1234567890 1234567890 1234567890 1234567890 1234567890", "technicality": "TM_NOCODIF_TECH_HIGH", "category": "TM_NOCODIF_CAT_MECHANICAL", "subCategory": "TM_NOCODIF_SCAT_AIR_CONDITIONNER", "nonCoded": true, "localLaborTimeId": "5cac415d5f150300dc64327a" }, { "opeCode": "9499", "label": "TestOB1 09/04", "time": "3,4", "description": "test test test ", "technicality": "TM_NOCODIF_TECH_HIGH", "category": "TM_NOCODIF_CAT_PAINTING", "subCategory": "", "nonCoded": true, "localLaborTimeId": "5cac42665f150300dc64327c" }, { "opeCode": "9499", "label": "TestOB1", "time": "3", "description": "Test", "technicality": "TM_NOCODIF_TECH_HIGH", "category": "TM_NOCODIF_CAT_PAINTING", "subCategory": "", "nonCoded": true, "localLaborTimeId": "5cac42ed3e009d00dccb6dc8" }, { "opeCode": "8777", "label": "Autonome niv5", "time": "3,5", "description": "holà uzegl ami zipzngaegn", "technicality": "TM_NOCODIF_TECH_VERY_HIGH", "category": "TM_NOCODIF_CAT_MECHANICAL", "subCategory": "TM_NOCODIF_SCAT_ELEC_EQU_ACC_INSTALL", "nonCoded": true, "localLaborTimeId": "5cac44395f150300dc64327d" }, { "opeCode": "8999", "label": "Autonome niv1-2", "time": "8,7", "description": "a la playa", "technicality": "TM_NOCODIF_TECH_NORMAL", "category": "TM_NOCODIF_CAT_MECHANICAL", "subCategory": "TM_NOCODIF_SCAT_ELEC_EQU_ACC_INSTALL", "nonCoded": true, "localLaborTimeId": "5cac447b5f150300dc64327e" }, { "opeCode": "6999", "label": "Holà", "time": "0,3", "description": "", "technicality": "TM_NOCODIF_TECH_NORMAL", "category": "TM_NOCODIF_CAT_AUTO_BODY", "subCategory": "TM_NOCODIF_SCAT_SEALING", "nonCoded": true, "localLaborTimeId": "5cac44c15f150300dc64327f" }, { "opeCode": "5888", "label": "Carosserie", "time": "1,3", "description": "Description de Carrosserie et Mécanique Editée", "technicality": "TM_NOCODIF_TECH_HIGH", "category": "TM_NOCODIF_CAT_AUTO_BODY", "subCategory": "TM_NOCODIF_SCAT_MECHANICS_AND_ACCESSOIRES", "nonCoded": true, "localLaborTimeId": "5cac5a1c3e009d00dccb6dca" }]);
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        };

        /**
        * @name setShowDetails
        * @desc reset showDetails of categories/subCategories except notChangedCategorie
        * @param {Array} categories
        * @param {Object} notChangedCategorie
        */
        function setShowDetails(categories) {

            if (categories && categories != null) {
                return categories.map(function (item) {
                    item.showDetails = false;
                    return item;
                });
            }
            else{
                return categories;
            }
        }

        /**
         * @name getCategoryIconClass
         * @desc get category icon class according to showdetails attribute (true, false)
         * @param {*} category
         */
        function getCategoryIconClass(category) {
            if (category.showDetails) {
                return "fa fa-chevron-down iconWidth";
            }
            return "fa fa-chevron-right iconWidth";
        }

        function findSubCat(category) {
            var subCat = [];
            subCat = vm.listCategories.map(function (item) {
                if (item.categoryName === category) {
                    return item.subCat;
                }
            });
            return _.isEmpty(subCat) ? [] : subCat;
        }

        /**
         * @name activateSelectedTab
         * @desc activate tab on click to apply CSS class afterwards
         * @param tab id
         * @returns integer
         */

        function activateSelectedTab(id, categorie) {

            vm.selectedSubTab = null;
            vm.selectedSubTabName = '';

            vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                if (item.category === categorie.name) {
                    return item;
                }
            });

            //This value most be stored because the method setShowDetails would override it if not.
            var newShowDetailsValue = !categorie.showDetails;

            setShowDetails(vm.categories);

            if (vm.selectedTab != id) {
                vm.selectedTab = id;
            }

            categorie.showDetails = newShowDetailsValue;
        }


        /**
         * @name activateSelectedSubTab
         * @desc activate subtab on click to apply CSS class afterwards
         * @param subtab id
         * @returns integer
         */

        function activateSelectedSubTab(id, categoryName, subCategoryName) {

            vm.selectedTab = null;

            vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                if (item.category === categoryName && item.subCategory === subCategoryName) {
                    return item;
                }
                vm.selectedSubTabName = subCategoryName;
            });

            if (vm.selectedSubTab != id) {
                vm.selectedSubTab = id;
            }
        }

        function inputQuantity(item, oldQuantity) {
            var number = item.quantity = parseInt(item.quantity);
            var copyComputed = angular.copy(item);

            if (isNaN(number)) {
                // RETURN ERROR
                return
            }

            copyComputed.quantity = parseInt(oldQuantity);
            var formatedTM = formatTM(copyComputed);

            blockUI.start();
            QuoteMetierService.updateQuotePart(_actions.REPLACE_QUANTITY, _.assign(formatedTM, { quantity: number })).catch(function () {
                item.quantity = oldQuantity // reset quantity
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        vm.updateTM = updateTM;

        function updateTM(TM) {
            // to avoid mutation by updateNoCodifiedTM, we create a new object
            var copiedTM = _.assign({}, TM);

            $mdDialog.show({
                templateUrl: 'app/components/favourites/TM/components/update-no-codified-tm.template.html',
                clickOutsideToClose: true,
                controller: 'updateNoCodifiedTM',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    tm: copiedTM
                }
            }).then(function (updatedTM) {
                return FavoitMetierService.updateNonCodedTm(updatedTM).then(function () {
                    return updatedTM;
                });
            }).then(function (updatedTM) {
                // reinsert new TM in safeData
                vm.safeData = vm.safeData.map(function (data) {
                    if (updatedTM.localLaborTimeId === data.localLaborTimeId) {
                        return updatedTM;
                    }
                    return data
                });

                // some categories don't have subCategory
                // reload list

                vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                    // subCategory may can be an empty string/null/undefined so we don't check type
                    return item.category === updatedTM.category && item.subCategory == updatedTM.subCategory;
                });

            }).catch(function (err) {
                if (!err) {
                    return
                }
                toastr.error($translate.instant('ERROR'));
            })
        }

        vm.deleteTM = deleteTM;

        function deleteTM(TM) {
            $mdDialog.show({
                templateUrl: 'app/components/favourites/TM/components/delete-no-codified-tm.template.html',
                clickOutsideToClose: true,
                controller: 'deleteNonCodifiedTMController',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    tm: TM
                }
            }).then(function () {
                return FavoitMetierService.deleteNonCodeTm(TM.localLaborTimeId);
            }).then(function () {
                // reinsert new TM in safeData
                vm.safeData = vm.safeData.filter(function (data) {
                    return TM.localLaborTimeId !== data.localLaborTimeId
                });

                // some categories don't have subCategory
                // reload list
                vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                    // subCategory may can be an empty string/null/undefined so we don't check type
                    return item.category === TM.category && item.subCategory == TM.subCategory;
                });
            }).catch(function (err) {
                if (!err) {
                    return;
                }
                toastr.error($translate.instant('ERROR'));
            })
        }

        /**
         * @description Open a dialog box to add a TM on click of 'Add a TM' button on 'favourites' page
         */

        function addTM() {
            $mdDialog.show({
                templateUrl: 'app/components/favourites/TM/components/add-non-codified-tm.template.html',
                controller: 'addNonCodifiedTMController',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    categories: vm.categories,
                    displayedData: vm.displayedData
                }
            })
                .then(function (newlyAddedTm) {

                    //*** Once the item has been added multiple sort and filter are applied base on business rules ***
                    blockUI.start();
                    FavoitMetierService.getNonCodedTmByCacheDealerId().then(function (response) {

                        //We alway sort by opeCode ascending
                        vm.safeData = _.orderBy(response.results, ['opeCode'], ['asc']);


                        //Base on the added item a filter is applied on the displayed data
                        if (_.isEmpty(newlyAddedTm.subCategory)) {
                            vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                                if (item.category === newlyAddedTm.category) {
                                    return item;
                                }
                            });
                        } else {
                            vm.displayedData = angular.copy(vm.safeData).filter(function (item) {
                                if (item.category === newlyAddedTm.category && item.subCategory === newlyAddedTm.subCategory) {
                                    return item;
                                }
                            });
                        }


                        //Always update the categoriesMenu
                        vm.updateCategories(response.results);

                        //The css of the category menu is updated to highlight a selection of the menu
                        setSelectedCategoryTabAndSubTabByNameIfApplied(newlyAddedTm.category, newlyAddedTm.subCategory);

                    }).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                    }).finally(function () {
                        blockUI.stop();
                    });
                });
        }

        /**
         * @description set the category tab and the subCategoryTab base on the input params
         * @param categoryName
         * @param subCategoryName
         * return nothing
         */

        function setSelectedCategoryTabAndSubTabByNameIfApplied(categoryName, subCategoryName) {
            var categoryIndex = _.findIndex(vm.listCategories, { categoryName: categoryName });
            var subCategoryIndex;

            if (categoryIndex >= 0) {
                subCategoryIndex = _.findIndex(vm.listCategories[categoryIndex], { subCategoryName: subCategoryName });
            }

            vm.selectedTab = categoryIndex >= 0 ? categoryIndex : 0;
            vm.selectedSubTab = subCategoryIndex >= 0 ? subCategoryIndex : 0;
        }

        /**
         * @returns {string}
         */

        function getCurrentCurrency() {
            return UtilsMetierService.getCurrencyForItem();
        }

        /**
         *
         */

        function consultCurrentTm(selectedTM) {
            if(vm.canAddToQuote){
            var items = _.get(QuoteMetierService.getQuoteData(), ['shoppingCart', 'TM']);

            if (Array.isArray(items)) {
                var alreadyInShop = items.some(function (item) {
                    return item.reference === selectedTM.localLaborTimeId;
                });
            }
            var payload = {
                localLaborTimeId: selectedTM.localLaborTimeId,
                opeCode: selectedTM.opeCode,
                codified: !selectedTM.nonCoded,
                label: selectedTM.label,
                description: selectedTM.description,
                category: selectedTM.category,
                subCategory: selectedTM.subCategory,
                technicality: selectedTM.technicality,
                time: selectedTM.time,
                price: selectedTM.price
            };
            $q.resolve().then(function () {
                if (alreadyInShop) {
                    return selectedTM
                } else {
                    return $mdDialog.show({
                        templateUrl: 'app/components/favourites/TM/components/consult-non-codified-tm.template.html',
                        controller: 'consultNonCodifiedTMController',
                        bindToController: true,
                        clickOutsideToClose: true,
                        controllerAs: 'vm',
                        locals: {
                            payload: payload
                        }
                    })
                }
            }).then(function (payload) {
                return addTMToShoppingCart(payload);
            }).then(function () {
                selectedTM.quantity = 1;
            }).catch(function (err) {
                if (!err) {
                    // cancel from modal
                    return
                }
                toastr.error($translate.instant('ERROR'));
            });
        }}

        /**
         *  @desc Recreate TM structure for quote basket
         *  @param {Object} TM
         */

        function formatTM(TM) {
            if (TM.price) {
                TM.price = TM.price.replace(/,/, '.');
            }
            return {
                piece: {
                    reference: TM.localLaborTimeId,
                    quantity: TM.quantity,
                    designation: TM.label, // can be .description
                    duration: TM.time,
                    priceExclTaxes: parseFloat(TM.price),
                    id: TM.opeCode,
                    codified: TM.codified
                },
                type: 'TM'
            }
        }

        /**
         * @namespace
         * @desc add item to part requisition basket, send it to the back
         * @desc increment the the piece quantity, the pps quantities
         */

        function addTMToShoppingCart(TM) {
            return $q.resolve().then(function () {
                var quote = QuoteMetierService.getQuoteData();
                if (!_.isEmpty(quote)) {
                    return;
                }

                var body = angular.element(document.body);
                var modalParams = {
                    body: body,
                    typeOfSuperCart: globalConstant.quote,
                    title: "NEW_ESTIMATE",
                    subtitle: "ESTIMATE_NO_ACTIVE_DRAFT",
                    showList: true,
                    showActifPartRequisition: false
                }

                return listOfDraftModalService.showModal(modalParams).then(function (superCartId) {
                    var promise = null;
                    if (superCartId.item) {
                        promise = QuoteMetierService.findAndSetCurrentQuote(superCartId.item);
                    } else {
                        promise = QuoteMetierService.instanciateNewQuote();
                    }
                    return promise;
                });
            }).then(function () {
                var formatedTM = formatTM(TM);
                blockUI.start();
                return QuoteMetierService.updateQuotePart(_actions.ADD_PIECE, formatedTM);
            }).catch(function (err) {
                return $q.reject(err);
            }).finally(function () {
                blockUI.stop();
            })
        }


        /**
         * @name increment
         * @desc increments count variable in inputs
         * @param
         * @returns integer
         */

        function increment(item) {
            var formatedTM = formatTM(item);
            QuoteMetierService.updateQuotePart(_actions.ADD_QUANTITY, formatedTM).then(function () {
                item.quantity += 1;
            }).finally(function () {
                blockUI.stop();
            })
        }


        /**
         * @name decrement
         * @desc decrements count variable in inputs
         * @param
         * @returns integer
         */

        function decrement(item) {
            var formatedTM = formatTM(item);

            blockUI.start();
            QuoteMetierService.updateQuotePart(_actions.REDUCE_QUANTITY, formatedTM).then(function () {
                item.quantity -= 1;
            }).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @description Close the dialog box on click on 'Cancel'
         */
        function cancel() {
            $mdDialog.hide(vm.displayedData);
        }

        /**
         * @description Count the number of characters to modify the label
         * that shows the number of charcters inserted in the description box
         * @param {*} description
         */
        function characterCount(description) {
            vm.description = description;
        }

        /**
         * @description update category base on incoming list from the api
         * @param nonCodedTmList
         */
        function updateCategories(nonCodedTmList) {

            vm.listCategories = _(nonCodedTmList)
                .groupBy(function (cat) {
                    return cat.category;
                })
                .map(function (value, key) {
                    return {
                        categoryName: key,
                        subCat: _(value)
                            .groupBy(function (subCat) {
                                return subCat.subCategory;
                            })
                            .map(function (value, key) {
                                if (key !== 'undefined') {
                                    return {
                                        subCategoryName: key,
                                        technicality: value
                                    };
                                }
                            }).value()
                    };
                })
                .value();

            vm.listCategories = UtilsMetierService.
                arrayMerger(FavouriteConstantes.menuCategoriesList, vm.listCategories, "categoryName");

        }
    }
})();

/**
 * FavouritesController
 * @namespace Controller
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('FavouritesPRController', FavouritesPRController);

    /* @ngInject */
    function FavouritesPRController(
        $mdDialog,
        blockUI,
        $state,
        toastr,
        $translate,
        RoutesConstants,
        FavouriteConstantes,
        UtilsMetierService,
        FavoitMetierService,
        DocumentsMetierService,
        DeleteModalService,
        DealerManagerSystemeService,$q,$log) {

        /*=============================================
       =                 VARIABLES                   =
       =============================================*/
        var vm = this;
        vm.favoritesProduct = [];
        vm.selectedCategoryIndex = -1;
        vm.selectedSubCategoryIndex = -1;
        vm.subCategories = [];
        vm.favoritesPRList = [];
        vm.selectedCategory = "";
        vm.selectedSubCategory = "";
        vm.sortedBy = 'reference';
        vm.reverse = false;
        vm.tempSubCategoryList = [];
        vm.tempEditSubCategories = [];
        vm.isEditMode = false;
        vm.modeParam = 0;
        vm.isUserDms = DealerManagerSystemeService.getHookResult();
        vm.selectedAll = false;
        vm.checkedSubCategory = [];
        vm.transmitData = $translate.instant('FAV_SELECTION_NUMBER').replace('#1', "0");
        vm.disableButtons = FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList) < 1;
        vm.productIds = [];
        vm.indexCat = 0;
        vm.currentPage = 0;
        vm.showMoreLink = false;
        //vm.init = init;
        vm.addPR = addPR;
        vm.moveRef = moveRef;
        vm.getproductsForcategory = getproductsForcategory;
        vm.onSelectCategory = onSelectCategory;
        vm.onSelectSubCategory = onSelectSubCategory;
        vm.getCategoryIconClass = getCategoryIconClass;
        vm.getCurrentCurrency = getCurrentCurrency;
        vm.getOrderClass = getOrderClass;
        vm.sortColumn = sortColumn;
        vm.goToProductPage = goToProductPage;
        vm.copyToClipboard = copyToClipboard;
        vm.getStockClass = getStockClass;
        vm.editCategory = editCategory;
        vm.addSubCategory = addSubCategory;
        vm.editSubCategory = editSubCategory;
        vm.saveChanges = saveChanges;
        vm.deleteConfirmation = deleteConfirmation;
        vm.confirmSelectionDel = confirmSelectionDel;
        vm.deleteSubCategory = deleteSubCategory;
        vm.closeEdit = closeEdit;
        vm.onChangeMode = onChangeMode;
        vm.getEditIconClass = getEditIconClass;
        vm.getSaveIconClass = getSaveIconClass;
        vm.getCloseIconClass = getCloseIconClass;
        vm.selectAll = selectAll;
        vm.onSelect = onSelect;
        vm.showSubCategories = showSubCategories;
        vm.showMoreReference = showMoreReference;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.$onInit = function () {
            blockUI.start();
            //get favorites products
            var categoryKeyForProduct;
            var categoryIndexForProducts = 0;
            if($state.params.category){
                categoryKeyForProduct = FavouriteConstantes.defaultCategories[$state.params.category];
                categoryIndexForProducts = $state.params.category
            }
            else {
                categoryKeyForProduct = FavouriteConstantes.defaultCategories[0];
            }
            getproductsForcategory(categoryKeyForProduct).then(function (response){
                if(response && response.categories && response.categories[categoryIndexForProducts].products){
                    return response;
                }
                return null;
            }).then( function(response){
            FavoitMetierService.getCategoriesByDealerId().then(function (dacaResponse) {
                //check category and subcategory data from url
                //update selectedCategoryIndex and selectedSubCategoryIndex
                //show details for the selected category
                if(response) {
                    _.merge(dacaResponse, response);
                }
                vm.selectedCategoryIndex = 0;

                var selectedItem = {};
                var isSelectedSubCategory = false;

                vm.favoritesProduct = dacaResponse;
                vm.tempResponse = vm.favoritesProduct;
                vm.favoritesProduct.categories = setShowDetails(vm.favoritesProduct.categories);
                vm.transmitData = $translate.instant('FAV_SELECTION_NUMBER').replace('#1', "0");
                vm.disableButtons = true;
                vm.selectedAll = false;
                vm.productIds = [];

                //to update the mode in html
                if ($state.params.mode) {
                    vm.modeParam = $state.params.mode;
                    if ($state.params.mode == 1) {
                        vm.isEditMode = true;
                    } else {
                        vm.isEditMode = false;
                    }
                }

                //if we have selected category, get selected category's object
                if ($state.params.category) {
                    vm.selectedCategoryIndex = $state.params.category;
                }

                //if we have selected sub-category, get selected subcategory's object
                if ($state.params.subCategory && $state.params.subCategory != -1) {
                    isSelectedSubCategory = true;
                    vm.selectedSubCategoryIndex = $state.params.subCategory;
                    selectedItem = vm.favoritesProduct.categories[vm.selectedCategoryIndex].subCategories[vm.selectedSubCategoryIndex];
                    vm.selectedCategory = vm.favoritesProduct.categories[vm.selectedCategoryIndex].categoryName;
                    vm.selectedSubCategory = selectedItem.subCategoryName;
                    vm.selectedSubCategoryKey = selectedItem.subcategoryKey;
                    vm.selectedCategoryKey = vm.favoritesProduct.categories[vm.selectedCategoryIndex].categoryKey;
                } else {
                    selectedItem = vm.favoritesProduct.categories[vm.selectedCategoryIndex];
                    vm.selectedCategory = selectedItem.categoryName;
                    vm.selectedCategoryKey = selectedItem.categoryKey;
                }

                //get PR from category only if we have object
                if (!_.isEmpty(selectedItem) && selectedItem.products && selectedItem.products.length > 0) {
                    return getPRFromCategory(selectedItem).then(function (referencesInformations) {
                        if (isSelectedSubCategory) {
                            vm.favoritesProduct.categories[vm.selectedCategoryIndex].showDetails = true;
                        }
                        return referencesInformations;
                    }).catch(function(){
                        return $q.reject();
                    })
                }

                return [];
            
            }).then(function (referencesInformations) {
                vm.favoritesPRList = referencesInformations;
                vm.favoritesPRList.forEach(function (item) {
                    item.isSelected = false;
                });
                //update url by selected category
                $state.go(RoutesConstants.favouritesPR, {
                    category: vm.selectedCategoryIndex,
                    subCategory: vm.selectedSubCategoryIndex,
                    mode: vm.modeParam
                }, { notify: false });
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        });
        }
        

        /**
         * @name onSelectCategory
         * @desc This action is fired when user select a category
         * @param {Object} category
         */
        function onSelectCategory(category) {
            blockUI.start();
            getproductsForcategory(category.categoryKey).then(function (response) {
                response.categories.forEach( function(element){
                    if(element.categoryKey === category.categoryKey){
                        category = element;
                        _.merge(vm.favoritesProduct.categories,response.categories);  
                    }
                });
            }).then( function(response) {  
            //Assign categorie to variable + set other variables
            vm.selectedCategory = category.categoryName;
            vm.selectedCategoryKey = category.categoryKey;
            vm.selectedSubCategoryKey=""
            vm.selectedSubCategory = "";
            vm.selectedAll = false;
            vm.transmitData = $translate.instant('FAV_SELECTION_NUMBER').replace('#1', FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList));
            vm.productIds = [];
            vm.favoritesPRList = [];
            nbLinesChecked();

            //get category's PR List
   
            getPRFromCategory(category).then(function (referencesInformations) {
                //get favorites PR for selected category
                vm.favoritesPRList = referencesInformations;

                //hide all sub categories except selected
                vm.favoritesProduct.categories.map(function (item) {
                    if (!_.isEqual(item.categoryName, category.categoryName)) {
                        item.showDetails = false;
                        item.isEditing = false;
                    }
                });

                //reset selected category and sub category index
                vm.selectedCategoryIndex = -1;
                vm.selectedSubCategoryIndex = -1;

                //get selected category index
                vm.selectedCategoryIndex = _.findIndex(vm.favoritesProduct.categories, function (o) {
                    return o.categoryName == category.categoryName;
                });

                //reset sorting
                vm.sortedBy = 'reference';
                vm.reverse = false;

                //update url by selected category without refresh page
                $state.go(RoutesConstants.favouritesPR, {
                    category: vm.selectedCategoryIndex,
                    subCategory: vm.selectedSubCategoryIndex,
                    mode: vm.modeParam
                }, { notify: false });
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            });
        }).finally(function () {
            blockUI.stop();
        });
        }

        /**
         * @name onSelectSubCategory
         * @desc This action is fired when user select a sub category
         * @param {Array} subCategories
         * @param {Object} currentSubCategory
         */
        function onSelectSubCategory(subCategories, currentSubCategory) {

            blockUI.start();
            vm.selectedSubCategory = currentSubCategory.subCategoryName;
            vm.selectedSubCategoryKey = currentSubCategory.subcategoryKey;
            vm.selectedAll = false;
            vm.transmitData = $translate.instant('FAV_SELECTION_NUMBER').replace('#1', FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList));
            vm.productIds = [];
            vm.favoritesPRList = [];
            nbLinesChecked();

            //get favorit PR list
            getPRFromCategory(currentSubCategory).then(function (response) {
                //get favories PR for selected subcategory
                vm.favoritesPRList = response;

                //reset selected category and sub category index
                vm.selectedSubCategoryIndex = -1;

                //get selected sub category's index
                vm.selectedSubCategoryIndex = _.findIndex(subCategories, function (o) {
                    return o.subCategoryName == currentSubCategory.subCategoryName;
                });

                //reset sorting
                vm.sortedBy = 'reference';
                vm.reverse = false;

                //update url by selected sub-category
                $state.go(RoutesConstants.favouritesPR, {
                    category: vm.selectedCategoryIndex,
                    subCategory: vm.selectedSubCategoryIndex,
                    mode: vm.modeParam
                }, { notify: false });
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * 
         * @param {categorykey} categoryKey
         * @desc get products for the selected category 
         */
        function getproductsForcategory(categoryKey) {
            return FavoitMetierService.getFavoritesProductsByDealerId(categoryKey).then(function (response) {
                return response;
            }).catch(function(){
                return $q.reject();
            });
        }
        /**
         * @name addPR
         * @desc Open a dialog box to add a PR on click of 'Add a PR' button on 'favourites' page
         */
        function addPR() {
            $mdDialog.show({
                templateUrl: 'app/components/favourites/PR/components/add-favorite-pr.template.html',
                controller: 'AddFavoritPRController',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    categories: vm.favoritesProduct.categories,
                    selectedCategoryIndex: vm.selectedCategoryIndex,
                    selectedSubCategoryIndex: vm.selectedSubCategoryIndex
                }
            }).then(function (response) {
                $state.go(RoutesConstants.favouritesPR, {
                    category: response.changedCategoryIndex,
                    subCategory: response.changedSubCategoryIndex,
                    mode: vm.modeParam
                }, { notify: true, reload: true, inherit: false });
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });

        }

        /**
         * @name moveRef
         * @desc Open a dialog box to move selected references on click of 'Move' button on 'favourites/product' page
         */
        function moveRef() {
            $mdDialog.show({
                templateUrl: 'app/components/favourites/PR/components/move-reference-template.html',
                controller: 'moveReferenceController',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    categories: vm.favoritesProduct,
                    favoritesPRList: vm.favoritesPRList,
                    productIds: vm.productIds,
                    selectedCategory: vm.selectedCategoryKey,
                    selectedSubCategory: vm.selectedSubCategoryKey
                }
            }).then(function (response) {
                // reinitialization
                if (!response.subCategory.subCategoryName){
                    vm.selectedSubCategory = "";
                }
                $state.go(RoutesConstants.favouritesPR, {
                    category: response.category,
                    subCategory: response.subCategory,
                    mode: vm.modeParam
                }, { notify: false });
                vm.$onInit();
            });
        }



        /**
         * @name confirmSelectionDel
         * @desc confirmation pop-in before delete selection favoris produits en cliquant sur bouton "Supprimer"
         */
        function confirmSelectionDel() {
            $mdDialog.show({
                templateUrl: 'app/components/favourites/PR/components/deleteRefModal.template.html',
                controller: 'DeleteRefModalCtrl',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    favoritesPRList: vm.favoritesPRList,
                    productIds: vm.productIds,
                    selectedCategory: vm.selectedCategoryKey,
                    selectedSubCategory: vm.selectedSubCategoryKey
                }
            }).then(function (response) {
                $state.go(RoutesConstants.favouritesPR, {
                    category: vm.selectedCategoryIndex,
                    subCategory: vm.selectedSubCategoryIndex,
                    mode: vm.modeParam
                }, { notify: false });
                vm.$onInit();
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
        }

        /**
         * @name getCategoryIconClass
         * @desc get category icon class according to showdetails attribute (true, false)
         * @param {*} category
         */
        function getCategoryIconClass(category) {
            if (category.subCategories && category.subCategories.length > 0) {
                if (category.showDetails) {
                    return "fa fa-chevron-down";
                } else {
                    return "fa fa-chevron-right";
                }
            }
            return "hideIcon";

        }

        /**
         * @name showSubCategories
         * @desc show subcategories in categories menu
         * @param {*} category
         */
        function showSubCategories(category) {
            if (category.subCategories && category.subCategories.length > 0) {
                if (!category.showDetails) {
                    category.showDetails = true;
                } else {
                    category.showDetails = false;
                }
            }
        }

        /**
         * @name goToProductPage
         * @desc redirect user to product sheet
         * @param {String} reference
         */
        function goToProductPage(reference) {
             reference = (reference || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
            $state.go(RoutesConstants.product, { reference: reference })
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        /**
         * @name sortColumn
         * @desc this action is fired when user click on the sort button
         * @param {String} columnName
         */
        function sortColumn(columnName) {
            vm.reverse = !vm.reverse;
            vm.sortedBy = columnName;
        }

        /**
         * @name getOrderClass
         * @desc get column's order classs
         * @param {String} columnHeader
         */
        function getOrderClass(columnHeader) {
            var top = false;
            var bottom = false;

            if (columnHeader === 'reference' && vm.sortedBy === 'reference') {
                top = vm.reverse ? false : true;
                bottom = !top;
            } else if (columnHeader === 'designation' && vm.sortedBy === 'designation') {
                top = vm.reverse ? false : true;
                bottom = !top;
            }

            return {
                "icon-sort": true,
                "icon-sort-top": top,
                "icon-sort-bottom": bottom
            }
        }

        /**
         * @name getStockClass
         * @desc get class for stock
         */
        function getStockClass(stock) {
            if (stock === "-") {
                return "";
            } else if (stock > 0) {
                return 'stockDispo';
            } else {
                return "stockIndispo";
            }
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name getPRFromCategory
         * @desc get PR list from selected category
         * @param {*} category
         */
        function getPRFromCategory(category) {
            blockUI.start();
            var tempArr = [];
            if(category.products && !_.isEmpty(category.products)){
                if(category.products.length <= 99){
                    vm.showMoreLink = false;
                    tempArr = category.products;
                }else{
                    vm.showMoreLink = true;
                    vm.currentPage = 1; 
                    var numberOfCases = category.products.length / 99;
                    var isNumber = isInteger(numberOfCases);
                    if (isNumber) {
                        vm.totalPage = numberOfCases;
                    } else {
                        vm.totalPage = Math.ceil(numberOfCases);
                    }
                    tempArr = category.products.slice(0,99); 
                }
                return DocumentsMetierService.getReferencesInformations(tempArr).then(function (response) {
                    return response;
                }).catch(function(){
                    return $q.reject();
                }).finally(function (){
                    blockUI.stop();
                })

            }
            else{
                
                blockUI.stop();
                return $q.resolve();
            }
            
        }
        function isInteger(totalCases) {
            return (typeof totalCases === 'number') && (totalCases % 1 === 0);
        }
        /**
         * @name setShowDetails
         * @desc reset showDetails of categories/subCategories except notChangedCategorie
         * @param {Array} categories
         * @param {Object} notChangedCategorie
         */
        function setShowDetails(categories) {
            return categories.map(function (item) {
                item.showDetails = false;
                return item;
            });
        }

        /***
         * @name getCurrentCurrency
         * @desc get currency
         */
        function getCurrentCurrency() {
            return UtilsMetierService.getCurrencyForItem();
        }

        /**
         * @name onChangeMode
         * @desc to change the mode and update in url
         */
        function onChangeMode() {
            vm.modeParam = vm.isEditMode ? 1 : 0;
            vm.favoritesProduct.categories.map(function (category) {
                category.isEditing = false;
                category.showDetails = false;
            });
            $state.go(RoutesConstants.favouritesPR, {
                category: vm.selectedCategoryIndex,
                subCategory: vm.selectedSubCategoryIndex, mode: vm.modeParam
            }, { notify: false });

        }


        /**
         * @name editCategory
         * @desc show the sub categories in the text box for the editable category
         * @param {Array} categoryEdited
         */
        function editCategory(categoryEdited) {
            //temporary array to store the non-edited category
            vm.tempSubCategoryList = angular.copy(categoryEdited);

            //to make only the selected subCategory editable
            var category = _.find(vm.favoritesProduct.categories, function (catTmp) {
                return catTmp === categoryEdited;
            });
            if (category) {
                category.isEditing = true;
                category.showDetails = true;
            }
        }

        /**
         * @name addSubCategory
         * @desc Add new sub category
         * @param {Array} category
         */
        function addSubCategory(category, newSubCategoryName) {

            vm.newSubCategoryName = '';
            if (!_.isEmpty(newSubCategoryName)) {
                blockUI.start();
                return FavoitMetierService.addSubCategory(category, newSubCategoryName).then(function (addedResponse) {
                    return addedResponse;
                }).then(function (addedResponse) {
                    //if the sub category is added in DACA, will add it to the temporary variable as well
                    if (vm.tempSubCategoryList.subCategories) {
                        vm.tempSubCategoryList.subCategories.push({
                            subcategoryKey: addedResponse.subcategoryKey,
                            subCategoryName: newSubCategoryName,
                            isDefault: false
                        });
                    } else {
                        var subCategory = {
                            subCategories: [{
                                subcategoryKey: addedResponse.subcategoryKey,
                                subCategoryName: newSubCategoryName,
                                isDefault: false
                            }]
                        };
                        _.assign(vm.tempSubCategoryList, subCategory);
                    }
                    toastr.success($translate.instant('SUBCATEGORY_ADDED'));
                }).catch(function (e) {
                    if (e.data && e.data.errors && e.data.errors[0]) {
                        toastr.error($translate.instant(e.data.errors[0].errorMessage));
                    } else {
                        toastr.error($translate.instant("ERROR"));
                    }
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        /**
         * @name editSubCategory
         * @desc To edit the sub category
         * @param {Array} category
         * @param {Array} subCategoryName
         * @param {integer} index
         */
        function editSubCategory(category, subCategoryName, index) {
            // to copy the categories into temp array to add the new subcategory name during edit
            if (_.isEmpty(vm.tempEditSubCategories)) {
                vm.tempEditSubCategories = angular.copy(category);
            }

            //add new property newSubCategoryName to store the newly edited name
            vm.tempEditSubCategories.subCategories[index].newSubCategoryName = subCategoryName;
            vm.tempEditSubCategories.subCategories[index].subCategoryName = vm.tempSubCategoryList.subCategories[index].subCategoryName;

        }


        /**
         * @name saveChanges
         * @desc to save the changes of sub category in DACA
         * @param {Array} category
         */
        function saveChanges(category) {

            //filter the subcategories which are having edited name 
            var editedObj = _.filter(vm.tempEditSubCategories.subCategories, function (item,i) {
                if (item.newSubCategoryName) {
                    _.extend(item, {
                        index : i
                    })
                    return item;
                }
            })
            if (editedObj.length > 0) {
                blockUI.start();
                _.forEach(editedObj, function (subCategorie) {
                    
                    var editSubcategoryKey = vm.tempSubCategoryList.subCategories[subCategorie.index].subcategoryKey;
                    _.extend(subCategorie, {
                        subcategoryKey: editSubcategoryKey
                    })

                    return FavoitMetierService.updateSubCategory(category, subCategorie).then(function (updatedResponse) {
                        return updatedResponse;
                    }).then(function (updatedResponse) {
                        toastr.success($translate.instant('SUBCATEGORY_CHANGES_SAVED'));
                        category.isEditing = false;
                        category.showDetails = false;
                        $state.reload();
                    }).catch(function (e) {
                        if (e.data && e.data.errors && e.data.errors[0]) {
                            toastr.error($translate.instant(e.data.errors[0].errorMessage));
                        } else {
                            toastr.error($translate.instant("ERROR"));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
                });
            } else {
                category.isEditing = false;
                category.showDetails = false;
                toastr.success($translate.instant('SUBCATEGORY_CHANGES_SAVED'));
            }
            vm.newSubCategoryName = '';
        }

        /**
         * @name closeEdit
         * @desc cancel the edit mode of the category
         * @param {Array} category
         */
        function closeEdit(category) {
            vm.newSubCategoryName = '';
            category.isEditing = false;
            category.showDetails = false;
            //to revert the changes made during the edit
            category.subCategories = vm.tempSubCategoryList.subCategories;
        }

        /**
         * @name deleteConfirmation
         * @desc confirmation pop-in before delete
         * @param {integer} toDeleteIndex
         */
        function deleteConfirmation(category, toDeleteIndex) {
            var modalParams = {
                title: $translate.instant('DELETE_SUBCATEGORY_CONFIRMATION'),
                isList: false
            };
            DeleteModalService.showModal(modalParams).then(function () {
                vm.deleteSubCategory(category, toDeleteIndex);
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });

        }

        /**
         * @name deleteSubCategory
         * @desc delete the sub category in DACA
         * @param {Array} category
         * @param {int} toDeleteIndex
         */
        function deleteSubCategory(category, toDeleteIndex) {
            //to get the unedited subCategory name from the temp list
            var subCategoryKey = vm.tempSubCategoryList.subCategories[toDeleteIndex].subcategoryKey;
            blockUI.start();
            return FavoitMetierService.deleteSubCategory(category, subCategoryKey).then(function (response) {
                return response;
            }).then(function (response) {
                category.subCategories.splice(toDeleteIndex, 1);
                vm.tempSubCategoryList.subCategories.splice(toDeleteIndex, 1);
                toastr.success($translate.instant('SUBCATEGORY_DELETED'));
            }).catch(function (e) {
                if (e.data && e.data.errors && e.data.errors[0]) {
                    toastr.error($translate.instant(e.data.errors[0].errorMessage));
                } else {
                    toastr.error($translate.instant("ERROR"));
                }
            }).finally(function () {
                blockUI.stop();
            });

        }

        /**
         * @name getEditIconClass
         * @desc get css class for Edit Icon
         * @param {Object} category
         */
        function getEditIconClass(category) {

            if (!vm.isEditMode && !category.isEditing) {
                return "fa fa-pencil font-icon margin pointer";
            }
            return "hideEditIcon"

        }

        /**
         * @name getSaveIconClass
         * @desc get css class for save icon
         * @param {Object} category
         */
        function getSaveIconClass(category) {

            if (!vm.isEditMode && category.isEditing) {
                return "fa fa-save dms-icons-family";
            }
            return "hideIcon"
        }

        /**
         * @name getCloseIconClass
         * @desc get css class for close icon
         * @param {Object} category
         */
        function getCloseIconClass(category) {

            if (!vm.isEditMode && category.isEditing) {
                return "icon-icons_close";
            }
            return "hideIcon"

        }

        function selectAll() {
            vm.favoritesPRList.forEach(function (product) {
                product.isSelected = vm.selectedAll;
                if (product.isSelected === true && !vm.productIds.includes(product.reference)) {
                    vm.productIds.push(product.reference);
                } else if (product.isSelected === false) {
                    vm.productIds = [];
                }
            });
            nbLinesChecked();
        }

        function onSelect() {
            //If product selected/unselected, add/remove product reference to array productIds
            vm.favoritesPRList.forEach(function (product) {
                if (product.isSelected === true && !vm.productIds.includes(product.reference)) {
                    vm.productIds.push(product.reference);
                } else if (product.isSelected === false && vm.productIds.includes(product.reference)) {
                    var index = vm.productIds.indexOf(product.reference);
                    vm.productIds.splice(index, 1);
                }
            });

            //If all product selected, select header checkbox
            vm.selectedAll = vm.favoritesPRList.every(function (item) {
                return item.isSelected === true;
            });
            nbLinesChecked();
        }

        function nbLinesChecked() {
            vm.transmitData = $translate.instant('FAV_SELECTION_NUMBER').replace('#1', FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList));
            vm.disableButtons = FavoitMetierService.getSelectedReferencesNumber(vm.favoritesPRList) < 1;
        }
        
        function showMoreReference(){
            var data = {}
            if ($state.params.subCategory && $state.params.subCategory != -1) {
                data = vm.favoritesProduct.categories[vm.selectedCategoryIndex].subCategories[vm.selectedSubCategoryIndex];
            }else{
                data = vm.favoritesProduct.categories[vm.selectedCategoryIndex];
            }
            if(vm.currentPage < vm.totalPage){
                var start = vm.currentPage * 99;
                vm.currentPage++;
                var end = (vm.currentPage == vm.totalPage) ? data.products.length : vm.currentPage * 99;
                var tempArr = data.products.slice(start,end); 
                return DocumentsMetierService.getReferencesInformations(tempArr).then(function (response) {
                    return response;
                }).then(function (referencesInformations) {
                    vm.favoritesPRList = _.concat(vm.favoritesPRList,referencesInformations);
                    $state.go(RoutesConstants.favouritesPR, {
                        category: vm.selectedCategoryIndex,
                        subCategory: vm.selectedSubCategoryIndex,
                        mode: vm.modeParam
                    }, { notify: false });
                }).catch(function(){
                    return $q.reject();
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }
    }
})();


(function () {
    'use strict';
    angular.module('phenix').service('DocPrivWsService', DocPrivWsService);

    function DocPrivWsService($q,DocPrivConstants,RestUpgrade) {

        this.getFamilyBrandFilter = getFamilyBrandFilter;
        this.getTreeNode = getTreeNode;
        this.getPlateNumber = getPlateNumber;
        this.getDocPrivPlates = getDocPrivPlates;
        this.getDocPrivParts = getDocPrivParts;
        this.getMtcLines = getMtcLines;


        function getFamilyBrandFilter(payload) {
            return RestUpgrade.all(DocPrivConstants.restCarSearchFamilyBrandFilter).post(payload).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getMtcLines(payload) {
            return RestUpgrade.all(DocPrivConstants.mtcLines).post(payload).then(function (res) {
                return res;
            }).catch(function () {
                return $q.reject();
            });
        }

        function getTreeNode(payload) {
            return RestUpgrade.all(DocPrivConstants.restCarSearchTreeNode).post(payload).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getPlateNumber(payload) {
            return RestUpgrade.all(DocPrivConstants.restCarSearchPlateNumber).post(payload).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getDocPrivPlates(body) {
            var defer = $q.defer();

            if(body.next_url) {
                body.next_url = body.next_url.substring(7);
                var endpoint = DocPrivConstants.docPrivPlates + body.next_url;
            }

            else{
                var endpoint = DocPrivConstants.docPrivPlates;
            }

            RestUpgrade.all(endpoint).post(body).then(function(res){
                defer.resolve(res);
            }).catch(function(error){
                defer.reject(error);
            });
            return defer.promise;
        }

        function getDocPrivParts(payload){

            return RestUpgrade.all(DocPrivConstants.docPrivParts)
            .post(payload).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });

        }

        

    }

    })();


(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DocPrivMetierService', DocPrivMetierService);

    /** @ngInject */
    function DocPrivMetierService($q,DocPrivWsService,CacheService,toastr,blockUI,DocPrivConstants,
        $translate,$http,configConstantes,$filter,$log,PDFViewService,MainMetierService,$rootScope,RoutesConstants,CarSearchConstants) {


        var vm = this;

        vm.plateDetails;
        vm.mtcLineDetails;
        vm.listFamiliesDetails;
        vm.isCommentsAvailable = false;
        var selectedPlateId = '';
        var isDocpriv = '';
        var isVinFromDocpriv = false;
        vm.partsList = [];
        var arraySortOrder = ["007V","007B","007E","007G","008","999","998","948","946","997","996","968","966" ];
        var varApplSortOrder = ["MODAP1","APVAP1","APVAP2","APVAP3","APVAP4","MODAV1","APVAV1","APVAV2","APVAV3","APVAV4" ];       
        vm.getFamilyBrandList = getFamilyBrandList;
        vm.getTreeNodeList = getTreeNodeList;
        vm.getPlateNumberList = getPlateNumberList;
        vm.getDocPrivPlates = getDocPrivPlates;
        vm.getDocPrivParts = getDocPrivParts;
        vm.setPlateDetails = setPlateDetails;
        vm.getPlateDetails = getPlateDetails;
        vm.setCommentsAvailability = setCommentsAvailability;
        vm.getCommentsAvailability = getCommentsAvailability;
        vm.processSimplifiedApplicability = processSimplifiedApplicability;
        vm.getPlateLines = getPlateLines;
        vm.setPlateId = setPlateId;
        vm.getPlateId = getPlateId;
        vm.clearPlateId = clearPlateId;
        vm.callAllPlates = callAllPlates;
        vm.callAllImages = callAllImages;
        vm.downloadWordGeneric = downloadWordGeneric;
        vm.downloadPdfData = downloadPdfData;
        vm.setPartsListDetails = setPartsListDetails;
        vm.groupTargets = groupTargets;
        vm.getMtcLinesList = getMtcLinesList;
        vm.setMtcLineDetails = setMtcLineDetails;
        vm.getMtcLineDetails = getMtcLineDetails;
        vm.setListFamilies = setListFamilies;
        vm.getListFamilies = getListFamilies;
        vm.setBorneo3Resposne = setBorneo3Resposne;
        vm.getBorneo3Resposne = getBorneo3Resposne;
        vm.removeBorneo3Resposne = removeBorneo3Resposne;
        vm.setRepairManuals = setRepairManuals;
        vm.getRepairManuals = getRepairManuals;
        vm.removeRepairManuals = removeRepairManuals;
        vm.setLabourTimeResposne = setLabourTimeResposne;
        vm.getLabourTimeResposne = getLabourTimeResposne;
        vm.removeLabourTimes = removeLabourTimes;
        vm.setProductResposne = setProductResposne;
        vm.getProductResposne = getProductResposne;
        vm.removeProductResposne = removeProductResposne;
        vm.setInterventionResposne = setInterventionResposne;
        vm.getInterventionResposne = getInterventionResposne;
        vm.removeInterventionResposne = removeInterventionResposne;
        vm.setSearchEngineMd = setSearchEngineMd;
        vm.getSearchEngineMd = getSearchEngineMd;
        vm.removeSearchEngineMd = removeSearchEngineMd;
        vm.setPrResponse = setPrResponse;
        vm.getPrResponse= getPrResponse;
        vm.removePrResponse = removePrResponse;
        
        function setCommentsAvailability(isCommentsAvailable){
            vm.isCommentsAvailable = isCommentsAvailable;
          }
    
          function getCommentsAvailability(){
            return vm.isCommentsAvailable;
          }

        function setPlateDetails(data){
            vm.plateDetails = data;
        }
        function setPartsListDetails(data){
            vm.plateDetails ? _.assign(vm.plateDetails,{partsList: data}) : vm.plateDetails = {partsList: data};
        }

        function getPlateDetails(){
            return vm.plateDetails;
        }

        function setMtcLineDetails(data) {
            vm.mtcLineDetails = data;
        }

        function setBorneo3Resposne(data) {
            vm.borneoResponse = data;
        }

        function getBorneo3Resposne() {
            return vm.borneoResponse;
        }

        function removeBorneo3Resposne(){
            vm.borneoResponse = [];
        }

        function getRepairManuals(){
            return vm.repairManualResponse;
        }

        function setRepairManuals(data){
            vm.repairManualResponse = data;
        }

        function removeRepairManuals(){
            vm.repairManualResponse = [];
        }

        function setLabourTimeResposne(data) {
            vm.labourTimeResposne = data;
        }

        function getLabourTimeResposne() {
            return vm.labourTimeResposne;
        }

        function removeLabourTimes(){
            vm.labourTimeResposne = [];
        }

        function setProductResposne(data) {
            vm.productResposne = data;
        }

        function getProductResposne() {
            return vm.productResposne;
        }

        function removeProductResposne(){
            vm.productResposne = [];
        }

        function setInterventionResposne(data) {
            vm.interventionResposne = data;
        }

        function getInterventionResposne() {
            return vm.interventionResposne;
        }

        function removeInterventionResposne(){
            vm.interventionResposne = [];
        }

        function setSearchEngineMd(data) {
            vm.searchEngineMd = data;
        }

        function getSearchEngineMd() {
            return vm.searchEngineMd;
        }

        function removeSearchEngineMd(){
            vm.searchEngineMd = [];
        }

        function setPrResponse(data){
            vm.prResponse = data;
        }
        function getPrResponse() {
            return vm.prResponse;
        }

        function removePrResponse(){
            vm.prResponse = [];
        }

        function getMtcLineDetails() {
            return vm.mtcLineDetails;
        }

        function setListFamilies(data) {
            vm.listFamiliesDetails = data;
        }

        function getListFamilies() {
            return vm.listFamiliesDetails;
        }

        function getFamilyBrandList() {
            var backRequest = getUserContext();
            updateUserContextProfiles(backRequest.userContext);
            return DocPrivWsService.getFamilyBrandFilter(backRequest).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getMtcLinesList(applicabilityListData) {

            var payload = {
                applicabilityList: applicabilityListData ? applicabilityListData : []
            }

            return DocPrivWsService.getMtcLines(payload).then(function (res) {
                return res;
            }).catch(function () {
                return $q.reject();
            });
        }

        function getTreeNodeList() {
            var backRequest = getUserContext();

            return DocPrivWsService.getTreeNode(backRequest).then(function(res){
                return res;
              }).catch(function(){
                return $q.reject();
            });
        }

        function getUserContext() {
            var userContext = CacheService.getUserContext();


            var payload = {
                userContext: userContext
            }

            return payload;
        }

        function getPlateNumberList(families, brands) {
            var userContext = CacheService.getUserContext();
           
            if(families && brands && !_.isEmpty(brands)){
                var payload = {
                    family: families,
                    brand: brands,
                    userContext: userContext
                    
                };
            }
            if(families && !brands){
                var payload = {
                    family: families,
                    userContext: userContext
                };
            }
                return DocPrivWsService.getPlateNumber(payload).then(function(res){
                    return res;
                  }).catch(function(){
                    return $q.reject();
                });
        }

        function getDocPrivPlates(body, next_url) {
            var userContext = CacheService.getUserContext();
            updateUserContextProfiles(userContext);
            var userProfil = CacheService.getUserProfile();
            vm.isIndependentUser = MainMetierService.isIndependantUser(userProfil.roles);
            _.extend(body, {
                userContext: userContext
            })
            if (vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV) {
                if (vm.mtcLineDetails && vm.mtcLineDetails.carContext && !_.isEmpty(vm.mtcLineDetails.carContext)) {
                    var multipleMtcLine =[];
                    if (!_.isEmpty(body.family)) {
                        vm.mtcLineDetails.carContext.forEach(function (list) {
                            var mtcLineCarcontext = {};
                            Object.keys(list).forEach(function (key) {
                                var keyValue = key.slice(0, 3);
                                if (keyValue == "007") {
                                    if (list[key] && !_.isEmpty(list[key]) && list[key].includes(body.family)) {
                                        mtcLineCarcontext = list;
                                        delete mtcLineCarcontext['applicability'];
                                        multipleMtcLine.push(mtcLineCarcontext)
                                    }
                                }
                            })
                        })
                        if (multipleMtcLine && !_.isEmpty(multipleMtcLine)) {
                            delete body['brand'];
                            delete body['family'];
                            _.extend(body, {
                                carContext: multipleMtcLine
                            })
                        }
                    }
                    else if (_.isEmpty(body.family)) {
                        if (vm.mtcLineDetails && !_.isEmpty(vm.mtcLineDetails.carContext)) {
                            _.extend(body, {
                                carContext: vm.mtcLineDetails.carContext
                            })
                        }
                        delete body['brand'];
                    }
                }
            }
            else {
                if (vm.listFamiliesDetails && vm.listFamiliesDetails.listFamilies && !_.isEmpty(vm.listFamiliesDetails.listFamilies)){
                    var newCarcontext = {};
                var family = [];
                var carContextArray = [];
                if (body.family && !_.isEmpty(body.family)) {
                    var filteredFamily = _.filter(vm.listFamiliesDetails.listFamilies, function (item) {
                        return item.criteriaCode === body.family;
                    })
                    if (filteredFamily && !_.isEmpty(filteredFamily)) {
                        _.map(filteredFamily, function (item) {
                            if (item.familyType == "vehicle") {
                                family.push(body.family);
                                _.extend(newCarcontext, {
                                    '007V': family ? family : [],
                                    '336': body.brand ? body.brand : []
                                })
                            }
                            else if (item.familyType == "gearbox") {
                                family.push(body.family);
                                _.extend(newCarcontext, {
                                    '007G': family ? family : [],
                                    '336': body.brand ? body.brand : []
                                })
                            }
                            else if (item.familyType == "engine") {
                                family.push(body.family);
                                _.extend(newCarcontext, {
                                    '007E': family ? family : [],
                                    '336': body.brand ? body.brand : []
                                })
                            }
                            else if (item.familyType == "battery") {
                                family.push(body.family);
                                _.extend(newCarcontext, {
                                    '007B': family ? family : [],
                                    '336': body.brand ? body.brand : []
                                })
                            }
                        })
                        Object.keys(newCarcontext).forEach(function (key) {
                            if (_.isEmpty(newCarcontext[key])) {
                                delete newCarcontext[key]
                            }
                        })
                    }
                    carContextArray.push(newCarcontext)
                }
                else if (_.isEmpty(body.family)) {
                    if (!_.isEmpty(body.brand)) {
                        _.extend(newCarcontext, {
                            '336': body.brand ? body.brand : []
                        })
                    }
                    carContextArray.push(newCarcontext)
                }                
                if (!_.isEmpty(newCarcontext)) {
                    _.extend(body, {
                        carContext: carContextArray
                    })
                    delete body['brand'];
                    delete body['family'];
                }
            }
            }
            if (next_url) {
                _.extend(body, {
                    next_url: next_url
                })
            }
            else{
                body.next_url = "";
            }
            
            if(!body.family || !body.partNumber || !body.genericPart || !body.brand || !body.nodeId || !body.gieNumber || !body.plateNumber || !body.next_url) {
                body = cleanPayload(body);
            }
            var defer = $q.defer();
            DocPrivWsService.getDocPrivPlates(body).then(function (res) {
                     if(res){
                        defer.resolve(res);
                     }else{
                         defer.reject();
                     }
            }).catch(function(err){
                defer.reject(err)
            })

           return defer.promise;
        }

        function cleanPayload(obj) {
            for (var propName in obj) {
                if (propName != "minimalInfoSIE" && !obj[propName]) {
                delete obj[propName];
              }
            }
            return obj
        }

        function getDocPrivParts(plateId,mtcPayloadData){

            var payload = getUserContext();
            updateUserContextProfiles(payload.userContext);
            _.extend(payload, {
                plateId : plateId,
                carContext: mtcPayloadData
            })
            if(_.isEmpty(mtcPayloadData)){
                delete payload['carContext']
            }

            var defer = $q.defer();
            DocPrivWsService.getDocPrivParts(payload).then(function (res) {
                if(res){
                defer.resolve(res);
                }else{
                    defer.reject();
                }
            }).catch(function(err){
                defer.reject(err)
            })

           return defer.promise;

        }

        function processSimplifiedApplicability(applData,applicabilities,totalManufacIds){
            try{
            _.map(applData, function (appl) {
                var fixedAppl = "", variableAppl = "", codifiedAppl = "", obj007VExists = false;
                var manufactuerIdList ="";
                if (!_.isEmpty(appl.codifiedSigns)) {
                    _.map(appl.codifiedSigns, function (code, index) {
                        if (index != 0) {
                            codifiedAppl += ' / ';
                        }

                        if (!_.isEmpty(code.listCrit)) {
                            code.listCrit = _.orderBy(code.listCrit, 'codeCrit');
                            _.map(code.listCrit, function (list, listIndex) {
                                codifiedAppl += code.codeObj + ' — ' + list.labelCrit;
                                codifiedAppl += code.listCrit.length - 1 == listIndex ? "" : ",";
                            });
                        }
                    });
                }

                var sampleAppl = _.groupBy(appl.fixe, 'codeObj');
                var sampleData = [];
                for (var i in arraySortOrder){
                    if(sampleAppl[arraySortOrder[i]])
                        sampleData.push(sampleAppl[arraySortOrder[i]][0]);
                }
                appl.fixe = _.uniq((appl.fixe && !_.isEmpty(appl.fixe)) ? sampleData.concat(appl.fixe) : sampleData);
                if(appl.fixe && !_.isEmpty(appl.fixe)){
                    _.map(appl.fixe, function (fix, index) {
                        if(fix && fix.codeObj == "007V" && !_.isEmpty(fix.listCrit)){
                            obj007VExists = true;
                        }
                        
                        if(obj007VExists && (fix && fix.codeObj != "007E" && fix.codeObj != "007G" && fix.codeObj != "007B")){
                            if (index != 0) {
                                fixedAppl += ' / ';
                            }
                            fix.listCrit = _.orderBy(fix.listCrit,'codeCrit');
                            _.map(fix.listCrit, function (list, listIndex) {
                                fixedAppl += list.codeCrit;
                                fixedAppl += fix.listCrit.length - 1 == listIndex ? "" : ",";
                            });
                        } else if(!obj007VExists) {
                            if (index != 0) {
                                fixedAppl += ' / ';
                            }
                            fix.listCrit = _.orderBy(fix.listCrit,'codeCrit');
                            _.map(fix.listCrit, function (list, listIndex) {
                                fixedAppl += list.codeCrit;
                                fixedAppl += fix.listCrit.length - 1 == listIndex ? "" : ",";
                            });
                            
                        }
                    });
                }
                
                var sampleVarAppl = _.groupBy(appl.variable, 'codeObj');
                var sampleVarData = [];
                for (var i in varApplSortOrder){
                    if(sampleVarAppl[varApplSortOrder[i]])
                        sampleVarData.push(sampleVarAppl[varApplSortOrder[i]][0]);
                }
                appl.variable = sampleVarData;
                _.map(appl.variable, function (variable, index) {
                    if (index != 0) {
                        variableAppl += ' > ';
                        manufactuerIdList += ' > ';
                    }
                         var finalArray = [];
                         var manufactureNumber = [];
                    _.map(variable.listCrit, function (list, listIndex) {
                        var isModDateArray = [];
                          var code = moment(list.codeCrit, "YYYY/MM/DD", true).isValid();  
                          var valueCheck =list.codeCrit.charAt(0);
                          var regex =  /[0-9]/;
                       
                        if (list.codeCrit.substr(0, 3) == "MOD" && !code) {
                            list.modPresent = true;
                            isModDateArray.push(list);
                        } else if (list.codeCrit.substr(0, 3) != "MOD" && code) {
                            list.modPresent = false;
                            list.datePresent = true;
                            isModDateArray.push(list);
                        }else if (regex.test(valueCheck) && list.codeCrit.substr(0, 3) != "MOD" && !code) {
                            list.modPresent = false;
                            list.datePresent = false;
                            isModDateArray.push(list);
                        }
                        else {
                            if (!regex.test(valueCheck) && list.codeCrit.substr(0, 3) != "MOD" && !code) {
                                manufactureNumber.push(list.codeCrit);
                                totalManufacIds.push(list.codeCrit); 
                            }
                        }
                        finalArray = _.concat(finalArray, isModDateArray)

                    });
                    var isModAvailable = $filter("filter")(finalArray, { modPresent:true });
                    if(isModAvailable && !_.isEmpty(isModAvailable)){
                       _.remove(finalArray, { modPresent: false });
                    }
                    var isDateAvailable = $filter("filter")(finalArray, { datePresent:true });
                    if(isDateAvailable && !_.isEmpty(isDateAvailable)){
                       _.remove(finalArray, { datePresent: false });
                    }
                    _.map(finalArray, function (list, index) {
                        if(appl.variable.length == 1 && variable.codeObj.substr(3,2) == "AV"){
                            variableAppl += "...>";
                            manufactuerIdList += "...>";  
                        }
                        variableAppl += (variable.codeObj+'=') +list.codeCrit;
                        manufactuerIdList += (variable.codeObj+'=') +list.codeCrit;

                        if(manufactureNumber && !_.isEmpty(manufactureNumber)){ 
                            manufactuerIdList += ' ('
                            _.map(manufactureNumber, function (list, listIndex) {
                                manufactuerIdList += list;
                                manufactuerIdList += manufactureNumber.length - 1 == listIndex ? "" : ",";
                            })
                            manufactuerIdList += ') '
                        }

                        if( appl.variable.length == 1 && variable.codeObj.substr(3,2) == "AP"){
                            variableAppl += ">..."; 
                            manufactuerIdList += ">..."; 
                        }
                    variableAppl += finalArray.length - 1 == index ? "" : ",";
                    });
                });

                if(_.isEmpty(applicabilities)){
                    applicabilities.push(
                        {
                            fixedApplicability: fixedAppl,
                            variableApplicability: variableAppl,
                            codifiedApplicability: codifiedAppl,
                            display: true,
                            manufactuerId:manufactuerIdList
                        });
                }else{
                    applicabilities.push(
                        {
                            fixedApplicability: fixedAppl,
                            variableApplicability: variableAppl,
                            codifiedApplicability: codifiedAppl,
                            display: false,
                            manufactuerId:manufactuerIdList
                        });
                }
            });
        }catch(error){
            $log.debug(error);
        }
            return applicabilities;
        }
        function callAllPlates(catalogPlates){
            var promises = catalogPlates.map(function(plate){
                return getPlateLines(plate).then(function (response){
                    return response;
                }).catch(function(e){return null})
                })
                , all = $q.all(promises).then(function(data){
                    return data;
                });
            return all;
        }

        function callAllImages(imgList) {
            var promises = [];
            promises = imgList.map(function (img) {
                return callImages(img).then(function(resp){
                    return resp;
                });
            });
            return $q.all(promises).then(function(data){
                return data;
            });
        }
        function callImages(img) {
            var deferred = $q.defer();
            if(img){
                $http.get(img,{
                    withCredentials: true
                }).then(function (response) {
                    deferred.resolve(response);
                }).catch(function (e) {
                    deferred.resolve(null);
                })
            } else{
                deferred.resolve(null);
            }
            return deferred.promise;
        }

        function getPlateLines(docPlate){

            return vm.getDocPrivParts(docPlate.catalogPlateNumber).then(function (response) {
                
                response.references = _.filter(response.references, function(item){
                    return item.brand === DocPrivConstants.centraleBrand || DocPrivConstants.standardExchangeBrand;
                })
                response.references.map(function(item,index,array){
                    var applicabilities = [];
                    if (!_.isEmpty(item.applicability)) {
                        applicabilities = vm.processSimplifiedApplicability(item.applicability,applicabilities);
                        _.assign(item, {applicabilities:applicabilities});
                    } 

                    if(index === 0 || item.index !== array[index-1].index){
                        _.extend(item,{indexDisplay : true});
                    }else{
                        _.extend(item,{indexDisplay : false});
                    }
                    _.extend(item,{fullMtcDisplayed : false});
                    return item;

                })
                vm.partsList = response;
                return vm.partsList;
            }).catch(function(error){
                if (error) {
                    toastr.error(error);
                }
            }).finally(function () {
            });

        }
        function downloadWordGeneric(isMultiple,index,plateSingle){
            var HtmlHead = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body><style>@page WordSection1{size: 841.95pt 595.35pt;mso-page-orientation: landscape;font-size:10.0pt} div.WordSection1 {page: WordSection1;} td {font-size:10.0pt;} </style>"; 
            var EndHtml = "</body></html>";
            if(isMultiple){
                var html = HtmlHead +document.getElementById("docpriv-table-word"+index).innerHTML+EndHtml;
            } else if(plateSingle){
                var html = HtmlHead +document.getElementById("docpriv-table-word1").innerHTML+EndHtml;
            } else {
                var html = HtmlHead +document.getElementById("docpriv-table-word").innerHTML+EndHtml;
            }
            var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
            return url;
        }
        function downloadPdfData(plateDetails, partDetails,index,isMultiplePrint,picturePdfList) {
            return formatDataToPrint(plateDetails, partDetails,index,isMultiplePrint,picturePdfList);
        }
        function formatDataToPrint(plateDetails, partDetails, index,isMultiplePrint,picturePdfList) {

            var deferred = $q.defer();
            var serializedSVG = null;
            var cartToPrint = {
                translatedLabels: {
                    indexLabel: $translate.instant("BTLIST_HEADER_INDEX"),
                    genericParts: $translate.instant("DOCPRIV_GP"),
                    referenceLabel: $translate.instant("COMMON_REFERENCE"),
                    statusLabel: $translate.instant("ACTIS_GENERAL_STATUS"),
                    additionalLabel: $translate.instant("ADDITIONAL_PARTS"),
                    superSessionLabel: $translate.instant("PRODUCT_REPLACEMENT"),
                    mtcLabel: $translate.instant("DOCPRIV_MTC"),
                    codifiedLabel: $translate.instant("CODIFIED_SIGN_LABEL")
                }
            };
            if (!isMultiplePrint && document.querySelector("#divSvgContent svg image")) {
                var SVGDomElement = document.querySelector('svg#svgPanImage'); 
                var SVGDomElement1 = SVGDomElement.cloneNode(true); 
                var selectedSvgRef = SVGDomElement1.querySelectorAll('svg'); 
                if (selectedSvgRef && selectedSvgRef.length > 0) {
                    angular.forEach(selectedSvgRef, function (svgTag) {
                        svgTag.remove();
                    })
                }
                SVGDomElement1.setAttribute("viewBox","0 0 680 500");
                //serializedSVG = new XMLSerializer().serializeToString(SVGDomElement1);
                serializedSVG = SVGDomElement1;
            } else if (!isMultiplePrint && document.querySelector("#divSvgContent1 svg image")) {
                var SVGDomElement = document.querySelector('svg#svgPanImage'); 
                var SVGDomElement1 = SVGDomElement.cloneNode(true); 
                var selectedSvgRef = SVGDomElement1.querySelectorAll('svg'); 
                if (selectedSvgRef && selectedSvgRef.length > 0) {
                    angular.forEach(selectedSvgRef, function (svgTag) {
                        svgTag.remove();
                    })
                }
                //serializedSVG = new XMLSerializer().serializeToString(SVGDomElement1);
                serializedSVG = SVGDomElement1;
            }
            var dataArray = [];
            var finalArr = [];
            var firstTable = [
                {
                    column1: {
                        data: plateDetails.plateNo,
                        alignment: "left"
                    },
                    column2: {
                        data: $translate.instant("RLINKCAR_HU_VERSION") + " " + plateDetails.sieVersion,
                        alignment: "center"
                    },
                    column3: {
                        data: formatDate(plateDetails.publicationDate),
                        alignment: "right"
                    }
                }
            ];
            var firstObj = {
                type: "table", values: getTableData(firstTable, false), styles: "secondTableHeader",
                layout: "secondTableLayout", widths: [240, 240, 240]
            };
            dataArray.push(firstObj);
            var imageObj = {};
            if (isMultiplePrint && !_.isEmpty(picturePdfList) && picturePdfList[index]) {
                imageObj = {
                    type: "image", values: picturePdfList[index], isOuterHtml: false
                }                
            } else if (!isMultiplePrint && serializedSVG) {
                imageObj = {
                    type: "image", values: serializedSVG, isOuterHtml: true
                }
            } else {
                imageObj = { type: "columns", values: { 0: [$translate.instant("PLATE_IMAGE_MISSING")] }, styles: "tableTextStyle" };
            }
            dataArray.push(imageObj);
            var thirdTable = [
                {
                    column1: {
                        data: getMtcDetails(plateDetails)
                    }
                }
            ]

            var thirdObj = {
                type: "table", values: getTableData(thirdTable, false), styles: "tableStyle",
                layout: "thirdTableLayout", widths: [740]
            };

            dataArray.push(thirdObj);

            var fourthTable = partDetails;

            var filteredData = fourthTable.map(function (item) {
                var tableData = [];

                tableData[cartToPrint.translatedLabels.indexLabel] =
                {
                    data: item.indexDisplay ? item.index : '',
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.genericParts] =
                {
                    data: item.genericPart,
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.referenceLabel] =
                {
                    data: $filter('filterFormatRef')(item.reference),
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.statusLabel] =
                {
                    data: item.brand,
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.codifiedLabel] =
                {
                    data: (item.codifiedSigns && item.codifiedSigns.length > 0) ? getListValues(item.codifiedSigns, "value", "textAssociated", false, null) : null,
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.additionalLabel] =
                {
                    data: (item.additional && item.additional.length > 0) ? getListValues($filter('filterFormatRef')(item.additional), 'partNumber', 'ratio', false, null) : null,
                    alignment: "left"
                };
                tableData[cartToPrint.translatedLabels.superSessionLabel] =
                {
                    data: (item.supersedingList && item.supersedingList.length > 0) ? getSupersedingList(item) : null,
                    alignment: "left"
                };

                tableData[cartToPrint.translatedLabels.mtcLabel] =
                {
                    data: (item.applicabilities && item.applicabilities.length > 0) ? getListValues(item.applicabilities, null, null, true, null) : null,
                    alignment: "left"
                };
                return tableData;
            })

            var fourthObj = {};

            fourthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: [20, 60, 70, 60, 60, 70, 70, 270]
            };

            dataArray.push(fourthObj);

            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,false,false,false,true);
            if (finalArr.length == 4) {
                finalArr[3].pageBreak = 'before';
            } else {
                finalArr[2].pageBreak = 'before';
            }
            var docDefinition = {
                info: {
                    title: plateDetails.plateNo,
                },
                content: [
                    finalArr
                ],
                pageOrientation: 'landscape',
                styles: {
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 10
                    },
                    tableStyle: {
                        margin: [0, 5, 0, 0]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 9,
                        bold: true
                    },
                    secondTableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 9,
                        bold: true
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }
        function getMtcDetails(plate) {
            var mtcData = '';
            plate.applicability.forEach(function (item) {
                mtcData += item.fixedApplicability + (item.variableApplicability !== '' ? ' | ' :
                '') + item.variableApplicability + (item.codifiedApplicability !== '' ? ' | ' :
                '') + item.codifiedApplicability + '\n'
            })
            return mtcData;
        }
        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }
        function getListValues(array, cat1, cat2, applVal, ref) {
            var listData = '';
            array.forEach(function (val) {
                if (cat1 || cat2) {
                    listData += $filter('filterFormatRef')(val[cat1]) + ((val[cat1] && val[cat1] != '' && val[cat2] && val[cat2] != '') ? '-' : '') + (val[cat2] ? $filter('filterFormatRef')(val[cat2]) : '') + '\n ';
                } else if (applVal) {
                    listData += val.fixedApplicability + ' ' + val.variableApplicability +' '+val.codifiedApplicability+ '\n';
                } else {
                    listData += (val != ref ? val : '') + '\n ';
                }
            })
            return listData;
        }
        function formatDate(date) {
            return date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3");
        }
        function groupTargets(parts) {
            var finalList = [];
            var prevTarget;
            if(parts.supersedingList){
                prevTarget = parts.reference;
                for(var i=0; i<parts.supersedingList.length;i++){
                    _.map(parts.supersedingList,function(item){
                        if( item.src == prevTarget){
                            finalList.push(item);
                            prevTarget = item.target;
                        }
                    })
                }
            }
            var supersedingList = _.groupBy((finalList && finalList.length) ? finalList : parts.supersedingList, 'src');
            // if (Object.keys(supersedingList).length !== 1) {
            //     delete supersedingList[parts.reference];
            // }
            return supersedingList;
        }
        function getSupersedingList(parts) {
            var listData = '';  
            var dispList = groupTargets(parts);
            for (var s in dispList) {
                var index = 0;
                dispList[s].forEach(function (l) {
                    // if (dispList[s].length === 1 && l.src !== parts.reference) {
                    //     listData += l.src;
                    // }
                    // else
                     if (dispList[s].length === 1) {
                        listData += $filter('filterFormatRef')(l.target) + '\n ';
                    }
                    else {
                        listData += (index == 0) ? $filter('filterFormatRef')(l.target) : '+' + $filter('filterFormatRef')(l.target);
                        index++;
                    }
                })

            };
            return listData;
        }
        function setPlateId(plateId){
            selectedPlateId = plateId;
            isDocpriv = true;
        }
        function getPlateId(){
            return {
                "selectedPlateId": selectedPlateId,
                "isDocpriv": isDocpriv
            }
        }
        function clearPlateId(){
            selectedPlateId = '';
            isDocpriv = false;
        }

        function updateUserContextProfiles(userContext) {
            var user = CacheService.getObject(RoutesConstants.profil);
            if (userContext && userContext.userProfiles && user){
                if(user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)){
                    userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());
                }
                else if(user.roles && user.roles.includes(CarSearchConstants.ppxIndependentUser) && user.accountType === 'Partner'){
                    userContext.userProfiles.push(CarSearchConstants.ppxIndependentUser.toLowerCase());
                }
            }
        }
    }

    })();

(function () {
    "use strict";

    angular
        .module("phenix")
        .component('partDetailsComp', {
            bindings: {
                fixedData:'<'
            },
        controller: PartDetailsController,
        controllerAs: 'vm',
        templateUrl: 'app/components/docpriv/partDetails/partDetails.template.html'
    })
    .controller('PartDetailsController', PartDetailsController)
        .filter("highlight", function($sce) {
            return function(text, phrase) {
                if (phrase) {
                    text = text.replace(
                        new RegExp("(" + phrase + ")", "gi"),
                        '<span class="highlighted">$1</span>'
                    );
                }
                console.log("Filtered text: ", text);
                return $sce.trustAsHtml(text);
            };
        });
        
    /** @ngInject */
    function PartDetailsController($mdDialog,ListPieceConstants,DocPrivMetierService,UtilsMetierService) {
        var vm = this;
        vm.close = close;
        vm.isStandardExchange = isStandardExchange;
        vm.isTractionBattery = isTractionBattery;
        vm.keyLength = keyLength;
        vm.copyToClipboard = copyToClipboard;
        vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();

        if (vm.partDetails && vm.partDetails.additional) {
            vm.partDetails.additional.map(function (item) {
                var applicabilities = [];
                var totalManufacIds = [];
                if (!_.isEmpty(item.applicability)) {
                    applicabilities = DocPrivMetierService.processSimplifiedApplicability(item.applicability, applicabilities,totalManufacIds);
                    if (applicabilities && !_.isEmpty(applicabilities)) {
                        _.assign(item, { applicabilities: applicabilities });
                    }
                } else {
                    _.assign(item, { applicabilities: "" });
                }
            })
            var groupedArray = [];
            _.map(vm.partDetails.additional, function (item) {
                var group_to_values = item.applicabilities.reduce(function (obj, items) {
                    var newItem = [];
                    newItem.push(items);
                    var applicabilityString = JSON.stringify(newItem);
                    obj[applicabilityString] = obj[applicabilityString] || [];
                    obj[applicabilityString].push(item);
                    return obj;
                }, {});
                groupedArray = _.concat(groupedArray, group_to_values)
            })
            vm.firstgroup = [];
            _.map(groupedArray, function (item) {
                vm.allPartgrouping = Object.keys(item).map(function (key) {
                    return { applicability: JSON.parse(key), partArray: item[key] };
                });
                vm.firstgroup = _.concat(vm.firstgroup, vm.allPartgrouping)
            })

            var finalGroup = vm.firstgroup.reduce(function (obj, item) {
                var applicabilityString = JSON.stringify(item.applicability);
                obj[applicabilityString] = obj[applicabilityString] || [];
                obj[applicabilityString] = _.concat(obj[applicabilityString], item.partArray)
                return obj;
            }, {});
            vm.groups = Object.keys(finalGroup).map(function (key) {
                return { applicability: JSON.parse(key), partArray: finalGroup[key] };
            });

            var finalPartGroup = vm.groups.reduce(function (obj, item) {
                var applicabilityString = JSON.stringify(item.partArray);
                obj[applicabilityString] = obj[applicabilityString] || [];
                obj[applicabilityString] = _.concat(obj[applicabilityString], item.applicability)
                return obj;
            }, {});
            vm.partsGroup = Object.keys(finalPartGroup).map(function (key) {
                return { applicability: finalPartGroup[key], partArray: JSON.parse(key) };
            });


            if (vm.partsGroup && vm.partsGroup.length === 1) {
                vm.partsGroup.filter(function (additionalAppl) {
                    if (containsNewMethod(JSON.parse(angular.toJson(vm.partDetails.applicabilities)), additionalAppl.applicability))
                        _.remove(additionalAppl.applicability);
                })
            }
        }
        vm.applCriteria = [];
        vm.partDetails.applicability.map(function (item) {
            item.fixe.map(function (fixAppl) {
                if(fixAppl && fixAppl.codeObj){
                    fixAppl.listCrit.map(function (listAppl) {
                        if(vm.newApplicability){
                            if(fixAppl.codeObj === "755"){
                                vm.applCriteria.push(listAppl.codeCrit + " : " + listAppl.labelCrit);
                            }
                        }
                        else if(vm.showApplicabilityData){
                            var mtcCrit = fixAppl.codeObj + " : " + fixAppl.labelObj + "\n" + listAppl.codeCrit + " : " + listAppl.labelCrit;
                            vm.applCriteria.push(mtcCrit);
                        }
                        vm.applCriteria = _.uniq(vm.applCriteria);
                    });
                }
            });
        });

        function containsNewMethod(arr1, arr2) {
            var filterLen = arr1.length;
            var resultLen = arr2.length;
            if (filterLen != resultLen) {
                return false;
            } else {
                var uniqueResultOne = arr2.filter(function (obj) {
                    return arr1.some(function (obj2) {
                        var firstArraySplit = obj.fixedApplicability.split(' / ');
                        var secondArraySplit = obj2.fixedApplicability.split(' / ');
                        var comparedArrayOne = firstArraySplit.every(function(el, i){
                            return secondArraySplit.includes(el);
                        })
                        var comparedArrayTwo = secondArraySplit.every(function(el, i){
                            return firstArraySplit.includes(el);
                        })
                        if(comparedArrayOne && comparedArrayTwo){
                            var finalComparedArray = true;
                        }
                        else{
                            var finalComparedArray = false;
                        }

                        return finalComparedArray &&
                            obj.variableApplicability == obj2.variableApplicability;
                    });
                })
                if (uniqueResultOne && !_.isEmpty(uniqueResultOne)) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        function close() {
            $mdDialog.hide();
        }

        function isStandardExchange(types){
            return _.includes(types,ListPieceConstants.types.standardExchange);
        }

        function isTractionBattery(familyCode){
            return familyCode === ListPieceConstants.tractionBatteryFamilyCode;
        }

        function keyLength(data){
            return Object.keys(data).length;
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }
    }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('docPrivPlates', {
            bindings: {
                requestBody: '=',
                isPartsList: '=',
                isPlatesList: '=',
                selectedDocPlate: '=',
                listOfPlate: '=',
                showFullDocprivResults: '=',
                deletedPlates: '=',
                masterPlates: '=',
                showDeletedPlate: '='
            },
            controller: DocPrivPlatesController,
            controllerAs: 'vm',
            templateUrl: 'app/components/docpriv/docPrivPlates/docPrivPlates.template.html'
        })

    function DocPrivPlatesController(
        DocPrivMetierService, blockUI, toastr, $translate, $scope, $mdDialog, $http, FileSaver, $q, $timeout ,$filter,printPdfModalService,$log,DocumentsMetierService,$rootScope
    ) {


        var vm = this;

        // VARIABLES
        vm.masterPlates = {};
        vm.listOfPlate = [];
        vm.showFullDocprivResults = [];
        vm.deletedPlates = [];
        vm.showDeletedPlate = false;
        vm.partsList = [];
        vm.fixedData = "";
        vm.variableData = "";
        vm.codifiedData = "";
        vm.plateTotalManufactureIds = [];
        vm.selected = [];
        vm.allPartsResponse = [];
        //FUNCTIONS
        vm.formatDate = formatDate;
        vm.varAppBeforeGoToDocprivPage = varAppBeforeGoToDocprivPage;
        vm.scrollTop = scrollTop;
        vm.onValidate = onValidate;
        vm.onChange = onChange;
        vm.displayFullMtc = displayFullMtc;
        vm.printPlates = printPlates;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.displayManufactureId = displayManufactureId;
        vm.displayManufacture = false;

        this.$onInit = function () {


            $scope.$watch('vm.requestBody', function () {
                vm.selected = [];
                if (!_.isEmpty(vm.selectedDocPlate)) {
                    if (!_.isEmpty(vm.masterPlates.next_url)) {
                        toastr.info($translate.instant("DOCPRIV_LOAD_MORE_RESULTS"));
                    }
                    vm.selectedDocPlate = {};
                    vm.numberOfPlate = vm.listOfPlate.length;
                }

                else {
                    onValidate();
                }

            });
        }


        function formatDate(date) {
            return date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3");
        }
        function displayManufactureId(){
            vm.displayManufacture =  !vm.displayManufacture;
            if(vm.displayManufacture){
                vm.isManufactureId = true;
            }else{
                vm.isManufactureId = false;
            }
        }


        function checkVignetteAndPlancheImage(ref) {
            if ((ref && ref.thumbnailUrl == "") || angular.isUndefined(ref.thumbnailUrl))
                ref.thumbnailUrl = 'assets/images/no_image_vignette.png';
            if (
                (ref && ref.pictureUrl == "") ||
                angular.isUndefined(ref.pictureUrl)
            )
                ref.pictureUrl = 'assets/svg/no_image.svg';
        }

        function RefinePlates(list) {
            list.plates.forEach(function (plate) {
                checkVignetteAndPlancheImage(plate);
                var currentRefCatalogPlanche = plate.catalogPlateNumber.split('_');
                _.assign(plate, { plateNo: currentRefCatalogPlanche[0] + ' / ' + currentRefCatalogPlanche[1] });
            });

            list.plates.forEach(function (plate) {
                if (plate.status != 'DELETED') {
                    vm.listOfPlate.push(plate);
                }

                else {
                    vm.deletedPlates.push(plate);
                }
            })
            if (vm.listOfPlate.length === 0 && vm.deletedPlates.length !== 0) {
                vm.showDeletedPlate = true;
                return vm.deletedPlates;
            }

            return vm.listOfPlate;
        }

        function scrollTop() {
            if ($('#docPrivPlates').offset()) {
                $('html, body').animate(
                    { scrollTop: $('#docPrivPlates').offset().top },
                    100
                );
            }
        }

        function platesApplicability(catalogsList) {
            if (!catalogsList.length) {
                return;
            }
            vm.plateTotalManufactureIds = [];
            vm.numberOfPlate = catalogsList.length;
            _.map(catalogsList, function (item) {
                if (!_.isEmpty(item.applicability)) {
                    var applicabilities = [];
                    item.newApplicability ? item.newApplicability : _.assign(item, { newApplicability: item.applicability });
                    applicabilities = DocPrivMetierService.processSimplifiedApplicability(item.newApplicability, applicabilities,vm.plateTotalManufactureIds);
                    _.assign(item, { applicability: applicabilities });
                } else {
                    _.assign(item, { applicability: "" });
                }
                _.extend(item, { fullMtcDisplayed: false});
                if(!vm.showDeletedPlate && _.isEmpty(vm.selected))
                    _.extend(item, { printSelected: false });
            });
            if (vm.showDeletedPlate) {
                vm.showFullDocprivResults = vm.listOfPlate.concat(vm.deletedPlates);
            }

            else {
                vm.showFullDocprivResults = vm.listOfPlate;
            }

            vm.showFullDocprivResults = _.sortBy(_.uniqBy(vm.showFullDocprivResults, 'plateNo'), 'plateNo');
        }

        function displayFullMtc(docPlate) {
            docPlate.fullMtcDisplayed = !docPlate.fullMtcDisplayed;
            if (!docPlate.fullMtcDisplayed) {
                return docPlate.applicability.map(function (item) {
                    if (docPlate.applicability.indexOf(item) !== 0) {
                        item.display = false;
                        return item;
                    }

                })
            } else {
                return docPlate.applicability.map(function (item) {
                    item.display = true;
                    return item;

                })

            }

        }

        function onValidate() {
            blockUI.start();

            DocPrivMetierService.getDocPrivPlates(vm.requestBody, vm.masterPlates.next_url).then(function (platesList) {
                vm.masterPlates = platesList;
                $rootScope.$broadcast('filterFormat',vm.requestBody);

                if (!_.isEmpty(platesList && platesList.plates)) {

                    platesList = RefinePlates(platesList);
                    platesApplicability(platesList);

                    if (platesList.plates && platesList.plates.length == 1) {
                        vm.listOfPlate = platesList.plates;
                        varAppBeforeGoToDocprivPage(platesList.plates[0]);
                    }

                    if (!_.isEmpty(vm.masterPlates.next_url)) {
                        toastr.info($translate.instant("DOCPRIV_LOAD_MORE_RESULTS"));
                    }
                }

                else {
                    toastr.info($translate.instant('CARSEARCH_NAME_NOT_RESULT_FOUND'));
                }
            })
                .catch(function (error) {
                    if (error) {
                        toastr.error(error);
                    }
                })
                .finally(function () {
                    blockUI.stop();
                });
        }

        function varAppBeforeGoToDocprivPage(selectedItem) {
            vm.selectedDocPlate = selectedItem;
            vm.isPartsList = true;
            vm.isPlatesList = false;
        }

        function onChange(cbState) {
            vm.showDeletedPlate = cbState;
            (vm.deletedPlates.length !== 0) ? platesApplicability(vm.deletedPlates) : platesApplicability(vm.showFullDocprivResults);
        };

        function printPlates() {
            var parent = angular.element(document.body);
            vm.selected = _.uniq(vm.selected);
            if (!_.isEmpty(vm.selected)) {
                $mdDialog.show({
                    parent: parent,
                    templateUrl: 'app/components/docpriv/docPrivParts/docprivPrint.template.html',
                    controller: 'docprivPrintController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        isMultiplePlate: true
                    }
                }).then(function (resp) {
                    if(resp){
                        var emptyRespList = [];
                        vm.allPartsResponse = [];
                        blockUI.start();
                        DocPrivMetierService.callAllPlates(vm.selected).then(function (response) {
                            if (_.filter(response, function (item) { return item }).length > 0) {
                                response.forEach(function (item, index) {
                                    if (!_.isEmpty(item)) {
                                        _.assign(item, { pictureUrl: vm.selected[index].pictureUrl });
                                    }
                                    vm.allPartsResponse.push(item);
                                    if (!item || _.isEmpty(item.references)) {
                                        emptyRespList.push(vm.selected[index].plateNo);
                                    }
                                })
                                if (!_.isEmpty(emptyRespList)) {
                                    toastr.info($translate.instant("PLATE_EXPORT_FAIL") + " " + emptyRespList.join(' , '));
                                }
                                
                                initSVG(resp).then(function(){
                                }).catch(function(){
                                    blockUI.stop();
                                })
                            } else {
                                blockUI.stop();
                                toastr.info($translate.instant("PLATE_EXPORT_FAIL"));
                            }
                        })
                    }
                })
            }
            
        }
        function initSVG(printType) {
            vm.picturePdfList = [];
            var defer = $q.defer();
            var pictureList = [];
            pictureList = _.map(vm.allPartsResponse, "pictureUrl");            
            DocPrivMetierService.callAllImages(pictureList).then(function (resp) {
                if (_.filter(resp, function (item) { return item }).length > 0) {
                    var promiseArray = _.map(resp, function (response,index) {
                        if (response && response.data) {
                            var svg = response.data;
                            var element = document.createElement("divSvgContent1");
                            element.innerHTML = svg;
                            var svgElement = element ? element.querySelector("svg") : null;
                            var serializedSVG = new XMLSerializer().serializeToString(svgElement);
                            var canvas = document.createElement('canvas');
                            var context = canvas.getContext('2d');
                            canvas.width = 800;
                            canvas.height = 600;
                            var image = new Image();
                            image.src = "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(serializedSVG)));
                            image.onload = function () {
                                return $q.resolve().then(function () {
                                    context.clearRect(0, 0, 800, 600);
                                    context.drawImage(image, 0, 0, 800, 600);
                                    var pngData = canvas.toDataURL('image/png');
                                    _.assign(vm.allPartsResponse[index],{pictureWord : pngData});
                                    var serializedSVG1 = new XMLSerializer().serializeToString(svgElement);
                                    _.assign(vm.allPartsResponse[index],{picturePdf : serializedSVG1});
                                    return;
                                })
                            }

                        } else {
                            _.assign(vm.allPartsResponse[index],{pictureWord : null});
                            _.assign(vm.allPartsResponse[index],{picturePdf : null});
                        }
                    })
                    return $q.all(promiseArray).then(function () {
                        $timeout(function () {
                            if(printType == 'WORD'){
                                downloadWordDoc();
                            } else{
                                vm.picturePdfList = _.map(vm.allPartsResponse,"picturePdf");
                                downloadPdf();
                            }
                            defer.resolve();
                        }, (resp.length*150))
                    })
                } else {
                    vm.picturePdfList.push(null);
                    defer.resolve();
                }

            }).catch(function (error) {
                vm.picturePdfList.push(null);
                defer.reject();
                if (error)
                    toastr.error(error, 'Error');
            });
            return defer.promise;
        }

        function downloadWordDoc(docplate) {
            vm.selected = _.uniq(vm.selected);
            if (!_.isEmpty(vm.selected)) {
                var zip = new window.JSZip();
                var examples = zip.folder("Plates" + (vm.requestBody ? "-" + vm.requestBody.family : ""));
                if (_.filter(vm.allPartsResponse, function (item) { return item }).length > 0) {
                    var promiseArray = _.map(vm.allPartsResponse, function (plate, index) {
                        if (plate && !_.isEmpty(plate.references)) {
                            return $q.resolve().then(function () {
                                var url = DocPrivMetierService.downloadWordGeneric(true, index);
                                var filename = plate.id + '.doc';
                                return fetch(url).then(function (resp) {
                                    var blob = resp.blob();
                                    examples.file(filename, blob, { binary: true });
                                    return;
                                })
                            })
                        }
                    })
                    $q.all(promiseArray).then(function () {
                        $timeout(function () {
                            examples.generateAsync({ type: "blob", compression: "DEFLATE" }).then(function (content) {
                                FileSaver.saveAs(content, "Plates" + (vm.requestBody ? "-" + vm.requestBody.family : "") + ".zip");
                            });
                            vm.selected = [];
                            vm.allPartsResponse = [];
                            blockUI.stop();
                        }, 100);
                    });
                } else {
                    vm.selected = [];
                    vm.allPartsResponse = [];
                    blockUI.stop();
                }
                _.map(vm.showFullDocprivResults, function (item) {
                    item.printSelected = false;
                })
            }
        }

        function toggle(item) {
            var idx = vm.selected.indexOf(item);
            if (idx > -1) {
                vm.selected.splice(idx, 1);
            }
            else {
                vm.selected.push(item);
            }
        }
        function exists(item) {
            return vm.selected.indexOf(item) > -1;
        };
        function isIndeterminate() {
            return (vm.selected.length !== 0 &&
                vm.selected.length !== vm.showFullDocprivResults.length);
        }

        function isChecked() {
            return vm.selected.length === vm.showFullDocprivResults.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.showFullDocprivResults.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.showFullDocprivResults.slice(0);
            }
        }
        function downloadPdf(docplate) {
            pdfMake.tableLayouts = {
                otherTableLayout: {
                    hLineWidth: function () {
                        return 1;
                    },
                    vLineWidth: function () {
                        return 1;
                    }
                }, secondTableLayout: {
                    hLineWidth: function () {
                        return 0;
                    },
                    vLineWidth: function () {
                        return 0;
                    }
                },
                thirdTableLayout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                    }
                },
            };
            vm.filesList = [];
            var zip = new window.JSZip();
            var examples = zip.folder("Plates" + (vm.requestBody ? "-" + vm.requestBody.family : ""));
            if (_.filter(vm.allPartsResponse, function (item) { return item }).length > 0) {
                var promiseArray = _.map(vm.allPartsResponse, function (item, index) {
                    if (item && !_.isEmpty(item.references)) {
                        return DocPrivMetierService.downloadPdfData(vm.selected[index], item.references, index,true,vm.picturePdfList).then(function (response) {
                            var pdfDocGenerator = pdfMake.createPdf(response.data);
                            return pdfDocGenerator.getBlob(function (blob) {
                                examples.file(vm.selected[index].catalogPlateNumber + ".pdf", blob, { binary: true });
                                return;
                            });
                        });
                    }
                })                    
                $q.all(promiseArray).then(function () {
                    $timeout(function () {
                        examples.generateAsync({ type: "blob", compression: "DEFLATE" }).then(function (content) {
                            FileSaver.saveAs(content, "Plates" + (vm.requestBody ? "-" + vm.requestBody.family : "") + ".zip");
                        });
                        vm.selected = [];
                        vm.allPartsResponse = [];                                                       
                    }, 100);
                }).finally(function(){
                    blockUI.stop();
                });
            } else {
                vm.selected = [];
                vm.allPartsResponse = [];
                blockUI.stop();
            }
            _.map(vm.showFullDocprivResults, function (item) {
                item.printSelected = false;
            })
        } 
    }
    
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('docprivWord', docprivWord)
        .controller('docprivWordController', docprivWordController);

    /** @ngInject */
    function docprivWord() {

        var directive = {
            templateUrl: 'app/components/docpriv/docPrivParts/docprivPrintWord.template.html',
            restrict: 'E',
            controller: 'docprivWordController',
            controllerAs: 'vm',
            scope: {
                currentIndexPlate: '=',
                docPrivCatalogList: '=',
                wordDocImage: '=',
                selectedApplicability: '=',
                partsList: '=',
                fixedData: '=',
                variableData: '=',
                isMultiple: '=',
                wordPicList: '=',
                codifiedData: '='
            },
            bindToController: true
        };
        return directive;
    }
    function docprivWordController(DocPrivMetierService) {

        var vm = this;
        vm.formatDate = formatDate;
        vm.displayFullMtc = displayFullMtc;
        vm.groupTargets = groupTargets;
        function formatDate(date) {
            return date ? date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3") : '';
        }
        function displayFullMtc(parts, displayAllMtc) {
            parts.fullMtcDisplayed = _.isUndefined(displayAllMtc) ? !parts.fullMtcDisplayed : displayAllMtc;
            if (!parts.fullMtcDisplayed) {
                return parts.applicabilities.map(function (item) {
                    if (parts.applicabilities.indexOf(item) !== 0) {
                        item.display = false;
                        return item;
                    }
                })
            } else {
                return parts.applicabilities.map(function (item) {
                    item.display = true;
                    return item;
                })
            }
        }
        function groupTargets(parts) {
            return DocPrivMetierService.groupTargets(parts);
        }
    }
})();

(function () {
    angular.module('phenix').controller('docprivPrintController', docprivPrintController);

    function docprivPrintController($mdDialog) {
        
        var vm = this;
        vm.onCancel = onCancel;
        vm.selectPrintMode = selectPrintMode;

        function selectPrintMode(val){
            $mdDialog.hide(val);
        }

        function onCancel() {
            $mdDialog.hide();
        }
    }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */(function () {

    angular
        .module("phenix")
        .filter('applicabilityFilter', function () {
            return function (list,fixedData,variableData,codifiedData) {
                var filteredList;
                if(list && !_.isEmpty(list)){

                    if((fixedData && !_.isEmpty(fixedData)) || (variableData && !_.isEmpty(variableData)) || (codifiedData && !_.isEmpty(codifiedData))){

                        filteredList = list.filter(function(item){

                            var selected = false;

                            for(var i =0; i< item.applicabilities.length;i++){

                                var obj = item.applicabilities[i];

                                if(!_.isEmpty(fixedData) && !_.isEmpty(variableData) && !_.isEmpty(codifiedData)){
                                    selected = obj.fixedApplicability.split(" ").join("").toLowerCase().includes(fixedData.split(" ").join("").toLowerCase())
                                    && obj.variableApplicability.split(" ").join("").toLowerCase().includes(variableData.split(" ").join("").toLowerCase())
                                    && obj.codifiedApplicability.split(" ").join("").toLowerCase().includes(codifiedData.split(" ").join("").toLowerCase());
                                }else if(!_.isEmpty(variableData)){
                                    selected = obj.variableApplicability.split(" ").join("").toLowerCase().includes(variableData.split(" ").join("").toLowerCase());
                                }else if(!_.isEmpty(codifiedData)){
                                    selected = obj.codifiedApplicability.split(" ").join("").toLowerCase().includes(codifiedData.split(" ").join("").toLowerCase());
                                }else if(!_.isEmpty(fixedData)){
                                    selected = obj.fixedApplicability.split(" ").join("").toLowerCase().includes(fixedData.split(" ").join("").toLowerCase());
                                }

                                if(selected){
                                    break;
                                }

                            }

                            return selected;

                        })
                    }else{

                        filteredList = list;
                    }
                }

                if(filteredList && !_.isEmpty(filteredList)){

                    filteredList.map(function(item,index,array){

                        if(index === 0 || item.index !== array[index-1].index){
                            _.assign(item,{indexDisplay : true})
                        }else{
                            _.assign(item,{indexDisplay : false})
                        }
                    });
                }

                return filteredList;

            };
        })
        .filter('highlight', function($sce) {
            return function(text, phrase) {
            if (phrase) {
                text = text.replace(new RegExp('('+phrase+')', 'gi'),
            '<span class="highlighted">$1</span>');
            }
            return $sce.trustAsHtml(text);
            };
        })
        .component('docPrivParts', {
            bindings: {
                isPartsList: '=',
                isPlatesList: '=',
                selectedDocPlate: '=',
                listOfPlate: '=',
                setPlateDetails: '<',
                partsList: '='
            },
            controller: DocPrivPartsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/docpriv/docPrivParts/docPrivParts.template.html'
        })
        .controller('DocPrivPartsController',DocPrivPartsController);

    /* @ngInject */
    function DocPrivPartsController(
        $window,
        CommentsService,
        blockUI,
        $rootScope,FileSaver,
        MainMetierService,DocumentsMetierService,
        toastr,DocPrivMetierService,$http,$compile,$scope,DocPrivConstants,$timeout,
        EventConstants,$state,ListPieceConstants,$mdDialog,RoutingService,RoutesConstants,printPdfModalService,$translate,$q,$filter,$log,CacheService,CarSearchMetierService,configConstantes,UtilsMetierService,CacheConstants,DocumentsWsService, ProfilMetierService
    ){
        var vm = this;

        // VARIABLES
        vm.displayPlateCommentsPopup = false;
        vm.getplateComments = null;
        vm.isCommentsEnabledbyProfile = false;
        vm.partsList = [];
        vm.fixedData = "";
        vm.variableData = "";
        vm.codifiedData = "";
        vm.displayAllMtc = false;
        vm.displayManufacture = false;
        vm.filteredList = [];
        vm.totalManufactureIds = [];
        vm.displayNewComments = false;
        // FUNCTIONS
        vm.onVignetteClick = onVignetteClick;
        vm.isBorderVignette = isBorderVignette;
        vm.isLineVignette = isLineVignette;
        vm.fullOrReducedScreen = fullOrReducedScreen;
        vm.openFullscreen = openFullscreen;
        vm.exitFullscreen = exitFullscreen;
        vm.scrollVignette = scrollVignette;
        vm.backToPrevious = backToPrevious;
        vm.formatDate = formatDate;
        vm.openComments = openComments;
	    vm.displayPlateComments = displayPlateComments;
        vm.displayFullMtc = displayFullMtc;
        vm.displayPartsMtc = displayPartsMtc;
        vm.initSVG = initSVG;
        vm.gotoSvg = gotoSvg;
        vm.isStandardExchange = isStandardExchange;
        vm.isTractionBattery = isTractionBattery;
        vm.displayDetails = displayDetails;
        vm.displayApplicabilityDetails = displayApplicabilityDetails;
        vm.displayBorder = displayBorder;
        vm.validateFixedCriteria = validateFixedCriteria;
        vm.validateVariableCriteria = validateVariableCriteria;
        vm.validateResidualValue = validateResidualValue;
        vm.toDate = toDate;
        vm.extractIndex = extractIndex;
        vm.parseFixedCriteria = parseFixedCriteria;
        vm.groupTargets = groupTargets;
        vm.goToProduct = goToProduct;
        vm.zoomIn = zoomIn;
        vm.zoomOut = zoomOut;
        vm.resetZoom = resetZoom;
        vm.applySvgPanZoom = applySvgPanZoom;
        vm.printPlateDetails = printPlateDetails;
        vm.validateVin = validateVin;
        vm.copyToClipboard = copyToClipboard;
        vm.switchPRFormat = switchPRFormat;
        vm.resize = _.debounce(function () {
            vm.svgPanZoom.resize();
            vm.svgPanZoom.resetZoom();
            vm.svgPanZoom.center();
        }, 0);
        vm.selectedAppl = "";
        var textIndexDivClass = 'textIndex-div';
        vm.user = CacheService.getObject(RoutesConstants.profil);
        vm.displayManufactureId = displayManufactureId;
        vm.isRemanrenative = UtilsMetierService.isOktaAuthentication();
        var userProfil = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(userProfil.roles);

        this.$onInit = function () {

            vm.isDocprivProfile = MainMetierService.isDocprivProfile();
            vm.isPRFormat = vm.user.isPRFormat;            
            vm.docPrivCatalogList = angular.copy(vm.listOfPlate);
            if (vm.docPrivCatalogList != null) {
                var index = _.findIndex(vm.docPrivCatalogList, function(item){
                    if(vm.selectedDocPlate && !_.isEmpty(vm.selectedDocPlate)){
                        return item.catalogPlateNumber === vm.selectedDocPlate.catalogPlateNumber;
                    }else{
                        return -1;
                    }

                });
                vm.currentIndexPlate = index !== -1 ? index : 0;
                if(vm.selectedDocPlate && vm.selectedDocPlate.applicability) {
                    vm.selectedApplicability = JSON.parse(angular.toJson(vm.selectedDocPlate.applicability));
                }
            }

            if (vm.user && vm.user.roles && !_.isEmpty(vm.user.roles) && _.find(vm.user.roles,function (item){
                if (item == DocPrivConstants.docPrivCommentProfile){
                    return true;
                }
            })){
                vm.isCommentsEnabledbyProfile = true;
            }

            if (_.find(vm.isDocprivProfile,function (item){
                if (item == DocPrivConstants.docPrivPopinVinProfile){
                    return true;
                }
            }) || (vm.isIndependentUser && $rootScope.asomDocList['DOCPRIV'] && $rootScope.asomDocList['PR-HERCULES'])){
                vm.isVinPopinEnabled = true;
            }
            if(vm.partsList && !_.isEmpty(vm.partsList)){
                vm.displayPlateCommentsPopup = DocPrivMetierService.getCommentsAvailability();
                initSVG(vm.selectedDocPlate);
            }else{
                getPlateLines();
            }
            $scope.$on('onSvgLoad', function (event) {
                applySvgPanZoom();
            });
        };
        function switchPRFormat(isPRFormat) {
            vm.isPRFormat = isPRFormat;
            const cacheProfile = CacheService.getObject(CacheConstants.profil);
            cacheProfile.isPRFormat = isPRFormat;
            CacheService.setObject(CacheConstants.profil, cacheProfile);
            ProfilMetierService.updatePRFormat(isPRFormat).then(function () {
                $rootScope.$applyAsync();
            });
        }
        $rootScope.$on("referenceCheck",function (event,data){
            vm.displayPicto = data.displayPicto;
            vm.checkValid = data.checkValid;
            vm.displayHercules = data.displayHercules;
            vm.partsList = DocPrivMetierService.getPlateDetails() ? DocPrivMetierService.getPlateDetails().partsList : null ;
            
            if(vm.displayPicto){
                vm.displayAllMtc = false;
                vm.displayPartsMtc();
            }
        });

        function getPlateLines(){

            blockUI.start();            
            vm.checkValid = null;
            if (DocumentsWsService.plateLines && DocumentsWsService.plateLines.references) {
                DocumentsWsService.plateLines.references = [];
            }
            vm.displayPicto = false;
            var mtcPayloadData = [];
            if (vm.docPrivCatalogList && !_.isEmpty(vm.docPrivCatalogList)) {
                var familySortedOrder = ['007V', '007E', '007B', '007G']
                var fixeArray = [];
                var filteredFamilyList = [];
                vm.docPrivCatalogList.forEach(function (plate) {
                    if (vm.selectedDocPlate && plate.catalogPlateNumber == vm.selectedDocPlate.catalogPlateNumber) {
                        plate.newApplicability.forEach(function (item) {
                            fixeArray.push(item.fixe);
                        });
                    }
                    
                })

                _.map(fixeArray, function (list) {
                    var filteredData = _.filter(list, function (item) {
                        return item.codeObj.slice(0, 3) === "007"
                    })
                    filteredFamilyList = filteredFamilyList.concat(filteredData);
                })
                var groupedFamily = _.groupBy(filteredFamilyList, 'codeObj');
                var sampleData = [];
                var isFamilyPresent = false

                for (var i in familySortedOrder) {
                    if (groupedFamily[familySortedOrder[i]] && !isFamilyPresent) {
                        isFamilyPresent = true;
                        sampleData.push(groupedFamily[familySortedOrder[i]][0]);
                    }
                }
                if (vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV) {
                    var listFamilyData = DocPrivMetierService.getListFamilies();
                    if (listFamilyData && listFamilyData.requestBody && !_.isEmpty(listFamilyData.requestBody.carContext)) {
                        var isFamilyPresent = false;
                        listFamilyData.requestBody.carContext.forEach(function (list) {
                            Object.keys(list).forEach(function (key) {
                                var keyValue = key.slice(0, 3);
                                if (keyValue == "007") {
                                    isFamilyPresent = true;
                            }

                        })
                    })
                        if(isFamilyPresent){
                         mtcPayloadData = listFamilyData.requestBody.carContext
                        }
                        else{
                             mtcPayloadData = []; 
                        }
                    }
                }
                else {
                    var requestBodyData = DocPrivMetierService.getListFamilies();
                    var carContextArray = {}
                    var isFamilyPresent = false;
                    if (requestBodyData && requestBodyData.requestBody && !_.isEmpty(requestBodyData.requestBody.partNumber)) {
                        sampleData[0].listCrit.forEach(function (item) {
                            var familyVal = [];
                            if (!_.isEmpty(item.codeCrit)) {
                                familyVal.push(item.codeCrit);
                            }
                            _.extend(carContextArray, {
                                [sampleData[0].codeObj]: familyVal
                            })
                            mtcPayloadData.push(carContextArray)
                        })
                    }
                    if (requestBodyData && requestBodyData.requestBody && !_.isEmpty(requestBodyData.requestBody.carContext)) {
                        requestBodyData.requestBody.carContext.forEach(function (item) {
                            Object.keys(item).forEach(function (key) {
                                var keyValue = key.slice(0, 3);
                                if (keyValue == "007") {
                                    isFamilyPresent = true;
                                }
                            })
                            if (!_.isEmpty(item[336])) {
                                _.extend(carContextArray, {
                                    '336': item[336]
                                })
                            }
                        })
                        if (isFamilyPresent) {
                            mtcPayloadData = requestBodyData.requestBody.carContext
                        }
                    }
                }
            }
            DocPrivMetierService.getDocPrivParts(vm.selectedDocPlate.catalogPlateNumber,mtcPayloadData).then(function (response) {
                vm.totalManufactureIds = [];
                response.references = _.filter(response.references, function(item){
                    return item.brand === DocPrivConstants.centraleBrand || DocPrivConstants.standardExchangeBrand;
                })
                response.references.map(function(item,index,array){
                    var applicabilities = [];
                    if (!_.isEmpty(item.applicability)) {
                        applicabilities = DocPrivMetierService.processSimplifiedApplicability(item.applicability,applicabilities,vm.totalManufactureIds);
                        _.assign(item, {applicabilities:applicabilities});
                    }

                    if(index === 0 || item.index !== array[index-1].index){
                        _.extend(item,{indexDisplay : true})
                    }else{
                        _.extend(item,{indexDisplay : false})
                    }
                    _.extend(item,{fullMtcDisplayed : false})
                    return item;

                })
                vm.partsList = response;
                vm.partsList.references.map(function (item) {
                    item.applicability.map(function (appl) {
                        appl.fixe.map(function (fixAppl) {
                            if(fixAppl && fixAppl.codeObj === "755"){
                                vm.showApplicabilityPicto = true;
                            }
                        });                        
                    });
                });
                $timeout(function() {
                    vm.setPlateDetails();
                },0);
                initSVG(vm.selectedDocPlate);
            }).catch(function(error){
                if (error) {
                    toastr.error(error);
                }
                initSVG(vm.selectedDocPlate);
            }).finally(function () {
                blockUI.stop();
                if (vm.isCommentsEnabledbyProfile){
                    getComments(vm.selectedDocPlate.catalogPlateNumber);
                }
            });
        }

        function displayBorder(applicability,reference) {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var filteredLineDetails = null;
            if (DocumentsWsService.plateLines && DocumentsWsService.plateLines.references && !_.isEmpty(DocumentsWsService.plateLines.references)) {
               filteredLineDetails = DocumentsWsService.plateLines.references.filter(function(item){
                return item.reference === reference;
            });
            }
            var productionNumber = '';
            if(applicability.manufactuerId && applicability.manufactuerId !== ''){
                productionNumber = (applicability.manufactuerId.match(/\(([^)]+)\)/) || [])[1];
            }
            var isFixedCriteriaValid = true;
            if (applicability.fixedApplicability && applicability.fixedApplicability !== '') {
                isFixedCriteriaValid = vm.validateFixedCriteria(
                    contextCarRequest, 
                    applicability.fixedApplicability
                );
            }
            var isVariableCriteriaValid = true;
            if (applicability.variableApplicability && applicability.variableApplicability !== '') {
                isVariableCriteriaValid = vm.validateVariableCriteria(
                    contextCarRequest, 
                    applicability.variableApplicability,
                    productionNumber
                );
            }
            var isResidualValueValid = true;
            if (applicability.codifiedApplicability && applicability.codifiedApplicability !== '') {
                if (filteredLineDetails && filteredLineDetails.length > 0 && filteredLineDetails[0].residual) {
                    isResidualValueValid = vm.validateResidualValue(filteredLineDetails[0].residual, applicability.codifiedApplicability);
                }
            }
            return vm.displayPicto && isFixedCriteriaValid && isVariableCriteriaValid && isResidualValueValid;
        }

        function parseFixedCriteria(fixedCriteria) {
            var parts = fixedCriteria.split('/');

            var mandatory = [];
            var optionalGroups = [];

            angular.forEach(parts, function (part) {
                part = part.trim();

                if (part.indexOf(',') !== -1) {
                    var options = part.split(',');
                    var trimmedOptions = [];

                    angular.forEach(options, function (opt) {
                        trimmedOptions.push(opt.trim());
                    });

                    optionalGroups.push(trimmedOptions);
                } else {
                    mandatory.push(part);
                }
            });


            return {
                mandatory: mandatory,
                optionalGroups: optionalGroups
            };
        }

        function validateFixedCriteria(contextCarRequest, fixedCriteria) {
            var parsed = vm.parseFixedCriteria(fixedCriteria);
            var firstMandatory = parsed.mandatory[0];
            var mandatory = parsed.mandatory.slice(1);
            var optionalGroups = parsed.optionalGroups;

            var values = [];
            var firstValues = [];
            if(contextCarRequest && contextCarRequest.fixedCriterias) {
                angular.forEach(contextCarRequest.fixedCriterias, function (val) {
                    values.push(val);
                });
            }

            if (contextCarRequest && contextCarRequest.contextBLMS && contextCarRequest.contextBLMS.dataCrit) {
                angular.forEach(contextCarRequest.contextBLMS.dataCrit, function (val) {
                    if (values.indexOf(val) === -1) {
                        values.push(val);
                    }
                });
            }

            if (contextCarRequest && contextCarRequest.extraFamilies) {
                angular.forEach(contextCarRequest.extraFamilies, function (val) {
                    firstValues.push(val);
                });
            }

            var mandatoryOk = true;
            angular.forEach(mandatory, function (m) {
                if (values.indexOf(m) === -1) {
                    mandatoryOk = false;
                }
            });

            if (firstValues.indexOf(firstMandatory) === -1) {
                mandatoryOk = false;
            }

            var optionalOk = true;
            angular.forEach(optionalGroups, function (group) {
                var groupMatch = false;

                angular.forEach(group, function (opt) {
                    if (values.indexOf(opt) !== -1) {
                        groupMatch = true;
                    }
                });

                if (!groupMatch) {
                    optionalOk = false;
                }
            });

            return mandatoryOk && optionalOk;
        }

        function toDate(value) {
            if (value.indexOf('MOD') === 0) {
                var yy = parseInt(value.substr(3, 2), 10);
                var mm = parseInt(value.substr(5, 2), 10) - 1;
                return new Date(2000 + yy, mm, 1);
            }

            value = value.replace(/\//g, '-');
            return new Date(value);
        }

        function extractIndex(key) {
            return key.replace(/\D/g, '');
        }

        function validateVariableCriteria(contextCarRequest, variableApplicability, productionNumber) {
            
            var parts = variableApplicability.split('>');
            var left = parts[0].trim();
            var right = parts[1].trim();

            var apvapKey = null;
            var fromVal = null;
            var toVal = null;

            if (left.indexOf('=') !== -1) {
                var leftParts = left.split('=');
                apvapKey = leftParts[0].trim();  
                fromVal = leftParts[1].trim();
            }

            if (right.indexOf('=') !== -1) {
                var rightParts = right.split('=');
                if (!apvapKey) {
                    apvapKey = rightParts[0].trim();
                }
                toVal = rightParts[1].trim();
            }

            var index = extractIndex(apvapKey);

            var productionNumberCriteria = null;
            var criteriaDateStr = null;
            
            if (index === '4' && contextCarRequest && contextCarRequest.contextBLMS && contextCarRequest.contextBLMS.dataCritVar) {
                productionNumberCriteria = contextCarRequest.contextBLMS.dataCritVar['APVNM' + index];
                criteriaDateStr = contextCarRequest.contextBLMS.dataCritVar['APVDT' + index];
            } else if (contextCarRequest && contextCarRequest.variableCriterias) {
                productionNumberCriteria = contextCarRequest.variableCriterias['APVNM' + index];
                criteriaDateStr = contextCarRequest.variableCriterias['APVDT' + index];
            }
            if (!criteriaDateStr && !productionNumberCriteria) {
                return false;
            }
            if (productionNumber && productionNumberCriteria) {
                return productionNumber === productionNumberCriteria;
            }

            if (criteriaDateStr) {
                var criteriaDate = toDate(criteriaDateStr);
                var fromDate = fromVal ? toDate(fromVal) : null;
                var toDateVal = toVal ? toDate(toVal) : null;

                if (fromDate && toDateVal) {
                    return criteriaDate >= fromDate && criteriaDate <= toDateVal;
                }

                if (fromDate && !toDateVal) {
                    return criteriaDate >= fromDate;
                }

                if (!fromDate && toDateVal) {
                    return criteriaDate <= toDateVal;
                }
            }

            return false;
        }

        function validateResidualValue(residualValueCriteria, residualValueApplicability) {
            var textCodes = residualValueApplicability.split(',').map(function (item) {
                return item.split('—')[0].trim();
            });
            var hasMatch = residualValueCriteria.some(function (res) {
                return res.codifiedSigns.some(function (sign) {
                    return textCodes.indexOf(sign.codeObj) !== -1;
                });
            });
            return hasMatch;
        }

        function displayApplicabilityDetails(parts,fixedData) {
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl: 'app/components/docpriv/partDetails/partDetails.template.html',
                controller: 'PartDetailsController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    partDetails: parts,
                    fixedData: fixedData,
                    showApplicabilityData: true
                }
            });
        }

        function isStandardExchange(types){
            return _.includes(types,ListPieceConstants.types.standardExchange);
        }

        function isTractionBattery(familyCode){
            return familyCode === ListPieceConstants.tractionBatteryFamilyCode;
        }

        function displayFullMtc(parts,displayAllMtc){
            parts.fullMtcDisplayed = _.isUndefined(displayAllMtc) ? !parts.fullMtcDisplayed : displayAllMtc;
            if(!parts.fullMtcDisplayed){
                return parts.applicabilities.map(function(item){
                    if(parts.applicabilities.indexOf(item) !== 0){
                        item.display = false;
                        return item;
                    }

                })
            }else{
                return parts.applicabilities.map(function(item){
                    item.display = true;
                    return item;

                })

            }

        }
        function displayManufactureId(){
            vm.displayManufacture =  !vm.displayManufacture;
            if(vm.displayManufacture){
                vm.isManufactureId = true;
            }else{
                vm.isManufactureId = false;
            }
        }

        function displayPartsMtc(){
            vm.displayAllMtc = !vm.displayAllMtc;
            vm.partsList.references.map(function(parts){
                return displayFullMtc(parts,vm.displayAllMtc);
            })

        }

        function groupTargets(parts) {
            return DocPrivMetierService.groupTargets(parts);
        }

        function displayDetails(parts, showNewApplicability) {
            var dispList = groupTargets(parts);
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl: 'app/components/docpriv/partDetails/partDetails.template.html',
                controller: 'PartDetailsController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    partDetails: parts,
                    displaySuperseding: dispList,
                    newApplicability: showNewApplicability
                }
            })
        }


        function goToProduct(partNumber) {

            vm.setPlateDetails();
            var url = $state.href(RoutesConstants.product,{ reference: partNumber,mainReference : partNumber});
            var openedWindow = $window.open(url, '_blank');
            openedWindow.onload  = function(){
                var channel = new BroadcastChannel("isFromDocPriv");
                channel.postMessage(true);
            }

        }

        /**
         * @name backToPrevious
         * @desc go to previous page
         */
        function backToPrevious() {
            vm.partsList = [];
            vm.isPartsList = false;
            vm.isPlatesList = true;
            vm.displayPicto = false;
            vm.checkValid = null;
            vm.displayHercules = false;
        }

        function formatDate(date) {
            return date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3");
        }


        /**
         * @name scrollVignette
         * @desc scroll down to vignette
         * @param direction direction of scroll available values ['left', 'right']
         */
        function scrollVignette(direction) {
            var elmnt = document.getElementById("scrollVignetteContainer");
            var scrollValue = 75;
            if (direction === "left") {
                elmnt.scrollLeft -= scrollValue;
            } else {
                elmnt.scrollLeft += scrollValue;
            }
        }

        function setActivePlate(catalogsList, indexPR) {
            document.getElementById("vignette_"+ indexPR).scrollIntoView({ inline: 'center' });
            if (!catalogsList.length)
                return;
            if (!indexPR)
                indexPR = 0;

            if (catalogsList[indexPR] && catalogsList[indexPR].catalogPlateNumber) {
                getPlateLines();
            }
        }

        function onVignetteClick(selectedPlate) {
            for (var i = 0; i < vm.docPrivCatalogList.length; i++) {
                if (selectedPlate.plateNo === vm.docPrivCatalogList[i].plateNo) {
                    vm.currentIndexPlate = i;
                }
            }
            vm.selectedApplicability = JSON.parse(angular.toJson(selectedPlate.applicability));
            vm.selectedDocPlate = selectedPlate;
            vm.checkValid = null;
            if (DocumentsWsService.plateLines && DocumentsWsService.plateLines.references) {
                DocumentsWsService.plateLines.references = [];
            }
            vm.displayPicto = false;
            setActivePlate(vm.docPrivCatalogList, vm.currentIndexPlate);
            // Replace the value of the plateIndex parameter in the url to ensure back button to work
            // with set refIndex to 0 to ensure that a new active plate have not repere selectioned

        }

        function fullOrReducedScreen() {
            if (vm.isFullScreen) {
                vm.exitFullscreen();
            } else {
                vm.openFullscreen();
            }
        }

        function openFullscreen() {
            vm.isFullScreen = true;
            vm.elemToZoomContainer = document.getElementById('divSvgContent');
            if (vm.elemToZoomContainer.requestFullscreen) {
                vm.elemToZoomContainer.requestFullscreen();
            } else if (vm.elemToZoomContainer.mozRequestFullScreen) { /* Firefox */
                vm.elemToZoomContainer.mozRequestFullScreen();
            } else if (vm.elemToZoomContainer.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                vm.elemToZoomContainer.webkitRequestFullscreen();
            } else if (vm.elemToZoomContainer.msRequestFullscreen) { /* IE/Edge */
                vm.elemToZoomContainer.msRequestFullscreen();
            }
        }

        function exitFullscreen() {
            vm.isFullScreen = false;
            if (document.fullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }

        document.addEventListener("fullscreenchange", function(event) {
            if(document && !document.fullscreenElement){
                exitFullscreen();
            }
        });

        this.$onDestroy = function () {
            angular.element($window).off('resize', vm.resize);
        };

        function isBorderVignette(id) {
            if (id == vm.currentIndexPlate) {
                return 'phx-img-ratio-1-1-vignette_border';
            }
            return 'phx-img-ratio-1-1-vignette_noborder';
        }

        function isLineVignette(id) {
            if (id === vm.currentIndexPlate) {
                return 'line';
            }
            return "";
        }


        function openComments() {
            var indexList = _.keys(_.groupBy(vm.partsList.references, 'index'));
            var initialIndex = "";
            indexList.unshift(initialIndex);
            getComments(vm.partsList.id);
            if (!_.isEmpty(vm.getplateComments)){
                _.map(vm.getplateComments, function (list) {
                    if (list && list.index) {
                        _.remove(indexList, function(item) {
                            return item == list.index;
                        });
                    }
                });
            }

            CommentsService.setIndexList(indexList);
            CommentsService.setPlateDetails(false,vm.selectedDocPlate.catalogPlateNumber);
            CommentsService.setNewPlateComments(true);
            CommentsService.setPopinVisibility(true);
        }

        function getComments(plateId){
            blockUI.start();
            CommentsService.getPlateCommentsDetailsfromDB(plateId).then(function (response){
                if (!_.isEmpty(response)){
                        CommentsService.setPlateCommentsDetails(response);
                        vm.getplateComments = response;
                        vm.displayPlateCommentsPopup = true;
                        var plateComment = _.filter(vm.getplateComments, function (item){
                            return item.index == "0";
                        });
                        if(plateComment.length > 0){
                            if (plateComment[0].commentDate.split('T')[0].replaceAll('-','/') > vm.formatDate(vm.selectedDocPlate.publicationDate)){
                                vm.displayNewComments = true;                            
                            }
                        }
                        
                }

                else{
                    vm.displayPlateCommentsPopup = false;
                    vm.getplateComments = [];
                    CommentsService.setPlateCommentsDetails("");
                }
                DocPrivMetierService.setCommentsAvailability(vm.displayPlateCommentsPopup);

            }).catch(function(error){
                if (error) {
                    toastr.error(error);
                }
            }).finally(function () {
                blockUI.stop();
            });
        }

        function displayPlateComments(plateIndex){
            var indexList = _.keys(_.groupBy(vm.partsList.references, 'index'));
            if (plateIndex == undefined) {
                plateIndex = 0;
            }
            CommentsService.setIndexList(indexList);
            CommentsService.setPlateDetails(true,vm.selectedDocPlate.catalogPlateNumber, plateIndex);
            CommentsService.setPopinVisibility(true);
            CommentsService.setNewPlateComments(false);
        }

        $rootScope.$on('displayDocprivComments',function(event, response){
            vm.getplateComments = response;
            vm.displayPlateCommentsPopup = true;
        })

        $rootScope.$on('hideDocprivComments',function(event, commentsList){
            vm.getplateComments = commentsList;
            if (!_.isEmpty(vm.getplateComments)) {
                vm.displayPlateCommentsPopup = true;
            } else {
                vm.displayPlateCommentsPopup = false;
            }
        })

        $scope.$on(EventConstants.selectReferencesFromPlanche, function (event, index) {
            selectedMark(index);
            goToElement(index);
        });

        function initSVG(piece, repere) {
            var urlSvg = piece.pictureUrl;
            if (urlSvg) {
                blockUI.start();
                //will be removed later
                // $http.get('../../assets/captures.svg').then(function (response){

                DocumentsMetierService.returnSVG(piece.catalogPlateNumber, urlSvg).then(function (response) {
                    var svg = response.data;
                    if (document.getElementById("divSvgContent")) {
                        var element = document.getElementById("divSvgContent")
                        element.innerHTML = svg;
                        element.setAttribute("svg-handler", "");
                        $compile(element)($scope);
                        if(document.querySelector("#divSvgContent svg image")){
                            var svgElement = document.querySelector("#divSvgContent svg")
                            var serializedSVG = new XMLSerializer().serializeToString(svgElement);
                            var canvas = document.createElement('canvas');
                            var context = canvas.getContext('2d');
                            canvas.width = 800;
                            canvas.height = 600;
                            var image = new Image();
                            image.onload = function () {
                                context.clearRect(0, 0, 800, 600);
                                context.drawImage(image, 0, 0, 800, 600);
                                var pngData = canvas.toDataURL('image/png');
                                callWordDoc(pngData);
                            };
                            image.src = "data:image/svg+xml;base64,"+ window.btoa(unescape(encodeURIComponent(serializedSVG)));
                        }
                    }

                    // Wait dom ready
                    // Need to reopen svg with the selected node (on init)
                    scrollTop();
                    var refIndex = repere ? repere : $state.params.refIndex;
                    if (refIndex && refIndex != 0) {
                        gotoSvg(refIndex);
                    }
                }, function (error) {
                    if (error)
                        toastr.error(error, 'Error');
                }).finally(function () {
                    blockUI.stop();
                    document.getElementById("vignette_" + vm.currentIndexPlate).scrollIntoView({inline:'center'});
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                });


            } else {
                var element = document.getElementById("divSvgContent");
                element.innerHTML = "";
                element.removeAttribute("svg-handler");
                $compile(element)($scope);
            }
        }

        function gotoSvg(index) {
            $('text').removeClass("active-repere");
            $('.rid_' + index).addClass('active-repere');
            var elem = document.getElementById("docPrivPlates");
            var anchor = elem && $(elem).length !== 0 ? $(elem).offset().top : 0;
            $('html, body').animate({ scrollTop: anchor }, 300);
            selectedMark(index);
        }
        var tmpIndex = 1;

        function selectedMark(repereIndex) {
            var selectedElement = document.getElementById(tmpIndex)
            var container;
            if (selectedElement) {
                container = selectedElement.getElementsByClassName(textIndexDivClass);
                angular.element(container).removeClass('landmark');
                $('svg line, svg polyline, svg path').removeClass("active-line");
            }
            $('svg>svg').remove();
            $('g>svg').remove();
            if(document.getElementById(repereIndex)){
                container = document.getElementById(repereIndex).getElementsByClassName(textIndexDivClass);
                angular.element(container).addClass('landmark');
            }
            tmpIndex = repereIndex;

            if (document.getElementById("r" + repereIndex) != null) {
                //BUG-1878
                var parent = document.getElementById("r" + repereIndex).parentNode;
                var repereGroup = getRepereGroupElement();
                if (repereGroup) {
                    var listSvg = repereGroup.getElementsByTagName("g");

                    angular.forEach(listSvg, function (value, key) {

                        if ($(value).text().trim() == repereIndex) {

                            applySelectionPlateFull(repereIndex, value);
                        }
                    });
                } else {
                    var listText = document.getElementsByTagName("text");
                    angular.forEach(listText, function (value, key) {
                        if ($(value).text().trim() == repereIndex) {
                            applySelectionPlateLite(repereIndex, value);
                        }
                    });
                }
            }

        }

        function applySelectionPlateFull(repereIndex, node) {

            var findLine = highlightLeaderShapes(node);
            if (!findLine || findLine.length === 0) {
                highlightNearestLeaderLine(node);
            }
            var positions = node.getElementsByTagName("text");

            var y;
            var x;

            $.each(positions, function (index, node) {
                if (repereIndex <= 9) {
                    y = (node.getAttribute("y")) - 6;
                    x = (node.getAttribute("x")) - 1;
                    $("<svg><rect height='7' width='6' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                        + y + "' x='" + x + "' /></svg>").insertBefore(node);

                } else {
                    y = (node.getAttribute("y")) - 6;
                    x = (node.getAttribute("x")) - 0.5;
                    $("<svg><rect height='7' width='9' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                        + y + "' x='" + x + "' /></svg>").insertBefore(node);
                };
            });
        }

        function applySelectionPlateLite(repereIndex, node) {
            highlightNearestLeaderLine(node);
            var y = node.getAttribute("y");
            var x = node.getAttribute("x");
            if (repereIndex <= 9) {
                y -= 6;
                x -= 1;
                $("<svg><rect height='7' width='6' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                    + y + "' x='" + x + "' /></svg>").insertBefore(node);
            } else {
                y -= 6;
                x -= 0.5;
                $("<svg><rect height='7' width='9' style='fill:var(--renaultPrimaryColor);stroke:none' y='"
                    + y + "' x='" + x + "' /></svg>").insertBefore(node);
            };
        }

        function getRepereGroupElement() {
            return document.getElementById("Repères") || document.getElementById("Reperes");
        }

        function highlightLeaderShapes(node) {
            return $(node).find('line, polyline, path').addClass('active-line');
        }

        function highlightNearestLeaderLine(markerNode) {
            var markerCenter = getSvgNodeCenter(markerNode);
            if (!markerCenter) {
                return;
            }

            var lineSelectors = '#divSvgContent svg line, #divEbSvgContent svg line';
            var lines = document.querySelectorAll(lineSelectors);
            if (!lines || lines.length === 0) {
                return;
            }

            var nearestLine = null;
            var nearestDistance = Number.POSITIVE_INFINITY;

            angular.forEach(lines, function (lineNode) {
                var lineCenter = getSvgNodeCenter(lineNode);
                if (!lineCenter) {
                    return;
                }

                var deltaX = markerCenter.x - lineCenter.x;
                var deltaY = markerCenter.y - lineCenter.y;
                var distance = (deltaX * deltaX) + (deltaY * deltaY);
                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nearestLine = lineNode;
                }
            });

            if (nearestLine) {
                angular.element(nearestLine).addClass('active-line');
            }
        }

        function getSvgNodeCenter(node) {
            if (!node || !node.getBBox) {
                return null;
            }

            try {
                var bbox = node.getBBox();
                return {
                    x: bbox.x + (bbox.width / 2),
                    y: bbox.y + (bbox.height / 2)
                };
            } catch (e) {
                return null;
            }
        }

        function scrollTop() {
            if ($('#docPrivPlates').offset()) {
                $('html, body').animate({ scrollTop: $('#docPrivPlates').offset().top }, 100);
            }
        }

        function goToElement(loc) {
            var element = document.getElementById(loc);
            if(element)
                element.focus();
            element.scrollIntoView();
        }

        Element.prototype.documentOffsetTop = function () {
            return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
        };

        Element.prototype.scrollIntoViewCenter = function () {
            window.scrollTo(0, this.documentOffsetTop() - (window.innerHeight / 2));
        };

        function applySvgPanZoom() {
            // hack for IE
            // image is loaded but not on the DoM
            // wait for it and apply svgPanZoom
            $timeout(function() {
                var beforePan;
                beforePan = function (oldPan, newPan) {
                    var sizes = this.getSizes()
                        , gutterWidth = sizes.width
                        , gutterHeight = sizes.height
                        , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
                        , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
                        , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
                        , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
                    var customPan = {};
                    var positionOnX = vm.svgPanZoom.getPan().x;
                    // if svg is in last zoom out position, center svg. Else, normal behavior.
                    if (positionOnX > 0) {
                        customPan.x = 10;
                        customPan.y = 0;
                    } else {
                        customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
                        customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
                    }

                    return customPan;
                };

                vm.svgPanZoom = svgPanZoom('#svgPanImage', {
                    dblClickZoomEnabled: false,
                    minZoom: 1,
                    maxZoom: 15,
                    zoomScaleSensitivity: 1,
                    beforePan: beforePan
                });

                angular.element($window).on('resize', vm.resize);
            }, 0);
        };

         function zoomIn() {
            vm.svgPanZoom.zoomIn();
        }

        function zoomOut() {
            vm.svgPanZoom.zoomOut();
        }

        function resetZoom() {
            vm.svgPanZoom.resetZoom();
            vm.svgPanZoom.center();
        }
        function printPlateDetails(){
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl: 'app/components/docpriv/docPrivParts/docprivPrint.template.html',
                controller: 'docprivPrintController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true
            }).then(function (resp) {
                if(resp == 'WORD'){
                    downloadWordDoc();
                } else if (resp == 'PDF'){
                    downloadPdf();
                }
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
        }
        function callWordDoc(data){
            vm.wordDocImage = data;
        }
        function downloadWordDoc(){
            var url = DocPrivMetierService.downloadWordGeneric(false,null);
            var filename = vm.docPrivCatalogList[vm.currentIndexPlate].plateNo+'.doc';
            var downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = url;
            downloadLink.download = filename;
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
        function downloadPdf(){
            pdfMake.tableLayouts = {
                otherTableLayout: {
                    hLineWidth: function () {
                        return 1;
                    },
                    vLineWidth: function () {
                        return 1;
                    }
                },secondTableLayout: {
                    hLineWidth: function () {
                        return 0;
                    },
                    vLineWidth: function () {
                        return 0;
                    }
                },
                thirdTableLayout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                    }
                },
            };
            var partListForPrint = $filter('applicabilityFilter')(vm.partsList.references,vm.fixedData,vm.variableData,vm.codifiedData);
            resetZoom();
            $timeout(function () {
                DocPrivMetierService.downloadPdfData(vm.docPrivCatalogList[vm.currentIndexPlate],partListForPrint,null,null,null).then(function(response){
                    var pdfDocGenerator = pdfMake.createPdf(response.data);
                    pdfDocGenerator.getBuffer(function (buffer) {
                        var file = new Blob([(buffer)], { type: 'application/pdf' });
                        var isIE = false || !!document.documentMode;
                        var isEdge = !isIE && !!window.StyleMedia;
                            if (isIE || isEdge) {
                                FileSaver.saveAs(file, vm.docPrivCatalogList[vm.currentIndexPlate].plateNo+".pdf");
                            }else {
                                printPdfModalService.encode64Base(file).then(function (response) {
                                    var modalParams = {
                                        data: response
                                    }
                                    return printPdfModalService.showModal(modalParams).catch(function () {
                                        $log.debug($translate.instant('ERROR'));
                                     });
                                }).catch(function () {
                                    toastr.error($translate.instant('ERROR'));
                                });
                            }
                    })
                });
            },100)
        }
        $scope.$watch('listOfList',function(event){
            $timeout(function() {
                var elements = document.getElementsByClassName(textIndexDivClass);
                angular.forEach(elements, function(element){
                    angular.element(element).removeClass('landmark');
                })

                vm.filteredList = $scope.listOfList;
            },100);
        })
        function validateVin(){ 
            DocPrivMetierService.setPlateId(vm.docPrivCatalogList[vm.currentIndexPlate].catalogPlateNumber);
            $mdDialog.show({
                templateUrl: 'app/components/docpriv/docPrivParts/docPrivVinCheck.template.html',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                onRemoving : function () {
                    DocPrivMetierService.clearPlateId();
                }
            }).then(function(){
                DocPrivMetierService.clearPlateId();
            })
        }
        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }
    }
})();

/**
 * commentsDeleteController
 * @namespace Controller
 */
(function () {
    angular.module('phenix').controller('commentsDeleteController', commentsDeleteController);

    function commentsDeleteController(
        $mdDialog) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace onConfirm
         * @desc on confirm exit
         */
        function onConfirm() {
            $mdDialog.hide(true);
            
        }

        /**
         * @namespace onCancel
         * @desc on cancel exit
         */
        function onCancel() {
            $mdDialog.hide(false);
        }

    }

})();

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .factory('CommentsService', CommentsService);
  
  
    /* @ngInject */
    function CommentsService(CarSearchConstants,$q,toastr, $translate, RestUpgrade) {
      var popinVisibility = { status: false };
      var plateInfo = {};
      var plateCommentDetails = {};
      var newPlateComments = false;
      var indexList = [];

      var service = {
        setPopinVisibility: setPopinVisibility,
        getPopinVisibility: getPopinVisibility,
        setPlateDetails:setPlateDetails,
        getPlateDetails: getPlateDetails,
        getPlateCommentsDetailsfromDB : getPlateCommentsDetailsfromDB,        
        getPlateCommentsDetails: getPlateCommentsDetails,
        setPlateCommentsDetails:setPlateCommentsDetails,
        savePlateComments :savePlateComments,
        updatePlateComments :updatePlateComments,
        deletePlateComments: deletePlateComments,
        getNewPlateComments: getNewPlateComments,
        setNewPlateComments:setNewPlateComments,
        setIndexList: setIndexList,
        getIndexList: getIndexList
        
      };
      return service;

      function setPopinVisibility(visibility) {
        popinVisibility.status = visibility;
      }
      function getPopinVisibility() {
        return popinVisibility;
      }

      function setPlateDetails(fromRefPlate,plateDetails, index){
          plateInfo = {
            disableIndex: fromRefPlate,
            plateDetails: plateDetails,
            index: index
          }
      }

      function getPlateDetails() {
        return plateInfo;
      }

      function getPlateCommentsDetailsfromDB(plateId){
        var url = CarSearchConstants.docPrivComments + "/" + plateId ;
        return RestUpgrade.one(url).get();
      }

      function getPlateCommentsDetails(){
        return plateCommentDetails;
      }

      function setPlateCommentsDetails(commentsDetails){
        plateCommentDetails = commentsDetails;
      }

      function getNewPlateComments(){
        return newPlateComments;
      }

      function setNewPlateComments(display){
        return newPlateComments = display;
      }

      function savePlateComments(plateId, docprivPlate){

        var defer = $q.defer();
        
          var payload = {
          ipn: docprivPlate.ipn,
          cr: docprivPlate.cr,
          gar: docprivPlate.gar,
          comment: docprivPlate.comments,
          status:"Valid",
          index: docprivPlate.index ? docprivPlate.index : 0,
          idComment:plateId
          }
          RestUpgrade.all(CarSearchConstants.docPrivComments).post(payload).then( function (response){
          defer.resolve(response);
          }, function (response) {
            toastr.error($translate.instant("DOCPRIV_COMMENTS_EXISITS"));
            defer.reject(response);
          });
          return defer.promise;
      }

      function updatePlateComments(plateId, docprivPlate){
        var defer = $q.defer();
        var url = CarSearchConstants.docPrivComments + "/" + plateId;
        var payload = {
          ipn: docprivPlate.ipn,
          cr: docprivPlate.cr,
          gar: docprivPlate.gar,
          comment:docprivPlate.comments,
          index: docprivPlate.index ? docprivPlate.index : 0,
          status:"Valid"
        }
        RestUpgrade.all(url).post(payload).then( function (response){
          defer.resolve(response);
          }, function (response) {
            defer.reject(response);
          });
        return defer.promise;
      }

      function deletePlateComments(plateId,index){

        return RestUpgrade.one(CarSearchConstants.docPrivDeleteComments + "/" + plateId+"/"+index).post().then(function (response) {
          return response;
      }, function (msg) {
          return $q.reject(msg.errors || {
              errors: [{
                  errorCode: msg.status,
                  message: (msg !== null && msg !== undefined) ? msg.statusText : ""
              }]
          });
      });
      }

      function setIndexList(list){
        indexList = list;
      }

      function getIndexList(){
        return indexList;
      }
      
    }
})();

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .directive('phxComments', phxComments);
  
  
    /* @ngInject */
    function phxComments() {
      var directive = {
        templateUrl: 'app/components/docpriv/comments/comments.template.html',
        bindToController: true,
        controller: phxCommentsController,
        controllerAs: 'vm',
        restrict: 'EA',
        scope: {}
      };
      return directive;
    }
  
    /* @ngInject */
    function phxCommentsController(blockUI, CommentsService, CacheConstants, CacheService, $rootScope, $mdDialog, toastr, $translate) {
      var vm = this;
      vm.hidePopin = CommentsService.getPopinVisibility();
      vm.actionHidePopin = actionHidePopin;
      
      vm.userIpn = CacheService.getObject(CacheConstants.profil).ipn;
      vm.userCR = '';
      vm.userGAR = '';
      vm.indexList = [];
      vm.selectedComments = '';
      vm.selectedIndex = '';
      init();         

      vm.goBack = goBack;
      vm.saveComments = saveComments;
      vm.savePlateComments = savePlateComments;
      vm.deleteComments = deleteComments;

      function init() {
        vm.idComment = CommentsService.getPlateDetails();
        vm.disableIndex = vm.idComment ? vm.idComment.disableIndex : false;
        vm.checkforComments = CommentsService.getNewPlateComments();

        if(!vm.checkforComments){
          vm.plateCommentsDetails = CommentsService.getPlateCommentsDetails();
        }
        else{
          vm.plateCommentsDetails = '';
        }


        if (!_.isEmpty(vm.plateCommentsDetails)){
          _.map(vm.plateCommentsDetails, function (item) {
            if (item && item.idComment != null && vm.idComment.index == item.index){
                vm.userIpn = item.ipn; 
                vm.userCR = item.cr;
                vm.userGAR = item.gar;
                vm.selectedIndex = item.index;
                vm.indexList = CommentsService.getIndexList();
                vm.selectedComments = item.comment;
            }
          });
        }

        else{
          vm.userCR = '';
          vm.userGAR = '';
          vm.indexList = CommentsService.getIndexList();
          vm.selectedComments = '';
        }
      }
      function actionHidePopin() {
        CommentsService.setPopinVisibility(false);
      }
      function goBack(){
        CommentsService.setPopinVisibility(false);
      }
      function saveComments() {
        blockUI.start();
        var docprivPlate = {};
        docprivPlate.ipn = vm.userIpn;
        docprivPlate.cr = vm.userCR;
        docprivPlate.gar = vm.userGAR;
        docprivPlate.comments = vm.selectedComments;
        docprivPlate.index = vm.selectedIndex ? vm.selectedIndex : 0;

        if (!_.isEmpty(vm.plateCommentsDetails)) {
          _.map(vm.plateCommentsDetails, function (item) {
            if (item && item.idComment != null) {
              if (item.index == docprivPlate.index) {
                  CommentsService.updatePlateComments(item.idComment, docprivPlate).then(function (response) {
                  CommentsService.setPopinVisibility(false);
                  CommentsService.setPlateCommentsDetails(response);
                  $rootScope.$broadcast("displayDocprivComments", response);
                  }).finally(function () {
                    blockUI.stop();
                  });
              }
            }
          });
        } 
          
        else {

          if (vm.idComment.index === 0 || vm.idComment.index === undefined){
            if (!_.isEmpty(vm.plateCommentsDetails)){
              _.map(vm.plateCommentsDetails, function (list) {
                if (list && list.idComment != null) {
                    if (list.index == 0 && list.comment != null) {
                        toastr.error($translate.instant("DOCPRIV_COMMENTS_EXISITS"));
                    }
                    else{
                      savePlateComments(docprivPlate);
                    }
                }
              }); 
            }
            else{
                savePlateComments(docprivPlate);
            }
          }
          else{
            savePlateComments(docprivPlate);
          }
        }
      }

      function savePlateComments(docprivPlate) {
        if (docprivPlate.index == 0 && docprivPlate.comment != null) {
            toastr.error($translate.instant("DOCPRIV_COMMENTS_EXISITS"));
            blockUI.stop();
        }
        else {
            CommentsService.savePlateComments(vm.idComment.plateDetails, docprivPlate).then(function (response) {
            CommentsService.setPopinVisibility(false);
            CommentsService.setPlateCommentsDetails(response);
            $rootScope.$broadcast("displayDocprivComments", response);
            }).finally(function () {
              blockUI.stop();
            });
        }
      }

      function deleteComments(index){
        CommentsService.setPopinVisibility(false);
        $mdDialog.show({
          templateUrl: 'app/components/docpriv/comments/commentsDelete.template.html',
          controller: 'commentsDeleteController',
          bindToController: true,
          controllerAs: 'vm',
          clickOutsideToClose: true,
          preserveScope: true,
          multiple:true,
          autoWrap: true,
          skipHide: true
          }).then(function (confirm) {
            if(confirm){
              blockUI.start();
              CommentsService.deletePlateComments(vm.idComment.plateDetails,vm.idComment.index).then(function (response){
                CommentsService.setPopinVisibility(false);
                vm.plateCommentsDetails = response;

              }).finally(function () {
                CommentsService.setPlateCommentsDetails(vm.plateCommentsDetails);
                $rootScope.$broadcast('hideDocprivComments', vm.plateCommentsDetails);
                blockUI.stop();
                });
            }
            else{
              vm.displayDeletePopup = false;
              CommentsService.setPopinVisibility(true);
            }
                        
          })
        
        }              
      
    }
  }) ();
  

/**
 * @namespace CreateActisWSService
 * @desc send Actis informations and files to update/upload/download to the back service
 */

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DocAlertsWSService', DocAlertsWSService)

    /** @ngInject */
    function DocAlertsWSService($q,DocAlertsConstants,$translate,RestUpgrade ) {

        this.getDocumentAlerts = getDocumentAlerts;
        this.getDocumentAlertsNew = getDocumentAlertsNew;
        this.getDocTicketDetails = getDocTicketDetails; 
        this.updateDocTicket = updateDocTicket;

        function getDocumentAlerts(payload){

            var defer = $q.defer();

            RestUpgrade.all(DocAlertsConstants.docList).post(payload).then(function(response){

                defer.resolve(response);
            }).catch(function(error){

                defer.reject($translate.instant('DOC_ALERT_ERROR'))
            })

            return defer.promise;
        }

        function getDocumentAlertsNew(payload) {
            var defer = $q.defer();
            RestUpgrade.all(DocAlertsConstants.docListNew).post(payload).then(function (response) {
                defer.resolve(response);
            }).catch(function (error) {
                defer.reject($translate.instant('DOC_ALERT_ERROR'))
            })
            return defer.promise;
        }

        function getDocTicketDetails(uuid){
            var defer = $q.defer();
            var url = DocAlertsConstants.docTicketDetails + uuid;
            RestUpgrade.one(url).get().then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject($translate.instant('DOC_ALERT_ERROR'));
            });
            return defer.promise;
        }

        function updateDocTicket(payload) {
            var defer = $q.defer();
            RestUpgrade.all(DocAlertsConstants.updateDocTicket).post(payload).then(function (response) {
                defer.resolve(response);
            }).catch(function (error) {
                defer.reject(error)
            })
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DocAlertsMetierService', DocAlertsMetierService);

    /** @ngInject */
    function DocAlertsMetierService(DocAlertsWSService, DocAlertsConstants, $q,CacheService) {

        this.getDocumentAlerts = getDocumentAlerts;
        this.getDocumentAlertsNew = getDocumentAlertsNew;
        this.getDocTicketDetails = getDocTicketDetails;
        this.updateDocTicket = updateDocTicket;

        /**
         * @name getDocumentAlerts
         * @desc get alerts list with dealer ID
         * @returns {Promise}
         */
        function getDocumentAlerts(filter, sorting, pageNumber) {
        sorting = sorting || { sortBy: 'created', order: true };
        pageNumber = (typeof pageNumber === 'number') ? pageNumber : 0;
            var payload = {};

            payload = {
                filter: filter
            }

            _.extend(payload, {
                sort: {
                    by: sorting.sortBy,
                    order: (sorting.order)?-1:1
                },
                pagination: {
                    limit: DocAlertsConstants.pagination.limit,
                    offset: pageNumber
                }
            })

            var defer = $q.defer();

            DocAlertsWSService.getDocumentAlerts(payload).then(function (response) {

                if (response) {
                    defer.resolve(response);
                } else {
                    defer.reject();
                }

            }).catch(function (error) {
                defer.reject(error);
            })

            return defer.promise;
        }


        function getDocumentAlertsNew() {
            var payload = {};
            var defer = $q.defer();
            var profil = CacheService.getObject('profil');
            if (profil && profil.dealerId) {
                payload.dealerNumber = profil.dealerId;
                payload.pageSize = 200;
            }
            DocAlertsWSService.getDocumentAlertsNew(payload).then(function (response) {
                if (response) {
                    defer.resolve(response);
                } else {
                    defer.reject();
                }

            }).catch(function (error) {
                defer.reject(error);
            })
            return defer.promise;
        }

        function getDocTicketDetails(uuid) {
            var defer = $q.defer();

            DocAlertsWSService.getDocTicketDetails(uuid).then(function (response) {
                if (response) {
                    defer.resolve(response);
                } else {
                    defer.reject();
                }
            }).catch(function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

        function updateDocTicket(payload) {
            const defer = $q.defer();

            DocAlertsWSService.updateDocTicket(payload).then(function (response) {
                if (response) {
                    defer.resolve(response);
                } else {
                    defer.reject();
                }
            }).catch(function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

    }
})();

(function () {
    angular.module('phenix')
    .directive('pagingControl', [function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/doc-alerts/pagination/paging.html',
            controller: ['$scope', PagingController],
            scope: {
                totalPages: "=",
                pagingSize: '=',
                itemPerPage: '=noofitem',
                pageChange: '&',
                currentPage: "="
            },
            link: function(scope) {
                scope.$watch('currentPage', function() {
                    scope.setPage(false,scope.currentPage);
                });
              }
        };
    }]);

    function PagingController($scope) {
        $scope.pager = {};

        function setPager(totalPages, currentPage) {
            currentPage = currentPage || 1;
            var startPage, endPage;

            if (totalPages <= $scope.pagingSize) {
                startPage = 1;
                endPage = totalPages;
            } else {
                if (currentPage + 1 >= totalPages) {
                    startPage = totalPages - ($scope.pagingSize - 1);
                    endPage = totalPages;
                } else {
                    startPage = currentPage - parseInt($scope.pagingSize / 2);
                    startPage = startPage <= 0 ? 1 : startPage;
                    endPage = (startPage + $scope.pagingSize - 1) <= totalPages ? (startPage + $scope.pagingSize - 1) : totalPages;
                    if (totalPages === endPage) {
                        startPage = endPage - $scope.pagingSize + 1;
                    }
                }
            }
            var index = startPage;
            var pages = [];
            for (; index < endPage + 1; index++)
                pages.push(index);

            $scope.pager.currentPage = currentPage;
            $scope.pager.totalPages = totalPages;
            $scope.pager.startPage = startPage;
            $scope.pager.endPage = endPage;
            $scope.pager.pages = pages;
        }

        $scope.setPage = function (disable,currentPage) {
            if(!disable){
                setPager($scope.totalPages, currentPage);
                $scope.pageChange({page:currentPage});
            }
        };

        $scope.setPage(false,$scope.currentPage);

    }    
})();

(function () {
    angular.module('phenix').config(routing);

    function routing($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.quote, {
            url: '/quote',
            templateUrl: 'app/components/dms/quote/draft/quote.template.html',
            controller: 'QuoteController',
            params: {
                data: null,
                quoteListOptions: null
            },
            controllerAs: 'vm',
            onlyDMS: true
        });

        $stateProvider.state(RoutesConstants.quoteListDraft, {
            url: '/quoteList/draft',
            templateUrl: 'app/components/dms/quote/list/draft/quoteDraftList.template.html',
            controller: 'quoteListDraftController',
            params: {
                data: null,
                quoteListOptions: null
            },
            controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.quoteListValidated, {
            url: '/quoteList/validated',
            templateUrl: 'app/components/dms/quote/list/validated/quoteValidatedList.template.html',
            controller: 'quoteListValidatedController',
            params: {
                quoteListOptions: null
            },
            controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.validatedQuote, {
            url: '/validatedQuote/:id',
            templateUrl: 'app/components/dms/quote/validate/validatedQuote.html',
            controller: 'validatedQuoteCtrl',
            controllerAs: 'vm',
            params: {
              data: null,
              customer: null,
              quoteId: null,
              quoteListOptions: null
            }
        });
    }
})();

'use strict';

angular.module('phenix').constant('QuoteConstants',{
    quote: "quote",
    draftStatus: 'DRAFT',
    validatedStatus: 'VALIDATED',
    sort: {
        asc: 1,
        desc: -1,
        date: 'DATE',
        ID: 'ID'
    },
    pagination: {
        limit: 10
    },
    searchBy: {
        vin: 1,
        registrationNumber: 2,
        model: 3
    },
    errors : {
        partNotFound: 1,
        partNotFoundDMS: 2,
        partUnknownDMS: 3
    },
    status:{
        unknownPieceDMS: 1
    },
    localPiece:{
        min: 7701383000,
        max: 7701383999
    },
    quoteList: 'quote/list',
    quoteCreatedEvent: "quoteCreatedEvent",
    quoteUpdatedEvent: "quoteUpdatedEvent",
    quoteClosedEvent: "quoteClosedEvent",
    quoteSpread :"quoteSpread",
    TMLength: 4,
    PRLength: 10
});

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('DmsWsService', DmsWsService);

    /** @ngInject */
    function DmsWsService(
        $q,
        $http,

        CacheService,configConstantes,CacheConstants,

        DmsConstants, toastr,
        $translate, RestUpgrade,
        DmsErrorConstants) {

        this.getReferencesDms = getReferencesDms;
        this.sendBstoDms = sendBstoDms;
        this.getUsersListByCustomers = getUsersListByCustomers;
        this.getUserByAccount = getUserByAccount;
        this.getOrderByNumber = getOrderByNumber;
        this.getVehicle = getVehicle;
        this.getHourlyRates = getHourlyRates;
        this.callDms = callDms;
        this.getCustomers = getCustomers;
        this.calculQuote = calculQuote;
        this.getAwaitingParts = getAwaitingParts;

        /**
         *  ENUMS
         */
        var code = {
            success: 0,
            forbidden: -1,
            dms: 'dms'
        }

        /*=============================================
        =                FUNCTIONS                    =
        =============================================*/


        function getReferencesDms(payload) {
            return callDms(DmsConstants.referencesDmsUrl, payload);
            // return $q.resolve({"returnCode":0,"response":{"parts":[{"reference":"8200257642","cort":"1422","priceCode":"12","familyCode":"501","availabilities":[{"stockLabel":"NANCY","quantity":0.0,"stockId":1,"siteId":"00900011","location":"0020214","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"R.M.S NANCY","quantity":1.0,"stockId":2,"siteId":"00900011","location":"stsamed","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"Pneumatiques NANCY","quantity":0.0,"stockId":3,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"}],"description":"FILTRE HUILE","priceExclTaxes":13.98,"priceInclTaxes":16.78,"status":0,"depositReference":""},{"reference":"8200702754","cort":"1172","priceCode":"17","familyCode":"049","availabilities":[{"stockLabel":"NANCY","quantity":0.0,"stockId":1,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"R.M.S NANCY","quantity":0.0,"stockId":2,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"Pneumatiques NANCY","quantity":0.0,"stockId":3,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"}],"description":"MAMELON FILTRE HU","priceExclTaxes":6.43,"priceInclTaxes":7.72,"status":0,"depositReference":""}]}})

            //mock data to test DMS reference for status:2
            //return $q.resolve({"returnCode":0,"response":{"parts":[{"reference":"641213201R","cort":"1172","priceCode":"17","familyCode":"268","availabilities":[{"stockLabel":"NANCY","quantity":8.0,"stockId":1,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"R.M.S NANCY","quantity":0.0,"stockId":2,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"Pneumatiques NANCY","quantity":0.0,"stockId":3,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"}],"description":"PASSAGE ROUE AV G ASS","priceExclTaxes":238.53,"priceInclTaxes":286.24,"status":2,"depositReference":""},{"reference":"641212036R","cort":"1172","priceCode":"17","familyCode":"268","description":"PASSAGE ROUE AV G ASS","priceExclTaxes":254.28,"priceInclTaxes":305.14,"status":2,"depositReference":""},{"reference":"641308343R","cort":"1172","priceCode":"17","familyCode":"268","availabilities":[{"stockLabel":"NANCY","quantity":0.0,"stockId":1,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"R.M.S NANCY","quantity":0.0,"stockId":2,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"},{"stockLabel":"Pneumatiques NANCY","quantity":0.0,"stockId":3,"siteId":"00900011","location":"","siteLabel":"RE7 RLT NANCY"}],"description":"PASSAGE ROUE AV D PARTIE CTL","priceExclTaxes":273.64,"priceInclTaxes":328.37,"status":1,"depositReference":""},{"reference":"641308472R","cort":"1172","priceCode":"17","familyCode":"268","description":"PASSAGE ROUE AV D PARTIE CTL","priceExclTaxes":301.06,"priceInclTaxes":361.27,"status":1,"depositReference":""},{"reference":"214750939R","cort":"","priceCode":null,"familyCode":"","description":"","priceExclTaxes":0.0,"priceInclTaxes":0.0,"status":2,"depositReference":""}]}})
        }

        function getAwaitingParts(payload) {
            return callDms(DmsConstants.quotePartsUrl, payload).then(function (response) {
                var error = response.returnCode;
                if (error) {
                    return $q.reject(error);
                }
                return response;
            });
            //  return $q.resolve({"returnCode":0,"response":{"references":[{"reference":"271435467R","splitLabel":"TEST SIRVA","quantity":1.0,"splitId":"B","lineNumber":1}]}})
        }

        function sendBstoDms(payload) {
            return callDms(DmsConstants.partsDmsUrl, payload,DmsErrorConstants.prErrors).then(function (response) {
                var error = response.returnCode;
                //reject if error code is 1035
                if (error == "1035") {
                    return $q.reject(error);
                }
                return response;
            });
        }

        function getUsersListByCustomers(payload) {
            payload.maximumNumber = DmsConstants.maximumNumberOfreturnUsersDms;
            return callDms(DmsConstants.customersDmsUrl, payload);
        }

        /**
         *  @desc Get list of customers
         *  @param {object} payload
         *  @return {promise}
         */

        function getCustomers(payload) {
            return callDms(DmsConstants.customersDmsUrl, payload);
        }

        function getUserByAccount(payload) {
            return callDms(DmsConstants.accountDmsUrl, payload);
        }

        function getOrderByNumber(payload) {
            return callDms(DmsConstants.orderDmsUrl, payload);
             //return $q.resolve({"returnCode":0,"response":{"payCash":true,"orderNumber":"376649","splits":[{"splitLabel":"BRUIT MOTEUR (DIAGNOSTIC)","splitId":"A"},{"splitLabel":"BRUIT MOTEUR (DIAGNOSTIC)","splitId":"B"}],"isSplittingRequired":true,"isKnown":false,"team":"B","accountNumber":"20999","defaultSplitFlag":2,"customer":{"city":"PARIS","mainPhone":"0154678790","title":"M","bisTer":"","commercialAgreement":false,"poCity":"","streetName":"RUE SUGER","faxAgreement":false,"preferredMedia":0,"countryCode":"FR","fax":"0104040404","email":"test@gmail.com","phoneAgreement":false,"dmsCustomerId":"20999","poBoxNumber":"","address3":"","streetNumber":"10","address2":"","address1":"","provinceCode":"","message":"","emailAgreement":false,"firstName":"HUGO","roadType":"","postAgreement":false,"poPostCode":"","mobilePhone":"0676227948","smsAgreement":false,"name":"DI CESARE","postCode":"75006","workPhone":""},"vehicle":{"bodyType":"","engineNumber":"","paintType":"O","engineType":"D4F","body":"","fabricationNumber":"Y492888","version":"","afterSalesType":"CN0A","gearBoxType":"JB1","energyType":"0","fiscalPower":"00","batteryId2":"","registrationNumber":"BD424XX","batteryId1":"","vin":"VF1CNBA0544210258","model":"","colorCode":"","deliveryDate":"","brand":"REN","gearBoxNumber":"S170247","mileage":1000}}});
            // return $q.resolve({"returnCode":0,"response":{"payCash":true,"orderNumber":"376718","splits":[{"splitLabel":"BRUIT: BOITE DE VITESSE","splitId":"B"}],"isSplittingRequired":true,"isKnown":true,"team":"A","accountNumber":"429261","defaultSplitFlag":2,"customer":{"city":"BOUXIERES AUX DAMES","mainPhone":"0383227285","title":"M","bisTer":"","commercialAgreement":false,"poCity":"","streetName":"RUE DES DAMES CHANOINESSES","faxAgreement":false,"preferredMedia":0,"countryCode":"FR","fax":"","email":"","phoneAgreement":false,"dmsCustomerId":"429261","poBoxNumber":"","address3":"","streetNumber":"13","address2":"","address1":"","provinceCode":"","message":"","emailAgreement":false,"firstName":"PIERRE","roadType":"","postAgreement":false,"poPostCode":"","mobilePhone":"0668456782","smsAgreement":false,"name":"CORDIER","postCode":"54136","workPhone":""},"vehicle":{"bodyType":"","engineNumber":"","paintType":"V","engineType":"","body":"","fabricationNumber":"T008787","version":"","afterSalesType":"JE0P","gearBoxType":"","energyType":"2","fiscalPower":"07","batteryId2":"","registrationNumber":"154BCW78","batteryId1":"","vin":"VF111111111111111","model":"ESA","colorCode":"408","deliveryDate":"20000327","brand":"REN","gearBoxNumber":"","mileage":17406}}})
        }

        function getVehicle(payload) {
            return callDms(DmsConstants.vehicleDmsUrl, payload);
        }

        function calculQuote(payload) {
            return callDms(DmsConstants.estimateDmsUrl, payload,DmsErrorConstants.quotationErrors);
            // return $q.resolve({"returnCode":8,"response":{"totalPaintAmount":0.0,"labourTimes":{"total":{"total":35.04,"exclTaxes":29.21,"taxes":5.83,"basis":29.21},"detail":[{"amount":{"total":8.72,"exclTaxes":7.27,"taxes":1.45,"basis":7.27},"code":"0068"},{"amount":{"total":8.72,"exclTaxes":7.27,"taxes":1.45,"basis":7.27},"code":"0014"},{"amount":{"total":17.46,"exclTaxes":14.55,"taxes":2.91,"basis":14.55},"code":"2428"},{"amount":{"total":0.14,"exclTaxes":0.12,"taxes":0.02,"basis":0.12},"code":"DECH"}]},"dmsEstimateId":"121749","parts":{"total":{"total":41.27,"exclTaxes":34.39,"taxes":6.88,"basis":34.39},"detail":[{"reference":"8200257642","amount":{"total":33.55,"exclTaxes":27.96,"taxes":5.59,"basis":27.96}},{"reference":"8200702754","amount":{"total":7.72,"exclTaxes":6.43,"taxes":1.29,"basis":6.43}}]},"estimate":{"total":76.32,"exclTaxes":63.6,"taxes":12.72,"basis":63.6},"recycling":{"total":0.14,"exclTaxes":0.12},"paintTime":0},"message":" Tout travail fini exceptÃ© l'Ã©dition"});
        }


        function getHourlyRates(payload) {
            return callDms(DmsConstants.hourlyRatesUrl, payload);
            // return $q.resolve({"returnCode":0,"response":{"bodyWorkHourlyRate":74.16,"veryHightTechMechHourlyRate":74.16,"paintIncluded":false,"veryHightTechBodyWHourlyRate":74.16,"mechanicalHourlyRate":74.16,"paintWorkHourlyRate":74.16,"hightTechMechHourlyRate":74.16,"hightTechPaintWHourlyRate":74.16,"hightTechBodyWHourlyRate":74.16,"veryHightTechPaintWHourlyRate":74.16}});
        }

        function dmsApiCall(endpoint, url, payload, timeoutDMS) {
            var isApigeeDmsUrl = endpoint.includes(DmsConstants.apigeeQaUrl) || endpoint.includes(DmsConstants.apigeeUrl)  || endpoint.includes(DmsConstants.apigeeQaOktaUrl) || endpoint.includes(DmsConstants.apigeeOktaUrl);           
            var isRdcsDms = CacheService.getObject(CacheConstants.isRdcsDms);
            var isRdcsEnable = JSON.parse(configConstantes.isRdcsEnable);

            if ((isRdcsEnable && (isRdcsDms || isApigeeDmsUrl)) || (!isRdcsEnable && isApigeeDmsUrl)) {

                var requestUrl = DmsConstants.baseDmsApigee;
                var dealerId;
                if (payload.dealerId) {
                    dealerId = payload.dealerId;
                    delete payload['dealerId'];
                } else {
                    var userProfil = CacheService.getUserProfile();
                    dealerId = userProfil.dealerId;
                }
                
              switch (url) {
                    case DmsConstants.accountDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.customers + DmsConstants.baseDealers + dealerId 
                      +'/'+ DmsConstants.rdcsUrl.account;
                        break;
                    case DmsConstants.customersDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.customers + DmsConstants.baseDealers + dealerId +'/' +DmsConstants.rdcsUrl.customers;
                        break;
                    case DmsConstants.estimateDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.estimates + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.estimates;
                        break;
                    case DmsConstants.partsDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.parts + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.parts;
                        break;
                    case DmsConstants.referencesDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.reference + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.reference;
                        break;
                    case DmsConstants.vehicleDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.vehicles + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.vehicle;
                        break;
                    case DmsConstants.hourlyRatesUrl:
                      requestUrl += DmsConstants.rdcsUrl.hourly_rates + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.hourlyrates;
                        break;
                    case DmsConstants.orderDmsUrl:
                      requestUrl += DmsConstants.rdcsUrl.orders + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.order;
                        break;
                    case DmsConstants.quotePartsUrl:
                      requestUrl += DmsConstants.rdcsUrl.quoteParts + DmsConstants.baseDealers + dealerId + '/' + DmsConstants.rdcsUrl.quoteParts;
                        break;
                }

                return RestUpgrade.all(requestUrl).post(payload).then(function (response) {
                    return response;
                })
            } else {
                return $http.post(endpoint + url, payload, {
                    'headers': {
                        'Content-Type': 'text/plain; charset=UTF-8'
                    },

                    timeout: timeoutDMS
                }).then(function (response) {
                    return response;
                })
            }
        }

        //can use it for mock the service
        //res.data={"returnCode":1,"message":"‘siteId’ code not entered"};
        function callDms(url, payload,errorCodes) {
            var user = CacheService.getUserProfile();
            var endpoint = user.dmsConfig.url;
            var timeoutDMS ;
            //increase timeout to 2 mins for estiamte.v1
            if(url === DmsConstants.estimateDmsUrl){
                timeoutDMS = 120000;
            }else{
                timeoutDMS = 30000;
            }
            if (!endpoint) {
                return $q.resolve({
                    returnCode: code.forbidden,
                    message: 'Some error occurred'
                });
            }
            return dmsApiCall(endpoint, url, payload, timeoutDMS).then(function (response) {
                var res = {};
                res.data = response.data ? response.data : response;
                if(errorCodes){
                    var isKnownError = _.find(errorCodes, function(item){
                        return item.returnCode === res.data.returnCode;
                    });
                }

                if (res.data.returnCode === 0) {
                    return res.data;
                }else if(isKnownError){
                    if(res.data.returnCode === 8){
                        return $q.resolve(res);
                    }else{
                        _.assign(res.data,{
                            message: $translate.instant(isKnownError.message) 
                        })
                        return $q.reject(res);
                    }
                } else {

                    if(url === DmsConstants.vehicleDmsUrl && res.data.returnCode === 2000){
                        toastr.error($translate.instant('DMS_' + res.data.returnCode));
                        return $q.resolve(res);
                    }

                    if (res.data.returnCode == 1 || res.data.returnCode == 2)
                        return $q.resolve(res);
                    else
                        return $q.reject(res);
                }
            }).catch(function (err) {
                if (err.status == 200) {
                    if($translate.instant('DMS_'+err.data.returnCode) != 'DMS_'+err.data.returnCode)
                        toastr.error($translate.instant('DMS_' + err.data.returnCode));
                    else
                        toastr.error(err.data.message);
                    return $q.reject(err);
                } else {
                    toastr.error($translate.instant('DMS_ERROR_TIMEOUT'));
                    return $q.reject(err);
                }
            })
        }

    }
})();

(function () {
    "use strict";

    angular.module("phenix").service("DmsMetierService", DmsMetierService);

    /** @ngInject */
    function DmsMetierService(
        $q,

        CacheService,
        DmsWsService,
        DealerManagerSystemeService,

        QuoteConstants,
        QuoteEndpointConstant,
        DmsConstants,
        CacheConstants, toastr,
        $translate) {

        var selectedSuperseeding = [];
        this.getReferencesDms = getReferencesDms;
        this.sendBstoDms = sendBstoDms;
        this.matchReferenceFromDms = matchReferenceFromDms;
        this.addDmsInformationToCurrentPiece = addDmsInformationToCurrentPiece;
        this.getReferencesFromListPiece = getReferencesFromListPiece;
        this.buildDataFromDms = buildDataFromDms;
        this.getUsersListByCustomers = getUsersListByCustomers;
        this.getUserByAccount = getUserByAccount;
        this.getOrderByNumber = getOrderByNumber;
        this.calculQuote = calculQuote;
        this.getVehicleByVin = getVehicleByVin;
        this.getVehicleByRegistrationNumber = getVehicleByRegistrationNumber;
        this.getHourlyRatesLogic = getHourlyRatesLogic;
        this.initPayload = initPayload;
        this.getCustomers = getCustomers;
        this.getAwaitingParts = getAwaitingParts;
        this.getSupersedingList = getSupersedingList;
        this.matchReferenceFromDmsforSuperSeding = matchReferenceFromDmsforSuperSeding;
        this.addDmsInformationforSuperSeding = addDmsInformationforSuperSeding;
        this.getNoLocalStockSupersedingList = getNoLocalStockSupersedingList;
        this.matchReferenceFromR2AforSuperSeding = matchReferenceFromR2AforSuperSeding;
        this.getAllReferencesForStock = getAllReferencesForStock;
        this.attachCentralStockInfo = attachCentralStockInfo;
        this.calculateFodEstimate = calculateFodEstimate;

        /*=============================================
        =                FUNCTIONS                    =
        =============================================*/

        /**
         * @desc Function which provide the list of references of each plates (even additional and alternative)
         * @param {*Array} listOfPieces list of pieces of the current plate
         */
        function getReferencesFromListPiece(listOfPieces, type) {
            var references = [];
            angular.forEach(listOfPieces, function (value) {
                var PrOrTmReference = value.opecod ? value.opecod : value.reference;
                references.push(PrOrTmReference);
                if (value.alternative && value.alternative.length) {
                    angular.forEach(value.alternative, function (
                        alternativeValue
                    ) {
                        references.push(alternativeValue.reference);

                        angular.forEach(alternativeValue.alternative, function (
                            alternativeItem
                        ) {
                            references.push(alternativeItem.reference);
                        });

                        angular.forEach(alternativeValue.additional, function (
                            additionalItem
                        ) {
                            references.push(additionalItem.reference);
                        });
                    });
                }
                if (value.additional && value.additional.length) {
                    angular.forEach(value.additional, function (
                        additionalValue
                    ) {
                        references.push(additionalValue.reference);
                        var temp = [];
                        temp.push(additionalValue);
                        if (!type) {
                            getReferencesFromListPiece(temp, "pps");
                        }
                    });
                }
            });
            return references;
        }

        /**
         * @desc Function which provide the list of references of each plates based on supersedinglist (even additional and alternative)
         * @param {*Array} listOfPieces list of pieces of the current plate
         */
        function getSupersedingList(listOfPieces){
            var references = [];
            angular.forEach(listOfPieces, function (value) {
                if (value.supersedingList != null){
                    angular.forEach(value.supersedingList, function(list){
                        references.push(list);
                    })
                }
                else{
                    references.push(value.reference);
                }
                if (value.alternative && value.alternative.length) {
                    angular.forEach(value.alternative, function (
                        alternativeValue
                    ) {
                        if (alternativeValue.supersedingList != null){
                            angular.forEach(alternativeValue.supersedingList, function(list){
                                references.push(list);
                            })
                        }
                        else{
                            references.push(alternativeValue.reference);
                        }

                        angular.forEach(alternativeValue.additional, function (
                            additionalItem
                        ) {
                            if (additionalItem.supersedingList != null){
                                angular.forEach(additionalItem.supersedingList, function(list){
                                    references.push(list);
                                })
                                
                            }
                            else{
                                references.push(additionalItem.reference);
                            }
                            
                        });
                    });
                }
                if (value.additional && value.additional.length) {
                    angular.forEach(value.additional, function (
                        additionalValue
                    ) {
                        if (additionalValue.supersedingList != null){
                            references.push(additionalValue.supersedingList);
                        }
                        else{
                            references.push(additionalValue.reference);
                        }
                        
                    });
                }
            });
            return references;

        }
        function getNoLocalStockSupersedingList(listOfPieces){

            var references = [];
            angular.forEach(listOfPieces, function (value) {
                if (!_.isEmpty(value.supersedingList) && value.dmsInformations.quantity < 1 ){
                    angular.forEach(value.supersedingList, function(ref){                  
                        references.push({reference:ref, quantity: 1});
                    })
                }
                if (!_.isEmpty(value.alternative)) {
                    angular.forEach(value.alternative, function (alternativeValue){
                        if (!_.isEmpty(alternativeValue.supersedingList) && alternativeValue.dmsInformations.quantity < 1){
                            angular.forEach(alternativeValue.supersedingList, function(ref){
                                references.push({reference:ref, quantity: 1});
                            })
                        }
                        angular.forEach(alternativeValue.additional, function (additionalItem){
                            if (!_.isEmpty(additionalItem.supersedingList) && additionalItem.dmsInformations.quantity < 1){
                                angular.forEach(additionalItem.supersedingList, function(ref){
                                    references.push({reference:ref, quantity: 1});
                                })                                
                            }
                        });
                    });
                }
                if (!_.isEmpty(value.additional)) {
                    angular.forEach(value.additional, function (additionalValue){
                        if (!_.isEmpty(additionalValue.supersedingList) && additionalValue.dmsInformations.quantity < 1){
                            angular.forEach(additionalValue.supersedingList, function(ref){
                                references.push( { reference:ref, quantity: 1});
                            })
                        }
                    });
                }
            });
            return references;
        }
        

        function getAllReferencesForStock(listOfPieces, quantityByRef){
            var references = [];
            function pushRef(ref){
                if (ref) {
                    var qty = quantityByRef && quantityByRef[ref];
                    references.push({ reference: ref, quantity: qty > 0 ? qty : 1 });
                }
            }
            function pushPart(part){
                if (!part) { return; }
                pushRef(part.reference);
                if (!_.isEmpty(part.supersedingList)) {
                    angular.forEach(part.supersedingList, pushRef);
                }
            }
            angular.forEach(listOfPieces, function (piece) {
                pushPart(piece);
                angular.forEach(piece.additional, pushPart);
                angular.forEach(piece.alternative, function (alt) {
                    pushPart(alt);
                    angular.forEach(alt.additional, pushPart);
                });
            });
            return _.uniqWith(references, _.isEqual);
        }

        function attachCentralStockInfo(listOfPieces, r2aResponse, isDmsUser, onlyMatching){
            if (!r2aResponse || _.isEmpty(r2aResponse.products)) { return; }
            var productsByRef = _.keyBy(r2aResponse.products, 'reference');

            function setCentralStockOnPart(part){
                if (!part || !part.reference) { return; }
                var product = productsByRef[part.reference];
                if (onlyMatching && !product) { return; }
                var myStockQty = isDmsUser && part.dmsInformations ? part.dmsInformations.quantity : null;
                part.centralStock = buildCentralStockView(product, myStockQty, isDmsUser);
            }

            angular.forEach(listOfPieces, function (piece) {
                setCentralStockOnPart(piece);
                angular.forEach(piece.additional, setCentralStockOnPart);
                angular.forEach(piece.alternative, function (alt) {
                    setCentralStockOnPart(alt);
                    angular.forEach(alt.additional, setCentralStockOnPart);
                });
            });
        }

        function buildCentralStockView(product, myStockQty, isDmsUser){
            var tooltipLines = [];
            var hasMyStock = isDmsUser && _.isNumber(myStockQty);

            if (hasMyStock) {
                tooltipLines.push({ iconKey: 'MY_STOCK', tooltipKey: 'MY_STOCK_TOOLTIP', qty: myStockQty });
            }

            var warehouses = product && product.warehouses;
            var isOkResponse = product && product.itemReturnCode === 'A000';

            if (!isOkResponse || _.isEmpty(warehouses)) {
                return {
                    iconKey: 'NO_INFO',
                    tooltipLines: tooltipLines.concat([{ tooltipKey: 'NO_STOCK_INFO_AVAILABLE' }])
                };
            }

            var allZero = _.every(warehouses, function (w) { return !w.confirmedQuantity; });
            if (allZero) {
                return {
                    iconKey: 'OUT_OF_STOCK',
                    tooltipLines: tooltipLines.concat([{ iconKey: 'OUT_OF_STOCK', tooltipKey: 'CURRENTLY_OUT_OF_STOCK' }])
                };
            }

            var canonicalOrder = ['LOCAL', 'REGION', 'COUNTRY', 'CENTRAL', 'WW', 'DELAYED'];
            angular.forEach(canonicalOrder, function (type) {
                var w = _.find(warehouses, function (x) { return (x.type || '').toUpperCase() === type; });
                if (!w) { return; }
                var entry = getCentralStockDisplayEntry(type);
                if (!entry) { return; }
                var line = buildTooltipLineForWarehouse(type, w, entry);
                if (line) { tooltipLines.push(line); }
            });

            var farthest = getFarthestFulfillingWarehouse(warehouses);
            var display = getCentralStockDisplayEntry((farthest.type || '').toUpperCase());
            return {
                iconKey: display ? display.iconKey : 'NO_INFO',
                tooltipLines: tooltipLines
            };
        }

        function getFarthestFulfillingWarehouse(warehouses){
            var contributing = _.filter(warehouses, function (w) { return w.confirmedQuantity > 0; });
            var candidates = contributing.length ? contributing : warehouses;
            var farthest = candidates[0];
            var farthestOrder = _.isNumber(farthest.order) ? farthest.order : 0;
            angular.forEach(candidates, function (w, index) {
                var order = _.isNumber(w.order) ? w.order : index;
                if (order >= farthestOrder) {
                    farthestOrder = order;
                    farthest = w;
                }
            });
            return farthest;
        }

        function getCentralStockDisplayEntry(warehouseType){
            var map = {
                LOCAL:   { iconKey: 'R1',       tooltipKey: 'R1_STOCK_TOOLTIP' },
                REGION:  { iconKey: 'REGIONAL', tooltipKey: 'REGIONAL_STOCK_TOOLTIP' },
                CENTRAL: { iconKey: 'CENTRAL',  tooltipKey: 'CENTRAL_STOCK_TOOLTIP' },
                COUNTRY: { iconKey: 'COUNTRY',  tooltipKey: 'COUNTRY_STOCK_TOOLTIP' },
                WW:      { iconKey: 'WW',       tooltipKey: 'WORLDWIDE_STOCK_TOOLTIP' },
                DELAYED: { iconKey: 'RESTOCKING', tooltipKey: 'RESTOCKING_TOOLTIP' }
            };
            return map[warehouseType] || null;
        }

        function buildTooltipLineForWarehouse(type, warehouse, entry) {
            var confirmed = warehouse.confirmedQuantity;
            var available = warehouse.availableQuantity;
            var hasConfirmed = _.isNumber(confirmed) && confirmed > 0;
            var qtyUnknown = available === -1 || !_.isNumber(available);

            if (type === 'CENTRAL' && hasConfirmed && qtyUnknown) {
                return { iconKey: entry.iconKey, tooltipKey: 'CENTRAL_STOCK_IN_STOCK_TOOLTIP' };
            }
            var qty = _.isNumber(available) && available >= 0
                ? available
                : (_.isNumber(confirmed) ? confirmed : null);
            return { iconKey: entry.iconKey, tooltipKey: entry.tooltipKey, qty: qty };
        }

        /**
         * @name calculQuote
         * @desc function which call the estimate dms service in order to return the total taxes of items sent. It may be return an additional list of items
         * @param {*} quote represents the vm.quote object in quote controlleur
         * @param {*} customer  is the customer selected
         * @param {*} workFlag the estimate dms service need a workflag in order to select what kind of calculation (1 - simple calculation,  2 -  Calculation + automatic editing + validation)
         */
        function calculQuote(quote, customer, workFlag, dmsLoginInformations, type) {
            var profile = CacheService.getObject(CacheConstants.profil);
            var paintType;
            var items = [];
            if (type == "INT") {
                quote.inter.forEach(function (item) {
                    item.PR.forEach(function (list) {
                        if(list.quantity > 0)
                            items.push(list);
                    })
                    item.TM.forEach(function (list) {
                        items.push(list);
                    })
                })

                items = getStructuredItems(items);

            }
            else if (type == "PRTM") {
                items = getStructuredItems(quote.items);
            }
            else if (type == "ALL") {
                quote.inter.forEach(function (item) {
                    item.PR.forEach(function (list) {
                        if(list.quantity > 0)
                            items.push(list);
                    })
                    item.TM.forEach(function (list) {
                        items.push(list);
                    })
                })
                quote.items.forEach(function (list) {
                    items.push(list);
                })
                items = getStructuredItems(items);
            }
            var payload = {
                items: items,
                userDms: profile.dmsConfig.userDmsId,
                ipn: profile.ipn,
                dealerId: profile.dealerId,
                workshopPartshopId: profile.dmsConfig.workshopPartshopId,
                userId: dmsLoginInformations.username,
                userPassword: dmsLoginInformations.password,
                accountNumber: customer.accountNumber,
                clientEstimateId: quote.number,
                activityId: getWorkshopPartShopNumber(
                    profile.dmsConfig.networkProfile
                ),
                customer: _.omit(customer, 'accountNumber'),
                text: quote.mentions,
                workFlag: workFlag || 1
            };

            //add customer category if exist
            if (quote.userScale) {
                _.extend(payload, {
                    customerType: quote.userScale
                });
            }

            //add vin to if exist
            if (quote.vin) {
                payload.vin = quote.vin;
            }

            //add registrationNumber if exist
            if (quote.registrationNumber) {
                payload.registrationNumber = quote.registrationNumber;
            }

            // in case of workshop, add mileAge and order number if exist
            if (profile && DealerManagerSystemeService.isWorkshop(profile)) {
                //parsing mileage to integer as per DMS CLA
                if (quote.mileAge || quote.mileAge === '0' || quote.mileAge === 0) {
                    payload.mileage = typeof quote.mileAge !== 'number' ? parseInt(quote.mileAge) : quote.mileAge;
                }
                if (quote.orderNumber) {
                    payload.orderNumber = quote.orderNumber;
                }
            }

            //add paintType if exist
            if (quote && quote.paintType) {
                paintType = quote.paintType;
                _.extend(payload, { paintType: paintType });
            }

            //add order number if exist
            if (quote.orderNumber) {
                payload.orderNumber = quote.orderNumber;
            }

            return DmsWsService.calculQuote(payload).then(function (response) {
                var calResp;
                if (response.data)
                    calResp = response.data;
                else
                    calResp = response;
           
                return calResp;
            })

        }

        function calculateFodEstimate(enabledParts, enabledTm, customer) {
            var user = CacheService.getUserProfile();
            var carContext = CacheService.getCarContext();
            customer = customer || (carContext && carContext.customer) || {};
            var payload = initPayload();
            payload.activityId = (user && user.dmsConfig && user.dmsConfig.networkProfile === QuoteEndpointConstant.workshop) ? 0 : 1;
            payload.clientEstimateId = 'FOD00000';
            payload.workFlag = 1;
            payload.accountNumber = customer.accountNumber || customer.dmsCustomerId || '';
            payload.customer = _.omit(customer, 'accountNumber');
            payload.vin = carContext && carContext.vin ? carContext.vin : '';
            var prItems = _.filter(enabledParts, function (p) { return p.quantity > 0; }).map(function (part) {
                var isKnown = part.dmsInformations && part.dmsInformations.isKnowFromDms;
                if (isKnown) {
                    return { type: 'R', reference: part.reference, quantity: part.quantity };
                }
                return { type: 'X', reference: part.reference, quantity: part.quantity, priceExclTaxes: '', description: part.designation || '' };
            });
            var tmItems = (enabledTm && enabledTm.length)
                ? _.filter(enabledTm, function (tm) { return tm.opecod; }).map(buildStructureOfTM)
                : [];
            payload.items = prItems.concat(tmItems);
            return DmsWsService.calculQuote(payload).then(function (response) {
                return response.data ? response.data : response;
            });
        }

        /**
         * @desc provide the list of references which come from the DMS
         * @param {*Array} reference list of references from a plate
         */
        function getReferencesDms(reference) {
            var payload = initPayload();
            payload.references = reference;
            return DmsWsService.getReferencesDms(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.info($translate.instant('DMS_REFERENCE_' + response.data.returnCode));
                return response;
            })
        }
        /**
         * @desc provide the list of references which come from the DMS
         * @param {*Array} reference list of references from a plate
         */
        function getAwaitingParts(or) {
            var payload = initPayload();
            payload.orderNumber = or;
            return DmsWsService.getAwaitingParts(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.error(response.data.message);
                return response;
            })
        }

        function getHourlyRatesLogic() {
            var payload = initPayload();
            return DmsWsService.getHourlyRates(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.error(response.data.message);
                return response;
            })
        }

        /**
         * @desc provide the list of references which come from the DMS
         */

        function sendBstoDms(networkProfile, customer, partsRequisition) {
            var payload = initPayload();
            if (networkProfile === "WORKSHOP") {
                networkProfile = 0;
            } else {
                networkProfile = 1;
            }

            payload.activityId = networkProfile;
            if (partsRequisition.orderNumber && networkProfile === 0) {
                payload.orderNumber = partsRequisition.orderNumber;
            }

            payload.clientPartListId = partsRequisition.number;

            //bugPPX1863 : adding registrationNumber and VIN to part requisition request and commenting VIN because not in CLA

            // payload.vin = partsRequisition.vin;
            payload.registrationNumber = partsRequisition.registrationNumber;

            //set user informations (id, password)
            payload.userId = partsRequisition.dmsLoginInformations.username;
            payload.userPassword = partsRequisition.dmsLoginInformations.password;

            if (customer) {
                payload.accountNumber = customer.accountNumber;
                payload.customer = _.omit(customer, 'accountNumber');
            }

            if (partsRequisition) {
                payload.items = [];
                if (partsRequisition.description) {
                    payload.text = partsRequisition.description;
                }
                angular.forEach(partsRequisition.items, function (value) {
                    var discountType = 0;
                    if (value.additionalDiscount) {
                        discountType = 2;
                    } else {
                        value.additionalDiscount = 0;
                    }
                    var item = {
                        reference: value.reference,
                        quantity: value.quantity,
                        discountType: discountType,
                        discount: value.additionalDiscount,
                        isUnusualSale: value.unusualSale,
                        // orderType ne prend que les valeurs entre 0 - 4
                        // mais notre liste à 1 - 5, hot fix pour eviter les regressions du aux
                        // regressions que ca impliquerait de changer les id
                        orderType: value.orderType === 0 ? 2 : value.orderType - 1
                    }
                    if (value.designation) {
                        _.extend(item, { "description": value.designation })
                    }
                    if (value.price) {
                        _.extend(item, { "priceExclTaxes": value.price })
                    }
                    if (value.interventionId) {
                        _.extend(item, { "splitId": value.interventionId })
                    }

                    if (value.lineNumber) {
                        _.extend(item, { "lineNumber": value.lineNumber })
                    }
                    if (value.dmsInformation) {
                        _.extend(item, {
                            availabilities: [
                                {
                                    stockId: value.dmsInformations.stockId,
                                    stockLabel: value.dmsInformations.stockLabel,
                                    siteId: value.dmsInformations.siteId,
                                    siteLabel: value.dmsInformations.siteLabel,
                                    quantity: value.dmsInformations.quantity,
                                    location: value.dmsInformations.location,
                                }
                            ]
                        })
                    }

                    payload.items.push(item);

                });
            }
            return DmsWsService.sendBstoDms(payload)
                // BADFIX TODO remove when Sirvza Dms repect the CLA
                .catch(function (error) {
                    // retry call to dms if error is 1035
                    if (error.data.returnCode == "1035") {
                        // parse clientPartListId to integer before
                        payload.clientPartListId = parseInt(partsRequisition.number.substring(2));
                        return DmsWsService.sendBstoDms(payload);
                    } 
                    return error;                    
                })
                // End of BADFIX TODO remove when Sirvza Dms repect the CLA
                .then(function (response) {
                    return response;
                });
        }

        /**
         * POST
         * @param paramsRequest
         * @returns {promise}
         */
        function getUserByAccount(client) {
            var payload = initPayload();
            payload.accountNumber = client.accountNumber;
            return DmsWsService.getUserByAccount(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2)) {
                    toastr.error($translate.instant('DMS_ACCOUNT_' + response.data.returnCode));
                } else if (response.response && response.response.customer) {
                    response.response.customer.accountNumber = client.accountNumber;
                } else {
                    // unexpected/forbidden response shape (e.g. missing dmsConfig) -> surface instead of throwing
                    toastr.error($translate.instant('PART_REQUISITION_ERROR_DISPLAY_CUSTOMER_INFORMATIONS'));
                }
                return response;
            });
        }

        /**
         * @desc provide OR from DMS by documentNumber
         * @param {*Array} documentNumber number of OR
         * @returns {promise}
         */
        function getOrderByNumber(documentNumber) {
            var payload = initPayload();
            payload.documentNumber = documentNumber;
            return DmsWsService.getOrderByNumber(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.error($translate.instant('DMS_ORDER_' + response.data.returnCode));
                return response;
            });
        }

        /**
         * @desc provide Vehicle from DMS by VIN
         * @param {*String} vin vin of vehcile
         * @returns {promise}
         */
        function getVehicleByVin(vin) {
            var payload = initPayload();
            payload.vin = vin;
            return DmsWsService.getVehicle(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.info($translate.instant('DMS_VEHICLE_' + response.data.returnCode));
                return response;
            })
        }

        /**
         * @desc provide vehicle from DMS by registrationNumber
         * @param {*String} registartionNumber registrationNumber of vehcile
         * @returns {promise}
         */
        function getVehicleByRegistrationNumber(registrationNumber) {
            var payload = initPayload();
            payload.registrationNumber = registrationNumber;
            return DmsWsService.getVehicle(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.info($translate.instant('DMS_VEHICLE_' + response.data.returnCode));
                return response;
            });
        }

        /**
         * POST
         * @param paramsRequest
         * @returns {promise}
         */
        function getUsersListByCustomers(client) {
            // customers.v1 does not filter by accountNumber alone, so use account.v1 instead
            if (client.accountNumber && !client.name && !client.firstName) {
                return getUserByAccount(client).then(function (response) {
                    var customer = response.response && response.response.customer;
                    response.response = {
                        customers: customer ? [customer] : [],
                        numberOfCustomers: customer ? 1 : 0
                    };
                    return response;
                });
            }

            var payload = initPayload();

            if (client.name) {
                payload.name = client.name;
            }
            if (client.firstName) {
                payload.firstName = client.firstName;
            }
            if (client.accountNumber) {
                payload.accountNumber = client.accountNumber;
            }
            payload.index = client.index;

            return DmsWsService.getUsersListByCustomers(payload).then(function (response) {
                if (response.data && (response.data.returnCode == 1 || response.data.returnCode == 2))
                    toastr.error($translate.instant('DMS_CUSTOMER_' + response.data.returnCode));
                return response;
            });
        }

        /**
         *      @desc   fetch customers from DMS
         *              This service has a pagination
         *      @param {object} customer {
         *          name        : string,
         *          firstName*  : string
         *      }
         *      @param {number} page
         *      @return {promise<Object>} {
         *          numberOfCustomers: number
         *          customers: [{
         *                  accountNumber:  string
         *                  name:           string
         *                  firstName*:      string
         *                  customerId      string
         *                  vehicles* : {
         *                      registrationNumber*:  string
         *                      vin*:                 string
         *                  }
         *          }]
         *      }
         *      * optional
         */
        function getCustomers(customer, page) {
            var payload = initPayload();

            if (customer.name) {
                _.extend(payload, {
                    name: customer.name
                })
            }

            if (customer.firstName) {
                _.extend(payload, {
                    firstName: customer.firstName
                })
            }

            _.extend(payload, {
                index: page,
                maximumNumber: 10
            });

            return DmsWsService.getCustomers(payload).then(function (res) {
                if (!res) {
                    return $q.reject(DmsConstants.errors.EMPTY_RESPONSE);
                }
                var error = res.returnCode;
                if (error) {
                    return $q.reject(DmsConstants.errors.NO_CUSTOMERS);
                }
                if (res.data && (res.data.returnCode == 1 || res.data.returnCode == 2))
                    toastr.error($translate.instant('DMS_CUSTOMER_' + res.data.returnCode));
                return res.response;
            });
        }

        function initPayload() {
            var user = CacheService.getUserProfile();
            var dms = user.dmsConfig || {};
            var payload = {
                userDms: dms.userDmsId,
                ipn: user.ipn,
                dealerId: user.dealerId,
                workshopPartshopId: dms.workshopPartshopId
            };
            return payload;
        }

        /**
         * @desc build object dmsData with value provided in DMS
         * @param {*} parts list of references which come from the DMS
         */
        function buildDataFromDms(parts) {
            var businessDataFromDms = [];
            if (parts) {
                angular.forEach(parts, function (dmsValue) {
                    var dmsData = {};
                    dmsData.cort = "-";

                    dmsData.description = dmsValue.description;
                    dmsData.reference = dmsValue.reference;
                    dmsData.priceExclTaxes = dmsValue.priceExclTaxes;

                    dmsData.status = dmsValue.status;
                    if (dmsData.status == 2) {
                        dmsData.stockQuantity = 0;
                    }
                    if (dmsValue.cort) {
                        dmsData.cort = dmsValue.cort[2];
                    }

                    if (!_.isEmpty(dmsValue.supersedingPart)) {
                        dmsData.supersedingPart = dmsValue.supersedingPart;
                    }

                    if (
                        dmsValue.availabilities &&
                        dmsValue.availabilities.length > 0
                    ) {
                        var availabilities = dmsValue.availabilities[0];
                        if (availabilities) {
                            dmsData.stockQuantity = availabilities.quantity;
                            dmsData.stockId = availabilities.stockId;
                            dmsData.siteId = availabilities.siteId;
                            dmsData.stockLabel = availabilities.stockLabel;
                            dmsData.siteLabel = availabilities.siteLabel;
                            dmsData.location = availabilities.location;
                        }

                    }

                    businessDataFromDms.push(dmsData);
                });
            }
            return businessDataFromDms;

        }

        /**
         * @desc Match the reference of a plate with the reference of the DMS (reference.v1 response),
         * if current reference exist in reference.v1 response, we add dmsInformations object
         * @param {*} listOfPieces list of pieces of the current plate
         * @param {*} referenceFromDms list of references which come from the DMS
         */
        function matchReferenceFromDms(listOfPieces, referenceFromDms) {
            //parse list of pieces
            angular.forEach(listOfPieces, function (currentPiece) {
                //add dms informations object for the current piece if exist
                addDmsInformationToCurrentPiece(currentPiece, referenceFromDms);

                //parse alternative
                if (currentPiece.alternative && currentPiece.alternative.length) {
                    angular.forEach(currentPiece.alternative, function (currentAlternativePiece) {

                        //parse alternative of current alternative if exist
                        angular.forEach(currentAlternativePiece.alternative, function (alternativeItem) {
                            //add dms informations object for the current alternative of alternative piece if exist
                            addDmsInformationToCurrentPiece(alternativeItem, referenceFromDms);
                        });

                        //add dms informations object for the current additional of alternative piece if exist
                        angular.forEach(currentAlternativePiece.additional, function (additionalItem) {
                            addDmsInformationToCurrentPiece(additionalItem, referenceFromDms);
                        });

                        //add dms informations object for the current alternative piece if exist
                        addDmsInformationToCurrentPiece(currentAlternativePiece, referenceFromDms);
                    });
                }

                //parse additional
                if (currentPiece.additional && currentPiece.additional.length) {

                    angular.forEach(currentPiece.additional, function (currentAdditionalPiece) {

                        //parse alternative of current additional piece if exist
                        angular.forEach(currentAdditionalPiece.alternative, function (alternativeItem) {
                            //add dms informations object for the current alternative of additional piece if exist
                            addDmsInformationToCurrentPiece(alternativeItem, referenceFromDms);
                        });

                        //parse additional of current additional piece if exist
                        angular.forEach(currentAdditionalPiece.additional, function (additionalItem) {
                            //add dms informations object for the current additional of additional piece if exist
                            addDmsInformationToCurrentPiece(additionalItem, referenceFromDms);
                        });

                        //add dms informations object for the current additional piece if exist
                        addDmsInformationToCurrentPiece(currentAdditionalPiece, referenceFromDms);
                    });
                }
            });
        } 
        
        /**
         * @desc Match the reference of a plate with the reference of the DMS (reference.v1 response),
         * if current reference exist in reference.v1 response, we add dmsInformations object
         * @param {*} listOfPieces list of pieces of the current plate
         * @param {*} referenceFromDms list of references which come from the DMS
         */
        function matchReferenceFromDmsforSuperSeding(listOfPieces, referenceFromDms) {
            //parse list of pieces
            angular.forEach(listOfPieces, function (currentPiece) {
                //add dms informations object for the current piece if exist
                addDmsInformationforSuperSeding(currentPiece, referenceFromDms);

                //parse alternative
                if (currentPiece.alternative && currentPiece.alternative.length) {
                    angular.forEach(currentPiece.alternative, function (currentAlternativePiece) {
                        //add dms informations object for the current alternative piece if exist
                        addDmsInformationforSuperSeding(currentAlternativePiece, referenceFromDms);
                    });
                }

                //parse additional
                if (currentPiece.additional && currentPiece.additional.length) {

                    angular.forEach(currentPiece.additional, function (currentAdditionalPiece) {

                        //add dms informations object for the current additional piece if exist
                        addDmsInformationforSuperSeding(currentAdditionalPiece, referenceFromDms);
                    });
                }
            });
        } 


        /**
         * @desc    add to the current piece dmsInformations object
         *          containing piece's dms response (reference.v1 request)
         * @param {Object} currentPiece the current piece
         * @param {Array<Object>} referenceFromDms reference of a piece from Dms
         */

        function addDmsInformationforSuperSeding(currentPiece, referenceFromDms) {
            var isPriceandStockHigh = false;

            if (currentPiece.supersedingList != null) {
                for (var i = 0; i < currentPiece.supersedingList.length; i++) {
                    var supersedingRef = currentPiece.supersedingList[i];

                    // Find matching DMS value for this superseding reference
                    var dmsValue = _.find(referenceFromDms, function (dms) {
                        return dms.reference === supersedingRef;
                    });

                    if (dmsValue) {
                        if (dmsValue.stockQuantity > 0 && dmsValue.priceExclTaxes > 0 && !isPriceandStockHigh) {
                            isPriceandStockHigh = true;

                            if (dmsValue.priceExclTaxes > 0) {
                                currentPiece.priceExclTaxes = dmsValue.priceExclTaxes;
                            }
                            if (dmsValue.description) {
                                currentPiece.designation = dmsValue.description;
                            }
                            currentPiece.reference = dmsValue.reference;

                            var informationFromDms = {};
                            informationFromDms["isLocalPiece"] = false;

                            informationFromDms["quantity"] = dmsValue.stockQuantity;
                            informationFromDms["priceExclTaxes"] = dmsValue.priceExclTaxes;
                            informationFromDms["location"] = dmsValue.location;
                            informationFromDms["stockId"] = dmsValue.stockId;
                            informationFromDms["siteId"] = dmsValue.siteId;
                            informationFromDms["stockLabel"] = dmsValue.stockLabel;
                            informationFromDms["siteLabel"] = dmsValue.siteLabel;
                            informationFromDms["cort"] = dmsValue.cort;
                            informationFromDms["isKnowFromDms"] = dmsValue.status != 1 ? true : false;

                            if (!_.isEmpty(dmsValue.supersedingPart)) {
                                informationFromDms["supersedingPart"] = dmsValue.supersedingPart;
                            }

                            //we add this proprety to know if we let user to go to product page (if local, he can't)
                            if (dmsValue.reference >= QuoteConstants.localPiece.min && dmsValue.reference <= QuoteConstants.localPiece.max) {
                                informationFromDms["isLocalPiece"] = true;
                            }
                            currentPiece["dmsInformations"] = informationFromDms;

                            return;
                        }
                        else if (dmsValue.stockQuantity < 1 && dmsValue.priceExclTaxes > 0 && !isPriceandStockHigh) {

                            if (dmsValue.priceExclTaxes > 0) {
                                currentPiece.priceExclTaxes = dmsValue.priceExclTaxes;
                            }
                            if (dmsValue.description) {
                                currentPiece.designation = dmsValue.description;
                            }

                            currentPiece.reference = dmsValue.reference;

                            var informationFromDms = {};
                            informationFromDms["isLocalPiece"] = false;

                            informationFromDms["quantity"] = dmsValue.stockQuantity;
                            informationFromDms["priceExclTaxes"] = dmsValue.priceExclTaxes;
                            informationFromDms["location"] = dmsValue.location;
                            informationFromDms["stockId"] = dmsValue.stockId;
                            informationFromDms["siteId"] = dmsValue.siteId;
                            informationFromDms["stockLabel"] = dmsValue.stockLabel;
                            informationFromDms["siteLabel"] = dmsValue.siteLabel;
                            informationFromDms["cort"] = dmsValue.cort;
                            informationFromDms["isKnowFromDms"] = dmsValue.status != 1 ? true : false;

                            if (!_.isEmpty(dmsValue.supersedingPart)) {
                                informationFromDms["supersedingPart"] = dmsValue.supersedingPart;
                            }

                            //we add this proprety to know if we let user to go to product page (if local, he can't)
                            if (dmsValue.reference >= QuoteConstants.localPiece.min && dmsValue.reference <= QuoteConstants.localPiece.max) {
                                informationFromDms["isLocalPiece"] = true;
                            }
                            currentPiece["dmsInformations"] = informationFromDms;
                        }
                    }
                }
            }

            else {
                // Find matching DMS value for current piece reference
                var dmsValue = _.find(referenceFromDms, function (dms) {
                    return dms.reference === currentPiece.reference;
                });

                if (dmsValue) {
                    // override designation when we are connected as dms user
                    if (dmsValue.description) {
                        currentPiece.designation = dmsValue.description;
                    }
                    if (dmsValue.priceExclTaxes > 0) {
                        currentPiece.priceExclTaxes = dmsValue.priceExclTaxes;
                    }

                    var informationFromDms = {};
                    informationFromDms["isLocalPiece"] = false;

                    informationFromDms["quantity"] = dmsValue.stockQuantity;
                    informationFromDms["priceExclTaxes"] = dmsValue.priceExclTaxes;
                    informationFromDms["location"] = dmsValue.location;
                    informationFromDms["stockId"] = dmsValue.stockId;
                    informationFromDms["siteId"] = dmsValue.siteId;
                    informationFromDms["stockLabel"] = dmsValue.stockLabel;
                    informationFromDms["siteLabel"] = dmsValue.siteLabel;
                    informationFromDms["cort"] = dmsValue.cort;
                    informationFromDms["isKnowFromDms"] = dmsValue.status != 1 ? true : false;

                    if (!_.isEmpty(dmsValue.supersedingPart)) {
                        informationFromDms["supersedingPart"] = dmsValue.supersedingPart;
                    }

                    //we add this proprety to know if we let user to go to product page (if local, he can't)
                    if (dmsValue.reference >= QuoteConstants.localPiece.min && dmsValue.reference <= QuoteConstants.localPiece.max) {
                        informationFromDms["isLocalPiece"] = true;
                    }
                    currentPiece["dmsInformations"] = informationFromDms;
                }
            }
        }

        /**
         * @desc    add to the current piece dmsInformations object
         *          containing piece's dms response (reference.v1 request)
         * @param {Object} currentPiece the current piece
         * @param {Array<Object>} referenceFromDms reference of a piece from Dms
         */
        function addDmsInformationToCurrentPiece(currentPiece, referenceFromDms) {
            angular.forEach(referenceFromDms, function (dmsValue) {

                if (currentPiece.reference === dmsValue.reference) {
                    // override designation when we are connected as dms user
                    if (dmsValue.description) {
                        currentPiece.designation = dmsValue.description;
                    }


                    var informationFromDms = {};
                    informationFromDms["isLocalPiece"] = false;

                    informationFromDms["quantity"] = dmsValue.stockQuantity;
                    informationFromDms["priceExclTaxes"] = dmsValue.priceExclTaxes;
                    informationFromDms["location"] = dmsValue.location;
                    informationFromDms["stockId"] = dmsValue.stockId;
                    informationFromDms["siteId"] = dmsValue.siteId;
                    informationFromDms["stockLabel"] = dmsValue.stockLabel;
                    informationFromDms["siteLabel"] = dmsValue.siteLabel;
                    informationFromDms["cort"] = dmsValue.cort;
                    informationFromDms["isKnowFromDms"] = dmsValue.status != 1 ? true : false;

                    if (!_.isEmpty(dmsValue.supersedingPart)) {
                        informationFromDms["supersedingPart"] = dmsValue.supersedingPart;
                    }

                    //we add this proprety to know if we let user to go to product page (if local, he can't)
                    if (dmsValue.reference >= QuoteConstants.localPiece.min && dmsValue.reference <= QuoteConstants.localPiece.max) {
                        informationFromDms["isLocalPiece"] = true;
                    }
                    currentPiece["dmsInformations"] = informationFromDms;
                }

            });
        }

        function matchReferenceFromR2AforSuperSeding(listOfPieces,referenceFromR2A){
            selectedSuperseeding = [];
            angular.forEach(listOfPieces, function (currentPiece) {
                if(!_.isEmpty(currentPiece.supersedingList))
                    addR2AInformationforSuperSeding(currentPiece, referenceFromR2A);
                if (!_.isEmpty(currentPiece.alternative)) {
                    angular.forEach(currentPiece.alternative, function (currentAlternativePiece) {
                        if(!_.isEmpty(currentAlternativePiece.supersedingList))
                            addR2AInformationforSuperSeding(currentAlternativePiece, referenceFromR2A);
                    });
                }
                if (!_.isEmpty(currentPiece.additional)) {
                    angular.forEach(currentPiece.additional, function (currentAdditionalPiece) {
                        if(!_.isEmpty(currentAdditionalPiece.supersedingList))
                            addR2AInformationforSuperSeding(currentAdditionalPiece, referenceFromR2A);
                    });
                }
            });
            return selectedSuperseeding;
        }

        function addR2AInformationforSuperSeding(currentPiece, referenceFromR2A){
           if(referenceFromR2A && !_.isEmpty(referenceFromR2A.products)){ 
                angular.forEach(referenceFromR2A.products, function (r2avalue) {
                    if (currentPiece && !_.isEmpty(currentPiece.supersedingList)) {
                        angular.forEach(currentPiece.supersedingList, function(item){
                            if (item == r2avalue.reference && !_.isEmpty(r2avalue.warehouses) && r2avalue.itemReturnCode === 'A000') {
                                const warehouse = r2avalue.warehouses[0];
                                const warehouseType = warehouse.type ? warehouse.type.toUpperCase() : null;
                                let isValidStock = false;
                                
                                if (warehouseType === 'LOCAL' || warehouseType === 'REGION' || warehouseType === 'COUNTRY' || warehouseType === 'CENTRAL' || warehouseType === 'WW') {
                                    isValidStock = warehouse.confirmedQuantity > 0;
                                }
                                
                                if (isValidStock) {      
                                    selectedSuperseeding.push({
                                        reference:item, 
                                        index:currentPiece.index, 
                                        supersedingList:currentPiece.supersedingList.length, 
                                        originalPart: (item == currentPiece.reference) ? true : false })
                                    return;
                                }
                            }
                        })
                    }
                });
            }
        }
        /*******************************
         *          GETTER             *
         ******************************/
        function getStructuredItems(items) {

            var structuredItems = items.map(function (item) {
                var newItem;
                switch (item.type) {
                    case "PR":
                        newItem = getTypeOfPartProduct(item);
                        break;
                    case "TM":
                        newItem = buildStructureOfTM(item);
                        break;
                }
                return newItem;
            });
            return structuredItems
        }

        function getWorkshopPartShopNumber(value) {
            if (value == QuoteEndpointConstant.workshop) {
                return 0;
            } else {
                return 1;
            }
        }

        function getTypeOfPartProduct(item) {
            var isKnowFromDms = item && item.isKnownDms == true;
            if (isKnowFromDms) {
                return buildStructureOfPR(item, "R");
            } else {
                return buildStructureOfPR(item, "X");
            }
        }

        /*******************************
         *          TOOLS             *
         ******************************/

        function buildStructureOfPR(item, type) {
            var newItem = {
                type: type,
                reference: item.reference,
                quantity: item.quantity
            };

            if (type == "X") {
                _.extend(newItem, {
                    priceExclTaxes: "",
                    description: item.designation
                });

                if (item.cort && item.cort == "-") {
                    _.extend(newItem, {
                        taxCode: ""
                    });
                }
            }
            return newItem;

        }

        //if tm is codified we build a standard labour time structure, else its a specific structure (see DMS CI)
        function buildStructureOfTM(TM) {
            // easy-basket items use `duration`; standard quote items use `laborTime`
            var laborTime = TM.laborTime != null ? TM.laborTime : TM.duration;
            var item = {};
            item = {
                type: "F",
                code: TM.opecod,
                time: calculLaborTime(TM.quantity, laborTime)
            };

            if (TM.codified === false) {
                item = {
                    type: "V",
                    code: TM.opecod,
                    description: TM.designation
                };

                if (laborTime) {
                    _.extend(item, {
                        time: calculLaborTime(TM.quantity, laborTime)
                    });
                } else {
                    _.extend(item, {
                        priceExclTaxes: calculpriceExclTaxes(TM.quantity, TM.exclTaxes)
                    });
                }
            }

            return item;
        }

        function calculLaborTime(quantity, time) {
            if (typeof time === "string") {
                time = time.replace(",", ".") * 10;
                if (quantity > 1) {
                    time = quantity * parseFloat(time);
                }
            } else if (typeof time === "number") {
                time = time * 10;
                if (quantity > 1) {
                    time = quantity * time;
                }
            }

            return time;
        }
        function calculpriceExclTaxes(quantity, price) {
            if (quantity > 1) {
                price = quantity * price;
            }

            return price;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('SettingsMetierService', SettingsMetierService);

    /** @ngInject */
    function SettingsMetierService($q, SettingsConstants, RestUpgrade) {
        //this.getLanguagesList = getLanguagesList;
        this.deleteCustomerGroup = deleteCustomerGroup;
        this.getCustomersGroup = getCustomersGroup;
        this.addCustomerGroup = addCustomerGroup;
        this.updateCustomerGroup = updateCustomerGroup;

        function getUserScales(res) {
            return res.userScales;
        }

        function deleteCustomerGroup(id) {
            var payload = {
                id: id
            }
            return RestUpgrade.all(SettingsConstants.deleteScale).post(payload).then(getUserScales);
        }

        function updateCustomerGroup(label, id) {
            var payload = {
                id: id,
                label: label
            }
            return RestUpgrade.all(SettingsConstants.updateFamilyGroup).post(payload).then(getUserScales);
        }

        function getCustomersGroup() {
            return RestUpgrade.one(SettingsConstants.getFamilyGroup).get().then(getUserScales);
        }

        function addCustomerGroup(label) {
            var payload = {
                label: label
            };
            return RestUpgrade.all(SettingsConstants.addFamilyGroup).post(payload).then(getUserScales);
        }

        // /**
        //  * get list of languages for portal
        //  * @param selectedCountryCode : code of country to manage (selected from list)
        //  */
        // function getPortalLanguages(selectedCountryCode) {
        //     //return CountryWSService.getPortalLanguages(selectedCountryCode);
        // }

        // /**
        //  * get list of languages for documentation and alternative language documentation
        //  * @param selectedCountryCode : code of country to manage (selected from list)
        //  */
        // function getDocumentationLanguages(selectedCountryCode) {
        //    // return CountryWSService.getDocumentationLanguages(selectedCountryCode);
        // }


        // function getLanguagesList(countryCode) {
        //     return $q.all({
        //         portalLanguages: getPortalLanguages(countryCode),
        //         documentationLanguages: getDocumentationLanguages(countryCode),
        //     });
        // }
    }


})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.userSettings, {
        url: '/settings',
        templateUrl: 'app/components/client/settings/settings.html',
        controller: 'SettingsCtrl',
        controllerAs: 'vm'
      });

  }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('SettingsCtrl', SettingsCtrl);

    /** @ngInject */
    function SettingsCtrl(
        $translate,
        $window,
        $stateParams,
        $state,
        $q,
        $rootScope,
        toastr,
        blockUI,

        CacheService,
        DealerManagerSystemeService,
        LoginMetierService,
        ProfilMetierService,
        AlertsLocationService,
        ShoppingCartPartsService,
        PartRequisitionMetierService,
        QuoteMetierService,

        globalConstant,
        PartRequisitionConstants,
        RoutesConstants,
        CacheConstants,
        configConstantes,
        UtilsMetierService,MainMetierService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.dmsState;
        vm.isWorkshop;
        vm.isFunctionalityDevOnly;

        vm.profile = $stateParams.profile;
        vm.isActisRole = false;

        vm.save = save;
        vm.changeProfile = changeProfile;
        vm.backToPrevious = backToPrevious;
        vm.checkHtlAuthorisation = checkHtlAuthorisation;
        vm.onChangeUsernamePassword = onChangeUsernamePassword;
        vm.onChangeMentions = onChangeMentions;
        vm.onChangeHeader = onChangeHeader;
        vm.isProfileChanged = isProfileChanged;
        vm.saveAndClosePartRequisition = saveAndClosePartRequisition;
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        init();

        function init() {

            vm.profile = CacheService.getObject(CacheConstants.profil);
            vm.isActisRole = UtilsMetierService.isActisProfil(vm.profile);
            vm.dmsLoginRequired = false;
            if (vm.profile && vm.profile.dmsConfig) {
                vm.dmsLoginRequired = vm.profile.dmsConfig.dmsLoginRequired;
            }
            vm.mentions = vm.profile.mentions;
            vm.header = vm.profile.header;
            vm.htlState = CacheService.getObject(CacheConstants.htlState);
            vm.isHtlGranted = "COMMON_NO";
            vm.dmsConnected = DealerManagerSystemeService.getHookResult();
            $rootScope.$on("storeHookResultEvent", function () {
                vm.dmsConnected = DealerManagerSystemeService.getHookResult();
            });
            getLanguages();
            checkHtlAuthorisation();
            AlertsLocationService.buildAlerts({
                location: '',
                identification: '',
                typeOfElement: $translate.instant('LOCATION_PROFIL'),
                reference: '',
                label: $translate.instant('LOCATION_PROFIL')
            }, 'PROFIL');
        }

        /**
         * @name onChangeUsernamePassword
         * @desc get state of switch username password
         * @param {Boolean} state
         */
        function onChangeUsernamePassword(state) {
            vm.dmsLoginRequired = state;

        }

        /**
         * @name onChangeMentions
         * @desc get mentions on change
         * @param {*} mentions
         */
        function onChangeMentions(mentions) {
            vm.mentions = mentions;
        }

        /**
         * @name onChangeHeader
         * @desc get header on change
         * @param {*} header
         */
        function onChangeHeader(header) {
            vm.header = header;
        }

        /**
         * @name checkHtlAuthorisation
         */
        function checkHtlAuthorisation() {
            if (vm.htlState) {
                if (vm.htlState[1] == false) {
                    vm.isHtlGranted = "COMMON_NO";
                } else {
                    vm.isHtlGranted = "COMMON_YES";
                }
            }
        }

        /**
         * @name backToPrevious
         * @desc go to previous page
         */
        function backToPrevious() {
            $window.history.back();
        }

        function changeProfile() {

            save();
            LoginMetierService.logOut();
            $state.go(RoutesConstants.login);
        }

        /**
         * @name save
         * @desc save form values (dms-informations, langages)
         */
        function save() {
            //get active part requisition
            var currentPartRequisition = PartRequisitionMetierService.getCurrentPartRequisition();
            //get active quote
            var currentQuote = QuoteMetierService.getQuoteData();
            //if user profile changed and at least we have active part requisition or quote:
            //workshop to partshop if dms connected
            //partshop to workshop if dms connected
            //not dms connected
            if (isProfileChanged(vm.dmsState, vm.networkProfile, vm.profile) && (currentPartRequisition || currentQuote)) {
                //save and close active part requisition if exists
                if (currentPartRequisition) {
                    saveAndClosePartRequisition(currentPartRequisition).then(function (partRequisitionStatus) {
                        switch (partRequisitionStatus) {
                            case -2:
                                toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                                break;
                            case -1:
                                toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                                break;
                            case 0:
                                ShoppingCartPartsService.setShoppingCart([]);
                                break;
                        }
                    });
                }

                //close active quote if exists
                if (currentQuote) {
                    //call only close quote service
                    saveAndCloseQuote(currentQuote).then(function (quoteStatus) {
                        switch (quoteStatus) {
                            case -2:
                                toastr.error($translate.instant("ESTIMATION_SAVE_FAILURE"));
                                break;
                            case -1:
                                toastr.error($translate.instant("ESTIMATION_CLOSE_FAILURE"));
                                break;
                        }
                    });
                }


            }
            blockUI.start();
            // if DMS mode is connected then check another time the dms connection with filled parameters
            // in case of the user change the parameters
            if (vm.dmsState) {
                DealerManagerSystemeService.hookDMS(vm.profile.dmsConfig.url, vm.userDmsId, vm.workshopPartshopId).then(function (dms) {
                    var success = 0;
                    var displayMsg = '';
                    if (dms && $translate.instant('DMS_' + dms.returnCode) != 'DMS_' + dms.returnCode)
                        displayMsg = $translate.instant('DMS_' + dms.returnCode);
                    else
                        displayMsg = dms.message;
                    return {
                        msg: displayMsg,
                        connection: (dms && dms.returnCode === success) ? true : false
                    }
                }).then(function (dms) {
                    //vm.dmsState = dms.connection;
                    if (dms && dms.connection === false) {
                        vm.msg = dms.msg;
                        if(!_.isEmpty(vm.msg)){
                            toastr.error(vm.msg);
                        }else{
                            toastr.error($translate.instant('ADMIN_DMS_ERROR'));
                        }
                    } else if (dms && dms.connection === true) {
                        vm.msg = null;
                        // save profile                            
                        CacheService.removeObject(CacheConstants.otsCheck);
                        CacheService.removeObject(CacheConstants.maintenanceIconCheck);
                        saveProfile(dms.connection);
                    }
                }).finally(function () {
                    blockUI.stop();
                })
            }
            else {                    
                CacheService.removeObject(CacheConstants.otsCheck);
                CacheService.removeObject(CacheConstants.maintenanceIconCheck);
                saveProfile();
            }
            
            /* CacheService.removeObject(CacheConstants.breakingNewsNoCarContext);
            CacheService.removeObject(CacheConstants.wdObjectCriteria);
            CacheService.removeObject(CacheConstants.motCle);
            CacheService.removeObject(CacheConstants.isSearchEngine);
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            CacheService.removeObject(CacheConstants.searchEngineIds);
            CacheService.removeObject(CacheConstants.filter);
            CacheService.removeObject(CacheConstants.symptomsBasketList);
            CacheService.removeObject(CacheConstants.treeContainingNodes); */
            CacheService.setDefaultStorageKeys();
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name isProfileChanged
         * @desc check if user profile changed from workshop to partshop, from partshop to workshop, dms connected to not dms connected
         * @param {Boolean} isDmsConnected
         * @param {String} currentNetworkProfil
         * @param {Object} currentProfil
         * @return {Boolean}
         */
        function isProfileChanged(isDmsConnected, currentNetworkProfil, currentProfil) {
            var isProfileChanged = false;

            //if user is dms connected and switch from workshop to partshop profil
            if (isDmsConnected && currentProfil && currentNetworkProfil === globalConstant.partshop && DealerManagerSystemeService.isWorkshop(currentProfil)) {
                isProfileChanged = true;
            }
            // //if user is connected to dms and switch from partshop to workshop profil
            else if (isDmsConnected && currentProfil && currentNetworkProfil === globalConstant.workshop && DealerManagerSystemeService.isPartshop(currentProfil)) {
                isProfileChanged = true;
            }
            // //if user is not connected dms
            else if (!isDmsConnected) {
                isProfileChanged = true;
            }
            return isProfileChanged;
        }

        /**
         * @name saveAndClosePartRequisition
         * @desc call save and close part requisitions back services
         * @param {Object} currentPartRequisition
         * @returns {Promise} - {-1 if save request fails, -2 if close requset fails, 0 if success}
         */
        function saveAndClosePartRequisition(currentPartRequisition) {
            return PartRequisitionMetierService.saveAndCloseCurrentPartRequisition(currentPartRequisition);
        }

        /**
         * @name saveAndCloseQuote
         * @desc call save and close back quote back services
         * @param {Object} currentQuote
         * @returns {Promise} - {-1 if save request fails, -2 if close requset fails, 0 if success}
         */
        function saveAndCloseQuote(currentQuote) {
            return QuoteMetierService.saveAndCloseCurrentQuote(currentQuote);
        }

        /**
         * @name saveProfile
         * @desc save profile values and call updateProfile service
         */
        function saveProfile(dmsState) {
            // The object required by the service
            var profile = {
                "ipn": vm.profile.ipn,
                "userId": vm.profile.userId,
                "portal": vm.profile.language,
                "documentationFirstLanguage": vm.profile.documentationFirstLanguage,
                "documentationSecondLanguage": vm.profile.documentationSecondLanguage,
                "mentions": vm.mentions,
                "header": vm.header,
                "isLandscape": vm.profile.isLandscape
            }
            if (vm.profile.dmsConfig.ipAddress || vm.profile.dmsConfig.url) {
                profile.dmsConfig = {
                    "networkProfile": vm.networkProfile,
                    "workshopPartshopId": vm.workshopPartshopId || "",
                    "userDmsId": vm.userDmsId || "",
                    "dmsLoginRequired": vm.dmsLoginRequired
                }
            }

            // If user already accepted cookies from GDPR banner, send his data with the profile update to keep it saved in DB
            var user = CacheService.getObject(CacheConstants.profil);
            if (user.gdprTimeOutDate) {
                profile.gdprTimeOutDate = user.gdprTimeOutDate;
                profile.isGdprAccepted = user.isGdprAccepted;
                profile.isGdprAudienceAllowed = user.isGdprAudienceAllowed;
            }


            ProfilMetierService.updateProfil(profile)
                .then(function (result) {
                    return $translate.use(profile.portal).then(function () {
                        toastr.success($translate.instant("ADMIN_PROFILE_UPDATED"));
                        if (vm.htlState && result) {
                            result.dealerLogisticIds = vm.htlState[0];
                        }
                        if (dmsState) {
                            toastr.success($translate.instant('ADMIN_DMS_CONNECTED_SUB_TITLE'));
                        }
                        $rootScope.$emit("profileUpdated", { "dmsState": vm.dmsState, "language": vm.profile.language, "networkProfile": vm.networkProfile });
                        CacheService.setObject(CacheConstants.profil, result);
                        const dynatraceMonitoring = {
                            roles:result.roles,
                            dmsConnected:result.dmsConnected,
                            dmsUrl: result.dmsConfig.url,
                            dealerId: result.dealerId
                        };
                        CacheService.setObject(CacheConstants.dynatraceMonitoring, dynatraceMonitoring);
                    })
                }).then(function () {
                    $state.go(RoutesConstants.default);
                }).catch(function (err) {
                    toastr.error($translate.instant("ERROR_IN_PROFILE_SAVE"), err);
                }).finally(function () {
                    blockUI.stop();
                })
        }

        /**
         * @name getLanguages
         * @desc call getLanguages service to get all langages
         */
        function getLanguages() {
            ProfilMetierService.getLanguages()
                .then(function (result) {
                    vm.languages = result;
                });
        }

    }
})();

(function() {
    angular.module('phenix').constant('SettingsConstants', {
        addFamilyGroup: '/users/createScale',
        getFamilyGroup: '/userScale/getScales',
        updateFamilyGroup: '/users/updateScale',
        deleteScale: '/users/deleteScale',
        mentionsTextForDE: "Hinweis: Falls dieser Kostenvoranschlag ein Austauschteil enthält, kann AT-Steuer fällig werden."
    });
})();

-(function () {
    "use strict";

    angular
        .module('phenix')
        .component('dmsState', {
            controller: dealerManagementSystemContainer,
            templateUrl: 'app/components/client/settings/dms-state.template.html',
            bindings: {
                dms: '<', // endpoint
                dmsState: '=',
                networkProfile: '=',
                workshopPartshopId: '=',
                userDmsId: '=',
                onChangeUsernamePassword: '<',
                onChangeMentions: '<',
                onChangeHeader: '<'
            },
            controllerAs: 'vm'
        });


    function dealerManagementSystemContainer(
        blockUI,
        toastr,

        $translate,
        $scope,
        $mdDialog,

        DealerManagerSystemeService,
        CacheService,
        SettingsMetierService,

        CacheConstants,
        SettingsConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.profile = CacheService.getObject(CacheConstants.profil);
        vm.dmsState = false;
        vm.networkProfile = "";
        vm.msg = null;

        vm.changeState = changeState;
        vm.inputProvider = inputProvider;
        vm.changeUsernamePassword = changeUsernamePassword;
        vm.changeMentions = changeMentions;
        vm.changeHeader = changeHeader;
        vm.mentions = vm.profile.mentions;

        /**
         *      FAMILY GROUP
         */

        vm.list = [];
        vm.newLabel = null;
        vm.addFamilyLabel = addFamilyLabel;
        vm.saveFamilyLabel = saveFamilyLabel;
        vm.updateFamilyLabel = updateFamilyLabel;
        vm.deleteFamilyLabel = deleteFamilyLabel;


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.$onInit = function () {
            $scope.buttonSelected = vm.profile.dmsConfig.networkProfile || "WORKSHOP";
            $scope.workshopPartshopId = vm.profile.dmsConfig.workshopPartshopId;
            $scope.userDmsId = vm.profile.dmsConfig.userDmsId;
            $scope.IdentifiantMdp = vm.profile.dmsConfig.dmsLoginRequired;
            $scope.header = vm.profile.header;

            /* On connection a ping request is executed, the result is stored in DealerManagerSystemeService */
            vm.dmsState = DealerManagerSystemeService.getHookResult();
            vm.networkProfile = $scope.buttonSelected;
            vm.workshopPartshopId = $scope.workshopPartshopId;
            vm.userDmsId = $scope.userDmsId;

            vm.stateIdentifiantMdp = getLabelIdentifiantMdp(vm.profile.dmsConfig.dmsLoginRequired);

            // Action fired if german users are connected : change mention value and disable textarea field
            if (vm.profile.country.toUpperCase() === "DE") {
                vm.mentions = SettingsConstants.mentionsTextForDE;
                tryAddingAttr();
            }

            vm.header = $scope.header;

            SettingsMetierService.getCustomersGroup().then(function (list) {
                vm.list = list;
            });
        }

        /**
         *@desc Wait for DOM to load to get element textarea and add attribute, and modify text for german users 
         */
        function tryAddingAttr() {
            if (document.getElementsByClassName("area-mentions").length === 0) {
                setTimeout(tryAddingAttr, 50);
            } else {
                vm.mentions = SettingsConstants.mentionsTextForDE;
                document.getElementsByClassName("area-mentions")[0].setAttribute("disabled", "");
            }
        }

        /**
         *  @desc call DMS, depending to the response -> save the result as boolean
         *  @return {void}
         */

        this.hookDMS = function () {
            blockUI.start();
            DealerManagerSystemeService.hookDMS(vm.dms.url, vm.userDmsId, vm.workshopPartshopId).then(function (dms) {
                var success = 0;
                var displayMsg = '';
                if ($translate.instant('DMS_' + dms.returnCode) != 'DMS_' + dms.returnCode)
                    displayMsg = $translate.instant('DMS_' + dms.returnCode);
                else
                    displayMsg = dms.message;
                return {
                    msg: displayMsg,
                    connection:  dms.returnCode === success ? true : false
                }
            }).then(function (dms) {
                vm.dmsState = dms.connection;
                if (dms.connection === false) {
                    vm.msg = dms.msg;
                    if(!_.isEmpty(vm.msg)){
                        toastr.error(vm.msg);
                    }else{
                        toastr.error($translate.instant('ADMIN_DMS_ERROR'));
                    }
                } else if (dms.connection === true) {
                    vm.msg = null;
                    toastr.success($translate.instant('ADMIN_DMS_CHECK_SUCCESS'));
                }
            }).finally(function () {
                blockUI.stop();
            })
        }

        /**
         * @desc Change the selected radio button value (WORKSHOP/PARTSHOP)
         * @param {String} state provided by ng-model => buttonSelected
         */
        function changeState(state) {
            vm.networkProfile = state;
        }

        /**
         * @name changeUsernamePassword
         * @desc change the label (activated, desactivated) according to the user's action
         * @desc and send the value to setting controller
         * @param {Boolean} state
         */

        function changeUsernamePassword(state) {
            vm.stateIdentifiantMdp = getLabelIdentifiantMdp(state);
            vm.onChangeUsernamePassword(state);
        }

        /**
         * @name changeMentions
         * @desc change the mention label on user action
         * @desc set the value updated of header to setting controller
         * @param {*} mentions
         */
        function changeMentions(mentions) {
            vm.mentions = mentions;
            vm.onChangeMentions(mentions);
        }

        /**
         * @name changeHeader
         * @desc change the header label on user action
         * @desc set the value updated of header to setting controller
         * @param {*} header
         */
        function changeHeader(header) {
            vm.header = header;
            vm.onChangeHeader(header);
        }

        /**
         * @desc provide the workshop and userDms field
         * @param {*String} type type of field (Workshop or UserDms)
         * @param {*String} textEntered value returned by ng-model
         */
        function inputProvider(type, textEntered) {
            if (type === "workshop") {
                vm.workshopPartshopId = textEntered;
            } else {
                vm.userDmsId = textEntered;
            }
        }

        /**
         *  @desc Unset DMS
         */
        this.unsetDMS = function () {
            vm.dmsState = false;
            vm.msg = null
            toastr.success($translate.instant('ADMIN_DMS_NOT_CONNECTED_SUB_TITLE'));
        }


        /*=============================================
        =                 TOOLS                      =
        =============================================*/

        /**
         * @name getLabelIdentifiantMdp
         * @desc get if the switch Identifiant mdp's label
         * @param {Boolean} state
         * @returns {String} Activate / Desactivate
         */
        function getLabelIdentifiantMdp(state) {
            var label = $translate.instant('LABEL_LOGIN_PASSWORD_DESACTIVATE');
            if (state) {
                label = $translate.instant('LABEL_LOGIN_PASSWORD_ACTIVATE');
            }
            return label;
        }

        function addFamilyLabel() {
            if (Array.isArray(vm.list) && vm.list.length === 10) {
                return toastr.info($translate.instant('LIMIT_CUSTOMER_GROUPS_REACHED'));
            }
            if (vm.newLabel) {
                return;
            }

            vm.newLabel = '';
        }

        function saveFamilyLabel() {
            if (!vm.newLabel.length) {
                return;
            }

            SettingsMetierService.addCustomerGroup(vm.newLabel).then(function (res) {
                vm.list = res;
                vm.newLabel = null;
            });
        }

        function updateFamilyLabel(label, id) {
            $mdDialog.show({
                templateUrl: 'app/components/client/settings/components/updateFamilyLabel.template.html',
                controller: 'updateFamilyLabel',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    label: label
                }
            }).then(function (updatedLabel) {
                return SettingsMetierService.updateCustomerGroup(updatedLabel, id);
            }).then(function (customerGroupList) {
                vm.list = customerGroupList;
            }).catch(function () {
                // catch do avoid warning in browser
            });
        }

        function deleteFamilyLabel(label, id) {
            $mdDialog.show({
                templateUrl: 'app/components/client/settings/components/confirmDeleteFamilyLabel.template.html',
                controller: 'confirmDeleteFamilyLabel',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    label: label
                }
            }).then(function () {
                return SettingsMetierService.deleteCustomerGroup(id);
            }).then(function (customerGroupList) {
                vm.list = customerGroupList;
            }).catch(function () {
                // catch do avoid warning in browser
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.infoClient, {
        url: '/infoClient',
        templateUrl: 'app/components/client/infoClient/infoClient.html',
        controller: 'InfoClientCtrl',
        controllerAs: 'infoCltCtrl'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('InfoClientCtrl', InfoClientCtrl);

  /** @ngInject */
  function InfoClientCtrl(RoutesConstants, CarSearchConstants, InfoClientMetierService, $state, $translate, AlertsLocationService) {
    var vm = this;

    function backToCarSearchResult(){
      $state.go(RoutesConstants.carSearchResult);
    }

    function getInfoClient(){
      return InfoClientMetierService.getInfoClient();
    }

    function isPhonePrefered(){
      return vm.infoClient.preferredMedia === 6;
    }
    function isSmsPrefered(){
      return vm.infoClient.preferredMedia === 5;
    }
    function isCourrierPrefered(){
      return vm.infoClient.preferredMedia === 1;
    }
    function isEmailPrefered(){
      return vm.infoClient.preferredMedia === 2;
    }
    function isFaxPrefered(){
      return vm.infoClient.preferredMedia === 4;
    }

    function canPhone(){
      return vm.infoClient.customer.phoneAgreement;
    }
    function canSms(){
      return vm.infoClient.customer.smsAgreement;
    }
    function canCourrier(){
      return vm.infoClient.customer.postAgreement;
    }
    function canEmail(){
      return vm.infoClient.customer.emailAgreement;
    }
    function canFax(){
      return vm.infoClient.customer.faxAgreement;
    }
    function init() {
      vm.backToCarSearchResult = backToCarSearchResult;
      vm.infoClient = getInfoClient();
      vm.email = "mailto:";
      vm.isPhonePrefered = isPhonePrefered;
      vm.isSmsPrefered = isSmsPrefered;
      vm.isCourrierPrefered = isCourrierPrefered;
      vm.isEmailPrefered = isEmailPrefered;
      vm.isFaxPrefered = isFaxPrefered;
      vm.canPhone = canPhone;
      vm.canSms = canSms;
      vm.canCourrier = canCourrier;
      vm.canEmail = canEmail;
      vm.canFax = canFax;

      if(vm.infoClient){
        vm.email += vm.infoClient.email;
      }

      AlertsLocationService.buildAlerts({
        location: '',
        identification: '',
        typeOfElement: $translate.instant('LOCATION_CLIENT'),
        reference: vm.infoClient.dmsCustomerId,
        label: vm.infoClient.title + ' ' + vm.infoClient.firstName + ' ' + vm.infoClient.name + ' (' + vm.infoClient.dmsCustomerId + ')'
      }, 'CLIENT');
    }

    init();

  }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('searchSpecializedTool', {
            bindings: {
                isSpecialToolsDocz: '<',
                globalSearch: '<',
                selectedCategory: '<',
                searchText: '<'
            },
            controller: SearchSpecializedToolController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchSpecializedTool/searchSpecializedTool.template.html'
        }).filter('customFilter', function () {
        return function (items, search) {

            if (!search || (Object.keys(JSON.parse(JSON.stringify(search))).length === 0 && search.constructor === Object)) {
                return items;
            }
            var selected = Object.keys(search).map(function (key) {
                return search[key]
            });
            items = items.filter(function (value) {
                return selected.indexOf(value.type) != -1;
            });
            return items;
        }
    }).filter('pages', function() {
        return function(input, currentPage, pageSize) {
            if (angular.isArray(input)) {
                var start = (currentPage - 1) * pageSize;
                var end = currentPage * pageSize;
                return input.slice(start, end);
            }
        };
    });

    function SearchSpecializedToolController(SearchSpecializedToolBusinessService,
                                             SearchSpecializedToolConstants,
                                             toastr,
                                             blockUI,
                                             $translate,
                                             CacheService,
                                             $mdDialog,$http,RestUpgrade,FeaturesConstants,
                                             $sce,$filter,printPdfModalService,FileSaver,
                                             $q,$log,$rootScope,configConstantes,CarSearchMetierService,PDFViewService,SearchArboTextualMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.selected = undefined;
        vm.isMainTabActive = undefined;
        vm.specializedToolsSubTypes = [];
        vm.specializedToolsSubTypesAfterFiltering = [];
        vm.specializedToolsIds = [];
        vm.specializedToolsSubTypesWithoutDuplicates = [];
        vm.specializedToolsSubTypesWithoutDuplicatesAfterFiltering = [];
        vm.labelObjects = [];
        vm.codes = [];
        vm.labels = [];
        vm.responseSpecialTools = [];
        vm.selectedDocType = null;
        vm.applicabilityData = [];
        vm.typeOfToolArray = [];
        vm.displayedData = [];
        vm.expanded = false;
        vm.statusResult = '';
        vm.statusSelected = '';
        vm.pictogram = '';
        vm.isFromNewSpecialTools = false;
        vm.allCategorySelected = false;
        vm.advanceFilteredPayload = {};
        vm.codeRefList = "";

        vm.currentPage = 1;
        vm.itemsPerPage = 20;
        vm.maxSize = 20;
        vm.totalItems = 0;
        vm.pageSize = 20;
        vm.downloadPdf = downloadPdf;
        vm.headerValue = {};
        vm.showData = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        // Status list available
        vm.status = [
            {
                id: 0,
                name: 'Essentiel',
                label: $translate.instant('SPECIALIZED_TOOL_STATUS_ESSENTIAL')
            },
            {
                id: 1,
                name: 'Valide',
                label: $translate.instant('SPECIALIZED_TOOL_STATUS_VALID')
            },
            {
                id: 2,
                name: 'Arrêté',
                label: $translate.instant('SPECIALIZED_TOOL_STATUS_STOPPED')
            }
        ]

        // Selected status Specific user rules says to preFilter on Essentiel and Valide
        vm.statusSelection = ['Essentiel', 'Valide'];


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.activateSelectedTab = activateSelectedTab;
        vm.getSpecialToolsData = getSpecialToolsData;
        vm.isTabActive = isTabActive;
        vm.removeDuplicatesFromArray = removeDuplicatesFromArray;
        vm.displayPictogram = displayPictogram;
        vm.removeSpacesFromReferenceNumber = removeSpacesFromReferenceNumber;
        vm.openSpecializedToolInformation = openSpecializedToolInformation;
        vm.toggleSelection = toggleSelection;
        vm.showCheckboxes = showCheckboxes;
        vm.specialToolsData = specialToolsData;

        $rootScope.$on('advancedFilteredPayload',function(event, response){
            if(response && (vm.selectedCategory || vm.searchText || vm.globalSearch)){
                vm.isFromNewSpecialTools = true;
                vm.statusSelection = ['Essentiel', 'Valide', 'Arrêté'];
                vm.specializedToolsIds = [];
                vm.specializedToolsSubTypesAfterFiltering = [];
                vm.specializedToolsSubTypesWithoutDuplicatesAfterFiltering = [];
                vm.advanceFilteredPayload = response;
                vm.getSpecialToolsData();
            }
            else {
                vm.isFromNewSpecialTools = false;
                vm.responseSpecialTools = [];
            }
        });

        this.$onInit = function () {

            vm.userContext = CacheService.getUserContext();
            vm.carContext = CacheService.getCarContext();
            vm.docType = SearchSpecializedToolConstants.specialToolsAllSubTypes;

            vm.docTypeStringified = JSON.stringify(vm.docType.SPECIALTOOLS.subType);

            vm.menu = SearchSpecializedToolConstants.specialToolsMenu;

            vm.icons = SearchSpecializedToolConstants.icons;

            if(!vm.isFromNewSpecialTools && !vm.isSpecialToolsDocz) {
                vm.getSpecialToolsData();
            }
            else {
                vm.pdf = configConstantes.ndHelpUrl + "/special_tools/Content/OS_Suppliers_List.pdf"
            }
            vm.activateSelectedTab(0);
            vm.pictoImages = {
                "essential":{src:"/assets/images/stop.png"},
                "valid":{src:"/assets/images/star.png"},
                "noImageCross":{src:"/assets/images/cross.png"},
                "white_empty":{src:"/assets/images/white_empty.png"}
            }
            _.map(vm.pictoImages,function(item){
                    return convertImgToBase64(item,item.src);                
            })

        };

        $rootScope.$on('resetSTData',function(event, globalSearch, selectedCategory, searchText){
            if(!(globalSearch.battery_type && globalSearch.engine_type && globalSearch.gearbox_type && globalSearch.vehicle_family && selectedCategory && searchText)){
                vm.isFromNewSpecialTools = false;
                vm.selected = undefined;
                vm.specializedToolsSubTypesAfterFiltering = [];
                vm.responseSpecialTools = [];
                vm.printIconEnabled = false;
            }
            else if((globalSearch.battery_type || globalSearch.engine_type || globalSearch.gearbox_type || globalSearch.vehicle_family) && !selectedCategory && !searchText){
                vm.selected = 0;
            }
        });

        /**
         * @name getSpecialToolsData
         * @desc calls fixedFiltered2 and specialTools services to return all specialized tools related to a car
         * @param {*}
         */
        function getSpecialToolsData(selectedDocType) {

            if (selectedDocType && selectedDocType.SPECIALTOOLS && selectedDocType.SPECIALTOOLS.subType) {
                const isAllCategory = vm.menu && vm.menu[vm.selected] && vm.menu[vm.selected].label === 'SPECIALIZED_TOOL_MENU_ALL_SUBTYPES';
                const categoryCode = isAllCategory ? 'ALL' : selectedDocType.SPECIALTOOLS.subType[0];
                if (categoryCode) {
                    SearchArboTextualMetierService.setConnectedServicesAuditData('Tool_Category_' + categoryCode).then(function () {});
                }
            }

            blockUI.start();

            if(!vm.isFromNewSpecialTools) {
                var docType = '';

                if (_.isEmpty(selectedDocType)) {
                    docType = vm.docType;
                } else {
                    docType = vm.selectedDocType;
                }

                var fixedFiltered2Payload = {
                    userContext: vm.userContext,
                    carContext: vm.carContext,
                    docType: docType
                };

                SearchSpecializedToolBusinessService.fixedFiltered2(fixedFiltered2Payload).then(function (response) {
                    specialToolsData(response, docType);
                }).catch(function (error) {
                    if (error){
                        $log.debug($translate.instant('ERROR'));
                        blockUI.stop();
                    }
                });
            }

            else if(vm.isFromNewSpecialTools) {
                
                if (_.isEmpty(selectedDocType)) {
                    if(vm.selectedCategory){
                        var selectedCategory = vm.selectedCategory.substr(0,3).toUpperCase();
                        var allCat = $translate.instant('SPECIALIZED_TOOL_MENU_ALL_SUBTYPES');
                        vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType = vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType.filter(function (data) {
                            if(selectedCategory == data){
                                return data;
                            }
                            else if(allCat.toUpperCase().includes(selectedCategory)){
                                return vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType;
                            }
                        })
                    }
                    else{
                        vm.selected = 0;
                    }
                } 
                else {
                    vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType = vm.selectedDocType.SPECIALTOOLS.subType;
                }
                if(!_.isEmpty(vm.advanceFilteredPayload.carContext.fixedCriterias)){
                CarSearchMetierService.customService(vm.advanceFilteredPayload.carContext).then(function(response){
                    _.extend(vm.advanceFilteredPayload.carContext, {carContext: response.carContext})
                SearchSpecializedToolBusinessService.advancedFiltered(vm.advanceFilteredPayload).then(function (response) {
                    specialToolsData(response, vm.advanceFilteredPayload.docType);
                }).catch(function (error) {
                    if (error){
                        $log.debug($translate.instant('ERROR'));
                        blockUI.stop();
                    }
                })
                }).catch(function (error) {
                    if (error){
                        $log.debug($translate.instant('ERROR'));
                        blockUI.stop();
                    }
                });
            }
                else {
                    SearchSpecializedToolBusinessService.advancedFiltered(vm.advanceFilteredPayload).then(function (response) {
                        specialToolsData(response,vm.advanceFilteredPayload.docType);
                    }).catch(function (error) {
                        if (error){
                            $log.debug($translate.instant('ERROR'));
                            blockUI.stop();
                        }
                    });
                }
            }
        }        

        function getSearchTextData(item) {
            if(vm.searchText){
                vm.codeRefList = item.identifier.toLowerCase() + " " + item.reference.toLowerCase();
                _.extend(item, {codeRef: vm.codeRefList});
                vm.searchText = vm.searchText.toLowerCase();
                if(item.codeRef.includes(vm.searchText)) {
                    vm.responseSpecialTools.push(item);
                }
            }
        }

        function getSelectedCategData(item){
            var identifier = item.identifier.toLowerCase().slice(0,3);
            vm.selectedCategory = vm.selectedCategory.toLowerCase();
            var allCat = $translate.instant('SPECIALIZED_TOOL_MENU_ALL_SUBTYPES');

            vm.menu.forEach(function (data) {
                var categoryLabel = $translate.instant(data.label).toLowerCase();
                    if(vm.selectedCategory.substr(0,3) == identifier) {
                        if(vm.selectedCategory.includes(categoryLabel)){
                            vm.allCategorySelected = false;
                            activateSelectedTab(data.id);
                            vm.responseSpecialTools.push(item);
                        }
                    }
                    else if(allCat.toLowerCase().includes(vm.selectedCategory)){
                        if(vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType.length == 1 && vm.advanceFilteredPayload.docType.SPECIALTOOLS.subType[0]){
                            activateSelectedTab(vm.selected);
                        }
                        else{
                            vm.allCategorySelected = true;
                            activateSelectedTab(0);
                        }
                        vm.responseSpecialTools.push(item);
                    }

            });
        }

        function getSelectSearchData(item){
            vm.selectedCategory = vm.selectedCategory.toLowerCase();
            vm.searchText = vm.searchText.toLowerCase();
            var codeRefList = item.identifier.toLowerCase() + " " + item.reference.toLowerCase();
            var allCat = $translate.instant('SPECIALIZED_TOOL_MENU_ALL_SUBTYPES');
            _.extend(item, {codeRef: codeRefList});
            if((vm.selectedCategory && (item.codeRef.substr(0,3) == vm.selectedCategory.substr(0,3) || allCat.toLowerCase().includes(vm.selectedCategory))) && (vm.searchText && item.codeRef.includes(vm.searchText))) {
                activateSelectedTab(vm.selected);
                vm.responseSpecialTools.push(item);
            }
            else {
                toastr.error($translate.instant('INVALID_SEARCH'));
            }
        }
        function specializedSubTypeFiltering(item){
            vm.specializedToolsSubTypes.forEach(function (data) {
                if (!(item.validated === true && item.commercialized === false)) {
                    if(item.identifier.toLowerCase().includes(data.toLowerCase())){
                        vm.specializedToolsSubTypesAfterFiltering.push(data);
                    }
                }
            });

            vm.specializedToolsSubTypesAfterFiltering = _.uniq(vm.specializedToolsSubTypesAfterFiltering);
        }

        function specialToolsData(response, selectedDocType) {
            if (response && response.documents && response.documents.length > 0) {

                vm.specializedToolsSubTypes = response.documents.map(function (item) {
                    return item.subType;
                });

                vm.specializedToolsIds = response.documents.map(function (item) {
                    return item.id;
                });

                var specialToolsPayload = {
                    userContext: vm.userContext,
                    documentIds: vm.specializedToolsIds
                };
                if(vm.isFromNewSpecialTools && vm.advanceFilteredPayload && vm.advanceFilteredPayload.carContext && vm.advanceFilteredPayload.carContext.carContext){      
                    _.extend(specialToolsPayload, {
                        carContext : vm.advanceFilteredPayload.carContext.carContext,
                    });
                }
                vm.isFromNewSpecialTools ? _.extend(specialToolsPayload, {isFromNewSpecialTools: vm.isFromNewSpecialTools}) : "";
                vm.carContext ? _.extend(specialToolsPayload, {carContext: vm.carContext}) : "";
                vm.printIconEnabled = false;
                SearchSpecializedToolBusinessService.specialTools(specialToolsPayload).then(function (response) {

                    vm.responseSpecialTools = [];
                    vm.applicabilityData = [];

                    // get the pdf link to then open it in a new tab
                    vm.pdf = response.commonInfo[0];
                    if(!_.isEmpty(response.specialTools)){
                        vm.printIconEnabled = true;
                    }
                    angular.forEach(response.specialTools, function (item, index) {
                        if (!(item.validated === true && item.commercialized === false)) {
                            if(vm.isFromNewSpecialTools) {
                                
                                if(vm.advanceFilteredPayload && vm.advanceFilteredPayload.carContext && !_.isEmpty(vm.advanceFilteredPayload.carContext.fixedCriterias)){
                                    var criteriaData = vm.advanceFilteredPayload.carContext.fixedCriterias;
                                    item.applicableFamilies.forEach(function (appl) {
                                        if(!_.isEmpty(appl) && !_.isEmpty(appl.applicability)){
                                            if(!_.isEmpty(criteriaData) && ((!_.isEmpty(criteriaData["007"]) && criteriaData["007"] === appl.code) || ((!_.isEmpty(criteriaData["999"]) && appl.applicability.includes(criteriaData["999"])) || (!_.isEmpty(criteriaData["997"]) && appl.applicability.includes(criteriaData["997"])) || (!_.isEmpty(criteriaData["968"]) && appl.applicability.includes(criteriaData["968"]))))){
                                                if(vm.searchText && !vm.selectedCategory){
                                                    getSearchTextData(item);
                                                    specializedSubTypeFiltering(item);
                                                }
                                                if(vm.selectedCategory && !vm.searchText){
                                                    getSelectedCategData(item);
                                                    specializedSubTypeFiltering(item);
                                                }
                                                else if(vm.searchText && vm.selectedCategory){
                                                    getSelectSearchData(item);
                                                    specializedSubTypeFiltering(item);
                                                }
                                                else {
                                                    vm.allCategorySelected = true;
                                                    vm.selected ? activateSelectedTab(vm.selected) : activateSelectedTab(0);
                                                    vm.responseSpecialTools.push(item);
                                                    specializedSubTypeFiltering(item);
                                                }
                                            }
                                        }
                                    });
                                }

                                else {
                                    var allCat = $translate.instant('SPECIALIZED_TOOL_MENU_ALL_SUBTYPES');
                                    if(vm.selectedCategory && !vm.selectedCategory.toLowerCase().includes(allCat.toLowerCase())){
                                        vm.specializedToolsSubTypesAfterFiltering = [];
                                    }
                                    if(vm.searchText && !vm.selectedCategory){
                                         getSearchTextData(item);
                                         specializedSubTypeFiltering(item);
                                    }
                                    if(vm.selectedCategory && !vm.searchText){
                                        getSelectedCategData(item);
                                        specializedSubTypeFiltering(item);
                                    }
                                    else if(vm.searchText && vm.selectedCategory){
                                        getSelectSearchData(item);
                                        specializedSubTypeFiltering(item);
                                    }
                                }

                            }
                            else {
                                vm.responseSpecialTools.push(item);
                                vm.specializedToolsSubTypesAfterFiltering.push(vm.specializedToolsSubTypes[index]);
                            }
                        }
                    });
                    vm.responseSpecialTools = _.uniq(vm.responseSpecialTools);

                    if(vm.responseSpecialTools.length == 0){
                        vm.printIconEnabled = false;
                        return toastr.info($translate.instant('NO_DATA_FOUND'));
                    }

                    if(vm.isFromNewSpecialTools && ((vm.searchText && !_.isEmpty(vm.responseSpecialTools) && vm.responseSpecialTools.length == 1) || (!_.isEmpty(vm.responseSpecialTools) && vm.responseSpecialTools.length == 1))){
                        vm.responseSpecialTools.forEach(function(item){
                            if((vm.advanceFilteredPayload.docType.SPECIALTOOLS.reference && item.codeRef.includes(vm.advanceFilteredPayload.docType.SPECIALTOOLS.reference)) || (vm.advanceFilteredPayload.docType.SPECIALTOOLS.identifier && vm.specializedToolsSubTypes.includes(item.identifier.substr(0,3).toUpperCase())) || (vm.specializedToolsSubTypes.length == 1)){
                                vm.docType.SPECIALTOOLS.subType.map(function (data, index) {
                                    if(data == vm.specializedToolsSubTypes[0]){
                                        index = index + 1;
                                        activateSelectedTab(index);
                                        return openSpecializedToolInformation(item);
                                    }
                                });
                               }
                        });
                    }
                    angular.forEach(vm.responseSpecialTools, function (item, index) {
                        if (item.essential) {
                            if (!item.validated && !item.commercialized) {
                                item['type'] = "Arrêté";
                            } else {
                                item['type'] = "Essentiel";
                            }
                        } else if (!item.essential && !item.commercialized) {
                            item['type'] = "Arrêté";
                        } else {
                            item['type'] = "Valide";
                        }
                    });
                    var labelObj = '';
                    vm.responseSpecialTools.forEach(function (item) {
                        if (!_.isEmpty(item.residual) && !_.isEmpty(item.residual[0].fixe)) {
                            item.applicabilityResidual = [];
                            item.residual[0].fixe.forEach(function (residualFixe) {
                                var applicabilityResidualInformation = '';
                                labelObj = residualFixe.labelObj;
                                var listCritIndex = 0;
                                var listCritSize = residualFixe.listCrit.length;
                                residualFixe.listCrit.forEach(function (crit) {
                                    if (listCritSize === 1) {
                                        applicabilityResidualInformation += labelObj + ": " + crit.labelCrit + " (" + crit.codeCrit + ")";
                                    } else {
                                        if (listCritIndex === 0) {
                                            applicabilityResidualInformation = labelObj + ": " + crit.labelCrit + " (" + crit.codeCrit + ")";

                                        } else {
                                            applicabilityResidualInformation += ", " + crit.labelCrit + " (" + crit.codeCrit + ")";
                                        }
                                    }
                                    listCritIndex++;
                                });
                                item.applicabilityResidual.push(applicabilityResidualInformation);
                            });
                        }
                    });
                    if (vm.specializedToolsSubTypesWithoutDuplicatesAfterFiltering.length === 0) {
                        vm.specializedToolsSubTypesWithoutDuplicatesAfterFiltering = removeDuplicatesFromArray(vm.specializedToolsSubTypesAfterFiltering);
                    }
                    if (selectedDocType.SPECIALTOOLS.subType.length > 1  && selectedDocType.SPECIALTOOLS.subType.includes('BAT') && !_.includes(selectedDocType.SPECIALTOOLS.identifier,'Bat')) {                    
                        vm.responseSpecialTools = _.filter(vm.responseSpecialTools, function (item) { if ( !_.includes (item.identifier, 'Bat')){ return item}})
                    }
                    vm.totalItems = vm.responseSpecialTools.length;
                    vm.maxSize = vm.totalItems;
                    vm.statusSelected = vm.statusSelection;
                    if (selectedDocType.SPECIALTOOLS.subType.length == 1  && selectedDocType.SPECIALTOOLS.subType.includes('BAT') || _.includes(selectedDocType.SPECIALTOOLS.identifier,'Bat')){
                        var detail = $translate.instant("SPECIAL_TOOLS_BATTERY_INFO_1") + "<br>" + $translate.instant("SPECIAL_TOOLS_BATTERY_INFO_2");                        
                        $mdDialog.show({
                            templateUrl: 'app/components/car/searchSpecializedTool/selectedTool/specializedToolBattery.template.html',
                            controller: 'specializedToolSelectionController',
                            bindToController: true,
                            controllerAs: 'vm',
                            clickOutsideToClose: true,
                            skipHide:'true',
                            multiple:'true',
                            locals: {
                                detail: detail
                            }
                          });
                    }
                    vm.headerValue = {
                        'commercialized': $translate.instant('SPECIALIZED_TOOL_STATUS_COMMERCIALIZED'),
                        'validated': $translate.instant('LABEL_VALIDATED'),
                        'essential': $translate.instant('SPECIALIZED_TOOL_STATUS_ESSENTIAL'),
                        'toolsCode': $translate.instant('SEARCH_SPECIALIZED_TOOL_TOOLS_CODE'),
                        'reference': $translate.instant('SEARCH_SPECIALIZED_TOOL_REFERENCE'),
                        'supplier': $translate.instant('SEARCH_SPECIALIZED_TOOL_SUPPLIER'),
                        'description': $translate.instant('SEARCH_SPECIALIZED_TOOL_DESCRIPTION'),
                        'applicability': $translate.instant('SEARCH_SPECIALIZED_TOOL_APPLICABILITY'),

                    }
                    vm.columnValue = [];
                    vm.responseSpecialTools.forEach(function (item) {
                        var description = (item.designation ? item.designation : "") + '.' + (item.comment ? item.comment : "");
                        var applicabilityArray = [];
                        item.applicableFamilies.forEach(function (data) {
                            var applicableData = ((data && data.label) ? data.label : "") + ":" + ((data && data.applicability) ? data.applicability : "");
                            applicabilityArray.push(applicableData)
                        })
                        var applicability = !_.isEmpty(applicabilityArray) ? (applicabilityArray.toString()).split(',').join('/') : ""

                        vm.columnValueList = {
                            'commercialized': ((item && item.commercialized) ? true : false) ? "X" : "",
                            'validated': ((item && item.validated) ? true : false) ? "X" : "",
                            'essential': ((item && item.essential) ? true : false) ? "X" : "",
                            'toolsCode': item.identifier ? item.identifier : "",
                            'reference': item.reference ? removeSpacesFromReferenceNumber(item.reference) : "",
                            'supplier': item.supplier ? item.supplier : "",
                            'description': description.replace(",", "."),
                            'applicability': applicability

                        };
                        vm.columnValue.push(vm.columnValueList);
                    })

                    var finalData = Object.keys(vm.globalSearch).map(function (key) {
                        return vm.globalSearch[key]
                    });

                    if (!_.isEmpty(vm.selectedCategory)) {
                        finalData.push(vm.selectedCategory)

                    }
                    if (!_.isEmpty(vm.searchText)) {
                        vm.searchText = vm.searchText.includes(".") ? vm.searchText.replace(".", " ") : vm.searchText;
                        finalData.push(removeSpacesFromReferenceNumber(vm.searchText))

                    }
                    finalData = finalData.filter(function (value) {
                        return !_.isEmpty(value)
                    });
                    vm.csvName = (finalData.toString()).split(",").join("-")
                    vm.showData = true;
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                }).finally(function () {
                    blockUI.stop();
                });
            }
            else {
                vm.responseSpecialTools = [];
                toastr.error($translate.instant('INVALID_SEARCH'));
                blockUI.stop();
            }
        }

        /**
         * @name activateSelectedTab
         * @desc applies special CSS for selected tab
         * @param {id}, tab id
         */
        function activateSelectedTab(id) {
            vm.selected = id;
            vm.selectedDocType = vm.menu[id].docType;
        }

        /**
         * @name isTabActive
         * @desc check if docType element is present among the list of all docTypes.
         * @desc If not, tab is greyed out and not clickable (no available specialized tools then)
         * @param {value, array}
         */

        function isTabActive(value, array) {
            if($rootScope.isIndependentUser && value == 'BAT'){
                return false;
            }else{
                return array.indexOf(value) !== -1;
            }
            
        }

        /**
         * @name removeDuplicatesFromArray
         * @desc get each docType short code from all returned documents, then filter the values
         * @desc to remove duplicates. Then, newly created array is used to make menu tabs available or not.
         * @param {array}
         */

        function removeDuplicatesFromArray(arr) {
            return arr.filter(function (item, index) {
                return arr.indexOf(item) >= index;
            });
        }

        /**
         * @name displayPictogram
         * @desc displays essential, stopped pictograms or nothing whether special tool is essential,
         * @desc stopped/replaced or none of them
         * @param {boolean, boolean}
         */
        function displayPictogram(row, isPrint) {
            if (row.essential) {
                if (!row.validated && !row.commercialized) {
                    if(isPrint)
                        return 'stop';
                    else
                        return $sce.trustAsHtml('<i class="fa fa-stop-circle fa-2x" style="color: red;"></i>');
                } else {
                    if(isPrint)
                        return 'star';
                    else if(vm.nissanUserURL)
                        return $sce.trustAsHtml('<i class="fa fa-star fa-2x" style="color: #ff8e8f;"></i>');
                    else
                        return $sce.trustAsHtml('<i class="fa fa-star fa-2x" style="color: var(--renaultPrimaryColor);"></i>');
                }
            } else if (!row.essential && !row.commercialized) {
                if(isPrint)
                    return 'stop';
                else
                    return $sce.trustAsHtml('<i class="fa fa-stop-circle fa-2x" style="color: red;"></i>');
            } else {
                return '';
            }
        }

        /**
         * @name removeSpacesFromReferenceNumber
         * @desc remove spaces from reference number to make its length as 10 characters
         * @param {string}
         */

        function removeSpacesFromReferenceNumber(referenceNumber) {
            return referenceNumber.split(' ').join('');
        }

        /**
         * @name openSpecializedToolInformation
         * @desc open popin displaying detailed information for a specific tool
         * @param {payload}
         */

        function openSpecializedToolInformation(row) {
            SearchArboTextualMetierService.setConnectedServicesAuditData('Tool_Item_' + row.identifier).then(function () {});
            if (!_.isEmpty(row.applicableFamilies)) {
                var sampleAppl = _.groupBy(row.applicableFamilies, 'code')
                var filteredData = [];
                filteredData = _.filter(sampleAppl,function(apl){
                    return apl.length > 1
                })  
                if(!_.isEmpty(filteredData)) {             
                    filteredData.forEach(function(dat){
                        var applToBeDisplayed = '';
                        var showFullAppl = dat[0].applicability.indexOf("/") == -1;
                        dat.forEach(function(dat1,index){
                            applToBeDisplayed += (index != 0 ?',':'')+(!showFullAppl ? dat1.applicability.substring(dat1.applicability.indexOf("/") + 1) : dat1.applicability);
                        }) 
                        _.assign(dat[0],{applicabilityToBeDisplayed:applToBeDisplayed})
                    })
                }
                row.applicableFamilies = _.uniqBy(row.applicableFamilies, 'code');
                row.applicableFamilies =_.sortBy(row.applicableFamilies, function (itemObject) {
                    return itemObject.label;
                }, ['asc']);
            }
            vm.pictogram = '';
            vm.pictogram = vm.displayPictogram(row);
            $mdDialog.show({
                templateUrl: 'app/components/car/searchSpecializedTool/selectedTool/specializedToolSelection.template.html',
                controller: 'specializedToolSelectionController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    identifier: row.identifier,
                    reference: row.reference,
                    designation: row.designation,
                    comment: row.comment,
                    supplier: row.supplier,
                    pictureUrl: row.pictureUrl,
                    pictogram: vm.pictogram,
                    applicableFamilies : row.applicableFamilies
                }
            });

        }

        function showCheckboxes() {
            var checkboxes = document.getElementById("checkboxes");
            if (!vm.expanded) {
                checkboxes.style.display = "block";
                vm.expanded = true;
            } else {
                checkboxes.style.display = "none";
                vm.expanded = false;
            }
        }

        function toggleSelection(statusName) {
            var selectedIDs = vm.statusSelection.indexOf(statusName);

            // Is currently selected
            if (selectedIDs > -1) {
                vm.statusSelection.splice(selectedIDs, 1);
            }

            // Is newly selected
            else {
                vm.statusSelection.push(statusName);
            }

            vm.statusSelected = vm.statusSelection;
        };

        function convertImgToBase64(obj, url) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = "use-credentials";
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                canvas = null;
                obj.imgBaseData = dataURL;
                return;
            };
            img.src = url;
        }
        function downloadPdf() {
            if (!_.isEmpty(vm.responseSpecialTools)) {  

                var defer = $q.defer();
                var specialToolsDataItems = $filter('customFilter')(vm.responseSpecialTools, vm.statusSelected);
                if(specialToolsDataItems.length > 20)
                    blockUI.start($translate.instant("PRINT_LOADER"));
                else
                    blockUI.start();
                var promiseArray = _.map(specialToolsDataItems, function (item) {
                    if (item.thumbnailUrl) {
                        return RestUpgrade.one(SearchSpecializedToolConstants.loadCdnFiles).get({url:item.thumbnailUrl}).then(function(response){
                            item.imgBaseData = "data:image/png;base64,"+response;
                            _.assign(item,{isValidImage:true});
                            return;
                        }).catch(function(){
                            item.imgBaseData = vm.pictoImages.noImageCross.imgBaseData;
                            _.assign(item,{isValidImage:false});
                            return defer.reject()
                        })
                    } else {
                        item.imgBaseData = vm.pictoImages.noImageCross.imgBaseData;
                        _.assign(item,{isValidImage:false});
                        return defer.reject()
                    }
                })
                $q.all(promiseArray).then(function () {
                    formatDataToPrint(specialToolsDataItems, vm.pictoImages).then(function (response) {
                        pdfMake.tableLayouts = {
                            otherTableLayout: {
                                hLineWidth: function () {
                                    return 1;
                                },
                                vLineWidth: function () {
                                    return 1;
                                }
                            }, secondTableLayout: {
                                hLineWidth: function () {
                                    return 0;
                                },
                                vLineWidth: function () {
                                    return 0;
                                }
                            }
                        };
                        var pdfDocGenerator = pdfMake.createPdf(response.data);
                        pdfDocGenerator.getBuffer(function (buffer) {
                            var file = new Blob([(buffer)], { type: 'application/pdf' });
                            var isIE = false || !!document.documentMode;
                            var isEdge = !isIE && !!window.StyleMedia;
                            if (isIE || isEdge) {
                                FileSaver.saveAs(file, $translate.instant("LOCATION_CATA") + ".pdf");
                            } else {                                    
                                if (specialToolsDataItems.length <= 150) {
                                    printPdfModalService.encode64Base(file).then(function (response) {
                                        blockUI.stop();
                                        var modalParams = {
                                            data: response
                                        }
                                        return printPdfModalService.showModal(modalParams).catch(function () {
                                            $log.debug($translate.instant('ERROR'));
                                        });
                                    }).catch(function () {
                                        blockUI.stop();
                                        toastr.error($translate.instant('ERROR'));
                                    });
                                } else {
                                    toastr.info($translate.instant("INFO_NO_PRINT"))
                                    FileSaver.saveAs(file, $translate.instant("SPECIAL_TOOLS") + ".pdf");
                                }
                            }
                        })
                    });
                }).catch(function(error){
                    $log.debug($translate.instant('ERROR'));
                })
                .finally(function(){
                    blockUI.stop();
                })
            }
        }
        function formatDataToPrint(specialToolsDetails, pictoImageDetails) {
            var deferred = $q.defer();
            var dataToPrint = {
                translatedLabels: {
                    statusLabel: $translate.instant("SEARCH_SPECIALIZED_TOOL_DROPDOWN_TITLE"),
                    codeToolsLabel: $translate.instant("SEARCH_SPECIALIZED_TOOL_TOOLS_CODE"),
                    referenceLabel: $translate.instant("SEARCH_SPECIALIZED_TOOL_REFERENCE"),
                    supplierLabel: $translate.instant("SEARCH_SPECIALIZED_TOOL_SUPPLIER"),
                    descLabel: $translate.instant("SEARCH_SPECIALIZED_TOOL_DESCRIPTION"),
                    emptyLabel: ''
                }
            };
            var dataArray = [];
            var finalArr = [];
            var searchedVehDetails = vm.globalSearch.vehicle_family.toUpperCase() + (vm.globalSearch.engine_type.toUpperCase() ? "   " + vm.globalSearch.engine_type.toUpperCase() : '') + (vm.globalSearch.gearbox_type.toUpperCase() ? "   " + vm.globalSearch.gearbox_type.toUpperCase() : '') + (vm.globalSearch.battery_type.toUpperCase() ? "   " + vm.globalSearch.battery_type.toUpperCase() : '')
            var firstTable = [
                {
                    column1: {
                        data: searchedVehDetails,
                        alignment: "center"
                    }
                }
            ];
            var firstObj = {
                type: "table", values: getTableData(firstTable, false), styles: "secondTableHeader",
                layout: "secondTableLayout", widths: [400]
            };
            dataArray.push(firstObj);

            var selectedCatLabel = (vm.menu[vm.selected].label != 'SPECIALIZED_TOOL_MENU_ALL_SUBTYPES' ? vm.menu[vm.selected].docType.SPECIALTOOLS.subType[0] + "   :   "  : "") + $translate.instant(vm.menu[vm.selected].label);
            var secondTable = [
                {
                    column1: {
                        data: selectedCatLabel,
                        alignment: "center"
                    }
                }
            ];
            var secondObj = {
                type: "table", values: getTableData(secondTable, false), styles: "secondTableHeader",
                layout: "secondTableLayout", widths: [400]
            };
            dataArray.push(secondObj);

            var fourthTable = $filter('customFilter')(specialToolsDetails, vm.statusSelected);
            var filteredData = fourthTable.map(function (item) {
                var tableData = [];
                tableData[dataToPrint.translatedLabels.statusLabel] =
                {
                    data: (displayPictogram(item, true) == "stop") ? pictoImageDetails.essential.imgBaseData : (displayPictogram(item, true) == "star" ? pictoImageDetails.valid.imgBaseData : pictoImageDetails.white_empty.imgBaseData),
                    alignment: "right",
                    type: "smallImage"
                };
                tableData[dataToPrint.translatedLabels.codeToolsLabel] =
                {
                    data: item.identifier,
                    alignment: "left"
                };
                tableData[dataToPrint.translatedLabels.referenceLabel] =
                {
                    data: vm.removeSpacesFromReferenceNumber(item.reference),
                    alignment: "left"
                };
                tableData[dataToPrint.translatedLabels.supplierLabel] =
                {
                    data: item.supplier,
                    alignment: "left"
                };
                tableData[dataToPrint.translatedLabels.descLabel] =
                {
                    data: item.designation + '\n' + item.comment,
                    alignment: "left"
                };
                tableData[dataToPrint.translatedLabels.emptyLabel] =
                {
                    data: (item.thumbnailUrl && item.isValidImage)? item.imgBaseData : pictoImageDetails.noImageCross.imgBaseData,
                    alignment: "right",
                    type: (item.thumbnailUrl && item.isValidImage)? "bigImage" :"smallImage"
                };               
                return tableData;
            })

            var fourthObj = {};

            fourthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: [50,50, 50, 50, 170,100]
            };

            dataArray.push(fourthObj);
            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,true,false,false,false);
            var docDefinition = {
                info: {
                    title: "special tools",
                },
                content: [
                    finalArr
                ],
                styles: {
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [0, 5, 0, 0]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    },
                    tableIconStyle: {
                        margin: [0, 1.5, 0, 1.5],
                        alignment: "center"
                    }
                }
            };
            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }
        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }


    }
})
();

(function () {
    'use strict';
    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.electricalSchemaLevel3Multi, {
            url: '/electricalSchema/level3Multi',
            templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemalevel3Multi.template.html',
            controller: 'electricalSchemaLevel3MultiController',
            params: {
                node: null,     // MANDATORY
                WDList: null,   // MANDATORY
                isLiteApplicability: null,
                idlist: null,
                fromHarness: false,
                selectedComponent: null
            },
            // Redirect user if mandatary params are null;
            resolve: {
                data: function ($q, $stateParams) {
                    if (!$stateParams.node || !$stateParams.WDList) {
                        return $q.reject({
                            msg: RoutesConstants.errors.WRONG_PARAMS,
                            redirectTo: RoutesConstants.carSearchResult
                        });
                    }
                    return $q.resolve();
                }
            },
            controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.electricalSchemaLevel3Single, {
            url: '/electricalSchema/level3Single',
            templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemalevel3Single.template.html',
            controller: 'electricalSchemaLevel3SingleController',
            // Redirect user if mandatary params are null;
            params: {
                node: null,     // MANDATORY
                WD: null,       // MANDATORY
                WDList: null,
                componentCode: null,
                componentLabel: null,
                componentType: null,
                isComponentSelected: false,
                wiringDiagramData: null,
                thumbnailData: null,
                chosenComponent: null,
                CPCAndCSCElecSchemaWiringDiagram: null,
                CPCAndCSCElecSchemaThumbnailData: null,
                onlySignalElecSchemaWiringDiagram: null,
                isUserComingFromClip: false,
                isDetailMainComponentRequired: false,
                LC: null,
                WDT: null,
                id: null,
                idOptional: null,
                wiringDiagramsCache: null,
                isDetailsAvailable: false,
                connectorList: null,
                isHarness: false,
                fromHarness: false,
                selectedComponent: null
            },
            resolve: {
                data: function ($q, $stateParams) {
                    if ((!$stateParams.node || !$stateParams.WD) && $stateParams.isComponentSelected && !$stateParams.componentCode && !$stateParams.componentLabel) {
                        return $q.reject({
                            msg: RoutesConstants.errors.WRONG_PARAMS,
                            redirectTo: RoutesConstants.carSearchResult
                        });
                    } else if (!($stateParams.componentCode && $stateParams.componentLabel) && $stateParams.isComponentSelected) {
                        return $q.reject({
                            msg: RoutesConstants.errors.WRONG_PARAMS,
                            redirectTo: RoutesConstants.carSearchResult
                        });
                    }
                    return $q.resolve();
                }
            },
            controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.electricalSchemaHarness, {
            url: '/electricalSchema/Harness',
            templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemaHarness.template.html',
            controller: 'electricalSchemaHarnessController',
            params: {
                data: null     // MANDATORY
            },
            // Redirect user if mandatary params are null;
            resolve: {
                data: function ($q, $stateParams) {
                    if (!$stateParams.data ) {
                        return $q.reject({
                            msg: RoutesConstants.errors.WRONG_PARAMS,
                            redirectTo: RoutesConstants.carSearchResult
                        });
                    }
                    return $q.resolve();
                }
            },
            controllerAs: 'vm'
        });
    }
})();

(function () {
    angular.module('phenix').constant('searchElectricalSchemaConstant', {
        defaultTreeId: "WD_FUNCTIONS_TREE",
        getApplicabilitiesTree: "/proxy/apidh/rest/v1/applicabilities/tree",
        getWiringDiagramByIds: "/proxy/apidh/rest/v1/wiringDiagrams",
        getComponentDetailsById: "/proxy/apidh/rest/v1/wiringDiagrams/byComponentIds",
        getComponentsAndSignals:"/wd/ComponentsAndSignals",
        getByComponentIdLite: "/proxy/apidh/rest/v1/wiringDiagrams/byComponentIdLite",
        getBySignalIdLite: "/proxy/apidh/rest/v1/wiringDiagrams/bySignalIdLite",
        canHigh: ["CAN HIGH", "CAN H", "CANH", "H CAN", "HIGH CAN", "UPPER CAN", "CAN SGN H", "CAB MASTER PIU H_2 CAN SIGNAL"],
        canLow: ["CAN LOW", "CAN L", "CANL", "L CAN", "LOW CAN", "LOWER CAN", "CAN SGN L", "CAB MASTER PIU L_2 CAN SIGNAL"],
        errors: {
            NO_WIRING_AND_PART_HARNESS_IDS: 4801,
            NO_WIRING_AND_PART_HARNESS_DOCUMENTS: 4802,
            NO_TREE_RETURNED: 4803
        },
        nodeIdToEnglishLabel: {
            '2000': 'Anti-Theft',
            '2001': 'Driving_Assistance',
            '2002': 'Passenger_Compartment_Comfort',
            '2003': 'Transmission_Check',
            '2004': 'Engine_Check',
            '2005': 'Electrical_Distribution',
            '2006': 'Special_Equipment',
            '2007': 'On_Board_Instruments',
            '2008': 'Axle_Assembly',
            '2009': 'Passenger_Compartment_Safety',
            '2010': 'Visibility_And_Signalling',
            '2011': 'Network_diag'
        }
    });
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('searchElectricalSchema', {
            bindings: {
                nodes: '='
            },
            controller: SearchElectricalSchemaController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/searchElectricalSchema/searchElectricalSchema.template.html'
        })


    function SearchElectricalSchemaController(
        searchElectricalSchemaMetierService,
        CacheService,
        ScrollService,
        MainMetierService,

        searchElectricalSchemaConstant,
        RoutesConstants,
        CacheConstants,
        CarSearchResultConstants,

        toastr,

        $q,
        $translate,
        $timeout,
        $state,
        $mdMenu,
        $mdDialog,
        $filter,
        $rootScope,
        $scope,
        blockUI,
        configConstantes,$log,CloudFrontUrlHelper,SearchArboTextualMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.selectedNode = null;
        vm.selectedChildNode = null;

        vm.menu = [];
        vm.nodes2and3 = [];

        vm.WDList = [];
        vm.WD_CAN_DOC = [];
        vm.otherDocumentsList = [];
        vm.isWDCan = false;
        vm.isWDFusible = false;
        vm.isWDOtherDocument = false;
        vm.canExist = false;
        vm.nodeLevel3 = [];
        vm.user = CacheService.getObject(CacheConstants.profil);
        vm.wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria) ? CacheService.getObject(CacheConstants.wdObjectCriteria).header : [];
        vm.isTreeCalled = false;
        vm.isSearchByModel = MainMetierService.isSearchByModel();
        vm.isHorseUser = MainMetierService.isHorseUser();
        /**
         *      errors
         */

        vm.hideTree = false;
        vm.doneLoading = false;
        vm.ndDocumentsUrl = configConstantes.ndDocumentsUrl;
        vm.wdDocuments = "/wdDocuments/";
        vm.generalInfoFileName = 'General_Information';
        vm.newGeneralInfoFileName='General_Information_New';

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.selectNodeTwo = selectNodeTwo;
        vm.goToselectNode = goToselectNode;
        vm.displayCanAndFusesDocuments = displayCanAndFusesDocuments;
        vm.setCanDocButtonState = setCanDocButtonState;
        vm.enableOtherDocumentsList = enableOtherDocumentsList;
        vm.displayResidualFromDocumentName = displayResidualFromDocumentName;
        vm.setOtherDocumentsWidthValue = setOtherDocumentsWidthValue;
        vm.removeObjCriteria = removeObjCriteria;
        vm.removeCriteria = removeCriteria; 
        vm.initTree = initTree;
        vm.checkPlatfusi = checkPlatfusi;
        vm.displayPartHarness = displayPartHarness;
        vm.checkNode2WDHorseUser = checkNode2WDHorseUser;
        vm.formatLevel2Label = formatLevel2Label;
        vm.formatLevel3Label = formatLevel3Label;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        this.$onInit = function () {
            
            var userData = CacheService.getObject(CacheConstants.profil);
            if (userData && userData.language) {
                $translate.use(userData.language.toLowerCase());
            }
            var displayMessage = '';
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);
            if (carContext && carContext.fixedCriterias && carContext.fixedCriterias['007'] === 'XR310') {
                displayMessage = 'WD_POPIN_MESSAGE';
            } else if (carContext && carContext.fixedCriterias && carContext.fixedCriterias['007'] === 'XEF' && carContext.fixedCriterias['997'] === 'DW6') {
                displayMessage = 'WD_POPIN_INFO';
            }
            var wdMsgShown = CacheService.getObject(CacheConstants.wdMessageShow);
            if(displayMessage != '' && !wdMsgShown){
                var body = angular.element(document.body);
                CacheService.setObject(CacheConstants.wdMessageShow,true);
                $mdDialog.show({
                    parent: body,
                    templateUrl: "app/components/car/searchElectricalSchema/wdPopinMessage.template.html",
                    controller: ['$scope', wdPopupController],
                    controllerAs: 'vm',
                    locals:{
                        displayMessage
                    },
                    bindToController: true,
                    clickOutsideToClose: true,
                    multiple: true,
                    skipHide: true
                }).finally(function () {
                   toExecuteAfterMDDialog(); 
                });
            } else {
                toExecuteAfterMDDialog();
            }
           

        };
        function wdPopupController($scope) {
            const vm = this;
            $scope.close = function () {
                $mdDialog.hide();
            };
        }


        function toExecuteAfterMDDialog(){
            if (!CacheService.getObject(CacheConstants.treeContainingNodes)) {
                blockUI.start();
                vm.wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria) ? CacheService.getObject(CacheConstants.wdObjectCriteria).header : [];

                //var isTreecalled = vm.wdObjectCriteria.length > 0 ? true: false;
                $q.all([
                    searchElectricalSchemaMetierService.getApplicabilitiesTree(vm.isTreeCalled, vm.wdObjectCriteria),
                    searchElectricalSchemaMetierService.getAndSaveCan_Doc(vm.isTreeCalled, vm.wdObjectCriteria),
                    searchElectricalSchemaMetierService.getAndSaveComponents_Signals()
                ]).then(function (result) {
                    var tree = result[0];
                    CacheService.setObject(CacheConstants.treeContainingNodes, tree);
                    vm.WDList = result[1];
                    tree = disableNodes(tree);

                    if (vm.nodes && typeof vm.nodes === 'object') {
                        restoreTree(tree, vm.nodes);
                        // if user click on other tab and come back we doesn't want to restore again
                        vm.nodes = null;
                    } else {
                        initTree(tree);
                    }

                    vm.WD_CAN_DOC = CacheService.getCAN_Document();
                    vm.setCanDocButtonState();
                    vm.enableOtherDocumentsList();
                    vm.checkPlatfusi();

                    if (!_.isEmpty($rootScope.nodeId)) {
                        if ($rootScope.nodeId.nodeThreeID && Object.keys($rootScope.nodeId).length === 1) {
                            var node = _.find(vm.nodeLevel3, function (nodeThree) {
                                if ($rootScope.nodeId.nodeThreeID === nodeThree.nodeId) {
                                    return nodeThree;
                                }
                            });

                            if (node != null) {
                                goToselectNode(vm.nodeLevel3, node);
                            }
                            else {
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                            }

                        }
                        else {
                            restoreTree(tree, $rootScope.nodeId);
                        }

                        $rootScope.nodeId = null;
                    }


                }).catch(function (err) {
                    $rootScope.WDerror = true;
                    vm.hideTree = true;
                    if (typeof err === "number") {
                        switch (err) {
                            case searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_IDS:
                            case searchElectricalSchemaConstant.errors.NO_TREE_RETURNED:
                            case searchElectricalSchemaConstant.errors.NO_WIRING_AND_PART_HARNESS_DOCUMENTS:
                                CacheService.removeObject(CacheConstants.wiringDiagramsCanDocument);
                                CacheService.removeObject(CacheConstants.treeContainingNodes);
                                CacheService.removeObject(CacheConstants.wdObjectCriteria);
                                CacheService.removeObject(CacheConstants.componentsAndSignals);
                                break;
                            default:
                                toastr.error($translate.instant('ERROR') + ' : ' + err);
                                break;
                        }
                    } else {
                        toastr.error($translate.instant('ERROR'));
                    }
                }).finally(function () {
                    blockUI.stop();
                    vm.doneLoading = true;
                });
            } else {
                var tree = (CacheService.getObject(CacheConstants.treeContainingNodes));
                tree = disableNodes(tree);

                if (vm.nodes && typeof vm.nodes === 'object') {
                    restoreTree(tree, vm.nodes);
                    // if user click on other tab and come back we doesn't want to restore again
                    vm.nodes = null;
                } else {
                    initTree(tree);
                }
                vm.doneLoading = true;
                vm.WD_CAN_DOC = CacheService.getCAN_Document();
                vm.setCanDocButtonState();
                vm.enableOtherDocumentsList();
            }
        }
        /**
         * @description use jQuery attribute functions to set custom width to md-menu-content
         */

        function setOtherDocumentsWidthValue() {
            SearchArboTextualMetierService.setConnectedServicesAuditData('WD_Other_Document').then(function () {});
            $("#otherDocumentsMenu").removeAttr("width");
        }


        /**
         * @description set the stage of the button CAN, DOCUMENT and Other Document
         */

        function setCanDocButtonState() {
            var WD_CAN_DOC = CacheService.getCAN_Document();
            vm.isWDOtherDocument = true;

            if (WD_CAN_DOC.can && WD_CAN_DOC.can.length > 0) {
                vm.isWDCan = true;
            }

            else {
                vm.isWDCan = false;
            }

            if (WD_CAN_DOC.fusible && WD_CAN_DOC.fusible.length > 0) {
                vm.isWDFusible = true;
            }

        }

        function checkPlatfusi(){
            var WD_CAN_DOC = CacheService.getCAN_Document();
            if (!vm.isTreeCalled && WD_CAN_DOC.fusible && WD_CAN_DOC.fusible.length > 2) {
                var platfusi = WD_CAN_DOC.fusible;
                var parent = angular.element(document.body);
                $mdDialog.show({
                    parent: parent,
                    templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/objectCriteriaModal.template.html',
                    controller: 'ObjectCriteriaModalCtrl',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    bindToController: true,
                    controllerAs: 'vm',
                    locals: {
                        wiringDiagrams: platfusi,
                    }
                }).then(function(result){
                    vm.isTreeCalled = true;
                    CacheService.setObject(CacheConstants.wdObjectCriteria,result);
                    CacheService.removeObject(CacheConstants.wiringDiagramsCanDocument);
                    CacheService.removeObject(CacheConstants.treeContainingNodes);
                    vm.$onInit();
                })
            }

        }

        /**
         * @desc set the state of otherDocumentList *dropdown
         */

        function enableOtherDocumentsList() {
            var WD_CAN_DOC = CacheService.getCAN_Document();
            vm.otherDocumentsList = [];
            if (WD_CAN_DOC.otherDocs && WD_CAN_DOC.otherDocs.length > 0) {
                for (var i = 0; i < WD_CAN_DOC.otherDocs.length; i++) {
                    if (WD_CAN_DOC.otherDocs[i].name && WD_CAN_DOC.otherDocs[i].name.length > 0) {
                        vm.otherDocumentsList.push(WD_CAN_DOC.otherDocs[i].name);
                    }
                }
            }

            vm.otherDocumentsList.push('GENERAL_INFORMATION');
            vm.otherDocumentsList = _.uniq(vm.otherDocumentsList);
        }



        /**
         * @description get Other Documents from Cache, filter them by name, and return corresponding names in array
         */

        function displayResidualFromDocumentName(documentName) {

            var WD_CAN_DOC = CacheService.getCAN_Document();
            var tmpArray = [];
            
            vm.otherDocumentsList.forEach(function (item) {
                var nameItem = item;
                if (item === documentName) {
                    WD_CAN_DOC.otherDocs.forEach(function (obj) {
                        if (nameItem === obj.name) {
                            searchElectricalSchemaMetierService.formatResidualDoc_Can(obj);
                            if (obj.location) {
                                obj.location = CloudFrontUrlHelper.appendCloudFrontParams(obj.location);
                            }
                            tmpArray.push(obj);
                        }
                    })
                }
                
            });
            if (tmpArray.length == 0){
                var langList = [ 'cs', 'de', 'es', 'fa','fi','he', 'hr', 'hu', 'it', 'ja', 'ko', 'le', 'nl', 'pl', 'pt', 'ro', 'ru', 'sl', 'sv', 'tr'];
                var newLangList=['en','fr'];
                var url = '';
                if (langList.includes(vm.user.documentationFirstLanguage.code)){
                    url = vm.ndDocumentsUrl + vm.wdDocuments + vm.generalInfoFileName + '_' + vm.user.documentationFirstLanguage.code + '.pdf';
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(url);
                    window.open(signedUrl,'_blank');
                }
                else if(newLangList.includes(vm.user.documentationFirstLanguage.code)){
                    url = vm.ndDocumentsUrl + vm.wdDocuments + vm.newGeneralInfoFileName + '-' + vm.user.documentationFirstLanguage.code.toUpperCase() + '.pdf';
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(url);
                    window.open(signedUrl,'_blank');
                }
                else{
                    url = vm.ndDocumentsUrl + vm.wdDocuments + vm.generalInfoFileName + '_en.pdf';
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(url);
                    window.open(signedUrl,'_blank');
                }
                
            }
            else{
                var numberOfResidualLines = 0;

                tmpArray.forEach(function (item) {
                    if (item.residual && item.residual.length > 0) {
                        numberOfResidualLines++;
                    }
                });

                if (numberOfResidualLines === 1 || tmpArray.length === 1) {
                    var signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(tmpArray[0].location);
                    window.open(signedUrl);
                } else {

                    $mdDialog.show({
                        templateUrl: 'app/components/car/searchElectricalSchema/selectedNode/electricalSchemaCanFusibleDocResidualList.template.html',
                        controller: 'electricalSchemaCanFusibleDocResidualListController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: false,
                        locals: {
                            documentToDisplay: tmpArray
                        }
                    }).catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });

                }
            }

            

        }

        /**
         *  @desc   Display tree on a specific node
         *          data may contains 3 props 'nodeTwoID', 'nodeOneID', 'nodeThree'
         *  @param {object} tree
         *  @param {object} data
         */
        function restoreTree(tree, data) {
            vm.menu = tree;

            if (data.nodeOneID) {
                // selectedNodeOne is a node from level 1 (left menu)
                vm.selectedNodeOne = _.find(vm.menu, function (nodeOne) {
                    return nodeOne.nodeId === data.nodeOneID;
                });
                if (vm.selectedNodeOne) {
                    // we need to get data from this node to display it on the left of the menu
                    vm.tmpLevel2 = vm.selectedNodeOne.childNodes;
                    getNodesSecondAndThirdLevel(vm.tmpLevel2);

                }
            }

            var nodeLevel = Object.keys(data).length;


            // Process to know where we need to scroll when user come from a specific node
            // It can be on level 1,2,3. Menu contains nested child, level 3 is far deeper
            // that why we find in vm.menu (level1) -> level2 (level2) -> childNodes (level3)

            if (nodeLevel === 1) {
                if (vm.selectedNodeOne != null){
                    $timeout(function () {
                        ScrollService.animateTo('#searchElectricalSchema');
                    }, 0);
                }
                else{
                    toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                }
                
            } else if (nodeLevel === 2) {

                if (data.nodeTwoID && vm.tmpLevel2) {
                    vm.selectedChildNode = _.find(vm.tmpLevel2, function (nodeTwo) {
                        return nodeTwo.nodeId === data.nodeTwoID;
                    });
                    if (vm.selectedChildNode) {
                        $timeout(function () {
                            ScrollService.animateTo('#' + vm.selectedChildNode.nodeId);
                        }, 0);
                    }
                    else{
                        toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                    }
                }
                
            } else if (nodeLevel === 3){
                if (data.nodeTwoID && data.nodeThreeID && vm.nodes2and3) {
                    var level2node = _.find(vm.nodes2and3, function (nodeTwo) {
                        return nodeTwo.node.nodeId === data.nodeTwoID;
                    });
                    if (level2node.node && level2node.node.childNodes && nodeLevel === 3) {
                        var node = _.find(level2node.node.childNodes, function (nodeThree) {
                            return nodeThree.nodeId === data.nodeThreeID
                        })
                        if (node != null){
                            goToselectNode(level2node,node);
                        }
                        else{
                            toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                        }
                    }
                    
                }
            }
            else{
                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
            }
        }

        /**
         *      @desc Disable node if we don't find electrical schema associated
         *      @return {object}
         */

        function disableNodes(tree) {
            return tree.map(function (level1) {
                if (Array.isArray(level1.childNodes)) {
                    level1.childNodes = level1.childNodes.map(function (level2) {
                        if (Array.isArray(level2.childNodes)) {
                            level2.childNodes = level2.childNodes.map(function (level3) {
                                if (Array.isArray(level3.associatedDocument)) {
                                    // level3.activated = level3.associatedDocument.some(function (doc) {
                                    //     if (Array.isArray(doc.ids)) {
                                    //         var count = doc.ids.length;
                                    //         for (var index in doc.ids) {
                                    //             var es = _.find(vm.WDList, function (wd) {
                                    //                 return wd.id === doc.ids[index];
                                    //             });
                                    //             if (es) {
                                    //                 count--;
                                    //             }
                                    //         }
                                    //         if (count !== doc.ids.length) {
                                    //             return true;
                                    //         } else {
                                    //             return false;
                                    //         }
                                    //     }
                                    //     return false
                                    // })
                                    vm.nodeLevel3.push(level3);
                                    level3.activated = true;
                                }
                                return level3;
                            });
                            level2.activated = level2.childNodes.some(function (level3) {
                                return level3.activated;
                            });
                        }
                        return level2;
                    })
                }
                return level1;
            });
        }

        /**
         * @desc function called in order to set the node to the view, by default, we select the first element (vm.selectedNode = vm.menu[0]).
         * TODO in a second step, it will be necessary to manage the historization of the selected nodes
         * @param {Object} nodes is provided by the service getApplicabilitiesTree() or in cache : CacheConstants.electricalSchema.
         */

        function initTree(nodes) {
            vm.menu = nodes;

            //Set the tree data to Cache which can be used on Single3 controller when no node is selected
            

            if (vm.menu) {
                if(vm.isHorseUser){
                    var data = _.findIndex(vm.menu, function(item){
                        return CarSearchResultConstants.node2WDHorseList.includes(item.nodeId)
                    })
                    vm.selectedNodeOne = vm.menu[data];
                } else
                    vm.selectedNodeOne = vm.menu[0];
            }

            selectNodeTwo(vm.selectedNodeOne.nodeId);
        }

        /**
         * @desc function called to display level 2 and 3 nodes
         * @param {Object} nodeId Json node in order to displsay childNodes to the view
         */

        function selectNodeTwo(nodeId) {
            var nodeFound = _.find(vm.menu, function (node) {
                return nodeId === node.nodeId;
            });

            var englishLabel = searchElectricalSchemaConstant.nodeIdToEnglishLabel[nodeFound.nodeId] || nodeFound.nodeId;
            SearchArboTextualMetierService.setConnectedServicesAuditData(englishLabel).then(function () {});
            vm.selectedNodeOne = nodeFound;
            vm.tmpLevel2= nodeFound.childNodes;

            getNodesSecondAndThirdLevel(vm.tmpLevel2);
        }

        /**
         * @desc Get level 2 and 3 nodes for a level 1 node from cache
         * @param node the tree of level 2 and 3 nodes to be formatted before being sent to the HTML
         */
        function getNodesSecondAndThirdLevel(node) {
            initFilter();

            vm.nodes2and3 = [];

            if (node == null) { // if error
                toastr.error('Error BACK :Error');
            } else { // if success
                var dataArboLevelTwoAndThree = node;
                vm.showSearchNav = true;
                vm.showSearchRef = false;
                for (var level in dataArboLevelTwoAndThree) {
                    var arrayChunk = getArrayChunk(dataArboLevelTwoAndThree[level].childNodes);
                    vm.nodes2and3.push({ "node": dataArboLevelTwoAndThree[level], "arrays": arrayChunk });
                }
            }
        }

        /**
         * @desc order level 3 nodes in 3 arrays to show them in 3 columns in the table  
         * @param node the tree of level 2 and 3 nodes to be formatted before being sent to the HTML
         * @returns {Array}
         */
        function getArrayChunk(node) {
            var result0 = [];
            var result1 = [];
            var result2 = [];
            var order = [];

            var j = 0;
            for (var i = 0; i < (node.length); i = i + 3) {
                if (node[i] != null) {
                    result0[j] = node[i];
                } else {
                    break;
                }
                if (node[i + 1] != null) {
                    result1[j] = node[i + 1];
                } else {
                    break;
                }
                if (node[i + 2] != null) {
                    result2[j] = node[i + 2];
                } else {
                    break;
                }
                j++;
            }

            order[0] = result0.slice(0, result0.length);
            order[1] = result1.slice(0, result1.length);
            order[2] = result2.slice(0, result2.length);

            return order;
        }


        /**
         * @desc initialise the filter with all values
         */
        function initFilter() {
            //fixed this later
            // vm.selectedFilter = vm.initialFitlters[0];
            vm.selectedFilter = "All";
            changeFilter(vm.selectedFilter);
        }


        function changeFilter(filter) {
            vm.selectedFilter = filter;
            vm.filterTypes = _.filter(vm.initialFitlters, function (n) {
                return n.id !== filter.id;
            });
        }

        /**
         * @desc Function which redirected to the electrical schema selected
         * @param {*Json Object} level2 correspond to the level 2 node
         * @param {*Json Object} selectedNodeLevel3 correspond to the level 3 node whici is selected
         */
        function goToselectNode(level2, selectedNodeLevel3) {
            var breadcrumb = [vm.selectedNodeOne, level2, selectedNodeLevel3];

            var idlist = [];
            for (var i = 0; i < selectedNodeLevel3.associatedDocument.length; i++) {
                for (var j = 0; j < selectedNodeLevel3.associatedDocument[i]['ids'].length; j++) {
                    idlist.push(selectedNodeLevel3.associatedDocument[i]['ids'][j])
                }
            }

            var WDList = [];
            blockUI.start();

            if (vm.isSearchByModel){
                
                return searchElectricalSchemaMetierService.getWiringDiagramByIds(idlist,true,vm.wdObjectCriteria).then(function (res) {

                    WDList = res[0].WIRING_DIAGRAMS;
                    if (WDList == undefined) {
                    }
                    else if (WDList.length === 1) {
                        $state.go(RoutesConstants.electricalSchemaLevel3Single, { node: breadcrumb, WD: WDList[0], WDList: WDList, isFromWDUrlLink: false });
                    } else if (WDList.length > 1) {
                        $state.go(RoutesConstants.electricalSchemaLevel3Multi, { node: breadcrumb, WDList: WDList, isLiteApplicability: vm.isSearchByModel, idlist:idlist, isFromWDUrlLink: false });
                    }
    
                }).finally(function () {
                    blockUI.stop();
                });
            }
            else{
                return searchElectricalSchemaMetierService.getWiringDiagramByIdsWithFullContext(idlist).then(function (res) {

                    WDList = res[0].WIRING_DIAGRAMS;
                    if (WDList == undefined) {
                    }
                    else if (WDList.length === 1) {
                        $state.go(RoutesConstants.electricalSchemaLevel3Single, { node: breadcrumb, WD: WDList[0],WDList: WDList, isFromWDUrlLink: false });
                    } else if (WDList.length > 1) {
                        $state.go(RoutesConstants.electricalSchemaLevel3Multi, { node: breadcrumb, WDList: WDList, isLiteApplicability: vm.isSearchByModel, idlist:idlist, isFromWDUrlLink: false });
                    }
    
                }).then(function () {
                    if (WDList == undefined) {
                        return searchElectricalSchemaMetierService.getWiringDiagramByIds(idlist,true,vm.wdObjectCriteria).then(function (res) {
                            WDList = res[0].WIRING_DIAGRAMS;
                            if (WDList == undefined) {
                                toastr.error($translate.instant('CRITERIA_TOASTER'));
                            }
                            else if (WDList.length === 1) {
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, { node: breadcrumb, WD: WDList[0], WDList: WDList, isFromWDUrlLink: false });
                            } else if (WDList.length > 1) {
                                $state.go(RoutesConstants.electricalSchemaLevel3Multi, { node: breadcrumb, WDList: WDList, isLiteApplicability: true, idlist:idlist, isFromWDUrlLink: false });
                            }
                        })
                    }                
                }).finally(function () {
                    blockUI.stop();
                });

            }
            
        }

        function displayCanAndFusesDocuments(WDList, typeOfDoc) {
            const logType = typeOfDoc === 'CAN' ? 'WD_CAN_Network' : 'WD_Fuse_Relay';
            SearchArboTextualMetierService.setConnectedServicesAuditData(logType).then(function () {});
            searchElectricalSchemaMetierService.displayCanAndFusesDocuments(vm.WD_CAN_DOC, typeOfDoc);
        }
        function displayPartHarness(){
            var componentsAndSignals = CacheService.getObject(CacheConstants.componentsAndSignals);
            var idList =[];
            var components =  _.filter(componentsAndSignals.list, function(item){
                if (item.type == "WD_COMPONENT"){
                    idList.push(item.id);
                }
            })
            blockUI.start();

            return searchElectricalSchemaMetierService.getHarnessLayoutDetails(idList).then(function (res) {

                res = convertArrayWDResponseToObject(res);
                $state.go(RoutesConstants.electricalSchemaHarness, { data: res.WIRING_DIAGRAMS});
            })
            .finally( function (){
                blockUI.stop();
            })

        }

        /**
        * @description Used to convert incoming array into an object
        * @param {*} res
        */
       function convertArrayWDResponseToObject(res) {
            var result = {
                WIRING_DIAGRAMS: []
            }

            if (res && res.length) {
                res.forEach(function (item) {
                    result.WIRING_DIAGRAMS.push.apply(result.WIRING_DIAGRAMS, item.WIRING_DIAGRAMS);
                });
            }
            return result;
        }

        function removeObjCriteria(){
            vm.wdObjectCriteria = null;
            CacheService.removeObject(CacheConstants.wdObjectCriteria);
            if (vm.isSearchByModel){
                CacheService.removeObject(CacheConstants.wiringDiagramsCanDocument);
                CacheService.removeObject(CacheConstants.treeContainingNodes);
                vm.isTreeCalled = false;
                this.$onInit();
            }

        }

        function removeCriteria(codeCrit,codeObj){
            var resetTree = false;
            var idx =  _.findIndex(vm.wdObjectCriteria,function(item){                
                return item.codeCrit === codeCrit;
            })
            if (codeObj == "APVAP1" || codeObj == "956" || codeObj == "901"){
                resetTree = true;
            } 

            vm.wdObjectCriteria.splice(idx,1);

            var  updatedWdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria);
            updatedWdObjectCriteria.header = vm.wdObjectCriteria;
            CacheService.setObject(CacheConstants.wdObjectCriteria,updatedWdObjectCriteria);

            if (resetTree){
                CacheService.removeObject(CacheConstants.wiringDiagramsCanDocument);
                CacheService.removeObject(CacheConstants.treeContainingNodes);
                CacheService.removeObject(CacheConstants.wdObjectCriteria);
                vm.isTreeCalled = false;
                this.$onInit();
            }

        }
        function checkNode2WDHorseUser(nodeId){
            return CarSearchResultConstants.node2WDHorseList.includes(nodeId);
        }

        function capitalizeCanLis(label) {
            if (!label) {
                return label;
            }
            var camelCased = $filter('toCamelCase')(label);
            return camelCased.replace(/\b(can|lis)\b/gi, function (match) {
                return match.toUpperCase();
            });
        }

        function formatLevel2Label(level2) {
            if (!level2 || !level2.label) {
                return level2 && level2.label;
            }

            return capitalizeCanLis(level2.label);
        }

        function formatLevel3Label(level2, label) {
            if (!label) {
                return label;
            }

            var isNetworkDiagnosisCanCommunication =
                vm.selectedNodeOne &&
                String(vm.selectedNodeOne.nodeId) === '2011' &&
                level2 && level2.node &&
                String(level2.node.nodeId) === '3090';

            if (isNetworkDiagnosisCanCommunication) {
                return label.toUpperCase();
            }

            return capitalizeCanLis(label);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('symptomSearch', symptomSearch);

    /** @ngInject */
    function symptomSearch() {

        var directive = {
            templateUrl:'app/components/car/searchByDiagnostic/symptomSearch.template.html',
            restrict: 'E',
            replace: true
        };
        return directive;
    }

})();

'use strict';

angular.module('phenix').constant('SearchbyDiagnosticConstants', {

    adtRnetRoles: [
        "IRN-67551:tech", "IRN-67551:diagnosis", "IRN-67551:immo",
        "IRN-67551:independent", "IRN-67551:rep"
    ],
    adtTechRole: 'IRN-67551:TECH',
    adtDiagnosisRole: 'IRN-67551:DIAGNOSIS',
    adtImmoRole: 'IRN-67551:IMMO',
    adtIndependentRole: 'IRN-67551:INDEPENDENT',
    adtRepRole: 'IRN-67551:REP',
    checkId: 'vehicleDiag/diag/',
    updateRemoteDiagId: '/vehicleDiag/updateDiagID/',
    updateRemoteDiagStatus: '/vehicleDiag/updateDiagStatus/',
    remoteStatus: [
        {id: 'SUCCESS' , status : ['SUCCESS']},
        {id: 'FAILED' , status : ['ERROR']},
        {id: 'IN_PROGRESS' , status : ['PENDING']},
    ],
    statusSuccess: 'SUCCESS',
    statusFailed: 'FAILED',
    statusInProgress: 'IN_PROGRESS',
    notificationsUrl: '/notifications',
    notificationUnreadCountUrl: '/notifications/unread-count',
    notificationPopInUrl: '/notifications/pop-in'
});

(function() {
    'use strict';

    angular
        .module('phenix')
        .service('SearchByDiagnosticService', SearchByDiagnosticService);

    /* @ngInject */
    function SearchByDiagnosticService() {
        this.defineRules = defineRules;
        
        ////////////////

        function defineRules(vm) {
            // If this unfamiliar to you, Object.defineProperties is a way to create
            // computed properties on an object.
            Object.defineProperties(vm.rules, {
                'SymptomActivated': {
                    enumerable: true,
                    get: function () {
                        return (!vm.search.dtcCode || !vm.data.defaultCode) && vm.search.symptom && vm.search.symptom.length >=3;
                    }
                },
                'DTCActivated': {
                    enumerable: true,
                    get: function () {
                        return (!vm.search.symptom || !vm.data.defaultCode) && vm.search.dtcCode && vm.search.dtcCode.length >=3;
                    }
                },
                'DefaultCodeActivated': {
                    enumerable: true,
                    get: function () {
                        return (!vm.search.symptom || !vm.data.dtcCode) && vm.search.defaultCode && vm.search.defaultCode.length >=3;
                    }
                },
                'showCodeDefault': {
                    enumerable: true,
                    get: function () {                    
              
                        return ((vm.typeMD === "B2" || vm.typeMD === "B2-3")) ;
                    }
                },
                'showCodeDtc': {
                    enumerable: true,
                    get: function () {
                        
                        return ((vm.typeMD === "B3" || vm.typeMD === "ADT"));
                    }
                },
                'showSymptom': {
                  enumerable: true,
                  get: function () {          
                      return  ((vm.typeMD === "B3")) ;
                  }
              }


            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider
            .state(RoutesConstants.searchByDiagnostic, {
                url: '/searchByDiagnostic',
                params: {
                    data: null,
                    symptomCode: null,
                    code: null,
                    fetchedSymptoms: null
                },
                templateUrl: 'app/components/car/searchByDiagnostic/searchByDiagnostic.template.html',
                controller: 'SearchByDiagnosticController',
                controllerAs: 'vm'
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('searchByDiagnostic', searchByDiagnostic);

    /** @ngInject */
    function searchByDiagnostic() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: "SearchByDiagnosticController",
            templateUrl:'app/components/car/searchByDiagnostic/searchByDiagnostic.template.html',
            controllerAs: 'vm',
            restrict: 'E',
            scope: {
                responseApi: '<',
                isDaysToReopen: '<'
            }
        };
        return directive;


    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .filter('momentLocaleDate', function ($translate) {
        return function (value) {

            var locale = $translate.use();
            if(locale === 'no')
                locale='nn';
            if(locale === 'zh')
                locale = 'zh-cn';
            var date = moment(value).locale(locale).format("dddd DD MMMM YYYY")
            return date;
        }
    }).controller('SearchByDiagnosticController', SearchByDiagnosticController);

    /* @inject */
    function SearchByDiagnosticController(SearchByDiagnosticService, ResultSearchByDiagnosticMetierService, activeVinService, toastr, DiagFileBusinessService, MainMetierService, configConstantes,
        CacheService, CacheConstants, systemDocumentationConstants, blockUI, $state, RoutesConstants, $translate, $filter, $location, $q,rLinkConstant,CarSearchMetierService,
        $mdDialog, $document, DiagFileDetailsNewConstants, ResultSearchByDiagnosticConstants, UtilsMetierService, $scope, $rootScope, SearchbyDiagnosticConstants,ActisConstantes,$timeout,CarSearchResultConstants,RLinkCarMetierService, $log,FicInputValidationService,PDFViewService,printPdfModalService,FileSaver,CarSearchWsService,SearchArboTextualMetierService, CarSearchConstants) {

        /** VARIABLES */
        var vm = this;
        $rootScope.ficReopenEnabled = false;

        $scope.$on('ficReopened', function(event, data) {
            $rootScope.ficReopenEnabled = true;
        });
        vm.isFicReopenClicked = false;
        vm.isSymptomInputEnabled = false;
        vm.normalizeFilter = normalizeFilter;
        vm.search = {};
        vm.data = {};
        vm.dataSymptoms = {};
        vm.rules = {};
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.historyPagination = {
            "ECU":{"screen":DiagFileDetailsNewConstants.ECU, "category":""},
            "DTC":{"screen":DiagFileDetailsNewConstants.DTC, "category":"" },
            "alert":{"screen":DiagFileDetailsNewConstants.alerts, "category":""},
            "network":{"screen":DiagFileDetailsNewConstants.network ,"category":DiagFileDetailsNewConstants.customerReport},
            "userJourney":{"screen":DiagFileDetailsNewConstants.userJourney,"category":DiagFileDetailsNewConstants.customerReport},
            "OCV":{"screen":DiagFileDetailsNewConstants.OCV,"category":DiagFileDetailsNewConstants.customerReport}
        }
        vm.typeMD = CacheService.getCarContext() ? CacheService.getCarContext().typeMD : '';
        vm.contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);
        vm.contextCarVinCurrent = vm.contextVehicle ? vm.contextVehicle.vehicle.vin : '';
        vm.carSymptomsList = [];
        vm.searchedSymptom = { code: '', label: '' };
        vm.carContext = CacheService.getCarContext();
            vm.diagCond =(vm.carContext && vm.carContext.typeMD && (!(vm.carContext.typeMD.includes('B3')) && !(vm.carContext.typeMD.includes('ADT')) && !(vm.carContext.typeMD.includes('B2'))));

        vm.diagSearch= {"system":{"active":false,"icon":false},
                "remoteList":{"active":false,"icon":false},
                "solution":{"active":false,"icon":true},
                "diagnosticFile":{"active":true,"icon":false},
                "binDiagnosticFile":{"active":false,"icon":false},
                "history":{"active":false,"icon":true},
                "ecu": {"active":false,"icon":false},
                "network": {"active":false,"icon":false},
                "userjourney":{"active":false, "icon":false},
                "dtcHistory":{"active":false,"icon": false},
                "nvPreparation":{"active":false,"icon": true},
                "ocv":{"active":false,"icon": false},
                "alert":{"active":false,"icon":false},
                "diagCompare":{"active":false, "icon":false},
                "reprogrammingHistory": {"active":false, "icon":false},
                "batteryReuseCrash": {"active":false, "icon":false},
                "historyPage": {"active":false, "icon":false}
                };
        
        var systemDocDetails = CacheService.getObject(CacheConstants.systemDocDetails);
        if(systemDocDetails && systemDocDetails.isSystemDocEnable){
            vm.isOpenSystemDoc = true;
            showSystem();
        }
        vm.diagDataFound = true;
        vm.proactiveAlertCheck = false;
        vm.selectedDiagFile = null;
        vm.firstSelectedDiagFile = null;
        vm.secondSelectedDiagFile = null;
        vm.user = CacheService.getUserProfile();
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.isRnetUser = MainMetierService.isRnetUserType(vm.user.userType);
        vm.displayText = $translate.instant('NOTHING_SELECTED');
        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
        vm.secondDiagFilesList = [];
        vm.isSearchByModel = MainMetierService.isSearchByModel();
        vm.displaySympText = '';
        vm.selectedSympBasket = null;
        vm.selectedSympBasketId = null;
        vm.sympBasketFound = true;
        vm.isHistoryPagination = false;
        vm.symptomsBasketList = CacheService.getObject(CacheConstants.symptomsBasketList);
        vm.isDiagFileDisplay = (CacheService.getObject(CacheConstants.diagFileDisplay) !== null && CacheService.getObject(CacheConstants.diagFileDisplay) !== undefined ) ? CacheService.getObject(CacheConstants.diagFileDisplay) : true;        
        vm.showDiagHelpContent = false;
        vm.showBINContent = false;
        vm.showSymptom = true;
        vm.isIndependentUser = UtilsMetierService.isIndependentUser(); 
        vm.isDisplayDiagForNissan = MainMetierService.isEnableDiagForNissan();
        vm.adtTechrole = false;
        vm.adtOtherRoles= false;
        vm.showDTCcompareRnet = false;
        $scope.origin = [];
        vm.listOfDTC = [];
        vm.systemDocResponse=[];
        if (vm.user && vm.user.roles && (vm.isRnetUser || vm.isArcaUser || vm.isDisplayDiagForNissan)) {
            if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtTechRole)) {
                vm.adtTechrole = true;
                vm.showDTCcompareRnet = true;
            }
            else if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtDiagnosisRole) || vm.user.roles.includes(SearchbyDiagnosticConstants.adtImmoRole)) {
                vm.adtOtherRoles = false;
                vm.showDTCcompareRnet = true;
            }
            else if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtIndependentRole)) {
                vm.adtOtherRoles = true;
            }
            else if(vm.user.roles.includes(SearchbyDiagnosticConstants.adtRepRole)) {
                vm.adtNoRoles = true;
            }
            else if(vm.isRnetUser){
                vm.adtNoRoles = true;
            }
        }
        vm.isRLink2Vehicle = false;
        vm.isEasyLinkVehicle = false;
        vm.isUnknownVehicle = false;
        vm.hasTabAccess = vm.isIndependentUser || vm.isSearchByModel || vm.adtOtherRoles;
        vm.systemDocSubMenu = [];
        vm.systemDocResponse = [];
        vm.dataperPage = vm.dataperPage1 = vm.dataperPage2 = 10;
        vm.binVal = '';
        vm.currentPage = CacheService.getObject(CacheConstants.diagCurrentPage) ? CacheService.getObject(CacheConstants.diagCurrentPage) : 1;
        vm.newPage = vm.currentPage;
        vm.loadPagination = false;
        vm.loadADTPagination = false;
        vm.diagfirstSelected = false;
        vm.ipnList = [];
        vm.dealerList = [];
        vm.reprogrammingHistoryCheck = UtilsMetierService.isVespaProfil(vm.user);
        vm.batteryReuseCrashCheck = UtilsMetierService.showBatteryPostCrash();
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.featureData = {};
        $rootScope.asomDocList = $rootScope.asomDocList || {};
        vm.loadSymptomSearch = false;
        vm.tokenBalance=UtilsMetierService.getTokenBalance();
        vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
        vm.isCirSentVin = vm.carContext ? MainMetierService.isCirSentVin(vm.carContext.vin):null;


        /** FUNCTIONS */
        vm.goToResultByDiagnostic = goToResultByDiagnostic;
        vm.getOnlyLabelSymptoms = getOnlyLabelSymptoms;
        vm.getSymptomsBasketList = getSymptomsBasketList;
        vm.onClose = onClose;
        vm.getAllSymptoms = getAllSymptoms;
        vm.getAllCodes = getAllCodes;
        vm.processSymptoms = processSymptoms;
        vm.findUniqueSymptomFromClip = findUniqueSymptomFromClip;
        vm.showHistory = showHistory;
        vm.showdiagFile = showdiagFile;
        vm.showSolution=showSolution;
        vm.showSystem = showSystem;
        vm.saveSelectedDiag = saveSelectedDiag;
        vm.getDiagDetails = getDiagDetails;
        vm.processSymptomBaskets = processSymptomBaskets;
        vm.saveSelectedSymptomBasket = saveSelectedSymptomBasket;
        vm.switchDisplay = switchDisplay;
        vm.showECU = showECU;
        vm.showDtcHistory = showDtcHistory;
        vm.showDiagHelp = showDiagHelp;
        vm.showBINDetails = showBINDetails;
        vm.showNetwork = showNetwork;
        vm.showUserJourney = showUserJourney;
        vm.showGenericInfo = showGenericInfo;
        vm.getPagedData = getPagedData;
        vm.getPageData = getPageData;
        vm.gotoADT = gotoADT;
        vm.gotoADTFeedback = gotoADTFeedback;
        vm.showNvPreparation = showNvPreparation;
        vm.showOCV = showOCV;
        vm.removeColors = removeColors;
        vm.showAlerts = showAlerts;
        vm.compareButton = compareButton;
        vm.downloadPdf = downloadPdf;
        vm.printMaintenance = printMaintenance;
        vm.newPagedData = newPagedData;
        vm.newPageData = newPageData;
        /** BIND FOR UNIT TEST */
        vm.queryDoc = queryDoc;
        CacheService.cleanSieDocumentsHistory();
        vm.widthClass=false;
        vm.setSymptoms =setSymptoms;
        vm.showSymptomLabel = false;
        vm.diagIconClick = diagIconClick;
        vm.getConnectedPlatform = getConnectedPlatform;
        vm.checkDataBaseId = checkDataBaseId;
        vm.clickComp = clickComp;
        vm.getStatusColor = getStatusColor;
        vm.getRemoteDiagStatus = getRemoteDiagStatus;
        vm.updateRemoteDiagStatus = updateRemoteDiagStatus;
        vm.clearBinDiagDetails = clearBinDiagDetails;
        var listRLink = CarSearchResultConstants.listRLink;
        var rLink2Code = CarSearchResultConstants.rLink2Code;
        vm.diagUpdatedDate="";
        vm.remoteDiagStatus="";
        vm.userProfile = CacheService.getObject(CacheConstants.profil);
        vm.roles = (vm.userProfile && vm.userProfile.roles)?vm.userProfile.roles : null;
        vm.isVehicleRemoteDiag = false;        
        var userType = vm.user.userType ?
            (vm.user.userType.toUpperCase() === 'ARCA' || vm.user.userType.toUpperCase() === 'RNET') : false;
            if (vm.user && vm.user.roles && (vm.isRnetUser || vm.isArcaUser)) {
             if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtDiagnosisRole) || vm.user.roles.includes(SearchbyDiagnosticConstants.adtImmoRole)) {
                vm.adtImmoDiag = true;
            }
        }
        var pictoImage = {
            
            "RENAULT":{src:convertImgToBase64("/assets/images/renaultgroup.png","RENAULT")},
            "GREEN":{src:convertImgToBase64("/assets/images/greenimage.png","GREEN")},
            "RED":{src:convertImgToBase64("/assets/images/redimage.png","RED")},
            "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")}
        }
        vm.showDiagCompare = showDiagCompare;
        vm.showReprogrammingHistory = showReprogrammingHistory;
        vm.showBatteryReuseCrash = showBatteryReuseCrash;
        vm.selectFirstDiagFile = selectFirstDiagFile;
        vm.selectSecondDiagFile = selectSecondDiagFile;
        vm.selectedItemId = null;
        vm.repairOrderCheck = false;
        vm.ficStatusData = false;
        vm.isBrwTypeFic = $state && $state.params && $state.params.data && $state.params.data.type && $state.params.data.type === 'BRW';
        vm.isSymptomAiSearchEnable = UtilsMetierService.isSymptomAiSearchEnable();        
        vm.symptomAiSearch = symptomAiSearch;
        vm.handleKeydown = handleKeydown;
        vm.resetPlaceholder = resetPlaceholder;
        vm.showDropdown = false;
        vm.openDropdown = openDropdown;
        vm.clearSearch = clearSearch;
        vm.symptomSearchSelected = symptomSearchSelected;
        vm.dropdownItems = [];
        var previousSearch = null;
        var symptomSearchError = null;
        vm.showRemoteList = showRemoteList;
        vm.addRegistrationNumber = addRegistrationNumber;
        const DIAG_FILE_RESTORE_TIMEOUT = 50;

        this.$onInit = function () {

            const isComingFromDiagFileDetails = $state.params.isFromDiagFileDetails;            
            // Only make API calls for remote diagnostics if NOT coming from product sheet
            if (!isComingFromDiagFileDetails) {
            vm.isVehicleRemoteDiag =  activeVinService.getVinDiag();
            if(vm.userProfile && UtilsMetierService.isRemoteDiagDealers()){
                vm.isDealerAvailable = true;
            }
            if ( vm.isArcaUser || vm.isDealerAvailable || (vm.isIndependentUser && $rootScope.asomDocList['MD-REMOTE'])) {
               if(vm.carContext.fixedCriterias['E70']!= 'AIVCT' ){
                        checkFeatureId().then(function() {
                            if (vm.isVehicleRemoteDiag){
                                checkRlinkData();
                            }
                        }).catch(function() {
                        });
                    }
                    else {
                        checkFeatureId().finally(function() {
                            if (vm.isVehicleRemoteDiag) {
                                checkRlinkData();
                            }
                        });
                    }
            }
            }           
            if(!vm.isIndependentUser){
                vm.loadSymptomSearch = true;
            }else if(vm.isIndependentUser){
                var redirectDiagnostic = $state.params.data ? $state.params.data.redirectDiagnostic : null;
                if(redirectDiagnostic){
                    vm.loadSymptomSearch = vm.tokenBalance > 0 || vm.isAsomValidDocAccess==='true';
                }else if((vm.isAsomValidDocAccess==='false' && (vm.tokenBalance > 0 || (vm.tokenBalance===0 && vm.isCirSentVin))) || (vm.isAsomValidDocAccess==='true' && ($rootScope.asomDocList.MD || $rootScope.asomDocList['MD-DIAGFILES']))){
                    vm.loadSymptomSearch = true;
                }
            }
            if (!isComingFromDiagFileDetails) {
            // We dont activate if we are coming from any of the 2 states of the CLIP APP
            if (!$state.params.symptomCode) {
                activate();
            }else if ($state.params.symptomCode) {
                findUniqueSymptomFromClip($state.params.fetchedSymptoms);
            }
            } else {
                // When coming back from product sheet, load symptoms and system doc from cache
                vm.dataSymptoms = CacheService.getObject(CacheConstants.getAllSymptoms) || {};
                vm.systemDocSubMenu = ($state.params.systemDocSubMenu) ? $state.params.systemDocSubMenu : [];
                vm.systemDocResponse = ($state.params.systemDocResponse) ? $state.params.systemDocResponse : [];
                SearchByDiagnosticService.defineRules(vm);
            }     
            if(!vm.diagCond && !vm.isSearchByModel && !vm.adtOtherRoles && (!vm.isIndependentUser || (vm.isIndependentUser && ($rootScope.asomDocList["MD-DIAGFILES"] || $rootScope.asomDocList['MD-REPROG'])))){
                
                if (isComingFromDiagFileDetails) {
                    vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList) || [];
                    vm.isDiagFileDisplay = CacheService.getObject(CacheConstants.diagFileDisplay) || false;
                    const diagFileIdToRestore = $state.params.selectedDiagFileId || CacheService.getObject(CacheConstants.selectedDiagFileId);                
                    if(diagFileIdToRestore && vm.diagFilesList && vm.diagFilesList.length > 0) {

                            $timeout(function() {
                               const diagFileToRestore = _.find(vm.diagFilesList, { id: diagFileIdToRestore });
                                vm.isDiagFileDisplay = true;
                                saveSelectedDiag(diagFileToRestore, vm.isDiagFileDisplay);
                                CacheService.setObject(CacheConstants.diagFileDisplay, true);
                                 vm.sympBasketFound = _.isEmpty(vm.symptomsBasketList) ? false : true;
                                $timeout(function() {
                                    CacheService.removeObject(CacheConstants.selectedDiagFileId);
                                    delete $state.params.selectedDiagFileId;
                                    delete $state.params.isFromDiagFileDetails;
                                }, 100);
                            }, DIAG_FILE_RESTORE_TIMEOUT);
                    }
                    
                } else {
                if ($location.path() !== '/newdialogys/manageFIC') {
                    getDiagDetails();
                }
                if(!vm.isIndependentUser){
                    getSymptomsBasketList();
                    }
                }                
                
            }
             if(vm.hasTabAccess){
                if((vm.isIndependentUser && $rootScope.asomDocList["MD-DIAGFILES"])){
                    vm.diagSearch["solution"].active= true;
                    vm.diagSearch["diagnosticFile"].active= true;
                }else{
                    vm.diagSearch["solution"].active= true;
                    vm.diagSearch["diagnosticFile"].active= false;
                }
               
              }
            if($state.params.isForBwr)
            {
                vm.widthClass=true;

            }
            vm.proactiveAlertCheck = activeVinService.getActiveData();
            if(vm.proactiveAlertCheck && (($state.params.data === true) || $state.params.redirectToAlerts)){
                vm.diagSearch["alert"].active = true;
                vm.diagSearch["solution"].active = false;
                vm.diagSearch["diagnosticFile"].active = false;
            }            
            if(vm.isSymptomAiSearchEnable){
                resetPlaceholder();
            }
        };

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function activate() {

            var symptomsList = CacheService.getObject(CacheConstants.getAllSymptoms);

            if (symptomsList && symptomsList.symptoms && symptomsList.symptoms.length > 0) {
                vm.dataSymptoms = symptomsList;
                var isFromActis = $state.params.data ? $state.params.data.type : '';
                if(isFromActis === 'BRW'){
                    setSymptoms();
                }
            } /* else if (vm.contextVehicle && vm.contextVehicle.diagDocuments) {
                CacheService.setObject(CacheConstants.getAllCodes, vm.contextVehicle.diagDocuments);
                vm.data = vm.contextVehicle.diagDocuments;
            }  */
            else {
                getAllSymptoms();
            }
            if(_.isEmpty(vm.systemDocResponse))
                getSystemDocumentation();
            SearchByDiagnosticService.defineRules(vm);
        }

        function removeColors(elementName) {
            FicInputValidationService.removeColors(elementName);
        }
        function clickComp(remoteValue,vin){

            if(_.isEmpty(vm.remoteDiagStatus) || vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusSuccess ||
                    vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusFailed){
                        $mdDialog.show({
                            templateUrl: 'app/components/car/searchByDiagnostic/remoteDiagnostic.template.html',
                           controller: 'remoteDiagnosticController',
                           bindToController: true,
                           controllerAs: 'vm',
                           locals: {
                            repairOrderCheck: vm.repairOrderCheck
                           },
                           clickOutsideToClose: true,
                         }).then(function(resp){
                            return RLinkCarMetierService.getRemoteDiagData(!remoteValue ? vin : undefined).then(function(remoteDiagResponse){
                                vm.remoteDiagId ;
                                if(remoteDiagResponse && _.has(remoteDiagResponse,'id') && remoteDiagResponse.id){
                                    vm.remoteDiagId = remoteDiagResponse.id;
                                    return  vm.remoteDiagId;
                                }
                            }).then(function(remoteDiagId){

                                return RLinkCarMetierService.updateRemoteDiagId(remoteDiagId, vm.preDiagVehData,vin).then(function(resp){
                                    if(resp){
                                        vm.remoteDiagId = resp.diagId;
                                        vm.diagUpdatedDate = resp.diagUpdatedDate;
                                    }
                                    return remoteDiagId;
                                })

                            }).then(function(remoteDiagId){
                                getRemoteDiagStatus(remoteDiagId,false,vin);
                                
                            }).catch(function(error){
                                if(error && error.serviceId === 1 && error.response && error.response.status){
                                    var errorResp = error.response;
                                    if(errorResp.status === 409){
                                        toastr.error($translate.instant('ERROR_REMOTE_DIAG_IN_PROGRESS'));
                                    }else{
                                        toastr.error($translate.instant('ERROR_REMOTE_DIAG'));
                                    }
                                }else if(error && error.serviceId === 2){
                                    toastr.error($translate.instant('ERROR_UPDATE_REMOTE_DIAG_ID'));
                                }
                            }).finally(function(){
                                if(!remoteValue){
                                    $mdDialog.hide();
                                    showRemoteList();
                                }
                            })
                         }).catch(function(){
                            $log.debug($translate.instant('ERROR'));
                         })
            }else if(vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusInProgress){
                getRemoteDiagStatus(vm.remoteDiagId,true);
            }
            
        }

         function getRemoteDiagStatus(diagId, fromRefresh,vin){
               vm.statusLoading = true;

                RLinkCarMetierService.getRemoteDiagStatus(diagId).then(function(statusResponse){
                    if (statusResponse.status) {
                        vm.remoteDiagStatus = statusResponse.status;
                        vm.statusDisplay = $translate.instant('STATUS_' + vm.remoteDiagStatus);
                        if (vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusSuccess || vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusFailed) {
                            updateRemoteDiagStatus(diagId, vm.remoteDiagStatus,vin);
                        }
                        if (fromRefresh && vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusSuccess) {
                            _.map(vm.diagFilesList, function (item) {
                                _.assign(item, { selected: false })
                            })
                            getDiagDetails(null,null,null,null,null,null,vin);
                        }
                    } else {
                        remoteDiagDbStatusCheck(fromRefresh,vin);
                    }
            }).catch(function(){
                remoteDiagDbStatusCheck(fromRefresh,vin);
            }).finally(function(){
                vm.statusLoading = false;
            })
            
         }

        function remoteDiagDbStatusCheck(fromRefresh,vin) {
            var diagIdResponse = vm.remoteDiagDbData;
            if (diagIdResponse && diagIdResponse.diagStatus && !_.isNull(diagIdResponse.diagStatus)) {
                vm.remoteDiagStatus = diagIdResponse.diagStatus;
                vm.statusDisplay = $translate.instant('STATUS_' + vm.remoteDiagStatus);
                if (fromRefresh && vm.remoteDiagStatus === SearchbyDiagnosticConstants.statusSuccess) {
                    _.map(vm.diagFilesList, function (item) {
                        _.assign(item, { selected: false })
                    })
                     getDiagDetails(null,null,null,null,null,null,vin);
                }
            } else if (diagIdResponse && _.isNull(diagIdResponse.diagStatus)) {
                var diagDataList = CacheService.getObject(CacheConstants.diagFilesList);

                var isDDPData = _.filter(diagDataList, function (item) {
                    return item.origin === 'DDP';
                })
                if (isDDPData && !_.isEmpty(isDDPData)) {
                    if (diagIdResponse && diagIdResponse.diagUpdatedDate) {
                        var remoteDiagDbDateTime = diagIdResponse.diagUpdatedDate;
                        var remoteDiagDbDate = remoteDiagDbDateTime.split(" ")[0];
                        var hasDDPData = _.some(isDDPData, function (item) {
                            return item.captureDateTime.startsWith(remoteDiagDbDate);
                        });
                        if (hasDDPData) {
                            vm.diagUpdatedDate = diagIdResponse && diagIdResponse.diagUpdatedDate ? diagIdResponse.diagUpdatedDate : "None";
                            vm.remoteDiagStatus = SearchbyDiagnosticConstants.statusSuccess;
                            vm.statusDisplay = $translate.instant('STATUS_' + vm.remoteDiagStatus);
                        } else {
                            vm.diagUpdatedDate = diagIdResponse && diagIdResponse.diagUpdatedDate ? diagIdResponse.diagUpdatedDate : "None";
                            vm.remoteDiagStatus = "";
                            vm.statusDisplay = $translate.instant('CONNECTED_SERVICES_UNKNOWN_STATUS');
                        }
                    }
                } else {
                    vm.diagUpdatedDate = diagIdResponse && diagIdResponse.diagUpdatedDate ? diagIdResponse.diagUpdatedDate : "None";
                    vm.remoteDiagStatus = "";
                    vm.statusDisplay = $translate.instant('CONNECTED_SERVICES_UNKNOWN_STATUS');
                }
            } else {
                vm.diagUpdatedDate = "None";
                vm.remoteDiagStatus = "";
                vm.statusDisplay = $translate.instant('CONNECTED_SERVICES_UNKNOWN_STATUS');
            }
        }

        function updateRemoteDiagStatus(diagId, diagStatus,vin) {
            RLinkCarMetierService.updateRemoteDiagStatus(diagId, diagStatus,vin);
        }


        function getStatusColor(status, value) {
            if (status === SearchbyDiagnosticConstants.statusSuccess) {
                return {
                    color: "green",
                };
            } else if (status === SearchbyDiagnosticConstants.statusFailed) {
                return value
                    ? { color: "blue", cursor: "pointer" }
                    : { color: "blue" };
            } else if (status === SearchbyDiagnosticConstants.statusInProgress) {
                return {
                    color: "var(--renaultPrimaryColor)",
                }
            }
        }

           function checkDataBaseId(){
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            if(contextCarRequest && contextCarRequest.vin){
                var vin = contextCarRequest.vin;
                return RLinkCarMetierService.checkId(vin).then(function (data) {
                    return data;
                }).catch(function(){
                    return $q.reject();
                })
            }
            
           }

        function checkFeatureId() {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            if (contextCarRequest && contextCarRequest.vin) {
                var vin = contextCarRequest.vin;
                    return RLinkCarMetierService.getFeatureId(vin).then(function (data) {
                    if (data && data.features) {
                        activeVinService.setFeatureData(data);
                        data.features.forEach(function (item) {
                            if (item.featureId === 2852 && item.status === 'ACTIVATED') {
                                vm.isVehicleRemoteDiag = true;
                            }
                        })
                    }
                })
            }else{
                return $q.reject();
            }
            }

            function checkRlinkData(){
                vm.isWheelLoading = true;
                vm.featureData = activeVinService.getFeatureData();
                var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
                if (contextCarRequest && contextCarRequest.vin && vm.featureData) {
                    var feature820Data = _.find(vm.featureData.features, { 'featureId': 820 });
                        if (feature820Data && !_.isEmpty(feature820Data) && feature820Data.status === 'ACTIVATED') {
                            getConnectedPlatform(vm.featureData);
                            vm.isWheelLoading = false;
                        }else if(!feature820Data || _.isEmpty(feature820Data) || feature820Data.status !== 'ACTIVATED'){
                             RLinkCarMetierService.getPrivacySettings().then(function(privacyResponse){

                                if(privacyResponse && !_.isEmpty(privacyResponse) && _.has(privacyResponse,'privacyType')){
                                    var privacyType = privacyResponse.privacyType;
                                        if(privacyType === 'LEGACY_PRIVACY' && _.has(privacyResponse,'legacyPrivacyChoice')
                                            &&  _.has(privacyResponse.legacyPrivacyChoice,'privacyMode')){
                                                if(privacyResponse.legacyPrivacyChoice.privacyMode === 'DATA_ON'){
                                                    vm.preDiagVehData = privacyResponse.legacyPrivacyChoice.privacyMode;
                                                }else{
                                                    vm.preDiagVehData = 'OR_APPROVAL';
                                                    vm.repairOrderCheck = true;
                                                }
                                                getConnectedPlatform(vm.featureData);
                                        }else if(privacyType === 'GRANULAR_PRIVACY' && _.has(privacyResponse,'granularPrivacyChoices') 
                                            && _.isArray(privacyResponse.granularPrivacyChoices) && privacyResponse.granularPrivacyChoices.length > 0){
                                                privacyResponse.granularPrivacyChoices.forEach(function(item){
                                                    if(item && item.category && item.category === "CONNECTED_CAR_SERVICES" && item.consentStatus){
                                                        if(item.consentStatus.toUpperCase() === 'ACCEPTED'){
                                                            vm.preDiagVehData = 'DATA_ON';
                                                        }else{
                                                            vm.preDiagVehData = 'OR_APPROVAL';
                                                            vm.repairOrderCheck = true;
                                                        }
                                                        
                                                    }
                                                })
                                                getConnectedPlatform(vm.featureData);
                                        }else{
                                             vm.repairOrderCheck = true;
                                            getConnectedPlatform(vm.featureData);
                                        }
                                }
                            }).catch(function () {
                                vm.isWheelLoading = false;
                                 vm.repairOrderCheck = true;
                                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                            }).finally(function () {
                                $timeout(function () {
                                    vm.isWheelLoading = false;
                                }, 2000);
                            });
                        }
                } else {
                    vm.isWheelLoading = false;
                }
            }

           function getConnectedPlatform(data){
            $timeout(function () {
                var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
                // uncommented due to data mock
                if (contextCarRequest && contextCarRequest.fixedCriterias[rLink2Code] && userType) {
                    angular.forEach(listRLink, function (mnemonic) {
                        if (contextCarRequest.fixedCriterias[rLink2Code] === mnemonic) {
                            vm.isRLink2Vehicle = true;
                        }
                    });
                }
                var connectedResponse = CacheService.getObject(CacheConstants.connectedPlatform);
                if (connectedResponse && connectedResponse.platform && ((connectedResponse.platform === 'EASYLINK') || (connectedResponse.platform === 'AVN') || (connectedResponse.platform === 'CVC') || (connectedResponse.platform === 'RGDC'))) {
                    vm.isEasyLinkVehicle = true;
                }
                if (connectedResponse && connectedResponse.platform && connectedResponse.platform === 'UNKNOWN') {
                    vm.isUnknownVehicle = true;
                }

                var isRLinkOrEasyLink = vm.isRLink2Vehicle || vm.isEasyLinkVehicle;
                var notUnknown = !vm.isUnknownVehicle;
                var fixed = contextCarRequest.fixedCriterias || {};
                var isADT = vm.typeMD === 'ADT' && isRLinkOrEasyLink && notUnknown;
                var isB3_others = vm.typeMD === 'B3' &&
                    fixed['007'] === 'XJF' &&
                    fixed['901'] === 'PHAS2' &&
                    ['BJI', 'LJI', 'LJF', 'RJI'].includes(fixed['008']) &&
                    isRLinkOrEasyLink && notUnknown;

           if(isADT || isB3_others){
                if(data && data.features){
                    angular.forEach(data.features, function (item) {
                            if(item.featureId === 2852 && item.status === 'ACTIVATED'){
                                vm.connectedPlatformResp = true;
                                checkDataBaseId().then(function (diagIdResponse) {
                                    if (diagIdResponse && !_.isNull(diagIdResponse) && !_.isEmpty(diagIdResponse)) {
                                        vm.remoteDiagDbData = diagIdResponse;
                                        vm.remoteDiagId = diagIdResponse.diagId;
                                        vm.diagUpdatedDate = diagIdResponse.diagUpdatedDate;
                                        getRemoteDiagStatus(vm.remoteDiagId,false);
                                    }else if(_.isNull(diagIdResponse)){
                                        var diagDataList = CacheService.getObject(CacheConstants.diagFilesList);
    
                                        var isDDPData = _.filter(diagDataList, function (item) {
                                            return item.origin === 'DDP';
                                        })
    
                                        if(isDDPData && !_.isEmpty(isDDPData)){
                                            vm.diagUpdatedDate=isDDPData[0].captureDateTime;
                                            vm.remoteDiagStatus=SearchbyDiagnosticConstants.statusSuccess;
                                            vm.statusDisplay = $translate.instant('STATUS_'+vm.remoteDiagStatus);
                                        }else{
                                            vm.diagUpdatedDate="None";
                                            vm.remoteDiagStatus="";
                                            vm.statusDisplay = "";
                                        }
                                    }
                                }).catch(function(){
                                    toastr.error($translate.instant('ERROR_GET_REMOTE_DIAG_ID'));
                                }).finally(function () {
                                    vm.isWheelLoading = false; 
                                });
                            }
                    })  
                }
            }
        }, 2000);
        }

        function setSymptoms(){
            var sympFromActis = CacheService.getObject('sympFromActis');
            vm.widthClass = true;
            if(sympFromActis && !_.isEmpty(sympFromActis)){
                var filteredSymptoms = getOnlyLabelSymptoms(CacheService.getObject(CacheConstants.getAllSymptoms).symptoms);
                var selSymptom = _.find(filteredSymptoms,function(item){
                    var code  = item.label.substring(0,6);
                    code = code.substr(0, code.indexOf(' -'))
                    return code === sympFromActis;
                });
                vm.search = {
                    defect: "",
                    dtcCode: "",
                    symptom: selSymptom && selSymptom.label ? selSymptom.label : "",
                    symptomSelected: selSymptom ? selSymptom : ""
                }
                vm.checkBRWType = $state.params.data ? $state.params.data.type : '';
                vm.checkFicStatus = $state.params.data ? $state.params.data.status : '';
                if(vm.checkFicStatus == 'Closed' || vm.checkFicStatus == 'Sent' || vm.checkFicStatus == 'New' || vm.checkFicStatus == 'Reopen'){
                    vm.ficStatusData = true;
                }
                CacheService.removeObject('sympFromActis');
                getAllCodes(vm.search.symptom, 3);
            }
        };

        function diagIconClick(selOrigin){                        
            var idx = $scope.origin.indexOf(selOrigin);
            var elem = document.getElementById(selOrigin);
            if(idx === -1){
                angular.element(elem).css('background-color', 'var(--renaultPrimaryColor)');                
                if(selOrigin=='ADT' || selOrigin == 'GNDS'){
                    $scope.origin.push("ADT", "GNDS");                    
                }else{
                    $scope.origin.push(selOrigin);
                }                
            }else{
                angular.element(elem).css('background-color', '#ede9e9');
                $scope.origin.splice(idx,1);
                if(selOrigin=='ADT'){
                    var removeidx = $scope.origin.indexOf("GNDS");
                    if(removeidx !== -1){
                        $scope.origin.splice(removeidx,1);                    
                    }                    
                }
                else if(selOrigin=='GNDS'){
                    var removeidx = $scope.origin.indexOf("ADT");
                    if(removeidx !== -1){
                        $scope.origin.splice(removeidx,1);                    
                    }
                }                
            }
            $timeout(function () {
                $scope.$apply();
            }, 0);
        }
        
        // for ADT, BIN Search -> HealthCheck,Ticket maintenance
        // for B3-ADT          -> Initial, HealthCheck,Ticket maintenance
        // for B3, B2-03       -> Initial,Ticket maintenance
        // for B2              -> no category, we display all diag files

        // Constants for category strings to avoid duplication
        var HEALTH_CHECK_TICKET_MAINTENANCE = 'HealthCheck,Ticket maintenance';
        var PAGE_SIZE_PARAM = '&pageSize=';
        var CATEGORIES_PARAM = '&categories=';
        
        function buildDiagnosticParams(vin, pageIndex, pageSize, history, fromScreen) {
            var baseUrl = '?vin=' + String(vin) + '&page=' + String(pageIndex) + PAGE_SIZE_PARAM + String(pageSize);
            var categories = getCategoriesForType(vm.typeMD, history, fromScreen);
            
            if (categories) {
                return baseUrl + CATEGORIES_PARAM + categories;
            }
            
            if (vm.typeMD === 'ADT' && history !== 'history' && vm.diagSearch['diagnosticFile'].active) {
                return baseUrl + DiagFileDetailsNewConstants.diagnewFilter + CATEGORIES_PARAM + HEALTH_CHECK_TICKET_MAINTENANCE;
            }
            
            if (vm.typeMD === 'ADT' && vm.diagSearch['ocv'].active) {
                return baseUrl + CATEGORIES_PARAM + DiagFileDetailsNewConstants.healthCheck;
            }
            
            return baseUrl;
        }
        
        function getCategoriesForType(typeMD, history, fromScreen) {
            // Category constants to reduce code duplication
            var INITIAL_TICKET = 'Initial,Ticket maintenance';
            var INITIAL_HEALTH_TICKET = 'Initial,' + HEALTH_CHECK_TICKET_MAINTENANCE;
            var FINAL = 'Final';
            var INITIAL = 'Initial';
            var INITIAL_HEALTH = 'Initial,HealthCheck';
            
            var categoryMappings = {
                'B3': {
                    'default': INITIAL_TICKET,
                    'history': {}
                },
                'B2': {
                    'default': '',
                    'history': {}
                },
                'B2-3': {
                    'default': INITIAL_TICKET,
                    'history': {}
                },
                'B3-ADT': {
                    'default': INITIAL_HEALTH_TICKET,
                    'history': {}
                }
            };
            
            // Set up history-specific categories using constants
            categoryMappings['B3']['history'][DiagFileDetailsNewConstants.network] = INITIAL_TICKET;
            categoryMappings['B3']['history'][DiagFileDetailsNewConstants.userJourney] = FINAL;
            categoryMappings['B3']['history'][DiagFileDetailsNewConstants.OCV] = INITIAL;
            
            categoryMappings['B2']['history'][DiagFileDetailsNewConstants.network] = '';
            categoryMappings['B2']['history'][DiagFileDetailsNewConstants.userJourney] = '';
            categoryMappings['B2']['history'][DiagFileDetailsNewConstants.OCV] = INITIAL;
            
            categoryMappings['B2-3']['history'][DiagFileDetailsNewConstants.network] = INITIAL_TICKET;
            categoryMappings['B2-3']['history'][DiagFileDetailsNewConstants.userJourney] = FINAL;
            categoryMappings['B2-3']['history'][DiagFileDetailsNewConstants.OCV] = INITIAL;
            
            categoryMappings['B3-ADT']['history'][DiagFileDetailsNewConstants.network] = INITIAL_HEALTH_TICKET;
            categoryMappings['B3-ADT']['history'][DiagFileDetailsNewConstants.userJourney] = FINAL;
            categoryMappings['B3-ADT']['history'][DiagFileDetailsNewConstants.OCV] = INITIAL_HEALTH;
            
            var typeConfig = categoryMappings[typeMD];
            if (!typeConfig) {
                return '';
            }
            
            if (history === 'history') {
                if (typeConfig['history'] && typeConfig['history'][fromScreen] !== undefined) {
                    return typeConfig['history'][fromScreen];
                }
                // For history screens not specifically defined, return empty category
                return '';
            }
            
            return typeConfig['default'];
        }

        function getDiagDetails(isFromPagination, fromScreen, category, currentPage,issecondSelected,binData,vin,history) {
            if (vin) {
                var payload = {
                    "vin": vin
                }
                CarSearchMetierService.searchCar(payload, true).then(function (result) {
                    vm.carContext = result.carContext
                });
            }
            else {
                vm.carContext = CacheService.getCarContext();
            }
            
            vm.bindata = CacheService.getBinData();
            var fromScreenList = [DiagFileDetailsNewConstants.userJourney,DiagFileDetailsNewConstants.OCV,DiagFileDetailsNewConstants.ECU,DiagFileDetailsNewConstants.network,DiagFileDetailsNewConstants.DTC];
            if (!vm.isSearchByModel && vm.carContext && vm.carContext.vin) {
                blockUI.start();
                var selDiagFile =  _.find(vm.diagFilesList , function(item){
                    return item.selected === true;
                })
                
                if (vm.showBINContent || (!vm.diagFilesList || (vm.diagFilesList && _.isEmpty(vm.diagFilesList))) ||  (isFromPagination || (!isFromPagination && (!selDiagFile || _.isEmpty(selDiagFile))))){
                    if(!fromScreen)
                        vm.selectedDiagFile = null;
                    var params = '';                    
                    if(vm.showBINContent){
                        if(binData && vm.carContext && vm.carContext.typeMD == 'ADT'){
                            if(binData.length == 18){
                                vm.binVal = binData;
                            } else if(binData.length == 17){
                                vm.binVal = binData.substr(0,10)+'T'+binData.substr(10);
                            }
                        } else if(isFromPagination){
                            vm.binVal = vm.carContext.bin.substr(0,10)+'T'+vm.carContext.bin.substr(10);
                        } else if(binData){
                            vm.binVal = binData;
                        }
                       var currentPageIndex = !currentPage ? vm.currentPage - 1 : currentPage - 1;
                       if(history==='history' || vm.diagSearch["diagCompare"].active){
                                params = '?bin=' + vm.binVal + DiagFileDetailsNewConstants.diagnewFilter + '&page=' + currentPageIndex + PAGE_SIZE_PARAM + vm.dataperPage;
                            }else{
                        params = '?bin=' + vm.binVal + DiagFileDetailsNewConstants.diagnewFilter + '&page=' + currentPageIndex + PAGE_SIZE_PARAM + vm.dataperPage + CATEGORIES_PARAM + HEALTH_CHECK_TICKET_MAINTENANCE;
                            }
                    } else {
                        CacheService.removeObject(CacheConstants.binData);
                        var currentPageIndex = !currentPage ? vm.currentPage - 1 : currentPage - 1;
                        params = buildDiagnosticParams(vm.carContext.vin, currentPageIndex, vm.dataperPage, history, fromScreen);
                    }
                    
                    if(vm.diagSearch["diagnosticFile"].active)
                        vm.loadPagination = false;
                    else
                        vm.loadADTPagination = false;

                    DiagFileBusinessService.getDiagFilesByVin(params).then(function (response) {

                        if (response && !_.isEmpty(response)
                            && response.data && !_.isEmpty(response.data)) {
                            if(vm.showBINContent){
                                vm.binSearched = true;
                                vm.diagDataFound = true;
                                vm.diagSearch['diagnosticFile'].active = false;
                                vm.diagSearch['binDiagnosticFile'].active = true;
                                CacheService.setObject('binData', {showBINContent:true,binValue: vm.binVal});
                                
                                if(!fromScreenList.includes(fromScreen)){                                
                                    resetDiagMenus();
                                    if(vm.diagSearch["diagCompare"].active){
                                       vm.diagSearch['binDiagnosticFile'].active = false; 
                                    }
                                } else {
                                    vm.diagSearch['binDiagnosticFile'].active = false; 
                                }
                            } else if(fromScreen == 'bin'){
                                vm.diagSearch['binDiagnosticFile'].active = false;
                                resetDiagMenus();
                            }
                            var filteredResponse = _.map(response.data, function (item) {
                                return _.pick(item, DiagFileDetailsNewConstants.requiredDiagFileFields)
                            });
                            filteredResponse = _.orderBy(filteredResponse, 'captureDateTime', 'desc');
                            if (!fromScreen || fromScreen == 'bin') {
                                processDiagFiles(filteredResponse,issecondSelected);
                            } else {
                                processADTDiagFiles(filteredResponse, isFromPagination, fromScreen);
                            }
                        } else {
                            if(_.isEmpty(response.data)){
                                if(vm.showBINContent){
                                    vm.showBINContent = false;
                                    toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                                    vm.currentPage = 1;
                                    getDiagDetails();
                                    return;
                                } else if(fromScreen == 'bin'){
                                    resetDiagMenus();
                                } 

                                if(vm.paginationData){
                                    vm.paginationData.isLastPage = true;
                                }
                                
                                if (!fromScreen) {
                                    if(issecondSelected){
                                        vm.newPage = vm.newPage > 1 ? vm.newPage - 1 : 1;
                                    }else{
                                        vm.currentPage = vm.currentPage > 1 ? vm.currentPage - 1 : 1; 
                                    }
                                    toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                                    CacheService.setObject(CacheConstants.diagCurrentPage, vm.currentPage);
                                    if (!isFromPagination && fromScreen != 'bin') {
                                        vm.diagDataFound = false;
                                    }
                                    blockUI.stop();
                                    return;
                                }
                            }
                            else {
                                vm.isHistoryPagination = true;
                            }
                            if (!isFromPagination && fromScreen != 'bin') {
                                vm.diagDataFound = false;
                            } else {
                                $rootScope.$broadcast('diagDataFound', fromScreen);
                                if(vm.historyPagination && vm.paginationData && vm.paginationData.screen){
                                    vm.historyPagination[vm.paginationData.screen].currentPage = vm.paginationData.currentPage === 1 ? vm.paginationData.currentPage : vm.paginationData.currentPage - 1;
                                    CacheService.setObject(CacheConstants.historyPagination, vm.historyPagination);
                                }
                            }

                        }
                        CacheService.setObject(CacheConstants.diagCurrentPage, vm.currentPage);
                        blockUI.stop();
                    }).catch(function (error) {
                        vm.showBINContent = false;
                        toastr.error(error)
                    }).finally(function () {
                        $mdDialog.hide(false);
                        blockUI.stop();
                    });
                } else {
                    if(vm.bindata){
                        vm.diagSearch['binDiagnosticFile'].active = true;
                        vm.diagSearch['diagnosticFile'].active = false;
                        vm.showBINContent = vm.bindata.showBINContent;
                        vm.binVal = vm.bindata.binValue;
                        vm.binSearched = true;
                    }
                    var selDiagFile = _.find(vm.diagFilesList, function (item) {
                        return item.selected === true;
                    })

                    if (selDiagFile && !_.isEmpty(selDiagFile)) {
                        saveSelectedDiag(selDiagFile, vm.isDiagFileDisplay);
                    } else {
                        vm.diagFilesList = _.orderBy(vm.diagFilesList, 'captureDateTime', 'desc');
                        processDiagFiles(vm.diagFilesList);
                    }
                    blockUI.stop();

                }
            }
        }
        function resetDiagMenus(){
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false;      
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;           
            // vm.diagSearch["diagCompare"].active = diagSearch["diagCompare"].active ? diagSearch["diagCompare"].active : false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            if (!vm.isDiagFileDisplay){
                vm.showSymptom = true;
            }
            vm.isSystemDocContent = false;
            systemSubMenuReset();
        }
        function processADTDiagFiles(diagFilesList,isFromPagination,fromScreen){
            if(isFromPagination){
                _.assign(vm.historyPagination[fromScreen],{"totalCount":diagFilesList.length});
                CacheService.setObject(CacheConstants.historyPagination, vm.historyPagination); 
                vm.paginationData = vm.historyPagination[fromScreen];
                vm.paginationData.isLastPage = false;
            }
            vm.loadADTPagination = true;
            if(isFromPagination){
                $rootScope.$broadcast('getPaginatedData',fromScreen,diagFilesList);
            }
        }
        function processDiagFiles(diagFilesList,issecondSelected){

            var tempDiagList=[];
            if((vm.typeMD === 'B3' || vm.typeMD === 'B2' || vm.typeMD === 'B2-3' || vm.typeMD === 'B3-ADT')){
                tempDiagList = diagFilesList.filter(function(item){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,item.category)|| _.includes(DiagFileDetailsNewConstants.ticketMaintenanceCategory,item.category.toLowerCase());
                })
                if(!issecondSelected){
                vm.diagFilesList = diagFilesList.filter(function(obj){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,obj.category)
                            || _.includes(DiagFileDetailsNewConstants.finalCategory,obj.category)
                            || _.includes(DiagFileDetailsNewConstants.healthCheckCategory,obj.category.toLowerCase())
                            || _.includes(DiagFileDetailsNewConstants.ticketMaintenanceCategory,obj.category.toLowerCase());
                });
                angular.copy(vm.diagFilesList,vm.secondDiagFilesList);
                setFirstDisabled();
            }else{
                vm.secondDiagFilesList = diagFilesList.filter(function(obj){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,obj.category)
                            || _.includes(DiagFileDetailsNewConstants.finalCategory,obj.category)
                            || _.includes(DiagFileDetailsNewConstants.healthCheckCategory,obj.category.toLowerCase())
                            || _.includes(DiagFileDetailsNewConstants.ticketMaintenanceCategory,obj.category.toLowerCase());
                })
                setSecondDisabled();
            }
            }else if(vm.typeMD === 'ADT'){
                angular.copy(diagFilesList,tempDiagList);
                if(issecondSelected){
                    angular.copy(diagFilesList,vm.secondDiagFilesList);
                    setSecondDisabled();
                }else{
                    angular.copy(diagFilesList,vm.diagFilesList); 
                    angular.copy(diagFilesList,vm.secondDiagFilesList);
                    setFirstDisabled();
                }
                $timeout(function() {
                    if($scope.origin.length > 0){
                        $scope.origin.forEach(function(item){
                            var elem = document.getElementById(item);
                            angular.element(elem).css('background-color', 'var(--renaultPrimaryColor)');
                        })
                    }
                });

                _.map(vm.diagFilesList, function (item) {

                    if(item.mileage){
                        var mileageData = item.mileage.split(" ");
                        if(mileageData.length === 2){
                            var mileage = parseInt(mileageData[0]);
                            _.assign(item, { mileage: mileage+" " +mileageData[1]})
                        }
                        
                    }
                    
                })
            }
            
            vm.loadPagination = true;
            if(vm.diagFilesList.length == 0 && vm.currentPage < 5 && vm.binSearched){
                vm.currentPage++;
                getDiagDetails();
            }else{
            CacheService.setObject(CacheConstants.diagFilesList,vm.diagFilesList);
            }
            if(tempDiagList && !_.isEmpty(tempDiagList)){

                var todaysDate = moment(new Date());
                var responseCaptureDate = moment(tempDiagList[0].captureDateTime);
                var difference = todaysDate.diff(responseCaptureDate, 'days');

                if($state.params.diagFileId && !_.isEmpty($state.params.diagFileId)){
                    
                    var selDiagFile =  _.find(vm.diagFilesList, function(item){
                        return item.id === $state.params.diagFileId;
                    })

                    if(selDiagFile && !_.isEmpty(selDiagFile)){
                        saveSelectedDiag(selDiagFile,true);
                    }

                }else{ 
                
                    if (difference <= 14) {
                        saveSelectedDiag(tempDiagList[0],vm.isDiagFileDisplay);
                    }else{
                        vm.selectedDiagFileId = '';
                        vm.displayText = $translate.instant("RECENT_DIAG_FILE");
                    }
                }
            }

            blockUI.stop();
            
        }

        function getPagedData(page) {
            if (page != vm.currentPage) {
                vm.loadPagination = false;
                vm.currentPage = page;
                getDiagDetails(true);
            }

        }

        function newPagedData(page) {
            if (page != vm.newPage) {
                vm.loadPagination = false;
                vm.newPage = page;
                getDiagDetails(true,null,null,vm.newPage,true);
            }

        }
        //reusable function for active deactivation of the menu items, yet to complete 
       /*  function setDiagMenuActive(activeKey){
            Object.keys(vm.diagSearch).forEach(function(key) {
                vm.diagSearch[key].active = (key === activeKey);
            });
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.isHistoryPagination = false;
            vm.isSystemDocContent = false;
            systemSubMenuReset();
        } */

        function showdiagFile(){
            vm.historyPagination = {
            "ECU":{"screen":DiagFileDetailsNewConstants.ECU, "category":""},
            "DTC":{"screen":DiagFileDetailsNewConstants.DTC, "category":"" },
            "alert":{"screen":DiagFileDetailsNewConstants.alerts, "category":""},
            "network":{"screen":DiagFileDetailsNewConstants.network ,"category":DiagFileDetailsNewConstants.customerReport},
            "userJourney":{"screen":DiagFileDetailsNewConstants.userJourney,"category":DiagFileDetailsNewConstants.customerReport},
            "OCV":{"screen":DiagFileDetailsNewConstants.OCV,"category":DiagFileDetailsNewConstants.customerReport}
        };
        CacheService.setObject(CacheConstants.historyPagination, vm.historyPagination);
            vm.diagSearch['diagnosticFile'].active = true; 
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["history"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.isHistoryPagination = false;
            if (!vm.isDiagFileDisplay){
                 vm.showSymptom = true;
            }
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;            
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            systemSubMenuReset();
            vm.currentPage=vm.currentPage === 0 ? 1 : vm.currentPage;
            getDiagDetails();
            if(vm.isSymptomAiSearchEnable){
                resetPlaceholder();
            }
            if(vm.showBINContent){
                vm.showBINContent= false;
                vm.binSearched = false;
                vm.diagFilesList = [];
                CacheService.setObject(CacheConstants.diagFilesList,vm.diagFilesList);
                vm.isDiagFileDisplay = false;
                CacheService.setObject(CacheConstants.diagFileDisplay,vm.isDiagFileDisplay)
                getDiagDetails();
            }            
        }
        function showSolution() {
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["system"].active= false;
            vm.diagSearch["history"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["solution"].icon=!vm.diagSearch["solution"].icon ;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.isHistoryPagination = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            if(vm.hasTabAccess){
                vm.diagSearch["solution"].active= true;
            }
            systemSubMenuReset();
      }
           function showSystem($event){
          
            vm.diagSearch["system"].icon=!vm.diagSearch["system"].icon ;
            /* if(vm.diagSearch['system'].icon && _.isEmpty(vm.systemDocResponse))
                getSystemDocumentation();  // no need as we call it during first to get dtc list*/
        }
        function getSystemDocumentation(){
            blockUI.start();            
            DiagFileBusinessService.getSystemDocuments().then(function(response){
                if(response && response.diagnosticTree){
                    vm.systemDocResponse = response.diagnosticTree;
                    vm.systemDocSubMenu = [];
                    var genericInfo;
                    if(!_.isEmpty(response.diagnosticTree.systems)){
                        var genericInfo = _.find(response.diagnosticTree.systems,function(item){
                            return item.system.substr(-3) == '055';
                        })
                        
                        vm.systemDocResponse.systems.map(function(item){
                            if(!_.isEmpty(item.dtcs)){
                                var uniqueDtcs = _.uniqBy(item.dtcs, 'dtcNumber');
                                item.dtcs = uniqueDtcs;
                                
                                uniqueDtcs.forEach(function(data){
                                    if(data.dtcNumber && vm.listOfDTC.indexOf(data.dtcNumber) === -1){
                                        vm.listOfDTC.push(data.dtcNumber)
                                    }
                                })
                            }
                            if(item.system.substr(-3) != '055')
                                vm.systemDocSubMenu.push({"code":item.system.substr(-3),"locale":item.locale,"isActive":false})
                        })
                        vm.listOfDTC = _.uniq(vm.listOfDTC);
                        vm.systemDocSubMenu = _.orderBy(vm.systemDocSubMenu, ['code'],['asc']);
                        vm.systemDocSubMenu.unshift({"code":"055","locale":genericInfo.locale,"isActive":false})
                    }                   
                }
                
                if(systemDocDetails && systemDocDetails.systemId){
                    var systemInfo = {
                        code : systemDocDetails.systemId.substr(-3)
                    }
                    showGenericInfo(systemInfo); 
                }
            }).catch(function(){
                $log.debug($translate.instant('ERROR'));
            }).finally(function(){
                blockUI.stop();
            })
        }
        
        function  showHistory(){
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
           // vm.diagSearch["solution"].active= true;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["history"].icon=!vm.diagSearch["history"].icon ;
            vm.showSymptom = false;
            vm.solutionContent =false;
            vm.showDiagHelpContent = false;
            vm.isHistoryPagination = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["alert"].active = false;
      }
      function saveSelectedDiag(diagFile,display) {

        //trigger click for the div to reset the filter on load of the page
        var resetDiv = angular.element(document.querySelector('#resetFilter'));
        angular.element(resetDiv).triggerHandler('click');

        blockUI.start();
        var mileage = !_.includes(diagFile.mileage,'NA') ? Math.round(parseFloat(diagFile.mileage.match(/[+-]?\d+(\.\d+)?/g))) : diagFile.mileage;
        var mileageUnit = (!_.includes(diagFile.mileage, 'NA') && diagFile.mileage.match(/[a-zA-Z]+/g))? diagFile.mileage.match(/[a-zA-Z]+/g) : "";
        if (vm.isArcaUser || vm.adtTechrole){
            if (vm.typeMD === 'ADT') {                
                vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage+" "+mileageUnit +" "+ diagFile.dealerId;
            } else {
                vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM - " + diagFile.dealerId;
            }        
        }else{
            if (vm.typeMD === 'ADT') {
                vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage+" "+mileageUnit;
            }
            else {
                vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM";
            }
        }
            SearchArboTextualMetierService.setConnectedServicesAuditData('recent_diag_' + vm.selectedDiagFile).then(function () {});
            vm.selectedDiagFileId = diagFile.id;

            vm.isDiagFileDisplay = display;

            CacheService.setObject(CacheConstants.diagFileDisplay,vm.isDiagFileDisplay)

            _.map(vm.diagFilesList, function(item){

                if (item.id === vm.selectedDiagFileId) {
                    if (vm.typeMD === 'ADT') {
                        _.assign(item, { mileage: mileage + " " + mileageUnit });
                    }
                    if (!item.ischecked) {
                        _.assign(item, { selected: true, ischecked: false });
                    }

                } else {
                    if (!item.ischecked) {
                        _.assign(item, { selected: false, ischecked: false });
                    }
                }
            })

            CacheService.setObject(CacheConstants.diagFilesList,vm.diagFilesList);

            blockUI.stop();
        }

        function compareButton(diagDate){
            var buttonColor = false;
            vm.filtered = [];
            if(vm.firstSelectedDiagFile && vm.secondSelectedDiagFile && vm.secondSelectedDiagFile !=''){
                buttonColor = true;
                if(diagDate && vm.diagFirstDate && vm.diagSecondDate){
                    var firstSelectedDiagFile = vm.firstSelectedDiagFile.split(' ')[3].substr(5);
                    var secondSelectedDiagFile = vm.secondSelectedDiagFile.split(' ')[3].substr(5);
                    
                    vm.filtered.push({"date": vm.diagFirstDate}, {"date": vm.diagSecondDate});
                    vm.filtered = _.orderBy(vm.filtered, 'date', 'asc');
                    vm.filtered[0].date = vm.filtered[0].date.substring(11);
                    vm.filtered[1].date = vm.filtered[1].date.substring(11);
                }
                if(firstSelectedDiagFile.includes(vm.filtered[0].date)){
                    vm.filtered[0].date = vm.firstSelectedDiagFile;
                }
                else if(secondSelectedDiagFile.includes(vm.filtered[0].date)){
                    vm.filtered[0].date = vm.secondSelectedDiagFile;
                }
                if(firstSelectedDiagFile.includes(vm.filtered[1].date)){
                    vm.filtered[1].date = vm.firstSelectedDiagFile;
                }
                else{
                    vm.filtered[1].date = vm.secondSelectedDiagFile;
                }
            }
            $scope.$emit("buttonColorchange", buttonColor);
        }


        function convertImgToBase64(url, objVal) {
            if((!vm.nissanUserURL) || (vm.nissanUserURL && objVal === "TRIMAN")){
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.onload = function () {
                    canvas.height = img.height;
                    canvas.width = img.width;
                    ctx.drawImage(img, 0, 0);
                    var dataURL = canvas.toDataURL('image/png');
                    pictoImage[objVal].value = dataURL;
                    canvas = null;
                };
                img.src = url;
            }
        }

        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }


        function downloadPdf() { 
            var redArray = [];
            var greenArray = [];
            var ecuDateTime = '';
            var contributorData =[];
            var sessionData = [];
            var redPictoData = [];
            var greenPictoData = [];
            
            vm.diagFilesList.forEach(function (item) {
                if (item.id === vm.selectedDiagFileId) {
                    ecuDateTime = item.captureDateTime;
                    if(!_.isEmpty(vm.contextVehicle) && vm.contextVehicle.vehicle){
                        if(vm.contextVehicle.vehicle.typeMD == "ADT"){
                            var tempDTCGroup = _.groupBy(item.dtcs, 'ecuLabel');
                            if(!_.isEmpty(item.ecus)) {
                                item.ecus.forEach(function (ecu) {
                                    var ecuLabel = ecu.label;
                                    var ecuDTCs = tempDTCGroup[ecuLabel] || [];
                                    var filteredDTCs = ecuDTCs.filter(function(dtc) {
                                        return dtc.code !== 'B2E2306';
                                    });
                                    var hasPresentDTC = filteredDTCs.some(function(dtc) {
                                        return dtc.status === 'CURRENT';
                                    });                                    
                                    if (hasPresentDTC) {
                                        redArray.push({'label': ecuLabel});
                                    } else {
                                        greenArray.push({'label': ecuLabel});
                                    }
                                });
                            }
                        }
                        else if((vm.contextVehicle.vehicle.typeMD == "B2") || (vm.contextVehicle.vehicle.typeMD == "B3")){                           
                            if(!_.isEmpty(item.networks)){
                                item.networks.forEach(function (data) {
                                    if(!_.isEmpty(data.ecus)){
                                        data.ecus.forEach(function (value){
                                            if(!_.isEmpty(value.clipSessionNumber)){
                                                sessionData.push({'clipSessionNumber': value.clipSessionNumber, 'label': value.label});
                                            }
                                        });
                                    }
                                });
                            }
                            if(!_.isEmpty(item.dtcs)){
                                var tempDTCGroupB23 = _.groupBy(item.dtcs, 'ecuLabel');
                                sessionData.forEach(function (val) {
                                    if (val.picto != pictoImage.RED.value) {
                                        var ecuLabel = val.label;
                                        var ecuDTCs = tempDTCGroupB23[ecuLabel] || [];
                                        var filteredDTCs = ecuDTCs.filter(function(dtc) {
                                            return dtc.code !== 'B2E2306';
                                        });
                                        var hasPresentDTC = filteredDTCs.some(function(dtc) {
                                            return dtc.statusCode === "1";
                                        });  
                                        if (hasPresentDTC) {
                                            _.assign(val, {'picto': pictoImage.RED.value});
                                        } else {
                                            _.assign(val, {'picto': pictoImage.GREEN.value});
                                        }
                                    }
                                });
                            }                            
                            var uniqueSessionData = _.uniqBy(sessionData, 'label');
                            _.forEach(uniqueSessionData, function(pic) {
                                if (pic.picto === pictoImage.RED.value) {
                                    redPictoData.push(pic);
                                } else {
                                    greenPictoData.push(pic);
                                }
                            });
                        }
                    }
                }
            })

            if(vm.systemDocResponse && !_.isEmpty(vm.systemDocResponse.systems)) {
                vm.systemDocResponse.systems.forEach(function (item){
                    if(!_.isEmpty(item.contributors)) {
                        item.contributors.forEach(function (data) {
                        contributorData.push(data)
                        })
                    }            
                })
            }
            greenArray = getDesignation(greenArray,contributorData);           
            redArray = getDesignation(redArray,contributorData);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var userProfile = CacheService.getObject(CacheConstants.profil);
            var ecuPrintDetails = {
                array1: redArray,
                array2: greenArray,
                array3: redPictoData,
                array4: greenPictoData,
                ecuDetails: { Date:ecuDateTime ? ecuDateTime.substring(0, 10): '', Type: contextCarRequest.model ? 
                contextCarRequest.model:'', VIN: contextCarRequest.vin },
                userDetails: { Header: userProfile.header ? userProfile.header : ''},
                ecuId: vm.selectedDiagFileId,
                translatedLabels: {
                    healthCheck: $translate.instant("HEALTH_CHECK"),
                    analysisOfVechile: $translate.instant("ANALYSIS_OF_YOUR_VEHICLE"),
                    statusofControlledEcu: $translate.instant("STATUS_OF_CONTROLLED_ECU"),
                    sessionNumber: $translate.instant("SESSION_NO"),
                    ecus: $translate.instant("ECUS"),
                    designations: $translate.instant("DESIGNATIONS"),
                    status: $translate.instant("STATUS"),
                    pdfName: $translate.instant("PDF_NAME")
                }

            };
            return formatDatatoPrint(ecuPrintDetails);
        }
        function getDesignation(data,contributorData){
            if(!_.isEmpty(data)){
                data.forEach(function (key) {
                    var labelData = false;
                    if(!_.isEmpty(contributorData)){
                        contributorData.forEach(function(contributor){
                            if (key.label == contributor.ecuDomain) {
                                labelData = true;
                                _.assign(key, { designation: contributor.longLabel});
                            }
                        })
                    }
                    if(!labelData){
                        _.assign(key, { designation: " "});  
                    }
                })
            }
            return data;
        }

        function formatDatatoPrint(ecuPrintDetails) {
            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];

            if(ecuPrintDetails.userDetails.Header){
            var ecuTable = [
                {
                    column1: {
                        data: ecuPrintDetails.userDetails.Header,
                        alignment: "left"
                    }
                }
            ];
            var ecuObj = {
                type: "table", values: getTableData(ecuTable, false), styles: "secondTableHeader",
                layout: "secondTableLayout", widths: [100, 100]
            };
            dataArray.push(ecuObj);
        }
            

            var healthObj = { type: "columns", values: { 0: [ecuPrintDetails.translatedLabels.healthCheck] }, styles: "healthStyle" };
            dataArray.push(healthObj);

            var ecuDetailsObj = { type: "columns", values: { 0: ['\n'+ecuPrintDetails.translatedLabels.analysisOfVechile] }, styles: "textStyle1" };
            dataArray.push(ecuDetailsObj);

            var ecuDetailsObj1 = { type: "columns", values: { 0: ['\n'+'Date : '], 1:[ecuPrintDetails.ecuDetails.Date ] }, styles: "dateTextStyle" };
            dataArray.push(ecuDetailsObj1);


            var ecuDetailsObj2 = { type: "columns", values: { 0: ['Type : '], 1:[ecuPrintDetails.ecuDetails.Type ] }, styles: "textStyle2" };
            dataArray.push(ecuDetailsObj2);

            var ecuDetailsObj3 = { type: "columns", values: { 0: ['VIN : '], 1:[ecuPrintDetails.ecuDetails.VIN] }, styles: "textStyle2" };
            dataArray.push(ecuDetailsObj3);

            var thirdObj = { type: "columns", values: { 0: ['\n\n'+ecuPrintDetails.translatedLabels.statusofControlledEcu+":"+'\n\n'] }, styles: "textStyle" };
            dataArray.push(thirdObj);
 
          
            var firstTable = [];
            var healthCheckRedTable = [];
            var healthCheckGreenTable = [];
            firstTable = ecuPrintDetails.array1;
            healthCheckRedTable = ecuPrintDetails.array3;
            healthCheckGreenTable = ecuPrintDetails.array4;

            if(!_.isEmpty(vm.contextVehicle) && vm.contextVehicle.vehicle){
                if(vm.contextVehicle.vehicle.typeMD == "ADT"){
                    var filteredData = firstTable.map(function (item) {
                        var tableData = [];

                        tableData[ecuPrintDetails.translatedLabels.ecus] =
                        {
                            data: item.label,
                            alignment: "center",
                            
                        };
                        tableData[ecuPrintDetails.translatedLabels.designations] =
                        {
                            data: item.designation,
                            alignment: "center",
                            
                        };
                        tableData[ecuPrintDetails.translatedLabels.status] =
                        {
                            data: pictoImage.RED.value,
                            alignment: "right",
                            type: "smallImage",
                            
                        };
                        return tableData;
                    });
                }
                else if((vm.contextVehicle.vehicle.typeMD == "B2") || (vm.contextVehicle.vehicle.typeMD == "B3")){
                   
                    var filteredData = healthCheckRedTable.map(function (item) {
                        if(item.picto == pictoImage.RED.value){
                        var tableData = [];

                        tableData[ecuPrintDetails.translatedLabels.ecus] =
                        {
                            data: item.label,
                            alignment: "center",
                            
                        };
                        tableData[ecuPrintDetails.translatedLabels.status] =
                        {
                            data: item.picto,
                            alignment: "right",
                            type: "smallImage",
                            
                        };
                        return tableData;
                    }
                    });
                }
            }

            var fifthObj = {};

            fifthObj = {
                type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: vm.contextVehicle.vehicle.typeMD === "ADT" ? [120, 160, 120] : [160, 160]
            };
            dataArray.push(fifthObj);

            var secondTable = [];
            secondTable = ecuPrintDetails.array2;

            if(!_.isEmpty(vm.contextVehicle) && vm.contextVehicle.vehicle){
                if(vm.contextVehicle.vehicle.typeMD == "ADT"){
                    var filteredDataGreen = secondTable.map(function (item) {
                    var tableData = [];

                        tableData[ecuPrintDetails.translatedLabels.ecus] =
                        {
                            data: item.label,
                            alignment: "center"
                        };
                        tableData[ecuPrintDetails.translatedLabels.designations] =
                        {
                            data: item.designation,
                            alignment: "center",
                            
                        };
                        tableData[ecuPrintDetails.translatedLabels.status] =
                        {
                            data: pictoImage.GREEN.value,
                            alignment: "right",
                            type: "smallImage"
                        };
                        return tableData;
                    });
                }

                else if((vm.contextVehicle.vehicle.typeMD == "B2") || (vm.contextVehicle.vehicle.typeMD == "B3")){
                    var filteredDataGreen = healthCheckGreenTable.map(function (item) {
                        if(item.picto == pictoImage.GREEN.value){
                        var tableData = [];

                        tableData[ecuPrintDetails.translatedLabels.ecus] =
                        {
                            data: item.label,
                            alignment: "center",
                            
                        };
                        tableData[ecuPrintDetails.translatedLabels.status] =
                        {
                            data: item.picto,
                            alignment: "right",
                            type: "smallImage",
                            
                        };
                        return tableData;
                    }
                    });
                }
            }
            
            var sixthObj = {};

            sixthObj = {
                type: "table", values: getTableData(filteredDataGreen, true), styles: "tableStyle",
                layout: "otherTableLayout", widths: vm.contextVehicle.vehicle.typeMD === "ADT" ? [120, 160, 120] : [160, 160]
            };
            dataArray.push(sixthObj);
            dataArray = PDFViewService.getProcessedDataArray(finalArr, dataArray, false, false, true, false);
            var docDefinition = {
                
                info: {
                    title: $translate.instant(ecuPrintDetails.ecuDetails.Date+'_'+$translate.instant("PDF_NAME"))
                },header: {
                   style:"header",                  
                    columns: [
                         {
                     },
                        {    
                        image: pictoImage.RENAULT.value,
                        width: 50,
                    }]
                }, 
                footer:{
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [10, 10, 0, 10],
                            width: 25,
                            bold: false
                        },
                        {
                            
                            text:'FD id : '+ecuPrintDetails.ecuId,
                            margin: [0, 20, 10, 5],
                            alignment: 'right',
                            bold: false,

                        }
                       
                    ]
                    
                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 13
                    },
                    header:{
                        margin: [0, 10, 10, 20],
                    },
                    textStyle1: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 13
                    },
                    dateTextStyle:{
                        margin: [-231, 11, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    textStyle2: {
                        margin: [-231, 1, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    textStyle3:{
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 9,
                        color: "#8f8f8f"
                    },
                    healthStyle:{
                        fontSize: 12,
                        bold: true,
                        margin: [23, 20, 0, 20],
                        alignment: "center"
                     
                    },
                    textPlainStyle: {
                        margin: [0, 1, 0, 1],
                        alignment: "left",
                        fontSize: 10,
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [60, 0, 0, 0],
                        border:[false,true,false,true],
                        fontSize: 10
                    },
                    tableIconStyle: {
                        margin: [0, 1.5, 0, 1.5],
                        alignment: "center"
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8,
                        bold: true,
                        fillColor: '#eeeeee',
                    },
                    secondTableHeader: {
                        margin: [0, 3, 0, 10],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    },
                    secondTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 3 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                        }
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

    function printMaintenance(){
        SearchArboTextualMetierService.setConnectedServicesAuditData('Health_Check').then(function () {});
        downloadPdf().then(function(response){
            pdfMake.tableLayouts = {
                    otherTableLayout: {
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    }
                };
            var pdfDocGenerator = pdfMake.createPdf(response.data);
            pdfDocGenerator.getBuffer(function (buffer) {
                var file = new Blob([(buffer)], { type: 'application/pdf' });
                var isIE = false || !!document.documentMode;
                var isEdge = !isIE && !!window.StyleMedia;
                
                    if (isIE || isEdge) { 
                        var todaysDate = moment(new Date()).format('"YYYY/MM/DD"');
                        FileSaver.saveAs(file, todaysDate+'_' + $translate.instant('PDF_NAME')+'.pdf');
                    }else {    
                                
                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }                                    
                            return printPdfModalService.showModal(modalParams).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                             });
                        }).catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
            })
        });
    }

        function setSecondDisabled() {
            vm.secondDiagFilesList.forEach(function (item) {
                if (vm.diagFirstId == item.id) {
                    _.assign(item, { isDisabled: true, ischecked: true })
                }
                if(!vm.diagSecondId && vm.diagFirstId != item.id) {                
                    _.assign(item, { ischecked: false })
                }
                else if (vm.diagSecondId  && vm.diagSecondId == item.id) {
                    _.assign(item, { ischecked: true })
                } 
            })
        }

        function setFirstDisabled() {
            vm.diagFilesList.forEach(function (item) {
                if (vm.diagFirstId == item.id) {
                    _.assign(item, { ischecked: true })
                }
            })
            if(!_.isEmpty(vm.secondDiagFilesList)){
                vm.secondDiagFilesList.forEach(function (item1) {
                    _.assign(item1, { ischecked: false })
                    if (vm.diagFirstId == item1.id) {
                        _.assign(item1, { isDisabled: true, ischecked: true })
                    }
                })
            }
        }
        function selectFirstDiagFile(index, diagFile) {
            if (vm.selectedItemId != null && diagFile.id == vm.selectedItemId) {
                vm.secondSelectedDiagFile = '';
            }
            if (diagFile.ischecked) {

                vm.diagFilesList.forEach(function (item) {
                    if (item.id != diagFile.id) {
                        item.ischecked = false;
                    }
                    else {
                        item.ischecked = true;
                    }
                })
                vm.diagFirstDate = diagFile.captureDateTime;
                vm.diagFirstId = diagFile.id;

                var mileage = !_.includes(diagFile.mileage, 'NA') ? Math.round(parseFloat(diagFile.mileage.match(/[+-]?\d+(\.\d+)?/g))) : diagFile.mileage;
                var mileageUnit = (!_.includes(diagFile.mileage, 'NA') && diagFile.mileage.match(/[a-zA-Z]+/g)) ? diagFile.mileage.match(/[a-zA-Z]+/g) : "";
                if (vm.isArcaUser || vm.adtTechrole) {
                    if (vm.typeMD === 'ADT') {
                        vm.firstSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " " + mileageUnit + " " + diagFile.dealerId;
                    } else {
                        vm.firstSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM - " + diagFile.dealerId;
                    }
                } else {
                    if (vm.typeMD === 'ADT') {
                        vm.firstSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " " + mileageUnit;
                    }
                    else {
                        vm.firstSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM";
                    }
                }
            }
            else{
                vm.firstSelectedDiagFile = '';
            }
            vm.newPage = vm.currentPage;
            vm.secondDiagFilesList = angular.copy(vm.diagFilesList);

            _.extend(vm.secondDiagFilesList,{ isDisabled : false});
            _.map(vm.secondDiagFilesList, function(item){

                if(item.ischecked){
                    _.assign(item,{isDisabled : true});
                }
                else{
                    _.assign(item,{isDisabled : false});
                }

            })
           compareButton(vm.diagFirstDate); 
        }

        function selectSecondDiagFile(index, diagFile) {
            vm.selectedItemId = diagFile && diagFile.id ? diagFile.id : null;
            if (diagFile.ischecked) {

                vm.secondDiagFilesList.forEach(function (item) {
                    if (item.id != diagFile.id && !item.isDisabled) {
                        item.ischecked = false;
                    }
                    else {
                        item.ischecked = true;
                    }
                })
                vm.diagSecondDate = diagFile.captureDateTime;
                vm.diagSecondId = diagFile.id;

                var mileage = !_.includes(diagFile.mileage, 'NA') ? Math.round(parseFloat(diagFile.mileage.match(/[+-]?\d+(\.\d+)?/g))) : diagFile.mileage;
                var mileageUnit = (!_.includes(diagFile.mileage, 'NA') && diagFile.mileage.match(/[a-zA-Z]+/g)) ? diagFile.mileage.match(/[a-zA-Z]+/g) : "";
                if (vm.isArcaUser || vm.adtTechrole) {
                    if (vm.typeMD === 'ADT') {
                        vm.secondSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " " + mileageUnit + " " + diagFile.dealerId;
                    } else {
                        vm.secondSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM - " + diagFile.dealerId;
                    }
                } else {
                    if (vm.typeMD === 'ADT') {
                        vm.secondSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " " + mileageUnit;
                    }
                    else {
                        vm.secondSelectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage + " KM";
                    }
                }
            }
            else{
                vm.secondSelectedDiagFile = '';
            } 
            compareButton(vm.diagSecondDate);          
        }
        
        function getAllSymptoms() {
            if(!vm.nissanUserURL){
                blockUI.start();
            ResultSearchByDiagnosticMetierService.getAllSymptoms()
                .then(function (response) {
                    processSymptoms(response);
                }, function (err) {
                    toastr.error('Error BACK : ' + err, 'Error');
                }).finally( function(){
                    blockUI.stop();
                });
            }
        }

        function normalizeFilter(value) {
            if (value)
                return value.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            else
                return value;
        }

        function getAllCodes(diag, code, searchAiText) {

            blockUI.start();
            var label = diag;
            vm.searchedSymptom.code = diag.substring(0, 6) || '';
            if (vm.searchedSymptom && vm.searchedSymptom.code) {
                vm.searchedSymptom.code = vm.searchedSymptom.code.substr(0, vm.searchedSymptom.code.indexOf(' -'));
                if (vm.searchedSymptom.code === '') {
                    vm.searchedSymptom.code = diag;
                }else{
                    vm.searchedSymptom.label = diag.substring(7) || '';
                }
            }
            //vm.searchedSymptom.label = diag.substring(7) || '';

            CacheService.setObject(CacheConstants.searchedSymptom, vm.searchedSymptom);

            var dtcCode = "";
            var defaultCode = "";
            var symptomLongCode = "";
            var shortCode;

            if (code === 1) {
                defaultCode = [diag];
            } else if (code === 2) {
                dtcCode = [diag];
            } else if (code === 3) { //case symptom
                shortCode = vm.searchedSymptom.code;

                var symptomsList = CacheService.getObject(CacheConstants.getAllSymptoms);

                if(symptomsList && symptomsList.symptoms && symptomsList.symptoms.length > 0){
                    symptomsList.symptoms.forEach(function (item){

                        if ((shortCode === item.shortCode) && code === 3) {
                            symptomLongCode = [item.longCode];
                            // completing the symptom code with the label to have the complete symptom code
                            diag = item.label;
                            label = item.label;
                        }

                    })

                }
            }

            var dataBody = ResultSearchByDiagnosticMetierService.createDataObject(symptomLongCode, dtcCode, defaultCode);

            ResultSearchByDiagnosticMetierService.getAllCodes(dataBody)
                .then(function (response) {
                    vm.data = response;
                    /* vm.contextVehicle.diagDocuments = vm.data;
                    CacheService.setObject(CacheConstants.getAllCodes, vm.data);
                    CacheService.setObject(CacheConstants.contextCarSearch, vm.contextVehicle); */
                    // blockUI.stop();
                }, function (err) {
                    toastr.error('Error BACK : ' + err, 'Error');
                }).finally(function () {
                    blockUI.stop();
                    goToResultByDiagnostic(diag, code, label,searchAiText);
                });
        }

        /**
         *  Si le diagnostique existe, on fera une recuperation des documents qui lui sont liés.
         *  Sinon on affiche une erreur
         *
         *  @param {number} code Definie le type de diagnostic | symptom, dtc, defect
         *  @param {string} diag
         */

        function goToResultByDiagnostic(diag, code, label,searchAiText) {

            //return to createFIC page from pop-in
            if ($location.path() === '/newdialogys/manageFIC') {
                CacheService.setObject(CacheConstants.isCreateActisSearchedSymptom, true);
                $mdDialog.hide();
                return;
            }
            if (code === 3) {
                vm.dataSymptoms.symptoms.forEach(function (doc) {
                    if (doc.label === diag) {
                        diag = doc.longCode;
                    }
                });
            }


            var payload;
            if (!(vm.data.documents)) {
                payload = queryDoc(vm.dataSymptoms.symptoms, diag, code);
            } else {
                payload = queryDoc(vm.data.documents, diag, code);
            }

            CacheService.setObject(CacheConstants.showDiagnosticView, true);
            blockUI.reset();
            $state.go(RoutesConstants.resultSearchByDiagnostic, { data: payload, traficDiag: true, code: label, searchAiText:searchAiText, codeNumber: code });
        }

        /**
         *  Get symptoms list related to the car in the context
         */
        function getSymptomsBasketList() {
            blockUI.start();

            if ((!vm.symptomsBasketList || (vm.symptomsBasketList && _.isEmpty(vm.symptomsBasketList))) && !vm.nissanUserURL){

                ResultSearchByDiagnosticMetierService.getCarSymptomsList().then(function (data) {

                    if(data && !_.isEmpty(data) && data.basketHistory && !_.isEmpty(data.basketHistory)){

                        var filteredResponse = _.map(data.basketHistory, function(item){
                                return  _.pick(item, ResultSearchByDiagnosticConstants.requiredSymptomBasketFields)});

                        var formattedDateList = [];
                        _.map(filteredResponse,function(it){
                            var date = moment(it.basketcreationdate);
                            formattedDateList.push({'basketDate':date.clone().startOf('day')});
                        })

                        if(formattedDateList && !_.isEmpty(formattedDateList)){
                            var sympListByDate = $filter('unique')(formattedDateList,'basketDate');

                            _.map(sympListByDate,function(date){
                                var symptoms = [];

                                filteredResponse.forEach(function(symptom){

                                    var sympDate = moment(new Date(symptom.basketcreationdate));
                                    var d = moment(new Date(date.basketDate));

                                    if(d.diff(sympDate,'days') === 0){
                                        symptoms.push(symptom);
                                    }
                                })

                                _.assign(date,{symptomBasketDetails:symptoms})
                            })

                            vm.symptomsBasketList = sympListByDate;

                            processSymptomBaskets();
                    }


                    }else{
                        vm.sympBasketFound = false;
                    }
                }).catch(function (error) {
                    vm.sympBasketFound = false;
                }).finally(function () {
                    blockUI.stop();
                });
            }else{

                var selSympBakset =  _.find(vm.symptomsBasketList , function(item){
                    return item.selected === true;
                })

                if(selSympBakset && !_.isEmpty(selSympBakset)){
                    saveSelectedSymptomBasket(selSympBakset,vm.isDiagFileDisplay);
                }else{
                    processSymptomBaskets();
                }
                blockUI.stop();

            }
        }

        function processSymptomBaskets(){

            if(vm.symptomsBasketList && !_.isEmpty(vm.symptomsBasketList)){

                var tempSympBasketList = angular.copy(vm.symptomsBasketList);

                CacheService.setObject(CacheConstants.symptomsBasketList, vm.symptomsBasketList);

                var todaysDate = moment(new Date());
                var responseCaptureDate = moment(tempSympBasketList[0].basketDate);
                var difference = todaysDate.diff(responseCaptureDate, 'days');

                if(difference <= 14){
                    saveSelectedSymptomBasket(tempSympBasketList[0], vm.isDiagFileDisplay);
                }else{
                    vm.displaySympText = $translate.instant("RECENT_SYMPTOM_BASKET");
                }
            }
        }

        function saveSelectedSymptomBasket(selSympBasket, display){

            if(selSympBasket && !_.isEmpty(selSympBasket)){

                blockUI.start();
                
                vm.selectedSympBasket = $filter('momentLocaleDate')(new Date(selSympBasket.basketDate));

                vm.selectedSympBasketId = selSympBasket;

                vm.isDiagFileDisplay = display;

                vm.isSymptomsDisplayed = true;

                CacheService.setObject(CacheConstants.diagFileDisplay,vm.isDiagFileDisplay)

                _.map(vm.symptomsBasketList, function(item){

                    if(item.basketDate === vm.selectedSympBasketId.basketDate){
                        _.assign(item, { selected: true});
                    }else{
                        _.assign(item, { selected: false});
                    }
                })

                CacheService.setObject(CacheConstants.symptomsBasketList,vm.symptomsBasketList);

                blockUI.reset();
            }

        }

        function switchDisplay(displayDiag){

            if (!vm.selectedDiagFile && vm.displayText === $translate.instant('RECENT_DIAG_FILE')) {
                SearchArboTextualMetierService.setConnectedServicesAuditData('Recent_Diag').then(function () {});
            }
            vm.isDiagFileDisplay = displayDiag;

            vm.showDiagHelpContent = false;
            vm.showSymptom = true;
            CacheService.setObject(CacheConstants.diagFileDisplay,vm.isDiagFileDisplay)
        }

        /*=============================================
        =                  HELPERS                    =
        =============================================*/

        function getOnlyLabelSymptoms(symptoms) {
            if (symptoms) {
                return symptoms.map(function (symptom) {
                    return { label: symptom.label, filteredLabel: symptom.filteredLabel };
                });
            }
        }

        /**
         * Recupere tous les BT et MD liés au diagnostique.
         *
         * @param {array<object>} documents La liste de documents qui va nous
         *                                  permettre de recuperer les id
         * @param {string} diag Le diagnostique que l'utilisateur a selectionné
         * @param {number} code Le type de diagnostique
         * @return {Object} {
         *      MD: Array<string>
         *      BT: Array<string>
         * } une liste de MD - BT lié au diagnostique
         */

        function queryDoc(documents, diag, code) {
            var payload = {
                MD: [],
                BT: [],
                BTWithColorType: []
            };
            if (code === 3 && vm.data.documents) {
                documents.forEach(function (doc) {
                    var found = -1;
                    var tags = doc.indexationsTags;
                    var documentType = doc.type;
                    var id = doc.id;
                    if (!tags) {
                        return null;
                    }

                    found = tags.symptoms ? tags.symptoms.indexOf(diag) : -1;

                    if (found >= 0) {
                        if (documentType === 'BT') {
                            payload["BT"] = payload["BT"].concat(id);
                            payload["BTWithColorType"] = payload["BTWithColorType"].concat({
                                id: id,
                                subType: doc.subType
                            });
                        } else if (documentType === 'MD') {
                            payload["MD"] = payload["MD"].concat(id);
                        }
                    }
                });
            } else if (code === 3 && vm.dataSymptoms.symptoms && (!(vm.data.documents))) {
                documents.forEach(function (doc) {
                    var found = -1;
                    var tags = doc.indexationsTags;
                    var documentType = doc.type;
                    var id = doc.id;
                    if (!tags) {
                        return null;
                    }

                    found = tags.symptoms ? tags.symptoms.indexOf(diag) : -1;

                    if (found >= 0) {
                        if (documentType === 'BT') {
                            payload["BT"] = payload["BT"].concat(id);
                            payload["BTWithColorType"] = payload["BTWithColorType"].concat({
                                id: id,
                                subType: doc.subType
                            });
                        } else if (documentType === 'MD') {
                            payload["MD"] = payload["MD"].concat(id);
                        }
                    }
                });
            } else {
                documents.forEach(function (doc) {
                    var found = -1;
                    var tags = doc.indexationsTags;
                    var documentType = doc.type;
                    var id = doc.id;
                    if (!tags) {
                        return null;
                    }

                    switch (code) {
                        case 1:
                            found = tags.defects ? tags.defects.indexOf(diag) : -1; break;
                        case 2:
                            found = tags.DTC ? tags.DTC.indexOf(diag) : -1; break;
                    }

                    if (found >= 0) {
                        if (documentType === 'BT') {
                            payload["BT"] = payload["BT"].concat(id);
                            payload["BTWithColorType"] = payload["BTWithColorType"].concat({
                                id: id,
                                subType: doc.subType
                            });
                        } else if (documentType === 'MD') {
                            payload["MD"] = payload["MD"].concat(id);
                        }
                    }

                });
            }
            return payload;
        }

        /**
         * @namespace onClose
         * @desc on close hide dialog
         */
        function onClose() {
            $mdDialog.hide();
        }

        /**
         * Gets the user to the result page after finding and processing the unique symptom types in the Clip App
         * @param fetchedSymptoms
         * @returns array of symptoms objects
         */
        function findUniqueSymptomFromClip(fetchedSymptoms) {
            blockUI.start();
            processSymptoms(fetchedSymptoms)

            SearchByDiagnosticService.defineRules(vm);

            getAllCodes($state.params.symptomCode, 3)
        }

        /**
         * processes all of the symptoms labels while normalizing their labels and puts them into the cache
         * @param fetchedSymptoms
         */
        function processSymptoms(fetchedSymptoms) {
            vm.dataSymptoms = fetchedSymptoms;
            if(vm.dataSymptoms && !_.isEmpty(vm.dataSymptoms.symptoms)){
                vm.dataSymptoms.symptoms.forEach(function (item) {
                    if (item.label)
                        item.filteredLabel = normalizeFilter(item.label);
                });
            }
            CacheService.setObject(CacheConstants.getAllSymptoms, vm.dataSymptoms);
            var isFromActis = $state.params.data ? $state.params.data.type : '';
            if(isFromActis === 'BRW'){
                setSymptoms();
            }
            blockUI.stop();
        }
        function setPaginationDetails(screen){
            vm.isHistoryPagination = true;
            var currentPageDetails = CacheService.getObject(CacheConstants.historyPagination);
            if(currentPageDetails && currentPageDetails[screen].currentPage){
                _.assign(vm.historyPagination[screen],{"dataPerPage":currentPageDetails[screen].dataPerPage, "currentPage":currentPageDetails[screen].currentPage});
                vm.paginationData = vm.historyPagination[screen];
            } else{
                _.assign(vm.historyPagination[screen],{"dataPerPage":10, "currentPage":1});
                CacheService.setObject(CacheConstants.historyPagination, vm.historyPagination);                
                vm.paginationData = vm.historyPagination[screen];
            }  
            if(vm.showBINContent)          
                vm.getDiagDetails(true,vm.paginationData.screen,vm.historyPagination[vm.paginationData.screen].category,vm.historyPagination[vm.paginationData.screen].currentPage,null,vm.binVal,undefined,'history');
            else 
                vm.getDiagDetails(true,vm.paginationData.screen,vm.historyPagination[vm.paginationData.screen].category,vm.historyPagination[vm.paginationData.screen].currentPage,undefined,undefined,undefined,'history');
        }
        function showECU(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('ECU').then(function () {});
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = true;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["ecu"].icon=!vm.diagSearch["ecu"].icon ;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            vm.diagSearch["historyPage"].active = true;
            setPaginationDetails(DiagFileDetailsNewConstants.ECU);
            systemSubMenuReset();

        }

        function showNetwork(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('Network_Diagnosis').then(function () {});
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["network"].active = true;
            vm.diagSearch["network"].icon=!vm.diagSearch["network"].icon ;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.diagSearch["historyPage"].active = true;
            setPaginationDetails(DiagFileDetailsNewConstants.network);
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            systemSubMenuReset();
        }

        function showDtcHistory() {
            SearchArboTextualMetierService.setConnectedServicesAuditData('DTC').then(function () {});
            vm.diagSearch['history'].active = false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = true;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.diagSearch["historyPage"].active = true;
            setPaginationDetails(DiagFileDetailsNewConstants.DTC);
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            systemSubMenuReset();
            
        }

        function showDiagHelp(){
            if(vm.isDiagFileDisplay && vm.selectedDiagFileId){
                if(!vm.diagSearch['solution'].active){
                    vm.diagSearch["solution"].active = true;
                    vm.diagSearch["remoteList"].active = false; 
                    vm.diagSearch["ecu"].active = false;
                    vm.diagSearch["dtcHistory"].active = false;
                    vm.diagSearch["network"].active = false;
                    vm.diagSearch["history"].active= false;
                    vm.diagSearch["system"].active= false;
                    vm.diagSearch["userjourney"].active = false;
                    vm.diagSearch["nvPreparation"].active = false;
                    vm.diagSearch["ocv"].active = false;
                    vm.diagSearch["alert"].active = false;
                    vm.diagSearch['diagnosticFile'].active = true;
                    vm.isSystemDocContent = false;
                    vm.diagSearch["diagCompare"].active = false;
                    vm.diagSearch["reprogrammingHistory"].active = false;
                    vm.diagSearch['batteryReuseCrash'].active = false;
                    systemSubMenuReset();
                }
                if(vm.diagSearch["solution"].active){
                    vm.showDiagHelpContent = true;
                    vm.isSystemDocContent = false;
                }
            }else if(!vm.isDiagFileDisplay && vm.selectedDiagFileId){
                vm.isDiagFileDisplay = true;
                vm.diagSearch["solution"].active = true;
                vm.diagSearch["remoteList"].active = false; 
                vm.diagSearch["ecu"].active = false;
                vm.diagSearch["dtcHistory"].active = false;
                vm.diagSearch["network"].active = false;
                vm.diagSearch["history"].active= false;
                vm.diagSearch["system"].active= false;
                vm.diagSearch["userjourney"].active = false;
                vm.diagSearch["nvPreparation"].active = false;
                vm.diagSearch["ocv"].active = false;
                vm.diagSearch["alert"].active = false;
                vm.diagSearch['diagnosticFile'].active = false;
                vm.isSystemDocContent = false;
                vm.showDiagHelpContent = true;
                vm.isSystemDocContent = false;
                vm.diagSearch["diagCompare"].active = false;
                vm.diagSearch["reprogrammingHistory"].active = false;
                vm.diagSearch['batteryReuseCrash'].active = false;
                systemSubMenuReset();
            }else if(!vm.selectedDiagFileId){
                toastr.info($translate.instant("DIAG_FILE_NOT_SELECTED"))
            }
            vm.isHistoryPagination = false;
                
        }
        function clearBinDiagDetails(){
            vm.showBINContent= false;
            vm.binSearched = false; 
            vm.diagFilesList = []; 
            CacheService.setObject(CacheConstants.diagFilesList,vm.diagFilesList);
            vm.selectedDiagFile = null;
            vm.isDiagFileDisplay = false;
            CacheService.setObject(CacheConstants.diagFileDisplay,vm.isDiagFileDisplay);
            CacheService.removeObject(CacheConstants.batteryCrashPrintData);
            vm.diagSearch["diagnosticFile"].active = true; 
            vm.currentPage=1;
            resetDiagMenus();
            getDiagDetails(null,null,null,1,null,null);
            event.stopPropagation();
            CacheService.removeObject(CacheConstants.binData);
        }
        function showBINDetails(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('BIN_Diagnostic_Files').then(function () {});
            vm.currentPage=1;
            vm.showBINContent= true;
            vm.isHistoryPagination = false;
            vm.historyPagination = {
            "ECU":{"screen":DiagFileDetailsNewConstants.ECU, "category":""},
            "DTC":{"screen":DiagFileDetailsNewConstants.DTC, "category":"" },
            "alert":{"screen":DiagFileDetailsNewConstants.alerts, "category":""},
            "network":{"screen":DiagFileDetailsNewConstants.network ,"category":DiagFileDetailsNewConstants.customerReport},
            "userJourney":{"screen":DiagFileDetailsNewConstants.userJourney,"category":DiagFileDetailsNewConstants.customerReport},
            "OCV":{"screen":DiagFileDetailsNewConstants.OCV,"category":DiagFileDetailsNewConstants.customerReport}
        };
        CacheService.setObject(CacheConstants.historyPagination, vm.historyPagination);
            if (vm.binSearched) {
                vm.diagSearch['binDiagnosticFile'].active = true;
                vm.diagSearch["ecu"].active = false;
                vm.diagSearch["network"].active = false;
                vm.diagSearch["dtcHistory"].active = false;
                vm.diagSearch["diagCompare"].active = false;
                vm.diagSearch["userjourney"].active = false;
                vm.diagSearch["reprogrammingHistory"].active = false; 
                vm.diagSearch['batteryReuseCrash'].active = false;
                vm.diagSearch["ocv"].active = false;
                vm.diagSearch["nvPreparation"].active = false;
                vm.diagSearch["alert"].active = false;                 
                vm.diagSearch["remoteList"].active = false; 
                vm.diagSearch["solution"].active= false;
                vm.diagSearch["system"].active= false;
                vm.diagSearch["history"].active= false;
                return;
            }
            vm.binSearched = true;           
            $mdDialog.show({
                templateUrl: 'app/components/car/searchByDiagnostic/remoteBinSearchPopup.template.html',
               controller: ["$scope", binDetailPopup],
               bindToController: true,
               controllerAs: 'vm',
               locals: {
                bin: vm.carContext.bin,
                enableRemoteListPopup: false
               },
               clickOutsideToClose: false,
             }).then(function(resp){
                    CacheService.removeObject(CacheConstants.batteryCrashPrintData);
                    if(resp == 'close'){
                        vm.binSearched = false;
                        vm.showBINContent= false;
                    }
             })
        }
        function binDetailPopup($scope){
            var vm = this;
            $scope.binDetailPopup = vm.binDetailPopup;

            $scope.search = function(){
                getDiagDetails(false,'bin',null,null,null,vm.bin);                
            }
            $scope.close = function(){                
                $mdDialog.hide("close");
            }
            $scope.getNumberArray = function() {
                return new Array(Math.max(vm.ipnList.length, vm.dealerList.length));
            };
            $scope.getStatusColor = function(status,value){
                return getStatusColor(status,value);
            };
             $scope.onVinClick = function(vin) {
                return onVinClick(vin);
            };
            $scope.onRelaunch = function(diagInfo) {
                return onRelaunch(diagInfo);
            };

        }
	    function showUserJourney(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('User_Journey').then(function () {});
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["userjourney"].active = true;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            vm.diagSearch["historyPage"].active = true;
            setPaginationDetails(DiagFileDetailsNewConstants.userJourney);
            systemSubMenuReset();

        }

        function showRemoteList(){
            vm.diagSearch["remoteList"].active = true;
            blockUI.start();
            addRegistrationNumber().then(function(){
                return ResultSearchByDiagnosticMetierService.getRemoteDiagList();
            }).then(function(remoteListResp){
                if(remoteListResp && remoteListResp.ipnList && !_.isEmpty(remoteListResp.ipnList)){
                    vm.ipnList = remoteListResp.ipnList;
                }
                if(remoteListResp && remoteListResp.dealerList && !_.isEmpty(remoteListResp.dealerList)){
                    vm.dealerList = remoteListResp.dealerList;
                }
            $mdDialog.show({
                templateUrl: 'app/components/car/searchByDiagnostic/remoteBinSearchPopup.template.html',
               controller: ["$scope", binDetailPopup],
               bindToController: true,
               controllerAs: 'vm',
               locals: {
                enableRemoteListPopup: true,
                ipnList: vm.ipnList,
                dealerList: vm.dealerList
               },
               clickOutsideToClose: true,
               onRemoving: function() {
                        vm.diagSearch['remoteList'].active = false;
                        vm.ipnList = [];
                        vm.dealerList = [];
               }
             }).then(function(resp){
                    if(resp == 'close'){
                        vm.diagSearch['remoteList'].active = false;
                        vm.ipnList = [];
                        vm.dealerList = [];
                    }
             })
             
            }).finally(function(){
                blockUI.stop();
            });
        }

        function showAlerts() {
            vm.diagSearch["history"].active = false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active = false;
            vm.diagSearch["system"].active = false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = true;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.solutionContent = false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
        }

        function addRegistrationNumber(){
            const contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            const vin = contextCarRequest.vin;
            const registrationNumber = contextCarRequest.registrationNumber;
            if (registrationNumber && registrationNumber.trim() !== '') {
                return ResultSearchByDiagnosticMetierService.addRegistrationNumber(vin, registrationNumber);
            }
            return $q.resolve();
        }

        function showNvPreparation(){
            vm.diagSearch["nvPreparation"].active= false;
            vm.diagSearch["history"].active= false;
           // vm.diagSearch["solution"].active= true;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["nvPreparation"].icon = !vm.diagSearch["nvPreparation"].icon;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["remoteList"].active = false; 
            vm.showSymptom = false;
            vm.solutionContent =false;
            vm.showDiagHelpContent = false;
            vm.isHistoryPagination = false;
        }
       
        function showOCV(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('OCV').then(function () {});
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.diagSearch["ocv"].active = true;
            vm.diagSearch["alert"].active = false;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            vm.diagSearch["historyPage"].active = true;
            setPaginationDetails(DiagFileDetailsNewConstants.OCV);
            systemSubMenuReset();
        } 

        function showGenericInfo(menu){
            systemSubMenuReset(menu);
            if (menu && menu.locale) {
                SearchArboTextualMetierService.setConnectedServicesAuditData('doc-' + menu.locale).then(function () {});
            }
            _.find(vm.systemDocResponse.systems, function(item){
                if(item.system.substr(-3) === menu.code){
                    vm.selectedSystemDoc = item;
                }
            });
            vm.isSystemDocContent = true;
            vm.diagSearch["system"].active= false
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["history"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.solutionContent = false;
            vm.isHistoryPagination = false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
        }
        function systemSubMenuReset(menu){
            vm.systemDocSubMenu.map(function(item){
                if(menu){
                    if(menu.code == item.code)
                        item.isActive = true;
                    else
                        item.isActive = false;
                }else{
                    item.isActive = false;
                }
                return item;
            })
            
        }

        function getPageData(page) {
            if (page != vm.paginationData.currentPage){ 
                vm.historyPagination[vm.paginationData.screen].currentPage = page;
                if(vm.diagSearch['historyPage'].active){
                getDiagDetails(true,vm.paginationData.screen,vm.historyPagination[vm.paginationData.screen].category,page,undefined,undefined,undefined,'history');
                }else{
                getDiagDetails(true,vm.paginationData.screen,vm.historyPagination[vm.paginationData.screen].category,page);
                }
            } 
        }

        function newPageData(page) {
            if (page != vm.paginationData.newPage){ 
                vm.historyPagination[vm.paginationData.screen].newPage = page;
                vm.getDiagDetails(true,vm.paginationData.screen,vm.historyPagination[vm.paginationData.screen].category,page);
            } 
        }

        function gotoADT(){
            //ADT Vehicle Selection by VIN
            if(!vm.isSearchByModel){
                var url = systemDocumentationConstants.adtVinSearchUrl +vm.carContext.vin+ systemDocumentationConstants.adtVinUrl;
                window.open(url,'_blank');
            }
            //ADT Vehicle Selection by Model
            else if(vm.isSearchByModel){
                var url = systemDocumentationConstants.adtModelSearchUrl;
                window.open(url,'_blank');
            }
        }

        function gotoADTFeedback() {
            //ADT Vehicle Selection by VIN & ADT Vehicle Selection by Model
            var url = systemDocumentationConstants.adtFeedbackUrl + encodeURIComponent(vm.contextCarVinCurrent);
            window.open(url,'_blank');
        }

        function showDiagCompare(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('DTC_Comparison').then(function () {});
            vm.diagSearch["history"].active= false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active= false;
            vm.diagSearch["system"].active= false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.solutionContent =false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["diagCompare"].active = true;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = false;
            vm.isHistoryPagination = false;
            systemSubMenuReset();
        }

        function showReprogrammingHistory() {
            SearchArboTextualMetierService.setConnectedServicesAuditData('Reprogramming_History').then(function () {});
            vm.diagSearch["history"].active = false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active = false;
            vm.diagSearch["system"].active = false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.solutionContent = false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.isHistoryPagination = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = true;
            vm.diagSearch['batteryReuseCrash'].active = false;
            systemSubMenuReset();
        }

        function showBatteryReuseCrash() {
            vm.diagSearch["history"].active = false;
            vm.diagSearch["remoteList"].active = false; 
            vm.diagSearch["solution"].active = false;
            vm.diagSearch["system"].active = false;
            vm.diagSearch["ecu"].active = false;
            vm.diagSearch["network"].active = false;
            vm.diagSearch["dtcHistory"].active = false;
            vm.diagSearch["nvPreparation"].active = false;
            vm.diagSearch['diagnosticFile'].active = false;
            vm.diagSearch['binDiagnosticFile'].active = false;
            vm.solutionContent = false;
            vm.showSymptom = false;
            vm.showDiagHelpContent = false;
            vm.isSystemDocContent = false;
            vm.isHistoryPagination = false;
            vm.diagSearch["userjourney"].active = false;
            vm.diagSearch["ocv"].active = false;
            vm.diagSearch["alert"].active = false;
            vm.diagSearch["diagCompare"].active = false;
            vm.diagSearch["reprogrammingHistory"].active = false;
            vm.diagSearch['batteryReuseCrash'].active = true
            systemSubMenuReset();
        }

        function symptomAiSearch(search) {
            symptomSearchError = null;
            var input = document.querySelector('.search-input');
            if (input && (!input.value || input.value.trim().length < 5)) {
                input.value = '';
                input.placeholder = $translate.instant('SYMPTOM_NOT_ENOUGH_CHARACTERS');
                changePlaceholderColor(input, 'red');
                vm.showDropdown = false;
            } else {
                if(input){
                    input.placeholder = $translate.instant('SYMPTOM_AI_SEARCH');
                    changePlaceholderColor(input, 'lightgray');
                }
                if(search !== previousSearch){
                blockUI.start();
                ResultSearchByDiagnosticMetierService.getSymptomsAIResult(search).then(function(QemotionResult) {
                    vm.dropdownItems = []; 
                    previousSearch = search;
                    var symptomsCodesList = CacheService.getObject(CacheConstants.getAllSymptoms);
                    var QemotionResultList = QemotionResult &&  QemotionResult.results ? QemotionResult.results : [];
                    var symptomsList = symptomsCodesList && symptomsCodesList.symptoms ? symptomsCodesList.symptoms : [];
                    var filterSymptoms = _.filter(symptomsList, function(item2) {
                        return _.some(QemotionResultList, function(item1) {
                            return item1.code === item2.shortCode;
                        });
                    });
                    var sortedSymptomsList = _.orderBy(filterSymptoms, function(item) {
                        return _.find(QemotionResultList, {
                            code: item.shortCode
                        }).score;
                    }, ['desc']);
                    vm.dropdownItems = sortedSymptomsList;
                    vm.showDropdown = true;
                    }).catch(function(err) {
                        if (err && err.status && err.status === 400) {
                            toastr.error($translate.instant("SYMPTOM_ERROR_MSG") + " " + ((err.data && err.data.errors && err.data.errors[0] && err.data.errors[0].errorMessage) || ""));
                        } else {
                            toastr.info($translate.instant("SYMPTOM_NO_RESULT"));
                        }
                    symptomSearchError = err;
                }).finally(function(err) {
                    if (!symptomSearchError && vm.dropdownItems && vm.dropdownItems.length == 0) {
                        toastr.info($translate.instant("SYMPTOM_NO_RESULT"));
                    }
                    blockUI.stop();
                })
                }else{
                    vm.showDropdown = true;
                    if(vm.dropdownItems && vm.dropdownItems.length == 0) {
                        toastr.info($translate.instant("SYMPTOM_NO_RESULT"));
                    }
                }
            }
        }

        function symptomSearchSelected(searchText, selectSymptom){
            getAllCodes(selectSymptom.label, 3,searchText);
        }

        function handleKeydown(event, searchText) {
            if (event.key === 'Enter') {
                event.stopPropagation();
                event.preventDefault();
                vm.symptomAiSearch(searchText);
            }
        }


        function resetPlaceholder() {
            $timeout(function() {
                var input = document.querySelector('.search-input');
                if(input){
                    input.placeholder = $translate.instant('SYMPTOM_AI_SEARCH');
                    changePlaceholderColor(input, 'lightgray');
                }
            }, 0);
        }

        function changePlaceholderColor(input, color) {
            var style = document.createElement('style');
            style.innerHTML = `.search-input::placeholder { color: ${color}; }`;
            document.head.appendChild(style);
        }

        function openDropdown(event) {
            $document.on('click', handleClickOutside);
        }

        function closeDropdown(event) {
            vm.showDropdown = false;
            $document.off('click', handleClickOutside);
        }


        function handleClickOutside(event) {
            var dropDownContainer = document.querySelector('.dropdown-list');
            var inputContainer = document.querySelector('.search-container');
            if (dropDownContainer && !dropDownContainer.contains(event.target) && inputContainer && !inputContainer.contains(event.target)) {
                $scope.$apply(closeDropdown(event));
            }
        }

        function clearSearch() {
            var input = document.querySelector('.search-input');
            if(input){
                input.value = '';
                input.placeholder = $translate.instant('SYMPTOM_AI_SEARCH');
                changePlaceholderColor(input, 'lightgray');
            }
            vm.showDropdown = false;
        }

        function onVinClick(vin){
            $mdDialog.show({
                templateUrl:
                    "app/components/basket/delete-dialog.template.html",
                controller: "deleteDialog",
                multiple:true,
                locals: {
                    enableRemote:true,
                    vinNumber:vin
                },
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true
            });
        }


        function onRelaunch(diagInfo){
             $mdDialog.show({
                templateUrl:
                    "app/components/basket/delete-dialog.template.html",
                controller: "deleteDialog",
                multiple:true,
                locals: {
                    enableLaunch:true,
                    vin: diagInfo.vin
                },
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true
            });
        }
        
        $scope.$on('$destroy', function() {
            $document.off('click', handleClickOutside);
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('remoteDiagnosticController', remoteDiagnosticController);

    /** @ngInject */
    function remoteDiagnosticController($mdDialog, SearchArboTextualMetierService) {
        var vm = this;
        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        function onCancel() {
            $mdDialog.cancel();
        }

        function onConfirm(){
            SearchArboTextualMetierService.setConnectedServicesAuditData('remote_diagnostic').then(function () { });
            $mdDialog.hide(true);
        }
    }
})();
/**
 * Recap Car Metier Service
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .service('RecapCarMetierService', RecapCarMetierService);

    /**
     * @namespace RecapCarMetierService
     * @desc Display car context informations(brand, model, image ...)
     * @memberOf Services
     */

    /** @ngInject */
    function RecapCarMetierService(
        CacheService,
        CarTechnicalFeaturesConstants,
        CacheConstants,
        CarSearchConstants,
        AlertsService,
        ShoppingCartService,
        QuoteMetierService,
        PartRequisitionMetierService,
        RoutesConstants,
        $state,
        $q,
        $rootScope,
        CreateActisBusinessService,
        $translate,
        toastr,
        warningModalCustomerService,
        globalConstant,
        $mdDialog,
        FicViewListWSService,
        CarSearchMetierService,$log, MainMetierService, AccessConfigService, configConstantes
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.reinitCarContext = reinitCarContext;
        this.getCarInfos = getCarInfos;
        this.redirectionReinitContext = redirectionReinitContext;
        this.reinitContext = reinitContext;
        this.clearAndRedirectCarsearch=clearAndRedirectCarsearch;
        vm.fic = {};
        vm.isActisFromDiag = CacheService.getObject(CacheConstants.isActisFromDiag);

        $rootScope.getFicData = function () {
            $rootScope.$broadcast('getFicData');
        };

        $rootScope.$on('loadFicData', function (event, data) {

            //Deep copy of the case view if it contains multiple object property
            for (var property in data) {
                // Case the property of data is not include in vm.fic we add it
                if (vm.fic && data && !vm.fic[property]) {
                    vm.fic[property] = data[property];
                } else { //On the other hand if property exist we copy the innerproperty inside
                    for (var innerProperty in data[property]) {
                        vm.fic[property][innerProperty] = data[property][innerProperty];
                    }
                }
            }
        });

        /**
         * @name reinitCarContext
         * @desc remove context car search and context car request form cache
         * @memberOf Services.RecapCarMetierService
         */
        function reinitCarContext() {
            CarSearchMetierService.setLocalizedData(false,null);
            CacheService.removeObject(CarSearchConstants.contextCarSearch);
            CacheService.removeObject(CarSearchConstants.contextCarRequest);
            CacheService.removeObject(CacheConstants.vehiclePresentInDMSbutNotInBVM);
            CacheService.removeObject(CacheConstants.nodeSelect);
            CacheService.removeObject(CacheConstants.hideDocsVisited);
            CacheService.removeObject(CacheConstants.isOrSearchCar);
            CacheService.removeObject(CacheConstants.bvaApigee);
            CacheService.removeObject(CacheConstants.otsCheck);
            CacheService.removeObject(CacheConstants.maintenanceIconCheck);
            CacheService.removeObject(CacheConstants.maintenanceProgramIcon);
            CacheService.removeObject(CacheConstants.diagFilesList);
            CacheService.removeObject(CacheConstants.getAllSymptoms);
            CacheService.removeObject(CacheConstants.symptomsBasketList);
            CacheService.removeObject(CacheConstants.searchedSymptom);
            CacheService.removeObject(CacheConstants.diagFileDisplay);
            CacheService.removeObject(CacheConstants.systemDocDetails);
            CacheService.removeObject(CacheConstants.wdObjectCriteria);
            CacheService.removeObject(CacheConstants.connectedPlatform);     
            CacheService.removeObject(CacheConstants.motCle);
            CacheService.removeObject(CacheConstants.isSearchEngine);
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            CacheService.removeObject(CacheConstants.searchEngineIds);
            CacheService.removeObject(CacheConstants.filter);
            CacheService.removeObject(CacheConstants.siesByGiesHistory);
            CacheService.removeObject(CacheConstants.transeversalPartsIds);
            CacheService.removeObject(CarTechnicalFeaturesConstants.isContextCarChanged);
            CacheService.removeObject(CarTechnicalFeaturesConstants.isLightFiltering);
            CacheService.removeObject(CacheConstants.componentsAndSignals);
            CacheService.removeObject(CacheConstants.treeContainingNodes);
            CacheService.removeObject(CacheConstants.wiringDiagramsCanDocument);
            CacheService.removeObject(CacheConstants.nodeFromSearchArbo);
            CacheService.removeObject(CacheConstants.levelsDoc);
            CacheService.removeObject(CacheConstants.tabIndex);
            CacheService.removeObject(CacheConstants.interventionIdList);
            CacheService.removeObject(CacheConstants.intNodeSelected);
            CacheService.removeObject(CacheConstants.selectedInterventionId);
            CacheService.removeObject(CacheConstants.backButtonEnable);
            CacheService.removeObject(CacheConstants.batteryCrashPrintData);
            CacheService.removeObject(CacheConstants.binData);
            CacheService.removeObject(CacheConstants.vinEligibleOffers);
            CacheService.removeObject(CacheConstants.wdMessageShow);
            CacheService.removeObject(CacheConstants.listOts);
            CacheService.removeObject(CacheConstants.basketPopupData);
            const profile = CacheService.getUserProfile();
            if(MainMetierService.isIndependantUser(profile.roles)){
                CacheService.removeObject(CacheConstants.asomSubscriptionForAllowedVin);
                refreshAsomDocRights();
            }
            CacheService.removeObject(CacheConstants.isRedirectFromDesyre);
            $rootScope.$emit('CART_UPDATED');
            CacheService.cleanSieDocumentsHistory();
            
        }

        function redirectionReinitContext() {
            var defer = $q.defer();
            var status = AlertsService.getPopinVisibility().status;
            
            if (status) {
                $mdDialog.show({
                    templateUrl: 'app/components/alerts/modal/contextCarModal/contextCar.html',
                    controller: 'ContextCarAlert',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        isFromChangeVehicle: true
                    }
                }).then(function () {
                    clearAndRedirectCarsearch();
                }).catch(function () { 
                    $log.debug($translate.instant('ERROR'));
                });
            } else {
                clearAndRedirectCarsearch();
            }
        }

        function clearAndRedirectCarsearch() {
            //if user is not connected dms, unlock current cart and set carContext's dms response to null
            var cartID = ShoppingCartService.getCurrentCartID();
            if(cartID){
                ShoppingCartService.unlockCart(cartID);
            }
            
            //if user is connected dms and has a workshop profile, unlock current part requsition,
            // set part requisition null and disable icon basket
            var currentPartRequisition = PartRequisitionMetierService.getCurrentPartRequisition();
            if (currentPartRequisition) {
                PartRequisitionMetierService.saveAndCloseCurrentPartRequisition(currentPartRequisition).then(function () {
                    return PartRequisitionMetierService.unlockPartRequisitionLogic().then(function (result) {
                        var message = $translate.instant("PART_REQUISITION_SUCCESS") + " (" + currentPartRequisition.number + ")";
                        toastr.success(message);
                        return result;
                    });
                }).catch(function () {
                    toastr.error($translate.instant("PART_REQUISITION_FAILURE"));
                })
            }

            var currentQuote = CacheService.getDmsQuote();
            if (currentQuote) {
                QuoteMetierService.closeQuote(currentQuote.id);
            }
            CacheService.removeObject(CacheConstants.dmsResponse);
            reinitCarContext();
            // On dev/local the car search screen lives in desyre, elsewhere it is still the legacy state.
            if (JSON.parse(configConstantes.isLocalRedirection) || JSON.parse(configConstantes.newCarSearch)) {
                MainMetierService.goToDesyre('carSearch');
            } else {
                $state.go(RoutesConstants.carSearch);
            }
        }

        function refreshAsomDocRights() {
            var asomDocList = MainMetierService.getAsomDocrights();
            $rootScope.asomDocList = asomDocList;
            AccessConfigService.getDocRights($rootScope.asomDocList);
        }
        /**
         * @name getCarInfos
         * @desc get car infos from cache
         * @desc get dmsResponse's registration number if exist
         * @returns {array} context car search from cache
         * @memberOf Services.RecapCarMetierService
         */
        function getCarInfos() { //TODO Brieuc
            //dms response (vehicle.v1) response
            var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
            //car context from bvm
            var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);

            //get dms's registration number if exist
            if (carInfosFromCache && carInfosFromCache.vehicle && dmsResponse && dmsResponse.vehicle && dmsResponse.vehicle.registrationNumber != "") {
                carInfosFromCache.vehicle.registrationNumber = dmsResponse.vehicle.registrationNumber;
            }
            return carInfosFromCache;
        }



        /**
         * @name reinitContext
         * @desc re-intialize context car
         * this action trigger when user click on a page having recap-car directive
         * @memberOf Controllers.recapCarController
         */

        function reinitContext() {
            if ($rootScope.currentState === RoutesConstants.manageFIC) {

                // Get the fic data
                $rootScope.getFicData();
                var responseApi = CacheService.getObject(CacheConstants.actisResponse);
                if (responseApi && responseApi.Car && responseApi.Car.mileageUnit) {
                    responseApi.Car.mileageUnit = responseApi.Car.mileageUnit.toUpperCase();
                }

                // Get the difference in response data and fic data
                var dataChanged = CreateActisBusinessService.deepDiffApiResultVsDataActisView(responseApi, vm.fic);
                dataChanged = CreateActisBusinessService.getDataChangedVerification(dataChanged);

                var currentStatus = $translate.instant(FicViewListWSService.convertStatusToND($rootScope.currentStatus));

                /**
                 * Do not show the pop-in if the FIC has been registered and no information has been changed
                 * or if the FIC is in the 'Sent' status, then the pop-in is not displayed.
                 */
                if (((currentStatus !== $translate.instant('ACTIS_ALL_OTHER_STATUSES') && currentStatus !== $translate.instant('ACTIS_CLOSED')) && !_.isEmpty(dataChanged))
                    || (_.isEmpty(currentStatus) && _.isEmpty(dataChanged)) && !vm.isActisFromDiag) {
                    $mdDialog.show({
                        templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                        controller: 'modalOnCloseFicController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        resolve: {
                            searchReference: function () {
                                return redirectionReinitContext;
                            }
                        }
                    });
                } else {
                    CacheService.removeObject(CacheConstants.searchedSymptom);
                    redirectionReinitContext();
                }
            } else {
                $q.resolve().then(function () {
                    var partRequisitionCustomer = CacheService.getPartRequisitionCustomer();
                    var quoteCustomer = CacheService.getQuoteCustomer();
                    if ((partRequisitionCustomer && partRequisitionCustomer.updated) || (quoteCustomer && quoteCustomer.updated)) {
                        return warningModalCustomerService.displayModal().catch(function () {
                            // reject from modal (on cancel)
                            return $q.reject(globalConstant.cancelModal);
                        })
                    }
                }).then(function () {
                    /** Added for upgrade migration fix */
                    CacheService.setObject(CacheConstants.basketPopupData,'')
                    $rootScope.panierData = '';
                    /**  */
                    redirectionReinitContext();
                }).catch(function (err) {
                    if (err === globalConstant.cancelModal) {
                        // do nothing, just catch to avoid browser warning
                    }
                })
            }
        }

    }

})();

/**
* recapCarController Controller
* @namespace Controllers
*/
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('recapCarController', recapCarController);

    /**
     * @namespace recapCarController
     * @desc get car search context after vin or brand/model search
     * @memberOf Controllers
     */

    /** @ngInject */
    function recapCarController($rootScope, RecapCarMetierService, CarTechnicalFeaturesConstants, 
        CacheConstants, CarSearchResultConstants, $state, RoutesConstants, CacheService, activeVinService, $scope,
        UtilsMetierService, DealerManagerSystemeService, 
        $mdDialog,  CarOtsMetierService,MainMetierService, $translate,
        $location, configConstantes, $window, CarSearchConstants, CloudFrontUrlHelper, ChatbotService, $timeout, CarSearchMetierService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        var recapCar = RecapCarMetierService.getCarInfos();
        var user = CacheService.getObject(RoutesConstants.profil);
        if(user){
            var isPartShop = DealerManagerSystemeService.isPartshop(user);
            var isWorkShop = DealerManagerSystemeService.isWorkshop(user);
        }
        var goTocarSearch = false;
        vm.showBtnInitContext = true;
        vm.isLinkCarFeatures = true;
        vm.isSearchByModel = false;
        vm.isConsultPrDoc = false;
        vm.proactiveAlert = activeVinService.getAlertData();
        vm.api = {
            showBtnInitContext: showBtnInitContext,
            enableLinkCarFeatures: enableLinkCarFeatures,
            showBtnConsultPrDoc: showBtnConsultPrDoc,
            init: init
        };
        vm.carDetailKilometers = {};
        vm.carComplementaryInformations = {};
        vm.dmsConnected = user.dmsConnected;
        vm.onCloseFic = onCloseFic;
        vm.fic = {};
        vm.redirectToOts = redirectToOts;
        vm.redirectToMaintenance = redirectToMaintenance;
        vm.checkOts =  checkOts;
        vm.hasCareAlert = !!CarSearchMetierService.getCareAlertData();
        vm.openCareAlert = function () {
            CarSearchMetierService.openCareAlertPopup();
        };        
        var carContext = CacheService.getCarContext();
        var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
        vm.carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);       
        
        // Use UtilsMetierService for standard exchange validation
        var standardExchangeValidation = UtilsMetierService.getStandardExchangeValidation(vm.carContextRequest);
        vm.hasAPVNM2 = standardExchangeValidation.hasAPVNM2;
        vm.hasAPVNM3 = standardExchangeValidation.hasAPVNM3;
        vm.hasAPVNM4 = standardExchangeValidation.hasAPVNM4;
        vm.hasAPV002 = standardExchangeValidation.hasAPV002;
        vm.hasAPV003 = standardExchangeValidation.hasAPV003;
        vm.hasAPV004 = standardExchangeValidation.hasAPV004;
        
        // Only show standard exchange if there's actual data
        vm.hasStandardExchange = vm.hasAPVNM2 || vm.hasAPVNM3 || vm.hasAPVNM4;
        
        vm.hasEligibleOffers = contextCarSearch && contextCarSearch.vehicle && contextCarSearch.vehicle.hasEligibleOffers;
        vm.otsVisible  =  CacheService.getObject(CacheConstants.otsCheck);
        vm.isPlannedAssistanceEnabled  = UtilsMetierService.isPlannedAssistance();
        var maintenanceProgramIcon = CacheService.getObject(CacheConstants.maintenanceProgramIcon);
        vm.showMaintenanceIcon = maintenanceProgramIcon && typeof maintenanceProgramIcon.showMaintenanceIcon !== 'undefined' ? maintenanceProgramIcon.showMaintenanceIcon : false;
        vm.maintenanceTooltip = maintenanceProgramIcon && typeof maintenanceProgramIcon.maintenanceTooltip !== 'undefined' ? maintenanceProgramIcon.maintenanceTooltip : '';
        var profileRole = UtilsMetierService.getProfile().roles;
        var listOts = CacheService.getObject(CacheConstants.listOts);
        vm.otsAvailable = (listOts && listOts.length != 0);
        vm.checkIndependentUser=profileRole ? MainMetierService.isIndependantUser(profileRole): null;
        vm.isCirSentVin = carContext ? MainMetierService.isCirSentVin(carContext.vin):null;
        vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
        vm.hasAsomTechCriTabAccess = this.hasAsomTechCriTabAccess;
        vm.isLightFiltering = CacheService.getObject(CarTechnicalFeaturesConstants.isLightFiltering);
        vm.redirectToAlertDiag = redirectToAlertDiag;
        vm.redirectToEligibleOffers = redirectToEligibleOffers;
        vm.loadInfoSection = loadInfoSection;
        vm.userProfiles = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.userProfiles.roles);
        vm.hasAsomOTSTabAccess = UtilsMetierService.hasAsomDocumentAccess('OTS', vm.isIndependentUser);
        vm.redirectToTechnicalCriteria = redirectToTechnicalCriteria;
        vm.showTechCritTab = false;
        vm.mileage = null;
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        vm.mileageUnit = null;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.userEditDisable = false;
        vm.isInfoFicEnabled = UtilsMetierService.isInfoFicEnabled();
        vm.hasDealerRole = MainMetierService.hasDealerRole;
        vm.isRedirecting = false;

        // Prevent multiple eligible offers redirects at once
        var eligibleRedirectInProgress = false;

        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name init
         * @desc show recap informations
         * this action trigger when the user click on search by vin or brand/model
         * @returns {panel} panel having (car image, car context informations,
         * link to update search for brancd/model search and change vehicule button)
         * @memberOf Controllers.recapCarController
         */
        $rootScope.$on('bannerDataLoaded', function () {
            recapCar = RecapCarMetierService.getCarInfos();
            if (recapCar && recapCar.vehicle) {
                vm.imageUrl = CloudFrontUrlHelper.appendCloudFrontParams(recapCar.vehicle.urlImage);
                vm.carDetailModel = returnCarDetailsFromJson(recapCar.vehicle);
                vm.carDetailVin = returnCarVinDetailsFromJson(recapCar.vehicle);
            }
        });

        $rootScope.$on(CarTechnicalFeaturesConstants.isLightFiltering, function (event, isLightFiltering) {
            vm.isLightFiltering = isLightFiltering;
            CacheService.setObject(CarTechnicalFeaturesConstants.isLightFiltering, vm.isLightFiltering);
        });

        $scope.$on('alertDisplay', function (event, data) {
            vm.proactiveAlert = data.isAlert;
            activeVinService.setAlertData(true);
        });
        $scope.$on('mileage', function (event,data){
            vm.mileage = data.mileage;
            vm.mileageUnit = data.mileageUnits ? data.mileageUnits : (data.vinMileageResponse ? (data.vinMileageResponse.charAt(0).toUpperCase() + data.vinMileageResponse.slice(1).toLowerCase()) : null);
            recapCar = RecapCarMetierService.getCarInfos();
            if (recapCar && recapCar.vehicle) {
                vm.imageUrl = CloudFrontUrlHelper.appendCloudFrontParams(recapCar.vehicle.urlImage);
                vm.carDetailModel = returnCarDetailsFromJson(recapCar.vehicle);
            }
        });
        
        $scope.$on('maintenanceIconUpdate', function (event, data) {
            vm.showMaintenanceIcon = data.showIcon;
            vm.maintenanceTooltip = data.tooltip;
        });

        $rootScope.$on('assistTool', function () {
            recapCar = RecapCarMetierService.getCarInfos();
            if (recapCar && recapCar.vehicle) {
                vm.carDetailModel = returnCarDetailsFromJson(recapCar.vehicle);
            }
        });

        function init() {
            vm.reinitContext = reinitContext;
            vm.goToCarFeatures = goToCarFeatures;
            vm.goToInfoClient = goToInfoClient;
            vm.goToSearchByModel = goToSearchByModel;
            vm.goToCatalog = goToCatalog;
            vm.reloadTree = reloadTree;

            $rootScope.$on('hasEligibleOffers', function ($event) {
                var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                vm.hasEligibleOffers = contextCarSearch && contextCarSearch.vehicle && contextCarSearch.vehicle.hasEligibleOffers;
                
            });
            if($state.params && $state.params.isOpenTechCritTab){
                vm.showTechCritTab = $state.params.isOpenTechCritTab;
            }
            if(!vm.otsVisible && recapCar && recapCar.vehicle && recapCar.vehicle.vin) {
                checkOts();
            }

            vm.hasAsomTechCriTabAccess = UtilsMetierService.hasAsomDocumentAccess('REF-BVM', vm.isIndependentUser);
            
            var maintenanceIconCheck = CacheService.getObject(CacheConstants.maintenanceIconCheck);
            if(!maintenanceIconCheck && recapCar && recapCar.vehicle && recapCar.vehicle.vin && vm.isPlannedAssistanceEnabled) {
                $rootScope.$broadcast('checkMaintenanceOperations');
            }

            if (recapCar && recapCar.vehicle) {
                vm.imageUrl = CloudFrontUrlHelper.appendCloudFrontParams(recapCar.vehicle.urlImage);
                vm.carDetailModel = returnCarDetailsFromJson(recapCar.vehicle);
                vm.carDetailVin = returnCarVinDetailsFromJson(recapCar.vehicle);

                vm.carComplementaryInformations = returnCarComplementaryInformations(recapCar.vehicle);
                if (isWorkShop) {
                    vm.carDetailKilometers = returnCarDetailsKilometers(recapCar.vehicle);
                }
                if (!isPartShop && recapCar.customer) {
                    vm.clientDetails = returnClientDetailsFromJson(recapCar);

                    if (recapCar.searchTypeByOR) {
                        vm.clientDetailsPoBoxNumber = returnClientDetailsPoBoxNumberFromJson(recapCar.ordersAndSplits && recapCar.ordersAndSplits.orderNumber);
                    }
                }

                vm.isSearchByModel = (recapCar && recapCar.vehicle && !recapCar.vehicle.vin && !recapCar.vehicle.registrationNumber);
            }
            else if ($rootScope.previousState != RoutesConstants.ficConsultation && $rootScope.currentState != RoutesConstants.manageFIC ) {
                $state.go(RoutesConstants.carSearch);
            }
            var idData = document.getElementById('newTechCritTab');
            var isGoToBackFromFeatures = CacheService.getObject(CacheConstants.goToBackFromFeatures);
            vm.userEditDisable = !!idData && !isGoToBackFromFeatures;

            if (isGoToBackFromFeatures) {
                CacheService.removeObject(CacheConstants.goToBackFromFeatures);
            }
        }


        function  checkOts(){   
        CarOtsMetierService.getOts().then(function (response) {
          if (response) {
             //CacheService.setObject(CacheConstants.otsCheck,true);
            if(response.length != 0){
                CacheService.setObject(CacheConstants.listOts, response);
            
                $rootScope.$broadcast('otsAvailable', {
                    response:  	CacheConstants.listOts
                });
                var profileRole = UtilsMetierService.getProfile().roles;
                 if(profileRole && vm.hasAsomOTSTabAccess){
                   
                      vm.otsAvailable = true;
                 } 
                 }
                                   
          }
        }).finally(function(){
            CacheService.setObject(CacheConstants.otsCheck,true);
        });
        }

        function onCloseFic(redirectionPage, displayParam) {
            vm.redirectionPage = redirectionPage;

            if ($rootScope.currentState === vm.rCst.manageFIC) {

                if (displayParam) {
                    vm.redirectionPage.displayParam = displayParam;
                }
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        redirectionPage: function () {
                            return vm.redirectionPage;
                        }
                    }
                });
            } else {
                if (displayParam) {
                    $state.go(redirectionPage, displayParam);
                } else {
                    $state.go(redirectionPage);
                }
            }
        }

        function redirectToOts(){
            $state.go(RoutesConstants.carFeaturesView, {tabName:'otsTab'});
        }

        function redirectToMaintenance(fromCalendarIcon){
            $state.go(RoutesConstants.carFeatures, {tabName:'maintenanceProgramTab'});
        }
          
        function redirectToAlertDiag(isAlert){
            $rootScope.$broadcast("isAlertsClicked", { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic, redirectToAlerts: isAlert });
        }

        function redirectToEligibleOffers(isEligible){
            if (vm.isRedirecting || !isEligible) {
                return;
            }
            
            vm.isRedirecting = true;
            
            function switchToEligibleTab() {
                return new Promise(function(resolve, reject) {
                    var searchArboScope = angular.element(document.getElementById('searchArboTextual')).scope();
                    
                    if (searchArboScope && searchArboScope.searchArboTextualCtrl) {
                        
                        try {
                            searchArboScope.searchArboTextualCtrl.openSelectedView('showVehicleMultimediaInformation');
                            
                            // CRITICAL: Use consistent, production-safe timing (1200ms)
                            $timeout(function() {
                                findAndCallSwitchOffers()
                                    .then(function() {
                                        // CRITICAL: Wait for digest cycle to complete (250ms)
                                        return $timeout(function() {
                                            $rootScope.$broadcast("switchToEligibleOffers", { 
                                                isEligible: true, 
                                                forceSwitch: true,
                                                timestamp: Date.now()
                                            });
                                            resolve();
                                        }, 250);
                                    })
                                    .catch(function(error) {
                                        console.error('[redirectToEligibleOffers] Error in findAndCallSwitchOffers:', error);
                                        reject(error);
                                    });
                            }, 1200);
                        } catch (error) {
                            console.error('[redirectToEligibleOffers] Error opening view:', error);
                            reject(error);
                        }
                    } else {
                        // CRITICAL: Same timing as main path for consistency (1200ms)
                        $timeout(function() {
                            findAndCallSwitchOffers()
                                .then(function() {
                                    return $timeout(function() {
                                        $rootScope.$broadcast("switchToEligibleOffers", { 
                                            isEligible: true, 
                                            forceSwitch: true,
                                            timestamp: Date.now()
                                        });
                                        $rootScope.$broadcast("ConnectedServicesOffers", true, 'isEligibleOffer');
                                        resolve();
                                    }, 250);
                                })
                                .catch(function(error) {
                                    console.error('[redirectToEligibleOffers] Error in fallback:', error);
                                    reject(error);
                                });
                        }, 1200);
                    }
                });
            }

            function findAndCallSwitchOffers() {
                return new Promise(function(resolve, reject) {
                    // CRITICAL: Wait for DOM to be ready (500ms for production)
                    $timeout(function() {
                        var selectors = [
                            'connected-services-offers',
                            '[connected-services-offers]'
                        ];
                        var scopeToUse = null;
                        var elementFound = false;
                        
                        // Try specific selectors first
                        for (var j = 0; j < selectors.length; j++) {
                            var element = angular.element(document.querySelector(selectors[j]));
                            if (element.length > 0) {
                                var scope = element.scope();
                                if (scope && scope.vm && scope.vm.switchOffers && typeof scope.vm.switchOffers === 'function') {
                                    scopeToUse = scope;
                                    elementFound = true;
                                    break;
                                }
                            }
                        }
                        
                        // Fallback: search all elements if not found
                        if (!elementFound) {
                            var allElements = document.querySelectorAll('*');
                            for (var i = 0; i < allElements.length; i++) {
                                var el = angular.element(allElements[i]);
                                var elScope = el.scope();
                                if (elScope && elScope.vm && elScope.vm.switchOffers && typeof elScope.vm.switchOffers === 'function') {
                                    scopeToUse = elScope;
                                    elementFound = true;
                                    break;
                                }
                            }
                        }
                        
                        if (scopeToUse) {
                            // CRITICAL: Wait before calling switchOffers (300ms for production)
                            $timeout(function() {
                                try {
                                    scopeToUse.vm.switchOffers('eligible');
                                    
                                    // CRITICAL: Chain $onInit calls with production-safe delays (350ms each)
                                    $timeout(function() {
                                        // Call rLinkCarController $onInit
                                        var rlinkCarScope = angular.element(document.getElementById('rLinkCar')).scope();
                                        if (rlinkCarScope && rlinkCarScope.rLinkCarCtrl && typeof rlinkCarScope.rLinkCarCtrl.$onInit === 'function') {
                                            try {
                                                rlinkCarScope.rLinkCarCtrl.$onInit({ fromEligibleRedirect: true });
                                            } catch (initError) {
                                                console.error('[findAndCallSwitchOffers] Error in rLinkCarCtrl.$onInit:', initError);
                                            }
                                        }
                                        
                                        // Call connectedServicesOffers $onInit
                                        $timeout(function() {
                                            var connectedServicesScope = angular.element(document.querySelector('connected-services-offers')).scope();
                                            if (connectedServicesScope && connectedServicesScope.vm && typeof connectedServicesScope.vm.$onInit === 'function') {
                                                try {
                                                    connectedServicesScope.vm.$onInit({ fromEligibleRedirect: true });
                                                } catch (initError) {
                                                    console.error('[findAndCallSwitchOffers] Error in connectedServicesOffers.$onInit:', initError);
                                                }
                                            }
                                            resolve();
                                        }, 350);
                                    }, 350);
                                } catch (error) {
                                    console.error('[findAndCallSwitchOffers] Error calling switchOffers:', error);
                                    reject(error);
                                }
                            }, 300);
                        } else {
                            console.warn('[findAndCallSwitchOffers] Component not found in DOM');
                            resolve(); // Don't fail, just resolve
                        }
                    }, 500);
                });
            }
            
            function resetRedirectingFlag() {
                $timeout(function() {
                    vm.isRedirecting = false;
                }, 2000);
            }
            
            // Check if already on the multimedia page
            if ($state.current.name === RoutesConstants.carSearchResult && 
                $state.params.tab === CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation) {
                switchToEligibleTab()
                    .then(function() {
                        resetRedirectingFlag();
                    })
                    .catch(function(error) {
                        console.error('[redirectToEligibleOffers] Error switching tab:', error);
                        resetRedirectingFlag();
                    });
            } else {
                $state.go(RoutesConstants.carSearchResult, { 
                    tab: CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation 
                }).then(function() {
                    // CRITICAL: Long delay for state transition + bundle loading in production (1500ms)
                    return $timeout(function() {
                        // Try direct vm.switchOffers first
                        if (vm.switchOffers && typeof vm.switchOffers === 'function') {
                            try {
                                vm.switchOffers('eligible');
                            } catch (error) {
                                console.error('[redirectToEligibleOffers] Error calling vm.switchOffers:', error);
                            }
                        }
                        
                        // Search for component and call switchOffers
                        var selectors = ['connected-services-offers', '[connected-services-offers]'];
                        var componentFound = false;
                        
                        for (var j = 0; j < selectors.length; j++) {
                            var element = angular.element(document.querySelector(selectors[j]));
                            if (element.length > 0) {
                                var scope = element.scope();
                                if (scope && scope.vm && typeof scope.vm.switchOffers === 'function') {
                                    componentFound = true;
                                    
                                    // CRITICAL: Use $timeout with proper delay (300ms)
                                    $timeout(function() {
                                        try {
                                            scope.vm.switchOffers('eligible');
                                        } catch (error) {
                                            console.error('[redirectToEligibleOffers] Error calling scope.vm.switchOffers:', error);
                                        }
                                    }, 300);
                                    
                                    // Handle submenu switching
                                    if (scope.vm.connectedServiceOfferTab && scope.vm.selectedSubMenu && Array.isArray(scope.vm.connectedServiceOfferTab)) {
                                        var enableTabMenu = null;
                                        for (var k = 0; k < scope.vm.connectedServiceOfferTab.length; k++) {
                                            var menu = scope.vm.connectedServiceOfferTab[k];
                                            if (menu && (menu.name === 'isEnableTab' || menu.type === 'isEnableTab' || 
                                                        menu.id === 'isEnableTab' || menu.key === 'isEnableTab')) {
                                                enableTabMenu = menu;
                                                break;
                                            }
                                        }
                                        if (enableTabMenu) {
                                            $timeout(function() {
                                                try {
                                                    scope.vm.selectedSubMenu(enableTabMenu);
                                                } catch (error) {
                                                    console.error('[redirectToEligibleOffers] Error calling selectedSubMenu:', error);
                                                }
                                            }, 400);
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                        
                        if (!componentFound) {
                            console.warn('[redirectToEligibleOffers] Component not found after state transition');
                        }
                        
                        // Call main switch function
                        return switchToEligibleTab();
                    }, 1500);
                }).then(function() {
                    resetRedirectingFlag();
                }).catch(function(error) {
                    console.error('[redirectToEligibleOffers] Error in state navigation:', error);
                    resetRedirectingFlag();
                });
            }
        }

        function redirectToTechnicalCriteria(){
            var url = $state.href(RoutesConstants.newTechCritTab, {tabName:'technicalCriteriaTab', isOpenTechCritTab: true});
            var openedWindow = $window.open(url, '_blank');
            openedWindow.onload  = function(){
                var channel = new BroadcastChannel("open-tech-tab");
                channel.postMessage(true);
            }
        }

        /**
         * @name reinitContext
         * @desc re-intialize context car
         * this action trigger when user click on a page having recap-car directive
         * @memberOf Controllers.recapCarController
         */
        function reinitContext() {
            goTocarSearch = true;
            if (ChatbotService && ChatbotService.hasActiveSession && ChatbotService.hasActiveSession()) {
                ChatbotService.clearSession();
            }
            $rootScope.$broadcast("vehicleClicked",goTocarSearch);
            return RecapCarMetierService.reinitContext();
        }

        /**
         * @name goToCarFeatures
         * @desc redirect user to carFeatures
         * not used, always redirect to car search result
         * @returns {state} redirect to car features if carDetailVin & isLinkCarFeatures
         * @memberOf Controllers.recapCarController
         */
        function goToCarFeatures() {
            var userProfile = CacheService.getUserProfile();
            if(userProfile &&userProfile.roles && !_.isEmpty(userProfile.roles) && MainMetierService.isIndependantUser(userProfile.roles))
            {
                 
                if(UtilsMetierService.hasAsomDocumentAccess('REF-BVM', vm.isIndependentUser)){
                    return $state.go(RoutesConstants.carFeatures, { tabName: 'technicalCriteriaTab' });
                }else if(UtilsMetierService.hasAsomDocumentAccess('OTS', vm.isIndependentUser)){
                    return $state.go(RoutesConstants.carFeatures, { tabName: 'otsTab' });
                }else if(UtilsMetierService.hasAsomDocumentAccess('REP', vm.isIndependentUser)){    
                    return $state.go(RoutesConstants.carFeatures, { tabName: 'maintenanceProgramTab' });
                }else if(UtilsMetierService.hasAsomDocumentAccess('HM', vm.isIndependentUser)){
                    $timeout(function() {
                        $rootScope.$broadcast('phx-opentabvehicleMaintenanceHistoryTab', {});
                    }, 100);
                    return $state.go(RoutesConstants.carFeatures, { tabName: 'vehicleMaintenanceHistoryTab' });
                }else if ( vm.isAsomValidDocAccess == "false" && !vm.isCirSentVin &&  userProfile.accountType == 'Automobile repairer'){
                    return $state.go(RoutesConstants.carFeatures, { tabName: 'maintenanceProgramTab' });
                }
                
            }
            if(vm.checktm) {
                return false;
            }
            if (vm.carDetailVin && vm.isLinkCarFeatures && !vm.isMitsubishiUser && !vm.isPpxLightUser) {

                var previousState = $scope.vm.callback();
                $state.go(RoutesConstants.carFeatures, { previousState: previousState });
            }
            else {
                return false;
            }
        }

        /**
         * @name goToInfoClient
         * @desc redirect user to infos client
         * not used, always redirect to car search result
         * @returns {state} infoClient state
         * @memberOf Controllers.recapCarController
         */
        function goToInfoClient() {
            if(!vm.userEditDisable) {
                $state.go(RoutesConstants.infoClient);
            }
        }

        /**
          * @name goToSearchByModel
          * @desc redirect user to carFeatures
          * not used, always redirect to car search result
          * @returns {state} carSearch state
          * @memberOf Controllers.recapCarController
          */
        function goToSearchByModel() {
            goTocarSearch = true;
            if (ChatbotService && ChatbotService.hasActiveSession && ChatbotService.hasActiveSession()) {
                ChatbotService.clearSession();
            }
            RecapCarMetierService.reinitCarContext();
            $rootScope.$broadcast("vehicleClicked",goTocarSearch);
            $state.go(RoutesConstants.carSearch, { "searchByModel": true });
        }

        /**
         * @name showAttachedIllustration
         * @desc redirect to car search result
         * always redirect to car search result
         * @returns {state} carSearchResult state
         * @memberOf Controllers.showAttachedIllustration
         */
        function goToCatalog() {
            $state.go(RoutesConstants.carSearchResult);
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        //return first row informations (brand, model, motorisation label, gearbox label)
        function returnCarDetailsFromJson(carsDetail) {
            var carDetails = '';
            carDetails += (carsDetail.model != null && carsDetail.model !== undefined && carsDetail.model != '') ? (carsDetail.model + ', ') : '';
            carDetails += (carsDetail.motorisation !== null &&carsDetail.motorisation !== undefined && carsDetail.motorisation != '') ? (carsDetail.motorisation) : '';
            carDetails += (carsDetail.motorisation || carsDetail.model) ? ', ' : '';
            carDetails += (carsDetail.gearBoxType !== null && carsDetail.gearBoxType !== undefined && carsDetail.gearBoxType !== '') ? carsDetail.gearBoxType : '';
            carDetails += ((carsDetail.motorisation || carsDetail.model) && (carsDetail.colorCode || carsDetail.color)) ? ', ' : '';
            carDetails += (carsDetail.colorCode != null && carsDetail.colorCode !== undefined && carsDetail.colorCode != '') ? (carsDetail.colorCode + ' ') : ((carsDetail.color != null && carsDetail.color !== undefined && carsDetail.color != '') ? (carsDetail.color + ' ') : '');
            if(vm.mileage) {
                carDetails += ', '+vm.mileage+' '+ vm.mileageUnit;
            }
            
            var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            if (connectedPlatform && connectedPlatform.architecture) {
                carDetails += ', ' + connectedPlatform.architecture.toUpperCase();
            }
            
            return carDetails;
        }

        //return car kilometers
        function returnCarDetailsKilometers(carsDetail) {
            return carsDetail.mileAge;
        }

        //return carDetails after vin search
        function returnCarVinDetailsFromJson(car) {
            var carDetailsVin = car.vin ? car.vin : '';
            if (car.registrationNumber) {
                carDetailsVin += car.registrationNumber ? (' | ' + car.registrationNumber) : '';
            }

            return carDetailsVin;
        }

        //return client details when dms is active
        function returnClientDetailsFromJson(clientDetail) {
            var clientDetails = '';
            clientDetails += clientDetail.customer.firstName !== undefined ? (clientDetail.customer.firstName + ' ') : '';
            clientDetails += clientDetail.customer.name !== undefined ? (clientDetail.customer.name + ' ') : '';
            clientDetails += clientDetail.accountNumber !== undefined ? ('(' + clientDetail.accountNumber + ')') : '';

            return clientDetails;
        }

        //return client order number when dms is active
        function returnClientDetailsPoBoxNumberFromJson(orderNumber) {
            var orderInformations = '';
            orderInformations += orderNumber !== undefined ? (' ' + orderNumber) : '';
            return orderInformations;
        }

        //return second row informations (engineSuffix, gearboxSuffix, batterySuffix ...)
        function returnCarComplementaryInformations(vehiculeContext) {
            var complementaryInfos = [];

            if (vehiculeContext.engineSuffix && vehiculeContext.engineSuffix != "") {
                complementaryInfos.push(vehiculeContext.engineSuffix);
            }
            if (vehiculeContext.gearboxSuffix && vehiculeContext.gearboxSuffix != "") {
                complementaryInfos.push(vehiculeContext.gearboxSuffix);
            }
            if (vehiculeContext.batterySuffix && vehiculeContext.batterySuffix != "") {
                complementaryInfos.push(vehiculeContext.batterySuffix);
            }
            if (vehiculeContext.tractionBattery && vehiculeContext.tractionBattery != "") {
                complementaryInfos.push(vehiculeContext.tractionBattery);
            }
            if (vehiculeContext.steeringWheelLocation && vehiculeContext.steeringWheelLocation != "") {
                complementaryInfos.push(vehiculeContext.steeringWheelLocation);
            }
            if (vehiculeContext.vehiculeVersion && vehiculeContext.vehiculeVersion != "") {
                complementaryInfos.push(vehiculeContext.vehiculeVersion);
            }
            if (vehiculeContext.equipmentLevel && vehiculeContext.equipmentLevel != "") {
                complementaryInfos.push(vehiculeContext.equipmentLevel);
            }
            if (vehiculeContext.heatingSystem && vehiculeContext.heatingSystem != "") {
                complementaryInfos.push(vehiculeContext.heatingSystem);
            }
            if (vehiculeContext.gas && vehiculeContext.gas != "") {
                complementaryInfos.push(vehiculeContext.gas);
            }

            return complementaryInfos;

        }

        function showBtnInitContext(showOrHide) {
            vm.showBtnInitContext = showOrHide;
        }

        function enableLinkCarFeatures(showOrHide) {
            vm.isLinkCarFeatures = showOrHide;
        }

        function showBtnConsultPrDoc(showOrHide) {
            vm.isConsultPrDoc = showOrHide;
        }

        function reloadTree(){
            if($location.path().includes('carFeatures')){
                $rootScope.$broadcast('resetLightFiltering', {});
            }else{

                var body = angular.element(document.body);

                $mdDialog.show({
                    parent: body,
                    templateUrl: 'app/components/car/recapCar/lightFilteringModal.template.html',
                    controller: "lightFilteringController",
                    controllerAs: "vm",
                    bindToController: true,
                    clickOutsideToClose: true
                    
                });

            }
            
        }

        function loadInfoSection() {
            var body = angular.element(document.body);
            $mdDialog.show({
                parent: body,
                template: $translate.instant("INFO_SEC_CONTENT_MSG"),
                bindToController: true,
                clickOutsideToClose: true,
                multiple: true,
                scope: angular.extend($scope.$new(), {
                    close: function () { $mdDialog.cancel(); },
                    searchBT: function () {
                        if ($rootScope.searchRefBTNT) {
                            $rootScope.searchRefBTNT("86605", "InfoSec");
                        }           
                    }
                })
            });
        }
    }
})();

(function () {
    'use strict';

    /**
     * @desc get tm information (code, title, ...)
     * @param {array} api current tm object
     * @example <recap-car api="cSearchResultCtrl.recapCarAPI"></recap-car>
     */

    angular
        .module('phenix')
        .directive('recapCar', recapCar);

    /** @ngInject */
    function recapCar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/car/recapCar/recapCar.html',
            controller: 'recapCarController',
            controllerAs: 'vm',
            scope: {
                api: '=',
                checktm:'=',
                callback: '&',
                icons: '=',
                isWd: '='
            },
            bindToController: true
        };
        return directive;
    }

})();

/**
* recapCarController Controller
* @namespace Controllers
*/
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('lightFilteringController', lightFilteringController);

        /**
     * @namespace lightFilteringController
     * @desc get car search context after vin or brand/model search
     * @memberOf Controllers
     */

    /** @ngInject */
    function lightFilteringController($rootScope, CarTechnicalFeaturesConstants, 
        CacheConstants, $state, RoutesConstants, CacheService, $mdDialog,  blockUI, 
        CarSearchMetierService, configConstantes) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/

            var vm = this;
            vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
            vm.onValidate = onValidate;
            vm.onCancel = onCancel;


            function onValidate(){
                $mdDialog.hide();
                CacheService.removeObject(CacheConstants.otsCheck);
                CacheService.removeObject(CacheConstants.maintenanceIconCheck);

                blockUI.start();
                var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
                var getCarContext;
    
                //call search car with vin if exist, immat else
                if(contextCarRequest.vin){
                    getCarContext = CarSearchMetierService.searchCar({ vin: contextCarRequest.vin }).then(function(){
                        CarSearchMetierService.getBannerData();
                    });
                }else if(contextCarRequest.registrationNumber){
                    getCarContext = CarSearchMetierService.searchCar({ imat: contextCarRequest.registrationNumber }).then(function(){
                        CarSearchMetierService.getBannerData();
                    });
                }
    
                getCarContext.then(function(data){
                    var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                    delete contextCarSearch.treeNodes;
                    $state.go(RoutesConstants.carSearchResult, {
                    }, { notify: true, reload: true, inherit: false });
                    
                }).finally(function(){
                    $rootScope.$broadcast(CarTechnicalFeaturesConstants.isLightFiltering, false);
                    CarSearchMetierService.setLocalizedData(false,null);
                    blockUI.stop();
                })
                
                
            }
    
            function onCancel(){
                $mdDialog.cancel();
            }
        }
    })();

/**
 * SearchArboTextualCtrl Controller
 * @namespace Controllers
 */
(function () {

    angular
        .module('phenix')
        .filter('onlyMRandMDandPR', function () {
            return function (filters) {
                var filtered = [];
                if (filters && filters.length >0) {
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        // check if the filter type is ALL, MR or MD or PR
                        if (filter && (filter.id === 'ALL' || filter.id === 'MR' || filter.id === 'MD' || filter.id === 'PR')) {
                            filtered.push(filter);
                        }
                    }
                }
                return filtered;
            };
        }).filter('onlyTMandMRandMDandTMLIST', function () {
            return function (filters) {
                var newFiltered = [];
                if (filters && filters.length > 0) {
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        // check if the filter type is ALL, MR or MD or PR
                        if (filter && (filter.id === 'TM' || filter.id === 'MR' || filter.id === 'MD' || filter.id === 'TM_LIST')) {
                            newFiltered.push(filter);
                        }
                    }
                }
                return newFiltered;
            };
        }).filter('onlyMRandMD', function () {
            return function (filters) {
                var newFiltered = [];
                if (filters && filters.length > 0) {
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        if (filter && (filter.id === 'MR' || filter.id === 'MD')) {
                            newFiltered.push(filter);
                        }
                    }
                }
                return newFiltered;
            };
        })
        .controller('SearchArboTextualCtrl', SearchArboTextualCtrl);

    //ça sert à quoi !
    angular.module('phenix')
    .run(['$anchorScroll', function ($anchorScroll) {
        $anchorScroll.yOffset = 0;
        //$rootScope.$broadcast('phx-scrollTop', {});
    }]);

    /**
    * @namespace SearchArboTextualCtrl
    * @desc display tree (level1, level2 and level3)
    * @memberOf Controllers
    */

    /** @ngInject */
    function SearchArboTextualCtrl(
        CacheConstants,
        AxleGeometryService,
        SvgCache,
        ScrollService,
        searchByTextsIdsMertierService,
        DocumentsWsService,
        $modal,
        toastr,
        RoutesConstants,
        CacheService,
        SearchArboTextualMetierService,
        $state,
        $window,
        $scope,
        configConstantes,
        $rootScope,
        $translate,
        blockUI,
        AlertsLocationService,
        $q,
        $log,
        $filter,
        $timeout,
        DocumentsMetierService,
        $mdDialog,
        UtilsMetierService,
        ClipConstants,
	    RdsConstants,
        RetailGroupConstants,
        MainMetierService,
        ClipService,
        CarSearchResultConstants,
        searchElectricalSchemaMetierService,
        CarSearchMetierService,
        ProductMetierService,
        RoutingService,
        errorsConstant,DocPrivMetierService,CloudFrontUrlHelper
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);
        var typeMD = CacheService.getCarContext() ? CacheService.getCarContext().typeMD : '';
        var vm = this;
        var filter = CacheService.getObject(CacheConstants.filter);
        vm.isArcaUser = MainMetierService.isArcaUser();
        var isSearchClicked = false;
        vm.filterChoosen = filter ? filter : { id: "ALL" };
        vm.stateInit = true;
        vm.firstSelect = true;
        vm.nodeSelect = undefined;
        //boolean to show or hide the whole container
        vm.showContent = true;
        vm.showArboView = true;
        vm.showDiagnosticView = false;
        vm.showSpecializedToolView = false;
        vm.searchByKeyWord = false;
        vm.showDiagFilesView = false;
        vm.isActive = isActive;
        vm.divSelected = divSelected;
        vm.stateInputsForm = { motCle: { active: undefined } };
        vm.stateInputSearch = { dftcode: { active: undefined }, dtcode: { active: undefined }, symptom: { active: undefined } };
        vm.diagnosticDefaultCodeDropDownOpenClose = 'diagnosticDropDownClose';
        vm.diagnosticDTCCodeDropDownOpenClose = 'diagnosticDropDownClose';
        vm.diagnosticSymptomCodeDropDownOpenClose = 'diagnosticDropDownClose';
        vm.scrollToTopButtonClass = 'scrollToTopButtonHidden';
        vm.isComponentSelectedFromClip = false;
        vm.wiringDiagramsCache = '';
        vm.primaryPresent = false;
        vm.secondaryPresent = false;
        vm.signalPresent = false;
        vm.isUserComingFromClip = false;
        vm.isRLink2Vehicle = false;
        vm.isRLink1Vehicle = false;
        vm.connectorList = [];
        vm.isDetailsAvailable = false;
        vm.isEasyBasket = false;
        vm.independentProfilcheck = independentProfilcheck;
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        vm.isNewSearchBar = true;
        vm.defaultCode = {
            defaultCode: ""
        };
        vm.dtcCode = {
            dtcCode: ""
        };
        vm.symptom = {
            symptom: ""
        };
        var node_1 = '';
        var node_2 = '';
        var node_3 = '';
        vm.diagFileId = null;
        vm.isCountryKorea = UtilsMetierService.isCountryTargeted('KR');
        vm.otsResponse;
        vm.showAutocomplete = false;
        vm.newTextSearch=false;
        vm.isRLinkHeader = true;
        vm.isCnrUserGuide = false;
        vm.autocompleteList = [];
        var carContext = CacheService.getCarContext();
        vm.diagCond =(carContext && carContext.typeMD && !(carContext.typeMD.includes('B3')) && ((carContext.typeMD.includes('B2')) || (carContext.typeMD.includes('B2-3'))));
        var localizedData = CarSearchMetierService.getLocalizedData();
        vm.tiresResponse = localizedData ? localizedData.hasData : false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.tyresInfo = (vm.tiresResponse && localizedData.data && _.has(localizedData.data,'tyresInfo') && localizedData.data.tyresInfo) ? localizedData.data.tyresInfo : [];
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.isClipRedirectionForNodes = false;
        let isTextSearchRedirect = false;
        let isComingFromDiagFileDetails = false;
        vm.setFocus = setFocus;
        vm.consultElectricalShema = consultElectricalShema;
        vm.consultLastDocument = consultLastDocument;
        vm.VarAppBeforeGoToListePiece = VarAppBeforeGoToListePiece;
        vm.goToQuestionnig = goToQuestionnig;
        vm.goToLevelTwoAndThreeAndShowImage = goToLevelTwoAndThreeAndShowImage();
        vm.goToLevelTwoAndThreeWithoutShowImage = goToLevelTwoAndThreeWithoutShowImage;
        vm.goToLevelTwoAndThreeWithoutShowImageFirst = goToLevelTwoAndThreeWithoutShowImageFirst;
        vm.showExplodedViewFunction = showExplodedViewFunction;
        vm.goToListePiece = goToListePiece;
        vm.scrollToTop = scrollToTop;
        vm.selectDefaultCodeFromDropdown = selectDefaultCodeFromDropdown;
        vm.selectDTCCodeFromDropdown = selectDTCCodeFromDropdown;
        vm.selectSymptomCodeFromDropdown = selectSymptomCodeFromDropdown;
        vm.switchState = switchState;
        vm.searchOnPressEnter = searchOnPressEnter;
        vm.changeFilter = changeFilter;
        vm.searchNodebyRef = searchNodebyRef;
        vm.filterDocumentsArboByType = filterDocumentsArboByType;
        //vm.showViewSearchByDiagnostic = showViewSearchByDiagnostic;
        //vm.showViewSearchBySpecializedTool = showViewSearchBySpecializedTool;
        vm.reinitSearch = reinitSearch;
        vm.onChangeMotCle = onChangeMotCle;
        vm.onKeyPressed = onKeyPressed;
        vm.openSelectedView = openSelectedView;
        vm.getArboIconClass = getArboIconClass;
        vm.getDiagnosticIconClass = getDiagnosticIconClass;
        vm.getElectricalSchemaClass = getElectricalSchemaClass;
        vm.getSpecialToolsClass = getSpecialToolsClass;
        vm.displayComponentData = displayComponentData;
        vm.displayComponentCodeAndLabel = displayComponentCodeAndLabel;
        vm.getvehicleMultimediaInformationClass = getvehicleMultimediaInformationClass;
        vm.findIfIsVehicleRlink2OrRlink1 = findIfIsVehicleRlink2OrRlink1;
        // {inactif : !searchArboTextualCtrl.borneo, activeButton: searchArboTextualCtrl.showDiagnosticView}
        vm.goToDiagnosis = goToDiagnosis;
        vm.checkTMListPattern = checkTMListPattern;
        vm.onOtsDialogClose = onOtsDialogClose;
        vm.redirectToOts = redirectToOts;
        vm.checkEmptyNodes = checkEmptyNodes;
        vm.clearSelectedDiagFile = clearSelectedDiagFile;
        vm.tokenBalance=UtilsMetierService.getTokenBalance();
        vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
        vm.isCirSentVin = carContext ? MainMetierService.isCirSentVin(carContext.vin):null;
        vm.getItemfromAutocomplete = getItemfromAutocomplete;
        vm.goToSearchEngineListePiece=goToSearchEngineListePiece;
        vm.goToSearchEngineCatalogPage=goToSearchEngineCatalogPage;
        vm.getSearchEngineDocs=getSearchEngineDocs;
        vm.goToSearchEngine = goToSearchEngine;
        vm.checkFieldsOfTires = checkFieldsOfTires;
        vm.checkInterventions = checkInterventions;
        vm.onCancel = onCancel;
        vm.checkNode2HorseUser = checkNode2HorseUser;
        vm.isInterventionAccess = UtilsMetierService.isInterventionAccess();
        var _errors = errorsConstant;
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.user.roles);
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        vm.isNissanConnectedServicesUser = MainMetierService.isNissanConnectedServices(vm.user.roles);
        vm.showNoContent = false;
        
        vm.doctypes = [];
        if (vm.isIndependentUser){
            if($rootScope.asomDocList.PR){ vm.doctypes.push('PR')}
            if($rootScope.asomDocList.TM){ vm.doctypes.push('TM')}
            if($rootScope.asomDocList.MR){ vm.doctypes.push('MR')}
            if($rootScope.asomDocList.MD){ vm.doctypes.push('MD')}
            if($rootScope.asomDocList.CS){ vm.doctypes.push('CS')}
        }
        vm.isIPNTester = false;
        var searchEngineDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        if(!vm.nissanUserURL && !searchEngineDetails){
        vm.newSearchFilter =  vm.contextCarBrandCheck ? ((filter && filter.id != 'ALL') ? filter : { id: "TM" }) : ((filter && filter.id != 'ALL') ? filter : { id: "PR" });
        }else if(vm.nissanUserURL && !searchEngineDetails){
            vm.newSearchFilter =  {id: "MR"}
        }
        else {
            vm.newSearchFilter = { id: searchEngineDetails.documentType } 
        }
        vm.isRnetUser = MainMetierService.isRnetUserType(vm.user.userType);
        $rootScope.$on("isRLinkHeader", function (event, value) {
            vm.isRLinkHeader = value;
        });
        init();

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        vm.appendCloudFrontParams = CloudFrontUrlHelper.appendCloudFrontParams;

        function init() {
            isComingFromDiagFileDetails = $state.params && $state.params.isFromDiagFileDetails;
            isTextSearchRedirect = $state.params && $state.params.isTextSearchRedirect;                        
            setFocus();
             var filteredSearchDetails = CacheService.getObject(CacheConstants.contextCarSearch);
                var interventionIdList = !_.isEmpty(interventionIdList) ? interventionIdList : CacheService.getObject(CacheConstants.interventionIdList);
             if(($rootScope.previousState === RoutesConstants.listePieceViews && interventionIdList && interventionIdList.isIntClick) ||
                ($rootScope.previousState === RoutesConstants.panier && interventionIdList && interventionIdList.isIntClick) ||
                  $rootScope.previousState === RoutesConstants.documentMR){
                
                var intNodeSelected = CacheService.getObject(CacheConstants.intNodeSelected);
                var selectedInterventionId = CacheService.getObject(CacheConstants.selectedInterventionId);

                if(interventionIdList && !interventionIdList.isIntTabClick && filteredSearchDetails && _.isEmpty(filteredSearchDetails.filteredTree)){
                    checkInterventions(interventionIdList.intLabel, interventionIdList.interventionIds, interventionIdList.intNodeId, interventionIdList.intNodeSelect);
                }
                else if((filteredSearchDetails && filteredSearchDetails.filteredTree && filteredSearchDetails.filteredTree.level1 && filteredSearchDetails.filteredTree.level1.nodes.length > 0 && filteredSearchDetails.filteredTree.level2 && filteredSearchDetails.filteredTree.level2.nodes.length > 0 && interventionIdList && !interventionIdList.isIntTabClick )){
                    if(selectedInterventionId && !filter){
                        checkInterventions(interventionIdList.intLabel, interventionIdList.interventionIds, interventionIdList.intNodeId, interventionIdList.intNodeSelect, true, true);
                    }
                    else{
                        checkInterventions(interventionIdList.intLabel, interventionIdList.interventionIds, interventionIdList.intNodeId, interventionIdList.intNodeSelect, false, false);
                    }
                }
            }else{
                CacheService.removeObject(CacheConstants.interventionIdList);
                CacheService.removeObject(CacheConstants.selectedInterventionId);
            }

            var identifierList = CacheService.getObject(CacheConstants.identifierList);
            vm.goToSearchResult = (filteredSearchDetails && !_.isEmpty(filteredSearchDetails.filteredTree) && identifierList && !_.isEmpty(identifierList)) ? true : false;
            vm.motCle=CacheService.getObject(CacheConstants.motCle);
            vm.redirectCarBrandCheck = MainMetierService.redirectCarBrandCheck(vm.contextCarBrandCheck);
            if($state.params.data && $state.params.data.redirectDiagnostic)
            {
                openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
            }
           vm.checkIndependentUser=vm.user ? MainMetierService.isIndependantUser( vm.user.roles): null;

           var subscriptionOnlyTab = getSubscriptionOnlyTab();
           if (vm.checkIndependentUser && subscriptionOnlyTab) {
               $state.go(RoutesConstants.carFeatures, {
                   tabName: subscriptionOnlyTab,
                   showSubscriptionAccessMessage: true
               });
               return;
           }
           
           // If coming from diagnostic file details, skip to diagnostic view without API calls
           if (isComingFromDiagFileDetails && !isTextSearchRedirect) {
               openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
               return;
           }      
           if(vm.checkIndependentUser&&vm.isAsomValidDocAccess==='false'&&vm.tokenBalance > 0)
           {
            openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);

           }
           if(vm.checkIndependentUser&&vm.isAsomValidDocAccess==='true'&&vm.tokenBalance > 0 && vm.doctypes.length == 0
                    && $rootScope.asomDocList.MD)
           {
            openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
           }
           else if(vm.checkIndependentUser&&vm.isAsomValidDocAccess==='true'&&vm.tokenBalance > 0 && vm.doctypes.length == 0
                    && !$rootScope.asomDocList.MD && $rootScope.asomDocList.WD)
           {
            openSelectedView(CarSearchResultConstants.searchTypes.consultElectricalShema);
           }
           else if(vm.checkIndependentUser&&vm.isAsomValidDocAccess==='true'&&vm.tokenBalance > 0 && vm.doctypes.length == 0
                    && !$rootScope.asomDocList.MD && !$rootScope.asomDocList.WD && $rootScope.asomDocList.ST)
           {
            openSelectedView(CarSearchResultConstants.searchTypes.searchBySpecializedTool);
           }
           else if(vm.checkIndependentUser&&vm.isAsomValidDocAccess==='true'&&vm.tokenBalance > 0 && vm.doctypes.length == 0
                    && !$rootScope.asomDocList.MD && !$rootScope.asomDocList.WD && !$rootScope.asomDocList.ST && $rootScope.asomDocList.AG)
           {
            $rootScope.$on('axleGeometry', function (event, data) {
                if (data) {
                    vm.axleGeometry = data;
                    openSelectedView(CarSearchResultConstants.searchTypes.axleGeometry);
                } else {
                    vm.showContent = false;
                return;
                }

            });

           }
           else if(vm.checkIndependentUser&& (vm.isAsomValidDocAccess==='true'|| vm.isAsomValidDocAccess === 'false') && vm.doctypes.length == 0
                    && !$rootScope.asomDocList.MD && !$rootScope.asomDocList.WD && !$rootScope.asomDocList.ST && !$rootScope.asomDocList.AG && !vm.isCirSentVin)
           {
            if(vm.tokenBalance === 0 ){
                vm.showContent = false;
            }
                return;
           }


            vm.searchCPCByClip = $state.params.id;
            vm.searchCSCByClip = $state.params.idOptional;
            vm.isUserComingFromClip = $state.params.isUserComingFromClip || $state.params.isUserComingFromMD ;
            vm.isFromWDUrlLink = $state.params.isFromWDUrlLink;
            vm.vinComingFromClip = $state.params.vinComingFromClip;
            vm.symptom = $state.params.symptomComingFromClip;
            vm.componentWithCPCAndCSC = [];
            vm.LC = $state.params.LC;
            $rootScope.isComponentPresentFromClip = false;
            vm.functionId = $state.params.functionId;
            vm.subFunctionId = $state.params.subFunctionId;
            vm.titleId = $state.params.titleId;
            var carContext = CacheService.getCarContext();
            vm.isCirSentVin = carContext ? MainMetierService.isCirSentVin(carContext.vin):null;
            if(!vm.isUserComingFromClip){
                searchElectricalSchemaMetierService.getComponentsAndSignalsData();
            }

            if (vm.isUserComingFromClip) {
                blockUI.start();
                var defer = $q.defer();
                $q.all([
                    searchElectricalSchemaMetierService.getApplicabilitiesTree(),
                    searchElectricalSchemaMetierService.getAndSaveCan_Doc(),
                    searchElectricalSchemaMetierService.getAndSaveComponents_Signals()
                ]).then(function (response) {

                    defer.resolve(response);

                    if (vm.searchCPCByClip && !vm.searchCSCByClip && !vm.LC && $state.params.WDT) {
                        if ($state.params.WDT === 'SCH' || $state.params.WDT === 'PC' || $state.params.WDT === 'NOM') {

                            vm.isComponentSelectedFromClip = true;
                            $rootScope.isComponentPresentFromClip = true;

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.searchCPCByClip
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCPCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                if ($state.params.isUserComingFromMD) {
                                    $window.history.back();
                                } else {
                                    $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                                }
                            }
                        }
                    } else if (vm.searchCPCByClip && vm.searchCSCByClip && !vm.LC && ($state.params.WDT === 'SCH' || $state.params.WDT === 'PC' || $state.params.WDT === 'NOM')) {

                        $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                            isUserComingFromClip: true,
                            LC: vm.LC,
                            WDT: $state.params.WDT,
                            id: vm.searchCPCByClip,
                            idOptional: vm.searchCSCByClip,
                            isDetailMainComponentRequired: true,
                            isSecondaryComponentPresent: true,
                            wiringDiagramsCache: vm.wiringDiagramsCache,
                            isFromWDUrlLink: true
                        });

                    } else if (vm.LC && _.isEmpty(vm.searchCPCByClip) && _.isEmpty(vm.searchCSCByClip) && $state.params.WDT) {
                        if ($state.params.WDT === 'SCH') {


                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.LC
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.LC,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                            }
                        }else if($state.params.WDT === 'PC' || $state.params.WDT === 'NOM'){
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                        }

                    } else if (vm.LC && vm.searchCPCByClip && _.isEmpty(vm.searchCSCByClip) && $state.params.WDT) {
                        if($state.params.WDT === 'PC' || $state.params.WDT === 'NOM'){

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.searchCPCByClip
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCPCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                            }
                        }
                        else if ($state.params.WDT === 'SCH') {

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.LC
                            });
                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.LC,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCPCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                        }

                    } else if (vm.LC && _.isEmpty(vm.searchCPCByClip) && vm.searchCSCByClip && $state.params.WDT) {
                        if($state.params.WDT === 'PC' || $state.params.WDT === 'NOM'){

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.searchCSCByClip
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCSCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false
                                });
                            }
                            else {
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                            }
                        }
                        else if ($state.params.WDT === 'SCH') {

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.LC
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.LC,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCSCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                        }

                    } else if (vm.LC && vm.searchCPCByClip && vm.searchCSCByClip && $state.params.WDT) {
                        if($state.params.WDT === 'PC' || $state.params.WDT === 'NOM'){

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.searchCPCByClip
                            });

                            var getComponent1 = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.searchCSCByClip
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCPCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else if (getComponent1[0] != undefined || getComponent1[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCSCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: false,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                                toastr.info($translate.instant('DOCUMENT_NOT_FOUND'));
                                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                            }
                        }
                        else if ($state.params.WDT === 'SCH') {

                            var getComponent = _.filter(CacheService.getComponentsAndSignals(), function (item) {
                                return item.id == vm.LC
                            });

                            if (getComponent[0] != undefined || getComponent[0] != null) {
                                // TBW
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.LC,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: true,
                                    isFromWDUrlLink: true
                                });
                            }
                            else {
                                $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                    isUserComingFromClip: true,
                                    LC: vm.LC,
                                    WDT: $state.params.WDT,
                                    id: vm.searchCPCByClip,
                                    idOptional: vm.searchCSCByClip,
                                    isDetailMainComponentRequired: true,
                                    isSecondaryComponentPresent: true,
                                    isFromWDUrlLink: true
                                });
                            }
                        }

                    }
                    else if (!_.isEmpty(vm.functionId) && _.isEmpty(vm.subFunctionId) && _.isEmpty(vm.titleId)){
                        var data = {
                            nodeOneID : vm.functionId
                        }
                        $rootScope.nodeId = data;
                    }
                    else if (!_.isEmpty(vm.functionId) && !_.isEmpty(vm.subFunctionId) && _.isEmpty(vm.titleId)){
                        var data = {
                            nodeOneID : vm.functionId,
                            nodeTwoID : vm.subFunctionId
                        }
                        $rootScope.nodeId = data;
                    }
                    else if (!_.isEmpty(vm.functionId) && !_.isEmpty(vm.subFunctionId) && !_.isEmpty(vm.titleId)){
                        var data = {
                            nodeOneID : vm.functionId,
                            nodeTwoID : vm.subFunctionId,
                            nodeThreeID : vm.titleId
                        }
                        $rootScope.nodeId = data;
                    }
                    else if (_.isEmpty(vm.functionId) && _.isEmpty(vm.subFunctionId) && !_.isEmpty(vm.titleId)){
                        var data = {
                            nodeThreeID : vm.titleId
                        }
                        $rootScope.nodeId = data;
                    }


                }, function (error) {
                    defer.reject(error);
                }
                );
            }

            if ($state && $state.params && $state.params.data) {
                vm.traficDiag = $state.params.data.traficDiag;
                vm.traficDiagSymp = $state.params.data.traficDiagSymp;
                vm.traficVdh = $state.params.data.traficVdh;
            }
            if (vm.traficDiag) {
                vm.showDiagnosticView = CacheService.getObject(CacheConstants.showDiagnosticView);
            } else if (vm.traficDiagSymp) {
                var carContext = CacheService.getCarContext();
                vm.isIndependantUser =  vm.user ? MainMetierService.isIndependantUser( vm.user.roles): null;
                    vm.typeMD = (carContext && carContext.typeMD && (carContext.typeMD.includes('B3')) && (carContext.typeMD.includes('B2')) && (carContext.typeMD.includes('B2-3')));
                vm.isSearchByModel = MainMetierService.isSearchByModel();
                vm.traficDiag = false;
                vm.showArboView = false;
                vm.showDiagnosticView = true;
                vm.showSpecializedToolView = false;
                vm.showDiagFilesView = false;
            } else if(vm.traficVdh){
                var userProfil = CacheService.getUserProfile();
                var carContext = CacheService.getCarContext();
                vm.isIndependantUser = MainMetierService.isIndependantUser(userProfil.roles);
                    vm.typeMD = (carContext && carContext.typeMD &&  (carContext.typeMD.includes('B3')) && (carContext.typeMD.includes('B2')) && (carContext.typeMD.includes('B2-3')));
                vm.isSearchByModel = MainMetierService.isSearchByModel();
                vm.showDiagFilesView = true;
                vm.traficDiag = false;
                vm.showArboView = false;
                vm.showDiagnosticView = false;
                vm.showSpecializedToolView = false;
            }
            var clipParameters = MainMetierService.getClipParameters();
            var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
            var elementRef = '';
            var operationCode = '';

            if($state.params.isnodeLinkNavigation){ 
               CacheService.setObject(CacheConstants.backButtonEnable, true);
                vm.filterChoosen = { id: "MR" };
                vm.changeFilter(vm.filterChoosen);
                vm.newSearchFilter = { id: "MR" };
                vm.isClipRedirectionForNodes = true;
                node_1 = $state.params.node1 ? $state.params.node1 : '';
                node_2 = $state.params.node2 ? $state.params.node2 : '';
                node_3 = $state.params.node3 ? $state.params.node3 : '';
            }

            if($state.params.maintenanceProgLinkNavigate){ 
                node_1 = $state.params.node1 ? $state.params.node1 : '';
                node_2 = $state.params.node2 ? $state.params.node2 : '';
                node_3 = $state.params.node3 ? $state.params.node3 : '';
            }

            if (!_.isEmpty(clipParameters)) {
                elementRef = clipParameters.clipRdcElementRef;
                operationCode = clipParameters.clipRdcOperationRef;
                node_1 = clipParameters.NODE_1 ? clipParameters.NODE_1 : '';
                node_2 = clipParameters.NODE_2 ? clipParameters.NODE_2 : '';
                node_3 = clipParameters.NODE_3 ? clipParameters.NODE_3 : '';
            } else if (!_.isEmpty(commonParameters)) {
                elementRef = commonParameters.elementRef;
                operationCode = commonParameters.operationRef;
            }

            $rootScope.previousState = RoutesConstants.carSearchResult;
            $rootScope.currentState = RoutesConstants.carSearchResult;

            vm.selectedLevel1;
            vm.scrolled = false;

            vm.borneo = typeMD === 'B3' || typeMD === 'B2' || typeMD === 'B2-3' ? true : false;

            //show exploded view
            vm.svg = null;
            vm.showExplodedView = false;
            vm.showExplodedButton = true;

            //shows or hide the level2 navigation tree
            vm.showSearchNav = false;
            vm.showSearchRef = false;
            vm.dataArboLevelOne = {};

            vm.showCodeDefault = false;
            vm.showCodeDtc = false;
            vm.isFunctionalityDevOnly = configConstantes.isFunctionalityDevOnly;


            if ($state.params.data) {
                vm.hasToScroll = true;
            }
            if (elementRef || operationCode) {
                initializeScroll();
                getNodesFirstLevelForClipRedirection(0, elementRef, operationCode);
                //elementRef = operationCode = ''; no work around for now

            }else if(isTextSearchRedirect){
                initializeScroll();
                getNodesFirstLevelForClipRedirection(0, null, null);
            } else if ($state.params.tab === CarSearchResultConstants.searchTypes.consultElectricalShema) {
                //
                ClipService.removeParameters(ClipConstants.clipCookieName);
                vm.electricalSchemaNodesId = $state.params.data;
                openSelectedView(CarSearchResultConstants.searchTypes.consultElectricalShema);
            } else if ($state.params.tab === CarSearchResultConstants.searchTypes.searchByDiagnostic) {
                //
                if(vm.isUserComingFromClip && $state.params.data)
                    vm.diagFileId = $state.params.data;
                openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
            } else if ($state.params.data && $state.params.data.arbo) {
                vm.dataArboLevelOne.nodes = $state.params.data.arbo;
                vm.level2 = vm.dataArboLevelOne.nodes[0].level2;
                vm.showSearchRef = true;
                vm.showContent = true;
                vm.motCle = $state.params.data.keyWord;
                vm.selectedLevel1 = $state.params.data.node1;
                vm.showExplodedButton = false;

                if ($state.params.data && $state.params.data.node1) {
                    vm.nodeSelect = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                        return node.nodeId === $state.params.data.node1.nodeId;
                    });
                } else {
                    vm.nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                    vm.nodeSelect = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                        return node.nodeId === vm.nodeSelect.nodeId;
                    });
                }
                angular.element(document).ready(function () {
                    scrollToNode($state.params.data.node);
                });
            } else if(!_.isEmpty(node_1)){
                vm.isClipRedirectionForNodes = true;
                openSelectedView(CarSearchResultConstants.searchTypes.searchByArbo);
            }
            else {
                if(vm.isMitsubishiUser || vm.isPpxLightUser){
                    vm.showNoContent = true;
                }
               else if(vm.isHorseUser){
                    (interventionIdList && intNodeSelected) ? getNodesFirstLevelAndShowFirstNode(interventionIdList.intNodeSelect) : getNodesFirstLevelAndShowFirstNode(1);
                } 
                else if(interventionIdList && intNodeSelected){
                    getNodesFirstLevelAndShowFirstNode(interventionIdList.intNodeSelect);
                }
                else {
                    getNodesFirstLevelAndShowFirstNode(0); 
                }
                initializeScroll();
            }

            $scope.$on('phx-scrollTop', function () {
                vm.scrolled = false;
            });

            // When is usefull to do this ??
            // $scope.$watch(vm.level2, function () {
            //
            //     vm.targetNode = undefined;
            // });

            $scope.containsDocuments = function (item) {
                if (item.node.documents) {
                    return true;
                }
                return false;
            };

            AlertsLocationService.buildAlerts({
                location: '',
                identification: '',
                typeOfElement: $translate.instant('LOCATION_ARBO'),
                reference: '',
                label: ''
            }, 'ARBO');

            translate();

            if ($state.params.docTypeSelected) {
                vm.filterChoosen = { id: "TM_LIST" };
                vm.changeFilter(vm.filterChoosen);
                vm.motCle = $state.params.docTypeSelected;
            }

            $rootScope.$on('axleGeometry', function (event, data) {
                if (data) {
                    vm.axleGeometry = data;
                }

            });

            findIfIsVehicleRlink2OrRlink1();

            if(!vm.isRLink2Vehicle && !vm.isRLink1Vehicle) {
                $rootScope.$emit('isRLink2Vehicle', vm.isRLink2Vehicle);
            }
            if((vm.isRLink2Vehicle || vm.isRLink1Vehicle) && vm.isPpxLightUser){
                openSelectedView(CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation);

            }


            // if we come back from diagnosis page we display rlink view
            if (CacheService.getObject(CacheConstants.fromDiagnosis)) {
                CacheService.removeObject(CacheConstants.fromDiagnosis);
                openSelectedView(CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation);
            }
            $rootScope.$on('assistTool', function (event, data) {
                if (data) {

                    if(vm.showNoContent && (vm.isRLink1Vehicle || vm.isRLink2Vehicle || data.isEasyLinkVehicle) && !data.isUnknownVehicle && !vm.checkIndependentUser 
                    ){
                        openSelectedView(CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation);
                    }                 
                } 
            });           


        }

        function setFocus() {
            $timeout(function () {
                var autoCompleteInput = document.querySelector('md-autocomplete input');
                if (autoCompleteInput) {
                    autoCompleteInput.focus();
                } else {
                    var inputBox = document.getElementById('newSearchMotCle');
                    var secondaryInputBox = document.getElementById('motCleInde');
                    if (inputBox) {
                        var mainInputBox = angular.element(inputBox);
                        mainInputBox[0].focus();
                    } else if (secondaryInputBox) {
                        var secondaryInputElement = angular.element(secondaryInputBox);
                        secondaryInputElement[0].focus();
                    }
                }
            }, 0);
        }

        function getSubscriptionOnlyTab() {
            var subscriptionRights = $rootScope.asomDocList || {};
            var subscriptionTabs = [
                { right: 'REF-BVM', tab: 'technicalCriteriaTab' },
                { right: 'OTS', tab: 'otsTab' },
                { right: 'REP', tab: 'maintenanceProgramTab' },
                { right: 'HM', tab: 'vehicleMaintenanceHistoryTab' }
            ];
            var hasOtherActiveSubscription = _.some(subscriptionRights, function (isActive, right) {
                return isActive && !_.some(subscriptionTabs, { right: right });
            });

            if (hasOtherActiveSubscription) {
                return null;
            }

            var accessibleTab = _.find(subscriptionTabs, function (subscriptionTab) {
                return subscriptionRights[subscriptionTab.right];
            });
            return accessibleTab ? accessibleTab.tab : null;
        }
        

        function showOtsDialog(response) {
            var body = angular.element(document.body);

            $mdDialog.show({
                parent: body,
                templateUrl: 'app/components/car/searchArboTextual/showOtsDesignation.template.html',
                controller: 'SearchArboTextualCtrl',
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    otsData: response
                }
            });
        }

        function getArboIconClass() {
            var diagnosticIconClass = '';
            if (!vm.nissanUserURL ){
                if(vm.showArboView) {
                diagnosticIconClass = 'renaultActiveButton renault_search_arbo';
            }else{
                diagnosticIconClass = 'search_arbo_black';
            }
        }
            else if(vm.nissanUserURL){
                if(vm.showArboView){
                diagnosticIconClass = 'nissanActiveButton search_arbo_black';
                }else{
                diagnosticIconClass = 'search_arbo_black';
            }
            }
            return diagnosticIconClass;
        }


        /**
        * @desc function called by ng-class in HTML in order to activate the electrical Schema button
        */
        function getElectricalSchemaClass() {
            var ElectricalSchemaClass = '';
            if (!vm.nissanUserURL && vm.showconsultElectricalShema) {
                ElectricalSchemaClass = 'renaultActiveButton';
            }else if(vm.nissanUserURL && vm.showconsultElectricalShema){
                ElectricalSchemaClass = 'nissanActiveButton';
            }
            return ElectricalSchemaClass;
        }

        function getSpecialToolsClass(){
            var specialToolsClass = '';
            if (!vm.nissanUserURL && vm.showSpecializedToolView) {
                specialToolsClass = 'renaultActiveButton';
            }else if(vm.nissanUserURL && vm.showSpecializedToolView){
                specialToolsClass = 'nissanActiveButton';
            }
            return specialToolsClass;
        }

        function getDiagnosticIconClass() {
            // vm.showContent = !vm.showContent;
            // {inactif : !searchArboTextualCtrl.borneo, activeButton: searchArboTextualCtrl.showDiagnosticView}
            var diagnosticIconClass = '';
            if (!vm.borneo && typeMD !== 'ADT') {
                diagnosticIconClass = 'inactif';
            }
            else if (!vm.nissanUserURL && vm.showDiagnosticView) {
                diagnosticIconClass = 'renaultActiveButton';
            }
            else if (vm.nissanUserURL && vm.showDiagnosticView) {
                diagnosticIconClass = 'nissanActiveButton';
            }
            return diagnosticIconClass;
        }

        /**
        * @desc function called by ng-class in HTML in order to activate the vehicle assistance button
        */
        function getvehicleMultimediaInformationClass() {
            var vehicleMultimediaInformationClass = '';
            
            if (!vm.nissanUserURL && vm.showVehicleMultimediaInformation) {
                vehicleMultimediaInformationClass = 'renaultActiveButton icon-car_assistance_tool_renaultColor';
            }else if(vm.nissanUserURL && vm.showVehicleMultimediaInformation) {
                vehicleMultimediaInformationClass = 'nissanActiveButton icon-car_assistance_tool';
            } else {
                vehicleMultimediaInformationClass = 'icon-car_assistance_tool';
            }
            return vehicleMultimediaInformationClass;
        }

        function onKeyPressed(event) {
            $timeout(function () {
                if (event.charCode == 13 && vm.motCle && vm.motCle != "") {
                    searchNodebyRef(true);
                }
            }, 100);
        }

        //Last viewed documents
        function consultLastDocument() {
            blockUI.start();
            SearchArboTextualMetierService.getLastViewedDocuments().then(function (response) {
                if (response.errorCode) { // if error
                    toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                    blockUI.stop();
                } else {
                    $modal.open({
                        templateUrl: 'app/components/transverse/modalDocument/consult_doc.html',
                        controller: 'ConsultDocCtrl',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowClass: 'modalDocumentsViewRef',
                        resolve: {
                            modalOpts: function () {
                                return {
                                    docs: response.documents
                                };
                            }
                        }
                    });
                    blockUI.stop();
                }
            });
        }

        function divSelected(key) {
            var elemSelected = document.getElementById(key);
            var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
            var topContainer;
            positionOfElem + 15 + "px";
            if (positionOfElem < 200) {
                topContainer = positionOfElem + 25 + "px";
            } else {
                topContainer = positionOfElem + 10 + "px";
            }
            setTimeout(function () {
                $(".my-container").css({ 'top': topContainer });
            }, 50);
        }

        function consultElectricalShema() {
            blockUI.start();
            SearchArboTextualMetierService.getDocumentsElectricals().then(function (response) {
                blockUI.stop();
                if (response && response.errorCode) { // if error
                    toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                } else { // if success
                    if (response && response.electrics) {
                        if (response.electrics.length == 0) {
                            $translate('ELECTRICAL_ERROR_EMPTY').then(function (text) {
                                toastr.info(text, { timeOut: 1500 });
                            });

                        } else {
                            $modal.open({
                                templateUrl: 'app/components/transverse/modalElectrical/electrical_shema.html',
                                controller: 'ElectricalShemaCtrl',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                windowClass: 'modalCircuitPlan',
                                resolve: {
                                    modalOpts: function () {
                                        return {
                                            electrics: response.electrics
                                        };
                                    }
                                }
                            });
                        }
                    }
                }
            });

        }

        function VarAppBeforeGoToListePiece(nodeTwo, nodeThree, selectedNode) {
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removeProductResposne();
            DocPrivMetierService.removeInterventionResposne();
            DocPrivMetierService.removePrResponse();

            if (selectedNode && selectedNode.documents) {

                if(selectedNode.nodeId === CarSearchResultConstants.nodeIdTires){


                    var data = {
                        node1: vm.selectedLevel1 ? vm.selectedLevel1 : vm.dataArboLevelOne.nodes[0],
                        node2: nodeTwo,
                        node3: nodeThree,
                        selectedNode: selectedNode,
                        arbo: vm.showSearchRef ? vm.dataArboLevelOne.nodes : undefined,
                        tyresInfo : vm.tyresInfo
                    };

                    SearchArboTextualMetierService.saveNodeInCache(selectedNode);

                    $state.go(RoutesConstants.listePieceViews, {
                        data: data,
                        documentType: 'tires'
                    });
                }else{

                    /**
                     *  Temporary fix, documentsMenuController need to access idsDocumentsByType || documentsByType,
                     *  but it can be null...
                     */
                    selectedNode.documentsByType = selectedNode.idsDocumentsByType || {
                        BT: [],
                        MD: {},
                        MR: [],
                        NI: [],
                        TM: [],
                        PRODUCTS: [],
                        PR: [],
                        TM_BY_TYPE: {}
                    };
                    SearchArboTextualMetierService.saveNodeInCache(selectedNode);

                    goToListePiece(vm.selectedLevel1, nodeTwo, nodeThree, selectedNode);
                }
            } else if(vm.isClipRedirectionForNodes) {
                toastr.info($translate.instant("DOCUMENT_NOT_FOUND"));
            }

        }

        function goToQuestionnig() {
            $state.go(RoutesConstants.questionning);
        }

        /*
        *   This function return a closure which can display node two and three and display the exploded view
        *   nodeSVG save the current index
        *   and we check if the user has clicked on the same node, if yes, hide explode view
        */
        function goToLevelTwoAndThreeAndShowImage(isFromIntNode, nodeIndex) {
            var nodeSVG;
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            return function (node, index) {
                if (!vm.showSearchRef) {
                    goToLevelTwoAndThree(node);
                    vm.showExplodedView = (nodeSVG === index) ? !vm.showExplodedView : true;
                    vm.firstSelect = false;
                    vm.nodeSelect = index;
                    if(!isFromIntNode && vm.dataArboLevelOne && !_.isEmpty(vm.dataArboLevelOne.nodes)){
                        AlertsLocationService.buildAlerts({ location: getNodeName(index), label: getNodeName(index) }, 'ARBO');
                    }
                    else{
                        AlertsLocationService.buildAlerts({ location: getNodeName(isFromIntNode.label, true), label: getNodeName(isFromIntNode.label, true) }, 'ARBO');
                    }
                }
                else if (vm.isArboFiltered) {
                    goToFilteredLevel1(index);
                }
                else if (contextCarSearch && contextCarSearch.filteredTree && !_.isEmpty(contextCarSearch.filteredTree)) {
                    vm.dataArboLevelOne = contextCarSearch.filteredTree.level1;
                    goToFilteredLevel1(index);
                }

                setSVG(node.urlExplodedView);
                nodeSVG = index;
                vm.nodeSelect = index;
            }
        }

        function goToLevelTwoAndThreeWithoutShowImage(node) {
            if (!vm.showSearchRef) {
                goToLevelTwoAndThree(node);
            }
            vm.showExplodedView = false;
        }

        function goToLevelTwoAndThreeWithoutShowImageFirst(node, index, isFromIntNode) {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            if(!isFromIntNode && node){
                CacheService.setObject(CacheConstants.intNodeSelected, node);
            }

            if (vm.isArboFiltered) {
                goToFilteredLevel1(index);
            }
            else if (contextCarSearch && contextCarSearch.filteredTree && !_.isEmpty(contextCarSearch.filteredTree)) {
                vm.dataArboLevelOne = contextCarSearch.filteredTree.level1;
                goToFilteredLevel1(index);
            }
            else if (!vm.showSearchRef) {
                vm.showExplodedView = false;
                vm.firstSelect = false;
                vm.nodeSelect = index;
                if(!isFromIntNode && vm.dataArboLevelOne && !_.isEmpty(vm.dataArboLevelOne.nodes)){
                    AlertsLocationService.buildAlerts({ location: getNodeName(index), label: getNodeName(index) }, 'ARBO');
                }
                else if(node){
                    AlertsLocationService.buildAlerts({ location: getNodeName(node.label, true), label: getNodeName(node.label, true) }, 'ARBO');
                }
                goToLevelTwoAndThree(node);
            }
            else {
                vm.firstSelect = false;
                vm.nodeSelect = index;
                vm.selectedLevel1 = node;
                vm.level2 = node.level2;
            }
            vm.nodeSelect = index;
            vm.svg = null;
        }

        function goToFilteredLevel1(index) {

            var filterLevel1 = searchByTextsIdsMertierService.getFilteredLevel1();
            var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
            var nodeIndex = 0;
            goToLevelTwoAndThree(filterLevel1.nodes[index]);
            var docsByType = searchByTextsIdsMertierService.getFilterdDocs();
            if(carContext && carContext.filteredTree){
                docsByType[vm.filterChoosen.id] = _.filter(docsByType[vm.filterChoosen.id], function(item){
                    return item == carContext.filteredTree.selectedId
                })
            }
            vm.level2 = searchByTextsIdsMertierService.filterArboLevel2(vm.level2, docsByType.PR,
                docsByType.MR, docsByType.MD, docsByType.TM);

            if ($state.params.data && !_.isEmpty($state.params.data)) {
                if ($state.params.data.node1) {
                    nodeIndex = _.findIndex(filterLevel1.nodes, function (node) {
                        return node.nodeId === $state.params.data.node1.nodeId;
                    });
                }
                else {
                    var nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                    nodeIndex = _.findIndex(filterLevel1.nodes, function (node) {
                        return node.nodeId === nodeSelect.nodeId;
                    });
                }

                goToLevelTwoAndThree(filterLevel1.nodes[nodeIndex]);
                vm.level2 = searchByTextsIdsMertierService.filterArboLevel2(vm.level2, docsByType.PR,
                    docsByType.MR, docsByType.MD, docsByType.TM);

                vm.targetNode = $state.params.data.node;

                $state.params.data = {};
            }

            vm.nodeSelect = nodeIndex;
        }

        function showExplodedViewFunction() {
            vm.showExplodedView = !vm.showExplodedView;
            if (vm.showExplodedView) {
                setSVG(vm.selectedLevel1.urlExplodedView);
            }
            if (vm.showExplodedView) {
                $('html, body').animate({ scrollTop: $('#line_resultat_level2_and_3').offset().top }, 300);
            }
        }
        function checkEmptyNodes(node) {
            var checkempty = node === undefined ? false : !_.isEmpty(node) ? true : false;
            return checkempty;
        }

        function goToListePiece(node1, node2, node3, selectedNode) {
            SearchArboTextualMetierService.saveNodeInCache(selectedNode);
            if(vm.isNewSearchBar){
                CacheService.setObject(CacheConstants.isSearchEngine,false);
                //CacheService.removeObject(CacheConstants.motCle);
            }
            var docids;
            if (checkEmptyNodes(selectedNode.idDocuments)) {
                docids = selectedNode.idDocuments;
            }
            docids = _.uniq(docids);
            var data = {
                node1: node1 ? node1 : vm.dataArboLevelOne.nodes[0],
                node2: node2,
                node3: node3,
                selectedNode: selectedNode,
                arbo: vm.showSearchRef ? vm.dataArboLevelOne.nodes : undefined,
                keyWord: vm.showSearchRef ? vm.motCle : undefined,
                hash: 'listePiece',
                transversaldocIds: docids
            };
            CacheService.setObject(CacheConstants.transeversalPartsIds, docids)

            var documentType = null;
            if (!vm.isNewSearchBar && vm.filterChoosen && vm.filterChoosen.id != "ALL") {
                CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
                if (vm.filterChoosen.id === "TM_LIST") {
                    documentType = "TM";
                } else {
                    documentType = vm.filterChoosen.id.toUpperCase();
                }

            }

            else if(!vm.isNewSearchBar && vm.filterChoosen && vm.filterChoosen.id == "ALL"){
                CacheService.setObject(CacheConstants.filter, vm.filterChoosen);
            }
            else if (vm.isNewSearchBar && vm.newSearchFilter) {
                CacheService.setObject(CacheConstants.filter, vm.newSearchFilter);
                if (vm.newSearchFilter.id === "TM_LIST") {
                    documentType = "TM";
                } else {
                    documentType = vm.newSearchFilter.id.toUpperCase();
                }
            }
            var searchEngineDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
            CacheService.removeObject(CacheConstants.interventionIdList);
            CacheService.removeObject(CacheConstants.selectedInterventionId);
            $state.go(RoutesConstants.listePieceViews, {
                data: data,
                documentType: documentType,
                plateIndex: 0,
                refIndex: 0,
                selectedReference : (searchEngineDetails && searchEngineDetails.reference) ? searchEngineDetails.reference : null
            });

        }


        function scrollToTop() {
            ScrollService.animateTo('#line_resultat_level2_and_3', 300);
            vm.scrollToTopButtonClass = 'scrollToTopButtonHidden';
        }

        function selectDefaultCodeFromDropdown(val) {
            vm.defaultCode.defaultCode = val;
            vm.diagnosticDefaultCodeDropDownOpenClose = 'diagnosticDropDownClose';
        }

        function selectDTCCodeFromDropdown(val) {
            vm.dtcCode.dtcCode = val;
            vm.diagnosticDTCCodeDropDownOpenClose = 'diagnosticDropDownClose';
        }

        function selectSymptomCodeFromDropdown(val) {
            vm.symptom.symptom = val;
            vm.diagnosticSymptomCodeDropDownOpenClose = 'diagnosticDropDownClose';
        }

        function switchState(indexInput, isFocused) {
            reinitFields(indexInput, isFocused);
            changeStyleFields(indexInput, isFocused);
        }

        function searchOnPressEnter(keyEvent) {
            if (keyEvent.which === 13) {
                searchNodebyRef();
            }
        }

        //TODO Test spec
        function changeFilter(filter) {
            vm.selectedFilter = filter;
            if(vm.nissanUserURL && _.isEmpty(vm.filterTypes)){
                vm.filterTypes = [{ "id":"MR", "label": "MR"},{ "id":"MD", "label": "MD"}];
                return;
            }
            if(!vm.nissanUserURL) {
                if (vm.isNewSearchBar){
                    if(!_.isEmpty(vm.initialFitlters)){
                        vm.filterTypes = vm.initialFitlters.filter(function(item) {
                            return item.id !== 'CS'; 
                        });
                    }
                    CacheService.setObject(CacheConstants.filter, vm.newSearchFilter);
                    vm.onChangeMotCle();
                }
                else{
                    if(!_.isEmpty(vm.initialFitlters)){
                        vm.filterTypes = _.filter(vm.initialFitlters, function (n) {
                            return n.id !== filter.id && filter.id !== 'CS';
                        });
                    }
                }
            }
        }

        function searchNodebyRef(issearchBtnClick) {
            if (issearchBtnClick) {
                isSearchClicked = true;
            } else {
                isSearchClicked = false;
            }
            if ((!vm.isNewSearchBar && vm.filterChoosen && vm.filterChoosen.id === "TM_LIST") || (vm.isNewSearchBar && vm.newSearchFilter && vm.newSearchFilter.id === "TM_LIST")) {
                if (vm.motCle && vm.motCle.length <= 98) {
                    if (vm.checkTMListPattern()) {
                        CacheService.setNodeSearchTmList(vm.motCle);

                        $state.go(RoutesConstants.listePieceTMView, {
                            searchText: vm.motCle.toUpperCase()
                        });
                    }
                    else {
                        toastr.error($translate.instant('CAR_SEARCH_EXAMPLE_OF_TM_LIST'));
                    }
                }
                else {
                    toastr.error($translate.instant('TM_LIST_SEARCH_ERROR'));
                }
            }
            else {
                if (vm.motCle && vm.motCle != "") {
                    if (vm.isNewSearchBar && vm.motCle.length >= 3 && vm.newSearchFilter.id !== "TM_LIST"){
                        var regExp = /^([A-Za-z0-9]{3,5})\/([0-9]{6}|[0-9]{8})$/;
                        var searchedIds = vm.motCle.split(" ").join("");
                        if(vm.newSearchFilter.id === "PR" && regExp.test(searchedIds)){

                            CacheService.setObject(CacheConstants.isSearchEngine,true);
                            //CacheService.setObject(CacheConstants.searchEngineIds, vm.searchEngineIds);
                            CacheService.setObject(CacheConstants.motCle, vm.motCle);
                            CacheService.setObject(CacheConstants.filter, vm.newSearchFilter);
                            var arr = [];
                            var obj = {};
                            arr.push({'id':searchedIds.split('/').join('_').toUpperCase()});
                            obj = {'catalogPlates':arr};
                            DocPrivMetierService.removeBorneo3Resposne();
                            DocPrivMetierService.removeSearchEngineMd();
                            DocPrivMetierService.removeRepairManuals();
                            DocPrivMetierService.removeLabourTimes();
                            DocPrivMetierService.removePrResponse(); 
                            DocumentsMetierService.filterSelectedIds(obj, 'PR',true,null,isComingFromDiagFileDetails,isTextSearchRedirect);

                        }else{
                            vm.showAutocomplete = false;
                            vm.newTextSearch=true;
                            goToSearchEngineCatalogPage(false, null);
                            var carSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                            carSearch.filteredTree = null;
                            CacheService.setObject(CacheConstants.contextCarSearch, carSearch);
                        }
                    }
                    else{
                        getFilteredTree(0,null);

                    }
                  }
            }
        }

        function getFilteredTree(index,element) {

            var formattedFilteredDocuments = [];
            var filteredDocumentsByType = [];
            var tempLevel2 = vm.level2;
            vm.level2 = [];
            var tempMotCle = vm.motCle;


            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var resultDocumentsArbo = [];

            if (contextCarSearch && contextCarSearch.allDocsArbo && !_.isEmpty(contextCarSearch.allDocsArbo.documents)) {
                contextCarSearch.filteredTree = {};
                CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
                vm.motCle = undefined;
                vm.showSearchRef = false;
                vm.isArboFiltered = false;
                if(contextCarSearch.treeNodes){
                    vm.dataArboLevelOne = contextCarSearch.treeNodes.levelOne;
                    vm.level2 = contextCarSearch.treeNodes.otherLevel;
                }
                resultDocumentsArbo = contextCarSearch.allDocsArbo;

                if(vm.isHorseUser){
                    getNodesFirstLevelAndShowFirstNode(1);
                    goToLevelTwoAndThree(vm.dataArboLevelOne.nodes[1]);
                }else{
                    getNodesFirstLevelAndShowFirstNode(0);
                    goToLevelTwoAndThree(vm.dataArboLevelOne.nodes[0]);
                }                

                vm.motCle = tempMotCle;
                tempLevel2 = vm.level2;
            }
            else if (contextCarSearch && contextCarSearch.treeNodes && contextCarSearch.treeNodes.otherLevel && contextCarSearch.treeNodes.otherLevel.nodes && contextCarSearch.treeNodes.otherLevel.nodes.length > 0) {
                resultDocumentsArbo = searchByTextsIdsMertierService.getDocumentsArbo(contextCarSearch.treeNodes.otherLevel.nodes);
                var resultDocumentsArboMR = angular.copy(resultDocumentsArbo);
                var resultDocumentsArboMD = angular.copy(resultDocumentsArbo);
                if (vm.isCountryKorea) {
                    resultDocumentsArboMR.documents = filterDocumentsArboByType(resultDocumentsArbo.documents, 'MR');
                    resultDocumentsArboMD.documents = filterDocumentsArboByType(resultDocumentsArbo.documents, 'MD');
                    resultDocumentsArbo.documents = _.union(resultDocumentsArboMR.documents, resultDocumentsArboMD.documents);
                }
                contextCarSearch.allDocsArbo = resultDocumentsArbo;
                CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
            }

            if (vm.filterChoosen && vm.filterChoosen.id != "ALL") {
                if (contextCarSearch && contextCarSearch.treeNodes && contextCarSearch.treeNodes.otherLevel)
                    resultDocumentsArbo = searchByTextsIdsMertierService.getDocumentsArbo(contextCarSearch.treeNodes.otherLevel.nodes);
                resultDocumentsArbo.documents = filterDocumentsArboByType(resultDocumentsArbo.documents, vm.filterChoosen.id);
            }


            blockUI.start();
            if(isTextSearchRedirect){
                goToSearchEngineCatalogPage(false,element);
            } else {
                goToSearchEngineCatalogPage(true,element);
            }            
        }

        function filterDocumentsArboByType(resultDocumentsArbo, type) {
            var FilteredListDocumentsByType = [];

            if(resultDocumentsArbo && resultDocumentsArbo.length >0){
                angular.forEach(resultDocumentsArbo, function (value) {
                    if (value.documentType === type) {
                        FilteredListDocumentsByType.push(value);
                    }
                });
            }
            return FilteredListDocumentsByType;
        }

        $rootScope.$on('isAlertsClicked',function (event, data) {
            openSelectedView(data.tab);
            $state.params.redirectToAlerts = data.redirectToAlerts;
            if(vm.showDiagnosticView){
                $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic, data: true });
            }
        });
        $rootScope.$on('isFromDiagFileDetails',function (event, data) {
            $state.params.isFromDiagFileDetails = data.isFromDiagFileDetails;
            
            if(vm.showDiagnosticView){
                $state.go(RoutesConstants.carSearchResult, { 
                    tab: CarSearchResultConstants.searchTypes.searchByDiagnostic, 
                    data: true,
                    selectedDiagFileId: data.selectedDiagFileId,
                    isFromDiagFileDetails: data.isFromDiagFileDetails,
                    systemDocSubMenu: data.systemDocSubMenu,
                    systemDocResponse: data.systemDocResponse
                });
            }
        });

        /**
         * @desc set to true or false variable binded in html
         * @param {*String} searchTypes provide in HTML in order to switch to the case
         */
        function openSelectedView(searchTypes, isDiag, isUserClick) {
            if(searchTypes){
                $state.params.redirectToAlerts = false;
                switch (searchTypes) {
                    case CarSearchResultConstants.searchTypes.searchByDiagFiles:
                        vm.showDiagnosticView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showSpecializedToolView = false;
                        vm.showconsultElectricalShema = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showArboView = false;
                        vm.showDiagFilesView = false;
                        $state.go(RoutesConstants.diagFilesByVin, { vin: contextVehicle.vehicle.vin });
                        break;
                    case CarSearchResultConstants.searchTypes.searchByArbo:
                        SearchArboTextualMetierService.setConnectedServicesAuditData('Back to the tree structure').then(function () {});
                        vm.showDiagnosticView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showSpecializedToolView = false;
                        vm.showconsultElectricalShema = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showDiagFilesView = false;
                        vm.showArboView = true;
                        if(_.isEmpty(vm.initialFitlters)){
                            translate();
                        }
                        clearSelectedDiagFile();
                        break;
                    case CarSearchResultConstants.searchTypes.searchByDiagnostic:
                        if(isDiag){
                            $state.params.data = false;
                        }
                        vm.showArboView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showSpecializedToolView = false;
                        vm.showconsultElectricalShema = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showDiagFilesView = false;
                        vm.showDiagnosticView = true;
                        var userProfil = CacheService.getUserProfile();
                        var carContext = CacheService.getCarContext();
                        vm.isIndependantUser = MainMetierService.isIndependantUser(userProfil.roles);
                            vm.typeMD = (carContext && carContext.typeMD && (carContext.typeMD.includes('B3')) && (carContext.typeMD.includes('B2')) && (carContext.typeMD.includes('B2-3')));
                        vm.isSearchByModel = MainMetierService.isSearchByModel();
                        vm.diagSearch= {"system":{"active":false,"icon":false},
                        "solution":{"active":true,"icon":true},
                        "history":{"active":false,"icon":false}
                    }
                        /* if(vm.isUserComingFromClip && $state.params.data && vm.user){
                            var preferredLanguage = vm.user.documentationFirstLanguage.code;
                            var defaultLanguage = vm.user.documentationSecondLanguage.code;
                            //blockUI.start();
                            DiagFileBusinessService.getDiagFileById($state.params.data, preferredLanguage, defaultLanguage).then(function (response){
                                //redirect to details page
                                blockUI.stop();
                            }).catch(function(error){
                                blockUI.stop();
                            });
                        }else  */
                        const isComingFromDiagFileDetails = $state.params && $state.params.isFromDiagFileDetails;
                        if(!isComingFromDiagFileDetails){
                        clearSelectedDiagFile();
                        }
                        reinitSearch();
                        break;
                    case CarSearchResultConstants.searchTypes.searchBySpecializedTool:
                        SearchArboTextualMetierService.setConnectedServicesAuditData('Specific_Tools').then(function () {});
                        vm.showArboView = false;
                        vm.showDiagnosticView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showconsultElectricalShema = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showDiagFilesView = false;
                        vm.showSpecializedToolView = true;
                        clearSelectedDiagFile();
                        reinitSearch();
                        break;
                    case CarSearchResultConstants.searchTypes.axleGeometry:
                        vm.showArboView = false;
                        vm.showDiagnosticView = false;
                        vm.showSpecializedToolView = false;
                        vm.showconsultElectricalShema = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showDiagFilesView = false;
                        vm.showGeometryApplicabilities = true;
                        clearSelectedDiagFile();
                        reinitSearch();
                        break;
                    case CarSearchResultConstants.searchTypes.consultElectricalShema:
                        SearchArboTextualMetierService.setConnectedServicesAuditData('Wiring_Diagram').then(function () {});
                        vm.showArboView = false;
                        vm.showDiagnosticView = false;
                        vm.showSpecializedToolView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showVehicleMultimediaInformation = false;
                        vm.showDiagFilesView = false;
                        vm.showconsultElectricalShema = true;
                        $rootScope.WDerror = false;
                        clearSelectedDiagFile();
                        reinitSearch();
                        break;
                    case CarSearchResultConstants.searchTypes.showVehicleMultimediaInformation:
                        if (isUserClick === true) {
                            show2G3GNetworkShutdownPopup();
                        }
                        vm.showArboView = false;
                        vm.showDiagnosticView = false;
                        vm.showSpecializedToolView = false;
                        vm.showGeometryApplicabilities = false;
                        vm.showconsultElectricalShema = false;
                        vm.showDiagFilesView = false;
                        vm.showVehicleMultimediaInformation = true;
                        clearSelectedDiagFile();
                        //findIfIsVehicleRlink2();
                        // reinitSearch();
                        trackInformation();
                        break;
                }
            }
        }

        function trackInformation() { 
            vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            if(vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {          
                SearchArboTextualMetierService.setConnectedServicesAuditData('VIN_SEARCH')
                    .then(function () { }) 
            }
        }

        function checkRCallCriteria() {
            const carContext = CacheService.getCarContext();
            if (!carContext || !carContext.fixedCriterias) {
                return false;
            }
            return carContext.fixedCriterias['D86'] === 'RCALL';
        }

        function isRLink1Or2Platform() {
            vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            if (!vm.connectedPlatform || !vm.connectedPlatform.platform) {
                return false;
            }
            const platform = vm.connectedPlatform.platform.toUpperCase();
            return platform === 'RLINK1' || platform === 'RLINK2';
        }

        function show2G3GNetworkShutdownPopup() {
            const hasRCall = checkRCallCriteria();
            const isRLink = isRLink1Or2Platform();
            vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
                const arch = vm.connectedPlatform && vm.connectedPlatform.architecture ? vm.connectedPlatform.architecture.toLowerCase() : '';
            
            if ((arch === 'ccs3' && hasRCall) || (!hasRCall && !isRLink)) {
                return;
            }
            let messageKey = '';      
            if (hasRCall) { 
                messageKey = 'NETWORK_2G3G_RCALL_MESSAGE';
            } else if (isRLink) {
                messageKey = 'NETWORK_2G3G_RLINK_MESSAGE';
            }
            const message = $translate.instant(messageKey);
            const okText = $translate.instant('OK');

            $mdDialog.show({
                template:
                    '<div class="popinInfo" style="padding:20px; min-width:400px; max-width:60rem; font-family: newRenaultGroupRegular;">' +
                    '<div style="margin-bottom:15px; font-size:16px; font-weight:bold;">' +
                    '<span style="color: #ff0000;">\u26a0\ufe0f</span> ' +
                    '<span style="color: #ff0000;">{{ "NETWORK_2G3G_TITLE" | translate }}</span>' +
                    '</div>' +
                    '<div style="font-weight:normal; margin-bottom:10px; line-height:1.6; white-space: pre-line;">' +
                    '<span>{{ message }}</span>' +
                    '</div>' +
                    '<div style="display:flex; justify-content:center; gap:20px; margin-top:20px;">' +
                    '<button ng-class="{\'nissanBtnWithIcon\': nissanUserURL, \'buttonWithIcon\': !nissanUserURL}" ng-click="closeDialog()" style="min-width:80px;">{{ okText }}</button>' +
                    '</div>' +
                    '</div>',
                controller: function ($scope, $mdDialog) {
                    $scope.message = message;
                    $scope.okText = okText;
                    $scope.nissanUserURL = vm.nissanUserURL;

                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
                clickOutsideToClose: true,
                escapeToClose: true
            });
        }

        function clearSelectedDiagFile(){

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            delete contextCarSearch['diagDocuments'];
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);

            var diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);

            diagFilesList = _.map(diagFilesList,  function(item){
               return _.omit(item, ['selected','dtcs','ecus','networks','ecuVisible','networkVisible']);
            })

            CacheService.setObject(CacheConstants.diagFilesList, diagFilesList);

            var symptomBasketList = CacheService.getObject(CacheConstants.symptomsBasketList);

            symptomBasketList = _.map(symptomBasketList, function(it){
                 return _.omit(it,['selected']);
            })

            CacheService.setObject(CacheConstants.symptomsBasketList, symptomBasketList);
            CacheService.removeObject(CacheConstants.diagFileDisplay);
            CacheService.removeObject(CacheConstants.systemDocDetails);
            CacheService.removeObject(CacheConstants.diagCurrentPage);
            CacheService.removeObject(CacheConstants.historyPagination);

            if(vm.isClipRedirectionForNodes){
                reinitSearch();
            }
        }

        function reinitSearch() {
            if (!vm.isNewSearchBar){
                vm.filterChoosen = { id: "ALL" };
            }

            vm.motCle = undefined;
            vm.showSearchRef = false;
            vm.isArboFiltered = false;
            vm.goToSearchResult = false;
            vm.autocompleteList = [];

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            contextCarSearch.filteredTree = {};
            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
            CacheService.setObject(CacheConstants.motCle, vm.motCle);
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            if(vm.isHorseUser){
                getNodesFirstLevelAndShowFirstNode(1);
            } else {
                getNodesFirstLevelAndShowFirstNode(0);
            }
        }

        /**
         * @desc get the car context and check if it contains one of the RLINK 2 codes stocked in constants
         */
        function findIfIsVehicleRlink2OrRlink1() {
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var listRLink = CarSearchResultConstants.listRLink;
            var rLink2Code = CarSearchResultConstants.rLink2Code;
            var listRLink1 = CarSearchResultConstants.listRLink1;
            var rLink1Code = CarSearchResultConstants.rLink1Code;

            if (contextCarRequest && contextCarRequest.fixedCriterias[rLink2Code]) {
                if(_.includes(listRLink,contextCarRequest.fixedCriterias[rLink2Code])){
                    vm.isRLink2Vehicle = true;
                    CacheService.setObject(CacheConstants.connectedPlatform, {platform: 'rlink2'});
                }

                if(_.includes(listRLink1,contextCarRequest.fixedCriterias[rLink1Code])){
                    vm.isRLink1Vehicle = true;
                    CacheService.setObject(CacheConstants.connectedPlatform, {platform: 'rlink2', vehicle: 'rlink1'});
                }
            }
        }

        function onChangeMotCle() {
            //add condition specific to tm list
            vm.showAutocomplete = false;
            if (!vm.motCle && vm.showSearchRef) {
                getNodesFirstLevelAndShowFirstNode(0);
            }

            var regExp = /^([0-9]{4,})([\/]{1,})([0-9]{6,})$/;
        
            if (vm.isNewSearchBar && vm.motCle && vm.motCle.length >= 3
                    &&vm.stateInputsForm['motCle'].active&&vm.newSearchFilter.id !== "TM_LIST"){

                var searchedIds = vm.motCle.split(" ").join("");
                var isPlateSearch = vm.newSearchFilter.id === "PR" && searchedIds.length === 11 && regExp.test(searchedIds);
                if(!isPlateSearch){
                    vm.showAutocomplete = true;
                    var types = [];
                    types.push(vm.newSearchFilter.id);
                    getAutoCompleteList(vm.motCle,types);
                }
            }
        }

        function getAutoCompleteList(searchText, types){
            vm.autocompleteList = [];
            var isOtherLang = CacheService.getUserContext() ? CarSearchResultConstants.autoSearchLang.includes(CacheService.getUserContext().language) : false;
            if(isOtherLang){
                searchByTextsIdsMertierService.getSearchEngineDocs(searchText,types,isOtherLang).then( function (response){
                    if (response && response.documents){
                        vm.autocompleteList = response.documents;
                    }
                });
            }else{
                searchByTextsIdsMertierService.getAutoCompleteList(searchText,types).then( function (response){
                    if (response && response.documents){
                        vm.autocompleteList = response.documents;
                    }
                });
            }
        }

        function getItemfromAutocomplete(item){
            vm.motCle = item.label;
            if (vm.isNewSearchBar && vm.motCle.length >= 3 && vm.newSearchFilter.id !== "TM_LIST"){
                goToSearchEngineCatalogPage(false, null);
            }
            vm.showAutocomplete = false;
        }
        /**
         * @description
         *
         *              newSearchENgineCataloguee Page redirecting
         */
        function goToSearchEngineListePiece(motCle,documentType,clipRedirection) {

            CacheService.setObject(CacheConstants.isSearchEngine,true);
            CacheService.setObject(CacheConstants.searchEngineIds, vm.searchEngineIds);
            CacheService.setObject(CacheConstants.motCle, vm.motCle);
            CacheService.setObject(CacheConstants.filter, vm.newSearchFilter);
            documentType = motCle && documentType[0] === 'PR' ? 'newSearch' : documentType;
            $state.go(RoutesConstants.listePieceViews, {
                searchGenericParts: vm.searchEngineIds,
                isSearchEngine:vm.isNewSearchBar,
                documentType: documentType,
                plateIndex: 0,
                refIndex: 0,
                motCle:motCle,
                filterChoosen:vm.newSearchFilter,
                clipRedirect: clipRedirection,
                isComingFromDiagFileDetails: isComingFromDiagFileDetails,
                isTextSearchRedirect: isTextSearchRedirect
            });
        }


        function goToSearchEngineCatalogPage(clipRedirection,element){
            var types = [];
            types.push(vm.newSearchFilter.id);
            getSearchEngineDocs(vm.motCle,types,clipRedirection,element);

        }

        function getSearchEngineDocs (searchText, types,clipRedirection, element){
            SearchArboTextualMetierService.setConnectedServicesAuditData('Search_' + (types && types[0] ? types[0] : '') + '_' + searchText).then(function () {});
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeSearchEngineMd();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removePrResponse();
            blockUI.start();
            searchByTextsIdsMertierService.getSearchEngineDocs(searchText,types).then( function (response){
                var filterData ={};
                filterData[types[0]] = response;
                DocPrivMetierService.setSearchEngineMd(filterData);

                if (!_.isEmpty(response)){
                    vm.searchEngineIds = response;
                    if(clipRedirection){
                        goToLevelTwoAndThree(vm.dataArboLevelOne.nodes[0]);
                        blockUI.stop();
                    }

                    if(vm.newTextSearch && vm.newSearchFilter.id === "PR"){
                        blockUI.start();
                        DocumentsMetierService.getPartsByGenericParts(vm.searchEngineIds).then(function (response) {
                            goToSearchEngineListePiece(searchText,types);
                        }).catch(function () {
                            $log.debug($translate.instant('ERROR'));
                        }).finally(function () {
                            blockUI.stop();
                        });
                   }else{
                       goToSearchEngineListePiece(searchText,types,clipRedirection);
                   }
                }
                else if(vm.newSearchFilter.id === "TM"){
                    var tmListData = vm.motCle.split(/[.,!,?]/);
                    if (tmListData.length > 1) {
                        toastr.info($translate.instant("SELECT_TM_LIST"));
                      _.map(vm.initialFitlters, function (filter) {
                            if(filter.id === "TM_LIST") {
                                vm.selectedFilter = filter;
                            }
                        })
                        vm.newSearchFilter = vm.selectedFilter;
                        CacheService.setObject(CacheConstants.filter, vm.newSearchFilter);
                    }
                    else {
                        if (vm.checkTMListPattern()) {
                            goToSearchEngineListePiece(searchText, types);
                        }
                    }
                } else if(clipRedirection && vm.motCle.length > 11){
                        vm.motCle = element;
                        goToSearchEngineCatalogPage(true, null);
                }
                else {
                    if(clipRedirection){
                        CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                        toastr.info($translate.instant('NO_DOCUMENT_FOUND'));
                        goToLevelTwoAndThree(vm.dataArboLevelOne.nodes[0]);
                    }
                    else{
                        toastr.error($translate.instant("CARSEARCH_NAME_NOT_RESULT_FOUND"));
                        if(isTextSearchRedirect){
                            openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
                            return;                
                        }
                    }
                }
            }).catch(function (e) {
                vm.searchEngineIds=[];
                if(clipRedirection){
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                    toastr.info($translate.instant('NO_DOCUMENT_FOUND'));
                    goToLevelTwoAndThree(vm.dataArboLevelOne.nodes[0]);
                }
                if(isTextSearchRedirect){
                    openSelectedView(CarSearchResultConstants.searchTypes.searchByDiagnostic);
                    return;                
                }
            }).finally(function () {
                if(isTextSearchRedirect){
                    isTextSearchRedirect = false;
                }
                blockUI.stop();
            });
        }
        function redirectSearchReference(ref) {
            if (ref) {

                blockUI.start();
                ProductMetierService
                    .getReferenceInformation(ref, ref)
                    .then(function (response) {
                        response.genericPart = vm.searchEngineIds[0];
                        RoutingService.goToProductPage({
                            path: {
                                reference: response.originalPartReference,
                                mainReference: response.supersessionRootReference,
                                refIndex: null,
                                plateIndex: null
                            },
                            data: response
                        });
                    }).catch(function (err) {
                        if (err === _errors.UNKNOW_REFERENCE) {
                            toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                        } else {
                            toastr.error($translate.instant('ERROR'));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
            }
        }
        /**
         * @description Used to populate the list of all components for the corresponding wiring diagram
         *              Remove the duplicates
         *              Sort the component data alphanumerically (A-Z and 1-9)
         */
        function displayComponentData() {
            vm.sharedWdPartHarnessAndWiringDataComponentsAndSignals = searchElectricalSchemaMetierService.sharedWdPartHarnessAndWiringDataComponentsAndSignals;
        }

        /**
        * @description Used to convert incoming array into an object
        * @param {*} res
        */
        function convertArrayWDResponseToObject(res) {
            var result = {
                WIRING_DIAGRAMS: []
            }

            if (res && res.length) {
                res.forEach(function (item) {
                    result.WIRING_DIAGRAMS.push.apply(result.WIRING_DIAGRAMS, item.WIRING_DIAGRAMS);
                });
            }
            return result;
        }


        /**
         * @description Used to get all the thumbnail data of wiring and part harness components
         *              Used to go to the Single Controller page
         *              Used to send the component data as parameters
         * @param {*} component
         */
        function displayComponentCodeAndLabel(component) {
            SearchArboTextualMetierService.setConnectedServicesAuditData('Search_component/signal label').then(function () {});
            var first_call = [];
            var sec_res = [];
            var final_res = [];
            var WD_PH = [];
            var WD_GH = [];
            var WD_Conn = [];
            var WD_Wiring = [];
            var subType = ["WIRING"];
            vm.wdObjectCriteria = CacheService.getObject(CacheConstants.wdObjectCriteria) ? CacheService.getObject(CacheConstants.wdObjectCriteria).header : [];
            vm.isObjCritSelected = vm.wdObjectCriteria ? true : false;
            blockUI.start();

            return searchElectricalSchemaMetierService.getByIdLiteWithFullContext(component.id, component.type, vm.isObjCritSelected, vm.wdObjectCriteria).then(function (res) {

                res = convertArrayWDResponseToObject(res);

                WD_PH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "PART_HARNESS";
                });


                WD_GH = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "GROUND_HARNESS";
                });

                WD_Conn = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "CONNECTOR";
                });

                WD_Wiring = _.filter(res.WIRING_DIAGRAMS, function (item) {
                    return item.subType == "WIRING";
                });

                WD_PH.length == 0 ? subType.push("PART_HARNESS") : first_call.push(WD_PH);
                WD_GH.length == 0 ? subType.push("GROUND_HARNESS") : first_call.push(WD_GH);
                WD_Conn.length == 0 ? subType.push("CONNECTOR") : first_call.push(WD_Conn);

                vm.connectorList = WD_Conn;

            }).then(function () {
                if (WD_PH.length == 0 || WD_GH.length == 0 || WD_Conn.length == 0) {
                    return searchElectricalSchemaMetierService.getByIdLite(component.id, component.type, subType, vm.isObjCritSelected, vm.wdObjectCriteria).then(function (res) {
                        res = convertArrayWDResponseToObject(res);
                        sec_res = res.WIRING_DIAGRAMS;

                        var sec_wiring = _.filter(sec_res, function (item) {
                            return item.subType == "WIRING";
                        });
                        var final_wd = _.filter(sec_res, function (item) {
                            return item.subType == "WIRING";
                        });

                        var subtype = _.filter(sec_res, function (item) {
                            return item.subType != "WIRING";
                        });
                        if (subtype.length > 0) {
                            final_res = subtype;
                            first_call.push(subtype);
                        }


                        for (var i = 0; i < WD_Wiring.length; i++) {
                            for (var j = 0; j < sec_wiring.length; j++) {
                                if ((WD_Wiring[i].nodes.WD_TREE[0]['code'] == sec_wiring[j].nodes.WD_TREE[0]['code']) &&
                                    (WD_Wiring[i].nodes.WD_TREE[1]['code'] == sec_wiring[j].nodes.WD_TREE[1]['code']) &&
                                    (WD_Wiring[i].nodes.WD_TREE[2]['code'] == sec_wiring[j].nodes.WD_TREE[2]['code'])) {
                                    var getindex = _.findIndex(final_wd, sec_wiring[j]);
                                    if (getindex > -1) {
                                        final_wd.splice(getindex, 1);
                                    }
                                }
                            }

                        }

                        for (var k = 0; k < WD_Wiring.length; k++) {
                            final_wd.push(WD_Wiring[k]);
                        }

                        if (final_wd.length == 0) {
                            final_wd = angular.copy(WD_Wiring);
                        }

                        if (WD_PH.length == 0) {
                            WD_PH = _.filter(final_res, function (item) {
                                return item.subType == "PART_HARNESS";
                            });
                        }

                        if (WD_Conn.length == 0) {
                            WD_Conn = _.filter(final_res, function (item) {
                                return item.subType == "CONNECTOR";
                            });
                            vm.connectorList = WD_Conn;
                        }

                        if (vm.connectorList.length > 0) {
                            vm.isDetailsAvailable = true;
                        }

                        displayPartHarnessAndWiringDiagram(WD_PH, final_wd, component);

                    });

                }
                else {
                    displayPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, component);
                }

            });


        }

        /**
         * @description Used to display PartHarness And Wiring Diagram
         * @param {*} res
         */
        function displayPartHarnessAndWiringDiagram(WD_PH, WD_Wiring, component) {
            vm.componentSvgObject = [];
            vm.phObject = {};
            var rawMTCdata = '';

            vm.relatedElectricalSchema = {};
            vm.relatedElectricalSchema.id = '';
            vm.relatedElectricalSchema.thumbnailLocation = '';
            vm.relatedElectricalSchema.nodes = {};
            vm.relatedElectricalSchema.nodes.wdNode = [];
            vm.nodes = [];

            for (var i = 0; i < WD_PH.length; i++) {
                vm.phObject['id'] = WD_PH[i].id;
                vm.phObject['thumbnailLocation'] = WD_PH[i].thumbnailLocation;
                vm.phObject['residual'] = WD_PH[i].residual;
                vm.phObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(WD_PH[i]);
                if (WD_PH[i].residual && WD_PH[i].residual.length) {
                    vm.phObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(WD_PH[i].residual[0].variable);
                }
                vm.phObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(rawMTCdata);
                vm.componentSvgObject.push(vm.phObject);
                vm.phObject = {};
            }

            for (var i = 0; i < WD_Wiring.length; i++) {
                var thumbNailLoc = WD_Wiring[i].thumbnailLocation;
                if (true) {
                    var nodeFunction = [];
                    var nodeSubFunction = [];
                    var nodeTitle = [];
                    if (WD_Wiring[i].nodes !== undefined) {
                        WD_Wiring[i].nodes.WD_TREE.forEach(function (node) {
                            if (node.type === "FUNCTION") {
                                nodeFunction.push(node);
                            } else if (node.type === "SUBFUNCTION") {
                                nodeSubFunction.push(node);
                            } else if (node.type === "TITLE") {
                                nodeTitle.push(node);
                            }
                        });

                        var subNode = {};
                        subNode.thumbNailLoc = [thumbNailLoc];
                        nodeFunction.forEach(function (nodeFunctionElement) {
                            var currentNode = {};
                            currentNode.function = nodeFunctionElement;
                            nodeSubFunction.forEach(function (subFunction) {
                                currentNode.subFunction = subFunction;
                                nodeTitle.forEach(function (title) {
                                    currentNode.title = title;
                                    subNode.subNode = angular.copy(currentNode);
                                    vm.nodes = subNode.subNode;
                                    vm.relatedElectricalSchema.nodes.wdNode.push(subNode);
                                });
                            });
                        });

                        nodeFunction = [];
                    } else {
                        vm.relatedElectricalSchema.nodes.wdNode.push(WD_Wiring[i]);
                    }
                }
            }

            var myArray = null;
            var myFilteredArr = [];
            myArray = angular.copy(vm.relatedElectricalSchema.nodes.wdNode);
            var filteredSubNodes = _.groupBy(myArray, 'subNode.title.code');
            _.forEach(filteredSubNodes, function(node){
                if(node.length > 1){
                    var tempThumbNailLoc = [].concat.apply([], (_.map(node,'thumbNailLoc')))
                    myFilteredArr.push({subNode: node[0].subNode, thumbNailLoc: _.uniq(tempThumbNailLoc)})
                } else{
                    myFilteredArr.push(node[0])
                }
            })
            myFilteredArr.sort(function (a, b) {
                if (a.subNode && b.subNode) {
                    return a.subNode.function.code - b.subNode.function.code ||
                        a.subNode.subFunction.code - b.subNode.subFunction.code ||
                        a.subNode.title.code - b.subNode.title.code;
                }
            });

            vm.relatedElectricalSchema.nodes.wdNode = myFilteredArr;

            vm.relatedElectricalSchema.nodes.wdNode.forEach(function (item) {

                item.residualInfo = [];
                //BUG-1851 foreach exception resolved
                if (item.thumbNailLoc !== undefined) {
                    item.thumbNailLoc.forEach(function (thumb) {
                        WD_Wiring.forEach(function (obj) {
                            if (obj.thumbnailLocation === thumb) {
                                var itemObject = {};
                                itemObject['displayedThumbnail'] = obj.thumbnailLocation;
                                itemObject['residual'] = obj.residual;
                                itemObject['id'] = obj.id;
                                if (obj.residual && obj.residual.length) {
                                    itemObject['variableResidual'] = searchElectricalSchemaMetierService.formatVariableResidualForRawMTC(obj.residual[0].variable);
                                }
                                itemObject['formattedResidual'] = searchElectricalSchemaMetierService.formatResidual(obj);
                                itemObject['rawMTCdata'] = searchElectricalSchemaMetierService.filterCriteriasFromMTC(obj.rawMTC);
                                item.residualInfo.push(itemObject);
                            }
                        });
                    });
                }
            });
            blockUI.stop();

            $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                componentLabel: component.label, componentCode: component.id, isComponentSelected: true, node: vm.nodes,
                componentType: component.type, isFromWDUrlLink: vm.isFromWDUrlLink,
                wiringDiagramData: vm.relatedElectricalSchema.nodes.wdNode, thumbnailData: vm.componentSvgObject, chosenComponent: component,
                isUserComingFromClip: vm.isUserComingFromClip, isDetailsAvailable: vm.isDetailsAvailable, connectorList: vm.connectorList,
            });

        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        function translate() {
            vm.initialFitlters = [];
            if (vm.isIndependentUser){
                if (vm.doctypes.length > 0){
                    vm.filterChoosen = filter ? filter : { id: vm.doctypes[0] };
            vm.newSearchFilter =  (filter && filter.id != 'ALL') ? filter : { id: vm.doctypes[0] };
                for(var i=0; i < vm.doctypes.length;i++){
                    vm.initialFitlters.push({ "id":vm.doctypes[i], label: $translate.instant(CarSearchResultConstants.searchLabels[vm.doctypes[i]]) });
                }
                if(_.includes(vm.doctypes,"TM")){
                    vm.initialFitlters.push({ "id":"TM_LIST", label: $translate.instant('CAR_SEARCH_RESULT_FILTER_TM_LIST') });
                }
                initFilter();
                }
                else{
                    vm.filterChoosen = null;
                    vm.newSearchFilter.id = null;
                    initFilter();
                }

            }
            else if(vm.isNewSearchBar){
                var toTrad = [
                    $translate('CAR_SEARCH_RESULT_FILTER_PR'),
                    $translate('CAR_SEARCH_RESULT_FILTER_TM'),
                    $translate('CAR_SEARCH_RESULT_FILTER_MR'),
                    $translate('CAR_SEARCH_RESULT_FILTER_MD'),
                    $translate('CAR_SEARCH_RESULT_FILTER_TM_LIST'),
                ];

                $q.all(toTrad).then(function (trads) {
                    vm.initialFitlters.push({ "id": "PR", label: trads[0] });
                    vm.initialFitlters.push({ "id": "TM", label: trads[1] });
                    vm.initialFitlters.push({ "id": "MR", label: trads[2] });
                    vm.initialFitlters.push({ "id": "MD", label: trads[3] });
                    vm.initialFitlters.push({ "id": "TM_LIST", label: trads[4] });
                    initFilter();
                });
            }
            else {
            var toTrad = [
                $translate('CAR_SEARCH_RESULT_FILTER_ALL'),
                $translate('CAR_SEARCH_RESULT_FILTER_PR'),
                $translate('CAR_SEARCH_RESULT_FILTER_TM'),
                $translate('CAR_SEARCH_RESULT_FILTER_MR'),
                $translate('CAR_SEARCH_RESULT_FILTER_MD'),
                $translate('CAR_SEARCH_RESULT_FILTER_TM_LIST'),
            ];
            $q.all(toTrad).then(function (trads) {
                vm.initialFitlters.push({ "id": "ALL", label: trads[0] });
                vm.initialFitlters.push({ "id": "PR", label: trads[1] });
                vm.initialFitlters.push({ "id": "TM", label: trads[2] });
                vm.initialFitlters.push({ "id": "MR", label: trads[3] });
                vm.initialFitlters.push({ "id": "MD", label: trads[4] });
                vm.initialFitlters.push({ "id": "TM_LIST", label: trads[5] });
                initFilter();
            });
        }

    }

        function getNodesFirstLevelAndShowFirstNode(nodeIndex) {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);

            if (contextCarSearch && contextCarSearch.filteredTree && !_.isEmpty(contextCarSearch.filteredTree)) {

                vm.motCle = contextCarSearch.filteredTree.criteria;
                vm.dataArboLevelOne = contextCarSearch.filteredTree.level1;
                vm.filterChoosen = contextCarSearch.filteredTree.filterChoosen;
                goToFilteredLevel1(0);
                vm.showContent = true;
            }
            else if (contextCarSearch && !contextCarSearch.treeNodes) {
                blockUI.start();
                SearchArboTextualMetierService.getNodes()
                    .then(function (response) {
                        if (response[0].errorCode) {
                            return toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                        }
                        else if (!response[0].nodes) {
                            return;
                        }
                        if (vm.nissanUserURL) {
                            const excludedIds = [
                                'N-21397', 'N-21404', 'N-21446',
                                'N-33907', 'N-33909', 'N-33908', 'N-33910'
                            ];

                            response[0].nodes = response[0].nodes.filter(function (node) {
                                return !excludedIds.includes(node.nodeId);
                            });
                        }
                        vm.dataArboLevelOne = response[0];
                        vm.showContent = true;
                        contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                        contextCarSearch.treeNodes = {
                            levelOne: vm.dataArboLevelOne
                        };
                        CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
                        splitNodeLabel(vm.dataArboLevelOne);
                        if ($state.params.data) {
                            if ($state.params.data.node1) {
                                nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {

                                    return node.nodeId === $state.params.data.node1.nodeId;
                                });
                            } else {
                                var nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                                nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {

                                    return node.nodeId === nodeSelect.nodeId;
                                });
                            }
                        }
                        
                        vm.nodeSelect = nodeIndex;
                        var intNodeSelected = CacheService.getObject(CacheConstants.intNodeSelected);
                        if(intNodeSelected && vm.dataArboLevelOne && !_.isEmpty(vm.dataArboLevelOne.nodes)){
                            AlertsLocationService.buildAlerts({location: getNodeName(intNodeSelected.label, true), label: getNodeName(intNodeSelected.label, true)}, 'ARBO');
                            CacheService.setObject(CacheConstants.nodeSelect, intNodeSelected);
                        }
                        else{
                            AlertsLocationService.buildAlerts({location: getNodeName(nodeIndex), label: getNodeName(nodeIndex)}, 'ARBO');
                            CacheService.setObject(CacheConstants.nodeSelect, vm.dataArboLevelOne.nodes[nodeIndex]);
                        }
                        vm.showExplodedButton = true;
                    })
                
                getAllLevelTwoAndThree();
            } else {
                blockUI.start();
                var treeNodes = CacheService.getObject(CacheConstants.contextCarSearch).treeNodes;
                if(treeNodes)
                    vm.dataArboLevelOne = treeNodes.levelOne;
                vm.showContent = true;

                if ($state.params.data) {
                    if ($state.params.data.node1) {
                        nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === $state.params.data.node1.nodeId;
                        });
                    } else {
                        var nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                        nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === nodeSelect.nodeId;
                        });
                    }
                    if ($state.params.data.node) {
                        vm.targetNode = $state.params.data.node;
                        vm.hasToScroll = false;
                        var node_id = (vm.targetNode.level === 2) ? '#_' + vm.targetNode.rang : '#line_resultat_level2_and_3';
                        $timeout(function () {
                            ScrollService.animateTo(node_id);
                        }, 0);
                    }
                }
                vm.nodeSelect = nodeIndex;
                var intNodeSelected = CacheService.getObject(CacheConstants.intNodeSelected);
                var interventionIdList = CacheService.getObject(CacheConstants.interventionIdList);
                if(interventionIdList && intNodeSelected && vm.dataArboLevelOne && !_.isEmpty(vm.dataArboLevelOne.nodes)){
                    AlertsLocationService.buildAlerts({location: getNodeName(intNodeSelected.label, true), label: getNodeName(intNodeSelected.label, true)}, 'ARBO');
                    CacheService.setObject(CacheConstants.nodeSelect, intNodeSelected);
                    goToLevelTwoAndThreeWithoutShowImageFirst(intNodeSelected, interventionIdList.intNodeSelect, true);
                }
                else{
                    AlertsLocationService.buildAlerts({location: getNodeName(nodeIndex), label: getNodeName(nodeIndex)}, 'ARBO');
                    CacheService.setObject(CacheConstants.nodeSelect, vm.dataArboLevelOne.nodes[nodeIndex]);
                    goToLevelTwoAndThreeWithoutShowImage(vm.dataArboLevelOne.nodes[nodeIndex]);
                }
                vm.showExplodedButton = true;
                blockUI.stop();
            }
        }

        /*
         * This method is base on getNodesFirstLevelAndShowFirstNode but is specific for clip
         * since we need to wait for multiple promises  getAllLevelTwoAndThree() and returnSIEDocuments()
         * in order to redirect the user to the proper documentType ex documentMR
         */
        function getNodesFirstLevelForClipRedirection(nodeIndex, elementRef, operationCode) {
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);

            if (contextCarSearch && !contextCarSearch.treeNodes) {
                blockUI.start();
                SearchArboTextualMetierService.getNodes()
                    .then(function (response) {
                        if (response[0].errorCode) {
                            return toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                        }
                        else if (!response[0].nodes) {
                            return;
                        }
                        vm.dataArboLevelOne = response[0];
                        vm.showContent = true;
                        contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                        contextCarSearch.treeNodes = {
                            levelOne: vm.dataArboLevelOne
                        };

                        splitNodeLabel(vm.dataArboLevelOne);

                        CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
                        if ($state.params.data) {
                            if ($state.params.data.node1) {
                                nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {

                                    return node.nodeId === $state.params.data.node1.nodeId;
                                });
                            } else {
                                var nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                                nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {

                                    return node.nodeId === nodeSelect.nodeId;
                                });
                            }
                        }
                        vm.nodeSelect = nodeIndex;
                        AlertsLocationService.buildAlerts({
                            location: getNodeName(nodeIndex),
                            label: getNodeName(nodeIndex)
                        }, 'ARBO');


                        CacheService.setObject(CacheConstants.nodeSelect, vm.dataArboLevelOne.nodes[nodeIndex]);
                        vm.showExplodedButton = true;

                    }).catch(function(error){
                        console.log(error);
                    })
                    getAllLevelTwoAndThree().then(function (response) {
                        vm.isSearchEngine = true;
                        CacheService.setObject(CacheConstants.isSearchEngine,true);
                        vm.newSearchFilter = {
                            "id": "MR",
                            "label": "MR",
                            "$$hashKey": "object:17"
                        };
                        vm.motCle = (!UtilsMetierService.isEmpty(elementRef) && !UtilsMetierService.isEmpty(operationCode)) ? elementRef + ' ' + operationCode
                            : !UtilsMetierService.isEmpty(elementRef) ? elementRef
                                : !UtilsMetierService.isEmpty(operationCode) ? operationCode : '';

                    }).finally(function () {

                        if (vm.motCle && vm.motCle != "") {
                            getFilteredTree(0,elementRef);
                        }

                        //clear data CLIP from Cache
                        CacheService.removeObject(CacheConstants.clipParameters);
                        blockUI.stop();

                    })
            } else {

                // *  Case we come back from the DocumentMR page or any DocumentType page
                // *  this section has for purpose to redisplay the arbo

                //TODO extract this part -> duplicate code (smell) for the next UserStory aka redirection to different documentTYpe
                blockUI.start();
                var treeNodes = CacheService.getObject(CacheConstants.contextCarSearch).treeNodes;
                if(treeNodes)
                    vm.dataArboLevelOne = treeNodes.levelOne;
                vm.showContent = true;
                if(isTextSearchRedirect){
                    vm.isSearchEngine = true;
                    CacheService.setObject(CacheConstants.isSearchEngine,true);
                    vm.newSearchFilter = {
                        "id": "PR",
                        "label": "PR"
                    };
                    vm.motCle = $state.params.reference ? $state.params.reference.replace(/_/g, '/') : '';
                    blockUI.stop();
                    if (vm.motCle && vm.motCle != "") {
                        if(vm.motCle.indexOf('/') !== -1){
                            searchNodebyRef(false);
                        } else {
                            getFilteredTree(0,vm.motCle);
                        }
                    }
                } else {
                    if ($state.params.data) {
                        if ($state.params.data.node1) {
                            nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                                return node.nodeId === $state.params.data.node1.nodeId;
                            });
                        } else {
                            var nodeSelect = CacheService.getObject(CacheConstants.nodeSelect);
                            nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                                return node.nodeId === nodeSelect.nodeId;
                            });
                        }
                        if ($state.params.data.node) {
                            vm.targetNode = $state.params.data.node;
                            vm.hasToScroll = false;
                            var node_id = (vm.targetNode.level === 2) ? '#_' + vm.targetNode.rang : '#line_resultat_level2_and_3';
                            $timeout(function () {
                                ScrollService.animateTo(node_id);
                            }, 0);
                        }
                    }
                    vm.nodeSelect = nodeIndex;
                    AlertsLocationService.buildAlerts({
                        location: getNodeName(nodeIndex),
                        label: getNodeName(nodeIndex)
                    }, 'ARBO');
                    CacheService.setObject(CacheConstants.nodeSelect, vm.dataArboLevelOne.nodes[nodeIndex]);
                    goToLevelTwoAndThreeWithoutShowImage(vm.dataArboLevelOne.nodes[nodeIndex]);
                    vm.showExplodedButton = true;
                }
                blockUI.stop();
            }

        }


        function splitNodeLabel(nodeTree) {
            var parentNode = nodeTree.nodes;
            var nodeLabelSplitted;
            angular.forEach(parentNode, function (value, key) {
                nodeLabelSplitted = value.label.split('- ');
                nodeLabelSplitted = formatUpperCaseNode(nodeLabelSplitted);
                value.label = nodeLabelSplitted.join('- ');
                if (value.level === 2) {
                    if (!value.documents) {
                        value.documents = checkEmptyNodes(value.idDocuments); //for enabling level2 transeversalNodes
                    }
                }
                if (value.childNodes) {
                    angular.forEach(value.childNodes, function (result, indice) {
                        if (result.level === 3) {
                            if (!value.childNodes[indice].documents) {
                                value.childNodes[indice].documents = checkEmptyNodes(result.idDocuments); //for enabling level3 transeversalNodes
                            }
                        }
                        nodeLabelSplitted = result.label.split('- ');
                        nodeLabelSplitted = formatUpperCaseNode(nodeLabelSplitted);
                        value.childNodes[indice].label = nodeLabelSplitted.join('- ');
                    })
                }
                return nodeTree;
            });
        }

        function formatUpperCaseNode(nodeLabelSplitted) {

            for (var index = 0; index < nodeLabelSplitted.length; index++) {
                nodeLabelSplitted[index] = nodeLabelSplitted[index].charAt(0).toUpperCase() + nodeLabelSplitted[index].slice(1);
            }
            return nodeLabelSplitted;

        }

        /**
         * get nodes all level 2 nodes and thier childrenn (level3) and save in the cache.
         */
        function getAllLevelTwoAndThree(node) {
            blockUI.start();
            var requestNodesFromCtrl = {
                nodeId: "ALL"
            };

            return SearchArboTextualMetierService.getNodes(requestNodesFromCtrl).then(function (response) {
                if (!_.isEmpty(response) && response[0].errorCode) { // if error
                    toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                    blockUI.stop();
                } else if(!_.isEmpty(response)){ // if success
                    var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
                    if(contextCarSearch && contextCarSearch.treeNodes)
                        contextCarSearch.treeNodes.otherLevel = response[0];
                    else {
                        contextCarSearch.treeNodes = {
                            otherLevel : response[0],
                            levelOne : vm.dataArboLevelOne
                        };
                    }
                    CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);
                    
                    if (vm.isHorseUser && contextCarSearch.treeNodes && contextCarSearch.treeNodes.otherLevel) {
                        computeAndCacheAllowedPRDocumentsForHorse(contextCarSearch);
                    }
                    
                    var tempDocIds={}
                    if (response[1] && checkEmptyNodes(response[1].nodes) && contextCarSearch && contextCarSearch.treeNodes && contextCarSearch.treeNodes.otherLevel) {
                        response[1].nodes.forEach(function(level1){
                            tempDocIds[level1.nodeId]=level1.idDocuments;
                            if(level1.childNodes && level1.childNodes.length > 0){
                                level1.childNodes.forEach(function(level2){
                                    tempDocIds[level2.nodeId]=level2.idDocuments;
                                    if(level2.childNodes && level2.childNodes.length > 0){
                                        level2.childNodes.forEach(function(level3){
                                            tempDocIds[level3.nodeId]=level3.idDocuments;
                                        })
                                    }
                                })

                            }
                        })
                        contextCarSearch.treeNodes.otherLevel.nodes.forEach(function(nodes){
                            nodes.idDocuments = tempDocIds[nodes.nodeId];
                            var childNodeCount = 0;
                            var childNodeLength = nodes.childNodes.length;
                            nodes.childNodes.forEach(function(level2){
                                level2.idDocuments = tempDocIds[level2.nodeId];                                
                                    if(vm.nissanUserURL && !(level2.nbrDocumentsByType.MR > 0 || level2.nbrDocumentsByType.MD > 0 || level2.nbrDocumentsByType.MD_101 > 0 || level2.nbrDocumentsByType.MD_102 >0 || level2.nbrDocumentsByType.MD_104 >0 || level2.nbrDocumentsByType.MD_106 > 0 || level2.nbrDocumentsByType.MD_109 >0 || level2.nbrDocumentsByType.MD_108 >0 || level2.nbrDocumentsByType.MD_110 >0 || level2.nbrDocumentsByType.MD_111 >0 || level2.nbrDocumentsByType.MD_501 >0 || level2.nbrDocumentsByType.MD_502 >0)){
                                    level2.documents = false;
                                    childNodeCount = childNodeCount + 1;
                                    return level2;
                                }
                            })
                            if(vm.nissanUserURL && childNodeCount == childNodeLength){
                                nodes.documents = false;                                
                            }
                            
                            if(_.includes(CarSearchResultConstants.nodeIdsAxleAssembly,nodes.nodeId)){
                                nodes.childNodes.push(
                                    {
                                        codeParent : nodes.nodeId,
                                        documents : vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo),
                                        label : $translate.instant('TIRES_NODE_LABEL'),
                                        nodeId : CarSearchResultConstants.nodeIdTires,
                                        level : 3,
                                        rang : 0
                                    });
                            }
                        })
                    }
                    var contextCarSearch1 = CacheService.getObject(CacheConstants.contextCarSearch);
                    contextCarSearch1.treeNodes.otherLevel = contextCarSearch.treeNodes.otherLevel;
                    CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch1);
                    if(vm.isHorseUser){
                        goToLevelTwoAndThreeWithoutShowImage(vm.dataArboLevelOne.nodes[1])
                    } else {
                        goToLevelTwoAndThreeWithoutShowImage(node);
                    }  
                    if(vm.isClipRedirectionForNodes){
                        nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === node_1;
                        });
                        vm.nodeSelect = nodeIndex != -1 ? nodeIndex : 0;
                        vm.selectedLevel1 = vm.dataArboLevelOne.nodes[vm.nodeSelect];
                        if(_.isEmpty(node_2 && _.isEmpty(node_3))){
                            node_1 = '';
                            MainMetierService.setClipParameters(null);
                        }
                        goToLevelTwoAndThreeWithoutShowImage(vm.dataArboLevelOne.nodes[nodeIndex]);
                    }                  
                    if (!$state.params.symptomComingFromClip) {
                        blockUI.reset();
                    }
                } else {
                    blockUI.stop();
                }
            }).then(function () {
                if (vm.otsResponse && vm.checkIndependentUser && vm.isAsomValidDocAccess==='true') {
                    showOtsDialog(vm.otsResponse);
                }
                if (vm.checkIndependentUser&&vm.isAsomValidDocAccess==='false'&&!vm.isCirSentVin) {
                    MainMetierService.AsomDocAccessPopIn(vm.user);
                }
                var retailGroupParameters = ClipService.getParameters(RetailGroupConstants.retailGroupCookieName);
                if(retailGroupParameters && !_.isEmpty(retailGroupParameters)){
                    CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                    ClipService.removeParameters(RetailGroupConstants.retailGroupCookieName);
                    }
                    var clipParameters = ClipService.getParameters(ClipConstants.clipCookieName);
                    var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
                    
                    if((!_.isEmpty(clipParameters) && !clipParameters.clipRdcElementRef && !clipParameters.clipRdcOperationRef && clipParameters.TYPE =='MR') || (!_.isEmpty(commonParameters) && !commonParameters.elementRef && !commonParameters.operationRef && commonParameters.TYPE =='MR')){
                        CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                        ClipService.removeParameters(ClipConstants.clipCookieName);
                        ClipService.removeParameters(RdsConstants.commonCookieName);
                        
                    }

            }).finally(function(){
                blockUI.stop();
            })
        }

        $rootScope.$on('otsAvailable', function (event, data) {

            vm.otsResponse = data.response;

        });
        $rootScope.$on('isEasyBasket', function (event, goToPopup) {
            vm.isEasyBasket = goToPopup;
        });

        var techCritDestroy = $rootScope.$on('technicalCriteria', function (event, data) {

            vm.tiresResponse = true; 
            vm.tyresInfo = data && data.tyresInfo ? data.tyresInfo : null;

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);

            if(contextCarSearch && _.has(contextCarSearch,'treeNodes') &&
             _.has(contextCarSearch.treeNodes,'otherLevel') && _.has(contextCarSearch.treeNodes.otherLevel,'nodes')){

                    contextCarSearch.treeNodes.otherLevel.nodes.forEach(function(nodes){

                        if(_.includes(CarSearchResultConstants.nodeIdsAxleAssembly,nodes.nodeId)){

                            var isTireNode = _.find(nodes.childNodes, {'nodeId' : CarSearchResultConstants.nodeIdTires});
                            if(isTireNode){
                                nodes.childNodes.forEach(function(child){
                                    if(child.nodeId === CarSearchResultConstants.nodeIdTires){
                                        child.documents = vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo);
                                    }
                                })
                            }else{
                                nodes.childNodes.push(
                                    {
                                        codeParent : nodes.nodeId,
                                        documents : vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo),
                                        label : $translate.instant('TIRES_NODE_LABEL'),
                                        nodeId : CarSearchResultConstants.nodeIdTires,
                                        level : 3,
                                        rang : 0
                                    });
                            }

                            CacheService.setObject(CacheConstants.contextCarSearch, contextCarSearch);

                        }
                    })
            }

            if(vm.level2 && !_.isEmpty(vm.level2)){

                vm.level2.forEach(function(nodes){
                    var node2 = nodes.node;
                    if(_.includes(CarSearchResultConstants.nodeIdsAxleAssembly,node2.nodeId)){

                        var isTireNode = _.find(node2.childNodes, {'nodeId' : CarSearchResultConstants.nodeIdTires});
                            if(isTireNode){
                                node2.childNodes.forEach(function(child){
                                    if(child.nodeId === CarSearchResultConstants.nodeIdTires){
                                        child.documents = vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo);
                                    }
                                })
                            }else{
                                node2.childNodes.push(
                                    {
                                        codeParent : node2.nodeId,
                                        documents : vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo),
                                        label : $translate.instant('TIRES_NODE_LABEL'),
                                        nodeId : CarSearchResultConstants.nodeIdTires,
                                        level : 3,
                                        rang : 0
                                    });
                            }
                    }

                    var arrays = nodes.arrays;

                    arrays.forEach(function(node3Array){

                        node3Array.forEach(function(node3){

                            if(node3.nodeId === CarSearchResultConstants.nodeIdTires){
                                node3.documents = vm.tiresResponse && checkFieldsOfTires(vm.tyresInfo)
                            }

                        })
                    })

                })

            }

        });

        $scope.$on('$destroy', techCritDestroy);

        function checkFieldsOfTires(tyresInfo){

            return (tyresInfo && !_.isEmpty(tyresInfo) && (_.has(tyresInfo[0],'axleInfo') && !_.isEmpty(tyresInfo[0].axleInfo)
                || _.has(tyresInfo[0],'tyres') && !_.isEmpty(tyresInfo[0].tyres)));
        }

        $rootScope.$on('redirectDiagnostic', function (event, data) {
            if(data&&data.redirectDiagnostic)
            {
            $state.go(RoutesConstants.carSearchResult,{data:data});
            }
        });



        /**
         * Get level 2 and 3 nodes for a level 1 node from cache
         */
        function getNodesSecondAndThirdLevel(requestNodesFromCtrl, node) {
            vm.level2 = [];
            initFilter();
            var treeNodes;

            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            if(contextCarSearch && contextCarSearch.treeNodes){
                if (contextCarSearch.treeNodes.otherLevel != null || contextCarSearch.treeNodes.otherLevel != undefined) {
                    treeNodes = contextCarSearch.treeNodes.otherLevel;
                }
                else if (contextCarSearch.treeNodes.levelOne != null || contextCarSearch.treeNodes.levelOne != undefined) {
                    treeNodes = contextCarSearch.treeNodes.levelOne;
                }
            }
            if(treeNodes){
            var chilNodeLevel1 = null;
            if(vm.isClipRedirectionForNodes && !_.isEmpty(node_1)){
                chilNodeLevel1 = _.filter(treeNodes.nodes, function(item){
                    return item.codeParent == node_1;
                })
                if(!_.isEmpty(chilNodeLevel1)){
                    var nodeIndex = _.findIndex(contextCarSearch.treeNodes.levelOne.nodes, function (node) {
                        return node.nodeId === node_1;
                    });
                    vm.nodeSelect = nodeIndex;
                    vm.selectedLevel1 = contextCarSearch.treeNodes.levelOne.nodes[nodeIndex];
                } else {
                    chilNodeLevel1 = $filter("filter")(treeNodes.nodes, { "codeParent": requestNodesFromCtrl.nodeId });
                }
            } else {
                chilNodeLevel1 = $filter("filter")(treeNodes.nodes, { "codeParent": requestNodesFromCtrl.nodeId });
                if (vm.nissanUserURL) {
                    const excludedIds = ['N-21348'];
                    chilNodeLevel1 = chilNodeLevel1.filter(function (node) {
                        return excludedIds.indexOf(node.nodeId) === -1;
                    });
                }
            }
            var nodesLevel2And3 =
            {
                nodes: chilNodeLevel1,
                urlIllustration: treeNodes.urlIllustration
            };

            splitNodeLabel(nodesLevel2And3);
            if (nodesLevel2And3 == null) { // if error
                toastr.error('Error BACK :Error');
            } else { // if success
                var dataArboLevelTwoAndThree = nodesLevel2And3;
                vm.showSearchNav = true;
                vm.showSearchRef = false;
                vm.selectedLevel1 = node;
                for (var level in dataArboLevelTwoAndThree.nodes) {
                    var arrayChunk = getArrayChunk(dataArboLevelTwoAndThree.nodes[level].childNodes);
                    vm.level2.push({ "node": dataArboLevelTwoAndThree.nodes[level], "arrays": arrayChunk });
                }

                var i = 1;
                for (var index in vm.level2) {
                    if (vm.level2[index].node.urlVignette) {
                        vm.level2[index].node.urlVignette = vm.level2[index].node.urlVignette;
                    }
                    i++;
                }
                if (vm.hasToScroll && !vm.traficDiag) {
                    angular.element(document).ready(function () {
                        if ($state.params.data.node) {
                            scrollToNode($state.params.data.node);
                        }
                        /* else {
                          var nodeSelected = CacheService.getObject(CacheConstants.nodeSelect);
                          scrollToNode(nodeSelected);
                        }*/

                    });
                }
                vm.hasToScroll = false;

                vm.showExplodedButton = true;
                vm.level2.forEach(function(level2Node){
                    if(level2Node.node && level2Node.node.nbrDocumentsByType && level2Node.node.nbrDocumentsByType.INT_REPAIR && level2Node.node.nbrDocumentsByType.INT_REPAIR >= 1 ){
                        level2Node.node.interventionPresent = true;
                    }
                    else{
                        level2Node.node.interventionPresent = false;
                    }

                })
                if (vm.isIndependentUser && vm.doctypes.length !=4 ){
                    checkNodesforIndependent(treeNodes);
                }                
            }
            }
            if(vm.isClipRedirectionForNodes && nodesLevel2And3 && !_.isEmpty(nodesLevel2And3.nodes) && nodesLevel2And3.nodes[0].codeParent == node_1){
                if(!_.isEmpty(node_2) && !_.isEmpty(node_3)){
                    var node2Index = null;
                    if(nodesLevel2And3 && !_.isEmpty(nodesLevel2And3.nodes)){
                        node2Index = _.findIndex(nodesLevel2And3.nodes, function (node2) {
                            return node2.nodeId === node_2;
                        });
                    }
                    if(node2Index != -1 && !_.isEmpty(nodesLevel2And3.nodes[node2Index].childNodes)){
                        var node3Index = _.findIndex(nodesLevel2And3.nodes[node2Index].childNodes, function (node3) {
                            return node3.nodeId === node_3;
                        });
                        var nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === node_1;
                        });
                        vm.selectedLevel1 = vm.dataArboLevelOne.nodes[nodeIndex]; 
                        if(node3Index != -1){                            
                            VarAppBeforeGoToListePiece(nodesLevel2And3.nodes[node2Index],nodesLevel2And3.nodes[node2Index].childNodes[node3Index], nodesLevel2And3.nodes[node2Index].childNodes[node3Index]);
                        } else {
                            VarAppBeforeGoToListePiece(nodesLevel2And3.nodes[node2Index],null, nodesLevel2And3.nodes[node2Index]);
                        }                       
                    } else {
                        toastr.info($translate.instant("DOCUMENT_NOT_FOUND"));
                        nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === node_1;
                        });
                        vm.nodeSelect = nodeIndex != -1 ? nodeIndex : 0;
                    }
                } else if(!_.isEmpty(node_2)){
                    var node2Index = null;
                    if(nodesLevel2And3 && !_.isEmpty(nodesLevel2And3.nodes)){
                        node2Index = _.findIndex(nodesLevel2And3.nodes, function (node2) {
                            return node2.nodeId === node_2;
                        });
                    }
                    if(node2Index != -1){  
                        var nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === node_1;
                        });
                        vm.selectedLevel1 = vm.dataArboLevelOne.nodes[nodeIndex];                   
                        VarAppBeforeGoToListePiece(nodesLevel2And3.nodes[node2Index],null, nodesLevel2And3.nodes[node2Index]);
                    } else {
                        toastr.info($translate.instant("DOCUMENT_NOT_FOUND"));
                        nodeIndex = _.findIndex(vm.dataArboLevelOne.nodes, function (node) {
                            return node.nodeId === node_1;
                        });
                        vm.nodeSelect = nodeIndex != -1 ? nodeIndex : 0;
                    }                   
                } 
                vm.isClipRedirectionForNodes = false;
                node_1 = '';
                node_2 = '';
                node_3 = '';
                MainMetierService.setClipParameters(null);                   
            }       

        }

        function redirectToOts() {
            $mdDialog.hide();
            $state.go(RoutesConstants.carFeaturesView, { tabName: 'otsTab' });
        }

        function goToLevelTwoAndThree(node) {
            var requestNodesFromCtrl = {};
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            if(node)
                requestNodesFromCtrl.nodeId = node.nodeId;
            else if(contextCarSearch && contextCarSearch.treeNodes && contextCarSearch.treeNodes.levelOne && !_.isEmpty(contextCarSearch.treeNodes.levelOne.nodes[0]))
                requestNodesFromCtrl.nodeId = contextCarSearch.treeNodes.levelOne.nodes[0].nodeId;
            requestNodesFromCtrl.childNodes = true;
            getNodesSecondAndThirdLevel(requestNodesFromCtrl, node);
            vm.scrollToTopButtonClass = 'scrollToTopButtonHidden';
        }

        function changeStyleFields(indexInput, isFocused) {
            var property;
            vm.stateInit = true;

            if (indexInput == "motCle") {
                for (property in vm.stateInputsForm) {
                    if (vm.stateInputsForm && vm.stateInputsForm.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputsForm[property].active = true;
                                vm.stateInit = false;
                            } else {
                                vm.stateInputsForm[property].active = false;
                            }

                        } else {
                            vm.stateInputsForm[property].active = undefined;
                        }
                    }
                }
            }
            else {
                for (property in vm.stateInputSearch) {
                    if (vm.stateInputSearch && vm.stateInputSearch.hasOwnProperty(property)) {

                        if (isFocused) {
                            if (property == indexInput) {
                                vm.stateInputSearch[property].active = true;
                            } else {
                                vm.stateInputSearch[property].active = false;
                            }

                        } else {
                            vm.stateInputSearch[property].active = undefined;
                        }
                    }
                }
            }
        }

        function reinitFields(indexInput, isFocused) {
            if (isFocused && !vm.stateInputsForm[indexInput]) {
                if (indexInput === "dftcode") {
                    vm.dtcCode = {};
                    vm.symptom = {};
                    vm.diagnosticDTCCodeDropDownOpenClose = 'diagnosticDropDownClose';
                    vm.diagnosticSymptomCodeDropDownOpenClose = 'diagnosticDropDownClose';
                }
                else if (indexInput === "dtcode") {
                    vm.defaultCode = {};
                    vm.symptom = {};
                    vm.diagnosticDefaultCodeDropDownOpenClose = 'diagnosticDropDownClose';
                    vm.diagnosticSymptomCodeDropDownOpenClose = 'diagnosticDropDownClose';
                }
                else {
                    vm.defaultCode = {};
                    vm.dtcCode = {};
                    vm.diagnosticDefaultCodeDropDownOpenClose = 'diagnosticDropDownClose';
                    vm.diagnosticDTCCodeDropDownOpenClose = 'diagnosticDropDownClose';
                }
            }
        }

        function setSVG(url) {
            if (!url || !url.length) {
                vm.svg = null;
                return;
            }

            var svg = SvgCache.getSVG(url);
            if (svg) {
                vm.svg = svg;
                ScrollService.animateTo('#line_resultat_level2_and_3', 300);
            } else {
                blockUI.start();
                DocumentsWsService.getSVG2(url).then(function (res) {
                    SvgCache.addSVG(res, url);
                    vm.svg = res;
                    ScrollService.animateTo('#line_resultat_level2_and_3', 300);
                }, function (err) {
                    vm.svg = null;
                }).finally(function () {
                    blockUI.stop();
                });
            }
        }

        function initializeScroll() {
            angular.element($window).bind("scroll", function () {
                if (this.pageYOffset > 225) {
                    vm.scrolled = true;
                    vm.scrollToTopButtonClass = 'scrollToTopButtonShow';

                }
                else {
                    vm.scrolled = false;
                    vm.scrollToTopButtonClass = '';
                }
                $scope.$apply();
            });
        }

       /**initialise the filter with all values**/
       function initFilter() {
        if(vm.isNewSearchBar)
        {
            vm.selectedFilter = vm.newSearchFilter.id;
        }
        else
        {
            vm.selectedFilter = "All";
        }
        changeFilter(vm.selectedFilter);
    }

        //TODO test dans spec
        /**
         *
         * @param node
         * @returns {Array}
         */
        function getArrayChunk(node) {
            var result0 = [];
            var result1 = [];
            var result2 = [];
            var order = [];

            var j = 0;
            for (var i = 0; i < (node.length); i = i + 3) {
                if (node[i] != null) {
                    result0[j] = node[i];
                } else {
                    break;
                }
                if (node[i + 1] != null) {
                    result1[j] = node[i + 1];
                } else {
                    break;
                }
                if (node[i + 2] != null) {
                    result2[j] = node[i + 2];
                } else {
                    break;
                }
                j++;
            }

            order[0] = result0.slice(0, result0.length);
            order[1] = result1.slice(0, result1.length);
            order[2] = result2.slice(0, result2.length);

            return order;
        }

        function getNodeName(nodeIndex, isFromNode) {
            if(isFromNode){
                return nodeIndex;
            }
            else{
                return vm.dataArboLevelOne.nodes[nodeIndex].label;
            }
        }

        function scrollToNode(node) {
            vm.targetNode = node;
            var scrollTo = node;
            if (node.level == 1) {
                var elem = $window.document.getElementById("ArborescenceHeader");
                scrollTo = vm.level2[0].node;
            } else {
                var elem = $window.document.getElementById(scrollTo.nodeId);
                $('#' + scrollTo.nodeId).addClass("return");
            }
            var anchor = elem && $(elem).length !== 0 ? $(elem).offset().top : 0;
            $('html, body').animate({ scrollTop: anchor }, 300);
        }

        function goToDiagnosis() {
            $state.go(RoutesConstants.diagnosis);
        }

        function checkTMListPattern() {
            var regex = /^(([0-9a-zA-Z]{4})[,])*([0-9a-zA-Z]{4})$/;
            return (vm.motCle.length > 0) ? regex.test(vm.motCle) : true;
        }



        function isActive(tab){
            return vm.showDiagFilesView === tab;
        }

        function onOtsDialogClose() {
            $mdDialog.hide();
        }

        function independentProfilcheck() {
            if(vm.isNewSearchBar && !vm.showDiagnosticView && !vm.showSpecializedToolView && !vm.showconsultElectricalShema && !vm.showVehicleMultimediaInformation){
                if(vm.checkIndependentUser && vm.isAsomValidDocAccess==='false' && !vm.isCirSentVin){
                    return '';
                }
                else{
                    return 'searchBar_row';
                }
            }
            else {
                return 'small-5 medium-5 large-8 columns';
            }
        }

        function goToSearchEngine(){
            var searchDetails = CacheService.getObject(CacheConstants.searchEngineDetails);
            CacheService.setObject(CacheConstants.filter, {id: searchDetails.documentType});
            CacheService.setObject(CacheConstants.isSearchEngine,true);
            var carSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            carSearch.filteredTree = null;
            CacheService.setObject(CacheConstants.contextCarSearch, carSearch);
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            $state.go(RoutesConstants.listePieceViews, {
                isSearchEngine: true,
                documentType: ['newSearch'],
                plateIndex: 0,
                refIndex: 0,
                motCle:vm.motCle
            });
         }

        function checkInterventions(label, SIEIds,nodeId, nodeSelectIndex, isIntIdList, isFromMultipleNodeTree){ 
            SearchArboTextualMetierService.setConnectedServicesAuditData('Operation').then(function () {});
            blockUI.start();
            if(isIntIdList){
                CacheService.removeObject(CacheConstants.interventionIdList);
                CacheService.removeObject(CacheConstants.selectedInterventionId);
                var interventionIdList = SIEIds;
                CacheService.setObject(CacheConstants.interventionIdList, {interventionIds: interventionIdList, intLabel: label, intNodeId: nodeId, intNodeSelect: nodeSelectIndex, isIntClick: false, isIntTabClick: false});    
            }
            if(!isIntIdList && nodeSelectIndex){
                var intNodeSelected = CacheService.getObject(CacheConstants.intNodeSelected);
                goToLevelTwoAndThreeAndShowImage(intNodeSelected, nodeSelectIndex, true);
                goToLevelTwoAndThreeWithoutShowImageFirst(intNodeSelected, nodeSelectIndex, true);
            }
            if(!isFromMultipleNodeTree){
            SearchArboTextualMetierService.getInterventionById(SIEIds).then(function (response) {
                if(response && response.INT && !_.isEmpty(response.INT)){
                    var body = angular.element(document.body);
                    $mdDialog.show({
                        parent: body,
                        templateUrl: 'app/components/car/carSearchResult/easyBasket/easyBasketDetails.template.html',
                        controller: 'EBCtrl',
                        controllerAs: 'vm',
                        skipHide: true,
                        multiple: true,
                        bindToController: true,
                        clickOutsideToClose: true,
                        locals: {
                            data: response,
                            title : label,
                            nodeId : nodeId
                        }
                    });
                }
            }).catch(function(error){
                // show error toastr
            }).finally(function(){
                blockUI.stop();
            })
            }
            else{
                blockUI.stop();
            }
        }
        function onCancel(){
            $mdDialog.hide();
        }

        $rootScope.$on('closeOperation',function(){
            var interventionIdList = CacheService.getObject(CacheConstants.interventionIdList);
            if(interventionIdList && _.has(interventionIdList, 'isIntClick')){
                interventionIdList.isIntClick = true;
                CacheService.setObject(CacheConstants.interventionIdList, interventionIdList);
            }
            onCancel();
        });

	function checkNodesforIndependent(treeNodes) {
            treeNodes.nodes.forEach(function (node) {
                calcs(node, vm.doctypes);
                node.childNodes.forEach(function (item) {
                    if (item.nbrDocumentsByType) {
                        calcs(item, vm.doctypes);
                    }
                })
            })
        }

        function calcs(node, filterDocType) {
            if (filterDocType.length > 0) {
                for (var i = 0; i < filterDocType.length; i++) {
                    if ([filterDocType[i]] == 'MD') {
                        var obj;
                        if (typeMD == 'B3') {
                            obj = _.pick(node.nbrDocumentsByType, ['MD', 'MD_102', 'MD_108', 'MD_110', 'MD_111', 'MD_501', 'MD_502']);
                        } else {
                            obj = _.pick(node.nbrDocumentsByType, ['MD_104', 'MD_106', 'MD_109', 'MD_B2']);
                        }
                        if (_.sum(_.values(obj)) > 0) {
                            node.documents = true;
                            break;
                        }
                        else {
                            node.documents = false;
                        }
                    }
                    else if (node.nbrDocumentsByType[filterDocType[i]] > 0) {
                        node.documents = true;
                        break;
                    }
                    else {
                        node.documents = false;
                    }
                }
            } else {
                node.documents = false;
            }
        }
        function checkNode2HorseUser(nodeId){
            return CarSearchResultConstants.node2HorseList.includes(nodeId);
        }

        function computeAndCacheAllowedPRDocumentsForHorse(contextCarSearch) {
            var allowedNodeIds = ['N-21947', 'N-22009', 'N-21901']; // Engine, Gearbox, Wiring
            var prDocumentIds = [];
            var allNodes = contextCarSearch.treeNodes.otherLevel.nodes;

            allNodes.forEach(function (level2Node) {
                if (allowedNodeIds.indexOf(level2Node.codeParent) !== -1) {
                    if (level2Node.idsDocumentsByType && level2Node.idsDocumentsByType.PR) {
                        prDocumentIds = prDocumentIds.concat(level2Node.idsDocumentsByType.PR);
                    }

                    var level3Nodes = findChildNodesByCodeParent(allNodes, level2Node.nodeId);
                    level3Nodes.forEach(function (level3Node) {
                        if (level3Node.idsDocumentsByType && level3Node.idsDocumentsByType.PR) {
                            prDocumentIds = prDocumentIds.concat(level3Node.idsDocumentsByType.PR);
                        }
                    });
                }
            });

            var uniquePrDocuments = _.uniq(prDocumentIds);
            CacheService.setObject(CacheConstants.allowedPrDocumentsForHorse, {
                vin: contextCarSearch.vehicle ? contextCarSearch.vehicle.vin : null,
                allowedPrDocuments: uniquePrDocuments
            });
        }

        function findChildNodesByCodeParent(allNodes, parentNodeId) {
            var childNodes = [];

            allNodes.forEach(function (node) {
                if (node.codeParent === parentNodeId) {
                    childNodes.push(node);
                }

                if (node.childNodes && node.childNodes.length > 0) {
                    node.childNodes.forEach(function (childNode) {
                        if (childNode.codeParent === parentNodeId) {
                            childNodes.push(childNode);
                        }
                    });
                }
            });

            return childNodes;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.questionning, {
        url: '/questionning',
        templateUrl: 'app/components/car/questionning/questionning.html',
        params: {
          data:null
        },
        controller: 'questionningCtrl',
        controllerAs: 'vm'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('questionningCtrl', questionningCtrl);

  /** @ngInject */
  function questionningCtrl($state,RoutesConstants) {
    var vm = this;
    vm.cancel = goToCarSearch;

    if ($state && $state.params && $state.params.data) {
      vm.data = $state.params.data;
      vm.document = $state.params.documentType;

   }

    function goToListePiece(){
      $state.go(RoutesConstants.listePieceViews,
        {
          data: vm.data,
          documentType: vm.document
        });
    }
    function goToCarSearch(){
      $state.go(RoutesConstants.carSearchResult);

    }
    function init() {
    vm.goToListePiece = goToListePiece;

    }

    init();

  }
})();

(function () {
    'use strict';
    angular.module('phenix').config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.diagnosis, {
            url: '/diagnoses',
            templateUrl: 'app/components/car/rLinkCar/diagnosis/diagnosis.template.html',
            controller: 'DiagnosisController',
            controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.diagnosisProcess, {
            url: '/diagnoses/:type/:idDiag/:idNode',
            templateUrl: 'app/components/car/rLinkCar/diagnosis/diagnosis.template.html',
            controller: 'DiagnosisController',
            controllerAs: 'vm',
            params: {
                isDiagnosis: true,
                data: null
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('rLinkCar', {
            bindings: {},
            controller: RLinkCarController,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/rLinkCar.template.html'
        });

    function RLinkCarController(
        rLinkConstant,
        RLinkCarMetierService,
        rLinkMenu,
        easyLinkMenu,
        $rootScope,
        $translate,
        RoutesConstants,
        $state,
        toastr,
        blockUI,
        CacheService,
        CacheConstants,
        configConstantes,
        easyLinkMenuNew,
        rLinkMenuNew,
        rLinkMenuExpanded,
        rlinkMenuNewExpanded,
        easyLinkMenuNewExpanded,
        vegasEasylinkMenuExpanded,
        easyLinkMenuExpanded,
        UtilsMetierService,
        ActisConstantes,DocumentsWsService,
        vegasEasylinkMenu,rlinkEVMenuExpanded,rlinkEVSmartChargeExpanded,ddpAdministration,ddphelpExpanded,
        vegasRlinkMenu,$timeout,$scope,
        SearchArboTextualMetierService,RLinkCarWSService, $q,connectedServicesOffers, DocumentsMetierService, DiagFileBusinessService, systemDocumentationConstants, ResultSearchByDiagnosticMetierService,MainMetierService,$mdDialog,CloudFrontUrlHelper

    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.loadingIcon = false;
        vm.connectionStatus = {};
        vm.expandMenuReset = [rLinkMenuNew, easyLinkMenuNew, vegasEasylinkMenu, easyLinkMenu, rLinkMenu, rlinkMenuNewExpanded, easyLinkMenuNewExpanded, vegasEasylinkMenuExpanded, easyLinkMenuExpanded, rLinkMenuExpanded, vegasRlinkMenu, rlinkEVMenuExpanded, rlinkEVSmartChargeExpanded,ddpAdministration,ddphelpExpanded,connectedServicesOffers];
        resetConstantsMenu(vm.expandMenuReset);
        vm.profile = UtilsMetierService.getProfile();
                    if (!_.isEmpty(vm.profile.roles)) {
                        vm.profile.roles = vm.profile.roles.map(function (e) {
                            return e.toUpperCase()
                        });
                    }
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        vm.isFodEnable = JSON.parse(configConstantes.isFodEnable);
    function isArcaCustomerCare(profile) {
        return profile.userType === "ARCA" &&
            !_.isEmpty(profile.roles) &&
            profile.roles.includes(rLinkConstant.arcaCnrCustomerCare);
    }

    function isRnetUser(profile) {
        return profile.userType === "RNET" && !_.isEmpty(profile.roles);
    }

    function hasRnetCare(profile) {
        return isRnetUser(profile) && profile.roles.includes(rLinkConstant.rnetCnrCustomerCare);
    }

    function hasRnetDealer(profile) {
        return isRnetUser(profile) && profile.roles.includes(rLinkConstant.rnetCnrDealer);
    }

    function isRnetLightUser(profile) {
        return isRnetUser(profile) && vm.isPpxLightUser;
    }

    function isSpecialUserRole(profile) {
        if (_.isEmpty(profile)) {
            return false;
        }
        const isArca = isArcaCustomerCare(profile);
        const isRnet = hasRnetCare(profile) || hasRnetDealer(profile) || isRnetLightUser(profile);
        return isArca || isRnet;
    }

    if (isSpecialUserRole(vm.profile)) {
        vm.showLoaderIcon = true;
        $timeout(function () {
            RLinkCarMetierService.setHideHeader(false);
        }, 100);
    }
        vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
        vm.hasCcsArch = hasCcsArchitecture(vm.connectedPlatform);
        vm.isEasyLink = (vm.connectedPlatform !== null && (vm.connectedPlatform.platform === "EASYLINK" || vm.connectedPlatform.platform === 'AVN' || vm.connectedPlatform.platform === 'CVC' || vm.connectedPlatform.platform === 'RGDC'));
        vm.user = CacheService.getUserProfile();
        vm.vehicleInformationDisplay = UtilsMetierService.vehicleInformationDisplay(vm.user);
        vm.ddpHelpTabDisplay = UtilsMetierService.ddpHelpPageDisplay(vm.user);
        vm.adasEhorizonInformationDisplay = UtilsMetierService.adasEhorizonInformationDisplay(vm.user);
        vm.vegasTabDisplay = UtilsMetierService.vegasTabDisplay(vm.user);
        if(!vm.vehicleInformationDisplay && !vm.vegasTabDisplay){
            vm.menu = vm.isEasyLink ? easyLinkMenu : rLinkMenu;
            if(vm.isEasyLink){
                vm.oldEasyLinkTabs = true;
            }
            else{
                vm.oldRlinkTabs = true;
            }
        }
        else if(!vm.vehicleInformationDisplay && vm.vegasTabDisplay){
            vm.menu = vm.isEasyLink ? vegasEasylinkMenu : vegasRlinkMenu;
            vm.connectedServiceOfferTab = connectedServicesOffers;
            if(vm.isEasyLink){
                vm.newVegasEasyLinkTabs = true;
            }
            else{
                vm.newRlinkTabs = true;
            }
        }
        if(vm.vehicleInformationDisplay && vm.vegasTabDisplay){
            vm.menu = vm.isEasyLink ? easyLinkMenuNew : rLinkMenuNew;
            vm.connectedServiceOfferTab = connectedServicesOffers;
            if(vm.isEasyLink){
                vm.newEasyLinkTabs = true;
            }
            else{
                vm.newRlinkTabs = true;
            }
        }
        vm.evServicesTab = false;
        vm.showAudit = false;
        vm.showUserGuide = false
        expandConnectedInfo();
        const startingNode = 0;

        vm.selectNode = selectNode;
        vm.selectConnectInfo = selectConnectInfo;
        vm.getCarData = getCarData;
        vm.translateMenu = translateMenu;
        vm.translateMenuNew = translateMenuNew;
        vm.selectedSubMenu = selectedSubMenu;

        // vehicle informations
        vm.vehicleInformationsData = vehicleInformationsData;
        vm.vehicleInformationsEasyLinkData = vehicleInformationsEasyLinkData;
        vm.vehicleInformations = {};

        // subscriptions and services
        vm.subscriptionAndServicesData = subscriptionAndServicesData;
        vm.subscriptionAndServicesEasyLinkData = subscriptionAndServicesEasyLinkData;
        vm.subscriptionAndServices = {};

        // update campaigns
        vm.agregateUpdateCampaigns = agregateUpdateCampaigns;
        vm.updateCampaigns = [];

        //dataConsistency
        vm.dataConsistencyData = dataConsistencyData;
        vm.dataConsistencyDataEasyLinkData = dataConsistencyDataEasyLinkData;
        vm.dataConsistencies = {};
        vm.virtualKeyData = {};
        vm.uidTitle = '';

        vm.hideDiagnosisAcces = true;
        vm.accordions = { dataConsistencies: {}, adasEhorizonContracts: {}, adasEhorizonDiagnostic: {}, adasEhorizonEventHistory: {}, virtualKey: {} };
        vm.cvc = rLinkConstant.cvc;
        vm.bvm = rLinkConstant.bvm;
		vm.bva = rLinkConstant.bva;
        vm.ccs3Architecture = vm.connectedPlatform && vm.connectedPlatform.architecture && vm.connectedPlatform.architecture.toLowerCase() === 'ccs3';
        vm.vnext = rLinkConstant.vnext;
        vm.vcps = rLinkConstant.vcps;
        vm.noTcu = false;
        vm.noHu = false;
        vm.threeHuValuesEqual = false;
        vm.threeTcuValuesEqual = false;
        vm.isDataConsistency = false;
        vm.isAdasEhorizon = false;
        vm.isCnrUserGuide = false;
        vm.isRemoteServicesEnabled = JSON.parse(configConstantes.isRemoteServicesEnabled);
        vm.isAdasTab = false;
        vm.isVirtualTab = false;
        vm.isVirtualKey = false;
        vm.isDdpHelpTab = false;
        vm.isDdpGenericDiagTab = false;
        const userType = CacheService.getUserProfile().userType;
        vm.checkIfNoTcuHu = checkIfNoTcuHu;
        vm.refreshData = refreshData;
        vm.checkConnectivityDevices = checkConnectivityDevices;
        vm.goToUserGuidePage = goToUserGuidePage;
        vm.goToCnrUserGuidePage = goToCnrUserGuidePage;
        vm.goToCnrUserGuideLatam = goToCnrUserGuideLatam;
        vm.goToCnrUserGuideGeneral = goToCnrUserGuideGeneral;
        vm.goToGenericDiagnosisPage = goToGenericDiagnosisPage;
        vm.rLinkConstant = rLinkConstant;
        vm.formatFileName = formatFileName;
        const fileAvailableList = rLinkConstant.fileList;
        vm.userLanguage =  fileAvailableList.includes(vm.user.language) ? vm.user.language : 'en';
        vm.ndHelpDocUrl = configConstantes.ndHelpUrl + '/ndHelp/';
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        
        // Configuration object for language-specific user guides
        const cnrUserGuideConfig = {
            'fr': [rLinkConstant.cnrFrUserGuide],
            'es': [rLinkConstant.cnrEsUserGuide, rLinkConstant.cnrEsUserGuide1],
            'pl': [rLinkConstant.cnrPlUserGuide],
            'ro': [rLinkConstant.cnrRoUserGuide],
            'de': [rLinkConstant.cnrDeUserGuide]
        };
        
        $scope.$on("enableLoader", function (event, value) {
            vm.loadingIcon = value;
            
        });

        $scope.$on("smartChargingLabelUpdated", function (event, label) {
            if (vm.evServicesMenu && vm.evServicesMenu[4]) {
                vm.evServicesMenu[4].track = label;
                vm.evServicesMenu[4].dynamicLabel = label;
            }
        });

        vm.refreshPrivacyData = refreshPrivacyData;
        vm.displaySettings = false;

        function openSecurePdfPopup(pdfUrl) {
            $mdDialog.show({
                controller: securePdfController,
                template: 
                    '<md-dialog class="secure-pdf-dialog" style="width: 90vw; height: 90vh; max-width: 1200px;">' +
                    '  <md-toolbar style="background-color: #978B7F; color: #FFFFFF;">' +
                    '    <div class="md-toolbar-tools">' +
                    '      <h2 style="color: #FFFFFF;">{{ "GENERIC_DIAGNOSIS" | translate }}</h2>' +
                    '      <span flex></span>' +
                    '      <md-button class="md-icon-button" ng-click="closeDialog()" style="color: #FFFFFF;">' +
                    '        <em class="fa fa-close"></em>' +
                    '      </md-button>' +
                    '    </div>' +
                    '  </md-toolbar>' +
                    '  <md-dialog-content style="height: calc(100% - 64px); overflow: hidden; position: relative;">' +
                    '    <div style="position: relative; width: 100%; height: 100%; overflow: hidden;">' +
                    '      <iframe id="securePdfFrame" ng-src="{{trustedUrl}}" ' +
                    '              style="width: 100%; height: 100%; border: none; position: absolute; top: 0; left: 0;"></iframe>' +
                    '      <div id="pdfOverlay" style="position: absolute; top: 0; left: 0; width: calc(100% - 20px); height: 100%; background: rgba(255, 255, 255, 0.01); z-index: 1000;"></div>' +
                    '    </div>' +
                    '  </md-dialog-content>' +
                    '</md-dialog>',
                locals: {
                    pdfUrl
                },
                clickOutsideToClose: false,
                escapeToClose: true,
                fullscreen: true
            });
        }

        function securePdfController($scope, $mdDialog, $sce, pdfUrl) {
            const KEY_CODE_P = 80;
            const KEY_CODE_S = 83;
            const KEY_CODE_PRINTSCREEN = 44;
            
            $scope.trustedUrl = $sce.trustAsResourceUrl(pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH');
            
            $scope.closeDialog = function() {
                $mdDialog.hide();
            };

            function handlePrintShortcut(e) {
                if ((e.ctrlKey || e.metaKey) && (e.key === 'p' || e.keyCode === KEY_CODE_P)) {
                    e.preventDefault();
                    e.stopPropagation();
                    toastr.warning($translate.instant('PRINT_DISABLED'));
                    return true;
                }
                return false;
            }

            function handleSaveShortcut(e) {
                if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.keyCode === KEY_CODE_S)) {
                    e.preventDefault();
                    e.stopPropagation();
                    toastr.warning($translate.instant('DOWNLOAD_DISABLED'));
                    return true;
                }
                return false;
            }

            function handlePrintScreen(e) {
                if (e.key === 'PrintScreen' || e.keyCode === KEY_CODE_PRINTSCREEN) {
                    e.preventDefault();
                    toastr.warning($translate.instant('SCREENSHOT_DISABLED'));
                    return true;
                }
                return false;
            }

            function handleWindowsScreenshot(e) {
                if (e.shiftKey && e.key === 'S' && e.metaKey) {
                    e.preventDefault();
                    toastr.warning($translate.instant('SCREENSHOT_DISABLED'));
                    return true;
                }
                return false;
            }

            function handleMacScreenshot(e) {
                const isMacScreenshot = e.metaKey && e.shiftKey;
                const isScreenshotKey = e.key === '3' || e.key === '4' || e.key === '5';
                if (isMacScreenshot && isScreenshotKey) {
                    e.preventDefault();
                    toastr.warning($translate.instant('SCREENSHOT_DISABLED'));
                    return true;
                }
                return false;
            }

            const preventPrintAndScreenshot = function(e) {
                if (handlePrintShortcut(e)) {
                    return false;
                }
                if (handleSaveShortcut(e)) {
                    return false;
                }
                if (handlePrintScreen(e)) {
                    return false;
                }
                if (handleWindowsScreenshot(e)) {
                    return false;
                }
                if (handleMacScreenshot(e)) {
                    return false;
                }
            };
            
            const preventContextMenu = function(e) {
                e.preventDefault();
                e.stopPropagation();
                toastr.warning($translate.instant('RIGHT_CLICK_DISABLED'));
                return false;
            };

            // Add event listeners to document
            document.addEventListener('keydown', preventPrintAndScreenshot, true);
            document.addEventListener('contextmenu', preventContextMenu, true);

            const style = document.createElement('style');
            style.textContent = 
                '.secure-pdf-dialog { user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; } ' +
                '.secure-pdf-dialog * { -webkit-touch-callout: none; -webkit-user-drag: none; } ' +
                '#pdfOverlay { pointer-events: auto; cursor: default; }';
            document.head.appendChild(style);

            $scope.$on('$destroy', function() {
                document.removeEventListener('keydown', preventPrintAndScreenshot, true);
                document.removeEventListener('contextmenu', preventContextMenu, true);
                
                if (style && style.parentNode) {
                    style.parentNode.removeChild(style);
                }
            });
        }        
        
        
        /*=============================================
       =                 FUNCTIONS                   =
       =============================================*/

        // Helper functions for smart charge eligibility
        function hasArcaTechRoles(userProfile) {
            if (userProfile.userType !== "ARCA") {
                return false;
            }
            return true;
        }
        
        // Wrappers to avoid function declarations in blocks and duplicate code
        function isArcaCnrCustomerCareWrapper(profile) {
            // Use the top-level isArcaCustomerCare function for logic
            return isArcaCustomerCare(profile);
        }
        
        function isRnetCnrWrapper(profile) {
            // Use the top-level hasRnetCare, hasRnetDealer, or isRnetLightUser for logic
            return (
                profile.userType === "RNET" &&
                !_.isEmpty(profile.roles) &&
                (profile.roles.includes(rLinkConstant.rnetCnrCustomerCare) ||
                 profile.roles.includes(rLinkConstant.rnetCnrDealer) ||
                 vm.isPpxLightUser)
            );
        }

        function hasRnetAccess(userProfile) {
            if (userProfile.userType !== "RNET" || _.isEmpty(userProfile.roles)) {
                return false;
            }
            const hasOktaAccess = !vm.nissanUserURL && userProfile.roles.includes(ActisConstantes.actis_okta);
            const hasCareAccess = userProfile.roles.includes(rLinkConstant.rnetCnrCustomerCare);
            return hasOktaAccess || hasCareAccess;
        }

        function checkUserForSmartCharge(userProfile) {
            if (hasArcaTechRoles(userProfile)) {
                return true;
            }
            if (userProfile.userType === "ASOM" && $rootScope.asomDocList['CS']) {
                return true;
            }
            if (hasRnetAccess(userProfile)) {
                return true;
            }
            return false;
        }

        function setupAuditDisplay(profile) {
            vm.ddpAuditTabDisplay = UtilsMetierService.ddpAuditTabDisplay(profile);
            if (vm.ddpAuditTabDisplay) {
                vm.showAudit = true;
                vm.showAdminMenu = ddpAdministration;
            }
        }

        function shouldRemoveUserGuide(profile) {
            if (profile.userType !== "ASOM" || !$rootScope.asomDocList['CS']) {
                return false;
            }
            return vm.helpDdpMenu && vm.helpDdpMenu[1] && vm.helpDdpMenu[1].name === 'userGuide';
        }

        function setupUserGuideDisplay(profile) {
            const isHelpDisplayUser = vm.ddpHelpTabDisplay || (profile.userType === "ASOM" && $rootScope.asomDocList['CS']);
            const hasCcsArch = vm.connectedPlatform && vm.connectedPlatform.architecture && (vm.connectedPlatform.architecture.toLowerCase() === 'ccs1' || vm.connectedPlatform.architecture.toLowerCase() === 'ccs2');
            if (isHelpDisplayUser && hasCcsArch) {
                vm.showUserGuide = true;
                vm.helpDdpMenu = ddphelpExpanded;
                if (shouldRemoveUserGuide(profile)) {
                    delete vm.helpDdpMenu[1];
                }
            }
        }

        function isAuthorizedForEVServices(profile) {
            if (!profile) {
                return false;
            }
            const isArcaOrRnet = profile.userType === "ARCA" || profile.userType === "RNET";
            const isAsomWithDocs = profile.userType === "ASOM" && $rootScope.asomDocList['CS'];
            return isArcaOrRnet || isAsomWithDocs;
        }

        function normalizeProfileRoles(profile) {
            if (!_.isEmpty(profile.roles)) {
                profile.roles = profile.roles.map(function (e) {
                    return e.toUpperCase()
                });
            }
        }

        function hasCcsArchitecture(connectedPlatform) {
            if (!connectedPlatform || !connectedPlatform.architecture) {
                return false;
            }
            const arch = connectedPlatform.architecture.toLowerCase();
            return arch === 'ccs1' || arch === 'ccs2' || arch === 'ccs3';
        }

        function getObjCriteria(carContext) {
            if (!carContext || !carContext.fixedCriterias || _.isEmpty(carContext.fixedCriterias)) {
                return null;
            }
            return carContext.fixedCriterias["019"] || null;
        }

        function isEVVehicle(connectedPlatform, carContext) {
            if (!hasCcsArchitecture(connectedPlatform)) {
                return false;
            }
            const objCriteria = getObjCriteria(carContext);
            return objCriteria && (objCriteria === "ELECX" || objCriteria === "ELEC");
        }

        function hasAnyEvServiceFeature(response) {
            const services = response && response.subscriptions && response.subscriptions.commercialServices;
            if (!Array.isArray(services)) {
                return false;
            }
            const evFeatureUids = ['743', '701', '976', '364', '955'];
            return services.some(function (service) {
                return Array.isArray(service.features) && service.features.some(function (feature) {
                    return evFeatureUids.includes(String(feature.uid));
                });
            });
        }

        function setupEVServicesMenu(profile) {
            if (!isAuthorizedForEVServices(profile)) {
                return;
            }
            normalizeProfileRoles(profile);
            const carContext = CacheService.getCarContext();
            vm.connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
            const response = vm.easyLinkResponse || vm.rLinkResponse;
            if (isEVVehicle(vm.connectedPlatform, carContext) || hasAnyEvServiceFeature(response)) {
                vm.evServicesTab = true;
                const isSmartChargeUser = checkUserForSmartCharge(profile);
                vm.evServicesMenu = isSmartChargeUser ? rlinkEVSmartChargeExpanded : rlinkEVMenuExpanded;
            }
        }

        function checkUid(services) {
            if (_.isEmpty(services)) {
                return false;
            }
            let hasHereNavigationUid = false;
            services.forEach(function (service) {
                const features = service.features || [];
                const hasAdas = Array.isArray(features) && features.some(function (feature) {
                    return ['4025', '4026', '4027', '4028', '4029'].includes(String(feature.uid));
                });
                
                if (hasAdas) {
                        hasHereNavigationUid = true;
                        vm.hereTabActivated = true;  
                        hereNaviStatus(); 
                        hereNaviSubscription();             
                }
            });
            return hasHereNavigationUid;
        }

        function checkAdasInServices(services) {
            if (_.isEmpty(services)) {
                return false;
            }
            
            let foundUid920 = false;
            services.forEach(function (service) {
                const features = service.features || [];
                const hasAdas = Array.isArray(features) && features.some(f => f.uid === '920');
                
                if (hasAdas) {
                    const adasFeature = features.find(f => f.uid === '920');
                    if (adasFeature && adasFeature.status === 'ACTIVATED') {
                        vm.isAdasActivated = true;
                    }
                    vm.isAdasTab = true;
                    foundUid920 = true;
                    getAdasEhorizonDetails();
                }
            });
            
            return foundUid920;
        }

        function setupHereNavigationTab(){
             if (_.isEmpty(vm.vehicleInformations) || _.isEmpty(vm.vehicleInformations.subscriptionInformation)) {
                return;
            }
             vm.hereTabActivated = false;
            const subscriptionInfo = vm.vehicleInformations.subscriptionInformation;
            
            checkUid(subscriptionInfo.commercialServices);
        }

        function setupAdasTab() {
            if (_.isEmpty(vm.vehicleInformations) || _.isEmpty(vm.vehicleInformations.subscriptionInformation)) {
                return;
            }
            
            vm.isAdasActivated = false;
            const subscriptionInfo = vm.vehicleInformations.subscriptionInformation;
            
            const foundInCommercial = checkAdasInServices(subscriptionInfo.commercialServices);
            if (!foundInCommercial) {
                checkAdasInServices(subscriptionInfo.technicalServices);
            }
        }

         function isSpecialUserRoleOnInit() {
                const isArcaCare = !_.isEmpty(vm.profile) && vm.profile.userType === "ARCA" && !_.isEmpty(vm.profile.roles) && vm.profile.roles.includes(rLinkConstant.arcaCnrCustomerCare);
                const isRnetUserFlag = vm.profile.userType === "RNET" && !_.isEmpty(vm.profile.roles);
                const isRnetCare = isRnetUserFlag && (vm.profile.roles.includes(rLinkConstant.rnetCnrCustomerCare) || vm.profile.roles.includes(rLinkConstant.rnetCnrDealer) || vm.isPpxLightUser);
                return isArcaCare || isRnetCare;
            }

        this.$onInit = function (params) {   
            resetMenu();
            if (isSpecialUserRoleOnInit()) {
                vm.menu[1].show = true;
             
            }
            if (params && params.fromEligibleRedirect) {
                vm.wasEligibleRedirect = true;
            }
            else{
                vm.wasEligibleRedirect = false;
            }
            getCarData(vm.wasEligibleRedirect).then(function() {
                configureAccordions();
                const profile = UtilsMetierService.getProfile(); 
                
                setupAuditDisplay(profile);
                setupUserGuideDisplay(profile);
                setupEVServicesMenu(profile);
                
                RLinkCarMetierService.applicabilityService().then(function(data) {
                    RLinkCarMetierService.setAdasData(data);
                    if (!_.isEmpty(data) && data.features) {
                        data.features.forEach(function(feature) {
                            if (feature.featureId === '920') {
                                return;
                            }
                        })
                    }
                });
                
                setupAdasTab();
                setupHereNavigationTab();

                if(!_.isEmpty(vm.vehicleInformations) && !_.isEmpty(vm.vehicleInformations.subscriptionInformation) && !_.isEmpty(vm.vehicleInformations.subscriptionInformation.commercialServices)){
                    vm.isVirtualKeyB2C = false;
                    vm.isVirtualKeyB2B = false;
                    vm.vehicleInformations.subscriptionInformation.commercialServices.forEach(function(vkid){
                        if(vkid && vkid.sid && (vkid.sid === '20000591' || vkid.sid === '20000556')){
                            vm.isVirtualTab = true;
                            if(vkid.sid === '20000591'){
                                vm.isVirtualKeyB2C = true;
                            }
                            if(vkid.sid === '20000556'){
                                vm.isVirtualKeyB2B = true;
                            }
                        }
                    });
                }
            });
        }

        function goToUserGuidePage(){
            const userGuideUrl = vm.ndHelpDocUrl + vm.userLanguage + '/User_Guide.pdf';
            const signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(userGuideUrl);
            window.open(signedUrl);
        }

        function openUserGuideFiles(userGuideFiles, lang) {
            if (!vm.user || !vm.user.language) return;
            
            const language = lang || vm.user.language.toLowerCase();
            userGuideFiles.forEach(function(userGuideFile) {
                const userGuideUrl = vm.ndHelpDocUrl + (cnrUserGuideConfig[language] ? language : 'en') + userGuideFile;
                const signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(userGuideUrl);
                window.open(signedUrl);
            });
        }

        function goToCnrUserGuidePage(){ 
            if (!vm.user || !vm.user.language) return;
            
            const lang = vm.user.language.toLowerCase();
            const userGuideFiles = cnrUserGuideConfig[lang] || [rLinkConstant.cnrEnUserGuide];
            openUserGuideFiles(userGuideFiles);
        }

        function goToCnrUserGuideLatam() {
            openUserGuideFiles([rLinkConstant.cnrEsUserGuide]);
        }

        function goToCnrUserGuideGeneral() {
            openUserGuideFiles([rLinkConstant.cnrEsUserGuide1]);
        }

        function formatFileName(fileName) {
            return fileName ? fileName.replace(/^\//, '').replace(/\.pdf$/, '') : '';
        }
 
        function goToGenericDiagnosisPage() {
            if (userType === "ASOM" && $rootScope.asomDocList['CS']) {
                const genericMethodUrl = vm.ndHelpDocUrl + vm.userLanguage + rLinkConstant.genericMethodDoc;
                const genericMethodEnUrl = vm.ndHelpDocUrl + 'en' + rLinkConstant.genericMethodDoc;
                DocumentsWsService.getSVG2(genericMethodUrl)
                .then(function () {
                    const signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(genericMethodUrl);
                    openSecurePdfPopup(signedUrl);
                }).catch(function () {
                    const signedUrl = CloudFrontUrlHelper.appendCloudFrontParams(genericMethodEnUrl);
                    openSecurePdfPopup(signedUrl);
                });

            } else {
                const genericElementId = rLinkConstant.genericElementId;
                if (!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.contributors)) {
                    var selectedGenericUserDoc = _.filter(vm.selectedSystemDoc.contributors, function (system) {
                        if (!_.isEmpty(system) && !_.isEmpty(system.contributor)) {
                            if (system.contributor === genericElementId) {
                                return system;
                            }
                        }
                    });
                }
                const systemDocDetails = {
                    "isSystemDocEnable": true,
                    "systemId": (!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.system)) ? vm.selectedSystemDoc.system : ""
                };
                _.extend(systemDocDetails, {
                    contributor: genericElementId
                });
                CacheService.setObject(CacheConstants.systemDocDetails, systemDocDetails);
                if (!_.isEmpty(selectedGenericUserDoc) && !_.isEmpty(selectedGenericUserDoc[0]) && !_.isEmpty(selectedGenericUserDoc[0].mdDocuments) && !_.isEmpty(selectedGenericUserDoc[0].mdDocuments[0]) && !_.isEmpty(selectedGenericUserDoc[0].mdDocuments[0].paramURL)) {
                    var genericId = selectedGenericUserDoc[0].mdDocuments[0].paramURL;
                }
                localStorage.setItem('isMDInNewTab', true);
                const url = $state.href(RoutesConstants.newTabMD, { id: genericId });
                window.open(url, '_blank');
            }
        }

        function configureAccordions() {
            // Techliner
            if(userType === 'ARCA' || userType === 'RNET' || (userType === "ASOM" && $rootScope.asomDocList['CS'])) {
                vm.accordions.dataConsistencies.isOpen = true;
                vm.accordions.adasEhorizonContracts.isOpen = true;
                vm.accordions.adasEhorizonDiagnostic.isOpen = true;
                vm.accordions.adasEhorizonEventHistory.isOpen = true; 
                vm.accordions.virtualKey.isOpen = true;
            }            
        }

        function checkIfNoTcuHu(data){
            return !data.present;
        }

        function refreshData(){
            blockUI.start();
            RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                emitPrivacyType(data);
                vm.dataConsistencyDataEasyLinkData(data);
            }).catch(function () {
            }).finally(function () {
                blockUI.stop();
            });
        }

        function emitPrivacyType(data) {
            if (data && data.vehicle && data.vehicle.privacyType) {
                $rootScope.$emit('privacyType', data.vehicle.privacyType);
            }
        }        

        function selectNode(node) {
            RLinkCarMetierService.setHideHeader(false);
            vm.connectedInfoIsOpen = true;
            vm.hereNavigationSelected = false;
            resetMenu();
            vm.expandMenuReset = [rLinkMenuNew, easyLinkMenuNew, vegasEasylinkMenu, easyLinkMenu, rLinkMenu, rlinkMenuNewExpanded, easyLinkMenuNewExpanded, vegasEasylinkMenuExpanded, easyLinkMenuExpanded, rLinkMenuExpanded, vegasRlinkMenu, rlinkEVMenuExpanded, rlinkEVSmartChargeExpanded,ddpAdministration,ddphelpExpanded,connectedServicesOffers];
            resetConstantsMenu(vm.expandMenuReset);
            if (vm.connectedInfoMenu && Array.isArray(vm.connectedInfoMenu)) {
                vm.connectedInfoMenu.forEach(function(item) {
                    item.show = false;
                });
            }
            if (vm.connectedServiceOfferTab && Array.isArray(vm.connectedServiceOfferTab)) {
                vm.connectedServiceOfferTab.forEach(function(item) {
                    item.show = false;
                });
            }
            vm.selectedMenu = null;
            vm.isDdpHelpTab = (vm.ddpHelpTabDisplay && vm.menu[node + 1] && vm.menu[node + 1].name === 'userGuide');
            vm.isDdpGenericDiagTab = (vm.ddpHelpTabDisplay && vm.menu[node + 1] && vm.menu[node + 1].name === 'genericDiagnosis');
                const id = node + 1;

                vm.menu[id].show = true;

            const isContractsTab = vm.menu[node + 1] && vm.menu[node + 1].name === 'contractsAndServices';
            const shouldAuditContracts = isContractsTab && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2';
            if (shouldAuditContracts) {
                SearchArboTextualMetierService.setConnectedServicesAuditData('CONTRACT_AND_SERVICES')
                    .then(function () { })
            }
            if (vm.vehicleInformationDisplay && (vm.menu[node + 1] && vm.menu[node + 1].name === 'dataConsistencies')) {
                vm.isDataConsistency = true;
                if (vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                    SearchArboTextualMetierService.setConnectedServicesAuditData('DATA_CONSISTENCY')
                        .then(function () { })
                }
            }
            else {
                vm.isDataConsistency = false;
            }
            if (vm.menu && !_.isEmpty(vm.menu[node + 1]) && vm.menu[node + 1].name && vm.menu[node + 1] === 'cnrUserGuide') {
                vm.isCnrUserGuide = true;
                RLinkCarMetierService.setHideHeader(true);
                if (vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                    SearchArboTextualMetierService.setConnectedServicesAuditData('CONNECTED_SERVICES_USER_GUIDE')
                        .then(function () { })
                }
            }
            else {
                vm.isCnrUserGuide = false;
            }
            if (vm.adasEhorizonInformationDisplay && (vm.menu[node+1] && vm.menu[node+1].name === 'connectedADASEhorizon')) {
                vm.isAdasEhorizon = true;
            }
            else {
                vm.isAdasEhorizon = false;
            }
            const isVirtualKeyTab = vm.menu[node + 1] && (vm.menu[node + 1].name === 'virtualKeyB2B' || vm.menu[node + 1].name === 'virtualKeyB2C');
            if (vm.isVirtualTab && vm.vehicleInformationDisplay && isVirtualKeyTab) {
                vm.isVirtualKey = true;
            }
            else{
                vm.isVirtualKey = false;
            }
            const isRlinkHeader = (vm.menu[node + 1].name === 'ConnectedServicesOffers') ? false : true;
            $rootScope.$emit('isRLinkHeader', isRlinkHeader);
            if (isRlinkHeader) {
                $timeout(function () {
                    if (vm.easyLinkResponse) {
                        shareConnectivityComponents(vm.easyLinkResponse);
                    }
                    else if (vm.rLinkResponse) {
                        shareRadio(vm.rLinkResponse);
                    }
                }, 100)
            } else {
                $rootScope.$broadcast('ConnectedServicesOffers', isRlinkHeader, 'isCurrentOffer');
                
                SearchArboTextualMetierService.setConnectedServicesAuditData('CONNECTED_SERVICES_OFFERS')
                        .then(function () { })
            }
        }

        function expandConnectedInfo(){
            vm.collapssed = true;
            if (vm.isEasyLink && vm.newEasyLinkTabs) {     
                    vm.connectedInfoMenu = easyLinkMenuNewExpanded;       
            }
            else if(vm.isEasyLink && vm.newVegasEasyLinkTabs){        
                    vm.connectedInfoMenu = vegasEasylinkMenuExpanded;              
            }
            else if(vm.isEasyLink && vm.oldEasyLinkTabs){     
                    vm.connectedInfoMenu = easyLinkMenuExpanded;              
            }
            else if(!vm.isEasyLink && vm.oldRlinkTabs){              
                    vm.connectedInfoMenu = rLinkMenuExpanded;               
            }
            else if(!vm.isEasyLink && vm.newRlinkTabs){             
                    vm.connectedInfoMenu = rlinkMenuNewExpanded;               
            }
        }

        function selectConnectInfo(){

            if (vm.isEasyLink && vm.newEasyLinkTabs) {
                if(vm.newEasyLinkTabs && vm.collapssed){
                    vm.connectedInfoMenu = easyLinkMenuNewExpanded;
                }
            }
            else if(vm.isEasyLink && vm.newVegasEasyLinkTabs){
                if(vm.newVegasEasyLinkTabs && vm.collapssed){
                    vm.connectedInfoMenu = vegasEasylinkMenuExpanded;
                }
            }
            else if(vm.isEasyLink && vm.oldEasyLinkTabs){
                if(vm.oldEasyLinkTabs && vm.collapssed){
                    vm.connectedInfoMenu = easyLinkMenuExpanded;
                }
            }
            else if(!vm.isEasyLink && vm.oldRlinkTabs){
                if(vm.oldRlinkTabs && vm.collapssed){
                    vm.connectedInfoMenu = rLinkMenuExpanded;
                }
            }
            else if(!vm.isEasyLink && vm.newRlinkTabs){
                if(vm.newRlinkTabs && vm.collapssed){
                    vm.connectedInfoMenu = rlinkMenuNewExpanded;
                }
            }
        }

        function getMDDocuments(mdIdList){
            blockUI.start();
            return $q.resolve().then(function(){
                return DocumentsMetierService.getMDList(mdIdList).then(function (result) {
                    return result;
                });
            }).catch(function (error) {
                toastr.error(error);
                return $q.reject();
            }).finally(function () {
                blockUI.stop();
            });
        }

        function getMDDocumentsIdList(selectedTab,systemList){
            return $q.resolve().then(function(){
                blockUI.start();
                const userContext = CacheService.getUserContext();
                const carContext = CacheService.getObject(CacheConstants.contextCarRequest);
                let subType = [];
                const contributor = [];
                const dtc = [];
                const system = [];
                const mdList = [];
                if(selectedTab === 0){
                    if(!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.contributors)){
                        vm.selectedSystemDoc.contributors.map(function (item) {
                            contributor.push(item.contributor);
                        });
                    }

                    if (!_.isEmpty(contributor)) {
                        subType = systemDocumentationConstants.elementSubType;
                    }
                }
                const docTypeParam = {
                    "MD": {
                        "subType": subType,
                        "systems": system,
                        "contributors": contributor,
                        "dtc": dtc
                    }
                };
                const inputBody = {
                    userContext: userContext,
                    carContext: carContext,
                    docType: docTypeParam
                };
                return ResultSearchByDiagnosticMetierService.getAllCodes(inputBody).then(function (response) {
                    if(!_.isEmpty(response) && !_.isEmpty(response.documents)){
                        _.filter(response.documents, function (doc) {
                            if (!_.isEmpty(doc)) {
                                mdList.push(doc.id);
                            }
                            if(!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.contributors)){
                                const idx = _.findIndex(vm.selectedSystemDoc.contributors,function(item){
                                    return item.contributor === doc.contributor;
                                });
                                if(idx !== -1){
                                    if(_.has(vm.selectedSystemDoc.contributors[idx],'mdId')){
                                        vm.selectedSystemDoc.contributors[idx].mdId.push(doc.id);
                                    }else{
                                        _.extend(vm.selectedSystemDoc.contributors[idx], {
                                            mdId: [doc.id]
                                        })
                                    }
                                }
                            }
                        });
                    }
                        return mdList;
                    })
                }).then(function (){
                    let mdList = [];
                    if (selectedTab === 0){
                        if(!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.contributors)){
                            vm.selectedSystemDoc.contributors.forEach(function (element) {
                                if (!_.isEmpty(element) && !_.isEmpty(element.mdId)){
                                    mdList = mdList.concat(element.mdId);
                                }
                            });
                        }
                    }
                if(!_.isEmpty(mdList)){ 
                    return getMDDocuments(mdList).then(function (response) {
                        if (!_.isEmpty(response) && !_.isEmpty(response.MD)) {
                            if (selectedTab === 0){
                                response = _.sortBy(response.MD, ["ref"]);
                                if(!_.isEmpty(vm.selectedSystemDoc) && !_.isEmpty(vm.selectedSystemDoc.contributors)){
                                    _.map(vm.selectedSystemDoc.contributors,function(item){
                                        const mdDocs = [];
                                        if (!_.isEmpty(item) && !_.isEmpty(item.mdId) && item.mdId.length > 0){
                                            item.mdId.forEach(function(items){
                                                if(!_.isEmpty(items)){
                                                    response.forEach(function (resp){
                                                        if(items === resp.id){
                                                            mdDocs.push(resp);
                                                        }
                                                    });
                                                }
                                            })
                                            _.extend(item,{mdDocuments : mdDocs})
                                        }
                                    });
                                }
                                _.extend(vm.selectedSystemDoc,{hasElementMdDoc : true});
                            }
                        }
                        return;
                    });    
                }
            }).then(function(){
            }).catch(function (error) {
                toastr.error(error);
            }).finally(function () {
                blockUI.stop();
                CacheService.removeObject(CacheConstants.systemDocDetails);
            });
        }

        function isConnectedServicesEligible() {
            return vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2';
        }

        function isSoftAndApplicationsEligible() {
            return vm.connectedPlatform && vm.connectedPlatform.architecture && vm.connectedPlatform.architecture.toLowerCase() === 'ccs1';
        }

        function selectedSubMenu(menu){
            vm.expandMenuReset = [rLinkMenuNew, easyLinkMenuNew, vegasEasylinkMenu, easyLinkMenu, rLinkMenu, rlinkMenuNewExpanded, easyLinkMenuNewExpanded, vegasEasylinkMenuExpanded, easyLinkMenuExpanded, rLinkMenuExpanded, vegasRlinkMenu, rlinkEVMenuExpanded, rlinkEVSmartChargeExpanded,ddpAdministration,ddphelpExpanded,connectedServicesOffers];
            resetConstantsMenu(vm.expandMenuReset);
            var isEvServicesMenu = vm.evServicesMenu && Object.values(vm.evServicesMenu).includes(menu);
            vm.selectedMenu = isEvServicesMenu ? menu : null;
            vm.hereNavigationSelected = (menu && menu.name === 'hereNavigation') ? true : false;
            vm.isDdpHelpTab = (vm.ddpHelpTabDisplay && menu && menu.name === 'userGuide');
            vm.isDdpGenericDiagTab =  (vm.ddpHelpTabDisplay && menu && menu.name === 'genericDiagnosis');
            let auditData = null;
            if (menu && menu.name) {
                if (menu.name === 'cnrUserGuide') {
                    vm.isCnrUserGuide = true;
                    RLinkCarMetierService.setHideHeader(true);
                    auditData = 'CONNECTED_SERVICES_USER_GUIDE';
                } else {
                    vm.isCnrUserGuide = false;
                    RLinkCarMetierService.setHideHeader(false);
                    if (menu.name === 'hereNavigation') {
                        auditData = 'HERE_NAVIGATION';
                    }
                }
                if (auditData && (auditData === 'CONNECTED_SERVICES_USER_GUIDE' 
                    ? isConnectedServicesEligible()
                    : true)) {
                    SearchArboTextualMetierService.setConnectedServicesAuditData(auditData)
                        .then(function () { })
                }
            }
            menu.show = true;
            
            if (menu.route) {
                $state.go(RoutesConstants[menu.route]);
            }

            if(menu.name === 'genericDiagnosis' && vm.profile.userType !== "ASOM"){
                blockUI.start();
                $q.all([
                    DiagFileBusinessService.getSystemDocuments()
                ]).then(function (response) {
                    if(response[0] && response[0].diagnosticTree){
                        vm.systemDocResponse = response[0].diagnosticTree;
                        vm.systemDocSubMenu = [];
                        if(!_.isEmpty(response[0].diagnosticTree.systems)){
                            vm.genericInfo = _.find(response[0].diagnosticTree.systems,function(item){
                                return item.system.substr(-3) === '055';
                            });
                            vm.systemDocSubMenu.unshift({"code":"055","locale":vm.genericInfo.locale,"isActive":false});
                        }
                        vm.selectedSystemDoc = vm.genericInfo;
                        getMDDocumentsIdList(0, vm.selectedSystemDoc.system);
                    }
                  
                }).catch(function (err) {
                    $log.debug($translate.instant(err));
                }).finally(function () {
                    blockUI.stop();
                });
            }

            if(menu.name === 'softAndApplications' && isSoftAndApplicationsEligible()){
                SearchArboTextualMetierService.setConnectedServicesAuditData('MAPS')
                    .then(function () { });

                RLinkCarMetierService.getMapData().then(function(mapData){
                    vm.vehicleInformations.isMapDataLoaded = true;
                    if(mapData){
                        vm.vehicleInformations.mapInformations.map = mapData.map;
                    }  
                }).catch(function(){
                    toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                }).finally(function(){
                    blockUI.stop();
                });
                
            }

            if (menu.name === 'updateCampaigns') {
                blockUI.start();
                if (vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                    SearchArboTextualMetierService.setConnectedServicesAuditData('MOTA_FOTA')
                        .then(function () { });
                    RLinkCarMetierService.getUpdateCampaignsCCS().then(function (data) {
                        if (data) {
                            var existingVehInventory = vm.updateCampaigns ? vm.updateCampaigns.vehInventory : null;
                            vm.agregateUpdateCampaigns(data);
                            if (existingVehInventory && !vm.updateCampaigns.vehInventory) {
                                vm.updateCampaigns.vehInventory = existingVehInventory;
                            }
                        }
                    }).catch(function () {
                        toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                    }).finally(function () {
                        blockUI.stop();
                    });
                } else {
                    blockUI.stop();
                }
            }
            if (vm.adasEhorizonInformationDisplay && (menu && menu.name === 'connectedADASEhorizon')) {
                vm.isAdasEhorizon = true;
                vm.loadingIcon = true;
                if (vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                    SearchArboTextualMetierService.setConnectedServicesAuditData('EHORIZON')
                        .then(function () { 
                            vm.loadingIcon = false;
                        }).catch(function () {
                            vm.loadingIcon = false; 
                        });
                } else {
                    vm.loadingIcon = false;
                
                }
            }
            else {
                vm.isAdasEhorizon = false;
            }  
            if (vm.vehicleInformationDisplay && vm.isVirtualTab && menu && (menu.name === 'virtualKeyB2C' || menu.name === 'virtualKeyB2B')) {
                if(menu.name === 'virtualKeyB2C'){
                    vm.uidTitle = 'UID 590';
                } else if (menu.name === 'virtualKeyB2B') {
                    vm.uidTitle = 'UID 592';
                } else {
                    vm.uidTitle = '';
                }
                if (vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                    let auditData = '';
                if (menu.name === 'virtualKeyB2C') {
                    auditData = 'VIRTUAL KEY B2C';
                } else if (menu.name === 'virtualKeyB2B') {
                    auditData = 'VIRTUAL KEY B2B';
                }
                    SearchArboTextualMetierService.setConnectedServicesAuditData(auditData)
                        .then(function () { })
                }
                blockUI.start();
                $q.all([
                    RLinkCarMetierService.getVirtualBlmsDetails(),
                    RLinkCarMetierService.getVirtualUserRolesDelegation(),
                    RLinkCarMetierService.getRights()
                ]).then(function(response){
                    vm.virtualKeyData = {
                        fixResponseOne: (response && response[0]) ? response[0] : null,
                        fixResponseTwo: (response && response[1]) ? response[1] : null,
                        fixResponseThree: (response && response[2]) ? response[2] : null
                    }
                $timeout(function () {
                $rootScope.$emit('virtualInfoData', {
                    virtualKeyData: vm.virtualKeyData,
                    isVirtualKey: vm.accordions.virtualKey.isOpen,
                    uidTitle: vm.uidTitle
                });
                vm.isVirtualKey = true;
                }, 3000)
                }).catch(function(){
                    $timeout(function() {
                        $rootScope.$emit('virtualInfoData',{virtualKeyData: vm.virtualKeyData, isVirtualKey: vm.accordions.virtualKey.isOpen, uidTitle:vm.uidTitle });
                    }, 4000);
                }).finally(function(){
                    blockUI.stop();
                });
            }
            else{
                vm.isVirtualKey = false;
            }
            if ((vm.vehicleInformationDisplay && menu && menu.name === 'dataConsistencies')) {
                vm.isDataConsistency = true;
            }
            else {
                vm.isDataConsistency = false;
            } 
            const isRlinkHeader = (menu && menu.name === 'eligibleOffers') ? false : true;
            $rootScope.$emit('isRLinkHeader', isRlinkHeader);
            if (isRlinkHeader) {
                $timeout(function () {
                    if (vm.easyLinkResponse) {
                        shareConnectivityComponents(vm.easyLinkResponse);
                    }
                    else if (vm.rLinkResponse) {
                        shareRadio(vm.rLinkResponse);
                    }
                }, 100)
            } else {
                $timeout(function () {
                    vm.loadingIcon = true;
                    $rootScope.$broadcast('ConnectedServicesOffers', isRlinkHeader, 'isCurrentOffer');
                }, 100)

                SearchArboTextualMetierService.setConnectedServicesAuditData('CONNECTED_SERVICES_OFFERS')
                        .then(function () { })              
            }
            if (menu.name === 'remoteServices' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('REMOTE_SERVICE')
                    .then(function () { })
            }
            if(menu.name === "plugAndCharge" || menu.name === "vehicleToGrid"||  menu.name === "vehicleToGridNew" || menu.name === "smartCharging"){
                if(vm.loadingIcon){
                RLinkCarMetierService.setEvServicesTab(menu.name);
                }         
               $rootScope.$broadcast('EVTabDetails',menu.name);
            }
            if (menu.name === 'plugAndCharge' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('PNC')
                    .then(function () { })
            }
             if (menu.name === 'evSettings' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('EV_SETTING')
                    .then(function () { })
            }
            if (menu.name === 'vehicleToGrid' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('V2G')
                    .then(function () { })
            }
            if (menu.name === 'vehicleToGridNew' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('V2GNew')
                    .then(function () { })
            }
            if (menu.name === 'smartCharging' && vm.vehicleInformationDisplay && vm.connectedPlatform !== null && vm.connectedPlatform.platform !== 'rlink2') {
                SearchArboTextualMetierService.setConnectedServicesAuditData('SMART_CHARGING')
                    .then(function () { })
            }

            if (menu.name === 'evSettings') {
                if (vm.loadingIcon) {
                    RLinkCarMetierService.setEvServicesTab(menu.name);
                }
                $rootScope.$broadcast('EVTabDetails', menu.name);

                const prediag = vm.easyLinkResponse || vm.rLinkResponse;
                if (prediag && prediag.subscriptions && prediag.subscriptions.commercialServices && Array.isArray(prediag.subscriptions.commercialServices)) {
                    prediag.subscriptions.commercialServices.forEach(function (service) {
                        if (Array.isArray(service.features)) {
                            const feature955 = service.features.find(function (f) {
                                return String(f.uid) === '955';
                            });
                            if (feature955) {
                                const uid955Data = {
                                    status: feature955.status,
                                    updatedAt: feature955.updatedAt
                                };
                                $rootScope.$broadcast('uid955Data', uid955Data);
                            }
                        }
                    });
                }

            }
           
        }

        function resetMenu(){
            const keys = Object.keys(vm.menu);
            keys.forEach(function(key) {
                vm.menu[key].show = false;
            });
        }

        function resetConstantsMenu(expandMenuReset){
            expandMenuReset.forEach(function(data){
                const keys = Object.keys(data);
                keys.forEach(function(key) {
                    data[key].show = false;
                });
            })          
        }

        function newRoleFunction(wasEligibleRedirect){
          
                vm.connectedInfoIsOpen = true;
                $timeout(function () {                   
                var isRlinkHeader = isSpecialUserRoleOnInit() ? true : false;
                $rootScope.$emit('isRLinkHeader', isRlinkHeader);
                if (!isRlinkHeader) {
                    vm.loadingIcon = true;
                    SearchArboTextualMetierService.setConnectedServicesAuditData('CONNECTED_SERVICES_OFFERS')
                        .then(function () { })
                        if(wasEligibleRedirect){
                            $rootScope.$broadcast('ConnectedServicesOffers', true, 'isEnableTab');
                        }
                        else{
                            $rootScope.$broadcast('ConnectedServicesOffers', isRlinkHeader, 'isCurrentOffer');
                        }
                    }
            }, 200)
            }
        

        function getCarData(wasEligibleRedirect) {
            vm.loadingIcon = true;
            if (vm.vehicleInformationDisplay) {
                if (vm.connectedPlatform !== null && vm.connectedPlatform.platform === 'rlink2') {
                    if(!vm.showLoaderIcon){
                        selectNode(startingNode); 
                    }
                    if (isArcaOrRnetSpecialUser(vm.profile)) {
                        newRoleFunction(wasEligibleRedirect);
                    }
                    RLinkCarMetierService.getRlinkCarData().then(function (data) {
                        vm.loadingIcon = true;
                        if (!angular.equals(data.clientReponseStatusMap, {})) {
                            // No action needed if clientReponseStatusMap is not empty
                        }
                        vm.rLinkResponse = data;                     
                        vm.vehicleInformationsEasyLinkData(data);
                        vm.subscriptionAndServicesData(data);
                        vm.dataConsistencyDataEasyLinkData(data);
                        shareRadio(data);
                    }).catch(function () {
                    }).finally(function () {
                    });
                } else {
                    
                    if(!vm.showLoaderIcon){
                        selectNode(startingNode); 
                    }
                    // moved outside the block below

                    if (isArcaCustomerCare(vm.profile) || isRnetCnrWrapper(vm.profile)) {
                        newRoleFunction(wasEligibleRedirect);
                    }
                    return RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                        vm.loadingIcon = true;
                        if (!angular.equals(data.clientReponseStatusMap, {})) {
                           // toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
                        }
                        getVehicleElectronicData();
                        if (vm.connectedPlatform !== null && vm.connectedPlatform.country === "TR") {
                            getSimStatus();
                        }
                        getBatteryDetails();
                        emitPrivacyType(data);                      
                        vm.easyLinkResponse = data;
                        vm.checkConnectivityDevices(data);
                        vm.vehicleInformationsEasyLinkData(data);
                        vm.subscriptionAndServicesEasyLinkData(data);
                        vm.dataConsistencyDataEasyLinkData(data);
                        vm.agregateUpdateCampaigns(data);
                        shareConnectivityComponents(data); 
                        checkForEvSettings();
                        if(vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present === false){
                            removeSoftAndApplicationsMenu(vm.connectedInfoMenu);
                        }

                        function removeSoftAndApplicationsMenu(menu) {
                            if (menu[2] && menu[2].name === 'softAndApplications') {
                                removeMenuItem(menu, '2');
                            }
                        }

                        function removeMenuItem(menu, key) {
                            if (menu.hasOwnProperty(key)) {
                                delete menu[key];
                            }
                        }
                    }).catch(function () {
                    }).finally(function () {
                        vm.loadingIcon = false;
                    });
                }
                //}
            } else{
                if (vm.connectedPlatform !== null && vm.connectedPlatform.platform === 'EASYLINK') {
                    if(!vm.showLoaderIcon){
                        selectNode(startingNode); 
                    }

                    if (isArcaCnrCustomerCareWrapper(vm.profile) || isRnetCnrWrapper(vm.profile)) {
                        newRoleFunction(wasEligibleRedirect);
                    }      
                    return RLinkCarMetierService.getEasyLinkCarData().then(function (data) {
                        vm.loadingIcon = true;
                        if (!angular.equals(data.clientReponseStatusMap, {})) {
                            // No action needed if clientReponseStatusMap is not empty
                        }
                        vm.easyLinkResponse = data;
                        vm.checkConnectivityDevices(data);
                        vm.vehicleInformationsEasyLinkData(data);
                        vm.subscriptionAndServicesEasyLinkData(data);
                        vm.dataConsistencyDataEasyLinkData(data);
                        checkForEvSettings();
                        shareConnectivityComponents(data);                   
                    }).catch(function () {
                    }).finally(function () {
                    });
                } else {
                    if(!vm.showLoaderIcon){
                        selectNode(startingNode); 
                    }
                    const isArcaCnr = !_.isEmpty(vm.profile) && vm.profile.userType === "ARCA" && !_.isEmpty(vm.profile.roles) && vm.profile.roles.includes(rLinkConstant.arcaCnrCustomerCare);
                    const hasRnetRoles = !_.isEmpty(vm.profile.roles) && (vm.profile.roles.includes(rLinkConstant.rnetCnrCustomerCare) || vm.profile.roles.includes(rLinkConstant.rnetCnrDealer) || vm.isPpxLightUser);
                    const isRnetCnr = vm.profile.userType === "RNET" && hasRnetRoles;
                    if (isArcaCnr || isRnetCnr) {
                        newRoleFunction(wasEligibleRedirect);
                    }
                    return RLinkCarMetierService.getRlinkCarData().then(function (data) {
                        vm.loadingIcon = true;
                        if (!angular.equals(data.clientReponseStatusMap, {})) {
                            // No action needed if clientReponseStatusMap is not empty
                        }
                        vm.rLinkResponse = data;
                        vm.vehicleInformationsData(data);
                        vm.subscriptionAndServicesData(data);
                        vm.dataConsistencyData(data);
                        vm.agregateUpdateCampaigns(data);
                        shareRadio(data);
                    }).catch(function () {
                        vm.vehicleInformations.allDataloaded = true;
                    }).finally(function () {
                        vm.loadingIcon = false;
                    });
                }
            }

            RLinkCarMetierService.getAllDiagnosis().then(function (data) {
                vm.hideDiagnosisAcces = (data.length === 0) ? true : false;
                CacheService.setObject(CacheConstants.diagList, data);
            }).catch(function () {
            })
            return $q.resolve();
        }

        function getSimStatus() {
            RLinkCarMetierService.getSimStatusData().then(function (simResponse) {

                if (!_.isEmpty(simResponse) && !_.isEmpty(simResponse.data) && !_.isEmpty(simResponse.data.ecus) && !_.isEmpty(simResponse.data.ecus.ivc) && !_.isEmpty(simResponse.data.ecus.ivc.connectionStatus)) {
                    _.assign(vm.connectionStatus, {
                        status: simResponse.data.ecus.ivc.connectionStatus.status ? simResponse.data.ecus.ivc.connectionStatus.status : "-",
                        lastUpdatedTime: simResponse.data.ecus.ivc.connectionStatus.lastUpdatedTime ? simResponse.data.ecus.ivc.connectionStatus.lastUpdatedTime : "-"
                    });
                }

            })

        }

        function hereNaviSubscription(){
             RLinkCarMetierService.getHereNaviSubscription().then(function (subscriptionData) {
                if (!_.isEmpty(subscriptionData)) {
                     _.assign(vm.vehicleInformations, {
                        hereNavigationSubscription: {
                            response: subscriptionData.data
                        }
                    });
                    
                }
            }) 
        }

        function hereNaviStatus(){
            RLinkCarMetierService.getHereNaviStatus().then(function (statusData) {
                if (!_.isEmpty(statusData)) {
                     _.assign(vm.vehicleInformations, {
                        hereNavigationStatus: {
                            response: statusData.data
                        }
                    });
                    
                }
            }) 
        }

        function getVehicleElectronicData() {
            RLinkCarMetierService.getVehicleSerialNumber(false).then(function (bvaData) {
                if (!_.isEmpty(bvaData)) {
                    _.assign(vm.vehicleInformations, {
                        electronicEcuVehicleData: {
                            response: bvaData.data
                        }
                    });
                }
                const hasBvaData = bvaData && bvaData.data;
                const hasEcuReport = hasBvaData && bvaData.data.ecuReport;
                const hasElectronicControlUnits = hasEcuReport && bvaData.data.ecuReport.electronicControlUnits;
                const hasControlUnitsLength = hasElectronicControlUnits && bvaData.data.ecuReport.electronicControlUnits.length > 0;

                if (hasControlUnitsLength) {
                    bvaData.data.ecuReport.electronicControlUnits.forEach(processEcuFeature);
                }
            });

            function processEcuFeature(feature) {
                if (feature.ecuName === 'NAV') {
                    processNavFeature(feature);
                }
                if (feature.ecuName === 'TCU') {
                    processTcuFeature(feature);
                }
                _.assign(vm.vehicleInformations, {
                    electronicFile: {
                        iviSerialNumber: vm.iviSerialNumber ? vm.iviSerialNumber : "-",
                        iviSoftwareVersion: vm.iviSoftwareVersion ? vm.iviSoftwareVersion : "-",
                        ivcSerialNumber: vm.ivcSerialNumber ? vm.ivcSerialNumber : "-",
                        ivcSoftwareVersion: vm.ivcSoftwareVersion ? vm.ivcSoftwareVersion : "-"
                    }
                });
            }

            function processNavFeature(feature) {
                if (feature.part && feature.part.partSerialNumber) {
                    vm.iviSerialNumber = feature.part.partSerialNumber.serialNumber;
                }
                if (feature.operationalReference && feature.operationalReference.USB) {
                    vm.iviSoftwareVersion = feature.operationalReference.USB.partNumber;
                }
            }

            function processTcuFeature(feature) {
                if (feature.part && feature.part.partSerialNumber) {
                    vm.ivcSerialNumber = feature.part.partSerialNumber.serialNumber;
                }
                setTcuSoftwareVersion(feature);
            }

            function setTcuSoftwareVersion(feature) {
                const hasPlatform = vm.connectedPlatform && vm.connectedPlatform.architecture;
                if (!hasPlatform) {
                    return;
                }
                    const arch = hasPlatform.toLowerCase();
                if (arch === 'ccs1') {
                    setTcuSoftwareVersionCcs1(feature);
                } else if (arch === 'ccs2' || arch === 'ccs3') {
                    setTcuSoftwareVersionCcs2(feature);
                }
            }

            function setTcuSoftwareVersionCcs1(feature) {
                if (feature.operationalReference && feature.operationalReference.USB) {
                    vm.ivcSoftwareVersion = feature.operationalReference.USB.partNumber;
                }
            }

            function setTcuSoftwareVersionCcs2(feature) {
                if (feature.operationalReference && feature.operationalReference.CAN) {
                    vm.ivcSoftwareVersion = feature.operationalReference.CAN.partNumber;
                }
            }
        }

        function getBatteryDetails() {
            const batterDisplayCriteria = ['ELECX','ELEC'];
            const batteryHybridCriteria = ['HYB05','HYB06','HYB07'];
            const carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            const vinValue = (carContextRequest && carContextRequest.vin) ? carContextRequest.vin : null;
            if (!_.isEmpty(carContextRequest) && !_.isEmpty(carContextRequest.fixedCriterias) &&
                ((!_.isEmpty(carContextRequest.fixedCriterias["019"]) && batterDisplayCriteria.includes(carContextRequest.fixedCriterias["019"])) ||
                 (!_.isEmpty(carContextRequest.fixedCriterias["956"]) && batteryHybridCriteria.includes(carContextRequest.fixedCriterias["956"])))) {
                vm.loadingIcon = true;
                RLinkCarWSService.getBatteryInformation(vinValue).then(function (res) {
                    if (res && !_.isEmpty(res.data)) {
                        vm.batteryResponse = res.data[0];
                        if (!_.isEmpty(vm.vehicleInformations)) {
                            _.assign(vm.vehicleInformations, {
                                batteryResponse: {
                                    bin: (vm.batteryResponse && vm.batteryResponse.bin) ? vm.batteryResponse.bin : "-",
                                    availableEnergy: (vm.batteryResponse && !_.isEmpty(vm.batteryResponse.kwhPack)) ? (vm.batteryResponse.kwhPack + 'kWh') : "-",
                                    lastUpdateTime: (vm.batteryResponse && vm.batteryResponse.kwhPackUpdateDate) ? moment(vm.batteryResponse.kwhPackUpdateDate, ['YYYY-MM-DDThh:mm']).format("DD/MM/YYYY HH:mm") : "-",
                                    evDstTot: (vm.batteryResponse && vm.batteryResponse.evDstTot) ? vm.batteryResponse.evDstTot : "-",
                                    evDstTotLud: (vm.batteryResponse && vm.batteryResponse.evDstTotLud) ? moment(vm.batteryResponse.evDstTotLud, ['YYYY-MM-DDThh:mm']).format("DD/MM/YYYY HH:mm") : "-",
                                    packMileage: (vm.batteryResponse && vm.batteryResponse.packMileage) ? vm.batteryResponse.packMileage : "-",
                                    packMileageLud: (vm.batteryResponse && vm.batteryResponse.packMileageLud) ? moment(vm.batteryResponse.packMileageLud, ['YYYY-MM-DDThh:mm']).format("DD/MM/YYYY HH:mm") : "-",
                                    binVinDateLnk: (vm.batteryResponse && vm.batteryResponse.binVinDateLnk) ? moment(vm.batteryResponse.binVinDateLnk, ['YYYY-MM-DDThh:mm']).format("DD/MM/YYYY HH:mm") : "-",
                                    sohBms: (vm.batteryResponse && vm.batteryResponse.sohBms) ? vm.batteryResponse.sohBms : "-",
                                    soheRefLud: (vm.batteryResponse && vm.batteryResponse.soheRefLud) ? moment(vm.batteryResponse.soheRefLud, ['YYYY-MM-DDThh:mm']).format("DD/MM/YYYY HH:mm") : "-",
                                    purchaseMode: (vm.batteryResponse && vm.batteryResponse.purchaseMode) ? vm.batteryResponse.purchaseMode : "-",
                                    soheRef: (vm.batteryResponse && vm.batteryResponse.soheRef) ? vm.batteryResponse.soheRef : "-",
                                }
                            });
                        }
                        vm.showBatteryInhibition = false;
                        if (
                            carContextRequest &&
                            carContextRequest.fixedCriterias &&
                            carContextRequest.fixedCriterias["019"] === "ELEC" &&
                            vm.batteryResponse &&
                            vm.batteryResponse.purchaseMode === 'L'
                        ) {
                            vm.showBatteryInhibition = true;
                            RLinkCarWSService.getBatteryInhibition(vinValue).then(function (inhibitionRes) {
                                if (!_.isEmpty(inhibitionRes) && !_.isEmpty(inhibitionRes.chargeProhibitionByRental) && inhibitionRes.chargeProhibitionByRental.value != null) {
                                    if (inhibitionRes.chargeProhibitionByRental.value === 0) {
                                        vm.inhibitionStatus = true;
                                    } else if (inhibitionRes.chargeProhibitionByRental.value === 1) {
                                        vm.inhibitionStatus = false;
                                    }
                                    vm.inhibitionLastUpdateDateTime = inhibitionRes.chargeProhibitionByRental.lastUpdateDateTime || null;
                                }
                            }).catch(function () {
                                toastr.error($translate.instant('ERROR'));
                            });
                        }
                    }
                }).catch(function () {
                });
                RLinkCarWSService.getBatteryStatus(vinValue).then(function (batteryStatus) {
                    if (!_.isEmpty(batteryStatus) && !_.isEmpty(vm.vehicleInformations)) {
                        vm.chargeStatusValue = rLinkConstant.chargeStatusLabels;
                        vm.fetchStatusValue = _.find(vm.chargeStatusValue, function (item) {
                            return batteryStatus &&
                                batteryStatus.chargeStatus &&
                                batteryStatus.chargeStatus.value != null &&
                                item.id === batteryStatus.chargeStatus.value.toString();
                        });
                        vm.plugStatusValue = rLinkConstant.plugStatusLabels;
                        vm.fetchPlugValue = _.find(vm.plugStatusValue, function (item) {
                            return batteryStatus &&
                                batteryStatus.evChargePlugConnected &&
                                batteryStatus.evChargePlugConnected.value != null &&
                                item.id === batteryStatus.evChargePlugConnected.value.toString();
                        });
                        _.assign(vm.vehicleInformations, {
                            batteryStatusResponse: {
                                infoUpdated: (batteryStatus && batteryStatus.commercialBrand && batteryStatus.commercialBrand.lastUpdateDateTime) ? batteryStatus.commercialBrand.lastUpdateDateTime : "-",
                                autonomy: (batteryStatus && batteryStatus.zevAutonomyDisplay && batteryStatus.zevAutonomyDisplay.value) ? (batteryStatus.zevAutonomyDisplay.value + '\n' + 'km') : "-",
                                chargeLevel: (batteryStatus && batteryStatus.evHvBatteryEnergyLevel && batteryStatus.evHvBatteryEnergyLevel.value) ? (batteryStatus.evHvBatteryEnergyLevel.value + '\n' + '%') : "-",
                                chargeStatus: (vm.fetchStatusValue && vm.fetchStatusValue.value) ? $translate.instant(vm.fetchStatusValue.value) : "-",
                                plugStatus: (vm.fetchPlugValue && vm.fetchPlugValue.value) ? $translate.instant(vm.fetchPlugValue.value) : "-",
                                chargeLevelTime: (batteryStatus && batteryStatus.evHvBatteryEnergyLevel && batteryStatus.evHvBatteryEnergyLevel.lastUpdateDateTime) ? (batteryStatus && batteryStatus.evHvBatteryEnergyLevel.lastUpdateDateTime) : "-",
                                plugStatusTime: (batteryStatus && batteryStatus.evChargePlugConnected && batteryStatus.evChargePlugConnected.lastUpdateDateTime) ? (batteryStatus && batteryStatus.evChargePlugConnected.lastUpdateDateTime) : "-",
                                chargeStatusTime: (batteryStatus && batteryStatus.chargeStatus && batteryStatus.chargeStatus.lastUpdateDateTime) ? (batteryStatus && batteryStatus.chargeStatus.lastUpdateDateTime) : "-",
                                autonomyTime: (batteryStatus && batteryStatus.zevAutonomyDisplay && batteryStatus.zevAutonomyDisplay.lastUpdateDateTime) ? (batteryStatus && batteryStatus.zevAutonomyDisplay.lastUpdateDateTime) : "-"
                            }
                        });
                    }
                }).catch(function () {
                }).finally(function () {
                });
            }
        }

        function checkConnectivityDevices(data) {
            const hu = data.headUnit.present !== null ? data.headUnit.present : false;
            const tcu = data.tcu.present !== null ? data.tcu.present : false;
            return (tcu && hu);
        }

        function dataConsistencyData(data){
            vm.dataConsistencies = {
                headUnitInformation: data.headUnit,
                tcuInformation: data.tcu
            }
        }

        function dataConsistencyDataEasyLinkData(data){
            vm.dataConsistencies = {
                headUnitInformation: data.headUnit,
                tcuInformation: data.tcu
            }
            if(!_.isEmpty(vm.dataConsistencies)){
                if (!_.isEmpty(vm.dataConsistencies.headUnitInformation)) {
                    vm.dataConsistencies.headUnitInformation.present = (vm.dataConsistencies && vm.dataConsistencies.headUnitInformation.present) ? 'YES' :'NO';
                    vm.headUnitInformation = vm.dataConsistencies.headUnitInformation;
                    vm.huTable = vm.dataConsistencies.headUnitInformation.huId;

                    if(!_.isEmpty(vm.huTable)){
                        if(!_.isEmpty(vm.huTable.vnext) && !_.isEmpty(vm.huTable.bvmAfterSales) && !_.isEmpty(vm.huTable.vehicleReferential) && (vm.huTable.vnext === vm.huTable.bvmAfterSales) && (vm.huTable.bvmAfterSales === vm.huTable.vehicleReferential)){
                            vm.threeHuValuesEqual = true;
                        }
                        else{
                            vm.threeHuValuesEqual = false;
                        }
                    }
                    vm.noHu = checkIfNoTcuHu(vm.dataConsistencies.headUnitInformation);
                }
                if(!_.isEmpty(vm.dataConsistencies.tcuInformation)){
                    vm.dataConsistencies.tcuInformation.present = (vm.dataConsistencies && vm.dataConsistencies.tcuInformation.present) ? 'YES' :'NO';
                    vm.tcuInformation = vm.dataConsistencies.tcuInformation;
                    vm.tcuTable = vm.dataConsistencies.tcuInformation.tcuId;
                    if(!_.isEmpty(vm.tcuTable)){
                        if(!_.isEmpty(vm.tcuTable.vnext) && !_.isEmpty(vm.tcuTable.bvmAfterSales) && !_.isEmpty(vm.tcuTable.vehicleReferential) && (vm.tcuTable.vnext === vm.tcuTable.bvmAfterSales) && (vm.tcuTable.bvmAfterSales === vm.tcuTable.vehicleReferential)){
                            vm.threeTcuValuesEqual = true;
                        }
                        else{
                            vm.threeTcuValuesEqual = false;
                        }
                    }
                    vm.noTcu = checkIfNoTcuHu(vm.tcuInformation);
                }
                _.assign(vm.vehicleInformations,{threeTcuValuesEqual: vm.threeTcuValuesEqual,threeHuValuesEqual: vm.threeHuValuesEqual})
            }
        }

        function vehicleInformationsData(data) {
            vm.vehicleInformations = {
                pboInformations: data.pushButton,
                pboRequestInfo: data.pboRequest,
                radioInformation: data.radio,
                simInformation: data.sim,
                headUnitInformation: data.headUnit,
                tcuInformation: data.tcu,
                storageInformation: {
                    maps:data.map,
                    coyote:data.coyote
                },
                connectivity: data.connectivity,
                subscriptionInformation: data.subscriptions,
                dataConsistencies: {
                    headUnitInformation: data.headUnit,
                    tcuInformation: data.tcu
                },
                vehicleInformation: data.vehicle,
                allDataloaded: true
            };
        }

        function vehicleInformationsEasyLinkData(data) {
            vm.vehicleInformations = {
                pboInformations: data.pushButton,
                pboRequestInfo: data.pboRequest,
                radioInformation: data.radio,
                simInformation: data.sim,
                headUnitInformation: data.headUnit,
                tcuInformation: data.tcu,
                mapInformations: {
                    // map:data.map,
                    radnavSystemType: data.headUnit.radnavSystemType,
                    hasConnectivityDevices: checkConnectivityDevices(data),
                    coyote: data.coyote
                },
                connectivity: data.connectivity,
                owner: data.owner,
                subscriptionInformation: data.subscriptions,
                vehicleInformation: data.vehicle,
                allDataloaded: true
            };
        }

        function subscriptionAndServicesData(data) {
            vm.subscriptionAndServices = data.subscriptions;
        }

        function subscriptionAndServicesEasyLinkData(data) {
            vm.subscriptionAndServices = data.subscriptions;
        }

        function shareRadio(data) {
            $rootScope.$emit('easyLinkDataLoaded', true);
            $rootScope.$emit('bose', data.radio.bose);
            $rootScope.$emit('dab', data.radio.dab);
            $rootScope.$emit('type', data.headUnit.radioRange);
            $rootScope.$emit('carPlay', data.radio.smartphoneReplication);
        }

        function shareConnectivityComponents(data) {
            $rootScope.$emit('easyLinkDataLoaded', true);
            $rootScope.$emit('TCU', data.tcu.present);
            $rootScope.$emit('HU', data.headUnit.present);
            if (data.headUnit.present && data.vehicle.dataPrivacy) {
                $rootScope.$emit('dataPrivacy', data.vehicle.dataPrivacy.toUpperCase());
            }
            if(data.vehicle.legacyDataPrivacy){
                $rootScope.$emit('privacyMode', data.vehicle.legacyDataPrivacy.privacyMode);
            }
            $rootScope.$emit('privacyType', data.vehicle.privacyType);
        }

        function agregateUpdateCampaigns(data) {
            let fota = [];
            let fotaHU = [];
            let fotaTCU = [];

            const isNewCampaignsEndpoint = !data.headUnit && !data.tcu;

            if (!isNewCampaignsEndpoint) {
                if(data.headUnit && data.headUnit.updateCampaigns !== null) {
                    fotaHU = data.headUnit.updateCampaigns;
                    for(var i = 0; i < fotaHU.length; i++) {
                        fotaHU[i]['component'] = 'IVI';
                    }
                }

                if(data.tcu && data.tcu.updateCampaigns !== null) {
                    fotaTCU = data.tcu.updateCampaigns;
                    for(var i = 0; i < fotaTCU.length; i++) {
                        fotaTCU[i]['component'] = 'IVC';
                    }
                }

                fota = fotaHU.concat(fotaTCU);
            } else {
                fota = data.softwareCampaigns || [];
            }

            const mota = (data.map && data.map.updateCampaigns) ? data.map.updateCampaigns : null;
            const mapInvent = (data.map && data.map.inventoryCampaigns) ? data.map.inventoryCampaigns : null;
            const softwareCampaigns = data.softwareCampaigns || null;
            const inventoryCampaigns = data.inventoryCampaigns || (data.map && data.map.inventoryCampaigns) || null;
            let vehInventory = null;
            if (!isNewCampaignsEndpoint && data.headUnit && data.tcu) {
                const { headUnit, tcu } = data;
                vehInventory = {
                    huPresent: headUnit.present, 
                    huPartNo: headUnit.partNumber, 
                    huConfigFile: headUnit.calibrationFile, 
                    huRadnavSysTypeDesc: headUnit.radnavSystemType ? headUnit.radnavSystemType.description : null,
                    huMtcCriteria: headUnit.radnavSystemType ? headUnit.radnavSystemType.mtcCriteria : null, 
                    huName: headUnit.radnavSystemType ? headUnit.radnavSystemType.name : null, 
                    tcuPartNo: tcu.partNumber, 
                    tcuConfigFile: tcu.configFile, 
                    tcuType: tcu.type, 
                    tcuPresent: tcu.present
                };
            }

            vm.updateCampaigns = {
                fota: fota,
                mota: mota,
                mapInvent: mapInvent,
                softwareCampaigns: softwareCampaigns,
                vehInventory: vehInventory,
                inventoryCampaigns: inventoryCampaigns
            }
        }

        function translateMenu(id) {
            if(vm.menu && !_.isEmpty(vm.menu[(id+1)])){
                return $translate.instant(vm.menu[(id+1)].translate);
            }
        }
             
        function translateMenuNew(id,menu){
            if(vm.connectedInfoMenu && !_.isEmpty(vm.connectedInfoMenu[(id+1)])){
                return $translate.instant(menu.translate)
            }
        }

        function processEhorizonData(currentLicense) {
            if (currentLicense.ehorizonData && !_.isEmpty(currentLicense.ehorizonData)) {
                vm.diagnosisEhorizon = currentLicense.ehorizonData;
                vm.diagnosisEhorizon.systemId = rLinkConstant.ehorizonData;
            } else {
                vm.diagnosisEhorizon = null;
            }
        }

        function processContinentalData(currentLicense) {
            const hasContinentalData = currentLicense.continentalData && !_.isEmpty(currentLicense.continentalData);
            const hasLicense = hasContinentalData && !_.isEmpty(currentLicense.continentalData.license);
            
            if (hasContinentalData) {
                vm.diagnosiscontinentalData = currentLicense.continentalData;
            }
            
            if (hasLicense) {
                vm.diagnosiscontinentalData.license.systemId = rLinkConstant.continentalData;
                vm.continentalLicenseRevoked = currentLicense.continentalData.license.revoked;
            } else {
                vm.diagnosiscontinentalData = null;
                vm.continentalLicenseRevoked = null;
            }
        }

        function getAdasEhorizonDetails() {
            const contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            const vin = (contextCarRequest && contextCarRequest.vin) ? contextCarRequest.vin : null;
            
            RLinkCarWSService.getConnectedAdasEhorizonDetails(vin).then(function (data) {
                vm.loadingIcon = false;
                vm.adasEhorizonData = data;
                
                processEhorizonData(vm.adasEhorizonData.currentLicense);
                processContinentalData(vm.adasEhorizonData.currentLicense);
                
                if (vm.adasEhorizonData.licenseEventsHistory.length > 0) {
                    vm.eventHistoryEhorizonData = rLinkConstant.ehorizonData;
                    vm.eventHistoryContinentalData = rLinkConstant.continentalData;
                }
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            });
        }

        function refreshPrivacyData(){
            blockUI.start();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            $timeout(function () {
                vm.vehicleInformations.allDataloaded = false;
            RLinkCarMetierService.getVehicleInformationDataCCS().then(function (data) {
                if (!_.isEmpty(data)) {
                     vm.usageMode = ((data.vehicle && data.vehicle.usageMode) || "-").split('_')[0];
                     vm.vehicleInformations.vehicleInformation = data.vehicle;
                }
            }).catch(function () {
                toastr.error($translate.instant('RLINKCAR_ERROR_LOAD_DATA'));
            }).finally(function () {
                vm.vehicleInformations.allDataloaded = true;
                blockUI.stop();
            });
            });
        }

        function isArcaOrRnetSpecialUser(profile) {
            if (_.isEmpty(profile)) {
                return false;
            }
            return isArcaSpecialUser(profile) || isRnetSpecialUser(profile);
        }

        function isArcaSpecialUser(profile) {
            // Delegate to isArcaCustomerCare to avoid duplicate implementation
            return isArcaCustomerCare(profile);
        }

        function isRnetSpecialUser(profile) {
            if (profile.userType !== "RNET" || _.isEmpty(profile.roles)) {
                return false;
            }
            const hasCustomerCare = profile.roles.includes(rLinkConstant.rnetCnrCustomerCare);
            const hasDealer = profile.roles.includes(rLinkConstant.rnetCnrDealer);
            const isLightUser = vm.isPpxLightUser;
            return hasCustomerCare || hasDealer || isLightUser;
        }

        function checkForEvSettings() {
            const prediag = vm.easyLinkResponse || vm.rLinkResponse;
            const commercialServices = prediag && prediag.subscriptions && prediag.subscriptions.commercialServices;

            vm.displaySettings = Array.isArray(commercialServices) && commercialServices.some(function (service) {
                return Array.isArray(service.features) && service.features.some(function (feature) {
                    return String(feature.uid) === '955';
                });
            });
        }

    }
})();

(function () {
    const HERE_NAVIGATION_TRACK = 'Here Navigation';
    const VIRTUAL_KEY_B2B_LABEL = 'Virtual Key B2B';

    angular.module('phenix').constant('rLinkConstant', {
        assistanceTag: 'Assistance tools',
        dateFormat: 'dd/MM/yyyy',
        fullDateFormat: 'yyyy/MM/dd HH:mm',
        dateYearFormat: 'yyyy-mm-dd HH:mm',
        tableLine: 5,
        featureId: 820,
        featureCapId: 204,
        restATWS: '/proxy/apigee/at1/v1/',
        restATWSNew:'/proxy/apigee/at1/v2/',
        refreshActivationBase: '/proxy/apigee/s13/vkm/tools/v1/vehicle/',
        rightsBase:'/proxy/apigee/s13/vkm/b2b/v1/vehicles/',
        activation: '/refresh-activation',
        association: '/refresh-association',
        rights:'/rights',
        provisioningReq: 'provisioning-requests',
        provisioningReqVeh:'provisioning-requests/vehicles/',
        provisioningRequests:'/requests/',
        restSmartCharge:'/proxy/apigee/e07/smart-charge/v1/',
        evManagerCalendar: '/proxy/apigee/e07/smart-charge/v1/vehicles/',
        launchInstallation: '/proxy/apigee/s15/diag/v1/vehicles/',
        certificates: '/certificates/',
        certificate: 'certificate',
        repair:'/repair',
        calendar : '/calendar',
        delegation : '/delegation',
        soc:'/soc-target',
        vehc: 'vehicles/',
        features: 'features/',
        ddpAdmin:'PPX_DDP_ADMIN',
        sdsm:'SDSM',
        //preDiag: '/connected-services/pre-diagnostic',
        preDiag: '/rlink2/connected-services/pre-diagnostic',
        preDiagEasyLink: '/easylink/connected-services/pre-diagnostic',
        vehicleInformationLinkCCS:'/ccs/connected-services/pre-diagnostic',
        vehicleInformationLinkContractsService:'/ccs/connected-services/pre-diagnostic/contract-services',
        updateCampaignsCCS:'/ccs/connected-services/pre-diagnostic/campaigns',
        campaignManagement:'/proxy/campaign-mgmt/v3/campaigns',
        usageMode:'/usage-modes',
        mapData:'/map',
        admireCommerciaLabel: '/proxy/apigee/lrq/repository/v1/links/data/criteria?',
        updateUsageCountry: '/proxy/apigee/repository/connected-vehicles-tooling-facade/v1/vehicles/',
        usageCountries: '/usage-countries',
        vinSearchOffer:'/proxy/apigee/cnr/subscriptions-referential/v1/vin/subscriptions/search',
        eligibleOffer:'/proxy/apigee/cnr/subscriptions-referential/v1/vin/subscriptions/eligible-offers',
        vinsubscription:'/proxy/apigee/cnr/subscriptions-referential/v1/vin/subscriptions',
        offerDetails:'/proxy/apigee/cnr/subscriptions-referential/v1/subscriptions/',
        catalog:'/proxy/apigee/sc4/services-features-catalog/v1/catalog',
        acquisitionsUrl:'/proxy/apigee/acr/acquisitions-referential/v1/acquisitions/vin/',
        eligibleHardwareUrl:'/proxy/apigee/acr/acquisitions-referential/v1/acquisitions/vin/',
        createAcquisitionUrl:'/proxy/apigee/acr/acquisitions-referential/v1/acquisitions',
        catalogHardwareSnapshot:'/proxy/apigee/scm/catalog-hardware/v1/catalog/hardwares-snapshot/search',
        synchronizeContract: '/rlink2/connected-services/resync-service',
        startPBO: '/rlink2/connected-services/start-pushbutton',
        adasEhorizonExternalCall: '/proxy/apigee/s25/diagnostic/v1/vehicles/',
        adasEhorizon: '/ehorizon-diagnostic',
        ehorizonData: 'Ehorizon',
        continentalData: 'Continental',  
        privacySettings: '/privacy-settings',
        diagList: 'diagnoses/',
        nodes: 'nodes/',
        diagRoutine: 'routine/',
        histoDiag: 'diagnosis-reports/',
        connectedPlateform: 'connected-platform',
        remoteDiag: '/proxy/apigee/RED/remote-diag-manager/v1/remote-diagnostics',
        remoteDiagVCPS: '/proxy/apigee/red/diagnostic-command/v1/remote-diagnostics',
        batteryInfo:'/proxy/apigee/bms/v1/batteries/vin/',
        batteryApi:'/proxy/apigee/ddv/lkcd/uid-362/v1/vehicles/',
        batteryInhibition:'/proxy/apigee/ddv/lkcd/uid-303/v1/vehicles/',
        lastSeenVehActivities:'/proxy/apigee/xvd/lsva/v1/vehicles/',
        activities:'/last-seen-vehicle-activities',
        batteryInhibitorChange:'/battery-inhibitor-change',
        batteryStatus:'/battery-status',
        settingsApi: '/proxy/apigee/s18/ev/v1/ev/',
        settingsEV:'/settings',
        settingsSocLevels: '/soc-levels',
        remoteDiagStatus: '/status',
        asap: '/proxy/apigee/aza/refservices/v1/',
        simInfoUrl:'/proxy/apigee/repository/connected-vehicles-facade/v1/vehicles/',
        simStatus:'/connectivity-info-details',
        v2gSubscriptions:'/proxy/apigee/s20/diag/v1/subscriptions?vin=',
        alerts: '/proxy/apigee/arp/v1/alerts/',
        applicabilityService: '/proxy/apigee/sc4/services-features-applicability/v1/vehicles/',
        applicabilityServiceParams: '/services-applicability/search?withOffers=false&withServices=false&withFeatures=true&withStatus=false',
        certificateInfo: '/proxy/apigee/s15/diag/v1/vehicles/',
        certificatesDiagnostic: '/certificates-diagnostic',
        certStatus:'/certificates/status',
        vehicleInfo: '/proxy/apigee/bva/vehicle-electronic-file/v2',
        hereStatus:'/proxy/apigee/s23/elcv/v1/vehicles/',
        hereSubscription:'/subscription/details',
        partsInfo: '/parts/information',
        partsSynchronization: '/parts/synchronization',
        vehicle: '/vehicles',
        csrPortalLink: 'https://internetonthemove.orange-business.com/csr/#/login',
        csrPortalLabel: 'CSR Portal',
        dataOff: 'Data Off',
        dataOn: 'Data On',
        cvc: 'CVC',
        bvm: 'BVM',
        bva: 'BVA',
        vnext: 'vNext',
        vcps: 'VCPS',
        restartSerialUrl: '/proxy/apigee/cnr/subscriptions-referential/v1/vin/subscriptions/serial-start-usage?vin=',
        arcaCnrCustomerCare : 'CNR_CUSTOMER_CARE',
        rnetCnrCustomerCare : 'IRN-74772:CNR_CUSTOMER_CAR',
        rnetCnrDealer : 'IRN-74772:CNR_DEALER',
        network : 'Network',
        customerCare : 'Customer_Care',
        cnrEnUserGuide: '/New Dialogys User Guide - Connected services - all brands_EN_11_2025.pdf',
        cnrFrUserGuide: '/Guide Utilisateur New Dialogys - Services Connectés_toutes marques _FR_11_2025.pdf',
        cnrEsUserGuide: '/New Dialogys - Guia Usuario Servicios Conectados - LATAM_11 2025 (colombia).pdf',
        cnrEsUserGuide1: '/New Dialogys Guía Usuario - Servicios Conectados - todas las marcas - Nov 2025.pdf',
        cnrPlUserGuide: '/New Dialogys User Guide - all brands_EN_11_2025 PL.pdf',
        cnrRoUserGuide: '/New Dialogys User Guide - Connected services - all brands_EN_11_2025-ro-RO.pdf',
        cnrDeUserGuide: '/Connected services user guide_DE.pdf',
        genericMethodDoc: '/Generic_Method_501.pdf',
        fileList : ['cs','de','es','fi','fr','hr','hu','it','ja','ko','nl','pl','pt','ro','ru','sk','sv','tr','zh','en'],
        chargeStatusLabels: [
            {id: '0' , value : 'CHARGE_STATUS_0'},
            {id: '1' , value : 'CHARGE_STATUS_1'},
            {id: '2' , value : 'CHARGE_STATUS_2'},
            {id: '3' , value : 'CHARGE_STATUS_3'},
            {id: '4' , value : 'CHARGE_STATUS_4'},
            {id: '5' , value : 'CHARGE_STATUS_5'},
            {id: '6' , value : 'CHARGE_STATUS_6'},
            {id: '7' , value : 'CHARGE_STATUS_7'},
            {id: '8' , value : 'CHARGE_STATUS_8'},
            {id: '9' , value : 'CHARGE_STATUS_9'},
            {id: '10' , value : 'CHARGE_STATUS_10'},
            {id: '11' , value : 'CHARGE_STATUS_11'},
            {id: '12' , value : 'CHARGE_STATUS_12'},
            {id: '13' , value : 'CHARGE_STATUS_13'},
            {id: '14' , value : 'CHARGE_STATUS_13'},
            {id: '15' , value : 'CHARGE_STATUS_13'},
           
        ],
        plugStatusLabels:[
            {id: '0' , value : 'PLUG_STATUS_0'},
            {id: '1' , value : 'PLUG_STATUS_1'},
            {id: '2' , value : 'PLUG_STATUS_2'},
            {id: '3' , value : 'PLUG_STATUS_3'}],
        soh: 'SOH',
        central: 'Central',
        provisioningActivationType: 'SERVICES_ACTIVATION',
        provisioningRealignmentType: 'REALIGNMENT',
        provisioningServiceActivationType:'SERVICES_FORCE_REACTIVATION',
        remoteCommandsHistory:'/remote-commands/history',
        remoteCommand: '/proxy/apigee/s25/diagnostic/v1/remote-commands/',
        refreshJwtConfig: '/refresh-jwt-config',
        virtualKey: 'Virtual Key',
        virtualKeyB2C: 'Virtual Key B2C',
        virtualKeyB2B: VIRTUAL_KEY_B2B_LABEL,
        blmEcu: 'BLM ECU',
        vkm: 'VKM',
        virtualBlmDetails: '/blm-details',
        virtualKeyUserRole: '/virtual-key/users-roles-delegated',
        uidTitle: 'UID 590',
        deactivateService: '/proxy/apigee/aza/v1/',
        basketInterventionDocuments: '/proxy/apidh/rest/v1/basket-interventions/documents',
        siesByGies: '/proxy/apidh/rest/v1/sies/gies',
        genericElementId: 'Y000_000_003_O',
        partReplacementIVC: 'PART_REPLACEMENT_IVC',
        partReplacementIVI: 'PART_REPLACEMENT_IVI',
        serviceReactivation:'SERVICES_REACTIVATION',
        lifeTime: 'Lifetime',
        statusOnGoing: ['TO_BE_ACTIVATED', 'ACTIVATION_IN_PROGRESS', 'ACTIVATION_IN_PROGRESS2', 'ACTIVATED', 'DEACTIVATION_IN_PROGRESS', 'DEACTIVATION_IN_PROGRES', 'DEACTIVATION_KO', 'ACTIVE', 'UNKNOWN'],
        targetServiceSids: ['20000638', '20000536', '20000670'],
        smartChargingB2B: 'Smart Charging B2B',
        smartChargingJedlix: 'Smart charging Jedlix',
        smartChargingB2C: 'Smart charging B2C',
        sidSmartChargingB2B: '20000638',
        sidSmartChargingJedlix: '20000536',
        sidSmartChargingB2C: '20000670',
        emergencyCallServiceIds: ['13590', '15307', '15339'],
        SSA: 'SSA'

    });

    angular.module('phenix').constant('rLinkMenu', {
        1:{show:false, name:'vehicleInformations', translate:'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track:'Informations véhicule'},
        2:{show:false, name:'contractsAndServices', translate:'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track:'Contrats & Services'},
    }); 

    angular.module('phenix').constant('rLinkMenuExpanded', {
        1:{show:false, name:'softAndApplications', translate:'CONNECTED_SERVICES_MENU_MAPS', track:'Maps & Applications'},
        2:{show:false, name:'diagnosis', translate:'CONNECTED_SERVICES_MENU_DIAGNOSIS', track:'Diagnostics', route:'diagnosis', display:'none' },
    });

    angular.module('phenix').constant('easyLinkMenu', {
        1:{show:false, name:'vehicleInformations', translate:'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track:'Informations véhicule'},
        2:{show:false, name:'contractsAndServices', translate:'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track:'Contrats & Services'},
    });

    angular.module('phenix').constant('easyLinkMenuExpanded', {
        1:{show:false, name:'updateCampaigns', translate:'CONNECTED_SERVICES_MENU_CAMPAIGNS', track:'Campagnes de mises à jour'},
        2:{show:false, name:'softAndApplications', translate:'CONNECTED_SERVICES_MENU_MAPS', track:'Maps & Applications'},
        3:{show:false, name:'diagnosis', translate:'CONNECTED_SERVICES_MENU_DIAGNOSIS', track:'Diagnostics', route:'diagnosis', display:'none'},
        4:{show: false, name: 'virtualKeyB2C', translate: 'Virtual Key B2C', track: 'Virtual Key B2C'},
        5:{show: false, name: 'virtualKeyB2B', translate: VIRTUAL_KEY_B2B_LABEL, track: VIRTUAL_KEY_B2B_LABEL},
        6:{show: false, name: 'hereNavigation', translate: 'HERE_NAVIGATION', track: HERE_NAVIGATION_TRACK}
    });

    angular.module('phenix').constant('vegasRlinkMenu', {
        1:{show:false, name:'vehicleInformations', translate:'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track:'Informations véhicule'},
        2:{show:false, name:'contractsAndServices', translate:'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track:'Contrats & Services'},
    });

    angular.module('phenix').constant('vegasEasylinkMenu', {
        1:{show:false, name:'vehicleInformations', translate:'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track:'Informations véhicule'},
        2:{show:false, name:'contractsAndServices', translate:'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track:'Contrats & Services'},
    });

    angular.module('phenix').constant('vegasEasylinkMenuExpanded', {
        1:{show:false, name:'updateCampaigns', translate:'CONNECTED_SERVICES_MENU_CAMPAIGNS', track:'Campagnes de mises à jour'},
        2:{show:false, name:'softAndApplications', translate:'CONNECTED_SERVICES_MENU_MAPS', track:'Maps & Applications'},
        3:{show:false, name:'diagnosis', translate:'CONNECTED_SERVICES_MENU_DIAGNOSIS', track:'Diagnostics', route:'diagnosis', display:'none'},
        4:{show:false, name:'connectedADASEhorizon', translate:'CONNECTED_SERVICES_MENU_ADAS_EHORIZON', track:'Connected ADAS/Ehorizon'},
        5:{show: false, name: 'hereNavigation', translate: 'HERE_NAVIGATION', track: HERE_NAVIGATION_TRACK}
    });

    angular.module('phenix').constant('rLinkMenuNew', {
        1: { show: false, name: 'vehicleInformations', translate: 'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track: 'Informations véhicule' },
        2: { show: false, name: 'contractsAndServices', translate: 'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track: 'Contrats & Services' },
    });

    angular.module('phenix').constant('rlinkMenuNewExpanded', {
        1:{show:false, name:'softAndApplications', translate:'CONNECTED_SERVICES_MENU_MAPS', track:'Maps & Applications'},
        2: {show:false, name:'diagnosis', translate:'CONNECTED_SERVICES_MENU_DIAGNOSIS', track:'Diagnostics', route:'diagnosis', display:'none'},
    });

    angular.module('phenix').constant('easyLinkMenuNew', {
        1: { show: false, name: 'vehicleInformations', translate: 'CONNECTED_SERVICES_MENU_VEHICLE_INFOS', track: 'Informations véhicule' },
        2: { show: false, name: 'contractsAndServices', translate: 'CONNECTED_SERVICES_MENU_CONTRACTS_SERVICES', track: 'Contrats & Services' }, 
        3: { show: false, name: 'dataConsistencies', translate: 'DATA_CONSISTENCY_MENU', track: 'Cohérence des données'},
    });

    angular.module('phenix').constant('rlinkEVMenuExpanded', {
        1:{show:false, name:'plugAndCharge', translate:'PLUG_AND_CHARGE', track:'Plug & Charge'},
        2:{show:false, name:'vehicleToGrid', translate:'VEHICLE_TO_GRID', track:'Vehicle To Grid'},
        3:{show:false, name:'vehicleToGridNew', translate:'V2G B2B Without charger', track:'V2G B2B Without charger'},
        4:{show:false, name:'evSettings', translate:'EV_SETTINGS', track:'EV Settings'}
    });

    angular.module('phenix').constant('rlinkEVSmartChargeExpanded', {
        1:{show:false, name:'plugAndCharge', translate:'PLUG_AND_CHARGE', track:'Plug & Charge'},
        2:{show:false, name:'vehicleToGrid', translate:'VEHICLE_TO_GRID', track:'Vehicle To Grid'},
        3:{show:false, name:'vehicleToGridNew', translate:'V2G B2B Without charger', track:'V2G B2B Without charger'},
        4:{show:false, name:'smartCharging', translate:'SMART_CHARGING', track:'Smart charging'},
        5:{show:false, name:'evSettings', translate:'EV_SETTINGS', track:'EV Settings'}
    });

    angular.module('phenix').constant('ddpAdministration', {
        1:{show:false, name:'ddpAudit', translate:'DDP_AUDIT', track:'Ddp Audit'}
    });

    angular.module('phenix').constant('connectedServicesOffers', {
        1:{show:false, name:'eligibleOffers', translate:'CURRENT_ELIGIBLE_OFFERS', track:'Eligible offers'},
        2:{show:false, name:'cnrUserGuide', translate:'CONNECTED_SERVICES_USER_GUIDE', track:'User Guide'}
    });

    angular.module('phenix').constant('ddphelpExpanded', {
        1:{show:false, name:'userGuide', translate:'USER_GUIDE', track:'User Guide'},
        2:{show:false, name:'genericDiagnosis', translate:'GENERIC_DIAGNOSIS', track:'Generic Diagnosis'},
    });

    angular.module('phenix').constant('rLinkUserProfile', {
        assistance_technique_N1 : "TL1",
        assistance_technique_N2 : "TL2",
        réseau_et_importateur : "Network",
        reseau_et_importateur : "Network",
        corp : "Corp"
    });

    angular.module('phenix').constant('usersProfile', {
        assistance_technique_N1 : "assistance_technique_N1",
        assistance_technique_N2 : "assistance_technique_N2",
        réseau_et_importateur : "réseau_et_importateur",
        reseau_et_importateur : "reseau_et_importateur"
    });
    angular.module('phenix').constant('easyLinkMenuNewExpanded', {
        1: { show: false, name: 'updateCampaigns', translate: 'CONNECTED_SERVICES_MENU_CAMPAIGNS', track: 'Campagnes de mises à jour' },
        2: { show: false, name: 'softAndApplications', translate: 'CONNECTED_SERVICES_MENU_MAPS', track: 'Maps & Applications' },
        3: { show: false, name: 'diagnosis', translate: 'CONNECTED_SERVICES_MENU_DIAGNOSIS', track: 'Diagnostics', route: 'diagnosis', display: 'none' },
        4: { show: false, name: 'connectedADASEhorizon', translate: 'CONNECTED_SERVICES_MENU_ADAS_EHORIZON', track: 'Connected ADAS/Ehorizon' },
        5: {show: false, name: 'virtualKeyB2C', translate: 'Virtual Key B2C', track: 'Virtual Key B2C'}, 
        6: {show: false, name: 'virtualKeyB2B', translate: VIRTUAL_KEY_B2B_LABEL, track: VIRTUAL_KEY_B2B_LABEL}, 
        7: { show: false, name: 'remoteServices', translate: 'Remote services', track: 'Remote services' },
        8:{show: false, name: 'hereNavigation', translate: 'HERE_NAVIGATION', track: HERE_NAVIGATION_TRACK}
    });
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .component('ddpAudit', {
            bindings: {
            },
            controller: DdpAuditComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/car/rLinkCar/ddpAudit.template.html'
        });

    /** @ngInject */
    function DdpAuditComponent(
        SearchArboTextualWsService
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.isAuditTabOpen = true;

        vm.exportLog = function () {
            SearchArboTextualWsService.getAllAuditData();
        };
      
    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .config(featuresRouterConfig);

    /* @ngInject */
    function featuresRouterConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.carFeatures, {
            url: '/carFeatures/:tabName',
            templateUrl: 'app/components/car/features/features.template.html',
            controller: 'FeaturesController',
            controllerAs: 'vm',
            params: {
                tabName: 'technicalCriteriaTab',
                previousState: null,
                showSubscriptionAccessMessage: false
            }
        });

        $stateProvider.state(RoutesConstants.newTechCritTab, { 
            url: '/carFeatures/:tabName',
            templateUrl: 'app/components/car/features/features.template.html',
            controller: 'FeaturesController',
            controllerAs: 'vm',
            params: {
                tabName: 'technicalCriteriaTab',
                previousState: null,
                isOpenTechCritTab: true,
                showSubscriptionAccessMessage: false
            }
        });

        $stateProvider.state(RoutesConstants.carFeaturesView, {
            url: '/carFeatures/:tabName',
            templateUrl: 'app/components/car/features/components/carOts/carOts.template.html',
            controller: 'CarOtsController',
            controllerAs: 'vm',
            params: {
                tabName: 'otsTab',
                previousState: null
            }
          });
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('FeaturesController', FeaturesController);

    angular
        .module('phenix')
        .run(['$anchorScroll', function ($anchorScroll) {
            $anchorScroll.yOffset = 0;
        }]);

    /* @ngInject */
    function FeaturesController(
        $timeout,
        $window,
        $rootScope,
        $state,
        $translate,
        $scope,
        $anchorScroll,

        RoutesConstants,
        AlertsLocationService,
        CacheService,
        CacheConstants,
        CarTechnicalFeaturesConstants,

        FeaturesConstants,
        MainMetierService,UtilsMetierService,configConstantes
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.isCarContextChanged = false;
        vm.isLightFilterChanged = false;
        vm.recapCarAPI = null;
        vm.featureTabs = FeaturesConstants.technicalTabs;
        vm.isHideOTS = isHideOTS;
        vm.isHideCarTechnical = isHideCarTechnical;
        vm.isHideMaintenanceProgram = isHideMaintenanceProgram;
        vm.isHideMaintenanceHistoryProgram = isHideMaintenanceHistoryProgram;
        vm.car = CacheService.getCarContext();
        vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
        var tabIndex = CacheService.getObject(CacheConstants.tabIndex);
        vm.userProfil = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.userProfil.roles);
        vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
        vm.isCirSentVin =  vm.car  ? MainMetierService.isCirSentVin( vm.car.vin):null;
        vm.showSubscriptionAccessMessage = $state.params && $state.params.showSubscriptionAccessMessage;
        vm.showTechCritTab = false;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.isAsomValidAllTechCritAccess = isAsomValidAllTechCritAccess;
        vm.isOpenTechCritTab = isOpenTechCritTab;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function shouldHideMaintenanceTab(vin, registrationNumber, documentType) {
            var hasNoVehicleInfo = !(vin || registrationNumber);
            var isTechCritTabOpen = $state.params && $state.params.isOpenTechCritTab;
            
            const hasDocumentAccess = UtilsMetierService.hasAsomDocumentAccess(documentType, vm.isIndependentUser);
            const isRestrictedUser = !hasDocumentAccess;
            
            return hasNoVehicleInfo || isTechCritTabOpen || isRestrictedUser;
        }

        function isAsomValidAllTechCritAccess() {
            const doctypes = ['REF-BVM', 'OTS', 'HM', 'REP'];
            return doctypes.some(function (docType) {
                return UtilsMetierService.hasAsomDocumentAccess(docType, vm.isIndependentUser);
            });
        }

        function isOpenTechCritTab() {
            return $state.params && $state.params.isOpenTechCritTab;
        }

        this.$onInit = function () {
            vm.scrollToTopButtonClass = 'scrollToTopButtonHidden';

            if (vm.showSubscriptionAccessMessage) {
                $timeout(function () {
                    MainMetierService.AsomDocAccessPopIn(vm.userProfil);
                }, 0);
            }
            
            if($state.$current.name === RoutesConstants.newTechCritTab){
                if($state.params && $state.params.isOpenTechCritTab){
                    vm.showTechCritTab = true;
                }                
            }
            if( vm.isIndependentUser && vm.userProfil.accountType === FeaturesConstants.AUTOMOBILE_REPAIRER && vm.isAsomValidDocAccess === 'false' && !vm.isCirSentVin){
                if($state.params.tabName && $state.params.tabName != ''){
                    vm.activeTab=$state.params.tabName;
                    selectTab(vm.activeTab);
                } 
            }
            else{
                var tabName = ($state.params.tabName && $state.params.tabName != '') ? $state.params.tabName
                                : ($state.current.params.tabName && $state.current.params.tabName != '') ? $state.current.params.tabName : '';
            if(tabName && tabName != '')
                vm.activeTab=tabName;
                selectTab(vm.activeTab);
            }
            vm.scrollToTop = scrollToTop;
            vm.goToBack = goToBack;
            vm.selectTab = selectTab;
            initializeScroll();           
        }

        /**
         * @name goToBack
         * @desc go previous page
         */
        function goToBack() {
            CacheService.setObject(CacheConstants.goToBackFromFeatures, true);

            if (vm.showSubscriptionAccessMessage) {
                $state.go(RoutesConstants.carSearch);
                return;
            }

            if (vm.isCarContextChanged) {
                //delete arbo navigation from cache
                CacheService.removeObject(CacheConstants.nodeSelect);
                CacheService.removeObject(CacheConstants.levelsDoc);
                CacheService.removeObject(CacheConstants.nodeFromSearchArbo);

                $state.go(RoutesConstants.carSearchResult);
            }
            else {
                if ($state.params.previousState && $state.params.previousState != null && (!$state.params.previousState.WDList || $state.params.previousState.thumbnailData
                    || $state.params.previousState.wiringDiagramData)) {
                    $state.go(RoutesConstants.electricalSchemaLevel3Single, $state.params.previousState);
                } else if ($state.params.previousState && $state.params.previousState != null && $state.params.previousState.WDList) {
                    $state.go(RoutesConstants.electricalSchemaLevel3Multi, $state.params.previousState);
                }
                else if(tabIndex){
                    $state.go(RoutesConstants.carSearchResult);
                    CacheService.removeObject(CacheConstants.tabIndex);
                }
                else {
                    var isLightFiltering = CacheService.getObject(CarTechnicalFeaturesConstants.isLightFiltering);
                    if(!_.isEmpty(isLightFiltering) && !vm.isLightFilterChanged){
                        $window.history.back();
                    }else{
                        $state.go(RoutesConstants.carSearchResult, {
                        }, { notify: true, reload: true, inherit: false });
                    }
                    
                }
            }
        }

        /**
         * @name selectTab
         * @desc this function is fired when user click on tab (technical criteria, ots ...)
         * @param {String} tab - selected tab's name
         */
        function selectTab(tab) {
            vm.activeTab = tab;
            if( vm.isIndependentUser && vm.userProfil.accountType === FeaturesConstants.AUTOMOBILE_REPAIRER && vm.isAsomValidDocAccess === 'false' && !vm.isCirSentVin){
            $timeout(function () {
            $rootScope.$broadcast('phx-opentab' + tab, {});
            },100)
        }else{
            $rootScope.$broadcast('phx-opentab' + tab, {});
        }
            AlertsLocationService.buildAlerts({ typeOfElement: getTraductionTabLabel(tab) }, 'CFEATURES');

            // Replace the value of the tab parameter in the url to ensure back button to work
            $state.transitionTo($state.$current.name, { tabName: tab }, {
                location: "replace",
                inherit: true,
                relative: $state.$current,
                notify: false
            })
        }

        /**
         * @name scrollToTop
         * @desc This action is fired when user click on top button
         */
        function scrollToTop() {
            if(vm.showTechCritTab){
                $state.go(RoutesConstants.newTechCritTab, {
                    url: '/carFeatures/:tabName',
                    params: {
                        tabName: vm.activeTab
                    }
                });
            }
            else{
                $state.go(RoutesConstants.carFeatures, {
                    url: '/carFeatures/:tabName',
                    params: {
                        tabName: vm.activeTab
                    }
                });
            }
            $anchorScroll();
            vm.scrollToTopButtonClass = 'scrollToTopButtonHidden';
        }

        /**
         * @name hideIfJP
         */
        function isHideOTS() {
            vm.hide = false;
            vm.countryCode = CacheService.getUserContext().countryCode;
            const hasDocumentAccess = UtilsMetierService.hasAsomDocumentAccess('OTS', vm.isIndependentUser);
            const isJPCountry = vm.countryCode === "JP";
            const isRestrictedUser = !hasDocumentAccess;
            const isTechCritTabOpen = $state.params && $state.params.isOpenTechCritTab;
            if (isJPCountry || isRestrictedUser || isTechCritTabOpen){
                vm.hide = true;
            }
            return vm.hide;
        }
        function isHideCarTechnical(){
            vm.hide = false;
            vm.userProfil = CacheService.getUserProfile();
            const hasDocumentAccess = UtilsMetierService.hasAsomDocumentAccess('REF-BVM', vm.isIndependentUser);
            if ( !hasDocumentAccess){
                vm.hide = true;
            }
            return vm.hide;
        }

        function isHideMaintenanceProgram() {
            vm.hide = false;
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var vin  = contextCarSearch.vehicle.vin;
            var registrationNumber = contextCarSearch.vehicle.registrationNumber;
            vm.userProfil = CacheService.getUserProfile();
            
            if (shouldHideMaintenanceTab(vin, registrationNumber, 'REP')){
                vm.hide = true;
            }
            
            return vm.hide;
        }

        function isHideMaintenanceHistoryProgram() {
            vm.hide = false;
            var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            var vin  = contextCarSearch.vehicle.vin;
            var registrationNumber = contextCarSearch.vehicle.registrationNumber;
            
            if (shouldHideMaintenanceTab(vin, registrationNumber, 'HM')){
                vm.hide = true;
            }
            
            return vm.hide;
        }
        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @name getTraductionTabLabel
         * @desc get the traduction label of the selected tab
         * @param {String} tab
         */
        function getTraductionTabLabel(tab) {
            var selectedTab;
            switch (tab) {
                case vm.featureTabs.otsTab:
                    selectedTab = $translate.instant('VEHICLE_DETAIL_TAB_OTS');
                    break;
                case vm.featureTabs.maintenanceProgramTab:
                    selectedTab = $translate.instant('VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM');
                    break;
                case vm.featureTabs.vehicleMaintenanceHistoryTab:
                    selectedTab = "vehicleMaintenanceHistoryTab"; // $translate.instant('VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM');
                    break;
                default:
                selectedTab = $translate.instant('VEHICLE_DETAIL_TAB_DATA_SHEET');
                    break;
            }
            return selectedTab;
        }

        /**
         * @name initializeScroll
         * @desc initialize scroll to know if we show / hide top button
         */
        function initializeScroll() {
            angular.element($window).bind("scroll", function () {
                if (this.pageYOffset > (this.screen.height) * 0.05) {
                    vm.scrolled = true;
                    vm.scrollToTopButtonClass = 'scrollToTopButtonShow';

                }
                $scope.$apply();
            });
        }
    }
})();

'use strict';

angular
    .module('phenix').constant('FeaturesConstants',{
        technicalTabs:{
            technicalCriteriaTab: 'technicalCriteriaTab',
            otsTab: 'otsTab',
            maintenanceProgramTab: 'maintenanceProgramTab',
            vehicleMaintenanceHistoryTab: 'vehicleMaintenanceHistoryTab'
        },
    endpoint: {
        pdfExport: 'maintenance/pdfExport',
        releases: '/ndReleases/',
        releaseDocument: '/documents/s3Url'
    },
    newreleases:'/New-Releases-',
    json:'.json',
    defaultLangFile:'en/New-Releases-EN.json',
    langList : [ 'fr','en','ru','cs','de','nl','pl','it','es','pt','pt-BR','hu','sk'],
    kilometerConstant : 1.60934,
    milesConstant : 0.62137,
    AUTOMOBILE_REPAIRER: 'Automobile repairer'
    });

(function () {
    angular
        .module('phenix')
        .directive('svgToNode', behavior)

    function behavior(ScrollService, configConstantes) {
        return {
            restrict: 'A',
            link: function (scope, elements, attrs) {
                var list = elements[0].querySelectorAll('text');
                var nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
                var hightlightSelectedElement = hightlightElement(nissanUserURL);

                if (!list)
                    return;
                angular.forEach(list, function (elem) {
                    var container =  angular.element(elem)[0];
                    var id = '#_' + container.textContent;
                    container.addEventListener('click', function () {
                        ScrollService.animateTo(id, 300);
                        var node = id + ' .linkPiece2 a';
                        hightlightSelectedElement(node);
                    })
                })
            }
        }
    }

    function hightlightElement(nissanUserURL) { 
        var tmpId = null;

        return function (node) {
            var element = angular.element(document.querySelector(node));
            
            if (nissanUserURL) {
                element.addClass('nissanHighlight');
            } else {
                element.addClass('hightlight');
            }

            if (tmpId && tmpId != node) {
                var previousElement = angular.element(document.querySelector(tmpId));
                previousElement.removeClass('hightlight');
                previousElement.removeClass('nissanHighlight');
            }

            tmpId = node;
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider
            .state(RoutesConstants.carSearchResultNoCarContext, {
                url: '/carSearchResultNoCarContext',
                templateUrl: 'app/components/car/carSearchResult/carSearchResultNoCarContext.template.html',
                params: {
                    vin: null,
                    immat: null,
                    or: null,
                    vehiclePresentInDMSbutNotInBVM: true
                },
                controller: 'carSearchResultNoCarContextController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('carSearchResultNoCarContextController', carSearchResultNoCarContextController);


    /** @ngInject */
    function carSearchResultNoCarContextController(
        $state,

        CacheService,
        RecapCarMetierService,
        CacheConstants,configConstantes) {

        /** VARIABLES */

        var vm = this;
        vm.vin = '';
        vm.immat = '';
        vm.orderNumber = ''
        vm.or = '';
        vm.clientDetails = '';
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        /** FUNCTIONS */

        vm.reinitContext = reinitContext;

        this.$onInit = function () {

            // Make sure we always display VIN and registration number even if we refresh the page
            vm.dataFromCarContext = CacheService.getObject(CacheConstants.contextCarSearch);
            var vin = vm.dataFromCarContext.vehicle.vin;
            var immat = vm.dataFromCarContext.vehicle.registrationNumber;


            if (vin && immat) {
                vm.carDetails = vin + ' | ' + immat;
                vm.kilometers = vm.dataFromCarContext.vehicle.mileage;
                if (vm.dataFromCarContext.customer) {
                    vm.clientDetails = vm.dataFromCarContext.customer.firstName + ' ' + vm.dataFromCarContext.customer.name + ' (' + vm.dataFromCarContext.customer.dmsCustomerId + ')';
                }

                //récupérer la valeur orderNumber dans phenix.dmsResponse si existe
                vm.dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);



                if (vm.dmsResponse && vm.dmsResponse.orderNumber) {
                    vm.orderNumber = vm.dmsResponse.orderNumber;
                }

            }
            else if ($state.params && $state.params.vin != null) {
                vm.vin = $state.params.vin;
                vm.immat = $state.params.immat;
                vm.or = $state.params.or;
            }
            else {
                vm.vin = vin;
                vm.immat = immat;
            }

        };

        /**
        * @name reinitContext
        * @desc re-intialize context car
        * this action trigger when user click on a page having recap-car directive
        * @memberOf Controllers.recapCarController
        */

        function reinitContext() {
            return RecapCarMetierService.reinitContext();
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.carSearchResult, {
        url: '/carSearchResult',
        templateUrl: 'app/components/car/carSearchResult/carSearchResult.html',
        controller: 'carSearchResultCtrl',
        controllerAs: 'cSearchResultCtrl',
        params: {
          data: null,
          tab: null,
          id: null,
          idOptional: null,
          isUserComingFromClip : false,
          isFromWDUrlLink: false,
          vinComingFromClip : null,
          symptomComingFromClip : null,
          WDT: null,
          LC: null,
          isDetailMainComponentRequired: false,
          docTypeSelected:null,
          functionId:null,
          subFunctionId: null,
          titleId:null,
          diagFileId: null,
          isUserComingFromMD:false,
          redirectToAlerts: false,
          node1:null,
          node2:null,
          node3:null,
          isnodeLinkNavigation: false,
          maintenanceProgLinkNavigate: false,
          isFromDiagFileDetails:false,
          selectedDiagFileId: null,
          systemDocSubMenu:null,
          systemDocResponse:null,
          reference: null,
          isTextSearchRedirect: false

        }
      });
  }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('carSearchResultCtrl', carSearchResultCtrl);

    /** @ngInject */
    function carSearchResultCtrl(CacheService, CacheConstants, configConstantes, FeaturesConstants, RoutesConstants,  DealerManagerSystemeService, $scope,$q,AxleGeometryService,
        $rootScope, CarSearchMetierService, CarTechnicalCriteriaMetierService, activeVinService, CarSearchResultConstants, rLinkConstant,
        UtilsMetierService, $log, $translate, $mdDialog, MainMetierService,RLinkCarMetierService,RLinkCarWSService, DocumentsWsService, $stateParams,$state,
        carMaintenanceProgramWsService) { 
        var vm = this;
        vm.recapCarAPI = null;
        // Ensure isFromWDUrlLink is always a boolean
        vm.isFromWDUrlLink = ($stateParams.isFromWDUrlLink === true || $stateParams.isFromWDUrlLink === 'true');
        vm.isEasyLinkVehicle = false;
        vm.isUnknownVehicle = false;
        vm.isnullVehicle = false;
        vm.axleGeometry = false;
        vm.getVehicleAssemblySpareParts = getVehicleAssemblySpareParts;
        vm.getVinMessage = getVinMessage;
        vm.displayAlertsData = displayAlertsData;
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.userProfile = CacheService.getObject(CacheConstants.profil);
        vm.isRnetUser = MainMetierService.isRnetUserType(vm.userProfile.userType);
        vm.roles = (vm.userProfile && vm.userProfile.roles)?vm.userProfile.roles : null;
        vm.capVinAlertData = false;
        var contextCarRequest = CacheService.getCarContext();
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.isVehicleRemoteDiag=false;
        var manufacturingDate = CacheService.getObject(CacheConstants.contextCarRequest);
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.isNDAssistantEnabled = UtilsMetierService.isNDChatBotEnabled();
        vm.isNissanConnectedServicesUser = MainMetierService.isNissanConnectedServices(vm.roles);

        function init() {
            // Check if coming from diagnostic file details page - skip API calls if true
            const isComingFromDiagFileDetails = $state.params && $state.params.isFromDiagFileDetails;            
            if (isComingFromDiagFileDetails) {
                return;
            }           
            var lsrInfo = CacheService.getObject(CacheConstants.bvaApigee);
            if (!lsrInfo && manufacturingDate && manufacturingDate.variableCriterias &&
                manufacturingDate.variableCriterias.APVDT1 &&
                !(moment(manufacturingDate.variableCriterias.APVDT1, 'YYYY-MM-DD').isBefore(moment(CarSearchResultConstants.sparePartsAvailability))) && !vm.contextCarBrandCheck){
                getVehicleAssemblySpareParts();
            }

            var isRedirectFromDesyre = CacheService.getObject(CacheConstants.isRedirectFromDesyre);
            if (manufacturingDate && !_.isEmpty(manufacturingDate) &&
                ($rootScope.previousState === RoutesConstants.carSearch || isRedirectFromDesyre)) {
                getVinMessage().finally(function () {
                    $rootScope.$emit('vinSearchPopinsCompleted');
                });
            }

            if (isRedirectFromDesyre && manufacturingDate && manufacturingDate.vin) {
                carMaintenanceProgramWsService.getVinRep({ vin: manufacturingDate.vin }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }

            var isDmsConnected = DealerManagerSystemeService.getHookResult();

            var localizedData = CarSearchMetierService.getLocalizedData();

            if((!localizedData || (localizedData && !localizedData.hasData))){
                CarTechnicalCriteriaMetierService.getTechnical(isDmsConnected).then(function (response) {
                    CarSearchMetierService.setLocalizedData(true,response);

                    $rootScope.$broadcast('technicalCriteria',response);

                }).catch(function(error){
                    $rootScope.$broadcast('technicalCriteria',null);
                });
            }

            vm.hideDocsVisited = CacheService.getObject(CacheConstants.hideDocsVisited);

            // Call service breakingNews to get data
            if(!UtilsMetierService.isIndependentUser() && !vm.nissanUserURL){
                CarSearchMetierService.getBreakingNews().then(function (response) {
                    CacheService.setBreakingNewsNoCarContext(response);
                    $rootScope.$emit('loadNews', response);
                });
            }

            // Axle Geometry
                fetchGeometryApplicabilities();
            // Connected Platform
                var unlistenIsRLink2Vehicle = $rootScope.$on('isRLink2Vehicle', function(event, isRLink2Vehicle) {
                    if((vm.nissanUserURL && vm.isNissanConnectedServicesUser) || (!vm.nissanUserURL && (!UtilsMetierService.isIndependentUser() || (UtilsMetierService.isIndependentUser() && ($rootScope.asomDocList['MD-REMOTE'] || $rootScope.asomDocList['CS']))) && !isRLink2Vehicle && manufacturingDate && manufacturingDate.vin && manufacturingDate.variableCriterias && (!manufacturingDate.variableCriterias.APVDT1 || (manufacturingDate.variableCriterias.APVDT1 && (moment(manufacturingDate.variableCriterias.APVDT1, 'YYYY-MM-DD').isAfter(moment(CarSearchResultConstants.nonConnectedVehicleDateLimit))))))) {
                        CarSearchMetierService.getConnectedPlatform().then( function (response) {
                            if (response) {
                                CacheService.setObject(CacheConstants.connectedPlatform, response);
                                if (response.platform === 'EASYLINK' || response.platform === 'AVN' || response.platform === 'CVC' || response.platform === 'RGDC') {
                                    vm.isEasyLinkVehicle = true;
                                }
                                if (response.platform === 'UNKNOWN') {
                                    vm.isUnknownVehicle = true;
                                }
                                if (response.platform === null) {
                                    vm.isnullVehicle = true;
                                }
                                
                                $rootScope.isConnectedVehicle = vm.isEasyLinkVehicle && !vm.isUnknownVehicle;
                                
                                $rootScope.$broadcast('assistTool',{isEasyLinkVehicle : vm.isEasyLinkVehicle,
                                    isUnknownVehicle: vm.isUnknownVehicle});
                            }
                            
                        })
                        .then(function() {
                            var hasEligibleOffers = null;
                            vm.multiMediaCheck = MainMetierService.multimediaInformation();
                            var vinEligibleOffers = CacheService.getObject(CacheConstants.vinEligibleOffers);
                            var hasDealerRole = MainMetierService.hasDealerRole();
                            if(vm.multiMediaCheck && contextCarRequest.vin && !vinEligibleOffers && hasDealerRole){ 

                                {
                                    RLinkCarWSService.getEligibleOffers(contextCarRequest.vin, rLinkConstant.network)
                                        .then(function (offerResp) {
                                            if (offerResp && offerResp.contextualOffers && offerResp.contextualOffers.length > 0) {
                                                hasEligibleOffers = true;
                                            

                                            } else {
                                                hasEligibleOffers = false;
                                                
                                            }
                                        })
                                        .catch(function (err) {
                                            hasEligibleOffers = false;
                                            
                                        })
                                        .finally(function() {
                                            var carContexts = CacheService.getObject(CacheConstants.contextCarSearch);
                                            if(carContexts && carContexts.vehicle){
                                                _.assign(carContexts.vehicle,{'hasEligibleOffers': hasEligibleOffers});
                                            }
                                            CacheService.setObject(CacheConstants.contextCarSearch, carContexts);
                                            CacheService.setObject(CacheConstants.vinEligibleOffers,true);
                                            $rootScope.$broadcast('hasEligibleOffers');
                                        });
                                }
                            }
                        })
                        .catch( function(err){
                            console.error("Error while loading connected platform", err.data);
                        });
                    }
                });

                if ((vm.nissanUserURL || vm.isRnetUser || vm.isArcaUser  || (UtilsMetierService.isIndependentUser() && ($rootScope.asomDocList['MD-REMOTE'] || $rootScope.asomDocList['CS']))) && contextCarRequest && contextCarRequest.vin && contextCarRequest.fixedCriterias['E70'] === 'AIVCT' ) {
                    RLinkCarMetierService.getFeatureId(contextCarRequest.vin)
                    .then(function (response) {
                        if (response && response.features) {
                            activeVinService.setFeatureData(response);
                            var firstCap = _.find(response.features, { 'featureId': 820 });
                            var firstCapData = firstCap ? firstCap : null;
                            var secondCap = _.find(response.features, { 'featureId': 204 });
                            var secondCapData = secondCap ? secondCap : null;
                            response.features.forEach(function (item) {
                                if (item.featureId === 2852 && item.status === 'ACTIVATED') {
                                   vm.isVehicleRemoteDiag = true;  
                                }
                            }) 
                        }
                        activeVinService.setVinDiag( vm.isVehicleRemoteDiag ? true:false);
                        if(!UtilsMetierService.isIndependentUser()){
                            if(!_.isEmpty(firstCapData)){
                                displayAlertsData(firstCapData);
                            }
                            else if(!_.isEmpty(secondCapData)){
                                displayAlertsData(secondCapData);
                            }
                            if(_.isEmpty(firstCapData) && _.isEmpty(secondCapData)){
                                vm.capVinAlertData = true;
                            }
                            if(vm.capVinAlertData){
                                $rootScope.$broadcast('alertDisplay', {isAlert: false});
                                activeVinService.setActiveData(false);
                                activeVinService.setAlertData(false);
                            }
                        }
                        
                    }).catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
                }
                else{
                    $rootScope.$broadcast('alertDisplay', {isAlert: false});
                    activeVinService.setActiveData(false);
                    activeVinService.setAlertData(false);
                }

            $scope.$on("$destroy", function() {
                unlistenIsRLink2Vehicle();
            })
        }

        function displayAlertsData(res){
            if (res && res.status === "ACTIVATED") {
                activeVinService.setActiveData(true);
                var param = {
                    status: 1,
                    fields: false
                }

                CarSearchMetierService.getProactiveAlert(param).then(function (alertResponse) {
                    if (!_.isEmpty(alertResponse)) {
                        $rootScope.$broadcast('alertDisplay', { isAlert: true });
                    }
                    else{
                        $rootScope.$broadcast('alertDisplay', {isAlert: false});
                        activeVinService.setAlertData(false);
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }
        }

        function getVinMessage() {
            var carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var searchedVin = normalizeVin(carContextRequest && carContextRequest.vin);
            var tolvVinInformationUrl = configConstantes.ndHelpUrl + '/tolvVinInformation.json';

            return DocumentsWsService.getSVG2(tolvVinInformationUrl).then(function (response) {
                if (containsVin(response, searchedVin)) {
                    return showTolvPopin();
                }

                return showStandardVinMessage(carContextRequest);
            }).catch(function () {
                return showStandardVinMessage(carContextRequest);
            });
        }

        function showStandardVinMessage(carContextRequest) {
            return DocumentsWsService.getSVG2(configConstantes.ndHelpUrl + '/popinInformation.json').then(function (response) {
                if (response && response.popinInformation) {
                    var userProfile = CacheService.getObject(CacheConstants.profil);
                    var displayText = [];
                    response.popinInformation.forEach(function (item) { 
                        if (item.MTC && item.OBJ) { 
                            var mtcCriterias = item.MTC.split('/'); 
                            var mtcObjects = item.OBJ.split('/'); 
                            var mtcCheck = false; 
                            for (var i = 0; i < mtcCriterias.length; i++) { 
                                for (var j = i; j < mtcObjects.length; j++) { 
                                    if (mtcCriterias[i].includes(',')) { 
                                        var criteriaArray = mtcCriterias[i].split(',');
                                        if (criteriaArray.includes(carContextRequest.fixedCriterias[mtcObjects[j]])) { 
                                            break; 
                                        } else { 
                                            mtcCheck = true; 
                                        } 
                                    } else if (mtcCriterias[i] == carContextRequest.fixedCriterias[mtcObjects[j]]) { 
                                        break; 
                                    } else { 
                                        mtcCheck = true; 
                                    } 
                                } 
                            } 
                            if (!mtcCheck) { displayText.push(item); } } })

                    if (displayText && !_.isEmpty(displayText)) {
                        var displayMessage = null;
                        displayMessage = _.find(displayText, function(item){
                            if(userProfile.portal.code.toUpperCase() == item.LAN.toUpperCase())
                                return item.TXT;                            
                        });
                        if(!displayMessage){
                            displayMessage = _.find(displayText, function(item){
                                if(item.LAN == "EN") {
                                    return item.TXT;
                                }                          
                            });
                        }
                        var isIndependentUser = UtilsMetierService.isIndependentUser();
                        var hasOnlySubscriptionDocumentTypes = false;
                        if (isIndependentUser) {
                            var subscriptionDocumentTypes = ['REF-BVM', 'OTS', 'REP', 'HM'];
                            var asomDocList = $rootScope.asomDocList || MainMetierService.getAsomDocrights();
                            var subscriptionDocumentTypeKeys = Object.keys(asomDocList || {}).filter(function (documentType) {
                                return asomDocList[documentType];
                            });
                            hasOnlySubscriptionDocumentTypes = subscriptionDocumentTypeKeys.length > 0 &&
                                subscriptionDocumentTypeKeys.every(function (documentType) {
                                    return subscriptionDocumentTypes.includes(documentType);
                                });
                        }

                        if (displayMessage && (!isIndependentUser || !hasOnlySubscriptionDocumentTypes)) {
                            return showPopinMessage(displayMessage.TXT);
                        }
                    }
                }
            });
        }

        function containsVin(response, searchedVin) {
            if (!searchedVin) {
                return false;
            }

            var vinValues = response;
            if (response && !Array.isArray(response)) {
                vinValues = response.vins || response.VINs || response.vinList || response.tolvVins || response.data || [];
            }
            if (!Array.isArray(vinValues)) {
                vinValues = [vinValues];
            }

            return vinValues.some(function (item) {
                if (item && typeof item === 'object') {
                    item = item.vin;
                }
                return normalizeVin(item) === searchedVin;
            });
        }

        function normalizeVin(vin) {
            return String(vin || '').replace(/\s+/g, '').toUpperCase();
        }

        function showTolvPopin() {
            var message = $translate.instant('TOLV_RETROFIT_MESSAGE');

            return showPopinMessage(message);
        }

        function showPopinMessage(message) {
            var body = angular.element(document.body);
            return $mdDialog.show({
                parent: body,
                template: '<div class = "popinInfo "style = "padding:10px">' + '<div style="position: absolute; right:15px;"><em class= "fa fa-close" ng-click="close()"></em></div >' + '<div class="renault-font">' + message + '</div>' + '</div>',
                bindToController: true,
                clickOutsideToClose: true,
                multiple: true,
                scope: angular.extend($scope.$new(), { close: function () { $mdDialog.cancel(); } }),
                onComplete: function () {
                    var dialog = document.querySelector('.popinInfo .renault-font');
                    if (dialog) {
                        dialog.querySelectorAll('p, span').forEach(function(el) {
                            el.style.setProperty('font-family', 'var(--renaultFontRegular)', 'important');
                            el.style.setProperty('font-size', 'var(--renaultMediumFont)', 'important');
                        });
                    }
                    angular.element(document.querySelectorAll("div.popinInfo a[target]").forEach(function (item) {
                        item.addEventListener('click', function (event) {
                            if (event.currentTarget && event.currentTarget.id) {
                                $rootScope.$emit('popinInfoActiveLinks', event.currentTarget.id);
                            }
                        });
                    }));
                }
            });
        }

    function getVehicleAssemblySpareParts(){
        CarSearchMetierService.getSparePartsDetails().then(function (responsePwt) {
            if(responsePwt && !_.isEmpty(responsePwt) && _.has(responsePwt,'partsList') && !_.isEmpty(responsePwt.partsList)){
                CacheService.setObject(CacheConstants.bvaApigee,responsePwt);
            }
        }).catch(function(){
            $log.debug($translate.instant('ERROR'));
      });
    }
       

        function fetchGeometryApplicabilities() {
            AxleGeometryService.getApplicabilities().then(function (axleGeometry) {
                vm.axleGeometry = axleGeometry;
                $rootScope.$broadcast('axleGeometry',axleGeometry);
            });
        }
        
        init();
    }
})();

'use strict';

angular.module('phenix').constant('CarSearchResultConstants', {
    searchByTextsIds: '/proxy/apidh/rest/v1/texts/ids',
    autoCompleteList:'/proxy/apidh/rest/v1/searchEngine/autocomplete?limit=10',
    searchTypes: {
        searchByArbo: 'searchByArbo',
        searchByDiagnostic: 'searchByDiagnostic',
        searchBySpecializedTool: 'searchBySpecializedTool',
        axleGeometry: 'axleGeometry',
        consultElectricalShema: 'consultElectricalShema',
        showVehicleMultimediaInformation: 'showVehicleMultimediaInformation',
        searchByDiagFiles: 'searchByDiagFiles'
    },
    listRLink: ["RA38D", "RA39D", "RA40D", "RA41D", "RAD23D", "RAD24D", "RAD32A", "RAD64A", "RAD65A", "RAD66A",
                "RAD67A", "RAD68A", "RAD69A", "RAD85A", "RAD86A", "RAD71A", "RAD72A", "RAD77A"], //list of codes corresponding to a car equipped with RLINK2 tech, imported from BVM
    listRLink1: ["NAV3G3", "NAV3G5"],
    rLink1Code: "408",
    rLink2Code: "425", //key corresponding to the value above of RLINK 2 cars
    sparePartsAvailability: "2012-07-01",
    nonConnectedVehicleDateLimit: "2012-01-01",
    searchEngineDocs:'/proxy/apidh/rest/v1/searchEngine/search',
    electronicRepairLink:'https://repairnav.rparts.renault.com/',
    serviceWeatherLink:'https://dynmo-ope.live.dynatrace.com/dashboards/11f14977-68dd-4d6a-88fd-ed27503f84c8?auth=dt0c01.MKZ5ZLQKFYXOKUKYP4YVSZEZ.IQERX5MWVO6PCKJXUSALGFXZWK2VEJDA5JDLQPS4QW6EE4CAPQRBSWIHQ2AEVAZJ#dashboard;id=11f14977-68dd-4d6a-88fd-ed27503f84c8;gtf=-5m;reportId=;gf=-8186173754852886976',
    nissanServiceWeatherLink:'https://dynmo-ope.live.dynatrace.com/dashboards/65642e35-5413-4b77-a4fb-1587d48750db?auth=dt0c01.KSGCINS5UZSYBLQYMDSQFYR6.IGLYYCO5UUHMQ4TPALRB7J6CWGKF76C223YPMTU7BHMXYJNSNZYI3MUAJB6ONINL',
    boschLink: 'https://service-solutions.dcs2.renault.com/',
    connectServicesLink: 'https://mdx.dcs.renault.com/allianceupdate.html',
    accessoriesWebsiteLink:'https://accessories.manuals.renaultgroup.com/en/home',  
    dabSiteLink: 'https://dab.dcs2.renault.com/home',  
    repairCountryList: ["FR", "BE", "LU", "NL", "DE", "CH", "ES", "IT", "PL", "AT", "GB", "BG", "CY", "HR", "DK", "EE", "FI", "HU", "IE", "LV", "LT", "MT", "PT", "CZ", "RO", "SK", "SI", "SE"],
    eGuideLink:'http://www.e-guide.renault.com/portail/',
    autoSearchLang: ['zh','ko','ja'],
    nodeIdsAxleAssembly: ['N-21922','N-21369'],
    nodeIdTires : 'N-TIRES',
    garageEquipmentLink: 'https://www.renault-equipment.com',
    userBox: 'https://www.userguide-renaultgroup.com/',
    reuseLinks:'https://sao.dcs2.renault.com/okta.php',
    searchLabels : {
      PR : "CAR_SEARCH_RESULT_FILTER_PR",
      TM : "CAR_SEARCH_RESULT_FILTER_TM",
      MR : "CAR_SEARCH_RESULT_FILTER_MR",
      MD : "CAR_SEARCH_RESULT_FILTER_MD"
    },
    renaultPrimaryColor : '#978b7f',
    renaultSmallFont : '12px',
    renaultMediumFont : '14px',
    renaultLargeFont : '16px',
    renaultExtraLargeFont : '18px',
    asomDocList : {MR: true, PR: true, AG: true, WD: true, MD: true, ST: true, TM: true, REP: true, HM: true, BT: true, ICP: true, 'PR-ILL': true, CS: true, 'REF-BVM': true, 'MD-DIAGFILES': true, 'PR-HERCULES': true },
    asomDocListSessionValue: [{"productName":"ND","active":true,"documentList":[{"documentType":"MD","documentDescription":"Diagnostic Method"},{"documentType":"WD","documentDescription":"Wiring Diagram"},{"documentType":"MR","documentDescription":"Repair Method"},{"documentType":"BT","documentDescription":"Technical Bulletin"},{"documentType":"TM","documentDescription":"Labor Time"},{"documentType":"PR","documentDescription":"Spare Parts"},{"documentType":"AG","documentDescription":"LCV Axle Geometry"},{"documentType":"ST","documentDescription":"Special Tools"},{"documentType":"REP","documentDescription":"Periodic Revision Sheet"},{"documentType":"HM","documentDescription":"History of maintenance"},{"documentType":"ICP","documentDescription":"Renault Tech-Converted Product"},{"documentType":"PR-ILL","documentDescription":"Spare Parts Illustration"},{"documentType":"CS","documentDescription":"Connected Services"},{"documentType":"REF-BVM","documentDescription":"BVM Objects and Criterias Labels"},{"documentType":"MD-DIAGFILES","documentDescription":"Diagnostic Files"},{"documentType":"PR-HERCULES","documentDescription":"PR Hercules"}]}], 
    node2HorseList: ['N-21947','N-22009','N-21901'],
    node2WDHorseList: ['2003','2004','2005'],
    dataPolicyFileName: "Notice_Data_Privacy",
    cguFileName: "Conditions_Générales_d_Utilisation",
    cookiesFileName: "Cookie_Policy",
    ndFooterFileDate: "NewDialogys_Oct_2023",
    nissanArcaProfile:["catPEGN","catPRGN"],
    configDocumentsURL: "/assets/json/documents.json",
    spaceNomadeDealersLink: 'https://sway.office.com/q0gusdk6XcBfdstD?ref=Link',
});

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.carSearchRedirection, {
        url: '/carSearchRedirection',
        templateUrl: '',
        controller: 'carSearchRedirectionCtrl',
        controllerAs: 'cSearchRedirectionCtrl',
        params: {
          data: null
        }
      });
  }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('carSearchRedirectionCtrl', carSearchRedirectionCtrl);

    /** @ngInject */
    /*
    * Intermediary controller triggered by default.controler
    * has purpose to call carSearch with the appropriated parameters
     */
    function carSearchRedirectionCtrl($state,
                                      $translate,
                                      toastr,
                                      CacheService,
                                      ClipService,
                                      ClipConstants,
                                      RdsConstants,
                                      RoutesConstants,
                                      CacheConstants,
                                      blockUI,
                                      CarSearchMetierService,
                                      configConstantes,
                                      MainMetierService
                                      ) {
        var vm = this;
        function search() {
            CacheService.setObject(CacheConstants.hideDocsVisited, false);
            CacheService.setObject(CacheConstants.isOrSearchCar, false);
            vm.searchClicked = true;

            function alertErrorMessage(message) {
                $translate(message).then(function (text) {
                    toastr.error(text, 'Error');
                });
                $state.go(RoutesConstants.carSearch);
            }

            if (!vm.carSearch || !vm.carSearch.vin) {
                if (vm.carSearch.forname) {
                    alertErrorMessage('COMMON_SEARCH_ONLY_FIRSTNAME');
                } else {
                    alertErrorMessage('COMMON_ERROR_AT_LEAST_ONE_DATA');
                }
            } else {
                if (vm.carSearch.vin && vm.carSearch.vin.length != 17) {
                    alertErrorMessage('CARSEARCH_VIN_NUMBER_CHARACTER');
                } else {
                    if (!vm.carSearch.name) {
                        CarSearchMetierService.changeLinkColor("#BACKIMAGE_CHANGE");
                        blockUI.start();
                        CarSearchMetierService.searchCar(vm.carSearch).then(function () {
                            CarSearchMetierService.getBannerData().finally(function(){
                                CarSearchMetierService.historizationVehicleSave(vm.user).catch(function (error) {
                                    toastr.error('Error BACK : ' + error.backError, 'Error');
                                    $state.go(RoutesConstants.carSearch);
                                });
                            })
                            $state.go(RoutesConstants.carSearchResult);
                        }, function (err) {
                            if (err.msg) {
                                toastr.error(err.msg);
                                $state.go(RoutesConstants.carSearch);
                            }
                        }).finally(function () {
                            CarSearchMetierService.changeNormalcolor("#BACKIMAGE_CHANGE");
                            blockUI.stop();
                        });
                    } else {
                        vm.showHisto = false;
                        vm.directiveClientVehicleAPI.init(vm.carSearch.name, vm.carSearch.forname, vm.maximumVehiclesPerPage);
                    }
                }
            }
        }

        function init() {
            vm.search = search;
            vm.user = CacheService.getObject(RoutesConstants.profil);

            vm.carSearch = {};
            var clipParameters = MainMetierService.getClipParameters();
            ClipService.removeParameters(ClipConstants.clipCookieName);
            var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
            if (!_.isEmpty(clipParameters)){
                vm.carSearch.vin = clipParameters.clipVin;
                vm.carSearch.elementRef = clipParameters.clipRdcElementRef;
                vm.carSearch.operationCode = clipParameters.clipRdcOperationRef;
                vm.carSearch.type = clipParameters.clipSearchDocumentType;
            } else if (!_.isEmpty(commonParameters)){
                vm.carSearch.vin = commonParameters.VIN;
                vm.carSearch.elementRef = commonParameters.elementRef;
                vm.carSearch.operationCode = commonParameters.operationRef;
                vm.carSearch.type = commonParameters.TYPE;
            }
            search();
        }

        init();
    }
})();

(function () {
    angular
        .module('phenix')
        .controller('phaseMillesimController', phaseMillesimController);

    function phaseMillesimController($mdDialog,configConstantes) {

        var vm = this;
        vm.onClose = onClose;
        vm.validate = validate;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        function onClose() {
            $mdDialog.hide();
        }

        function validate(selectedPhase, selectedMillesim) {
            var list = vm.phaseList;
            if (!selectedPhase && !selectedMillesim) {
                return;
            }
            if (vm.phaseList.length > 0 && !selectedPhase || vm.millesimList.length > 0 && !selectedMillesim) {
                return;
            }
            var selectedPhaseMillesim = {};
            selectedPhaseMillesim.phase = selectedPhase;
            selectedPhaseMillesim.millesim = selectedMillesim
            $mdDialog.hide(selectedPhaseMillesim);
        }
    }
})();
(function () {

    angular
        .module('phenix')
        .directive('carSearchVinModel', carSearchVinModel)
        .controller('carSearchVinModelController', carSearchVinModelController)
        .filter('formatCarSearchHisto', function () {
            return function (value) {
                var formattedCarDetails = value.model;
                if (value.registrationNumber) {
                    formattedCarDetails += ' (' + value.registrationNumber + ' )';
                }
                return formattedCarDetails;
            };
        });
    function carSearchVinModel() {
        var directive = {
            templateUrl: 'app/components/car/carSearch/carSearchVinModel.html',
            bindToController: true,
            controller: carSearchVinModelController,
            controllerAs: 'vm',
            restrict: 'E',
            scope:{
                isDocpriv: '='
            }
        };
        return directive;
    }

    function carSearchVinModelController($translate, MainMetierService,DocPrivConstants, configConstantes, DocumentsMetierService, $q, customerListPaginationService, CarSearchMetierService, errorsConstant, globalConstant, $state, toastr, RoutesConstants, CacheService, CacheConstants, $scope, CarSearchConstants, ShoppingCartConstants, $rootScope, CodesConstants, blockUI, UtilsMetierService, AlertsService, AlertsLocationService, DealerManagerSystemeService, DmsMetierService, DmsConstants, ShoppingCartPartsService, $timeout, listOfDraftModalService, PartRequisitionMetierService, $mdDialog, ClipService, RetailGroupConstants, $log,DocPrivMetierService,DocumentsWsService,CryptoService, carMaintenanceProgramWsService) {

        var vm = this;
        vm.carSearch = {};
        vm.getAwaitingOrderNumber = null;
        vm.getAwaitingOtherBrand = false;
        vm.directiveClientVehicleAPI = null;
        vm.searchCustomer = null;
        vm.showHisto = true;
        vm.maximumVehiclesPerPage = 10;
        vm.stateInit = true;
        vm.maintenanceOperations = null;
        vm.showMaintenanceIcon = false;
        vm.maintenanceTooltip = '';
        vm.stateInputsForm = {
            imat: { active: false },
            or: { active: false },
            firstName: { active: false },
            name: { active: false },
            vin: { active: false }
        };
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess   );
       // var _customerService = null;
        var backBtnError = 'Error BACK : ';
        vm.displayCustomersPagination = false;
        vm.customersList = null;
        vm.customerLookFor = null;
        vm.hasPrevious = false;
        vm.hasNext = false;
        vm.page = 0;
        vm.userProfil = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(vm.userProfil.roles);
        vm.isCareAlertEnabled = JSON.parse(configConstantes.isCareAlertEnabled);
        vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
        vm.isHideModelSearch = isHideModelSearch;
        vm.next = next;
        vm.previous = previous;
        vm.resetField = resetField;
        vm.onClose = onClose;
        vm.showCarSearchResultByRegistration = showCarSearchResultByRegistration;
        vm.search = search;
        vm.searchByVin = searchByVin;
        vm.searchByImat = searchByImat;
        vm.searchByOr = searchByOr;
        vm.switchState = switchState;
        vm.onSelectedVehicle = onSelectedVehicle;
        vm.initVinFocus = initVinFocus;
        vm.arrPicto = [];
        vm.displayPicto = false;
        vm.displayHercules = false;
        vm.checkValid = null;
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.redirectCarBrandCheck = MainMetierService.redirectCarBrandCheck(vm.contextCarBrandCheck);
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();
        vm.isOnlyPpxLightUser = MainMetierService.isOnlyPpxLightUser();
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        const firstTabRetryCount = 5;
        vm.allowASOM = CacheService.getObject(CacheConstants.asomNotAllowed) ? CacheService.getObject(CacheConstants.asomNotAllowed) :false;
        vm.initVehicleModelSearch = function () {
            $timeout(function () {
                var brandDiv = angular.element(document.querySelector('#brand'));
                var brandMdInputContainer = angular.element(document.querySelector('#brand md-input-container'));
                var brandMdSelect = angular.element(document.querySelector('#brand md-select'));
                angular.element(brandDiv).triggerHandler('click');
                angular.element(brandMdInputContainer).triggerHandler('click');
                angular.element(brandMdSelect).triggerHandler('click');
            }, 0);
        };

        // Handle model search click and add nissan-tab class
        vm.handleModelSearchClick = function() {
            vm.initVehicleModelSearch();
            vm.toggleNissanTabClass(true);
        };

        // Toggle nissan-tab class on first tab
        vm.toggleNissanTabClass = function(addClass) {
            if (!vm.nissanUserURL) return;

            applyNissanClassToFirstTab(addClass, firstTabRetryCount);
        };

        vm.removeNissanTabFromFirstTab = function () {
            vm.toggleNissanTabClass(false);
        };

        function applyNissanClassToFirstTab(addClass, remainingAttempts) {
            $timeout(function () {
                const firstTabElement = document.getElementById('firstCarSearchTab');
                const firstTab = firstTabElement ? angular.element(firstTabElement) : null;

                if (firstTab && firstTab.length > 0) {
                    firstTab[addClass ? 'addClass' : 'removeClass']('nissan-tab');
                    return;
                }

                if (remainingAttempts > 0) {
                    applyNissanClassToFirstTab(addClass, remainingAttempts - 1);
                }
            }, 0, false);
        }

        // Handle first tab activation
        vm.changeCarSearchActive = function() {
            vm.carSearchActive = true;
            vm.carSearchModelActive = false;
        };
        
        function initVinFocus() {
            $timeout(function () {
                var inputBox = document.getElementById('vin');
                if (inputBox) {
                    var vinInputBox = angular.element(inputBox);
                    vinInputBox[0] && vinInputBox[0].focus();
                }
            }, 0);
        };

        function onClose() {
            $mdDialog.hide();
        }

        /**
         * @desc store care alert data (if the user is eligible) instead of auto-opening the popup;
         * recapCar shows an alert text that opens the popup on click
         */
        function storeCareAlertData(data) {
            // ASOM/independent users must never see the care alert
            if (vm.isIndependentUser) {
                CarSearchMetierService.setCareAlertData(null);
                return;
            }

            var isArcaUser = vm.userProfil && vm.userProfil.userType === 'ARCA';
            var isPilotRnetUser = vm.userProfil && vm.userProfil.userType === 'RNET' &&
                CarSearchConstants.careAlertPilotDealers.includes(vm.userProfil.dealerId);
            var isEligibleUser = isArcaUser || isPilotRnetUser;
            var isEligible = vm.isCareAlertEnabled && data && data.vinIsRed === true && isEligibleUser;
            CarSearchMetierService.setCareAlertData(isEligible ? data : null);
        }

        vm.cleanModelForm = function () {
            CacheService.removeObject(CarSearchConstants.fieldSearchModel);
            vm.toggleNissanTabClass(false); // Remove nissan-tab class
        };
        function searchByVin(vin, registrationNumber) {
            vm.carSearch = {};
            vm.carSearch.vin = vin;
            vm.carSearch.imat = registrationNumber;
            checkAlertsModal();
        }

        function searchByImat(imat) {
            vm.carSearch = {};
            vm.carSearch.imat = imat;
            checkAlertsModal();
        }

        function searchByOr(or) {
            vm.carSearch = {};
            vm.carSearch.or = or;
            checkAlertsModal();
        }

        function checkAlertsModal() {
            var status = AlertsService.getPopinVisibility().status;
            if (status) {
                AlertsService.modalAlertsContactCar().then(function () {
                    AlertsService.setPopinVisibility(false,'',null,false);
                    search();
                }, function () {
                    AlertsService.setHidePopin(true);
                });
            } else {
                search()
            }
        }
        function onSelectedVehicle(vehicle) {
            vm.carSearch.vin = vehicle.vin;
            vm.carSearch.imat = vehicle.imat;
            return search();
        }

        function search() {  
            var getPlate = DocPrivMetierService.getPlateId();
            if (getPlate && getPlate.isDocpriv && vm.carContextRequest && vm.carSearch.vin === vm.carContextRequest.vin) {
                var selectedPlateId = [];
                selectedPlateId.push(DocPrivMetierService.getPlateId().selectedPlateId)
                DocumentsMetierService.getPlates(selectedPlateId, getPlate.isDocpriv).then(function (platesList) {
                    if (!_.isEmpty(platesList)) {
                        vm.checkValid = "valid";
                        var res =  DocPrivMetierService.getPlateDetails() ? DocPrivMetierService.getPlateDetails().partsList : null ;
                        retrievePartsResponse(res,selectedPlateId[0], getPlate.isDocpriv);
                        toastr.info("Plate is valid");
                        var lsrInfo = CacheService.getObject(CacheConstants.bvaApigee) ? 
                        CacheService.getObject(CacheConstants.bvaApigee).partsList : [];
                        if(_.isEmpty(lsrInfo)){
                            CarSearchMetierService.getSparePartsDetails().then(function(bvaResponse){ 
                                var lsrInfoRes = (bvaResponse && bvaResponse.partsList) ? bvaResponse.partsList : [];
                                CacheService.setObject(CacheConstants.bvaApigee,bvaResponse);
                                retrieveResponseLinesBva(selectedPlateId[0],platesList,res,lsrInfoRes,getPlate.isDocpriv);
                            }).catch(function(){
                                $log.debug($translate.instant('ERROR'));
                            })
                        }  
                        else{
                           retrieveResponseLinesBva(selectedPlateId[0],platesList,res,lsrInfo,getPlate.isDocpriv);
                        }      
                    } else {
                        vm.checkValid = "invalid";
                        checkValidPlatesBroadcast();
                        toastr.info("Plate is invalid");
                    }
                }).then(function () {
                }).finally(function () {
                    $mdDialog.hide();
                });
            }
            else{ 
            if(getPlate && !getPlate.isDocpriv){
                CacheService.setObject(CacheConstants.hideDocsVisited, false);
                CacheService.setObject(CacheConstants.isOrSearchCar, false);
                vm.searchClicked = true;
            }           
            function alertErrorMessage(message) {
                var promise = $translate(message)
                promise.then(function (text) {
                    toastr.error(text, 'Error');
                });
            }

            if (!vm.carSearch || (!vm.carSearch.vin && !vm.carSearch.imat && !vm.carSearch.or && !vm.carSearch.name)) {
                alertErrorMessage('COMMON_ERROR_AT_LEAST_ONE_DATA');
            } else {

                if (vm.carSearch.vin && vm.carSearch.vin.length != 17) {
                    alertErrorMessage('CARSEARCH_VIN_NUMBER_CHARACTER');
                } else {
                    if (vm.carSearch.vin || vm.carSearch.or || vm.carSearch.imat) {
                        if (vm.retailGroupParameters && !_.isEmpty(vm.retailGroupParameters)) {
                            CarSearchMetierService.changeLinkColor("#BACKIMAGE_CHANGE");
                        }
                        blockUI.start();
                        var carSearchCopy = angular.copy(vm.carSearch);
                        CarSearchMetierService.initSearchCar(vm.carSearch, vm.isDmsConnected).then(function (response) {
                            vm.carSearch = carSearchCopy;
                            var data = response;
                            storeCareAlertData(data);
                            vm.brandList = [];
                            var horseEntityFields = (data && data.carContext) ? _.pick(data.carContext.bvmExtraFields,CarSearchConstants.horseProfFields) : null;
                            if(vm.isIndependentUser){
                                var decrypted = CryptoService.AES.decrypt((CacheService.getObject(CacheConstants.applicabilities)), CacheConstants.encryptedValue);
                                
                               vm.applicabilities = JSON.parse(decrypted.toString(CryptoService.enc.Utf8)).length > 0 ? JSON.parse(decrypted.toString(CryptoService.enc.Utf8)) : [];
                
                                if (vm.applicabilities.length > 0) {
                                    vm.applicabilities.forEach(function (list) {
                                        if(!_.isEmpty(list.brandCriteria)){
                                            list.brandCriteria.forEach(function (item) {
                                                vm.brandList.push(item);
                                            })
                                        }
                                    })
                                    vm.brandList = _.uniq(vm.brandList);
                                }                              
                                    if ( !_.isEmpty(vm.brandList)){
                                        if(data && !_.isEmpty(data) && vm.brandList.includes(data.carContext.brandComputed)){
                                            callCarSearchPendingServices(data,getPlate);
                                        } else {
                                            CacheService.removeObject(CacheConstants.contextCarSearch);
                                            CacheService.removeObject(CacheConstants.contextCarRequest);
                                            toastr.error($translate.instant("VIN_NOT_ALLOWED"));
                                        }
                                    } else {
                                        callCarSearchPendingServices(data,getPlate);
                                    }
                            }
                            else if(vm.isHorseUser){
                                if(!_.isEmpty(horseEntityFields) && !_.isEmpty(_.values(horseEntityFields))){
                                    CarSearchMetierService.getEnggInfoForParts(_.values(horseEntityFields)).then(function(res){
                                        if(res && !_.isEmpty(res.parts)){
                                            callCarSearchPendingServices(data,getPlate);
                                        }else {
                                            CacheService.removeObject(CacheConstants.contextCarSearch);
                                            toastr.error($translate.instant("UNKNOWN_VIN_BVM"));
                                        }
                                    }).catch(function(err){
                                        CacheService.removeObject(CacheConstants.contextCarSearch);
                                        toastr.error($translate.instant("UNKNOWN_VIN_BVM"));
                                    })
                                } else {
                                    CacheService.removeObject(CacheConstants.contextCarSearch);
                                    toastr.error($translate.instant("UNKNOWN_VIN_BVM"));
                                }
                            } else if(vm.isMitsubishiUser){
                                if(data && data.carContext && data.carContext.brandComputed && (data.carContext.brandComputed == "APL15" || data.carContext.brandComputed == "BRA15"  )){
                                    callCarSearchPendingServices(data,getPlate);
                                }else {
                                    CacheService.removeObject(CacheConstants.contextCarSearch);
                                    CacheService.removeObject(CacheConstants.contextCarRequest);
                                    toastr.error($translate.instant("VIN_NOT_ALLOWED"));
                                }
                            }
                            else if(vm.nissanUserURL){
                                var nissanBrands = ['APL04', 'BRA04', 'APL09', 'BRA09', 'APL16', 'BRA16'];
                                var nissanFamily = ['XDD', 'XDE', 'XFK', 'X1322','X1324','X1325'];
                                if(!_.isEmpty(data) && !_.isEmpty(data.carContext) && !_.isEmpty(data.carContext.fixedCriterias) && !_.isEmpty(data.carContext.fixedCriterias["336"]) && nissanBrands.includes(data.carContext.fixedCriterias["336"])
                                && (nissanFamily.includes(data.carContext.fixedCriterias["007"]) || (data.carContext.fixedCriterias["007"] === 'X82' && data.carContext.fixedCriterias["901"] === 'PHAS2'))){
                                    callCarSearchPendingServices(data,getPlate);
                                }                                
                                else{
                                    CacheService.removeObject(CacheConstants.contextCarSearch);
                                    toastr.error($translate.instant("UNKNOWN_VIN_BVM"));
                                }
                            }
                                else {
                                    callCarSearchPendingServices(data,getPlate);
                                }
                        }).catch(function (err) {
                        function showDialog(messageKey) {
                            $mdDialog.show({
                                controller: function DialogController($scope, $mdDialog) {
                                    $scope.closeDialog = function () {
                                        $mdDialog.hide();
                                    };
                                },
                                template: `<div ng-keypress class="actions" style="position: absolute; right:5px;" ng-click="closeDialog()"><em class="fa fa-close"></em></div><div style="padding: 20px;font-family:var(--renaultFontRegular);">{{'${messageKey}' | translate}}</div>`,
                                clickOutsideToClose: true,
                            });
                        }
                            if (err === errorsConstant.NOT_AUTHORIZED) {
                                toastr.error($translate.instant('NOT_AUTHORIZED_RESEARCH'));
                            }
                            else if (err && err.msg && err.msg != $translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE')) {
                                toastr.error(err.msg);
                            }
                            else if (err && err.msg && err.msg == $translate.instant('CARSEARCH_BVM_ERROR_NO_VEHICLE')) {
                                toastr.error($translate.instant("CARSEARCH_VEHICLE_IN_DMS_BUT_NOT_IN_BVM"));
                                var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                                var carInfosFromCache = CacheService.getObject(CarSearchConstants.contextCarSearch);
                                if (dmsResponse == null) {
                                    CarSearchMetierService.setCarContextVehicleNotKnownBvmAndDms(vm.carSearch);
                                    if(getPlate && !getPlate.isDocpriv){
                                    $state.go(RoutesConstants.carSearchResultNoCarContext);
                                    }
                                }
                                else if (dmsResponse) {
                                    CarSearchMetierService.setCarContextVehicleNotKnownBvm(dmsResponse, carInfosFromCache);
                                    CacheService.setObject(CacheConstants.vehiclePresentInDMSbutNotInBVM, true);

                                    CarSearchMetierService.historizationVehicleSave(vm.user).catch(function (error) {
                                        toastr.error(backBtnError + error.backError, 'Error');
                                    });
                                    getAwaitingParts(dmsResponse.orderNumber, true);

                                } else {
                                    $state.go(RoutesConstants.carSearchResult);
                                }
                            }else if (err && (err === errorsConstant.SERVICE_UNVAILABLE)) {

                                toastr.error($translate.instant('CARSEARCH_BVM_ERROR'));
                            }
                            else if (err && (err.xhrStatus === DmsConstants.errors.ABORT || err.xhrStatus === DmsConstants.errors.ERROR) && (err.config.url.includes('.v1'))) {
                                toastr.error($translate.instant('DMS_ERROR_TIMEOUT'));
                            }
                            else if (err && (err.status && err.status == 429)) {
                                showDialog('VIN_SEARCH_LIMIT_REACHED');	
                            }
                            else if (err && (!err.status || (err.status && err.status !== 200))) {
                                toastr.error($translate.instant('ERROR'));
                            } else {
                                toastr.error($translate.instant('ERROR'));
                            }
                        }).finally(function () {
                            if(getPlate && getPlate.isDocpriv){
                            $mdDialog.hide();
                            }

                            blockUI.stop();
                        });
                    } else {
                        vm.customerLookFor = angular.copy(vm.carSearch);

                        vm.displayCustomersPagination = false;
                        blockUI.start();
                        // _customerService = new customerListPaginationService();
                        customerListPaginationService.get(vm.customerLookFor).then(function (response) {
                            vm.showHisto = false;
                            var customers = response.customers;
                            if (customers.length === 1 && customers[0].vehicles.length === 1) {
                                vm.carSearch = {
                                    vin: customers[0].vehicles[0].vin,
                                    imat: customers[0].vehicles[0].registrationNumber
                                }
                                vm.search();
                            } else {
                                updatePaginationView(response);
                                vm.displayCustomersPagination = true;
                            }
                        }).catch(function () {
                            $log.debug($translate.instant('ERROR'));
                        }).finally(function () {
                            blockUI.stop();
                        })
                    }
                }
            }
        }
        }
        function callCarSearchPendingServices(data,getPlate){
            CarSearchMetierService.getBannerData().finally(function (resp) {
                if(getPlate && !getPlate.isDocpriv){
                    CarSearchMetierService.historizationVehicleSave(vm.user).catch(function (error) {
                    toastr.error(backBtnError + error.backError, 'Error');
                });
            }
            });
            
            checkMaintenanceOperations();
            if (vm.carSearch.or) {
                getAwaitingParts(vm.carSearch.or, false);
            }
            if(getPlate && !getPlate.isDocpriv){
                if (data && data.carContext && data.carContext.fixedCriterias && (data.carContext.typeMD === "B2-3" || data.carContext.typeMD === "B3-ADT") && (!_.has(data.carContext.fixedCriterias, '901') || !_.has(data.carContext.fixedCriterias, '900'))) {
                    return CarSearchMetierService.getPhasemillesimDetails(data).then(function (result) {
                        if (result) {
                            $state.go(RoutesConstants.carSearchResult);
                        }
                    });
                }
                else {
                    $state.go(RoutesConstants.carSearchResult);
                }
            } else{
                var selectedPlateId = [];
                selectedPlateId.push(DocPrivMetierService.getPlateId().selectedPlateId);
                DocumentsMetierService.getPlates(selectedPlateId, getPlate.isDocpriv).then(function (platesList) {
                    if(!_.isEmpty(platesList)){
                        vm.checkValid = "valid";
                        var res =  DocPrivMetierService.getPlateDetails() ? DocPrivMetierService.getPlateDetails().partsList : null ;
                        retrievePartsResponse(res,selectedPlateId[0], getPlate.isDocpriv);
                        toastr.info("Plate is valid");
                        CarSearchMetierService.getSparePartsDetails().then(function(bvaResponse){   
                        var lsrInfo = (bvaResponse && bvaResponse.partsList) ? bvaResponse.partsList : [];
                        retrieveResponseLinesBva(selectedPlateId[0],platesList,res,lsrInfo,getPlate.isDocpriv);
                    }).catch(function(){
                        vm.displayHercules = false;
                        checkValidPlatesBroadcast();
                    });
                    
                    } else{
                        vm.checkValid = "invalid";
                        vm.displayPicto = false;
                        checkValidPlatesBroadcast();
                        toastr.info("Plate is invalid");
                    }
                })
            }
        }
        function retrievePartsResponse(res,selectedPlateId,isDocpriv){
            vm.displayPicto = true;
            var partsList = res;
            var userContext = CacheService.getUserContext();
            var user = CacheService.getObject(RoutesConstants.profil);
            var carContext = CacheService.getCarContext();
            var singleton = CacheService.getObject(CacheConstants.contextCarSearch);
            if(isDocpriv && userContext && userContext.userProfiles && user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)){
                userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());      
            }
            var body_lines = {
                userContext: userContext,
                carContext: carContext,
                plate: selectedPlateId, 
                partFilter: singleton.vehicle.displayMotrio ? 'ALLPARTS' : 'NOMOTRIO'
            }
           
            var defer = $q.defer();
            DocumentsWsService.getPlateLines(body_lines).then(function (response_lines) {
                retrievePlates(response_lines,partsList);

            }).catch(function(err){
                defer.reject(err)
        })
        }


        function retrieveResponseLinesBva(selectedPlateId,plateInfo,res,lsrInfo,isDocpriv){
            try{
            vm.displayHercules = true;
            var partsList = res;
            var userContext = CacheService.getUserContext();
            var carContext = CacheService.getCarContext();
            var singleton = CacheService.getObject(CacheConstants.contextCarSearch);
            var user = CacheService.getObject(RoutesConstants.profil);
            if(isDocpriv && userContext && userContext.userProfiles && user && user.roles && user.roles.includes(DocPrivConstants.docPrivPopinVinProfile)){
                userContext.userProfiles.push(DocPrivConstants.docPrivPopinVinProfile.toLowerCase());
            }
            var displayMotrio = (singleton && singleton.vehicle && singleton.vehicle.displayMotrio) ? singleton.vehicle.displayMotrio : null;
            var body = {
                userContext: userContext? userContext : null,
                carContext: carContext? carContext : null,
                plate: selectedPlateId? selectedPlateId : null, 
                partFilter: displayMotrio? 'ALLPARTS' : 'NOMOTRIO'
            }

            var bvaLinesResponse;

            if(lsrInfo && !_.isEmpty(lsrInfo)){
                var genericPartsFromPlates = (plateInfo && plateInfo[0] && plateInfo[0].genericParts ) ? plateInfo[0].genericParts : [];

                var lsrForLines;
                if(genericPartsFromPlates && !_.isEmpty(genericPartsFromPlates)){
                    lsrForLines = _.filter(lsrInfo, function(item){
                        if(_.includes(genericPartsFromPlates, item.spareGenericPart)){
                            return item;
                        }
                    })
                }

                if(lsrForLines && !_.isEmpty(lsrForLines)){

                    _.map(lsrForLines,function(lsrItems){
                        if(lsrItems && lsrItems.additionalSpareParts && !_.isEmpty(lsrItems.additionalSpareParts)){
                            var additionalParts = [];
                            _.map(lsrItems.additionalSpareParts,function(item){
                                _.map(item.lvaSparePartList, function(parts){
                                    additionalParts.push(parts);
                                })
                                
                            });
                            _.assign(lsrItems,{additionalSpareParts : additionalParts});
                        }
                    
                    });

                    _.extend(body,
                        {herculesInputs:lsrForLines})
                }
            }

            DocumentsWsService.getPlateLines(body).then(function (response_lines) {
                 bvaLinesResponse = response_lines;
                var lines = _.groupBy(bvaLinesResponse.references, 'index');
                if(partsList && !_.isEmpty(partsList) && partsList.references && !_.isEmpty(partsList.references) ){
                    partsList.references.map(function(parts_ref){
                       for(var lines_ref in lines){
                        if(parts_ref.index==lines_ref){
                            lines[lines_ref].forEach(function(lines_ref_key){
                                if(parts_ref.reference == lines_ref_key.reference){
                                    _.extend(parts_ref,{herculesCase : lines_ref_key.herculesCase}) 
                                }  
                            })
                        }
                       }
                    });    
                    var parts = _.groupBy(partsList.references, 'index');
                    for (var lines_ref in lines) {
                        for (var parts_ref in parts) {
                            var referencePresent = false;
                            if (parts_ref === lines_ref) {
                                lines[lines_ref].forEach(function (lines_reference) {
                                    parts[parts_ref].forEach(function (parts_reference) {
                                        if (lines_reference.reference === parts_reference.reference || lines_reference.initialReference === parts_reference.reference) {
                                            referencePresent = true;

                                        }
                                    })
                                })
                                if (!referencePresent) {
                                    var refItem = _.filter(parts[parts_ref], function (item, index) {
                                        return index == parts[parts_ref].length - 1;
                                    })
                                    refItem.forEach(function (value) {
                                        vm.indexCategory = _.findIndex(partsList.references, value);
                                    })
                                    lines[lines_ref].forEach(function (reference) {
                                        reference.textColor = true;
                                        partsList.references.splice(vm.indexCategory + 1, 0, reference);
                                    })
                                }
                            }
                        }
                    }
                }

            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
            checkValidPlatesBroadcast(); 
            }
            catch(error){
                $log.debug($translate.instant('ERROR'));
            }

        }


        function retrievePlates(response_lines,partsList){
           
            var lines = _.groupBy(response_lines.references, 'index');
            if(partsList && !_.isEmpty(partsList) && partsList.references && !_.isEmpty(partsList.references) ){
            partsList.references.map(function(parts_ref){
                       for(var lines_ref in lines){
                        
                        if(parts_ref.index==lines_ref){
                            lines[lines_ref].forEach(function(lines_ref_key){
                                if(parts_ref.reference == lines_ref_key.reference){
                                    _.extend(parts_ref,{status : 1})
                                    
                                }  
                                else if(lines_ref_key.alternative.length>0){
                                    lines_ref_key.alternative.forEach(function (alternative_key){
                                        if(parts_ref.reference==alternative_key.reference){
                                            _.extend(parts_ref,{status : 1})
                                            
                                        }
                                        else if (parts_ref.reference == lines_ref_key.initialReference ||parts_ref.reference == alternative_key.initialReference){
                                            _.extend(parts_ref,{status : 2})
                                        }
                                    })
                                }
                                else if(parts_ref.reference == lines_ref_key.initialReference){
                                    _.extend(parts_ref,{status : 2})
                                }
                                else{
                                    _.extend(parts_ref,{status : 0})
                                }
                            })
                        }
                        
                       
                       }
                    
             
            
            });
            DocPrivMetierService.setPartsListDetails(partsList);
            checkValidPlatesBroadcast();   
        }
        }

        function checkValidPlatesBroadcast(){
            $rootScope.$broadcast("referenceCheck",{
                displayPicto :  vm.displayPicto, 
                checkValid : vm.checkValid,
                displayHercules : vm.displayHercules

            });

        }

        function continueAfterPopupConfirmation(){
            var AwaitingParts;
            return DmsMetierService.getAwaitingParts(vm.getAwaitingOrderNumber).then(function (response) {
                AwaitingParts = response;
                var body = angular.element(document.body);
                var modalParams = {
                    body: body,
                    typeOfSuperCart: globalConstant.partRequisition,
                    title: "NEW_PARTLIST",
                    subtitle: "PARTLIST_NO_ACTIVE_DRAFT",
                    showList: true
                }
                return listOfDraftModalService.showModal(modalParams).then(function (partRequisition) {
                    if (partRequisition.item) {
                        return PartRequisitionMetierService
                            .findPartRequisitionLogic(partRequisition.item)
                            .then(ShoppingCartPartsService.restorePartRequisition);
                    } 
                }).then(function () {
                    return loadAndRestorePartsInformationsFromDH(AwaitingParts.response.references);
                }).then(function (parts) {
                    angular.forEach(parts, function (part) {
                        ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_SPECIFIC_QUANTITY, {
                            piece: part,
                            type: 'PR'
                        });
                    });
                    PartRequisitionMetierService.onUpdateCart(parts);
                })
            }).catch(function () {
                $log.debug($translate.instant('ERROR'));
            }).finally(function () {
                if (!vm.getAwaitingOtherBrand) {
                    $state.go(RoutesConstants.carSearchResult);
                }
                else {
                    var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                    $state.go(RoutesConstants.carSearchResultNoCarContext, {
                        vin: dmsResponse.vehicle.vin,
                        immat: dmsResponse.vehicle.registrationNumber,
                        or: dmsResponse.orderNumber,
                        vehiclePresentInDMSbutNotInBVM: true
                    });
                }
            });
        }

        function getAwaitingParts(orderNumber, isOtherBrand) {
            vm.getAwaitingOrderNumber = orderNumber;
            vm.getAwaitingOtherBrand = isOtherBrand;
            CarSearchMetierService.showPopinIfOrderIsWaiting().then();
        }

        function loadAndRestorePartsInformationsFromDH(items) {
            var IDList = items.map(function (PR) {
                return PR.reference;
            })

            if (!IDList.length) {
                return $q.resolve(items);
            }

            return DocumentsMetierService.getPRLight(IDList).then(function (partsList) {
                return items.map(function (item) {
                    var part = _.find(partsList, function (pr) {
                        return pr.reference === item.reference;
                    });

                    if (!part) {
                        return item;
                    }
                    return _.assign({}, item, {
                        designation: part.designation
                    });
                })
            });
        }

        function resetField() {
            vm.showHisto = true;
            vm.carSearch = {};
        }

        function showCarSearchResultByRegistration(vin) {
            vm.carSearch.vin = vin;
            search();
            $mdDialog.hide();
        }

        function getHistorizationVehicle() {
            var promise = CarSearchMetierService.historizationVehicleLoad(vm.user)
            promise.then(function (response) {
                if (response.vehicles) {
                    var histo = [];
                    for (var i = 0; histo.length < 12 && i < response.vehicles.length; i++) {
                        if (uniqueVin(histo, response.vehicles[i].vin)) {
                            histo.push(response.vehicles[i]);
                            vm.carSearchHisto = _.chunk(histo, 4);
                        }
                    }
                }
            }, function (error) {
                toastr.error(backBtnError + error.backError, 'Error');
            });
        }

        function reinitFields(indexInput, isFocused) {
            if (isFocused && !vm.carSearch[indexInput]) {
                if (indexInput === 'name' || indexInput === 'firstName') {
                    var name = vm.carSearch['name'];
                    var firstName = vm.carSearch['firstName'];
                    vm.carSearch = { name: name, firstName: firstName };
                } else {
                    vm.carSearch = {};
                }
            }
        }

        function changeStyleFields(indexInput, isFocused) {
            vm.stateInit = true;
            for (var property in vm.stateInputsForm) {
                if (vm.stateInputsForm.hasOwnProperty(property)) {

                    if (isFocused) {
                        if ((indexInput == 'name' || indexInput == 'firstName') && (property == 'name' || property == 'firstName')) {
                            vm.stateInputsForm['firstName'].active = true;
                            vm.stateInputsForm['name'].active = true;
                            vm.stateInit = false;

                        } else if (property == indexInput) {
                            vm.stateInputsForm[property].active = true;
                            vm.stateInit = false;
                        } else {
                            vm.stateInputsForm[property].active = false;
                        }

                    } else {
                        vm.stateInputsForm[property].active = undefined;
                    }
                }
            }
        }

        function switchState(indexInput, isFocused) {
            reinitFields(indexInput, isFocused);
            changeStyleFields(indexInput, isFocused);
        }
        
        function init() {
            //get if docpriv from docprivservice and assign to var variable in init alone 
            var unsubscribeConfirm = $rootScope.$on('confirmPendingClicked', function (event, confirmCLicked) {
                if(confirmCLicked){
                    continueAfterPopupConfirmation();
                }
                else{
                    if (!vm.getAwaitingOtherBrand) {
                        $state.go(RoutesConstants.carSearchResult);
                    }
                    else {
                        var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                        $state.go(RoutesConstants.carSearchResultNoCarContext, {
                            vin: dmsResponse.vehicle.vin,
                            immat: dmsResponse.vehicle.registrationNumber,
                            or: dmsResponse.orderNumber,
                            vehiclePresentInDMSbutNotInBVM: true
                        });
                    }
                }
            });
            
            var unsubscribeMaintenanceCheck = $rootScope.$on('checkMaintenanceOperations', function (event) {
                if (vm.isPlannedAssistanceEnabled) {
                    checkMaintenanceOperations();
                }
            });

            $scope.$on("$destroy", function () {
                if (unsubscribeConfirm) {
                    unsubscribeConfirm(); // Remove listener
                    unsubscribeConfirm = null;
                }
                if (unsubscribeMaintenanceCheck) {
                    unsubscribeMaintenanceCheck(); 
                    unsubscribeMaintenanceCheck = null;
                }
            });
            var getPlate = DocPrivMetierService.getPlateId();
            if(getPlate && !getPlate.isDocpriv){
                $rootScope.$broadcast('loadTooltip');
                $rootScope.previousState = RoutesConstants.carSearch;
                $rootScope.currentState = RoutesConstants.carSearch;
                vm.isDmsConnected = DealerManagerSystemeService.getHookResult();            
            }
            vm.currentCustomer = {};
            vm.index = 0;
            vm.carSearch = {};
            vm.user = CacheService.getObject(RoutesConstants.profil);
            vm.carContextRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            if(getPlate && getPlate.isDocpriv && vm.carContextRequest && !_.isEmpty(vm.carContextRequest)){
                vm.carSearch.vin = vm.carContextRequest.vin;
            }
            vm.show = vm.user.dmsConnected;
            vm.isGemStopped = false;
            if(!$state.params.isAngularRedirect && getPlate && !getPlate.isDocpriv){
            CacheService.cleanCarContext();
            }
            if(getPlate && !getPlate.isDocpriv){
                vm.retailGroupParameters = ClipService.getParameters(RetailGroupConstants.retailGroupCookieName);
                if (vm.user) {
                    var isPartShop = UtilsMetierService.isPartShop(vm.user);
                    var isWorkShop = UtilsMetierService.isWorkShop(vm.user);
                    var isWorkShopPartShop = UtilsMetierService.isWorkShopPartShop(vm.user);
                }
                if (isWorkShop || isWorkShopPartShop) {
                    $scope.isWorkshopOrWorkshopPartshop = true;
                    $scope.$parent.enableEstimate = false;
                    $scope.$parent.enablePartList = false;
                }

                if (vm.user.dmsConnected && isPartShop) {
                    vm.show = false;
                }
                if ($state.params.orderNumber) {
                    vm.carSearch.or = $state.params.orderNumber;
                    vm.isDmsConnected = true;
                    search();
                }
            }
            if ($state.params.vin) {
                vm.carSearch.vin = $state.params.vin;
                vm.isDmsConnected = true;
                search();
            }
            if(getPlate && !getPlate.isDocpriv){
                vm.showSearchByRegistrationNumber = checkSearchByImmatAuth(vm.user.country);
                vm.showSearchByOR = isNetworkProfileWorkshop(vm.user.dmsConfig);
                vm.showSearchByNameAndFirstName = isNetworkProfileWorkshop(vm.user.dmsConfig);

                vm.configuration = {
                    country: vm.user.country,
                    dmsConnected: vm.user.dmsConnected
                };
                if ($state.params && $state.params.searchByModel) {
                    vm.carSearchModelActive = true;
                    vm.toggleNissanTabClass(true);
                } else {
                    vm.cleanModelForm();
                    vm.carSearchActive = !vm.carSearchModelActive;
                }
                if(!vm.allowASOM){
                    getHistorizationVehicle();
                }

                                
                if(!vm.nissanUserURL){
                    var breakingNewsNoCarContext = CacheService.getBreakingNewsNoCarContext();
                    if (!UtilsMetierService.isIndependentUser() && (!breakingNewsNoCarContext || _.isEmpty(breakingNewsNoCarContext))) {
                        CarSearchMetierService.getBreakingNews().then(function (response) {
                            CacheService.setBreakingNewsNoCarContext(response);
                            $rootScope.$emit('loadNews', response);
                        });
                    } else {
                        $rootScope.$emit('loadNews', breakingNewsNoCarContext);
                    }
                }
                AlertsLocationService.buildAlerts({
                    location: '',
                    identification: '',
                    typeOfElement: $translate.instant('LOCATION_SEARCH_VEHICLE'),
                    reference: '',
                    label: $translate.instant('CARSEARCH_FORM_VEHICLE')
                }, 'CSEARCH');
            }

        }

        init();
        function checkSearchByImmatAuth(countryCode) {
            var isAllowed = false;
            if (DealerManagerSystemeService.getHookResult()) {
                isAllowed = true;
                return isAllowed;
            }
            var allowedCountry = CodesConstants.listCountryRegisterNumber;
            var findedCountry = _.find(allowedCountry, function (country) {
                return country === countryCode;
            });
            if (findedCountry) {
                isAllowed = true;
            }
            return isAllowed;
        }
        function uniqueVin(tableau, vinTest) {
            var result = true;
            tableau.forEach(function (element) {
                if (element.vin == vinTest) {
                    result = false;
                }
            });
            return result;
        }
        function isNetworkProfileWorkshop(dmsConfig) {
            return DealerManagerSystemeService.getHookResult() && dmsConfig.networkProfile === CarSearchConstants.networkProfileWorkshop;
        }
        function next() {
            blockUI.start();
            customerListPaginationService.next().then(updatePaginationView).catch(handleErrors).finally(function () {
                blockUI.stop();
            });
        }

        function previous() {
            blockUI.start();

            customerListPaginationService.previous().then(updatePaginationView).catch(handleErrors).finally(function () {
                blockUI.stop();
            });
        }

        function updatePaginationView(response) {
            vm.customersList = response.customers;
            vm.hasNext = response.next;
            vm.hasPrevious = response.previous;
            vm.page = response.page + 1;
        }
        function isHideModelSearch(){
            vm.hide = false;
            if (vm.isIndependentUser && vm.userProfil.accountType === 'Automobile repairer' && vm.isAsomValidDocAccess === 'false'){
                vm.hide = true;
            }
            return vm.hide;
        }

        function handleErrors(error) {
            if (typeof error === "number") {
                switch (error) {
                    case DmsConstants.errors.NO_CUSTOMERS:
                        toastr.error($translate.instant('CARSEARCH_NAME_NOT_VEHICLE_ASSOCIATED'));
                        break;
                    default:
                        toastr.error($translate.instant('ERROR'));
                        break;
                }
            } else {
                toastr.error($translate.instant('ERROR'));
            }
        }


        function checkMaintenanceOperations() {
            var contextCar = CacheService.getCarContext();
            var maintenanceIconCheck = CacheService.getObject(CacheConstants.maintenanceIconCheck);
            
            if (!contextCar || !contextCar.vin) {
                vm.showMaintenanceIcon = false;
                return;
            }
            
            if (maintenanceIconCheck) {
                var maintenanceProgramIcon = CacheService.getObject(CacheConstants.maintenanceProgramIcon);
                if (maintenanceProgramIcon && 
                    typeof maintenanceProgramIcon.showMaintenanceIcon !== 'undefined') {
                    vm.showMaintenanceIcon = maintenanceProgramIcon.showMaintenanceIcon;
                    vm.maintenanceTooltip = maintenanceProgramIcon.maintenanceTooltip || '';
                    $rootScope.$broadcast('maintenanceIconUpdate', {
                        showIcon: vm.showMaintenanceIcon,
                        tooltip: vm.maintenanceTooltip
                    });
                    return;
                }
            }
            
            var requestVinrep = {
                vin: contextCar.vin
            };
            
            carMaintenanceProgramWsService.getVinRep(requestVinrep).then(function (response) {
                if (response && response[1] && response[1]._embedded && response[1]._embedded.operations && response[0]) {
                    vm.maintenanceOperations = response[1]._embedded.operations;
                    updateMaintenanceIconStatus();
                } else {
                    vm.showMaintenanceIcon = false;
                }
            }).catch(function (error) {
                vm.showMaintenanceIcon = false;
            });
        }


        function updateMaintenanceIconStatus() {
            if (!vm.maintenanceOperations || vm.maintenanceOperations.length === 0) {
                vm.showMaintenanceIcon = false;
                return;
            }
            
            var operationsToCarryOut = []; // isOpen = 1
            var operationsDelayed = []; // isOpen = 2
            
            vm.maintenanceOperations.forEach(function(operation) {
                if (operation.isOpen === '1' || operation.isOpen === 1) {
                    operationsToCarryOut.push(operation);
                } else if (operation.isOpen === '2' || operation.isOpen === 2) {
                    operationsDelayed.push(operation);
                }
            });
            
            if ((operationsToCarryOut.length > 0 && operationsDelayed.length > 0) || (operationsToCarryOut.length === 0 && operationsDelayed.length > 0)) {
                vm.showMaintenanceIcon = true;
                vm.maintenanceTooltip = 'OPERATIONS_DELAYED';
            } else if (operationsToCarryOut.length > 0 && operationsDelayed.length === 0) {
                vm.showMaintenanceIcon = true;
                vm.maintenanceTooltip = 'CURRENT_OPERATIONS';
            } else {
                vm.showMaintenanceIcon = false;
            }
            
            var maintenanceProgramIcon = {
                showMaintenanceIcon: vm.showMaintenanceIcon,
                maintenanceTooltip: vm.maintenanceTooltip
            }
            CacheService.setObject(CacheConstants.maintenanceProgramIcon, maintenanceProgramIcon);
            CacheService.setObject(CacheConstants.maintenanceIconCheck, true);
            
            $rootScope.$broadcast('maintenanceIconUpdate', {
                showIcon: vm.showMaintenanceIcon,
                tooltip: vm.maintenanceTooltip
            });
        }


    }
})();

(function () {
    angular.module('phenix')
        .directive('carSearchByModel', behavior)

    /* DIRECTIVE OPTIONS */
    /** @ngInject */
    function behavior() {
        return {
            scope: {

            },
            restrict: 'E',
            controllerAs: 'searchByModelCtrl',
            templateUrl: 'app/components/car/carSearch/carSearchByModel.html',
            controller: CarSearchByModelController,
            bindToController: true

    }
  }

    /* CONTROLLER */
    /** @ngInject */
    function CarSearchByModelController(CarSearchMetierService,
        $translate,
        toastr,
        RoutesConstants,
        CacheService,
        $state,
        $scope,
        $element,
        $timeout,
        blockUI,
        CacheConstants,
        CarSearchConstants,
        CarSearchByModelService,MainMetierService,CryptoService,configConstantes) {

        var vm = this;

        vm.fields = [];

        vm.rules = {};

        CarSearchByModelService.defineRules(vm);


        vm.searchTerm = '';

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };



        vm.fields2 = [];
        vm.fields3 = [];
        vm.fields4 = [];
        vm.refine = false;
        vm.showList = false;
        vm.notHide = false;
        vm.manufactureDate = '';
        vm.getFiltersList = getFiltersList;
        vm.checkEngineGearboxSelect = checkEngineGearboxSelect;
        vm.autoSelect = autoSelect;
        vm.autoFocus = autoFocus;
        vm.divSelected = divSelected;
        vm.search = search;
        vm.isFamilyCodeXTPorXRQ = isFamilyCodeXTPorXRQ;
        vm.familyCode = '';
        vm.clickOnNext = clickOnNext;
        vm.showCriteria=showCriteria;
        vm.criteriaResponse = false;
        vm.watchVariable = watchVariable;
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        /**
         *  To trigger the click on carSearchByModelForm mandatory fields only
         *  in order to reduce the number of clicks performed by the user
         *  @param {string} id
         */
        function clickOnNext(id) {
            if (id === 'brand' || (id === 'familyCode' && !vm.isFamilyCodeXTPorXRQ(vm.fields)) || id === 'engine') {
                $timeout(function () {
                    var currentDiv = angular.element(document.querySelector('#'+id));
                    var nextDivId = $(currentDiv).next().attr('id');
                    var nextDiv = angular.element(document.querySelector('#'+nextDivId));
                    var nextMdInputContainer = angular.element(document.querySelector('#'+nextDivId + ' md-input-container'));
                    var nextMdSelect = angular.element(document.querySelector('#'+nextDivId + ' md-select'));
                    var nextMdSelectValue = angular.element(document.querySelector('#'+nextDivId + ' md-select-value span div'));
                    if (nextMdSelectValue.length === 0) {
                        angular.element(nextDiv).triggerHandler('click');
                        angular.element(nextMdInputContainer).triggerHandler('click');
                        angular.element(nextMdSelect).triggerHandler('click');
                    }
                }, 800);
            }

            if ((id === 'familyCode' && vm.isFamilyCodeXTPorXRQ(vm.fields)) || id === 'modelType') {
                $timeout(function () {
                    var engineDiv = angular.element(document.querySelector('#engine'));
                    var engineMdInputContainer = angular.element(document.querySelector('#engine md-input-container'));
                    var engineMdSelect = angular.element(document.querySelector('#engine md-select'));
                    var engineMdSelectValue = angular.element(document.querySelector('#engine md-select-value span div'));
                    if (engineMdSelectValue.length === 0) {
                        angular.element(engineDiv).triggerHandler('click');
                        angular.element(engineMdInputContainer).triggerHandler('click');
                        angular.element(engineMdSelect).triggerHandler('click');
                    }
                }, 800);
            }
        }

        /**
         *  TO CHECK if familyCode is XTP or XRQ
         *  @param {Array} fields
         *  @return boolean
         */
        function isFamilyCodeXTPorXRQ(fields) {
            if (vm.fields[CarSearchConstants.indexFamilyCode] && vm.fields[CarSearchConstants.indexFamilyCode].value) {
                vm.familyCode = fields[CarSearchConstants.indexFamilyCode].value.criteriaCode;
                return (vm.familyCode === "XTP" || vm.familyCode === "XRQ");
            } else {
                return false;
            }
        }

        function showCriteria() {
            if ( vm.notHide) {
                vm.notHide = ! vm.notHide;
              }
              else {
                vm.notHide = true;
              }
        }

        vm.reset = {
            all: resetAllList,
            secondList: resetSecondList,
            thirdList: resetThirdList,
            fourthList:resetFourthList,
            fields: resetFields
        };

        vm.init = init;

        var user = CacheService.getObject(RoutesConstants.profil);
        vm.isIndependentUser = MainMetierService.isIndependantUser(user.roles);
        var firstListFields = [
            {
                key: 'brand',//336
                defaultOption: 'VEHICLE_BRAND',
                required: true,
            }, {
                key: 'familyCode',//007
                defaultOption: 'VEHICLE_MODEL_FAMILY',
                required: true,
            }, {
                key: 'modelType',//008
                defaultOption: 'VEHICLE_MODEL_TYPE',
                required: true,
            }
        ];
        var secondListFields = [
          {
            key: 'engine',
            code: '999',
            defaultOption: 'VEHICLE_ENGINE_TYPE',
            required: true,
          }, {
            key: 'gearbox',
            code: '997',
            defaultOption: 'VEHICLE_GEARBOX',
            required: true,
          }, {
            key: 'tractionBattery',
            code: '968',
            defaultOption: 'VEHICLE_BATTERY_TRACTION',
            required: false,
          }, {
            key: 'engineIndex',
            code: '998',
            defaultOption: 'VEHICLE_ENGINE_SUFFIX',
            required: false,
          }, {
            key: 'gearboxIndex',
            code: '996',
            defaultOption: 'VEHICLE_GEARBOX_SUFFIX',
            required: false,
          }, {
            key: 'batteryIndex',
            code: '966',
            defaultOption: 'VEHICLE_BATTERY_SUFFIX',
            required: false,
          }
        ];
        var thirdListFields = [
            {
                key: 'steeringWheel',
                code: '027',
                defaultOption: 'VEHICLE_STEERING_WHEEL_LOCATION'
            }, {
                key: 'version',
                code: '013',
                defaultOption: 'VEHICLE_VERSION'
            }, {
                key: 'equipmentLevel',
                code: '513',
                defaultOption: 'VEHICLE_EQUIPMENT_LEVEL'
            }, {
                key: 'heatingSystem',
                code: '046',
                defaultOption: 'VEHICLE_HEATING_SYSTEM'
            },
            {
                key: 'gas',
                code: '019',
                defaultOption: 'VEHICLE_GAS'
            },
            {
              key: 'gearboxType',
              code: '427',
              defaultOption: 'VEHICLE_GEARBOX_TYPE'
            }

        ];

        var fourthListFields = [
           
            {
                key: 'phase',
                code: '901',
                defaultOption: 'VEHICLE_PHASE'
            },
            {key: 'Documentryperiod',
            code: '900',
            defaultOption: 'VEHICLE_DOCUMENTRARY_PERIOD'

            }

        ];
        var tapvmbList = [];
        var lexiqueList = [];

        init(firstListFields, secondListFields, thirdListFields,fourthListFields);


        function autoSelect(list) {
               if(list.length == 1 ){
              return(list[0]);
            }
          }


        function autoFocus(key) {
         var id =key+"s";
         var input = document.getElementById(id);
           setTimeout(function () {
            $(input).focus();
           }, 300);
        };

         function divSelected(key) {
             var elemSelected = document.getElementById(key);
             var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
             var topContainer;
             positionOfElem + 15 + "px";
             if(positionOfElem <200){
               topContainer = positionOfElem + 25 + "px";
             } else{
               topContainer = positionOfElem + 28 + "px";
             }
             setTimeout(function () {
                 $(".my-container").css({ 'top': topContainer });
             }, 50);
         };

        function saveToCache() {
            var cacheData = {};
            var selectedFields = {};
            var dataCache = ['fields', 'fields2', 'fields3','fields4', 'showList', 'manufactureDate', 'lexiqueList', 'tapvmbList', 'selected'];

            vm.fields2.forEach(function (field) {
                if (field.value)
                    selectedFields[field.code] = field.value;
            })
            if(!_.isEmpty(vm.fields[0].selList)){
                vm.fields[0].selList.forEach(function(item){
                    delete item.childFilters
                })
            }

            dataCache.forEach(function (field) {
                switch (field) {
                    case 'fields': cacheData[field] = vm.fields; break;
                    case 'fields2': cacheData[field] = vm.fields2; break;
                    case 'fields3': cacheData[field] = vm.fields3; break;
                    case 'fields4': cacheData[field] = vm.fields4; break;
                    case 'showList': cacheData[field] = vm.showList; break;
                    case 'manufactureDate': cacheData[field] = vm.manufactureDate; break;
                    case 'lexiqueList': cacheData[field] = lexiqueList; break;
                    case 'tapvmbList': cacheData[field] = tapvmbList; break;
                    case 'selected': cacheData[field] = selectedFields; break;
                }
            });
            CacheService.setObject(CarSearchConstants.fieldSearchModel, cacheData);
        }

        function init(firstList, secondList, thirdList,fourthList) {
            var brandCache = CacheService.getObject(CarSearchConstants.manufacturerFilters);
            var cache = CacheService.getObject(CarSearchConstants.fieldSearchModel) || {};

            (brandCache ) ?
                vm.fields = buildFields(firstList, brandCache, cache.fields) : getBrandFamilyBodyTypeFilters(firstList);
            tapvmbList = cache.tapvmbList || [];
            lexiqueList = cache.lexiqueList || [];
            vm.manufactureDate = cache.manufactureDate
            vm.fields2 = buildFields2(secondList, cache.tapvmbList, cache.fields2, cache.selected);
            vm.fields3 = buildFields3(thirdList, cache.lexiqueList, cache.fields3);
            vm.fields4 = buildFields3(fourthList, cache.lexiqueList, cache.fields4);
            vm.showList = cache.showList || false;
            vm.refine = false;
        }

        function launchToaster(idMessage, error) {
            var promise = $translate(idMessage, { errorCode: (error && error.backError) ? error.backError : '?' });
            promise.then(function (text) {
                toastr.error(text, 'Error');
            });
        }

      
        /* RESET FUNCTION */

        function resetAllList() {
            resetThirdList();
            resetSecondList();
            resetFourthList(),

            vm.showList = false;
            vm.refine = false;
            vm.manufactureDate = '';
        }


        function resetFields() {

            vm.fields.forEach(function (field, index) {
                if (index > 0){
                    field.list = [];
                }

                if(index === 0){
                    field.selList = [];
                    field.tempValue = null;
                }
                    
                field.value = null;
            })
            resetSecondList();
            resetThirdList();
            resetFourthList();
            vm.showList = false;
            vm.refine = false;
            vm.manufactureDate = '';
            CacheService.removeObject(CarSearchConstants.fieldSearchModel);
        }

        function resetSecondList() {
            vm.fields2.forEach(function (field) {
                field.value = null;
                field.list = [];
            })
        }

        function resetThirdList() {
            vm.fields3.forEach(function (field) {
                field.list = [];
                field.value = null;
            })
        }
        function resetFourthList() {
            vm.fields4.forEach(function (field) {
                field.list = [];
                field.value = null;
            })
        }
        /* GET LIST FIRSTLISTFIELD */
        function getBrandFamilyBodyTypeFilters(firstListFields) {
            blockUI.start();
            var promise = CarSearchMetierService.getBrandModelList();

            function initFirstListFields(response) {
                if (vm.isIndependentUser) {
                    vm.brandList = [];
                    var decrypted = CryptoService.AES.decrypt((CacheService.getObject(CacheConstants.applicabilities)), CacheConstants.encryptedValue);
                    
                    vm.applicabilities = JSON.parse(decrypted.toString(CryptoService.enc.Utf8)).length > 0 ? JSON.parse(decrypted.toString(CryptoService.enc.Utf8)) : [];

                    if (vm.applicabilities.length > 0) {
                        vm.applicabilities.forEach(function (list) {
                            if(!_.isEmpty(list.brandCriteria)){
                                list.brandCriteria.forEach(function (item) {
                                    vm.brandList.push(item);
                                })
                            }
                        })
                        vm.brandList = _.uniq(vm.brandList);
                    }
                    if (!_.isEmpty(vm.brandList) && !_.isEmpty(response)) {
                        var asomBrandList = [];
                        var aplFilter = [];
                        var braFilter = [];
                        vm.brandList.forEach(function (asomBrand) {
                            response.forEach(function (resp) {
                                if (asomBrand == resp.criteriaCode) {
                                    asomBrandList.push(resp)
                                }
                            })

                        })
                        if (!_.isEmpty(asomBrandList)) {
                            asomBrandList.forEach(function (data) {
                                if (data.criteriaCode.substr(0, 3) === 'APL') {
                                    aplFilter.push(data)
                                }
                                else if (data.criteriaCode.substr(0, 3) === 'BRA') {
                                    braFilter.push(data)
                                }
                            })
                        }
                CacheService.setObject(CarSearchConstants.manufacturerFilters, {aplFilter:aplFilter,braFilter:braFilter});
                vm.fields = buildFields(firstListFields, {aplFilter:aplFilter,braFilter:braFilter});

                    } else {
                        getFilteredBrands(response);
                    }

                } else {
                    getFilteredBrands(response);
            }
            }

            promise.then(initFirstListFields, function (error) {
                launchToaster('CARSEARCH_ERROR_BRAND_LIST', error);
            }).finally(function () {
                blockUI.stop();
            });
        }
        function getFilteredBrands(response){
            var listSearchByModel = [];
            if (response && response.length) {
                if(vm.nissanUserURL){
                    listSearchByModel = response;
                }
                else{
                    listSearchByModel = response.filter(function (item1) {
                        if (item1.criteriaCode !== "APL12" &&
                            item1.criteriaCode !== "APL14" &&
                            item1.criteriaCode !== "APL04" &&
                            item1.criteriaCode !== "APL06" &&
                            item1.criteriaCode !== "APL02") {
                            return item1;
                        }
                    });
                }

                response = [];
                var tempResponse = [];
                listSearchByModel.forEach(function (item1) {
                    if(vm.nissanUserURL){
                        if (item1.criteriaCode === "APL04"){
                            response[0] = item1;
                        }
                        if (item1.criteriaCode === "APL09"){
                            response[1] = item1;
                        }
                        if (item1.criteriaCode === "APL16"){
                            response[2] = item1;
                        }
                        if (item1.criteriaCode === "BRA04"){
                            tempResponse[0] = item1;
                        }
                        if (item1.criteriaCode === "BRA09"){
                            tempResponse[1] = item1;
                        }
                        if (item1.criteriaCode === "BRA16"){
                            tempResponse[2] = item1;
                        }
                    }
                    else{
                        if (item1.criteriaCode === "APL03"){
                            response[0] = item1;
                        }
                        if (item1.criteriaCode === "APL05"){
                            response[1] = item1;
                        }
                        if (item1.criteriaCode === "APL18"){
                            response[2] = item1;
                        }
                        if (item1.criteriaCode === "APL08"){
                            response[3] = item1;
                        }
                        if (item1.criteriaCode === "APL11"){
                            response[4] = item1;
                        } 
                        if (item1.criteriaCode === "BRA03"){
                            tempResponse[0]= item1;
                        }
                        if (item1.criteriaCode === "BRA05"){
                            tempResponse[1]= item1;
                        }
                        if (item1.criteriaCode === "BRA18"){
                            tempResponse[2]= item1;
                        }
                        if (item1.criteriaCode === "BRA08"){
                            tempResponse[3]= item1;
                        };
                        if(item1.criteriaCode === "BRA26"){
                            tempResponse[4]= item1;
                        }
                    }
                })
            }
            if(vm.nissanUserURL) {
                var allowedFamilyCodes = ['XDD', 'XDE', 'XFK', 'X1322', 'X82','X1324','X1325'];

                if(!_.isEmpty(response)){
                    response.forEach(function(item){
                        item.childFilters = item.childFilters.filter(function(familyId){
                            return allowedFamilyCodes.includes(familyId.criteriaCode);
                        });
                    });
                    if(!_.isEmpty(tempResponse)){
                        tempResponse.forEach(function(item){
                            item.childFilters = item.childFilters.filter(function(familyId){
                                return allowedFamilyCodes.includes(familyId.criteriaCode);
                            });
                        });
                    }
                }            
            }
            CacheService.setObject(CarSearchConstants.manufacturerFilters, {aplFilter:response,braFilter:tempResponse});
            vm.fields = buildFields(firstListFields, {aplFilter:response,braFilter:tempResponse});
        }
        function replaceList(index, limit, list) {
            function reverse(field) {
                var tmp = field.tmp;
                field.tmp = field.list;
                field.list = tmp;
                field.value = null;
                return field;
            }
            for (; index < limit; index++)
                list[index] = reverse(list[index]);

            return true;
        }

        function watchVariable(listFields2, index){
            $scope.$watch("vm.criteriaResponse", function(){
                if(vm.criteriaResponse){
                    checkEngineGearboxSelect(listFields2, index);
                }
            },false);
        }

        function checkEngineGearboxSelect(listFields2, index) {
             if (index > 1)
                return;

            var stateRequiredFields = (listFields2[0].value && listFields2[1].value);
            if (stateRequiredFields && !vm.showList) {
                replaceList(0, vm.fields3.length, vm.fields3);
                replaceList(0, vm.fields4.length, vm.fields4);

                vm.showList = true;
            } else if (!stateRequiredFields && vm.showList) {
                replaceList(0, vm.fields3.length, vm.fields3);
                replaceList(0, vm.fields4.length, vm.fields4);

                vm.manufactureDate = '';
                vm.showList = false;
            }

        }




        function getFiltersList(fieldsList, value, id) {

            if (!value)
                return;
            /* GET LIST SECOND FIELD */
            function getTapvmbFilters(data) {
                if (!data.value)
                    return;
                blockUI.start();
                var bodyType = data.value.criteriaCode;

                function adjustOptionOnSelect(response) {
                    tapvmbList = response;
                    vm.fields2 = buildFields2(secondListFields, response);
                    replaceList(2, vm.fields2.length, vm.fields2);
                }

                if (vm.isFamilyCodeXTPorXRQ(vm.fields)) {
                    var promise = CarSearchMetierService.getTapvmbFilterListByFamilyType(vm.familyCode);
                } else {
                    var promise = CarSearchMetierService.getTapvmbFilterListByBodyType(bodyType, vm.familyCode);
                }
                promise.then(adjustOptionOnSelect, function (error) {
                    launchToaster('CARSEARCH_ERROR_GEARBOX_LIST', error);
                }).finally(function () {
                    blockUI.stop();
                    clickOnNext(id);
                });
            }

            /* GET LIST THIRD FIELD */
            function getLexiqueFilterList(data) {
                if (!data || !data.value)
                    return;
                blockUI.start();
                var fields3,fields4 = false;
                vm.criteriaResponse = false;

                var promise = CarSearchMetierService.getLexiqueFilterList(vm.familyCode, user);

                function adjustOptionOnSelect(response) {
                    lexiqueList = response;
                    vm.fields3 = buildFields3(thirdListFields, response);
                    vm.fields4 = buildFields3(fourthListFields, response);
                    if (vm.nissanUserURL && data && data.value && data.value.criteriaCode == "X82" ) {
                        vm.fields4.forEach(function (field) {
                            if (field.code === '901' && !_.isEmpty(field.list)) {
                                field.list = field.list.filter(function (item) {
                                    return item.criteriaCode === 'PHAS2';
                                });
                            }
                             if (field.code === '900' && !_.isEmpty(field.list)) {
                                field.list = field.list.filter(function (item) {
                                    return item.criteriaCode === "M2020";
                                });
                            }
                        });
                    }                
                    var stateRequiredFields = (vm.fields2[0].value && vm.fields2[1].value);
                    fields3 = !stateRequiredFields && replaceList(0, vm.fields3.length, vm.fields3);
                    fields4 = !stateRequiredFields && replaceList(0, vm.fields4.length, vm.fields4);
                    if(fields3 && fields4){
                        vm.criteriaResponse = true;
                    }
                }

               
                promise.then(adjustOptionOnSelect).finally(function () {
                    blockUI.stop();
                })
            }

            if (vm.isFamilyCodeXTPorXRQ(vm.fields))  {
                getTapvmbFilters(fieldsList[CarSearchConstants.indexFamilyCode]);
            } else {
                getTapvmbFilters(fieldsList[CarSearchConstants.indexBodyType]);
            }

            getLexiqueFilterList(fieldsList[CarSearchConstants.indexFamilyCode]);
        }



        function search(firstList, secondList, thirdList, date,fourthList) {

            function checkRequiredField(firstList, secondList) {
                for (var index in firstList) {
                    if (vm.isFamilyCodeXTPorXRQ(firstList)){
                        break;
                    } else if (!firstList[index].value){
                        return false;
                    }
                }
                for (var index in secondList)
                    if (secondList[index].required && !secondList[index].value)
                        return false;
                return true;
            }

            function checkDate(date) {
                var re = /^[0-9]{4}\/[0-9]{2}$/;
                return date.match(re);
            }

            function alert(message) {
                var promise = $translate(message);
                promise.then(function (text) {
                    toastr.error(text, 'Error');
                });
            }

            if (!checkRequiredField(firstList, secondList)) {
                alert('COMMON_ERROR_MISSING_MANDATORY_DATA');
                return;
            } else if (date.length > 0 && !checkDate(date)) {
                alert('COMMON_ERROR_INVALID_DATE_FORMAT');
                return;
            }

            var dataCritFixe = {};

            for (var index in firstList) {
                if (index==='0' && firstList[index].tempValue) {
                        dataCritFixe[firstList[index].tempValue.objectCode] = firstList[index].tempValue.criteriaCode;
                    }else{
                        if (firstList[index].value && firstList[index].value.objectCode && firstList[index].value.criteriaCode) {
                            dataCritFixe[firstList[index].value.objectCode] = firstList[index].value.criteriaCode;
                        }
                    }
            }

            for (var index in secondList) {
                if (secondList[index].value) {
                    dataCritFixe[secondList[index].code] = secondList[index].value;
                }
            }

            for (var index in thirdList) {
                if (thirdList[index].value) {
                    dataCritFixe[thirdList[index].value.objectCode] = thirdList[index].value.criteriaCode;
                }
            }

            for (var index in fourthList) {
                if (fourthList[index].value) {
                    dataCritFixe[fourthList[index].value.objectCode] = fourthList[index].value.criteriaCode;
                }
            }

            var carContext = {
                "fixedCriterias": dataCritFixe,
                "variableCriterias": date.length ? { 'APVDT1': date } : {},
            }

            CacheService.setObject(CacheConstants.hideDocsVisited, true);
            CarSearchMetierService
                .searchCarModel(carContext)
                .then(function (resp) {
                    saveToCache();
                    var data = resp;
                    if(vm.isMitsubishiUser  && data && data.carContext && data.carContext.brandComputed && (data.carContext.brandComputed != "APL15" && data.carContext.brandComputed != "BRA15" )){
                        CacheService.removeObject(CacheConstants.contextCarSearch);
                        CacheService.removeObject(CacheConstants.contextCarRequest);
                        toastr.error($translate.instant("VIN_NOT_ALLOWED"));
                    }
                   else{
                    if (data && data.carContext && data.carContext.fixedCriterias && (data.carContext.typeMD === "B2-3" || data.carContext.typeMD === "B3-ADT") && (!_.has(data.carContext.fixedCriterias, '901') || !_.has(data.carContext.fixedCriterias, '900'))) {

                        if (vm.nissanUserURL && vm.familyCode == "X82" ) {
                        lexiqueList = lexiqueList.filter(function (field) {
                            if (field.objectCode === '901') {
                                return field.criteriaCode === 'PHAS2';
                            }
                            if (field.objectCode === '900') {
                                return field.criteriaCode === 'M2020'; 
                            }
                        });
                    }  

                        CarSearchMetierService.phaseMillesimPopup(data, lexiqueList).then(function (result) {
                            if (result) {
                                var carContext = {
                                    "fixedCriterias": result.carContext.fixedCriterias,
                                    "variableCriterias": date.length ? { 'APVDT1': date } : {},
                                }
                                blockUI.start();
                                CarSearchMetierService.searchCarModel(carContext).then(function (resp) {
                                    CarSearchMetierService.getBannerData(carContext.fixedCriterias,carContext.brandComputed);
                                    $state.go(RoutesConstants.carSearchResult);
                                }).catch(function(error){
                                    toastr.error(error)
                                }).finally(function(){
                                    blockUI.stop();
                                });
                            }
                        });
                    }
                    else {
                        CarSearchMetierService.getBannerData(carContext.fixedCriterias,carContext.brandComputed);
                        $state.go(RoutesConstants.carSearchResult);
                    }
                    }               
                }), function (error) {
                    toastr.error(error, 'Error');
                }
        }
    }

    /* END CONTROLER */

    /* TOOLS */

    /* CREATE THREE FIRST FIELDS */
    function buildFields(arrayFields, list, cacheData) {
        if (!list)
            list = [];
        else if (!arrayFields)
            arrayFields = [];

        function resetSelect(index, fields) {
            /* reset next field */
            index = index + 1;
            if (index >= fields.length) return;

            for (; fields[index]; index++) {
                fields[index].value = null;
                fields[index].list = [];
                fields[index].tempValue = null;
            }
        }

        function adjustSelect(index, selectValue, fields) {
            /* adjust next select */
            var newSamplList = [];
            resetSelect(index, fields);
            index = index + 1;
            var key = "childFilters";
            if (!selectValue)
                return;
            else if (index >= fields.length)
                return;

                if(index===1){
                    fields[0].selList = [];
                    selectValue = JSON.parse(angular.toJson(selectValue));
                    newSamplList = list.aplFilter.concat(list.braFilter);
                    newSamplList = _.filter(newSamplList, function (item) {
                        if (item != null && !_.isEmpty(item)) {
                            return item;
                        }
                    });
                    var sampleAppl = _.groupBy(newSamplList, 'criteriaCode');
                    fields[0].selList.push(sampleAppl[selectValue.criteriaCode][0])
                    if(sampleAppl["BRA"+selectValue.criteriaCode.substr(3,2)])
                        fields[0].selList.push(sampleAppl["BRA"+selectValue.criteriaCode.substr(3,2)][0])
                    fields[0].selList = _.uniq(fields[0].selList);
                    angular.forEach(fields[0].selList,function(listVal){
                        fields[index].list = fields[index].list.concat(listVal[key]);
                    })
                }else{
                    fields[index].list = selectValue[key];
                }
            
                if(index===2){
                    selectValue = JSON.parse(angular.toJson(selectValue));
                    angular.forEach(fields[0].selList,function(val){
                        if(val[key]){
                            var keyVal = JSON.parse(angular.toJson(val[key]));
                            angular.forEach(keyVal,function(criteria){
                                if(angular.equals(criteria,selectValue)){
                                    fields[0].tempValue = val;
                                }
                            })
                        }
                    })
                }
            fields[index].value = null;
          }

        function recoverValueFromCache(cacheData, index) {
            if (!cacheData || !cacheData[index] || !cacheData[index].value || !cacheData[index].list)
                return null;
            var list1 = cacheData[index].list;
            var label = cacheData[index].value.label;
            for (var prop in list1)
                if (list1[prop].label === label)
                    return list1[prop];

            return null;
        }

        function recoverTempValueFromCache(cacheData, index) {
            if (!cacheData || !cacheData[index] || !cacheData[index].tempValue)
                return null;
            var list1 = list.aplFilter.concat(list.braFilter);
            var label = cacheData[index].tempValue.label;
            for(var tList in list1){
                if (tList.label === label)
                    return tList;
            }

            return null;
        }

        function recoverListFromCache(cacheData, index) {
            if (!cacheData || !cacheData[index] || !cacheData[index].list)
                return [];
            return cacheData[index].list;
        }

        function recoverSelListFromCache(cacheData, index) {
            if (!cacheData || !cacheData[index] || !cacheData[index].selList)
                return [];
            return cacheData[index].selList;
        }

        var data = [];

        arrayFields.forEach(function (item, index) {
            data.push({
                key: item.key,
                value: recoverValueFromCache(cacheData, index), // value is an object
                reset: resetSelect, // function
                function: resetSelect, // function
                defaultOption: item.defaultOption, // string
                adjust: adjustSelect,
                list: recoverListFromCache(cacheData, index),
                index: index,
                required: item.required,
                tempValue: recoverTempValueFromCache(cacheData, index),
                selList:recoverSelListFromCache(cacheData, index),
            });
        });

        if (!data[0].list.length){
            if(list.braFilter && !_.isEmpty(list.braFilter[4])){
                var newModalList = list.aplFilter.concat(list.braFilter[4]);
                data[0].list = newModalList;
            }
            else{
                data[0].list = list.aplFilter;
            }
        }
        return data;
    }

    /* CREATE 6 NEXT FIELDS */
    function buildFields2(arrayFields, listSelect, dataFromCache, selectedFromCache) {
        if (!arrayFields)
            arrayFields = [];
        if (!listSelect)
            listSelect = [];
        function parseList(arrayFields, list) {
            var newList = {};
            arrayFields.forEach(function (item) {
                var key = item.code
                newList[key] = [];
                list.forEach(function (element) {
                    var value = element[key];
                    if (value && newList[key].indexOf(value) === -1)
                        newList[key].push(value);
                });
            });
            return newList;
        }

        var selected = selectedFromCache || {};
        function filterList(value, field, listFields, action) {
            var filterList = listSelect;
            var previousSelectedElement = angular.element(document.querySelector('md-option[value="'+selected[field.code]+'"]'));
            var currentSelectedElement = angular.element(document.querySelector('md-option[value="'+value+'"]'));

            if (!selected[field.code]) {
                currentSelectedElement.attr('selected', 'selected');
            }

            if (!value) {
                previousSelectedElement.removeAttr('selected');
                delete selected[field.code];
            } else if (action === 'ADDED') {
                //to remove attribute selected from previous element and add it to current
                if (selected[field.code]) {
                    previousSelectedElement.removeAttr('selected');
                    currentSelectedElement.attr('selected', 'selected');
                }
                selected[field.code] = value;
            } else if (action === 'DELETED') {
                delete selected[field.code];
            }
            if (Object.keys(selected).length > 0)
                filterList = listSelect.filter(function (value) {
                    var length = Object.keys(selected).length;
                    var i = 0;

                    _.forEach(selected,function(v,k){
                        if(v === value[k]){
                            i++;
                        }
                    })
                    
                    if(i===length){
                        return true;
                    }
                        return false;
                    
                })

                if(listFields[2].value){
                    listFields[5].selParent = true;
                }else if(!listFields[2].value){
                    listFields[5].selParent = false;
                }

                if(field.index === 1 && filterList.length > 1){
                    listFields[2].selParent = false;
                }else if(field.index === 1 && filterList.length === 1){
                    listFields[2].selParent = true;
                }
            var list = parseList(arrayFields, filterList);
            var required = (listFields[0].value && listFields[1].value);
            listFields.forEach(function (field, index) {
                if (!required && index > 1)
                    field.list = [];
                else{
                    if(index !== 5 || (index === 5 && listFields[2].value)){
                        field.list = list[field.code];
                    }else{
                        field.list = [];
                    }
                }
            })
        }

        function restoreValueFromCache(dataCache, index) {
            if (!dataCache || !dataCache[index] || !dataCache[index].list)
                return null
            return dataCache[index].value;
        }

        function restoreListFromCache(dataCache, index, list) {
            if (!dataCache || !dataCache[index] || !dataCache[index].list)
                return list
            return dataCache[index].list;
        }

        function resetSelect(index, fields) {
            /* reset next field */
            if (index >= fields.length) return;
            if(index > 1){

                if(index === 2){
                    fields[5].value = null;
                    fields[5].list = [];
                    fields[5].tmp = [];
                    delete selected[fields[5].code];
                }else{
                    fields[index].value = null;
                    fields[index].list = [];
                    fields[index].tmp = [];
                    delete selected[fields[index].code];
                }                
            } else {
                index = index + 1;                
                for (; fields[index]; index++) {
                    fields[index].value = null;
                    fields[index].list = [];
                    fields[index].tmp = [];
                    delete selected[fields[index].code];
                }
            }            
        }

        function createCompleteFields(fields, listSelect, dataFromCache) {
            var newFields = [];
            fields.forEach(function (field, index) {
                newFields.push({
                    key: field.key,
                    code: field.code,
                    defaultOption: field.defaultOption,
                    list: restoreListFromCache(dataFromCache, index, listSelect[field.code]) || [],
                    filterList: filterList,
                    required: field.required,
                    tmp: [],
                    reset: resetSelect,
                    index: index,
                    selParent : false,
                    value: restoreValueFromCache(dataFromCache, index),
                })
            })
            return newFields;
        }

        var newListSelect = parseList(arrayFields, listSelect);
        var newFields = createCompleteFields(arrayFields, newListSelect, dataFromCache);
        return newFields;
    }

    function buildFields3(arrayFields, listSelect, dataFromCache) {
        if (!arrayFields)
            arrayFields = [];
        if (!listSelect)
            listSelect = [];
        /*
          LIST SELECT = LEXIQUE FROM QUERY OR CACHE
        */
        function parseList(arrayFields, listSelect) {
            var newList = {};

            arrayFields.forEach(function (field) {
                var code = field.code;
                newList[code] = [];
                listSelect.forEach(function (element) {
                    if (code === element['objectCode'])
                        newList[code].push({
                            'objectCode': element.objectCode,
                            'label': element.label,
                            'criteriaCode': element.criteriaCode
                        })
                })
            })
            return newList;
        }

        function recoverValueFromCache(cacheData, index) {
            if (!cacheData || !cacheData[index] || !cacheData[index].value || !cacheData[index].list)
                return null;
            var list = cacheData[index].list;
            var label = cacheData[index].value.label;
            for (var prop in list)
                if (list[prop].label === label)
                    return list[prop];
            return null;
        }

        function recoverListFromCache(cacheData, index, listSelect) {
            if (!cacheData || !cacheData[index] || !cacheData[index].list)
                return listSelect;
            return cacheData[index].list;
        }

        function createCompleteFields(arrayFields, listSelect /* object */, dataFromCache) {
            var completeFields = [];
            arrayFields.forEach(function (field, index) {
                completeFields.push({
                    key: field.key,
                    code: field.code,
                    defaultOption: field.defaultOption,
                    tmp: [],
                    list: recoverListFromCache(dataFromCache, index, listSelect[field.code]) || [],
                    value: recoverValueFromCache(dataFromCache, index)
                })
            })
            return completeFields;
        }

        var newList = parseList(arrayFields, listSelect);
        return createCompleteFields(arrayFields, newList, dataFromCache);
    }

})();

(function () {

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.carSearch, {
        url: '/carSearch/?:orderNumber/?:vin',
        templateUrl: 'app/components/car/carSearch/carSearch.html',
        params: {
          searchByModel: false
        },
        controller: 'carSearchCtrl',
        controllerAs: 'cSearchctrl',
        resolve: {
          alerts: function ($q, $state, AlertsService) {
            var defer = $q.defer();
            var status = AlertsService.getPopinVisibility().status;
            if (status) {
            //  AlertsService.modalAlertsContactCar().then(function () {
                AlertsService.setPopinVisibility(false,'',null,false);
                defer.resolve();
           //   }, function () {
            //    AlertsService.setHidePopin(true);
            //    defer.reject();
            //  });

              return defer.promise;
            }
          },
          // permission : function(authService) {
          //   return authService.checkPermission();
          // }
        }
      });
  }
})();


(function () {

    angular
        .module('phenix')
        .controller('carSearchCtrl', carSearchCtrl);

    function carSearchCtrl($timeout,$state,CacheService, CacheConstants, $mdDialog, $rootScope, MainMetierService,configConstantes,$scope) {
        var vm = this;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.userProfile = CacheService.getObject(CacheConstants.profil);
        vm.roles = (vm.userProfile && vm.userProfile.roles)?vm.userProfile.roles : null;
        var user = CacheService.getObject('profil');
        var informationDetails = CacheService.getObject(CacheConstants.informationServiceDetails)

        var hasDealerRole = MainMetierService.hasDealerRole();
        var popinShown = CacheService.getObject('eligibleOffersPopinShown');
            if (hasDealerRole && !popinShown) {
                $mdDialog.show({
                    templateUrl: 'app/components/car/rLinkCar/connectedServicesOffers/eligibleOffersPopin.template.html',
                    controller: 'EligibleOffersPopinCtrl',
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    multiple: true,
                    locals: {
                        offers: []
                    }
                });
                CacheService.setObject('eligibleOffersPopinShown', true);
            }
        $scope.$on('$destroy', function() 
        {$mdDialog.hide();});       
        if($state.params.isAngularRedirect){
            var e = document.getElementById("toast-container")
            if(e){
                e.setAttribute("style","display:none;");
            }
            $timeout(function () {                
                var brandDiv = null;
                if( window.location.href.split('#ng')[1] == 'Help' || window.location.href.split('#ng')[1] == 'Profile'){
                    brandDiv = angular.element(document.querySelector('#ng'+ window.location.href.split('#ng')[1]));
                }else if( window.location.href.split('#ng')[1] == 'prTextSearch'){
                    brandDiv = angular.element(document.querySelector('#ng'+ window.location.href.split('#ng')[1]+' div div#searchButton'));
                } else if( window.location.href.split('#ng')[1] == 'BasketClick' && user.userType != 'ARCA' && user.userType != 'RNET'){
                    brandDiv = angular.element(document.querySelector('#ng'+ window.location.href.split('#ng')[1]+' div#asomBasketIcon div'));
                } else if(window.location.href.split('#ng')[1] != 'Settings'){
                    brandDiv = angular.element(document.querySelector('#ng'+ window.location.href.split('#ng')[1] +' div'));
                }
                angular.element(brandDiv).triggerHandler('click');

                var userProfile = CacheService.getObject(CacheConstants.profil);
                /* if(CacheService.getUserType() === 'RNET' && userProfile.userContextList.length > 1){
                    $mdDialog.show({
                        templateUrl: 'app/components/login/multiProfile.template.html',
                        controller: 'multiProfileController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            userContextList: userProfile.userContextList,
                            userName:  userProfile.firstName + ' ' + userProfile.lastName
                        }
                    }).then(function (result) {
                    }).catch(function (error) {
                        $log.debug($translate.instant('ERROR'));
                    });
                }*/ 
                if(CacheService.getObject(CacheConstants.angularInfoServiceDetails) && informationDetails && informationDetails.message){
                    $mdDialog.show({
                        templateUrl:
                            "app/components/car/carSearch/components/modalInformation.template.html",
                        controller: "modalInformationController",
                        bindToController: true,
                        controllerAs: "vm",
                        clickOutsideToClose: true,
                        locals: {                            
                            information: informationDetails.message,
                            on_complete: function(informationDetails) {
                                MainMetierService.AsomDocAccessPopIn(user);                                
                                if (CacheService.getObject(CacheConstants.r2aDealerList)){
                                    var cachedetail = CacheService.getR2ADealerList();
                                    var dealerList = _.find(cachedetail.dealers, function(item){
                                        return item.active == true;
                                    });
                                    if (!dealerList){
                                        $rootScope.$broadcast('displayDealerPopup', true);
                                    }

                                }

                            }                           
                        }
                    });
                }else{
                    MainMetierService.AsomDocAccessPopIn(user);
                }
            },100);
        }

    }

})();


angular.module('phenix').constant('CarSearchConstants', {

  contextCarSearch: 'contextCarSearch',

  restCarSearchByModel: '/proxy/apidh/rest/v1/carContexts/custom',  // for submitting the search form by model (POST)
  restCarSearchByVin: '/proxy/apidh/rest/v1/carContexts/vin',
  customerFocusStatus: '/proxy/apigee/aic/customer-focus/v1/customer-focuses',
  carSearchByNewRegistrationUrl: '/proxy/apidh/rest/v1/carContexts/registration',

  technicalBulletins: '/proxy/apidh/rest/v1/technicalBulletins/numbers',
  technicalNotes: '/proxy/apidh/rest/v1/technicalNotes/numbers',
  connectedServicesAudit: '/connectedService/updateAudit',
  userTrackingAudit: '/userTracking/updateTracking',
  auditData:'/connectedService/getAllAudit',

  restCarSearchSticker:'/proxy/apidh/rest/v1/vehicle/modele',//?family=xde&manufactuerID=xxxx
  restCarSearchLabel:'/proxy/apidh/rest/v1/label/criteria/',///{codeObject}/{codeLangue}
  getGemStopped:'/vehicles/getGemStopped',
  dmsCarSearch: '/vehicle.v1',
  restCarSearchByOR: '/order.v1',
  dmsCustomerSearch: 'customers.v1',
  restHistorizationVehicles: '/history/vehicles',
  restHistorizationVehiclesSB: '/history/updateVehicle',
  documentsElectrical:'/documents/electrical',
  documentsViewed:'documents/recentlyvisited',
  restCarOts: '/proxy/apigee/ots/v1/solutions/vin/',/* vin/VFxxxxxxxxxxx[lang=EN]*/
  restCarOtsInformations: '/proxy/apigee/ots/v1/solutions/vin',/* /solutions/vin/{vin}/ots-informations */
  restCarSplits: '/vehicles/splits',
  restCarSplitsDetail: '/vehicles/splits/detail',
  restCarMtnProg: '/vehicles/maintenance',
  restSearchArboTextual:'/proxy/apidh/rest/v1/applicabilities/fixedFilteredTree',
  documentationNode:'/proxy/apidh/rest/v1/plates', ///{NODE***/PR}
  productsNode:'/proxy/apidh/rest/v1/texts/paged',
  applicabilityVar:'/proxy/apidh/rest/v1/applicabilities/variableFiltered/',
  restCarSearchBms :'/proxy/apigee/vehicle/bms/v0/vin/',
  restCarSearchBrandFilter:'/proxy/apidh/rest/v1/carContexts/listVehBody',
  restCarSearchTapvmbFilter:'/proxy/apidh/rest/v1/carContexts/listComponents',
  restCarSearchLexiqueFilter:'/proxy/apidh/rest/v1/carContexts/listCriterias',
  breakingNews:'/proxy/apidh/rest/v1/breakingNews',
  breakingNewsSB:'/news/breakingNews',
  sparePartsHercule: '/proxy/apidh/rest/v1/spare-parts/vin/',
  sparePartsFamily: '/family/',
  enggInfoPart:'/proxy/apigee/bom/engineering-information-part/v1/parts',
  sparePart:'/spare-parts?withSerial=false&carryOverOnly=true&singleLVAOnly=true',
  sparePartCharacteristicsWhiteList:'&sparePartCharacteristicsWhiteList=000ERP&sparePartCharacteristicsWhiteList=000RVX&sparePartCharacteristicsWhiteList=000ECO&sparePartCharacteristicsWhiteList=000SOH&lang=en',
  serialGenericPartBlackList:'&serialGenericPartBlackList=F17193/AG&serialGenericPartBlackList=F17193/AH&serialGenericPartBlackList=ASS007668&serialGenericPartBlackList=A2950020-&serialGenericPartBlackList=A2950359-',
  vehicleAssemblyCharacteristicsWhiteList:['000ERP','000RVX','000ECO','000SOH'],
  vehicleAssemblySpareParts:'/vehicle-assemblies-spare-parts?withSerial=false&carryOverOnly=true&singleLVAOnly=true',
  vehicleAssemblySparePartsBeta:'/vehicle-assemblies-spare-parts?withSerial=false&carryOverOnly=false&singleLVAOnly=true',
  platesNode:'/proxy/apidh/rest/v1/plates2',
  plateLines:'/proxy/apidh/rest/v1/plates/lines',
  docPrivComments:'/docpriv/comments',
  docPrivDeleteComments:'/docpriv/deletecomments',
  getInterventionId: '/proxy/apidh/rest/v1/interventions',
  basketByIntId: '/proxy/apidh/rest/v1/basket-interventions/documents',
  contextCarRequest: 'contextCarRequest',

  vehicleCriteriaBrand:'BRAND',
  vehicleCriteriaModel:'008',
  vehicleCriteriaEngineType:'999',
  vehicleCriteriaGearbox:'997',
  vehicleCriteriaEngineSuffix:'998',
  vehicleCriteriaGearboxSuffix:'996',
  vehicleCriteriaSteeringWheel:'027',
  vehicleCriteriaVersion:'013',
  vehicleCriteriaEquipmentLevel:'513',
  vehicleCriteriaHeatingSystem:'046',
  manufacturerFilters : 'manufacturerFilters',
  fieldSearchModel: 'fieldsFromCarSearchModel',
  networkProfileWorkshop:'WORKSHOP',
  networkProfilePartshop:'PARTSHOP',
  horseProfile:'HORSE',
  mitsubishiProfile:'PPX_MMC',
  ppxNetworkProfile:'PPX_NETWORK_USER',
  ppxIndependentUser:'PPX_INDEPENDENT_USER',
  ppxNis: 'PPX_NIS',
  ppxNissanConnectedServices: 'PPX_NISSAN_CONNECTED_SERVICES',
  ppxLight: 'PPX_LIGHT',
  ppxCorporateUser:'PPX_CORPORATE_USER',
  horseProfFields: ['refBoi','refMot','refMot2','refBattery'],
  careAlertPilotDealers: ['0100111001010100001','00001190','00001173','00001168','00001290','00001312','00001156','00000001','00000856','00000862','00000857','00001328','00000002','00001299','00001270','00001256','00001268','00001263','00001269'],
  partId: '?part-id=',
  managingCompanyLabel: '&managingCompany=',
  indexFamilyCode: 1,
  indexBodyType: 2,
  restVinReP:'/proxy/apigee/vehicle/rep/v0/vin/',
  restOperationsVin:'/proxy/apigee/after-sales/maintenance/v1/operations/vin',
  restOperationDetail:'/proxy/apigee/after-sales/maintenance/v1/operations/operation-id',
  r2aService:'/proxy/apigee/rp4-R2a/v1/referential/commercial-links',
  restTransversalPartsTree:'/proxy/apidh/rest/v1/transversalPartsTree',
  transeversalNodes:'/proxy/apidh/rest/v1/transversalParts',

  commercialLinkSave: 'commercialLinks/saveR1Details',
  commercialLinkGet: 'commercialLinks/getR1Dealer',
  r2aIrn:'59104',
  ppxSia:'PPX',
  r2aRepo:'BIR',
  r2aPriceTaxDiscount:'/proxy/apigee/rp4-R2a/v1/prices',
  r2aStock:'/proxy/apigee/rp4-R2a/v1/stocks',
  r2aPlaceOrder: '/proxy/apigee/1po/v1/external-orders',
  rpsPlaceOrder: 'proxy/apigee/1po/v1/external-baskets',
  partReqRpsPartsTransfer:'/partsRequisitions/IsPartsTransferred',
  partRequisitionRpsId:'/partsRequisitions/updateOrderId',
  // partRequisitionEstimateNumber:'/partsRequisitions/updateEstimateNumber',
  cartRpsId:'/carts/updateOrderId',
  elementsByGenericParts:'/proxy/apidh/rest/v1/elements/byGenericParts',
  subscriptionsurl:'/proxy/apigee/a5o/v1/persons/',
  subscriptionsurlsuffix:'/subscriptions',
  
  vinOperation: 'proxy/apigee/arp/v1/operations/',
  vinOperationControllerV2:'proxy/apigee/arp/v2/vehicles/',
  vinOperationOperationV2:'/operations/planned',
  vinMileage: 'proxy/apigee/arp/v1/vin-info/',
  vinMileageNewV2: 'proxy/apigee/arp/v2/vehicles/',
  infoFicEnabledCountries: ['FR','DE','IT','ES','GB','UK','PT','BE','LU','NL','AT','CH','PL','CZ','SK','RO','MA','DZ','TR','IN','BR','AR','CO','MX'],
  notificationsEndPoint: '/notifications',
  updateReadStatus: '/updateReadStatus/'
});

(function () {
    angular.module('phenix').component('axleGeometry', {
        bindings: {
            applicabilities: '<' // array<object>
        },
        controller: axleGeometryController,
        controllerAs: 'vm',
        templateUrl: 'app/components/car/axleGeometry/axleGeometry.template.html'

    });

    /* @ngInject */
    function axleGeometryController(

        AxleGeometryService,
        ApplicabilitiesX70Constants,
        CacheService,
        toastr,
        $translate
    ) {

        /************************
         *     VARIABLE         *
         ***********************/

        var vm = this;
        vm.computedGeometry = [];
        vm.id = null;
        vm.isX70Vehicle = false;

        /* inputs */

        vm.sizes = {};
        vm.calculResult = {};

        /************************
         *    FUNCTIONS         *
         ***********************/

        vm.selectGeometry = selectGeometry;
        vm.formatResidual = formatResidual;
        vm.onCalcul = onCalcul;

        /**
         *      @desc
         *      Set default value on sizes / id
         *      format data from residuel
         */

        this.$onInit = function () {
            setDefaultsValue();

            var applicabilitiesLabelX70 = ApplicabilitiesX70Constants.applicabilitiesLabelX70;
            var userProfil = CacheService.getUserProfile();

            var car = CacheService.getCarContext();

            if (!_.isEmpty(car.families.familyVehicle) && car.families.familyVehicle[0] === 'X70'){
                vm.isX70Vehicle = true;
                if (applicabilitiesLabelX70[userProfil.language] != undefined) {
                    vm.computedGeometry = applicabilitiesLabelX70[userProfil.language];
                }
                else {
                    vm.computedGeometry = applicabilitiesLabelX70["en"];
                }

                if (vm.computedGeometry.length === 1) {
                    vm.id = vm.computedGeometry[0].id;
                }
            }else {
                if (Array.isArray(vm.applicabilities)) {
                    vm.computedGeometry = vm.formatResidual(vm.applicabilities);
                    if (vm.computedGeometry.length === 1) {
                        vm.id = vm.computedGeometry[0].id;
                    }
                }
            }
        };

        /**
         *  @desc This function is trigger when user select an element of vm.computedGeometry
         *        Save ID, and reset all values from inputs.
         *        ID is used on calcul
         */

        function selectGeometry(id) {
            vm.id = id;
            setDefaultsValue();
        }

        /**
         *  @desc   Add new field on each element of residualApplication => computedResiduel: Array<string>
         *  @param {}
         *  @return {array<{}>}
         */

        function formatResidual(residualApplicabilities) {
            return residualApplicabilities.map(function (lign) {
                var computedResidual = lign.residual.reduce(function (acc, obj) {
                    var tmp = [];

                    if (Array.isArray(obj.variable)) {
                        tmp = tmp.concat(obj.variable);
                    }

                    if (Array.isArray(obj.fixe)) {
                        tmp = tmp.concat(obj.fixe);
                    }

                    var residual = tmp.map(function (v) {
                        var labelObj = v.labelObj;
                        var labelCrit = '';
                        if (Array.isArray(v.listCrit)) {
                            labelCrit = v.listCrit.map(function (crit) {
                                return crit.labelCrit
                            }).join(' | ');
                        }
                        return labelObj + ' : ' + labelCrit;
                    });

                    return acc.concat(residual);
                }, []);

                return _.assign({}, lign, {
                    computedResidual: computedResidual
                });
            });
        }

        function onCalcul(sizes) {
            (function () {
                //remove result from previous calcul
                vm.calculResult = {};

                // remove errors from previous calcul
                _.map(sizes,function(item){
                    _.assign(item,{error : false})
                })
            })()
            // check if all inputs
            for (var prop in sizes) {
                if (!sizes[prop].value) {
                    return;
                }
            }

            AxleGeometryService.calculate(vm.id, sizes).then(function (res) {
                vm.calculResult = res;
            }).catch(function (err) {
                // err is an array when some sizes are incorrects | ERRORS
                // .error used on template to display a red border on input
                if (Array.isArray(err)) {
                    err.forEach(function (prop) {
                        vm.sizes[prop].error = true;
                    })
                    toastr.error($translate.instant('OUT_TOLERANCE'));
                    return;
                } else {
                    toastr.error($translate.instant('ERROR'));
                }

            });
        }

        /********************
         *      TOOLS       *
         *******************/

        /**
         *  @desc reset/set default value
         */

        function setDefaultsValue() {
            vm.sizes = {
                leftFrontW: {
                    value: null
                },
                leftFrontR: {
                    value: null
                },
                rightFrontW: {
                    value: null
                },
                rightFrontR: {
                    value: null
                },
                leftRearW: {
                    value: null
                },
                leftRearR: {
                    value: null
                },
                rightRearW: {
                    value: null
                },
                rightRearR: {
                    value: null
                }
            }

            vm.calculResult = {
                // frontRighthandWheel: null,
                // frontLefthandWheel: null,
                // rearRighthandWheel: null,
                // rearLefthandWheel: null
            }

        }


    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('testOpcodPopupController', testOpcodPopupController);

    /** @ngInject */
    function testOpcodPopupController($mdDialog) {
        var vm = this;

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;
        vm.onClose = onClose;

        function onClose() {
            $mdDialog.hide();
        }

        function onConfirm() {
            $mdDialog.hide(true);
        }

        function onCancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {

    angular.module('phenix').component('shoppingCart', {
        bindings: {
            /* MANDATORY */
            piece: '=', // Object
            /* MANDATORY IF TYPE === PPS */
            mainPiece: '<', // MUST BE DEFINE if type === 'PPS'
            reference: '<',

            type: '@',   // PPS | UNDEFINED
            from: '@',  // PR | TM | PRODUCTS | PART

            /* USE IN HTML */
            page: '@',
            checkDealerList: "<"
        },
        controller: controller,
        templateUrl: 'app/components/basket/shoppingCart/shopping-cart.template.html'
    })

    /**
     *      @desc /!\ READ THIS FIRST
     *
     *      A piece can be a PPS when the mainPiece's quantity is > 0.
     *
     */

    function controller(ShoppingCartService, $translate, $mdDialog, toastr, blockUI, CodesConstants, ShoppingCartServiceConstant) {
        const _actions = ShoppingCartService.constants;

        const vm = this;

        /*=============================================
        =                  VARIABLES                  =
        =============================================*/

        vm._computedPiece = {};
        vm._previousPiece = {};
        /**
         * It is mandatory for the function 'updateFromInput', we have to update it once the quantity change.
        */
        let _oldQuantity = 0;
        let _VOI = [];
        let _type = 'PR';
        const _essai = ShoppingCartServiceConstant.essai;

        vm.isOrderingModuleEnable = false;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        this.handleFirstAdd = handleFirstAdd;
        this.addToShoppingCart = addToShoppingCart;
        this.addOne = addOne;
        this.handleKeydown = handleKeydown;
        this.reduceOne = reduceOne;
        this.updateFromInput = updateFromInput;
        this.updateFromInputSecond = updateFromInputSecond;
        this.getVOI = getVOI;


        this.$onChanges = function() {
            this.$onInit();
        }


        this.$onInit = function () {
            if (vm.page === 'cart') {
                _oldQuantity = vm.piece.quantity;
            }

            if (vm.from === 'TM') {
                vm._computedPiece = {
                    reference: vm.piece.technicalId,
                    opecod: vm.piece.id,
                    duration: vm.piece.duration,
                    designation: vm.piece.designation,
                    element:vm.piece.element,
                    operation: vm.piece.operation,
                    essay: vm.piece.essay,
                    gie: vm.piece.gie
                }
                vm.piece.reference = vm.piece.technicalId;
                _type = 'TM';
            } else if (vm.from === 'PART') {
                vm._computedPiece = {
                    reference: vm.piece.originalPartReference,
                    designation: vm.piece.designation,
                    priceExclTaxes: vm.piece.priceWithoutTaxes,
                    currency: vm.piece.currency,
                    reach: !!vm.piece.reach,
                    additional: vm.piece.additional
                }
            } else {
                vm._computedPiece = vm.piece;
                if(vm.piece && vm.piece.simplifiedResidual){
                    _VOI = getVOI(vm.piece.simplifiedResidual);
                }
            }

            vm._previousPiece = vm._computedPiece;
        }

        function saveUpdatedCart() {
            ShoppingCartService.onUpdateCart().then(function () {
                if (vm.piece && vm.piece.additional && vm.piece.additional.length === 0) {
                    if (vm.piece.supersessions && vm.piece.supersessions.length > 0) {
                        vm.piece.supersessions.forEach(function (item) {
                            if (vm.piece.originalPartReference === item.mainReference && item.ratio > 1) {
                                vm.piece.quantity = item.ratio;
                            } else if (vm.piece.originalPartReference === item.mainReference && _.isEmpty(item.ratio)) {
                                vm.piece.quantity = 1;
                            }
                        })
                    }
                }
                else {
                    vm.piece.quantity = 1;
                }
                _oldQuantity = vm.piece.quantity;
                updatePPSQuantity();
                displayPPS();
                
                ShoppingCartService.emitCartUpdated();
            }, handleError).finally(function () {
                blockUI.stop();
            })
        }


        /**
         *  @desc Add item in shopping cart, and call back to update postgres
         */

        function addToShoppingCart() {

            const action = _actions.ADD_PIECE;
            const payload = {
                piece:  vm._computedPiece,
                type: _type
            }
            if (payload.piece && payload.piece.opecod) {
                _.extend(payload.piece, { isTestOpcode: Object.values(_essai).includes(payload.piece.opecod) ? true : false });
            }
            ShoppingCartService.updateShoppingCart(action, payload).then(function () {
                saveUpdatedCart()
            }).catch(function (err) {
                if (err === '1' && !Object.values(_essai).includes(payload.piece.opecod)) {
                   saveUpdatedCart()
                }
            })

        }


        /**
         *  @desc Update quantity in shopping cart, and call back to update postgres
         */

        function addOne() {
            const action = _actions.ADD_QUANTITY;
            const payload = {
                piece:  vm._computedPiece,
                type: _type
            }

            blockUI.start();
            ShoppingCartService.updateShoppingCart(action, payload)
            ShoppingCartService.onUpdateCart().then(function () {
                if (vm.piece && vm.piece.additional && vm.piece.additional.length === 0) {
                    if (vm.piece.supersessions && vm.piece.supersessions.length > 0) {
                        vm.piece.supersessions.forEach(function (item) {
                            if (vm.piece.originalPartReference === item.mainReference && item.ratio > 1) {
                                vm.piece.quantity = parseInt(vm.piece.quantity) + item.ratio;
                            } else if (vm.piece.originalPartReference === item.mainReference && _.isEmpty(item.ratio)) {
                                vm.piece.quantity = parseInt(vm.piece.quantity) + 1;
                            }
                        })
                    }
                }
                else {
                    vm.piece.quantity = parseInt(vm.piece.quantity) + 1;
                }
                _oldQuantity = vm.piece.quantity;
                updatePPSQuantity();
                
                ShoppingCartService.emitCartUpdated();
            }, handleError).then( function(){
                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true);
                }
            })
            .finally(function () {
                blockUI.stop();
            })
        }

        function handleKeydown(event){
            if (event.key === 'Enter' || event.key === 'Tab') {
                event.preventDefault();
                const nextElement = getNextFocusableElement(event.target);
                if (nextElement) {
                    nextElement.focus();
                }
            }
        }

        function getNextFocusableElement(currentElement) {
            const focusableElements = Array.from(document.querySelectorAll('input'));
            const index = focusableElements.indexOf(currentElement);
            return focusableElements[index + 1] || null;

        }

        /**
         *  @desc Update quantity in shopping cart, and call back to update postgres
         */

        function reduceOne() {
            const action = _actions.REDUCE_QUANTITY;
            const payload = {
                piece: vm._computedPiece
            }

            blockUI.start();
            ShoppingCartService.updateShoppingCart(action, payload)
            ShoppingCartService.onUpdateCart().then(function () {
                if (vm.piece && vm.piece.additional && vm.piece.additional.length === 0) {
                    if (vm.piece.supersessions && vm.piece.supersessions.length > 0) {
                        vm.piece.supersessions.forEach(function (item) {
                            if (vm.piece.originalPartReference === item.mainReference && item.ratio > 1) {
                                vm.piece.quantity = parseInt(vm.piece.quantity) - item.ratio;
                                
                            } else if (vm.piece.originalPartReference === item.mainReference && _.isEmpty(item.ratio)) {
                                vm.piece.quantity = parseInt(vm.piece.quantity) - 1;
                            }
                        })
                    }
                }
                else {
                    if (vm.piece.quantity.toString().indexOf(',') !== -1) {
                        if (parseInt(vm.piece.quantity.toString().split(',')[0]) > 0) {
                            vm.piece.quantity = parseInt(vm.piece.quantity.toString().split(',')[0]);
                        }
                    } else if (vm.piece.quantity > 0) {
                        if (vm.piece.quantity.toString().indexOf('.') !== -1) {
                            vm.piece.quantity = parseInt(vm.piece.quantity);
                        } else {
                            vm.piece.quantity--;
                        }
                    } else {
                        vm.piece.quantity = 0;
                    }
                }
                _oldQuantity = vm.piece.quantity;
                updatePPSQuantity();
                
                ShoppingCartService.emitCartUpdated();
            }, handleError).then(function(){
                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true);
                }
            })
            .finally(function () {
                blockUI.stop();
            })
        }

        /**
         *  @desc Update quantity in shopping cart, and call back to update postgres
         */

        function updateFromInput(lastQuantityValue) {
            if (vm.piece.quantity.toString().indexOf(',') !== -1) {
                vm.piece.quantity = vm.piece.quantity.toString().replace(",", ".");
            }
            const number = parseFloat(vm.piece.quantity);
            const copyComputed = angular.copy(vm._computedPiece);
            copyComputed.quantity = lastQuantityValue || _oldQuantity;
            if (isNaN(number)) {
                return
            }            
            const action = _actions.REPLACE_QUANTITY;
            const payload = {
                piece: copyComputed,
                type: _type,
                quantity: number
            }
            blockUI.start();
            ShoppingCartService.updateShoppingCart(action, payload)
            ShoppingCartService.onUpdateCart().then(function () {
                _oldQuantity = number;
                updatePPSQuantity();
                
                ShoppingCartService.emitCartUpdated();
            }, function () {
                vm.piece.quantity = _oldQuantity;
                handleError();
            }).then(function(){
                if(vm.checkDealerList){
                    vm.checkDealerList(vm.piece,true);
                }
            })
            .finally(function () {
                blockUI.stop();
            });
        }


        function handleFirstAdd() {
            if (_VOI.length) {
                const parentEl = angular.element(document.body);
                $mdDialog.show({
                    locals: {
                        VOIList: _VOI
                    },
                    parent: parentEl,
                    templateUrl: 'app/components/basket/shoppingCart/modal-voi.template.html',
                    clickOutsideToClose: true,
                    controller: 'modalVoi',
                    bindToController: true,
                    controllerAs: 'vm'
                }).then(function () {
                    // on confirm
                    addToShoppingCart();
                }).catch(function () {
                    // on cancel
                });
            } else {
                addToShoppingCart();
            }

        }

        /**
         *  @desc get all VOI data from fixe residual
         *  @param {Array<Object>} [{
         *      fixe: [{
         *          codeObj: string
         *      }]
         *  }]
         *  @return {Array<Object>} [{
         *      codeObj: string,
         *      labelObj: string,
         *      langueObj: string,
         *      listCrit: [{
         *          codeCrit: string,
         *          labelCrit: string,
         *          langueCrit: string
         *      }]
         *  }]
         */

        function getVOI(residual) {
            if (!residual) {
                return [];
            }

            return residual.reduce(function (acc, applicability) {
                return applicability.fixe ? acc.concat(applicability.fixe) : acc;
            }, []).map(function (line) {
                return (line.codeObj === CodesConstants.VOI) ? line : null;
            }).filter(function (VOI) {
                return VOI;
            })
        }

        function updateFromInputSecond() {
            if (this.piece.quantity === 0 || _.isEmpty(this.piece.quantity)) {
                const msg = $translate.instant('ERROR_QUANTITY');
                toastr.error(msg);
                this.piece.quantity = 1;
            }
            updateFromInput();
        }

        function updatePPSQuantity() {
            if (vm.piece.additional) {
                vm.piece.additional.forEach(function (pps) {
                        pps.quantity = parseFloat(vm.piece.quantity) * pps.ratio;
                })
            }
        }

        function displayPPS() {
            if (vm.piece.additional) {
                vm.piece.showAdd = true;
            }
        }

        function handleError() {
            const msgError = $translate.instant('ERROR');
            toastr.error(msgError);
        }

    }

})();

(function () {
    angular.module('phenix').controller('modalVoi', function ($mdDialog) {
        var vm = this;

        vm.computedVOIList = [];

        /***************************
         *         FUNCTION        *
         **************************/

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        /**
         *   @desc Create a list of label from VOIList - listCrit
         */

        this.$onInit = function () {
            /**
             * vm.VOIList = Array<Object>
             * vm.computedVOI = Array<String>
             */
            vm.computedVOIList = vm.VOIList.reduce(function (acc, VOI) {
                return VOI.listCrit ? acc.concat(VOI.listCrit) : acc;
            }, []).map(function (crit) {
                return crit.labelCrit;
            })
        }

        function onConfirm() {
            $mdDialog.hide();
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    })
})();

(function () {

  angular
    .module('phenix')
    .factory('AlertsService', AlertsService);


  /* @ngInject */
  function AlertsService($mdDialog, AlertsModels, AlertsLocationService, CacheService,DiagFileDetailsNewConstants,
    CacheConstants, AlertsConstants,$translate,FicViewListService,toastr,blockUI,configConstantes,UtilsMetierService) {
    var vm = this;
    var popinVisibility = { status: false };
    var screenshotButtonVisibility = { status : false};
    var hidePopin = { status: true };
    var incident = {};
    var OMAlertsData = null;
    var emailAndDesc = null;
    var stepElem;
 
    var service = {
      getStepElem: getStepElem,
      setPopinVisibility: setPopinVisibility,
      getPopinVisibility: getPopinVisibility,
      setScreenshotButtonVisibility : setScreenshotButtonVisibility,
      getScreenshotButtonVisibility : getScreenshotButtonVisibility,
      getHidePopin: getHidePopin,
      setHidePopin: setHidePopin,
      setOMAlertPayload: setOMAlertPayload,
      getOMAlertPayload: getOMAlertPayload,
      setEmailDesc: setEmailDesc,
      getEmailDesc: getEmailDesc,
      transformSendAlerts: transformSendAlerts,
      transformErrorReportAlerts : transformErrorReportAlerts,
      transformEmailReportAlerts: transformEmailReportAlerts,
      showAlertsConfirmation: showAlertsConfirmation,
      modalAlertsContactCar: modalAlertsContactCar,
      buildIncidentNature: buildIncidentNature,
      getIncidentNature: getIncidentNature,
      showAlertsReject: showAlertsReject,
      getDocumentType: getDocumentType,
      orderAlertPayload: orderAlertPayload,
      setTraceDealerLogisticId: setTraceDealerLogisticId,
      getTraceDealerLogisticId: getTraceDealerLogisticId,
      getIsTraceEnabled: getIsTraceEnabled
    };
    return service;

    ////////////////

    function getIsTraceEnabled(docType){
      let isTraceEnabled = false;
      if(docType === 'INT'){
        isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
      } else {
        isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
      }
      return isTraceEnabled;
    }

    /**
     * Build the step element on init
     * @returns {*}
     */
    function getStepElem() {
      if(vm.checkDocType === 'TM') {
        stepElem = AlertsModels.tmReportPopinModels(getIsTraceEnabled(vm.checkDocType));
        buildTmReportProfile();
        builtRequestObject();
      }
      else if(vm.checkDocType === 'MR')
      {
        stepElem = AlertsModels.mrReportPopinModels(getIsTraceEnabled(vm.checkDocType));
        buildmrReportProfile();
        builtRequestObject();
      }
      else if (vm.checkDocType === 'INT'){
        stepElem = AlertsModels.intReportPopinModels(getIsTraceEnabled(vm.checkDocType));
        buildTmReportProfile();
        builtRequestObject();
      }
      else if (vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions){
        stepElem = AlertsModels.predictionReportPopinModels();
        buildTmReportProfile();
        builtPredictionRequestObject();
      }
      else if(vm.checkDocType !== 'ORDER_MODE'){  
      stepElem = AlertsModels.alertsPopinModels();
      buildUserProfile();
      buildCarContext();
      buildLocationContext();
      }
      return stepElem;
    }

    /**
     * @param visibility {boolean}
     */
    function setPopinVisibility(visibility,docType,listOfTMDocuments) {
      popinVisibility.status = visibility;
      vm.checkDocType = docType;
      vm.listOfTMDocuments = listOfTMDocuments;
      if(getIsTraceEnabled(vm.checkDocType) && visibility && docType !== 'INT' && docType !== DiagFileDetailsNewConstants.alertPredictions){
        blockUI.start();
        vm.isLoading = true;
        var user = CacheService.getUserProfile();
        var dealerId = user && user.dealerId ? user.dealerId : "";
        var pagination = 50;
        var start = pagination.start || 0;
        var numberOfEntriesPerPage = pagination.number || 30;
        var page = Math.ceil(start / numberOfEntriesPerPage) + 1;
        var pageSize = 5000;
        FicViewListService.getFicList(dealerId, page, pageSize).then(function (response) {
            var responseResult = response.result;
            var listFics = responseResult.Cases;
            if(!_.isEmpty(listFics)){
                vm.activeFicIds = [];
                listFics.forEach(function (data) {
                    if(!_.isEmpty(data)){
                        if (data.CaseDetail && data.CaseDetail.status && data.CaseDetail.status != "Closed") {
                            vm.activeFicIds.push(data.CaseDetail.caseNumber);
                        }
                    }
                });
                if((getIsTraceEnabled('INT') && checkDocType === 'INT') ||  (getIsTraceEnabled('MR') && checkDocType === 'MR') || (getIsTraceEnabled('TM') && checkDocType === 'TM')) {
                  stepElem[1].alerteRequestObject.data.activeFicIds = assign(vm.activeFicIds);
                }
            }       
        }).catch(function (error) {
            // toastr.error($translate.instant('ERROR'));
        }).finally(function () {
            vm.isLoading = false;
            blockUI.stop();
        });
      }
    }

    function getDocumentType() {
      return vm.checkDocType;
    }

    function getPopinVisibility() {
      return popinVisibility;
    }

    /**
     * @param hide {boolean}
     */
    function setHidePopin(hide) {
      hidePopin.status = hide
    }

    function getHidePopin() {
      return hidePopin;
    }

    function setScreenshotButtonVisibility(visibility) {
      screenshotButtonVisibility.status = visibility;
    }

    function getScreenshotButtonVisibility() {
      return screenshotButtonVisibility;
    }
    /**
     * show alerts confirmation of creation
     * @param response alerts create
     */
    function showAlertsConfirmation(response) {
      return $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'app/components/alerts/modal/confirmModal/alertsConfirm.html',
        controller: 'alertsConfirmCtrl',
        controllerAs: 'vm',
        bindToController: true,
        clickOutsideToClose: (vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions) ? false : true,
        skipHide:'true',
        multiple:'true',
        locals: {
          response: response,
          docType: vm.checkDocType
        }
      });
    }

    /**
 * show alerts confirmation of creation
 * @param response alerts create
 */
    function showAlertsReject(error) {
      return $mdDialog.show({
        templateUrl: 'app/components/alerts/modal/confirmModal/alertsReject.html',
        controller: 'alertsRejectCtrl',
        controllerAs: 'vm',
        bindToController: true,
        windowClass: 'modalAlertsConfirm',
        locals: {
          data: error
        }
      });
    }


    /**
     * Open the alerts modal
     */
    function modalAlertsContactCar() {
      return $mdDialog.show({
        templateUrl: 'app/components/alerts/modal/contextCarModal/contextCar.html',
        controller: 'ContextCarAlert',
        controllerAs: 'vm',
        bindToController: true,
        windowClass: 'modalAlertsConfirm',
        backdrop: 'static'
      });
    }

    function matchRequestType(incidentSelected) {

      switch (incidentSelected) {
        case AlertsConstants.partWithoutDesignation:
          vm.comments = $translate.instant(AlertsConstants.partWithoutDesignation);
          return AlertsConstants.unknownPartFormated;
        case AlertsConstants.partWithoutPrice:
          vm.comments = $translate.instant(AlertsConstants.partWithoutPrice);
          return AlertsConstants.unknownPartFormated;
        case AlertsConstants.notFoundRef:
          return AlertsConstants.notFoundRefFormated;
        case AlertsConstants.notConformRef:
          return AlertsConstants.notConformRefFormated;
        default:
          return "";
      }

    }

    function splitCatalogPlateNumber(catalogPlate) {
      if(catalogPlate){
        catalogPlate = catalogPlate.split(" / ");
        vm.getCatalogNumber = catalogPlate[0];
        vm.getPlateNumber = catalogPlate[1];
      }      
    }

    function getRefNotFound(alertSelected) {
      if (alertSelected.natureIncidentSelected == AlertsConstants.notFoundRef ||alertSelected.natureIncidentSelected == AlertsConstants.notConformRef ) {
        return alertSelected.partmarking;
      } else if (alertSelected.natureIncidentSelected == AlertsConstants.partWithoutDesignation || alertSelected.natureIncidentSelected == AlertsConstants.partWithoutPrice ){
        return AlertsConstants.staticMarking;
      }else{
        return "";
      }
    }
    
    function isUrgentLevelAlerte(levelAlerteChecked) {
      if (levelAlerteChecked == AlertsConstants.PviOrderRelated) {
        return true;
      } else {
        return false;
      }

    }

    function assignAttachment(attachment, docType) {
      var send = [];
      angular.forEach(attachment, function (value) {
        send.push({
          "fileName": value.file.fileName,
          "fileType": (docType == "MR_TM_ASE") ? value.file.fileType.toLowerCase() : value.file.fileType,
          "size": value.file.Alertsize,
          "data": cleanData(value.file.data.base64)
        })
      });
      return send;
    }

    function cleanData(data){
      return data.split(',').pop();
    }

    function orderAlertPayload(alertMessage,alertData){
      var send = {
        vin: alertData.vin,
        mailId: alertData.mailId,
        issueDescription: alertMessage,
        attachments: alertData.attachments
      }
      return send;
    }
    /**
     * Transform the AlertsModels.alertsPopinModels(); -> send to BACK
     * @param data
     * @returns {{dealerId, alerteDealerDetail: *, alerteUserDetail: *, alerteVehicleDetail: *, alerteDealerDetailNew: *,alerteLocationDetail: *, alerteDocumentDetail: (*|alerteDocumentDetail|{levelAlerte, natureIncident, comments, files}|{levelAlerte, natureIncident, comments})}}
     */
    function transformSendAlerts(data) {
      splitCatalogPlateNumber(data[1].alerteDocumentDetail.reference.data);

      delete data[1].alerteDocumentDetail.files; //TODO real files in back
      var requestType = matchRequestType(data[1].alerteDocumentDetail.natureIncidentSelected);
      var comments = data[1].alerteDocumentDetail.comments;
      comments = comments.trim()

      var send = {
        "requestType": requestType, // 3 possible values: unknown_part, not_found_ref, not_conform_ref
        "creator": {
          "ipn": data[0].alerteUserDetail.data.ipn.data,
          "phoneNumber": data[0].alerteUserDetail.data.phone.data
        },
        "dealer": {
          "siteId": checkIfMany(data[0].alerteUserDetail.data.code)
        },
        "car": {
          "vin": data[0].alerteVehicleDetail.data.vin.data,
          "registrationNumber": data[0].alerteVehicleDetail.data.immat.data,
          "automaticInformation": true
        },
        "catalogPlate": {
          "catalogNumber": vm.getCatalogNumber,
          "plateNumber": vm.getPlateNumber,
          "itemNumber": data[1].alerteDocumentDetail.selected
        },
        "sparePart": {
          "partNumber": (data[1].alerteDocumentDetail.code || '').toString().replace(/[^a-zA-Z0-9]/g, '') ,
          "marking": getRefNotFound(data[1].alerteDocumentDetail),
          "description": data[1].alerteDocumentDetail.description
        },
        "problem": {
          "description": comments,
          "isPviOrderRelated": isUrgentLevelAlerte(data[1].alerteDocumentDetail.levelAlerte)
        }
      }
      if (data[1].alerteDocumentDetail.attachment.length) {
        send.attachments = assignAttachment(data[1].alerteDocumentDetail.attachment);
      }
      return send;
    }

    /**
     * 
     * @param {data} requestData 
     */
    function transformErrorReportAlerts(requestData,documentType) {
      var requestReasonSelected ;
      var send;
      if((getIsTraceEnabled('INT') && documentType === 'INT') || (getIsTraceEnabled('MR') && documentType === 'MR') || (getIsTraceEnabled('TM') && documentType === 'TM'))
      {
        requestReasonSelected = requestData[1].alerteRequestObject.data.requestReasonSelected;
      }
      else if(!getIsTraceEnabled('MR') && !getIsTraceEnabled('TM') && documentType != 'INT'){
        if(documentType === 'MR'){
          requestReasonSelected = matchMrRequestReason(requestData[1].alerteRequestObject.data.requestReasonSelected);
        }
        else if(documentType === 'TM'){
          requestReasonSelected = matchTmRequestReason(requestData[1].alerteRequestObject.data.requestReasonSelected);
        }else{
          requestReasonSelected = "";
        }
      }
      var user = CacheService.getObject(CacheConstants.profil);
      var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
      var carContext = CacheService.getObject(CacheConstants.contextCarSearch);
      var nodeIdValue = CacheService.getObject(CacheConstants.nodeFromSearchArbo);
      if(documentType === 'INT'){
        nodeIdValue = {nodeId : vm.listOfTMDocuments.nodeId};
        requestData[1].alerteRequestObject.data.concernedDocumentSelected = requestData[1].alerteRequestObject.data.concernedDocument;
      }
      if((getIsTraceEnabled('INT') && documentType === 'INT') || (getIsTraceEnabled('MR') && documentType === 'MR') || (getIsTraceEnabled('TM') && documentType === 'TM')){
        send = {
          "requestType": documentType === 'INT' ? AlertsConstants.requestTypeInt : AlertsConstants.requestTypeMRTM, // 2 possible values: MR_TM_ASE, EASY_BASKET
          "creator": {
            "ipn": requestData[0].alerteUserDetail.data.ipn.data,
            "phoneNumber": requestData[0].alerteUserDetail.data.phone.data,
            "dealerName": requestData[0].alerteDealerDetailNew.data.dealerName.data,
            "dealerNumber" : requestData[0].alerteDealerDetailNew.data.dealerId.data,
            "email" : requestData[0].alerteUserDetail.data.email.data,
            "country" : requestData[0].alerteDealerDetailNew.data.country.data,
            "userName" : `${requestData[0].alerteUserDetail.data.firstName.data} ${requestData[0].alerteUserDetail.data.lastName.data}`
          },
          "vehicle": {
            "vin": (carContext && carContext.vehicle && !_.isEmpty(carContext.vehicle) && carContext.vehicle.vin && !_.isEmpty(carContext.vehicle.vin)) ? carContext.vehicle.vin : null,
            "automaticInformation": true,
            "registrationNumber": (carContext && carContext.vehicle && carContext.vehicle.registrationNumber && carContext.vehicle.registrationNumber.trim())
              ? carContext.vehicle.registrationNumber
              : undefined
          },
          "problem": {
            "issueOrigin": (function() {
              const docType = requestData[1].alerteRequestObject.data.documentType;
              if (docType === 'INT') {
                return AlertsConstants.requestTypeInt;
              } else if (docType === 'TM') {
                return AlertsConstants.issueOriginTM;
              } else {
                return AlertsConstants.issueOriginMR;
              }
            })(),
            "customerEffect": requestReasonSelected,
            "documentId": requestData[1].alerteRequestObject.data.concernedDocumentSelected.code,
            "description": requestData[1].alerteRequestObject.data.requestDetails,
            "nodId": nodeIdValue ? nodeIdValue.nodeId : "",
            "vehicleCoveredByWarranty": requestData[1].alerteRequestObject.data.vehicleCoveredByWarranty,
            "ficCirAssociated": requestData[1].alerteRequestObject.data.cirAssociatedSelected ?  requestData[1].alerteRequestObject.data.cirAssociatedSelected : "",
            "temporarySolution": requestData[1].alerteRequestObject.data.temporarySolution,
            "partAssociatedNumber": (requestData[1] &&
              requestData[1].alerteRequestObject &&
              requestData[1].alerteRequestObject.data &&
              requestData[1].alerteRequestObject.data.partAssociatedNumber &&
              requestData[1].alerteRequestObject.data.partAssociatedNumber.trim())
              ? (requestData[1].alerteRequestObject.data.partAssociatedNumber || '').toString().replace(/[^a-zA-Z0-9]/g, '')
              : undefined
          }
        }
        /* if(!_.isEmpty(carContext) && !_.isEmpty(carContext.vehicle) && !_.isEmpty(carContext.vehicle.registrationNumber)){
          if(!_.isEmpty(send) && !_.isEmpty(send.vehicle)){
            _.extend(send.vehicle, {
                "registrationNumber": carContext.vehicle.registrationNumber
            });
          }
        } */

          if(documentType === 'INT'){
            send.problem.operationNumber = requestData[1].alerteRequestObject.data.concernedDocumentSelected.code;
          }

        if (requestData[1] && requestData[1].alerteRequestObject && requestData[1].alerteRequestObject.data && requestData[1].alerteRequestObject.data.attachment && requestData[1].alerteRequestObject.data.attachment.length) {
          send.attachments = assignAttachment(requestData[1].alerteRequestObject.data.attachment, send.requestType);
        }
      }
      if(!getIsTraceEnabled('MR') && !getIsTraceEnabled('TM') && documentType != 'INT'){
        send = {
          "personalInformation" : {
          "ipn" : requestData[0].alerteUserDetail.data.ipn.data,
          "dealerId" : requestData[0].alerteUserDetail.data.dealerId.data,
          "lastName" : requestData[0].alerteUserDetail.data.lastName.data,
          "firstName" : requestData[0].alerteUserDetail.data.firstName.data,
          "email" : requestData[0].alerteUserDetail.data.email.data,
          "phoneNumber": requestData[0].alerteUserDetail.data.phone.data
          },
          "requestObject" : {
            "path" : requestData[1].alerteRequestObject.data.path,
            "nodeId": nodeIdValue ? nodeIdValue.nodeId : "",
            "documentType" : requestData[1].alerteRequestObject.data.documentType,
            "requestReason" : requestReasonSelected,
            "concernedDocumentSelected" : requestData[1].alerteRequestObject.data.concernedDocumentSelected,
            "requestDetails" : requestData[1].alerteRequestObject.data.requestDetails,
            "attachments" : requestData[1].alerteRequestObject.data.attachment
          },
          "userDetails" : {
            "countryCode" : user.country.toUpperCase(),
            "isTraceCountry": getIsTraceEnabled(documentType)
          },
          "vehicleConcerned":
          {
            "designation":(carContext && carContext.vehicle && !_.isEmpty(carContext.vehicle) && carContext.vehicle.model && !_.isEmpty(carContext.vehicle.model)) ? carContext.vehicle.model : null,
            "motorisation":(carContext && carContext.vehicle && !_.isEmpty(carContext.vehicle) && carContext.vehicle.motorisation && !_.isEmpty(carContext.vehicle.motorisation)) ? carContext.vehicle.motorisation : null,
            "vin":(carContext && carContext.vehicle && !_.isEmpty(carContext.vehicle) && carContext.vehicle.vin && !_.isEmpty(carContext.vehicle.vin)) ? carContext.vehicle.vin : null,
            "familyVehicle":(contextCarRequest && contextCarRequest.families && !_.isEmpty(contextCarRequest.families) && contextCarRequest.families.familyVehicle && !_.isEmpty(contextCarRequest.families.familyVehicle) && contextCarRequest.families.familyVehicle.length > 0) ? contextCarRequest.families.familyVehicle[0] : null,
            "immatNumber":(carContext && carContext.vehicle && !_.isEmpty(carContext.vehicle) && carContext.vehicle.registrationNumber && !_.isEmpty(carContext.vehicle.registrationNumber)) ? carContext.vehicle.registrationNumber : null
          },
          "transLabels":
          {
            "greetingLabel":$translate.instant('DOCUMENTARYERROR_HELLO_LABEL')+",",
             "mailHeader":$translate.instant('DOCUMENTARYERROR_HEADER_LABEL'),
             "requestObject":$translate.instant('ALERTS_REQUEST_OBJECT')+" :",
            "requestId":$translate.instant('DOCUMENTARYERROR_REQUESTID_LABEL'),
            "path":$translate.instant('ALERTS_PATH'),
            "nodeId":$translate.instant('ALERTS_NODEID_LABEL'),
            "documentType":$translate.instant('ALERTS_DOCUMENT_TYPE'),
            "requestReason":$translate.instant('ALERTS_REQUEST_REASON'),
            "concernedDocument":$translate.instant('ALERTS_CONCERNED_DOCUMENT'),
            "requestDetails":$translate.instant('DOCUMENTARYERROR_REQUESTDETAILS_LABEL'),
            "vehicleConcerned":$translate.instant('DOCUMENTARYERROR_VEHICLECONCERNED_LABEL'),
            "designation":$translate.instant('COMMON_DESIGNATION'),
            "motorisation":$translate.instant('DOCUMENTARYERROR_MOTORISATION_LABEL'),
            "vin":$translate.instant('ACTIS_VEHICLE_VIN'),
            "imat":$translate.instant('DOCUMENTARYERROR_IMMATRICULATION_LABEL'),
            "contactInfo":$translate.instant('DOCUMENTARYERROR_CONTACTINFORMATION_LABEL'),
            "ipn":$translate.instant('ADMIN_MENU_IPN'),
            "dealerId":$translate.instant('DEALER_ID'),
            "lastName":$translate.instant('ALERTS_LASTNAME'),
            "firstName":$translate.instant('ALERTS_FIRSTNAME'),
            "emailAdress":$translate.instant('EMAIL_ADDRESS'),
            "mailFooter":$translate.instant('DOCUMENTARYERROR_FOOTER_LABEL'),
            "phoneNumber":$translate.instant('ALERTS_PHONE_PLACEHOLDER')
          }
        }
        if(send.requestObject.concernedDocumentSelected == ""){
          send.requestObject.concernedDocumentSelected = {
            "code": "",
            "title":""
          }
        }
      }
      else if(documentType === DiagFileDetailsNewConstants.alertPredictions) {
        _.extend(vm.listOfTMDocuments, 
          {"userDetails" : requestData[0].alerteUserDetail.data.ipn.data + ' | ' + 
            (requestData[0].alerteUserDetail.data.dealerId.data ? requestData[0].alerteUserDetail.data.dealerId.data + ' | ': '') +
             requestData[0].alerteUserDetail.data.email.data
          }
        )
        send = {
          "personalInformation" : {
          "ipn" : requestData[0].alerteUserDetail.data.ipn.data,
          "dealerId" : requestData[0].alerteUserDetail.data.dealerId.data,
          "lastName" : requestData[0].alerteUserDetail.data.lastName.data,
          "firstName" : requestData[0].alerteUserDetail.data.firstName.data,
          "email" : requestData[0].alerteUserDetail.data.email.data,
          "phoneNumber": requestData[0].alerteUserDetail.data.phone.data
          },
          "requestObject" : {
            "version" : requestData[1].alerteRequestObject.data.version,
            "documentType" : requestData[1].alerteRequestObject.data.documentType,
            "predictionInDefaultSelected" : requestData[1].alerteRequestObject.data.predictionInDefaultSelected,
            "requestDetails" : requestData[1].alerteRequestObject.data.requestDetails,
          },
          "predictionData": vm.listOfTMDocuments,
          "transLabels":
          {
            "title": DiagFileDetailsNewConstants.alertPredictionTitle + ' + ' + vm.listOfTMDocuments.vehFamily,
            "versionLabel": DiagFileDetailsNewConstants.alertVersionLabel,
            "predictionInDefaultLabel": DiagFileDetailsNewConstants.alertPredictionInDefaultLabel,
            "predictionLabel": DiagFileDetailsNewConstants.alertPredictionLabel,
            "userLabel": DiagFileDetailsNewConstants.alertUserLabel,
            "commentLabel": DiagFileDetailsNewConstants.alertCommentLabel,
            "diagFileLabel": DiagFileDetailsNewConstants.alertDiagFileLabel
          }
        }
      }
        if(send && send.problem && send.problem.ficCirAssociated == ""){
          delete send.problem.ficCirAssociated
        }
        if(send && send.problem && send.problem.temporarySolution == ""){
          delete send.problem.temporarySolution
      }
        return send;
    }

    function resolveEmailRequestReason(documentType, rawReason) {
      switch(documentType){
        case 'MR': return matchMrRequestReason(rawReason);
        case 'TM': return matchTmRequestReason(rawReason);
        case 'INT': return matchIntRequestReason(rawReason);
        default: return '';
      }
    }

    function buildEmailVehicleConcerned(carContext, contextCarRequest, immatNumber) {
      const vehicle = (carContext && carContext.vehicle) ? carContext.vehicle : null;
      const familyVehicles = (contextCarRequest && contextCarRequest.families && contextCarRequest.families.familyVehicle)
        ? contextCarRequest.families.familyVehicle
        : null;
      const registrationNumber = (vehicle && !_.isEmpty(vehicle.registrationNumber)) ? vehicle.registrationNumber : null;
      return {
        "designation": (vehicle && !_.isEmpty(vehicle.model)) ? vehicle.model : null,
        "motorisation": (vehicle && !_.isEmpty(vehicle.motorisation)) ? vehicle.motorisation : null,
        "vin": (vehicle && !_.isEmpty(vehicle.vin)) ? vehicle.vin : null,
        "familyVehicle": (!_.isEmpty(familyVehicles) && familyVehicles.length > 0) ? familyVehicles[0] : null,
        "immatNumber": immatNumber || registrationNumber
      };
    }

    function transformEmailReportAlerts(requestData, documentType, apiResponse) {
      const rawReason = requestData[1].alerteRequestObject.data.requestReasonSelected;
      const requestReasonSelected = resolveEmailRequestReason(documentType, rawReason);

      const user = CacheService.getObject(CacheConstants.profil);
      const contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
      const carContext = CacheService.getObject(CacheConstants.contextCarSearch);
      let nodeIdValue = CacheService.getObject(CacheConstants.nodeFromSearchArbo); 
      const traceDealerId = (requestData[0] && requestData[0].alerteDealerDetailNew && requestData[0].alerteDealerDetailNew.data && requestData[0].alerteDealerDetailNew.data.dealerId && requestData[0].alerteDealerDetailNew.data.dealerId.data) ? requestData[0].alerteDealerDetailNew.data.dealerId.data : '';
      const userDealerId = (requestData[0] && requestData[0].alerteUserDetail && requestData[0].alerteUserDetail.data && requestData[0].alerteUserDetail.data.dealerId && requestData[0].alerteUserDetail.data.dealerId.data) ? requestData[0].alerteUserDetail.data.dealerId.data : '';
      const immatNumber = (requestData[0] && requestData[0].alerteVehicleDetail && requestData[0].alerteVehicleDetail.data && requestData[0].alerteVehicleDetail.data.immat && requestData[0].alerteVehicleDetail.data.immat.data) ? requestData[0].alerteVehicleDetail.data.immat.data : '';
      const requestId = (apiResponse && apiResponse.request && apiResponse.request.number) ? apiResponse.request.number : '';

      if(documentType === 'INT'){
        nodeIdValue = {nodeId : vm.listOfTMDocuments.nodeId};
        requestData[1].alerteRequestObject.data.concernedDocumentSelected = requestData[1].alerteRequestObject.data.concernedDocument;
        requestData[1].alerteRequestObject.data.path = vm.listOfTMDocuments.title;
      }

      const send = {
        "personalInformation" : {
        "ipn" : requestData[0].alerteUserDetail.data.ipn.data,
        "dealerId" : userDealerId || traceDealerId,
        "lastName" : requestData[0].alerteUserDetail.data.lastName.data,
        "firstName" : requestData[0].alerteUserDetail.data.firstName.data,
        "email" : requestData[0].alerteUserDetail.data.email.data,
        "phoneNumber": requestData[0].alerteUserDetail.data.phone.data
        },
        "requestObject" : {
          requestId,
          "path" : requestData[1].alerteRequestObject.data.path,
          "nodeId": nodeIdValue ? nodeIdValue.nodeId : "",
          "documentType" : requestData[1].alerteRequestObject.data.documentType,
          "requestReason" : requestReasonSelected,
          "concernedDocumentSelected" : requestData[1].alerteRequestObject.data.concernedDocumentSelected,
          "requestDetails" : requestData[1].alerteRequestObject.data.requestDetails,
          "attachments" : requestData[1].alerteRequestObject.data.attachment
        },
        "userDetails" : {
          "countryCode" : user.country ? user.country.toUpperCase() : "",
          "isTraceCountry": getIsTraceEnabled(documentType)
        },
        "vehicleConcerned": buildEmailVehicleConcerned(carContext, contextCarRequest, immatNumber),
        "transLabels":
        {
          "greetingLabel":$translate.instant('DOCUMENTARYERROR_HELLO_LABEL')+",",
           "mailHeader":$translate.instant('DOCUMENTARYERROR_HEADER_LABEL'),
           "requestObject":$translate.instant('ALERTS_REQUEST_OBJECT')+" :",
          "requestId":$translate.instant('DOCUMENTARYERROR_REQUESTID_LABEL'),
          "path":$translate.instant('ALERTS_PATH'),
          "nodeId":$translate.instant('ALERTS_NODEID_LABEL'),
          "documentType":$translate.instant('ALERTS_DOCUMENT_TYPE'),
          "requestReason":$translate.instant('ALERTS_REQUEST_REASON'),
          "concernedDocument":$translate.instant('ALERTS_CONCERNED_DOCUMENT'),
          "requestDetails":$translate.instant('DOCUMENTARYERROR_REQUESTDETAILS_LABEL'),
          "vehicleConcerned":$translate.instant('DOCUMENTARYERROR_VEHICLECONCERNED_LABEL'),
          "designation":$translate.instant('COMMON_DESIGNATION'),
          "motorisation":$translate.instant('DOCUMENTARYERROR_MOTORISATION_LABEL'),
          "vin":$translate.instant('ACTIS_VEHICLE_VIN'),
          "imat":$translate.instant('DOCUMENTARYERROR_IMMATRICULATION_LABEL'),
          "contactInfo":$translate.instant('DOCUMENTARYERROR_CONTACTINFORMATION_LABEL'),
          "ipn":$translate.instant('ADMIN_MENU_IPN'),
          "dealerId":$translate.instant('DEALER_ID'),
          "lastName":$translate.instant('ALERTS_LASTNAME'),
          "firstName":$translate.instant('ALERTS_FIRSTNAME'),
          "emailAdress":$translate.instant('EMAIL_ADDRESS'),
          "mailFooter":$translate.instant('DOCUMENTARYERROR_FOOTER_LABEL'),
          "phoneNumber":$translate.instant('ALERTS_PHONE_PLACEHOLDER')
        }
      };

      if(send.requestObject.concernedDocumentSelected === ""){
        send.requestObject.concernedDocumentSelected = {
          "code": "",
          "title":""
        };
      }

      return send;
    }

    function matchTmRequestReason(requestReasonSelected) {
      switch(requestReasonSelected){
        case AlertsConstants.tmIncorrect : 
          return $translate.instant(AlertsConstants.tmIncorrect);
        case AlertsConstants.tmIncorrectDesignation : 
          return $translate.instant(AlertsConstants.tmIncorrectDesignation);
        case AlertsConstants.tmNotfound : 
          return $translate.instant(AlertsConstants.tmNotfound);
        default :
          return "";  
      }
    }

    function matchMrRequestReason(requestReasonSelected) {
      switch(requestReasonSelected){
        case AlertsConstants.mrIncorrect : 
          return $translate.instant(AlertsConstants.mrIncorrect);
        case AlertsConstants.mrIncorrectDesignation : 
          return $translate.instant(AlertsConstants.mrIncorrectDesignation);
        case AlertsConstants.mrNotfound : 
          return $translate.instant(AlertsConstants.mrNotfound);
        default :
          return "";  
      }
    }

    function matchIntRequestReason(requestReasonSelected) {
      const INT_EASY_BASKET_NOT_COMPLETED_INDEX = 3;
      const INT_DISPLAY_ISSUE_INDEX = 6;
      switch(requestReasonSelected){
        case AlertsConstants.intPRIncorrect: 
          return $translate.instant(AlertsConstants.intPRIncorrect);
        case AlertsConstants.intTMIncorrect: 
          return $translate.instant(AlertsConstants.intTMIncorrect);
        case AlertsConstants.intDataIncorrect : 
          return $translate.instant(AlertsConstants.intDataIncorrect);
        case AlertsConstants.requestReasons[INT_EASY_BASKET_NOT_COMPLETED_INDEX]:
          return $translate.instant(AlertsConstants.requestReasons[INT_EASY_BASKET_NOT_COMPLETED_INDEX]);
        case AlertsConstants.requestReasons[INT_DISPLAY_ISSUE_INDEX]:
          return $translate.instant(AlertsConstants.requestReasons[INT_DISPLAY_ISSUE_INDEX]);
        case AlertsConstants.otherProblem : 
          return $translate.instant(AlertsConstants.otherProblem);
        
        default :
          return "";  
      }
    }
    
    function checkIfMany(code) {
      if (code.type === "select") {
        return code.selected;
      }
      else {
        return code.data;
      }
    }

    function buildUserProfile() {
      var user = CacheService.getObject(CacheConstants.profil);
      if (user) {
        assignDealerIdData(user.dealerLogisticIds);
        stepElem[0].alerteUserDetail.data.ipn.data = assign(user.ipn);
        stepElem[0].alerteUserDetail.data.firstName.data = assign(user.firstName);
        stepElem[0].alerteUserDetail.data.name.data = assign(user.lastName);
      }
    }

    function buildTmReportProfile() {
      var user = CacheService.getObject(CacheConstants.profil);
      if(user){
        if((getIsTraceEnabled('INT') && vm.checkDocType === 'INT') || (getIsTraceEnabled('TM') && vm.checkDocType === 'TM')){
          stepElem[0].alerteUserDetail.data.ipn.data = assign(user.ipn);
          stepElem[0].alerteUserDetail.data.firstName.data = assign(user.firstName);
          stepElem[0].alerteUserDetail.data.lastName.data = assign(user.lastName);
          stepElem[0].alerteDealerDetailNew.data.dealerName.data = (user.userContext && user.userContext.siteName) && assign(user.userContext.siteName);
          stepElem[0].alerteDealerDetailNew.data.dealerId.data = assign(user.dealerId);
          stepElem[0].alerteDealerDetailNew.data.country.data = assign(user.country);
          stepElem[0].alerteUserDetail.data.email.data = assign(user.emailAlerte);
        }
        if((!getIsTraceEnabled('TM') && !getIsTraceEnabled('MR')) || vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions){
          stepElem[0].alerteUserDetail.data.ipn.data = assign(user.ipn);
          stepElem[0].alerteUserDetail.data.firstName.data = assign(user.firstName);
          stepElem[0].alerteUserDetail.data.lastName.data = assign(user.lastName);
          if(stepElem[0].alerteUserDetail.data.dealerId){
            stepElem[0].alerteUserDetail.data.dealerId.data = assign(user.dealerId);
          }
          stepElem[0].alerteUserDetail.data.email.data = assign(user.emailAlerte);
        }
      }
    }
    function buildmrReportProfile() {
      var user = CacheService.getObject(CacheConstants.profil);
      if(user){
        if(getIsTraceEnabled('MR') && vm.checkDocType === 'MR'){
         stepElem[0].alerteUserDetail.data.ipn.data = assign(user.ipn);
         stepElem[0].alerteUserDetail.data.firstName.data = assign(user.firstName);
         stepElem[0].alerteUserDetail.data.lastName.data = assign(user.lastName);
         stepElem[0].alerteDealerDetailNew.data.dealerName.data = (user.userContext && user.userContext.siteName) && assign(user.userContext.siteName);
         stepElem[0].alerteDealerDetailNew.data.dealerId.data = assign(user.dealerId);
         stepElem[0].alerteDealerDetailNew.data.country.data = assign(user.country);
         stepElem[0].alerteUserDetail.data.email.data = assign(user.emailAlerte);
        }
        else{
          stepElem[0].alerteUserDetail.data.ipn.data = assign(user.ipn);
          stepElem[0].alerteUserDetail.data.firstName.data = assign(user.firstName);
          stepElem[0].alerteUserDetail.data.lastName.data = assign(user.lastName);
          stepElem[0].alerteUserDetail.data.dealerId.data = assign(user.dealerId);
          stepElem[0].alerteUserDetail.data.email.data = assign(user.emailAlerte);
        }
      }
    }

    function builtRequestObject() {
      var tmPath = CacheService.getObject(CacheConstants.levelsDoc);
      if(tmPath && !_.isEmpty(tmPath)){
      vm.path = tmPath.node1.label +" > "+ tmPath.node2.label;
      if(tmPath.node3) {
      vm.path = vm.path + " > " + tmPath.node3.label;
      }
    }
      if((getIsTraceEnabled('TM') && vm.checkDocType === 'TM') || (getIsTraceEnabled('MR') && vm.checkDocType === 'MR')) {
        stepElem[1].alerteRequestObject.data.documentType = assign(vm.checkDocType);
        stepElem[1].alerteRequestObject.data.requestReason = assign([AlertsConstants.requestReasons[0],AlertsConstants.requestReasons[1],AlertsConstants.requestReasons[2]]);
        stepElem[1].alerteRequestObject.data.activeFicIds = assign(vm.activeFicIds);
      }
      else if(!getIsTraceEnabled('TM') && !getIsTraceEnabled('MR') && vm.checkDocType !== 'INT'){
        stepElem[1].alerteRequestObject.data.path = assign(vm.path);
        stepElem[1].alerteRequestObject.data.documentType = assign(vm.checkDocType);
        if(vm.checkDocType === 'TM'){
          stepElem[1].alerteRequestObject.data.requestReason = assign([AlertsConstants.tmIncorrect,AlertsConstants.tmNotfound,AlertsConstants.tmIncorrectDesignation]);
        }
        else if(vm.checkDocType === 'MR'){
          stepElem[1].alerteRequestObject.data.requestReason = assign([AlertsConstants.mrIncorrect,AlertsConstants.mrNotfound,AlertsConstants.mrIncorrectDesignation]);
        }
      }
      if(vm.checkDocType === 'TM') {
        assignTmData(vm.listOfTMDocuments);
      }
      else if(vm.checkDocType === 'MR'){
        assignMRData(vm.listOfTMDocuments);
      }

      if(vm.checkDocType === 'INT'){
        stepElem[1].alerteRequestObject.data.documentType = assign(vm.checkDocType);
        assignIntData(vm.listOfTMDocuments);
        if(getIsTraceEnabled('INT')){
          // Use named constants for requestReasons indices
          const INT_EASY_BASKET_NOT_COMPLETED_INDEX = 3;
          const INT_DISPLAY_ISSUE_INDEX = 6;
          const INT_OTHER_INDEX = 7;
          stepElem[1].alerteRequestObject.data.requestReason = assign([
            AlertsConstants.requestReasons[INT_EASY_BASKET_NOT_COMPLETED_INDEX],
            AlertsConstants.requestReasons[INT_DISPLAY_ISSUE_INDEX],
            AlertsConstants.requestReasons[INT_OTHER_INDEX]
          ]);
        }else{
          vm.path = vm.listOfTMDocuments.title;
          stepElem[1].alerteRequestObject.data.path = assign(vm.path);
          stepElem[1].alerteRequestObject.data.requestReason = assign([AlertsConstants.intPRIncorrect,AlertsConstants.intTMIncorrect,AlertsConstants.intDataIncorrect,AlertsConstants.otherProblem]);
        }
      }
    }

    function builtPredictionRequestObject(){
        stepElem[1].alerteRequestObject.data.version = assign(vm.listOfTMDocuments.version);
        stepElem[1].alerteRequestObject.data.documentType = assign(vm.checkDocType);
        stepElem[1].alerteRequestObject.data.concernedDocument = assign(vm.listOfTMDocuments.concernedDocument);
        stepElem[1].alerteRequestObject.data.predictionInDefault = assign(AlertsConstants.predictionInDefaults);
    }

    function assignTmData(listOfTMDocuments) {
      var tmLabel = [];
      listOfTMDocuments.forEach( function(data) {  
          tmLabel.push({"code":data.id,"title":data.designation});
      });
      stepElem[1].alerteRequestObject.data.concernedDocument = assign(tmLabel);
    }


    function assignMRData(listOfMRDocuments) {
      var mrlabel = [];
      listOfMRDocuments.forEach( function(data) {  
          mrlabel.push({"code":data.sieRef,"title":data.designation});
      });
      stepElem[1].alerteRequestObject.data.concernedDocument = assign(mrlabel);
    }

    function assignIntData(data){
      var intLabel = {"code": data.intId, "title": data.intDesignation};
      stepElem[1].alerteRequestObject.data.concernedDocument = assign(intLabel);
    }
    function assignDealerIdData(dealerId) {
      if (dealerId && dealerId.length > 1) {
        stepElem[0].alerteUserDetail.data.code.type = assign('select');
        stepElem[0].alerteUserDetail.data.code.data = assign(dealerId);
      } else {
        stepElem[0].alerteUserDetail.data.code.type = assign('text');
        stepElem[0].alerteUserDetail.data.code.data = assign(dealerId[0]);
      }
    }


    function buildCarContext() {
      var car = CacheService.getObject(CacheConstants.contextCarSearch);

      var contextCar = CacheService.getCarContext();
      if (car && car.vehicle) {
        stepElem[0].alerteVehicleDetail.data.brand.data = assign(contextCar.brandComputed);
        stepElem[0].alerteVehicleDetail.data.model.data = assign(car.vehicle.model);
        stepElem[0].alerteVehicleDetail.data.vin.data = assign(car.vehicle.vin);
        stepElem[0].alerteVehicleDetail.data.immat.data = assign(car.vehicle.registrationNumber);
      }
    }

    function buildLocationContext() {
      var data = AlertsLocationService.getAlerts();
      if (data && data.location) {
        stepElem[1].alerteDocumentDetail.reference.data = assign(data.location.reference);
        stepElem[1].alerteDocumentDetail.natureIncident = assign([AlertsConstants.partWithoutDesignation, AlertsConstants.partWithoutPrice, AlertsConstants.notFoundRef, AlertsConstants.notConformRef]);
      }
    }



    function buildIncidentNature(incidents) {
      if (incidents) {
        incident.data = incidents;
      }
    }

    function getIncidentNature() {
      return incident;
    }

    /**
     * Assign if data
     * @param toAssign
     * @returns {*}
     */
    function assign(toAssign) {
      if (toAssign) {
        return toAssign;
      }
    }

    function setOMAlertPayload(payload){
      OMAlertsData = payload;
    }
    function getOMAlertPayload(){
      return OMAlertsData;
    }
    function setEmailDesc(data){
      emailAndDesc = data;
    }
    function getEmailDesc(){
      return emailAndDesc;
    }

    function setTraceDealerLogisticId(){
      vm.logisticDealerId = JSON.parse(sessionStorage.getItem('traceSiteIds'));
    }

    function getTraceDealerLogisticId(){
      vm.logisticDealerId = JSON.parse(sessionStorage.getItem('traceSiteIds'));
      return vm.logisticDealerId;
    }
  }

})();

(function () {

  angular
    .module('phenix')
    .factory('AlertsModels', AlertsModels);


  /* @ngInject */
  function AlertsModels() {

    /**
     * Alerts Popin data model
     * @type {[*]}
     */
    var alertsPopin = [{
      alerteUserDetail: {
        title: 'ALERTS_MYBUSINESS_INFO',
        data: {
          ipn: {
            label: 'ALERTS_IPN',
            data: '',
            type: 'text'
          },
          name: {
            label: 'ALERTS_FIRSTNAME',
            data: '',
            type: 'text'
          },
          firstName: {
            label: 'ALERTS_LASTNAME',
            data: '',
            type: 'text'
          }, code: {
            label: "DEALER_LOGISTIC_ID",
            data: '',
            type: 'text',
            selected: ''
          },
          phone: {
            label: 'ALERTS_PHONE',
            data: '',
            type: 'input',
            placeholder: 'ALERTS_PHONE_PLACEHOLDER'
          }
        }
      },
      alerteVehicleDetail: {
        title: 'ALERTS_VEHICLE',
        data: {
          brand: {
            label: 'ALERTS_BRAND',
            data: '',
            type: 'text'
          },
          model: {
            label: 'ALERTS_MODEL',
            data: '',
            type: 'text'
          },
          vin: {
            label: 'ALERTS_VIN',
            data: '',
            type: 'text'
          },
          immat: {
            label: 'ALERTS_VEHICLE_REGISTRATION',
            data: '',
            type: 'text'
          }
        }
      }
    }, {
      alerteDocumentDetail: {
        natureIncident: [],
        natureIncidentSelected: '',        
        levelAlerte: 'ALERTS_LEVEL_ALERTS_STANDARD',
        title: 'ALERTS_LOCATION_TITLE',
        selectedLabel: 'ALERTS_SELECTED',
        selected: "",
        codeLabel: 'ALERTS_REFERENCE',
        partmarkingLabel:'ALERTS_PART_MARKING',
        code: '',
        attachment: [],
        descriptionLabel: 'ALERTS_DESCRIPTION',
        description: '',
        reference: {
          label: 'ALERTS_REF',
          data: '',
          type: 'text'
        },
        comments: '',
        files: '',
        partmarking:''
      }
    }];
      var tmOldReportPopin = [{
        alerteUserDetail: {
          title: 'ALERTS_PERSONAL_INFO',
          data: {
            ipn: {
              label: 'ALERTS_IPN',
              data: '',
              type: 'text'
            },
            dealerId: {
              label: 'DEALER_ID',
              data:'',
              type:'text'
            },
            lastName: {
              label: 'ALERTS_LASTNAME',
              data: '',
              type: 'text'
            },
            firstName: {
              label: 'ALERTS_FIRSTNAME',
              data: '',
              type: 'text'
            },
            email: {
              label: 'EMAIL_ADDRESS',
              data: '',
              type: 'input',
              placeholder: ''
            },
            phone: {
              label: 'ALERTS_PHONE',
              data: '',
              type: 'input',
              placeholder: 'ALERTS_PHONE_PLACEHOLDER'
            }
          }
        }
      },
      {
      alerteRequestObject : {
      title : "ALERTS_REQUEST_OBJECT",
      data : {
        path : '',
        documentType: '',
        requestReason : [],
        requestReasonSelected : '',
        concernedDocument : [],
        concernedDocumentSelected:'',
        requestDetails : '',
        attachment : []
      }	
    }
    }];
    var mrOldReportPopin = [{
      alerteUserDetail: {
        title: 'ALERTS_PERSONAL_INFO',
        data: {
          ipn: {
            label: 'ALERTS_IPN',
            data: '',
            type: 'text'
          },
          dealerId: {
            label: 'DEALER_ID',
            data:'',
            type:'text'
          },
          lastName: {
            label: 'ALERTS_LASTNAME',
            data: '',
            type: 'text'
          },
          firstName: {
            label: 'ALERTS_FIRSTNAME',
            data: '',
            type: 'text'
          },
          email: {
            label: 'EMAIL_ADDRESS',
            data: '',
            type: 'input',
            placeholder: ''
          },
          phone: {
            label: 'ALERTS_PHONE',
            data: '',
            type: 'input',
            placeholder: 'ALERTS_PHONE_PLACEHOLDER'
          }
        }
      }
    },
    {
    alerteRequestObject : {
    title : "ALERTS_REQUEST_OBJECT",
    data : {
      path : '',
      documentType: '',
      requestReason : [],
      requestReasonSelected : '',
      concernedDocument : [],
      concernedDocumentSelected:'',
      requestDetails : '',
      attachment : []
    }	
  }
  }];

     var tmReportPopin = [{
      alerteUserDetail: {
        title: 'ALERTS_PERSONAL_INFO',
        data: {
          ipn: {
            label: 'ALERTS_IPN',
            data: '',
            type: 'text'
          },
          lastName: {
            label: 'ALERTS_LASTNAME',
            data: '',
            type: 'text'
          },
          firstName: {
            label: 'ALERTS_FIRSTNAME',
            data: '',
            type: 'text'
          },
          phone: {
            label: 'ALERTS_PHONE',
            data: '',
            type: 'input',
            placeholder: 'ALERTS_PHONE_PLACEHOLDER'
          },
          email: {
            label: 'EMAIL_ADDRESS',
            data: '',
            type: 'input',
            placeholder: ''
          }
        }
      },
      alerteDealerDetailNew: {
        title: 'TRACE_DEALER',
        data: {
          dealerName: {
            label: 'DEALER_NAME',
            data: '',
            type: 'text'
          },
          dealerId: {
            label: 'DEALER_ID',
            data: '',
            type: 'text'
          },
          country: {
            label: 'ALERTS_COUNTRY',
            data: '',
            type: 'text'
          }
        }
      }
    },
    {
	  alerteRequestObject : {
		title : "ALERTS_REQUEST_OBJECT",
		data : {
			documentType: '',
      requestReason : [],
      requestReasonSelected : '',
      concernedDocument : [],
      concernedDocumentSelected:'',
			requestDetails : '',
      vehicleCoveredByWarranty: 'YES',
      cirAssociated: [],
      cirAssociatedSelected: '',
      temporarySolution: '',
			attachment : [],
      partAssociatedNumber : ''
	  }	
  }
  }];
  var mrReportPopin = [{
    alerteUserDetail: {
      title: 'ALERTS_PERSONAL_INFO',
      data: {
        ipn: {
          label: 'ALERTS_IPN',
          data: '',
          type: 'text'
        },
        lastName: {
          label: 'ALERTS_LASTNAME',
          data: '',
          type: 'text'
        },
        firstName: {
          label: 'ALERTS_FIRSTNAME',
          data: '',
          type: 'text'
        },
        phone: {
          label: 'ALERTS_PHONE',
          data: '',
          type: 'input',
          placeholder: 'ALERTS_PHONE_PLACEHOLDER'
        },
        email: {
          label: 'EMAIL_ADDRESS',
          data: '',
          type: 'input',
          placeholder: ''
        },
      }
    },
    alerteDealerDetailNew: {
      title: 'TRACE_DEALER',
      data: {
        dealerName: {
          label: 'DEALER_NAME',
          data: '',
          type: 'text'
        },
        dealerId: {
          label: 'DEALER_ID',
          data: '',
          type: 'text'
        },
        country: {
          label: 'ALERTS_COUNTRY',
          data: '',
          type: 'text'
        }
      }
    }
  },
  {
  alerteRequestObject : {
  title : "ALERTS_REQUEST_OBJECT",
  data : {
    documentType: '',
    requestReason : [],
    requestReasonSelected : '',
    concernedDocument : [],
    concernedDocumentSelected:'',
    requestDetails : '',
    vehicleCoveredByWarranty: 'YES',
    cirAssociated: [],
    cirAssociatedSelected: '',
    temporarySolution: '',
    attachment : [],
    partAssociatedNumber : ''
  }	
}
}];

var intReportPopin = [{
  alerteUserDetail: {
        title: 'ALERTS_PERSONAL_INFO',
        data: {
          ipn: {
            label: 'ALERTS_IPN',
            data: '',
            type: 'text'
          },
          lastName: {
            label: 'ALERTS_LASTNAME',
            data: '',
            type: 'text'
          },
          firstName: {
            label: 'ALERTS_FIRSTNAME',
            data: '',
            type: 'text'
          },
          phone: {
            label: 'ALERTS_PHONE',
            data: '',
            type: 'input',
            placeholder: 'ALERTS_PHONE_PLACEHOLDER'
          },
          email: {
            label: 'EMAIL_ADDRESS',
            data: '',
            type: 'input',
            placeholder: ''
          }
        }
      },
      alerteDealerDetailNew: {
        title: 'TRACE_DEALER',
        data: {
          dealerName: {
            label: 'DEALER_NAME',
            data: '',
            type: 'text'
          },
          dealerId: {
            label: 'DEALER_ID',
            data: '',
            type: 'text'
          },
          country: {
            label: 'ALERTS_COUNTRY',
            data: '',
            type: 'text'
          }
        }
      }
    },
    {
	  alerteRequestObject : {
		title : "ALERTS_REQUEST_OBJECT",
		data : {
			documentType: '',
      requestReason : [],
      requestReasonSelected : '',
      concernedDocument : [],
      concernedDocumentSelected:'',
			requestDetails : '',
			attachment : [],
	  }	
  }
  }];

const intOldReportPopin = [{
  alerteUserDetail: {
    title: 'ALERTS_PERSONAL_INFO',
    data: {
      ipn: {
        label: 'ALERTS_IPN',
        data: '',
        type: 'text'
      },
      dealerId: {
        label: 'DEALER_ID',
        data:'',
        type:'text'
      },
      lastName: {
        label: 'ALERTS_LASTNAME',
        data: '',
        type: 'text'
      },
      firstName: {
        label: 'ALERTS_FIRSTNAME',
        data: '',
        type: 'text'
      },
      email: {
        label: 'EMAIL_ADDRESS',
        data: '',
        type: 'input',
        placeholder: ''
      },
      phone: {
        label: 'ALERTS_PHONE',
        data: '',
        type: 'input',
        placeholder: 'ALERTS_PHONE_PLACEHOLDER'
      }
    }
  }
},
{
alerteRequestObject : {
title : "ALERTS_REQUEST_OBJECT",
data : {
  path : '',
  documentType: '',
  requestReason : [],
  requestReasonSelected : '',
  concernedDocument : [],
  concernedDocumentSelected:'',
  requestDetails : '',
  attachment : []
}	
}
}];

var predictionReportPopin = [{
  alerteUserDetail: {
    title: 'ALERTS_PERSONAL_INFO',
    data: {
      ipn: {
        label: 'ALERTS_IPN',
        data: '',
        type: 'text'
      },
      dealerId: {
        label: 'DEALER_ID',
        data:'',
        type:'text'
      },
      lastName: {
        label: 'ALERTS_LASTNAME',
        data: '',
        type: 'text'
      },
      firstName: {
        label: 'ALERTS_FIRSTNAME',
        data: '',
        type: 'text'
      },
      email: {
        label: 'EMAIL_ADDRESS',
        data: '',
        type: 'input',
        placeholder: ''
      },
      phone: {
        label: 'ALERTS_PHONE',
        data: '',
        type: 'input',
        placeholder: 'ALERTS_PHONE_PLACEHOLDER'
      }
    }
  }
},
{
alerteRequestObject : {
title : "ALERTS_REQUEST_OBJECT",
data : {
  version : '',
  documentType: '',
  predictionInDefault : [],
  predictionInDefaultSelected : '',
  concernedDocument : '',
  requestDetails : ''
}	
}
}];
    /**
     * Alerts posts model
     * @type {}
     */
    var alertsPost = {
      dealerId: "",
      alerteDealerDetail: {
        codeDealerBir: "",
        codeMpr: "",
        socialReason: "",
        country: "",
        emailDealer: "",
        phone: "",
        fax: ""
      },
      alerteUserDetail: {
        ipn: "",
        name: "",
        firstName: "",
        email: ""
      },
      alerteVehicleDetail: {
        model: "",
        vin: "",
        immat: "",
        engine: "",
        gearbox: "",
        dateOfManufacture: ""
      },
      alerteLocationDetail: {
        location: "",
        identification: "",
        typeOfElement: "",
        reference: "",
        label: ""
      },
      alerteDocumentDetail: {
        levelAlerte: "",
        natureIncident: "",
        comments: ""
      }
    };


    /**
     * Alerts location
     * @type {{location: {location: string, identification: string, element: string, ref: string, label: string}}}
     */
    var alertsLocation = {
      location: {
        location: '',
        identification: '',
        typeOfElement: '',
        reference: '',
        label: ''
      },
      code: ''
    };

    var service = {
      alertsPopinModels: alertsPopinModels,
      alertsPostModels: alertsPostModels,
      alertsLocationModels: alertsLocationModels,
      tmReportPopinModels : tmReportPopinModels,
      mrReportPopinModels:mrReportPopinModels,
      intReportPopinModels : intReportPopinModels,
      predictionReportPopinModels : predictionReportPopinModels
    };
    return service;

    ////////////////

    function alertsPopinModels() {
      return angular.copy(alertsPopin);
    }

    function alertsPostModels() {
      return angular.copy(alertsPost);
    }

    function alertsLocationModels() {
      return angular.copy(alertsLocation)
    }

    function tmReportPopinModels(isTraceEnabled) {
      if(isTraceEnabled){
        return angular.copy(tmReportPopin)
      }
      else{
        return angular.copy(tmOldReportPopin)
      }
    }
    function mrReportPopinModels(isTraceEnabled) {
      if(isTraceEnabled){
        return angular.copy(mrReportPopin)
      }
      else{
        return angular.copy(mrOldReportPopin)
      }
    }

    function intReportPopinModels(isTraceEnabled){
      return angular.copy(intReportPopin)
    }

    function predictionReportPopinModels(){
      return angular.copy(predictionReportPopin);
    }
  }

})();

(function () {

  angular
    .module('phenix')
    .directive('phxAlerts', phxAlerts);


  /* @ngInject */
  function phxAlerts() {
    var directive = {
      templateUrl: 'app/components/alerts/popin/alerts.html',
      bindToController: true,
      controller: phxAlertsController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {}
    };
    return directive;
  }

  /* @ngInject */
  function phxAlertsController(toastr, AlertsService, AlertsWSService,blockUI,AlertsConstants,$mdDialog,
    configConstantes,$log,$translate,UtilsMetierService,DiagFileDetailsNewConstants) {
    var vm = this;
    vm.step = 1;
    vm.stepMax = 2;
    vm.clicked = true;
    vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
    vm.isTraceEnabledINT = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
    vm.isVehicleCoverByWarranty = AlertsConstants.isVehicleCoverByWarranty;
    vm.noVehicleCoverByWarranty = AlertsConstants.noVehicleCoverByWarranty;
    vm.alertRequestReasonSelected = AlertsConstants.requestReasons;
    vm.stepElem = AlertsService.getStepElem();
    //Popin status effect
    AlertsService.setHidePopin(true); // init status
    vm.hidePopin = AlertsService.getHidePopin();
    //////////////
    vm.checkDocType = AlertsService.getDocumentType();
    vm.isDocumentaryErrorReportLoading = false;
    vm.nextStep = nextStep;
    vm.previousStep = previousStep;
    vm.actionHidePopin = actionHidePopin;
    vm.closePopin = closePopin;
    vm.sendAlerts = sendAlerts;
    vm.sendDocumentryerrorReportAlerts = sendDocumentryerrorReportAlerts;
    vm.onCancel = onCancel;
    vm.onConfirm = onConfirm;

    //////////////


    function nextStep(data) {

      if(vm.checkDocType !== DiagFileDetailsNewConstants.alertPredictions){

        validForm('#ALERTS_PHONE');
        validForm('#EMAIL_ADDRESS');
        validForm('#DEALER_NAME');
        validForm('#DEALER_ID');
        validForm('#ALERTS_COUNTRY');
        validForm('#DEALER_LOGISTIC_ID');
          

        var alerteUserDetail = data[0].alerteUserDetail;
        var alerteDealerDetailNew = data[0].alerteDealerDetailNew;
        

        if((vm.isTraceEnabled && (vm.checkDocType === 'TM' || vm.checkDocType === 'MR')) || (vm.isTraceEnabledINT && vm.checkDocType === 'INT') || (!vm.isTraceEnabled && (vm.checkDocType !== 'TM' && vm.checkDocType !== 'MR')) || vm.checkDocType !== DiagFileDetailsNewConstants.alertPredictions){ 
          if(!_.isEmpty(alerteUserDetail) && !_.isEmpty(alerteUserDetail.data) && !_.isEmpty(alerteUserDetail.data.code)){
            var detectedError = false; 
            if (!alerteUserDetail.data.phone.data) {
              invalidForm('#ALERTS_PHONE');
              detectedError = true;
            }
          }
          if ((vm.isTraceEnabled && (vm.checkDocType === 'TM' || vm.checkDocType === 'MR')) || (vm.isTraceEnabledINT && vm.checkDocType === 'INT')){
          if (!alerteDealerDetailNew.data.dealerName.data) {
            invalidForm('#DEALER_NAME');
            detectedError = true;
          }
          if (!alerteDealerDetailNew.data.dealerId.data) {
            invalidForm('#DEALER_ID');
            detectedError = true;
          }
          if (!alerteDealerDetailNew.data.country.data) {
            invalidForm('#ALERTS_COUNTRY');
            detectedError = true;
          }
        }
          if (!alerteUserDetail.data.phone.data) {
            invalidForm('#ALERTS_PHONE');
            detectedError = true;
          }
          
        }
        if (vm.checkDocType !== DiagFileDetailsNewConstants.alertPredictions && !_.isEmpty(alerteUserDetail) && !_.isEmpty(alerteUserDetail.data) && !_.isEmpty(alerteUserDetail.data.code)) {
          var logisticCodes = data[0].alerteUserDetail.data.code.selected;
          if (!alerteUserDetail.data.phone.data) {
            invalidForm('#ALERTS_PHONE');
            detectedError = true;
          }
          if (alerteUserDetail.data.code.type === 'select' &&(!logisticCodes || logisticCodes === '')
          ) {
            invalidForm('#DEALER_LOGISTIC_ID');
            detectedError = true;
          }
        }

        const isNotTraceEnabledAndDocTypeTmMrInt = !vm.isTraceEnabled && (vm.checkDocType === 'TM' || vm.checkDocType === 'MR');
        const isDocTypeAlertPredictions = vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions;
        if(isNotTraceEnabledAndDocTypeTmMrInt || isDocTypeAlertPredictions){ 
          var email=alerteUserDetail.data.email.data;
          if(!email||!validateEmail(email)) {
            invalidForm("#EMAIL_ADDRESS");
            detectedError = true;
          }
        }
        if (detectedError) {
          return;
        }
      }
    
      vm.step++;
      vm.stepTemplateUrl = setTemplateUrl();
    }

    function previousStep() {
      vm.step--;
      vm.stepTemplateUrl = setTemplateUrl();
    }

    function invalidForm(id) {
      $(id).css({
        'border-color' : 'red',
        'border-width' : '2px'
    });
    }


    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    function validForm(id) {
      $(id).css({
        'border-color' : 'green',
        'border-width' : '2px'
    });
    }

    function standardForm(id) {
      $(id).css({
        'border-color' : 'none',
        'border-width' : '1px'
    });
    }



    /**
     * Define the type of template to show compared to step number
     * @returns {string}
     */
    function setTemplateUrl() {
      return vm.step < 2 ? 'list' :!(vm.checkDocType==='MR'|| vm.checkDocType==='TM' ||  vm.checkDocType === 'INT' || vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions)?'form-pr':'form';
    }

    /**
     * Fold to the right the modal alerts
     */
    function actionHidePopin() {
      AlertsService.setHidePopin(!vm.hidePopin.status);
      AlertsService.setScreenshotButtonVisibility(false);
    }

    /**
     * Close the modal alerts
     */
    function closePopin() {
      if(vm.checkDocType === 'INT' || vm.checkDocType === DiagFileDetailsNewConstants.alertPredictions){
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: 'app/components/car/carSearchResult/easyBasket/confirmPopUp.template.html',
          bindToController: true,
          controller: phxAlertsController,
          controllerAs: 'vm',
          clickOutsideToClose: true,
          skipHide: true,
          multiple: true,
      }).then(function (confirm) {
          if (confirm) {
            AlertsService.setPopinVisibility(false,vm.checkDocType, null, (vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
          }
      }).catch(function () {
          $log.debug($translate.instant('ERROR'));
      });
      }
      else
        AlertsService.setPopinVisibility(false,vm.checkDocType, null, (vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
     
      // to set black color to tm report pop up in 
      $("#TM_DOCUMENTARY_ERROR").css({
            'color': 'black'
      });
    
    }

    function onCancel() {
      $mdDialog.hide();
    }
    function onConfirm() {
        $mdDialog.hide(true);
    }

    function sendAlerts(data) {
      validForm('#ALERTS_NATURE_INCIDENT');
      validForm('#ALERTS_LANDMARK');
      validForm('#ALERTS_CODE');
      validForm('#ALERTS_DESCRIPTION');
      validForm('#ALERTS_PART_MARKING');
       validForm('#ALERTS_COMMENTS');

      var detectedError = false;
      var natureIncidentField = data[1].alerteDocumentDetail.natureIncidentSelected;
      var landmarkField = data[1].alerteDocumentDetail.selected;


      var codeField = data[1].alerteDocumentDetail.code;
      var descriptionField = data[1].alerteDocumentDetail.description;
      var commentsField = data[1].alerteDocumentDetail.comments;
      var partmarkingField = data[1].alerteDocumentDetail.partmarking;


      if (!natureIncidentField) {
        invalidForm('#ALERTS_NATURE_INCIDENT');
        detectedError = true;
      }
      if (!landmarkField) {
        invalidForm('#ALERTS_LANDMARK');
        detectedError = true;
      }
      if (!codeField) {
        invalidForm('#ALERTS_CODE');
        detectedError = true;
      }
      if (!descriptionField) {
        invalidForm('#ALERTS_DESCRIPTION');
        detectedError = true;
      }
      if (!commentsField) {
        invalidForm('#ALERTS_COMMENTS');
        detectedError = true;
      }


      if ((natureIncidentField === AlertsConstants.notFoundRef ||natureIncidentField === AlertsConstants.notConformRef) && !partmarkingField) {
        invalidForm('#ALERTS_PART_MARKING');
        detectedError = true;
      }
     

      if (detectedError) {
        return;
      }

      blockUI.start();
      AlertsWSService.sendAlerts(vm.stepElem).then(function (response) {
        if (response) {
          AlertsService.setPopinVisibility(false,vm.checkDocType, null, (vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
          AlertsService.showAlertsConfirmation(response);
        }
      }, function (error) {
        AlertsService.showAlertsReject(error);
      //  toastr.error($translate.instant("ALERTS_ERROR_HTL") + " - " + error.status + " " + error.data.errors[0].errorMessage);
      }).finally(function(){
        blockUI.stop();
      });
    }

    function sendDocumentryerrorReportAlerts(requestdata,docType) {

      if(docType !== DiagFileDetailsNewConstants.alertPredictions){
        var concernedDocumentId = '#ALERTS_CONCERNED_DOCUMENT';

        const isDocTypeTmMrInt = docType && (docType === 'TM' || docType === 'MR' || docType === 'INT');
        if((vm.isTraceEnabled && (docType === 'TM' || docType === 'MR')) || (vm.isTraceEnabledINT && docType === 'INT')){
          validForm('#DEALER_NAME');
          validForm('#DEALER_ID');
          validForm('#ALERTS_COUNTRY');
          validForm('#EMAIL_ADDRESS');
          validForm('#ALERTS_PHONE');
        }
        validForm('#ALERTS_REQUEST_REASON');
        validForm(concernedDocumentId);
        validForm('#ALERTS_REQUEST_DETAILS');
        if(((vm.isTraceEnabled && (docType === 'TM' || docType === 'MR')) || (vm.isTraceEnabledINT && docType === 'INT')) && requestdata && !_.isEmpty(requestdata) && requestdata[0] && requestdata[0].alerteUserDetail && requestdata[0].alerteUserDetail.data && requestdata[0].alerteUserDetail.data.code && requestdata[0].alerteUserDetail.data.code.data){
          var siteId = requestdata[0].alerteUserDetail.data.code.data;
        }
        var requestReason = requestdata[1].alerteRequestObject.data.requestReasonSelected;
        var requestDetails = requestdata[1].alerteRequestObject.data.requestDetails;
        var concernedDocument = requestdata[1].alerteRequestObject.data.concernedDocumentSelected;
        if (docType === 'INT'){
          concernedDocument =  requestdata[1].alerteRequestObject.data.concernedDocument;
        }
        // if(vm.isTraceEnabled && docType == 'TM'){
        //   if(requestdata[1].alerteRequestObject.data.documentType == 'TM'){
        //     requestdata[1].alerteRequestObject.data.documentType = AlertsConstants.issueOriginTM;
        //   }
        // }
        // else if(vm.isTraceEnabled && docType == 'MR'){
        //   if(requestdata[1].alerteRequestObject.data.documentType == 'MR'){
        //     requestdata[1].alerteRequestObject.data.documentType = AlertsConstants.issueOriginMR;
        //   }
        // }
        var detectedError = false;

        

        if (!requestdata[0].alerteUserDetail.data.phone.data) {
          invalidForm('#ALERTS_PHONE');
          detectedError = true;
        }
        if (((vm.isTraceEnabled && (docType == 'TM' || docType == 'MR')) || (vm.isTraceEnabledINT && docType == 'INT'))) {
          if (!requestdata[0].alerteDealerDetailNew.data.dealerName.data) {
            invalidForm('#DEALER_NAME');
            detectedError = true;
          }
          if (!requestdata[0].alerteDealerDetailNew.data.dealerId.data) {
            invalidForm('#DEALER_ID');
            detectedError = true;
          }
          if (!requestdata[0].alerteDealerDetailNew.data.country.data) {
            invalidForm('#ALERTS_COUNTRY');
            detectedError = true;
          }
        }
        if(!requestReason) {
          invalidForm('#ALERTS_REQUEST_REASON');
          detectedError = true;
        }
        if(!requestDetails) {
          invalidForm('#ALERTS_REQUEST_DETAILS');
          detectedError = true;
        }

        var requiresConcernedDocument = false;
      
        if (((vm.isTraceEnabled && (docType == 'TM' || docType == 'MR')) || (vm.isTraceEnabledINT && docType == 'INT')) && requestReason && vm.alertRequestReasonSelected && 
            (Array.isArray(vm.alertRequestReasonSelected) ? vm.alertRequestReasonSelected.includes(requestReason) : requestReason === vm.alertRequestReasonSelected)) {
          requiresConcernedDocument = true;
        } else if (docType === 'TM' && requestReason && 
                  (requestReason === "ALERTS_TM_INCORRECT" || requestReason === "ALERTS_TM_INCORRECT_DESIGNATION")) {
          requiresConcernedDocument = true;
        } else if (docType === 'MR' && requestReason && 
                  (requestReason === "ALERTS_MR_INCORRECT" || requestReason === "ALERTS_MR_INCORRECT_DESIGNATION")) {
          requiresConcernedDocument = true;
        }

      if (requiresConcernedDocument && !concernedDocument) {
          invalidForm(concernedDocumentId); 
          detectedError = true;
        }
      }else{
        var predictionInDefaultSelected = requestdata[1].alerteRequestObject.data.predictionInDefaultSelected;
        if(!predictionInDefaultSelected){
          invalidForm('#ALERTS_PREDICTION_IN_DEFAULT');
          detectedError = true;
        }

        var requestDetails = requestdata[1].alerteRequestObject.data.requestDetails;
        if(!requestDetails) {
          invalidForm('#ALERTS_REQUEST_DETAILS');
          detectedError = true;
        }
      }

      if (detectedError) {
        return;
      }

      blockUI.start();
      vm.isDocumentaryErrorReportLoading=true;
      AlertsWSService.sendDocumentryerrorReportAlerts(requestdata,docType,(docType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled)).then(function (response) {
        if (response) {
          AlertsService.setPopinVisibility(false,vm.checkDocType, null, (vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
          if((vm.isTraceEnabled && (docType === "MR" || docType === "TM")) || (vm.isTraceEnabledINT && docType === "INT")){
            response.documentType = docType;
          }
          AlertsService.showAlertsConfirmation(response);
        }
      }, function (error) {
        AlertsService.showAlertsReject(error);
      //  toastr.error($translate.instant("ALERTS_ERROR_HTL") + " - " + error.status + " " + error.data.errors[0].errorMessage);
      }).finally(function(){
        vm.isDocumentaryErrorReportLoading = false;
        blockUI.stop();
      });
  
   }
  }
}) ();

(function () {
    angular.module('phenix').component('paginationCartsList', {
        controller: paginationCartsListController,
        templateUrl: 'app/components/basket/consultation/pagination-carts-list.template.html',
        bindings: {
            count: '<',
            updatePagination: '<',
            limit: '@'
        },
        controllerAs: 'vm'
    })

    function paginationCartsListController(cartViewListConstants) {
        var vm = this;

        /************************
         *      VARIABLES       *
         ***********************/

        vm.nbPages = 0;
        vm.actualPage = 1;
        vm.list = []

        /************************
         *      FUNCTIONS       *
         ***********************/

        vm.previous = previous
        vm.next = next;
        vm.onUpdate = onUpdate;

        this.$onChanges = function () {
            initPagination();
        }


        function previous() {
            vm.actualPage -= 1;
            onUpdate();
        }

        function next() {
            vm.actualPage += 1;
            onUpdate();
        }

        function onUpdate() {
            vm.updatePagination(vm.actualPage);
        }


        function initPagination() {
            var list = [];
            var limit = vm.limit ? parseInt(vm.limit) : cartViewListConstants.pagination.limit;

            vm.actualPage = 1;
            vm.nbPages = Math.ceil(vm.count / limit);
            for (var i = 1; i <= vm.nbPages; i++) {
                list.push(i);
            }
            vm.list = list;
        }

    }
})();

(function () {
    angular.module('phenix').component('listCart', {
        controller: listCartController,
        templateUrl: 'app/components/basket/consultation/list-carts.template.html',
        bindings: {
            list: '<',
            onDelete: '<',
            onSort: '<',
            onSelect: '<',
            onUnlock: '<'
        },
        controllerAs: 'vm'
    })

    function listCartController(cartViewListConstants, DeleteModalService, toastr, $translate,$log) {
        var vm = this;

        /**************************
         *      INTERNAL STATE    *
         *************************/

        var _asc = cartViewListConstants.sort.asc;
        var _desc = cartViewListConstants.sort.desc;


        /**************************
         *      FUNCTIONS         *
         *************************/

        vm.deleteCarts = deleteCarts
        vm.sortBy = sortBy;
        vm.selectCart = selectCart;
        vm.unlock = unlock;

        vm.handleIconOrder = handleIconOrder;

        /*************************
         *     VARIABLES         *
         ************************/

        var _sort = {
            by: 'DATE',
            order: 1
        }

        /**
         * @desc Looking inside list and get all checked cart;
         */

        function deleteCarts() {
            var checkedRow = vm.list
            .filter(function(currentSuperCart) {
                return currentSuperCart.checked;
            })
            .map(function(currentSuperCart) {
                return {
                    number: currentSuperCart.id
                };
            });
        //lockedRows is an array of locked cart
        var lockedRows = vm.list
            .filter(function(currentSuperCart) {
                return currentSuperCart.lockedByUser;
            })
            .map(function(currentSuperCart) {
                return {
                    id: currentSuperCart.id
                };
            });

        var checkedIdsSuperCart = checkedRow.map(function(

            currentSuperCart
        ) {
            return currentSuperCart.number;
        });

        if (!checkedRow.length) {
            return;
        }
        //here we just iterate the lockedRows array in order to check if a locked quote or partReq is checked for suppression
        //in this case, we instanciate the abortFunction to return the function.
        var abortFunction;
        lockedRows.forEach(function(lockedRow) {
            abortFunction = _.find(checkedRow, function(iterat) {
                return iterat.number === lockedRow.id;
            });
        });
        if (abortFunction) {
            toastr.error($translate.instant("ERROR"));
            return;
        }
            var body = angular.element(document.body);
            var payload = {
                body: body,
                isList: true,
                title: "CART_MSG_DELETE",
                rows: checkedRow
            };

            DeleteModalService.showModal(payload)
                .then(function() {
                    vm.onDelete(checkedIdsSuperCart);
                })
                .catch(function() {
                    $log.debug($translate.instant('ERROR'));
                });
        }

        /**
         * @param {string} type
         */

        function sortBy(type) {
            if (_sort.by === type) {
                _sort.order = _sort.order === _asc ? _desc : _asc;
            } else {
                _sort.by = type;
                _sort.order = _asc;
            }

            vm.onSort(_sort.by, _sort.order);
        }

        function unlock(id) {
            vm.onUnlock(id);
        }

        function handleIconOrder(sortBy) {
            var top = false;
            var bot = false;

            if (sortBy === 'DATE' && _sort.by === 'DATE') {
                top = _sort.order === _asc ? false : true;
                bot = !top;
            } else if (sortBy === 'ID' && _sort.by === 'ID') {
                top = _sort.order === _asc ? false : true;
                bot = !top;
            }

            return {
                'icon-icons_filter_order': true,
                'icon-icons_filter_top_basket': top,
                'icon-icons_filter_bot_basket': bot
            }
        }

        /**
         *  @desc selectedCart
         */

        function selectCart(cart) {
            vm.onSelect(cart);
        }

    }
})();

(function () {
    angular.module('phenix').component('filterListCart', {
        controller: filterListCartController,
        templateUrl: 'app/components/basket/consultation/filter-list-carts.template.html',
        bindings: {
            onSearch: '<'
        },
        controllerAs: 'vm'
    })

    function filterListCartController(CodesConstants, CacheService) {
        var vm = this;

        vm.displayRegisterNumber = false;

        /***********************
         *      FUNCTIONS      *
         **********************/

        vm.onValidate = onValidate;
        vm.deleteEmptyValue = deleteEmptyValue;

        this.$onInit = function () {
            var user = CacheService.getUserProfile();
            vm.displayRegisterNumber = CodesConstants.listCountryRegisterNumber.some(function (country) {
                return country === user.country;
            })
        }

        /**
         * @param {Object} filter
         * @return {void}
         */

        function onValidate(filter) {
            if (!filter) {
                return;
            }

            var newFilter = deleteEmptyValue(filter);
            if (newFilter.label) {
                newFilter.keyWord = newFilter.label.trim().toUpperCase();
                delete newFilter.label;
            }

            vm.onSearch(newFilter);
        }

        /**
         *  @desc Return new object with only fulfill contain example :
         *  {
         *      a : null,
         *      b : '',
         *      c: false
         *  }
         *
         *  to :
         *
         *  {
         *      c: false;
         *  }
         *
         *  @param {Object} filter
         *  @returns {Object}
         *
        */

        function deleteEmptyValue(filter) {
            var obj = {};

            for (var prop in filter) {
                var isInvalid = typeof filter[prop] !== 'boolean' && !filter[prop];
                if (isInvalid) {
                    continue;
                }
                obj[prop] = filter[prop];
            }

            return obj;
        }

    }

})();

(function () {

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.consultPanier, {
        url: '/consultPanier',
        templateUrl: 'app/components/basket/consultation/container-view-list.template.html',
        controller: 'containerViewList',
        params: {
          data: null
        },
        controllerAs: 'vm'
      });
  }
})();

(function () {
    angular
        .module('phenix')
        .controller('containerViewList', containerViewListController);

    function containerViewListController(
        CartViewListService,
        DocumentsMetierService,
        ShoppingCartService,
        CarSearchMetierService,
        CartViewListWSService,

        RoutesConstants,
        cartViewListConstants,
        CacheService,
        CacheConstants,
        blockUI,
        configConstantes,
        toastr,
        MainMetierService,

        $translate,
        $state,
        $q) {
        var vm = this;

        /************************
         *    INTERNAL STATE    *
         ***********************/

        var _options = {
            filter: {

            },
            sort: {
                by: 'DATE',
                order: cartViewListConstants.sort.desc
            },
            pagination: {
                limit: cartViewListConstants.pagination.limit,
                offset: 1
            }
        };
        var _searchBy = cartViewListConstants.searchBy;

        /*********************
         *      VARIABLE     *
         ********************/

        vm.dataLoaded = false;
        vm.cartList = [];
        vm.count = 0;
        vm.isOrderingModuleEnable = false;
        vm.isRpartsRole = MainMetierService.isRpartsRole();

        /***********************
         *     FUNCTIONS       *
         **********************/

        vm.onSearch = onSearch;
        vm.onSort = onSort;
        vm.onDelete = onDelete;
        vm.onUpdatePagination = onUpdatePagination;
        vm.onSelect = onSelect;
        vm.onUnlock = onUnlock;


        this.$onInit = function () {
            blockUI.start();
            fetchCartsList().finally(function () {
                vm.dataLoaded = true;
                blockUI.stop();
            });
        }


        /**
         * @desc Call fetchCartsList with a filter
         * @param {Object} filter
         */

        function onSearch(filter) {
            blockUI.start();
            _options.filter = filter || {};

            // reset pagination
            _options.pagination = {
                limit: cartViewListConstants.pagination.limit,
                offset: 1
            }

            fetchCartsList(_options.filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            });
        }

        /**
         *  @desc Unlock all carts
         */

        function onUnlock(id) {
            blockUI.start();
            ShoppingCartService.unlockCart(id).then(function () {
                return fetchCartsList();
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @desc Call fetchCartsList with a specific sort
         * @param {string} by
         * @param {number} order
         */

        function onSort(by, order) {
            blockUI.start();

            _options.sort = {
                by: by,
                order: order
            }

            fetchCartsList(_options.filter, _options.sort).finally(function () {
                blockUI.stop();
            })
        }

        /**
         *  @desc Delete one or more cart, an recall fetchCartsList
         *  @param {Array<string>}
         */

        function onDelete(listID) {
            blockUI.start();

            CartViewListService
                .deleteCarts(listID)
                .then(fetchCartsList)
                .finally(function () {
                    blockUI.stop();
                })
        }

        /**
         * @desc Update data with pagination
         * @param {number} page
         */

        function onUpdatePagination(page) {
            blockUI.start();

            _options.pagination = {
                limit: _options.pagination.limit,
                offset: page
            }

            fetchCartsList(_options.filter, null, _options.pagination).finally(function () {
                blockUI.stop();
            })
        }

        /**
         *  @desc fetch the selected cart data and display it
         *  @param {object} cart see getCartsList in CartViewListService
         */

        function onSelect(cart) {
            CacheService.removeObject(CacheConstants.basketList);
            var getCartMetadata;
            var cartID = cart.id;

            blockUI.start()
            switch (cart.searchBy) {
                case _searchBy.vin:
                    getCartMetadata = CarSearchMetierService.searchCar({ vin: cart.vin }).then(function(){
                        CarSearchMetierService.getBannerData();
                    })
                    break;
                case _searchBy.registrationNumber:
                    getCartMetadata = CarSearchMetierService.searchCar({ imat: cart.registrationNumber }).then(function(){
                        CarSearchMetierService.getBannerData();
                    })
                    break;
                case _searchBy.model:
                    getCartMetadata = CarSearchMetierService.searchCarModel(createModelPayload(cart)).then(function(){
                        CarSearchMetierService.getBannerData();
                    })
                    break;
                default:
                    getCartMetadata = $q.resolve();
                    break;
            }

            getCartMetadata.then(function () {
                return CartViewListService.getCart(cartID);
            }).then(function (cart) {
                return updateCartMetadataOnPR(cart);
            }).then(function (cart) {
                return updateCartMetadataOnTM(cart);
            }).then(function (cart) {  
                if(vm.isOrderingModuleEnable && vm.isRpartsRole){
                 CacheService.setObject(CacheConstants.basketList,cart);
                }
                return ShoppingCartService.replaceShoppingCart(cart);
            }).then(function () {
                $state.go(RoutesConstants.panier);
            }).catch(function (response) {
                if (response.errors && Array.isArray(response.errors)) {
                    response.errors.forEach(function (error) {
                        toastr.error(error.msg);
                    })
                } else {
                    toastr.error($translate.instant('ERROR'));
                }
            }).finally(function () {
                blockUI.stop();
            });
        }

        /**
         * @desc add informations on items of type PR, cart INPUT is modified
         * @param {object} cart see getCartsList in CartViewListService
         * @return cart with PR items modified, 3 fields was add  : piece, currency, reach, designation
         */

        function updateCartMetadataOnPR(cart) {
            var IDList = cart.items.filter(function (item) {
                return item.type === 'PR'
            }).map(function (PR) {
                return PR.reference
            })

            if (!IDList.length) {
                return cart;
            }

            return DocumentsMetierService.getPRLight(IDList).then(function (PRList) {
                cart.items.forEach(function (item) {
                    var PR = _.find(PRList, function(PR){
                        return PR.reference === item.reference;
                    });
                    if(PR && !_.isEmpty(PR)){
                    _.assign(item, {
                        designation: PR.designation,
                        priceHT: PR.priceExclTaxes,
                        currency: PR.currency,
                        reach: PR.reach
                    });
                }
                });
                return cart;
            })
        }

        /**
         * @desc add informations on items of type TM, cart INPUT is modified
         * @param {object} cart see getCartsList in CartViewListService
         * @return cart with PR items modified, 2 field was add  : designation, duration
         */

        function updateCartMetadataOnTM(cart) {
            var IDList = cart.items.filter(function (item) {
                return item.type === 'TM'
            }).map(function (TM) {
                return TM.reference
            })

            if (!IDList.length) {
                return cart;
            }

            return DocumentsMetierService.returnTmDocuments(IDList).then(function (response) {
                var TMList = response.TM;
                cart.items.forEach(function (item) {
                var TM = _.find(TMList, function (TM) {
                        return TM.technicalId === item.reference;
                    });
                    if(TM && !_.isEmpty(TM)){
                    _.assign(item, {
                        designation: TM.designation,
                        duration: TM.duration
                    });
                }
                });
                return cart;
            })
        }


        /**
         * @desc Create payload for carSearchByModel request
         * @param {Oject} cart see getCartsList in CartViewListService
         * @return {Object} See below
         */

        function createModelPayload(cart) {
            return {
                fixedCriterias: {
                    '007': cart.familyVehicle,
                    '008': cart.bodyType,
                    '336': cart.brand,
                    '997': cart.gearboxType,
                    '999': cart.engineType
                }
            }
        }

        /**
         * @desc Fetch carts with options
         * @param {object} filter see _options
         * @param {object} sort see _options
         * @param {object} pagination see _options
         */

        function fetchCartsList(filter, sort, pagination) {
            if (!filter) {
                filter = _options.filter;
            }
            if (!sort) {
                sort = _options.sort;
            }
            if (!pagination) {
                pagination = _options.pagination;
            }

            return CartViewListService.getCartsList(filter, sort, pagination).then(function (response) {
                vm.cartList = response.carts;
                vm.count = response.totalCount;
            }).catch(function () {
                // DISPLAY ERROR
            })
        }


    }

})();

(function() {
    angular.module('phenix').constant('cartViewListConstants', {
        endpoint: {
            list: '/carts/list',
            delete: '/carts/delete',
            cart: '/carts/',
            unlock: '/carts/unlock'
        },
        sort: {
            asc: 1,
            desc: -1,
            date: 'DATE',
            ID: 'ID'
        },
        pagination: {
            limit: 20
        },
        searchBy: {
            vin: 1,
            registrationNumber: 2,
            model: 3
        },
        errors: {
            isLocked: 'CART001'
        }

    })
})();

angular.module('phenix')

    // This directive was created for pagination.
    // It triggers the selected page based on Next or Previous buttons and the dropdown menu.
    .directive('pageSelect', function() {
      return {
        restrict: 'E',
        template: '<select class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)" ng-options="page for page in pages" >',
        link: function(scope, element, attrs) {
          scope.$watch('currentPage', function(c) {
            scope.inputPage = c;
          });
        }
      }
    });


(function () {

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.ficConsultation, {
        url: '/ficConsultation',
        templateUrl: 'app/components/actis/listFic/listFic.template.html',
        controller: 'ficListController',
        params: {
          data: null
        },
        controllerAs: 'vm'
      });
  }
})();

(function () {

        angular
            .module('phenix').controller('ficListController', ficListController);

        /** @ngInject */
        function ficListController(
            FicViewListService,
            FicViewListWSService,
            RoutesConstants,
            ficViewListConstants,
            blockUI,
            toastr,
            $translate,
            $state,
            CacheService,
            MainMetierService,
            $rootScope,
            $mdDialog,
            CacheConstants,
            configConstantes,
            CryptoService,
            $q,$log,UtilsMetierService) {

            var vm = this;

            vm.openFic = openFic;
            vm.createMotrioFIC = createMotrioFIC;
            vm.lastModifictnDate = lastModifictnDate;
            /************************
             *    INTERNAL STATE    *
             ***********************/

            var _options = {
                pagination: {
                    limit: ficViewListConstants.pagination.limit,
                    offset: 1
                }
            };


            this.displayed = [];
            this.processedFicList = [];
            this.isListFicOpen = false;
            this.isProcessedListFicOpen = false;
            this.profile = CacheService.getObject(CacheConstants.profil);
            if(this.profile && this.profile.userType && (this.profile.userType.toUpperCase() === "RNET") && !_.isEmpty(this.profile.rolesActis) && this.profile.rolesActis.length > 0){
                this.isActisChatbotEnable = true;
            }
            vm.isChatBotDealerAccess = UtilsMetierService.isChatBotDealerAccess();
            vm.isIndependantUser = this.profile ? MainMetierService.isIndependantUser(this.profile.roles): null;

            /**
             * @desc format date to avoid any display issue on IE 11
             * @param date
             * @returns {*|string}
             */

            this.formatDate = function (date) {
                var dateOut = date.split(' ')[0];

                return dateOut;
            };

            //Format the data of the Search Vehicle Column
            this.formatModelVehicle = function (modelName, modelCode, vin, registrationNumber) {
                var vehicle;
                if (modelName && modelCode && vin && registrationNumber) {
                    vehicle = modelName + ' (' + modelCode + ')' + '\n' + vin + ' | ' + registrationNumber;
                } else if (!modelCode && modelName && vin && registrationNumber) {
                    vehicle = modelName + '\n' + vin + ' | ' + registrationNumber;
                } else if (!registrationNumber && modelName && modelCode && vin) {
                    vehicle = modelName + ' (' + modelCode + ')' + '\n' + vin;
                } else if (!modelName && modelCode && vin && registrationNumber) {
                    vehicle = modelCode + '\n' + vin + ' | ' + registrationNumber;
                } else if (!vin && modelName && modelCode && registrationNumber) {
                    vehicle = modelName + ' (' + modelCode + ')' + '\n' + registrationNumber;
                } else if (!modelName && !modelCode && vin && registrationNumber){
                    vehicle =  vin + ' | ' + registrationNumber;
                } else if (!modelName && !modelCode && !registrationNumber && vin){
                    vehicle =  vin;
                }
                return vehicle;
            };

            /**
             * @description Check if the total number of cases returned by the API is an integer or not
             * @param {*} totalCases 
             */
            function isInteger(totalCases) {
                return (typeof totalCases === 'number') && (totalCases % 1 === 0);
            }

            this.callServer = function callServer() {
                blockUI.start();
                vm.isLoading = true;
                var userProfil = CacheService.getUserProfile();

                var pagination = 50; //tableState.pagination;

                var start = pagination.start || 0;     // This is NOT the page numberOfEntriesPerPage, but the index of item in the list that you want to use to display the table.
                var numberOfEntriesPerPage = pagination.number || 30;  // Number of entries showed per page.
                var dealerId = userProfil.dealerId;
                var page = Math.ceil(start / numberOfEntriesPerPage) + 1;
                var pageSize = 5000;
                vm.isActisProfil = MainMetierService.isActisProfilNoContext();
                vm.lastNameCreator = userProfil.lastName.toUpperCase();

                var userContext = CacheService.getUserContext();
                var carContext = CacheService.getCarContext();

                FicViewListService.getFicList(dealerId, page, pageSize).then(function (response) {
                    var responseResult = response.result;
                    lastModifictnDate(response);
                    var listFics = responseResult.Cases;
                    var count = 0;
                    if(!_.isEmpty(listFics)){
                        listFics.forEach(function (data) {
                            count = ((data.CaseDetail.status == "Answered") || (data.CaseDetail.status == "Resolved")) ? ++count : count;
                        })
                    }
                    $rootScope.$broadcast('processedCIRList', count);
                    if (responseResult && responseResult.totalCases) {
                        CacheService.removeObject(CacheConstants.searchedSymptom);
                        var numberOfCases = responseResult.totalCases / 30;
                        var isNumber = isInteger(numberOfCases);
                        if (isNumber) {
                            vm.numberOfPagesToDisplay = numberOfCases;
                        } else {
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfCases);
                        }
                    }
                    var allowedVin = [];


                    for (var key in listFics) {

                        if (listFics.hasOwnProperty(key)) {
                            if(userProfil&&userProfil.roles&&!_.isEmpty(userProfil.roles)&&MainMetierService.isIndependantUser(userProfil.roles)&&listFics[key].CaseDetail.status=== "New")
                            {
                                allowedVin.push(listFics[key].Car.vin);

                            }
                            listFics[key].Car.vehicle = vm.formatModelVehicle(listFics[key].Car.modelName, listFics[key].Car.modelCode, listFics[key].Car.vin, listFics[key].Car.registrationNumber);
                            listFics[key].CaseDetail.statusOriginal = listFics[key].CaseDetail.status;
                            listFics[key].CaseDetail.status = $translate.instant(FicViewListWSService.convertStatusToND(listFics[key].CaseDetail.status));
                            if (listFics[key].Dealer.lastContactLastName) {
                                vm.lastModifier = listFics[key].Dealer.lastContactLastName.toUpperCase();
                            }

                        }

                    }
                    const encrypted = CryptoService.AES.encrypt(JSON.stringify(allowedVin), CacheConstants.encryptedValue);
                    CacheService.setObject(CacheConstants.allowedVin, encrypted.toString());


                    //Used for st-search and st-sort aka column filters and column order (asc,desc)
                    var filteredSlicedFics = FicViewListService.smartTableMainFilters(listFics);

                    // Replacing null with contactLatName
                    filteredSlicedFics.forEach(function (item) {
                        if (item.Dealer.lastContactLastName == null){
                            item.Dealer.lastContactLastName = item.Dealer.contactLastName;
                        }
                    });

                    // Filtering data on the 'lastNameCreatorCreator' and 'Abandoned' status
                    FicViewListService.dataTransformation(filteredSlicedFics, vm.lastNameCreator, userContext, carContext, vm.isActisProfil).then(function (result) {
                        vm.displayed = result.data;
                        if(!_.isEmpty(vm.displayed)){
                            vm.processedFicList = vm.displayed.filter(function(item){
                                return (item.CaseDetail.status == 'Proposal' || item.CaseDetail.status == 'To do');
                            });
                        }
                    });

                }).catch(function (error) {
                    toastr.error($translate.instant('ERROR'));
                }).finally(function () {
                    vm.isLoading = false;
                    blockUI.stop();
                });
            };

            /*********************
             *      VARIABLE     *
             ********************/

            vm.ficList = [];
            vm.count = 0;

            /***********************
             *     FUNCTIONS       *
             **********************/

            vm.addClassToFicStatus = addClassToFicStatus;
            vm.closeCurrentFIC = closeCurrentFIC;

            this.$onInit = function () {
                vm.isListFicOpen = false;
                vm.isProcessedListFicOpen = true;
                this.callServer();
            };

            /**
             * @desc Add class to determine the status type and action to do
             * @param {object} status of the fic
             * @param {object} id of the fic entry
             */
            function addClassToFicStatus(status, id) {
                var rowStatusId1 = '#rowStatus1';
                var rowStatusId2 = '#rowStatus2';
                angular.element(document.querySelector(rowStatusId1 + id)).removeAttr('class');
                angular.element(document.querySelector(rowStatusId2 + id)).removeAttr('class');
                if (status === $translate.instant("ACTIS_DRAFT")) {
                    angular.element(document.querySelector(rowStatusId1 + id)).addClass('circleYellow');
                    angular.element(document.querySelector(rowStatusId2 + id)).addClass('circleYellow');
                } else if (status === $translate.instant("ACTIS_ANSWERED")) {
                    angular.element(document.querySelector(rowStatusId1 + id)).addClass('circleRed');
                    angular.element(document.querySelector(rowStatusId2 + id)).addClass('circleRed');
                } else if (status === $translate.instant("ACTIS_PROPOSAL")) {
                    angular.element(document.querySelector(rowStatusId1 + id)).addClass('circleBlue');
                    angular.element(document.querySelector(rowStatusId2 + id)).addClass('circleBlue');
                } else if (status === $translate.instant("ACTIS_SENT")) {
                    angular.element(document.querySelector(rowStatusId1 + id)).addClass('circleGreen');
                    angular.element(document.querySelector(rowStatusId2 + id)).addClass('circleGreen');
                } else if (status === $translate.instant("ACTIS_CLOSED")) {
                    angular.element(document.querySelector(rowStatusId1 + id)).addClass('circleGrey');
                    angular.element(document.querySelector(rowStatusId2 + id)).addClass('circleGrey');
                }
            }

            /**
             * Call popup when the user clicks on the to do fic status
             */
            function closeCurrentFIC(caseNumber, caseId) {

                var payload = {
                    caseNumber: caseNumber,
                    caseId: caseId
                };

                $mdDialog.show({

                    templateUrl: 'app/components/actis/listFic/closeFicPopIn.template.html',
                    controller: 'closeFicPopInController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        payload: function () {
                            return payload;
                        }
                    }
                }).then(function (result) {
                    if (result && result.confirmClose) {
                        var st = $translate.instant(FicViewListWSService.convertStatusToND(result.status));
                        vm.addClassToFicStatus(st, result.caseId);
                        $state.reload();
                        toastr.success($translate.instant('FIC_CLOSED'));
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }


            /**
             * Open fic accordingly with the caseNUmber and caseId and re-route to manageFic page
             * @param caseNumber
             * @param caseId
             */
            function openFic(caseDetail, symptom) {

                $rootScope.previousState = RoutesConstants.ficConsultation;
                const sympCode = symptom && symptom.symptomCode && symptom.symptomCode.split("- ")[1] ? symptom.symptomCode.split("- ")[1] : null;
                $state.go(RoutesConstants.manageFIC, {
                    data: {caseNumber: caseDetail.caseNumber, caseId: caseDetail.caseId,
                        type : caseDetail.recordType, status: caseDetail.status, statusOriginal: caseDetail.statusOriginal, symptomCode: sympCode }

                });

            }

            // Used to create a FIC for MOTRIO parts
            function createMotrioFIC(){
                $state.go(RoutesConstants.manageFIC, {
                    isActisUserComingFromFicConsultation: true
                });
            }

            function lastModifictnDate(response){
                try{
                 var responseDate =  {
                    lastModificationDate: (response && response.result && response.result.Cases && !_.isEmpty(response.result.Cases) && response.result.Cases[0].CaseDetail && response.result.Cases[0].CaseDetail.lastModificaitonDate && !_.isEmpty(response.result.Cases[0].CaseDetail.lastModificaitonDate)) ? response.result.Cases[0].CaseDetail.lastModificaitonDate : null
                 };
                 FicViewListService.showLastModificationDate(responseDate).catch(function(){
                    $log.debug($translate.instant('ERROR'));
                 })
            }catch(err){
              
            }
          }
        }


    }

)();

(function() {
    angular.module('phenix').constant('ficViewListConstants', {
        endpoint: {
            listCase: '/proxy/wired/commerce/v1/dealers/',
            symptoms: '/proxy/apidh/rest/v1/symptoms',
            articles: '/proxy/apidh/rest/v1/articles',
        },
        pagination: {
            limit: 20
        },
        status : {
            abandoned : "Abandoned"
        },
        typesFIC: [
            {id: 1, name: 'Technical Assistance'},
            {id: 2, name: 'Agreement'},
            {id: 3, name: 'Alert'},
            {id: 4, name: 'Good Practice '},
            {id: 5, name: 'ZE Battery'},
            {id: 6, name: 'Accessoiries'},
            {id: 7, name: 'Painting'}
        ]
    })
})();

(function () {

    angular
        .module('phenix')
        .filter('replacePipeByCarriageReturn', replacePipeByCarriageReturn)
        .directive('stResetSearch', stResetSearch)
        .config(function (stConfig) {
            stConfig.pagination.template = 'app/components/actis/listFic/listFic-pagination.template.html';
        });

    /**
     * @desc Purpose is to reset every input filter in the table
     */
    /** @ngInject */
    function stResetSearch() {
        return {
            restrict: 'EA',
            require: '^stTable',
            link: function (scope, element, attrs, ctrl) {
                return element.bind('click', function () {
                    return scope.$apply(function () {
                        var tableState;
                        tableState = ctrl.tableState();
                        tableState.search.predicateObject = {};
                        tableState.pagination.start = 0;
                        angular.element(document.querySelectorAll(".md-input-has-value:not(.actisProfil)")).removeClass("md-input-has-value");
                        ctrl.isActisProfil = false;
                        return ctrl.pipe();
                    });
                });
            }
        }

    }

    /**
     * @desc This filter takes a string as an input (Car Model | VIN | Registration number) and
     * prints the output in two lines as follows :
     */
    function replacePipeByCarriageReturn() {
        return function (text) {
            if (text){
                return text.replace(/\s\|\s/, "\n");
            }else {
                return text;
            }

        };
    }

})();

(function () {

    angular
        .module('phenix').controller('closeFicPopInController', closeFicPopInController)
        .directive('starRating', starRating);

    /** @ngInject */
    function closeFicPopInController(
        RoutesConstants,
        blockUI,
        toastr,
        $translate,
        $state,
        $scope,
        CacheConstants,
        CacheService,
        $mdDialog,
        CreateActisWSService) {


        // VARIABLES
        var vm = this;
        vm.starsRating = 0;
        vm.displayedText = '';

        // FUNCTIONS
        vm.enableOrDisableCloseFicButton = enableOrDisableCloseFicButton;
        vm.closeDialog = closeDialog;
        vm.displayTitleOnHover = displayTitleOnHover;
        vm.closeFIC = closeFIC;

        /**
         *  We watch the rating value to enable or disable Close Fic button based on this value
         */

        $scope.$watch('starsRating', function (oldValue, newValue) {
            if (newValue || newValue === 0) {
                enableOrDisableCloseFicButton(vm.starsRating);
            }
        });


        /**
         * @name enableOrDisableCloseFicButton
         * @desc Implemented logic to enable or disable Close Fic button. It takes rating value as a parameter
         * @param value
         */

        function enableOrDisableCloseFicButton(value) {
            if (value === 4) {
                return true;
            } else if (value < 4) {
                if ((vm.resolutionTime || vm.techlineAdvices || vm.technicalInformationQuality || vm.piecesQuality || vm.otherReason)) {
                    return true;
                } else {
                    return false;
                }
            }
        }


        /**
         * @name closeDialog
         * @desc Closes pop-in if Close button is clicked
         */

        function closeDialog() {
            $mdDialog.hide();
        }


        /**
         * @name displayTitleOnHover
         * @desc Displays specific value based on user's rating
         * @param value, displayedText
         */

        function displayTitleOnHover(index, displayedText) {
            switch (index) {
                case 1:
                    vm.displayedText = 'USER_COMPLETELY_UNSATISFIED';
                    break;
                case 2:
                    vm.displayedText = 'USER_QUITE_UNSATISFIED';
                    break;
                case 3:
                    vm.displayedText = 'USER_QUITE_SATISFIED';
                    break;
                case 4:
                    vm.displayedText = 'USER_COMPLETELY_SATISFIED';
                    break;
            }

            return displayedText;
        }


        /**
         * @name closeFIC
         * @desc Calls API PUT request to update Fic status to 'Closed'
         */

        function closeFIC() {

            var userProfil = CacheService.getUserProfile();

            var dealerId = userProfil.dealerId;

            var mandatoryParameters = {
                caseNumber: vm.payload.caseNumber,
                dealerId: dealerId,
                caseId: vm.payload.caseId,
                firstName: userProfil.firstName,
                lastName: userProfil.lastName,
                status: 'Closed'
            };

            var unsatisfactoryReasons = {

            }
            if (vm.resolutionTime) {
                unsatisfactoryReasons.resolutionTime = {
                    'id' : 1
                }
            }
            if (vm.techlineAdvices) {
                unsatisfactoryReasons.techlineAdvices = {
                    'id' : 2
                }
            }
            if (vm.technicalInformationQuality) {
                unsatisfactoryReasons.technicalInformationQuality = {
                    'id' : 3
                }
            }

            if (vm.piecesQuality) {
                unsatisfactoryReasons.piecesQuality = {
                    'id' : 4
                }
            }

            if (vm.otherReason) {
                unsatisfactoryReasons.otherReason = {
                    'id' : 5
                }
            }

            var nonSatisfactionReason = '';
            if (unsatisfactoryReasons) {
                angular.forEach(unsatisfactoryReasons, function (value, key) {
                    var id = value.id;
                    if (nonSatisfactionReason) {
                        nonSatisfactionReason = nonSatisfactionReason + ',' + id;
                    } else {
                        nonSatisfactionReason = id;
                    }
                })
            }

            var reasons = nonSatisfactionReason;

            var dataChanged = {
                "grade": vm.starsRating,
                "satisfactionComment": vm.closePopInTextArea,
                "nonSatisfactionReason": reasons
            };

            blockUI.start();
            CreateActisWSService.updateFic(mandatoryParameters, dataChanged).then(function (response) {
                vm.responseApi = response.result;
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
                var result = {
                    confirmClose: true,
                    status : vm.responseApi.CaseDetail.status,
                    caseId : vm.responseApi.CaseDetail.caseId,
                    grade: vm.responseApi.CaseDetail.grade,
                    satisfactionComment: vm.responseApi.CaseDetail.satisfactionComment,
                    nonSatisfactionReason: vm.responseApi.CaseDetail.nonSatisfactionReason
                }
                $mdDialog.hide(result);
            });
        }
    }


    /**
     * @name starRating
     * @desc Special directive to display customized yellow stars. Value is dynamically updated based on user's input
     */

    function starRating() {
        return {
            restrict: 'EA',
            template:
                '<ul class="star-rating">' +
                '  <li ng-repeat="star in stars" class="star" ng-class="{filled: star.filled}" ng-click="toggle($index)">' +
                '    <i id="closeFicStarRating" class="fa fa-star"></i>' + // or &#9733
                '  </li>' +
                '</ul>',
            scope: {
                ratingValue: '=ngModel',
                max: '=?', // optional (default is 5)
                onRatingSelect: '&?',
                readonly: '=?'
            },
            link: function (scope, element, attributes) {
                if (scope.max == undefined) {
                    scope.max = 4;
                }

                function updateStars() {
                    scope.stars = [];
                    for (var i = 0; i < scope.max; i++) {
                        scope.stars.push({
                            filled: i < scope.ratingValue
                        });
                    }
                }

                scope.toggle = function (index) {
                    if (scope.readonly == undefined || scope.readonly === false) {
                        scope.ratingValue = index + 1;
                        scope.onRatingSelect({
                            rating: index + 1
                        });
                    }
                };
                scope.$watch('ratingValue', function (oldValue, newValue) {
                    if (newValue || newValue === 0) {
                        updateStars();
                    }
                });
            }
        };
    }
})();

(function() {

    angular
        .module('phenix')
        .directive('apsUploadFile', apsUploadFile);

        function apsUploadFile() {
            var directive = {
                restrict: 'E',
                template: '<input id="fileInput" type="file" class="ng-hide"> <md-button id="uploadButton" class="md-raised md-primary" aria-label="attach_file">    Choose file </md-button><md-input-container  md-no-float>    <input id="textInput" ng-model="fileName" type="text" placeholder="No file chosen" ng-readonly="true"></md-input-container>',
                link: apsUploadFileLink
            };
            return directive;
        }

        function apsUploadFileLink(scope, element) {
            var input = $(element[0].querySelector('#fileInput'));
            var button = $(element[0].querySelector('#uploadButton'));
            var textInput = $(element[0].querySelector('#textInput'));

            if (input.length && button.length && textInput.length) {
                button.click(function() {
                input.click();
                });
                textInput.click(function() {
                input.click();
                });
            }

            input.on('change', function(e) {
                var files = e.target.files;
                if (files[0]) {
                scope.fileName = files[0].name;
                } else {
                scope.fileName = null;
                }
                scope.$apply();
            });
        }

})();

(function() {
    angular.module('phenix').directive('chatbot', function(CacheService,CacheConstants,configConstantes) {
        var directive = {
            template:'<div class="embeddedServiceHelpButton helpButton uiButton"> </div>',
        link:function(){
            var isChatbotNewScriptEnable = JSON.parse(configConstantes.isChatbotNewScriptEnable);
            var initESW = function(gslbBaseURL) {
                embedded_svc.settings.displayHelpButton = true; //Or false
                embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'
        
                //embedded_svc.settings.defaultMinimizedText = '...'; //(Defaults to Chat with an Expert)
                //embedded_svc.settings.disabledMinimizedText = '...'; //(Defaults to Agent Offline)
        
                //embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
                //embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)
        
                // Settings for Chat
                //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
                    // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
                    // Returns a valid button ID.
                //};

                //Sets the auto-population of pre-chat form fields
                var profil = CacheService.getObject(CacheConstants.profil);
                var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);

                embedded_svc.settings.prepopulatedPrechatFields = {
                    FirstName: profil.firstName,
                    LastName: profil.lastName,
                    Email: profil.emailAlerte,
                    Subject: "Please type your message",
                    VIN_Number__c: contextCarRequest.vin,
                    VehicleIdentificationNumber__c: contextCarRequest.vin,
                    Dealer_Id__c: profil.dealerId
                };
                //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
                //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)
        
                embedded_svc.settings.enabledFeatures = ['LiveAgent'];
                embedded_svc.settings.entryFeature = 'LiveAgent';
                if(isChatbotNewScriptEnable){
                    embedded_svc.init(
                        'https://renaultarca.my.salesforce.com',
                        'https://renaultarca.my.site.com/snapin',
                        gslbBaseURL,
                        '00Db0000000cZvn',
                        'RActis_chat_Team',
                        {
                            baseLiveAgentContentURL: 'https://c.la3-c2-fra.salesforceliveagent.com/content',
                            deploymentId: '57267000000CvTN',
                            buttonId: '573670000000JeR',
                            baseLiveAgentURL: 'https://d.la3-c2-fra.salesforceliveagent.com/chat',
                            eswLiveAgentDevName: 'RActis_chat_Team',
                            isOfflineSupportEnabled: true
                        }
                    );
                }
                else{
                    embedded_svc.init(
                        'https://renaultarca--hquat.sandbox.my.salesforce.com',
                        'https://renaultarca--hquat.sandbox.my.site.com/snapin',
                        gslbBaseURL,
                        '00DAY000004CyCb',
                        'RActis_chat_Team',
                        {
                            baseLiveAgentContentURL: 'https://c.la12s-core1.sfdc-urlt2q.salesforceliveagent.com/content',
                            deploymentId: '57267000000CvTN',
                            buttonId: '573670000000JeR',
                            baseLiveAgentURL: 'https://d.la12s-core1.sfdc-urlt2q.salesforceliveagent.com/chat',
                            eswLiveAgentDevName: 'RActis_chat_Team',
                            isOfflineSupportEnabled: false
                        }
                    );
                }
            };
        
         
        
            if (!window.embedded_svc) {
                var s = document.createElement('script');
                if(isChatbotNewScriptEnable){
                    s.setAttribute('src', 'https://renaultarca.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                }
                else{
                    s.setAttribute('src', 'https://renaultarca--hquat.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                }
                s.onload = function() {
                    initESW(null);
                };
                document.body.appendChild(s);
            } else {
                initESW('https://service.force.com');
            }
        }

        }        
        
        return directive;   
      });
  })();
/**
 * vehicleComponent
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('vehicleActis', {
            bindings: {
                type: '@',
                removeButtonToRecapCar: '<',
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isLoadFic: '<',
                isFicCancelled: '<',
                isFicReopen: '<',
                isActisFromDiag: '<',
                isDraft: '<',
                isForQstomize: '<',
                isIndependentUser:'<',
                isDaysToReopen: '<'
            },
            controller: VehicleActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/vehicle-actis.template.html'
        })
        .directive("limitTo", [function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    var limit = parseInt(attrs.limitTo);
                    angular.element(elem).on("keypress", function (e) {
                        if (this.value.length === limit) {
                            e.preventDefault();
                        }
                    });
                }
            };
        }]);

        function VehicleActisController(
            CacheService,
            CacheConstants,
            $scope,
            FicInputValidationService,
            ActisConstantes,
            $state,CarSearchMetierService,blockUI,$translate,toastr,$rootScope,MainMetierService,errorsConstant,$mdDialog) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;
            vm.vehicle = {};
            vm.createMotrioFic = false;
            vm.getVinClass = getVinClass;
            vm.whichFieldIsSelected = whichFieldIsSelected;
            vm.isDisabled = false;
            vm.recapCarSelected = true;
            vm.isVehicleOpen = false;
            vm.vehicleFieldsSelected = false;
            vm.refreshVin =  false;
            vm.clearRefreshVin = false;
            vm.removeColors = removeColors;
            vm.getBinCarContext = getBinCarContext;
            vm.onRefreshClick = onRefreshClick;
            vm.getVin = getVin;
            vm.radioButtonColorChange = radioButtonColorChange;
            vm.isActisProfil = MainMetierService.isActisProfilNoContext();
            vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
            vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            /**
             * Create a listener to listen from Actis.constoler (broadcast)
             * in order to call getVehicleData()
             */
            $scope.$on("clearRefreshVin",function (event,data){
                vm.refreshVin = data.refreshVin;
                vm.clearRefreshVin = data.clearRefreshVin;
                vm.status = data.status;                
            });
            $scope.$on('getFicData', function(event) {
                $scope.$emit("loadFicData", $scope.getVehicleData());
            });
            $rootScope.$on('getQstomise', function (event, carContext) {
                vm.context = carContext;
            });
            $rootScope.$on("saveOrSendCheck",function (event,data){
                vm.ficSend = data.isNewFicType;
            });

            /**
             * return Current data contained in the view at the moment when the method is called
             * @returns Car object
             */
            $scope.getVehicleData = function(){
                var context = CacheService.getObject(CacheConstants.contextCarSearch);
                vm.vehicle.mileageValue = vm.distance;
                if(vm.isForQstomize){
                    vm.vehicle.isVehicleTransformed = true;
                    vm.vehicle.vin = (context && context.vehicle) ? context.vehicle.vin: "";
                    vm.vehicleModel = (context && context.vehicle) ? context.vehicle.model: "";
                }
                else{
                    if(vm.transformedVehicle === "Yes"){
                        vm.vehicle.isVehicleTransformed = true;
                    }
                    else if(vm.transformedVehicle === "No"){
                        vm.vehicle.isVehicleTransformed = false;
                    }
                    else{
                        vm.vehicle.isVehicleTransformed="";
                    }
                    vm.vehicle.model = vm.vehicleModel;
                }
                if(vm.accessoiresVehicle === "Yes"){
                    vm.vehicle.isVehicleAccessories = true;
                }
                else if(vm.accessoiresVehicle === "No"){
                    vm.vehicle.isVehicleAccessories = false;
                }
                else{
                    vm.vehicle.isVehicleAccessories ="";  
                }
                if(vm.vehiculeImmobilized === "Yes"){
                    vm.vehicle.isVehicleImmobilised = true;
                }
                else if(vm.vehiculeImmobilized === "No"){
                    vm.vehicle.isVehicleImmobilised = false;
                }
                else{
                    vm.vehicle.isVehicleImmobilised = "";
                }
                vm.vehicle.bin = vm.binValueToDisplay;
                vm.vehicle.brand = vm.vehicleBrand;
                vm.vehicle.year = vm.vehicleYear;
                // vm.vehicleVin = vm.vehicleVin ? vm.vehicleVin : vm.vin;
                vm.vehicleVin = vm.vin;
                if(vm.selectedUnite.name && (vm.selectedUnite.name.toUpperCase() == ActisConstantes.km || vm.selectedUnite.name === '')){
                    vm.vehicle.mileageUnit = ActisConstantes.km;
                }else if (vm.selectedUnite.name && vm.selectedUnite.name.toUpperCase() == ActisConstantes.miles.toUpperCase()){
                    vm.vehicle.mileageUnit = ActisConstantes.miles;
                }

                return {"Car": vm.vehicle};
            };


            this.$onInit = function () {
                if ($state.params.isActisUserComingFromFicConsultation) {
                    vm.createMotrioFic = true;
                }

                vm.unites =[
                    {id: 1, name: ActisConstantes.km},
                    {id: 2, name: ActisConstantes.miles}
                ];

                vm.distance = vm.responseApi && vm.responseApi.Car && vm.responseApi.Car.mileageValue ? vm.responseApi.Car.mileageValue : '';

                if (vm.responseApi && vm.responseApi.Car && vm.responseApi.Car.mileageUnit) {
                    vm.selectedUnite = vm.unites.find(function (u) {
                        return u.name.toLowerCase() === vm.responseApi.Car.mileageUnit.toLowerCase();
                    });
                } else {
                    vm.selectedUnite = { id: 1, name: ActisConstantes.km };
                }

                
                 vm.context = CacheService.getObject(CacheConstants.contextCarSearch);
                if (vm.context && !$state.params.isActisUserComingFromFicConsultation && !$state.params.data) {
                    vm.vehicle = angular.copy(vm.context.vehicle);
                }

                vm.removeButtonToRecapCar();
                vm.isVehicleOpen = ((vm.isDraft || vm.isActisFromDiag || vm.isForQstomize) && !vm.nonModifiableFic ) ? true : false;
                vm.vehicleEnabled = (vm.context && vm.context.vehicle) ? true : false;
            };

            /**
             * Triggered by any change of the UI
             * used to update the view
             */
            this.$onChanges = function () {
                var context = CacheService.getObject(CacheConstants.contextCarSearch);
            if((vm.type == "others" || vm.type =="zeBattery") && !_.isEmpty(context) && context.vehicle){
                vm.distance =  context.vehicle.mileAge ?  context.vehicle.mileAge : ""
            }
                //Insert the data into vm from response API post
                //We make sure that we change the view in the case we save/edit the fic
                if (vm.isEditMode && vm.responseApi) {

                    var context = CacheService.getObject(CacheConstants.contextCarSearch);
                    if (context && !vm.isLoadFic && !$state.params.isActisUserComingFromFicConsultation) {
                        vm.vehicle = context.vehicle;
                    } else {
                        if (_.isEmpty(vm.vehicle)) {
                            vm.vehicle = {};
                        }
                    }

                    vm.distance = vm.responseApi.Car.mileageValue;
                    vm.transformedVehicle = vm.responseApi.Car.isVehicleTransformed ? "Yes" : "No";
                    vm.accessoiresVehicle = vm.responseApi.Car.isVehicleAccessories ? "Yes" : "No";
                    vm.vehiculeImmobilized = vm.responseApi.Car.isVehicleImmobilised ? "Yes" : "No";
                    if (!$state.params.isActisUserComingFromFicConsultation) {
                        vm.vehicle.vin = vm.responseApi.Car.vin;
                        vm.binValueToDisplay = vm.responseApi.Car.bin;
                        vm.vehicle.registrationNumber = vm.responseApi.Car.registrationNumber;
                        vm.vehicleBrand = vm.responseApi.Car.brand;
                        vm.vehicleModel = vm.responseApi.Car.model;
                        vm.vehicleYear = vm.responseApi.Car.year;
                        vm.vehicleVin = vm.responseApi.Car.vin;
                    }
                    vm.status = vm.responseApi.CaseDetail.status;

                    if (vm.responseApi.Car.mileageUnit && vm.responseApi.Car.mileageUnit !== "") {
                        if (vm.responseApi.Car.mileageUnit.toUpperCase() === ActisConstantes.km) {
                            vm.selectedUnite = {id: 1, name: ActisConstantes.km};
                        } else if (vm.responseApi.Car.mileageUnit.toUpperCase() === ActisConstantes.miles.toUpperCase()) {
                            vm.selectedUnite = {id: 2, name: ActisConstantes.miles};
                        }
                    }

                    if (vm.isLoadFic) {
                        vm.carDetailModel = vm.responseApi.Car.model;

                        if (!_.isEmpty(vm.responseApi.Car.vin) && !_.isEmpty(vm.responseApi.Car.registrationNumber) && !$state.params.isActisUserComingFromFicConsultation) {
                            vm.carDetailVin = vm.responseApi.Car.vin + " | " + vm.responseApi.Car.registrationNumber;
                        } else if (!_.isEmpty(vm.responseApi.Car.vin) && _.isEmpty(vm.responseApi.Car.registrationNumber) && !$state.params.isActisUserComingFromFicConsultation) {
                            vm.carDetailVin = vm.responseApi.Car.vin;
                        } else if (_.isEmpty(vm.responseApi.Car.vin) && !_.isEmpty(vm.responseApi.Car.registrationNumber) && !$state.params.isActisUserComingFromFicConsultation) {
                            vm.carDetailVin = vm.responseApi.Car.registrationNumber;
                        } else if (_.isEmpty(vm.responseApi.Car.vin) && _.isEmpty(vm.responseApi.Car.registrationNumber) && $state.params.data) {
                            vm.createMotrioFic = true;
                        }
                    }
                    if (vm.responseApi.Car.isVehicleImmobilised) {
                        vm.vehiculeImmobilized = "Yes";
                    } else {
                        vm.vehiculeImmobilized = "No";
                    }
                }
                if(_.isEmpty(vm.responseApi)){
                    vm.isQstomizeTypeFic = false;
                    vm.isQstomizeClosedFic = false;
                }
            };

            // Used to call service method to remove css of required fields
            function removeColors(elementName) {
                if (elementName === 'distanceValue') {
                    FicInputValidationService.removeColors("distanceValue");
                } else if (elementName === 'binValueToDisplay') {
                    FicInputValidationService.removeColors("binValueToDisplay");
                } else if (elementName === 'brand') {
                    FicInputValidationService.removeColors("brand");
                } else if (elementName === 'model') {
                    FicInputValidationService.removeColors("model");
                } else if (elementName === 'year') {
                    FicInputValidationService.removeColors("year");
                }
            }
            function radioButtonColorChange(elementName){

                if(vm.ficSend && ((elementName === "vehicleImmobilized" && vm.vehicle && vm.vehicle.isVehicleImmobilised === "") || (elementName === "transformedVehicle" && vm.vehicle && vm.vehicle.isVehicleTransformed === "") || (elementName === "accessoiresVehicle" && vm.vehicle && vm.vehicle.isVehicleAccessories === ""))){
                    var vehicleData = document.getElementById(elementName);
                    vehicleData.classList.add("radioButtonChange");
                }
                else{
                    var vehicleData = document.getElementById(elementName);
                    vehicleData.classList.remove("radioButtonChange");
                }
            }
            function getBinCarContext(vin)
            {
              
                if(vin && !_.isEmpty(vin)){

                    blockUI.start();
                    CarSearchMetierService.searchCar({vin: vin}).then(function(){
                        vm.carContext = CacheService.getCarContext();
                            if((vm.isIndependentUser && MainMetierService.isBrandApplicable()) || !vm.isIndependentUser){
                        
                                CarSearchMetierService.getBannerData().then(function(){
                                    if(vm.carContext && vm.carContext.registrationNumber){
                                    vm.vehicle.registrationNumber =  vm.carContext.registrationNumber
                                    }
                                    vm.displayGreyBanner = true;
                                    vm.refreshVin = false;
                                    vm.clearRefreshVin = false;
                                    vm.vin = ''
                                }).catch(function(error){
                                    toastr.error(error.msg || $translate.instant('ERROR'));
                                    CacheService.removeObject(CacheConstants.contextCarSearch);
                                    CacheService.removeObject(CacheConstants.contextCarRequest);
                                }).finally(function () {
                                    $rootScope.$broadcast("disableSendSave", {isDisabled: false});
                                    blockUI.stop();
                                });
                            }else{
                                toastr.error($translate.instant('VIN_SEARCH_NOT_AUTHORIZED'));
                                CacheService.removeObject(CacheConstants.contextCarSearch);
                                CacheService.removeObject(CacheConstants.contextCarRequest);
                                $rootScope.$broadcast("disableSendSave", {isDisabled: true});
                                blockUI.stop();
                            }
                    }).catch(function (err) {
                         function showDialog(messageKey) {
                            $mdDialog.show({
                                controller: function DialogController($scope, $mdDialog) {
                                    $scope.closeDialog = function () {
                                        $mdDialog.hide();
                                    };
                                },
                                template: `<div ng-keypress class="actions" style="position: absolute; right:5px;" ng-click="closeDialog()"><em class="fa fa-close"></em></div><div style="padding: 20px;font-family:var(--renaultFontRegular);">{{'${messageKey}' | translate}}</div>`,
                                clickOutsideToClose: true,
                            });
                         }
                        if (err && err.status === 429) {
                            showDialog('VIN_SEARCH_LIMIT_REACHED');
                        } else {
                            toastr.error(err.msg || $translate.instant('ERROR'));
                        }
                        vm.vin = '';
                        blockUI.stop();
                    });
                }
            }
            function getVin(val) {
                vm.vin = val;
            }
            /**
             * @namespace getVinClass
             * @desc get vin class according to the fic type
             * @param {string} type the selected type fic
             */
            function getVinClass(type){
                var vinClass="";
                switch(type){
                    case 'painting':
                        vinClass = 'small-12 columns';
                        break;
                    case 'accessory':
                        vinClass = 'small-12 columns';
                        break;
                    case 'zeBattery':
                        vinClass = 'small-6 columns';
                        break;
                    case 'others':
                        vinClass = 'small-6 columns';
                        break;
                }
                return vinClass;
            }

            function whichFieldIsSelected(value) {

                if (value === vm.recapCarSelected) {
                    vm.isDisabled = true;
                } else if (value === vm.vehicleFieldsSelected) {
                    vm.isDisabled = false;
                }
            }

            function onRefreshClick(){                
                var carContextDetail = CacheService.getObject(CacheConstants.contextCarSearch);                                
                var vin = carContextDetail.vehicle.vin;
                if(vin && !_.isEmpty(vin)){
                    blockUI.start();
                    CarSearchMetierService.searchCar({vin: vin}).then(function(){
                        CarSearchMetierService.getBannerData().then(function(){
                            vm.carContext = CacheService.getCarContext();
                            if(vm.carContext && vm.carContext.registrationNumber){
                            vm.vehicle.registrationNumber =  vm.carContext.registrationNumber
                            }                            
                            vm.refreshVin = true;
                            vm.clearRefreshVin = true;                            
                        }).catch(function(error) {
                            toastr.error(error.msg || $translate.instant('ERROR'));
                            CacheService.removeObject(CacheConstants.contextCarSearch);
                            CacheService.removeObject(CacheConstants.contextCarRequest);
                        }).finally(function () {
                            blockUI.stop();
                        });
                    }).catch(function (errorMessage) {
                        errorMessage ? toastr.error(errorMessage.msg) : toastr.error($translate.instant('ERROR'));  
                        vm.vin='';
                        blockUI.stop();
                    });
                }
            }

        }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('resolutionActis', {
            bindings: {
            },
            controller: GeneralActisComponent,
            templateUrl: 'app/components/actis/components/resolution-actis.template.html'
        })

        function GeneralActisComponent() {
        }
})();

/**
 * requestComponent
 * @namespace Components
 */
 (function () {

    angular
        .module('phenix')
        .component('requestDetails', {
            bindings: {
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isFicCancelled: '<',
                isFicReopen: '<',
                isDaysToReopen: '<',
                isDraft: '<',
                saveFic: '<',
                onDeleteFic: '<',
                isStatusPresent: '<',
                isForBwr: '<',
                isFicCreation: '<',
                isSaveButtonVisible: '<',
                isForBwr: '<',
                isForPaint: '<',
                isForAccessories: '<',
                isIndependentUser:'<',
                isForBwr: '<'
            },
            controller: RequestDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/request-details.template.html'
        });

        function RequestDetailsController(
            ActisFicModalService,
            $http,
            $scope,
            CacheService,
            CacheConstants,
            ActisConstantes,
            toastr,
            $rootScope,
            $attrs,
            CreateActisBusinessService,
            $translate,
            $filter,
            $interval,$q,$log,RestUpgrade,MainMetierService) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;
            
            $scope.files = [];
            $scope.filesToBeShown = [];
            $scope.sizeTable = [];
            $scope.log = '';
            $scope.onLoading = 0;
            $scope.isLoading = false;
            vm.isOpenRequest = false;
            vm.cirDemand = ActisConstantes.cirDemand;
            $scope.rDocIdsAndFileNames = [];
            var cancelDefer = $q.defer();
            var intervals = [];
            var putRequests = [];
            vm.isRequestOpen = false;
            vm.isActisProfil = MainMetierService.isActisProfilNoContext();

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            
            vm.saveFicHeader = saveFicHeader;
            vm.removeTextAreaColors = removeTextAreaColors;
            vm.showRequest = showRequest;

            //init();

            /**
             * Create a listener to listen from Actis.constoler (broadcast)
             * in order to call getVehicleData()
             */
            $scope.$on('getFicData', function(event) {
                $scope.$emit("loadFicData", $scope.getRequestDetails());
            });

            $rootScope.$on("disableSendSave", function(event, data) {
                vm.disableSendSave = data.isDisabled;
            });

            /**
             * Triggered by any change of the UI
             * Used to update the view
             */
            this.$onChanges = function () {

                if(vm.responseApi && vm.isEditMode){
                    vm.numberFic = vm.responseApi.CaseDetail.caseNumber;
                    vm.status = vm.responseApi.CaseDetail.status;
                    vm.selectedDemand = _.find(vm.cirDemand,function(item){
                        return $translate.instant(item.id) === vm.responseApi.Request.cirDemand1;
                    });
                    vm.selectedDemandDetails = vm.responseApi.Request.cirDemand2;
                    vm.customerComplaint = vm.responseApi.Request.customerComplaint;
                }
            }

            function showRequest(){
                vm.isOpenRequest = true;
            }

            this.$onInit = function() {

                if(vm.isDraft && !vm.nonModifiableFic){
                    vm.isRequestOpen = true;
                }

                _.map(vm.cirDemand,function(item){
                    item.id = $translate.instant(item.id);
                    var values = [];
                    _.map(item.value,function(val){
                        values.push($translate.instant(val));
                    })
                    item.value = values;
                })
            }

            /**
         * @description Used to remove css when the field is populated
         * @param {*} elementName 
         */
        function removeTextAreaColors(elementName) {
            var element = document.getElementById(elementName);
            
            var elem = angular.element(element);
            $(elem).removeClass('backgroundColorRequiredFields');
            var label = $(element).parent().parent().children().first();
            var e = angular.element(label);
            e.removeClass('changeTextColorToRed');
            var parent = $(element).parent().parent();
            parent.removeClass('md-input-invalid');
        }

            /**
             * return Current data contained in the view at the moment when the method is called
             * @returns Car object
             */
            $scope.getRequestDetails = function(){

                return {
                        "Request":{
                            "customerComplaint": vm.customerComplaint,
                            "cirDemand1": vm.selectedDemand ? vm.selectedDemand.id : '',
                            "cirDemand2" : vm.selectedDemandDetails
                        }
                };
            };

            $scope.$watch('files', function () {
                $scope.checkAlreadyUploadedFiles($scope.files);
            });
            $scope.$watch('file', function () {
                if ($scope.file != null) {
                    $scope.files = [$scope.file];
                }
            });


            /**
         * @namespace fileConvertSize
         * @desc convert file size to standard size
         * @param {aSize} file size in bytes
         */

        $scope.fileConvertSize = function (aSize) {
            aSize = Math.abs(parseInt(aSize, 10));
            var def = [
                [1, 'octets'],
                [1024, 'Ko'],
                [1024 * 1024, 'Mo'],
                [1024 * 1024 * 1024, 'Go'],
                [1024 * 1024 * 1024 * 1024, 'To']
            ];
            for (var i = 0; i < def.length; i++) {
                if (aSize < def[i][0]){
                    return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
                } 
            }
        };

        /**
         * @namespace showProgressBar
         * @desc add specific rules to show progress bar during file upload
         * @param {index} file index in list
         */

        $scope.showProgressBar = function (index) {
            if ($scope.onLoading !== 100 && (index === $scope.filesToBeShown.length - 1) && $scope.isLoading === true) {
                if($scope.delete ==false){
                    return true;
                }
            } else if (index > $scope.filesToBeShown.length - 1) {
                return false;
            }
        };

            /**
         * @description Used to check if there are any files already uplaoded
         * If yes, then do not upload the same file again and display a toastr error
         * If no, then upload the file
         */
        $scope.checkAlreadyUploadedFiles = function (files) {
            var isFileAlreadyPresent = false;
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                vm.showCoTechFilesInAttachment.forEach(function (item) {
                    if (files[0].name === item.fileName && files[0].type === item.fileType) {
                        isFileAlreadyPresent = true;
                        toastr.error($translate.instant("FILE_UPLOAD_ERROR"));
                        return;
                    }
                })
            } else {
                $scope.upload($scope.files);
            }

            if (!isFileAlreadyPresent && vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                $scope.upload($scope.files);
            }
        }

        /**
         * @namespace upload
         * @desc upload file to server
         * @param {files} selected file to be uploaded
         */

        $scope.upload = function (files) {

            var user = CacheService.getObject(CacheConstants.profil);
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);

            if (files && files.length == 1) {
                var file = files[0];
                var vin = "", brand = "";

                var body;
                var responseApi = CacheService.getObject(CacheConstants.actisResponse);
                
                if (_.isEmpty(carContext)) {
                    if (!_.isEmpty(responseApi)) {
                        vin = responseApi.Car.vin;
                        brand = responseApi.Car.brand;
                    } else {
                        toastr.error($translate.instant('ALERTS_ERROR_HTL'));
                        return;
                    }
                } else {
                    brand = carContext.brandComputed;
                    vin = carContext.vin;
                }

                var currentDate = new Date();
                var formattedCurrentDate = $filter('date')(currentDate, 'yyyy-MM-dd HH:mm:ss');
                // Add 10 years to the current date
                currentDate.setFullYear(currentDate.getFullYear() + 10);
                // Format the new date using AngularJS $filter
                var formattedDateAfter10Years = $filter('date')(currentDate, 'yyyy-MM-dd HH:mm:ss');

                if(!_.isEmpty(responseApi)){
                    if ($attrs.template === "discussion") {
                        body = {
                            "fileName": file.name,
                            "fileType": file.type,
                            "documentType": 'ATTACHMENT_CASE',
                            "country": "FR",
                            "dealerId": (!_.isEmpty(user)) ? user.dealerId : null,
                            "eventType": (responseApi.CaseDetail && responseApi.CaseDetail.caseNumber) ? responseApi.CaseDetail.caseNumber : null,
                            "eventId": (responseApi.CaseDetail && responseApi.CaseDetail.caseId) ? responseApi.CaseDetail.caseId : '',
                            "brand": brand,
                            //"providerSystem": providerSystem,
                            "vin": vin,
                            "lang": (!_.isEmpty(user)) ? user.language:null,
                            "localDate": formattedCurrentDate,
                            "purgeDate": formattedDateAfter10Years
                        }
                    } else if ($attrs.template === "attachment" || $attrs.template === 'attachmentBrw') {
                        body = {
                            "fileName": file.name,
                            "fileType": file.type,
                            "documentType": 'ATTACHMENT_CASE',
                            "country": "FR",
                            "dealerId": (!_.isEmpty(user)) ? user.dealerId :null,
                            //"eventType": eventType,
                            "eventId": (responseApi.CaseDetail && responseApi.CaseDetail.caseId) ? responseApi.CaseDetail.caseId : '',
                            "brand": brand,
                            //"providerSystem": providerSystem,
                            "vin": vin,
                            "lang": (!_.isEmpty(user)) ? user.language:null,
                            "localDate": formattedCurrentDate,
                            "purgeDate": formattedDateAfter10Years
                        }
                    } 
                    else{

                        body = {
                            "fileName": file.name,
                            "fileType": file.type,
                            "documentType": 'ATTACHMENT_CASE',
                            "country": "FR",
                            "dealerId": (!_.isEmpty(user)) ? user.dealerId :null,
                            //"eventType": eventType,
                            "eventId": (responseApi.CaseDetail && responseApi.CaseDetail.caseId) ? responseApi.CaseDetail.caseId : '',
                            "brand": brand,
                            //"providerSystem": providerSystem,
                            "vin": vin,
                            "lang": (!_.isEmpty(user)) ? user.language:null,
                            "localDate": formattedCurrentDate,
                            "purgeDate": formattedDateAfter10Years
                        }
                    }


                    if (!file.$error) {
                        $scope.delete=false;    
                        var url = ActisConstantes.endpoint.listCase + "FR";
                        var itemObject = {};

                        RestUpgrade.all(url).post(body).then(function (response) {

                            //Check if url from S3 is valid
                            if (response && response.temporaryUrl) {
                                $scope.rDocId = response.rDocId;
                                $scope.fileName = response.fileName;
                                $scope.fileType = response.fileType;
                                itemObject['rDocId'] = $scope.rDocId;
                                itemObject['fileName'] = $scope.fileName;
                                itemObject['fileType'] = $scope.fileType;
                                itemObject['file'] = $scope.file;

                                $scope.rDocIdsAndFileNames.push(itemObject);

                                $scope.isLoading = true;

                                var httpPutPromise = $http({
                                    method: 'PUT',
                                    url: response.temporaryUrl,
                                    headers: { 'Content-Type': undefined },
                                    data: $scope.file,
                                    transformRequest: [],
                                    timeout: cancelDefer.promise,
                                    eventHandlers: {
                                        progress: function (event) {
                                            $scope.onLoading = 0;
                                        }
                                    },
                                    uploadEventHandlers: {
                                        progress: function (e) {
                                            if (e.lengthComputable) {

                                                $scope.onLoading = Math.round((e.loaded / e.total) * 90);
                                                return $scope.onLoading;
                                            }
                                        }
                                    }
                                })
                                    .then(function () {

                                        var times = 5;
                                        var promise = $interval(
                                            function () {
                                                var retry = 5 - (times++);
                                                CreateActisBusinessService.getDocInfoByRdocId($scope.rDocId).then(function (response) {
                                                    if (response.scannedStatus === ActisConstantes.attachment_scannedStatus_ok) {
                                                        $interval.cancel(promise);
                                                        promise = null;
                                                    }
                                                }).catch(function () {
                                                    $log.debug($translate.instant('ERROR'));
                                                });

                                                if (retry == 5) { //cancel in 30 seconds instead .. for some reason

                                                    var url = ActisConstantes.endpoint.wiredRDocId + $scope.rDocId;
                                                    CreateActisBusinessService.close(url).then(function (response) {
                                                        //delete fic from the UI specificaly with index zero and true
                                                        $scope.close($scope.file, 0, true);
                                                        toastr.error($translate.instant('ACTIS_ERROR_UPLOAD'));

                                                    }).finally(function () {
                                                        $interval.cancel(promise);
                                                        promise = null;
                                                    });
                                                }
                                            }, 5000, 5);
                                        intervals.push(promise);
                                        return $scope.onLoading = 100;

                                    })
                                    .finally(function () {
                                        $scope.isLoading = false;
                                    });

                                putRequests.push(httpPutPromise);
                            }
                        });
                    }
                }
                Array.prototype.push.apply($scope.filesToBeShown, $scope.files);
                $rootScope.$broadcast("fileAttachments", {
                    filesToBeShown: $scope.filesToBeShown,
                    rDocIdsAndFileNames: $scope.rDocIdsAndFileNames
                });
                $scope.filesToBeShown = _.uniqBy($scope.filesToBeShown, 'name');
            }
        };

        $scope.getFileData = function () {
            $rootScope.$broadcast('getFileData');
        };

        /**
         * @description Used to download a file on click of its' name
         * @param rDocId
         */
        $scope.downloadPdf = function (file, index) {
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0 && !file && (index || index == 0)) {
                vm.showCoTechFilesInAttachment.forEach(function (item) {
                    if (index == vm.showCoTechFilesInAttachment.indexOf(item)) {
                        var rDocId = item.rDocId;
                        var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                        CreateActisBusinessService.downloadPdf(url);
                    }
                })
            } else if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0) {
                $scope.rDocIdsAndFileNames.forEach(function (item) {
                    if (item.fileName === file.name && item.fileType === file.type) {
                        var rDocId = item.rDocId;
                        var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                        CreateActisBusinessService.downloadPdf(url);
                    }
                })
            } else {
                var rDocId = file.rDocId;
                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                CreateActisBusinessService.downloadPdf(url);
            }
        }

        /**
         * @namespace close
         * @desc remove line from attachment list
         * @param {index} file index in list
         */

        $scope.close = function (file, index, isFromManageFicPage) {
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0 && (index || index == 0) && !isFromManageFicPage) {
                if (index === vm.showCoTechFilesInAttachment.length - 1) {
                    cancelDefer.resolve("cancelled");
                    cancelDefer.reject();  // Reject just in case
                    cancelDefer = $q.defer();
                    $scope.isLoading = false;
                    $scope.onLoading = 0;
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                        vm.showCoTechFilesInAttachment.forEach(function (item) {
                            if (index === vm.showCoTechFilesInAttachment.indexOf(item)) {
                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url);
                            }
                        });
                    }
                    vm.showCoTechFilesInAttachment.splice(index, 1);
                } else {
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                        vm.showCoTechFilesInAttachment.forEach(function (item) {
                            if (index === vm.showCoTechFilesInAttachment.indexOf(item)) {
                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url);
                            }
                        });
                    }
                    vm.showCoTechFilesInAttachment.splice(index, 1);
                }
            } else if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0 && isFromManageFicPage) {
                if (file === $scope.filesToBeShown.length - 1) {
                    cancelDefer.resolve("cancelled");
                    cancelDefer.reject();  // Reject just in case
                    cancelDefer = $q.defer();
                    $scope.isLoading = false;
                    $scope.onLoading = 0;

                    // Select the correct file and create the URL according to its RDocId and call the service
                    if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0) {
                        $scope.rDocIdsAndFileNames.forEach(function (item) {
                            if (item.file === file) {

                                var removedIndex = $scope.rDocIdsAndFileNames.indexOf(item);

                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url).then(function () {

                                    if (removedIndex > -1) {
                                        $scope.rDocIdsAndFileNames.splice(removedIndex, 1);
                                    }
                                });
                            }
                        });
                    }
                    $scope.filesToBeShown.splice(file, 1);
                } else {
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length) {
                        $scope.rDocIdsAndFileNames.forEach(function (item) {
                            if (item.file === file) {

                                var removedIndex = $scope.rDocIdsAndFileNames.indexOf(item);

                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url).then(function () {

                                    if (removedIndex > -1) {
                                        $scope.rDocIdsAndFileNames.splice(removedIndex, 1);
                                    }
                                });
                            }
                        });
                    }
                    $scope.filesToBeShown.splice(index, 1);
                    $scope.delete =true;
                }
            }
            else{
                $scope.filesToBeShown.splice(index, 1);
                $scope.delete = true;
            }
        };

        /**
         * @namespace saveFicHeader
         * @desc throws pop-in whether user wants to save or send an Actis form when a file upload is running.
         */


        function saveFicHeader(isUpdate) {

            $scope.getFileData();

            if ($scope.isLoading) {

                var body = angular.element(document.body);

                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FILE_UPLOAD_MESSAGE",
                    ref: ''
                };

                ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });

            } else {
                vm.saveFic(isUpdate);
            }
        }

        }
})();

(function () {

    angular
        .module('phenix')
        .component('qstomizeDetails', {
            bindings: {
                type: '@',
                isDraft: '<',
                isForQstomize: '<',
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isFicCancelled: '<',
                isFicReopen: '<',
                isActisFromDiag: '<',
                isStatusPresent: '<',
                saveFic: '<',
                onDeleteFic: '<',
                isSaveButtonVisible: '<',
                isForBwr: '<',
                isForPaint: '<',
                isForAccessories: '<',
                isIndependentUser: '<'
            },
            controller: qstomizeDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/qstomize-details.template.html'
        });

    function qstomizeDetailsController(ActisConstantes, $scope, $translate, $state, MainMetierService) {

        var vm = this;
        vm.isRequestOpen = false;
        vm.qstomizeRequestReason = ActisConstantes.qstomizeRequestReason;
        vm.showCirDemand2field = true;
        vm.changeRequestType = changeRequestType;
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
        vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';
        $scope.$on('getFicData', function(event) {
            $scope.$emit("loadFicData", $scope.getFicDetails());
        });

        $scope.getFicDetails = function(){
            var type = "QSTOMIZE";
            changeRequestType();
            return {
                "Request": {
                    "cirDemand1": vm.selectedRequestType ? vm.selectedRequestType.id: "" ,
                    "cirDemand2": vm.selectedSubCategory ? vm.selectedSubCategory: "",
                    "customerComplaint": vm.customerComplaint ? vm.customerComplaint: ""
                },
                "CaseDetail": {
                    "recordType": type
                }
            };

        }

        function changeRequestType() { 
            if ((vm.selectedRequestType && vm.selectedRequestType.id) === vm.qstomizeRequestReason[4].id) {
                vm.showCirDemand2field = false;
                vm.selectedSubCategory = "null";
            }
            else{
                vm.showCirDemand2field = true;
            }
        }

        this.$onChanges = function () {

            if(vm.responseApi && vm.isEditMode){
                var localLang = $translate.use();
                vm.selectedRequestType = _.find(vm.qstomizeRequestReason,function(item){
                    if(vm.responseApi && vm.responseApi.Request){
                        if(vm.responseApi.Request.cirDemand1){
                            $translate.use('en');
                            if(_.includes(vm.responseApi.Request.cirDemand1,'_') ? (item.id.toLowerCase() === vm.responseApi.Request.cirDemand1.toLowerCase())
                                 : ($translate.instant(item.id).toLowerCase() === vm.responseApi.Request.cirDemand1.toLowerCase())){
                                return item.id;
                            }
                        }
                    }
                });
                $translate.use(localLang);
                if(vm.responseApi.Request.cirDemand1Label === "TECHNICAL_ASSISTANCE"){
                    vm.selectedSubCategory = "null";
                }
                else{
                    if(vm.responseApi.Request.cirDemand2){
                        var localLang = $translate.use();
                        _.map(vm.qstomizeRequestReason,function(item){
                            _.map(item.value,function(val){
                                $translate.use('en');
                                if(_.includes(vm.responseApi.Request.cirDemand1,'_') ?  val.toLowerCase() === vm.responseApi.Request.cirDemand2.toLowerCase()
                                : $translate.instant(val).toLowerCase() === vm.responseApi.Request.cirDemand2.toLowerCase()){
                                    vm.selectedSubCategory = val;
                                    return vm.selectedSubCategory;
                                }
                            });
                        });
                    }
                }
                $translate.use(localLang);
                vm.customerComplaint = vm.responseApi.Request.customerComplaint;
            }
            if(_.isEmpty(vm.responseApi)){
                vm.isQstomizeTypeFic = false;
                vm.isQstomizeClosedFic = false;
            }
        }

        this.$onInit = function () {
            vm.isRequestOpen = ((vm.isDraft || vm.isForQstomize) && (!vm.nonModifiableFic && !vm.isLoadFic)) ? true : false;
        };
    }
})();
/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('paintingActis', {
            bindings: {
                nonModifiableFic: '<',
                isActisFromDiag: '<',
                isDraft: '<'
            },
            controller: GeneralActisComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/painting-actis.template.html'
        })

        function GeneralActisComponent() {
            var vm= this;
            vm.isPaintingActisOpen = false;
            vm.paintingQualities =[
                {id: 1, name: 'HS2'},
                {id: 2, name: 'Oxélia'},
                {id: 3, name: 'IxellTech'}
            ];
            vm.selectedPaintingQuality = {id: 1, name: 'HS2'};

            this.$onInit = function () {
                vm.isPaintingActisOpen = (vm.isDraft || vm.isActisFromDiag)? true : false;
            }
        }
})();

(function () {

    angular
        .module('phenix')
        .component('paintDetails', {
            bindings: {

            },
            controller: paintDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/paint-details.template.html'
        });

    function paintDetailsController(CacheService, ActisConstantes) {

        var vm = this;

        vm.carContext = CacheService.getCarContext();
        vm.paintRequestType = ActisConstantes.paintRequestType;
        vm.paintFunction = ActisConstantes.paintFunction;
        vm.requestType1 = false;
        vm.requestType2 = false;
        vm.requestType3 = false;
        vm.isManual = false;
        vm.ficStatus = 'draft';
        var requestType2 = ['PAINT_REQUEST_TYPE2', 'PAINT_REQUEST_TYPE3', 'PAINT_REQUEST_TYPE4'];
        var requestType3 = ['PAINT_REQUEST_TYPE5', 'PAINT_REQUEST_TYPE6', 'PAINT_REQUEST_TYPE7'];

        vm.changeRequestType = changeRequestType;
        vm.changeMode = changeMode;

        if (vm.carContext) {
            if (vm.carContext.vin) {
                vm.vin = vm.carContext.vin;
            }
            if (vm.carContext.model) {
                vm.model = vm.carContext.model;
            }
            if (vm.carContext.registrationNumber) {
                vm.registrationNumber = vm.carContext.registrationNumber;
            }
        }


        function changeRequestType() {
            if (vm.selectedRequestType === "PAINT_REQUEST_TYPE1") {
                vm.requestType1Enabled = true;
                vm.requestType2Enabled = false;
                vm.requestType3Enabled = false;
            } else if (requestType2.includes(vm.selectedRequestType)) {
                vm.requestType2Enabled = true;
                vm.requestType1Enabled = false;
                vm.requestType3Enabled = false;
            } else if (requestType3.includes(vm.selectedRequestType)) {
                vm.requestType3Enabled = true;
                vm.requestType1Enabled = false;
                vm.requestType2Enabled = false;
            }
        }

        function changeMode() {
            if (vm.isManual) {
                vm.vin = '';
            }
            else if (!vm.isManual) {
                vm.brand = '';
                vm.model = '';
                vm.year = '';
                vm.registrationNumber = '';
                vm.distance = '';
            }
        }
    }
})();
(function () {

    angular
        .module('phenix')
        .component('newAccessories', {
            bindings: {

            },
            controller: newAccessoriesController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/new-accessories.template.html'
        });

    function newAccessoriesController(CacheService, ActisConstantes) {

        var vm = this;

        vm.carContext = CacheService.getCarContext();
        vm.accessorieRequestType = ActisConstantes.accessorieRequestType;
        vm.paintFunction = ActisConstantes.paintFunction;
        vm.requestType1 = false;
        vm.requestType2 = false;
        vm.requestType3 = false;
        vm.isManual = false;
        vm.ficStatus = 'draft';
        var requestType2 = ['ACCESSORIE_REQUEST_TYPE2', 'ACCESSORIE_REQUEST_TYPE3', 'ACCESSORIE_REQUEST_TYPE4'];

        vm.changeRequestType = changeRequestType;
        vm.changeMode = changeMode;

        if (vm.carContext) {
            if (vm.carContext.vin) {
                vm.vin = vm.carContext.vin;
            }
            if (vm.carContext.model) {
                vm.model = vm.carContext.model;
            }
            if (vm.carContext.registrationNumber) {
                vm.registrationNumber = vm.carContext.registrationNumber;
            }
        }


        function changeRequestType() {
            vm.incidentTypeRequest = false;
            vm.fittingTypeRequest = false;
            vm.fittingSubCategory = false;
            if (vm.selectedRequestType.id === "ACCESSORIE_REQUEST_TYPE1") {
                vm.requestType1Enabled = true;
                vm.requestType2Enabled = false;
                vm.requestType3Enabled = false;
            } else if (requestType2.includes(vm.selectedRequestType.id)) {
                vm.requestType2Enabled = true;
                vm.requestType1Enabled = false;
                vm.requestType3Enabled = false;
                if(vm.selectedRequestType.id === "ACCESSORIE_REQUEST_TYPE3"){
                vm.incidentTypeRequest = true;
                }
                if(vm.selectedRequestType.id === "ACCESSORIE_REQUEST_TYPE4"){
                    vm.fittingTypeRequest = true; 
                        if(vm.selectedSubCategory === "FITTING_INSTRUCT"){
                            vm.fittingSubCategory = true;
                        }
                    }
            } else if (vm.selectedRequestType.id === "ACCESSORIE_REQUEST_TYPE5") {
                vm.requestType3Enabled = true;
                vm.requestType1Enabled = false;
                vm.requestType2Enabled = false;
            }
        }

        function changeMode() {
            if (vm.isManual) {
                vm.vin = '';
            }
            else if (!vm.isManual) {
                vm.brand = '';
                vm.model = '';
                vm.year = '';
                vm.registrationNumber = '';
                vm.distance = '';
            }
        }
    }
})();
/**
 * modalOnCloseFicController
 * @namespace Controller
 */
 (function () {
    angular.module('phenix').controller('modalOnCloseFicController', modalOnCloseFicController);

    function modalOnCloseFicController(
        $mdDialog,
        $window,
        $state,$rootScope,
        CacheService,
        CacheConstants,
        ActisConstantes,RoutesConstants ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;
        vm.newConfirm = newConfirm;
        vm.newCancel = newCancel;
        vm.clearSearchedSymptom = clearSearchedSymptom;
        vm.isFrCountry = ((CacheService.getUserProfile() || {}).country || '').toUpperCase() === 'FR';

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace onConfirm
         * @desc on confirm exit
         */
        function onConfirm() {
            $mdDialog.hide(ActisConstantes.YES);

            if(vm.searchRefBTNT){
                vm.searchRefBTNT(vm.searchRefBTNT.ref);
            }else
            if (vm.searchBTByNumber){
                vm.searchBTByNumber(vm.searchBTByNumber.ref);
            } else if (vm.searchNTByNumber){
                vm.searchNTByNumber(vm.searchNTByNumber.ref);
            }else if (vm.searchReference){
                clearSearchedSymptom();
                vm.searchReference(vm.searchReference.ref);
            }else if (vm.redirectionPage) {
                clearSearchedSymptom();
                if (vm.redirectionPage.displayParam){
                    $state.go(vm.redirectionPage.url, vm.redirectionPage.displayParam);
                }else {
                    $state.go(vm.redirectionPage);
                }
            }else if (vm.disconnect){
                vm.disconnect();
            }
            else {
                clearSearchedSymptom();
                CacheService.removeObject(CacheConstants.consultationFIC);
                if (!vm.isDocRedirect) {
                    $window.history.back();
                }
            }
            
        }

        function newConfirm(){
            $mdDialog.hide(ActisConstantes.YES);
        }

        function newCancel() {
            $mdDialog.cancel();
        }

        /**
         * @namespace onCancel
         * @desc on cancel exit
         */
        function onCancel() {
            $mdDialog.hide(ActisConstantes.NO);
        }

        /**
         * @namespace clearSearchedSymptom
         * @desc clear the searchedSymptom from context
         */
        function clearSearchedSymptom() {
            if($rootScope.previousState !== RoutesConstants.resultSearchByDiagnostic){
                CacheService.removeObject(CacheConstants.searchedSymptom);
            }
        }

    }

})();

/**
 * modalOnCloseFicController
 * @namespace Controller
 */
(function () {
    angular.module('phenix').controller('modalCancelUploadFileController', modalCancelUploadFileController);

    function modalCancelUploadFileController(
        $mdDialog,
        $window,
        $state,
        CacheService,
        CacheConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.onConfirm = onConfirm;
        vm.onCancel = onCancel;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @namespace onConfirm
         * @desc on confirm exit
         */
        function onConfirm() {
            $mdDialog.hide();
            
        }

        /**
         * @namespace onCancel
         * @desc on cancel exit
         */
        function onCancel() {
            $mdDialog.hide();
        }

    }

})();

/**
 * HeaderActisComponent
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('headerActis', {
            bindings: {
                isDraft: '<',
                nonModifiableFic: '<',
                isFicBeingModified: '<',
                isFicCreation : '<',
                isForBwr: '<',
                isForPaint: '<',
                isForAccessories:'<',
                isForQstomize:'<',
                isAlertFic:'<'
            },
            controller: HeaderActisComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/header-actis.template.html'
        });


    function HeaderActisComponent($window,
        FicViewListWSService,
        $mdDialog,
        $scope,
        $rootScope,
        CacheConstants,
        $translate,
        CacheService,
        CreateActisBusinessService,
        printPdfModalService,
        ActisConstantes,
        toastr, configConstantes,RoutesConstants,$log,UtilsMetierService, MainMetierService) {

        var vm = this;        
        vm.fic = {};
        vm.backToPrevious = backToPrevious;
        vm.close = close;        
        vm.printFicHeader = printFicHeader;
        var userProfile = CacheService.getUserProfile();
        vm.isActisFromDiag = CacheService.getObject(CacheConstants.isActisFromDiag);
        if(!vm.isActisFromDiag && userProfile && userProfile.userType && (userProfile.userType.toUpperCase() === "RNET") && !_.isEmpty(userProfile.rolesActis) && userProfile.rolesActis.length > 0){
            vm.isActisChatbotEnable = true;
        }
        vm.isChatBotDealerAccess = UtilsMetierService.isChatBotDealerAccess();
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.actisResponse = CacheService.getObject(CacheConstants.actisResponse);
        vm.isIndependentUser = UtilsMetierService.isIndependentUser();
        var CONSULTATION_FIC_EVENT = 'ACTIS_CONSULTATION_FIC_SYNC';
        vm.consultationFIC = getConsultationFICFromCache();
        init();
        /**
         * Broadcast getFicData to other component in order to retrieve/load the data from the component views
         */
        $scope.getFileData = function () {
            $rootScope.$broadcast('getFileData');
        };

        var destroyHandler = $rootScope.$on("loadAttachmentData", function (event, data) {
            $scope.isLoading = data;
        });

        var consultationSyncHandler = $rootScope.$on(CONSULTATION_FIC_EVENT, function (event, data) {
            if (!data) {
                return;
            }
            vm.consultationFIC = data;
        });

        $scope.$on('$destroy', destroyHandler);
        $scope.$on('$destroy', consultationSyncHandler);

        $rootScope.getFicData = function () {
            $rootScope.$broadcast('getFicData');
        };

        $rootScope.$on('loadFicData', function (event, data) {
            //Deep copy of the case view if it contains multiple object property
            for (var property in data) {
                // Case the property of data is not include in vm.fic we add it
                if (!vm.fic[property]) {
                    vm.fic[property] = data[property];
                } else { //On the other hand if property exist we copy the innerproperty inside
                    for (var innerProperty in data[property]) {
                        vm.fic[property][innerProperty] = data[property][innerProperty];
                    }
                }
            }
        });

        function getConsultationFICFromCache() {
            return CacheService.getObject(CacheConstants.consultationFIC);
        }

        function init(){
            var div = document.getElementsByClassName("embeddedServiceHelpButton");
            if (div.length > 0){
                if (($rootScope.currentState === RoutesConstants.manageFIC) || ($rootScope.currentState === RoutesConstants.ficConsultation)) {
                    div[div.length -1].classList.remove("hideChatbot");
                }
                else {
                    div[div.length -1].classList.add("hideChatbot");
                }
            }
        }

        /**
         * @namespace backToPrevious
         * @desc throws pop-in whether user wants to leave Create Actis page or not. It will land to the previous page that has been consulted.
         */

        function backToPrevious() {
            var previousState=$rootScope.previousState;

            var isFicBeingModified = vm.isFicBeingModified();
            var currentStatus = $translate.instant(FicViewListWSService.convertStatusToND($rootScope.currentStatus));

            // Get the fic data
            $rootScope.getFicData();
            var responseApi = CacheService.getObject(CacheConstants.actisResponse);
            if (responseApi && responseApi.Car && responseApi.Car.mileageUnit) {
                responseApi.Car.mileageUnit = responseApi.Car.mileageUnit.toUpperCase();
            }

            // Get the difference in response data and fic data
            var dataChanged = CreateActisBusinessService.deepDiffApiResultVsDataActisView(responseApi, vm.fic);
            dataChanged = CreateActisBusinessService.getDataChangedVerification(dataChanged);

            /**
             * Do not show the pop-in if the FIC has been registered and no information has been changed
             * or if the FIC is in the 'Sent' status, then the pop-in is not displayed.
             */
            if (isFicBeingModified && (((currentStatus !== $translate.instant('ACTIS_ALL_OTHER_STATUSES') && currentStatus !== $translate.instant('ACTIS_CLOSED')) && !_.isEmpty(dataChanged))
                || (_.isEmpty(currentStatus) && _.isEmpty(dataChanged)))) {

                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true
                })
                    .then(function (resp) {
                        if(vm.isForBwr && resp && resp === ActisConstantes.YES){
                            if(previousState === RoutesConstants.carSearch){
                                CacheService.removeObject(CacheConstants.contextCarRequest);
                                CacheService.removeObject(CacheConstants.getAllSymptoms);
                                CacheService.removeObject(CacheConstants.isActisFromDiag);
                                CacheService.removeObject(CacheConstants.searchedSymptom);
                                CacheService.removeObject(CacheConstants.consultationFIC);
                                vm.isFicCreation = false;
                            }
                            else{
                                CacheService.removeObject(CacheConstants.isActisFromDiag);
                                if(previousState !== RoutesConstants.resultSearchByDiagnostic){
                                    CacheService.removeObject(CacheConstants.searchedSymptom);
                                }
                                CacheService.removeObject(CacheConstants.consultationFIC);
                                vm.isFicCreation = false;
                            }
                        }
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
            } else {
                CacheService.removeObject(CacheConstants.searchedSymptom);
                CacheService.removeObject(CacheConstants.consultationFIC);
                $window.history.back();
            }

        }

        /**
         * @namespace close
         * @desc throws pop-in whether user wants to delete the created FIC or not.
         */

        function close() {
            $mdDialog.show({
                templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                controller: 'modalOnCloseFicController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true
            })
                .catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
        }


        function isBlank(value) {
            return _.isEmpty(value) && !_.isNumber(value) || _.isNaN(value);
        }
        
        function printFicHeader() {
            var profil = CacheService.getObject(CacheConstants.profil);
            var consultationFIC = getConsultationFICFromCache();
            var actisResponse = CacheService.getObject(CacheConstants.actisResponse) ?  CacheService.getObject(CacheConstants.actisResponse) : null;
            if(actisResponse && actisResponse.Request && actisResponse.Request.fisrtNodeName &&  actisResponse.Request.secondNodeName){
                _.extend(consultationFIC, {
                    "treeStructure":actisResponse.Request.fisrtNodeName + '>'+  actisResponse.Request.secondNodeName
                })
            }
            consultationFIC.language = profil.portal.label;
            var authorName = profil.firstName + " " + profil.lastName;
            var now = new Date();
            var minutes = now.getMinutes();
            var month = now.getMonth()+1;
            if(month<10){    month='0'+month;  }
            if (minutes.toString().length == 1) { minutes = '0' + minutes }
            consultationFIC.date = now.getFullYear()  + "-" + month + "-" +now.getDate() + " " + now.getHours() + ":" + minutes;
            if(vm.isForQstomize){
                consultationFIC.ficType = actisResponse.CaseDetail.recordType;
                consultationFIC.cirDemand1 = actisResponse.Request.cirDemand1;
                consultationFIC.cirDemand2 = actisResponse.Request.cirDemand2;
                consultationFIC.customerComplaint = actisResponse.Request.customerComplaint;
            }

            var data = {
                translatedLabels:
                {
                    actisDate: $translate.instant("CIR_DETAILS"),
                    generalTitle: $translate.instant("ACTIS_GENERAL_TITLE"),
                    ficType: $translate.instant("ACTIS_GENERAL_TYPE"),
                    immobilizedVehicle: $translate.instant("ACTIS_GENERAL_IMMOBILIZED_VEHICLE"),
                    ficNumber: $translate.instant("FIC_NUMBER"),
                    status: $translate.instant("ACTIS_GENERAL_STATUS"),
                    creator: $translate.instant("ACTIS_GENERAL_CREATOR"),
                    phone: $translate.instant("ACTIS_GENERAL_PHONE"),
                    vehicle: $translate.instant("ACTIS_SAVE_VEHICLE_TITLE"),
                    vehicleInfo: $translate.instant("FIC_VEHICLE_INFO"),
                    vehicleVin: $translate.instant("ACTIS_VEHICLE_VIN"),
                    immatriculation: $translate.instant("ACTIS_VEHICLE_IMMAT"),
                    distance: $translate.instant("ACTIS_VEHICLE_DISTANCE"),
                    transformedVehicle: $translate.instant("ACTIS_VEHICLE_TRANSFORMED_VEHICLE"),
                    description: $translate.instant("ACTIS_DESCRIPTION_TITLE"),
                    vehicleAccesoires: $translate.instant("ACTIS_VEHICLE_ACCESSOIRES"),
                    commonOrder: $translate.instant("COMMON_ORDER"),
                    vehicleBin: $translate.instant("ACTIS_VEHICLE_BIN"),
                    dateOr: $translate.instant("ACTIS_DESCRIPTION_DATE_OR"),
                    standardExchange: $translate.instant("STANDARD_EXCHANGE_LABEL"),
                    symptonCode: $translate.instant("ACTIS_DESCRIPTION_SYMPTOM_CODE"),
                    treeStructure:$translate.instant("LOCATION_ARBO"),
                    complaintReproduced: $translate.instant("ACTIS_DESCRIPTION_CUSTOMER_COMPLAINT_REPRODUCED"),
                    symptonDesignation: $translate.instant("ACTIS_DESCRIPTION_SYMPTOM_DESIGNATION"),
                    permanent: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_PERMANENT"),
                    intermittent: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_INTERMITTENT"),
                    cold: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_COLD"),
                    hot: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_HOT"),
                    stoppedCar: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_STOPPED_CAR"),
                    movingCar: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_MOVING_CAR"),
                    frequency: $translate.instant("ACTIS_DESCRIPTION_PROBLEM_FREQUENCY"),
                    diagnostic: $translate.instant("ACTIS_DESCRIPTION_DIAGNOTIC"),
                    consultedDocument: $translate.instant("ACTIS_DOCUMENT_CONSULTED"),
                    opecode: $translate.instant("ACTIS_DESCRIPTION_OPECODE"),
                    time: $translate.instant("ACTIS_DESCRIPTION_TIME"),
                    discussion: $translate.instant("ACTIS_DISCUSSION"),
                    customerComplaint: $translate.instant("ACTIS_DESCRIPTION_CUSTOMER_COMPLAINT"),
                    dtc1: $translate.instant("ACTIS_DESCRIPTION_DTC1"),
                    dtc2: $translate.instant("ACTIS_DESCRIPTION_DTC2"),
                    dtc3: $translate.instant("ACTIS_DESCRIPTION_DTC3"),
                    agreement: $translate.instant("ACTIS_AGREEMENT"),
                    agreementStatus: $translate.instant("ACTIS_AGREMENT_STATUS"),
                    agreementDesignation: $translate.instant("ACTIS_AGREMENT_DESIGNATION"),
                    agreementIntervention: $translate.instant("ACTIS_AGREMENT_INTERVENTION"),
                    agreementPieces: $translate.instant("ACTIS_AGREMENT_PIECES"),
                    agreementMo: $translate.instant("ACTIS_AGREMENT_MO"),
                    identificationPiece: $translate.instant("ACTIS_AGREMENT_IDENTIFICATION_PIECE"),
                    autorisation: $translate.instant("ACTIS_AGREMENT_AUTORISATION"),
                    piecesJointes: $translate.instant("ACTIS_ATTACHMENT_TITLE"),
                    date: $translate.instant("CAR_SPLITS_DATE"),
                    confidential: $translate.instant("ACTIS_CONFIDENTIAL"),
                    fileName: $translate.instant("ACTIS_FILENAME"),
                    model: $translate.instant("ACTIS_VEHICLE_MODEL"),
                    ro:$translate.instant("ACTIS_DESCRIPTION_OR"),
                    cirNumber:$translate.instant("ACTIS_GENERAL_NUMBER"),
                    openDate:$translate.instant("ACTIS_GENERAL_OPENDATE"),
                    closeDate:$translate.instant("ACTIS_GENERAL_CLOSEDATE"),
                    frequencyOfProblem:$translate.instant("ACTIS_DESCRIPTION_FREQUENCY_OF_PROBLEM"),
                    confidentialRenault:$translate.instant("ACTIS_DESCRIPTION_CONFIDENTIAL_RENAULT"),
                    cirDemand1: $translate.instant("CIR_DEMAND1"),
                    cirDemand2: $translate.instant("CIR_DEMAND2"),
                    anonymousUser: $translate.instant("ANONYMOUS_USER"),
                    otsNumber: $translate.instant("ACTIS_DESCRIPTION_OTS"),
                    btNumber: $translate.instant("BT")

                },
                fic: consultationFIC

            };

            try {
                            
                var isCustomerComplaintReproduced = data.fic.isCustomerComplaintReproduced == true ? 'yes' : 'no';
                var isProblemFrequencyHot = data.fic.problemFrequencyHot == true ? data.translatedLabels.hot+' - ' : '';
                var isProblemFrequencyCold = data.fic.problemFrequencyCold == true ? data.translatedLabels.cold+' - ' : '';
                var isProblemFrequencyStoppedCar = data.fic.problemFrequencyStoppedCar == true ? data.translatedLabels.stoppedCar+' - ' : '';
                var isProblemFrequencyMovingCar = data.fic.problemFrequencyMovingCar == true ? data.translatedLabels.movingCar+' - ' : '';
                var otsNumber = data.fic.isDocumentationConsulted ? data.fic.isDocumentationConsulted : '';
                var otsColorCode = '';
                var otsColor = '';
                if (otsNumber) {
                    var otsColorCodes = CreateActisBusinessService.getOtsColorData();
                    otsColorCodes ? otsColorCode = otsColorCodes[otsNumber] : '';
                    if (otsColorCode === 'R') {
                        otsColor = 'red';
                    }else if (otsColorCode === 'B') {
                        otsColor = 'blue';  
                    }else if (otsColorCode === 'J') {
                        otsColor = 'yellow';  
                    }else if (otsColorCode === 'V') {
                        otsColor = 'green';  
                    }else if (otsColorCode === 'S') {
                        otsColor = 'skyblue';  
                    }else if (otsColorCode === 'I') {
                        otsColor = 'peach';  
                    }else if (otsColorCode === 'O') {
                        otsColor = 'orange';  
                    }
                }
                
                var btNumber = data.fic.tintName ? data.fic.tintName : '';
                var isPermanent = data.fic.checkboxesPermanentOrIntermittentValue == 'Permanent' ? data.translatedLabels.permanent+' - ' : '';
                var isIntermittent = data.fic.checkboxesPermanentOrIntermittentValue == 'Intermittent' ? data.translatedLabels.intermittent+' - ' : '';
                
                if (data.fic.authorName){
                    authorName = data.fic.authorName;
                }

                
                
                var cirDemand1 = '';
                var cirDemand2 = '';

                if(consultationFIC.cirDemand1 != null){
                    cirDemand1 = $translate.instant(consultationFIC.cirDemand1);
                }
                if(consultationFIC.cirDemand2 != null){
                    cirDemand2 = $translate.instant(consultationFIC.cirDemand2);
                }

                var dtcCode1 = '';
                var dtcCode2 = '';
                var dtcCode3 = '';

                if (consultationFIC.dtcCode1 != null){
                    dtcCode1 = consultationFIC.dtcCode1;
                }
                if (consultationFIC.dtcCode2 != null){
                    dtcCode2 = consultationFIC.dtcCode2;
                }
                if (consultationFIC.dtcCode3 != null){
                    dtcCode3 = consultationFIC.dtcCode3;
                }

            vm.mergedCommentsAndPJ = [];
            if (data.fic.comments && data.fic.comments.length > 0) {
                data.fic.comments.forEach(function (item) {
                    item.dateToOrderCommentsAndPJ = item.commentDate;
                    vm.mergedCommentsAndPJ.push(item);
                });
            }
            if (data.fic.attachments && data.fic.attachments.length > 0) {
                data.fic.attachments.forEach(function (item) {
                    item.dateToOrderCommentsAndPJ = item.localDate;
                    vm.mergedCommentsAndPJ.push(item);
                })
            }

            if (vm.mergedCommentsAndPJ && vm.mergedCommentsAndPJ.length > 0) {
                vm.mergedCommentsAndPJ.sort(function (a, b) {
                    return new Date(a.dateToOrderCommentsAndPJ) - new Date(b.dateToOrderCommentsAndPJ);
                }).reverse();
            }

            var commentList =[];
            var mergedList = [];
            var count = -1;
            var isAdded = false;
            var groupName = "Group Name";

            for (var i=0; i< vm.mergedCommentsAndPJ.length ; i++){
                if(vm.mergedCommentsAndPJ[i].commentDate){
                    
                    var commentDate = vm.mergedCommentsAndPJ[i].commentDate;
                        var commentName = (consultationFIC && consultationFIC.closureReason === "Rejected")
                            ? (data && data.translatedLabels && data.translatedLabels.anonymousUser ? data.translatedLabels.anonymousUser : '')
                            : (vm.mergedCommentsAndPJ[i].commentAuthorFirstName ? vm.mergedCommentsAndPJ[i].commentAuthorFirstName : '') + " " + (vm.mergedCommentsAndPJ[i].commentAuthorLastName ? vm.mergedCommentsAndPJ[i].commentAuthorLastName : '');
                        var commentBody = vm.mergedCommentsAndPJ[i].commentBody;

                        var liListIncrement = commentBody;
                        var listCommentBody = !_.isEmpty(liListIncrement) && liListIncrement.includes('<ol>') && !_.isEmpty(liListIncrement.split('<ol>')) ? liListIncrement.split('<ol>')[1] : "";
                        commentBody = commentBody.replace(/<b>/gm, "");
                        commentBody = commentBody.replace(/<\/b>/gm, "");
                        commentBody = commentBody.replace(/<i>/gm, "");
                        commentBody = commentBody.replace(/<\/i>/gm, "");
                        commentBody = commentBody.replace(/<u>/gm, "");
                        commentBody = commentBody.replace(/<\/u>/gm, "");
                        commentBody = commentBody.replace(/<p>/gm, "\n");
                        commentBody = commentBody.replace(/<\/p>/gm, "");
                        commentBody = commentBody.replace(/&#39;/gm, "'");
                        commentBody = commentBody.replace(/<s>/gm, "\u0336");
                        commentBody = commentBody.replace(/<\/s>/gm, "\u0336");
                            
                        if(!_.isEmpty(commentBody)){
                            var tempDiv = document.createElement('div');
                            tempDiv.innerHTML = commentBody;
                            var ulElements = tempDiv.querySelectorAll('ul');
                            ulElements.forEach(function(ul) {
                              var liElements = ul.querySelectorAll('li');
                              var newContent = '';
                              liElements.forEach(function(ulList) {
                                newContent += '• ' + ulList.textContent + '\n';
                              });
                              ul.innerHTML = newContent;
                            });
                        }
                        if(!_.isEmpty(commentBody)){
                            commentBody = commentBody.split('<ol>')[0];
                        }
                        if(!_.isEmpty(listCommentBody)){
                            var liPrintTags = listCommentBody.split('</li>');
                            if(listCommentBody.includes('</ol>')){
                                if(!_.isEmpty(liPrintTags)){
                                    liPrintTags = liPrintTags.slice(0, liPrintTags.length-1);
                                }
                            }
                            liPrintTags.forEach(function(list, index){
                                if(!_.isEmpty(list)){
                                    list = list.replace(/<p>/gm, "");
                                    list = list.replace(/<\/p>/gm, "");
                                    list = list.replace(/<li>/gm, "");
                                    list = list.replace(/<\/li>/gm, "");
                                    commentBody += (index+1) + "\u002E" +list+ "\n";
                                }
                                commentBody = commentBody.replace(/<p>/gm, "").replace(/<\/p>/gm, "\n");
                                commentBody = commentBody.replace(/<b>/gm, "").replace(/<\/b>/gm, "");
                                commentBody = commentBody.replace(/<ul>/gm, "").replace(/<\/ul>/gm, "");
                                commentBody = commentBody.replace(/<ol>/gm, "").replace(/<\/ol>/gm, "");
                                commentBody = commentBody.replace(/<li>/gm, "").replace(/<\/li>/gm, "");
                                commentBody = commentBody.replace(/<i>/gm, "").replace(/<\/i>/gm, "\n");
                                commentBody = commentBody.replace(/<u>/gm, "").replace(/<\/u>/gm, "");
                                commentBody = commentBody.replace(/&#39;/gm, "'");
                                commentBody = commentBody.replace(/&[a-zA-Z0-9#]+;/g, "")
                            });
                        }    
                        if (commentBody.includes(groupName)){
                                if (vm.mergedCommentsAndPJ[i].lines[0].includes(groupName)){
                                    var removeGroupName = vm.mergedCommentsAndPJ[i].lines[0].length;
                                    commentBody = commentBody.substring(removeGroupName);
                                }
                                else if (vm.mergedCommentsAndPJ[i].lines[1].includes(groupName)){
                                    var removeGroupName = vm.mergedCommentsAndPJ[i].lines[1].length;
                                    commentBody = commentBody.substring(removeGroupName);
                                }                         
                        }
                        else if (commentBody.includes("Comment by cotech")){
                            var removeName ="Comment by cotech : "+ vm.mergedCommentsAndPJ[i].commentAuthorFirstName + " " + vm.mergedCommentsAndPJ[i].commentAuthorLastName;
                            commentBody = commentBody.replace(removeName, '');
                            commentBody = commentBody.substring(2);
                        }
                        var keyword=commentDate.toString();
                        var date=keyword.split(" ");
                        var date1 = date[0];
                        var date2=date[1];
                        var authlevel=vm.mergedCommentsAndPJ[i].commentAuthorLevel

                        var  checkDealerComment=isBlank(authlevel);

                        var checkSalesforceMsg = "Salesforce Platform";
                        var checkAutocloseMsg = "Automatic Closure";
                        var commentDateStr=date1+"        "+date2;
                        
                        commentList.push([{ text: "\n" + commentName +"        "+ commentDateStr + "\n\n", bold: true ,alignment:'left', fontSize: 9, italics:commentName.includes(checkSalesforceMsg)? true: false}, 
                                        { text: commentBody + "\n\n\n",alignment:'left',fontSize: 9,italics:commentBody.includes(checkAutocloseMsg)? true: false },
                                         ]);
                        if (mergedList.length < 1){
                            mergedList = commentList;
                        }
                        else if (mergedList.length > 0 && isAdded) {
                            mergedList.push([{ text: "\n" + commentName +"        "+ commentDateStr + "\n\n", bold: true ,alignment:'left', fontSize: 9}, 
                            { text: commentBody + "\n\n\n",alignment:'left',fontSize: 9 }])
                        }
                        count = commentList.length - 1;

                }
                if (vm.mergedCommentsAndPJ[i].localDate){
                   
                    if (count >= 0 ){
                        mergedList[count].push(
                            { text: vm.mergedCommentsAndPJ[i].fileName + " \t" + vm.mergedCommentsAndPJ[i].localDate +"\n", fontSize:9,alignment:'center',lineHeight:1.3 }
                        )
                    }
                    else if(mergedList.length <1){
                        isAdded = true;
                        mergedList.push([
                            { text: vm.mergedCommentsAndPJ[i].fileName + " \t" + vm.mergedCommentsAndPJ[i].localDate +"\n", fontSize:9,alignment:'center',lineHeight:1.3 }
                        ])
                    }
                    else if (count < 0  && mergedList.length > 0){
                        isAdded = true;
                        mergedList[0].push(
                            { text: vm.mergedCommentsAndPJ[i].fileName + " \t" + vm.mergedCommentsAndPJ[i].localDate +"\n", fontSize:9,alignment:'center',lineHeight:1.3 }
                        )
                    }
                    
                }
            }
                

                if (profil && profil.language == 'ko'){
                    var sansRegularFont = 'NotoSansKR-Regular.otf';
                    pdfMake.fonts = {
                        arialunicodems: {
                            normal: sansRegularFont,
                            bold: 'NotoSansKR-Bold.otf',
                            italics: sansRegularFont,
                            bolditalics: sansRegularFont
                        }
                    }
                }
                else{
                    pdfMake.fonts = {
                        arialunicodems: {
                            normal: 'Roboto-Regular.ttf',
                            bold: 'Roboto-Medium.ttf',
                            italics: 'Roboto-Italic.ttf',
                            bolditalics: 'Roboto-MediumItalic.ttf'
                        }
                    }
                }
            
                var immatriculation=isBlank(data.fic.immatriculation)?' ':'/'+data.fic.immatriculation;

                var frequencyProblem=isPermanent+isProblemFrequencyHot+isIntermittent+isProblemFrequencyCold+isProblemFrequencyStoppedCar+isProblemFrequencyMovingCar;
                frequencyProblem=frequencyProblem.substring(0,frequencyProblem.length-2);

                var immobilizedVehicle=data.fic.isVehicleImmobilised == true ? data.translatedLabels.immobilizedVehicle:'';
                var vehicleAccesoires=data.fic.vehicleAccesoires == true ? data.translatedLabels.vehicleAccesoires:'';
                var transformedVehicle=(!vm.isForQstomize && data.fic.isVehicleTransformed == true) ?data.translatedLabels.transformedVehicle:'';


                var dd = {
                    info: {
                        title: 'Actis - ' + data.fic.ficNumber
                    },


                    footer: function(currentPage, pageCount) {
                         {
                             return {
                                 margin:5,
                                 columns: [
                                 {
                                     fontSize: 8,
                                     text:[
                                     {                                       
                    
                                     },
                                     {
                                     text: [{text:'                  ' + data.translatedLabels.confidentialRenault+'                                                                                           ' ,fontSize: 8}   ,                                            
                                        { text:'Page ' + currentPage.toString() + ' / ' + pageCount,bold:true}],
                                     }
                                     ],
                                     alignment: 'right'

                                 }
                                 ]
                             };
                        }
                     },

                     header: {
                        columns: [ 
                            '',
                            { 
                                text: 'CIR : '+data.fic.ficNumber + '-' +data.translatedLabels.vehicle +' : '+ data.fic.vehicleVin+immatriculation+' ',fontSize: 8,
                                alignment: 'right'
                            }
                        ],
                        margin: [0, 20, 10, 5]  
                    },

                    content: [
                       
                        {
                            text: [data.translatedLabels.actisDate+ ' : ' ,{text: consultationFIC.date,  italics: true} ],
                            style: 'header1',
                        },
                        {
                            text: [
                                { text: '\nI', fontSize: 12, bold: true, color: 'var(--renaultPrimaryColor)' },
                                {text: data.translatedLabels.cirNumber+" : "+data.fic.ficNumber },
                                {text:'\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t STATUS'+" : "+data.fic.status, preserveLeadingSpaces: true,alignment:'right'},
                            ],
                            style: 'header',
                        },
                        
                        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                        {
                            alignment: 'justify',
                            columns: [
                                {
                                    width: '*',
                                    alignment: 'left',
                                    columns: [
                                        
                                        {
                                            width: '30%',
                                            alignment: 'left',
                                            stack: [
                                                {
                                                    style: 'h1',
                                                    text: [
                                                        {text: ['\n'+data.translatedLabels.ficType+ ' : ' , ]},                                                        
                                                        {text: ['\n'+data.translatedLabels.openDate+ ' : ' , ]},
                                                        {text: ['\n'+data.translatedLabels.closeDate+ ' : ' , ]},        
                                                        {text: ['\n'+data.translatedLabels.creator+ ' : ' , ]},
                                                        {text: ['\n'+data.translatedLabels.phone+ ' : ' , ]},
                                                        {text: ['\n'+data.translatedLabels.ro+ ' : ' , ]},
                                                        {text: ['\n'+data.translatedLabels.dateOr+ ' : ' , ]},
                                                        {text: '\n' + '   ' },
        
                                                    ]
                                                }
                                            ]
        
                                        },

                                        {
                                            width: '*',
                                            alignment: 'left',
                                            stack: [
                                                {
                                                    style: 'h1',
                                                    text: [
                                                        {text: '\n'+ consultationFIC.ficType,  bold: true },                                                        
                                                        {text: '\n'+ consultationFIC.creationDate.replace(' ', '          '),  bold: true},
                                                        {text: '\n'+ consultationFIC.closedDate.replace(' ', '          '),  bold: true},
                                                        {text: '\n'+ authorName,  bold: true},
                                                        {text: '\n'+ consultationFIC.phoneNumber,  bold: true},
                                                        {text:'\n' + consultationFIC.or,  bold: true},
                                                        {text: '\n'+ consultationFIC.dateOr,  bold: true},
                                                        {text: '\n'+ immobilizedVehicle, bold: true},
        
                                                    ]
                                                }
                                            ]
        
                                        },
                                        
                                    ]

                                },
                                {
                                    width: '*',
                                    alignment: 'left',
                                    columns: [
                                        
                                        {
                                            width: '50%',
                                            alignment: 'left',
                                            stack: [
                                                {
                                                    style: 'h1',
                                                    text: [
                                                        {text: ['\n'+data.translatedLabels.model+ ' : ' , ]},
                                                        {text: ['\n'+data.translatedLabels.immatriculation+ ' : ' ,]},
                                                        {text: ['\n'+data.translatedLabels.vehicleVin+ ' : ' ,]},
                                                        {text: ['\n'+data.translatedLabels.distance+ ' : ' , ]},
                                                        { text: '\n' + '          '  },
                                                        { text: '\n' + '          ' }
        
                                                    ],
                                                }
                                            ]
        
                                        },

                                        {
                                            width: '*',
                                            alignment: 'left',
                                            stack: [
                                                {
                                                    style: 'h1',
                                                    text: [
                                                        {text: '\n'+ consultationFIC.model,  bold: true},
                                                        {text: '\n'+ consultationFIC.immatriculation,  bold: true},
                                                        {text: '\n'+consultationFIC.vehicleVin,  bold: true},
                                                        {text: '\n'+consultationFIC.mileageValue+ " " + consultationFIC.mileageUnit,  bold: true},
                                                        {text:'\n'+ transformedVehicle,  bold: true},
                                                        {text: '\n'+ vehicleAccesoires,  bold: true},
        
                                                    ]
                                                }
                                            ]
        
                                        },
                                        
                                    ]
                                },
                            ],
                            columnGap: 3,
                        },
                        {
                            text: [
                                { text: '\nI', fontSize: 12, bold: true, color: 'var(--renaultPrimaryColor)' },
                                {text: data.translatedLabels.customerComplaint+" : "+data.fic.customerComplaint},
                            ],
                            style: 'header',
                        },
                        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                        {
                            alignment: 'justify',
                            style: 'h1',
                            text: '\n' + data.translatedLabels.diagnostic + ' : \n' + data.fic.diagnosticComment,
                            lineHeight: 1.1,
                            
                        },
                        {
                            style: 'tableExample',
                            table: {
                                widths: [150,  350],
                                body: [
                                    [{text: [data.translatedLabels.standardExchange+ ' : ' ]}, {text:actisResponse.Request.reference,  bold: true }],
                                    [{text: [data.translatedLabels.symptonCode+ ' : ' ]}, {text:consultationFIC.symptonCode,  bold: true }],
                                    [{text: [data.translatedLabels.symptonDesignation+ ' : ' ]}, {text:data.fic.symptomLabel.length > 0 ? data.fic.symptomLabel: '',  bold: true}],
                                    [{text: [data.translatedLabels.treeStructure + ' : ' ]}, {text: consultationFIC.treeStructure ? consultationFIC.treeStructure : ' ',  bold: true }],
                                    [{text: [data.translatedLabels.complaintReproduced+ ' : ' ]}, {text:isCustomerComplaintReproduced,  bold: true}],
                                    [{text: [data.translatedLabels.frequencyOfProblem+ ' : ' ]},{text:frequencyProblem,  bold: true}],
                                    [{text: [data.translatedLabels.frequency+ ' : ' ]}, {text: data.fic.frequenceProbleme?data.fic.frequenceProbleme:'',  bold: true}],
                                    [{text: [data.translatedLabels.otsNumber+ ' : ' ]}, {text: (consultationFIC.isDocumentationConsulted && consultationFIC.isDocumentationConsulted !== 'No' && consultationFIC.isDocumentationConsulted !== '' && otsColor !=='') ? '(' + otsColor + ') ' + consultationFIC.isDocumentationConsulted : (consultationFIC.isDocumentationConsulted || ''),  bold: true}],
                                    [{text: [data.translatedLabels.btNumber+ ' : ' ]},{text:consultationFIC.tintName,  bold: true}],
                                    [{text: [data.translatedLabels.opecode+ ' : ' ]}, {text: !vm.isAlertFic ? consultationFIC.opecode : "-",  bold: true}],
                                    [{text: [data.translatedLabels.time+ ' : ' ]}, {text: !vm.isAlertFic ? consultationFIC.time : "-",  bold: true}],
                                    [{text: [data.translatedLabels.cirDemand1+ ' : ' ]}, {text:cirDemand1,  bold: true}],
                                    [{text: [data.translatedLabels.cirDemand2+ ' : ' ]}, {text:cirDemand2,  bold: true}],
                                    [{text: [data.translatedLabels.dtc1+ ' : ' ]}, {text:dtcCode1,  bold: true}],
                                    [{text: [data.translatedLabels.dtc2+ ' : ' ]}, {text:dtcCode2,  bold: true}],
                                    [{text: [data.translatedLabels.dtc3+ ' : ' ]}, {text:dtcCode3,  bold: true}]
                                ]
                            },
                            layout: 'noBorders'
                        },
                       
                        
                        {
                            columns: [
                                
                            ]
                        },

                        {
                            columns: [
                                
                            ]
                        },

                        {
                            columns: [
                               
                                ]
                        },

                        {
                            columns: [
                               
                            ]
                        },

                      
                        {
                            text: [
                                { text: '\nI', fontSize: 12, bold: true, color: 'var(--renaultPrimaryColor)' },
                                data.translatedLabels.discussion + '\n',
                            ],
                            style: 'header',
                        },
                        { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},

                                               
                    ],
                    
                    images: {
                        checkboxInActive: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAyMDowMToxNCAxMDo1Mzo0NusczIsAAABxSURBVEhL7ZZRCsAgCIZ1J6r7H0JvtC0Q9qDBaOke9HvJQPowfig8byCYQ9ZQfpGq6+29S7UHIpLqQUkR0WxcYQxgRcaUWo0rzM7KE6SSulJSV0rqSkldySM1H/HWmuy+wczvfg6jcSfWAEoaQZYgAVzE1zQUfg0csAAAAABJRU5ErkJggg==',
                        checkboxActive: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAIESURBVFhH7ZbNygFRGMdHoohY4AJkh6WNjy22ytYV2LgBH2WhyE1RFhZcAVLylchHNuL/9pyc0owxc8Z4bfzqKdM05//rnOccR8KX+QkoBHq9Hjqdzseq2+3icrnc02QCt9sNwWAQPp/vY+X3+7Hb7e6JTwS8Xi8kSUK1WkWj0TC1HA4HG3u73d4TVQSy2SxWqxWGwyFGoxEOhwNOp5OhmkwmGAwG2O/3yOfzsNvt2gK5XA7z+RyxWAzJZJINQu9EWa/XyGQyiEQimM1mKBQK+gWOxyPa7Tbcbjfi8biwBA+naa/Vajifz2ICfApbrRZcLpeQxGN4pVLBZrNh3wkLEKISauGEIQFCr8SrcMKwAEHPzWaT9UQikVBIPIaXy2VFOPGWACGXGI/H7Bs94cTbAoRcot/vI51Oa4YTpggQjxKBQIANqhVOmCZAUA94PB52tFLRqXm9Xu9vn2OaAF9zm82GUCgEq9XKdgfvCTVMEZA33HQ6fdqYz3hbQK3b6djWI/GWgNZW0yNhWEDvPteSMCSgN5zzSkJYQDScoyYhJLBYLNjNSDScI5egC46QAA1QKpVQr9eFwzlcolgsst/CS0C3V7oPGgnnUDAF0hi6BZxOJ8LhMKLRqKlF9wmLxaIuQFDT0ZqlUinTi49Ls8pRCFDnL5fLj9bjn5ZC4L/5CXxZAPgDG1Eg0tmWkHAAAAAASUVORK5CYII=',
                        radioInActive: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAgCAYAAACYTcH3AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAQKSURBVFhH7Vc3SGxREJ01J0yFOWfFjFaijYggGLARWwsLsdPKVrEzNCq2FnYmtFAwNYIoKAoqopizYhaz82eGJ3x9+3b3rfvB4h8Q4d23886dO3PmXAMS4JfATvn/K/CfjBasrpmbmxs4PDyE5+dncHR0hODgYPD29gaDwaC8oR+6yGxtbcHIyAjMz8/DwcEBPDw8wMfHhxBwc3ODoKAgyMzMhOLiYoiLiwM7O32Jt4jM6ekpdHR0wOTkJOzu7oK7uzuEh4dDREQEuLq6wsvLizzf3t6Gu7s7IZWbmwu1tbUQFhZmMSmzZKampqClpUWykZKSAqWlpZCRkQE+Pj7g4eEB9vb2kp37+3u4vb2F5eVlGBwchIWFBUhKSoK6ujooLCwEBwcHJaIJMBktjI6OYnZ2NlI9YFNTEy4uLuL19TXSx5U31CBCuLKygq2trRgZGYnJycnY19eHlD3lDW1okpmdncWsrCwMDQ3F3t5ePDs7M0niOy4vL3FoaAhjYmKQMoTj4+P4+vqqrBqHUTK8+6KiIvT19RUiVAfKij48PT3h8PAwBgQEYF5eHlL3mdyQUTJtbW3o6emJDQ0NQuwnYELNzc0Sr7GxER8fH5UVNVRk+MxTU1MltZubm7qORgsnJydy5HxkR0dHmjFVPUdnKy1aUVEBISEhPxKxT/j7+0NlZSUcHx9L/Le3N2XlK1RkuJWp0KCsrEyU1VYoLy+X9p6enpb4xqAiw/oQGBgI1EW6FdQUOB7/cXyLM7OzswOkDzbNCoPFMTo6Gvb390UkjUFFhqpdlNUWtfIdHJfjU60qT75CRcbFxUUGoNYPfgIeGRxfa6MqMlFRUUAtDe/v78oT24A3t7GxIcNVqxZVT9PT0+H8/FymsNbZWgOWC9IbIA3THJoqMgUFBZLG/v5+zRa0BgMDA1IvHF+zOVj5/sbV1RWmpaVhfHw8UnZsosAXFxdIpgvJcOHe3p7lCszWsbq6Wiwl2QCg2aKsWI/29nZYX1+Hqqoq8PPz0+5UhdQXUM1gSUmJTNvu7m4kn6us6AdPfbYh+fn5SBqmf2ozyNkhFbMMt87OTpPT1hioG7Gnp0cGLh85jRnr/AyDf8gBmBC1O9bU1ODa2pp8xByoc7C+vl5qJCEhQTyNJZsx6YF5hszNzUFXVxeMjY2JnOfk5AClHOgjYrZZ5jkE3xa4Lti0z8zMwOrqKpChAtqE/IbFzhzMGnLWGr6iTExMSHuy4SYHKIVOhgmcnJxEAvhWQEYMyJ5CYmKiTH1uY76yWGTGCRbfm/hjPER590tLS6Km3HGcPVZUnvSxsbEiapw1HrZeXl66ZpzFZD7BdyTSIrlR8gzjscFk+BLHH+esOTs7K2/rg24y/w4AfwDNQbgHiCNGygAAAABJRU5ErkJggg==',
                        radioActive: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAgCAYAAACYTcH3AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAASvSURBVFhH7ZdpKKZdGMctUQjTMAgxTCjG7oOSIksmRErIkvhiK0TIEiWypPlgmVEKSaJmIqUoImWPkj179m3GMoxl/Kfr9MzreR/nfjzUW/Ph/dfpqft+7nN+51zX/7qvWw5/kf6HEdKLYG5vb7GwsICOjg5UVVWhoqIClZWV+Pr1K2ZmZnB9fS365/P0LJjDw0PU19cjKCgITk5OMDc3h6GhIfT19dmvmZkZ7O3t4e/vj5qaGmxvb+P+/l709NOSCYYm7OzshI+PD0xMTNiIiIhAcXExWlpa0N7ejra2NpSVlSEmJoZBGRsbw83NDa2trTKf1JMwNzc3KCwshJWVFdt9fn4+BgcHsbKygqOjI1xdXbH//Pz5E8fHx1hfX8fIyAhKSkpgamrKwDIyMnB2diaaUVhSYSg3aHEKg7u7O7q6urC/vy/T0RNof38/fH19oauri7S0NJyfn4vu8iUVpq6uDgYGBvD29sbExMSzE/Pu7g5zc3MIDAxkQB8/fmQnKCRBmNnZWVhaWrIxPj7OJn6p5ufnWcJTro2OjgrOJQgTHx8PNTU1lqCUEzydnJwwezc0NODLly84ODjghvCPAV69eoXIyEj8+PFDdOff4sKsra2xZPX09GR2llyAdlZdXQ0PDw9YWFjg7du3LFFdXV1RXl7OXezy8pKFS1tbG9PT0/j165fozoO4MFQjVFRU0NjY+OhUaBJyCh25oqIi5OTk/hny8vIs2XNycrhAVBTptEtLS7m5w4UJDw+Huro6NjY2Hp0KxZxAaGFxEPHx5s0b9Pb2MjeKi8Kqo6ODgIAAXFxciK4+iAvz/v172NracmtDUlISlJWVuRDiIzo6+tHp0MZcXFzw7t07fP/+XXT1QVwYov/w4QOX3sHBAQoKClwA8UGvitPTU9FTDwoODman/u3bN9GVB3FhtLS02PuFB0NWlwXGyMiIu/uwsDCWNxQySXFh6BidnZ25FTMkJARKSkpcAPFBlZf3PDmQklzmMPn5+TELkq0lRXWFdsYDEB/Nzc2PnEgVnE6MXi08UC5MQUEBs3Z3d/cjR1AePJXElLx7e3uPnDg0NAQNDQ2kp6ezuiMpLszk5CQ0NTUFq+Xm5iarJWRx8fyh409NTcXS0hK3qCUkJEBVVRUDAwPcVwIXhgoSxZxcRe0C78Hd3V0MDw/j06dPKCoqYp0eLbK1tcUFmZqaYiGiHodaDZ64MKS+vj6WN15eXlLbBqpFlFuUkEL/IVdSd0ghopyTDP0fCcJQ05Sbm8vCFRsby/oTocWkicKckpLCQJKTk5mlheYRhCHt7OwwEDqhqKgoLC4uckMgJHqdJCYmsudDQ0OxvLws9XmpMKTV1VXExcWxCamU19bWcp0iLtp9U1MTqymvX79mRqD+6KmNPAlDor728+fPrF0gB1ESZmZmsi8FStqxsTGW6ARAoaU8o8JJrQV9xgi5S1IywZCovlCdIOdQdSYbE5i1tTXs7OxgY2PDAPT09ODo6Ii8vDzWA0vLEUnJDEOiSck5ZNOenh5m6+zsbFbEsrKymL2paad+mUL5nPwiPQtGXARGtqZF6WON6g7Z+7kA4noxzH+hvwgG+A0SIvBlbS/39AAAAABJRU5ErkJggg==',
                    },
                    styles: {
                        header: {
                            fontSize: 10,
                            bold: true,
                        },
                        header1: {
                            fontSize: 10,
                            italics: true
                        },
                        h1: {
                            lineHeight: 1.3,
                            fontSize: 9,
                        },
                        lead: {
                            leadingIndent: 50
                        },
                        tableExample: {
                            lineHeight: 1.3,
                            fontSize: 9,
                            margin: [0, 5, 0, 15]
                        }
                    },
                    defaultStyle: {
                        columnGap: 30,
                        lineHeight: 1.1,
                        font:'arialunicodems'
                    }

                }                

                var discussion = [];

                for (var i=0; i < mergedList.length; i++){
                    var col1 = [
                        {unbreakable : true, text :mergedList[i], },
                        {canvas: [{ type: 'line', x1: 200, y1: 1,x2: 395-2*40, y2: 1,lineWidth: 1 }]}
                    ]
                    discussion.push(col1);

                }
                
                dd.content.push(discussion);

                
                var pdfDocGenerator = pdfMake.createPdf(dd);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([buffer], { type: 'application/pdf' });

                    // Internet Explorer 6-11
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;

                    // Edge 20+
                    var isEdge = !isIE && !!window.StyleMedia;

                    if (isIE || isEdge) {
                        //FileSaver.saveAs(file, $translate.instant("LOCATION_ESTIM") + ".pdf");
                        pdfDocGenerator.download('Actis - ' + data.fic.ficNumber + '.pdf');
                    } else {
                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }
                            return printPdfModalService.showModal(modalParams).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });
                        }).catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
                });
            }
            catch (error) {
                toastr.error($translate.instant('ERROR'));
            }
        }

        $scope.$on('$destroy', function() {
            var div = document.getElementsByClassName("embeddedServiceHelpButton");
            if (div.length > 0){
                if (($rootScope.currentState !== RoutesConstants.manageFIC) && ($rootScope.currentState !== RoutesConstants.ficConsultation)) {
                    div[div.length -1].classList.add("hideChatbot");
                }
            }
        });

    }
}

)();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('generalActis', {
            bindings: {
                onUpdateTypeFic: '<',
                onLoadPage: '<',
                isDraft: '<',
                saveFic: '<',
                isDeleteButtonVisible: '<',
                responseApi: '<',
                closedStatusFic: '<',
                isEditMode: '<',
                isForBwr: '<',
                isAnswered: '<',
                nonModifiableFic: '<',
                activateActisAccessoriesAndPaint: '<',
                loadFic: '<',
                isFicReopen: '<',
                isForPaint:'<',
                selectedFicTypeId: '<',
                isFicCancelled: '<',
                reOpenFic: '<',
                cancelFic: '<',
                isSendButtonVisible: '<',
                isIndependentUser:'<',
                isBrw:'<',
                isForAccessories:'<',                
                isActisFromDiag: '<',
                onDeleteFic: '<',
                isForQstomize: '<',
                isDiscussionCommentBox: '<',
                isSaveButtonVisible: '<',
                isDaysToReopen: '<'
            },
            controller: GeneralActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/general-actis.template.html'
        });

    function GeneralActisController(
        CacheService,
        CacheConstants,
        $state,
        $scope,
        $rootScope,
        FicInputValidationService,
        CreateActisBusinessService,
        blockUI,
        $translate,
        FicViewListWSService,
        ActisConstantes,
        UtilsMetierService,
        configConstantes,
        MainMetierService,
        ActisFicModalService,
        $mdDialog,$log) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;

        vm.general = {};
        vm.updateTypeFIC = updateTypeFIC;
        vm.createMotrioFic = false;
        vm.consultationFIC = {};
        vm.isIndependentUser = false;
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.splitString = splitString;
        vm.saveFicHeader = saveFicHeader;
        vm.closedStatusFic = closedStatusFic;
        vm.deleteFicHeader = deleteFicHeader;
        vm.reOpenFic = reOpenFic;
        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;
        vm.handleQstomize = handleQstomize;
        var userProfil = CacheService.getUserProfile();
        vm.isRnetUserType = MainMetierService.isRnetUserType(userProfil.userType);
        vm.isBrwDealer = UtilsMetierService.isActisProfil(userProfil);
        vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
        vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';
        vm.isQstomizeSentFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Sent';
        vm.statusOriginal = $state && $state.params && $state.params.data && $state.params.data.statusOriginal && $state.params.data.statusOriginal;
        vm.country = userProfil.country;
        vm.isSending = false;
        vm.actisResponse = CacheService.getObject(CacheConstants.actisResponse);
        var CONSULTATION_FIC_EVENT = 'ACTIS_CONSULTATION_FIC_SYNC';

        /*=============================================
       =                 FUNCTIONS                   =
       =============================================*/

        /**
         * Create a listener to listen from Actis.constoler (broadcast)
         * in order to call getGeneralData()
         */
        $scope.$on('getFicData', function (event) {
            $scope.$emit("loadFicData", $scope.getGeneralData());
        });
        $scope.getFileData = function () {
            $rootScope.$broadcast('getFileData');
        };

        $rootScope.$on("disableSendSave", function(event, data) {
                vm.disableSendSave = data.isDisabled;
        });
        /**
         * return Current data contained in the view at the moment
         * where the methode is called
         * @returns {*}
         */
        $scope.getGeneralData = function () {
            $rootScope.currentStatus = "";
            $rootScope.currentStatus = vm.status;

            return {
                "CaseDetail": {
                    "caseNumber": vm.numberFic,
                    "status": vm.status
                },
                'Dealer': {
                    "phoneNumber": vm.phone
                }
            }
        };

        // Used to call service method to remove css of 'Telephone' field
        this.removeColors = function () {
            FicInputValidationService.removeColors("phoneNumber");
        }
         $rootScope.$on("loadAttachmentData", function (event, data) {
            $scope.isLoading = data;
        });

        this.$onInit = function () {

            if ($state.params.isActisUserComingFromFicConsultation) {
                vm.createMotrioFic = true;
            }
            if(vm.isForQstomize || ($state.params && $state.params.data && $state.params.data.type == "QSTOMIZE") || ($state.params && $state.params.isForQstomize)){
                vm.ficType = ActisConstantes.QSTOMIZE_CIRS;
            }

            //Will load the data from NAT CASE API GET
            //Parameter gotten from listFicController
            if ($state.params.data && !vm.isForQstomize) {
                var caseParameters = $state.params.data;

                blockUI.start();
                CreateActisBusinessService.getFicByIdNumber(caseParameters).then(function (response) {
                    
                    var responseJson = response.result;
                    var recordType = responseJson.CaseDetail.recordType;

                    var profil = CacheService.getObject(CacheConstants.profil);

                    var contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
                    vm.isCreateActisSearchedSymptom = CacheService.getObject(CacheConstants.isCreateActisSearchedSymptom);
                    vm.consultationFIC.symptomLabel = '';
                    if (contextSearchedSymptom) {
                        if (contextSearchedSymptom.label !== null || contextSearchedSymptom.label !== undefined || contextSearchedSymptom.label !== '') {
                            vm.consultationFIC.symptomLabel = contextSearchedSymptom.label;
                        }
                    }
                    vm.consultationFIC.language = profil.portal.label;
                    var now = new Date();
                    var minutes = now.getMinutes();
                    if (minutes == '0') {
                        minutes = '00';
                    }
                    vm.consultationFIC.authorName = response.result.Dealer.contactFirstName + " " + response.result.Dealer.contactLastName;
                    vm.consultationFIC.date = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear() + " " + now.getHours() + ":" + minutes;
                    vm.consultationFIC.ficNumber = response.result.CaseDetail.caseNumber;
                    vm.consultationFIC.or = response.result.Request.orNumber;
                    vm.consultationFIC.dateOr = response.result.Request.orDate;
                    vm.consultationFIC.symptonCode = response.result.Request.symptomCode;
                    vm.consultationFIC.customerComplaint = response.result.Request.customerComplaint;
                    vm.consultationFIC.isCustomerComplaintReproduced = response.result.Request.isCustomerComplaintReproduced;
                    vm.consultationFIC.diagnosticComment = response.result.Request.diagnosticComment;
                    vm.consultationFIC.isDocumentationConsulted = response.result.Request.isDocumentationConsulted;
                    vm.consultationFIC.tintName = responseJson.Request.tintName;
                    vm.consultationFIC.frequenceProbleme = response.result.Request.problemFrequency;
                    vm.consultationFIC.dtcCode1 = response.result.Request.dtcCode1;
                    vm.consultationFIC.dtcCode2 = response.result.Request.dtcCode2;
                    vm.consultationFIC.dtcCode3 = response.result.Request.dtcCode3;
                    vm.consultationFIC.problemCharacteristics = response.result.Request.problemCharacteristics;
                    vm.consultationFIC.opecode = response.result.Request.opeCode;
                    vm.consultationFIC.time = response.result.Request.opeCodeTime;
                    vm.consultationFIC.checkboxesPermanentOrIntermittentValue = ((response.result.Request.problemFrequencyType.length > 0) ? response.result.Request.problemFrequencyType : "Permanent");
                    vm.consultationFIC.immatriculation = response.result.Car.registrationNumber;
                    vm.consultationFIC.problemFrequencyHot = ((response.result.Request.problemCharacteristics.indexOf('Warm State') !== -1) ? true : false);
                    vm.consultationFIC.problemFrequencyCold = ((response.result.Request.problemCharacteristics.indexOf('Cold State') !== -1) ? true : false);
                    vm.consultationFIC.problemFrequencyStoppedCar = ((response.result.Request.problemCharacteristics.indexOf('Idle') !== -1) ? true : false);
                    vm.consultationFIC.problemFrequencyMovingCar = ((response.result.Request.problemCharacteristics.indexOf('Moving') !== -1) ? true : false);
                    vm.consultationFIC.isAgreementType = ((response.result.CaseDetail.recordType === "Agreement CIRs") ? true : false);
                    if (vm.consultationFIC.isAgreementType) {
                        vm.consultationFIC.agreementMo = response.result.Request.maximumRepairCostExTax;
                        vm.consultationFIC.agreementStatus = response.result.Request.agreementValidation;
                        vm.consultationFIC.agreementDesignation = response.result.Request.operationApprovalDesignation;
                        vm.consultationFIC.agreementIntervention = response.result.Request.maximumLabourCostExTax;
                        vm.consultationFIC.agreementPieces = response.result.Request.maximumPartsCostExTax;
                        vm.consultationFIC.agreements = response.result.agreements;
                    }
                    if ($state.params.isActisUserComingFromFicConsultation) {
                        vm.consultationFIC.code = 'M000';
                        vm.consultationFIC.label = '';
                        vm.consultationFIC.createMotrioFic = true;
                    } else if ($state.params.data && _.isEmpty(response.result.Car.vin)) {
                        vm.consultationFIC.code = 'M000';
                        vm.consultationFIC.label = '';
                    }


                    vm.consultationFIC.status = $translate.instant(FicViewListWSService.convertStatusToND(responseJson.CaseDetail.status));
                    if (responseJson && responseJson.CaseDetail.status === 'Draft') {
                        vm.typesFIC = [
                            {
                                id: ActisConstantes.type_technical_assistance,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_technical_assistance])
                            },
                            {
                                id: ActisConstantes.type_approval,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_approval])
                            },
                            {
                                id: ActisConstantes.type_alert,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_alert])
                            },
                            {
                                id: ActisConstantes.type_good_practise,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_good_practise])
                            },
                            {
                                id: ActisConstantes.type_ze_battery,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_ze_battery])
                            },
                            {
                                id: ActisConstantes.type_accessoires,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_accessoires])
                            },
                            {
                                id: ActisConstantes.type_painting,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_painting])
                            },
                            {
                                id: ActisConstantes.type_pilote,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_pilote])
                            },
                            {
                                id: ActisConstantes.type_calm,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_calm])
                            },
                            {
                                id: ActisConstantes.type_administrative,
                                name: $translate.instant(ActisConstantes[ActisConstantes.type_administrative])
                            }
                        ];
                    } else {
                        //Used to set the typeFic dropdown menu to the value obtained from the NAT Case Get response
                        vm.typesFIC = [
                            CreateActisBusinessService.findRelatedRecordTypeToFicType(recordType)
                        ];
                    }
                    vm.selectedTypeFIC = CreateActisBusinessService.findRelatedRecordTypeToFicType(recordType);
                    var profil = CacheService.getObject(CacheConstants.profil);
                    vm.profilName = profil.firstName + " " + profil.lastName;
                    if (responseJson && responseJson.Dealer) {
                        if (responseJson.Dealer.lastContactFirstName && responseJson.Dealer.lastContactLastName) {
                            vm.creator = responseJson.Dealer.lastContactFirstName + " " + responseJson.Dealer.lastContactLastName;
                        } else {
                            vm.creator = (responseJson.Dealer.contactFirstName ? responseJson.Dealer.contactFirstName + " " : "")
                                + (responseJson.Dealer.contactLastName ? responseJson.Dealer.contactLastName : "");
                        }
                    } else {
                        vm.creator = "";
                    }
                    vm.consultationFIC.creator = '';
                    vm.consultationFIC.ficType = vm.selectedTypeFIC.name;
                    vm.consultationFIC.vehicleBin = responseJson.Car.bin;
                    vm.consultationFIC.vehicleVin = responseJson.Car.vin;
                    vm.consultationFIC.mileageValue = responseJson.Car.mileageValue;
                    vm.consultationFIC.mileageUnit = responseJson.Car.mileageUnit;
                    vm.consultationFIC.isVehicleTransformed = responseJson.Car.isVehicleTransformed;
                    vm.consultationFIC.vehicleAccesoires = responseJson.Car.isVehicleAccessories;
                    vm.consultationFIC.isVehicleImmobilised = responseJson.Car.isVehicleImmobilised;
                    vm.consultationFIC.phoneNumber = responseJson.Dealer.phoneNumber;
                    vm.consultationFIC.model = responseJson.Car.model;

                    var comments = responseJson.CaseDetail.comments;

                    for (var i = 0; i < responseJson.CaseDetail.comments.length; i++) {
                        var commentBody = formatText(comments[i].commentBody, 180);

                        if (commentBody.indexOf("<p>") != -1) {
                            commentBody = commentBody.replace(/\n/gi, ' ');
                            commentBody = commentBody.replace(/\t/gi, ' ');
                            responseJson.CaseDetail.comments[i].lines = splitString(commentBody, "<p>");
                        } else if (commentBody.indexOf("\n") != -1) {
                            commentBody = commentBody.replace(/\t/gi, ' ');
                            responseJson.CaseDetail.comments[i].lines = splitString(commentBody, "\n");
                        } else if (commentBody.indexOf("\t") != -1) {
                            commentBody = commentBody.replace(/\n/gi, ' ');
                            responseJson.CaseDetail.comments[i].lines = splitString(commentBody, "\t");
                        }
                        commentBody = commentBody.replace(/\n/gi, ' ');
                        commentBody = commentBody.replace(/\t/gi, ' ');

                    }


                    vm.consultationFIC.comments = responseJson.CaseDetail.comments;
                    vm.consultationFIC.closedDate=responseJson.CaseDetail.closedDate;
                    vm.consultationFIC.creationDate=responseJson.CaseDetail.creationDate;
                    vm.consultationFIC.closureReason=responseJson.CaseDetail.closureReason;

                    CacheService.setObject('consultationFIC', vm.consultationFIC);
                    $rootScope.$broadcast(CONSULTATION_FIC_EVENT, vm.consultationFIC);

                    vm.onUpdateTypeFic(CreateActisBusinessService.findRelatedRecordTypeToFicType(recordType).id);
                    vm.loadFic(responseJson);

                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                }).finally(function () {
                    blockUI.stop();
                });

            } else {
                if ($state.params.isActisUserComingFromFicConsultation) {
                    vm.typesFIC = [
                        {
                            id: ActisConstantes.type_technical_assistance,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_technical_assistance])
                        },
                        {
                            id: ActisConstantes.type_approval,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_approval])
                        },
                        {
                            id: ActisConstantes.type_alert,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_alert])
                        },
                        {
                            id: ActisConstantes.type_good_practise,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_good_practise])
                        },
                        {
                            id: ActisConstantes.type_calm,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_calm])
                        },
                        {
                            id: ActisConstantes.type_administrative,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_administrative])
                        }
                    ];
                } else {
                    vm.typesFIC = [
                        {
                            id: ActisConstantes.type_technical_assistance,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_technical_assistance])
                        },
                        {
                            id: ActisConstantes.type_approval,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_approval])
                        },
                        {
                            id: ActisConstantes.type_alert,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_alert])
                        },
                        {
                            id: ActisConstantes.type_good_practise,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_good_practise])
                        },
                        {
                            id: ActisConstantes.type_ze_battery,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_ze_battery])
                        },
                        {
                            id: ActisConstantes.type_accessoires,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_accessoires])
                        },
                        {
                            id: ActisConstantes.type_painting,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_painting])
                        },
                        {
                            id: ActisConstantes.type_pilote,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_pilote])
                        },
                        {
                            id: ActisConstantes.type_calm,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_calm])
                        },
                        {
                            id: ActisConstantes.type_administrative,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_administrative])
                        }
                    ];
                }
                var profil = CacheService.getObject(CacheConstants.profil);
                vm.creator = profil.firstName + " " + profil.lastName;
                //vm.onLoadPage();
                if (UtilsMetierService.isIndependentUser()){
                    vm.isIndependentUser =  true;
                }
            }
        };
        function formatText(text, n) {
            var length = text.length;
            var lines = [];
            var newText = "";
            var index = 0;
            var endOfLine = n;
            if (length > n) {
                while (length > n) {
                    if ((
                            text.substring(index, index + n).lastIndexOf('<p>') == -1
                        )
                        &&
                        (text[endOfLine] === ' ') || (text[endOfLine] === '.') || (text[endOfLine] === ',')) {
                        newText = newText + text.substring(index, index + endOfLine) + '<p>';
                        length = length - endOfLine;
                        index = index + endOfLine;
                        endOfLine = index;
                    } else {
                        var lastIndex = (text.substring(index, index + n).lastIndexOf(' ')> 0) ? text.substring(index, index + n).lastIndexOf(' ') : n;
                        newText = newText + text.substring(index, index + lastIndex) + '<p>';
                        length = length - lastIndex;
                        index = index + lastIndex;
                        endOfLine = index + lastIndex;
                    }
                }
                if (length > 0) {
                    newText = newText + text.substring(index, text.length);
                }
            } else {
                newText = newText + text + '<p>';
            }
            return newText;
        }
        /**
         * Triggered by any change of the UI
         * Used to update the view
         */
        this.$onChanges = function () {
            //We make sure that we change the view in the case we save/edit the fic
            if (vm.isEditMode) {
                vm.numberFic = vm.responseApi.CaseDetail.caseNumber;
                vm.status = vm.responseApi.CaseDetail.status;
                if (vm.responseApi.Dealer.lastContactFirstName && vm.responseApi.Dealer.lastContactLastName) {
                    vm.creator = vm.responseApi.Dealer.lastContactFirstName + " " + vm.responseApi.Dealer.lastContactLastName;
                } else {
                    vm.creator = (vm.responseApi.Dealer.contactFirstName ? vm.responseApi.Dealer.contactFirstName + " " : "")
                        + (vm.responseApi.Dealer.contactLastName ? vm.responseApi.Dealer.contactLastName : "");
                }
                if (vm.status === 'Closed' && !vm.isFicReopen && vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.closedDate) {
                    var todaysDate = moment(new Date());
                    var responseApiClosedStatusDate = moment(vm.responseApi.CaseDetail.closedDate);
                    var difference = todaysDate.diff(responseApiClosedStatusDate, 'days');
                    if (difference <= ActisConstantes.days_to_reopen) {
                        vm.statusToDisplay = 'ACTIS_HEADER_REOPEN';
                    }
                }
                //to get the status always
                // else {
                    vm.statusToDisplay = FicViewListWSService.convertStatusToND(vm.status);
                //}
                vm.statusToDisplay = $translate.instant(vm.statusToDisplay);
                $rootScope.currentStatus = "";
                $rootScope.currentStatus = vm.statusToDisplay;
                vm.phone = vm.responseApi.Dealer.phoneNumber;
            }
            if(_.isEmpty(vm.responseApi)){
                vm.isQstomizeTypeFic = false;
                vm.isQstomizeClosedFic = false;
                vm.statusOriginal = false;
            }
        };

        /**
         * @namespace updateTypeFIC
         * @desc update type fic
         */
        function updateTypeFIC() {
            vm.onUpdateTypeFic(vm.selectedTypeFIC.id);
        }


        function splitString(stringToSplit, separator) {
            var arrayOfStrings = stringToSplit.split(separator);
            for (var i = 0; i < arrayOfStrings.length; i++) {
                var reg = new RegExp("<+.*>+", "gi");
                arrayOfStrings[i] = arrayOfStrings[i].replace('</b>', " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace('<b>', " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace(reg, " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace('\u00A0', "");
                arrayOfStrings[i] = arrayOfStrings[i].replace('\u25A0', "");
                arrayOfStrings[i] = arrayOfStrings[i].replace('U+000A', "");
            }
            return arrayOfStrings;
        }

        function handleQstomize(isUpdate) {
            if (vm.isSending) {
                return;
            }
            
            vm.isSending = true;
            
            if (vm.isForQstomize && !$scope.isLoading) {
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: false,
                    locals: {
                        message: $translate.instant("QSTOMIZE_WARNING")
                    }
                }).then(function (confirm) {
                    if (confirm) {
                        saveFicHeader(isUpdate);
                    }
                }).catch(function () {
                    toastr.error($translate.instant('QSTOMIZE_TOASTR'));
                }).finally(function () {
                    vm.isSending = false;
                });
            } else {
                saveFicHeader(isUpdate);
                vm.isSending = false;
            }
        }

        function saveFicHeader(isUpdate) {
            $scope.getFileData();
           if ($scope.isLoading) {
                var body = angular.element(document.body);
                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FILE_UPLOAD_MESSAGE",
                    ref: ''
                };

               ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });

            } else {
                vm.saveFic(isUpdate);
            }
        }
        function closedStatusFic(isClosed) {
            vm.closedStatusFic(isClosed);
        }

        function deleteFicHeader() {

            $scope.getFileData();

            if ($scope.isLoading) {

                var body = angular.element(document.body);

                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FIC_DELETE_MSG",
                    ref: ''
                };

                ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
            } else {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/components/actis/components/deleteFicConfirmation.template.html',
                    bindToController: true,
                    controller: GeneralActisController,
                    controllerAs: 'vm',
                    clickOutsideToClose: true
                }).then(function (confirm) {
                    if (confirm) {
                        vm.onDeleteFic();
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }
        }
        function reOpenFic(isFicReopen) {
            vm.reOpenFic(isFicReopen);
        }
        function onCancel() {
            $mdDialog.hide();
        }
        function onConfirm() {
            $mdDialog.hide(true);
        }
    }
})();

(function () {
    angular
        .module('phenix')
        .service('FicInputValidationService', FicInputValidationService);


    function FicInputValidationService() {

        var vm = this;

        vm.formValidation = formValidation;
        vm.isolateCaseNumber = isolateCaseNumber;
        vm.removeColors = removeColors;

        /**
         * @description Used to remove css from different fields of different components
         * @param {*} elementName 
         */
        function removeColors(elementName) {
            var element;
            if (elementName === "phoneNumber") {
                element = document.getElementById("phoneNumber");
            } else if (elementName === "orNumber") {
                element = document.getElementById("orNumber");
            } else if (elementName === "distanceValue") {
                element = document.getElementById("distanceValue");
            } else if (elementName === "binValueToDisplay") {
                element = document.getElementById("binValueToDisplay");
            } else if (elementName === "orDate") {
                element = document.getElementById("orDate");
            } else if (elementName === 'symptomCodeColor') {
                element = document.getElementById("symptomCodeColor");
            } else if (elementName === 'brand') {
                element = document.getElementById("brand");
            } else if (elementName === 'model') {
                element = document.getElementById("model");
            } else if (elementName === 'year') {
                element = document.getElementById("year");
            } else if (elementName === 'binNumber') {
                element = document.getElementById("binNumber");
            } else if (elementName === 'packMileage') {
                element = document.getElementById("packMileage");
            } else if (elementName === 'globalKwh') {
                element = document.getElementById("globalKwh");
            } else if(elementName === 'symptomCode'){
                element = document.getElementById("symptomCode").querySelectorAll("input")[0];
            }
            
            $(element).removeClass("backgroundColorRequiredFields");
            $(element).removeClass("backgroundColorRequiredFieldsOTSDropdown");
            $(element).removeClass("backgroundColorRequiredFieldsBTDropdown");
            var label = $(element).parent();
            var first = $(label).children().first();
            var e = angular.element(first);
            e.removeClass('changeTextColorToRed');
        }

        function formValidation(responseApi,isNewFic,isForBwr, containsProblemFreqBtn, isTreeStructureNodeSelected, isForQstomize) {
            var isFormValid = false;
            var invalidFields;
            if (responseApi && responseApi.CaseDetail && (responseApi.CaseDetail.status === "Answered" || responseApi.CaseDetail.status === "Resolved")) {
                invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid, select[required].ng-invalid, md-select[required].ng-invalid"));
            }else if(isNewFic && isForBwr){
                invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid:not(.discussionComment), select[required].ng-invalid, md-select[required].ng-invalid, select.ng-empty, md-select.ng-empty, #customerComplaint.ng-empty, input[type='search'].ng-empty"));
            }else if( _.isEmpty(responseApi)){
                if(containsProblemFreqBtn){
                    invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid:not(.discussionComment), select[required].ng-invalid, md-select[required].ng-invalid"));
                }
                else{
                    invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid:not(.discussionComment), select[required].ng-invalid, md-select[required].ng-invalid"));
                }
                if (isTreeStructureNodeSelected === false && (!isForQstomize && !isForBwr)) {
                    invalidFields.push(document.querySelector("#treeNodeSelected"));
                }
                
            } else {
                if(!_.isEmpty(responseApi)){
                    if(containsProblemFreqBtn){
                        invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid:not(.discussionComment), select[required].ng-invalid, md-select[required].ng-invalid, md-radio-group[required].ng-invalid"));
                    }
                    else{
                        invalidFields = angular.element(document.querySelectorAll("input[required].ng-invalid, md-datepicker[required].ng-invalid, textArea[required].ng-invalid:not(.discussionComment), select[required].ng-invalid, md-select[required].ng-invalid"));
                    }
                }
            }

            var otsDropdown = document.getElementById('ots-dropdown');
            if (otsDropdown && otsDropdown.offsetParent !== null && !otsDropdown.disabled) { 
                var scope = angular.element(otsDropdown).scope();
                if (scope && scope.vm && scope.vm.selectedOts !== undefined) {
                    var selectedOts = scope.vm.selectedOts;
                    if (!selectedOts || _.isEmpty(selectedOts)) {
                        invalidFields = invalidFields || angular.element([]);
                        invalidFields = angular.element(Array.from(invalidFields).concat([otsDropdown]));
                    }
                }
            }
            var btDropdown = document.getElementById('bt-dropdown');
            if (btDropdown && btDropdown.offsetParent !== null && !btDropdown.disabled) {
                var scope = angular.element(btDropdown).scope();
                if (scope && scope.vm && scope.vm.selectedBt !== undefined) {
                    var selectedBt = scope.vm.selectedBt;
                    const noBtForVin = scope.vm.noBtForVin;
                    
                    let isBtValid = false;
                    if (selectedBt && selectedBt !== '') {
                        isBtValid = true; 
                    } else if (selectedBt === '' && noBtForVin) {
                        isBtValid = true; 
                    }else{
                        isBtValid = false;
                    }
                    
                    if (!isBtValid) {
                        invalidFields = invalidFields || angular.element([]);
                        invalidFields = angular.element(Array.from(invalidFields).concat([btDropdown]));
                    }
                }
            }

            if (invalidFields.length == 0) {
                isFormValid = true;
            } else {
                isFormValid = false;
            }
            var itemObject = {};
            itemObject['isFormValid'] = isFormValid;
            itemObject['invalidFields'] = invalidFields;
            return itemObject;
        }

        function isolateCaseNumber(response) {

            var finalData = response.result.replace(/\\/g, '');
            var indexOfCaseNumber = finalData.indexOf('caseNumber');
            var lastPartOfString = finalData.substring(indexOfCaseNumber); // on garde la string à partir de caseNumber
            var isolateCaseNumberAndNumber = lastPartOfString.substring(0, lastPartOfString.indexOf(","));

            var indexOfDoublePoints = isolateCaseNumberAndNumber.indexOf(':');
            var lastPartOfStringNumber = isolateCaseNumberAndNumber.substring(indexOfDoublePoints); //
            var isolateNumber = lastPartOfStringNumber.substring(2, lastPartOfStringNumber.lastIndexOf('"'));
            return isolateNumber;

        }

    }

})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('ficTypeActis', {
            bindings: {
                onUpdateTypeFic: '<',
                activateActisAccessoriesAndPaint: '<'
            },
            controller: FicTypeActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/fic-type-actis.template.html'
        });

        function FicTypeActisController(ActisConstantes,$translate,$mdDialog,CacheService) {

            var vm = this;
            var profil = CacheService.getUserProfile();
            vm.country =   profil.country;
            vm.updateFicType = updateFicType;

            this.$onInit = function () {

                vm.ficTypes = [
                    {
                        id: ActisConstantes.type_technical_assistance,
                        description: $translate.instant(ActisConstantes.type_technical_assistance_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_technical_assistance]),
                        imgSrc: ActisConstantes.type_technical_assistance_image,
                        buttonName: $translate.instant(ActisConstantes.type_technical_assistance_button)
                    },
                    {
                        id: ActisConstantes.type_approval,
                        description: $translate.instant(ActisConstantes.type_approval_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_approval]),
                        imgSrc: ActisConstantes.type_approval_image,
                        buttonName: $translate.instant(ActisConstantes.type_approval_button)
                    },
                    {
                        id: ActisConstantes.type_alert,
                        description: $translate.instant(ActisConstantes.type_alert_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_alert]),
                        imgSrc: ActisConstantes.type_alert_image,
                        buttonName: $translate.instant(ActisConstantes.type_alert_button)
                    },
                    {
                        id: ActisConstantes.type_good_practise,
                        description: $translate.instant(ActisConstantes.type_good_practise_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_good_practise]),
                        imgSrc: ActisConstantes.type_good_practise_image,
                        buttonName: $translate.instant(ActisConstantes.type_good_practise_button)
                    },
                    {
                        id: ActisConstantes.type_ze_battery,
                        description: $translate.instant(ActisConstantes.type_ze_battery_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_ze_battery]),
                        imgSrc: ActisConstantes.type_ze_battery_image,
                        buttonName: $translate.instant(ActisConstantes.type_ze_battery_button)
                    },
                    {
                        id: ActisConstantes.type_qstomize,
                        description: $translate.instant(ActisConstantes.type_qstomize_description),
                        name: $translate.instant(ActisConstantes[ActisConstantes.type_qstomize]),
                        imgSrc: ActisConstantes.type_qstomize_image
                    }
                ];

                 if(vm.activateActisAccessoriesAndPaint === 'true'){
                    vm.ficTypes.push(
                        {
                            id: ActisConstantes.type_accessoires,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_accessoires]),
                            buttonName: $translate.instant(ActisConstantes.type_accessoires_button)
                        },
                        {
                            id: ActisConstantes.type_painting,
                            name: $translate.instant(ActisConstantes[ActisConstantes.type_painting]),
                            buttonName: $translate.instant(ActisConstantes.type_painting_button)
                        }
                    )
                } 
            }

            /**
             * @namespace updateTypeFIC
             * @desc update type fic
             */
            function updateFicType(selectedFicType) {
                var userProfil = CacheService.getUserProfile();
                if (userProfil && userProfil.country == "FR" && (selectedFicType.id == ActisConstantes.type_technical_assistance || selectedFicType.id == ActisConstantes.type_approval || selectedFicType.id == ActisConstantes.type_alert)) {
                    $mdDialog.show({
                        templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                        controller: 'modalOnCloseFicController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: false,
                        locals: {
                            cotechInfo: $translate.instant("INFORMATION_COTECH"),
                            ficTypeId: selectedFicType.id
                        }
                    }).then(function (confirm) {
                        if (confirm) {
                            vm.onUpdateTypeFic(selectedFicType.id);
                        }
                    }).catch(function () {
                    });
                } else {
                    vm.onUpdateTypeFic(selectedFicType.id);
                }
            }
        }
})();

/**
 * batteryComponent
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('ficDetails', {
            bindings: {
                type: '@',
                responseApi: '<',
                isEditMode: '<',
                saveFic: '<',
                reOpenFic: '<',
                onDeleteFic: '<',
                isFicReopen: '<',
                isSendButtonVisible: '<',
                isDiscussionCommentBox: '<'
            },
            controller: FicDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/fic-details.template.html'
        });

        function FicDetailsController(
            CacheService,
            CacheConstants,
            $scope, $translate,
            ActisFicModalService,
            ActisConstantes,
            $rootScope, $mdDialog, FicViewListWSService,
            $state,RoutesConstants,toastr, $log, MainMetierService) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;
            vm.userProfile = CacheService.getObject(CacheConstants.profil);
            vm.isActisProfil = MainMetierService.isActisProfilNoContext();
            vm.isReopenClicked = false;

            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/

            vm.saveFicHeader = saveFicHeader;
            vm.reOpenFicHeader = reOpenFicHeader;
            vm.closedStatusFic = closedStatusFic;
            vm.onCancel = onCancel;
            vm.onConfirm = onConfirm;
            vm.deleteFicHeader = deleteFicHeader;
            vm.reOpenFic = reOpenFic;

            $scope.getFileData = function () {
                $rootScope.$broadcast('getFileData');
            };

            /**
             * Create a listener to listen from Actis.constoler (broadcast)
             * in order to call getVehicleData()
             */
            $scope.$on('getFicData', function(event) {
                $scope.$emit("loadFicData", $scope.getFicDetails());
            });

            $scope.getFicDetails = function(){
                var type = "BRW : Battery repair";

                return {
                        "Dealer":{},
                        "CaseDetail": {
                            "recordType": type
                        }
                };

            }

            /**
             * Triggered by any change of the UI
             * Used to update the view
             */
            this.$onChanges = function () {
                if (vm.status !== 'Closed' || !vm.isFicReopen) {
                    vm.isReopenClicked = false;
                }
                
                if(vm.responseApi && vm.isEditMode){
                    vm.numberFic = vm.responseApi.CaseDetail.caseNumber;
                    vm.status = vm.responseApi.CaseDetail.status;
                    if (vm.responseApi.Dealer.lastContactFirstName && vm.responseApi.Dealer.lastContactLastName) {
                        vm.creator = vm.responseApi.Dealer.lastContactFirstName + " " + vm.responseApi.Dealer.lastContactLastName;
                    } else {
                        vm.creator = (vm.responseApi.Dealer.contactFirstName ? vm.responseApi.Dealer.contactFirstName + " " : "")
                            + (vm.responseApi.Dealer.contactLastName ? vm.responseApi.Dealer.contactLastName : "");
                    } 
                    if (vm.status === 'Closed' && vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.closedDate) {
                        var todaysDate = moment(new Date());
                        var responseApiClosedStatusDate = moment(vm.responseApi.CaseDetail.closedDate);
                        var difference = todaysDate.diff(responseApiClosedStatusDate, 'days');
                        if (difference <= ActisConstantes.days_to_reopen) {
                            vm.isFicReopen = true;
                            vm.statusToDisplay = 'ACTIS_HEADER_REOPEN';
                        }
                        else{
                            vm.isFicReopen = false;
                        }
                    }
                    vm.statusToDisplay = FicViewListWSService.convertStatusToND(vm.status);
                    vm.statusToDisplay = $translate.instant(vm.statusToDisplay);
                }
            }
            
            $rootScope.$on("loadAttachmentData", function (event, data) {
                $scope.isLoading = data;
            });

            this.$onInit = function () {
                if (!vm.creator) {
                    vm.creator = (vm.userProfile.firstName ? vm.userProfile.firstName + ' ' : '')
                        + (vm.userProfile.lastName ? vm.userProfile.lastName : '');
                }
                if(vm.type === 'brw') {
                    vm.ficType = ActisConstantes.BRW_CIRS;
                } else if(vm.type === 'paint'){
                    vm.ficType = ActisConstantes.PAINT_CIRS;
                } else if(vm.type === 'accessories'){
                    vm.ficType = ActisConstantes.ACCESSORIE_CIRS;
                }else if(vm.type === 'qstomize'){
                    vm.ficType = ActisConstantes.QSTOMIZE_CIRS;
                } else{
                    vm.ficType = "";
                }

            };

            /**
         * @namespace saveFicHeader
         * @desc throws pop-in whether user wants to save or send an Actis form when a file upload is running.
         */


        function saveFicHeader(isUpdate) {

            $scope.getFileData();

            if ($scope.isLoading) {

                var body = angular.element(document.body);

                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FILE_UPLOAD_MESSAGE",
                    ref: ''
                };

                ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });

            } else {
                vm.isDiscussionCommentBox = true;
                vm.saveFic(isUpdate);
            }
        }

        function reOpenFicHeader(isReopen) {
            vm.reOpenFic(isReopen);
            if (isReopen) {
                $rootScope.ficReopenEnabled = true;
                if (!$rootScope.$$phase) $rootScope.$apply();
            }
        }

        /**
         * @namespace closedStatusFic
         * @description used to close a FIC and call the closeFic method of Actis Controller
         */
         $scope.getFicData = function () {
            $scope.$broadcast('getFicData');
        };

         function closedStatusFic(isClosed) {

            if (isClosed && (vm.responseApi.CaseDetail.status === 'Answered' || vm.responseApi.CaseDetail.status === 'Resolved')) {
                $scope.getFicData();
                var payload = {
                    caseNumber: vm.responseApi.CaseDetail.caseNumber,
                    caseId: vm.responseApi.CaseDetail.caseId
                };

                $mdDialog.show({
                    templateUrl: 'app/components/actis/listFic/closeFicPopIn.template.html',
                    controller: 'closeFicPopInController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        payload: function () {
                            return payload;
                        }
                    }
                }).then(function (result) {
                    if (result && result.confirmClose) {
                        $state.go(RoutesConstants.ficConsultation);
                        toastr.success($translate.instant('FIC_CLOSED'));
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }
        }

        /**
        * Clicking on 'No' button in the dialog box closes the dialog box
        */
        function onCancel() {
            $mdDialog.hide();
        }

        /**
         * Clicking on 'Yes' button in the dialog box updates the status to 'Abandoned'
         * and redirects to FIC consultation page
         */
        function onConfirm() {
            $mdDialog.hide(true);
        }

        /**
         * @namespace deleteFicHeader
         * @desc throws pop-in whether user wants to delete current Actis form when a file upload is running.
         */

         function deleteFicHeader() {

            $scope.getFileData();

            if ($scope.isLoading) {

                var body = angular.element(document.body);

                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FIC_DELETE_MSG",
                    ref: ''
                };

                ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
            } else {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/components/actis/components/deleteFicConfirmation.template.html',
                    bindToController: true,
                    controller: FicDetailsController,
                    controllerAs: 'vm',
                    clickOutsideToClose: true
                }).then(function (confirm) {
                    if (confirm) {
                        vm.onDeleteFic();
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }
        }

        function reOpenFic(isFicReopen) {
            if (isFicReopen && vm.reOpenFic) {
                vm.isReopenClicked = true;
                vm.reOpenFic(isFicReopen);
                
                $rootScope.$broadcast('ficReopened', {
                    isReopenClicked: vm.isReopenClicked
                });
            }
        }

        

        }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('discussionActis', {
            bindings: {
                nonModifiableFic: '<',
                onUpdateComment: '<',
                responseApi: '<',
                isEditMode: '<',
                isFicReopen: '<',
                isForBwr: '<',
                isDraft: '<',
                isForQstomize: '<',
                isDiscussionCommentBox: '<',
                isDaysToReopen: '<',
                filesToBeShown: '<'
            },
            controller: DiscussionActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/discussion-actis.template.html'
        })

    function DiscussionActisController(
        $scope,
        $rootScope,
        $translate,
        FicViewListWSService,
        CacheService,
        MainMetierService,
        ActisConstantes,
        CreateActisBusinessService,
        $sce,
        $timeout,
        configConstantes,
        blockUI,$state) {

        var vm = this;
        vm.updateComment = updateComment;
        vm.comments = [];
        vm.mergedCommentsAndPJ = [];
        vm.pageNumber = 0;
        vm.totalPages = 0;
        vm.isDiscussionOpen = true;
        vm.statusToBeProcessed = $translate.instant('ACTIS_ANSWERED');
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        var user = CacheService.getUserProfile();
        vm.isIndependentProfil = MainMetierService.isIndependantUser(user.roles);
        vm.removeDescriptionBoxColor = removeDescriptionBoxColor;
        vm.getMoreAttachments = getMoreAttachments;
        vm.getAttachments = getAttachments;
        vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
        vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';
        vm.closeAttachments = closeAttachments;

        /**
         * Update comments as the text inside the discussion comment changes
         * @param {*} description 
         */

        function updateComment(description) {
            vm.description = description;
            vm.onUpdateComment(description);
        }

        $rootScope.$on("fileAttachments", function(event, files) {
            vm.filesToBeShown = files.filesToBeShown;
            vm.rDocIdsAndFileNames = files.rDocIdsAndFileNames;
        });

        /**
         * Triggered by any change of the UI
         * Used to update the view
         */
        vm.$onChanges = function () {
            if (vm.isEditMode) {
                vm.comments = vm.responseApi.CaseDetail.comments;
                if (vm.comments && vm.comments.length > 0) {
                    vm.comments.forEach(function (item) {
                            if(_.isEmpty(item.commentAuthorLevel)){
                                if(item.commentAuthorFirstName === 'Salesforce' && item.commentAuthorLastName === 'Platform'){
                                    _.extend(item,{icon:'closure'})
                                }else{
                                    _.extend(item,{icon:'blackBubble'})
                                }
                            }else{
                                _.extend(item,{icon:'yellowBubble'})
                            }

                        if(!vm.isForBwr){
                            if (item.commentAuthorFirstName && item.commentAuthorFirstName.toLowerCase() === 'wired'
                            && item.commentAuthorLastName && item.commentAuthorLastName.toLowerCase() === 'case') {
                            item.commentAuthorFirstName = '';
                            item.commentAuthorLastName = 'Cotech';
                        }
                    }

                        if (_.isString(item.commentBody)) {
                            var itemCommentBody = $sce.trustAsHtml(item.commentBody);
                            item.commentBody = itemCommentBody;
                        }
                    })
                }
                if(!vm.isDiscussionCommentBox && vm.isFicReopen){
                    vm.closeAttachments(true);
                }
                vm.status = vm.responseApi.CaseDetail.status;
                vm.statusToDisplay = FicViewListWSService.convertStatusToND(vm.status);
                vm.statusToDisplay = $translate.instant(vm.statusToDisplay);
                vm.closureReason = vm.responseApi.CaseDetail.closureReason;

                if(vm.responseApi && vm.responseApi.CaseDetail)
                    var eventId = vm.responseApi.CaseDetail.caseId;
                //Display the attachments on ManageFIC page when a FIC is selected on FIC Consultation page
                if (eventId) {
                    vm.pageNumber = 0;
                    if(vm.isFicReopen && vm.isDiscussionCommentBox == false ){
                        var consultationFIC = CacheService.getObject('consultationFIC');
                        if(!_.isEmpty(consultationFIC.attachments) && !_.isEmpty(vm.showCoTechFiles)){
                            consultationFIC.attachments = vm.showCoTechFiles;
                            consultationFIC.attachments = _.uniqBy(consultationFIC.attachments, 'fileName');
                        }
                        mergeCommentsAndCoTechFilesArrays();
                    }
                    else{
                        vm.getAttachments(eventId,true);
                    }
                } else {
                    //to display the comments alone
                    mergeCommentsAndCoTechFilesArrays();
                }
            }

        }

        function closeAttachments(files){
            $rootScope.$broadcast("closeAttachments", {
                isDiscussionCommentBox: vm.isDiscussionCommentBox,
                isFicReopen: vm.isFicReopen,
                filesToBeShown: vm.filesToBeShown,
                rDocIdsAndFileNames: vm.rDocIdsAndFileNames,
                files: files
            });
        }

        /**
         * @description Used to merge both the arrays (comments and PJs)
         */
        function mergeCommentsAndCoTechFilesArrays() {
            //$timeout(function() {
            vm.mergedCommentsAndPJ = [];
            if (vm.comments && vm.comments.length > 0) {
                vm.comments.forEach(function (item) {
                    item.dateToOrderCommentsAndPJ = item.commentDate;
                    vm.mergedCommentsAndPJ.push(item);
                });
            }
            if (vm.showCoTechFiles && vm.showCoTechFiles.length > 0) {
                vm.showCoTechFiles.forEach(function (item) {
                    item.dateToOrderCommentsAndPJ = item.localDate;
                    vm.mergedCommentsAndPJ.push(item);
                })
            }

            if (vm.mergedCommentsAndPJ && vm.mergedCommentsAndPJ.length > 0) {
                vm.mergedCommentsAndPJ.sort(function (a, b) {
                    return new Date(a.dateToOrderCommentsAndPJ) - new Date(b.dateToOrderCommentsAndPJ);
                }).reverse();
            }
            //}, 1000);
        }

        /**
         * Create a listener to listen from Actis.controller (broadcast)
         * in order to call getGeneralData()
         */

        $scope.$on('getFicData', function (event) {
            $scope.$emit("loadFicData", $scope.getGeneralData());
        });

        /**
         * returns Current data contained in the view at the moment
         * where the method is called
         * @returns {*}
        */

        $scope.getGeneralData = function () {

            if (!_.isEmpty(vm.responseApi) && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.comments && (vm.responseApi.CaseDetail.comments.length == 0
                || vm.responseApi.CaseDetail.comments.length > 0) && vm.description
                && (vm.statusToBeProcessed === vm.statusToDisplay) || (!vm.isFicReopen)) {
                return {
                    "CaseDetail": {
                        "comments": vm.description,
                        "status": vm.status
                    }
                }
            }
        };

        // Used to remove css when field is populated
        function removeDescriptionBoxColor() {
            var element = document.getElementById("descriptionUndefined");
            $(element).removeClass('borderRed');
            $(element).removeClass('backgroundColorRequiredFields');
        }

        //to get next 20 attachments
        function getMoreAttachments() {  
            var eventId = vm.responseApi.CaseDetail.caseId;          
            if (vm.pageNumber < vm.totalPages) {
                vm.getAttachments(eventId,false);
            }
        }

        function getAttachments(eventId,firstCall) {            
            var url = ActisConstantes.endpoint.wiredRDocIdSearch + "?q=eventId==" + eventId + '&page=' + vm.pageNumber + '&size='+ActisConstantes.rdoc_page_size+'&sort='+ActisConstantes.rdoc_sort;
            blockUI.start();
            CreateActisBusinessService.displayAttachments(url).then(function (resp) {
                vm.showCoTechFiles = [];
                if (resp && resp.data) {
                    vm.pageNumber = vm.pageNumber + 1;
                    if (firstCall)
                        vm.totalPages = resp.totalPages;
                    var consultationFIC = CacheService.getObject('consultationFIC');
                    if (firstCall)
                        if(!_.isEmpty(vm.showCoTechFiles)){
                            consultationFIC.attachments = vm.showCoTechFiles;
                        }
                        else{
                            consultationFIC.attachments = resp.data;
                        }
                    else {
                        var existingIds = consultationFIC.attachments.map(function (item) {
                            return item.rDocId;
                        });
                        var newItems = resp.data.filter(function (item) {
                            return existingIds.indexOf(item.rDocId) === -1;
                        });

                        consultationFIC.attachments = consultationFIC.attachments.concat(newItems);
                    }
                    CacheService.setObject('consultationFIC', consultationFIC);
                    vm.providerSystem = ActisConstantes.attachmentProviderSystem;
                    consultationFIC.attachments.forEach(function (item) {
                        vm.showCoTechFiles.push(item);
                            if(item.providerSystem === vm.providerSystem && item.scannedStatus !== ActisConstantes.attachment_scannedStatus_ok){
                                var rDocId = item.rDocId
                                 var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                  CreateActisBusinessService.close(url);
                                var removedIndex =  vm.showCoTechFiles.indexOf(item);
                                 if (removedIndex > -1) {
                                    vm.showCoTechFiles.splice(removedIndex, 1); 
                          }
                        }
                        vm.scannedStatusOk = ActisConstantes.attachment_scannedStatus_ok;
                    })
                }
            }).then(function () {
                mergeCommentsAndCoTechFilesArrays();
            }).finally(function () {
                blockUI.stop();
            });
        }

    }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {
    angular
        .module('phenix')
        .filter('momentLocaleDate', function ($translate) {
            return function (value) {
                var locale = $translate.use();
                if(locale === 'no'){
                    locale='nn';
                }
                if(locale === 'zh'){
                    locale = 'zh-cn';
                }
                var date = moment(value).locale(locale).format("dddd DD MMMM YYYY")
                return date;
            }
        })
        .component('descriptionActis', {
            bindings: {
                type: '@',
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isFicCancelled: '<',
                isFicReopen: '<',
                isActisFromDiag: '<',
                isDraft:'<',
                isStatusPresent: '<',
                saveFic: '<',
                onDeleteFic: '<',
                isSaveButtonVisible: '<',
                isForBwr: '<',
                isForPaint: '<',
                isForAccessories: '<',
                isIndependentUser:'<',
                isDaysToReopen: '<',
                isApprovalFic: '<',
                isTechnicalAssistanceFic: '<',
                isAlertFic:'<',
                isGoodPractiseFic: '<',
                isPiloteFic: '<',
                isAdministrativeFic: '<',
                isCalmFic: '<'
            },
            controller: DescriptionActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/description-actis.template.html'
        }).config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
               return moment(date).format("YYYY/MM/DD");
            };
        });

        function DescriptionActisController(CacheService, CacheConstants, DiagFileDetailsNewConstants, SearchbyDiagnosticConstants,
            DiagFileBusinessService, FicInputValidationService, $mdDialog, $scope, $state, $filter, $timeout, toastr, $translate, blockUI, MainMetierService,$log,$rootScope,configConstantes,ActisConstantes,CarOtsMetierService,ResultSearchByDiagnosticMetierService,ResultSearchByDiagnosticWsService,$q,CreateActisBusinessService) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.btDropdownOptions = [];
        vm.selectedBt = null;
        vm.btSearchText = '';
        vm.symptomCode = '';
        vm.filteredBtOptions = [];
        vm.showBtField = false;
        vm.btLoadedForVin = null;
        vm.btApiCallInProgress = false;
        vm.savedBtValue = null;
        vm.symptomLongCode = null;
        vm.symptomsLoading = false;
        vm.btLoading = false;
        vm.otsColorData;

        vm.filterBtList = function () {
            if (!vm.btSearchText) {
                vm.filteredBtOptions = angular.copy(vm.btDropdownOptions);
                return;
            }
            var search = vm.btSearchText.toLowerCase();

            vm.filteredBtOptions = vm.btDropdownOptions.filter(function (bt) {
                var matches = bt.name.toLowerCase().startsWith(search);
                return matches;
            });
        };

        vm.resetBtSearch = function () {
            $timeout(function() {
                vm.btSearchText = '';
                vm.filteredBtOptions = angular.copy(vm.btDropdownOptions);
                
                if (vm.selectedBt && vm.selectedBt !== 'No' && vm.selectedBt !== '') {
                    var isValidOption = vm.btDropdownOptions && vm.btDropdownOptions.some(function(bt) {
                        return bt.name === vm.selectedBt;
                    });
                    
                    if (!isValidOption) {
                        if (vm.noBtForVin || !vm.btDropdownOptions || vm.btDropdownOptions.length === 0) {
                            vm.selectedBt = '';
                        } else {
                            vm.selectedBt = null;
                        }
                    }
                }
            });
        };


        vm.getDocumentationClass = getDocumentationClass;
        vm.setSelectedCheckboxPermanentOrIntermittent = setSelectedCheckboxPermanentOrIntermittent;
        vm.isSelectedCheckbox = false;
        vm.searchSymptom = searchSymptom;
        vm.isCreateActisSearchedSymptom = false;
        vm.descriptionData = {};
        vm.removeColors = removeColors;
        vm.removeTextAreaColors = removeTextAreaColors;
        vm.remove = remove;
        vm.createMotrioFic = false;
        vm.isDescriptionOpen = false;
        vm.dateOr = null;
        vm.diagDataFound = true;
        vm.selectedDiagFile = null;
        vm.adtTechrole = false;
        vm.adtOtherRoles= false;
        vm.display = false;
        vm.dataperPage = 10;
        $scope.origin = [];
        vm.user = CacheService.getUserProfile();
        vm.isArcaUser = MainMetierService.isArcaUser();
        vm.isRnetUser = MainMetierService.isRnetUserType(vm.user.userType);
        vm.radioButtonColorChange = radioButtonColorChange;
        vm.checkBoxColorChange = checkBoxColorChange;
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
        vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';
        vm.isTreeStructureNodeSelected = false;
        vm.showAdditionalDiagnosticMessage = false;
        vm.showPlusIcon = true;
        vm.getSymptomLongCode = getSymptomLongCode; 
        vm.loadBtForSymptom = loadBtForSymptom;
        vm.getAllSymptoms = getAllSymptoms;

        if (vm.user && vm.user.roles && (vm.isRnetUser || vm.isArcaUser)) {
            if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtTechRole)) {
                vm.adtTechrole = true;
            }
            else if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtDiagnosisRole) || vm.user.roles.includes(SearchbyDiagnosticConstants.adtImmoRole)) {
                vm.adtOtherRoles = false;
            }
            else if (vm.user.roles.includes(SearchbyDiagnosticConstants.adtIndependentRole) || vm.user.roles.includes(SearchbyDiagnosticConstants.adtRepRole)) {
                vm.adtOtherRoles = true;
            }
            else {
                vm.adtOtherRoles = true;
            }
        }

        vm.isSearchByModel = MainMetierService.isSearchByModel();
        vm.currentPage = CacheService.getObject(CacheConstants.diagCurrentPage) ? CacheService.getObject(CacheConstants.diagCurrentPage) : 1;
        vm.diagFilesList = CacheService.getObject(CacheConstants.diagFilesList);
        vm.typeMD = CacheService.getCarContext() ? CacheService.getCarContext().typeMD : '';
        vm.saveSelectedDiag = saveSelectedDiag;
        vm.diagIconClick = diagIconClick;
        vm.getDiagDetails = getDiagDetails;
        vm.initialCategory = initialCategory;
        vm.getPagedData = getPagedData;
        vm.onClickFirstNode =onClickFirstNode;
        vm.saveSecondNode = saveSecondNode;
        vm.clickAccord = clickAccord;
        vm.expandDiagList = expandDiagList;
        vm.toggleDiagnosticInfo = toggleDiagnosticInfo;
        vm.goToAttachmentDoc = goToAttachmentDoc;
        vm.currentDate = MainMetierService.getCurrentDate();
      
        vm.otsData = [];
        vm.selectedOts = null;
        vm.showOtsField = false; 
        vm.isOtsFieldDisabled = isOtsFieldDisabled;
        vm.loadOtsForVin = loadOtsForVin;
        vm.getOtsCode = getOtsCode;
        vm.removeOtsColors = removeOtsColors;
        vm.removeBtColors = removeBtColors;
        vm.isBtFieldDisabled = isBtFieldDisabled;
        vm.calculateShowBtField = calculateShowBtField;
        vm.restoreSelectedBt = restoreSelectedBt;
        vm.getBtCode = getBtCode;
        vm.isBtValid = isBtValid;
       
        vm.otsLoadedForVin = null;
        vm.otsApiCallInProgress = false;
        
        vm.probFreqState = [{model:'problemFrequencyHot', label:'HOT',modelHighResolution:'problemFrequencyHot2'},
        {model:'problemFrequencyCold', label:'COLD',modelHighResolution:'problemFrequencyCold2'},
        {model:'problemFrequencyStoppedCar', label:'STOPPED_CAR',modelHighResolution:'problemFrequencyStoppedCar2'},
        {model:'problemFrequencyMovingCar', label:'MOVING_CAR',modelHighResolution:'problemFrequencyMovingCar2'}]
            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/
            /**
             * Create a listener to listen from Actis.constoler (broadcast)
             * in order to call getDescriptionData()
             */
            $scope.$on('getFicData', function(event) {
                $scope.$emit("loadFicData", $scope.getDescriptionData());
            });
            $rootScope.$on("saveOrSendCheck",function (event,data){
                vm.ficSend = data.isNewFicType;
            });

            // Watch for changes in FIC type flags and recalculate OTS field visibility
            $scope.$watch(function() {
                return vm.isTechnicalAssistanceFic + '|' + vm.isApprovalFic + '|' + vm.isAlertFic + '|' + 
                       vm.isGoodPractiseFic + '|' + vm.isPiloteFic + '|' + vm.isAdministrativeFic + '|' + 
                       vm.isCalmFic + '|' + vm.type;
            }, function(newVal, oldVal) {
                if (newVal !== oldVal) {
                    calculateShowOtsField();
                    calculateShowBtField();
                    if (vm.showOtsField && (!vm.otsData || vm.otsData.length === 0)) {
                        loadOtsForVin();
                    }
                    if (vm.showBtField && (!vm.btDropdownOptions || vm.btDropdownOptions.length === 0)) {
                        loadBtForSymptom();
                    }
                }
            });

            /**
             * return Current data contained in the view at the moment
             * where the methode is called
             * @returns {*}
             */
            $scope.getDescriptionData = function(){
                vm.descriptionData.orNumber = vm.or;
                vm.descriptionData.dtcCode1 = vm.fisrtNodeId || vm.dtcCode1;
                vm.descriptionData.dtcCode2 = vm.secondNodeId || vm.dtcCode2;
                vm.descriptionData.orDate = vm.dateOr ? moment(vm.dateOr).format("YYYY-MM-DD") : "";
                vm.descriptionData.symptomCode = vm.code ? vm.code.trim() : '';

                vm.descriptionData.customerComplaint = vm.plianteClientToDisplay;
                vm.descriptionData.isCustomerComplaintReproduced = vm.reproducedCustomerComplaint;
                vm.descriptionData.diagnosticComment = vm.diagnostiqueToDisplay;
                vm.descriptionData.problemFrequency = vm.problemFrequencyToDisplay;
                if(vm.fisrtNodeName && vm.secondNodeName){
                   
                    vm.descriptionData.fisrtNodeName = vm.fisrtNodeName;
                    vm.descriptionData.secondNodeName = vm.secondNodeName;
                }
                if(!vm.display && (!vm.fisrtNodeName || !vm.secondNodeName)){
                    vm.descriptionData.fisrtNodeName  = "";
                    vm.descriptionData.secondNodeName = "";
                }

                if (vm.type !== 'painting' && vm.type !== 'accessory') {
                    vm.descriptionData.dtcCode3 = vm.selectedDiagFileId;
                }
                else {
                    vm.descriptionData.dtcCode3 = vm.dtcCode3;
                }

                //problemFrequencyCharacteristics data to API
                var frequencyCharacteristics = {

                }
                if (vm.problemFrequencyHot) {
                    frequencyCharacteristics.hotState = {
                        'id' : 1
                    }
                }
                if (vm.problemFrequencyCold) {
                    frequencyCharacteristics.coldState = {
                        'id' : 2
                    }
                }
                if (vm.problemFrequencyStoppedCar) {
                    frequencyCharacteristics.idleState = {
                        'id' : 3
                    }
                }

                if (vm.problemFrequencyMovingCar) {
                    frequencyCharacteristics.movingState = {
                        'id' : 4
                    }
                }

                var problemCharacteristics = '';
                if (frequencyCharacteristics) {
                    angular.forEach(frequencyCharacteristics, function (value, key) {
                        var id = value.id;
                        if (problemCharacteristics) {
                            problemCharacteristics = problemCharacteristics + ',' + id;
                        } else {
                            problemCharacteristics = id;
                        }
                    })
                }

                vm.descriptionData.problemCharacteristics = problemCharacteristics;
                vm.descriptionData.problemFrequencyType = vm.checkboxesPermanentOrIntermittentValue;
                vm.descriptionData.reference = (vm.reference === "yes") ? vm.reference : "no";
                
                if (vm.showOtsField) {
                    vm.descriptionData.selectedOts = vm.selectedOts;
                    vm.descriptionData.otsRelated = vm.selectedOts && vm.selectedOts !== 'notLinked' && vm.selectedOts !== '' && vm.selectedOts !== 'noOtsAvailable';
                    
                    if (!vm.otsData || vm.otsData.length === 0 || vm.selectedOts === 'noOtsAvailable') {
                        vm.descriptionData.isDocumentationConsulted = "";
                    } else {
                        vm.descriptionData.isDocumentationConsulted = getOtsCode(vm.selectedOts);
                    }
                } else {
                    vm.descriptionData.isDocumentationConsulted = vm.documentationConsulted;
                }

                if (vm.showBtField) {
                    if (vm.selectedBt && vm.selectedBt !== '') {
                        vm.btValue = getBtCode(vm.selectedBt);
                        $scope.$emit('btValueSelected', vm.btValue);
                    } else if (vm.noBtForVin) {
                        vm.btValue = '';
                        $scope.$emit('btValueSelected', '');
                    } else {
                        vm.btValue = '';
                        $scope.$emit('btValueSelected', '');
                    }
                } else {
                    vm.btValue = '';
                    $scope.$emit('btValueSelected', '');
                }
                vm.descriptionData.tintname = vm.btValue;
               
                if(vm.descriptionData.problemFrequencyType && vm.descriptionData.problemFrequencyType === 'Permanent') {
                    vm.descriptionData.problemFrequencyType = 1;
                } else if (vm.descriptionData.problemFrequencyType && vm.descriptionData.problemFrequencyType === 'Intermittent') {
                    vm.descriptionData.problemFrequencyType = 2;
                }

                return {"Request": vm.descriptionData};
            };


            this.$onInit = function () {
                var contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
                var savDetails = 'SAV: coordonnées fournisseurs';
                vm.isCreateActisSearchedSymptom = CacheService.getObject(CacheConstants.isCreateActisSearchedSymptom);
                vm.symptomCode = (vm.isCreateActisSearchedSymptom || (contextSearchedSymptom && contextSearchedSymptom.label)) ? contextSearchedSymptom.label : ($state && $state.params && $state.params.data ? $state.params.data.symptomCode : null);
                if (vm.type !== 'painting' && vm.type !== 'accessory') {
                    vm.currentPage = 1;
                    getDiagDetails();
                }
                vm.contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch) ? CacheService.getObject(CacheConstants.contextCarSearch) : null;
                if(vm.contextCarSearch && vm.contextCarSearch.treeNodes){
                    if(vm.contextCarSearch.treeNodes.levelOne && vm.contextCarSearch.treeNodes.levelOne.nodes){
                        vm.firstLevelNode = [];
                    _.map(vm.contextCarSearch.treeNodes.levelOne.nodes,function(val){
                        vm.firstLevelNode.push({
                            label:val.label,
                            nodeId:val.nodeId
                        });
                    })
                    }
                }
                if (contextSearchedSymptom) {
                    if (contextSearchedSymptom.label == null || contextSearchedSymptom.label == undefined || contextSearchedSymptom.label == '') {
                        vm.dtc1 = contextSearchedSymptom.code;
                    } else {
                        vm.code = contextSearchedSymptom.code;
                        vm.label = contextSearchedSymptom.label;
                        getSymptomLongCode();
                        // Used to remove css for symptom code and label fields
                        vm.remove();
                    }
                }

                CacheService.setObject(CacheConstants.isCreateActisSearchedSymptom, vm.searchedSymptom);

                if ($state.params.isActisUserComingFromFicConsultation) {
                    vm.code = 'M000';
                    vm.label = '';
                    vm.createMotrioFic = true;
                }
                vm.isDescriptionOpen = (vm.isDraft || vm.isActisFromDiag)? true : false;
                if (vm.type ==='accessory'){
                    vm.infosIncident1 =[
                        {
                            id: 1,
                            name: 'Accessoire',
                            subCategory:
                                [
                                    {id: 1, name:'Demande de référence'},
                                    {id: 2, name:'Information produit : Homologation'},
                                    {id: 3, name:'Information produit : Description'},
                                    {id: 4, name:'Incident: Produit non conforme à la description'},
                                    {id: 5, name:'Incident: Produit incomplet'},
                                    {id: 6, name:'Montage: problème'},
                                    {id: 7, name:'Montage: notice de montage'},
                                    {id: 8, name:savDetails}
                                ],
                            isDefault: false
                        },
                        {
                            id: 2,
                            name: 'Ixtar PAPP',
                            subCategory:
                                [
                                    {id: 1, name:'Description produit'},
                                    {id: 2, name:'Utilisation du produit'},
                                    {id: 3, name:savDetails}
                                ],
                            isDefault: false
                        },
                        {
                            id: 3,
                            name: 'Marchandising',
                            subCategory:
                                [
                                    {id: 1, name:'Utilisation du produit'},
                                    {id: 2, name:savDetails}
                                ],
                            isDefault: false
                        }
                    ];
                }

                if (vm.type ==='painting') {
                    vm.infosIncident1 =[
                        {
                            id: 1,
                            name: 'Ixell',
                            subCategory:
                                [
                                    {id: 1, name:'Contretypage'},
                                    {id: 2, name:'Correction de teinte'},
                                    {id: 3, name:'Code couleur caisse'},
                                    {id: 4, name:'Référence produit Ixell'},
                                    {id: 5, name:'Information produit Ixell'},
                                    {id: 8, name:savDetails}
                                ],
                            isDefault: true
                        }
                    ];
                }



            vm.checkboxesPermanentOrIntermittent = [{
                    id: 1,
                    name: 'Permanent'
                },
                {
                    id: 2,
                    name: 'Intermittent'
                }
            ];

            calculateShowOtsField();
            calculateShowBtField();
            if (vm.showOtsField) {
                loadOtsForVin();
            }
            if (vm.showBtField) {
                var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
                var isDraftStatus = !currentStatus || currentStatus === '' || currentStatus === 'Draft';
                var isAnsweredOrResolved = currentStatus === 'Answered' || currentStatus === 'Resolved';
                if (isDraftStatus || !vm.isEditMode || isAnsweredOrResolved) {
                    loadBtForSymptom();
                } else {
                    restoreSelectedBt();
                }
            }

        };

            function checkBoxColorChange(elementName, checkBoxName) {
                if ((vm.isActisFromDiag || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status == "Draft")) && vm.isAlertFic && vm.ficSend && ((vm.descriptionData && vm.descriptionData.problemCharacteristics === "" || vm.descriptionData.problemCharacteristics === undefined))) {
                    var vehicleData = document.getElementById(elementName);
                    vehicleData.classList.add("checkBoxColorChange");
                }
                else {
                    var vehicleData = document.getElementById(elementName);
                    vehicleData.classList.remove("checkBoxColorChange");
                }
            }

        function radioButtonColorChange(elementName){
            if(vm.ficSend && ((elementName === "problemFrequencyButton" && (vm.descriptionData && vm.descriptionData.problemFrequencyType === "" || vm.descriptionData.problemFrequencyType === undefined)) || (elementName === "problemFrequencyButtonResolution" && (vm.descriptionData && vm.descriptionData.problemFrequencyType === "" || vm.descriptionData.problemFrequencyType === undefined)) || (elementName === "standard_exchange" && (vm.reference === "" || vm.reference === undefined)) || (elementName === "customerComplaintReproduced" && (vm.descriptionData && vm.descriptionData.isCustomerComplaintReproduced === "" || vm.descriptionData.isCustomerComplaintReproduced === undefined)))){
                var vehicleData = document.getElementById(elementName);
                vehicleData.classList.add("radioButtonChange");
            }
            else {
                var vehicleData = document.getElementById(elementName);
                vehicleData.classList.remove("radioButtonChange");
            }
        }

        function expandDiagList(){
            vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
            if((!vm.isActisProfil && !vm.isQstomizeTypeFic) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.nonModifiableFic)){
                vm.collapssed = !vm.collapssed;
            }
            else{
                vm.collapssed = false;
            }
        }

        function saveSecondNode(key){
            vm.secondNodeName = key.label ? key.label:"";
            vm.secondNodeId = key.nodeId;
            vm.display = true;
            vm.displaySecondNode = false;
            if(!_.isEmpty(vm.fisrtNodeName) && !_.isEmpty(vm.secondNodeName)){
                vm.isTreeStructureNodeSelected = true;
            }
            systemSubMenuReset(key);
        }
        function clickAccord(){ 
        if(vm.isDraft){
           if(vm.isDraft && vm.descriptionData && vm.descriptionData.fisrtNodeName && vm.descriptionData.secondNodeName){
            vm.collapssed = false;
            vm.isOpen = !vm.isOpen;
            vm.cardBody = true;
           }
           else if(vm.responseApi && vm.responseApi.Request && vm.responseApi.Request.fisrtNodeName && vm.responseApi.Request.secondNodeName){
            vm.isOpen = !vm.isOpen;
            vm.cardBody = true;
           }
           else{
           vm.collapssed = !vm.collapssed;
             
           }
        }
        else if((vm.nonModifiableFic && (vm.status !== 'Answered' && vm.status !== 'Resolved') && (!vm.isFicCancelled || vm.isFicReopen))){
            vm.collapssed = false;
            vm.isOpen = !vm.isOpen;
            vm.cardBody = true;
        }  
        else{
            vm.collapssed = !vm.collapssed;
        } 
        if(!_.isEmpty(vm.fisrtNodeName) && !_.isEmpty(vm.secondNodeName)){
            vm.isTreeStructureNodeSelected = true;
        }
        }
        function onClickFirstNode(key){
            systemSubMenuReset(key);
            vm.secondLevelNode=[];
            vm.fisrtNodeName = key.label ? key.label:"";
            vm.fisrtNodeId = key.nodeId;
            vm.displaySecondNode = false;
            vm.display = false;
           angular.forEach(vm.contextCarSearch.treeNodes.otherLevel.nodes, function (value) {
              
                   if(value.codeParent === key.nodeId){
                       vm.secondLevelNode.push({
                           label:value.label,
                           nodeId:value.nodeId,
                           isActive:key.isActive
                       });
                       vm.displaySecondNode = true;
                   }              
           })
        }
        function systemSubMenuReset(menu){
            vm.firstLevelNode.map(function(item){
                if(menu){
                    if(menu.nodeId == item.nodeId){
                        item.isActive = true;
                    }else{
                        item.isActive = false;
                    }
                }else{
                    item.isActive = false;
                }
                return item;
            })
        }
        function goToAttachmentDoc(){
            vm.ndDocumentsUrl = configConstantes.ndDocumentsUrl;
             vm.attachmentInfoDoc = (vm.user && vm.user.language && ActisConstantes.attachmentPdfDoc[vm.user.language]) ? ActisConstantes.attachmentPdfDoc[vm.user.language] : ActisConstantes.attachmentPdfDoc['en'];
            var url = '';
            url = vm.ndDocumentsUrl + vm.attachmentInfoDoc + '.pdf';
            window.open(url,'_blank');
        }
        this.$onChanges = function () {

            if (vm.isEditMode) {
                vm.or = vm.responseApi.Request.orNumber;
                vm.dateOr = !_.isEmpty(vm.responseApi.Request.orDate) ? moment(vm.responseApi.Request.orDate) : "";
                vm.code = vm.responseApi.Request.symptomCode;

                vm.plianteClientToDisplay = vm.responseApi.Request.customerComplaint;
                vm.reproducedCustomerComplaint = vm.responseApi.Request.isCustomerComplaintReproduced;
                vm.diagnostiqueToDisplay = vm.responseApi.Request.diagnosticComment;
                vm.documentationConsulted = vm.responseApi.Request.isDocumentationConsulted;
                vm.frequenceProbleme = vm.responseApi.Request.problemFrequency;
                vm.problemFrequencyToDisplay = vm.frequenceProbleme;
                vm.dtcCode1 = vm.responseApi.Request.dtcCode1;
                vm.dtcCode2 = vm.responseApi.Request.dtcCode2;
                vm.dtcCode3 = vm.responseApi.Request.dtcCode3;
                vm.problemCharacteristics = vm.responseApi.Request.problemCharacteristics;
                vm.opecode = vm.responseApi.Request.opeCode;
                vm.temps = vm.responseApi.Request.opeCodeTime;
                vm.status = vm.responseApi.CaseDetail.status;
                vm.reference = (vm.responseApi.Request.reference == "yes") ? vm.responseApi.Request.reference : 'no' ;
                
                vm.savedOtsValue = vm.responseApi.Request.selectedOts || vm.responseApi.Request.isDocumentationConsulted;

                vm.savedBtValue = vm.responseApi.Request.selectedBt || (vm.responseApi.Request.tintName === 'Creation tin' ? '' : vm.responseApi.Request.tintName);
                
                getSymptomLongCode().then(processOnChangesAfterSymptomLoad);
            }
        };

        function processOnChangesAfterSymptomLoad() {
            if(!_.isEmpty(vm.responseApi.Request.fisrtNodeName) && !_.isEmpty(vm.responseApi.Request.secondNodeName)){
                vm.display = true;
                vm.fisrtNodeName = vm.responseApi.Request.fisrtNodeName;
                vm.secondNodeName = vm.responseApi.Request.secondNodeName;
                vm.isTreeStructureNodeSelected = true;
            }
            else{
                vm.isTreeStructureNodeSelected = false;
            }
            vm.checkboxesPermanentOrIntermittentValue = vm.responseApi.Request.problemFrequencyType;
            //Check the checkbox of problemFrequencyCharacteristics according to Salesforce data received
            if (vm.responseApi.Request.problemCharacteristics.indexOf('Warm State') !== -1) {
                vm.problemFrequencyHot = true;
            }
            if (vm.responseApi.Request.problemCharacteristics.indexOf('Cold State') !== -1) {
                vm.problemFrequencyCold = true;
            }
            if (vm.responseApi.Request.problemCharacteristics.indexOf('Idle') !== -1) {
                vm.problemFrequencyStoppedCar = true;
            }
            if (vm.responseApi.Request.problemCharacteristics.indexOf('Moving') !== -1) {
                vm.problemFrequencyMovingCar = true;
            }

            if ($state.params.isActisUserComingFromFicConsultation) {
                vm.code = 'M000';
                vm.label = '';
                vm.createMotrioFic = true;
            } else if ($state.params.data && !vm.createMotrioFic && _.isEmpty(vm.responseApi.Car.vin)) {
                vm.code = 'M000';
                vm.label = '';
            }
            calculateShowOtsField();
            calculateShowBtField();
            if (vm.showOtsField) {
                if (!vm.otsData || vm.otsData.length === 0) {
                    loadOtsForVin();
                } else {
                    restoreSelectedOts();
                }
            }
            if (vm.showBtField) {
                var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
                var isDraftStatus = currentStatus === 'Draft';
                var isAnsweredOrResolved = currentStatus === 'Answered' || currentStatus === 'Resolved';

                if (isDraftStatus || isAnsweredOrResolved) {
                    loadBtForSymptom();
                } else {
                    restoreSelectedBt();
                }
            }
        }

        /**
         * @description Used to remove css when the field is populated
         * @param {*} elementName 
         */
        function removeColors(elementName) {
            if (elementName === 'orNumber') {
                FicInputValidationService.removeColors("orNumber");
            } else if (elementName === 'orDate') {
                FicInputValidationService.removeColors("orDate");
            }
        }

        // Used to remove css for symptom code and label fields
        function remove() {
            var symptomCodeInput = document.getElementById('symptomCodeColor');
            $(symptomCodeInput).removeClass("backgroundColorRequiredFields");
            var symptomCodeInputParent = $(symptomCodeInput).parent();
            $(symptomCodeInputParent).removeClass('md-input-invalid');
            var symptomCodeInputParentFirstChild = $(symptomCodeInputParent).children().first();
            var symptomCodeInputParentFirstChildElement = angular.element(symptomCodeInputParentFirstChild);
            symptomCodeInputParentFirstChildElement.removeClass('changeTextColorToRed');
            var symptomLabelInput = document.getElementById('symptomLabelColor');
            $(symptomLabelInput).removeClass("backgroundColorRequiredFields");
            var symptomLabelInputParent = $(symptomLabelInput).parent();
            $(symptomLabelInputParent).removeClass('md-input-invalid');
            var symptomLabelInputParentFirstChild = $(symptomLabelInputParent).children().first();
            var symptomLabelInputParentFirstChildElement = angular.element(symptomLabelInputParentFirstChild);
            symptomLabelInputParentFirstChildElement.removeClass('changeTextColorToRed');
        }

        /**
         * @description Used to remove css when the field is populated
         * @param {*} elementName 
         */
        function removeTextAreaColors(elementName) {
            var element;
            if (elementName === 'plianteClient') {
                element = document.getElementById("plianteClient");
            } else if (elementName === 'diagnostique') {
                element = document.getElementById("diagnostique");
            }
            var elem = angular.element(element);
            $(elem).removeClass('backgroundColorRequiredFields');
            var label = $(element).parent().parent().children().first();
            var e = angular.element(label);
            e.removeClass('changeTextColorToRed');
            var parent = $(element).parent().parent();
            parent.removeClass('md-input-invalid');
        }


        function removeOtsColors() {
            var otsDropdown = document.getElementById('ots-dropdown');
            if (otsDropdown) {
                $(otsDropdown).removeClass('backgroundColorRequiredFieldsOTSDropdown');
            }
            

            var otsContainer = $(otsDropdown).closest('md-input-container');
            if (otsContainer.length) {
                otsContainer.removeClass('md-input-invalid');
            }
            

            var otsLabel = $('label[for="ots-dropdown"]');
            if (otsLabel.length) {
                otsLabel.removeClass('changeTextColorToRed');
            }
        }

            function removeBtColors() {
                var btDropdown = document.getElementById('bt-dropdown');
                if (btDropdown) {
                    $(btDropdown).removeClass('backgroundColorRequiredFieldsBTDropdown');
                }

                var btContainer = $(btDropdown).closest('md-input-container');
                if (btContainer.length) {
                    btContainer.removeClass('md-input-invalid');
                }

                var btLabel = $('label[for="bt-dropdown"]');
                if (btLabel.length) {
                    btLabel.removeClass('changeTextColorToRed');
                }
            }
        

            function calculateShowBtField() {
                vm.showBtField = false;
                var BT_FEATURE_RELEASE_DATE = moment('2026-01-08').startOf('day');
                if (vm.isEditMode && vm.responseApi && vm.responseApi.CaseDetail) {
                    var ficStatus = vm.responseApi.CaseDetail.status;
                    var ficCreationDate = vm.responseApi.CaseDetail.creationDate;
                    var isAnsweredOrResolved = ficStatus === 'Answered' || ficStatus === 'Resolved';
                    if (isAnsweredOrResolved  && (vm.isAlertFic || vm.isTechnicalAssistanceFic || vm.isCalmFic || vm.isGoodPractiseFic || vm.isForBwr || vm.isApprovalFic  || (['Alert CIRs','Technical Assistance CIRs','CALM','BRW','Good Practise','Agreement CIRs'].includes(vm.responseApi.CaseDetail.recordType)))) {
                        vm.showBtField = true;
                        return;
                    }
                    var isSentFic = ficStatus && ficStatus !== 'Draft' && ficStatus !== '';
                    if (isSentFic && ficCreationDate) {
                        var creationDate = moment(ficCreationDate).startOf('day');

                        if (creationDate.isBefore(BT_FEATURE_RELEASE_DATE)) {
                            vm.showBtField = false;
                            return;
                        }
                    }
                    if (ficStatus === 'Closed' && ficCreationDate) {
                        var creationDate = moment(ficCreationDate).startOf('day');
                        if (creationDate.isBefore(BT_FEATURE_RELEASE_DATE)) {
                            vm.showBtField = false;
                            return;
                        }
                    }
                }

                if (vm.isAlertFic || vm.isTechnicalAssistanceFic || vm.isCalmFic || vm.isGoodPractiseFic || vm.isForBwr || vm.isApprovalFic || (vm.responseApi && vm.responseApi.CaseDetail && (['Alert CIRs','Technical Assistance CIRs','CALM','BRW','Good Practise','Agreement CIRs'].includes(vm.responseApi.CaseDetail.recordType)))) {
                    vm.showBtField = true;
                    return;
                }
            }

            function isBtValid() {
                if (vm.selectedBt && vm.selectedBt !== '') {
                    return true;
                }
                if (vm.selectedBt === '' && vm.noBtForVin) {
                    return true;
                }
                return false;
            }

            function isBtFieldDisabled() {
                var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
                var isDraftStatus = !currentStatus || currentStatus === '' || currentStatus === 'Draft';
                var isEditableStatus = isDraftStatus || currentStatus === 'Answered' || currentStatus === 'Resolved';
                if ((!vm.btDropdownOptions || vm.btDropdownOptions.length === 0) && vm.noBtForVin) {
                    return true;
                }

                if (vm.isEditMode && vm.savedBtValue && !isEditableStatus) {
                    return true;
                }
                if (isEditableStatus) {
                    return false;
                }

                return true;
            }
            
            function getSymptomLongCode() {
                if (vm.symptomsLoading) {
                    return $q.resolve(vm.symptomLongCode);
                }
                var symptomShortCode = vm.code;
                if (!symptomShortCode) {
                    vm.symptomLongCode = null;
                    return $q.resolve(null);
                }
                var allSymptoms = CacheService.getObject(CacheConstants.getAllSymptoms);
                if (allSymptoms && allSymptoms.symptoms && allSymptoms.symptoms.length > 0) {
                    var longCode = findLongCodeFromSymptoms(allSymptoms, symptomShortCode);
                    return $q.resolve(longCode);
                } else {
                    vm.symptomsLoading = true;
                    return getAllSymptoms().then(function (symptomsData) {
                        CacheService.setObject(CacheConstants.getAllSymptoms, symptomsData);
                        var longCode = findLongCodeFromSymptoms(symptomsData, symptomShortCode);
                        return longCode;
                    }).catch(function (error) {
                        vm.symptomLongCode = null;
                        return null;
                    }).finally(function () {
                        vm.symptomsLoading = false;
                    });
                }
            }


            function findLongCodeFromSymptoms(symptomsData, symptomShortCode) {
                if (!symptomsData || !symptomsData.symptoms || symptomsData.symptoms.length === 0) {
                    vm.symptomLongCode = null;
                    return null;
                }
                var matchingSymptom = symptomsData.symptoms.find(function (symptom) {
                    return symptom.shortCode === symptomShortCode;
                });
                if (matchingSymptom && matchingSymptom.longCode) {
                    vm.symptomLongCode = matchingSymptom.longCode;
                    if (matchingSymptom.label && matchingSymptom.label.includes("-")) {
                        vm.symptomLabelCode = matchingSymptom.label.split("-")[1].trim();
                    }
                    return vm.symptomLongCode;
                } else {
                    vm.symptomLongCode = null;
                    return null;
                }
            }
            
            function loadBtForSymptom() {
                if (vm.btLoading) {
                    return;
                }
                vm.btLoading = true;
                blockUI.start();
                getSymptomLongCode().then(function (symptomLongCode) {
                    if (!symptomLongCode) {
                        vm.btDropdownOptions = [];
                        vm.filteredBtOptions = [];
                        vm.noBtForVin = true;
                        restoreSelectedBt();
                        blockUI.stop();
                        return;
                    }
                    var userContext = CacheService.getUserContext();
                    var carContext = CacheService.getCarContext();

                    if (!userContext) {
                        vm.btDropdownOptions = [];
                        vm.filteredBtOptions = [];
                        vm.noBtForVin = true;
                        restoreSelectedBt();
                        blockUI.stop();
                        return;
                    }

                    var dataBody = {
                        userContext: userContext,
                        carContext: carContext,
                        docType: {
                            BT: {
                                subType: ["YELLOW", "GREEN", "NO_COLOR"],
                                symptom: [symptomLongCode],
                                dtc: [],
                                defaultCode: []
                            }
                        }
                    };
                    return ResultSearchByDiagnosticMetierService.getAllCodes(dataBody);
                })
                    .then(function (response) {
                        if (response && response.documents && response.documents.length > 0) {
                            var btWithColorType = response.documents.map(function (doc) {
                                return { id: doc.id, subType: doc.subType };
                            });
                            return ResultSearchByDiagnosticMetierService.getBTList(btWithColorType);
                        } else {
                            return { BTInformation: [], noBtForVin: true };
                        }
                    })
                    .then(function (btResponse) {
                        if (btResponse && btResponse.BTInformation && btResponse.BTInformation.length > 0) {
                            var btNames = btResponse.BTInformation.map(function (bt) {
                                return bt.name;
                            });
                            vm.btDropdownOptions = btNames.map(function (btName) {
                                return { name: btName };
                            });
                            vm.filteredBtOptions = angular.copy(vm.btDropdownOptions);
                            vm.noBtForVin = false;
                            restoreSelectedBt();
                            
                            
                        } else {
                            vm.btDropdownOptions = [];
                            vm.filteredBtOptions = [];
                            vm.noBtForVin = true;
                            restoreSelectedBt();
                        }
                    })
                    .catch(function (error) {
                        vm.btDropdownOptions = [];
                        vm.filteredBtOptions = [];
                        vm.noBtForVin = true;
                        restoreSelectedBt();
                    })
                    .finally(function () {
                        blockUI.stop();
                        vm.btLoading = false;
                    });
            }

            function getAllSymptoms() {
                var userContext = CacheService.getUserContext();
                var carContext = CacheService.getObject(CacheConstants.contextCarRequest);

                var data = {
                    userContext: userContext,
                    carContext: carContext
                };

                return ResultSearchByDiagnosticWsService.getAllSymptoms(data)
                    .then(function (response) {

                        var codes = {
                            symptoms: []
                        };

                        if (response && response.symptoms && response.symptoms.length > 0) {
                            var symptoms = response.symptoms.map(function (item) {
                                var longCode = item.longCode;
                                var label = item.label;
                                var shortCode = item.shortCode;

                                if (longCode) {
                                    label = item.shortCode + ' - ' + item.label;
                                }

                                return {
                                    shortCode: shortCode,
                                    longCode: longCode,
                                    label: label
                                }
                            });
                            codes.symptoms = codes.symptoms.concat(symptoms);
                        }

                        codes.symptoms = $filter('orderBy')(codes.symptoms, 'label');

                        codes["symptoms"] = _.sortedUniqBy(codes["symptoms"], function (diag) {
                            return diag.label
                        });

                        return codes;
                    });
            }
            
            function restoreSelectedBt() {
                if (!vm.isEditMode) {
                    if (vm.noBtForVin) {
                        vm.selectedBt = '';
                    } else {
                        vm.selectedBt = null;
                    }
                    return;
                }
                if (vm.isEditMode && vm.savedBtValue !== undefined) {

                    if (vm.savedBtValue === '' && (!vm.btDropdownOptions || vm.btDropdownOptions.length === 0)) {
                        vm.selectedBt = '';
                        vm.noBtForVin = true;
                        return;
                    }
                    
                    if (vm.savedBtValue === 'No') {
                        vm.selectedBt = 'No';
                        vm.noBtForVin = false;
                        $timeout(function () {
                            vm.selectedBt = 'No';
                        }, 100);

                        return;
                    }
                    
                    if (vm.savedBtValue && vm.savedBtValue !== '') {
                        var needsTimeout = false;
                        if (!vm.btDropdownOptions || vm.btDropdownOptions.length === 0) {
                            vm.btDropdownOptions = [{ name: vm.savedBtValue }];
                            vm.filteredBtOptions = angular.copy(vm.btDropdownOptions);
                            vm.noBtForVin = false;
                            needsTimeout = true;
                        } else {
                            var matchingBt = vm.btDropdownOptions.find(function (bt) {
                                return bt.name === vm.savedBtValue;
                            });

                            if (!matchingBt) {
                                vm.btDropdownOptions.unshift({ name: vm.savedBtValue });
                                needsTimeout = true;
                            }
                            vm.filteredBtOptions = angular.copy(vm.btDropdownOptions);
                            vm.noBtForVin = false;
                        }
                        

                        vm.selectedBt = null;
                        $timeout(function () {
                            vm.selectedBt = vm.savedBtValue;
                        }, 50);
                        
                        if (needsTimeout) {
                            $timeout(function () {
                                vm.selectedBt = vm.savedBtValue;
                            }, 150);
                        }

                        return;
                    }
                }
                vm.selectedBt = null;
            }
            
            function getBtCode(selectedBt) {
                if (!selectedBt || selectedBt === '') {
                    return "";
                }

                if (selectedBt === 'No') {
                    return "No";
                }

 
                if (typeof selectedBt === 'object' && selectedBt.name) {
                    return selectedBt.name;
                }
                

                return selectedBt;
            }

                /**
         * @namespace getDocumentationClass
         * @desc get documentation class according to the fic type
         * @param {string} type the selected type fic
         */
        function getDocumentationClass(type) {
            var documentationClass = "";
            switch (type) {
                case 'painting':
                    documentationClass = 'small-12 columns';
                    break;
                case 'accessory':
                    documentationClass = 'small-12 columns';
                    break;
                case 'zeBattery':
                    documentationClass = 'small-4 columns';
                    break;
                case 'others':
                    documentationClass = 'small-4 columns';
                    break;
            }
            return documentationClass;
        }

        function setSelectedCheckboxPermanentOrIntermittent(c) {
            vm.isSelectedCheckbox = true;
        }

        function resetSubcategory() {
            vm.selectedInfoIncident2 = {};
        }

        /**
        * @namespace searchSymptom
        * @desc added to search button on description zone of createFIC page
        */
        function searchSymptom() {
            $mdDialog.show({
                templateUrl: 'app/components/actis/components/symptomsPopIn.template.html',
                clickOutsideToClose: true
            })
            .then(function () {
                return vm.$onInit();
            })
            .catch(function () {
                $log.debug($translate.instant('ERROR'));
            });
        }

        function initialCategory(item){
            if(vm.typeMD === 'B3'){
                if($scope.origin.length === 0){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,item.category)
                            || _.includes(DiagFileDetailsNewConstants.finalCategory,item.category)
                            || _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category ? item.category.toLowerCase() : item.category);
                }
                else{
                    return (_.includes(DiagFileDetailsNewConstants.initialCategory,item.category)
                    || _.includes(DiagFileDetailsNewConstants.finalCategory,item.category)
                    || _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category ? item.category.toLowerCase() : item.category))
                    && (_.includes($scope.origin,item.origin));
                }
            }

            else if(vm.typeMD === 'ADT'){
                if($scope.origin.length === 0){
                    return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category ? item.category.toLowerCase() : item.category);
                }
                else{
                    return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category ? item.category.toLowerCase() : item.category)
                    && _.includes($scope.origin,item.origin);
                }
            }
                
        }

        function diagIconClick(selOrigin){
            var idx = $scope.origin.indexOf(selOrigin);
            var elem = document.getElementById(selOrigin);
            if(idx === -1){
                angular.element(elem).css('background-color', 'var(--renaultPrimaryColor)');
                $scope.origin.push(selOrigin);
            }else{
                angular.element(elem).css('background-color', '#ffffff');
                $scope.origin.splice(idx,1);
            }
            $timeout(function () {
                $scope.$apply();
            }, 0);
        }

        function getDiagDetails(item, currentPage) {
            vm.carContext = CacheService.getCarContext();

            if (!vm.isSearchByModel && vm.carContext && vm.carContext.vin) {
                blockUI.start();
                if (!vm.diagFilesList || (vm.diagFilesList && _.isEmpty(vm.diagFilesList)) || item) {
                    var params = '';
                    var currentPageIndex = !currentPage ? vm.currentPage - 1 : currentPage - 1;
                    if (vm.typeMD === 'ADT') {
                        params = '?vin=' + vm.carContext.vin + '&page=' + currentPageIndex + '&pageSize=' + vm.dataperPage + '&categories=' + DiagFileDetailsNewConstants.healthCheck;
                    }
                    else {
                        params = '?vin=' + vm.carContext.vin;
                    }

                    DiagFileBusinessService.getDiagFilesByVin(params).then(function (response) {
                        if (response && !_.isEmpty(response)
                            && response.data && !_.isEmpty(response.data)) {
                            var filteredResponse = _.map(response.data, function (item) {
                                return _.pick(item, DiagFileDetailsNewConstants.requiredDiagFileFields)
                            });
                            filteredResponse = _.orderBy(filteredResponse, 'captureDateTime', 'desc');
                            processDiagFiles(filteredResponse);
                        }
                        else {
                            vm.diagDataFound = false;
                            vm.currentPage = vm.currentPage - 1;
                            if($state.params && $state.params.data && $state.params.data.type !== "QSTOMIZE"){
                                toastr.info($translate.instant("NO_MORE_DIAG_FILE"));
                            }
                        }
                    }).catch(function (error) {
                        toastr.error(error)
                    }).finally(function () {
                        blockUI.stop();
                    });
                }

                else {
                    vm.diagFilesList = _.orderBy(vm.diagFilesList, 'captureDateTime', 'desc');
                    processDiagFiles(vm.diagFilesList);
                    blockUI.stop();
                }
            }
        }

        function saveSelectedDiag(diagFile) {
            blockUI.start();
            var mileage = Math.round(parseFloat(diagFile.mileage.match(/[+-]?\d+(\.\d+)?/g)));
            var mileageUnit = diagFile.mileage.match(/[a-zA-Z]+/g) ? diagFile.mileage.match(/[a-zA-Z]+/g) : "";
            if (vm.isArcaUser || vm.adtTechrole){
                if (vm.typeMD === 'ADT') {
                    vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage+" "+mileageUnit +" "+ diagFile.dealerId;
                }
                else {
                    vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + Math.round(parseFloat(diagFile.mileage)) + " KM - " + diagFile.dealerId;
                }        
            }

            else{
                if (vm.typeMD === 'ADT') {
                    vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + mileage+" "+mileageUnit;
                }
                else {
                    vm.selectedDiagFile = $filter('momentLocaleDate')(new Date(diagFile.captureDateTime)) + "-" + diagFile.captureDateTime.substring(11, 19) + " - " + Math.round(parseFloat(diagFile.mileage)) + " KM";
                }
            }
                vm.selectedDiagFileId = diagFile.id;

                _.map(vm.diagFilesList, function(item){
                    if(item.id === vm.selectedDiagFileId){
                        if (vm.typeMD === 'ADT') {
                            _.assign(item, { mileage: mileage+" "+mileageUnit});
                        }
                    }
                })
                blockUI.reset();
            }

        function processDiagFiles(diagFilesList){
            var tempDiagList = [];
            if(vm.typeMD === 'B3'){
                tempDiagList = diagFilesList.filter(function(item){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,item.category);
                });

                vm.initialDiagFile = tempDiagList[0];
                vm.diagFilesList = diagFilesList.filter(function(obj){
                    return _.includes(DiagFileDetailsNewConstants.initialCategory,obj.category)
                        || _.includes(DiagFileDetailsNewConstants.finalCategory,obj.category)
                        || _.includes(DiagFileDetailsNewConstants.healthCheckCategory,obj.category.toLowerCase());
                });
            }

            else if(vm.typeMD === 'ADT'){
                tempDiagList = diagFilesList.filter(function(item){
                    return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,item.category.toLowerCase());
                });

                vm.diagFilesList = diagFilesList.filter(function(obj){
                    return _.includes(DiagFileDetailsNewConstants.healthCheckCategory,obj.category.toLowerCase())
                            || _.includes(DiagFileDetailsNewConstants.customerReportCategory,obj.category.toLowerCase());
                });

                $timeout(function() {
                    if($scope.origin.length > 0){
                        $scope.origin.forEach(function(item){
                            var elem = document.getElementById(item);
                            angular.element(elem).css('background-color', 'var(--renaultPrimaryColor)');
                        })
                    }
                });

                _.map(vm.diagFilesList, function (item) {
                    if(item.mileage){
                        var mileageData = item.mileage.split(" ");
                        if(mileageData.length === 2){
                            var mileage = parseInt(mileageData[0]);
                            _.assign(item, { mileage: mileage+" " +mileageData[1]})
                        }
                    }
                })
            }
        
            if(tempDiagList && !_.isEmpty(tempDiagList)){
                saveSelectedDiag(tempDiagList[0]);
            }
            blockUI.stop();
        }
 
        function getPagedData(page) {
            if (page != vm.currentPage){
                vm.currentPage = page;
                getDiagDetails(true);
            }
        }


        function calculateShowOtsField() {
            vm.showOtsField = false;

            if(vm.isPiloteFic){
                vm.showOtsField = false;
                return;
            }
            
            if (vm.type === 'zeBattery') {
                vm.showOtsField = true;
                return;
            }
            
            if (vm.type === 'others' && (vm.isTechnicalAssistanceFic || vm.isApprovalFic || vm.isAlertFic || vm.isGoodPractiseFic)) {
                vm.showOtsField = true;
                return;
            }
            
            if (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.recordType) {
                var recordType = vm.responseApi.CaseDetail.recordType;
                if (recordType === 'Technical Assistance CIRs' ||
                    recordType === 'Agreement CIRs' ||
                    recordType === 'Alert CIRs' ||
                    recordType === 'Good Practise' ||
                    recordType === 'ZE Battery') {
                    vm.showOtsField = true;
                }
                return;
            }
        }

        function isOtsFieldDisabled() {
            var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
            var isDraftStatus = !currentStatus || currentStatus === '' || currentStatus === 'Draft';
            var isEditableStatus = isDraftStatus || currentStatus === 'Answered' || currentStatus === 'Resolved';
            
            if ((!vm.otsData || vm.otsData.length === 0) && vm.selectedOts === 'noOtsAvailable') {
                return true;
            }
            
            if (currentStatus === 'Closed') {
                var isReopenClicked = !vm.isFicReopen && vm.isDaysToReopen && vm.isSaveButtonVisible;
                return !isReopenClicked;
            }

            if (isEditableStatus) {
                return false;
            }

            return true;
        }


        function getOtsCode(selectedOts) {
             if (selectedOts === 'notLinked') {
                return "No";
            }else if(selectedOts === 'noOtsAvailable'){
                return "";
            }
            return selectedOts;
        }


        function loadOtsForVin() {
            var carContext = CacheService.getCarContext();
            var userContext = CacheService.getUserContext();
            var locale = userContext.language + '_' + userContext.countryCode || '';
            var vin = null;
            
            var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
            var isCreationMode = !vm.isEditMode || vm.createMotrioFic || !currentStatus || currentStatus === '';
            
            if (isCreationMode) {
                if (carContext && carContext.vin) {
                    vin = carContext.vin;
                }
            } else {
                    vin = vm.responseApi.Car.vin;
            }
            
            if (vin) {
                if (vm.otsLoadedForVin === vin || vm.otsApiCallInProgress) {
                    restoreSelectedOts();
                    return;
                }
                
                if (vm.isEditMode && vm.otsData && vm.otsData.length > 0) {
                    vm.otsLoadedForVin = vin;
                    restoreSelectedOts();
                    return;
                }
                
                vm.otsApiCallInProgress = true;

                var queryParams = {
                    colorCodes: 'R,B,J,V,S,I,O',
                    local: locale
                };
                
                CarOtsMetierService.getOtsInformation(vin, queryParams)
                    .then(function(response) {
                        if (response && response.length > 0) {
                            vm.otsData = response.map(function(ots) {
                                return {
                                    id: ots.code,
                                    otsNumber: ots.code,
                                    colorCode: ots.colorCode,
                                    designation: ots.label,
                                    otsCode: ots.code,
                                    description: ots.description,
                                    technicalNoteNumber: ots.technicalNoteNumber,
                                    quotation: ots.quotation,
                                    agreement: ots.agreement,
                                    deliveryDate: ots.deliveryDate,
                                    isCustomerVisible: ots.isCustomerVisible
                                };
                            });

                            vm.otsColorData = vm.otsData.reduce(function(acc, ots) {
                                acc[ots.otsNumber] = ots.colorCode;
                                return acc;
                            }, {});

                            CreateActisBusinessService.setOtsColorData(vm.otsColorData);

                        } else {
                            vm.otsData = [];
                        }
                        vm.otsLoadedForVin = vin;
                        restoreSelectedOts();
                    }).catch(function(error) {
                        vm.otsData = [];
                        vm.otsLoadedForVin = vin;
                        restoreSelectedOts();
                    }).finally(function() {
                        vm.otsApiCallInProgress = false;
                    });
            } else {
                restoreSelectedOts();
            }
        }

        function restoreSelectedOts() {
            var currentStatus = vm.status || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status);
            var isDraftStatus = !currentStatus || currentStatus === '' || currentStatus === 'Draft';
            var isEditableStatus = isDraftStatus || currentStatus === 'Answered' || currentStatus === 'Resolved';
            var savedOtsValue = vm.isEditMode ? (vm.responseApi.Request.selectedOts || vm.responseApi.Request.isDocumentationConsulted) : null;
            
            if (!vm.isEditMode) {
                if (!vm.otsData || vm.otsData.length === 0) {
                    vm.selectedOts = "noOtsAvailable";
                } else {
                    vm.selectedOts = "";
                }
                return;
            }
            
            if (vm.isEditMode && (!vm.otsData || vm.otsData.length === 0)) {
                vm.selectedOts = "noOtsAvailable";
                return;
            }
            
            if (vm.isEditMode) {
                if (savedOtsValue && savedOtsValue !== "No" && savedOtsValue !== "" && savedOtsValue !== null && savedOtsValue !== undefined) {
                    vm.selectedOts = savedOtsValue;
                    return;
                }
                
                if (savedOtsValue === "No") {
                    vm.selectedOts = "notLinked";
                    return;
                }
                
                if (savedOtsValue === null || savedOtsValue === "" || savedOtsValue === undefined) {
                    if (isEditableStatus || vm.isFicReopen) {
                        vm.selectedOts = "";
                    } 
                    /* else {
                        vm.selectedOts = "notLinked";
                    } */
                    return;
                }
            }
            
            vm.selectedOts = "";
        }

        function toggleDiagnosticInfo() {
            vm.showPlusIcon = !vm.showPlusIcon;
            vm.showAdditionalDiagnosticMessage = !vm.showAdditionalDiagnosticMessage;
        }

    }
})();

/**
 * batteryComponent
 * @namespace Components
 */
 (function () {
    angular
        .module('phenix')
        .component('batteryDetails', {
            bindings: {
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isDraft: '<',
                isFicCreation: '<',
                isDaysToReopen: '<',
                isFicReopen: '<',
                isFicCancelled: '<',
                isIndependentUser:'<',
                isForBwr: '<'
            },
            controller: BatteryDetailsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/battery-details.template.html'
        });

        function BatteryDetailsController(
            CacheService,
            CacheConstants,
            $scope,
            FicInputValidationService,
            ActisConstantes,
            $rootScope,
            blockUI,
            CarSearchMetierService,
            toastr,MainMetierService) {

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;
            vm.vehicle = {};
            vm.carContext = CacheService.getCarContext();
            vm.SymptomsEnable=vm.carContext ? true : false;
            vm.isBatteryOpen = false;
            vm.isActisProfil = MainMetierService.isActisProfilNoContext();
            /*=============================================
            =                 FUNCTIONS                   =
            =============================================*/


            vm.getVal = getVal;
            vm.removeColors = removeColors;
            vm.getBinCarContext=getBinCarContext;
            vm.getVin = getVin;
            vm.getBin=getBin;
            vm.mapBinAndVinNumbers=mapBinAndVinNumbers;
            vm.currentDate = MainMetierService.getCurrentDate();



            /**
             * Create a listener to listen from Actis.constoler (broadcast)
             * in order to call getVehicleData()
             */
            $scope.$on('getFicData', function(event) {
                $scope.$emit("loadFicData", $scope.getBatteryDetails());
            });

            function getVal(val) {
                vm.unitMileage = val;
            }

            function getVin(val) {
                vm.vin = val;
            }
            function getBin(val) {
                vm.bin = val;
            }
            function mapBinAndVinNumbers()
            {  
                if(vm.isFicCreation == false && !_.isEmpty(vm.responseApi)){
                    vm.vin = vm.responseApi.Car.vin;
                    vm.bin = vm.responseApi.Car.bin;
                }

                else {
                    vm.vin = vm.carContext ? vm.carContext.vin : '';
                    vm.bin = vm.carContext ? vm.carContext.bin : '';
                }
            getBinCarContext(vm.vin);

            }


            /**
         * @description Used to remove css when the field is populated
         * @param {*} elementName 
         */
        function removeColors(elementName) {
            //if (elementName === 'orNumber') {
                FicInputValidationService.removeColors(elementName);
            /* } else if (elementName === 'orDate') {
                FicInputValidationService.removeColors("orDate");
            } */
        }
       
        function getBinCarContext(vin)
        {
            vm.SymptomsEnable=false;
            if(vin && !_.isEmpty(vin)){
                blockUI.start();
                CarSearchMetierService.searchCar({vin: vin}).then(function(){
                    CarSearchMetierService.getBannerData().then(function(){
                        vm.carContext = CacheService.getCarContext();
                        vm.SymptomsEnable=vm.carContext ? true : false;
                        if(vm.bin == '' && vm.carContext.bin){
                            vm.bin = vm.carContext.bin;
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
                }).catch(function (errorMessage) {
                    toastr.error(errorMessage.msg);  
                    vm.vin='';
                    vm.bin='';
                    vm.SymptomsEnable=false;
                    blockUI.stop();
                });
            }
          
        }

            /**
             * return Current data contained in the view at the moment when the method is called
             * @returns Car object
             */
            $scope.getBatteryDetails = function(){

                vm.vehicle.mileageValue = vm.packMileage;
                vm.vehicle.isVehicleMobilised = vm.batTrans;
                vm.vehicle.vin = vm.vin;
                vm.vehicle.bin = vm.bin;

                if(vm.unitMileage && vm.unitMileage.toUpperCase() == ActisConstantes.km){
                    vm.vehicle.mileageUnit = ActisConstantes.km;
                }else if (vm.unitMileage && vm.unitMileage.toUpperCase() == ActisConstantes.miles.toUpperCase()){
                    vm.vehicle.mileageUnit = ActisConstantes.miles;
                }else{
                    vm.vehicle.mileageUnit = ActisConstantes.km;
                }

                var contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
                vm.code = contextSearchedSymptom ? contextSearchedSymptom.code : '';

                return {"Car": vm.vehicle,
                        "Request":{
                            "orNumber": vm.repairOrder,
                            "orDate": vm.dateOr ? moment(vm.dateOr).format("YYYY-MM-DD") : "",
                            "symptomCode": vm.code ? vm.code.trim() : ''
                        }
                };
            };


            this.$onInit = function () {
                
                if(vm.isDraft && !vm.nonModifiableFic){
                    vm.isBatteryOpen = true;
                }
                mapBinAndVinNumbers()
            };

            this.$onChanges = function () {
                if(vm.responseApi && vm.isEditMode){
                    vm.repairOrder = vm.responseApi.Request.orNumber;
                    vm.status = vm.responseApi.CaseDetail.status;
                    vm.dateOr = vm.responseApi.Request.orDate;
                    vm.code = vm.responseApi.Request.symptomCode;
                    vm.packMileage = vm.responseApi.Car.mileageValue;
                    vm.unitMileage = vm.responseApi.Car.mileageUnit;
                    vm.batTrans = vm.responseApi.Car.isVehicleImmobilised;
                    CacheService.setObject('sympFromActis', vm.responseApi.Request.symptomCode);
                }
            }
           
        }
})();

(function () {

    angular
        .module('phenix')
        .component('attachmentActis', {
            bindings: {
                type: '@',
                file: '=',
                fileName: '=',
                fileType: '=',
                fileSize: '=',
                nonModifiableFic: '<',
                template: '@',
                responseApi: '<',
                isEditMode: '<',
                isStatusPresent: '<',
                saveFic: '<',
                onDeleteFic: '<',
                isDraft: '<',
                isActisFromDiag: '<',
                isForQstomize:'<',
                isIndependentUser:'<',
                isTreeStructureNodeSelected:'<',
                isAlertFic:'<'
            },
            controller: AttachmentActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/attachment-actis.template.html'
        })
        .component('attachmentBrwActis', {
            bindings: {
                type: '@',
                file: '=',
                fileName: '=',
                fileType: '=',
                fileSize: '=',
                nonModifiableFic: '<',
                template: '@',
                responseApi: '<',
                isEditMode: '<',
                isStatusPresent: '<'
            },
            controller: AttachmentActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/attachmentBRW-actis.template.html'
        })
        .component('discussionAttachmentActis', {
            bindings: {
                type: '@',
                file: '=',
                fileName: '=',
                fileType: '=',
                fileSize: '=',
                nonModifiableFic: '<',
                template: '@',
                responseApi: '<',
                isEditMode: '<',
                isStatusPresent: '<',
                isFicReopen: '<'
            },
            controller: AttachmentActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/discussion-attachment-actis.template.html'
        });


    function AttachmentActisController(
        $q,
        $http,
        $scope,
        CacheService,
        CacheConstants,
        ActisConstantes,
        toastr,
        $rootScope,
        $attrs,
        CreateActisBusinessService,
        $translate,
        $filter,
        $interval,
        configConstantes,
        ActisFicModalService,
        FicViewListWSService,
        RoutesConstants,        
        $window,
        $mdDialog,$log,RestUpgrade, MainMetierService,$state) {

        var vm = this;
        var cancelDefer = $q.defer();

        var intervals = [];
        var putRequests = [];
        vm.totalPages = 0;
        vm.pageNumber=0;
        vm.fic = {};
        vm.isAttachmentOpen = false;
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.isQstomizeTypeFic = $state && $state.params && $state.params.data && $state.params.data.type === 'QSTOMIZE';
        vm.isQstomizeClosedFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Closed';
        vm.isQstomizeSentFic = $state && $state.params && $state.params.data && $state.params.data.status === 'Sent';
        vm.cancelIntervals = cancelIntervals;
        vm.cancelPutRequests = cancelPutRequests;
        vm.getAllAttachments = getAllAttachments;
        vm.getMoreAttachments = getMoreAttachments;
        vm.saveFicHeader = saveFicHeader;
        vm.handleQstomize = handleQstomize;
        vm.changeAttachmentBoxColor = changeAttachmentBoxColor;
        vm.close = close;
        vm.backToPrevious = backToPrevious;
        if ($attrs.template === "discussion") {
            $scope.$parent.isDiscussionCommentBox = vm.isDiscussionCommentBox;
            $scope.$parent.isFicReopen = vm.isFicReopen;
            $scope = $scope.$parent;
        }
        $scope.$watch('files', function () {
            $scope.checkAlreadyUploadedFiles($scope.files);
        });
        $scope.$watch('file', function () {
            if ($scope.file != null) {
                $scope.files = [$scope.file];
            }
        });
        $scope.$on("$destroy", function () {
            window.onbeforeunload = null;
            vm.cancelIntervals();
        });
        window.onbeforeunload = function () {
            vm.cancelPutRequests();
            vm.cancelIntervals();
        };
        $scope.$on('$stateChangeStart', function (event, toState, toParams, previousState) {
            vm.cancelPutRequests();
            vm.cancelIntervals();
        });
        $rootScope.$on("saveOrSendCheck",function (event,data){
                vm.ficSend = data.isNewFicType;
            });
        $rootScope.$on("closeAttachments", function(event, name) {
            vm.isDiscussionCommentBox = name.isDiscussionCommentBox;
            vm.isFicReopen = name.isFicReopen;
            $scope.filesToBeShown = name.filesToBeShown;
            $scope.rDocIdsAndFileNames = name.rDocIdsAndFileNames;
            if(!vm.isDiscussionCommentBox && vm.isFicReopen){
                if(!_.isEmpty($scope.filesToBeShown)){
                    $scope.close($scope.filesToBeShown[0], 0, true);
                }
            }
        });
        function changeAttachmentBoxColor(attachmentBox){
            const vehicleData = document.getElementById(attachmentBox);
            if(vm.isAlertFic){
                if(vm.ficSend){
                    if((_.isEmpty(vm.showCoTechFilesInAttachment) || (vm.showCoTechFilesInAttachment.length === 0)) && $scope.filesToBeShown.length === 0){
                        vehicleData.classList.add("drop-box-red");
                    }
                    else{
                        vehicleData.classList.remove("drop-box-red");
                    }
                }
                else {
                    vehicleData.classList.remove("drop-box-red");
                }
            }
        }
        function cancelIntervals() {
            intervals.forEach(function (promise) {
                if (promise != null) {
                    $interval.cancel(promise);
                    promise = null;
                }
            });
            intervals.length = 0;
        }

        function cancelPutRequests() {
            cancelDefer.resolve("cancelled");
            cancelDefer.reject();  // Reject just in case
            cancelDefer = $q.defer();
        }

        /**
         * @description Used to check if there are any files already uplaoded
         * If yes, then do not upload the same file again and display a toastr error
         * If no, then upload the file
         */
        $scope.checkAlreadyUploadedFiles = function (files) {
            var isFileAlreadyPresent = false;
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                vm.showCoTechFilesInAttachment.forEach(function (item) {
                    if (files[0].name === item.fileName && files[0].type === item.fileType) {
                        isFileAlreadyPresent = true;
                        toastr.error($translate.instant("FILE_UPLOAD_ERROR"));
                        return;
                    }
                })
            } else {
                $scope.upload($scope.files);
            }

            if (!isFileAlreadyPresent && vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                $scope.upload($scope.files);
            }
        }

        $scope.files = [];
        $scope.filesToBeShown = [];
        $scope.sizeTable = [];
        $scope.log = '';
        $scope.onLoading = 0;
        $scope.isLoading = false;
        $scope.rDocIdsAndFileNames = [];
        $scope.delete = false;
        /**
         * Triggered by any change of the UI
         * Used to update the view
         */

        vm.$onChanges = function () {
            if (vm.isEditMode) {
                var eventId = vm.responseApi.CaseDetail.caseId;
                vm.status = vm.responseApi.CaseDetail.status;

                //Used to populate the array to display the added files in attachment component
                if (eventId && vm.status === 'Draft') {
                    vm.pageNumber = 0;
                    vm.getAllAttachments(eventId,true);
                }
            }
            if(_.isEmpty(vm.responseApi)){
                vm.isQstomizeTypeFic = false;
                vm.isQstomizeClosedFic = false;
                if(!_.isEmpty($scope.filesToBeShown)){
                    $scope.filesToBeShown = [];
                }
            }
        }
        function getMoreAttachments() {  
            var eventId = vm.responseApi.CaseDetail.caseId;          
            if (vm.pageNumber < vm.totalPages) {
                vm.getAllAttachments(eventId,false);
            }
        }

        function getAllAttachments(eventId,firstCall){
            var url = ActisConstantes.endpoint.wiredRDocIdSearch + "?q=eventId==" + eventId+ '&page=' + vm.pageNumber + '&size='+ActisConstantes.rdoc_page_size+'&sort='+ActisConstantes.rdoc_sort;
                    CreateActisBusinessService.displayAttachments(url).then(function (resp) {
                        if (resp && resp.data.length > 0) {
                            vm.pageNumber = vm.pageNumber + 1;
                            if(firstCall){
                                vm.showCoTechFilesInAttachment = [];
                                vm.totalPages = resp.totalPages;
                            }
                            var consultationFIC = CacheService.getObject('consultationFIC');
                            if (firstCall)
                                consultationFIC.attachments = resp.data;
                            else
                                consultationFIC.attachments = consultationFIC.attachments.concat(resp.data);
                            CacheService.setObject('consultationFIC', consultationFIC);
                                vm.providerSystem = ActisConstantes.attachmentProviderSystem;
                                resp.data.forEach(function (item) {
                                if ($scope.files && $scope.files.length && $scope.files[0].name === item.fileName && $scope.files[0].type === item.fileType) {
                                    return;
                                } else {
                                    vm.scannedStatusOk = ActisConstantes.attachment_scannedStatus_ok;
                                    if (item.providerSystem === vm.providerSystem && item.scannedStatus !== ActisConstantes.attachment_scannedStatus_ok) {
                                        var rDocId = item.rDocId;
                                        var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                        CreateActisBusinessService.close(url);
                                    } else if (!vm.isActisFromDiag && item.scannedStatus === ActisConstantes.attachment_scannedStatus_ok) {
                                        if(!_.isEmpty(consultationFIC) && !_.isEmpty(consultationFIC.attachments)){
                                            vm.showCoTechFilesInAttachment = consultationFIC.attachments;
                                            $scope.filesToBeShown.forEach(function (data) {
                                                var oldindex = _.findIndex(vm.showCoTechFilesInAttachment, function (obj) {
                                                    return obj.fileName == data.name;
                                                });
                                                if (oldindex !== -1) {
                                                    vm.showCoTechFilesInAttachment.splice(oldindex, 1)
                                                }
                                                else{
                                                    vm.showCoTechFilesInAttachment.push(item);
                                                }
                                                });
                                        }
                                        vm.showCoTechFilesInAttachment = _.uniqBy(vm.showCoTechFilesInAttachment, 'fileName');
                                    }
                                }
                            })
                        }
                    });
        }
        /**
         * Create a listener to listen from Attachment Actis component (broadcast)
         * in order to call getAttachmentData()
         */

        $rootScope.$on('getFileData', function (event) {
            $rootScope.$emit("loadAttachmentData", $scope.getAttachmentData());
        });


        /**
         * return Current data contained in the view at the moment
         * where the methode is called
         * @returns {*}
         */
        $scope.getAttachmentData = function () {
            return $scope.isLoading;
        };


        /**
         * @namespace upload
         * @desc upload file to server
         * @param {files} selected file to be uploaded
         */

        $scope.upload = function (files) {

            var user = CacheService.getObject(CacheConstants.profil);
            var carContext = CacheService.getObject(CacheConstants.contextCarRequest);

            if (files && files.length == 1) {
                var file = files[0];
                var vin = "", brand = "";

                var body;
                var responseApi = CacheService.getObject(CacheConstants.actisResponse);
                
                if (_.isEmpty(carContext)) {
                    if (!_.isEmpty(responseApi)) {
                        vin = responseApi.Car.vin;
                        brand = responseApi.Car.brand;
                    } else {
                        toastr.error($translate.instant('ALERTS_ERROR_HTL'));
                        return;
                    }
                } else {
                    brand = carContext.brandComputed;
                    vin = carContext.vin;
                }

                var currentDate = new Date();
                var formattedCurrentDate = $filter('date')(currentDate, 'yyyy-MM-dd HH:mm:ss');
                // Add 10 years to the current date
                currentDate.setFullYear(currentDate.getFullYear() + 10);
                // Format the new date using AngularJS $filter
                var formattedDateAfter10Years = $filter('date')(currentDate, 'yyyy-MM-dd HH:mm:ss');

                if(!_.isEmpty(responseApi)){
                    if ($attrs.template === "discussion") {
                        body = {
                            "fileName": file.name,
                            "fileType": file.type,
                            "documentType": 'ATTACHMENT_CASE',
                            "country": "FR",
                            "dealerId": (!_.isEmpty(user)) ? user.dealerId : null,
                            "eventType": (responseApi.CaseDetail && responseApi.CaseDetail.caseNumber) ? responseApi.CaseDetail.caseNumber : null,
                            "eventId": (responseApi.CaseDetail && responseApi.CaseDetail.caseId) ? responseApi.CaseDetail.caseId : '',
                            "brand": brand,
                            //"providerSystem": providerSystem,
                            "vin": vin,
                            "lang": (!_.isEmpty(user)) ? user.language:null,
                            "localDate": formattedCurrentDate,
                            "purgeDate": formattedDateAfter10Years
                        }
                    } else if ($attrs.template === 'attachment' || $attrs.template === 'attachmentBrw') {
                        body = {
                            "fileName": file.name,
                            "fileType": file.type,
                            "documentType": 'ATTACHMENT_CASE',
                            "country": "FR",
                            "dealerId": (!_.isEmpty(user)) ? user.dealerId :null,
                            //"eventType": eventType,
                            "eventId": (responseApi.CaseDetail && responseApi.CaseDetail.caseId) ? responseApi.CaseDetail.caseId : '',
                            "brand": brand,
                            //"providerSystem": providerSystem,
                            "vin": vin,
                            "lang": (!_.isEmpty(user)) ? user.language:null,
                            "localDate": formattedCurrentDate,
                            "purgeDate": formattedDateAfter10Years
                        }
                    }


                    if (!file.$error) {
                        $scope.delete=false;
                        var url = ActisConstantes.endpoint.listCase + "FR";
                        var itemObject = {};

                        RestUpgrade.all(url).post(body).then(function (response) {

                            //Check if url from S3 is valid
                            if (response && response.temporaryUrl) {
                                    const vehicleData = document.getElementById('attachmentBox');
                                    if(!_.isEmpty(vehicleData)){
                                        vehicleData.classList.remove("drop-box-red");
                                    }             
                                $scope.rDocId = response.rDocId;
                                $scope.fileName = response.fileName;
                                $scope.fileType = response.fileType;
                                itemObject['rDocId'] = $scope.rDocId;
                                itemObject['fileName'] = $scope.fileName;
                                itemObject['fileType'] = $scope.fileType;
                                itemObject['file'] = $scope.file;

                                $scope.rDocIdsAndFileNames.push(itemObject);

                                $scope.isLoading = true;

                                var httpPutPromise = $http({
                                    method: 'PUT',
                                    url: response.temporaryUrl,
                                    headers: { 'Content-Type': undefined },
                                    data: $scope.file,
                                    transformRequest: [],
                                    timeout: cancelDefer.promise,
                                    eventHandlers: {
                                        progress: function (event) {
                                            $scope.onLoading = 0;
                                        }
                                    },
                                    uploadEventHandlers: {
                                        progress: function (e) {
                                            if (e.lengthComputable) {

                                                $scope.onLoading = Math.round((e.loaded / e.total) * 90);
                                                return $scope.onLoading;
                                            }
                                        }
                                    }
                                })
                                    .then(function () {

                                        var times = 5;
                                        var promise = $interval(
                                            function () {
                                                var retry = 5 - (times++);
                                                CreateActisBusinessService.getDocInfoByRdocId($scope.rDocId).then(function (response) {
                                                    if (response.scannedStatus === ActisConstantes.attachment_scannedStatus_ok) {
                                                        $interval.cancel(promise);
                                                        promise = null;
                                                    }
                                                }).catch(function () {
                                                    $log.debug($translate.instant('ERROR'));
                                                });

                                                if (retry == 5) { //cancel in 30 seconds instead .. for some reason

                                                    var url = ActisConstantes.endpoint.wiredRDocId + $scope.rDocId;
                                                    CreateActisBusinessService.close(url).then(function (response) {
                                                        //delete fic from the UI specificaly with index zero and true
                                                        $scope.close($scope.file, 0, true);
                                                        toastr.error($translate.instant('ACTIS_ERROR_UPLOAD'));

                                                    }).finally(function () {
                                                        $interval.cancel(promise);
                                                        promise = null;
                                                    });
                                                }
                                            }, 5000, 5);
                                        intervals.push(promise);
                                        return $scope.onLoading = 100;

                                    }).finally(function () {
                                        $scope.isLoading = false;
                                    });

                                putRequests.push(httpPutPromise);
                            }
                        });
                    }
                }
                Array.prototype.push.apply($scope.filesToBeShown, $scope.files);
                $rootScope.$broadcast("fileAttachments", {
                    filesToBeShown: $scope.filesToBeShown,
                    rDocIdsAndFileNames: $scope.rDocIdsAndFileNames
                });
                $scope.filesToBeShown = _.uniqBy($scope.filesToBeShown, 'name');
            }
        };

        /**
         * @namespace fileConvertSize
         * @desc convert file size to standard size
         * @param {aSize} file size in bytes
         */

        $scope.fileConvertSize = function (aSize) {
            aSize = Math.abs(parseInt(aSize, 10));
            var def = [
                [1, 'octets'],
                [1024, 'Ko'],
                [1024 * 1024, 'Mo'],
                [1024 * 1024 * 1024, 'Go'],
                [1024 * 1024 * 1024 * 1024, 'To']
            ];
            for (var i = 0; i < def.length; i++) {
                if (aSize < def[i][0] && def[i - 1]){
                    return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
                }
            }
        };

        /**
         * @description Used to download a file on click of its' name
         * @param rDocId
         */
        $scope.downloadPdf = function (file, index) {
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0 && !file && (index || index == 0)) {
                vm.showCoTechFilesInAttachment.forEach(function (item) {
                    if (index == vm.showCoTechFilesInAttachment.indexOf(item)) {
                        var rDocId = item.rDocId;
                        var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                        CreateActisBusinessService.downloadPdf(url);
                    }
                })
            } else if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0) {
                $scope.rDocIdsAndFileNames.forEach(function (item) {
                    if (item.fileName === file.name && item.fileType === file.type) {
                        var rDocId = item.rDocId;
                        var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                        CreateActisBusinessService.downloadPdf(url);
                    }
                })
            } else {
                var rDocId = file.rDocId;
                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                CreateActisBusinessService.downloadPdf(url);
            }
        }

        /**
         * @namespace close
         * @desc remove line from attachment list
         * @param {index} file index in list
         */

        $scope.close = function (file, index, isFromManageFicPage) {
            if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0 && (index || index == 0) && !isFromManageFicPage) {
                if (index === vm.showCoTechFilesInAttachment.length - 1) {
                    cancelDefer.resolve("cancelled");
                    cancelDefer.reject();  // Reject just in case
                    cancelDefer = $q.defer();
                    $scope.isLoading = false;
                    $scope.onLoading = 0;
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                        vm.showCoTechFilesInAttachment.forEach(function (item) {
                            if (index === vm.showCoTechFilesInAttachment.indexOf(item)) {
                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url);
                            }
                        });
                    }
                    vm.showCoTechFilesInAttachment.splice(index, 1);
                } else {
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if (vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0) {
                        vm.showCoTechFilesInAttachment.forEach(function (item) {
                            if (index === vm.showCoTechFilesInAttachment.indexOf(item)) {
                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url);
                            }
                        });
                    }
                    vm.showCoTechFilesInAttachment.splice(index, 1);
                }
            } else if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0 && isFromManageFicPage) {
                if (file === $scope.filesToBeShown.length - 1) {
                    cancelDefer.resolve("cancelled");
                    cancelDefer.reject();  // Reject just in case
                    cancelDefer = $q.defer();
                    $scope.isLoading = false;
                    $scope.onLoading = 0;

                    // Select the correct file and create the URL according to its RDocId and call the service
                    if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length > 0) {
                        $scope.rDocIdsAndFileNames.forEach(function (item) {
                            if (item.file === file) {

                                var removedIndex = $scope.rDocIdsAndFileNames.indexOf(item);

                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url).then(function () {

                                    if (removedIndex > -1) {
                                        $scope.rDocIdsAndFileNames.splice(removedIndex, 1);
                                    }
                                });
                            }
                        });
                    }
                    $scope.filesToBeShown.splice(file, 1);
                } else {
                    // Select the correct file and create the URL according to its RDocId and call the service
                    if ($scope.rDocIdsAndFileNames && $scope.rDocIdsAndFileNames.length) {
                        $scope.rDocIdsAndFileNames.forEach(function (item) {
                            if (item.file === file) {

                                var removedIndex = $scope.rDocIdsAndFileNames.indexOf(item);

                                var rDocId = item.rDocId;
                                var url = ActisConstantes.endpoint.wiredRDocId + rDocId;
                                CreateActisBusinessService.close(url).then(function () {

                                    if (removedIndex > -1) {
                                        $scope.rDocIdsAndFileNames.splice(removedIndex, 1);
                                    }
                                });
                            }
                        });
                    }
                    $scope.filesToBeShown.splice(index, 1);
                    $scope.delete =true;
                }
            }
            else{
                $scope.filesToBeShown.splice(index, 1);
                $scope.delete = true;
            }
        };


        /**
         * @namespace showProgressBar
         * @desc add specific rules to show progress bar during file upload
         * @param {index} file index in list
         */

        $scope.showProgressBar = function (index) {
            if ($scope.onLoading !== 100 && (index === $scope.filesToBeShown.length - 1) && $scope.isLoading === true ) {
                if($scope.delete ==false){
                    return true;
                }
               
               
            } else if (index > $scope.filesToBeShown.length - 1) {
                return false;
            }
        };
        $scope.getFileData = function () {
            $rootScope.$broadcast('getFileData');
        };

        function handleQstomize(isUpdate, isTreeStructureNodeSelected) {
            if (vm.isForQstomize && !$scope.isLoading) {
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: false,
                    locals: {
                        message: $translate.instant("QSTOMIZE_WARNING")
                    }
                }).then(function (confirm) {
                    if (confirm) {
                        saveFicHeader(isUpdate);
                    }
                }).catch(function () {
                    toastr.error($translate.instant('QSTOMIZE_TOASTR'));
                });
            } else {
                saveFicHeader(isUpdate, isTreeStructureNodeSelected);
            }
        }
    
        function saveFicHeader(isUpdate, isTreeStructureNodeSelected) {
            $scope.getFileData();
            if ($scope.isLoading) {
                var body = angular.element(document.body);
                var modalParams = {
                    body: body,
                    designation: '',
                    isList: false,
                    title: "FILE_UPLOAD_MESSAGE",
                    ref: ''
                };
                ActisFicModalService.showModal(modalParams)
                    .then(function () {
                        vm.onDeleteFic();
                    })
                    .catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
            } else {
                vm.saveFic(isUpdate, isTreeStructureNodeSelected);
            }
        }
        function backToPrevious() {
            var previousState = $rootScope.previousState;
            if (!vm.isFicCreation) {
                var currentStatus = $translate.instant(FicViewListWSService.convertStatusToND($rootScope.currentStatus));
                $rootScope.getFicData();
                var responseApi = CacheService.getObject(CacheConstants.actisResponse);
                if (responseApi && responseApi.Car && responseApi.Car.mileageUnit) {
                    responseApi.Car.mileageUnit = responseApi.Car.mileageUnit.toUpperCase();
                }
                var dataChanged = CreateActisBusinessService.deepDiffApiResultVsDataActisView(responseApi, vm.fic);
                dataChanged = CreateActisBusinessService.getDataChangedVerification(dataChanged);
                if (((currentStatus !== $translate.instant('ACTIS_ALL_OTHER_STATUSES') && currentStatus !== $translate.instant('ACTIS_CLOSED')) && !_.isEmpty(dataChanged) || (_.isEmpty(currentStatus) && _.isEmpty(dataChanged)))) {
                    $mdDialog.show({
                        templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                        controller: 'modalOnCloseFicController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true
                    }).then(function (resp) {
                            if (vm.isForBwr && resp && resp === ActisConstantes.YES && previousState === RoutesConstants.carSearch) {
                                CacheService.removeObject(CacheConstants.contextCarRequest);
                                CacheService.removeObject(CacheConstants.getAllSymptoms);
                            }
                        })
                        .catch(function () {
                            $log.debug($translate.instant('ERROR'));
                        });
                } else {
                    CacheService.removeObject(CacheConstants.searchedSymptom);
                    CacheService.removeObject(CacheConstants.consultationFIC);
                    $window.history.back();
                }
            } else {
                CacheService.removeObject(CacheConstants.isActisFromDiag);
                CacheService.removeObject(CacheConstants.searchedSymptom);
                CacheService.removeObject(CacheConstants.consultationFIC);
                $window.history.back();
            }
        }
        $rootScope.$on('loadFicData', function (event, data) {
            //Deep copy of the case view if it contains multiple object property
            for (var property in data) {
                // Case the property of data is not include in vm.fic we add it
                if (!vm.fic[property]) {
                    vm.fic[property] = data[property];
                } else { //On the other hand if property exist we copy the innerproperty inside
                    for (var innerProperty in data[property]) {
                        vm.fic[property][innerProperty] = data[property][innerProperty];
                    }
                }
            }
        });
    }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('agrementActis', {
            bindings: {
                responseApi: '<',
                isEditMode: '<',
                nonModifiableFic: '<',
                isActisFromDiag: '<',
                isDraft: '<'
            },
            controller: AgrementActisComponent,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/agrement-actis.template.html'
        })

        function AgrementActisComponent($translate,configConstantes) {

            var vm = this;
            vm.isAgreementOpen = false;
            this.$onChanges = function () {
                if (vm.isEditMode) {
                    vm.designation_agrement = vm.responseApi.Request.operationApprovalDesignation;
                    vm.montantOperationAgrement = vm.responseApi.Request.maximumRepairCostExTax;
                    vm.montantPiecesHTAutorise = vm.responseApi.Request.maximumPartsCostExTax;
                    vm.montantMOHTMaxAutorise = vm.responseApi.Request.maximumLabourCostExTax; 
                    vm.agreements = vm.responseApi.agreements;
                    if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'none') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_NONE')
                    } else if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'temporary') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_TEMPORARY')
                    } else if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'authorised') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_AUTHORISED')
                    } else if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'refused') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_REFUSED')
                    } else if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'out of scope') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_OUT_OF_SCOPE')
                    } else if (vm.responseApi.Request.agreementValidation.toLowerCase() === 'exempted') {
                        vm.status_agrement = $translate.instant('AGREEMENT_APPROVAL_EXEMPTED')
                    } else {
                        vm.status_agrement = " ";
                    }
                }
            }
            this.$onInit = function () {
                vm.isAgreementOpen = (vm.isDraft || vm.isActisFromDiag)? true : false;
            }
        }
})();

/**
 * shoppingCartPartsRequisition
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('accessoiresActis', {
            bindings: {
                nonModifiableFic: '<',
                isActisFromDiag: '<',
                isDraft: '<'
            },
            controller: AccessoiresActisController,
            controllerAs: 'vm',
            templateUrl: 'app/components/actis/components/accessoires-actis.template.html'
        });

        function AccessoiresActisController() {
            var vm = this;
            vm.isAccessoriesOpen = false;
            this.$onInit = function () {
                vm.isAccessoriesOpen = (vm.isDraft || vm.isActisFromDiag)? true : false;
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('supportIndendependentModePopupController', supportIndendependentModePopupController);

    /** @ngInject */
    function supportIndendependentModePopupController($mdDialog) {
        var vm = this;
        var response = {};

       
        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;


        function onConfirm(switchValue) {
              response.isFicSentEnabled = switchValue;
            $mdDialog.hide(response);
        }


        function onCancel(switchValue) {
            response.isFicSentEnabled = switchValue;

            $mdDialog.hide(response);
        }
    }

})();
(function () {
    angular.module('phenix').service('RoutingService', function (RoutesConstants, $state) {
        this.goToProductPage = goToProductPage;
        this.goToTextSearchPage = goToTextSearchPage;


        function goToProductPage(params) {
            var path = params.path;
            var data = params.data;
            if (path.mainReference === undefined) {
                path.mainReference = null;
            }
            var toParams = _.assign({}, path, {data: data});
            $state.go(RoutesConstants.product, toParams);
        }

        function goToTextSearchPage(params) {
            const path = params.path;
            if (path && path.reference) {
                $state.go(RoutesConstants.carSearchResult, {
                    reference: path.reference.toLowerCase(),
                    isFromDiagFileDetails: true,
                    isTextSearchRedirect: true,
                    systemDocSubMenu: path.systemDocSubMenu,
                    systemDocResponse: path.systemDocResponse
                });
            }
        }
    })
})();

(function() {
    'use strict';

    angular.module('phenix.core')
    .directive('uiEqualizer', [uiEqualizer])
    .directive('uiEqualizerWatch', [uiEqualizerWatch]);

    /** @ngInject */
    function uiEqualizerCtrl ($interval) {
        var childs = [],
            intervalPromise,
            STR_FIRST_HEIGHT = 'firstHeight',
            TICK = 250;

        var reflow = function() {
            console.log("reflow fn called");
            var heights = childs.map(function (value) {
                return value[0].offsetHeight;
            });
            var max = Math.max.apply(null, heights);
            for (var i = childs.length - 1; i >= 0; i--) {
                childs[i].css('height', max + 'px');
            }
        };

        var testForReflow = function() {
            var noNeedReflow = true;
            for (var i = childs.length - 1; i >= 0; i--) {
                if ( childs[i].data(STR_FIRST_HEIGHT) !== childs[i][0].offsetHeight ) {
                    childs[i].data(STR_FIRST_HEIGHT, childs[i][0].offsetHeight);
                    noNeedReflow = false;
                }
            }
            if (!noNeedReflow) {
                reflow();
            }
        };

        var startWatching = function() {
            intervalPromise = $interval(function() {
                testForReflow();
            },TICK);
        };

        var stopWatching = function() {
            $interval.cancel(intervalPromise);
        };

        this.addChild = function(pChild) {
            pChild.data(STR_FIRST_HEIGHT, pChild[0].offsetHeight);
            childs.push(pChild);
            if (childs.length === 1) {
                startWatching();
            }
            reflow();
        };

        this.removeChild = function(pChild) {
            childs.splice(childs.indexOf(pChild), 1);
            if (childs.length) {
                reflow();
            } else {
                stopWatching();
            }
        };
    }

    function uiEqualizer() {
        return {
            controller: [
                '$interval',
                uiEqualizerCtrl
            ],
            restrict: 'A',
            scope: {}
        };
    }

    //========================================

    function uiEqualizerWatchLinkFn () {
        // arguments order:
        // $scope [0], $element [1], $attrs [2], uiEqualizerCtrl [3]
        var uiEqualizerCtrl = arguments[3],
            $element = arguments[1];

        uiEqualizerCtrl.addChild($element);
        $element.on('$destroy', function() {
            uiEqualizerCtrl.removeChild();
        });
    }

    function uiEqualizerWatch() {
        return {
            link: uiEqualizerWatchLinkFn,
            require: '^uiEqualizer',
            restrict: 'A'
        };
    }



})();

(function () {
    angular
        .module('phenix.core')
        .service('UserKeyService', userKeyService);

    /** @ngInject */
    function userKeyService($log) {
        
        const USER_KEY_STORAGE_KEY = 'ctx';
        
        this.setUserKey = setUserKey;
        this.getUserKey = getUserKey;
        this.clearUserKey = clearUserKey;
        this.hasUserKey = hasUserKey;

        /**
         * Stores user key in sessionStorage.
         * @param {string} userKey Hashed user identifier
         */
        function setUserKey(userKey) {
            if (!userKey || typeof userKey !== 'string') {
                $log.warn('[UserKeyService] Attempted to set invalid user key');
                return;
            }
            
            try {
                sessionStorage.setItem(USER_KEY_STORAGE_KEY, userKey);
                $log.debug('[UserKeyService] User key stored successfully');
            } catch (e) {
                $log.error('[UserKeyService] Error storing user key:', e);
            }
        }

        /**
         * Retrieves user key from sessionStorage.
         * @returns {string|null} User key or null
         */
        function getUserKey() {
            try {
                return sessionStorage.getItem(USER_KEY_STORAGE_KEY);
            } catch (e) {
                $log.error('[UserKeyService] Error retrieving user key:', e);
                return null;
            }
        }

        function clearUserKey() {
            try {
                sessionStorage.removeItem(USER_KEY_STORAGE_KEY);
                $log.debug('[UserKeyService] User key cleared');
            } catch (e) {
                $log.error('[UserKeyService] Error clearing user key:', e);
            }
        }

        /**
         * @returns {boolean} True if user key exists
         */
        function hasUserKey() {
            const userKey = getUserKey();
            return userKey !== null && userKey !== '';
        }
    }
})();

/**
 * Created by a527713 on 23/12/2016.
 */
(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('TypePaintTMModalCtrl', TypePaintTMModalCtrl);

  /** @ngInject */
  function TypePaintTMModalCtrl($modalInstance, $translate) {
    var vm = this;

    function init() {
      $translate('TM_TYPE_PAINT_2').then(function(text){
        vm.typePaintTm = text;
      });
      vm.addToEstimate = addToEstimate;
      vm.cancel = cancel;
    }

    function addToEstimate() {
      $modalInstance.close(vm.typePaintTm);
    }

    function cancel() {
      $modalInstance.dismiss(null);
    }

    init();
  }
})();




angular.module('phenix.core')
  .directive('uploadFile', ['$timeout', function ($timeout) {
    return {
      restrict: 'EA',
      scope: {
        idFile: '@',
        file: '=',
        fileTypeSupport: '=', //array of extensions || set to all for skip the check
        fileError: '=',
        fileArray: '=',
        fileTypeError: '=',
        disabledCondition: '=',
        listAlerts: '='
      },
      templateUrl: 'app/core/uploadFile/uploadFile.html',
      controller: function uploadFileCtrl ($scope) {
        $scope.fileError = false;
        $scope.fileTypeError = false;

        function processFile() {
          const fileExtension = $scope.fileTypeSupport.length ? getExtensionFile($scope.file.file.name) : 'all';
          let counter = 0;
          const enumeration = ["avi", "bmp", "doc", "docm", "docx", "eml", "gif", "htm", "html", "jpeg","JPG",
            "jpg", "log", "mov", "mpeg", "mp4", "msg", "ods", "odt", "pdf", "png", "ppsx", "ppt", "pptx", "rar",
            "rtf", "tif", "tiff", "txt", "xls", "xlsb", "xlsm", "xlsx", "xml", "xps", "zip", "7z"];
          
          const isSupported = enumeration.includes(fileExtension);

          // Check type support
          for (const supportedType of $scope.fileTypeSupport) {
            if (fileExtension === supportedType || supportedType === 'all') {
              counter++;
            }
          }

          if (counter === 0) {
            $scope.file = null;
            return;
          }

          // Set file properties
          $scope.file.file.humanSize = humanFileSize($scope.file.file.size);
          $scope.file.file.fileName = getFileName($scope.file.file.name);
          $scope.file.file.fileType = fileExtension;
          $scope.file.file.Alertsize = alertSizeFormat($scope.file.file.size);
          $scope.file.file.data = encode64Base($scope.file.file);

          // Validate based on context
          if ($scope.listAlerts !== true && $scope.listAlerts !== 'true') {
            handleNonListAlertsValidation($scope, isSupported);
          } else {
            handleListAlertsValidation($scope, isSupported);
          }
        }

        $scope.$watch('file', function (newValue, oldValue) {
          if (oldValue !== newValue && $scope.file && $scope.fileTypeSupport.length && newValue) {
            processFile();
          }
        });

        function alertSizeFormat(size) {
          const i = Math.floor(Math.log(size) / Math.log(1024));
          return (size / Math.pow(1024, i)).toFixed(2) * 1;
        }


        /**
        * @desc function that aims to encode a file in base 64 format
        * @param {object} file file that we wish to encode
        * @returns {object} returns object containing the encoded format
        */
        function encode64Base(file) {
          const reader = new FileReader();
          const obj = {};
          reader.readAsDataURL(file);
          reader.onload = function () {
            obj.base64 = reader.result;
          }
          reader.onerror = function (_error) {
            // Error handling can be added here if needed
          };

          return obj;
        }

        /**
         * @param filename
         * @returns {string}
         */
        function getExtensionFile(filename) {
          return filename.split('.').pop();
        }

        /**
         * @param filename
         * @returns {string}
         */
        function getFileName(filename) {
          return filename.split('.').shift();
        }

        function humanFileSize(size) {
          const i = Math.floor(Math.log(size) / Math.log(1024));
          return `${(size / Math.pow(1024, i)).toFixed(2) * 1} ${['o', 'Ko', 'Mo', 'Go', 'To'][i]}`;
        }

        function calculateTotalFileSize(currentFileSize, existingFiles) {
          let totalSize = currentFileSize;
          
          if (!existingFiles || existingFiles.length === 0) {
            return totalSize;
          }
          
          for (const existingFile of existingFiles) {
            if (existingFile && existingFile.file && existingFile.file.size) {
              totalSize += existingFile.file.size;
            }
          }
          
          return totalSize;
        }

        function handleNonListAlertsValidation(scope, isSupported) {
          // Original validation logic for non-listAlerts context
          if (scope.file.file.size > 1048576 && isSupported === false) {
            scope.file = null;
            scope.fileError = true;
            scope.fileTypeError = true;
          } else if (isSupported === false) {
            scope.file = null;
            scope.fileTypeError = true;
          } else if (scope.file.file.size > 1048576) {
            scope.file = null;
            scope.fileError = true;
          } else {
            scope.fileArray.push(scope.file);
          }
        }

        function handleListAlertsValidation(scope, isSupported) {
          // File type validation first
          if (!isSupported) {
            scope.file = null;
            scope.fileTypeError = true;
            return;
          }
          
          // Calculate total size including current file
          const BYTES_PER_MB = 1024 * 1024;
          const MAX_SIZE_MB = 7;
          const MAX_TOTAL_SIZE = MAX_SIZE_MB * BYTES_PER_MB;
          const totalSize = calculateTotalFileSize(scope.file.file.size, scope.fileArray);
          
          if (totalSize > MAX_TOTAL_SIZE) {
            scope.file = null;
            scope.fileError = true;
            return;
          }
          
          // All validations passed, add file
          scope.fileArray.push(scope.file);
        }

      },
      controllerAs: 'vm',
      link(scope, el) {

        scope.selectFileUpload = selectFileUpload;

        function selectFileUpload(id) {
          $timeout(function() {
            document.getElementById(id).click();
          }, 0);
        }

        el.bind('change', function (event) {
          const files = event.target.files;
          //iterate files since 'multiple' may be specified on the element
          for (const file of files) {
            scope.file = { file };
            scope.fileError = false;
            scope.fileTypeError = false;
            $timeout(function () {
              scope.$apply();
            }, 0);
          }
          $('#' + scope.idFile).val(""); // if need to upload same file
        });

      }
    }
  }]);

(function () {
  'use strict';

  angular.module('phenix.core')
  .directive('svgParser', svgParser);


  /** @ngInject */
  function svgParser($http) {
   return {
      restrict: 'EA',
      scope: {
        source: '@svgSrc'
      },
       link: function(scope, element, attr) {

        var injectSvg;
        injectSvg = function(source) {

          return $http.get(source).success(function(data) {
            var svg;

            svg = angular.element(data);
            if (!svg) {
              return;
            }

           // svg.css('width', '100%');
            //svg.css('height', '100%');
            return element.html(svg);
          });
        };
        scope.$watch('source', function(newVal) {
          return injectSvg(newVal);
        });
        return injectSvg(scope.source);
      }
    };
  }



  })();

(function () {
  'use strict';

  angular.module('phenix.core')
    .directive('svgHandler', svgHandler);

  /** @ngInject */
  function svgHandler($rootScope, $timeout, $compile) {
    var directive = {
      restrict: 'A',
      replace: true,
      scope: {
        filteredList: '='
      },
      link: function (scope, element, attrs) {

        scope.$watch('filteredList', function (event) {
          scope.render();
        })
        scope.render = function () {
          var svg = element[0].getElementsByTagName("svg");

          if (svg && svg.length>0) {
            
              var svgElem = angular.element(svg[0]);
              svgElem.attr("id", "svgPanImage");
            var reperesList = svg[0].querySelectorAll('text[x]');
            angular.forEach(reperesList, function (path, key) {

              if (scope.filteredList && path.previousElementSibling) {
                path.previousSibling.remove();
              }
              var textElement = angular.element(path);
              var idRepSvg = textElement[0].textContent;
              textElement.css('font-family', 'var(--renaultFontRegular)');
              
                if (element[0].id.includes("divEbSvgContent")) {
                  var ele = document.querySelectorAll(`[id="${idRepSvg}" ]`)
                  if (ele.length > 1 && [...ele][1].className.includes('EbSvg')) {
                    if (scope.filteredList) {
                      $('svg line').removeClass("active-line");
                      $('text').removeClass("active-repere");
                      $('.rid_' + idRepSvg).removeClass('active-repere');
                    }
                    textElement.attr("ng-click", "repereClick(" + idRepSvg + ")");
                    textElement.attr("id", "r" + idRepSvg);
                    textElement.removeClass("disable-repere");
                    textElement.addClass('rid_' + idRepSvg);
                  }
                  else if (ele.length == 1 && [...ele][0].className.includes('EbSvg')) {
                    if (scope.filteredList) {
                      $('svg line').removeClass("active-line");
                      $('text').removeClass("active-repere");
                      $('.rid_' + idRepSvg).removeClass('active-repere');
                    }
                    textElement.attr("ng-click", "repereClick(" + idRepSvg + ")");
                    textElement.attr("id", "r" + idRepSvg);
                    textElement.removeClass("disable-repere");
                    textElement.addClass('rid_' + idRepSvg);
                  }
                  else {
                    textElement.attr("id", "r" + idRepSvg);
                    textElement.addClass('disable-repere');
                  }
                } else {
                  var refRep = document.getElementById(idRepSvg);
  
                  if (refRep) {
                    if (scope.filteredList) {
                      $('svg line').removeClass("active-line");
                      $('text').removeClass("active-repere");
                      $('.rid_' + idRepSvg).removeClass('active-repere');
                    }
  
                    textElement.attr("ng-click", "repereClick(" + idRepSvg + ")");
                    textElement.attr("id", "r" + idRepSvg);
                    textElement.removeClass("disable-repere");
                    textElement.addClass('rid_' + idRepSvg);
  
                  } else {
                    textElement.attr("id", "r" + idRepSvg);
                    textElement.addClass('disable-repere');
  
                  }
                }
              
              
              $compile(textElement)(scope);
            
            });
          
            $rootScope.onSvgLoad();
          }


          scope.repereClick = function (id) {
            $('text').removeClass("active-repere");
            $('.rid_' + id).addClass('active-repere');
            $rootScope.selectReferencesFromPlanche(id);

          };
        }

      }
    };
    return directive;

  }


})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('stickyNotification', stickyNotification);

  /* @ngInject */
  function stickyNotification() {
    var directive = {
      templateUrl: 'app/core/stickyNotification/stickyNotification.html',
      bindToController: true,
      controller: StickyNotificationController,
      controllerAs: 'vmStickyNotif',
      restrict: 'EA',
      scope: {
        saveAction: '&',
        isEdited: '='
      }
    };
    return directive;
  }

  /* @ngInject */
  function StickyNotificationController() {

  }

})();


(function(){
    'use strict';

    angular
        .module('phenix.core')
        .component('spinnerLoadingDms',{
            bindings:{

            },
            controller: SpinnerLoadingDmsController,
            controllerAs: 'vm',
            templateUrl: 'app/core/spinnerLoadingDms/spinner-loading-dms.template.html'
        })

        function SpinnerLoadingDmsController(){

        }
})();

(function() {
    angular
        .module("phenix.core")
        .service("YesNoModaleService", YesNoModaleService);

    /** @ngInject */
    function YesNoModaleService($mdDialog) {
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.showModal = showModal;

        function showModal(payload) {
            $mdDialog.show({
                parent: payload.body,
                controller: "modalYesNoConfirmController",
                templateUrl:
                    "app/components/basket/consultation/components/modal-yes-no-confirm.template.html",
                clickOutsideToClose: true,
                skipHide: true,
                multiple: true,
                locals: {
                    header : payload.header,
                    title : payload.title,
                    subtitle : payload.subtitle,
                    or: payload.or
                },
                bindToController: true,
                controllerAs: "vm"
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('SuperCartWsService', SuperCartWsService);

    /** @ngInject */
    function SuperCartWsService($q, PanierConstants,RestUpgradeRaw) {
        this.downloadCSV = downloadCSV;

        function downloadCSV(id,body) {
            return RestUpgradeRaw.one(PanierConstants.csv_endpoint, id).post('',body).then(function(response) {
                return {
                    data: response.data,
                    fileName : response.headers('Content-Disposition')
                }
            });
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("phenix")
        .service("SuperCartMetierService", SuperCartMetierService);

    /** @ngInject */

    function SuperCartMetierService(
        SuperCartWsService,
        $translate,
        CacheService,
        CacheConstants,
        globalConstant,
        UtilsMetierService,
        configConstantes,
        $q,
        $filter,$rootScope,PDFViewService
    ) {
        this.downloadCSV = downloadCSV;
        this.downloadPdf = downloadPdf;
        this.formatDataToPrint = formatDataToPrint;
        this.getTableData = getTableData;
        var pictoImage = {            
            "RENAULT":{src:convertImgToBase64("/assets/images/renaultgroup.png","RENAULT")},
            "TRIMAN":{src:convertImgToBase64("/assets/images/triman.png","TRIMAN")}
        }
        function downloadCSV(id,body) {
            return SuperCartWsService.downloadCSV(id,body).then(function (response) {
                var parsedFilename = response.fileName.match(/\"(.*?)\"/);

                if (!parsedFilename) {
                    return response;
                }

                response.fileName = parsedFilename[1]
                    ? parsedFilename[1].trim()
                    : id;
                return response;
            });
        }

        /**
         *  @desc Will call the service layer in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  We construct the payload that we will send to the backend controller
         *  cartToPrint will contain the content of the parameters such as cartMetadata, basket, vehicle
         *  but we also add translatedLabels, those are the translated label that we can see in the view and that we
         *  want to display in the pdf
         *
         *  @param  cartMetadata : information regarding the basket (creation, modification date ...)
         *  @param  basket : list of TM and PR entries that we want to display in the pdf
         *  @param  vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         */
        function downloadPdf(cartMetadata, basket, vehicle, type, status,isPriceStock,withRef,withTaxDiscountCal) {
            var cartToPrint = {

                cartMetaData: cartMetadata,
                superCartNode: {
                    superCart: basket,
                    type: type,
                    statut: status
                },
                vehicle: vehicle,
                translatedLabels: {
                    cartCreation: $translate.instant("CART_CREATION", {
                        date: moment(cartMetadata.creationDateTime).format(
                            "DD/MM/YYYY"
                        ),
                        person: cartMetadata.creator
                    }),

                    cartModification: $translate.instant("CART_MODIFICATION", {
                        date: moment(
                            cartMetadata.lastModificationDateTime
                        ).format("DD/MM/YYYY"),
                        person: cartMetadata.lastModifier
                    }),
                    documentTmTime: $translate.instant("DOCUMENT_TM_TIME"),
                    documentTmlabourTimes: $translate.instant(
                        "COMMON_COLUMN_HRATE_TITLE"
                    ),
                    columnRef: $translate.instant("COMMON_COLUMN_REF_TITLE"),
                    columnDesignation: $translate.instant("COMMON_DESIGNATION"),
                    columnQuantity: $translate.instant(
                        "COMMON_COLUMN_QTE_TITLE"
                    ),
                    superCartNumber:
                        $translate.instant("LABEL_NUM_BASKET") +
                        " " +
                        ((cartMetadata.id)?cartMetadata.id:""),
                    superCartCreationDate:
                        $translate.instant("BASKET_CREATION") +
                        " " +
                        moment(cartMetadata.creationDateTime).format(
                            "DD/MM/YYYY"
                        ) +
                        " " +
                        $translate.instant("BASKET_CREATION_BY") +
                        " " +
                        ((cartMetadata.creator)?cartMetadata.creator:""),
                    superCartLastModificationDate:
                        $translate.instant("BASKET_LAST_MODIFICATION") +
                        " " +
                        moment(cartMetadata.lastModificationDateTime).format(
                            "DD/MM/YYYY"
                        ) +
                        " " +
                        $translate.instant("BASKET_CREATION_BY") +
                        " " +
                        ((cartMetadata.creator)?cartMetadata.creator:"") ,
                    codeTm: $translate.instant("CODE_TM"),
                    columnPUBHT: $translate.instant(
                        "COMMON_COLUMN_PUBHT_TITLE"
                    ),
                    columnWholesalerPUBHT: $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("WHOLESALER_GUP_TAX"),
                    documentTmTitle: $translate.instant(
                        "COMMON_COLUMN_LABEL_TITLE"
                    ),
                    documentTmQuantity: $translate.instant(
                        "COMMON_COLUMN_QTE_TITLE"
                    ),
                    documentBasketTitle: $translate.instant("LOCATION_BASKET"),
                    discountCode: $translate.instant("ORDERING_MODULE_DISCOUNT_CODE"),
                    availabilities: $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("R1_AVAILABILITIES"),
                    orderMark: $translate.instant("ORDER_MARK")+" :",
                    orderMessage: $translate.instant("VALIDATED_ORDER_MESSAGE")+" :",
                    urgentOrderLabel: $translate.instant("URGENT_ORDER"),
                    taxLabel: $translate.instant("TAX"),
                    discountLabel: $translate.instant("ESTIMATE_DISCOUNT")+" %",
                    columnMNHT: $translate.instant("COMMON_COLUMN_MNT_NETHT_TITLE"),
                    itemTotal: $translate.instant("COMMON_TOTAL_HT"),                    
                    totalTTC: $translate.instant("ESTIMATE_TOTAL_TTC"),
                    totalTaxes: $translate.instant("ESTIMATE_TOTAL_TAXES"),
                    totalNetHT: $translate.instant("ESTIMATE_TOTAL_NETHT"),
                    totalTotalHT: $translate.instant("ESTIMATE_TOTAL_BRUTHT")
                }
            };
            if (type === globalConstant.quote) {
                var userProfile = CacheService.getObject(CacheConstants.profil);

                var creationDateTime = moment(
                    cartMetadata.creationDateTime
                ).format("DD/MM/YYYY");
                var lastModificationDateTime = moment(
                    cartMetadata.lastModificationDateTime
                ).format("DD/MM/YYYY");

                var pr = _.filter(basket, function (item) {
                    if (item.type === "PR") {
                        if (item.dmsInformations) {
                            item.cort = item.dmsInformations.cort;
                            item.priceHT = item.dmsInformations.priceExclTaxes
                                ? item.dmsInformations.priceExclTaxes
                                : item.priceHT;
                        }
                        return item;
                    }
                });

                var tm = _.filter(basket, function (item) {
                    if (item.type === "TM") {
                        return item;
                    }
                });

                basket = {};
                basket.pr = pr;
                basket.tm = tm;


                cartToPrint.superCartNode.superCart = basket;

                var userContext = CacheService.getUserContext();
                if (userContext && userContext.countryCode) {
                    _.extend(cartToPrint.cartMetaData, {
                        countryCode: userContext.countryCode
                    });
                }
                var header = userProfile.header;
                if (header) {
                    _.extend(cartToPrint.cartMetaData, {
                        header: header
                    });
                }

                if (cartToPrint.cartMetaData.status === "VALID") {
                    var validationDateTime = $filter('localTimeFilter')(cartToPrint.cartMetaData.validationDateTime);
                    _.extend(cartToPrint.cartMetaData, {
                        validationDateTime: validationDateTime
                    });

                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber:
                            $translate.instant("LABEL_NUM_ESTIMATE") +
                            " " +
                            cartMetadata.number,
                        superCartValidationDate:
                            $translate.instant("ESTIMATE_VALIDATED_DATE") +
                            " " +
                            cartMetadata.validationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN

                    });

                } else {
                    _.extend(cartToPrint.cartMetaData, {
                        creationDateTime: creationDateTime,
                        lastModificationDateTime: lastModificationDateTime
                    });

                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber:
                            $translate.instant("LABEL_NUM_ESTIMATE") +
                            " " +
                            cartMetadata.number,
                        superCartCreationDate:
                            $translate.instant("ESTIMATION_CREATE_DATE") +
                            " " +
                            cartMetadata.creationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN,
                        superCartLastModificationDate:
                            $translate.instant("ESTIMATION_UPDATE_DATE") +
                            " " +
                            cartMetadata.lastModificationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN
                    });

                }

                _.extend(cartToPrint.translatedLabels, {
                    columnMNHT: $translate.instant(
                        "COMMON_COLUMN_MNT_NETHT_TITLE"
                    ),
                    columnCT: $translate.instant("COMMON_COLUMN_CT_TITLE"),
                    category: $translate.instant("ESTIMATE_CATEGORY_LABEL"),
                    brutHT: $translate.instant("ESTIMATE_CATEGORY_BRUTHT"),
                    netHT: $translate.instant("ESTIMATE_CATEGORY_NETHT"),
                    totalTaxe: $translate.instant("ESTIMATE_TOTAL_TAX"),
                    totalTTC: $translate.instant("ESTIMATE_TOTAL_TTC"),
                    documentBasketTitle: $translate.instant("LOCATION_ESTIM"),
                    isNonCalculatedParts: $translate.instant("WARNING_CALCULATED"),
                    userScale: $translate.instant("ADMIN_FAMILY_CLIENT") + " : ",
                    itemTotal: $translate.instant("COMMON_TOTAL_HT")
                });
            }
            else if (type === "partRequisition" || type === 'order') {
                userProfile = CacheService.getObject(CacheConstants.profil);
                if(type === "partRequisition")
                 header = userProfile.header;
                creationDateTime = moment(
                    cartMetadata.creationDateTime
                ).format("YYYY/MM/DD");
                lastModificationDateTime = moment(
                    cartMetadata.lastModificationDateTime
                ).format("YYYY/MM/DD");


                pr = basket;
                basket = {};
                basket.pr = pr;
                cartToPrint.superCartNode.superCart = basket;
                if (header) {
                    _.extend(cartToPrint.cartMetaData, {
                        header: header
                    });
                }

                userContext = CacheService.getUserContext();
                if (userContext && userContext.countryCode) {
                    _.extend(cartToPrint.cartMetaData, {
                        countryCode: userContext.countryCode
                    });
                }

                _.extend(cartToPrint.translatedLabels, {
                    documentBasketTitle: $translate.instant("LOCATION_ESTIM"),
                    columnIntervention: $translate.instant("PARTLIST_TABLE_TITLE_SPLIT"),
                    columnCasier: $translate.instant("COMMON_COLUMN_LOCATION"),
                    columnUrgence: $translate.instant("PARTLIST_TABLE_TITLE_URGENCY"),
                    columnAdditionalDiscount: $translate.instant("PARTLIST_TABLE_TITLE_DISCOUNT"),
                    unusualSale: $translate.instant("PARTLIST_UNUSUAL_SALE")

                })

                if (cartToPrint.cartMetaData.status === "VALID" ) {
                    if(type === 'order'){
                        var validationDateTime = cartToPrint.cartMetaData.validationDateTime;
                     } else{
                         var validationDateTime = $filter('localTimeFilter')(cartToPrint.cartMetaData.validationDateTime);
                     }
                    _.extend(cartToPrint.cartMetaData, {
                        validationDateTime: validationDateTime
                    });

                    if(type === 'order')
                        var orderValidationDateTime = validationDateTime.split(' ');
                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber:
                            $translate.instant("LABEL_NUM_PARTLIST") +
                            " " +
                            cartMetadata.number +
                            " / " +
                            cartMetadata.dmsPartListId,
                        superCartValidationDate:
                            $translate.instant("ESTIMATE_VALIDATED_DATE") +
                            " " +
                            cartMetadata.validationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN,
                        orderNumber: $translate.instant("ORDER_NUMBER")+" : "+(cartMetadata.responseData != undefined ? cartMetadata.responseData.orderNumber :''),
                        orderValidationDate:
                        (cartMetadata.responseData != undefined ? $translate.instant("ORDER_VALIDATED") +" "+$translate.instant("COMMON_ON") +" " + orderValidationDateTime[0]  +" " + $translate.instant("COMMON_AT")+" " + orderValidationDateTime[1] + " " + $translate.instant("ACTION_BY") +" " + cartMetadata.creatorIPN : ''),
                        invalidOrderValidationDate:
                        (cartMetadata.responseData != undefined ? $translate.instant("ORDER_VALIDATED") +" "+$translate.instant("ORDER_VALIDATED_WITH_DEFECT")+" "+$translate.instant("COMMON_ON") +" " +  orderValidationDateTime[0]  +" " + $translate.instant("COMMON_AT")+" " + orderValidationDateTime[1] + " " + $translate.instant("ACTION_BY") +" " + cartMetadata.creatorIPN : '')
                    });

                } else {
                    _.extend(cartToPrint.cartMetaData, {
                        creationDateTime: creationDateTime,
                        lastModificationDateTime: lastModificationDateTime
                    });

                    _.extend(cartToPrint.translatedLabels, {
                        superCartNumber:
                            $translate.instant("LABEL_NUM_PARTLIST") +
                            " " +
                            cartMetadata.number,
                        superCartCreationDate:
                            $translate.instant("ESTIMATION_CREATE_DATE") +
                            " " +
                            cartMetadata.creationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN,
                        superCartLastModificationDate:
                            $translate.instant("ESTIMATION_UPDATE_DATE") +
                            " " +
                            cartMetadata.lastModificationDateTime +
                            " " +
                            $translate.instant("ACTION_BY") +
                            " " +
                            cartMetadata.creatorIPN
                    });

                }

            }
            else {
                var currency = UtilsMetierService.getCurrencyForItem();
                if (currency) {
                    cartToPrint.cartMetaData.currency = currency;
                }

                var sortedBasket = {};
                sortedBasket.pr = basket.pr;
                sortedBasket.tm = basket.tm;
                //cartToPrint.superCartNode.superCart = sortedBasket;
            }
            formatItemsToFitPrintPayload(cartToPrint.superCartNode.superCart);
            if (cartMetadata.quoteStatus === "CalculatedQuote") {
                formatCalculedDataToFitPrintPayload(cartMetadata.calculedQuoteData);
                formatCalculedDataToFitPrintPayload(cartMetadata.totalCalculatedQuote);
            }
            return formatDataToPrint(cartToPrint,isPriceStock,withRef,withTaxDiscountCal);            
        }

        function formatItemsToFitPrintPayload(items) {
            angular.forEach(items.pr, function (value) {
                if (value.priceHT && typeof value.priceHT === "number") {
                    value.priceHT = value.priceHT.toFixed(2)
                }
                if (value.price && typeof value.price === "number") {
                    value.priceHT = value.price.toFixed(2)
                }
                if (value.total && typeof value.total === "number") {
                    value.total = value.total.toFixed(2)
                }
                if (value.taxes && typeof value.taxes === "number") {
                    value.taxes = value.taxes.toFixed(2)
                }
                if (value.totalPriceExclTaxess && typeof value.totalPriceExclTaxes === "number") {
                    value.totalPriceExclTaxes = value.totalPriceExclTaxes.toFixed(2)
                }
            });
            angular.forEach(items.tm, function (value) {
                if (value.priceHT && typeof value.priceHT === "number") {
                    value.priceHT = value.priceHT.toFixed(2)
                }
                if (value.total && typeof value.total === "number") {
                    value.total = value.total.toFixed(2)
                }
                if (value.taxes && typeof value.taxes === "number") {
                    value.taxes = value.taxes.toFixed(2)
                }
                if (value.totalPriceExclTaxes && typeof value.totalPriceExclTaxes === "number") {
                    value.totalPriceExclTaxes = value.totalPriceExclTaxes.toFixed(2)
                }
            });
        }

        function formatCalculedDataToFitPrintPayload(items) {
            angular.forEach(items, function (value) {
                if (value.basis && typeof value.basis === "number") {
                    value.basis = value.basis.toFixed(2)
                }
                if (value.exclTaxes && typeof value.exclTaxes === "number") {
                    value.exclTaxes = value.exclTaxes.toFixed(2)
                }
                if (value.taxes && typeof value.taxes === "number") {
                    value.taxes = value.taxes.toFixed(2)
                }

                if (value.total && typeof value.total === "number") {
                    value.total = value.total.toFixed(2)
                }
            });
        }

        function formatDataToPrint(data,isPriceStock,withRef,withTaxDiscountCal) {
           
            var deferred = $q.defer();
            var dataArray = [];
            var finalArr = [];
            var userProfile = CacheService.getObject(CacheConstants.profil);
            var firstObj = { type: "columns", values: {}, styles: "textStyle" };

            var headers = data.cartMetaData.header ? data.cartMetaData.header.split("\n") : [];

            var secondArr = [];
            secondArr.push("\n");
            if(data.superCartNode.type !== "order")
                secondArr.push(data.translatedLabels.superCartNumber);
            else if(data.cartMetaData.responseData != undefined && data.cartMetaData.responseData.orderNumber)
                secondArr.push(data.translatedLabels.orderNumber);
            if (data.cartMetaData.status === "DRAFT" || data.superCartNode.type === "cart") {
                secondArr.push(data.translatedLabels.superCartCreationDate);
                secondArr.push(data.translatedLabels.superCartLastModificationDate);
            } else if (data.cartMetaData.status === "VALID" && data.superCartNode.type !== "order"){
                secondArr.push(data.translatedLabels.superCartValidationDate);
            } else if (data.cartMetaData.status === "VALID" && data.superCartNode.type === "order") {
                if(data.cartMetaData.responseData != undefined)
                    secondArr.push(data.translatedLabels.orderValidationDate);
                else
                    secondArr.push(data.translatedLabels.invalidOrderValidationDate);
            }
            if(data.superCartNode.type !== "cart" && data.superCartNode.type !== "order"){
                secondArr.push("\n");           
                secondArr.push(data.cartMetaData.client);
                secondArr.push(data.cartMetaData.clientAdress);
                secondArr.push(data.cartMetaData.clientAdressEnd);
                secondArr.push(data.cartMetaData.clientAdressPhoneAndMail);
            }
            if(isPriceStock && data.superCartNode.type === "cart"){
                if(data.cartMetaData.label && data.cartMetaData.label != ''){
                    secondArr.push("\n");
                    secondArr.push(data.translatedLabels.orderMark+" "+data.cartMetaData.label);
                }
                if(data.cartMetaData.description && data.cartMetaData.description != ''){
                    secondArr.push("\n");                
                    secondArr.push(data.translatedLabels.orderMessage+" "+data.cartMetaData.description);
                    secondArr.push("\n");
                }
            } else if(isPriceStock && data.superCartNode.type === "order"){
                if(data.cartMetaData.orderMark && data.cartMetaData.orderMark != ''){
                    secondArr.push("\n");
                    secondArr.push(data.translatedLabels.orderMark+" "+data.cartMetaData.orderMark);
                }
                if(data.cartMetaData.message && data.cartMetaData.message != ''){
                    secondArr.push("\n");                
                    secondArr.push(data.translatedLabels.orderMessage+" "+data.cartMetaData.message);
                    secondArr.push("\n");
                }
            }
            var whichArray = secondArr.length > headers.length ? secondArr : headers;

            angular.forEach(whichArray, function (val, i) {
                firstObj.values[i] = [secondArr[i] ? secondArr[i] : "", headers[i] ? headers[i] : ""];
            })

            dataArray.push(firstObj);
            
                if(data.superCartNode.type === "cart" && !isPriceStock){
                    var labelTable = [
                        {
                            column1: {
                                data: data.cartMetaData.label ? data.cartMetaData.label : ""
                            }
                        }
                    ]

                    var descObj = {
                        type: "table", values: getTableData(labelTable, false), styles: "descTableStyle",
                        layout: "descTableLayout", widths: [485]
                    };

                    if (data.cartMetaData.label) {
                        dataArray.push(descObj);
                    }
                }   

                if(data && data.superCartNode && data.superCartNode.superCart && data.superCartNode.superCart.inter){
                    var interListDup = data.superCartNode.superCart.inter;
                    if (!_.isEmpty(interListDup)) {
                        interListDup.forEach(function (inter, index) {
                            var interArr = [];

                            if (inter.PR && !_.isEmpty(inter.PR)) {
                                angular.forEach(inter.PR, function (value) {
                                    if (value.quantity > 0) {
                                        interArr.push(value);
                                    }
                                });
                            }

                            data.superCartNode.superCart.inter[index].PR = interArr;
                        });
                    }
                   
                }

                if(!isPriceStock){
                    var descTable = [
                        {
                            column1: {
                                data: data.cartMetaData.description ? data.cartMetaData.description : ""
                            }
                        }
                    ]

                    var descObj = {
                        type: "table", values: getTableData(descTable, false), styles: "descTableStyle",
                        layout: "descTableLayout", widths: [485]
                    };

                    if (data.cartMetaData.description) {
                        dataArray.push(descObj);
                    }
                }


            var rgpdObj = { type: "rgpd", values: { 0: [$translate.instant("RGPD_MESSAGE")] }, styles: "rgpdStyle" };

            dataArray.push(rgpdObj);


            var columnData1 = data.vehicle ? dataConcatenation(data.vehicle.model, data.vehicle.engineDesignation, " , ") : "";

            columnData1 = data.vehicle ? dataConcatenation(columnData1, data.vehicle.motorisation, " , ") : "";

            columnData1 = data.vehicle ? dataConcatenation(columnData1, data.vehicle.gearBoxType, " , ") : "";

            var columnData2 = data.vehicle ? dataConcatenation(data.vehicle.vin, data.vehicle.registrationNumber, " | ") : "";

            var columnData3 = UtilsMetierService.replaceEmptyString(data.cartMetaData.orderNumber, "");
            var secondTable;
            if(data.superCartNode.type != "cart"){
                secondTable = [
                    {
                        column1: {
                            data: columnData1,
                            alignment: "left"
                        },
                        column2: {
                            data: columnData2,
                            alignment: "left"
                        },
                        column3: {
                            data: columnData3,
                            alignment: "left"
                        }
                    }
                ];
            }else{
                secondTable = [
                    {
                        column1: {
                            data: columnData1,
                            alignment: "left"
                        },
                        column2: {
                            data: columnData2,
                            alignment: "left"
                        }
                    }
                ]; 
            }

            var secondObj = {
                type: "table", values: getTableData(secondTable, false), styles: "secondTableHeader",
                layout: "secondTableLayout", widths: (data.superCartNode.type != "cart")?[160, 150, 155]:[235,235]
            };

            if (data.vehicle || data.cartMetaData.orderNumber) {
                dataArray.push(secondObj);
            }

            var interList = data.superCartNode.superCart.inter;

            if (interList && interList.length > 0) {

                var operTable = [
                    {
                        column1: {
                            data: "Operation"
                        }
                    }
                ]
                var operObj = {
                    type: "table", values: getTableData(operTable, false), styles: "tableStyle",
                    layout: "thirdTableLayout", widths: [480]
                };


                dataArray.push(operObj);


                interList.forEach(function (inter) {

                    var operHeader = [
                        {
                            column1: {
                                data: inter.designation
                            }
                        }
                    ]
                    var operHeaderObj = {
                        type: "table", values: getTableData(operHeader, false), styles: "tableStyle",
                        layout: "thirdTableLayout", widths: [480]
                    };

                    dataArray.push(operHeaderObj);

                    if (inter.PR.length > 0){

                    

                    var operPR = [
                        {
                            column1: {
                                data: 'PR'
                            }
                        }
                    ]
                    var operPRHeader = {
                        type: "table", values: getTableData(operPR, false), styles: "tableStyle",
                        layout: "thirdTableLayout", widths: [480]
                    };

                    dataArray.push(operPRHeader);
                    var currency = CacheService.getObject(CacheConstants.currency);
                    var filteredData = inter.PR.map(function (item) {
                        var tableData = [];
                        tableData[data.translatedLabels.columnRef] =
                        {
                            data: UtilsMetierService.replaceEmptyString($filter('filterFormatRef')(item.reference), ""),
                            alignment: "left"
                        };

                        tableData[data.translatedLabels.columnDesignation] =
                        {
                            data: UtilsMetierService.isEmpty(item.designation) ?
                                (item.unusualSale ? data.translatedLabels.unusualSale : "") :
                                item.unusualSale ? item.designation.concat("\n").concat(data.translatedLabels.unusualSale) : item.designation,
                            alignment: "left"
                        };
                        if((userProfile.country.toUpperCase() !=  "IN" && userProfile.country.toUpperCase() !=  "CN")){
                            tableData[data.translatedLabels.columnPUBHT] =
                            {
                                data: item.priceHT ? dataConcatenation(item.priceHT, item.currency, " ") : item.price ? dataConcatenation(item.price, item.currency ? item.currency : currency, " ") : '-',
                                alignment: "right"
                            };
                        }
                        tableData[data.translatedLabels.columnQuantity] =
                        {
                            data: item.quantity,
                            alignment: "center"
                        };
                        return tableData;
                    });
                    var operPRObj = []

                    operPRObj = {
                        type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                        layout: "otherTableLayout", 
                        widths: ((userProfile.country.toUpperCase() !=  "IN" && userProfile.country.toUpperCase() !=  "CN")?(data.superCartNode.type != "cart" && data.superCartNode.type != "order") ? [70, 100, 50, 50, 50, 60, 60] : [90, 180, 90, 95]:[90, 270, 104]) 
                    };

                    if (data.superCartNode.type === "cart"){
                        dataArray.push(operPRObj);
                    }

                }

                    if (inter.TM.length > 0) {

                        var fifthTable = [
                            {
                                column1: {
                                    data: "TM"
                                }
                            }
                        ]

                        var fifthObj = {
                            type: "table", values: getTableData(fifthTable, false), styles: "tableStyle",
                            layout: "thirdTableLayout", widths: [480]
                        };


                        dataArray.push(fifthObj);

                        var sixthTable = inter.TM;

                        var tmFilteredData = sixthTable.map(function (item) {
                            var tableData = [];
                            tableData[data.translatedLabels.codeTm] =
                            {
                                data: UtilsMetierService.replaceEmptyString(item.opecod, ""),
                                alignment: "left"
                            };
                            tableData[data.translatedLabels.documentTmTitle] =
                            {
                                data: UtilsMetierService.replaceEmptyString(item.designation, ""),
                                alignment: "left"
                            };
                            tableData[data.translatedLabels.documentTmTime] =
                            {
                                data: (item.duration && item.duration != '-') ? item.duration : (item.laborTime && item.laborTime != '-') ? item.laborTime.toString().replace('.',',') :"-",
                                alignment: "center"
                            };
                            tableData[data.translatedLabels.columnQuantity] =
                            {
                                data: item.quantity,
                                alignment: "center"
                            };

                            return tableData;
                        })

                        var sixthObj = {};

                        sixthObj = {
                            type: "table", values: getTableData(tmFilteredData, true), styles: "tableStyle",
                            layout: "otherTableLayout", widths: [90, 180, 90, 95]
                        };

                        dataArray.push(sixthObj);

                    }


                })
            }

            var thirdTable = [
                {
                    column1: {
                        data: "PR"
                    }
                }
            ]

            var thirdObj = {
                type: "table", values: getTableData(thirdTable, false), styles: "tableStyle",
                layout: "thirdTableLayout", widths: [480]
            };

            var fourthTable = (data.superCartNode.type != "cart")?data.cartMetaData.items : data.superCartNode.superCart.pr;
            
            var filteredData = fourthTable.map(function (item) {
                var tableData = [];
                if(withTaxDiscountCal){
                    tableData[data.translatedLabels.columnRef] =
                        {
                            data: withRef ? UtilsMetierService.replaceEmptyString($filter('filterFormatRef')(item.reference), ""): ' ',
                            alignment: "left"
                        };
                } else {
                    tableData[data.translatedLabels.columnRef] =
                    {
                        data:UtilsMetierService.replaceEmptyString($filter('filterFormatRef')(item.reference), ""),
                        alignment: "left"
                    };
                }
                if (data.cartMetaData.type === "WORKSHOP") {
                    tableData[data.translatedLabels.columnDesignation] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.designation, ""),
                        alignment: "left"
                    };
                } else {
                    tableData[data.translatedLabels.columnDesignation] =
                    {
                        data: UtilsMetierService.isEmpty(item.designation) ?
                            (item.unusualSale ? data.translatedLabels.unusualSale : "") :
                            item.unusualSale ? item.designation.concat("\n").concat(data.translatedLabels.unusualSale) : item.designation,
                        alignment: "left"
                    };
                }
                if(withTaxDiscountCal){
                    tableData[data.translatedLabels.taxLabel] =
                    {
                        data: item.tax,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.discountLabel] =
                    {
                        data: item.discount,
                        alignment: "center"
                    };
                }
                if (data.cartMetaData.type === "PARTSHOP" && data.superCartNode.type != "order") {
                    tableData[data.translatedLabels.columnAdditionalDiscount] =
                    {
                        data: !UtilsMetierService.isEmptyNumber(item.additionalDiscount) ?
                            item.additionalDiscount.toString().concat(" % ") : "-",
                        alignment: "center"
                    };
                }

                if (data.cartMetaData.type === "WORKSHOP" && data.superCartNode.type != "order") {
                    tableData[data.translatedLabels.columnIntervention] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.interventionId, "-"),
                        alignment: "center"
                    }
                }
                if(isPriceStock && data.superCartNode.type == "cart"){
                    tableData[data.translatedLabels.columnWholesalerPUBHT] =
                    {
                        data: dataConcatenation(item.priceHT, item.currency, " "),
                        alignment: "right"
                    };
                } else if(isPriceStock && data.superCartNode.type == "order" && data.cartMetaData.urgentOrder){
                    var priceValue = item.priceUrgentTaxFree || (item.dmsInformations && item.dmsInformations.priceExclTaxes) || item.price;
                    tableData[data.translatedLabels.columnWholesalerPUBHT] =
                    {
                        data: priceValue ? dataConcatenation(priceValue, CacheService.getObject(CacheConstants.currency), " ") : '-',
                        alignment: "right"
                    };
                } else if(isPriceStock && data.superCartNode.type == "order" && !data.cartMetaData.urgentOrder){
                    var priceValue = item.priceAdvisedTaxFree || (item.dmsInformations && item.dmsInformations.priceExclTaxes) || item.price;
                    tableData[data.translatedLabels.columnWholesalerPUBHT] =
                    {
                        data: priceValue ? dataConcatenation(priceValue, CacheService.getObject(CacheConstants.currency), " ") : '-',
                        alignment: "right"
                    };
                } else if((!$rootScope.isIndependentUser || ($rootScope.isIndependentUser && $rootScope.asomDocList.PX)) && (userProfile.country.toUpperCase() !=  "IN" && userProfile.country.toUpperCase() !=  "CN")){
                    tableData[data.translatedLabels.columnPUBHT] =
                    {
                        data: item.priceHT ? dataConcatenation(item.priceHT, item.currency, " ") : '-',
                        alignment: "right"
                    };
                }
                if(isPriceStock && (data.superCartNode.type == "cart" || data.superCartNode.type == "order")){
                    tableData[data.translatedLabels.discountCode] =
                    {
                        data: (item.isDiscountcodeVisible && item.discountRate)?item.priceTaxFree+" "+item.currency+" "+$translate.instant('PRODUCT_EXCL_TAX')+" "+ (data.cartMetaData.urgentOrder ? item.discountRateUrgent+"%" : item.discountRate +"%"):((item.discountCode)?item.discountCode:"-"),
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.columnQuantity] =
                    {
                        data: item.quantity,
                        alignment: "center"
                    };
                    tableData[data.translatedLabels.availabilities] =
                    {
                        data: (item.applicableClass) ? $translate.instant(item.applicableClass) : '-',
                        alignment: "center"
                    };
                }else {
                    tableData[data.translatedLabels.columnQuantity] =
                    {
                        data: item.quantity,
                        alignment: "center"
                    };
                }
                if(data.superCartNode.type != "cart" &&  data.superCartNode.type != "order"){
                    tableData[data.translatedLabels.columnUrgence] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.orderTypeLabel, ""),
                        alignment: "center"
                    }
                    tableData[data.translatedLabels.columnCasier] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.location, "-"),
                        alignment: "center"
                    };
                }
                if(withTaxDiscountCal){
                    tableData[data.translatedLabels.columnMNHT] =
                    {
                        data: (item.netAmountExclTax && item.netAmountExclTax > 0) ? $filter('numberPhenix')(item.netAmountExclTax)+' '+data.cartMetaData.currency : '-',
                        alignment: "center"
                    };                    
                }
                return tableData;
            })
            
            var fourthObj = {};
            if(isPriceStock){
                fourthObj = {
                    type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: (data.superCartNode.type != "cart" && data.superCartNode.type != "order")?[70, 100, 50, 50, 50, 60, 55]:[70, 180, 50, 50, 40, 67]
                };
            }else{
                if(userProfile.country.toUpperCase() !=  "IN" && userProfile.country.toUpperCase() !=  "CN"){
                    fourthObj = {
                        type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                        layout: "otherTableLayout", widths: (data.superCartNode.type != "cart" && data.superCartNode.type != "order")?[70, 100, 50, 50, 50, 60, 55]: withTaxDiscountCal ? [70, 120, 40,40, 60,35,60] :[90, 180, 90, 95]
                    };
                } else {
                    fourthObj = {
                        type: "table", values: getTableData(filteredData, true), styles: "tableStyle",
                        layout: "otherTableLayout", widths: (data.superCartNode.type != "cart" && data.superCartNode.type != "order")?[70, 100, 50, 50, 50, 60, 55]: withTaxDiscountCal ? [90, 165, 50, 50, 30, 60] : [90, 270, 103]
                    };
                }
            }
           if(fourthTable.length >0){
                if(data.superCartNode.type === "cart")
                    dataArray.push(thirdObj);
                dataArray.push(fourthObj);
            } 
            if (withTaxDiscountCal && data.superCartNode.superCart.pr.subTotalExclTaxPrTm && data.superCartNode.superCart.pr.subTotalExclTaxPrTm != 0) {
                const subTotalTM = [];
                subTotalTM.push({
                    column1: {
                        data: data.translatedLabels.itemTotal + " " + ((data.superCartNode.superCart.pr.subTotalExclTaxPrTm && data.superCartNode.superCart.pr.subTotalExclTaxPrTm > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.pr.subTotalExclTaxPrTm) + " " + data.cartMetaData.currency : "-"),
                        alignment: "right"
                    }
                })
                var subTotalTMObj = {
                    type: "table", values: getTableData(subTotalTM, false), styles: "withoutMargin",
                    layout: "otherTableLayout", widths: [480]
                };
                dataArray.push(subTotalTMObj);
            }
            if(data.superCartNode.type === "cart" && data.superCartNode.superCart.tm.length > 0){
                var fifthTable = [
                    {
                        column1: {
                            data: "TM"
                        }
                    }
                ]

                var fifthObj = {
                    type: "table", values: getTableData(fifthTable, false), styles: "tableStyle",
                    layout: "thirdTableLayout", widths: [480]
                };

                
                dataArray.push(fifthObj);

                var sixthTable = data.superCartNode.superCart.tm;

                var tmFilteredData = sixthTable.map(function (item) {
                    var tableData = [];
                    tableData[data.translatedLabels.codeTm] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.opecod, ""),
                        alignment: "left"
                    };
                    tableData[data.translatedLabels.documentTmTitle] =
                    {
                        data: UtilsMetierService.replaceEmptyString(item.designation, ""),
                        alignment: "left"
                    };
                    if(withTaxDiscountCal){
                        tableData[data.translatedLabels.taxLabel] =
                        { 
                            data: item.tax,
                            alignment: "center"
                        };
                        tableData[data.translatedLabels.discountLabel] =
                        {
                            data: item.discount,
                            alignment: "center"
                        };
                    }
                    tableData[data.translatedLabels.documentTmTime] =
                    {
                        data:(item.duration && item.duration != '-') ? item.duration : (item.laborTime && item.laborTime != '-') ? item.laborTime.toString().replace('.',',') :"-",
                        alignment: "center"
                    };
                    if(withTaxDiscountCal){
                        tableData[data.translatedLabels.documentTmlabourTimes] =
                        {
                            data: item.hourlyRate,
                            alignment: "center"
                        };                    
                    }
                    tableData[data.translatedLabels.columnQuantity] =
                    {
                        data: item.quantity,
                        alignment: "center"
                    };
                    if(withTaxDiscountCal){
                        tableData[data.translatedLabels.columnMNHT] =
                        {
                            data: (item.netAmountExclTax && item.netAmountExclTax > 0) ? $filter('numberPhenix')(item.netAmountExclTax)+' '+data.cartMetaData.currency : '-',
                            alignment: "center"
                        };                    
                    }
                    return tableData;
                })

                var sixthObj = {};

                sixthObj = {
                    type: "table", values: getTableData(tmFilteredData, true), styles: "tableStyle",
                    layout: "otherTableLayout", widths: withTaxDiscountCal ? [50,120,40,40,30,40,40,60] : [90, 180, 90, 95]
                };

                dataArray.push(sixthObj);
                
                if (withTaxDiscountCal && data.superCartNode.superCart.tm.subTotalExclTaxPrTm && data.superCartNode.superCart.tm.subTotalExclTaxPrTm != 0) {
                    var subTotalTM = [];
                    subTotalTM.push({
                        column1: {
                            data: data.translatedLabels.itemTotal + ' ' + ((data.superCartNode.superCart.tm.subTotalExclTaxPrTm && data.superCartNode.superCart.tm.subTotalExclTaxPrTm > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.tm.subTotalExclTaxPrTm) + " " + data.cartMetaData.currency : "-"),
                            alignment: "right"
                        }
                    })
                    var subTotalTMObj = {
                        type: "table", values: getTableData(subTotalTM, false), styles: "withoutMargin",
                        layout: "otherTableLayout", widths: [480]
                    };
                    dataArray.push(subTotalTMObj);
                }
            }
            if(data.cartMetaData.urgentOrder){
                var lastObj = { type: "columns", values: {}, styles: "textStyle" };
                var lastArr = [];
                lastArr.push(data.translatedLabels.urgentOrderLabel);
                lastObj.values = {0:lastArr};
                dataArray.push(lastObj);
            }
            if (withTaxDiscountCal && data.superCartNode.superCart.grossTotalAmt && data.superCartNode.superCart.grossTotalAmt > 0) {
                var calcRightTable = [];
                var calcLeftTable = [];                
                calcRightTable =[
                    {type: data.translatedLabels.totalTotalHT ,value: (data.superCartNode.superCart.grossTotalAmt && data.superCartNode.superCart.grossTotalAmt > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.grossTotalAmt) : '-'},
                    {type: data.translatedLabels.totalNetHT ,value: (data.superCartNode.superCart.netTotalAmt && data.superCartNode.superCart.netTotalAmt > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.netTotalAmt) : '-'},
                    {type: data.translatedLabels.totalTaxes ,value: (data.superCartNode.superCart.totalTax && data.superCartNode.superCart.totalTax > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.totalTax) : '-'},
                    {type: data.translatedLabels.totalTTC ,value: (data.superCartNode.superCart.totalAmtInclTax && data.superCartNode.superCart.totalAmtInclTax > 0) ? $filter('numberPhenix')(data.superCartNode.superCart.totalAmtInclTax) : '-'}
                ];
                var calcLeftTable = calcRightTable.map(function (item) {
                    var tableData = [];
                    tableData['left'] =
                    {
                        data: " ",
                        alignment: "left"
                    };
                    tableData['right'] =
                    {
                        data: " ",
                        alignment: "right"
                    };

                    return tableData;
                })
                var calcRightData = calcRightTable.map(function (item) {
                    var tableData = [];
                    tableData['left'] =
                    {
                        data: item.type,
                        alignment: "left"
                    };
                    tableData['right'] =
                    {
                        data: item.value +' '+ data.cartMetaData.currency,
                        alignment: "right"
                    };

                    return tableData;
                })

                const total1Obj = { table: { body: getTableData(calcLeftTable, false) }, widths: [185, 185], layout: {defaultBorder: false} };
                const total2Obj = [{ table: { body: getTableData(calcRightData, false) }, widths: [200, 90], margin: [-65, 0, 0, 0], styles: "tableStyle" }];

                const totalTable = [ ];
                const totalTable2 = [];
                totalTable.push(total1Obj);
                totalTable.push(total2Obj);
                totalTable2.push(totalTable);
                const totalObj = {
                    type: "table", values: totalTable2, 
                    layout: {defaultBorder: false}, widths: [370, 290]
                };
                dataArray.push(totalObj);
            }
            dataArray = PDFViewService.getProcessedDataArray(finalArr,dataArray,false,false,false,false);
            if(data.cartMetaData.urgentOrder){
                finalArr[finalArr.length - 1].columns.unshift({
                    image: 'data:image/png;base64,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',
                    width: 13
                })
            }
            var user = CacheService.getObject(CacheConstants.profil);
            var docDefinition = {
                info: {
                    title: (data.superCartNode.type === "order") ? ((data.cartMetaData.responseData != undefined && data.cartMetaData.responseData.orderNumber )?data.translatedLabels.orderNumber : $translate.instant("LABEL_ORDER")): data.translatedLabels.superCartNumber,
                },header: {
                    columns: [
                        {
                        image: pictoImage.RENAULT.value,
                        alignment: "left",
                        width: 50,
                        margin: [40, 15, 0, 10],
                    }]
                },
                footer:{
                    columns: [
                        {
                            image: pictoImage.TRIMAN.value,
                            margin: [20, 0, 0, 15],
                            width: 25,
                            bold: false
                        },
                        {
                            type: 'none',
                            ul: [
                                moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A"),
                                user.ipn + ' ' + user.firstName,
                            ],
                            alignment: 'right',
                            margin: [0, 0, 10, 0]
                        },                       
                       
                    ]
                    
                },
                content: [
                    finalArr
                ],
                styles: {
                    textStyle: {
                        margin: [0, 3, 0, 3],
                        alignment: "left",
                        fontSize: 8
                    },
                    rgpdStyle: {
                        margin: [0, 8, 0, 8],
                        fontSize: 7
                    },
                    tableTextStyle: {
                        margin: [0, 0, 0, 3],
                        fontSize: 8
                    },
                    tableStyle: {
                        margin: [0, 5, 0, 0]
                    },
                    othertableStyle: {
                        margin: [0, 5, 0, 0],
                        alignment: "right"
                    },
                    descTableStyle: {
                        margin: [0, 5, 0, 5]
                    },
                    tableHeader: {
                        margin: [0, 3, 0, 3],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    },
                    secondTableHeader: {
                        margin: [0, 3, 0, 10],
                        alignment: "center",
                        fontSize: 8,
                        bold: true
                    }
                }
            };

            deferred.resolve({
                data: docDefinition
            });
            return deferred.promise;
        }

        function getTableData(tableData, isHeader) {
            return PDFViewService.getTableData(tableData, isHeader);
        }

        function dataConcatenation(data1, data2, separator) {
            return UtilsMetierService.isEmpty(data1) ?
                (UtilsMetierService.isEmpty(data2) ? "" : data2) :
                (UtilsMetierService.isEmpty(data2) ? data1 :
                    data1.toString().concat(separator).concat(data2));
        }

        function convertImgToBase64(url, objVal) {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                pictoImage[objVal].value = dataURL;
                canvas = null;
            };
            img.src = url;
        }

    }
})();

(function() {
    angular
        .module("phenix.core")
        .service("printPdfModalService", printPdfModalService);

    /** @ngInject */
    function printPdfModalService($mdDialog,$q) {
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.showModal = showModal;
        this.encode64Base = encode64Base;

        function showModal(payload) {
            return $mdDialog.show({
                parent: payload.body,
                controller: "PdfModalController",
                templateUrl:
                    "app/core/components/pdfModal/pdfModal.template.html",
                clickOutsideToClose: true,
                showClose: true,
                locals: {
                    data : payload.data
                },
                bindToController: true,
                controllerAs: "vm"
            });
        }

                                /**
        * @desc function that aims to encode a file in base 64 format
        * @param {object} file file that we wish to encode
        * @returns {object} returns object containing the encoded format
        */
       function encode64Base(file) {
        var deferred = $q.defer();

        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (res) {
            console.log('res: ', res);
            deferred.resolve(res.target.result);

        }
        reader.onerror = function (error) {
            deferred.reject(error);
            console.log('Error: ', error);
        };

       return deferred.promise;

    }

    }
})();

(function() {
    angular
        .module("phenix.core")
        .service("listOfDraftModalService", listOfDraftModalService);

    /** @ngInject */
    function listOfDraftModalService($mdDialog,$rootScope) {
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.showModal = showModal;

        function showModal(payload) {
            return $mdDialog.show({
                parent: payload.body,
                controller: "superCartDraftListModalController",
                templateUrl:
                    "app/core/components/superCartDraftListModal/superCartDraftListModal.template.html",
                clickOutsideToClose: true,
                onRemoving : function () {
                    var isEasyBasket = false;
                    $rootScope.$broadcast("isEasyBasket",isEasyBasket);
                },
                skipHide: true,
                multiple: true,
                locals: {
                    title : payload.title,
                    subtitle: payload.subtitle,
                    typeOfSuperCart: payload.typeOfSuperCart,
                    showList: payload.showList,
                    showActifPartRequisition: payload.showActifPartRequisition,
                    isEasyBasket: payload.isEasyBasket,
                    isEasyBasketHeader:payload.isEasyBasketHeader,
                    isEasyBasketFooter: payload.isEasyBasketFooter,
                    prYesButton: payload.prYesButton,
                    prPopupHeader:payload.prPopupHeader,
                    tmPopupHeader:payload.tmPopupHeader,
                    tmYesButton:payload.tmYesButton,
                    tmPopUp:payload.tmPopUp,
                    prPopUp:payload.prPopUp
                },
                bindToController: true,
                controllerAs: "vm"
            });
        }
    }
})();

(function() {
    angular
        .module("phenix.core")
        .service("DeleteModalService", DeleteModalService);

    /** @ngInject */
    function DeleteModalService($mdDialog, $q) {
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.showModal = showModal;

        function showModal(payload) {
            return $mdDialog.show({
                parent: payload.body,
                controller: "deleteReferenceModal",
                templateUrl:
                    "app/components/dms/quote/modals/delete/deleteReferenceModal.template.html",
                clickOutsideToClose: true,
                locals: {
                    title : payload.title,
                    reference: payload.ref,
                    designation: payload.designation,
                    isList: payload.isList,
                    rows: payload.rows,
                    color: payload.color,
                    centerTitle: payload.centerTitle
                },
                bindToController: true,
                controllerAs: "vm"
            }).catch(function() {
                return $q.reject();
            });
        }
    }
})();

(function () {
    angular.module('phenix.core').factory('BasketTools2', function (
        CacheService,UtilsMetierService,ShoppingCartServiceConstant) {

        var _enums = ShoppingCartServiceConstant.enums;
        var isInterventionAccess = UtilsMetierService.isInterventionAccess();


        function BasketTools() {

            /**
             * @desc Update or Add items to shoppingCart, it's can be one or multiple items
             * @param {object} piece Look to createNewStructOfPiece
             * @param {string} type It's usefull when we need to make a difference PR/TM/ etc...
             * @return {void}
             */

            function onAddQuantity(piece, type, genericPart) {
                piece.genericPart && piece.genericPart !== undefined && !_.isEmpty(piece.genericPart) ? piece.genericPart : _.extend(piece, { "genericPart": genericPart });
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        return _.flow([addQuantity, checkMaxQuantity])(existingPiece, quantity)
                    } else {
                        if (newPiece.detectAsPPS) {
                            quantity = newPiece.propertionnalQuantity + newPiece.ratio;
                        }
                        return _.flow([createNewStructOfPiece])(newPiece, type, quantity);
                    }
                });
            }



            function onAddOneInQuantity(piece, type, genericPart) {
                piece.genericPart && piece.genericPart !== undefined && !_.isEmpty(piece.genericPart) ? piece.genericPart : _.extend(piece, { "genericPart": genericPart });
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        return _.flow([addOne, checkMaxQuantity])(existingPiece, quantity)
                    } else {
                        if (newPiece.detectAsPPS) {
                            quantity = newPiece.propertionnalQuantity + newPiece.ratio;
                        }
                        quantity = newPiece.quantity ? newPiece.quantity : quantity;
                        return _.flow([createNewStructOfPiece])(newPiece, type, quantity);
                    }
                });
            }

            /**
             *  To avoid regression and add more complexity to `onAddQuantity` function, we created a new
             *  one which doesn't handle PPS, and the quantity we add is from piece input
             *
             * @param {Objet}   piece
             * @param {String}  type
             *
             */
            function addSpecificQuantity(piece, type) {
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    if (existingPiece) {
                        return _.flow([addQuantity, checkMaxQuantity])(existingPiece, newPiece.quantity);
                    } else {
                        return _.flow([createNewStructOfPiece])(newPiece, type, newPiece.quantity);
                    }
                });
            }

            function onInputQuantity(piece, quantity, type) {
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var oldQuantity = newPiece.quantity;
                    var newQuantity = newPiece.detectAsPPS ? quantity * (newPiece.ratio || 1) : quantity;
                    if (existingPiece) {
                        if (newQuantity > 0) {
                            // clean old quantity
                            _.flow([reduceQuantity, checkMinQuantity])(existingPiece, oldQuantity);
                            // add new quantity
                            return _.flow([addQuantity, checkMaxQuantity])(existingPiece, newQuantity);
                        } else {
                            // clean old quantity
                            return _.flow([reduceQuantity, checkMinQuantity])(existingPiece, oldQuantity);
                        }
                    } else {
                        if (newQuantity > 0) {
                            return _.flow([createNewStructOfPiece])(newPiece, type, newQuantity);
                        }
                    }
                })
            }

            function onReduceQuantity(piece, type) {
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        return _.flow([reduceQuantity, checkMinQuantity])(existingPiece, quantity);
                    } else {
                        // It's only can be a PPS, because a mainReference can contain something like this (ratio: 1) :
                        // - REF quantity 2
                        //      - REF PPS 1 quantity 2
                        //      - REF PPS 2 quantity 0
                        // if user clicks on reduce, this gonna be :
                        // - REF quantity 1
                        //      - REF PPS 1 quantity 1
                        //      - REF PPS 1 quantity 1 << NEW PIECE
                        quantity = newPiece.propertionnalQuantity - newPiece.ratio;
                        return _.flow([createNewStructOfPiece])(newPiece, type, quantity);
                    }
                })
            }
            function onReduceOneInQuantity(piece, type) {
                return forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        return _.flow([reduceOneInQuantity, checkMinQuantity])(existingPiece, quantity);
                    } else {
                        // It's only can be a PPS, because a mainReference can contain something like this (ratio: 1) :
                        // - REF quantity 2
                        //      - REF PPS 1 quantity 2
                        //      - REF PPS 2 quantity 0
                        // if user clicks on reduce, this gonna be :
                        // - REF quantity 1
                        //      - REF PPS 1 quantity 1
                        //      - REF PPS 1 quantity 1 << NEW PIECE
                        quantity = newPiece.propertionnalQuantity - newPiece.ratio;
                        //newPiece.propertionnalQuantity - newPiece.ratio;
                        return _.flow([createNewStructOfPiece])(newPiece, type, quantity);
                    }
                })
            }
            /**
             *  @desc It's work like a reduce but for piece
             *  for each piece, and PPS, we call fn
             *  @param {object} piece look at createNewStructOfPiece
             *  @param {function} cb
             *  @return {Array<Object>}
             */

            function forEachElementInPiece(piece, cb) {
                // piece.additional can be null, that why we need a filter
                var listPiece = [].concat([piece], piece.additional).filter(function (piece) {
                    return piece;
                });

                return listPiece.reduce(function (acc, pieceFromListPiece, index) {
                    var existingPiece = lookingReferenceInCart(pieceFromListPiece);
                    // made a copy to avoid mutation
                    var copy = angular.copy(pieceFromListPiece);
                    // After the first piece, the following is necessarily a PPS;
                    copy.quantity = copy.quantity || 0;
                    var isPPS = index > 0;
                    if (isPPS) {
                        copy.ratio = parseInt(copy.ratio);
                        if (isNaN(copy.ratio)) {
                            copy.ratio = 1;
                        }
                        copy.propertionnalQuantity = (piece.quantity || 0) * copy.ratio;
                        copy.detectAsPPS = true;
                    }
                    return acc.concat(cb(copy, existingPiece));
                }, []);
            }

            function createNewStructOfPiece(piece, type, quantity) {
                var reference = piece.reference || piece.technicalId;
                //manage case when type is not defined
                var newPiece = {
                    designation: piece.designation,
                    type: type,
                    reference: reference,
                    quantity: quantity,
                    genericPart:piece.genericPart,
                    sbomId: piece.sbomId,
                    price: piece.price ? piece.price : "",
                }
                if(isInterventionAccess){
                    _.extend(newPiece,{
                        "suggestedQuantity": piece.suggestedQuantity ? piece.suggestedQuantity : null,
                        "interventionId": piece.interventionId ? piece.interventionId : null,
                        "interventionDesignation": piece.interventionDesignation ? piece.interventionDesignation : null,
                         "interventionQuantity": piece.interventionQuantity ? piece.interventionQuantity : null,
                         "interventionSieVersion": piece.interventionSieVersion ? piece.interventionSieVersion : null
                    });
                }

                if (type === 'PR') {
                    /** PR | PRODUCTS */

                    // reach: piece.reach,
                    // priceHT: piece.priceExclTaxes,
                    // currency: piece.currency,
                    // codeTaxe: piece.taxCode,

                    // PART REQUISITION ONLY
                    // orderType: 0,

                    // WORSHOP USER
                    // interventionId: piece.splitId,
                    // interventionLabel: piece.splitLabel

                } else if (type === 'TM') {

                    // DO WE NEED technicality, businessSpecificities ??
                    // technicality: piece.technicality,
                    // businessSpecifity: piece.businessSpecificities,


                    // PART REQUISITION
                    // orderType: 0,

                    // PART REQUISITION - WORSHOP USER
                    // interventionId: piece.splitId,
                    // interventionLabel: piece.splitLabel
                    _.extend(newPiece, {
                        opecod: piece.id
                    });

                    _.extend(newPiece, {
                        element: piece.element
                    });

                    _.extend(newPiece, {
                        operation: piece.operation
                    });

                    _.extend(newPiece, {
                        essay: piece.essay
                    });

                    if (piece.duration) {

                        // in v1/laborTimes service we receive duration with a ','
                        // parseFloat doesnt reconize ',' as '.'

                        _.extend(newPiece, {
                            laborTime: parseFloat(piece.duration.replace(/,/, '.'))
                        });
                    } else if (piece.laborTime != null) {
                        // basket API may return laborTime directly as a number instead of duration
                        _.extend(newPiece, {
                            laborTime: typeof piece.laborTime === 'string' ? parseFloat(piece.laborTime.replace(/,/, '.')) : piece.laborTime
                        });
                    }

                    if (_.isNumber(piece.priceExclTaxes)) {
                        _.extend(newPiece, {
                            exclTaxes : piece.priceExclTaxes
                        })
                    }


                    if (_.isBoolean(piece.codified)) {
                        _.extend(newPiece, {
                            codified: piece.codified
                        });
                    }
                } else {
                        _.extend(newPiece, {
                            reference: piece.reference || piece.technicalId
                        });
                       }

                return newPiece;
            }

            function adjustPPSQuantity(piece, existingPieceFromCart) {
                var actualQuantity = piece.quantity;
                var propertionnalQuantity = piece.propertionnalQuantity;
                if (actualQuantity > propertionnalQuantity) {
                    var quantityToReduce = actualQuantity - propertionnalQuantity;
                    _.flow([reduceQuantity, checkMinQuantity])(existingPieceFromCart, quantityToReduce);
                } else if (actualQuantity < propertionnalQuantity) {
                    var quantityToAdd = propertionnalQuantity - actualQuantity;
                    _.flow([addQuantity, checkMaxQuantity])(existingPieceFromCart, quantityToAdd);
                }
            }


            function getShoppingCart() {
                // return angular.copy(_shoppingCart);
            }

            /**
             * @desc Research inside _shoppingCart through an reference
             * @param {string} reference
             * @return {undefined | object<piece>}
             */

            function lookingReferenceInCart(listPiece) {
                var shoppingCart = CacheService.getDmsQuote().shoppingCart;

                if (!shoppingCart) {
                    return null;
                }

                var items = [].concat(shoppingCart.PR, shoppingCart.TM);
                var part;
                part = _.filter(items, function (piece) {
                    if (piece.reference === listPiece.reference && piece.interventionId == listPiece.interventionId) {
                        return piece;
                    }
                });

                if (!part) {
                    return null;
                }
                if (part.length === 0) {
                    return part[0];
                } else {
                    return _.find(part, function(item) {
                        return item.quantity > 0;
                    });
                }

            }

            // function deletePieceIfQuantityNull(piece) {
            //     if (piece.quantity === 0) {
            //         deletePieceToShoppingCart(piece.reference)
            //     }
            // }

            function addQuantity(piece, quantity) {
                 piece.quantity += quantity;

                return piece;
            }

            function addOne(piece, quantity) {

                piece.quantity =parseInt(piece.quantity)+ quantity;
                return piece;
            }

            function reduceQuantity(piece, quantity) {
                piece.quantity -= quantity;

                return piece;
            }
            function reduceOneInQuantity(piece, quantity) {



                if (piece.quantity.toString().indexOf(',') != -1) {
                    if( (piece.quantity.toString().split(',')[0]) > 0) {

                        piece.quantity = parseInt(piece.quantity.toString().split(',')[0]);

                    }
                } else if (piece.quantity > 0) {
                    if (piece.quantity.toString().indexOf('.') != -1) {
                        piece.quantity = parseInt(piece.quantity);
                    } else {
                        piece.quantity = piece.quantity - 1;
                    }
                }

                return piece;
            }

            function checkMaxQuantity(piece) {
                if (piece.quantity > _enums.QUANTITY_MAX) {
                    piece.quantity = _enums.QUANTITY_MAX;
                }
                return piece;
            }

            function checkMinQuantity(piece) {
                if (piece.quantity < _enums.QUANTITY_MIN) {
                    piece.quantity = _enums.QUANTITY_MIN;
                }
                return piece;
            }

            return {
                onAddQuantity: onAddQuantity,
                onInputQuantity: onInputQuantity,
                onReduceQuantity: onReduceQuantity,
                getShoppingCart: getShoppingCart,       // WE MAY DO NOT NEED THIS AFTER REFACTO
                // clearAll: clearAll,                     // WE MAY DO NOT NEED THIS AFTER REFACTO
                addSpecificQuantity: addSpecificQuantity,
                // deletePiece: deletePieceToShoppingCart  // WE MAY DO NOT NEED THIS AFTER REFACTO
                onAddOneInQuantity: onAddOneInQuantity,
                onReduceOneInQuantity: onReduceOneInQuantity
            }
        }

        return new BasketTools();
    });
})();

(function () {
    angular.module('phenix.core').factory('BasketTools', function (ShoppingCartServiceConstant) {
        var _enums = ShoppingCartServiceConstant.enums;
        var _actions = ShoppingCartServiceConstant.actions;


        function BasketTools() {
            var _shoppingCart = null;

            function addPieceToShoppingCart(piece) {
                if (!_shoppingCart) {
                    _shoppingCart = [];
                }
                _shoppingCart.push(piece);
            }

            function replaceShoppingCart(cart) {
                 _shoppingCart = angular.copy(cart);
            }

            /**
             * @desc clear all item in list
             */
            function clearAll() {
                _shoppingCart = [];
            }

            /**
             * @desc Update or Add items to shoppingCart, it's can be one or multiple items
             * @param {object} piece Look to createNewStructOfPiece
             * @param {string} type It's usefull when we need to make a difference PR/TM/ etc...
             * @return {void}
             */

            function onAddQuantity(piece, type) {
                forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : (newPiece.quantity?newPiece.quantity:1);
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        _.flow([addQuantity, checkMaxQuantity])(existingPiece, quantity)
                    } else {
                        if (newPiece.detectAsPPS) {
                            quantity = newPiece.propertionnalQuantity + newPiece.ratio;
                        }
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                    }
                });
            }


            function onAddOneInQuantity(piece, type) {
                forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        _.flow([addOne, checkMaxQuantity])(existingPiece, quantity)
                    } else {
                        if (newPiece.detectAsPPS) {
                            quantity = newPiece.propertionnalQuantity + newPiece.ratio;
                        }
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                    }
                });
            }
            /**
             *  To avoid regression and add more complexity to `onAddQuantity` function, we created a new
             *  one which doesn't handle PPS, and the quantity we add is from piece input
             *
             * @param {Objet}   piece
             * @param {String}  type
             *
             */
            function addSpecificQuantity(piece, type) {
                forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    if (existingPiece) {
                        _.flow([addQuantity, checkMaxQuantity])(existingPiece, newPiece.quantity);
                    } else {
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, newPiece.quantity);
                    }
                });
            }

            function onInputQuantity(piece, quantity, type) {
                 forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var oldQuantity = newPiece.quantity;
                    var newQuantity = newPiece.detectAsPPS ? quantity * (newPiece.ratio || 1) : quantity;
                    if (existingPiece) {
                        if (newQuantity > 0) {
                            // clean old quantity
                            _.flow([reduceQuantity, checkMinQuantity])(existingPiece, oldQuantity);
                            // add new quantity
                            _.flow([addQuantity, checkMaxQuantity])(existingPiece, newQuantity);
                        } else {
                            // clean old quantity
                            _.flow([reduceQuantity, checkMinQuantity, deletePieceIfQuantityNull])(existingPiece, oldQuantity);
                        }
                    } else {
                        if (newQuantity > 0) {
                            _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, newQuantity);
                        }
                    }
                })
            }

            function onReduceQuantity(piece, type) {
                forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        }
                        _.flow([reduceQuantity, checkMinQuantity, deletePieceIfQuantityNull])(existingPiece, quantity);
                    } else {
                        // It's only can be a PPS, because a mainReference can contain something like this (ratio: 1) :
                        // - REF quantity 2
                        //      - REF PPS 1 quantity 2
                        //      - REF PPS 2 quantity 0
                        // if user clicks on reduce, this gonna be :
                        // - REF quantity 1
                        //      - REF PPS 1 quantity 1
                        //      - REF PPS 1 quantity 1 << NEW PIECE
                        quantity = newPiece.propertionnalQuantity - newPiece.ratio;
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                    }
                })
            }




            function onReduceOneInQuantity(piece, type) {
                forEachElementInPiece(piece, function (newPiece, existingPiece) {
                    var quantity = newPiece.detectAsPPS ? newPiece.ratio : 1;
                    if (existingPiece) {
                        if (newPiece.detectAsPPS) {
                            adjustPPSQuantity(newPiece, existingPiece);
                        } 
                        _.flow([reduceOneInQuantity, checkMinQuantity])(existingPiece, quantity);
                    } else {
                        // It's only can be a PPS, because a mainReference can contain something like this (ratio: 1) :
                        // - REF quantity 2
                        //      - REF PPS 1 quantity 2
                        //      - REF PPS 2 quantity 0
                        // if user clicks on reduce, this gonna be :
                        // - REF quantity 1
                        //      - REF PPS 1 quantity 1
                        //      - REF PPS 1 quantity 1 << NEW PIECE
                        quantity = newPiece.propertionnalQuantity - newPiece.ratio;
                        _.flow([createNewStructOfPiece, addPieceToShoppingCart])(newPiece, type, quantity);
                    }
                })
            }
            /**
             * @desc Delete an item in cart
             * @param {reference} string
             * @return {void}
             */

            function deletePieceToShoppingCart(reference) {
                var index = _.findIndex(_shoppingCart, function (piece) {
                    return piece.reference === reference
                })
                if (index !== _enums.NOTFOUND) {
                    index === 0 ? _shoppingCart.shift() : _shoppingCart.splice(index, 1);
                }
            }

            /**
             *  @desc It's work like a forEach but for piece
             *  for each piece, and PPS, we call fn
             *  @param {object} piece look at createNewStructOfPiece
             *  @param {function} cb
             *  @return {void}
             */

            function forEachElementInPiece(piece, cb) {
                // piece.additional can be null, that why we need a filter
                var listPiece = [].concat([piece], piece.additional).filter(function (piece) {
                    return piece;
                });
                listPiece.forEach(function (pieceFromListPiece, index) {
                    var existingPiece = lookingReferenceInCart(pieceFromListPiece.reference);
                    // made a copy to avoir mutation
                    var copy = angular.copy(pieceFromListPiece);
                    // After the first piece, the following is necessarily a PPS;
                    copy.quantity = copy.quantity || 0;
                    var isPPS = index > 0;
                    if (isPPS) {
                        copy.ratio = parseInt(copy.ratio);
                        if (isNaN(copy.ratio)) {
                            copy.ratio = 1;
                        }
                        copy.propertionnalQuantity = (piece.quantity || 0) * copy.ratio;
                        copy.detectAsPPS = true;
                    }
                    cb(copy, existingPiece);
                })
            }

            function createNewStructOfPiece(piece, type, quantity) {
                //manage case when type is not defined
                if(!type){
                    return {
                        reference: piece.reference || piece.technicalId,
                        genericPart:piece.genericPart,
                        sbomId:piece.sbomId,
                        quantity: quantity,
                        type: type,
                        designation: piece.designation,

                        /** PR | PRODUCTS */

                        reach: piece.reach,
                        priceHT: piece.priceExclTaxes,
                        currency: piece.currency,
                        codeTaxe: piece.taxCode,
                        // PART REQUISITION ONLY
                        orderType: 0,

                        // WORSHOP USER
                        interventionId: piece.splitId,
                        interventionLabel: piece.splitLabel,
                        lineNumber: piece.lineNumber
                    }
                }
                //manage case when type is PR | TM
                if(type){
                    switch(type){
                        case "PR" :
                        return {
                            reference: piece.reference || piece.technicalId,
                            quantity: quantity,
                            genericPart:piece.genericPart,
                            sbomId:piece.sbomId,
                            type: type,
                            designation: piece.designation,

                            /** PR | PRODUCTS */

                            reach: piece.reach,
                            priceHT: piece.priceExclTaxes,
                            currency: piece.currency,
                            codeTaxe: piece.taxCode,
                            // PART REQUISITION ONLY
                            orderType: 0,

                            // WORSHOP USER
                            interventionId: piece.splitId,
                            interventionLabel: piece.splitLabel,
                            lineNumber: piece.lineNumber
                        }
                        case "TM" :
                        return {
                            reference: piece.reference || piece.technicalId,
                            quantity: quantity,
                            type: type,
                            designation: piece.designation,
                            priceHT: piece.priceExclTaxes,

                            /** TM */
                            opecod: piece.id,
                            laborTime: piece.duration,
                            technicality: piece.technicality,
                            businessSpecifity: piece.businessSpecificities,
                            codified: piece.codified,
                            // PART REQUISITION ONLY
                            orderType: 0,

                            // WORSHOP USER
                            interventionId: piece.splitId,
                            interventionLabel: piece.splitLabel
                        }

                    }
                }
            }

            function adjustPPSQuantity(piece, existingPieceFromCart) {
                var actualQuantity = piece.quantity;
                var propertionnalQuantity = piece.propertionnalQuantity;
                if (actualQuantity > propertionnalQuantity) {
                    var quantityToReduce = actualQuantity - propertionnalQuantity;
                    _.flow([reduceQuantity, checkMinQuantity])(existingPieceFromCart, quantityToReduce);
                } else if (actualQuantity < propertionnalQuantity) {
                    var quantityToAdd = propertionnalQuantity - actualQuantity;
                    _.flow([addQuantity, checkMaxQuantity])(existingPieceFromCart, quantityToAdd);
                }
            }


            function getShoppingCart() {
                return angular.copy(_shoppingCart);
            }

            /**
             * @desc Research inside _shoppingCart through an reference
             * @param {string} reference
             * @return {undefined | object<piece>}
             */

            function lookingReferenceInCart(reference) {
                return _.find(_shoppingCart, function (piece) {
                    return piece.reference === reference;
                })
            }

            function deletePieceIfQuantityNull(piece) {
                if (piece.quantity === 0) {
                    deletePieceToShoppingCart(piece.reference)
                }
            }

            function addQuantity(piece, quantity) {

               piece.quantity  =  piece.quantity+ quantity;
                return piece;
            }

            function addOne(piece, quantity) {
                piece.quantity =parseInt(piece.quantity)+ quantity;
                return piece;
            }

            function reduceQuantity(piece, quantity) {
                piece.quantity -= quantity;

                return piece;
            }
            function reduceOneInQuantity(piece, quantity) {
                if (piece.quantity.toString().indexOf(',') != -1) {
                    if( (piece.quantity.toString().split(',')[0]) > 0) {
                        piece.quantity = parseInt(piece.quantity.toString().split(',')[0]);
                    }
                } else if (piece.quantity > 0) {
                    if (piece.quantity.toString().indexOf('.') != -1) {
                        piece.quantity = parseInt(piece.quantity);
                    } else {
                        piece.quantity = piece.quantity - quantity;
                    }
                }

                return piece;
            }

            function checkMaxQuantity(piece) {
                if (piece.quantity > _enums.QUANTITY_MAX) {
                    piece.quantity = _enums.QUANTITY_MAX;
                }
                return piece;
            }

            function checkMinQuantity(piece) {
                if (piece.quantity < _enums.QUANTITY_MIN) {
                    piece.quantity = _enums.QUANTITY_MIN;
                }
                return piece;
            }

            return {
                onAddQuantity: onAddQuantity,
                onAddOneInQuantity: onAddOneInQuantity,
                onInputQuantity: onInputQuantity,
                onReduceQuantity: onReduceQuantity,
                onReduceOneInQuantity: onReduceOneInQuantity,
                addPieceToShoppingCart: addPieceToShoppingCart,
                getShoppingCart: getShoppingCart,
                clearAll: clearAll,
                addSpecificQuantity: addSpecificQuantity,
                replaceShoppingCart: replaceShoppingCart,
                deletePiece: deletePieceToShoppingCart
            }
        }

        return new BasketTools();
    });
})();

(function () {
    angular
        .module("phenix.core")
        .service("ActisFicModalService", ActisFicModalService);

    /** @ngInject */
    function ActisFicModalService($mdDialog, $q) {
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.showModal = showModal;

        function showModal(payload) {
            document.getElementById('Background_color').style.height = "200%";
            return $mdDialog.show({
                //parent: payload.body,
                parent: angular.element(payload.body),
                controller: "actisFicModal",
                templateUrl:
                    "app/components/dms/quote/modals/delete/actis-fic-modal.template.html",
                clickOutsideToClose: true,
                locals: {
                    title: payload.title,
                    reference: payload.ref,
                    designation: payload.designation,
                    isList: payload.isList,
                    rows: payload.rows,
                    color: payload.color
                },
                bindToController: true,
                controllerAs: "vm"
            }).catch(function () {
                return $q.reject();
            });
        }
    }
})();

angular.module('phenix.core').factory('blockUIUtils', function() {

  var $ = angular.element;

  var utils = {
    buildRegExp: function(pattern) {
      var match = pattern.match(/^\/(.*)\/([gim]*)$/), regExp;

      if(match) {
        regExp = new RegExp(match[1], match[2]);
      } else {
        throw Error('Incorrect regular expression format: ' + pattern);
      }

      return regExp;
    },
    forEachFn: function(arr, fnName, args) {
      var i = arr.length;
      while(i--) {
        var t = arr[i];
        t[fnName].apply(t, args);
      }
    },
    forEachFnHook: function(arr, fnName) {
      arr[fnName] = function() {
        utils.forEachFn(this, fnName, arguments);
      }
    },
    isElementInBlockScope: function($element, blockScope) {
      var c = $element.inheritedData('block-ui');

      while(c) {
        if(c === blockScope) {
          return true;
        }

        c = c._parent;
      }

      return false;
    },
    findElement: function ($element, predicateFn, traverse) {
      var ret = null;

      if (predicateFn($element)) {
        ret = $element;
      } else {

        var $elements;

        if (traverse) {
          $elements = $element.parent();
        } else {
          $elements = $element.children();
        }

        var i = $elements.length;
        while (!ret && i--) {
          ret = utils.findElement($($elements[i]), predicateFn, traverse);
        }
      }

      return ret;
    },
    indexOf: function(arr, obj, start) {
//      if(Array.prototype.indexOf) {
//        return arr.indexOf(obj, start);
//      }

      for (var i = (start || 0), j = arr.length; i < j; i++) {
        if (arr[i] === obj) {
          return i;
        }
      }

      return -1;
    }
  };

  return utils;

});

angular.module('phenix.core').factory('blockUI', function(blockUIConfig, $timeout, blockUIUtils, $document) {

  var $body = $document.find('body');

  var reservedStateProperties = ['id', 'blockCount', 'blocking'];


  var instances = [];
  

  instances.get = function(id) {

    if(!isNaN(id)) {
      throw new Error('BlockUI id cannot be a number');
    }

    var instance = instances[id];

    if(!instance) {
      // TODO: ensure no array instance trashing [xxx] -- current workaround: '_' + $scope.$id
      instance = instances[id] = new BlockUI(id);
      instances.push(instance);
    }

    return instance;
  };

  instances._destroy = function(idOrInstance) {
    if (angular.isString(idOrInstance)) {
      idOrInstance = instances[idOrInstance];
    }

    if (idOrInstance) {
      idOrInstance.reset();

      var i = blockUIUtils.indexOf(instances, idOrInstance);
      instances.splice(i, 1);

      delete instances[idOrInstance.state().id];
    }
  };
  var mainBlock = instances.get('main');
  
  instances.locate = function(request) {

    var result = [];


    blockUIUtils.forEachFnHook(result, 'start');
    blockUIUtils.forEachFnHook(result, 'stop');

    var i = instances.length;

    while(i--) {
      var instance = instances[i];
      var pattern = instance._pattern;

      if(pattern && pattern.test(request.url)) {
        result.push(instance);
      }
    }

    if(result.length === 0) {
      result.push(mainBlock);
    }

    return result;
  };

  blockUIUtils.forEachFnHook(instances, 'reset');

  mainBlock.addRef();
  mainBlock.instances = instances;

  return mainBlock;

  function BlockUI(id) {

    var self = this;

    var state = {
      id: id,
      blockCount: 0,
      message: blockUIConfig.message,
      blocking: false
    }, startPromise, doneCallbacks = [];

    this._id = id;

    this._refs = 0;

    this.start = function(messageOrOptions) {
      //document.getElementById('Background_color').style.height = document.getElementsByTagName("body")[0].scrollHeight+"px";
      messageOrOptions = messageOrOptions || {};

      if(angular.isString(messageOrOptions)) {
        messageOrOptions = {
          message: messageOrOptions
        };
      } else {
        angular.forEach(reservedStateProperties, function(x) {
          if(messageOrOptions[x]) {
            throw new Error('The property ' + x + ' is reserved for the block state.');
          }
        });
      }

      angular.extend(state, messageOrOptions);

      if(state.blockCount > 0) {
        state.message = messageOrOptions.message || state.message || blockUIConfig.message;
      } else {
        state.message = messageOrOptions.message || blockUIConfig.message;
      }

      // if(state.blockCount > 0) {
      //   messageOrOptions = messageOrOptions || state.message || blockUIConfig.message;
      // } else {
      //   messageOrOptions = messageOrOptions || blockUIConfig.message;
      // }

      // state.message = messageOrOptions;

      state.blockCount++;


      var $ae = angular.element($document[0].activeElement);

      if($ae.length && blockUIUtils.isElementInBlockScope($ae, self)) {

        if($ae[0])
          self._restoreFocus = $ae[0];



        $timeout(function() {
          if (self._restoreFocus && self._restoreFocus !== $body[0]) {
            self._restoreFocus.blur();
          }
        });
      }

      if (!startPromise && blockUIConfig.delay !== 0) {
        startPromise = $timeout(block, blockUIConfig.delay);
      } else if (blockUIConfig.delay === 0) {
        block();
      }

      function block () {
        startPromise = null;
        state.blocking = true;
      }
    };

    this._cancelStartTimeout = function() {
      if (startPromise) {
        $timeout.cancel(startPromise);
        startPromise = null;
      }
    };

    this.stop = function() {
      state.blockCount = Math.max(0, --state.blockCount);
      //document.getElementById('Background_color').style.height = "135%";
      if (state.blockCount === 0) {
        self.reset(true);
      }
    };

    this.isBlocking = function () {
        return state.blocking;
    };

    this.message = function(value) {
      state.message = value;
    };

    this.pattern = function(regexp) {
      if (regexp !== undefined) {
        self._pattern = regexp;
      }

      return self._pattern;
    };

    this.reset = function(executeCallbacks) {

      self._cancelStartTimeout();
      state.blockCount = 0;
      state.blocking = false;


      if(self._restoreFocus &&
         (!$document[0].activeElement || $document[0].activeElement === $body[0])) {

        try {
          // unable focus
          // self._restoreFocus.focus();
        } catch(e1) {
          (function () {
            var elementToFocus = self._restoreFocus;
            $timeout(function() {
              if(elementToFocus) {
                try {
                  elementToFocus.focus();
                } catch(e2) {
                  console.log(e2);
                }
              }
            },100);
          })();
        }

        self._restoreFocus = null;
      }

      try {
        if (executeCallbacks) {
          angular.forEach(doneCallbacks, function(cb) {
            cb();
          });
        }
      } finally {
        doneCallbacks.length = 0;
      }
    };

    this.done = function(fn) {
      doneCallbacks.push(fn);
    };

    this.state = function() {
      return state;
    };

    this.addRef = function() {
      self._refs += 1;
    };

    this.release = function() {
      if(--self._refs <= 0) {
        mainBlock.instances._destroy(self);
      }
    };
  }
});

angular.module('phenix.core').factory('blockUIHttpInterceptor', function($q, $injector, blockUIConfig, $templateCache) {

  var blockUI;

  function injectBlockUI() {
    blockUI = blockUI || $injector.get('blockUI');
  }

  function stopBlockUI(config) {
    if (blockUIConfig.autoBlock && (config && !config.$_noBlock && config.$_blocks)) {
      injectBlockUI();
      config.$_blocks.stop();
    }
  }

  function error(rejection) {

    try {
      stopBlockUI(rejection.config);
    } catch(ex) {
      console.log('httpRequestError', ex);
    }

    return $q.reject(rejection);
  }

  return {
    request: function(config) {

      if (blockUIConfig.autoBlock &&
        !(config.method == 'GET' && $templateCache.get(config.url))) {


        var result = blockUIConfig.requestFilter(config);

        if (result === false) {
          config.$_noBlock = true;
        } else {

          injectBlockUI();

          config.$_blocks = blockUI.instances.locate(config);
          config.$_blocks.start(result);
        }
      }

      return config;
    },

    requestError: error,

    response: function(response) {


      if(response) {
        stopBlockUI(response.config);
      }

      return response;
    },

    responseError: error
  };

});

angular.module('phenix.core').constant('blockUIConfig', {
    templateUrl: 'angular-block-ui.ng.html',
    delay: 250,
    //message: "Loading ...",
    autoBlock: false,
    resetOnException: true,
    requestFilter: angular.noop,
    autoInjectBodyBlock: true,
    cssClass: 'block-ui block-ui-anim-fade',
    blockBrowserNavigation: false
});


angular.module('phenix.core').directive('blockUi', function (blockUiCompileFn) {

  return {
    scope: true,
    restrict: 'A',
    compile: blockUiCompileFn
  };

}).factory('blockUiCompileFn', function (blockUiPreLinkFn) {

  return function () {
    return {
      pre: blockUiPreLinkFn
    };

  };

}).factory('blockUiPreLinkFn', function (blockUI, blockUIUtils, blockUIConfig) {

  return function ($scope, $element, $attrs) {


    if (!$element.hasClass('block-ui')) {
      $element.addClass(blockUIConfig.cssClass);
    }

    $attrs.$observe('blockUiMessageClass', function (value) {
      $scope.$_blockUiMessageClass = value;
    });


    var instanceId = $attrs.blockUi || '_' + $scope.$id;
    var srvInstance = blockUI.instances.get(instanceId);

    if (instanceId != 'main') {
      var parentInstance = $element.inheritedData('block-ui');

      if (parentInstance) {
        // TODO: assert if parent is already set to something else
        srvInstance._parent = parentInstance;
      }
    }


    $scope.$on('$destroy', function () {
      srvInstance.release();
    });


    srvInstance.addRef();


    $scope.$_blockUiState = srvInstance.state();

    $scope.$watch('$_blockUiState.blocking', function (value) {
      $element.attr('aria-busy', !!value);
      $element.toggleClass('block-ui-visible', !!value);
    });

    $scope.$watch('$_blockUiState.blockCount > 0', function (value) {
      $element.toggleClass('block-ui-active', !!value);
    });


    var pattern = $attrs.blockUiPattern;

    if (pattern) {
      var regExp = blockUIUtils.buildRegExp(pattern);
      srvInstance.pattern(regExp);
    }


    $element.data('block-ui', srvInstance);

  };

});

angular.module('phenix.core').directive('blockUiContainer', function (blockUIConfig, blockUiContainerLinkFn) {
  return {
    scope: true,
    restrict: 'A',
    compile: function() {
      return blockUiContainerLinkFn;
    }
  };
}).factory('blockUiContainerLinkFn', function () {

  return function ($scope, $element) {

    var srvInstance = $element.inheritedData('block-ui');

    if (!srvInstance) {
      throw new Error('No parent block-ui service instance located.');
    }

    $scope.state = srvInstance.state();

  };
});

var decorateLocation = [
  '$delegate', 'blockUI', 'blockUIConfig',
  function ($delegate, blockUI, blockUIConfig) {

    if (blockUIConfig.blockBrowserNavigation) {

      blockUI.$_blockLocationChange = true;

      var overrides = ['url', 'path', 'search', 'hash', 'state'];

      function hook(f) {
        var s = $delegate[f];
        $delegate[f] = function () {

          var result = s.apply($delegate, arguments);

          if (result === $delegate) {
            blockUI.$_blockLocationChange = false;
          }

          return result;
        };
      }
      angular.forEach(overrides, hook);
    }

    return $delegate;
}];

angular.module('phenix.core').config(function ($provide) {
  $provide.decorator('$location', decorateLocation);
});

angular.module('phenix.core').config(function ($provide, $httpProvider) {

  $provide.decorator('$exceptionHandler', ['$delegate', '$injector',
    function ($delegate, $injector) {
      var blockUI, blockUIConfig;

      return function (exception, cause) {

        blockUIConfig = blockUIConfig || $injector.get('blockUIConfig');

        if (blockUIConfig.resetOnException) {
          try {
            blockUI = blockUI || $injector.get('blockUI');
            blockUI.instances.reset();
          } catch (ex) {
            console.log('$exceptionHandler', exception);
          }
        }

        $delegate(exception, cause);
      };
    }
  ]);

  $httpProvider.interceptors.push('blockUIHttpInterceptor');
});

angular.module('phenix.core').run(function ($document, blockUIConfig) {
  if (blockUIConfig.autoInjectBodyBlock) {
    $document.find('body').attr('block-ui', 'main');
  }
});

(function () {

    angular.module('phenix.core').component('selectOrderNumber', {
        bindings: {
            defaultValue: '<',
            onChange: '<'
        },
        template: '\
            <div id="selectOrderNumber">\
                <i class="icon-icons_repair"></i>\
                <select id="orderNumber"\
                    style="width: 102px;"\
                    ng-class="{error: vm.orderNumber === \'-\' || vm.orderNumber === null}"\
                    ng-change="vm.changeOrderNumber(vm.orderNumber)"\
                    ng-model="vm.orderNumber"\
                    ng-options="option for option in vm.orderList">\
                </select>\
            <div>',
        controller: selectOrderNumber,
        controllerAs: 'vm'
    });

    function selectOrderNumber(
        $q,
        blockUI,

        CacheService,
        DmsMetierService,

        CacheConstants,
        CodesConstants,$log,$translate) {

        var vm = this;

        vm.changeOrderNumber = changeOrderNumber;
        vm.orderNumber = '-';
        vm.orderList = ['-']

        var carSearchContext = CacheService.getCarSearchContext();

        /**
         *  @desc Get the list of order number, and set the default order if sent;
         */

        this.$onInit = function () {
            if (vm.defaultValue) {
                vm.orderNumber = vm.defaultValue;
            }
            

            //get orders numbers
            blockUI.start();
            loadVehicleOrderNumbers(carSearchContext, vm.orderNumber).then(function (vehicleOrderNumbers) {
                vm.orderList = vehicleOrderNumbers;
            }).finally(function () {
                blockUI.stop();
            });
        }

        this.$onChanges = function () {
            if (vm.defaultValue) {
                vm.orderNumber = vm.defaultValue;
            }
        }

        /**
         *  @desc Event on select
         *  @param {string} or
         */

        function changeOrderNumber(or) {
            vm.onChange(or);
        }

        /**
         * @name loadVehicleOrderNumbers
         * @desc load vehicle's order numbers list
         * @param {*} carSearchContext
         */
        function loadVehicleOrderNumbers(carSearchContext, orderNumber) {

            if (carSearchContext) {
                var vin = carSearchContext.vehicle.vin;
                var imat = carSearchContext.vehicle.imat;
                var openOrderFlag = carSearchContext.ordersAndSplits ? carSearchContext.ordersAndSplits.openOrderFlag : null;               
                var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);
                var isOrSearchCar = CacheService.getObject(CacheConstants.isOrSearchCar);
                var orderAndSplits = carSearchContext.ordersAndSplits ? carSearchContext.ordersAndSplits : (dmsResponse ? dmsResponse.ordersAndSplits: null);

                return $q.resolve().then(function () {
                    if (vin) {
                            if (!isOrSearchCar && orderAndSplits) {
                                //set order and splits form vehicle.v1 response for unkown bvm vehicle
                                if (!openOrderFlag) {
                                    carSearchContext.ordersAndSplits = orderAndSplits;
                                    openOrderFlag = orderAndSplits.openOrderFlag;
                                }
                                return orderAndSplits.orderNumbers;
                            }else if(isOrSearchCar){
                                return DmsMetierService.getVehicleByVin(vin).then(function (vehicleDmsresponse) {

                                    if (!openOrderFlag) {
                                        carSearchContext.ordersAndSplits = vehicleDmsresponse.response.ordersAndSplits;
                                        openOrderFlag = carSearchContext.ordersAndSplits.openOrderFlag;
                                    }
                                    return vehicleDmsresponse.response.ordersAndSplits.orderNumbers;
                                }).catch(function(){
                                    $log.debug($translate.instant('ERROR'));
                                });
                            }
                    }
                    else {
                            if (!isOrSearchCar && orderAndSplits) {
                                //set order and splits form vehicle.v1 response for unkown bvm vehicle
                                if (!openOrderFlag) {
                                    carSearchContext.ordersAndSplits = orderAndSplits;
                                    openOrderFlag = orderAndSplits.openOrderFlag;
                                }
                                return orderAndSplits.orderNumbers;
                            }else if(isOrSearchCar){
                                return DmsMetierService.getVehicleByRegistrationNumber(imat).then(function (vehicleDmsresponse) {
                                    if (!openOrderFlag) {
                                        carSearchContext.ordersAndSplits = vehicleDmsresponse.response.ordersAndSplits;
                                        openOrderFlag = carSearchContext.ordersAndSplits.openOrderFlag;
                                    } 
                                    return vehicleDmsresponse.response.ordersAndSplits.orderNumbers; 
                                });
                            }
                    }
                }).then(function (orderNumbersResponse) {
                    var ordersList = ['-'];

                    if (_.difference(orderAndSplits.orderNumbers, orderNumbersResponse).length > 0) {
                        carSearchContext.ordersAndSplits.orderNumbers = orderNumbersResponse;
                        CacheService.setObject(CacheConstants.contextCarSearch, carSearchContext);
                    }

                    switch (openOrderFlag) {
                        case CodesConstants.ONE_ORDER_TYPE:
                            if (orderNumbersResponse && orderNumbersResponse.length > 0) {
                                ordersList = ordersList.concat(orderNumbersResponse);
                            }
                            else {
                                ordersList = ordersList.concat(orderNumber);
                            }
                            break;
                        case CodesConstants.MULTIPLES_ORDERS_TYPES:
                            ordersList = ordersList.concat(orderNumbersResponse);
                            break;
                    }


                    return ordersList;
                });
            }
        }
    }
})();

(function() {
    angular.module("phenix").component("selectIntervention", {
        bindings: {
            defaultValue: "<" /* MANDATORY : STRING   */,
            item: "<" /* MANDATORY : OBJECT   */,
            onChange: "<" /* MANDATORY : FUNCTION */
        },

        templateUrl: "app/core/select/select-intervention.template.html",
        controller: selectIntervention,
        controllerAs: "vm"
    });

function selectIntervention(DmsMetierService, PartRequisitionMetierService, CarSearchMetierService, $rootScope, CacheService, PartRequisitionConstants,CacheConstants, $scope) {
        var vm = this;

        /***********************
         *      FUNCTION       *
         **********************/

        vm.onUpdate = onUpdate;

        /************************
         *      VARIABLES       *
         ************************/

        var _intervention;
        var unsubReload;
        var unsubClean;
        var orderNumberIsSet;
        var _unsubscribe;
        vm.split = {
            splitId: null,
            splitLabel: "-",
            computedLabel: "-"
        };

        vm.interventionIsMandatory = false;

        vm.splits = [];

        /**
         *  @desc Get operation/splits list, and set select by default
         */

        this.$onInit = function() {
            retrieveData();
        };
        /**
         * @desc Get order number and splits, set them in dmsResponse and contextCarSearch in cache, then get splits and load them in html
         */
        function retrieveData() {
            var partRequisition = CacheService.getObject(PartRequisitionConstants.bs);
            CarSearchMetierService.refreshSplitOnChangeOrderNumber();
            resetDefaultValue();
            // Get orderNumber and splits from car search context in cache  
            _intervention = PartRequisitionMetierService.getOrdersAndSplits();
            orderNumberIsSet = PartRequisitionMetierService.isSetOrderNumberPartRequisition(partRequisition);
            loadData();

            /* DmsMetierService.getOrderByNumber(partRequisition.orderNumber)
                .then(function (response) {
                    var returnCode = response.returnCode;
                    //set data in dmsResponse in cache when passed
                    if (response.response && returnCode === 0) {
                        return CacheService.setObject(CacheConstants.dmsResponse, response.response);
                    }
                    //clean splits lists when request is failed
                    else {
                        $rootScope.$emit('clean');
                        return CarSearchMetierService.handleErrorFromDmsOrder(returnCode);
                    }
                }).then(function () {
                    //get splits for the selected order number and set them in carSearchContext
                    
                }).then(function () {
                    
                }); */
        }

        function loadData() {
            if (_intervention && _intervention.splits) {
                _intervention.splits = _intervention.splits.map(function(
                    split
                ) {
                    return _.extend(split, {
                        computedLabel: split.splitId + " - " + split.splitLabel
                    });
                });
            }

            if (!_intervention.isSplittingRequired) {
                vm.splits = vm.splits.concat([vm.split]);
            } else if (_intervention.isSplittingRequired && (!_intervention.defaultSplitFlag ||  _intervention.defaultSplitFlag === 2)) {
                vm.splits = vm.splits.concat([vm.split]);
                vm._interventionIsMandatory = true;
            }

            if (_intervention.splits) {
                vm.splits = vm.splits.concat(_intervention.splits);
            }

            if (_intervention.splits && orderNumberIsSet && _intervention.splits.length === 1) {
             vm.split = _intervention.splits[0];
             onUpdate(_intervention.splits[0]);
            }
            if (vm.defaultValue) {
                vm.split = _.find(vm.splits, function (split) {
                    return split.splitId == vm.defaultValue;
                });
            }

        }


        unsubReload = $rootScope.$on("reload", function () {
            retrieveData();
        });

        unsubClean = $rootScope.$on("clean", function () {
            if (_intervention && _intervention.splits) {
                _intervention.splits = [];
            }
            resetDefaultValue();
            loadData();
        });


        $scope.$on("$destroy", function () {
            unsubReload();
            unsubClean();
        })


        //called in order to reset the default values to be sure to have the right splits
        function resetDefaultValue() {
            _intervention = {};
            vm.splits = [];
            vm.split = {
                splitId: null,
                splitLabel: "-",
                computedLabel: "-"
            };
           //vm.defaultValue = null;
        }

        /**
         *  @desc This function is trigger when the select is uptated
         *  @param {object} {
         *      splitId: string,
         *      splitLabel: string,
         *      computedLabel: string
         *  }
         */

        function onUpdate(split) {
            vm.onChange(vm.item, split);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('scrollUp', scrollUp);

  /* @ngInject */
  function scrollUp($location) {
    var directive = {
      restrict: 'EA',
      replace: true,
      transclude: true,
      link: link,
      scope: {
        scrollTrigger: '@', //when you want to show the button
        scrollAnchor: '@' //where you want to scroll on button click
      },
      template: '<div id="btnBackTop" ng-click="scrollToTop()" style="display: none;">' +
                '<i class="icon-icons_scroll_to_top_phx"></i>' +
                '</div>'
    };
    return directive;

    function link(scope, el) {
      var anchor;
      var trigger = scope.scrollTrigger ? scope.scrollTrigger : $(window).height();

      scope.scrollToTop = scrollToTop;
      //////////////

      //show/hide button on scroll position
      $(window).scroll(function () {
        if ($(this).scrollTop() > trigger) {
          el[0].style.display = 'block'; // 1. back to top arrow in PR and TM are two blocks of code, both targeted for chaage of display with this line.
          // $(el).find("#btnBackTop").css('display', 'block'); //2. With this line only one of the arrows' display option was changed.
        } else {
          el[0].style.display = 'none';
          // $(el).find('#btnBackTop').css('display', 'none');
        }
      });

      /**
       * scroll to top position define in anchor
       */
      function scrollToTop() {
        $location.hash('');
        defineAnchorPosition(scope.scrollAnchor);
        $('html, body').animate({scrollTop: anchor}, 300);
      }

      /**
       * define top position of elem
       * @param elem
       */
      function defineAnchorPosition(elem) {
        anchor = elem && $(elem).length !== 0 ? $(elem).position().top : 0;
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('revealPwd', revealPwd);

  /* @ngInject */
  function revealPwd($translate) {

    function RevealPwdLink(scope, element, attrs) {
      scope.showPassword = false;
    }


    return {
      templateUrl: 'app/core/revealPwd/revealPwd.html',
      restrict: 'E',
      scope: {
        pwdModel: "="
      },
      link: RevealPwdLink //FI: use controller if need to expose an API, else use link
    };
  }


  /**
   * @example
   *   <reveal-pwd pwd-model="vm.user.password"></reveal-pwd>
   */

})();


(function(){
    angular
        .module('phenix.core')
        .service('RetailGroupService', RetailGroupService);

        /** @ngInject */
        function RetailGroupService(
            RetailGroupConstants
        ){

            /*=============================================
            =                 VARIABLES                   =
            =============================================*/
            var vm = this;

            vm.getParameters = getParameters;
            vm.manageRetailGroupObject = manageRetailGroupObject;
            vm.isUserProfileChanged = isUserProfileChanged;
            vm.updateUserProfile = updateUserProfile;

            /**
             * @name getParameters
             * @desc get url parameters
             * @param {Object} parametrsObject
             */
            function getParameters(parametrsObject){
                return parametrsObject;
            }

            /**
             * @name manageRetailGroupObject
             * @desc parse url to get action
             * @param {Object} paramsObject
             */
            function manageRetailGroupObject(paramsObject){
                var result = 0;
                if(_.isEmpty(paramsObject)){
                    result = RetailGroupConstants.Result.emptyParameters;
                }
                else if(!paramsObject.hasOwnProperty(RetailGroupConstants.Parameters.appId)
                    || !paramsObject.hasOwnProperty(RetailGroupConstants.Parameters.dealerId)
                    || !paramsObject.hasOwnProperty(RetailGroupConstants.Parameters.workshopPartshopId)
                    || !paramsObject.hasOwnProperty(RetailGroupConstants.Parameters.profil)){
                    result = RetailGroupConstants.Result.mandatoryFiledsNotExist;
                }
                else if(paramsObject.APP_ID !== RetailGroupConstants.App_ID.DMS){
                    result = RetailGroupConstants.Result.appIdNotDms;
                }
                else{
                    switch(paramsObject.profil){
                        case RetailGroupConstants.Profil.Partshop:
                            if(paramsObject.accountid && paramsObject.accountid != ""){
                                result = RetailGroupConstants.Result.partshopProfilWithAccountId;
                            }else if((paramsObject.VIN && paramsObject.VIN != "")||(paramsObject.vin && paramsObject.vin != "") ||(paramsObject.Vin && paramsObject.Vin != "")){
                                result = RetailGroupConstants.Result.partshopProfilWithVin;
                            }
                            else{
                                result = RetailGroupConstants.Result.partshopProfil;
                            }
                            break;
                        case RetailGroupConstants.Profil.Workshop:
                            if(paramsObject.OR && paramsObject.OR != ""){
                                result = RetailGroupConstants.Result.workshopProfilWithOrderNumber;
                            }
                            else if(paramsObject.VIN && paramsObject.VIN != ""){
                                result = RetailGroupConstants.Result.workshopProfilWithVin;
                            }
                            else{
                                result = RetailGroupConstants.Result.workshopProfil;
                            }
                            break;
                    }
                }
                return result;
            }

            /**
             * @name isUserProfileChanged
             * @desc check if user profile is changed
             * @param {Object} userProfile
             * @param {Object} parametersObject
             */
            function isUserProfileChanged(userProfile, parametersObject){
                if(userProfile.dealerId === parametersObject.dealerid
                    && userProfile.dmsConfig.workshopPartshopId === parametersObject.workshoppartshopid
                    && ((userProfile.dmsConfig.networkProfile === RetailGroupConstants.NetworkProfile.Partshop && parametersObject.profil === RetailGroupConstants.Profil.Partshop)
                    || (userProfile.dmsConfig.networkProfile === RetailGroupConstants.NetworkProfile.Workshop && parametersObject.profil === RetailGroupConstants.Profil.Workshop))){
                    return false;
                }
                return true;
            }

            /**
             * @name updateUserProfile
             * @desc update user profil using url parameters
             * @param {Object} userProfile
             * @param {Object} parametersObject
             */
            function updateUserProfile(userProfile, parametersObject){
                userProfile.dealerId = parametersObject.dealerid;
                userProfile.dmsConfig.workshopPartshopId = parametersObject.workshoppartshopid;
                if(userProfile.dmsConfig.networkProfile === RetailGroupConstants.NetworkProfile.Partshop && parametersObject.profil === RetailGroupConstants.Profil.Workshop){
                    userProfile.dmsConfig.networkProfile = RetailGroupConstants.NetworkProfile.Workshop;
                }
                else if(userProfile.dmsConfig.networkProfile === RetailGroupConstants.NetworkProfile.Workshop && parametersObject.profil === RetailGroupConstants.Profil.Partshop){
                    userProfile.dmsConfig.networkProfile = RetailGroupConstants.NetworkProfile.Partshop;
                }
                return userProfile;
            }
        }
})();

(function(){
    'use strict';

    angular
        .module('phenix')
        .constant('RetailGroupConstants', {
            Result:{
                emptyParameters: -1,
                mandatoryFiledsNotExist: -2,
                appIdNotDms: -3,
                partshopProfil: 1,
                partshopProfilWithAccountId: 2,
                workshopProfil: 3,
                workshopProfilWithOrderNumber: 4,
                workshopProfilWithVin: 5,
                partshopProfilWithVin:17
            },
            App_ID:{
                DMS: 'DMS'
            },
            Profil:{
                Partshop: 'Magasin',
                Workshop: 'Atelier'
            },
            NetworkProfile:{
                Partshop: 'PARTSHOP',
                Workshop: 'WORKSHOP'
            },
            Parameters:{
                appId: 'APP_ID',
                dealerId: 'dealerid',
                dealerLabel: 'dealerLabel',
                workshopPartshopId: 'workshoppartshopid',
                profil: 'profil'
            },
            retailGroup: 'retailGroup',
            retailGroupCookieName: 'NewDialogys-Dms'
        })
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .config(config);

    /** @ngInject */
    function config(RestangularProvider, configConstantes) {
        RestangularProvider.setBaseUrl(configConstantes.baseUrlBack + configConstantes.apiBack);
        RestangularProvider.setDefaultHeaders({
            'Content-Type': 'application/json; charset=UTF-8'
        });
        RestangularProvider.setPlainByDefault(true);
        RestangularProvider.setDefaultHttpFields({
            withCredentials: true
        });
    }

    angular.module('phenix.core').factory('RestUpgrade', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(configConstantes.springBackBaseUrl + configConstantes.apiBack);
            RestangularConfigurer.setDefaultHeaders({
                'Content-Type': 'application/json; charset=UTF-8'
            });
        });
    });

    angular.module('phenix.core').factory('RestUpgradeRaw', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(configConstantes.springBackBaseUrl + configConstantes.apiBack);
            RestangularConfigurer.setDefaultHeaders({
                'Content-Type': 'application/json; charset=UTF-8'
            });
            RestangularConfigurer.setFullResponse(true);
        });
    });

    angular.module('phenix.core').factory('RestUpgradeRLink', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(configConstantes.springBackBaseUrl + configConstantes.apiBack);
            RestangularConfigurer.setDefaultHttpFields({
                timeout: configConstantes.rLinkRestTimeout
            });
        });
    });
    angular.module('phenix.core').factory('RestRLink', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setDefaultHttpFields({
                timeout: configConstantes.rLinkRestTimeout
            });
        });
    });

    angular.module('phenix.core').factory('RestLSR', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setDefaultHeaders({
                'Content-Type': 'application/json; charset=UTF-8'
            });
            RestangularConfigurer.setPlainByDefault(true);
            RestangularConfigurer.setDefaultHttpFields({
                withCredentials: true,
                timeout: configConstantes.lsrTimeout
            });
        });
    });
    angular.module('phenix.core').factory('RestUpgradeLSR', function (Restangular, configConstantes) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setDefaultHeaders({
                'Content-Type': 'application/json; charset=UTF-8'
            });
            RestangularConfigurer.setBaseUrl(configConstantes.springBackBaseUrl + configConstantes.apiBack);
            RestangularConfigurer.setPlainByDefault(true);
            RestangularConfigurer.setDefaultHttpFields({
                withCredentials: true,
                timeout: configConstantes.lsrTimeout
            });
        });
    });
})();

(function () {
    'use strict';

    angular.module('phenix.core').run(function (TokenService, RestUpgrade, Restangular, LoginConstants, UserKeyService) {

        Restangular.addFullRequestInterceptor(function (element, operation, route, url, headers, params) {
                var token = TokenService.getToken();
                var secret = LoginConstants.ndApiSecret;
                const userKey = UserKeyService.getUserKey();
                
                headers = _.extend(headers, {
                    'Authorization': 'Bearer ' + token,
                    'Furtive-latch': secret
                });
                
                // Add X-ND-CTX header if userKey is available
                if (userKey) {
                    headers['X-ND-CTX'] = userKey;
                }
                
                if (headers.Cookie) {
                    var cookies = headers.Cookie.split('; ');
                    cookies = cookies.filter(function(cookie) {
                        return !cookie.startsWith('assure=');
                    });
                    headers.Cookie = cookies.join('; ');
                }
                return {
                    headers: headers,
                    elem: element,
                    params: params
                };
            }
        );
        RestUpgrade.addFullRequestInterceptor(function (element,operation, route, url, headers, params) {
            var token = TokenService.getToken();
            var secret = LoginConstants.ndApiSecret;
            const userKey = UserKeyService.getUserKey();
            
            headers = _.extend(headers, {
                'Authorization': 'Bearer ' + token,
                'Furtive-latch': secret
            });
            
            // Add X-ND-CTX header if userKey is available
            if (userKey) {
                headers['X-ND-CTX'] = userKey;
            }
            
            if (headers.Cookie) {
                var cookies = headers.Cookie.split('; ');
                cookies = cookies.filter(function(cookie) {
                    return !cookie.startsWith('assure=');
                });
                headers.Cookie = cookies.join('; ');
            }
            return {
                headers: headers,
                elem: element,
                params: params
            };
        }
        );

    });

})();



(function () {
    'use strict';

    angular
        .module('phenix.core')
        .run(runBlock);

    /**
     *      @desc Intercepteur qui va gerer le retour des
     *      requetes en cas d'erreur.
     *
     *      403 = token expiré
     *      TODO : Definir ce qu'on `reject` dans ce cas
     *      Redirection vers la page de connection
     *
     */

    /** @ngInject */
    function runBlock(toastr, $state, $rootScope, configConstantes, CacheService, $translate, TokenService, LoginConstants,CarSearchConstants,
        AlertsConstants,ApplicabilitiesConstants,$location,
        FavouriteConstantes,CloudFrontService,ActisConstantes,CryptoService,CacheConstants,RestUpgrade,rLinkConstant
    ) {
        const HTTP_STATUS = {
            UNAUTHORIZED: 401,
            CUSTOM_SESSION_EXPIRED: 430
        };
        
        function handleErrorResponse(response, deferred) {
            if (!response.config) {
                return true; // Or handle appropriately for cases where response.config is undefined
            }
        
            var fromNdSB = response.config.url.match(configConstantes.springBackBaseUrl);
            var fromNd = response.config.url.match(configConstantes.baseUrlBack);
            var fromNissan = response.config.url.match(configConstantes.nissanUrl);
            var fromHtl = response.config.url.match(LoginConstants.logisticIds);
            var fromHtl2 = response.config.url.match(AlertsConstants.alerts);
            var fromR2A = response.config.url.match(CarSearchConstants.r2aStock);
            var fromRparts = response.config.url.match(CarSearchConstants.r2aPlaceOrder);
            var fromR2APrice = response.config.url.match(CarSearchConstants.r2aPriceTaxDiscount);
            var fromOts = response.config.url.match(CarSearchConstants.restCarOts);
            var fromSpareParts = response.config.url.match(CarSearchConstants.sparePart);
            var fromNews = response.config.url.match(CarSearchConstants.breakingNews);
            var fromAxleGeo = response.config.url.match(ApplicabilitiesConstants.axleGeometry);
            var fromasom = response.config.url.match(ActisConstantes.endpoint.assistanceTokens);
            if ((response.status === HTTP_STATUS.UNAUTHORIZED || response.status === HTTP_STATUS.CUSTOM_SESSION_EXPIRED) && (fromNd || fromNdSB || fromNissan)) {
                toastr.warning($translate.instant('SESSION_EXPIRED'));
                deferred.reject({});
                CloudFrontService.removeAccessCookies();
                CacheService.clearAll();
                TokenService.delToken();
                $state.go('/connection');
                return false;
            } else if (response.status == -1 && fromR2A) {
                var msg = $translate.instant('CENTRAL_UNAVAILABLE');
                toastr.warning(msg);
                $rootScope.$broadcast("central_unavailable");
                return false;
            } else if (response.status == 400 && fromasom && !fromR2APrice) {
                var encrypted = CryptoService.AES.encrypt("0", CacheConstants.encryptedValue);
                CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());
            } else if (response.status == 500 && response.status != 400 && fromRparts) {
                toastr.error($translate.instant("PLACE_ORDER_ERROR"));
            } else if (response.status !== 200 && !fromR2APrice) {
                // UGLY BUT FUNCTIONAL
                // Check if env==local
                if (_.includes(configConstantes.baseUrlBack, '127.0.0.1') && !fromHtl && !fromHtl2) {
                    toastr.warning(response.status + ' - ' + response.statusText, 'Error');
                }
                if (fromSpareParts || fromAxleGeo || fromNews) {
                    return false;
                }
                if (!$location.path().includes('carFeatures') && fromOts && (response.status == 404 || response.status == 500)) {
                    CacheService.setObject(CacheConstants.otsCheck, true);
                    return false;
                }
            }
        
            return true;
        }
        
        RestUpgrade.setErrorInterceptor(function(response, deferred) {
            return handleErrorResponse(response, deferred);
        });
    }

})();

(function() {
    angular.module('phenix.core').component('recapCart', {
        bindings: {
            flattenCart: '<',
            cartMetadata: '<',
            newHeader: '<'
        },
        templateUrl: 'app/core/recap-cart/recap-cart.template.html',
        controller: recapCartController
    })

    function recapCartController() {
        var vm = this;
        vm.pr = [];
        vm.tm = [];

        this.$onInit = function() {
            splitByTypes(vm.flattenCart);
        }

        function splitByTypes(cart) {
            var tm = [];
            var pr = [];
            (cart || []).forEach(function(piece) {
                if (piece.type === 'TM') {
                    tm.push(piece);
                } else {
                    pr.push(piece);
                }
            })
            vm.pr = pr;
            vm.tm = tm;
        }

        this.$onChanges = function (changes){
            if (changes.cartMetadata) {
                vm.cartMetadata = changes.cartMetadata.currentValue;
            }
            if (changes.flattenCart) {
                vm.flattenCart = changes.flattenCart.currentValue || [];
            }
            if (changes.newHeader) {
                vm.newHeader = changes.newHeader.currentValue;
            }
            splitByTypes(vm.flattenCart);
        }
    }
})();

(function(){
    angular
        .module('phenix.core')
        .service('RdsService', RdsService);

        /** @ngInject */
        function RdsService(
            RdsConstants,
            $cookies
        ){

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.manageRdsObject = manageRdsObject;

        /**
         * @name manageRdsObject
         * @desc parse url to get action
         * @param {Object} paramsObject
         */
        function manageRdsObject(paramsObject){
            var result = 0;
            if(_.isEmpty(paramsObject)){
                result = RdsConstants.Result.emptyParameters;
            }
            else if(!paramsObject.hasOwnProperty(RdsConstants.Parameters.APP_ID)
                || !paramsObject.hasOwnProperty(RdsConstants.Parameters.TYPE)
                ){
                result = RdsConstants.Result.mandatoryFiledsNotExist;
            }
            else if(paramsObject.APP_ID !== RdsConstants.APP_ID.RDS){
                result = RdsConstants.Result.appIdNotRds;
            }
            else if(paramsObject.TYPE !== RdsConstants.DocumentType.BT && paramsObject.TYPE !== RdsConstants.DocumentType.MR && paramsObject.TYPE !== RdsConstants.DocumentType.DI){
                result = RdsConstants.Result.notBtDocument;
            }
            return result;
        }


        }
})();

(function(){
    'use strict';

    angular
        .module('phenix')
        .constant('RdsConstants', {
            rdsCookieName: 'NewDialogys-Rds',
            domain: 'renault.com',
            path: '/',
            Result:{
                emptyParameters: -1,
                mandatoryFiledsNotExist: -2,
                appIdNotRds: -3,
                notBtDocument: -4,
                rdsBT: 13
            },
            APP_ID:{
                RDS: 'RDS'
            },
            DocumentType:{
                BT: 'BT',
                MR: 'MR',
                DI: 'DI'
            },
            Parameters:{
                APP_ID: 'APP_ID',
                TYPE: 'TYPE',
                docId: 'docId',
                VIN: 'VIN',
                VDH_DF_ID: 'VDH_DF_ID',
                USER_TYPE: 'USER_TYPE'
            },
            rds: 'rds'
        })
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .controller('picturesGalleryFSController', picturesGalleryFSController);

    /** @ngInject */
    function picturesGalleryFSController($mdDialog) {
        var vm = this;
        vm.currentPicture = vm.images[vm.currentIndex];

        vm.showBig = function (index) {
            vm.currentIndex = index;
            vm.currentPicture = vm.images[vm.currentIndex];
        };

        vm.closePopin = function () {
            $mdDialog.hide();
        };

        vm.showNext = function () {
            vm.currentIndex = vm.images[vm.currentIndex + 1] ? vm.currentIndex + 1 : 0;
            vm.currentPicture = vm.images[vm.currentIndex];
        };

        vm.showPrevious = function () {
            vm.currentIndex = vm.images[vm.currentIndex - 1] ? vm.currentIndex - 1 : vm.images.length - 1;
            vm.currentPicture = vm.images[vm.currentIndex];
        };
    }

})();

(function(){
  'use strict';

  // https://github.com/thatisuday/ng-image-gallery
  // https://rawgit.com/thatisuday/ng-image-gallery/master/demo/main.html

  // Key codes
  var keys = {
    enter : 13,
    esc   : 27,
    left  : 37,
    right : 39
  };

  angular
    .module('phenix.core')
    .directive('picturesGallery', function(configConstantes, $mdDialog){
      return {
        replace : true,
        transclude : false,
        restrict : 'AE',
        scope : {
          images 			: 	'=',		// []
          imgAnim 		: 	'@?',		// {name}
          currentIndex:   '=',
          onOpen 			: 	'&?',		// function
          onClose 		: 	'&?'		// function
        },
        templateUrl: 'app/core/picturesGallery/picturesGallery.html',

        link : function(scope){
          scope.currentIndex = scope.currentIndex || 0;
          scope.backUrl = configConstantes.baseUrlBack;

          scope.currentPicture = scope.images[scope.currentIndex];

          scope.$watch("images",function() {
            if(scope.images[0].includes("image3d") && scope.images.length == 1){
              scope.currentPicture = scope.images[0];
            } else if(scope.images[0].includes("image3d") && scope.images.length > 1){
              scope.currentIndex++;
            }
          });
          scope.showBig = function (index) {
            scope.currentIndex = index;
            scope.currentPicture = scope.images[scope.currentIndex];
          };

          scope.showNext = function () {
            scope.currentIndex = scope.images[scope.currentIndex + 1]? scope.currentIndex + 1 : 0;
            scope.currentPicture = scope.images[scope.currentIndex];
          };

          scope.showPrevious = function () {
            scope.currentIndex = scope.images[scope.currentIndex - 1]? scope.currentIndex - 1 : scope.images.length - 1;
            scope.currentPicture = scope.images[scope.currentIndex];
          };

          scope.openFullScreen = function () {
            if(scope.images[scope.currentIndex].includes("image3d")){
              $mdDialog.show({
                template: '<three-d-viewer></three-d-viewer>',
                clickOutsideToClose: true,
                parent: angular.element(document.body)
            })
            } else {    
              var imageListFS = [];
              angular.copy(scope.images,imageListFS)
              if(scope.images[0].includes("image3d")){
                imageListFS.shift();
                scope.currentIndex--;
              }
              $mdDialog.show({
                  controller : 'picturesGalleryFSController',
                  templateUrl : 'app/core/picturesGallery/picturesGalleryFullScreen.html',
                  bindToController: true,
                  controllerAs: 'vm',
                  clickOutsideToClose: true,
                  parent: angular.element(document.body),
                  locals : {
                      images: imageListFS,
                      currentIndex: scope.currentIndex
                  }
              })              
            }
          };
        }


      }
    });
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('PartListModalCtrl', PartListModalCtrl);

  /** @ngInject */
  function PartListModalCtrl($rootScope, toastr, $modalInstance, modalOpts, CacheConstants, CacheService, $state,
                            PartListClientService, PartListMetierService, $q, $translate) {
    var vm = this;

    function init() {
      vm.accept = accept;
      vm.decline = declineGeneric;

      vm.translationData = {
        orderNumber: modalOpts.vehicleContext.ordersAndSplits.orderNumber
      };
    }




    // Dismiss a modal, passing a reason
    function acceptGeneric(data) {
      $modalInstance.close(data);
    }


    // Dismiss a modal, passing a reason
    function declineGeneric(data) {
      if(modalOpts.declineAction) {
        modalOpts.declineAction(data)
      }
      $modalInstance.close(null);
    }


    function accept() {
      var request = buildRequest();
      PartListMetierService.getQuotePart(request).then(function(response) {
        if(!response.returnCode) {
          acceptGeneric(response.response.references);
        } else if(response.returnCode == 2) {
          $translate('QUOTEPARTS_ERROR_PR_MISSING').then(function(text) {
            declineGeneric(text);
          });
        } else if(response.returnCode == 3) {
          $translate('QUOTEPARTS_ERROR_DMS_ID').then(function(text) {
            declineGeneric(text);
          });
        }else {
          declineGeneric('unknow problem pieces in waiting');
        }
      });
    }

    function buildRequest() {
      var dmsQuotePart = {};
      
      var profil = CacheService.getObject(CacheConstants.profil);
      if (profil) {
        dmsQuotePart.ipn = profil.userId;
        dmsQuotePart.dealerId = profil.dealerId;
        dmsQuotePart.orderNumber = modalOpts.vehicleContext.ordersAndSplits.orderNumber;
        dmsQuotePart.clientPartListId = modalOpts.vehicleContext.ordersAndSplits.clientPartListId;
        if (profil.dmsConfig) {
          dmsQuotePart.userDms = profil.dmsConfig.userDms;
          dmsQuotePart.workshopPartshopId = profil.dmsConfig.workshopPartshopId;
        }
      }
      return dmsQuotePart;
    }
    



    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('paginationDirective', paginationDirective);

  /* @ngInject */
  function paginationDirective() {
    var directive = {
      bindToController: true,
      controller: PaginationController,
      controllerAs: 'vm',
      templateUrl: 'app/core/pagination/pagination.html',
      restrict: 'EA',
      scope: {
        paginationGetData: '&?', // by WS call
        paginationData: '=', // full list object
        paginationSize: '=', // if paginationData, define number of element by page
        paginationMaxPage: '=?',
        paginationPage: '=?',
        paginationFilter: '=?',
        paginationFilterSizeCopy: '=?',
        paginationScrollId: '@?',
        paginationMode: '@' // mode : 'select' or 'text'
      }
    };
    return directive;
  }

  /* @ngInject */
  function PaginationController($scope) {
    var vm = this;

    ////////////
    vm.tempArray = [];
    vm.firstPage = 1;

    ////////////
    vm.paginateClick = paginateClick;
    vm.paginateRange = paginateRange;

    ////////////
    if (!vm.paginationPage)
      vm.paginationPage = 1;

    /**
     * @desc On click paginate +1 || -1 to get the data from controller
     * vm.paginationGetData() : action in controller of the view where the directive is include
     * The action call the WS with in param the number of the page
     * @param page
     */
    function paginateClick(page) {
      if (angular.isDefined(vm.paginationGetData)) {
        vm.paginationGetData({page: page});
      } else {
        vm.paginationData = vm.tempArray[page - 1];
      }
      vm.paginationPage = page;

      if(vm.paginationScrollId)
        scrollTop();
    }

    /**
     * @desc set a paginate range for the select box
     * @param start
     * @param end
     * @returns {Array}
     */
    function paginateRange(start, end) {
      var result = [];
      for (var i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    }

    /**
     * @desc Split array into chunks of vm.paginationSize
     */
    function splitData() {
      var sizeArray = vm.paginationSize ? vm.paginationSize : 10;
      vm.tempArray = _.chunk(vm.paginationData, sizeArray);
      vm.paginationMaxPage = vm.tempArray.length;
      vm.paginationData = vm.tempArray[vm.paginationPage - 1];
    }

    // only when you pass the full list of object
    if (vm.paginationData && vm.paginationData.length) {
      var totalSizeArray = vm.paginationData.length;
      splitData();
      //TODO Split again when a list is modified
      if (vm.paginationFilter) {
        $scope.$watch('vm.paginationData', function (newValue) {
          if (newValue.length > totalSizeArray) {
            totalSizeArray = vm.paginationData.length;
          }
          if (newValue.length === totalSizeArray && totalSizeArray > vm.paginationSize) {
            splitData();
          }
        }, true);

        if (vm.paginationFilterSizeCopy) {
          $scope.$watch('vm.paginationFilterSizeCopy', function (newValue) {
            if (newValue != totalSizeArray) {
              totalSizeArray = newValue;
              vm.paginationPage = 1;
              splitData();
            }
          }, true);
        }
      }
    }

    function scrollTop(){
      $('html, body').animate({scrollTop: $('#' + vm.paginationScrollId).offset().top - 50}, 100);
    }

  }

  /**
   * @example WS pagination
   *   <pagination-directive  ng-if='vm.totalPage'
   *                          pagination-get-data="vm.getData(page)"
   *                          pagination-max-page="vm.totalPage" // total from WS
   *                          pagination-page="vm.numberPage" // number from WS
   *                          pagination-mode="select">
   *   </pagination-directive>
   */

  /**
   * @example Full list pagination
   *   <pagination-directive  ng-if="vm.data"
   *                          pagination-data="vm.data"
   *                          pagination-size="vm.pageSize"
   *                          pagination-filter="true"
   *                          pagination-mode="select">
   *   </pagination-directive>
   */

})();


(function(){
    "use strict";

    angular
        .module('phenix.core')
        .component('paginationList', {
            controller: paginateListController,
            templateUrl: 'app/core/paginateList/paginateList.template.html',
            bindings:{
                count: '<',
                updatePagination: '<',
                currentPage: '='
            },
            controllerAs: 'vm'
        });

    /**
     * @param {Integer} count - the total elemnts
     * @param {Event} updatePagination
     */

    /* @ngInject */
    function paginateListController(PartRequisitionConstants, $rootScope){
         /*=============================================
        =               VARIABLES                     =
        =============================================*/

        var vm = this;
        vm.nbPages = 0;
        vm.actualPage = 1;
        vm.list = [];

        vm.previous = previous
        vm.next = next;
        vm.onUpdate = onUpdate;

        /*=============================================
        =               FUNCTIONS                     =
        =============================================*/
        this.$onInit = function() {
            vm.actualPage = vm.currentPage ? vm.currentPage : 1;
            initPagination(vm.actualPage);
        }

        this.$onChanges = function() {
            initPagination(vm.actualPage);
        }

        $rootScope.$on('resetPagination', function(){
               vm.actualPage = 1;
        })


        /**
         * @name previous
         * @desc this action is fired when user click on previous button
         * @desc spread this event to partRequisition controller
         */
        function previous() {
            vm.actualPage -= 1;
            onUpdate();
        }

         /**
         * @name next
         * @desc this action is fired when user click on next button
         * @desc spread this event to partRequisition controller
         */
        function next() {
            vm.actualPage += 1;
            onUpdate();
        }

         /**
         * @name onUpdate
         * @desc this action is fired when user enter a page number
         * @desc spread this event to partRequisition controller
         */
        function onUpdate() {
            if(!vm.actualPage){
                vm.actualPage = 1;
            }
            vm.updatePagination(vm.actualPage);
        }

        /*=============================================
        =               TOOLS                         =
        =============================================*/

        /**
         * @name initPagination
         * @desc init paginaation bloc
         */
        function initPagination(page) {
            var list = [];
            var limit = PartRequisitionConstants.pagination.limit;


            vm.actualPage = page;
            vm.nbPages = Math.ceil(vm.count / limit);
            for (var i = 1; i <= vm.nbPages; i++) {
                list.push(i);
            }
            vm.list = list;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .directive('numbersOnly', numbersOnly);

    /** @ngInject */
    function numbersOnly() {

        var directive = {
            require: 'ngModel',
            link: function (scope, element) {
                element.on('keydown', function (event) {
                    var authorizedKeys = [
                    '0','1', '2', '3', '4', '5','6', '7', '8', '9',
                    /** CHROME / FIREFOXE */
                    'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete',
                    /** IE */
                    'Left', 'Right','Del'
                    ];


                    if (authorizedKeys.indexOf(event.key) >= 0) {
                        return true
                    } else {
                        event.preventDefault();
                        return false;
                    }
                });
            }
        };

        return directive;


    }

})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('NavBarController', NavBarController);

  /** @ngInject */
  function NavBarController() {
    var vm = this;


    function init() {
      vm.listOfAtelier = [{id: 1, label: 'ATL meca 1'}, {id: 2, label: 'ATL meca 2'}, {id: 3, label: 'ATL meca 3'}];
    }

    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('multipleSelectsDirective', multipleSelectsDirective);

  /* @ngInject */
  function multipleSelectsDirective($translate) {

    function MultipleSelectsLink(scope, element, attrs) {

      var widthSelect = null;

      scope.itemSelected = function (itemClicked) {
        var index = _.findIndex(scope.selectedItems, function(item) {
          return itemClicked.id == item.id
        });
        if(index !== -1) {
          scope.selectedItems.splice(index, 1);
        } else {
          scope.selectedItems.push(itemClicked);
        }
      };

      $translate(scope.defaultText).then(function (text) {
        scope.defaultText = text;
      });

      scope.$watch(function () {
        return scope.lists
      }, function (lists) {
        displayCheckedRows();
      }, true);


      ////////////


      ////////////
      function displayCheckedRows() {
        if(scope.lists) {
          scope.selectedItems = [];
          for (var l = 0; l < scope.lists.length; l++) {
            for (var sl = 0; sl < scope.lists[l].data.length; sl++) {
              if(scope.lists[l].data[sl].checked) {
                scope.selectedItems.push(scope.lists[l].data[sl]);
              }
            }
          }
        }
      }

      function init() {
        displayCheckedRows();
      }


      /**
       * Call on click on select div
       */
      scope.displaySelectBox = function () {
        setStyle();
        scope.showMultipleCheckbox = !scope.showMultipleCheckbox;
      };


      /**
       * Calcul width of select div, once time
       * Can not be placed in init() because not work in popin
       */
      function setStyle() {
        if(!widthSelect) {
          widthSelect = element[0].getBoundingClientRect().width;
          element[0].querySelector('.mutliSelect').style.width = widthSelect + "px";
        }
      }

      init();

    }


    return {
      templateUrl: 'app/components/transverse/multipleSelects/multipleSelects.html',
      restrict: 'E',
      scope: {
        lists: '=', // array of values array
        selectedItems: '=', // array of values array
        defaultText: '@'
      },
      link: MultipleSelectsLink //FI: use controller if need to expose an API, else use link
    };
  }


  /**
   * @example WS pagination
   *   <multiple-selects-directive
   *          lists="vm.lists"                                  //array of { title: '', data[] }
   *          default-text="ADMIN_MODAL_CHOOSE_INT_EXT_STOCK">  //text if no item are selected
   *   </multiple-selects-directive>
   */

})();


(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalOrderTypeCtrl', ModalOrderTypeCtrl);

  /** @ngInject */
  function ModalOrderTypeCtrl($modalInstance, modalOpts) {
    var vm = this;

    vm.ordersType = [
        {id: 0, label: "PVI"},
        {id: 1, label: "Urgence 1"},
        {id: 2, label: "Urgence 2"},
        {id: 3, label: "Vente manquée"}
      ];

    function init() {
      vm.validate = okGeneric;
      vm.ordersTypeSelected = vm.ordersType[0].id;
      vm.cancel = cancel;
    }

    // Close a modal, passing a result
    function okGeneric() {
      modalOpts.okAction(vm.ordersTypeSelected);
      $modalInstance.close('ok');
    }
    //Close modal, reject promise
    function cancel() {
      $modalInstance.dismiss('cancel');
    }

    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalSplitDefaultCtrl', ModalSplitDefaultCtrl);

  /** @ngInject */
  function ModalSplitDefaultCtrl($modalInstance, modalOpts) {
    var vm = this;

    function init() {
      vm.validate = okGeneric;
      vm.cancel = cancel;
      vm.orderAndSplits = modalOpts.orderAndSplits;
      vm.titleModal = modalOpts.titleModal;
      vm.defaultSplit = vm.orderAndSplits.defaultSplitId ? vm.orderAndSplits.defaultSplitId : vm.orderAndSplits.splits[0].id;
    }

    // Close a modal, passing a result
    function okGeneric() {
      if(modalOpts.okAction) {
        modalOpts.okAction(vm.defaultSplit);
      }
      $modalInstance.close(vm.defaultSplit);
    }
    //Close modal, reject promise
    function cancel() {
      $modalInstance.dismiss('cancel');
    }

    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalSelectOrCtrl', ModalSelectOrCtrl);

  /** @ngInject */
  function ModalSelectOrCtrl($modalInstance, modalOpts, PartListMetierService, CacheService, CacheConstants, toastr) {
    var vm = this;


    function init() {
      vm.validate = onValidate;
      vm.cancel = cancel;
      vm.ordersAndSplits = modalOpts.ordersAndSplits;
      vm.orderNumber = modalOpts.ordersAndSplits.orderNumbers[0];
    }


    function onValidate() {
      var contextCar = CacheService.getObject(CacheConstants.contextCarSearch);
      PartListMetierService.getDetailOrder(vm.orderNumber).then(function(orderResponse){
        if(orderResponse.response && orderResponse.response.vehicle.vin == contextCar.vehicle.vin) {
          $modalInstance.close(orderResponse.response);
        } else if(!orderResponse.response) {
          toastr.error("Cette OR est inconnu. Veuillez en sélectionner un autre");
        } else {
          toastr.error("Ce bon de service est associé à un autre véhicule. Veuillez sélectionner un OR différent");
        }
      })
    }

    //Close modal, reject promise
    function cancel() {
      $modalInstance.dismiss('cancel');
    }


    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .service('PaymentModalMetierService', PaymentModalMetierService);

  /** @ngInject */
  function PaymentModalMetierService($modal) {
    var refsPayment = [];
    var pieceSaved;
    this.openModalPayment = openModalPayment;
    // this.findPaymentRefs = findPaymentRefs;

    function openModalPayment(actionPayment, listPiece, piece, parentPiece, pieceSelected, piecePayment, pieceSaved) {
      if (getLocaleOlderReplacement(listPiece, piece, piecePayment, pieceSaved) && !pieceSaved) {
        findPaymentRefs(listPiece, piece, parentPiece, pieceSelected, piecePayment, pieceSaved);
        pieceSaved = piece;
        var modalInstance = $modal.open({
          templateUrl: 'app/components/transverse/modalPayment/modalPayment.html',
          controller: 'ModalPaymentCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          windowClass: 'modalPaymentRef',
          resolve: {
            modalOpts: function () {
              return {
                refsPayment: refsPayment,
                actionPayment: actionPayment
              };
            }
          }
        });

        modalInstance.result.then(function () {
          if(piece.payment){
            delete pieceSaved.payment;
            piece.payment = angular.copy(piece);
            piece.saved = false;
          }
        });

      } else {
        if(piece && piece.payment){
          actionPayment(piece.payment);
        }else{
          actionPayment(piece);
        }
      }
    }

    function findPaymentRefs(listPiece, piece, parentPiece, pieceSelected, piecePayment, pieceSaved) {

      refsPayment = {
        'principal': piece,
        'locale': getLocaleReplacement(piece, piecePayment),
        'locale_older': getLocaleOlderReplacement(listPiece, piece, piecePayment, pieceSaved)
      };

      if(pieceSelected){
        refsPayment.selected = pieceSelected;
      }
      // if ref local

      // ref direct
      // find ref local direct
      // find locale amont

      // traitement si ref repetée
      deleteDuplicateReplacement(refsPayment);
      return refsPayment;
    }

    function getLocaleReplacement(piece, piecePayment) {
      var pieceLocale = piecePayment ? piecePayment : piece;
      if(pieceLocale && pieceLocale.supersedingPart && (!pieceLocale.stock || (pieceLocale.stock && pieceLocale.stock.quantity === 0))) {
          addAdditionalToPiece(pieceLocale);
          return pieceLocale.supersedingPart;
      }

      if(pieceLocale && pieceLocale.stock && pieceLocale.stock.quantity > 0) {
        if (pieceLocale.supersedingPart && pieceLocale.supersedingPart.stock && pieceLocale.supersedingPart.stock.quantity > 0) {
          addAdditionalToPiece(pieceLocale);
          return pieceLocale.supersedingPart;
        }
      }
    }

    function getLocaleOlderReplacement(listPiece, piece, piecePayment, pieceSaved) {
      var pieceOlder = piecePayment ? piecePayment : piece;
      if(listPiece && !pieceSaved) {
        for (var i = 0; i < listPiece.length; i++) {
          if (pieceOlder && (!pieceOlder.stock || (pieceOlder.stock && pieceOlder.stock.quantity === 0))) {
            if (listPiece[i] && listPiece[i].supersedingPart) {
              addAdditionalToPiece(pieceOlder, listPiece[i]);
              return listPiece[i].supersedingPart;
            }
          } else {
            if (listPiece[i] && listPiece[i].supersedingPart && listPiece[i].supersedingPart.stock.quantity > 0) {
              addAdditionalToPiece(pieceOlder, listPiece[i]);
              return listPiece[i].supersedingPart;
            }
          }
        }
      }
    }

    function addAdditionalToPiece(piece, listPiece){
      if(piece) {
        if (piece.additional && piece.supersedingPart) {
          piece.supersedingPart.additional = angular.copy(piece.additional);
        }

        if (listPiece) {
          if (piece.additional && listPiece.supersedingPart) {
            listPiece.supersedingPart.additional = angular.copy(piece.additional);
          }
        }
      }
    }

    function deleteDuplicateReplacement(refs) {
      if (refs['locale'] && refs['locale_older']) {
        if (refs['locale'].reference === refs['locale_older'].reference) {
          delete refs['locale_older'];
        }
      }
      if (refs['principal'] && refs['locale']) {
        if (refs['principal'].reference === refs['locale'].reference) {
          delete refs['locale'];
        }
      }
      if (refs['principal'] && refs['locale_older']) {
        if (refs['principal'].reference === refs['locale_older'].reference) {
          delete refs['locale'];
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalPaymentCtrl', ModalPaymentCtrl);

  /** @ngInject */
  function ModalPaymentCtrl(modalOpts, $modalInstance) {
    var vm = this;
    var localSaved;
    var refSaved;
    var additionalLength;

    //////////////

    vm.references = modalOpts.refsPayment;
    vm.validateModal = validateModal;
    vm.closeModal = closeModal;

    function closeModal() {
      $modalInstance.dismiss(null);
    }

    function actionPaymentModal(ref, local) {
      //ref.payment = {};
      if (ref.payment) {
        modalOpts.actionPayment(ref.payment);
      } else {
        modalOpts.actionPayment(local.payment);
      }
      //local.payment = ref;
      $modalInstance.close();
    }

    var preventClick = false;

    function validateModal(ref, local) {
      if (!preventClick) {
        preventClick = true;

        if (!localSaved && !refSaved) { // save replacement local
          refSaved = ref;
          localSaved = local;
          if (!refSaved.payment) {
            localSaved.payment = ref;
          }
        } else {
          if (refSaved.additional.length) {
            for (var i = 0; i < refSaved.additional.length; i++) {
              if (refSaved.additional[i].reference === local.reference) {
                if (refSaved.payment) {
                  _.extend(refSaved.payment.additional[i], ref); //merge two object additional
                } else {
                  _.extend(localSaved.payment.additional[i], ref);
                }
              }
            }
          }
        }
        preventClick = false;

        if (refSaved && refSaved.additional && refSaved.additional.length) {
          if (!additionalLength && additionalLength != 0) {
            additionalLength = 0;
          }

          if (refSaved.additional[additionalLength] && refSaved.additional[additionalLength].supersedingPart && additionalLength >= 0) {
            vm.references = {};
            vm.references = {
              principal: refSaved.additional[additionalLength],
              locale: refSaved.additional[additionalLength].supersedingPart
            };
            additionalLength = additionalLength + 1;
          } else {
            additionalLength = additionalLength + 1;
            if (additionalLength >= refSaved.additional.length) {
              preventClick = true;
              //action payment
              actionPaymentModal(refSaved, localSaved);
            } else {
              validateModal(refSaved, localSaved);
            }
          }
        } else {
          actionPaymentModal(refSaved, localSaved);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalPartlistCtrl', ModalPartlistCtrl);

  /** @ngInject */
  function ModalPartlistCtrl(RoutesConstants, toastr, $modalInstance, modalOpts, CacheConstants, CacheService, PartListMetierService, $translate, UtilsMetierService) {
    var vm = this;

    var canCrateNewPL = false;

    function init() {
      vm.cancel = cancelGeneric;
      vm.createPartlist = createPartlist;

      vm.initiateFirstStateShowing = initiateFirstStateShowing;
      vm.nextPartListSearch = nextPartListSearch;
      vm.prevPartListSearch = prevPartListSearch;
      vm.getPartList = getPartList;
      vm.showNextPrev = false;
      vm.maximumPageNext = 0;
      vm.currentPartListSearchPage = 1;
      vm.canShowingOr = canShowingOr();

      vm.partLists = modalOpts.partLists;

      var user = CacheService.getObject(RoutesConstants.profil);
      var contextCar = CacheService.getObject(CacheConstants.contextCarSearch);
      var isPartShop = UtilsMetierService.isPartShop(user);
      canCrateNewPL = (isPartShop || !isPartShop && contextCar.ordersAndSplits) ? true : false;

      PartListMetierService.getListPartListsValidatedOrDrafts([1]).then(function(listPartListsResponse) {
        if (listPartListsResponse.errorCode) { // if error
          toastr.error('Error BACK : ' + listPartListsResponse.errorCode.label, 'Error');
        } else { // if success
          vm.partLists = [];
          var partLists = listPartListsResponse.partLists;

          if(isPartShop){
            vm.partLists = partLists;
          }
          else{
            var contextCar = CacheService.getObject(CacheConstants.contextCarSearch);
            if(contextCar && contextCar.vehicle){
              for(var index in partLists){
                if(partLists[index].vehicles && partLists[index].vehicles.length > 0){
                  if(partLists[index].vehicles[0].vin === contextCar.vehicle.vin){
                    vm.partLists.push(partLists[index]);
                  }
                }
              }
            }
          }
          initiateFirstStateShowing(vm.partLists);
        }
      });
    }

    function prevPartListSearch(){
      var indexBegin = 7 * (vm.currentPartListSearchPage - 2);
      vm.partListsToShowing = [];
      for(var i = indexBegin; i < (indexBegin + 7) && i < vm.partListsFirstState.length; i++){
        vm.partListsToShowing.push(vm.partListsFirstState[i]);
      }
      vm.currentPartListSearchPage--;
    }

    function nextPartListSearch(){
      var indexBegin = 7 * vm.currentPartListSearchPage;
      vm.partListsToShowing = [];
      for(var i = indexBegin; i < (indexBegin + 7) && i < vm.partListsFirstState.length; i++){
        vm.partListsToShowing.push(vm.partListsFirstState[i]);
      }
      vm.currentPartListSearchPage++;
    }

    function initiateFirstStateShowing(partLists){
      vm.partListsFirstState = partLists;
      vm.partListsToShowing = [];

      for(var i = 0; i < 7 && i < vm.partListsFirstState.length; i++){
        vm.partListsToShowing.push(vm.partListsFirstState[i]);
      }
      if(vm.partListsFirstState.length > 7){
        vm.showNextPrev = true;
      }
      vm.maximumPageNext = Math.ceil(vm.partListsFirstState.length / 7);
    }

    function getPartList(idPartList){
      PartListMetierService.getPartList(idPartList).then(function (partListResponse) {
        if (partListResponse.errorCode) { // if error
          toastr.error('Error BACK : ' + partListResponse.errorCode.label, 'Error');
        } else { // if success
          CacheService.setObject(CacheConstants.partList, partListResponse);
          partListResponse.edited = false;
          okGeneric(partListResponse);
        }
      });
    }

    /**
     * Call when click on new partlist. Create it with WS and put it in local storage
     * @return {[type]} [description]
     */
    function createPartlist() {
      if(canCrateNewPL) {
        PartListMetierService.createPartList().then(function(partlistResponse) {
          if (partlistResponse.errorCode) { // if error
            toastr.error('Error BACK : ' + partlistResponse.errorCode.label, 'Error');
          } else { // if success
            CacheService.setObject(CacheConstants.partList, partlistResponse);
            partlistResponse.edited = false;
            okGeneric(partlistResponse);
          }
        });
      } else {
        $translate('TOASTER_PARTLIST_NO_OR').then(function(text) {
          $modalInstance.dismiss(text);
        });
      }
    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      if(modalOpts.cancelAction) {
        modalOpts.cancelAction();
      }
      $modalInstance.dismiss('cancel');
    }

    // Close a modal, passing a result
    function okGeneric(callBackValue) {
      if(modalOpts.okAction) {
        modalOpts.okAction(callBackValue);
      }
      $modalInstance.close(callBackValue);
    }

    function canShowingOr(){
      var user = CacheService.getObject(RoutesConstants.profil);
      var isPartShop = UtilsMetierService.isPartShop(user);
      if(isPartShop){
        return false;
      }
      else{
        return true;
      }
    }

    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ElectricalShemaCtrl', ElectricalShemaCtrl);

  /** @ngInject */
  function ElectricalShemaCtrl($modalInstance, modalOpts, $translate, toastr ,ConfigMetierService) {
    var vm = this;
    var config = ConfigMetierService.getSettings();
    vm.maxPerPage = 2;

    function prevElecShSearch(){
      var indexBegin = vm.maxPerPage * (vm.currentElecShSearchPage - 2);
      vm.ElecShToShowing = [];
      for(var i = indexBegin; i < (indexBegin + vm.maxPerPage) && i < vm.elecShFirstState.length; i++){
        vm.ElecShToShowing.push(vm.elecShFirstState[i]);
      }
      vm.currentElecShSearchPage--;
      scrollTop();
    }

    function nextElecShSearch(){
      var indexBegin = vm.maxPerPage * vm.currentElecShSearchPage;
      vm.ElecShToShowing = [];
      for(var i = indexBegin; i < (indexBegin + vm.maxPerPage) && i < vm.elecShFirstState.length; i++){
        vm.ElecShToShowing.push(vm.elecShFirstState[i]);
      }
      vm.currentElecShSearchPage++;
      scrollTop();
    }

    function initiateFirstStateShowing(shemas){
      vm.elecShFirstState = shemas;
      vm.ElecShToShowing = [];

      for(var i = 0; i < vm.maxPerPage && i < vm.elecShFirstState.length; i++){
        vm.ElecShToShowing.push(vm.elecShFirstState[i]);
      }
      if(vm.elecShFirstState.length > vm.maxPerPage){
        vm.showNextPrev = true;
      }
      vm.maximumPageNext = Math.ceil(vm.elecShFirstState.length / vm.maxPerPage);
    }

    function init() {
      vm.cancel = cancelGeneric;
      vm.initiateFirstStateShowing = initiateFirstStateShowing;
      vm.nextElecShSearch = nextElecShSearch;
      vm.prevElecShSearch = prevElecShSearch;
      vm.showNextPrev = false;
      vm.maximumPageNext = 0;
      vm.currentElecShSearchPage=1;
      vm.shemas=modalOpts.electrics;
      vm.getElectric = getElectric;
      initiateFirstStateShowing(vm.shemas);
    }

    function scrollTop(){
      $('html, body').animate({scrollTop: $('#modalElecShPhenix').offset().top - 42}, 100);
    }

    function getElectric(listShema) {
      if(!listShema.dateFin){
        $translate('DOC_TOASTR_ERROR_SERVER_NO_RESPONSE').then(function (text) {
          toastr.error(text);
        });
      }
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }

    init();

  }
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ConsultDocCtrl', ConsultDocCtrl);

  /** @ngInject */
  function ConsultDocCtrl($modalInstance, modalOpts, ConfigMetierService) {
    var vm = this;
    var config = ConfigMetierService.getSettings();
    vm.maxPerPage = config.history.maximumPerPage;

    function init() {
      vm.cancel = cancelGeneric;
      vm.showNextPrev = false;
      vm.maximumPageNext = 0;
      vm.currentDocSearchPage=1;
      vm.docs=modalOpts.docs;
      vm.getDoc = getDoc;
      vm.DocToShowing = vm.docs;
    }

    function getDoc(doc) {
      console.log(doc);
    }


    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      $modalInstance.dismiss('cancel');
    }

    init();

  }
})();

(function() {
    angular.module('phenix.core').service('warningModalCustomerService', function($mdDialog, $q) {
        this.displayModal = function() {
            var parentEl = angular.element(document.body);
            return $mdDialog.show({
                parentEl: parentEl,
                bindToController: true,
                controllerAs: 'vm',
                templateUrl: 'app/core/modalCustomer/warningModalCustomer.component.html',
                controller: 'warningModalCustomerController'
            }).catch(function() {
                return $q.reject(0);
            })
        }
    })
})();

(function() {
    angular.module('phenix.core').controller('warningModalCustomerController', function($mdDialog) {
        this.onCancel = function () {
            $mdDialog.cancel();
        }

        this.onConfirm = function() {
            $mdDialog.hide();
        }
    })
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ModalCtrl', ModalCtrl);

  /** @ngInject */
  function ModalCtrl($modalInstance, modalOpts) {
    var vm = this;

    function init() {

      vm.title = modalOpts.title;
      vm.description = modalOpts.description;
      vm.cancelButtonLabel = modalOpts.cancelButtonLabel;
      vm.okButtonLabel = modalOpts.okButtonLabel;
      vm.okButtonIcon = modalOpts.okButtonIcon;

      vm.cancel = cancelGeneric;
      vm.reposition = repositionGeneric;
      vm.ok = okGeneric;
    }

    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      modalOpts.cancelAction();
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }

    // Close a modal, passing a result
    function okGeneric() {
      modalOpts.okAction();
      $modalInstance.close('ok');
    }


    init();

  }
})();

(function() {
  'use strict';

  angular.module('phenix.core')
    .directive('onLongPress', [onLongPress])

  /** @ngInject */
  function onLongPress ($timeout) {
    return {
      restrict: 'A',
      link: function ($scope, $elm, $attrs) {
        $elm.bind('touchstart', function() {
          // Locally scoped variable that will keep track of the long press
          $scope.longPress = true;

          // We'll set a timeout for 600 ms for a long press
          $timeout(function() {
            if ($scope.longPress) {
              // If the touchend event hasn't fired,
              // apply the function given in on the element's on-long-press attribute
              $scope.$apply(function() {
                $scope.$eval($attrs.onLongPress)
              });
            }
          }, 600);
        });

        $elm.bind('touchend', function() {
          // Prevent the onLongPress event from firing
          $scope.longPress = false;
          // If there is an on-touch-end function attached to this element, apply it
          if ($attrs.onTouchEnd) {
            $scope.$apply(function() {
              $scope.$eval($attrs.onTouchEnd)
            });
          }
        });
      }
    };
  }



})();

/* global angular */
angular.module('phenix.core')
    .service('phxSrcSetService', ['$window', '$timeout', function($window, $timeout) {
        'use strict';

        /**
         * For other applications wanting the srccset/best image approach it is possible to use this module only
         * Loosely based on https://raw.github.com/borismus/srcset-polyfill/master/js/srcset-info.js
         */
        var INT_REGEXP = /^[0-9]+$/;

        // SRCSET IMG OBJECT
        function ImageInfo(options) {
            this.src = options.src;
            this.w = options.w || Infinity;
            this.h = options.h || Infinity;
            this.x = options.x || 1;
        }

        /**
         * Parse srcset rules
         * @param  {string} descString Containing all srcset rules
         * @return {object}            Srcset rules
         */
        var _parseDescriptors = function (descString) {

            var descriptors = descString.split(/\s/);
            var out = {};

            for (var i = 0, l = descriptors.length; i < l; i++) {

                var desc = descriptors[i];

                if (desc.length > 0) {

                    var lastChar = desc.slice(-1);
                    var value = desc.substring(0, desc.length - 1);
                    var intVal = parseInt(value, 10);
                    var floatVal = parseFloat(value);

                    if (value.match(INT_REGEXP) && lastChar === 'w') {
                        out[lastChar] = intVal;
                    } else if (value.match(INT_REGEXP) && lastChar === 'h') {
                        out[lastChar] = intVal;
                    } else if (!isNaN(floatVal) && lastChar === 'x') {
                        out[lastChar] = floatVal;
                    }

                }
            }

            return out;

        };

        /**
         * Returns best candidate under given circumstances
         * @param  {object} images     Candidate image
         * @param  {function} criteriaFn Rule
         * @return {object}            Returns best candidate under given criteria
         */
        var _getBestCandidateIf = function (images, criteriaFn) {

            var bestCandidate = images[0];

            for (var i = 0, l = images.length; i < l; i++) {
                var candidate = images[i];
                if (criteriaFn(candidate, bestCandidate)) {
                    bestCandidate = candidate;
                }
            }

            return bestCandidate;

        };

        /**
         * Remove candidate under given circumstances
         * @param  {object} images     Candidate image
         * @param  {function} criteriaFn Rule
         * @return {object}            Removes images from global image collection (candidates)
         */
        var _removeCandidatesIf = function (images, criteriaFn) {

            for (var i = images.length - 1; i >= 0; i--) {
                var candidate = images[i];
                if (criteriaFn(candidate)) {
                    images.splice(i, 1); // remove it
                }
            }

            return images;

        };

        /**
        * Direct implementation of "processing the image candidates":
        * http://www.whatwg.org/specs/web-apps/current-work/multipage/embedded-content-1.html#processing-the-image-candidates
        *
        * @param  {array} imageCandidates (required)
        * @param  {object} view (optional)
        * @returns {ImageInfo} The best image of the possible candidates.
        */
        var getBestImage = function (imageCandidates, view) {

            if (!imageCandidates) { return; }
            if (!view) {
                view = {
                    'w' : $window.innerWidth || document.documentElement.clientWidth,
                    'h' : $window.innerHeight || document.documentElement.clientHeight,
                    'x' : $window.devicePixelRatio || 1
                };
            }

            var images = imageCandidates.slice(0);

            /* LARGEST */
            // Width
            var largestWidth = _getBestCandidateIf(images, function (a, b) { return a.w > b.w; });
            // Less than client width.
            _removeCandidatesIf(images, function (a) { return a.w < view.w; });
            // If none are left, keep the one with largest width.
            if (images.length === 0) { images = [largestWidth]; }


            // Height
            var largestHeight = _getBestCandidateIf(images, function (a, b) { return a.h > b.h; });
            // Less than client height.
            _removeCandidatesIf(images, function (a) { return a.h < view.h; });
            // If none are left, keep one with largest height.
            if (images.length === 0) { images = [largestHeight]; }

            // Pixel density.
            var largestPxDensity = _getBestCandidateIf(images, function (a, b) { return a.x > b.x; });
            // Remove all candidates with pxdensity less than client pxdensity.
            _removeCandidatesIf(images, function (a) { return a.x < view.x; });
            // If none are left, keep one with largest pixel density.
            if (images.length === 0) { images = [largestPxDensity]; }


            /* SMALLEST */
            // Width
            var smallestWidth = _getBestCandidateIf(images, function (a, b) { return a.w < b.w; });
            // Remove all candidates with width greater than it.
            _removeCandidatesIf(images, function (a) { return a.w > smallestWidth.w; });

            // Height
            var smallestHeight = _getBestCandidateIf(images, function (a, b) { return a.h < b.h; });
            // Remove all candidates with height greater than it.
            _removeCandidatesIf(images, function (a) { return a.h > smallestHeight.h; });

            // Pixel density
            var smallestPxDensity = _getBestCandidateIf(images, function (a, b) { return a.x < b.x; });
            // Remove all candidates with pixel density less than smallest px density.
            _removeCandidatesIf(images, function (a) { return a.x > smallestPxDensity.x; });

            return images[0];

        };



        // options {src: null/string, srcset: string}
        // options.src    normal url or null
        // options.srcset 997-s.jpg 480w, 997-m.jpg 768w, 997-xl.jpg 1x
        var getSrcset = function (options) {

            var imageCandidates = [];

            var srcValue = options.src;
            var srcsetValue = options.srcset;

            if (!srcsetValue) { return; }

            /* PUSH CANDIDATE [{src: _, x: _, w: _, h:_}, ...] */
            var _addCandidate = function (img) {

                for (var j = 0, ln = imageCandidates.length; j < ln; j++) {
                    var existingCandidate = imageCandidates[j];

                    // DUPLICATE
                    if (existingCandidate.x === img.x &&
                        existingCandidate.w === img.w &&
                        existingCandidate.h === img.h) { return; }
                }

                imageCandidates.push(img);

            };


            var _parse = function () {

                var input = srcsetValue,
                position = 0,
                rawCandidates = [],
                url,
                descriptors;

                while (input !== '') {

                    while (input.charAt(0) === ' ') {
                        input = input.slice(1);
                    }

                    position = input.indexOf(' ');

                    if (position !== -1) {

                        url = input.slice(0, position);

                        // if (url === '') { break; }

                        input = input.slice(position + 1);

                        position = input.indexOf(',');

                        if (position === -1) {
                            descriptors = input;
                            input = '';
                        } else {
                            descriptors =  input.slice(0, position);
                            input = input.slice(position + 1);
                        }

                        rawCandidates.push({
                            url: url,
                            descriptors: descriptors
                        });

                    } else {

                        rawCandidates.push({
                            url: input,
                            descriptors: ''
                        });
                        input = '';
                    }

                }

                // FROM RAW CANDIDATES PUSH IMAGES TO COMPLETE SET
                for (var i = 0, l = rawCandidates.length; i < l; i++) {

                    var candidate = rawCandidates[i],
                    desc = _parseDescriptors(candidate.descriptors);

                    _addCandidate(new ImageInfo({
                        src: candidate.url,
                        x: desc.x,
                        w: desc.w,
                        h: desc.h
                    }));

                }

                if (srcValue) {
                    _addCandidate(new ImageInfo({src: srcValue}));
                }

            };

            _parse();


            // Return best available image for current view based on our list of candidates
            var bestImage = getBestImage(imageCandidates);

            /**
             * Object returning best match at moment, and total collection of candidates (so 'image' API can be used by consumer)
             * @type {Object}
             */
            var object = {
                'best': bestImage,              // IMAGE INFORMATION WHICH FITS BEST WHEN API IS REQUESTED
                'candidates': imageCandidates   // ALL IMAGE CANDIDATES BY GIVEN SRCSET ATTRIBUTES
            };

            // empty collection
            imageCandidates = null;

            // pass best match and candidates
            return object;

        };

        // debouncer function to be used in directive
        function debounce(call, delay) {
          var preventCalls = false;

          return function() {
            if (!preventCalls) {
              call();

              preventCalls = true;

              $timeout(function() {
                preventCalls = false;
              }, delay);
            }
          };
        }


        /**
         * PUBLIC API
         */
        return {
            get: getSrcset,        // RETURNS BEST IMAGE AND IMAGE CANDIDATES
            image: getBestImage,   // RETURNS BEST IMAGE WITH GIVEN CANDIDATES
            debounce: debounce     // RETURNS A DEBOUNCER FUNCTION
        };


}]);
// /* global angular */
// angular.module('phenix.core')
//   .directive('phxImageContainer', function () {
//     'use strict';

//     return {
//       restrict: 'A',
//       // We have to use controller instead of link here so that it will always run earlier than nested phxLazyImage directives
//       controller: ['$scope', '$element', function ($scope, $element) {
//         $element.data('phxImageContainer', $element);
//       }]
//     };
//   })
//   .directive('phxLazyImage', ['configConstantes', '$rootScope', '$window', '$timeout', 'phxSrcSetService', '$parse', function (configConstantes, $rootScope, $window, $timeout, srcSetService, $parse) {
//     'use strict';

//     // Use srcSetService to find out our best available image
//     var bestImage = function (images) {
//       var image = srcSetService.get({srcset: images});
//       var sourceUrl;
//       if (image) {
//         sourceUrl = image.best.src;
//       }
//       return sourceUrl;
//     };

//     return {
//       restrict: 'A',
//       transclude: true,
//       link: function (scope, element, attrs) {
//         var _concatImgAttrs = function (imgAttrs) {
//           var result = [];
//           if (options.imgAttrs) {
//             result = Array.prototype.map.call(imgAttrs, function (item) {
//               for (var key in item) {
//                 if (item.hasOwnProperty(key)) {
//                   return String.prototype.concat.call(key, '="', item[key], '"');
//                 }
//               }
//             });
//           }
//           return result.join(' ');
//         };

//         // CONFIGURATION VARS
//         var $container = element.inheritedData('phxImageContainer');
//         if (!$container) {
//           $container = angular.element(attrs.phxLazyImageContainer || $window);
//         }

//         var loaded = false;
//         var timeout;

//         var images = attrs.phxLazyImage; // srcset attributes
//         var options = attrs.phxLazyImageOptions ? $parse(attrs.phxLazyImageOptions)(scope) : {}; // options (background, offset)


//         var img = null; // Angular element to image which will be placed
//         var currentImage = null; // current image url
//         var offset = options.offset ? options.offset : 50; // default offset
//         var imgAttrs = _concatImgAttrs(options.imgAttrs); // all image attributes like class, title, onerror
//         $rootScope.imgAttrs = imgAttrs;
//         var LOADING = 'phx-lazy-image-loading';


//         attrs.phxLazyImageLoaded = false;

//         var _containerScrollTop = function () {
//           // See if we can use jQuery, with extra check
//           // TODO: check if number is returned
//           if ($container.scrollTop) {
//             var scrollTopPosition = $container.scrollTop();
//             if (scrollTopPosition) {
//               return scrollTopPosition;
//             }
//           }

//           var c = $container[0];
//           if (c.pageYOffset !== undefined) {
//             return c.pageYOffset;
//           }
//           else if (c.scrollTop !== undefined) {
//             return c.scrollTop;
//           }

//           return document.documentElement.scrollTop || 0;
//         };

//         var _containerInnerHeight = function () {
//           if ($container.innerHeight) {
//             return $container.innerHeight();
//           }

//           var c = $container[0];
//           if (c.innerHeight !== undefined) {
//             return c.innerHeight;
//           } else if (c.clientHeight !== undefined) {
//             return c.clientHeight;
//           }

//           return document.documentElement.clientHeight || 0;
//         };

//         // Begin with offset and update on resize
//         var _elementOffset = function () {
//           if (element.offset) {
//             return element.offset().top;
//           }
//           var box = element[0].getBoundingClientRect();
//           return box.top + _containerScrollTop() - document.documentElement.clientTop;
//         };


//         var _elementOffsetContainer = function () {
//           if (element.offset) {
//             return element.offset().top - $container.offset().top;
//           }
//           return element[0].getBoundingClientRect().top - $container[0].getBoundingClientRect().top;
//         };

//         // Update url of our image
//         var _setImage = function () {
//           if (options.background) {
//             element[0].style.backgroundImage = 'url("' + currentImage + '")';
//           } else if (img) {
//             img[0].src = currentImage;
//           }
//         };

//         // Append image to DOM
//         var _placeImage = function () {

//           loaded = true;
//           // What is my best image available
//           var hasImage = bestImage(images);

//           if (hasImage) {
//             // we have to make an image if background is false (default)
//             if (!options.background) {

//               if (!img) {
//                 element.addClass(LOADING);
//                 if (attrs.phxLazyImageIsplanche) {

//                   $rootScope.$watch('listOfReferencesForPlanch', function (newValue, oldValue) {
//                     if(newValue && (newValue !== oldValue)){

//                       var target = document.getElementById('plancheMAP');
//                       if(target){
//                         var mapToDestroy = angular.element(target);
//                         mapToDestroy.remove();
//                       }

//                       var targetImg = document.getElementById('plancheIMG');
//                       if(targetImg){
//                         var imgToDestroy = angular.element(targetImg);
//                         imgToDestroy.remove();
//                       }

//                       img = angular.element('<img id="plancheIMG" src="'+newValue.urlIllustration+'" USEMAP="#planche"/>');
//                       var tempMap = '<map id="plancheMAP" name="planche">';

//                       for (var i = 0; i < newValue.references.length; i++) {
//                         var reference = newValue.references[i];
//                         for (var j= 0; reference.coords && j < reference.coords.length; j++) {
//                           var coord = reference.coords[j];
//                           var x1 = coord.x;
//                           var y1 = coord.y;
//                           var x2 = x1 + 14;
//                           var y2 = y1 + 14;
//                           tempMap += "<area shape=\"rect\" coords=\"" + x1 + "," + y1 + "," + x2 + "," + y2 + "\" href=\"javascript:var $rootScope = angular.element(document).injector().invoke(function($rootScope){return $rootScope;}); $rootScope.selectReferencesFromPlanche(" + reference.index + ")\">";
//                         }
//                       }
//                       tempMap += '</map>';
//                       var map = angular.element(tempMap);
//                       element.append(map);


//                       img.one('load', _loaded);
//                       img.one('error', _error);
//                       // remove loading class when image is acually loaded
//                       img['0'].srcset = newValue.urlIllustration;
//                       element.append(img);
//                     }
//                   }, false);
//                 }
//                 else {
//                   img = angular.element('<img ' + imgAttrs + ' />');
//                   img.one('load', _loaded);
//                   img.one('error', _error);
//                   // remove loading class when image is acually loaded
//                   element.append(img);
//                 }


//               }

//             }

//             // set correct src/url
//             _checkIfNewImage();
//           }

//           // Element is added to dom, no need to listen to scroll anymore
//           $container.off('scroll', _onViewChange);

//         };

//         // Check on resize if actually a new image is best fit, if so then apply it
//         var _checkIfNewImage = function () {
//           if (loaded) {
//             var newImage = bestImage(images);

//             if (newImage !== currentImage) {
//               // update current url
//               currentImage = newImage;

//               // TODO: loading state...

//               // update image url
//               _setImage();
//             }
//           }
//         };

//         // First update our begin offset
//         _checkIfNewImage();

//         var _loaded = function () {

//           attrs.$set('phxLazyImageLoaded', 'done');

//           element.removeClass(LOADING);

//         };

//         var _error = function () {

//           attrs.$set('phxLazyImageLoaded', 'fail');

//         };

//         // Check if the container is in view for the first time. Utilized by the scroll and resize events.
//         var _onViewChange = function () {
//           // only do stuff when not set already
//           if (!loaded) {

//             // Config vars
//             var remaining, shouldLoad, windowBottom;

//             var height = _containerInnerHeight();
//             var scroll = _containerScrollTop();

//             var elOffset = $container[0] === $window ? _elementOffset() : _elementOffsetContainer();
//             windowBottom = $container[0] === $window ? height + scroll : height;

//             remaining = elOffset - windowBottom;

//             // Is our top of our image container in bottom of our viewport?
//             //console.log($container[0].className, _elementOffset(), _elementPosition(), height, scroll, remaining, elOffset);
//             shouldLoad = remaining <= offset;


//             // Append image first time when it comes into our view, after that only resizing can have influence
//             if (shouldLoad) {

//               _placeImage();

//             }

//           }

//         };

//         var _onViewChangeDebounced = srcSetService.debounce(_onViewChange, 300);

//         // EVENT: RESIZE THROTTLED
//         var _onResize = function () {
//           $timeout.cancel(timeout);
//           timeout = $timeout(function () {
//             _checkIfNewImage();
//             _onViewChange();
//           }, 300);
//         };


//         // Remove events for total destroy
//         var _eventsOff = function () {

//           $timeout.cancel(timeout);

//           angular.element($window).off('resize', _onResize);
//           angular.element($window).off('scroll', _onViewChangeDebounced);

//           if ($container[0] !== $window) {
//             $container.off('resize', _onResize);
//             $container.off('scroll', _onViewChangeDebounced);
//           }

//           // remove image being placed
//           if (img) {
//             img.remove();
//           }

//           img = timeout = currentImage = undefined;
//         };

//         // set events for scrolling and resizing on window
//         // even if container is not window it is important
//         // to cover two cases:
//         //  - when container size is bigger than window's size
//         //  - when container's side is out of initial window border
//         angular.element($window).on('resize', _onResize);
//         angular.element($window).on('scroll', _onViewChangeDebounced);

//         // if container is not window, set events for container as well
//         if ($container[0] !== $window) {
//           $container.on('resize', _onResize);
//           $container.on('scroll', _onViewChangeDebounced);
//         }

//         // events for image change
//         attrs.$observe('phxLazyImage', function () {
//           images = attrs.phxLazyImage;
//           if (loaded) {
//             _placeImage();
//           }
//         });

//         // Image should be directly placed
//         if (options.nolazy) {
//           _placeImage();
//         }


//         scope.$on('phx.lazyImage.destroyed', _onResize);

//         // Remove all events when destroy takes place
//         scope.$on('$destroy', function () {
//           // tell our other kids, i got removed
//           $rootScope.$broadcast('phx.lazyImage.destroyed');
//           // remove our events and image
//           return _eventsOff();
//         });

//         return _onViewChange();

//       }
//     };

//   }]);

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('inputTextAutoCompletionDirective', inputTextAutoCompletionDirective);

  /** @ngInject */
  function inputTextAutoCompletionDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/inputTextAutoCompletion/inputTextAutoCompletion.html',
      controller: InputTextAutoCompletionController,
      controllerAs: 'inTextAutoCompletionCtrl',
      bindToController: true,
      scope: {
        styleClass: '='
      }

    };
    return directive;

    /** @ngInject */
    function InputTextAutoCompletionController() {
      var vm = this;


      function init(){
        vm.styleClass = directive.scope.styleClass;
        vm.data = ["Meteor", "Meteor1", "Meteor2", "Meteor3", "Meteor4", "Meteor5", "Meteor6", "Meteor7", "Meteor8", "Meteor9", "Meteor10", "Pils", "Kronenbourg", "Grimbergen"];
      }

      init();

    }
  }
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .config(config);

    /** @ngInject */
    function config($translateProvider) {
        var langList = ['ar','bg','cs','da','de','el','en','es','fa','fi','fr','hr','hu','it','ja','ko','nl','no','pl'
            ,'pt-BR','pt','ro','ru','sk','sl','sv','tr','uk','zh']
        $translateProvider.useStaticFilesLoader({
            prefix: '/assets/messages/local-',
            suffix: '.json'
        });
        var language = navigator.language || navigator.userLanguage;
        language = language.split('-')[0];
        language =  langList.includes(language) ? language : 'en';
        // $translateProvider.useLocalStorage();
        $translateProvider.preferredLanguage(language);
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

    }

})();

(function () {
  'use strict';

  angular.module('phenix.core').directive('headerPhnx', headerPhnx);

  /** @ngInject */
  function headerPhnx() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/header/header.html',
      scope: {
        user: '='
      }

    };

    return directive;
  }
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .directive('floatOnly', floatOnly);

    /** @ngInject */
    function floatOnly() {

        var directive = {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text;
                        if (!transformedInput.match(/^[0-9]+((\,|\.)?[0-9]?[0-9]?)?$/)) {
                            if (transformedInput.indexOf('.') != -1) {
                                transformedInput = transformedInput.replace(/[^0-9.]/g, '');
                                var textSplited = transformedInput.split('.');
                                transformedInput = (textSplited[0] ? textSplited[0] : '') + (textSplited[1] ? '.' + textSplited[1].substring(0, 4) : '');
                            } else {
                                transformedInput = transformedInput.replace(/[^0-9,]/g, '');
                                var textSplited = transformedInput.split(',');
                                transformedInput = (textSplited[0] ? textSplited[0] : '') + (textSplited[1] ? ',' + textSplited[1].substring(0, 4) : '');
                            }
                        }

                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return '';
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };

        return directive;


    }

})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .controller('ForfaitModalCtrl', ForfaitModalCtrl);

  /** @ngInject */
  function ForfaitModalCtrl($modalInstance, modalOpts, UtilsMetierService, $translate, toastr) {
    var vm = this;

    function init() {
      vm.title = modalOpts.title;
      vm.product = modalOpts.product;
      vm.page = modalOpts.page;
      vm.cancelButtonLabel = modalOpts.cancelButtonLabel;
      vm.okButtonLabel = modalOpts.okButtonLabel;
      vm.th = '';

      vm.estimates = modalOpts.estimates;
      vm.cancel = cancelGeneric;
      vm.ok = okGeneric;
      vm.reposition = repositionGeneric;

      if(modalOpts.page){
        $translate('PRODUCT_ADD_TO_ESTIMATE').then(function (text) {
          vm.addRefLabel = text;
        }, function () {
          toastr.error('Translation error');
        });
      }else{
        $translate('PRODUCT_ADD_PRODUCT').then(function (text) {
          vm.addRefLabel = text;
        }, function () {
          toastr.error('Translation error');
        });
      }
    }




    // Dismiss a modal, passing a reason
    function cancelGeneric() {
      modalOpts.cancelAction();
      $modalInstance.dismiss('cancel');
    }

    // Recalculates and positions the top position of the modal
    function repositionGeneric() {
      $modalInstance.reposition();
    }


    // Close a modal, passing a result
    function okGeneric() {
      if (vm.th.length > 0) {
        vm.th = UtilsMetierService.formatDecimal(vm.th);
        modalOpts.okAction(vm.th);
        $modalInstance.close('ok');
      }
    }



    init();

  }
})();

angular.module('phenix.core').filter('unique', function() {
    return function (arr, field) {
        var o = {}, i, l = arr ? arr.length : 0, r = [];
        for(i=0; i<l;i+=1) {
            o[arr[i][field]] = arr[i];
        }
        for(i in o) {
            r.push(o[i]);
        }
        return r;
    }
  });
  
angular
  .module('phenix.core')
  .filter('titlecase', function () {
    return function(input) {
      if (!input) {
        return '';
      }
      return input.toString().toLowerCase().split(' ').map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    };
  });

angular
  .module('phenix.core')
  .filter('localTimeFilter', function () {
    return function(inputDate) {
      if (inputDate === null || _.isEmpty(inputDate)) {
        return inputDate;
      }
       return moment.tz(inputDate, moment.tz.guess(true)).format('YYYY/MM/DD HH:mm');
    };
  });

angular
    .module('phenix.core')
    .filter('toCamelCase', function () {
        return function (items) {
            if (!items) {
                return items;
            }
            var formatedString = "";
            formatedString = items.charAt(0).toUpperCase() + items.toLowerCase().slice(1);
            return formatedString;
        };
    });


angular.module('phenix.core').filter('filterOptionSplit', function() {
  return function(value) {
    if(value){
      //la structures splits[] contient splitLabel dans context.ordersAndSplits
      //mais label dans un bon de service
      value.id = value.splitId || value.id;
      if(value.id != null && value.id != -1) {
        value.label = value.splitLabel || value.label;
        return (value.id + ' : ' + value.label);
      }
      if(value.id == -1) {
        return ('- : ' + value.label);
      }
      return '-';
    }
    return '';
  };
});

angular.module('phenix.core').filter('filterFormatRef', function (CacheConstants, CacheService) {
  function filterFormatRef(ref) {
    const cacheProfile = CacheService.getObject(CacheConstants.profil);
    const isFormatEnabled = cacheProfile && cacheProfile.isPRFormat;
    if (!isFormatEnabled) {
      return ref;
    }
    if (isFormatEnabled && ref) {
      if (ref.length != 10) {
        return (ref);
      }
      return (ref.substring(0, 2) + ' ' + ref.substring(2, 4) + ' ' + ref.substring(4, 7) + ' ' + ref.substring(7, 10));
    }
  }
  filterFormatRef.$stateful = true;
  return filterFormatRef;
});

angular
  .module('phenix.core')
  .filter('filterFormatDateDms', function () {
    return function (date) {
      if (date) {
        if(!/^(\d){8}$/.test(date)) return "invalid date";
        var y = date.substr(0,4),
          m = date.substr(4,2),
          d = date.substr(6,2);
        return m+'/'+d+'/'+y;
      }
    };
  });

angular
  .module('phenix.core')
  .filter('capitalize', function () {
    return function(input) {
      return (input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
  });

(function() {
    angular.module('phenix.core').service('filterListService', function () {
        this.renameIpnField = renameIpnField;

        /**
         *
         * @desc Return a new filter obj without ipn field, and create a new properties
         *
         * @param {obj} filter
         * @param {string} propName
         */

        function renameIpnField(filter, propName) {
            var newFilter = _.omit(filter, 'ipn');

            newFilter[propName] = filter['ipn'];

            return newFilter;
        }
    });
})();

(function(){
    "use strict";

    angular.module('phenix').component('filterList', {
        controller: filterListController,
        templateUrl: 'app/core/filterList/filterList.template.html',
        bindings:{
            onSearch: '<',
            typeOfSupercart: '=',
            filtersValues: '='
        },
        controllerAs: 'vm'
    })

    /**
     * @param {Array} fields - filters propreties (label, name, value and class)
     * [
            {'label': 'COMMON_NUMBER_ID', 'name': 'number', 'value': '', 'class': 'icon-icons_basket icon-position' },
            {'label': 'COMMON_NUMCLIENT_LABEL', 'name': 'accountNumber', 'value': '', 'class': 'icon-icons_vehicle_search_panier icon-position' },
            {'label': 'ADMIN_IPN', 'name': 'ipn', 'value': '', 'class': 'icon-icons_people_search_basket icon-position' }
        ];
     * @param {Event} onSearch
     */

    /* @ngInject */
    function filterListController(CodesConstants, CacheService,globalConstant, $rootScope) {

        /*=============================================
        =               VARIABLES                     =
        =============================================*/

        var vm = this;
        vm.displayRegisterNumber = false;

        vm.onValidate = onValidate;
        vm.onReset = onReset;
        vm.deleteEmptyValue = deleteEmptyValue;


        /*=============================================
        =               FUNCTIONS                     =
        =============================================*/

        this.$onInit = function () {
            var user = CacheService.getUserProfile();
            vm.displayRegisterNumber = CodesConstants.listCountryRegisterNumber.some(function (country) {
                return country === user.country;
            })
            setDisplayConfiguration(user.dmsConfig.networkProfile);

        }

        function setDisplayConfiguration(profil) {
            switch (profil) {
                case globalConstant.workshop:
                    setWorkshopConfig();
                    break;
                case globalConstant.partshop:
                    setPartshopConfig();
                    break;
            }
        }
        function setPartshopConfig() {
            vm.filterFields = [
                {
                    'label': 'COMMON_NUMBER_ID',
                    'name': 'number',
                    'value': vm.filtersValues && vm.filtersValues.number ? vm.filtersValues.number : '',
                    'class': 'icon-icons_basket icon-position'
                },
                {
                    'label': 'COMMON_NUMCLIENT_LABEL',
                    'name': 'accountNumber',
                    'value': vm.filtersValues && vm.filtersValues.accountNumber ? vm.filtersValues.accountNumber : '',
                    'class': 'icon-icons_vehicle_search_panier icon-position'
                },
                {
                    'label': 'ADMIN_IPN',
                    'name': 'ipn',
                    'value': vm.filtersValues && vm.filtersValues.lastModifierIpn ? vm.filtersValues.lastModifierIpn: '',
                    'class': 'icon-icons_people_search_basket icon-position'
                }
            ];

        }

        function setWorkshopConfig() {
            var vehSearchQuoteIconPosition = "icon-icons_vehicle_search_quote icon-position";
            vm.filterFields = [
                {
                    label: "COMMON_NUMBER_ID",
                    name: "number",
                    value: vm.filtersValues && vm.filtersValues.number ? vm.filtersValues.number : '',
                    class: vehSearchQuoteIconPosition
                },
                {
                    label: "ACTIS_VEHICLE_VIN",
                    name: "vin",
                    value: vm.filtersValues && vm.filtersValues.vin ? vm.filtersValues.vin : '',
                    class: vehSearchQuoteIconPosition
                },
                {
                    label: "ACTIS_VEHICLE_IMMAT",
                    name: "registrationNumber",
                    value: vm.filtersValues && vm.filtersValues.registrationNumber ? vm.filtersValues.registrationNumber : '',
                    class: vehSearchQuoteIconPosition
                },
                {
                    label: "ACTIS_VEHICLE_MODEL",
                    name: "vehicleDesignation",
                    value: vm.filtersValues && vm.filtersValues.vehicleDesignation ? vm.filtersValues.vehicleDesignation : '',
                    class: vehSearchQuoteIconPosition
                },
                {
                    label: "COMMON_ORDER_NUMBER",
                    name: "orderNumber",
                    value: vm.filtersValues && vm.filtersValues.orderNumber ? vm.filtersValues.orderNumber : '',
                    class: "icon-icons_repair_search_quote icon-position"
                },
                {
                    label: "COMMON_NUMCLIENT_LABEL",
                    name: "accountNumber",
                    value: vm.filtersValues && vm.filtersValues.accountNumber ? vm.filtersValues.accountNumber : '',
                    class: vehSearchQuoteIconPosition
                },
                {
                    label: "ADMIN_IPN",
                    name: "ipn",
                    value: vm.filtersValues && vm.filtersValues.ipn ? vm.filtersValues.ipn : '',
                    class: "icon-icons_people_search_basket icon-position"
                }
            ];

        }


        /**
         * @name onValidate
         * @desc this action is fired when the user click on search button
         * @param {Object} filter
         * @return {void}
         */
        function onValidate(filtersFields) {
            var filter = {};
            var networkProfil = CacheService.getNetworkProfile();
            filter.type =networkProfil;
            filtersFields.forEach(function(filterItem){
                filter[filterItem.name] = filterItem.value;
            });

            if (!filter) {
                return;
            }
            $rootScope.$emit("resetPagination");
            vm.filters = deleteEmptyValue(filter);
            vm.onSearch(vm.filters);
        }

        function onReset(filtersFields){
            var networkProfil = CacheService.getNetworkProfile();
            filtersFields.map(function(filterItem){
                filterItem.value= "";
            });
            vm.filters.type = networkProfil;
            vm.onSearch(vm.filters);
            $rootScope.$emit("resetPagination");
        }
        /*=============================================
        =               TOOLS                         =
        =============================================*/

        /**
         *  @desc Return new object with only fulfill contain example :
         *  {
         *      a : null,
         *      b : '',
         *      c: false
         *  }
         *
         *  to :
         *
         *  {
         *      c: false;
         *  }
         *
         *  @param {Object} filter
         *  @returns {Object}
         *
        */
        function deleteEmptyValue(filter) {
            var obj = {};

            for (var prop in filter) {
                var isInvalid = typeof filter[prop] !== 'boolean' && !filter[prop];
                if (isInvalid) {
                    continue;
                }
                obj[prop] = filter[prop];
            }

            return obj;
        }

    }
})();

angular.module('phenix.core').directive('expandFilter', function() {


  function expandFilterLink(scope, element, attributes) {
    element.addClass('removeOutline');
  }


  return {
    templateUrl: 'app/core/expandFilter/expandFilter.html',
    restrict: 'E',
    transclude: true,
    scope: {
      expand: '=',
      onClick: '&',
      filterTitle: '=',
      icon: '@'
    },
    link: expandFilterLink
  };


    /**
     * <expand-filter
     *     expand="vm.filters.VEHICLE.show" // variable which show content if TRUE
           filter-title="my filter-title"                 // the filter name
           icon="icon-icons_vehicle"        //the icon class
           on-click="vm.onClickAction()"    //the action on click filter's filter-title. NOT USE NG-CLICK!!>
             <div>
                <div>This is filter's content</div>
                <input type="text"
             </div>
     * </expand-filter>
     */
});

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .directive('doubleOnly', doubleOnly);

  /** @ngInject */
  function doubleOnly() {

    var directive = {
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text;

                  if (!transformedInput.match(/^[0-9]+(\.?[0-9]?[0-9]?)?$/)) {
                      transformedInput = transformedInput.replace(/[^0-9.]/g, '');
                      var textSplited = transformedInput.split('.');
                      transformedInput =  (textSplited[0] ? textSplited[0] :'') + (textSplited[1] ? '.' + textSplited[1].substring(0,2) :'');
                    }

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
              return '';
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };

    return directive;


  }

})();

(function() {
    angular
        .module("phenix.core")
        .service("DealerManagerSystemeService", dealerManagerSysteme);

    /** @ngInject */
    function dealerManagerSysteme(
        /**
         *  ANGULAR MODULE
         */

        $translate,
        $http,
        $q,
        $rootScope,
        /**
         *  OTHERS
         */
        RestUpgrade,
        CacheService,CacheConstants,
        /**
         *  CONSTANTS
         */
        CarSearchConstants, DmsConstants,configConstantes
    ) {
        /**
         *  ENUMS
         */

        var code = {
            success: 0,
            forbidden: -1,
            dms: "dms"
        };

        /**
         *  GETTER - SETTER
         */

        var vm = this;

        vm.storeHookResult = storeHookResult;
        vm.getHookResult = getHookResult;
        vm.authorization = authorization;
        vm.isWorkshop = isWorkshop;
        vm.isPartshop = isPartshop;
        vm.isSetWorkshopPartshopId = isSetWorkshopPartshopId;
        vm.siteLabel = '';
        vm.setDMSSiteLabel = setDMSSiteLabel;
        vm.getDMSSiteLabel = getDMSSiteLabel;

        /*
         *  INTERNAL STATE
         */

        var connectedToDMS = defaultValue();
        //  var connectedToDMS = true;

        /**
         * ?
         */

        vm.hookDMS = hookDMS;

        function hookDMS(dmsEndpoint, userDms, workshopPartshopId, dealerId) {
            var user = CacheService.getUserProfile();

            var payload = {
                userDms: userDms,
                ipn: user.ipn,
                workshopPartshopId: workshopPartshopId
            };

            if(dealerId){
                _.extend(payload, {
                    dealerId: dealerId
                });
            }
            else{
                _.extend(payload, {
                    dealerId: user.dealerId
                });
            }

            return ping(dmsEndpoint, payload);
        }



        function pingRequest(endpoint, payload) {            
            var failureDMSPayload = {
                dmsConnectedMode: false
            }
            vm.isRdcsEnable = JSON.parse(configConstantes.isRdcsEnable);
            var userProfil = CacheService.getUserProfile(); 
            var isApigeeDmsUrl = endpoint.includes(DmsConstants.apigeeQaUrl) || endpoint.includes(DmsConstants.apigeeUrl)  || endpoint.includes(DmsConstants.apigeeQaOktaUrl) || endpoint.includes(DmsConstants.apigeeOktaUrl);           
            if(!vm.isRdcsEnable){
            if (isApigeeDmsUrl) {
                var dealerId;
                if (payload.dealerId) {
                    dealerId = payload.dealerId;
                    delete payload['dealerId'];
                } else {
                    var userProfil = CacheService.getUserProfile();
                    dealerId = userProfil.dealerId;
                }
                
                return RestUpgrade.all(DmsConstants.pingRdcsUrl + dealerId + DmsConstants.rdcsUrl.ping).post(payload).then(function (response) {
                    return response;
                })
                
            } else {
                return $http
                    .post(endpoint + "ping.v1", payload, {
                        headers: {
                            "Content-Type": "text/plain; charset=UTF-8"
                        },
                        timeout: 30000
                    }).then(function (response) {                            
                            return response;                                                 
                    }).catch(function(error){
                        if(error && error.status === -1 || response.returnCode !== 0){
                            userProfil.dmsConnected = false;                                
                            CacheService.setUserProfile(userProfil);
                        }
                        return response;
                    })
            }
        }else{
                var dealerId;
                if (payload.dealerId) {
                    dealerId = payload.dealerId;
                    delete payload['dealerId'];
                } else {
                    var userProfil = CacheService.getUserProfile();
                    dealerId = userProfil.dealerId;
                }
                
                return RestUpgrade.all(DmsConstants.pingRdcsUrl + dealerId + DmsConstants.rdcsUrl.ping).post(payload).then(function (response) {
                    CacheService.setObject(CacheConstants.isRdcsDms,true);
                    return response;
                }).catch(function(error){
                    CacheService.setObject(CacheConstants.isRdcsDms,false);
                    payload.dealerId = dealerId;
                
                return $http
                    .post(endpoint + "ping.v1", payload, {
                        headers: {
                            "Content-Type": "text/plain; charset=UTF-8"
                        },
                        timeout: 30000
                    }).then(function (response) {                            
                            return response;                                                 
                    }).catch(function(error){
                        if(error && error.status === -1 || response.returnCode !== 0){
                            CacheService.removeObject(CacheConstants.isRdcsDms);
                            userProfil.dmsConnected = false;                                
                            CacheService.setUserProfile(userProfil);
                        }
                        return response;
                    })
                })
        }
        }
        

        /**
         * @param {string} endpoint
         * @param {object} payload
         * @return {Promise<Object>}
         */

        function ping(endpoint, payload) {
            if (!endpoint) {
                return $q.resolve({
                    returnCode: code.forbidden,
                    message: "Some error occurred"
                });
            }
            // content-type:    text/plain to unset "options" request ;
            //                  charset=UTF-8 to unset "connect" request on IE
            return pingRequest(endpoint, payload).then(
                    function (res) {
                        return res.data || res || {};
                    },
                    function (err) {
                        var msgError = $translate.instant("ERROR");
                        return {
                            returnCode: code.forbidden,
                            message: msgError
                        };
                    }
                );
            }       

        /**
         *  @desc L'etat du DMS est stocke en session
         *  pour recharger son etat en cas de reactualisation de page
         *
         * @param {Object || Boolean} state
         * @return {Boolean}
         */

        function storeHookResult(state) {

            // when switching dms mode in settings and saving, separate analysis of service call and boolean of DMS mode
            if(state && "undefined" !== typeof(state["isDmsMode"])){
                var isDmsMode = state.isDmsMode;
                state = state.dmsCallSuccess;
            }

            var invalid = state == undefined || state == null;
            if (invalid) {
                return false;
            }
            
            $rootScope.$emit("storeHookResultEvent");
            if (typeof state === "boolean") {
                connectedToDMS = state;
            } else if (typeof state === "object" && isDmsMode !== false) {
                connectedToDMS = state.returnCode === code.success ? true : false;
            }
            sessionStorage.setItem(code.dms, connectedToDMS);
            return connectedToDMS;
        }

        /**
         *   @returns {boolean}
         */
        function getHookResult() {
            return connectedToDMS;
        }

        /**
         * Check si l'utilisateur a les droits pour avoir acces au DMS
         *
         * @return {boolean}
         */
        function authorization() {
            var dms = CacheService.getDMSInformation();

            return dms.url ? true : false;
        }

        /**
         * L'etat du DMS connecté ou deconnecté est recuperé
         * dans le cas ou l'utilisateur reactualise sa page
         *
         * @return {boolean}
         */
        function defaultValue() {
            var dms = sessionStorage.getItem(code.dms);
            return JSON.parse(dms);
        }

        /**
         * @name is isWorkshop
         * @desc check if user sent as a parameter has a workshop profile
         * @param {Object} user
         */
        function isWorkshop(user) {
            return (
                (vm.getHookResult() || user.dmsConnected) &&
                user.dmsConfig &&
                user.dmsConfig.networkProfile ===
                    CarSearchConstants.networkProfileWorkshop
            );
        }

        /**
         * @name is isPartshop
         * @desc check if user sent as a parameter has a partshop profile
         * @param {Object} user
         */
        function isPartshop(user) {
            return (
                (vm.getHookResult() || user.dmsConnected) &&
                user.dmsConfig &&
                user.dmsConfig.networkProfile ===
                    CarSearchConstants.networkProfilePartshop
            );
        }

        function isSetWorkshopPartshopId(user) {
            return (
                vm.getHookResult() &&
                user.dmsConfig &&
                user.dmsConfig.workshopPartshopId &&
                user.dmsConfig.workshopPartshopId != ""
            );
        }
        function setDMSSiteLabel(siteLabel){
            vm.siteLabel = siteLabel;
        }

        function getDMSSiteLabel(){
            return vm.siteLabel;
        }

    }
})();

(function () {
    'use strict';

    angular.module('phenix.core').directive('sticky', sticky);

    /** @ngInject */
    function sticky($window) {
        return {
            restrict: 'A',
            scope: {
                nameClass: '@'
            },
            link: function (scope, element, attr) {
                var stickyActif = false;
                var headerElement = document.querySelectorAll('#phenixHeader');
                var headerHeight = getHeight(headerElement);

                angular.element($window).bind("scroll", _.debounce(function () {
                    var elementHeight = getHeight(element);
                    var totalHeight = headerHeight;

                    if (this.pageYOffset > totalHeight && !stickyActif) {
                        angular.element(element).addClass(attr.nameClass);
                        angular.element(headerElement).css({
                            'margin-bottom': elementHeight + 'px'
                        });
                        stickyActif = true;
                    } else if (this.pageYOffset < totalHeight && stickyActif) {
                        angular.element(element).removeClass(attr.nameClass);
                        angular.element(headerElement).css({
                            'margin-bottom': 0 + 'px'
                        });
                        stickyActif = false;
                    }
                }, 1));
            }
        };
    }

    function getHeight(el) {
        if(el.length > 0){
            var heightDocument = el[0].offsetHeight;
            var styles = window.getComputedStyle(el[0]);
            var margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
            return heightDocument + margin;
        }
    }
})();

angular.module('phenix.core').directive('phenixEnter', function() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if(event.which === 13) {
                    scope.$apply(function(){
                        scope.$eval(attrs.phenixEnter, {'event': event});
                    });

                    event.preventDefault();
                }
            });
        };
    });
(function () {

    angular.module('phenix.core').directive('phenixIsNumber', directive);

    function directive() {
        return {
            scope: {
                quantity: '<',
                isSearchEngine:'<',
                isAlterNative:'<',
                isAdditional:'<'
            },
            restrict: 'E',
            transclude: true,
            template: '<div>'
                + '<ng-transclude ng-if="vm.quantityIsNumber"></ng-transclude>'
                + '<span style="font-size: 20px;" ng-if="!vm.quantityIsNumber&&!vm.isSearchEnable"> - </span>'
                + '<span style="font-size: 20px;" ng-if="!vm.quantityIsNumber&&vm.isSearchEnable&&!vm.isAlterNative&&!vm.isAdditional"> - </span>'
                + '<span style="font-size: 20px;margin-left:151px" ng-if="!vm.quantityIsNumber&&vm.isSearchEnable&&vm.isAlterNative&&!vm.isAdditional"> - </span>'
                + '<span style="font-size: 20px;margin-left:132px" ng-if="!vm.quantityIsNumber&&vm.isSearchEnable&&vm.isAdditional&&!vm.isAlterNative"> - </span>'

                + '</div>',
            controller: phenixIsNumberController,
            bindToController: true,
            controllerAs: 'vm'
        }
    }

    function phenixIsNumberController() {
        var vm = this;
        vm.quantityIsNumber = false;
        vm.isSearchEnable=false;
        vm.isAlterNative=false;
        vm.isAdditional=false;


        this.$onInit = function () {
            if (_.isNumber(this.quantity)) {
                vm.quantityIsNumber = true;
            }
            if(this.isSearchEngine)
            {
                vm.isSearchEnable=true;
            }
            if(this.isAlterNative)
            {
                vm.isAlterNative=true;
            }
            if(this.isAdditional)
            {
                vm.isAdditional=true;
            }
        }
    }

})();

(function () {
    'use strict';
    angular.module('phenix.core').service('CurrencyWsService', CurrencyWsService);


    function CurrencyWsService(RestUpgrade, CurrencyConstants,$q) {

        this.getCurrency = getCurrency;

        function getCurrency(country){

            if(_.includes(CurrencyConstants.nonSPARCCountries,country)){
                return $q.resolve(CurrencyConstants.currencyEUR);
            }else if(_.includes(_.keys(CurrencyConstants.currencyNDCountries),country)){
                return $q.resolve(_.get(CurrencyConstants.currencyNDCountries,country));
            }else{
                var url = CurrencyConstants.partsCurrency + country;
                return RestUpgrade.one(url).get();
            }
            
        }

    }
})();

(function () {
    'use strict';
    angular
    .module('phenix.core')
    .service('CurrencyService', CurrencyService);

    function CurrencyService(CurrencyWsService, CacheService) {
        this.getCurrency = getCurrency;

        function getCurrency(){
            var userProfile = CacheService.getUserProfile();
            return CurrencyWsService.getCurrency(userProfile.country).then(function(response){
                var currency = "";
                //case 1 ou plusieurs résultats
                if (response && response.length >= 1) {
                    currency = response[0];
                }
                return currency;
            });
        }
    }
})();

'use strict';

angular.module('phenix.core').constant('CurrencyConstants', {
    partsCurrency:'/proxy/apidh/rest/v1/parts/currency/',
    nonSPARCCountries: ['MQ','GP','GF','RE','RS','SI','IE','HR'],
    currencyNDCountries: {
        'SE' : ['SEK'],
        'DK' : ['DKK'],
        'HU' : ['HUF'],
        'BG' : ['BGN']
    },
    currencyEUR: ['EUR']
});


(function() {
    angular.module('phenix').constant('ContainerListConstants', {
        sort: {
            asc: 1,
            desc: -1,
            date: 'DATE',
            ID: 'ID'
        },
        QUOTE_MODE: "QUOTE_MODE",
        PART_REQUISITION_MODE: "PART_REQUISITION_MODE"
    })
})();

(function () {
    "use strict";

    angular.module("phenix.core").component("containerList", {
        controller: containerListController,
        templateUrl: 'app/core/containerList/containerList.template.html',
        bindings: {
            // currentSuperCart: "=",
            // type: "@",

            list: "<",
            stateOfSupercart: '=',
            typeOfSupercart: '=',

            // ??
            actions: "=",

            isPartRequisition: "<",

            onDelete: "<",
            onSelect: "<",
            onUnlock: "<",
            onCheck: "<",
            onSort: "<"
        },
        controllerAs: "vm"
    });

    /**
         *
         * @param {Object} currentSuperCart
         * @param {Array} list - parts requisitions list
         * [{
                "id": "af4c18a0-e174-48ec-9995-256532f460a1",
                "number": "ND000257",
                "creationDateTime": "2018-07-25T07:50Z",
                "creatorIPN": "FR11111118",
                "description": null,
                "accountNumber": "2145",
                "lastModificationDateTime": "2018-07-25T07:57Z",
                "lastModifierIPN": "FR11111118",
                "validationDateTime": "2018-07-25T00:00Z",
                "validatorIPN": "FR11111118",
                "dealerId": "testdealer",
                "dmsPartListId": null,
                "status": "VALID",
                "userLock": null,
                "type": "WORKSHOP",
                "vin": null,
                "registrationNumber": null,
                "brand": "APL03",
                "familyVehicle": "X85",
                "bodyType": "C85",
                "engineType": "K4J",
                "gearboxType": null,
                "batteryType": null,
                "lockedByUser": false,
                "items": null,
                "vehiculeLabel": "X85, C85, K4J, null",
                "searchBy": 3
            }]
         * @param {String} type - used to know the data to display from the list {validatedWorkshop, draftWorkshop}
         * @param {Array} actions - actions fields propreties (class, event and icon)
         * [
                {
                    "class": "small-1 columns cell_remove",
                    "event": "",
                    "icon": "fa fa-lock",
                    "$$hashKey": "object:70"
                },
                {
                    "class": "small-1 columns cell_remove",
                    "event": "delete",
                    "icon": "icon-icons_remove",
                    "$$hashKey": "object:71"
                }
            ]
         * @param {Event} onDelete
         * @param {Event} onSort
         * @param {Event} onSelect
         * @param {Event} onUnlock
         * @param {Event} onCheck
         */

    /* @ngInject */
    function containerListController(
        ContainerListConstants,
        DeleteModalService,
        toastr,
        globalConstant,
        $translate,
        CacheService,
        $rootScope,$log
    ) {
        var vm = this;
        vm.globalConstant = globalConstant;


        /*=============================================
            =               INTERNAL STATE                =
            =============================================*/

        var _asc = ContainerListConstants.sort.asc;
        var _desc = ContainerListConstants.sort.desc;
        var _defaultOrder = _desc;
        var _sort = {
            by: "DATE",
            order: 1
        };

        /*=============================================
            =               VARIABLES                     =
            =============================================*/
        vm.superCart = {};
        vm.deleteCarts = deleteCarts;
        vm.selectCart = selectCart;
        vm.unlock = unlock;
        vm.check = check;
        vm.handleIconOrder = handleIconOrder;
        vm.sortBy = sortBy;
        vm.networkProfile;

        /*=============================================
            =               FUNCTIONS                     =
            =============================================*/

        this.$onInit = function () {
            vm.networkProfile = CacheService.getNetworkProfile();
            vm.validatedSuperCart = vm.stateOfSupercart === vm.globalConstant.validated;
            setDisplayConfiguration(vm.typeOfSupercart);
        };

        function setDisplayConfiguration(typeOfSupercart) {
            switch (typeOfSupercart) {
                case globalConstant.partRequisition:
                    setPartRequisitionConfig();
                    break;
                case globalConstant.quote:
                    setQuoteConfig();
                    break;
            }
        }

        function sortBy(header) {
            $rootScope.$emit("resetPagination");
            if (_defaultOrder === _desc) {
                _defaultOrder = _asc
            } else {
                _defaultOrder = _desc
            }

            _sort.by = header;
            vm.onSort(header, _defaultOrder);
        }

        function setQuoteConfig() {
            vm.superCart.displayMode = ContainerListConstants.QUOTE_MODE;
            vm.superCart.title = "ESTIMATE_MSG_DELETE";
            vm.superCart.lockLabel = "ESTIMATE_CLICK_UNLOCK";
            vm.superCart.errorMessageSuperCartAlreadyInUse = "ERROR_ES_IN_USE";
        }

        function setPartRequisitionConfig() {
            vm.superCart.displayMode = ContainerListConstants.PART_REQUISITION_MODE;
            vm.superCart.title = "PART_REQUISITION_MSG_DELETE";
            vm.superCart.lockLabel = "PART_REQUISITION_CLICK_UNLOCK";
            vm.superCart.errorMessageSuperCartAlreadyInUse = "ERROR_BS_IN_USE";
        }

        /**
         * @name deleteCarts
         * @desc Looking inside list and get all checked cart
         * @desc spread this event to superCart controller
         */
        function deleteCarts() {
            var checkedRow = vm.list
                .filter(function (currentSuperCart) {
                    return currentSuperCart.checked;
                })
                .map(function (currentSuperCart) {
                    return {
                        id: currentSuperCart.id,
                        number: currentSuperCart.number
                    };
                });

            //lockedRows is an array of locked cart (part requisition or quote)
            var lockedRows = vm.list
                .filter(function (currentSuperCart) {
                    return currentSuperCart.lockedByUser;
                })
                .map(function (currentSuperCart) {
                    return {
                        id: currentSuperCart.id
                    };
                });

            var checkedIdsSuperCart = checkedRow.map(function (
                currentSuperCart
            ) {
                return currentSuperCart.id;
            });

            if (!checkedRow.length) {
                return;
            }

            //here we just iterate the lockedRows array in order to check if a locked quote or partReq is checked for suppression
            //in this case, we instanciate the abortFunction to return the function.
            var abortFunction;
            lockedRows.forEach(function (lockedRow) {
                abortFunction = _.find(checkedRow, function (iterat) {
                    return iterat.id === lockedRow.id;
                });
            });
            if (abortFunction) {
                toastr.error($translate.instant(vm.superCart.errorMessageSuperCartAlreadyInUse));
                return;
            }


            var body = angular.element(document.body);
            var payload = {
                body: body,
                isList: true,
                title: vm.superCart.title,
                rows: checkedRow
            };
            DeleteModalService.showModal(payload)
                .then(function () {
                    vm.onDelete(checkedIdsSuperCart);
                })
                .catch(function () {
                    $log.debug($translate.instant('ERROR'));
                 });
        }

        /**
         * @name unlock
         * @desc this action is fired when user click on unlock button
         * @desc spread this event to SuperCart controller
         * @param {Object} currentSuperCart
         */
        function unlock(currentSuperCart) {
            vm.onUnlock(currentSuperCart);
        }

        /**
         * @name handleIconOrder
         * @desc add icon sort ofr each column
         * @param {string} sortBy (ID, ACCOUNT_NUMBER, DATE)
         */
        function handleIconOrder(sortBy) {

            var top = false;
            var bot = false;

            if ((sortBy === "DATE" && _sort.by === 'DATE') ||
                (sortBy === "VALIDATED_DATE" && _sort.by === 'VALIDATED_DATE')) { 
 
                top = _defaultOrder === _asc ? false : true;
                bot = !top;
            }
            else if (sortBy === "ID" && _sort.by === 'ID') {
                top = _defaultOrder === _asc ? false : true;
                bot = !top;
            }
            else if (sortBy === "ACCOUNT_NUMBER" && _sort.by === 'ACCOUNT_NUMBER') {
                top = _defaultOrder === _asc ? false : true;
                bot = !top;
            }

            return {
                "icon-icons_filter_order": true,
                "icon-icons_filter_top_basket": top,
                "icon-icons_filter_bot_basket": bot
            };
        }

        /**
         * @name selectCart
         * @desc this action is fired when user select a part requisition
         * @desc spread this event to SuperCart controller
         * @param {Object} currentSuperCart
         */
        function selectCart(currentSuperCart) {
            vm.onSelect(currentSuperCart);
        }

        /**
         * @name check
         * @desc this action is fired when user check a part requisition
         * @desc spread this event to SuperCart controller
         * @param {Object} currentSuperCart
         */
        function check(currentSuperCart) {
            vm.onCheck(currentSuperCart);
        }
    }
})();

(function() {
    angular.module('phenix.core').constant('errorsConstant', {
        'NOT_AUTHORIZED' : 1,
        'UNKNOW_REFERENCE' : 2,
        'SERVICE_UNVAILABLE': 503
    })
})();

(function () {
  'use strict';

  angular.module('phenix.core').constant('ConfigurationConstants', {

    restConfiguration: '/configuration'
  });
})();

(function () {
    'use strict';
    angular.module('phenix.core').service('CloudFrontWsService', CloudFrontWsService);


    function CloudFrontWsService(RestUpgrade, CloudFrontConstants) {


        this.returnTokenCloudFront = returnTokenCloudFront;


        function returnTokenCloudFront(){
            return RestUpgrade.all(CloudFrontConstants.cloudFrontAccess).post();
        }

    }
})();

/**
 * CloudFront URL Helper Service
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix.core')
        .service('CloudFrontUrlHelper', CloudFrontUrlHelper);

    /**
     * @namespace CloudFrontUrlHelper
     * @desc Service to append CloudFront signed URL parameters to URLs in content
     * @memberOf Services
     */

    /** @ngInject */
    function CloudFrontUrlHelper($cookies) {

        /*=============================================
        =                 PUBLIC API                  =
        =============================================*/
        this.sanitizeContent = sanitizeContent;
        this.appendCloudFrontParams = appendCloudFrontParams;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        /**
         * @name sanitizeContent
         * @desc Processes HTML content and adds CloudFront parameters to CDN image URLs
         * @param {string} htmlContent - HTML string containing image tags
         * @returns {string} Processed HTML with CloudFront parameters in CDN image URLs
         */
        function sanitizeContent(htmlContent) {
            if (!htmlContent || typeof htmlContent !== 'string') {
                return htmlContent;
            }

            if (!window.location.hostname.includes('.biz')) {
                return htmlContent;
            }

            if (htmlContent.indexOf('<img') === -1 &&
                htmlContent.indexOf('<video') === -1 &&
                htmlContent.indexOf('<source') === -1) {
                return htmlContent;
            }

            var modifiedContent = htmlContent;

            var imgTagRegex = /<img([^>]*)\ssrc=["']([^"']+)["']([^>]*)>/gi;

            modifiedContent = modifiedContent.replace(imgTagRegex, function (match, before, srcUrl, after) {
                if (isCDNUrl(srcUrl)) {
                    var signedUrl = appendCloudFrontParams(srcUrl);
                    if (signedUrl !== srcUrl) {
                        return '<img' + before + ' src="' + signedUrl + '"' + after + '>';
                    }
                }
                return match;
            });

            var sourceTagRegex = /<source([^>]*)\ssrc=["']([^"']+)["']([^>]*)>/gi;

            modifiedContent = modifiedContent.replace(sourceTagRegex, function (match, before, srcUrl, after) {
                if (isCDNUrl(srcUrl)) {
                    var signedUrl = appendCloudFrontParams(srcUrl);
                    if (signedUrl !== srcUrl) {
                        return '<source' + before + ' src="' + signedUrl + '"' + after + '>';
                    }
                }
                return match;
            });

            var sourceNgSrcRegex = /<source([^>]*)\sng-src=["']([^"']+)["']([^>]*)>/gi;

            modifiedContent = modifiedContent.replace(sourceNgSrcRegex, function (match, before, srcUrl, after) {
                if (isCDNUrl(srcUrl)) {
                    var signedUrl = appendCloudFrontParams(srcUrl);
                    if (signedUrl !== srcUrl) {
                        return '<source' + before + ' ng-src="' + signedUrl + '"' + after + '>';
                    }
                }
                return match;
            });

            var videoSrcRegex = /<video([^>]*)\ssrc=["']([^"']+)["']([^>]*)>/gi;

            modifiedContent = modifiedContent.replace(videoSrcRegex, function (match, before, srcUrl, after) {
                if (isCDNUrl(srcUrl)) {
                    var signedUrl = appendCloudFrontParams(srcUrl);
                    if (signedUrl !== srcUrl) {
                        return '<video' + before + ' src="' + signedUrl + '"' + after + '>';
                    }
                }
                return match;
            });

            return modifiedContent;
        }

        /**
         * @name appendCloudFrontParams
         * @desc Appends CloudFront signed URL parameters to a single URL
         * @param {string} url - The URL to process
         * @returns {string} URL with CloudFront parameters appended if applicable
         */
        function appendCloudFrontParams(url) {
            if (!url || typeof url !== 'string') {
                return url;
            }

            if (!window.location.hostname.includes('.biz')) {
                return url;
            }

            if (!isCDNUrl(url)) {
                return url;
            }

            var policy = $cookies.get('CloudFront-Policy');
            var signature = $cookies.get('CloudFront-Signature');
            var keyPairId = $cookies.get('CloudFront-Key-Pair-Id');

            if (!policy || !signature || !keyPairId) {
                return url;
            }

            if (url.indexOf('CloudFront-Policy') !== -1 ||
                url.indexOf('Policy=') !== -1) {
                return url;
            }

            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            return url + separator +
                'Policy=' + encodeURIComponent(policy) +
                '&Signature=' + encodeURIComponent(signature) +
                '&Key-Pair-Id=' + encodeURIComponent(keyPairId);
        }

        /**
         * @name isCDNUrl
         * @desc Checks if a URL is a CDN URL that needs CloudFront signing
         * @param {string} url - The URL to check
         * @returns {boolean} True if URL is a CDN URL
         * @private
         */
        function isCDNUrl(url) {
            if (!url) {
                return false;
            }
            return url.includes('.asdh.aws.renault.com') && url.includes('cdn');
        }
    }

})();

/**
 * Recap cloud front Service
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix.core')
        .service('CloudFrontService', CloudFrontService);

    /**
     * @namespace CloudFrontService
     * @desc get cloud front service
     * @memberOf Services
     */

    /** @ngInject */
    function CloudFrontService($cookies, CloudFrontWsService, CloudFrontConstants, CacheService, CacheConstants) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        this.setCookies = setCookies;
        this.getAccessCookies = getAccessCookies;
        this.removeAccessCookies = removeAccessCookies;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        /**
         * @name setCookies
         * @desc set cookies after an interval
         * @memberOf Services.CloudFrontService
         */
        function setCookies() {
            var expirationDate;
            //get cookies from response body
            //response should be like this
            //{"CloudFront-Policy": "value1", "CloudFront-Signature": "value2", "CloudFront-Key-Pair-Id": "value3", "Expiration-Date": "Sun, 29 Mar 2020 09:27:31 GMT" }
            return CloudFrontWsService.returnTokenCloudFront().then(function (response) {
                
                var responseSize = Object.keys(response);

                if (responseSize) {
                    //get current date
                    var currentDate = moment.utc(new Date().getTime());

                    //get expiration date
                    var expirationDate = moment.utc(response["Expiration-Date"]);

                    //get difference between current date and expiration date in seconds
                    var differenceMilliSeconds = (expirationDate.unix() - currentDate.unix() - CloudFrontConstants.nextSetCookie) * 1000;

                    // //delete expiration date from response
                    delete response["Expiration-Date"];

                    // //response be like this {"CloudFront-Policy": "value1", "CloudFront-Signature": "value2", "CloudFront-Key-Pair-Id": "value3"}
                    angular.forEach(response, function (cookieValue, cookieName) {
                        
                        // Uncomment below and biz checks for localhost testing
                        // var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                        // if (isLocalhost) {
                        //     var cookieString = cookieName + '=' + encodeURIComponent(cookieValue) + 
                        //                      '; path=' + CloudFrontConstants.path;
                        //     console.log('Setting CloudFront cookie for localhost:', cookieName);
                        //     document.cookie = cookieString;
                        //     return;
                        // }

                        // Set cookie for the current domain
                        var currentDomain = '.' + window.location.hostname.split('.').slice(-2).join('.');

                        var cookieString = cookieName + '=' + encodeURIComponent(cookieValue) +
                            '; domain=' + currentDomain +
                            '; path=' + CloudFrontConstants.path +
                            '; SameSite=None; Secure';
                        document.cookie = cookieString;
                    });

                    //call set cookies after difference seconds
                    var interval = setInterval(function () {
                        clearInterval(interval);
                        setCookies();
                    }, differenceMilliSeconds);
                }

            });

        }

        function getAccessCookies(){

            var cookiesObjects = CloudFrontConstants.cookiesElements;

            var cookiesFromCache = [];

            var isCookiesPresent = false;

            angular.forEach(cookiesObjects, function(cookieValue, cookieName){

               var value = $cookies.get(cookieValue, {
                    'domain': CloudFrontConstants.domain,
                    'path': CloudFrontConstants.path
                });

                if(value && !_.isEmpty(value)){
                    cookiesFromCache.push(value);
                }
            })
            
            var len = Object.keys(cookiesObjects).length;

            if(len === cookiesFromCache.length){
                isCookiesPresent = true;
            }

            return isCookiesPresent;
            

        }

        function removeAccessCookies() {

            var cookiesObjects = CloudFrontConstants.cookiesElements;

            var currentDomain = '.' + window.location.hostname.split('.').slice(-2).join('.');

            angular.forEach(cookiesObjects, function (cookieValue, cookieName) {

                var cookieString = cookieValue + '=; domain=' + currentDomain +
                    '; path=' + CloudFrontConstants.path +
                    '; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure';
                document.cookie = cookieString;

            })

        }
    }

})();

/**
 * CloudFront HTTP Interceptor
 * @namespace Interceptors
 */
(function () {
    'use strict';

    angular
        .module('phenix.core')
        .factory('CloudFrontInterceptor', CloudFrontInterceptor)
        .config(configureInterceptor);

    /**
     * @namespace CloudFrontInterceptor
     * @desc Intercepts HTTP requests to CDN and appends CloudFront signed URL parameters
     * @memberOf Interceptors
     */

    /** @ngInject */
    function CloudFrontInterceptor($cookies, $injector) {
        return {
            request: request
        };

        /**
         * @name request
         * @desc Intercepts outgoing HTTP requests and appends CloudFront parameters if needed
         * @param {Object} config - HTTP request configuration
         * @returns {Object} Modified HTTP request configuration
         */
        function request(config) {
            if (!config.url || !window.location.hostname.includes('nissan.biz')) {
                return config;
            }

            var isCDNRequest = config.url.includes('.asdh.aws.renault.com') &&
                config.url.includes('cdn')

            if (!isCDNRequest) {
                return config;
            }

            var policy = $cookies.get('CloudFront-Policy');
            var signature = $cookies.get('CloudFront-Signature');
            var keyPairId = $cookies.get('CloudFront-Key-Pair-Id');

            if (policy && signature && keyPairId) {
                var separator = config.url.indexOf('?') !== -1 ? '&' : '?';

                config.url = config.url + separator +
                    'Policy=' + encodeURIComponent(policy) +
                    '&Signature=' + encodeURIComponent(signature) +
                    '&Key-Pair-Id=' + encodeURIComponent(keyPairId);
            }
            return config;
        }
    }

    /**
     * @name configureInterceptor
     * @desc Registers the CloudFront interceptor with Angular's $httpProvider
     */
    /** @ngInject */
    function configureInterceptor($httpProvider) {
        $httpProvider.interceptors.push('CloudFrontInterceptor');
    }

})();

'use strict';

angular.module('phenix.core').constant('CloudFrontConstants',{
    cloudFrontAccess:'/proxy/apidh/rest/v1/contents/accessCookies',
    nextSetCookie: 600,
    domain: '.renault.com',
    path: '/',
    accessToken: 'assure',
    cookiesElements: {
                        cloudFrontKeyPairId: 'CloudFront-Key-Pair-Id',
                        cloudFrontPolicy: 'CloudFront-Policy',
                        cloudFrontSignature: 'CloudFront-Signature',
                        domainBasePath: 'domainBasePath',
                        urlBasePath: 'urlBasePath'
                    }
});

/**
 * Recap cloud front Service
 * @namespace Services
 */
(function () {
    'use strict';

    angular
        .module('phenix.core')
        .service('ClipService', ClipService);

    /**
     * @namespace ClipService
     * @desc get cloud front service
     * @memberOf Services
     */

    /** @ngInject */
    function ClipService($cookies, ClipConstants) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        this.setParameters = setParameters;
        this.getParameters = getParameters;
        this.removeParameters  = removeParameters;
        this.manageWiringDiagramsAndDiagnosticObject = manageWiringDiagramsAndDiagnosticObject;
        this.manageICMObject = manageICMObject;
        this.manageVDHObject = manageVDHObject;


        /**
         * @name setParameters
         * @desc create a cookies to store all clip parameters separated by a &
         */
        function setParameters(parameters,cookieName) {
            var cookieValue = [];

            angular.forEach(parameters, function(value, key) {
                if (value){
                    cookieValue.push(key + "=" + value) ;
                }
                else{
                    cookieValue.push(key + "=" + '') ;
                }
            });

            $cookies.put(cookieName, cookieValue.join("&"), {
                'domain': ClipConstants.domain,
                'path': ClipConstants.path
            });
        }

         /**
         * @return clip parameters object
         * @desc return a javascript object containing the clip parameters by parse the cookie value
         */
        function getParameters(cookieName) {
            var parametersString = $cookies.get(cookieName, {
                'domain': ClipConstants.domain,
                'path': ClipConstants.path
            });
            var parametersObject = {};

            if (parametersString){
                var parameters = parametersString.split("&");
                angular.forEach(parameters, function(parameter) {
                    var keyValueArray = parameter.split("=");
                    var value = keyValueArray[1];
                    parametersObject[keyValueArray[0]] = value;
                });
            }
            return parametersObject;
        }

        function removeParameters(cookieName) {
            $cookies.remove(cookieName, {
                'domain': ClipConstants.domain,
                'path': ClipConstants.path
            });
        }

        function manageWiringDiagramsAndDiagnosticObject(paramsObject) {

            var result = 0;
            if(_.isEmpty(paramsObject)){
                result = ClipConstants.WiringDiagrams.Result.emptyParameters;
            }
            else if(!paramsObject.APP_ID || !paramsObject.VIN || !paramsObject.TYPE || !paramsObject.WDT){
                result = ClipConstants.WiringDiagrams.Result.mandatoryFieldsDoNotExist;
            }
            else if( paramsObject.APP_ID && paramsObject.VIN && !paramsObject.TYPE && !paramsObject.WDT ){
                result = ClipConstants.DiagnosticByUrl.Result.vinOnly;
            }
            else {
                if (paramsObject.CPC && paramsObject.WDT === 'NOM') {
                    result = ClipConstants.WiringDiagrams.Result.detailMainComponent;
                } else if (paramsObject.CPC && !paramsObject.CSC) {
                    result = ClipConstants.WiringDiagrams.Result.electricalSchemasWithMainComponent;
                } else if (paramsObject.CPC && paramsObject.CSC) {
                    result = ClipConstants.WiringDiagrams.Result.electricalSchemasWithMainAndOptionalComponents;
                } else if (paramsObject.LC && _.isEmpty(paramsObject.CPC)) {
                    result = ClipConstants.WiringDiagrams.Result.electricalSchemasWithSignalsAndNoComponent;
                } else {
                    result = ClipConstants.WiringDiagrams.Result.electricalSchemasMainPage;
                }
            }

            return result;
        }

        function manageVDHObject(paramsObject){
            var result = 0;

            if(_.isEmpty(paramsObject)){
                result = ClipConstants.VDH.Result.emptyParameters;
            }
            else if(!paramsObject.APP_ID || !paramsObject.VIN || !paramsObject.TYPE || !paramsObject.VDH_DF_ID){
                result = ClipConstants.VDH.Result.mandatoryFieldsDoNotExist;
            }
            else {
                result = ClipConstants.VDH.Result.diagFileDetailsComponent;
            }
            return result;
        }

        function manageICMObject(paramsObject){
            var result = 0;
                if(_.isEmpty(paramsObject)){
                    result = ClipConstants.ICM.Result.emptyParameters;
                }
                else if(paramsObject.TYPE == 'BT' && (!paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.appId)
                    || !paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.TYPE)
                    || !paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.docId))){
                    result = ClipConstants.ICM.Result.mandatoryFiledsNotExist;
                } else if(paramsObject.TYPE == 'MR' && (!paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.appId)
                || !paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.TYPE)
                || !paramsObject.hasOwnProperty(ClipConstants.ICM.Parameters.VIN))){
                    result = ClipConstants.ICM.Result.mandatoryFiledsNotExist;
                }
                else if(paramsObject.APP_ID !== ClipConstants.ICM.App_ID.ICM){
                    result = ClipConstants.ICM.Result.appIdNotIcm;
                }
                else if(paramsObject.TYPE !== ClipConstants.ICM.DocumentType.BT && paramsObject.TYPE !== ClipConstants.ICM.DocumentType.MR){
                    result = ClipConstants.ICM.Result.notBtDocument;
                }
                return result;
        }
    }

})();

(function () {
    'use strict';
    
    angular
        .module('phenix.core')
        .constant('ClipConstants', {
            clipCookieName: 'NewDialogys-Clip',
            commonCookieName: 'NewDialogys-External', 
            domain: 'renault.com',
            path: '/',
            newDiagnosticPage: 'newADT',
            DiagnosticByUrl: {
                Result: {
                    availableVinAndSymptom: 11,
                    vinOnly: 12
                },
                App_ID: {
                    CLIP: 'CLIP'
                },
                SYMPTOM: 'SYMPTOM',
                Parameters: {
                    appId: 'APP_ID',
                    VIN: 'VIN',
                    SYMPTOM: 'SYMPTOM'
                }
            },
            DiagnosticSearch:{
                Result: {
                    DiagnosticSearchMainPage: 15
                }
            },
            WiringDiagrams: {
                Result: {
                    emptyParameters: -4,
                    mandatoryFieldsDoNotExist: -5,
                    electricalSchemasMainPage: 6,
                    electricalSchemasWithMainComponent: 7,
                    electricalSchemasWithSignalsAndNoComponent: 8,
                    electricalSchemasWithMainAndOptionalComponents: 9,
                    detailMainComponent: 10
                },
                App_ID: {
                    CLIP: 'CLIP'
                },
                WDT: {
                    SCH: 'Schéma',
                    NOM: 'Nomenclature',
                    PC: 'Passage câblage'
                },
                CPC: 'CPC',
                CSC: 'CSC',
                LC: 'LC',
                SYMPTOM: 'SYMPTOM',
                Parameters: {
                    appId: 'APP_ID',
                    VIN: 'VIN',
                    TYPE: 'TYPE',
                    WDT: 'WDT'
                },
                FUNCTION:'FUNCTION',
                TITLE:'TITLE',
                wiringDiagramsCache: 'wiringDiagrams'
            },
            
            COMMON:{
                Result: {
                    vinSearch: 20,
                    availableVinAndSymptom: 21,
                    btWithoutNavigation: 18,
                    emptyParameters: -6,
                    DiagnosticSearchMainPage: 16
                },
            }
        });
})();

(function() {
    angular.module('phenix.core').service('StorageService', function() {
     
        var storage = {};

        this.setItem = function(key, data) {
            storage[key] = angular.copy(data);
        }

        this.deleteItem = function(key) {
            delete storage[key];
        }

        this.getItem = function(key) {
            return angular.copy(storage[key]);
        }

    })
})();
(function () {
  'use strict';

  angular
    .module('phenix.core')
    .service('CacheTokenService', CacheTokenService);

  /** @ngInject */
  function CacheTokenService(CacheService) {

    this.getSessionInfo = getSessionInfo;
    this.setSessionInfo = setSessionInfo;
    this.removeSessionInfo = removeSessionInfo;

    function getSessionInfo() {
      return CacheService.getObject("sessionInfo");
    }

    function setSessionInfo(session) {
      session.date = (new Date).getTime();
      return CacheService.setObject("sessionInfo", session);
    }

    function removeSessionInfo() {
      return CacheService.removeObject("sessionInfo");
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .service('CacheService', CacheService);

    /** @ngInject */
    function CacheService(localStorageService, CacheConstants,$rootScope, $window) {
        var sessionStorage = $window.sessionStorage;


        this.getObject = getObject;
        this.setObject = setObject;
        this.removeObject = removeObject;
        this.clearAll = clearAll;
        this.setDefaultStorageKeys = setDefaultStorageKeys;
        this.getNetworkProfile = getNetworkProfile;

        this.getUserProfile = getUserProfile;
        this.setUserProfile = setUserProfile;

        this.setR2ADealerList = setR2ADealerList;
        this.getR2ADealerList = getR2ADealerList;


        this.getQuoteCustomer = getQuoteCustomer;
        this.saveQuoteCustomer = saveQuoteCustomer;
        this.getPartRequisitionCustomer = getPartRequisitionCustomer;
        this.savePartRequisitionCustomer = savePartRequisitionCustomer;
        this.getFodCustomer = getFodCustomer;
        this.saveFodCustomer = saveFodCustomer;
        this.removeFodCustomer = removeFodCustomer;

        //New Function
        this.setDmsQuote = setDmsQuote;
        this.getDmsQuote = getDmsQuote;
        this.deleteDmsQuote = deleteDmsQuote;
        this.deleteDmsPartRequisition = deleteDmsPartRequisition;


        this.isUserContextExist = isUserContextExist;
        this.getUserContext = getUserContext;
        this.getUserContextForElectricalSchema = getUserContextForElectricalSchema;
        this.getDMSInformation = getDMSInformation;

        this.getCarSearchContext = getCarSearchContext;

        this.getCarContext = getCarContext;
        this.getBinData = getBinData;
        this.removeCarContext = removeCarContext;
        this.cleanCarContext = cleanCarContext;

        this.getSieDocumentsHistory = getSieDocumentsHistory;
        this.setSieDocumentsHistory = setSieDocumentsHistory;
        this.setBtListDocumentsHistory = setBtListDocumentsHistory;
        this.getBtListDocumentsHistory = getBtListDocumentsHistory;


        this.cleanSieDocumentsHistory = cleanSieDocumentsHistory;

        this.getSiesByGiesHistory = getSiesByGiesHistory;
        this.setSiesByGiesHistory = setSiesByGiesHistory;
        this.getNodeSearchTmList = getNodeSearchTmList;
        this.setNodeSearchTmList = setNodeSearchTmList;
        this.cleanNodeSearchTmList = cleanNodeSearchTmList;
        this.cleanSiesByGiesHistory = setSiesByGiesHistory;

        this.saveCAN_Document = saveCAN_Document;
        this.getCAN_Document = getCAN_Document;
        this.getFixedCriteriasForWd = getFixedCriteriasForWd;
        this.filterEmptyFields = filterEmptyFields;

        this.setBreakingNewsNoCarContext = setBreakingNewsNoCarContext;
        this.getBreakingNewsNoCarContext = getBreakingNewsNoCarContext;

        this.saveComponentsAndSignals = saveComponentsAndSignals;
        this.getComponentsAndSignals = getComponentsAndSignals;

        this.setUserType = setUserType;
        this.getUserType = getUserType;

        function isStorageSupported() {
            return localStorageService.isSupported || localStorageService.cookie.isSupported;
        }

        function getObject(key) {
            if (isSessionStorageSupported) {
                var object = sessionStorage.getItem(key);
                if (object === null || object === undefined || object === 'undefined') {
                    return null;
                }
                try {
                    var parsed = JSON.parse(object);
                    return parsed;
                } catch (error) {
                    return null;
                }
            }
            return null;
        }

        function setObject(key, object) {
            if (isSessionStorageSupported) {
                if (object != null || object != undefined){
                    return sessionStorage.setItem(key, JSON.stringify(object));
                }
                else{
                    return sessionStorage.setItem(key, null);
                }

            }
        }

        function removeObject(key) {
            if (isSessionStorageSupported) {
                return sessionStorage.removeItem(key);
            }
        }

        function clearAll() {
            if (isSessionStorageSupported) {
                return sessionStorage.clear();
            }
        }

        function isSessionStorageSupported(){
            return sessionStorage.isSupported || sessionStorage.cookie.isSupported;
        }

        function isUserContextExist() {
            var user = getObject(CacheConstants.profil);
            if (user) {
                return true;
            }
            return false;
        }

          //function for filtering  carcontext when we search WD with a VIN.
          function getFixedCriteriasForWd(carContext,isObjCritSelected,wdObjectCriteria){
            var fixedCriterias = {
                "027" : carContext.fixedCriterias["027"],
                "427" : carContext.fixedCriterias["427"],
                "336" : carContext.fixedCriterias["336"],
                "901" : carContext.fixedCriterias["901"],
                "007" : carContext.fixedCriterias["007"],
                "008" : carContext.fixedCriterias["008"],
                "019" : carContext.fixedCriterias["019"],
                "APV001" :carContext.fixedCriterias["APV001"],
                "956" :carContext.fixedCriterias["956"]
            };
            var variableCriterias = {
                "APVDT1" : carContext.variableCriterias["APVDT1"]
            }

            var wdSelectedObjCriteria = wdObjectCriteria;
            if(wdSelectedObjCriteria && !_.isEmpty(wdSelectedObjCriteria) && isObjCritSelected){
                wdSelectedObjCriteria.forEach(function(item){
                    if (item.codeObj !== "APVDT1" && item.codeObj !== "APVAP1"){
                        fixedCriterias[item.codeObj] = item.codeCrit;
                    }else{
                       if (item.codeObj == "APVAP1"){
                        variableCriterias["APVDT1"] = item.codeCrit.replaceAll('/','-');
                       }else{
                        variableCriterias[item.codeObj] = item.codeCrit;
                       }                       
                    }
                    
                })

            }
            fixedCriterias = filterEmptyFields(fixedCriterias);
            variableCriterias = filterEmptyFields(variableCriterias);
            carContext.fixedCriterias = fixedCriterias;
            carContext.variableCriterias = variableCriterias;
            return carContext;
        }
        function filterEmptyFields(criterias){
            for(var check in criterias){
                if(criterias[check] == null || criterias[check] == undefined){
                    delete criterias[check];
                }
            }
            return criterias;
        }


        /**
         * @desc    Save wiringDiagrams for DOCUMENT AND CAN only !!
         *          carContext is use to check if we need to clean it when we get it
         * @param {Array<Object>} WD
         *
         */
        function saveCAN_Document(CAN_DocumentList) {
            var carContextDefault = getCarContext();
            var carContext = getFixedCriteriasForWd(carContextDefault);
            setObject(CacheConstants.wiringDiagramsCanDocument, {
                vehicle: carContext,
                list: CAN_DocumentList
            })
        }

        /**
         * @desc    Save Components And Signals !!!
         * @param {Array<Object>} componentsAndSignals
         *
         */
        function saveComponentsAndSignals(componentsAndSignals) {
            var carContextDefault = getCarContext();
            var carContext = getFixedCriteriasForWd(carContextDefault);
            setObject(CacheConstants.componentsAndSignals, {
                vehicle: carContext,
                list: componentsAndSignals
            })
        }

        /**
         * @desc    return Components And Signals
         */
        function getComponentsAndSignals() {
            var WDContext = getObject(CacheConstants.componentsAndSignals);
            var carContextDefault = getCarContext();
            var carContext = getFixedCriteriasForWd(carContextDefault);
            if (!WDContext) {
                setObject(CacheConstants.componentsAndSignals, null);
                return null;
            }

            if (!_.isEqual(carContext, WDContext.vehicle)) {
                setObject(CacheConstants.componentsAndSignals, null);
                return null;
            }

            return WDContext.list;
        }

        /**
         * @desc    return wiringDiagrams
         *          Contains of wiringDiagrams depend of carContext, so if they are not equal we clean it
         */
        function getCAN_Document() {
            var WDContext = getObject(CacheConstants.wiringDiagramsCanDocument);
            var carContextDefault = getCarContext();
            var carContext = getFixedCriteriasForWd(carContextDefault);
			//WD - Return KO after update or data resetting of VIN technical criteria - DEV/RE7/PROD - PPX59104-1800
			//update carcontext in wirinng diagram in cache
			// if(WDContext){
			// WDContext.vehicle=carContext;
			// setObject(CacheConstants.wiringDiagramsCanDocument,WDContext); 
			// }

            if (!WDContext) {
                setObject(CacheConstants.wiringDiagramsCanDocument, null);
                return null;
            }

            if (!_.isEqual(carContext, WDContext.vehicle)) {
                setObject(CacheConstants.wiringDiagramsCanDocument, null);
                return null;
            }

            return WDContext.list;
        }

        /**
         *
         * Retourne un objet qui represente le type de profil, les langues de la documentation
         * que l'utilisateur peut potentiellement recevoir en plus des pays, car certains pays
         * peuvent parler la meme langue mais avoir un vocabulaire legerement different
         *
         * language : la langue du pays
         * countryReference : le pays qui fait reference a la langue
         *
         * @return Object<{}>
         *
         */

        function getUserContext() {
            var user = getObject(CacheConstants.profil);
            return {
                language: user.documentationFirstLanguage.code.includes("-") ? user.documentationFirstLanguage.code.substr(0,2) : user.documentationFirstLanguage.code,
                countryReferenceLanguage: user.documentationFirstLanguage.countryCode,

                substitutionLanguage: user.documentationSecondLanguage.code.includes("-") ? user.documentationSecondLanguage.code.substr(0,2) : user.documentationSecondLanguage.code,
                countryReferenceLanguageSubstitution: user.documentationSecondLanguage.countryCode,

                countryCode: user.country,
                userProfiles: user.profiles
            }
        }

        /**
         *      @desc   Same as getUserContext except we use portal
         *              language instead of documentationFirstLanguage.
         *
         *              Because electrical schema is not a documentation
         *      @return Object<{}>
         */

        function getUserContextForElectricalSchema() {
            var user = getObject(CacheConstants.profil);
            return {
                language: user.portal.code.includes("-") ? user.portal.code.substr(0,2) : user.portal.code,
                countryReferenceLanguage: user.portal.countryCode,

                // I don't know if we really need this, and if this should be documentation language.
                substitutionLanguage: user.documentationSecondLanguage.code.includes("-") ? user.documentationSecondLanguage.code.substr(0,2) : user.documentationSecondLanguage.code,
                countryReferenceLanguageSubstitution: user.documentationSecondLanguage.countryCode,

                countryCode: user.country,
                userProfiles: user.profiles
            }
        }

        /**
         *  @desc  Save customer from quote (ONLY WHEN IS UPDATED)
         *  @param {*} customer
         */

        function saveQuoteCustomer(customer) {
            setObject(CacheConstants.quoteCustomer, customer);
        }

        function getQuoteCustomer() {
            return getObject(CacheConstants.quoteCustomer);
        }

    // this.saveQuote = saveQuote;

    // function saveQuote(quoteInformations) {
    //     setObject('testQuote', quoteInformations);
    // }

    // this.getQuote = getQuote;

    // function getQuote() {
    //     return getObject('testQuote');
    // }

        /**
         *  @desc  Save customer from quote (ONLY WHEN IS UPDATED)
         *  @param {*} customer
         */

        function setDmsQuote(dmsQuote) {
            setObject(CacheConstants.dmsQuote, dmsQuote);
        }

        function getDmsQuote() {
            return getObject(CacheConstants.dmsQuote);
        }

        function deleteDmsQuote() {
            removeObject(CacheConstants.dmsQuote);
        }

        function deleteDmsPartRequisition() {
            removeObject(CacheConstants.currentBS);
        }

        /**
         *  @desc  Save customer from partRequisition (ONLY WHEN IS UPDATED)
         *  @param {*} customer
         */

        function savePartRequisitionCustomer(customer) {
            setObject(CacheConstants.partRequisitionCustomer, customer);
        }

        /**
         *  @desc   return the current customer from partRequisition
         *          which contains {
         *              // updated is use when close the partRequisited, to warn user that customer will not be save
         *              updated: bool <= this field can be true when value is updated from user
         *              value: {} <= customer
         *          }
         *  @return {object}
         */

        function getPartRequisitionCustomer() {
            return getObject(CacheConstants.partRequisitionCustomer);
        }

        function saveFodCustomer(customer) {
            setObject(CacheConstants.fodCustomer, customer);
        }

        function getFodCustomer() {
            return getObject(CacheConstants.fodCustomer);
        }

        function removeFodCustomer() {
            removeObject(CacheConstants.fodCustomer);
        }

        /**
         *      @desc Get the network dms profile
         *      @return {Object}
         */

        function getNetworkProfile() {
            var userProfile = getUserProfile();

            return userProfile.dmsConfig.networkProfile;
        }

        function getUserProfile() {
            return getObject(CacheConstants.profil);
        }

        function setUserProfile(profile) {
            if (!_.isEmpty(profile)) {
                if (!_.isEmpty(profile.roles)) {
                    profile.roles = profile.roles.map(function (e) {
                        return e.toUpperCase()
                    });
                }

                if (!_.isEmpty(profile.rolesActis)) {
                    profile.rolesActis = profile.rolesActis.map(function (e) {
                        return e.toUpperCase()
                    });
                }

                if (!_.isEmpty(profile.rolesRparts)) {
                    profile.rolesRparts = profile.rolesRparts.map(function (e) {
                        return e.toUpperCase()
                    });
                }
            }
            setObject(CacheConstants.profil, profile);
        }

        function getR2ADealerList() {
            return getObject(CacheConstants.r2aDealerList);
        }

        function setR2ADealerList(r2aDealerList) {
            setObject(CacheConstants.r2aDealerList, r2aDealerList);
            $rootScope.$emit('R2A_UPDATED')
        }

        function getDMSInformation() {
            var profile = getUserProfile();
            return profile.dmsConfig || {}
        }

        function getCarSearchContext() {
            return getObject(CacheConstants.contextCarSearch);
        }

        /**
         *
         * TODO : TYPE RETURNED OBJECT
         * @return Object<{
         *
         * }>
         */
        function getCarContext() {
            return getObject(CacheConstants.contextCarRequest);
        }
        function getBinData() {
            return getObject(CacheConstants.binData);
        }

        function removeCarContext() {
            removeObject(CacheConstants.contextCarRequest);
            //removeObject(CacheConstants.connectedPlatform);
        }

        function cleanCarContext() {
            removeObject(CacheConstants.contextCarSearch);
            if (getObject(CacheConstants.allowedPrDocumentsForHorse)) {
                removeObject(CacheConstants.allowedPrDocumentsForHorse);
            }
            //removeObject(CacheConstants.connectedPlatform);
        }
        /**
         *  @return Array<string> list ID
         */


        function setSieDocumentsHistory(documents) {
            setObject(CacheConstants.sieDocumentsHistory, documents);
        }
        function setBtListDocumentsHistory(documents) {
            setObject(CacheConstants.btListDocumentsHistory, documents);
        }

        function getBtListDocumentsHistory() {
            return getObject(CacheConstants.btListDocumentsHistory);
        }


        function getSieDocumentsHistory() {
            return getObject(CacheConstants.sieDocumentsHistory);
        }

        function getNodeSearchTmList() {
            return getObject(CacheConstants.tmListSearch);
        }

        function setNodeSearchTmList(searchText) {
            setObject(CacheConstants.tmListSearch, searchText);
        }

        function cleanNodeSearchTmList() {
            removeObject(CacheConstants.tmListSearch);
        }

        function cleanSieDocumentsHistory() {
            removeObject(CacheConstants.sieDocumentsHistory);
        }

        function setSiesByGiesHistory(documents) {
            setObject(CacheConstants.siesByGiesHistory, documents);
        }

        function getSiesByGiesHistory() {
            return getObject(CacheConstants.siesByGiesHistory);
        }


        function setBreakingNewsNoCarContext(breakingNews){
            setObject(CacheConstants.breakingNewsNoCarContext, breakingNews);
        }

        function getBreakingNewsNoCarContext() {
            return getObject(CacheConstants.breakingNewsNoCarContext);
        }

        function setDefaultStorageKeys(){
            if (isSessionStorageSupported) {
                Object.keys(sessionStorage).map(function(item){
                    if(!CacheConstants.defaultStorageKeys.includes(item)){
                        removeObject(item);
                    }
                    return item;
                })
            }
        }

        function setUserType(type){
            setObject(CacheConstants.userType, type);
        }

        function getUserType() {
            return getObject(CacheConstants.userType);
        }
    }
})();

(function () {
    'use strict';

  angular
    .module('phenix.core')
    .constant('CacheConstants', {
      contextCarSearch: 'contextCarSearch',
      profil: 'profil',
      connectedPlatform: 'connectedPlatform',
      nodeFromSearchArbo: 'nodeFromSearchArbo',
      panier: 'panier',
      partList: 'partList',
      levelsDoc: "levelsDoc",
      hideDocsVisited:"hideDocsVisited",
      isOrSearchCar:"isOrSearchCar",
      showDiagnosticView:'showDiagnosticView',
      nodeSelect:'nodeSelect',
      getAllSymptoms: 'getAllSymptoms',
      diagnosticSymptomsResult: 'diagnosticSymptomsResult',
      contextCarRequest: 'contextCarRequest',
      treeNodes:'treeNodes',
      requestDiagnostic: 'requestDiagnostic',
      tabIndex: 'tabIndex',
      sieDocumentsHistory: 'sieDocumentsHistory',
      siesByGiesHistory: 'siesByGiesHistory',
      listOfPiece: 'listOfPiece',
      btListDocumentsHistory:'btListDocumentsHistory',
      htlState : 'htlState',
      traceState : 'traceState',
      dmsResponse : 'dmsResponse',
      workshop: 'WORKSHOP',
      searchedSymptom: 'searchedSymptom',
      isCreateActisSearchedSymptom: 'isCreateActisSearchedSymptom',
      quoteCustomer: 'quoteCustomer',
      partRequisitionCustomer: 'partRequisitionCustomer',
      fodCustomer: 'fodCustomer',
      actisResponse : 'actisResponse',
      wiringDiagramsCanDocument: 'wiringDiagramsCanDocument',
      currency:'currency',
      currentElectricalSchemaInfo: 'currentElectricalSchemaInfo',
      treeContainingNodes: 'treeContainingNodes',
      dmsQuote: 'dmsQuote',
      vehiclePresentInDMSbutNotInBVM: 'vehiclePresentInDMSbutNotInBVM',
      maintenanceProgram:'maintenanceProgram',
      maintenanceProgramIcon:'maintenanceProgramIcon',
      componentsAndSignals:'componentsAndSignals',
      fromDiagnosis:'fromDiag',
      histoyDiagnosis:'historyDiag',
      consultationFIC : 'consultationFIC',
      tmListSearch: 'tmListSearch',
      reportDiagnosis:'reportDiag',
      isActisFromDiag: 'isActisFromDiag',
      r2aDealerList:'r2aDealerList',
      informationMessage: 'informationMessage',
      otsCheck: 'otsCheck',
      transeversalPartsIds:'transeversalPartsIds',
      bvaApigee: 'bvaApigee',
      breakingNewsNoCarContext : 'breakingNewsNoCarContext',
      diagFilesList: 'diagFilesList',
      tokenBalance:'tokenBalance',
      careAlertData: 'careAlertData',
      encryptedValue:'RNtbci-Nd!',
      symptomsBasketList: 'symptomsBasketList',
      diagFileDisplay : 'diagFileDisplay',
      dynatraceMonitoring: 'userProfil',
      selectedDiagFileId: 'selectedDiagFileId',
      basketList: 'basketList',
      isOrderMode:'isOrderMode',
      orderModePartsList:'orderModePartsList',
      systemDocDetails:'systemDocDetails',
      newOrderStart: 'newOrderStart',
      allowedVin:'allowedVin',
      wdObjectCriteria:'wdObjectCriteria',
      isSearchEngine:'isSearchEngine',
      searchEngineIds:'searchEngineIds',
      motCle: 'motCle',
      filter: 'filter',
      binData: 'binData',
      searchEngineDetails:'searchEngineDetails',
      diagList: 'diagList',
      mapDiags: 'mapDiags',
      diagCurrentPage: 'diagCurrentPage',
      historyPagination: 'historyPagination',
      identifierList: 'identifierList',
      newNonDmsOrderStart: 'newNonDmsOrderStart',
      defaultStorageKeys: ['token','profil','dms','informationMessage','currency','htlState','breakingNewsNoCarContext','r2aDealerList','asomSubscription','tokenBalance'],
      asomSubscription:'asomSubscription',
      isNavigatedfromDocPriv: 'isNavigatedfromDocPriv',
      applicabilities: 'applicabilities',
      interventionIdList: 'interventionIdList',
      selectedInterventionId: 'selectedInterventionId',
      intNodeSelected: 'intNodeSelected',
      tmDataSieList: 'tmDataSieList',
      allowedPrDocumentsForHorse: 'allowedPrDocumentsForHorse',
      angularIdData: 'angularIdData',
      basketPopupData: 'basketPopupData',
      prSearchText: 'prSearchText',
      mileage: 'mileage',
      asomSubscriptionList: 'asomSubscriptionList',
      vinEligibleOffers: 'vinEligibleOffers',
      maintenanceIconCheck: 'maintenanceIconCheck',
      angularTokenBalance: "angularTokenBalance",
      asomNotAllowed : 'asomNotAllowed',
      userType : 'userType',
      angularInfoServiceDetails: 'angularInfoServiceDetails',
      informationServiceDetails: 'angularInformationMessage',
      traceSiteIds: 'traceSiteIds',
      backButtonEnable: 'backButtonEnable',
      goToBackFromFeatures: 'goToBackFromFeatures',
      isRdcsDms: "isRdcsDms",
      batteryCrashPrintData: 'batteryCrashPrintData',
      wdMessageShow: 'wdMessageShow',
      isRedirectFromDesyre: 'isRedirectFromDesyre',
      listOts: 'listOts',
      asomSubscriptionForAllowedVin: 'asomSubscriptionForAllowedVin',
      actisFicType: 'actisFicType',
      Common_Assistance: 'Common_Assistance'
    });
})();

(function () {
  'use strict';

  angular
    .module('phenix.core')
    .config(config);

  /** @ngInject */
  function config(localStorageServiceProvider) {

    localStorageServiceProvider
      .setPrefix('phenix')
      .setStorageType('localStorage')
      .setNotify(true, true);
  }

})();

(function() {

    angular.module('phenix.core').component('cartBadge', {
        bindings: {
            cartLength: '<'
        },
        templateUrl: 'app/core/badge/cart-badge.template.html',
        controller: cartBadgeController
    })

    function cartBadgeController() {
        var vm = this;
    }

})();

(function() {
    'use strict';

    angular
        .module('phenix.core')
        .directive('applicabilityTooltip', applicabilityTooltip);

    /* @ngInject */
    function applicabilityTooltip() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            controller: "ApplicabilityTooltipController",
            controllerAs: 'vm',
            templateUrl: "app/core/applicabilityTooltip/applicability-tooltip.template.html",
            restrict: 'E',
            scope: {
                sieDoc : '='
            }
        };
        return directive;

    }

})();

(function() {
    'use strict';

    angular
        .module('phenix.core')
        .controller('ApplicabilityTooltipController', ApplicabilityTooltipController);

    /* @ngInject */
    function ApplicabilityTooltipController($scope) {

        var vm = this;
        vm.sieDoc = $scope.sieDoc;

        activate();

        ////////////////

        function activate() {
            if(vm.sieDoc && vm.sieDoc != 'filterMDReset')
                vm.sieDoc = formatResidualApplicability(vm.sieDoc);
        }


        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        function formatResidualApplicability(sieDocument) {

                sieDocument.residual = (sieDocument.residual) ? sieDocument.residual : [];
                sieDocument.residual.forEach(function (residualElement) {
                    sieDocument.concatApplicabilities = [];
                    residualElement.fixe = (residualElement.fixe) ? residualElement.fixe : [];
                    residualElement.variable = (residualElement.variable) ? residualElement.variable : [];

                    residualElement.fixe.forEach(function (fixe) {
                        sieDocument.concatApplicabilities.push({
                            label: fixe.labelObj,
                            list: fixe.listCrit.map(function (crit) {
                                return crit.labelCrit == null ? crit.codeCrit : crit.labelCrit + ' (' + crit.codeCrit + ')';
                            })
                        })
                        getApplicabilityLabel(sieDocument, fixe);
                    });
                    residualElement.variable.forEach(function (variable) {
                        sieDocument.concatApplicabilities.push({
                            label: variable.labelObj,
                            list: variable.listCrit.map(function (crit) {
                                return crit.labelCrit == null ? crit.codeCrit : crit.labelCrit + ' (' + crit.codeCrit + ')';
                            })
                        });
                        getApplicabilityLabel(sieDocument, variable);
                    });
                });
                return sieDocument;

        }



        function getApplicabilityLabel(residualElement, data){
            //variables
            var applicabilityLabel = "";
            residualElement.applicabilityLabel = [];

            //get label
            applicabilityLabel += data.labelObj + ": ";

            //get labelCrit and codeCrit
            data.listCrit.map(function (crit) {
                var conditionalResidual = crit.labelCrit == null ? crit.codeCrit : crit.labelCrit + ' (' + crit.codeCrit + ')';
                applicabilityLabel += conditionalResidual;
            });

            //push element
            residualElement.applicabilityLabel.push(applicabilityLabel);
        }
    }
})();

(function () {
    angular.module('phenix.core').service('UtilsMetierService', UtilsMetierService);

    /** @ngInject */
    function UtilsMetierService($state, $http, $translate, $rootScope, toastr, CacheService,
        CacheConstants, LoginConstants, configConstantes, globalConstant, ActisConstantes, CarSearchConstants,
        CloudFrontService, CryptoService, MainMetierService,rLinkConstant,ResultSearchByDiagnosticConstants,AlertsConstants,DocPrivConstants) {

        this.isPartShop = isPartShop;
        this.isWorkShop = isWorkShop;
        this.isWorkShopPartShop = isWorkShopPartShop;
        this.toTitleCase = toTitleCase;
        this.clone = clone;
        this.formatDecimal = formatDecimal;
        this.isCorporateUser = isCorporateUser;
        this.isCountryUser = isCountryUser;
        this.isBusinessUser = isBusinessUser;
        this.getUserRoles = getUserRoles;
        this.userIsAdmin = userIsAdmin;
        this.responseHasError = responseHasError;
        this.getProfile = getProfile;
        this.splitList = splitList;
        this.customHttpDelete = customHttpDelete;
        this.getSearchParameters = getSearchParameters;
        this.manageLoginError = manageLoginError;
        this.isEmpty = isEmpty;
        this.replaceEmptyString = replaceEmptyString;
        this.isEmptyNumber = isEmptyNumber;
        this.replaceEmptyNumber = replaceEmptyNumber;
        this.padStart = padStart;
        this.setErrorFrame = setErrorFrame;
        this.resetErrorFrame = resetErrorFrame;
        this.scrollTop = scrollTop;
        this.resetField = resetField;
        this.getPriceToDisplay = getPriceToDisplay;
        this.getCurrencyForItem = getCurrencyForItem;
        this.getCurrencyFromItems = getCurrencyFromItems;
        this.createArrayObject = createArrayObject;
        this.fixDropDownMenu = fixDropDownMenu;
        this.extendPathWithTabToRedirect = extendPathWithTabToRedirect;
        this.arrayMerger = arrayMerger;
        this.isRedButtonAuthorized = isRedButtonAuthorized;
        this.isTraceKnownUser = isTraceKnownUser;
        this.isTraceKnownUserINT = isTraceKnownUserINT;
        this.isFrenchPilotDealer = isFrenchPilotDealer;
        this.isActisProfil = isActisProfil;
        this.isUserFromSparcCountry = isUserFromSparcCountry;
        this.getUserType = getUserType;
        this.isIndependentUser = isIndependentUser;
        this.fixedToDecimal = fixedToDecimal;
        this.getTokenBalance = getTokenBalance;
        this.checkAsomValidDocAcess = checkAsomValidDocAcess;
        this.isDealerAuthorised = isDealerAuthorised;
        this.isNonDMSDealerAuthorised = isNonDMSDealerAuthorised;
        this.isTestingDealers = isTestingDealers;
        this.isR2aStockCountry = isR2aStockCountry;
        this.isCountryTargeted = isCountryTargeted;
        this.isInterventionAccess = isInterventionAccess;
        this.isRemoteDiagDealers = isRemoteDiagDealers;
        this.isSymptomAiSearchEnable = isSymptomAiSearchEnable;
        this.isVespaProfil = isVespaProfil;
        this.isChatBotDealerAccess = isChatBotDealerAccess;
        this.vehicleInformationDisplay = vehicleInformationDisplay;
        this.vegasTabDisplay = vegasTabDisplay;
        this.csrButtonShow = csrButtonShow;
        this.adasEhorizonInformationDisplay = adasEhorizonInformationDisplay;
        this.isPlannedAssistance = isPlannedAssistance; 
        this.copyToClipboard = copyToClipboard;
        var contryExceptionArray = ["RO"];
        this.ddpAuditTabDisplay = ddpAuditTabDisplay;
        this.ddpHelpPageDisplay = ddpHelpPageDisplay;
        this.isOktaAuthentication = isOktaAuthentication;
        this.decryptAccessToken = decryptAccessToken;
        this.getQemotionLang = getQemotionLang;
        this.isArcaUser = isArcaUser;
        this.ddpServiceDeactivatedDisplay = ddpServiceDeactivatedDisplay;
        this.showPredictions = showPredictions;
        this.showBatteryPostCrash = showBatteryPostCrash;
        var nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        this.isTechProfil = isTechProfil;
        this.isInfoFicEnabled = isInfoFicEnabled;
        this.hasCnrRole = hasCnrRole;
        this.showEcoValueParts = showEcoValueParts;
        this.hasAsomDocumentAccess = hasAsomDocumentAccess;
        this.getStandardExchangeValidation = getStandardExchangeValidation;
        this.diagNoiseAccess = diagNoiseAccess;
        this.isNDChatBotEnabled = isNDChatBotEnabled;
        this.isChangeUsageCountryAuthorized = isChangeUsageCountryAuthorized;
        /**
         *  @description merge deeply to array object base on a keyValue --> by _.lodash
         * @param array1
         * @param array2
         * @param keyValue
         * @returns new mergedArray
         */
        function arrayMerger(array1, array2, keyValue) {
            return _(array1) // start sequence
                .keyBy(keyValue) // create a dictionary of the 1st array
                .merge(_.keyBy(array2, keyValue)) // create a dictionary of the 2nd array, and merge it to the 1st
                .values() // turn the combined dictionary to array
                .value(); // get the value (array) out of the sequence
        }

        /**
         * @desc getPriceToDisplay
         * @param centralPrice
         * @param centralCurrency
         * @param dmsPrice
         * @param countryCode
         * @param parts is optional when not defined then use central price
         * @returns {string}
         */
        function getPriceToDisplay(centralPrice, dmsPrice) {
            var priceString;
            priceString = "";
            if (dmsPrice && dmsPrice !== null) {
                priceString = dmsPrice.toFixed(2).toString();
            } else {
                if (centralPrice) {
                    priceString = centralPrice.toFixed(2).toString();
                }
                else {
                    priceString = "-";
                }
            }
            return priceString;
        }

        /**
         * @name getCurrencyForItem
         * @desc get currency from cacheService
         * @returns {string}
         */
        function getCurrencyForItem(dms) {
            var country = getProfile().country;
            var countryExceptionArray = globalConstant.countryCurrencyException;
            if ((countryExceptionArray.indexOf(country) != -1) && dms) {
                return "";
            } else {
                return CacheService.getObject(CacheConstants.currency)
            }
        }

        function getCurrencyFromItems(parts) {
            var currency = "";
            var userContext = CacheService.getUserContext();
            var itemWithDatahubCurrency = contryExceptionArray.indexOf(userContext.countryCode);
            if (itemWithDatahubCurrency == -1) { // standard country
                if (parts) {
                    parts.forEach(function (item) {
                        if (item.currency) {
                            currency = item.currency;
                        }
                    });
                }
            }
            return currency;
        }

        /**
         * Check if connected user is PARTSHOP (magasin)
         */

        // U SHOULD NOT USE THIS FUNCTION THEY ARE NOT UP TO DATE
        function isPartShop(profile) {
            return (profile && profile.roleActive === "PARTSHOP") ? true : false; // magasin comptoir
        }

        // U SHOULD NOT USE THIS FUNCTION THEY ARE NOT UP TO DATE
        function isWorkShop(profile) {
            return (profile && profile.roleActive === "WORKSHOP") ? true : false; // magasin comptoir
        }

        // U SHOULD NOT USE THIS FUNCTION THEY ARE NOT UP TO DATE
        function isWorkShopPartShop(profile) {
            return (profile && profile.roleActive === "WORKSHOP_PARTSHOP") ? true : false; // magasin comptoir
        }

        /**
         * Check if connected user is ADMIN_CORPORATE (admin corporate -> hight level)
         */
        function isCorporateUser(profile) {
            return (profile && profile.roleActive === "ADMIN_CORPORATE") ? true : false;
        }

        /**
         * Check if connected user is ADMIN_CORPORATE (admin country -> medium level)
         */
        function isCountryUser(profile) {
            return (profile && profile.roleActive === "ADMIN_COUNTRY") ? true : false;
        }

        /**
         * Check if connected user is ADMIN (admin business -> low-level)
         */
        function isBusinessUser(profile) {
            return (profile && profile.roleActive === "ADMIN") ? true : false;
        }


        function getUserRoles(profile) {
            var roles = {};
            if (profile) {
                roles.isCorporate = (profile && profile.roleActive === "ADMIN_CORPORATE") ? true : false;
                roles.isCountry = (profile && profile.roleActive === "ADMIN_COUNTRY") ? true : false;
                roles.isBusiness = (profile && profile.roleActive === "ADMIN") ? true : false;
            }
            return roles;
        }

        /**
         * reset Field (set empty value)
         */
        function resetField(field) {
            var fieldResult;
            if (field.length > 0) {
                fieldResult = "";
            }
            return fieldResult;
        }


        /**
         * Return true if user is admin (corporate, country or business)
         **/
        function userIsAdmin(profile) {
            var roles = getUserRoles(profile);
            return roles.isCorporate || roles.isCountry || roles.isBusiness;
        }


        function clone(obj) {
            try {
                var copy = JSON.parse(JSON.stringify(obj));
            } catch (ex) {
                console.log("problem copy");
            }
            return copy;
        }

        function toTitleCase(str) {
            if (!str) {
                return;
            }
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        /**
         * Remove the '.' char on a decimal value if it's the last char.
         * @param textNumber
         * @returns {string}
         */
        function formatDecimal(textNumber) {
            if (textNumber.charAt(textNumber.length - 1) == '.') {
                textNumber = textNumber.substring(0, textNumber.length - 1);
            }
            return textNumber;
        }


        /**
         * When call some WS with $q.all, check if one of response has error
         * @param responses
         * @returns {boolean}
         */
        function responseHasError(responses) {
            var hasErrors = false;
            _.forOwn(responses, function (value, key) {
                if (responses[key].errorCode) {
                    hasErrors = true;
                }
            });
            return hasErrors;
        }


        function getProfile() {
            return CacheService.getObject(CacheConstants.profil);
        }



        function splitList(array, chunk) {
            var i, j, tempArray = [];
            for (i = 0, j = array.length; i < j; i += chunk) {
                tempArray.push(array.slice(i, i + chunk));
            }
            return tempArray;
        }

        function getSearchParameters() {
            var prmstr = window.location.search.substr(1);
            return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
        }

        function transformToAssocArray(prmstr) {
            var params = {};
            var prmarr = prmstr.split("&");
            for (var i = 0; i < prmarr.length; i++) {
                var tmparr = prmarr[i].split("=");
                params[tmparr[0]] = tmparr[1];
            }
            return params;
        }

        function manageLoginError(errMsg) {
            var msgError = $translate.instant(errMsg);
            toastr.error(msgError);
            event.preventDefault();
            CloudFrontService.removeAccessCookies();
            CacheService.clearAll();
            $state.go('/');
        }

        function isEmpty(str) {
            return (!str || 0 === str.length);
        }

        function replaceEmptyString(str, replacedString) {
            if (str && str.length > 0) {
                return str;
            } else {
                return replacedString;
            }
        }

        function isEmptyNumber(num) {
            return !num || 0 === num.toString().length;
        }

        function replaceEmptyNumber(str, replacedString) {
            if (str && str.toString().length > 0) {
                return str;
            } else {
                return replacedString;
            }
        }

        function padStart(stringNumber, targetLength, padString) {
            targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
            padString = String((typeof padString !== 'undefined' ? padString : ' '));
            if (stringNumber.length > targetLength) {
                return stringNumber;
            }
            else {
                targetLength = targetLength - stringNumber.length;
                if (targetLength > padString.length) {
                    padString += repeat(padString, targetLength / padString.length); //append to original to ensure we are longer than needed
                }
                return padString.slice(0, targetLength) + stringNumber;
            }
        }

        function repeat(numberRepeat, count) {
            if (numberRepeat == null) {
                throw new TypeError('can\'t convert ' + numberRepeat + ' to object');
            }
            var str = '' + numberRepeat;
            count = +count;
            if (count != count) {
                count = 0;
            }
            if (count < 0) {
                throw new RangeError('repeat count must be non-negative');
            }
            if (count == Infinity) {
                throw new RangeError('repeat count must be less than infinity');
            }
            count = Math.floor(count);
            if (str.length == 0 || count == 0) {
                return '';
            }
            // Ensuring count is a 31-bit integer allows us to heavily optimize the
            // main part. But anyway, most current (August 2014) browsers can't handle
            // strings 1 << 28 chars or longer, so:
            if (str.length * count >= 1 << 28) {
                throw new RangeError('repeat count must not overflow maximum string size');
            }
            var rpt = '';
            for (var i = 0; i < count; i++) {
                rpt += str;
            }
            return rpt;
        }

        function customHttpDelete(url, data) {
            var req = {
                method: 'DELETE',
                url: configConstantes.baseUrlBack + configConstantes.apiBack + url,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            return $http(req);
        }

        function setErrorFrame(id) {
            var inputToFrame = angular.element(document.querySelector(id));
            inputToFrame.addClass('errorFrame');
        }

        function resetErrorFrame(id) {
            var inputToReset = angular.element(document.querySelector(id));
            inputToReset.removeClass('errorFrame');
        }

        function scrollTop(id) {
            $('html, body').animate({ scrollTop: $(id).offset().top - 42 }, 100);
        }

        /**
        * @desc This function aims to set the drop-down menu to a specific position in order to cut off the Angular material process
        * @param {String} key sent in html and it corresponds to the div id
        * @param {number} defaultIncrement expressed in pixels, corresponds to the default increment
        * @param {number} indexPosition expressed in pixels, corresponds to the reference index
        * @param {number} positionFirstCase expressed in pixels, corresponds to the incrementation if the position is lower than the index
        * @param {number} positionSecondCase expressed in pixels, corresponds to the incrementation if the position is higher than the index
        *
        */
        function fixDropDownMenu(key, defaultIncrement, indexPosition, positionFirstCase, positionSecondCase) {
            var elemSelected = document.getElementById(key);
            var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
            var topContainer;
            positionOfElem + defaultIncrement + "px";
            if (positionOfElem < indexPosition) {
                topContainer = positionOfElem + positionFirstCase + "px";
            } else {
                topContainer = positionOfElem + positionSecondCase + "px";
            }
            setTimeout(function () {
                $(".my-container").css({ top: topContainer });
            }, 50);
        }
        /**
         * @desc function used to select the tab on which you should be redirected
         * @param {*String} tab String from function param in html
         * @return return an index used in a fonction to select the correct tab
         */
        function extendPathWithTabToRedirect(tab) {
            switch (tab) {
                case globalConstant.details:
                    return { tab: 0 };
                case globalConstant.replacement:
                    return { tab: 1 };
                case globalConstant.applicability:
                    return { tab: 2 };
            }
        }

        /**
         * @desc if Array.from() method is not supported by IE 11, this creates a polyfill
         * @param
         * @returns {*}
         */
        function createArrayObject() {

            Array.from = (function () {
                var toStr = Object.prototype.toString;
                var isCallable = function (fn) {
                    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
                };
                var toInteger = function (value) {
                    var number = Number(value);
                    if (isNaN(number)) { return 0; }
                    if (number === 0 || !isFinite(number)) { return number; }
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function (value) {
                    var len = toInteger(value);
                    return Math.min(Math.max(len, 0), maxSafeInteger);
                };

                // The length property of the from method is 1.
                return function from(arrayLike/*, mapFn, thisArg */) {
                    // 1. Let C be the this value.
                    var C = this;

                    // 2. Let items be ToObject(arrayLike).
                    var items = Object(arrayLike);

                    // 3. ReturnIfAbrupt(items).
                    if (arrayLike == null) {
                        throw new TypeError('Array.from requires an array-like object - not null or undefined');
                    }

                    // 4. If mapfn is undefined, then let mapping be false.
                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                    var T;
                    if (typeof mapFn !== 'undefined') {
                        // 5. else
                        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                        if (!isCallable(mapFn)) {
                            throw new TypeError('Array.from: when provided, the second argument must be a function');
                        }

                        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }

                    // 10. Let lenValue be Get(items, "length").
                    // 11. Let len be ToLength(lenValue).
                    var len = toLength(items.length);

                    // 13. If IsConstructor(C) is true, then
                    // 13. a. Let A be the result of calling the [[Construct]] internal method
                    // of C with an argument list containing the single item len.
                    // 14. a. Else, Let A be ArrayCreate(len).
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                    // 16. Let k be 0.
                    var k = 0;
                    // 17. Repeat, while k < len… (also steps a - h)
                    var kValue;
                    while (k < len) {
                        kValue = items[k];
                        if (mapFn) {
                            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        } else {
                            A[k] = kValue;
                        }
                        k += 1;
                    }
                    // 18. Let putStatus be Put(A, "length", len, true).
                    A.length = len;
                    // 20. Return A.
                    return A;
                };
            }());

        }

        function isTraceKnownUser(user) {
            var user = CacheService.getObject(CacheConstants.profil);
            if (!user) return false;
            var pilotCountries = ['NL','DE','FR','CZ','HR','RS','SI','BE','AT','CH','HU','PL','SK','PT','ES','DK','SE','IE','GB','IT','TR','BG','RO','UA','CN','AU','KR','ZA','IN','AR','BR','CO','MX','MA'];
            // var pilotDealers = ['00000709']
            var hasValidCountry = user.country && pilotCountries.includes(user.country.toUpperCase());
            var hasValidRole = user.roles && !_.isEmpty(user.roles) &&
                user.roles.map(function (e) { return e.toUpperCase(); })
                    .includes(AlertsConstants.newAlertButtonRole.toUpperCase());
            // if (user.country && user.country.toUpperCase() === 'FR') {
            //     var hasValidDealer = user.dealerId && pilotDealers.includes(user.dealerId);
            //     return hasValidRole && hasValidDealer;
            // }
            return hasValidRole && hasValidCountry;
        }

        function isTraceKnownUserINT() {
            const user = CacheService.getObject(CacheConstants.profil);
            if (!user) return false;
            if(user && user.userType && user.userType === 'RNET') {
                return true;
            }
            return false;
        }
        
        /**
        * @description check if user is Authoried for Red Button
        */
        function isRedButtonAuthorized() {
            var user = CacheService.getObject(CacheConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var isRedButtonAuthorized = false;
            var isPilotCoutry = false;
            var isAccessCountry = false;
            var pilotCoutryCodes = ['CZ', 'HU', 'PL', 'SK', 'BR', 'MA', 'IL', 'HR', 'RS', 'SI', 'AL', 'BA',
                'AU', 'IN', 'LK', 'NP', 'RU', 'AM', 'BY', 'KZ', 'AZ', 'GE', 'ZA', 'TR', 'UA', 'EE', 'LT', 'LV', 'GB', 'IE', 'CY', 'MT',
                'AR', 'BO', 'CL', 'PY', 'UY', 'BM', 'CO', 'CR', 'CW', 'DO', 'EC', 'SV', 'GT', 'HN', 'NI', 'PA', 'PE', 'TT', 'VE', 'BH', 'EG', 'ET', 'IQ', 'JO', 'KW', 'LB', 'LY', 'OM', 'PS', 'QA', 'SA', 'SY', 'AE', 'MD',
                'RO', 'DK', 'FI', 'IS', 'NO', 'SE', 'GF', 'GP', 'MQ', 'NC', 'PF', 'RE', 'YT',
                'DZ', 'BN', 'HK', 'ID', 'JP', 'MY', 'NZ', 'SG', 'TW', 'TH', 'VN', 'ES', 'PT', 'IR', 'MX', 'BG', 'KR', 'AT', 'CH', 'GR', 'AO', 'BF', 'BI', 'BJ', 'CD', 'CG', 'CI', 'CM', 'CU', 'CV', 'DJ', 'GA', 'GH', 'GM', 'GN', 'KE', 'KM', 'LR', 'MG', 'ML', 'MR', 'MU', 'MW', 'MZ', 'NE', 'NG', 'PM', 'RW', 'SC', 'SD', 'SN', 'TG', 'TN', 'TZ', 'UG', 'ZM', 'ZW'];

            var familyBrandCode = ['X06', 'X09', 'X32', 'X33', 'X35', 'X38', 'X43', 'X44', 'X45', 'X47', 'X64', 'X65', 'X70', 'X73', 'X76', 'X77', 'X81', 'X83', 'X84', 'X85', 'X87', 'X90', 'X91', 'X95', 'X98'];
            var accessUserCountryCodes = ['BE', 'IT'];
            var isLuxembourgCtry = 'LU';
            var country = user.country.toUpperCase();            
            if (pilotCoutryCodes.includes(country)) {
                isPilotCoutry = pilotCoutryCodes.indexOf(country) != -1;
            }
            else {
                isAccessCountry = accessUserCountryCodes.indexOf(country) != -1;
            }

            var isActisProfile = isActisProfil(user);
            // var isFrPilotDealer = isFrenchPilotDealer(user);
            if (((isActisProfile && (isPilotCoutry)) || ((isAccessCountry || country === isLuxembourgCtry) && (!_.isEmpty(contextCarRequest) && !_.isEmpty(contextCarRequest.families) && !_.isEmpty(contextCarRequest.families.familyVehicle) && !familyBrandCode.includes(contextCarRequest.families.familyVehicle[0])))) && user.userType === "RNET") {
                isRedButtonAuthorized = true;
            }

            return isRedButtonAuthorized;
        }

        function isChangeUsageCountryAuthorized() {
            var user = CacheService.getObject(CacheConstants.profil);
            var hasValidRole = !!(user && user.roles && user.roles.some(function (role) {
                var normalizedRole = role.toUpperCase();
                return normalizedRole === ActisConstantes.ppx_assist_tech_n2.toUpperCase() ||
                    normalizedRole === rLinkConstant.arcaCnrCustomerCare.toUpperCase();
            }));
            return hasValidRole;
        }

        function isNDChatBotEnabled() {
            if (!JSON.parse(configConstantes.isNDAssistantEnabled) || nissanUserURL) {
                return false;
            }
            const profil = CacheService.getObject(CacheConstants.profil);
            const carContext = CacheService.getCarContext();
            if (!carContext || !carContext.vin) {
                return false;
            }
            const PERMITTED_CHATBOT_ROLES = [DocPrivConstants.docPrivPopinVinProfile, DocPrivConstants.docprivStdProfile];
            return isArcaUser() &&
                profil &&
                !_.isEmpty(profil.roles) &&
                PERMITTED_CHATBOT_ROLES.some(role => profil.roles.includes(role));
        }

        function isChatBotDealerAccess() {
            var userProfil = CacheService.getUserProfile();
            var result = false;
            var chatBotDealerId = ['0100111001010100001', '00000951', '00000980', '00001262', '00000856', '00000154', '00000714', '00000175', '00000555', '00000556', '00000430', '00000149', '00000593', '00000403', '00000862', '00000252', '00000702', '00000730', '00001154', '00001256', '00001268', '00001269', '00001258', '00001263', '00001152', '00000851', '00001314', '00001318', '25003137', '00001260', '00001308', '00000852', '00000853', '00000874', '00001255'];
            if (userProfil && userProfil.userType == "RNET" && chatBotDealerId.includes(userProfil.dealerId)) {
                result = true;
            }
            return result;
        }

        function isFrenchPilotDealer(user) {
            var result = false;
            var frPilotDealerId = ['00000150', '00000152', '00000701', '00000010', '00000953', '00000060', '00000423', '00000412', '00001306', '00001161', '00000602', '00000552', '00000856', '00000296'];
            if (user.country == 'FR' && frPilotDealerId.includes(user.dealerId)) {
                result = true;
            }
            return result;
        }

        function isActisProfil(user) {
            var carContext = CacheService.getCarContext();
            var result = false;

                if (user.roles&& user.roles.length > 0) {
                    angular.forEach(user.roles, function (value) {
                        if (value.toLowerCase() === ActisConstantes.actis_okta.toLowerCase()) {
                            result = true;
                        }
                    });
                
            }
            
            return result;
        }

        function isVespaProfil(user) {
            var reprogrammingHistoryCheck = false;
            var carContext = CacheService.getCarContext();
            var diagCond = carContext && carContext.typeMD && (carContext.typeMD.includes('B3') || carContext.typeMD.includes('ADT'));
            if (user && (user.userType == "RNET" || user.userType == "ARCA") && diagCond && !_.isEmpty(user.roles) && (user.roles.includes(ActisConstantes.ppx_assist_tech_corp) || user.roles.includes(ActisConstantes.ppx_assist_tech_n1) || user.roles.includes(ActisConstantes.ppx_assist_tech_n2))) {
                reprogrammingHistoryCheck = true;
            }
            return reprogrammingHistoryCheck;
        }

        function vehicleInformationDisplay(user) {

            var vehicleInformationEnable = false;
            if (user && (user.userType == "ARCA" || user.userType == "RNET" || (user.userType == "ASOM" && $rootScope.asomDocList['CS']))) {
                vehicleInformationEnable = true;
            }
            return vehicleInformationEnable;
        }
        function adasEhorizonInformationDisplay(user) { 
            var adasEhorizonInformationEnable = false;
            if (user && !_.isEmpty(user.roles)) {
                user.roles = user.roles.map(function (e) {
                    return e.toUpperCase()
                });
            }
            if (!nissanUserURL && (user && ((user.userType == "ARCA") || (user.userType == "RNET") || (user.userType == "ASOM" && $rootScope.asomDocList['CS'])))) {
                adasEhorizonInformationEnable = true;
            } 

            return adasEhorizonInformationEnable;
        }

        function csrButtonShow(user) {
            var csrButtonEnable = false;
            if ((user && user.userType == "ARCA") && (user.roles.includes(ActisConstantes.ppx_assist_tech_corp) || user.roles.includes(ActisConstantes.ppx_assist_tech_n2))) {
                csrButtonEnable = true;
            }
            return csrButtonEnable;
        }

        function hasCnrRole(userProfile) {
            var roles = userProfile && userProfile.roles ? userProfile.roles : [];
            var allowedRoles = [
                rLinkConstant.arcaCnrCustomerCare,
                rLinkConstant.rnetCnrCustomerCare,
                rLinkConstant.rnetCnrDealer
            ];
            if (!roles) return false;
            return roles.some(function (role) {
                return allowedRoles.some(function (allowed) {
                    return role.toUpperCase() === allowed.toUpperCase();
                });
            });
        }


        function vegasTabDisplay(user) {
            var isVegasTabEnabled = false;
            if (user && ((user.userType == "ARCA") || (user.userType == "RNET") || (user.userType == "ASOM" && $rootScope.asomDocList['CS']))) {
                isVegasTabEnabled = true;
            }
            return isVegasTabEnabled;
        }

        function ddpHelpPageDisplay(user) {
            
            var isHelpTabEnabled = false;
            if (user && ((user.userType == "ARCA") || (user.userType == "RNET") || (user.userType == "ASOM" && $rootScope.asomDocList['CS']))) {
                isHelpTabEnabled = true;
            }
            return isHelpTabEnabled;
        }

        function ddpAuditTabDisplay(profile){
            var isAuditTabEnabled = false;
            if(profile && profile.userType == "ARCA" && profile.roles.includes(rLinkConstant.ddpAdmin)){
                isAuditTabEnabled = true;
            }
            return isAuditTabEnabled;
        }

        function ddpServiceDeactivatedDisplay(user){
            var enableDeactivateService = false;
            if (user) {
                if (!_.isEmpty(user.roles)) {
                    user.roles = user.roles.map(function (e) {
                        return e.toUpperCase()
                    });
                }
            }
            if(!nissanUserURL && user && (!_.isEmpty(user.userType) && (user.userType == "ARCA" && !_.isEmpty(user.roles) && user.roles.includes(rLinkConstant.arcaCnrCustomerCare)) || (user.userType == "RNET" && !_.isEmpty(user.roles) && user.roles.includes(rLinkConstant.rnetCnrCustomerCare)))){
                enableDeactivateService = true;
            }
            return enableDeactivateService;
        }

        function isR2aStockCountry() {
            var isR2aStockCountry = false;
            var user = CacheService.getObject(CacheConstants.profil);
            var R2aStockCountries = ['FR', 'ES', 'IT', 'AT', 'NL', 'DE', 'GB', 'TR', 'PT', 'BE', 'PL', 'CH'];
            if (user && user.country) {
                if (R2aStockCountries.includes(user.country)) {
                    isR2aStockCountry = true;
                }
            }
            return isR2aStockCountry;
        }
        function isUserFromSparcCountry() {
            var isCountrySparc = false;
            var user = CacheService.getObject(CacheConstants.profil);
            var sparcCountries = ['AR', 'AT', 'BE', 'BR', 'CH', 'CN', 'CO', 'CZ', 'DE', 'DZ', 'ES', 'FR', 'GB', 'IN', 'IT', 'KR', 'MA', 'NL', 'PL', 'PT', 'RO', 'RU', 'SK', 'TR', 'UA'];
            if (user && user.country) {
                if (sparcCountries.includes(user.country)) {
                    isCountrySparc = true;
                }
            }
            return isCountrySparc;
        }

        function getUserType() {
            var user = CacheService.getObject(CacheConstants.profil);
            return user.userType;
        }

        function isIndependentUser() {
            var user = CacheService.getObject(CacheConstants.profil);
            if (user && user.userType == "ASOM" & user.roles[0] == CarSearchConstants.ppxIndependentUser) {
                return true;
            }
            else
                return false;
        }


        function checkAsomValidDocAcess() {
            var profile = getProfile();
            var isAsomValidDocAccess = 'false';
            if (profile.isAsomValidDocAccess) {

                return profile.isAsomValidDocAccess
            }

            return isAsomValidDocAccess;
        }

        function getTokenBalance() {
            var tokenBalance = 0;
            if ((CacheService.getObject(CacheConstants.tokenBalance))) {
                var decrypted = CryptoService.AES.decrypt((CacheService.getObject(CacheConstants.tokenBalance)), CacheConstants.encryptedValue);
                tokenBalance = parseInt((decrypted.toString(CryptoService.enc.Utf8)));
            }

            return tokenBalance;
        }

        function fixedToDecimal(data, digit) {

            if (typeof data === 'number') {
                return data.toFixed(digit);
            } else {
                return parseFloat(data).toFixed(digit);
            }
        }
        function isInterventionAccess() {
            var result = false;
            var user = CacheService.getObject(CacheConstants.profil);
            var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
            var brandComputedCode = ['APL15', 'BRA15'];
            if (user && (user.userType == "ARCA" || (user.userType == "RNET" && contextCarRequest && contextCarRequest.brandComputed && !brandComputedCode.includes(contextCarRequest.brandComputed)))) {
                result = true;
            }
            return result;
        }

        function diagNoiseAccess(){
        let result = false;
        const userProfil = CacheService.getUserProfile();
        const isArcaUserProf = MainMetierService.isArcaUser();
        const isRnetUser = MainMetierService.isRnetUserType(userProfil.userType);
        const diagNoiseCountries = ['BE','FR','CH','GF','PF','GP','LU','MQ','RE','PM','AD','AR','CO','DK','FI','IE','MX','MA','NO','ES','GB','AT','DE','IT','PT','BR','CV','HR','IN','NL','SE','BO','CL','CU','DO','EC','GR','GT','KR','NI','PA','PE','PL','PY','RO','SI','SV','TR','UY','VE','HN','AE','AU','BA','BD','CN','CR','CS','CW','CY','CZ','DZ','EE','EG','HK','IL','IS','JP','LK','LT','MD','MG','MK','MT','MU','MY','NZ','RS','SG','SK','TN','TW','UA','YT','YU','ZA'];
        if ((isArcaUserProf || (isRnetUser && userProfil && userProfil.country && diagNoiseCountries.includes(userProfil.country)))) {      
              result = true;
        }
        return result;
        }

        function isDealerAuthorised() {
            var isDealerValid = false;
            var dealerId = getProfile() ? getProfile().dealerId : "";
            var dealersList = ['72422818', '72439007', '38000369', '38001397', '27631768', '27615599', '27615032', '27616550', '27630194', '27611974', '27611069', '27615842', '27613030', '27616016', '27611059', '27641221', '27612013', '27615132', '27631077', '04000012', '04000128', '90179293', '75601031', '05600204', '05640003', '75612226', '75665075', '72405065', '72416514', '62013999', '62013850', '62013769'];
            if ((getProfile() && getProfile().country && (getProfile().country.toUpperCase() === 'FR' || getProfile().country.toUpperCase() === 'IT'
                || getProfile().country.toUpperCase() === 'AT' || getProfile().country.toUpperCase() === 'DE' || getProfile().country.toUpperCase() === 'CH' || getProfile().country.toUpperCase() === 'BE'))
                || dealersList.includes(dealerId)) {
                isDealerValid = true;
            }
            return isDealerValid;
        }

        function isNonDMSDealerAuthorised(isDealerValid) {
            var isDealerValid = false;
            var dealerId = getProfile() ? getProfile().dealerId : "";
            var isNonDmsTestingDealerId = JSON.parse(configConstantes.isNonDmsTestingDealerId);
            var nonDmsDealerId = '75699080';
            var dealersList = ['25002389', '25002262', '00059121', '00030243', '00030225', '00030218', '00030152', '00030105', '05625007', '05636010', '05600532', '05600614'];
            if ((isNonDmsTestingDealerId && (nonDmsDealerId == dealerId)) || dealersList.includes(dealerId) || (getProfile() && getProfile().country && (getProfile().country.toUpperCase() === 'FR' || getProfile().country.toUpperCase() === 'DE' || getProfile().country.toUpperCase() === 'BE'))) {
                isDealerValid = true;
            }
            return isDealerValid;
        }

        function isTestingDealers(dealerId) {
            var isDealerValid = true; //enable new text search for all
            /* var isDealerValid = false;
            var dealersTestList = ['00000150','00000152','00000701','00000010','00000953','00000060','00000423','00000412','00001306','00001161','00000602','00000552','00000856','00000296','20318041','20318248','00017007','70300003', '27613838', '27614928','00900011','00900001'];

            if (dealersTestList.includes(dealerId)) {
                isDealerValid = true;
            } */
            return isDealerValid;
        }

        function isRemoteDiagDealers() {
            var isDiagDealerValid = false;
            var user = getProfile();
            var rnetAllowedCountries = ['FR','IT','UK','IE','DE','ES','GB','PL','CZ','SK','BE','LU','NL','RO','CH','PT','AT','DK','SE','NO','IS','MQ','GF','IE','HU','LT','LV','EE','RE','GP','HR','SI','MT','IL','BG','RS','KR','TR','BR','MX','AR','CO','IN'];
            var country = user.country.toUpperCase();
            if (user && user.userType && ((user.userType == "ARCA") || ((user.userType == "RNET") && ((_.includes(rnetAllowedCountries,country)) || (!_.isEmpty(user.roles) && user.roles.includes(ActisConstantes.ppx_assist_tech_n1)))))) {
                isDiagDealerValid = true;
            }
            return isDiagDealerValid;
        }

        function isSymptomAiSearchEnable() {
            var isSymptomAiSearchValid = false;
            var user = getProfile();
            if (user && user.userType && ((user.userType == "ARCA") || (user.userType == "RNET"))) {
                isSymptomAiSearchValid = true;
            }
            return isSymptomAiSearchValid; 
        }

        /**
     * Check if country is targeted
     * @param {String} country (i.e. FR, GB, CN)
     * @returns {boolean}
     */
        function isCountryTargeted(country) {
            var user = CacheService.getObject(CacheConstants.profil);
            return user.country === country;
        }

        function isPlannedAssistance(){
            var user = CacheService.getObject(CacheConstants.profil);
            if (user && (user.userType === "ARCA" || user.userType === "RNET")) {
                return true;
            }
            return false;
        }
        function copyToClipboard(reference) {
            navigator.clipboard.writeText(reference).then(function() {
                toastr.info($translate.instant("COPIED"));
            }).catch(function(error) {
                toastr.error($translate.instant("FAILED_TO_COPY"));
            });
        }
        function isOktaAuthentication(){
            var validAccess = false;
            var userType = CacheService.getUserType();
            if(userType && (userType.toLowerCase() == "arca" || (userType.toLowerCase() == "rnet"))){
                validAccess = true;
            }
            return validAccess;
        }

        function decryptAccessToken(encryptedToken){
          var secretKey = LoginConstants.ndApiSecret; 
          var initVector = LoginConstants.ndApiVector;
          var key = CryptoService.enc.Utf8.parse(secretKey);
          var iv = CryptoService.enc.Utf8.parse(initVector);
          encryptedToken = encryptedToken.replace(/ /g, '+');
          var decrypted = CryptoService.AES.decrypt(encryptedToken, key, {
              iv: iv,
              mode: CryptoService.mode.CBC,
              padding: CryptoService.pad.Pkcs7
          });
          var decryptedStr = CryptoService.enc.Utf8.stringify(decrypted);
          return decryptedStr;
        }

        function getQemotionLang() {
            var profil = CacheService.getObject(CacheConstants.profil);
            var lang = profil && profil.documentationFirstLanguage.code ? profil.documentationFirstLanguage.code : 'en';
            return lang;
        }

        function isArcaUser(){
            var profil = CacheService.getObject(CacheConstants.profil);
            var userType = CacheService.getUserType();
            var returnValue = false;
            if(userType && userType.toLowerCase() == "arca" && !_.isEmpty(profil.roles) && profil.roles.includes(CarSearchConstants.ppxCorporateUser)) {
                returnValue = true;
            }
            return returnValue;
        }
        
        function showPredictions(){
           var profil = CacheService.getObject(CacheConstants.profil);
            var returnValue = false; 
            const pilotDealers = ['00900011','00900001','00001314','00000889','00001268','00000852','00001355','00000403','00000702','00026219','00000003','00000595','00000401'];
            var isRnetAllowed =
                profil &&
                profil.userType === 'RNET' &&
                (
                    (!_.isEmpty(profil.roles) && profil.roles.includes(ActisConstantes.ppx_assist_tech_n1)) ||
                    (profil.dealerId && pilotDealers.includes(profil.dealerId))
                );

            if (profil && (profil.userType === 'ARCA' || isRnetAllowed)) {
                returnValue = true;
            }
            return returnValue;
        }

        function showBatteryPostCrash() {
            const profil = CacheService.getObject(CacheConstants.profil);
            const carSearchContext = CacheService.getCarContext();
            if (profil && (profil.userType === 'ARCA' || profil.userType === 'RNET') &&
                carSearchContext && carSearchContext.bin && carSearchContext.fixedCriterias &&
                typeof carSearchContext.fixedCriterias === 'object') {
                const families007 = ['X1316', 'X1317','X1325','XCB', 'HCB'];
                const families008 = ['XCB', 'HCB'];
                const families019 = ['ELEC'];

                const fixedCriterias = carSearchContext.fixedCriterias;
                const criteria007 = fixedCriterias['007'];
                const criteria008 = fixedCriterias['008'];
                const criteriaF88 = fixedCriterias['F88'];
                const criteria019 = fixedCriterias['019'];

                // XCB/BCB/C1AH2
                if (criteria007 === 'XCB' && criteria008 === 'BCB' && criteriaF88 === 'C1AH2') {
                    return true;
                }
                
                if (criteria007 === 'XCB') {
                    return criteria008 === 'HCB';
                }

                // XFK/ELEC
                if (criteria007 === 'XFK') {
                    return criteria019 === 'ELEC';
                }

                const match007 = families007.includes(criteria007);
                const match008 = families008.includes(criteria008);
                const match019 = families019.includes(criteria019);

                if (match007 || match008 || match019) {
                    return true;
                }
            }

            return false;
        }


        function isTechProfil() {
            var techProfile = false;
            var userProfil = CacheService.getUserProfile();
            if ((userProfil && (userProfil.userType == "ARCA" || userProfil.userType == "RNET")) && (!_.isEmpty(userProfil.roles) && (userProfil.roles.includes(ActisConstantes.ppx_assist_tech_corp) || userProfil.roles.includes(ActisConstantes.ppx_assist_tech_n1) || userProfil.roles.includes(ActisConstantes.ppx_assist_tech_n2)))) {
                techProfile = true;
            }
            return techProfile;
        }

        function isValidUserForInfoFic(userProfil) {
            if (!userProfil || !userProfil.country) {
                return false;
            }
            
            const isValidUserType = userProfil.userType === "ARCA" || userProfil.userType === "RNET";
            const isCountryEnabled = CarSearchConstants.infoFicEnabledCountries.includes(userProfil.country);
            
            return isValidUserType && isCountryEnabled;
        }

        function getDeliveryDateSource(carContext) {
            if (!carContext) {
                return null;
            }

            if (carContext.bvmExtraFields && _.has(carContext.bvmExtraFields, 'customerDeliveryDate')) {
                return carContext.bvmExtraFields.customerDeliveryDate;
            }

            if (carContext.variableCriterias && carContext.variableCriterias.APVDT1) {
                return carContext.variableCriterias.APVDT1;
            }

            return null;
        }

        function isWithinValidDateRange(dateSource) {
            if (!dateSource) {
                return false;
            }

            const deliveryDate = new Date(dateSource);
            if (isNaN(deliveryDate.getTime())) {
                return false;
            }

            const MAX_DAYS_SINCE_DELIVERY = 92;
            const diffDays = (new Date() - deliveryDate) / (1000 * 60 * 60 * 24);
            return diffDays >= 0 && diffDays <= MAX_DAYS_SINCE_DELIVERY;
        }

        function isInfoFicEnabled() {
            const userProfil = CacheService.getUserProfile();
            const carContext = CacheService.getCarContext();

            if (!isValidUserForInfoFic(userProfil)) {
                return false;
            }

            const dateSource = getDeliveryDateSource(carContext);
            return isWithinValidDateRange(dateSource);
        }

        function showEcoValueParts(){
            const profil = CacheService.getObject(CacheConstants.profil);
            let returnValue = false; 
            const pilotDealer = ['00900001','00001305'];
            if(profil && ((profil.userType === 'RNET' && pilotDealer.includes(profil.dealerId)) || (profil.userType === 'ARCA'))){ 
                returnValue = true;
            }
            return returnValue;
        }


        function hasAsomDocumentAccess(documentType, isIndependentUserFlag) {
            if (!isIndependentUserFlag) {
                return true; 
            }

            try {
                const asomSubscription = CryptoService.AES.decrypt(
                    CacheService.getObject(CacheConstants.asomSubscription), 
                    CacheConstants.encryptedValue
                );
                let upadtedAsomSubscription = CacheService.getObject(CacheConstants.asomSubscriptionForAllowedVin);
                if(upadtedAsomSubscription){
                    upadtedAsomSubscription = CryptoService.AES.decrypt(
                        CacheService.getObject(CacheConstants.asomSubscriptionForAllowedVin),   
                        CacheConstants.encryptedValue
                    );
                }
                const decrypted = upadtedAsomSubscription || asomSubscription;
                let asomSubscriptions = JSON.parse(decrypted.toString(CryptoService.enc.Utf8));
                asomSubscriptions = asomSubscriptions.length > 0 ? asomSubscriptions[0] : false;
                
                if (asomSubscriptions && asomSubscriptions.documentList) {
                    return asomSubscriptions.documentList.some(function(doc) {
                        return doc.documentType === documentType;
                    });
                } else {
                    return false;
                }
            } catch (error) {
                return false;
            }
        }
    }

        function getStandardExchangeValidation(carContextRequest) {
            const hasValidStandardExchange = !!(carContextRequest && carContextRequest.standardExchange);
            
            const validation = {
                hasStandardExchange: hasValidStandardExchange,
                hasAPVNM2: hasValidStandardExchange && carContextRequest.standardExchange.APVNM2 && carContextRequest.standardExchange.APVNM2.trim() !== '',
                hasAPVNM3: hasValidStandardExchange && carContextRequest.standardExchange.APVNM3 && carContextRequest.standardExchange.APVNM3.trim() !== '',
                hasAPVNM4: hasValidStandardExchange && carContextRequest.standardExchange.APVNM4 && carContextRequest.standardExchange.APVNM4.trim() !== '',
                hasAPV002: hasValidStandardExchange && carContextRequest.standardExchange.APV002 && carContextRequest.standardExchange.APV002.trim() !== '',
                hasAPV003: hasValidStandardExchange && carContextRequest.standardExchange.APV003 && carContextRequest.standardExchange.APV003.trim() !== '',
                hasAPV004: hasValidStandardExchange && carContextRequest.standardExchange.APV004 && carContextRequest.standardExchange.APV004.trim() !== ''
            };
            
            return validation;
        }
})();

(function () {

  angular.module('phenix.core').service('RouterMetierService', RouterMetierService);

  /** @ngInject */
  function RouterMetierService(RoutesConstants) {

    this.getParams = getParams;
    this.setParams = setParams;

    this.getPreviousState = getPreviousState;
    this.setPreviousState = setPreviousState;

    this.getHome = getHome;

    var adminCountryParams = {},
      adminBusinessParams = {},
      adminUserParams = {},
      adminIpnParams = {},
      history = [];


    function getParams(target) {
      switch (target) {
        case 'user':
            return adminUserParams;
        case 'business':
            return adminBusinessParams;
        case 'country':
            return adminCountryParams;
        case 'ipn':
          return adminIpnParams;
      }
    }

    function setParams(target, params) {
      switch (target) {
        case 'user':
            adminUserParams = params;
            break;
        case 'business':
            adminBusinessParams = params;
            break;
        case 'country':
            adminCountryParams = params;
            break;
        case 'ipn':
            adminIpnParams = params;
            break;
      }
    }


    function setPreviousState(previousState) {
      history.push(previousState);
    }

    /**
     * Get the previous state and remove from list history
     * @returns {string}
     */
    function getPreviousState() {
      return history.pop();
    }


    /**
     * Get route to go when starting app
     * @returns {string|*}
     */
    function getHome() {
      return RoutesConstants.carSearch;
    }

  }
})();

(function () {
    'use strict';

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
            if (this_len === undefined || this_len > this.length) {
                this_len = this.length;
            }
            return this.substring(this_len - search.length, this_len) === search;
        };
    }

    if (!String.prototype.includes) {
        String.prototype.includes = function(search, start) {
            'use strict';
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function(valueToFind, fromIndex) {

                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(valueToFind, elementK) is true, return true.
                    if (sameValueZero(o[k], valueToFind)) {
                        return true;
                    }
                    // c. Increase k by 1.
                    k++;
                }

                // 8. Return false
                return false;
            }
        });
    }

})();

(function () {
    'use strict';
    angular.module('phenix')        
        .directive('inputClear', inputClear)
        .directive('inputClearNoMaterial', inputClearNoMaterial);

    function inputClear() {
        return {
            restrict: 'A',
            compile: function (element, attrs) {
                var color = attrs.inputClear;
                var style = color ? "color:" + color + ";" : "";
                var action = attrs.ngModel + " = ''";
                element.after(
                    '<md-button class="animate-show md-icon-button md-accent"' +
                    'ng-show="' + attrs.ngModel + '" ng-click="' + action + '"' +
                    'style="position: absolute; top: 0px; right: 15px; margin: 0px 0px;">' +
                    '<div style="' + style + '">x</div>' +
                    '</md-button>');
            }
        };
    }
    
    function inputClearNoMaterial() {
        return {
            restrict: 'A',
            compile: function (element, attrs) {
                var color = attrs.inputClearNoMaterial;
                var style = color ? "color:" + color + ";" : "";
                var action = attrs.ngModel + " = ''";
                element.after(
                    '<span class="animate-show"' +
                    'ng-show="' + attrs.ngModel + '" ng-click="' + action + '"' +
                    'style="position: absolute; margin: 3px -20px; cursor: pointer;">' +
                    '<div style="' + style + '">x</div>' +
                    '</span>');
            }
        };
    }
})();
/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
(function () {

    angular
    .module('phenix')
    .service('CryptoService', CryptoService);

    function CryptoService(){

var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof global !== 'undefined' && global.crypto) {
	        crypto = global.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && typeof require === 'function') {
	        try {
	            crypto = require('crypto');
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            var block;

	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    var tMsw;
	                    var tLsw;

	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                var Wil;
	                var Wih;

	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    Wih = Wi.high = M[offset + i * 2]     | 0;
	                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    Wil = gamma0l + Wi7l;
	                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    Wil = Wil + gamma1l;
	                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    Wil = Wil + Wi16l;
	                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            var block;

	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            var modeCreator;

	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            var finalProcessedBlocks;

	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            var wordArray;

	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            var salt;

	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        var keystream;

	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            var t;

	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            // Make sure the key length is valid (64, 128 or >= 192 bit)
	            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
	                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
	            }

	            // Extend the key according to the keying options defined in 3DES standard
	            var key1 = keyWords.slice(0, 2);
	            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
	            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(key1));
	            this._des2 = DES.createEncryptor(WordArray.create(key2));
	            this._des3 = DES.createEncryptor(WordArray.create(key3));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        for (var i = data.sigBytes - 1; i >= 0; i--) {
	            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	                data.sigBytes = i + 1;
	                break;
	            }
	        }
	    }
	};


	return CryptoJS;
}
})();

(function () {
    'use strict';

    angular
        .module('phenix.core')
        .constant('VdhConstants', {
            domain: 'renault.com',
            path: '/',
            VDH: 'vdh',
            VDH_DF_ID: 'VDH_DF_ID',
            DI: 'DI',
            restDiagFileById: '/proxy/apigee/vdh/v1/diagnostic-files',
            restDiagFileByVin: '/proxy/apigee/vdh/v1/diagnostic-files',
            restPatternsByDiagFileId: '/proxy/apigee/dai-api-ct/v1/diagnostic-files',
            restCommentsByPatternId: '/proxy/apigee/dai-api-ct/v1/patterns',
            restPhasesByFamilies: '/proxy/apigee/dai-api-ct/v1/familyPhases',
            restPredictions: '/proxy/apigee/dai/v2/predictions',
            restSysDoc: '/proxy/apidh/rest/v1/diagnosticTree',
            restReprogrammingHistory: '/proxy/apigee/after-sales-ecu-operations-traceinfo/v1/vehicles/',
            traceabilityInfo: '/traceability-information'
        });
})();

(function () {
    'use strict';

    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {

        $stateProvider.state(RoutesConstants.partRequisition, {
            url: '/partRequisition/:view/:accountId',
            templateUrl: 'app/components/partRequisition/partRequisition.template.html',
            controller: 'PartRequisitionController',
            controllerAs: 'vm',
            params: {
                partsRequisitionOptions: null,
                createNew: null
            }
        });

        $stateProvider.state(RoutesConstants.partRequisitionListDraft, {
          url: '/partRequisitionList/draft',
          templateUrl: 'app/components/partRequisition/list/draft/partRequisitionDraftList.template.html',
          controller: 'partRequisitionListDraftController',
          params: {
            data: null,
            partsRequisitionOptions: null
          },
          controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.partRequisitionListValidated, {
            url: '/partRequisitionList/validated',
            templateUrl: 'app/components/partRequisition/list/validated/partRequisitionValidatedList.template.html',
            controller: 'partRequisitionListValidatedController',
            params: {
              data: null,
              partsRequisitionOptions: null
            },
            controllerAs: 'vm'
          });

    }

})();


/**
 * initPartRequisitionController
 * @namespace Controller
 */
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('PartRequisitionController', PartRequisitionController)

    /* @ngInject */
    function PartRequisitionController($window, $scope, $q, ScrollService, PartRequisitionMetierService,
        DocumentsMetierService, toastr, PartRequisitionConstants, ShoppingCartPartsService,FileSaver,
        CacheService, CacheConstants, blockUI, $translate, $state, DmsMetierService, CarSearchMetierService,
        $rootScope, RoutesConstants, RoutingService, ShoppingCartConstants, DeleteModalService,
        DmsCustomerConstants, DealerManagerSystemeService, warningModalCustomerService, UtilsMetierService,
        SuperCartValidateService, globalConstant, SuperCartMetierService, printPdfModalService,configConstantes,MainMetierService,$mdDialog, $log, PartRequisitionWsService,$timeout) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;
        vm.partsRequisition = {};
        vm.loading = true;
        vm.isList = false;
        vm.isCreate = false;
        vm.isSearchCustomerMode = true;
        vm.dmsLoginRequired = false;

        vm.dmsLoginContainer = {};
        vm.dmsLoginContainer.username = "";
        vm.dmsLoginContainer.password = "";

        vm.isWorkshop = false;
        vm.isPartshop = false;
        vm.userProfile = null;

        vm.showOrderModeView = false;
        
        vm.orderAndSplitDetails = {};
        vm.isReplicaClicked = false; 
        var isOrderNumberChanged = false;        
        vm.isPartsReplicated = false;
        vm.constant = CacheConstants;
        vm.maxItemsLimit = 99 + " " + "max";
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.backToPrevious = backToPrevious;
        vm.savePartRequisition = savePartRequisition;
        vm.closePartRequisition = closePartRequisition;
        vm.initPartRequisition = initPartRequisition;
        vm.findPartRequisition = findPartRequisition;
        vm.onChangeUnusualSale = onChangeUnusualSale;
        vm.getStockClass = getStockClass;
        vm.onChangeAdditionalDiscount = onChangeAdditionalDiscount;
        vm.onChangeDescription = onChangeDescription;
        vm.updateOrderNumber = updateOrderNumber;
        vm.getOrderSplitDetails = getOrderSplitDetails;
        vm.ref = "";
        vm.sortBy = sortBy;
        vm.addRef = addRef;
        vm.getTypeOf = getTypeOf;
        vm.validate = validate;
        vm.onChangeOrderType = onChangeOrderType;
        vm.onChangeUsername = onChangeUsername;
        vm.onChangePassword = onChangePassword;
        vm.goToProduct = goToProduct;
        vm.checkStock = checkStock;
        vm.deleteReference = deleteReference;
        vm.dmsCustomerConstants = DmsCustomerConstants;
        vm.onUpdateIntervention = onUpdateIntervention;
        vm.getValidatePartRequisitionClass = getValidatePartRequisitionClass;
        vm.checkSetOrderTypeValue = checkSetOrderTypeValue;
        vm.goToProductPage = goToProductPage;
        vm.copyToClipboard = copyToClipboard;
        vm.printPartRequisition = printPartRequisition;
        vm.multipleOperations = multipleOperations;


        vm.loadAndRestorePartsInformationsFromDH = loadAndRestorePartsInformationsFromDH;
        // search-dms-customer component callback events / variable
        vm.defaultClientMode = false;
        vm.isDealerAvailable = false;
        vm.onSelectedCustomerCallback = onSelectedCustomerCallback;
        vm.onNewCustomerCallback = onNewCustomerCallback;
        vm.onCustomerFilledCallback = onCustomerFilledCallback;
        vm.onResetCustomerCallback = onResetCustomerCallback;
        vm.onUpdatedCustomerCallback = onUpdatedCustomerCallback;
        vm.onSetCustomerDetails = onSetCustomerDetails;

        $scope.getPriceToDisplay = getPriceToDisplay;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.onClose = onClose;
        vm.isRpartsRole = MainMetierService.isRpartsRole();
        vm.initPartFocus = initPartFocus;
        vm.isValidating = false;
        vm.formatReferenceInput = formatReferenceInput;

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/
        $rootScope.$on('bannerDataLoaded', function () {
            vm.bannerData = CarSearchMetierService.getBannerDetails();
        });
        /**
         * @name init
         * @desc instantiate when a new part Req is selected from dropdown in mainController
         */
        this.$onInit = function () {
            initPartFocus();
            vm.isCustomerFilled = false;
            if(CacheService.getObject(CacheConstants.isOrderMode))
            {
                vm.showOrderModeView=true;
            }

            vm.userProfile = CacheService.getUserProfile();
            vm.redirectCarBrandCheck = MainMetierService.redirectCarBrandCheck(vm.contextCarBrandCheck);
            if(vm.userProfile){
                vm.isWorkshop = DealerManagerSystemeService.isWorkshop(vm.userProfile);
                vm.isPartshop = DealerManagerSystemeService.isPartshop(vm.userProfile);
            }
            //get dmsLoginRequired's value
            //get false from nd-services and delete this condition later
            if (vm.userProfile.dmsConfig.dmsLoginRequired) {
                vm.dmsLoginRequired = vm.userProfile.dmsConfig.dmsLoginRequired;
            }

            if ($state.params) {
                if ($state.params.view) {
                    switch ($state.params.view) {
                        case 'list':
                            vm.isList = true;
                            break;
                        case 'create':
                            vm.isCreate = true;
                            break;
                    }
                }
            }
            vm.partsRequisition = PartRequisitionMetierService.getCurrentPartRequisition();            
            if (vm.partsRequisition) {
                if(vm.partsRequisition.status === "DRAFT" && !$state.params.createNew){
                    vm.isCreate = false;
                    vm.isList = true;
                }
                if (vm.isCreate) {
                    closePartRequisition(vm.partsRequisition, true).then(function () {

                        initPartRequisition().finally(function () {
                            vm.loading = false;
                        });

                    })

                }
                if (vm.isList) {
                    findPartRequisition(vm.partsRequisition).then(function () {
                        return loadAndRestorePartsInformationsFromDH(vm.partsRequisition.items);
                    }).then(function (cart) {
                        vm.partsRequisition.items = cart;
                    }).then(function () {
                        restoreCustomer(); //fetch customer in cache and set variables
                        if (vm.partsRequisition.items && vm.partsRequisition.items.length != 0) {
                            return getDmsReferencesInformations(vm.partsRequisition).then(function () {
                                PartRequisitionMetierService.setCurrentPartRequisition(vm.partsRequisition) //set PartRequisition in cache
                                if (vm.partsRequisition && vm.partsRequisition.orderNumber && vm.partsRequisition.orderNumber != "-" && vm.partsRequisition.status != 'VALID')
                                    getOrderSplitDetails(vm.partsRequisition.orderNumber);
                            }).catch(function(){
                                $log.debug($translate.instant('ERROR'));
                            });
                        }
                    }).catch(function () {
                        $translate("ERROR").then(function (text) {
                            toastr.error(text, { timeOut: 1500 });
                        });
                    }).finally(function () {
                        vm.loading = false;
                    });
                }
            } else {
                if (vm.isCreate) {
                    initPartRequisition().then(function () {
                        if ($state.params.accountId) {
                            vm.partsRequisition.accountNumber = $state.params.accountId;
                            restoreCustomer();
                        }
                    }).finally(function () {
                        vm.loading = false;
                    });
                }

            }

            if ((location.search.match(/accountid=([^&]*)/i)) && (!location.search.match(/vin=([^&]*)/i))) {
                CacheService.cleanCarContext();
                CacheService.removeCarContext();
            }
            var context = CacheService.getObject(CacheConstants.contextCarSearch);
            if (context && context.vehicle) {
                vm.vehicle = context.vehicle;
                vm.bannerData = CarSearchMetierService.getBannerDetails();
            }

            // get customer data from accountNmber of quote or car context

            vm.ordersType = [
                { id: 0, name: "PARTLIST_MODAL_TYPEORDER_DEFAULT" },
                { id: 1, name: "PARTLIST_MODAL_TYPEORDER_PVI" },
                { id: 2, name: "PARTLIST_MODAL_TYPEORDER_Urgence1" },
                { id: 3, name: "PARTLIST_MODAL_TYPEORDER_Urgence2" },
                { id: 4, name: "PARTLIST_MODAL_TYPEORDER_MISSSELL" },
            ];

            $rootScope.$emit('ENABLE_BACKGROUND');
            // getDmsInformation(vm.partsRequisition.items);
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            if (cachedetail && !_.isEmpty(cachedetail.dealers)) {
                var dealerList = _.find(cachedetail.dealers, function (item) {
                    return item.active == true;
                });
                if(vm.userProfile && UtilsMetierService.isDealerAuthorised(vm.userProfile.dealerId))
                    vm.isDealerAvailable = true;
            }
            vm.orderAndSplitDetails = context ? context.ordersAndSplits : null;
        };

        function formatReferenceInput() {

           var formattedVal =  MainMetierService.formatReferenceInput(vm.ref);
            vm.ref = formattedVal;
        };

        function initPartFocus() {
            $timeout(function () {
                var inputBox = document.getElementById('inputReference');
                if (inputBox) {
                    var partReqInputBox = angular.element(inputBox);
                    partReqInputBox[0].focus();
                }
            }, 0);
        };

        function getOrderSplitDetails(orderNumber) {
            DmsMetierService.getOrderByNumber(orderNumber)
                .then(function (response) {
                    var returnCode = response.returnCode;
                    //set response in cache when passed
                    if (response.response && returnCode === 0) {
                        return CacheService.setObject(CacheConstants.dmsResponse, response.response);
                    }
                    //clean splits lists when request is failed
                    else {
                        CacheService.removeObject(CacheConstants.dmsResponse);
                        $rootScope.$emit('clean');
                        return CarSearchMetierService.handleErrorFromDmsOrder(returnCode);

                    }
                }).then(function () {
                    //get splits for the selected order number
                    CarSearchMetierService.refreshSplitOnChangeOrderNumber();
                    $rootScope.$emit('reload');
                    var context = CacheService.getObject(CacheConstants.contextCarSearch);
                    vm.orderAndSplitDetails = context ? context.ordersAndSplits : null; 
                }).catch(function(){
                    $log.debug($translate.instant('ERROR'));
                })

        }
        /**
         * display the correct price (DMS or Datahub)
         * @param piece
         * @returns {string}
         */
        function getPriceToDisplay(item) {
            var price = UtilsMetierService.getPriceToDisplay(
                item.price, !item.dmsInformations ? null : item.dmsInformations.priceExclTaxes);
            return price;
        }

        /**
         * @name getCurrencyForItem
         * @desc get currency to display
         * @returns {string}
         */

        function getCurrencyForItem(piece) {
            if (piece && piece.dmsInformations && piece.dmsInformations.isKnowFromDms) {
                return UtilsMetierService.getCurrencyForItem(piece.dmsInformations.isKnowFromDms)
            } else {
                return UtilsMetierService.getCurrencyForItem()
            }
        }

        /**
         *      @desc   Restore client information if we have it
         *              1) From cache (stored when customer information is updated)
         *              2) From accountNumber (partRequisition)
         */

        function restoreCustomer() {
            // Restore default client
            var customerData = CacheService.getPartRequisitionCustomer();
            var quoteCustomer = CacheService.getQuoteCustomer();

            if (customerData) {
                vm.defaultClientMode = true;
                $state.params.customer = customerData.value;
                vm.currentCustomer = customerData.value;
            }
            else if (quoteCustomer) {
                vm.defaultClientMode = true;
                $state.params.customer = quoteCustomer;
                vm.currentCustomer = quoteCustomer;
                var requestBody = {"accountNumber":quoteCustomer.accountNumber,"id":vm.partsRequisition.id};
                PartRequisitionWsService.savePartRequisition(requestBody);
            }
            else if(vm.partsRequisition){
                var accountNumber = vm.partsRequisition.accountNumber;
                // IDK if we need this, and why :/
                // if (!accountNumber && context && context.customer) {
                //     accountNumber = context.customer.dmsCustomerId;
                // }
                if (accountNumber) {
                    setDmsCustomerByAccountNumber(accountNumber);
                }
            }
        }

        function getTypeOf(value) {
            if (value === null) {
                return "null";
            }
            if (Array.isArray(value)) {
                return "array";
            }
            return typeof value;
        }

        function getValidatePartRequisitionClass() {
            var validatePartRequisitionClass = 'row validateButton';
            if (vm.dmsLoginRequired) {
                validatePartRequisitionClass += ' margin-top-0';
            }
            return validatePartRequisitionClass;
        }

        /**
         *  @desc This function is trigger when an intervention is updated
         *  @param {object} item is a line of items in console.log(s
         *  @par)//am {object} split {
         *      splitId     : string
         *      splitLabel  : string
         *  }
         */


        function onUpdateIntervention(item, split) {
            var interventionEmpty = 0;
            vm.partsRequisition.items.forEach(function(part){
                if(part.interventionId == null){
                    interventionEmpty++;
                }
            })
            var context = CacheService.getObject(CacheConstants.contextCarSearch);
            vm.orderAndSplitDetails = context ? context.ordersAndSplits : null; 
            if(interventionEmpty > 1 && !isOrderNumberChanged && !vm.isPartsReplicated && vm.isWorkshop && vm.partsRequisition.orderNumber != '-' && vm.orderAndSplitDetails && vm.orderAndSplitDetails.splits && vm.orderAndSplitDetails.splits.length > 1) {
                $mdDialog.show({
                    templateUrl: 'app/components/partRequisition/operationUpdate.template.html',
                    controller: 'PartRequisitionController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true
                });  
            }
            if(split){
                item.interventionId = split.splitId;
                item.interventionLabel = split.splitLabel;
            }
            ShoppingCartPartsService.updateSplit([item], split)
            PartRequisitionMetierService.onUpdateCart([item]);
        }

        // DMS informations
        function getDmsReferencesInformations(partRequisition) {
            var references = DmsMetierService.getReferencesFromListPiece(partRequisition.items);
            return DmsMetierService.getReferencesDms(references).then(function (response) {
                var dmsData = DmsMetierService.buildDataFromDms(response.response.parts);
                DmsMetierService.matchReferenceFromDms(partRequisition.items, dmsData);
                if(vm.partsRequisition.items.length > 0){
                    vm.partsRequisition.items.forEach(function (item) {
                        if (item.dmsInformations && item.dmsInformations.quantity >= item.quantity) {
                            item.orderType = 0;
                        }else if(item.dmsInformations && item.dmsInformations.quantity < item.quantity){
                            item.orderType = 2;
                        }
                        item.orderTypeObject = { id: item.orderType };

                    });
                }
                return response;
            });
        }

        /**
         * @desc Merge data from DH/DMS to one
         * @param {object} DHRef
         * @param {object} DMSRef
         * @return {object}
         */

        function mergeData(DHRef, DMSRef) {
            var DMSData = DmsMetierService.buildDataFromDms([DMSRef]);
            DmsMetierService.addDmsInformationToCurrentPiece(DHRef, DMSData);
            // DHRef is mutated inside addDmsInformationToCurrentPiece
            DHRef.quantity = 1;

            if(DHRef.quantity > DMSData[0].stockQuantity){
                DHRef.orderTypeObject = { id: 2 };
                DHRef.orderType = 2;
            }else{
                DHRef.orderTypeObject = { id: 0 };
                DHRef.orderType = 0;
            }

            return DHRef;
        }

        function setDmsCustomerByAccountNumber(accountNumber) {
            // set customer to send account number
            var customer = {};
            customer.accountNumber = accountNumber;
            $state.params.customer = customer;
        }

        /**
         *  @desc Navigate to product
         *  @param {string} ref
         *  @return {void}
         */

        function goToProductPage(ref) {
            $state.go(RoutesConstants.product, { reference: ref })
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }
        /**
         *      @desc function called when the user want to insert a new ref
         *      @param {ref} string
         */

        function addRef(ref) {

            if (!ref) {
                return;
            }
             ref = ref.replace(/\s/g, '');
            if (ref.length !== 10) {
                toastr.error($translate.instant('ERROR_INVALID_REFERENCE'));
                return;
            }

            ref = ref.toUpperCase();
            if(vm.partsRequisition && vm.partsRequisition.items.length >= 99){
                toastr.error($translate.instant('PR_MAX_LIMIT_ERROR'));
                return;
            }
            var item = _.find(vm.partsRequisition.items, function (item) {
                return item.reference === ref;
            });

            blockUI.start();
            $q.resolve().then(function () {
                if (item) {
                    // update current item
                    item.quantity += 1;
                    vm.ref = "";
                    ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_QUANTITY, { piece: item });
                    return item;
                } else {
                    return DocumentsMetierService.getPRLight([ref]).then(function (products) {
                        // call DH
                        if (!products || !products.length) {
                            return null;
                        }
                        return products[0];
                    }, function () {
                        return null;
                    }).then(function (RefInformations) {
                        // return a promise which contains DMS/DH informations on user reference input
                        return DmsMetierService.getReferencesDms([ref]).then(function (response) {
                            // call DMS
                            var error = response.response.returnCode;
                            var part = response.response.parts[0];
                            var DMSRefInformations;

                            if (error || !part.priceExclTaxes) {
                                DMSRefInformations = null;
                            } else {
                                DMSRefInformations = part;
                            }
                            return {
                                fromDMS: DMSRefInformations,
                                fromDH: RefInformations
                            };
                        }, function (err) {
                            if(!err.status){
                                return {
                                    fromDMS: null,
                                    fromDH: RefInformations
                                }
                            }else{
                                return $q.reject(err);
                            }
                        });
                    }).then(updateShoppingCartState).then(function (item) {
                        vm.partsRequisition.items.push(item);
                        vm.ref = "";
                        return item;
                    });
                }
            }).then(function (item) {
                // UPDATE TABLE
                return PartRequisitionMetierService.onUpdateCart([item]).then(function (partRequisition) {
                    if(partRequisition.items.length > 0){
                        partRequisition.items.forEach(function (partRequisitionItem) {
                            if (partRequisitionItem.reference === item.reference) {
                                item.id = partRequisitionItem.id;
                            }
                        });
                    }
                    return item;
                });
            }).then(function (item) {
                // SCROLL TO THE REF
                var id = "_" + item.reference;
                ScrollService.toHash(id);
            }).catch(function (err) {
                if(!err.status){
                    switch (err) {
                        case PartRequisitionConstants.errors.partNotFound:
                            toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                            break;
                        default:
                            toastr.error($translate.instant('ERROR'));
                            break;
                    }
                }
            }).finally(function () {
                blockUI.stop();
            });
        }


        /**
         *  @desc   Update part requisition shopping cart state
         *          Display error toastr when we only have data from DH
         *  @param {Object} refInfo {
         *      fromDH  : Object
         *      fromDMS : Object
         *  }
         *  @return {object} return DH/DMS/ or both inside a same object
         */

        function updateShoppingCartState(refInfo) {
            // UPDATE SHOPPING CART SERVICE
            if (!refInfo.fromDMS && !refInfo.fromDH) {
                return $q.reject(PartRequisitionConstants.errors.partNotFound);
            }

            if (!refInfo.fromDMS && refInfo.fromDH) {
                toastr.info($translate.instant('COMMON_ERROR_REF_DMS'));
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDH,
                    type: 'PR'
                });
                return formatPart(refInfo.fromDH);
            } else if (refInfo.fromDMS && !refInfo.fromDH) {
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDMS,
                    type: 'PR'
                });
                return formatPart(refInfo.fromDMS);
            } else {
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDH,
                    type: 'PR'
                });
                return mergeData(refInfo.fromDH, refInfo.fromDMS);
            }
        }

        /**
         *  @desc   Fetch data from DH and restore it
         *          Items is not mutated
         *  @param  {Array<Object>} items // cart
         *  @return Array<Object>
         */

        function loadAndRestorePartsInformationsFromDH(items) {
            var IDList = items.map(function (PR) {
                return PR.reference;
            })

            if (!IDList.length) {
                return $q.resolve(items);
            }

            return DocumentsMetierService.getPRLight(IDList).then(function (partsList) {
                return items.map(function (item) {
                    var part = _.find(partsList, function (pr) {
                        return pr.reference === item.reference;
                    });

                    if (!part) {
                        return item;
                    }

                    // ADD DH INFORMATIONS ON THE CURRENT PART
                    return _.assign({}, item, {
                        designation: part.designation,
                        priceHT: part.priceExclTaxes,
                        currency: part.currency,
                        reach: part.reach
                    });
                })
            });
        }

        /**
         *  @desc Return a new struct of part
         *  @param {object} part
         *  @return {object}
         */

        function formatPart(part) {
            return {
                reference: part.reference,
                designation: part.designation || part.description,
                price: part.priceExclTaxes,
                reach: part.reach,
                quantity: 1,
                orderType: 0,
                orderTypeObject: { id: 0 },
                currency: part.currency,
                familyCode: part.familyCode ? part.familyCode : null,
            }
        }

        // check if all orderType are set when is necessary
        //verify if dms informations (available quantity are the same)
        function checkSetOrderTypeValue(parts) {
            var refs = parts.map(function (part) {
                return part.reference;
            });
            return DmsMetierService.getReferencesDms(refs).then(function (res) {
                res.response.parts.forEach(function (DMSpart) {
                    var notAvailable = !DMSpart.availabilities || !DMSpart.availabilities.length
                    if (notAvailable) {
                        DMSpart.dmsStock = 0;
                        return;
                    }
                    DMSpart.availability = DMSpart.availabilities[0];
                    DMSpart.dmsStock = DMSpart.availability.quantity;
                })
                return res.response.parts;
            }).then(function (DMSParts) {
                return DMSParts.map(function (partDMS) {
                    var foundedPart = _.find(parts, function (part) { return part.reference === partDMS.reference });
                    if (foundedPart && foundedPart.quantity && partDMS.dmsStock) {
                        var notEnoughStock = foundedPart.quantity > partDMS.dmsStock;
                        var orderTypeIsNotSet = !foundedPart.orderType
                        if (notEnoughStock && orderTypeIsNotSet) {
                            return partDMS;
                        }
                    }
                    return null;
                }).filter(function (DMSPart) {
                    return DMSPart;
                })
            });
        }

        function backToPrevious() {
            // if we come from ValidatedQuote, go to quotelistvalidated
            // back to partsRequisitionListDraft page if we come from quoteListDraft with options list (filters, sort, pagination)
            // back to previous page else
            vm.isPartsReplicated = false;
            if ($state.redirectedFrom == RoutesConstants.validatedQuote) {
                $state.go(RoutesConstants.partRequisitionListValidated);
            } else if (!$state.params.partsRequisitionOptions) {
                $window.history.back();
            } else {
                $state.go(RoutesConstants.partRequisitionListDraft, {
                    partsRequisitionOptions: $state.params.partsRequisitionOptions
                });
            }
        }

        /**
         * @namespace savePartRequisition
         * @desc saves the user's changes / deletions and the partRequisition remains active.
         * @param {Object} partRequisition the current bs
         * @param {Boolean} hidePopin condition to show/hide the toastr in case of success
         * @memberOf Controller.savePartRequisition
         */

        function savePartRequisition(partRequisition, hidePopin) {
            PartRequisitionMetierService.savePartRequisitionLogic(partRequisition).then(function () {
                if (!hidePopin) {
                    $translate("PART_REQUISITION_SUCCESS").then(function (text) {
                        toastr.success(text + " (" + partRequisition.number + ")", { timeOut: 1500 });
                    });
                }
                // backToPrevious();
            }).catch(function () {
                $translate("PART_REQUISITION_FAILURE").then(function (text) {
                    toastr.error(text, { timeOut: 1500 });
                });
            });
        }

        //#region search-dms-customer component callback

        /**
         * @namespace onSelectedCustomerCallback
         * @desc save the customer accountNumber  related to current partRequisition
         * @param {*} customer
         */
        function onSelectedCustomerCallback(customer) {
            vm.partsRequisition.accountNumber = (customer) ? customer.accountNumber : null;
            CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
            CacheService.savePartRequisitionCustomer({
                value: customer
            });
            savePartRequisition(vm.partsRequisition, true);
        }

        /**
         *  @namespace updateOrderNumber
         *  @desc save the customer accountNumber  related to current Part Requisition
         */

        function updateOrderNumber(orderNumber) {
            isOrderNumberChanged = true;
            vm.partsRequisition.items.forEach(function (item) {
                item.interventionId = null;
                item.interventionLabel = '-';
            })
            vm.partsRequisition.orderNumber = orderNumber;
            vm.getOrderSplitDetails(orderNumber)
            CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
            savePartRequisition(vm.partsRequisition, true);
            isOrderNumberChanged = false;
            vm.isPartsReplicated = false;
        }


        /**
         * @namespace onNewCustomerCallback
         * @desc erase the customer accountNumber  related to current partRequisition
         */
        function onNewCustomerCallback() {
            savePartRequisition(vm.partsRequisition, true);
        }

        function onCustomerFilledCallback(value) {
            vm.isCustomerFilled = value;
        }

        function onResetCustomerCallback() {
            if (vm.partsRequisition.accountNumber) {
                vm.partsRequisition.accountNumber = null;
                savePartRequisition(vm.partsRequisition, true);
            }
        }

        // this function is only trigger when the default client is set
        function onUpdatedCustomerCallback(customer) {
            CacheService.savePartRequisitionCustomer({
                updated: true,
                value: customer
            });
            vm.partsRequisition.accountNumber = (customer) ? customer.accountNumber : null;
            savePartRequisition(vm.partsRequisition, true);
        }

        //#endregion

        /**
         * @namespace closePartRequisition
         * @desc registers the partRequisition and is added to the user's draft partRequisition list. The partRequisition is no longer active.
         * @param {object} partRequisition the id of current bs
         * @param {Boolean} isFromInit Hack to call the backToPrevious function only when needed
         * @memberOf Controller.closePartRequisition
         */
        function closePartRequisition(partRequisition, isFromInit) {
            return $q.resolve().then(function () {
                var customer = CacheService.getPartRequisitionCustomer();
                if (customer && customer.updated) {
                    return warningModalCustomerService.displayModal();
                }
            }).then(function () {
                return PartRequisitionMetierService.saveAndCloseCurrentPartRequisition(partRequisition).then(function () {
                    if (!isFromInit) {
                        $translate("PART_REQUISITION_SUCCESS").then(function (text) {
                            toastr.success(text + " (" + partRequisition.number + ")", { timeOut: 1500 });
                        });
                    }
                    ShoppingCartPartsService.setShoppingCart([]);
                    if (!isFromInit) {
                        backToPrevious();
                    }
                })
            }).catch(function (err) {
                // reject from the modal can return 0 (when user choose to cancel it)
                if (err) {
                    $translate("PART_REQUISITION_FAILURE").then(function (text) {
                        toastr.error(text, { timeOut: 1500 });
                    });
                }
            });
        }

        /**
        * @namespace initPartRequisition
        * @desc create the partRequisition and add the active.
        * @memberOf Controller.initPartRequisition
        */
        function initPartRequisition() {
            return PartRequisitionMetierService.initPartRequisition().then(function (response) {

                var carInfosFromCache = CacheService.getObject(CacheConstants.contextCarSearch);
                //dms response
                var dmsResponse = CacheService.getObject(CacheConstants.dmsResponse);

                vm.partsRequisition = response;
                formatDates(response);

                //set registration number dms if exist
                //registration number bvm else
                if(carInfosFromCache && carInfosFromCache.vehicle)
                    vm.partsRequisition.registrationNumber = carInfosFromCache.vehicle.registrationNumber;
                if (dmsResponse && dmsResponse.vehicle && dmsResponse.vehicle.registrationNumber && dmsResponse.vehicle.registrationNumber != "") {
                    vm.partsRequisition.registrationNumber = dmsResponse.vehicle.registrationNumber;
                }
                restoreCustomer();
            }).catch(function () {
                $translate("PART_REQUISITION_FAILURE").then(function (text) {
                    toastr.error(text, { timeOut: 1500 });
                });
            });
        }

        /**
         *
         * @param {*} response
         * @desc format dates in model in iso format
         */
        function formatDates(response) {
            if (response.lastModificationDateTime) {
                vm.partsRequisition.lastModificationDateTime = moment(response.lastModificationDateTime).format('YYYY/MM/DD');
            }
            else {
                vm.partsRequisition.lastModificationDateTime = "";
            }
            vm.partsRequisition.creationDateTime = moment(response.creationDateTime).format('YYYY/MM/DD');
        }

        function getStockClass(piece) {
            if (piece && (piece.dmsInformations) && (piece.dmsInformations.quantity > 0) && (piece.quantity <= piece.dmsInformations.quantity)) {
                return 'stockDispo';
            } else {
                return 'stockIndispo';
            }
        }

        function checkStock(piece) {
            // we don't have to check stock if the orderType is set
            if (piece.orderType > 0) {
                return true;
            }

            if (!piece.dmsInformations) {
                return false;
            }

            var dmsHasStock = piece.dmsInformations.quantity > 0
            var dmsHasEnoughtStock = piece.quantity <= piece.dmsInformations.quantity;

            if (dmsHasStock && dmsHasEnoughtStock) {
                return true;
            }
            return false;
        }

        /**
        * @namespace findPartRequisition
        * @desc create the partRequisition and add the active.
        * @memberOf Controller.initPartRequisition
        */
        function findPartRequisition(partRequisition) {
            return PartRequisitionMetierService.findPartRequisitionLogic(partRequisition.id)
                .then(function (response) {
                    //we use this to get quote account number and order number
                    //when we put quote items to part requisition
                    var partRequisitionCache = vm.partsRequisition;
                    vm.partsRequisition = response;
                    vm.partsRequisition.accountNumber = (partRequisitionCache.accountNumber) ? partRequisitionCache.accountNumber : null;
                    if (partRequisitionCache.orderNumber) {
                        vm.partsRequisition.orderNumber = partRequisitionCache.orderNumber;
                    }

                    formatDates(response);
                    vm.partsRequisition.creationDateTime = moment(response.creationDateTime).format('YYYY/MM/DD');
                    CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
                })
                .then(function () {
                    ShoppingCartPartsService.setShoppingCart(vm.partsRequisition.items);
                })

        }

        function onChangeUnusualSale(item) {
            ShoppingCartPartsService.onUpdateUnusableSale(item);
        }

        function onChangeOrderType(item) {
            item.orderType = item.orderTypeObject.id;
            ShoppingCartPartsService.updateTypeOrder([item], item.orderType);
            PartRequisitionMetierService.onUpdateCart([item]);
        }

        function onChangePassword(passwordInput) {
            if (passwordInput === "") {
                UtilsMetierService.setErrorFrame("#identifiantPasswordPartRequisition");
                return -1;
            }
            UtilsMetierService.resetErrorFrame("#identifiantPasswordPartRequisition");
            return 0;
        }

        function onChangeUsername(usernameInput) {
            if (usernameInput === "") {
                UtilsMetierService.setErrorFrame("#identifiantLoginPartRequisition");
                return -1;
            }
            UtilsMetierService.resetErrorFrame("#identifiantLoginPartRequisition");
            return 0;
        }


        function onChangeAdditionalDiscount(item) {
            if (item.additionalDiscount < 0 || item.additionalDiscount > 99) {
                item.additionalDiscount = 0;
                toastr.error($translate.instant('PART_REQUISITION_ERROR_SUPPL_SALE'), { timeOut: 1500 });
                return;
            }
            ShoppingCartPartsService.onUpdateAdditionalDiscount(item);
        }

        /**
         *  @desc Save partRequisition description
         *  @param {Object} partRequisition
         *  @return {void}
         */

        function onChangeDescription(partRequisition) {
            PartRequisitionMetierService.savePartRequisitionLogic(partRequisition).catch(function () {
                $translate("PART_REQUISITION_FAILURE").then(function (text) {
                    toastr.error(text, { timeOut: 1500 });
                });
            });
        }

        /**
         * @desc set phenix.partRequisitionCustomer value and change phenix.bs.accountNumber value
         * @param {Object} newCustomer
         */
        function onSetCustomerDetails(newCustomer) {
            //set phenix.partRequisitionCustomer value

            CacheService.savePartRequisitionCustomer({
                value: newCustomer
            });

            //change phenix.bs.accountNumber value
            vm.partsRequisition.accountNumber = (newCustomer) ? newCustomer.accountNumber: null;
            CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
            savePartRequisition(vm.partsRequisition, true);
        }

        /**
         *  @desc   Function to validate a partRequisition
         *          we do some verification before sending it
         *
         *  @param {Object} partRequisition
         *  @return {void}
         */

        function validate() {
            if (vm.isValidating) {
                return;
            }
            vm.isValidating = true;
            //set part requisition user informations (login, password)
            vm.partsRequisition.dmsLoginInformations = vm.dmsLoginContainer;

            var profil = CacheService.getObject(CacheConstants.profil);
            var data = {};
            var isUsernameEmpty = 0;
            var isPasswordEmpty = 0;

            //check if username or password are set when dms login option is checked
            if (vm.dmsLoginRequired) {
                isUsernameEmpty = vm.onChangeUsername(vm.dmsLoginContainer.username);
                isPasswordEmpty = vm.onChangePassword(vm.dmsLoginContainer.password);
                if (isUsernameEmpty === -1 || isPasswordEmpty === -1) {
                    toastr.error($translate.instant("COMMON_ERROR_MISSING_FIELD"));
                    vm.isValidating = false;
                    return -6;
                }
            }
            //check if workshop partshop id is set
            if (!DealerManagerSystemeService.isSetWorkshopPartshopId(profil)) {
                toastr.error($translate.instant("WORKSHOPPARTSHOP_ID_UNSET"));
                vm.isValidating = false;
                return -1;
            }

            //check if customer informations are set
            if (!PartRequisitionMetierService.isSetCustomerInformations(vm.currentCustomer) || !vm.isCustomerFilled) {
                $rootScope.$emit('CUSTOMER_NOT_SELECTED');
                toastr.error($translate.instant("UNSELECTED_CLIENT"));
                vm.isValidating = false;
                return -2;
            }

            //check if order type are set for part requisitions items
            if (!PartRequisitionMetierService.isSetOrderTypePartRequisitionItems(vm.partsRequisition.items)) {
                toastr.error($translate.instant("UNSELECTED_ORDER_TYPE"));
                vm.isValidating = false;
                return -3;
            }
            if (vm.isWorkshop) {
                //check if interventions are set for part requisitions items
                if (!PartRequisitionMetierService.isSetInterventionsPartRequisitionItems(vm.partsRequisition.items)) {
                    toastr.error($translate.instant("UNSELECTED_INTERVENTION"));
                    vm.isValidating = false;
                    return -4;
                }

                //check if order number is set for part requisition (only workshop profile)
                if (!PartRequisitionMetierService.isSetOrderNumberPartRequisition(vm.partsRequisition)) {
                    toastr.error($translate.instant("UNSELECTED_ORDER_NUMBER"));
                    vm.isValidating = false;
                    return -5;
                }
            }


            blockUI.start();
            onChangeDescription(vm.partsRequisition);
            checkSetOrderTypeValue(vm.partsRequisition.items)
                .then(function (notSetOrderTypePartRequisition) {

                    //reject if having part requisition without order type
                    if (notSetOrderTypePartRequisition && notSetOrderTypePartRequisition.length > 0) {
                        notSetOrderTypePartRequisition.forEach(function (part) {
                            var item = _.find(vm.partsRequisition.items, function (item) {
                                return item.reference === part.reference;
                            });
                            item.dmsInformations.quantity = part.quantity;
                        })
                        return $q.reject(5);
                    }
                })
                .then(function () {
                    // call dms in order to get the dmsPartlistId and add it to part requisition informations
                    return DmsMetierService.sendBstoDms(profil.dmsConfig.networkProfile, vm.currentCustomer, vm.partsRequisition);
                })
                .then(function (dmsPartRequisitionResponse) {
                    //if return code is not in validated parts requisition list (view list in SuperCartValidateService)
                    //reject promise and send error object {message, returnCode}
                    if (SuperCartValidateService.isPartsRequisitionValidate(dmsPartRequisitionResponse.returnCode) < 0) {
                        var error = {};
                        //return object error with message and return code from dms
                        error.message = dmsPartRequisitionResponse.message;
                        error.returnCode = dmsPartRequisitionResponse.returnCode;
                        return $q.reject(error);
                    }

                    //add dmsPartlistId to part requisition informations
                    vm.partsRequisition.dmsPartListId = PartRequisitionMetierService.getPartListIdFromDmsResponse(dmsPartRequisitionResponse);
                })
                .then(function () {
                    //format parts requsition to get price and location from dms informations
                    vm.partsRequisition.items = formatPartsRequisitionItems(vm.partsRequisition.items);

                    //call validate service part requsition (nd-services)
                    return PartRequisitionMetierService.validatePartRequsitionLogic(vm.partsRequisition)
                })
                .then(function (partRequisitionValidationResponse) {
                    ShoppingCartPartsService.setShoppingCart([]);
                    CacheService.removeObject(PartRequisitionConstants.bs);
                    CacheService.removeObject(CacheConstants.partRequisitionCustomer);

                    //add location to part requisition items
                    vm.partsRequisition.items = PartRequisitionMetierService.getPartRequisitionItemLocation(vm.partsRequisition.items);

                    //set part requisition validator infos
                    vm.partsRequisition = PartRequisitionMetierService.setPartRequisitionValidationInfos(vm.partsRequisition, partRequisitionValidationResponse);

                    //set data to send to validate part requisition page
                    data.carContext = vm.vehicle,
                    data.customer = vm.currentCustomer,
                    data.partRequisition = vm.partsRequisition;


                    //redirect user to validate part requisition page
                    $state.go(RoutesConstants.validatedPartRequisition, { data: data, id: vm.partsRequisition.id, customer: vm.currentCustomer, vehicle: vm.vehicle });
                }).catch(function (error) {

                    //if dms login is checked, reset username and password fields while displaying error message
                    if (vm.dmsLoginRequired) {
                        vm.dmsLoginContainer.username = UtilsMetierService.resetField(vm.dmsLoginContainer.username);
                        vm.dmsLoginContainer.password = UtilsMetierService.resetField(vm.dmsLoginContainer.password);
                    }
                    //AS dms specific errors are already displayed
                    /* if (error.message && error.returnCode) {
                        var errorMessage = $translate.instant("DMS_RESPONSE_LABEL") + " : ";
                        try {
                            errorMessage += decodeURIComponent(escape(error.message));
                        } catch (e) {
                            errorMessage += error.message;
                        }

                        errorMessage += " (" + error.returnCode + ")";

                        toastr.error(errorMessage);
                    }
                    else {
                        toastr.error($translate.instant("DMS_ERROR_VALIDATION"));
                    } */
                }).finally(function () {
                    blockUI.stop();
                    vm.isValidating = false;
                    return 0;
                });

            return 0;
        }

        /**
         * @name formatPartsRequisitionItems
         * @desc parse parts requisition items to get price and location from dms informations object if exist
         * @desc and replace validate request's payload with price and location
         * @param {Array} partsRequisitionItems
         */
        function formatPartsRequisitionItems(partsRequisitionItems) {
            var parsedPartRequisitionItems = [];
            partsRequisitionItems.forEach(function (partRequisitionItem) {
                if (partRequisitionItem && partRequisitionItem.dmsInformations && partRequisitionItem.dmsInformations.location) {
                    partRequisitionItem.location = partRequisitionItem.dmsInformations.location;
                }
                if (partRequisitionItem && partRequisitionItem.dmsInformations && partRequisitionItem.dmsInformations.priceExclTaxes) {
                    partRequisitionItem.price = partRequisitionItem.dmsInformations.priceExclTaxes;
                }
                parsedPartRequisitionItems.push(partRequisitionItem);
            })

            return parsedPartRequisitionItems;
        }

        function sortBy(propertyName) {
            vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        /**
    *  @desc Display modal, and delete item if the user confirms the suppression
    *  @param {object} item
    */
        function deleteReference(item) {
            var ref = item.type === 'TM' ? item.opecod : item.reference;
            var body = angular.element(document.body);
            var designation = item.designation;
            var payload = {
                referenceId: item.id
            };

            var modalParams = {
                body: body,
                designation: designation,
                isList: false,
                title: "PARTLIST_MODAL_DELETE_REF_TITLE",
                ref: ref
            }
            DeleteModalService.showModal(modalParams).then(function () {
                var index = _.findIndex(vm.partsRequisition.items, function (piece) {
                    return piece.id === item.id;
                });

                if (index !== -1) {
                    index === 0 ? vm.partsRequisition.items.shift() : vm.partsRequisition.items.splice(index, 1);
                }
                ShoppingCartPartsService.updateShoppingCart('DELETE_PIECE', payload);
                ShoppingCartPartsService.deleteItem(vm.partsRequisition.id, item.id).catch(function () {
                    $translate.instant('ERROR');
                });
            }).catch(function (err) {
                // err can be from canceled modal
                if (err) {
                    toastr.error($translate.instant('ERROR'));
                }
            }).finally(function () {
                //  blockUI.stop();
            })
        }

        /**
         *  @desc Will call the business service layer (metier.service.js) in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  @param  vm.quote : list of TM and PR entries that we want to display in the pdf
         *  @param  vm.vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         *  response {
         *      data : blob type for the pdf file
         *  }
         */
        function printPartRequisition(isDownload) {
            blockUI.start();

            var type = globalConstant.partRequisition;
            var status = globalConstant.draft;

            var partRequisitionToPrint = PartRequisitionMetierService.buildClientForPrintPayload(vm.partsRequisition, vm.currentCustomer, false, false, false);
            partRequisitionToPrint.items = PartRequisitionMetierService.formatItemsForPrintPayload(vm.partsRequisition.items);
            var isKnownByDms = _.find(partRequisitionToPrint.items, function (item) {
                return item.dmsInformations;
            })
            if (isKnownByDms) {
                var currency = UtilsMetierService.getCurrencyForItem(isKnownByDms);
            } else {
                var currency = UtilsMetierService.getCurrencyForItem();
            }

            PartRequisitionMetierService.addTranslatedOrderTypeToItems(partRequisitionToPrint.items);
            if (currency) {
                partRequisitionToPrint.currency = currency;
                partRequisitionToPrint.items.forEach(function(item) {//for EUR currency in PartRequistion Screen -> Deepthi
                  if(item.price != 0){
                     item.currency = partRequisitionToPrint.currency;
                  }
                  else if(item.price == 0){
                     item.currency="-";
                  }
                });
            }
           
            SuperCartMetierService.downloadPdf(partRequisitionToPrint, partRequisitionToPrint.items, vm.vehicle, type, status).then(function (response) {                
                if(pdfMake){
                    pdfMake.tableLayouts = {
                        descTableLayout: {
                            hLineWidth: function () {
                                return 0.1;
                            },
                            vLineWidth: function () {
                                return 0.1;
                            },
                            hLineColor: function () {
                                return 'gray';
                            },
                            vLineColor: function () {
                                return 'gray';
                            },
                        },
                        secondTableLayout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 3 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                            }
                        },
                        thirdTableLayout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 2 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                            }
                        },
                        otherTableLayout: {
                            hLineWidth: function () {
                                return 1;
                            },
                            vLineWidth: function () {
                                return 1;
                            }
                        }
    
                    };
                    var pdfDocGenerator = pdfMake.createPdf(response.data);
                }
                if(pdfDocGenerator){
                    pdfDocGenerator.getBuffer(function (buffer) {
                        var file = new Blob([(buffer)], { type: 'application/pdf' });

                        // Internet Explorer 6-11
                        var isIE = /*@cc_on!@*/false || !!document.documentMode;

                        // Edge 20+
                        var isEdge = !isIE && !!window.StyleMedia;
                        if (isDownload){
                            FileSaver.saveAs(file, $translate.instant("COMMON_PARTLIST_PRINT_BUTTON") + "-" + partRequisitionToPrint.number + ".pdf");
                        }else{
                            if (isIE || isEdge) {
                                FileSaver.saveAs(file, $translate.instant("COMMON_PARTLIST_PRINT_BUTTON") + "-" + partRequisitionToPrint.number + ".pdf");
                            } else {
                                printPdfModalService.encode64Base(file).then(function (response) {
                                    var modalParams = {
                                        data: response
                                    }
                                    return printPdfModalService.showModal(modalParams).catch(function () {
                                        $log.debug($translate.instant('ERROR'));
                                    });
                                }).catch(function (err) {
                                    toastr.error($translate.instant('ERROR'));
                                });
                            }
                        }
                    });
                }
            }).catch(function (err) {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });


        }

        /**
       * Navigation to product page
       * @param {*} piece
       * @param {*} mainPiece
       */
        function goToProduct(piece) {
            $state.transitionTo($state.$current.name, { refIndex: piece.index }, {
                location: "replace",
                inherit: true,
                relative: $state.$current,
                notify: false
            })
            angular.element(function () {
                var path = {
                    reference: piece.reference,
                    mainReference: piece.initialReference
                }

                RoutingService.goToProductPage({
                    path: path
                })
            });
        }
        function multipleOperations(part){
            var partData = angular.copy(vm.partsRequisition);
            var atLeast1PartUpdated = false;
            partData.items.forEach(function(item){
                if(item.id != part.id && part.interventionId){ 
                    if(item.interventionId == null){
                        vm.isPartsReplicated = true;
                        atLeast1PartUpdated = true;
                        item.interventionId = part.interventionId;
                        item.interventionLabel = part.interventionLabel;
                    }
                }
            })
            vm.partsRequisition = partData;
            CacheService.setObject(PartRequisitionConstants.bs,vm.partsRequisition);
            if(!atLeast1PartUpdated){
                toastr.info($translate.instant('NO_REPLICATION'));
            }            
        }
        function onClose(){
            $mdDialog.hide();
        }
    }
})();



'use strict';

angular.module('phenix').constant('PartRequisitionConstants',{
    create: '/partsRequisitions/create',
    close: 'partsRequisitions/',
    save: '/partsRequisitions/save',
    delete: '/partsRequisitions/delete',
    unlock: '/partsRequisitions/unlock',
    bs: "bs",
    find: 'partsRequisitions/',
    validate: 'partsRequisitions/validate',
    draftStatus: 'DRAFT',
    validatedStatus: 'VALIDATED',
    sort: {
        asc: 1,
        desc: -1,
        date: 'DATE',
        ID: 'ID'
    },
    pagination: {
        limit: 10
    },
    searchBy: {
        vin: 1,
        registrationNumber: 2,
        model: 3
    },
    partRequisitionList: 'partsRequisitions/list',
    errors : {
        partNotFound: 1,
        partNotFoundDMS: 2
    },
    partsRequisitionCreatedEvent: "partsRequisitionCreatedEvent",
    partsRequisitionUpdatedEvent: "partsRequisitionUpdatedEvent",
    partsRequisitionClosedEvent: "partsRequisitionClosedEvent"
});

(function () {
  'use strict';

  angular
    .module('phenix')
    .directive('orderAlerts', orderAlerts);


  /* @ngInject */
  function orderAlerts() {
    var directive = {
      templateUrl: 'app/components/orderModule/orderCreateAlertPopup.template.html',
      bindToController: true,
      controller: orderAlertsController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {}
    };
    return directive;
  }

  /* @ngInject */
  function orderAlertsController( AlertsService, AlertsWSService,blockUI,CacheService,CacheConstants,$rootScope,printPdfModalService,toastr, $translate,configConstantes,UtilsMetierService) {
    var vm = this;
    vm.clicked = true;
    vm.checkDocType = AlertsService.getDocumentType();
    vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
    vm.isTraceEnabledINT = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
    vm.closePopin = closePopin;
    vm.sendAlerts = sendAlerts;
    vm.removeCapture = removeCapture;
    vm.takeScreenshot = takeScreenshot;      
    vm.carContext = CacheService.getCarContext();
    var cacheProfile = CacheService.getObject(CacheConstants.profil);
    var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
    vm.vin = vm.carContext ? vm.carContext.vin : '';
    vm.countryCode = cacheProfile.country ? cacheProfile.country : '';
    vm.firstName = cacheProfile.firstName ? cacheProfile.firstName : '';
    vm.lastName = cacheProfile.lastName ? cacheProfile.lastName : '';
    vm.userDetail = vm.firstName +  " " + vm.lastName.toUpperCase();
    vm.dealerId = cacheProfile.dealerId ? cacheProfile.dealerId : '';
    vm.garageId = cachedetail.garageId ? cachedetail.garageId : '';
    var emailDescDetails = AlertsService.getEmailDesc();
    vm.emailAlerte = emailDescDetails ? emailDescDetails.email : '';
    vm.alertMessage = emailDescDetails ? emailDescDetails.desc : '';
    vm.attachments = emailDescDetails ? emailDescDetails.attachments : []; 
    vm.alertData = {
      "vin":vm.vin,
      "firstName":vm.firstName,
      "lastName":vm.lastName,
      "mailId":vm.emailAlerte,
      "region":vm.countryCode,
      "dealerId":vm.dealerId,
      "garageId": vm.garageId
    };
    vm.isScreenshotImageTaken = emailDescDetails ? emailDescDetails.isScreenshotImageTaken : false ;
    var omScreenshotId = '#TAKE_OM_SCREENSHOT';

    function closePopin() {
      AlertsService.setPopinVisibility(false,vm.checkDocType,null,( vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
      AlertsService.setEmailDesc(null);    
    }
    function removeCapture(){
      vm.attachments = [];
      vm.isScreenshotImageTaken = false;
    }
    function invalidForm(id) {
      $(id).css({
        'border-color' : 'red',
        'border-width' : '2px',
        'border-style' : 'solid'
    });
    }
    function validForm(id) {
      $(id).css({
        'border-color' : 'green',
        'border-width' : '2px',
        'border-style' : 'solid'
    });
    }
    function alertSizeFormat(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024));
      return (size / Math.pow(1024, i)).toFixed(2) * 1;
    }
    function humanFileSize(size) {
        var i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['o', 'Ko', 'Mo', 'Go', 'To'][i];
    }
    function sendAlerts() {
      if(vm.alertMessage)
        validForm('#ALERT_DESCRIPTION');
      if(validateEmail(vm.emailAlerte))
        validForm('#user_email');
      if(!_.isEmpty(vm.attachments) && vm.attachments[0] && !_.isEmpty(vm.attachments[0].file) && !_.isEmpty(vm.attachments[0].file.data))
        validForm(omScreenshotId);
      var detectedError = false;
      var natureIncidentField = vm.alertMessage && vm.emailAlerte && validateEmail(vm.emailAlerte) && (!_.isEmpty(vm.attachments) && vm.attachments[0] && !_.isEmpty(vm.attachments[0].file)) ;
    
      if (!natureIncidentField) {
        if(!vm.alertMessage)
          invalidForm('#ALERT_DESCRIPTION');
        if(!validateEmail(vm.emailAlerte))
          invalidForm('#user_email');
        if(_.isEmpty(vm.attachments) || _.isEmpty(vm.attachments[0].file) || _.isEmpty(vm.attachments[0].file.data)){
          invalidForm(omScreenshotId);
          toastr.error($translate.instant("ALERT_TAKE_SCREENSHOT")+" - "+$translate.instant("ACTIS_FIELD_REQUIRED"))
        }
        detectedError = true;
      }
      if (detectedError) {
        return;
      }
      var blobVal = new Blob([JSON.stringify(AlertsService.getOMAlertPayload())],{type:"text/plain"});
      printPdfModalService.encode64Base(blobVal).then(function (response){
        vm.attachments.push({
          file: {
            humanSize: humanFileSize(blobVal.size),
            fileName: 'OMAlert',
            fileType: 'txt',
            Alertsize: alertSizeFormat(blobVal.size),
            data: {base64: response}
          }
        })
        vm.alertData.mailId = vm.emailAlerte;
        vm.alertData.attachments = vm.attachments;
        blockUI.start();
        AlertsWSService.sendOrderAlerts(vm.alertMessage,vm.alertData).then(function (response) {
          if (response) {
            AlertsService.setPopinVisibility(false,vm.checkDocType,null,(vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
            AlertsService.showAlertsConfirmation(response);
          }
        }, function (error) {
          AlertsService.showAlertsReject(error);
          toastr.error(error.errorMessage);
        }).finally(function(){
          AlertsService.setEmailDesc(null);
          blockUI.stop();
        });
      })      
    }
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    function takeScreenshot() {
      AlertsService.setPopinVisibility(false, vm.checkDocType,null,(vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
      AlertsService.setScreenshotButtonVisibility(true);
      AlertsService.setEmailDesc({email:vm.emailAlerte, desc:vm.alertMessage});
    }
    $rootScope.$on('addAlert', function (event, capturedImage) {
      if(CacheService.getObject(CacheConstants.isOrderMode)){      
        AlertsService.setPopinVisibility(true, vm.checkDocType,null,(vm.checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
        AlertsService.setScreenshotButtonVisibility(false);
        vm.attachments = [];           
        if(capturedImage){    
          var size = (((capturedImage.length - 814) / 1.37) / 1000).toFixed(2);    
          vm.attachments.push({
            file: {
              humanSize: size + " Ko",
              fileName: "OM_alert_capture",
              fileType: "png",
              Alertsize: parseInt(size),
              data: {
                base64: capturedImage
              }
            }
          })
          screenshotButtonColor(omScreenshotId, '#CCCCCC');
          var saveCapturedImage = AlertsService.getEmailDesc();
          if(saveCapturedImage){
            saveCapturedImage.attachments = vm.attachments;
            saveCapturedImage.isScreenshotImageTaken = true;
            AlertsService.setEmailDesc(saveCapturedImage);
          }
          
        }
      }
    });

    function screenshotButtonColor(id, color) {
      $(id).css({
        'background-color': color
      })
    }
  }
}) ();
'use strict';

angular.module('phenix').constant('OrderModuleConstants', {

    orderModePopOption1: "allParts",
    orderModePopOption2: "withoutStockparts",
    rpartsProfile: ['irn-72795:commande'],
    OMAlertFields: ["applicableClass","designation","discountCode","discountRate","discountRateUrgent","dmsInformations","genericPart","herculesCase","index","itemReturnCode","itemReturnMessage","price","priceAdvisedTaxFree","priceAdvisedTaxIncluded","priceHT","priceTaxFree","priceTaxIncluded","priceUrgentTaxFree","priceUrgentTaxIncluded","quantity","reference","taxRate"]
});


(function () {
    'use strict';

    angular
        .module('phenix')
        .component('orderModule', {
            bindings: {
                vehicle: '<',
                partsRequisition: '=',
                showOrderModeView: '=',
                gotoProductPage: '<'
            },
            controller: orderModuleController,
            controllerAs: 'vm',
            templateUrl: 'app/components/orderModule/orderModule.template.html'
        });

    function orderModuleController($mdDialog, OrderModuleConstants, CarSearchConstants, CacheService, CacheConstants, ShoppingCartWSService, blockUI, UtilsMetierService, PartRequisitionMetierService, ShoppingCartPartsService, $q,DocumentsMetierService, DmsMetierService, PartRequisitionConstants, ScrollService,ShoppingCartConstants,toastr, $translate,DeleteModalService,DealerManagerSystemeService,
        ShoppingCartService,$rootScope,PanierConstants,$state,RoutesConstants,configConstantes,AlertsService,$scope,$timeout) {
        var vm = this;
        vm.isOrderMode = false;
        vm.isRNETUser = false;
        vm.showAllDiscountRate = false;
        vm.countryCode = null;
        vm.r2aPriceResponse = null;
        var priceOrderList = [];
        var stockOrderList = [];
        vm.isTraceEnabled = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
        vm.isTraceEnabledINT = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
        var cacheProfile = CacheService.getObject(CacheConstants.profil);
        vm.isUrgentCountry = (cacheProfile.country == 'AT' || cacheProfile.country == 'BE' || cacheProfile.country == 'CH' || cacheProfile.country == 'DE');
        vm.isCountryChina = UtilsMetierService.isCountryTargeted('CN');
        vm.isCountryIndia = UtilsMetierService.isCountryTargeted('IN');
        vm.isCountryRoumania = UtilsMetierService.isCountryTargeted('RO');
        var rpartsRedirectUrl = configConstantes.rpartsUrl;
        var rpartstoreUrl = "https://rpartstore.renault.com";
        vm.orderDetailsForAlerts = null;
        var orderModeClosePopup = 'app/components/orderModule/orderModeClosePopup.html';
        var evBatteryPopup = 'app/components/orderModule/evBatteryPopup.html';

        vm.orderModePopup = orderModePopup;
        vm.closeOrderModeView = closeOrderModeView;
        vm.goToProductPage = goToProductPage;
        vm.copyToClipboard = copyToClipboard;
        vm.sortByRef = sortByRef;
        vm.displayAllDiscountRate = displayAllDiscountRate;
        vm.displayDiscountRate = displayDiscountRate;
        vm.getPriceToDisplay = getPriceToDisplay;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.addRef = addRef;
        vm.deleteReference = deleteReference;
        vm.checkDealerList = checkDealerList;
        vm.validateOrder = validateOrder;
        vm.saveMarkAndMessage = saveMarkAndMessage;
        vm.urgentOrderChange = urgentOrderChange;
        vm.openAlertsPopin = openAlertsPopin;
        vm.captureScreenshot = captureScreenshot;
        vm.initOrderFocus = initOrderFocus;
        vm.isValidatingOrder = false;

        this.$onInit = function () {
            initOrderFocus();
            vm.isOrderingAlert = JSON.parse(configConstantes.isOrderingAlert);
            vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
            vm.dmsConnected = DealerManagerSystemeService.getHookResult();
            if (CacheService.getObject(CacheConstants.isOrderMode)) {
                vm.isOrderMode = true;
                vm.orderModePartsList = CacheService.getObject(CacheConstants.orderModePartsList);
                if (vm.orderModePartsList && !_.isEmpty(vm.orderModePartsList.items)) {
                    _.map(vm.orderModePartsList.items, function (item) {
                        _.assign(item, { isLoadingPriceData: false, isLoadingStockData: false })
                    })
                }
            }

            if (!_.isEmpty(cacheProfile.rolesRparts) && vm.dmsConnected) {
                var rpartsProfile = OrderModuleConstants.rpartsProfile;
                angular.forEach(cacheProfile.rolesRparts, function (value) {
                    if(rpartsProfile.includes(value)){
                vm.isOrderMode = true;
            }
        });
        }
        vm.screenshotButtonVisibility = AlertsService.getScreenshotButtonVisibility();
    }

        function initOrderFocus() {
            $timeout(function () {
                var inputBox = document.getElementById('inputReference');
                if (inputBox) {
                    var partReqInputBox = angular.element(inputBox);
                    partReqInputBox[0].focus();
                }
            }, 0);
        }

        function openAlertsPopin(checkDocType) {
            var OMAlertList = OrderModuleConstants.OMAlertFields;
            var filteredResponse = [];
            if(!_.isEmpty(vm.orderModePartsList.items)){
                filteredResponse = _.map(vm.orderModePartsList.items, function (item) {
                    return _.pick(item, OMAlertList);
                });
            }
            AlertsService.setOMAlertPayload({ cartsErrorDetails:vm.orderDetailsForAlerts, priceStockDMSDetails: filteredResponse});
            AlertsService.setPopinVisibility(true, checkDocType,null, (checkDocType === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));

        }
    
        /**
         * @desc to display the pop up for parts stock selection
         */
        function orderModePopup(isOrderMode) {
            
            vm.isOrderMode = isOrderMode;
            
            CacheService.setObject(CacheConstants.isOrderMode, isOrderMode);

            if (!isOrderMode) {
                CacheService.removeObject(CacheConstants.newOrderStart);
                vm.partsRequisition = CacheService.getObject(PartRequisitionConstants.bs);
                _.map(vm.partsRequisition.items,function(item){
                    if(vm.orderModePartsList && !_.isEmpty(vm.orderModePartsList.items)){
                        vm.orderModePartsList.items.forEach(function(obj){
                            if(obj.reference === item.reference){
                                _.assign(item,{dmsInformations:obj.dmsInformations})
                            }
                        })
                    }
                })
                closeOrderModeView();
            }
            
            if (isOrderMode) {
                CacheService.setObject(CacheConstants.newOrderStart, moment(new Date()));
                
                $mdDialog.show({
                    templateUrl: 'app/components/orderModule/orderMethodSelectionPopup.html',
                    controller: 'orderMethodSelectionController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        isOrderMode: vm.isOrderMode
                    }
                }).then(function (methodResponse) {
                    if (methodResponse && methodResponse.selectedMethod === 'direct') {
                        showOrderModePopup();
                    } else {
                        vm.isOrderMode = false;
                        CacheService.setObject(CacheConstants.isOrderMode, false);
                    }
                }).catch(function() {
                    vm.isOrderMode = false;
                    CacheService.setObject(CacheConstants.isOrderMode, false);
                });

            }
        }

        function showOrderModePopup() {
                $mdDialog.show({
                    templateUrl: 'app/components/orderModule/orderModePopup.html',
                    controller: 'orderModePopupController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: false,
                    locals: {
                        isOrderMode: vm.isOrderMode
                    }
                }).then(function (response) {
                    if (response && !response.isSwitchEnabled) {
                        vm.isOrderMode = false;
                    }
                    if (response && response.isSwitchEnabled) {
                        vm.showOrderModeView = true;
                        AlertsService.setPopinVisibility(false,'',null,(response.selectedOption === 'INT' ? vm.isTraceEnabledINT : vm.isTraceEnabled));
                        if (response.selectedOption === OrderModuleConstants.orderModePopOption1) {
                            vm.orderModePartsList = angular.copy(vm.partsRequisition);
                        }
                        if (response.selectedOption === OrderModuleConstants.orderModePopOption2) {
                            vm.orderModePartsList = angular.copy(vm.partsRequisition);
                            var itemsWithoutStock = [];

                            vm.orderModePartsList.items.forEach(function (item) {
                                if (item.dmsInformations && (item.dmsInformations.quantity === 0 || item.dmsInformations.quantity === undefined)) {
                                    itemsWithoutStock.push(item);
                                }
                            });
                            vm.orderModePartsList.items = itemsWithoutStock;
                        }
                        if (vm.orderModePartsList && !_.isEmpty(vm.orderModePartsList.items)) {
                            if(cacheProfile.country == 'CH'){
                                vm.urgentOrder = true;
                            } else {
                                vm.urgentOrder = false;
                            }
                            checkDealerList(null);
                        }
                    }
                });
        }

        /**
         * @desc Close order mode and go back to part Requisition screen
         */
        function closeOrderModeView() {
            vm.isOrderMode = true;
            $mdDialog.show({
                templateUrl: orderModeClosePopup,
                controller: 'orderModeClosePopupController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false,
                locals: {
                    isOrderMode: vm.isOrderMode,
                    message: $translate.instant("ORDER_MODE_CLOSPOPUP_DESCRIPTION1"),
                    message2: $translate.instant("ORDER_MODE_CLOSPOPUP_DESCRIPTION2"),
                    confirmMessage: $translate.instant("ACTIS_SAVE_INFORMATIONS_YES"),
                    cancelMessage: $translate.instant("ACTIS_SAVE_INFORMATIONS_NO")
                }

            }).then(function (response) {
                if (response && response.isOrderModeEnabled) {             //vm.isOrderMode=false;
                    AlertsService.setEmailDesc(null);
                    AlertsService.setScreenshotButtonVisibility(false);
                    vm.orderDetailsForAlerts = null;
                    vm.showOrderModeView = false;
                    vm.isOrderMode = false;
                    CacheService.setObject(CacheConstants.isOrderMode, false);
                    vm.orderModePartsList = CacheService.getObject(CacheConstants.orderModePartsList);
                    _.map(vm.orderModePartsList.items, function (item) {
                        if (vm.partsRequisition && !_.isEmpty(vm.partsRequisition.items)) {
                            vm.partsRequisition.items.forEach(function (obj) {
                                if (obj.reference === item.reference) {
                                    _.assign(obj, { dmsInformations: item.dmsInformations, quantity: item.quantity })
                                }
                            })
                        }
                    })
                    CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
                    CacheService.removeObject(CacheConstants.orderModePartsList);
                    CacheService.removeObject(CacheConstants.newOrderStart);
                }
                else {
                    CacheService.setObject(CacheConstants.isOrderMode, true);

                }


            })


        }

        function goToProductPage(ref) {
            vm.gotoProductPage(ref);
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        function sortByRef(propertyName) {
            vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        function checkDealerList(ref, isUpdate) {
            var cartList = [];
            vm.countryCode = cacheProfile.country;
            vm.isRNETUser = cacheProfile.userType == "RNET" ? true : false;
            vm.isDmsConnected = DealerManagerSystemeService.getHookResult();
            if (vm.isOrderMode && vm.isRNETUser && vm.isDmsConnected) {
                var productList = [];
                var refQuantityList = [];
                if (ref) {
                    cartList.push(ref);
                } else {
                    cartList = vm.orderModePartsList.items;
                }
                cartList.forEach(function (item) {
                    productList.push(item.reference);
                    refQuantityList.push({
                        "reference": item.reference,
                        "quantity": item.quantity.toString()
                    });

                    if (isUpdate) {
                        var r2aList = CacheService.getObject(CacheConstants.orderModePartsList);
                        _.map(r2aList.items, function (data) {
                            if (data.reference === item.reference) {
                                data.quantity = item.quantity;
                            }
                        })
                        CacheService.setObject(CacheConstants.orderModePartsList, r2aList);
                    }
                })
                var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
                if (cachedetail && cachedetail.dealers && cachedetail.garageId != undefined) {
                    var dealerList = _.find(cachedetail.dealers, function (item) {
                        return item.active == true;
                    });
                    if (dealerList && !_.isEmpty(productList) && !isUpdate) {
                        //cachedetail.garageId = "00027076";
                        //cacheProfile.dealerId = "00000722";
                        getPriceTaxDiscount(ref,cachedetail.garageId, dealerList.dealerId, productList, cachedetail.r1);
                    }
                    if(dealerList && !_.isEmpty(refQuantityList)){                        
                        //cachedetail.garageId= "00027076";
                        //dealerList.dealerId= "00000722";
                        getStockDetails(ref,cachedetail.garageId, dealerList.dealerId, refQuantityList);
                    }                   
                }
            }
        }
        function getPriceTaxDiscount(refItem, garageId, dealerId, productList,isr1) {
            // blockUI.start();
            var url = CarSearchConstants.r2aPriceTaxDiscount;
            vm.fetchUpdatedPrice = false;
            var panierList = [];
            if (refItem)
                panierList.push(refItem);
            else {
                panierList = vm.orderModePartsList.items;
            }

            _.map(vm.orderModePartsList.items, function (item) {
                productList.forEach(function (product) {
                    if (product === item.reference) {
                        _.assign(item, { isLoadingPriceData: true })
                    }
                })
            })
            vm.allPriceDataLoader = true;
            return ShoppingCartWSService.getR2APriceStockDetails(garageId, dealerId, productList, url, vm.urgentOrder, isr1).then(function (response) {
                //response = {"repository":"BIR","dealerId":"75699080","garageId":"75699081","products":[{"reference":"7701208110","taxRate":8,"discountCode":"57","discountRate":16,"discountRateUrgent":16,"priceTaxFree":140.28,"priceTaxIncluded":151.50,"priceAdvisedTaxFree":167.00,"priceAdvisedTaxIncluded":180.36,"priceUrgentTaxFree":2.00,"priceUrgentTaxIncluded":0.00,"currency":"CHF","itemReturnCode":"A000","itemReturnMessage":"Item OK"},{"reference":"7701036907","taxRate":8,"discountCode":"57","discountRate":16,"discountRateUrgent":16,"priceTaxFree":223.44,"priceTaxIncluded":241.32,"priceAdvisedTaxFree":266.00,"priceAdvisedTaxIncluded":287.28,"priceUrgentTaxFree":12.00,"priceUrgentTaxIncluded":0.00,"currency":"CHF","itemReturnCode":"A000","itemReturnMessage":"Item OK"}]};
                if (!_.isEmpty(panierList) && response && !_.isEmpty(response.products)) {
                    panierList.forEach(function (pr) {
                        response.products.forEach(function (ref) {
                            if (pr.reference === ref.reference) {
                                if (ref.itemReturnCode === "A000") {
                                    _.extend(pr, ref, {
                                        isDiscountcodeVisible: false
                                    });
                                } else{
                                    _.extend(pr, ref);
                                }
                            if(pr.dmsInformations && pr.dmsInformations.cort !== "-" && ref.itemReturnCode === "A000"){
                                pr.discountCode = pr.dmsInformations.cort;
                            }
                            else if(!pr.dmsInformations && ref.itemReturnCode === "A000"){
                                pr.discountCode = ref.discountCode;
                            }
                        }
                        })
                    })

                    var itemReturnCodeUnkown = false;
                    if(!_.isEmpty(response.products)){
                            for(var i =0; i < response.products.length; i++ ){
                               if(response.products[i].itemReturnCode === 'A001'){ 
                                itemReturnCodeUnkown = true;
                                $mdDialog.show({
                                        templateUrl: orderModeClosePopup,
                                        controller: 'orderModeClosePopupController',
                                        bindToController: true,
                                        controllerAs: 'vm',
                                        clickOutsideToClose: false,
                                        locals: {
                                            isOrderMode: vm.isOrderMode,
                                            message: $translate.instant("ORDER_MODE_WARN_MESSAGE"),
                                            message2: $translate.instant("ORDER_MODE_DELETE_UNKNOWN_REFERENCES"),
                                            orderModeWarnPop: true
                                        }  
                                    })
                                break;
                                }
                            }  
                        }
                    _.assign(response, {"urgentOrderPrices" : vm.urgentOrder});
                    vm.r2aPriceResponse = response;
                }
                
                if (refItem) {
                    vm.orderModePartsList.items = _.map(vm.orderModePartsList.items, function (obj) {
                        return _.assign(obj, _.find(panierList, { reference: obj.reference }));
                    });
                    vm.orderModePartsList.items = _.uniq(vm.orderModePartsList.items);
                    mapPriceStockValues('PRICE');
                } else {
                    vm.orderModePartsList.items = panierList;
                }
            }).catch(function (error) {
                if(error && error.data && !_.isEmpty(error.data.errors[0]) && error.data.errors[0].errorCode.length == 4){
                    toastr.error($translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                }
                vm.priceError = true;
            }).finally(function () {
                _.map(vm.orderModePartsList.items, function (item) {
                    productList.forEach(function (product) {
                        if (product === item.reference) {
                            _.assign(item, { isLoadingPriceData: false })
                        }
                    })
                })
                vm.allPriceDataLoader = false;
                CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
                if (vm.validateClicked) {
                    vm.fetchUpdatedPrice = true;
                    placeOrderStockPriceUpdated();
                }
            })
        }

        $rootScope.$on("central_unavailable",function(){           
            _.map(vm.orderModePartsList.items, function (item) {
                        _.assign(item, { isLoadingStockData: false })
            })            
            CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
            vm.stockError = true;
        })
        function displayDiscountRate(pr) {
            pr.isDiscountcodeVisible = (pr.isDiscountcodeVisible) ? false : true;
            if (vm.orderModePartsList.items.length == 1)
                vm.showAllDiscountRate = false;
        }

        function displayAllDiscountRate() {
            if (vm.orderModePartsList && !_.isEmpty(vm.orderModePartsList.items)) {
                if (!vm.showAllDiscountRate) {
                    vm.orderModePartsList.items.forEach(function (pr) {
                        pr.isDiscountcodeVisible = true;
                    })
                    vm.showAllDiscountRate = true;
                } else {
                    vm.orderModePartsList.items.forEach(function (pr) {
                        pr.isDiscountcodeVisible = false;
                    })
                    vm.showAllDiscountRate = false;
                }
            }
        }
        function getPriceToDisplay(item) {
            var price = UtilsMetierService.getPriceToDisplay(
                item.price, !item.dmsInformations ? null : item.dmsInformations.priceExclTaxes);
            return price;
        }

        function getCurrencyForItem(piece) {
            if (piece && piece.dmsInformations && piece.dmsInformations.isKnowFromDms) {
                return UtilsMetierService.getCurrencyForItem(piece.dmsInformations.isKnowFromDms)
            } else {
                return UtilsMetierService.getCurrencyForItem()
            }
        }
        function addRef(ref) {

            if (!ref) {
                return;
            }
            if (ref.length !== 10) {
                toastr.error($translate.instant('ERROR_INVALID_REFERENCE'));
                return;
            }

            ref = ref.toUpperCase();
            var item = _.find(vm.orderModePartsList.items, function (item) {
                return item.reference === ref;
            });

            blockUI.start();
            $q.resolve().then(function () {
                if (item) {
                    // update current item
                    item.quantity += 1;
                    vm.ref = "";
                    ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_QUANTITY, { piece: item });
                    return item;
                } else {
                    return DocumentsMetierService.getPRLight([ref]).then(function (products) {
                        // call DH
                        if (!products || !products.length) {
                            return null;
                        }
                        return products[0];
                    }, function () {
                        return null;
                    }).then(function (RefInformations) {
                        // return a promise which contains DMS/DH informations on user reference input
                        return DmsMetierService.getReferencesDms([ref]).then(function (response) {
                            // call DMS
                            var error = response.response.returnCode;
                            var part = response.response.parts[0];
                            var DMSRefInformations;

                            if (error || !part.priceExclTaxes) {
                                DMSRefInformations = null;
                            } else {
                                DMSRefInformations = part;
                            }
                            return {
                                fromDMS: DMSRefInformations,
                                fromDH: RefInformations
                            };
                        }, function (err) {
                            if (!err.status) {
                                return {
                                    fromDMS: null,
                                    fromDH: RefInformations
                                }
                            } else {
                                return $q.reject(err);
                            }
                        });
                    }).then(updateShoppingCartState).then(function (item) {
                        vm.orderModePartsList.items.push(item);
                        vm.partsRequisition.items.push(item);
                        CacheService.setObject(PartRequisitionConstants.bs, vm.partsRequisition);
                        savePartRequisition(vm.partsRequisition, true);
                        vm.ref = "";
                        return item;
                    });
                }
            }).then(function (item) {
                // UPDATE TABLE
                return PartRequisitionMetierService.onUpdateCart([item]).then(function (partRequisition) {
                    if (partRequisition.items.length > 0) {
                        partRequisition.items.forEach(function (partRequisitionItem) {
                            if (partRequisitionItem.reference === item.reference) {
                                item.id = partRequisitionItem.id;
                            }
                        });
                    }
                    return item;
                });
            }).then(function (item) {
                mapPriceStockValues();
                var refItem = _.filter(vm.orderModePartsList.items, function (item) {
                    return item.reference == ref;
                })
                checkDealerList(refItem[0]);
                // SCROLL TO THE REF
                var id = "_" + item.reference;
                ScrollService.toHash(id);
            }).catch(function (err) {
                if (!err.status) {
                    switch (err) {
                        case PartRequisitionConstants.errors.partNotFound:
                            toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                            break;
                        default:
                            toastr.error($translate.instant('ERROR'));
                            break;
                    }
                }
            }).finally(function () {
                blockUI.stop();
            });
        }
        function getStockDetails(refItem, garageId, dealerId, refQuantityList) {
            //blockUI.start();
            var url = CarSearchConstants.r2aStock;
            vm.fetchUpdatedStock = false;
            var panierList = [];
            if (refItem)
                panierList.push(refItem);
            else {
                panierList = vm.orderModePartsList.items;
            }

            _.map(vm.orderModePartsList.items, function (item) {
                refQuantityList.forEach(function (product) {
                    if (product.reference === item.reference) {
                        _.assign(item, { isLoadingStockData: true })
                    }
                })
            })
            vm.allStockDataLoader = true;
            ShoppingCartService.getR2APriceStockDetails(garageId, dealerId, refQuantityList, url, panierList).then(function (response) {
                if (response) {
                    panierList = response;
                    if (refItem) {
                        _.map(vm.orderModePartsList.items, function (obj) {
                            return _.assign(obj, _.find(panierList, { reference: obj.reference }));
                        });
                        vm.orderModePartsList.items = _.uniq(vm.orderModePartsList.items);
                        mapPriceStockValues('STOCK');
                    } else {
                        vm.orderModePartsList.items = panierList;
                    }
                }
            }).catch(function(error){
                vm.stockError = true;
            }).finally(function () {
                _.map(vm.orderModePartsList.items, function (item) {
                    refQuantityList.forEach(function (product) {
                        if (product.reference === item.reference) {
                            _.assign(item, { isLoadingStockData: false })
                        }
                    })
                })
                vm.allStockDataLoader = false;
                CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
                if (vm.validateClicked) {
                    vm.fetchUpdatedStock = true;
                    placeOrderStockPriceUpdated();
                }
            })
        }
        function mapPriceStockValues(priceOrStock) {
            var r2aList = CacheService.getObject(CacheConstants.orderModePartsList);
            _.map(vm.orderModePartsList.items, function (obj) {
                r2aList.items.forEach(function (item) {
                    if (item.reference === obj.reference) {
                        if (priceOrStock === 'STOCK') {
                            _.assign(obj, { isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode })
                        } else if (priceOrStock === 'PRICE') {
                            _.assign(obj, { applicableClass: item.applicableClass })
                        } else {
                            _.assign(obj, { isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode, applicableClass: item.applicableClass })
                        }
                    }
                })
            });
            CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
        }
        function updateShoppingCartState(refInfo) {
            // UPDATE SHOPPING CART SERVICE
            if (!refInfo.fromDMS && !refInfo.fromDH) {
                return $q.reject(PartRequisitionConstants.errors.partNotFound);
            }

            if (!refInfo.fromDMS && refInfo.fromDH) {
                toastr.info($translate.instant('COMMON_ERROR_REF_DMS'));
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDH,
                    type: 'PR'
                });
                return formatPart(refInfo.fromDH);
            } else if (refInfo.fromDMS && !refInfo.fromDH) {
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDMS,
                    type: 'PR'
                });
                return formatPart(refInfo.fromDMS);
            } else {
                ShoppingCartPartsService.updateShoppingCart(ShoppingCartConstants.actions.ADD_PIECE, {
                    piece: refInfo.fromDH,
                    type: 'PR'
                });
                return mergeData(refInfo.fromDH, refInfo.fromDMS);
            }
        }
        function formatPart(part) {
            return {
                reference: part.reference,
                designation: part.designation || part.description,
                price: part.priceExclTaxes,
                reach: part.reach,
                quantity: 1,
                orderType: 0,
                orderTypeObject: { id: 0 },
                currency: part.currency,
                familyCode: part.familyCode ? part.familyCode : null,
            }
        }
        function mergeData(DHRef, DMSRef) {
            var DMSData = DmsMetierService.buildDataFromDms([DMSRef]);
            DmsMetierService.addDmsInformationToCurrentPiece(DHRef, DMSData);
            // DHRef is mutated inside addDmsInformationToCurrentPiece
            DHRef.quantity = 1;

            if (DHRef.quantity > DMSData[0].stockQuantity) {
                DHRef.orderTypeObject = { id: 2 };
                DHRef.orderType = 2;
            } else {
                DHRef.orderTypeObject = { id: 0 };
                DHRef.orderType = 0;
            }

            return DHRef;
        }
        function deleteReference(item) {
            var ref = item.reference
            var body = angular.element(document.body);
            var designation = item.designation;
            var payload = {
                referenceId: item.id
            };

            var modalParams = {
                body: body,
                designation: designation,
                isList: false,
                title: "ORDER_DEL_REFERENCE",
                ref: ref,
                color: 'var(--renaultPrimaryColor)'
            }
            DeleteModalService.showModal(modalParams).then(function () {
                var orderIndex = _.findIndex(vm.orderModePartsList.items, function (piece) {
                    return piece.id === item.id;
                });
                if (orderIndex !== -1) {
                    orderIndex === 0 ? vm.orderModePartsList.items.shift() : vm.orderModePartsList.items.splice(orderIndex, 1);
                }
                CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);

                var index = _.findIndex(vm.partsRequisition.items, function (piece) {
                    return piece.id === item.id;
                });

                if (index !== -1) {
                    index === 0 ? vm.partsRequisition.items.shift() : vm.partsRequisition.items.splice(index, 1);
                }
                ShoppingCartPartsService.updateShoppingCart('DELETE_PIECE', payload);
                ShoppingCartPartsService.deleteItem(vm.partsRequisition.id, item.id).catch(function () {
                    $translate.instant('ERROR');
                });
            }).catch(function (err) {
                if (err) {
                    toastr.error($translate.instant('ERROR'));
                }
            })
        }
        function savePartRequisition(partRequisition, hidePopin) {
            PartRequisitionMetierService.savePartRequisitionLogic(partRequisition).then(function () {
                if (!hidePopin) {
                    $translate("PART_REQUISITION_SUCCESS").then(function (text) {
                        toastr.success(text + " (" + partRequisition.number + ")", { timeOut: 1500 });
                    });
                }
                // backToPrevious();
            }).catch(function () {
                $translate("PART_REQUISITION_FAILURE").then(function (text) {
                    toastr.error(text, { timeOut: 1500 });
                });
            });
        }
        function validateOrder() {
            if (vm.isValidatingOrder) {
                return; 
            }
            vm.isValidatingOrder = true;
            
            var evBatteryFamilyCodes = ['277M', '281R'];
            var hasEvBattery = false;
            var hasNonEvBattery = false;            
            if (vm.orderModePartsList && vm.orderModePartsList.items) {
                vm.orderModePartsList.items.forEach(function(item) {
                    if (item.familyCode && evBatteryFamilyCodes.includes(item.familyCode)) {
                        hasEvBattery = true;
                    } else {
                        hasNonEvBattery = true;
                    }
                });
            }

            if (hasEvBattery) {
                var hasMixedParts = hasEvBattery && hasNonEvBattery;
                
                $mdDialog.show({
                    templateUrl: evBatteryPopup,
                    controller: 'evBatteryPopupController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: false,
                    locals: {
                        hasMixedParts: hasMixedParts,
                        rpartstoreUrl: rpartstoreUrl
                    }
                }).then(function(response) {
                    if (response && response.action === 'transfer') {
                        var productList = [];
                        vm.orderModePartsList.items.forEach(function(item) {
                            productList.push({
                                reference: item.reference,
                                quantity: item.quantity
                            });
                        });
                        
                        if (productList.length === 0) {
                            toastr.error($translate.instant('ERROR'));
                            vm.isValidatingOrder = false;
                            return;
                        }
                        
                        blockUI.start();
                        ShoppingCartService.rpsPlaceOrder(productList)
                            .then(function(rpsResponse) {
                                blockUI.stop();
                                if (rpsResponse && rpsResponse.products && Array.isArray(rpsResponse.products)) {
                                    var errorCodes = { A001: false, A002: false, A099: false };
                                    for (var m = 0; m < rpsResponse.products.length; m++) {
                                        var p = rpsResponse.products[m];
                                        if (p.itemReturnCode === 'A001') errorCodes.A001 = true;
                                        if (p.itemReturnCode === 'A002') errorCodes.A002 = true;
                                        if (p.itemReturnCode === 'A099') errorCodes.A099 = true;
                                    }
                                    
                                    if (errorCodes.A099) {
                                        toastr.error($translate.instant('ERROR_A099'));
                                    }
                                    if (errorCodes.A001 || errorCodes.A002) {
                                        if (errorCodes.A001) toastr.error($translate.instant('ORDER_UNSUCCESS'));
                                        if (errorCodes.A002) toastr.error($translate.instant('ORDER_INCORRECT_QTY'));
                                    }
                                    if (!errorCodes.A001 && !errorCodes.A002 && !errorCodes.A099) {
                                        toastr.success($translate.instant('ORDER_SUCCESS'));
                                        
                                        if (vm.partsRequisition && vm.partsRequisition.id) {
                                            var updatePayload = {
                                                id: vm.partsRequisition.id,
                                                rpsTransferValue: true
                                            };
                                            ShoppingCartService.updateRpsPartsTransfer(updatePayload)
                                                .catch(function() {
                                                    toastr.error($translate.instant('ERROR'));
                                                });
                                        }
                                        vm.showOrderModeView = false;
                                        vm.isOrderMode = false;
                                        CacheService.setObject(CacheConstants.isOrderMode, false);
                                        CacheService.removeObject(CacheConstants.orderModePartsList);
                                        CacheService.removeObject(CacheConstants.newOrderStart);
                                    }
                                }
                                vm.isValidatingOrder = false;
                            })
                            .catch(function() {
                                blockUI.stop();
                                toastr.error($translate.instant('ERROR'));
                                vm.isValidatingOrder = false;
                            });
                                  
                    } else if (response && response.action === 'orderWithout') {
                        var filteredItems = vm.orderModePartsList.items.filter(function(item) {
                            return !(item.familyCode && evBatteryFamilyCodes.includes(item.familyCode));
                        });
                        
                        if (filteredItems.length === 0) {
                            toastr.error($translate.instant('ERROR'));
                            vm.isValidatingOrder = false;
                            return;
                        }
                        
                        vm.orderModePartsList.items = filteredItems;
                        CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
                        onClickOrderPopup();
                        
                    } else {
                      
                        vm.isValidatingOrder = false;
                    }
                }).catch(function() {
                    vm.isValidatingOrder = false;
                });
                
                return;
            }
           onClickOrderPopup();

        }

        function onClickOrderPopup(){
        var priceOrderList = [];
        var stockOrderList = [];
            var orderEndTime = moment(new Date());
            var orderStartTime = CacheService.getObject(CacheConstants.newOrderStart);
            var duration = moment.duration(moment(orderEndTime).diff(moment(orderStartTime)));
            vm.validateClicked = true;
            if (duration.minutes() >= 10) {
                vm.orderModePartsList.items.forEach(function (item) {
                    priceOrderList.push({ isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode});
                    stockOrderList.push({ applicableClass: item.applicableClass });
                })
                blockUI.start($translate.instant("LOADER_MESSAGE"));
                checkDealerList(null);
            } else {
                callPlaceOrder();
            }

        }
        
        function placeOrderStockPriceUpdated() {
            blockUI.stop();
            var newPriceOrderList = [];
            var newStockOrderList = [];
            if (vm.fetchUpdatedPrice && vm.fetchUpdatedStock) {
                vm.orderModePartsList.items.forEach(function (item) {
                    newPriceOrderList.push({ isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode });
                    newStockOrderList.push({ applicableClass: item.applicableClass });
                })
                //newPriceOrderList[0].discountRate =2;
                //newStockOrderList[0].applicableClass = '';
                var orderPriceUpdate = angular.equals(priceOrderList, newPriceOrderList);
                var orderStockUpdate = angular.equals(stockOrderList, newStockOrderList);
                
                if (vm.stockError && vm.priceError){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(vm.priceError && !orderStockUpdate){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    callPopUp("PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                        callPopUp("STOCK_UPDATE_SUCCESS","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                        })
                    })
                } else if (vm.priceError && orderStockUpdate){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    callPopUp("PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(vm.stockError && !orderPriceUpdate){                    
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                        callPopUp("PRICE_UPDATE_SUCCESS","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                        })
                    })
                } else if(vm.stockError && orderPriceUpdate){                    
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(!orderPriceUpdate || !orderStockUpdate){
                    callPopUp("STOCK_PRICE_CHANGED","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                        $mdDialog.hide();
                        callPlaceOrder();
                    }) 
                }
            }
        }
        function callPlaceOrder() {
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            var userIpn = CacheService.getObject(CacheConstants.profil) ? CacheService.getObject(CacheConstants.profil).ipn : null;
            var dealerList = null;
            var refQuantityList = [];
            if (cachedetail && !_.isEmpty(cachedetail.dealers) && cachedetail.garageId != undefined) {
                dealerList = _.find(cachedetail.dealers, function (item) {
                    return item.active == true;
                });
            }
            if (!_.isEmpty(vm.orderModePartsList.items)) {
                vm.orderModePartsList.items.forEach(function (item) {
                    refQuantityList.push({
                        "reference": item.reference,
                        "quantity": item.quantity
                    });
                })
            }
            blockUI.start();
            var isProductUnknown = false;
            var garageId = cachedetail && cachedetail.garageId != undefined ? cachedetail.garageId : '';
            ShoppingCartService.r2aPlaceOrder(dealerList,userIpn,
                refQuantityList,vm.orderModePartsList.orderMark,vm.orderModePartsList.message,vm.urgentOrder,garageId).then(function (response) {
                   // var response = {"repository":"BIR","ipn":"d015225","dealerId":"00090330","clientCode":"014007","products":[{"reference":"7700274177","quantity":1,"itemReturnCode":"A000","itemReturnMessage":"Item OK"},{"reference":"8671002274","quantity":1,"itemReturnCode":"A000","itemReturnMessage":"Item OK"},{"reference":"8200721889","quantity":1,"itemReturnCode":"A000","itemReturnMessage":"Item OK"}]};
                    if(response && response.returnCode==='H000'){
                        if(!_.isEmpty(response.products)){
                            for(var i =0; i < response.products.length; i++ ){
                               if(response.products[i].itemReturnCode != 'A000'){ 
                                isProductUnknown = true;
                                break;
                               }                  
                            }  
                        }
                        if(!response.orderNumber && !isProductUnknown){
                            toastr.error($translate.instant("PLACE_ORDER_ERROR"));
                            CacheService.setObject(CacheConstants.newOrderStart, moment(new Date()));
                        } else if(isProductUnknown){
                            toastr.error($translate.instant("ORDER_FAILED")+'\n'+$translate.instant("ERROR_A001"));
                            CacheService.setObject(CacheConstants.newOrderStart, moment(new Date()));
                        } else if(response.orderNumber && !isProductUnknown){
                            var rpsId = response.orderNumber;  
                            var id = vm.partsRequisition.id;
                            var url = CarSearchConstants.partRequisitionRpsId;
                            ShoppingCartService.updateRpsId(id, rpsId, url )
                                .catch(function (error) {
                                    toastr.error($translate.instant("UPDATE_RPS_ID_FAILED"));
                                });
                            $state.go(RoutesConstants.validatedOrder, { 
                                validatedOrder: vm.orderModePartsList, 
                                vehicle: vm.vehicle, 
                                isCountryIndia: vm.isCountryIndia, 
                                isCountryChina: vm.isCountryChina, 
                                isCountryRoumania: vm.isCountryRoumania, 
                                addOrderResponse: response, 
                                validatorInfo: { 
                                    dateAndTime: moment(new Date()).format("YYYY/MM/DD HH:mm"), ipn: response ? response.ipn : null, 
                                    urgentOrder: vm.urgentOrder 
                                } 
                            });
                            CacheService.removeObject(CacheConstants.newOrderStart);
                        } 
                    }
                }).catch(function (error) {
                    vm.orderDetailsForAlerts = (error && error.data) ? error.data.errors : error.data;
                    if(error && error.data && !_.isEmpty(error.data.errors)){
                        if(error.data.errors[0].errorCode === 'H003'){
                            $mdDialog.show({
                                templateUrl: orderModeClosePopup,
                                controller: 'orderModeClosePopupController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: true,
                                locals: {
                                    isOrderMode: vm.isOrderMode,
                                    message: $translate.instant("INVALID_IPN1"),
                                    message2: $translate.instant("INVALID_IPN2"),
                                    redirectLink: rpartsRedirectUrl
                                }       
                            }).then(function(response){
                                if(response && response.isOrderModeEnabled)
                                    $mdDialog.hide();
                            })
                        }else{
                            toastr.error($translate.instant("ORDER_FAILED")+'\n'+$translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                            CacheService.setObject(CacheConstants.newOrderStart, moment(new Date()));
                        }
                    }
                }).finally(function () {
                    blockUI.stop();
                    vm.validateClicked = false;
                    vm.isValidatingOrder = false;
                })
        }
        function saveMarkAndMessage() {
            CacheService.setObject(CacheConstants.orderModePartsList, vm.orderModePartsList);
        }
        function callPopUp(message1, message2){
            var deferred = $q.defer();
            $mdDialog.show({
                templateUrl: orderModeClosePopup,
                controller: 'orderModeClosePopupController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false,
                locals: {
                    message: $translate.instant(message1),
                    message2: $translate.instant(message2),
                    confirmMessage: $translate.instant("ORDER_CONFIRM"),
                    cancelMessage: $translate.instant("ACTIS_HEADER_CANCEL")
                }
            }).then(function (response) {
                if (response.isOrderModeEnabled) {
                    deferred.resolve();
                } else{
                    $mdDialog.hide();
                    CacheService.setObject(CacheConstants.newOrderStart, moment(new Date()));
                    deferred.reject();
                }
            });
            return deferred.promise;
        }
        function urgentOrderChange(){
            if(vm.urgentOrder){
                if(vm.r2aPriceResponse && !vm.r2aPriceResponse.urgentOrderPrices){
                    var cartList = vm.orderModePartsList.items;
                    var productList = [];
                    cartList.forEach(function (item) {
                        productList.push(item.reference);
                    });
                    var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
                    if (cachedetail && cachedetail.dealers && cachedetail.garageId != undefined) {
                        var dealerList = _.find(cachedetail.dealers, function (item) {
                            return item.active == true;
                        });
                        if (dealerList && !_.isEmpty(productList)) {
                            getPriceTaxDiscount(null,cachedetail.garageId, dealerList.dealerId, productList, cachedetail.r1);
                        }
                    }
                }
            }
        }
        function captureScreenshot() {
            blockUI.start();
            var node = document.body;
            html2canvas(node, {
                x: window.scrollX,
                y: window.scrollY,
                type: 'view'
            }).then(function (canvas) {
                vm.capturedImage = canvas.toDataURL();
                blockUI.stop();
                $mdDialog.show({
                    templateUrl: 'app/components/alerts/modal/screenShotModel/captureScreenshot.html',
                    controller: 'captureScreenshotController',
                    bindToController: true,
                    controllerAs: 'vm',
                    size: 'lg',
                    locals: {
                        capturedImage: vm.capturedImage
                    }
                });
            }).catch(function (error) {
                console.log("Error in htmlcanvas (orderModuleController):" + error);
            });
        }
        $scope.$on("$destroy", function () {
            AlertsService.setScreenshotButtonVisibility(false);
        });
        
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('orderModePopupController', orderModePopupController);

    /** @ngInject */
    function orderModePopupController($mdDialog, OrderModuleConstants) {
        var vm = this;
        var response = {};

        vm.selected = OrderModuleConstants.orderModePopOption1;

        vm.close = close;
        vm.confirm = confirm;

        this.$onInit = function () {
            vm.isSwitchEnabled = vm.isOrderMode;
        }

        function close(switchValue) {
            response.isSwitchEnabled = switchValue;
            $mdDialog.hide(response);
        }

        function confirm(switchValue) {
            response.isSwitchEnabled = switchValue;
            response.selectedOption = vm.selected;
            $mdDialog.hide(response);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('orderModeClosePopupController', orderModeClosePopupController);

    /** @ngInject */
    function orderModeClosePopupController($mdDialog) {
        var vm = this;
        var response = {};
       
        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;
        vm.onClose = onClose;

        function onClose() {
            $mdDialog.hide();
        }
        
        function onConfirm(switchValue) {
            response.isOrderModeEnabled = switchValue;
            $mdDialog.hide(response);
        }

        function onCancel(switchValue) {
            response.isOrderModeEnabled = switchValue;
            $mdDialog.hide(response);
        }
    }
})();
(function () {
    'use strict';

        angular.module('phenix').controller('orderMethodSelectionController', orderMethodSelectionController);

    function orderMethodSelectionController($mdDialog, isOrderMode, ShoppingCartService, CacheService, CacheConstants, PartRequisitionConstants, toastr, $translate, blockUI) {
        var vm = this;

        vm.selectedMethod = null;
        vm.isOrderMode = isOrderMode;
        vm.confirm = confirm;
        vm.transferToRpartStore = transferToRpartStore;
        vm.selectDirectOrder = selectDirectOrder;

        function selectDirectOrder() {
            vm.selectedMethod = 'direct';
            $mdDialog.hide({ selectedMethod: 'direct', confirmed: true });
        }

        function showErrorDialog(messages) {
            const messageContent = messages.map(function(msg) {
                return '<div style="font-weight:bold;margin-bottom:8px">' + msg + '</div>';
            }).join('');
            $mdDialog.show({
                template: '<md-dialog>' +
                    '<md-dialog-content>' +
                    '<div style="padding:24px;max-width:400px">' +
                    messageContent +
                    '</div>' +
                    '</md-dialog-content>' +
                    '</md-dialog>',
                controller: function DialogController() {
                    this.close = function () { $mdDialog.hide(); };
                },
                controllerAs: '$ctrl',
                clickOutsideToClose: true
            });
        }

        function transferToRpartStore() {
            try {
                vm.selectedMethod = 'rpartstore';
                vm.partsRequisition = CacheService.getObject(PartRequisitionConstants.bs);
                const productList = [];
                let requisitionId = null;

                if (vm.partsRequisition && vm.partsRequisition.items && vm.partsRequisition.items.length > 0) {
                    for (let i = 0; i < vm.partsRequisition.items.length; i++) {
                        const item = vm.partsRequisition.items[i];
                        productList.push({
                            reference: item.reference,
                            quantity: item.quantity,
                            designation: item.designation
                        });
                    }
                    requisitionId = vm.partsRequisition.id;
                } else {
                    const r2aList = CacheService.getObject(CacheConstants.basketList);
                    const interItems = r2aList && Array.isArray(r2aList.inter) ? r2aList.inter : [];

                    if (!r2aList || (!Array.isArray(r2aList.pr) && !Array.isArray(r2aList.tm) && interItems.length === 0)) {
                        toastr.error($translate.instant('ERROR'));
                        return;
                    }
                    if (interItems.length > 0) {
                        for (let l = 0; l < interItems.length; l++) {
                            const interItem = interItems[l];

                            if (Array.isArray(interItem.PR) && interItem.PR.length > 0) {
                                for (let m = 0; m < interItem.PR.length; m++) {
                                    const interPrItem = interItem.PR[m];
                                    productList.push({
                                        reference: interPrItem.reference,
                                        quantity: interPrItem.quantity,
                                        designation: interPrItem.designation
                                    });
                                }
                            }

                            if (Array.isArray(interItem.TM) && interItem.TM.length > 0) {
                                for (let n = 0; n < interItem.TM.length; n++) {
                                    const interTmItem = interItem.TM[n];
                                    productList.push({
                                        reference: interTmItem.reference || interTmItem.opecod,
                                        quantity: interTmItem.quantity,
                                        designation: interTmItem.designation
                                    });
                                }
                            }
                        }
                    }
                    if (Array.isArray(r2aList.pr) && r2aList.pr.length > 0) {
                        for (let j = 0; j < r2aList.pr.length; j++) {
                            const prItem = r2aList.pr[j];
                            productList.push({
                                reference: prItem.reference,
                                quantity: prItem.quantity,
                                designation: prItem.designation
                            });
                        }
                    }
                    if (Array.isArray(r2aList.tm) && r2aList.tm.length > 0) {
                        for (let k = 0; k < r2aList.tm.length; k++) {
                            const tmItem = r2aList.tm[k];
                            productList.push({
                                reference: tmItem.reference,
                                quantity: tmItem.quantity,
                                designation: tmItem.designation
                            });
                        }
                    }

                    if (productList.length === 0) {
                        toastr.error($translate.instant('ERROR'));
                        return;
                    }
                }

                blockUI.start();
                ShoppingCartService.rpsPlaceOrder(productList)
                    .then(function(response) {
                        blockUI.stop();
                        if (response && response.products && Array.isArray(response.products)) {
                            const errorCodes = { A001: false, A002: false, A099: false };
                            for (let m = 0; m < response.products.length; m++) {
                                const p = response.products[m];
                                if (p.itemReturnCode === 'A001') errorCodes.A001 = true;
                                if (p.itemReturnCode === 'A002') errorCodes.A002 = true;
                                if (p.itemReturnCode === 'A099') errorCodes.A099 = true;
                            }
                            if (errorCodes.A099) {
                                showErrorDialog([$translate.instant('ERROR_A099')]);
                            }
                            if (errorCodes.A001 || errorCodes.A002) {
                                const messages = [];
                                if (errorCodes.A001) messages.push($translate.instant('ORDER_UNSUCCESS'));
                                if (errorCodes.A002) messages.push($translate.instant('ORDER_INCORRECT_QTY'));
                                showErrorDialog(messages);
                            }
                            if (!errorCodes.A001 && !errorCodes.A002 && !errorCodes.A099) {
                                toastr.success($translate.instant('ORDER_SUCCESS'));
                            }
                        }
                        const updateId = requisitionId ? requisitionId : vm.cartId;
                        if (updateId) {
                            const updatePayload = {
                                id: updateId,
                                rpsTransferValue: true
                            };
                            ShoppingCartService.updateRpsPartsTransfer(updatePayload)
                                .catch(function() {
                                    toastr.error($translate.instant('ERROR'));
                                });
                        }
                        const result = {
                            selectedMethod: 'rpartstore',
                            confirmed: true,
                            transferSuccess: true,
                            data: response
                        };
                        $mdDialog.hide(result);
                    })
                    .catch(function() {
                        blockUI.stop();
                        toastr.error($translate.instant('ERROR'));
                        const updateId = requisitionId ? requisitionId : vm.cartId;
                        if (updateId) {
                            const updatePartsPayload = {
                                id: updateId,
                                rpsTransferValue: false
                            };
                            ShoppingCartService.updateRpsPartsTransfer(updatePartsPayload)
                                .catch(function() {
                                    toastr.error($translate.instant('ERROR'));
                                });
                        }
                    });
            } catch (e) {
                blockUI.stop();
                toastr.error($translate.instant('ERROR'));
            }
        }
        }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('evBatteryPopupController', evBatteryPopupController);

    /** @ngInject */
    function evBatteryPopupController($mdDialog, hasMixedParts, rpartstoreUrl) {
        const vm = this;
        
        vm.hasMixedParts = hasMixedParts;
        vm.rpartstoreUrl = rpartstoreUrl;
        vm.onCancel = onCancel;
        vm.onTransferBasket = onTransferBasket;
        vm.onOrderWithoutEvBattery = onOrderWithoutEvBattery;

        function onCancel() {
            $mdDialog.hide({ action: 'cancel' });
        }
        
        function onTransferBasket() {
            $mdDialog.hide({ action: 'transfer' });
        }

        function onOrderWithoutEvBattery() {
            $mdDialog.hide({ action: 'orderWithout' });
        }
    }
})();

/**
 * multiProfile
 * @namespace Components
 */
(function () {

    angular
        .module('phenix')
        .component('multiProfile', {
            bindings: {
                userContextList: '<',
                userName: '<'
            },
            controller: multiProfileController,
            controllerAs: 'vm',
            templateUrl: 'app/components/login/multiProfile.template.html'
        }).controller('multiProfileController', multiProfileController);

    function multiProfileController($mdDialog,$window,configConstantes) {
        var vm = this;

        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.onSelect = onSelect;
        vm.onCancel = onCancel;
        vm.getLogo = getLogo;
        var sessionStorage = $window.sessionStorage;

        vm.$onInit = function () {

        }

        function onSelect() {            
            vm.selectedUserContext = vm.userContextList.find(function(userContext) {
                return userContext.id == vm.selectedUid;
            });            
            var selectedBrand = {
                "selectedUserContext": vm.selectedUserContext
            }

            var oktaRnetProfilValue = {
                userContextList: vm.userContextList
            }
            sessionStorage.setItem('profil', JSON.stringify(selectedBrand));
            $mdDialog.hide(vm.selectedUid);
        }

        function onCancel() {
            $mdDialog.cancel();
        }

        function getLogo(brand){
            return './assets/svg/'+brand.toLowerCase()+'.svg';
        }                
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider
            // for nested views, you have to write a ste: 'stateParent.myState'
            .state(RoutesConstants.default, {
                url: '/',
                templateUrl: 'app/components/login/default.template.html',
                controller: 'defaultP',
                controllerAs: 'ctrl',
                authenticate: false,
                params: {
                    token: null
                },resolve: {
                        token: function(TokenService, LoginMetierService, $window, RoutesConstants, $mdDialog,
                            toastr, $translate, CacheService, UtilsMetierService, UserKeyService) {
                            if ($window.sessionStorage.getItem('ndExternalHandover')) {
                                return TokenService.getToken();
                            }
                            var isOktaRedirect = UtilsMetierService.isOktaAuthentication();
                            var userType = CacheService.getUserType();
                            if (userType && (userType.toLowerCase() == "arca" || (isOktaRedirect && userType.toLowerCase() == "rnet"))) {
                                var token = TokenService.getToken();
                                if (token) {
                                    window.location.href = window.location.origin + '/#!/?token=' + token;
                                    return token;
                                } else {
                                    var respParam = window.location.search;
                                    if (respParam && respParam.includes('code') && !respParam.includes('error')) {
                                        return LoginMetierService.openIdCallback(userType).then(function(response) {                                            
                                            if(userType.toLowerCase() == "arca"){
                                                var access_token = response.token;
                                                
                                                // Store userKey for ARCA users
                                                if (response.userKey) {
                                                    UserKeyService.setUserKey(response.userKey);
                                                }
                                            }
                                            else if(userType.toLowerCase() == "rnet"){                                                
                                                var access_token = $window.jwt_decode(response.id_token);                                                                                                
                                            }                                            
                                            if(userType.toLowerCase() == "rnet"){
                                                var oktaToken = response;                                                                                                
                                                var access_token = $window.jwt_decode(response.id_token);
                                                if (_.has(access_token, 'userContext')) {
                                                    var userContextList = [];
                                                    var functionCodesByGroup = {};
                                                    _.map(access_token.userContext, function (item) {
                                                        var userSplit = item.split(/[:;|]/);

                                                        var substring = userSplit[5];
                                                        var userContextStr = item.toString();
                                                        var siteIndex = item.indexOf(substring);
                                                        var siteNames = userContextStr.substring(siteIndex);

                                                        var siteArr = siteNames.split('|');

                                                        if (userSplit.length < 7 && siteArr.length>=2) {
                                                            return; 
                                                        }
                                                        var uid = userSplit[0];
                                                        var brand = userSplit[1];
                                                        var code = userSplit[2];
                                                        var siteSourceId = userSplit[3];
                                                        var identitySource = userSplit[4];
                                                        var siteName = siteArr[0];
                                                        var siteShortName = siteArr[1];
                                                        var groupKey = [uid, siteSourceId].join(':');
                                                        var existingItem = _.find(userContextList, function (context) {
                                                            return context.groupKey === groupKey;
                                                        });

                                                        if (existingItem) {
                                                            if (!existingItem.brand.includes(brand)) {
                                                                existingItem.brand.push(brand);
                                                            }
                                                            if (!existingItem.functionCodes.includes(code)) {
                                                                existingItem.functionCodes.push(code);
                                                            }
                                                        } else {
                                                            userContextList.push({
                                                                groupKey: groupKey,
                                                                uid: uid,
                                                                brand: [brand],
                                                                code: code,
                                                                functionCodes: [code],
                                                                siteSourceId: siteSourceId,
                                                                identitySource: identitySource,
                                                                siteName: siteName,
                                                                siteShortName: siteShortName,
                                                                selected: false
                                                            });
                                                        }
                                                    });

                                                    access_token.userContext = _.map(userContextList, function (context) {
                                                        functionCodesByGroup[[context.uid, context.siteSourceId].join(':')] = context.functionCodes;
                                                        delete context.groupKey;
                                                        return context.uid + ':' + context.brand + ';' + context.code + ';' + context.siteSourceId + '|' + context.identitySource + '|' + context.siteName + '|' + context.siteShortName;
                                                    });
                                                }
                                                if(_.has(access_token,'userContext') && access_token.userContext.length > 1){
                                                    var userContextDetails = access_token.userContext;                                                
                                                    var userContextList = [];
                                                    _.map(userContextDetails, function(item){
                                                        var userSplit = item.split(/[:;|]/);
                                                        var substring = userSplit[5];
                                                        var userContextStr = item.toString();
                                                        var siteIndex = item.indexOf(substring);
                                                        var siteNames = userContextStr.substring(siteIndex);

                                                        var siteArr = siteNames.split('|');

                                                        var brand = userSplit[1].split(',');
                                                        var finalUserContext = {
                                                            'uid' : userSplit[0],
                                                            'brand': brand !== null && brand.length > 0 && brand[0] !== '' ? brand : null,
                                                            'code': userSplit[2],
                                                            'functionCodes': functionCodesByGroup[[userSplit[0], userSplit[3]].join(':')] || (userSplit[2] ? [userSplit[2]] : []),
                                                            'siteSourceId': userSplit[3],
                                                            'identitySource': userSplit[4],
                                                            'siteName': siteArr[0],
                                                            'shortName': siteArr[1],
                                                            'selected': false
                                                        }                                                        
                                                        userContextList.push(finalUserContext);
                                                    })
                                                    
                                                    userContextList = _.filter(userContextList, function(uc){
                                                         return !_.isEmpty(uc.brand) && !_.isEmpty(uc.uid) && !_.isEmpty(uc.siteSourceId);
                                                    })
                                                   if(!_.isEmpty(userContextList)){
                                                    var firstName = _.has(access_token,'firstName') ? access_token.firstName : '';
                                                    var lastName = _.has(access_token,'lastName') ? access_token.lastName : '';
                                                    var userName = firstName.concat(' ',lastName);
                                                    var arrayWithIds = userContextList.map(function(item, index) {
                                                        return Object.assign({}, item, { id: index + 1 });
                                                    });
                                                    userContextList = arrayWithIds;
                                                    $mdDialog.show({
                                                        templateUrl: 'app/components/login/multiProfile.template.html',
                                                        controller: 'multiProfileController',
                                                        bindToController: true,
                                                        controllerAs: 'vm',
                                                        clickOutsideToClose: true,
                                                        locals: {
                                                            userContextList: userContextList,
                                                            userName : userName
                                                        }
                                                    }).then(function (result) {
                                                        _.map(userContextList,function(userContext){
                                                            if(userContext.id == result){
                                                                userContext.selected = true;
                                                            }
                                                        });
                                                        var oktaRnetProfilValue = {
                                                            userContextList: userContextList,
                                                            oktaTokenResponse: oktaToken
                                                        }                                                        
                                                        sessionStorage.setItem('oktaRnetProfil', JSON.stringify(oktaRnetProfilValue));                                                        
                                                        var retrievedBrand = JSON.parse(sessionStorage.getItem('profil'));
                                                        if(retrievedBrand && retrievedBrand.selectedUserContext && retrievedBrand.selectedUserContext.id){
                                                            delete retrievedBrand.selectedUserContext.id;
                                                        }
                                                        var selectedUserContext = _.omit(retrievedBrand.selectedUserContext, ['functionCodes']);
                                                        return LoginMetierService.updateUserContext(selectedUserContext, oktaToken).then(function(updatedUserContext){
                                                            var access_token = updatedUserContext.token;
                                                            
                                                            // Store userKey for RNET users with multiple contexts
                                                            if (updatedUserContext.userKey) {
                                                                UserKeyService.setUserKey(updatedUserContext.userKey);
                                                            }
                                                            
                                                            TokenService.setToken(access_token);
                                                            window.location.href = window.location.origin + '/#!/?token=' + access_token;
                                                            return access_token;
                                                        })
                                                    }).catch(function (error) {
                                                        window.location.href = window.location.origin + '/#!/connection';
                                                    });
                                                    }else{
                                                        window.location.href = window.location.origin + '/#!/connection';
                                                    }
                                                }else if(_.has(access_token,'userContext') && access_token.userContext.length === 1 && response.token){
                                                        var oktaRnetProfilValue = {
                                                            functionCodes: _.find(functionCodesByGroup) || [],
                                                            oktaTokenResponse: response
                                                        }
                                                        
                                                        // Store userKey for RNET users with single context
                                                        if (response.userKey) {
                                                            UserKeyService.setUserKey(response.userKey);
                                                        }
                                                        
                                                        sessionStorage.setItem('oktaRnetProfil', JSON.stringify(oktaRnetProfilValue));   
                                                        TokenService.setToken(response.token);
                                                        window.location.href = window.location.origin + '/#!/?token=' + response.token;
                                                        return response.token;
                                                } else if(!_.has(access_token,'userContext') || (_.has(access_token,'userContext') && (!Array.isArray(access_token.userContext) || access_token.userContext.length < 1))){                                                                                                                
                                                        var language =  window.navigator.language;
                                                        var getLanguage = language.substring(0, language.indexOf('-'));                                                        
                                                        $translate.use(getLanguage).then(function() {                                                        
                                                        var errorMessage = $translate.instant('USER_CONTEXT_ERROR');
                                                        toastr.error(errorMessage);
                                                        angular.element($0).scope().$apply();                                                                                                                
                                                     });
                                                }
                                                else {
                                                        window.location.href = window.location.origin + '/#!/connection';
                                                }
                                            }else{
                                                        TokenService.setToken(access_token);
                                                        window.location.href = window.location.origin + '/#!/?token=' + access_token;
                                                        return access_token;                                                       
                                            }                                            
                                        }).catch(function(err) {
                                            window.location.href = window.location.origin + '/#!/connection';
                                        });
                                    } else {
                                        window.onload = function() {
                                            window.location.href = window.location.origin + '/#!/connection';
                                        };
                                    }
                                }
                            }
                            return undefined;
                        }
                }   
            })

        $stateProvider
            .state(RoutesConstants.connection, {
                url: '/connection',
                templateUrl: 'app/components/login/connection.template.html',
                controller: 'ConnectionCtrl',
                controllerAs: 'ctrl',
                authenticate: false
            });
    }

})();

'use strict';

angular.module('phenix').constant('LoginConstants', {

  loginSuccess: 'auth-login-success',
  loginFailed: 'auth-login-failed',
  logoutSuccess: 'auth-logout-success',
  sessionTimeout: 'auth-session-timeout',
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized',
  logisticIds: '/proxy/apigee/technical-documentation/dialogys/site-ids',
  trace: '/proxy/apigee/dog/engineering-tickets/v1/sites/site-ids',
  mrTmRequests: '/proxy/apigee/dog/engineering-tickets/v1/requests',
  restAuthentification: '/users/authenticate',
  informations: 'informations/getMessage',
  independentUser: 'INDEPENDENT_USER',
  infoConsent: 'user/updateConsent',
  storeUserconnection:'usersConnections/createConnection',
  openIdCallback: '/login/open-id-callback',
  nissanIndepLogin: '/nissanAuth/login',
  authorize: '/rest/login/authorize/',
  ndApiSecret: "6f69aec02Aa483a79EC8739a04e0a388",
  ndApiVector: "NewDialogys59104",
  independentLogin: '/asomAuth/independentLogin',
  updateUserContext: '/login/updateUserContext',
  b2bPortalUrl: 'https://eu.nissan.biz/',
  aosPortalUrl: 'https://eu.nissan.biz/EURO6/#/app/home'
});

(function () {
    const MAX_HANDOVER_LENGTH = 10000;
    const MAX_PARAMETER_LENGTH = 1024;
    const BT_OFFSET_REFERENCE_MIN = 10001;
    const BT_OFFSET_REFERENCE_MAX = 29999;
    const BT_REFERENCE_OFFSET = 10000;
    const BT_FULL_REFERENCE_LENGTH = 5;
    const BT_SHORT_REFERENCE_LENGTH = 4;

    angular.module('phenix')
        .factory('ExternalEntryHandoverService', ['TokenService', '$window', '$q', '$state', 'RoutesConstants', '$controller',
            function (TokenService, $window, $q, $state, RoutesConstants, $controller) {
                    const actions = ['vehicle', 'md', 'mr', 'bt', 'diagnostic', 'diagnostic-file',
                        'dtc', 'symptom', 'wiring', 'wiring-component', 'wiring-components',
                        'wiring-signals', 'wiring-detail', 'partshop', 'partshop-vin',
                        'partshop-account', 'workshop-order'];

                    function hasValidParameters(params) {
                        if (!params || typeof params !== 'object' || Array.isArray(params)) {
                            return false;
                        }
                        const validFields = Object.keys(params).every(function (key) {
                            return typeof params[key] === 'string' && params[key].length <= MAX_PARAMETER_LENGTH;
                        });
                        return validFields && (!params.VIN || /^[A-HJ-NPR-Z0-9]{17}$/.test(params.VIN));
                    }

                    function parseHandover(raw, profile) {
                        if (!profile || !raw || raw.length > MAX_HANDOVER_LENGTH) {
                            throw new Error('INVALID_EXTERNAL_HANDOVER');
                        }
                        const request = JSON.parse(raw);
                        if (!request || actions.indexOf(request.action) < 0 || !hasValidParameters(request.params)) {
                            throw new Error('INVALID_EXTERNAL_HANDOVER');
                        }
                        return request;
                    }

                    function consume() {
                        if (!TokenService.getToken()) {
                            $window.sessionStorage.removeItem('ndExternalHandover');
                            $state.go(RoutesConstants.connection);
                            return $q.resolve(null);
                        }
                        return TokenService.handleToken().then(function (profile) {
                            const raw = $window.sessionStorage.getItem('ndExternalHandover');
                            $window.sessionStorage.removeItem('ndExternalHandover');
                            return parseHandover(raw, profile);
                        }).catch(function () {
                            $state.go(RoutesConstants.carSearch);
                            return null;
                        });
                    }
                    return {
                        hasPending() {
                            return !!$window.sessionStorage.getItem('ndExternalHandover');
                        },
                        run() {
                            return consume().then(function (handover) {
                                if (handover) {
                                    $controller('ExternalEntryHandoverController', { handover });
                                }
                            });
                        }
                    };
            }])
        .controller('ExternalEntryHandoverController', ['handover', '$injector', function (handover, $injector) {
                    if (!handover) {
                        return;
                    }
                    const $state = $injector.get('$state');
                    const $window = $injector.get('$window');
                    const $q = $injector.get('$q');
                    const $rootScope = $injector.get('$rootScope');
                    const RoutesConstants = $injector.get('RoutesConstants');
                    const ErrorConstants = $injector.get('ErrorConstants');
                    const CacheConstants = $injector.get('CacheConstants');
                    const CarSearchResultConstants = $injector.get('CarSearchResultConstants');
                    const CacheService = $injector.get('CacheService');
                    const MainMetierService = $injector.get('MainMetierService');
                    const CloudFrontService = $injector.get('CloudFrontService');
                    const DocumentsMetierService = $injector.get('DocumentsMetierService');
                    const ResultSearchByDiagnosticMetierService = $injector.get('ResultSearchByDiagnosticMetierService');
                    const PartRequisitionMetierService = $injector.get('PartRequisitionMetierService');
                    const DmsMetierService = $injector.get('DmsMetierService');
                    const DealerManagerSystemeService = $injector.get('DealerManagerSystemeService');
                    const toastr = $injector.get('toastr');
                    const $translate = $injector.get('$translate');
                    const params = handover.params;
                    MainMetierService.setClipParameters(params);
                    DealerManagerSystemeService.storeHookResult(CacheService.getObject('dms'));
                    if (params.dealerLabel) {
                        DealerManagerSystemeService.setDMSSiteLabel(params.dealerLabel);
                    }
                    const diagnosticParams = { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic };
                    const wiringParams = {
                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                        isUserComingFromClip: true,
                        vinComingFromClip: params.VIN,
                        id: params.CPC,
                        idOptional: params.CSC,
                        LC: params.LC,
                        WDT: params.WDT,
                        functionId: params.FUNCTION,
                        subFunctionId: params.SUB_FUNCTION,
                        titleId: params.TITLE,
                        isDetailMainComponentRequired: handover.action === 'wiring-detail'
                    };

                    function showBt(reference) {
                        return DocumentsMetierService.returnBTByRef(reference).then(function (response) {
                            const documents = response && response.BT;
                            if (!documents || !documents.length) {
                                const numericReference = Number(reference);
                                if (numericReference >= BT_OFFSET_REFERENCE_MIN && numericReference <= BT_OFFSET_REFERENCE_MAX) {
                                    return showBt(String(numericReference - BT_REFERENCE_OFFSET));
                                }
                                if (String(reference).length === BT_FULL_REFERENCE_LENGTH) {
                                    return showBt(String(reference).substring(0, BT_SHORT_REFERENCE_LENGTH));
                                }
                                throw new Error('DOCUMENT_NO_BT_FOUND');
                            }
                            const document = documents[0];
                            const details = documents.length === 1 ? {
                                lupNumber: document.LUPNumber,
                                nitgNumber: document.NITGNumber,
                                creationDate: document.creationDate,
                                updateDate: document.updateDate,
                                colorCode: document.colorCode === 'BLUE_WITH_FOLLOW_UP' ? 'lightblue' : document.colorCode
                            } : null;
                            return DocumentsMetierService.displayBtDetailsRds(document.paramURL, document.pdfContent, details);
                        });
                    }

                    function showDtc() {
                        const code = params.DTC_CODE.toUpperCase();
                        const body = ResultSearchByDiagnosticMetierService.createDataObject('', [code], '');
                        CacheService.setObject(CacheConstants.searchedSymptom, { code, label: '' });
                        CacheService.setObject(CacheConstants.showDiagnosticView, true);
                        return ResultSearchByDiagnosticMetierService.getAllCodes(body).then(function (response) {
                            CacheService.setObject(CacheConstants.getAllCodes, response);
                            const payload = { MD: [], BT: [], BTWithColorType: [] };
                            (response && response.documents || []).forEach(function (document) {
                                const tags = document.indexationsTags;
                                if (!tags || !tags.DTC || tags.DTC.indexOf(code) < 0) {
                                    return;
                                }
                                if (document.type === 'BT') {
                                    payload.BT.push(document.id);
                                    payload.BTWithColorType.push({ id: document.id, subType: document.subType });
                                    return;
                                }
                                if (document.type === 'MD') {
                                    payload.MD.push(document.id);
                                }
                            });
                            return $state.go(RoutesConstants.resultSearchByDiagnostic, {
                                code, data: payload, traficDiag: true, codeNumber: 2
                            });
                        }).catch(function () {
                            return $state.go(RoutesConstants.carSearchResult, diagnosticParams);
                        });
                    }

                    const actions = {
                        vehicle() { return $state.go(RoutesConstants.carSearchResult); },
                        mr() { return $state.go(RoutesConstants.carSearchResult); },
                        diagnostic() { return $state.go(RoutesConstants.carSearchResult, diagnosticParams); },
                        'diagnostic-file'() {
                            diagnosticParams.diagFileId = params.VDH_DF_ID;
                            return $state.go(RoutesConstants.carSearchResult, diagnosticParams);
                        },
                        dtc: showDtc,
                        symptom() {
                            return $state.go(RoutesConstants.carSearchResult, {
                                isUserComingFromClip: true, vinComingFromClip: params.VIN,
                                symptomComingFromClip: params.SYMPTOM
                            }).then(function () {
                                return ResultSearchByDiagnosticMetierService.getAllSymptoms();
                            }).then(function (response) {
                                return $state.go(RoutesConstants.searchByDiagnostic, {
                                    fetchedSymptoms: response, symptomCode: params.SYMPTOM, code: 3
                                });
                            });
                        },
                        wiring() { return $state.go(RoutesConstants.carSearchResult, wiringParams); },
                        'wiring-signals'() { return actions.wiring(); },
                        'wiring-detail'() { return actions.wiring(); },
                        'wiring-component'() {
                            return actions.wiring().then(function () {
                                return $rootScope.isComponentPresentFromClip
                                    ? $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                        id: params.CPC, idOptional: params.CSC, vinComingFromClip: params.VIN,
                                        isUserComingFromClip: true, isDetailMainComponentRequired: true
                                    }) : $state.go(RoutesConstants.carSearchResult);
                            });
                        },
                        'wiring-components'() { return actions['wiring-component'](); },
                        partshop() { return $state.go(RoutesConstants.partRequisition, { view: 'create' }); },
                        'partshop-vin'() { return actions.partshop(); },
                        'partshop-account'() {
                            return PartRequisitionMetierService.initPartRequisition().then(function () {
                                return DmsMetierService.getUserByAccount({ accountNumber: params.accountid });
                            }).then(function (result) {
                                const customer = result && result.response && result.response.customer;
                                if (customer) {
                                    CacheService.savePartRequisitionCustomer({ value: customer });
                                }
                                return $state.go(RoutesConstants.carSearch);
                            });
                        },
                        'workshop-order'() { return $state.go(RoutesConstants.carSearch, { orderNumber: params.OR }); },
                        bt() { return showBt(params.docId); },
                        md() {
                            return DocumentsMetierService.returnSiePdfContentFromClip(params.mrId, params.ecuId, params.codeDef)
                                .then(function (response) {
                                    const contentUrl = response && response.contentUrl && response.contentUrl[0];
                                    if (!contentUrl) {
                                        throw new Error('MD_DOCUMENT_NOT_FOUND');
                                    }
                                    const target = new URL(contentUrl, $window.location.origin);
                                    if (!/^https?:$/.test(target.protocol) || target.username || target.password) {
                                        throw new Error('INVALID_MD_DOCUMENT_URL');
                                    }
                                    if (response.pageNum) {
                                        target.hash = 'page=' + encodeURIComponent(response.pageNum);
                                    }
                                    $window.location.replace(target.toString());
                                });
                        }
                    };
                    $q.resolve().then(function () {
                        return CloudFrontService.getAccessCookies() ? null : CloudFrontService.setCookies();
                    }).then(function () {
                        return actions[handover.action]();
                    }).catch(function () {
                        if (handover.action === 'md') {
                            $state.go(ErrorConstants.noDocumentFound);
                        } else {
                            toastr.error($translate.instant(handover.action === 'bt' ? 'DOCUMENT_NO_BT_FOUND' : 'ERROR'));
                            $state.go(RoutesConstants.carSearch);
                        }
                    });
                }]);
})();
(function () {
    angular.module("phenix").controller("defaultP", defaultP);

    function defaultP(
        RoutesConstants,
        ErrorConstants,
        CacheConstants,
        ClipConstants,
        RetailGroupConstants,
        CarSearchResultConstants,
        DealerManagerSystemeService,
        RdsConstants,
        VdhConstants,
        /**
         * ANGULAR SERVICES
         */

        $location,
        $state,
        $translate,
        $mdDialog,
        $window,
        $q,
        $rootScope,
        $timeout,
        $http,
        /**
         *  SERVICES
         */

        CacheService,
        CloudFrontService,
        TokenService,
        LoginMetierService,
        LoginWsService,
        UtilsMetierService,
        ClipService,
        DocumentsMetierService,
        CurrencyService,
        RetailGroupService,
        CarSearchMetierService,
        PartRequisitionMetierService,
        DmsMetierService,
        SearchByDiagnosticService,
        ResultSearchByDiagnosticMetierService,
        DiagFileBusinessService,
        configConstantes,
        FicViewListService,
        MainMetierService,
        CryptoService,
        UserKeyService,
        ExternalEntryHandoverService,
        /**
         * External
         */

        blockUI,
        toastr,$log,CarSearchConstants,rLinkConstant, CloudFrontUrlHelper
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var redirection = "";
        var vm = this;
         vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess   );
        var clipParameters = ClipService.getParameters(ClipConstants.clipCookieName);
        MainMetierService.setClipParameters(clipParameters);
        var sieClipType = clipParameters ? clipParameters.clipSearchDocumentType : "";
        var tokenFromParam = $location.search().token;
        var tokenFromNissan = null;
        var absUrl = $location.absUrl();
        var tokenMatch = absUrl.match(/token=([^&#]+)/);
        if (tokenMatch && tokenMatch[1]) {
            tokenFromNissan = tokenMatch[1];
        }
        var retailGroupParameters = ClipService.getParameters(RetailGroupConstants.retailGroupCookieName);
        var wiringDiagramsParameters = ClipService.getParameters(ClipConstants.WiringDiagrams.wiringDiagramsCache);
        var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
        var isTraceEnabled = JSON.parse(configConstantes.isTraceEnable);
        var code = {
            success: 0,
            forbidden: -1,
            dms: 'dms'
        }
        var backImageChangeId = "#BACKIMAGE_CHANGE";
        const ndPopin = configConstantes.ndHelpUrl + "/ndPopin";
        
        function resumeDesyreNavigation() {
            const isRedirectFromDesyre = CacheService.getObject(CacheConstants.isRedirectFromDesyre);
            const contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);
            const isSymptomSearchAvailable = CacheService.getObject(CacheConstants.searchedSymptom);
            if (!isRedirectFromDesyre) {
                return false;
            }
            if (contextCarSearch && isSymptomSearchAvailable) {
                $state.go(RoutesConstants.resultSearchByDiagnostic);
            } else if (contextCarSearch) {
                $state.go(RoutesConstants.carSearchResult);
            } else {
                $state.go(RoutesConstants.carSearch);
            }
            return true;
        }

        this.$onInit = function () {
            if (ExternalEntryHandoverService.hasPending()) {
                ExternalEntryHandoverService.run();
                return;
            }
            if (resumeDesyreNavigation()) {
                return;
            } else {
                blockUI.start();
                var userType = CacheService.getUserType();
                if(vm.nissanUserURL && !userType && tokenFromNissan){
                    LoginMetierService.nissanIndepLogin(tokenFromNissan).then(function(response){
                        var token = response.jwtToken;
                        
                        // Store userKey for Nissan users
                        if (response.userKey) {
                            UserKeyService.setUserKey(response.userKey);
                        }
                        
                        return TokenService.handleToken(token)
                    }).then(function(userProfile){    
                        LoginMetierService.storeUserConnection();
                        var absUrl = $location.absUrl();
                        // Remove token from both query and hash fragments robustly
                        var urlNoToken = absUrl
                            .replace(/[?&]token=[^&#]*(?=[&#]|$)/, '')
                            .replace(/([#!][^?]*)\?token=[^&#]*/, '$1')
                            .replace(/([#!][^&]*)&token=[^&#]*/, '$1')
                            .replace(/[?&]$/, '')
                            .replace(/\?#!/, '#!')
                            .replace(/\?#\!\//, '#!/')
                            .replace(/\?$/, '');
                        if (absUrl !== urlNoToken) {
                            $window.location.replace(urlNoToken);
                            return;
                        }
                        $state.go(RoutesConstants.carSearch);
                    }).catch(function () {
                        $window.sessionStorage.setItem('showAsomDocAccessPopup', '1');
                        var absUrl = $location.absUrl();
                        // Remove token from both query and hash fragments robustly
                        var urlNoToken = absUrl
                            .replace(/[?&]token=[^&#]*(?=[&#]|$)/, '')
                            .replace(/([#!][^?]*)\?token=[^&#]*/, '$1')
                            .replace(/([#!][^&]*)&token=[^&#]*/, '$1')
                            .replace(/[?&]$/, '')
                            .replace(/\?#!/, '#!')
                            .replace(/\?#\!\//, '#!/')
                            .replace(/\?$/, '');
                        if (absUrl !== urlNoToken) {
                            $window.location.replace(urlNoToken);
                            return;
                        }
                        $state.go(RoutesConstants.connection);
                    }).finally(function () {
                        blockUI.stop();
                    });
            }else{
            TokenService.handleToken(tokenFromParam)
                .then(function (userProfile) {    
                    var allowASOM = CacheService.getObject(CacheConstants.asomNotAllowed) ? CacheService.getObject(CacheConstants.asomNotAllowed) :false;
                    var userType = CacheService.getUserType();
                    if (!userProfile) {
                        return RoutesConstants.connection;
                    } else if(userProfile && userProfile.userType =="RNET" && ((!vm.nissanUserURL && !(userProfile.roles.includes(CarSearchConstants.ppxNetworkProfile)) && !(userProfile.roles.includes(CarSearchConstants.mitsubishiProfile)) && !(userProfile.roles.includes(CarSearchConstants.ppxLight))) || (vm.nissanUserURL && !(userProfile.roles.includes(CarSearchConstants.ppxNis))))){
                        CloudFrontService.removeAccessCookies();
                            CacheService.clearAll();
                        $timeout(function () {
                            toastr.error($translate.instant('RNET_PROFILE_INVALID'));
                          },100);
                            return RoutesConstants.connection;
                    }
                    else if(userProfile && userProfile.userType == "RNET" && !_.isEmpty(userProfile.roles) && userProfile.roles.length === 1 && !(userProfile.roles.includes(CarSearchConstants.ppxNetworkProfile)) && (userProfile.roles.includes(CarSearchConstants.ppxLight))){
                        toastr.info($translate.instant("PPX_LIGHT_INFO"));
                    }
                    else if(userProfile && userType === "ARCA" && (!(userProfile.roles.includes(CarSearchConstants.ppxCorporateUser)) || CarSearchResultConstants.nissanArcaProfile.includes(userProfile.personType))){
                        CloudFrontService.removeAccessCookies();
                        CacheService.clearAll();
                        $timeout(function () {
                          toastr.error($translate.instant('ACCESS_DENIED'));
                        },100);
                          return RoutesConstants.connection;
                    }else {
                        if(userProfile.dealerId == '90322014'){
                            CloudFrontService.removeAccessCookies();
                            CacheService.clearAll();
							$timeout(function () {
                              toastr.error("ACCESS DENIED");
                            },100);
                              return RoutesConstants.connection;
                        }
                        //set application's cookies
                        let cookiesPromise = $q.resolve();
                        if(!CloudFrontService.getAccessCookies() && !allowASOM){
                            cookiesPromise = CloudFrontService.setCookies();
                        }
                        
                        cookiesPromise.then(function() {
                            if (userProfile && (userProfile.userType == "RNET" || userProfile.userType == "ARCA") &&!vm.nissanUserURL) {
                                if(JSON.parse(configConstantes.newPopInInfo)){
                                    MainMetierService.getNotificationPopIn().then(function(notificationList) {
                                        if(!_.isEmpty(notificationList)){
                                            let notification = notificationList;
                                            const notificationId = notification.id; 
                                            let matchedLanguageNotification;
                                            if (notification.notificationsByLanguage && notification.notificationsByLanguage.length > 0) {
                                                const userLanguage = userProfile.portal.code;
                                                matchedLanguageNotification = _.find(notification.notificationsByLanguage, function(item) {
                                                    return item.language === userLanguage;
                                                });
                                                if (!matchedLanguageNotification) {
                                                    let enNotifications = _.filter(notification.notificationsByLanguage, function(item) {
                                                        return item.language === 'en';
                                                    });
                                                    if (enNotifications.length > 0) {
                                                        matchedLanguageNotification = _.maxBy(enNotifications, function(item) {
                                                            return new Date(item.updatedDate);
                                                        });
                                                    }
                                                }
                                                if (matchedLanguageNotification) {
                                                    notification = _.extend({}, notification, matchedLanguageNotification);
                                                    notification.notificationsByLanguage = [matchedLanguageNotification];
                                                }
                                            }  
                                            CacheService.setObject(CacheConstants.informationMessage, {"message":matchedLanguageNotification.content, "notificationId": notificationId});
                                            $rootScope.$broadcast('loadTooltip');
                                            $mdDialog.show({
                                                templateUrl:
                                                    "app/components/car/carSearch/components/modalInformation.template.html",
                                                controller: "modalInformationController",
                                                bindToController: true,
                                                controllerAs: "vm",
                                                clickOutsideToClose: true,
                                                multiple: true,
                                                locals: {
                                                    information: matchedLanguageNotification.content,
                                                    on_consent: function() {
                                                        return MainMetierService.updateNotificationReadStatus(notificationId, true)
                                                            .then(function() {
                                                                return MainMetierService.getUnreadNotificationCount();
                                                            })
                                                            .then(function(unreadCount) {
                                                                $rootScope.$broadcast('notificationCountUpdated', unreadCount);
                                                            });
                                                    },
                                                    on_complete: function(response) {
                                                        // Fetch updated notifications after DB update completes
                                                        // MainMetierService.getAllNotifications(0, 10)
                                                        //     .then(function(notificationResponse) {
                                                        //         var unreadCount = 0;

                                                        //         if (notificationResponse && notificationResponse.notifications) {
                                                        //             unreadCount = notificationResponse.notifications.filter(function(notification) {
                                                        //                 return notification.read === false;
                                                        //             }).length;
                                                        //         }

                                                        //         $rootScope.$broadcast('notificationCountUpdated', unreadCount);
                                                        //     })
                                                        //     .catch(function(error) {
                                                        //         toastr.error(error);
                                                        //     });

                                                        MainMetierService.AsomDocAccessPopIn(userProfile);
                                                        if (CacheService.getObject(CacheConstants.r2aDealerList)){
                                                            const cachedetail = CacheService.getR2ADealerList();
                                                            const dealerList = _.find(cachedetail.dealers, function(item){
                                                                return item.active == true;
                                                            });
                                                            if (!dealerList){
                                                                $rootScope.$broadcast('displayDealerPopup', true);
                                                            }
                                                        }
                                                    }
                                                }
                                            });
                                        }          
                                    }).catch(function(error) {
                                        toastr.error(error);
                                    });
                                } else {
                                    diplayInformationMessage(userProfile);
                                }
                                // openComPdf(userProfile); 
                            }
                        });
                        
                        // if (MainMetierService.isIndependantUser(userProfile.roles) && userProfile.accountType == 'Partner'){
                        //    return $state.go(RoutesConstants.docprivData);
                        // }
                        var isRnetUserType = MainMetierService.isRnetUserType(userProfile.userType);
                        if (isRnetUserType && MainMetierService.isActisProfilNoContext()) {
                            MainMetierService.getLastModificationDate().then(function (res) {
                                manageActicUser(res, userProfile);
                            }).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });
                        }
                        else if (userProfile && userProfile.roles && !_.isEmpty(userProfile.roles) && MainMetierService.isIndependantUser(userProfile.roles)&& !allowASOM) {
                            manageActicUser(null, userProfile);
                        }
                        callHtl(userProfile.isHTLCountry);
                        if(isTraceEnabled){
                            callTrace(userProfile.isTraceCountry);
                        }
                        if(allowASOM){
                            MainMetierService.AsomDocAccessPopIn(userProfile);
                        }

                        //clean quote
                        CacheService.deleteDmsQuote();

                        // clean part requisition
                        CacheService.deleteDmsPartRequisition();

                        if(!allowASOM){
                            LoginMetierService.storeUserConnection();
                            getCurrency();
                        }
                        if (!_.isEmpty(retailGroupParameters)) {
                            CarSearchMetierService.changeLinkColor(backImageChangeId);
                            if(retailGroupParameters.dealerLabel && retailGroupParameters.dealerLabel != '')
                                DealerManagerSystemeService.setDMSSiteLabel(retailGroupParameters.dealerLabel);
                            ClipService.removeParameters(RetailGroupConstants.retailGroupCookieName);
                            return manageRetailGroupUrl(retailGroupParameters, userProfile);
                        }
                        //get route for clip
                        else if (!sieClipType && !_.isEmpty(clipParameters)) {
                            redirection = manageClipUrl(undefined, clipParameters);
                        }
                        //get route for clip type if sieClipType is mentionned
                        else if (sieClipType) {
                            redirection = manageClipUrl(sieClipType, clipParameters);
                        }                        
                        //call dms, redirect to carSearch if user is connected to dms
                        else if (userProfile && userProfile.userType == "RNET" && userProfile.dmsConnected == true && userProfile.dmsConfig && userProfile.dmsConfig.url) {
                            redirection = DealerManagerSystemeService.hookDMS(userProfile.dmsConfig.url,
                                userProfile.dmsConfig.userDmsId, userProfile.dmsConfig.workshopPartshopId)
                                .then(function (dmsCallSuccess) {

                                    if(dmsCallSuccess.returnCode !== 0 && dmsCallSuccess.returnCode !== code.forbidden){
                                        if ($translate.instant('DMS_' + dmsCallSuccess.returnCode) != 'DMS_' + dmsCallSuccess.returnCode){
                                            toastr.error($translate.instant('DMS_' + dmsCallSuccess.returnCode));
                                        }else{
                                            toastr.error(dmsCallSuccess.message);
                                        }
                                    }

                                    var dmsConnectionData = {
                                        isDmsMode: DealerManagerSystemeService.getHookResult(),
                                        dmsCallSuccess: dmsCallSuccess
                                    };

                                    DealerManagerSystemeService.storeHookResult(
                                        dmsConnectionData
                                    );
                                    if(!_.isEmpty(commonParameters) && (commonParameters.APP_ID != 'DMS' && commonParameters.APP_ID != 'ADT' &&  commonParameters.APP_ID != 'CLIP')) {
                                        redirection = manageExternalRedirection(commonParameters);
                                        return redirection;
                                    } else {
                                        return RoutesConstants.carSearch;
                                    }
                                });
                        }
                        else if(userProfile && (userProfile.userType == "ARCA" || (userProfile.userType == "RNET" && !userProfile.dmsConnected)) && !_.isEmpty(commonParameters) && (commonParameters.APP_ID != 'DMS' && commonParameters.APP_ID != 'ADT' &&  commonParameters.APP_ID != 'CLIP')) {
                            redirection = manageExternalRedirection(commonParameters);
                        }
                        else {
                            redirection = RoutesConstants.carSearch;
                        }
                        return redirection;
                    }

                }).then(function (route) {
                    var isMitsubishiUser = MainMetierService.isMitsubishiUser();
                    var isPpxLightUser = MainMetierService.isPpxLightUser();
                    var isOnlyPpxLightUser = MainMetierService.isOnlyPpxLightUser();
                    const profileData = CacheService.getObject(CacheConstants.profil);
                    let dms = false;
                    if(profileData){
                        dms = profileData.dmsConnected ? profileData.dmsConnected : false;
                        CacheService.setObject(CacheConstants.profil, profileData);
                        const dynatraceMonitoring = {
                            roles: profileData.roles,
                            dmsConnected: profileData.dmsConnected,
                            dmsUrl: profileData.dmsConfig.url,
                            dealerId: profileData.dealerId,
                        };
                        CacheService.setObject(
                            CacheConstants.dynatraceMonitoring,
                            dynatraceMonitoring
                        );
                        CacheService.setObject("dms", dms);
                    }
                    if (route && !isMitsubishiUser && !isPpxLightUser && !isOnlyPpxLightUser) {
                        switch (route) {
                            case RetailGroupConstants.Result.partshopProfil:
                                $state.go(RoutesConstants.partRequisition, { view: 'create' });
                                break;
                            case RetailGroupConstants.Result.partshopProfilWithAccountId:
                                PartRequisitionMetierService.initPartRequisition().then(function () {
                                    var customerAccountId = { accountNumber: retailGroupParameters.accountid };
                                    DmsMetierService.getUserByAccount(customerAccountId).then(function (result) {
                                        var customer = result.response.customer;
                                        if (customer) {
                                            CacheService.savePartRequisitionCustomer({
                                                value: customer
                                            });
                                        }
                                    });
                                    $state.go(RoutesConstants.carSearch);
                                });
                                break;
                            case RetailGroupConstants.Result.partshopProfilWithVin:
                                var vin;
                                if(retailGroupParameters.VIN)
                                {
                                      vin=retailGroupParameters.VIN;
                                }else if(retailGroupParameters.vin)
                                {      vin=retailGroupParameters.vin;
                                }else if(retailGroupParameters.Vin){
                                    vin=retailGroupParameters.Vin
                                }
                                if (!_.isEmpty(vin) ) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: vin }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.partRequisition, { view: 'create' });

                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                break;
                            case RetailGroupConstants.Result.workshopProfil:
                                $state.go(RoutesConstants.carSearch);
                                break;
                            case RetailGroupConstants.Result.workshopProfilWithOrderNumber:
                                $state.go(RoutesConstants.carSearch, { orderNumber: retailGroupParameters.OR });
                                break;
                            case RetailGroupConstants.Result.workshopProfilWithVin:
                                $state.go(RoutesConstants.carSearch, { vin: retailGroupParameters.VIN });
                                break;
                            case ClipConstants.WiringDiagrams.Result.electricalSchemasMainPage:
                                if (!_.isEmpty(clipParameters.VIN) && !_.isEmpty(clipParameters.FUNCTION) && _.isEmpty(clipParameters.SUB_FUNCTION) && _.isEmpty(clipParameters.TITLE)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult,
                                            { tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                              isUserComingFromClip: true,
                                              functionId : clipParameters.FUNCTION });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                else if (!_.isEmpty(clipParameters.VIN) && !_.isEmpty(clipParameters.FUNCTION) && !_.isEmpty(clipParameters.SUB_FUNCTION) && _.isEmpty(clipParameters.TITLE)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult,
                                            { tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                              isUserComingFromClip: true,
                                              functionId : clipParameters.FUNCTION,
                                              subFunctionId : clipParameters.SUB_FUNCTION });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                else if (!_.isEmpty(clipParameters.VIN) && !_.isEmpty(clipParameters.FUNCTION) && !_.isEmpty(clipParameters.SUB_FUNCTION) && !_.isEmpty(clipParameters.TITLE)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult,
                                            { tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                              isUserComingFromClip: true,
                                              functionId : clipParameters.FUNCTION,
                                              subFunctionId : clipParameters.SUB_FUNCTION,
                                              titleId : clipParameters.TITLE });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                else if (!_.isEmpty(clipParameters.VIN) && _.isEmpty(clipParameters.FUNCTION) && _.isEmpty(clipParameters.SUB_FUNCTION) && !_.isEmpty(clipParameters.TITLE)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult,
                                            { tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                              isUserComingFromClip: true,
                                              titleId : clipParameters.TITLE });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                else if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.consultElectricalShema });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                    });
                                }
                                break;
                            case ClipConstants.WiringDiagrams.Result.electricalSchemasWithMainComponent:
                                if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult, {
                                            tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                            isUserComingFromClip: true,
                                            vinComingFromClip: clipParameters.VIN,
                                            id: clipParameters.CPC,
                                            LC: clipParameters.LC,
                                            WDT: clipParameters.WDT
                                        })
                                            .then(function () { //TODO enlever $rootScope
                                                CarSearchMetierService.changeLinkColor(backImageChangeId)
                                                if ($rootScope.isComponentPresentFromClip) {
                                                    $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                                        id: clipParameters.CPC, vinComingFromClip: clipParameters.VIN, isUserComingFromClip: true, isDetailMainComponentRequired : (clipParameters.CPC != null ? true : false)
                                                    });
                                                } else {
                                                    $state.go(RoutesConstants.carSearchResult);
                                                }
                                            });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                        ClipService.removeParameters(ClipConstants.clipCookieName);
                                    });
                                }
                                break;
                            case ClipConstants.WiringDiagrams.Result.electricalSchemasWithSignalsAndNoComponent:
                                blockUI.start();
                                CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                    CarSearchMetierService.getBannerData().finally(function(){
                                        CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                            toastr.error('Error', error);
                                        });
                                    })
                                    $state.go(RoutesConstants.carSearchResult, {
                                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                        isUserComingFromClip: true,
                                        vinComingFromClip: clipParameters.VIN,
                                        LC: clipParameters.LC,
                                        WDT: clipParameters.WDT,
                                        id: clipParameters.CPC
                                    })
                                        .then(function () {
                                            CarSearchMetierService.changeLinkColor(backImageChangeId);

                                        });
                                }).catch(function () {
                                    //redirect to car search if something go wrong
                                    $state.go(RoutesConstants.carSearch);
                                }).finally(function () {
                                    blockUI.stop();
                                    ClipService.removeParameters(ClipConstants.clipCookieName);
                                });
                                break;
                            case ClipConstants.WiringDiagrams.Result.electricalSchemasWithMainAndOptionalComponents:
                                if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        $state.go(RoutesConstants.carSearchResult, {
                                            tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                            isUserComingFromClip: true,
                                            vinComingFromClip: clipParameters.VIN,
                                            id: clipParameters.CPC,
                                            idOptional: clipParameters.CSC,
                                            WDT: clipParameters.WDT,
                                            LC: clipParameters.LC
                                        })
                                            .then(function () { //TODO enlever ce putain de $rootScope
                                                CarSearchMetierService.changeLinkColor(backImageChangeId)
                                                if ($rootScope.isComponentPresentFromClip) {
                                                    $state.go(RoutesConstants.electricalSchemaLevel3Single, {
                                                        id: clipParameters.CPC,
                                                        idOptional: clipParameters.CSC,
                                                        vinComingFromClip: clipParameters.VIN
                                                    });
                                                } else {
                                                    $state.go(RoutesConstants.carSearchResult);
                                                }
                                            });
                                    }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                        ClipService.removeParameters(ClipConstants.clipCookieName);
                                    });
                                }
                                break;
                            case ClipConstants.DiagnosticByUrl.Result.availableVinAndSymptom:
                                if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({vin: clipParameters.VIN})
                                        .then(function () {
                                            CarSearchMetierService.getBannerData().finally(function(){
                                                CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                    toastr.error('Error', error);
                                                });
                                            })
                                            $state.go(RoutesConstants.carSearchResult, {
                                                isUserComingFromClip: true,
                                                vinComingFromClip: clipParameters.VIN,
                                                symptomComingFromClip: clipParameters.SYMPTOM
                                            })
                                                .then(function () {
                                                    ResultSearchByDiagnosticMetierService.getAllSymptoms()
                                                        .then(function (response) {
                                                            $state.go(RoutesConstants.searchByDiagnostic, {
                                                                fetchedSymptoms: response,
                                                                symptomCode: clipParameters.SYMPTOM,
                                                                code: 3
                                                            });
                                                        })
                                                });
                                        }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                        ClipService.removeParameters(ClipConstants.clipCookieName);
                                    });
                                }
                                break;
                            case ClipConstants.DiagnosticByUrl.Result.vinOnly:
                                if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({vin: clipParameters.VIN})
                                        .then(function () {
                                            CarSearchMetierService.getBannerData().finally(function(){
                                                CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                    toastr.error('Error', error);
                                                });
                                            })
                                            $state.go(RoutesConstants.carSearchResult, {
                                                isUserComingFromClip: true,
                                                vinComingFromClip: clipParameters.VIN,
                                                symptomComingFromClip: clipParameters.SYMPTOM
                                            })
                                        }).catch(function () {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);

                                    }).finally(function () {
                                        blockUI.stop();
                                        ClipService.removeParameters(ClipConstants.clipCookieName);
                                    });
                                }
                                break;
                            case ClipConstants.WiringDiagrams.Result.detailMainComponent:
                                blockUI.start();
                                CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                    CarSearchMetierService.getBannerData().finally(function(){
                                        CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                            toastr.error('Error', error);
                                        });
                                    })
                                    $state.go(RoutesConstants.carSearchResult, {
                                        tab: CarSearchResultConstants.searchTypes.consultElectricalShema,
                                        isUserComingFromClip: true,
                                        LC: clipParameters.LC,
                                        WDT: clipParameters.WDT,
                                        id: clipParameters.CPC,
                                        idOptional: clipParameters.CSC,
                                        isDetailMainComponentRequired: true
                                    })
                                        .then(function () {
                                            CarSearchMetierService.changeLinkColor(backImageChangeId);
                                        });
                                }).catch(function () {
                                    //redirect to car search if something go wrong
                                    $state.go(RoutesConstants.carSearch);
                                }).finally(function () {
                                    ClipService.removeParameters(ClipConstants.clipCookieName);
                                });
                                break;
                            case ClipConstants.newDiagnosticPage:

                                     if (!_.isEmpty(clipParameters.VIN)) {

                                        // will remove the else part & have if part alone for new VDH implementation

                                            blockUI.start();
                                            CarSearchMetierService.changeLinkColor(backImageChangeId)
                                            CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                                CarSearchMetierService.getBannerData().finally(function(){
                                                    CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                        toastr.error('Error', error);
                                                    });
                                                })
                                                $state.go(RoutesConstants.carSearchResult, {
                                                    tab: CarSearchResultConstants.searchTypes.searchByDiagnostic,
                                                    diagFileId: clipParameters.VDH_DF_ID});
                                                }).catch(function () {
                                                    //redirect to car search if something go wrong
                                                    $state.go(RoutesConstants.carSearch);
                                                }).finally(function(){
                                                    ClipService.removeParameters(ClipConstants.clipCookieName);
                                                    blockUI.stop();
                                                });

                                             }
                                break;
                            case ClipConstants.COMMON.Result.DiagnosticSearchMainPage:
                                blockUI.start();
                                CarSearchMetierService.searchCar({ vin: commonParameters.VIN }).then(function () {
                                    CarSearchMetierService.getBannerData().finally(function(){
                                        CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                            toastr.error('Error', error);
                                        });
                                    })
                                    $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic, diagFileId: commonParameters.VDH_DF_ID });
                                }).catch(function (error) {
                                    $state.go(RoutesConstants.carSearch);
                                }).finally(function () {
                                    ClipService.removeParameters(ClipConstants.commonCookieName);
                                    blockUI.stop();
                                });
                                break;
                                case ClipConstants.DiagnosticSearch.Result.DiagnosticSearchMainPage:
                                if (!_.isEmpty(clipParameters.VIN)) {
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({ vin: clipParameters.VIN }).then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        })
                                        if(!_.isEmpty(clipParameters.DTC_CODE)){
                                            var dtcCode = clipParameters.DTC_CODE.toUpperCase();
                                            var dataBody = ResultSearchByDiagnosticMetierService.createDataObject('', [dtcCode], '');
                                            CacheService.setObject(CacheConstants.searchedSymptom, { code: dtcCode, label: '' });
                                            CacheService.setObject(CacheConstants.showDiagnosticView, true);
                                            ResultSearchByDiagnosticMetierService.getAllCodes(dataBody)
                                                .then(function(response) {
                                                    CacheService.setObject(CacheConstants.getAllCodes, response);
                                                    // Build payload matching queryDoc logic for code=2 (DTC)
                                                    var payload = { MD: [], BT: [], BTWithColorType: [] };
                                                    if (response && response.documents) {
                                                        response.documents.forEach(function(doc) {
                                                            var tags = doc.indexationsTags;
                                                            if (!tags) { return; }
                                                            var found = tags.DTC ? tags.DTC.indexOf(dtcCode) : -1;
                                                            if (found >= 0) {
                                                                if (doc.type === 'BT') {
                                                                    payload.BT.push(doc.id);
                                                                    payload.BTWithColorType.push({ id: doc.id, subType: doc.subType });
                                                                } else if (doc.type === 'MD') {
                                                                    payload.MD.push(doc.id);
                                                                }
                                                            }
                                                        });
                                                    }
                                                    $state.go(RoutesConstants.resultSearchByDiagnostic, {
                                                        data: payload,
                                                        traficDiag: true,
                                                        code: dtcCode,
                                                        codeNumber: 2
                                                    });
                                                })
                                                .catch(function() {
                                                    $log.debug($translate.instant('ERROR'));
                                                    $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic });
                                                });
                                        } else {
                                            $state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic });
                                        }
                                        //to be used after P31_US12 story
                                        // blockUI.stop();
                                        //$state.go(RoutesConstants.carSearchResult, { tab: CarSearchResultConstants.searchTypes.searchByDiagnostic,isUserComingFromClip: true,data: clipParameters.VDH_DF_ID});
                                    }).catch(function (error) {
                                        //redirect to car search if something go wrong
                                        $state.go(RoutesConstants.carSearch);
 
                                    }).finally(function () {
                                        ClipService.removeParameters(ClipConstants.clipCookieName);
                                        blockUI.stop();
                                    });
                                }
                                break;
                            case ClipConstants.COMMON.Result.btWithoutNavigation:
                                ClipService.removeParameters(ClipConstants.commonCookieName);
                                redirectToBT(commonParameters.docId, false);
                                //check true or false for icm, and others in existing code 
                                break;
                            case ClipConstants.COMMON.Result.vinSearch:
                                blockUI.start();
                                CarSearchMetierService.searchCar({vin: commonParameters.VIN}).then(function () {
                                    CarSearchMetierService.getBannerData().finally(function(){
                                        CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                            toastr.error('Error', error);
                                        });
                                    });
                                    $state.go(RoutesConstants.carSearchResult);
                                }).catch(function () {
                                    $state.go(RoutesConstants.carSearch);    
                                }).finally(function () {
                                    blockUI.stop();
                                    ClipService.removeParameters(ClipConstants.commonCookieName);
                                });                                
                                break;
                            case ClipConstants.COMMON.Result.availableVinAndSymptom:
                                    blockUI.start();
                                    CarSearchMetierService.searchCar({vin: commonParameters.VIN})
                                    .then(function () {
                                        CarSearchMetierService.getBannerData().finally(function(){
                                            CarSearchMetierService.historizationVehicleSave(profileData).catch(function (error) {
                                                toastr.error('Error', error);
                                            });
                                        });
                                        $state.go(RoutesConstants.carSearchResult, {
                                            isUserComingFromClip: true,
                                            vinComingFromClip: commonParameters.VIN,
                                            symptomComingFromClip: commonParameters.SYMPTOM
                                        }).then(function () {
                                            ResultSearchByDiagnosticMetierService.getAllSymptoms()
                                                .then(function (response) {
                                                    $state.go(RoutesConstants.searchByDiagnostic, {
                                                        fetchedSymptoms: response,
                                                        symptomCode: commonParameters.SYMPTOM,
                                                        code: 3
                                                    });
                                                })
                                            });
                                    }).catch(function () {
                                        $state.go(RoutesConstants.carSearch);
                                        toastr.error($translate.instant("CARSEARCH_VEHICLE_IN_DMS_BUT_NOT_IN_BVM"));
                                    }).finally(function () {
                                        blockUI.stop();
                                        ClipService.removeParameters(ClipConstants.commonCookieName);
                                    });                                
                                break;
                            default:
                                $state.go(route);
                                break;
                        }
                    }
                    else if(isMitsubishiUser || isPpxLightUser || isOnlyPpxLightUser){
                        $state.go(RoutesConstants.carSearch); 
                    }
                }).catch(function (error) {
                    if (error === "PingError") {
                        toastr.error($translate.instant("ACCESS_DENIED"));
                    }
                    else {
                        toastr.error($translate.instant("ERROR"));
                    }

                    $state.go(RoutesConstants.connection);
                })
                .finally(function () {
                    blockUI.stop();
                });
            }
        };

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        function manageRetailGroupUrl(retailGroupParameters, userProfile) {
            var action = RetailGroupService.manageRetailGroupObject(retailGroupParameters);
            return $q.resolve().then(function () {
                return DealerManagerSystemeService.hookDMS(userProfile.dmsConfig.url, userProfile.dmsConfig.userDmsId, retailGroupParameters.workshoppartshopid, retailGroupParameters.dealerid)
                    .then(function (dmsResponse) {
                        if (dmsResponse.returnCode === 0) {
                            CarSearchMetierService.changeLinkColor(backImageChangeId);
                            if (RetailGroupService.isUserProfileChanged(userProfile, retailGroupParameters)) {
                                var userContext = RetailGroupService.updateUserProfile(userProfile, retailGroupParameters);
                                userContext.dmsConfig.userDmsId = "";
                                CacheService.setObject(CacheConstants.profil, userContext);
                            }
                            return dmsResponse;
                        }
                        else {
                                if ($translate.instant('DMS_' + dmsResponse.returnCode) != 'DMS_' + dmsResponse.returnCode){
                                    toastr.error($translate.instant('DMS_' + dmsResponse.returnCode));
                                }else{
                                    toastr.error(dmsResponse.message);
                                }

                            return $q.reject("PingError");
                        }
                    });
            }).then(function (dmsState) {
                DealerManagerSystemeService.storeHookResult(dmsState);
                return action;
            });
        }


        /**
         * @name manageClipUrl
         * @desc get clip's route
         * @param {String} sieClipType
         * @param {Object} clipParameters
         * @param {Object} userProfile
         */
        function manageClipUrl(sieClipType, clipParameters) {

            var redirection = "";
            //if sie clip is MD, open MD pdf in the same tab
            if (sieClipType === "MD" && clipParameters) {
                getMdPdfContentFromClip();
            }
            //else if vin is field in clip url, redirect to carSearchRediction to open MR
            else if (sieClipType === "MR" && clipParameters) {
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                redirection = RoutesConstants.carSearchRedirection;
            }
            // else if vin and diagnosis file identifier, redirect to diagnosis file details
            else if(clipParameters && !UtilsMetierService.isEmpty(clipParameters.VIN) && clipParameters.TYPE == VdhConstants.DI && !UtilsMetierService.isEmpty(clipParameters.VDH_DF_ID)){
                redirection = ClipConstants.newDiagnosticPage;
                //to be used after P31_US12 story
               // redirection = ClipConstants.DiagnosticSearch.Result.DiagnosticSearchMainPage;
            }
            //if sie clip is DI redirect to diagnostic search page
            else if (sieClipType === "DI" && clipParameters) {
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                redirection = ClipConstants.DiagnosticSearch.Result.DiagnosticSearchMainPage;
            }
            //else if sie clip is SE, redirect to WD
            else if( sieClipType === "SE" && clipParameters){
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                redirection = ClipService.manageWiringDiagramsAndDiagnosticObject(clipParameters);

            }
            //else if vin and symptom are field in clip url
            else if(!UtilsMetierService.isEmpty(clipParameters.VIN) && !UtilsMetierService.isEmpty(clipParameters.SYMPTOM)){
                redirection = ClipConstants.DiagnosticByUrl.Result.availableVinAndSymptom;
            }
             //else if vin is field in clip url, redirect to carSearchRediction to open MR
            else if (clipParameters && !UtilsMetierService.isEmpty(clipParameters.clipVin)) {
                redirection = RoutesConstants.carSearchRedirection;
            } else {
                redirection = RoutesConstants.carSearch;
            }

            return redirection;
        }

        /**
         * @name diplayInformationMessage
         * @desc display information message if message exist
         */
        function diplayInformationMessage(userProfile) {
            LoginMetierService.displayInformationsLogic()
                .then(function (response) {
                    if (response) {
                        if(response.information){
                            var infoData = response.information? JSON.parse(response.information) : null;
                            var tempJson = JSON.parse(JSON.stringify(Object.assign({}, infoData.content)));
                            _.forIn(tempJson, function(value,key,obj) {
                                obj[infoData.header[key]] = value;
                                delete obj[key];
                              });
                        }
                        CacheService.setObject(CacheConstants.informationMessage, {"message":response.message,"information":tempJson});
                        $rootScope.$broadcast('loadTooltip');
                        if(response.message){
                            $mdDialog.show({
                            templateUrl:
                                "app/components/car/carSearch/components/modalInformation.template.html",
                            controller: "modalInformationController",
                            bindToController: true,
                            controllerAs: "vm",
                            clickOutsideToClose: true,
                            multiple: true,
                            locals: {
                                information: response.message,
                                on_complete: function(response) {
                                    MainMetierService.AsomDocAccessPopIn(userProfile);
                                    if (CacheService.getObject(CacheConstants.r2aDealerList)){
                                        var cachedetail = CacheService.getR2ADealerList();
                                        var dealerList = _.find(cachedetail.dealers, function(item){
                                            return item.active == true;
                                        });
                                        if (!dealerList){
                                            $rootScope.$broadcast('displayDealerPopup', true);
                                        }

                                    }

                                }
                            }
                        });
                        }
                        else{
                            MainMetierService.AsomDocAccessPopIn(userProfile);
                        }
                    }else{
                        MainMetierService.AsomDocAccessPopIn(userProfile);
                    }
                })
                .catch(function () {
                    toastr.error("Error while calling information service");
                });
        }

       /* function openComPdf(userProfile) {
            const langcode = (userProfile && userProfile.portal && userProfile.portal.code) ? userProfile.portal.code : 'en';

            const baseUrl = `${ndPopin}/${langcode}/`;
            const pdfName = `Critic_Comm_ND_${langcode.toUpperCase()}.pdf`;

            const userLangUrl = baseUrl + pdfName;

            checkPdfExists(userLangUrl).then(function (exists) {
                if (exists) {
                    $window.open(userLangUrl, '_blank');
                } else {
                    const fallbackUrl = `${ndPopin}/en/Critic_Comm_ND_EN.pdf`;
                    checkPdfExists(fallbackUrl).then(function (fallbackExists) {
                        if (fallbackExists) {
                            $window.open(fallbackUrl, '_blank');
                        }
                    }).catch(function() {
                    });
                }
            }).catch(function() {
            });
        }
        
        function checkPdfExists(url) {
            return $http.get(url, {
                responseType: 'blob',
                headers: { 'Range': 'bytes=0-11' },
                withCredentials: true
            })
                .then(() => true)
                .catch(() => false);
        }
        */

        /**
         * @name callHtl
         * @desc call htl if country authorized
         */
        function callHtl(isHTLCountry) {
            var htlData = CacheService.getObject(CacheConstants.htlState);
            if (isHTLCountry && (!htlData || _.isEmpty(htlData))) {
                LoginMetierService.checkHtl();
            }
        }

        
        /**
         * @name callTrace
         * @desc call Trace if country authorized
         */
        function callTrace(isTraceCountry) {
            if (isTraceCountry) {
                LoginMetierService.checkTrace();
            }
        }

        /**
         * @name getCurrency
         * @desc set value of currency return by currency service in cache
         */
        function getCurrency() {

            var currencyFromCache = CacheService.getObject(CacheConstants.currency);

            if(!currencyFromCache && _.isEmpty(currencyFromCache)){
                CurrencyService.getCurrency().then(
                    function (response) {
                        var currency = response;
                        CacheService.setObject(CacheConstants.currency, currency);
                    }
                );
            }
        }

        /**
         * @name getMdPdfContentFromClip
         * @desc call service returnSiePdfContentFromClip and display pdf content if found
         * @desc or redirect to error document page not found
         */
        function getMdPdfContentFromClip() {
            var clipInformations = ClipService.getParameters(ClipConstants.clipCookieName);

            DocumentsMetierService.returnSiePdfContentFromClip(
                clipInformations.mrId,
                clipInformations.ecuId,
                clipInformations.codeDef
            )
                .then(function (response) {
                    // clear clip parameters in cache before read parameter from url
                    //CloudFrontService.removeAccessCookies();
                    CacheService.clearAll();

                    var url = response.contentUrl[0];

                    if (response.pageNum) {
                        (url += "#page=" + response.pageNum), "_blank";
                    }
                    $window.open(url, "_self");
                })
                .catch(function () {
                    $state.go(ErrorConstants.noDocumentFound);
                })
                .finally(function () {
                    ClipService.removeParameters(ClipConstants.clipCookieName);
                })
        }
        function redirectToBT(btDocId , inSameTab){
            DocumentsMetierService.returnBTByRef(btDocId).then(function (responseBT) {
                var itemObject;
                if (responseBT && responseBT !== null && responseBT.BT !== null && responseBT.BT.length > 0) {
                    var btNamesAndLabels = [];
                    angular.forEach(responseBT.BT, function (item) {
                        itemObject = {};
                        itemObject['id'] = item.name;
                        itemObject['number'] = item.paramURL;
                        itemObject['label'] = item.designation;
                        itemObject['pdfContent'] = item.pdfContent;

                        btNamesAndLabels.push(itemObject);
                    });
                    if (inSameTab) {
                        DocumentsMetierService.displayBtDetailsDab(responseBT.BT[0].paramURL, responseBT.BT[0].pdfContent);
                    } else {
                        var btDetails = null;
                        if (responseBT.BT.length == 1) {
                            btDetails = {
                                lupNumber  : responseBT.BT[0].LUPNumber,
                                nitgNumber : responseBT.BT[0].NITGNumber,
                                creationDate: responseBT.BT[0].creationDate,
                                updateDate: responseBT.BT[0].updateDate,
                                colorCode : responseBT.BT[0].colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : responseBT.BT[0].colorCode
                                };
                        }                         
                        CarSearchMetierService.changeLinkColor(backImageChangeId);
                        DocumentsMetierService.displayBtDetailsRds(responseBT.BT[0].paramURL, responseBT.BT[0].pdfContent,btDetails);
                    }
                } else if (btDocId >= 10001 && btDocId <= 29999) {
                    redirectToBT(btDocId - 10000);
                } else if (btDocId.length === 5 && !(btDocId >= 10001 && btDocId <= 29999)) {
                    redirectToBT(_.isNumber(btDocId) ? btDocId.toString().substring(0, 4) : btDocId.substring(0, 4));
                } else {
                    toastr.error($translate.instant('DOCUMENT_NO_BT_FOUND'));
                    $state.go(RoutesConstants.carSearch);
                }
            }).catch(function () {
                toastr.error($translate.instant('DOCUMENT_NO_BT_FOUND'));
                $state.go(RoutesConstants.carSearch);
            })
        }
        function manageActicUser(response, userProfile) {
            var isRnetUserType = MainMetierService.isRnetUserType(userProfile.userType);
            if ((userProfile && userProfile.roles && !_.isEmpty(userProfile.roles) && MainMetierService.isIndependantUser(userProfile.roles)) || (isRnetUserType && MainMetierService.isActisProfilNoContext() && response == true)) {
                var pagination = 50;
                var start = pagination.start || 0;
                var numberOfEntriesPerPage = pagination.number || 30;
                var page = Math.ceil(start / numberOfEntriesPerPage) + 1;
                var pageSize = 5000;
                FicViewListService.getFicList(userProfile.dealerId, page, pageSize).then(function (response) {
                    var responseResult = response.result;
                    var listFics = responseResult.Cases;
                    if (MainMetierService.isIndependantUser(userProfile.roles)) {
                        var allowedVin = [];
                        listFics.forEach(function (data) {
                            if (data && data.CaseDetail && data.CaseDetail.status == "New") {
                                allowedVin.push(data.Car.vin)
                            }
                        })
                        const encrypted = CryptoService.AES.encrypt(JSON.stringify(allowedVin), CacheConstants.encryptedValue);
                        CacheService.setObject(CacheConstants.allowedVin, encrypted.toString());
                    }
                    else if (MainMetierService.isActisProfilNoContext()) {
                        var count = 0;
                        listFics.forEach(function (data) {
                            count = (data && data.CaseDetail && ((data.CaseDetail.status == "Answered") || (data.CaseDetail.status == "Resolved"))) ? ++count : count;
                        })
                        $rootScope.$broadcast('processedCIRList', count);
                    }
                })
            }
        }
        function manageExternalRedirection(commonData){
            if(commonData && commonData.TYPE == 'BT' && !_.isEmpty(commonData.docId)){
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                return ClipConstants.COMMON.Result.btWithoutNavigation;
            } else if (commonData && commonData.VIN && !_.isEmpty(commonData.VIN) && commonData.TYPE === "DI") {
                if(commonData.APP_ID === 'ADT' && !_.isEmpty(commonData.DTC_CODE)){
                    CarSearchMetierService.changeLinkColor(backImageChangeId);
                    return ClipConstants.COMMON.Result.DiagnosticSearchMainPage;
                }
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                return ClipConstants.COMMON.Result.DiagnosticSearchMainPage;
            } else if(commonData && commonData.VIN && !_.isEmpty(commonData.VIN) && commonData.TYPE == 'MR'){
                CarSearchMetierService.changeLinkColor(backImageChangeId);
                return RoutesConstants.carSearchRedirection;
            } else if(commonData && commonData.VIN && !_.isEmpty(commonData.VIN) && !_.isEmpty(commonData.SYMPTOM)){
                return ClipConstants.COMMON.Result.availableVinAndSymptom;
            } else if (commonData && commonData.VIN && !_.isEmpty(commonData.VIN)){
                return ClipConstants.COMMON.Result.vinSearch;
            } else{
                return RoutesConstants.carSearch;
            }
        }   

        }
    }
})();

(function () {
    angular
        .module('phenix')
        .controller('ConnectionCtrl', ConnectionCtrl);

    /** @ngInject */
    function ConnectionCtrl(
            $mdDialog,
        $window,
        $location,
        $sce,
        $http,
        $httpParamSerializerJQLike,
        configConstantes,LoginConstants,
        $scope,
        toastr,
        $translate,
        $state,
        RoutesConstants,
        TokenService,
        CacheConstants,
        $rootScope,
        CacheService,
        CloudFrontService,
        CryptoService,
        UtilsMetierService,
        CarSearchResultConstants,RestUpgrade,blockUI,UserKeyService) {


        var vm = this;
                if ($window.sessionStorage.getItem('showAsomDocAccessPopup') === '1') {
                    $window.sessionStorage.removeItem('showAsomDocAccessPopup');
                    $mdDialog.show({
                        locals: {},
                        templateUrl: 'app/main/AsomDocAccessPopup.html',
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        controller: 'AsomDocAccessPopupController',
                        bindToController: true,
                        controllerAs: 'vm',
                    });
                }
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        vm.showUI = true;
        vm.version = configConstantes.version;
        vm.message = null;
        //vm.gu = configConstantes.gigyaCDNUrl+"?apikey="+configConstantes.gigyaApiKey;
        //vm.ak = configConstantes.gigyaApiKey;
        vm.form = {};
        vm.isSubmitted = false;
        vm.asosLink = configConstantes.asosLink;
        vm.ndLegalNoticeUrl = configConstantes.ndLegalNoticeUrl;
        vm.ndDataPolicyUrlisActive = false;
        vm.dataPolicyFileName = CarSearchResultConstants.dataPolicyFileName;
        vm.ndFooterFileDate = CarSearchResultConstants.ndFooterFileDate;
        vm.newUiEnable = configConstantes.newHeaderMenu;

        vm.redirection = function (ndIdpType) {
            CloudFrontService.removeAccessCookies();
            TokenService.delToken();
            CacheService.clearAll();
            CacheService.setUserType(ndIdpType);
            var isOktaRedirect = UtilsMetierService.isOktaAuthentication();
            if(ndIdpType.toLowerCase() == 'arca' || (isOktaRedirect && ndIdpType.toLowerCase() == 'rnet')){
                window.location.href = configConstantes.springBackBaseUrl + LoginConstants.authorize + CacheService.getUserType();                
            }else{
                window.location.href = configConstantes.baseUrlBack + '/samlAuth?nd_idp=' + ndIdpType;
            }
        };

        vm.gigyaLogin = gigyaLogin;
        vm.subscribeOrRequestForgottenPassword = subscribeOrRequestForgottenPassword;
        vm.openEmergencyLink = openEmergencyLink;
        vm.openDataProtectionLink = openDataProtectionLink;
        vm.b2bPortal = b2bPortal;

        /**
         *  Opens a new tab when either Subscription or Forgotten Password buttons are clicked
         */
        
     
        function subscribeOrRequestForgottenPassword() {
            window.open(vm.asosLink);
        }

        function openDataProtectionLink() {
            if ($window.clientInformation && $window.clientInformation.language) {
                var lang = $window.clientInformation.language.substr(0,2).toLowerCase();
                if (vm.dataPolicyFileName) {
                    vm.ndDataPolicyUrlisActive = true;
                    vm.ndDataPolicyUrl = vm.ndLegalNoticeUrl + '/' + vm.dataPolicyFileName + '_' + ((lang == 'en') ? lang :'fr') + '_' + vm.ndFooterFileDate +'.html';
                    window.open(vm.ndDataPolicyUrl);
                }
                
            }
        }

        function openEmergencyLink() {
            try {
                var actionId = dtrum.enterAction("trackingRescueLink") || 0;
                dtrum.addActionProperties(actionId, {
                    shortString: {
                        buttonName: { value: "EmergencyLink", public: true }
                    }
                });
                dtrum.leaveAction(actionId);
            } catch (e) {
                console.log(e);
            } finally{
                window.open(configConstantes.emergencylink);
            }
        }

        function stopBlockUIWithError(errorMessage) {
            blockUI.stop();
            toastr.error(errorMessage);
        }

        function storeAsomTokenData(decode) {
            if (decode.tokenBalance) {
                const encryptedTokenBalance = CryptoService.AES.encrypt(decode.tokenBalance, CacheConstants.encryptedValue);
                CacheService.setObject(CacheConstants.tokenBalance, encryptedTokenBalance.toString());
            }
            if (decode.asomSubscriptions) {
                const encryptedAsomSubscription = CryptoService.AES.encrypt(decode.asomSubscriptions, CacheConstants.encryptedValue);
                CacheService.setObject(CacheConstants.asomSubscription, encryptedAsomSubscription.toString());
            }
            if (decode.applicabilities) {
                const encryptedApplicabilities = CryptoService.AES.encrypt(decode.applicabilities, CacheConstants.encryptedValue);
                CacheService.setObject(CacheConstants.applicabilities, encryptedApplicabilities.toString());
            }
            if (decode.allowedVin) {
                const allowedVin = decode.allowedVin === "4012";
                CacheService.setObject(CacheConstants.asomNotAllowed, allowedVin);
            }
        }

        function gigyaLogin(gigyaForm) {
           
            blockUI.start();
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = configConstantes.gigyaCDNUrl + "?apikey=" + configConstantes.gigyaApiKey;
            document.body.appendChild(script);
            script.onload = function () {
                onGigyaJSLoad(gigyaForm);
            }
            script.onerror = function () {
                console.log("gigya load failed");
                stopBlockUIWithError("Error loading gigya,a third party library");
            };

        }
        function onGigyaJSLoad(gigyaForm) {
            console.log("gigya loaded");
            vm.isSubmitted = true;

            if (typeof gigya === 'undefined' || !gigya || !gigya.accounts || typeof gigya.accounts.login !== 'function') {
                stopBlockUIWithError($translate.instant('ERROR'));
                return;
            }
            
            if (gigyaForm.$valid) {

                var params = {
                    "callback": onLogin,
                    "loginID": vm.form.email,
                    "password": vm.form.password
                };
                gigya.accounts.login(params);
            } else {
                stopBlockUIWithError($translate.instant('ERROR'));
            }

        }
     
        
        //callback
        function onLogin(response) {
            
            if (response && response.errorCode === 0) {
                CloudFrontService.removeAccessCookies();
                CacheService.clearAll();
                TokenService.delToken();
                RestUpgrade.one(LoginConstants.independentLogin).post('', {
                    gigya: response
                }).then(function (response) {
                    if (response) {
                        if (response.userKey) {
                            UserKeyService.setUserKey(response.userKey);
                        }
                        
                        const decryptedasomSubscriptionsAndTokenBalance = UtilsMetierService.decryptAccessToken(response.asomSubscriptionsAndTokenBalance);
                        const decode = $window.jwt_decode(decryptedasomSubscriptionsAndTokenBalance);
                        storeAsomTokenData(decode);

                        var location = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        TokenService.setToken(response.jwtToken);
                        window.location.href = location + "/#!/?token=" + response.jwtToken;
                    }
                }).catch(function (error) {
                    if (error.data === "4010") {
                        toastr.error($translate.instant('ASOM_INVALID_SUBCRIPTION'));
                    } else if (error.data === "4011") {
                        toastr.error($translate.instant('ASOM_INVALID_SUBCRIPTION_DATE'));
                    } else {
                        toastr.error($translate.instant('ERROR'));
                    }
                }).finally(function () {
                    blockUI.stop();
                });
            } else {
                blockUI.stop();
                console.log("An error has occured !" + '\n' +
                    "Error details: " + response.errorMessage + '\n' +
                    "In method: " + response.operation);
                toastr.error($translate.instant('LOGIN_GIGYA_ERROR'));
            }
        }
        function b2bPortal() {
            blockUI.stop();
            window.open(LoginConstants.b2bPortalUrl, '_blank');
        }
    }
    

})();

var IsVoiceMode=!1,filterList=[],fontSize=15,restorefontSize=15,saveLocalVariables=!0,IsRotate=!0,isResetClick=!1,elementFocusEnabled=!1;filterList[1]="hc_extension_off",filterList[2]="hc_extension_highcontrast",filterList[3]="hc_extension_grayscale",filterList[4]="hc_extension_invert",filterList[5]="hc_extension_invert_grayscale",filterList[6]="hc_extension_yellow_on_black";var noteTextarea=document.querySelector("#note-textarea"),notesList=document.querySelector("ul#notes"),noteContent="";function setLocalStorage(e,t){if(null!==localStorage.getItem("accEncode")){var n=JSON.parse(localStorage.getItem("accEncode"));"filter"==e?n.filterItem=t:"font"==e?n.fontSize=t:"speech"==e?n.speechmode=t:"save"==e&&(n.save=t),localStorage.setItem("accEncode",JSON.stringify(n))}}function positionAccessibilityPanel(){const e=document.querySelector("#accessibilityPanel"),t=document.querySelector(".accGear"),n=document.querySelector(".accessibility-wrapper"),a=getFooterContainer();if(e&&t)if(a&&n&&n.parentElement===a){const n=t.getBoundingClientRect(),a=Math.max(8,window.innerWidth-n.right),i=Math.max(8,window.innerHeight-n.top+8),s=Math.max(140,n.top-12);e.style.setProperty("position","fixed","important"),e.style.setProperty("right",a+"px","important"),e.style.setProperty("bottom",i+"px","important"),e.style.setProperty("left","auto","important"),e.style.setProperty("top","auto","important"),e.style.setProperty("z-index","1000001","important"),e.style.setProperty("max-height",s+"px","important"),e.style.setProperty("overflow-y","auto","important")}else e.style.removeProperty("position"),e.style.removeProperty("right"),e.style.removeProperty("bottom"),e.style.removeProperty("left"),e.style.removeProperty("top"),e.style.removeProperty("z-index"),e.style.removeProperty("max-height"),e.style.removeProperty("overflow-y")}function showOrHideMenu(){const e=document.querySelector("#accessibilityPanel"),t=document.querySelector(".accGear");"none"!==e.style.display&&e.style.display?(e.style.display="none",t.classList.remove("accActive")):(e.style.display="block",t.classList.add("accActive"),positionAccessibilityPanel()),restorefontSize=fontSize=window.getComputedStyle(document.getElementsByTagName("body")[0]).fontSize.substring(0,2)}function fontSizeChange(e){1==e?(fontSize=parseInt(fontSize)+2,document.body.style.fontSize=fontSize+"px"):(fontSize=parseInt(fontSize)-2,document.body.style.fontSize=fontSize+"px"),setLocalStorage("font",fontSize)}function modeSelected(e){const t=document.getElementsByTagName("html")[0];t&&(t.style.filter="",t.offsetHeight,t.style.filter="url(#"+e+")")}function validate(){fixColors(document.body)}function getHtml(){const e='\n        <style>\n            .accGear {\n                width: 40px;\n                height: 40px;\n                background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMzMzIj48cGF0aCBkPSJNMTIgMTVjLTEuNjUgMC0zIDEuMzUtMyAzcy0xLjM1IDMtMyAzLTMtMS4zNS0zLTMgMS4zNS0zIDMtM2MxLjY2IDAgMyAxLjM1IDMgMyAwIDEuNjYtMS4zNCAzLTMgMy0xLjY1IDAtMy0xLjM0LTMtMyAwLTEuNjUgMS4zNS0zIDMtM3ptMCA2Yy0xLjY1IDAtMy0xLjM1LTMtMyAwLTEuNjYgMS4zNS0zIDMtM3MzIDEuMzQgMyAzYzAgMS42NS0xLjM1IDMtMyAzeiIvPjwvc3ZnPg==) no-repeat center;\n                background-size: 24px 24px;\n                border-radius: 50%;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background-color: white;\n                box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n            }\n            .accGear:hover {\n                background-color: #f5f5f5;\n                box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n                transform: scale(1.05);\n            }\n            .accGear.accActive {\n                background-color: #e3f2fd;\n            }\n            .FilterItem, .Item {\n                padding: 10px;\n                cursor: pointer;\n                border-radius: 4px;\n                transition: background-color 0.2s ease;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin: 4px 0;\n                min-height: 36px;\n                width: 100%;\n                box-sizing: border-box;\n            }\n            .FilterItem:hover, .Item:hover {\n                background-color: #f0f0f0;\n            }\n            .FilterItem:active, .Item:active {\n                background-color: #e0e0e0;\n            }\n            .accImg {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                pointer-events: none;\n                width: 100%;\n                height: 100%;\n            }\n            .accImg img {\n                pointer-events: none;\n            }\n            #accessibilityPanel {\n                padding: 8px 4px;\n                box-sizing: border-box;\n            }\n            .tabcontent {\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n            }\n            a#manual {\n                width: 100%;\n                text-decoration: none;\n            }\n        </style>\n        <div class="accessibility-wrapper" style="position: fixed; right: 15px;  z-index: 1000001;">\n            <div class="accGear" title="Accessibility" onclick="showOrHideMenu()" tabindex="0" role="button" aria-label="Accessibility Options"></div>\n            <div class="tabPanel container" id="accessibilityPanel" style="display: none; width: 40px; background: white; border-radius: 4px; box-shadow: 0 2px 10px rgba(0,0,0,0.15); box-sizing: border-box;">\n                <div class="saveCheckBox" style="display:none">\n                    <input type="checkbox" id="accAutoSave" name="accAutoSave" aria-label="Auto Save Settings"/> Auto Save\n                </div>\n                <div class="tabcontent activeTab" style="margin-left:5px">\n                    <div class="FilterItem" data-value="2" title="Increased Contrast">\n                        <span class="accImg">\n                            <img src="../../assets/brightness.svg" class="accImg" alt="Increased Contrast" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="FilterItem" data-value="4" title="Inverted Color">\n                        <span class="accImg">\n                            <img src="../../assets/invert-colors.svg" class="accImg" alt="Inverted Color" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="FilterItem" data-value="3" title="Grayscale">\n                        <span class="accImg">\n                            <img src="../../assets/greyscale.svg" class="accImg" alt="Grayscale" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="FilterItem" data-value="5" title="Inverted Grayscale">\n                        <span class="accImg">\n                            <img src="../../assets/greyscale.svg" class="accImg" alt="Inverted Grayscale" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="FilterItem" data-value="6" title="Yellow on Black">\n                        <span class="accImg">\n                            <img src="../../assets/chat.svg" class="accImg" alt="Yellow on Black" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" style="display:none" onclick="fontSizeChange(1)" title="Increase Font">\n                        <span class="accImg">\n                            <img src="../../assets/zoom-in.svg" class="accImg" alt="Increase Font" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" style="display:none" onclick="fontSizeChange(2)" title="Decrease Font">\n                        <span class="accImg">\n                            <img src="../../assets/zoom-out.svg" class="accImg" alt="Decrease Font" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" data-value="7" onclick="validate()" title="Fix Text Contrast">\n                        <span class="accImg">\n                            <img src="../../assets/color.svg" class="accImg" alt="Fix Text Contrast" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" style="display:none" onclick="startVoiceMode()" title="Enable Voice Mode">\n                        <span class="accImg">\n                            <img src="../../assets/mic.png" class="accImg" alt="Enable Voice Mode" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" data-value="8" onclick="populatePlaceHolderAndFocus()" title="Element focus">\n                        <span class="accImg">\n                            <img src="../../assets/focus.jpg" class="accImg" alt="Element focus" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" style="display:none" onclick="screenRotate()" title="Screen Rotate">\n                        <span class="accImg">\n                            <img src="../../assets/rotate.png" class="accImg" alt="Screen Rotate" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="FilterItem" style="display:none" onclick="pageTitle(1)" title="Page title">\n                        <span class="accImg">\n                            <img src="../../assets/page-title.svg" class="accImg" alt="Page title" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <div class="Item" data-value="9" style="display:none" onclick="magnifier()" title="Magnifier">\n                        <span class="accImg">\n                            <img src="../../assets/magnifier.svg" class="accImg" alt="Magnifier" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                    <a id="manual" href="../../assets/Accessibility-Manual.pdf" target="_blank" title="Manual" data-value="10">\n                        <div class="Item">\n                            <span class="accImg">\n                                <img src="../../assets/manual.svg" class="accImg" alt="Manual" style="width:14px;height:14px;" />\n                            </span>\n                        </div>\n                    </a>\n                    <div class="FilterItem" data-value="1" title="Reset" id="reset" onclick="reset()">\n                        <span id="resetChild" class="accImg">\n                            <img src="../../assets/refresh.svg" class="accImg" alt="Reset" style="width:14px;height:14px;" />\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div id="hc_extension_bkgnd" style="position: fixed; left: 0px; top: 0px; right: 0px; bottom: 0px; z-index: -1999999999; display: block; background: none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255);"></div>\n        <span id="hc_extension_svg_filters">\n            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">\n                <defs>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_off">\n                        <feComponentTransfer>\n                            <feFuncR type="table" tableValues="0 1"></feFuncR>\n                            <feFuncG type="table" tableValues="0 1"></feFuncG>\n                            <feFuncB type="table" tableValues="0 1"></feFuncB>\n                        </feComponentTransfer>\n                    </filter>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_highcontrast">\n                        <feComponentTransfer>\n                            <feFuncR type="gamma" exponent="3.0"></feFuncR>\n                            <feFuncG type="gamma" exponent="3.0"></feFuncG>\n                            <feFuncB type="gamma" exponent="3.0"></feFuncB>\n                        </feComponentTransfer>\n                    </filter>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_grayscale">\n                        <feColorMatrix type="matrix" values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"></feColorMatrix>\n                        <feComponentTransfer>\n                            <feFuncR type="gamma" exponent="3"></feFuncR>\n                            <feFuncG type="gamma" exponent="3"></feFuncG>\n                            <feFuncB type="gamma" exponent="3"></feFuncB>\n                        </feComponentTransfer>\n                    </filter>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_invert">\n                        <feComponentTransfer>\n                            <feFuncR type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncR>\n                            <feFuncG type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncG>\n                            <feFuncB type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncB>\n                        </feComponentTransfer>\n                    </filter>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_invert_grayscale">\n                        <feColorMatrix type="matrix" values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"></feColorMatrix>\n                        <feComponentTransfer>\n                            <feFuncR type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncR>\n                            <feFuncG type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncG>\n                            <feFuncB type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncB>\n                        </feComponentTransfer>\n                    </filter>\n                    <filter x="0" y="0" width="99999" height="99999" id="hc_extension_yellow_on_black">\n                        <feComponentTransfer>\n                            <feFuncR type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncR>\n                            <feFuncG type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncG>\n                            <feFuncB type="gamma" amplitude="-1" exponent="3" offset="1"></feFuncB>\n                        </feComponentTransfer>\n                        <feColorMatrix type="matrix" values="0.3 0.5 0.2 0 0 0.3 0.5 0.2 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>\n                    </filter>\n                </defs>\n            </svg>\n        </span>\n    ';function t(){if(document.querySelector(".accessibility-wrapper"))return!0;const t=document.createElement("div");return t.innerHTML=e,function(){const e=getFooterContainer(),n=t.querySelector(".accessibility-wrapper"),a=t.querySelector("#hc_extension_svg_filters"),i=t.querySelector("#hc_extension_bkgnd");n&&(e?(n.style.setProperty("position","static","important"),n.style.setProperty("bottom","auto","important"),n.style.setProperty("right","auto","important"),n.style.setProperty("left","auto","important"),n.style.setProperty("top","auto","important"),n.style.zIndex="999999",e.appendChild(n)):(n.style.position="fixed",n.style.bottom="15px",n.style.right="15px",n.style.zIndex="999999",document.body.appendChild(n))),a&&(a.style.position="absolute",a.style.width="0",a.style.height="0",a.style.overflow="hidden",a.style.pointerEvents="none",document.body.appendChild(a)),i&&(i.style.pointerEvents="none",document.body.appendChild(i))}(),e}return t()||setTimeout(()=>{t()||document.body.insertAdjacentHTML("beforeend",e)},500),e}function getFooterContainer(){const e=document.querySelector("footer.phnxFooter");return e?e.querySelector(".right.no-print.newFooter #footerContent")||e.querySelector(".right.no-print #footerContent")||e.querySelector(".right.no-print.newFooter")||e.querySelector(".right.no-print")||e:null}function ensureAccessibilityIconZIndex(){const e=document.querySelector(".accessibility-wrapper");e&&(e.style.zIndex="999999")}function isVisibleFooter(e){if(!e)return!1;if(e.classList&&e.classList.contains("footer-hidden"))return!1;const t=window.getComputedStyle(e);return!!t&&"none"!==t.display&&"hidden"!==t.visibility&&"0"!==t.opacity}function isElementVisible(e){if(!e)return!1;const t=window.getComputedStyle(e);return!!t&&"none"!==t.display&&"hidden"!==t.visibility&&"0"!==t.opacity}function ensureAccessibilityIconPlacement(){let e=document.querySelector(".accessibility-wrapper");if(e||(getHtml(),e=document.querySelector(".accessibility-wrapper")),!e)return;const t=getFooterContainer();t?(e.parentElement!==t&&t.appendChild(e),e.style.setProperty("position","static","important"),e.style.setProperty("bottom","auto","important"),e.style.setProperty("right","auto","important"),e.style.setProperty("left","auto","important"),e.style.setProperty("top","auto","important"),e.style.setProperty("margin-left","8px","important"),e.style.setProperty("vertical-align","middle","important"),e.style.zIndex="999999",e.style.display="inline-flex"):(e.parentElement!==document.body&&document.body.appendChild(e),e.style.setProperty("position","fixed","important"),e.style.setProperty("bottom","15px","important"),e.style.setProperty("right","15px","important"),e.style.setProperty("left","auto","important"),e.style.setProperty("top","auto","important"),e.style.setProperty("margin-left","0","important"),e.style.zIndex="999999",e.style.display="block");const n=document.querySelector("#accessibilityPanel");n&&"none"!==n.style.display&&n.style.display&&positionAccessibilityPanel()}function populatePlaceHolderAndFocus(){elementFocusEnabled=!0;for(var e=document.querySelectorAll("input[type='text'],input[type='search'],input[type='password'],textarea,select,a,button"),t=0;t<e.length;t++)e[t].classList.add("addFocus"),"A"==e[t].tagName&&e[t].setAttribute("tabindex",0);var n=document.querySelectorAll("input[type='checkbox'],input[type='radio']");for(t=0;t<n.length;t++)n[t].parentElement.classList.add("addFocus")}function containsClass(e,t){return(" "+e.className+" ").indexOf(" "+t+" ")>-1}function reset(){document.body.style.fontSize=restorefontSize,elementFocusEnabled=!1;for(var e=document.querySelectorAll("input[type='text'],input[type='search'],input[type='password'],textarea,select,a,button"),t=0;t<e.length;t++)e[t].classList.remove("addFocus");var n=document.querySelectorAll("input[type='checkbox'],input[type='radio']");for(t=0;t<n.length;t++)n[t].parentElement.classList.remove("addFocus");document.body.style.fontSize=restorefontSize}function fixColors(e,t={isBackground:!1}){var n={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgrey:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkslategrey:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",grey:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4",indianred:"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgray:"#d3d3d3",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",slategrey:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};function a(e){var t=e.match(/rgba[ \t]*\([ \t]*([0-9.]+)[ \t]*,[ \t]*([0-9.]+)[ \t]*,[ \t]*([0-9.]+)[ \t]*,[ \t]*([0-9.]+)[ \t]*\)/),n=!0;null===t&&(t=e.match(/rgb[ \t]*\([ \t]*([0-9.]+)[ \t]*,[ \t]*([0-9.]+)[ \t]*,[ \t]*([0-9.]+)[ \t]*\)/),n=!1);var a=1*t[1],i=1*t[2],s=1*t[3],o=1*t[4],r=(299*a+587*i+114*s)/1e3,l=20;return r<127&&(l=235),isTransparent=n&&0===o,{r:a,g:i,b:s,a:o,brightness:r,maxContrast:"rgb("+l+","+l+","+l+")",rgb:"rgb("+a+","+i+","+s+")",isAlpha:n,isTransparent:isTransparent}}function i(e,t){var n,a=e;return a.currentStyle?n=a.currentStyle[t]:window.getComputedStyle&&(n=document.defaultView.getComputedStyle(a,null).getPropertyValue(t)),n}function s(e,t){var o={c:{css:"color",v:"rgb(0,0,0)"},b:{css:"background-color",v:"rgb(255,255,255)"}};if(null==e||"html"===e.tagName.toLowerCase())return o[t].v;var r="";try{void 0===(r=i(e,o[t].css))&&"background-color"===o[t].css&&(r=i(e,"background")),r=function(e){if(null===e||"string"!=typeof e||(e=e.toLowerCase()).indexOf("transparent")>=0)return"rgba(0,0,0,0)";if(null===e.match(/rgb.+[0-9]+/)){var t=e;if(null===e.match(/#[0-9a-f]+/)&&void 0===(t=n[e]))return"rgba(0,0,0,0)";t.length<=4&&(t=t.replace(/([0-9a-f])/g,"0$1"));var a=[];t=t.replace(/[0-9a-f]{2}/g,function(e,t){a[a.length]=e});var i="rgb({r},{g},{b})";return(i=(i=i.replace("{r}",parseInt(a[0],16))).replace("{g}",parseInt(a[1],16))).replace("{b}",parseInt(a[2],16))}return e}(r)}catch(e){r=o[t].v}return a(r).isTransparent?s(e.parentNode,t):r}!function e(t,n,i){const o=a(s(t=t||document.body,"b")),r=a(s(t,"c"));o.isAlpha&&(t.style.backgroundColor=o.rgb),r.isAlpha&&(t.style.color=r.rgb),Math.abs(r.brightness-o.brightness)<80&&(t.style.color=o.maxContrast),Array.from(t.children).forEach(t=>{const n=t.tagName;(!n||"INPUT"!==n&&"BUTTON"!==n)&&e(t,o,r)})}(e)}document.addEventListener("DOMContentLoaded",function(e){if(!document.querySelector(".accessibility-wrapper")){if(getHtml(),null!==localStorage.getItem("accEncode")){var t=JSON.parse(localStorage.getItem("accEncode"));saveLocalVariables=t.save,1==t.save&&(modeSelected(filterList[parseInt(t.filterItem)]),document.body.style.fontSize=parseInt(t.fontSize)+"px")}else t={filterItem:1,speechmode:!1,fontSize:fontSize,save:saveLocalVariables},localStorage.setItem("accEncode",JSON.stringify(t));const e=document.querySelector("#accAutoSave");e&&(e.checked=saveLocalVariables)}ensureAccessibilityIconPlacement(),setTimeout(ensureAccessibilityIconPlacement,100),setTimeout(ensureAccessibilityIconPlacement,500),setTimeout(ensureAccessibilityIconPlacement,1e3),setInterval(ensureAccessibilityIconPlacement,1500),document.addEventListener("click",function(){setTimeout(ensureAccessibilityIconPlacement,80)}),window.addEventListener("hashchange",function(){setTimeout(ensureAccessibilityIconPlacement,80)}),window.addEventListener("popstate",function(){setTimeout(ensureAccessibilityIconPlacement,80)}),window.addEventListener("resize",function(){setTimeout(positionAccessibilityPanel,30)}),window.addEventListener("scroll",function(){setTimeout(positionAccessibilityPanel,30)});const n=new MutationObserver(function(){setTimeout(ensureAccessibilityIconPlacement,50)});document.body&&n.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["class","style"]}),document.addEventListener("keyup",function(e){if(e.isComposing||121===e.keyCode){const e=document.querySelector(".accGear");e.style.display="none"===e.style.display?"block":"none"}}),document.addEventListener("keydown",function(e){if(e.isComposing||121===e.keyCode){const e=document.querySelector(".accGear");e.style.display="none"===e.style.display?"block":"none"}})}),document.addEventListener("click",function(e){setTimeout(ensureAccessibilityIconZIndex,10);const t=e.target.closest(".FilterItem");if(t){e.preventDefault(),e.stopPropagation();const n=t.getAttribute("data-value");n&&(setLocalStorage("filter",n),modeSelected(filterList[n]),restorefontSize&&(document.body.style.fontSize=restorefontSize+"px"))}},!0),document.addEventListener("click",function(e){"reset"!=e.target.id&&"resetChild"!=e.target.id&&e.target.parentElement&&e.target.parentElement.id&&"resetChild"!=e.target.parentElement.id&&elementFocusEnabled&&(document.querySelectorAll("input[type='text'],input[type='search'],input[type='password'],textarea,select,a,button").forEach(e=>{e.classList.add("addFocus"),"A"===e.tagName&&e.setAttribute("tabindex",0)}),document.querySelectorAll("input[type='checkbox'],input[type='radio']").forEach(e=>e.parentElement.classList.add("addFocus")))});
(function () {
    'use strict';

    angular
        .module('phenix')
        .config(favouritesRouterConfig);

    /* @ngInject */
    function favouritesRouterConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.favourites, {
            url: '/favourites',
            templateUrl: 'app/components/favourites/TM/favourites.template.html',
            controller: 'FavouritesController',
            controllerAs: 'vm',
            params: {}
        });
        $stateProvider.state(RoutesConstants.favouritesPR, {
            url: '/favouritesProduct/:category/:subCategory/:mode',
            templateUrl: 'app/components/favourites/PR/favouritesPR.template.html',
            controller: 'FavouritesPRController',
            controllerAs: 'vm',
            params: {

            }
        });
    }
})();

(function () {
    "use strict";
    angular.module('phenix').constant('FavouriteConstantes', {
        categories: 'favourites',
        nonCodifiedLaborTime: {
            "categories": [
                {
                    "name": "TM_NOCODIF_CAT_FIXPRICE",
                    "subCategories": [],
                    "technicalities": [],
                    "code": "0999"
                },
                {
                    "name": "TM_NOCODIF_CAT_MECHANICAL",
                    "subCategories": [
                        {
                            "name": "TM_NOCODIF_SCAT_ENGINE",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "1999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "1888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "1777"
                                }
                            ]
                        },
                        {
                            "name": "TM_NOCODIF_SCAT_TRANSMISSION",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "2999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "2888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "2777"
                                }
                            ]
                        },
                        {

                            "name": "TM_NOCODIF_SCAT_MECHANICAL_ORGANS",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "3999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "3888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "3777"
                                }
                            ]
                        },
                        {
                            "name": "TM_NOCODIF_SCAT_AIR_CONDITIONNER",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "6999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "6888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "6777"
                                }
                            ]
                        },
                        {

                            "name": "TM_NOCODIF_SCAT_ELEC_EQU_ACC_INSTALL",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "8999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "8888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "8777"
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "TM_NOCODIF_CAT_AUTO_BODY",
                    "subCategories": [
                        {
                            "name": "TM_NOCODIF_SCAT_SHEET_METAL_WORKSHOP",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "4999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "4888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "4777"
                                }
                            ]
                        },
                        {
                            "name": "TM_NOCODIF_SCAT_MECHANICS_AND_ACCESSOIRES",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "5999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "5888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "5777"
                                }
                            ]
                        },
                        {
                            "name": "TM_NOCODIF_SCAT_SEALING",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "6999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "6888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "6777"
                                }
                            ]
                        },
                        {
                            "name": "TM_NOCODIF_SCAT_TRIM",
                            "technicalities": [
                                {
                                    "name": "TM_NOCODIF_TECH_NORMAL",
                                    "code": "7999"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_HIGH",
                                    "code": "7888"
                                },
                                {
                                    "name": "TM_NOCODIF_TECH_VERY_HIGH",
                                    "code": "7777"
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "TM_NOCODIF_CAT_PAINTING",
                    "subCategories": [],
                    "technicalities": [
                        {
                            "name": "TM_NOCODIF_TECH_HIGH",
                            "code": "9499"
                        }
                    ]
                }

            ]
        },
        favoritesProductsCategories:{
            "categories": [
                {
                    "categoryName": "PR_FAV_CAT_MISCELLANEOUS_LUBRICANTS",
                    "products": ["6901056869"],
                    "isDefault": true,
                    "subCategories": [
                        {
                            "subCategoryName": "PR_FAV_SCAT_1",
                            "products": ["8201056869", "9501056869"],
                            "isDefault": true
                        },
                        {
                            "subCategoryName": "PR_FAV_SCAT_2",
                            "products": ["7501056869"],
                            "isDefault": true
                        }
                    ]
                },
                {
                    "categoryName": "PR_FAV_CAT_TYRES",
                    "products": ["6901056869"],
                    "isDefault": true,
                    "subCategories": [
                        {
                            "subCategoryName": "PR_FAV_SCAT_3",
                            "products": [],
                            "isDefault": true
                        }
                    ]
                },
                {
                    "categoryName": "PR_FAV_CAT_BATTERIES",
                    "products": ["6901056869"],
                    "isDefault": true,
                    "subCategories": []
                },
                {
                    "categoryName": "PR_FAV_CAT_ACCESSORIES",
                    "subCategories": [],
                    "products": [ "690105678" ],
                    "isDefault": true
                },
                {
                    "categoryName": "PR_FAV_CAT_SERVICING",
                    "subCategories": [],
                    "products": [ "690105678" ],
                    "isDefault": true
                },
                {
                    "categoryName": "PR_FAV_CAT_MISCELLANEOUS",
                    "subCategories": [
                        {
                            "subCategoryName": "PR_FAV_SCAT_1",
                            "products": ["6901056869", "5401056869"],
                            "isDefault": true
                        },
                        {
                            "subCategoryName": "PR_FAV_SCAT_5",
                            "products": [],
                            "isDefault": true
                        },
                        {
                            "subCategoryName": "PR_FAV_SCAT_9",
                            "products": [],
                            "isDefault": true
                        }
                    ],
                    "products": [ "690105678" ],
                    "isDefault": true
                },
                {
                    "categoryName": "PR_FAV_CAT_PAINT_CONSUMABLES",
                    "subCategories": [],
                    "products": [ "690105678" ],
                    "isDefault": true
                },
                {
                    "categoryName": "Catégorie pesraonnalisé par dealer 1",
                    "subCategories": [
                        {
                            "subCategoryName": "sous catégorie pesraonnalisé par dealer 1",
                            "products": ["6901056869", "5401056869"],
                            "isDefault": false
                        }
                    ],
                    "isDefault": false
                }
            ]
        },
        menuCategoriesList: [
            {
                "categoryName": "TM_NOCODIF_CAT_FIXPRICE",
                "subCat": []
            },
            {
                "categoryName": "TM_NOCODIF_CAT_MECHANICAL",
                "subCat": []
            },
            {
                "categoryName": "TM_NOCODIF_CAT_AUTO_BODY",
                "subCat": []
            },
            {
                "categoryName": "TM_NOCODIF_CAT_PAINTING",
                "subCat": []
            }
        ],
        nonCodedLaborTimeUrl: '/proxy/daca/rest/v1/dealers/',
        addNonCodedLaborTimeUrl: '/proxy/daca/rest/v1/dealers/',
        getNonCodedLaborTimeUrl: '/proxy/daca/rest/v1/dealers/',
        //daca apigee
        apigeeNonCodedLaborTimeUrl : '/proxy/apigee/d4c/llt/v1/dealers/',
        apigeeAddNonCodedLaborTimeService : '/local-labor-times',
        apigeeBaseLaborTimeService: 'local-labor-times',
        
        addNonCodedLaborTimeService: '/local-labor-time',
        baseLaborTimeService: 'local-labor-time',
        baseDacaUrl: '/proxy/daca/rest/v1/dealers/',
        getFavoritesProducts: '/favorite-products',
        //TODO: use only baseDacaUrl
        PRUrl:'/proxy/daca/rest/v1/dealers/',
        addPR: '/favorite-products',
        subCategoryParam: '/subCategory',
        subCategoryParamDaca: '/subCategoryName',
        productIdParam: '/productId/',
        productIdParamDaca: '/product/',

        //apigee Favorite products
        apigeeBaseDacaUrl: '/proxy/apigee/d4c/fp/v1/dealers/',
        apigeeGetFavoritesProducts: '/favorite-products',
        favoriteCategories: '/categories',
        favoriteSubcategories: '/subcategories',
        defaultCategories: ["PR_FAV_CAT_MISCELLANEOUS_LUBRICANTS", "PR_FAV_CAT_TYRES", "PR_FAV_CAT_BATTERIES", "PR_FAV_CAT_PAINT_CONSUMABLES",
            "PR_FAV_CAT_ACCESSORIES", "PR_FAV_CAT_SERVICING", "PR_FAV_CAT_MISCELLANEOUS"]
    });
})();

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
      $stateProvider
        .state(RoutesConstants.docprivData, {
          url: '/docprivData',
          templateUrl: 'app/components/docpriv/docpriv.template.html',
          controller: 'DocprivController',
          params: {
            isFromProductSheet: false
          },
          controllerAs: 'vm'
        })
    }
  })();
  
(function () {
    "use strict";

    angular
        .module("phenix")
        .controller("DocprivController", DocprivController)
        .directive("focusToInput", function () {
            return {
                restrict: "A",
                require: ["^mdSelect"],
                link: function (scope, element) {
                    var currentElement = element;
                    scope.$watch(
                        function () {
                            while (
                                !currentElement.hasClass(
                                    "md-select-menu-container"
                                )
                            ) {
                                currentElement = currentElement.parent();
                            }
                            return currentElement.hasClass("md-active");
                        },
                        function (selected) {
                            if (selected) element.focus();
                        }
                    );
                },
            };
        });

    /** @ngInject */
    function DocprivController(
        DocPrivMetierService,
        blockUI,
        toastr,
        $translate,
        MainMetierService,$state,$window,CryptoService,CacheService,CacheConstants,$rootScope,configConstantes,DocPrivConstants
    ) {
        var vm = this;
        vm.onReset = onReset;
        vm.onValidate = onValidate;
        vm.divSelected = divSelected;
        vm.getPlate = getPlate;
        vm.getGieData = getGieData;
        vm.setPlateDetails = setPlateDetails;
        vm.updateBrand = updateBrand;
        vm.filterList = filterList;
        var userProfil = CacheService.getUserProfile();
        vm.isIndependentUser = MainMetierService.isIndependantUser(userProfil.roles);
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess   );
        
        vm.isPlatesList = false;
        vm.isPartsList = false;
        vm.requestBody = {};
        vm.masterPlates = {};
        vm.listOfPlate = [];
        vm.deletedPlates = [];
        vm.showFullDocprivResults = [];
        vm.asomFamilyList = [];
        vm.asomBrandList = [];
        vm.formatReferenceInput = formatReferenceInput;

        this.$onInit = function () {
            
            vm.isDocprivProfile = MainMetierService.isDocprivProfile();
            if(vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV){
                var decrypted = CryptoService.AES.decrypt((CacheService.getObject(CacheConstants.applicabilities)), CacheConstants.encryptedValue);
                vm.applicabilities = JSON.parse(decrypted.toString(CryptoService.enc.Utf8)).length > 0 ? JSON.parse(decrypted.toString(CryptoService.enc.Utf8)) : [];

                if ( vm.applicabilities.length > 0) {
                    vm.applicabilityList = [];
                    vm.applicabilities.forEach(function (list) {
                        vm.initialArray = [];
                        if (list.familyCriteria != '') {
                            vm.asomFamilyList.push(list.familyCriteria);
                            vm.initialArray.push(list.familyCriteria);
                        }
                        if (!_.isEmpty(list.brandCriteria)) {
                             if (list.brandCriteria.length > 1) {
                                vm.asomBrandList = vm.asomBrandList.concat(list.brandCriteria);
                                vm.initialArray.push(list.brandCriteria.join(','));
                            } else {
                                vm.asomBrandList.push(list.brandCriteria[0]);
                                vm.initialArray.push(list.brandCriteria[0]);
                            }
                        }
                        if (list.mtcCriteria && !_.isEmpty(list.mtcCriteria)) {
                            list.mtcCriteria.forEach(function (item) {
                                  vm.initialArray.push(item);
                            });
                        }
                        vm.initialArray = vm.initialArray.join('/');
                        vm.applicabilityList = vm.applicabilityList.concat(vm.initialArray)
                    })
                    vm.asomBrandList = _.uniq(vm.asomBrandList);
                    vm.asomFamilyList = _.uniq(vm.asomFamilyList);
                }
            }
            

            if($state.params.isFromProductSheet && DocPrivMetierService.getPlateDetails()){

                var data = DocPrivMetierService.getPlateDetails();
                
                vm.isPlatesList = data.isPlatesList;
                vm.isPartsList = data.isPartsList;
                vm.selectedDocPlate = data.selectedDocPlate;
                vm.listOfPlate = data.listOfPlate;
                vm.deletedPlates = data.deletedPlates;
                vm.showFullDocprivResults = data.showFullDocprivResults;
                vm.masterPlates = data.masterPlates;
                vm.showDeletedPlate =data.showDeletedPlate;
                vm.families = data.families;
                vm.brands = data.brands;
                vm.treeNodes = data.treeNodes;
                vm.gieDetails = data.gieDetails;
                vm.requestBody = data.requestBody;
                vm.partsList = data.partsList;
                if(vm.requestBody && !_.isEmpty(vm.requestBody)){
                    vm.familyName = vm.requestBody.family;
                    vm.partNumber = vm.requestBody.partNumber;
                    vm.genericPart = vm.requestBody.genericPart;
                    vm.brandName = vm.requestBody.brand;
                    vm.treeNodeValue = vm.requestBody.nodeId;
                    vm.gieValue = vm.requestBody.gieNumber;
                    vm.plateNumber = vm.requestBody.plateNumber;
                }

                DocPrivMetierService.setPlateDetails({});

            }else{
                blockUI.start();
                if ( vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV) {
                    DocPrivMetierService.getMtcLinesList(vm.applicabilityList).then(function (res) {
                        if (res && !_.isEmpty(res)) {
                            vm.mtcLineResponse = res;
                            DocPrivMetierService.setMtcLineDetails(res);
                        }
                        familyTreeService();
                    }).catch(function (){
                        blockUI.stop();
                        toastr.error($translate.instant('ERROR')); 
                    })
                }
                else{
                    familyTreeService();
                }
            }
            
        }
         function formatReferenceInput() {

           const formattedVal =  MainMetierService.formatReferenceInput(vm.partNumber);
            vm.partNumber = formattedVal;
        };

        function familyTreeService(){
            DocPrivMetierService.getFamilyBrandList()
            .then(function (response) {
                buildVehFamilyAndType(response);
            })
            .then(function () {
                DocPrivMetierService.getTreeNodeList().then(function (response) {
                    buildTreeNodeList(response);
                });
            })
            .catch(function () {
                toastr.error($translate.instant('ERROR'));
            })
            .finally(function () {
                blockUI.stop();
            });
        }

        function filterList(familyNameSelect) {
            if (familyNameSelect) {
                return function (family) {
                    return ((family.criteriaCode.toLowerCase().indexOf(familyNameSelect.toLowerCase()) != -1) || (family.label.toLowerCase().indexOf(familyNameSelect.toLowerCase()) != -1));
                }
            }
        }
        

        function setPlateDetails(){
            DocPrivMetierService.setPlateDetails({
                requestBody: vm.requestBody,
                isPlatesList: vm.isPlatesList,
                isPartsList: vm.isPartsList,
                selectedDocPlate: vm.selectedDocPlate,
                listOfPlate: vm.listOfPlate,
                deletedPlates: vm.deletedPlates,
                showFullDocprivResults: vm.showFullDocprivResults,
                masterPlates: vm.masterPlates,
                showDeletedPlate: vm.showDeletedPlate,
                families: vm.families,
                brands: vm.brands,
                treeNodes: vm.treeNodes,
                gieDetails: vm.gieDetails,
                partsList: vm.partsList
            })
        }
        function brandFromMtcLines(vehicleBrand){
            vm.mtcLineResponse.carContext.forEach(function (mtcList) {
                Object.keys(mtcList).forEach(function (key) {
                    var keyValue = key.slice(0, 3);
                    if (keyValue == "007") {
                        if (mtcList[key] && !_.isEmpty(mtcList[key]) && !_.isEmpty(mtcList["336"])) {
							mtcList["336"].forEach(function (brand) {
                                vehicleBrand.push(brand);
                            });
                        }
                    }
                })
            })
            return vehicleBrand;
        }
        $rootScope.$on('filterFormat', function (event, data) {
            vm.partNumber =  MainMetierService.formatReferenceInput(data.partNumber);
            
            
        })
        function buildVehFamilyAndType(list) {
            
            var vahicleFamilyType = [];
            var vahicleBrandType = [];

            if(userProfil.userType == "ARCA" && vm.isDocprivProfile.includes(DocPrivConstants.docPrivPopinVinProfile)){
                list.forEach(function (item) {
                    if (item && (!_.has(item, 'typePR') || (_.has(item, 'typePR') && (_.isEmpty(item.typePR) || (!_.isEmpty(item.typePR) && !item.typePR.includes('PDF')))))) {
                        vahicleFamilyType.push(item);
                        item.childFilters.forEach(function (subitem) {
                            vahicleBrandType.push(subitem.criteriaCode);
                            subitem.childFilters.forEach(function (vehicleTypeItem) {
                                vahicleBrandType.push(vehicleTypeItem.criteriaCode);
                            });
                        });
                    }
                });
            } else if((userProfil.userType == "ARCA" && vm.isDocprivProfile.includes(DocPrivConstants.docprivStdProfile))
                 || (userProfil.userType == "RNET" && vm.isDocprivProfile.includes(DocPrivConstants.ppxDocpriv))){
                list.forEach(function (item) {
                    if (item && _.has(item, 'typePR') && !_.isEmpty(item.typePR) && item.typePR.includes('BTR') && !item.typePR.includes('PDF')) {
                        vahicleFamilyType.push(item);
                        item.childFilters.forEach(function (subitem) {
                            vahicleBrandType.push(subitem.criteriaCode);
                            subitem.childFilters.forEach(function (vehicleTypeItem) {
                                vahicleBrandType.push(vehicleTypeItem.criteriaCode);
                            });
                        });
                    }
                });
            } else if (vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV) {
                 vm.familyList = vm.mtcLineResponse && vm.mtcLineResponse.familyList ? vm.mtcLineResponse.familyList : [];
                 if(!_.isEmpty(vm.familyList)){ 
                    list.forEach(function (item) {
                        if(vm.familyList.includes(item.criteriaCode)){
                            vahicleFamilyType.push(item); 
                        }
                    }) 
                    vahicleBrandType = brandFromMtcLines(vahicleBrandType);       
                } 
                
            }
            
            
            vahicleFamilyType = _.sortBy(_.uniqBy(vahicleFamilyType,'criteriaCode'),'criteriaCode');
            vahicleBrandType = _.uniq(vahicleBrandType).sort();
            vm.families = vahicleFamilyType;
            vm.brands = vahicleBrandType;
        }

        function updateBrand(selectedFamily){
            var vehicleBrandType = [];
            if ( vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV) {
                if (selectedFamily && !_.isEmpty(selectedFamily)) {
                    vm.mtcLineResponse.carContext.forEach(function (list) {
                        Object.keys(list).forEach(function (key) {
                            var keyValue = key.slice(0, 3);
                            if (keyValue == "007") {
                                if (list[key] && !_.isEmpty(list[key]) && list[key].includes(selectedFamily) && !_.isEmpty(list["336"])) {
                                    list["336"].forEach(function (brand) {
                                        vehicleBrandType.push(brand);
                                    });
                                }
                            }
                        })
                    })
                } else {
                    vehicleBrandType = brandFromMtcLines(vehicleBrandType);
                }
            }
            else {
                if (selectedFamily && !_.isEmpty(selectedFamily)) {
                    var selectedFamilyData = _.find(vm.families, function (data) {
                        return data && data.criteriaCode === selectedFamily;
                    })
                    if (_.has(selectedFamilyData, 'childFilters') && !_.isEmpty(selectedFamilyData.childFilters)) {
                        selectedFamilyData.childFilters.forEach(function (item) {
                                vehicleBrandType.push(item.criteriaCode);
                        });
                    }
                } else {
                    vm.families.forEach(function (family) {
                        if (_.has(family, 'childFilters') && !_.isEmpty(family.childFilters)) {
                            family.childFilters.forEach(function (item) {
                                vehicleBrandType.push(item.criteriaCode);
                            });
                        }
                    })
                }
            }
 
        vm.brands = _.uniq(vehicleBrandType).sort();
        }

        function newDocAsomPayload() {
            var brandArr = [];
            vm.brandName ? brandArr.push(vm.brandName) : '';
            if (vm.treeNodeValue && vm.treeNodeValue != undefined) {
                var treeNodeVal = vm.treeNodeValue.slice(-7);
            }
            if (vm.gieValue && vm.gieValue != undefined) {
                var gieValue = vm.gieValue.length > 6 ? vm.gieValue.slice(-12) : vm.gieValue.slice(-6);
            }
            var requestBody = {
                family: vm.familyName,
                partNumber: vm.partNumber ? vm.partNumber.toUpperCase() : '',
                genericPart: vm.genericPart ? vm.genericPart.toUpperCase() : '',
                brand: !_.isEmpty(brandArr) ? brandArr : '',
                nodeId: treeNodeVal,
                minimalInfoSIE: true,
                gieNumber: gieValue,
                plateNumber: vm.plateNumber
            }
           
                var setDocprivData = {};
                _.extend(setDocprivData, {
                    'requestBody': requestBody,
                    'listFamilies': vm.families
                })
                DocPrivMetierService.setListFamilies(setDocprivData);
            
            return DocPrivMetierService.getDocPrivPlates(requestBody, vm.masterPlates.next_url)
        }

        
        function getPlate() {
            if (vm.familyName && !_.isEmpty(vm.familyName)) {
                blockUI.start();
                
                    newDocAsomPayload().then(function (response) {
                        var vahiclePlate = [];
                        response.plates.forEach(function (item) {
                            vahiclePlate.push(item.catalogPlateNumber);
                        });
                        vahiclePlate = _.uniq(vahiclePlate).sort();
                        vm.plateNumberList = vahiclePlate;
                    })
                        .catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        })
                        .finally(function () {
                            blockUI.stop();
                        });
                 
            }
        }

        function getGieData() {
            if (vm.familyName && !_.isEmpty(vm.familyName)) {
                blockUI.start();
                
                    newDocAsomPayload().then(function (response) {
                        var gieData = [];
                        var gieNumData = [];
                        if (response && response.plates) {
                            response.plates.forEach(function (item) {
                                var gieLabel = "";
                                if (item && item.gieDescription) {
                                    gieLabel = item.gieDescription + " - " + item.gieNumber;
                                    gieData.push(gieLabel);
                                    gieData.sort();
                                }
                                else {
                                    gieLabel = item.gieNumber;
                                    gieNumData.push(gieLabel);
                                    gieNumData.sort();
                                }
                            });
                        }
                        gieData = gieData.concat(gieNumData);
                        gieData = _.uniq(gieData);
                        vm.gieList = gieData;
                    })
                        .catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        }).finally(function () {
                            blockUI.stop();
                        });
                
            }
        }

        function startsWithNumber(str) {
            return /^\d/.test(str);
        }

        function buildTreeNodeList(list) {
            var treeNodeLevelsList = [];
            var treeNumList = [];
            vm.treeLists = [];
            list.nodes.forEach(function (item) {
                treeNodeLevelsList.push(item);
                item.childNodes.forEach(function (subitem) {
                    treeNodeLevelsList.push(subitem);
                    subitem.childNodes.forEach(function (vehicleTypeItem) {
                        treeNodeLevelsList.push(vehicleTypeItem);
                    });
                });
            });
            treeNodeLevelsList.sort(function (a, b) {
                return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
            });
            treeNodeLevelsList.forEach(function (treeNode) {
                if(treeNode && !(startsWithNumber(treeNode.label))){
                    vm.treeLists.push(treeNode.level + " - " + treeNode.label + " " + treeNode.nodeId);
                }
                else {
                    treeNumList.push(treeNode.level + " - " + treeNode.label + " " + treeNode.nodeId);
                }
             });
            vm.treeLists = vm.treeLists.concat(treeNumList);
            vm.treeLists = _.uniq(vm.treeLists);
            vm.treeNodes = vm.treeLists;
        }

        function divSelected(key) {
            var elemSelected = document.getElementById(key);
            var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;

            var topContainer;

            if (positionOfElem < 200) {
                topContainer = positionOfElem - 5 + 'px';
            } else {
                topContainer = positionOfElem + 18 + 'px';
            }
            setTimeout(function () {
                $('.my-container').css({ top: topContainer });
            }, 50);
        }

        function onReset() {
            vm.genericPart = "";
            vm.partNumber = "";
            vm.plateNumber = "";
            vm.brandName = "";
            vm.familyName = "";
            vm.familyNameSelect = "";
            vm.treeNodeValue = "";
            vm.gieValue = "";
            vm.simplifiedApplicability = "";
            vm.listOfPlate = [];
            vm.selectedDocPlate = "";
            vm.deletedPlates = [];
            vm.showFullDocprivResults = [];
            vm.masterPlates = {};
            vm.showDeletedPlate = false;
            vm.numberOfPlate = 0;
            vm.isPlatesList = false;
            vm.isPartsList = false;

            var vehicleBrandType = [];
            if(vm.isIndependentUser && $rootScope.asomDocList.DOCPRIV){
                vehicleBrandType = brandFromMtcLines(vehicleBrandType);
            }
            vm.brands = _.uniq(vehicleBrandType).sort();
        }


        function onValidate(){
            vm.selectedDocPlate = "";
            vm.listOfPlate = [];
            vm.showFullDocprivResults = [];
            vm.deletedPlates = [];
            vm.masterPlates = {};
            vm.showDeletedPlate = false;
            vm.partsList = [];
            var brandArr = [];
            vm.brandName ? brandArr.push(vm.brandName) : '';

            if(vm.asomBrandList.length > 0 && _.isEmpty(vm.brandName)){
                angular.copy(vm.brands, brandArr);
            }

            if(vm.gieValue && vm.gieValue != undefined){
                var gieValue = vm.gieValue.length > 6 ? vm.gieValue.slice(-12) : vm.gieValue.slice(-6);
            }
            if(vm.treeNodeValue && vm.treeNodeValue != undefined){
                var treeNodeVal = vm.treeNodeValue.slice(-7);
            }
            vm.partNumber = (vm.partNumber || '').toString().replace(/[^a-zA-Z0-9]/g, '');
            vm.requestBody = {
                family: vm.familyName,
                partNumber: vm.partNumber ? vm.partNumber.toUpperCase():'',
                genericPart:vm.genericPart ? vm.genericPart.toUpperCase(): '',
                brand: !_.isEmpty(brandArr) ? brandArr : '',
                nodeId: treeNodeVal,
                gieNumber: gieValue,
                plateNumber: vm.plateNumber
            }
            
                _.extend(vm.requestBody,{
                    'minimalInfoSIE': false
                })
            var setDocprivData = {};
            _.extend(setDocprivData,{
                'requestBody' :vm.requestBody,
                'listFamilies':vm.families
            })
            DocPrivMetierService.setListFamilies(setDocprivData);
        
            vm.isPlatesList = true;
            vm.isPartsList = false;

        }
        
    }
})();

'use strict';

angular.module('phenix').constant('DocPrivConstants', {

    
  restCarSearchFamilyBrandFilter:'/proxy/apidh/rest/v1/carContexts/listFamilies',
  restCarSearchTreeNode:'/proxy/apidh/rest/v1/tree',
  restCarSearchPlateNumber:'/proxy/apidh/rest/v1/plates/byFamily',
  docPrivPlates:'/proxy/apidh/rest/v1/plates',
  docPrivParts:'/proxy/apidh/rest/v1/plates/parts',
  mtcLines:'/proxy/apidh/rest/v1/carContexts/mtcLines',


  centraleBrand: 'Centrale',
  standardExchangeBrand: 'Echange_standard',
  docPrivCommentProfile: 'PPX_DOCPRIV_COMMENT',
  docPrivPopinVinProfile: 'PPX_DOCPRIV_ASE',
  docprivStdProfile:'PPX_DOCPRIV_STD',
  docprivNissan:'PPX_DOCPRIV_NISSAN',
  ppxDocpriv: 'PPX_DOC_PRIV',
  ppxConfidentialPayload: 'PPX_CONFIDENTIAL'

});

(function () {
    angular
    .module('phenix').filter('customApplicabilityFilter', function ($filter) {
        return function(array, expression) {
            return $filter('filter')(array, expression, function(actual, expected) {

                if(_.isObject(actual)){

                    var fixedApplicability = actual.fixedApplicability ? actual.fixedApplicability.split(" ").join("").toLowerCase() : "";
                    var variableApplicability = actual.variableApplicability ? actual.variableApplicability.split(" ").join("").toLowerCase() : "";
                    var codifiedApplicability = actual.codifiedApplicability ? actual.codifiedApplicability.split(" ").join("").toLowerCase() : "";
                    return ('' + fixedApplicability.indexOf('' + expected.split(" ").join("").toLowerCase()) > -1)
                        || ('' + variableApplicability.indexOf('' + expected.split(" ").join("").toLowerCase()) > -1)
                        || ('' + codifiedApplicability.indexOf('' + expected.split(" ").join("").toLowerCase()) > -1);
                }

                return ('' + actual).split(" ").join("").toLowerCase().indexOf(('' + expected).split(" ").join("").toLowerCase()) > -1;
            });

            
        };
    })
})();

(function () {
    'use strict';
  
    angular
      .module('phenix')
      .config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
      $stateProvider
        .state(RoutesConstants.alertsList, {
          url: '/alertsList',
          templateUrl: 'app/components/doc-alerts/listAlerts.template.html',
          controller: 'docAlertsController',
          params: {
            data: null
          },
          controllerAs: 'vm'
        });
    }
  })();
  
(function () {

    angular
        .module('phenix').controller('docAlertsController', docAlertsController)
            .filter('newlinesToBr', function() {
                return function(text) {
                    if (!text){
                        return text;
                    } 
                    return text
                        .replace(/\\n/g, '<br>')      // \n to <br>
                        .replace(/\\r\\n/g, '<br>')  // \r\n to <br>
                        .replace(/\\r/g, '<br>')     // \r to <br>
                        .replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')  // \t to 4 spaces
                        .replace(/\\"/g, '"')        // \" to "
                        .replace(/\\'/g, "'")        // \' to '
                        .replace(/\\\\/g, '\\')      // \\ to \
                        .replace(/\\b/g, '')         // \b (backspace) remove
                        .replace(/\\f/g, '')         // \f (form feed) remove
                        .replace(/\\v/g, '')         // \v (vertical tab) remove
                        .replace(/\n/g, '<br>')      // actual newlines to <br>
                        .replace(/\r\n/g, '<br>')    // actual CRLF to <br>
                        .replace(/\r/g, '<br>')      // actual CR to <br>
                        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'); // actual tabs to 4 spaces
                };
            });
    /** @ngInject */
    function docAlertsController(
        blockUI,
        $q,
        $filter,
        toastr,
        $translate,
        DocAlertsMetierService, DocAlertsConstants, UtilsMetierService, RoutesConstants, $state, configConstantes, AlertsConstants, CacheConstants, CacheService,MainMetierService) {

        var vm = this;
        vm.docAlertsList = [];
        vm.numberOfPagesToDisplay = 0;
        vm.isAlertsEnabled = false;
        vm.docTypes = [
            "HEADER_TM",
            "HEADER_MR",
            "HEADER_MD",
            "WIRING_DIAGRAM_SHORT"];
        vm.reasonsList = [];
        vm.selectedTypes = [];
        vm.searchNumber = '';
        vm.searchVin = '';
        vm.searchRegNumber = '';
        vm.searchModel = '';
        vm.selectedReasons = [];
        vm.searchDocTitle = '';
        vm.searchDate = '';
        vm.searchIpn = '';
        vm.dataPerPage = 20;
        vm.currentPage = 1;
        vm.totalRows = 0;
        vm.filterObj = {};
        vm.callDBForFilter = false;
        var sorting = {
            "number": {
                sortBy: DocAlertsConstants.sort.number,
                order: true // DESC
            },
            "createdDate": {
                sortBy: DocAlertsConstants.sort.date,
                order: true // DESC
            },
            ticketNumber: {
                sortBy: DocAlertsConstants.sort.number,
                order: true
            },
            alertType: {
                sortBy: DocAlertsConstants.sort.alertType,
                order: true
            },
            documentType: {
                sortBy: DocAlertsConstants.sort.documentType,
                order: true
            },
            status: {
                sortBy: DocAlertsConstants.sort.status,
                order: true
            },
            vin: {
                sortBy: DocAlertsConstants.sort.vin,
                order: true
            },
            creationDate: {
                sortBy: DocAlertsConstants.sort.creationDate,
                order: true
            },
            creatorIpn: {
                sortBy: DocAlertsConstants.sort.creatorIpn,
                order: true
            }
        };
        vm.emptyList = false;
        vm.hideAlertsPagination = false;
        vm.showTicketPopup = false;
        vm.selectedTicket = null;
        vm.ticketDetails = null;
        vm.newComment = '';
        vm.isLoadingTicketDetails = false;
        vm.attachedFiles = [];
        vm.combinedAndSortedItems = [];
        vm.sectionStates = {
            ticketDetails: true,
            problemDescription: true,
            solution: true
        };
        vm.profil = CacheService.getObject(CacheConstants.profil);

        //Functions
        vm.resetSearch = resetSearch;
        vm.getPageData = getPageData;
        vm.getAlertsListData = getAlertsListData;
        vm.sortBy = sortBy;
        vm.getSortHeaderClass = getSortHeaderClass;
        vm.getFilterObject = getFilterObject;
        vm.changeFilter = changeFilter;
        vm.changeArrayFilter = changeArrayFilter;
        vm.checkAllFilters = checkAllFilters;
        vm.mapIssueOrigin = mapIssueOrigin;
        vm.translateCustomerEffect = translateCustomerEffect;
        vm.openTicketDetails = openTicketDetails;
        vm.closeTicketPopup = closeTicketPopup;
        vm.closeTicket = closeTicket;
        vm.formatDate = formatDate;
        vm.formatMessageDate = formatMessageDate;
        vm.toggleSection = toggleSection;
        vm.postComment = postComment;
        vm.cancelComment = cancelComment;
        vm.downloadAttachment = downloadAttachment;
        vm.deleteAttachment = deleteAttachment;

        init();

        function init() {
            vm.hideAlertsPagination = false;
            vm.isAlertsEnabled = UtilsMetierService.isRedButtonAuthorized();
            vm.isTraceEnabled = (JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser());
            vm.isTraceEnabledINT = (JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT());
            getAlertsListData(true, vm.filterObj, (vm.isTraceEnabled || vm.isTraceEnabledINT) ? sorting[DocAlertsConstants.sort.creationDate] : sorting[DocAlertsConstants.sort.date], vm.currentPage);
        }
        function checkFilterinDb() {
            if (vm.callDBForFilter) {
                var tempNumber = null;
                var tempArr = [];
                vm.currentPage = 1;
                vm.hideAlertsPagination = false;
                var numberArr = vm.searchNumber.split(/(\d+)/).filter(Boolean);
                numberArr.forEach(function (item) {
                    if (isNaN(parseInt(item))) {
                        _.filter(vm.docTypes, function (obj) {
                            if (obj.includes(item.toUpperCase()))
                                tempArr.push(obj);
                        })
                    } else {
                        tempNumber = parseInt(item)
                    }
                })
                getAlertsListData(false, vm.getFilterObject(tempNumber, tempArr), vm.isTraceEnabled ? sorting[DocAlertsConstants.sort.creationDate] : sorting[DocAlertsConstants.sort.date], vm.currentPage);
            } else {
                $filter('docReason')(vm.docAlertsList, vm.searchNumber, vm.selectedTypes, vm.searchVin, vm.searchRegNumber, vm.searchModel, vm.selectedReasons, vm.searchDocTitle, vm.searchDate, vm.searchIpn)
            }
        }
        function checkAllFilters() {
            if (vm.searchNumber === '' && vm.selectedTypes.length === 0 && vm.searchVin === '' && vm.searchRegNumber === '' && vm.searchModel === '' && vm.selectedReasons.length === 0 && vm.searchDocTitle === '' && vm.searchDate === '' && vm.searchIpn === '') {
                vm.hideAlertsPagination = false;
                sorting[DocAlertsConstants.sort.date] = {
                    sortBy: DocAlertsConstants.sort.date,
                    order: true // DESC
                }
                vm.currentPage = 1;
                vm.getAlertsListData(true, vm.getFilterObject(), sorting[DocAlertsConstants.sort.date], vm.currentPage);
            }
        }
        function getFilterObject(number, tempArr) {
            vm.filterObj = {
                number: number ? number + '' : '',
                documentType: tempArr ? _.uniq(vm.selectedTypes.concat(tempArr)) : vm.selectedTypes,
                vin: vm.searchVin,
                registrationNumber: vm.searchRegNumber,
                model: vm.searchModel,
                requestReason: vm.selectedReasons,
                documentCode: vm.searchDocTitle,
                createdDate: vm.searchDate,
                userCreator: vm.searchIpn
            }
            for (var propName in vm.filterObj) {
                if (vm.filterObj[propName] === '' || vm.filterObj[propName] === undefined || _.isEmpty(vm.filterObj[propName])) {
                    delete vm.filterObj[propName];
                }
            }
            return vm.filterObj;
        }
        function isInteger(totalCases) {
            return (typeof totalCases === 'number') && (totalCases % 1 === 0);
        }
        function resetSearch() {
            vm.selectedTypes = [];
            vm.searchNumber = '';
            vm.searchVin = '';
            vm.searchRegNumber = '';
            vm.searchModel = '';
            vm.selectedReasons = [];
            vm.searchDocTitle = '';
            vm.searchDate = '';
            vm.searchIpn = '';
            vm.currentPage = 1;
            vm.hideAlertsPagination = false;
            vm.callDBForFilter = false;
            vm.ticketNumber = '';
            vm.documentType = '';
            vm.alertType = '';
            vm.status = '';
            vm.vin = '';
            vm.creationDate = '';
            vm.creatorIpn = '';
            var tableCtrl = angular.element(document.getElementById('doc-alerts-list')).controller('stTable');
            if (tableCtrl && vm.isTraceEnabled) {
                var tableState = tableCtrl.tableState();
                tableState.search = {}; 
            }

            getAlertsListData(true, {}, vm.isTraceEnabled ? sorting[DocAlertsConstants.sort.creationDate] : sorting[DocAlertsConstants.sort.date], vm.currentPage);

        }
        function getPageData(page) {
            if (page != vm.currentPage) {
                vm.currentPage = page;
                getAlertsListData(true, vm.getFilterObject(), vm.isTraceEnabled ? sorting[DocAlertsConstants.sort.creationDate] : sorting[DocAlertsConstants.sort.date], vm.currentPage);
            }

        }

        function mapStatus(status) {
            switch (status) {
                case 'NEW':
                    return 'New';
                case 'WAIT_DEALER':
                    return 'Answer available';
                case 'WAIT_SUBSIDIARY':
                    return 'On going';
                case 'READ_BY_SUBSIDIARY':
                    return 'On going';
                case 'REOPEN':
                    return 'Re Opened';
                case 'CLOSED':
                    return 'Closed';
                case 'TRANSFERRED':
                    return 'On going';
                default:
                    return status;
            }
        }

        function mapIssueOrigin(origin) {
            switch (origin) {
                case 'REPAIR_METHOD':
                    return 'MR';
                case 'LABOR_TIME':
                    return 'TM';
                case 'EASY_BASKET':
                    return 'Operation';
                default:
                    return origin;
            }
        }

         function mapAlertType(alertType){
            switch (alertType) {
                case 'MR_TM_ASE':
                    return $translate.instant('NEW_ALERT_DOCUMENT');
                case 'EASY_BASKET':
                    return 'Operation';
                default:
                    return alertType;
            }
        }

        function translateCustomerEffect(customerEffect) {
            if (!customerEffect) {
                return '-';
            }
            if (AlertsConstants.requestReasons.includes(customerEffect)) {
                return $translate.instant(customerEffect);
            }
            
            return customerEffect;
        }

        function getAlertsListData(showLoader, filter, sorting, pageNumber) {
            vm.docAlertsList = [];

            if ((vm.isTraceEnabled || vm.isTraceEnabledINT) && vm.isAlertsEnabled) {
                getCombinedAlertsListData(showLoader, filter, sorting, pageNumber);
            } else if (vm.isTraceEnabled || vm.isTraceEnabledINT) {
                blockUI.start();
                DocAlertsMetierService.getDocumentAlertsNew().then(function (response) {
                    try {
                        if (!_.isEmpty(response) && response.data.length > 0) {
                            vm.emptyList = false;
                            var numberOfCases = response.pages;
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfCases);
                            vm.totalRows = response.data.length;
                            vm.getStatusCircleClass = getStatusCircleClass;
                            vm.docAlertsList = response.data.map(function (alert) {
                                return {
                                    ticketNumber: alert.ticketNumber,
                                    alertType: mapAlertType(alert.formType),
                                    documentType: mapIssueOrigin(alert.issueOrigin),
                                    status: mapStatus(alert.status),
                                    vin: alert.vin,
                                    creationDate: alert.created,
                                    creatorIpn: alert.creatorIpn,
                                    uuid: alert.uuid
                                };
                            });
                            vm.docAlertsList = _.orderBy(vm.docAlertsList, [DocAlertsConstants.sort.creationDate], ['desc']);
                            if (vm.isTraceEnabledINT && !vm.isTraceEnabled) {
                                vm.docAlertsList = vm.docAlertsList.filter(function (alert) {
                                    return alert.documentType === 'Operation';
                                });
                            }   
                        } else {
                            vm.docAlertsList = [];
                            vm.emptyList = true;
                            vm.numberOfPagesToDisplay = 0;
                            vm.callDBForFilter = false;
                        }
                    } catch (error) {
                        toastr.error($translate.instant("NO_DATA_FOUND"));
                        vm.docAlertsList = [];
                        vm.emptyList = true;
                        vm.numberOfPagesToDisplay = 0;
                    }
                }).catch(function (error) {
                    toastr.error($translate.instant("NO_DATA_FOUND"));
                    vm.docAlertsList = [];
                    vm.emptyList = true;
                    vm.numberOfPagesToDisplay = 0;
                }).finally(function () {
                    blockUI.stop();
                });
            } else if (vm.isAlertsEnabled) {
                if (showLoader)
                    blockUI.start();
                    DocAlertsMetierService.getDocumentAlerts(filter, sorting, pageNumber).then(function (response) {
                    if (!_.isEmpty(response) && response.alertDocumentaryList.length > 0) {
                        vm.emptyList = false;
                        if (response.totalCount > 20)
                            vm.callDBForFilter = false;
                        var numberOfCases = response.totalCount / vm.dataPerPage;
                        var isNumber = isInteger(numberOfCases);
                        if (isNumber) {
                            vm.numberOfPagesToDisplay = numberOfCases;
                        } else {
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfCases);
                        }
                        vm.totalRows = response.totalCount;
                        response.alertDocumentaryList.forEach(function (alert) {
                            alert.number = alert.documentType + "" + alert.number;
                            vm.reasonsList.push(alert.requestReason);
                        });
                        vm.reasonsList = _.uniq(vm.reasonsList);
                        vm.docAlertsList = response.alertDocumentaryList;
                    } else {
                        vm.docAlertsList = [];
                        vm.emptyList = true;
                        vm.numberOfPagesToDisplay = 0;
                        vm.callDBForFilter = false;
                    }
                }).catch(function (error) {
                    toastr.error($translate.instant("NO_DATA_FOUND"));
                    vm.docAlertsList = [];
                    vm.emptyList = true;
                    vm.numberOfPagesToDisplay = 0;
                }).finally(function () {
                    if (showLoader)
                        blockUI.stop();
                });
            } else {
                $state.go(RoutesConstants.carSearch);
            }
        }

        function getCombinedAlertsListData(showLoader, filter, sorting, pageNumber) {
            if (showLoader) {
                blockUI.start();
            }

            vm.getStatusCircleClass = getStatusCircleClass;
            vm.hideAlertsPagination = true;

            var tracePromise = DocAlertsMetierService.getDocumentAlertsNew().catch(function () {
                return null;
            });

            $q.all([tracePromise]).then(function (responses) {
                var traceResponse = responses[0];

                var traceAlerts = mapTraceAlerts(traceResponse);

                vm.docAlertsList = mergeAlertsByKey(traceAlerts, []);
                vm.totalRows = vm.docAlertsList.length;
                vm.numberOfPagesToDisplay = Math.ceil(vm.totalRows / vm.dataPerPage);
                vm.emptyList = vm.docAlertsList.length === 0;

                if (vm.emptyList) {
                    vm.numberOfPagesToDisplay = 0;
                    vm.callDBForFilter = false;
                } else {
                    vm.docAlertsList = _.orderBy(vm.docAlertsList, [DocAlertsConstants.sort.creationDate], ['desc']);  
                }

                if (!traceResponse) {
                    toastr.error($translate.instant("NO_DATA_FOUND"));
                }
            }).finally(function () {
                if (showLoader) {
                    blockUI.stop();
                }
            });
        }

        function mapTraceAlerts(response) {
            if (_.isEmpty(response) || !response.data || response.data.length === 0) {
                return [];
            }

            var traceAlerts = response.data.map(function (alert) {
                return {
                    ticketNumber: alert.ticketNumber,
                    alertType: mapAlertType(alert.formType),
                    documentType: mapIssueOrigin(alert.issueOrigin),
                    status: mapStatus(alert.status),
                    vin: alert.vin,
                    creationDate: alert.created,
                    creatorIpn: alert.creatorIpn,
                    uuid: alert.uuid,
                    source: 'trace'
                };
            });

            if (UtilsMetierService.isTraceKnownUserINT() && !UtilsMetierService.isTraceKnownUser()) {
                traceAlerts = traceAlerts.filter(function (alert) {
                    return alert.documentType === 'Operation';
                });
            }

            return traceAlerts;
        }

        function mergeAlertsByKey(traceAlerts, legacyAlerts) {
            var mergedByKey = {};

            traceAlerts.forEach(function (alert) {
                var key = alert.uuid || ('trace-' + alert.ticketNumber + '-' + alert.creationDate);
                mergedByKey[key] = alert;
            });

            legacyAlerts.forEach(function (alert) {
                var key = alert.uuid || ('legacy-' + alert.ticketNumber + '-' + alert.creationDate);
                if (!mergedByKey[key]) {
                    mergedByKey[key] = alert;
                }
            });

            return _.values(mergedByKey);
        }

        function getStatusCircleClass(status) {
            switch (status) {
                case 'New':
                    return 'status-circle-green';
                case 'Closed':
                    return 'status-circle-gray';
                case 'Re Opened':
                    return 'status-circle-blue';
                case 'On going':
                    return 'status-circle-blue';
                case 'Answer available':
                    return 'status-circle-red';
                default:
                    return 'status-circle-default';
            }
        }
        function sortBy(columnName) {
            sorting[columnName].order = !sorting[columnName].order;
            if (vm.totalRows > 20 && !vm.isTraceEnabled) {
                vm.currentPage = 1;
                vm.hideAlertsPagination = false;
                getAlertsListData(true, vm.getFilterObject(), sorting[columnName], vm.currentPage);
            }
            else{
                vm.docAlertsList = $filter('orderBy')(vm.docAlertsList, sorting.sortBy, !sorting.order);
            }
        }

        function getSortHeaderClass(columnName) {
            if (sorting.sortBy != columnName) {
                return "icon-icons_filter_order";
            }
            if (!sorting.order) {
                return "icon-icons_filter_order_down";
            }
            return "icon-icons_filter_order_up";
        }
        function changeFilter(value) {
            if (value === '')
                vm.checkAllFilters();
            if (vm.callDBForFilter) {
                var result = $filter('docReason')(vm.docAlertsList, vm.searchNumber, vm.selectedTypes, vm.searchVin, vm.searchRegNumber, vm.searchModel, vm.selectedReasons, vm.searchDocTitle, vm.searchDate, vm.searchIpn).length;
                if (result == vm.docAlertsList.length)
                    checkFilterinDb();
            } else {
                vm.callDBForFilter = true;
                checkFilterinDb();
            }

        }
        function changeArrayFilter(value) {
            if (value.length === 0)
                vm.checkAllFilters();
            if (vm.callDBForFilter) {
                var result = $filter('docReason')(vm.docAlertsList, vm.searchNumber, vm.selectedTypes, vm.searchVin, vm.searchRegNumber, vm.searchModel, vm.selectedReasons, vm.searchDocTitle, vm.searchDate, vm.searchIpn).length;
                if (result == vm.docAlertsList.length)
                    checkFilterinDb();
            } else {
                vm.callDBForFilter = true;
                checkFilterinDb();
            }
        }

        function openTicketDetails(ticket) {
            if (!ticket || !ticket.uuid) {
                return;
            }

            vm.selectedTicket = ticket;
            vm.showTicketPopup = true;
            vm.isLoadingTicketDetails = true;
            vm.ticketDetails = null;
            vm.combinedAndSortedItems = [];
            vm.fileError = false;
            vm.fileTypeError = false;

            DocAlertsMetierService.getDocTicketDetails(ticket.uuid).then(function (response) {
                response.ticket.status = mapStatus(response.ticket.status);
                vm.ticketDetails = response;
                vm.ticketDetails.problemDescription.partAssociatedNumber = (vm.ticketDetails && vm.ticketDetails.problemDescription && vm.ticketDetails.problemDescription.partAssociatedNumber) ? MainMetierService.formatReferenceInput(vm.ticketDetails.problemDescription.partAssociatedNumber) : '-';

                vm.combinedAndSortedItems = buildCombinedAndSortedItems();
                vm.isLoadingTicketDetails = false;
            }).catch(function (error) {
                vm.isLoadingTicketDetails = false;
                vm.combinedAndSortedItems = buildCombinedAndSortedItems();
                toastr.error($translate.instant('DOC_ALERT_ERROR'));
                vm.showTicketPopup = false;
            });
        }

        function closeTicketPopup() {
            vm.showTicketPopup = false;
            vm.selectedTicket = null;
            vm.ticketDetails = null;
            vm.newComment = '';
        }

        function closeTicket() {
            vm.closeTicketPopup();
        }

        function formatDate(dateString) {
            if (!dateString) return '';
            var date = new Date(dateString);
            var day = ('0' + date.getDate()).slice(-2);
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var year = date.getFullYear();
            return day + '/' + month + '/' + year;
        }

        function formatMessageDate(dateString) {
            if (!dateString) return '';
            var date = new Date(dateString);
            var day = ('0' + date.getDate()).slice(-2);
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var year = date.getFullYear();
            var hours = ('0' + date.getHours()).slice(-2);
            var minutes = ('0' + date.getMinutes()).slice(-2);
            return day + '/' + month + '/' + year + ' - ' + hours + 'h' + minutes;
        }

        function buildCombinedAndSortedItems() {
            const combined = [];

            if (vm.ticketDetails) {
                if (vm.ticketDetails.messages && vm.ticketDetails.messages.length > 0) {
                    vm.ticketDetails.messages.forEach(function (message) {
                        combined.push({
                            uuid: message.uuid,
                            created: message.created,
                            creatorName: message.creatorName,
                            text: message.text,
                            type: 'message'
                        });
                    });
                }

                if (vm.ticketDetails.attachments && vm.ticketDetails.attachments.length > 0) {
                    vm.ticketDetails.attachments.forEach(function (attachment) {
                        combined.push({
                            uuid: attachment.uuid,
                            created: attachment.created,
                            creatorName: attachment.creatorName,
                            name: attachment.fileName,
                            data: attachment.data,
                            type: 'attachment'
                        });
                    });
                }
            }
            combined.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });

            return combined;
        }

        function toggleSection(sectionName) {
            vm.sectionStates[sectionName] = !vm.sectionStates[sectionName];
        }

        function postComment() {

            blockUI.start();
            const formattedAttachments = vm.attachedFiles.map(function(attachedFiles) {
                const file = attachedFiles.file;
                return {
                    fileName: file.fileName,
                    fileType: file.fileType,
                    size: file.size,
                    data: file.data ? cleanData(file.data.base64) : ''
                };
            });

            const payload = {
                ticketUuid: vm.selectedTicket.uuid,
                status: "WAIT_SUBSIDIARY",
                creator: {
                    ipn: vm.profil.ipn,
                    phoneNumber: vm.ticketDetails.ticket.telNo,
                    dealerName: vm.ticketDetails.ticket.dealerName,
                    dealerNumber: vm.ticketDetails.ticket.dealerNumber,
                    email: vm.ticketDetails.ticket.email,
                    country: vm.ticketDetails.ticket.group,
                    userName: `${vm.profil.firstName} ${vm.profil.lastName}`
                },
                message: vm.newComment,
                attachments: formattedAttachments
            }

            DocAlertsMetierService.updateDocTicket(payload).then(function (_response) {
                toastr.success($translate.instant("COMMENT_POSTED_SUCCESSFULLY"));
                cancelComment();
                vm.showTicketPopup = false;
                resetSearch();
            }).catch(function (error) {
                toastr.error(error.data.errors[0].errorMessage);
            }).finally(function () {
                blockUI.stop();
            });
        }

        function cleanData(data){
            return data.split(',').pop();
        }

        function deleteAttachment(index) {
            vm.attachedFiles.splice(index, 1);
        }

        function cancelComment() {
            vm.newComment = '';
            vm.attachedFiles = [];
            vm.fileTypeError = false;
            vm.fileError = false;
        }

        function downloadAttachment(item, event) {
            event.preventDefault();
            
            if (!item.name) {
                toastr.error($translate.instant("ERROR"));
                return;
            }
            
            // If the item has base64 data, download directly
            if (item.data) {
                try {
                    // Clean the base64 data (remove data URL prefix if present)
                    let base64Data = item.data;
                    if (base64Data.includes(',')) {
                        base64Data = base64Data.split(',')[1];
                    }
                    
                    // Convert base64 to blob
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = Array.from(byteCharacters, function(char) {
                        return char.charCodeAt(0);
                    });
                    const byteArray = new Uint8Array(byteNumbers);
                    
                    // Determine MIME type based on file extension
                    const mimeType = getMimeType(item.name);
                    const blob = new Blob([byteArray], { type: mimeType });
                    
                    // Create download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = item.name;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                } catch (error) {
                    toastr.error($translate.instant("ERROR"));
                }
            }
            else {
                toastr.error($translate.instant("ERROR"));
            }
        }

        // Helper function to determine MIME type
        function getMimeType(filename) {
            const extension = filename.split('.').pop().toLowerCase();
            const mimeTypes = {
                'pdf': 'application/pdf',
                'doc': 'application/msword',
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'xls': 'application/vnd.ms-excel',
                'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'png': 'image/png',
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'gif': 'image/gif',
                'txt': 'text/plain',
                'zip': 'application/zip'
            };
            return mimeTypes[extension] || 'application/octet-stream';
        }
    }
}
)();
(function () {
    angular
        .module('phenix').filter('docReason', function ($filter, $rootScope) {
            return function (array, number, docType, vin, regNumber, model, reason, docTitle, createdDate, ipn) {
                if (number == '' && docType.length == 0 && vin == '' && regNumber == '' && model == '' && docTitle == '' && reason.length == 0 && createdDate == '' && ipn == '') {
                    return array;
                }
                var filters = {
                    number: number,
                    documentType: docType,
                    vin: vin,
                    registrationNumber: regNumber,
                    model: model,
                    requestReason: reason,
                    documentCode: docTitle,
                    createdDate: createdDate,
                    userCreator: ipn
                }
                //To clear null objects in filters
                for (var propName in filters) {
                    if (filters[propName] === '' || filters[propName] === undefined || filters[propName] === []) {
                        delete filters[propName];
                    }
                }
                var setFilter = [];
                setFilter = array.filter(function (item) {
                    var selRecord = false;
                    for (var key in filters) {
                        if (filters.hasOwnProperty(key)) {
                            if (filters[key] != '' && filters[key] != []) {
                                if(key == 'documentType' || key =='requestReason')
                                    selRecord = filters[key].includes(item[key]) 
                                else
                                    selRecord = item[key].toLowerCase().includes(filters[key].toLowerCase())
                                if (!selRecord)
                                    break;

                            }
                        }
                    }
                    return selRecord;
                });
                return setFilter;
            }
        });
}
)();
'use strict';

angular.module('phenix').constant('DocAlertsConstants', {

    sort: {
        date: 'createdDate',
        number: 'number',
        status: 'status',
        documentType: 'documentType',
        alertType: 'alertType',
        creatorIpn: 'creatorIpn',
        vin: 'vin',
        creationDate: 'creationDate'
    },
    pagination: {
        limit: 20
    },
    docListNew : 'proxy/apigee/dog/engineering-tickets/v1/tickets',
    docTicketDetails: 'proxy/apigee/dog/engineering-tickets/v1/ticket-details?uuid=',
    updateDocTicket: 'proxy/apigee/dog/engineering-tickets/v1/ticket-updates',
    docList : '/documentaryError/list'

});

'use strict';

angular.module('phenix').constant('DmsErrorConstants', {

    quotationErrors : [
        {
            returnCode: 1, 
            message : "DMS_ESTIMATE_1"
        },
        {
            returnCode: 2, 
            message : "DMS_ESTIMATE_2"
        },
        {
            returnCode: 3, 
            message : "DMS_ESTIMATE_3"
        },
        {
            returnCode: 4, 
            message : "DMS_ESTIMATE_4"
        },{
            returnCode: 5, 
            message : "DMS_ESTIMATE_5"
        },
        {
            returnCode: 8, 
            message : "DMS_ESTIMATE_8"
        },
        {
            returnCode: 9, 
            message : "DMS_ESTIMATE_9"
        }
    ],

    prErrors :[
        {
            returnCode: 1, 
            message : "DMS_ESTIMATE_1"
        },
        {
            returnCode: 2, 
            message :  "DMS_ESTIMATE_2"
        },
        {
            returnCode: 3, 
            message : "DMS_PARTS_3"
        },
        {
            returnCode: 4, 
            message : "DMS_PARTS_4"
        },{
            returnCode: 5, 
            message : "DMS_PARTS_5"
        },
        {
            returnCode: 6, 
            message : "DMS_PARTS_6"
        }
    ]


});
(function(){
    angular.module('phenix').config(dmsRoutes);

    function dmsRoutes(
        $stateProvider,

        RoutesConstants){
            $stateProvider.state(RoutesConstants.dmsQuote, {
                url: '/dms/quote',
                templateUrl: 'app/components/dms/quote/draft/quote.template.html',
                controller: 'DMSQuoteController',
                params: {
                    data: null,
                    quoteListOptions: null
                },
                controllerAs: 'vm',
                onlyDMS: true
            });
        }
})();

'use strict';

angular.module('phenix').constant('DmsConstants', {
    customersDmsUrl: "customers.v1",
    referencesDmsUrl: "references.v1",
    accountDmsUrl: "account.v1",
    partsDmsUrl: "parts.v1",
    orderDmsUrl: "order.v1",
    vehicleDmsUrl: "vehicle.v1",
    hourlyRatesUrl: 'hourlyrates.v1',
    estimateDmsUrl: 'estimate.v1',
    quotePartsUrl: 'quoteparts.v1',
    baseDmsApigee: 'proxy/webdms/drv/local-dms-',
    baseDealers:'/v1/dealers/',
    pingRdcsUrl: 'proxy/webdms/drv/local-dms-ping/v1/dealers/',
    apigeeQaUrl: 'apis-qa.tls.renault.com',
    apigeeUrl: 'apis.tls.renault.com',
    apigeeQaOktaUrl: 'apis-qa.renault.com',
    apigeeOktaUrl: 'apis.renault.com',
    maximumNumberOfreturnUsersDms:10,
    workshopProfile: 'DMS_WORKSHOP',
    partshopProfile: 'DMS_PARTSHOP',
    dms:"DMS",
    dms_Ots: "DMS_OTS",
    rdcsUrl: {
        ping: '/ping',
        account: 'account',
        vehicle: 'vehicle',
        vehicles: 'vehicles',
        reference: 'references',
        customers: 'customers',
        order: 'order',
        orders: 'orders',
        parts: 'parts',
        estimates: 'estimates',
        hourlyrates: 'hourlyrates',
        hourly_rates: 'hourly-rates',
        quoteParts: 'quoteparts'
    }, 
    errors: {
        EMPTY_RESPONSE: 54,
        NO_CUSTOMERS: 55,
        ESTIMATE_FAIL: 56,
        ABORT: "abort",
        ERROR: "error"
    },
    localPiece:{
        min: 7701383000,
        max: 7701383999
    }
});


(function () {

    angular
        .module('phenix')
        .directive('onSelectColor', onSelectColor)

    /**
     * @desc Purpose is to  custom color select filter for custom select dropdown
     */
    /** @ngInject */
    function onSelectColor($timeout) {
        return {
            restrict: 'EA',
            require: '^stTable',
            scope: { 
                options: '=' 
            },
            link: function (scope, element, attrs, ctrl) {
                angular.extend(scope.options, {
                    colorFilter: function (selectedColor) {
                        return scope.$apply(function () {
                            var tableState;
                            tableState = ctrl.tableState();
                            if (tableState.search && tableState.search.predicateObject) {
                                _.extend(tableState.search.predicateObject, {
                                    colorCode: selectedColor
                                })
                            }
                            else {
                                tableState.search.predicateObject = { colorCode: selectedColor }
                            }
                            return ctrl.pipe();
                        });
                    },

                    resetTableState: function () {
                        $timeout(function () {
                            return scope.$apply(function () {
                                var tableState;
                                tableState = ctrl.tableState();
                                tableState.search.predicateObject = {};
                                tableState.sort.predicate = scope.defaultSortColumn ? scope.defaultSortColumn.predicate : {};
                                tableState.sort.reverse = scope.defaultSortColumn ? scope.defaultSortColumn.reverse : {};
                                tableState.pagination.start = 0;
                                return ctrl.pipe();
                            });
                        }, 0);
                    }
                });
            }
        }
    }
})();
(function () {
    angular.module('phenix').service('btListWSService', function (btViewListConstants,RestUpgrade) {

     

        /************************
         *      FUNCTIONS       *
         ***********************/

        this.getBtList=getBtList;
        this.fixedFiltered2=fixedFiltered2
        this.getAdvancedBtList=getAdvancedBtList;
        
        
    
        
        
        function fixedFiltered2(payload) 
        {
          return RestUpgrade.all(btViewListConstants.endpoint.fixedFiltered2).post(payload);
        }

        /* get BT LIST DATA   */

        
         function getBtList( url, payload) {
            var btlist = [];
            return getBtListAdvance(btlist, url, payload, {});
        }
        function getAdvancedBtList(url,payload) {
           var btlist = [];
            return getBtListAdvance(btlist, url, payload, {});
        }

        function getBtListAdvance(btlist, url, payload, requestedUrls) {
            if (requestedUrls[url]) {
                return Promise.resolve(btlist);
            }
            requestedUrls[url] = true;

            return RestUpgrade.all(url).post(payload).then(function (res) {
                btlist = btlist.concat((res && res.BT) || []);
                if (res && res.next_url) {
                    var nextUrl = "/proxy/apidh/rest/v1" + res.next_url;
                    return getBtListAdvance(btlist, nextUrl, payload, requestedUrls);
                } else {
                    return btlist;
                }
            })
        }
    
    
    
    });
})();

angular.module('phenix')

    // This directive was created for pagination.
    // It triggers the selected page based on Next or Previous buttons and the dropdown menu.
    .directive('btpageSelect', function() {
      return {
        restrict: 'E',
        template: '<select class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)" ng-options="page for page in pages" >',
        link: function(scope, element, attrs) {
          scope.$watch('currentPage', function(c) {
            scope.inputPage = c;
          });
        }
      }
    });


(function () {
    
    angular
        .module('phenix')
        .controller('btListAdvancedController', btListAdvancedController)
        .filter('customStrictFilter', function ($filter) {
            return function (input, predicate) {
                if (!input || !Array.isArray(input)) {
                    return input;
                }

                if (predicate && predicate.colorCode && predicate.colorCode === "BLUE") {
                    var filteredArray = [];
                    angular.forEach(input, function (value, index, array) {
                        if (value.colorCode === "BLUE") {
                            filteredArray.push(array[index]);
                        }
                    });
                    return $filter('filter')(filteredArray, predicate);
                }

                var searchTerm = null;
                if (predicate && predicate.tripleFilter !== undefined && predicate.tripleFilter !== null) {
                    searchTerm = String(predicate.tripleFilter).trim();
                } else if (predicate && predicate.$ !== undefined && predicate.$ !== null) {
                    searchTerm = String(predicate.$).trim();
                }

                if (searchTerm !== null && searchTerm !== '') {
                    var normalizedSearch = searchTerm.toLowerCase();
                    return input.filter(function (value) {
                        var combinedSearchValue = [
                            value && value.tripleFilter,
                            value && value.designation,
                            value && value.solution,
                            value && value.informations,
                            value && value.dtcSearchString,
                            value && value.symptomSearchString,
                            value && value.lupSearchString
                        ].filter(function (entry) {
                            return entry !== undefined && entry !== null && entry !== '';
                        }).join(' ');

                        return String(combinedSearchValue).toLowerCase().indexOf(normalizedSearch) !== -1;
                    });
                }

                return $filter('filter')(input, predicate);
            }
        })
        .directive('focusToInput', function () {
            return {
                restrict: 'A',
                require: ['^mdSelect'],
                link: function (scope, element) {
                    var currentElement = element
                    scope.$watch(function () {
                        while (!currentElement.hasClass('md-select-menu-container')) {
                            currentElement = currentElement.parent();
                        }
                        return currentElement.hasClass('md-active');
                    }, function (selected) {
                        if (selected)
                            element.focus();
                    })
                }
            }
        });

    /** @ngInject */
    function btListAdvancedController(
        $scope,
        blockUI,

        toastr,
        $translate,
        $state,
        $mdDialog,
        CacheService,
        $filter,
        $timeout,
        $rootScope,


        btListMetierService,
        RoutesConstants,
        DocumentsMetierService,
        CarSearchWsService,
        ResultSearchByDiagnosticMetierService,
        CarSearchMetierService,
        BtListControllerService
    ) {

        var vm = this;
        vm.pageSize = 30;
        vm.showGlobalSearch = true;
        vm.tooltipVisible = false;
        vm.globalSearch = {
            "fromDate":null,
            "toDate":null,
            vehicle_family : "",
            vehicle_type : "",
            engine_family  : "",
            engine_type : "",
            engine_index : "",
            gearbox_family : "",
            gearbox_type : "",
            gearbox_index  : "",
            battery_family : "",
            battery_type : "",
            battery_index : "",
            engine2_family : "",
            engine2_type : "",
            engine2_index : ""
        }
        vm.customSearch = '';
        vm.disabled = true;
        vm.rules = {};
        BtListControllerService.defineRules(vm);

        vm.enableSearchButton = enableSearchButton;
        vm.getSmptomcodes = getSmptomcodes;
        vm.getDtcCodes = getDtcCodes;
        vm.getLupNumbers = getLupNumbers;
        vm.btSearch = btSearch;
        vm.btSearchAdvanced = btSearchAdvanced;
        vm.onSelectColor = onSelectColor;
        vm.formatDate = formatDate;
        vm.getApplicabilityFix = getApplicabilityFix;
        vm.getVariableResidual = getVariableResidual;
        vm.searchBTByNumber = searchBTByNumber;
        vm.goToDiagnosticSearch = goToDiagnosticSearch;
        vm.reset = reset;
        vm.rePopulateCriterias = rePopulateCriterias;
        vm.pageSizeChange = pageSizeChange;
        vm.mapFieldsToSearch = mapFieldsToSearch;
        vm.resetSelectedFields = resetSelectedFields;
        vm.divSelected = divSelected;
        vm.selectState = selectState;
        vm.applyGlobalSearch = applyGlobalSearch;
        vm.searchGlobal = searchGlobal;
        vm.rCst = RoutesConstants;

        init();
        vm.btListFound = true;
        vm.colorCodes = [];
        vm.showStates = [];
        vm.displayedResults = [];
        vm.displayCopy = [];
        vm.displayedSort = [];
        vm.stSelectOptions = {};
        
        vm.count = 0;
        vm.btListFixedCriterias = ResultSearchByDiagnosticMetierService.getBtListFixedCriterias();
        vm.btListFixedCriteriasParams = $state.params.data;
        // if (vm.btListFixedCriteriasParams) {
        //     rePopulateCriterias(vm.btListFixedCriteriasParams);
        // }

        //repopulate the criterias from carcontext
        function rePopulateCriterias(btListFixedCriterias) {
            if (btListFixedCriterias["007"]) {
                vm.globalSearch.vehicle_family = btListFixedCriterias["007"];
                vm.count = vm.globalSearch.vehicle_family.length;
                enableSearchButton();
            }
            // if (btListFixedCriterias["008"]) {
            //     vm.MODEL = btListFixedCriterias["008"];
            // }
            // if (btListFixedCriterias["999"]) {
            //     vm.ENGINE = btListFixedCriterias["999"];
            // }
            // if (btListFixedCriterias["998"]) {
            //     vm.EINDEX = btListFixedCriterias["998"];
            // }
            // if (btListFixedCriterias["997"]) {
            //     vm.GEARBOX = btListFixedCriterias["997"];
            // }
            // if (btListFixedCriterias["996"]) {
            //     vm.GINDEX = btListFixedCriterias["996"];
            // }
            // if (btListFixedCriterias["968"]) {
            //     vm.BATTERY = btListFixedCriterias["968"];
            // }
            // if (btListFixedCriterias["966"]) {
            //     vm.BINDEX = btListFixedCriterias["966"];
            // }
        }

        function init() {

            var firstRowFields = [
                {
                    key: 'vehicle_family',
                    code: '007',
                    defaultOption: 'VEHICLE_FAMILY',
                    required: true,
                },
                {
                    key: 'engine_family',
                    code: '007E',
                    defaultOption: 'ENGINE_FAMILY',
                    required: true,
                },
                {
                    key: 'gearbox_family',
                    code: '007G',
                    defaultOption: 'GEARBOX_FAMILY',
                    required: true,
                },
                {
                    key: 'battery_family',
                    code: '007B',
                    defaultOption: 'BATTERY_FAMILY',
                    required: true,
                },
                {
                    key: 'engine2_family',
                    code: '007E2',
                    defaultOption: 'ENGINE2_FAMILY',
                    required: true,
                },
                {
                    key: 'vehicle_type',
                    code: '008',
                    defaultOption: 'VEHICLE_TYPE',
                    required: true,
                },
                {
                    key: 'engine_type',
                    code: '999',
                    defaultOption: 'ENGINE_TYPE',
                    required: true,
                },
                {
                    key: 'gearbox_type',
                    code: '997',
                    defaultOption: 'GEARBOX_TYPE',
                    required: true,
                },
                {
                    key: 'battery_type',
                    code: '968',
                    defaultOption: 'BATTERY_TYPE',
                    required: true,
                },
                {
                    key: 'engine2_type',
                    code: '948',
                    defaultOption: 'ENGINE2_TYPE',
                    required: true,
                },
                {
                    key: 'vehicle_index',
                    code: '008',
                    defaultOption: 'VEHICLE_INDEX',
                    required: true,
                    class: "removeSelect"
                },
                {
                    key: 'engine_index',
                    code: '998',
                    defaultOption: 'ENGINE_INDEX',
                    required: true,
                },
                {
                    key: 'gearbox_index',
                    code: '996',
                    defaultOption: 'GEARBOX_INDEX',
                    required: true,
                },
                {
                    key: 'battery_index',
                    code: '966',
                    defaultOption: 'BATTERY_INDEX',
                    required: true,
                },
                {
                    key: 'engine2_index',
                    code: '946',
                    defaultOption: 'ENGINE_INDEX',
                    required: true,
                }
            ];

            vm.selectFields = firstRowFields;
            var isFromDiagnosticScreen = $state.params.isFromDiagnosticScreen;
            blockUI.start();
            CarSearchMetierService.getTapvmbFilterList().then(function (response) {
                vm.selectFields = btListMetierService.buildFields2(firstRowFields, response);
                if(isFromDiagnosticScreen) {
                    var carcontext = CacheService.getCarContext();
                    vm.selectFields.forEach( function(item){
                       
                        if(item.key === 'vehicle_family') {
                            item.value = carcontext.fixedCriterias['007'] || '';
                            vm.globalSearch['vehicle_family'] = item.value
                        }
                        if(item.key === 'vehicle_type') {
                            item.value = carcontext.fixedCriterias['008'] || '';
                            vm.globalSearch['vehicle_type'] = item.value
                        }
                        if(item.key === 'engine_family') {
                            item.value = carcontext.extraFamilies['007E'] || '';
                            vm.globalSearch['engine_family'] = item.value
                        }
                        if(item.key === 'engine_type') {
                            item.value = carcontext.fixedCriterias['999'] || '';
                            vm.globalSearch['engine_type'] = item.value
                        }
                        if(item.key === 'gearbox_family') {
                            item.value = carcontext.extraFamilies['007G'] || '';
                            vm.globalSearch['gearbox_family'] = item.value
                        }
                        if(item.key === 'gearbox_type') {
                            item.value = carcontext.fixedCriterias['997'] || '';
                            vm.globalSearch['gearbox_type'] = item.value
                        }
                        if(item.key === 'battery_family') {
                            item.value = carcontext.extraFamilies['007B'] || '';
                            vm.globalSearch['battery_family'] = item.value
                        }
                        if(item.key === 'battery_type') {
                            item.value = carcontext.fixedCriterias['968'] || '';
                            vm.globalSearch['battery_type'] = item.value
                        } 
                    })
                }
            }).then(function(){
                CarSearchMetierService.getBrandModelList().then(function(response){
                    vm.selectFields = btListMetierService.buildVehFamilyAndType(response,vm.selectFields);
                });
            }).catch(function () {
                toastr.error($translate.instant('ERROR'));
            }).finally(function () {
                blockUI.stop();
            });
            var todaysDate = new Date();
            var toDate = moment(todaysDate).format("YYYYMMDD");
            var fromDate = moment(todaysDate).subtract(15, 'd').format("YYYYMMDD");
            var initialDateRange = {
                fromDate: fromDate,
                toDate: toDate
            }
            if(!isFromDiagnosticScreen) {
                btSearchAdvanced(initialDateRange);
            }
        }

        
        
        function divSelected(key) {
            var elemSelected = document.getElementById(key);
            var positionOfElem = elemSelected ? elemSelected.getBoundingClientRect().top : 0;
            var topContainer;

            if (positionOfElem < 200) {
                topContainer = positionOfElem + 25 + "px";
            } else {
                topContainer = positionOfElem + 28 + "px";
            }
            setTimeout(function () {
                $(".my-container").css({ 'top': topContainer });
            }, 100);
        };

        function mapFieldsToSearch(key, value) {
            vm.globalSearch[key] = value;
        }

        function resetSelectedFields(key, value) {
            vm.globalSearch[key] = "";
            vm.selectFields.map(function (item) {
                if (item.key === key) {
                    item.value = "";
                }
                if (key === 'engine_type' && item.key === 'engine_index') {
                    item.value = "";
                    vm.globalSearch[item.key] = "";
                }
                if (key === 'gearbox_type' && item.key === 'gearbox_index') {
                    item.value = "";
                    vm.globalSearch[item.key] = "";
                }
                if (key === 'battery_type' && item.key === 'battery_index') {
                    item.value = "";
                    vm.globalSearch[item.key] = "";
                }
                if (key === 'engine2_type' && item.key === 'engine2_index') {
                    item.value = "";
                    vm.globalSearch[item.key] = "";
                }
            })
        }

        function reset() {
            if(vm.stSelectOptions) {
                vm.stSelectOptions.resetTableState();
            }
            vm.globalSearch = {
                "fromDate":null,
                "toDate":null,
                vehicle_family : "",
                vehicle_type : "",
                engine_family  : "",
                engine_type : "",
                engine_index : "",
                gearbox_family : "",
                gearbox_type : "",
                gearbox_index  : "",
                battery_family : "",
                battery_type : "",
                battery_index : "",
                engine2_family : "",
                engine2_type : "",
                engine2_index : ""
            }
            $rootScope.btListSearched = vm.displayed;
            vm.displayed = null;
            vm.customSearch = '';
            
            $timeout(function(){
                document.getElementById("selectOptions").click();
            },100)
            
            vm.selectFields.forEach(function(item){
                item.value = null;
            });

        }

        function goToDiagnosticSearch() {
            $state.go(RoutesConstants.resultSearchByDiagnostic);
        }

        //for enabling search button.
        function enableSearchButton() {
            vm.displayed = null;
            vm.count++;

            if (vm.count >= 3) {
                vm.disabled = false;

            }
            if (vm.FAMILY.length >= 3) {
                vm.disabled = false;

            }
        }

        //formating the updatedate
        function formatDate(date) {
            // return  $filter('date')(new Date(date),'yyyy/MM/dd');
            //  return moment(date).format("YYYY/MM/DD");
            return date.replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3');

        }

        function isInteger(totalBTList) {
            return (typeof totalBTList === 'number') && (totalBTList % 1 === 0);
        }
        //forming Smptomcodes array as String
        function getSmptomcodes(details) {
            return _.sortBy(details.symptomList, ['shortCode']);
        }

        //forming DTCcodes array as String
        function getDtcCodes(details) {
            return _.uniq(details.DTCList.sort());
        }

        function getLupNumbers(details) {
            var lupNumbers = [];
            lupNumbers = _.split(details, ';')
            return _.uniq(lupNumbers.sort());
        }
        //get the data for mapping for ApplicabilityFix column
        function getApplicabilityFix(residual) {


            var applicabilityResidual = [];

            if (!_.isEmpty(residual) && !_.isEmpty(residual[0].fixe)) {

                for (var i = 0; i < residual.length; i++) {
                    var codeCritvalues = [];
                    var firstResidual;
                    var vardate;
                    var codecrit;
                    var sortedcodeCritvalues = [];

                    residual[i].fixe.forEach(function (residualFixe) {
                        if (residualFixe.listCrit) {
                            residualFixe.listCrit.forEach(function (crit) {
                                sortedcodeCritvalues.push({ "codeObj": residualFixe.codeObj, "codeCrit": crit.codeCrit })
                            })
                        }
                    })
                    for (var j = 0; j < sortedcodeCritvalues.length; j++) {
                        if (sortedcodeCritvalues[j].codeObj == "007G" || sortedcodeCritvalues[j].codeObj == "007E") {
                            sortedcodeCritvalues.splice(j, 1);
                        }
                    }

                    var largeCodeCritvalues = [];
                    var smallCodeCritvalues = [];
                    var otherCodeCritvalues = [];
                    var aplCodeCritvalues = [];
                    sortedcodeCritvalues.forEach(function (params) {
                        var codeObj = params.codeObj;
                        var codeobj1 = ["999", "998", "997", "996"];
                        var codeobj2 = ["007V", "008"];
                        if (codeobj1.includes(codeObj)) {
                            largeCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (codeobj2.includes(codeObj)) {
                            smallCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (codeObj == "APV001") {
                            aplCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (!codeobj1.includes(codeObj) && !codeobj2.includes(codeObj) && codeObj != "APV001") {
                            otherCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                    });
                    largeCodeCritvalues = _.orderBy(largeCodeCritvalues, 'codeObj', 'desc');
                    smallCodeCritvalues = _.orderBy(smallCodeCritvalues, 'codeObj', 'asc');
                    otherCodeCritvalues = _.orderBy(otherCodeCritvalues, 'codeObj', 'asc');
                    var finalCodeCritvalues = smallCodeCritvalues.concat(largeCodeCritvalues, otherCodeCritvalues, aplCodeCritvalues);
                    finalCodeCritvalues.forEach(function (params) {
                        codeCritvalues.push(params.codeCrit);
                    })

                    if (i == 0) {
                        firstResidual = codeCritvalues.join('/');
                    }
                    vardate = getVariableResidual(residual, i);


                    if (vardate) {
                        codecrit = codeCritvalues.join('/') + ' - ' + vardate;

                    } else {
                        codecrit = codeCritvalues.join('/') + ' - '
                    }

                    applicabilityResidual.push(codecrit);
                    codecrit = "";
                }



                var applicabilityFix = firstResidual;

                var appfix =
                {
                    tooltipApplicabilityFix: applicabilityResidual,
                    applicabilityFix: applicabilityFix
                }

                return appfix;

            }



            return null;
        }



        function searchBTByNumber(ref) {

            if ($rootScope.currentState === vm.rCst.manageFIC) {
                //vm.redirectSearchBTByNumber = redirectSearchBTByNumber;
                vm.redirectSearchBTByNumber.ref = ref;
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        searchBTByNumber: function () {
                            return vm.redirectSearchBTByNumber;
                        }
                    }
                });
            } else {
                var dtcData = "";
                if(ref.details && ref.details.DTCList){
                    var data = ref.details.DTCList.toString();
                    dtcData = data.split(",").join(", ");
                }
                var BtnumbersAndSymptomsDetails = {
                    lupNumber: ref.LUPNumber,
                    nitgNumber: ref.NITGNumber,
                    dtcCode: dtcData,
                    creationDate: ref.creationDate,
                    updateDate: ref.updateDate,
                    colorCode : ref.colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : ref.colorCode
                };
                if (ref.details) {
                    _.extend(BtnumbersAndSymptomsDetails, {
                        symptoms: _.sortBy(ref.details.symptomList, ['shortCode'])
                    })
                }


                CacheService.setBtListDocumentsHistory(BtnumbersAndSymptomsDetails);


                DocumentsMetierService.displayBtListDetails(ref.paramURL, ref.pdfContent, BtnumbersAndSymptomsDetails);
            }
        }



        //get the data for mapping for Variable column
        function getVariableResidual(residual, index) {

            var applicabilityResidualInformation = '';
            if (!_.isEmpty(residual) && !_.isEmpty(residual[index].variable)) {



                var variable = residual[index].variable;
                if (!_.isEmpty(variable)) {
                    var crit = variable[0].listCrit;
                    var crit1 = variable[1].listCrit;
                    if (!_.isEmpty(crit) && !_.isEmpty(crit1)) {
                           // Code for the Full-Year Format
                           crit1.forEach(function (item) {
                                if(item.codeCrit && (moment(item.codeCrit, "YY/MM/DD",true).isValid())) {
                                    var newDate = item.codeCrit.split("/");
                                    if(newDate[0] >= '51' &&  newDate[0] <= '99') {
                                        var prefix19Yr = '19';
                                        newDate[0] = prefix19Yr + newDate[0];
                                        item.codeCrit = newDate.join("/")
                                    }
                                    else if(newDate[0] >= '00' &&  newDate[0] <= '50') {
                                        var prefix20Yr = '20';
                                        newDate[0] = prefix20Yr + newDate[0];
                                        item.codeCrit = newDate.join("/")
                                    }
                                }
                            });
                            crit.forEach(function (item) {
                                if(item.labelCrit && (moment(item.labelCrit, "YY/MM/DD",true).isValid())) {
                                    var newDate = item.labelCrit.split("/");
                                    if(newDate[0] >= '51' &&  newDate[0] <= '99') {
                                        var prefix19Yr = '19';
                                        newDate[0] = prefix19Yr + newDate[0];
                                        item.labelCrit = newDate.join("/")
                                    }
                                    else if(newDate[0] >= '00' &&  newDate[0] <= '50') {
                                        var prefix20Yr = '20';
                                        newDate[0] = prefix20Yr + newDate[0];
                                        item.labelCrit = newDate.join("/")
                                    }
                                }
                        });
                        if (variable[0].codeObj == 'APVAP1' && variable[1].codeObj == 'APVAV1') {
                            applicabilityResidualInformation += crit[0].labelCrit + ' > ' + crit1[0].codeCrit;
                        }
                        else if (variable[0].codeObj == 'APVNA1' && variable[1].codeObj == 'APVND1') {
                            applicabilityResidualInformation += crit1[0].labelCrit + ' > ' + crit[0].codeCrit;

                        }

                        return applicabilityResidualInformation;

                    }

                }

            }


            return '-';
        }
        //filter for emptyFields  
        function filterEmptyFields(criterias) {
            for (var check in criterias) {
                if (criterias[check] == null || criterias[check] == undefined || criterias[check] == '') {
                    delete criterias[check];
                }
            }
            return criterias;
        }

        //update the color select when change in vm.colorCodes
        $scope.$watch('vm.colorCodesOrdered', function () {
            angular.element(document.getElementById("#customColorSelect")).ready(function () {
                $("#customSelectDiv").remove();
                onSelectColor();
            });
        });

        /**
         * @desc Create custome color select dropdown
         */
        function onSelectColor(opt) {
            var customSelectClass = ".custom-select";
            $("#customColorSelect").each(function () {
                var classes = $(this).attr("class");
                var template;
                template = '<div id="customSelectDiv" class="' + classes + '">';
                template += '<span class="custom-select-trigger"><span class="colorText">' + $(this).attr("placeholder") + '</span></span>';
                template += '<div class="custom-options">';

                $(this).find("option").each(function () {
                    var colorCode = $(this).attr("value");
                    var text = $(this).text();
                    var colorStyle = assignColorCodes(colorCode);
                    if (colorCode) {
                        template += '<span on-select-color value="' + colorCode + '" style="background-color:' + colorStyle + '" class="custom-option circle"> ' + $(this).attr("value") + '</span>';
                    } else if (text && text.toLocaleLowerCase() === "all") {
                        template += '<span on-select-color value="" id="selectOptions" style="background-color:white;color:black" class="custom-option">All</span>';
                    }
                });
                $(this).attr("value")
                $(this).hide();
                $(this).after(template);
            });

            $(".custom-select-trigger").on("click", function () {
                $('html').one('click', function () {
                    $(customSelectClass).removeClass("opened");
                });
                $(this).parents(customSelectClass).toggleClass("opened");
                event.stopPropagation();
            });

            $(".custom-option").on("click", function () {
                var selectedColor = $(this).attr("value");
                var selectedText = $(this).text();
                vm.stSelectOptions.colorFilter(selectedColor);
                selectedColor = assignColorCodes(selectedColor);
                if (selectedColor)
                    $(this).parents(customSelectClass).find(".colorText").css({ "background-color": selectedColor, "color": "transparent" })
                else if (selectedText && selectedText.toLocaleLowerCase() === "all") {
                    $(this).parents(customSelectClass).find(".colorText").css({ "background-color": "white", "color": "black" })
                }
            });
        }
        
        function assignColorCodes(selectedColor) {
            switch (selectedColor) {
                case "NO_COLOR":
                    selectedColor = "lightgray";
                    break;
                case "BLUE_WITH_FOLLOW_UP":
                    selectedColor = "lightblue";
                    break;
                case "BEIGE":
                    selectedColor = "#C7A68B";
                    break;
                default:
                    break;
            }
            return selectedColor;
        }

        /**
         * @desc Search for BT based on selected inputs
         */
        function btSearchAdvanced(initialDateRange) {
            if(vm.stSelectOptions) {
              vm.stSelectOptions.resetTableState();
            }
            $timeout(function(){
                document.getElementById("selectOptions").click();
            },100)

            $rootScope.btListSearched = vm.displayed;
            vm.customSearch = '';
            vm.displayed = null;

            var advancedFilters = {
                "dtcCode": vm.globalSearch.dtcCode,
                "lupNumber": vm.globalSearch.lupNumber,
                "otsNumber": vm.globalSearch.otsNumber
            };
            if (initialDateRange) {
                _.extend(advancedFilters, {
                    "dateRange": {
                        "from": initialDateRange.fromDate,
                        "to": initialDateRange.toDate
                    }
                })
            }
            else if (vm.globalSearch.fromDate && vm.globalSearch.toDate && !initialDateRange) {
                _.extend(advancedFilters, {
                    "dateRange": {
                        "from": moment(vm.globalSearch.fromDate).format("YYYYMMDD"),
                        "to": moment(vm.globalSearch.toDate).format("YYYYMMDD")
                    }
                })
            }
            else if (vm.globalSearch.fromDate && !vm.globalSearch.toDate && !initialDateRange) {
                _.extend(advancedFilters, {
                    "dateRange": {
                        "from": moment(vm.globalSearch.fromDate).format("YYYYMMDD"),
                        "to": "21001231"
                    }
                })
            }
            else if ((!vm.globalSearch.fromDate || !vm.globalSearch.toDate) && !initialDateRange) {
                _.extend(advancedFilters, {
                    "dateRange": {
                        "from": "19000101",
                        "to": "21001231"
                    }
                })
            }

            if (vm.globalSearch.symptomSearch && !_.isEmpty(vm.globalSearch.symptomSearch)) {
                _.extend(advancedFilters, {
                    "symptom": {
                        "text": vm.globalSearch.symptomSearch
                    }
                })
            }
            var userContext = CacheService.getUserContext();
            var carContextbody = {
                "fixedCriterias": {
                    "007": vm.globalSearch.vehicle_family.toUpperCase(),
                    "008": vm.globalSearch.vehicle_type.toUpperCase(),
                    "946": vm.globalSearch.engine2_index.toUpperCase(),
                    "948": vm.globalSearch.engine2_type.toUpperCase(),
                    "966": vm.globalSearch.battery_index.toUpperCase(),
                    "968": vm.globalSearch.battery_type.toUpperCase(),
                    "996": vm.globalSearch.gearbox_index.toUpperCase(),
                    "997": vm.globalSearch.gearbox_type.toUpperCase(),
                    "998": vm.globalSearch.engine_index.toUpperCase(),
                    "999": vm.globalSearch.engine_type.toUpperCase(),
                    "007V": vm.globalSearch.vehicle_family.toUpperCase(),
                    "007B": vm.globalSearch.battery_family.toUpperCase(),
                    "007E": vm.globalSearch.engine_family.toUpperCase(),
                    "007G": vm.globalSearch.gearbox_family.toUpperCase(),
                    "007E2": vm.globalSearch.engine2_family.toUpperCase()
                }
            }
            var technicalBlltnPayLoad;
            blockUI.start();
            CarSearchWsService.carSearchByModel(carContextbody).then(function(res){
                var cutomCarContext = res.carContext;
                technicalBlltnPayLoad = {
                    userContext: userContext,

                    text: vm.globalSearch.tripleFilter,
                    advancedFilters: advancedFilters
                };
            var carContext = false;
            for(var i in cutomCarContext){
                 if (i != 'typeMD'){
                    if(i == 'contextBLMS'){
                        for(var j in cutomCarContext[i]){
                            if(!_.isEmpty(cutomCarContext[i][j])){
                              carContext = true;
                            }
                        }
                    }
                    else{
                        if(!_.isEmpty(cutomCarContext[i])){
                         carContext = true;
                        }
                    }
                }
            }
            if(carContext){
                technicalBlltnPayLoad.carContext =cutomCarContext;
            }
            btListMetierService.getAdvancedBtList(technicalBlltnPayLoad).then(function (response) {
                var rowCollection = dedupeBtList(response);
                var length = rowCollection.length;
                var numberOfBTList = length / 30;

                var isNumber = isInteger(numberOfBTList);
                if (isNumber) {
                    vm.numberOfPagesToDisplay = numberOfBTList;
                } else {
                    vm.numberOfPagesToDisplay = Math.ceil(numberOfBTList);
                }

                rowCollection.sort(function (a, b) {
                    return a.name - b.name;
                });

                vm.displayCopy = enhanceDataForSearch(rowCollection);
                vm.displayed = filterRowsByGlobalSearch(vm.displayCopy, vm.globalSearch);
                vm.showGlobalSearch = false;
                vm.colorCodesOrdered = [];
                vm.colorCodes = _.uniq(_.map(vm.displayed, 'colorCode'));
                var defaultColorCodes = ['NO_COLOR','GREEN','BLUE','BLUE_WITH_FOLLOW_UP','YELLOW','BEIGE','ORANGE','RED'];
                defaultColorCodes.forEach( function(item){
                    if(vm.colorCodes.includes(item)){
                        vm.colorCodesOrdered.push(item);
                    }
                })
                vm.showStates = _.uniq(_.map(vm.displayed, 'state'));
                vm.firstStateLabel = "ALL";
                vm.showStates.unshift(vm.firstStateLabel);
                angular.copy(vm.showStates,vm.displayedResults);

                if(!_.isEmpty(vm.displayed)){
                    vm.displayed.forEach(function(item){
                        if(!_.isEmpty(item.details.DTCList)){
                            item.details.DTCList = _.uniq(item.details.DTCList.sort());
                            item.dtcCodes = item.details.DTCList.join(' ');
                        } else{
                            item.dtcCodes = '';
                        }
                        if(!_.isEmpty(item.details.symptomList)){
                            item.details.symptomList = _.sortBy(item.details.symptomList, ['shortCode']);
                            item.symptomCodes = (_.map(item.details.symptomList , 'shortCode')).join(' ');
                        } else {
                            item.symptomCodes = '';
                        }
                        var residualitem = getVariableResidual(item.residual,0);
                        var combinedTextSearch = _.compact([
                            item.designation,
                            item.solution,
                            item.informations
                        ]).join(' ');
                        _.assign(item, {
                            tripleFilter: combinedTextSearch,
                            applicability: (!_.isEmpty(item.residual)) ? getApplicabilityFix(item.residual) : '',
                            residualInfo: _.isEmpty(item.residual) ? '-' : residualitem ? residualitem : '-'
                        });
                        
                        if(item.applicability && item.applicability.applicabilityFix)
                            _.assign(item,{applicabilityFix:item.applicability.tooltipApplicabilityFix})

                        if(!_.isEmpty(item.LUPNumber)){
                            var lupNumbers = [];
                            lupNumbers = _.split(item.LUPNumber, ';')
                            item.LUPNumber = _.uniq(lupNumbers.sort());
                        }else{
                            item.LUPNumber = "";
                        }
                    })
                    angular.copy(vm.displayed, vm.displayedSort);
                    vm.btListFound = true;
                }
                else {
                    vm.btListFound = false;
                }
                blockUI.stop();
            }).catch(function (e) {
                if (e && e.data && e.data.error)
                    toastr.error($translate.instant(e.data.error));
                vm.isLoading = false;
                blockUI.stop();
            })
            }).catch(function (e) {
                    if (e && e.data && e.data.error)
                        toastr.error($translate.instant(e.data.error));
                    else
                        toastr.error($translate.instant('ERROR'));
                    vm.isLoading = false;
                    blockUI.stop();
                })
        }
        
        //get the BTList data
        function btSearch(selectedDocType) {
            $rootScope.btListSearched = vm.displayed;
            vm.customSearch = '';
            vm.displayed = null;
            if (!vm.FAMILY) {
                return false;
            }
            blockUI.start();
            vm.isLoading = true;
            var userProfil = CacheService.getUserProfile();

            var pagination = 50; //tableState.pagination;

            var start = pagination.start || 0;     // This is NOT the page numberOfEntriesPerPage, but the index of item in the list that you want to use to display the table.
            var numberOfEntriesPerPage = pagination.number || 20;  // Number of entries showed per page.
            var dealerId = userProfil.dealerId;
            var page = Math.ceil(start / numberOfEntriesPerPage) + 1;
            var pageSize = 5000;

            vm.userContext = CacheService.getUserContext();
            //vm.carContext = CacheService.getCarContext();

            var fixedCriterias = {
                "007": vm.FAMILY.toUpperCase(),
                "008": vm.MODEL.toUpperCase(),
                "999": vm.ENGINE.toUpperCase(),
                "998": vm.EINDEX.toUpperCase(),
                "997": vm.GEARBOX.toUpperCase(),
                "996": vm.GINDEX.toUpperCase(),
                "968": vm.BATTERY.toUpperCase(),
                "966": vm.BINDEX.toUpperCase()
            };

            vm.carContext = {
                "millesim": null,
                "fixedCriterias": filterEmptyFields(fixedCriterias),

                "families": {
                    "familyVehicle": [
                        vm.FAMILY.toUpperCase()
                    ]
                },
                "extraFamilies": {
                    "007V": vm.FAMILY.toUpperCase()
                }

            };


            var fixedFiltered2Payload = {
                userContext: vm.userContext,
                carContext: vm.carContext,
                "docType": { "BT": {} }
            };


            btListMetierService.fixedFiltered2(fixedFiltered2Payload).then(function (response) {
                if (response && response.documents && response.documents.length > 0) {


                    vm.docids = _.map(response.documents, 'id');



                    var technicalBlltnPayLoad = {
                        userContext: vm.userContext,
                        carContext: vm.carContext,
                        BT: vm.docids
                    };

                    btListMetierService.getBtList(technicalBlltnPayLoad).then(function (response) {
                        var rowCollection = response.BT;
                        var length = rowCollection.length;
                        var numberOfBTList = length / 30;

                        var isNumber = isInteger(numberOfBTList);
                        if (isNumber) {
                            vm.numberOfPagesToDisplay = numberOfBTList;
                        } else {
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfBTList);
                        }

                        rowCollection.sort(function (a, b) {
                            return a.name - b.name;
                        });

                        vm.displayed = enhanceDataForSearch(rowCollection);
                        if (!_.isEmpty(vm.displayed)) {
                            vm.btListFound = true;

                        }
                        else {
                            vm.btListFound = false;
                        }

                        blockUI.stop();


                    }

                    ).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                        vm.isLoading = false;

                        blockUI.stop();

                    });

                }
                else {

                    vm.btListFound = false;
                    blockUI.stop();

                }



            }
            ).catch(function () {
                toastr.error($translate.instant('ERROR'));
                vm.isLoading = false;

            }).finally(function () {
                vm.isLoading = false;
                // vm.disabled=true;
                vm.displayed = null;



            });
        }

        function pageSizeChange(){
            var numberOfBTList = vm.displayed.length / vm.pageSize;

            var isNumber = isInteger(numberOfBTList);
            if (isNumber) {
                vm.numberOfPagesToDisplay = numberOfBTList;
            } else {
                vm.numberOfPagesToDisplay = Math.ceil(numberOfBTList);
            }
        }

        function selectState(state) {
            vm.displayed = vm.displayedSort;
            
            if(vm.displayedResults[state] != "ALL"){
                vm.displayed = _.filter(vm.displayed,function (item) {
                    return vm.displayedResults[state] === item.state;
                 })
            }
            else {
                vm.displayed = vm.displayedSort;
            }
        }

        vm.showTooltip = function () {
            if (vm.hideTimeout) {
                $timeout.cancel(vm.hideTimeout);
            }
            vm.tooltipVisible = true;
        };

        vm.hideTooltip = function () {
            vm.hideTimeout = $timeout(function () {
                vm.tooltipVisible = false;
            }, 200);
        };

        function dedupeBtList(rowCollection) {
            if (!rowCollection || !Array.isArray(rowCollection)) return rowCollection;

            return _.uniqBy(rowCollection, function (item) {
                return [
                    item && item.name,
                    item && item.creationDate,
                    item && item.updateDate,
                    item && item.designation,
                    item && item.solution,
                    item && item.informations
                ].join('|');
            });
        }

        function enhanceDataForSearch(dataArray) {
            if (!dataArray || !Array.isArray(dataArray)) return dataArray;
            
            return dataArray.map(function(item) {
                if (item.details && item.details.DTCList && Array.isArray(item.details.DTCList)) {
                    item.dtcSearchString = item.details.DTCList.join(' ');
                } else {
                    item.dtcSearchString = '';
                }
                
                if (item.details && item.details.symptomList && Array.isArray(item.details.symptomList)) {
                    item.symptomSearchString = item.details.symptomList.map(function(symptom) {
                        return (symptom.shortCode || '') + ' ' + (symptom.label || '');
                    }).join(' ');
                } else {
                    item.symptomSearchString = '';
                }
                
                if (item.LUPNumber) {
                    if (Array.isArray(item.LUPNumber)) {
                        item.lupSearchString = item.LUPNumber.join(' ');
                    } else if (typeof item.LUPNumber === 'string' && item.LUPNumber !== '') {
                        item.lupSearchString = item.LUPNumber.replace(/;/g, ' ');
                    } else {
                        item.lupSearchString = '';
                    }
                } else {
                    item.lupSearchString = '';
                }

                item.tripleFilter = _.compact([
                    item.designation,
                    item.solution,
                    item.informations
                ]).join(' ');
                
                return item;
            });
        }

        function filterRowsByGlobalSearch(dataArray, searchTerm) {
            var searchValues = typeof searchTerm === 'object' ? [
                searchTerm.tripleFilter,
                searchTerm.symptomSearch,
                searchTerm.dtcCode,
                searchTerm.lupNumber,
                searchTerm.otsNumber
            ] : [searchTerm];
            var normalizedSearch = searchValues.filter(function (value) {
                return value !== undefined && value !== null && String(value).trim() !== '';
            }).map(function (value) {
                return String(value).trim().toLowerCase();
            });

            if (!normalizedSearch.length) {
                return dataArray;
            }

            return dataArray.filter(function (item) {
                var searchableText = [
                    item.tripleFilter,
                    item.dtcSearchString,
                    item.symptomSearchString,
                    item.lupSearchString
                ].join(' ').toLowerCase();

                return normalizedSearch.every(function (value) {
                    return searchableText.indexOf(value) !== -1;
                });
            });
        }

        function applyGlobalSearch() {
            vm.displayed = filterRowsByGlobalSearch(vm.displayCopy, vm.globalSearch);
            vm.btListFound = !_.isEmpty(vm.displayed);
        }

        function searchGlobal() {
            var hasBackendCriteria = [
                'vehicle_family', 'vehicle_type', 'engine_family', 'engine_type',
                'engine_index', 'gearbox_family', 'gearbox_type', 'gearbox_index',
                'battery_family', 'battery_type', 'battery_index', 'engine2_family',
                'engine2_type', 'engine2_index', 'fromDate', 'toDate'
            ].some(function (key) {
                return vm.globalSearch[key];
            });

            if (hasBackendCriteria) {
                btSearchAdvanced();
            } else {
                applyGlobalSearch();
            }
        }

    }


}

)();

(function () {
  
    angular
      .module('phenix')
      .config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
      $stateProvider
        .state(RoutesConstants.btListData, {
          url: '/btListData',
          templateUrl: 'app/components/btList/btList.template.html',
          controller: 'btListController',
          params: {
            data: null
          },
          controllerAs: 'vm'
        });

        $stateProvider.state(RoutesConstants.btListAdvanced, {
          url: '/btList',
          templateUrl: 'app/components/btList/btListAdvanced.template.html',
          controller: 'btListAdvancedController',
          params: {
            data: null,
            isFromDiagnosticScreen: false
          },
          controllerAs: 'vm'
        });
    }
  })();
  
(function () {

    angular
        .module('phenix')
        .service('BtListControllerService', BtListControllerService);

    function BtListControllerService() {
        this.defineRules = defineRules;

        function defineRules(vm) {
            Object.defineProperties(vm.rules, {
                'engine_index': {
                    enumerable: true,
                    get: function () {
                        return vm.globalSearch.engine_type === "" || vm.globalSearch.engine_type === null;
                    }
                },
                'gearbox_index': {
                    enumerable: true,
                    get: function () {
                        return vm.globalSearch.gearbox_type === "" || vm.globalSearch.gearbox_type === null;
                    }
                },
                'battery_index': {
                    enumerable: true,
                    get: function () {
                        return vm.globalSearch.battery_type === "" || vm.globalSearch.battery_type === null;
                    }
                },
                'engine2_index': {
                    enumerable: true,
                    get: function () {
                        return vm.globalSearch.engine2_type === "" || vm.globalSearch.engine2_type === null;
                    }
                }
            });
        }
    }

})();
(function () {

    angular
        .module('phenix')
        .controller('btListController', btListController)
        .filter('myCustomFilter', function ($filter, $rootScope) {
            return function (input, predicate) {
                var searchValue = predicate['$'];
                if (typeof searchValue === 'undefined') {
                    return input;
                }
                var setFilter = [];
                angular.forEach(input, function (value, index, array) {

                    var designation = value['designation'].toLowerCase().indexOf(searchValue.toLowerCase());
                    var solution = value['solution'].toLowerCase().indexOf(searchValue.toLowerCase());
                    var informations = value['informations'].toLowerCase().indexOf(searchValue.toLowerCase());

                    if (designation > -1 || solution > -1 || informations > -1) {
                        setFilter.push(array[index]);
                    }
                });
                if ($rootScope.btListSearched) {
                    predicate['$'] = '';
                }
                return setFilter;
            }
        });

    /** @ngInject */
    function btListController(
        $scope,
        blockUI,

        toastr,
        $translate,
        $state,
        $mdDialog,
        CacheService,
        $filter,
        $rootScope,


        btListMetierService,
        RoutesConstants,
        DocumentsMetierService,
        ResultSearchByDiagnosticMetierService
    ) {

        var vm = this;
        vm.FAMILY = '';
        vm.MODEL = '';
        vm.GEARBOX = '';
        vm.BATTERY = '';
        vm.GINDEX = '';
        vm.BINDEX = '';
        vm.ENGINE = '';
        vm.EINDEX = '';
        vm.customSearch = '';
        vm.disabled = true;
        vm.enableSearchButton = enableSearchButton;
        vm.getSmptomcodes = getSmptomcodes;
        vm.getDtcCodes = getDtcCodes;
        vm.getLupNumbers = getLupNumbers;
        vm.btSearch = btSearch;
        vm.formatDate = formatDate;
        vm.getApplicabilityFix = getApplicabilityFix;
        vm.getVariableResidual = getVariableResidual;
        vm.searchBTByNumber = searchBTByNumber;
        vm.goToDiagnosticSearch = goToDiagnosticSearch;
        vm.reset = reset;
        vm.rePopulateCriterias = rePopulateCriterias;
        vm.rCst = RoutesConstants;


        vm.btListFound = true;

        vm.count = 0;
        vm.btListFixedCriterias = ResultSearchByDiagnosticMetierService.getBtListFixedCriterias();
        vm.btListFixedCriteriasParams = $state.params.data;
        if (vm.btListFixedCriteriasParams) {
            rePopulateCriterias(vm.btListFixedCriteriasParams);
        }

        //repopulate the criterias from carcontext
        function rePopulateCriterias(btListFixedCriterias) {
            if (btListFixedCriterias["007"]) {
                vm.FAMILY = btListFixedCriterias["007"];
                vm.count = vm.FAMILY.length;
                enableSearchButton();
            }
            if (btListFixedCriterias["008"]) {
                vm.MODEL = btListFixedCriterias["008"];
            }
            if (btListFixedCriterias["999"]) {
                vm.ENGINE = btListFixedCriterias["999"];
            }
            if (btListFixedCriterias["998"]) {
                vm.EINDEX = btListFixedCriterias["998"];
            }
            if (btListFixedCriterias["997"]) {
                vm.GEARBOX = btListFixedCriterias["997"];
            }
            if (btListFixedCriterias["996"]) {
                vm.GINDEX = btListFixedCriterias["996"];
            }
            if (btListFixedCriterias["968"]) {
                vm.BATTERY = btListFixedCriterias["968"];
            }
            if (btListFixedCriterias["966"]) {
                vm.BINDEX = btListFixedCriterias["966"];
            }
        }

        function reset() {
            vm.FAMILY = '';
            vm.MODEL = '';
            vm.GEARBOX = '';
            vm.BATTERY = '';
            vm.GINDEX = '';
            vm.BINDEX = '';
            vm.ENGINE = '';
            vm.EINDEX = '';
            $rootScope.btListSearched = vm.displayed;
            vm.displayed = null;
            vm.customSearch = '';
            rePopulateCriterias(vm.btListFixedCriterias);

        }

        function goToDiagnosticSearch() {
            $state.go(RoutesConstants.resultSearchByDiagnostic);
        }

        //for enabling search button.
        function enableSearchButton() {
            vm.displayed = null;
            vm.count++;

            if (vm.count >= 3) {
                vm.disabled = false;

            }
            if (vm.FAMILY.length >= 3) {
                vm.disabled = false;

            }
        }

        //formating the updatedate
        function formatDate(date) {
            // return  $filter('date')(new Date(date),'yyyy/MM/dd');
            //  return moment(date).format("YYYY/MM/DD");
            return date.replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3');

        }

        function isInteger(totalBTList) {
            return (typeof totalBTList === 'number') && (totalBTList % 1 === 0);
        }
        //forming Smptomcodes array as String
        function getSmptomcodes(details) {

            return _.sortBy(details.symptomList, ['shortCode']);
        }

        //forming DTCcodes array as String

        function getDtcCodes(details) {

            return _.uniq(details.DTCList.sort());
        }

        function getLupNumbers(details) {
            var lupNumbers = [];
            lupNumbers = _.split(details, ';')
            return _.uniq(lupNumbers.sort());
        }
        //get the data for mapping for ApplicabilityFix column
        function getApplicabilityFix(residual) {


            var applicabilityResidual = [];

            if (!_.isEmpty(residual) && !_.isEmpty(residual[0].fixe)) {

                for (var i = 0; i < residual.length; i++) {
                    var codeCritvalues = [];
                    var firstResidual;
                    var vardate;
                    var codecrit;
                    var sortedcodeCritvalues = [];

                    residual[i].fixe.forEach(function (residualFixe) {
                        if (residualFixe.listCrit) {
                            residualFixe.listCrit.forEach(function (crit) {
                                sortedcodeCritvalues.push({ "codeObj": residualFixe.codeObj, "codeCrit": crit.codeCrit })
                            })
                        }
                    })
                    for (var j = 0; j < sortedcodeCritvalues.length; j++) {
                        if (sortedcodeCritvalues[j].codeObj == "007G" || sortedcodeCritvalues[j].codeObj == "007E") {
                            sortedcodeCritvalues.splice(j, 1);
                        }
                    }

                    var largeCodeCritvalues = [];
                    var smallCodeCritvalues = [];
                    var otherCodeCritvalues = [];
                    var aplCodeCritvalues = [];
                    sortedcodeCritvalues.forEach(function (params) {
                        var codeObj = params.codeObj;
                        var codeobj1 = ["999", "998", "997", "996"];
                        var codeobj2 = ["007V", "008"];
                        if (codeobj1.includes(codeObj)) {
                            largeCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (codeobj2.includes(codeObj)) {
                            smallCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (codeObj == "APV001") {
                            aplCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                        if (!codeobj1.includes(codeObj) && !codeobj2.includes(codeObj) && codeObj != "APV001") {
                            otherCodeCritvalues.push({ "codeObj": params.codeObj, "codeCrit": params.codeCrit });
                        }
                    });
                    largeCodeCritvalues = _.orderBy(largeCodeCritvalues, 'codeObj', 'desc');
                    smallCodeCritvalues = _.orderBy(smallCodeCritvalues, 'codeObj', 'asc');
                    otherCodeCritvalues = _.orderBy(otherCodeCritvalues, 'codeObj', 'asc');
                    var finalCodeCritvalues = smallCodeCritvalues.concat(largeCodeCritvalues, otherCodeCritvalues, aplCodeCritvalues);
                    finalCodeCritvalues.forEach(function (params) {
                        codeCritvalues.push(params.codeCrit);
                    })

                    if (i == 0) {
                        firstResidual = codeCritvalues.join('/');
                    }
                    vardate = getVariableResidual(residual, i);


                    if (vardate) {
                        codecrit = codeCritvalues.join('/') + ' - ' + vardate;

                    } else {
                        codecrit = codeCritvalues.join('/') + ' - '
                    }

                    applicabilityResidual.push(codecrit);
                    codecrit = "";
                }



                var applicabilityFix = firstResidual;

                var appfix =
                {
                    tooltipApplicabilityFix: applicabilityResidual,
                    applicabilityFix: applicabilityFix
                }

                return appfix;

            }



            return null;
        }



        function searchBTByNumber(ref) {

            if ($rootScope.currentState === vm.rCst.manageFIC) {
                //vm.redirectSearchBTByNumber = redirectSearchBTByNumber;
                vm.redirectSearchBTByNumber.ref = ref;
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        searchBTByNumber: function () {
                            return vm.redirectSearchBTByNumber;
                        }
                    }
                });
            } else {
                var dtcData = "";
                if(ref.details && ref.details.DTCList){
                    var data = ref.details.DTCList.toString();
                    dtcData = data.split(",").join(", ");
                }
                var BtnumbersAndSymptomsDetails = {
                    lupNumber: ref.LUPNumber,
                    nitgNumber: ref.NITGNumber,
                    dtcCode: dtcData,
                    creationDate: ref.creationDate,
                    updateDate: ref.updateDate,
                    colorCode : ref.colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : ref.colorCode
                };
                if (ref.details) {
                    _.extend(BtnumbersAndSymptomsDetails, {
                        symptoms: _.sortBy(ref.details.symptomList, ['shortCode'])
                    })
                }


                CacheService.setBtListDocumentsHistory(BtnumbersAndSymptomsDetails);


                DocumentsMetierService.displayBtListDetails(ref.paramURL, ref.pdfContent, BtnumbersAndSymptomsDetails);
            }
        }



        //get the data for mapping for Variable column
        function getVariableResidual(residual, index) {

            var applicabilityResidualInformation = '';
            if (!_.isEmpty(residual) && !_.isEmpty(residual[index].variable)) {



                var variable = residual[index].variable;
                if (!_.isEmpty(variable)) {
                    var crit = variable[0].listCrit;
                    var crit1 = variable[1].listCrit;
                    if (!_.isEmpty(crit) && !_.isEmpty(crit1)) {
                        if (variable[0].codeObj == 'APVAP1' && variable[1].codeObj == 'APVAV1') {
                            applicabilityResidualInformation += crit[0].labelCrit + ' > ' + crit1[0].codeCrit;
                        }
                        else if (variable[0].codeObj == 'APVNA1' && variable[1].codeObj == 'APVND1') {
                            applicabilityResidualInformation += crit1[0].labelCrit + ' > ' + crit[0].codeCrit;

                        }
                        return applicabilityResidualInformation;

                    }

                }

            }


            return null;
        }
        //filter for emptyFields  
        function filterEmptyFields(criterias) {
            for (var check in criterias) {
                if (criterias[check] == null || criterias[check] == undefined || criterias[check] == '') {
                    delete criterias[check];
                }
            }
            return criterias;
        }



        //get the BTList data
        function btSearch(selectedDocType) {
            $rootScope.btListSearched = vm.displayed;
            vm.customSearch = '';
            vm.displayed = null;
            if (!vm.FAMILY) {
                return false;
            }
            blockUI.start();
            vm.isLoading = true;
            var userProfil = CacheService.getUserProfile();

            var pagination = 50; //tableState.pagination;

            var start = pagination.start || 0;     // This is NOT the page numberOfEntriesPerPage, but the index of item in the list that you want to use to display the table.
            var numberOfEntriesPerPage = pagination.number || 20;  // Number of entries showed per page.
            var dealerId = userProfil.dealerId;
            var page = Math.ceil(start / numberOfEntriesPerPage) + 1;
            var pageSize = 5000;

            vm.userContext = CacheService.getUserContext();
            //vm.carContext = CacheService.getCarContext();

            var fixedCriterias = {
                "007": vm.FAMILY.toUpperCase(),
                "008": vm.MODEL.toUpperCase(),
                "999": vm.ENGINE.toUpperCase(),
                "998": vm.EINDEX.toUpperCase(),
                "997": vm.GEARBOX.toUpperCase(),
                "996": vm.GINDEX.toUpperCase(),
                "968": vm.BATTERY.toUpperCase(),
                "966": vm.BINDEX.toUpperCase()
            };

            vm.carContext = {
                "millesim": null,
                "fixedCriterias": filterEmptyFields(fixedCriterias),

                "families": {
                    "familyVehicle": [
                        vm.FAMILY.toUpperCase()
                    ]
                },
                "extraFamilies": {
                    "007V": vm.FAMILY.toUpperCase()
                }

            };


            var fixedFiltered2Payload = {
                userContext: vm.userContext,
                carContext: vm.carContext,
                "docType": { "BT": {} }
            };


            btListMetierService.fixedFiltered2(fixedFiltered2Payload).then(function (response) {
                if (response && response.documents && response.documents.length > 0) {


                    vm.docids = _.map(response.documents, 'id');



                    var technicalBlltnPayLoad = {
                        userContext: vm.userContext,
                        carContext: vm.carContext,
                        BT: vm.docids
                    };

                    btListMetierService.getBtList(technicalBlltnPayLoad).then(function (response) {
                        var rowCollection = response;
                        var length = rowCollection.length;
                        var numberOfBTList = length / 30;

                        var isNumber = isInteger(numberOfBTList);
                        if (isNumber) {
                            vm.numberOfPagesToDisplay = numberOfBTList;
                        } else {
                            vm.numberOfPagesToDisplay = Math.ceil(numberOfBTList);
                        }

                        rowCollection.sort(function (a, b) {
                            return a.name - b.name;
                        });

                        vm.displayed = rowCollection;
                        // getApplicabilityFix(rowCollection);
                        if (!_.isEmpty(vm.displayed)) {
                            vm.btListFound = true;

                        }
                        else {
                            vm.btListFound = false;
                        }

                        blockUI.stop();


                    }

                    ).catch(function () {
                        toastr.error($translate.instant('ERROR'));
                        vm.isLoading = false;

                        blockUI.stop();

                    });

                }
                else {

                    vm.btListFound = false;
                    blockUI.stop();

                }



            }
            ).catch(function () {
                toastr.error($translate.instant('ERROR'));
                vm.isLoading = false;

            }).finally(function () {
                vm.isLoading = false;
                // vm.disabled=true;
                vm.displayed = null;



            });
        }


    }


}

)();

(function() {
    angular.module('phenix').constant('btViewListConstants', {
        endpoint: {
            fixedFiltered2: '/proxy/apidh/rest/v1/applicabilities/fixedFiltered2',
            technicalBulletins: '/proxy/apidh/rest/v1/technicalBulletins',
            advancedTechnicalBulletins: '/proxy/apidh/rest/v1/advanced/technicalBulletins' 
        },
        pagination: {
            limit: 20
        }
    })
})();

(function () {
    angular.module('phenix').service('btListMetierService', function (
        btListWSService, btViewListConstants
    ) {

        /************************
         *      FUNCTIONS       *
         ***********************/
        this.getBtList = getBtList;
        this.getAdvancedBtList = getAdvancedBtList;
        this.fixedFiltered2 = fixedFiltered2;
        this.buildFields2 = buildFields2;
        this.buildVehFamilyAndType = buildVehFamilyAndType;
        /*************************
         *      VARIABLE         *
         ************************/



        
        
        function fixedFiltered2(payload) {
            return btListWSService.fixedFiltered2(payload);
        }

        function getBtList(payload) {
            var url= btViewListConstants.endpoint.technicalBulletins;
            return btListWSService.getBtList(url,payload);
        }

        function getAdvancedBtList(payload) {
            var url = btViewListConstants.endpoint.advancedTechnicalBulletins;
            return btListWSService.getAdvancedBtList(url,payload);
        }
        function buildVehFamilyAndType(list, selectedFields) {
            var vahicleFamilyList = [];
            var vahicleTypeList = [];
            list.forEach(function (item) {
                item.childFilters.forEach(function (subitem) {
                    vahicleFamilyList.push(subitem.criteriaCode);
                    subitem.childFilters.forEach(function (vehicleTypeItem) {
                        vahicleTypeList.push(vehicleTypeItem.criteriaCode);
                    })
                })
            });
            vahicleFamilyList = _.uniq(vahicleFamilyList).sort();
            vahicleTypeList = _.uniq(vahicleTypeList).sort();
            selectedFields[0].list = vahicleFamilyList;

            selectedFields.map(function (item) {
                if (item.key === "vehicle_type") {
                    item.list = vahicleTypeList;
                }
            })
            return selectedFields;
        }

        function buildFields2(arrayFields, listSelect, dataFromCache, selectedFromCache) {
            if (!arrayFields)
                arrayFields = [];
            if (!listSelect)
                listSelect = [];
            function parseList(arrayFields, list) {
                var newList = {};
                arrayFields.forEach(function (item) {
                    var key = item.code
                    newList[key] = [];
                    list.forEach(function (element) {
                        var value = element[key];
                        if (value && newList[key].indexOf(value) === -1)
                            newList[key].push(value);
                    });
                });
                return newList;
            }
    
            var selected = selectedFromCache || {};
            function filterList(value, field, listFields, action) {
                var filterList = listSelect;
                var previousSelectedElement = angular.element(document.querySelector('md-option[value="'+selected[field.code]+'"]'));
                var currentSelectedElement = angular.element(document.querySelector('md-option[value="'+value+'"]'));
    
                if (!selected[field.code]) {
                    currentSelectedElement.attr('selected', 'selected');
                }
    
                if (!value) {
                    previousSelectedElement.removeAttr('selected');
                    delete selected[field.code];
                } else if (action === 'ADDED') {
                    //to remove attribute selected from previous element and add it to current
                    if (selected[field.code]) {
                        previousSelectedElement.removeAttr('selected');
                        currentSelectedElement.attr('selected', 'selected');
                    }
                    selected[field.code] = value;
                } else if (action === 'DELETED') {
                    delete selected[field.code];
                }
                if (Object.keys(selected).length > 0)
                    filterList = listSelect.filter(function (value) {
                        var length = Object.keys(selected).length;
                        var i = 0;
    
                        _.forEach(selected,function(v,k){
                            if(v === value[k]){
                                i++;
                            }
                        })
                        
                        if(i===length){
                            return true;
                        }
                            return false;
                        
                    })
    
                    if(listFields[2].value){
                        listFields[5].selParent = true;
                    }else if(!listFields[2].value){
                        listFields[5].selParent = false;
                    }
    
                    if(field.index === 1 && filterList.length > 1){
                        listFields[2].selParent = false;
                    }else if(field.index === 1 && filterList.length === 1){
                        listFields[2].selParent = true;
                    }
                var list = parseList(arrayFields, filterList);
                var required = (listFields[0].value && listFields[1].value);
                listFields.forEach(function (field, index) {
                    if (!required && index > 1)
                        field.list = [];
                    else
                        field.list = list[field.code];
                })
            }
    
            function restoreValueFromCache(dataCache, index) {
                if (!dataCache || !dataCache[index] || !dataCache[index].list)
                    return null
                return dataCache[index].value;
            }
    
            function restoreListFromCache(dataCache, index, list) {
                list.sort();
                if (!dataCache || !dataCache[index] || !dataCache[index].list)
                    return list
                return dataCache[index].list;
            }
    
            function resetSelect(index, fields) {
                /* reset next field */
                if (index >= fields.length) return;
                if(index > 1){
                    fields[index].value = null;
                    fields[index].list = [];
                    fields[index].tmp = [];
                    delete selected[fields[index].code];
                }else{
                index = index + 1;
                
                for (; fields[index]; index++) {
                        fields[index].value = null;
                        fields[index].list = [];
                        fields[index].tmp = [];
                        delete selected[fields[index].code];
                    }
                }
                
            }
    
            function createCompleteFields(fields, listSelect, dataFromCache) {
                var newFields = [];
                fields.forEach(function (field, index) {
                    newFields.push({
                        key: field.key,
                        code: field.code,
                        defaultOption: field.defaultOption,
                        class: field.class,
                        list: restoreListFromCache(dataFromCache, index, listSelect[field.code]) || [],
                        filterList: filterList,
                        required: field.required,
                        tmp: [],
                        reset: resetSelect,
                        index: index,
                        selParent : false,
                        value: field.value ? field.value :restoreValueFromCache(dataFromCache, index),
                    })
                })
                return newFields;
            }
    
            var newListSelect = parseList(arrayFields, listSelect);
            var newFields = createCompleteFields(arrayFields, newListSelect, dataFromCache);
            return newFields;
        }
        

       
    })
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ChatbotService', ChatbotService);

    /** @ngInject */
    function ChatbotService($q, $translate, RestUpgrade, CacheService, CacheConstants, DocumentsWsService) {
        const CHAT_ENDPOINT = '/proxy/llm/search/agent/v1/parts/chat';
        const HEALTH_ENDPOINT = '/proxy/llm/search/agent/v1/ping';
        
        const service = {
            sendMessage: sendMessage,
            checkHealth: checkHealth,
            getCarContext: getCarContext,
            getUserContext: getUserContext,
            clearSession: clearSession,
            hasActiveSession: hasActiveSession,
            getMessages: getMessages,
            addMessage: addMessage,
            resetMessages: resetMessages,
            getPartsByGenericCodes: getPartsByGenericCodes,
            loadWelcomeMessage: loadWelcomeMessage
        };

        let sessionId = null;
        const messages = [];
        let healthCheckPromise = null;
        let isHealthy = null;
        let isWelcomeLoaded = false;

        return service;

        function loadWelcomeMessage() {
            
            if (isWelcomeLoaded) {
                return $q.resolve();
            }

            const deferred = $q.defer();
            isWelcomeLoaded = true;
            messages.length = 0;

            const carContext = getCarContext();
            const userContext = getUserContext();

            if (!carContext.vin) {
                $translate("CHATBOT_API_ERROR").then(function (translation) {
                    if (messages.length === 0) {
                        messages.push({
                            id: 1,
                            type: 'bot',
                            content: translation,
                            timestamp: new Date()
                        });
                    }
                    deferred.resolve();
                });
                return deferred.promise;
            }

            const requestBody = {
                carContext: carContext,
                userContext: userContext
            };

            RestUpgrade.all(CHAT_ENDPOINT).post(requestBody)
                .then(function (response) {
                    if (response.sessionId) {
                        sessionId = response.sessionId;
                    }

                    const welcomeMessage = response.assistantReply || response.assistant_reply || $translate.instant('CHATBOT_API_ERROR');

                    if (messages.length === 0) {
                        messages.push({
                            id: 1,
                            type: 'bot',
                            content: welcomeMessage,
                            timestamp: new Date(),
                            sessionId: sessionId
                        });
                    }
                    deferred.resolve();
                })
                .catch(function () {
                    $translate("CHATBOT_API_ERROR").then(function (translation) {
                        if (messages.length === 0) {
                            messages.push({
                                id: 1,
                                type: 'bot',
                                content: translation,
                                timestamp: new Date()
                            });
                        }
                        deferred.resolve();
                    });
                });

            return deferred.promise;
        }

        function getMessages() {
            return messages;
        }

        function addMessage(message) {
            messages.push(message);
        }

        function resetMessages() {
            messages.length = 0;
            isWelcomeLoaded = false;

            const carContext = getCarContext();
            const userContext = getUserContext();

            if (!carContext.vin) {
                return $q.resolve();
            }

            isWelcomeLoaded = true;

            const deferred = $q.defer();
            const requestBody = {
                carContext: carContext,
                userContext: userContext
            };

            RestUpgrade.all(CHAT_ENDPOINT).post(requestBody)
                .then(function (response) {
                    if (response.sessionId) {
                        sessionId = response.sessionId;
                    }

                    const welcomeMessage = response.assistantReply || response.assistant_reply || $translate.instant('CHATBOT_API_ERROR');

                    messages.push({
                        id: 1,
                        type: 'bot',
                        content: welcomeMessage,
                        timestamp: new Date(),
                        sessionId: sessionId
                    });
                    deferred.resolve();
                })
                .catch(function () {
                    $translate("CHATBOT_API_ERROR").then(function (translation) {
                        messages.push({
                            id: 1,
                            type: 'bot',
                            content: translation,
                            timestamp: new Date()
                        });
                        deferred.resolve();
                    });
                });

            return deferred.promise;
        }

        function hasActiveSession() {
            return sessionId !== null;
        }

        function checkHealth() {
            if (isHealthy !== null) {
                return $q.resolve(isHealthy);
            }

            if (healthCheckPromise) {
                return healthCheckPromise;
            }

            const deferred = $q.defer();
            healthCheckPromise = deferred.promise;

            RestUpgrade.one(HEALTH_ENDPOINT).get()
                .then(function (response) {
                    if (response && response.pong && response.pong.MIDDLE_STATUS === 'OK') {
                        isHealthy = true;
                        deferred.resolve(true);
                    } else {
                        isHealthy = false;
                        deferred.reject('Invalid health status');
                    }
                })
                .catch(function (error) {
                    isHealthy = false;
                    deferred.reject(error);
                })
                .finally(function () {
                    healthCheckPromise = null;
                });

            return deferred.promise;
        }

        function clearSession() {
            const deferred = $q.defer();

            if (!sessionId) {
                resetMessages().then(function () {
                    deferred.resolve();
                });
                return deferred.promise;
            }

            const requestBody = {
                sessionId: sessionId
            };

            RestUpgrade.all(CHAT_ENDPOINT).customOperation("remove", null, null, { 'Content-Type': 'application/json' }, requestBody)
                .then(function (response) {
                    sessionId = null;
                    resetMessages().then(function () {
                        deferred.resolve(response);
                    });
                })
                .catch(function (error) {
                    sessionId = null;
                    resetMessages().then(function () {
                        deferred.reject(error);
                    });
                });

            return deferred.promise;
        }

        function getCarContext() {
            const carContext = CacheService.getCarContext();

            if (carContext && !_.isEmpty(carContext)) {
                return carContext;
            }

            return {
                vin: null,
                registrationNumber: null
            };
        }

        function getUserContext() {
            const user = CacheService.getObject(CacheConstants.profil);

            return {
                language: user.documentationFirstLanguage.code.includes("-") ? user.documentationFirstLanguage.code.substr(0, 2) : user.documentationFirstLanguage.code,
                countryReferenceLanguage: user.documentationFirstLanguage.countryCode,
                substitutionLanguage: user.documentationSecondLanguage.code.includes("-") ? user.documentationSecondLanguage.code.substr(0, 2) : user.documentationSecondLanguage.code,
                countryReferenceLanguageSubstitution: user.documentationSecondLanguage.countryCode,
                countryCode: user.country,
                userProfiles: user.profiles
            };
        }

        function sendMessage(message) {
            const deferred = $q.defer();
            let requestBody;

            if (sessionId) {
                requestBody = {
                    sessionId: sessionId,
                    message: message
                };
            } else {
                const carContext = getCarContext();

                if (!carContext.vin) {
                    const errorResponse = {
                        id: Date.now(),
                        type: 'bot',
                        content: $translate.instant('FAV_TOASTR_INFO_MISSING_CONTEXT'),
                        timestamp: new Date()
                    };
                    deferred.resolve(errorResponse);
                    return deferred.promise;
                }

                requestBody = {
                    query: message,
                    carContext: carContext,
                    userContext: getUserContext()
                };
            }

            RestUpgrade.all(CHAT_ENDPOINT).post(requestBody)
                .then(function (response) {
                    if (response.sessionId) {
                        sessionId = response.sessionId;
                    }

                    const selectedParts = response.selectedParts || [];
                    const suggestedParts = response.suggestedParts || [];
                    const messageContent = response.assistantReply || response.assistant_reply || 'I received your message but couldn\'t generate a response.';

                    const uniqueParts = [];
                    const allPartsFlat = [];
                    const seenReferences = {};
                    let totalParts = 0;

                    const allParts = [...selectedParts, ...suggestedParts];

                    if (allParts.length > 0) {
                        allParts.forEach(function (part) {
                            const key = `${part.reference}_${part.genericPart || ''}`;
                            if (!seenReferences[key]) {
                                seenReferences[key] = true;
                                uniqueParts.push(part);

                                allPartsFlat.push({
                                    reference: part.reference,
                                    designation: part.designation,
                                    brand: part.brand,
                                    initialReference: part.initialReference,
                                    genericPart: part.genericPart,
                                    catalogPlates: part.catalogPlates || [],
                                    designationLanguage: part.designationLanguage
                                });
                                totalParts++;

                                if (part.alternative && part.alternative.length > 0) {
                                    part.alternative.forEach(function (altPart) {
                                        allPartsFlat.push({
                                            reference: altPart.reference,
                                            designation: altPart.designation,
                                            brand: altPart.brand,
                                            catalogPlates: altPart.catalogPlates || [],
                                            designationLanguage: altPart.designationLanguage,
                                            isAlternative: true
                                        });
                                        totalParts++;
                                    });
                                }
                            }
                        });
                    }

                    const botResponse = {
                        id: Date.now(),
                        type: 'bot',
                        content: messageContent,
                        timestamp: new Date(),
                        sessionId: sessionId,
                        selectedParts: selectedParts,
                        suggestedParts: suggestedParts,
                        partsContext: uniqueParts,
                        partsDetails: {
                            references: allPartsFlat,
                            totalCount: totalParts
                        },
                        totalParts,
                        hasPartsPlaceholder: messageContent.indexOf('{parts}') !== -1
                    };

                    deferred.resolve(botResponse);
                })
                .catch(function () {
                    const fallbackResponse = {
                        id: Date.now(),
                        type: 'bot',
                        content: $translate.instant('CHATBOT_API_ERROR'),
                        timestamp: new Date()
                    };
                    deferred.resolve(fallbackResponse);
                });

            return deferred.promise;
        }

        function getPartsByGenericCodes(genericCodes) {
            const deferred = $q.defer();

            if (!genericCodes || genericCodes.length === 0) {
                deferred.reject('No generic codes provided');
                return deferred.promise;
            }

            const body = {
                userContext: getUserContext(),
                carContext: getCarContext(),
                listOfGenericParts: genericCodes
            };

            DocumentsWsService.getPartsByGenericParts(body)
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .directive('ndChatbot', ndChatbotDirective);

    /** @ngInject */
    function ndChatbotDirective() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/chatbot/chatbot.html',
            controller: 'ChatbotController',
            controllerAs: 'chatbotCtrl',
            bindToController: true,
            scope: {},
            link: function(scope, element, attrs) {
                // Any additional linking logic can go here
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('ChatbotController', chatbotController);

    /** @ngInject */
    function chatbotController($timeout, ChatbotService, RoutingService, configConstantes, $mdDialog, $rootScope) {
        const vm = this;
        const EVENT_BROADCAST_DELAY = 300;

        vm.isExpanded = false;
        vm.messageInput = '';
        vm.isTyping = false;
        vm.isHealthy = false;
        vm.isHealthChecking = true;
        vm.isNDAssistantEnabled = JSON.parse(configConstantes.isNDAssistantEnabled);
        vm.messages = ChatbotService.getMessages();
        vm.chatWidth = 535;
        vm.chatHeight = 535;
        vm.minWidth = 350;
        vm.minHeight = 400;
        vm.isResizing = false;
        vm.resizeDirection = null;
        vm.startX = 0;
        vm.startY = 0;
        vm.startWidth = 0;
        vm.startHeight = 0;

        vm.toggleChatbot = toggleChatbot;
        vm.sendMessage = sendMessage;
        vm.onEnterKey = onEnterKey;
        vm.formatTimestamp = formatTimestamp;
        vm.startNewChat = startNewChat;
        vm.goToProduct = goToProduct;
        vm.getAssistantReply = getAssistantReply;
        vm.goToCatalogPlate = goToCatalogPlate;
        vm.getCatalogPlateIds = getCatalogPlateIds;
        vm.startResize = startResize;
        vm.doResize = doResize;
        vm.stopResize = stopResize;
        vm.getMessageBeforeParts = getMessageBeforeParts;
        vm.getMessageAfterParts = getMessageAfterParts;
        vm.hasPartsPlaceholder = hasPartsPlaceholder;

        init();
        

        function init() {
            if (!vm.isNDAssistantEnabled) {
                vm.isHealthy = false;
                vm.isHealthChecking = false;
                return;
            }

            if (vm.messages.length > 1 && !ChatbotService.hasActiveSession()) {
                ChatbotService.resetMessages();
            }

            ChatbotService.checkHealth()
                .then(function () {
                    vm.isHealthy = true;
                    vm.isHealthChecking = false;
                })
                .catch(function () {
                    vm.isHealthy = false;
                    vm.isHealthChecking = false;
                });

            $timeout(function () {
                scrollToBottom();
            }, 100);
        }

        function toggleChatbot() {
            if (!vm.isExpanded) {
                vm.isExpanded = true;
                
                if (vm.messages.length === 0) {
                    const carContext = ChatbotService.getCarContext();
                    if (carContext.vin) {
                        vm.isTyping = true;
                        ChatbotService.loadWelcomeMessage().then(function() {
                            vm.isTyping = false;
                            $timeout(function () {
                                scrollToBottom();
                                focusInput();
                            }, 100);
                        }).catch(function() {
                            vm.isTyping = false;
                        });
                    } else {
                        $timeout(function () {
                            scrollToBottom();
                            focusInput();
                        }, 100);
                    }
                } else {
                    $timeout(function () {
                        scrollToBottom();
                        focusInput();
                    }, 100);
                }
            } else {
                vm.isExpanded = false;
            }
        }

        function startNewChat() {
            vm.isTyping = true;
            ChatbotService.clearSession()
                .then(function () {
                    vm.isTyping = false;
                    scrollToBottom();
                })
                .catch(function () {
                    vm.isTyping = false;
                    scrollToBottom();
                });
        }

        function sendMessage() {
            if (!vm.messageInput.trim()) {
                return;
            }

            const userMessage = {
                id: vm.messages.length + 1,
                type: 'user',
                content: vm.messageInput,
                timestamp: new Date()
            };

            ChatbotService.addMessage(userMessage);
            vm.messageInput = '';
            vm.isTyping = true;

            ChatbotService.sendMessage(userMessage.content)
                .then(function (botResponse) {
                    vm.isTyping = false;
                    ChatbotService.addMessage(botResponse);
                    scrollToBottom();
                })
                .catch(function () {
                    vm.isTyping = false;
                });

            scrollToBottom();
            focusInput();
        }

        function onEnterKey($event) {
            if ($event.keyCode === 13 && !$event.shiftKey) {
                $event.preventDefault();
                sendMessage();
            }
        }

        function scrollToBottom() {
            $timeout(function () {
                const chatMessages = document.querySelector('.chatbot-messages');
                if (chatMessages) {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            }, 50);
        }

        function focusInput() {
            $timeout(function () {
                const input = document.querySelector('.chatbot-input-field');
                if (input) {
                    input.focus();
                }
            }, 100);
        }

        function formatTimestamp(timestamp) {
            if (!timestamp) return '';
            const now = new Date();
            const diff = now - timestamp;

            if (diff < 60000) { // Less than 1 minute
                return 'Just now';
            } else if (diff < 3600000) { // Less than 1 hour
                return Math.floor(diff / 60000) + ' min ago';
            } else if (diff < 86400000) { // Less than 24 hours
                return Math.floor(diff / 3600000) + ' hour ago';
            } else {
                return timestamp.toLocaleDateString();
            }
        }

        /**
         * Navigate to product details page
         * @param {Object} piece - The part/reference object
         */
        function goToProduct(piece) {
            if (!piece || !piece.reference) {
                return;
            }

            vm.isExpanded = false;

            RoutingService.goToProductPage({
                path: {
                    reference: piece.reference,
                    mainReference: piece.reference
                }
            });
        }

        /**
         * Extract the assistant reply portion from message content
         * (Everything before the "---" separator)
         * @param {string} content - The full message content
         * @returns {string} The assistant reply text
         */
        function getAssistantReply(content) {
            if (!content) return '';
            const separatorIndex = content.indexOf('\n\n---\n\n');
            if (separatorIndex === -1) return content;
            return content.substring(0, separatorIndex);
        }

        /**
         * Get catalog plate IDs as a comma-separated string for tooltip
         * @param {Object} part - The part object with catalogPlates
         * @returns {string} Comma-separated plate IDs
         */
        function getCatalogPlateIds(part) {
            if (!part || !part.catalogPlates || part.catalogPlates.length === 0) {
                return '';
            }
            return part.catalogPlates.map(function(plate) {
                return plate.id;
            }).join(', ');
        }

        /**
         * Navigate to catalog plate view
         * @param {Object} part - The part object with catalogPlates
         * @param {Array} allParts - All parts in the message for context
         */
        function goToCatalogPlate(part, allParts) {
            if (!part || !part.catalogPlates || part.catalogPlates.length === 0) {
                return;
            }
            part.catalogPlateClick = true;

            const plateIds = _.map(part.catalogPlates, 'id');
            
            let relatedReferences = [];
            if (allParts && allParts.length > 0) {
                allParts.forEach(function(p) {
                    if (p.catalogPlates && p.catalogPlates.length > 0) {
                        const partPlateIds = _.map(p.catalogPlates, 'id');
                        if (_.intersection(plateIds, partPlateIds).length > 0) {
                            relatedReferences.push(p.reference);
                        }
                    }
                });
            }
            relatedReferences = _.uniq(relatedReferences);

            vm.isExpanded = false;

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/components/car/carSearchResult/easyBasket/catalogPlate.template.html',
                controller: 'ListePieceCtrl',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                size: 'lg',
                skipHide: true,
                multiple: true,
                windowClass: 'my-modal-popup',
                locals: {
                    plateId: plateIds,
                    selectedReference: part.reference
                },
                resolve: {
                    disconnect() {
                        $timeout(function () {
                            $rootScope.$broadcast('phx-init-listPR', plateIds, part.reference, relatedReferences, part);
                        }, EVENT_BROADCAST_DELAY);
                    }
                }
            });
        }

        function startResize($event, direction) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.isResizing = true;
            vm.resizeDirection = direction;
            vm.startX = $event.clientX;
            vm.startY = $event.clientY;
            vm.startWidth = vm.chatWidth;
            vm.startHeight = vm.chatHeight;

            const widget = document.querySelector('.chatbot-widget');
            if (widget) {
                widget.classList.add('chatbot-resizing');
            }

            angular.element(document).on('mousemove', vm.doResize);
            angular.element(document).on('mouseup', vm.stopResize);
        }

        function doResize($event) {
            if (!vm.isResizing) return;

            const deltaX = $event.clientX - vm.startX;
            const deltaY = $event.clientY - vm.startY;
            const direction = vm.resizeDirection;

            let newWidth = vm.startWidth;
            let newHeight = vm.startHeight;

            if (direction.includes('e')) {
                newWidth = vm.startWidth + deltaX;
            }
            if (direction.includes('w')) {
                newWidth = vm.startWidth - deltaX;
            }
            if (direction.includes('s')) {
                newHeight = vm.startHeight + deltaY;
            }
            if (direction.includes('n')) {
                newHeight = vm.startHeight - deltaY;
            }

            const maxWidth = window.innerWidth * 0.9;
            const maxHeight = window.innerHeight * 0.9;

            newWidth = Math.max(vm.minWidth, Math.min(newWidth, maxWidth));
            newHeight = Math.max(vm.minHeight, Math.min(newHeight, maxHeight));

            vm.chatWidth = newWidth;
            vm.chatHeight = newHeight;

            $timeout(function() {
            }, 0);
        }

        function stopResize() {
            if (!vm.isResizing) return;

            vm.isResizing = false;
            vm.resizeDirection = null;

            const widget = document.querySelector('.chatbot-widget');
            if (widget) {
                widget.classList.remove('chatbot-resizing');
            }

            angular.element(document).off('mousemove', vm.doResize);
            angular.element(document).off('mouseup', vm.stopResize);

            $timeout(function() {
                scrollToBottom();
            }, 50);
        }

        function hasPartsPlaceholder(content) {
            return content && content.indexOf('{parts}') !== -1;
        }

        function getMessageBeforeParts(content) {
            if (!content) return '';
            const index = content.indexOf('{parts}');
            if (index === -1) return content;
            return content.substring(0, index);
        }

        function getMessageAfterParts(content) {
            if (!content) return '';
            const index = content.indexOf('{parts}');
            if (index === -1) return '';
            return content.substring(index + '{parts}'.length);
        }
    }
})();

(function () {
    angular.module('phenix').constant('CodesConstants', {
        brand: '336',
        familyVehicle: '007',
        bodyType: '008',
        engineType: '999',
        gearBoxType: '997',
        batteryType: '968',
        engineSuffix: '998',
        gearboxSuffix: '996',
        batterySuffix: '966',
        tractionBattery: '968',
        steeringWheelLocation: '027',
        vehiculeVersion: '013',
        equipmentLevel: '513',
        heatingSystem: '046',
        gas: '019',
        VOI: '755',
        listCountryRegisterNumber: ["IT", "FR", "PT", "NL", "GB","BR", "IE", "AR", "RE", "GP", "MQ", "GF","CO"],

        ONE_ORDER_TYPE: 0,
        MULTIPLES_ORDERS_TYPES: 2
    })
})();

(function () {

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, RoutesConstants) {
    $stateProvider
      .state(RoutesConstants.panier, {
        url: '/panier',
        templateUrl: 'app/components/basket/panier.html',
        controller: 'panierCtrl',
        controllerAs: 'panierCtrl'
      });
  }
})();

/**
 * Panier Controller
 * @namespace Controllers
 */
(function () {
    "use strict";

    angular.module("phenix").controller("panierCtrl", panierCtrl).config(function($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function(date) {
            var m = moment(date);
           return m.isValid()? m.format("YYYY-MM-DD") : '';
        };
    });

    /**
     * @namespace panierCtrl
     * @desc Display Panier data ...
     * @memberOf Controllers
     */

    /* @ngInject */
    function panierCtrl(
        CacheConstants,
        RoutesConstants,
        PanierConstants,
        globalConstant,
        CarSearchConstants,
        CacheService,
        ShoppingCartService,
        ProductMetierService,
        DocumentsMetierService,
        SuperCartMetierService,
        CarSearchMetierService,
        $scope,
        $translate,
        $state,
        $mdDialog,
        $q,
        $rootScope,
        toastr,
        blockUI,
        ShoppingCartWSService,
        DealerManagerSystemeService,
        configConstantes,
        ShoppingCartServiceConstant,
        MainMetierService,
        printPdfModalService,
        UtilsMetierService,
        $filter,
        SearchArboTextualWsService,
        SearchArboTextualMetierService,
        FileSaver,$log,$timeout
    ) {
        /*=============================================
        =                 VARIABLES                   =
        =============================================*/
        var vm = this;

        vm.vehicle = null;
        vm.panier = {};
        vm.cartMedatadata = {};
        var priceOrderList = [];
        var stockOrderList = [];
        /**
         *  GLOBAL PRIVATE VARIABLE ONLY VALABLE IN CONTROLLER
         */

        var _actions = ShoppingCartService.constants;
        var _essai = ShoppingCartServiceConstant.essai;
        /**
         *  BIND TO CONTROLER USING IN HTML
         */

        vm.closeCart = closeCart;
        vm.goBack = goBack;
        vm.saveCart = saveCart;
        vm.goToProductPage = goToProductPage;
        vm.copyToClipboard = copyToClipboard;
        vm.displayModal = displayModal;
        vm.deletedDesignation = deletedDesignation;
        vm.deleteByDesignation = deleteByDesignation;
        vm.onConfirm = onConfirm;
        vm.updateShoppingCartMetadata = updateShoppingCartMetadata;
        vm.downloadCSV = downloadCSV;
        vm.printCart = printCart;
        vm.computedPieceAndUpdateCart = computedPieceAndUpdateCart;
        vm.addRef = addRef;
        vm.ref = "";
        vm.displayDiscountRate = displayDiscountRate;
        vm.displayAllDiscountRate = displayAllDiscountRate;
        vm.showAllDiscountRate = false;
        vm.isOrderingModuleEnable = false;
        vm.isRpartsRole = MainMetierService.isRpartsRole();
        vm.isRNETUser = false;
        vm.isDmsConnected = false;
        vm.showGetPriceColumns = false;
        vm.countryCode=null;
        var userProfil = CacheService.getUserProfile();
        vm.isWorkshop = userProfil ? DealerManagerSystemeService.isWorkshop(userProfil) : false;
        vm.estimateGroupData = [];
        vm.quote = {
            selectedPricingDetails: null
        };
        vm.isIndependantUser = userProfil ? MainMetierService.isIndependantUser(userProfil.roles): null;
        vm.isSearchByModel = MainMetierService.isSearchByModel();
        vm.declareToRenault = declareToRenault;
        vm.onCancel = onCancel;
        vm.onValidate = onValidate;
        vm.isCarcontext = CacheService.getCarContext();
        vm.contextCarBrandCheck = MainMetierService.rnetUserBrandCheck();
        vm.operationalDetailsMileage = "";
        vm.operationalDetailsInvoice = "";
        vm.operationalDetailsFacture ="";
        vm.operationalDetailsTitle ="";
        vm.operationalDetailsDescription="";
        vm.onChange = onChange;
        vm.onChangeData = onChangeData;
        vm.handleKeydown = handleKeydown;
        vm.startDate = null;
        vm.checkDealerList = checkDealerList;
        vm.validateOrder = validateOrder;
        vm.r2aPriceResponse = null;
        var cacheProfile = CacheService.getObject(CacheConstants.profil);
        vm.isUrgentCountry = (cacheProfile.country == 'BE');
        vm.isCountryChina = UtilsMetierService.isCountryTargeted('CN');
        vm.isCountryIndia = UtilsMetierService.isCountryTargeted('IN');
        vm.isCountryRoumania = UtilsMetierService.isCountryTargeted('RO');
        var rpartsRedirectUrl = configConstantes.rpartsUrl;
        vm.isNonDmsOrderModeEnable = UtilsMetierService.isNonDMSDealerAuthorised();
        vm.urgentOrderChange = urgentOrderChange;
        vm.getLabelText = getLabelText;
        vm.getPlaceholderText = getPlaceholderText;
        vm.userProfil = CacheService.getUserProfile();
        vm.chooseNodeLevelOne = chooseNodeLevelOne;
        vm.chooseNodeLevelTwo = chooseNodeLevelTwo;
        vm.nodesLevelOne =  [];
        vm.nodesLevelTwo =  [];
        vm.chilNodeLevel1 = [];
        vm.arrNodesElement = [];
        vm.operationText = operationText;
        vm.showNewButtons = showNewButtons;
        vm.disableCalculation = disableCalculation;
        vm.copyToClipboardNew = copyToClipboardNew;
        vm.onCalculBasket = onCalculBasket;
        vm.hasMissingHourlyRate = hasMissingHourlyRate;
        vm.getCurrencyForItem = getCurrencyForItem;
        vm.subTotalExclTaxPr = subTotalExclTaxPr;
        vm.initBasketFocus = initBasketFocus;
        vm.formatReferenceInput = formatReferenceInput;
        vm.onEstimateGroupChange = onEstimateGroupChange;
        vm.isDisplayOldTab  = true;
        vm.showPricingSection = MainMetierService.shouldShowPricingSection(vm.userProfil);
        vm.isEnableButtonVisible = true;
        vm.areNewButtonsVisible = false;
        vm.estimateGroupId = null;
        var orderModeClosePopup = 'app/components/orderModule/orderModeClosePopup.html';
        vm.isEstimateCalculation = JSON.parse(configConstantes.isEstimateCalculation);
        vm.isRNETUser = cacheProfile.userType == "RNET" ? true : false;
        vm.isDmsConnected = cacheProfile.dmsConnected ? true : false;
        var isProcessingEstimateGroup = false;
        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/


        $rootScope.$on('bannerDataLoaded', function () {
            vm.bannerData = CarSearchMetierService.getBannerDetails();
        });
        /**
         * @name init
         * @desc Get copy of Panier from ShoppingCartService
         * @returns {array} list of Products (PR, TM..)
         * @memberOf Controllers.TmDocumentsController
         */

        this.$onInit = function () {
            getLastUpdateCart(true);
            var context = CacheService.getObject(
                CacheConstants.contextCarSearch
            );
            if (context && context.vehicle) {
                vm.vehicle = context.vehicle;
                vm.bannerData = CarSearchMetierService.getBannerDetails();
            }

            $rootScope.$on(ShoppingCartService.event.cartUpdated, function () {
                vm.prCalculDone = false;
                
                if (vm.areNewButtonsVisible) {
                    if (vm.panier && vm.panier.pr && vm.panier.pr.length > 0) {
                        vm.panier.pr.forEach(function(item) {
                            item.netAmountExclTax = null;
                            item.totalTax = null;
                            item.netTotalAmtWithTax = null;
                        });
                        vm.panier.pr.subTotalExclTaxPrTm = null;
                    }
                    
                    if (vm.panier && vm.panier.tm && vm.panier.tm.length > 0) {
                        vm.panier.tm.forEach(function(item) {
                            item.netAmountExclTax = null;
                            item.totalTax = null;
                            item.netTotalAmtWithTax = null;
                            item.totalHourlyRate = null;
                        });
                        vm.panier.tm.subTotalExclTaxPrTm = null;
                    }

                    if(vm.panier && vm.panier.inter && vm.panier.inter.length > 0){
                        vm.panier.inter.forEach(function(item){
                            if(item.PR && item.PR.length > 0){
                                item.PR.forEach(function(prItem){
                                    prItem.netAmountExclTax = null;
                                    prItem.totalTax = null;
                                    prItem.netTotalAmtWithTax = null;
                                })
                            }
                            if(item.TM && item.TM.length > 0){
                                item.TM.forEach(function(tmItem){
                                    tmItem.netAmountExclTax = null;
                                    tmItem.totalTax = null;
                                    tmItem.netTotalAmtWithTax = null;
                                    tmItem.totalHourlyRate = null;
                                })
                            }
                        })
                    }
                    
                    vm.panier.grossTotalAmt = null;
                    vm.panier.netTotalAmt = null;
                    vm.panier.totalTax = null;
                    vm.panier.totalAmtInclTax = null;
                }
                
                getLastUpdateCart(false);
                
                if (vm.areNewButtonsVisible && vm.quote.selectedPricingDetails && !isProcessingEstimateGroup) {
                    isProcessingEstimateGroup = true;
                    onEstimateGroupChange(false);
                }
            });
            if(vm.isNonDmsOrderModeEnable && vm.isRpartsRole){
                checkDealerList(null);
                CacheService.setObject(CacheConstants.newNonDmsOrderStart, moment(new Date()));
            }
            if(vm.maintenanceProgram && vm.isIndependantUser){
                getFixedFilteredTreeResponse();
            }
           
        };

        function hasMissingHourlyRate() {
            var missingInTm = vm.panier && vm.panier.tm && vm.panier.tm.some(function(tm) {
                return !tm.hourlyRate && tm.hourlyRate !== 0;
            });
            var missingInInter = vm.panier && vm.panier.inter && vm.panier.inter.some(function(interGroup) {
                return interGroup.TM && interGroup.TM.some(function(tm) {
                    return !tm.hourlyRate && tm.hourlyRate !== 0;
                });
            });
            return missingInTm || missingInInter;
        }

        function _hasAnyPrItems() {
            var hasStandalonePr = vm.panier && vm.panier.pr && vm.panier.pr.length > 0;
            var hasInterPr = vm.panier && vm.panier.inter && vm.panier.inter.some(function(g) { return g.PR && g.PR.length > 0; });
            return hasStandalonePr || hasInterPr;
        }
        vm.hasAnyPrItems = _hasAnyPrItems;

        function _isBasketEmpty() {
            var noPr = !vm.panier || !vm.panier.pr || vm.panier.pr.length === 0;
            var noTm = !vm.panier || !vm.panier.tm || vm.panier.tm.length === 0;
            var noInter = !vm.panier || !vm.panier.inter || vm.panier.inter.length === 0;
            return noPr && noTm && noInter;
        }
        vm.isBasketEmpty = _isBasketEmpty;

        function onCalculBasket() {
            vm.basketCurrency = '';
            if (vm.panier && !_.isEmpty(vm.panier.pr)) {
                vm.basketCurrency = vm.panier.pr[0].currency;
                vm.prCalculDone = true;
                vm.panier.pr.forEach(function (item) {
                    if (item.discount && item.priceHT && item.quantity) {
                        item.netAmountExclTax = (item.priceHT * item.quantity) - ((item.priceHT * item.quantity) * (item.discount / 100))
                    } else {
                        item.netAmountExclTax = (item.priceHT && item.quantity) ? (item.priceHT * item.quantity) : ""
                    }
                    item.totalTax = (item.tax && item.netAmountExclTax) ? ((item.tax * item.netAmountExclTax) / 100) : "";
                    item.netTotalAmtWithTax = (item.netAmountExclTax && item.totalTax) ? (item.netAmountExclTax + item.totalTax) : ""
                })

                subTotalExclTaxPr(vm.panier.pr);
            }

            if (vm.panier && !_.isEmpty(vm.panier.tm)) {
                vm.prCalculDone = true;
                vm.panier.tm.forEach(function (item) {
                    if (item.hourlyRate && item.duration) {
                        item.totalHourlyRate = item.hourlyRate * parseFloat(item.duration.replace(",", "."))
                    }

                    if (item.discount && item.totalHourlyRate && item.quantity) {
                        item.netAmountExclTax = (item.totalHourlyRate * item.quantity) - ((item.totalHourlyRate * item.quantity) * (item.discount / 100))
                    } else {
                        item.netAmountExclTax = (item.totalHourlyRate && item.quantity) ? (item.totalHourlyRate * item.quantity) : ""
                    }
                    item.totalTax = (item.tax && item.netAmountExclTax) ? ((item.tax * item.netAmountExclTax) / 100) : "";
                    item.netTotalAmtWithTax = (item.netAmountExclTax && item.totalTax) ? (item.netAmountExclTax + item.totalTax) : ""
                })

                subTotalExclTaxPr(vm.panier.tm);
            }
            
            if (!_.isEmpty(vm.panier)) {
                var netTotalPr = (vm.panier.pr && vm.panier.pr.subTotalExclTaxPrTm) ? vm.panier.pr.subTotalExclTaxPrTm : 0;
                var netTotalTm = (vm.panier.tm && vm.panier.tm.subTotalExclTaxPrTm) ? vm.panier.tm.subTotalExclTaxPrTm : 0;
                var netTotalTaxTm = (vm.panier.tm && vm.panier.tm.netTotalTax) ? vm.panier.tm.netTotalTax : 0;
                var netTotalTaxPr = (vm.panier.pr && vm.panier.pr.netTotalTax) ? vm.panier.pr.netTotalTax : 0;
                var sumGupTotalTm = (vm.panier.tm && vm.panier.tm.totalHourlyRate) ? vm.panier.tm.totalHourlyRate : 0;
                var sumGupTotalPr = (vm.panier.pr && vm.panier.pr.sumGupTotal) ? vm.panier.pr.sumGupTotal : 0;

                // Process inter groups
                var netTotalInter = 0;
                var netTotalTaxInter = 0;
                var grossTotalInter = 0;
                if (vm.panier.inter && vm.panier.inter.length > 0) {
                    vm.prCalculDone = true;
                    vm.panier.inter.forEach(function(interGroup) {
                        var groupNetTotal = 0;
                        var groupTaxTotal = 0;
                        var groupGrossTotal = 0;

                        if (interGroup.PR && interGroup.PR.length > 0) {
                            if (!vm.basketCurrency && interGroup.PR[0].currency) {
                                vm.basketCurrency = interGroup.PR[0].currency;
                            }
                            interGroup.PR.forEach(function(item) {
                                if (item.discount && item.priceHT && item.quantity) {
                                    item.netAmountExclTax = (item.priceHT * item.quantity) - ((item.priceHT * item.quantity) * (item.discount / 100));
                                } else {
                                    item.netAmountExclTax = (item.priceHT && item.quantity) ? (item.priceHT * item.quantity) : 0;
                                }
                                item.totalTax = (item.tax && item.netAmountExclTax) ? ((item.tax * item.netAmountExclTax) / 100) : 0;
                                groupNetTotal += Number(item.netAmountExclTax) || 0;
                                groupTaxTotal += Number(item.totalTax) || 0;
                                groupGrossTotal += (Number(item.priceHT) || 0) * (Number(item.quantity) || 1);
                            });
                        }

                        if (interGroup.TM && interGroup.TM.length > 0) {
                            interGroup.TM.forEach(function(item) {
                                if (item.hourlyRate && item.duration) {
                                    item.totalHourlyRate = item.hourlyRate * parseFloat(String(item.duration).replace(",", "."));
                                }
                                if (item.discount && item.totalHourlyRate && item.quantity) {
                                    item.netAmountExclTax = (item.totalHourlyRate * item.quantity) - ((item.totalHourlyRate * item.quantity) * (item.discount / 100));
                                } else {
                                    item.netAmountExclTax = (item.totalHourlyRate && item.quantity) ? (item.totalHourlyRate * item.quantity) : 0;
                                }
                                item.totalTax = (item.tax && item.netAmountExclTax) ? ((item.tax * item.netAmountExclTax) / 100) : 0;
                                groupNetTotal += Number(item.netAmountExclTax) || 0;
                                groupTaxTotal += Number(item.totalTax) || 0;
                                groupGrossTotal += Number(item.totalHourlyRate) || 0;
                            });
                        }

                        interGroup.subTotalExclTax = groupNetTotal;
                        netTotalInter += groupNetTotal;
                        netTotalTaxInter += groupTaxTotal;
                        grossTotalInter += groupGrossTotal;
                    });
                }

                vm.panier.grossTotalAmt = Number(sumGupTotalPr) + Number(sumGupTotalTm) + Number(grossTotalInter);
                vm.panier.netTotalAmt = Number(netTotalPr) + Number(netTotalTm) + Number(netTotalInter);
                vm.panier.totalTax = Number(netTotalTaxPr) + Number(netTotalTaxTm) + Number(netTotalTaxInter);
                vm.panier.totalAmtInclTax = Number(vm.panier.netTotalAmt) + Number(vm.panier.totalTax);

                var interPrHasUnknown = vm.panier.inter && vm.panier.inter.some(function(interGroup) {
                    return interGroup.PR && interGroup.PR.some(function(item) { return !item.priceHT; });
                });
                vm.unknowPartsNotCalculated = (vm.panier.pr && vm.panier.pr.some(function(item) { return !item.priceHT; })) || interPrHasUnknown;
            }
        }

        function subTotalExclTaxPr(data) {
            var totalNetAmount = 0;
            var totalNetTax = 0;
            var gupExclTax = 0;
            var totalHourlyRate = 0;
            if (data) {
                angular.forEach(data, function (item) {
                    if (item.netAmountExclTax) {
                        totalNetAmount += Number(item.netAmountExclTax);
                    }
                    if (item.totalTax) {
                        totalNetTax += Number(item.totalTax);
                    }
                    if (item.priceHT) {
                        gupExclTax += Number(item.priceHT);
                    }
                    if (item.totalHourlyRate) {
                        totalHourlyRate += Number(item.totalHourlyRate);
                    }
                });
                data.subTotalExclTaxPrTm = totalNetAmount;
                data.netTotalTax = totalNetTax;
                data.sumGupTotal = gupExclTax;
                data.totalHourlyRate = totalHourlyRate;
            }
        }
        function getCurrencyForItem() {
            vm.userProfile = CacheService.getUserProfile();
            var countryExceptionArray = globalConstant.countryCurrencyException;
            var country = (vm.userProfile && vm.userProfile.country) ? vm.userProfile.country : null;
            if (countryExceptionArray.indexOf(country) == -1) {
                return UtilsMetierService.getCurrencyForItem()
            }
            return "";
        }

        function initBasketFocus() {
            $timeout(function () {
                var inputBox = document.getElementById('reference');
                if (inputBox) {
                    var basketInputBox = angular.element(inputBox);
                    basketInputBox[0] && basketInputBox[0].focus();
                }
            }, 0);
        };

        /**
         * Format reference input in real-time as XX XX XXX XXX (2-2-3-3 grouping)
         * Formats progressively as user types each digit or letter
         * @return {void}
         */
        function formatReferenceInput() {

           var formattedVal =  MainMetierService.formatReferenceInput($scope.ref);
            $scope.ref = formattedVal;
        };



        function showNewButtons(isShowBtn) {
            vm.isDisplayOldTab = false;
            vm.isEnableButtonVisible = false;
            vm.areNewButtonsVisible = true;
            vm.prCalculDone = false;
            if(!_.isEmpty(vm.panier.pr)){
                vm.panier.pr.forEach(function(item){
                    item.tax = null;
                    item.discount = null;
                    item.netAmountExclTax = null;
                })
                vm.panier.pr.subTotalExclTaxPrTm = null;
            }
            if(!_.isEmpty(vm.panier.tm)){
                vm.panier.tm.forEach(function(item){
                    item.tax = null;
                    item.discount = null;
                    item.netAmountExclTax = null;   
                    item.hourlyRate = null;
                })
                vm.panier.tm.subTotalExclTaxPrTm = null;
            }
            if(vm.panier && vm.panier.inter && vm.panier.inter.length > 0){
                vm.panier.inter.forEach(function(interGroup){
                    if(interGroup.PR && interGroup.PR.length > 0){
                        interGroup.PR.forEach(function(item){
                            item.tax = null;
                            item.discount = null;
                            item.netAmountExclTax = null;
                        });
                    }
                    if(interGroup.TM && interGroup.TM.length > 0){
                        interGroup.TM.forEach(function(item){
                            item.tax = null;
                            item.discount = null;
                            item.netAmountExclTax = null;
                            item.hourlyRate = null;
                        });
                    }
                    interGroup.subTotalExclTax = null;
                });
            }
            vm.panier.grossTotalAmt = null;
            vm.panier.netTotalAmt = null;
            vm.panier.totalTax = null;
            vm.panier.totalAmtInclTax = null;
        
            blockUI.start();
            ShoppingCartService.getEstimateGroup().then(function(response){
                if(response && !_.isEmpty(response)){
                    vm.estimateGroupData = response;
                    if(vm.estimateGroupData && vm.estimateGroupData.length > 0){
                        var selectedGroup = vm.estimateGroupData.find(function(group) {
                            return group.selected;
                        });
                        
                        if (!selectedGroup) {
                            selectedGroup = vm.estimateGroupData[0];
                            selectedGroup.selected = true; 
                        }
                        
                        vm.quote.selectedPricingDetails = selectedGroup;
                    }
                }
                
                // Let onEstimateGroupChange handle TM hourlyRate application (standalone + inter)
                // via its own returnTmDocumentsByOpeCode call — same path confirmed working in _reloadPanierAndReapplyEstimate
                onEstimateGroupChange(isShowBtn);
                
            }).catch(function(error){
                $log.debug(error);
            }).finally(function(){
                blockUI.stop();
            });
        }

        function disableCalculation() {
            vm.isDisplayOldTab = true;
            vm.areNewButtonsVisible = false;
            vm.isEnableButtonVisible = true;
        }

        function copyToClipboardNew(data, field, type) {
            if (data !== undefined && data !== null && data !== '') {
                vm.panier[type].forEach(function (item, index) {
                    if (index != 0) {
                        item[field] = data;
                    }
                });
                
                if (vm.areNewButtonsVisible && vm.quote.selectedPricingDetails && 
                    (field === 'tax' || field === 'discount')) {
                    vm.quote.selectedPricingDetails[field] = parseFloat(data) || 0;
                }
            }
        }

        function onEstimateGroupChange(isSelected, tmResponse) {
            
            if (isSelected && vm.areNewButtonsVisible) {
                vm.prCalculDone = false;
                
                if (vm.panier && vm.panier.pr && vm.panier.pr.length > 0) {
                    vm.panier.pr.forEach(function(item) {
                        item.netAmountExclTax = null;
                    });
                    vm.panier.pr.subTotalExclTaxPrTm = null;
                }
                
                if (vm.panier && vm.panier.tm && vm.panier.tm.length > 0) {
                    vm.panier.tm.forEach(function(item) {
                        item.netAmountExclTax = null;
                    });
                    vm.panier.tm.subTotalExclTaxPrTm = null;
                }

                if(vm.panier && vm.panier.inter && vm.panier.inter.length > 0){
                    vm.panier.inter.forEach(function(item){
                        if(item.PR && item.PR.length > 0){
                            item.PR.forEach(function(prItem){
                                prItem.netAmountExclTax = null;
                            })
                        }
                        if(item.TM && item.TM.length > 0){
                            item.TM.forEach(function(tmItem){
                                tmItem.netAmountExclTax = null;
                            })
                        }
                    })
                }
                vm.panier.grossTotalAmt = null;
                vm.panier.netTotalAmt = null;
                vm.panier.totalTax = null;
                vm.panier.totalAmtInclTax = null;
            }

            if (vm.areNewButtonsVisible && vm.quote.selectedPricingDetails) {
                var selectedOption = vm.quote.selectedPricingDetails;
                
                if (vm.panier.pr && vm.panier.pr.length > 0) {
                    vm.panier.pr.forEach(function(item) {
                        if (selectedOption.tax !== undefined) {
                            item.tax = selectedOption.tax;
                        }
                        if (selectedOption.discount !== undefined) {
                            item.discount = selectedOption.discount;
                        }
                    });
                }
                
                if (vm.panier.tm && vm.panier.tm.length > 0) {
                    vm.panier.tm.forEach(function(item) {
                        if (selectedOption.tax !== undefined) {
                            item.tax = selectedOption.tax;
                        }
                        if (selectedOption.discount !== undefined) {
                            item.discount = selectedOption.discount;
                        }
                    });
                    
                    if (tmResponse && tmResponse.TM && vm.quote.selectedPricingDetails) {
                        tmResponse.TM.forEach(function(tmDoc) {
                            if(tmDoc.technicality) {
                                var technicality = tmDoc.technicality.toUpperCase();
                                var hourlyRateFieldName = PanierConstants.hourlyRate + technicality;
                                
                                if(vm.quote.selectedPricingDetails[hourlyRateFieldName] !== undefined) {
                                    if(vm.panier.tm) {
                                        for(var i = 0; i < vm.panier.tm.length; i++) {
                                            if(vm.panier.tm[i].opecod === tmDoc.id) {
                                                vm.panier.tm[i].hourlyRate = vm.quote.selectedPricingDetails[hourlyRateFieldName];
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        });
                        updateHourlyRatesInShoppingCart();
                    } else {
                        var opeCodeList = vm.panier.tm.map(function(tmItem) {
                            return tmItem.opecod;
                        }).filter(function(opecod) {
                            return opecod;
                        });
                        
                        if (opeCodeList.length > 0) {
                            DocumentsMetierService.returnTmDocumentsByOpeCode(opeCodeList).then(function(tmServiceResponse) {
                                if(tmServiceResponse && tmServiceResponse.TM && vm.quote.selectedPricingDetails){
                                    tmServiceResponse.TM.forEach(function(tmDoc) {
                                        if(tmDoc.technicality) {
                                            var technicality = tmDoc.technicality.toUpperCase();
                                            var hourlyRateFieldName = PanierConstants.hourlyRate + technicality;
                                            
                                            if(vm.quote.selectedPricingDetails[hourlyRateFieldName] !== undefined) {
                                                if(vm.panier.tm) {
                                                    for(var i = 0; i < vm.panier.tm.length; i++) {
                                                        if(vm.panier.tm[i].opecod === tmDoc.id) {
                                                            vm.panier.tm[i].hourlyRate = vm.quote.selectedPricingDetails[hourlyRateFieldName];
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                                updateHourlyRatesInShoppingCart();
                            }).catch(function(error) {
                                $log.debug(error);
                                updateHourlyRatesInShoppingCart();
                            });
                        } else {
                            updateHourlyRatesInShoppingCart();
                        }
                    }
                } else {
                    updateHourlyRatesInShoppingCart();
                }

                // Apply tax/discount and hourly rates to inter PR/TM items
                if (vm.panier.inter && vm.panier.inter.length > 0) {
                    var interTmEntries = [];
                    vm.panier.inter.forEach(function(interGroup) {
                        if (interGroup.PR && interGroup.PR.length > 0) {
                            interGroup.PR.forEach(function(item) {
                                if (selectedOption.tax !== undefined) item.tax = selectedOption.tax;
                                if (selectedOption.discount !== undefined) item.discount = selectedOption.discount;
                            });
                        }
                        if (interGroup.TM && interGroup.TM.length > 0) {
                            interGroup.TM.forEach(function(item) {
                                if (selectedOption.tax !== undefined) item.tax = selectedOption.tax;
                                if (selectedOption.discount !== undefined) item.discount = selectedOption.discount;
                                interTmEntries.push({ item: item, group: interGroup });
                            });
                        }
                    });

                    if (interTmEntries.length > 0) {
                        if (tmResponse && tmResponse.TM) {
                            tmResponse.TM.forEach(function(tmDoc) {
                                if (tmDoc.technicality) {
                                    var technicality = tmDoc.technicality.toUpperCase();
                                    var hourlyRateFieldName = PanierConstants.hourlyRate + technicality;
                                    if (vm.quote.selectedPricingDetails && vm.quote.selectedPricingDetails[hourlyRateFieldName] !== undefined) {
                                        interTmEntries.forEach(function(entry) {
                                            if (entry.item.opecod === tmDoc.id) {
                                                entry.item.hourlyRate = vm.quote.selectedPricingDetails[hourlyRateFieldName];
                                            }
                                        });
                                    }
                                }
                            });
                        } else {
                            var interOpeList = interTmEntries.map(function(e) { return e.item.opecod; }).filter(Boolean);
                            if (interOpeList.length > 0) {
                                DocumentsMetierService.returnTmDocumentsByOpeCode(interOpeList).then(function(interTmServiceResponse) {
                                    if (interTmServiceResponse && interTmServiceResponse.TM && vm.quote.selectedPricingDetails) {
                                        interTmServiceResponse.TM.forEach(function(tmDoc) {
                                            if (tmDoc.technicality) {
                                                var technicality = tmDoc.technicality.toUpperCase();
                                                var hourlyRateFieldName = PanierConstants.hourlyRate + technicality;
                                                if (vm.quote.selectedPricingDetails[hourlyRateFieldName] !== undefined) {
                                                    interTmEntries.forEach(function(entry) {
                                                        if (entry.item.opecod === tmDoc.id) {
                                                            entry.item.hourlyRate = vm.quote.selectedPricingDetails[hourlyRateFieldName];
                                                        }
                                                    });
                                                }
                                            }
                                        });
                                    }
                                }).catch(function(error) { $log.debug(error); });
                            }
                        }
                    }
                }
            }
            
            isProcessingEstimateGroup = false;
        }

        function getFixedFilteredTreeResponse(){
            blockUI.start();
            var requestNodesFromCtrl = {
                nodeId: "ALL"
            };
            $q.all([
                SearchArboTextualMetierService.getNodes(),
                SearchArboTextualMetierService.getNodes(requestNodesFromCtrl)
            ]).then(function(response){
                var fixResponseOne = (response && response[0])?response[0]:null;
                var fixResponseTwo = (response && response[1])?response[1]:null;
                vm.nodesLevelOne = (fixResponseOne && fixResponseOne[0].nodes)?fixResponseOne[0].nodes:null;
               vm.levelOne = [];
               var label = 'label';
               for (var i=0;i<vm.nodesLevelOne.length;i++){
                   var item = vm.nodesLevelOne[i];
                   if(label in item){
                       vm.levelOne.push(item[label]);
                   }
               }

               vm.nodesLevelTwo = (fixResponseTwo && fixResponseTwo[0].nodes)?fixResponseTwo[0].nodes:null;

            }).catch(function(err){
                $log.debug($translate.instant('ERROR'));
            }).finally(function(){
                blockUI.stop();
            });

          
            
        }

        function chooseNodeLevelOne(label){
            document.getElementById("descriptionValue").value= "";
            vm.arrNodesElm = [];
            vm.arrNodesLevel1 = [];
            var labelNode = _.find(vm.nodesLevelOne  ,function(x){
                return x.label === label;
            })
            vm.chilNodeLevel1 = $filter("filter")(vm.nodesLevelTwo, { "codeParent": labelNode.nodeId });
        
       var labels = 'label';
        
        for (var i=0;i<vm.chilNodeLevel1.length;i++){
            var item = vm.chilNodeLevel1[i];
            if(labels in item && item.idsDocumentsByType && item.idsDocumentsByType.TM && item.idsDocumentsByType.TM.length>0 ){
                vm.arrNodesLevel1.push(item[labels]);
            }
        }
            
        }

        function chooseNodeLevelTwo(labelTM){
            
            if(labelTM){
            blockUI.start();
            document.getElementById("descriptionValue").value= "";
            vm.arrNodesElm = [];
            vm.arrNodesElement = [];
            var labelTMList = _.find(vm.chilNodeLevel1  ,function(x){
                return x.label === labelTM;
            });
            var tmList = (labelTMList.idsDocumentsByType && labelTMList.idsDocumentsByType.TM)? labelTMList.idsDocumentsByType.TM : null;
            DocumentsMetierService.returnTmDocuments(tmList).then(function(response){
                var elements = response.elements;
                var operations = response.operations;
                for (const [key, value] of Object.entries(elements)){
                    vm.arrNodesElement.push(value.label);

                }
                for (const [key, value] of Object.entries(operations)){
                    vm.arrNodesElement.push(value.label);
                    
                }
                
            }).catch(function(err){
                $log.debug($translate.instant('ERROR'));
            }).finally(function(){
                blockUI.stop();
            });

        }
        else 
        vm.arrNodesElm = [];
        vm.arrNodesElement = [];
        }

        function operationText(label){
        
        var labelText= "";
        for(var labelObj in label){
             labelText += label[labelObj]
             labelText +=" :\n";
            
        }
        document.getElementById("descriptionValue").value=labelText;
        }

        function declareToRenault() {
            var body = angular.element(document.body);
            $mdDialog.show({
                parent: body,
                templateUrl: 'app/components/basket/declareToRenault.html',
                controller: 'panierCtrl',
                bindToController: true,
                controllerAs: 'vm',
               
            }).then(function(confirm){
                vm.operationalDetailsMileage = confirm.operationalDetailsMileage;
                vm.startDate = confirm.startDate;
                vm.operationalDetailsInvoice = confirm.operationalDetailsInvoice;
                
                    blockUI.start();
                    vm.formattedDate = moment(vm.startDate).format("YYYY-MM-DD")
                    ShoppingCartService.sendOperationDetails(vm).then(function(response){

                        declareCart();
                    }).catch(function(err){
                        toastr.error(err);
                    }).finally(function(){
                        blockUI.stop();
                    })
                       
                    
            })
        }
        function onCancel() {
            $mdDialog.cancel();
        }
        function onValidate(data){
            var isDateEmpty = 0;
            var isMileageEmpty = 0;
            var isInvoiceEmpty = 0;
            var isFactureEmpty =0;
            var isTitleEmpty =0;
            var isdescriptionEmpty =0;
            var isLevelOne = 0;
            var isLevelTwo = 0;
            var iselementsOperations = 0;
            isDateEmpty = vm.onChange(vm.startDate);
            isMileageEmpty = vm.onChange(vm.operationalDetailsMileage);
            isInvoiceEmpty = vm.onChange(vm.operationalDetailsInvoice);
            isFactureEmpty = vm.onChange(vm.operationalDetailsFacture);
            isTitleEmpty = vm.onChange(vm.operationalDetailsTitle);
            isdescriptionEmpty= vm.onChange(vm.operationalDetailsDescription);
            isLevelOne = vm.levelOneNode? vm.levelOneNode :[];
            isLevelTwo = vm.arrNodeslvl ? vm.arrNodeslvl :[];
            iselementsOperations = vm.arrNodesElm ? vm.arrNodesElm :[];

                     if (isDateEmpty === -1) {
                        invalidForm('#dateOfOperation');
                         }
                         else{
                            validForm('#dateOfOperation');
                         }
                         if (isMileageEmpty === -1) {
                            invalidForm('#mileage');
                             }
                             else{
                                validForm('#mileage');
                             }
                             if (isInvoiceEmpty === -1) {
                                invalidForm('#invoiceNumber');
                                 }
                                 else{
                                    validForm('#invoiceNumber');
                                 }
                                 if (isFactureEmpty === -1) {
                                    invalidForm('#factureNumber');
                                     }
                                     else{
                                        validForm('#factureNumber');
                                     }
                                     if (isTitleEmpty === -1) {
                                        invalidForm('#titleValue');
                                         }
                                         else{
                                            validForm('#titleValue');
                                         }
                                         if (isdescriptionEmpty === -1) {
                                            invalidForm('#descriptionValue');
                                             }
                                             else{
                                                validForm('#descriptionValue');
                                             }
                                            if(isLevelOne && isLevelOne.length ===0){
                                                invalidForm('#levelOneValue');
                                                 }
                                                 else{
                                                    validForm('#levelOneValue');
                                                 }
                                                 if(isLevelTwo  && isLevelTwo.length ===0){
                                                    invalidForm('#levelTwoValue');
                                                     }
                                                     else{
                                                        validForm('#levelTwoValue');
                                                     }
                                                     if(iselementsOperations  && iselementsOperations.length ===0){
                                                        invalidForm('#elementsOperationsValue');
                                                        vm.elementsOperationsInvalid = true;
                                                         }
                                                         else{
                                                            validForm('#elementsOperationsValue');
                                                            vm.elementsOperationsInvalid = false;
                                                         }
                    if(!vm.maintenanceProgram && vm.operationalDetailsMileage && vm.startDate && vm.operationalDetailsInvoice != ""){
                    $mdDialog.hide(vm);
                    }
                    else if(vm.maintenanceProgram && vm.isIndependantUser && vm.operationalDetailsMileage && vm.startDate && vm.operationalDetailsFacture != "" && vm.operationalDetailsTitle!= "" && isLevelOne!="" && isLevelTwo!="" && iselementsOperations!="" && vm.operationalDetailsDescription!=""){
                        $mdDialog.hide(vm);
                    }
                    
                }

        function declareCart(){
            blockUI.start();

                ShoppingCartService.declareCart(vm).then(function(response){

                vm.cartMedatadata.declared = response ? response.declared : false;
                ShoppingCartService.updateShoppingCart(
                    _actions.UPDATE_CARTMETADATA,
                    {
                        cartDescription: vm.cartMedatadata
                    }
                );
                toastr.success($translate.instant('OPERATION_RECORDED_SUCCESSFULLY'))
                }).catch(function(err){
                toastr.error(err);
                }).finally(function(){
                blockUI.stop();
                })
            
            }

                             
            
            function invalidForm(id) {
                $(id).css({
                    'border-color': 'red',
                    'border-width': '2px'
                });
            }
            function validForm(id) {
                $(id).css({
                    'border-color': '#cccccc',
                    'border-width': '1px'
                });
            }

            function onChange(userdateInput) {
                if (userdateInput === "" || userdateInput === null || userdateInput ===undefined) {
                    return -1;
                }
                return 0;
            }

        function handleKeydown(event) {
            if (event.key === 'Enter' || event.key === 'Tab') {
                event.preventDefault();
                var nextElement = getNextFocusableElement(event.target);
                if (nextElement) {
                    nextElement.focus();
                }
            }
            else if (event.key === 'Backspace' && vm.areNewButtonsVisible) {
                vm.prCalculDone = false;
            }   
        }

        function getNextFocusableElement(currentElement) {
            // Get all focusable elements
            var focusableElements = Array.from(document.querySelectorAll('input'));
            var index = focusableElements.indexOf(currentElement);
            return focusableElements[index + 1] || null;

        }

        function onChangeData(data, index) {
            $timeout(function () {
                var id = data + index;
                var inputField = document.getElementById(id);
                var invalidChars = [ "-", "+", "e" ];
                    inputField.addEventListener("keypress", function(e) {
                    if (invalidChars.includes(e.key)) {
                      e.preventDefault();
                    }
                  });                  
                if (data.indexOf('hourlyRate') === -1) {
                    var regex = /^\d{0,4}(\.\d{0,2})?$/;
                    if (inputField && !regex.test(inputField.value)) {
                        inputField.value = inputField.value.slice(0, -1);
                    }
                } else {
                    var regex = /^\d{0,5}(\.\d{0,2})?$/;
                    if (inputField && !regex.test(inputField.value)) {
                        inputField.value = inputField.value.slice(0, -1);
                    }
                }
                
                updateSelectedPricingDetails(data, index);
            }, 0);
            if (vm.areNewButtonsVisible) {
                vm.prCalculDone = false;
            }
        }
        function downloadCSV() {
            blockUI.start();           
            
            _.map(vm.panier.pr,function(item){
                if(!_.isEmpty(item.applicableClass)){
                _.extend(item,{
                    applicableClassTranslation : $translate.instant(item.applicableClass)
                });
            }
            });
            
            var headersTranslations = {};
            headersTranslations.reference = $translate.instant('COMMON_COLUMN_REF_TITLE');
            headersTranslations.designation = $translate.instant('COMMON_DESIGNATION');
            if((!vm.showGetPriceColumns && !vm.isIndependantUser )|| (!vm.showGetPriceColumns && vm.isIndependantUser && $rootScope.asomDocList.PX===true)){
                headersTranslations.pubhtTitle = $translate.instant('COMMON_COLUMN_PUBHT_TITLE');
            }else  if((!vm.showGetPriceColumns && !vm.isIndependantUser )) {
                headersTranslations.pubhtTitle = $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("WHOLESALER_GUP_TAX");
            }
                headersTranslations.codeTm = $translate.instant('CODE_TM');
                headersTranslations.timeTm = $translate.instant('COMMON_COLUMN_TIME_TITLE');

            if (vm.showGetPriceColumns) {
                headersTranslations.discountCode = $translate.instant('ORDERING_MODULE_DISCOUNT_CODE');
                headersTranslations.availability = $translate.instant("WHOLESALER_LABEL")+' '+ $translate.instant("R1_AVAILABILITIES");
            }
             
            headersTranslations.quantity = $translate.instant('COMMON_COLUMN_QTE_TITLE');   
            var inputbody = {};
            _.extend(inputbody,{
                partsDetails: vm.panier.pr,
                headersTranslations: headersTranslations
            });
           
            SuperCartMetierService.downloadCSV(vm.cartMedatadata.id, inputbody)
                .then(function (response) {
                    var data = new Blob([response.data],{type:"text/plain;charset=UTF-8"});
                    FileSaver.saveAs(
                        data,
                        response.fileName || vm.cartMedatadata.id
                    );
                })
                .catch(function () {
                    toastr.error($translate.instant("ERROR"));
                })
                .finally(function () {
                    blockUI.stop();
                });
        }

        /**
         *  @desc Will call the business service layer (metier.service.js) in order to generate the pdf file based on information included in the
         *  vm.cartMetadata, vm.panier and vm.vehicle
         *  Basically those contains almost every data that are display in the list basket page
         *
         *  @param  vm.cartMedatadata : information regarding the basket (creation, modification date ...)
         *  @param  vm.panier : list of TM and PR entries that we want to display in the pdf
         *  @param  vm.vehicle : information regarding the vehicle such as VIN, plante number, model ...
         *  @param  {String} type : the type of the superCart (quote, basket, partRequisition)
         *  @param  {String} status : the status of the superCart (draft, validated)
         *  @return promise
         *  response {
         *      data : blob type for the pdf file
         *  }
         */
        function printCart(withRef) {
            blockUI.start();
            var type = globalConstant.cart;
            var status = globalConstant.validated;
            var panierCopy = angular.copy(vm.panier);
            SuperCartMetierService.downloadPdf(vm.cartMedatadata, panierCopy, vm.vehicle, type, status,vm.showGetPriceColumns,withRef,vm.areNewButtonsVisible).then(function (response) {
                pdfMake.tableLayouts = {
                    descTableLayout: {
                        hLineWidth: function () {
                            return 0.1;
                        },
                        vLineWidth: function () {
                            return 0.1;
                        },
                        hLineColor: function () {
                            return 'gray';
                        },
                        vLineColor: function () {
                            return 'gray';
                        },
                    },
                    secondTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 3 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 3 : 1;
                        }
                    },
                    thirdTableLayout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 2 : 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                        }
                    },
                    otherTableLayout: {
                        hLineWidth: function () {
                            return 1;
                        },
                        vLineWidth: function () {
                            return 1;
                        }
                    }

                };
                var pdfDocGenerator = pdfMake.createPdf(response.data);
                pdfDocGenerator.getBuffer(function (buffer) {
                    var file = new Blob([(buffer)], { type: 'application/pdf' });

                    // Internet Explorer 6-11
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;

                    // Edge 20+
                    var isEdge = !isIE && !!window.StyleMedia;

                    if (isIE || isEdge) {
                        FileSaver.saveAs(file,$translate.instant("LOCATION_BASKET") +"-" +
                        ((vm.cartMedatadata.id)?vm.cartMedatadata.id:"") +".pdf");
                    } else {
                        printPdfModalService.encode64Base(file).then(function (response) {
                            var modalParams = {
                                data: response
                            }
                            return printPdfModalService.showModal(modalParams).catch(function () {
                                $log.debug($translate.instant('ERROR'));
                            });
                        }).catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        });
                    }
                })                
            })
            .catch(function (err) {
                toastr.error($translate.instant("ERROR"));
            })
            .finally(function () {
                blockUI.stop();
            });
        }

        /**
         *  @desc Navigate to product
         *  @param {string} ref
         *  @return {void}
         */

        function goToProductPage(ref, genericPart) {
            $state.go(RoutesConstants.product, { reference: ref, genericPart: genericPart });
        }

        function copyToClipboard(reference) {
            UtilsMetierService.copyToClipboard(reference)
        }

        /**
         *  @desc Display modal which will make it possible to remove reference
         *  @param {object} item mandatory
         *  @param {string} type mandatory
         *  @param {boolean} isPPS optional
         *  @param {boolean} mainReference optional | mandatory if isPPS is set
         *  @return {void}
         */

        function displayModal(item, type, isPPS, mainReference) {
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl:
                    "app/components/basket/delete-dialog.template.html",
                controller: "deleteDialog",
                locals: {
                    item: item,
                    pieceType: type,
                    isPPS: isPPS,
                    mainReference: mainReference,
                    onSuccess: deletedSuccess
                },
                bindToController: true,
                controllerAs: "vm",
                clickOutsideToClose: true
            });
        }
        /**
         *  @desc Callback when the delete have successed, reload cart
         */

        function deletedSuccess() {
            vm.panier = splitType(ShoppingCartService.getShoppingCart());
            if(!_.isEmpty(vm.panier)){
                if(!_.isEmpty(vm.panier.pr)){
                    _.remove(vm.panier.pr, { quantity: 0 });
                }
                if(!_.isEmpty(vm.panier.tm)){
                    _.remove(vm.panier.tm, { quantity: 0 });
                }
            }
            if(vm.isNonDmsOrderModeEnable && vm.isRpartsRole){
                var r2aList = CacheService.getObject(CacheConstants.basketList);
                _.map(vm.panier.pr, function(obj) {
                    return _.assign(obj, _.find(r2aList.pr, {reference: obj.reference}));
                }); 
                CacheService.setObject(CacheConstants.basketList, vm.panier);
            }
            var isPanierEmpty = _.isEmpty(vm.panier.pr) && _.isEmpty(vm.panier.tm) && _.isEmpty(vm.panier.inter);
            if (isPanierEmpty) {
                vm.showGetPriceColumns = false;
                vm.isNonDmsOrderModeEnable = false;
            }
            vm.prCalculDone = false;
            if (vm.areNewButtonsVisible && vm.quote && vm.quote.selectedPricingDetails && !isProcessingEstimateGroup) {
                isProcessingEstimateGroup = true;
                onEstimateGroupChange(false);
            }
        }
        /**
         *  @desc Back to previous page
         *  @param {void}
         *  @return {void}
         */
        function onConfirm () {
            var closed = $mdDialog.hide();
            closed.then(function () {
                deletedDesignation(vm.item);
            })
        }
       
        function deleteByDesignation (item,isDelete){
            var parent = angular.element(document.body);
            $mdDialog.show({
                parent: parent,
                templateUrl:
                    "app/components/basket/delete-dialog.template.html",
                    controller: "panierCtrl",
                    locals: {
                        item: item,
                        designation: item.designation,
                        isDelete: isDelete
                    },
                    bindToController: true,
                    controllerAs: "vm",
                    clickOutsideToClose: true
                });
        }

        function deletedDesignation(basketData) {
            var interventionIds = [];
            if(basketData.PR.length > 0) { 
                interventionIds = basketData.PR[0].interventionId;
            } else{
                interventionIds = basketData.TM[0].interventionId;
            }    
            var prList = basketData.PR ? basketData.PR : [];
            var tmList = basketData.TM ? basketData.TM : [];
            var interventionList = tmList.concat(prList);
            var referenceList = [];
            if (!_.isEmpty(interventionList)) {
                interventionList.forEach(function (item) {
                    var reference = _.get(item, 'reference');
                    referenceList.push(reference);
                });
            }
            var payload = {
                references: referenceList
            };

            ShoppingCartService.deleteIntervention(interventionIds, payload).then(function (response) {
                if (response) {
                      response.items.forEach(function(respItem){
                  if(respItem.type == 'PR'){
                    _.assign(respItem,{'priceHT':respItem.price});
                  }
                  else {
                    _.assign(respItem,{duration:respItem.laborTime.toString().replace('.',',')});
                  }
                })

                    ShoppingCartService.setShoppingCart(response.items);
                    ShoppingCartService.emitCartUpdated();
                }
            });
        }
        function goBack() {
            CacheService.removeObject(CacheConstants.basketList);
            CacheService.removeObject(CacheConstants.newNonDmsOrderStart);
            window.history.back();
            $rootScope.panierData = '';
        }

        /**
         *  @desc Prepare cart for save or close operations
         *  @param {void}
         *  @return {void}
         */
        function prepareCartOperation() {
            if (vm.areNewButtonsVisible) {
                onCalculBasket();
            }
            updateHourlyRatesInShoppingCart();
        }

        /**
         *  @desc   We save label, description, clean the actual cart, and back to previous page.
         *          We emit an event for cart-badge component, this will update the badge counter
         *  @param  {void}
         *  @return {void}
         */
        function closeCart() {
            blockUI.start();
            CacheService.removeObject(CacheConstants.basketList);
            
            var estimateGroupId = vm.areNewButtonsVisible ? vm.estimateGroupId : null;
            var selectedOptionId = vm.areNewButtonsVisible && vm.quote.selectedPricingDetails ? vm.quote.selectedPricingDetails.id : null;
            
            prepareCartOperation();
            
            ShoppingCartService.closeCart(estimateGroupId, selectedOptionId)
                .then(function (response) {
                    if (vm.areNewButtonsVisible) {
                        onEstimateGroupChange(false);
                    }
                    var cartId = response && response.id ? response.id : (vm.cartMedatadata && vm.cartMedatadata.id ? vm.cartMedatadata.id : '');
                    toastr.success($translate.instant("BASKET_CLOSE_SUCCESS") + " (" + cartId + ")");
                    goBack();
                }, handleError)
                .finally(function () {
                    blockUI.stop();
                    $rootScope.panierData = '';
                });
        }

        /**
         *  @desc   Save cart, and back to previous page.
         *          Before that we need to save label and description cart
         *  @param  {void}
         *  @return {void}
         */
        function saveCart() {
            blockUI.start();

            var estimateGroupId = vm.areNewButtonsVisible ? vm.estimateGroupId : null;
            var selectedOptionId = vm.areNewButtonsVisible && vm.quote.selectedPricingDetails ? vm.quote.selectedPricingDetails.id : null;
            
            prepareCartOperation();
            ShoppingCartService.updateShoppingCart(
                _actions.UPDATE_CARTMETADATA,
                { cartDescription: vm.cartMedatadata }
            );

            var updateCart = ShoppingCartService.getShoppingCart();
            vm.panier.pr.forEach(function(item){      
                    updateCart.forEach(function(cartData){
                        if(cartData.id == item.id){
                            cartData.tax = (item.tax) ? item.tax : ""
                            cartData.discount = (item.discount) ? item.discount : ""
                        }
                    })
            })
            vm.panier.tm.forEach(function(item){      
                updateCart.forEach(function(cartData){
                    if(cartData.id == item.id){
                        cartData.tax = (item.tax) ? item.tax : ""
                        cartData.discount = (item.discount) ? item.discount : ""
                        cartData.hourlyRate = (item.hourlyRate) ? item.hourlyRate : ""

                    }
                })
        })
            ShoppingCartService.setShoppingCart(updateCart);
            ShoppingCartService.emitCartUpdated();

            updateShoppingCartMetadata().then(function(){
                ShoppingCartService.saveCart(estimateGroupId, selectedOptionId).then(function(result) {
                    var cartId = result && result.id ? result.id : (vm.cartMedatadata && vm.cartMedatadata.id ? vm.cartMedatadata.id : '');
                    toastr.success($translate.instant("BASKET_SAVE_SUCCESS") + " (" + cartId + ")");
                })
                .catch(handleError)
                .finally(function () {
                    blockUI.stop();
                });
            }) 
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        function splitType(cart) {
            var tm = [];
            var tmList = _.filter(cart, function (item) {
                if (item.type === "TM") {
                    return !item.interventionId;
                }
            });
            var pr = [];
            var prList = _.filter(cart, function (list) {
                if (list.type === "PR") {
                    return !list.interventionId;
                }
            });
            var inter = [];
            //check here and add interventionQuantity 
            var interList = _.filter(cart, function (item) { return item.interventionDesignation != null });
            var list = _.groupBy(interList, 'interventionDesignation');

            for(var x in list){
                var y ={designation :x,interQuantity:list[x][0].interventionQuantity, PR: [], TM : []};
                list[x].forEach(function(item){
                    switch (item.type) {
                        case "TM":
                            y.TM.push(item);
                            break;
                        default:
                            y.PR.push(item);
                            break;
                    }
                });
                inter.push(y);
            }
            angular.forEach(cart, function (value) {
                if(!value.interventionDesignation || value.interventionDesignation == null){
                    switch (value.type) {
                        case "TM":
                            tm = tmList;
                            break;
                        default:
                            pr = prList;
                            break;
                    }
                } 
            });

            return {
                inter:inter,
                tm: tm,
                pr: pr
            };
        }

        function getLastUpdateCart(isOpeningNewBasket) {
            vm.panier = splitType(ShoppingCartService.getShoppingCart());
            if(!_.isEmpty(vm.panier)){
                if(!_.isEmpty(vm.panier.pr)){
                    _.remove(vm.panier.pr, { quantity: 0 });
                }
                if(!_.isEmpty(vm.panier.tm)){
                    _.remove(vm.panier.tm, { quantity: 0 });
                }
                if(!_.isEmpty(vm.panier.inter)){
                    vm.panier.inter.forEach(function(item){
                        if(!_.isEmpty(item.PR)){
                            _.remove(item.PR, { quantity: 0 });
                        }
                        if(!_.isEmpty(item.TM)){
                            _.remove(item.TM, { quantity: 0 });
                        }
                    });
                }
            }
            vm.cartMedatadata = ShoppingCartService.getCartMedatadata();
            if(isOpeningNewBasket && _.isEmpty(vm.cartMedatadata) && vm.panier && vm.panier.pr.length === 0 && vm.panier.tm.length === 0 && vm.panier.inter.length === 0){
                updateShoppingCartMetadata();
            }
        }

        function checkDealerList(ref,isUpdate){
            var cacheProfile = CacheService.getObject(CacheConstants.profil);
            var cartList = [];
            vm.countryCode = cacheProfile.country;
            vm.isRNETUser = cacheProfile.userType == "RNET" ? true : false;
            vm.isDmsConnected = (cacheProfile.dmsConnected == null || cacheProfile.dmsConnected == false) ? false : true;
            if (vm.isNonDmsOrderModeEnable && vm.isRNETUser && !vm.isDmsConnected &&  vm.isRpartsRole) {
                var productList = [];
                var refQuantityList = [];
                if(ref){
                    cartList.push(ref);
                }else{
                    cartList= vm.panier.pr;
                }
                cartList.forEach(function(item){
                    productList.push(item.reference);
                    refQuantityList.push({
                        "reference":item.reference,
                        "quantity":item.quantity.toString()
                    });
                    //uncomment for quantity update in basket
                    /* if(isUpdate){
                        var r2aList = CacheService.getObject(CacheConstants.basketList);
                        _.map(r2aList.pr,function(data){
                            if(data.reference === item.reference){
                                data.quantity = item.quantity;
                            }
                        })
                        CacheService.setObject(CacheConstants.basketList,r2aList);
                    } */
                })            
                var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
                if (cachedetail && cachedetail.dealers && cachedetail.garageId != undefined) {   
                    var dealerList = _.find(cachedetail.dealers, function (item) {
                        return item.active == true;
                    });
                    if(dealerList && userProfil && UtilsMetierService.isDealerAuthorised(userProfil.dealerId)){
                        if (productList.length > 0 && !isUpdate){
                            getPriceTaxDiscount(ref,cachedetail.garageId, dealerList.dealerId, productList);
                            vm.showGetPriceColumns = true;
                        }
                        if(refQuantityList.length > 0){    
                            getStockDetails(ref,cachedetail.garageId, dealerList.dealerId, refQuantityList);
                        vm.showGetPriceColumns = true;
                    }
                }
            }
        }
        }

        function getLabelText(){
            if(vm.isIndependantUser){
                if($rootScope.asomDocList.TM && $rootScope.asomDocList.PR){
                    return $translate.instant("COMMON_ADD_REF");
                } else if ($rootScope.asomDocList.PR){
                    return $translate.instant("FAV_MODAL_ADD_REF_CREATE_BUTTON");
                } else if ($rootScope.asomDocList.TM){
                    return $translate.instant("FAV_ADD_TM");
                }                
            }
            else {
                return $translate.instant('COMMON_ADD_REF');
            }
            
        }

        function getPlaceholderText(){
            if(vm.isIndependantUser){
                if($rootScope.asomDocList.TM && $rootScope.asomDocList.PR){
                    return $translate.instant("COMMON_ADD_REF_PLACEHOLDER");
                } else if ($rootScope.asomDocList.PR){
                    return $translate.instant("COMMON_REFERENCE");
                } else if ($rootScope.asomDocList.TM){
                    return $translate.instant("ACTIS_DESCRIPTION_OPECODE");
                }                
            }
            else{
                return $translate.instant('COMMON_ADD_REF_PLACEHOLDER');
            }
            
        }

        function getStockDetails(refItem,garageId, dealerId, refQuantityList){
           // blockUI.start();
            var url = CarSearchConstants.r2aStock;
            vm.fetchUpdatedStock = false;
            var panierList = [];
            if(refItem){
                panierList.push(refItem);
            }else{
                panierList = vm.panier.pr;
            }

            _.map(vm.panier.pr, function(item){
                refQuantityList.forEach(function(product){
                    if(product.reference === item.reference){
                        _.assign(item,{isLoadingStockData:true})
                    }
                })
            })
            vm.allStockDataLoader = true;
            ShoppingCartService.getR2APriceStockDetails(garageId, dealerId, refQuantityList,url,panierList).then(function(response){ 
                if(response){
                    panierList = response;
                    if(refItem){
                        vm.panier.pr = _.map(vm.panier.pr, function(obj) {
                            return _.assign(obj, _.find(panierList, {reference: obj.reference}));
                        });
                        vm.panier.pr =  _.uniq(vm.panier.pr);
                        mapPriceStockValues('STOCK');
                    } else{
                        vm.panier.pr = panierList;
                    } 
                    
                }
            }).catch(function(error){
                vm.stockError = true;
            }).finally(function () {
                _.map(vm.panier.pr, function (item) {
                    refQuantityList.forEach(function (product) {
                        if (product.reference === item.reference) {
                            _.assign(item, { isLoadingStockData: false })
                            if(!vm.allPriceDataLoader){
                                _.assign(item, { isLoadingPriceData: false })
                            }
                        }
                    })
                })
                vm.allStockDataLoader = false;
                CacheService.setObject(CacheConstants.basketList,vm.panier);
                updatestockAndPriceToService();
                if (vm.validateClicked) {
                    vm.fetchUpdatedStock = true;
                    placeOrderStockPriceUpdated();
                }
               // blockUI.stop();
            })
        }
        $rootScope.$on("central_unavailable",function(){           
            _.map(vm.panier.pr, function (item) {
                _.assign(item, { isLoadingStockData: false })
            })            
            CacheService.setObject(CacheConstants.basketList,vm.panier);
            vm.stockError = true;
        })

        function getPriceTaxDiscount(refItem,garageId, dealerId, productList) {
           // blockUI.start();
            var url = CarSearchConstants.r2aPriceTaxDiscount;
            vm.fetchUpdatedPrice = false;
            var panierList = [];
            if(refItem){
                panierList.push(refItem);
            }else{
                panierList = vm.panier.pr;
            }

            _.map(vm.panier.pr, function(item){
                productList.forEach(function(product){
                    if(product === item.reference){
                        _.assign(item,{isLoadingPriceData:true})
                    }
                })
            })
            vm.allPriceDataLoader = true;
            return ShoppingCartWSService.getR2APriceStockDetails(garageId, dealerId, productList, url, vm.urgentOrder,false).then(function (response) {
                if (!_.isEmpty(panierList) && response && !_.isEmpty(response.products)) {
                    panierList.forEach(function(pr){
                        response.products.forEach(function (ref) {
                            if (pr.reference === ref.reference) {
                                if (ref.itemReturnCode === "A000") {
                                    _.extend(pr, ref, {
                                        isDiscountcodeVisible: false
                                    });
                                } else{
                                    _.extend(pr, ref);
                                }
                            }
                        })
                    })
                    var itemReturnCodeUnkown = false;
                    if(!_.isEmpty(response.products)){
                            for(var i =0; i < response.products.length; i++ ){
                               if(response.products[i].itemReturnCode === 'A001'){ 
                                itemReturnCodeUnkown = true;
                                $mdDialog.show({
                                        templateUrl: orderModeClosePopup,
                                        controller: 'orderModeClosePopupController',
                                        bindToController: true,
                                        controllerAs: 'vm',
                                        clickOutsideToClose: false,
                                        locals: {
                                            isOrderMode: vm.isOrderMode,
                                            message: $translate.instant("ORDER_MODE_WARN_MESSAGE"),
                                            message2: $translate.instant("ORDER_MODE_DELETE_UNKNOWN_REFERENCES"),
                                            orderModeWarnPop: true
                                        }  
                                    })
                                break;
                                }
                            }  
                    }
                    _.assign(response, { "urgentOrderPrices": vm.urgentOrder });
                    vm.r2aPriceResponse = response;
                }
                if(refItem){
                    vm.panier.pr = _.map(vm.panier.pr, function(obj) {
                        return _.assign(obj, _.find(panierList, {reference: obj.reference}));
                    }); 
                    vm.panier.pr =  _.uniq(vm.panier.pr);
                    mapPriceStockValues('PRICE');
                } else{
                    vm.panier.pr = panierList;
                } 
                
            }).catch(function(error){
                vm.priceError = true;
                //toastr.error($translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
            }).finally(function () {
                _.map(vm.panier.pr, function (item) {
                    productList.forEach(function (product) {
                        if (product === item.reference) {
                            _.assign(item, { isLoadingPriceData: false })
                            if(!vm.allStockDataLoader){
                                _.assign(item, { isLoadingStockData: false })
                            }
                        }
                    })
                })
                vm.allPriceDataLoader = false;
                CacheService.setObject(CacheConstants.basketList,vm.panier);
                updatestockAndPriceToService();
                if (vm.validateClicked) {
                    vm.fetchUpdatedPrice = true;
                    placeOrderStockPriceUpdated();
                }
               // blockUI.stop();
            })
        }

        function updatestockAndPriceToService() {
            var shopingCartData = ShoppingCartService.getShoppingCart();
            shopingCartData.forEach(function (item, index) {
                vm.panier.pr.forEach(function (updatedItem, updatedIndex) {
                    if (item.type === "PR" && item.reference === updatedItem.reference) {
                        shopingCartData[index] = vm.panier.pr[updatedIndex];
                    }
                })
            })
            ShoppingCartService.setShoppingCart(shopingCartData);
        }
        
        function displayDiscountRate(pr) {
            if (pr.isDiscountcodeVisible) {
                pr.isDiscountcodeVisible = false;
            }
            else {
                pr.isDiscountcodeVisible = true;
            }
        }

        function displayAllDiscountRate() {
            if (!vm.showAllDiscountRate) {
                for (var i = 0; i < vm.panier.pr.length; i++) {
                    vm.panier.pr[i].isDiscountcodeVisible = true;
                }
                vm.showAllDiscountRate = true;
            }
            else {
                for (var i = 0; i < vm.panier.pr.length; i++) {
                    vm.panier.pr[i].isDiscountcodeVisible = false;
                }
                vm.showAllDiscountRate = false;
            }
        }
        /**
         *  @desc Update cart metada - Label and description
         *  @param {void}
         *  @return {void}
         */
        function updateShoppingCartMetadata() {
            if (vm.areNewButtonsVisible && vm.panier.tm && vm.panier.tm.length > 0) {
                updateHourlyRatesInShoppingCart();
            }
            
            ShoppingCartService.updateShoppingCart(
                _actions.UPDATE_CARTMETADATA,
                {
                    cartDescription: vm.cartMedatadata
                }
            );
            if (vm.areNewButtonsVisible && vm.quote.selectedPricingDetails && vm.quote.selectedPricingDetails.id) {
                return ShoppingCartService.onUpdateCartWithEstimate(vm.quote.selectedPricingDetails.id).catch(handleError);
            } else {
                return ShoppingCartService.onUpdateCart().catch(handleError);
            }
        }

        function updateSelectedPricingDetails(fieldType, index) {
            if (!vm.areNewButtonsVisible || !vm.quote.selectedPricingDetails) {
                return;
            }
            
            // Handle tax and discount updates for both PR and TM
            var fieldMap = {
                'inputTax': { collection: 'pr', property: 'tax', targetProperty: 'tax' },
                'inputTaxTm': { collection: 'tm', property: 'tax', targetProperty: 'tax' },
                'inputDiscount': { collection: 'pr', property: 'discount', targetProperty: 'discount' },
                'inputDiscountTm': { collection: 'tm', property: 'discount', targetProperty: 'discount' }
            };
            
            if (fieldMap[fieldType]) {
                var config = fieldMap[fieldType];
                var item = vm.panier[config.collection] && vm.panier[config.collection][index];
                if (item && item[config.property] !== null && item[config.property] !== undefined) {
                    vm.quote.selectedPricingDetails[config.targetProperty] = parseFloat(item[config.property]) || 0;
                }
                return;
            }
            
            // Handle hourly rate updates
            if (fieldType === 'hourlyRate' && vm.panier.tm && vm.panier.tm[index]) {
                var tmItem = vm.panier.tm[index];
                var hourlyRateValue = parseFloat(tmItem.hourlyRate) || 0;
                
                if (tmItem.opecod) {
                    DocumentsMetierService.returnTmDocumentsByOpeCode([tmItem.opecod]).then(function(tmResponse) {
                        if (tmResponse && tmResponse.TM && tmResponse.TM.length > 0) {
                            var tmDoc = tmResponse.TM[0];
                            if (tmDoc.technicality) {
                                var hourlyRateFieldName = PanierConstants.hourlyRate + tmDoc.technicality.toUpperCase();
                                if (vm.quote.selectedPricingDetails[hourlyRateFieldName] !== undefined) {
                                    vm.quote.selectedPricingDetails[hourlyRateFieldName] = hourlyRateValue;
                                }
                            }
                        }
                    }).catch(function(error) {
                        console.error('Error updating hourly rate in selectedPricingDetails:', error);
                    });
                }
            }
        }

        function updateHourlyRatesInShoppingCart() {
            var shoppingCartData = ShoppingCartService.getShoppingCart();
            
            // Update cart items with current values from UI
            shoppingCartData.forEach(function(cartItem) {
                var matchKey = cartItem.type === "TM" ? 'opecod' : 'reference';
                var uiItem = null;

                if (!cartItem.interventionDesignation) {
                    // Standalone PR / TM
                    var itemCollection = cartItem.type === "TM" ? vm.panier.tm : vm.panier.pr;
                    for (var i = 0; i < itemCollection.length; i++) {
                        if (cartItem[matchKey] === itemCollection[i][matchKey]) {
                            uiItem = itemCollection[i];
                            break;
                        }
                    }
                } else {
                    // Inter PR / TM — match by group designation + key
                    if (vm.panier.inter) {
                        for (var g = 0; g < vm.panier.inter.length; g++) {
                            var interGroup = vm.panier.inter[g];
                            if (interGroup.designation !== cartItem.interventionDesignation) { continue; }
                            var interCollection = cartItem.type === "TM" ? interGroup.TM : interGroup.PR;
                            if (interCollection) {
                                for (var j = 0; j < interCollection.length; j++) {
                                    if (cartItem[matchKey] === interCollection[j][matchKey]) {
                                        uiItem = interCollection[j];
                                        break;
                                    }
                                }
                            }
                            if (uiItem) { break; }
                        }
                    }
                }

                if (uiItem) {
                    // Common properties for both TM and PR
                    ['tax', 'discount', 'netAmountExclTax', 'totalTax', 'netTotalAmtWithTax'].forEach(function(prop) {
                        if (uiItem[prop] !== undefined) cartItem[prop] = uiItem[prop];
                    });

                    // TM-specific: always persist hourlyRate (not gated on totalHourlyRate)
                    if (cartItem.type === "TM") {
                        if (uiItem.hourlyRate !== undefined && uiItem.hourlyRate !== null) {
                            cartItem.hourlyRate = uiItem.hourlyRate;
                        }
                        if (uiItem.totalHourlyRate !== undefined) {
                            cartItem.totalHourlyRate = uiItem.totalHourlyRate;
                        }
                    }
                }
            });
            
            ShoppingCartService.setShoppingCart(shoppingCartData);
            
            // Save calculated totals in cart metadata
            var totalsMap = {
                grossTotalAmt: vm.panier.grossTotalAmt,
                netTotalAmt: vm.panier.netTotalAmt,
                totalTax: vm.panier.totalTax,
                totalAmtInclTax: vm.panier.totalAmtInclTax,
                prSubTotalExclTax: vm.panier.pr && vm.panier.pr.subTotalExclTaxPrTm,
                tmSubTotalExclTax: vm.panier.tm && vm.panier.tm.subTotalExclTaxPrTm
            };
            
            Object.keys(totalsMap).forEach(function(key) {
                if (totalsMap[key] !== undefined) {
                    vm.cartMedatadata[key] = totalsMap[key];
                }
            });
        }

        /**
         *  @desc Display an error toastr
         *  @param {void}
         *  @return {void}
         */

        function handleError() {
            var msgError = $translate.instant("ERROR");
            toastr.error(msgError);
        }

        /**
         * Add addRef to panier could be a PR (prId) or TM (opeCode)
         * @param {string} ref
         * @return {void}
         */
        function _reloadPanierAndReapplyEstimate() {
            vm.panier = splitType(ShoppingCartService.getShoppingCart());
            vm.prCalculDone = false;
            if (vm.areNewButtonsVisible && vm.quote && vm.quote.selectedPricingDetails && !isProcessingEstimateGroup) {
                isProcessingEstimateGroup = true;
                onEstimateGroupChange(false);
            }
        }

        function addRef(ref) {
            // vm.ref = ""
            if (!ref) {
                return;
            }
            
            ref = ref.replace(/\s/g, '');
            
            var idType = ref.length;
            blockUI.start();
            if ( vm.isIndependantUser ){
                if (idType === PanierConstants.TM && $rootScope.asomDocList.TM) {
                    var opeCode = [ref];
                    DocumentsMetierService.returnTmDocumentsByOpeCode(opeCode).then(
                        function (response) {
                            blockUI.stop();
                            if (response.TM.length == 1) {
                                var document = response.TM[0];
                                if (document.subType === "STANDARD") {
                                    $scope.ref = "";
                                    computedPieceAndUpdateCart(document, "TM");
                                    _reloadPanierAndReapplyEstimate();
                                } else {
                                    toastr.error(
                                        $translate.instant("DOCUMENT_NO_TM_FOUND")
                                    );
                                }
                            } else if (response.TM.length > 1) {
                                var exist = false;
                                var index = 0;
                                var occurences = 0;
                                var indexStandard = 0;

                                //parse TM to get occurences of standard type
                                //and the first index of standard type
                                response.TM.forEach(function (item) {
                                    if (item.subType === "STANDARD") {
                                        if (!exist) {
                                            indexStandard = index;
                                        }
                                        exist = true;
                                        occurences++;
                                    }
                                    index++;
                                });

                                if (occurences == 0) {
                                    toastr.error(
                                        $translate.instant("DOCUMENT_NO_TM_FOUND")
                                    );
                                } else if (occurences == 1) {
                                    document = response.TM[indexStandard];
                                    computedPieceAndUpdateCart(document, "TM");
                                    _reloadPanierAndReapplyEstimate();
                                } else if (occurences > 1) {
                                    toastr.info(
                                        $translate.instant(
                                            "DOCUMENT_TM_MULTIPLE_RESULT_RETRY"
                                        )
                                    );
                                }
                            } else {
                                toastr.error(
                                    $translate.instant("DOCUMENT_NO_TM_FOUND")
                                );
                            }
                        },
                        function () {
                            toastr.error(
                                $translate.instant("DOCUMENT_NO_TM_FOUND")
                            );
                        }
                    );
                } else if (idType === PanierConstants.PART && $rootScope.asomDocList.PR) {
                    ProductMetierService.getReferenceInformationRaw(ref).then(
                        function (response) {
                            $scope.ref = "";
                            blockUI.stop();
                            computedPieceAndUpdateCart(response, "PR");
                            _reloadPanierAndReapplyEstimate();
                            if(vm.isNonDmsOrderModeEnable && vm.isRpartsRole){
                                mapPriceStockValues();
                                var refItem = _.filter(vm.panier.pr,function(item){
                                    return item.reference == ref;
                                })
                                checkDealerList(refItem[0]);
                            }
                        },
                        function () {
                            blockUI.stop();
                            toastr.info($translate.instant("DOCUMENT_NO_PR_FOUND"));
                        }
                    );
                } else {
                    blockUI.stop();
                    toastr.error($translate.instant("INVALID_SEARCH"));
                }
            }
            else {
                if (idType === PanierConstants.TM) {
                    var opeCode = [ref];
                    DocumentsMetierService.returnTmDocumentsByOpeCode(opeCode).then(
                        function (response) {
                            blockUI.stop();
                            if (response.TM.length == 1) {
                                var document = response.TM[0];
                                if (document.subType === "STANDARD") {
                                    $scope.ref = "";
                                    computedPieceAndUpdateCart(document, "TM");
                                    _reloadPanierAndReapplyEstimate();
                                } else {
                                    toastr.error(
                                        $translate.instant("DOCUMENT_NO_TM_FOUND")
                                    );
                                }
                            } else if (response.TM.length > 1) {
                                var exist = false;
                                var index = 0;
                                var occurences = 0;
                                var indexStandard = 0;

                                //parse TM to get occurences of standard type
                                //and the first index of standard type
                                response.TM.forEach(function (item) {
                                    if (item.subType === "STANDARD") {
                                        if (!exist) {
                                            indexStandard = index;
                                        }
                                        exist = true;
                                        occurences++;
                                    }
                                    index++;
                                });

                                if (occurences == 0) {
                                    toastr.error(
                                        $translate.instant("DOCUMENT_NO_TM_FOUND")
                                    );
                                } else if (occurences == 1) {
                                    document = response.TM[indexStandard];
                                    computedPieceAndUpdateCart(document, "TM");
                                    _reloadPanierAndReapplyEstimate();
                                } else if (occurences > 1) {
                                    toastr.info(
                                        $translate.instant(
                                            "DOCUMENT_TM_MULTIPLE_RESULT_RETRY"
                                        )
                                    );
                                }
                            } else {
                                toastr.error(
                                    $translate.instant("DOCUMENT_NO_TM_FOUND")
                                );
                            }
                        },
                        function () {
                            toastr.error(
                                $translate.instant("DOCUMENT_NO_TM_FOUND")
                            );
                        }
                    );
                } else if (idType === PanierConstants.PART) {
                    ProductMetierService.getReferenceInformationRaw(ref).then(
                        function (response) {
                            $scope.ref = "";
                            blockUI.stop();
                            computedPieceAndUpdateCart(response, "PR");
                            _reloadPanierAndReapplyEstimate();
                            if(vm.isNonDmsOrderModeEnable && vm.isRpartsRole){
                                mapPriceStockValues();
                                var refItem = _.filter(vm.panier.pr,function(item){
                                    return item.reference == ref;
                                })
                                checkDealerList(refItem[0]);
                            }
                        },
                        function () {
                            blockUI.stop();
                            toastr.info($translate.instant("DOCUMENT_NO_PR_FOUND"));
                        }
                    );
                } else {
                    blockUI.stop();
                    toastr.error($translate.instant("INVALID_REFERENCE"));
                }
            }
        }

        /**
         * @desc Computed document and update cart
         * @param {Object} document
         * @param {string} type
         * @return {void}
         */

        function computedPieceAndUpdateCart(document, type) {
            var computedPiece = ShoppingCartService.createNewStructureOfPieceByType(
                document,
                type
            );
            var payload = {
                piece: computedPiece,
                type: type,
                cartDescription: vm.cartMedatadata
            };
            if (payload.piece && payload.piece.opecod) {
                _.extend(payload.piece, { isTestOpcode: Object.values(_essai).includes(payload.piece.opecod) ? true : false });
            }
            return ShoppingCartService.updateShoppingCart(_actions.ADD_PIECE, payload).then(function () {
                return ShoppingCartService.onUpdateCart().catch(handleError);
            })
        }
        /* function mapPriceStockValues(){   
            var r2aList = CacheService.getObject(CacheConstants.basketList);
            _.map(vm.panier.pr, function(obj) {
                return _.assign(obj, _.find(r2aList.pr, {reference: obj.reference}));
            });            
            CacheService.setObject(CacheConstants.basketList,vm.panier);
        } */

        function mapPriceStockValues(priceOrStock){   
            var r2aList = CacheService.getObject(CacheConstants.basketList);
            if (r2aList && !_.isEmpty(r2aList.pr)) {
                _.map(vm.panier.pr, function (obj) {
                    r2aList.pr.forEach(function (item) {
                        if (item.reference === obj.reference) {
                            if (priceOrStock === 'STOCK') {
                                _.assign(obj, { isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode })
                            } else if (priceOrStock === 'PRICE') {
                                _.assign(obj, { applicableClass: item.applicableClass })
                            } else {
                                _.assign(obj, { isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode, applicableClass: item.applicableClass })
                            }
                        }
                    })
                });
            }
            CacheService.setObject(CacheConstants.basketList,vm.panier);
        }

        function validateOrder() {
            $mdDialog.show({
                templateUrl: 'app/components/orderModule/orderMethodSelectionPopup.html',
                controller: 'orderMethodSelectionController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    isOrderMode: vm.isOrderMode,
                    cartId: vm.cartMedatadata && vm.cartMedatadata.id ? vm.cartMedatadata.id : null
                }
            }).then(function(dialogResult) {
                if (dialogResult && dialogResult.selectedMethod === 'rpartstore') {
                    return;
                }
                // Continue with the original logic after dialog is closed
                var orderEndTime = moment(new Date());
                var orderStartTime = CacheService.getObject(CacheConstants.newNonDmsOrderStart);
                var duration = moment.duration(moment(orderEndTime).diff(moment(orderStartTime)));
                vm.validateClicked = true;
                priceOrderList = [];
                stockOrderList = [];
                updateShoppingCartMetadata();
                if (duration.minutes() >= 10) {
                    vm.panier.pr.forEach(function (item) {
                        priceOrderList.push({ isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode});
                        stockOrderList.push({ applicableClass: item.applicableClass });
                    })
                    blockUI.start($translate.instant("LOADER_MESSAGE"));
                    checkDealerList(null);
                } else {
                    callPlaceOrder();
                }
            });
        }
        function callPlaceOrder() {
            var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
            var userIpn = CacheService.getObject(CacheConstants.profil) ? CacheService.getObject(CacheConstants.profil).ipn : null;
            var dealerList = null;
            var refQuantityList = [];
            if (cachedetail && !_.isEmpty(cachedetail.dealers) && cachedetail.garageId != undefined) {
                dealerList = _.find(cachedetail.dealers, function (item) {
                    return item.active == true;
                });
            }
            if (!_.isEmpty(vm.panier.pr)) {
                vm.panier.pr.forEach(function (item) {
                    refQuantityList.push({
                        "reference": item.reference,
                        "quantity": item.quantity
                    });
                })
            }
            blockUI.start();
            var isProductUnknown = false;
            var garageId = cachedetail && cachedetail.garageId != undefined ? cachedetail.garageId : '';
            ShoppingCartService.r2aPlaceOrder(dealerList,userIpn,
                refQuantityList,vm.cartMedatadata.label,vm.cartMedatadata.description,vm.urgentOrder,garageId).then(function (response) {
                    if(response && response.returnCode==='H000'){
                        if(!_.isEmpty(response.products)){
                            for(var i =0; i < response.products.length; i++ ){
                               if(response.products[i].itemReturnCode != 'A000'){ 
                                    isProductUnknown = true;
                                break;
                               }                  
                            }  
                        }
                        if(!response.orderNumber && !isProductUnknown){
                            toastr.error($translate.instant("PLACE_ORDER_ERROR"));
                            CacheService.setObject(CacheConstants.newNonDmsOrderStart, moment(new Date()));
                        } else if(isProductUnknown){
                            toastr.error($translate.instant("ORDER_FAILED")+'\n'+$translate.instant("ERROR_A001"));
                            CacheService.setObject(CacheConstants.newNonDmsOrderStart, moment(new Date()));
                        } else if(response.orderNumber && !isProductUnknown){
                            var rpsId = response.orderNumber;
                            var id = vm.cartMedatadata.id;
                            var url = CarSearchConstants.cartRpsId;
                            ShoppingCartService.updateRpsId(id, rpsId, url)
                                .catch(function (error) {
                                    toastr.error($translate.instant("UPDATE_RPS_ID_FAILED"));
                                });
                            CacheService.removeObject(CacheConstants.newNonDmsOrderStart);
                            $state.go(RoutesConstants.validatedOrder, { validatedOrder: { items: vm.panier.pr, orderMark: vm.cartMedatadata.label, message: vm.cartMedatadata.description }, vehicle: vm.vehicle, isCountryIndia: vm.isCountryIndia, isCountryChina: vm.isCountryChina, isCountryRoumania: vm.isCountryRoumania, addOrderResponse: response, validatorInfo: { dateAndTime: moment(new Date()).format("YYYY/MM/DD HH:mm"), ipn: response ? response.ipn : null, urgentOrder: vm.urgentOrder, basketId: vm.cartMedatadata.id } });
                        } 
                    }
                }).catch(function (error) {
                    if(error && error.data && !_.isEmpty(error.data.errors)){
                        if(error.data.errors[0].errorCode === 'H003'){
                            $mdDialog.show({
                                templateUrl: orderModeClosePopup,
                                controller: 'orderModeClosePopupController',
                                bindToController: true,
                                controllerAs: 'vm',
                                clickOutsideToClose: true,
                                locals: {
                                    isOrderMode: vm.isOrderMode,
                                    message: $translate.instant("INVALID_IPN1"),
                                    message2: $translate.instant("INVALID_IPN2"),
                                    redirectLink: rpartsRedirectUrl
                                }       
                            }).then(function(response){
                                if(response && response.isOrderModeEnabled){
                                    $mdDialog.hide();
                                }
                            })
                        }else{
                            toastr.error($translate.instant("ORDER_FAILED")+'\n'+$translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                            CacheService.setObject(CacheConstants.newNonDmsOrderStart, moment(new Date()));
                        }
                    }
                }).finally(function () {
                    blockUI.stop();
                    vm.validateClicked = false;
                })
        }
        function placeOrderStockPriceUpdated() {
            blockUI.stop();
            var newPriceOrderList = [];
            var newStockOrderList = [];
            if (vm.fetchUpdatedPrice && vm.fetchUpdatedStock) {
                vm.panier.pr.forEach(function (item) {
                    newPriceOrderList.push({ isDiscountcodeVisible: item.isDiscountcodeVisible, priceTaxFree: item.priceTaxFree, discountRate: item.discountRate, currency: item.currency, discountCode: item.discountCode });
                    newStockOrderList.push({ applicableClass: item.applicableClass });
                })
                var orderPriceUpdate = angular.equals(priceOrderList, newPriceOrderList);
                var orderStockUpdate = angular.equals(stockOrderList, newStockOrderList);
                
                if (vm.stockError && vm.priceError){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(vm.priceError && !orderStockUpdate){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    callPopUp("PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                        callPopUp("STOCK_UPDATE_SUCCESS","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                        })
                    })
                } else if (vm.priceError && orderStockUpdate){
                    toastr.error($translate.instant("PRICE_ERROR"));
                    callPopUp("PRICE_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(vm.stockError && !orderPriceUpdate){                    
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                        callPopUp("PRICE_UPDATE_SUCCESS","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                        })
                    })
                } else if(vm.stockError && orderPriceUpdate){                    
                    toastr.error($translate.instant("STOCK_ERROR"));
                    callPopUp("STOCK_UPDATE_ERROR","CONTINUE_PLACE_ORDER").then(function(){
                            $mdDialog.hide();
                            callPlaceOrder();
                    })
                } else if(!orderPriceUpdate || !orderStockUpdate){
                    callPopUp("STOCK_PRICE_CHANGED","CONFIRM_CANCEL_PLACE_ORDER").then(function(){
                        $mdDialog.hide();
                        callPlaceOrder();
                    }) 
                } else {
                    callPlaceOrder();
                }
            }
        }
        function urgentOrderChange() {
            if (vm.urgentOrder) {
                if (vm.r2aPriceResponse && !vm.r2aPriceResponse.urgentOrderPrices) {
                    var cartList = vm.panier.pr;
                    var productList = [];
                    cartList.forEach(function (item) {
                        productList.push(item.reference);
                    });
                    var cachedetail = CacheService.getObject(CacheConstants.r2aDealerList);
                    if (cachedetail && cachedetail.dealers && cachedetail.garageId != undefined) {
                        var dealerList = _.find(cachedetail.dealers, function (item) {
                            return item.active == true;
                        });
                        if (dealerList && !_.isEmpty(productList)) {
                            getPriceTaxDiscount(null, cachedetail.garageId, dealerList.dealerId, productList);
                        }
                    }
                }
            }
        }
        function callPopUp(message1, message2){
            var deferred = $q.defer();
            $mdDialog.show({
                templateUrl: orderModeClosePopup,
                controller: 'orderModeClosePopupController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false,
                locals: {
                    message: $translate.instant(message1),
                    message2: $translate.instant(message2),
                    confirmMessage: $translate.instant("ORDER_CONFIRM"),
                    cancelMessage: $translate.instant("ACTIS_HEADER_CANCEL")
                }
            }).then(function (response) {
                if (response.isOrderModeEnabled) {
                    deferred.resolve();
                } else{
                    $mdDialog.hide();
                    CacheService.setObject(CacheConstants.newNonDmsOrderStart, moment(new Date()));
                    deferred.reject();
                }
            });
            return deferred.promise;
        }
    }
})();

'use strict';

angular.module('phenix').constant('PanierConstants', {
    csv_endpoint: '/carts/csvExport/',
    TM: 4,
    PART: 10,
    CART_META_DATA: 'cartMedatadata',
    PANIER : 'panier',
    Error:{
        "H001":"ERROR_H001",
        "H002":"ERROR_H002",
        "H003":"ERROR_H003",
        "H004":"ERROR_H004",
        "H005":"ERROR_H005",
        "H006":"ERROR_H006",
        "H099":"ERROR_H099"
    },
    operationDetails:  '/proxy/apigee/d4c/obi/v1/vehicles/',
    operations: '/operations',
    partDetailsForOperations: ['reference','quantity','designation'],
    tmDetailsForOperations: ['duration','opecod','designation'],
    declare_endpoint: '/carts/declareCart',
    saveVotes: '/carts/saveVotes',
    getVotes: '/carts/getVotes',
    origin: 'New Dialogys',
    getEstimateGroup: '/estimateGroup',
    hourlyRate: 'hourlyRate'
});

(function () {
    angular.module('phenix').controller('deleteDialog', function(
        $mdDialog, $translate,

        ShoppingCartService, 

        blockUI, toastr,CarSearchMetierService,$controller,$scope,$state,RoutesConstants,CarSearchResultConstants,CarSearchWsService,CacheService,activeVinService,CacheConstants) {


        var vm = this;
        var childScope = $scope.$new(true);
        var searchDiagController = $controller('SearchByDiagnosticController', { $scope: childScope });
        this.$onInit = function () {
            vm.designation = this.item ? this.item.designation : null;
            if (this.pieceType === 'TM') {
                vm.code = vm.item.opecod;
            } else {
                vm.code = vm.item && vm.item.reference ? vm.item.reference : vm.code;
            }
        }


        this.onConfirm = function () {
            var closed = $mdDialog.hide();
            closed.then(function () {
                deleted(vm.item, vm.isPPS, vm.mainReference);
            })
        }

        this.onCancel = function () {
            $mdDialog.hide();
        }

        /**
         *  @desc Delete item in cart, call nd-service for postgres update
         *  onSuccess is a callback given by 'panier.controller' when this dialog is called
         *
         *  @param {object}     item {
         *      reference: string
         *      id: string
         *  }
         *  @param {boolean}    isPPS
         *  @param {string}     mainReference
         *  @return {void}
         */
        this.OnConfirmVin = function (vinNumber) {
            CarSearchMetierService.searchCar({ vin: vinNumber }).then(function () {
                return CarSearchMetierService.getBannerData();
            }).then(function() {
                activeVinService.setVinDiag(true);
                activeVinService.setRemoteConsult(true);
                $mdDialog.hide();
                $state.go(RoutesConstants.carSearchResult, {
                    tab: CarSearchResultConstants.searchTypes.searchByDiagnostic
                }, { reload: true });
                var params = {
                    vin: vinNumber,
                    region: 'EU'
                };
                CarSearchWsService.getConnectedPlatform(params).then(function (response) {
                    if (response) {
                        CacheService.setObject(CacheConstants.connectedPlatform, response);
                    }
                });
            }).catch(function () {
                $state.go(RoutesConstants.carSearch);
            })
        }

        this.OnConfirmLaunch = function(vin){
            searchDiagController.clickComp(false, vin );
        }

        function deleted(item, isPPS, mainReference) {
            var action;
            var payload;

            if (isPPS) {
                action = ShoppingCartService.constants.DELETE_PIECE_PPS;
                payload = {
                    reference: item.reference,
                    mainReference: mainReference
                };
            } else {
                action = ShoppingCartService.constants.DELETE_PIECE;
                payload = {
                    reference: item.reference,
                    genericPart: (item.genericPart && item.genericPart !== undefined && !_.isEmpty(item.genericPart)) ? item.genericPart : "",
                    item: item
                };
            }

            blockUI.start();
            ShoppingCartService.updateShoppingCart(action, payload);
            ShoppingCartService.deleteReference(item.id).then(function () {
                vm.onSuccess();
            }, handleError).finally(function() {
                blockUI.stop();
            });

            function handleError() {
                var msgError = $translate.instant('ERROR');
                toastr.error(msgError);
            }
        }

    })
})();

/**
 * Created by a645375 on 29/12/2016.
 */
(function () {

  angular
    .module('phenix')
    .service('AlertsWSService', AlertsWSService);


  function AlertsWSService($q, AlertsConstants, UtilsMetierService, AlertsService,RestUpgrade,LoginConstants,DiagFileDetailsNewConstants, configConstantes) {

    this.sendDeleteAlerts = sendDeleteAlerts;
    this.getAlertsList = getAlertsList;
    this.getAlertsFilters = getAlertsFilters;
    this.sendAlerts = sendAlerts;
    this.getAlertDetail = getAlertDetail;
    this.getIncidentAlerts = getIncidentAlerts;
    this.sendDocumentryerrorReportAlerts = sendDocumentryerrorReportAlerts;
    this.sendOrderAlerts = sendOrderAlerts;


    /**
     * POST
     * @param paramsRequest
     * @returns {promise}
     */
    function getAlertsList(paramsRequest) {
      var defer = $q.defer();
      RestUpgrade.one(AlertsConstants.search).post('', paramsRequest).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }


    /**
     * POST
     * @param paramsRequest
     * @returns {promise}
     */
    function getAlertsFilters(paramsRequest) {
      var defer = $q.defer();
      RestUpgrade.one(AlertsConstants.filters).post('', paramsRequest).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }


    /**
     * POST
     * @param paramsRequest
     * @returns {promise}
     */
    function getAlertDetail(paramsRequest) {
      var defer = $q.defer();
      RestUpgrade.one(AlertsConstants.detail).post('', paramsRequest).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }


    /**
     * DELETE
     * @param paramsRequest
     * @returns {*}
     */
    function sendDeleteAlerts(paramsRequest) {
      return UtilsMetierService.customHttpDelete(AlertsConstants.delete, paramsRequest);
    }

    /**
     * POST
     * @param paramsRequest
     * @returns {promise}
     */
    function sendAlerts(paramsRequest) {
      paramsRequest = AlertsService.transformSendAlerts(angular.copy(paramsRequest));
      var defer = $q.defer();
      RestUpgrade.one(AlertsConstants.alerts).post('', paramsRequest).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }).catch(function (err) {
        return defer.reject(err);
      });
      return defer.promise;
    }

     /**
     * POST
     * @param alertMessage
     * @returns {promise}
     */
      function sendOrderAlerts(alertMessage,alertData) {
        var alertReportData = AlertsService.orderAlertPayload(alertMessage,alertData);
        var defer = $q.defer();
        RestUpgrade.one(AlertsConstants.orderAlerts).post('', alertReportData).then(function (response) {
          response = response.plain ? response.plain() : response;
          defer.resolve(response);
        }).catch(function (err) {
          return defer.reject(err);
        });
        return defer.promise;
      }

    /**
     * POST
     * @param requestData 
     */
    function sendDocumentryerrorReportAlerts(requestData,docType,isTraceEnabled){
      var isTraceEnabledVal = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUser();
      var isTraceEnabledINTVal = JSON.parse(configConstantes.isTraceEnable) && UtilsMetierService.isTraceKnownUserINT();
      var errorReportRequestData = AlertsService.transformErrorReportAlerts(requestData,docType);
      var defer = $q.defer();
      var url = LoginConstants.mrTmRequests;
      if((!isTraceEnabledVal && (docType === "TM" || docType === "MR")) || docType === DiagFileDetailsNewConstants.alertPredictions){
        RestUpgrade.one(AlertsConstants.documentaryError+docType).post('', errorReportRequestData).then(function (response) {
          defer.resolve(response);
        }).catch(function (err) {
          return defer.reject(err);
        });
        return defer.promise;
      }
      else if((isTraceEnabledVal && (docType == "TM" || docType == "MR")) || (isTraceEnabledINTVal && docType == "INT")){
        RestUpgrade.one(url).post('', errorReportRequestData).then(function (response) {
          defer.resolve(response);

          // if (docType === "INT") {
          //   try {
          //     var emailReportRequestData = AlertsService.transformEmailReportAlerts(requestData, docType, response);
          //     RestUpgrade.one(AlertsConstants.documentaryError+docType).post('', emailReportRequestData).catch(function (emailErr) {
          //       console.warn('Failed to send Easy Basket email notification:', emailErr);
          //     });
          //   } catch (emailPayloadErr) {
          //     console.warn('Failed to build Easy Basket email payload:', emailPayloadErr);
          //   }
          // }
        }).catch(function (err) {
          return defer.reject(err);
        });
        return defer.promise;
      }
    }

    /**
     * POST
     * @param paramsRequest
     * @returns {promise}
     */
    function getIncidentAlerts(incident) {
      var defer = $q.defer();
      RestUpgrade.one(AlertsConstants.incident).post('', incident).then(function (response) {
        response = response.plain ? response.plain() : response;
        defer.resolve(response);
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }

  }
})();

(function () {

  angular
    .module('phenix')
    .constant('AlertsConstants', {
      search: '/alerts/search',
      delete: '/alerts/delete',
      filters: '/alerts/filters',
      alerts: '/proxy/apigee/technical-documentation/dialogys/documents',
      detail: '/alerts/detail',
      incident: 'alerts/incident ',
      documentaryError: '/documentaryError/',
      orderAlerts:'/orderingMail/alertOrder',
      unknownPart: 'ALERTS_UNKNOWN_PART',
      partWithoutDesignation : 'ALERTS_UNKNOWN_DESIGNATION_PART',
      partWithoutPrice: 'ALERTS_UNKNOWN_PRICE_PART',
      notFoundRef: 'ALERTS_NOT_FOUND_REF',
      notConformRef: 'ALERTS_NOT_CONFORM_REF',
      unknownPartFormated: 'unknown_part',
      notFoundRefFormated: 'not_found_ref',
      notConformRefFormated: 'not_conform_ref',
      PviOrderRelated:'ALERTS_LEVEL_ALERTS_URGENT',
      tmIncorrect: 'ALERTS_TM_INCORRECT',
      tmNotfound: 'ALERTS_TM_NOT_FOUND',
      tmIncorrectDesignation:'ALERTS_TM_INCORRECT_DESIGNATION' ,
      mrIncorrect:'ALERTS_MR_INCORRECT',
      mrNotfound:'ALERTS_MR_NOT_FOUND',
      mrIncorrectDesignation:'ALERTS_MR_INCORRECT_DESIGNATION',
      otherProblem:'OTHER',
      intPRIncorrect:'ALERTS_INT_PR_INCORRECT',
      intTMIncorrect:'ALERTS_INT_TM_INCORRECT',
      intDataIncorrect:'ALERTS_INT_DATA_INCORRECT',
      staticMarking:"99999999",
      requestTypeMRTM:'MR_TM_ASE',
      requestTypeInt:'EASY_BASKET',
      issueOriginTM:'LABOR_TIME',
      issueOriginMR:'REPAIR_METHOD',
      isVehicleCoverByWarranty: 'YES',
      noVehicleCoverByWarranty: 'NO',
      newAlertButtonRole: 'IRN-75245:DEALER',
      requestReasons: ['MISSING', 'NOT_CORRECT', 'WRONG_TRANSLATION', 'EASY_BASKET_NOT_COMPLETED', 'MISSING_REFERENCE', 'MISSING_LABOR_TIME', 'DISPLAY_ISSUE', 'OTHER'],
      predictionInDefaults: ['ALL','RULE','TOP1','TOP2','TOP3']
    });
})();

(function () {

  angular
    .module('phenix')
    .service('AlertsLocationService', AlertsLocationService);

  function AlertsLocationService(AlertsModels) {
    var alerts = AlertsModels.alertsLocationModels();

    this.getAlerts = getAlerts;
    this.setCurrentPlate = setCurrentPlate;
    this.buildAlerts = buildAlerts;

    function setCurrentPlate(currentPlate) { 
      this.plateAndCatalogNumber = currentPlate;
    }
    function getAlerts() {
      alerts.location.reference = this.plateAndCatalogNumber;
      return alerts;
    }

    function buildAlerts(data, code) {
      alerts.location = _.assign(alerts.location, data);
      alerts.code = code;
    }

  }

})();

(function () {

    angular.module('phenix').config(routerConfig);

    /** ngInject */
    function routerConfig($stateProvider, RoutesConstants) {
        $stateProvider.state(RoutesConstants.manageFIC, {
            url: '/manageFIC',
            templateUrl: 'app/components/actis/actis.template.html',
            controller: 'ActisController',
            controllerAs: 'vm',
            params: {
                data: null,
                isActisUserComingFromFicConsultation: false,
                isForBwr: false,
                isForPaint: false,
                isForAccessories:false,
                isForQstomize:false
            }
        });
    }

})();

/**
 * ActisController
 * @namespace Controller
 */
(function () {
    angular
        .module('phenix')
        .controller('ActisController', ActisController);

   /* @ngInject */
    function ActisController(
        $scope,
        $mdDialog,
        $timeout,
        $mdMedia,
        $state,
        toastr,
        ActisConstantes,
        CacheService,
        CacheConstants,
        CreateActisBusinessService,
        RoutesConstants,
        $rootScope,
        $translate,
        blockUI,
        FicInputValidationService,
        configConstantes,
        MainMetierService,
        CarSearchMetierService,
        FicViewListWSService,
        UtilsMetierService,
        CryptoService,$log,$q
    ) {

        /*=============================================
        =                 VARIABLES                   =
        =============================================*/

        var vm = this;
        vm.isTechnicalAssistance = false;
        vm.isCalm = false;
        vm.isAdministrative = false;
        vm.containsProblemFreqBtn = false;
        vm.isPilote = false;
        vm.isApproval = false;
        vm.isAccessoires = false;
        vm.isPainting = false;
        vm.isClosed = false;
        vm.selectedTypeFIC = {};
        vm.typesFIC = [];
        vm.recapCarAPI = null;
        vm.isRequired = false;
        vm.responseApi = {};
        vm.vehicle = {};
        vm.isFormValid = false;
        vm.showFicSent = false;
        vm.showFicSave = false;
        vm.caseNumber = '';
        vm.isEditMode = false;
        vm.isPreSave = false;
        vm.fic = {};
        vm.isNewFic = false;
        vm.isDeletedFic = false;
        vm.isDraft = false;
        vm.nonModifiableFic = false;
        vm.isLoadFic = false;
        vm.isAnswered = false;
        vm.isFicReopen = false;
        vm.isFicCancelled = false;
        vm.isDeleteButtonVisible = false;
        vm.isSaveButtonVisible = false;
        vm.isSendButtonVisible = false;
        vm.isDaysToReopen = false;
        vm.activateActisAccessoriesAndPaint = configConstantes.activateActisAccessoriesAndPaint;
        vm.hideCarContextInformation = hideCarContextInformation;
        vm.description = '';
        vm.isStatusPresent = true;
        vm.consultationFIC = {};
        vm.isForBwr = false;
        vm.isForPaint = false;
        vm.isForAccessories = false;
        vm.isForQstomize = false;
        vm.isBrw=false;
        vm.isQstomize = false;
        vm.clearRefreshVin = false;
        vm.refreshVin = false;
        vm.selectedFicTypeId = 0;
        vm.onUpdateTypeFic = onUpdateTypeFic;
        vm.onUpdateComment = onUpdateComment;
        vm.keepTypeFic = keepTypeFic;
        vm.findTypeFic = findTypeFic;
        vm.onLoadPage = onLoadPage;
        vm.removeButtonToRecapCar = removeButtonToRecapCar;
        vm.$mdMedia = $mdMedia;
        vm.isolateCaseNumber = isolateCaseNumber;
        vm.saveFic = saveFic;
        vm.updateFic = updateFic;
        vm.onDeleteFic = onDeleteFic;
        vm.loadFic = loadFic;
        vm.isFicBeingModified = isFicBeingModified;
        vm.closedStatusFic = closedStatusFic;
        vm.reOpenFic = reOpenFic;
        vm.cancelFic = cancelFic;
        vm.showDiscussionBlock = showDiscussionBlock;
        vm.splitString = splitString;
        vm.isFicCreation = false;
        vm.daysToReopen = ActisConstantes.days_to_reopen;
        vm.isIndependentUser =  false;
        vm.tokenBalance=UtilsMetierService.getTokenBalance();
        vm.deductedTokenBalance=0;
        vm.deductTokenBalance=deductTokenBalance;
        vm.isChatBotDealerAccess = UtilsMetierService.isChatBotDealerAccess();
        vm.isActisProfil = MainMetierService.isActisProfilNoContext();
        vm.qstomizeReqLabel = qstomizeReqLabel;
        var CONSULTATION_FIC_EVENT = 'ACTIS_CONSULTATION_FIC_SYNC';

        

        vm.btValue = '';
        $scope.$on('btValueSelected', function (event, btValue) {
            vm.btValue = btValue;
            if (vm.fic && vm.fic.Request) {
                vm.fic.Request.tintname = btValue;
            }
        });

        /*=============================================
        =                 FUNCTIONS                   =
        =============================================*/

        
         this.$onInit = function () {
             vm.isActisFromDiag = CacheService.getObject(CacheConstants.isActisFromDiag);
            if(vm.isActisFromDiag || $state.params.isForBwr){
                vm.isFicCreation = true;
            }

            if($state.params.isForBwr){
                vm.isForBwr = true;
                //onUpdateTypeFic(5);
            }

            if($state.params.isForPaint){
                vm.isForPaint = true;
            }

            if($state.params.isForAccessories){
                vm.isForAccessories = true;
            }
            
            if($state.params.isForQstomize){
                vm.isForQstomize = true;
            }
            
            if (UtilsMetierService.isIndependentUser()){
                vm.isIndependentUser =  true;
            }
             if (vm.isIndependentUser) {
                 if (vm.isForQstomize) {
                     onUpdateTypeFic(9);
                 } else {
                     onUpdateTypeFic(1);
                 }

             }
        } 


        /********************** START Broadcast and Listener **************************/

        /**
         * Broadcast getFicData to other component in order to retrieve/load the data from the component views
         */
        $scope.getFicData = function () {
            $scope.$broadcast('getFicData');
        };

        $rootScope.$on("fileAttachments", function(event, files) {
            vm.filesToBeShown = files.filesToBeShown;
            vm.rDocIdsAndFileNames = files.rDocIdsAndFileNames;
        });

        $scope.$on('loadFicData', function (event, data) {

            //Deep copy of the case view if it contains multiple object property
            for (var property in data) {
                // Case the property of data is not include in vm.fic we add it
                if (!vm.fic[property]) {
                    vm.fic[property] = data[property];
                } else { //On the other hand if property exist we copy the innerproperty inside
                    for (var innerProperty in data[property]) {
                        vm.fic[property][innerProperty] = data[property][innerProperty];
                    }
                }
            }
        });


        //TODO BASILE TEST

        /**
         * Create a listener to listen from mainController
         * in order to call getFicModificationInformation()
         */

        // $rootScope.$on('getBeingModifiedFic', function (event) {
        //     $rootScope.$emit("loadFicModification", $scope.getFicModificationInformation());
        // });


        /**
         * Inform is fic is being modified
         * @returns {*}
         */
        // $scope.getFicModificationInformation = function () {
        //     return isFicBeingModified();
        // };

        /********************** END Broadcast and Listener Emition **************************/


        /**
         * @namespace hideCarContextInformation
         * @desc uses recapCar directive to get car context, and remove Car Context informations when a FIC is consulted
         *
         */
        function hideCarContextInformation() {

            var carContextImage = document.querySelectorAll("#imageRecapCar")[0];
            var recapCarInformations = document.querySelectorAll("#recapCarInformations")[0];
            if (carContextImage) {
                carContextImage.parentElement.removeChild(carContextImage);
            }

            if (recapCarInformations) {
                recapCarInformations.parentElement.removeChild(recapCarInformations);
            }
        }

        /**
         * @namespace onUpdateTypeFic
         * @desc get the right state when user change type fic
         * @param {number} selectedItem the selected type fic item
         * @memberOf Controller.onUpdateTypeFic
         */
        function onUpdateTypeFic(selectedItem) {
            vm.isFicCreation = false;
            CacheService.removeObject(CacheConstants.isActisFromDiag);
            vm.showBlocs = true;
            vm.selectedFicTypeId = selectedItem;
            hideBlocs();
            switch (selectedItem) {
                case ActisConstantes.type_technical_assistance:
                    vm.isTechnicalAssistance = true;
                    break;
                case ActisConstantes.type_accessoires:
                    vm.isAccessoires = true;
                    break;
                case ActisConstantes.type_painting:
                    vm.isPainting = true;
                    break;
                case ActisConstantes.type_approval:
                    vm.isApproval = true;
                    break;
                case ActisConstantes.type_ze_battery:
                    vm.isZeBattery = true;
                    break;
                case ActisConstantes.type_good_practise:
                    vm.isGoodPractise = true;
                    break;
                case ActisConstantes.type_alert:
                    vm.isAlert = true;
                    break;
                case ActisConstantes.type_pilote:
                    vm.isPilote = true;
                    break;
                case ActisConstantes.type_qstomize:
                    vm.isForQstomize = true;
                    break;
                case ActisConstantes.type_calm:
                    vm.isCalm = true;
                    break;
                case ActisConstantes.type_administrative:
                    vm.isAdministrative = true;
                    break;
            }
        }

        /**
         * Used to capture the changes in the comments in the discussion component
         * @param {*} comment
         */
        function onUpdateComment(comment) {
            vm.description = comment;
        }

        /**
         * @description Used to show the discussion component depending on the Salesforce status
         */
        function showDiscussionBlock() {
            if (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status &&
                (vm.responseApi.CaseDetail.status === 'Answered' || vm.responseApi.CaseDetail.status === 'Resolved' || vm.responseApi.CaseDetail.status === 'More Info Needed'
                    || vm.responseApi.CaseDetail.status === 'Closed' || vm.responseApi.CaseDetail.status === 'Reopen'
                    || vm.responseApi.CaseDetail.status === 'In Progress' || vm.responseApi.CaseDetail.status === 'Email Received'
                    || vm.responseApi.CaseDetail.status === 'Waiting Expert Answer' || vm.responseApi.CaseDetail.status === 'Expert Answer Received'
                    || vm.responseApi.CaseDetail.status === 'Draft In Queue' || vm.responseApi.CaseDetail.status === 'Waiting Email Answer'
                    || vm.responseApi.CaseDetail.status === 'New' || vm.responseApi.CaseDetail.status === 'Back To Queue'
                    || vm.responseApi.CaseDetail.status === 'Back')) {
                return true;
            } else {
                return false;
            }
        }

        function findTypeFicNumber() {
            switch (true) {
                case vm.isTechnicalAssistance:
                    return ActisConstantes.technical_CIRS;
                case vm.isAccessoires:
                    return ActisConstantes.accessories_CIRS;
                case vm.isPainting:
                    return ActisConstantes.painting_CIRS;
                case vm.isApproval:
                    return ActisConstantes.agreement_CIRS;
                case vm.isZeBattery:
                    return ActisConstantes.ze_battery_CIRS;
                case vm.isGoodPractise:
                    return ActisConstantes.goodPractise_CIRS;
                case vm.isAlert:
                    return ActisConstantes.alert_CIRS;
                case vm.isForBwr:
                    return ActisConstantes.BRW_CIRS;
                case vm.isForQstomize:
                    return ActisConstantes.QSTOMIZE_CIRS;
                case vm.isForPilote:
                    return ActisConstantes.ACTIS_PILOTE;
                case vm.isCalm:
                    return ActisConstantes.CALM_CIRS;
                case vm.isAdministrative:
                    return ActisConstantes.ADMINISTRATIVE_CIRS;
            }
        }

        //Set the type Fic by ids
        function keepTypeFic(typeFicId) {
            vm.showBlocs = true;
            //hideBlocs();
            switch (typeFicId) {
                case ActisConstantes.type_technical_assistance:
                    vm.isTechnicalAssistance = true;
                    break;
                case ActisConstantes.type_accessoires:
                    vm.isAccessoires = true;
                    break;
                case ActisConstantes.type_painting:
                    vm.isPainting = true;
                    break;
                case ActisConstantes.type_approval:
                    vm.isApproval = true;
                    break;
                case ActisConstantes.type_ze_battery:
                    vm.isZeBattery = true;
                    break;
                case ActisConstantes.type_good_practise:
                    vm.isGoodPractise = true;
                    break;
                case ActisConstantes.type_alert:
                    vm.isAlert = true;
                    break;
                case ActisConstantes.type_pilote:
                    vm.isPilote = true;
                    break;
                case ActisConstantes.type_calm:
                    vm.isCalm = true;
                    break;
                case ActisConstantes.type_administrative:
                    vm.isAdministrative = true;
                    break;
            }
        }

        function findTypeFic(selectedItem) {
            var returnedType;
            switch (selectedItem) {
                case vm.isTechnicalAssistance:
                    returnedType = ActisConstantes.type_technical_assistance;
                    break;
                case vm.isAccessoires:
                    returnedType = ActisConstantes.type_accessoires;
                    break;
                case vm.isPainting:
                    returnedType = ActisConstantes.type_painting;
                    break;
                case vm.isApproval:
                    returnedType = ActisConstantes.type_approval;
                    break;
                case vm.isZeBattery:
                    returnedType = ActisConstantes.type_ze_battery;
                    break;
                case vm.isGoodPractise:
                    returnedType = ActisConstantes.type_good_practise;
                    break;
                case vm.isAlert:
                    returnedType = ActisConstantes.type_alert;
                    break;
                case vm.isPilote:
                    returnedType = ActisConstantes.type_pilote;
                    break;
                case vm.isCalm:
                    returnedType = ActisConstantes.type_calm;
                    break;
                case vm.isAdministrative:
                    returnedType = ActisConstantes.type_administrative;
                    break;
            }
            return returnedType;
        }

        /**
         * @namespace onLoadPage
         * @desc hide all blocs expect general bloc
         * @memberOf Controller.onLoadPage
         */
        function onLoadPage() {
            vm.showBlocs = false;
        }

        /*=============================================
        =                 TOOLS                       =
        =============================================*/

        /**
         * @namespace hideBlocs
         * @desc hide all blocs, used when user choose another type fic
         * @memberOf Controller.hideBlocs
         */
        function hideBlocs() {
            vm.isTechnicalAssistance = false;
            vm.isCalm = false;
            vm.isAdministrative = false; 
            vm.isApproval = false;
            vm.isAccessoires = false;
            vm.isPainting = false;
            vm.isClosed = false;
            vm.isZeBattery = false;
            vm.isGoodPractise = false;
            vm.isAlert = false;
            vm.isPilote = false;
        }

        /**
         * @namespace removeButtonToRecapCar
         * @desc uses recapCar directive to get car context, and remove "Change Vehicle" button
         *
         */
        function removeButtonToRecapCar() {

            $timeout(function () {
                var carContextButtonElement = document.querySelectorAll("#carContextButton")[1];
                var buttonProperty = document.querySelectorAll(".phnx-clickable3")[1];
                if (carContextButtonElement) {
                    carContextButtonElement.parentElement.removeChild(carContextButtonElement);
                } else if (buttonProperty) {
                    buttonProperty.parentElement.removeChild(buttonProperty);
                }
            }, 0);

        }

        /**
         *
         * @param response
         * @returns {string}
         */

        function isolateCaseNumber(response) {

            var finalData = response.result.replace(/\\/g, '');
            var indexOfCaseNumber = finalData.indexOf('caseNumber');
            var lastPartOfString = finalData.substring(indexOfCaseNumber); // on garde la string à partir de caseNumber
            var isolateCaseNumberAndNumber = lastPartOfString.substring(0, lastPartOfString.indexOf(","));

            var indexOfDoublePoints = isolateCaseNumberAndNumber.indexOf(':');
            var lastPartOfStringNumber = isolateCaseNumberAndNumber.substring(indexOfDoublePoints); //
            var isolateNumber = lastPartOfStringNumber.substring(2, lastPartOfStringNumber.lastIndexOf('"'));

            return isolateNumber;
        }


        function createFicActis(isNewFic,isSaveAsDraft) {

            $q.resolve().then(function(){
                if(!vm.isQstomize && vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.recordType && vm.fic.CaseDetail.recordType !== 'QSTOMIZE'){
                    document.getElementById('Background_color').style.height = "350%";
                    return;
                }
                else{
                    document.getElementById('Background_color').style.height = "160%";
                    return qstomizeReqLabel(vm.fic.Request, vm.fic.Request);
                }
            }).then(function(){

                blockUI.start();
                CreateActisBusinessService.createFic(vm.fic).then(function (response) {
                    if (response.result.Car.mileageUnit) {
                        response.result.Car.mileageUnit = response.result.Car.mileageUnit.toUpperCase();
                    }
                    CacheService.setObject(CacheConstants.actisResponse, response.result);

                    //vm.caseNumber = isolateCaseNumber(response);
                    vm.isEditMode = true;
                    vm.responseApi = response.result;
                    if(vm.isIndependentUser && vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.recordType && vm.fic.CaseDetail.recordType !== 'QSTOMIZE' && vm.fic.CaseDetail.caseNumber === "") {
                        var tokenBalance = UtilsMetierService.getTokenBalance();
                        var userProfile = CacheService.getObject(CacheConstants.profil);
                        var email = userProfile.emailAlerte;
                        CreateActisBusinessService.getAssistancetokens(email).then(function (tokenResponse) {
                            if (tokenResponse) {
                                MainMetierService.reCheckAsomSubscriptions().then(function (userDetails) {
                                    if(userDetails && userDetails.asomSubscriptions && userDetails.asomSubscriptions.assistanceOfferSubscriptions){
                                        const latestTokenBalance = userDetails.asomSubscriptions.assistanceOfferSubscriptions.tokenBalance;
                                        if (latestTokenBalance > 0) {
                                            var encrypted = CryptoService.AES.encrypt(latestTokenBalance.toString(), CacheConstants.encryptedValue);
                                            CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());                                            
                                        }
                                        else if(latestTokenBalance === 0) {
                                            var encrypted = CryptoService.AES.encrypt(latestTokenBalance.toString(), CacheConstants.encryptedValue);
                                            CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());
                                            window.location.reload();
                                        }
                                    }                            
                                }).catch(function(error){
                                    if(tokenBalance > 0){
                                        var updateTokenBalance = tokenBalance - 1;
                                        var encrypted = CryptoService.AES.encrypt(updateTokenBalance.toString(), CacheConstants.encryptedValue);
                                        CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());
                                    }
                                });
                            }
                        });
                    }

                    if (isNewFic) {
                        toastr.success($translate.instant('FIC_SENT'));
                        vm.nonModifiableFic = true;
                        $state.go(RoutesConstants.ficConsultation);
                    } else {
                        //Needed for the delete button in header-component
                        vm.isDraft = true;
                        if(vm.responseApi && !_.isEmpty(vm.responseApi) && vm.responseApi.CaseDetail && !_.isEmpty(vm.responseApi.CaseDetail) && _.has(vm.responseApi.CaseDetail,'caseNumber') && !_.isEmpty(vm.responseApi.CaseDetail.caseNumber)){
                            vm.isStatusPresent = false;
                        }
                        // if(( vm.isForQstomize && vm.fic.Request && vm.fic.Request.cirDemand1 && !_.isEmpty(vm.fic.Request.cirDemand1)) && vm.fic.Request.cirDemand2 && !_.isEmpty(vm.fic.Request.cirDemand2)){
                        if(vm.isForQstomize && !vm.isNewFic) {
                            toastr.success($translate.instant('FIC_SAVED'));
                            vm.clearRefreshVin = false;
                            vm.refreshVin = false;                                                
                            $rootScope.$broadcast("clearRefreshVin", {
                                clearRefreshVin: vm.clearRefreshVin,
                                refreshVin: vm.refreshVin,
                                status : vm.responseApi.CaseDetail.status                          
                            });                        
                        } else if(vm.isActisFromDiag){
                            if((vm.fic.Request.fisrtNodeName && !_.isEmpty(vm.fic.Request.fisrtNodeName)) && vm.fic.Request.secondNodeName && !_.isEmpty(vm.fic.Request.secondNodeName)){
                                toastr.success($translate.instant('FIC_SAVED'));
                            } else {
                                toastr.error($translate.instant('CHECK_TREE_NODE'));
                            }
                        } else {
                            toastr.success($translate.instant('FIC_SAVED'));                        
                        }
                        if(isSaveAsDraft)
                        {
                        $state.go(RoutesConstants.ficConsultation);
                        }


                    }

                }).catch(function (error) {
                    if(vm.isForBwr)
                    {
                        vm.isEditMode = false;
                        vm.isDraft = false;
                        vm.fic.CaseDetail.status = '';
                    }
                    if(error){
                        toastr.error($translate.instant('ALERTS_ERROR_HTL'));
                    }
                }).finally(function () {
                    blockUI.stop();
                    if(vm.isForBwr&&vm.isEditMode&&vm.isDraft)
                    {
                        updateFicCache(vm.responseApi);
                    }
                    else if(!vm.isForBwr)
                    {
                        updateFicCache(vm.responseApi);
                    }
    
                });
            })
        }

        /**
         * Load data from Fic Consultation page
         * @param responseApi
         */
        function loadFic(responseApi) {


            //******* START CARCONTEXT SETUP ********************
            //responseApi.CaseDetail.status = responseApi.CaseDetail.status === 'Resolved' ? 'Answered' : responseApi.CaseDetail.status;
            var status = responseApi.CaseDetail.status;
            vm.isBrw = responseApi.CaseDetail.recordType==='BRW'&& $rootScope.previousState===RoutesConstants.ficConsultation &&(status.toLowerCase() === 'draft');
            vm.isQstomize = responseApi.CaseDetail.recordType==='QSTOMIZE'&& $rootScope.previousState===RoutesConstants.ficConsultation &&(status.toLowerCase() === 'draft');
            if (status.toLowerCase() === 'draft' || status.toLowerCase() === 'answered' || status.toLowerCase() === 'resolved' ){
                var vin = responseApi.Car.vin;
                var getCarContext;
                if (!_.isEmpty(vin)) {
					
					getCarContext = CarSearchMetierService.searchCar({vin: vin}).then(function(){
                         CarSearchMetierService.getBannerData();
                                    });
                }

                if (getCarContext) {
                    if(!vm.isQstomize){
                        document.getElementById('Background_color').style.height = "350%";
                    }
                    else{
                        document.getElementById('Background_color').style.height = "160%";
                    }
                    blockUI.start();
                    getCarContext.then(function () {
                        //var contextCarSearch = CacheService.getObject(CacheConstants.contextCarSearch);

                    }).finally(function () {
                        if(vm.isQstomize){
                        vm.carContext = CacheService.getObject(CacheConstants.contextCarSearch) 
                        $rootScope.$broadcast('getQstomise',vm.carContext);
                        }
                        blockUI.stop();
                    });
                }
            }

            vm.isForBwr = responseApi.CaseDetail.recordType === 'BRW' && $rootScope.previousState === RoutesConstants.ficConsultation;
            vm.isForQstomize = responseApi.CaseDetail.recordType === 'QSTOMIZE' && $rootScope.previousState === RoutesConstants.ficConsultation;

            if (responseApi.Car.mileageUnit && !vm.isForBwr && !vm.isForQstomize) {

                responseApi.Car.mileageUnit = responseApi.Car.mileageUnit.toUpperCase();
            }

            //******* END CARCONTEXT SETUP ********************

            CacheService.setObject(CacheConstants.actisResponse, responseApi);

            hideCarContextInformation();
            vm.isActisProfil = MainMetierService.isActisProfilNoContext();
            //vm.isActisProfil = true;

            if (responseApi.CaseDetail.status.toLowerCase() === 'answered' || responseApi.CaseDetail.status === 'Resolved') {
                vm.isAnswered = true;
                vm.nonModifiableFic = true;
                vm.isFicReopen = false;
            }

            if (responseApi.CaseDetail.status.toLowerCase() === 'draft') {
                vm.nonModifiableFic = false;
                vm.isDeleteButtonVisible = false;
                vm.isDraft = true;
                vm.isStatusPresent = false;
            }

            if (responseApi.CaseDetail.status.toLowerCase() === 'more info needed' || responseApi.CaseDetail.status === 'Reopen') {
                vm.isMoreInfoNeeded = true;
                vm.nonModifiableFic = true;
                vm.isFicReopen = false;
            }

            // FIC should be non-modifiable when Salesforce sends these status
            if (responseApi.CaseDetail.status === 'In Progress' || responseApi.CaseDetail.status === 'Email Received' ||
                responseApi.CaseDetail.status === 'Waiting Expert Answer' || responseApi.CaseDetail.status === 'Expert Answer Received' ||
                responseApi.CaseDetail.status === 'Draft In Queue' || responseApi.CaseDetail.status === 'Waiting Email Answer' ||
                responseApi.CaseDetail.status === 'New' || responseApi.CaseDetail.status === 'Back To Queue' ||
                responseApi.CaseDetail.status === 'Back') {
                vm.nonModifiableFic = true;
                vm.isStatusPresent = true;
            }

            if (responseApi.CaseDetail.status === 'Closed' && responseApi.CaseDetail.closedDate) {
                var todaysDate = moment(new Date());
                var responseApiDate = moment(responseApi.CaseDetail.closedDate);
                var difference = todaysDate.diff(responseApiDate, 'days');
                if (difference <= vm.daysToReopen) {
                    vm.isFicReopen = true;
                    vm.isAnswered = false;
                    vm.isDeleteButtonVisible = false;
                    vm.isSaveButtonVisible = false;
                    vm.isSendButtonVisible = false;
                    vm.nonModifiableFic = true;
                }
            }

            vm.isLoadFic = true;
            vm.isEditMode = true;
            vm.responseApi = responseApi;
        }

        /**
         * @namespace closedStatusFic
         * @description Used to close a FIC
         */

        function closedStatusFic(isClosed) {
            if (isClosed && (vm.responseApi.CaseDetail.status === 'Answered' || vm.responseApi.CaseDetail.status === 'Resolved')) {
                var userProfile = CacheService.getObject(CacheConstants.profil);
                var dealerId = userProfile.dealerId;
                $scope.getFicData();

                var payload = {
                    caseNumber: vm.responseApi.CaseDetail.caseNumber,
                    caseId: vm.responseApi.CaseDetail.caseId
                };

                $mdDialog.show({

                    templateUrl: 'app/components/actis/listFic/closeFicPopIn.template.html',
                    controller: 'closeFicPopInController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        payload: function () {
                            return payload;
                        }
                    }
                }).then(function (result) {
                    if (result && result.confirmClose) {
                        $state.go(RoutesConstants.ficConsultation);
                        toastr.success($translate.instant('FIC_CLOSED'));
                    }
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });
            }
        }

        /**
         * @namespace reOpenFic
         * @param {*} isFicreopen
         * @description Used to reOpen a FIC if it has been closed for less than vm.daysToReopen days
         */

        function reOpenFic(isFicReopen) {
            if (isFicReopen && vm.responseApi.CaseDetail.status === 'Closed') {
                vm.isFicReopen = false;
                vm.isAnswered = false;
                vm.isDeleteButtonVisible = true;
                vm.isSaveButtonVisible = true;
                vm.isFicCancelled = true;
                vm.isSendButtonVisible = true;
                vm.nonModifiableFic = true;
                vm.isDiscussionCommentBox = true;
                vm.isDaysToReopen = true;
            }
        }

        function saveFicAsDraft(isNewFic, status, dealerId) {
            $mdDialog.show({
                templateUrl: 'app/components/actis/components/SupportIndendependentModePopup.html',
                controller: 'supportIndendependentModePopupController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false
            }).then(function (response) {
                var userProfile = CacheService.getObject(CacheConstants.profil);

                if (response.isFicSentEnabled) {
                    if (status === "save") {
                        vm.fic.CaseDetail.status = 'Draft';
                        vm.isDraft = true;
                        isNewFic=false;
                        createFicActis(isNewFic,true);
                    }
                    else if (status === "send") {
                        vm.isNewFic = false;
                        updateFic(userProfile, dealerId,true);
                    }
                }
                else {
                }
            });
        }

        function deductTokenBalance(isNewFic, status, dealerId) {
            var userProfile = CacheService.getObject(CacheConstants.profil);
            if (vm.isIndependentUser) {
                if ((vm.tokenBalance > 0 && vm.fic.CaseDetail.caseNumber ===  "") || (vm.fic.CaseDetail.caseNumber !== "")) {     
                    if (status === "save") {                        
                        createFicActis(isNewFic);
                    }
                    else if (status === "send") {
                        updateFic(userProfile, dealerId);
                    }
                } else {
                    saveFicAsDraft(isNewFic, status, dealerId);    
                }
            }
        }

        function qstomizeReqLabel(responseData, ficData, isSaveData){

            var localLang = $translate.use();
            return $translate.use('en').then(function(langId){
                
                responseData.cirDemand1 = ficData.cirDemand1 ? (isSaveData ? $translate.instant(ficData.cirDemand1) : ficData.cirDemand1) : "";
                responseData.cirDemand2 = ficData.cirDemand2 ? (isSaveData ? $translate.instant(ficData.cirDemand2) : ficData.cirDemand2) : "";
                responseData.cirDemand1Label = ficData.cirDemand1Label ? ficData.cirDemand1Label : "";
                responseData.cirDemand2Label = ficData.cirDemand2Label ? ficData.cirDemand2Label : "";

                $translate.use(localLang);

                return;
            });
        }

        /**
         * @namespace cancelFic
         * @param {*} isFicCancelled
         * @description Used to Cancel a FIC
         */

        function cancelFic(isFicCancelled) {
            if (isFicCancelled) {
                vm.isFicReopen = true;
                vm.isDiscussionCommentBox = false;
                $rootScope.$broadcast("saveOrSendCheck", { isNewFicType: false });
            }
        }

        /**
         * @description Used to color the mandatory fields while sending a FIC
         */
        function colorMandatoryFields() {
            if (vm.requiredFields && vm.requiredFields.length) {
                var reqFields = Array.prototype.slice.call(vm.requiredFields);
                reqFields.forEach(function (item) {
                    var element = angular.element(item);
                    if (element[0].tagName === 'TEXTAREA') {
                        var label = $(element).parent().parent().children().first();
                        var e = angular.element(label);
                        e.addClass('changeTextColorToRed');
                        var parent = $(element).parent().parent();
                        parent.addClass('md-input-invalid');
                    } else if (element[0].tagName === 'INPUT' || element[0].tagName === 'MD-DATEPICKER') {
                        var label = $(element).parent();
                        var first = $(label).children().first();
                        var e = angular.element(first);
                        e.addClass('changeTextColorToRed');
                        label.addClass('md-input-invalid');
                    } else if (element[0].tagName === 'MD-SELECT' || element[0].id === 'ots-dropdown') {
                        // Handle OTS dropdown and other MD-SELECT elements
                        var otsLabel = $('label[for="ots-dropdown"]');
                        if (otsLabel.length) {
                            otsLabel.addClass('changeTextColorToRed');
                        }
                        var container = $(element).closest('md-input-container');
                        if (container.length) {
                            container.addClass('md-input-invalid');
                        }
                        element.addClass('backgroundColorRequiredFieldsOTSDropdown');
                    } else if (element[0].id === 'bt-dropdown') {

                        var btLabel = $('label[for="bt-dropdown"]');
                        if (btLabel.length) {
                            btLabel.addClass('changeTextColorToRed');
                        }
                        var container = $(element).closest('md-input-container');
                        if (container.length) {
                            container.addClass('md-input-invalid');
                        }
                        element.addClass('backgroundColorRequiredFieldsBTDropdown');

                    }
                    if (element[0].tagName === 'TEXTAREA' || element[0].tagName === 'INPUT') {
                        element.addClass('backgroundColorRequiredFields');
                    }
                })
            }
        }

        function highlightOtsField() {
            var otsDropdown = document.getElementById('ots-dropdown');
            if (!otsDropdown) {
                return;
            }

            var element = angular.element(otsDropdown);
            var otsLabel = $('label[for="ots-dropdown"]');
            if (otsLabel.length) {
                otsLabel.addClass('changeTextColorToRed');
            }

            var container = $(element).closest('md-input-container');
            if (container.length) {
                container.addClass('md-input-invalid');
            }

            element.addClass('backgroundColorRequiredFieldsOTSDropdown');
        }

        /**
         * @desc display field specific eror message
         */
        function displaySpecificError(){

            var reqFields = Array.prototype.slice.call(vm.requiredFields);

                    if(reqFields.length > 1){
                        reqFields.forEach(function(item){
                            var element = angular.element(item);
                            if ( vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.status ==="Draft" && vm.isDraft && vm.isActisFromDiag &&  (_.isEmpty(vm.fic.Request.fisrtNodeName) ||  _.isEmpty(vm.fic.Request.secondNodeName) || _.isEmpty(vm.fic.Request.selectedOts))){
                                if(element[0].id === "treeNodeSelected"){
                                    toastr.error($translate.instant("CHECK_TREE_NODE"));
                                }
                            }else{
                            if(element[0].id === ActisConstantes.mileage_id){
                                toastr.error($translate.instant("FIC_ERROR_REAL_MILEAGE"));
                            }
                        }
                        })
                        toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));
                    }else if(reqFields.length === 1){
                        var elem = angular.element(reqFields);
                        if ( vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.status ==="Draft" && vm.isDraft && vm.isActisFromDiag &&  (_.isEmpty(vm.fic.Request.fisrtNodeName) ||  _.isEmpty(vm.fic.Request.secondNodeName) || _.isEmpty(vm.fic.Request.selectedOts))){
                            if(elem[0].id === "treeNodeSelected"){
                                toastr.error($translate.instant("CHECK_TREE_NODE"));
                            } 
                        }else{
                        if(elem[0].id === ActisConstantes.mileage_id){
                            toastr.error($translate.instant("FIC_ERROR_REAL_MILEAGE"));
                        }
                        else{
                            toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));
                        }
                    }
                }
        }

        /**
         * @namespace saveFic
         * @desc calls API to save FIC and throw a toastr to confirm it has been saved.
         *
         */
        function saveFic(isNewFic, isTreeStructureNodeSelected) {

            if (window && typeof window.scrollTo === 'function') {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            } else {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }

            var typeName = findTypeFicNumber();
            var errorFound = false;
            if(isNewFic && (vm.isTechnicalAssistance || vm.isCalm || vm.isAdministrative || vm.isApproval || vm.isAlert || vm.isGoodPractise || vm.isZeBattery)){
                vm.containsProblemFreqBtn = true;
            }
            else { 
                vm.containsProblemFreqBtn = false;
            }
            //Load vm's data from all component
            $scope.getFicData();
            $timeout(function () {
                if (!vm.btValue && vm.fic && vm.fic.Request && vm.fic.Request.tintname) {
                    vm.btValue = vm.fic.Request.tintname;
                }
                if (!_.isEmpty(vm.fic) && !_.isEmpty(vm.fic.Request) && !_.isEmpty(vm.fic.Request.fisrtNodeName) && !_.isEmpty(vm.fic.Request.secondNodeName)) {
                    isTreeStructureNodeSelected = true;
                }
                else {
                    isTreeStructureNodeSelected = false;
                }

                var responseFormValidation = FicInputValidationService.formValidation(vm.responseApi, isNewFic, vm.isForBwr, vm.containsProblemFreqBtn, isTreeStructureNodeSelected, vm.isForQstomize);
                vm.isFormValid = responseFormValidation.isFormValid;
                vm.requiredFields = responseFormValidation.invalidFields;

            var userProfile = CacheService.getObject(CacheConstants.profil);
            var dealerId = userProfile.dealerId;//123456;


            vm.fic.Dealer.contactFirstName = userProfile.firstName;
            vm.fic.Dealer.contactLastName = userProfile.lastName;
            vm.fic.Dealer.dealerId = dealerId;
            vm.fic.CaseDetail.recordType = typeName;
            vm.fic.Dealer.contactId = (userProfile && userProfile.hasOwnProperty('contactId') && userProfile.contactId !== null && userProfile.contactId !== undefined && userProfile.contactId !== '')
                                            ? userProfile.contactId
                                            : ((userProfile && userProfile.emailAlerte) ? userProfile.emailAlerte : '');


                var todaysDate;
                var responseApiDate;
                var difference;
                if (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.closedDate) {
                    todaysDate = moment(new Date());
                    responseApiDate = moment(vm.responseApi.CaseDetail.closedDate);
                    difference = todaysDate.diff(responseApiDate, 'days');
                }

                $rootScope.$broadcast("saveOrSendCheck", {
                    isNewFicType: isNewFic
                });
                $q.resolve().then(function () {

                if(vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.recordType && vm.fic.CaseDetail.recordType === 'QSTOMIZE'
                    && vm.fic.Request && !_.isEmpty(vm.fic.Request)){
                        return qstomizeReqLabel(vm.fic.Request, vm.fic.Request, true);
                }else{
                    return;
                }

            }).then(function(){

                //means the fic is about to be created
                if (vm.fic.CaseDetail.status === '' || angular.isUndefined(vm.fic.CaseDetail.status)) {

                    if (isNewFic) {

                        if (vm.isFormValid) {
                            vm.isNewFic = true;
                            vm.isDraft = false;
                            vm.fic.CaseDetail.status = 'New';

                        } else {
                            errorFound = true;

                        }
                    } else if (vm.isDeletedFic) {
                        vm.isDraft = false;
                        vm.fic.CaseDetail.status = 'Abandoned';
                    } else {
                        vm.fic.CaseDetail.status = 'Draft';
                        vm.isDraft = true;
                    }
                    if (!errorFound && !vm.isForQstomize) {
                        if (!vm.isForBwr && vm.fic.CaseDetail.status ==="Draft" && vm.isDraft && vm.fic.Request && (_.isEmpty(vm.fic.Request.fisrtNodeName) ||  _.isEmpty(vm.fic.Request.secondNodeName) || _.isEmpty(vm.fic.Request.selectedOts))){
                            displaySpecificError();
                            if (_.isEmpty(vm.fic.Request.selectedOts)) {
                                highlightOtsField();
                            }
                        }
                        else
                        {
                            if (vm.isIndependentUser) {
                                if (isNewFic) {
                                    deductTokenBalance(isNewFic, "save");
                                }
                                else {
                                    createFicActis(isNewFic);
                                }
                            }else{
                                if(vm.isForBwr && !vm.isFormValid){
                                    displaySpecificError();
                                    if(vm.fic.CaseDetail.status === "Draft"){
                                        vm.isDraft = false;
                                    }
                                }
                                if (vm.isActisFromDiag && vm.isAlert && isNewFic && vm.fic.Request && !vm.fic.Request.problemCharacteristics) {
                                    toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));
                                }
                                else{
                                    createFicActis(isNewFic);
                                }
                                if(vm.fic.CaseDetail.recordType !== "BRW" && vm.fic.CaseDetail.recordType !== "QSTOMIZE"){
                                    if(isNewFic && vm.fic && (vm.fic.Request && !vm.fic.Request.problemFrequencyType && (vm.fic.Request.problemFrequencyType == null || vm.fic.Request.problemFrequencyType == undefined)) || (vm.fic.CaseDetail.recordType === "Agreement CIRs" && _.isEmpty(vm.fic.Request.reference)) || ((vm.fic.Car.isVehicleAccessories && typeof vm.fic.Car.isVehicleAccessories !== 'boolean') || (vm.fic.Car.isVehicleImmobilised && typeof vm.fic.Car.isVehicleImmobilised !== 'boolean') || (vm.fic.Car.isVehicleTransformed && typeof vm.fic.Car.isVehicleTransformed !== 'boolean'))){
                                        vm.isNewFic = false;
                                        toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));
                                    }
                                }
                            }
                        }
                    }
                    else if(!errorFound && vm.isForQstomize) {
                        if((!isNewFic && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) || (isNewFic && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || (vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) && vm.fic.Request && vm.fic.Request.cirDemand1 && vm.fic.Request.cirDemand2 && vm.fic.Request.customerComplaint && !_.isEmpty(vm.fic.Request.cirDemand1) && !_.isEmpty(vm.fic.Request.cirDemand2) && !_.isEmpty(vm.fic.Request.customerComplaint))){
                            createFicActis(isNewFic);
                        }
                        else{
                            vm.isNewFic = false;
                            toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));  
                        }
                    } else {
                        displaySpecificError();
                        colorMandatoryFields();
                    }
                } else {

                    if (isNewFic && vm.isFormValid) {

                        vm.isNewFic = true;
                    } else if (vm.fic.CaseDetail.status && vm.fic.CaseDetail.status.toLowerCase() !== 'draft' || (vm.fic.CaseDetail.status === 'Closed' && difference && difference <= vm.daysToReopen)) {
                        errorFound = true;
                        if ((vm.fic.CaseDetail.status && (vm.fic.CaseDetail.status === 'Closed' && difference <= vm.daysToReopen)) && _.isEmpty(vm.description)) {
                            toastr.error($translate.instant('FIC_NOT_DEFINED'));
                            var descriptionEmpty = angular.element(document.querySelector('#descriptionUndefined'));
                            descriptionEmpty.addClass('borderRed');
                        } else {
                            displaySpecificError();
                            colorMandatoryFields();
                        }
                    }

                    if (!(vm.isFormValid) && isNewFic && vm.fic.CaseDetail.status && vm.fic.CaseDetail.status !== 'Answered' && vm.fic.CaseDetail.status !== 'Resolved' && vm.fic.CaseDetail.status !== 'Closed') {
                        displaySpecificError();
                        colorMandatoryFields();
                    } else if (!errorFound) {
                        if (vm.isIndependentUser)
                    { 
                        if (vm.isNewFic && !vm.isForQstomize) {
                            deductTokenBalance(vm.isNewFic, "send", dealerId);
                        }
                        else {
                            if((!isNewFic && !vm.isForQstomize) || (!isNewFic && vm.isForQstomize && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) || (vm.isForQstomize && isNewFic && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || (vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) && vm.fic.Request && vm.fic.Request.cirDemand1 && vm.fic.Request.cirDemand2 && vm.fic.Request.customerComplaint && !_.isEmpty(vm.fic.Request.cirDemand1) && !_.isEmpty(vm.fic.Request.cirDemand2) && !_.isEmpty(vm.fic.Request.customerComplaint)) || (vm.isForQstomize && isNewFic && (vm.responseApi.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.responseApi.Car.vin && !_.isEmpty(vm.responseApi.Car.vin) || (vm.responseApi.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) && vm.responseApi.Request && vm.responseApi.Request.cirDemand1 && vm.responseApi.Request.cirDemand2 && vm.responseApi.Request.customerComplaint && !_.isEmpty(vm.responseApi.Request.cirDemand1) && !_.isEmpty(vm.responseApi.Request.cirDemand2) && !_.isEmpty(vm.responseApi.Request.customerComplaint))){
                                updateFic(userProfile, dealerId);
                            }
                            else{
                                vm.isNewFic = false;
                                toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));  
                            }
                        }
                    }else{
                        if(vm.isForQstomize){
                            if((!isNewFic && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) || (isNewFic && (vm.fic.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.fic.Car.vin && !_.isEmpty(vm.fic.Car.vin) || (vm.fic.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) && vm.fic.Request && vm.fic.Request.cirDemand1 && vm.fic.Request.cirDemand2 && vm.fic.Request.customerComplaint && !_.isEmpty(vm.fic.Request.cirDemand1) && !_.isEmpty(vm.fic.Request.cirDemand2) && !_.isEmpty(vm.fic.Request.customerComplaint)) || (isNewFic && (vm.responseApi.Request.cirDemand2 != $translate.instant("ORDER_FOR_STOCK") && vm.responseApi.Car.vin && !_.isEmpty(vm.responseApi.Car.vin) || (vm.responseApi.Request.cirDemand2 == $translate.instant("ORDER_FOR_STOCK"))) && vm.responseApi.Request && vm.responseApi.Request.cirDemand1 && vm.responseApi.Request.cirDemand2 && vm.responseApi.Request.customerComplaint && !_.isEmpty(vm.responseApi.Request.cirDemand1) && !_.isEmpty(vm.responseApi.Request.cirDemand2) && !_.isEmpty(vm.responseApi.Request.customerComplaint))){
                                updateFic(userProfile, dealerId);
                            }
                            else{
                                vm.isNewFic = false;
                                toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD"));  
                            }
                        }
                        if(vm.fic.CaseDetail.recordType !== "BRW" && vm.fic.CaseDetail.recordType !== "QSTOMIZE"){
                            if(isNewFic && vm.fic && ((vm.fic.Request && !vm.fic.Request.problemFrequencyType && (vm.fic.Request.problemFrequencyType == null || vm.fic.Request.problemFrequencyType === undefined)) || (vm.isAlert && vm.fic.Request && !vm.fic.Request.problemCharacteristics && (vm.isActisFromDiag || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status == "Draft")) ) || ((vm.isActisFromDiag || (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status == "Draft")) && vm.isAlert && (!vm.filesToBeShown || (vm.filesToBeShown && vm.filesToBeShown.length == 0))) || (vm.fic.CaseDetail.recordType === "Agreement CIRs" && _.isEmpty(vm.fic.Request.reference)))){
                                vm.isNewFic = false;
                                toastr.error($translate.instant("FIC_ERROR_MANDATORY_FIELD")); 
                            }
                            else {
                                updateFic(userProfile, dealerId);
                            }
                        }
                        else {
                            updateFic(userProfile, dealerId);
                        }

                    }
                    }

                    }
                });

            }, 300);
        }

        /**
         * @namespace updateFic
         * @desc calls API to update FIC and throw a toastr to confirm it has been updated.
         *
         */

        function updateFic(userProfile, dealerId,isSaveAsDraft) {
            $q.resolve().then(function(){
            if(!vm.isQstomize){
                document.getElementById('Background_color').style.height = "350%";
                return;
            }
            else{
                document.getElementById('Background_color').style.height = "160%";

                if(vm.responseApi && vm.responseApi.Request && vm.fic && vm.fic.Request && !_.isEmpty(vm.fic.Request)){
                    return qstomizeReqLabel(vm.responseApi.Request, vm.fic.Request); 
                }else{
                    return;
                }
            }

            }).then(function(){

                var todaysDate;
                var responseApiDate;
                var difference;

            if (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.closedDate) {
                todaysDate = moment(new Date());
                responseApiDate = moment(vm.responseApi.CaseDetail.closedDate);
                difference = todaysDate.diff(responseApiDate, 'days');
                updateFicCache(vm.responseApi);

            }
            if (vm.isDeletedFic) {
                vm.fic.CaseDetail.status = 'Abandoned';
            } else if (vm.isNewFic) {
                if (vm.fic.CaseDetail.status === 'Draft') {
                    vm.fic.CaseDetail.status = 'New';
                } else if ((vm.fic.CaseDetail.status === 'Answered' || vm.fic.CaseDetail.status === 'Resolved') && !_.isEmpty(vm.description)) {
                    vm.fic.CaseDetail.status = 'More Info Needed';
                } else if (vm.fic.CaseDetail.status === 'Closed' && !_.isEmpty(vm.description) && difference <= vm.daysToReopen) {
                    vm.fic.CaseDetail.status = 'Reopen';
                }
            } else if ((vm.fic.CaseDetail.status === 'Answered' || vm.fic.CaseDetail.status === 'Resolved') && !_.isEmpty(vm.description)) {
                vm.fic.CaseDetail.status = 'More Info Needed';
            } else if (vm.fic.CaseDetail.status === 'Closed' && !_.isEmpty(vm.description) && difference <= vm.daysToReopen) {
                vm.fic.CaseDetail.status = 'Reopen';
            }
            if (((vm.fic.CaseDetail.status && (vm.fic.CaseDetail.status === 'Answered' || vm.fic.CaseDetail.status === 'Resolved')) || (vm.fic.CaseDetail.status === 'Closed' && difference <= vm.daysToReopen)) && _.isEmpty(vm.description)) {
                toastr.error($translate.instant('FIC_NOT_DEFINED'));
                var descriptionEmpty = angular.element(document.querySelector('#descriptionUndefined'));
                descriptionEmpty.addClass('borderRed');
                updateFicCache(vm.responseApi);

            } else {
                blockUI.start();
                CreateActisBusinessService.updateFic(userProfile, dealerId, vm.responseApi, vm.fic,vm.btValue).then(function (response) {
                    
                        response.result.Car.vin = vm.fic.Car.vin;
                        response.result.Car.model = vm.fic.Car.model;
                        response.result.Car.registrationNumber = vm.fic.Car.registrationNumber;
                        CacheService.setObject(CacheConstants.actisResponse, response.result);

                        vm.responseApi = response.result;
                        if(vm.isIndependentUser && vm.fic && vm.fic.CaseDetail && vm.fic.CaseDetail.recordType && vm.fic.CaseDetail.recordType !== 'QSTOMIZE' && vm.fic.CaseDetail.caseNumber === "") {
                            var tokenBalance = UtilsMetierService.getTokenBalance();
                            var userProfile = CacheService.getObject(CacheConstants.profil);
                            var email = userProfile.emailAlerte;
                            CreateActisBusinessService.getAssistancetokens(email).then(function (tokenResponse) {
                                if (tokenResponse) {
                                    MainMetierService.reCheckAsomSubscriptions().then(function (userDetails) {
                                        if(userDetails && userDetails.asomSubscriptions && userDetails.asomSubscriptions.assistanceOfferSubscriptions){
                                            const latestTokenBalance = userDetails.asomSubscriptions.assistanceOfferSubscriptions.tokenBalance;
                                            if (latestTokenBalance > 0) {
                                                var encrypted = CryptoService.AES.encrypt(latestTokenBalance.toString(), CacheConstants.encryptedValue);
                                                CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());                                            
                                            }
                                            else if(latestTokenBalance === 0) {
                                                var encrypted = CryptoService.AES.encrypt(latestTokenBalance.toString(), CacheConstants.encryptedValue);
                                                CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());
                                                window.location.reload();
                                            }
                                        }                            
                                    }).catch(function(error){
                                        if(tokenBalance > 0){
                                            var updateTokenBalance = tokenBalance - 1;
                                            var encrypted = CryptoService.AES.encrypt(updateTokenBalance.toString(), CacheConstants.encryptedValue);
                                            CacheService.setObject(CacheConstants.tokenBalance, encrypted.toString());
                                        }
                                    });
                                }
                            });
                        }

                        if (vm.responseApi && (vm.responseApi.CaseDetail.status === 'More Info Needed' || vm.responseApi.CaseDetail.status === 'Reopen')) {
                            vm.responseApi.CaseDetail.status = $translate.instant(vm.responseApi.CaseDetail.status);
                            toastr.success($translate.instant('FIC_SENT'));
                            $state.go(RoutesConstants.ficConsultation);
                        } else if (vm.responseApi && vm.responseApi.CaseDetail.status === 'Abandoned') {
                            vm.responseApi.CaseDetail.status = $translate.instant(vm.responseApi.CaseDetail.status);
                            toastr.success($translate.instant('FIC_ABANDONED'));
                            $state.go(RoutesConstants.ficConsultation);
                        } else if (vm.isNewFic && vm.responseApi.CaseDetail.status !== 'More Info Needed') {
                            if (vm.isFormValid) {
                                vm.isEditMode = true;
                                vm.responseApi.CaseDetail.status = 'New';
                                if (!vm.showFicSent) {
                                    toastr.success($translate.instant('FIC_SENT'));    
                                }
                                $state.go(RoutesConstants.ficConsultation);
                                vm.nonModifiableFic = true;
                                vm.isStatusPresent = true;
                                vm.showFicSent = true;
                            }

                        } else if (vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.status && !vm.isNewFic) {
                            
                            if(vm.showFicSave){
                                toastr.success($translate.instant('FIC_SAVED'));   
                            }
                            vm.showFicSave = true;
                            if(isSaveAsDraft)
                    {
                    $state.go(RoutesConstants.ficConsultation);
                    }
                        }

                    }
                ).catch(function (error) {
                    vm.isNewFic = false;
                    if(error){
                        toastr.error($translate.instant('ALERTS_ERROR_HTL'));
                    }
                }).finally(function () {
                    updateFicCache(vm.responseApi);
                    blockUI.stop();
                });
            }
        })
        }

        /**
         * Fic status is updated to Abandoned
         *
         */
        function onDeleteFic() {
            vm.isDeletedFic = true;
            saveFic();
        }


        function updateFicCache(ficData) {

            var contextSearchedSymptom = CacheService.getObject(CacheConstants.searchedSymptom);
            vm.isCreateActisSearchedSymptom = CacheService.getObject(CacheConstants.isCreateActisSearchedSymptom);
            vm.consultationFIC.symptomLabel = '';
            if (contextSearchedSymptom) {
                if (contextSearchedSymptom.label !== null || contextSearchedSymptom.label !== undefined || contextSearchedSymptom.label !== '') {
                    vm.consultationFIC.symptomLabel = contextSearchedSymptom.label;
                }
            }

            vm.consultationFIC.cirDemand1Label = (vm.fic && vm.fic.Request && vm.fic.Request.cirDemand1Label) ? vm.fic.Request.cirDemand1Label : "";
            vm.consultationFIC.cirDemand2Label = (vm.fic && vm.fic.Request && vm.fic.Request.cirDemand2Label) ? vm.fic.Request.cirDemand2Label : "";
            vm.consultationFIC.cirDemand1 = (vm.fic && vm.fic.Request && vm.fic.Request.cirDemand1) ? vm.fic.Request.cirDemand1 : "" ;
            vm.consultationFIC.cirDemand2 = (vm.fic && vm.fic.Request && vm.fic.Request.cirDemand2) ? vm.fic.Request.cirDemand2 : "";
            if(vm.isForQstomize && vm.fic.CaseDetail.recordType === "QSTOMIZE"){
                vm.consultationFIC.customerComplaint = (vm.fic && vm.fic.Request && vm.fic.Request.customerComplaint) ? vm.fic.Request.customerComplaint : "";
            }
            else{
                vm.consultationFIC.customerComplaint = (ficData && ficData.Request && ficData.Request.customerComplaint) ? ficData.Request.customerComplaint : "";
            }
            vm.consultationFIC.ficNumber = (ficData && ficData.CaseDetail && ficData.CaseDetail.caseNumber) ? ficData.CaseDetail.caseNumber : "";
            vm.consultationFIC.or = (ficData && ficData.Request && ficData.Request.orNumber) ? ficData.Request.orNumber : "";
            vm.consultationFIC.dateOr = (ficData && ficData.Request && ficData.Request.orDate) ? ficData.Request.orDate : "";
            vm.consultationFIC.symptonCode = (ficData && ficData.Request && ficData.Request.symptomCode) ? ficData.Request.symptomCode : "";
            vm.consultationFIC.customerComplaint = (vm.consultationFIC && vm.consultationFIC.customerComplaint) ? vm.consultationFIC.customerComplaint : "";
            vm.consultationFIC.isCustomerComplaintReproduced = (ficData && ficData.Request && ficData.Request.isCustomerComplaintReproduced) ? ficData.Request.isCustomerComplaintReproduced : "";
            vm.consultationFIC.diagnosticComment = (vm.responseApi && vm.responseApi.Request && vm.responseApi.Request.diagnosticComment) ? vm.responseApi.Request.diagnosticComment : "";
            var profil = CacheService.getObject(CacheConstants.profil);
            vm.consultationFIC.language = profil.portal.label;
            var now = new Date();
            var minutes = now.getMinutes();
            if (minutes == '0') {
                minutes = '00';
            }
            vm.consultationFIC.date = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear() + " " + now.getHours() + ":" + minutes;
            vm.consultationFIC.isDocumentationConsulted = (ficData && ficData.Request && ficData.Request.isDocumentationConsulted) ? ficData.Request.isDocumentationConsulted : "";
            vm.consultationFIC.tintName = (ficData && ficData.Request && ficData.Request.tintName) ? ficData.Request.tintName : "";
            vm.consultationFIC.frequenceProbleme = (ficData && ficData.Request && ficData.Request.problemFrequency) ? ficData.Request.problemFrequency : "";
            vm.consultationFIC.dtcCode1 = (ficData && ficData.Request && ficData.Request.dtcCode1) ? ficData.Request.dtcCode1 : "";
            vm.consultationFIC.dtcCode2 = (ficData && ficData.Request && ficData.Request.dtcCode2) ? ficData.Request.dtcCode2 : "";
            vm.consultationFIC.dtcCode3 = (ficData && ficData.Request && ficData.Request.dtcCode3) ? ficData.Request.dtcCode3 : "";
            vm.consultationFIC.problemCharacteristics = (ficData && ficData.Request && ficData.Request.problemCharacteristics) ? ficData.Request.problemCharacteristics : "";
            vm.consultationFIC.opecode = (ficData && ficData.Request && ficData.Request.opeCode) ? ficData.Request.opeCode : "";
            vm.consultationFIC.time = (ficData && ficData.Request && ficData.Request.opeCodeTime) ? ficData.Request.opeCodeTime : "";
            vm.consultationFIC.checkboxesPermanentOrIntermittentValue = ((ficData && ficData.Request && ficData.Request.problemFrequencyType && ficData.Request.problemFrequencyType.length > 0) ? ficData.Request.problemFrequencyType : "Permanent");
            vm.consultationFIC.immatriculation = (ficData && ficData.Car && ficData.Car.registrationNumber) ? ficData.Car.registrationNumber : "";
            vm.consultationFIC.problemFrequencyHot = ((ficData && ficData.Request && ficData.Request.problemCharacteristics && ficData.Request.problemCharacteristics.indexOf('Warm State') !== -1) ? true : false);
            vm.consultationFIC.problemFrequencyCold = ((ficData && ficData.Request && ficData.Request.problemCharacteristics && ficData.Request.problemCharacteristics.indexOf('Cold State') !== -1) ? true : false);
            vm.consultationFIC.problemFrequencyStoppedCar = ((ficData && ficData.Request && ficData.Request.problemCharacteristics && ficData.Request.problemCharacteristics.indexOf('Idle') !== -1) ? true : false);
            vm.consultationFIC.problemFrequencyMovingCar = ((ficData && ficData.Request && ficData.Request.problemCharacteristics && ficData.Request.problemCharacteristics.indexOf('Moving') !== -1) ? true : false);
            vm.consultationFIC.isAgreementType = ((ficData && ficData.CaseDetail && ficData.CaseDetail.recordType && ficData.CaseDetail.recordType === "Agreement CIRs") ? true : false);
            if (vm.consultationFIC.isAgreementType) {
                vm.consultationFIC.agreementMo = (ficData && ficData.Request && ficData.Request.maximumRepairCostExTax) ? ficData.Request.maximumRepairCostExTax : "";
                vm.consultationFIC.agreementStatus = (ficData && ficData.Request && ficData.Request.agreementValidation) ? ficData.Request.agreementValidation : "";
                vm.consultationFIC.agreementDesignation = (ficData && ficData.Request && ficData.Request.operationApprovalDesignation) ? ficData.Request.operationApprovalDesignation : "";
                vm.consultationFIC.agreementIntervention = (ficData && ficData.Request && ficData.Request.maximumLabourCostExTax) ? ficData.Request.maximumLabourCostExTax : "";
                vm.consultationFIC.agreementPieces = (ficData && ficData.Request && ficData.Request.maximumPartsCostExTax) ? ficData.Request.maximumPartsCostExTax : "";
                vm.consultationFIC.agreements = (ficData && ficData.agreements) ? ficData.agreements : "";
            }
            if ($state && $state.params && $state.params.isActisUserComingFromFicConsultation) {
                vm.consultationFIC.code = 'M000';
                vm.consultationFIC.label = '';
                vm.consultationFIC.createMotrioFic = true;
            } else if ($state && $state.params && $state.params.data && _.isEmpty(ficData.Car.vin)) {
                vm.consultationFIC.code = 'M000';
                vm.consultationFIC.label = '';
            }


            vm.consultationFIC.status = (ficData && ficData.CaseDetail && ficData.CaseDetail.status) ? $translate.instant(FicViewListWSService.convertStatusToND(ficData.CaseDetail.status)) : "";
            if ((ficData && ficData.result && ficData.result.CaseDetail && ficData.result.CaseDetail.status) && ficData.result.CaseDetail.status === 'Draft') {
                vm.typesFIC = [
                    {id: 1, name: 'Assistance technique'},
                    {id: 2, name: 'Agrément'},
                    {id: 3, name: 'Alerte'},
                    {id: 4, name: 'Bonne pratique'},
                    {id: 5, name: 'ZE Batterie'},
                    {id: 6, name: 'Accessoire'},
                    {id: 7, name: 'Peinture'}
                ];
            } else {
                //Used to set the typeFic dropdown menu to the value obtained from the NAT Case Get response
                if(ficData && ficData.CaseDetail && ficData.CaseDetail.recordType){
                    vm.typesFIC = [
                        CreateActisBusinessService.findRelatedRecordTypeToFicType(ficData.CaseDetail.recordType)
                    ];
                }
            }
            vm.selectedTypeFIC = (ficData && ficData.CaseDetail && ficData.CaseDetail.recordType) ? CreateActisBusinessService.findRelatedRecordTypeToFicType(ficData.CaseDetail.recordType) : "";
            vm.consultationFIC.creator = '';
            vm.consultationFIC.ficType = (vm.selectedTypeFIC && vm.selectedTypeFIC.name) ? vm.selectedTypeFIC.name : "";
            vm.consultationFIC.vehicleBin = (ficData && ficData.Car && ficData.Car.bin) ? ficData.Car.bin : "";
            vm.consultationFIC.vehicleVin = (ficData && ficData.Car && ficData.Car.vin) ? ficData.Car.vin : "";
            vm.consultationFIC.mileageValue = (ficData && ficData.Car && ficData.Car.mileageValue) ? ficData.Car.mileageValue : "";
            vm.consultationFIC.mileageUnit = (ficData && ficData.Car && ficData.Car.mileageUnit) ? ficData.Car.mileageUnit : "";
            vm.consultationFIC.isVehicleImmobilised = (ficData && ficData.Car && ficData.Car.isVehicleImmobilised) ? ficData.Car.isVehicleImmobilised : "";
            vm.consultationFIC.isVehicleTransformed = (ficData && ficData.Car && ficData.Car.isVehicleTransformed) ? ficData.Car.isVehicleTransformed : "";
            vm.consultationFIC.vehicleAccesoires = (ficData && ficData.Car && ficData.Car.isVehicleAccessories) ? ficData.Car.isVehicleAccessories : "";
            vm.consultationFIC.phoneNumber = (ficData && ficData.Dealer && ficData.Dealer.phoneNumber) ? ficData.Dealer.phoneNumber : "";
            vm.consultationFIC.model = (ficData && ficData.Car && ficData.Car.model) ? ficData.Car.model : "";
            var comments = (ficData && ficData.CaseDetail && ficData.CaseDetail.comments) ? ficData.CaseDetail.comments : "";
            if(ficData && ficData.CaseDetail && ficData.CaseDetail.comments){
                for (var i = 0; i < ficData.CaseDetail.comments.length; i++) {
                    var commentBody = formatText(comments[i].commentBody, 180);

                    if (commentBody.indexOf("<p>") != -1) {
                        commentBody = commentBody.replace(/\n/gi, ' ');
                        commentBody = commentBody.replace(/\t/gi, ' ');
                        ficData.CaseDetail.comments[i].lines = splitString(commentBody, "<p>");
                    } else if (commentBody.indexOf("\n") != -1) {
                        commentBody = commentBody.replace(/\t/gi, ' ');
                        ficData.CaseDetail.comments[i].lines = splitString(commentBody, "\n");
                    } else if (commentBody.indexOf("\t") != -1) {
                        commentBody = commentBody.replace(/\n/gi, ' ');
                        ficData.CaseDetail.comments[i].lines = splitString(commentBody, "\t");
                    }
                    commentBody = commentBody.replace(/\n/gi, ' ');
                    commentBody = commentBody.replace(/\t/gi, ' ');
                    ficData.CaseDetail.comments[i].commentBody = commentBody;
                }
                 
            }


            vm.consultationFIC.comments = (ficData && ficData.CaseDetail && ficData.CaseDetail.comments) ? ficData.CaseDetail.comments : "";
            vm.consultationFIC.closedDate = (ficData && ficData.CaseDetail && ficData.CaseDetail.closedDate) ? ficData.CaseDetail.closedDate : "";
            vm.consultationFIC.creationDate = (ficData && ficData.CaseDetail && ficData.CaseDetail.creationDate) ? ficData.CaseDetail.creationDate : "";
            vm.consultationFIC.closureReason =(ficData && ficData.CaseDetail && ficData.CaseDetail.closureReason) ? ficData.CaseDetail.closureReason : "";
            CacheService.setObject('consultationFIC', vm.consultationFIC);
            $rootScope.$broadcast(CONSULTATION_FIC_EVENT, vm.consultationFIC);
        }

        function formatText(text, n) {
            var length = text.length;
            var lines = [];
            var newText = "";
            var index = 0;
            var endOfLine = n;
            if (length > n) {
                while (length > n) {
                    if ((
                            text.substring(index, index + n).lastIndexOf('<p>') == -1
                        )
                        &&
                        (text[endOfLine] === ' ') || (text[endOfLine] === '.') || (text[endOfLine] === ',')) {
                        newText = newText + text.substring(index, index + endOfLine) + '<p>';
                        length = length - endOfLine;
                        index = index + endOfLine;
                        endOfLine = index;
                    } else {
                        var lastIndex = (text.substring(index, index + n).lastIndexOf(' ')> 0) ? text.substring(index, index + n).lastIndexOf(' ') : n;
                        newText = newText + text.substring(index, index + lastIndex) + '<p>';
                        length = length + lastIndex;
                        index = index + lastIndex;
                        endOfLine = index + lastIndex;
                    }
                }
                if (length > 0) {
                    newText = newText + text.substring(index, text.length);
                }
            } else {
                newText = newText + text + '<p>';
            }
            return newText;
        }
        function isFicBeingModified() {

            // var responseApi = CacheService.getObject(CacheConstants.actisResponse);
            // $scope.getFicData();
            //
            // var dataChanged = CreateActisBusinessService.deepDiffApiResultVsDataActisView(responseApi, vm.fic);
            //
            // //todo refactor ?
            // // var node = document.querySelector('input, md-datepicker');
            // //
            // // var observer = new MutationObserver(function(mutations) {
            // //     mutations.forEach(function(mutation) {
            // //         console.info(mutation.type);
            // //     });
            // //     console.info('**** DOM changes ****')
            // // });
            // //
            // // observer.observe(node, {
            // //     element: true,
            // //     subtree: true,
            // //     type : true,
            // //     attributes: true,
            // //     childList: true,
            // //     characterData: true
            // // });

            return true;
        }


        function splitString(stringToSplit, separator) {
            var arrayOfStrings = stringToSplit.split(separator);
            for (var i = 0; i < arrayOfStrings.length; i++) {
                var reg = new RegExp("<+.*>+", "gi");
                arrayOfStrings[i] = arrayOfStrings[i].replace('</b>', " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace('<b>', " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace(reg, " ");
                arrayOfStrings[i] = arrayOfStrings[i].replace('\u00A0', "");
                arrayOfStrings[i] = arrayOfStrings[i].replace('\u25A0', "");
                arrayOfStrings[i] = arrayOfStrings[i].replace('U+000A', "");
            }
            return arrayOfStrings;
        }

        function formatText(text, n) {
            var length = text.length;
            var lines = [];
            var newText = "";
            var index = 0;
            var endOfLine = n;
            if (length > n) {
                while (length > n) {
                    if ((text.substring(index, index + n).lastIndexOf('<p>') == -1) && (text[endOfLine] === ' ') || (text[endOfLine] === '.') || (text[endOfLine] === ',')) {
                        newText = newText + text.substring(index, index + endOfLine) + '<p>';
                        length = length - endOfLine;
                        index = index + endOfLine;
                        endOfLine = index;
                    } else {
                        var lastIndex = text.substring(index, index + n).lastIndexOf(' ');
                        newText = newText + text.substring(index, index + lastIndex) + '<p>';
                        length = length - lastIndex;
                        index = index + lastIndex;
                        endOfLine = index + lastIndex;
                    }
                }
                if (length > 0) {
                    newText = newText + text.substring(index, text.length);
                }
            } else {
                newText = newText + text + '<p>';
            }
            return newText;
        }
    }
})();



angular.module('phenix').constant('ActisConstantes', {

    profil1: 'ACTIS',
    profil2: 'ACTIS_USER',
    profil3: 'IRN-67591:FIC_MANAGEMENT',
    actis_okta: 'RACTIS_FIC_MANAGEMENT',
    km : "KM",
    miles : "Miles",

    type_technical_assistance: 1,
    type_approval: 2,
    type_alert: 3,
    type_good_practise: 4,
    type_ze_battery: 5,
    type_accessoires: 6,
    type_painting: 7,
    type_brw: 8,
    type_qstomize: 9,
    type_pilote: 10,
    type_calm: 11,
    type_administrative: 12,

    1 : 'ACTIS_TECHNICAL_ASSISTANCE',
    2 : 'ACTIS_AGREEMENT',
    3 : 'ACTIS_ALERT',
    4 : 'ACTIS_GOOD_PRACTICE',
    5 : 'ACTIS_ZE_BATTERY',
    6 : 'ACTIS_ACCESSORY',
    7 : 'ACTIS_PAINTING',
    8 : 'ACTIS_BRW',
    9 : 'FIC_QSTOMIZE',
    10 : 'ACTIS_PILOTE',
    11 : 'ACTIS_CALM',
    12 : 'ACTIS_ADMINISTRATIVE',

    type_technical_assistance_description : 'ACTIS_TECHNICAL_ASSISTANCE_DESCRIPTION',
    type_approval_description : 'ACTIS_AGREEMENT_DESCRIPTION',
    type_alert_description : 'ACTIS_ALERT_DESCRIPTION',
    type_good_practise_description : 'ACTIS_GOOD_PRACTICE_DESCRIPTION',
    type_ze_battery_description : 'ACTIS_ZE_BATTERY_DESCRIPTION',
    type_qstomize_description : 'QSTOMIZE_MSG',
    
    type_technical_assistance_button : 'ACTIS_TECHNICAL_ASSISTANCE_BUTTON',
    type_approval_button : 'ACTIS_AGREEMENT_BUTTON',
    type_alert_button : 'ACTIS_ALERT_BUTTON',
    type_good_practise_button : 'ACTIS_GOOD_PRACTICE_BUTTON',
    type_ze_battery_button : 'ACTIS_ZE_BATTERY_BUTTON',
    type_accessoires_button : 'ACTIS_ACCESSORY_BUTTON',
    type_painting_button : 'ACTIS_PAINTING_BUTTON',

    type_technical_assistance_image : '/assets/images/icn_assistance.png',
    type_approval_image : '/assets/images/icn_agreement.png',
    type_alert_image : '/assets/images/icn_danger.png',
    type_good_practise_image : '/assets/images/icn_light.png',
    type_qstomize_image: '/assets/images/icn_qstomize.png',
    type_ze_battery_image : '/assets/images/icn_battery.png',

    accessories_CIRS: "Accessories CIRs",
    agreement_CIRS: "Agreement CIRs",
    goodPractise_CIRS: "Good Practise",
    painting_CIRS: "Painting CIRs",
    technical_CIRS: "Technical Assistance CIRs",
    ze_battery_CIRS: "ZE Battery",
    alert_CIRS: "Alert",
    BRW_CIRS: "BRW",
    PAINT_CIRS:"PAINT",
    ACCESSORIE_CIRS:"ACCESSORIE",
    QSTOMIZE_CIRS: "QSTOMIZE",
    ACTIS_PILOTE: "Pilote",
    CALM_CIRS: "CALM",
    ADMINISTRATIVE_CIRS: 'Administrative',

    status_closed: 'Closed',
    attachment_scannedStatus_ok: 'SCANNED_OK',

    endpoint: {
        listCase: '/proxy/wired/commerce/v1/rdocs/?country=',
        natCase: '/proxy/wired/commerce/v1/dealers/',
        suffixCases: '/cases',
        suffixCaseId: '?caseId=',
        suffixCaseIdParam: 'caseId',
        wiredRDocId: 'proxy/wired/commerce/v1/rdocs/',
        wiredRDocIdSearch: 'proxy/wired/commerce/v1/rdocs',
        pdfExport: 'actis/pdfExport',
        assistanceTokens:'proxy/apigee/a5o/v1/persons/',
        assistanceTokensSuffix:'/assistance-tokens/consume'
    },
    //BTlist userprofileConstants
    Assistance_Technique_N1:"Assistance_Technique_N1",
    Assistance_Technique_N2 :"Assistance_Technique_N2",
    ppx_assist_tech_corp : "PPX_ASSIST_TECH_CORP",
    ppx_assist_tech_n1 : "PPX_ASSIST_TECH_N1",
    ppx_assist_tech_n2 : "PPX_ASSIST_TECH_N2",
    ppx_import_parts_manager : 'PPX_IMPORT_PARTS_MANAGER',
    days_to_reopen:30,
    rdoc_page_size:20,
    rdoc_sort: "localDate%2CDESC",
    mileage_id : 'distanceValue',
    cirDemand: [
        {id: 'ACTIS_TECHNICAL_ASSISTANCE' , value : ['DAMAGED_BATTERY','FLOODED_BATTERY','AUTONOMY_COMPLAIN','SAFETY_REQUEST','RECYCLING_REQUEST','DIAGNOSIS_ASSISTANCE','NOT_ON_LIST']},
        {id: 'REQUEST_INFORMATION' , value : ['VEHICLE_HISTORY','CONTACT_DETAILS','PROFITABILITY_REPAIR','COST_EFFECTIVENESS','BAD_BATTERY','NOT_ON_LIST']},
        {id: 'OPERATION_APPROVAL' , value : ['WARRANTY_AGREEMENT']},
        
    ],
    YES: 'YES',
    NO: 'NO',
    paintRequestType :['PAINT_REQUEST_TYPE1', 'PAINT_REQUEST_TYPE2', 'PAINT_REQUEST_TYPE3', 'PAINT_REQUEST_TYPE4', 'PAINT_REQUEST_TYPE5', 'PAINT_REQUEST_TYPE6', 'PAINT_REQUEST_TYPE7'],
    paintFunction : ['PAINT_FUNCTION_OPTION1','PAINT_FUNCTION_OPTION2','PAINT_FUNCTION_OPTION3','PAINT_FUNCTION_OPTION4','PAINT_FUNCTION_OPTION5','PAINT_FUNCTION_OPTION6','PAINT_FUNCTION_OPTION7','PAINT_FUNCTION_OPTION8','PAINT_FUNCTION_OPTION9'],
    accessorieRequestType :[{id:'ACCESSORIE_REQUEST_TYPE1', value:[]},{id:'ACCESSORIE_REQUEST_TYPE2', value:['HOMOLOGUATION','PRODUCT_INFO']}, {id:'ACCESSORIE_REQUEST_TYPE3', value:['MISSING_PART','INCORRECT_DESCRIPTION']}, {id:'ACCESSORIE_REQUEST_TYPE4', value:['FITTING_INSTRUCT','FITTING_PROB']}, {id:'ACCESSORIE_REQUEST_TYPE5',value:[]}],
    qstomizeRequestReason: [
        {id: 'QUOTE_REQUEST' , value : ['SPARE_PART','TPMR','STRIPPING','ORDER_FOR_STOCK']},
        {id: 'WARRANTY_REQUEST' , value : ['TPMR','DRIVING_SCHOOL_CAR','UTILITY_VEHICLE','PARTICULAR_VEHICLE','OTHER']},
        {id: 'INFORMATION_REQUEST' , value : ['ACCOUNT', 'FOLLOW_UP_FILE', 'DUPLICATE_REQUEST', 'OTHER']},
        {id: 'RETURN_REQUEST' , value : ['TPMR','DRIVING_SCHOOL_CAR','UTILITY_VEHICLE','PARTICULAR_VEHICLE','OTHER']},
        {id: 'TECHNICAL_ASSISTANCE' , value : ['']}
    ],
     attachmentProviderSystem: "RNLT-IRN-5910-PPX-PPX-304",
     attachmentPdfDoc: {en:'/Appendix Supporting Documents FIC ALERT JUL 25 V1',
                        fr:'/Annexe Justificatifs FIC ALERTE JUIL 25 V1'}

});

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('supportVinController', supportVinController);

    /** @ngInject */
    function supportVinController($mdDialog,$rootScope) {
        var vm = this;
        vm.close = close;
        vm.closeAndRedirect = closeAndRedirect;
        
        function close() {
            $mdDialog.hide();
        }

        function closeAndRedirect() {
            
            $rootScope.$broadcast('redirectDiagnostic', {
                redirectDiagnostic: true
            });
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('supportIndependentPopController', supportIndependentPopController);

    /** @ngInject */
    function supportIndependentPopController($mdDialog) {
        var vm = this;
        vm.close = close;
        
        function close() {
            $mdDialog.hide()
        }
    }
})();
!function(e){function t(t){for(var o,i,l=t[0],s=t[1],c=t[2],d=0,u=[];d<l.length;d++)r[i=l[d]]&&u.push(r[i][0]),r[i]=0;for(o in s)Object.prototype.hasOwnProperty.call(s,o)&&(e[o]=s[o]);for(f&&f(t);u.length;)u.shift()();return a.push.apply(a,c||[]),n()}function n(){for(var e,t=0;t<a.length;t++){for(var n=a[t],o=!0,l=1;l<n.length;l++)0!==r[n[l]]&&(o=!1);o&&(a.splice(t--,1),e=i(i.s=n[0]))}return e}var o={},r={0:0},a=[];function i(t){if(o[t])return o[t].exports;var n=o[t]={i:t,l:!1,exports:{}};return e[t].call(n.exports,n,n.exports,i),n.l=!0,n.exports}i.m=e,i.c=o,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(n,o,function(t){return e[t]}.bind(null,o));return n},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="";var l=window.webpackJsonp=window.webpackJsonp||[],s=l.push.bind(l);l.push=t,l=l.slice();for(var c=0;c<l.length;c++)t(l[c]);var f=s;n()}([]),(window.webpackJsonp=window.webpackJsonp||[]).push([[2],{1:function(e,t,n){e.exports=n("hN/g")},"hN/g":function(e,t,n){"use strict";n.r(t),n("nf2o"),n("lgC5")},lgC5:function(e,t){!function(e,t){"use strict";function n(){var e=E.splice(0,E.length);for(Ke=0;e.length;)e.shift().call(null,e.shift())}function o(e,t){for(var n=0,o=e.length;n<o;n++)p(e[n],t)}function r(e){return function(t){Oe(t)&&(p(t,e),ae.length&&o(t.querySelectorAll(ae),e))}}function a(e){var t=qe.call(e,"is"),n=e.nodeName.toUpperCase(),o=le.call(oe,t?ee+t.toUpperCase():J+n);return t&&-1<o&&!i(n,t)?-1:o}function i(e,t){return-1<ae.indexOf(e+'[is="'+t+'"]')}function l(e){var t=e.currentTarget,n=e.attrChange,o=e.attrName,r=e.target,a=e[W]||2,i=e[G]||3;!ot||r&&r!==t||!t[q]||"style"===o||e.prevValue===e.newValue&&(""!==e.newValue||n!==a&&n!==i)||t[q](o,n===a?null:e.prevValue,n===i?null:e.newValue)}function s(e){var t=r(e);return function(e){E.push(t,e.target),Ke&&clearTimeout(Ke),Ke=setTimeout(n,1)}}function c(e){nt&&(nt=!1,e.currentTarget.removeEventListener(K,c)),ae.length&&o((e.target||k).querySelectorAll(ae),e.detail===H?H:P),ze&&function(){for(var e,t=0,n=Re.length;t<n;t++)ie.contains(e=Re[t])||(n--,Re.splice(t--,1),p(e,H))}()}function f(e,t){var n=this;$e.call(n,e,t),T.call(n,{target:n})}function d(e,t,n){var o=t.apply(e,n),r=a(o);return-1<r&&M(o,re[r]),n.pop()&&ae.length&&function(e){for(var t,n=0,o=e.length;n<o;n++)M(t=e[n],re[a(t)])}(o.querySelectorAll(ae)),o}function u(e,t){Ie(e,t),j?j.observe(e,Ge):(tt&&(e.setAttribute=f,e[O]=N(e),e[R](X,T)),e[R](Y,l)),e[U]&&ot&&(e.created=!0,e[U](),e.created=!1)}function m(e){throw new Error("A "+e+" type is already registered")}function p(e,t){var n,o,r=a(e);-1<r&&!He.call(e,"TEMPLATE")&&(D(e,re[r]),r=0,t!==P||e[P]?t!==H||e[H]||(e[P]=!1,e[H]=!0,o="disconnected",r=1):(e[H]=!1,e[P]=!0,o="connected",r=1,ze&&le.call(Re,e)<0&&Re.push(e)),r&&(n=e[t+L]||e[o+L])&&n.call(e))}function b(){}function h(e,t,n){var o=n&&n[V]||"",r=t.prototype,a=je(r),i=t.observedAttributes||ue,l={prototype:a};Ae(a,U,{value:function(){if(Ce)Ce=!1;else if(!this[xe]){this[xe]=!0,new t(this),r[U]&&r[U].call(this);var e=Ee[Se.get(t)];(!ye||e.create.length>1)&&w(this)}}}),Ae(a,q,{value:function(e){-1<le.call(i,e)&&r[q]&&r[q].apply(this,arguments)}}),r[B]&&Ae(a,Z,{value:r[B]}),r[$]&&Ae(a,Q,{value:r[$]}),o&&(l[V]=o),e=e.toUpperCase(),Ee[e]={constructor:t,create:o?[o,Ne(e)]:[e]},Se.set(t,e),k[z](e.toLowerCase(),l),y(e),Te[e].r()}function g(e){var t=Ee[e.toUpperCase()];return t&&t.constructor}function x(e){return"string"==typeof e?e:e&&e.is||""}function w(e){for(var t,n=e[q],o=n?e.attributes:ue,r=o.length;r--;)n.call(e,(t=o[r]).name||t.nodeName,null,t.value||t.nodeValue)}function y(e){return(e=e.toUpperCase())in Te||(Te[e]={},Te[e].p=new _e(function(t){Te[e].r=t})),Te[e].p}function v(){we&&delete e.customElements,de(e,"customElements",{configurable:!0,value:new b}),de(e,"CustomElementRegistry",{configurable:!0,value:b});for(var t=C.get(/^HTML[A-Z]*[a-z]/),n=t.length;n--;function(t){var n=e[t];if(n){e[t]=function(e){var t,o;return e||(e=this),e[xe]||(Ce=!0,t=Ee[Se.get(e.constructor)],(e=(o=ye&&1===t.create.length)?Reflect.construct(n,ue,t.constructor):k.createElement.apply(k,t.create))[xe]=!0,Ce=!1,o||w(e)),e},e[t].prototype=n.prototype;try{n.prototype.constructor=e[t]}catch(o){de(n,xe,{value:e[t]})}}}(t[n]));k.createElement=function(e,t){var n=x(t);return n?We.call(this,e,Ne(n)):We.call(this,e)},Xe||(et=!0,k[z](""))}var k=e.document,_=e.Object,C=function(e){var t,n,o,r,a=/^[A-Z]+[a-z]/,i=function(e,t){(t=t.toLowerCase())in l||(l[e]=(l[e]||[]).concat(t),l[t]=l[t.toUpperCase()]=e)},l=(_.create||_)(null),s={};for(n in e)for(r in e[n])for(l[r]=o=e[n][r],t=0;t<o.length;t++)l[o[t].toLowerCase()]=l[o[t].toUpperCase()]=r;return s.get=function(e){return"string"==typeof e?l[e]||(a.test(e)?[]:""):function(e){var t,n=[];for(t in l)e.test(t)&&n.push(t);return n}(e)},s.set=function(e,t){return a.test(e)?i(e,t):i(t,e),s},s}({collections:{HTMLAllCollection:["all"],HTMLCollection:["forms"],HTMLFormControlsCollection:["elements"],HTMLOptionsCollection:["options"]},elements:{Element:["element"],HTMLAnchorElement:["a"],HTMLAppletElement:["applet"],HTMLAreaElement:["area"],HTMLAttachmentElement:["attachment"],HTMLAudioElement:["audio"],HTMLBRElement:["br"],HTMLBaseElement:["base"],HTMLBodyElement:["body"],HTMLButtonElement:["button"],HTMLCanvasElement:["canvas"],HTMLContentElement:["content"],HTMLDListElement:["dl"],HTMLDataElement:["data"],HTMLDataListElement:["datalist"],HTMLDetailsElement:["details"],HTMLDialogElement:["dialog"],HTMLDirectoryElement:["dir"],HTMLDivElement:["div"],HTMLDocument:["document"],HTMLElement:["element","abbr","address","article","aside","b","bdi","bdo","cite","code","command","dd","dfn","dt","em","figcaption","figure","footer","header","i","kbd","mark","nav","noscript","rp","rt","ruby","s","samp","section","small","strong","sub","summary","sup","u","var","wbr"],HTMLEmbedElement:["embed"],HTMLFieldSetElement:["fieldset"],HTMLFontElement:["font"],HTMLFormElement:["form"],HTMLFrameElement:["frame"],HTMLFrameSetElement:["frameset"],HTMLHRElement:["hr"],HTMLHeadElement:["head"],HTMLHeadingElement:["h1","h2","h3","h4","h5","h6"],HTMLHtmlElement:["html"],HTMLIFrameElement:["iframe"],HTMLImageElement:["img"],HTMLInputElement:["input"],HTMLKeygenElement:["keygen"],HTMLLIElement:["li"],HTMLLabelElement:["label"],HTMLLegendElement:["legend"],HTMLLinkElement:["link"],HTMLMapElement:["map"],HTMLMarqueeElement:["marquee"],HTMLMediaElement:["media"],HTMLMenuElement:["menu"],HTMLMenuItemElement:["menuitem"],HTMLMetaElement:["meta"],HTMLMeterElement:["meter"],HTMLModElement:["del","ins"],HTMLOListElement:["ol"],HTMLObjectElement:["object"],HTMLOptGroupElement:["optgroup"],HTMLOptionElement:["option"],HTMLOutputElement:["output"],HTMLParagraphElement:["p"],HTMLParamElement:["param"],HTMLPictureElement:["picture"],HTMLPreElement:["pre"],HTMLProgressElement:["progress"],HTMLQuoteElement:["blockquote","q","quote"],HTMLScriptElement:["script"],HTMLSelectElement:["select"],HTMLShadowElement:["shadow"],HTMLSlotElement:["slot"],HTMLSourceElement:["source"],HTMLSpanElement:["span"],HTMLStyleElement:["style"],HTMLTableCaptionElement:["caption"],HTMLTableCellElement:["td","th"],HTMLTableColElement:["col","colgroup"],HTMLTableElement:["table"],HTMLTableRowElement:["tr"],HTMLTableSectionElement:["thead","tbody","tfoot"],HTMLTemplateElement:["template"],HTMLTextAreaElement:["textarea"],HTMLTimeElement:["time"],HTMLTitleElement:["title"],HTMLTrackElement:["track"],HTMLUListElement:["ul"],HTMLUnknownElement:["unknown","vhgroupv","vkeygen"],HTMLVideoElement:["video"]},nodes:{Attr:["node"],Audio:["audio"],CDATASection:["node"],CharacterData:["node"],Comment:["#comment"],Document:["#document"],DocumentFragment:["#document-fragment"],DocumentType:["node"],HTMLDocument:["#document"],Image:["img"],Option:["option"],ProcessingInstruction:["node"],ShadowRoot:["#shadow-root"],Text:["#text"],XMLDocument:["xml"]}});"object"!=typeof t&&(t={type:t||"auto"});var E,T,S,N,j,I,D,M,F,z="registerElement",A=1e5*e.Math.random()|0,O="__"+z+A,R="addEventListener",P="attached",L="Callback",H="detached",V="extends",q="attributeChanged"+L,Z=P+L,B="connected"+L,$="disconnected"+L,U="created"+L,Q=H+L,W="ADDITION",G="REMOVAL",Y="DOMAttrModified",K="DOMContentLoaded",X="DOMSubtreeModified",J="<",ee="=",te=/^[A-Z][._A-Z0-9]*-[-._A-Z0-9]*$/,ne=["ANNOTATION-XML","COLOR-PROFILE","FONT-FACE","FONT-FACE-SRC","FONT-FACE-URI","FONT-FACE-FORMAT","FONT-FACE-NAME","MISSING-GLYPH"],oe=[],re=[],ae="",ie=k.documentElement,le=oe.indexOf||function(e){for(var t=this.length;t--&&this[t]!==e;);return t},se=_.prototype,ce=se.hasOwnProperty,fe=se.isPrototypeOf,de=_.defineProperty,ue=[],me=_.getOwnPropertyDescriptor,pe=_.getOwnPropertyNames,be=_.getPrototypeOf,he=_.setPrototypeOf,ge=!!_.__proto__,xe="__dreCEv1",we=e.customElements,ye=!/^force/.test(t.type)&&!!(we&&we.define&&we.get&&we.whenDefined),ve=_.create||_,ke=e.Map||function(){var e,t=[],n=[];return{get:function(e){return n[le.call(t,e)]},set:function(o,r){(e=le.call(t,o))<0?n[t.push(o)-1]=r:n[e]=r}}},_e=e.Promise||function(e){function t(e){for(o=!0;n.length;)n.shift()(e)}var n=[],o=!1,r={catch:function(){return r},then:function(e){return n.push(e),o&&setTimeout(t,1),r}};return e(t),r},Ce=!1,Ee=ve(null),Te=ve(null),Se=new ke,Ne=function(e){return e.toLowerCase()},je=_.create||function e(t){return t?(e.prototype=t,new e):this},Ie=he||(ge?function(e,t){return e.__proto__=t,e}:pe&&me?function(){function e(e,t){for(var n,o=pe(t),r=0,a=o.length;r<a;r++)ce.call(e,n=o[r])||de(e,n,me(t,n))}return function(t,n){do{e(t,n)}while((n=be(n))&&!fe.call(n,t));return t}}():function(e,t){for(var n in t)e[n]=t[n];return e}),De=e.MutationObserver||e.WebKitMutationObserver,Me=e.HTMLAnchorElement,Fe=(e.HTMLElement||e.Element||e.Node).prototype,ze=!fe.call(Fe,ie),Ae=ze?function(e,t,n){return e[t]=n.value,e}:de,Oe=ze?function(e){return 1===e.nodeType}:function(e){return fe.call(Fe,e)},Re=ze&&[],Pe=Fe.attachShadow,Le=Fe.cloneNode,He=Fe.closest||function(e){for(var t=this;t&&t.nodeName!==e;)t=t.parentNode;return t},Ve=Fe.dispatchEvent,qe=Fe.getAttribute,Ze=Fe.hasAttribute,Be=Fe.removeAttribute,$e=Fe.setAttribute,Ue=k.createElement,Qe=k.importNode,We=Ue,Ge=De&&{attributes:!0,characterData:!0,attributeOldValue:!0},Ye=De||function(e){tt=!1,ie.removeEventListener(Y,Ye)},Ke=0,Xe=z in k&&!/^force-all/.test(t.type),Je=!0,et=!1,tt=!0,nt=!0,ot=!0;if(De&&((F=k.createElement("div")).innerHTML="<div><div></div></div>",new De(function(e,t){if(e[0]&&"childList"==e[0].type&&!e[0].removedNodes[0].childNodes.length){var n=(F=me(Fe,"innerHTML"))&&F.set;n&&de(Fe,"innerHTML",{set:function(e){for(;this.lastChild;)this.removeChild(this.lastChild);n.call(this,e)}})}t.disconnect(),F=null}).observe(F,{childList:!0,subtree:!0}),F.innerHTML=""),Xe||(he||ge?(D=function(e,t){fe.call(t,e)||u(e,t)},M=u):M=D=function(e,t){e[O]||(e[O]=_(!0),u(e,t))},ze?(tt=!1,function(){var e=me(Fe,R),t=e.value,n=function(e){var t=new CustomEvent(Y,{bubbles:!0});t.attrName=e,t.prevValue=qe.call(this,e),t.newValue=null,t[G]=t.attrChange=2,Be.call(this,e),Ve.call(this,t)},o=function(e,t){var n=Ze.call(this,e),o=n&&qe.call(this,e),r=new CustomEvent(Y,{bubbles:!0});$e.call(this,e,t),r.attrName=e,r.prevValue=n?o:null,r.newValue=t,n?r.MODIFICATION=r.attrChange=1:r[W]=r.attrChange=0,Ve.call(this,r)},r=function(e){var t,n=e.currentTarget,o=n[O],r=e.propertyName;o.hasOwnProperty(r)&&(o=o[r],(t=new CustomEvent(Y,{bubbles:!0})).attrName=o.name,t.prevValue=o.value||null,t.newValue=o.value=n[r]||null,null==t.prevValue?t[W]=t.attrChange=0:t.MODIFICATION=t.attrChange=1,Ve.call(n,t))};e.value=function(e,a,i){e===Y&&this[q]&&this.setAttribute!==o&&(this[O]={className:{name:"class",value:this.className}},this.setAttribute=o,this.removeAttribute=n,t.call(this,"propertychange",r)),t.call(this,e,a,i)},de(Fe,R,e)}()):De||(ie[R](Y,Ye),ie.setAttribute(O,1),ie.removeAttribute(O),tt&&(T=function(e){var t,n,o,r=this;if(r===e.target){for(o in t=r[O],r[O]=n=N(r),n){if(!(o in t))return S(0,r,o,t[o],n[o],W);if(n[o]!==t[o])return S(1,r,o,t[o],n[o],"MODIFICATION")}for(o in t)if(!(o in n))return S(2,r,o,t[o],n[o],G)}},S=function(e,t,n,o,r,a){var i={attrChange:e,currentTarget:t,attrName:n,prevValue:o,newValue:r};i[a]=e,l(i)},N=function(e){for(var t,n,o={},r=e.attributes,a=0,i=r.length;a<i;a++)"setAttribute"!==(n=(t=r[a]).name)&&(o[n]=t.value);return o})),k[z]=function(e,t){if(n=e.toUpperCase(),Je&&(Je=!1,De?(j=function(e,t){function n(e,t){for(var n=0,o=e.length;n<o;t(e[n++]));}return new De(function(o){for(var r,a,i,l=0,s=o.length;l<s;l++)"childList"===(r=o[l]).type?(n(r.addedNodes,e),n(r.removedNodes,t)):(a=r.target,ot&&a[q]&&"style"!==r.attributeName&&(i=qe.call(a,r.attributeName))!==r.oldValue&&a[q](r.attributeName,r.oldValue,i))})}(r(P),r(H)),(I=function(e){return j.observe(e,{childList:!0,subtree:!0}),e})(k),Pe&&(Fe.attachShadow=function(){return I(Pe.apply(this,arguments))})):(E=[],k[R]("DOMNodeInserted",s(P)),k[R]("DOMNodeRemoved",s(H))),k[R](K,c),k[R]("readystatechange",c),k.importNode=function(e,t){switch(e.nodeType){case 1:return d(k,Qe,[e,!!t]);case 11:for(var n=k.createDocumentFragment(),o=e.childNodes,r=o.length,a=0;a<r;a++)n.appendChild(k.importNode(o[a],!!t));return n;default:return Le.call(e,!!t)}},Fe.cloneNode=function(e){return d(this,Le,[!!e])}),et)return et=!1;if(-2<le.call(oe,ee+n)+le.call(oe,J+n)&&m(e),!te.test(n)||-1<le.call(ne,n))throw new Error("The type "+e+" is invalid");var n,a,i=function(){return f?k.createElement(u,n):k.createElement(u)},l=t||se,f=ce.call(l,V),u=f?t[V].toUpperCase():n;return f&&-1<le.call(oe,J+u)&&m(u),a=oe.push((f?ee:J)+n)-1,ae=ae.concat(ae.length?",":"",f?u+'[is="'+e.toLowerCase()+'"]':u),i.prototype=re[a]=ce.call(l,"prototype")?l.prototype:je(Fe),ae.length&&o(k.querySelectorAll(ae),P),i},k.createElement=We=function(e,t){var n=x(t),o=n?Ue.call(k,e,Ne(n)):Ue.call(k,e),r=""+e,a=le.call(oe,(n?ee:J)+(n||r).toUpperCase()),l=-1<a;return n&&(o.setAttribute("is",n=n.toLowerCase()),l&&(l=i(r.toUpperCase(),n))),ot=!k.createElement.innerHTMLHelper,l&&M(o,re[a]),o}),addEventListener("beforeunload",function(){delete k.createElement,delete k.importNode,delete k[z]},!1),b.prototype={constructor:b,define:ye?function(e,t,n){if(n)h(e,t,n);else{var o=e.toUpperCase();Ee[o]={constructor:t,create:[o]},Se.set(t,o),we.define(e,t)}}:h,get:ye?function(e){return we.get(e)||g(e)}:g,whenDefined:ye?function(e){return _e.race([we.whenDefined(e),y(e)])}:y},!we||/^force/.test(t.type))v();else if(!t.noBuiltIn)try{!function(t,n,o){var r=new RegExp("^<a\\s+is=('|\")"+o+"\\1></a>$");if(n[V]="a",(t.prototype=je(Me.prototype)).constructor=t,e.customElements.define(o,t,n),!r.test(k.createElement("a",{is:o}).outerHTML)||!r.test((new t).outerHTML))throw n}(function e(){return Reflect.construct(Me,[],e)},{},"document-register-element-a"+A)}catch(e){v()}if(!t.noBuiltIn)try{if(Ue.call(k,"a","a").outerHTML.indexOf("is")<0)throw{}}catch(e){Ne=function(e){return{is:e.toLowerCase()}}}}(window)},nf2o:function(e,t){!function(e){const t=e.performance;function n(e){t&&t.mark&&t.mark(e)}function o(e,n){t&&t.measure&&t.measure(e,n)}n("Zone");const r=!0===e.__zone_symbol__forceDuplicateZoneCheck;if(e.Zone){if(r||"function"!=typeof e.Zone.__symbol__)throw new Error("Zone already loaded.");return e.Zone}class a{constructor(e,t){this._parent=e,this._name=t?t.name||"unnamed":"<root>",this._properties=t&&t.properties||{},this._zoneDelegate=new l(this,this._parent&&this._parent._zoneDelegate,t)}static assertZonePatched(){if(e.Promise!==S.ZoneAwarePromise)throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)")}static get root(){let e=a.current;for(;e.parent;)e=e.parent;return e}static get current(){return j.zone}static get currentTask(){return I}static __load_patch(t,i){if(S.hasOwnProperty(t)){if(r)throw Error("Already loaded patch: "+t)}else if(!e["__Zone_disable_"+t]){const r="Zone:"+t;n(r),S[t]=i(e,a,N),o(r,r)}}get parent(){return this._parent}get name(){return this._name}get(e){const t=this.getZoneWith(e);if(t)return t._properties[e]}getZoneWith(e){let t=this;for(;t;){if(t._properties.hasOwnProperty(e))return t;t=t._parent}return null}fork(e){if(!e)throw new Error("ZoneSpec required!");return this._zoneDelegate.fork(this,e)}wrap(e,t){if("function"!=typeof e)throw new Error("Expecting function got: "+e);const n=this._zoneDelegate.intercept(this,e,t),o=this;return function(){return o.runGuarded(n,this,arguments,t)}}run(e,t,n,o){j={parent:j,zone:this};try{return this._zoneDelegate.invoke(this,e,t,n,o)}finally{j=j.parent}}runGuarded(e,t=null,n,o){j={parent:j,zone:this};try{try{return this._zoneDelegate.invoke(this,e,t,n,o)}catch(e){if(this._zoneDelegate.handleError(this,e))throw e}}finally{j=j.parent}}runTask(e,t,n){if(e.zone!=this)throw new Error("A task can only be run in the zone of creation! (Creation: "+(e.zone||g).name+"; Execution: "+this.name+")");if(e.state===x&&(e.type===T||e.type===E))return;const o=e.state!=v;o&&e._transitionTo(v,y),e.runCount++;const r=I;I=e,j={parent:j,zone:this};try{e.type==E&&e.data&&!e.data.isPeriodic&&(e.cancelFn=void 0);try{return this._zoneDelegate.invokeTask(this,e,t,n)}catch(e){if(this._zoneDelegate.handleError(this,e))throw e}}finally{e.state!==x&&e.state!==_&&(e.type==T||e.data&&e.data.isPeriodic?o&&e._transitionTo(y,v):(e.runCount=0,this._updateTaskCount(e,-1),o&&e._transitionTo(x,v,x))),j=j.parent,I=r}}scheduleTask(e){if(e.zone&&e.zone!==this){let t=this;for(;t;){if(t===e.zone)throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${e.zone.name}`);t=t.parent}}e._transitionTo(w,x);const t=[];e._zoneDelegates=t,e._zone=this;try{e=this._zoneDelegate.scheduleTask(this,e)}catch(t){throw e._transitionTo(_,w,x),this._zoneDelegate.handleError(this,t),t}return e._zoneDelegates===t&&this._updateTaskCount(e,1),e.state==w&&e._transitionTo(y,w),e}scheduleMicroTask(e,t,n,o){return this.scheduleTask(new s(C,e,t,n,o,void 0))}scheduleMacroTask(e,t,n,o,r){return this.scheduleTask(new s(E,e,t,n,o,r))}scheduleEventTask(e,t,n,o,r){return this.scheduleTask(new s(T,e,t,n,o,r))}cancelTask(e){if(e.zone!=this)throw new Error("A task can only be cancelled in the zone of creation! (Creation: "+(e.zone||g).name+"; Execution: "+this.name+")");e._transitionTo(k,y,v);try{this._zoneDelegate.cancelTask(this,e)}catch(t){throw e._transitionTo(_,k),this._zoneDelegate.handleError(this,t),t}return this._updateTaskCount(e,-1),e._transitionTo(x,k),e.runCount=0,e}_updateTaskCount(e,t){const n=e._zoneDelegates;-1==t&&(e._zoneDelegates=null);for(let o=0;o<n.length;o++)n[o]._updateTaskCount(e.type,t)}}a.__symbol__=F;const i={name:"",onHasTask:(e,t,n,o)=>e.hasTask(n,o),onScheduleTask:(e,t,n,o)=>e.scheduleTask(n,o),onInvokeTask:(e,t,n,o,r,a)=>e.invokeTask(n,o,r,a),onCancelTask:(e,t,n,o)=>e.cancelTask(n,o)};class l{constructor(e,t,n){this._taskCounts={microTask:0,macroTask:0,eventTask:0},this.zone=e,this._parentDelegate=t,this._forkZS=n&&(n&&n.onFork?n:t._forkZS),this._forkDlgt=n&&(n.onFork?t:t._forkDlgt),this._forkCurrZone=n&&(n.onFork?this.zone:t.zone),this._interceptZS=n&&(n.onIntercept?n:t._interceptZS),this._interceptDlgt=n&&(n.onIntercept?t:t._interceptDlgt),this._interceptCurrZone=n&&(n.onIntercept?this.zone:t.zone),this._invokeZS=n&&(n.onInvoke?n:t._invokeZS),this._invokeDlgt=n&&(n.onInvoke?t:t._invokeDlgt),this._invokeCurrZone=n&&(n.onInvoke?this.zone:t.zone),this._handleErrorZS=n&&(n.onHandleError?n:t._handleErrorZS),this._handleErrorDlgt=n&&(n.onHandleError?t:t._handleErrorDlgt),this._handleErrorCurrZone=n&&(n.onHandleError?this.zone:t.zone),this._scheduleTaskZS=n&&(n.onScheduleTask?n:t._scheduleTaskZS),this._scheduleTaskDlgt=n&&(n.onScheduleTask?t:t._scheduleTaskDlgt),this._scheduleTaskCurrZone=n&&(n.onScheduleTask?this.zone:t.zone),this._invokeTaskZS=n&&(n.onInvokeTask?n:t._invokeTaskZS),this._invokeTaskDlgt=n&&(n.onInvokeTask?t:t._invokeTaskDlgt),this._invokeTaskCurrZone=n&&(n.onInvokeTask?this.zone:t.zone),this._cancelTaskZS=n&&(n.onCancelTask?n:t._cancelTaskZS),this._cancelTaskDlgt=n&&(n.onCancelTask?t:t._cancelTaskDlgt),this._cancelTaskCurrZone=n&&(n.onCancelTask?this.zone:t.zone),this._hasTaskZS=null,this._hasTaskDlgt=null,this._hasTaskDlgtOwner=null,this._hasTaskCurrZone=null;const o=n&&n.onHasTask;(o||t&&t._hasTaskZS)&&(this._hasTaskZS=o?n:i,this._hasTaskDlgt=t,this._hasTaskDlgtOwner=this,this._hasTaskCurrZone=e,n.onScheduleTask||(this._scheduleTaskZS=i,this._scheduleTaskDlgt=t,this._scheduleTaskCurrZone=this.zone),n.onInvokeTask||(this._invokeTaskZS=i,this._invokeTaskDlgt=t,this._invokeTaskCurrZone=this.zone),n.onCancelTask||(this._cancelTaskZS=i,this._cancelTaskDlgt=t,this._cancelTaskCurrZone=this.zone))}fork(e,t){return this._forkZS?this._forkZS.onFork(this._forkDlgt,this.zone,e,t):new a(e,t)}intercept(e,t,n){return this._interceptZS?this._interceptZS.onIntercept(this._interceptDlgt,this._interceptCurrZone,e,t,n):t}invoke(e,t,n,o,r){return this._invokeZS?this._invokeZS.onInvoke(this._invokeDlgt,this._invokeCurrZone,e,t,n,o,r):t.apply(n,o)}handleError(e,t){return!this._handleErrorZS||this._handleErrorZS.onHandleError(this._handleErrorDlgt,this._handleErrorCurrZone,e,t)}scheduleTask(e,t){let n=t;if(this._scheduleTaskZS)this._hasTaskZS&&n._zoneDelegates.push(this._hasTaskDlgtOwner),n=this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt,this._scheduleTaskCurrZone,e,t),n||(n=t);else if(t.scheduleFn)t.scheduleFn(t);else{if(t.type!=C)throw new Error("Task is missing scheduleFn.");b(t)}return n}invokeTask(e,t,n,o){return this._invokeTaskZS?this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt,this._invokeTaskCurrZone,e,t,n,o):t.callback.apply(n,o)}cancelTask(e,t){let n;if(this._cancelTaskZS)n=this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt,this._cancelTaskCurrZone,e,t);else{if(!t.cancelFn)throw Error("Task is not cancelable");n=t.cancelFn(t)}return n}hasTask(e,t){try{this._hasTaskZS&&this._hasTaskZS.onHasTask(this._hasTaskDlgt,this._hasTaskCurrZone,e,t)}catch(t){this.handleError(e,t)}}_updateTaskCount(e,t){const n=this._taskCounts,o=n[e],r=n[e]=o+t;if(r<0)throw new Error("More tasks executed then were scheduled.");0!=o&&0!=r||this.hasTask(this.zone,{microTask:n.microTask>0,macroTask:n.macroTask>0,eventTask:n.eventTask>0,change:e})}}class s{constructor(t,n,o,r,a,i){this._zone=null,this.runCount=0,this._zoneDelegates=null,this._state="notScheduled",this.type=t,this.source=n,this.data=r,this.scheduleFn=a,this.cancelFn=i,this.callback=o;const l=this;this.invoke=t===T&&r&&r.useG?s.invokeTask:function(){return s.invokeTask.call(e,l,this,arguments)}}static invokeTask(e,t,n){e||(e=this),D++;try{return e.runCount++,e.zone.runTask(e,t,n)}finally{1==D&&h(),D--}}get zone(){return this._zone}get state(){return this._state}cancelScheduleRequest(){this._transitionTo(x,w)}_transitionTo(e,t,n){if(this._state!==t&&this._state!==n)throw new Error(`${this.type} '${this.source}': can not transition to '${e}', expecting state '${t}'${n?" or '"+n+"'":""}, was '${this._state}'.`);this._state=e,e==x&&(this._zoneDelegates=null)}toString(){return this.data&&void 0!==this.data.handleId?this.data.handleId.toString():Object.prototype.toString.call(this)}toJSON(){return{type:this.type,state:this.state,source:this.source,zone:this.zone.name,runCount:this.runCount}}}const c=F("setTimeout"),f=F("Promise"),d=F("then");let u,m=[],p=!1;function b(t){if(0===D&&0===m.length)if(u||e[f]&&(u=e[f].resolve(0)),u){let e=u[d];e||(e=u.then),e.call(u,h)}else e[c](h,0);t&&m.push(t)}function h(){if(!p){for(p=!0;m.length;){const e=m;m=[];for(let t=0;t<e.length;t++){const n=e[t];try{n.zone.runTask(n,null,null)}catch(e){N.onUnhandledError(e)}}}N.microtaskDrainDone(),p=!1}}const g={name:"NO ZONE"},x="notScheduled",w="scheduling",y="scheduled",v="running",k="canceling",_="unknown",C="microTask",E="macroTask",T="eventTask",S={},N={symbol:F,currentZoneFrame:()=>j,onUnhandledError:M,microtaskDrainDone:M,scheduleMicroTask:b,showUncaughtError:()=>!a[F("ignoreConsoleErrorUncaughtError")],patchEventTarget:()=>[],patchOnProperties:M,patchMethod:()=>M,bindArguments:()=>[],patchThen:()=>M,patchMacroTask:()=>M,setNativePromise:e=>{e&&"function"==typeof e.resolve&&(u=e.resolve(0))},patchEventPrototype:()=>M,isIEOrEdge:()=>!1,getGlobalObjects:()=>{},ObjectDefineProperty:()=>M,ObjectGetOwnPropertyDescriptor:()=>{},ObjectCreate:()=>{},ArraySlice:()=>[],patchClass:()=>M,wrapWithCurrentZone:()=>M,filterProperties:()=>[],attachOriginToPatched:()=>M,_redefineProperty:()=>M,patchCallbacks:()=>M};let j={parent:null,zone:new a(null,null)},I=null,D=0;function M(){}function F(e){return"__zone_symbol__"+e}o("Zone","Zone"),e.Zone=a}("undefined"!=typeof window&&window||"undefined"!=typeof self&&self||global),Zone.__load_patch("ZoneAwarePromise",(e,t,n)=>{const o=Object.getOwnPropertyDescriptor,r=Object.defineProperty,a=n.symbol,i=[],l=a("Promise"),s=a("then");n.onUnhandledError=e=>{if(n.showUncaughtError()){const t=e&&e.rejection;t?console.error("Unhandled Promise rejection:",t instanceof Error?t.message:t,"; Zone:",e.zone.name,"; Task:",e.task&&e.task.source,"; Value:",t,t instanceof Error?t.stack:void 0):console.error(e)}},n.microtaskDrainDone=()=>{for(;i.length;)for(;i.length;){const e=i.shift();try{e.zone.runGuarded(()=>{throw e})}catch(e){f(e)}}};const c=a("unhandledPromiseRejectionHandler");function f(e){n.onUnhandledError(e);try{const n=t[c];n&&"function"==typeof n&&n.call(this,e)}catch(e){}}function d(e){return e&&e.then}function u(e){return e}function m(e){return E.reject(e)}const p=a("state"),b=a("value"),h=a("finally"),g=a("parentPromiseValue"),x=a("parentPromiseState");function w(e,t){return n=>{try{v(e,t,n)}catch(t){v(e,!1,t)}}}const y=a("currentTaskTrace");function v(e,o,a){const l=function(){let e=!1;return function(t){return function(){e||(e=!0,t.apply(null,arguments))}}}();if(e===a)throw new TypeError("Promise resolved with itself");if(null===e[p]){let c=null;try{"object"!=typeof a&&"function"!=typeof a||(c=a&&a.then)}catch(t){return l(()=>{v(e,!1,t)})(),e}if(!1!==o&&a instanceof E&&a.hasOwnProperty(p)&&a.hasOwnProperty(b)&&null!==a[p])_(a),v(e,a[p],a[b]);else if(!1!==o&&"function"==typeof c)try{c.call(a,l(w(e,o)),l(w(e,!1)))}catch(t){l(()=>{v(e,!1,t)})()}else{e[p]=o;const l=e[b];if(e[b]=a,e[h]===h&&!0===o&&(e[p]=e[x],e[b]=e[g]),!1===o&&a instanceof Error){const e=t.currentTask&&t.currentTask.data&&t.currentTask.data.__creationTrace__;e&&r(a,y,{configurable:!0,enumerable:!1,writable:!0,value:e})}for(let t=0;t<l.length;)C(e,l[t++],l[t++],l[t++],l[t++]);if(0==l.length&&0==o){e[p]=0;try{throw new Error("Uncaught (in promise): "+((s=a)&&s.toString===Object.prototype.toString?(s.constructor&&s.constructor.name||"")+": "+JSON.stringify(s):s?s.toString():Object.prototype.toString.call(s))+(a&&a.stack?"\n"+a.stack:""))}catch(o){const r=o;r.rejection=a,r.promise=e,r.zone=t.current,r.task=t.currentTask,i.push(r),n.scheduleMicroTask()}}}}var s;return e}const k=a("rejectionHandledHandler");function _(e){if(0===e[p]){try{const n=t[k];n&&"function"==typeof n&&n.call(this,{rejection:e[b],promise:e})}catch(e){}e[p]=!1;for(let t=0;t<i.length;t++)e===i[t].promise&&i.splice(t,1)}}function C(e,t,n,o,r){_(e);const a=e[p],i=a?"function"==typeof o?o:u:"function"==typeof r?r:m;t.scheduleMicroTask("Promise.then",()=>{try{const o=e[b],r=n&&h===n[h];r&&(n[g]=o,n[x]=a);const l=t.run(i,void 0,r&&i!==m&&i!==u?[]:[o]);v(n,!0,l)}catch(e){v(n,!1,e)}},n)}class E{constructor(e){const t=this;if(!(t instanceof E))throw new Error("Must be an instanceof Promise.");t[p]=null,t[b]=[];try{e&&e(w(t,!0),w(t,!1))}catch(e){v(t,!1,e)}}static toString(){return"function ZoneAwarePromise() { [native code] }"}static resolve(e){return v(new this(null),!0,e)}static reject(e){return v(new this(null),!1,e)}static race(e){let t,n,o=new this((e,o)=>{t=e,n=o});function r(e){t(e)}function a(e){n(e)}for(let t of e)d(t)||(t=this.resolve(t)),t.then(r,a);return o}static all(e){let t,n,o=new this((e,o)=>{t=e,n=o}),r=2,a=0;const i=[];for(let o of e){d(o)||(o=this.resolve(o));const e=a;o.then(n=>{i[e]=n,r--,0===r&&t(i)},n),r++,a++}return r-=2,0===r&&t(i),o}get[Symbol.toStringTag](){return"Promise"}then(e,n){const o=new this.constructor(null),r=t.current;return null==this[p]?this[b].push(r,o,e,n):C(this,r,o,e,n),o}catch(e){return this.then(null,e)}finally(e){const n=new this.constructor(null);n[h]=h;const o=t.current;return null==this[p]?this[b].push(o,n,e,e):C(this,o,n,e,e),n}}E.resolve=E.resolve,E.reject=E.reject,E.race=E.race,E.all=E.all;const T=e[l]=e.Promise,S=t.__symbol__("ZoneAwarePromise");let N=o(e,"Promise");N&&!N.configurable||(N&&delete N.writable,N&&delete N.value,N||(N={configurable:!0,enumerable:!0}),N.get=function(){return e[S]?e[S]:e[l]},N.set=function(t){t===E?e[S]=t:(e[l]=t,t.prototype[s]||I(t),n.setNativePromise(t))},r(e,"Promise",N)),e.Promise=E;const j=a("thenPatched");function I(e){const t=e.prototype,n=o(t,"then");if(n&&(!1===n.writable||!n.configurable))return;const r=t.then;t[s]=r,e.prototype.then=function(e,t){return new E((e,t)=>{r.call(this,e,t)}).then(e,t)},e[j]=!0}if(n.patchThen=I,T){I(T);const t=e.fetch;"function"==typeof t&&(e[n.symbol("fetch")]=t,e.fetch=(D=t,function(){let e=D.apply(this,arguments);if(e instanceof E)return e;let t=e.constructor;return t[j]||I(t),e}))}var D;return Promise[t.__symbol__("uncaughtPromiseErrors")]=i,E});const n=Object.getOwnPropertyDescriptor,o=Object.defineProperty,r=Object.getPrototypeOf,a=Object.create,i=Array.prototype.slice,l=Zone.__symbol__("addEventListener"),s=Zone.__symbol__("removeEventListener");function c(e,t){return Zone.current.wrap(e,t)}function f(e,t,n,o,r){return Zone.current.scheduleMacroTask(e,t,n,o,r)}const d=Zone.__symbol__,u="undefined"!=typeof window,m=u?window:void 0,p=u&&m||"object"==typeof self&&self||global,b=[null];function h(e,t){for(let n=e.length-1;n>=0;n--)"function"==typeof e[n]&&(e[n]=c(e[n],t+"_"+n));return e}function g(e){return!e||!1!==e.writable&&!("function"==typeof e.get&&void 0===e.set)}const x="undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope,w=!("nw"in p)&&void 0!==p.process&&"[object process]"==={}.toString.call(p.process),y=!w&&!x&&!(!u||!m.HTMLElement),v=void 0!==p.process&&"[object process]"==={}.toString.call(p.process)&&!x&&!(!u||!m.HTMLElement),k={},_=function(e){if(!(e=e||p.event))return;let t=k[e.type];t||(t=k[e.type]=d("ON_PROPERTY"+e.type));const n=this||e.target||p,o=n[t];let r;if(y&&n===m&&"error"===e.type){const t=e;r=o&&o.call(this,t.message,t.filename,t.lineno,t.colno,t.error),!0===r&&e.preventDefault()}else r=o&&o.apply(this,arguments),null==r||r||e.preventDefault();return r};function C(e,t,r){let a=n(e,t);if(!a&&r&&n(r,t)&&(a={enumerable:!0,configurable:!0}),!a||!a.configurable)return;const i=d("on"+t+"patched");if(e.hasOwnProperty(i)&&e[i])return;delete a.writable,delete a.value;const l=a.get,s=a.set,c=t.substr(2);let f=k[c];f||(f=k[c]=d("ON_PROPERTY"+c)),a.set=function(t){let n=this;n||e!==p||(n=p),n&&(n[f]&&n.removeEventListener(c,_),s&&s.apply(n,b),"function"==typeof t?(n[f]=t,n.addEventListener(c,_,!1)):n[f]=null)},a.get=function(){let n=this;if(n||e!==p||(n=p),!n)return null;const o=n[f];if(o)return o;if(l){let e=l&&l.call(this);if(e)return a.set.call(this,e),"function"==typeof n.removeAttribute&&n.removeAttribute(t),e}return null},o(e,t,a),e[i]=!0}function E(e,t,n){if(t)for(let o=0;o<t.length;o++)C(e,"on"+t[o],n);else{const t=[];for(const n in e)"on"==n.substr(0,2)&&t.push(n);for(let o=0;o<t.length;o++)C(e,t[o],n)}}const T=d("originalInstance");function S(e){const t=p[e];if(!t)return;p[d(e)]=t,p[e]=function(){const n=h(arguments,e);switch(n.length){case 0:this[T]=new t;break;case 1:this[T]=new t(n[0]);break;case 2:this[T]=new t(n[0],n[1]);break;case 3:this[T]=new t(n[0],n[1],n[2]);break;case 4:this[T]=new t(n[0],n[1],n[2],n[3]);break;default:throw new Error("Arg list too long.")}},I(p[e],t);const n=new t(function(){});let r;for(r in n)"XMLHttpRequest"===e&&"responseBlob"===r||function(t){"function"==typeof n[t]?p[e].prototype[t]=function(){return this[T][t].apply(this[T],arguments)}:o(p[e].prototype,t,{set:function(n){"function"==typeof n?(this[T][t]=c(n,e+"."+t),I(this[T][t],n)):this[T][t]=n},get:function(){return this[T][t]}})}(r);for(r in t)"prototype"!==r&&t.hasOwnProperty(r)&&(p[e][r]=t[r])}function N(e,t,o){let a=e;for(;a&&!a.hasOwnProperty(t);)a=r(a);!a&&e[t]&&(a=e);const i=d(t);let l=null;if(a&&!(l=a[i])&&(l=a[i]=a[t],g(a&&n(a,t)))){const e=o(l,i,t);a[t]=function(){return e(this,arguments)},I(a[t],l)}return l}function j(e,t,n){let o=null;function r(e){const t=e.data;return t.args[t.cbIdx]=function(){e.invoke.apply(this,arguments)},o.apply(t.target,t.args),e}o=N(e,t,e=>function(t,o){const a=n(t,o);return a.cbIdx>=0&&"function"==typeof o[a.cbIdx]?f(a.name,o[a.cbIdx],a,r):e.apply(t,o)})}function I(e,t){e[d("OriginalDelegate")]=t}let D=!1,M=!1;function F(){try{const e=m.navigator.userAgent;if(-1!==e.indexOf("MSIE ")||-1!==e.indexOf("Trident/"))return!0}catch(e){}return!1}function z(){if(D)return M;D=!0;try{const e=m.navigator.userAgent;-1===e.indexOf("MSIE ")&&-1===e.indexOf("Trident/")&&-1===e.indexOf("Edge/")||(M=!0)}catch(e){}return M}Zone.__load_patch("toString",e=>{const t=Function.prototype.toString,n=d("OriginalDelegate"),o=d("Promise"),r=d("Error"),a=function(){if("function"==typeof this){const a=this[n];if(a)return"function"==typeof a?t.call(a):Object.prototype.toString.call(a);if(this===Promise){const n=e[o];if(n)return t.call(n)}if(this===Error){const n=e[r];if(n)return t.call(n)}}return t.call(this)};a[n]=t,Function.prototype.toString=a;const i=Object.prototype.toString;Object.prototype.toString=function(){return this instanceof Promise?"[object Promise]":i.call(this)}});let A=!1;if("undefined"!=typeof window)try{const e=Object.defineProperty({},"passive",{get:function(){A=!0}});window.addEventListener("test",e,e),window.removeEventListener("test",e,e)}catch(e){A=!1}const O={useG:!0},R={},P={},L=/^__zone_symbol__(\w+)(true|false)$/;function H(e,t,n){const o=n&&n.add||"addEventListener",a=n&&n.rm||"removeEventListener",i=n&&n.listeners||"eventListeners",l=n&&n.rmAll||"removeAllListeners",s=d(o),c="."+o+":",f=function(e,t,n){if(e.isRemoved)return;const o=e.callback;"object"==typeof o&&o.handleEvent&&(e.callback=e=>o.handleEvent(e),e.originalDelegate=o),e.invoke(e,t,[n]);const r=e.options;r&&"object"==typeof r&&r.once&&t[a].call(t,n.type,e.originalDelegate?e.originalDelegate:e.callback,r)},u=function(t){if(!(t=t||e.event))return;const n=this||t.target||e,o=n[R[t.type].false];if(o)if(1===o.length)f(o[0],n,t);else{const e=o.slice();for(let o=0;o<e.length&&(!t||!0!==t.__zone_symbol__propagationStopped);o++)f(e[o],n,t)}},m=function(t){if(!(t=t||e.event))return;const n=this||t.target||e,o=n[R[t.type].true];if(o)if(1===o.length)f(o[0],n,t);else{const e=o.slice();for(let o=0;o<e.length&&(!t||!0!==t.__zone_symbol__propagationStopped);o++)f(e[o],n,t)}};function p(t,n){if(!t)return!1;let f=!0;n&&void 0!==n.useG&&(f=n.useG);const p=n&&n.vh;let b=!0;n&&void 0!==n.chkDup&&(b=n.chkDup);let h=!1;n&&void 0!==n.rt&&(h=n.rt);let g=t;for(;g&&!g.hasOwnProperty(o);)g=r(g);if(!g&&t[o]&&(g=t),!g)return!1;if(g[s])return!1;const x=n&&n.eventNameToString,y={},v=g[s]=g[o],k=g[d(a)]=g[a],_=g[d(i)]=g[i],C=g[d(l)]=g[l];let E;function T(e){A||"boolean"==typeof y.options||null==y.options||(e.options=!!y.options.capture,y.options=e.options)}n&&n.prepend&&(E=g[d(n.prepend)]=g[n.prepend]);const S=f?function(e){if(!y.isExisting)return T(e),v.call(y.target,y.eventName,y.capture?m:u,y.options)}:function(e){return T(e),v.call(y.target,y.eventName,e.invoke,y.options)},N=f?function(e){if(!e.isRemoved){const t=R[e.eventName];let n;t&&(n=t[e.capture?"true":"false"]);const o=n&&e.target[n];if(o)for(let t=0;t<o.length;t++)if(o[t]===e){o.splice(t,1),e.isRemoved=!0,0===o.length&&(e.allRemoved=!0,e.target[n]=null);break}}if(e.allRemoved)return k.call(e.target,e.eventName,e.capture?m:u,e.options)}:function(e){return k.call(e.target,e.eventName,e.invoke,e.options)},j=n&&n.diff?n.diff:function(e,t){const n=typeof t;return"function"===n&&e.callback===t||"object"===n&&e.originalDelegate===t},D=Zone[Zone.__symbol__("BLACK_LISTED_EVENTS")],M=function(t,n,o,r,a=!1,i=!1){return function(){const l=this||e,s=arguments[0];let c=arguments[1];if(!c)return t.apply(this,arguments);if(w&&"uncaughtException"===s)return t.apply(this,arguments);let d=!1;if("function"!=typeof c){if(!c.handleEvent)return t.apply(this,arguments);d=!0}if(p&&!p(t,c,l,arguments))return;const u=arguments[2];if(D)for(let e=0;e<D.length;e++)if(s===D[e])return t.apply(this,arguments);let m,h=!1;void 0===u?m=!1:!0===u?m=!0:!1===u?m=!1:(m=!!u&&!!u.capture,h=!!u&&!!u.once);const g=Zone.current,v=R[s];let k;if(v)k=v[m?"true":"false"];else{const e="__zone_symbol__"+(x?x(s):s)+"false",t="__zone_symbol__"+(x?x(s):s)+"true";R[s]={},R[s].false=e,R[s].true=t,k=m?t:e}let _,C=l[k],E=!1;if(C){if(E=!0,b)for(let e=0;e<C.length;e++)if(j(C[e],c))return}else C=l[k]=[];const T=l.constructor.name,S=P[T];S&&(_=S[s]),_||(_=T+n+(x?x(s):s)),y.options=u,h&&(y.options.once=!1),y.target=l,y.capture=m,y.eventName=s,y.isExisting=E;const N=f?O:void 0;N&&(N.taskData=y);const I=g.scheduleEventTask(_,c,N,o,r);return y.target=null,N&&(N.taskData=null),h&&(u.once=!0),(A||"boolean"!=typeof I.options)&&(I.options=u),I.target=l,I.capture=m,I.eventName=s,d&&(I.originalDelegate=c),i?C.unshift(I):C.push(I),a?l:void 0}};return g[o]=M(v,c,S,N,h),E&&(g.prependListener=M(E,".prependListener:",function(e){return E.call(y.target,y.eventName,e.invoke,y.options)},N,h,!0)),g[a]=function(){const t=this||e,n=arguments[0],o=arguments[2];let r;r=void 0!==o&&(!0===o||!1!==o&&!!o&&!!o.capture);const a=arguments[1];if(!a)return k.apply(this,arguments);if(p&&!p(k,a,t,arguments))return;const i=R[n];let l;i&&(l=i[r?"true":"false"]);const s=l&&t[l];if(s)for(let e=0;e<s.length;e++){const n=s[e];if(j(n,a))return s.splice(e,1),n.isRemoved=!0,0===s.length&&(n.allRemoved=!0,t[l]=null),n.zone.cancelTask(n),h?t:void 0}return k.apply(this,arguments)},g[i]=function(){const t=arguments[0],n=[],o=V(this||e,x?x(t):t);for(let e=0;e<o.length;e++){const t=o[e];n.push(t.originalDelegate?t.originalDelegate:t.callback)}return n},g[l]=function(){const t=this||e,n=arguments[0];if(n){const e=R[n];if(e){const o=t[e.false],r=t[e.true];if(o){const e=o.slice();for(let t=0;t<e.length;t++){const o=e[t];this[a].call(this,n,o.originalDelegate?o.originalDelegate:o.callback,o.options)}}if(r){const e=r.slice();for(let t=0;t<e.length;t++){const o=e[t];this[a].call(this,n,o.originalDelegate?o.originalDelegate:o.callback,o.options)}}}}else{const e=Object.keys(t);for(let t=0;t<e.length;t++){const n=L.exec(e[t]);let o=n&&n[1];o&&"removeListener"!==o&&this[l].call(this,o)}this[l].call(this,"removeListener")}if(h)return this},I(g[o],v),I(g[a],k),C&&I(g[l],C),_&&I(g[i],_),!0}let b=[];for(let e=0;e<t.length;e++)b[e]=p(t[e],n);return b}function V(e,t){const n=[];for(let o in e){const r=L.exec(o);let a=r&&r[1];if(a&&(!t||a===t)){const t=e[o];if(t)for(let e=0;e<t.length;e++)n.push(t[e])}}return n}function q(e,t){const n=e.Event;n&&n.prototype&&t.patchMethod(n.prototype,"stopImmediatePropagation",e=>function(t,n){t.__zone_symbol__propagationStopped=!0,e&&e.apply(t,n)})}function Z(e,t,n,o,r){const a=Zone.__symbol__(o);if(t[a])return;const i=t[a]=t[o];t[o]=function(a,l,s){return l&&l.prototype&&r.forEach(function(t){const r=`${n}.${o}::`+t,a=l.prototype;if(a.hasOwnProperty(t)){const n=e.ObjectGetOwnPropertyDescriptor(a,t);n&&n.value?(n.value=e.wrapWithCurrentZone(n.value,r),e._redefineProperty(l.prototype,t,n)):a[t]&&(a[t]=e.wrapWithCurrentZone(a[t],r))}else a[t]&&(a[t]=e.wrapWithCurrentZone(a[t],r))}),i.call(t,a,l,s)},e.attachOriginToPatched(t[o],i)}const B=Zone.__symbol__,$=Object[B("defineProperty")]=Object.defineProperty,U=Object[B("getOwnPropertyDescriptor")]=Object.getOwnPropertyDescriptor,Q=Object.create,W=B("unconfigurables");function G(e,t,n){const o=n.configurable;return X(e,t,n=K(e,t,n),o)}function Y(e,t){return e&&e[W]&&e[W][t]}function K(e,t,n){return Object.isFrozen(n)||(n.configurable=!0),n.configurable||(e[W]||Object.isFrozen(e)||$(e,W,{writable:!0,value:{}}),e[W]&&(e[W][t]=!0)),n}function X(e,t,n,o){try{return $(e,t,n)}catch(r){if(!n.configurable)throw r;void 0===o?delete n.configurable:n.configurable=o;try{return $(e,t,n)}catch(o){let r=null;try{r=JSON.stringify(n)}catch(e){r=n.toString()}console.log(`Attempting to configure '${t}' with descriptor '${r}' on object '${e}' and got error, giving up: ${o}`)}}}const J=["absolutedeviceorientation","afterinput","afterprint","appinstalled","beforeinstallprompt","beforeprint","beforeunload","devicelight","devicemotion","deviceorientation","deviceorientationabsolute","deviceproximity","hashchange","languagechange","message","mozbeforepaint","offline","online","paint","pageshow","pagehide","popstate","rejectionhandled","storage","unhandledrejection","unload","userproximity","vrdisplyconnected","vrdisplaydisconnected","vrdisplaypresentchange"],ee=["encrypted","waitingforkey","msneedkey","mozinterruptbegin","mozinterruptend"],te=["load"],ne=["blur","error","focus","load","resize","scroll","messageerror"],oe=["bounce","finish","start"],re=["loadstart","progress","abort","error","load","progress","timeout","loadend","readystatechange"],ae=["upgradeneeded","complete","abort","success","error","blocked","versionchange","close"],ie=["close","error","open","message"],le=["error","message"],se=["abort","animationcancel","animationend","animationiteration","auxclick","beforeinput","blur","cancel","canplay","canplaythrough","change","compositionstart","compositionupdate","compositionend","cuechange","click","close","contextmenu","curechange","dblclick","drag","dragend","dragenter","dragexit","dragleave","dragover","drop","durationchange","emptied","ended","error","focus","focusin","focusout","gotpointercapture","input","invalid","keydown","keypress","keyup","load","loadstart","loadeddata","loadedmetadata","lostpointercapture","mousedown","mouseenter","mouseleave","mousemove","mouseout","mouseover","mouseup","mousewheel","orientationchange","pause","play","playing","pointercancel","pointerdown","pointerenter","pointerleave","pointerlockchange","mozpointerlockchange","webkitpointerlockerchange","pointerlockerror","mozpointerlockerror","webkitpointerlockerror","pointermove","pointout","pointerover","pointerup","progress","ratechange","reset","resize","scroll","seeked","seeking","select","selectionchange","selectstart","show","sort","stalled","submit","suspend","timeupdate","volumechange","touchcancel","touchmove","touchstart","touchend","transitioncancel","transitionend","waiting","wheel"].concat(["webglcontextrestored","webglcontextlost","webglcontextcreationerror"],["autocomplete","autocompleteerror"],["toggle"],["afterscriptexecute","beforescriptexecute","DOMContentLoaded","freeze","fullscreenchange","mozfullscreenchange","webkitfullscreenchange","msfullscreenchange","fullscreenerror","mozfullscreenerror","webkitfullscreenerror","msfullscreenerror","readystatechange","visibilitychange","resume"],J,["beforecopy","beforecut","beforepaste","copy","cut","paste","dragstart","loadend","animationstart","search","transitionrun","transitionstart","webkitanimationend","webkitanimationiteration","webkitanimationstart","webkittransitionend"],["activate","afterupdate","ariarequest","beforeactivate","beforedeactivate","beforeeditfocus","beforeupdate","cellchange","controlselect","dataavailable","datasetchanged","datasetcomplete","errorupdate","filterchange","layoutcomplete","losecapture","move","moveend","movestart","propertychange","resizeend","resizestart","rowenter","rowexit","rowsdelete","rowsinserted","command","compassneedscalibration","deactivate","help","mscontentzoom","msmanipulationstatechanged","msgesturechange","msgesturedoubletap","msgestureend","msgesturehold","msgesturestart","msgesturetap","msgotpointercapture","msinertiastart","mslostpointercapture","mspointercancel","mspointerdown","mspointerenter","mspointerhover","mspointerleave","mspointermove","mspointerout","mspointerover","mspointerup","pointerout","mssitemodejumplistitemremoved","msthumbnailclick","stop","storagecommit"]);function ce(e,t,n){if(!n||0===n.length)return t;const o=n.filter(t=>t.target===e);if(!o||0===o.length)return t;const r=o[0].ignoreProperties;return t.filter(e=>-1===r.indexOf(e))}function fe(e,t,n,o){e&&E(e,ce(e,t,n),o)}function de(e,t){if(w&&!v)return;if(Zone[e.symbol("patchEvents")])return;const n="undefined"!=typeof WebSocket,o=t.__Zone_ignore_on_properties;if(y){const e=window,t=F?[{target:e,ignoreProperties:["error"]}]:[];fe(e,se.concat(["messageerror"]),o?o.concat(t):o,r(e)),fe(Document.prototype,se,o),void 0!==e.SVGElement&&fe(e.SVGElement.prototype,se,o),fe(Element.prototype,se,o),fe(HTMLElement.prototype,se,o),fe(HTMLMediaElement.prototype,ee,o),fe(HTMLFrameSetElement.prototype,J.concat(ne),o),fe(HTMLBodyElement.prototype,J.concat(ne),o),fe(HTMLFrameElement.prototype,te,o),fe(HTMLIFrameElement.prototype,te,o);const n=e.HTMLMarqueeElement;n&&fe(n.prototype,oe,o);const a=e.Worker;a&&fe(a.prototype,le,o)}const a=t.XMLHttpRequest;a&&fe(a.prototype,re,o);const i=t.XMLHttpRequestEventTarget;i&&fe(i&&i.prototype,re,o),"undefined"!=typeof IDBIndex&&(fe(IDBIndex.prototype,ae,o),fe(IDBRequest.prototype,ae,o),fe(IDBOpenDBRequest.prototype,ae,o),fe(IDBDatabase.prototype,ae,o),fe(IDBTransaction.prototype,ae,o),fe(IDBCursor.prototype,ae,o)),n&&fe(WebSocket.prototype,ie,o)}Zone.__load_patch("util",(e,t,r)=>{r.patchOnProperties=E,r.patchMethod=N,r.bindArguments=h,r.patchMacroTask=j;const l=t.__symbol__("BLACK_LISTED_EVENTS"),s=t.__symbol__("UNPATCHED_EVENTS");e[s]&&(e[l]=e[s]),e[l]&&(t[l]=t[s]=e[l]),r.patchEventPrototype=q,r.patchEventTarget=H,r.isIEOrEdge=z,r.ObjectDefineProperty=o,r.ObjectGetOwnPropertyDescriptor=n,r.ObjectCreate=a,r.ArraySlice=i,r.patchClass=S,r.wrapWithCurrentZone=c,r.filterProperties=ce,r.attachOriginToPatched=I,r._redefineProperty=G,r.patchCallbacks=Z,r.getGlobalObjects=()=>({globalSources:P,zoneSymbolEventNames:R,eventNames:se,isBrowser:y,isMix:v,isNode:w,TRUE_STR:"true",FALSE_STR:"false",ZONE_SYMBOL_PREFIX:"__zone_symbol__",ADD_EVENT_LISTENER_STR:"addEventListener",REMOVE_EVENT_LISTENER_STR:"removeEventListener"})});const ue=d("zoneTask");function me(e,t,n,o){let r=null,a=null;n+=o;const i={};function l(t){const n=t.data;return n.args[0]=function(){try{t.invoke.apply(this,arguments)}finally{t.data&&t.data.isPeriodic||("number"==typeof n.handleId?delete i[n.handleId]:n.handleId&&(n.handleId[ue]=null))}},n.handleId=r.apply(e,n.args),t}function s(e){return a(e.data.handleId)}r=N(e,t+=o,n=>function(r,a){if("function"==typeof a[0]){const e=f(t,a[0],{isPeriodic:"Interval"===o,delay:"Timeout"===o||"Interval"===o?a[1]||0:void 0,args:a},l,s);if(!e)return e;const n=e.data.handleId;return"number"==typeof n?i[n]=e:n&&(n[ue]=e),n&&n.ref&&n.unref&&"function"==typeof n.ref&&"function"==typeof n.unref&&(e.ref=n.ref.bind(n),e.unref=n.unref.bind(n)),"number"==typeof n||n?n:e}return n.apply(e,a)}),a=N(e,n,t=>function(n,o){const r=o[0];let a;"number"==typeof r?a=i[r]:(a=r&&r[ue],a||(a=r)),a&&"string"==typeof a.type?"notScheduled"!==a.state&&(a.cancelFn&&a.data.isPeriodic||0===a.runCount)&&("number"==typeof r?delete i[r]:r&&(r[ue]=null),a.zone.cancelTask(a)):t.apply(e,o)})}Zone.__load_patch("legacy",e=>{const t=e[Zone.__symbol__("legacyPatch")];t&&t()}),Zone.__load_patch("timers",e=>{me(e,"set","clear","Timeout"),me(e,"set","clear","Interval"),me(e,"set","clear","Immediate")}),Zone.__load_patch("requestAnimationFrame",e=>{me(e,"request","cancel","AnimationFrame"),me(e,"mozRequest","mozCancel","AnimationFrame"),me(e,"webkitRequest","webkitCancel","AnimationFrame")}),Zone.__load_patch("blocking",(e,t)=>{const n=["alert","prompt","confirm"];for(let o=0;o<n.length;o++)N(e,n[o],(n,o,r)=>function(o,a){return t.current.run(n,e,a,r)})}),Zone.__load_patch("EventTarget",(e,t,n)=>{!function(e,t){t.patchEventPrototype(e,t)}(e,n),function(e,t){if(Zone[t.symbol("patchEventTarget")])return;const{eventNames:n,zoneSymbolEventNames:o,TRUE_STR:r,FALSE_STR:a,ZONE_SYMBOL_PREFIX:i}=t.getGlobalObjects();for(let e=0;e<n.length;e++){const t=n[e],l=i+(t+a),s=i+(t+r);o[t]={},o[t][a]=l,o[t][r]=s}const l=e.EventTarget;l&&l.prototype&&t.patchEventTarget(e,[l&&l.prototype])}(e,n);const o=e.XMLHttpRequestEventTarget;o&&o.prototype&&n.patchEventTarget(e,[o.prototype]),S("MutationObserver"),S("WebKitMutationObserver"),S("IntersectionObserver"),S("FileReader")}),Zone.__load_patch("on_property",(e,t,n)=>{de(n,e),Object.defineProperty=function(e,t,n){if(Y(e,t))throw new TypeError("Cannot assign to read only property '"+t+"' of "+e);const o=n.configurable;return"prototype"!==t&&(n=K(e,t,n)),X(e,t,n,o)},Object.defineProperties=function(e,t){return Object.keys(t).forEach(function(n){Object.defineProperty(e,n,t[n])}),e},Object.create=function(e,t){return"object"!=typeof t||Object.isFrozen(t)||Object.keys(t).forEach(function(n){t[n]=K(e,n,t[n])}),Q(e,t)},Object.getOwnPropertyDescriptor=function(e,t){const n=U(e,t);return n&&Y(e,t)&&(n.configurable=!1),n}}),Zone.__load_patch("customElements",(e,t,n)=>{!function(e,t){const{isBrowser:n,isMix:o}=t.getGlobalObjects();(n||o)&&e.customElements&&"customElements"in e&&t.patchCallbacks(t,e.customElements,"customElements","define",["connectedCallback","disconnectedCallback","adoptedCallback","attributeChangedCallback"])}(e,n)}),Zone.__load_patch("XHR",(e,t)=>{!function(e){const u=e.XMLHttpRequest;if(!u)return;const m=u.prototype;let p=m[l],b=m[s];if(!p){const t=e.XMLHttpRequestEventTarget;if(t){const e=t.prototype;p=e[l],b=e[s]}}function h(e){const t=e.data,o=t.target;o[a]=!1,o[c]=!1;const i=o[r];p||(p=o[l],b=o[s]),i&&b.call(o,"readystatechange",i);const f=o[r]=()=>{if(o.readyState===o.DONE)if(!t.aborted&&o[a]&&"scheduled"===e.state){const n=o.__zone_symbol__loadfalse;if(n&&n.length>0){const r=e.invoke;e.invoke=function(){const n=o.__zone_symbol__loadfalse;for(let t=0;t<n.length;t++)n[t]===e&&n.splice(t,1);t.aborted||"scheduled"!==e.state||r.call(e)},n.push(e)}else e.invoke()}else t.aborted||!1!==o[a]||(o[c]=!0)};return p.call(o,"readystatechange",f),o[n]||(o[n]=e),k.apply(o,t.args),o[a]=!0,e}function g(){}function x(e){const t=e.data;return t.aborted=!0,_.apply(t.target,t.args)}const w=N(m,"open",()=>function(e,t){return e[o]=0==t[2],e[i]=t[1],w.apply(e,t)}),y=d("fetchTaskAborting"),v=d("fetchTaskScheduling"),k=N(m,"send",()=>function(e,n){if(!0===t.current[v])return k.apply(e,n);if(e[o])return k.apply(e,n);{const t={target:e,url:e[i],isPeriodic:!1,args:n,aborted:!1},o=f("XMLHttpRequest.send",g,t,h,x);e&&!0===e[c]&&!t.aborted&&"scheduled"===o.state&&o.invoke()}}),_=N(m,"abort",()=>function(e,o){const r=e[n];if(r&&"string"==typeof r.type){if(null==r.cancelFn||r.data&&r.data.aborted)return;r.zone.cancelTask(r)}else if(!0===t.current[y])return _.apply(e,o)})}(e);const n=d("xhrTask"),o=d("xhrSync"),r=d("xhrListener"),a=d("xhrScheduled"),i=d("xhrURL"),c=d("xhrErrorBeforeScheduled")}),Zone.__load_patch("geolocation",e=>{e.navigator&&e.navigator.geolocation&&function(e,t){const o=e.constructor.name;for(let r=0;r<t.length;r++){const a=t[r],i=e[a];if(i){if(!g(n(e,a)))continue;e[a]=(e=>{const t=function(){return e.apply(this,h(arguments,o+"."+a))};return I(t,e),t})(i)}}}(e.navigator.geolocation,["getCurrentPosition","watchPosition"])}),Zone.__load_patch("PromiseRejectionEvent",(e,t)=>{function n(t){return function(n){V(e,t).forEach(o=>{const r=e.PromiseRejectionEvent;if(r){const e=new r(t,{promise:n.promise,reason:n.rejection});o.invoke(e)}})}}e.PromiseRejectionEvent&&(t[d("unhandledPromiseRejectionHandler")]=n("unhandledrejection"),t[d("rejectionHandledHandler")]=n("rejectionhandled"))})}},[[1,0]]]),(window.webpackJsonp=window.webpackJsonp||[]).push([[1],{0:function(e,t,n){e.exports=n("zUnb")},zUnb:function(e,t,n){"use strict";function o(e){return"function"==typeof e}n.r(t);let r=!1;const a={Promise:void 0,set useDeprecatedSynchronousErrorHandling(e){if(e){const e=new Error;console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n"+e.stack)}else r&&console.log("RxJS: Back to a better error behavior. Thank you. <3");r=e},get useDeprecatedSynchronousErrorHandling(){return r}};function i(e){setTimeout(()=>{throw e})}const l={closed:!0,next(e){},error(e){if(a.useDeprecatedSynchronousErrorHandling)throw e;i(e)},complete(){}},s=Array.isArray||(e=>e&&"number"==typeof e.length);function c(e){return null!==e&&"object"==typeof e}function f(e){return Error.call(this),this.message=e?`${e.length} errors occurred during unsubscription:\n${e.map((e,t)=>`${t+1}) ${e.toString()}`).join("\n  ")}`:"",this.name="UnsubscriptionError",this.errors=e,this}f.prototype=Object.create(Error.prototype);const d=f;let u=(()=>{class e{constructor(e){this.closed=!1,this._parent=null,this._parents=null,this._subscriptions=null,e&&(this._unsubscribe=e)}unsubscribe(){let e,t=!1;if(this.closed)return;let{_parent:n,_parents:r,_unsubscribe:a,_subscriptions:i}=this;this.closed=!0,this._parent=null,this._parents=null,this._subscriptions=null;let l=-1,f=r?r.length:0;for(;n;)n.remove(this),n=++l<f&&r[l]||null;if(o(a))try{a.call(this)}catch(n){t=!0,e=n instanceof d?m(n.errors):[n]}if(s(i))for(l=-1,f=i.length;++l<f;){const o=i[l];if(c(o))try{o.unsubscribe()}catch(n){t=!0,e=e||[],n instanceof d?e=e.concat(m(n.errors)):e.push(n)}}if(t)throw new d(e)}add(t){let n=t;switch(typeof t){case"function":n=new e(t);case"object":if(n===this||n.closed||"function"!=typeof n.unsubscribe)return n;if(this.closed)return n.unsubscribe(),n;if(!(n instanceof e)){const t=n;n=new e,n._subscriptions=[t]}break;default:if(!t)return e.EMPTY;throw new Error("unrecognized teardown "+t+" added to Subscription.")}if(n._addParent(this)){const e=this._subscriptions;e?e.push(n):this._subscriptions=[n]}return n}remove(e){const t=this._subscriptions;if(t){const n=t.indexOf(e);-1!==n&&t.splice(n,1)}}_addParent(e){let{_parent:t,_parents:n}=this;return t!==e&&(t?n?-1===n.indexOf(e)&&(n.push(e),!0):(this._parents=[e],!0):(this._parent=e,!0))}}return e.EMPTY=function(e){return e.closed=!0,e}(new e),e})();function m(e){return e.reduce((e,t)=>e.concat(t instanceof d?t.errors:t),[])}const p="function"==typeof Symbol?Symbol("rxSubscriber"):"@@rxSubscriber_"+Math.random();class b extends u{constructor(e,t,n){switch(super(),this.syncErrorValue=null,this.syncErrorThrown=!1,this.syncErrorThrowable=!1,this.isStopped=!1,arguments.length){case 0:this.destination=l;break;case 1:if(!e){this.destination=l;break}if("object"==typeof e){e instanceof b?(this.syncErrorThrowable=e.syncErrorThrowable,this.destination=e,e.add(this)):(this.syncErrorThrowable=!0,this.destination=new h(this,e));break}default:this.syncErrorThrowable=!0,this.destination=new h(this,e,t,n)}}[p](){return this}static create(e,t,n){const o=new b(e,t,n);return o.syncErrorThrowable=!1,o}next(e){this.isStopped||this._next(e)}error(e){this.isStopped||(this.isStopped=!0,this._error(e))}complete(){this.isStopped||(this.isStopped=!0,this._complete())}unsubscribe(){this.closed||(this.isStopped=!0,super.unsubscribe())}_next(e){this.destination.next(e)}_error(e){this.destination.error(e),this.unsubscribe()}_complete(){this.destination.complete(),this.unsubscribe()}_unsubscribeAndRecycle(){const{_parent:e,_parents:t}=this;return this._parent=null,this._parents=null,this.unsubscribe(),this.closed=!1,this.isStopped=!1,this._parent=e,this._parents=t,this}}class h extends b{constructor(e,t,n,r){let a;super(),this._parentSubscriber=e;let i=this;o(t)?a=t:t&&(a=t.next,n=t.error,r=t.complete,t!==l&&(i=Object.create(t),o(i.unsubscribe)&&this.add(i.unsubscribe.bind(i)),i.unsubscribe=this.unsubscribe.bind(this))),this._context=i,this._next=a,this._error=n,this._complete=r}next(e){if(!this.isStopped&&this._next){const{_parentSubscriber:t}=this;a.useDeprecatedSynchronousErrorHandling&&t.syncErrorThrowable?this.__tryOrSetError(t,this._next,e)&&this.unsubscribe():this.__tryOrUnsub(this._next,e)}}error(e){if(!this.isStopped){const{_parentSubscriber:t}=this,{useDeprecatedSynchronousErrorHandling:n}=a;if(this._error)n&&t.syncErrorThrowable?(this.__tryOrSetError(t,this._error,e),this.unsubscribe()):(this.__tryOrUnsub(this._error,e),this.unsubscribe());else if(t.syncErrorThrowable)n?(t.syncErrorValue=e,t.syncErrorThrown=!0):i(e),this.unsubscribe();else{if(this.unsubscribe(),n)throw e;i(e)}}}complete(){if(!this.isStopped){const{_parentSubscriber:e}=this;if(this._complete){const t=()=>this._complete.call(this._context);a.useDeprecatedSynchronousErrorHandling&&e.syncErrorThrowable?(this.__tryOrSetError(e,t),this.unsubscribe()):(this.__tryOrUnsub(t),this.unsubscribe())}else this.unsubscribe()}}__tryOrUnsub(e,t){try{e.call(this._context,t)}catch(e){if(this.unsubscribe(),a.useDeprecatedSynchronousErrorHandling)throw e;i(e)}}__tryOrSetError(e,t,n){if(!a.useDeprecatedSynchronousErrorHandling)throw new Error("bad call");try{t.call(this._context,n)}catch(t){return a.useDeprecatedSynchronousErrorHandling?(e.syncErrorValue=t,e.syncErrorThrown=!0,!0):(i(t),!0)}return!1}_unsubscribe(){const{_parentSubscriber:e}=this;this._context=null,this._parentSubscriber=null,e.unsubscribe()}}const g="function"==typeof Symbol&&Symbol.observable||"@@observable";function x(){}let w=(()=>{class e{constructor(e){this._isScalar=!1,e&&(this._subscribe=e)}lift(t){const n=new e;return n.source=this,n.operator=t,n}subscribe(e,t,n){const{operator:o}=this,r=function(e,t,n){if(e){if(e instanceof b)return e;if(e[p])return e[p]()}return e||t||n?new b(e,t,n):new b(l)}(e,t,n);if(r.add(o?o.call(r,this.source):this.source||a.useDeprecatedSynchronousErrorHandling&&!r.syncErrorThrowable?this._subscribe(r):this._trySubscribe(r)),a.useDeprecatedSynchronousErrorHandling&&r.syncErrorThrowable&&(r.syncErrorThrowable=!1,r.syncErrorThrown))throw r.syncErrorValue;return r}_trySubscribe(e){try{return this._subscribe(e)}catch(t){a.useDeprecatedSynchronousErrorHandling&&(e.syncErrorThrown=!0,e.syncErrorValue=t),function(e){for(;e;){const{closed:t,destination:n,isStopped:o}=e;if(t||o)return!1;e=n&&n instanceof b?n:null}return!0}(e)?e.error(t):console.warn(t)}}forEach(e,t){return new(t=y(t))((t,n)=>{let o;o=this.subscribe(t=>{try{e(t)}catch(e){n(e),o&&o.unsubscribe()}},n,t)})}_subscribe(e){const{source:t}=this;return t&&t.subscribe(e)}[g](){return this}pipe(...e){return 0===e.length?this:((t=e)?1===t.length?t[0]:function(e){return t.reduce((e,t)=>t(e),e)}:x)(this);var t}toPromise(e){return new(e=y(e))((e,t)=>{let n;this.subscribe(e=>n=e,e=>t(e),()=>e(n))})}}return e.create=t=>new e(t),e})();function y(e){if(e||(e=a.Promise||Promise),!e)throw new Error("no Promise impl found");return e}function v(){return Error.call(this),this.message="object unsubscribed",this.name="ObjectUnsubscribedError",this}v.prototype=Object.create(Error.prototype);const k=v;class _ extends u{constructor(e,t){super(),this.subject=e,this.subscriber=t,this.closed=!1}unsubscribe(){if(this.closed)return;this.closed=!0;const e=this.subject,t=e.observers;if(this.subject=null,!t||0===t.length||e.isStopped||e.closed)return;const n=t.indexOf(this.subscriber);-1!==n&&t.splice(n,1)}}class C extends b{constructor(e){super(e),this.destination=e}}let E=(()=>{class e extends w{constructor(){super(),this.observers=[],this.closed=!1,this.isStopped=!1,this.hasError=!1,this.thrownError=null}[p](){return new C(this)}lift(e){const t=new T(this,this);return t.operator=e,t}next(e){if(this.closed)throw new k;if(!this.isStopped){const{observers:t}=this,n=t.length,o=t.slice();for(let t=0;t<n;t++)o[t].next(e)}}error(e){if(this.closed)throw new k;this.hasError=!0,this.thrownError=e,this.isStopped=!0;const{observers:t}=this,n=t.length,o=t.slice();for(let t=0;t<n;t++)o[t].error(e);this.observers.length=0}complete(){if(this.closed)throw new k;this.isStopped=!0;const{observers:e}=this,t=e.length,n=e.slice();for(let e=0;e<t;e++)n[e].complete();this.observers.length=0}unsubscribe(){this.isStopped=!0,this.closed=!0,this.observers=null}_trySubscribe(e){if(this.closed)throw new k;return super._trySubscribe(e)}_subscribe(e){if(this.closed)throw new k;return this.hasError?(e.error(this.thrownError),u.EMPTY):this.isStopped?(e.complete(),u.EMPTY):(this.observers.push(e),new _(this,e))}asObservable(){const e=new w;return e.source=this,e}}return e.create=(e,t)=>new T(e,t),e})();class T extends E{constructor(e,t){super(),this.destination=e,this.source=t}next(e){const{destination:t}=this;t&&t.next&&t.next(e)}error(e){const{destination:t}=this;t&&t.error&&this.destination.error(e)}complete(){const{destination:e}=this;e&&e.complete&&this.destination.complete()}_subscribe(e){const{source:t}=this;return t?this.source.subscribe(e):u.EMPTY}}class S extends b{constructor(e,t,n){super(),this.parent=e,this.outerValue=t,this.outerIndex=n,this.index=0}_next(e){this.parent.notifyNext(this.outerValue,e,this.outerIndex,this.index++,this)}_error(e){this.parent.notifyError(e,this),this.unsubscribe()}_complete(){this.parent.notifyComplete(this),this.unsubscribe()}}const N=e=>t=>{for(let n=0,o=e.length;n<o&&!t.closed;n++)t.next(e[n]);t.closed||t.complete()},j="function"==typeof Symbol&&Symbol.iterator?Symbol.iterator:"@@iterator",I=e=>{if(e instanceof w)return t=>e._isScalar?(t.next(e.value),void t.complete()):e.subscribe(t);if(e&&"function"==typeof e[g])return(e=>t=>{const n=e[g]();if("function"!=typeof n.subscribe)throw new TypeError("Provided object does not correctly implement Symbol.observable");return n.subscribe(t)})(e);if((e=>e&&"number"==typeof e.length&&"function"!=typeof e)(e))return N(e);if(function(e){return!!e&&"function"!=typeof e.subscribe&&"function"==typeof e.then}(e))return(e=>t=>(e.then(e=>{t.closed||(t.next(e),t.complete())},e=>t.error(e)).then(null,i),t))(e);if(e&&"function"==typeof e[j])return(e=>t=>{const n=e[j]();for(;;){const e=n.next();if(e.done){t.complete();break}if(t.next(e.value),t.closed)break}return"function"==typeof n.return&&t.add(()=>{n.return&&n.return()}),t})(e);{const t=c(e)?"an invalid object":`'${e}'`;throw new TypeError(`You provided ${t} where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.`)}};class D extends b{notifyNext(e,t,n,o,r){this.destination.next(t)}notifyError(e,t){this.destination.error(e)}notifyComplete(e){this.destination.complete()}}function M(e,t){return function(n){if("function"!=typeof e)throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");return n.lift(new F(e,t))}}class F{constructor(e,t){this.project=e,this.thisArg=t}call(e,t){return t.subscribe(new z(e,this.project,this.thisArg))}}class z extends b{constructor(e,t,n){super(e),this.project=t,this.count=0,this.thisArg=n||this}_next(e){let t;try{t=this.project.call(this.thisArg,e,this.count++)}catch(e){return void this.destination.error(e)}this.destination.next(t)}}class A{constructor(e,t=Number.POSITIVE_INFINITY){this.project=e,this.concurrent=t}call(e,t){return t.subscribe(new O(e,this.project,this.concurrent))}}class O extends D{constructor(e,t,n=Number.POSITIVE_INFINITY){super(e),this.project=t,this.concurrent=n,this.hasCompleted=!1,this.buffer=[],this.active=0,this.index=0}_next(e){this.active<this.concurrent?this._tryNext(e):this.buffer.push(e)}_tryNext(e){let t;const n=this.index++;try{t=this.project(e,n)}catch(e){return void this.destination.error(e)}this.active++,this._innerSub(t,e,n)}_innerSub(e,t,n){const o=new S(this,void 0,void 0);this.destination.add(o),function(e,t,n,o,r=new S(e,n,o)){r.closed||I(t)(r)}(this,e,t,n,o)}_complete(){this.hasCompleted=!0,0===this.active&&0===this.buffer.length&&this.destination.complete(),this.unsubscribe()}notifyNext(e,t,n,o,r){this.destination.next(t)}notifyComplete(e){const t=this.buffer;this.remove(e),this.active--,t.length>0?this._next(t.shift()):0===this.active&&this.hasCompleted&&this.destination.complete()}}function R(e){return e}function P(...e){let t=Number.POSITIVE_INFINITY,n=null,o=e[e.length-1];var r;return(r=o)&&"function"==typeof r.schedule?(n=e.pop(),e.length>1&&"number"==typeof e[e.length-1]&&(t=e.pop())):"number"==typeof o&&(t=e.pop()),null===n&&1===e.length&&e[0]instanceof w?e[0]:function(e=Number.POSITIVE_INFINITY){return function e(t,n,o=Number.POSITIVE_INFINITY){return"function"==typeof n?r=>r.pipe(e((e,o)=>{return(r=t(e,o),r instanceof w?r:new w(I(r))).pipe(M((t,r)=>n(e,t,o,r)));var r},o)):("number"==typeof n&&(o=n),e=>e.lift(new A(t,o)))}(R,e)}(t)(function(e,t){return new w(t?n=>{const o=new u;let r=0;return o.add(t.schedule(function(){r!==e.length?(n.next(e[r++]),n.closed||o.add(this.schedule())):n.complete()})),o}:N(e))}(e,n))}function L(){return function(e){return e.lift(new H(e))}}class H{constructor(e){this.connectable=e}call(e,t){const{connectable:n}=this;n._refCount++;const o=new V(e,n),r=t.subscribe(o);return o.closed||(o.connection=n.connect()),r}}class V extends b{constructor(e,t){super(e),this.connectable=t}_unsubscribe(){const{connectable:e}=this;if(!e)return void(this.connection=null);this.connectable=null;const t=e._refCount;if(t<=0)return void(this.connection=null);if(e._refCount=t-1,t>1)return void(this.connection=null);const{connection:n}=this,o=e._connection;this.connection=null,!o||n&&o!==n||o.unsubscribe()}}const q=class extends w{constructor(e,t){super(),this.source=e,this.subjectFactory=t,this._refCount=0,this._isComplete=!1}_subscribe(e){return this.getSubject().subscribe(e)}getSubject(){const e=this._subject;return e&&!e.isStopped||(this._subject=this.subjectFactory()),this._subject}connect(){let e=this._connection;return e||(this._isComplete=!1,e=this._connection=new u,e.add(this.source.subscribe(new B(this.getSubject(),this))),e.closed?(this._connection=null,e=u.EMPTY):this._connection=e),e}refCount(){return L()(this)}}.prototype,Z={operator:{value:null},_refCount:{value:0,writable:!0},_subject:{value:null,writable:!0},_connection:{value:null,writable:!0},_subscribe:{value:q._subscribe},_isComplete:{value:q._isComplete,writable:!0},getSubject:{value:q.getSubject},connect:{value:q.connect},refCount:{value:q.refCount}};class B extends C{constructor(e,t){super(e),this.connectable=t}_error(e){this._unsubscribe(),super._error(e)}_complete(){this.connectable._isComplete=!0,this._unsubscribe(),super._complete()}_unsubscribe(){const e=this.connectable;if(e){this.connectable=null;const t=e._connection;e._refCount=0,e._subject=null,e._connection=null,t&&t.unsubscribe()}}}function $(){return new E}function U(e,t,n){const o=function(e){return function(...t){if(e){const n=e(...t);for(const e in n)this[e]=n[e]}}}(t);function r(...e){if(this instanceof r)return o.apply(this,e),this;const t=new r(...e);return n.annotation=t,n;function n(e,n,o){const r=e.hasOwnProperty("__parameters__")?e.__parameters__:Object.defineProperty(e,"__parameters__",{value:[]}).__parameters__;for(;r.length<=o;)r.push(null);return(r[o]=r[o]||[]).push(t),e}}return n&&(r.prototype=Object.create(n.prototype)),r.prototype.ngMetadataName=e,r.annotationCls=r,r}const Q=U("Inject",e=>({token:e})),W=U("Optional"),G=U("Self"),Y=U("SkipSelf");var K=function(e){return e[e.Default=0]="Default",e[e.Host=1]="Host",e[e.Self=2]="Self",e[e.SkipSelf=4]="SkipSelf",e[e.Optional=8]="Optional",e}({});function X(e){for(let t in e)if(e[t]===X)return t;throw Error("Could not find renamed property on target object.")}function J(e){return{token:e.token,providedIn:e.providedIn||null,factory:e.factory,value:void 0}}function ee(e){const t=e[te];return t&&t.token===e?t:null}const te=X({ngInjectableDef:X});function ne(e){if("string"==typeof e)return e;if(e instanceof Array)return"["+e.map(ne).join(", ")+"]";if(null==e)return""+e;if(e.overriddenName)return`${e.overriddenName}`;if(e.name)return`${e.name}`;const t=e.toString();if(null==t)return""+t;const n=t.indexOf("\n");return-1===n?t:t.substring(0,n)}const oe=X({__forward_ref__:X});function re(e){return e.__forward_ref__=re,e.toString=function(){return ne(this())},e}function ae(e){const t=e;return"function"==typeof t&&t.hasOwnProperty(oe)&&t.__forward_ref__===re?t():e}const ie="undefined"!=typeof globalThis&&globalThis,le="undefined"!=typeof window&&window,se="undefined"!=typeof self&&"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope&&self,ce="undefined"!=typeof global&&global,fe=ie||ce||le||se;class de{constructor(e,t){this._desc=e,this.ngMetadataName="InjectionToken",this.ngInjectableDef=void 0,"number"==typeof t?this.__NG_ELEMENT_ID__=t:void 0!==t&&(this.ngInjectableDef=J({token:this,providedIn:t.providedIn||"root",factory:t.factory}))}toString(){return`InjectionToken ${this._desc}`}}const ue=new de("INJECTOR",-1),me=new Object,pe=/\n/gm,be=X({provide:String,useValue:X});let he;function ge(e){const t=he;return he=e,t}class xe{get(e,t=me){if(t===me){const t=new Error(`NullInjectorError: No provider for ${ne(e)}!`);throw t.name="NullInjectorError",t}return t}}function we(e,t,n,o=null){e=e&&"\n"===e.charAt(0)&&"ɵ"==e.charAt(1)?e.substr(2):e;let r=ne(t);if(t instanceof Array)r=t.map(ne).join(" -> ");else if("object"==typeof t){let e=[];for(let n in t)if(t.hasOwnProperty(n)){let o=t[n];e.push(n+":"+("string"==typeof o?JSON.stringify(o):ne(o)))}r=`{${e.join(", ")}}`}return`${n}${o?"("+o+")":""}[${r}]: ${e.replace(pe,"\n  ")}`}class ye{}function ve(e,t,n){t>=e.length?e.push(n):e.splice(t,0,n)}function ke(e,t){return t>=e.length-1?e.pop():e.splice(t,1)[0]}const _e=function(){var e={Emulated:0,Native:1,None:2,ShadowDom:3};return e[e.Emulated]="Emulated",e[e.Native]="Native",e[e.None]="None",e[e.ShadowDom]="ShadowDom",e}(),Ce=("undefined"!=typeof requestAnimationFrame&&requestAnimationFrame||setTimeout).bind(fe);function Ee(e){return e.ngDebugContext}function Te(e){return e.ngOriginalError}function Se(e,...t){e.error(...t)}class Ne{constructor(){this._console=console}handleError(e){const t=this._findOriginalError(e),n=this._findContext(e),o=function(e){return e.ngErrorLogger||Se}(e);o(this._console,"ERROR",e),t&&o(this._console,"ORIGINAL ERROR",t),n&&o(this._console,"ERROR CONTEXT",n)}_findContext(e){return e?Ee(e)?Ee(e):this._findContext(Te(e)):null}_findOriginalError(e){let t=Te(e);for(;t&&Te(t);)t=Te(t);return t}}let je=!0,Ie=!1;function De(){return Ie=!0,je}class Me{constructor(e){if(this.defaultDoc=e,this.inertDocument=this.defaultDoc.implementation.createHTMLDocument("sanitization-inert"),this.inertBodyElement=this.inertDocument.body,null==this.inertBodyElement){const e=this.inertDocument.createElement("html");this.inertDocument.appendChild(e),this.inertBodyElement=this.inertDocument.createElement("body"),e.appendChild(this.inertBodyElement)}this.inertBodyElement.innerHTML='<svg><g onload="this.parentNode.remove()"></g></svg>',!this.inertBodyElement.querySelector||this.inertBodyElement.querySelector("svg")?(this.inertBodyElement.innerHTML='<svg><p><style><img src="</style><img src=x onerror=alert(1)//">',this.getInertBodyElement=this.inertBodyElement.querySelector&&this.inertBodyElement.querySelector("svg img")&&function(){try{return!!window.DOMParser}catch(e){return!1}}()?this.getInertBodyElement_DOMParser:this.getInertBodyElement_InertDocument):this.getInertBodyElement=this.getInertBodyElement_XHR}getInertBodyElement_XHR(e){e="<body><remove></remove>"+e+"</body>";try{e=encodeURI(e)}catch(e){return null}const t=new XMLHttpRequest;t.responseType="document",t.open("GET","data:text/html;charset=utf-8,"+e,!1),t.send(void 0);const n=t.response.body;return n.removeChild(n.firstChild),n}getInertBodyElement_DOMParser(e){e="<body><remove></remove>"+e+"</body>";try{const t=(new window.DOMParser).parseFromString(e,"text/html").body;return t.removeChild(t.firstChild),t}catch(e){return null}}getInertBodyElement_InertDocument(e){const t=this.inertDocument.createElement("template");return"content"in t?(t.innerHTML=e,t):(this.inertBodyElement.innerHTML=e,this.defaultDoc.documentMode&&this.stripCustomNsAttrs(this.inertBodyElement),this.inertBodyElement)}stripCustomNsAttrs(e){const t=e.attributes;for(let n=t.length-1;0<n;n--){const o=t.item(n).name;"xmlns:ns1"!==o&&0!==o.indexOf("ns1:")||e.removeAttribute(o)}let n=e.firstChild;for(;n;)n.nodeType===Node.ELEMENT_NODE&&this.stripCustomNsAttrs(n),n=n.nextSibling}}const Fe=/^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,ze=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;function Ae(e){return(e=String(e)).match(Fe)||e.match(ze)?e:(De()&&console.warn(`WARNING: sanitizing unsafe URL value ${e} (see http://g.co/ng/security#xss)`),"unsafe:"+e)}function Oe(e){const t={};for(const n of e.split(","))t[n]=!0;return t}function Re(...e){const t={};for(const n of e)for(const e in n)n.hasOwnProperty(e)&&(t[e]=!0);return t}const Pe=Oe("area,br,col,hr,img,wbr"),Le=Oe("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),He=Oe("rp,rt"),Ve=Re(He,Le),qe=Re(Pe,Re(Le,Oe("address,article,aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul")),Re(He,Oe("a,abbr,acronym,audio,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video")),Ve),Ze=Oe("background,cite,href,itemtype,longdesc,poster,src,xlink:href"),Be=Oe("srcset"),$e=Re(Ze,Be,Oe("abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,valign,value,vspace,width"),Oe("aria-activedescendant,aria-atomic,aria-autocomplete,aria-busy,aria-checked,aria-colcount,aria-colindex,aria-colspan,aria-controls,aria-current,aria-describedby,aria-details,aria-disabled,aria-dropeffect,aria-errormessage,aria-expanded,aria-flowto,aria-grabbed,aria-haspopup,aria-hidden,aria-invalid,aria-keyshortcuts,aria-label,aria-labelledby,aria-level,aria-live,aria-modal,aria-multiline,aria-multiselectable,aria-orientation,aria-owns,aria-placeholder,aria-posinset,aria-pressed,aria-readonly,aria-relevant,aria-required,aria-roledescription,aria-rowcount,aria-rowindex,aria-rowspan,aria-selected,aria-setsize,aria-sort,aria-valuemax,aria-valuemin,aria-valuenow,aria-valuetext")),Ue=Oe("script,style,template");class Qe{constructor(){this.sanitizedSomething=!1,this.buf=[]}sanitizeChildren(e){let t=e.firstChild,n=!0;for(;t;)if(t.nodeType===Node.ELEMENT_NODE?n=this.startElement(t):t.nodeType===Node.TEXT_NODE?this.chars(t.nodeValue):this.sanitizedSomething=!0,n&&t.firstChild)t=t.firstChild;else for(;t;){t.nodeType===Node.ELEMENT_NODE&&this.endElement(t);let e=this.checkClobberedElement(t,t.nextSibling);if(e){t=e;break}t=this.checkClobberedElement(t,t.parentNode)}return this.buf.join("")}startElement(e){const t=e.nodeName.toLowerCase();if(!qe.hasOwnProperty(t))return this.sanitizedSomething=!0,!Ue.hasOwnProperty(t);this.buf.push("<"),this.buf.push(t);const n=e.attributes;for(let e=0;e<n.length;e++){const t=n.item(e),r=t.name,a=r.toLowerCase();if(!$e.hasOwnProperty(a)){this.sanitizedSomething=!0;continue}let i=t.value;Ze[a]&&(i=Ae(i)),Be[a]&&(o=i,i=(o=String(o)).split(",").map(e=>Ae(e.trim())).join(", ")),this.buf.push(" ",r,'="',Ye(i),'"')}var o;return this.buf.push(">"),!0}endElement(e){const t=e.nodeName.toLowerCase();qe.hasOwnProperty(t)&&!Pe.hasOwnProperty(t)&&(this.buf.push("</"),this.buf.push(t),this.buf.push(">"))}chars(e){this.buf.push(Ye(e))}checkClobberedElement(e,t){if(t&&(e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)===Node.DOCUMENT_POSITION_CONTAINED_BY)throw new Error(`Failed to sanitize html because the element is clobbered: ${e.outerHTML}`);return t}}const We=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,Ge=/([^\#-~ |!])/g;function Ye(e){return e.replace(/&/g,"&amp;").replace(We,function(e){return"&#"+(1024*(e.charCodeAt(0)-55296)+(e.charCodeAt(1)-56320)+65536)+";"}).replace(Ge,function(e){return"&#"+e.charCodeAt(0)+";"}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}let Ke;function Xe(e){return"content"in e&&function(e){return e.nodeType===Node.ELEMENT_NODE&&"TEMPLATE"===e.nodeName}(e)?e.content:null}const Je=function(){var e={NONE:0,HTML:1,STYLE:2,SCRIPT:3,URL:4,RESOURCE_URL:5};return e[e.NONE]="NONE",e[e.HTML]="HTML",e[e.STYLE]="STYLE",e[e.SCRIPT]="SCRIPT",e[e.URL]="URL",e[e.RESOURCE_URL]="RESOURCE_URL",e}();class et{}const tt=new RegExp("^([-,.\"'%_!# a-zA-Z0-9]+|(?:(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|Z|3d)?|(?:rgb|hsl)a?|(?:repeating-)?(?:linear|radial)-gradient|(?:calc|attr))\\([-0-9.%, #a-zA-Z]+\\))$","g"),nt=/^url\(([^)]+)\)$/,ot=/([A-Z])/g;function rt(e){try{return null!=e?e.toString().slice(0,30):e}catch(e){return"[ERROR] Exception while trying to serialize the value"}}let at=(()=>{class e{}return e.__NG_ELEMENT_ID__=()=>it(),e})();const it=(...e)=>{},lt=new de("The presence of this token marks an injector as being the root injector."),st=function(e,t,n){return new pt(e,t,n)};let ct=(()=>{class e{static create(e,t){return Array.isArray(e)?st(e,t,""):st(e.providers,e.parent,e.name||"")}}return e.THROW_IF_NOT_FOUND=me,e.NULL=new xe,e.ngInjectableDef=J({token:e,providedIn:"any",factory:()=>function(e,t=K.Default){return function(e,t=K.Default){if(void 0===he)throw new Error("inject() must be called from an injection context");return null===he?function(e,t,n){const o=ee(e);if(o&&"root"==o.providedIn)return void 0===o.value?o.value=o.factory():o.value;if(n&K.Optional)return null;throw new Error(`Injector: NOT_FOUND [${ne(e)}]`)}(e,0,t):he.get(e,t&K.Optional?null:void 0,t)}(e,t)}(ue)}),e.__NG_ELEMENT_ID__=-1,e})();const ft=function(e){return e},dt=[],ut=ft,mt=function(){return Array.prototype.slice.call(arguments)};class pt{constructor(e,t=ct.NULL,n=null){this.parent=t,this.source=n;const o=this._records=new Map;o.set(ct,{token:ct,fn:ft,deps:dt,value:this,useNew:!1}),o.set(ue,{token:ue,fn:ft,deps:dt,value:this,useNew:!1}),function e(t,n){if(n)if((n=ae(n))instanceof Array)for(let o=0;o<n.length;o++)e(t,n[o]);else{if("function"==typeof n)throw ht("Function/Class not supported",n);if(!n||"object"!=typeof n||!n.provide)throw ht("Unexpected provider",n);{let e=ae(n.provide);const o=function(e){const t=function(e){let t=dt;const n=e.deps;if(n&&n.length){t=[];for(let e=0;e<n.length;e++){let o=6,r=ae(n[e]);if(r instanceof Array)for(let e=0,t=r;e<t.length;e++){const n=t[e];n instanceof W||n==W?o|=1:n instanceof Y||n==Y?o&=-3:n instanceof G||n==G?o&=-5:r=n instanceof Q?n.token:ae(n)}t.push({token:r,options:o})}}else if(e.useExisting)t=[{token:ae(e.useExisting),options:6}];else if(!n&&!(be in e))throw ht("'deps' required",e);return t}(e);let n=ft,o=dt,r=!1,a=ae(e.provide);if(be in e)o=e.useValue;else if(e.useFactory)n=e.useFactory;else if(e.useExisting);else if(e.useClass)r=!0,n=ae(e.useClass);else{if("function"!=typeof a)throw ht("StaticProvider does not have [useValue|useFactory|useExisting|useClass] or [provide] is not newable",e);r=!0,n=a}return{deps:t,fn:n,useNew:r,value:o}}(n);if(!0===n.multi){let o=t.get(e);if(o){if(o.fn!==mt)throw bt(e)}else t.set(e,o={token:n.provide,deps:[],useNew:!1,fn:mt,value:dt});e=n,o.deps.push({token:e,options:6})}const r=t.get(e);if(r&&r.fn==mt)throw bt(e);t.set(e,o)}}}(o,e)}get(e,t,n=K.Default){const o=this._records.get(e);try{return function e(t,n,o,r,a,i){try{return function(t,n,o,r,a,i){let l;if(!n||i&K.SkipSelf)i&K.Self||(l=r.get(t,a,K.Default));else{if(l=n.value,l==ut)throw Error("ɵCircular dependency");if(l===dt){n.value=ut;let t,a=n.useNew,i=n.fn,s=n.deps,c=dt;if(s.length){c=[];for(let t=0;t<s.length;t++){const n=s[t],a=n.options,i=2&a?o.get(n.token):void 0;c.push(e(n.token,i,o,i||4&a?r:ct.NULL,1&a?null:ct.THROW_IF_NOT_FOUND,K.Default))}}n.value=l=a?new i(...c):i.apply(t,c)}}return l}(t,n,o,r,a,i)}catch(e){throw e instanceof Error||(e=new Error(e)),(e.ngTempTokenPath=e.ngTempTokenPath||[]).unshift(t),n&&n.value==ut&&(n.value=dt),e}}(e,o,this._records,this.parent,t,n)}catch(t){return function(e,t,n,o){const r=e.ngTempTokenPath;throw t.__source&&r.unshift(t.__source),e.message=we("\n"+e.message,r,"StaticInjectorError",o),e.ngTokenPath=r,e.ngTempTokenPath=null,e}(t,e,0,this.source)}}toString(){const e=[];return this._records.forEach((t,n)=>e.push(ne(n))),`StaticInjector[${e.join(", ")}]`}}function bt(e){return ht("Cannot mix multi providers and regular providers",e)}function ht(e,t){return new Error(we(e,t,"StaticInjectorError"))}let gt=null;function xt(){if(!gt){const e=fe.Symbol;if(e&&e.iterator)gt=e.iterator;else{const e=Object.getOwnPropertyNames(Map.prototype);for(let t=0;t<e.length;++t){const n=e[t];"entries"!==n&&"size"!==n&&Map.prototype[n]===Map.prototype.entries&&(gt=n)}}}return gt}function wt(e,t){return e===t||"number"==typeof e&&"number"==typeof t&&isNaN(e)&&isNaN(t)}function yt(e,t){const n=kt(e),o=kt(t);return n&&o?function(e,t,n){const o=e[xt()](),r=t[xt()]();for(;;){const e=o.next(),t=r.next();if(e.done&&t.done)return!0;if(e.done||t.done)return!1;if(!n(e.value,t.value))return!1}}(e,t,yt):!(n||!e||"object"!=typeof e&&"function"!=typeof e||o||!t||"object"!=typeof t&&"function"!=typeof t)||wt(e,t)}class vt{constructor(e){this.wrapped=e}static wrap(e){return new vt(e)}static unwrap(e){return vt.isWrapped(e)?e.wrapped:e}static isWrapped(e){return e instanceof vt}}function kt(e){return!!_t(e)&&(Array.isArray(e)||!(e instanceof Map)&&xt()in e)}function _t(e){return null!==e&&("function"==typeof e||"object"==typeof e)}function Ct(e){return!!e&&"function"==typeof e.then}class Et{constructor(e,t,n){this.previousValue=e,this.currentValue=t,this.firstChange=n}isFirstChange(){return this.firstChange}}class Tt{}function St(e){const t=Error(`No component factory found for ${ne(e)}. Did you add it to @NgModule.entryComponents?`);return t[Nt]=e,t}const Nt="ngComponent";class jt{resolveComponentFactory(e){throw St(e)}}let It=(()=>{class e{}return e.NULL=new jt,e})();class Dt{constructor(e,t,n){this._parent=t,this._ngModule=n,this._factories=new Map;for(let t=0;t<e.length;t++){const n=e[t];this._factories.set(n.componentType,n)}}resolveComponentFactory(e){let t=this._factories.get(e);if(!t&&this._parent&&(t=this._parent.resolveComponentFactory(e)),!t)throw St(e);return new Mt(t,this._ngModule)}}class Mt extends Tt{constructor(e,t){super(),this.factory=e,this.ngModule=t,this.selector=e.selector,this.componentType=e.componentType,this.ngContentSelectors=e.ngContentSelectors,this.inputs=e.inputs,this.outputs=e.outputs}create(e,t,n,o){return this.factory.create(e,t,n,o||this.ngModule)}}function Ft(...e){}let zt=(()=>{class e{constructor(e){this.nativeElement=e}}return e.__NG_ELEMENT_ID__=()=>At(e),e})();const At=Ft;class Ot{}const Rt=function(){var e={Important:1,DashCase:2};return e[e.Important]="Important",e[e.DashCase]="DashCase",e}();let Pt=(()=>{class e{}return e.__NG_ELEMENT_ID__=()=>Lt(),e})();const Lt=Ft,Ht=new class{constructor(e){this.full=e,this.major=e.split(".")[0],this.minor=e.split(".")[1],this.patch=e.split(".").slice(2).join(".")}}("8.2.14");class Vt{constructor(){}supports(e){return kt(e)}create(e){return new Zt(e)}}const qt=(e,t)=>t;class Zt{constructor(e){this.length=0,this._linkedRecords=null,this._unlinkedRecords=null,this._previousItHead=null,this._itHead=null,this._itTail=null,this._additionsHead=null,this._additionsTail=null,this._movesHead=null,this._movesTail=null,this._removalsHead=null,this._removalsTail=null,this._identityChangesHead=null,this._identityChangesTail=null,this._trackByFn=e||qt}forEachItem(e){let t;for(t=this._itHead;null!==t;t=t._next)e(t)}forEachOperation(e){let t=this._itHead,n=this._removalsHead,o=0,r=null;for(;t||n;){const a=!n||t&&t.currentIndex<Qt(n,o,r)?t:n,i=Qt(a,o,r),l=a.currentIndex;if(a===n)o--,n=n._nextRemoved;else if(t=t._next,null==a.previousIndex)o++;else{r||(r=[]);const e=i-o,t=l-o;if(e!=t){for(let n=0;n<e;n++){const o=n<r.length?r[n]:r[n]=0,a=o+n;t<=a&&a<e&&(r[n]=o+1)}r[a.previousIndex]=t-e}}i!==l&&e(a,i,l)}}forEachPreviousItem(e){let t;for(t=this._previousItHead;null!==t;t=t._nextPrevious)e(t)}forEachAddedItem(e){let t;for(t=this._additionsHead;null!==t;t=t._nextAdded)e(t)}forEachMovedItem(e){let t;for(t=this._movesHead;null!==t;t=t._nextMoved)e(t)}forEachRemovedItem(e){let t;for(t=this._removalsHead;null!==t;t=t._nextRemoved)e(t)}forEachIdentityChange(e){let t;for(t=this._identityChangesHead;null!==t;t=t._nextIdentityChange)e(t)}diff(e){if(null==e&&(e=[]),!kt(e))throw new Error(`Error trying to diff '${ne(e)}'. Only arrays and iterables are allowed`);return this.check(e)?this:null}onDestroy(){}check(e){this._reset();let t,n,o,r=this._itHead,a=!1;if(Array.isArray(e)){this.length=e.length;for(let t=0;t<this.length;t++)n=e[t],o=this._trackByFn(t,n),null!==r&&wt(r.trackById,o)?(a&&(r=this._verifyReinsertion(r,n,o,t)),wt(r.item,n)||this._addIdentityChange(r,n)):(r=this._mismatch(r,n,o,t),a=!0),r=r._next}else t=0,function(e,t){if(Array.isArray(e))for(let n=0;n<e.length;n++)t(e[n]);else{const n=e[xt()]();let o;for(;!(o=n.next()).done;)t(o.value)}}(e,e=>{o=this._trackByFn(t,e),null!==r&&wt(r.trackById,o)?(a&&(r=this._verifyReinsertion(r,e,o,t)),wt(r.item,e)||this._addIdentityChange(r,e)):(r=this._mismatch(r,e,o,t),a=!0),r=r._next,t++}),this.length=t;return this._truncate(r),this.collection=e,this.isDirty}get isDirty(){return null!==this._additionsHead||null!==this._movesHead||null!==this._removalsHead||null!==this._identityChangesHead}_reset(){if(this.isDirty){let e,t;for(e=this._previousItHead=this._itHead;null!==e;e=e._next)e._nextPrevious=e._next;for(e=this._additionsHead;null!==e;e=e._nextAdded)e.previousIndex=e.currentIndex;for(this._additionsHead=this._additionsTail=null,e=this._movesHead;null!==e;e=t)e.previousIndex=e.currentIndex,t=e._nextMoved;this._movesHead=this._movesTail=null,this._removalsHead=this._removalsTail=null,this._identityChangesHead=this._identityChangesTail=null}}_mismatch(e,t,n,o){let r;return null===e?r=this._itTail:(r=e._prev,this._remove(e)),null!==(e=null===this._linkedRecords?null:this._linkedRecords.get(n,o))?(wt(e.item,t)||this._addIdentityChange(e,t),this._moveAfter(e,r,o)):null!==(e=null===this._unlinkedRecords?null:this._unlinkedRecords.get(n,null))?(wt(e.item,t)||this._addIdentityChange(e,t),this._reinsertAfter(e,r,o)):e=this._addAfter(new Bt(t,n),r,o),e}_verifyReinsertion(e,t,n,o){let r=null===this._unlinkedRecords?null:this._unlinkedRecords.get(n,null);return null!==r?e=this._reinsertAfter(r,e._prev,o):e.currentIndex!=o&&(e.currentIndex=o,this._addToMoves(e,o)),e}_truncate(e){for(;null!==e;){const t=e._next;this._addToRemovals(this._unlink(e)),e=t}null!==this._unlinkedRecords&&this._unlinkedRecords.clear(),null!==this._additionsTail&&(this._additionsTail._nextAdded=null),null!==this._movesTail&&(this._movesTail._nextMoved=null),null!==this._itTail&&(this._itTail._next=null),null!==this._removalsTail&&(this._removalsTail._nextRemoved=null),null!==this._identityChangesTail&&(this._identityChangesTail._nextIdentityChange=null)}_reinsertAfter(e,t,n){null!==this._unlinkedRecords&&this._unlinkedRecords.remove(e);const o=e._prevRemoved,r=e._nextRemoved;return null===o?this._removalsHead=r:o._nextRemoved=r,null===r?this._removalsTail=o:r._prevRemoved=o,this._insertAfter(e,t,n),this._addToMoves(e,n),e}_moveAfter(e,t,n){return this._unlink(e),this._insertAfter(e,t,n),this._addToMoves(e,n),e}_addAfter(e,t,n){return this._insertAfter(e,t,n),this._additionsTail=null===this._additionsTail?this._additionsHead=e:this._additionsTail._nextAdded=e,e}_insertAfter(e,t,n){const o=null===t?this._itHead:t._next;return e._next=o,e._prev=t,null===o?this._itTail=e:o._prev=e,null===t?this._itHead=e:t._next=e,null===this._linkedRecords&&(this._linkedRecords=new Ut),this._linkedRecords.put(e),e.currentIndex=n,e}_remove(e){return this._addToRemovals(this._unlink(e))}_unlink(e){null!==this._linkedRecords&&this._linkedRecords.remove(e);const t=e._prev,n=e._next;return null===t?this._itHead=n:t._next=n,null===n?this._itTail=t:n._prev=t,e}_addToMoves(e,t){return e.previousIndex===t||(this._movesTail=null===this._movesTail?this._movesHead=e:this._movesTail._nextMoved=e),e}_addToRemovals(e){return null===this._unlinkedRecords&&(this._unlinkedRecords=new Ut),this._unlinkedRecords.put(e),e.currentIndex=null,e._nextRemoved=null,null===this._removalsTail?(this._removalsTail=this._removalsHead=e,e._prevRemoved=null):(e._prevRemoved=this._removalsTail,this._removalsTail=this._removalsTail._nextRemoved=e),e}_addIdentityChange(e,t){return e.item=t,this._identityChangesTail=null===this._identityChangesTail?this._identityChangesHead=e:this._identityChangesTail._nextIdentityChange=e,e}}class Bt{constructor(e,t){this.item=e,this.trackById=t,this.currentIndex=null,this.previousIndex=null,this._nextPrevious=null,this._prev=null,this._next=null,this._prevDup=null,this._nextDup=null,this._prevRemoved=null,this._nextRemoved=null,this._nextAdded=null,this._nextMoved=null,this._nextIdentityChange=null}}class $t{constructor(){this._head=null,this._tail=null}add(e){null===this._head?(this._head=this._tail=e,e._nextDup=null,e._prevDup=null):(this._tail._nextDup=e,e._prevDup=this._tail,e._nextDup=null,this._tail=e)}get(e,t){let n;for(n=this._head;null!==n;n=n._nextDup)if((null===t||t<=n.currentIndex)&&wt(n.trackById,e))return n;return null}remove(e){const t=e._prevDup,n=e._nextDup;return null===t?this._head=n:t._nextDup=n,null===n?this._tail=t:n._prevDup=t,null===this._head}}class Ut{constructor(){this.map=new Map}put(e){const t=e.trackById;let n=this.map.get(t);n||(n=new $t,this.map.set(t,n)),n.add(e)}get(e,t){const n=this.map.get(e);return n?n.get(e,t):null}remove(e){const t=e.trackById;return this.map.get(t).remove(e)&&this.map.delete(t),e}get isEmpty(){return 0===this.map.size}clear(){this.map.clear()}}function Qt(e,t,n){const o=e.previousIndex;if(null===o)return o;let r=0;return n&&o<n.length&&(r=n[o]),o+t+r}class Wt{constructor(){}supports(e){return e instanceof Map||_t(e)}create(){return new Gt}}class Gt{constructor(){this._records=new Map,this._mapHead=null,this._appendAfter=null,this._previousMapHead=null,this._changesHead=null,this._changesTail=null,this._additionsHead=null,this._additionsTail=null,this._removalsHead=null,this._removalsTail=null}get isDirty(){return null!==this._additionsHead||null!==this._changesHead||null!==this._removalsHead}forEachItem(e){let t;for(t=this._mapHead;null!==t;t=t._next)e(t)}forEachPreviousItem(e){let t;for(t=this._previousMapHead;null!==t;t=t._nextPrevious)e(t)}forEachChangedItem(e){let t;for(t=this._changesHead;null!==t;t=t._nextChanged)e(t)}forEachAddedItem(e){let t;for(t=this._additionsHead;null!==t;t=t._nextAdded)e(t)}forEachRemovedItem(e){let t;for(t=this._removalsHead;null!==t;t=t._nextRemoved)e(t)}diff(e){if(e){if(!(e instanceof Map||_t(e)))throw new Error(`Error trying to diff '${ne(e)}'. Only maps and objects are allowed`)}else e=new Map;return this.check(e)?this:null}onDestroy(){}check(e){this._reset();let t=this._mapHead;if(this._appendAfter=null,this._forEach(e,(e,n)=>{if(t&&t.key===n)this._maybeAddToChanges(t,e),this._appendAfter=t,t=t._next;else{const o=this._getOrCreateRecordForKey(n,e);t=this._insertBeforeOrAppend(t,o)}}),t){t._prev&&(t._prev._next=null),this._removalsHead=t;for(let e=t;null!==e;e=e._nextRemoved)e===this._mapHead&&(this._mapHead=null),this._records.delete(e.key),e._nextRemoved=e._next,e.previousValue=e.currentValue,e.currentValue=null,e._prev=null,e._next=null}return this._changesTail&&(this._changesTail._nextChanged=null),this._additionsTail&&(this._additionsTail._nextAdded=null),this.isDirty}_insertBeforeOrAppend(e,t){if(e){const n=e._prev;return t._next=e,t._prev=n,e._prev=t,n&&(n._next=t),e===this._mapHead&&(this._mapHead=t),this._appendAfter=e,e}return this._appendAfter?(this._appendAfter._next=t,t._prev=this._appendAfter):this._mapHead=t,this._appendAfter=t,null}_getOrCreateRecordForKey(e,t){if(this._records.has(e)){const n=this._records.get(e);this._maybeAddToChanges(n,t);const o=n._prev,r=n._next;return o&&(o._next=r),r&&(r._prev=o),n._next=null,n._prev=null,n}const n=new Yt(e);return this._records.set(e,n),n.currentValue=t,this._addToAdditions(n),n}_reset(){if(this.isDirty){let e;for(this._previousMapHead=this._mapHead,e=this._previousMapHead;null!==e;e=e._next)e._nextPrevious=e._next;for(e=this._changesHead;null!==e;e=e._nextChanged)e.previousValue=e.currentValue;for(e=this._additionsHead;null!=e;e=e._nextAdded)e.previousValue=e.currentValue;this._changesHead=this._changesTail=null,this._additionsHead=this._additionsTail=null,this._removalsHead=null}}_maybeAddToChanges(e,t){wt(t,e.currentValue)||(e.previousValue=e.currentValue,e.currentValue=t,this._addToChanges(e))}_addToAdditions(e){null===this._additionsHead?this._additionsHead=this._additionsTail=e:(this._additionsTail._nextAdded=e,this._additionsTail=e)}_addToChanges(e){null===this._changesHead?this._changesHead=this._changesTail=e:(this._changesTail._nextChanged=e,this._changesTail=e)}_forEach(e,t){e instanceof Map?e.forEach(t):Object.keys(e).forEach(n=>t(e[n],n))}}class Yt{constructor(e){this.key=e,this.previousValue=null,this.currentValue=null,this._nextPrevious=null,this._next=null,this._prev=null,this._nextAdded=null,this._nextRemoved=null,this._nextChanged=null}}let Kt=(()=>{class e{constructor(e){this.factories=e}static create(t,n){if(null!=n){const e=n.factories.slice();t=t.concat(e)}return new e(t)}static extend(t){return{provide:e,useFactory:n=>{if(!n)throw new Error("Cannot extend IterableDiffers without a parent injector");return e.create(t,n)},deps:[[e,new Y,new W]]}}find(e){const t=this.factories.find(t=>t.supports(e));if(null!=t)return t;throw new Error(`Cannot find a differ supporting object '${e}' of type '${n=e,n.name||typeof n}'`);var n}}return e.ngInjectableDef=J({token:e,providedIn:"root",factory:()=>new e([new Vt])}),e})(),Xt=(()=>{class e{constructor(e){this.factories=e}static create(t,n){if(n){const e=n.factories.slice();t=t.concat(e)}return new e(t)}static extend(t){return{provide:e,useFactory:n=>{if(!n)throw new Error("Cannot extend KeyValueDiffers without a parent injector");return e.create(t,n)},deps:[[e,new Y,new W]]}}find(e){const t=this.factories.find(t=>t.supports(e));if(t)return t;throw new Error(`Cannot find a differ supporting object '${e}'`)}}return e.ngInjectableDef=J({token:e,providedIn:"root",factory:()=>new e([new Wt])}),e})();const Jt=[new Wt],en=new Kt([new Vt]),tn=new Xt(Jt);let nn=(()=>{class e{}return e.__NG_ELEMENT_ID__=()=>on(e,zt),e})();const on=Ft;let rn=(()=>{class e{}return e.__NG_ELEMENT_ID__=()=>an(e,zt),e})();const an=Ft;function ln(e,t,n,o){let r=`ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '${t}'. Current value: '${n}'.`;return o&&(r+=" It seems like the view has been created after its parent and its children have been dirty checked. Has it been created in a change detection hook ?"),function(e,t){const n=new Error(e);return sn(n,t),n}(r,e)}function sn(e,t){e.ngDebugContext=t,e.ngErrorLogger=t.logError.bind(t)}function cn(e){return new Error(`ViewDestroyedError: Attempt to use a destroyed view: ${e}`)}function fn(e,t,n){const o=e.state,r=1792&o;return r===t?(e.state=-1793&o|n,e.initIndex=-1,!0):r===n}function dn(e,t,n){return(1792&e.state)===t&&e.initIndex<=n&&(e.initIndex=n+1,!0)}function un(e,t){return e.nodes[t]}function mn(e,t){return e.nodes[t]}function pn(e,t){return e.nodes[t]}function bn(e,t){return e.nodes[t]}function hn(e,t){return e.nodes[t]}const gn={setCurrentNode:void 0,createRootView:void 0,createEmbeddedView:void 0,createComponentView:void 0,createNgModuleRef:void 0,overrideProvider:void 0,overrideComponentView:void 0,clearOverrides:void 0,checkAndUpdateView:void 0,checkNoChangesView:void 0,destroyView:void 0,resolveDep:void 0,createDebugContext:void 0,handleEvent:void 0,updateDirectives:void 0,updateRenderer:void 0,dirtyParentQueries:void 0},xn=()=>{},wn=new Map;function yn(e){let t=wn.get(e);return t||(t=ne(e)+"_"+wn.size,wn.set(e,t)),t}let vn=0;function kn(e,t,n,o){return!(!(2&e.state)&&wt(e.oldValues[t.bindingIndex+n],o))}function _n(e,t,n,o){return!!kn(e,t,n,o)&&(e.oldValues[t.bindingIndex+n]=o,!0)}function Cn(e,t,n,o){const r=e.oldValues[t.bindingIndex+n];if(1&e.state||!yt(r,o)){const a=t.bindings[n].name;throw ln(gn.createDebugContext(e,t.nodeIndex),`${a}: ${r}`,`${a}: ${o}`,!!(1&e.state))}}function En(e){let t=e;for(;t;)2&t.def.flags&&(t.state|=8),t=t.viewContainerParent||t.parent}function Tn(e,t){let n=e;for(;n&&n!==t;)n.state|=64,n=n.viewContainerParent||n.parent}function Sn(e,t,n,o){try{return En(33554432&e.def.nodes[t].flags?mn(e,t).componentView:e),gn.handleEvent(e,t,n,o)}catch(t){e.root.errorHandler.handleError(t)}}function Nn(e){return e.parent?mn(e.parent,e.parentNodeDef.nodeIndex):null}function jn(e){return e.parent?e.parentNodeDef.parent:null}function In(e,t){switch(201347067&t.flags){case 1:return mn(e,t.nodeIndex).renderElement;case 2:return un(e,t.nodeIndex).renderText}}function Dn(e){return!!e.parent&&!!(32768&e.parentNodeDef.flags)}function Mn(e){return!(!e.parent||32768&e.parentNodeDef.flags)}function Fn(e){return 1<<e%32}function zn(e){const t={};let n=0;const o={};return e&&e.forEach(([e,r])=>{"number"==typeof e?(t[e]=r,n|=Fn(e)):o[e]=r}),{matchedQueries:t,references:o,matchedQueryIds:n}}function An(e,t){return e.map(e=>{let n,o;return Array.isArray(e)?[o,n]=e:(o=0,n=e),n&&("function"==typeof n||"object"==typeof n)&&t&&Object.defineProperty(n,"__source",{value:t,configurable:!0}),{flags:o,token:n,tokenKey:yn(n)}})}function On(e,t,n){let o=n.renderParent;return o?1&o.flags&&33554432&o.flags&&(!o.element.componentRendererType||o.element.componentRendererType.encapsulation!==_e.Native)?void 0:mn(e,n.renderParent.nodeIndex).renderElement:t}const Rn=new WeakMap;function Pn(e){let t=Rn.get(e);return t||(t=e(()=>xn),t.factory=e,Rn.set(e,t)),t}function Ln(e,t,n,o,r){3===t&&(n=e.renderer.parentNode(In(e,e.def.lastRenderRootNode))),Hn(e,t,0,e.def.nodes.length-1,n,o,r)}function Hn(e,t,n,o,r,a,i){for(let l=n;l<=o;l++){const n=e.def.nodes[l];11&n.flags&&qn(e,n,t,r,a,i),l+=n.childCount}}function Vn(e,t,n,o,r,a){let i=e;for(;i&&!Dn(i);)i=i.parent;const l=i.parent,s=jn(i),c=s.nodeIndex+s.childCount;for(let e=s.nodeIndex+1;e<=c;e++){const i=l.def.nodes[e];i.ngContentIndex===t&&qn(l,i,n,o,r,a),e+=i.childCount}if(!l.parent){const i=e.root.projectableNodes[t];if(i)for(let t=0;t<i.length;t++)Zn(e,i[t],n,o,r,a)}}function qn(e,t,n,o,r,a){if(8&t.flags)Vn(e,t.ngContent.index,n,o,r,a);else{const i=In(e,t);if(3===n&&33554432&t.flags&&48&t.bindingFlags?(16&t.bindingFlags&&Zn(e,i,n,o,r,a),32&t.bindingFlags&&Zn(mn(e,t.nodeIndex).componentView,i,n,o,r,a)):Zn(e,i,n,o,r,a),16777216&t.flags){const i=mn(e,t.nodeIndex).viewContainer._embeddedViews;for(let e=0;e<i.length;e++)Ln(i[e],n,o,r,a)}1&t.flags&&!t.element.name&&Hn(e,n,t.nodeIndex+1,t.nodeIndex+t.childCount,o,r,a)}}function Zn(e,t,n,o,r,a){const i=e.renderer;switch(n){case 1:i.appendChild(o,t);break;case 2:i.insertBefore(o,t,r);break;case 3:i.removeChild(o,t);break;case 0:a.push(t)}}const Bn=/^:([^:]+):(.+)$/;function $n(e){if(":"===e[0]){const t=e.match(Bn);return[t[1],t[2]]}return["",e]}function Un(e){let t=0;for(let n=0;n<e.length;n++)t|=e[n].flags;return t}function Qn(e,t,n,o,r,a,i,l,s,c,f,d,u,m,p,b,h,g,x,w){switch(e){case 1:return t+Wn(n)+o;case 2:return t+Wn(n)+o+Wn(r)+a;case 3:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l;case 4:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c;case 5:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c+Wn(f)+d;case 6:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c+Wn(f)+d+Wn(u)+m;case 7:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c+Wn(f)+d+Wn(u)+m+Wn(p)+b;case 8:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c+Wn(f)+d+Wn(u)+m+Wn(p)+b+Wn(h)+g;case 9:return t+Wn(n)+o+Wn(r)+a+Wn(i)+l+Wn(s)+c+Wn(f)+d+Wn(u)+m+Wn(p)+b+Wn(h)+g+Wn(x)+w;default:throw new Error("Does not support more than 9 expressions")}}function Wn(e){return null!=e?e.toString():""}const Gn=new Object,Yn=yn(ct),Kn=yn(ue),Xn=yn(ye);function Jn(e,t,n,o){return n=ae(n),{index:-1,deps:An(o,ne(t)),flags:e,token:t,value:n}}function eo(e,t,n=ct.THROW_IF_NOT_FOUND){const o=ge(e);try{if(8&t.flags)return t.token;if(2&t.flags&&(n=null),1&t.flags)return e._parent.get(t.token,n);const o=t.tokenKey;switch(o){case Yn:case Kn:case Xn:return e}const i=e._def.providersByKey[o];let l;if(i){let t=e._providers[i.index];return void 0===t&&(t=e._providers[i.index]=to(e,i)),t===Gn?void 0:t}if((l=ee(t.token))&&(r=e,null!=(a=l).providedIn&&(function(e,t){return e._def.modules.indexOf(t)>-1}(r,a.providedIn)||"root"===a.providedIn&&r._def.isRoot))){const n=e._providers.length;return e._def.providers[n]=e._def.providersByKey[t.tokenKey]={flags:5120,value:l.factory,deps:[],index:n,token:t.token},e._providers[n]=Gn,e._providers[n]=to(e,e._def.providersByKey[t.tokenKey])}return 4&t.flags?n:e._parent.get(t.token,n)}finally{ge(o)}var r,a}function to(e,t){let n;switch(201347067&t.flags){case 512:n=function(e,t,n){const o=n.length;switch(o){case 0:return new t;case 1:return new t(eo(e,n[0]));case 2:return new t(eo(e,n[0]),eo(e,n[1]));case 3:return new t(eo(e,n[0]),eo(e,n[1]),eo(e,n[2]));default:const r=new Array(o);for(let t=0;t<o;t++)r[t]=eo(e,n[t]);return new t(...r)}}(e,t.value,t.deps);break;case 1024:n=function(e,t,n){const o=n.length;switch(o){case 0:return t();case 1:return t(eo(e,n[0]));case 2:return t(eo(e,n[0]),eo(e,n[1]));case 3:return t(eo(e,n[0]),eo(e,n[1]),eo(e,n[2]));default:const r=Array(o);for(let t=0;t<o;t++)r[t]=eo(e,n[t]);return t(...r)}}(e,t.value,t.deps);break;case 2048:n=eo(e,t.deps[0]);break;case 256:n=t.value}return n===Gn||null===n||"object"!=typeof n||131072&t.flags||"function"!=typeof n.ngOnDestroy||(t.flags|=131072),void 0===n?Gn:n}function no(e,t){const n=e.viewContainer._embeddedViews;if((null==t||t>=n.length)&&(t=n.length-1),t<0)return null;const o=n[t];return o.viewContainerParent=null,ke(n,t),gn.dirtyParentQueries(o),ro(o),o}function oo(e,t,n){const o=t?In(t,t.def.lastRenderRootNode):e.renderElement,r=n.renderer.parentNode(o),a=n.renderer.nextSibling(o);Ln(n,2,r,a,void 0)}function ro(e){Ln(e,3,null,null,void 0)}const ao=new Object;class io extends Tt{constructor(e,t,n,o,r,a){super(),this.selector=e,this.componentType=t,this._inputs=o,this._outputs=r,this.ngContentSelectors=a,this.viewDefFactory=n}get inputs(){const e=[],t=this._inputs;for(let n in t)e.push({propName:n,templateName:t[n]});return e}get outputs(){const e=[];for(let t in this._outputs)e.push({propName:t,templateName:this._outputs[t]});return e}create(e,t,n,o){if(!o)throw new Error("ngModule should be provided");const r=Pn(this.viewDefFactory),a=r.nodes[0].element.componentProvider.nodeIndex,i=gn.createRootView(e,t||[],n,r,o,ao),l=pn(i,a).instance;return n&&i.renderer.setAttribute(mn(i,0).renderElement,"ng-version",Ht.full),new lo(i,new uo(i),l)}}class lo extends class{}{constructor(e,t,n){super(),this._view=e,this._viewRef=t,this._component=n,this._elDef=this._view.def.nodes[0],this.hostView=t,this.changeDetectorRef=t,this.instance=n}get location(){return new zt(mn(this._view,this._elDef.nodeIndex).renderElement)}get injector(){return new ho(this._view,this._elDef)}get componentType(){return this._component.constructor}destroy(){this._viewRef.destroy()}onDestroy(e){this._viewRef.onDestroy(e)}}function so(e,t,n){return new co(e,t,n)}class co{constructor(e,t,n){this._view=e,this._elDef=t,this._data=n,this._embeddedViews=[]}get element(){return new zt(this._data.renderElement)}get injector(){return new ho(this._view,this._elDef)}get parentInjector(){let e=this._view,t=this._elDef.parent;for(;!t&&e;)t=jn(e),e=e.parent;return e?new ho(e,t):new ho(this._view,null)}clear(){for(let e=this._embeddedViews.length-1;e>=0;e--){const t=no(this._data,e);gn.destroyView(t)}}get(e){const t=this._embeddedViews[e];if(t){const e=new uo(t);return e.attachToViewContainerRef(this),e}return null}get length(){return this._embeddedViews.length}createEmbeddedView(e,t,n){const o=e.createEmbeddedView(t||{});return this.insert(o,n),o}createComponent(e,t,n,o,r){const a=n||this.parentInjector;r||e instanceof Mt||(r=a.get(ye));const i=e.create(a,o,void 0,r);return this.insert(i.hostView,t),i}insert(e,t){if(e.destroyed)throw new Error("Cannot insert a destroyed View in a ViewContainer!");const n=e;return function(e,t,n,o){let r=t.viewContainer._embeddedViews;null==n&&(n=r.length),o.viewContainerParent=e,ve(r,n,o),function(e,t){const n=Nn(t);if(!n||n===e||16&t.state)return;t.state|=16;let o=n.template._projectedViews;o||(o=n.template._projectedViews=[]),o.push(t),function(e,t){if(4&t.flags)return;e.nodeFlags|=4,t.flags|=4;let n=t.parent;for(;n;)n.childFlags|=4,n=n.parent}(t.parent.def,t.parentNodeDef)}(t,o),gn.dirtyParentQueries(o),oo(t,n>0?r[n-1]:null,o)}(this._view,this._data,t,n._view),n.attachToViewContainerRef(this),e}move(e,t){if(e.destroyed)throw new Error("Cannot move a destroyed View in a ViewContainer!");const n=this._embeddedViews.indexOf(e._view);return function(e,t,n){const o=e.viewContainer._embeddedViews,r=o[t];ke(o,t),null==n&&(n=o.length),ve(o,n,r),gn.dirtyParentQueries(r),ro(r),oo(e,n>0?o[n-1]:null,r)}(this._data,n,t),e}indexOf(e){return this._embeddedViews.indexOf(e._view)}remove(e){const t=no(this._data,e);t&&gn.destroyView(t)}detach(e){const t=no(this._data,e);return t?new uo(t):null}}function fo(e){return new uo(e)}class uo{constructor(e){this._view=e,this._viewContainerRef=null,this._appRef=null}get rootNodes(){return function(e){const t=[];return Ln(e,0,void 0,void 0,t),t}(this._view)}get context(){return this._view.context}get destroyed(){return!!(128&this._view.state)}markForCheck(){En(this._view)}detach(){this._view.state&=-5}detectChanges(){const e=this._view.root.rendererFactory;e.begin&&e.begin();try{gn.checkAndUpdateView(this._view)}finally{e.end&&e.end()}}checkNoChanges(){gn.checkNoChangesView(this._view)}reattach(){this._view.state|=4}onDestroy(e){this._view.disposables||(this._view.disposables=[]),this._view.disposables.push(e)}destroy(){this._appRef?this._appRef.detachView(this):this._viewContainerRef&&this._viewContainerRef.detach(this._viewContainerRef.indexOf(this)),gn.destroyView(this._view)}detachFromAppRef(){this._appRef=null,ro(this._view),gn.dirtyParentQueries(this._view)}attachToAppRef(e){if(this._viewContainerRef)throw new Error("This view is already attached to a ViewContainer!");this._appRef=e}attachToViewContainerRef(e){if(this._appRef)throw new Error("This view is already attached directly to the ApplicationRef!");this._viewContainerRef=e}}function mo(e,t){return new po(e,t)}class po extends nn{constructor(e,t){super(),this._parentView=e,this._def=t}createEmbeddedView(e){return new uo(gn.createEmbeddedView(this._parentView,this._def,this._def.element.template,e))}get elementRef(){return new zt(mn(this._parentView,this._def.nodeIndex).renderElement)}}function bo(e,t){return new ho(e,t)}class ho{constructor(e,t){this.view=e,this.elDef=t}get(e,t=ct.THROW_IF_NOT_FOUND){return gn.resolveDep(this.view,this.elDef,!!this.elDef&&!!(33554432&this.elDef.flags),{flags:0,token:e,tokenKey:yn(e)},t)}}function go(e){return new xo(e.renderer)}class xo{constructor(e){this.delegate=e}selectRootElement(e){return this.delegate.selectRootElement(e)}createElement(e,t){const[n,o]=$n(t),r=this.delegate.createElement(o,n);return e&&this.delegate.appendChild(e,r),r}createViewRoot(e){return e}createTemplateAnchor(e){const t=this.delegate.createComment("");return e&&this.delegate.appendChild(e,t),t}createText(e,t){const n=this.delegate.createText(t);return e&&this.delegate.appendChild(e,n),n}projectNodes(e,t){for(let n=0;n<t.length;n++)this.delegate.appendChild(e,t[n])}attachViewAfter(e,t){const n=this.delegate.parentNode(e),o=this.delegate.nextSibling(e);for(let e=0;e<t.length;e++)this.delegate.insertBefore(n,t[e],o)}detachView(e){for(let t=0;t<e.length;t++){const n=e[t],o=this.delegate.parentNode(n);this.delegate.removeChild(o,n)}}destroyView(e,t){for(let e=0;e<t.length;e++)this.delegate.destroyNode(t[e])}listen(e,t,n){return this.delegate.listen(e,t,n)}listenGlobal(e,t,n){return this.delegate.listen(e,t,n)}setElementProperty(e,t,n){this.delegate.setProperty(e,t,n)}setElementAttribute(e,t,n){const[o,r]=$n(t);null!=n?this.delegate.setAttribute(e,r,n,o):this.delegate.removeAttribute(e,r,o)}setBindingDebugInfo(e,t,n){}setElementClass(e,t,n){n?this.delegate.addClass(e,t):this.delegate.removeClass(e,t)}setElementStyle(e,t,n){null!=n?this.delegate.setStyle(e,t,n):this.delegate.removeStyle(e,t)}invokeElementMethod(e,t,n){e[t].apply(e,n)}setText(e,t){this.delegate.setValue(e,t)}animate(){throw new Error("Renderer.animate is no longer supported!")}}function wo(e,t,n,o){return new yo(e,t,n,o)}class yo{constructor(e,t,n,o){this._moduleType=e,this._parent=t,this._bootstrapComponents=n,this._def=o,this._destroyListeners=[],this._destroyed=!1,this.injector=this,function(e){const t=e._def,n=e._providers=new Array(t.providers.length);for(let o=0;o<t.providers.length;o++){const r=t.providers[o];4096&r.flags||void 0===n[o]&&(n[o]=to(e,r))}}(this)}get(e,t=ct.THROW_IF_NOT_FOUND,n=K.Default){let o=0;return n&K.SkipSelf?o|=1:n&K.Self&&(o|=4),eo(this,{token:e,tokenKey:yn(e),flags:o},t)}get instance(){return this.get(this._moduleType)}get componentFactoryResolver(){return this.get(It)}destroy(){if(this._destroyed)throw new Error(`The ng module ${ne(this.instance.constructor)} has already been destroyed.`);this._destroyed=!0,function(e){const t=e._def,n=new Set;for(let o=0;o<t.providers.length;o++)if(131072&t.providers[o].flags){const t=e._providers[o];if(t&&t!==Gn){const e=t.ngOnDestroy;"function"!=typeof e||n.has(t)||(e.apply(t),n.add(t))}}}(this),this._destroyListeners.forEach(e=>e())}onDestroy(e){this._destroyListeners.push(e)}}const vo=yn(class{}),ko=yn(Pt),_o=yn(zt),Co=yn(rn),Eo=yn(nn),To=yn(at),So=yn(ct),No=yn(ue);function jo(e,t,n,o,r,a,i,l){const s=[];if(i)for(let e in i){const[t,n]=i[e];s[t]={flags:8,name:e,nonMinifiedName:n,ns:null,securityContext:null,suffix:null}}const c=[];if(l)for(let e in l)c.push({type:1,propName:e,target:null,eventName:l[e]});return Do(e,t|=16384,n,o,r,r,a,s,c)}function Io(e,t,n,o,r){return Do(-1,e,t,0,n,o,r)}function Do(e,t,n,o,r,a,i,l,s){const{matchedQueries:c,references:f,matchedQueryIds:d}=zn(n);s||(s=[]),l||(l=[]),a=ae(a);const u=An(i,ne(r));return{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,checkIndex:e,flags:t,childFlags:0,directChildFlags:0,childMatchedQueries:0,matchedQueries:c,matchedQueryIds:d,references:f,ngContentIndex:-1,childCount:o,bindings:l,bindingFlags:Un(l),outputs:s,element:null,provider:{token:r,value:a,deps:u},text:null,query:null,ngContent:null}}function Mo(e,t){return Oo(e,t)}function Fo(e,t){let n=e;for(;n.parent&&!Dn(n);)n=n.parent;return Ro(n.parent,jn(n),!0,t.provider.value,t.provider.deps)}function zo(e,t){const n=Ro(e,t.parent,(32768&t.flags)>0,t.provider.value,t.provider.deps);if(t.outputs.length)for(let r=0;r<t.outputs.length;r++){const a=t.outputs[r],i=n[a.propName];if(!(o=i)||"function"!=typeof o.subscribe)throw new Error(`@Output ${a.propName} not initialized in '${n.constructor.name}'.`);{const n=i.subscribe(Ao(e,t.parent.nodeIndex,a.eventName));e.disposables[t.outputIndex+r]=n.unsubscribe.bind(n)}}var o;return n}function Ao(e,t,n){return o=>Sn(e,t,n,o)}function Oo(e,t){const n=(8192&t.flags)>0,o=t.provider;switch(201347067&t.flags){case 512:return Ro(e,t.parent,n,o.value,o.deps);case 1024:return function(e,t,n,o,r){const a=r.length;switch(a){case 0:return o();case 1:return o(Lo(e,t,n,r[0]));case 2:return o(Lo(e,t,n,r[0]),Lo(e,t,n,r[1]));case 3:return o(Lo(e,t,n,r[0]),Lo(e,t,n,r[1]),Lo(e,t,n,r[2]));default:const i=Array(a);for(let o=0;o<a;o++)i[o]=Lo(e,t,n,r[o]);return o(...i)}}(e,t.parent,n,o.value,o.deps);case 2048:return Lo(e,t.parent,n,o.deps[0]);case 256:return o.value}}function Ro(e,t,n,o,r){const a=r.length;switch(a){case 0:return new o;case 1:return new o(Lo(e,t,n,r[0]));case 2:return new o(Lo(e,t,n,r[0]),Lo(e,t,n,r[1]));case 3:return new o(Lo(e,t,n,r[0]),Lo(e,t,n,r[1]),Lo(e,t,n,r[2]));default:const i=new Array(a);for(let o=0;o<a;o++)i[o]=Lo(e,t,n,r[o]);return new o(...i)}}const Po={};function Lo(e,t,n,o,r=ct.THROW_IF_NOT_FOUND){if(8&o.flags)return o.token;const a=e;2&o.flags&&(r=null);const i=o.tokenKey;i===To&&(n=!(!t||!t.element.componentView)),t&&1&o.flags&&(n=!1,t=t.parent);let l=e;for(;l;){if(t)switch(i){case vo:return go(Ho(l,t,n));case ko:return Ho(l,t,n).renderer;case _o:return new zt(mn(l,t.nodeIndex).renderElement);case Co:return mn(l,t.nodeIndex).viewContainer;case Eo:if(t.element.template)return mn(l,t.nodeIndex).template;break;case To:return fo(Ho(l,t,n));case So:case No:return bo(l,t);default:const e=(n?t.element.allProviders:t.element.publicProviders)[i];if(e){let t=pn(l,e.nodeIndex);return t||(t={instance:Oo(l,e)},l.nodes[e.nodeIndex]=t),t.instance}}n=Dn(l),t=jn(l),l=l.parent,4&o.flags&&(l=null)}const s=a.root.injector.get(o.token,Po);return s!==Po||r===Po?s:a.root.ngModule.injector.get(o.token,r)}function Ho(e,t,n){let o;if(n)o=mn(e,t.nodeIndex).componentView;else for(o=e;o.parent&&!Dn(o);)o=o.parent;return o}function Vo(e,t,n,o,r,a){if(32768&n.flags){const t=mn(e,n.parent.nodeIndex).componentView;2&t.def.flags&&(t.state|=8)}if(t.instance[n.bindings[o].name]=r,524288&n.flags){a=a||{};const t=vt.unwrap(e.oldValues[n.bindingIndex+o]);a[n.bindings[o].nonMinifiedName]=new Et(t,r,!!(2&e.state))}return e.oldValues[n.bindingIndex+o]=r,a}function qo(e,t){if(!(e.def.nodeFlags&t))return;const n=e.def.nodes;let o=0;for(let r=0;r<n.length;r++){const a=n[r];let i=a.parent;for(!i&&a.flags&t&&Bo(e,r,a.flags&t,o++),0==(a.childFlags&t)&&(r+=a.childCount);i&&1&i.flags&&r===i.nodeIndex+i.childCount;)i.directChildFlags&t&&(o=Zo(e,i,t,o)),i=i.parent}}function Zo(e,t,n,o){for(let r=t.nodeIndex+1;r<=t.nodeIndex+t.childCount;r++){const t=e.def.nodes[r];t.flags&n&&Bo(e,r,t.flags&n,o++),r+=t.childCount}return o}function Bo(e,t,n,o){const r=pn(e,t);if(!r)return;const a=r.instance;a&&(gn.setCurrentNode(e,t),1048576&n&&dn(e,512,o)&&a.ngAfterContentInit(),2097152&n&&a.ngAfterContentChecked(),4194304&n&&dn(e,768,o)&&a.ngAfterViewInit(),8388608&n&&a.ngAfterViewChecked(),131072&n&&a.ngOnDestroy())}const $o=new de("SCHEDULER_TOKEN",{providedIn:"root",factory:()=>Ce}),Uo={},Qo=function(){var e={LocaleId:0,DayPeriodsFormat:1,DayPeriodsStandalone:2,DaysFormat:3,DaysStandalone:4,MonthsFormat:5,MonthsStandalone:6,Eras:7,FirstDayOfWeek:8,WeekendRange:9,DateFormat:10,TimeFormat:11,DateTimeFormat:12,NumberSymbols:13,NumberFormats:14,CurrencySymbol:15,CurrencyName:16,Currencies:17,PluralCase:18,ExtraData:19};return e[e.LocaleId]="LocaleId",e[e.DayPeriodsFormat]="DayPeriodsFormat",e[e.DayPeriodsStandalone]="DayPeriodsStandalone",e[e.DaysFormat]="DaysFormat",e[e.DaysStandalone]="DaysStandalone",e[e.MonthsFormat]="MonthsFormat",e[e.MonthsStandalone]="MonthsStandalone",e[e.Eras]="Eras",e[e.FirstDayOfWeek]="FirstDayOfWeek",e[e.WeekendRange]="WeekendRange",e[e.DateFormat]="DateFormat",e[e.TimeFormat]="TimeFormat",e[e.DateTimeFormat]="DateTimeFormat",e[e.NumberSymbols]="NumberSymbols",e[e.NumberFormats]="NumberFormats",e[e.CurrencySymbol]="CurrencySymbol",e[e.CurrencyName]="CurrencyName",e[e.Currencies]="Currencies",e[e.PluralCase]="PluralCase",e[e.ExtraData]="ExtraData",e}(),Wo=void 0;var Go=["en",[["a","p"],["AM","PM"],Wo],[["AM","PM"],Wo,Wo],[["S","M","T","W","T","F","S"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],["Su","Mo","Tu","We","Th","Fr","Sa"]],Wo,[["J","F","M","A","M","J","J","A","S","O","N","D"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["January","February","March","April","May","June","July","August","September","October","November","December"]],Wo,[["B","A"],["BC","AD"],["Before Christ","Anno Domini"]],0,[6,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE, MMMM d, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",Wo,"{1} 'at' {0}",Wo],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"$","US Dollar",{},function(e){let t=Math.floor(Math.abs(e)),n=e.toString().replace(/^[^.]*\.?/,"").length;return 1===t&&0===n?1:5}];class Yo extends E{constructor(e=!1){super(),this.__isAsync=e}emit(e){super.next(e)}subscribe(e,t,n){let o,r=e=>null,a=()=>null;e&&"object"==typeof e?(o=this.__isAsync?t=>{setTimeout(()=>e.next(t))}:t=>{e.next(t)},e.error&&(r=this.__isAsync?t=>{setTimeout(()=>e.error(t))}:t=>{e.error(t)}),e.complete&&(a=this.__isAsync?()=>{setTimeout(()=>e.complete())}:()=>{e.complete()})):(o=this.__isAsync?t=>{setTimeout(()=>e(t))}:t=>{e(t)},t&&(r=this.__isAsync?e=>{setTimeout(()=>t(e))}:e=>{t(e)}),n&&(a=this.__isAsync?()=>{setTimeout(()=>n())}:()=>{n()}));const i=super.subscribe(o,r,a);return e instanceof u&&e.add(i),i}}function Ko(){return this._results[xt()]()}class Xo{constructor(){this.dirty=!0,this._results=[],this.changes=new Yo,this.length=0;const e=xt(),t=Xo.prototype;t[e]||(t[e]=Ko)}map(e){return this._results.map(e)}filter(e){return this._results.filter(e)}find(e){return this._results.find(e)}reduce(e,t){return this._results.reduce(e,t)}forEach(e){this._results.forEach(e)}some(e){return this._results.some(e)}toArray(){return this._results.slice()}toString(){return this._results.toString()}reset(e){this._results=function e(t,n){void 0===n&&(n=t);for(let o=0;o<t.length;o++){let r=t[o];Array.isArray(r)?(n===t&&(n=t.slice(0,o)),e(r,n)):n!==t&&n.push(r)}return n}(e),this.dirty=!1,this.length=this._results.length,this.last=this._results[this.length-1],this.first=this._results[0]}notifyOnChanges(){this.changes.emit(this)}setDirty(){this.dirty=!0}destroy(){this.changes.complete(),this.changes.unsubscribe()}}const Jo=new de("Application Initializer");class er{constructor(e){this.appInits=e,this.initialized=!1,this.done=!1,this.donePromise=new Promise((e,t)=>{this.resolve=e,this.reject=t})}runInitializers(){if(this.initialized)return;const e=[],t=()=>{this.done=!0,this.resolve()};if(this.appInits)for(let t=0;t<this.appInits.length;t++){const n=this.appInits[t]();Ct(n)&&e.push(n)}Promise.all(e).then(()=>{t()}).catch(e=>{this.reject(e)}),0===e.length&&t(),this.initialized=!0}}const tr=new de("AppId");function nr(){return`${or()}${or()}${or()}`}function or(){return String.fromCharCode(97+Math.floor(25*Math.random()))}const rr=new de("Platform Initializer"),ar=new de("Platform ID"),ir=new de("appBootstrapListener");class lr{log(e){console.log(e)}warn(e){console.warn(e)}}const sr=new de("LocaleId");function cr(){throw new Error("Runtime compiler is not loaded")}const fr=cr,dr=cr,ur=cr,mr=cr;class pr{constructor(){this.compileModuleSync=fr,this.compileModuleAsync=dr,this.compileModuleAndAllComponentsSync=ur,this.compileModuleAndAllComponentsAsync=mr}clearCache(){}clearCacheFor(e){}getModuleId(e){}}class br{}let hr,gr;const xr=function(){const e=fe.wtf;return!(!e||(hr=e.trace,!hr)||(gr=hr.events,0))}();function wr(e,t){return null}const yr=xr?function(e,t=null){return gr.createScope(e,t)}:(e,t)=>wr,vr=xr?function(e,t){return hr.leaveScope(e,t),t}:(e,t)=>t,kr=Promise.resolve(0);function _r(e){"undefined"==typeof Zone?kr.then(()=>{e&&e.apply(null,null)}):Zone.current.scheduleMicroTask("scheduleMicrotask",e)}class Cr{constructor({enableLongStackTrace:e=!1}){if(this.hasPendingMicrotasks=!1,this.hasPendingMacrotasks=!1,this.isStable=!0,this.onUnstable=new Yo(!1),this.onMicrotaskEmpty=new Yo(!1),this.onStable=new Yo(!1),this.onError=new Yo(!1),"undefined"==typeof Zone)throw new Error("In this configuration Angular requires Zone.js");var t;Zone.assertZonePatched(),this._nesting=0,this._outer=this._inner=Zone.current,Zone.wtfZoneSpec&&(this._inner=this._inner.fork(Zone.wtfZoneSpec)),Zone.TaskTrackingZoneSpec&&(this._inner=this._inner.fork(new Zone.TaskTrackingZoneSpec)),e&&Zone.longStackTraceZoneSpec&&(this._inner=this._inner.fork(Zone.longStackTraceZoneSpec)),(t=this)._inner=t._inner.fork({name:"angular",properties:{isAngularZone:!0},onInvokeTask:(e,n,o,r,a,i)=>{try{return Nr(t),e.invokeTask(o,r,a,i)}finally{jr(t)}},onInvoke:(e,n,o,r,a,i,l)=>{try{return Nr(t),e.invoke(o,r,a,i,l)}finally{jr(t)}},onHasTask:(e,n,o,r)=>{e.hasTask(o,r),n===o&&("microTask"==r.change?(t.hasPendingMicrotasks=r.microTask,Sr(t)):"macroTask"==r.change&&(t.hasPendingMacrotasks=r.macroTask))},onHandleError:(e,n,o,r)=>(e.handleError(o,r),t.runOutsideAngular(()=>t.onError.emit(r)),!1)})}static isInAngularZone(){return!0===Zone.current.get("isAngularZone")}static assertInAngularZone(){if(!Cr.isInAngularZone())throw new Error("Expected to be in Angular Zone, but it is not!")}static assertNotInAngularZone(){if(Cr.isInAngularZone())throw new Error("Expected to not be in Angular Zone, but it is!")}run(e,t,n){return this._inner.run(e,t,n)}runTask(e,t,n,o){const r=this._inner,a=r.scheduleEventTask("NgZoneEvent: "+o,e,Tr,Er,Er);try{return r.runTask(a,t,n)}finally{r.cancelTask(a)}}runGuarded(e,t,n){return this._inner.runGuarded(e,t,n)}runOutsideAngular(e){return this._outer.run(e)}}function Er(){}const Tr={};function Sr(e){if(0==e._nesting&&!e.hasPendingMicrotasks&&!e.isStable)try{e._nesting++,e.onMicrotaskEmpty.emit(null)}finally{if(e._nesting--,!e.hasPendingMicrotasks)try{e.runOutsideAngular(()=>e.onStable.emit(null))}finally{e.isStable=!0}}}function Nr(e){e._nesting++,e.isStable&&(e.isStable=!1,e.onUnstable.emit(null))}function jr(e){e._nesting--,Sr(e)}class Ir{constructor(){this.hasPendingMicrotasks=!1,this.hasPendingMacrotasks=!1,this.isStable=!0,this.onUnstable=new Yo,this.onMicrotaskEmpty=new Yo,this.onStable=new Yo,this.onError=new Yo}run(e){return e()}runGuarded(e){return e()}runOutsideAngular(e){return e()}runTask(e){return e()}}class Dr{constructor(e){this._ngZone=e,this._pendingCount=0,this._isZoneStable=!0,this._didWork=!1,this._callbacks=[],this.taskTrackingZone=null,this._watchAngularEvents(),e.run(()=>{this.taskTrackingZone="undefined"==typeof Zone?null:Zone.current.get("TaskTrackingZone")})}_watchAngularEvents(){this._ngZone.onUnstable.subscribe({next:()=>{this._didWork=!0,this._isZoneStable=!1}}),this._ngZone.runOutsideAngular(()=>{this._ngZone.onStable.subscribe({next:()=>{Cr.assertNotInAngularZone(),_r(()=>{this._isZoneStable=!0,this._runCallbacksIfReady()})}})})}increasePendingRequestCount(){return this._pendingCount+=1,this._didWork=!0,this._pendingCount}decreasePendingRequestCount(){if(this._pendingCount-=1,this._pendingCount<0)throw new Error("pending async requests below zero");return this._runCallbacksIfReady(),this._pendingCount}isStable(){return this._isZoneStable&&0===this._pendingCount&&!this._ngZone.hasPendingMacrotasks}_runCallbacksIfReady(){if(this.isStable())_r(()=>{for(;0!==this._callbacks.length;){let e=this._callbacks.pop();clearTimeout(e.timeoutId),e.doneCb(this._didWork)}this._didWork=!1});else{let e=this.getPendingTasks();this._callbacks=this._callbacks.filter(t=>!t.updateCb||!t.updateCb(e)||(clearTimeout(t.timeoutId),!1)),this._didWork=!0}}getPendingTasks(){return this.taskTrackingZone?this.taskTrackingZone.macroTasks.map(e=>({source:e.source,creationLocation:e.creationLocation,data:e.data})):[]}addCallback(e,t,n){let o=-1;t&&t>0&&(o=setTimeout(()=>{this._callbacks=this._callbacks.filter(e=>e.timeoutId!==o),e(this._didWork,this.getPendingTasks())},t)),this._callbacks.push({doneCb:e,timeoutId:o,updateCb:n})}whenStable(e,t,n){if(n&&!this.taskTrackingZone)throw new Error('Task tracking zone is required when passing an update callback to whenStable(). Is "zone.js/dist/task-tracking.js" loaded?');this.addCallback(e,t,n),this._runCallbacksIfReady()}getPendingRequestCount(){return this._pendingCount}findProviders(e,t,n){return[]}}let Mr,Fr=(()=>{class e{constructor(){this._applications=new Map,zr.addToWindow(this)}registerApplication(e,t){this._applications.set(e,t)}unregisterApplication(e){this._applications.delete(e)}unregisterAllApplications(){this._applications.clear()}getTestability(e){return this._applications.get(e)||null}getAllTestabilities(){return Array.from(this._applications.values())}getAllRootElements(){return Array.from(this._applications.keys())}findTestabilityInTree(e,t=!0){return zr.findTestabilityInTree(this,e,t)}}return e.ctorParameters=()=>[],e})(),zr=new class{addToWindow(e){}findTestabilityInTree(e,t,n){return null}};const Ar=new de("AllowMultipleToken");class Or{constructor(e,t){this.name=e,this.token=t}}function Rr(e,t,n=[]){const o=`Platform: ${t}`,r=new de(o);return(t=[])=>{let a=Pr();if(!a||a.injector.get(Ar,!1))if(e)e(n.concat(t).concat({provide:r,useValue:!0}));else{const e=n.concat(t).concat({provide:r,useValue:!0});!function(e){if(Mr&&!Mr.destroyed&&!Mr.injector.get(Ar,!1))throw new Error("There can be only one platform. Destroy the previous one to create a new one.");Mr=e.get(Lr);const t=e.get(rr,null);t&&t.forEach(e=>e())}(ct.create({providers:e,name:o}))}return function(e){const t=Pr();if(!t)throw new Error("No platform exists!");if(!t.injector.get(e,null))throw new Error("A platform with a different configuration has been created. Please destroy it first.");return t}(r)}}function Pr(){return Mr&&!Mr.destroyed?Mr:null}class Lr{constructor(e){this._injector=e,this._modules=[],this._destroyListeners=[],this._destroyed=!1}bootstrapModuleFactory(e,t){const n=function(e){let t;return t="noop"===e?new Ir:("zone.js"===e?void 0:e)||new Cr({enableLongStackTrace:De()}),t}(t?t.ngZone:void 0),o=[{provide:Cr,useValue:n}];return n.run(()=>{const t=ct.create({providers:o,parent:this.injector,name:e.moduleType.name}),r=e.create(t),a=r.injector.get(Ne,null);if(!a)throw new Error("No ErrorHandler. Is platform module (BrowserModule) included?");return r.onDestroy(()=>qr(this._modules,r)),n.runOutsideAngular(()=>n.onError.subscribe({next:e=>{a.handleError(e)}})),function(e,t,n){try{const o=n();return Ct(o)?o.catch(n=>{throw t.runOutsideAngular(()=>e.handleError(n)),n}):o}catch(n){throw t.runOutsideAngular(()=>e.handleError(n)),n}}(a,n,()=>{const e=r.injector.get(er);return e.runInitializers(),e.donePromise.then(()=>(this._moduleDoBootstrap(r),r))})})}bootstrapModule(e,t=[]){const n=Hr({},t);return function(e,t,n){return e.get(br).createCompiler([t]).compileModuleAsync(n)}(this.injector,n,e).then(e=>this.bootstrapModuleFactory(e,n))}_moduleDoBootstrap(e){const t=e.injector.get(Vr);if(e._bootstrapComponents.length>0)e._bootstrapComponents.forEach(e=>t.bootstrap(e));else{if(!e.instance.ngDoBootstrap)throw new Error(`The module ${ne(e.instance.constructor)} was bootstrapped, but it does not declare "@NgModule.bootstrap" components nor a "ngDoBootstrap" method. Please define one of these.`);e.instance.ngDoBootstrap(t)}this._modules.push(e)}onDestroy(e){this._destroyListeners.push(e)}get injector(){return this._injector}destroy(){if(this._destroyed)throw new Error("The platform has already been destroyed!");this._modules.slice().forEach(e=>e.destroy()),this._destroyListeners.forEach(e=>e()),this._destroyed=!0}get destroyed(){return this._destroyed}}function Hr(e,t){return Array.isArray(t)?t.reduce(Hr,e):Object.assign({},e,t)}let Vr=(()=>{class e{constructor(e,t,n,o,r,a){this._zone=e,this._console=t,this._injector=n,this._exceptionHandler=o,this._componentFactoryResolver=r,this._initStatus=a,this._bootstrapListeners=[],this._views=[],this._runningTick=!1,this._enforceNoNewChanges=!1,this._stable=!0,this.componentTypes=[],this.components=[],this._enforceNoNewChanges=De(),this._zone.onMicrotaskEmpty.subscribe({next:()=>{this._zone.run(()=>{this.tick()})}});const i=new w(e=>{this._stable=this._zone.isStable&&!this._zone.hasPendingMacrotasks&&!this._zone.hasPendingMicrotasks,this._zone.runOutsideAngular(()=>{e.next(this._stable),e.complete()})}),l=new w(e=>{let t;this._zone.runOutsideAngular(()=>{t=this._zone.onStable.subscribe(()=>{Cr.assertNotInAngularZone(),_r(()=>{this._stable||this._zone.hasPendingMacrotasks||this._zone.hasPendingMicrotasks||(this._stable=!0,e.next(!0))})})});const n=this._zone.onUnstable.subscribe(()=>{Cr.assertInAngularZone(),this._stable&&(this._stable=!1,this._zone.runOutsideAngular(()=>{e.next(!1)}))});return()=>{t.unsubscribe(),n.unsubscribe()}});this.isStable=P(i,l.pipe(e=>{return L()((t=$,function(e){let n;n="function"==typeof t?t:function(){return t};const o=Object.create(e,Z);return o.source=e,o.subjectFactory=n,o})(e));var t}))}bootstrap(e,t){if(!this._initStatus.done)throw new Error("Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.");let n;n=e instanceof Tt?e:this._componentFactoryResolver.resolveComponentFactory(e),this.componentTypes.push(n.componentType);const o=n instanceof Mt?null:this._injector.get(ye),r=n.create(ct.NULL,[],t||n.selector,o);r.onDestroy(()=>{this._unloadComponent(r)});const a=r.injector.get(Dr,null);return a&&r.injector.get(Fr).registerApplication(r.location.nativeElement,a),this._loadComponent(r),De()&&this._console.log("Angular is running in the development mode. Call enableProdMode() to enable the production mode."),r}tick(){if(this._runningTick)throw new Error("ApplicationRef.tick is called recursively");const t=e._tickScope();try{this._runningTick=!0;for(let e of this._views)e.detectChanges();if(this._enforceNoNewChanges)for(let e of this._views)e.checkNoChanges()}catch(e){this._zone.runOutsideAngular(()=>this._exceptionHandler.handleError(e))}finally{this._runningTick=!1,vr(t)}}attachView(e){const t=e;this._views.push(t),t.attachToAppRef(this)}detachView(e){const t=e;qr(this._views,t),t.detachFromAppRef()}_loadComponent(e){this.attachView(e.hostView),this.tick(),this.components.push(e),this._injector.get(ir,[]).concat(this._bootstrapListeners).forEach(t=>t(e))}_unloadComponent(e){this.detachView(e.hostView),qr(this.components,e)}ngOnDestroy(){this._views.slice().forEach(e=>e.destroy())}get viewCount(){return this._views.length}}return e._tickScope=yr("ApplicationRef#tick()"),e})();function qr(e,t){const n=e.indexOf(t);n>-1&&e.splice(n,1)}class Zr{constructor(e,t){this.name=e,this.callback=t}}class Br{constructor(e,t,n){this.listeners=[],this.parent=null,this._debugContext=n,this.nativeNode=e,t&&t instanceof $r&&t.addChild(this)}get injector(){return this._debugContext.injector}get componentInstance(){return this._debugContext.component}get context(){return this._debugContext.context}get references(){return this._debugContext.references}get providerTokens(){return this._debugContext.providerTokens}}class $r extends Br{constructor(e,t,n){super(e,t,n),this.properties={},this.attributes={},this.classes={},this.styles={},this.childNodes=[],this.nativeElement=e}addChild(e){e&&(this.childNodes.push(e),e.parent=this)}removeChild(e){const t=this.childNodes.indexOf(e);-1!==t&&(e.parent=null,this.childNodes.splice(t,1))}insertChildrenAfter(e,t){const n=this.childNodes.indexOf(e);-1!==n&&(this.childNodes.splice(n+1,0,...t),t.forEach(t=>{t.parent&&t.parent.removeChild(t),e.parent=this}))}insertBefore(e,t){const n=this.childNodes.indexOf(e);-1===n?this.addChild(t):(t.parent&&t.parent.removeChild(t),t.parent=this,this.childNodes.splice(n,0,t))}query(e){return this.queryAll(e)[0]||null}queryAll(e){const t=[];return function e(t,n,o){t.childNodes.forEach(t=>{t instanceof $r&&(n(t)&&o.push(t),e(t,n,o))})}(this,e,t),t}queryAllNodes(e){const t=[];return function e(t,n,o){t instanceof $r&&t.childNodes.forEach(t=>{n(t)&&o.push(t),t instanceof $r&&e(t,n,o)})}(this,e,t),t}get children(){return this.childNodes.filter(e=>e instanceof $r)}triggerEventHandler(e,t){this.listeners.forEach(n=>{n.name==e&&n.callback(t)})}}const Ur=new Map,Qr=function(e){return Ur.get(e)||null};function Wr(e){Ur.set(e.nativeNode,e)}const Gr=Rr(null,"core",[{provide:ar,useValue:"unknown"},{provide:Lr,deps:[ct]},{provide:Fr,deps:[]},{provide:lr,deps:[]}]);function Yr(){return en}function Kr(){return tn}function Xr(e){return e||"en-US"}function Jr(e){let t=[];return e.onStable.subscribe(()=>{for(;t.length;)t.pop()()}),function(e){t.push(e)}}class ea{constructor(e){}}function ta(e,t,n,o,r,a){e|=1;const{matchedQueries:i,references:l,matchedQueryIds:s}=zn(t);return{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,flags:e,checkIndex:-1,childFlags:0,directChildFlags:0,childMatchedQueries:0,matchedQueries:i,matchedQueryIds:s,references:l,ngContentIndex:n,childCount:o,bindings:[],bindingFlags:0,outputs:[],element:{ns:null,name:null,attrs:null,template:a?Pn(a):null,componentProvider:null,componentView:null,componentRendererType:null,publicProviders:null,allProviders:null,handleEvent:r||xn},provider:null,text:null,query:null,ngContent:null}}function na(e,t,n,o,r,a,i=[],l,s,c,f,d){c||(c=xn);const{matchedQueries:u,references:m,matchedQueryIds:p}=zn(n);let b=null,h=null;a&&([b,h]=$n(a)),l=l||[];const g=new Array(l.length);for(let e=0;e<l.length;e++){const[t,n,o]=l[e],[r,a]=$n(n);let i,s;switch(15&t){case 4:s=o;break;case 1:case 8:i=o}g[e]={flags:t,ns:r,name:a,nonMinifiedName:a,securityContext:i,suffix:s}}s=s||[];const x=new Array(s.length);for(let e=0;e<s.length;e++){const[t,n]=s[e];x[e]={type:0,target:t,eventName:n,propName:null}}const w=(i=i||[]).map(([e,t])=>{const[n,o]=$n(e);return[n,o,t]});return d=function(e){if(e&&"$$undefined"===e.id){const t=null!=e.encapsulation&&e.encapsulation!==_e.None||e.styles.length||Object.keys(e.data).length;e.id=t?"c"+vn++:"$$empty"}return e&&"$$empty"===e.id&&(e=null),e||null}(d),f&&(t|=33554432),{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,checkIndex:e,flags:t|=1,childFlags:0,directChildFlags:0,childMatchedQueries:0,matchedQueries:u,matchedQueryIds:p,references:m,ngContentIndex:o,childCount:r,bindings:g,bindingFlags:Un(g),outputs:x,element:{ns:b,name:h,attrs:w,template:null,componentProvider:null,componentView:f||null,componentRendererType:d,publicProviders:null,allProviders:null,handleEvent:c||xn},provider:null,text:null,query:null,ngContent:null}}function oa(e,t,n){const o=n.element,r=e.root.selectorOrNode,a=e.renderer;let i;if(e.parent||!r){i=o.name?a.createElement(o.name,o.ns):a.createComment("");const r=On(e,t,n);r&&a.appendChild(r,i)}else i=a.selectRootElement(r,!!o.componentRendererType&&o.componentRendererType.encapsulation===_e.ShadowDom);if(o.attrs)for(let e=0;e<o.attrs.length;e++){const[t,n,r]=o.attrs[e];a.setAttribute(i,n,r,t)}return i}function ra(e,t,n,o){for(let i=0;i<n.outputs.length;i++){const l=n.outputs[i],s=aa(e,n.nodeIndex,(a=l.eventName,(r=l.target)?`${r}:${a}`:a));let c=l.target,f=e;"component"===l.target&&(c=null,f=t);const d=f.renderer.listen(c||o,l.eventName,s);e.disposables[n.outputIndex+i]=d}var r,a}function aa(e,t,n){return o=>Sn(e,t,n,o)}function ia(e,t,n,o){if(!_n(e,t,n,o))return!1;const r=t.bindings[n],a=mn(e,t.nodeIndex),i=a.renderElement,l=r.name;switch(15&r.flags){case 1:!function(e,t,n,o,r,a){const i=t.securityContext;let l=i?e.root.sanitizer.sanitize(i,a):a;l=null!=l?l.toString():null;const s=e.renderer;null!=a?s.setAttribute(n,r,l,o):s.removeAttribute(n,r,o)}(e,r,i,r.ns,l,o);break;case 2:!function(e,t,n,o){const r=e.renderer;o?r.addClass(t,n):r.removeClass(t,n)}(e,i,l,o);break;case 4:!function(e,t,n,o,r){let a=e.root.sanitizer.sanitize(Je.STYLE,r);if(null!=a){a=a.toString();const e=t.suffix;null!=e&&(a+=e)}else a=null;const i=e.renderer;null!=a?i.setStyle(n,o,a):i.removeStyle(n,o)}(e,r,i,l,o);break;case 8:!function(e,t,n,o,r){const a=t.securityContext;let i=a?e.root.sanitizer.sanitize(a,r):r;e.renderer.setProperty(n,o,i)}(33554432&t.flags&&32&r.flags?a.componentView:e,r,i,l,o)}return!0}function la(e,t,n){let o=[];for(let e in n)o.push({propName:e,bindingType:n[e]});return{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,checkIndex:-1,flags:e,childFlags:0,directChildFlags:0,childMatchedQueries:0,ngContentIndex:-1,matchedQueries:{},matchedQueryIds:0,references:{},childCount:0,bindings:[],bindingFlags:0,outputs:[],element:null,provider:null,text:null,query:{id:t,filterId:Fn(t),bindings:o},ngContent:null}}function sa(e){const t=e.def.nodeMatchedQueries;for(;e.parent&&Mn(e);){let n=e.parentNodeDef;e=e.parent;const o=n.nodeIndex+n.childCount;for(let r=0;r<=o;r++){const o=e.def.nodes[r];67108864&o.flags&&536870912&o.flags&&(o.query.filterId&t)===o.query.filterId&&hn(e,r).setDirty(),!(1&o.flags&&r+o.childCount<n.nodeIndex)&&67108864&o.childFlags&&536870912&o.childFlags||(r+=o.childCount)}}if(134217728&e.def.nodeFlags)for(let t=0;t<e.def.nodes.length;t++){const n=e.def.nodes[t];134217728&n.flags&&536870912&n.flags&&hn(e,t).setDirty(),t+=n.childCount}}function ca(e,t){const n=hn(e,t.nodeIndex);if(!n.dirty)return;let o,r;if(67108864&t.flags){const n=t.parent.parent;r=fa(e,n.nodeIndex,n.nodeIndex+n.childCount,t.query,[]),o=pn(e,t.parent.nodeIndex).instance}else 134217728&t.flags&&(r=fa(e,0,e.def.nodes.length-1,t.query,[]),o=e.component);n.reset(r);const a=t.query.bindings;let i=!1;for(let e=0;e<a.length;e++){const t=a[e];let r;switch(t.bindingType){case 0:r=n.first;break;case 1:r=n,i=!0}o[t.propName]=r}i&&n.notifyOnChanges()}function fa(e,t,n,o,r){for(let a=t;a<=n;a++){const t=e.def.nodes[a],n=t.matchedQueries[o.id];if(null!=n&&r.push(da(e,t,n)),1&t.flags&&t.element.template&&(t.element.template.nodeMatchedQueries&o.filterId)===o.filterId){const n=mn(e,a);if((t.childMatchedQueries&o.filterId)===o.filterId&&(fa(e,a+1,a+t.childCount,o,r),a+=t.childCount),16777216&t.flags){const e=n.viewContainer._embeddedViews;for(let t=0;t<e.length;t++){const a=e[t],i=Nn(a);i&&i===n&&fa(a,0,a.def.nodes.length-1,o,r)}}const i=n.template._projectedViews;if(i)for(let e=0;e<i.length;e++){const t=i[e];fa(t,0,t.def.nodes.length-1,o,r)}}(t.childMatchedQueries&o.filterId)!==o.filterId&&(a+=t.childCount)}return r}function da(e,t,n){if(null!=n)switch(n){case 1:return mn(e,t.nodeIndex).renderElement;case 0:return new zt(mn(e,t.nodeIndex).renderElement);case 2:return mn(e,t.nodeIndex).template;case 3:return mn(e,t.nodeIndex).viewContainer;case 4:return pn(e,t.nodeIndex).instance}}function ua(e,t,n){const o=On(e,t,n);o&&Vn(e,n.ngContent.index,1,o,null,void 0)}function ma(e,t){const n=Object.keys(t),o=n.length,r=new Array(o);for(let e=0;e<o;e++){const o=n[e];r[t[o]]=o}return function(e,t,n){const o=new Array(n.length);for(let e=0;e<n.length;e++){const t=n[e];o[e]={flags:8,name:t,ns:null,nonMinifiedName:t,securityContext:null,suffix:null}}return{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,checkIndex:t,flags:64,childFlags:0,directChildFlags:0,childMatchedQueries:0,matchedQueries:{},matchedQueryIds:0,references:{},ngContentIndex:-1,childCount:0,bindings:o,bindingFlags:Un(o),outputs:[],element:null,provider:null,text:null,query:null,ngContent:null}}(0,e,r)}function pa(e,t,n){const o=new Array(n.length-1);for(let e=1;e<n.length;e++)o[e-1]={flags:8,name:null,ns:null,nonMinifiedName:null,securityContext:null,suffix:n[e]};return{nodeIndex:-1,parent:null,renderParent:null,bindingIndex:-1,outputIndex:-1,checkIndex:e,flags:2,childFlags:0,directChildFlags:0,childMatchedQueries:0,matchedQueries:{},matchedQueryIds:0,references:{},ngContentIndex:t,childCount:0,bindings:o,bindingFlags:8,outputs:[],element:null,provider:null,text:{prefix:n[0]},query:null,ngContent:null}}function ba(e,t,n){let o;const r=e.renderer;o=r.createText(n.text.prefix);const a=On(e,t,n);return a&&r.appendChild(a,o),{renderText:o}}function ha(e,t){return(null!=e?e.toString():"")+t.suffix}function ga(e,t,n,o){let r=0,a=0,i=0,l=0,s=0,c=null,f=null,d=!1,u=!1,m=null;for(let e=0;e<t.length;e++){const n=t[e];if(n.nodeIndex=e,n.parent=c,n.bindingIndex=r,n.outputIndex=a,n.renderParent=f,i|=n.flags,s|=n.matchedQueryIds,n.element){const e=n.element;e.publicProviders=c?c.element.publicProviders:Object.create(null),e.allProviders=e.publicProviders,d=!1,u=!1,n.element.template&&(s|=n.element.template.nodeMatchedQueries)}if(wa(c,n,t.length),r+=n.bindings.length,a+=n.outputs.length,!f&&3&n.flags&&(m=n),20224&n.flags){d||(d=!0,c.element.publicProviders=Object.create(c.element.publicProviders),c.element.allProviders=c.element.publicProviders);const e=!!(32768&n.flags);8192&n.flags&&!e?(u||(u=!0,c.element.allProviders=Object.create(c.element.publicProviders)),c.element.allProviders[yn(n.provider.token)]=n):c.element.publicProviders[yn(n.provider.token)]=n,e&&(c.element.componentProvider=n)}if(c?(c.childFlags|=n.flags,c.directChildFlags|=n.flags,c.childMatchedQueries|=n.matchedQueryIds,n.element&&n.element.template&&(c.childMatchedQueries|=n.element.template.nodeMatchedQueries)):l|=n.flags,n.childCount>0)c=n,xa(n)||(f=n);else for(;c&&e===c.nodeIndex+c.childCount;){const e=c.parent;e&&(e.childFlags|=c.childFlags,e.childMatchedQueries|=c.childMatchedQueries),c=e,f=c&&xa(c)?c.renderParent:c}}return{factory:null,nodeFlags:i,rootNodeFlags:l,nodeMatchedQueries:s,flags:e,nodes:t,updateDirectives:n||xn,updateRenderer:o||xn,handleEvent:(e,n,o,r)=>t[n].element.handleEvent(e,o,r),bindingCount:r,outputCount:a,lastRenderRootNode:m}}function xa(e){return!!(1&e.flags)&&null===e.element.name}function wa(e,t,n){const o=t.element&&t.element.template;if(o){if(!o.lastRenderRootNode)throw new Error("Illegal State: Embedded templates without nodes are not allowed!");if(o.lastRenderRootNode&&16777216&o.lastRenderRootNode.flags)throw new Error(`Illegal State: Last root node of a template can't have embedded views, at index ${t.nodeIndex}!`)}if(20224&t.flags&&!(1&(e?e.flags:0)))throw new Error(`Illegal State: StaticProvider/Directive nodes need to be children of elements or anchors, at index ${t.nodeIndex}!`);if(t.query){if(67108864&t.flags&&(!e||!(16384&e.flags)))throw new Error(`Illegal State: Content Query nodes need to be children of directives, at index ${t.nodeIndex}!`);if(134217728&t.flags&&e)throw new Error(`Illegal State: View Query nodes have to be top level nodes, at index ${t.nodeIndex}!`)}if(t.childCount){const o=e?e.nodeIndex+e.childCount:n-1;if(t.nodeIndex<=o&&t.nodeIndex+t.childCount>o)throw new Error(`Illegal State: childCount of node leads outside of parent, at index ${t.nodeIndex}!`)}}function ya(e,t,n,o){const r=_a(e.root,e.renderer,e,t,n);return Ca(r,e.component,o),Ea(r),r}function va(e,t,n){const o=_a(e,e.renderer,null,null,t);return Ca(o,n,n),Ea(o),o}function ka(e,t,n,o){const r=t.element.componentRendererType;let a;return a=r?e.root.rendererFactory.createRenderer(o,r):e.root.renderer,_a(e.root,a,e,t.element.componentProvider,n)}function _a(e,t,n,o,r){const a=new Array(r.nodes.length),i=r.outputCount?new Array(r.outputCount):null;return{def:r,parent:n,viewContainerParent:null,parentNodeDef:o,context:null,component:null,nodes:a,state:13,root:e,renderer:t,oldValues:new Array(r.bindingCount),disposables:i,initIndex:-1}}function Ca(e,t,n){e.component=t,e.context=n}function Ea(e){let t;Dn(e)&&(t=mn(e.parent,e.parentNodeDef.parent.nodeIndex).renderElement);const n=e.def,o=e.nodes;for(let r=0;r<n.nodes.length;r++){const a=n.nodes[r];let i;switch(gn.setCurrentNode(e,r),201347067&a.flags){case 1:const n=oa(e,t,a);let l;if(33554432&a.flags){const t=Pn(a.element.componentView);l=gn.createComponentView(e,a,t,n)}ra(e,l,a,n),i={renderElement:n,componentView:l,viewContainer:null,template:a.element.template?mo(e,a):void 0},16777216&a.flags&&(i.viewContainer=so(e,a,i));break;case 2:i=ba(e,t,a);break;case 512:case 1024:case 2048:case 256:i=o[r],i||4096&a.flags||(i={instance:Mo(e,a)});break;case 16:i={instance:Fo(e,a)};break;case 16384:i=o[r],i||(i={instance:zo(e,a)}),32768&a.flags&&Ca(mn(e,a.parent.nodeIndex).componentView,i.instance,i.instance);break;case 32:case 64:case 128:i={value:void 0};break;case 67108864:case 134217728:i=new Xo;break;case 8:ua(e,t,a),i=void 0}o[r]=i}za(e,Fa.CreateViewNodes),Pa(e,201326592,268435456,0)}function Ta(e){ja(e),gn.updateDirectives(e,1),Aa(e,Fa.CheckNoChanges),gn.updateRenderer(e,1),za(e,Fa.CheckNoChanges),e.state&=-97}function Sa(e){1&e.state?(e.state&=-2,e.state|=2):e.state&=-3,fn(e,0,256),ja(e),gn.updateDirectives(e,0),Aa(e,Fa.CheckAndUpdate),Pa(e,67108864,536870912,0);let t=fn(e,256,512);qo(e,2097152|(t?1048576:0)),gn.updateRenderer(e,0),za(e,Fa.CheckAndUpdate),Pa(e,134217728,536870912,0),t=fn(e,512,768),qo(e,8388608|(t?4194304:0)),2&e.def.flags&&(e.state&=-9),e.state&=-97,fn(e,768,1024)}function Na(e,t,n,o,r,a,i,l,s,c,f,d,u){return 0===n?function(e,t,n,o,r,a,i,l,s,c,f,d){switch(201347067&t.flags){case 1:return function(e,t,n,o,r,a,i,l,s,c,f,d){const u=t.bindings.length;let m=!1;return u>0&&ia(e,t,0,n)&&(m=!0),u>1&&ia(e,t,1,o)&&(m=!0),u>2&&ia(e,t,2,r)&&(m=!0),u>3&&ia(e,t,3,a)&&(m=!0),u>4&&ia(e,t,4,i)&&(m=!0),u>5&&ia(e,t,5,l)&&(m=!0),u>6&&ia(e,t,6,s)&&(m=!0),u>7&&ia(e,t,7,c)&&(m=!0),u>8&&ia(e,t,8,f)&&(m=!0),u>9&&ia(e,t,9,d)&&(m=!0),m}(e,t,n,o,r,a,i,l,s,c,f,d);case 2:return function(e,t,n,o,r,a,i,l,s,c,f,d){let u=!1;const m=t.bindings,p=m.length;if(p>0&&_n(e,t,0,n)&&(u=!0),p>1&&_n(e,t,1,o)&&(u=!0),p>2&&_n(e,t,2,r)&&(u=!0),p>3&&_n(e,t,3,a)&&(u=!0),p>4&&_n(e,t,4,i)&&(u=!0),p>5&&_n(e,t,5,l)&&(u=!0),p>6&&_n(e,t,6,s)&&(u=!0),p>7&&_n(e,t,7,c)&&(u=!0),p>8&&_n(e,t,8,f)&&(u=!0),p>9&&_n(e,t,9,d)&&(u=!0),u){let u=t.text.prefix;p>0&&(u+=ha(n,m[0])),p>1&&(u+=ha(o,m[1])),p>2&&(u+=ha(r,m[2])),p>3&&(u+=ha(a,m[3])),p>4&&(u+=ha(i,m[4])),p>5&&(u+=ha(l,m[5])),p>6&&(u+=ha(s,m[6])),p>7&&(u+=ha(c,m[7])),p>8&&(u+=ha(f,m[8])),p>9&&(u+=ha(d,m[9]));const b=un(e,t.nodeIndex).renderText;e.renderer.setValue(b,u)}return u}(e,t,n,o,r,a,i,l,s,c,f,d);case 16384:return function(e,t,n,o,r,a,i,l,s,c,f,d){const u=pn(e,t.nodeIndex),m=u.instance;let p,b=!1;const h=t.bindings.length;return h>0&&kn(e,t,0,n)&&(b=!0,p=Vo(e,u,t,0,n,p)),h>1&&kn(e,t,1,o)&&(b=!0,p=Vo(e,u,t,1,o,p)),h>2&&kn(e,t,2,r)&&(b=!0,p=Vo(e,u,t,2,r,p)),h>3&&kn(e,t,3,a)&&(b=!0,p=Vo(e,u,t,3,a,p)),h>4&&kn(e,t,4,i)&&(b=!0,p=Vo(e,u,t,4,i,p)),h>5&&kn(e,t,5,l)&&(b=!0,p=Vo(e,u,t,5,l,p)),h>6&&kn(e,t,6,s)&&(b=!0,p=Vo(e,u,t,6,s,p)),h>7&&kn(e,t,7,c)&&(b=!0,p=Vo(e,u,t,7,c,p)),h>8&&kn(e,t,8,f)&&(b=!0,p=Vo(e,u,t,8,f,p)),h>9&&kn(e,t,9,d)&&(b=!0,p=Vo(e,u,t,9,d,p)),p&&m.ngOnChanges(p),65536&t.flags&&dn(e,256,t.nodeIndex)&&m.ngOnInit(),262144&t.flags&&m.ngDoCheck(),b}(e,t,n,o,r,a,i,l,s,c,f,d);case 32:case 64:case 128:return function(e,t,n,o,r,a,i,l,s,c,f,d){const u=t.bindings;let m=!1;const p=u.length;if(p>0&&_n(e,t,0,n)&&(m=!0),p>1&&_n(e,t,1,o)&&(m=!0),p>2&&_n(e,t,2,r)&&(m=!0),p>3&&_n(e,t,3,a)&&(m=!0),p>4&&_n(e,t,4,i)&&(m=!0),p>5&&_n(e,t,5,l)&&(m=!0),p>6&&_n(e,t,6,s)&&(m=!0),p>7&&_n(e,t,7,c)&&(m=!0),p>8&&_n(e,t,8,f)&&(m=!0),p>9&&_n(e,t,9,d)&&(m=!0),m){const m=bn(e,t.nodeIndex);let b;switch(201347067&t.flags){case 32:b=new Array(u.length),p>0&&(b[0]=n),p>1&&(b[1]=o),p>2&&(b[2]=r),p>3&&(b[3]=a),p>4&&(b[4]=i),p>5&&(b[5]=l),p>6&&(b[6]=s),p>7&&(b[7]=c),p>8&&(b[8]=f),p>9&&(b[9]=d);break;case 64:b={},p>0&&(b[u[0].name]=n),p>1&&(b[u[1].name]=o),p>2&&(b[u[2].name]=r),p>3&&(b[u[3].name]=a),p>4&&(b[u[4].name]=i),p>5&&(b[u[5].name]=l),p>6&&(b[u[6].name]=s),p>7&&(b[u[7].name]=c),p>8&&(b[u[8].name]=f),p>9&&(b[u[9].name]=d);break;case 128:const e=n;switch(p){case 1:b=e.transform(n);break;case 2:b=e.transform(o);break;case 3:b=e.transform(o,r);break;case 4:b=e.transform(o,r,a);break;case 5:b=e.transform(o,r,a,i);break;case 6:b=e.transform(o,r,a,i,l);break;case 7:b=e.transform(o,r,a,i,l,s);break;case 8:b=e.transform(o,r,a,i,l,s,c);break;case 9:b=e.transform(o,r,a,i,l,s,c,f);break;case 10:b=e.transform(o,r,a,i,l,s,c,f,d)}}m.value=b}return m}(e,t,n,o,r,a,i,l,s,c,f,d);default:throw"unreachable"}}(e,t,o,r,a,i,l,s,c,f,d,u):function(e,t,n){switch(201347067&t.flags){case 1:return function(e,t,n){let o=!1;for(let r=0;r<n.length;r++)ia(e,t,r,n[r])&&(o=!0);return o}(e,t,n);case 2:return function(e,t,n){const o=t.bindings;let r=!1;for(let o=0;o<n.length;o++)_n(e,t,o,n[o])&&(r=!0);if(r){let r="";for(let e=0;e<n.length;e++)r+=ha(n[e],o[e]);r=t.text.prefix+r;const a=un(e,t.nodeIndex).renderText;e.renderer.setValue(a,r)}return r}(e,t,n);case 16384:return function(e,t,n){const o=pn(e,t.nodeIndex),r=o.instance;let a,i=!1;for(let r=0;r<n.length;r++)kn(e,t,r,n[r])&&(i=!0,a=Vo(e,o,t,r,n[r],a));return a&&r.ngOnChanges(a),65536&t.flags&&dn(e,256,t.nodeIndex)&&r.ngOnInit(),262144&t.flags&&r.ngDoCheck(),i}(e,t,n);case 32:case 64:case 128:return function(e,t,n){const o=t.bindings;let r=!1;for(let o=0;o<n.length;o++)_n(e,t,o,n[o])&&(r=!0);if(r){const r=bn(e,t.nodeIndex);let a;switch(201347067&t.flags){case 32:a=n;break;case 64:a={};for(let e=0;e<n.length;e++)a[o[e].name]=n[e];break;case 128:const e=n[0],t=n.slice(1);a=e.transform(...t)}r.value=a}return r}(e,t,n);default:throw"unreachable"}}(e,t,o)}function ja(e){const t=e.def;if(4&t.nodeFlags)for(let n=0;n<t.nodes.length;n++){const o=t.nodes[n];if(4&o.flags){const t=mn(e,n).template._projectedViews;if(t)for(let n=0;n<t.length;n++){const o=t[n];o.state|=32,Tn(o,e)}}else!(4&o.childFlags)&&(n+=o.childCount)}}function Ia(e,t,n,o,r,a,i,l,s,c,f,d,u){return 0===n?function(e,t,n,o,r,a,i,l,s,c,f,d){const u=t.bindings.length;u>0&&Cn(e,t,0,n),u>1&&Cn(e,t,1,o),u>2&&Cn(e,t,2,r),u>3&&Cn(e,t,3,a),u>4&&Cn(e,t,4,i),u>5&&Cn(e,t,5,l),u>6&&Cn(e,t,6,s),u>7&&Cn(e,t,7,c),u>8&&Cn(e,t,8,f),u>9&&Cn(e,t,9,d)}(e,t,o,r,a,i,l,s,c,f,d,u):function(e,t,n){for(let o=0;o<n.length;o++)Cn(e,t,o,n[o])}(e,t,o),!1}function Da(e,t){if(hn(e,t.nodeIndex).dirty)throw ln(gn.createDebugContext(e,t.nodeIndex),`Query ${t.query.id} not dirty`,`Query ${t.query.id} dirty`,!!(1&e.state))}function Ma(e){if(!(128&e.state)){if(Aa(e,Fa.Destroy),za(e,Fa.Destroy),qo(e,131072),e.disposables)for(let t=0;t<e.disposables.length;t++)e.disposables[t]();!function(e){if(!(16&e.state))return;const t=Nn(e);if(t){const n=t.template._projectedViews;n&&(ke(n,n.indexOf(e)),gn.dirtyParentQueries(e))}}(e),e.renderer.destroyNode&&function(e){const t=e.def.nodes.length;for(let n=0;n<t;n++){const t=e.def.nodes[n];1&t.flags?e.renderer.destroyNode(mn(e,n).renderElement):2&t.flags?e.renderer.destroyNode(un(e,n).renderText):(67108864&t.flags||134217728&t.flags)&&hn(e,n).destroy()}}(e),Dn(e)&&e.renderer.destroy(),e.state|=128}}const Fa=function(){var e={CreateViewNodes:0,CheckNoChanges:1,CheckNoChangesProjectedViews:2,CheckAndUpdate:3,CheckAndUpdateProjectedViews:4,Destroy:5};return e[e.CreateViewNodes]="CreateViewNodes",e[e.CheckNoChanges]="CheckNoChanges",e[e.CheckNoChangesProjectedViews]="CheckNoChangesProjectedViews",e[e.CheckAndUpdate]="CheckAndUpdate",e[e.CheckAndUpdateProjectedViews]="CheckAndUpdateProjectedViews",e[e.Destroy]="Destroy",e}();function za(e,t){const n=e.def;if(33554432&n.nodeFlags)for(let o=0;o<n.nodes.length;o++){const r=n.nodes[o];33554432&r.flags?Oa(mn(e,o).componentView,t):!(33554432&r.childFlags)&&(o+=r.childCount)}}function Aa(e,t){const n=e.def;if(16777216&n.nodeFlags)for(let o=0;o<n.nodes.length;o++){const r=n.nodes[o];if(16777216&r.flags){const n=mn(e,o).viewContainer._embeddedViews;for(let e=0;e<n.length;e++)Oa(n[e],t)}else!(16777216&r.childFlags)&&(o+=r.childCount)}}function Oa(e,t){const n=e.state;switch(t){case Fa.CheckNoChanges:!(128&n)&&(12&~n?64&n&&Ra(e,Fa.CheckNoChangesProjectedViews):Ta(e));break;case Fa.CheckNoChangesProjectedViews:!(128&n)&&(32&n?Ta(e):64&n&&Ra(e,t));break;case Fa.CheckAndUpdate:!(128&n)&&(12&~n?64&n&&Ra(e,Fa.CheckAndUpdateProjectedViews):Sa(e));break;case Fa.CheckAndUpdateProjectedViews:!(128&n)&&(32&n?Sa(e):64&n&&Ra(e,t));break;case Fa.Destroy:Ma(e);break;case Fa.CreateViewNodes:Ea(e)}}function Ra(e,t){Aa(e,t),za(e,t)}function Pa(e,t,n,o){if(!(e.def.nodeFlags&t&&e.def.nodeFlags&n))return;const r=e.def.nodes.length;for(let a=0;a<r;a++){const r=e.def.nodes[a];if(r.flags&t&&r.flags&n)switch(gn.setCurrentNode(e,r.nodeIndex),o){case 0:ca(e,r);break;case 1:Da(e,r)}r.childFlags&t&&r.childFlags&n||(a+=r.childCount)}}let La=!1;function Ha(e,t,n,o,r,a){const i=r.injector.get(Ot);return va(qa(e,r,i,t,n),o,a)}function Va(e,t,n,o,r,a){const i=r.injector.get(Ot),l=qa(e,r,new yi(i),t,n),s=Xa(o);return xi(ri.create,va,null,[l,s,a])}function qa(e,t,n,o,r){const a=t.injector.get(et),i=t.injector.get(Ne),l=n.createRenderer(null,null);return{ngModule:t,injector:e,projectableNodes:o,selectorOrNode:r,sanitizer:a,rendererFactory:n,renderer:l,errorHandler:i}}function Za(e,t,n,o){const r=Xa(n);return xi(ri.create,ya,null,[e,t,r,o])}function Ba(e,t,n,o){return n=Wa.get(t.element.componentProvider.provider.token)||Xa(n),xi(ri.create,ka,null,[e,t,n,o])}function $a(e,t,n,o){return wo(e,t,n,function(e){const{hasOverrides:t,hasDeprecatedOverrides:n}=function(e){let t=!1,n=!1;return 0===Ua.size||(e.providers.forEach(e=>{const o=Ua.get(e.token);3840&e.flags&&o&&(t=!0,n=n||o.deprecatedBehavior)}),e.modules.forEach(e=>{Qa.forEach((o,r)=>{ee(r).providedIn===e&&(t=!0,n=n||o.deprecatedBehavior)})})),{hasOverrides:t,hasDeprecatedOverrides:n}}(e);return t?(function(e){for(let t=0;t<e.providers.length;t++){const o=e.providers[t];n&&(o.flags|=4096);const r=Ua.get(o.token);r&&(o.flags=-3841&o.flags|r.flags,o.deps=An(r.deps),o.value=r.value)}if(Qa.size>0){let t=new Set(e.modules);Qa.forEach((o,r)=>{if(t.has(ee(r).providedIn)){let t={token:r,flags:o.flags|(n?4096:0),deps:An(o.deps),value:o.value,index:e.providers.length};e.providers.push(t),e.providersByKey[yn(r)]=t}})}}(e=e.factory(()=>xn)),e):e}(o))}const Ua=new Map,Qa=new Map,Wa=new Map;function Ga(e){let t;Ua.set(e.token,e),"function"==typeof e.token&&(t=ee(e.token))&&"function"==typeof t.providedIn&&Qa.set(e.token,e)}function Ya(e,t){const n=Pn(t.viewDefFactory),o=Pn(n.nodes[0].element.componentView);Wa.set(e,o)}function Ka(){Ua.clear(),Qa.clear(),Wa.clear()}function Xa(e){if(0===Ua.size)return e;const t=function(e){const t=[];let n=null;for(let o=0;o<e.nodes.length;o++){const r=e.nodes[o];1&r.flags&&(n=r),n&&3840&r.flags&&Ua.has(r.provider.token)&&(t.push(n.nodeIndex),n=null)}return t}(e);if(0===t.length)return e;e=e.factory(()=>xn);for(let o=0;o<t.length;o++)n(e,t[o]);return e;function n(e,t){for(let n=t+1;n<e.nodes.length;n++){const t=e.nodes[n];if(1&t.flags)return;if(3840&t.flags){const e=t.provider,n=Ua.get(e.token);n&&(t.flags=-3841&t.flags|n.flags,e.deps=An(n.deps),e.value=n.value)}}}}function Ja(e,t,n,o,r,a,i,l,s,c,f,d,u){const m=e.def.nodes[t];return Na(e,m,n,o,r,a,i,l,s,c,f,d,u),224&m.flags?bn(e,t).value:void 0}function ei(e,t,n,o,r,a,i,l,s,c,f,d,u){const m=e.def.nodes[t];return Ia(e,m,n,o,r,a,i,l,s,c,f,d,u),224&m.flags?bn(e,t).value:void 0}function ti(e){return xi(ri.detectChanges,Sa,null,[e])}function ni(e){return xi(ri.checkNoChanges,Ta,null,[e])}function oi(e){return xi(ri.destroy,Ma,null,[e])}const ri=function(){var e={create:0,detectChanges:1,checkNoChanges:2,destroy:3,handleEvent:4};return e[e.create]="create",e[e.detectChanges]="detectChanges",e[e.checkNoChanges]="checkNoChanges",e[e.destroy]="destroy",e[e.handleEvent]="handleEvent",e}();let ai,ii,li;function si(e,t){ii=e,li=t}function ci(e,t,n,o){return si(e,t),xi(ri.handleEvent,e.def.handleEvent,null,[e,t,n,o])}function fi(e,t){if(128&e.state)throw cn(ri[ai]);return si(e,pi(e,0)),e.def.updateDirectives(function(e,n,o,...r){const a=e.def.nodes[n];return 0===t?ui(e,a,o,r):mi(e,a,o,r),16384&a.flags&&si(e,pi(e,n)),224&a.flags?bn(e,a.nodeIndex).value:void 0},e)}function di(e,t){if(128&e.state)throw cn(ri[ai]);return si(e,bi(e,0)),e.def.updateRenderer(function(e,n,o,...r){const a=e.def.nodes[n];return 0===t?ui(e,a,o,r):mi(e,a,o,r),3&a.flags&&si(e,bi(e,n)),224&a.flags?bn(e,a.nodeIndex).value:void 0},e)}function ui(e,t,n,o){if(Na(e,t,n,...o)){const i=1===n?o[0]:o;if(16384&t.flags){const n={};for(let e=0;e<t.bindings.length;e++){const o=t.bindings[e],l=i[e];8&o.flags&&(n[r=o.nonMinifiedName,a=void 0,a=r.replace(/[$@]/g,"_"),`ng-reflect-${r=a.replace(ot,(...e)=>"-"+e[1].toLowerCase())}`]=rt(l))}const o=t.parent,l=mn(e,o.nodeIndex).renderElement;if(o.element.name)for(let t in n){const o=n[t];null!=o?e.renderer.setAttribute(l,t,o):e.renderer.removeAttribute(l,t)}else e.renderer.setValue(l,`bindings=${JSON.stringify(n,null,2)}`)}}var r,a}function mi(e,t,n,o){Ia(e,t,n,...o)}function pi(e,t){for(let n=t;n<e.def.nodes.length;n++){const t=e.def.nodes[n];if(16384&t.flags&&t.bindings&&t.bindings.length)return n}return null}function bi(e,t){for(let n=t;n<e.def.nodes.length;n++){const t=e.def.nodes[n];if(3&t.flags&&t.bindings&&t.bindings.length)return n}return null}class hi{constructor(e,t){this.view=e,this.nodeIndex=t,null==t&&(this.nodeIndex=t=0),this.nodeDef=e.def.nodes[t];let n=this.nodeDef,o=e;for(;n&&!(1&n.flags);)n=n.parent;if(!n)for(;!n&&o;)n=jn(o),o=o.parent;this.elDef=n,this.elView=o}get elOrCompView(){return mn(this.elView,this.elDef.nodeIndex).componentView||this.view}get injector(){return bo(this.elView,this.elDef)}get component(){return this.elOrCompView.component}get context(){return this.elOrCompView.context}get providerTokens(){const e=[];if(this.elDef)for(let t=this.elDef.nodeIndex+1;t<=this.elDef.nodeIndex+this.elDef.childCount;t++){const n=this.elView.def.nodes[t];20224&n.flags&&e.push(n.provider.token),t+=n.childCount}return e}get references(){const e={};if(this.elDef){gi(this.elView,this.elDef,e);for(let t=this.elDef.nodeIndex+1;t<=this.elDef.nodeIndex+this.elDef.childCount;t++){const n=this.elView.def.nodes[t];20224&n.flags&&gi(this.elView,n,e),t+=n.childCount}}return e}get componentRenderElement(){const e=function(e){for(;e&&!Dn(e);)e=e.parent;return e.parent?mn(e.parent,jn(e).nodeIndex):null}(this.elOrCompView);return e?e.renderElement:void 0}get renderNode(){return 2&this.nodeDef.flags?In(this.view,this.nodeDef):In(this.elView,this.elDef)}logError(e,...t){let n,o;2&this.nodeDef.flags?(n=this.view.def,o=this.nodeDef.nodeIndex):(n=this.elView.def,o=this.elDef.nodeIndex);const r=function(e,t){let n=-1;for(let o=0;o<=t;o++)3&e.nodes[o].flags&&n++;return n}(n,o);let a=-1;n.factory(()=>(a++,a===r?e.error.bind(e,...t):xn)),a<r&&(e.error("Illegal state: the ViewDefinitionFactory did not call the logger!"),e.error(...t))}}function gi(e,t,n){for(let o in t.references)n[o]=da(e,t,t.references[o])}function xi(e,t,n,o){const r=ai,a=ii,i=li;try{ai=e;const l=t.apply(n,o);return ii=a,li=i,ai=r,l}catch(e){if(Ee(e)||!ii)throw e;throw function(e,t){return e instanceof Error||(e=new Error(e.toString())),sn(e,t),e}(e,wi())}}function wi(){return ii?new hi(ii,li):null}class yi{constructor(e){this.delegate=e}createRenderer(e,t){return new vi(this.delegate.createRenderer(e,t))}begin(){this.delegate.begin&&this.delegate.begin()}end(){this.delegate.end&&this.delegate.end()}whenRenderingDone(){return this.delegate.whenRenderingDone?this.delegate.whenRenderingDone():Promise.resolve(null)}}class vi{constructor(e){this.delegate=e,this.debugContextFactory=wi,this.data=this.delegate.data}createDebugContext(e){return this.debugContextFactory(e)}destroyNode(e){const t=Qr(e);!function(e){Ur.delete(e.nativeNode)}(t),t instanceof Br&&(t.listeners.length=0),this.delegate.destroyNode&&this.delegate.destroyNode(e)}destroy(){this.delegate.destroy()}createElement(e,t){const n=this.delegate.createElement(e,t),o=this.createDebugContext(n);if(o){const t=new $r(n,null,o);t.name=e,Wr(t)}return n}createComment(e){const t=this.delegate.createComment(e),n=this.createDebugContext(t);return n&&Wr(new Br(t,null,n)),t}createText(e){const t=this.delegate.createText(e),n=this.createDebugContext(t);return n&&Wr(new Br(t,null,n)),t}appendChild(e,t){const n=Qr(e),o=Qr(t);n&&o&&n instanceof $r&&n.addChild(o),this.delegate.appendChild(e,t)}insertBefore(e,t,n){const o=Qr(e),r=Qr(t),a=Qr(n);o&&r&&o instanceof $r&&o.insertBefore(a,r),this.delegate.insertBefore(e,t,n)}removeChild(e,t){const n=Qr(e),o=Qr(t);n&&o&&n instanceof $r&&n.removeChild(o),this.delegate.removeChild(e,t)}selectRootElement(e,t){const n=this.delegate.selectRootElement(e,t),o=wi();return o&&Wr(new $r(n,null,o)),n}setAttribute(e,t,n,o){const r=Qr(e);r&&r instanceof $r&&(r.attributes[o?o+":"+t:t]=n),this.delegate.setAttribute(e,t,n,o)}removeAttribute(e,t,n){const o=Qr(e);o&&o instanceof $r&&(o.attributes[n?n+":"+t:t]=null),this.delegate.removeAttribute(e,t,n)}addClass(e,t){const n=Qr(e);n&&n instanceof $r&&(n.classes[t]=!0),this.delegate.addClass(e,t)}removeClass(e,t){const n=Qr(e);n&&n instanceof $r&&(n.classes[t]=!1),this.delegate.removeClass(e,t)}setStyle(e,t,n,o){const r=Qr(e);r&&r instanceof $r&&(r.styles[t]=n),this.delegate.setStyle(e,t,n,o)}removeStyle(e,t,n){const o=Qr(e);o&&o instanceof $r&&(o.styles[t]=null),this.delegate.removeStyle(e,t,n)}setProperty(e,t,n){const o=Qr(e);o&&o instanceof $r&&(o.properties[t]=n),this.delegate.setProperty(e,t,n)}listen(e,t,n){if("string"!=typeof e){const o=Qr(e);o&&o.listeners.push(new Zr(t,n))}return this.delegate.listen(e,t,n)}parentNode(e){return this.delegate.parentNode(e)}nextSibling(e){return this.delegate.nextSibling(e)}setValue(e,t){return this.delegate.setValue(e,t)}}class ki extends class{}{constructor(e,t,n){super(),this.moduleType=e,this._bootstrapComponents=t,this._ngModuleDefFactory=n}create(e){!function(){if(La)return;La=!0;const e=De()?{setCurrentNode:si,createRootView:Va,createEmbeddedView:Za,createComponentView:Ba,createNgModuleRef:$a,overrideProvider:Ga,overrideComponentView:Ya,clearOverrides:Ka,checkAndUpdateView:ti,checkNoChangesView:ni,destroyView:oi,createDebugContext:(e,t)=>new hi(e,t),handleEvent:ci,updateDirectives:fi,updateRenderer:di}:{setCurrentNode:()=>{},createRootView:Ha,createEmbeddedView:ya,createComponentView:ka,createNgModuleRef:wo,overrideProvider:xn,overrideComponentView:xn,clearOverrides:xn,checkAndUpdateView:Sa,checkNoChangesView:Ta,destroyView:Ma,createDebugContext:(e,t)=>new hi(e,t),handleEvent:(e,t,n,o)=>e.def.handleEvent(e,t,n,o),updateDirectives:(e,t)=>e.def.updateDirectives(0===t?Ja:ei,e),updateRenderer:(e,t)=>e.def.updateRenderer(0===t?Ja:ei,e)};gn.setCurrentNode=e.setCurrentNode,gn.createRootView=e.createRootView,gn.createEmbeddedView=e.createEmbeddedView,gn.createComponentView=e.createComponentView,gn.createNgModuleRef=e.createNgModuleRef,gn.overrideProvider=e.overrideProvider,gn.overrideComponentView=e.overrideComponentView,gn.clearOverrides=e.clearOverrides,gn.checkAndUpdateView=e.checkAndUpdateView,gn.checkNoChangesView=e.checkNoChangesView,gn.destroyView=e.destroyView,gn.resolveDep=Lo,gn.createDebugContext=e.createDebugContext,gn.handleEvent=e.handleEvent,gn.updateDirectives=e.updateDirectives,gn.updateRenderer=e.updateRenderer,gn.dirtyParentQueries=sa}();const t=function(e){const t=Array.from(e.providers),n=Array.from(e.modules),o={};for(const t in e.providersByKey)o[t]=e.providersByKey[t];return{factory:e.factory,isRoot:e.isRoot,providers:t,modules:n,providersByKey:o}}(Pn(this._ngModuleDefFactory));return gn.createNgModuleRef(this.moduleType,e||ct.NULL,this._bootstrapComponents,t)}}const _i=(()=>{const e=Element.prototype;return e.matches||e.matchesSelector||e.mozMatchesSelector||e.msMatchesSelector||e.oMatchesSelector||e.webkitMatchesSelector})(),Ci={schedule(e,t){const n=setTimeout(e,t);return()=>clearTimeout(n)},scheduleBeforeRender(e){if("undefined"==typeof window)return Ci.schedule(e,0);if(void 0===window.requestAnimationFrame)return Ci.schedule(e,16);const t=window.requestAnimationFrame(e);return()=>window.cancelAnimationFrame(t)}};function Ei(e,t,n){let o=n;return function(e){return!!e&&e.nodeType===Node.ELEMENT_NODE}(e)&&t.some((t,n)=>!("*"===t||!function(e,t){return _i.call(e,t)}(e,t)||(o=n,0))),o}class Ti{constructor(e,t){this.componentFactory=t.get(It).resolveComponentFactory(e)}create(e){return new Si(this.componentFactory,e)}}class Si{constructor(e,t){this.componentFactory=e,this.injector=t,this.inputChanges=null,this.implementsOnChanges=!1,this.scheduledChangeDetectionFn=null,this.scheduledDestroyFn=null,this.initialInputValues=new Map,this.unchangedInputs=new Set}connect(e){if(null!==this.scheduledDestroyFn)return this.scheduledDestroyFn(),void(this.scheduledDestroyFn=null);this.componentRef||this.initializeComponent(e)}disconnect(){this.componentRef&&null===this.scheduledDestroyFn&&(this.scheduledDestroyFn=Ci.schedule(()=>{this.componentRef&&(this.componentRef.destroy(),this.componentRef=null)},10))}getInputValue(e){return this.componentRef?this.componentRef.instance[e]:this.initialInputValues.get(e)}setInputValue(e,t){var n,o;this.componentRef?((n=t)!==(o=this.getInputValue(e))&&(n==n||o==o)||void 0===t&&this.unchangedInputs.has(e))&&(this.recordInputChange(e,t),this.componentRef.instance[e]=t,this.scheduleDetectChanges()):this.initialInputValues.set(e,t)}initializeComponent(e){const t=ct.create({providers:[],parent:this.injector}),n=function(e,t){const n=e.childNodes,o=t.map(()=>[]);let r=-1;t.some((e,t)=>"*"===e&&(r=t,!0));for(let e=0,a=n.length;e<a;++e){const a=n[e],i=Ei(a,t,r);-1!==i&&o[i].push(a)}return o}(e,this.componentFactory.ngContentSelectors);this.componentRef=this.componentFactory.create(t,n,e),this.implementsOnChanges="function"==typeof this.componentRef.instance.ngOnChanges,this.initializeInputs(),this.initializeOutputs(),this.detectChanges(),this.injector.get(Vr).attachView(this.componentRef.hostView)}initializeInputs(){this.componentFactory.inputs.forEach(({propName:e})=>{this.implementsOnChanges&&this.unchangedInputs.add(e),this.initialInputValues.has(e)&&this.setInputValue(e,this.initialInputValues.get(e))}),this.initialInputValues.clear()}initializeOutputs(){const e=this.componentFactory.outputs.map(({propName:e,templateName:t})=>this.componentRef.instance[e].pipe(M(e=>({name:t,value:e}))));this.events=P(...e)}callNgOnChanges(){if(!this.implementsOnChanges||null===this.inputChanges)return;const e=this.inputChanges;this.inputChanges=null,this.componentRef.instance.ngOnChanges(e)}scheduleDetectChanges(){this.scheduledChangeDetectionFn||(this.scheduledChangeDetectionFn=Ci.scheduleBeforeRender(()=>{this.scheduledChangeDetectionFn=null,this.detectChanges()}))}recordInputChange(e,t){if(this.componentRef&&!this.implementsOnChanges)return;null===this.inputChanges&&(this.inputChanges={});const n=this.inputChanges[e];if(n)return void(n.currentValue=t);const o=this.unchangedInputs.has(e);this.unchangedInputs.delete(e);const r=o?void 0:this.getInputValue(e);this.inputChanges[e]=new Et(r,t,o)}detectChanges(){this.componentRef&&(this.callNgOnChanges(),this.componentRef.changeDetectorRef.detectChanges())}}class Ni extends HTMLElement{constructor(){super(...arguments),this.ngElementEventsSubscription=null}}function ji(e,t){e.forEach(({propName:e})=>{Object.defineProperty(t,e,{get(){return this.ngElementStrategy.getInputValue(e)},set(t){this.ngElementStrategy.setInputValue(e,t)},configurable:!0,enumerable:!0})})}class Ii{constructor(){this.emojiAngry=!1,this.emojiSad=!1,this.emojiMeh=!1,this.emojiYay=!1,this.emojiWow=!1,this.emojiAngryHov=!1,this.emojiSadHov=!1,this.emojiMehHov=!1,this.emojiYayHov=!1,this.emojiWowHov=!1,this.showAttachOverlay=!1,this.showQuestions=!1,this.questionCount=0,this.dynamicWidth=0,this.thanksNote=!1,this.rating=0,this.allQuestions=[],this.invalidTrigger=!1,this.backEndError=!1,this.answered=[],this.questions=[],this.irnSelected="",this.ipnSelected="",this.clientId="",this.clientSecret="",this.techIpn="",this.techPassword="",this.apiKey="",this.totalRes={},this.inProgress=!1,this.screenShotName="",this.descriptionScreenshot="",this.showScreenShot=!0,this.showComments=!0,this.showQuestionsFlag=!0,this.isShow=!0,this.emojiSelected=!0,this.hideBtn=!1,this.access_token="",this.api_secret="",this.showQuestionLink=!0,this.idpFailureCount=10,this.showErrorMsg="",this.applicationQueId="",this.browserLan=window.navigator.languages.toString(),this.pluginDetails=[],this.appLan=sessionStorage.getItem("profil")?JSON.parse(sessionStorage.getItem("profil")).language:"en",this.defaultPluginDetails=[],this.isAuth=!1,this.pluginColor="",this.pluginHeader="",this.loaded=new Yo,this.onHide=new Yo,this.apiUrl="https://apis-dev.renault.com/ufo/v1/",this.baseUrl="",this.element=[{lan:"en",mgs1:"Minimum 10 characters required",mgs2:"Choose lesser than 2MB",mgs3:"Please provide your comments",mgs4:"Answered",mgs5:"Thanks for submitting your feedback!",mgs6:"Powered By"},{lan:"fr",mgs1:"Minimum 10 caractères requis",mgs2:"Choisissez moins de 2MB",mgs3:'Merci d"apporter vos commentaires',mgs4:"Répondue",mgs5:'Merci d"avoir soumis vos commentaires !',mgs6:"Alimenté par"},{lan:"de",mgs1:"Mindestens 10 Zeichen erforderlich",mgs2:"Wählen Sie weniger als 2MB",mg3:"Bitte geben Sie Ihre Kommentare ein",mgs4:"Antwortete",mgs5:"Vielen Dank für Ihr Feedback!",mgs6:"Bereitgestellt von"},{lan:"es",mgs1:"Mínimo 10 caracteres requeridos",mgs2:"Elija menos de 2 MB",mg3:"Por favor proporcione sus comentarios",mg4:"Contestada",mg5:"¡Gracias por enviar sus comentarios!",mg6:"Energizado por"},{lan:"ru",mgs1:"Требуется минимум 10 символов",mgs2:"Выберите менее 2 МБ",mg3:"Пожалуйста, предоставьте свои комментарии",mg4:"Ответил",mg5:"Спасибо за отзыв!",mg6:"Питаться от"},{lan:"ja",mgs1:"最低 10 文字が必要です",mgs2:"2MB未満を選択してください",mg3:"ご意見をお聞かせください",mg4:"答えた",mg5:"フィードバックを送信していただきありがとうございます。",mg6:"搭載"},{lan:"ro",mgs1:"Sunt necesare minimum 10 caractere",mgs2:"Alegeți mai puțin de 2 MB",mg3:"Vă rugăm să furnizați comentariile dvs",mg4:"Răspuns",mg5:"Vă mulțumim pentru feedback-ul trimis!",mg6:"Cu sprijinul"},{lan:"pt",mgs1:"Mínimo 10 caracteres obrigatórios",mgs2:"Escolha menos de 2 MB",mg3:"Forneça seus comentários",mg4:"Respondidos",mg5:"Obrigado por enviar seu feedback!",mg6:"Distribuído por"},{lan:"it",mgs1:"Minimo 10 caratteri richiesti",mgs2:"Scegli meno di 2 MB",mg3:"Si prega di fornire i propri commenti",mg4:"Risposto",mg5:"Grazie per aver inviato il tuo feedback!",mg6:"Offerto da"},{lan:"ko",mgs1:"최소 10자 필요",mgs2:"2MB 미만 선택",mg3:"귀하의 의견을 제공하십시오",mg4:"대답했다",mg5:"피드백을 제출해 주셔서 감사합니다!",mg6:"에 의해 구동"},{lan:"zh",mgs1:"至少需要 10 个字符",mgs2:"选择小于2MB的",mg3:"请提供您的意见",mg4:"已回答",mg5:"感谢您提交反馈！",mg6:"供电"},{lan:"tr",mgs1:"Minimum 10 karakter gerekli",mgs2:"2MB tan küçük olanı seçin",mg3:"Lütfen yorumlarınızı belirtin",mg4:"cevaplandı",mg5:"Geri bildiriminizi gönderdiğiniz için teşekkür ederiz!",mg6:"Tarafından desteklenmektedir"},{lan:"ar",mgs1:"الحد الأدنى المطلوب هو 10 أحرف",mgs2:"اختر أقل من 2 ميغا بايت",mg3:"يرجى تقديم تعليقاتك",mg4:"أجاب",mg5:"شكرا لإرسال ملاحظاتك!",mg6:"مشغل بواسطة"}]}set irn(e){this.irnSelected=e}set ipn(e){this.ipnSelected=e}set client_id(e){this.clientId=e}set client_secret(e){this.clientSecret=e}set tech_ipn(e){this.techIpn=e}set tech_pass(e){this.techPassword=e}set apikey(e){this.apiKey=e}ngOnInit(){}ngAfterViewInit(){if(this.triggerId){const e=document.getElementById(this.triggerId);e&&e.addEventListener("click",()=>{this.showOverlay()})}this.apiKey?this.hitIDP():this.fetchQuestions()}fetchQuestions(){if(this.irnSelected&&this.ipnSelected){const e=this.apiKey?this.apiUrl+"questions":this.baseUrl+"/rest/proxy/apigee/ufo/v1/questions",t=new XMLHttpRequest;t.open("GET",`${e}?irn=${this.irnSelected}&ipn=${this.ipnSelected}&appLan=${this.appLan}`,!0),t.setRequestHeader("Content-Type","application/json"),t.setRequestHeader("Furtive-Latch",this.api_secret),function(){const e=sessionStorage.getItem("ctx");e&&t.setRequestHeader("X-ND-CTX",e)}(),this.apiKey?(t.setRequestHeader("apikey",this.apiKey),t.setRequestHeader("Authorization",this.access_token)):this.isAuth&&t.setRequestHeader("Authorization",this.access_token),t.onreadystatechange=()=>{if(4===t.readyState)if(200===t.status){const e=t.responseText?JSON.parse(t.responseText):"";e&&e.applicationQuestionId?(this.pluginDetails=e.appQuestiondetails,this.allQuestions=e.appQuestions,this.pluginHeader=e.pluginHeader,this.pluginColor=e.pluginColor,this.applicationQueId=e.applicationQuestionId,this.showScreenShot=e.enableScreenshot,this.showComments=e.enableGlobalFeedback,this.showQuestionsFlag=e.enableQuestions,this.showQuestionsFlag||this.showScreenShot||this.showComments||(this.hideBtn=!0),this.totalRes=e,this.loaded.emit(!0),this.defaultPluginDetails=this.element.filter(e=>e.lan==this.pluginDetails[0].language)):(this.pluginDetails=e.appQuestiondetails,this.allQuestions=[],this.applicationQueId="",this.loaded.emit(!1))}else this.pluginDetails=[],this.allQuestions=[],this.applicationQueId="",this.loaded.emit(!1)},t.send()}}changeEmoji(e){this.rating=+e,this.showQuestionLink=!!this.allQuestions.find(e=>e.rating===this.rating),this.emojiSelected=0!==e,this.emojiAngry=this.emojiMeh=this.emojiSad=this.emojiWow=this.emojiYay=!1,this.showQuestionsFlag||this.showScreenShot||this.showComments||this.submit()}changeEmHov(){this.emojiAngryHov=this.emojiMehHov=this.emojiSadHov=this.emojiWowHov=this.emojiYayHov=!1}featureHide(){this.isShow=!1,this.onHide.emit(!0)}showQu(){if(!this.rating)return void(this.invalidTrigger=!0);this.invalidTrigger=!1,this.showQuestions=!0,this.answered=[];const e=this.allQuestions.find(e=>e.rating===this.rating);this.questions=e?e.questions:"",this.questions&&setTimeout(()=>{this.questionsTabTag.nativeElement.addEventListener("scroll",e=>{const t=this.questionsTabTag.nativeElement;if(t){const e=t.getBoundingClientRect(),n=e.top,o=e.bottom;this.questionsTag.forEach(e=>{const t=e.nativeElement.getBoundingClientRect();e.nativeElement.classList.remove("show"),t.top+5>n&&t.top<o+20&&e.nativeElement.classList.add("show")})}})},500)}showOverlay(e){this.showAttachOverlay=!this.showAttachOverlay,this.invalidTrigger=!1,this.showQuestions=!1,this.backEndError=!1,this.dynamicWidth=this.questionCount=0,this.thanksNote=!1,this.showErrorMsg="",this.inProgress=!1,e&&(e.stopImmediatePropagation(),e.preventDefault()),this.changeEmoji(0),this.screenShotName="",this.descriptionScreenshot="",this.screenshot=""}imageConvert(e){const t=e.target.files[0];this.screenShotName=t.name.slice(0,15);let n=new FileReader;n.onloadend=e=>{let t=n.result.split("base64,");t.length>1&&(this.screenshot=t[1])},n.readAsDataURL(t)}splitOptions(e){if(!e)return[];const t=e.split(" ");let n=[];for(let e of t)n=n.concat(e.split("/"));return n}submit(){if(!this.rating||this.inProgress)return;this.backEndError=!1;const e=new XMLHttpRequest,t=this.apiKey?this.apiUrl+"feedbacks?irn="+this.irnSelected:this.baseUrl+"/rest/proxy/apigee/ufo/v1/feedbacks?irn="+this.irnSelected,n={appQuesID:this.totalRes.applicationQuestionId,userIPN:this.ipnSelected,rating:this.rating,answers:this.answered.filter(e=>e),imageData:this.screenshot,fileName:this.screenShotName,userComments:this.descriptionScreenshot};if(e.open("POST",t,!0),e.setRequestHeader("Content-Type","application/json"),e.setRequestHeader("Furtive-Latch",this.api_secret),function(){const t=sessionStorage.getItem("ctx");t&&e.setRequestHeader("X-ND-CTX",t)}(),this.apiKey?(e.setRequestHeader("apikey",this.apiKey),e.setRequestHeader("Authorization",this.access_token)):this.isAuth&&e.setRequestHeader("Authorization",this.access_token),this.inProgress=!0,this.showErrorMsg="",e.onreadystatechange=()=>{4===e.readyState&&201===e.status&&e.responseText&&(this.ipnSelected="")},!this.hideBtn){const e=this.planeTag.nativeElement,t=this.replaceTag.nativeElement;this.planeTag.nativeElement.classList.add("fly"),e.classList.add("visible"),t.classList.remove("fa-paper-plane"),t.classList.add("fa-check-circle"),t.classList.add("nav-center")}this.thanksNote=this.showQuestions=!0,setTimeout(()=>{this.showAttachOverlay=!1,this.fetchQuestions()},2500),this.inProgress=!1,e.onerror=()=>{this.inProgress=!1,this.backEndError=!0},e.send(JSON.stringify(n))}goToNextQues(e,t,n){let o={};o.answer=n.target.value,o.question=e,this.answered[t]=o;const r=this.answered.filter(e=>e.answer),a=this.questionCount=r.length;this.dynamicWidth=a/this.questions.length*100;const i=this.questionsTag.toArray()[t].nativeElement;i&&i.nextElementSibling&&i.nextElementSibling.scrollIntoView({behavior:"smooth",block:"center"})}onSend(e){this.screenShotName=this.ipnSelected+"_"+this.irnSelected+"_"+(new Date).toLocaleString("de-DE",{timeZone:"Europe/Paris"}),this.showAttachOverlay=!0,this.screenshot=e.screenshot,this.isShow=!0}resetScreenshot(){this.screenShotName="",this.screenshot=""}hitIDP(){const e=setTimeout(()=>{clearTimeout(e),this.hitIDP()},1798e3),t=new XMLHttpRequest,n=new URLSearchParams;let o="";o=this.apiUrl.indexOf("apis.renault.com")>0?"https://idp.renault.com/nidp/oauth/nam/token":"https://idp2.renault.com/nidp/oauth/nam/token",n.append("grant_type","password"),n.append("scope","arca"),n.append("username",this.techIpn),n.append("password",this.techPassword),n.append("client_id",this.clientId),n.append("client_secret",this.clientSecret),t.open("POST",o,!0),t.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),t.onreadystatechange=()=>{if(4===t.readyState)if(200===t.status){const e=t.responseText?JSON.parse(t.responseText):"";this.idpFailureCount=10,e?(this.access_token="Bearer "+e.access_token,this.fetchQuestions()):this.backEndError=!0}else this.backEndError=!0},t.onerror=()=>{0!==this.idpFailureCount&&(this.hitIDP(),this.idpFailureCount-=1)},t.send(n)}hidePlugin(){this.isShow=!1,setTimeout(()=>{this.feedbackBtn.nativeElement.click()},100)}}class Di{}class Mi{constructor(e){this.injector=e}ngDoBootstrap(){const e=function(e,t){const n=function(e,t){return t.get(It).resolveComponentFactory(e).inputs}(e,t.injector),o=t.strategyFactory||new Ti(e,t.injector),r=function(e){const t={};return e.forEach(({propName:e,templateName:n})=>{var o;t[o=n,o.replace(/[A-Z]/g,e=>`-${e.toLowerCase()}`)]=e}),t}(n);class a extends Ni{constructor(e){super(),this.injector=e}get ngElementStrategy(){if(!this._ngElementStrategy){const e=this._ngElementStrategy=o.create(this.injector||t.injector),r=n.filter(({propName:e})=>this.hasOwnProperty(e)).map(({propName:e})=>[e,this[e]]);this instanceof a?r.forEach(([e])=>delete this[e]):ji(n,this),r.forEach(([t,n])=>e.setInputValue(t,n))}return this._ngElementStrategy}attributeChangedCallback(e,t,n,o){this.ngElementStrategy.setInputValue(r[e],n)}connectedCallback(){this.ngElementStrategy.connect(this),this.ngElementEventsSubscription=this.ngElementStrategy.events.subscribe(e=>{const t=function(e,t,n){if("function"!=typeof CustomEvent){const o=e.createEvent("CustomEvent");return o.initCustomEvent(t,!1,!1,n),o}return new CustomEvent(t,{bubbles:!1,cancelable:!1,detail:n})}(this.ownerDocument,e.name,e.value);this.dispatchEvent(t)})}disconnectedCallback(){this._ngElementStrategy&&this._ngElementStrategy.disconnect(),this.ngElementEventsSubscription&&(this.ngElementEventsSubscription.unsubscribe(),this.ngElementEventsSubscription=null)}}return a.observedAttributes=Object.keys(r),ji(n,a.prototype),a}(Ii,{injector:this.injector});customElements.define("renault-ng-feedback",e)}}class Fi{}const zi=function(){var e={Zero:0,One:1,Two:2,Few:3,Many:4,Other:5};return e[e.Zero]="Zero",e[e.One]="One",e[e.Two]="Two",e[e.Few]="Few",e[e.Many]="Many",e[e.Other]="Other",e}(),Ai=new de("UseV4Plurals");class Oi{}class Ri extends Oi{constructor(e,t){super(),this.locale=e,this.deprecatedPluralFn=t}getPluralCategory(e,t){switch(this.deprecatedPluralFn?this.deprecatedPluralFn(t||this.locale,e):function(e){return function(e){const t=e.toLowerCase().replace(/_/g,"-");let n=Uo[t];if(n)return n;const o=t.split("-")[0];if(n=Uo[o],n)return n;if("en"===o)return Go;throw new Error(`Missing locale data for the locale "${e}".`)}(e)[Qo.PluralCase]}(t||this.locale)(e)){case zi.Zero:return"zero";case zi.One:return"one";case zi.Two:return"two";case zi.Few:return"few";case zi.Many:return"many";default:return"other"}}}class Pi{}class Li{constructor(e,t,n,o){this._iterableDiffers=e,this._keyValueDiffers=t,this._ngEl=n,this._renderer=o,this._initialClasses=[]}getValue(){return null}setClass(e){this._removeClasses(this._initialClasses),this._initialClasses="string"==typeof e?e.split(/\s+/):[],this._applyClasses(this._initialClasses),this._applyClasses(this._rawClass)}setNgClass(e){this._removeClasses(this._rawClass),this._applyClasses(this._initialClasses),this._iterableDiffer=null,this._keyValueDiffer=null,this._rawClass="string"==typeof e?e.split(/\s+/):e,this._rawClass&&(kt(this._rawClass)?this._iterableDiffer=this._iterableDiffers.find(this._rawClass).create():this._keyValueDiffer=this._keyValueDiffers.find(this._rawClass).create())}applyChanges(){if(this._iterableDiffer){const e=this._iterableDiffer.diff(this._rawClass);e&&this._applyIterableChanges(e)}else if(this._keyValueDiffer){const e=this._keyValueDiffer.diff(this._rawClass);e&&this._applyKeyValueChanges(e)}}_applyKeyValueChanges(e){e.forEachAddedItem(e=>this._toggleClass(e.key,e.currentValue)),e.forEachChangedItem(e=>this._toggleClass(e.key,e.currentValue)),e.forEachRemovedItem(e=>{e.previousValue&&this._toggleClass(e.key,!1)})}_applyIterableChanges(e){e.forEachAddedItem(e=>{if("string"!=typeof e.item)throw new Error(`NgClass can only toggle CSS classes expressed as strings, got ${ne(e.item)}`);this._toggleClass(e.item,!0)}),e.forEachRemovedItem(e=>this._toggleClass(e.item,!1))}_applyClasses(e){e&&(Array.isArray(e)||e instanceof Set?e.forEach(e=>this._toggleClass(e,!0)):Object.keys(e).forEach(t=>this._toggleClass(t,!!e[t])))}_removeClasses(e){e&&(Array.isArray(e)||e instanceof Set?e.forEach(e=>this._toggleClass(e,!1)):Object.keys(e).forEach(e=>this._toggleClass(e,!1)))}_toggleClass(e,t){(e=e.trim())&&e.split(/\s+/g).forEach(e=>{t?this._renderer.addClass(this._ngEl.nativeElement,e):this._renderer.removeClass(this._ngEl.nativeElement,e)})}}let Hi=(()=>{class e{constructor(e){this._delegate=e}getValue(){return this._delegate.getValue()}}return e.ngDirectiveDef=void 0,e})();class Vi extends Hi{constructor(e){super(e)}set klass(e){this._delegate.setClass(e)}set ngClass(e){this._delegate.setNgClass(e)}ngDoCheck(){this._delegate.applyChanges()}}class qi{constructor(e,t,n,o){this.$implicit=e,this.ngForOf=t,this.index=n,this.count=o}get first(){return 0===this.index}get last(){return this.index===this.count-1}get even(){return this.index%2==0}get odd(){return!this.even}}class Zi{constructor(e,t,n){this._viewContainer=e,this._template=t,this._differs=n,this._ngForOfDirty=!0,this._differ=null}set ngForOf(e){this._ngForOf=e,this._ngForOfDirty=!0}set ngForTrackBy(e){De()&&null!=e&&"function"!=typeof e&&console&&console.warn&&console.warn(`trackBy must be a function, but received ${JSON.stringify(e)}. See https://angular.io/docs/ts/latest/api/common/index/NgFor-directive.html#!#change-propagation for more information.`),this._trackByFn=e}get ngForTrackBy(){return this._trackByFn}set ngForTemplate(e){e&&(this._template=e)}ngDoCheck(){if(this._ngForOfDirty){this._ngForOfDirty=!1;const t=this._ngForOf;if(!this._differ&&t)try{this._differ=this._differs.find(t).create(this.ngForTrackBy)}catch(n){throw new Error(`Cannot find a differ supporting object '${t}' of type '${e=t,e.name||typeof e}'. NgFor only supports binding to Iterables such as Arrays.`)}}var e;if(this._differ){const e=this._differ.diff(this._ngForOf);e&&this._applyChanges(e)}}_applyChanges(e){const t=[];e.forEachOperation((e,n,o)=>{if(null==e.previousIndex){const n=this._viewContainer.createEmbeddedView(this._template,new qi(null,this._ngForOf,-1,-1),null===o?void 0:o),r=new Bi(e,n);t.push(r)}else if(null==o)this._viewContainer.remove(null===n?void 0:n);else if(null!==n){const r=this._viewContainer.get(n);this._viewContainer.move(r,o);const a=new Bi(e,r);t.push(a)}});for(let e=0;e<t.length;e++)this._perViewChange(t[e].view,t[e].record);for(let e=0,t=this._viewContainer.length;e<t;e++){const n=this._viewContainer.get(e);n.context.index=e,n.context.count=t,n.context.ngForOf=this._ngForOf}e.forEachIdentityChange(e=>{this._viewContainer.get(e.currentIndex).context.$implicit=e.item})}_perViewChange(e,t){e.context.$implicit=t.item}static ngTemplateContextGuard(e,t){return!0}}class Bi{constructor(e,t){this.record=e,this.view=t}}class $i{constructor(e,t){this._viewContainer=e,this._context=new Ui,this._thenTemplateRef=null,this._elseTemplateRef=null,this._thenViewRef=null,this._elseViewRef=null,this._thenTemplateRef=t}set ngIf(e){this._context.$implicit=this._context.ngIf=e,this._updateView()}set ngIfThen(e){Qi("ngIfThen",e),this._thenTemplateRef=e,this._thenViewRef=null,this._updateView()}set ngIfElse(e){Qi("ngIfElse",e),this._elseTemplateRef=e,this._elseViewRef=null,this._updateView()}_updateView(){this._context.$implicit?this._thenViewRef||(this._viewContainer.clear(),this._elseViewRef=null,this._thenTemplateRef&&(this._thenViewRef=this._viewContainer.createEmbeddedView(this._thenTemplateRef,this._context))):this._elseViewRef||(this._viewContainer.clear(),this._thenViewRef=null,this._elseTemplateRef&&(this._elseViewRef=this._viewContainer.createEmbeddedView(this._elseTemplateRef,this._context)))}}class Ui{constructor(){this.$implicit=null,this.ngIf=null}}function Qi(e,t){if(t&&!t.createEmbeddedView)throw new Error(`${e} must be a TemplateRef, but received '${ne(t)}'.`)}class Wi{constructor(e,t){this._viewContainerRef=e,this._templateRef=t,this._created=!1}create(){this._created=!0,this._viewContainerRef.createEmbeddedView(this._templateRef)}destroy(){this._created=!1,this._viewContainerRef.clear()}enforceState(e){e&&!this._created?this.create():!e&&this._created&&this.destroy()}}class Gi{constructor(){this._defaultUsed=!1,this._caseCount=0,this._lastCaseCheckIndex=0,this._lastCasesMatched=!1}set ngSwitch(e){this._ngSwitch=e,0===this._caseCount&&this._updateDefaultCases(!0)}_addCase(){return this._caseCount++}_addDefault(e){this._defaultViews||(this._defaultViews=[]),this._defaultViews.push(e)}_matchCase(e){const t=e==this._ngSwitch;return this._lastCasesMatched=this._lastCasesMatched||t,this._lastCaseCheckIndex++,this._lastCaseCheckIndex===this._caseCount&&(this._updateDefaultCases(!this._lastCasesMatched),this._lastCaseCheckIndex=0,this._lastCasesMatched=!1),t}_updateDefaultCases(e){if(this._defaultViews&&e!==this._defaultUsed){this._defaultUsed=e;for(let t=0;t<this._defaultViews.length;t++)this._defaultViews[t].enforceState(e)}}}class Yi{constructor(e,t,n){this.ngSwitch=n,n._addCase(),this._view=new Wi(e,t)}ngDoCheck(){this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase))}}class Ki{}class Xi{constructor(e,t,n){this._ngEl=e,this._differs=t,this._renderer=n}getValue(){return null}setNgStyle(e){this._ngStyle=e,!this._differ&&e&&(this._differ=this._differs.find(e).create())}applyChanges(){if(this._differ){const e=this._differ.diff(this._ngStyle);e&&this._applyChanges(e)}}_applyChanges(e){e.forEachRemovedItem(e=>this._setStyle(e.key,null)),e.forEachAddedItem(e=>this._setStyle(e.key,e.currentValue)),e.forEachChangedItem(e=>this._setStyle(e.key,e.currentValue))}_setStyle(e,t){const[n,o]=e.split(".");null!=(t=null!=t&&o?`${t}${o}`:t)?this._renderer.setStyle(this._ngEl.nativeElement,n,t):this._renderer.removeStyle(this._ngEl.nativeElement,n)}}let Ji=(()=>{class e{constructor(e){this._delegate=e}getValue(){return this._delegate.getValue()}}return e.ngDirectiveDef=void 0,e})();class el extends Ji{constructor(e){super(e)}set ngStyle(e){this._delegate.setNgStyle(e)}ngDoCheck(){this._delegate.applyChanges()}}class tl{}const nl=new de("DocumentToken");var ol=function(e){return{id:"$$undefined",styles:e.styles,encapsulation:e.encapsulation,data:e.data}}({encapsulation:3,styles:['@charset "UTF-8";#renaultNgFeedbackContainer .fa-spinner{-webkit-animation:1s linear infinite spin;animation:1s linear infinite spin}#renaultNgFeedbackContainer #provide-header{font-size:16px}#renaultNgFeedbackContainer .btn-warning{font-weight:700;color:#fff}#renaultNgFeedbackContainer .feedbkimg{background:url(assets/svg/newHeader/picto_HAPPY.svg) 0 0/contain no-repeat;height:25px}#renaultNgFeedbackContainer .btn-container{width:100%;position:relative;bottom:0;left:0;z-index:20}#renaultNgFeedbackContainer .btn-container:not(.show-bg){background:#fff!important}#renaultNgFeedbackContainer .btn-container:not(.show-bg) .submit-btn{color:#fff!important}#renaultNgFeedbackContainer .btn-container.show-bg{background:#ffc107}#renaultNgFeedbackContainer .btn-container.show-bg.hide-btn{visibility:hidden}#renaultNgFeedbackContainer .btn-container.show-bg .submit-btn{background-color:#fff!important;color:#ffa000;width:auto;transform:translateX(70%)}#renaultNgFeedbackContainer .btn-container.show-bg .submit-btn:disabled,#renaultNgFeedbackContainer .btn-container.show-bg .submit-btn[disabled]{opacity:.5;cursor:not-allowed}#renaultNgFeedbackContainer .btn-container .plane{position:absolute;right:18px}#renaultNgFeedbackContainer .btn-container .fa-check,#renaultNgFeedbackContainer .btn-container .hidden{display:none}#renaultNgFeedbackContainer .btn-container .visible{display:inline}#renaultNgFeedbackContainer .btn-container .fly{position:absolute;-webkit-animation-name:a;animation-name:a;-webkit-animation-duration:20s;animation-duration:20s;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-delay:0;animation-delay:0}#renaultNgFeedbackContainer .btn-container .done,#renaultNgFeedbackContainer .btn-container .done:hover{background-color:#d4e157}@-webkit-keyframes fade{0%{color:transparent}100%{color:#fff}}@keyframes fade{0%{color:transparent}100%{color:#fff}}@-webkit-keyframes a{0%{top:10px;left:80px}100%{top:-10000px;left:10000px;transform:scale(-5)}}@keyframes a{0%{top:10px;left:80px}100%{top:-10000px;left:10000px;transform:scale(-5)}}#renaultNgFeedbackContainer .btn-container .nav-center{position:absolute;top:-2.6em;left:-.8em;color:green;font-size:3em}#renaultNgFeedbackContainer .thanks-note{position:absolute;top:50%;left:13%;font-weight:700;font-size:16px}#renaultNgFeedbackContainer .card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem;color:#fff!important}#renaultNgFeedbackContainer .card.feedback-btn{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important;margin:0!important}#renaultNgFeedbackContainer .card .card-body{flex:1 1 auto;min-height:1px;padding:1.25rem;font-size:18px}#renaultNgFeedbackContainer .radio-check{position:relative;text-align:center}#renaultNgFeedbackContainer .question-new{margin-bottom:20px;text-align:left;z-index:10;height:inherit;padding-top:14px}#renaultNgFeedbackContainer .question-new .options{margin-left:12px;margin-bottom:15px}#renaultNgFeedbackContainer .question-new .options .textarea-new{height:150px;width:100%;margin-right:25px;resize:none;border:1px solid #000}#renaultNgFeedbackContainer .question-new .question-text{margin-bottom:20px}#renaultNgFeedbackContainer .question-new input{position:absolute;left:0;width:25px;height:25px;opacity:0;margin-right:10px;z-index:20}#renaultNgFeedbackContainer .question-new input:checked+.radio-check{border:0}#renaultNgFeedbackContainer .question-new input:checked+.radio-check:after{content:"✓";width:25px;height:25px;position:absolute;top:0;left:0;border:1px solid transparent;background-color:#02c602;color:#fff;font-weight:700;border-radius:50%}#renaultNgFeedbackContainer .count-question{position:absolute;left:1.5em;bottom:50%;color:#fff}#renaultNgFeedbackContainer .progress-bar{width:120px;height:10px;background-color:transparent!important;transition:width .6s ease-in-out;position:absolute;top:50%;left:20px;border-radius:20px;border:2px solid #fff}#renaultNgFeedbackContainer .progress-bar .fill{position:absolute;height:inherit;width:0;background:#fff}#renaultNgFeedbackContainer .feedback-btn{width:0;border-bottom-left-radius:0;border-bottom-right-radius:0;height:38px;border:0;cursor:pointer}#renaultNgFeedbackContainer .feedback-btn:hover{width:0;background-color:#ffc107!important}#renaultNgFeedbackContainer .feedback-btn.fixed{width:400px;border-bottom-left-radius:0;border-bottom-right-radius:0;height:60px}#renaultNgFeedbackContainer .content{position:fixed;bottom:-380px;right:-350px;box-shadow:-16px 16px 40px 0 rgba(0,0,0,.2);height:380px;z-index:100000;transition:.5s ease-in-out;overflow:hidden}#renaultNgFeedbackContainer .backdrop{position:fixed;top:0;left:0;width:100%;height:100%;opacity:.15;background-color:#000}#renaultNgFeedbackContainer hr{height:2px;width:50%;margin:13px 20px}#renaultNgFeedbackContainer .translateAttach{bottom:0;right:20px;height:auto}#renaultNgFeedbackContainer .footer-error-msg{font-weight:700;color:#fff;background:red}#renaultNgFeedbackContainer .feedback-container{overflow-y:auto;overflow-x:hidden;height:auto;width:400px;border:1px solid rgba(0,0,0,.05);padding:5px 15px;background-color:#fff;font-size:14px}#renaultNgFeedbackContainer .feedback-container.pr-0{padding-right:0;padding-top:0}#renaultNgFeedbackContainer .feedback-container h3{border-bottom:1px solid rgba(0,0,0,.05);padding-bottom:20px}#renaultNgFeedbackContainer .feedback-container .questions-tab{padding-top:20px;height:270px;overflow-y:auto}#renaultNgFeedbackContainer .feedback-container.no-selection{min-height:200px;padding-bottom:0}#renaultNgFeedbackContainer .relative{position:relative;display:flex}#renaultNgFeedbackContainer .radio-check{width:25px;height:25px;background:0 0;border:2px solid #aaa;border-radius:50%;display:inline-block;margin-right:10px}#renaultNgFeedbackContainer .submit-btn{display:inline-block;font-weight:400;text-align:center;vertical-align:middle;cursor:pointer;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:1s ease-in-out,color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;width:180px;height:44px;border-color:#ffc107;color:#fff;background-color:#ffa000;transform:translateX(0)}#renaultNgFeedbackContainer .submit-btn.hide-bg{box-shadow:none!important;border:0!important;background:0 0!important;padding:0;margin:0!important;transition:none}#renaultNgFeedbackContainer .submit-btn:disabled,#renaultNgFeedbackContainer .submit-btn[disabled]{opacity:.5!important;cursor:not-allowed!important}#renaultNgFeedbackContainer .margin-top-16{margin-top:16px}#renaultNgFeedbackContainer .margin-bottom-16{margin-bottom:16px}#renaultNgFeedbackContainer .or-content{color:#aaa}#renaultNgFeedbackContainer .smileys{display:flex;justify-content:space-between}#renaultNgFeedbackContainer .smileys .smiley{position:relative;color:#aaa}#renaultNgFeedbackContainer .smileys .smiley input{height:100%;width:100%;position:absolute;opacity:0;cursor:pointer}#renaultNgFeedbackContainer .smileys .smiley input:hover+.far{font-size:4.5em}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far{color:#ffa000;font-size:4.5em}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far+div{color:#ffa000}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-tired,#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-tired+div{color:red}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-frown,#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-frown+div{color:#f08080}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-grin,#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-grin+div{color:#90ee90}#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-grin-hearts,#renaultNgFeedbackContainer .smileys .smiley input:checked+.far.fa-grin-hearts+div{color:green}#renaultNgFeedbackContainer .smileys .far{color:#aaa;font-size:4em;margin:20px}#renaultNgFeedbackContainer .smileys .emoji{width:120px;height:120px;margin:15px 15px 40px;background:#ffda6a;display:inline-block;border-radius:50%;position:relative;zoom:.4;transform:scale(1,1);transition:transform .5s ease-in-out}#renaultNgFeedbackContainer .smileys .emoji.hovered,#renaultNgFeedbackContainer .smileys .emoji.selected{transform:scale(1.3,1.3)}#renaultNgFeedbackContainer .smileys .emoji input{height:100%;width:100%;position:absolute;opacity:0;left:0;top:0;cursor:pointer;z-index:10}#renaultNgFeedbackContainer .smileys .emoji input:checked+.check{display:block}#renaultNgFeedbackContainer .smileys .emoji .check{display:none;position:absolute;left:0;top:0;height:100%;width:100%;outline:#111 solid 5px;background:rgba(0,0,0,.05)}#renaultNgFeedbackContainer .smileys .emoji .check:after{content:"✓";width:30px;height:30px;position:absolute;top:-16px;right:-16px;border:1px solid transparent;background-color:#02c602;color:#fff;font-weight:700;line-height:2}#renaultNgFeedbackContainer .smileys .emoji:after{position:absolute;bottom:-57px;font-size:24px;width:108px;left:calc(50% - 40px);color:#8a8a8a}#renaultNgFeedbackContainer .smileys .emoji__eyebrows,#renaultNgFeedbackContainer .smileys .emoji__eyes,#renaultNgFeedbackContainer .smileys .emoji__face,#renaultNgFeedbackContainer .smileys .emoji__hand,#renaultNgFeedbackContainer .smileys .emoji__heart,#renaultNgFeedbackContainer .smileys .emoji__mouth,#renaultNgFeedbackContainer .smileys .emoji__thumb,#renaultNgFeedbackContainer .smileys .emoji__tongue{position:absolute}#renaultNgFeedbackContainer .smileys .emoji__eyebrows:after,#renaultNgFeedbackContainer .smileys .emoji__eyebrows:before,#renaultNgFeedbackContainer .smileys .emoji__eyes:after,#renaultNgFeedbackContainer .smileys .emoji__eyes:before,#renaultNgFeedbackContainer .smileys .emoji__face:after,#renaultNgFeedbackContainer .smileys .emoji__face:before,#renaultNgFeedbackContainer .smileys .emoji__hand:after,#renaultNgFeedbackContainer .smileys .emoji__hand:before,#renaultNgFeedbackContainer .smileys .emoji__heart:after,#renaultNgFeedbackContainer .smileys .emoji__heart:before,#renaultNgFeedbackContainer .smileys .emoji__mouth:after,#renaultNgFeedbackContainer .smileys .emoji__mouth:before,#renaultNgFeedbackContainer .smileys .emoji__thumb:after,#renaultNgFeedbackContainer .smileys .emoji__thumb:before,#renaultNgFeedbackContainer .smileys .emoji__tongue:after,#renaultNgFeedbackContainer .smileys .emoji__tongue:before{position:absolute;content:""}#renaultNgFeedbackContainer .smileys .emoji__face{width:inherit;height:inherit}#renaultNgFeedbackContainer .smileys .emoji--like{background:#548dff}#renaultNgFeedbackContainer .smileys .emoji--like:after{content:"Like"}#renaultNgFeedbackContainer .smileys .emoji--like .emoji__hand{left:25px;bottom:30px;width:20px;height:40px;background:#fff;border-radius:5px;z-index:0;-webkit-animation:2s linear infinite hands-up;animation:2s linear infinite hands-up}#renaultNgFeedbackContainer .smileys .emoji--like .emoji__hand:before{left:25px;bottom:5px;width:40px;background:inherit;height:10px;border-radius:2px 10px 10px 2px;box-shadow:1px -9px 0 1px #fff,2px -19px 0 2px #fff,3px -29px 0 3px #fff}#renaultNgFeedbackContainer .smileys .emoji--like .emoji__thumb{border-bottom:20px solid #fff;border-left:20px solid transparent;top:-25px;right:-25px;z-index:2;transform:rotate(5deg);transform-origin:0 100%;-webkit-animation:2s linear infinite thumbs-up;animation:2s linear infinite thumbs-up}#renaultNgFeedbackContainer .smileys .emoji--like .emoji__thumb:before{border-radius:50% 50% 0 0;background:#fff;width:10px;height:12px;left:-10px;top:-8px;transform:rotate(-15deg);transform-origin:100% 100%;box-shadow:-1px 4px 0 -1px #fff}#renaultNgFeedbackContainer .smileys .emoji--love{background:#f55064}#renaultNgFeedbackContainer .smileys .emoji--love:after{content:"Love"}#renaultNgFeedbackContainer .smileys .emoji--love .emoji__heart{left:calc(50% - 40px);top:calc(50% - 40px);width:80px;height:80px;-webkit-animation:1s linear infinite alternate heart-beat;animation:1s linear infinite alternate heart-beat}#renaultNgFeedbackContainer .smileys .emoji--love .emoji__heart:after,#renaultNgFeedbackContainer .smileys .emoji--love .emoji__heart:before{left:calc(50% - 20px);top:calc(50% - 32px);width:40px;height:64px;background:#fff;border-radius:20px 20px 0 0}#renaultNgFeedbackContainer .smileys .emoji--love .emoji__heart:before{transform:translate(20px) rotate(-45deg);transform-origin:0 100%}#renaultNgFeedbackContainer .smileys .emoji--love .emoji__heart:after{transform:translate(-20px) rotate(45deg);transform-origin:100% 100%}#renaultNgFeedbackContainer .smileys .emoji--haha:after{content:"Haha"}#renaultNgFeedbackContainer .smileys .emoji--haha .emoji__face{-webkit-animation:2s linear infinite haha-face;animation:2s linear infinite haha-face}#renaultNgFeedbackContainer .smileys .emoji--haha .emoji__eyes{width:26px;height:6px;border-radius:2px;left:calc(50% - 13px);top:35px;transform:rotate(20deg);background:0 0;box-shadow:-25px 5px 0 0 #000,25px -5px 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--haha .emoji__eyes:after{left:0;top:0;width:26px;height:6px;border-radius:2px;transform:rotate(-40deg);background:0 0;box-shadow:-25px -5px 0 0 #000,25px 5px 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--haha .emoji__mouth{width:80px;height:40px;left:calc(50% - 40px);top:50%;background:#000;border-radius:0 0 40px 40px;overflow:hidden;z-index:1;-webkit-animation:2s linear infinite haha-mouth;animation:2s linear infinite haha-mouth}#renaultNgFeedbackContainer .smileys .emoji--haha .emoji__tongue{width:70px;height:30px;background:#f55064;left:calc(50% - 35px);bottom:-10px;border-radius:50%}#renaultNgFeedbackContainer .smileys .emoji--yay:after{content:attr(data-emojiYay);-webkit-animation:1s linear infinite yay-reverse;animation:1s linear infinite yay-reverse}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__face{-webkit-animation:1s linear infinite alternate yay;animation:1s linear infinite alternate yay}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__eyebrows{left:calc(50% - 3px);top:30px;height:6px;width:6px;border-radius:50%;background:0 0;box-shadow:-6px 0 0 0 #000,-36px 0 0 0 #000,6px 0 0 0 #000,36px 0 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__eyebrows:after,#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__eyebrows:before{width:36px;height:18px;border-radius:60px 60px 0 0;background:0 0;border:6px solid #000;box-sizing:border-box;border-bottom:0;bottom:3px;left:calc(50% - 18px)}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__eyebrows:before{margin-left:-21px}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__eyebrows:after{margin-left:21px}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__mouth{top:60px;background:0 0;left:50%}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__mouth:after{width:80px;height:80px;left:calc(50% - 40px);top:-75px;border-radius:50%;background:0 0;border:6px solid #000;box-sizing:border-box;border-top-color:transparent;border-left-color:transparent;border-right-color:transparent;z-index:1}#renaultNgFeedbackContainer .smileys .emoji--yay .emoji__mouth:before{width:6px;height:6px;background:0 0;border-radius:50%;bottom:5px;left:calc(50% - 3px);box-shadow:-25px 0 0 0 #000,25px 0 0 0 #000,-35px -2px 30px 10px #d5234c,35px -2px 30px 10px #d5234c}#renaultNgFeedbackContainer .smileys .emoji--wow:after{content:attr(data-emojiWow)}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__face{-webkit-animation:3s linear infinite wow-face;animation:3s linear infinite wow-face}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyebrows{left:calc(50% - 3px);height:6px;width:6px;border-radius:50%;background:0 0;box-shadow:-18px 0 0 0 #000,-33px 0 0 0 #000,18px 0 0 0 #000,33px 0 0 0 #000;-webkit-animation:3s linear infinite wow-brow;animation:3s linear infinite wow-brow}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyebrows:after,#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyebrows:before{width:24px;height:20px;border:6px solid #000;box-sizing:border-box;border-radius:50%;border-bottom-color:transparent;border-left-color:transparent;border-right-color:transparent;top:-3px;left:calc(50% - 12px)}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyebrows:before{margin-left:-25px}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyebrows:after{margin-left:25px}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__eyes{width:16px;height:24px;left:calc(50% - 8px);top:35px;border-radius:50%;background:0 0;box-shadow:25px 0 0 0 #000,-25px 0 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--wow .emoji__mouth{width:30px;height:45px;left:calc(50% - 15px);top:50%;border-radius:50%;background:#000;-webkit-animation:3s linear infinite wow-mouth;animation:3s linear infinite wow-mouth}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh:after{content:"Neutral"}#renaultNgFeedbackContainer .smileys .emoji--sad:after{content:attr(data-emojiSad)}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__face{-webkit-animation:2s ease-in infinite sad-face;animation:2s ease-in infinite sad-face}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyebrows{left:calc(50% - 3px);top:35px;height:6px;width:6px;border-radius:50%;background:0 0;box-shadow:-40px 9px 0 0 #000,-25px 0 0 0 #000,25px 0 0 0 #000,40px 9px 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyebrows:after,#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyebrows:before{width:30px;height:20px;border:6px solid #000;box-sizing:border-box;border-radius:50%;border-bottom-color:transparent;border-left-color:transparent;border-right-color:transparent;top:2px;left:calc(50% - 15px)}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyebrows:before{margin-left:-30px;transform:rotate(-30deg)}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyebrows:after{margin-left:30px;transform:rotate(30deg)}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh{-webkit-animation:none;animation:none}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh .emoji__eyes:after{background:0 0;-webkit-animation:none;animation:none}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh .emoji__face{-webkit-animation:none;animation:none}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh .emoji__mouth{border-radius:0;-webkit-animation:none;animation:none}#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh .emoji__mouth:after,#renaultNgFeedbackContainer .smileys .emoji--sad.emoji--meh .emoji__mouth:before{display:none}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyes{width:14px;height:16px;left:calc(50% - 7px);top:50px;border-radius:50%;background:0 0;box-shadow:25px 0 0 0 #000,-25px 0 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__eyes:after{background:#548dff;width:12px;height:12px;margin-left:6px;border-radius:0 100% 40% 50%/0 50% 40% 100%;transform-origin:0 0;-webkit-animation:2s ease-in infinite tear-drop;animation:2s ease-in infinite tear-drop}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__mouth{width:60px;height:80px;left:calc(50% - 30px);top:80px;box-sizing:border-box;border:6px solid #000;border-radius:50%;border-bottom-color:transparent;border-left-color:transparent;border-right-color:transparent;background:0 0;-webkit-animation:2s ease-in infinite sad-mouth;animation:2s ease-in infinite sad-mouth}#renaultNgFeedbackContainer .smileys .emoji--sad .emoji__mouth:after{width:6px;height:6px;background:0 0;border-radius:50%;top:4px;left:calc(50% - 3px);box-shadow:-18px 0 0 0 #000,18px 0 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--angry{background:linear-gradient(#d5234c -10%,#ffda6a);background-size:100%;-webkit-animation:2s ease-in infinite angry-color;animation:2s ease-in infinite angry-color}#renaultNgFeedbackContainer .smileys .emoji--angry:after{content:attr(data-emojiAngry)}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__face{-webkit-animation:2s ease-in infinite angry-face;animation:2s ease-in infinite angry-face}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyebrows{left:calc(50% - 3px);top:55px;height:6px;width:6px;border-radius:50%;background:0 0;box-shadow:-44px 5px 0 0 #000,-7px 16px 0 0 #000,7px 16px 0 0 #000,44px 5px 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyebrows:after,#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyebrows:before{width:50px;height:20px;border:6px solid #000;box-sizing:border-box;border-radius:50%;border-top-color:transparent;border-left-color:transparent;border-right-color:transparent;top:0;left:calc(50% - 25px)}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyebrows:before{margin-left:-25px;transform:rotate(15deg)}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyebrows:after{margin-left:25px;transform:rotate(-15deg)}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__eyes{width:12px;height:12px;left:calc(50% - 6px);top:70px;border-radius:50%;background:0 0;box-shadow:25px 0 0 0 #000,-25px 0 0 0 #000}#renaultNgFeedbackContainer .smileys .emoji--angry .emoji__mouth{width:36px;height:18px;left:calc(50% - 18px);bottom:15px;background:#000;border-radius:50%;-webkit-animation:2s ease-in infinite angry-mouth;animation:2s ease-in infinite angry-mouth}@-webkit-keyframes heart-beat{25%{transform:scale(1.1)}75%{transform:scale(.6)}}@keyframes heart-beat{25%{transform:scale(1.1)}75%{transform:scale(.6)}}@-webkit-keyframes haha-face{10%,30%,50%{transform:translateY(25px)}20%,40%{transform:translateY(15px)}60%,80%{transform:translateY(0)}70%,90%{transform:translateY(-10px)}}@keyframes haha-face{10%,30%,50%{transform:translateY(25px)}20%,40%{transform:translateY(15px)}60%,80%{transform:translateY(0)}70%,90%{transform:translateY(-10px)}}@-webkit-keyframes haha-mouth{10%,30%,50%{transform:scale(.6);top:45%}20%,40%{transform:scale(.8);top:45%}60%,80%{transform:scale(1);top:50%}70%{transform:scale(1.2);top:50%}90%{transform:scale(1.1);top:50%}}@keyframes haha-mouth{10%,30%,50%{transform:scale(.6);top:45%}20%,40%{transform:scale(.8);top:45%}60%,80%{transform:scale(1);top:50%}70%{transform:scale(1.2);top:50%}90%{transform:scale(1.1);top:50%}}@-webkit-keyframes yay{25%{transform:rotate(-15deg)}75%{transform:rotate(15deg)}}@keyframes yay{25%{transform:rotate(-15deg)}75%{transform:rotate(15deg)}}@-webkit-keyframes wow-face{15%,25%{transform:rotate(20deg) translateX(-25px)}45%,65%{transform:rotate(-20deg) translateX(25px)}100%,75%{transform:rotate(0) translateX(0)}}@keyframes wow-face{15%,25%{transform:rotate(20deg) translateX(-25px)}45%,65%{transform:rotate(-20deg) translateX(25px)}100%,75%{transform:rotate(0) translateX(0)}}@-webkit-keyframes wow-brow{15%,65%{top:25px}0%,100%,75%{top:15px}}@keyframes wow-brow{15%,65%{top:25px}0%,100%,75%{top:15px}}@-webkit-keyframes wow-mouth{10%,30%{width:20px;height:20px;left:calc(50% - 10px)}50%,70%{width:30px;height:40px;left:calc(50% - 15px)}100%,75%{height:50px}}@keyframes wow-mouth{10%,30%{width:20px;height:20px;left:calc(50% - 10px)}50%,70%{width:30px;height:40px;left:calc(50% - 15px)}100%,75%{height:50px}}@-webkit-keyframes sad-face{25%,35%{top:-15px}55%,95%{top:10px}0%,100%{top:0}}@keyframes sad-face{25%,35%{top:-15px}55%,95%{top:10px}0%,100%{top:0}}@-webkit-keyframes sad-mouth{25%,35%{transform:scale(.85);top:70px}0%,100%,55%{transform:scale(1);top:80px}}@keyframes sad-mouth{25%,35%{transform:scale(.85);top:70px}0%,100%,55%{transform:scale(1);top:80px}}@-webkit-keyframes tear-drop{0%,100%{display:block;left:35px;top:15px;transform:rotate(45deg) scale(0)}25%{display:block;left:35px;transform:rotate(45deg) scale(2)}49.9%{display:block;left:35px;top:65px;transform:rotate(45deg) scale(0)}50%{display:block;left:-35px;top:15px;transform:rotate(45deg) scale(0)}75%{display:block;left:-35px;transform:rotate(45deg) scale(2)}99.9%{display:block;left:-35px;top:65px;transform:rotate(45deg) scale(0)}}@keyframes tear-drop{0%,100%{display:block;left:35px;top:15px;transform:rotate(45deg) scale(0)}25%{display:block;left:35px;transform:rotate(45deg) scale(2)}49.9%{display:block;left:35px;top:65px;transform:rotate(45deg) scale(0)}50%{display:block;left:-35px;top:15px;transform:rotate(45deg) scale(0)}75%{display:block;left:-35px;transform:rotate(45deg) scale(2)}99.9%{display:block;left:-35px;top:65px;transform:rotate(45deg) scale(0)}}@-webkit-keyframes hands-up{25%{transform:rotate(15deg)}50%{transform:rotate(-15deg) translateY(-10px)}100%,75%{transform:rotate(0)}}@keyframes hands-up{25%{transform:rotate(15deg)}50%{transform:rotate(-15deg) translateY(-10px)}100%,75%{transform:rotate(0)}}@-webkit-keyframes thumbs-up{25%{transform:rotate(20deg)}100%,50%{transform:rotate(5deg)}}@keyframes thumbs-up{25%{transform:rotate(20deg)}100%,50%{transform:rotate(5deg)}}@-webkit-keyframes angry-color{45%,60%{background-size:250%}0%,100%,85%{background-size:100%}}@keyframes angry-color{45%,60%{background-size:250%}0%,100%,85%{background-size:100%}}@-webkit-keyframes angry-face{35%,60%{transform:translateX(0) translateY(10px) scale(.9)}40%,50%{transform:translateX(-5px) translateY(10px) scale(.9)}45%,55%{transform:translateX(5px) translateY(10px) scale(.9)}}@keyframes angry-face{35%,60%{transform:translateX(0) translateY(10px) scale(.9)}40%,50%{transform:translateX(-5px) translateY(10px) scale(.9)}45%,55%{transform:translateX(5px) translateY(10px) scale(.9)}}@-webkit-keyframes angry-mouth{25%,50%{height:6px;bottom:25px}}@keyframes angry-mouth{25%,50%{height:6px;bottom:25px}}#renaultNgFeedbackContainer b,#renaultNgFeedbackContainer strong{font-weight:bolder;width:240px}#renaultNgFeedbackContainer button.close1,#renaultNgFeedbackContainer .card-body .far{font-weight:400;width:43px;right:0;text-align:center;position:absolute;background:#ffc107}#renaultNgFeedbackContainer .card-body .far:hover{background-color:#ffc107}#renaultNgFeedbackContainer ::-webkit-scrollbar{width:10px}#renaultNgFeedbackContainer ::-webkit-scrollbar-track{background-color:#ebebeb;border-radius:10px}#renaultNgFeedbackContainer ::-webkit-scrollbar-thumb{border-radius:10px;background:#6d6d6d}#renaultNgFeedbackContainer .feedbkimg{right:50px;width:22px;height:22px;position:fixed;top:1em}#renaultNgFeedbackContainer .translateAttach .card-body{background-color:#ffc107;position:relative}#renaultNgFeedbackContainer .error p{margin:0}#renaultNgFeedbackContainer .translateAttach .feedbkimg,#renaultNgFeedbackContainer .translateAttach button.happiClose,#renaultNgFeedbackContainer button.close1{display:none;margin-top:-85px}#renaultNgFeedbackContainer .translateAttach button.close1{display:inline-block;position:absolute;border:2px solid #fff1c8;background:#fff1c8;color:#ff9800;line-height:1;margin:0;right:10px;height:20px;width:20px;font-weight:700;top:10px;font-size:16px;display:flex;align-items:center;justify-content:center}@-webkit-keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}@keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}.close2{border-radius:50%;border:2px solid #fff1c8;background:#fff1c8;color:#ff9800;line-height:1;margin:0 0 0 5px;right:10px;height:18px;width:18px;font-weight:700;top:10px;font-size:15px;align-items:center;justify-content:center;display:flex}::ng-deep feedback-dialog .dialog-content,::ng-deep feedback-dialog .dialog-title{display:none!important}.comment-section{min-height:50px;position:relative;display:inline-block;width:318px;text-align:left;border:1px solid #ccc;height:80px;overflow:auto;border-radius:5px}.screenshot-feedback{height:auto;margin-top:5px}::ng-deep feedback-dialog .screenshot-checkbox{background-color:var(plugincolor)}.screenshot-name{display:flex;font-size:12px;float:right;height:24px}.questions-link.pt-3.d-block{padding-top:20px!important;height:auto}.questions-link.pt-3.d-block a{display:inline-block;height:27px;width:300px}.image-added{margin-left:15px;height:22px}.screenshot-name.no-comment{margin-right:152px}textarea::-webkit-input-placeholder{font-size:15px;color:gray}textarea::-moz-placeholder{font-size:15px;color:gray}textarea::-ms-input-placeholder{font-size:15px;color:gray}textarea::placeholder{font-size:15px;color:gray}.textarea-new::-webkit-input-placeholder{font-size:15px;color:gray}.textarea-new::-moz-placeholder{font-size:15px;color:gray}.textarea-new::-ms-input-placeholder{font-size:15px;color:gray}.textarea-new::placeholder{font-size:15px;color:gray}.fa-camera-retro{font-size:35px;vertical-align:top;margin-top:22px;margin-left:5px;width:25px;height:50px}.comment-section.no-screenShot{width:355px}.fas.fa-camera-retro .tooltiptext{visibility:hidden;width:50px;background-color:#fff;color:#000;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;top:229px;right:13%;font-size:10px;height:40px}.fas.fa-camera-retro:hover .tooltiptext{visibility:visible}.pt-3.d-block.screenShot-content{height:auto}.fas.fa-camera-retro.no-comment .tooltiptext{right:31%}::ng-deep .dialog-actions .action-button:first-child{display:none}.feedback-click{display:none}::ng-deep .cdk-overlay-connected-position-bounding-box .mat-tooltip{background:#fff!important;color:#000!important}input[type=file]{display:none}.custom-file-upload{display:inline-block;padding:0;cursor:pointer}.poweredby{text-align:center;color:grey;font-weight:400;font-size:.9em;padding-top:1.5em}.poweredby span{font-size:.9em;font-style:italic}#renaultNgFeedbackContainer label{margin-bottom:0}#renaultNgFeedbackContainer .d-block{padding-bottom:.5em}',":root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex='-1']:focus:not(:focus-visible){outline:0!important}h1,h2,h3,h4,h5,h6{margin-top:0}dl,ol,p,ul{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote,figure{margin:0 0 1rem}b,strong{font-weight:bolder}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]),a:not([href]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:dotted 1px;outline:-webkit-focus-ring-color auto 5px}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{box-sizing:content-box;height:0;overflow:visible;margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer::before{content:'\\2014\\00A0'}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid,.container-lg,.container-md,.container-sm,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}.row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-1>*{flex:0 0 100%;max-width:100%}.row-cols-2>*{flex:0 0 50%;max-width:50%}.row-cols-3>*{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4>*{flex:0 0 25%;max-width:25%}.row-cols-5>*{flex:0 0 20%;max-width:20%}.row-cols-6>*{flex:0 0 16.666667%;max-width:16.666667%}.col-auto{flex:0 0 auto;width:auto;max-width:100%}.col-1{flex:0 0 8.333333%;max-width:8.333333%}.col-2{flex:0 0 16.666667%;max-width:16.666667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.333333%;max-width:33.333333%}.col-5{flex:0 0 41.666667%;max-width:41.666667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.333333%;max-width:58.333333%}.col-8{flex:0 0 66.666667%;max-width:66.666667%}.col-9{flex:0 0 75%;max-width:75%}.col-10{flex:0 0 83.333333%;max-width:83.333333%}.col-11{flex:0 0 91.666667%;max-width:91.666667%}.col-12{flex:0 0 100%;max-width:100%}.order-first{order:-1}.order-last{order:13}.order-0{order:0}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-sm-1>*{flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4>*{flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{flex:0 0 100%;max-width:100%}.order-sm-first{order:-1}.order-sm-last{order:13}.order-sm-0{order:0}.order-sm-1{order:1}.order-sm-2{order:2}.order-sm-3{order:3}.order-sm-4{order:4}.order-sm-5{order:5}.order-sm-6{order:6}.order-sm-7{order:7}.order-sm-8{order:8}.order-sm-9{order:9}.order-sm-10{order:10}.order-sm-11{order:11}.order-sm-12{order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-md-1>*{flex:0 0 100%;max-width:100%}.row-cols-md-2>*{flex:0 0 50%;max-width:50%}.row-cols-md-3>*{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4>*{flex:0 0 25%;max-width:25%}.row-cols-md-5>*{flex:0 0 20%;max-width:20%}.row-cols-md-6>*{flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.col-md-1{flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{flex:0 0 100%;max-width:100%}.order-md-first{order:-1}.order-md-last{order:13}.order-md-0{order:0}.order-md-1{order:1}.order-md-2{order:2}.order-md-3{order:3}.order-md-4{order:4}.order-md-5{order:5}.order-md-6{order:6}.order-md-7{order:7}.order-md-8{order:8}.order-md-9{order:9}.order-md-10{order:10}.order-md-11{order:11}.order-md-12{order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-lg-1>*{flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4>*{flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{flex:0 0 100%;max-width:100%}.order-lg-first{order:-1}.order-lg-last{order:13}.order-lg-0{order:0}.order-lg-1{order:1}.order-lg-2{order:2}.order-lg-3{order:3}.order-lg-4{order:4}.order-lg-5{order:5}.order-lg-6{order:6}.order-lg-7{order:7}.order-lg-8{order:8}.order-lg-9{order:9}.order-lg-10{order:10}.order-lg-11{order:11}.order-lg-12{order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-xl-1>*{flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4>*{flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{flex:0 0 100%;max-width:100%}.order-xl-first{order:-1}.order-xl-last{order:13}.order-xl-0{order:0}.order-xl-1{order:1}.order-xl-2{order:2}.order-xl-3{order:3}.order-xl-4{order:4}.order-xl-5{order:5}.order-xl-6{order:6}.order-xl-7{order:7}.order-xl-8{order:8}.order-xl-9{order:9}.order-xl-10{order:10}.order-xl-11{order:11}.order-xl-12{order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-borderless tbody+tbody,.table-borderless td,.table-borderless th,.table-borderless thead th{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-primary tbody+tbody,.table-primary td,.table-primary th,.table-primary thead th{border-color:#7abaff}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-secondary tbody+tbody,.table-secondary td,.table-secondary th,.table-secondary thead th{border-color:#b3b7bb}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-success tbody+tbody,.table-success td,.table-success th,.table-success thead th{border-color:#8fd19e}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-info tbody+tbody,.table-info td,.table-info th,.table-info thead th{border-color:#86cfda}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-warning tbody+tbody,.table-warning td,.table-warning th,.table-warning thead th{border-color:#ffdf7e}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-danger tbody+tbody,.table-danger td,.table-danger th,.table-danger thead th{border-color:#ed969e}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-light tbody+tbody,.table-light td,.table-light th,.table-light thead th{border-color:#fbfcfc}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#95999c}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark td,.table-dark th,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple],select.form-control[size],textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid,.was-validated .custom-select:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat #fff}.custom-select.is-valid:focus,.was-validated .custom-select:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{border-color:#28a745}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid,.was-validated .custom-select:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat #fff}.custom-select.is-invalid:focus,.was-validated .custom-select:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{border-color:#dc3545}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:flex;flex-flow:row wrap;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:flex;align-items:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .custom-select,.form-inline .input-group{width:auto}.form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{align-items:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link.focus,.btn-link:focus{text-decoration:underline;box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#6c757d;pointer-events:none}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s}.dropdown,.dropleft,.dropright,.dropup{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:'';border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:'';border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;content:'';border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid;vertical-align:0}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{margin-left:.255em;vertical-align:.255em;content:'';display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;content:'';border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent;vertical-align:0}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropdown-menu[x-placement^=bottom],.dropdown-menu[x-placement^=left],.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;flex:1 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn-group:not(:first-child),.btn-group>.btn:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;flex:1 1 0%;min-width:0;margin-bottom:0}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control,.input-group>.form-control-plaintext+.custom-file,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.form-control{margin-left:-1px}.input-group>.custom-file .custom-file-input:focus~.custom-file-label,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:flex;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn:focus,.input-group-prepend .btn:focus{z-index:3}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group-lg>.custom-select,.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg>.custom-select,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.custom-select,.input-group-sm>.form-control:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm>.custom-select,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select,.input-group-sm>.custom-select{padding-right:1.75rem}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label,.custom-control-input[disabled]~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before,.custom-control-input[disabled]~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:'';background-color:#fff;border:1px solid #adb5bd}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:'';background:50%/50% 50% no-repeat}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat #fff;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size='1']){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label,.custom-file-input[disabled]~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:'Browse'}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:'Browse';background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.collapsing,.custom-switch .custom-control-label::after{transition:none}.custom-range::-webkit-slider-thumb{transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{flex:1 1 auto;text-align:center}.nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.navbar .container,.navbar .container-fluid,.navbar .container-lg,.navbar .container-md,.navbar .container-sm,.navbar .container-xl{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:'';background:center center/100% 100% no-repeat}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{padding-right:0;padding-left:0;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body{flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img,.card-img-bottom,.card-img-top{flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:flex;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:flex;flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}.card-columns{-moz-column-count:3;column-count:3;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.card-columns .card{margin-bottom:.75rem}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:'/'}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:focus,a.badge:hover{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:focus,a.badge-primary:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus,a.badge-primary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:focus,a.badge-secondary:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus,a.badge-secondary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:focus,a.badge-success:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus,a.badge-success:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:focus,a.badge-info:hover{color:#fff;background-color:#117a8b}a.badge-info.focus,a.badge-info:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:focus,a.badge-warning:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus,a.badge-warning:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:focus,a.badge-danger:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus,a.badge-danger:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:focus,a.badge-light:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus,a.badge-light:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:focus,a.badge-dark:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus,a.badge-dark:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .happiClose{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:1s linear infinite progress-bar-stripes;animation:1s linear infinite progress-bar-stripes}.media{display:flex;align-items:flex-start}.media-body{flex:1}.list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{flex-direction:row}.list-group-horizontal .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal .list-group-item.active{margin-top:0}.list-group-horizontal .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{flex-direction:row}.list-group-horizontal-sm .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm .list-group-item.active{margin-top:0}.list-group-horizontal-sm .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{flex-direction:row}.list-group-horizontal-md .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md .list-group-item.active{margin-top:0}.list-group-horizontal-md .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{flex-direction:row}.list-group-horizontal-lg .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg .list-group-item.active{margin-top:0}.list-group-horizontal-lg .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{flex-direction:row}.list-group-horizontal-xl .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl .list-group-item.active{margin-top:0}.list-group-horizontal-xl .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush .list-group-item{border-right-width:0;border-left-width:0;border-radius:0}.list-group-flush .list-group-item:first-child{border-top-width:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.happiClose{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.happiClose:hover{color:#000;text-decoration:none}.happiClose:not(:disabled):not(.disabled):focus,.happiClose:not(:disabled):not(.disabled):hover{opacity:.75}button.happiClose{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}a.happiClose.disabled{pointer-events:none}.toast{max-width:350px;overflow:hidden;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:flex;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}.progress-bar-animated{-webkit-animation:none;animation:none}.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{transform:none}.modal.modal-static .modal-dialog{transform:scale(1.02)}.modal-dialog-scrollable{display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-footer,.modal-dialog-scrollable .modal-header{flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);content:''}.modal-dialog-centered.modal-dialog-scrollable{flex-direction:column;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .happiClose{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;flex:1 1 auto;padding:1rem}.modal-footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:'';border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:'';border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top]>.arrow,.bs-popover-top>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top]>.arrow::before,.bs-popover-top>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top]>.arrow::after,.bs-popover-top>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right]>.arrow,.bs-popover-right>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right]>.arrow::before,.bs-popover-right>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right]>.arrow::after,.bs-popover-right>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom]>.arrow,.bs-popover-bottom>.arrow{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom]>.arrow::before,.bs-popover-bottom>.arrow::before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom]>.arrow::after,.bs-popover-bottom>.arrow::after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:'';border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left]>.arrow,.bs-popover-left>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left]>.arrow::before,.bs-popover-left>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left]>.arrow::after,.bs-popover-left>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:''}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-right,.carousel-item-next:not(.carousel-item-left){transform:translateX(100%)}.active.carousel-item-left,.carousel-item-prev:not(.carousel-item-right){transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right,.carousel-item{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:50%/100% 100% no-repeat}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev,.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes spinner-border{to{transform:rotate(360deg)}}@keyframes spinner-border{to{transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border;animation:.75s linear infinite spinner-border}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1}}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow;animation:.75s linear infinite spinner-grow}.spinner-grow-sm{width:1rem;height:1rem}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:''}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:''}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-fill{flex:1 1 auto!important}.flex-grow-0{flex-grow:0!important}.flex-grow-1{flex-grow:1!important}.flex-shrink-0{flex-shrink:0!important}.flex-shrink-1{flex-shrink:1!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{-ms-grid-row-align:auto!important;align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{-ms-grid-row-align:center!important;align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{-ms-grid-row-align:stretch!important;align-self:stretch!important}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:'';background-color:rgba(0,0,0,0)}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-sm-fill{flex:1 1 auto!important}.flex-sm-grow-0{flex-grow:0!important}.flex-sm-grow-1{flex-grow:1!important}.flex-sm-shrink-0{flex-shrink:0!important}.flex-sm-shrink-1{flex-shrink:1!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{-ms-grid-row-align:auto!important;align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{-ms-grid-row-align:center!important;align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{-ms-grid-row-align:stretch!important;align-self:stretch!important}.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-md-fill{flex:1 1 auto!important}.flex-md-grow-0{flex-grow:0!important}.flex-md-grow-1{flex-grow:1!important}.flex-md-shrink-0{flex-shrink:0!important}.flex-md-shrink-1{flex-shrink:1!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{-ms-grid-row-align:auto!important;align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{-ms-grid-row-align:center!important;align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{-ms-grid-row-align:stretch!important;align-self:stretch!important}.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-lg-fill{flex:1 1 auto!important}.flex-lg-grow-0{flex-grow:0!important}.flex-lg-grow-1{flex-grow:1!important}.flex-lg-shrink-0{flex-shrink:0!important}.flex-lg-shrink-1{flex-shrink:1!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{-ms-grid-row-align:auto!important;align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{-ms-grid-row-align:center!important;align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{-ms-grid-row-align:stretch!important;align-self:stretch!important}.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-xl-fill{flex:1 1 auto!important}.flex-xl-grow-0{flex-grow:0!important}.flex-xl-grow-1{flex-grow:1!important}.flex-xl-shrink-0{flex-shrink:0!important}.flex-xl-shrink-1{flex-shrink:1!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{-ms-grid-row-align:auto!important;align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{-ms-grid-row-align:center!important;align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{-ms-grid-row-align:stretch!important;align-self:stretch!important}.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;overflow-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:' (' attr(title) ')'}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}.container,body{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}",".fa,.fab,.fad,.fal,.far,.fas{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1}.fa-lg{font-size:1.33333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:.08em solid #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:2s linear infinite fa-spin;animation:2s linear infinite fa-spin}.fa-pulse{-webkit-animation:1s steps(8) infinite fa-spin;animation:1s steps(8) infinite fa-spin}@-webkit-keyframes fa-spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes fa-spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.fa-rotate-90{transform:rotate(90deg)}.fa-rotate-180{transform:rotate(180deg)}.fa-rotate-270{transform:rotate(270deg)}.fa-flip-horizontal{transform:scaleX(-1)}.fa-flip-vertical{transform:scaleY(-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{transform:scale(-1)}:root .fa-flip-both,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;line-height:2em;position:relative;vertical-align:middle;width:2.5em}.fa-stack-1x,.fa-stack-2x{left:0;position:absolute;text-align:center;width:100%}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-500px:before{content:'\\f26e'}.fa-accessible-icon:before{content:'\\f368'}.fa-accusoft:before{content:'\\f369'}.fa-acquisitions-incorporated:before{content:'\\f6af'}.fa-ad:before{content:'\\f641'}.fa-address-book:before{content:'\\f2b9'}.fa-address-card:before{content:'\\f2bb'}.fa-adjust:before{content:'\\f042'}.fa-adn:before{content:'\\f170'}.fa-adobe:before{content:'\\f778'}.fa-adversal:before{content:'\\f36a'}.fa-affiliatetheme:before{content:'\\f36b'}.fa-air-freshener:before{content:'\\f5d0'}.fa-airbnb:before{content:'\\f834'}.fa-algolia:before{content:'\\f36c'}.fa-align-center:before{content:'\\f037'}.fa-align-justify:before{content:'\\f039'}.fa-align-left:before{content:'\\f036'}.fa-align-right:before{content:'\\f038'}.fa-alipay:before{content:'\\f642'}.fa-allergies:before{content:'\\f461'}.fa-amazon:before{content:'\\f270'}.fa-amazon-pay:before{content:'\\f42c'}.fa-ambulance:before{content:'\\f0f9'}.fa-american-sign-language-interpreting:before{content:'\\f2a3'}.fa-amilia:before{content:'\\f36d'}.fa-anchor:before{content:'\\f13d'}.fa-android:before{content:'\\f17b'}.fa-angellist:before{content:'\\f209'}.fa-angle-double-down:before{content:'\\f103'}.fa-angle-double-left:before{content:'\\f100'}.fa-angle-double-right:before{content:'\\f101'}.fa-angle-double-up:before{content:'\\f102'}.fa-angle-down:before{content:'\\f107'}.fa-angle-left:before{content:'\\f104'}.fa-angle-right:before{content:'\\f105'}.fa-angle-up:before{content:'\\f106'}.fa-angry:before{content:'\\f556'}.fa-angrycreative:before{content:'\\f36e'}.fa-angular:before{content:'\\f420'}.fa-ankh:before{content:'\\f644'}.fa-app-store:before{content:'\\f36f'}.fa-app-store-ios:before{content:'\\f370'}.fa-apper:before{content:'\\f371'}.fa-apple:before{content:'\\f179'}.fa-apple-alt:before{content:'\\f5d1'}.fa-apple-pay:before{content:'\\f415'}.fa-archive:before{content:'\\f187'}.fa-archway:before{content:'\\f557'}.fa-arrow-alt-circle-down:before{content:'\\f358'}.fa-arrow-alt-circle-left:before{content:'\\f359'}.fa-arrow-alt-circle-right:before{content:'\\f35a'}.fa-arrow-alt-circle-up:before{content:'\\f35b'}.fa-arrow-circle-down:before{content:'\\f0ab'}.fa-arrow-circle-left:before{content:'\\f0a8'}.fa-arrow-circle-right:before{content:'\\f0a9'}.fa-arrow-circle-up:before{content:'\\f0aa'}.fa-arrow-down:before{content:'\\f063'}.fa-arrow-left:before{content:'\\f060'}.fa-arrow-right:before{content:'\\f061'}.fa-arrow-up:before{content:'\\f062'}.fa-arrows-alt:before{content:'\\f0b2'}.fa-arrows-alt-h:before{content:'\\f337'}.fa-arrows-alt-v:before{content:'\\f338'}.fa-artstation:before{content:'\\f77a'}.fa-assistive-listening-systems:before{content:'\\f2a2'}.fa-asterisk:before{content:'\\f069'}.fa-asymmetrik:before{content:'\\f372'}.fa-at:before{content:'\\f1fa'}.fa-atlas:before{content:'\\f558'}.fa-atlassian:before{content:'\\f77b'}.fa-atom:before{content:'\\f5d2'}.fa-audible:before{content:'\\f373'}.fa-audio-description:before{content:'\\f29e'}.fa-autoprefixer:before{content:'\\f41c'}.fa-avianex:before{content:'\\f374'}.fa-aviato:before{content:'\\f421'}.fa-award:before{content:'\\f559'}.fa-aws:before{content:'\\f375'}.fa-baby:before{content:'\\f77c'}.fa-baby-carriage:before{content:'\\f77d'}.fa-backspace:before{content:'\\f55a'}.fa-backward:before{content:'\\f04a'}.fa-bacon:before{content:'\\f7e5'}.fa-bahai:before{content:'\\f666'}.fa-balance-scale:before{content:'\\f24e'}.fa-balance-scale-left:before{content:'\\f515'}.fa-balance-scale-right:before{content:'\\f516'}.fa-ban:before{content:'\\f05e'}.fa-band-aid:before{content:'\\f462'}.fa-bandcamp:before{content:'\\f2d5'}.fa-barcode:before{content:'\\f02a'}.fa-bars:before{content:'\\f0c9'}.fa-baseball-ball:before{content:'\\f433'}.fa-basketball-ball:before{content:'\\f434'}.fa-bath:before{content:'\\f2cd'}.fa-battery-empty:before{content:'\\f244'}.fa-battery-full:before{content:'\\f240'}.fa-battery-half:before{content:'\\f242'}.fa-battery-quarter:before{content:'\\f243'}.fa-battery-three-quarters:before{content:'\\f241'}.fa-battle-net:before{content:'\\f835'}.fa-bed:before{content:'\\f236'}.fa-beer:before{content:'\\f0fc'}.fa-behance:before{content:'\\f1b4'}.fa-behance-square:before{content:'\\f1b5'}.fa-bell:before{content:'\\f0f3'}.fa-bell-slash:before{content:'\\f1f6'}.fa-bezier-curve:before{content:'\\f55b'}.fa-bible:before{content:'\\f647'}.fa-bicycle:before{content:'\\f206'}.fa-biking:before{content:'\\f84a'}.fa-bimobject:before{content:'\\f378'}.fa-binoculars:before{content:'\\f1e5'}.fa-biohazard:before{content:'\\f780'}.fa-birthday-cake:before{content:'\\f1fd'}.fa-bitbucket:before{content:'\\f171'}.fa-bitcoin:before{content:'\\f379'}.fa-bity:before{content:'\\f37a'}.fa-black-tie:before{content:'\\f27e'}.fa-blackberry:before{content:'\\f37b'}.fa-blender:before{content:'\\f517'}.fa-blender-phone:before{content:'\\f6b6'}.fa-blind:before{content:'\\f29d'}.fa-blog:before{content:'\\f781'}.fa-blogger:before{content:'\\f37c'}.fa-blogger-b:before{content:'\\f37d'}.fa-bluetooth:before{content:'\\f293'}.fa-bluetooth-b:before{content:'\\f294'}.fa-bold:before{content:'\\f032'}.fa-bolt:before{content:'\\f0e7'}.fa-bomb:before{content:'\\f1e2'}.fa-bone:before{content:'\\f5d7'}.fa-bong:before{content:'\\f55c'}.fa-book:before{content:'\\f02d'}.fa-book-dead:before{content:'\\f6b7'}.fa-book-medical:before{content:'\\f7e6'}.fa-book-open:before{content:'\\f518'}.fa-book-reader:before{content:'\\f5da'}.fa-bookmark:before{content:'\\f02e'}.fa-bootstrap:before{content:'\\f836'}.fa-border-all:before{content:'\\f84c'}.fa-border-none:before{content:'\\f850'}.fa-border-style:before{content:'\\f853'}.fa-bowling-ball:before{content:'\\f436'}.fa-box:before{content:'\\f466'}.fa-box-open:before{content:'\\f49e'}.fa-boxes:before{content:'\\f468'}.fa-braille:before{content:'\\f2a1'}.fa-brain:before{content:'\\f5dc'}.fa-bread-slice:before{content:'\\f7ec'}.fa-briefcase:before{content:'\\f0b1'}.fa-briefcase-medical:before{content:'\\f469'}.fa-broadcast-tower:before{content:'\\f519'}.fa-broom:before{content:'\\f51a'}.fa-brush:before{content:'\\f55d'}.fa-btc:before{content:'\\f15a'}.fa-buffer:before{content:'\\f837'}.fa-bug:before{content:'\\f188'}.fa-building:before{content:'\\f1ad'}.fa-bullhorn:before{content:'\\f0a1'}.fa-bullseye:before{content:'\\f140'}.fa-burn:before{content:'\\f46a'}.fa-buromobelexperte:before{content:'\\f37f'}.fa-bus:before{content:'\\f207'}.fa-bus-alt:before{content:'\\f55e'}.fa-business-time:before{content:'\\f64a'}.fa-buy-n-large:before{content:'\\f8a6'}.fa-buysellads:before{content:'\\f20d'}.fa-calculator:before{content:'\\f1ec'}.fa-calendar:before{content:'\\f133'}.fa-calendar-alt:before{content:'\\f073'}.fa-calendar-check:before{content:'\\f274'}.fa-calendar-day:before{content:'\\f783'}.fa-calendar-minus:before{content:'\\f272'}.fa-calendar-plus:before{content:'\\f271'}.fa-calendar-times:before{content:'\\f273'}.fa-calendar-week:before{content:'\\f784'}.fa-camera:before{content:'\\f030'}.fa-camera-retro:before{content:'\\f083'}.fa-campground:before{content:'\\f6bb'}.fa-canadian-maple-leaf:before{content:'\\f785'}.fa-candy-cane:before{content:'\\f786'}.fa-cannabis:before{content:'\\f55f'}.fa-capsules:before{content:'\\f46b'}.fa-car:before{content:'\\f1b9'}.fa-car-alt:before{content:'\\f5de'}.fa-car-battery:before{content:'\\f5df'}.fa-car-crash:before{content:'\\f5e1'}.fa-car-side:before{content:'\\f5e4'}.fa-caravan:before{content:'\\f8ff'}.fa-caret-down:before{content:'\\f0d7'}.fa-caret-left:before{content:'\\f0d9'}.fa-caret-right:before{content:'\\f0da'}.fa-caret-square-down:before{content:'\\f150'}.fa-caret-square-left:before{content:'\\f191'}.fa-caret-square-right:before{content:'\\f152'}.fa-caret-square-up:before{content:'\\f151'}.fa-caret-up:before{content:'\\f0d8'}.fa-carrot:before{content:'\\f787'}.fa-cart-arrow-down:before{content:'\\f218'}.fa-cart-plus:before{content:'\\f217'}.fa-cash-register:before{content:'\\f788'}.fa-cat:before{content:'\\f6be'}.fa-cc-amazon-pay:before{content:'\\f42d'}.fa-cc-amex:before{content:'\\f1f3'}.fa-cc-apple-pay:before{content:'\\f416'}.fa-cc-diners-club:before{content:'\\f24c'}.fa-cc-discover:before{content:'\\f1f2'}.fa-cc-jcb:before{content:'\\f24b'}.fa-cc-mastercard:before{content:'\\f1f1'}.fa-cc-paypal:before{content:'\\f1f4'}.fa-cc-stripe:before{content:'\\f1f5'}.fa-cc-visa:before{content:'\\f1f0'}.fa-centercode:before{content:'\\f380'}.fa-centos:before{content:'\\f789'}.fa-certificate:before{content:'\\f0a3'}.fa-chair:before{content:'\\f6c0'}.fa-chalkboard:before{content:'\\f51b'}.fa-chalkboard-teacher:before{content:'\\f51c'}.fa-charging-station:before{content:'\\f5e7'}.fa-chart-area:before{content:'\\f1fe'}.fa-chart-bar:before{content:'\\f080'}.fa-chart-line:before{content:'\\f201'}.fa-chart-pie:before{content:'\\f200'}.fa-check:before{content:'\\f00c'}.fa-check-circle:before{content:'\\f058'}.fa-check-double:before{content:'\\f560'}.fa-check-square:before{content:'\\f14a'}.fa-cheese:before{content:'\\f7ef'}.fa-chess:before{content:'\\f439'}.fa-chess-bishop:before{content:'\\f43a'}.fa-chess-board:before{content:'\\f43c'}.fa-chess-king:before{content:'\\f43f'}.fa-chess-knight:before{content:'\\f441'}.fa-chess-pawn:before{content:'\\f443'}.fa-chess-queen:before{content:'\\f445'}.fa-chess-rook:before{content:'\\f447'}.fa-chevron-circle-down:before{content:'\\f13a'}.fa-chevron-circle-left:before{content:'\\f137'}.fa-chevron-circle-right:before{content:'\\f138'}.fa-chevron-circle-up:before{content:'\\f139'}.fa-chevron-down:before{content:'\\f078'}.fa-chevron-left:before{content:'\\f053'}.fa-chevron-right:before{content:'\\f054'}.fa-chevron-up:before{content:'\\f077'}.fa-child:before{content:'\\f1ae'}.fa-chrome:before{content:'\\f268'}.fa-chromecast:before{content:'\\f838'}.fa-church:before{content:'\\f51d'}.fa-circle:before{content:'\\f111'}.fa-circle-notch:before{content:'\\f1ce'}.fa-city:before{content:'\\f64f'}.fa-clinic-medical:before{content:'\\f7f2'}.fa-clipboard:before{content:'\\f328'}.fa-clipboard-check:before{content:'\\f46c'}.fa-clipboard-list:before{content:'\\f46d'}.fa-clock:before{content:'\\f017'}.fa-clone:before{content:'\\f24d'}.fa-closed-captioning:before{content:'\\f20a'}.fa-cloud:before{content:'\\f0c2'}.fa-cloud-download-alt:before{content:'\\f381'}.fa-cloud-meatball:before{content:'\\f73b'}.fa-cloud-moon:before{content:'\\f6c3'}.fa-cloud-moon-rain:before{content:'\\f73c'}.fa-cloud-rain:before{content:'\\f73d'}.fa-cloud-showers-heavy:before{content:'\\f740'}.fa-cloud-sun:before{content:'\\f6c4'}.fa-cloud-sun-rain:before{content:'\\f743'}.fa-cloud-upload-alt:before{content:'\\f382'}.fa-cloudscale:before{content:'\\f383'}.fa-cloudsmith:before{content:'\\f384'}.fa-cloudversify:before{content:'\\f385'}.fa-cocktail:before{content:'\\f561'}.fa-code:before{content:'\\f121'}.fa-code-branch:before{content:'\\f126'}.fa-codepen:before{content:'\\f1cb'}.fa-codiepie:before{content:'\\f284'}.fa-coffee:before{content:'\\f0f4'}.fa-cog:before{content:'\\f013'}.fa-cogs:before{content:'\\f085'}.fa-coins:before{content:'\\f51e'}.fa-columns:before{content:'\\f0db'}.fa-comment:before{content:'\\f075'}.fa-comment-alt:before{content:'\\f27a'}.fa-comment-dollar:before{content:'\\f651'}.fa-comment-dots:before{content:'\\f4ad'}.fa-comment-medical:before{content:'\\f7f5'}.fa-comment-slash:before{content:'\\f4b3'}.fa-comments:before{content:'\\f086'}.fa-comments-dollar:before{content:'\\f653'}.fa-compact-disc:before{content:'\\f51f'}.fa-compass:before{content:'\\f14e'}.fa-compress:before{content:'\\f066'}.fa-compress-alt:before{content:'\\f422'}.fa-compress-arrows-alt:before{content:'\\f78c'}.fa-concierge-bell:before{content:'\\f562'}.fa-confluence:before{content:'\\f78d'}.fa-connectdevelop:before{content:'\\f20e'}.fa-contao:before{content:'\\f26d'}.fa-cookie:before{content:'\\f563'}.fa-cookie-bite:before{content:'\\f564'}.fa-copy:before{content:'\\f0c5'}.fa-copyright:before{content:'\\f1f9'}.fa-cotton-bureau:before{content:'\\f89e'}.fa-couch:before{content:'\\f4b8'}.fa-cpanel:before{content:'\\f388'}.fa-creative-commons:before{content:'\\f25e'}.fa-creative-commons-by:before{content:'\\f4e7'}.fa-creative-commons-nc:before{content:'\\f4e8'}.fa-creative-commons-nc-eu:before{content:'\\f4e9'}.fa-creative-commons-nc-jp:before{content:'\\f4ea'}.fa-creative-commons-nd:before{content:'\\f4eb'}.fa-creative-commons-pd:before{content:'\\f4ec'}.fa-creative-commons-pd-alt:before{content:'\\f4ed'}.fa-creative-commons-remix:before{content:'\\f4ee'}.fa-creative-commons-sa:before{content:'\\f4ef'}.fa-creative-commons-sampling:before{content:'\\f4f0'}.fa-creative-commons-sampling-plus:before{content:'\\f4f1'}.fa-creative-commons-share:before{content:'\\f4f2'}.fa-creative-commons-zero:before{content:'\\f4f3'}.fa-credit-card:before{content:'\\f09d'}.fa-critical-role:before{content:'\\f6c9'}.fa-crop:before{content:'\\f125'}.fa-crop-alt:before{content:'\\f565'}.fa-cross:before{content:'\\f654'}.fa-crosshairs:before{content:'\\f05b'}.fa-crow:before{content:'\\f520'}.fa-crown:before{content:'\\f521'}.fa-crutch:before{content:'\\f7f7'}.fa-css3:before{content:'\\f13c'}.fa-css3-alt:before{content:'\\f38b'}.fa-cube:before{content:'\\f1b2'}.fa-cubes:before{content:'\\f1b3'}.fa-cut:before{content:'\\f0c4'}.fa-cuttlefish:before{content:'\\f38c'}.fa-d-and-d:before{content:'\\f38d'}.fa-d-and-d-beyond:before{content:'\\f6ca'}.fa-dailymotion:before{content:'\\f952'}.fa-dashcube:before{content:'\\f210'}.fa-database:before{content:'\\f1c0'}.fa-deaf:before{content:'\\f2a4'}.fa-delicious:before{content:'\\f1a5'}.fa-democrat:before{content:'\\f747'}.fa-deploydog:before{content:'\\f38e'}.fa-deskpro:before{content:'\\f38f'}.fa-desktop:before{content:'\\f108'}.fa-dev:before{content:'\\f6cc'}.fa-deviantart:before{content:'\\f1bd'}.fa-dharmachakra:before{content:'\\f655'}.fa-dhl:before{content:'\\f790'}.fa-diagnoses:before{content:'\\f470'}.fa-diaspora:before{content:'\\f791'}.fa-dice:before{content:'\\f522'}.fa-dice-d20:before{content:'\\f6cf'}.fa-dice-d6:before{content:'\\f6d1'}.fa-dice-five:before{content:'\\f523'}.fa-dice-four:before{content:'\\f524'}.fa-dice-one:before{content:'\\f525'}.fa-dice-six:before{content:'\\f526'}.fa-dice-three:before{content:'\\f527'}.fa-dice-two:before{content:'\\f528'}.fa-digg:before{content:'\\f1a6'}.fa-digital-ocean:before{content:'\\f391'}.fa-digital-tachograph:before{content:'\\f566'}.fa-directions:before{content:'\\f5eb'}.fa-discord:before{content:'\\f392'}.fa-discourse:before{content:'\\f393'}.fa-divide:before{content:'\\f529'}.fa-dizzy:before{content:'\\f567'}.fa-dna:before{content:'\\f471'}.fa-dochub:before{content:'\\f394'}.fa-docker:before{content:'\\f395'}.fa-dog:before{content:'\\f6d3'}.fa-dollar-sign:before{content:'\\f155'}.fa-dolly:before{content:'\\f472'}.fa-dolly-flatbed:before{content:'\\f474'}.fa-donate:before{content:'\\f4b9'}.fa-door-closed:before{content:'\\f52a'}.fa-door-open:before{content:'\\f52b'}.fa-dot-circle:before{content:'\\f192'}.fa-dove:before{content:'\\f4ba'}.fa-download:before{content:'\\f019'}.fa-draft2digital:before{content:'\\f396'}.fa-drafting-compass:before{content:'\\f568'}.fa-dragon:before{content:'\\f6d5'}.fa-draw-polygon:before{content:'\\f5ee'}.fa-dribbble:before{content:'\\f17d'}.fa-dribbble-square:before{content:'\\f397'}.fa-dropbox:before{content:'\\f16b'}.fa-drum:before{content:'\\f569'}.fa-drum-steelpan:before{content:'\\f56a'}.fa-drumstick-bite:before{content:'\\f6d7'}.fa-drupal:before{content:'\\f1a9'}.fa-dumbbell:before{content:'\\f44b'}.fa-dumpster:before{content:'\\f793'}.fa-dumpster-fire:before{content:'\\f794'}.fa-dungeon:before{content:'\\f6d9'}.fa-dyalog:before{content:'\\f399'}.fa-earlybirds:before{content:'\\f39a'}.fa-ebay:before{content:'\\f4f4'}.fa-edge:before{content:'\\f282'}.fa-edit:before{content:'\\f044'}.fa-egg:before{content:'\\f7fb'}.fa-eject:before{content:'\\f052'}.fa-elementor:before{content:'\\f430'}.fa-ellipsis-h:before{content:'\\f141'}.fa-ellipsis-v:before{content:'\\f142'}.fa-ello:before{content:'\\f5f1'}.fa-ember:before{content:'\\f423'}.fa-empire:before{content:'\\f1d1'}.fa-envelope:before{content:'\\f0e0'}.fa-envelope-open:before{content:'\\f2b6'}.fa-envelope-open-text:before{content:'\\f658'}.fa-envelope-square:before{content:'\\f199'}.fa-envira:before{content:'\\f299'}.fa-equals:before{content:'\\f52c'}.fa-eraser:before{content:'\\f12d'}.fa-erlang:before{content:'\\f39d'}.fa-ethereum:before{content:'\\f42e'}.fa-ethernet:before{content:'\\f796'}.fa-etsy:before{content:'\\f2d7'}.fa-euro-sign:before{content:'\\f153'}.fa-evernote:before{content:'\\f839'}.fa-exchange-alt:before{content:'\\f362'}.fa-exclamation:before{content:'\\f12a'}.fa-exclamation-circle:before{content:'\\f06a'}.fa-exclamation-triangle:before{content:'\\f071'}.fa-expand:before{content:'\\f065'}.fa-expand-alt:before{content:'\\f424'}.fa-expand-arrows-alt:before{content:'\\f31e'}.fa-expeditedssl:before{content:'\\f23e'}.fa-external-link-alt:before{content:'\\f35d'}.fa-external-link-square-alt:before{content:'\\f360'}.fa-eye:before{content:'\\f06e'}.fa-eye-dropper:before{content:'\\f1fb'}.fa-eye-slash:before{content:'\\f070'}.fa-facebook:before{content:'\\f09a'}.fa-facebook-f:before{content:'\\f39e'}.fa-facebook-messenger:before{content:'\\f39f'}.fa-facebook-square:before{content:'\\f082'}.fa-fan:before{content:'\\f863'}.fa-fantasy-flight-games:before{content:'\\f6dc'}.fa-fast-backward:before{content:'\\f049'}.fa-fast-forward:before{content:'\\f050'}.fa-fax:before{content:'\\f1ac'}.fa-feather:before{content:'\\f52d'}.fa-feather-alt:before{content:'\\f56b'}.fa-fedex:before{content:'\\f797'}.fa-fedora:before{content:'\\f798'}.fa-female:before{content:'\\f182'}.fa-fighter-jet:before{content:'\\f0fb'}.fa-figma:before{content:'\\f799'}.fa-file:before{content:'\\f15b'}.fa-file-alt:before{content:'\\f15c'}.fa-file-archive:before{content:'\\f1c6'}.fa-file-audio:before{content:'\\f1c7'}.fa-file-code:before{content:'\\f1c9'}.fa-file-contract:before{content:'\\f56c'}.fa-file-csv:before{content:'\\f6dd'}.fa-file-download:before{content:'\\f56d'}.fa-file-excel:before{content:'\\f1c3'}.fa-file-export:before{content:'\\f56e'}.fa-file-image:before{content:'\\f1c5'}.fa-file-import:before{content:'\\f56f'}.fa-file-invoice:before{content:'\\f570'}.fa-file-invoice-dollar:before{content:'\\f571'}.fa-file-medical:before{content:'\\f477'}.fa-file-medical-alt:before{content:'\\f478'}.fa-file-pdf:before{content:'\\f1c1'}.fa-file-powerpoint:before{content:'\\f1c4'}.fa-file-prescription:before{content:'\\f572'}.fa-file-signature:before{content:'\\f573'}.fa-file-upload:before{content:'\\f574'}.fa-file-video:before{content:'\\f1c8'}.fa-file-word:before{content:'\\f1c2'}.fa-fill:before{content:'\\f575'}.fa-fill-drip:before{content:'\\f576'}.fa-film:before{content:'\\f008'}.fa-filter:before{content:'\\f0b0'}.fa-fingerprint:before{content:'\\f577'}.fa-fire:before{content:'\\f06d'}.fa-fire-alt:before{content:'\\f7e4'}.fa-fire-extinguisher:before{content:'\\f134'}.fa-firefox:before{content:'\\f269'}.fa-firefox-browser:before{content:'\\f907'}.fa-first-aid:before{content:'\\f479'}.fa-first-order:before{content:'\\f2b0'}.fa-first-order-alt:before{content:'\\f50a'}.fa-firstdraft:before{content:'\\f3a1'}.fa-fish:before{content:'\\f578'}.fa-fist-raised:before{content:'\\f6de'}.fa-flag:before{content:'\\f024'}.fa-flag-checkered:before{content:'\\f11e'}.fa-flag-usa:before{content:'\\f74d'}.fa-flask:before{content:'\\f0c3'}.fa-flickr:before{content:'\\f16e'}.fa-flipboard:before{content:'\\f44d'}.fa-flushed:before{content:'\\f579'}.fa-fly:before{content:'\\f417'}.fa-folder:before{content:'\\f07b'}.fa-folder-minus:before{content:'\\f65d'}.fa-folder-open:before{content:'\\f07c'}.fa-folder-plus:before{content:'\\f65e'}.fa-font:before{content:'\\f031'}.fa-font-awesome:before{content:'\\f2b4'}.fa-font-awesome-alt:before{content:'\\f35c'}.fa-font-awesome-flag:before{content:'\\f425'}.fa-font-awesome-logo-full:before{content:'\\f4e6'}.fa-fonticons:before{content:'\\f280'}.fa-fonticons-fi:before{content:'\\f3a2'}.fa-football-ball:before{content:'\\f44e'}.fa-fort-awesome:before{content:'\\f286'}.fa-fort-awesome-alt:before{content:'\\f3a3'}.fa-forumbee:before{content:'\\f211'}.fa-forward:before{content:'\\f04e'}.fa-foursquare:before{content:'\\f180'}.fa-free-code-camp:before{content:'\\f2c5'}.fa-freebsd:before{content:'\\f3a4'}.fa-frog:before{content:'\\f52e'}.fa-frown:before{content:'\\f119'}.fa-frown-open:before{content:'\\f57a'}.fa-fulcrum:before{content:'\\f50b'}.fa-funnel-dollar:before{content:'\\f662'}.fa-futbol:before{content:'\\f1e3'}.fa-galactic-republic:before{content:'\\f50c'}.fa-galactic-senate:before{content:'\\f50d'}.fa-gamepad:before{content:'\\f11b'}.fa-gas-pump:before{content:'\\f52f'}.fa-gavel:before{content:'\\f0e3'}.fa-gem:before{content:'\\f3a5'}.fa-genderless:before{content:'\\f22d'}.fa-get-pocket:before{content:'\\f265'}.fa-gg:before{content:'\\f260'}.fa-gg-circle:before{content:'\\f261'}.fa-ghost:before{content:'\\f6e2'}.fa-gift:before{content:'\\f06b'}.fa-gifts:before{content:'\\f79c'}.fa-git:before{content:'\\f1d3'}.fa-git-alt:before{content:'\\f841'}.fa-git-square:before{content:'\\f1d2'}.fa-github:before{content:'\\f09b'}.fa-github-alt:before{content:'\\f113'}.fa-github-square:before{content:'\\f092'}.fa-gitkraken:before{content:'\\f3a6'}.fa-gitlab:before{content:'\\f296'}.fa-gitter:before{content:'\\f426'}.fa-glass-cheers:before{content:'\\f79f'}.fa-glass-martini:before{content:'\\f000'}.fa-glass-martini-alt:before{content:'\\f57b'}.fa-glass-whiskey:before{content:'\\f7a0'}.fa-glasses:before{content:'\\f530'}.fa-glide:before{content:'\\f2a5'}.fa-glide-g:before{content:'\\f2a6'}.fa-globe:before{content:'\\f0ac'}.fa-globe-africa:before{content:'\\f57c'}.fa-globe-americas:before{content:'\\f57d'}.fa-globe-asia:before{content:'\\f57e'}.fa-globe-europe:before{content:'\\f7a2'}.fa-gofore:before{content:'\\f3a7'}.fa-golf-ball:before{content:'\\f450'}.fa-goodreads:before{content:'\\f3a8'}.fa-goodreads-g:before{content:'\\f3a9'}.fa-google:before{content:'\\f1a0'}.fa-google-drive:before{content:'\\f3aa'}.fa-google-play:before{content:'\\f3ab'}.fa-google-plus:before{content:'\\f2b3'}.fa-google-plus-g:before{content:'\\f0d5'}.fa-google-plus-square:before{content:'\\f0d4'}.fa-google-wallet:before{content:'\\f1ee'}.fa-gopuram:before{content:'\\f664'}.fa-graduation-cap:before{content:'\\f19d'}.fa-gratipay:before{content:'\\f184'}.fa-grav:before{content:'\\f2d6'}.fa-greater-than:before{content:'\\f531'}.fa-greater-than-equal:before{content:'\\f532'}.fa-grimace:before{content:'\\f57f'}.fa-grin:before{content:'\\f580'}.fa-grin-alt:before{content:'\\f581'}.fa-grin-beam:before{content:'\\f582'}.fa-grin-beam-sweat:before{content:'\\f583'}.fa-grin-hearts:before{content:'\\f584'}.fa-grin-squint:before{content:'\\f585'}.fa-grin-squint-tears:before{content:'\\f586'}.fa-grin-stars:before{content:'\\f587'}.fa-grin-tears:before{content:'\\f588'}.fa-grin-tongue:before{content:'\\f589'}.fa-grin-tongue-squint:before{content:'\\f58a'}.fa-grin-tongue-wink:before{content:'\\f58b'}.fa-grin-wink:before{content:'\\f58c'}.fa-grip-horizontal:before{content:'\\f58d'}.fa-grip-lines:before{content:'\\f7a4'}.fa-grip-lines-vertical:before{content:'\\f7a5'}.fa-grip-vertical:before{content:'\\f58e'}.fa-gripfire:before{content:'\\f3ac'}.fa-grunt:before{content:'\\f3ad'}.fa-guitar:before{content:'\\f7a6'}.fa-gulp:before{content:'\\f3ae'}.fa-h-square:before{content:'\\f0fd'}.fa-hacker-news:before{content:'\\f1d4'}.fa-hacker-news-square:before{content:'\\f3af'}.fa-hackerrank:before{content:'\\f5f7'}.fa-hamburger:before{content:'\\f805'}.fa-hammer:before{content:'\\f6e3'}.fa-hamsa:before{content:'\\f665'}.fa-hand-holding:before{content:'\\f4bd'}.fa-hand-holding-heart:before{content:'\\f4be'}.fa-hand-holding-usd:before{content:'\\f4c0'}.fa-hand-lizard:before{content:'\\f258'}.fa-hand-middle-finger:before{content:'\\f806'}.fa-hand-paper:before{content:'\\f256'}.fa-hand-peace:before{content:'\\f25b'}.fa-hand-point-down:before{content:'\\f0a7'}.fa-hand-point-left:before{content:'\\f0a5'}.fa-hand-point-right:before{content:'\\f0a4'}.fa-hand-point-up:before{content:'\\f0a6'}.fa-hand-pointer:before{content:'\\f25a'}.fa-hand-rock:before{content:'\\f255'}.fa-hand-scissors:before{content:'\\f257'}.fa-hand-spock:before{content:'\\f259'}.fa-hands:before{content:'\\f4c2'}.fa-hands-helping:before{content:'\\f4c4'}.fa-handshake:before{content:'\\f2b5'}.fa-hanukiah:before{content:'\\f6e6'}.fa-hard-hat:before{content:'\\f807'}.fa-hashtag:before{content:'\\f292'}.fa-hat-cowboy:before{content:'\\f8c0'}.fa-hat-cowboy-side:before{content:'\\f8c1'}.fa-hat-wizard:before{content:'\\f6e8'}.fa-hdd:before{content:'\\f0a0'}.fa-heading:before{content:'\\f1dc'}.fa-headphones:before{content:'\\f025'}.fa-headphones-alt:before{content:'\\f58f'}.fa-headset:before{content:'\\f590'}.fa-heart:before{content:'\\f004'}.fa-heart-broken:before{content:'\\f7a9'}.fa-heartbeat:before{content:'\\f21e'}.fa-helicopter:before{content:'\\f533'}.fa-highlighter:before{content:'\\f591'}.fa-hiking:before{content:'\\f6ec'}.fa-hippo:before{content:'\\f6ed'}.fa-hips:before{content:'\\f452'}.fa-hire-a-helper:before{content:'\\f3b0'}.fa-history:before{content:'\\f1da'}.fa-hockey-puck:before{content:'\\f453'}.fa-holly-berry:before{content:'\\f7aa'}.fa-home:before{content:'\\f015'}.fa-hooli:before{content:'\\f427'}.fa-hornbill:before{content:'\\f592'}.fa-horse:before{content:'\\f6f0'}.fa-horse-head:before{content:'\\f7ab'}.fa-hospital:before{content:'\\f0f8'}.fa-hospital-alt:before{content:'\\f47d'}.fa-hospital-symbol:before{content:'\\f47e'}.fa-hot-tub:before{content:'\\f593'}.fa-hotdog:before{content:'\\f80f'}.fa-hotel:before{content:'\\f594'}.fa-hotjar:before{content:'\\f3b1'}.fa-hourglass:before{content:'\\f254'}.fa-hourglass-end:before{content:'\\f253'}.fa-hourglass-half:before{content:'\\f252'}.fa-hourglass-start:before{content:'\\f251'}.fa-house-damage:before{content:'\\f6f1'}.fa-houzz:before{content:'\\f27c'}.fa-hryvnia:before{content:'\\f6f2'}.fa-html5:before{content:'\\f13b'}.fa-hubspot:before{content:'\\f3b2'}.fa-i-cursor:before{content:'\\f246'}.fa-ice-cream:before{content:'\\f810'}.fa-icicles:before{content:'\\f7ad'}.fa-icons:before{content:'\\f86d'}.fa-id-badge:before{content:'\\f2c1'}.fa-id-card:before{content:'\\f2c2'}.fa-id-card-alt:before{content:'\\f47f'}.fa-ideal:before{content:'\\f913'}.fa-igloo:before{content:'\\f7ae'}.fa-image:before{content:'\\f03e'}.fa-images:before{content:'\\f302'}.fa-imdb:before{content:'\\f2d8'}.fa-inbox:before{content:'\\f01c'}.fa-indent:before{content:'\\f03c'}.fa-industry:before{content:'\\f275'}.fa-infinity:before{content:'\\f534'}.fa-info:before{content:'\\f129'}.fa-info-circle:before{content:'\\f05a'}.fa-instagram:before{content:'\\f16d'}.fa-instagram-square:before{content:'\\f955'}.fa-intercom:before{content:'\\f7af'}.fa-internet-explorer:before{content:'\\f26b'}.fa-invision:before{content:'\\f7b0'}.fa-ioxhost:before{content:'\\f208'}.fa-italic:before{content:'\\f033'}.fa-itch-io:before{content:'\\f83a'}.fa-itunes:before{content:'\\f3b4'}.fa-itunes-note:before{content:'\\f3b5'}.fa-java:before{content:'\\f4e4'}.fa-jedi:before{content:'\\f669'}.fa-jedi-order:before{content:'\\f50e'}.fa-jenkins:before{content:'\\f3b6'}.fa-jira:before{content:'\\f7b1'}.fa-joget:before{content:'\\f3b7'}.fa-joint:before{content:'\\f595'}.fa-joomla:before{content:'\\f1aa'}.fa-journal-whills:before{content:'\\f66a'}.fa-js:before{content:'\\f3b8'}.fa-js-square:before{content:'\\f3b9'}.fa-jsfiddle:before{content:'\\f1cc'}.fa-kaaba:before{content:'\\f66b'}.fa-kaggle:before{content:'\\f5fa'}.fa-key:before{content:'\\f084'}.fa-keybase:before{content:'\\f4f5'}.fa-keyboard:before{content:'\\f11c'}.fa-keycdn:before{content:'\\f3ba'}.fa-khanda:before{content:'\\f66d'}.fa-kickstarter:before{content:'\\f3bb'}.fa-kickstarter-k:before{content:'\\f3bc'}.fa-kiss:before{content:'\\f596'}.fa-kiss-beam:before{content:'\\f597'}.fa-kiss-wink-heart:before{content:'\\f598'}.fa-kiwi-bird:before{content:'\\f535'}.fa-korvue:before{content:'\\f42f'}.fa-landmark:before{content:'\\f66f'}.fa-language:before{content:'\\f1ab'}.fa-laptop:before{content:'\\f109'}.fa-laptop-code:before{content:'\\f5fc'}.fa-laptop-medical:before{content:'\\f812'}.fa-laravel:before{content:'\\f3bd'}.fa-lastfm:before{content:'\\f202'}.fa-lastfm-square:before{content:'\\f203'}.fa-laugh:before{content:'\\f599'}.fa-laugh-beam:before{content:'\\f59a'}.fa-laugh-squint:before{content:'\\f59b'}.fa-laugh-wink:before{content:'\\f59c'}.fa-layer-group:before{content:'\\f5fd'}.fa-leaf:before{content:'\\f06c'}.fa-leanpub:before{content:'\\f212'}.fa-lemon:before{content:'\\f094'}.fa-less:before{content:'\\f41d'}.fa-less-than:before{content:'\\f536'}.fa-less-than-equal:before{content:'\\f537'}.fa-level-down-alt:before{content:'\\f3be'}.fa-level-up-alt:before{content:'\\f3bf'}.fa-life-ring:before{content:'\\f1cd'}.fa-lightbulb:before{content:'\\f0eb'}.fa-line:before{content:'\\f3c0'}.fa-link:before{content:'\\f0c1'}.fa-linkedin:before{content:'\\f08c'}.fa-linkedin-in:before{content:'\\f0e1'}.fa-linode:before{content:'\\f2b8'}.fa-linux:before{content:'\\f17c'}.fa-lira-sign:before{content:'\\f195'}.fa-list:before{content:'\\f03a'}.fa-list-alt:before{content:'\\f022'}.fa-list-ol:before{content:'\\f0cb'}.fa-list-ul:before{content:'\\f0ca'}.fa-location-arrow:before{content:'\\f124'}.fa-lock:before{content:'\\f023'}.fa-lock-open:before{content:'\\f3c1'}.fa-long-arrow-alt-down:before{content:'\\f309'}.fa-long-arrow-alt-left:before{content:'\\f30a'}.fa-long-arrow-alt-right:before{content:'\\f30b'}.fa-long-arrow-alt-up:before{content:'\\f30c'}.fa-low-vision:before{content:'\\f2a8'}.fa-luggage-cart:before{content:'\\f59d'}.fa-lyft:before{content:'\\f3c3'}.fa-magento:before{content:'\\f3c4'}.fa-magic:before{content:'\\f0d0'}.fa-magnet:before{content:'\\f076'}.fa-mail-bulk:before{content:'\\f674'}.fa-mailchimp:before{content:'\\f59e'}.fa-male:before{content:'\\f183'}.fa-mandalorian:before{content:'\\f50f'}.fa-map:before{content:'\\f279'}.fa-map-marked:before{content:'\\f59f'}.fa-map-marked-alt:before{content:'\\f5a0'}.fa-map-marker:before{content:'\\f041'}.fa-map-marker-alt:before{content:'\\f3c5'}.fa-map-pin:before{content:'\\f276'}.fa-map-signs:before{content:'\\f277'}.fa-markdown:before{content:'\\f60f'}.fa-marker:before{content:'\\f5a1'}.fa-mars:before{content:'\\f222'}.fa-mars-double:before{content:'\\f227'}.fa-mars-stroke:before{content:'\\f229'}.fa-mars-stroke-h:before{content:'\\f22b'}.fa-mars-stroke-v:before{content:'\\f22a'}.fa-mask:before{content:'\\f6fa'}.fa-mastodon:before{content:'\\f4f6'}.fa-maxcdn:before{content:'\\f136'}.fa-mdb:before{content:'\\f8ca'}.fa-medal:before{content:'\\f5a2'}.fa-medapps:before{content:'\\f3c6'}.fa-medium:before{content:'\\f23a'}.fa-medium-m:before{content:'\\f3c7'}.fa-medkit:before{content:'\\f0fa'}.fa-medrt:before{content:'\\f3c8'}.fa-meetup:before{content:'\\f2e0'}.fa-megaport:before{content:'\\f5a3'}.fa-meh:before{content:'\\f11a'}.fa-meh-blank:before{content:'\\f5a4'}.fa-meh-rolling-eyes:before{content:'\\f5a5'}.fa-memory:before{content:'\\f538'}.fa-mendeley:before{content:'\\f7b3'}.fa-menorah:before{content:'\\f676'}.fa-mercury:before{content:'\\f223'}.fa-meteor:before{content:'\\f753'}.fa-microblog:before{content:'\\f91a'}.fa-microchip:before{content:'\\f2db'}.fa-microphone:before{content:'\\f130'}.fa-microphone-alt:before{content:'\\f3c9'}.fa-microphone-alt-slash:before{content:'\\f539'}.fa-microphone-slash:before{content:'\\f131'}.fa-microscope:before{content:'\\f610'}.fa-microsoft:before{content:'\\f3ca'}.fa-minus:before{content:'\\f068'}.fa-minus-circle:before{content:'\\f056'}.fa-minus-square:before{content:'\\f146'}.fa-mitten:before{content:'\\f7b5'}.fa-mix:before{content:'\\f3cb'}.fa-mixcloud:before{content:'\\f289'}.fa-mixer:before{content:'\\f956'}.fa-mizuni:before{content:'\\f3cc'}.fa-mobile:before{content:'\\f10b'}.fa-mobile-alt:before{content:'\\f3cd'}.fa-modx:before{content:'\\f285'}.fa-monero:before{content:'\\f3d0'}.fa-money-bill:before{content:'\\f0d6'}.fa-money-bill-alt:before{content:'\\f3d1'}.fa-money-bill-wave:before{content:'\\f53a'}.fa-money-bill-wave-alt:before{content:'\\f53b'}.fa-money-check:before{content:'\\f53c'}.fa-money-check-alt:before{content:'\\f53d'}.fa-monument:before{content:'\\f5a6'}.fa-moon:before{content:'\\f186'}.fa-mortar-pestle:before{content:'\\f5a7'}.fa-mosque:before{content:'\\f678'}.fa-motorcycle:before{content:'\\f21c'}.fa-mountain:before{content:'\\f6fc'}.fa-mouse:before{content:'\\f8cc'}.fa-mouse-pointer:before{content:'\\f245'}.fa-mug-hot:before{content:'\\f7b6'}.fa-music:before{content:'\\f001'}.fa-napster:before{content:'\\f3d2'}.fa-neos:before{content:'\\f612'}.fa-network-wired:before{content:'\\f6ff'}.fa-neuter:before{content:'\\f22c'}.fa-newspaper:before{content:'\\f1ea'}.fa-nimblr:before{content:'\\f5a8'}.fa-node:before{content:'\\f419'}.fa-node-js:before{content:'\\f3d3'}.fa-not-equal:before{content:'\\f53e'}.fa-notes-medical:before{content:'\\f481'}.fa-npm:before{content:'\\f3d4'}.fa-ns8:before{content:'\\f3d5'}.fa-nutritionix:before{content:'\\f3d6'}.fa-object-group:before{content:'\\f247'}.fa-object-ungroup:before{content:'\\f248'}.fa-odnoklassniki:before{content:'\\f263'}.fa-odnoklassniki-square:before{content:'\\f264'}.fa-oil-can:before{content:'\\f613'}.fa-old-republic:before{content:'\\f510'}.fa-om:before{content:'\\f679'}.fa-opencart:before{content:'\\f23d'}.fa-openid:before{content:'\\f19b'}.fa-opera:before{content:'\\f26a'}.fa-optin-monster:before{content:'\\f23c'}.fa-orcid:before{content:'\\f8d2'}.fa-osi:before{content:'\\f41a'}.fa-otter:before{content:'\\f700'}.fa-outdent:before{content:'\\f03b'}.fa-page4:before{content:'\\f3d7'}.fa-pagelines:before{content:'\\f18c'}.fa-pager:before{content:'\\f815'}.fa-paint-brush:before{content:'\\f1fc'}.fa-paint-roller:before{content:'\\f5aa'}.fa-palette:before{content:'\\f53f'}.fa-palfed:before{content:'\\f3d8'}.fa-pallet:before{content:'\\f482'}.fa-paper-plane:before{content:'\\f1d8'}.fa-paperclip:before{content:'\\f0c6'}.fa-parachute-box:before{content:'\\f4cd'}.fa-paragraph:before{content:'\\f1dd'}.fa-parking:before{content:'\\f540'}.fa-passport:before{content:'\\f5ab'}.fa-pastafarianism:before{content:'\\f67b'}.fa-paste:before{content:'\\f0ea'}.fa-patreon:before{content:'\\f3d9'}.fa-pause:before{content:'\\f04c'}.fa-pause-circle:before{content:'\\f28b'}.fa-paw:before{content:'\\f1b0'}.fa-paypal:before{content:'\\f1ed'}.fa-peace:before{content:'\\f67c'}.fa-pen:before{content:'\\f304'}.fa-pen-alt:before{content:'\\f305'}.fa-pen-fancy:before{content:'\\f5ac'}.fa-pen-nib:before{content:'\\f5ad'}.fa-pen-square:before{content:'\\f14b'}.fa-pencil-alt:before{content:'\\f303'}.fa-pencil-ruler:before{content:'\\f5ae'}.fa-penny-arcade:before{content:'\\f704'}.fa-people-carry:before{content:'\\f4ce'}.fa-pepper-hot:before{content:'\\f816'}.fa-percent:before{content:'\\f295'}.fa-percentage:before{content:'\\f541'}.fa-periscope:before{content:'\\f3da'}.fa-person-booth:before{content:'\\f756'}.fa-phabricator:before{content:'\\f3db'}.fa-phoenix-framework:before{content:'\\f3dc'}.fa-phoenix-squadron:before{content:'\\f511'}.fa-phone:before{content:'\\f095'}.fa-phone-alt:before{content:'\\f879'}.fa-phone-slash:before{content:'\\f3dd'}.fa-phone-square:before{content:'\\f098'}.fa-phone-square-alt:before{content:'\\f87b'}.fa-phone-volume:before{content:'\\f2a0'}.fa-photo-video:before{content:'\\f87c'}.fa-php:before{content:'\\f457'}.fa-pied-piper:before{content:'\\f2ae'}.fa-pied-piper-alt:before{content:'\\f1a8'}.fa-pied-piper-hat:before{content:'\\f4e5'}.fa-pied-piper-pp:before{content:'\\f1a7'}.fa-pied-piper-square:before{content:'\\f91e'}.fa-piggy-bank:before{content:'\\f4d3'}.fa-pills:before{content:'\\f484'}.fa-pinterest:before{content:'\\f0d2'}.fa-pinterest-p:before{content:'\\f231'}.fa-pinterest-square:before{content:'\\f0d3'}.fa-pizza-slice:before{content:'\\f818'}.fa-place-of-worship:before{content:'\\f67f'}.fa-plane:before{content:'\\f072'}.fa-plane-arrival:before{content:'\\f5af'}.fa-plane-departure:before{content:'\\f5b0'}.fa-play:before{content:'\\f04b'}.fa-play-circle:before{content:'\\f144'}.fa-playstation:before{content:'\\f3df'}.fa-plug:before{content:'\\f1e6'}.fa-plus:before{content:'\\f067'}.fa-plus-circle:before{content:'\\f055'}.fa-plus-square:before{content:'\\f0fe'}.fa-podcast:before{content:'\\f2ce'}.fa-poll:before{content:'\\f681'}.fa-poll-h:before{content:'\\f682'}.fa-poo:before{content:'\\f2fe'}.fa-poo-storm:before{content:'\\f75a'}.fa-poop:before{content:'\\f619'}.fa-portrait:before{content:'\\f3e0'}.fa-pound-sign:before{content:'\\f154'}.fa-power-off:before{content:'\\f011'}.fa-pray:before{content:'\\f683'}.fa-praying-hands:before{content:'\\f684'}.fa-prescription:before{content:'\\f5b1'}.fa-prescription-bottle:before{content:'\\f485'}.fa-prescription-bottle-alt:before{content:'\\f486'}.fa-print:before{content:'\\f02f'}.fa-procedures:before{content:'\\f487'}.fa-product-hunt:before{content:'\\f288'}.fa-project-diagram:before{content:'\\f542'}.fa-pushed:before{content:'\\f3e1'}.fa-puzzle-piece:before{content:'\\f12e'}.fa-python:before{content:'\\f3e2'}.fa-qq:before{content:'\\f1d6'}.fa-qrcode:before{content:'\\f029'}.fa-question:before{content:'\\f128'}.fa-question-circle:before{content:'\\f059'}.fa-quidditch:before{content:'\\f458'}.fa-quinscape:before{content:'\\f459'}.fa-quora:before{content:'\\f2c4'}.fa-quote-left:before{content:'\\f10d'}.fa-quote-right:before{content:'\\f10e'}.fa-quran:before{content:'\\f687'}.fa-r-project:before{content:'\\f4f7'}.fa-radiation:before{content:'\\f7b9'}.fa-radiation-alt:before{content:'\\f7ba'}.fa-rainbow:before{content:'\\f75b'}.fa-random:before{content:'\\f074'}.fa-raspberry-pi:before{content:'\\f7bb'}.fa-ravelry:before{content:'\\f2d9'}.fa-react:before{content:'\\f41b'}.fa-reacteurope:before{content:'\\f75d'}.fa-readme:before{content:'\\f4d5'}.fa-rebel:before{content:'\\f1d0'}.fa-receipt:before{content:'\\f543'}.fa-record-vinyl:before{content:'\\f8d9'}.fa-recycle:before{content:'\\f1b8'}.fa-red-river:before{content:'\\f3e3'}.fa-reddit:before{content:'\\f1a1'}.fa-reddit-alien:before{content:'\\f281'}.fa-reddit-square:before{content:'\\f1a2'}.fa-redhat:before{content:'\\f7bc'}.fa-redo:before{content:'\\f01e'}.fa-redo-alt:before{content:'\\f2f9'}.fa-registered:before{content:'\\f25d'}.fa-remove-format:before{content:'\\f87d'}.fa-renren:before{content:'\\f18b'}.fa-reply:before{content:'\\f3e5'}.fa-reply-all:before{content:'\\f122'}.fa-replyd:before{content:'\\f3e6'}.fa-republican:before{content:'\\f75e'}.fa-researchgate:before{content:'\\f4f8'}.fa-resolving:before{content:'\\f3e7'}.fa-restroom:before{content:'\\f7bd'}.fa-retweet:before{content:'\\f079'}.fa-rev:before{content:'\\f5b2'}.fa-ribbon:before{content:'\\f4d6'}.fa-ring:before{content:'\\f70b'}.fa-road:before{content:'\\f018'}.fa-robot:before{content:'\\f544'}.fa-rocket:before{content:'\\f135'}.fa-rocketchat:before{content:'\\f3e8'}.fa-rockrms:before{content:'\\f3e9'}.fa-route:before{content:'\\f4d7'}.fa-rss:before{content:'\\f09e'}.fa-rss-square:before{content:'\\f143'}.fa-ruble-sign:before{content:'\\f158'}.fa-ruler:before{content:'\\f545'}.fa-ruler-combined:before{content:'\\f546'}.fa-ruler-horizontal:before{content:'\\f547'}.fa-ruler-vertical:before{content:'\\f548'}.fa-running:before{content:'\\f70c'}.fa-rupee-sign:before{content:'\\f156'}.fa-sad-cry:before{content:'\\f5b3'}.fa-sad-tear:before{content:'\\f5b4'}.fa-safari:before{content:'\\f267'}.fa-salesforce:before{content:'\\f83b'}.fa-sass:before{content:'\\f41e'}.fa-satellite:before{content:'\\f7bf'}.fa-satellite-dish:before{content:'\\f7c0'}.fa-save:before{content:'\\f0c7'}.fa-schlix:before{content:'\\f3ea'}.fa-school:before{content:'\\f549'}.fa-screwdriver:before{content:'\\f54a'}.fa-scribd:before{content:'\\f28a'}.fa-scroll:before{content:'\\f70e'}.fa-sd-card:before{content:'\\f7c2'}.fa-search:before{content:'\\f002'}.fa-search-dollar:before{content:'\\f688'}.fa-search-location:before{content:'\\f689'}.fa-search-minus:before{content:'\\f010'}.fa-search-plus:before{content:'\\f00e'}.fa-searchengin:before{content:'\\f3eb'}.fa-seedling:before{content:'\\f4d8'}.fa-sellcast:before{content:'\\f2da'}.fa-sellsy:before{content:'\\f213'}.fa-server:before{content:'\\f233'}.fa-servicestack:before{content:'\\f3ec'}.fa-shapes:before{content:'\\f61f'}.fa-share:before{content:'\\f064'}.fa-share-alt:before{content:'\\f1e0'}.fa-share-alt-square:before{content:'\\f1e1'}.fa-share-square:before{content:'\\f14d'}.fa-shekel-sign:before{content:'\\f20b'}.fa-shield-alt:before{content:'\\f3ed'}.fa-ship:before{content:'\\f21a'}.fa-shipping-fast:before{content:'\\f48b'}.fa-shirtsinbulk:before{content:'\\f214'}.fa-shoe-prints:before{content:'\\f54b'}.fa-shopify:before{content:'\\f957'}.fa-shopping-bag:before{content:'\\f290'}.fa-shopping-basket:before{content:'\\f291'}.fa-shopping-cart:before{content:'\\f07a'}.fa-shopware:before{content:'\\f5b5'}.fa-shower:before{content:'\\f2cc'}.fa-shuttle-van:before{content:'\\f5b6'}.fa-sign:before{content:'\\f4d9'}.fa-sign-in-alt:before{content:'\\f2f6'}.fa-sign-language:before{content:'\\f2a7'}.fa-sign-out-alt:before{content:'\\f2f5'}.fa-signal:before{content:'\\f012'}.fa-signature:before{content:'\\f5b7'}.fa-sim-card:before{content:'\\f7c4'}.fa-simplybuilt:before{content:'\\f215'}.fa-sistrix:before{content:'\\f3ee'}.fa-sitemap:before{content:'\\f0e8'}.fa-sith:before{content:'\\f512'}.fa-skating:before{content:'\\f7c5'}.fa-sketch:before{content:'\\f7c6'}.fa-skiing:before{content:'\\f7c9'}.fa-skiing-nordic:before{content:'\\f7ca'}.fa-skull:before{content:'\\f54c'}.fa-skull-crossbones:before{content:'\\f714'}.fa-skyatlas:before{content:'\\f216'}.fa-skype:before{content:'\\f17e'}.fa-slack:before{content:'\\f198'}.fa-slack-hash:before{content:'\\f3ef'}.fa-slash:before{content:'\\f715'}.fa-sleigh:before{content:'\\f7cc'}.fa-sliders-h:before{content:'\\f1de'}.fa-slideshare:before{content:'\\f1e7'}.fa-smile:before{content:'\\f118'}.fa-smile-beam:before{content:'\\f5b8'}.fa-smile-wink:before{content:'\\f4da'}.fa-smog:before{content:'\\f75f'}.fa-smoking:before{content:'\\f48d'}.fa-smoking-ban:before{content:'\\f54d'}.fa-sms:before{content:'\\f7cd'}.fa-snapchat:before{content:'\\f2ab'}.fa-snapchat-ghost:before{content:'\\f2ac'}.fa-snapchat-square:before{content:'\\f2ad'}.fa-snowboarding:before{content:'\\f7ce'}.fa-snowflake:before{content:'\\f2dc'}.fa-snowman:before{content:'\\f7d0'}.fa-snowplow:before{content:'\\f7d2'}.fa-socks:before{content:'\\f696'}.fa-solar-panel:before{content:'\\f5ba'}.fa-sort:before{content:'\\f0dc'}.fa-sort-alpha-down:before{content:'\\f15d'}.fa-sort-alpha-down-alt:before{content:'\\f881'}.fa-sort-alpha-up:before{content:'\\f15e'}.fa-sort-alpha-up-alt:before{content:'\\f882'}.fa-sort-amount-down:before{content:'\\f160'}.fa-sort-amount-down-alt:before{content:'\\f884'}.fa-sort-amount-up:before{content:'\\f161'}.fa-sort-amount-up-alt:before{content:'\\f885'}.fa-sort-down:before{content:'\\f0dd'}.fa-sort-numeric-down:before{content:'\\f162'}.fa-sort-numeric-down-alt:before{content:'\\f886'}.fa-sort-numeric-up:before{content:'\\f163'}.fa-sort-numeric-up-alt:before{content:'\\f887'}.fa-sort-up:before{content:'\\f0de'}.fa-soundcloud:before{content:'\\f1be'}.fa-sourcetree:before{content:'\\f7d3'}.fa-spa:before{content:'\\f5bb'}.fa-space-shuttle:before{content:'\\f197'}.fa-speakap:before{content:'\\f3f3'}.fa-speaker-deck:before{content:'\\f83c'}.fa-spell-check:before{content:'\\f891'}.fa-spider:before{content:'\\f717'}.fa-spinner:before{content:'\\f110'}.fa-splotch:before{content:'\\f5bc'}.fa-spotify:before{content:'\\f1bc'}.fa-spray-can:before{content:'\\f5bd'}.fa-square:before{content:'\\f0c8'}.fa-square-full:before{content:'\\f45c'}.fa-square-root-alt:before{content:'\\f698'}.fa-squarespace:before{content:'\\f5be'}.fa-stack-exchange:before{content:'\\f18d'}.fa-stack-overflow:before{content:'\\f16c'}.fa-stackpath:before{content:'\\f842'}.fa-stamp:before{content:'\\f5bf'}.fa-star:before{content:'\\f005'}.fa-star-and-crescent:before{content:'\\f699'}.fa-star-half:before{content:'\\f089'}.fa-star-half-alt:before{content:'\\f5c0'}.fa-star-of-david:before{content:'\\f69a'}.fa-star-of-life:before{content:'\\f621'}.fa-staylinked:before{content:'\\f3f5'}.fa-steam:before{content:'\\f1b6'}.fa-steam-square:before{content:'\\f1b7'}.fa-steam-symbol:before{content:'\\f3f6'}.fa-step-backward:before{content:'\\f048'}.fa-step-forward:before{content:'\\f051'}.fa-stethoscope:before{content:'\\f0f1'}.fa-sticker-mule:before{content:'\\f3f7'}.fa-sticky-note:before{content:'\\f249'}.fa-stop:before{content:'\\f04d'}.fa-stop-circle:before{content:'\\f28d'}.fa-stopwatch:before{content:'\\f2f2'}.fa-store:before{content:'\\f54e'}.fa-store-alt:before{content:'\\f54f'}.fa-strava:before{content:'\\f428'}.fa-stream:before{content:'\\f550'}.fa-street-view:before{content:'\\f21d'}.fa-strikethrough:before{content:'\\f0cc'}.fa-stripe:before{content:'\\f429'}.fa-stripe-s:before{content:'\\f42a'}.fa-stroopwafel:before{content:'\\f551'}.fa-studiovinari:before{content:'\\f3f8'}.fa-stumbleupon:before{content:'\\f1a4'}.fa-stumbleupon-circle:before{content:'\\f1a3'}.fa-subscript:before{content:'\\f12c'}.fa-subway:before{content:'\\f239'}.fa-suitcase:before{content:'\\f0f2'}.fa-suitcase-rolling:before{content:'\\f5c1'}.fa-sun:before{content:'\\f185'}.fa-superpowers:before{content:'\\f2dd'}.fa-superscript:before{content:'\\f12b'}.fa-supple:before{content:'\\f3f9'}.fa-surprise:before{content:'\\f5c2'}.fa-suse:before{content:'\\f7d6'}.fa-swatchbook:before{content:'\\f5c3'}.fa-swift:before{content:'\\f8e1'}.fa-swimmer:before{content:'\\f5c4'}.fa-swimming-pool:before{content:'\\f5c5'}.fa-symfony:before{content:'\\f83d'}.fa-synagogue:before{content:'\\f69b'}.fa-sync:before{content:'\\f021'}.fa-sync-alt:before{content:'\\f2f1'}.fa-syringe:before{content:'\\f48e'}.fa-table:before{content:'\\f0ce'}.fa-table-tennis:before{content:'\\f45d'}.fa-tablet:before{content:'\\f10a'}.fa-tablet-alt:before{content:'\\f3fa'}.fa-tablets:before{content:'\\f490'}.fa-tachometer-alt:before{content:'\\f3fd'}.fa-tag:before{content:'\\f02b'}.fa-tags:before{content:'\\f02c'}.fa-tape:before{content:'\\f4db'}.fa-tasks:before{content:'\\f0ae'}.fa-taxi:before{content:'\\f1ba'}.fa-teamspeak:before{content:'\\f4f9'}.fa-teeth:before{content:'\\f62e'}.fa-teeth-open:before{content:'\\f62f'}.fa-telegram:before{content:'\\f2c6'}.fa-telegram-plane:before{content:'\\f3fe'}.fa-temperature-high:before{content:'\\f769'}.fa-temperature-low:before{content:'\\f76b'}.fa-tencent-weibo:before{content:'\\f1d5'}.fa-tenge:before{content:'\\f7d7'}.fa-terminal:before{content:'\\f120'}.fa-text-height:before{content:'\\f034'}.fa-text-width:before{content:'\\f035'}.fa-th:before{content:'\\f00a'}.fa-th-large:before{content:'\\f009'}.fa-th-list:before{content:'\\f00b'}.fa-the-red-yeti:before{content:'\\f69d'}.fa-theater-masks:before{content:'\\f630'}.fa-themeco:before{content:'\\f5c6'}.fa-themeisle:before{content:'\\f2b2'}.fa-thermometer:before{content:'\\f491'}.fa-thermometer-empty:before{content:'\\f2cb'}.fa-thermometer-full:before{content:'\\f2c7'}.fa-thermometer-half:before{content:'\\f2c9'}.fa-thermometer-quarter:before{content:'\\f2ca'}.fa-thermometer-three-quarters:before{content:'\\f2c8'}.fa-think-peaks:before{content:'\\f731'}.fa-thumbs-down:before{content:'\\f165'}.fa-thumbs-up:before{content:'\\f164'}.fa-thumbtack:before{content:'\\f08d'}.fa-ticket-alt:before{content:'\\f3ff'}.fa-times:before{content:'\\f00d'}.fa-times-circle:before{content:'\\f057'}.fa-tint:before{content:'\\f043'}.fa-tint-slash:before{content:'\\f5c7'}.fa-tired:before{content:'\\f5c8'}.fa-toggle-off:before{content:'\\f204'}.fa-toggle-on:before{content:'\\f205'}.fa-toilet:before{content:'\\f7d8'}.fa-toilet-paper:before{content:'\\f71e'}.fa-toolbox:before{content:'\\f552'}.fa-tools:before{content:'\\f7d9'}.fa-tooth:before{content:'\\f5c9'}.fa-torah:before{content:'\\f6a0'}.fa-torii-gate:before{content:'\\f6a1'}.fa-tractor:before{content:'\\f722'}.fa-trade-federation:before{content:'\\f513'}.fa-trademark:before{content:'\\f25c'}.fa-traffic-light:before{content:'\\f637'}.fa-trailer:before{content:'\\f941'}.fa-train:before{content:'\\f238'}.fa-tram:before{content:'\\f7da'}.fa-transgender:before{content:'\\f224'}.fa-transgender-alt:before{content:'\\f225'}.fa-trash:before{content:'\\f1f8'}.fa-trash-alt:before{content:'\\f2ed'}.fa-trash-restore:before{content:'\\f829'}.fa-trash-restore-alt:before{content:'\\f82a'}.fa-tree:before{content:'\\f1bb'}.fa-trello:before{content:'\\f181'}.fa-tripadvisor:before{content:'\\f262'}.fa-trophy:before{content:'\\f091'}.fa-truck:before{content:'\\f0d1'}.fa-truck-loading:before{content:'\\f4de'}.fa-truck-monster:before{content:'\\f63b'}.fa-truck-moving:before{content:'\\f4df'}.fa-truck-pickup:before{content:'\\f63c'}.fa-tshirt:before{content:'\\f553'}.fa-tty:before{content:'\\f1e4'}.fa-tumblr:before{content:'\\f173'}.fa-tumblr-square:before{content:'\\f174'}.fa-tv:before{content:'\\f26c'}.fa-twitch:before{content:'\\f1e8'}.fa-twitter:before{content:'\\f099'}.fa-twitter-square:before{content:'\\f081'}.fa-typo3:before{content:'\\f42b'}.fa-uber:before{content:'\\f402'}.fa-ubuntu:before{content:'\\f7df'}.fa-uikit:before{content:'\\f403'}.fa-umbraco:before{content:'\\f8e8'}.fa-umbrella:before{content:'\\f0e9'}.fa-umbrella-beach:before{content:'\\f5ca'}.fa-underline:before{content:'\\f0cd'}.fa-undo:before{content:'\\f0e2'}.fa-undo-alt:before{content:'\\f2ea'}.fa-uniregistry:before{content:'\\f404'}.fa-unity:before{content:'\\f949'}.fa-universal-access:before{content:'\\f29a'}.fa-university:before{content:'\\f19c'}.fa-unlink:before{content:'\\f127'}.fa-unlock:before{content:'\\f09c'}.fa-unlock-alt:before{content:'\\f13e'}.fa-untappd:before{content:'\\f405'}.fa-upload:before{content:'\\f093'}.fa-ups:before{content:'\\f7e0'}.fa-usb:before{content:'\\f287'}.fa-user:before{content:'\\f007'}.fa-user-alt:before{content:'\\f406'}.fa-user-alt-slash:before{content:'\\f4fa'}.fa-user-astronaut:before{content:'\\f4fb'}.fa-user-check:before{content:'\\f4fc'}.fa-user-circle:before{content:'\\f2bd'}.fa-user-clock:before{content:'\\f4fd'}.fa-user-cog:before{content:'\\f4fe'}.fa-user-edit:before{content:'\\f4ff'}.fa-user-friends:before{content:'\\f500'}.fa-user-graduate:before{content:'\\f501'}.fa-user-injured:before{content:'\\f728'}.fa-user-lock:before{content:'\\f502'}.fa-user-md:before{content:'\\f0f0'}.fa-user-minus:before{content:'\\f503'}.fa-user-ninja:before{content:'\\f504'}.fa-user-nurse:before{content:'\\f82f'}.fa-user-plus:before{content:'\\f234'}.fa-user-secret:before{content:'\\f21b'}.fa-user-shield:before{content:'\\f505'}.fa-user-slash:before{content:'\\f506'}.fa-user-tag:before{content:'\\f507'}.fa-user-tie:before{content:'\\f508'}.fa-user-times:before{content:'\\f235'}.fa-users:before{content:'\\f0c0'}.fa-users-cog:before{content:'\\f509'}.fa-usps:before{content:'\\f7e1'}.fa-ussunnah:before{content:'\\f407'}.fa-utensil-spoon:before{content:'\\f2e5'}.fa-utensils:before{content:'\\f2e7'}.fa-vaadin:before{content:'\\f408'}.fa-vector-square:before{content:'\\f5cb'}.fa-venus:before{content:'\\f221'}.fa-venus-double:before{content:'\\f226'}.fa-venus-mars:before{content:'\\f228'}.fa-viacoin:before{content:'\\f237'}.fa-viadeo:before{content:'\\f2a9'}.fa-viadeo-square:before{content:'\\f2aa'}.fa-vial:before{content:'\\f492'}.fa-vials:before{content:'\\f493'}.fa-viber:before{content:'\\f409'}.fa-video:before{content:'\\f03d'}.fa-video-slash:before{content:'\\f4e2'}.fa-vihara:before{content:'\\f6a7'}.fa-vimeo:before{content:'\\f40a'}.fa-vimeo-square:before{content:'\\f194'}.fa-vimeo-v:before{content:'\\f27d'}.fa-vine:before{content:'\\f1ca'}.fa-vk:before{content:'\\f189'}.fa-vnv:before{content:'\\f40b'}.fa-voicemail:before{content:'\\f897'}.fa-volleyball-ball:before{content:'\\f45f'}.fa-volume-down:before{content:'\\f027'}.fa-volume-mute:before{content:'\\f6a9'}.fa-volume-off:before{content:'\\f026'}.fa-volume-up:before{content:'\\f028'}.fa-vote-yea:before{content:'\\f772'}.fa-vr-cardboard:before{content:'\\f729'}.fa-vuejs:before{content:'\\f41f'}.fa-walking:before{content:'\\f554'}.fa-wallet:before{content:'\\f555'}.fa-warehouse:before{content:'\\f494'}.fa-water:before{content:'\\f773'}.fa-wave-square:before{content:'\\f83e'}.fa-waze:before{content:'\\f83f'}.fa-weebly:before{content:'\\f5cc'}.fa-weibo:before{content:'\\f18a'}.fa-weight:before{content:'\\f496'}.fa-weight-hanging:before{content:'\\f5cd'}.fa-weixin:before{content:'\\f1d7'}.fa-whatsapp:before{content:'\\f232'}.fa-whatsapp-square:before{content:'\\f40c'}.fa-wheelchair:before{content:'\\f193'}.fa-whmcs:before{content:'\\f40d'}.fa-wifi:before{content:'\\f1eb'}.fa-wikipedia-w:before{content:'\\f266'}.fa-wind:before{content:'\\f72e'}.fa-window-close:before{content:'\\f410'}.fa-window-maximize:before{content:'\\f2d0'}.fa-window-minimize:before{content:'\\f2d1'}.fa-window-restore:before{content:'\\f2d2'}.fa-windows:before{content:'\\f17a'}.fa-wine-bottle:before{content:'\\f72f'}.fa-wine-glass:before{content:'\\f4e3'}.fa-wine-glass-alt:before{content:'\\f5ce'}.fa-wix:before{content:'\\f5cf'}.fa-wizards-of-the-coast:before{content:'\\f730'}.fa-wolf-pack-battalion:before{content:'\\f514'}.fa-won-sign:before{content:'\\f159'}.fa-wordpress:before{content:'\\f19a'}.fa-wordpress-simple:before{content:'\\f411'}.fa-wpbeginner:before{content:'\\f297'}.fa-wpexplorer:before{content:'\\f2de'}.fa-wpforms:before{content:'\\f298'}.fa-wpressr:before{content:'\\f3e4'}.fa-wrench:before{content:'\\f0ad'}.fa-x-ray:before{content:'\\f497'}.fa-xbox:before{content:'\\f412'}.fa-xing:before{content:'\\f168'}.fa-xing-square:before{content:'\\f169'}.fa-y-combinator:before{content:'\\f23b'}.fa-yahoo:before{content:'\\f19e'}.fa-yammer:before{content:'\\f840'}.fa-yandex:before{content:'\\f413'}.fa-yandex-international:before{content:'\\f414'}.fa-yarn:before{content:'\\f7e3'}.fa-yelp:before{content:'\\f1e9'}.fa-yen-sign:before{content:'\\f157'}.fa-yin-yang:before{content:'\\f6ad'}.fa-yoast:before{content:'\\f2b1'}.fa-youtube:before{content:'\\f167'}.fa-youtube-square:before{content:'\\f431'}.fa-zhihu:before{content:'\\f63f'}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}@font-face{font-family:'Font Awesome 5 Brands';font-style:normal;font-weight:400;font-display:auto;src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.eot);src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.eot?#iefix) format('embedded-opentype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.woff2) format('woff2'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.woff) format('woff'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.ttf) format('truetype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-brands-400.svg#fontawesome) format('svg')}.fab{font-family:'Font Awesome 5 Brands'}@font-face{font-family:'Font Awesome 5 Free';font-style:normal;font-weight:400;font-display:auto;src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.eot);src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.eot?#iefix) format('embedded-opentype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.woff2) format('woff2'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.woff) format('woff'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.ttf) format('truetype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-regular-400.svg#fontawesome) format('svg')}.fab,.far{font-weight:400}@font-face{font-family:'Font Awesome 5 Free';font-style:normal;font-weight:900;font-display:auto;src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.eot);src:url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.eot?#iefix) format('embedded-opentype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.woff2) format('woff2'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.woff) format('woff'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.ttf) format('truetype'),url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/webfonts/fa-solid-900.svg#fontawesome) format('svg')}.fa,.far,.fas{font-family:'Font Awesome 5 Free'}.fa,.fas{font-weight:900}"],data:{}});function rl(e){return ga(0,[(e()(),na(0,0,null,null,0,"div",[["class","backdrop"]],null,null,null,null,null))],null,null)}function al(e){return ga(0,[(e()(),na(0,0,null,null,1,"button",[["class","happiClose"],["type","button"]],null,[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.featureHide()&&o),o},null,null)),(e()(),pa(-1,null,[" × "]))],null,null)}function il(e){return ga(0,[(e()(),na(0,0,null,null,0,"div",[["class","feedbkimg float-right"]],null,null,null,null,null))],null,null)}function ll(e){return ga(0,[(e()(),na(0,0,null,null,1,"span",[],null,null,null,null,null)),(e()(),pa(1,null,["",""]))],null,function(e,t){e(t,1,0,t.component.showErrorMsg)})}function sl(e){return ga(0,[(e()(),na(0,0,null,null,2,null,null,null,null,null,null,null)),(e()(),na(1,0,null,null,1,"span",[],null,null,null,null,null)),(e()(),pa(-1,null,["Something went wrong.Please try after sometime !"]))],null,null)}function cl(e){return ga(0,[(e()(),na(0,0,null,null,7,"div",[["class","error"],["style","background-color: red;\n          font-weight: normal;\n          border: 1px solid red;\n          padding: 5px;\n          font-size: 15px;\n          margin-bottom: 0px;\n          position: absolute;\n          top: 66px;\n          width: 100%;\n          left: 0;\n          z-index: 9999;\n          display: flex;\n          align-items: center;\n          color: white;"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,ll)),jo(2,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,sl)),jo(4,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(5,0,null,null,2,"div",[["style","cursor: pointer;display: inline-flex;align-items:center;justify-content:center;width: 30px;height: 30px;border-radius: 50%;border: 1px solid #fff;\n                  background-color: #fff;\n                  color: #f00;\n                  font-size: 24px;"]],null,[[null,"click"]],function(e,t,n){var o=!0,r=e.component;return"click"===t&&(r.backEndError=!1,o=!1!==(r.showErrorMsg="")&&o),o},null,null)),(e()(),na(6,0,null,null,1,"span",[["style","padding-bottom: 5px;"]],null,null,null,null,null)),(e()(),pa(-1,null,["×"]))],function(e,t){var n=t.component;e(t,2,0,n.showErrorMsg),e(t,4,0,!n.showErrorMsg)},null)}function fl(e){return ga(0,[(e()(),na(0,0,null,null,1,"div",[["style","color:red;"]],null,null,null,null,null)),(e()(),pa(-1,null,[" Please select the rating "]))],null,null)}function dl(e){return ga(0,[(e()(),na(0,0,null,null,2,"textarea",[["class","comment-section"],["maxlength","200"]],[[8,"placeholder",0]],[[null,"input"]],function(e,t,n){var o=!0;return"input"===t&&(o=!1!==(e.component.descriptionScreenshot=n.target.value)&&o),o},null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(2,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null)],function(e,t){e(t,2,0,"comment-section",t.component.showScreenShot?"comment-section":"comment-section no-screenShot")},function(e,t){e(t,0,0,Qn(1,"",t.parent.parent.parent.parent.parent.context.$implicit.pluginData.pluginComment,""))})}function ul(e){return ga(0,[(e()(),na(0,0,null,null,1,"div",[["style","color:#ff0000;font-size:10px;text-align:left;margin-left:25px;"]],null,null,null,null,null)),(e()(),pa(1,null,[" "," "]))],null,function(e,t){e(t,1,0,t.parent.parent.parent.parent.context.$implicit.mgs1)})}function ml(e){return ga(0,[(e()(),na(0,0,null,null,3,"span",[["class","custom-file-upload"]],null,[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.resetScreenshot()&&o),o},null,null)),(e()(),pa(1,null,["",""])),(e()(),na(2,0,null,null,1,"span",[["style","font-size:20px; vertical-align: super;\n                          font-weight: 600;"]],null,null,null,null,null)),(e()(),pa(-1,null,["×"]))],null,function(e,t){e(t,1,0,t.component.screenShotName)})}function pl(e){return ga(0,[(e()(),na(0,0,null,null,5,"div",[["style","text-align:right;"]],null,null,null,null,null)),(e()(),na(1,0,null,null,1,"label",[["class","custom-file-upload"],["for","file-upload"]],null,null,null,null,null)),(e()(),na(2,0,null,null,0,"img",[["src","https://app-ufo.gke.ope.gcp.renault.com/assets/attachment.png"],["style","width:35px; height:25px; padding-right:2px;"]],[[8,"alt",0],[8,"title",0]],null,null,null,null)),(e()(),na(3,0,[["fileInput",1]],null,0,"input",[["accept","image/*"],["id","file-upload"],["type","file"]],[[8,"title",0]],[[null,"click"],[null,"change"]],function(e,t,n){var o=!0,r=e.component;return"click"===t&&(o=!1!==((function(e){const t=e.def.nodes[3];if(1&t.flags){const n=mn(e,t.nodeIndex);return t.element.template?n.template:n.renderElement}if(2&t.flags)return un(e,t.nodeIndex).renderText;if(20240&t.flags)return pn(e,t.nodeIndex).instance;throw new Error("Illegal state: read nodeValue for node index 3")}(e)).value=null)&&o),"change"===t&&(o=!1!==r.imageConvert(n)&&o),o},null,null)),(e()(),ta(16777216,null,null,1,null,ml)),jo(5,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null)],function(e,t){e(t,5,0,t.component.screenShotName)},function(e,t){e(t,2,0,Qn(1,"",t.parent.parent.parent.parent.context.$implicit.mgs2,""),Qn(1,"",t.parent.parent.parent.parent.context.$implicit.mgs2,"")),e(t,3,0,Qn(1,"",t.parent.parent.parent.parent.context.$implicit.mgs2,""))})}function bl(e){return ga(0,[(e()(),na(0,0,null,null,7,"div",[["class","pt-3 d-block screenShot-content"]],null,null,null,null,null)),(e()(),na(1,0,null,null,6,"div",[["class","screenshot-feedback"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,dl)),jo(3,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,ul)),jo(5,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,pl)),jo(7,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null)],function(e,t){var n=t.component;e(t,3,0,n.showComments),e(t,5,0,n.showComments&&(n.emojiAngry||n.emojiSad)&&(null==n.descriptionScreenshot?null:n.descriptionScreenshot.length)<10),e(t,7,0,n.showScreenShot)},null)}function hl(e){return ga(0,[(e()(),na(0,0,null,null,4,"a",[["href","javascript:void(0);"],["style","color:#000000"]],null,[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.showQu()&&o),o},null,null)),(e()(),na(1,0,null,null,3,"b",[],null,null,null,null,null)),(e()(),pa(2,null,["",""])),(e()(),na(3,0,null,null,1,"span",[["style","color:#ff0000"]],null,null,null,null,null)),(e()(),pa(-1,null,["*"]))],null,function(e,t){e(t,2,0,t.parent.parent.parent.parent.context.$implicit.pluginData.pluginSurveyDescription)})}function gl(e){return ga(0,[(e()(),na(0,0,null,null,3,"a",[["href","javascript:void(0);"],["style","color:#000000"]],null,null,null,null,null)),(e()(),pa(1,null,["",""])),(e()(),na(2,0,null,null,1,"span",[["style","color:#ff0000"]],null,null,null,null,null)),(e()(),pa(-1,null,["*"]))],null,function(e,t){e(t,1,0,t.parent.parent.parent.parent.context.$implicit.pluginData.pluginSurveyDescription)})}function xl(e){return ga(0,[(e()(),na(0,0,null,null,51,null,null,null,null,null,null,null)),(e()(),na(1,0,null,null,1,"div",[["class","margin-bottom-16"]],null,null,null,null,null)),(e()(),pa(2,null,[" "," "])),(e()(),na(3,0,null,null,39,"div",[["class","smileys margin-bottom-16"]],null,null,null,null,null)),(e()(),na(4,0,null,null,9,"div",[["class","emoji  emoji--angry"]],[[1,"data-emojiAngry",0]],null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(6,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(7,{selected:0,hovered:1}),(e()(),na(8,0,null,null,0,"input",[["name","tired"],["type","radio"]],null,[[null,"mouseleave"],[null,"mouseover"],[null,"change"]],function(e,t,n){var o=!0,r=e.component;return"mouseleave"===t&&(o=0!=(r.emojiAngryHov=!1)&&o),"mouseover"===t&&(r.changeEmHov(),o=0!=(r.emojiAngryHov=!0)&&o),"change"===t&&(r.changeEmoji(1),o=0!=(r.emojiAngry=!0)&&o),o},null,null)),(e()(),na(9,0,null,null,0,"div",[["class","check"]],null,null,null,null,null)),(e()(),na(10,0,null,null,3,"div",[["class","emoji__face"]],null,null,null,null,null)),(e()(),na(11,0,null,null,0,"div",[["class","emoji__eyebrows"]],null,null,null,null,null)),(e()(),na(12,0,null,null,0,"div",[["class","emoji__eyes"]],null,null,null,null,null)),(e()(),na(13,0,null,null,0,"div",[["class","emoji__mouth"]],null,null,null,null,null)),(e()(),na(14,0,null,null,9,"div",[["class","emoji  emoji--sad"]],[[1,"data-emojiSad",0]],null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(16,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(17,{selected:0,hovered:1}),(e()(),na(18,0,null,null,0,"input",[["name","tired"],["type","radio"]],null,[[null,"mouseleave"],[null,"mouseover"],[null,"change"]],function(e,t,n){var o=!0,r=e.component;return"mouseleave"===t&&(o=0!=(r.emojiSadHov=!1)&&o),"mouseover"===t&&(r.changeEmHov(),o=0!=(r.emojiSadHov=!0)&&o),"change"===t&&(r.changeEmoji(2),o=0!=(r.emojiSad=!0)&&o),o},null,null)),(e()(),na(19,0,null,null,0,"div",[["class","check"]],null,null,null,null,null)),(e()(),na(20,0,null,null,3,"div",[["class","emoji__face"]],null,null,null,null,null)),(e()(),na(21,0,null,null,0,"div",[["class","emoji__eyebrows"]],null,null,null,null,null)),(e()(),na(22,0,null,null,0,"div",[["class","emoji__eyes"]],null,null,null,null,null)),(e()(),na(23,0,null,null,0,"div",[["class","emoji__mouth"]],null,null,null,null,null)),(e()(),na(24,0,null,null,8,"div",[["class","emoji  emoji--yay"]],[[1,"data-emojiYay",0]],null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(26,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(27,{selected:0,hovered:1}),(e()(),na(28,0,null,null,0,"input",[["name","tired"],["type","radio"]],null,[[null,"mouseleave"],[null,"mouseover"],[null,"change"]],function(e,t,n){var o=!0,r=e.component;return"mouseleave"===t&&(o=0!=(r.emojiYayHov=!1)&&o),"mouseover"===t&&(r.changeEmHov(),o=0!=(r.emojiYayHov=!0)&&o),"change"===t&&(r.changeEmoji(3),o=0!=(r.emojiYay=!0)&&o),o},null,null)),(e()(),na(29,0,null,null,0,"div",[["class","check"]],null,null,null,null,null)),(e()(),na(30,0,null,null,2,"div",[["class","emoji__face"]],null,null,null,null,null)),(e()(),na(31,0,null,null,0,"div",[["class","emoji__eyebrows"]],null,null,null,null,null)),(e()(),na(32,0,null,null,0,"div",[["class","emoji__mouth"]],null,null,null,null,null)),(e()(),na(33,0,null,null,9,"div",[["class","emoji  emoji--wow"]],[[1,"data-emojiWow",0]],null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(35,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(36,{selected:0,hovered:1}),(e()(),na(37,0,null,null,0,"input",[["name","tired"],["type","radio"]],null,[[null,"mouseleave"],[null,"mouseover"],[null,"change"]],function(e,t,n){var o=!0,r=e.component;return"mouseleave"===t&&(o=0!=(r.emojiWowHov=!1)&&o),"mouseover"===t&&(r.changeEmHov(),o=0!=(r.emojiWowHov=!0)&&o),"change"===t&&(r.changeEmoji(4),o=0!=(r.emojiWow=!0)&&o),o},null,null)),(e()(),na(38,0,null,null,0,"div",[["class","check"]],null,null,null,null,null)),(e()(),na(39,0,null,null,3,"div",[["class","emoji__face"]],null,null,null,null,null)),(e()(),na(40,0,null,null,0,"div",[["class","emoji__eyebrows"]],null,null,null,null,null)),(e()(),na(41,0,null,null,0,"div",[["class","emoji__eyes"]],null,null,null,null,null)),(e()(),na(42,0,null,null,0,"div",[["class","emoji__mouth"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,fl)),jo(44,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,bl)),jo(46,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(47,0,null,null,4,"div",[["class","pt-3 d-block questions-link"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,hl)),jo(49,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,gl)),jo(51,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null)],function(e,t){var n=t.component,o=e(t,7,0,n.emojiAngry,n.emojiAngryHov);e(t,6,0,"emoji  emoji--angry",o);var r=e(t,17,0,n.emojiSad,n.emojiSadHov);e(t,16,0,"emoji  emoji--sad",r);var a=e(t,27,0,n.emojiYay,n.emojiYayHov);e(t,26,0,"emoji  emoji--yay",a);var i=e(t,36,0,n.emojiWow,n.emojiWowHov);e(t,35,0,"emoji  emoji--wow",i),e(t,44,0,!n.rating&&n.invalidTrigger),e(t,46,0,n.emojiSelected),e(t,49,0,n.showQuestionsFlag&&n.showQuestionLink&&(!(n.emojiAngry||n.emojiSad)||!n.showComments||(n.emojiAngry||n.emojiSad)&&(null==n.descriptionScreenshot?null:n.descriptionScreenshot.length)>=10)),e(t,51,0,n.showQuestionsFlag&&n.showQuestionLink&&n.showComments&&(n.emojiAngry||n.emojiSad)&&(null==n.descriptionScreenshot?null:n.descriptionScreenshot.length)<10)},function(e,t){e(t,2,0,t.parent.parent.parent.context.$implicit.pluginData.pluginDescription||"We would like your feedback to improve the website"),e(t,4,0,t.parent.parent.parent.context.$implicit.pluginData.pluginEmoji1),e(t,14,0,t.parent.parent.parent.context.$implicit.pluginData.pluginEmoji2),e(t,24,0,t.parent.parent.parent.context.$implicit.pluginData.pluginEmoji3),e(t,33,0,t.parent.parent.parent.context.$implicit.pluginData.pluginEmoji4)})}function wl(e){return ga(0,[(e()(),na(0,0,null,null,4,"div",[["class","options relative"]],null,null,null,null,null)),(e()(),na(1,0,null,null,0,"input",[["type","radio"]],[[8,"value",0],[8,"name",0]],[[null,"change"]],function(e,t,n){var o=!0;return"change"===t&&(o=!1!==e.component.goToNextQues(e.parent.parent.context.$implicit,e.parent.parent.context.index,n)&&o),o},null,null)),(e()(),na(2,0,null,null,0,"div",[["class","radio-check"]],null,null,null,null,null)),(e()(),na(3,0,null,null,1,"span",[],null,null,null,null,null)),(e()(),pa(4,null,["",""]))],null,function(e,t){e(t,1,0,t.context.$implicit,Qn(1,"question",t.parent.parent.context.index,"")),e(t,4,0,t.context.$implicit)})}function yl(e){return ga(0,[(e()(),na(0,0,null,null,2,null,null,null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,wl)),jo(2,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null),(e()(),ta(0,null,null,0))],function(e,t){var n=null==t.parent.context.$implicit||null==t.parent.context.$implicit.option||null==t.parent.context.$implicit.option.choices?null:t.parent.context.$implicit.option.choices.split(",");e(t,2,0,n)},null)}function vl(e){return ga(0,[(e()(),na(0,0,null,null,4,"div",[["class","options relative"]],null,null,null,null,null)),(e()(),na(1,0,null,null,0,"input",[["type","radio"]],[[8,"value",0],[8,"name",0]],[[null,"change"]],function(e,t,n){var o=!0;return"change"===t&&(o=!1!==e.component.goToNextQues(e.parent.parent.context.$implicit,e.parent.parent.context.index,n)&&o),o},null,null)),(e()(),na(2,0,null,null,0,"div",[["class","radio-check"]],null,null,null,null,null)),(e()(),na(3,0,null,null,1,"span",[],null,null,null,null,null)),(e()(),pa(4,null,["",""]))],null,function(e,t){e(t,1,0,t.context.$implicit,Qn(1,"question",t.parent.parent.context.index,"")),e(t,4,0,t.context.$implicit)})}function kl(e){return ga(0,[(e()(),na(0,0,null,null,2,null,null,null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,vl)),jo(2,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null),(e()(),ta(0,null,null,0))],function(e,t){e(t,2,0,t.component.splitOptions(null==t.parent.context.$implicit||null==t.parent.context.$implicit.option?null:t.parent.context.$implicit.option.description))},null)}function _l(e){return ga(0,[(e()(),na(0,0,null,null,2,null,null,null,null,null,null,null)),(e()(),na(1,0,null,null,1,"div",[["class","options relative"]],null,null,null,null,null)),(e()(),na(2,0,null,null,0,"textarea",[["class","textarea-new"],["cols","30"],["maxlength","300"],["name","comments"],["rows","10"]],[[8,"id",0],[8,"placeholder",0]],[[null,"focusout"]],function(e,t,n){var o=!0;return"focusout"===t&&(o=!1!==e.component.goToNextQues(e.parent.context.$implicit,e.parent.context.index,n)&&o),o},null,null))],null,function(e,t){e(t,2,0,Qn(1,"comments",t.parent.context.index,""),Qn(1,"",t.parent.parent.parent.parent.context.$implicit.mgs3,""))})}function Cl(e){return ga(0,[(e()(),na(0,0,[[1,0],["questionsTag",1]],null,13,"div",[],null,null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(2,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(3,{show:0}),(e()(),na(4,0,null,null,1,"div",[["class","question-text"]],null,null,null,null,null)),(e()(),pa(5,null,["",": ",""])),(e()(),na(6,0,null,null,7,null,null,null,null,null,null,null)),jo(7,16384,null,0,Gi,[],{ngSwitch:[0,"ngSwitch"]},null),(e()(),ta(16777216,null,null,1,null,yl)),jo(9,278528,null,0,Yi,[rn,nn,Gi],{ngSwitchCase:[0,"ngSwitchCase"]},null),(e()(),ta(16777216,null,null,1,null,kl)),jo(11,278528,null,0,Yi,[rn,nn,Gi],{ngSwitchCase:[0,"ngSwitchCase"]},null),(e()(),ta(16777216,null,null,1,null,_l)),jo(13,278528,null,0,Yi,[rn,nn,Gi],{ngSwitchCase:[0,"ngSwitchCase"]},null)],function(e,t){var n=Qn(1,"question-new question-",t.context.index,""),o=e(t,3,0,t.context.first);e(t,2,0,n,o),e(t,7,0,null==t.context.$implicit||null==t.context.$implicit.option?null:t.context.$implicit.option.id),e(t,9,0,3),e(t,11,0,1),e(t,13,0,2)},function(e,t){e(t,5,0,t.context.index+1,t.context.$implicit.description)})}function El(e){return ga(0,[(e()(),na(0,0,[[2,0],["questionsTabTag",1]],null,2,"div",[["class","questions-tab"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,Cl)),jo(2,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null)],function(e,t){e(t,2,0,t.component.questions)},null)}function Tl(e){return ga(0,[(e()(),na(0,0,null,null,1,"div",[["class","thanks-note"]],null,null,null,null,null)),(e()(),pa(1,null,[" "," "]))],null,function(e,t){e(t,1,0,t.parent.parent.context.$implicit.mgs5)})}function Sl(e){return ga(0,[(e()(),na(0,0,null,null,1,"div",[["class","progress-bar"]],null,null,null,null,null)),(e()(),na(1,0,null,null,0,"div",[["class","fill"]],[[4,"width",null]],null,null,null,null))],null,function(e,t){e(t,1,0,t.component.dynamicWidth+"%")})}function Nl(e){return ga(0,[(e()(),na(0,0,null,null,1,"span",[["class","count-question"]],null,null,null,null,null)),(e()(),pa(1,null,[""," of "," ",""]))],null,function(e,t){var n=t.component;e(t,1,0,n.questionCount,null==n.questions?null:n.questions.length,t.parent.parent.context.$implicit.mgs4)})}function jl(e){return ga(0,[(e()(),na(0,0,null,null,0,"i",[["class","far fas fa fa-spinner"]],null,null,null,null,null))],null,null)}function Il(e){return ga(0,[(e()(),na(0,0,[[4,0],["replaceTag",1]],null,0,"i",[["class","far fa-paper-plane fa-lg replace"]],null,null,null,null,null))],null,null)}function Dl(e){return ga(0,[(e()(),na(0,0,[[3,0],["planeTag",1]],null,0,"i",[["class","far fa-paper-plane plane fa-lg hidden"]],null,null,null,null,null))],null,null)}function Ml(e){return ga(0,[(e()(),na(0,0,null,null,41,"div",[["class","reanult-feedback feedback-container text-center"]],null,null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(2,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(3,{"pr-0":0,"no-selection":1}),(e()(),ta(16777216,null,null,1,null,cl)),jo(5,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,xl)),jo(7,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,El)),jo(9,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,Tl)),jo(11,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(12,0,null,null,24,"div",[["class","btn-container"]],null,null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(14,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(15,{"hide-btn":0,"show-bg":1}),Io(512,null,Ki,Xi,[zt,Xt,Pt]),jo(17,278528,null,0,el,[Ki],{ngStyle:[0,"ngStyle"]},null),ma(18,{"background-color":0,left:1,width:2}),(e()(),ta(16777216,null,null,1,null,Sl)),jo(20,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,Nl)),jo(22,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(23,0,null,null,13,"button",[["class","btn btn-warning my-3 submit-btn"]],[[8,"disabled",0]],[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.submit()&&o),o},null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(25,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(26,{"hide-bg":0}),Io(512,null,Ki,Xi,[zt,Xt,Pt]),jo(28,278528,null,0,el,[Ki],{ngStyle:[0,"ngStyle"]},null),ma(29,{"background-color":0,"border-color":1,color:2}),(e()(),ta(16777216,null,null,1,null,jl)),jo(31,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),pa(32,null,[" "," "])),(e()(),ta(16777216,null,null,1,null,Il)),jo(34,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,Dl)),jo(36,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(37,0,null,null,4,"div",[["class","poweredby"]],null,null,null,null,null)),(e()(),na(38,0,null,null,0,"img",[["src","https://app-ufo.gke.ope.gcp.renault.com/assets/powered.png"],["style","width:20px; height:25px; background:#1e5799"]],null,null,null,null,null)),(e()(),pa(39,null,[" "," HAPPI -"])),(e()(),na(40,0,null,null,1,"span",[],null,null,null,null,null)),(e()(),pa(-1,null,[" 2023_R1"]))],function(e,t){var n=t.component,o=e(t,3,0,n.showQuestions,n.hideBtn);e(t,2,0,"reanult-feedback feedback-container text-center",o),e(t,5,0,n.backEndError||n.showErrorMsg),e(t,7,0,!n.showQuestions),e(t,9,0,n.showQuestions&&!n.thanksNote),e(t,11,0,n.thanksNote);var r=e(t,15,0,n.thanksNote,n.showQuestions);e(t,14,0,"btn-container",r);var a=e(t,18,0,n.pluginColor,"-15px","104%");e(t,17,0,a),e(t,20,0,n.showQuestions&&!n.thanksNote),e(t,22,0,n.showQuestions&&!n.thanksNote);var i=e(t,26,0,n.thanksNote||n.hideBtn);e(t,25,0,"btn btn-warning my-3 submit-btn",i);var l=e(t,29,0,n.pluginColor,n.pluginColor,n.pluginColor);e(t,28,0,l),e(t,31,0,n.inProgress),e(t,34,0,!n.hideBtn),e(t,36,0,!n.hideBtn)},function(e,t){var n=t.component;e(t,23,0,!n.rating||n.showErrorMsg||n.inProgress||n.showComments&&(n.emojiAngry||n.emojiSad)&&(null==n.descriptionScreenshot?null:n.descriptionScreenshot.length)<10||n.showQuestionsFlag&&n.showQuestionLink&&!n.showQuestions),e(t,32,0,n.thanksNote?"":t.parent.parent.context.$implicit.pluginData.pluginSubmit),e(t,39,0,t.parent.context.$implicit.mgs6)})}function Fl(e){return ga(0,[(e()(),na(0,0,null,null,24,"div",[],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,al)),jo(2,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),na(3,0,null,null,19,"div",[["class","card text-white feedback-btn"]],null,[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.showOverlay()&&o),o},null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(5,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(6,{fixed:0}),Io(512,null,Ki,Xi,[zt,Xt,Pt]),jo(8,278528,null,0,el,[Ki],{ngStyle:[0,"ngStyle"]},null),ma(9,{"background-color":0}),(e()(),na(10,0,null,null,12,"div",[["class","card-body"]],null,null,null,null,null)),Io(512,null,Ki,Xi,[zt,Xt,Pt]),jo(12,278528,null,0,el,[Ki],{ngStyle:[0,"ngStyle"]},null),ma(13,{"background-color":0}),(e()(),na(14,0,null,null,1,"b",[["id","provide-header"]],null,null,null,null,null)),(e()(),pa(15,null,["",""])),(e()(),na(16,0,null,null,4,"button",[["class","close1"],["type","button"]],null,[[null,"click"]],function(e,t,n){var o=!0;return"click"===t&&(o=!1!==e.component.showOverlay(n)&&o),o},null,null)),Io(512,null,Ki,Xi,[zt,Xt,Pt]),jo(18,278528,null,0,el,[Ki],{ngStyle:[0,"ngStyle"]},null),ma(19,{color:0}),(e()(),pa(-1,null,[" × "])),(e()(),ta(16777216,null,null,1,null,il)),jo(22,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,Ml)),jo(24,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null)],function(e,t){var n=t.component;e(t,2,0,!n.triggerId);var o=e(t,6,0,n.showAttachOverlay);e(t,5,0,"card text-white feedback-btn",o);var r=e(t,9,0,n.pluginColor);e(t,8,0,r);var a=e(t,13,0,n.pluginColor);e(t,12,0,a);var i=e(t,19,0,n.pluginColor);e(t,18,0,i),e(t,22,0,!n.triggerId),e(t,24,0,n.showAttachOverlay)},function(e,t){e(t,15,0,t.parent.context.$implicit.pluginData.pluginHeader)})}function zl(e){return ga(0,[(e()(),na(0,0,null,null,5,"div",[["class","content"]],null,null,null,null,null)),Io(512,null,Pi,Li,[Kt,Xt,zt,Pt]),jo(2,278528,null,0,Vi,[Pi],{klass:[0,"klass"],ngClass:[1,"ngClass"]},null),ma(3,{translateAttach:0}),(e()(),ta(16777216,null,null,1,null,Fl)),jo(5,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null)],function(e,t){var n=t.component,o=e(t,3,0,n.showAttachOverlay);e(t,2,0,"content",o),e(t,5,0,n.defaultPluginDetails)},null)}function Al(e){return ga(0,[(e()(),na(0,0,null,null,2,"div",[],[[8,"hidden",0]],null,null,null,null)),(e()(),ta(16777216,null,null,1,null,zl)),jo(2,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null)],function(e,t){e(t,2,0,t.component.pluginDetails)},function(e,t){e(t,0,0,!t.component.isShow)})}function Ol(e){return ga(0,[(e()(),na(0,0,null,null,4,"div",[["id","renaultNgFeedbackContainer"]],null,null,null,null,null)),(e()(),ta(16777216,null,null,1,null,rl)),jo(2,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null),(e()(),ta(16777216,null,null,1,null,Al)),jo(4,278528,null,0,Zi,[rn,nn,Kt],{ngForOf:[0,"ngForOf"]},null)],function(e,t){var n=t.component;e(t,2,0,n.showAttachOverlay),e(t,4,0,n.defaultPluginDetails)},null)}function Rl(e){return ga(0,[la(671088640,1,{questionsTag:1}),la(671088640,2,{questionsTabTag:0}),la(671088640,3,{planeTag:0}),la(671088640,4,{replaceTag:0}),la(671088640,5,{feedbackBtn:0}),(e()(),ta(16777216,null,null,1,null,Ol)),jo(6,16384,null,0,$i,[rn,nn],{ngIf:[0,"ngIf"]},null)],function(e,t){var n=t.component;e(t,6,0,n.applicationQueId&&n.irnSelected&&n.ipnSelected)},null)}var Pl=function(e,t){return new io("renault-ng-feedback",t,function(e){return ga(0,[(e()(),na(0,0,null,null,1,"renault-ng-feedback",[],null,null,null,Rl,ol)),jo(1,4308992,null,0,Ii,[],null,null)],function(e,t){e(t,1,0)},null)},{isAuth:"is-authorized",access_token:"access_token",pluginColor:"plugincolor",pluginHeader:"pluginheader",triggerId:"triggerid",apiUrl:"apiUrl",baseUrl:"base_url",irn:"irn",ipn:"ipn",client_id:"client_id",client_secret:"client_secret",tech_ipn:"tech_ipn",tech_pass:"tech_pass",apikey:"apikey",api_secret:"api_secret"},{loaded:"loaded",onHide:"onHide"},[])}(0,Ii);let Ll=null;function Hl(){return Ll}const Vl={class:"className",innerHtml:"innerHTML",readonly:"readOnly",tabindex:"tabIndex"},ql={"\b":"Backspace","\t":"Tab","":"Delete","":"Escape",Del:"Delete",Esc:"Escape",Left:"ArrowLeft",Right:"ArrowRight",Up:"ArrowUp",Down:"ArrowDown",Menu:"ContextMenu",Scroll:"ScrollLock",Win:"OS"},Zl={A:"1",B:"2",C:"3",D:"4",E:"5",F:"6",G:"7",H:"8",I:"9",J:"*",K:"+",M:"-",N:".",O:"/","`":"0","":"NumLock"},Bl=(()=>{if(fe.Node)return fe.Node.prototype.contains||function(e){return!!(16&this.compareDocumentPosition(e))}})();class $l extends class extends class{constructor(){this.resourceLoaderType=null}get attrToPropMap(){return this._attrToPropMap}set attrToPropMap(e){this._attrToPropMap=e}}{constructor(){super(),this._animationPrefix=null,this._transitionEnd=null;try{const e=this.createElement("div",document);if(null!=this.getStyle(e,"animationName"))this._animationPrefix="";else{const t=["Webkit","Moz","O","ms"];for(let n=0;n<t.length;n++)if(null!=this.getStyle(e,t[n]+"AnimationName")){this._animationPrefix="-"+t[n].toLowerCase()+"-";break}}const t={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};Object.keys(t).forEach(n=>{null!=this.getStyle(e,n)&&(this._transitionEnd=t[n])})}catch(e){this._animationPrefix=null,this._transitionEnd=null}}getDistributedNodes(e){return e.getDistributedNodes()}resolveAndSetHref(e,t,n){e.href=null==n?t:t+"/../"+n}supportsDOMEvents(){return!0}supportsNativeShadowDOM(){return"function"==typeof document.body.createShadowRoot}getAnimationPrefix(){return this._animationPrefix?this._animationPrefix:""}getTransitionEnd(){return this._transitionEnd?this._transitionEnd:""}supportsAnimation(){return null!=this._animationPrefix&&null!=this._transitionEnd}}{parse(e){throw new Error("parse not implemented")}static makeCurrent(){var e;e=new $l,Ll||(Ll=e)}hasProperty(e,t){return t in e}setProperty(e,t,n){e[t]=n}getProperty(e,t){return e[t]}invoke(e,t,n){e[t](...n)}logError(e){window.console&&(console.error?console.error(e):console.log(e))}log(e){window.console&&window.console.log&&window.console.log(e)}logGroup(e){window.console&&window.console.group&&window.console.group(e)}logGroupEnd(){window.console&&window.console.groupEnd&&window.console.groupEnd()}get attrToPropMap(){return Vl}contains(e,t){return Bl.call(e,t)}querySelector(e,t){return e.querySelector(t)}querySelectorAll(e,t){return e.querySelectorAll(t)}on(e,t,n){e.addEventListener(t,n,!1)}onAndCancel(e,t,n){return e.addEventListener(t,n,!1),()=>{e.removeEventListener(t,n,!1)}}dispatchEvent(e,t){e.dispatchEvent(t)}createMouseEvent(e){const t=this.getDefaultDocument().createEvent("MouseEvent");return t.initEvent(e,!0,!0),t}createEvent(e){const t=this.getDefaultDocument().createEvent("Event");return t.initEvent(e,!0,!0),t}preventDefault(e){e.preventDefault(),e.returnValue=!1}isPrevented(e){return e.defaultPrevented||null!=e.returnValue&&!e.returnValue}getInnerHTML(e){return e.innerHTML}getTemplateContent(e){return"content"in e&&this.isTemplateElement(e)?e.content:null}getOuterHTML(e){return e.outerHTML}nodeName(e){return e.nodeName}nodeValue(e){return e.nodeValue}type(e){return e.type}content(e){return this.hasProperty(e,"content")?e.content:e}firstChild(e){return e.firstChild}nextSibling(e){return e.nextSibling}parentElement(e){return e.parentNode}childNodes(e){return e.childNodes}childNodesAsList(e){const t=e.childNodes,n=new Array(t.length);for(let e=0;e<t.length;e++)n[e]=t[e];return n}clearNodes(e){for(;e.firstChild;)e.removeChild(e.firstChild)}appendChild(e,t){e.appendChild(t)}removeChild(e,t){e.removeChild(t)}replaceChild(e,t,n){e.replaceChild(t,n)}remove(e){return e.parentNode&&e.parentNode.removeChild(e),e}insertBefore(e,t,n){e.insertBefore(n,t)}insertAllBefore(e,t,n){n.forEach(n=>e.insertBefore(n,t))}insertAfter(e,t,n){e.insertBefore(n,t.nextSibling)}setInnerHTML(e,t){e.innerHTML=t}getText(e){return e.textContent}setText(e,t){e.textContent=t}getValue(e){return e.value}setValue(e,t){e.value=t}getChecked(e){return e.checked}setChecked(e,t){e.checked=t}createComment(e){return this.getDefaultDocument().createComment(e)}createTemplate(e){const t=this.getDefaultDocument().createElement("template");return t.innerHTML=e,t}createElement(e,t){return(t=t||this.getDefaultDocument()).createElement(e)}createElementNS(e,t,n){return(n=n||this.getDefaultDocument()).createElementNS(e,t)}createTextNode(e,t){return(t=t||this.getDefaultDocument()).createTextNode(e)}createScriptTag(e,t,n){const o=(n=n||this.getDefaultDocument()).createElement("SCRIPT");return o.setAttribute(e,t),o}createStyleElement(e,t){const n=(t=t||this.getDefaultDocument()).createElement("style");return this.appendChild(n,this.createTextNode(e,t)),n}createShadowRoot(e){return e.createShadowRoot()}getShadowRoot(e){return e.shadowRoot}getHost(e){return e.host}clone(e){return e.cloneNode(!0)}getElementsByClassName(e,t){return e.getElementsByClassName(t)}getElementsByTagName(e,t){return e.getElementsByTagName(t)}classList(e){return Array.prototype.slice.call(e.classList,0)}addClass(e,t){e.classList.add(t)}removeClass(e,t){e.classList.remove(t)}hasClass(e,t){return e.classList.contains(t)}setStyle(e,t,n){e.style[t]=n}removeStyle(e,t){e.style[t]=""}getStyle(e,t){return e.style[t]}hasStyle(e,t,n){const o=this.getStyle(e,t)||"";return n?o==n:o.length>0}tagName(e){return e.tagName}attributeMap(e){const t=new Map,n=e.attributes;for(let e=0;e<n.length;e++){const o=n.item(e);t.set(o.name,o.value)}return t}hasAttribute(e,t){return e.hasAttribute(t)}hasAttributeNS(e,t,n){return e.hasAttributeNS(t,n)}getAttribute(e,t){return e.getAttribute(t)}getAttributeNS(e,t,n){return e.getAttributeNS(t,n)}setAttribute(e,t,n){e.setAttribute(t,n)}setAttributeNS(e,t,n,o){e.setAttributeNS(t,n,o)}removeAttribute(e,t){e.removeAttribute(t)}removeAttributeNS(e,t,n){e.removeAttributeNS(t,n)}templateAwareRoot(e){return this.isTemplateElement(e)?this.content(e):e}createHtmlDocument(){return document.implementation.createHTMLDocument("fakeTitle")}getDefaultDocument(){return document}getBoundingClientRect(e){try{return e.getBoundingClientRect()}catch(e){return{top:0,bottom:0,left:0,right:0,width:0,height:0}}}getTitle(e){return e.title}setTitle(e,t){e.title=t||""}elementMatches(e,t){return!!this.isElementNode(e)&&(e.matches&&e.matches(t)||e.msMatchesSelector&&e.msMatchesSelector(t)||e.webkitMatchesSelector&&e.webkitMatchesSelector(t))}isTemplateElement(e){return this.isElementNode(e)&&"TEMPLATE"===e.nodeName}isTextNode(e){return e.nodeType===Node.TEXT_NODE}isCommentNode(e){return e.nodeType===Node.COMMENT_NODE}isElementNode(e){return e.nodeType===Node.ELEMENT_NODE}hasShadowRoot(e){return null!=e.shadowRoot&&e instanceof HTMLElement}isShadowRoot(e){return e instanceof DocumentFragment}importIntoDoc(e){return document.importNode(this.templateAwareRoot(e),!0)}adoptNode(e){return document.adoptNode(e)}getHref(e){return e.getAttribute("href")}getEventKey(e){let t=e.key;if(null==t){if(t=e.keyIdentifier,null==t)return"Unidentified";t.startsWith("U+")&&(t=String.fromCharCode(parseInt(t.substring(2),16)),3===e.location&&Zl.hasOwnProperty(t)&&(t=Zl[t]))}return ql[t]||t}getGlobalEventTarget(e,t){return"window"===t?window:"document"===t?e:"body"===t?e.body:null}getHistory(){return window.history}getLocation(){return window.location}getBaseHref(e){const t=Ql||(Ql=document.querySelector("base"),Ql)?Ql.getAttribute("href"):null;return null==t?null:(n=t,Ul||(Ul=document.createElement("a")),Ul.setAttribute("href",n),"/"===Ul.pathname.charAt(0)?Ul.pathname:"/"+Ul.pathname);var n}resetBaseElement(){Ql=null}getUserAgent(){return window.navigator.userAgent}setData(e,t,n){this.setAttribute(e,"data-"+t,n)}getData(e,t){return this.getAttribute(e,"data-"+t)}getComputedStyle(e){return getComputedStyle(e)}supportsWebAnimation(){return"function"==typeof Element.prototype.animate}performanceNow(){return window.performance&&window.performance.now?window.performance.now():(new Date).getTime()}supportsCookies(){return!0}getCookie(e){return function(e,t){t=encodeURIComponent(t);for(const n of e.split(";")){const e=n.indexOf("="),[o,r]=-1==e?[n,""]:[n.slice(0,e),n.slice(e+1)];if(o.trim()===t)return decodeURIComponent(r)}return null}(document.cookie,e)}setCookie(e,t){document.cookie=encodeURIComponent(e)+"="+encodeURIComponent(t)}}let Ul,Ql=null;function Wl(){return!!window.history.pushState}let Gl=(()=>{class e extends Fi{constructor(e){super(),this._doc=e,this._init()}_init(){this.location=Hl().getLocation(),this._history=Hl().getHistory()}getBaseHrefFromDOM(){return Hl().getBaseHref(this._doc)}onPopState(e){Hl().getGlobalEventTarget(this._doc,"window").addEventListener("popstate",e,!1)}onHashChange(e){Hl().getGlobalEventTarget(this._doc,"window").addEventListener("hashchange",e,!1)}get href(){return this.location.href}get protocol(){return this.location.protocol}get hostname(){return this.location.hostname}get port(){return this.location.port}get pathname(){return this.location.pathname}get search(){return this.location.search}get hash(){return this.location.hash}set pathname(e){this.location.pathname=e}pushState(e,t,n){Wl()?this._history.pushState(e,t,n):this.location.hash=n}replaceState(e,t,n){Wl()?this._history.replaceState(e,t,n):this.location.hash=n}forward(){this._history.forward()}back(){this._history.back()}getState(){return this._history.state}}return e.ctorParameters=()=>[{type:void 0,decorators:[{type:Q,args:[nl]}]}],e})();const Yl=new de("TRANSITION_ID"),Kl=[{provide:Jo,useFactory:function(e,t,n){return()=>{n.get(er).donePromise.then(()=>{const n=Hl();Array.prototype.slice.apply(n.querySelectorAll(t,"style[ng-transition]")).filter(t=>n.getAttribute(t,"ng-transition")===e).forEach(e=>n.remove(e))})}},deps:[Yl,nl,ct],multi:!0}];class Xl{static init(){var e;e=new Xl,zr=e}addToWindow(e){fe.getAngularTestability=(t,n=!0)=>{const o=e.findTestabilityInTree(t,n);if(null==o)throw new Error("Could not find testability for element.");return o},fe.getAllAngularTestabilities=()=>e.getAllTestabilities(),fe.getAllAngularRootElements=()=>e.getAllRootElements(),fe.frameworkStabilizers||(fe.frameworkStabilizers=[]),fe.frameworkStabilizers.push(e=>{const t=fe.getAllAngularTestabilities();let n=t.length,o=!1;const r=function(t){o=o||t,n--,0==n&&e(o)};t.forEach(function(e){e.whenStable(r)})})}findTestabilityInTree(e,t,n){if(null==t)return null;const o=e.getTestability(t);return null!=o?o:n?Hl().isShadowRoot(t)?this.findTestabilityInTree(e,Hl().getHost(t),!0):this.findTestabilityInTree(e,Hl().parentElement(t),!0):null}}function Jl(e,t){"undefined"!=typeof COMPILED&&COMPILED||((fe.ng=fe.ng||{})[e]=t)}const es={ApplicationRef:Vr,NgZone:Cr};function ts(e){return Qr(e)}const ns=new de("EventManagerPlugins");class os{constructor(e,t){this._zone=t,this._eventNameToPlugin=new Map,e.forEach(e=>e.manager=this),this._plugins=e.slice().reverse()}addEventListener(e,t,n){return this._findPluginFor(t).addEventListener(e,t,n)}addGlobalEventListener(e,t,n){return this._findPluginFor(t).addGlobalEventListener(e,t,n)}getZone(){return this._zone}_findPluginFor(e){const t=this._eventNameToPlugin.get(e);if(t)return t;const n=this._plugins;for(let t=0;t<n.length;t++){const o=n[t];if(o.supports(e))return this._eventNameToPlugin.set(e,o),o}throw new Error(`No event manager plugin found for event ${e}`)}}class rs{constructor(e){this._doc=e}addGlobalEventListener(e,t,n){const o=Hl().getGlobalEventTarget(this._doc,e);if(!o)throw new Error(`Unsupported event target ${o} for event ${t}`);return this.addEventListener(o,t,n)}}class as{constructor(){this._stylesSet=new Set}addStyles(e){const t=new Set;e.forEach(e=>{this._stylesSet.has(e)||(this._stylesSet.add(e),t.add(e))}),this.onStylesAdded(t)}onStylesAdded(e){}getAllStyles(){return Array.from(this._stylesSet)}}class is extends as{constructor(e){super(),this._doc=e,this._hostNodes=new Set,this._styleNodes=new Set,this._hostNodes.add(e.head)}_addStylesToHost(e,t){e.forEach(e=>{const n=this._doc.createElement("style");n.textContent=e,this._styleNodes.add(t.appendChild(n))})}addHost(e){this._addStylesToHost(this._stylesSet,e),this._hostNodes.add(e)}removeHost(e){this._hostNodes.delete(e)}onStylesAdded(e){this._hostNodes.forEach(t=>this._addStylesToHost(e,t))}ngOnDestroy(){this._styleNodes.forEach(e=>Hl().remove(e))}}const ls={svg:"http://www.w3.org/2000/svg",xhtml:"http://www.w3.org/1999/xhtml",xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"},ss=/%COMP%/g;function cs(e,t,n){for(let o=0;o<t.length;o++){let r=t[o];Array.isArray(r)?cs(e,r,n):(r=r.replace(ss,e),n.push(r))}return n}function fs(e){return t=>{!1===e(t)&&(t.preventDefault(),t.returnValue=!1)}}class ds{constructor(e,t,n){this.eventManager=e,this.sharedStylesHost=t,this.appId=n,this.rendererByCompId=new Map,this.defaultRenderer=new us(e)}createRenderer(e,t){if(!e||!t)return this.defaultRenderer;switch(t.encapsulation){case _e.Emulated:{let n=this.rendererByCompId.get(t.id);return n||(n=new bs(this.eventManager,this.sharedStylesHost,t,this.appId),this.rendererByCompId.set(t.id,n)),n.applyToHost(e),n}case _e.Native:case _e.ShadowDom:return new hs(this.eventManager,this.sharedStylesHost,e,t);default:if(!this.rendererByCompId.has(t.id)){const e=cs(t.id,t.styles,[]);this.sharedStylesHost.addStyles(e),this.rendererByCompId.set(t.id,this.defaultRenderer)}return this.defaultRenderer}}begin(){}end(){}}class us{constructor(e){this.eventManager=e,this.data=Object.create(null)}destroy(){}createElement(e,t){return t?document.createElementNS(ls[t]||t,e):document.createElement(e)}createComment(e){return document.createComment(e)}createText(e){return document.createTextNode(e)}appendChild(e,t){e.appendChild(t)}insertBefore(e,t,n){e&&e.insertBefore(t,n)}removeChild(e,t){e&&e.removeChild(t)}selectRootElement(e,t){let n="string"==typeof e?document.querySelector(e):e;if(!n)throw new Error(`The selector "${e}" did not match any elements`);return t||(n.textContent=""),n}parentNode(e){return e.parentNode}nextSibling(e){return e.nextSibling}setAttribute(e,t,n,o){if(o){t=o+":"+t;const r=ls[o];r?e.setAttributeNS(r,t,n):e.setAttribute(t,n)}else e.setAttribute(t,n)}removeAttribute(e,t,n){if(n){const o=ls[n];o?e.removeAttributeNS(o,t):e.removeAttribute(`${n}:${t}`)}else e.removeAttribute(t)}addClass(e,t){e.classList.add(t)}removeClass(e,t){e.classList.remove(t)}setStyle(e,t,n,o){o&Rt.DashCase?e.style.setProperty(t,n,o&Rt.Important?"important":""):e.style[t]=n}removeStyle(e,t,n){n&Rt.DashCase?e.style.removeProperty(t):e.style[t]=""}setProperty(e,t,n){ps(t,"property"),e[t]=n}setValue(e,t){e.nodeValue=t}listen(e,t,n){return ps(t,"listener"),"string"==typeof e?this.eventManager.addGlobalEventListener(e,t,fs(n)):this.eventManager.addEventListener(e,t,fs(n))}}const ms="@".charCodeAt(0);function ps(e,t){if(e.charCodeAt(0)===ms)throw new Error(`Found the synthetic ${t} ${e}. Please include either "BrowserAnimationsModule" or "NoopAnimationsModule" in your application.`)}class bs extends us{constructor(e,t,n,o){super(e),this.component=n;const r=cs(o+"-"+n.id,n.styles,[]);t.addStyles(r),this.contentAttr="_ngcontent-%COMP%".replace(ss,o+"-"+n.id),this.hostAttr=function(e){return"_nghost-%COMP%".replace(ss,e)}(o+"-"+n.id)}applyToHost(e){super.setAttribute(e,this.hostAttr,"")}createElement(e,t){const n=super.createElement(e,t);return super.setAttribute(n,this.contentAttr,""),n}}class hs extends us{constructor(e,t,n,o){super(e),this.sharedStylesHost=t,this.hostEl=n,this.component=o,this.shadowRoot=o.encapsulation===_e.ShadowDom?n.attachShadow({mode:"open"}):n.createShadowRoot(),this.sharedStylesHost.addHost(this.shadowRoot);const r=cs(o.id,o.styles,[]);for(let e=0;e<r.length;e++){const t=document.createElement("style");t.textContent=r[e],this.shadowRoot.appendChild(t)}}nodeOrShadowRoot(e){return e===this.hostEl?this.shadowRoot:e}destroy(){this.sharedStylesHost.removeHost(this.shadowRoot)}appendChild(e,t){return super.appendChild(this.nodeOrShadowRoot(e),t)}insertBefore(e,t,n){return super.insertBefore(this.nodeOrShadowRoot(e),t,n)}removeChild(e,t){return super.removeChild(this.nodeOrShadowRoot(e),t)}parentNode(e){return this.nodeOrShadowRoot(super.parentNode(this.nodeOrShadowRoot(e)))}}const gs="undefined"!=typeof Zone&&Zone.__symbol__||function(e){return"__zone_symbol__"+e},xs=gs("addEventListener"),ws=gs("removeEventListener"),ys={},vs="__zone_symbol__propagationStopped",ks=(()=>{const e="undefined"!=typeof Zone&&Zone[gs("BLACK_LISTED_EVENTS")];if(e){const t={};return e.forEach(e=>{t[e]=e}),t}})(),_s=function(e){return!!ks&&ks.hasOwnProperty(e)},Cs=function(e){const t=ys[e.type];if(!t)return;const n=this[t];if(!n)return;const o=[e];if(1===n.length){const e=n[0];return e.zone!==Zone.current?e.zone.run(e.handler,this,o):e.handler.apply(this,o)}{const t=n.slice();for(let n=0;n<t.length&&!0!==e[vs];n++){const e=t[n];e.zone!==Zone.current?e.zone.run(e.handler,this,o):e.handler.apply(this,o)}}};class Es extends rs{constructor(e,t,n){super(e),this.ngZone=t,n&&function(e){return"server"===e}(n)||this.patchEvent()}patchEvent(){if("undefined"==typeof Event||!Event||!Event.prototype)return;if(Event.prototype.__zone_symbol__stopImmediatePropagation)return;const e=Event.prototype.__zone_symbol__stopImmediatePropagation=Event.prototype.stopImmediatePropagation;Event.prototype.stopImmediatePropagation=function(){this&&(this[vs]=!0),e&&e.apply(this,arguments)}}supports(e){return!0}addEventListener(e,t,n){let o=n;if(!e[xs]||Cr.isInAngularZone()&&!_s(t))e.addEventListener(t,o,!1);else{let n=ys[t];n||(n=ys[t]=gs("ANGULAR"+t+"FALSE"));let r=e[n];const a=r&&r.length>0;r||(r=e[n]=[]);const i=_s(t)?Zone.root:Zone.current;if(0===r.length)r.push({zone:i,handler:o});else{let e=!1;for(let t=0;t<r.length;t++)if(r[t].handler===o){e=!0;break}e||r.push({zone:i,handler:o})}a||e[xs](t,Cs,!1)}return()=>this.removeEventListener(e,t,o)}removeEventListener(e,t,n){let o=e[ws];if(!o)return e.removeEventListener.apply(e,[t,n,!1]);let r=ys[t],a=r&&e[r];if(!a)return e.removeEventListener.apply(e,[t,n,!1]);let i=!1;for(let e=0;e<a.length;e++)if(a[e].handler===n){i=!0,a.splice(e,1);break}i?0===a.length&&o.apply(e,[t,Cs,!1]):e.removeEventListener.apply(e,[t,n,!1])}}const Ts={pan:!0,panstart:!0,panmove:!0,panend:!0,pancancel:!0,panleft:!0,panright:!0,panup:!0,pandown:!0,pinch:!0,pinchstart:!0,pinchmove:!0,pinchend:!0,pinchcancel:!0,pinchin:!0,pinchout:!0,press:!0,pressup:!0,rotate:!0,rotatestart:!0,rotatemove:!0,rotateend:!0,rotatecancel:!0,swipe:!0,swipeleft:!0,swiperight:!0,swipeup:!0,swipedown:!0,tap:!0},Ss=new de("HammerGestureConfig"),Ns=new de("HammerLoader");class js{constructor(){this.events=[],this.overrides={}}buildHammer(e){const t=new Hammer(e,this.options);t.get("pinch").set({enable:!0}),t.get("rotate").set({enable:!0});for(const e in this.overrides)t.get(e).set(this.overrides[e]);return t}}class Is extends rs{constructor(e,t,n,o){super(e),this._config=t,this.console=n,this.loader=o}supports(e){return!(!Ts.hasOwnProperty(e.toLowerCase())&&!this.isCustomEvent(e)||!window.Hammer&&!this.loader&&(this.console.warn(`The "${e}" event cannot be bound because Hammer.JS is not loaded and no custom loader has been specified.`),1))}addEventListener(e,t,n){const o=this.manager.getZone();if(t=t.toLowerCase(),!window.Hammer&&this.loader){let o=!1,r=()=>{o=!0};return this.loader().then(()=>{if(!window.Hammer)return this.console.warn("The custom HAMMER_LOADER completed, but Hammer.JS is not present."),void(r=()=>{});o||(r=this.addEventListener(e,t,n))}).catch(()=>{this.console.warn(`The "${t}" event cannot be bound because the custom Hammer.JS loader failed.`),r=()=>{}}),()=>{r()}}return o.runOutsideAngular(()=>{const r=this._config.buildHammer(e),a=function(e){o.runGuarded(function(){n(e)})};return r.on(t,a),()=>{r.off(t,a),"function"==typeof r.destroy&&r.destroy()}})}isCustomEvent(e){return this._config.events.indexOf(e)>-1}}const Ds=["alt","control","meta","shift"],Ms={alt:e=>e.altKey,control:e=>e.ctrlKey,meta:e=>e.metaKey,shift:e=>e.shiftKey};class Fs extends rs{constructor(e){super(e)}supports(e){return null!=Fs.parseEventName(e)}addEventListener(e,t,n){const o=Fs.parseEventName(t),r=Fs.eventCallback(o.fullKey,n,this.manager.getZone());return this.manager.getZone().runOutsideAngular(()=>Hl().onAndCancel(e,o.domEventName,r))}static parseEventName(e){const t=e.toLowerCase().split("."),n=t.shift();if(0===t.length||"keydown"!==n&&"keyup"!==n)return null;const o=Fs._normalizeKey(t.pop());let r="";if(Ds.forEach(e=>{const n=t.indexOf(e);n>-1&&(t.splice(n,1),r+=e+".")}),r+=o,0!=t.length||0===o.length)return null;const a={};return a.domEventName=n,a.fullKey=r,a}static getEventFullKey(e){let t="",n=Hl().getEventKey(e);return n=n.toLowerCase()," "===n?n="space":"."===n&&(n="dot"),Ds.forEach(o=>{o!=n&&(0,Ms[o])(e)&&(t+=o+".")}),t+=n,t}static eventCallback(e,t,n){return o=>{Fs.getEventFullKey(o)===e&&n.runGuarded(()=>t(o))}}static _normalizeKey(e){return"esc"===e?"escape":e}}class zs{}class As extends zs{constructor(e){super(),this._doc=e}sanitize(e,t){if(null==t)return null;switch(e){case Je.NONE:return t;case Je.HTML:return t instanceof Rs?t.changingThisBreaksApplicationSecurity:(this.checkNotSafeValue(t,"HTML"),function(e,t){let n=null;try{Ke=Ke||new Me(e);let o=t?String(t):"";n=Ke.getInertBodyElement(o);let r=5,a=o;do{if(0===r)throw new Error("Failed to sanitize html because the input is unstable");r--,o=a,a=n.innerHTML,n=Ke.getInertBodyElement(o)}while(o!==a);const i=new Qe,l=i.sanitizeChildren(Xe(n)||n);return De()&&i.sanitizedSomething&&console.warn("WARNING: sanitizing HTML stripped some content, see http://g.co/ng/security#xss"),l}finally{if(n){const e=Xe(n)||n;for(;e.firstChild;)e.removeChild(e.firstChild)}}}(this._doc,String(t)));case Je.STYLE:return t instanceof Ps?t.changingThisBreaksApplicationSecurity:(this.checkNotSafeValue(t,"Style"),function(e){if(!(e=String(e).trim()))return"";const t=e.match(nt);return t&&Ae(t[1])===t[1]||e.match(tt)&&function(e){let t=!0,n=!0;for(let o=0;o<e.length;o++){const r=e.charAt(o);"'"===r&&n?t=!t:'"'===r&&t&&(n=!n)}return t&&n}(e)?e:(De()&&console.warn(`WARNING: sanitizing unsafe style value ${e} (see http://g.co/ng/security#xss).`),"unsafe")}(t));case Je.SCRIPT:if(t instanceof Ls)return t.changingThisBreaksApplicationSecurity;throw this.checkNotSafeValue(t,"Script"),new Error("unsafe value used in a script context");case Je.URL:return t instanceof Vs||t instanceof Hs?t.changingThisBreaksApplicationSecurity:(this.checkNotSafeValue(t,"URL"),Ae(String(t)));case Je.RESOURCE_URL:if(t instanceof Vs)return t.changingThisBreaksApplicationSecurity;throw this.checkNotSafeValue(t,"ResourceURL"),new Error("unsafe value used in a resource URL context (see http://g.co/ng/security#xss)");default:throw new Error(`Unexpected SecurityContext ${e} (see http://g.co/ng/security#xss)`)}}checkNotSafeValue(e,t){if(e instanceof Os)throw new Error(`Required a safe ${t}, got a ${e.getTypeName()} (see http://g.co/ng/security#xss)`)}bypassSecurityTrustHtml(e){return new Rs(e)}bypassSecurityTrustStyle(e){return new Ps(e)}bypassSecurityTrustScript(e){return new Ls(e)}bypassSecurityTrustUrl(e){return new Hs(e)}bypassSecurityTrustResourceUrl(e){return new Vs(e)}}class Os{constructor(e){this.changingThisBreaksApplicationSecurity=e}toString(){return`SafeValue must use [property]=binding: ${this.changingThisBreaksApplicationSecurity} (see http://g.co/ng/security#xss)`}}class Rs extends Os{getTypeName(){return"HTML"}}class Ps extends Os{getTypeName(){return"Style"}}class Ls extends Os{getTypeName(){return"Script"}}class Hs extends Os{getTypeName(){return"URL"}}class Vs extends Os{getTypeName(){return"ResourceURL"}}const qs=Rr(Gr,"browser",[{provide:ar,useValue:"browser"},{provide:rr,useValue:function(){$l.makeCurrent(),Xl.init()},multi:!0},{provide:Fi,useClass:Gl,deps:[nl]},{provide:nl,useFactory:function(){return document},deps:[]}]);function Zs(){return new Ne}class Bs{constructor(e){if(e)throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.")}static withServerTransition(e){return{ngModule:Bs,providers:[{provide:tr,useValue:e.appId},{provide:Yl,useExisting:tr},Kl]}}}"undefined"!=typeof window&&window;var $s=function(e){return new ki(e,[],function(e){return function(e){const t={},n=[];let o=!1;for(let r=0;r<e.length;r++){const a=e[r];a.token===lt&&!0===a.value&&(o=!0),1073741824&a.flags&&n.push(a.token),a.index=r,t[yn(a.token)]=a}return{factory:null,providersByKey:t,providers:e,modules:n,isRoot:o}}([Jn(512,It,Dt,[[8,[Pl]],[3,It],ye]),Jn(5120,sr,Xr,[[3,sr]]),Jn(4608,Oi,Ri,[sr,[2,Ai]]),Jn(5120,$o,Jr,[Cr]),Jn(4608,pr,pr,[]),Jn(5120,tr,nr,[]),Jn(5120,Kt,Yr,[]),Jn(5120,Xt,Kr,[]),Jn(4608,zs,As,[nl]),Jn(6144,et,null,[zs]),Jn(4608,Ss,js,[]),Jn(5120,ns,function(e,t,n,o,r,a,i,l){return[new Es(e,t,n),new Fs(o),new Is(r,a,i,l)]},[nl,Cr,ar,nl,nl,Ss,lr,[2,Ns]]),Jn(4608,os,os,[ns,Cr]),Jn(135680,is,is,[nl]),Jn(4608,ds,ds,[os,is,tr]),Jn(6144,Ot,null,[ds]),Jn(6144,as,null,[is]),Jn(4608,Dr,Dr,[Cr]),Jn(1073742336,tl,tl,[]),Jn(1024,Ne,Zs,[]),Jn(1024,Jo,function(e){return[(t=e,Jl("probe",ts),Jl("coreTokens",Object.assign({},es,(t||[]).reduce((e,t)=>(e[t.name]=t.token,e),{}))),()=>ts)];var t},[[2,Or]]),Jn(512,er,er,[[2,Jo]]),Jn(131584,Vr,Vr,[Cr,lr,ct,Ne,It,er]),Jn(1073742336,ea,ea,[Vr]),Jn(1073742336,Bs,Bs,[[3,Bs]]),Jn(1073742336,Di,Di,[]),Jn(1073742336,Mi,Mi,[ct]),Jn(256,lt,!0,[])])})}(Mi);(function(){if(Ie)throw new Error("Cannot enable prod mode after platform setup.");je=!1})(),qs().bootstrapModuleFactory($s).catch(e=>console.error(e))},zn8P:function(e,t){function n(e){return Promise.resolve().then(function(){var t=new Error("Cannot find module '"+e+"'");throw t.code="MODULE_NOT_FOUND",t})}n.keys=function(){return[]},n.resolve=n,e.exports=n,n.id="zn8P"}},[[0,0]]]);
(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('ndHelpVideoCtrl', ndHelpVideoCtrl);

  /** @ngInject */
  function ndHelpVideoCtrl($sce) {
    var vm = this;
    vm.videoUrl = { src: vm.url };
    function init() {
      vm.trustedSrc = trustedSrc;

    }
    function trustedSrc(src) {
      return $sce.trustAsResourceUrl(src);
    }
    init();
  }
})();
(function () {
  'use strict';

  angular
    .module('phenix')
    .controller('ndHelpCtrl', ndHelpCtrl);

  /** @ngInject */
  function ndHelpCtrl($sce, $translate, CacheService, $mdDialog, CacheConstants, configConstantes, $rootScope, $http) {
    var vm = this;
    vm.loadLanguage = loadLanguage;
    vm.getVideo = getVideo;
    vm.trustedSrcUrl = trustedSrcUrl;
    vm.languagePoupup = languagePoupup;
    vm.selectedLanguage = selectedLanguage;
    vm.getLangNameCode = getLangNameCode;
    vm.showRightContent = showRightContent;
    vm.ndHelpDocUrl = configConstantes.ndHelpUrl + '/ndHelp/';
    vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
    vm.selectedLeftMenu = {label: "ND_LABEL", img: "../assets/images/book.png", rightMenuImg: "../assets/images/user_guide.png"};
    vm.user = CacheService.getUserProfile();
    vm.atOMFile = "Schulungsunterlage_bestellmodul_V1.3_AT.pdf";
    vm.chOMFile = "Formazione teorica_modulo d'ordine_V1.4_CH.pdf";

    vm.leftMenuArray =  [
      {label: "ND_LABEL", img: "../assets/images/book.png", rightMenuImg: "../assets/images/user_guide.png"},
      {label: "EASY_BASKET_OPERATIONS", img: "../assets/images/automobile-operations.png", rightMenuImg: "../assets/images/automobile_with_wrench.png"},
      {label: "ND_DMS_MODE", img: "../assets/images/dms-mode.png", rightMenuImg: "../assets/images/dms-Icon.png"},
      {label: "NEW_ACTIS", img: "../assets/images/actis.svg", rightMenuImg: "../assets/images/new_actis.png"},
      {label: "DIAG_SEARCH", img: "../assets/images/diagnostics.png", rightMenuImg: "../assets/images/new_diag_icon.png"},
      {label: "ORDERING_MODULE", img: "../assets/images/ordering_modules.png", rightMenuImg: "../assets/images/orders.png"},
      {label: "EXTERNAL_APP_DOCUMENTS", img: "../assets/images/external_Docz.png", rightMenuImg: "../assets/images/externalDocx.png"},
      {label: "DOCPRIV_LABEL", img: "../assets/images/new_docpriv.png", rightMenuImg: "../assets/images/newDocpriv.png"},
      {label: "CONNECTED_SERVICES_ND_HELP", img: "../assets/images/connected_services.png", rightMenuImg: "../assets/images/connectedServices.png"},
      {label: "TRACE_LINK", img: "../assets/images/book.png", rightMenuImg: "../assets/images/user_guide.png"}]

    vm.langCodeList = [
      { langCode: 'en', langName: 'English' },
      { langCode: 'fr', langName: 'Français' },
      { langCode: 'es', langName: 'Español' },
      { langCode: 'it', langName: 'Italiano' },
      { langCode: 'pt', langName: 'Português' },
      { langCode: 'sk', langName: 'Slovenský' },
      { langCode: 'sv', langName: 'Svenska' },
      { langCode: 'de', langName: 'Deutsch' },
      { langCode: 'nl', langName: 'Nederlands' },
      { langCode: 'fi', langName: 'Suomi' },
      { langCode: 'cs', langName: 'čeština' },
      { langCode: 'pl', langName: 'Polski' },
      { langCode: 'hu', langName: 'Magyar' },
      { langCode: 'sl', langName: 'Slovenščin' },
      { langCode: 'pt-BR', langName: 'Português brasileiro' },
      { langCode: 'el', langName: 'Eλληνικά' },
      { langCode: 'ro', langName: 'Română' },
      { langCode: 'tr', langName: 'Türkçe' },
      { langCode: 'ru', langName: 'Pусский' },
      { langCode: 'ja', langName: '日本語' },
      { langCode: 'ko', langName: '한국어' },
      { langCode: 'zh', langName: '中文' },
      { langCode: 'ar', langName: 'العربية' },
      { langCode: 'fa', langName: 'فارسی' },
      { langCode: 'da', langName: 'Dansk' },
      { langCode: 'no', langName: 'Norsk' },
      { langCode: 'uk', langName: 'Ukrainian' },
      { langCode: 'bg', langName: 'Български' },
      { langCode: 'hr', langName: 'Hrvatski' }]

    function showRightContent(selectedItem){
      vm.selectedLeftMenu = selectedItem;
    }
     
    function loadLanguage() {
      var newArr = [];
      var profilLang = CacheService.getObject(CacheConstants.profil).language;
      $http.get('../../assets/json/ndHelpLangList.json').then(function (response) {
        vm.languagesList = response.data.languagesList;
        for (var i = 0; i < vm.languagesList.length; i += 3) {
          newArr.push(vm.languagesList.slice(i, i + 3));
        }
        vm.getLangNameCode(profilLang);
        vm.languageDropList = newArr;
        $translate.use(vm.langCode);
      });
      
    }

    function getLangNameCode(langVal) {
      for (var i = 0; i < vm.languagesList.length; i++) {
        var langCode = vm.languagesList[i].langCode;
        if (langCode === langVal) {
          vm.langName = vm.languagesList[i].langName;
          vm.langCode = vm.languagesList[i].langCode;
        }
      }
    }
    function selectedLanguage(langVal) {
      $translate.use(langVal);
      vm.getLangNameCode(langVal);
      $mdDialog.hide();
      vm.selectedLeftMenu = vm.leftMenuArray[0];
    }
    function getVideo(label) {
      $mdDialog.show({
        templateUrl: 'app/main/ndHelpVideo.html',
        controller: 'ndHelpVideoCtrl',
        bindToController: true,
        controllerAs: 'vm',
        clickOutsideToClose: true,
        locals: {
          url: label
        }
      })
    }
    function trustedSrcUrl() {
      return $sce.trustAsResourceUrl(vm.ndHelpDocUrl);
    }
    function languagePoupup() {
        $mdDialog.show({
          contentElement: '#langPopup',
          parent: angular.element(document.body),
          clickOutsideToClose: true
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .service('MainMetierService', MainMetierService);

  /** @ngInject */
  function MainMetierService(ProductWsService,
                             $q,
                             CacheService,
                             ActisConstantes,
                             CacheConstants,
                             $translate,
                             $http,AccessConfigService,
                             configConstantes,
                             CarSearchConstants,
                             ProfilConstants, $state,
                             OrderModuleConstants,
                             $mdDialog,ListPieceConstants, $rootScope,CarSearchResultConstants,CryptoService,RestUpgrade,DocPrivConstants,rLinkConstant, SearchbyDiagnosticConstants,$window, $location) {
    this.isArcaUser = isArcaUser;
    this.isActisProfil = isActisProfil;
    this.isBTListProfile = isBTListProfile;
    this.isFactoryProfile = isFactoryProfile;
    this.isIndependantUser = isIndependantUser;
    this.isActisProfilNoContext = isActisProfilNoContext;
    this.isRnetUserType = isRnetUserType;
    this.formatReferenceInput = formatReferenceInput;
    this.getDocunmentsInformations = getDocunmentsInformations;
    this.getDealersList = getDealersList;
    this.saveDealerDetails = saveDealerDetails;
    this.getDealerDetails = getDealerDetails;
    this.isSearchByModel = isSearchByModel;
    this.isCirSentVin = isCirSentVin;
    this.isRpartsRole = isRpartsRole;
    this.reCheckAsomSubscriptions=reCheckAsomSubscriptions;
    this.AsomDocAccessPopIn=AsomDocAccessPopIn;
	  this.isDocprivProfile = isDocprivProfile;
    this.isSupportAccess = isSupportAccess;
    this.isMotrioFilterProfile = isMotrioFilterProfile;
    this.setClipParameters = setClipParameters;
    this.getClipParameters = getClipParameters;
    this.getLastModificationDate = getLastModificationDate;
    this.setAsomDocrights = setAsomDocrights;
    this.rnetUserBrandCheck = rnetUserBrandCheck;
    this.redirectCarBrandCheck = redirectCarBrandCheck;
    this.isHorseUser = isHorseUser;
    this.isMitsubishiUser = isMitsubishiUser;
    this.hasDealerRole = hasDealerRole;
    this.isOnlyPpxLightUser = isOnlyPpxLightUser;
    this.isPpxLightUser = isPpxLightUser;
    this.multimediaInformation = multimediaInformation;
    this.getAsomDocrights = getAsomDocrights;
    this.getCurrentDate = getCurrentDate;
    this.isNissanConnectedServices =  isNissanConnectedServices;
    this.isNissanUserAccess = isNissanUserAccess;
    this.isEnableDiagForNissan = isEnableDiagForNissan;
    this.isBrandApplicable = isBrandApplicable;
    this.getAllNotifications = getAllNotifications;
    this.getUnreadNotificationCount = getUnreadNotificationCount;
    this.getNotificationPopIn = getNotificationPopIn;
    this.shouldShowPricingSection = shouldShowPricingSection;
    this.goToDesyre = goToDesyre;
    this.isDdpAdmin = isDdpAdmin;
    this.updateNotificationReadStatus = updateNotificationReadStatus;

    var clipParamters;
    $rootScope.renaultPrimaryColor = CarSearchResultConstants.renaultPrimaryColor;
    $rootScope.renaultSmallFont = CarSearchResultConstants.renaultSmallFont;
    $rootScope.renaultMediumFont = CarSearchResultConstants.renaultMediumFont;
    $rootScope.renaultLargeFont = CarSearchResultConstants.renaultLargeFont;
    $rootScope.renaultExtraLargeFont = CarSearchResultConstants.renaultExtraLargeFont;
    var isPricingSectionEnabled = JSON.parse(configConstantes.isPricingSectionEnabled);
    var vm = this;
    
    function setRLinkVehicleFlags() {
      var contextCarRequest = CacheService.getObject(CacheConstants.contextCarRequest);
      var listRLink = CarSearchResultConstants.listRLink;
      var rLink2Code = CarSearchResultConstants.rLink2Code;
      var listRLink1 = CarSearchResultConstants.listRLink1;
      var rLink1Code = CarSearchResultConstants.rLink1Code;
      var userProfil = CacheService.getUserProfile();
      var userType = userProfil && userProfil.userType ?
        (userProfil.userType.toUpperCase() === 'ARCA' || userProfil.userType.toUpperCase() === 'RNET') : false;

      vm.isRLink1Vehicle = false;
      vm.isRLink2Vehicle = false;

      if (contextCarRequest && contextCarRequest.fixedCriterias && userType) {
        if (_.includes(listRLink, contextCarRequest.fixedCriterias[rLink2Code])) {
          vm.isRLink2Vehicle = true;
        }
        if (_.includes(listRLink1, contextCarRequest.fixedCriterias[rLink1Code])) {
          vm.isRLink1Vehicle = true;
        }
      }
      
      updateConnectedVehicleStatus();
    }

    function updateConnectedVehicleStatus() {
      const connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
      const easyLinkPlatforms = ["EASYLINK", "AVN", "CVC", "RGDC"];
      const isEasyLink = connectedPlatform !== null && easyLinkPlatforms.includes(connectedPlatform.platform);
      const isUnknownVehicle = (connectedPlatform && connectedPlatform.platform === 'UNKNOWN') ? true : false;
      $rootScope.isConnectedVehicle = (vm.isRLink1Vehicle || vm.isRLink2Vehicle || isEasyLink) && !isUnknownVehicle;
    } 


    function multimediaInformation() {
        setRLinkVehicleFlags();
      var connectedPlatform = CacheService.getObject(CacheConstants.connectedPlatform);
      var isEasyLink = (connectedPlatform !== null && (connectedPlatform.platform === "EASYLINK" || connectedPlatform.platform === 'AVN' || connectedPlatform.platform === 'CVC' || connectedPlatform.platform === 'RGDC'));
      var isUnknownVehicle = (connectedPlatform && connectedPlatform.platform === 'UNKNOWN') ? true : false;
      var result = false;
      if ((isArcaUser() || isRnetUserType() || isMitsubishiUser() || isPpxLightUser()) &&
        (vm.isRLink1Vehicle || vm.isRLink2Vehicle || isEasyLink) &&
        !isUnknownVehicle && !isIndependantUser() && !isHorseUser()) {
        result = true;
      }
      return result;
    }


    function setClipParameters(clipValues){
      clipParamters = clipValues;
    }
    function getClipParameters(){
      return clipParamters;
    }

    function reCheckAsomSubscriptions() {
        var userProfil = CacheService.getUserProfile();

        var url = CarSearchConstants.subscriptionsurl  + userProfil.emailAlerte + CarSearchConstants.subscriptionsurlsuffix;

        return RestUpgrade.one(url).get();

      }
      function AsomDocAccessPopIn(userProfile) {
        var subscriptionDocumentTypes = ['REF-BVM', 'OTS', 'REP', 'HM'];
        var asomDocList = $rootScope.asomDocList;
        if (!asomDocList || _.isEmpty(asomDocList)) {
          asomDocList = getAsomDocrights();
        }
        var hasSubscriptionDocumentAccess = subscriptionDocumentTypes.some(function (documentType) {
          return asomDocList && asomDocList[documentType];
        });
        var hasLegacyNoDocumentAccess = userProfile &&
          (!userProfile.isAsomValidDocAccess || userProfile.isAsomValidDocAccess === 'false');
        var isIndependentUser = userProfile && userProfile.roles &&
          !_.isEmpty(userProfile.roles) && isIndependantUser(userProfile.roles);
        var shouldShowPopup = !hasSubscriptionDocumentAccess && hasLegacyNoDocumentAccess;

        if (isIndependentUser && shouldShowPopup) {
            $mdDialog.show({
                locals: {

                },
                templateUrl: 'app/main/AsomDocAccessPopup.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'AsomDocAccessPopupController',
                bindToController: true,
                controllerAs: 'vm',
            });
        }

    }

      function isSearchByModel(){
        var context = CacheService.getObject(CacheConstants.contextCarSearch);
        if( context && context.vehicle  && context.vehicle.vin == null){
          return true;
        }
        return false;  
      }

      function rnetUserBrandCheck(){
        var userProfil = CacheService.getUserProfile();
        var carContext = CacheService.getCarContext();

        var contextCarBrandCheck = (userProfil && userProfil.userType === "RNET") && (carContext && carContext.fixedCriterias && ((carContext.fixedCriterias["336"].includes('APL15')) || (carContext.fixedCriterias["336"].includes('BRA15'))));
        return contextCarBrandCheck;
      }

      function redirectCarBrandCheck(isRedirectCarBrand){
        if(isRedirectCarBrand){
          $rootScope.$emit('isContextCarBrandCheck', isRedirectCarBrand);
        }
        else{
            $rootScope.$emit('isContextCarBrandCheck', false);
        }
      }

      function isArcaUser(){

        var userProfil = CacheService.getUserProfile();
          var result = false;
          if(userProfil && userProfil.userType && 
                  !_.isEmpty(userProfil.userType) && userProfil.userType.toUpperCase() === 'ARCA'){
            result = true;
          }
          return result;
      }

      function isRpartsRole(){
        var result = false;
        var userProfil = CacheService.getUserProfile();
        var rpartsProfile = OrderModuleConstants.rpartsProfile;
        if(userProfil && userProfil.roles && !_.isEmpty(userProfil.roles)){
             angular.forEach(userProfil.roles, function (value) {
                  if(rpartsProfile.includes(value.toLowerCase())){
                 result = true;
               }
              });
        }
        return result;
      }
      function isMotrioFilterProfile(){
        var result = false;
        var userProfil = CacheService.getUserProfile();
        if(userProfil && userProfil.rolesRparts && !_.isEmpty(userProfil.rolesRparts)){
             angular.forEach(userProfil.rolesRparts, function (value) {
                  if(value === ListPieceConstants.motrioFilterRpartsProfile){
                 result = true;
               }
              });
        }
        return result;
      }
      function isActisProfil() {
          var carContext = CacheService.getCarContext();
          var userProfil = CacheService.getUserProfile();
          var result = false;
         
            if (userProfil.roles && userProfil.roles.length > 0 && carContext && carContext.vin) {
              angular.forEach(userProfil.roles, function (value) {
                  if (value.toLowerCase() === ActisConstantes.actis_okta.toLowerCase() ) {
                      result = true;
                  }
              });
          }
          
          
          return result;
      }
      function isBTListProfile() {

        var userProfil = CacheService.getUserProfile();
        var result = false;
         {
            angular.forEach(userProfil.roles, function (value) {
                if (value === ActisConstantes.ppx_assist_tech_n1 || value === ActisConstantes.ppx_assist_tech_n2 || value === ActisConstantes.ppx_assist_tech_corp) {
                    result = true;
                }
            });
        }
        return result;
    }
    function isFactoryProfile() {

        var userProfil = CacheService.getUserProfile();
        var result = false;
         {
            angular.forEach(userProfil.roles, function (value) {
                if (value === ActisConstantes.ppx_assist_tech_n1 || value === ActisConstantes.ppx_assist_tech_n2) {
                    result = true;
                }
            });
        }
        return result;
    }

      function isActisProfilNoContext() {
        var userProfil = CacheService.getUserProfile();
          var result = false;
            if (userProfil && userProfil.roles && userProfil.roles.length > 0) {
              angular.forEach(userProfil.roles, function (value) {
                  if (value.toLowerCase() === ActisConstantes.actis_okta.toLowerCase()) {
                      result = true;
                  }
              });
          }
          
          return result;
      }
        function formatReferenceInput(ref) {
          const cacheProfile = CacheService.getObject(CacheConstants.profil);
          const isFormatEnabled = cacheProfile && cacheProfile.isPRFormat;
          if(isFormatEnabled){
              const val = (ref || '').toString().replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);            
              let formattedVal = '';
              if (val.length > 0) {
                  formattedVal = val.substring(0, 2);
              }
              if (val.length > 2) {
                  formattedVal += ' ' + val.substring(2, 4);
              }
              if (val.length > 4) {
                  formattedVal += ' ' + val.substring(4, 7);
              }
              if (val.length > 7) {
                  formattedVal += ' ' + val.substring(7, 10);
              }
              return formattedVal;
            } else {
              return ref;
            }
            
        };

      function isRnetUserType() {
         var userProfil = CacheService.getUserProfile();
         var result = false;
         const isValidUserType = userProfil && userProfil.userType && !_.isEmpty(userProfil.userType);
         const isRnetType = isValidUserType && userProfil.userType.toUpperCase() === 'RNET';
         if(isRnetType && !isNissanUserAccess()){
            result = true;
          }
          return result;
      }
  function isIndependantUser(roles){
    var result = false;
    angular.forEach(roles, function(value) {
      if (value === CarSearchConstants.ppxIndependentUser){
        result = true;
      }
    });
    return result;
  }

  function isSupportAccess(){
        var result = false;
        var userProfil = CacheService.getUserProfile();
        var supportAccessCountries = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];
        if (userProfil && userProfil.country) {
              if (supportAccessCountries.includes(userProfil.country)) {
              result = true;
              }
        }

        return result;
  }
  
  function isDocprivProfile() {
      var userProfile = CacheService.getUserProfile();
      if(userProfile && userProfile.roles && !_.isEmpty(userProfile.roles)){
        var result = userProfile.roles.filter(function (value){
          value = value;
          if ((userProfile.userType == "ARCA" && (value == DocPrivConstants.docPrivPopinVinProfile || value == DocPrivConstants.docprivStdProfile)) || (userProfile.userType == "RNET" && value == DocPrivConstants.ppxDocpriv)) {
            return value;
          }
        })
      }
      
      return result;
    }
	
  function isCirSentVin(vin){
    const profile = CacheService.getUserProfile();
    if(!isIndependantUser(profile.roles)){
      return;
    }
    let result = false;
    const allowedVinFromSession = CacheService.getObject(CacheConstants.allowedVin);
    const decrypted = allowedVinFromSession ? CryptoService.AES.decrypt(allowedVinFromSession, CacheConstants.encryptedValue) : null;
    const allowedVin = decrypted ? JSON.parse(decrypted.toString(CryptoService.enc.Utf8)) : [];
    const hasAllowedBrand = isBrandApplicable();
    const asomDocList = getAsomDocrights();
    const hasAllowedVin = vin != null && allowedVin && allowedVin.includes(vin);

    if (!hasAllowedVin && !hasAllowedBrand && asomDocList && Object.keys(asomDocList).length === 0) {
      $rootScope.asomDocList = {};
    }
    else if (hasAllowedVin){
      result = true;
      $rootScope.asomDocList = CarSearchResultConstants.asomDocList;
      const encryptedSession = CryptoService.AES.encrypt(JSON.stringify(CarSearchResultConstants.asomDocListSessionValue), CacheConstants.encryptedValue);
      CacheService.setObject(CacheConstants.asomSubscriptionForAllowedVin, encryptedSession.toString());
    }
    else{
      if(asomDocList && Object.keys(asomDocList).length > 0){
        $rootScope.asomDocList = asomDocList;
      }
    }
    
    AccessConfigService.getDocRights($rootScope.asomDocList);
        
    return result;
  }

  function isBrandApplicable() {
    const encrypted = CacheService.getObject(CacheConstants.applicabilities);
    const decrypted = CryptoService.AES.decrypt(encrypted, CacheConstants.encryptedValue);
    const decryptedStr = decrypted.toString(CryptoService.enc.Utf8);
    const applicabilities = JSON.parse(decryptedStr);
    let brandList = [];
    if (applicabilities.length > 0) {
      applicabilities.forEach(function (list) {
        if(!_.isEmpty(list.brandCriteria)){
          list.brandCriteria.forEach(function (item) {
            brandList.push(item);
          })
        }
      })
      brandList = _.uniq(brandList);
    }
    const brandComputed = (CacheService.getCarContext() && CacheService.getCarContext().brandComputed) ? CacheService.getCarContext().brandComputed : null;
    if(brandComputed){
      return _.isEmpty(brandList) || (!_.isEmpty(brandList) && brandList.includes(brandComputed));
    }

    return true;

  }

  function setAsomDocrights(){
    const encrypted = CacheService.getObject(CacheConstants.asomSubscription);
    const decrypted = CryptoService.AES.decrypt(encrypted, CacheConstants.encryptedValue);
    const decryptedStr = decrypted.toString(CryptoService.enc.Utf8);
    const parsedArray = JSON.parse(decryptedStr);
    const asomSubscriptions = parsedArray && parsedArray.length > 0 ? parsedArray[0] : false;

    $rootScope.asomDocList = {};
    if (asomSubscriptions ) {
      asomSubscriptions.documentList.forEach(function (x) {
        $rootScope.asomDocList[x.documentType] = true;
      });
    }
      AccessConfigService.getDocRights($rootScope.asomDocList);
    }

    function getAsomDocrights() {
      const encrypted = CacheService.getObject(CacheConstants.asomSubscription);
      const decrypted = CryptoService.AES.decrypt(encrypted, CacheConstants.encryptedValue);
      const decryptedStr = decrypted.toString(CryptoService.enc.Utf8);
      const parsedArray = JSON.parse(decryptedStr);
      const asomSubscriptions = parsedArray && parsedArray.length > 0 ? parsedArray[0] : false;

      var asomDocList = {};
      if (asomSubscriptions) {
        asomSubscriptions.documentList.forEach(function (x) {
          asomDocList[x.documentType] = true;
        });
      }
      return asomDocList;
    }
      function getDocunmentsInformations() {
          return $http.get(CarSearchResultConstants.configDocumentsURL);
      }

      function getDealersList(){
        
        var url = CarSearchConstants.r2aService;
        return RestUpgrade.one(url).get();
      }

      function saveDealerDetails(r1DealerId, clientCode){
        var url = CarSearchConstants.commercialLinkSave;

        var payload = {
          r1DealerId: r1DealerId,
          clientCode: clientCode
        }
        return RestUpgrade.all(url).post(payload).then(function(response){
          if(!response){
            return $q.reject();
          }

          return response;
        }).catch(function(){
            return $q.reject($translate.instant('ERROR_R2A_SAVE'));
        });
      }

      function getDealerDetails(){
        return RestUpgrade.one(CarSearchConstants.commercialLinkGet).get().then(function(res){
          return res;
        }).catch(function(){
          return $q.reject($translate.instant('ERROR_R2A_GET'))
        });
      }

      function getLastModificationDate() {
          return RestUpgrade.one(ProfilConstants.getLastModificationDate).get().then(function (response) {
              return response;
          }).catch(function () {
              return $q.reject();
          });
      }

      function isMitsubishiUser(){
        var userProfil = CacheService.getUserProfile();

        if(userProfil && userProfil.userType == 'RNET' && userProfil.roles && userProfil.roles.map(role => role.toLowerCase()).includes(CarSearchConstants.mitsubishiProfile.toLowerCase())){
          return true; 
        }
        return false;
      }

      function hasDealerRole(){
        var userProfil = CacheService.getUserProfile();
        if(userProfil && userProfil.roles && Array.isArray(userProfil.roles) && userProfil.roles.includes(rLinkConstant.rnetCnrDealer)){
          return true; 
        }
        return false;
      }

      function isPpxLightUser(){
        var userProfil = CacheService.getUserProfile();

        if(userProfil && userProfil.userType == 'RNET' && userProfil.roles && Array.isArray(userProfil.roles)){
          var roles = userProfil.roles.map(role => role.toLowerCase());
          var ppxLight = CarSearchConstants.ppxLight.toLowerCase();
          var ppxNetworkProfile = CarSearchConstants.ppxNetworkProfile.toLowerCase();
          var rnetCnrDealer = rLinkConstant.rnetCnrDealer.toLowerCase();
          var rnetCnrCustomerCare = rLinkConstant.rnetCnrCustomerCare.toLowerCase();

          if (!roles.includes(ppxNetworkProfile) && roles.includes(ppxLight) && (roles.includes(rnetCnrDealer) || roles.includes(rnetCnrCustomerCare))) {
            return true;
          }
        }
        return false;
      }

      function isOnlyPpxLightUser(){
        var userProfil = CacheService.getUserProfile();

        if(userProfil && userProfil.userType == 'RNET' && userProfil.roles && Array.isArray(userProfil.roles)){
          var roles = userProfil.roles.map(role => role.toLowerCase());
          var ppxNetworkProfile = CarSearchConstants.ppxNetworkProfile.toLowerCase();
          var ppxLight = CarSearchConstants.ppxLight.toLowerCase();

          if (!roles.includes(ppxNetworkProfile) && roles.length === 1 && roles[0] === ppxLight) {
            return true;
          }
        }
        return false;
      }

      function isHorseUser(){
        var userProfil = CacheService.getUserProfile();
        if(userProfil.entityRoles && !_.isEmpty(userProfil.entityRoles)){
          userProfil.entityRoles = _.map(userProfil.entityRoles,function(data){
              return data.toUpperCase();
          })
        } 
        CacheService.setObject(CacheConstants.profil,userProfil);
        if(userProfil && userProfil.userType == 'ARCA' && userProfil.entityRoles && userProfil.entityRoles.includes(CarSearchConstants.horseProfile)){
          return true;
        }
        return false;
      }

      function getCurrentDate() {
          if (!this._currentDate) {
              this._currentDate = new Date();
          }
          return this._currentDate;
      }

    function isNissanConnectedServices(roles) {
      var result = false;
      angular.forEach(roles, function (value) {
        if (value === CarSearchConstants.ppxNissanConnectedServices) {
          result = true;
        }
      });
      return result;
    }

    function isNissanUserAccess() {
      let result = false;
      const userProfil = CacheService.getUserProfile();
      angular.forEach(userProfil.roles, function (value) {
        if (value === CarSearchConstants.ppxNis) {
          result = true;
        }
      });
      return result;
    }

    function isEnableDiagForNissan() {
      let result = false;
      const userProfil = CacheService.getUserProfile();
      if(userProfil.roles && userProfil.roles.includes(SearchbyDiagnosticConstants.adtImmoRole) && userProfil.roles.includes(CarSearchConstants.ppxNis)){
        result = true;
      }
      return result;
    }

    function getAllNotifications(page, pageSize) {
      page = page || 0;
      pageSize = pageSize || 10;
      
      const params = {
        page: page,
        pageSize: pageSize
      };
      
      return RestUpgrade.one(SearchbyDiagnosticConstants.notificationsUrl).get(params).then(function(res){
        return res;
      }).catch(function(){
        return $q.reject($translate.instant('ERROR'))
      });
    }

    function getNotificationPopIn() {
      return RestUpgrade.one(SearchbyDiagnosticConstants.notificationPopInUrl).get().then(function(res){
        return res;
      }).catch(function(error){
        if (error && error.status === 204) {
          return null;
        }
        return $q.reject($translate.instant('ERROR'));
      });
    }

    function getUnreadNotificationCount() {
      return RestUpgrade.one(SearchbyDiagnosticConstants.notificationUnreadCountUrl).get().then(function(res){
        return res && res.count ? res.count : 0;
      }).catch(function(){
        return $q.reject($translate.instant('ERROR'));
      });
    }

      /*function getReference(reference, supersedingList) {
        var defer = $q.defer();
        var user = CacheService.getObject(CacheConstants.profil);
        var configuration =CacheService.getObject(CacheConstants.configuration);
        var references = _.union([reference], supersedingList);

      var valueToSendDms = {
        userDms: user.dmsConfig.userDms,
        ipn: user.userId,
        dealerId: user.dealerId,
        workshopPartshopId: user.dmsConfig.workshopPartshopId,
        references: references,
        stocks: user.dmsConfig.stocks
      };

      var valueToSendBack = {
        userId: user.userId,
        userType: user.userType,
        country: user.country,
        language: user.language,
        references: references,
        vehicleContext:{}
      };

      var isDms = false;

      if (user.dmsConfig && user.dmsConfig.userDms) {
        valueToSendDms.userDms = user.dmsConfig.userDms;
        isDms = true;
      }


      if (isDms) {

        ProductWsService.getReferences(valueToSendBack).then(
          // DMS user
          function (backObjectFromWS) {

            var referenceFromBack;

            // manage additional
            if (backObjectFromWS && !backObjectFromWS.errorCode) {
              if (backObjectFromWS.references) {

                for (i = 0; i < backObjectFromWS.references.length; i++) {
                  referenceFromBack = backObjectFromWS.references[i];
                  if (referenceFromBack && referenceFromBack.status === 0 && referenceFromBack.additional) {
                    for (var j = 0; j < referenceFromBack.additional.length; j++) {
                      valueToSendDms.references.push(referenceFromBack.additional[j].reference);
                    }
                  }
                }
              }
            }

            ProductWsService.getReferencesDms(valueToSendDms).then(
              function (dmsObjectFromWS) {

                //if (dmsObjectFromWS.returnCode === 0 || backObjectFromWS.references) {
                var parts = [];

                if(dmsObjectFromWS && dmsObjectFromWS.response && dmsObjectFromWS.response.parts ){
                  parts = dmsObjectFromWS.response.parts;
                }
                if (parts || backObjectFromWS.references) {

                  var listProductMerged = initListReferences(backObjectFromWS.references, parts);
                  //var productMerged = mergeObjects(referenceFromBack ,dmsObjectFromWS);
                  getAllStockProduct(listProductMerged);
                  defer.resolve({product: listProductMerged});
                }
                else {
                  if (backObjectFromWS && backObjectFromWS.errorCode) {
                    defer.reject({dmsError: dmsObjectFromWS.message, backError: backObjectFromWS.errorCode.label});
                  }
                  else {
                    $translate('PRODUCT_ERROR_NOT_FOUND').then(
                      function (text) {
                        defer.reject({dmsError: dmsObjectFromWS.message, backError: text});
                      }
                    )
                  }
                }
              }
            );
          }
        );*/
    function isDdpAdmin(){
        let isDdpAdmins = false;
        const profil = CacheService.getObject(CacheConstants.profil);
        const isArcaUserType = profil && profil.userType === 'ARCA';
        const hasValidRoles = !_.isEmpty(profil && profil.roles) && profil.roles.includes(rLinkConstant.ddpAdmin);
        if(isArcaUserType && hasValidRoles){
            isDdpAdmins = true;
        }
        return isDdpAdmins;
    }
    function goToDesyre(url, type) {
      const isDDPAdmin = isDdpAdmin();
      const isLocalRedirect = JSON.parse(configConstantes.isLocalRedirection);
      if(type){
        CacheService.setObject(CacheConstants.actisFicType, type);
      }
      const currentUrl = $location.absUrl();
      const currentBaseUrl = currentUrl.split('#')[0];
      const desyreURL = isLocalRedirect && configConstantes.desyreBaseUrl
        ? configConstantes.desyreBaseUrl + '/'
        : currentBaseUrl;

      const targetUrl = url === 'notifications'
        ? (isDDPAdmin
          ? `${desyreURL}new/notifications/admin`
          : `${desyreURL}new/notifications/user`)
        : `${desyreURL}new/${url}`;

      if (isLocalRedirect) {
        try {
          const sessionData = {};
          for (let i = 0; i < $window.sessionStorage.length; i++) {
            const key = $window.sessionStorage.key(i);
            sessionData[key] = $window.sessionStorage.getItem(key);
          }
          $window.name = JSON.stringify({ __nd_session: true, data: sessionData });
        } catch(e) {
          console.info('Could not serialize session for transfer:', e);
        }
      }

      $window.location.href = targetUrl;
    }

    function shouldShowPricingSection(profileValue) {
      
      const isDmsNotConnected = profileValue && profileValue.dmsConnected === false;
      const isTargetDealerId = profileValue && profileValue.dealerId === '05600492';
      
      return isPricingSectionEnabled && profileValue && profileValue.userType === 'RNET' &&
        isDmsNotConnected &&
        isTargetDealerId;
    }

    function updateNotificationReadStatus(notificationId, readStatus) {
      const url = `${CarSearchConstants.notificationsEndPoint}${CarSearchConstants.updateReadStatus}${notificationId}/${readStatus}`;
      return RestUpgrade.one(url).put();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .service('ClickStateService', function () {
        const state = {};

        return {
            getState: function (id) {
                return state[id] || false;
            },
            setState: function (id, value) {
                state[id] = value;
            },
            resetState: function (id) {
                state[id] = false;
            }
        };
    }).directive('oneClickOnlyQuote', [
        '$parse', '$rootScope', 'ClickStateService',
        function ($parse, $rootScope, ClickStateService) {
            return {
                restrict: 'A',
                scope: false, 
                compile: function (element, attr) {
                    const fn = $parse(attr['oneClickOnlyQuote']);
                    return {
                        pre: function (scope, elem, attrs) {
                            const elementId = attrs.id || 'oneClickOnly_' + Math.random().toString(36).substr(2, 9);
                            attrs.$set('id', elementId);
                            $rootScope.$on('on-close-quote', function () {
                                ClickStateService.resetState(elementId);
                            });

                            const clickingCallback = function (e) {
                                if (ClickStateService.getState(elementId)) {
                                    return;
                                }
                                ClickStateService.setState(elementId, true);
                                fn(scope, { $event: e });
                            };
                            elem.bind("click", clickingCallback);
                        }
                    };
                }
            };
        }
    ]).controller('MainController', MainController);

    /** @ngInject */
    function MainController(RoutingService, QuoteMetierService, errorsConstant,
        CartViewListWSService, ShoppingCartService, TokenService,
        toastr, $state, $translate,$scope,
        CacheService, CacheConstants, RoutesConstants,
        $rootScope, UtilsMetierService, configConstantes, $q, blockUI,
        ProductMetierService, AlertsService, DocumentsMetierService, $window,
        DealerManagerSystemeService, PartRequisitionConstants, $mdDialog,
        PartRequisitionMetierService, DmsConstants, QuoteConstants,
        FicViewListWSService, MainMetierService, CreateActisBusinessService,
        CodesConstants, trainingConstants, CloudFrontService, $timeout,PanierConstants,
        RecapCarMetierService,CarSearchResultConstants,LoginConstants, CommentsService,
        btListMetierService,$log,DocPrivMetierService,$compile,AccessConfigService, $location) {

        var vm = this;
        vm.goToPublicationLink = goToPublicationLink;
        vm.goToElectronicRepair = goToElectronicRepair;
        vm.goToServiceWeather = goToServiceWeather;
        vm.goToNissanServiceWeather = goToNissanServiceWeather;
        vm.goToBoschLink = goToBoschLink;
        vm.goToSpaceNomadeDealersLink = goToSpaceNomadeDealersLink;
        vm.goToConnectServicesLink = goToConnectServicesLink;
        vm.goToAccessoriesWebsiteLink = goToAccessoriesWebsiteLink;
        vm.goToDabSiteLink = goToDabSiteLink;
        vm.serviceWeatherLink = CarSearchResultConstants.serviceWeatherLink
        vm.nissanServiceWeatherLink = CarSearchResultConstants.nissanServiceWeatherLink
        vm.boschLink = CarSearchResultConstants.boschLink;
        vm.spaceNomadeDealersLink = CarSearchResultConstants.spaceNomadeDealersLink;
        vm.connectServicesLink = CarSearchResultConstants.connectServicesLink;
        vm.accessoriesWebsiteLink = CarSearchResultConstants.accessoriesWebsiteLink;
        vm.dabSiteLink = CarSearchResultConstants.dabSiteLink;
        vm.electronicRepairLink = CarSearchResultConstants.electronicRepairLink;
        vm.eGuide = CarSearchResultConstants.eGuideLink;
        const { garageEquipmentLink, userBox, reuseLinks } = CarSearchResultConstants;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);
        const isActisNew = JSON.parse(configConstantes.isActisNew);
        $scope.partListNotif = [];
        const externalNoColorCodes = ['RED','BLUE','BLUE_WITH_FOLLOW_UP','YELLOW','ORANGE'];
        const _errors = errorsConstant;

        //#region handlers event
        let handlerQuoteCreadredEvent;
        let handlerQuoteUpdatedEvent;
        let handlerQuoteClosedEvent;
        let handlerPartsRequisitionCreatedEvent;
        let handlerPartsRequisitionUpdatedEvent;
        let handlerPartsRequisitionClosedEvent;
        let handlerProfileUpdated;
        let handlerStoreHookResultEvent;
        //#endregoin

        // quote supertCartPopin
        vm.quote = {};
        vm.quoteItems = [];
        vm.newHeaderMenu = JSON.parse(configConstantes.newHeaderMenu);
        vm.quotePopinTitle = '';
        vm.quotePopinSubtitle = '';
        vm.quoteItemsNumber = 0;
        vm.partsRequisition = {};
        vm.partsRequisitionItems = [];
        vm.partsRequisitionPopinTitle = '';
        vm.partsRequisitionPopinSubtitle = '';
        vm.partsRequisitionItemsNumber = 0;
        vm.notificationNumber = 0;
        vm.TRAD = {};
        vm.version = configConstantes.version;
        vm.ndHelpUrl = configConstantes.ndHelpUrl;
        vm.publications =configConstantes.publications;
        vm.ndDocumentsUrl = configConstantes.ndDocumentsUrl;
        vm.notHide = false;
        vm.quoteButtonDisabled = true;
        vm.partRequisitionButtonDisabled = true;
        const user = CacheService.getObject('profil');
        vm.contextCarBrandCritCheck = MainMetierService.rnetUserBrandCheck();
        vm.isContextCarBrandCheck =  vm.contextCarBrandCritCheck ? true : false;
        vm.currentLang = $translate.proposedLanguage() || $translate.use();
        vm.popinVisibility = AlertsService.getPopinVisibility();
        vm.commentsPopinVisibility = CommentsService.getPopinVisibility();
        vm.inputReference = "";
        vm.partRequisitionDraftStatus = PartRequisitionConstants.draftStatus;
        vm.partRequisitionValidateStatus = PartRequisitionConstants.validatedStatus;
        vm.searchRefBT = {};
        vm.searchRef = {};
        var interval;
        const NT_REFERENCE_RANGE_START = 10001;
        const NT_REFERENCE_RANGE_END = 29999;
        const BT_REFERENCE_OFFSET = 10001;
        const REFERENCE_LENGTH_WITH_SUFFIX = 5;
        const USER_GUIDING_NON_PROD_ORIGINS = [ 
            'https://dev.ppx.dev.asdh.aws.renault.com',           
            'https://re7.ppx.re7.asdh.aws.renault.com'
        ];
        const USER_GUIDING_PROD_SCRIPT_URL = 'https://static.userguiding.com/media/user-guiding-ICR1125406ZWID-embedded.js';
        const USER_GUIDING_NON_PROD_SCRIPT_URL = 'https://static.userguiding.com/media/user-guiding-4HO112539IF1ID-embedded.js';
        vm.btNamesAndLabels = [];
        vm.isFunctionalityDevOnly = configConstantes.isFunctionalityDevOnly;
        vm.fic = {};
        vm.isBannerVisible = false;
        vm.isOldRangeDocEnable = configConstantes.isOldRangeDocEnable;
        const userProfil = CacheService.getUserProfile();
        vm.isOldRangeDocEnable = configConstantes.isOldRangeDocEnable;
        vm.ndCookiesUrlisActive = false;
        vm.ndDataPolicyUrlisActive = false;
        vm.ndCguFileUrlisActive = false;
        vm.cookiesFileName = CarSearchResultConstants.cookiesFileName;
        vm.aidInstallation = "/AID_InstallationSheet";
        vm.dataPolicyFileName = CarSearchResultConstants.dataPolicyFileName;
        vm.cguFileName = CarSearchResultConstants.cguFileName;
        vm.ndFooterFileDate = CarSearchResultConstants.ndFooterFileDate;
        vm.isEmptyNews = false;
        vm.isPaintCirEnabled = JSON.parse(configConstantes.isPaintCirEnabled);
        vm.atLeastTwoBTDocument = false;
        vm.listOfBTDocuments = [];
        vm.cartLength = 0;
        vm.flattenCart = [];
        vm.cartMetadata = {};

        vm.goToVirtualAcademy = goToVirtualAcademy;
        vm.getDMSDealerLabel = getDMSDealerLabel;
        vm.goToAlertsMenu = goToAlertsMenu;
        vm.goToHelpPage = goToHelpPage;
        vm.vehicleNotFoundInDMS = false;
        vm.vehicleNotFoundInBVM = false;
        vm.multipleDealers = false;
        vm.isRpartsRole = MainMetierService.isRpartsRole();
        vm.displayDealerListPopIn = displayDealerListPopIn;
        vm.selectedDealer = {};
        vm.multipleDealersShow = false;
        vm.saveDealerDetails = saveDealerDetails;
        vm.isAlertsVisible = false;
        vm.tokenBalance=UtilsMetierService.getTokenBalance();
        vm.isBrwDealer = UtilsMetierService.isActisProfil(userProfil);
        vm.reCheckAsomSubscriptions=reCheckAsomSubscriptions;
        vm.goToReleases=goToReleases;
        vm.processedCIRCount = 0;
        vm.goToSpecialTools = goToSpecialTools;
        vm.removeCacheVariables = removeCacheVariables;
        translate();
        vm.isHorseUser = MainMetierService.isHorseUser();
        vm.formatBt = formatBt;
        vm.showQstomizeTabOnly = false;
        vm.showOnlyQstomizeTabOnly = false;
        vm.isDDPAdmin = false;
        vm.userProfile = CacheService.getUserProfile();
        vm.isMitsubishiUser = MainMetierService.isMitsubishiUser();
        vm.isOnlyPpxLightUser = MainMetierService.isOnlyPpxLightUser();
        vm.isPpxLightUser = MainMetierService.isPpxLightUser();
        vm.allowASOM = CacheService.getObject(CacheConstants.asomNotAllowed) ? CacheService.getObject(CacheConstants.asomNotAllowed) :false;
        vm.currentDate = moment(new Date()).format("dddd, D-MMM-YYYY h:mm:ss A");
        vm.checkMenuAccess = checkMenuAccess;
        vm.goToDesyre = goToDesyre;
        vm.isDDPAdmin = MainMetierService.isDdpAdmin();
        vm.toCallUserGuiding = toCallUserGuiding;
        vm.toEnableUserIdentification = toEnableUserIdentification;

        const SCROLL_THRESHOLD = 35;
        $rootScope.$on('notificationCountUpdated', function (event, unreadCount) {
            vm.notificationLength = unreadCount;
            $scope.$applyAsync();
        });
        init();

        /********************** STart Broadcast and Listener Emition **************************/

        /**
         * Broadcast getBeingModifiedFic  Actis controller in order to retrieve/load information from fic
         */
        $scope.isFicBeingModified = false;
        $rootScope.searchRefBTNT = searchRefBTNT;
        $scope.getBeingModifiedFic = function () {
            $rootScope.$broadcast('getBeingModifiedFic');
            return $scope.isFicBeingModified;
        };

        $rootScope.$on('loadFicModification', function (e, fromActisControllerData) {
            $scope.isFicBeingModified = fromActisControllerData;
        });
        $rootScope.$on('isContextCarBrandCheck', function (i, isContextCarBrandCheck) {
            if(isContextCarBrandCheck){
                vm.isContextCarBrandCheck = isContextCarBrandCheck;
            }
            else{
                vm.isContextCarBrandCheck = false;
            }
        });
        //Destroy the listener
        $scope.$on('$destroy', $rootScope.$on("loadFicModification", function () {
            $scope.loadFicModification = angular.noop();
        }));

        $scope.getFicData = function () {
            $scope.$broadcast('getFicData');
        };

        $scope.$on('loadFicData', function (_event, data) {

            //Deep copy of the case view if it contains multiple object property
            for (const property in data) {
                // Case the property of data is not include in vm.fic we add it
                if (vm.fic && !vm.fic[property]) {
                    vm.fic[property] = data[property];
                } else { //On the other hand if property exist we copy the innerproperty inside
                    for (const innerProperty in data[property]) {
                        vm.fic[property][innerProperty] = data[property][innerProperty];
                    }
                }
            }
        });


        // receiving part of checking if returnCode of DMS is "not found" for searched vin
        $rootScope.$on('VehicleNotFoundInDMS', function(){
            vm.vehicleNotFoundInDMS = true;
        });

        // receiving part of checking if returnCode of BVM is "not found" for searched vin
        $rootScope.$on('VehicleNotFoundInBVM', function(){
            vm.vehicleNotFoundInBVM = true;
        });

        //****************END  BROADCAST EMITION ******************

        /**
         *  @desc Bind a even for unlock all cart when user close tab/window
         *        Debind when the user logout
         */

        window.onbeforeunload = function () {
            if (window.closed) {
                ShoppingCartService.unlockCart().catch(function () {
                    // handle abort on reload
                });
                PartRequisitionMetierService.unlockPartRequisitionLogic();
            }
        }

        $scope.$on('$destroy', function () {
            window.onbeforeunload = null;
            handlerQuoteCreadredEvent();
        });

        $rootScope.$on('ACTIVATE_BANNER', function () {
            vm.isBannerVisible = true;
        });

        $rootScope.$on('loadTooltip', function () {
            vm.tooltip = (CacheService.getObject(CacheConstants.informationMessage)) ? CacheService.getObject(CacheConstants.informationMessage).information : null;
        });

        function bannerRGPD(){
            $mdDialog.show({
                templateUrl:'app/components/car/carSearch/components/bannerRGPDnew.template.html',
                controller:'bannerRGPDController',
                bindToController:true,
                controllerAs:'vm',
                clickOutsideToClose:false,
                escapeToClose:false
            });
        }
       
        function init() {
             $scope.showFooter = false;

            let scrollTimeout;

            function checkFooterVisibility() {
                if (scrollTimeout) clearTimeout(scrollTimeout);

                scrollTimeout = setTimeout(() => {
                    const scrollTop = window.scrollY || document.documentElement.scrollTop;
                    const windowHeight = window.innerHeight;
                    const docHeight = document.documentElement.scrollHeight;

                    if (docHeight <= windowHeight) {
                        $scope.showFooter = true;
                    } else if (scrollTop + windowHeight >= docHeight - 5) {
                        $scope.showFooter = true;
                    } else {
                        $scope.showFooter = false;
                    }

                    $scope.$applyAsync();
                }, 100);
            }

            window.addEventListener('scroll', checkFooterVisibility);
            window.addEventListener('resize', checkFooterVisibility);
            angular.element(document).ready(checkFooterVisibility);
            vm.isIndependentUser = MainMetierService.isIndependantUser(userProfil.roles);
            const isRedirectFromDesyre = CacheService.getObject(CacheConstants.isRedirectFromDesyre);
            if ($state.params.isAngularRedirect || isRedirectFromDesyre) {
                vm.inputReference = CacheService.getObject(CacheConstants.prSearchText)
                const basketData = CacheService.getObject(CacheConstants.basketPopupData)
                $rootScope.panierData = basketData;          
            }
            vm.isBrandApplicable = isBrandApplicable;
            vm.goToFavouritesProd = goToFavouritesProd;
            vm.goToFavouritesTM = goToFavouritesTM;
            vm.createQuote = createQuote;
            vm.createOrGetPartList = createOrGetPartList;
            vm.goToCarSearchPage = goToCarSearchPage;
            vm.goToListQuoteDraft = goToListQuoteDraft;
            vm.goToListQuoteValidated = goToListQuoteValidated;
            vm.goToListPartsRequisitionsDraft = goToListPartsRequisitionsDraft;
            vm.goToListPartsRequisitionsValidated = goToListPartsRequisitionsValidated;
            vm.backToSearchCar = backToSearchCar;
            vm.disconnect = disconnect;
            vm.redirectionDisconnect = redirectionDisconnect;
            vm.myProfile = myProfile;
            vm.editProfile = editProfile;
            vm.goToNewPart = goToNewPart;
            vm.goToCurrentState = goToCurrentState;
            vm.goToBasket = goToBasket;
            vm.goToDocpriv = goToDocpriv;
            vm.goToEasyBasketValidation = goToEasyBasketValidation;
            vm.goToFactoryRework = goToFactoryRework;
            vm.goToListPaniers = goToListPaniers;
            vm.goToBTlist = goToBTlist;
            vm.goToListFic = goToListFic;
            vm.goToSupport = goToSupport;
            vm.searchReference = searchReference;
            vm.tooltipVehicleContext = tooltipVehicleContext;
            vm.tooltipWhenPartList = tooltipWhenPartList;
            vm.tooltipWhenBasket = tooltipWhenBasket;
            vm.getUIMainClass = getUIMainClass;
            vm.goToGarageEquipment = goToGarageEquipment;
            vm.goToeGuide = goToeGuide;
            vm.goToUserBox = goToUserBox;
            vm.reuseParts = reuseParts;
            vm.goToAidInstallation = goToAidInstallation;

            vm.goToRenaultTech = goToRenaultTech;
            vm.goToTraining = goToTraining;
            vm.goToSdp = goToSdp;
            vm.goToOldRangeDocuments = goToOldRangeDocuments;

            vm.getPanierInCache = getPanierInCache;
            vm.getIconVehicleClass = getIconVehicleClass;
            vm.resetReferenceSearch = resetReferenceSearch;
            vm.goToPartsRequisition = goToPartsRequisition;
            vm.goToQuote = goToQuote;
            vm.canCreatePartRequisitionOrQuote = canCreatePartRequisitionOrQuote;
            vm.onCloseFic = onCloseFic;
            vm.redirectSearchBTByNumber = redirectSearchBTByNumber;
            vm.redirectSearchNTByNumber = redirectSearchNTByNumber;
            vm.redirectSearchReference = redirectSearchReference;
            vm.getNetworkUserProfil = getNetworkUserProfil;
            vm.setGDPRcookiesAndBanner = setGDPRcookiesAndBanner;

            vm.iconeCloseOrOpen = "icon-icons_arrow_down";
            vm.currentState = $rootScope.currentState;
            vm.searchBTByNumber = searchBTByNumber;
            vm.searchNTByNumber = searchNTByNumber;
            vm.rCst = RoutesConstants;
            vm.iconAccess = iconAccess;
            vm.searchRefBTNT = searchRefBTNT;
            vm.removeSpaces = removeSpaces;
            vm.redirectSearchOTSByNumber = redirectSearchOTSByNumber;

            vm.isActisProfil = MainMetierService.isActisProfilNoContext();
            vm.isRnetUserType = MainMetierService.isRnetUserType(userProfil.userType);
            vm.isArcaUser = MainMetierService.isArcaUser();            
            vm.isSupportAccess = MainMetierService.isSupportAccess();
            vm.isAsomValidDocAccess=UtilsMetierService.checkAsomValidDocAcess();
            if(!vm.nissanUserURL) {
                interval = setInterval(toCallUserGuiding, 500);
                toEnableUserIdentification();
            }            
            
            vm.notificationLength = 0;
            MainMetierService.getUnreadNotificationCount().then(function(unreadCount) {
                vm.notificationLength = unreadCount;
            }).catch(function(error) {
                toastr.error(error)
                vm.notificationLength = 0;
            });

            vm.openMedia = openMedia;
            vm.dealerList = CacheService.getR2ADealerList() ? CacheService.getR2ADealerList().dealers: {};
            vm.isTraceEnabled = (JSON.parse(configConstantes.isTraceEnable) && (UtilsMetierService.isTraceKnownUser() || UtilsMetierService.isTraceKnownUserINT()));
            vm.isAlertsEnabled = UtilsMetierService.isRedButtonAuthorized();
            
            // Convert cached properties to getter functions to always reflect current service values
            Object.defineProperty(vm, 'isAlertsVisible', {
                get() {
                    return JSON.parse(configConstantes.isTraceEnable) && (UtilsMetierService.isTraceKnownUser() || UtilsMetierService.isTraceKnownUserINT()) ? true : UtilsMetierService.isRedButtonAuthorized();
                }
            });
            
            Object.defineProperty(vm, 'isAlertsEnabled', {
                get() {
                    return UtilsMetierService.isRedButtonAuthorized();
                }
            });
            vm.goToActisPage = goToActisPage;
            vm.isNonDmsOrderModeEnable = UtilsMetierService.isNonDMSDealerAuthorised();
            vm.getPlaceHolder = getPlaceHolder;
            $rootScope.isIndependentUser = vm.isIndependentUser;

            if (vm.isIndependentUser){
                MainMetierService.setAsomDocrights();
            }

            if(vm.isIndependentUser && vm.userProfile && vm.userProfile.accountType == 'Automobile repairer'){
                vm.showQstomizeTabOnly = true;
            }

            AccessConfigService.getProfileFromCache(vm.userProfile);
            AccessConfigService.getDocRights($rootScope.asomDocList);

            if(!vm.nissanUserURL){
                vm.newsList = CacheService.getBreakingNewsNoCarContext();
                // Receive and manage data from service call breakingNews
                $rootScope.$on('loadNews', function (event, data) {
                    // Initialize newsList array structure
                    var newsData = CacheService.getBreakingNewsNoCarContext();
                    if (data && !_.isEmpty(data)) {
                        vm.newsList = data;
                    } else if(newsData && !_.isEmpty(newsData)){
                        vm.newsList = newsData;
                    }
                    else {
                        vm.isEmptyNews = true;
                    }
                });
            }
            $rootScope.$on('popinInfoActiveLinks', function (event, data) {
                if (data) {
                    goToRenaultTech(data);
                }
            });
            $rootScope.$on('isMRInNewTab', function (event, val) {
                vm.isMRInNewTab = val;
            });
            $rootScope.$on('isMDInNewTab', function (event, val) {
                vm.isMDInNewTab = val;
            });
            $rootScope.$on('isBTInNewTab', function (event, val) {
                vm.isBTInNewTab = val;
            });
            $rootScope.$on('processedCIRList', function (event, count) {
                vm.processedCIRCount = count;
            });
            if(isRedirectFromDesyre){
                vm.processedCIRCount = CacheService.getObject(CacheConstants.Common_Assistance);
            }
            vm.isFactoryProfile = MainMetierService.isFactoryProfile();

            // enable or disable quote button
            vm.quote = QuoteMetierService.getQuoteData();


            var partList = CacheService.getObject(CacheConstants.partList);
            $rootScope.currentPartList = partList ? true : false;

            vm.user = CacheService.getObject(CacheConstants.profil);
            var repairLabCountryList = CarSearchResultConstants.repairCountryList;
            if (vm.user && vm.user.country) {
                if (repairLabCountryList.includes(vm.user.country)) {
                   vm.repairLabCountries = true;
                }
           }

            vm.isCountryChina = UtilsMetierService.isCountryTargeted('CN');
            vm.isCountryIndia = UtilsMetierService.isCountryTargeted('IN');
            vm.isCountryKorea = UtilsMetierService.isCountryTargeted('KR');
            vm.isCountryRoumania = UtilsMetierService.isCountryTargeted('RO');
            vm.isCountrySparc = false;
            vm.sparcCountries = ['AR', 'AT', 'BE', 'BR', 'CH', 'CN', 'CO', 'CZ', 'DE', 'DK', 'DZ', 'ES', 'FR', 'GB','HR', 'HU', 'IN', 'IT', 'KR', 'MA', 'NL', 'PL', 'PT', 'RO', 'RU', 'SE', 'SI', 'SK', 'TR', 'UA'];
            if (vm.user && vm.user.country) {
                if (vm.sparcCountries.includes(vm.user.country)) {
                    vm.isCountrySparc = true;
                }
            }
            $translate.use(user.language);

            if (vm.user && !vm.user.dmsConnected) {
                vm.dmsConnected = false;
            }

            if (vm.user && UtilsMetierService.isPartShop(vm.user)) {
                $scope.enableEstimate = true;
                $scope.enablePartList = true;
            }
            else {
                $scope.enableEstimate = false;
                $scope.enablePartList = false;
            }



            if (vm.user && vm.user.activeNotification) {
                vm.showNotification = true;
            }


            setDocumentsUrl();

            vm.isAdmin = false;
            vm.dmsConnected = JSON.parse(sessionStorage.getItem("dms"));
            vm.user.dmsConnected = vm.dmsConnected;
            CacheService.setObject(CacheConstants.profil, vm.user);
            const dynatraceMonitoring = {
             roles: vm.user.roles,
             dmsConnected: vm.user.dmsConnected,
             dmsUrl: vm.user.dmsConfig.url,
             dealerId: vm.user.dealerId,
         };
         CacheService.setObject(
             CacheConstants.dynatraceMonitoring,
             dynatraceMonitoring
         );
            if (vm.isRnetUserType && !CacheService.getR2ADealerList()){
                MainMetierService.getDealersList().then(function (response){
                    CacheService.setR2ADealerList(response);
                }).catch(function(){
                    CacheService.setR2ADealerList({ dealers: [], r1: false });
                });
			}
            if (vm.isRpartsRole && (vm.dmsConnected || (!vm.dmsConnected && vm.isNonDmsOrderModeEnable))){
                if (CacheService.getR2ADealerList()){
                    var cachedetail = CacheService.getR2ADealerList();
                    var dealerList = _.find(cachedetail.dealers, function(item){
                        return item.active == true;
                    });
                    if (dealerList != undefined){
                        if (cachedetail.dealers.length > 1){
                            vm.multipleDealers = true;
                        }
                        vm.selectedDealer = dealerList;
                    }else{
                        if (cachedetail && cachedetail.dealers && cachedetail.dealers.length > 1){
                            displayDealerListPopIn(cachedetail);
                        }
                    }

                }

                else if (vm.isRnetUserType &&
                             !CacheService.getR2ADealerList() && UtilsMetierService.isDealerAuthorised()){
                        MainMetierService.getDealersList().then(function (response){
                            CacheService.setR2ADealerList(response);

                            return response;
                        }).then(function(response){
                            if (response)
                            {
                                if (response.r1 === false){
                                    if(response.dealers.length == 0){
                                        toastr.error($translate.instant('ORDERING_MODULE_SERVICE_ERROR'));
                                        removeInformation();
                                    }else if (response.dealers.length >= 1){
                                        _.map(response.dealers, function(element){
                                            _.extend(element,{active : false,dealerClient: element.dealerId+" | "+element.clientCode})
                                        })

                                        CacheService.setR2ADealerList(response);

                                        MainMetierService.getDealerDetails().then(function(dealerDetailsFromDb){

                                            if(dealerDetailsFromDb){
                                                var selDealerId = _.find(response.dealers, function(item){
                                                    return dealerDetailsFromDb.r1DealerId === item.dealerId;
                                                });

                                                _.assign(selDealerId, {
                                                    active: true
                                                })

                                                CacheService.setR2ADealerList(response);

                                            }


                                        }).then(function(){

                                            var cachedetail = CacheService.getR2ADealerList();

                                            var selectedDealer = _.find(cachedetail.dealers, function(item){
                                                return item.active === true;
                                            });

                                            if(selectedDealer){
                                                vm.selectedDealer = selectedDealer;
                                                removeInformation();
                                                if(cachedetail.dealers.length > 1){
                                                    vm.multipleDealers = true;
                                                }

                                            }else{
                                                if(cachedetail.dealers.length === 1){
                                                    removeInformation();

                                                    saveDealerDetails(cachedetail.dealers[0]);
                                                }else if (response.dealers.length > 1){

                                                    if (!CacheService.getObject(CacheConstants.informationMessage).message){
                                                        displayDealerListPopIn(cachedetail);

                                                    }
                                                    else {
                                                        $rootScope.$on('displayDealerPopup', function (event, display) {
                                                            if (display && CacheService.getR2ADealerList()){
                                                                displayDealerListPopIn(cachedetail);
                                                            }

                                                        })

                                                    }


                                                }
                                            }



                                        }).catch(function(error){
                                            if(error){
                                                toastr.error(error)
                                            }
                                        })


                                    }

                                }


                            }else{
                                removeInformation();
                                toastr.error(response.returnCode +" : " + $translate.instant('ORDERING_MODULE_SERVICE_ERROR'));

                            }

                        }).catch(function(error){
                            if(error && error.data && !_.isEmpty(error.data.errors[0]) && error.data.errors[0].errorCode.length == 4){
                                toastr.error($translate.instant(PanierConstants.Error[error.data.errors[0].errorCode]));
                            } else {
                                toastr.error($translate.instant("ERROR"));
                            }
                        })
                }
                else{
                    removeInformation();
                }
            }
            else{
                removeInformation();
            }

            var bsInformations = CacheService.getObject(PartRequisitionConstants.bs);
            if (bsInformations) {
                vm.partRequisitionButtonDisabled = false;
            }
            if (vm.quote && vm.quote.informations) {
                vm.quoteButtonDisabled = false;
            }

            setCurrentQuote();
            setCurrentPartsRequisition();
            setCurrentBasket();

            //#region Quote events
            handlerQuoteCreadredEvent = $rootScope.$on(QuoteConstants.quoteCreatedEvent, function () {
                setCurrentQuote();
            })

            handlerQuoteUpdatedEvent = $rootScope.$on(QuoteConstants.quoteUpdatedEvent, function () {
                setCurrentQuote();
            })

            $rootScope.$on('fodQuoteUpdated', function () {
                updateFodQuoteItemsNumber();
            })

            handlerQuoteClosedEvent = $rootScope.$on(QuoteConstants.quoteClosedEvent, function () {
                setCurrentQuote();
            })
            //#endregion

            //#region PartsRequisition events
            handlerPartsRequisitionCreatedEvent = $rootScope.$on(PartRequisitionConstants.partsRequisitionCreatedEvent, function () {
                setCurrentPartsRequisition();
            })

            handlerPartsRequisitionUpdatedEvent = $rootScope.$on(PartRequisitionConstants.partsRequisitionUpdatedEvent, function () {
                setCurrentPartsRequisition();
            })

            handlerStoreHookResultEvent = $rootScope.$on(PartRequisitionConstants.partsRequisitionClosedEvent, function () {
                setCurrentPartsRequisition();
            })

            $rootScope.$on(ShoppingCartService.event.cartUpdated, function() {
                setCurrentBasket(true);
            })

            $rootScope.$on("profileUpdated", function (event, data) {
                vm.user.language = data.language;
                vm.user.dmsConfig.networkProfile = data.networkProfile;
                setDocumentsUrl();
                DealerManagerSystemeService.storeHookResult(data.dmsState);
            })

            $rootScope.$on('R2A_UPDATED', function (event) {
                // update the dealerList while updating cache
                var r2aDealerList = CacheService.getR2ADealerList();

                if(r2aDealerList){
                    vm.dealerList = r2aDealerList.dealers;
                }

            });

            $rootScope.$on("storeHookResultEvent", function () {
                vm.dmsConnected = DealerManagerSystemeService.getHookResult();
            })


            vm.vehiclePresentInDMSbutNotInBVM = CacheService.getObject(CacheConstants.vehiclePresentInDMSbutNotInBVM);

            // setGDPRcookiesAndBanner();
            // if(vm.isBannerVisible){
            //     bannerRGPD();
            // }

            // Check if user country allows showing virtual academy button
            const userProfile = CacheService.getUserProfile();
            for (const country of trainingConstants.countries) {
                if (userProfile.country === country) {
                    vm.isVisibleBtnVirtualAcademy = true;
                    break;
                }
            }

            if(!vm.isIndependentUser){
                displayHappi();
            }

                
        }

        function checkMenuAccess(menu, subMenu){
            return AccessConfigService.checkAccess(menu, subMenu);
        }

        function displayHappi(){

                setTimeout(function(){

                    if (document.getElementById("phenixNav")){

                        vm.node = document.createElement('renault-ng-feedback');
                        document.getElementById('happi').appendChild(vm.node);

                        vm.nodes = document.getElementsByTagName('renault-ng-feedback');
                        vm.nodes[0].outerHTML = "<renault-ng-feedback is-authorized='true' ipn='" + vm.userProfile.ipn + "'  irn='IRN-59104' access_token='" + "Bearer " + sessionStorage.getItem("token") + "' base_url= '" + configConstantes.springBackBaseUrl + "' api_secret= '" + LoginConstants.ndApiSecret + "' class='scrollToTopButtonShow' > </renault-ng-feedback>"

                    }

                },1000)

                window.addEventListener('scroll', function() {
                    if (this.scrollY < SCROLL_THRESHOLD){
                        const happiElement = $window.document.getElementById("happi");
                        if (angular.element(document.body).hasClass('md-dialog-is-showing')){
                            if (happiElement) {
                            const showClass = happiElement.getElementsByClassName('scrollToTopButtonShow');
                            angular.element(showClass).addClass('scrollToTopButtonHidden');
                            angular.element(showClass).removeClass('scrollToTopButtonShow');
                            }

                        }else{
                            if (happiElement) {
                                const hiddenClass = happiElement.getElementsByClassName('scrollToTopButtonHidden');
                                angular.element(hiddenClass).addClass('scrollToTopButtonShow');
                                angular.element(hiddenClass).removeClass('scrollToTopButtonHidden');

                            }
                        }
                    }

                    else if (this.scrollY > SCROLL_THRESHOLD ){
                        const selectedElement = $window.document.getElementById("happi");
                            if (selectedElement) {
                            const getClass = selectedElement.getElementsByClassName('scrollToTopButtonShow');
                            angular.element(getClass).addClass('scrollToTopButtonHidden');
                            angular.element(getClass).removeClass('scrollToTopButtonShow');
                            }
                    }
                });
        }
        function getPlaceHolder(){
            if (vm.isIndependentUser){
                if($rootScope.asomDocList.PR && $rootScope.asomDocList.BT && $rootScope.asomDocList.OTS){
                        return $translate.instant('SEARCH_PLACEHOLDER_OTS');
                }
                else if($rootScope.asomDocList.PR && $rootScope.asomDocList.BT){
                    return $translate.instant('SEARCH_PLACEHOLDER');
                }
                else if ($rootScope.asomDocList.OTS){
                    return $translate.instant('HEADER_OTS');
                }
                else if ($rootScope.asomDocList.PR){
                    return $translate.instant('HEADER_PR');
                }
                else if ($rootScope.asomDocList.BT){
                    return $translate.instant('COMMON_BT_NUMBER');
                }
                else{
                    return "";
                }
            }
            else if(vm.isContextCarBrandCheck){
                return $translate.instant('SEARCH_BT_NT_OTS');
            }
            else{
               return $translate.instant('SEARCH_PLACEHOLDER_OTS');
            }
        }

        function displayDealerListPopIn(response){

            $mdDialog.show({
                locals: {
                    dealerList : response.dealers,
                    on_complete: function(response) {
                        saveDealerDetails(response);
                    }
                },
                templateUrl: 'app/main/dealerList.template.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'dealerList',
                bindToController: true,
                controllerAs: 'vm',
            });
            removeInformation();

        }
        function iconAccess(){
          const carContext = CacheService.getCarContext();
          const cirSentVin = carContext ? MainMetierService.isCirSentVin(carContext.vin):null;
          return !!cirSentVin;
          }
          function goToReleases() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.upgradeRelease);
            }
            else{
                oncloseOrderMode(RoutesConstants.releases, {});

            }
        }
          function reCheckAsomSubscriptions() {
            if (!vm.allowASOM){
            blockUI.start();
            MainMetierService.reCheckAsomSubscriptions().then(function (response) {
                if (response&&response.errorCode) { // if error
                    toastr.error('Error BACK : ' + response.errorCode.label, 'Error');
                    blockUI.stop();
                } else { // if success
                    const resp=response;
                    const currentUser = CacheService.getObject(CacheConstants.profil);
                    if(resp&&resp.asomSubscriptions&&resp.asomSubscriptions.documentOfferSubscriptions)
                    {
                         const length=resp.asomSubscriptions.documentOfferSubscriptions.length;
                         if(length<1||length>1)
                         {
                            MainMetierService.AsomDocAccessPopIn(currentUser);

                         }else{

                            vm.isAsomValidDocAccess ='true';

                            currentUser.isAsomValidDocAccess='true';
                            CacheService.setUserProfile(currentUser);
                            if(location.href.includes('carSearchResult')){
                                RecapCarMetierService.reinitContext();
                                $state.go(RoutesConstants.carSearch);
                            }
                         }



                    }

                    blockUI.stop();
                }
            }, function () {
                blockUI.stop();
            });
        
        }
    }
        function saveDealerDetails(dealerDetails){

            const cacheDetails = CacheService.getR2ADealerList();

            if(dealerDetails && cacheDetails){

                MainMetierService.saveDealerDetails(dealerDetails.dealerId, dealerDetails.clientCode).then(function(response){
                    if(cacheDetails.dealers){
                        _.map(cacheDetails.dealers, function(item){
                             if((item.dealerId === response.r1DealerId) && (item.clientCode === response.clientCode)){
                                _.assign(item, {
                                    active: true
                                })
                             }else{
                                _.assign(item, {
                                    active: false
                                })
                             }

                             return item;
                        })
                        if(cacheDetails.dealers.length > 1){
                            vm.multipleDealers = true;
                        }

                        vm.selectedDealer = _.find(cacheDetails.dealers, function(item){
                            return item.active === true;
                        });

                        CacheService.setR2ADealerList(cacheDetails);
                    }

                }).catch(function(error){
                    if(error){
                        toastr.error(error)
                    }
                })
            }

        }

        /**
         * @desc function called in html, on click we redirect to the Virtual Academy website in a new tab if country corresponds
         */
        function goToVirtualAcademy() {
            window.open("https://sales.renault-virtual-academy.dcs2.renault.com/nidp/in");
        }

        
        /**
         * @desc Open links on clicking doc in News menu
         * @param {String} link
         */
        function openMedia(link) {
            onCloseFic(null, false, {isDocRedirect: true, url: link});
        }
        /**
         * @name setBannerVisible
         * @desc Set GDPR banner visibility
         */
        function setGDPRcookiesAndBanner() {
            // get boolean from phenix.profil that was previously saved in the DB
            const profile = CacheService.getUserProfile();
            const dateNow = new Date();
            const dateNowInSeconds = Math.round(dateNow.getTime() / 1000);
            // analyse wether to show banner and keep info
            if (profile.isGdprAccepted && dateNowInSeconds < profile.gdprTimeOutDate) {
                vm.isBannerVisible = false;
            } else {
                vm.isBannerVisible = true;
            }
        }
        function getVisitorCookiesTimeout() {
            const dateNow = new Date();
            const dateNowInSeconds = Math.round(dateNow.getTime() / 1000);
            const cookieTimeout = 33696000; // 13 months in seconds
            const dateOfTimeout = dateNowInSeconds + cookieTimeout;
            return dateOfTimeout;
        }
        /**
         * @name setCurrentQuote
         * @param quote
         * @desc set all controller variables for a new quote
         */

        function setCurrentQuote() {
            const quote = QuoteMetierService.getQuoteData();

            if (!_.isEmpty(quote)) {
                vm.quote = quote;
                // Remove items with quantity 0 before setting to vm.quote.items
                const filteredItems = {
                    PR: _.filter(quote.shoppingCart.PR, function(item) { return item.quantity !== 0; }),
                    TM: _.filter(quote.shoppingCart.TM, function(item) { return item.quantity !== 0; })
                };
                vm.quote.items = filteredItems;

                // quotePopinTitle

                if (vm.user && DealerManagerSystemeService.isWorkshop(vm.user) && vm.quote.orderNumber) {
                    vm.quotePopinSubtitle = [vm.quote.number, '|', $translate.instant('ACTIS_DESCRIPTION_OR'), vm.quote.orderNumber].join(' ');
                } else {
                    vm.quotePopinTitle = vm.quote.number;
                }

                // quotePopinSubtitle

                vm.quotePopinSubtitle = "";

                if (vm.quote.vin) {
                    vm.quotePopinSubtitle += vm.quote.vin;
                }

                if (vm.quote.registrationNumber) {
                    vm.quotePopinSubtitle += " | " + vm.quote.registrationNumber;
                }

                if (vm.quote.accountNumber) {
                    vm.quotePopinSubtitle += " (" + vm.quote.accountNumber + ")";
                }

                const calPrCount= _.filter(vm.quote.shoppingCart.PR, function(item){
                    return item.quantity!=0;
                } ).length;
                const calTmCount= _.filter(vm.quote.shoppingCart.TM, function(item){
                    return item.quantity!=0;
                } ).length;
                vm.quoteItemsNumber = calPrCount + calTmCount;
                vm.quoteButtonDisabled = false;
            } else {
                vm.quoteItemsNumber = 0;
                vm.quoteButtonDisabled = true;
            }

        }

        function updateFodQuoteItemsNumber() {
            const quote = QuoteMetierService.getQuoteData();
            if (_.isEmpty(quote) || !quote.shoppingCart) {
                return;
            }

            const prCount = _.filter(quote.shoppingCart.PR || [], function (item) {
                return item.quantity != 0;
            }).length;
            const tmCount = _.filter(quote.shoppingCart.TM || [], function (item) {
                return item.quantity != 0;
            }).length;
            vm.quoteItemsNumber = prCount + tmCount;
        }


        /**
         * @name setCurrentPartsRequisition
         * @param partsRequisition
         * @desc set all controller variables for a new quote
         */
        function setCurrentPartsRequisition() {

            const partsRequisition = PartRequisitionMetierService.getCurrentPartRequisition();
            if (partsRequisition && partsRequisition.status !== "VALID") {
                vm.partsRequisition = partsRequisition;

                if (vm.partsRequisition && vm.user && vm.partsRequisition.orderNumber && DealerManagerSystemeService.isWorkshop(vm.user)) {
                    vm.partsRequisitionPopinTitle = vm.partsRequisition.number + " | " + $translate.instant('ACTIS_DESCRIPTION_OR') + " " + vm.partsRequisition.orderNumber;
                } else {
                    vm.partsRequisitionPopinTitle = /*$translate.instant('LABEL_NUM_PARTLIST') +*/ vm.partsRequisition.number;
                }
                vm.partsRequisitionPopinSubtitle = "";
                if (vm.partsRequisition.vin) {
                    vm.partsRequisitionPopinSubtitle += vm.partsRequisition.vin;
                }
                if (vm.partsRequisition.registrationNumber) {
                    vm.partsRequisitionPopinSubtitle += " | " + vm.partsRequisition.registrationNumber;
                }
                /* se baser sur le cache du client
                if (DealerManagerSystemeService.isWorkshop(vm.user) &&  carContext && carContext.customer && carContext.customer.name) {
                    vm.partsRequisitionPopinSubtitle += " - " + carContext.customer.name;
                }*/
                if (vm.partsRequisition.accountNumber) {
                    vm.partsRequisitionPopinSubtitle += " (" + vm.partsRequisition.accountNumber + ")";
                }
                if (partsRequisition.items) {
                    vm.partsRequisitionItemsNumber = partsRequisition.items.length;
                }
                else {
                    vm.partsRequisitionItemsNumber = 0;
                }
                vm.partRequisitionButtonDisabled = partsRequisition ? false : true;
            }
            else {
                vm.partRequisitionButtonDisabled = true;
                vm.partsRequisitionItemsNumber = 0;
            }
        }

        function setCurrentBasket(forceFromService){            
            const isRedirectFromDesyre = CacheService.getObject(CacheConstants.isRedirectFromDesyre);
            if (!forceFromService && ($state.params.isAngularRedirect || isRedirectFromDesyre)) {
                const basketData = CacheService.getObject(CacheConstants.basketPopupData)
                if(basketData && basketData.items){
                    const dataList = _.filter(basketData.items, function (list) {
                    return list.quantity !== 0;
                    });
                    vm.cartLength = basketData && basketData.items ? dataList.length : 0;
                    vm.flattenCart = basketData && basketData.items ? dataList : null;
                }                
                vm.cartMetadata.id = basketData && basketData.id;
            }
            else {
                if (isRedirectFromDesyre) {
                    CacheService.removeObject(CacheConstants.isRedirectFromDesyre);
                }
                vm.flattenCart = ShoppingCartService.getShoppingCart();
                vm.flattenCart = _.uniq(vm.flattenCart); /** Added for upgrade migration fix */
                if(!_.isEmpty(vm.flattenCart)){
                    _.remove(vm.flattenCart, { quantity: 0 });
                }
                vm.cartMetadata = ShoppingCartService.getCartMedatadata();
                vm.cartLength = vm.flattenCart.length;
            }
        }



        /**
         * @name getNetworkUserProfil
         * @desc get network profil if user is connected to dms (DMS_WORKSHOP, DMS_PARTSHOP)
         * @desc empty if user is not connected dms
         * @returns {String} - {"", DMS_WORKSHOP, DMS_PARTSHOP} values
         */
        function getNetworkUserProfil() {
            let profilLabel = "";
            if (vm.user && DealerManagerSystemeService.isWorkshop(vm.user)) {
                profilLabel = DmsConstants.workshopProfile;
            }
            else if (vm.user && DealerManagerSystemeService.isPartshop(vm.user)) {
                profilLabel = DmsConstants.partshopProfile;
            }
            return profilLabel;
        }

        function getDMSDealerLabel(){
            let dmsDealerLabel = '';
            dmsDealerLabel = DealerManagerSystemeService.getDMSSiteLabel();
            const labelArray = (dmsDealerLabel !== '')? dmsDealerLabel.split("+"):[];
            let finalValue ='';
            if(labelArray.length > 1){
                labelArray.forEach(function(item){
                    finalValue = finalValue.concat(item);
                })
            }else if(labelArray.length === 1){
                finalValue = labelArray[0];
            }
            return finalValue.replace('%20',' ');
        }

        /**
         * @name goToListQuote
         * @desc redirect user to quote list
         */
        function goToListQuoteDraft() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.quoteListDraft);
            } else{
                oncloseOrderMode(RoutesConstants.quoteListDraft,{});
            }
        }

        /**
         * @name goToListQuoteValidated
         * @desc redirect user to validated quote list
         */

        function goToListQuoteValidated() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.quoteListValidated);
            } else{
                oncloseOrderMode(RoutesConstants.quoteListValidated);
            }
        }

        /**
         * @name goToListPartRequisition
         * @desc redirect user to part requisition list
         */

        function goToListPartsRequisitionsDraft() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.partRequisitionListDraft);
            } else{
                oncloseOrderMode(RoutesConstants.partRequisitionListDraft, {});
            }
        }

        function goToListPartsRequisitionsValidated() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.partRequisitionListValidated);
            } else{
                oncloseOrderMode(RoutesConstants.partRequisitionListValidated,{});
            }
        }

        function goToNewPart() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.partRequisition, { view: 'create',createNew: true });
            } else{
                oncloseOrderMode(RoutesConstants.partRequisition,{ view: 'create',createNew: true })
            }
        }

        function oncloseOrderMode(redirectionPage,displayParam)
        {
            $state.go(RoutesConstants.partRequisition, { view: 'list' });

           callOrderModuleClose().then( function(){
                    resetOrderMode();
                    if (displayParam) {
                        $state.go(redirectionPage, displayParam);
                    } else {
                        $state.go(redirectionPage);
                    }
            });

        }


        function createQuote() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                QuoteMetierService.instanciateNewQuote().then(function () {
                    onCloseFic(RoutesConstants.dmsQuote);
                }).catch(function () {
                    toastr.error($translate.instant('ERROR'));
                })
             }
             else{
                $state.go(RoutesConstants.partRequisition, { view: 'list' });

                callOrderModuleClose().then( function(){
                        resetOrderMode();
                        QuoteMetierService.instanciateNewQuote().then(function () {
                            onCloseFic(RoutesConstants.dmsQuote);
                        }).catch(function () {
                            toastr.error($translate.instant('ERROR'));
                        })
                });

            }

        }

        function createOrGetPartList() {
            const partList = CacheService.getObject(CacheConstants.partList);
            if (partList) {
                $state.go(RoutesConstants.partList);
            }
        }
        function orderModeToSearchCar()
        {
            if (!vm.isProfileView) {
                const contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);
                if (contextVehicle && (!vm.vehicleNotFoundInBVM || !vm.vehicleNotFoundInDMS)) {
                    vm.vehiclePresentInDMSbutNotInBVM = CacheService.getObject(CacheConstants.vehiclePresentInDMSbutNotInBVM);
                    if ($rootScope.currentState === vm.rCst.carSearchResultNoCarContext || vm.vehiclePresentInDMSbutNotInBVM) {
                        onCloseFic(RoutesConstants.carSearchResultNoCarContext);
                    } else {
                        onCloseFic(RoutesConstants.carSearchResult);
                    }

                }
                // test if the vehicle is unknown BVM & DMS and redirect to the the correct arbo
                else if (vm.vehicleNotFoundInBVM && vm.vehicleNotFoundInDMS) {
                    onCloseFic(RoutesConstants.carSearchResultNoCarContext);
                }
                else {
                    onCloseFic(RoutesConstants.carSearch);
                }
            }
        }

        function backToSearchCar() {
            CacheService.removeObject(CacheConstants.systemDocDetails);
            CacheService.removeObject(CacheConstants.searchEngineDetails);
            CacheService.removeObject(CacheConstants.isNavigatedfromDocPriv);
            CacheService.removeObject(CacheConstants.tabIndex);
            CacheService.removeObject(CacheConstants.interventionIdList);
            CacheService.removeObject(CacheConstants.intNodeSelected);
            CacheService.removeObject(CacheConstants.selectedInterventionId);
            CacheService.removeObject(CacheConstants.backButtonEnable);
            CacheService.cleanSieDocumentsHistory();
            if(!CacheService.getObject(CacheConstants.isOrderMode))
        {
            orderModeToSearchCar();
        }
        else{
            $state.go(RoutesConstants.partRequisition, { view: 'list' });

            callOrderModuleClose().then(function(){
                    resetOrderMode()
                    orderModeToSearchCar()
            })
        }
        }
        function resetOrderMode()
        {
            CacheService.setObject(CacheConstants.isOrderMode,false);
            CacheService.removeObject(CacheConstants.orderModePartsList);
        }

        function getPanierInCache() {
            let panier = CacheService.getObject(CacheConstants.panier);
            if (!panier) {
                panier = $rootScope.panierFromCache;
            }
            return panier;
        }

        function disconnect() { 
            if ($rootScope.currentState === vm.rCst.manageFIC) {
                vm.redirectionDisconnect = redirectionDisconnect;
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        disconnect: function () {
                            return vm.redirectionDisconnect;
                        }
                    }
                });
            } else {
                redirectionDisconnect();
            }
        }

        function redirectionDisconnect() { 
            const status = AlertsService.getPopinVisibility().status;
            if (status) {
                $mdDialog.show({
                    templateUrl: 'app/components/alerts/modal/contextCarModal/contextCar.html',
                    controller: 'ContextCarAlert',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        isFromDisconnect: true
                    }
                }).then(function () {
                    CartViewListWSService.unlockCart();
                    PartRequisitionMetierService.unlockPartRequisitionLogic();
                    QuoteMetierService.unlockQuoteLogic();
                    $rootScope.editedEstimate = false;
                    ShoppingCartService.setShoppingCart([]);
                    CloudFrontService.removeAccessCookies();
                    TokenService.delToken();
                    CacheService.clearAll();
                    $state.go(RoutesConstants.connection);
                }).catch(function () {
                    $log.debug($translate.instant('ERROR'));
                });

            } else {
                if (!vm.allowASOM){
                    CartViewListWSService.unlockCart(); 
                    PartRequisitionMetierService.unlockPartRequisitionLogic();
                    QuoteMetierService.unlockQuoteLogic();
                }
                ShoppingCartService.setShoppingCart([]);
                CloudFrontService.removeAccessCookies();
                TokenService.delToken();
                CacheService.clearAll();
                $state.go(RoutesConstants.connection);
                removeInformation();
            }
        }

        function editProfile() {
            const profil = CacheService.getObject(CacheConstants.profil);
            $state.go(RoutesConstants.profil, { profile: profil });
        }

        function goToRenaultTech(doc) {
            if(!CacheService.getObject(CacheConstants.isOrderMode)){
                switch(doc){
                    case 'QSTOMIZE_' :$state.go(RoutesConstants.qstomizeMenu);
                        break;
                    case 'MOBILIZE_' :$state.go(RoutesConstants.mobilizeMenu);
                        break;
                    case 'MICRO_' :$state.go(RoutesConstants.microMobMenu);
                        break;
                    default: $state.go(RoutesConstants.convproductsMenu);
                        break;
                }
                onCloseFic();
            } else {
                oncloseOrderMode(RoutesConstants.qstomize, {docType :doc});
            }
        }

        function goToTraining(bntClicked) {
            if((bntClicked === "mainMenuTraining" && !vm.isVisibleBtnVirtualAcademy) || (bntClicked === "subMenuTraining" && vm.isVisibleBtnVirtualAcademy)){
                if(!CacheService.getObject(CacheConstants.isOrderMode))
                {
                    onCloseFic(RoutesConstants.trainingMenu);
                }
                else{
                    oncloseOrderMode(RoutesConstants.training);
                }

            }
        }

        function goToSdp() {
            if(!CacheService.getObject(CacheConstants.isOrderMode)){
                onCloseFic(RoutesConstants.sdpMenu);
            } else {
                oncloseOrderMode(RoutesConstants.sdp);
            }
        }

        function goToSpecialTools() {
            $state.go(RoutesConstants.specialToolsUpgrade);
        }

        function goToOldRangeDocuments() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.oldRangeMenu);
            }else{
                oncloseOrderMode(RoutesConstants.oldRangeDocuments);
            }
        }

        function myProfile() {
            if (!vm.allowASOM){
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.profile);
            }
            else{
                $state.go(RoutesConstants.partRequisition, { view: 'list' });
                callOrderModuleClose().then( function(){
                    resetOrderMode();
                    
                    onCloseFic(RoutesConstants.profile);
                });
            }
        }
    }

        function goToCurrentState() {
            $state.go($rootScope.currentState);
        }

        function goToBasket() {
            DocPrivMetierService.removePrResponse();
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removeProductResposne();
            DocPrivMetierService.removeInterventionResposne();
            const profil = CacheService.getObject(CacheConstants.profil);
            const panier = CacheService.getObject(CacheConstants.panier);
            if (profil && !profil.dmsConnected) {
                if (!panier) {
                    CacheService.setObject(CacheConstants.panier, []);
                }
                onCloseFic(RoutesConstants.panier);
            }
        }

        function goToListPaniers() {
            onCloseFic(RoutesConstants.consultPanier);
        }

        function goToDocpriv() {
            onCloseFic(RoutesConstants.docprivData);
        }
        function goToBTlist() {
            goToDesyre('btList');
        }
        function goToEasyBasketValidation() {
            onCloseFic(RoutesConstants.ngexpertDoc);
        }
        function goToFactoryRework() {
            onCloseFic(RoutesConstants.ngfactoryRework);
        }

        function goToListFic() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.ficConsultation);
            }else{
            $state.go(RoutesConstants.partRequisition, { view: 'list' });

            callOrderModuleClose().then( function(){
                    resetOrderMode();
                    onCloseFic(RoutesConstants.ficConsultation);
            });
        }
        }

        function goToSupport() {
                $translate.use(vm.user.portal.code);
                if ( !CacheService.getObject(CacheConstants.contextCarRequest)){
                    $mdDialog.show({
                            template:'<div style="max-width:405px;padding:10px;z-index:10002;font-family:var(--renaultFontRegular);"> '+ $translate.instant('SUPPORT_INDEPENDENT_WITHOUT_VIN') +'</div>' +
                            ' <div class="confirmbutton text-center"> '+
                            ' <button class="buttonWithIcon" ng-click="vm.close()"> '+
                            ' <div class="iconDiv"> '+
                            ' <i class="fa fa-check"></i> </div> ' +
                            '<div class="btnText"> '+ $translate.instant('OK_INDEPENDENT') + '</div>' +
                            '</button>' +
                            '</div>',
                            controller: 'supportVinController',
                            bindToController: true,
                            controllerAs: 'vm',
                            clickOutsideToClose: true
                    });
                }
                else {
                    $mdDialog.show({
                        template:'<div style="max-width:405px;padding:10px;z-index:10002;font-family:var(--renaultFontRegular);"> '+ $translate.instant('SUPPORT_INDEPENDENT_REDIRECT_DIAGNOSTIC') +'</div>' +
                        ' <div class="confirmbutton text-center"> '+
                        ' <button class="buttonWithIcon" ng-click="vm.closeAndRedirect()"> '+
                        ' <div class="iconDiv"> '+
                        ' <i class="fa fa-check"></i> </div> ' +
                        '<div class="btnText"> '+ $translate.instant('SUPPORT_INDEPENDENT_REDIRECT_DIAGNOSTIC_BUTTON') + '</div>' +
                        '</button>' +
                        '</div>',
                        controller: 'supportVinController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true
                    });
                }
        }

        function hideChatbot(){
            var div = document.getElementsByClassName("embeddedServiceHelpButton");
                    if (div.length > 0){
                        div[div.length -1].classList.add("hideChatbot");
                    }
        }

        function onCloseFic(redirectionPage, displayParam, redirectUrl) {
            const isActisFromDiag = CacheService.getObject(CacheConstants.isActisFromDiag);
            vm.redirectionPage = redirectionPage;
            if ($rootScope.currentState === vm.rCst.manageFIC && !isActisFromDiag) {

                if (displayParam) {
                    vm.redirectionPage = {'url' : redirectionPage, 'displayParam' : displayParam};
                }


                // Get the fic data
                $scope.getFicData();
                const responseApi = CacheService.getObject(CacheConstants.actisResponse);
                if (responseApi && responseApi.Car && responseApi.Car.mileageUnit) {
                    responseApi.Car.mileageUnit = responseApi.Car.mileageUnit.toUpperCase();
                }

                // Get the difference in response data and fic data
                let dataChanged = CreateActisBusinessService.deepDiffApiResultVsDataActisView(responseApi, vm.fic);
                dataChanged = CreateActisBusinessService.getDataChangedVerification(dataChanged);

                /**
                 * Do not show the pop-in if the FIC has been registered and no information has been changed
                 * or if the FIC is in the 'Sent' status, then the pop-in is not displayed.
                 */
                const currentStatus = $translate.instant(FicViewListWSService.convertStatusToND(vm.fic.CaseDetail.status));
                if (redirectionPage === RoutesConstants.carSearchResult && (currentStatus === $translate.instant('ACTIS_ALL_OTHER_STATUSES') || currentStatus === $translate.instant('ACTIS_CLOSED'))) {
                    if (redirectUrl && redirectUrl.isDocRedirect) {
                        window.open(redirectUrl.url);
                    } else{
                        if (displayParam) {
                            $state.go(redirectionPage, displayParam);
                        }
                        else{
                            $state.go(redirectionPage);
                        }
                    }
                } else if (currentStatus === $translate.instant('ACTIS_ALL_OTHER_STATUSES') || currentStatus === $translate.instant('ACTIS_CLOSED')) {
                    if (redirectUrl && redirectUrl.isDocRedirect) {
                        window.open(redirectUrl.url);
                    } else{
                        if (displayParam) {
                            $state.go(redirectionPage, displayParam);
                        }
                        else{
                            $state.go(redirectionPage);
                        }
                    }
                } else if (currentStatus && _.isEmpty(dataChanged)) {
                    if (redirectUrl && redirectUrl.isDocRedirect) {
                        window.open(redirectUrl.url);
                    } else{
                        if (displayParam) {
                            $state.go(redirectionPage, displayParam);
                        }
                        else{
                            $state.go(redirectionPage);
                        }
                    }
                }
                else {
                    $mdDialog.show({
                        templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                        controller: 'modalOnCloseFicController',
                        bindToController: true,
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            isDocRedirect: redirectUrl ? redirectUrl.isDocRedirect : "",
                        },
                        resolve: {
                            redirectionPage: function () {
                                return vm.redirectionPage;
                            }
                        }
                    }).then(function (confirm) {
                        if (redirectUrl && redirectUrl.isDocRedirect && confirm == 'YES') {
                            window.open(redirectUrl.url);
                        }
                    }).catch(function () {
                        $log.debug($translate.instant('ERROR'));
                    });
                }
            } else {
                CacheService.removeObject(CacheConstants.isActisFromDiag);
                if(vm.userProfile && vm.userProfile.userType && (vm.userProfile.userType.toUpperCase() === "RNET") && !_.isEmpty(vm.userProfile.rolesActis) && vm.userProfile.rolesActis.length > 0){
                    const div = document.getElementsByClassName("embeddedServiceHelpButton");
                    if (div.length > 0 && ((redirectionPage !== RoutesConstants.manageFIC) && (redirectionPage !== RoutesConstants.ficConsultation))){
                        div[div.length -1].classList.add("hideChatbot");
                    }
                    else {
                        if (div.length > 0){
                            div[div.length -1].classList.remove("hideChatbot");
                        }
                    }
                }
                if (displayParam) {
                    hideChatbot();
                    $state.go(redirectionPage, displayParam);
                }
                else if(redirectUrl && redirectUrl.isDocRedirect) {
                    hideChatbot();
                    window.open(redirectUrl.url);
                }
                else {
                    hideChatbot();
                    $state.go(redirectionPage, {}, { reload: true });
                }
            }
        }

        /**
         * Check if user have a specific role
         * @param role {string}
         * @returns {boolean}
         */


        function tooltipVehicleContext() {

            let user = CacheService.getObject(RoutesConstants.profil);
            const isWorkshop = user ? DealerManagerSystemeService.isWorkshop(user):null;

            const contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);
            let toReturn = '';

            if (contextVehicle) {

                if (contextVehicle.vehicle) {
                    const model = contextVehicle.vehicle.model;
                    let colorCode = contextVehicle.vehicle.colorCode;
                    if (!colorCode)
                        colorCode = contextVehicle.vehicle.color;
                    const engineType = contextVehicle.vehicle.engineType;
                    const vin = contextVehicle.vehicle.vin;
                    const motorisation = contextVehicle.vehicle.motorisation;
                    const registrationNumber = contextVehicle.vehicle.registrationNumber;
                    toReturn += '<div class="vehicle ">';
                    if (model)
                        toReturn += model;
                    if (motorisation)
                        toReturn += ", " + motorisation;
                    else
                        toReturn += '</div>';

                    if (vin && registrationNumber)
                        toReturn += '<div style="display: flex; flex-direction: row"><i class="icon-icons_vehicle_tooltip"></i><span class="vehicleInformation"> ' + vin + ' | ' + registrationNumber + '</span></div>';
                    else if (vin)
                        toReturn += '<div style="display: flex; flex-direction: row"><i class="icon-icons_vehicle_tooltip"></i><span class="vehicleInformation"> ' + vin + '</span></div>';
                    else if (registrationNumber)
                        toReturn += '<div style="display: flex; flex-direction: row"><i class="icon-icons_vehicle_tooltip"></i><span class="vehicleInformation"> ' + registrationNumber + '</span></div>';
                }


                if (contextVehicle.customer) {
                    const name = contextVehicle.customer.name;
                    const firstName = contextVehicle.customer.firstName;
                    const dmsCustomerId = contextVehicle.customer.dmsCustomerId;

                    if (firstName || name)
                        toReturn += '<div class="customer"><i class="icon-icons_people_tooltip"></i> ';
                    if (firstName)
                        toReturn += '<span class="customer-margin">' + UtilsMetierService.toTitleCase(firstName) + ' ';
                    if (name)
                        toReturn += UtilsMetierService.toTitleCase(name);

                    if (dmsCustomerId)
                        toReturn += '(' + dmsCustomerId + ')</span></div>';
                    else
                        toReturn += '</span></div>';
                }

                // if order.v1 or vehicle.v1 request return only 1 ordernumber and we are worshop, we must display it
                const displayOrderNumber = _.get(contextVehicle, ['ordersAndSplits', 'openOrderFlag']) == CodesConstants.ONE_ORDER_TYPE && isWorkshop;

                if (displayOrderNumber) {
                    toReturn += '<div class="customer"><i class="icon-icons_repair_tooltip"></i><span class="customer-margin"> ' + contextVehicle.ordersAndSplits.orderNumber + '</span></div>';
                }


            }
            else {
                toReturn += '<div class="tooltipTextNoVehicle capitalize">' + vm.TRAD.noVehicleContext + '</div>';
            }
            toReturn = showTooltip(toReturn);
            toReturn = showTooltip(toReturn);

            return toReturn;
        }


        /**
         * @name canCreatePartRequisitionOrQuote
         * @desc check if user can create part requisition
         * only user connected to dms, having workshop profile and context vehicle or user having partshop profile can create part requisition
         * @return {Boolean}
         */
        function canCreatePartRequisitionOrQuote() {
            const contextVehicle = CacheService.getObject(CacheConstants.contextCarSearch);
            const user = CacheService.getObject(CacheConstants.profil);
            return (user && (DealerManagerSystemeService.isWorkshop(user) && contextVehicle) || DealerManagerSystemeService.isPartshop(user));
        }

        function tooltipWhenPartList() {
            const user = CacheService.getObject(RoutesConstants.profil);
            const isPartShop = UtilsMetierService.isPartShop(user);
            const partList = CacheService.getObject(CacheConstants.partList);

            if (partList) {
                if (partList.status === 2) {
                    return vm.TRAD.tooltipTextNoPartList;
                }
                let toReturn = '';
                let statePartList = '';

                toReturn += '<div class="objectNumber capitalize"> ' + vm.TRAD.tooltipPartListNumber + partList.id + '</div>';

                if ($rootScope.editedPartList) {
                    statePartList = vm.TRAD.tooltipObjectNotSaved;
                    toReturn += '<div class="unsaved capitalize">' + statePartList + '</div>';
                }
                else {
                    statePartList = vm.TRAD.tooltipObjectSave;
                    toReturn += '<div class="save capitalize">' + statePartList + '</div>';
                }

                if (isPartShop) {
                    toReturn += getCustomerToolTip(partList);
                    toReturn += partList.customer ? '(' + partList.customer.dmsCustomerId + ')' : "";
                    return toReturn;
                }
                else {
                    if (partList.vehicles && partList.vehicles[0]) {
                        toReturn += '<div class="vehicle">' + partList.vehicles[0].vehicle.vin + ' | ' + partList.vehicles[0].vehicle.registrationNumber + '</div>';
                        toReturn += getCustomerToolTip(partList);
                    }
                    if (partList && partList.vehicles.length > 0) {
                        if (partList.vehicles[0].orderNumber) {
                            toReturn += '<span> (' + partList.vehicles[0].orderNumber + ')</span></div>';
                        } else if (partList.orderNumber) {
                            toReturn += '<span> (' + partList.orderNumber + ')</span></div>';
                        }

                    } else {
                        toReturn += '</span></div>';
                    }

                    return toReturn;
                }
            }
        }

        /**
         * @desc function called in html, on click we redirect to a website in a new tab
         */
        function goToGarageEquipment() {
            onCloseFic(null, false, {isDocRedirect: true, url: garageEquipmentLink});
        }
        function goToPublicationLink(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.publications});
        }
        function goToElectronicRepair(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.electronicRepairLink});
        }
        function goToServiceWeather(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.serviceWeatherLink});
        }
        function goToNissanServiceWeather(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.nissanServiceWeatherLink});
        }
        function goToBoschLink(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.boschLink});
        }
        function goToSpaceNomadeDealersLink(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.spaceNomadeDealersLink});
        }
        function goToConnectServicesLink(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.connectServicesLink});
        }
        function goToAccessoriesWebsiteLink(){
            onCloseFic(null, false , {isDocRedirect: true, url: vm.accessoriesWebsiteLink})
        }
        function goToDabSiteLink(){
            onCloseFic(null, false, {isDocRedirect: true, url: vm.dabSiteLink});
        }
        
        function goToeGuide() {
            onCloseFic(null, false, {isDocRedirect: true, url: vm.eGuide});
        }

        function goToUserBox() {
            onCloseFic(null, false, {isDocRedirect: true, url: userBox});
        }
        function reuseParts(){
            onCloseFic(null, false, {isDocRedirect: true, url: reuseLinks});
        }
        function goToAidInstallation(){
            let url = '';
            url = vm.ndDocumentsUrl + vm.aidInstallation + '.pdf';
            window.open(url,'_blank');
        }

        function tooltipWhenBasket() {
            const basket = CacheService.getObject(CacheConstants.panier);
            if (basket) {

                let toReturn = '';
                let stateBasket = '';
                if (basket) {
                    if (basket.id) {
                        toReturn += '<div class="objectNumber capitalize">' + vm.TRAD.tooltipBasketNumber + basket.id + '</div>';
                    }

                    if ($rootScope.editedBasket) {
                        stateBasket = vm.TRAD.tooltipObjectNotSaved;
                        toReturn += '<div class="unsaved capitalize">' + stateBasket + '</div>';
                    }
                    else {
                        stateBasket = vm.TRAD.tooltipObjectSave;
                        toReturn += '<div class="save capitalize">' + stateBasket + '</div>';
                    }

                    if (basket.creator) {
                        if (basket.labelBasket) {
                            toReturn += '<span class="objectNumber capitalize">' + basket.labelBasket + '</span></div>';
                        }
                    }
                    return toReturn;
                }
            }
        }

        function translate() {
            const toTrad = [
                $translate('TOOLTIP_OBJECT_SAVED'),
                $translate('TOOLTIP_OBJECT_NOTSAVED'),
                $translate('TOOLTIP_ESTIMATE_NO_ACTIVE'),
                $translate('TOOLTIP_PARTLIST_NO_ACTIVE'),
                $translate('TOOLTIP_ESTIMATE_NUMBER'),
                $translate('TOOLTIP_PARTLIST_NUMBER'),
                $translate('TOOLTIP_BASKET_NUMBER'),
                $translate('TOOLTIP_NO_VEHICLE_CONTEXT')
            ];
            $q.all(toTrad).then(function (trads) {
                vm.TRAD.tooltipObjectSave = trads[0];
                vm.TRAD.tooltipObjectNotSaved = trads[1];
                vm.TRAD.tooltipTextNoEstimate = "<div class='tooltipTextNoObject capitalize'>" + trads[2] + "</div>";
                vm.TRAD.tooltipTextNoPartList = "<div class='tooltipTextNoObject capitalize'>" + trads[3] + "</div>";
                vm.TRAD.tooltipEstimateNumber = trads[4];
                vm.TRAD.tooltipPartListNumber = trads[5];
                vm.TRAD.tooltipBasketNumber = trads[6];
                vm.TRAD.noVehicleContext = trads[7];
            });
        }

        function goToPartsRequisition() {
            DocPrivMetierService.removePrResponse();
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removeProductResposne();
            DocPrivMetierService.removeInterventionResposne();
            const bsInformations = CacheService.getObject(PartRequisitionConstants.bs);
            vm.isBsExist = (bsInformations && bsInformations.id) ? true : false;

            if (vm.isBsExist) {
                onCloseFic(RoutesConstants.partRequisition, { view: 'list' });
            }
        }

        function goToQuote() {
            DocPrivMetierService.removePrResponse();
            DocPrivMetierService.removeBorneo3Resposne();
            DocPrivMetierService.removeRepairManuals();
            DocPrivMetierService.removeLabourTimes();
            DocPrivMetierService.removeProductResposne();
            DocPrivMetierService.removeInterventionResposne();
            const quoteData = QuoteMetierService.getQuoteData();
            if (!_.isEmpty(quoteData)) {
                onCloseFic(RoutesConstants.dmsQuote);
            }
        }

        //parse bt elements and format date them
        //if date length is equal to 8
        //return bt list after format date
        function formatBt(btList){
            const formattedBt = [];
            //parse BT documents and format date
            angular.forEach(btList, function (btElement) {
                if (btElement.updateDate.length === 8 ) {
                    btElement.updateDate = formatDate(btElement.updateDate);
                }

                if(btElement.details && btElement.details.symptomList){
                    btElement.details.symptomList = btElement.details.symptomList.map(function (symptom) {
                        return symptom.shortCode + ' - ' + symptom.label;
                    });
                }
                formattedBt.push(btElement);
            });

            return formattedBt;
        }

        //format date by passing an integer sequence
        //example (input: 20171130 => output: 2017/11/30)
        function formatDate(date) {
            const year = date.substr(0, 4);
            const month = date.substr(4, 2);
            const day = date.substr(6, 2);

            const formattedDate = year + ("/").concat(month) + ("/").concat(day);

            return formattedDate;
        }

        function resetReferenceSearch() {
            vm.inputReference = "";
        }

        function redirectSearchBTByNumber(ref, tabName) {
            blockUI.start();
            DocumentsMetierService.returnBTByRef(ref).then(function (responseBT) {
                vm.atLeastTwoBTDocument = false;
                vm.listOfBTDocuments = [];
                if(responseBT && !_.isEmpty(responseBT.BT) && vm.isIndependentUser){
                    responseBT.BT = filterBTForIndependentUser(responseBT.BT);
                }
                if (responseBT == null && responseBT.BT == null && responseBT.BT.length < 1) {
                    redirectSearchNTByNumber(ref);
                } 
                else if(responseBT && !_.isEmpty(responseBT) && responseBT.BT.length > 1){
                    vm.atLeastTwoBTDocument = true;
                    vm.listOfBTDocuments = formatBt(responseBT.BT);

                    const element = document.getElementById("btDialog")
                    $compile(element)($scope);
                    $mdDialog.show({
                        contentElement: '#btDialog',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true
                    }).then(function(){
                        vm.inputReference = "";
                    })
                }
                else {
                    const btNamesAndLabels = [];
                    angular.forEach(responseBT.BT, function (item) {
                        const itemObject = {};
                        itemObject['type'] = 'BT';
                        itemObject['id'] = item.name;
                        itemObject['number'] = item.paramURL;
                        itemObject['label'] = item.designation;
                        itemObject['pdfContent'] = item.pdfContent;

                        btNamesAndLabels.push(itemObject);
                    });

                    redirectSearchNTByNumber(ref, btNamesAndLabels, responseBT, tabName);
                }
            })
                .catch(function () {
                    toastr.error($translate.instant('DOCUMENT_NO_BT_FOUND'));
                }) .finally(function () {
                    blockUI.stop();
                });
        }

        function redirectSearchNTByNumber(ref, btNamesAndLabels, responseBT, tabName) {
            DocumentsMetierService.returnNTByRef(ref).then(function (response) {
                if (response && response.NT && response.NT.length > 0) {
                    if (btNamesAndLabels != null && btNamesAndLabels.length > 0) {
                        angular.forEach(response.NT, function (item) {
                            const itemObject = {};
                            itemObject['type'] = 'NT';
                            itemObject['id'] = item.NTNumber;
                            itemObject['number'] = 'NT-' + item.NTNumber;
                            itemObject['label'] = item.designation;
                            itemObject['contentUrl'] = item.contentUrl;

                            btNamesAndLabels.push(itemObject);
                        });

                        vm.btNamesAndLabels = btNamesAndLabels;

                        const shouldSearchOTS = (ref.toString().length === 4) && 
                            (!vm.isIndependentUser || (vm.isIndependentUser && $rootScope.asomDocList.OTS));
                        
                        if(shouldSearchOTS){
                            redirectSearchOTSByNumber(ref, vm.btNamesAndLabels,responseBT);
                        }else{

                            $mdDialog.show({
                                templateUrl: 'app/components/products/documents/btNt/btNtDocuments.template.html',
                                controller: 'btNtDocumentsController',
                                clickOutsideToClose: true,
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    btNamesAndLabels: vm.btNamesAndLabels
                                }
                            });
                        }

                    } else {
                        const shouldSearchOTS = (ref.toString().length === 4) && 
                            (!vm.isIndependentUser || (vm.isIndependentUser && $rootScope.asomDocList.OTS));
                        
                        if(shouldSearchOTS){
                            angular.forEach(response.NT, function (item) {
                                const itemObject = {};
                                itemObject['type'] = 'NT';
                                itemObject['id'] = item.NTNumber;
                                itemObject['number'] = 'NT-' + item.NTNumber;
                                itemObject['label'] = item.designation;
                                itemObject['contentUrl'] = item.contentUrl;

                                btNamesAndLabels.push(itemObject);
                            });
                            redirectSearchOTSByNumber(ref, btNamesAndLabels,responseBT);
                        }else if (response.NT[0].NTNumber && response.NT[0].contentUrl) {
                            resetReferenceSearch();
                            DocumentsMetierService.displayNtDetails(response.NT[0].NTNumber, response.NT[0].contentUrl);
                        }
                        else if(ref>=NT_REFERENCE_RANGE_START&&ref<=NT_REFERENCE_RANGE_END)
                        {
                            searchBTByNumber(ref-10000);
                        }else if(ref.length === REFERENCE_LENGTH_WITH_SUFFIX && !(ref>=NT_REFERENCE_RANGE_START&&ref<=NT_REFERENCE_RANGE_END))
                        {
                            searchBTByNumber(_.isNumber(ref) ? ref.toString().substring(0,4) : ref.substring(0,4));
                        }
                         else {
                            removeCacheVariables();
                            toastr.error($translate.instant('DOCUMENT_NO_BT_NT_FOUND'));
                        }
                    }
                } else if(ref.toString().length === 4 && (!vm.isIndependentUser || (vm.isIndependentUser && $rootScope.asomDocList.OTS))){
                    redirectSearchOTSByNumber(ref, btNamesAndLabels,responseBT);
                } else if (responseBT.BT && responseBT.BT.length > 0) {
                    if(vm.isIndependentUser && responseBT.BT[0] &&externalNoColorCodes.includes(responseBT.BT[0].colorCode)){
                        removeCacheVariables();
                        toastr.error($translate.instant('DOCUMENT_NO_BT_NT_FOUND')); 
                    } else {
                        resetReferenceSearch();
                        let dtcDataNT = "";
                        if(responseBT.BT[0].details && responseBT.BT[0].details.DTCList){
                            responseBT.BT[0].details.DTCList =  _.uniq(responseBT.BT[0].details.DTCList.sort())
                            const data = responseBT.BT[0].details.DTCList.toString();
                            dtcDataNT = data.split(",").join(", ");
                        }
                        const BtnumbersAndSymptomsDetails = {
                        lupNumber  : responseBT.BT[0].LUPNumber,
                        nitgNumber : responseBT.BT[0].NITGNumber,
                        dtcCode: dtcDataNT,
                        creationDate: responseBT.BT[0].creationDate,
                        updateDate: responseBT.BT[0].updateDate,
                        colorCode : responseBT.BT[0].colorCode === "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : responseBT.BT[0].colorCode
                        };
                        if(responseBT.BT[0].details){
                            _.extend(BtnumbersAndSymptomsDetails,{
                                symptoms : _.sortBy( responseBT.BT[0].details.symptomList, ['shortCode'])
                            })
                        }
                        DocumentsMetierService.displayBtDetails(responseBT.BT[0].paramURL, responseBT.BT[0].pdfContent,BtnumbersAndSymptomsDetails,tabName);
                    }
                }
                else if(ref>=BT_REFERENCE_OFFSET&&ref<=NT_REFERENCE_RANGE_END)
                {
                    searchBTByNumber(ref-(BT_REFERENCE_OFFSET-1));
                }else if(ref.length === REFERENCE_LENGTH_WITH_SUFFIX && !(ref>=BT_REFERENCE_OFFSET&&ref<=NT_REFERENCE_RANGE_END))
                {
                    searchBTByNumber(_.isNumber(ref) ? ref.toString().substring(0,4) : ref.substring(0,4));
                }
                 else {
                    removeCacheVariables();
                    toastr.error($translate.instant('DOCUMENT_NO_BT_NT_FOUND'));
                }
            })
                .catch(function () {
                    toastr.error($translate.instant('DOCUMENT_NO_NT_FOUND'));
                })
        }


        function redirectSearchOTSByNumber(ref, btNamesAndLabels,responseBT){

            blockUI.start();
           const technicalBlltnPayLoad = {
                userContext: CacheService.getUserContext(),
                advancedFilters: {
                                    "dateRange": {
                                                    "from": "19000101",
                                                    "to": "21001231"
                                                  },
                                    "otsNumber": ref
                                }
            };

            btListMetierService.getAdvancedBtList(technicalBlltnPayLoad).then(function (response) {

                if (response && response.length > 0) {
                    if (btNamesAndLabels != null && btNamesAndLabels.length > 0) {
                        angular.forEach(response.BT, function (item) {
                            const itemObject = {};
                            itemObject['type'] = 'OTS';
                            itemObject['id'] = item.name;
                            itemObject['number'] = item.paramURL;
                            itemObject['label'] = item.designation;
                            itemObject['pdfContent'] = item.pdfContent;

                            btNamesAndLabels.push(itemObject);
                        });

                        vm.btNamesAndLabels = btNamesAndLabels;
                        $mdDialog.show({
                            templateUrl: 'app/components/products/documents/btNt/btNtDocuments.template.html',
                            controller: 'btNtDocumentsController',
                            clickOutsideToClose: true,
                            controllerAs: 'vm',
                            bindToController: true,
                            locals: {
                                btNamesAndLabels: vm.btNamesAndLabels
                            }
                        });
                    }else{
                        resetReferenceSearch();
                        let dtcData = "";
                        if(!_.isEmpty(responseBT.BT) && responseBT.BT[0].details && responseBT.BT[0].details.DTCList){
                            responseBT.BT[0].details.DTCList =  _.uniq(responseBT.BT[0].details.DTCList.sort())
                            const data = responseBT.BT[0].details.DTCList.toString();
                            dtcData = data.split(",").join(", ");
                        }
                        const BtnumbersAndSymptomsDetails = {
                            lupNumber  : response[0].LUPNumber,
                            nitgNumber : response[0].NITGNumber,
                            dtcCode: dtcData,
                            creationDate: response[0].creationDate,
                            updateDate: response[0].updateDate,
                            colorCode: response[0].colorCode == "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : response[0].colorCode
                            };
                            if(response[0].details){
                                _.extend(BtnumbersAndSymptomsDetails,{
                                    symptoms : _.sortBy( response[0].details.symptomList, ['shortCode'])
                                })
                            }
                        DocumentsMetierService.displayBtDetails(response[0].paramURL, response[0].pdfContent,BtnumbersAndSymptomsDetails);
                    }
                }else{

                    if (btNamesAndLabels != null && btNamesAndLabels.length > 0) {

                        const btDocs = _.filter(btNamesAndLabels, {'type': 'BT'});
                        const ntDocs = _.filter(btNamesAndLabels, {'type': 'NT'});

                        if(btDocs.length > 0 && ntDocs.length > 0){
                            $mdDialog.show({
                                templateUrl: 'app/components/products/documents/btNt/btNtDocuments.template.html',
                                controller: 'btNtDocumentsController',
                                clickOutsideToClose: true,
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    btNamesAndLabels: vm.btNamesAndLabels
                                }
                            });
                        }else if(btDocs.length > 0){
                            resetReferenceSearch();
                            let dtcDataBtDocs = "";
                        if(!_.isEmpty(responseBT.BT) && responseBT.BT[0].details && responseBT.BT[0].details.DTCList){
                            responseBT.BT[0].details.DTCList =  _.uniq(responseBT.BT[0].details.DTCList.sort())
                            const data = responseBT.BT[0].details.DTCList.toString();
                            dtcDataBtDocs = data.split(",").join(", ");
                        }
                            const BtnumbersAndSymptomsDetails = {
                                lupNumber  : responseBT.BT[0].LUPNumber,
                                nitgNumber : responseBT.BT[0].NITGNumber,
                                dtcCode: dtcDataBtDocs,
                                creationDate: responseBT.BT[0].creationDate,
                                updateDate: responseBT.BT[0].updateDate,
                                colorCode: responseBT.BT[0].colorCode === "BLUE_WITH_FOLLOW_UP" ? 'lightblue' : responseBT.BT[0].colorCode
                                };
                                if(responseBT.BT[0].details){
                                    _.extend(BtnumbersAndSymptomsDetails,{
                                        symptoms : _.sortBy( responseBT.BT[0].details.symptomList, ['shortCode'])
                                    })
                                }
                            DocumentsMetierService.displayBtDetails(responseBT.BT[0].paramURL, responseBT.BT[0].pdfContent,BtnumbersAndSymptomsDetails);

                        }else if(ntDocs.length > 0){
                            resetReferenceSearch();
                            DocumentsMetierService.displayNtDetails(ntDocs[0].number, ntDocs[0].contentUrl);
                        }else{
                            removeCacheVariables();
                            toastr.error($translate.instant('DOCUMENT_NO_BT_NT_FOUND'));
                        }

                    }else{
                        removeCacheVariables();
                        toastr.error($translate.instant('DOCUMENT_NO_BT_NT_FOUND'));
                    }
                }

            }).catch(function () {
                toastr.error($translate.instant('DOCUMENT_NO_NT_FOUND'));
            }).finally(function () {
                blockUI.stop();
            });

        }
        function filterBTForIndependentUser(btList) {
            const hasBT = $rootScope.asomDocList.BT;
            const hasOTS = $rootScope.asomDocList.OTS;
            
            let filteredBT = _.filter(btList, function(item){
                return !externalNoColorCodes.includes(item.colorCode)
            });
            
            if (hasBT && !hasOTS) {
                filteredBT = _.filter(filteredBT, function(item){
                    return !item.ots || item.ots === "";
                });
            }
            
            return filteredBT;
        }
        
        function removeCacheVariables(){
            CacheService.removeObject(CacheConstants.prSearchText);
            CacheService.removeObject(PartRequisitionConstants.bs);
            CacheService.removeObject(CacheConstants.dmsQuote);
            CacheService.removeObject(CacheConstants.basketPopupData);
            CacheService.removeObject(CacheConstants.contextCarSearch);
            CacheService.removeObject(CacheConstants.listOfPiece);
            vm.inputReference = '';
            vm.cartMetadata = {};
            vm.cartLength = 0;
            vm.partRequisitionButtonDisabled = true;
            vm.quoteButtonDisabled = true;
            vm.quoteItemsNumber = 0;
            vm.partsRequisitionItemsNumber = 0;
            $rootScope.panierData = '';
        }

        function goToCarSearchPage() {
            vm.isAdmin = false;
            $state.go(RoutesConstants.carSearch, { nav: 'carS' });
        }

        function isBrandApplicable(){
                return MainMetierService.isBrandApplicable();
        }

        function goToFavouritesProd() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.favouritesPR, { nav: 'FAVS' });
            }else{
            $state.go(RoutesConstants.partRequisition, { view: 'list' });


            callOrderModuleClose().then( function(){
                    resetOrderMode();
                    onCloseFic(RoutesConstants.favouritesPR, { nav: 'FAVS' });
            });
        }
        }

        function goToFavouritesTM() {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
                onCloseFic(RoutesConstants.favourites, { nav: 'TM' });
            }else{
            $state.go(RoutesConstants.partRequisition, { view: 'list' });


            callOrderModuleClose().then( function(){
                    resetOrderMode();
                    onCloseFic(RoutesConstants.favourites, { nav: 'TM' });
            });

        }

        }

        function getCustomerToolTip(object) {
            if (!object.customer || !object.customer.dmsCustomerId) {
                return "";
            }
            const firstName = object.customer.firstName ? object.customer.firstName : "";
            const lastName = object.customer.name ? object.customer.name : "";
            return '<span class="customerToolTip"><span class="capitalize">' + firstName + '</span><span class="capitalize"> ' + lastName + '</span>';
        }

        function getUIMainClass() {
            let cssClass = vm.isAdmin ? 'little' : '';
            cssClass += ($state.current.name === RoutesConstants.carSearch) ? (vm.nissanUserURL ? 'maxHeight mainBgPadding nissanCarSearchPageClass' :  'maxHeight mainBgPadding newCarSearchMainBg') :  '';
            return cssClass;
        }

        function removeSpaces(event){
            $timeout(function () {
                const ref = event.target.value;
                vm.inputReference = ref.split(" ").join("");
            }, 10);
        }

        function searchRefBTNT(ref, tabName) {
           
            if(ref)
                CacheService.setObject(CacheConstants.prSearchText,ref);
            if ($state.params.isAngularRedirect) {
                ref = CacheService.getObject(CacheConstants.prSearchText);
                CacheService.removeObject(CacheConstants.prSearchText);
            }
            if (ref) {
                let isRefOrBT = -1;
                const carContext = CacheService.getCarContext();
                vm.contextCarBrandCritCheck = MainMetierService.rnetUserBrandCheck();
                if (vm.isIndependentUser) {
                    const hasPR = $rootScope.asomDocList.PR;
                    const hasBT = $rootScope.asomDocList.BT;
                    const hasOTS = $rootScope.asomDocList.OTS;
                    
                    if (ref && ref.length === 10 && hasPR) {
                        isRefOrBT = 0;
                    } else if (ref && (ref.length === 3 || ref.length === 4 || ref.length === 5) && (hasBT || hasOTS)) {
                        isRefOrBT = 1; 
                    } else {
                        toastr.error($translate.instant('INVALID_SEARCH'));
                        return;
                    }
                } else {
                    if ((!carContext && ref && ref.length === 10) || (carContext && vm.user && ((vm.user.userType === "ARCA") || (!vm.contextCarBrandCritCheck)) && ref && ref.length === 10)) {
                        isRefOrBT = 0;
                    }
                    else if (ref && (ref.length === 3 || ref.length === 4 || ref.length === 5)) {
                        isRefOrBT = 1;
                    } else {
                        toastr.error($translate.instant('INVALID_SEARCH'));
                        return;
                    }
                }

                if (!CacheService.getObject(CacheConstants.isOrderMode)) {
                    if ($rootScope.currentState === vm.rCst.manageFIC) {
                        vm.redirectSearchReference = redirectSearchReference;
                        vm.redirectSearchReference.ref = ref;
                        vm.redirectSearchBTByNumber = redirectSearchBTByNumber;
                        vm.redirectSearchBTByNumber.ref = ref;
                        $mdDialog.show({
                            parent: angular.element(document.body),
                            templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                            controller: 'modalOnCloseFicController',
                            bindToController: true,
                            controllerAs: 'vm',
                            clickOutsideToClose: true,
                            resolve: {
                                searchRefBTNT: function () {
                                    if (isRefOrBT === 0) {
                                        return vm.redirectSearchReference;
                                    } else if (isRefOrBT === 1) {
                                        return vm.redirectSearchBTByNumber;
                                    }

                                }
                            }
                        });
                    } else {

                        if (isRefOrBT === 0) {
                            redirectSearchReference(ref);
                        } else if (isRefOrBT === 1) {
                            redirectSearchBTByNumber(ref, tabName);
                        } else {
                            toastr.error($translate.instant('INVALID_SEARCH'));
                            return;
                        }

                    }
                    CacheService.removeObject(CacheConstants.prSearchText);
                    vm.inputReference = '';
                }
                else {
                    $state.go(RoutesConstants.partRequisition, { view: 'list' });
                    callOrderModuleClose().then(function () {
                        resetOrderMode();
                        if (isRefOrBT === 0) {
                            redirectSearchReference(ref);
                        } else if (isRefOrBT === 1) {
                            redirectSearchBTByNumber(ref);
                        } else {
                            toastr.error($translate.instant('INVALID_SEARCH'));
                            return;
                        }
                    });

                }                
            }
        }

        /**
         *
         * @param ref
         */
        function searchReference(ref) {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
            {
            if ($rootScope.currentState === vm.rCst.manageFIC) {
                vm.redirectSearchReference = redirectSearchReference;
                vm.redirectSearchReference.ref = ref;
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        searchReference: function () {
                            return vm.redirectSearchReference;
                        }
                    }
                });
            } else {
                redirectSearchReference(ref);
            }
        }
        else{
            $state.go(RoutesConstants.partRequisition, { view: 'list' });
            callOrderModuleClose().then( function(){
                    resetOrderMode();
                    redirectSearchReference(ref);
            });

        }
        }

        function searchBTByNumber(ref) {
            if(!CacheService.getObject(CacheConstants.isOrderMode))
              {
                redirectSearchBTByNumber(ref);
            }
            else{
                $state.go(RoutesConstants.partRequisition, { view: 'list' });
                callOrderModuleClose().then( function(){
                        resetOrderMode();
                        redirectSearchBTByNumber(ref);
                });
            }
        }

        function searchNTByNumber(ref) {
            if ($rootScope.currentState === vm.rCst.createFIC) {
                vm.redirectSearchNTByNumber = redirectSearchNTByNumber;
                vm.redirectSearchNTByNumber.ref = ref;
                $mdDialog.show({
                    templateUrl: 'app/components/actis/components/modalOnCloseFic.template.html',
                    controller: 'modalOnCloseFicController',
                    bindToController: true,
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    resolve: {
                        searchNTByNumber: function () {
                            return vm.redirectSearchNTByNumber;
                        }
                    }
                });
            } else {
                redirectSearchNTByNumber(ref);
            }
        }

        function redirectSearchReference(ref) {
            if (ref) {
                blockUI.start();
                ProductMetierService
                    .getReferenceInformation(ref, ref)
                    .then(function (response) {
                        resetReferenceSearch();
                        RoutingService.goToProductPage({
                            path: {
                                reference: response.originalPartReference,
                                mainReference: response.supersessionRootReference,
                                refIndex: null,
                                plateIndex: null
                            },
                            data: response
                        });
                    }).catch(function (err) {
                        if (err === _errors.UNKNOW_REFERENCE) {
                            toastr.error($translate.instant('COMMON_ERROR_UNKNOWN_REFERENCE'));
                        } else {
                            toastr.error($translate.instant('ERROR'));
                        }
                    }).finally(function () {
                        blockUI.stop();
                    });
            }
        }


        function showTooltip(toReturn) {

            if (document.getElementById("blockResumeVehicle")) {
                toReturn = null;
            }
            return toReturn;
        }


        function isRouteActive(routeValue) {
            return $rootScope.currentState === routeValue || 
                   $rootScope.currentState.indexOf(routeValue) !== -1;
        }

        function getIconVehicleClass() {
            let isActiveRoute = false;
            
            if (vm.rCst && $rootScope.currentState) {
                for (const key in vm.rCst) {
                    if (vm.rCst.hasOwnProperty(key)) {
                        const routeValue = vm.rCst[key];
                        if (isRouteActive(routeValue)) {
                            isActiveRoute = true;
                            break;
                        }
                    }
                }
            }
            if(vm.newHeaderMenu){
                return 'activeLink';
            }
            
            if (isActiveRoute && $rootScope.currentState && $rootScope.currentState !== 'phenix.carSearch') {
                return 'activeLink';
            }
            else if (vm.isProfileView) {
                return 'noHover';
            }
            
            return '';
        }

        function setDocumentsUrl() { 

            vm.ndCookiesUrlisActive = false;
            vm.ndDataPolicyUrlisActive = false;
            vm.ndCguFileUrlisActive = false;
            MainMetierService.getDocunmentsInformations().then(function successCallback(response) {
                if (vm.user && vm.user.documentationFirstLanguage.active) {
                    const lang = vm.user.documentationFirstLanguage.code;
                    if (response.data[vm.cookiesFileName][lang] && response.data[vm.cookiesFileName][lang].exist) {
                        vm.ndCookiesUrl = vm.ndDocumentsUrl + '/' + vm.cookiesFileName + '_' + lang + '_' + vm.ndFooterFileDate + '.html';
                        vm.ndCookiesUrlisActive = true;
                    }
                    if (response.data[vm.dataPolicyFileName][lang] && response.data[vm.dataPolicyFileName][lang].exist) {
                        vm.ndDataPolicyUrl = vm.ndDocumentsUrl + '/' + vm.dataPolicyFileName + '_' + lang + '_' + vm.ndFooterFileDate + '.html';
                        vm.ndDataPolicyUrlisActive = true;
                    }
                    if (response.data[vm.cguFileName][lang] && response.data[vm.cguFileName][lang].exist) {
                        vm.ndCguFileUrl = vm.ndDocumentsUrl + '/' + vm.cguFileName + '_' + vm.ndFooterFileDate + '.html';
                        vm.ndCguFileUrlisActive = true;
                    }
                }
                if (vm.user && vm.user.documentationSecondLanguage.active) {
                    setDocumentsUrlByLanguage(vm.user.documentationSecondLanguage.code, response);
                }
                setDocumentsUrlByLanguage('fr', response);
            });
        }

        function setDocumentsUrlByLanguage(lang, res) {
            if (!vm.ndCookiesUrlisActive && !_.isEmpty(res) && !_.isEmpty(res.data) &&res.data[vm.cookiesFileName][lang] && res.data[vm.cookiesFileName][lang].exist) {
                vm.ndCookiesUrl = vm.ndDocumentsUrl + '/' + vm.cookiesFileName + '_' + lang + '_' + vm.ndFooterFileDate + '.html';
                vm.ndCookiesUrlisActive = true;
            }
            if (!vm.ndDataPolicyUrlisActive && !_.isEmpty(res) && !_.isEmpty(res.data) && res.data[vm.dataPolicyFileName][lang] && res.data[vm.dataPolicyFileName][lang].exist) {
                vm.ndDataPolicyUrl = vm.ndDocumentsUrl + '/' + vm.dataPolicyFileName + '_' + lang + '_' + vm.ndFooterFileDate + '.html';
                vm.ndDataPolicyUrlisActive = true;
            }
            if (!vm.ndCguFileUrlisActive && !_.isEmpty(res) && !_.isEmpty(res.data) && res.data[vm.cguFileName][lang] && res.data[vm.cguFileName][lang].exist) {
                vm.ndCguFileUrl = vm.ndDocumentsUrl + '/' + vm.cguFileName + '_' + vm.ndFooterFileDate + '.html';
                vm.ndCguFileUrlisActive = true;
            }
        }

        function goToHelpPage() {
            const helpUrl =  $state.href(RoutesConstants.ndHelp);
            onCloseFic(null, false, {isDocRedirect: true, url: helpUrl});
        }

        function goToAlertsMenu(){
            onCloseFic(RoutesConstants.alertsList);
        }
        function removeInformation(){
            const infoDetails = _.omit(CacheService.getObject(CacheConstants.informationMessage),'message');
            CacheService.setObject(CacheConstants.informationMessage,infoDetails);
        }
        function callOrderModuleClose(){
            const deferred = $q.defer();
            $mdDialog.show({
                templateUrl: 'app/components/orderModule/orderModeClosePopup.html',
                controller: 'orderModeClosePopupController',
                bindToController: true,
                controllerAs: 'vm',
                clickOutsideToClose: false,
                locals: {
                    isOrderMode: vm.isOrderMode,
                    message: $translate.instant("ORDER_MODE_CLOSPOPUP_DESCRIPTION1"),message2: $translate.instant("ORDER_MODE_CLOSPOPUP_DESCRIPTION2"),
                    confirmMessage: $translate.instant("ACTIS_SAVE_INFORMATIONS_YES"),
                    cancelMessage: $translate.instant("ACTIS_SAVE_INFORMATIONS_NO")
                }

            }).then( function(response){
                if(response && response.isOrderModeEnabled)
                {
                    deferred.resolve();
                }
            });
            return deferred.promise;
        }        

        function goToActisPage(ficCategory){
            if(isActisNew){
                MainMetierService.goToDesyre('actis/cirCreation', ficCategory);
            } else {
                if(ficCategory === 'BRW') {
                    if(!CacheService.getObject(CacheConstants.isOrderMode) || ($state.params && ($state.params.isForAccessories || $state.params.isForPaint || $state.params.isForQstomize))) {
                        CacheService.removeObject(CacheConstants.consultationFIC);
                        onCloseFic(RoutesConstants.manageFIC, {isForBwr: true, isForPaint: false, isForAccessories: false, isForQstomize: false});
                    }
                }
                else if(ficCategory === 'QSTOMIZE') {
                    if(!CacheService.getObject(CacheConstants.isOrderMode) || ($state.params && ($state.params.isForBwr || $state.params.isForPaint || $state.params.isForAccessories))) {
                        CacheService.removeObject(CacheConstants.consultationFIC);
                        onCloseFic(RoutesConstants.manageFIC, {isForQstomize: true, isForAccessories: false, isForPaint: false, isForBwr: false});
                    }
                }
            }
        }
        function setCacheForAngular(){
            if (!vm.dmsConnected) {
                const flattenCart = ShoppingCartService.getShoppingCart();
                const cartMetadata = ShoppingCartService.getCartMedatadata();
                _.assign(cartMetadata,{items:flattenCart,type:'basket',id:cartMetadata.id})
                if(cartMetadata && cartMetadata.items && cartMetadata.items.length > 0){
                    cartMetadata.items = _.uniq(cartMetadata.items);                   
                }
                CacheService.setObject(CacheConstants.basketPopupData, cartMetadata);
            }
        }
        function goToDesyre(url, type) {
            setCacheForAngular();
            if(url === 'ficHistory' && isActisNew){
                MainMetierService.goToDesyre(url, type);
            } else if(url === 'ficHistory' && !JSON.parse(configConstantes.isActisNew)){
                goToListFic();
                return;
            } else {
                MainMetierService.goToDesyre(url, type); 
            }           
        }

        function getUserGuidingScriptUrl() {
            const currentOrigin = ($window.location.origin || '').replace(/\/$/, '');
            return USER_GUIDING_NON_PROD_ORIGINS.indexOf(currentOrigin) !== -1 ?
                USER_GUIDING_NON_PROD_SCRIPT_URL : USER_GUIDING_PROD_SCRIPT_URL;
        }

        function toCallUserGuiding(){
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                if (window.userGuiding && typeof window.userGuiding.identify === 'function') {
                    toEnableUserIdentification();
                    clearInterval(interval);
                    return;
                }

                if (document.getElementById('user-guiding-sdk')) {
                    return;
                }

                var s = document.createElement('script');
                s.id = 'user-guiding-sdk';
                s.async = true;
                s.src = getUserGuidingScriptUrl();
                document.body.appendChild(s);
                clearInterval(interval);
                s.onerror = function() {
                    console.error('Failed to load the User Guiding plugin.');
                };
                s.onload = function() {
                    toEnableUserIdentification();
                };               
            }
        }

        function getUserGuidingRoleString(roles) {
            if (!roles) {
                return '';
            }

            if (_.isString(roles)) {
                return roles;
            }

            if (_.isArray(roles)) {
                return _.chain(roles)
                    .map(function (role) {
                        if (_.isString(role)) {
                            return role;
                        }
                        if (_.isObject(role)) {
                            return role.code || role.role || role.name || role.label || '';
                        }
                        return '';
                    })
                    .filter(Boolean)
                    .value()
                    .join(' ');
            }

            return '';
        }

        function toEnableUserIdentification(retryCount){
            const attempts = retryCount || 0;
            if (!window.userGuiding || typeof window.userGuiding.identify !== 'function') {
                if (attempts < 20) {
                    $timeout(function () {
                        toEnableUserIdentification(attempts + 1);
                    }, 500);
                }
                return;
            }

            const userProfile = CacheService.getUserProfile() || vm.userProfile || {};
            const userId = userProfile.ipn ? String(userProfile.ipn).trim() : '';
            if (!userId) {
                return;
            }

            const userRoles = getUserGuidingRoleString(userProfile.roles);
            const dealerId = userProfile.dealerId ? String(userProfile.dealerId) : '';
            const language = userProfile.portal && userProfile.portal.code ?
                String(userProfile.portal.code).toLowerCase() :
                ((userProfile.language ? String(userProfile.language) : 'en').substring(0, 2).toLowerCase());
            const country = userProfile.country ? String(userProfile.country).toUpperCase() : '';

            window.userGuiding.identify(userId, {
                role: userRoles,
                company: {
                    id: dealerId
                },
                language: language,
                country: country
            });
        }


    } 
})();

(function () {
    angular.module('phenix').controller('dealerList', function ($mdDialog,$scope,on_complete, CacheService, CacheConstants) {
        var vm = this;

        vm.dealerListCollection = [];
        vm.selectedDealer ="";
        vm.dealerDetail ="";

        /***************************
         *         FUNCTION        *
         **************************/

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        this.$onInit = function () {
            
            vm.dealerListCollection = vm.dealerList;
        }

        function onConfirm(dealer) {
            vm.selectedDealer = dealer;
            
            $mdDialog.hide();
        }

        function onCancel() {
            $mdDialog.cancel();
        }

        $scope.$on('$destroy', function() {
            on_complete(vm.selectedDealer);
        });

    })
})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .controller('AsomDocAccessPopupController', AsomDocAccessPopupController);

    /** @ngInject */
    function AsomDocAccessPopupController($mdDialog,configConstantes,LoginConstants) {
        var vm = this;
        var response = {};

       
        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;
        vm.asosLink= configConstantes.asosLink;
        vm.nissanUserURL = JSON.parse(configConstantes.isNissanUserAccess);

        function onConfirm(switchValue) {
              response.isFicSentEnabled = switchValue;
              var urlToOpen = vm.nissanUserURL ? LoginConstants.aosPortalUrl : vm.asosLink;
              window.open(urlToOpen);

            $mdDialog.hide(response);
        }


        function onCancel(switchValue) {
            response.isFicSentEnabled = switchValue;

            $mdDialog.hide(response);
        }
    }

})();
(function() {
    'use strict';

    angular.module('phenix.core').directive('clickTooltipContainer', directiveObject);

    /* @ngInject */
    function directiveObject() {
        return {
            restrict: 'E',
            template:
                // '<i ng-click="clicked($event)" style="outline: none; cursor: pointer; margin-left: 2px;" class="fa fa-info-circle" aria-hidden="true"></i>' +
                '<i ng-mouseover="show = true" ng-mouseleave="show = false" style="outline: none; cursor: pointer; margin-left: 5px;" class="fa fa-info-circle" aria-hidden="true"></i>' +
                '<span ng-show="show">' +
                    '<div ng-transclude style="position: relative;"></div>' +
                '</span>'
            ,transclude: true,
            controller: controller
        }
    }

    /* @ngInject */
    function controller ($scope, $document) {
        $scope.show = false;
        // $scope.clicked = function (event) {
        //     event.stopImmediatePropagation();
        //     $scope.show = true;
        // }
        // $document.on('click', function(event) {
        //     $scope.show = false;
        //     $scope.$apply();
        //     return $document.off('click', event);
        // });
    }
})();

(function () {

  angular
    .module('phenix.core')
    .directive('phenixSvg', behavior);

  function behavior($compile) {
    return {
      restrict: 'E',
      scope: {
        appSvg: '=',
        dir: '=',
      },
      link: function (scope, element, attrs, controllers) {
        if (!controllers.appSvg || !controllers.appSvg.length)
          return;
        scope.$watch(function () {
          return controllers.appSvg
        }, function () {

          // Create dynamic SVG

          var content = $compile(controllers.appSvg)(scope);
          if (attrs !== null && attrs !== undefined && attrs.dir)
            content.attr(attrs.dir, '');
          content = $compile(content)(scope);

          element.html('');
          element.append(content)
        })
      },
      controllerAs: 'ctrl',
      bindToController: true,
      controller: function () {}
    }
  }

})();

(function () {

    'use strict';

    angular
        .module('phenix.core')
        .service('ScrollService', behavior);

    function behavior($location, $anchorScroll) {
        var vm = this;
        vm.toHash = toHash;
        vm.animateTo = animateTo;


        /*
        *   id : string selector, id only
        */
        function toHash(id) {
            $location.hash(id);
            $anchorScroll();
            // unset hash on URL
            $location.hash('');
        }

        /*
        *   Scroll with animation
        *   id    : string selector, can be a class, or id.
        *   time  : number
        */
        function animateTo(id, time) {
            $('html, body').animate({ scrollTop: $(id).offset().top }, time);
        }


    }


})();

(function() {

  function mapObject(data, callback) {
      var newData = [];
      var tmp;
      var index = 0;
      for (var prop in data) {
          if (data[prop]) {
              tmp = callback(prop, data[prop], index);
              if (tmp) newData.push(tmp);
          }
          index++;
      }
      return newData;
  }

  // TAKE AN OBJECT AND RETURN ARRAY OBJECTS WITH KEY AND VALUE
  angular.module('phenix.core').filter('objectKeyValue', function() {
    return function(data) {
      var newData = mapObject(data, function(prop, value, index) {
        return {
          key: prop,
          value: value,
          index: index,
          // sort : special case ... used for orderBy in tmDocument.template.html
          sort: prop.length === 0 ? '!' : value
        }
      })
      return newData;
    }
  });

})();

angular.module('phenix.core').filter('numberPhenix', function($filter) {
  return function(value) {
    if(value){
      var valueToReturn = $filter('number')(value, 2);
      valueToReturn = valueToReturn.replace(',', ' ');
      return valueToReturn;
    }
    else return '';
  };
});

(function() {
    'use strict';

    function mapObject(data, callback) {
        var newData = [];
        var tmp;
        for (var prop in data) 
            if (data[prop]) {
                tmp = callback(prop, data[prop]);
                if (tmp) newData.push(tmp);
            }
        return newData;
    }

    angular
    .module('phenix.core')
    .filter('mapContainDurationTM', function() {
        
        function newObject (prop, value, trad) {
            return {
                prop: prop,
                value: value.toFixed(1),
                txt: trad,
            }
        }

        return function(data) {
            return mapObject(data, function (prop, value) {
                value = parseFloat(value.replace(',', '.'));
                if (value > 0){
                    switch (prop) {
                        case 'mechanics' : 
                            return newObject(prop, value, 'DOCUMENT_TM_TOOLTIP_MECHANICS');
                        case 'trim' :
                            return newObject(prop, value, 'DOCUMENT_TM_TOOLTIP_TRIM');
                        case 'panelwork' :
                            return newObject(prop, value, 'DOCUMENT_TM_TOOLTIP_PANELWORK');
                        case 'painting' :
                            return newObject(prop, value, 'DOCUMENT_TM_TOOLTIP_PAINTING');
                        case 'electricity':
                            return newObject(prop, value, 'DOCUMENT_TM_TOOLTIP_ELECTRICITY');
                    }
                }
                return null;
            });
        }
    });

})();
/* global moment:false */
(function () {
    'use strict';

    angular
      .module('phenix.core')
      .constant('ErrorConstants', {
          noDocumentFound: 'noDocumentFound'
      });
  })();

(function() {
  'use strict';

  angular.module('phenix.core').factory('authService', service);

  /** @ngInject */
  function service($location, $q, $rootScope) {
    return {
      defaultRoute: '',
      permission: false,
      updatePermission: function () {
        this.permission = true;
      },
      checkPermission: function () {
        var defer = $q.defer();
        if (!this.permission) {
          $location.path(this.defaultRoute);
          $rootScope.$on('$locationChangeSuccess', function (next, current) {
            defer.resolve();
          }); // ???
        } else {
          defer.resolve();
          return defer;
        }
      }
    }
  }

})();
'use strict';

angular.module('phenix').constant('ProfilConstantes', {
    actis : 'ACTIS'
});

'use strict';

angular.module('phenix.core').constant('configConstantes', {

    logDebug: 'true',
    baseUrlBack: 'https://dev.ppx.dev.asdh.aws.renault.com/nd-services',
    ndHelpUrl: 'https://cdn-re7.asdh.aws.renault.com',
    ndDocumentsUrl: 'https://cdn-re7.asdh.aws.renault.com/ndDocuments',
    ndLegalNoticeUrl:'https://cdn.esp.re7.asdh.aws.renault.com',
    apiBack: '/rest',
    serverDMS: 'http://127.1.2.3:1234/dms/rest',
    version: 'c6e9d2800bd5586070a78f2525dcc7b9d5d8cca8',
    activateActisAccessoriesAndPaint: 'true',
    isFunctionalityDevOnly : 'true',
    gigyaCDNUrl : 'https://cdns.eu1.gigya.com/js/gigya.js',
    gigyaApiKey : '3_lgartUjgHphK14RKnh1-Q-W8jPC-tE5HgfyW0_G8T2DfSTRJLBHUazwVkptgZdSA',
    asosLink: 'https://dev.a5o.dev.asdh.aws.renault.com/',
    emergencylink: 'https://dev.esp.dev.asdh.aws.renault.com/',
    publications: 'https://dfp.dev.dcs3.renault.com/login/itg',
    isOldRangeDocEnable: "true",
    isEasyLinkConnectedServicesVisible: "@@isEasyLinkConnectedServicesVisible",
    lsrTimeout: '4000',
    rpartsUrl: 'https://dev.portaildigital.ram.aws.renault.com/login',
    lightFilteringEnable: '@@lightFilteringEnable',
    isNonDmsTestingDealerId: 'true',
    isPaintCirEnabled: 'false',
    isOrderingAlert:'true',
    isVespaEnabled: 'true',
    isHerculeCorrection: 'true',
    isPrintComponentEnable: 'true',
    springBackBaseUrl: 'https://dev.ppx.dev.asdh.aws.renault.com/nd-services',
    isChatbotNewScriptEnable: 'false',
    isTraceEnable:'true',
    isRemoteServicesEnabled:'true',
    isEstimateCalculation: 'true',
    isCareAlertEnabled: 'true',
    isNissanUserAccess: 'false',
    isWDComponentNameList: 'true',
    isEnableNissanUI: 'true',
    nissanUrl: '["https://dev.nissan.asdh.aws.renault.com"]',
    isRdcsEnable: 'true',
    diagNoiseLink:'https://dab-74263-app-dab.dev.apps.renault.com/noise-diag-files/overview?',
    newHeaderMenu:'true',
    isNDAssistantEnabled:'true',
    isPricingSectionEnabled: 'true',
    isActisNew: 'true',
    isNewArticles: 'true',
    isFodEnable:'true',    
    desyreBaseUrl: '',
    isLocalRedirection: 'false',
    isNewContractService: 'true',
    newPopInInfo: 'true',
    newCarSearch: 'true'
});

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('snowFlake', snowFlake);

    /** @ngInject */
    function snowFlake() {
        var directive = {
            template:'<div class="snowflakes" aria-hidden="true">  <div class="snowflake">❅</div><div class="snowflake">❅</div><div class="snowflake">❆</div><div class="snowflake"> ❄ </div><div class="snowflake"> ❅ </div><div class="snowflake"> ❆ </div><div class="snowflake"> ❄ </div><div class="snowflake"> ❅ </div><div class="snowflake"> ❆ </div><div class="snowflake"> ❄ </div></div><div class="snowflake">❅</div><div class="snowflake">❅</div><div class="snowflake">❆</div><div class="snowflake"> ❄ </div><div class="snowflake"> ❅ </div><div class="snowflake"> ❆ </div><div class="snowflake"> ❄ </div><div class="snowflake"> ❅ </div><div class="snowflake"> ❆ </div><div class="snowflake"> ❄ </div></div>',
            restrict: 'E',
            replace:false
        };
        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .directive('newInfo', newInfo)
        .controller('NewInfoController',NewInfoController);

    /** @ngInject */
    function newInfo() {
        var directive = {
            template:'<div class="notification" style="{{vm.style}}" tooltip-placement="{{vm.position}}" tooltip-html-unsafe="{{vm.message}}">',
            restrict: 'E',           
            scope: {
                message: '@message',
                position: '@position',
                style: '@style'
            },
            controller: NewInfoController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }
    function NewInfoController($timeout){
        var el = angular.element(document.querySelectorAll('.notification'));
        var poll = function() {
          $timeout(function() {
            el.toggleClass('notify');
            poll();
          }, 2000);
        };
        poll();
    }

})();

(function () {
    'use strict';

    angular
        .module('phenix')
        .run(runBlock);

    /** @ngInject */

    function runBlock(
        EventConstants,
        configConstantes,
        UtilsMetierService,
        RoutesConstants,
        RetailGroupConstants,
        RetailGroupService,
        RdsConstants,
        LoginConstants,

        /**
         *  ANGULAR SERVICE
         */

        $rootScope,
        $state,
        $translate,
        $location,
        $locale,
        $window,
        $cookies,

        /**
         *  SERVICE
         */
        ProfilMetierService,
        CacheService,
        ClipService,
        TokenService,
        CacheConstants,
        ClipConstants,
        DealerManagerSystemeService,
        RdsService,
        CloudFrontService,
        MainMetierService,
        toastr,
        blockUI
    ) {
        var isStateChangeLoading = false;
        const isLocalRedirection = JSON.parse(configConstantes.isLocalRedirection);
        if(isLocalRedirection){
            try {
                if ($window.name) {
                    var nameData = JSON.parse($window.name);
                    if (nameData && nameData.__nd_session) {
                        Object.keys(nameData.data).forEach(function(key) {
                            var val = nameData.data[key];
                            if (val === null || val === 'null') {
                                $window.sessionStorage.setItem(key, 'null');
                            } else if (val != null && val !== 'undefined') {
                                $window.sessionStorage.setItem(key, val);
                            }
                        });
                        $window.name = ''; // Clear after reading
                    }
                }
            } catch(e) {
                console.warn('Could not restore session from window.name:', e);
            }
        }

        /**
         *  SELECTED LANGUAGE FROM USER PROFILE IF EXIST
         */
        var user = CacheService.getObject(CacheConstants.profil);
        
        if (user && user.language) {
            $translate.use(user.language.toLowerCase());
        }
        /*
        *
        *  Enter Clip/ICM redirection section
        *  If extrnal URL used we verify if it comes from CLIP
        *
        * */

        var clipParameters = ClipService.getParameters(ClipConstants.clipCookieName);
        var commonParameters = ClipService.getParameters(ClipConstants.commonCookieName);
        var searchUrlObject = UtilsMetierService.getSearchParameters();
        
        var isProfileUpdated = false;

        if (!UtilsMetierService.isEmpty(searchUrlObject) && !UtilsMetierService.isEmpty(searchUrlObject.APP_ID)) {

            if ((searchUrlObject.APP_ID === 'ADT' || searchUrlObject.APP_ID === 'CLIP') &&
                            ((searchUrlObject.VIN && !UtilsMetierService.isEmpty(searchUrlObject.VIN) && searchUrlObject.TYPE && !UtilsMetierService.isEmpty(searchUrlObject.TYPE)) &&
                            (searchUrlObject.TYPE === 'MR' || searchUrlObject.TYPE === 'DI' || searchUrlObject.TYPE === 'RDC' || (searchUrlObject.TYPE === 'MD' && searchUrlObject.MR_ID && !UtilsMetierService.isEmpty(searchUrlObject.MR_ID) && searchUrlObject.ECU_ID && !UtilsMetierService.isEmpty(searchUrlObject.ECU_ID))
                                || (searchUrlObject.TYPE === 'SE' && searchUrlObject.WDT && !UtilsMetierService.isEmpty(searchUrlObject.WDT))))
                            || (searchUrlObject.VIN && !UtilsMetierService.isEmpty(searchUrlObject.VIN) && searchUrlObject.SYMPTOM && !UtilsMetierService.isEmpty(searchUrlObject.SYMPTOM) && (searchUrlObject.APP_ID === 'CLIP'))) {
                            var symptom = searchUrlObject.SYMPTOM;
                var vin = searchUrlObject.VIN;
                if (!UtilsMetierService.isEmpty(vin)) {
                    clipParameters.mrId = searchUrlObject.MR_ID ? searchUrlObject.MR_ID : '';
                    clipParameters.ecuId = searchUrlObject.ECU_ID ? searchUrlObject.ECU_ID : '';
                    clipParameters.codeDef = searchUrlObject.CODE_DEF ? searchUrlObject.CODE_DEF : '';
                    clipParameters.APP_ID = searchUrlObject.APP_ID ? searchUrlObject.APP_ID : '';
                    clipParameters.DTC_CODE = searchUrlObject.DTC_CODE ? searchUrlObject.DTC_CODE : '';
                    clipParameters.USER_TYPE = searchUrlObject.USER_TYPE ? searchUrlObject.USER_TYPE : '';
                    clipParameters.TYPE = searchUrlObject.TYPE ? searchUrlObject.TYPE : '';
                    clipParameters.WDT = searchUrlObject.WDT ? searchUrlObject.WDT : '';
                    clipParameters.VIN = searchUrlObject.VIN ? searchUrlObject.VIN : '';
                    clipParameters.CPC = searchUrlObject.CPC ? searchUrlObject.CPC : '';
                    clipParameters.CSC = searchUrlObject.CSC ? searchUrlObject.CSC : '';
                    clipParameters.LC = searchUrlObject.LC ? searchUrlObject.LC : '';
                    clipParameters.SYMPTOM =searchUrlObject.SYMPTOM ? searchUrlObject.SYMPTOM : '';
                    clipParameters.FUNCTION =searchUrlObject.FUNCTION ? searchUrlObject.FUNCTION : '';
                    clipParameters.SUB_FUNCTION =searchUrlObject['SUB-FUNCTION'] ? searchUrlObject['SUB-FUNCTION']: '';
                    clipParameters.TITLE =searchUrlObject.TITLE ? searchUrlObject.TITLE : '';
                    clipParameters.VDH_DF_ID = searchUrlObject.VDH_DF_ID ? searchUrlObject.VDH_DF_ID : '';
                    clipParameters.NODE_1 = searchUrlObject.NODE_1 ? searchUrlObject.NODE_1 : '';
                    clipParameters.NODE_2 = searchUrlObject.NODE_2 ? searchUrlObject.NODE_2 : '';
                    clipParameters.NODE_3 = searchUrlObject.NODE_3 ? searchUrlObject.NODE_3 : '';
                    var rdcElementRef = searchUrlObject['RDC-ELEMENT-REF'] ? searchUrlObject['RDC-ELEMENT-REF'] : '';
                    var rdcOperationRef = searchUrlObject['RDC-OPERATION-REF'] ? searchUrlObject['RDC-OPERATION-REF'] : '';
                    var documentType = searchUrlObject.TYPE ? searchUrlObject.TYPE : '';
                    rdcElementRef = (rdcElementRef && rdcElementRef.length > 0) ? 'ELEM-' + UtilsMetierService.padStart(rdcElementRef, 6, '0') : '';
                    rdcOperationRef = (rdcOperationRef && rdcOperationRef.length > 0) ? 'OP-' + UtilsMetierService.padStart(rdcOperationRef, 6, '0') : '';
                    clipParameters.clipSymptom = symptom;
                    clipParameters.clipVin = vin;
                    clipParameters.clipRdcElementRef = rdcElementRef;
                    clipParameters.clipRdcOperationRef = rdcOperationRef;
                    clipParameters.clipSearchDocumentType = documentType;
                    if(searchUrlObject.TYPE === 'MR'){
                        for (var propName in clipParameters) {
                            if (clipParameters[propName] === null || clipParameters[propName] === undefined || clipParameters[propName] === '') {
                              delete clipParameters[propName];
                            }
                        }
                    }
                    ClipService.setParameters(clipParameters,ClipConstants.clipCookieName);
                    MainMetierService.setClipParameters(clipParameters);
                    CloudFrontService.removeAccessCookies();
                    CacheService.clearAll();
                    var userType = ['DI', 'SE', 'MR', 'RDC'].includes(searchUrlObject.TYPE) ? 'RNET' : 'ARCA';
                    CacheService.setUserType(userType);
                    window.location.href = configConstantes.springBackBaseUrl + LoginConstants.authorize + CacheService.getUserType();
                } else {
                    UtilsMetierService.manageLoginError('RESOURCE_UNKNOWN');
                }
            }
            else if (searchUrlObject.APP_ID === 'DMS') {
                var action = RetailGroupService.manageRetailGroupObject(searchUrlObject);
                if (action === RetailGroupConstants.Result.emptyParameters
                    || action === RetailGroupConstants.Result.mandatoryFiledsNotExist
                    || action === RetailGroupConstants.Result.appIdNotDms) {
                    UtilsMetierService.manageLoginError('ACCESS_DENIED');
                }
                else {
                    ClipService.setParameters(searchUrlObject,RetailGroupConstants.retailGroupCookieName);
                    if (!user) {
                        CloudFrontService.removeAccessCookies();
                        CacheService.clearAll();
                        CacheService.setUserType('RNET');
                        window.location.href = configConstantes.springBackBaseUrl + LoginConstants.authorize + CacheService.getUserType();
                    }
                }
            }                 
            else if(searchUrlObject.APP_ID != 'DMS' && searchUrlObject.APP_ID != 'ADT' &&  searchUrlObject.APP_ID != 'CLIP'){
                var isValid = true;
                var appIds = ['SFS','GCM','RBOTS','RFORCE','DAB','ICM','RSBD','RACTIS','RDS','AZE'];
                if(_.isEmpty(searchUrlObject)){
                    toastr.error("INVALID URL"); 
                    UtilsMetierService.manageLoginError('ACCESS_DENIED');
                    isValid = false;
                } else {
                    if(appIds.indexOf(searchUrlObject.APP_ID) !== -1 ){
                        console.log("good to go")
                    } else {
                        toastr.error("INVALID APP ID");
                        UtilsMetierService.manageLoginError('ACCESS_DENIED');
                        isValid = false;
                    }
                }                 
                var combinations = [   
                    { fields: ['APP_ID', 'TYPE', 'docId'], type: 'BT' },
                    { fields: ['APP_ID', 'TYPE', 'VIN', 'RDC-ELEMENT-REF', 'RDC-OPERATION-REF'], type: 'MR' },
                    { fields: ['APP_ID', 'TYPE', 'VIN', 'VDH_DF_ID'], type: 'DI' },
                    { fields: ['APP_ID', 'VIN', 'SYMPTOM'] },
                    { fields: ['APP_ID', 'VIN']}
                ];
                var matchedCombo = null;
                for (var c = 0; c < combinations.length; c++) {
                    var combo = combinations[c];
                    if (combo.type && searchUrlObject.TYPE !== combo.type) continue;
                    var allFieldsPresent = combo.fields.every(function(field) {
                        return searchUrlObject.hasOwnProperty(field);
                    });
                    if (allFieldsPresent) {
                        matchedCombo = combo;
                        break;
                    }
                }
                if (matchedCombo) {
                    var missingFields = [];
                    matchedCombo.fields.forEach(function(field) {
                        if (!searchUrlObject[field] || UtilsMetierService.isEmpty(searchUrlObject[field])) {
                            missingFields.push(field);
                        }
                    });
                    if (missingFields.length > 0) {
                        toastr.error('Missing required fields: ' + missingFields.join(', '));
                        isValid = false;
                    }
                } else {
                    toastr.error('No valid combination found for the given parameters.');
                    isValid = false;
                }
                if (isValid) {
                    if(searchUrlObject.APP_ID == 'DAB'){
                        searchUrlObject.USER_TYPE = 'RNET';
                    }
                    if(searchUrlObject.APP_ID == 'ICM'){
                        if(!searchUrlObject.USER_TYPE || UtilsMetierService.isEmpty(searchUrlObject.USER_TYPE)){
                            searchUrlObject.USER_TYPE = 'RNET';
                        }
                    }
                    commonParameters.APP_ID = searchUrlObject.APP_ID ? searchUrlObject.APP_ID : '';
                    commonParameters.VIN = searchUrlObject.VIN ? searchUrlObject.VIN : '';
                    commonParameters.USER_TYPE = searchUrlObject.USER_TYPE == 'RNET' ? searchUrlObject.USER_TYPE : 'ARCA';   
                    commonParameters.SYMPTOM =searchUrlObject.SYMPTOM ? searchUrlObject.SYMPTOM : '';
                    commonParameters.TYPE = searchUrlObject.TYPE ? searchUrlObject.TYPE : '';
                    commonParameters.VDH_DF_ID = searchUrlObject.VDH_DF_ID ? searchUrlObject.VDH_DF_ID : '';
                    commonParameters.docId = searchUrlObject.docId ? searchUrlObject.docId : '';
                    var elementRef = searchUrlObject['RDC-ELEMENT-REF'] ? searchUrlObject['RDC-ELEMENT-REF'] : '';
                    var operationRef = searchUrlObject['RDC-OPERATION-REF'] ? searchUrlObject['RDC-OPERATION-REF'] : '';
                    commonParameters.elementRef = (elementRef && elementRef.length > 0) ? 'ELEM-' + UtilsMetierService.padStart(elementRef, 6, '0') : '';
                    commonParameters.operationRef = (operationRef && operationRef.length > 0) ? 'OP-' + UtilsMetierService.padStart(operationRef, 6, '0') : '';
                    for (var key in commonParameters) {
                        if (commonParameters[key] === null || commonParameters[key] === undefined || commonParameters[key] === '') {
                            delete commonParameters[key];
                        }
                    }
                    ClipService.setParameters(commonParameters, ClipConstants.commonCookieName);
                    CloudFrontService.removeAccessCookies();
                    CacheService.clearAll();
                    CacheService.setUserType(commonParameters.USER_TYPE);
                    window.location.href = configConstantes.springBackBaseUrl + LoginConstants.authorize + commonParameters.USER_TYPE;
                } 
            }
            else {
                UtilsMetierService.manageLoginError('ACCESS_DENIED');
            }
        }

        var AuthorizedRoutes = ['/', '/connection'];
        var goTocarSearchEnabled = false;


        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            if (!isStateChangeLoading) {
                isStateChangeLoading = true;
                blockUI.start();
            }
            // $window.addEventListener('click', setRemovingCookies());
            var user = CacheService.getObject(CacheConstants.profil);
            // show the GDPR banner and erase data in cache and PostGre if 13 months have passed since last agreement of GDPR
            var dateNow = new Date();
            var dateNowInSeconds = Math.round(dateNow.getTime() / 1000);
            if (user && dateNowInSeconds >= user.gdprTimeOutDate && !isProfileUpdated) {
                // send event to show the banner once timed out
                $rootScope.$emit('ACTIVATE_BANNER');

                // delete info in DB :
                // init payload to be sent to PostGre
                var payload = {
                    "ipn": user.ipn,
                    "userId": user.userId, "portal": user.language,
                    "documentationFirstLanguage": user.documentationFirstLanguage,
                    "documentationSecondLanguage": user.documentationSecondLanguage,
                    "mentions": user.mentions,
                    "header": user.header,
                    "isGdprAccepted": false,
                    "isGdprAudienceAllowed": false,
                    "gdprTimeOutDate": null,
                    "isLandscape": user.isLandscape,
                    "isPRFormat": user.isPRFormat,
                    "dmsConnected": user.dmsConnected
                };
                // send request to update profil
                ProfilMetierService.updateProfil(payload);

                // set user informations in cache
                user.isGdprAccepted = false;
                user.isGdprAudienceAllowed = false;
                user.gdprTimeOutDate = null;
                CacheService.setUserProfile(user);
                isProfileUpdated = true;
            }

            $rootScope.actualLocation = $location.path();
            var currentUrl = $location.absUrl();
            var nissanUserURL = false;
            var configUrl = JSON.parse(configConstantes.nissanUrl);            
            if (configUrl) {
                nissanUserURL = configUrl.some(function(url) {
                    return currentUrl.split('#')[0].includes(url);
                });
            }
            if(nissanUserURL && configConstantes.isEnableNissanUI){
                configConstantes.isNissanUserAccess = "true";
                sessionStorage.setItem('isNissanUserAccess', "true");
            }
            var access = AuthorizedRoutes.some(function (route) {
                return toState.url === route;
            });

            /**
             *  Si !token et qu'on est sur une route necesitant un token redirection vers '/'
             */

            if (!TokenService.getToken() && !access) {
                event.preventDefault();
                $state.go('/');
            }
            
            /**
             *  Only authorize DMS user to access some pages
             */

            var DMSState = DealerManagerSystemeService.getHookResult();



            if (toState.onlyDMS && !DMSState) {
                event.preventDefault();
                $state.go(RoutesConstants.carSearch);
            }

            /**
             *   ?
             */

            $rootScope.$on('vehicleClicked', function (event, goTocarSearch) {
                goTocarSearchEnabled = goTocarSearch;
            });

            var carContext = CacheService.getCarSearchContext();
            //restricting user to go to carSearch page from carSearchResult if he hits browser backbutton
            if (carContext && !goTocarSearchEnabled && fromState.name == RoutesConstants.carSearchResult && toState.name == RoutesConstants.carSearch) {
                event.preventDefault();
                $state.go(RoutesConstants.carSearchResult);
            }
            goTocarSearchEnabled = false;

            $rootScope.previousState = fromState.name;
            $rootScope.currentState = toState.name;

        });

        // function setRemovingCookies(){
        //     if(user && !user.isGdprAccepted){
        //          // If GDPR not accepted, delete cookies
        //         var listOfCookies = $cookies.getAll();
        //         // angular.forEach(listOfCookies, function(cookie){
        //         //     console.log(cookie);
        //         //     $cookies.remove(cookie);
        //         // });
        //         console.log($cookies.userInfo);
        //     }
        // }

        /**
         *  SVG PR (LOL)
         */

        $rootScope.selectReferencesFromPlanche = function (id) {
            $rootScope.$broadcast(EventConstants.selectReferencesFromPlanche, id);
        };

        $rootScope.onSvgLoad = function(){
            $rootScope.$broadcast('onSvgLoad')
        }

        /**
         *  A quoi sert ce qui se trouve en dessous ?
         */

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (isStateChangeLoading) {
                isStateChangeLoading = false;
                blockUI.stop();
            }
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            if(fromState.url == '^'){
                $state.params.isAngularRedirect = true;
            }
        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            if (isStateChangeLoading) {
                isStateChangeLoading = false;
                blockUI.stop();
            }
            if (typeof error === "object") {
                if (error.msg === RoutesConstants.errors.WRONG_PARAMS) {
                    $state.go(error.redirectTo);
                }
            }
        });

        //used for filter number
        $locale.NUMBER_FORMATS.GROUP_SEP = " ";
        $locale.NUMBER_FORMATS.DECIMAL_SEP = ".";

        /** CAST CONSTANTS */


    }

})();

(function () {
  'use strict';

  angular
    .module('phenix')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $httpProvider, RoutesConstants) {
    $httpProvider.defaults.cache = false;
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }
    // disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

    $stateProvider
      .state(RoutesConstants.home, {
        url: "/newdialogys",
        abstract: true,
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'mainCtrl',
        params: {
          nav: null
        }
      }).state(RoutesConstants.ndHelp, {
        url: "/ndHelp",
        templateUrl: 'app/main/ndHelp.template.html',
        controller: 'ndHelpCtrl',
        controllerAs: 'ndhelpctrl'
      }).state(RoutesConstants.newTabMD, {
        url: '/documentMD/{id}/plate/:plateIndex/ref/:refIndex',
        templateUrl: 'app/components/products/documents/md/mdDocuments/mdDocumentsDetails.template.html',
        controller: 'MdDocumentDetailsCtrl',
        controllerAs: 'vm'
    }).state(RoutesConstants.newTabBT, {
        url: '/documentBT/{id}',
        params : {symptomNumbers : null,docDetails : null},
        templateUrl: 'app/components/products/documents/bt/btDocuments/btDocumentsDetails.template.html',
        controller: 'BtDocumentDetailsCtrl',
        controllerAs: 'vm'
      }).state(RoutesConstants.oldRangeMenu,{
        url:'/latest/shared/old-range-doc'
      }).state(RoutesConstants.qstomizeMenu,{
        url:'/latest/shared/qstomize'
      }).state(RoutesConstants.convproductsMenu,{
        url:'/latest/shared/converted-vehicle'
      }).state(RoutesConstants.mobilizeMenu,{
        url:'/latest/shared/mobilize'
      }).state(RoutesConstants.microMobMenu,{
        url:'/latest/shared/micro-mobility'
      }).state(RoutesConstants.trainingMenu,{
        url:'/latest/shared/training-offers'
      }).state(RoutesConstants.sdpMenu,{
        url:'/latest/shared/other-tools/sdp'
      }).state(RoutesConstants.specialToolsUpgrade,{
        url:'/latest/shared/special-tools'
      }).state(RoutesConstants.profile,{
        url:'/latest/shared/profile'
      }).state(RoutesConstants.upgradeRelease,{
        url:'/latest/shared/releases'
      }).state(RoutesConstants.ngexpertDoc,{
        url:'/latest/shared/easyBasket'
      }).state(RoutesConstants.ngfactoryRework,{
        url:'/latest/shared/factoryRework'
      });
      
    $urlRouterProvider.otherwise('/');


    // $locationProvider.html5Mode(true);
  }

})();

(function() {
    'use strict';

    angular
        .module('phenix')
        .controller('indexController', indexController);

    /* @ngInject */
    function indexController(
        $scope, $rootScope, $cookies
    ) {

        var vm  = this;
        var isIE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));

        if (isIE11){
            alert("Your browser is outdated... Please use Google Chrome / Microsoft Edge / Mozilla Firefox");            
        }

        /* var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = configConstantes.gigyaCDNUrl+"?apikey="+configConstantes.gigyaApiKey;
        document.body.appendChild(script); */

    }
})();

/* global moment:false */
(function () {
  'use strict';

  angular
    .module('phenix')
    .constant('moment', moment)
    .constant('profil', 'profil')
    .constant('listOfBackListCustomers', 'listOfBackListCustomers')
    .constant('EventConstants', {
      selectReferencesFromPlanche: 'selectReferencesFromPlanche'
    })
    .constant('globalConstant',{
    quote : 'quote',
    partRequisition : 'partRequisition',
    order : 'order',
    workshop : 'WORKSHOP',
    partshop : 'PARTSHOP',
    cart: 'cart',
    draft: 'draft',
    validated: 'validated',
    searchBy: {
        vin: 1,
        registrationNumber: 2,
        model: 3
    },
    cancelModal: 0,
    replacement:'replacement',
    details:'detail',
    applicability:'applicability',
    countryCurrencyException: ["RO"]
    })
    .constant('RoutesConstants', {
      home: 'phenix',
      default: '/',
      connection: '/connection',
      login: 'login',
      ndHelp: '/ndHelp',
      profil: 'profil',
      userSettings: 'phenix.userSettings',
      recapUser: 'recapUser',
      carSearch: 'phenix.carSearch',
      carSearchResult: 'phenix.carSearchResult',
      carSearchResultNoCarContext: 'phenix.carSearchResultNoCarContext',
      carSearchRedirection: 'phenix.carSearchRedirection',
      carOts: 'carOts',
      carFeatures: 'phenix.carFeatures',
      carFeaturesView: 'phenix.carFeatures.ots',
      carSplits: 'carSplits',
      infoClient: 'phenix.infoClient',
      product: 'phenix.product',
      searchArboTextual: 'searchArboTextual',
      listePiece: 'phenix.listePiece',
      listePieceViews: 'phenix.listePiece.pr',
      listePieceTMView: 'phenix.tm_list',
      listePieceTMContent: 'phenix.tm_list.list',
      carTechnBullt: 'carTechnBullt',
      documentMR: 'phenix.mr',
      documentMD: 'phenix.md',
      documentBT: 'phenix.bt',
      documentBTListDoc: 'btlist',
      favourites: 'phenix.favourites',
      favouritesPR: 'phenix.favouritesPR',
      resultSearchByDiagnostic:'phenix.resultSearchByDiagnostic',
      searchByDiagnostic:'phenix.searchByDiagnostic',
      questionning:'phenix.questionning',
      electricalSchemaLevel3Single:'phenix.electricalSchemaLevel3Single',
      electricalSchemaLevel3Multi:'phenix.electricalSchemaLevel3Multi',
      electricalSchemaHarness:'phenix.electricalSchemaHarness',
      qstomize:'phenix.qstomize',
	    oldRangeDocuments:'phenix.oldRangeDocuments',
      specialTools: 'phenix.specialTools',
      training:'phenix.training',
      diagnosis:'phenix.diagnosis',
      diagnosisProcess:'phenix.diagnosisProcess', 
      newTabMD: '/documentMD',
      newTabBT: '/documentBT',
      sdp: 'phenix.sdp',
      sdpMenu: 'phenix.sdpMenu',

      newTechCritTab: '/newTechCritTab',

      //TODO to remove when all source file on estimation directory are deleted
      consultEstimation:'phenix.consultEstimation',

      dmsQuote: 'phenix.dmsQuote',

      quote: 'phenix.quote',
      validatedQuote: 'phenix.validatedQuote',
      quoteListDraft: 'phenix.quoteListDraft',
      quoteListValidated: 'phenix.quoteListValidated',
      panier:'phenix.panier',
      consultPanier:'phenix.consultPanier',
      ficConsultation:'phenix.ficConsultation',
      alertsList:'phenix.alertsList',
      partList: 'phenix.partList',
      consultPartList:'phenix.consultPartList',
      partRequisition: 'phenix.partRequisition',
      validatedPartRequisition: 'phenix.validatedPartRequisition',
      partRequisitionListValidated: 'phenix.partRequisitionListValidated',
      partRequisitionListDraft: 'phenix.partRequisitionListDraft',
      validatedOrder: 'phenix.validatedOrder',
      //Administration Route
      //Country
      adminCountry: 'phenix.country',
      adminCountryDetail: 'phenix.country.detail',
      adminCountries: 'phenix.countries',

      //Business
      adminBusiness: 'phenix.business',
      adminBusinessCard: 'phenix.business.card',
      adminBusinessDms: 'phenix.business.dms',
      adminBusinessPartListEstimate: 'phenix.business.partListEstimate',
      adminBusinessBasket : 'phenix.business.basket',
      adminBusinessPartShop : 'phenix.business.partShop',
      adminBusinessTaxesAndFamilies : 'phenix.business.taxeFamily',
      adminBusinessUserListing: 'phenix.business.userListing',
      adminBusinessUserDetail: 'phenix.business.userDetail',

      adminBusinessIpnListing : 'phenix.business.ipnListing',
      adminBusinessIpnDetails : 'phenix.business.ipnDetails',


      //Stopped Range

      stoppedRange:'phenix.stoppedRange',
      stoppedRangeSelectCatalog:'phenix.stoppedRange.selectCatalog',
      stoppedRangePR:'phenix.stoppedRange.pr',
      stoppedRangeDocument:'phenix.stoppedRange.document',

      //Alerts
      listAlerts: 'phenix.listAlerts',
      detailAlert: 'phenix.detailAlert',

      //TAB listPieces
      listPieceIndexPR: '0',
      listPieceIndexProducts: '1',
      listPieceIndexTM: '2',
      listPieceIndexMR: '3',
      listPieceIndexBT: '4',
      listPieceIndexMD: '5',
      listPieceIndexINT: '6',

      //NEW ACTIS
      createFIC: 'phenix.createFIC',
      manageFIC: 'phenix.manageFIC',
      editFIC: 'phenix.editFIC',
//BTlist
      btListData:'phenix.btListData',
      btListAdvanced:'phenix.btListAdvanced',

      //DOCPRIV
      docprivData:'phenix.docprivData',
      docprivPlatesScreen:'phenix.docprivPlatesScreen',

      //VDH
      diagFilesByVin: 'phenix.diagFilesByVin',
      diagFileDetails: 'phenix.diagFileDetails',
      diagFileEcu: 'phenix.diagFileEcu',
      diagFileRecommendations: 'phenix.diagFileRecommendations',
      diagFilePredictions: 'phenix.diagFilePredictions',
        //newrealeases
        releases:'phenix.releases',
      documentsMenu: 'phenix.documents',
      oldRangeMenu:'phenix.oldRange',
      qstomizeMenu:'phenix.qstomizeMenu',
      convproductsMenu:'phenix.convertedProducts',
      mobilizeMenu:'phenix.mobilize',
      microMobMenu:'phenix.microMobility',
      trainingMenu:'phenix.trainingMenu',
      specialToolsUpgrade: 'phenix.specialToolsUpgrade',
      profile: 'phenix.profile',
      upgradeRelease:'phenix.upgradeRelease',
      ngexpertDoc : 'phenix.ngexpertDoc',
      ngfactoryRework : 'phenix.ngfactoryRework',
      // errors
      errors: {
        WRONG_PARAMS: 'PARAMS_NOT_SET'
      }
    })
    .constant('WSConstants', {
      document: '/documentation/document'
    })
    .constant('timeOutRecapCar', 500)
})();

(function () {
  angular
    .module('phenix')
    .config(config)

  /** @ngInject */
  function config($logProvider, configConstantes, $validationProvider, $compileProvider, toastrConfig, $mdThemingProvider,$qProvider) {
    $logProvider.debugEnabled((configConstantes.logDebug === 'true'));
    $compileProvider.debugInfoEnabled((configConstantes.logDebug === 'true'));
    $validationProvider.showSuccessMessage = false;
    angular.extend(toastrConfig, { timeOut: 5000 });
    $qProvider.errorOnUnhandledRejections(false);
    
    // Configure global jQuery error handling to prevent vendor bundle crashes
    window.addEventListener('error', function(event) {
      // eslint-disable-next-line no-var
      var hasError = event.error && event.error.message;
      // eslint-disable-next-line no-var
      var hasPrependError = hasError && event.error.message.includes('prepend');
      // eslint-disable-next-line no-var
      var hasVendorError = hasError && event.error.message.includes('vendor-');
      // eslint-disable-next-line no-var
      var hasTFunctionError = hasError && event.error.message.includes('.T(');
      
      if (hasPrependError || hasVendorError || hasTFunctionError) {
        console.info('Vendor bundle error caught and handled:', event.error.message);
        event.preventDefault();
        return true;
      }
      return false;
    });
    
    $mdThemingProvider.theme('default')
    .primaryPalette('amber')
    .accentPalette('deep-orange', {
        'default': '500'
    });
  }

})();

(function () {

    angular
        .module('phenix')
        .run(runBlock);

    /** @ngInject */

    function runBlock(
        RoutesConstants,


        /**
         *  ANGULAR SERVICE
         */

        $rootScope,

        /**
         *  SERVICE
         */
        MainMetierService,CacheService,UtilsMetierService,AccessConfigService
    ) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {

            if(toState.name === RoutesConstants.ficConsultation){
                var userProfil = CacheService.getUserProfile();
                if (!MainMetierService.isRnetUserType(userProfil.userType) && !(MainMetierService.isIndependantUser(userProfil.roles) && MainMetierService.isSupportAccess())) {
                    event.preventDefault();
                }
            }
            else if(toState.name === RoutesConstants.manageFIC){
                var userProfil = CacheService.getUserProfile();
                if(toParams.data && _.isEmpty(toParams.data.type)){
                    if (!MainMetierService.isRnetUserType(userProfil.userType) && 
                    !(MainMetierService.isIndependantUser(userProfil.roles) && (((UtilsMetierService.checkAsomValidDocAcess() === 'false' && UtilsMetierService.getTokenBalance() > 0) ) || (UtilsMetierService.checkAsomValidDocAcess() === 'true')) )) {
                        $rootScope.currentState = fromState.name;
                        event.preventDefault();
                    }
                }
                
            }else if(toState.name === RoutesConstants.btListAdvanced || toState.name === RoutesConstants.btListData){
                if (!MainMetierService.isBTListProfile() && !AccessConfigService.checkAccess('EXPERTS_DOC','BTLIST'))    {
                    event.preventDefault();
                }
            }

        });
        

    }

})();

angular.module('phenix').run(['$templateCache', function($templateCache) {$templateCache.put('app/main/AsomDocAccessPopup.html','<div class=supportIndependentop><div ng-if=vm.nissanUserURL><div style=padding:6px><strong>{{"AOS_DOC_ACCESS_DESCRIPTION1"| translate}}</strong></div><div style=padding:6px>{{"AOS_DOC_ACCESS_DESCRIPTION2"| translate}}</div></div><div ng-if=!vm.nissanUserURL><div style=padding:6px><strong>{{"ASOM_DOC_ACCESS_DESCRIPTION1"| translate}}</strong></div><div style=padding:6px>{{"ASOM_DOC_ACCESS_DESCRIPTION2"| translate}}</div><div style=padding:6px>{{"ASOM_DOC_ACCESS_DESCRIPTION3"| translate}}</div></div><div style=padding:6px class=text-center><button class=buttonWithIcon ng-class="{\'renault-class\': !vm.nissanUserURL, \'nissan-class nissanHover\': vm.nissanUserURL}" style=width:200px; ng-click=vm.onConfirm(true)><div class=iconDiv style=padding-right:15px><i style=font-weight:bolder;></i></div><div class=btnText ng-if=!vm.nissanUserURL>{{"ACCESS_TO_ASOS_PORTAL"| translate}}</div><div class=btnText ng-if=vm.nissanUserURL>{{"ACCESS_TO_NISSAN_PORTAL"| translate}}</div></button> <button class="buttonWithIcon cancel" ng-class="{\'renault-class\': !vm.nissanUserURL, \'nissan-class nissanHover\': vm.nissanUserURL, \'cancel-nissan\': vm.nissanUserURL}" style="width:200px; margin-left: 25px;" ng-click=vm.onCancel(false)><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>CANCEL</div></button></div></div>');
$templateCache.put('app/main/dealerList.template.html','<md-dialog id=dealerList style=z-index:79><div id=dealerList><div class=title>{{ \'ORDERING_MODULE_SERVICE_TITLE\' | translate}}</div><table id=dealerList><thead><tr><th>{{\'Name\'}}</th><th>{{\'Dealer Code\'}}</th><th>{{\'Client Code\'}}</th></tr></thead><tbody><tr ng-repeat="dealer in vm.dealerList track by $index" ng-click=vm.onConfirm(dealer)><td>{{dealer.name}}</td><td>{{dealer.dealerId}}</td><td>{{dealer.clientCode}}</td></tr></tbody></table></div></md-dialog>');
$templateCache.put('app/main/main.html','<div id=newCode><div class=only-print style=display:none;><img src=../../assets/images/renaultgroup.png width=50 height=50></div><div id=phenixHeader ng-style="{\'background-color\': mainCtrl.nissanUserURL ? \'#C3002F\' : \'\'}"><div class=headerContainer><nav ng-if=mainCtrl.nissanUserURL class="top-bar mainMenu" style="background-color: #C3002F; top: 20px;" id=phenixNav><ul class=title-area style="display: inline-flex;"><li class="enterprise name"><img src=./assets/images/Nissan-Brand-Logo-RGB-W.png alt="Nissan brand icon" style="top: -2px;position: relative;margin-left: 7px; width: 40px; height: 29px;"></li></ul><section class=top-bar-section style="top: 5px;" ng-hide="mainCtrl.isMRInNewTab || mainCtrl.isMDInNewTab || mainCtrl.isBTInNewTab"><ul class=right ng-class="{\'nissan-menu\': mainCtrl.nissanUserURL}"><li id=serviceWeather class=iconPlacement><a href={{mainCtrl.nissanServiceWeatherLink}} target=_blank style="background-color: #C3002F;padding: 0;"><img src=./assets/images/newIcons/desyreWeatherIcon.svg width=27 height=30 alt="Service Weather" title="{{\'EASYLINK_VEHICLE_SERVICES_STATUS\' | translate}}" style="filter: brightness(0) invert(1) !important;position: relative; bottom: 4px;"></a></li><li ng-if=!mainCtrl.isAdmin class="menu has-dropdown" id=nissanProfil ng-mouseenter="mainCtrl.notHide = true" ng-mouseleave="mainCtrl.notHide = false" style="display: flex; align-items: center; justify-content: center; position: relative;"><button type=button style="font-family: var(--renaultFontRegular) !important; font-size:14px !important;background: #F2EDE4; color: #222; border-radius: 16px; width: 24px; height: 24px; border: none; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.12);top: -5px; padding: 8px 6px;">{{mainCtrl.user.firstName.charAt(0)}}{{mainCtrl.user.lastName.charAt(0)}}</button><div class=profile-dropdown ng-show=mainCtrl.notHide style="position: absolute; right: 10px; top: 110%; min-width: 180px; z-index: 10; background: #222; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.18);"><ul style="display: block; margin: 0; padding: 8px 0;"><li class=profile-dropdown-item ng-click="mainCtrl.goToDesyre(\'profile\')" style="cursor:pointer; padding: 8px 16px; color: white;background: none;"><span class=profile-dropdown-icon></span> <img src=./assets/svg/newHeader/user.svg alt="user icon" style="height:20px; width:20px; vertical-align:middle;filter: invert(1);"> <span class=profile-dropdown-text>{{\'MY_PROFILE\' | translate}}</span></li><li id=ngdisconnect class=profile-dropdown-item ng-click=mainCtrl.disconnect() style="cursor:pointer; padding: 8px 16px; color: white;background: none;"><span class=profile-dropdown-icon><i class=icon-icons_logout style="font-size: 20px;"></i> </span><span class=profile-dropdown-text>{{\'DISCONNECT\' | translate}}</span></li></ul></div></li><li class="menu closeAdmin" ng-if=mainCtrl.isAdmin><a ng-click=mainCtrl.goToCarSearchPage()><span>{{\'CLOSE_ADMINISTRATION\' | translate}}</span> <i class=icon-icons_close></i></a></li></ul></section></nav><nav ng-if=!mainCtrl.isAdmin ng-hide="mainCtrl.nissanUserURL || mainCtrl.isMRInNewTab || mainCtrl.isMDInNewTab || mainCtrl.isBTInNewTab || mainCtrl.isOnlyPpxLightUser" class="top-bar submenu" data-topbar role=navigation id=phenixNav><section class="top-bar-section no-print"><!-- Right Nav Section --><ul class=left id=mainTag><li id=rgBrandLogo class=brandLogoStyle><img src=./assets/svg/newHeader/rg-brand-new.svg alt="RG Brand" style="height:48px; width:48px; vertical-align:middle;"></li><li class="brandLogoStyle name menu appNameStyle">New Dialogys</li><li class="carContext menu" id=ngCarSearch style="margin-left: 20px;"><div class="text no-print activeLink" ng-class=mainCtrl.getIconVehicleClass() ng-click=mainCtrl.backToSearchCar() tooltip-placement=bottom tooltip-html-unsafe={{mainCtrl.tooltipVehicleContext()}} style="margin-top: 6px;width: 40px;height: 24px;padding: 0px 5px 8px 8px;position: relative;top: 6px;"><img src=./assets/svg/newHeader/car.svg alt=car style="height:24px; width:24px; vertical-align:middle;filter: invert(1);position: relative;top: -8px;"></div></li><!--=====================================\n                        =           CAR CONTEXT MENU            =\n                        ======================================--><!--=====================================\n                        =            DOCUMENTS MENU             =\n                        ======================================--><!-- dropDown disabled while functionality not fully developed --><!-- add  <<<  ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}"  >>>  to re-activate --><!-- <li class="menu" ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}"> --><!--=====================================\n                        =        PARTS REQUISITION MENU         =\n                        ======================================--><li class="menu menuPlacement" ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}" ng-if=mainCtrl.dmsConnected ng-hide="mainCtrl.isContextCarBrandCheck || mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser" id=partRequisitionHeader><div class=text ng-class="{\'noHover\': mainCtrl.isProfileView}"><div class=partListMenu>{{\'HEADER_PARTLISTS\' | translate}}</div><p id=notification ng-if="mainCtrl.showNotification && partListNotif.length > 0" notification partlists=partListNotif>{{partListNotif.length}}</p></div><ul class=dropdown><li id=ngPR_0 ng-class="{\'inactifGrey\': !mainCtrl.canCreatePartRequisitionOrQuote()}"><div class=subMenu ng-click="mainCtrl.canCreatePartRequisitionOrQuote() && mainCtrl.goToNewPart()">{{\'NEW_PARTLIST_1\' | translate}}</div></li><li class=active id=ngPR_1><div class=subMenu ng-click=mainCtrl.goToListPartsRequisitionsDraft()>{{\'PARTLISTS_DRAFT\' | translate}}</div></li><li id=ngPR_2 class=active><div class=subMenu ng-click=mainCtrl.goToListPartsRequisitionsValidated()>{{\'PARTLISTS_VALIDATED\' | translate}}</div></li></ul></li><!--=====================================\n                        =            ESTIMATES MENU             =\n                        ======================================--><li id="estimateHeader " class="menu menuPlacement" ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}" ng-if=mainCtrl.dmsConnected ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=text ng-class="{\'noHover\': mainCtrl.isProfileView}"><div class=partListMenu>{{\'HEADER_ESTIMATES\' | translate}}</div></div><ul class=dropdown><li ng-hide=mainCtrl.isContextCarBrandCheck id=ngEQ_0 ng-class="{\'inactifGrey\': !mainCtrl.canCreatePartRequisitionOrQuote()}"><div ng-class="{\'inactifGrey\': !mainCtrl.canCreatePartRequisitionOrQuote()}" class=subMenu id=newEstimate one-click-only-quote="mainCtrl.canCreatePartRequisitionOrQuote() && mainCtrl.createQuote()">{{\'NEW_ESTIMATE_1\' | translate}}</div></li><li class=active id=ngEQ_1><div class=subMenu ng-click=mainCtrl.goToListQuoteDraft()>{{\'ESTIMATES_DRAFT\' | translate}}</div></li><li class=active id=ngEQ_2><div class=subMenu ng-click=mainCtrl.goToListQuoteValidated()>{{\'ESTIMATES_VALIDATED\' | translate}}</div></li></ul></li><!--=====================================\n                        =              CARTS MENU               =\n                        ======================================--><!-- dropDown disabled while functionality not fully developed --><!-- add  <<<  ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}"  >>>  to re-activate --><li id=ngBasketHeader class="menuPlacement has-dropdown menu" ng-if="!mainCtrl.isHorseUser && (!mainCtrl.dmsConnected && (!mainCtrl.isIndependentUser ))" ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=text ng-click=mainCtrl.goToListPaniers()><div>{{\'LOCATION_BASKET\' | translate}}</div></div></li><li class="menuPlacement has-dropdown asom-tooltip menu" id=ngBasketHeader ng-if="mainCtrl.isIndependentUser && (((mainCtrl.isAsomValidDocAccess===\'true\' && ($root.asomDocList.PR || $root.asomDocList.TM)) || (mainCtrl.isAsomValidDocAccess==\'false\' && mainCtrl.iconAccess())) || (mainCtrl.isAsomValidDocAccess===\'false\' && !mainCtrl.iconAccess()))" ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div ng-if="(mainCtrl.isAsomValidDocAccess===\'true\' && ($root.asomDocList.PR || $root.asomDocList.TM)) || (mainCtrl.isAsomValidDocAccess==\'false\' && mainCtrl.iconAccess())" class=text ng-click=mainCtrl.goToListPaniers()><div>{{\'LOCATION_BASKET\' | translate}}</div></div><div ng-if="mainCtrl.isAsomValidDocAccess===\'false\' && !mainCtrl.iconAccess()" class="asominactiv menuPlacement" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><div>{{\'LOCATION_BASKET\' | translate}}</div></div></li><li ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\')" class="has-dropdown menu menuPlacement" id=ngexpertDoc ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=text><div>{{\'EASYBASKET_EXPERT_DOC\' |translate}}</div></div><ul class=dropdown><li id=ngDocPriv ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\',\'DOCPRIV\')"><div ng-click=mainCtrl.goToDocpriv() class=subMenu><div>{{\'DOCPRIV_LABEL\' | translate}}</div></div></li><li id=ngeasyBasketValidation ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\',\'EBV\')"><div class=subMenu ng-click="mainCtrl.goToDesyre(\'ebValidation\')"><div>{{\'EASYBASKET_VALIDATION\' |translate}}</div></div></li><li id=factoryRework ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\',\'FACTORY_REWORK\')"><div class=subMenu ng-click="mainCtrl.goToDesyre(\'factoryRework\')"><div>{{\'FACTORY_REWORK\' |translate}}</div></div></li><li id=ngbtHeader ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\',\'BTLIST\')"><div class=subMenu ng-click=mainCtrl.goToBTlist()><div>{{\'BTLIST_TITLE\' | translate}}</div></div></li><li id=carParkCalculator ng-if="mainCtrl.checkMenuAccess(\'EXPERTS_DOC\',\'CARPARK_CALCULATION\')"><div class=subMenu ng-click="mainCtrl.goToDesyre(\'carParkCalculator\')"><div>{{\'CARPARK_CALCULATION\' |translate}}</div></div></li></ul></li><li class="menuPlacement has-dropdown menu" ng-if=mainCtrl.isRnetUserType id=ngActisHeader ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=text><div>{{\'COMMON_ASSISTANCE\' | translate}} <span class=actis-count-circle ng-if="mainCtrl.processedCIRCount > 0">{{mainCtrl.processedCIRCount}}</span></div></div><ul class=dropdown ng-if=!mainCtrl.isBrwDealer><li class=has-dropdown id=ngFic-H><div class=subMenu ng-class="{\'noHover\': mainCtrl.isProfileView}" ng-click="mainCtrl.goToDesyre(\'ficHistory\')">{{\'FIC_HISTORY\' | translate}}</div></li><li class=has-dropdown><div class="subMenu withArrow" ng-class="{\'noHover\': mainCtrl.isProfileView}">{{\'NEW_FIC\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown><li id=ngFic-QST><div class=subMenu ng-click="mainCtrl.goToActisPage(\'QSTOMIZE\')"><md-tooltip md-direction=right><span>{{\'QSTOMIZE_TOOLTIP\' | translate}}</span></md-tooltip>{{\'FIC_QSTOMIZE\' | translate}}</div></li></ul></li><!-- <li class="has-dropdown" ng-if="mainCtrl.isAlertsEnabled" id="ngTmmrAlerts">\n                                    <div class="subMenu" ng-class="{\'noHover\': mainCtrl.isProfileView}"\n                                        ng-click="mainCtrl.goToAlertsMenu()">\n                                        {{\'TM_MR_ALERTS\' | translate}}\n                                    </div>\n                                </li> --><li class=has-dropdown ng-if=mainCtrl.isTraceEnabled id=ngTraceAlerts><div class=subMenu ng-class="{\'noHover\': mainCtrl.isProfileView}" ng-click=mainCtrl.goToAlertsMenu()>{{\'TRACE_ALERTS\' | translate}}</div></li><li ng-if=mainCtrl.isRnetUserType><div class=subMenu ng-click=mainCtrl.goToBoschLink()>{{\'SDP_ASSISTANCE\' | translate}}</div></li></ul><ul class=dropdown ng-if=mainCtrl.isBrwDealer><li class=has-dropdown id=ngFic-H><div class=subMenu ng-class="{\'noHover\': mainCtrl.isProfileView}" ng-click="mainCtrl.goToDesyre(\'ficHistory\')">{{\'FIC_HISTORY\' | translate}}</div></li><li class=has-dropdown><div class="subMenu withArrow" ng-class="{\'noHover\': mainCtrl.isProfileView}">{{\'NEW_FIC\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown><li id=ngFic-BRW><div class=subMenu ng-click="mainCtrl.goToActisPage(\'BRW\')"><md-tooltip md-direction=right><span>{{\'BRW_TOOLTIP\' | translate}}</span></md-tooltip>{{\'FIC_BRW\' | translate}}</div></li><li id=ngFic-QST><div class=subMenu ng-click="mainCtrl.goToActisPage(\'QSTOMIZE\')"><md-tooltip md-direction=right><span>{{\'QSTOMIZE_TOOLTIP\' | translate}}</span></md-tooltip>{{\'FIC_QSTOMIZE\' | translate}}</div></li></ul></li><li class=has-dropdown ng-if=mainCtrl.isTraceEnabled id=ngTraceAlerts><div class=subMenu ng-class="{\'noHover\': mainCtrl.isProfileView}" ng-click=mainCtrl.goToAlertsMenu()>{{\'TRACE_ALERTS\' | translate}}</div></li><li ng-if=mainCtrl.isRnetUserType><div class=subMenu ng-click=mainCtrl.goToBoschLink()>{{\'SDP_ASSISTANCE\' | translate}}</div></li></ul></li><!--SUPPORT for independent users--><li id=ngSupportHeader class="menuPlacement has-dropdown asom-tooltip menu" ng-if="mainCtrl.isIndependentUser && mainCtrl.isSupportAccess"><div class=text><div>{{\'SUPPORT_INDEPENDENT\' | translate}}</div></div><ul class=dropdown><li class=fitMenuContent id=ngSupReq_0><div class=subMenu ng-click="mainCtrl.goToDesyre(\'ficHistory\')">{{\'SUPPORT_INDEPENDENT_ALL_REQUESTS\'| translate}}</div></li><li class="fitMenuContent disabledSupportMenuItem" ng-if="mainCtrl.isAsomValidDocAccess== \'false\' && mainCtrl.tokenBalance===0" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}" id=ngSupReq_1><div class=subMenu>{{\'SUPPORT_INDEPENDENT_NEW_REQUEST\'| translate}}</div></li><li class=fitMenuContent ng-if="mainCtrl.isAsomValidDocAccess== \'false\'&& mainCtrl.tokenBalance > 0" id=ngSupReq_1><div class=subMenu ng-click=mainCtrl.goToSupport()>{{\'SUPPORT_INDEPENDENT_NEW_REQUEST\'| translate}}</div></li><li class=fitMenuContent id=ngSupReq_1 ng-class="{\'disabledSupportMenuItem\': mainCtrl.tokenBalance === 0}" ng-if=" mainCtrl.isAsomValidDocAccess== \'true\'"><div class=subMenu ng-click=mainCtrl.goToSupport()>{{\'SUPPORT_INDEPENDENT_NEW_REQUEST\'| translate}}</div></li><li class=fitMenuContent id=ngSupReq_2 ng-class="{\'disabledSupportMenuItem\': !mainCtrl.isBrandApplicable()}"><div class=subMenu ng-keypress ng-click="mainCtrl.isBrandApplicable() && mainCtrl.goToActisPage(\'QSTOMIZE\')"><md-tooltip md-direction=right><span>{{\'QSTOMIZE_TOOLTIP\' | translate}}</span></md-tooltip>{{\'FIC_QSTOMIZE_REQUEST\' | translate}}</div></li></ul></li><!--=====================================\n                        =            Search field             =\n                        ======================================--></ul><!-- ======== END LEFT MENU ========== --><ul class=right><!--=====================================\n                        =        PARTLIST AND ITS TOOLTIP       =\n                        ======================================--><li ng-if=mainCtrl.dmsConnected class=iconPlacement ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div id=quoteDivButton style="margin-right: 5px;" ng-class="{\'actif\': !mainCtrl.quoteButtonDisabled ,\'inactif\': mainCtrl.quoteButtonDisabled}" class=iconAccessCurrent ng-click=mainCtrl.goToQuote()><img class=on-super-cart-quote-hover src=./assets/svg/newHeader/money.svg alt=quote style="height:24px; width:24px; vertical-align:middle;filter: invert(1);" ng-style="{\'filter\': mainCtrl.quoteButtonDisabled ? \'invert(0.5)\' : \'invert(1)\' }"><div class=super-cart-quote-container id=quotePopin ng-show=!mainCtrl.quoteButtonDisabled><super-cart-popin items=mainCtrl.quote.items icon=./assets/svg/newHeader/money.svg popin-title=mainCtrl.quotePopinTitle popin-subtitle=mainCtrl.quotePopinSubtitle type=quote></super-cart-popin></div><super-cart-badge cart-length=mainCtrl.quoteItemsNumber></super-cart-badge></div></li><li ng-if=mainCtrl.dmsConnected ng-hide="mainCtrl.isContextCarBrandCheck || mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser" id=ngBasketClick class=iconPlacement><div class=iconAccessCurrent id=asomBasketIcon style="margin-right: 5px;" ng-class="{\'actif\': !mainCtrl.partRequisitionButtonDisabled,\'inactif\': mainCtrl.partRequisitionButtonDisabled}" ng-click=mainCtrl.goToPartsRequisition()><!-- <i class="icon-icons_basket on-super-cart-parts-requisition-hover" ></i> --> <img class=on-super-cart-parts-requisition-hover src=./assets/svg/newHeader/shop-cart.svg alt="part req" style="height:24px; width:24px; vertical-align:middle;filter: invert(1);" ng-style="{\'filter\': mainCtrl.partRequisitionButtonDisabled ? \'invert(0.5)\' : \'invert(1)\'}"><div class=super-cart-parts-requisition-container id=partRequisitionPopin ng-show=!mainCtrl.partRequisitionButtonDisabled><super-cart-popin items=mainCtrl.partsRequisition.items icon=./assets/svg/newHeader/shop-cart.svg popin-title=mainCtrl.partsRequisitionPopinTitle popin-subtitle=mainCtrl.partsRequisitionPopinSubtitle type=parts></super-cart-popin></div><super-cart-badge cart-length=mainCtrl.partsRequisitionItemsNumber></super-cart-badge></div></li><li class="has-dropdown menu menuPlacement" ng-if=mainCtrl.dmsConnected id=favouritesHeader ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=text ng-click="mainCtrl.goToDesyre(\'favourite\')" style="margin-right: 0;" ng-class="{\'activeLink\':(currentState== mainCtrl.rCst.favourites || currentState== mainCtrl.rCst.favouritesPR), \'noHover\': mainCtrl.isProfileView}"><img src=./assets/svg/newHeader/favourite.svg alt=favourites style="height:24px; width:24px; vertical-align:middle;filter: invert(1);"></div><!-- <ul class="dropdown" style="right: auto;">\n                                    <li class="active" ng-hide="mainCtrl.isContextCarBrandCheck" id="ngFav-PR">\n                                        <div class="subMenu" ng-click="mainCtrl.goToFavouritesProd()">\n                                            {{\'HEADER_FAVORITES_PRODUCTS\' | translate}}</div>\n                                    </li>\n                                    <li class="active" id="ngFav-TM">\n                                        <div class="subMenu" ng-click="mainCtrl.goToFavouritesTM()">\n                                            {{\'HEADER_FAVORITES_TM\' | translate}}</div>\n                                    </li>\n                                </ul> --></li><!--=====================================\n                        =        BASKET AND ITS TOOLTIP       =\n                        ======================================--><!-- disabled while functionality not fully developed --><!-- add  <<<  ng-click="mainCtrl.goToBasket()"  >>>  to re-activate --><li id=ngRefresh ng-if=!mainCtrl.dmsConnected ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=iconAccessCurrent style="position: relative" ng-if="mainCtrl.isIndependentUser && mainCtrl.isAsomValidDocAccess==\'false\'" ng-click=mainCtrl.reCheckAsomSubscriptions()><span><i class="text fa fa-refresh activeLink" ng-class="{\'refreshDisabled\':mainCtrl.allowASOM}" style="padding:4px;background-image: linear-gradient(190deg,#978B7F, #978B7F);"></i><md-tooltip md-direction=left class=customTooltip ng-if=mainCtrl.allowASOM md-direction=left>{{ \'INDEPENDENT_REFRESH_TEXT\' | translate }}</md-tooltip></span></div></li><li id=ngBasketClick ng-if=!mainCtrl.dmsConnected ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div style="position: relative;margin-left: 10px;cursor: pointer;margin-top: 7px;margin-right: 5px;" ng-if="!mainCtrl.isHorseUser && !mainCtrl.isIndependentUser " class=iconAccessCurrent ng-click=mainCtrl.goToBasket()><img class=on-basket-hover src=./assets/svg/newHeader/shop-cart.svg alt=car style="height:24px; width:24px; vertical-align:middle;filter: invert(1);"><div class=recap-cart-container id=recap-cart><recap-cart flatten-cart=mainCtrl.flattenCart cart-metadata=mainCtrl.cartMetadata new-header=mainCtrl.newHeaderMenu></recap-cart></div><super-cart-badge cart-length=mainCtrl.cartLength></super-cart-badge></div><div ng-if="mainCtrl.isIndependentUser  && ($root.asomDocList.PR || $root.asomDocList.TM)" id=asomBasketIcon><div style="position: relative" ng-if="mainCtrl.isAsomValidDocAccess==\'true\' ||(mainCtrl.isAsomValidDocAccess==\'false\' && mainCtrl.iconAccess()) " class=iconAccessCurrent ng-click=mainCtrl.goToBasket()><img class="on-basket-hover basket-icon-asom" src=./assets/svg/newHeader/shop-cart.svg alt=car><div class=recap-cart-container id=recap-cart><recap-cart flatten-cart=mainCtrl.flattenCart cart-metadata=mainCtrl.cartMetadata new-header=mainCtrl.newHeaderMenu></recap-cart></div><super-cart-badge cart-length=mainCtrl.cartLength></super-cart-badge></div><div ng-if="mainCtrl.isAsomValidDocAccess==\'false\' && !mainCtrl.iconAccess()" style="position: relative" class=iconAccessCurrent ng-class="{\'asominactiv\': true,\'text\':false}" tooltip-placement=left tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i class="icon-icons_basket on-basket-hover" style="color: #fff;"></i></div></div></li><li class="menu iconPlacement" ng-if="!mainCtrl.isIndependentUser && !mainCtrl.isHorseUser" ng-hide=mainCtrl.isMitsubishiUser ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}" id=documentHeader><div class=text ng-class="{\'noHover\': mainCtrl.isProfileView}" style="margin-right: 0px;"><img src=./assets/svg/newHeader/more-2.svg alt="RG Brand" style="height:24px; width:24px; vertical-align:middle;filter: invert(1);top: -4px;\n        position: relative;"></div><ul class=dropdown id=otherDoc style="right: auto;"><li id=release ng-if="!mainCtrl.isIndependentUser &&!mainCtrl.isPpxLightUser"><div class=subMenu ng-click="mainCtrl.goToDesyre(\'release\')">{{\'RELEASE_NOTES_HEADING\' | translate}}</div></li><li id=documentsAndTools ng-hide=mainCtrl.isPpxLightUser><div class=subMenu ng-click="mainCtrl.goToDesyre(\'documentsAndTools\')" style="position: relative;">{{\'DOCUMENTS_AND_TOOLS\' | translate}}</div></li><hr class=hrLine id=linksId ng-hide=mainCtrl.isPpxLightUser><li class=has-dropdown ng-hide=mainCtrl.isPpxLightUser><div class="subMenu withArrow">{{\'COMMON_RENAULT_LINKS\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown><li id=reuseParts ng-if="((mainCtrl.isArcaUser || mainCtrl.isRnetUserType) && mainCtrl.user.country === \'FR\')"><div class=subMenu ng-click=mainCtrl.reuseParts()>{{\'REUSE_PARTS\' | translate}}</div></li><li id=electronicRepair ng-if=mainCtrl.repairLabCountries><div class=subMenu ng-click=mainCtrl.goToElectronicRepair()>{{\'ELECTRONIC_REPAIR\' | translate}}</div></li><li id=garageDoc ng-if="mainCtrl.user.country !== \'ES\'"><div class=subMenu ng-click=mainCtrl.goToGarageEquipment()>{{\'HEADER_DOCUMENTS_GARAGE\' | translate}}</div></li><li class=has-dropdown id=ownersManual><div class="subMenu withArrow" ng-class="{\'noHover\': mainCtrl.isProfileView}">{{\'HEADER_DOCUMENTS_OWNERS_MANUAL\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown id=documentEguide><li><div class=subMenu ng-click=mainCtrl.goToeGuide()>{{\'HEADER_DOCUMENTS_EGUIDES\' | translate}}</div></li><li><div class=subMenu ng-click=mainCtrl.goToUserBox()>{{\'HEADER_DOCUMENTS_USERBOX\' | translate}}</div></li></ul></li><li id=serviceWeather ng-if="mainCtrl.isArcaUser || mainCtrl.isRnetUserType"><div class=subMenu ng-click=mainCtrl.goToConnectServicesLink()><span style="min-width: 275px;\n                                            white-space: nowrap;">{{\'MULTIMEDIA_CONNECTED_SERVICES\' | translate}}</span></div></li><li id=serviceWeather ng-if="mainCtrl.isArcaUser || mainCtrl.isRnetUserType"><div class=subMenu ng-click=mainCtrl.goToAccessoriesWebsiteLink()><span style="white-space: pre-line;">{{\'ACCESSORIES_MENU\' | translate}}</span></div></li><li id=serviceWeather ng-if="mainCtrl.isArcaUser || mainCtrl.isRnetUserType"><div class=subMenu ng-click=mainCtrl.goToDabSiteLink()><span style="white-space: pre-line;">{{\'DAB_MENU\' | translate}}</span></div></li><li ng-if=mainCtrl.isRnetUserType><div class=subMenu id=publicationDoc ng-click=mainCtrl.goToPublicationLink()>{{\'PUBLICATION_ITG\' | translate}}</div></li><li id=serviceWeather ng-if="mainCtrl.isArcaUser || mainCtrl.isRnetUserType  || mainCtrl.nissanUserURL"><div class=subMenu ng-click=mainCtrl.goToServiceWeather()>{{\'SERVICE_WEATHER\' | translate}}</div></li><li><div class=subMenu ng-click=mainCtrl.goToSpaceNomadeDealersLink()>{{\'SPACE_NOMADE_DEALERS_LINK\' | translate}}</div></li><li ng-if=mainCtrl.isVisibleBtnVirtualAcademy><div class=subMenu ng-click=mainCtrl.goToVirtualAcademy()>{{\'COMMON_VIRTUAL_ACADEMY\' | translate}}</div></li></ul></li><li ng-hide=mainCtrl.isMitsubishiUser id=ngHelp ng-click="mainCtrl.goToDesyre(\'ndHelp\')"><div class=subMenu style="position: relative;">{{\'HELP\' | translate}}</div></li></ul></li><li class="menu iconPlacement" ng-if="mainCtrl.isIndependentUser && mainCtrl.isAsomValidDocAccess ===\'true\'" ng-class="{\'has-dropdown\': !mainCtrl.isProfileView}" id=documentHeader><div class=text ng-class="{\'noHover\': mainCtrl.isProfileView}" style="margin-right: 0px;"><img src=./assets/svg/newHeader/more-2.svg alt="RG Brand" style="height:24px; width:24px; vertical-align:middle;filter: invert(1);top: -4px;\n        position: relative;"></div><ul class=dropdown id=otherDoc style="right: 0px; min-width: 10vw;"><li id=documentsAndTools ng-if="($root.asomDocList.ICP || $root.asomDocList.ST || $root.asomDocList[\'MD-DIAGFILES\']) && mainCtrl.isAsomValidDocAccess==\'true\' && !mainCtrl.isPpxLightUser"><div class=subMenu ng-click="mainCtrl.goToDesyre(\'documentsAndTools\')" style="position: relative;">{{\'DOCUMENTS_AND_TOOLS\' | translate}}</div></li><hr class=hrLine id=linksId><li class=has-dropdown ng-if="mainCtrl.isAsomValidDocAccess===\'true\' && !mainCtrl.isPpxLightUser"><div class="subMenu withArrow">{{\'COMMON_RENAULT_LINKS\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown><li id=electronicRepair ng-if=mainCtrl.repairLabCountries><div class=subMenu ng-click=mainCtrl.goToElectronicRepair()>{{\'ELECTRONIC_REPAIR\' | translate}}</div></li><li id=garageDoc ng-if="mainCtrl.user.country !== \'ES\'"><div class=subMenu ng-click=mainCtrl.goToGarageEquipment()>{{\'HEADER_DOCUMENTS_GARAGE\' | translate}}</div></li><li class=has-dropdown id=ownersManual><div class="subMenu withArrow" ng-class="{\'noHover\': mainCtrl.isProfileView}">{{\'HEADER_DOCUMENTS_OWNERS_MANUAL\' | translate}} <img class=arrow-right-new-icon src=./assets/svg/newHeader/arrow-right-2.svg alt=arrow></div><ul class=dropdown id=documentEguide><li><div class=subMenu ng-click=mainCtrl.goToeGuide()>{{\'HEADER_DOCUMENTS_EGUIDES\' | translate}}</div></li><li><div class=subMenu ng-click=mainCtrl.goToUserBox()>{{\'HEADER_DOCUMENTS_USERBOX\' | translate}}</div></li></ul></li><li ng-if="mainCtrl.isAsomValidDocAccess===\'true\' && ($root.asomDocList.ICP)"><div class=subMenu ng-click=mainCtrl.goToSpaceNomadeDealersLink()>{{\'SPACE_NOMADE_DEALERS_LINK\' | translate}}</div></li><li ng-if="mainCtrl.isVisibleBtnVirtualAcademy && mainCtrl.isAsomValidDocAccess===\'true\'"><div class=subMenu ng-click=mainCtrl.goToVirtualAcademy()>{{\'COMMON_VIRTUAL_ACADEMY\' | translate}}</div></li></ul></li><li ng-if="mainCtrl.isAsomValidDocAccess===\'true\' && !mainCtrl.isMitsubishiUser" id=ngHelp ng-click="mainCtrl.goToDesyre(\'ndHelp\')"><div class=subMenu style="position: relative;">{{\'HELP\' | translate}}</div></li></ul></li><li id=ngprTextSearch class="iconPlacement custom-search-container" ng-if="!mainCtrl.isHorseUser && (!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && mainCtrl.isAsomValidDocAccess===\'true\' && ($root.asomDocList.PR || $root.asomDocList.BT || $root.asomDocList.OTS)))" ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"><div class=custom-search-box><div class=custom-search-icon ng-class="{\'searchDisable\' : !mainCtrl.inputReference}" id=searchButton ng-click=mainCtrl.searchRefBTNT(mainCtrl.inputReference.toUpperCase())><img src=./assets/images/newIcons/newHeaderSearchIcon.svg width=30 height=30 alt="My profile" style="filter: brightness(0) invert(1) !important;"></div><input type=text class=custom-search-input ng-focus="mainCtrl.displayMenuDoc = true" ng-blur="mainCtrl.displayMenuDoc = false" ng-attr-placeholder={{mainCtrl.getPlaceHolder()}} phenix-enter=mainCtrl.searchRefBTNT(mainCtrl.inputReference.toUpperCase()) ng-model=mainCtrl.inputReference ng-paste=mainCtrl.removeSpaces($event)></div></li><li id=dealerDetails class="iconPlacement r2aList" style="width: \n                                                        153px; height: 32px;" ng-click="mainCtrl.multipleDealersShow = !mainCtrl.multipleDealersShow" ng-if="mainCtrl.multipleDealers && (mainCtrl.dmsConnected ||  (!mainCtrl.dmsConnected && mainCtrl.isNonDmsOrderModeEnable))"><a class="arrowDown r2aDealerBox" title="{{mainCtrl.selectedDealer.name}}\n                                        {{mainCtrl.selectedDealer.dealerClient}}"><span>{{mainCtrl.selectedDealer.name}} {{mainCtrl.selectedDealer.dealerClient}}</span></a><ul class=r2aDealer-dropdown ng-show=mainCtrl.multipleDealersShow ng-class="{\'dealerShow\': mainCtrl.multipleDealersShow}"><li class=profile-dropdown-item ng-repeat="dealer in mainCtrl.dealerList" ng-if=!dealer.active><span class=profile-dropdown-text ng-click=mainCtrl.saveDealerDetails(dealer)>{{dealer.name}} {{dealer.dealerClient}}</span></li></ul></li><li id=serviceWeather ng-if="mainCtrl.isArcaUser || mainCtrl.isRnetUserType" class=iconPlacement style="margin-right: 12px;"><a href="https://dynmo-ope.live.dynatrace.com/dashboards/11f14977-68dd-4d6a-88fd-ed27503f84c8?auth=dt0c01.MKZ5ZLQKFYXOKUKYP4YVSZEZ.IQERX5MWVO6PCKJXUSALGFXZWK2VEJDA5JDLQPS4QW6EE4CAPQRBSWIHQ2AEVAZJ#dashboard;id=11f14977-68dd-4d6a-88fd-ed27503f84c8;gtf=-5m;reportId=;gf=-8186173754852886976" target=_blank style="background: rgba(0, 0, 0, 0);padding: 0;"><img src=./assets/images/newIcons/desyreWeatherIcon.svg width=27 height=30 alt="Service Weather" title="{{\'EASYLINK_VEHICLE_SERVICES_STATUS\' | translate}}" style="filter: brightness(0) invert(1) !important;position: relative; bottom: 4px;"></a></li><li id=notification class="iconPlacement brandLogoStyle" ng-click="mainCtrl.goToDesyre(\'notifications\')"><div style="position: relative; display: inline-block; width: 35px; height: 23px;"><img src=./assets/svg/newHeader/alarm-bell.svg alt="notification icon" style="height:24px; width:35px; vertical-align:middle;filter: invert(1); position: relative;"><super-cart-badge cart-length=mainCtrl.notificationLength></super-cart-badge></div></li><li class="iconPlacement brandLogoStyle" ng-if=!mainCtrl.isIndependentUser style="margin-left: 30px;" id=happi ng-hide="mainCtrl.isPpxLightUser || mainCtrl.isMitsubishiUser"></li><li ng-if=!mainCtrl.isAdmin class=iconPlacement id=profil ng-mouseenter="mainCtrl.notHide = true" ng-mouseleave="mainCtrl.notHide = false" style="display: flex; align-items: center; justify-content: center; position: relative;"><button type=button style="font-family: var(--renaultFontRegular) !important; font-size:14px !important;background: #F2EDE4; color: #222; border-radius: 16px; width: 24px; height: 24px; border: none; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.12);top: -5px; padding: 8px 6px;">{{mainCtrl.user.firstName.charAt(0)}}{{mainCtrl.user.lastName.charAt(0)}}</button><div class=profile-dropdown ng-show=mainCtrl.notHide><ul style="display: block;"><li class=profile-dropdown-item ng-click="mainCtrl.goToDesyre(\'profile\')"><span class=profile-dropdown-icon><img src=./assets/svg/newHeader/user.svg alt="user icon" style="height:20px; width:20px; vertical-align:middle;filter: invert(1);"> </span><span class=profile-dropdown-text>{{\'MY_PROFILE\' | translate}}</span></li><li id=ngdisconnect class=profile-dropdown-item ng-click=mainCtrl.disconnect()><span class=profile-dropdown-icon><i class=icon-icons_logout style="font-size: 20px;"></i> </span><span class=profile-dropdown-text>{{\'DISCONNECT\' | translate}}</span></li></ul></div></li></ul></section></nav></div></div><!--Popin alerts--><phx-alerts ng-if=mainCtrl.popinVisibility.status></phx-alerts><!--<location-alerts></location-alerts>--><phx-comments ng-if=mainCtrl.commentsPopinVisibility.status></phx-comments><!-- UI-VIEW ENTRY POINT --><div ui-view class=uiTemplate ng-class=mainCtrl.getUIMainClass()></div><footer class="phnxFooter row" ng-style="{\'background\': mainCtrl.nissanUserURL ? \'#C3002F\' : \'\' }" ng-class="{\'footer-hidden\': !showFooter}"><!-- FCT REMOVED UNTIL DEVELOPED --><!-- ADD THE UI-SREF + remove class inactif TO RE-ACTIVATE --><!-- ui-sref="phenix.listAlerts" --><!--div class="left left-border inactif">{{\'FOOTER_FOLLOW_ALERT\'|translate}}</div--><div class="right no-print newFooter" id=newFooter ng-if=!mainCtrl.nissanUserURL><div><a target=_blank ng-href="{{mainCtrl.ndDataPolicyUrlisActive ?   mainCtrl.ndDataPolicyUrl  : \'#\'}}" ng-class="{\'inactive\':!mainCtrl.ndDataPolicyUrlisActive}">{{\'FOOTER_DATA_POLICY\' | translate}}</a></div><div style="border-left: 2px solid white; height: 20px;"></div><div class=left-border><a target=_blank ng-href="{{mainCtrl.ndCguFileUrlisActive ?  mainCtrl.ndCguFileUrl  : \'#\'}}" ng-class="{\'inactive\':!mainCtrl.ndCguFileUrlisActive}">{{\'FOOTER_CGU\' | translate}}</a></div><div style="border-left: 2px solid white; height: 20px;"></div><div class=left-border><a target=_blank ng-href="{{mainCtrl.ndCookiesUrlisActive ?  mainCtrl.ndCookiesUrl  : \'#\'}}" ng-class="{\'inactive\':!mainCtrl.ndCookiesUrlisActive}">{{\'FOOTER_COOKIES\' | translate}}</a></div><div style="border-left: 2px solid white; height: 20px;"></div><div class=left-border>{{::mainCtrl.version}}</div><div class=left-border style="position: relative;top: -5px;" id=footerContent></div></div><div class="right no-print newFooter" id=newFooter ng-if=mainCtrl.nissanUserURL><div>{{::mainCtrl.version}}</div><div style="position: relative;" id=footerContent></div></div></footer><div style="visibility: hidden"><div class=md-dialog-container id=btDialog><md-dialog><div class="centered-div documents-table"><bt-documents docs=mainCtrl.listOfBTDocuments from-search=true ng-if=mainCtrl.atLeastTwoBTDocument></bt-documents></div></md-dialog></div></div></div>');
$templateCache.put('app/main/ndHelp.template.html','<div id=ndHelpContent><div><div class="columns small-12 medium-12 large-12 PaddLeftRight0 menu_nav top-menu-bar"><div class="columns small-11 medium-11 large-11 PaddLeftRight0"><div align=left class=top-header><span class=groupe-header><strong>GROUPE</strong></span> <span class=color-white><strong>RENAULT</strong></span></div></div><div class="columns small-1 medium-1 large-1 PaddLeftRight0"><div align=center class=lang-label ng-click=ndhelpctrl.languagePoupup()><a class="color-white label-underline">{{ndhelpctrl.langName}}</a><!-- <span ng-class="{\' iconRight2 icon-icons_arrow_top\':ndhelpctrl.showLangPop ,\'iconRight2 icon-icons_arrow_bottom\':!ndhelpctrl.showLangPop}"></span> --></div></div></div></div><div class="columns small-12 medium-12 large-12 PaddLeftRight0 ndhelp-background" ng-init=ndhelpctrl.loadLanguage()><div class="color-white welcome-label">{{"LBL_WELCOME"|translate}}</div><div class=leftMenuDocz ng-class="(ndhelpctrl.langCode == \'fr\' || ndhelpctrl.langCode == \'de\' || ndhelpctrl.langCode == \'it\'||ndhelpctrl.langCode == \'en\') ? \'ndHelpDocxMenu\':\'ndHelpDocz\'"><div class="large-9 title_head" ng-click=ndhelpctrl.showRightContent(first) ng-hide="((first.label == \'ORDERING_MODULE\' && (ndhelpctrl.langCode != \'fr\' && ndhelpctrl.langCode != \'de\' && ndhelpctrl.langCode != \'it\' && ndhelpctrl.langCode != \'en\')) || (first.label == \'EXTERNAL_APP_DOCUMENTS\' && ndhelpctrl.langCode != \'de\') || (first.label == \'DOCPRIV_LABEL\' && ndhelpctrl.langCode != \'fr\' && ndhelpctrl.langCode != \'en\') || (first.label == \'TRACE_LINK\' && ndhelpctrl.langCode != \'de\'))" ng-class="{\'bgYellow\':first.label == ndhelpctrl.selectedLeftMenu.label, \'title_head\':(ndhelpctrl.langCode != \'fr\' || ndhelpctrl.langCode != \'de\' || ndhelpctrl.langCode != \'it\'||ndhelpctrl.langCode != \'en\'), \'menuContent\':(ndhelpctrl.langCode == \'fr\' || ndhelpctrl.langCode == \'de\' || ndhelpctrl.langCode == \'it\'|| ndhelpctrl.langCode == \'en\')}" ng-repeat="first in ndhelpctrl.leftMenuArray"><span class=iconeEclate><img class=Icon-ndhelp ng-class="{\'external_Docx\':first.label == \'EXTERNAL_APP_DOCUMENTS\'}" ng-src={{first.img}}> </span><span class=label_menu_1>{{first.label | translate | capitalize}}</span></div></div><div layout=row class=row style="max-width:100% !important;" ng-repeat="lang in ndhelpctrl.languagesList"><md-card layout=column ng-class="{\'rightMenuHeight\' : ((ndhelpctrl.langCode == \'fr\' || ndhelpctrl.langCode == \'de\' || ndhelpctrl.langCode == \'it\'|| ndhelpctrl.langCode == \'en\') && (ndhelpctrl.selectedLeftMenu.label != \'ND_LABEL\' && ndhelpctrl.selectedLeftMenu.label != \'ND_DMS_MODE\')), \'rightMenuBoxHeight\': ((ndhelpctrl.langCode != \'fr\' && ndhelpctrl.langCode != \'de\' && ndhelpctrl.langCode != \'it\' && ndhelpctrl.langCode != \'en\') && (ndhelpctrl.selectedLeftMenu.label != \'ND_LABEL\' && ndhelpctrl.selectedLeftMenu.label != \'ND_DMS_MODE\'))}" class="large-4 medium-4 small-12 rightDocz" ng-if="lang.langCode == ndhelpctrl.langCode" ng-hide="((ndhelpctrl.selectedLeftMenu.label == \'ORDERING_MODULE\' && (ndhelpctrl.langCode != \'fr\' && ndhelpctrl.langCode != \'de\' && ndhelpctrl.langCode != \'it\' && ndhelpctrl.langCode != \'en\')) || (ndhelpctrl.selectedLeftMenu.label == \'EXTERNAL_APP_DOCUMENTS\' && ndhelpctrl.langCode != \'de\'))"><md-card-title><md-card-title-text><span class=md-headline><img class=width-8 ng-src={{ndhelpctrl.selectedLeftMenu.rightMenuImg}} ng-class="{\'externalDocz\':(ndhelpctrl.selectedLeftMenu.label == \'EXTERNAL_APP_DOCUMENTS\')}"><span class=card-header>{{ndhelpctrl.selectedLeftMenu.label === \'TRACE_LINK\' ? (\'TRACE\' | translate) : (ndhelpctrl.selectedLeftMenu.label | translate)}}</span></span></md-card-title-text></md-card-title><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'DOCPRIV_LABEL\'"><div ng-repeat="pdf5 in lang.pdfList.docpriv "><div ng-if=!pdf5.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{pdf5.file}} target=_blank>{{pdf5.file}}</a></span></div></div></md-card-content><md-card-content ng-if="ndhelpctrl.selectedLeftMenu.label == \'ND_LABEL\'"><div ng-repeat="video in lang.videoList "><div ng-click=ndhelpctrl.getVideo(video.videoUrl) style="position: relative;"><span class="leftHandPosition cursor-pointer" ng-if=video.videoUrl><i class="fa fa-play-circle fa-style"></i></span> <span><span class="labelSize pl-5" ng-style="video.videoUrl && { cursor: \'pointer\'}">{{video.video}}</span></span></div></div><div ng-repeat="pdf1 in lang.pdfList.quickStartList"><div ng-if=pdf1.folderName><span class=leftHandPosition><img class="Icon-ndhelp width-4-5" src=../assets/images/file.png alt=""> </span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{pdf1.folderName}}/{{pdf1.file}} target=_blank>{{pdf1.file}}</a></span></div><div ng-if=!pdf1.folderName><span class=leftHandPosition><img class="Icon-ndhelp width-4-5" src=../assets/images/file.png alt=""> </span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{pdf1.file}} target=_blank>{{pdf1.file}}</a></span></div></div></md-card-content><md-card-content ng-if="ndhelpctrl.selectedLeftMenu.label == \'ND_DMS_MODE\'"><div ng-if="lang.langCode == ndhelpctrl.langCode && lang.pdfList.dmsVideos && (ndhelpctrl.langCode == \'es\' || ndhelpctrl.langCode == \'fr\')" ng-repeat="video in lang.pdfList.dmsVideos"><div ng-click=ndhelpctrl.getVideo(video.videoUrl) style="position: relative;"><span class="leftHandPosition cursor-pointer" ng-if=video.videoUrl><i class="fa fa-play-circle fa-style"></i></span> <span><span class="labelSize pl-5" ng-style="video.videoUrl && {cursor: \'pointer\'}">{{video.video}}</span></span></div></div><div ng-repeat="pdf3 in lang.pdfList.dmsList "><div><span class=leftHandPosition><img class="Icon-ndhelp width-4-5" src=../assets/images/file.png alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{pdf3.file}} target=_blank>{{pdf3.file}}</a></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'NEW_ACTIS\'"><div ng-repeat="pdf4 in lang.pdfList.actis "><div ng-if=pdf4.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{pdf4.folderName}}/{{pdf4.file}} target=_blank>{{pdf4.file}}</a></span></div><div ng-if="!pdf4.folderName && !pdf4.swayUrl"><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{pdf4.file}} target=_blank>{{pdf4.file}}</a></span></div><div ng-if=pdf4.swayUrl><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/externalDocx.png style="width: 3.5%;left: 4px;position: relative;" alt=""></span><span style="padding-left: 12px !important;"><a class=labelSize ng-href={{pdf4.swayUrl}} target=_blank>{{pdf4.file}}</a></span></div></div></md-card-content><md-card-content ng-if="ndhelpctrl.selectedLeftMenu.label == \'DIAG_SEARCH\'"><div ng-repeat="pdf2 in lang.pdfList.diagSearchList track by $index"><div ng-if=pdf2.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{pdf2.folderName}}/{{pdf2.file}} target=_blank>{{pdf2.file}}</a></span></div><div ng-if=!pdf2.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{pdf2.file}} target=_blank>{{pdf2.file}}</a></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'EASY_BASKET_OPERATIONS\'"><div ng-if=lang.pdfList.easyBasket ng-repeat="basket in lang.pdfList.easyBasket"><div ng-click=ndhelpctrl.getVideo(basket.videoUrl) style="position: relative;" ng-if=basket.videoUrl><span class="leftHandPosition cursor-pointer"><i class="fa fa-play-circle fa-style"></i></span> <span><span class="labelSize pl-5" ng-style="basket.videoUrl && {cursor: \'pointer\'}">{{basket.video}}</span></span></div><div ng-if=!basket.videoUrl style="margin-bottom: 5px;"><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""> </span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{basket.file}} target=_blank>{{basket.file}}</a></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'ORDERING_MODULE\'"><div ng-if=lang.pdfList.orderingModule ng-repeat="omPdf in lang.pdfList.orderingModule"><div ng-if=!omPdf.videoUrl style="margin-bottom: 5px;"><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""> </span><span ng-hide="((ndhelpctrl.user.country == \'AT\' && ndhelpctrl.langCode == \'de\') || (ndhelpctrl.user.country == \'CH\' && ndhelpctrl.langCode == \'it\'))"><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{omPdf.file}} target=_blank>{{omPdf.file}}</a> </span><span ng-if="(ndhelpctrl.user.country == \'AT\' && ndhelpctrl.langCode == \'de\')"><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{ndhelpctrl.atOMFile}} target=_blank>{{ndhelpctrl.atOMFile}}</a> </span><span ng-if="(ndhelpctrl.user.country == \'CH\' && ndhelpctrl.langCode == \'it\')"><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{ndhelpctrl.chOMFile}} target=_blank>{{ndhelpctrl.chOMFile}}</a></span></div><div ng-click=ndhelpctrl.getVideo(omPdf.videoUrl) style="position: relative;" ng-if=omPdf.videoUrl><span class="leftHandPosition cursor-pointer"><i class="fa fa-play-circle fa-style"></i></span> <span><span class="labelSize pl-5" ng-style="omPdf.videoUrl && {cursor: \'pointer\'}">{{omPdf.video}}</span></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'EXTERNAL_APP_DOCUMENTS\'"><div ng-repeat="extDocx in lang.pdfList.externalAppDocx "><div><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{extDocx.file}} target=_blank>{{extDocx.file}}</a></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'CONNECTED_SERVICES_ND_HELP\'"><div ng-repeat="conServices in lang.pdfList.connectedServices "><div ng-if=!conServices.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{lang.langCode}}/{{conServices.file}} target=_blank>{{conServices.designation}}</a></span></div><div ng-if=conServices.folderName><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/file.png style="width: 4.5%;" alt=""></span><span><a class="labelSize pl-5" ng-href={{ndhelpctrl.trustedSrcUrl()}}{{conServices.folderName}}/{{conServices.file}} target=_blank>{{conServices.file}}</a></span></div></div></md-card-content><md-card-content layout=column class=large-12 ng-if="ndhelpctrl.selectedLeftMenu.label == \'TRACE_LINK\'"><div ng-repeat="pdf4 in lang.pdfList.trace "><div ng-if=pdf4.swayUrl><span class=leftHandPosition><img class=Icon-ndhelp src=../assets/images/externalDocx.png style="width: 3.5%;left: 4px;position: relative;" alt=""></span><span style="padding-left: 12px !important;"><a class=labelSize ng-href={{pdf4.swayUrl}} target=_blank>{{pdf4.file}}</a></span></div></div></md-card-content></md-card></div></div></div><div style="visibility: hidden;"><div class="PopUpVER md-dialog-container color-black" id=langPopup><md-dialog class=lang-popup><div class="columns small-12 medium-12 large-12 PopUpBody PaddingLeftRight"><div ng-repeat="lang in ndhelpctrl.langCodeList track by $index" ng-switch on="$index % 2" class="columns small-12 medium-12 large-12 padding-0"><span ng-switch-when=0 class="columns large-6 medium-6 small-12 padding-0"><a ng-click=ndhelpctrl.selectedLanguage(ndhelpctrl.langCodeList[$index].langCode) class=lang_hover>{{ndhelpctrl.langCodeList[$index].langName}}</a> </span><span ng-switch-when=0 class="columns large-6 medium-6 small-12 padding-0"><a ng-click=ndhelpctrl.selectedLanguage(ndhelpctrl.langCodeList[$index+1].langCode) class=lang_hover><span ng-show=ndhelpctrl.langCodeList[$index+1]>{{ndhelpctrl.langCodeList[$index+1].langName}}</span></a></span></div></div></md-dialog></div></div>');
$templateCache.put('app/main/ndHelpVideo.html','<div class="columns small-12 medium-12 large-12 PaddLeftRight0" style="width: 75vw;\nheight: 79vh;"><!-- <div class="columns small-1 medium-1 large-1 PaddLeftRight0">\n        <button id="IDButCancel" class="okCancelButton okCancelBtn MarginTop lbl_cancel"\n            ng-click="goHome()">Back</button>\n    </div> --><div class="columns small-11 medium-11 large-11 PaddLeftRight0"><iframe id=iframeVideo ng-src={{vm.trustedSrc(vm.videoUrl.src)}} allowfullscreen=allowFullScreen allow="autoplay; encrypted-media" style="width: 70vw;\n            height: 75vh;"></iframe></div></div>');
$templateCache.put('app/main/supportIndependentPop.html','<div class=supportIndependentPop><div ng-if="vm.language != \'fr\'"><p>For any technical assistance request, please email the following address:</p><p class=heighlightText style="padding-bottom: 10px;">assistance.technique@renault.com</p><p>Prior to your technical assistance request, make sure that the diagnosis prerequisites are met, otherwise we will not be able to support you in your diagnosis.</p><p class=heighlightText style="padding-top: 10px;">Prerequisites:</p><p>\u2022 The vehicle must be present in the workshop</p><p>\u2022 The vehicle\u2019s brand is Renault, Dacia or Alpine</p><p>\u2022 The spare part is new and from Renault, Dacia, Alpine or Motrio</p><p>\u2022The identification number (VIN) of the vehicle must be recognised by Renault\u2019s main server</p><p>\u2022The stored default codes in the vehicles computer must be recognized by Renault\u2019s main server</p><p>\u2022The vehicle must be recognized electronically within the Renault Technical documentation</p><p>\u2022 You are a professional automotive repairer with a current VAT number</p><p>\u2022 You are trained as a vehicle or body repair technician with a recognised automotive qualification</p><p>\u2022 You have a suitable vehicle management diagnostic tool capable of reading stored defect codes in the vehicle\u2019s computer</p><p>\u2022 You must have consulted the vehicle technical documentation (repair manual, electrical diagram, \u2026) in New Dialogys</p></div><div ng-if="vm.language == \'fr\'"><p>Pour toute demande d\'assistance technique, veuillez adresser un mail \xE0 l\'adresse suivante :</p><p class=heighlightText style="padding-bottom: 10px;">assistance.technique@renault.com</p><p>Pr\xE9alablement \xE0 votre demande d\u2019assistance technique, veuillez-vous assurer que les pr\xE9-requis du diagnostic sont respect\xE9s, dans le cas contraire, nous ne serons pas en mesure de vous accompagner dans votre diagnostic.</p><p class=heighlightText style="padding-top: 10px;">Pr\xE9-Requis :</p><p>\u2022Le v\xE9hicule doit \xEAtre pr\xE9sent dans l\u2019atelier</p><p>\u2022Le v\xE9hicule est de marque Renault ou Dacia</p><p>\u2022La pi\xE8ce de rechange est neuve et de marque Renault ou Dacia ou Motrio</p><p>\u2022Le num\xE9ro de s\xE9rie du v\xE9hicule doit \xEAtre reconnu par les syst\xE8mes informatiques Renault</p><p>\u2022Les codes d\xE9fauts dans le ou les calculateurs sont reconnus par les syst\xE8mes informatiques Renault</p><p>\u2022Le mod\xE8le du v\xE9hicule doit \xEAtre r\xE9f\xE9renc\xE9 et num\xE9ris\xE9 dans la documentation technique Renault</p><p>\u2022Vous \xEAtes un r\xE9parateur professionnel de l\u2019automobile avec un num\xE9ro TAV intracommunautaire</p><p>\u2022Vous avez une formation de m\xE9canicien ou de carrossier Vous disposez d\u2019un outil \xE9lectronique de diagnostic capable de lire les trames codes d\xE9fauts dans les calculateurs</p><p>\u2022Vous devez avoir consult\xE9 la documentation technique du v\xE9hicule (manuel de r\xE9paration, sch\xE9ma \xE9lectrique,...) dans New Dialogys</p></div><div class="confirmbutton text-center"><button class=buttonWithIcon ng-click=vm.close()><div class=iconDiv><i class="fa fa-check"></i></div><div class=btnText>{{\'OK_INDEPENDENT\' | translate }}</div></button></div></div>');
$templateCache.put('app/components/actis/actis.template.html','<!-- BLOC RECAP CAR --><div class=containerView id=createFic><!-- BLOC HEADER --><header-actis is-draft=vm.isDraft non-modifiable-fic=vm.nonModifiableFic is-fic-being-modified=vm.isFicBeingModified is-fic-creation=vm.isFicCreation is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories is-for-qstomize=vm.isForQstomize is-alert-fic=vm.isAlert></header-actis><div ng-if="vm.isFicCreation && !vm.isIndependentUser && !vm.isForBwr && !vm.isForPaint && !vm.isForAccessories && !vm.isForQstomize"><div ng-if=vm.isChatBotDealerAccess><chatbot></chatbot></div><fic-type-actis on-update-type-fic=vm.onUpdateTypeFic activate-actis-accessories-and-paint=vm.activateActisAccessoriesAndPaint></fic-type-actis></div><div ng-if=vm.isForBwr><div class=row><div class="small-8 columns no-padding"><battery-details response-api=vm.responseApi is-fic-creation=vm.isFicCreation non-modifiable-fic=vm.nonModifiableFic is-edit-mode=vm.isEditMode is-draft=vm.isDraft is-days-to-reopen=vm.isDaysToReopen is-fic-reopen=vm.isFicReopen is-for-bwr=vm.isForBwr is-fic-cancelled=vm.isFicCancelled is-independent-user=vm.isIndependentUser></battery-details><request-details response-api=vm.responseApi is-fic-creation=vm.isFicCreation is-for-bwr=vm.isForBwr is-status-present=vm.isStatusPresent non-modifiable-fic=vm.nonModifiableFic is-edit-mode=vm.isEditMode is-draft=vm.isDraft save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-days-to-reopen=vm.isDaysToReopen is-fic-cancelled=vm.isFicCancelled is-independent-user=vm.isIndependentUser></request-details><discussion-actis ng-show=vm.showDiscussionBlock() on-update-comment=vm.onUpdateComment is-edit-mode=vm.isEditMode response-api=vm.responseApi non-modifiable-fic=vm.nonModifiableFic is-fic-reopen=vm.isFicReopen is-draft=vm.isDraft is-for-bwr=vm.isForBwr is-discussion-comment-box=vm.isDiscussionCommentBox is-days-to-reopen=vm.isDaysToReopen></discussion-actis></div><div class="small-3 columns no-padding"><fic-details type=brw save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic re-open-fic=vm.reOpenFic is-send-button-visible=vm.isSendButtonVisible is-edit-mode=vm.isEditMode response-api=vm.responseApi closed-status-fic=vm.closedStatusFic is-fic-reopen=vm.isFicReopen is-discussion-comment-box=vm.isDiscussionCommentBox is-days-to-reopen=vm.isDaysToReopen re-open-fic=vm.reOpenFic></fic-details></div></div></div><div ng-if=vm.isForPaint><div class=row><div class="small-8 columns no-padding"><paint-details></paint-details></div><div class="small-3 columns no-padding"><fic-details type=paint save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-edit-mode=vm.isEditMode response-api=vm.responseApi></fic-details></div></div></div><div ng-if=vm.isForAccessories><div class=row><div class="small-8 columns no-padding"><new-accessories></new-accessories></div><div class="small-3 columns no-padding"><fic-details type=accessories save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-edit-mode=vm.isEditMode response-api=vm.responseApi></fic-details></div></div></div><div ng-if=vm.isForQstomize><div class=row style="margin-bottom: 1%;"><span style="font-size: var(--renaultMediumFont);" class=descBRW>{{\'QSTOMIZE_MSG\' | translate}}</span></div><div class=row><div class="small-8 columns no-padding"><vehicle-actis type=qstomize remove-button-to-recap-car=vm.removeButtonToRecapCar response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-load-fic=vm.isLoadFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-for-qstomize=vm.isForQstomize is-independent-user=vm.isIndependentUser></vehicle-actis><qstomize-details type=qstomize is-fic-reopen=vm.isFicReopen is-fic-cancelled=vm.isFicCancelled is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories non-modifiable-fic=vm.nonModifiableFic template=attachment response-api=vm.responseApi is-edit-mode=vm.isEditMode is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-draft=vm.isDraft is-actis-from-diag=vm.isActisFromDiag is-independent-user=vm.isIndependentUser is-for-qstomize=vm.isForQstomize></qstomize-details></div></div></div><!-- BLOC GENERAL --><div ng-if="!vm.isFicCreation && !vm.isForBwr && !vm.isForPaint && !vm.isForAccessories" style=margin-bottom:2%;><div><general-actis on-update-type-fic=vm.onUpdateTypeFic on-load-page=vm.onLoadPage is-draft=vm.isDraft save-fic=vm.saveFic is-delete-button-visible=vm.isDeleteButtonVisible response-api=vm.responseApi closed-status-fic=vm.closedStatusFic is-edit-mode=vm.isEditMode is-for-bwr=vm.isForBwr is-answered=vm.isAnswered non-modifiable-fic=vm.nonModifiableFic activate-actis-accessories-and-paint=vm.activateActisAccessoriesAndPaint load-fic=vm.loadFic is-fic-reopen=vm.isFicReopen is-for-paint=vm.isForPaint selected-fic-type-id=vm.selectedFicTypeId is-fic-cancelled=vm.isFicCancelled re-open-fic=vm.reOpenFic cancel-fic=vm.cancelFic is-send-button-visible=vm.isSendButtonVisible is-save-button-visible=vm.isSaveButtonVisible is-delete-button-visible=vm.isDeleteButtonVisible is-independent-user=vm.isIndependentUser is-brw=vm.isBrw is-for-accessories=vm.isForAccessories is-actis-from-diag=vm.isActisFromDiag is-for-qstomize=vm.isForQstomize on-delete-fic=vm.onDeleteFic is-discussion-comment-box=vm.isDiscussionCommentBox is-days-to-reopen=vm.isDaysToReopen></general-actis></div><div class=row ng-if="vm.showBlocs "><div class="small-12 columns no-padding leftBlocActis" style=width:70%;><!-- BLOC VEHICLE --><div class="small-12 columns"><vehicle-actis ng-if=vm.isPainting type=painting remove-button-to-recap-car=vm.removeButtonToRecapCar response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-load-fic=vm.isLoadFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></vehicle-actis><vehicle-actis ng-if=vm.isAccessoires type=accessory remove-button-to-recap-car=vm.removeButtonToRecapCar response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-load-fic=vm.isLoadFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></vehicle-actis><vehicle-actis ng-if=vm.isZeBattery type=zeBattery remove-button-to-recap-car=vm.removeButtonToRecapCar response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-load-fic=vm.isLoadFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></vehicle-actis><vehicle-actis ng-if="vm.isTechnicalAssistance || vm.isCalm || vm.isAdministrative || vm.isApproval || vm.isGoodPractise || vm.isAlert || vm.isPilote" type=others remove-button-to-recap-car=vm.removeButtonToRecapCar response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-load-fic=vm.isLoadFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></vehicle-actis></div><!-- BLOC AGREMENT --><div class="small-12 columns" ng-if=vm.isApproval><agrement-actis non-modifiable-fic=vm.nonModifiableFic is-edit-mode=vm.isEditMode response-api=vm.responseApi ng-if=vm.isEditMode is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft></agrement-actis></div><!-- BLOC ACCESSORES --><div class="small-12 columns" ng-if=vm.isAccessoires><accessoires-actis non-modifiable-fic=vm.nonModifiableFic is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft></accessoires-actis></div><!-- BLOC PAINTING --><div class="small-12 columns" ng-if=vm.isPainting><painting-actis non-modifiable-fic=vm.nonModifiableFic is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft></painting-actis></div><!-- BLOC RESOLUTION --><div class="small-12 columns" ng-if=vm.isClosed><resolution-actis></resolution-actis></div></div><div class="small-12 columns leftBlocActis" style="width:70%; float:left !important;"><!-- BLOC DESCRIPTION --><description-actis ng-if=vm.isPainting type=painting response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></description-actis><description-actis ng-if=vm.isAccessoires type=accessory response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></description-actis><description-actis ng-if=vm.isZeBattery type=zeBattery response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen></description-actis><description-actis ng-if="vm.isTechnicalAssistance || vm.isCalm || vm.isAdministrative || vm.isApproval || vm.isGoodPractise || vm.isAlert || vm.isPilote" type=others response-api=vm.responseApi is-edit-mode=vm.isEditMode non-modifiable-fic=vm.nonModifiableFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-actis-from-diag=vm.isActisFromDiag is-draft=vm.isDraft is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories is-independent-user=vm.isIndependentUser is-days-to-reopen=vm.isDaysToReopen is-approval-fic=vm.isApproval is-technical-assistance-fic=vm.isTechnicalAssistance is-alert-fic=vm.isAlert is-good-practise-fic=vm.isGoodPractise is-pilote-fic=vm.isPilote is-administrative-fic=vm.isAdministrative is-calm-fic=vm.isCalm></description-actis></div><div class="small-12 columns" ng-if="vm.showDiscussionBlock() && vm.isForBwr" style=width:70%;float:left;><!-- BLOC DISCUSSION --><discussion-actis non-modifiable-fic=vm.nonModifiableFic on-update-comment=vm.onUpdateComment response-api=vm.responseApi is-edit-mode=vm.isEditMode is-fic-reopen=vm.isFicReopen is-for-bwr=vm.isForBwr is-draft=vm.isDraft is-discussion-comment-box=vm.isDiscussionCommentBox is-days-to-reopen=vm.isDaysToReopen></discussion-actis></div><div class="small-12 columns" ng-if="vm.showDiscussionBlock() && !vm.isForBwr" style=width:70%;float:left;><!-- BLOC DISCUSSION --><discussion-actis non-modifiable-fic=vm.nonModifiableFic on-update-comment=vm.onUpdateComment response-api=vm.responseApi is-edit-mode=vm.isEditMode is-fic-reopen=vm.isFicReopen is-for-bwr=vm.isForBwr is-draft=vm.isDraft is-for-qstomize=vm.isForQstomize is-discussion-comment-box=vm.isDiscussionCommentBox is-days-to-reopen=vm.isDaysToReopen></discussion-actis></div></div></div></div>');
$templateCache.put('app/components/basket/declareToRenault.html','<md-dialog id=dialogBox><div class=modalPhenix><div class=row><div class="small-6 column title" style="font-weight: bold">{{\'OPERATIONAL_DETAILS\' | translate}}</div></div><div class=description style="font-size: var(--renaultMediumFont);">{{\'OPERATIONAL_DETAILS_MESSAGE\' | translate }}</div><div style="color: red; font-size: var(--renaultMediumFont);">{{\'QUESTIONNING_MANDATORY\' | translate}}</div><div style="width: 100%;" class=texts ng-if="vm.maintenanceProgram && vm.isIndependantUser"><div style=margin-bottom:-57px><md-input-container type=text class="medium-8 dateOfOperation" id=dateOfOperation><label style=left:3px>{{\'DATE_OF_THE_OPERATION\' | translate}}</label><md-datepicker type=date ng-change=vm.onChange(vm.startDate) ng-model=vm.startDate></md-datepicker></md-input-container></div><div style=padding-left:320px><input type=number id=mileage ng-model=vm.operationalDetailsMileage ng-change=vm.onChange(vm.operationalDetailsMileage) class="medium-8 textAreas" placeholder="{{\'MILEAGE\' | translate}}"></div><input type=text id=factureNumber ng-model=vm.operationalDetailsFacture ng-change=vm.onChange(vm.operationalDetailsFacture) class="medium-8 displayIn textAreas" placeholder="{{\'FACTURE_NUMBER\' | translate}}"> <input type=text id=titleValue ng-model=vm.operationalDetailsTitle ng-change=vm.onChange(vm.operationalDetailsTitle) class="medium-8 displayIn textAreas" placeholder="{{\'TITLE_LABEL\' | translate}}"> <select class="medium-8 textAreas" id=levelOneValue ng-change=vm.chooseNodeLevelOne(vm.levelOneNode) ng-model=vm.levelOneNode ng-options="page for page in vm.levelOne"><option value="" disabled=disabled selected=selected hidden>{{\'DISPLAY_FUNCTIONS\' | translate}}</option></select> <select class="medium-8 textAreas levelTwoDisplay" id=levelTwoValue ng-change=vm.chooseNodeLevelTwo(vm.arrNodeslvl) ng-model=vm.arrNodeslvl ng-options="page for page in vm.arrNodesLevel1"></select><md-select style=width:80%; multiple=multiple class="medium-8 textAreas" ng-class="{\'invalid-field\': vm.elementsOperationsInvalid}" id=elementsOperationsValue ng-change=vm.operationText(vm.arrNodesElm) ng-model=vm.arrNodesElm placeholder="{{\'ELEMENTS_OPERATIONS\' | translate}}"><md-option ng-value=page ng-repeat="page in vm.arrNodesElement">{{page}}</md-option></md-select><textarea type=text style=width:80% rows=6 id=descriptionValue class="medium-8 displayIn textAreas" placeholder="{{\'OPERATIONAL_DESCRIPTION\'|translate}}" ng-change=vm.onChange(vm.operationalDetailsDescription) ng-model=vm.operationalDetailsDescription>\n        </textarea></div><div class=texts ng-if=!vm.maintenanceProgram><md-input-container type=text class="medium-8 dateOfOperationCart" id=dateOfOperation><label class=operationLabel>{{\'DATE_OF_THE_OPERATION\' | translate}}</label><md-datepicker type=date ng-change=vm.onChange(vm.startDate) ng-model=vm.startDate></md-datepicker></md-input-container><input type=number id=mileage ng-model=vm.operationalDetailsMileage ng-change=vm.onChange(vm.operationalDetailsMileage) class="medium-8 textAreasCart" placeholder="{{\'MILEAGE\' | translate}}"> <input type=text id=invoiceNumber ng-if=!vm.maintenanceProgram ng-model=vm.operationalDetailsInvoice ng-change=vm.onChange(vm.operationalDetailsInvoice) class="medium-8 textAreasCart" placeholder="{{\'INVOICE_NUMBER\' | translate}}"></div><div class=modalButtonsCart><button type=button class="buttonWithIcon left" ng-click=vm.onValidate()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/basket/delete-dialog.template.html','<div id=delete-modal><div class=title><span ng-if="!vm.isIntervention && !vm.isDelete && !vm.enableRemote && !vm.enableLaunch">{{\'BASKET_DELETE_REF\' | translate}}</span> <span ng-if="!vm.isIntervention && vm.isDelete">{{\'BASKET_DELETE_OPERATION\' | translate}}</span> <span ng-if=vm.isIntervention>{{\'INTERVENTION_DELETE_REF\' | translate}}</span></div><span ng-if=vm.enableRemote>{{\'CONSULT_VIN\' | translate}} {{vm.vinNumber}}</span> <span ng-if=vm.enableLaunch>{{\'LAUNCH_DIAG\' | translate}} {{vm.vin}}</span><div class=piece><div class=ref>{{vm.code}}</div><div class=description>{{vm.designation}}</div></div><div class=actionButton ng-class="{\'text-center\': vm.enableRemote || vm.enableLaunch}"><button type=button class="buttonWithIcon cancel" ng-click=vm.onConfirm() ng-if="!vm.enableRemote && !vm.enableLaunch"><div class=iconDiv><i class="icon-icons_remove icon-icons_remove-adjusted"></i></div><div class="btnText btnText-delete-adjusted">{{\'COMMON_DELETE\' | translate}}</div></button> <button type=button class=buttonWithIcon ng-if="vm.enableRemote || vm.enableLaunch" ng-click="(vm.enableRemote ? vm.OnConfirmVin(vm.vinNumber) : vm.OnConfirmLaunch(vm.vin))"><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{ \'COMMON_YES\' | translate }}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary-adjusted"></i></div><div class="btnText btnText-cancel-adjusted-modal">{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/basket/panier.html','<div id=panier><!-- =====================\n            HEADER\n    ====================== --><div class="row headerPanier"><div class="small-1 columns btnBack"><div class=backPanier ng-click=panierCtrl.goBack()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-4 columns"><label class=labelNumPanier>{{\'LABEL_NUM_BASKET\' |translate}} {{panierCtrl.cartMedatadata.id}}</label><div class=labelValidateByCart><div ng-if=panierCtrl.cartMedatadata.creationDateTime><span translate=CART_CREATION translate-values="{\n                            date: (panierCtrl.cartMedatadata.creationDateTime | date: \'dd/MM/yyyy\'),\n                            person: panierCtrl.cartMedatadata.creator\n                        }"></span></div><div ng-if=panierCtrl.cartMedatadata.lastModificationDateTime><span translate=CART_MODIFICATION translate-values="{\n                        date: (panierCtrl.cartMedatadata.lastModificationDateTime | date: \'dd/MM/yyyy\'),\n                        person: panierCtrl.cartMedatadata.lastModifier\n                    }"></span></div></div></div><div class="small-5 columns listPanierAction"><div class=declareToRenault ng-if="panierCtrl.isIndependantUser && !panierCtrl.isSearchByModel && panierCtrl.isCarcontext" ng-click="!panierCtrl.cartMedatadata.declared && panierCtrl.declareToRenault()" ng-class="{\'inactif-container\' : (panierCtrl.cartMedatadata.declared || (!panierCtrl.cartMedatadata.declared && panierCtrl.panier.pr.length === 0 && panierCtrl.panier.tm.length === 0)), \n                            \'activeButton\': (!panierCtrl.cartMedatadata.declared && (panierCtrl.panier.pr.length >=1 || panierCtrl.panier.tm.length >=1))}"><img src=./assets/images/icons_check_actis.svg ng-class="{\'inactif\' : (panierCtrl.cartMedatadata.declared || (!panierCtrl.cartMedatadata.declared && panierCtrl.panier.pr.length === 0 && panierCtrl.panier.tm.length === 0)), \n                            \'activeButton\': (!panierCtrl.cartMedatadata.declared && (panierCtrl.panier.pr.length >=1 || panierCtrl.panier.tm.length >=1))}" class=declareTo alt=""> <label class=head ng-class="{\'inactif\' : (panierCtrl.cartMedatadata.declared || (!panierCtrl.cartMedatadata.declared && panierCtrl.panier.pr.length === 0 && panierCtrl.panier.tm.length === 0)), \n                           \'activeButton\': (!panierCtrl.cartMedatadata.declared && (panierCtrl.panier.pr.length >=1 || panierCtrl.panier.tm.length >=1))}">{{\'DECLARE_TO_RENAULT\' |translate}}</label></div><div ng-click=panierCtrl.saveCart() class=clickable ng-class="{\'disableIcon\':panierCtrl.areNewButtonsVisible}"><i class=icon-icons_save_panier></i> <label ng-class="{\'disableIcon\':panierCtrl.areNewButtonsVisible}">{{\'BUTTON_ESTIMATE_SAVE\' |translate}}</label></div><div class=clickable ng-click=panierCtrl.printCart() ng-if=!panierCtrl.areNewButtonsVisible><i class=icon-icons_print_panier></i> <label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div class=clickable ng-if=panierCtrl.areNewButtonsVisible><md-menu><div id=printIcon class=clickable ng-click=$mdMenu.open()><i class=icon-icons_print_panier></i></div><md-menu-content id=menuContent width=2><md-menu-item class=custom-label ng-click=panierCtrl.printCart(false)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_KO\' |translate}}</span></md-menu-item><md-menu-item class=custom-label ng-click=panierCtrl.printCart(true)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_OK\' |translate}}</span></md-menu-item></md-menu-content></md-menu><label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><!--<div>--><!--<i class="icon-icons_mail_panier"></i>--><!--<label>{{\'BUTTON_ESTIMATE_SEND\' |translate}}</label>--><!--</div>--><div ng-click="panierCtrl.cartMedatadata.id && panierCtrl.downloadCSV()" ng-class="{clickable: panierCtrl.cartMedatadata.id, unclickable: !panierCtrl.cartMedatadata.id, disableIcon: panierCtrl.areNewButtonsVisible}"><i class=icon-icons_export_csv_panier></i> <label ng-class="{\'disableIcon\':panierCtrl.areNewButtonsVisible}">{{\'BUTTON_ESTIMATE_EXPORT\' |translate}}</label></div><div ng-click=panierCtrl.closeCart() class=clickable><i class=icon-icons_close_big_panier></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><div class=row><div class="small-7 colums"><input aria-label=cart type=text maxlength=30 placeholder="{{\'CART_PLACEHOLDER_LABEL\'|translate}}" ng-model-options="{debounce: 500}" ng-model=panierCtrl.cartMedatadata.label ng-if=!panierCtrl.showGetPriceColumns> <input aria-label=order type=text maxlength=30 placeholder="{{\'ORDER_MARK\'|translate}}" ng-model-options="{debounce: 500}" ng-model=panierCtrl.cartMedatadata.label ng-if=panierCtrl.showGetPriceColumns></div></div><div class="row areatext"><div class="small-12 colums"><textarea rows=4 placeholder="*{{\'COMMON_TEXTAREA_PLACEHOLDER\'|translate}}" ng-model-options="{debounce: 500}" ng-model=panierCtrl.cartMedatadata.description ng-if=!panierCtrl.showGetPriceColumns></textarea> <textarea rows=4 placeholder="{{\'ORDER_DESCRIPTION_MESSAGE\'|translate}}" ng-model-options="{debounce: 500}" ng-model=panierCtrl.cartMedatadata.description ng-if=panierCtrl.showGetPriceColumns>\n            </textarea></div></div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic">{{\'RGPD_MESSAGE\' |translate}}</div></div><!-- ==============================\n            VEHICLE BANNER\n    =============================== --><div class=row ng-if=panierCtrl.vehicle><div class="small-12 columns blocVehiculeBandeauSelected"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader><label class=designationVehiculeBlocContext ng-bind-html=panierCtrl.bannerData></label> <label class=vinImatVehiculeBlocContext><span ng-if=panierCtrl.vehicle.vin ng-class="{\'vehicle-info-shifted\': panierCtrl.areNewButtonsVisible}">{{panierCtrl.vehicle.vin}}</span> <span ng-if="panierCtrl.vehicle.vin && panierCtrl.vehicle.registrationNumber" ng-class="{\'vehicle-info-shifted\': panierCtrl.areNewButtonsVisible}">|</span> <span ng-if=panierCtrl.vehicle.registrationNumber ng-class="{\'vehicle-info-shifted\': panierCtrl.areNewButtonsVisible}">{{panierCtrl.vehicle.registrationNumber}}</span></label></div><div class="vehicleOr estimateGroupContainer" ng-if="panierCtrl.showPricingSection && panierCtrl.areNewButtonsVisible"><label for=estimateGroupSelect class=estimateGroupLabel>{{\'ESTIMATE_GROUP\' | translate}}</label><div id=estimateGroupSelect class="en_bas custom-select-wrapper" ng-class="{\'open\': panierCtrl.estimateGroupDropdownOpen}"><div class=custom-select-overlay ng-if=panierCtrl.estimateGroupDropdownOpen ng-click="panierCtrl.estimateGroupDropdownOpen = false"></div><div class=custom-select-trigger ng-click="panierCtrl.estimateGroupDropdownOpen = !panierCtrl.estimateGroupDropdownOpen; $event.stopPropagation()"><span>{{ panierCtrl.quote.selectedPricingDetails.designation }}</span> <span class=custom-select-arrow>&#9660;</span></div><div class=custom-select-options><div class=custom-select-option ng-repeat="option in panierCtrl.estimateGroupData track by option.id" ng-class="{\'is-selected\': panierCtrl.quote.selectedPricingDetails && panierCtrl.quote.selectedPricingDetails.id === option.id}" ng-click="panierCtrl.quote.selectedPricingDetails = option; panierCtrl.estimateGroupDropdownOpen = false; panierCtrl.onEstimateGroupChange(true); $event.stopPropagation()">{{ option.designation }}</div></div></div></div></div></div><div class="row border_grey" ng-if=panierCtrl.panier><!--Easy Basket Operation--><div ng-if=panierCtrl.panier.inter.length><div class=headerPRorTM><label class=label_pr>{{\'PARTLIST_TABLE_TITLE_SPLIT\' | translate | uppercase}}</label></div><div class="row contentTabListPRorTM" ng-repeat="inter in panierCtrl.panier.inter"><span style="margin-left: 7px; font-weight: bold; font-size: 20px; text-decoration: underline;">{{inter.designation}}</span> <span class="fa fa-trash deleteIcon" ng-click=panierCtrl.deleteByDesignation(inter,true) style="font-size: 20px;"></span> <span ng-if="inter.interQuantity > 1" class=qtyCircle>X{{inter.interQuantity}}<md-tooltip>{{\'SEVERAL_OPERATIONS\' | translate}}</md-tooltip></span><!-- INTER PR SECTION --><div ng-if="inter.PR.length > 0"><label class=label_pr>{{\'HEADER_PR\' | translate | uppercase}}</label><!-- OLD VIEW --><div ng-if=!panierCtrl.areNewButtonsVisible><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label></div><div class="small-4 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><label ng-if="!panierCtrl.showGetPriceColumns && !panierCtrl.isIndependantUser">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.isIndependantUser && $root.asomDocList.PX">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if=panierCtrl.showGetPriceColumns><div>{{"WHOLESALER_LABEL"|translate| uppercase}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate| uppercase}}</div></label></div><div class="small-2 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><label>&nbsp;</label></div><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"></div></div><div class="row contentTabListPRorTM" ng-repeat="item in inter.PR track by $index" ng-if="item.quantity != 0"><div class="row espace_droit_line"><div class="small-2 columns" ng-click=panierCtrl.goToProduct(item)><span class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(item.reference, item.genericPart)">{{item.reference | filterFormatRef}}&nbsp;</span> <i class="fa fa-files-o" aria-hidden=true style="padding-left: 0.5px;font-size: 13px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=panierCtrl.copyToClipboard(item.reference);$event.stopPropagation();></i></div><div class="small-4 columns" ng-click=panierCtrl.goToProduct(item)><span class="caractere_label break-all-word">{{item.designation}}&nbsp;</span></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !panierCtrl.isIndependantUser"><span class=caractere_label ng-if=item.priceHT>{{item.priceHT}} {{item.currency}}&nbsp;</span><div class=caractere_label ng-if=!item.priceHT>-</div></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && panierCtrl.isIndependantUser && $root.asomDocList.PX"><span class=caractere_label ng-if=item.priceHT>{{item.priceHT}} {{item.currency}}&nbsp;</span><div class=caractere_label ng-if=!item.priceHT>-</div></div><div class="small-2 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><div class=caractere_label>&nbsp;</div></div><div class="small-2 columns gauche margin-left-10" style="margin-bottom: 3px;"><shopping-cart piece=item page=cart></shopping-cart></div><div class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(item, \'PR\')"></i></div></div></div></div><!-- NEW VIEW --><div ng-if=panierCtrl.areNewButtonsVisible><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'TAX\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'ESTIMATE_DISCOUNT\' | translate | uppercase}} <i style="font-size: x-small; padding-left: 3px;" class="fa fa-percent" aria-hidden=true></i></label></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><label ng-if=!panierCtrl.isIndependantUser>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if="panierCtrl.isIndependantUser && $root.asomDocList.PX">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"></div></div><div style="line-height: 1;" class="small-12 columns"><div style="margin-bottom: -1px;" class="row contentTabListPRorTM" ng-repeat="item in inter.PR track by $index" ng-if="item.quantity != 0"><div class="row espace_droit_line"><div class="small-2 columns" ng-click=panierCtrl.goToProduct(item)><span class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(item.reference, item.genericPart)">{{item.reference | filterFormatRef}}&nbsp;</span> <i class="fa fa-files-o" aria-hidden=true style="padding-left: 0.5px;font-size: 13px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=panierCtrl.copyToClipboard(item.reference);$event.stopPropagation();></i></div><div class="small-2 columns" ng-click=panierCtrl.goToProduct(item)><span class="caractere_label break-all-word">{{item.designation}}&nbsp;</span></div><div class="small-1 columns"><input type=text min=0 max=9999 step=0.01 style="width: 60px; height: 30px;" id=inputTaxInterPr{{$parent.$index}}_{{$index}} ng-model=item.tax ng-keypress="panierCtrl.onChangeData(\'inputTaxInterPr\', $parent.$index + \'_\' + $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-1 columns"><input type=text min=0 max=9999 step=0.01 style="width: 60px; height: 30px;" id=inputDiscountInterPr{{$parent.$index}}_{{$index}} ng-model=item.discount ng-keypress="panierCtrl.onChangeData(\'inputDiscountInterPr\', $parent.$index + \'_\' + $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !panierCtrl.isIndependantUser"><span class=caractere_label ng-if=item.priceHT>{{item.priceHT}} {{item.currency}}&nbsp;</span><div class=caractere_label ng-if=!item.priceHT>-</div></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && panierCtrl.isIndependantUser && $root.asomDocList.PX"><span class=caractere_label ng-if=item.priceHT>{{item.priceHT}} {{item.currency}}&nbsp;</span><div class=caractere_label ng-if="!item.priceHT && !panierCtrl.prCalculDone">-</div></div><div class="small-1 columns gauche margin-left-10" style="margin-bottom: 3px;"><shopping-cart piece=item page=cart></shopping-cart></div><div class="small-2 columns gauche margin-left-10" style="margin-bottom: 3px;"><span class="caractere_label margin-left-10" ng-if=item.netAmountExclTax>{{item.netAmountExclTax | numberPhenix}} {{item.currency}}&nbsp;</span><div class="caractere_label margin-left-10" ng-if="!item.netAmountExclTax && (item.priceHT || !panierCtrl.prCalculDone)">-</div><span ng-if="panierCtrl.prCalculDone && !item.netAmountExclTax && !item.priceHT" class=margin-left-10><i class="warningIcon fa fa-exclamation-triangle" style="font-size: 16px;"></i></span></div><div style="margin-top: -15px;" class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(item, \'PR\')"></i></div></div></div></div></div></div><!-- INTER TM SECTION --><div ng-if="inter.TM.length > 0"><label class=label_pr>{{\'COMMON_TABLE_MO_TITLE\' | translate | uppercase}}</label><!-- OLD VIEW --><div ng-if=!panierCtrl.areNewButtonsVisible><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label></div><div class="small-4 columns"><label>{{\'DOCUMENT_TM_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label></label></div></div><div class="row contentTabListPRorTM" ng-repeat="tm in inter.TM" ng-init="sectionTm = $index"><div class="small-2 columns"><span class=caractere_label>{{tm.opecod | trim}}&nbsp;</span></div><div class="small-4 columns"><span class="caractere_label break-all-word">{{tm.designation}}&nbsp;</span></div><div class="small-2 columns temps_div_width"><label class=caractere_label ng-if=tm.duration>{{tm.duration}}&nbsp;</label> <label class=caractere_label ng-if=!tm.duration>-</label></div><div class="small-2 columns gauche margin-left-10"><div ng-if="tm.isPackage || tm.isNotCodifiedPackage" class="stockComponent Flou"><div class=square><i class=icon-icons-phnx_stepper_moins></i></div><div class=stockText><input numbers-only class=text-center type=text aria-label=quantity id=quantity maxlength=3 size=3 ng-model=tm.quantity disabled=disabled>&nbsp;&nbsp;</div><div class=square><i class=icon-icons-phnx_stepper_plus></i></div></div><div ng-if="!tm.isPackage && !tm.isNotCodifiedPackage" class=stockComponent><shopping-cart piece=tm page=cart></shopping-cart></div></div><div class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(tm, \'TM\')"></i></div></div></div><!-- NEW VIEW --><div ng-if=panierCtrl.areNewButtonsVisible><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'DOCUMENT_TM_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'TAX\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'ESTIMATE_DISCOUNT\' | translate | uppercase}}<i style="font-size: x-small; padding-left: 3px;" class="fa fa-percent" aria-hidden=true></i></label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}} <span style="color: red;">*</span></label></div><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"></div></div><div style="line-height: 1;" class="small-12 columns"><div style="margin-bottom: -1px;" class="row contentTabListPRorTM" ng-repeat="tm in inter.TM" ng-init="sectionTm = $index"><div class="small-2 columns"><span class=caractere_label>{{tm.opecod | trim}}&nbsp;</span></div><div class="small-2 columns"><span class=caractere_label>{{tm.designation}}&nbsp;</span></div><div class="small-1 columns"><input type=text min=0 max=9999 step=0.01 style="width: 60px; height: 30px; margin-bottom: 0px;" id=inputTaxInterTm{{$parent.$index}}_{{$index}} ng-model=tm.tax ng-keypress="panierCtrl.onChangeData(\'inputTaxInterTm\', $parent.$index + \'_\' + $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-1 columns"><input type=text min=0 max=9999 step=0.01 style="width: 60px; height: 30px; margin-bottom: 0px;" id=inputDiscountInterTm{{$parent.$index}}_{{$index}} ng-model=tm.discount ng-keypress="panierCtrl.onChangeData(\'inputDiscountInterTm\', $parent.$index + \'_\' + $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-1 columns temps_div_width"><label class=caractere_label ng-if=tm.duration>{{tm.duration}}&nbsp;</label> <label class=caractere_label ng-if=!tm.duration>-</label></div><div class="small-1 columns"><input type=text min=0 max=99999 step=0.01 style="width: 80px; height: 30px;" id=hourlyRateInter{{$parent.$index}}_{{$index}} ng-model=tm.hourlyRate ng-keypress="panierCtrl.onChangeData(\'hourlyRateInter\', $parent.$index + \'_\' + $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-2 columns gauche margin-left-10"><div ng-if="tm.isPackage || tm.isNotCodifiedPackage" class="stockComponent Flou"><div class=square><i class=icon-icons-phnx_stepper_moins></i></div><div class=stockText><input numbers-only class=text-center type=text aria-label=quantity id=quantity maxlength=3 size=3 ng-model=tm.quantity disabled=disabled>&nbsp;&nbsp;</div><div class=square><i class=icon-icons-phnx_stepper_plus></i></div></div><div ng-if="!tm.isPackage && !tm.isNotCodifiedPackage" class=stockComponent><shopping-cart piece=tm page=cart></shopping-cart></div></div><div style="position: relative; left: 10%; bottom: 29px;" class="small-2 columns"><span class="caractere_label margin-left-10" ng-if=tm.netAmountExclTax>{{tm.netAmountExclTax | numberPhenix}} {{tm.currency}}&nbsp;</span><div class="caractere_label margin-left-10" ng-if=!tm.netAmountExclTax>-</div></div><div style="margin-top: -25px;" class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(tm, \'TM\')"></i></div></div></div></div></div><!-- Per-group subtotal --><div ng-if="panierCtrl.areNewButtonsVisible && panierCtrl.prCalculDone && inter.subTotalExclTax" class=row><div class="small-9 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-3 columns"><div class=price_label_gras_1>{{inter.subTotalExclTax | number: 2}} {{panierCtrl.getCurrencyForItem()}}</div></div></div></div></div><div ng-if=panierCtrl.showGetPriceColumns><div class=headerPRorTM><label class=label_pr>{{\'HEADER_PR\' | translate | uppercase}}</label></div><div class="small-12 columns" style="background-color: #fff;"><div class="row headerTabListPRorTM" style="margin-bottom: -5px;"><div class="small-1 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label></div><div class="small-3 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><!-- <div class="small-1 columns">\n                  <label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label>\n                </div> --><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><label ng-if="!panierCtrl.showGetPriceColumns && !panierCtrl.isIndependantUser">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label><!-- <label ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.isIndependantUser && $rootScope.asomDocList.PX">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> --> <label ng-if=panierCtrl.showGetPriceColumns><div>{{"WHOLESALER_LABEL"|translate| uppercase}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate| uppercase}}</div></label></div><div class="small-1 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><label>&nbsp;</label></div><div class="small-2 columns" ng-click=panierCtrl.displayAllDiscountRate()><span class=discountCodeHeader>{{\'ORDERING_MODULE_DISCOUNT_CODE\' | translate | uppercase}} <i class=iconRight ng-class="panierCtrl.showAllDiscountRate? \'icon-icons_arrow_top\' : \'icon-icons_arrow_bottom\'"></i></span></div><div class="small-1 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label><div>{{"WHOLESALER_LABEL"|translate|uppercase}}</div><div>{{"R1_AVAILABILITIES"|translate|uppercase}}</div></label></div><div class="small-1 columns"></div></div></div><div class="small-12 columns"><div class="row contentTabListPRorTM" ng-repeat="pr in panierCtrl.panier.pr"><!-- ******************************\n                        PR REFERENCE\n                ********************************--><div class="row espace_droit_line"><div class="small-1 columns" ng-click=panierCtrl.goToProduct(pr)><span class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)">{{pr.reference | trim | filterFormatRef}}&nbsp;</span> <i class="fa fa-files-o" aria-hidden=true style="padding-left: 0.5px;font-size: 13px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=panierCtrl.copyToClipboard(pr.reference);$event.stopPropagation();></i></div><div class="small-3 columns" ng-click=panierCtrl.goToProduct(pr)><span ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)" class="caractere_label break-all-word">{{pr.designation}}&nbsp; </span><span ng-if=pr.reach><img src=./assets/svg/reach.svg height=16 width=16 alt=""></span></div><!-- COMMON_COLUMN_CT_TITLE --><!-- <div class="small-1 columns">\n                    <span class="caractere_label">{{pr.taxCode}}&nbsp;</span>\n                  </div> --><div class="small-2 columns" ng-if="panierCtrl.isUrgentCountry && panierCtrl.urgentOrder"><span class=caractere_label ng-if=pr.priceUrgentTaxFree>{{pr.priceUrgentTaxFree}} {{pr.currency}}&nbsp;</span> <span class=caractere_label ng-if=!pr.priceUrgentTaxFree>{{pr.priceAdvisedTaxFree}} {{pr.currency}}&nbsp;</span></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !panierCtrl.urgentOrder"><span class=caractere_label ng-if=pr.priceAdvisedTaxFree>{{pr.priceAdvisedTaxFree}} {{pr.currency}}&nbsp;</span> <span class=caractere_label ng-if="!pr.priceAdvisedTaxFree && !panierCtrl.isIndependantUser">{{pr.priceHT}} {{pr.currency}}&nbsp;</span><!-- <span class="caractere_label" ng-if="!pr.priceAdvisedTaxFree && panierCtrl.isIndependantUser && $rootScope.asomDocList.PX">{{pr.priceHT}} {{pr.currency}}&nbsp;</span> --></div><div class="small-1 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><div class=caractere_label>&nbsp;</div></div><div class="small-2 columns"><div class=caractere_label style="cursor: pointer;" ng-if="pr.discountCode && !pr.isLoadingPriceData" ng-click=panierCtrl.displayDiscountRate(pr)><span ng-if=!pr.isDiscountcodeVisible>{{pr.discountCode}} <span class="iconRight icon-icons_arrow_bottom" ng-if=!pr.isDiscountcodeVisible></span> </span><span ng-if=pr.isDiscountcodeVisible>{{pr.priceTaxFree}} {{pr.currency}} {{\'PRODUCT_EXCL_TAX\' | translate | uppercase}} <span class="iconRight icon-icons_arrow_top" ng-if=pr.isDiscountcodeVisible></span><div style="font-size: var(--renaultSmallFont);"><span ng-if=!panierCtrl.urgentOrder>{{pr.discountRate}}</span> <span ng-if=panierCtrl.urgentOrder>{{pr.discountRateUrgent}}</span> {{\'%\'}}</div></span></div><div class=caractere_label ng-if="!pr.discountCode && !pr.isLoadingPriceData"><div ng-if="pr.itemReturnCode ===\'A001\'"><i class="warningIcon fa fa-exclamation-triangle"></i><md-tooltip md-direction=left style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'UNKNOWN_PARTS_RPARTS\' | translate }}</md-tooltip></div><div class=caractere_label ng-if="pr.itemReturnCode!= \'A001\'">{{\'-\'}}</div></div><div class=caractere_label ng-if=pr.isLoadingPriceData><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div></div><div class="small-1 columns" style="margin-bottom: 3px;"><shopping-cart piece=pr check-dealer-list=panierCtrl.checkDealerList page=cart></shopping-cart></div><div class="small-2 columns"><div class="caractere_label availabilities" ng-if=!pr.isLoadingStockData ng-class="{\'light-green-dot\':(pr.applicableClass === \'STOCK_AVAILABLE\' || pr.applicableClass === \'STOCK_IT_ES_GREEN\' || pr.applicableClass === \'STOCK_AVAILABLE_BE\'),\n                                \'red-dot\':(pr.applicableClass === \'STOCK_UNAVAILABLE\' || ((panierCtrl.countryCode === \'IT\' || panierCtrl.countryCode === \'ES\') && pr.applicableClass ===\'STOCK_CERGY\') || pr.applicableClass === \'STOCK_PARTIAL\' || pr.applicableClass === \'STOCK_PART_UNAVAILABLE\'|| pr.applicableClass === \'STOCK_UNAVAILABLE_BE\'), \n                                \'green-dot\':(pr.applicableClass ===\'STOCK_IT_ES_YELLOW\' && panierCtrl.countryCode === \'IT\'),\n                                \'orange-dot\':((panierCtrl.countryCode != \'IT\' && panierCtrl.countryCode != \'ES\') && pr.applicableClass ===\'STOCK_CERGY\' || pr.applicableClass === \'STOCK_AVAILABLE_D1\'|| pr.applicableClass === \'STOCK_CERGY_BE\'),\n                                \'yellow-dot\':((pr.applicableClass === \'STOCK_IT_ES_YELLOW\'||pr.applicableClass === \'STOCK_IT_ES_YELLOW_BE\') && panierCtrl.countryCode != \'IT\')}" tooltip-placement=bottom tooltip-html-unsafe={{pr.applicableClass|translate}}><span ng-if="!pr.applicableClass || pr.applicableClass === \'STOCK_EMPTY\'" style="margin-left : 10%;" tooltip-placement=bottom tooltip-html-unsafe="{{\'STOCK_EMPTY\'|translate}}">-</span></div><div ng-if=!pr.isLoadingStockData class=warnTooltip><span ng-if="pr.applicableClass === \'UNKNOWN_PARTS_RPARTS\'"><i class="warningIcon fa fa-exclamation-triangle"></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'UNKNOWN_PARTS_RPARTS\' | translate }}</md-tooltip></span></div><div class="caractere_label availabilities" ng-if=pr.isLoadingStockData><img src=../assets/images/newHourGlassGrey.gif width=24px style=margin-left:7% alt=""></div></div><div class="small-1 columns"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(pr, \'PR\')"></i></div></div><!-- ******************************\n                        PPS LIGNE\n                ******************************* --><!-- <div class="row espace_droit_line" ng-repeat="ref in pr.pps">\n                  <div class="small-2 columns">\n                    <div class="lineArborescence"></div>\n                    <div class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(ref.reference)">{{ref.reference | trim}}&nbsp;</div>\n                  </div>\n                  <div class="small-4 columns">\n                    <span  ng-click="panierCtrl.goToProductPage(ref.reference)" class="caractere_label clickable">{{ref.designation}}&nbsp;</span>\n                    <span ng-if="ref.reach">\n                            <img src="./assets/svg/reach.svg" height="16" width="16" />\n                        </span>\n                    </div>\n\n                  <div class="small-2 columns">\n                    <span ng-if="ref.priceHT" class="caractere_label">{{ref.priceHT}} {{ref.currency}}&nbsp;</span>\n                    <div class="centrer_label" ng-if="!ref.priceHT">-</div>\n                  </div>\n\n                  <div class="small-2 columns gauche" style="margin-bottom: 3px;">\n                    <shopping-cart piece="ref" main-piece="pr" type="PPS"  page="cart"></shopping-cart>\n                  </div>\n                  <div class="small-1 columns marge_droite">\n                    <i class="icon-icons_remove_panier" ng-click="panierCtrl.displayModal(ref, \'PR\', true, pr)"></i>\n                  </div>\n                </div> --></div></div></div><!--Basket PR & TM--><div ng-show=panierCtrl.isDisplayOldTab ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.panier.pr.length && !panierCtrl.areNewButtonsVisible"><div class=headerPRorTM><label class=label_pr>{{\'HEADER_PR\' | translate | uppercase}}</label></div><div class="small-12 columns"><div class="row headerTabListPRorTM" style="margin-bottom: -5px;"><div class="small-2 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label></div><div class="small-4 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><!-- <div class="small-1 columns">\n                  <label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label>\n                </div> --><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><label ng-if="!panierCtrl.showGetPriceColumns && !panierCtrl.isIndependantUser">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.isIndependantUser && $root.asomDocList.PX">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if=panierCtrl.showGetPriceColumns><div>{{"WHOLESALER_LABEL"|translate| uppercase}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate| uppercase}}</div></label> <label>&nbsp;</label></div><div class="small-2 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><label>&nbsp;</label></div><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"></div></div></div><div class="small-12 columns"><div class="row contentTabListPRorTM" ng-repeat="pr in panierCtrl.panier.pr"><!-- ******************************\n                        PR REFERENCE\n                ********************************--><div class="row espace_droit_line"><div class="small-2 columns" ng-click=panierCtrl.goToProduct(pr)><span class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)">{{pr.reference | trim | filterFormatRef}}&nbsp;</span> <i class="fa fa-files-o" aria-hidden=true style="padding-left: 0.5px;font-size: 13px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=panierCtrl.copyToClipboard(pr.reference);$event.stopPropagation();></i></div><div class="small-4 columns" ng-click=panierCtrl.goToProduct(pr)><span ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)" class="caractere_label break-all-word">{{pr.designation}}&nbsp; </span><span ng-if=pr.reach><img src=./assets/svg/reach.svg height=16 width=16 alt=""></span></div><!-- COMMON_COLUMN_CT_TITLE --><!-- <div class="small-1 columns">\n                    <span class="caractere_label">{{pr.taxCode}}&nbsp;</span>\n                  </div> --><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !panierCtrl.isIndependantUser"><span class=caractere_label ng-if=pr.priceHT>{{pr.priceHT}} {{pr.currency}}&nbsp;</span><div class=caractere_label ng-if=!pr.priceHT>-</div></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && panierCtrl.isIndependantUser && $root.asomDocList.PX"><span class=caractere_label ng-if=pr.priceHT>{{pr.priceHT}} {{pr.currency}}&nbsp;</span><div class=caractere_label ng-if=!pr.priceHT>-</div></div><div class="small-2 columns" style="margin-bottom: -20px" ; ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><div class=caractere_label>&nbsp;</div></div><div class="small-2 columns" ng-if="mainCtrl.isCountryChina || mainCtrl.isCountryIndia"><div class=caractere_label>&nbsp;</div></div><div class="small-2 columns gauche margin-left-10" style="margin-bottom: 3px;"><shopping-cart piece=pr page=cart></shopping-cart></div><div class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(pr, \'PR\')"></i></div></div><!-- ******************************\n                        PPS LIGNE\n                ******************************* --><!-- <div class="row espace_droit_line" ng-repeat="ref in pr.pps">\n                  <div class="small-2 columns">\n                    <div class="lineArborescence"></div>\n                    <div class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(ref.reference)">{{ref.reference | trim}}&nbsp;</div>\n                  </div>\n                  <div class="small-4 columns">\n                    <span  ng-click="panierCtrl.goToProductPage(ref.reference)" class="caractere_label clickable">{{ref.designation}}&nbsp;</span>\n                    <span ng-if="ref.reach">\n                            <img src="./assets/svg/reach.svg" height="16" width="16" />\n                        </span>\n                    </div>\n\n                  <div class="small-2 columns">\n                    <span ng-if="ref.priceHT" class="caractere_label">{{ref.priceHT}} {{ref.currency}}&nbsp;</span>\n                    <div class="centrer_label" ng-if="!ref.priceHT">-</div>\n                  </div>\n\n                  <div class="small-2 columns gauche" style="margin-bottom: 3px;">\n                    <shopping-cart piece="ref" main-piece="pr" type="PPS"  page="cart"></shopping-cart>\n                  </div>\n                  <div class="small-1 columns marge_droite">\n                    <i class="icon-icons_remove_panier" ng-click="panierCtrl.displayModal(ref, \'PR\', true, pr)"></i>\n                  </div>\n                </div> --></div></div></div><!--Basket PR & TM New Tab--><div ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.panier.pr.length && panierCtrl.areNewButtonsVisible"><div class=headerPRorTM><label class=label_pr>{{\'HEADER_PR\' | translate | uppercase}}</label></div><div class="small-12 columns"><div class="row headerTabListPRorTM" style="margin-bottom: -5px;"><div class="small-2 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'TAX\'|translate|uppercase}}</label></div><div class="small-1 columns"><label>{{\'ESTIMATE_DISCOUNT\'|translate|uppercase}} <i style="font-size: x-small; padding-left: 3px;" class="fa fa-percent" aria-hidden=true></i></label></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><label ng-if="!panierCtrl.showGetPriceColumns && !panierCtrl.isIndependantUser">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.isIndependantUser && $root.asomDocList.PX">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label> <label ng-if=panierCtrl.showGetPriceColumns><div>{{"WHOLESALER_LABEL"|translate| uppercase}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate| uppercase}}</div></label> <label>&nbsp;</label></div><div class="small-1 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label></label></div></div></div><div style="line-height: 1;" class="small-12 columns"><div style="margin-bottom: -1px;" class="row contentTabListPRorTM" ng-repeat="pr in panierCtrl.panier.pr"><!-- ******************************\n                        PR REFERENCE NEW SCREEN\n                ********************************--><div class="row espace_droit_line"><div class="small-2 columns" ng-click=panierCtrl.goToProduct(pr)><span class="caractere_label clickable" ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)">{{pr.reference | trim | filterFormatRef}}&nbsp;</span> <i class="fa fa-files-o" aria-hidden=true style="padding-left: 0.5px;font-size: 13px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=panierCtrl.copyToClipboard(pr.reference);$event.stopPropagation();></i></div><div class="small-2 columns" ng-click=panierCtrl.goToProduct(pr)><span ng-click="panierCtrl.goToProductPage(pr.reference, pr.genericPart)" class="caractere_label break-all-word">{{pr.designation}}&nbsp; </span><span ng-if=pr.reach><img src=./assets/svg/reach.svg height=16 width=16 alt=""></span></div><div class="small-1 columns"><input ng-style="{\'margin-bottom\' : $index === 0 ? \'0px\' : \'\'}" type=text min=0 max=9999 step=0.01 ng-keypress="panierCtrl.onChangeData(\'inputTax\', $index )" ng-keydown=panierCtrl.handleKeydown($event) style="width: 60px; height: 30px;" id=inputTax{{$index}} ng-model=pr.tax> <i ng-click="panierCtrl.copyToClipboardNew(pr.tax,\'tax\',\'pr\')" ng-if="$index === 0 && !(panierCtrl.showPricingSection && panierCtrl.areNewButtonsVisible)" class="fa fa-arrow-circle-down copyValuesIcon"><md-tooltip>{{\'COPY_DOWN_TOOLTIP\' | translate}}</md-tooltip></i></div><div class="small-1 columns"><input ng-style="{\'margin-bottom\' : $index === 0 ? \'0px\' : \'\'}" type=text min=0 max=9999 step=0.01 style="width: 60px; height: 30px;" id=inputDiscount{{$index}} ng-model=pr.discount ng-keypress="panierCtrl.onChangeData(\'inputDiscount\', $index)" ng-keydown=panierCtrl.handleKeydown($event)> <i ng-click="panierCtrl.copyToClipboardNew (pr.discount,\'discount\',\'pr\')" ng-if="$index === 0 && !(panierCtrl.showPricingSection && panierCtrl.areNewButtonsVisible)" class="fa fa-arrow-circle-down copyValuesIcon"><md-tooltip>{{\'COPY_DOWN_TOOLTIP\' | translate}}</md-tooltip></i></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !panierCtrl.isIndependantUser"><span class=caractere_label ng-if=pr.priceHT>{{pr.priceHT}} {{pr.currency}}&nbsp;</span><div class=caractere_label ng-if=!pr.priceHT>-</div></div><div class="small-2 columns" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && panierCtrl.isIndependantUser && $root.asomDocList.PX"><span class=caractere_label ng-if=pr.priceHT>{{pr.priceHT}} {{pr.currency}}&nbsp;</span><div class=caractere_label ng-if="!pr.priceHT && !panierCtrl.prCalculDone">-</div></div><div class="small-1 columns gauche margin-left-10" style="margin-bottom: 3px;"><shopping-cart piece=pr page=cart></shopping-cart></div><div class="small-2 columns gauche margin-left-10" style="margin-bottom: 3px;"><span class="caractere_label margin-left-10" ng-if=pr.netAmountExclTax>{{pr.netAmountExclTax | numberPhenix}} {{pr.currency}}&nbsp;</span><div class="caractere_label margin-left-10" ng-if="!pr.netAmountExclTax && (pr.priceHT || !panierCtrl.prCalculDone)">-</div><span ng-if="panierCtrl.prCalculDone && !pr.netAmountExclTax && !pr.priceHT" class=margin-left-10><i class="warningIcon fa fa-exclamation-triangle" style="font-size: 16px;"></i></span></div><div style="margin-top: -15px;" class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(pr, \'PR\')"></i></div></div></div></div></div><div ng-if="!panierCtrl.showGetPriceColumns && panierCtrl.panier.pr.length && panierCtrl.areNewButtonsVisible" class=row><div class="small-9 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-3 columns"><div class="small-12 columns"><div class=price_label_gras_1 ng-if="panierCtrl.prCalculDone && panierCtrl.panier.pr.subTotalExclTaxPrTm">{{panierCtrl.panier.pr.subTotalExclTaxPrTm | number: 2}} {{panierCtrl.getCurrencyForItem()}}</div></div></div></div><!-- ========================\n               DISPLAY LIST CART\n        ========================= --><div ng-if=panierCtrl.panier.tm.length><div class="small-12 columns headerTM"><div class=grey>{{\'COMMON_TABLE_MO_TITLE\' | translate | uppercase}}</div></div><!-- ***********************\n                    HEADER TM\n            **************************--><div ng-if=!panierCtrl.areNewButtonsVisible class="small-12 columns"><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label></div><div class="small-4 columns"><label>{{\'DOCUMENT_TM_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><!-- <div class="small-1 columns">\n                  <label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label>\n                </div> --><!-- <div class="small-2 columns">\n                  <label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label>\n                </div> --><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label></label></div></div></div><!-- ***********************\n                    HEADER TM NEW\n            **************************--><div ng-if=panierCtrl.areNewButtonsVisible class="small-12 columns"><div class="row headerTabListPRorTM"><div class="small-2 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'DOCUMENT_TM_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'TAX\'|translate|uppercase}}</label></div><div class="small-1 columns"><label>{{\'ESTIMATE_DISCOUNT\'|translate|uppercase}}<i style="font-size: x-small; padding-left: 3px;" class="fa fa-percent" aria-hidden=true></i></label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}} <span style="color: red;">*</span></label></div><div class="small-2 columns stock"><label class=a_droite>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label></label></div></div></div><!-- ***********************\n                    TM DATA LIGN\n            **************************--><div ng-if=!panierCtrl.areNewButtonsVisible class="small-12 columns"><div class="row contentTabListPRorTM" ng-repeat="tm in panierCtrl.panier.tm" ng-init="sectionTm = $index"><div class="small-2 columns"><span class=caractere_label>{{tm.opecod | trim}}&nbsp;</span></div><div class="small-4 columns"><span class="caractere_label break-all-word">{{tm.designation}}&nbsp;</span></div><div class="small-2 columns temps_div_width"><label class=caractere_label ng-if=tm.duration>{{tm.duration}}&nbsp;</label> <label class=caractere_label ng-if=!tm.duration>-</label></div><!-- COMMON_COLUMN_CT_TITLE --><!--\n                <div class="small-1 columns">\n                  <div class="selectCodeTaxeTM caractere_label clickable" dropdown-toggle="#dropDownFilterCT{{sectionIndex}}{{sectionTm}}">\n                    {{tm.taxCode}}\n                    <i class="icon-icons_arrow_down"></i>\n                  </div>\n                  <ul id="dropDownFilterCT{{sectionIndex}}{{sectionTm}}" class="f-dropdown">\n                    <li ng-repeat="item in panierCtrl.listOfTaxesCodeTM">\n                      <a ng-click="panierCtrl.changeTaxeCode($parent.tm, item)">{{item.value}}</a>\n                    </li>\n                  </ul>\n                </div> --><!-- <div class="small-2 columns">\n                  <div class="caractere_label" ng-if="tm.isNotCodifiedPackage">\n                    <input ng-model="tm.priceExclTaxes" class="hourlyRate" ng-change="panierCtrl.updateHourlyRate()">\n                    {{panierCtrl.currency}}\n                  </div>\n                  <div class="caractere_label" ng-if="tm.isPackage">\n                    <input ng-model="tm.hourlyRate" class="hourlyRate" ng-change="panierCtrl.updateHourlyRate()">\n                    {{panierCtrl.currency}}\n                  </div>\n                  <div ng-if="!tm.isPackage && !tm.isNotCodifiedPackage">\n                    <label class="caractere_label">{{tm.hourlyRate | numberPhenix}}{{panierCtrl.currency}}</label>\n                    &nbsp;\n                  </div>\n                </div> --><div class="small-2 columns gauche margin-left-10"><div ng-if="tm.isPackage || (tm.isNotCodifiedPackage)" class="stockComponent Flou"><div class=square><i class=icon-icons-phnx_stepper_moins></i></div><div class=stockText><input numbers-only class=text-center type=text aria-label=quantity id=quantity maxlength=3 size=3 ng-model=tm.quantity disabled=disabled>&nbsp; &nbsp;</div><div class=square><i class=icon-icons-phnx_stepper_plus></i></div></div><!-- *************************\n                            CART\n                   ************************* --><div ng-if="!tm.isPackage && !tm.isNotCodifiedPackage" class=stockComponent><shopping-cart piece=tm page=cart></shopping-cart></div></div><div class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(tm, \'TM\')"></i></div></div></div><!-- TM DATA NEW PAGE --><div ng-if=panierCtrl.areNewButtonsVisible style="line-height: 1;" class="small-12 columns"><div style="margin-bottom: -1px;" class="row contentTabListPRorTM" ng-repeat="tm in panierCtrl.panier.tm" ng-init="sectionTm = $index"><div class="small-2 columns"><span class=caractere_label>{{tm.opecod | trim}}&nbsp;</span></div><div class="small-2 columns"><span class=caractere_label>{{tm.designation}}&nbsp;</span></div><div class="small-1 columns"><input type=text ng-keydown=panierCtrl.handleKeydown($event) min=0 max=9999 step=0.01 style="width: 60px; height: 30px;margin-bottom: 0px;" id=inputTaxTm{{$index}} ng-model=tm.tax ng-keypress="panierCtrl.onChangeData(\'inputTaxTm\', $index)"> <i ng-click="panierCtrl.copyToClipboardNew(tm.tax,\'tax\',\'tm\')" ng-if="$index === 0 && !(panierCtrl.showPricingSection && panierCtrl.areNewButtonsVisible)" class="fa fa-arrow-circle-down copyValuesIcon"><md-tooltip>{{\'COPY_DOWN_TOOLTIP\' | translate}}</md-tooltip></i></div><div class="small-1 columns"><input type=text ng-keydown=panierCtrl.handleKeydown($event) min=0 max=9999 step=0.01 style="width: 60px; height: 30px;margin-bottom: 0px;" id=inputDiscountTm{{$index}} ng-model=tm.discount ng-keypress="panierCtrl.onChangeData(\'inputDiscountTm\', $index)"> <i ng-click="panierCtrl.copyToClipboardNew(tm.discount,\'discount\',\'tm\')" ng-if="$index === 0 && !(panierCtrl.showPricingSection && panierCtrl.areNewButtonsVisible)" class="fa fa-arrow-circle-down copyValuesIcon"><md-tooltip>{{\'COPY_DOWN_TOOLTIP\' | translate}}</md-tooltip></i></div><div class="small-1 columns temps_div_width"><label class=caractere_label ng-if=tm.duration>{{tm.duration}}&nbsp;</label> <label class=caractere_label ng-if=!tm.duration>-</label></div><div class="small-1 columns"><input type=text min=0 max=99999 step=0.01 style="width: 80px; height: 30px;" id=hourlyRate{{$index}} ng-model=tm.hourlyRate ng-keypress="panierCtrl.onChangeData(\'hourlyRate\', $index)" ng-keydown=panierCtrl.handleKeydown($event)></div><div class="small-2 columns gauche margin-left-10"><div ng-if="tm.isPackage || (tm.isNotCodifiedPackage)" class="stockComponent Flou"><div class=square><i class=icon-icons-phnx_stepper_moins></i></div><div class=stockText><input numbers-only class=text-center type=text aria-label=quantity id=quantity maxlength=3 size=3 ng-model=tm.quantity disabled=disabled>&nbsp; &nbsp;</div><div class=square><i class=icon-icons-phnx_stepper_plus></i></div></div><div ng-if="!tm.isPackage && !tm.isNotCodifiedPackage" class=stockComponent><shopping-cart piece=tm page=cart></shopping-cart></div></div><div style="position: relative;left: 10%; bottom: 29px;" class="small-2 columns"><span class="caractere_label margin-left-10" ng-if=tm.netAmountExclTax>{{tm.netAmountExclTax | numberPhenix}} {{tm.currency}}&nbsp;</span><div class="caractere_label margin-left-10" ng-if=!tm.netAmountExclTax>-</div></div><div style="margin-top: -25px;" class="small-1 columns marge_droite"><i class=icon-icons_remove_panier ng-click="panierCtrl.displayModal(tm, \'TM\')"></i></div></div></div></div></div><div ng-if="panierCtrl.panier.tm.length && panierCtrl.areNewButtonsVisible" class=row><div class="small-9 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-3 columns"><div class="small-12 columns"><div class=price_label_gras_1 ng-if="panierCtrl.prCalculDone && panierCtrl.panier.tm.subTotalExclTaxPrTm">{{panierCtrl.panier.tm.subTotalExclTaxPrTm | number: 2}} {{panierCtrl.getCurrencyForItem()}}</div></div></div></div><!-- ===========================\n                INPUT ADD TM OR PR\n        ============================ --><div class=row ng-hide=panierCtrl.contextCarBrandCheck><div class="small-12 columns blocVehiculeFooter"><label class=label_ref>{{panierCtrl.getLabelText()}}</label><div class=containerInputRefFooter><input ng-init=panierCtrl.initBasketFocus() ng-focus=panierCtrl.selectContextVehicle(sectionIndex) type=text class=inputRefFooter maxlength=13 ng-model=ref ng-change=panierCtrl.formatReferenceInput() ng-attr-placeholder={{panierCtrl.getPlaceholderText()}} aria-label=reference id=reference phenix-enter=panierCtrl.addRef(ref)></div><div class="containerAjoutRefIconFooter clickable" ng-click=panierCtrl.addRef(ref)><i class=icon-icons_stepper_plus_panier></i></div></div></div><div class="small-12 row"><div class="small-8 columns padding-left-0"></div><div class="small-4 columns padding-right-0"><div class=blocCalculTotalLoginEstimation ng-if="panierCtrl.prCalculDone && panierCtrl.areNewButtonsVisible"><div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_BRUTHT\' |translate}}</label></div><div class="small-4 columns"><label class=price_label ng-if=panierCtrl.panier.grossTotalAmt>{{panierCtrl.panier.grossTotalAmt | numberPhenix}} {{panierCtrl.getCurrencyForItem()}}</label><div class=caractere_label ng-if=!panierCtrl.panier.grossTotalAmt>-</div></div></div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_NETHT\' |translate}}</label></div><div class="small-4 columns"><label ng-if=panierCtrl.panier.netTotalAmt class=price_label>{{panierCtrl.panier.netTotalAmt | numberPhenix}} {{panierCtrl.getCurrencyForItem()}}</label><div class=caractere_label ng-if=!panierCtrl.panier.netTotalAmt>-</div></div></div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_TAXES\' |translate}}</label></div><div class="small-4 columns"><label ng-if=panierCtrl.panier.totalTax class=price_label>{{panierCtrl.panier.totalTax | numberPhenix}} {{panierCtrl.getCurrencyForItem()}}</label><div class=caractere_label ng-if=!panierCtrl.panier.totalTax>-</div></div></div><div class=row><div class="small-8 columns"><label class=price_label_gras>{{\'ESTIMATE_TOTAL_TTC\' |translate}}</label></div><div class="small-4 columns"><label class=price_label_gras ng-if=panierCtrl.panier.totalAmtInclTax>{{panierCtrl.panier.totalAmtInclTax | numberPhenix}} {{panierCtrl.getCurrencyForItem()}}</label><div class=caractere_label ng-if=!panierCtrl.panier.totalAmtInclTax>-</div></div></div><div ng-if=panierCtrl.unknowPartsNotCalculated class="small-12 columns unknowPartMsg"><i class="fa fa-exclamation-triangle"></i> {{\'WARNING_CALCULATED_BASKET\' | translate}}</div></div></div></div></div><!-- Enable Calculation Button --><div ng-show="panierCtrl.isEnableButtonVisible && !panierCtrl.areNewButtonsVisible && panierCtrl.isEstimateCalculation && panierCtrl.isRNETUser && !panierCtrl.isDmsConnected" class=row style="margin:2% 0;display: flex; justify-content: flex-end;"><button ng-disabled=panierCtrl.isBasketEmpty() ng-click=panierCtrl.showNewButtons(true) type=button class="small-offset-10 small-2 columns buttonWithIcon enableButton enableButton-white" style="margin: 0px !important;"><div style="position: relative; right: 42%;" class=iconDiv><i class="icon-icons_calc_estimation icon-icons_calc_estimation-adjusted"></i></div><div style="position: relative; left: 31px; bottom: 22px;" class=btnText>{{\'ESTIMATE_ENABLE_CALCULATION\'|translate}}</div></button></div><!-- New Buttons --><div ng-show="panierCtrl.areNewButtonsVisible && !panierCtrl.isEnableButtonVisible" class="small-12 row" style="display: flex; justify-content: flex-end; align-items: center; margin-top: 15px;"><button type=button ng-if="panierCtrl.showGetPriceColumns && panierCtrl.isNonDmsOrderModeEnable" ng-disabled="panierCtrl.panier.pr.length == 0 || panierCtrl.allPriceDataLoader || panierCtrl.allStockDataLoader" class="buttonWithIcon ng-scope" style="width: max-content !important; height: 31px; margin-right: 10px;margin-bottom: 1rem;" ng-click=panierCtrl.validateOrder()><div class="placeOrderBtn iconDiv"><i class="orderIcon fa fa-truck"></i></div><div class="placeOrderText btnText">{{\'PLACE_ORDER\'| translate}}</div></button><div ng-click=panierCtrl.disableCalculation() style="margin-right: 10px;"><button class=estimateButtons ng-show=panierCtrl.areNewButtonsVisible><i class="icon-icons-phnx_reinit iconDiv" style="position: relative;right: 24px;"></i><div style="margin-left: -15px;">{{\'ESTIMATE_DISABLE_CALCULATION\'|translate}}</div></button></div><div ng-if=!panierCtrl.prCalculDone><button class=estimateButtons ng-disabled="panierCtrl.hasMissingHourlyRate() || panierCtrl.isBasketEmpty() || (panierCtrl.hasAnyPrItems() && (!panierCtrl.estimateGroupData || panierCtrl.estimateGroupData.length == 0))" ng-click=panierCtrl.onCalculBasket()><md-tooltip class=estimate-wrap-tooltip md-direction=top ng-if="panierCtrl.hasAnyPrItems() && (!panierCtrl.estimateGroupData || panierCtrl.estimateGroupData.length == 0)">{{\'ESTIMATE_GROUP_TOOLTIP\' | translate}}</md-tooltip><md-tooltip class=estimate-wrap-tooltip md-direction=top ng-if="panierCtrl.hasMissingHourlyRate() && (!panierCtrl.hasAnyPrItems() || (panierCtrl.estimateGroupData && panierCtrl.estimateGroupData.length > 0))">{{\'ESTIMATE_FILL_REQUIRED\' | translate}}</md-tooltip><i class="icon-icons_calc_estimation iconDiv" style="position: relative;right: 30px;"></i><!-- <i class="icon-icons-phnx_reinit iconDiv" style="position: relative;right: 30px;"></i> --><div style="position: relative;right: 15px;">{{\'ESTIMATE_CALCULATE\'| translate}}</div></button></div></div><md-input-container ng-disabled="panierCtrl.panier.pr.length == 0 || panierCtrl.allPriceDataLoader || panierCtrl.allStockDataLoader" ng-if="panierCtrl.isUrgentCountry && panierCtrl.showGetPriceColumns" style="float:right; margin:1% 0;"><md-checkbox ng-model=panierCtrl.urgentOrder md-no-ink ng-change=panierCtrl.urgentOrderChange()>{{\'URGENT_ORDER\' | translate}}</md-checkbox></md-input-container></div><!-- <div class="blocMentionPanier">\n      <div class="row">\n        <div class="small-12 columns">\n          <div ng-if="panierCtrl.mentionModeLecture">\n            <div class="containerMention">\n              <div class="firstLineMention">\n                <div class="mentionMention"><label>{{\'COMMON_MENTION_LABEL\' |translate}}</label></div>\n                <div class="editMention clickable" ng-click="panierCtrl.editMention()"><i class="icon-icons_change_panier"></i><label>{{\'COMMON_EDIT\' |translate}}</label></div>\n              </div>\n              <div class="secondLineMention">\n                <label>{{panierCtrl.mentionText}}</label>\n              </div>\n            </div>\n          </div>\n          <div ng-if="!panierCtrl.mentionModeLecture">\n            <div class="containerMention">\n              <div class="firstLineMention">\n                <div class="mentionMention"><label>{{\'COMMON_MENTION_LABEL\' |translate}}</label></div>\n                <div class="editMention">\n                  <span ng-click="panierCtrl.annulerMention()">\n                  <i class="icon-icons_close_basket"></i><label class="editMentionAnnulerPanier">{{\'COMMON_CANCEL\' |translate}}</label>\n                </span>\n                  <span ng-click="panierCtrl.saveMention()">\n                  <i class="icon-icons_save_mention_basket"></i><label>{{\'BUTTON_BASKET_SAVE\' |translate}}</label>\n                </span>\n                </div>\n              </div>\n              <div class="numCharEditMention">\n                <label>{{panierCtrl.mentionTextEdit.length}}/100</label>\n              </div>\n              <div class="secondLineMention">\n                <textarea ng-trim="false" maxlength="100" ng-model="panierCtrl.mentionTextEdit">{{panierCtrl.mentionText}}</textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div> --><!--check-save Directive--><!--<sticky-notification is-edited="editedBasket" save-action="panierCtrl.savePanier()"></sticky-notification>--><check-save form-dirty=editedBasket save-action=panierCtrl.savePanierAsync()></check-save>');
$templateCache.put('app/components/btList/btList-pagination.template.html','<!--&lt;!&ndash; This template includes PageSelect directive to setup custom pagination &ndash;&gt;--><div class=pagination_basket ng-if="pages.length > 1"><div class=container-arrow><i class=icon-icons_arrow_left_panier ng-if="currentPage > 1" ng-click="selectPage(currentPage - 1)"></i> &nbsp;</div><div>{{\'COMMON_PAGINATION_PAGE\'| translate}}&nbsp;</div><div class=custom-select><btpage-select></btpage-select></div><div class=container-arrow><i class=icon-icons_arrow_right_panier ng-if="currentPage < numPages" ng-click="selectPage(currentPage + 1)"></i></div></div>');
$templateCache.put('app/components/btList/btList.template.html','<span id=btlist><div><div class="small-12 columns text-center emptyrow"></div><div class="small-12 columns searchButton"><div ng-if=vm.btListFixedCriteriasParams class="small-1 btnBack" ng-click=vm.goToDiagnosticSearch()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class="small-12 text-center"><md-button class="md-raised buttonWithIcon" type=button ng-disabled=vm.disabled ng-click=vm.btSearch()><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button ng-if=vm.btListFixedCriterias class="md-raised buttonWithIcon rePopulate" ng-click=vm.reset()><div class=iconDiv><i class=icon-icons_refresh></i></div><div class=btnText>{{\'BT_LIST_RESET_DATA\' | translate}}</div></md-button></div></div><table class=responsive-table style=margin:5px st-table=btListTable st-set-filter=myCustomFilter st-safe-src=vm.displayed cellspacing=1><thead><tr><th st-sort=btListTable.name class=btlistheader style="width: 95px !important">{{\'BTLIST_HEADER_REF\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_APPLICABILLITY_FIX\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'BTLIST_HEADER_VARIABLE\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_CUSTOMER_EFFEECT\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_SOLUTION\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_INFORMATIONS\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'BTLIST_HEADER_STATE\' | translate}}</th><th st-sort=creationDate class=btlistheader style="width: 80px">{{\'COMMON_CREATION\' | translate}}</th><th st-sort=updateDate class=btlistheader style="width: 80px">{{\'BTLIST_HEADER_UPDATE\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'SYMPTOM\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'BTLIST_HEADER_LUPN\' | translate}}</th></tr><tr><th class=btlistheader1 scope=col></th><th><input ng-keypress=vm.enableSearchButton() placeholder=Family type=text aria-label=family id=family ng-model=vm.FAMILY phenix-enter=vm.btSearch()> <input placeholder="{{\'ALERTS_MODEL\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=modal id=modal ng-model=vm.MODEL> <input placeholder="{{\'ALERTS_VEHICLE_ENGINE\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=engine id=engine ng-model=vm.ENGINE> <input placeholder="{{\'BTLIST_HEADER_INDEX\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=btIndex id=btIndex ng-model=vm.EINDEX> <input placeholder="{{\'ALERTS_VEHICLE_GEAR\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=gear id=gear ng-model=vm.GEARBOX> <input placeholder="{{\'BTLIST_HEADER_INDEX\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=btListNo id=btListNo ng-model=vm.GINDEX> <input placeholder="{{\'BTLIST_HEADER_BATTERY\' | translate}}" phenix-enter=vm.btSearch() type=text aria-label=battery id=battery ng-model=vm.BATTERY> <input placeholder="{{\'BTLIST_HEADER_INDEX\' | translate}}" type=text phenix-enter=vm.btSearch() aria-label=btNo id=btNo ng-model=vm.BINDEX></th><th class=btlistheader1 scope=col></th><th colspan=3 class=btlistheader1 scope=col><input placeholder="{{\'BT_LIST_CUSTOM_FILTER\' | translate }}" ng-disabled=!vm.displayed ng-model=vm.customSearch class=btlistCustomSearch st-search=""></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th></tr></thead><tbody ng-show=!vm.isLoading><tr ng-repeat="row in btListTable"><td class=btnumberwidth ng-click=vm.searchBTByNumber(row) role=button>{{row.name}}</td><td><div ng-if=row.residual><div class=applicabilityfix ng-init="applicabilityfix=vm.getApplicabilityFix(row.residual)"><div class=applicabilityfix ng-if=!applicabilityfix><span class=center>-</span></div><div class=applicabilityfix ng-if=applicabilityfix><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color: white;opacity: 1.0; color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="aplbty in applicabilityfix.tooltipApplicabilityFix | limitTo:25" style="line-height: 2">{{aplbty}}</div><div style="font-size: 15px" ng-if="applicabilityfix.tooltipApplicabilityFix.length>=25">...........</div></md-tooltip>{{applicabilityfix.applicabilityFix}}</div></div></div><div ng-if=!row.residual><span class=center>-</span></div></td><td><div ng-if=row.residual><div class=variable ng-init="variableResidual=vm.getVariableResidual(row.residual,0)"><div class=variable ng-if=!variableResidual><span class=center>-</span></div><div class=variable ng-if=variableResidual>{{variableResidual}}</div></div></div><div ng-if=!row.residual><span class=center>-</span></div></td><td><div class=nonvariable ng-if=!row.designation><span class=center>-</span></div><div class=nonvariable ng-if=row.designation><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: 12px; color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;"><div>{{row.designation}} &nbsp;</div></md-tooltip><span>{{row.designation | limitTo:30}}</span> <span ng-if="row.designation.length > 30">...</span></div></td><td><div class=nonvariable ng-if=!row.solution><span class=center>-</span></div><div class=nonvariable ng-if=row.solution><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: 12px; color: black; border: 1.5px solid black;height: auto !important; max-width: 700px !important; white-space: normal;font-family: \'renaultGroupRegular\'"><div>{{row.solution}} &nbsp;</div></md-tooltip><span>{{row.solution | limitTo:30}}</span> <span ng-if="row.solution.length > 30">...</span></div></td><td><div class=nonvariable ng-if=!row.informations><span class=center>-</span></div><div class=nonvariable ng-if=row.informations><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: 12px; color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;"><div>{{row.informations}} &nbsp;</div></md-tooltip><span>{{row.informations | limitTo:30}}</span> <span ng-if="row.informations.length > 30">...</span></div></td><td><div class=state ng-if=!row.state><span class=center>-</span></div><div class=state ng-if=row.state>{{row.state}}</div></td><td><div ng-if=!row.creationDate><span class=center>-</span></div><div ng-if=row.creationDate>{{vm.formatDate(row.creationDate)}}</div></td><td><div ng-if=!row.updateDate><span class=center>-</span></div><div ng-if=row.updateDate>{{vm.formatDate(row.updateDate)}}</div></td><td><div ng-if=row.details.DTCList><div class=state ng-init="dtccodes=vm.getDtcCodes(row.details)"><div class=state ng-if="!dtccodes||dtccodes.length==0"><span class=center>-</span></div><div class=state ng-if=dtccodes><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white; opacity: 1.0;color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="dtcCode in dtccodes | limitTo:25" style="line-height: 2">{{dtcCode}} &nbsp;</div><div style="font-size: 15px" ng-if="dtccodes.length>=25"><strong>...........</strong></div></md-tooltip><span ng-if="dtccodes.length > 1" ng-repeat="dtcCode in dtccodes | limitTo:2">{{dtcCode}}, </span><span ng-if="dtccodes.length == 1" ng-repeat="dtcCode in dtccodes | limitTo:1">{{dtcCode}} &nbsp;</span></div></div></div><div ng-if=!row.details.DTCList><span class=center>-</span></div></td><td><div ng-if=row.details.symptomList><div class=state ng-init="symptomcodes=vm.getSmptomcodes(row.details)"><div class=state ng-if="!symptomcodes||symptomcodes.length==0"><span class=center>-</span></div><div class=state ng-if=symptomcodes><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white; opacity: 1.0;color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="smptmCode in symptomcodes | limitTo:25" style="line-height: 2">{{smptmCode.shortCode}} , {{smptmCode.label}} &nbsp;</div><div style="font-size: 15px" ng-if="symptomcodes.length>=25">...........</div></md-tooltip><span ng-if="symptomcodes.length > 1" ng-repeat="item in symptomcodes | limitTo:3">{{item.shortCode}}, </span><span ng-if="symptomcodes.length == 1" ng-repeat="item in symptomcodes | limitTo:3">{{item.shortCode}}</span></div></div></div><div ng-if=!row.details.symptomList><span class=center>-</span></div></td><td><div ng-if=row.LUPNumber><div class=lup ng-init="LUPNumbers = vm.getLupNumbers(row.LUPNumber)"><div class=lup ng-if=!row.LUPNumber><span class=center>-</span></div><div class=lup ng-if=LUPNumbers><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white;opacity: 1.0;font-size: 12px; color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="LUPNumber in LUPNumbers">{{LUPNumber}}&nbsp;</div></md-tooltip><span ng-repeat="item in LUPNumbers | limitTo:2">{{item}}</span></div></div></div><div ng-if=!row.LUPNumber><span class=center>-</span></div></td></tr></tbody><!-- Smart table footer : display pagination + Show closed FIC button --><tfoot style="background-color: white;border:none;"><tr id=paginationRow ng-show=!vm.isLoading><td class=text-center st-pagination="" st-items-by-page=30 st-displayed-pages=vm.numberOfPagesToDisplay colspan=12></td></tr></tfoot></table><div ng-if=!vm.btListFound>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div></div></span>');
$templateCache.put('app/components/btList/btListAdvanced.template.html','<span id=btlist><div><div class="small-12 columns searchButton"><div ng-if=vm.btListFixedCriteriasParams class="small-1 btnBack" ng-click=vm.goToDiagnosticSearch()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div></div><table class=responsive-table style=margin:5px st-table=btListTable st-set-filter=customStrictFilter st-safe-src=vm.displayed cellspacing=1><thead><tr><td colspan=13 style=width:100vw ng-style="{\'display\': !vm.showGlobalSearch ? \'table-cell\' : \'none\'}"><div ng-click="vm.showGlobalSearch = !vm.showGlobalSearch" style="margin:0px !important;cursor: pointer;" class=searchHead><div class=row style="text-align: center; font-weight: 700;font-size: var(--renaultLargeFont); margin: 0 auto; max-width: none;"><span ng-if=vm.globalSearch.vehicle_family>{{vm.globalSearch.vehicle_family}}</span> <span ng-if=vm.globalSearch.vehicle_type>&nbsp; / &nbsp;{{vm.globalSearch.vehicle_type}}</span> <span ng-if=vm.globalSearch.engine_family>&nbsp; / &nbsp;{{vm.globalSearch.engine_family}}</span> <span ng-if=vm.globalSearch.engine_type>&nbsp; / &nbsp;{{vm.globalSearch.engine_type}}</span> <span ng-if=vm.globalSearch.engine_index>&nbsp; / &nbsp;{{vm.globalSearch.engine_index}}</span> <span ng-if=vm.globalSearch.gearbox_family>&nbsp; / &nbsp;{{vm.globalSearch.gearbox_family}}</span> <span ng-if=vm.globalSearch.gearbox_type>&nbsp; / &nbsp;{{vm.globalSearch.gearbox_type}}</span> <span ng-if=vm.globalSearch.gearbox_index>&nbsp; / &nbsp;{{vm.globalSearch.gearbox_index}}</span> <span ng-if=vm.globalSearch.battery_family>&nbsp; / &nbsp;{{vm.globalSearch.battery_family}}</span> <span ng-if=vm.globalSearch.battery_type>&nbsp; / &nbsp;{{vm.globalSearch.battery_type}}</span> <span ng-if=vm.globalSearch.battery_index>&nbsp; / &nbsp;{{vm.globalSearch.battery_index}}</span> <span ng-if=vm.globalSearch.engine2_family>&nbsp; / &nbsp;{{vm.globalSearch.engine2_family}}</span> <span ng-if=vm.globalSearch.engine2_type>&nbsp; / &nbsp;{{vm.globalSearch.engine2_type}}</span> <span ng-if=vm.globalSearch.engine2_index>&nbsp; / &nbsp;{{vm.globalSearch.engine2_index}}</span> <span ng-if=vm.globalSearch.fromDate>&nbsp; - &nbsp; From &nbsp; {{vm.globalSearch.fromDate | date:\'mediumDate\'}} </span><span ng-if=vm.globalSearch.toDate>&nbsp; to &nbsp; To &nbsp; {{vm.globalSearch.toDate | date:\'mediumDate\'}} </span><span ng-if=vm.globalSearch.dtcCode>&nbsp; - &nbsp; {{vm.globalSearch.dtcCode}}</span> <span ng-if=vm.globalSearch.otsNumber>&nbsp; / &nbsp; {{vm.globalSearch.otsNumber}}</span> <span ng-if=vm.globalSearch.lupNumber>&nbsp; / &nbsp; {{vm.globalSearch.lupNumber}}</span> <span ng-if=vm.globalSearch.tripleFilter>&nbsp; - &nbsp; {{vm.globalSearch.tripleFilter}}</span> <span ng-if=vm.globalSearch.symptomSearch>&nbsp; / &nbsp; {{vm.globalSearch.symptomSearch}}</span></div><div style="max-width: none; text-align: right;margin-right: 0px !important;" class="hoverSearch row"><i class="fa fa-caret-down" style=font-size:25px;></i></div></div></td><td colspan=13 class=searchHead ng-style="{\'display\': vm.showGlobalSearch ? \'table-cell\' : \'none\'}"><form name=globalSearch style="display: inline-flex;"><div style="max-width: 50vw;"><div ng-repeat="field in vm.selectFields" id={{field.key}} ng-click=vm.divSelected(field.key) class="select-criterias column" style="float: left;padding: 0px 10px"><md-input-container md-no-float><md-select md-container-class=my-container name={{field.key}} ng-disabled=vm.rules[field.key] id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change=vm.mapFieldsToSearch(field.key,field.value) class={{field.class}}><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input></md-select-header><md-option ng-value=list ng-repeat="list in field.list | filter: search">{{list}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click=vm.resetSelectedFields(field.key,field.value)><md-button class=btn>X</md-button></div></div></div><div style="width: 50vw;padding-top: 5px;"><div class=row style="margin-bottom: 10px;"><div class="small-3 column" style=margin:0><div name=bt_nt style="margin: 0px;height: 30px;width: 100%; max-width: none;border: none;margin-top: 10px;\n                                                                box-shadow: none;">{{\'BT/NT_UPDATE\'|translate}}:</div></div><div class="small-3 column"><input type=text name=dtcCode ng-model=vm.globalSearch.dtcCode style="margin: 0px;height: 30px;width: 100%; max-width: none;border: none;\n                                                                border-bottom: 1px black solid;\n                                                                box-shadow: none;" placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\'|translate}}" aria-label="{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\'|translate}}" tabindex=16></div><div class="small-5 column"><input type=text name=tripleFilter ng-model=vm.globalSearch.tripleFilter style="margin: 0px;height: 30px;width: 100%; max-width: none;" placeholder="{{\'TEXT_TRIPLE_SEARCH\'|translate}}" tabindex=19 aria-label="{{\'TEXT_TRIPLE_SEARCH\'|translate}}"></div></div><div class=row style="margin-bottom: 10px;"><div id=fromDate class="small-3 column" style="margin: 0; padding: 0;"><md-datepicker ng-model=vm.globalSearch.fromDate md-placeholder="{{\'FROM_DATE\'|translate}}" tabindex=14 aria-label="{{\'FROM_DATE\'|translate}}"></md-datepicker></div><div id=otsNumber class="small-3 column"><input type=text name=otsNumber ng-model=vm.globalSearch.otsNumber style="margin: 0px;height: 30px;width: 100%; max-width: none;border: none;\n                                    border-bottom: 1px black solid;\n                                    box-shadow: none;" placeholder="{{\'OTS\'|translate}}" aria-label="{{\'OTS\'|translate}}" tabindex=17></div><div id=symptomSearch class="small-5 column"><input type=text name=symptomSearch ng-model=vm.globalSearch.symptomSearch style="margin: 0px;height: 30px;width: 100%; max-width: none;" placeholder="{{\'TEXT_SYMPTOM_SEARCH\'|translate}}" tabindex=20 aria-label="{{\'TEXT_SYMPTOM_SEARCH\'|translate}}"></div></div><div class=row style="display: inline-flex;"><div id=toDate class="small-3 column" style="margin: 0; padding: 0;"><md-datepicker ng-model=vm.globalSearch.toDate md-placeholder="{{\'TO_DATE\'|translate}}" tabindex=15 aria-label="{{\'TO_DATE\'|translate}}"></md-datepicker></div><div class="small-3 column" style=margin-left:4px><input type=text name=lupNumber ng-model=vm.globalSearch.lupNumber style="margin: 0px;height: 30px;width: 102%; max-width: none;border: none;\n                                        border-bottom: 1px black solid;\n                                        box-shadow: none;" placeholder="{{\'BTLIST_HEADER_LUPN\'|translate}}" aria-label="{{\'BTLIST_HEADER_LUPN\'|translate}}" tabindex=18></div><div class="small-6 column" style="text-align: center;display: flex;"><md-button class="md-raised buttonWithIcon" style="margin-left: 16%" type=submit ng-disabled="!(vm.globalSearch.vehicle_family || vm.globalSearch.vehicle_type || vm.globalSearch.engine_family || vm.globalSearch.engine_type || vm.globalSearch.engine_index || vm.globalSearch.gearbox_family || vm.globalSearch.gearbox_type || vm.globalSearch.gearbox_index || vm.globalSearch.battery_family || vm.globalSearch.battery_type || vm.globalSearch.battery_index || vm.globalSearch.engine2_family || vm.globalSearch.engine2_type || vm.globalSearch.engine2_index || vm.globalSearch.fromDate || vm.globalSearch.toDate || vm.globalSearch.dtcCode.length >= 3 || vm.globalSearch.otsNumber.length >= 3 || vm.globalSearch.lupNumber || vm.globalSearch.tripleFilter.length >=3 || vm.globalSearch.symptomSearch.length >= 3)" ng-click=vm.searchGlobal() tabindex=21 aria-label="{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}"><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button class="md-raised buttonWithIcon rePopulate" style="margin-left: 23px" ng-click=vm.reset()><div class=iconDiv><i class=icon-icons_refresh></i></div><div class=btnText>{{\'BT_LIST_RESET_DATA\' | translate}}</div></md-button></div></div></div><div style="margin-top: 125px;" ng-click="vm.showGlobalSearch = !vm.showGlobalSearch" style="text-align: right;" class=hoverSearch><i class="fa fa-caret-up" style=font-size:25px;></i></div></form></td></tr><tr><th st-sort=colorCode class="btlistheader withSort" style="width: 50px !important"></th><th st-sort=btListTable.name st-skip-natural=true class="btlistheader withSort" style="width: 95px !important">{{\'BTLIST_HEADER_REF\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_APPLICABILLITY_FIX\' | translate}}</th><th st-sort=residualInfo class="btlistheader withSort" style="width: 145px">{{\'BTLIST_HEADER_VARIABLE\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_CUSTOMER_EFFEECT\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_SOLUTION\' | translate}}</th><th class=btlistheader style="width: 230px">{{\'BTLIST_HEADER_INFORMATIONS\' | translate}}</th><th st-sort=state class="btlistheader withSort" style="width: 80px">{{\'BTLIST_HEADER_STATE\' | translate}}</th><th st-sort=creationDate st-skip-natural=true class="btlistheader withSort" style="width: 80px">{{\'COMMON_CREATION\' | translate}}</th><th st-sort=updateDate st-skip-natural=true class="btlistheader withSort" style="width: 90px">{{\'BTLIST_HEADER_UPDATE\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'SYMPTOM\' | translate}}</th><th class=btlistheader style="width: 80px">{{\'BTLIST_HEADER_LUPN\' | translate}}</th></tr><tr><th class="btlistheader1 colorCodeColumn" scope=col style="text-align: center;"><on-select-color options=vm.stSelectOptions></on-select-color><select id=customColorSelect class=custom-select placeholder=All ng-click=vm.onSelectColor(opt) ng-disabled=!vm.displayed ng-model=vm.searchColorCode style="margin:2%; font-size:11px;"><option ng-hide=true value="">ALL</option><option ng-hide=true value={{opt}} ng-repeat="opt in vm.colorCodesOrdered track by $index" ng-style="{\'color\' :opt}" style=font-size:var(--renaultMediumFont);>{{opt}}</option></select></th><th class=btlistheader1 scope=col st-search=name><input placeholder="{{\'ACTIS_ACCESSOIRES_REFERENCE\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch></th><th><input placeholder="{{\'FILTER_CRITERIA\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch st-search=applicabilityFix></th><th class=btlistheader1 scope=col></th><th colspan=3 class=btlistheader1 scope=col><input placeholder="{{\'BT_LIST_CUSTOM_FILTER\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch st-search=tripleFilter></th><th class=btlistheader1 scope=col><md-input-container><md-select md-container-class=selectState placeholder=All ng-change=vm.selectState(vm.showStates) ng-disabled=!vm.displayed ng-model=vm.showStates class=stateList><md-option value={{$index}} ng-selected=$first ng-repeat="item in vm.displayedResults track by $index" ng-model=item>{{item}}</md-option></md-select></md-input-container></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col></th><th class=btlistheader1 scope=col><input placeholder="{{\'ALERTS_CODE\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch st-search=dtcCodes></th><th class=btlistheader1 scope=col><input placeholder="{{\'ALERTS_CODE\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch st-search=symptomCodes></th><th class=btlistheader1 scope=col><input placeholder="{{\'BTLIST_HEADER_LUPN\' | translate }}" ng-disabled=!vm.displayed class=btlistCustomSearch st-search=LUPNumber></th></tr></thead><tbody ng-show=!vm.isLoading><tr ng-repeat="row in btListTable track by $index" ng-click=vm.searchBTByNumber(row) class=selectBTRow><td style="width: 50px !important; text-align: center;"><i class="fa fa-circle" style=font-size:15px; ng-if="row.colorCode != \'BLUE_WITH_FOLLOW_UP\' && row.colorCode != \'NO_COLOR\' && row.colorCode != \'BEIGE\'" ng-style="{\'color\':row.colorCode}"></i> <i class="fa fa-circle" style=font-size:15px; ng-if="row.colorCode == \'BLUE_WITH_FOLLOW_UP\'" ng-style="{\'color\':\'lightblue\'}"></i> <i class="fa fa-circle" style=font-size:15px; ng-if="row.colorCode == \'NO_COLOR\'" ng-style="{\'color\':\'lightgray\'}"></i> <i class="fa fa-circle" style=font-size:15px; ng-if="row.colorCode == \'BEIGE\'" ng-style="{\'color\':\'#C7A68B\'}"></i></td><td class=btnumberwidth style="text-align: center;" role=button>{{row.name}}</td><td><div ng-if=row.residual><div class=applicabilityfix><div class=applicabilityfix ng-if=!row.applicability><span class=center>-</span></div><div class=applicabilityfix ng-if=row.applicability><!-- <div ng-mouseenter="showTooltip()" ng-mouseleave="hideTooltip()"> --><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color: white;opacity: 1.0; color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="aplbty in row.applicability.tooltipApplicabilityFix | limitTo:25" style="line-height: 2">{{aplbty}}</div></md-tooltip><!-- </div> --> <span>{{row.applicability.applicabilityFix}}</span> <span ng-if="row.applicability.applicabilityFix.length>=25 || row.applicability.tooltipApplicabilityFix.length>1">...</span></div></div></div><div ng-if=!row.residual><span class=center>-</span></div></td><td style="text-align: center;"><div ng-if=row.residual style="margin-left: 5px"><!--  <div class="variable" ng-if="!row.residualInfo">\n                                    <span class="center">-</span>\n                                </div> --><div class=variable ng-if=row.residualInfo style="margin-right: 0px"><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color:white;opacity: 1.0;font-size: var(--renaultSmallFont); color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;" ng-if="row.residualInfo !=\'-\'"><div>{{row.residualInfo}} &nbsp;</div></md-tooltip>{{row.residualInfo}}</div></div></td><td><div class=nonvariable ng-if=!row.designation><span class=center>-</span></div><div class=nonvariable ng-if=row.designation><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: var(--renaultSmallFont); color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;"><div>{{row.designation}} &nbsp;</div></md-tooltip><span>{{row.designation | limitTo:30}}</span> <span ng-if="row.designation.length > 30">...</span></div></td><td><div class=nonvariable ng-if=!row.solution><span class=center>-</span></div><div class=nonvariable ng-if=row.solution><md-tooltip md-direction=right style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: var(--renaultSmallFont); color: black; border: 1.5px solid black;height: auto !important; max-width: 700px !important; white-space: normal;font-family: \'renaultGroupRegular\'"><div>{{row.solution}} &nbsp;</div></md-tooltip><span>{{row.solution | limitTo:30}}</span> <span ng-if="row.solution.length > 30">...</span></div></td><td><div class=nonvariable ng-if=!row.informations><span class=center>-</span></div><div class=nonvariable ng-if=row.informations><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color:white  ;opacity: 1.0;font-size: var(--renaultSmallFont); color: black; border: 1.5px solid black;height: auto !important; max-width: 500px !important; white-space: normal;"><div>{{row.informations}} &nbsp;</div></md-tooltip><span>{{row.informations | limitTo:30}}</span> <span ng-if="row.informations.length > 30">...</span></div></td><td style="text-align: center"><div class=state ng-if=!row.state><span class=center>-</span></div><div class=state ng-if=row.state>{{row.state}}</div></td><td style="text-align: center"><div ng-if=!row.creationDate><span class=center>-</span></div><div ng-if=row.creationDate>{{vm.formatDate(row.creationDate)}}</div></td><td style="text-align: center"><div ng-if=!row.updateDate><span class=center>-</span></div><div ng-if=row.updateDate>{{vm.formatDate(row.updateDate)}}</div></td><td><div ng-if=row.details.DTCList><div class=state><div class=state ng-if="row.details.DTCList.length == 0"><span class=center>-</span></div><div class=state ng-if="row.details.DTCList.length > 0"><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white; opacity: 1.0;color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="dtcCode in row.details.DTCList | limitTo:25 track by $index" style="line-height: 2">{{dtcCode}} &nbsp;</div><div style="font-size: var(--renaultMediumFont)" ng-if="row.details.DTCList.length>=25"><strong>...........</strong></div></md-tooltip><span ng-if="row.details.DTCList.length > 1" ng-repeat="dtcCode in row.details.DTCList | limitTo:2 track by $index">{{dtcCode}}, </span><span ng-if="row.details.DTCList.length == 1" ng-repeat="dtcCode in row.details.DTCList | limitTo:1 track by $index">{{dtcCode}} &nbsp;</span></div></div></div><div ng-if=!row.details.DTCList><span class=center>-</span></div></td><td><div ng-if=row.details.symptomList><div class=state><div class=state ng-if="row.details.symptomList.length==0"><span class=center>-</span></div><div class=state ng-if="row.details.symptomList.length > 0"><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white; opacity: 1.0;color: black; border: 1.5px solid black; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="smptmCode in row.details.symptomList | limitTo:25" style="line-height: 2">{{smptmCode.shortCode}} , {{smptmCode.label}} &nbsp;</div><div style="font-size: var(--renaultMediumFont)" ng-if="row.details.symptomList.length>=25">...........</div></md-tooltip><span ng-if="row.details.symptomList.length > 1" ng-repeat="item in row.details.symptomList | limitTo:3">{{item.shortCode}}, </span><span ng-if="row.details.symptomList.length == 1" ng-repeat="item in row.details.symptomList | limitTo:3">{{item.shortCode}}</span></div></div></div><div ng-if=!row.details.symptomList><span class=center>-</span></div></td><td><div ng-if=row.LUPNumber><div class=lup><div class=lup><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';background-color: white;opacity: 1.0;font-size: var(--renaultSmallFont); color: black; border: 1.5px solid black;height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="LUPNumber in row.LUPNumber">{{LUPNumber}}&nbsp;</div></md-tooltip><span ng-repeat="item in row.LUPNumber | limitTo:2">{{item}}</span></div></div></div><div ng-if=!row.LUPNumber><span class=center>-</span></div></td></tr></tbody><!-- Smart table footer : display pagination + Show closed FIC button --><tfoot style="background-color: white;border:none;"><tr id=paginationRow ng-show=!vm.isLoading><td colspan=13 class=text-center ng-show=vm.displayed style="position: relative;"><div st-pagination="" st-items-by-page=vm.pageSize st-displayed-pages=vm.numberOfPagesToDisplay></div><md-input-container style="position: absolute;top: 15%;left: 40%;" ng-if="btListTable.length >= vm.pageSize"><label>{{\'PAGE_SIZE\' | translate}} {{vm.pageSize}}</label><md-select ng-model=vm.pageSize ng-change=vm.pageSizeChange() placeholder="{{\'PAGE_SIZE\' | translate}}"><md-option ng-if="vm.displayed.length > 0" ng-value=vm.displayed.length>ALL</md-option><md-option ng-if="vm.displayed.length > 30" ng-value=30>30</md-option><md-option ng-if="vm.displayed.length > 50" ng-value=50>50</md-option><md-option ng-if="vm.displayed.length > 100" ng-value=100>100</md-option></md-select></md-input-container></td></tr></tfoot></table><div ng-if=!vm.btListFound>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div></div></span>');
$templateCache.put('app/components/chatbot/chatbot.html','<!-- Chatbot Component --><div class=chatbot-container ng-controller="ChatbotController as chatbotCtrl"><div class=chatbot-collapse-button ng-if="!chatbotCtrl.isExpanded && chatbotCtrl.isHealthy && chatbotCtrl.isNDAssistantEnabled" ng-click=chatbotCtrl.toggleChatbot()><md-icon md-svg-src=./assets/artificial-intelligence-filled.svg class=chatbot-ai-icon></md-icon><span class=chatbot-notification-badge ng-show="chatbotCtrl.messages.length > 3">!</span></div><!-- Expanded State - Full Chatbot --><div class=chatbot-widget ng-if="chatbotCtrl.isExpanded && chatbotCtrl.isHealthy && chatbotCtrl.isNDAssistantEnabled" ng-style="{\'width\': chatbotCtrl.chatWidth + \'px\', \'height\': chatbotCtrl.chatHeight + \'px\'}"><!-- Resize Handles --><div class="chatbot-resize-handle chatbot-resize-n" ng-mousedown="chatbotCtrl.startResize($event, \'n\')"></div><div class="chatbot-resize-handle chatbot-resize-ne" ng-mousedown="chatbotCtrl.startResize($event, \'ne\')"></div><div class="chatbot-resize-handle chatbot-resize-e" ng-mousedown="chatbotCtrl.startResize($event, \'e\')"></div><div class="chatbot-resize-handle chatbot-resize-se" ng-mousedown="chatbotCtrl.startResize($event, \'se\')"></div><div class="chatbot-resize-handle chatbot-resize-s" ng-mousedown="chatbotCtrl.startResize($event, \'s\')"></div><div class="chatbot-resize-handle chatbot-resize-sw" ng-mousedown="chatbotCtrl.startResize($event, \'sw\')"></div><div class="chatbot-resize-handle chatbot-resize-w" ng-mousedown="chatbotCtrl.startResize($event, \'w\')"></div><div class="chatbot-resize-handle chatbot-resize-nw" ng-mousedown="chatbotCtrl.startResize($event, \'nw\')"></div><!-- Chatbot Header --><div class=chatbot-header><div class=chatbot-header-left><span class=chatbot-title>NewDialogys Assistant</span></div><div class=chatbot-header-right><button class=chatbot-close-btn ng-click=chatbotCtrl.toggleChatbot()><i class="fa fa-times"></i></button></div></div><!-- Chat Area --><div class=chatbot-chat-area><div class=chatbot-messages><div ng-repeat="message in chatbotCtrl.messages track by message.id" class=chatbot-message ng-class="{\'chatbot-message-user\': message.type === \'user\', \'chatbot-message-bot\': message.type === \'bot\', \'chatbot-message-api\': message.sessionId || message.parts}"><div class=chatbot-message-avatar><i class="fa fa-user" ng-if="message.type === \'user\'"></i><md-icon md-svg-src=./assets/artificial-intelligence-filled.svg class=chatbot-avatar-icon ng-if="message.type === \'bot\'"></md-icon></div><div class=chatbot-message-content><!-- Message without parts or without {parts} placeholder --><div class=chatbot-message-text ng-if="!message.partsDetails || !message.partsDetails.references || message.partsDetails.references.length === 0 || !chatbotCtrl.hasPartsPlaceholder(message.content)">{{message.translationKey ? (message.translationKey | translate) : message.content}}</div><!-- Message with parts and {parts} placeholder - inject parts at placeholder position --><div class=chatbot-message-text ng-if="message.partsDetails && message.partsDetails.references && message.partsDetails.references.length > 0 && chatbotCtrl.hasPartsPlaceholder(message.content)"><span ng-bind-html=chatbotCtrl.getMessageBeforeParts(message.content)></span><div class=chatbot-part-item ng-repeat="ref in message.partsDetails.references track by $index"><span class=chatbot-part-number>{{$index + 1}}.</span> <span class=chatbot-part-reference ng-click=chatbotCtrl.goToProduct(ref) title="Click to view product details">{{ref.reference | filterFormatRef}} </span><span class=chatbot-part-separator>- </span><span class=chatbot-part-designation>{{ref.designation}}</span> <span ng-if=ref.brand class=chatbot-part-separator>- </span><span ng-if=ref.brand class=chatbot-part-brand>{{ref.brand}}</span> <button ng-if="ref.catalogPlates && ref.catalogPlates.length > 0" type=button class=chatbot-catalog-plate-wrapper ng-click="chatbotCtrl.goToCatalogPlate(ref, message.partsDetails.references); \n                                                  $event.stopPropagation()" aria-label="{{\'INTERVENTION_CATALOG_PLATE\' | translate}}" title={{chatbotCtrl.getCatalogPlateIds(ref)}}><img src=./assets/images/Eb_plate.svg alt="{{\'INTERVENTION_CATALOG_PLATE\' | translate}}" class=chatbot-catalog-plate-icon></button></div><span ng-bind-html=chatbotCtrl.getMessageAfterParts(message.content)></span></div><div class=chatbot-message-timestamp>{{chatbotCtrl.formatTimestamp(message.timestamp)}}</div></div></div><!-- Typing indicator --><div class=chatbot-typing-indicator ng-show=chatbotCtrl.isTyping><div class="chatbot-message chatbot-message-bot"><div class=chatbot-message-avatar><md-icon md-svg-src=./assets/artificial-intelligence-filled.svg class=chatbot-avatar-icon></md-icon></div><div class=chatbot-message-content><div class=chatbot-typing-dots><span></span> <span></span> <span></span></div></div></div></div></div></div><!-- Chat Input --><div class=chatbot-input-container><div class=chatbot-input-row><button ng-click=chatbotCtrl.startNewChat() class=chatbot-reset-btn title="Start new conversation"><md-icon md-svg-src=./assets/reset-icon.svg class=chatbot-reset-icon></md-icon></button><div class=chatbot-input-wrapper><textarea ng-model=chatbotCtrl.messageInput ng-keydown=chatbotCtrl.onEnterKey($event) placeholder="Ask your ND Assistant here..." class=chatbot-input-field rows=1></textarea></div><button ng-click=chatbotCtrl.sendMessage() ng-disabled=!chatbotCtrl.messageInput.trim() class=chatbot-send-btn><i class="fa fa-arrow-right"></i></button></div></div></div></div>');
$templateCache.put('app/components/doc-alerts/listAlerts.template.html','<span id=alertsList ng-if="vm.isTraceEnabled || vm.isTraceEnabledINT"><table class=table cellspacing=0 id=doc-alerts-list st-table=displayedList st-safe-src=vm.docAlertsList style=margin-top:2%><thead><tr id=table-heads><th class=large-2 ng-click="vm.sortBy(\'ticketNumber\')">{{"TICKET_NUMBER"|translate}} <i ng-class="vm.getSortHeaderClass(\'ticketNumber\')"></i></th><th class=large-1 ng-click="vm.sortBy(\'alertType\')">{{\'ALERT_TYPE\'|translate}} <i ng-class="vm.getSortHeaderClass(\'alertType\')"></i></th><th class=large-2 ng-click="vm.sortBy(\'documentType\')">{{"ALERTS_DOCUMENT_TYPE"|translate}} <i ng-class="vm.getSortHeaderClass(\'documentType\')"></i></th><th class=large-1 ng-click="vm.sortBy(\'status\')">{{"COMMON_STATUS"|translate}} <i ng-class="vm.getSortHeaderClass(\'status\')"></i></th><th class=large-1>{{"ACTIS_VEHICLE_VIN"|translate}}</th><th class=large-2 ng-click="vm.sortBy(\'creationDate\')">{{"ALERTS_CREATION_DATE"|translate}} <i ng-class="vm.getSortHeaderClass(\'creationDate\')"></i></th><th class=large-2 ng-click="vm.sortBy(\'creatorIpn\')">{{"CREATOR_IPN"|translate}} <i ng-class="vm.getSortHeaderClass(\'creatorIpn\')"></i></th></tr><tr id=table-filters><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=ticketNumber placeholder="{{\'CARSEARCH_SEARCH_BUTTON\'|translate}}" ng-model=vm.ticketNumber class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=documentType placeholder=Document ng-model=vm.documentType class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=alertType placeholder=Document ng-model=vm.alertType class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=status placeholder=Document ng-model=vm.status class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=vin placeholder="{{\'CARSEARCH_SEARCH_BUTTON\'|translate}}" ng-model=vm.vin class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=creationDate placeholder=yyyy-mm-dd ng-model=vm.creationDate class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input st-search=creatorIpn placeholder="{{\'CARSEARCH_SEARCH_BUTTON\'|translate}}" ng-model=vm.creatorIpn class=materialInput type=text></md-input-container><i class="icon-icons_search search-icon"></i></div></th><th class=large-1><md-button ng-click=vm.resetSearch() class="btn search-reset">X<md-tooltip><span>{{\'COMMON_REINIT\' | translate}}</span></md-tooltip></md-button></th></tr></thead><tbody><tr ng-repeat="row in displayedList track by $index" class=clickable-row><td class=large-2 ng-click=vm.openTicketDetails(row)>{{ row.ticketNumber }}</td><td class=large-1 ng-click=vm.openTicketDetails(row)>{{row.documentType}}</td><td class=large-1 ng-click=vm.openTicketDetails(row)>{{row.alertType }}</td><td class=large-2 ng-click=vm.openTicketDetails(row)><i class="fa fa-circle" ng-class=vm.getStatusCircleClass(row.status) ng-if=row.status></i> <span ng-if=row.status>{{ row.status }}</span></td><td class=large-2 ng-click=vm.openTicketDetails(row)>{{ row.vin }}</td><td class=large-1 ng-click=vm.openTicketDetails(row)>{{ row.creationDate | date: \'yyyy-MM-dd\' }}</td><td class=large-1 ng-click=vm.openTicketDetails(row)>{{ row.creatorIpn }}</td></tr></tbody><tr ng-if=vm.emptyList><td colspan=8>{{"NO_DATA_FOUND"|translate}}</td></tr></table></span><div class=ticket-popup-overlay ng-show=vm.showTicketPopup ng-click=vm.closeTicketPopup()><div class=ticket-popup-container ng-click=$event.stopPropagation()><div class=ticket-popup-header><h2 class=ticket-popup-title><strong>{{"DOCUMENTARY_ALERT" | translate}} {{vm.selectedTicket.ticketNumber || \'-\'}}</strong></h2><button class=ticket-popup-close ng-click=vm.closeTicketPopup()><i class="fa fa-times"></i></button></div><div class=ticket-popup-loading ng-show=vm.isLoadingTicketDetails><i class="fa fa-spinner fa-spin"></i> <span>{{"DOCUMENTARY_ALERT_LOADING" | translate}}...</span></div><div class=ticket-popup-content ng-show="!vm.isLoadingTicketDetails && vm.ticketDetails"><div class=ticket-section><div class=ticket-section-header ng-click="vm.toggleSection(\'ticketDetails\')"><div class=collapse-button><i class=fa ng-class="vm.sectionStates.ticketDetails ? \'fa-chevron-up\' : \'fa-chevron-down\'"></i></div><h3 class=ticket-section-title>{{"TICKET_DETAILS" | translate}}</h3></div><div class=ticket-section-content ng-show=vm.sectionStates.ticketDetails><div class=ticket-details-columns><div class=ticket-details-column><div class=ticket-field><span class=field-label>{{"VEHICLE_MODEL" | translate}}</span> <span class=field-value>{{vm.ticketDetails.vehicleDetail.carModel || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"ALERTS_VIN" | translate}}</span> <span class=field-value>{{vm.ticketDetails.vehicleDetail.vin || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"ALERTS_REGISTRATION" | translate}}</span> <span class=field-value>{{vm.ticketDetails.vehicleDetail.registrationNumber || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"VEH_COVERED_BY_WARRANTY" | translate}}</span> <span class=field-value>{{(vm.ticketDetails.problemDescription.vehicleCoveredByWarranty !== undefined) ? (vm.ticketDetails.problemDescription.vehicleCoveredByWarranty) : \'-\'}}</span></div></div><div class=ticket-details-column><div class=ticket-field><span class=field-label>{{"COMMON_STATUS" | translate}}</span> <span class=field-value>{{vm.ticketDetails.ticket.status || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"CREATOR_NAME" | translate}}</span> <span class=field-value>{{(vm.ticketDetails.logs && vm.ticketDetails.logs.length > 0) ? vm.ticketDetails.logs[0].creatorName : \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"CREATION_DATE" | translate}}</span> <span class=field-value>{{(vm.ticketDetails.logs && vm.ticketDetails.logs.length > 0) ? vm.formatDate(vm.ticketDetails.logs[0].created) : \'-\'}}</span></div></div></div></div></div><div class=ticket-section><div class=ticket-section-header ng-click="vm.toggleSection(\'problemDescription\')"><div class=collapse-button><i class=fa ng-class="vm.sectionStates.problemDescription ? \'fa-chevron-up\' : \'fa-chevron-down\'"></i></div><h3 class=ticket-section-title>{{"PROBLEM_DESCRIPTION" | translate}}</h3></div><div class=ticket-section-content ng-show=vm.sectionStates.problemDescription><div class=problem-description-layout><div class=problem-left-column><div class=ticket-field><span class=field-label>{{"CAR_SPLITS_DETAIL_TYPE" | translate}}</span> <span class=field-value>{{vm.mapIssueOrigin(vm.ticketDetails.problemDescription.issueOrigin) || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"DOCUMENT_ID" | translate}}</span> <span class=field-value>{{vm.ticketDetails.problemDescription.documentId || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"CUSTOMER_EFFECT" | translate}}</span> <span class=field-value>{{vm.translateCustomerEffect(vm.ticketDetails.problemDescription.customerEffect)}}</span></div><div class=ticket-field><span class=field-label>{{"DESCRIPTION_RAISED" | translate}}</span> <span class=field-value ng-bind-html="(vm.ticketDetails.problemDescription.problemDesc || \'-\') | newlinesToBr"></span></div><div class=ticket-field><span class=field-label>{{"ALERTS_TEMPORARY_SOLUTION" | translate}}</span> <span class=field-value>{{vm.ticketDetails.problemDescription.temporarySolution || \'-\'}}</span></div></div><div class=problem-right-column><div class=ticket-field><span class=field-label>{{"ASSOCIATED_CIR" | translate}}</span> <span class=field-value>{{vm.ticketDetails.problemDescription.ficCirAssociated || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"PART_ASSOCIATED_CIR" | translate}}</span> <span class=field-value>{{vm.ticketDetails.problemDescription.partAssociatedNumber || \'-\'}}</span></div></div></div></div></div><div class=ticket-section><div class=ticket-section-header ng-click="vm.toggleSection(\'solution\')"><div class=collapse-button><i class=fa ng-class="vm.sectionStates.solution ? \'fa-chevron-up\' : \'fa-chevron-down\'"></i></div><h3 class=ticket-section-title>{{"BTLIST_HEADER_SOLUTION" | translate}}</h3></div><div class=ticket-section-content ng-show=vm.sectionStates.solution><div class=problem-description-layout><div class=problem-left-column><div class=ticket-field><span class=field-label>{{"DOCUMENTARY_CORRECTION" | translate}}</span> <span class=field-value>{{vm.ticketDetails.documentaryCorrection || \'-\'}}</span></div><div class=ticket-field><span class=field-label>{{"ESTIMATED_DATE_OF_MODIFICATION" | translate}}</span> <span class=field-value>{{vm.formatDate(vm.ticketDetails.estimatedDateOfModification) || \'-\'}}</span></div></div><div class=problem-right-column></div></div><div class=add-comment-section><div class=comment-author><i class="fa fa-user rightIcon"></i> <strong>{{vm.profil.firstName}} {{vm.profil.lastName}}</strong></div><div class=comment-input-container><div class=comment-textarea-wrapper><label for=newCommentTextarea class=sr-only>Add a new comment</label> <textarea id=newCommentTextarea ng-model=vm.newComment placeholder="Add a new comment here..." class=comment-textarea ng-disabled="vm.ticketDetails.ticket.status !== \'Answer available\'">\n                                </textarea><upload-file id-file=importFile file=vm.file file-type-support="[\'all\']" file-error=vm.fileError file-type-error=vm.fileTypeError file-array=vm.attachedFiles disabled-condition="vm.ticketDetails.ticket.status !== \'Answer available\'" list-alerts=true></upload-file></div><div class="message-content small-font red-color" ng-if=vm.fileError><span translate=ALERTS_ERROR_FILE_SIZE translate-values="{size: 0.7}"></span></div><div class="message-content small-font red-color" ng-if=vm.fileTypeError>{{\'ALERTS_ERROR_FILE_TYPE\' | translate}}</div><div class="message-content small-font" ng-repeat="file in vm.attachedFiles" ng-if="vm.attachedFiles.length > 0"><span>{{file.file.name}}</span> <span>{{file.file.humanSize}}</span> <i ng-click=vm.deleteAttachment($index) class=icon-icons_remove></i></div></div><div class=comment-buttons><button class="btn btn-link-cancel" ng-click=vm.cancelComment() ng-disabled="!vm.newComment || vm.newComment.trim() === \'\'">{{"COMMON_CANCEL" | translate}}</button> <button class="btn btn-success" ng-click=vm.postComment() ng-disabled="!vm.newComment || vm.newComment.trim() === \'\'">{{"ATTACH_POST" | translate}}</button></div><div class=comment-separator></div></div><div class=solution-messages ng-class="{\'solution-messages-empty\': vm.combinedAndSortedItems.length === 0}"><div class=message-item ng-repeat="item in vm.combinedAndSortedItems track by item.uuid" ng-if="vm.combinedAndSortedItems.length > 0"><div class=message-header><div class=message-author><i class="fa rightIcon" ng-class="item.type === \'attachment\' ? \'fa-paperclip\' : \'fa-user\'"></i> <strong>{{item.creatorName}}</strong></div><div class=message-date>{{vm.formatMessageDate(item.created)}}</div></div><div class=message-content><span ng-if="item.type === \'message\'" ng-bind-html="item.text | newlinesToBr"></span> <a ng-if="item.type === \'attachment\'" href=# class=attachment-link ng-click="vm.downloadAttachment(item, $event)">{{item.name}}</a></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/docpriv/docpriv.template.html','<div id=docPrivListView><div class=recapCars><div id=docprivDesign class=rows><div class="large-1 margin-3 medium-2 columns" ng-click="vm.divSelected(\'FAMILY_NAME\')"><md-input-container><label>{{\'FAMILY_LABEL\' | translate}}</label><md-select md-container-class=my-container id=FAMILY_NAME ng-change=vm.updateBrand(vm.familyName) placeholder="{{\'FAMILY_LABEL\' | translate}}" ng-model=vm.familyName class="md-selected selectStyle"><md-select-header class=demo-select-header><input ng-model=vm.familyNameSelect type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=family.criteriaCode ng-repeat="family in vm.families | filter:vm.filterList(vm.familyNameSelect) | orderBy:\'criteriaCode\'" ng-class="{\'nissanOptionFocus\': vm.nissanUserURL, \'renaultOptionFocus\': !vm.nissanUserURL}">{{family.criteriaCode}} - {{family.label}}</md-option></md-select></md-input-container><div ng-if=vm.familyName ng-click="vm.familyName = \'\'; vm.familyNameSelect = \'\'; vm.updateBrand(vm.familyName)"><md-button class=btn>X</md-button></div></div><div class="large-1 margin-3 medium-2 columns" ng-click="vm.divSelected(\'BRAND_NAME\')"><md-input-container><label>{{\'VEHICLE_BRAND\'|translate}}</label><md-select md-container-class=my-container id=BRAND_NAME ng-click="" placeholder="{{\'VEHICLE_BRAND\'|translate}}" ng-model=vm.brandName class="md-selected selectStyle" input-clear=black><md-select-header class=demo-select-header><input ng-model=vm.brandName type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=brand ng-repeat="brand in vm.brands | filter:vm.brandName  | orderBy:\'brand\'" ng-class="{\'nissanOptionFocus\': vm.nissanUserURL, \'renaultOptionFocus\': !vm.nissanUserURL}">{{brand}}</md-option></md-select></md-input-container></div><div class="large-1 margin-3 medium-2 columns" ng-click="vm.divSelected(\'TREE_NODE\')" style="font-size: var(--renaultMediumFont) !important"><md-input-container><label>{{\'TREE_NODE\' | translate}}</label><md-select md-container-class=my-container id=TREE_NODE ng-click="" placeholder="{{\'TREE_NODE\' | translate}}" ng-model=vm.treeNodeValue class="md-selected selectStyle" input-clear=black><md-select-header class=demo-select-header><input ng-model=vm.treeNodeValue type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=treeNode class=docprivDropdownList ng-repeat="treeNode in vm.treeNodes | filter:vm.treeNodeValue" ng-class="{\'nissanOptionFocus\': vm.nissanUserURL, \'renaultOptionFocus\': !vm.nissanUserURL}">{{treeNode}}</md-option></md-select></md-input-container><md-tooltip md-direction=bottom class=docprivLabelTooltip><span>{{vm.treeNodeValue}}</span></md-tooltip></div><div class="large-1 margin-3 medium-2 columns" ng-click="vm.divSelected(\'GIE_LABEL\')" style="font-size: var(--renaultMediumFont) !important"><md-input-container><label>{{\'GIE_LABEL\' | translate}}</label><md-select md-container-class=my-container ng-disabled=!vm.familyName id=GIE_LABEL ng-click=vm.getGieData() placeholder="{{\'GIE_LABEL\' | translate}}" ng-model=vm.gieValue class="md-selected selectStyle" input-clear=black><md-select-header class=demo-select-header><input ng-model=vm.gieValue type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=gie class=docprivDropdownList ng-repeat="gie in vm.gieList | filter:vm.gieValue" ng-class="{\'nissanOptionFocus\': vm.nissanUserURL, \'renaultOptionFocus\': !vm.nissanUserURL}">{{gie}}</md-option></md-select></md-input-container><md-tooltip md-direction=bottom class=docprivLabelTooltip><span>{{vm.gieValue}}</span></md-tooltip></div><div class="large-1 margin-3 medium-2 columns" ng-click="vm.divSelected(\'PLATE_NUMBER\')"><md-input-container><label>{{\'PLATE_NUMBER\'|translate}}</label><md-select md-container-class=my-container ng-disabled=!vm.familyName id=PLATE_NUMBER ng-click=vm.getPlate() placeholder="{{\'PLATE_NUMBER\'|translate}}" ng-model=vm.plateNumber class="md-selected selectStyle" input-clear=black><md-select-header class=demo-select-header><input ng-model=vm.plateNumber type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=plate ng-repeat="plate in vm.plateNumberList | filter:vm.plateNumber  | orderBy:\'plate\'" ng-class="{\'nissanOptionFocus\': vm.nissanUserURL, \'renaultOptionFocus\': !vm.nissanUserURL}">{{plate}}</md-option></md-select></md-input-container></div><div class="large-1 margin-3 medium-2 columns"><md-input-container style="height: 37px;font-family: var(--renaultFontRegular);"><label>{{\'GENERIC_LABEL\'|translate}}</label> <input type=text style="width:170px; border-radius: 5px; text-transform: uppercase;" name=genericPart ng-model=vm.genericPart input-clear=black ng-disabled=!vm.familyName class=selectStyle></md-input-container></div><div class="large-1 margin-3 medium-2 columns"><md-input-container style="height: 37px;font-family: var(--renaultFontRegular);"><label>{{\'COMMON_REFERENCE\' | translate}}</label> <input type=text style="width:170px; border-radius: 5px; text-transform: uppercase;" name=partNumber id=PART_NUMBER ng-model=vm.partNumber maxlength=13 input-clear=black ng-change=vm.formatReferenceInput()></md-input-container></div><div class="large-1 medium-2 columns searchButton"><md-button class=md-raised type=submit ng-disabled="!(vm.familyName || vm.partNumber)" ng-click=vm.onValidate() style="box-shadow: unset;"><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button></div><div class="large-1 medium-2 columns resetButton"><md-button class="md-raised cancel" ng-click=vm.onReset() style="box-shadow: unset;"><div class=btnText style="padding-left: 14px;">{{\'COMMON_REINIT\' | translate}}</div></md-button></div></div></div><doc-priv-plates request-body=vm.requestBody is-plates-list=vm.isPlatesList is-parts-list=vm.isPartsList ng-if=vm.isPlatesList selected-doc-plate=vm.selectedDocPlate list-of-plate=vm.listOfPlate deleted-plates=vm.deletedPlates show-full-docpriv-results=vm.showFullDocprivResults master-plates=vm.masterPlates show-deleted-plate=vm.showDeletedPlate></doc-priv-plates><doc-priv-parts is-plates-list=vm.isPlatesList is-parts-list=vm.isPartsList selected-doc-plate=vm.selectedDocPlate ng-if=vm.isPartsList list-of-plate=vm.listOfPlate set-plate-details=vm.setPlateDetails parts-list=vm.partsList></doc-priv-parts></div>');
$templateCache.put('app/components/login/connection.template.html','<div id=connectionP><div class=headerCP ng-if=!ctrl.nissanUserURL><nav role=navigation><div class=logoCP><span>GROUPE</span> <span style="color: white;">RENAULT</span> <span id=current_version style="color: #fff;float: right;margin-right: 2rem;">{{::ctrl.version}}</span></div><div class=hide id=current_version>V{{::ctrl.version}}</div></nav></div><div ng-if=ctrl.nissanUserURL style="background-color: #C3002F;"><nav role=navigation><div class=logoCP><img src=./assets/images/Nissan-Brand-Wordmark.png width=90 height=30 alt="Nissan Brand logo"> <span><img src=./assets/images/Nissan-Brand-Logo-RGB-W.png width=36 height=24 alt="Nissan brand icon" style="top: -2px;position: relative;margin-left: 7px;"> </span><span id=current_version style="color: black;float: right;margin-right: 2rem;">{{::ctrl.version}}</span></div></nav></div><!-- <snow-flake></snow-flake> --><div class=carSearchMainBg ng-class="{\'renaultCarClass\': !ctrl.nissanUserURL, \'nissanCarClass\': ctrl.nissanUserURL}"><div class="marginTitle logoHeight"><div ng-class="{\'logoHeader\': true}" ng-if=!ctrl.nissanUserURL><span class=renault-vertical-line></span> <span>NEW DIALOGYS</span></div></div><div class=marginTitle layout=row layout-align=start style="margin-left:11%;display: inline-block;margin-top: 10px;"><div><div class=row style="max-width: none;"><div class=small-12><md-card class="connectBloc cardDesignArca" ng-style="ctrl.nissanUserURL && {\'width\':\'155%\',\'margin-top\':\'30%\'}"><md-card-title class=titleConnectionCard style="max-height:100px;text-overflow: clip;padding:3% 5% 0% 5%;"><h1 ng-if=!ctrl.nissanUserURL class=logInTitleRenault>{{\'GROUP_RENAULT_ACCESS\' | translate}}</h1><h1 ng-if=ctrl.nissanUserURL style="padding: 0 10px;" class=logInTitleRenault>{{\'NISSAN USERS\'}}</h1></md-card-title><md-card-actions style="padding: 5% 6% 13% 6%;" ng-style="ctrl.nissanUserURL && {\'padding\': \'0% 6% 13% 6%\'}"><md-button ng-click="ctrl.redirection(\'ARCA\')" ng-if=!ctrl.nissanUserURL class=connectButton ng-class="{\'renault-class\': !ctrl.nissanUserURL, \'nissan-class\': ctrl.nissanUserURL}"><div class=connection>{{\'ARCA_SIGN_IN\' | translate}}</div><md-tooltip style="background-color: rgba(0, 0, 0, 0.7);\n                                    margin-left: 7%;\n                                    margin-top: 9px;\n                                    width: 14%;\n                                    white-space: initial;\n                                    height: auto;\n                                    font-family: renaultGroupBold;">{{ \'ARCA_SIGN_IN_TOOLTIP\' | translate }}</md-tooltip></md-button><md-button ng-click="ctrl.redirection(\'RNET\')" ng-class="{\'renault-class\': !ctrl.nissanUserURL, \'nissan-class\': ctrl.nissanUserURL}" class=connectButton style="margin-top: 17%;  margin-left: 0;"><div class=connection>{{\'TOKEN_SIGN_IN\' | translate}}</div><md-tooltip style="background-color: rgba(0, 0, 0, 0.7);\n                                    margin-left: 7%;\n                                    margin-top: 9px;\n                                    width: 14%;\n                                    white-space: initial;\n                                    height: auto;\n                                    font-family: renaultGroupBold;">{{ \'TOKEN_SIGN_IN_TOOLTIP\' | translate }}</md-tooltip></md-button></md-card-actions></md-card></div></div></div><div><div class=small-12><form name=gigyaForm><md-card class="connectBloc cardDesignIndependent" ng-style="ctrl.nissanUserURL && {\'width\':\'155%\'}"><md-card-title class=titleConnectionCard style="max-height:100px;text-overflow: clip;padding:3% 5% 2% 5%;"><h1 ng-if=!ctrl.nissanUserURL class="logInTitleExternal renaultFontColor">{{\'OTHER_ACCESS\' | translate}}</h1><h1 ng-if=ctrl.nissanUserURL class="logInTitleExternal nissanFontColor">{{\'INDEPENDENT_OPERATORS\' | translate}}</h1></md-card-title><md-input-container ng-if=!ctrl.nissanUserURL class="small-10 small-offset-1 column min-height-35 md-icon-right" md-is-error="ctrl.isSubmitted && gigyaForm.email.$valid == false"><label class="color-black italicLabel">{{\'EXTERNAL_LOGINID\' | translate}}</label> <input class=displayConnectionInputNoMargin style="background: rgba(255,255,255,0);width: 95%;\n                                border-bottom: 2px solid black;" ng-model=ctrl.form.email type=text name=email required ng-pattern=/^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,10})$/ ><md-icon style="margin-top: -3px;right: -13px;"><i class="fa fa-envelope" style="font-size: var(--renaultLargeFont);color:black !important;"></i></md-icon></md-input-container><md-input-container ng-if=!ctrl.nissanUserURL class="small-10 small-offset-1 column min-height-35 md-icon-right" md-is-error="ctrl.isSubmitted && gigyaForm.password.$valid == false"><label class="color-black italicLabel">{{\'EXTERNAL_PASSWORD\' | translate}}</label> <input type=password ng-model=ctrl.form.password required name=password ng-pattern=/\\S/ style="background: rgba(255,255,255,0);width: 95%;\n                                border-bottom: 2px solid black;"><md-icon style="margin-top: -3px;right: -13px;"><i class="fa fa-lock" style="font-size: var(--renaultExtraLargeFont);color:black !important;"></i></md-icon></md-input-container><md-card-actions style="margin: 2px 0px 2px 0px;padding: 0% 8% 0% 8%;" ng-style="ctrl.nissanUserURL && {\'padding\': \'5% 8% 17% 10%\'}"><md-button ng-click="!ctrl.nissanUserURL && ctrl.gigyaLogin(gigyaForm) || ctrl.nissanUserURL && ctrl.b2bPortal()" class=connectButton ng-class="{\'renault-class\': !ctrl.nissanUserURL, \'nissan-class\': ctrl.nissanUserURL}" style="margin-bottom: 4%;"><div ng-if=!ctrl.nissanUserURL class=connection>{{\'SIGN_IN\' | translate}}</div><div ng-if=ctrl.nissanUserURL class=connection>{{\'IMT_SIGN_UP\' | translate}}</div><md-tooltip ng-if=!ctrl.nissanUserURL style="background-color: rgba(0, 0, 0, 0.7);\n                                    margin-left: 7%;\n                                    margin-top: 9px;\n                                    width: 14%;\n                                    white-space: initial;\n                                    height: auto;\n                                    font-family: renaultGroupBold;">{{ \'SIGN_IN_TOOLTIP\'|translate }}</md-tooltip></md-button><md-button ng-if=!ctrl.nissanUserURL ng-click=ctrl.gigyaLogin(gigyaForm) class="connectButton renault-class-offers"><div class=connection ng-href ng-click=ctrl.subscribeOrRequestForgottenPassword() target=_blank>{{\'SIGN_UP\' | translate}}</div><md-tooltip style="background-color: rgba(0, 0, 0, 0.7);\n                                    margin-left: 7%;\n                                    margin-top: 9px;\n                                    width: 14%;\n                                    white-space: initial;\n                                    height: auto;\n                                    font-family: renaultGroupBold;">{{ \'SIGN_UP_TOOLTIP\'|translate}}</md-tooltip></md-button></md-card-actions><md-text-float ng-if=!ctrl.nissanUserURL class="small-12 column min-height-35 forgottenPasswordMargin" style="text-align: center;"><a ng-href ng-click=ctrl.subscribeOrRequestForgottenPassword() target=_blank class=linkSubscriptionOrForgottenPassword style="color:black;vertical-align: middle;">{{\'FORGOTTEN_PASSWORD\' | translate}}</a></md-text-float></md-card></form></div></div></div><div class="row emergencyGuide" ng-if=!ctrl.nissanUserURL><div class="small-12 buttonLeft"><md-button ng-click="ctrl.openEmergencyLink(); $event.currentTarget.blur(); $event.preventDefault();" target=_blank class="connectButton2 mediaWidth" style="margin: 0;border-radius: 2px;" ng-mouseout=$event.currentTarget.blur()><div style="width:227px;line-height:initial;margin-top: 1%;"><md-text-float class="small-12 column" style="padding: 0;"><a class=emergencyButton style="color:white;white-space: initial;font-family: renaultGroupBold;">{{\'EMERGENCY_SUPPORT_SERVICE_LINK\' | translate}}</a></md-text-float></div><div><img src=./assets/images/siren.png alt="" width=25px ng-style="{top: ctrl.newUiEnable ? \'5px\' : \'-6px\'}" style="left:-7px;position: relative;"></div></md-button></div></div><div class=legalText style="font-size:var(--renaultSmallFont); font-weight:100; color:white; background-color: rgba(19, 18, 18, 0.468); font-family: \'renaultGroupRegular\';position: fixed;left: 5%;"><span style="width: 95%; display: block;">{{ ctrl.nissanUserURL ? \'NISSAN_RGPD_BIG_NOTICE\' : \'RGPD_BIG_NOTICE\' | translate }} <a ng-click=ctrl.openDataProtectionLink() style="cursor: pointer; color: white; font-weight: bold;" target=_blank ng-class="{\'inactive\':!ctrl.ndDataPolicyUrlisActive}"><u>{{\'RGPD_LEGAL_NOTICE\' | translate}}</u></a></span></div><!--        <div class="small-12 marginTitle" layout="column" layout-align="start">--><!--        </div>--></div></div><!-- <script type="text/javascript" src="./accessibility.min.js"></script> -->');
$templateCache.put('app/components/login/default.template.html','<div id=connectionP><div class=headerCP ng-if=!ctrl.nissanUserURL><nav role=navigation><div class=logoCP><span>GROUPE</span> <span>RENAULT</span></div></nav></div><div class=headerCP ng-if=ctrl.nissanUserURL style="background-color: #C3002F;"><nav role=navigation><div class=logoCP><img src=./assets/images/Nissan-Brand-Wordmark.png width=90 height=30 alt="Nissan Brand logo"> <span><img src=./assets/images/Nissan-Brand-Logo-RGB-W.png width=36 height=24 alt="Nissan brand icon" style="top: -2px;position: relative;margin-left: 7px;"></span></div></nav></div><div class="carSearchMainBg flex-1"></div></div>');
$templateCache.put('app/components/login/multiProfile.template.html','<div class=multiProfileClass><div class=row><div class="small-1 columns userIcon"><i class="fa fa-user"></i></div><div class="small-11 columns" style="right: 2.5%;" ng-class="{\'userProfile\': !vm.nissanUserURL, \'nissanUserProfile\': vm.nissanUserURL}">{{\'DOCUMENTARYERROR_HELLO_LABEL\' | translate}} {{vm.userName}}</div></div><div class="row selectProfile">Select a profile :</div><div class=row ng-repeat="userContext in vm.userContextList track by $index"><div ng-if="userContext.uid != \'\' && userContext.siteSourceId != \'\' && userContext.brand != \'\'"><md-radio-group ng-model=vm.selectedUid required><md-radio-button value={{userContext.id}} class=line ng-class="{\'nissanRadio\': vm.nissanUserURL, \'renaultRadio\': !vm.nissanUserURL}" style="padding:5px 0; margin:0px;"><span ng-style="{\'border-bottom\': $last ? \'none\':\'2px solid lightgray\'}" style="padding-bottom: 6px;white-space:nowrap;font-size:90%;bottom: 10px;\n                        position: relative;">{{userContext.uid}} - {{userContext.siteSourceId}} - {{userContext.siteName}} &nbsp; <span ng-repeat="brand in userContext.brand"><img class=renoIcons ng-src={{vm.getLogo(brand)}} alt=""></span></span></md-radio-button></md-radio-group></div></div><div class=buttonGroups><button style="height: 100%; min-width: 30%;border: none;" class=submit ng-style="{\'background-color\': vm.nissanUserURL ? \'#C3002F\' : $root.renaultPrimaryColor}" ng-click=vm.onSelect(vm.selectedUid) ng-disabled=!vm.selectedUid><div class=iconDiv><i class="fa fa-check"></i></div><div class=btnText>{{\'LOGIN_SUBMIT_LABEL\' | translate}}</div></button> <button style="height: 100%;min-width: 30%;margin-left: 20%;" class=cancel ng-click=vm.onCancel()><div class=iconDiv><i class="fa fa-close"></i></div><div class=btnText>{{\'ACTIS_HEADER_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/partRequisition/operationUpdate.template.html','<div class=multipleOperation style="margin: 20px; width: 500px;"><div ng-click=vm.onClose()><i class="fa fa-close closeWarnPopup"></i></div><div style=padding:6px><i class="fa fa-files-o" aria-hidden=true style="font-size: 20px;cursor:pointer;"></i> {{\'REPLICATE_OPERATION\'|translate}}</div><div style=padding:6px>{{\'OPERATION_UPDATE\'|translate}}</div></div>');
$templateCache.put('app/components/partRequisition/partRequisition.template.html','<div class=containerView ng-if=!vm.loading id=createPartRequisition><!--BLOC HEADER --><div ng-if="vm.showOrderModeView == false"><div class="row headerPartList" ng-style="{\'margin-top\' : (vm.isRpartsRole) ? \'0px\':\'25px\'}"><div class="small-1 columns numPartList"><div class=backPartList ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-5 columns"><!-- <span class="labelNumPartList">\n                {{\'LABEL_NUM_PARTLIST\' |translate}} {{vm.partsRequisition.number}}\n                <span ng-if="vm.partsRequisition.rpsOrderId">\n                    {{\'AND_R_PART_STORE_ORDER_ID\' | translate}} {{vm.partsRequisition.rpsOrderId}}\n                </span>\n            </span> --> <label class="labelValidateByPartList size-14">{{\'CREATE_DATE\' |translate}} {{vm.partsRequisition.creationDateTime | date:\'yyyy/MM/dd\' }} {{\'ACTION_BY\' |translate}} {{vm.partsRequisition.creatorIPN}}</label> <label ng-if="vm.partsRequisition.lastModificationDateTime != \'\'" class="labelValidateByPartList size-14">{{\'UPDATE_DATE\' |translate}} {{vm.partsRequisition.lastModificationDateTime | date:\'yyyy/MM/dd\' }} {{\'ACTION_BY\' |translate}} {{vm.partsRequisition.lastModifierIPN}}</label></div><div class="small-5 columns listPartListAction"><div ng-click=vm.savePartRequisition(vm.partsRequisition) class=clickable><i class=icon-icons_save_partlist></i> <label>{{\'BUTTON_ESTIMATE_SAVE\' |translate}}</label></div><div ng-click=vm.printPartRequisition(false) class=clickable><i class=icon-icons_print_partlist></i> <label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div ng-click=vm.printPartRequisition(true) class=clickable style=position:relative;><i class="fa fa-download"></i> <label>{{\'BUTTON_ESTIMATE_DOWNLOAD\' | translate}}</label></div><div ng-click="vm.closePartRequisition(vm.partsRequisition, false)" class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><!--BLOC CLIENT --><!-- <client-part-requisition on-choose-customer="vm.onChooseCustomer" selected-customer="vm.currentCustomer" on-search-customer-mode="vm.onSearchCustomerMode" on-edit-part-requisition-mode="vm.onEditPartRequisitionMode"></client-part-requisition> --><!-- <dms-customer class="headerClient" view="standard" on-new-customer-callback="vm.onNewCustomerCallback" --><dms-customer class=headerClient view=standard on-select-customer-callback=vm.onSelectedCustomerCallback current-customer=vm.currentCustomer on-customer-filled-callback=vm.onCustomerFilledCallback on-updated-customer-callback=vm.onUpdatedCustomerCallback on-reset-customer-callback=vm.onResetCustomerCallback on-set-customer-details=vm.onSetCustomerDetails send-dms-request=!vm.defaultClientMode></dms-customer><!--BLOC COMMENT --><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.partsRequisition.description.length || 0}}</span> <span>/100</span></div><textarea class="comment textarea inputCommentItalic" ng-model-options="{ debounce: 500 }" name=comment rows=2 cols=20 ng-model=vm.partsRequisition.description ng-attr-placeholder="*{{\'COMMON_TEXTAREA_PLACEHOLDER\'|translate}}" maxlength=100>\n        </textarea></div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic" style="background-color: #F1F2F3; border: none;min-height: 0px !important;">{{\'RGPD_MESSAGE\' |translate}}</div></div><div class=blocVehiculePartList><!-- BLOC VEHICLE --><div class=row><div class="small-12 columns blocVehiculeBandeauSelected"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader ng-if="vm.vehicle && vm.vehicle != null"><label class=designationVehiculeBlocContext><span ng-bind-html=vm.bannerData></span></label> <label class=vinImatVehiculeBlocContext><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span></label></div><select-order-number default-value=vm.partsRequisition.orderNumber ng-if=vm.isWorkshop on-change=vm.updateOrderNumber><select-order-number></select-order-number></select-order-number></div></div><div class="row headerTabListPRorTM" ng-if="vm.partsRequisition && vm.partsRequisition.items && vm.partsRequisition.items.length > 0"><table style="width: 100%"><!-- HEADER TABLE --><tr><th class=partListTitle>{{\'COMMON_COLUMN_REF_TITLE\' | translate}} <i class=icon-icons_order_partlist ng-click="vm.sortBy(\'reference\')"></i></th><th class=partListTitle>{{\'COMMON_DESIGNATION\' | translate}}</th><th class=partListTitle ng-if=vm.isWorkshop>{{\'PARTLIST_TABLE_TITLE_SPLIT\' | translate}}</th><th ng-if=vm.isWorkshop style="max-width: 100px;\n                    width: 100px;">&nbsp;</th><th class="partListTitle text-align-right" ng-if=!mainCtrl.isCountryRoumania>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate}}</th><th class=partListTitle ng-if=vm.isPartshop>{{\'PARTLIST_TABLE_TITLE_DISCOUNT\' | translate}}</th><th class=partListTitle>{{\'PARTLIST_TABLE_TITLE_QUANTITY\' | translate}}</th><th class=partListTitle>{{\'PARTLIST_TABLE_TITLE_URGENCY\' | translate}}</th><th class=partListTitle>{{\'COMMON_COLUMN_LOCATION\' | translate}} <i class=icon-icons_order_partlist ng-click="vm.sortBy(\'dmsInformations.location\')"></i></th><th><!-- bin --></th></tr><!-- CONTAIN TABLE --><tr id=_{{item.reference}} style="background-color: white" ng-repeat="item in vm.partsRequisition.items | orderBy:vm.propertyName:vm.reverse"><td class="large-1 medium-1 small-1"><span ng-click=vm.goToProductPage(item.reference) class="clickable white-space" style="display: flex;">{{item.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;padding-top: 2px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(item.reference);$event.stopPropagation();></i></span></td><td class="large-3 medium-3 small-3"><span ng-click=vm.goToProductPage(item.reference) class="clickable white-space">{{item.designation}} </span><img ng-if=item.reach src=./assets/svg/reach.svg height=16 width=16> <button ng-if=vm.isPartshop type=button class="customCheckbox display-block" ng-model=item.unusualSale btn-checkbox btn-checkbox-true=true btn-checkbox-false=false ng-change=vm.onChangeUnusualSale(item)><div class="box display-inline-block"></div><div class=txt>{{\'PARTLIST_UNUSUAL_SALE\' | translate}}</div></button></td><td ng-if=vm.isWorkshop class="max-width-300 large-2 medium-2 small-2"><select-intervention item=item default-value=item.interventionId on-change=vm.onUpdateIntervention></select-intervention></td><td ng-if=vm.isWorkshop class="large-1 medium-1 small-1" style="max-width: 100px; width: 100px;" ng-click=vm.multipleOperations(item)><span ng-if="vm.isWorkshop && vm.partsRequisition.orderNumber && vm.partsRequisition.orderNumber != \'-\' && vm.orderAndSplitDetails && vm.orderAndSplitDetails.splits && vm.orderAndSplitDetails.splits.length > 1"><i class="fa fa-files-o" aria-hidden=true style="font-size: 20px;cursor:pointer;"><md-tooltip md-direction=bottom><span style="font-size: var(--renaultSmallFont);">{{\'REPLICATE_LABEL\' |translate}}</span></md-tooltip></i></span></td><td ng-if=!mainCtrl.isCountryRoumania class="large-1 medium-1 small-1"><div class=text-align-right ng-if="item.dmsInformations.priceExclTaxes || item.price">{{getPriceToDisplay(item)}} {{vm.getCurrencyForItem(item)}}</div><div class=text-align-center ng-if="!item.dmsInformations.priceExclTaxes && !item.price">-</div></td><td ng-if=vm.isPartshop class="large-1 medium-1 small-1"><input type=number ng-model=item.additionalDiscount ngmin=0 ngmax=99 ng-change=vm.onChangeAdditionalDiscount(item)> <label style="display: inline">%</label></td><td class="large-1 medium-1 small-1"><shopping-cart-parts-requisition options={} piece=item page=partsRequisition></shopping-cart-parts-requisition><div><label ng-if="item.dmsInformations.quantity && item.quantity <= item.dmsInformations.quantity" class=stockDispo>{{item.dmsInformations.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</label> <label ng-if="item.dmsInformations.quantity && item.quantity > item.dmsInformations.quantity || item.dmsInformations.quantity <= 0" class=stockIndispo>{{item.dmsInformations.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</label></div></td><td class="large-2 medium-2 small-2"><select id=orderType class=removeMargin ng-class="{missing: !vm.checkStock(item)}" ng-options="option as (option.name | translate) for option in vm.ordersType track by option.id" ng-model=item.orderTypeObject ng-change=vm.onChangeOrderType(item)></select></td><td class="large-1 medium-1 small-1"><span ng-if=item.dmsInformations.location>{{item.dmsInformations.location}}</span> <span ng-if=!item.dmsInformations.location>-</span></td><td class="large-1 medium-1 small-1"><i class=icon-icons_remove_partlist ng-click=vm.deleteReference(item)></i></td></tr></table></div><!-- FOOTER VEHICLE --><div class=row ng-hide=vm.contextCarBrandCheck><div class="small-12 columns blocVehiculeFooter"><label>{{\'COMMON_ADD_REF\'|translate}}</label><div class=inputSearch><form ng-init=vm.initPartFocus()><input type=text ng-model=vm.ref maxlength=13 class=inputReference ng-change=vm.formatReferenceInput() ng-attr-placeholder="{{\'PARTLIST_REF_PR_PLACEHOLDER\' | translate}}" phenix-enter=vm.addRef(vm.ref) id=inputReference></form><div ng-click=vm.addRef(vm.ref) class=loupe role=button tabindex=0><i class=icon-icons_stepper_plus_partlist></i></div></div><div><label class=maxItems ng-class="{\'maxLimit\': vm.partsRequisition.items.length >= 99}">{{vm.partsRequisition.items.length}} / {{vm.maxItemsLimit}}</label></div></div></div><!-- LOGIN PASSWORD BLOCK --><div class="row loginPasswordBlock" ng-if=vm.dmsLoginRequired><div class="small-offset-10 small-2 columns content"><div class=loginContainer><input type=text id=identifiantLoginPartRequisition ng-change=vm.onChangeUsername(vm.dmsLoginContainer.username) ng-model=vm.dmsLoginContainer.username placeholder="{{\'COMMON_IDENT_PLACEHOLDER\' |translate}}"> <i class=icon-icons_login_partRequisition></i></div><div class=passwordContainer><input type=password id=identifiantPasswordPartRequisition ng-change=vm.onChangePassword(vm.dmsLoginContainer.password) ng-model=vm.dmsLoginContainer.password placeholder="{{\'COMMON_PASSWD_PLACEHOLDER\' |translate}}"> <i class=icon-icons_password_partRequisition></i></div></div></div><div ng-class=vm.getValidatePartRequisitionClass()><button style="z-index: 20;" type=button class="small-offset-10 small-2 columns buttonWithIcon" ng-class="{\'disabled\': vm.isValidating, \'disabled-button-text\': vm.isValidating}" ng-if=vm.partsRequisition.items.length ng-click="!vm.isValidating && vm.validate()"><div class=iconDiv><i class=icon-icons_bonDeService_partlist></i></div><div class="btnText ng-binding">{{\'PARTLIST_VALIDATE_BUTTON\' | translate}}</div></button></div></div></div><!-- ORDERMODE BLOCK --><div class=row ng-if="vm.isRpartsRole && vm.isDealerAvailable"><order-module vehicle=vm.vehicle parts-requisition=vm.partsRequisition show-order-mode-view=vm.showOrderModeView goto-product-page=vm.goToProductPage></order-module></div></div>');
$templateCache.put('app/components/orderModule/evBatteryPopup.html','<div class="orderModepop evBatteryPopup"><div class=alertCloseIcon><i class="fa fa-exclamation-triangle"></i></div><div class=evBatteryMessage><strong>{{(\'EV_BATTERY_ORDER_MESSAGE\' | translate)}}</strong></div><div class=evBatteryLink><a ng-if=vm.rpartstoreUrl href={{vm.rpartstoreUrl}} target=_blank>{{vm.rpartstoreUrl}}</a></div><div class=evBatteryButtonContainer><button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{(\'COMMON_CANCEL\' | translate)}}</div></button> <button class="buttonWithIcon confirm orderValidate" ng-click=vm.onTransferBasket()><div class=btnText>{{(\'EV_BATTERY_TRANSFER_BASKET\' | translate)}}</div><md-tooltip md-direction=bottom style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{(\'EV_BATTERY_TRANSFER_TOOLTIP\' | translate)}}</md-tooltip></button> <button class="buttonWithIcon confirm orderValidate" ng-if=vm.hasMixedParts ng-click=vm.onOrderWithoutEvBattery()><div class=btnText>{{(\'EV_BATTERY_ORDER_WITHOUT\' | translate)}}</div><md-tooltip md-direction=bottom style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{(\'EV_BATTERY_ORDER_WITHOUT_TOOLTIP\' | translate)}}</md-tooltip></button></div></div>');
$templateCache.put('app/components/orderModule/orderCreateAlertPopup.template.html','<div><div class=alerts-popin_list style="margin-top: 5%;"><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 12px;"><div class="medium-3 column textLeft text-bold">{{\'ALERTS_VIN\' | translate}}:</div><div class="medium-9 column text-left"><span>{{vm.vin}}</span></div></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 12px;"><div class="medium-3 column textLeft text-bold">{{\'ALERTS_FIRSTNAME\' | translate}}:</div><div class="medium-9 column text-left"><span>{{vm.firstName}}</span></div></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 12px;"><div class="medium-3 column textLeft text-bold">{{\'ALERTS_LASTNAME\' | translate}}:</div><div class="medium-9 column text-left"><span>{{vm.lastName}}</span></div></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 12px;"><div class="medium-3 column textLeft text-bold">{{\'EXTERNAL_LOGINID\' | translate}}:</div><div class="medium-9 column text-left"><input type=email ng-model=vm.emailAlerte id=user_email></div></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 12px;"><div class="medium-3 column textLeft text-bold">{{\'ALERTS_COUNTRY\' | translate}}:</div><div class="medium-9 column text-left"><span>{{vm.countryCode}}</span></div></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 16px;"><div class="medium-3 column textLeft text-bold">{{\'DEALER_ID\' | translate}}:</div><div class="medium-9 column text-left"><span>{{ vm.dealerId}}</span></div></div><div class=maxCharacter><span>{{vm.alertMessage.length || 0}}</span> <span>/250</span></div><div class="alerts-popin_list-text alerts-popin_list-row row" style="margin-bottom: 15px;"><div class="medium-3 column textLeft text-bold">{{\'ALERT_DESCRIPTION\' | translate}}:</div><textarea class="medium-9 textArea" maxlength=250 ng-model=vm.alertMessage id=ALERT_DESCRIPTION style="padding:6px;max-width: 322px;position: relative;left: 12px;" placeholder="{{\'ALERTS_COMMENTS_INPUT\' | translate}}" rows=6></textarea></div></div><section layout=row layout-sm=column layout-align="center center" layout-wrap class=alerts-popin-action style="padding: 5px 0;"><div ng-if=vm.isScreenshotImageTaken><span style="font-weight: bold;">{{"SCREENSHOT_NEW_CAPTURE" | translate | capitalize}}&nbsp; </span>: &nbsp;OM_alert_capture.png <i class="fa fa-trash" ng-click=vm.removeCapture() style="cursor: pointer;"></i></div></section><section layout=row layout-sm=column layout-align="center center" layout-wrap class=alerts-popin-action style="padding: 5px 0;"><md-button ng-click=vm.takeScreenshot() class="alerts-popin-btn buttonWithIcon" title="{{\'ACTIS_FIELD_REQUIRED\' | translate}}" style="margin-right: 2%;"><div class=iconDiv><i class="fa fa-camera"></i></div><div class=btnText id=TAKE_OM_SCREENSHOT>{{\'ALERT_TAKE_SCREENSHOT\' | translate}}</div></md-button><md-button ng-click=vm.sendAlerts() class="md-raise alerts-popin-btn buttonWithIcon" style="margin-right: 2%;"><div class=iconDiv><i class=icon-icons_mail></i></div><div class=btnText>{{"BUTTON_ESTIMATE_SEND" | translate}}</div></md-button><md-button ng-click=vm.closePopin() class="md-raise alerts-popin-btn buttonWithIcon cancel" style="height:auto !important"><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{"COMMON_CANCEL" | translate}}</div></md-button></section></div>');
$templateCache.put('app/components/orderModule/orderMethodSelectionPopup.html','<div class=order-method-selection-popup><md-dialog class=order-method-dialog flex=40><md-dialog-content class=order-method-content><div class="md-dialog-content om-dialog"><div class=method-selection-container><md-radio-group ng-model=vm.selectedMethod class=method-radio-group><div class=method-option><md-radio-button value=direct class="method-radio-button direct-option" ng-click=vm.selectDirectOrder()><div class=option-content><div class=option-text><span class=option-title>{{\'PLACE_ORDER_DIRECTLY\' | translate}}</span></div></div></md-radio-button></div><div class=method-option><md-radio-button value=rpartstore class="method-radio-button rpartstore-option" ng-click=vm.transferToRpartStore()><div class=option-content><div class=option-text><span class=option-title>{{\'TRANSFER_BASKET_TO_RPARTS\' | translate}}</span></div></div></md-radio-button></div></md-radio-group></div></div></md-dialog-content></md-dialog></div>');
$templateCache.put('app/components/orderModule/orderModeClosePopup.html','<div class=orderModepop ng-class="{\'goConfirm\': vm.interventionTmPop}"><div class=alertCloseIcon ng-if="!vm.orderModeWarnPop && !vm.interventionTmPop"><i class="fa fa-exclamation-triangle"></i></div><div ng-click=vm.onClose() ng-if=vm.orderModeWarnPop><i class="fa fa-close closeWarnPopup"></i></div><div ng-class="{\'interventionPop\':vm.interventionTmPop,\'defaultPadding\':!vm.interventionTmPop}"><strong>{{vm.message}}</strong> <span class="warnIcon ng-scope" ng-if=vm.orderModeWarnPop><i class="fa fa-exclamation-triangle"></i></span></div><div style=padding:6px><a ng-if=vm.redirectLink href={{vm.redirectLink}} target=blank ng-click=vm.onConfirm(true)>{{vm.redirectLink}}</a></div><div ng-if=!vm.interventionTmPop style=padding:6px><strong>{{vm.message2}}</strong></div><div ng-if=vm.interventionTmPop>{{vm.message2}}</div><div style=padding:6px class=text-center><button class="buttonWithIcon confirm orderValidate" ng-click=vm.onConfirm(true) ng-if=vm.confirmMessage><div class=btnText>{{vm.confirmMessage}}</div></button> <button class="buttonWithIcon cancel" ng-click=vm.onCancel(false) ng-if=vm.cancelMessage><div class=btnText>{{vm.cancelMessage}}</div></button></div></div>');
$templateCache.put('app/components/orderModule/orderModePopup.html','<div class=orderModepop><div class=alertIcon><i class="fa fa-exclamation-triangle"></i></div><div><md-radio-group ng-model=vm.selected ng-change=vm.changeselect(vm.selected)><md-radio-button value=allParts>{{\'ORDER_MODE_DEPOSIT_ALL_PARTS\'| translate}}</md-radio-button><md-radio-button value=withoutStockparts>{{\'ORDER_MODE_DEPOSIT_WITHOUTSTOCK_PARTS\' | translate}}</md-radio-button></md-radio-group></div><div class=text-center><button class="buttonWithIcon confirm orderValidate" ng-click=vm.confirm(vm.isSwitchEnabled)><div class=btnText>{{"MODAL_OK_BUTTON"| translate}}</div></button> <button class="buttonWithIcon cancel" ng-click=vm.close(!vm.isSwitchEnabled)><div class=btnText>{{"COMMON_CANCEL" | translate}}</div></button></div></div>');
$templateCache.put('app/components/orderModule/orderModule.template.html','<div id=orderModule><!-- PLACE ORDER BLOCK --><div id=btnPlace-Order ng-if=!vm.showOrderModeView ng-class=" {\'orderBtn\':(vm.partsRequisition.items.length === 0), \'placeOrderBtn\':(vm.partsRequisition.items.length >= 1)}"><button type=button class=buttonWithIcon ng-click=vm.orderModePopup(true) ng-disabled="vm.partsRequisition.items.length === 0"><div class=iconDiv><i class="orderIcon fa fa-truck"></i></div><div class=btnText>{{\'PLACE_ORDER\' | translate}}</div></button></div><div ng-if=vm.showOrderModeView style="margin-top: 25px; position: relative;"><div class="row headerPartList" style="margin-top : 0px"><div class="small-1 columns numPartList"><div class=backPartList ng-click=vm.closeOrderModeView()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' | translate}}</div></div></div><div class="small-5 columns"><label class=labelNumPartList>{{\'ORDER_NUMBER\' | translate}}</label></div><div class="small-5 columns listPartListAction"><div ng-click="vm.openAlertsPopin(\'ORDER_MODE\')" class=clickable ng-if=vm.isOrderingAlert><i class="fa fa-exclamation-triangle" style="color: var(--renaultPrimaryColor);"></i> <label>{{\'CREATE_ALERT\' |translate}}</label></div><div ng-click=vm.closeOrderModeView() class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><!--BLOC COMMENT --><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.orderModePartsList.orderMark.length || 0}}</span> <span>/100</span></div><div><textarea class="comment textarea inputCommentItalic" ng-model=vm.orderModePartsList.orderMark ng-change=vm.saveMarkAndMessage() ng-attr-placeholder="{{\'ORDER_MARK\'| translate}}" maxlength=100>\n                </textarea></div></div><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.orderModePartsList.message.length || 0}}</span> <span>/250</span></div><div><textarea class="comment textarea inputCommentItalic" ng-model=vm.orderModePartsList.message ng-change=vm.saveMarkAndMessage() ng-attr-placeholder="{{\'ORDER_DESCRIPTION_MESSAGE\'| translate}}" maxlength=250>\n                </textarea></div></div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic">{{\'RGPD_MESSAGE\' |translate}}</div></div><div class=blocVehiculePartList><!-- BLOC VEHICLE --><div class=row><div class="small-12 columns orderMode blocVehiculeBandeauSelected"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader ng-if="vm.vehicle && vm.vehicle != null"><label class=designationVehiculeBlocContext><span ng-if=vm.vehicle.model>{{vm.vehicle.model}}</span> <span ng-if=vm.vehicle.motorisation>, {{vm.vehicle.motorisation}}</span> <span ng-if=vm.vehicle.gearBoxType>, {{vm.vehicle.gearBoxType}}</span></label> <label class=vinImatVehiculeBlocContext><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span></label></div></div></div><div class="row headerTabListPRorTM" ng-if="vm.orderModePartsList && vm.orderModePartsList.items && vm.orderModePartsList.items.length > 0"><table style="width: 100%"><tr><th class=partListTitle>{{\'COMMON_COLUMN_REF_TITLE\' | translate}} <i class=icon-icons_order_partlist ng-click="vm.sortByRef(\'reference\')"></i></th><th class=partListTitle>{{\'COMMON_DESIGNATION\' | translate}}</th><th class=partListTitle><div>{{"WHOLESALER_LABEL"|translate}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate}}</div></th><th class=partListTitle ng-click=vm.displayAllDiscountRate()><span class=discountCodeHeader>{{\'ORDERING_MODULE_DISCOUNT_CODE\' | translate}} <i class=iconRight ng-class="vm.showAllDiscountRate? \'icon-icons_arrow_top\' : \'icon-icons_arrow_bottom\'"></i></span></th><th class=partListTitle>{{\'PARTLIST_TABLE_TITLE_QUANTITY\' | translate}}</th><th class=partListTitle><div>{{"WHOLESALER_LABEL"|translate}}</div><div>{{"R1_AVAILABILITIES"|translate}}</div></th><th><!-- bin --></th></tr><!-- CONTAIN TABLE --><tr id=_{{item.reference}} style="background-color: white" ng-repeat="item in vm.orderModePartsList.items | orderBy:vm.propertyName:vm.reverse"><td class="large-1 medium-1 small-1"><span ng-click=vm.goToProductPage(item.reference) class=clickable style=display:flex;>{{item.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(item.reference);$event.stopPropagation();></i></span></td><td class="large-3 medium-3 small-3"><span ng-click=vm.goToProductPage(item.reference) class=clickable>{{item.designation}} </span><img ng-if=item.reach src=./assets/svg/reach.svg height=16 width=16></td><td><div ng-if="!vm.isCountryChina && !vm.isCountryIndia && vm.urgentOrder"><span class=caractere_label ng-if=item.priceUrgentTaxFree>{{item.priceUrgentTaxFree}} {{item.currency}}&nbsp;</span> <span class=caractere_label ng-if="!item.priceUrgentTaxFree && !vm.isCountryRoumania && (item.dmsInformations.priceExclTaxes || item.price)">{{vm.getPriceToDisplay(item)}} {{vm.getCurrencyForItem(item)}}&nbsp;</span></div><div ng-if="!vm.isCountryChina && !vm.isCountryIndia && !vm.urgentOrder "><span class=caractere_label ng-if=item.priceAdvisedTaxFree>{{item.priceAdvisedTaxFree}} {{item.currency}}&nbsp;</span> <span class=caractere_label ng-if="!item.priceAdvisedTaxFree && !vm.isCountryRoumania && (item.dmsInformations.priceExclTaxes || item.price)">{{vm.getPriceToDisplay(item)}} {{vm.getCurrencyForItem(item)}}&nbsp;</span></div><div ng-if="vm.isCountryChina || vm.isCountryIndia"><div class=caractere_label>&nbsp;</div></div></td><td><div class=caractere_label style="cursor: pointer;" ng-if="item.discountCode && !item.isLoadingPriceData" ng-click=vm.displayDiscountRate(item)><span ng-if="!item.isDiscountcodeVisible && item.itemReturnCode === \'A000\'">{{item.discountCode}} </span><span class="iconRight icon-icons_arrow_bottom" ng-if="!item.isDiscountcodeVisible && item.itemReturnCode === \'A000\'"></span> <span ng-if="item.isDiscountcodeVisible && item.priceTaxFree && item.discountRate">{{item.priceTaxFree}} {{item.currency}} {{\'PRODUCT_EXCL_TAX\' | translate | uppercase}} <span class="iconRight icon-icons_arrow_top" ng-if=item.isDiscountcodeVisible></span><div style="font-size: var(--renaultSmallFont);"><span ng-if=!vm.urgentOrder>{{item.discountRate}}</span> <span ng-if=vm.urgentOrder>{{item.discountRateUrgent}}</span> {{\'%\'}}</div></span></div><div class=caractere_label ng-if="!item.discountCode && !item.isLoadingPriceData" style="left: 3%;width: fit-content;position: relative;"><div ng-if="item.itemReturnCode ===\'A001\'"><i class="warningIcon fa fa-exclamation-triangle"></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'UNKNOWN_PARTS_RPARTS\' | translate }}</md-tooltip></div><div class=caractere_label ng-if="item.itemReturnCode!= \'A001\'">{{\'-\'}}</div></div><div class=caractere_label ng-if=item.isLoadingPriceData><img src=../assets/images/newHourGlassGrey.gif width=24px></div></td><td class="large-1 medium-1 small-1"><shopping-cart-parts-requisition check-dealer-list=vm.checkDealerList options={} piece=item page=partsRequisition></shopping-cart-parts-requisition><div><label ng-if="item.dmsInformations.quantity && item.quantity <= item.dmsInformations.quantity" class=stockDispo>{{item.dmsInformations.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</label> <label ng-if="item.dmsInformations.quantity && item.quantity > item.dmsInformations.quantity || item.dmsInformations.quantity <= 0" class=stockIndispo>{{item.dmsInformations.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</label></div></td><td><div class="small-2 columns availabilities-tooltip" ng-if=!item.isLoadingStockData><div class="caractere_label availabilities" ng-class="{\'light-green-dot\':(item.applicableClass === \'STOCK_AVAILABLE\' || (item.applicableClass === \'STOCK_IT_ES_GREEN\' && vm.countryCode !== \'ES\') || item.applicableClass === \'STOCK_AVAILABLE_BE\'),\n                                \'red-dot\':(item.applicableClass === \'STOCK_UNAVAILABLE\'|| item.applicableClass === \'STOCK_UNAVAILABLE_BE\' || item.applicableClass === \'STOCK_PARTIAL\' || item.applicableClass === \'STOCK_PART_UNAVAILABLE\' || ((vm.countryCode === \'IT\' || vm.countryCode === \'ES\') && item.applicableClass ===\'STOCK_CERGY\')), \n                                \'green-dot\':((item.applicableClass ===\'STOCK_IT_ES_YELLOW\' && vm.countryCode === \'IT\') || ( item.applicableClass === \'STOCK_IT_ES_GREEN\' && vm.countryCode === \'ES\')),\n                                \'orange-dot\':((vm.countryCode != \'IT\' && vm.countryCode != \'ES\') && item.applicableClass ===\'STOCK_CERGY\' || item.applicableClass === \'STOCK_AVAILABLE_D1\'|| item.applicableClass === \'STOCK_CERGY_BE\'),\n                                \'yellow-dot\':((item.applicableClass === \'STOCK_IT_ES_YELLOW\' || item.applicableClass === \'STOCK_IT_ES_YELLOW_BE\') && vm.countryCode != \'IT\')}" tooltip-placement=bottom tooltip-html-unsafe={{item.applicableClass|translate}}><span ng-if="!item.applicableClass || item.applicableClass === \'STOCK_EMPTY\'" style="margin-left : 10%;" tooltip-placement=bottom tooltip-html-unsafe="{{\'STOCK_EMPTY\'|translate}}">-</span></div></div><div ng-if=!item.isLoadingStockData class=warnTooltip><span ng-if="item.applicableClass === \'UNKNOWN_PARTS_RPARTS\'"><i class="warningIcon fa fa-exclamation-triangle"></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'UNKNOWN_PARTS_RPARTS\' | translate }}</md-tooltip></span></div><div class="caractere_label availabilities" ng-if=item.isLoadingStockData><img src=../assets/images/newHourGlassGrey.gif width=24px style=margin-left:7%></div></td><td class="large-1 medium-1 small-1"><i class=icon-icons_remove_partlist ng-click=vm.deleteReference(item)></i></td></tr></table></div><!-- FOOTER VEHICLE --><div class=row><div class="small-12 columns blocVehiculeFooter"><label>{{\'COMMON_ADD_REF\'|translate}}</label><div class=inputSearch><form ng-init=vm.initOrderFocus()><input type=text ng-model=vm.ref maxlength=10 class=inputReference ng-attr-placeholder="{{\'PARTLIST_REF_PR_PLACEHOLDER\' | translate}}" phenix-enter=vm.addRef(vm.ref) id=inputReference></form><div class=loupe role=button tabindex=0 ng-click=vm.addRef(vm.ref)><i class=icon-icons_stepper_plus_partlist></i></div></div></div></div><md-input-container ng-disabled="vm.orderModePartsList.items.length == 0 || vm.allPriceDataLoader || vm.allStockDataLoader" ng-if=vm.isUrgentCountry style="float:right; margin:1% 0;"><md-checkbox ng-model=vm.urgentOrder md-no-ink ng-change=vm.urgentOrderChange()>{{\'URGENT_ORDER\' | translate}}</md-checkbox></md-input-container><!--order block--><div class="row validateButton"><div><button ng-disabled="vm.orderModePartsList.items.length == 0 || vm.allPriceDataLoader || vm.allStockDataLoader" type=button class="partListBtn buttonWithIcon" ng-click=vm.orderModePopup(false)><div class=iconDiv><i class=icon-icons_bonDeService_partlist></i></div><div class=btnText>{{\'PARTS_LIST\'| translate}}</div></button></div><div><button ng-disabled="vm.orderModePartsList.items.length == 0 || vm.allPriceDataLoader || vm.allStockDataLoader" type=button class="validateOrderBtn buttonWithIcon" ng-class="{\'disabled\': vm.isValidatingOrder, \'disabled-button-text\': vm.isValidatingOrder}" ng-click="!vm.isValidatingOrder && vm.validateOrder()"><div class=iconDiv><i class="fa fa-check"></i></div><div class=btnText>{{\'VALIDATE_ORDER\'| translate}}</div></button></div></div></div></div><div data-html2canvas-ignore ng-if=vm.screenshotButtonVisibility.status class=tmScreenshot><button class=tmScreenshotButton ng-click=vm.captureScreenshot()><i class="fa fa-camera"></i></button></div></div>');
$templateCache.put('app/core/applicabilityTooltip/applicability-tooltip.template.html','<md-icon ng-if="vm.sieDoc.residual.length > 0" md-font-set=material-icons class=margin-left-20><md-tooltip md-direction=bottom style="height: auto;" class=tooltip-applicability><div ng-repeat="applicability in vm.sieDoc.concatApplicabilities"><div class=tooltip-applicability>{{::applicability.label}} :&nbsp;</div>{{::applicability.list.join(\', \')}}</div></md-tooltip>info</md-icon>');
$templateCache.put('app/core/badge/cart-badge.template.html','<div class=cart-badge ng-if="$ctrl.cartLength > 0">{{$ctrl.cartLength}}</div>');
$templateCache.put('app/core/containerList/containerList.template.html','<div class=containerList><table st-table=vm.list class="table table-striped width-100"><thead class=cursor-pointer><tr><th ng-click="vm.sortBy(\'ID\')">{{"COMMON_NUMBER_ID" | translate}} <i ng-class="vm.handleIconOrder(\'ID\')"></i></th><th ng-show="vm.networkProfile === vm.globalConstant.workshop">{{"ACTIS_VEHICLE_VIN" | translate}}</th><th ng-show="vm.networkProfile === vm.globalConstant.workshop">{{"ACTIS_VEHICLE_IMMAT" | translate}}</th><th ng-show="vm.networkProfile === vm.globalConstant.workshop">{{"ACTIS_VEHICLE_MODEL" | translate}}</th><th ng-click="vm.sortBy(\'ACCOUNT_NUMBER\')">{{"COMMON_NUMCLIENT_LABEL" | translate}} <i ng-class="vm.handleIconOrder(\'ACCOUNT_NUMBER\')"></i></th><th ng-show="vm.networkProfile === vm.globalConstant.workshop">{{"COMMON_ORDER_NUMBER" | translate}}</th><th ng-if=!vm.validatedSuperCart ng-click="vm.sortBy(\'DATE\')"><span>{{"MODIFICATION_DATE" | translate}} / {{"LAST_MODIFIER_IPN" | translate}} </span><i ng-class="vm.handleIconOrder(\'DATE\')"></i></th><th ng-if=vm.validatedSuperCart ng-click="vm.sortBy(\'VALIDATED_DATE\')"><span>Date de validation / IPN du validateur </span><i ng-class="vm.handleIconOrder(\'DATE\')"></i></th><th ng-if=!vm.validatedSuperCart><div ng-click="action.event === \'delete\' && vm.deleteCarts()"><i class="fa fa-lock"></i></div></th><th ng-if=!vm.validatedSuperCart><div ng-click=vm.deleteCarts()><i class=icon-icons_remove></i></div></th></tr></thead><tbody><tr ng-repeat="cart in vm.list track by cart.id" class=hover-Yellow><td ng-click=vm.selectCart(cart)><table class=tableinfo><tr><td class=myinfo><span class=spnDetails>{{cart.number}}</span> <span class=spnTooltip ng-if="cart.description.length > 0"><div class=urlsize><span>{{cart.description}}</span></div></span></td></tr></table></td><td ng-click=vm.selectCart(cart) ng-show="vm.networkProfile === vm.globalConstant.workshop">{{cart.vin}}</td><td ng-click=vm.selectCart(cart) ng-show="vm.networkProfile === vm.globalConstant.workshop">{{cart.registrationNumber}}</td><td ng-click=vm.selectCart(cart) ng-show="vm.networkProfile === vm.globalConstant.workshop">{{cart.vehicleDesignation}}</td><td ng-click=vm.selectCart(cart) ng-keyup=vm.selectCart(cart)>{{cart.accountNumber}}</td><td ng-click=vm.selectCart(cart) ng-show="vm.networkProfile === vm.globalConstant.workshop">{{cart.orderNumber}}</td><td ng-if=!vm.validatedSuperCart ng-click=vm.selectCart(cart) ng-keyup=vm.selectCart(cart)>{{cart.lastModificationDateTime | date:\'yyyy/MM/dd\'}} / {{cart.lastModifierIPN}}</td><td ng-if=vm.validatedSuperCart ng-click=vm.selectCart(cart) ng-keyup=vm.selectCart(cart)>{{cart.validationDateTime | localTimeFilter}} / {{cart.validatorIPN}}</td><td ng-if=!vm.validatedSuperCart><div class=checkbox><i ng-click=vm.unlock(cart) ng-if=cart.lockedByUser class="fa fa-unlock" title="{{vm.superCart.lockLabel | translate}}"></i></div></td><td ng-if=!vm.validatedSuperCart><div class=checkbox><input type=checkbox class=customCheckBox ng-model=cart.checked id={{cart.id}} ng-click=vm.check(cart)> <label for={{cart.id}}></label></div></td></tr></tbody></table></div>');
$templateCache.put('app/core/estimateModal/estimateModal.html','<div class=modalPhenix><div class=close ng-click=vm.cancel()><div class=text>{{\'MODAL_CLOSE\'|translate}}</div><i class=icon-icons_close></i></div><div id=modalEstimatePhenix><label class=title>{{\'ESTIMATE_NO_ACTIVE_ESTIMATE\' | translate}}</label> <button type=button class=buttonWithIcon ng-click=vm.createEstimate()><div class=iconDiv><i class=icon-icons_estimation></i></div><div class=btnText>{{\'NEW_ESTIMATE\'|translate}}</div></button> <label ng-if="vm.estimatesToShowing && vm.estimatesToShowing.length > 0" class=chooseDraft>{{\'ESTIMATE_NO_ACTIVE_DRAFT\' | translate}}</label><div ng-if="vm.estimatesToShowing && vm.estimatesToShowing.length > 0" class="centered-div documents-table"><div class="row documents-row-title"><div class="small-2 columns cell">{{\'COMMON_NUMBER_ID\' | translate}}</div><div class="small-2 columns cell">{{\'COMMON_CREATION\' | translate}}</div><div class="small-5 columns cell">{{\'COMMON_CUSTOMER\' | translate}}</div><div ng-if=vm.canShowingOr class="small-2 columns cell">{{\'COMMON_ORDER\' | translate}}</div><div class="small-1 columns cell"></div></div><div class="row documents-row" ng-repeat="estimate in vm.estimatesToShowing" ng-click=vm.getEstimate(estimate.id)><div class="small-2 columns cell">{{estimate.id}}</div><div class="small-2 columns cell">{{estimate.creationDateTime | dateTimeConsultEstimation}}</div><div class="small-5 columns cell">{{estimate.customerLastName}} {{estimate.customerFirstName}} ({{estimate.customerId}})</div><div ng-if=vm.canShowingOr class="small-2 columns cell">{{estimate.orderNumber}}</div><div class="small-1 columns"><i class=icon-icons-phnx-next></i></div></div></div><div class=pagination ng-if=vm.showNextPrev><i class=icon-icons_arrow_left_estimation ng-click=vm.prevEstimateSearch() ng-show="vm.currentEstimateSearchPage > 1"></i> <label>Page {{vm.currentEstimateSearchPage}} sur {{vm.maximumPageNext}}</label> <i class=icon-icons_arrow_right_estimation ng-click=vm.nextEstimateSearch() ng-show="vm.currentEstimateSearchPage < vm.maximumPageNext"></i></div></div></div>');
$templateCache.put('app/core/expandFilter/expandFilter.html','<div class=expandFilterDirective><div class=expandFilterLabel ng-click=onClick()><span><i ng-class=icon class=labelFilterIcon></i> <span>{{filterTitle | translate}}</span> </span><i class=icon-icons_arrow_dropdown></i></div><div class=expandFilterTransclude ng-show=expand><ng-transclude></ng-transclude></div></div>');
$templateCache.put('app/core/filterList/filterList.template.html','<div class=filterList><form><!-- FIELDS --><div class=input-material-container ng-repeat="field in vm.filterFields"><md-icon class={{field.class}}></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{field.label | translate}}</label> <input ng-model=field.value class=materialInput type=text></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- ACTIONS --><div class=actions><md-button class="md-raised buttonWithIcon" type=submit ng-click=vm.onValidate(vm.filterFields)><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button class="md-raised buttonWithIcon cancel" style="height: auto;" ng-click="vm.filters = {}; vm.onReset(vm.filterFields)"><div class=iconDiv><i class=icon-icons-phnx_reinit style="font-size: 20px;"></i></div><div class=btnText>{{\'COMMON_REINIT\' | translate}}</div></md-button></div></form></div>');
$templateCache.put('app/core/forfaitModal/forfaitModal.html','<div class=forfaitModalPhenix><div class=partOne>{{vm.product.id}}</div><div class=partOne>{{vm.product.designation}}</div><div class=price>Prix brut HT</div><div><input double-only class=inputText ng-model=vm.th ng-trim=false> <span class=devise>\u20AC</span></div><div class=actionButton><button type=button class="buttonWithIcon add" ng-click=vm.ok() ng-class="{\'disabled\': !vm.th || vm.th.length < 1}"><div class=iconDiv><i ng-class="vm.page ? \'icon-icons_estimation\' : \'icon-icons_basket\'"></i></div><div class=btnText>{{vm.addRefLabel}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/core/header/header.html','<div class=header><span class=phenix>PHENIX</span> <span class=renault>RENAULT</span> <span class=groupe>GROUPE</span> <span class=userInfo>{{user.lastName}} {{user.firstName}} {{user.country}}</span></div>');
$templateCache.put('app/core/inputTextAutoCompletion/inputTextAutoCompletion.html','<div class=input_autocompletion_1><input list=codes type=text><datalist id=codes><option ng-repeat="val in inTextAutoCompletionCtrl.data" value={{val}}></option></datalist></div>');
$templateCache.put('app/core/modal/modal.html','<div class=modalPhenix><div class=title>{{vm.title|translate}}</div><div class=description><div class=text>{{vm.description[0]}}</div><div class=optional ng-if=vm.description[1]>{{vm.description[1]}}</div></div><div class=actionButton><button type=button class=buttonWithIcon ng-click=vm.ok()><div class=iconDiv><i class=icon-icons_remove ng-if=!vm.okButtonIcon></i> <i ng-class=vm.okButtonIcon ng-if=vm.okButtonIcon></i></div><div class=btnText>{{vm.okButtonLabel | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{vm.cancelButtonLabel | translate}}</div></button></div></div>');
$templateCache.put('app/core/modalCustomer/warningModalCustomer.component.html','<div id=warningModalCustomer class=modalPhenix style="padding: 20px"><div class=modalPhenixTitle>{{\'CUSTOMER_NOT_SAVE\' | translate}}</div><div style="margin-top: 10px;"><button type=button class=buttonWithIcon ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'COMMON_YES\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_NO\'| translate}}</div></button></div></div>');
$templateCache.put('app/core/modalDocument/consult_doc.html','<div class=modalPhenix><div class=close ng-click=vm.cancel()><div class=text>{{\'MODAL_CLOSE\'|translate}}</div><i class=icon-icons_close></i></div><div id=modalDocPhenix><label class=title>{{\'VIEWED_DOC_TITLE\' | translate}}</label><div class="centered-div documents-table"><div class="row documents-row-title"><div class="small-1 columns cell">{{\'VIEWED_DOC_TYPE\' | translate}}</div><div class="small-2 columns cell">{{\'VIEWED_DOC_REF\' | translate}}</div><div class="small-8 columns cell">{{\'VIEWED_DOC_WORDING\' | translate}}</div><div class="small-1 columns cell"></div></div><div class="row documents-row" ng-repeat="doc in vm.DocToShowing" ng-click=vm.getDoc(doc) ng-if=vm.DocToShowing><div class="small-1 columns cell">{{doc.type}}</div><div class="small-2 columns cell">{{doc.ref}}</div><div class="small-8 columns cell">{{doc.libelle}}</div><div class="small-1 columns"><i class=icon-icons-phnx-next></i></div></div></div></div><pagination-directive ng-if=vm.DocToShowing pagination-data=vm.DocToShowing pagination-size=vm.maxPerPage pagination-scroll-id=modalDocPhenix pagination-mode=text></pagination-directive></div>');
$templateCache.put('app/core/modalElectrical/electrical_shema.html','<div class=modalPhenix id=modalElecShPhenix><div class=close ng-click=vm.cancel()><div class=text>{{\'MODAL_CLOSE\'|translate}}</div><i class=icon-icons_close></i></div><label class=title>{{\'ELECTRICAL_SHEMA_TITLE\' | translate}}</label><div class="row documents-row-title"><div class="small-3 columns cell">{{\'ELECTRICAL_SHEMA_CODE\' | translate}}</div><div class="small-7 columns cell end">{{\'ELECTRICAL_SHEMA_ATTRIBUT\' | translate}}</div></div><div class=row ng-repeat="site in vm.ElecShToShowing"><div class="row site">{{site.site}}</div><div class="row documents-row" ng-repeat="listShema in site.elements" ng-click=vm.getElectric(listShema)><div class="small-3 columns cell">{{listShema.code}}</div><div class="small-7 columns cell">{{listShema.attribut}}</div><div class="small-2 columns"><i class=icon-icons-phnx-next></i></div></div></div><div class=pagination ng-if=vm.showNextPrev><i class=icon-icons_arrow_left_ElecSh ng-click=vm.prevElecShSearch() ng-show="vm.currentElecShSearchPage > 1"></i> <label>Page {{vm.currentElecShSearchPage}}/{{vm.maximumPageNext}}</label> <i class=icon-icons_arrow_right_ElecSh ng-click=vm.nextElecShSearch() ng-show="vm.currentElecShSearchPage < vm.maximumPageNext"></i></div></div>');
$templateCache.put('app/core/modalPartlist/modalPartlist.html','<div class=modalPhenix><div class=close ng-click=vm.cancel()><div class=text>{{\'MODAL_CLOSE\'|translate}}</div><i class=icon-icons_close></i></div><div id=modalEstimatePhenix><label class=title>{{\'ESTIMATE_NO_ACTIVE_ESTIMATE\' | translate}}</label> <button type=button class=buttonWithIcon ng-click=vm.createPartlist()><div class=iconDiv><i class=icon-icons_basket></i></div><div class=btnText>{{\'NEW_PARTLIST\'|translate}}</div></button> <label ng-if="vm.partListsToShowing && vm.partListsToShowing.length > 0" class=chooseDraft>{{\'PARTLIST_NO_ACTIVE_DRAFT\' | translate}}</label><div ng-if="vm.partListsToShowing && vm.partListsToShowing.length > 0" class="centered-div documents-table"><div class=row><div class="row documents-row-title"><div class="small-2 columns cell">{{\'COMMON_NUMBER_ID\' | translate}}</div><div class="small-2 columns cell">{{\'COMMON_CREATION\' | translate}}</div><div class="small-5 columns cell">{{\'COMMON_CUSTOMER\' | translate}}</div><div ng-if=vm.canShowingOr class="small-2 columns cell">{{\'COMMON_ORDER\' | translate}}</div><div class="small-1 columns cell"></div></div><div class="row documents-row" ng-repeat="partList in vm.partListsToShowing" ng-click=vm.getPartList(partList.id)><div class="small-2 columns cell">{{partList.id}}</div><div class="small-2 columns cell">{{partList.creationDateTime | dateTimeConsultEstimation}}</div><div class="small-5 columns cell">{{partList.customerLastName}} {{partList.customerFirstName}} ({{partList.customerId}})</div><div ng-if=vm.canShowingOr class="small-2 columns cell">{{partList.orderNumber}}</div><div class="small-1 columns cell"><i class=icon-icons-phnx-next></i></div></div></div></div><div class=pagination ng-if=vm.showNextPrev><i class=icon-icons_arrow_left_estimation ng-click=vm.prevPartListSearch() ng-show="vm.currentPartListSearchPage > 1"></i> <label>Page {{vm.currentPartListSearchPage}} sur {{vm.maximumPageNext}}</label> <i class=icon-icons_arrow_right_estimation ng-click=vm.nextPartListSearch() ng-show="vm.currentPartListSearchPage < vm.maximumPageNext"></i></div></div></div>');
$templateCache.put('app/core/modalPayment/modalPayment.html','<div class=modalPhenix><div id=modalPayment><label class=title>{{\'PAYMENT_MODAL_REF\' | translate}}</label><div class="medium-12 margin-btn-payment-modal" ng-if="vm.references[\'principal\'] && !vm.references[\'selected\']"><label class=title>{{\'PAYMENT_MODAL_REF_LIST\' | translate}}</label> <button type=button class=buttonWithIcon ng-click="vm.validateModal(vm.references[\'principal\'], vm.references[\'principal\'])"><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText><span class=reference>{{vm.references[\'principal\'].reference | filterFormatRef}}</span> <span>{{vm.references[\'principal\'].designation}}</span></div></button></div><div class="medium-12 margin-btn-payment-modal" ng-if="vm.references[\'principal\'] && vm.references[\'selected\']"><label class=title>{{\'PAYMENT_MODAL_REF_LIST\' | translate}}</label> <button type=button class=buttonWithIcon ng-click="vm.validateModal(vm.references[\'selected\'], vm.references[\'principal\'])"><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText><span class=reference>{{vm.references[\'selected\'].reference | filterFormatRef}}</span> <span>{{vm.references[\'selected\'].designation}}</span></div></button></div><div class="medium-12 margin-btn-payment-modal" ng-if="vm.references[\'locale\']"><label class=title>{{\'PAYMENT_MODAL_REF_LOCALE\' | translate}}</label> <button type=button class=buttonWithIcon ng-click="vm.validateModal(vm.references[\'locale\'], vm.references[\'principal\'])"><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText><span class=reference>{{vm.references[\'locale\'].reference | filterFormatRef}}</span> <span>{{vm.references[\'locale\'].description}}</span></div></button></div><div class="medium-12 margin-btn-payment-modal" ng-if="vm.references[\'locale_older\']"><label class=title>{{\'PAYMENT_MODAL_REF_LOCALE_OLDER\' | translate}}</label> <button type=button class=buttonWithIcon ng-click="vm.validateModal(vm.references[\'locale_older\'], vm.references[\'principal\'])"><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText><span class=reference>{{vm.references[\'locale_older\'].reference | filterFormatRef}}</span> <span>{{vm.references[\'locale_older\'].description}}</span></div></button></div><button type=button class="buttonWithIcon cancel" ng-click=vm.closeModal()><div class=iconDiv><i class=icon-icons_close></i></div><div class="btnText ng-binding">Annuler</div></button></div></div>');
$templateCache.put('app/core/modalSelectOr/modalSelectOr.html','<div id=modalEstimatePhenix><h1 class=title>{{\'PARTLIST_MODAL_SELECT_OR_TITLE\' | translate}}</h1><p>{{\'PARTLIST_MODAL_SELECT_OR_MESSAGE\' | translate}}</p><select name="" ng-model=vm.orderNumber><option ng-repeat="option in vm.ordersAndSplits.orderNumbers" value={{option}}>{{option}}</option></select> <button type=button class=buttonWithIcon ng-click=vm.validate()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div>');
$templateCache.put('app/core/modalSelectOrderType/modalSelectOrderType.template.html','<div id=modalOrderTypePhenix><h1 class=title>{{\'PARTLIST_MODAL_TYPEORDER_TITLE\' | translate}}</h1><p>{{\'PARTLIST_MODAL_TYPEORDER_MSG\' | translate}}</p><p>{{\'PARTLIST_MODAL_TYPEORDER_LABEL_SELECT\' | translate}}</p><select ng-model=vm.ordersTypeSelected ng-options="option.id as (option|filterOptionSplit) for option in vm.ordersType"></select> <button type=button class=buttonWithIcon ng-click=vm.validate()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div>');
$templateCache.put('app/core/modalSplitDefault/modalSplitDefault.html','<div id=modalEstimatePhenix><h1 class=title>{{vm.titleModal | translate}}</h1><select ng-model=vm.defaultSplit ng-options="option.id as (option|filterOptionSplit) for option in vm.orderAndSplits.splits"></select> <button type=button class=buttonWithIcon ng-click=vm.validate()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div>');
$templateCache.put('app/core/multipleSelects/multipleSelects.html','<div id=multiple-selects-container><div class=select ng-click=displaySelectBox() ng-class="selectedItems.length == 0? \'small\' : \'\'"><span ng-show="selectedItems.length == 0">{{defaultText}}</span><div class=multiSel ng-show="selectedItems.length > 0"><p ng-repeat="selected in selectedItems track by $index">{{selected.label}}</p></div></div><div class=mutliSelect ng-class="showMultipleCheckbox? \'show\' : \'\'"><div class=listBloc ng-repeat="(listIndex, list) in lists track by $index"><div class=listBlocTitle ng-if=list.title>{{list.title}}</div><ul><li ng-repeat="element in list.data track by element.id"><div class=checkbox><input type=checkbox class=customCheckBox id="{{listIndex+\'-\'+element.id}}" ng-model=element.checked ng-change=itemSelected(element)> <label for="{{listIndex+\'-\'+element.id}}">{{element.label}}</label></div></li></ul></div></div></div>');
$templateCache.put('app/core/navBar/navBar.html','<top-bar><ul class=title-area><li class=name><h1><a href=#>PHENIX</a></h1></li></ul><top-bar-section><!-- Right Nav Section --><ul class=right><li has-dropdown><a href=#>Ateliers</a><ul top-bar-dropdown><li ng-repeat="atelier in navCTRL.listOfAtelier"><a href=#>{{::atelier.label}}</a></li></ul></li></ul><!-- Left Nav Section --><ul class=left><li><a href=#>Catalogue PR et AXS</a></li><li><a href=#>Documentation technique</a></li><li><a href=#>Commande</a></li><li><a href=#>Animation commerciale</a></li><li><a href=#>Administration</a></li></ul></top-bar-section></top-bar>');
$templateCache.put('app/core/paginateList/paginateList.template.html','<div class=paginationList ng-if="vm.nbPages > 1"><!-- PREVIOUS BUTTON --><div class=container-arrow><i ng-if="vm.actualPage > 1" ng-click=vm.previous() class=icon-icons_arrow_left_panier></i> &nbsp;</div><!-- PAGE LABEL --><div>{{\'COMMON_PAGINATION_PAGE\'| translate}}&nbsp;</div><!-- LIST PAGE --><div class=custom-select><select ng-change=vm.onUpdate() ng-model=vm.actualPage ng-options="page for page in vm.list"></select></div><!-- NUMBER PAGE --><div>&nbsp;{{\'COMMON_PAGINATION_ON\'| translate}} {{vm.nbPages}}</div><!-- NEXT BUTTON --><div class=container-arrow><i ng-click=vm.next() ng-if="vm.actualPage < vm.nbPages" class=icon-icons_arrow_right_panier></i> &nbsp;</div></div>');
$templateCache.put('app/core/pagination/pagination.html','<div class=pagination-container ng-if="vm.paginationMaxPage > 1"><button class="pagination-btn pagination-btn--arrow-icon icon-icons_arrow_left-client" ng-click="vm.paginateClick(vm.paginationPage - 1)" ng-class="{\'disable\':vm.paginationPage <= vm.firstPage}" ng-disabled="vm.paginationPage <= vm.firstPage"></button> <span class=pagination-text>Page </span><!--scope--> <span class=pagination-number ng-if="vm.paginationMode === \'text\'">{{vm.paginationPage}} </span><!--select box--><div class=custom-select ng-if="vm.paginationMode === \'select\'"><select class=pagination-select-box ng-change=vm.paginateClick(vm.paginationPage) ng-model=vm.paginationPage ng-options="page for page in vm.paginateRange(1, vm.paginationMaxPage)"></select></div><span class=pagination-text>sur {{vm.paginationMaxPage}}</span> <button class="pagination-btn pagination-btn--arrow-icon icon-icons_arrow_right-client" ng-click="vm.paginateClick(vm.paginationPage + 1)" ng-class="{\'disable\':vm.paginationPage >= vm.paginationMaxPage}" ng-disabled="vm.paginationPage >= vm.paginationMaxPage"></button></div>');
$templateCache.put('app/core/partListModal/partListModal.html','<div class=PartListModalPhenix><div class="columns text-right close"><span class=closeText ng-click=vm.cancel()>Fermer<span class=icon-icons_close_partlist></span></span></div><label class=title>{{\'LISTPART_MODAL_TITLE\' | translate}}</label> <label class=partOne>{{\'LISTPART_MODAL_TEXT1\' | translate:vm.translationData}}.</label> <label class=partTwo>{{\'LISTPART_MODAL_TEXT2\' | translate}}</label> <button type=button class=buttonWithIcon ng-click=vm.accept()><div class=iconDiv role=button><i class=icon-icons_basket></i></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon no cancel" ng-click=vm.decline()><div class=iconDiv role=button><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div>');
$templateCache.put('app/core/picturesGallery/picturesGallery.html','<div class=picturesGallery><div class=currentPictureContainer><i class=icon-icons_arrow_left ng-click=showPrevious()></i> <img class=pictureContainer ng-src={{currentPicture}} ng-click=openFullScreen() alt=""> <i class=icon-icons_arrow_right ng-click="showNext ()"></i></div><div class=infoNote>{{\'NON_CONTRACTUAL_PICTURES\' | translate}}</div><div class=alignContainer><div class=gallery><img class=thumbnail ng-mouseover=showBig($index) ng-repeat="image in images track by $index" ng-src={{image}} ng-class="{\'selected\': currentIndex == $index}" alt=""></div></div></div>');
$templateCache.put('app/core/picturesGallery/picturesGalleryFullScreen.html','<!--this is contain in class .modalPictureFullScreen--><md-dialog id=picturesGalleryFullScreen style="height: 70%; width: 50%; padding: 10px"><md-dialog-content class="flex-column h-100"><div style="margin-bottom: 5px"><div class=close ng-click=vm.closePopin() style="float: right">{{\'MODAL_CLOSE\' | translate}} <i class=icon-icons_close></i></div></div><div class="picturesGallery flex-column flex-1"><div class="currentPictureContainer flex-row flex-1"><i class=icon-icons_arrow_left ng-click=vm.showPrevious()></i> <img style="max-width: calc(100% - 50px); max-height: 100%" ng-src={{vm.currentPicture}} ng-click=openFullScreen() alt=""> <i class=icon-icons_arrow_right ng-click=vm.showNext()></i></div><div class=alignContainer><div class=gallery><img class=thumbnail ng-mouseover=vm.showBig($index) ng-repeat="image in vm.images track by $index" ng-src={{image}} ng-class="{\'selected\': vm.currentIndex == $index}" alt=""></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/core/recap-cart/recap-cart.template.html','<div ng-if=$ctrl.flattenCart.length id=recap-cart><!-- ***************\n        HEADER\n    *****************--><div class=recap-cart-header><div><img class=popinIcon src=./assets/svg/newHeader/shop-cart.svg style="height:24px; width:24px; vertical-align:middle;" ng-if=$ctrl.newHeader> <i class="icon-icons_basket popinIcon" role=button tabindex=0 ng-if=!$ctrl.newHeader></i></div><div class=recap-cart-header-description><div class="recap-cart-ellipsis popinTitle font-bold">{{\'LABEL_NUM_BASKET\' |translate}} {{$ctrl.cartMetadata.id}}</div><div ng-if=$ctrl.cartMetadata.label class="recap-cart-ellipsis popinSubtitle">{{$ctrl.cartMetadata.label}}</div></div></div><div class=container-list><!-- *****************\n            PR DATA ROW\n        *******************--><div ng-if=$ctrl.pr.length><div class=category><h7><span class="category-title font-bold">{{\'HEADER_PR\' | translate }}</span></h7></div><div class="list border-bottom" ng-repeat="element in $ctrl.pr"><div class="id white-space">{{element.reference | filterFormatRef}}</div><div class=designation>{{element.designation}}</div><div class=quantity>{{element.quantity}}</div></div></div><!-- ***************\n            TM DATA ROW\n        *****************--><div ng-if=$ctrl.tm.length><div class=category><h7><span class="title font-bold">{{\'COMMON_TABLE_MO_TITLE\' | translate }}</span></h7></div><div class="list border-bottom" style="display: flex" ng-repeat="element in $ctrl.tm"><div class=id>{{element.opecod}}</div><div class=designation>{{element.designation}}</div><div class=quantity>{{element.quantity}}</div></div></div></div></div>');
$templateCache.put('app/core/revealPwd/revealPwd.html','<div class=reveal-pwd-container><input ng-attr-type="{{ showPassword ? \'text\' : \'password\' }}" ng-model=pwdModel><div class=reveal-pwd-eye ng-class="showPassword? \'\' : \'hidePwd\'" ng-click="showPassword = !showPassword"></div></div>');
$templateCache.put('app/core/select/select-intervention.template.html','<div id=selectIntervention><select ng-class="{\n                error: vm.interventionIsMandatory && vm.split.splitLabel === \'-\'\n            }" ng-options="split.computedLabel for split in vm.splits" ng-model=vm.split ng-change=vm.onUpdate(vm.split) class=select-intervention></select></div>');
$templateCache.put('app/core/spinnerLoadingDms/spinner-loading-dms.template.html','<img src=./assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}');
$templateCache.put('app/core/spinner/angular-block-ui.ng.html','<div class=block-ui-overlay></div><div class=block-ui-message-container aria-live=assertive aria-atomic=true><div class=block-ui-message ng-class=$_blockUiMessageClass><div class=loading><img src=./assets/images/newHourGlassGrey.gif width=80 height=80></div>{{ state.message }}</div></div>');
$templateCache.put('app/core/stickyNotification/stickyNotification.html','<div id=stickyNotification ng-if=vmStickyNotif.isEdited><img src=./assets/svg/icons_warning_document.svg class=warning alt=""> <label class=sticklblText>{{\'TOOLTIP_ESTIMATE_TOSAVE\' |translate}}</label><div class=save ng-click=vmStickyNotif.saveAction()><label class=buttonMAJ>{{\'COMMON_SAVE\' |translate}}</label></div></div>');
$templateCache.put('app/core/typePaintTMModal/typePaintTMModal.html','<div class=modalPhenix><div id=modalTypePaintTmPhenix><label class=title>{{\'TM_TYPE_PAINT_TITLE\' | translate}}</label><div class=custom-select><select name=select ng-model=vm.typePaintTm value="{{\'TM_TYPE_PAINT_2\' | translate}}"><option value="{{\'TM_TYPE_PAINT_1\' | translate}}" selected=selected>{{\'TM_TYPE_PAINT_1\' | translate}}</option><option value="{{\'TM_TYPE_PAINT_2\' | translate}}">{{\'TM_TYPE_PAINT_2\' | translate}}</option><option value="{{\'TM_TYPE_PAINT_3\' | translate}}">{{\'TM_TYPE_PAINT_3\' | translate}}</option><option value="{{\'TM_TYPE_PAINT_4\' | translate}}">{{\'TM_TYPE_PAINT_4\' | translate}}</option></select></div><div class=actionButton><button type=submit ng-click=vm.addToEstimate() class=buttonWithIcon><div class=iconDiv><i class=icon-icons_expendable_plus></i></div><div class=btnText>{{\'PRODUCT_ADD_TO_ESTIMATE\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'| translate}}</div></button></div></div></div>');
$templateCache.put('app/core/uploadFile/uploadFile.html','<button ng-if=!listAlerts ng-click=selectFileUpload(idFile) class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><i class=icon-icons_expendable_plus></i></div><div class=btnText>{{"ALERTS_ADD_FILES" | translate}}</div></button> <button ng-if=listAlerts class=attach-file-btn-inline ng-click=selectFileUpload(idFile) ng-disabled=disabledCondition><i class="fa fa-plus"></i> {{"ATTACH_A_FILE" | translate}}</button> <input ng-show=false type=file size=60 name=file id={{idFile}} class=input_file_style_file>');
$templateCache.put('app/components/actis/components/SupportIndendependentModePopup.html','<div class=supportIndependentop><div style=padding:6px><strong>{{"SUPPORT_INDEPENDENT_MODE_CLOSPOPUP_DESCRIPTION1"| translate}}</strong></div><div style=padding:6px>{{"SUPPORT_INDEPENDENT_MODE_CLOSPOPUP_DESCRIPTION2"| translate}}</div><div style=padding:6px class=text-center><!-- <button class="buttonWithIcon " style="width:200px;" ng-click="vm.onConfirm(true)">\n            <div class="iconDiv">\n                <em class="icon-icons_save" style="font-weight:bolder;"></em>\n            </div>\n            <div class="btnText">{{"SUPPORT_INDEPENDENT_SAVE_AS_DRAFT"| translate}}</div>\n        </button> --> <button class="buttonWithIcon cancel" style="width:200px; margin-left: 25px;" ng-click=vm.onCancel(false)><div class=iconDiv><em class=icon-icons_close></em></div><div class=btnText>CANCEL</div></button></div></div>');
$templateCache.put('app/components/actis/components/accessoires-actis.template.html','<div class=brwAccordion id=accessoriesActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isAccessoriesOpen><accordion-heading><div ng-keypress ng-click="vm.isAccessoriesOpen == !vm.isAccessoriesOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isAccessoriesOpen,\'icon-icons_exependable_moins float-left\':vm.isAccessoriesOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'ACTIS_ACCESSOIRES_TITLE\' | translate}}</label></div></div></accordion-heading><form style=margin-top:1%;><div class=row><div class="small-4 columns"><label for=actis-reference>{{\'ACTIS_ACCESSOIRES_REFERENCE\' | translate}}</label> <input aria-label=actis-reference id=actis-reference type=text ng-model=vm.reference ng-readonly=vm.nonModifiableFic></div><div class="small-4 columns" style=float:left;><label for=nonModFic>{{\'ACTIS_ACCESSOIRES_PRODUCT_NAME\' | translate}}</label> <input aria-label=nonModFic id=nonModFic type=text ng-model=vm.nomProduit ng-readonly=vm.nonModifiableFic></div></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/agrement-actis.template.html','<div class=brwAccordion id=agreementActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isAgreementOpen><accordion-heading><div ng-keypress ng-click="vm.isAgreementOpen == !vm.isAgreementOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isAgreementOpen,\'icon-icons_exependable_moins float-left\':vm.isAgreementOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'ACTIS_AGREMENT_TITLE\' | translate}}</label></div></div></accordion-heading><form style=margin-top:1%;><div class=row><div class="small-3 columns"><label for=status>{{\'ACTIS_AGREMENT_STATUS\' | translate}}</label> <input type=text id=status aria-label=status ng-model=vm.status_agrement readonly=readonly style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;"></div><div class="small-5 columns" style=float:left;><label for=designation>{{\'ACTIS_AGREMENT_DESIGNATION\' | translate}}</label> <input type=text id=designation aria-label=designation ng-model=vm.designation_agrement readonly=readonly style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;"></div></div><div class=row><div class="small-6 columns"><label for=intervention>{{\'ACTIS_AGREMENT_INTERVENTION\' | translate}}</label> <input type=text id=intervention aria-label=intervention ng-model=vm.montantOperationAgrement readonly=readonly style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;"></div></div><div class=row><div class="small-6 columns"><label for=pieceHT>{{\'ACTIS_AGREMENT_PIECES\' | translate}}</label> <input type=text id=pieceHT aria-label=priceHT ng-model=vm.montantPiecesHTAutorise readonly=readonly style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;"></div></div><div class=row><div class="small-6 columns"><label for=MOHT>{{\'ACTIS_AGREMENT_MO\' | translate}}</label> <input type=text id=MOHT aria-label=MOHT ng-model=vm.montantMOHTMaxAutorise readonly=readonly style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;"></div></div><div class=row style=margin-top:1%;><md-table-container><table md-table class=agreementComponentFields><thead md-head><tr md-row><th md-column id=agree-piece><span>{{\'ACTIS_AGREMENT_IDENTIFICATION_PIECE\' | translate}}</span></th><th md-column id=agree-athorise><span>{{\'ACTIS_AGREMENT_AUTORISATION\' | translate}}</span></th></tr></thead><tbody md-body><tr ng-repeat="item in vm.agreements"><td md-cell>{{item.idIndividualParts}}</td><td md-cell>{{item.authorisationToReplace}}</td></tr></tbody></table></md-table-container></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/attachment-actis.template.html','<div class=row><div ng-show=!vm.isStatusPresent><div ng-disabled="isLoading || ((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser))" ngf-drop ngf-select ng-model=file class=drop-box ngf-drag-over-class="\'dragover\'" ngf-multiple=false id=attachmentBox ngf-allow-dir=true ng-class="vm.changeAttachmentBoxColor(\'attachmentBox\')">{{\'ACTIS_UPLOAD_SECTION\' | translate}}<br>or<!-- {{\'LABEL_OR\' | translate}} --></div><div class="small-12 small-offset-5 columns" style="margin-top: -5%;\n        padding-left: 0px;"><button class="alerts-popin-btn buttonWithIcon" ng-disabled="isLoading || ((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser))" ngf-select ng-model=file ngf-multiple=false style="border-radius: 20px;\n                padding: 3px 7px; color: white !important;"><div class=iconDiv><i class=icon-icons_expendable_plus></i></div><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button></div></div><div class=row ng-show="((vm.isActisProfil && ((vm.status !== \'Closed\' || vm.responseApi.CaseDetail.status !== \'Closed\') && (vm.status !== \'Sent\' || vm.responseApi.CaseDetail.status !== \'Sent\'))) || (!vm.isActisProfil && !vm.isQstomizeClosedFic && !vm.isQstomizeSentFic) || (!vm.isActisProfil && ((vm.status !== \'Closed\' || vm.responseApi.CaseDetail.status !== \'Closed\') && (vm.status !== \'Sent\' || vm.responseApi.CaseDetail.status !== \'Sent\'))) || (vm.isIndependentUser && vm.isFicReopen)) && vm.isStatusPresent && !vm.nonModifiableFic" style="background-color: gray;"><label style="text-align: center; margin: 5%; color:white;">{{\'ATTACHMENT_ACTIS_LABEL\' | translate}}</label></div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><div class=row style="margin-top: 2%;" ng-if="vm.isDraft || vm.isActisFromDiag || vm.isForQstomize" ng-hide=vm.isIndependentUser><div ng-keypress class=btnTextColor style="width: 10%; float: right;" ng-hide="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) ) || (vm.nonModifiableFic || vm.isFicReopen || vm.isSaveButtonVisible || vm.isForBwr || vm.isForPaint || vm.isForAccessories) || (vm.isForQstomize && vm.type === \'qstomize\' && (vm.status === \'Closed\' || vm.responseApi.CaseDetail.status === \'Closed\'))" ng-click="vm.handleQstomize(false, vm.isTreeStructureNodeSelected)"><button class="alerts-popin-btn buttonWithIcon save-white" style="border-radius: 15px;\n            padding: 5px;"><div class=iconDiv><em class="icon-icons_save_actis icon-icons_save_actis-adjusted"></em></div><div class="btnText btnText-save-adjusted">{{"ACTIS_HEADER_SAVE" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor style="width: 12%; margin-left: 17px; float: right;" ng-hide="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) ) || (vm.nonModifiableFic || vm.isFicReopen || vm.isSaveButtonVisible || vm.isForBwr || vm.isForPaint || vm.isForAccessories) || (vm.isForQstomize && vm.type === \'qstomize\' && (vm.status === \'Closed\' || vm.responseApi.CaseDetail.status === \'Closed\'))" ng-click=vm.backToPrevious()><button class="alerts-popin-btn buttonWithIcon cancel" style="background-color:#ccc8c8;border-radius: 15px;\n            padding: 5px;"><div class=iconDiv><em class="fa fa-times fa-times-adjusted" aria-hidden=true></em></div><div class="btnText btnText-cancel-adjusted">{{\'COMMON_CANCEL\' | translate}}</div></button></div></div><div ng-show=!vm.isStatusPresent><div class="small-12 columns padding-l0" ng-if="vm.showCoTechFilesInAttachment.length > 0 || filesToBeShown.length > 0">Files:</div><div class="row blocFile padding-l0" ng-if="vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0" ng-repeat="files in vm.showCoTechFilesInAttachment track by $index" style="line-height: 0px;"><!--<button ng-if="files.scannedStatus !== vm.scannedStatusOk" style="margin-left: 20px; margin-right: 5px; margin-bottom: 20px;" id="attachmentButtonFileNameRed">{{files.fileName}}</button>--><!-- <button ng-if="files.scannedStatus !== vm.scannedStatusOk" id="attachmentButtonFileNameRed" \n                ng-click="close(files, $index)" class="clickable padding-l0">\n                <em class="icon-icons_close_big_actis"></em>\n            </button> --> <button ng-if="files.scannedStatus === vm.scannedStatusOk" style="margin-right: 5px; margin-bottom: 20px;" id=attachmentButtonFileName ng-href ng-click="downloadPdf(f, $index)" class=padding-l0>{{files.fileName}}</button> <button ng-if="files.scannedStatus === vm.scannedStatusOk" id=attachmentButtonFileName ng-click="close(files, $index)" class="clickable padding-l0"><em class=icon-icons_close_big_actis></em></button></div><div><a style=float:right; ng-if="((vm.pageNumber < vm.totalPages) && vm.showCoTechFilesInAttachment.length > 0)" ng-click=vm.getMoreAttachments()>{{"SHOW_MORE"|translate}}&nbsp;</a></div><div class="row blocFile" ng-if="filesToBeShown.length > 0" ng-repeat="f in filesToBeShown track by $index"><div class="small-7 columns padding-l0" style="padding-bottom: 3px; word-break: break-all;"><button id=attachmentButtonFileName ng-href ng-click=downloadPdf(f)>{{f.name}}</button> {{f.$error}}{{f.$errorParam}}</div><div class="small-3 columns" style="padding-bottom: 3px;"><div class=progress ng-if=showProgressBar($index)><div ng-style="{ width: onLoading + \'%\' }" ng-bind="onLoading + \'%\'"></div></div><div ng-class="{background : showProgressBar($index)}">{{fileConvertSize(f.size)}}</div></div><div class="small-2 columns" style="padding-bottom: 3px;"><div><button id=attachmentButtonFileName ng-click="close(f, $index, true)" class=clickable><em class=icon-icons_close_big_actis></em></button></div></div></div></div></div>');
$templateCache.put('app/components/actis/components/attachmentBRW-actis.template.html','<div class=row ng-show=!vm.isStatusPresent><div class="small-12 columns">Files:</div><div class="row blocFile" ng-if="vm.showCoTechFilesInAttachment && vm.showCoTechFilesInAttachment.length > 0" ng-repeat="files in vm.showCoTechFilesInAttachment track by $index" style="line-height: 0px;"><button ng-if="files.scannedStatus !== vm.scannedStatusOk" id=attachmentButtonFileNameRed ng-click="close(files, $index)" class=clickable><em class=icon-icons_close_big_actis></em></button> <button ng-if="files.scannedStatus === vm.scannedStatusOk" style="margin-left: 20px; margin-right: 5px; margin-bottom: 20px;" id=attachmentButtonFileName ng-href ng-click="downloadPdf(f, $index)">{{files.fileName}}</button> <button ng-if="files.scannedStatus === vm.scannedStatusOk" id=attachmentButtonFileName ng-click="close(files, $index)" class=clickable><em class=icon-icons_close_big_actis></em></button></div><div><a style=float:right; ng-if="((vm.pageNumber < vm.totalPages) && vm.showCoTechFilesInAttachment.length > 0)" ng-click=vm.getMoreAttachments()>{{"SHOW_MORE"|translate}}&nbsp;</a></div><div class="row blocFile" ng-if="filesToBeShown.length > 0" ng-repeat="f in filesToBeShown track by $index"><div class="small-7 columns" style="padding-bottom: 3px; word-break: break-all;"><button id=attachmentButtonFileName ng-href ng-click=downloadPdf(f)>{{f.name}}</button> {{f.$error}}{{f.$errorParam}}</div><div class="small-3 columns" style="padding-bottom: 3px;"><div class=progress ng-if=showProgressBar($index)><div ng-style="{ width: onLoading + \'%\' }" ng-bind="onLoading + \'%\'"></div></div><div ng-class="{background : showProgressBar($index)}">{{fileConvertSize(f.size)}}</div></div><div class="small-2 columns" style="padding-bottom: 3px;"><div><button id=attachmentButtonFileName ng-click="close(f, $index, true)" class=clickable><em class=icon-icons_close_big_actis></em></button></div></div></div></div><div class="row blocFile"><div class="small-12 columns"><button class="alerts-popin-btn buttonWithIcon" ng-disabled="isLoading || (!vm.isActisProfil)" ngf-select ng-model=file ngf-multiple=false><div class=iconDiv><em class=icon-icons_expendable_plus></em></div><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button></div></div><div class=row ng-show="vm.isStatusPresent && !vm.nonModifiableFic"><label style="text-align: center; margin: 5%">{{\'ATTACHMENT_ACTIS_LABEL\' | translate}}</label></div>');
$templateCache.put('app/components/actis/components/battery-details.template.html','<div class=row style="margin-bottom: 1%;"><span class=descBRW>{{\'DESC_BRW\' | translate}}</span></div><div class=brwAccordion ng-if="!vm.isFicCreation && !vm.isDraft"><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isBatteryOpen><accordion-heading><div ng-keypress ng-click="vm.isBatteryOpen == !vm.isBatteryOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isBatteryOpen,\'icon-icons_exependable_moins float-left\':vm.isBatteryOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'BATTERY_DETAILS\' | translate}}</label></div></div></accordion-heading><form name=vehicleActis class=batteryDetails><table><tbody><tr><td>{{\'VIN_BATTERY\' | translate}}</td><td>{{\'BIN_NUMBER\' | translate}}<span style="color: red;"> *</span></td><td>{{\'BATTERY_TRANSPORT\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><div class="small-11 columns" style="padding: 0;"><input id=brwVinNumber aria-label=vinNo ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" type=text ng-focus="vm.removeColors(\'brwVinNumber\')" ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 class="ng-pristine ng-empty ng-invalid ng-invalid-required ng-valid-maxlength ng-touched" aria-invalid=true> <span><em class="fa fa-refresh" style="padding:4px;background-image: linear-gradient(190deg, #978B7F, #978B7F);float: right;margin-top: -31px;font-size: large;margin-right: 5px;color: #fff;" ng-click=vm.getBinCarContext(vm.vin) role=button tabindex=0></em></span></div></td><td><input id=binNumber ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" type=text ng-focus="vm.removeColors(\'binNumber\')" required ng-model=vm.bin ng-click=vm.getBin(vm.bin)></td><td><input type=radio ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" required name=batTrans ng-model=vm.batTrans ng-value=false>{{\'BATTERY_ALONE\' | translate}} <input type=radio ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" name=batTrans ng-model=vm.batTrans ng-value=true style=margin-left:10%;>{{\'BATTERY_COMPLETE_VEHICLE\' | translate}}</td></tr><tr><td>{{\'ACTIS_DESCRIPTION_OR\' | translate}}<span style="color: red;"> *</span></td><td>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><input type=text aria-label=orNumber ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=orNumber ng-focus="vm.removeColors(\'orNumber\')" required ng-model=vm.repairOrder></td><td><md-input-container class=dateOr><md-datepicker ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" type=date id=orDate required ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate></md-datepicker></md-input-container></td></tr><tr><td>{{\'PACK_MILEAGE\' | translate}}<md-tooltip><span>{{\'PACK_MILEAGE_TOOLTIP\' | translate}}</span></md-tooltip><em class="fa fa-info-circle"></em></td><td>{{\'UNIT_MILEAGE\' | translate}}</td></tr><tr><td><input type=number ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=packMileage ng-focus="vm.removeColors(\'packMileage\')" ng-model=vm.packMileage onwheel=this.blur()></td><td><input type=radio ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" name=unitMileage ng-model=vm.unitMileage ng-value="\'Km\'">Km <input type=radio ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" name=unitMileage ng-model=vm.unitMileage ng-value="\'Miles\'" style=margin-left:10%;>Miles</td></tr><tr><td>{{\'GLOBAL_KWH\' | translate}}</td></tr><tr><td><input type=number ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=globalKwh ng-focus="vm.removeColors(\'globalKwh\')" ng-model=vm.globalKwh onwheel=this.blur()></td></tr><tr><td>{{\'SYMPTOM_LABEL\' | translate}}<md-tooltip ng-if="!(vm.vin&&vm.vin.length===17)"><span>{{\'BRW_SYMPTOMS_TOOLTIP\' | translate}}</span></md-tooltip><span ng-if="!(vm.vin && vm.vin.length===17)"><em class="fa fa-info-circle"></em></span><span style="color: red;"> *</span></td></tr><tr><td ng-if="!(vm.carContext.vin && vm.carContext.vin.length===17) && vm.SymptomsEnable"><input type=text disabled=disabled></td><td ng-if=!vm.SymptomsEnable><input type=text disabled=disabled></td><td ng-if="vm.carContext.vin && vm.carContext.vin.length === 17 && vm.SymptomsEnable" ng-controller="SearchByDiagnosticController as vm"><symptom-search response-api=vm.responseApi is-days-to-reopen=vm.isDaysToReopen non-modifiable-fic=vm.nonModifiableFic is-fic-cancelled=vm.isFicCancelled is-fic-reopen=vm.isFicReopen is-independent-user=vm.isIndependentUser></symptom-search></td></tr></tbody></table></form></accordion-group></accordion></div><div class=brwAccordion ng-if="vm.isFicCreation || vm.isDraft"><div><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'BATTERY_DETAILS\' | translate}}</label></div></div><form name=vehicleActis class=batteryDetails><table><tbody><tr><td>{{\'VIN_BATTERY\' | translate}}</td><td>{{\'BIN_NUMBER\' | translate}}<span style="color: red;"> *</span></td><td>{{\'BATTERY_TRANSPORT\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><div class="small-11 columns" style="padding: 0;"><input id=brwVinNumber aria-label=vinNo type=text ng-disabled=(!vm.isActisProfil) ng-focus="vm.removeColors(\'brwVinNumber\')" ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 class="ng-pristine ng-empty ng-invalid ng-invalid-required ng-valid-maxlength ng-touched" aria-invalid=true> <span><em class="fa fa-refresh" style="padding:4px;background-image: linear-gradient(190deg, #978B7F, #978B7F);float: right;margin-top: -31px;font-size: large;margin-right: 5px;color: #fff;" ng-click=vm.getBinCarContext(vm.vin) role=button tabindex=0></em></span></div></td><td><input id=binNumber type=text ng-disabled=(!vm.isActisProfil) ng-focus="vm.removeColors(\'binNumber\')" required ng-model=vm.bin ng-click=vm.getBin(vm.bin)></td><td><input type=radio ng-disabled=(!vm.isActisProfil) required name=batTrans ng-model=vm.batTrans ng-value=false>{{\'BATTERY_ALONE\' | translate}} <input type=radio name=batTrans ng-disabled=(!vm.isActisProfil) ng-model=vm.batTrans ng-value=true style=margin-left:10%;>{{\'BATTERY_COMPLETE_VEHICLE\' | translate}}</td></tr><tr><td>{{\'ACTIS_DESCRIPTION_OR\' | translate}}<span style="color: red;"> *</span></td><td>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><input type=text id=orNumber ng-disabled=(!vm.isActisProfil) ng-focus="vm.removeColors(\'orNumber\')" required ng-model=vm.repairOrder></td><td><md-input-container class=dateOr><md-datepicker type=date id=orDate ng-disabled=(!vm.isActisProfil) required ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate></md-datepicker></md-input-container></td></tr><tr><td>{{\'PACK_MILEAGE\' | translate}}<md-tooltip><span>{{\'PACK_MILEAGE_TOOLTIP\' | translate}}</span></md-tooltip><em class="fa fa-info-circle"></em></td><td>{{\'UNIT_MILEAGE\' | translate}}</td></tr><tr><td><input type=number id=packMileage ng-disabled=(!vm.isActisProfil) ng-focus="vm.removeColors(\'packMileage\')" ng-model=vm.packMileage onwheel=this.blur()></td><td><input type=radio name=unitMileage ng-disabled=(!vm.isActisProfil) ng-model=vm.unitMileage ng-value="\'Km\'">Km <input type=radio name=unitMileage ng-disabled=(!vm.isActisProfil) ng-model=vm.unitMileage ng-value="\'Miles\'" style=margin-left:10%;>Miles</td></tr><tr><td>{{\'GLOBAL_KWH\' | translate}}</td></tr><tr><td><input type=number id=globalKwh ng-disabled=(!vm.isActisProfil) ng-focus="vm.removeColors(\'globalKwh\')" ng-model=vm.globalKwh onwheel=this.blur()></td></tr><tr><td>{{\'SYMPTOM_LABEL\' | translate}}<md-tooltip ng-if="!(vm.vin&&vm.vin.length===17)"><span>{{\'BRW_SYMPTOMS_TOOLTIP\' | translate}}</span></md-tooltip><span ng-if="!(vm.carContext.vin && vm.carContext.vin.length === 17)"><em class="fa fa-info-circle"></em></span><span style="color: red;"> *</span></td></tr><tr><td ng-if="!(vm.carContext.vin && vm.carContext.vin.length === 17) && vm.SymptomsEnable"><input type=text disabled=disabled></td><td ng-if=!vm.SymptomsEnable><input type=text disabled=disabled></td><td ng-if="vm.carContext.vin && vm.carContext.vin.length===17 && vm.SymptomsEnable" ng-controller="SearchByDiagnosticController as vm"><symptom-search is-disabled="!vm.isActisProfil && !vm.isEditMode && !vm.isDraft"></symptom-search></td></tr></tbody></table></form></div>');
$templateCache.put('app/components/actis/components/deleteFicConfirmation.template.html','<md-dialog id=modalOnDeleteCart><div class=modalPhenix><div class=title>{{\'DELETE_FIC_DIALOG_TITLE\' | translate}}</div><div class="modalPhenixButtons modalPhenixButtons-centered"><button type=button class="buttonWithIcon left left-white" ng-click=vm.onConfirm()><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><em class="icon-icons_close icon-icons_close-primary"></em></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/actis/components/description-actis.template.html','<div class=brwAccordion id=descriptionActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isDescriptionOpen><accordion-heading><div ng-keypress ng-click="vm.isDescriptionOpen == !vm.isDescriptionOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isDescriptionOpen,\n                        \'icon-icons_exependable_moins float-left\':vm.isDescriptionOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}}</label></div></div></accordion-heading><form name=descriptionForm class=description style=margin-top:2%;><div class=row><div class="small-5 columns" style=display:flex; ng-if="vm.isApprovalFic && vm.user.country == \'FR\' "><label>{{\'STANDARD_EXCHANGE_LABEL\'| translate}}* <span class=icon-information id=cursor-default><md-tooltip id=standardExchangeToolTip><div id=standardExchangeToolTipDiv><li>{{\'STANDARD_EXCHANGE_INFO\' | translate}}</li></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="standard exchange" id=standardExchangeToolTipIcon md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></span></label> <span><md-radio-group ng-model=vm.reference ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style="display: inline-flex;" id=standard_exchange ng-class="vm.radioButtonColorChange(\'standard_exchange\')" required><md-radio-button value=yes style="margin-left: 25px;">{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</md-radio-button><md-radio-button value=no style="margin-left: 33px;">{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</md-radio-button></md-radio-group></span></div></div><div class=row><div class="small-4 columns" ng-switch=vm.type><div ng-switch-when=zeBattery><label for=orNumber>{{\'ACTIS_DESCRIPTION_OR\' | translate}}*</label> <input type=text aria-label=batteryOrNumber id=orNumber ng-focus="vm.removeColors(\'orNumber\')" ng-model=vm.or ng-maxlength=40 name=or required ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                        (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div><div ng-switch-when=others><label for=orNumber>{{\'ACTIS_DESCRIPTION_OR\' | translate}}*</label> <input type=text aria-label=orNumber id=orNumber ng-focus="vm.removeColors(\'orNumber\')" ng-model=vm.or ng-maxlength=40 name=or required ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                        (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div><div ng-switch-when=painting><label for=orNumber>{{\'ACTIS_DESCRIPTION_OR\' | translate}}</label> <input type=text aria-label=paintOrNumber id=orNumber ng-focus="vm.removeColors(\'orNumber\')" ng-model=vm.or ng-maxlength=40 name=or ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                        (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div><div ng-switch-when=accessory><label for=orNumber>{{\'ACTIS_DESCRIPTION_OR\' | translate}}</label> <input type=text aria-label=accessoryOrNumber id=orNumber ng-focus="vm.removeColors(\'orNumber\')" ng-model=vm.or ng-maxlength=40 name=or ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                        (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div></div><div class="small-4 columns" ng-switch=vm.type style=float:left;><div ng-switch-when=others class=dateOr><label for=orDate>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}*</label><md-datepicker type=date id=orDate ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate required ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                   (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                   (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                                   (!vm.isFicCancelled || vm.isFicReopen)) || \n                                   ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></md-datepicker></div><div ng-switch-when=zeBattery class=dateOr><label for=orDate>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}*</label><md-datepicker type=date id=orDate ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate required ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                   (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                   (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                                   (!vm.isFicCancelled || vm.isFicReopen)) || \n                                   ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></md-datepicker></div><div ng-switch-when=painting class=dateOr><label for=orDate>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}</label><md-datepicker type=date id=orDate ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                   (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                   (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                                   (!vm.isFicCancelled || vm.isFicReopen)) || \n                                   ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></md-datepicker></div><div ng-switch-when=accessory class=dateOr><label for=orDate>{{\'ACTIS_DESCRIPTION_DATE_OR\' | translate}}</label><md-datepicker type=date id=orDate ng-focus="vm.removeColors(\'orDate\')" ng-model=vm.dateOr name=dateOr md-current-view=day md-max-date=vm.currentDate ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                   (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                   (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                                   (!vm.isFicCancelled || vm.isFicReopen)) || \n                                   ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></md-datepicker></div></div></div><div class=row><div class="small-3 columns" ng-if="vm.type ===\'accessory\' || vm.type ===\'painting\'"><div class=incident1><md-select ng-model=vm.selectedInfoIncident1 ng-model-options="{trackBy: \'$value.id\'}" placeholder="{{\'ACTIS_DESCRIPTION_INFO_INCIDENT1\' | translate}}" ng-change=vm.resetSubcategory() ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                               (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                               (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                               (!vm.isFicCancelled || vm.isFicReopen)) || \n                               ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"><md-option ng-value=incident1 ng-repeat="incident1 in vm.infosIncident1" ng-selected="{{ incident1.isDefault == true }}">{{ incident1.name }}</md-option></md-select></div></div><div class="small-5 columns" ng-if="vm.type ===\'accessory\' || vm.type ===\'painting\'" style=float:left;><div class=incident2><md-select ng-model=vm.selectedInfoIncident2 ng-model-options="{trackBy: \'$value.id\'}" placeholder="{{\'ACTIS_DESCRIPTION_INFO_INCIDENT2\' | translate}}" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                               (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                               (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && \n                               (!vm.isFicCancelled || vm.isFicReopen)) || \n                               ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"><md-option ng-value=incident2 ng-repeat="incident2 in vm.selectedInfoIncident1.subCategory">{{ incident2.name }}</md-option></md-select></div></div></div><div class="row left-collapse" ng-if="vm.type ===\'others\' || vm.type ===\'zeBattery\'" style="margin-top:1%; padding-left: 0.9375rem;"><div class="small-3 columns symptomCodeBloc" style=margin-bottom:0px;><div class=symptomCode><label for=symptomCodeColor>{{\'ACTIS_DESCRIPTION_SYMPTOM_CODE\' | translate}}*</label> <input type=text aria-label=symptomCodeColor id=symptomCodeColor ng-model=vm.code name=code required readonly=readonly></div></div><div class="small-5 columns symptomDesignationBloc" style=margin-bottom:0px;><div class=symptomDesignation><label for=symptomLabelColor>{{\'ACTIS_DESCRIPTION_SYMPTOM_DESIGNATION\' | translate}}</label> <input class=ellipsis aria-label=symptpmLabel id=symptomLabelColor type=text ng-model=vm.symptomCode name=label readonly=readonly></div></div><div id=searchSymptom class="small-2 column" ng-hide="(vm.symptomCode != null && vm.symptomCode !=\'\' && \n                vm.isCreateActisSearchedSymptom!= true) || vm.createMotrioFic || \n                (vm.nonModifiableFic && vm.responseApi.CaseDetail.status !== \'Draft\')"><button class="md-primary md-buttonSearch" type=button ng-click=vm.searchSymptom() style="margin-top: 15%;" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" ng-hide="(vm.symptomCode != null && vm.symptomCode !=\'\' && \n                        vm.isCreateActisSearchedSymptom!= true) || vm.createMotrioFic || \n                        (vm.nonModifiableFic && vm.responseApi.CaseDetail.status !== \'Draft\')"><em class=icon-icons_search_arbo></em></button></div></div><div class="row diagDropDownList" ng-if="vm.type ===\'others\' || vm.type ===\'zeBattery\'" ng-hide="!vm.isActisFromDiag || (vm.isDraft && vm.isEditMode && !vm.isActisFromDiag)"><div id=diagFilesDropDown><div class=dtc><label style="left: -2px !important;">{{\'LOCATION_ARBO\' | translate}}*</label><form layout=row layout=row layout-align="start center" class="small-7 columns"><accordion class=collapse id=treeNodeAccord style="left: 7px; position: relative;"><accordion-group class=accord is-open=vm.isOpen><accordion-heading><div ng-keypress class=right-row-one ng-model=vm.collapssed id=treeNodeSelected style="width: 102%;" ng-class="{\'selectedOne\':vm.display || \n                                    (!vm.display && vm.fisrtNodeName === undefined && vm.secondNodeName === undefined), \n                                    \'notSelected\': !vm.display && vm.descriptionData && \n                                    vm.descriptionData.fisrtNodeName=== \'\' && vm.descriptionData.secondNodeName=== \'\', \n                                    \'disabled\':(vm.isDraft && vm.descriptionData && vm.descriptionData.fisrtNodeName && \n                                    vm.descriptionData.secondNodeName) || (vm.responseApi.Request.fisrtNodeName && \n                                    vm.responseApi.Request.secondNodeName && vm.isDraft) || \n                                    (vm.status === \'Answered\' || vm.status === \'Resolved\')}" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                    (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                    (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                    ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen) || \n                                    (vm.status === \'Answered\' || vm.status === \'Resolved\')" ng-click=vm.clickAccord() required><span class=iconDivs ng-if=" vm.display">{{vm.fisrtNodeName}} > {{ vm.secondNodeName}} </span><span class=iconDivs ng-if=" !vm.display ">{{\'SELECT_TREE\' | translate}} </span><em ng-class="{\'iconRight2 icon-icons_arrow_top\':vm.collapssed,\n                                        \'iconRight2 icon-icons_arrow_bottom\':!vm.collapssed}"></em></div></accordion-heading><div ng-if=!vm.cardBody><div class=card-body style="overflow-y: scroll;\n                                max-height: 244px;background: var(--renaultPrimaryColor);\n                                right: 27px;"><div ng-keypress ng-repeat="value in vm.firstLevelNode" class=diagList><div ng-keypress ng-click=vm.onClickFirstNode(value) ng-class="{\'activeMenuTab\':value.isActive,\'inactiveMenuTab\':!value.isActive}" class=subCateogire>{{ value.label }} <span><em class="icon-icons_arrow_right arrowIcon" style="float: right;padding-top: 5px;"></em></span></div></div></div><div class=card-body ng-if=vm.displaySecondNode style="bottom: 247px;background: var(--renaultPrimaryColor);left: 473px;max-height: 243px;overflow-y: auto;"><div ng-if=vm.displaySecondNode><div ng-keypress class=subCateogire ng-click="vm.saveSecondNode(value);vm.isOpen = !vm.isOpen;vm.collapssed=!vm.collapssed" ng-repeat="value in vm.secondLevelNode">{{value.label}}</div></div></div></div></accordion-group></accordion></form></div></div></div><div class="row diagDropDownList" ng-if="vm.type ===\'others\' || vm.type ===\'zeBattery\'"><div id=diagFilesDropDown><div class=dtc><label style="left: -2px !important;">{{\'VDH_DIAG_TAB\' | translate | toCamelCase}}</label><form layout=row layout=row layout-align="start center" class="small-7 columns"><accordion class=collapse close-others=false style="left: -7px; position: relative;"><div class=textDataNotFound ng-if=!vm.diagDataFound><span class=noDiagData>{{\'NO_RECORDED_DIAG_FILE\' | translate}}</span></div><accordion-group class=accord is-open=$scope.isOpen ng-if=vm.diagDataFound><accordion-heading><div ng-keypress class=right-row-one ng-model=$scope.collapssed id=diagFileSelected ng-class="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                    (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                    (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                    ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen) ? \n                                    \'disable\' : \'hightlightSel\'" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                    (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                    (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                    ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen) || \n                                    (vm.status === \'Answered\' || vm.status === \'Resolved\')" ng-click=vm.expandDiagList()><span class=iconDivs ng-if=vm.diagFilesList>{{vm.selectedDiagFile}}</span> <em ng-class="{\'iconRight2 icon-icons_arrow_top\':$scope.collapssed,\n                                        \'iconRight2 icon-icons_arrow_bottom\':!$scope.collapssed}"></em></div></accordion-heading><div><div class=card-body><div ng-repeat="diag in vm.diagFilesList | filter : vm.initialCategory" class=diagList><div ng-keypress class=subCateg ng-click="vm.saveSelectedDiag(diag,true);\n                                                 $scope.isOpen = !$scope.isOpen;\n                                                 $scope.collapssed=!$scope.collapssed"><span><em class=icon-icons_diagnostic ng-if="diag.origin !== \'Stive\' && diag.origin !== \'DDP\'"></em> </span><span><em class=icon-car_assistance_tool style=padding:3px; ng-if="diag.origin === \'Stive\' || diag.origin === \'DDP\'"></em> </span>{{diag.captureDateTime | momentLocaleDate | capitalize }} -{{diag.captureDateTime | limitTo :8:11}}&nbsp;-&nbsp;{{diag.mileage}} <span ng-if="vm.typeMD !== \'ADT\'">&nbsp;KM&nbsp;</span> <span ng-if="vm.isArcaUser || vm.adtTechrole">&nbsp;-&nbsp;{{diag.dealerId}}</span></div></div></div><div class=iconFilter ng-if="vm.typeMD === \'B3\'"><ul><li><span><em id=CLIP ng-click="vm.diagIconClick(\'CLIP\')" ng-keypress="vm.diagIconClick(\'CLIP\')" class="icon-icons_diagnostic b3DiagIcon"></em> <em id=Stive ng-click="vm.diagIconClick(\'Stive\')" ng-keypress="vm.diagIconClick(\'Stive\')" class="icon-car_assistance_tool b3DiagIcon" style=padding:3px;></em></span></li></ul></div><div class=paginationClass ng-if="vm.typeMD === \'ADT\' "><span><em id=ADT ng-click="vm.diagIconClick(\'ADT\')" ng-keypress="vm.diagIconClick(\'ADT\')" class="icon-icons_diagnostic adtDiagIcon"></em> <em id=DDP ng-click="vm.diagIconClick(\'DDP\')" ng-keypress="vm.diagIconClick(\'DDP\')" class="icon-car_assistance_tool ddpDiagIcon"></em></span><pagination-control dataper-page=vm.dataperPage ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser))" total-count=vm.diagFilesList.length page-change=vm.getPagedData(page) is-solution=true current-page=vm.currentPage class=paginationRow></pagination-control></div></div></accordion-group></accordion></form></div></div></div><div class=row><div class="small-12 columns"><div class=textAreaBloc><label for=plianteClient>{{\'ACTIS_DESCRIPTION_CUSTOMER_COMPLAINT\' | translate}}*</label> <textarea id=plianteClient ng-focus="vm.removeTextAreaColors(\'plianteClient\')" ng-model=vm.plianteClientToDisplay name=plianteClient required rows=4 ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)">\n                    </textarea></div></div></div><!-- El\xE9ments \xE0 enlever pour FIC accessoires et peinture --><div class="small-12 columns" ng-hide="vm.type ===\'painting\' || vm.type ===\'accessory\'"><div class=customerComplaint><label class=customerComplaint>{{ \'ACTIS_DESCRIPTION_CUSTOMER_COMPLAINT_REPRODUCED\' | translate }}*</label><md-radio-group ng-model=vm.reproducedCustomerComplaint ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                             (!vm.isActisProfil && vm.isQstomizeTypeFic && \n                                             vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                             (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                             ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=customerComplaintReproduced ng-class="vm.radioButtonColorChange(\'customerComplaintReproduced\')" style="display: flex; gap: 30px; margin-top: 5px;" required><md-radio-button ng-value=true style="font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate }}</md-radio-button><md-radio-button ng-value=false style="font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate }}</md-radio-button></md-radio-group></div></div><div class=row style=margin-top:1%; ng-if="vm.type !== \'painting\' && vm.type !== \'accessory\' && !vm.isIndependentUser"><div class="small-6 columns" ng-if=vm.showOtsField><label for=ots-dropdown ng-class="{\'changeTextColorToRed\': vm.ficSend && (!vm.selectedOts || \n                               vm.selectedOts === \'\' || vm.selectedOts === null)}">{{\'ACTIS_DESCRIPTION_OTS\' | translate}}* <span class=icon-information id=cursor-default><md-tooltip id=otsToolTip><div id=otsToolTipDiv>{{\'ACTIS_DESCRIPTION_OTS_TOOLTIP\' | translate}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="OTS info" id=otsToolTipIcon md-labeled-by-tooltip=md-tooltip-ots role=img>info</md-icon></span></label><md-input-container class=md-block style="width: 90%; margin-top:0px;" ng-class="{\'md-input-invalid\': vm.ficSend && (!vm.selectedOts || vm.selectedOts === \'\' || vm.selectedOts === null), \'notSelected\': !vm.display && vm.descriptionData && \n                                    vm.descriptionData.isDocumentationConsulted  === \'\' && vm.selectedOts !== \'noOtsAvailable\'}"><md-select ng-model=vm.selectedOts placeholder="{{\'ACTIS_DESCRIPTION_OTS_PLACEHOLDER\' | translate}}" style="background-color: white;" id=ots-dropdown required ng-disabled=vm.isOtsFieldDisabled() ng-class="{\'md-input-invalid\': vm.ficSend && (!vm.selectedOts || vm.selectedOts === \'\' || \n                                        vm.selectedOts === null), \n                                        \'backgroundColorRequiredFieldsOTSDropdown\': vm.ficSend && (!vm.selectedOts || \n                                        vm.selectedOts === \'\' || vm.selectedOts === null)}" ng-change=vm.removeOtsColors() md-container-class=ots-select-container><md-option ng-value=null ng-if=!vm.isOtsFieldDisabled() disabled=disabled class=placeholder-option>{{\'ACTIS_DESCRIPTION_OTS_PLACEHOLDER\' | translate}}</md-option><md-option ng-value="\'noOtsAvailable\'" ng-if="vm.selectedOts === \'noOtsAvailable\'">{{\'ACTIS_DESCRIPTION_NO_OTS_VEHICLE\' | translate}}</md-option><md-option ng-value=ots.otsCode ng-repeat="ots in vm.otsData" ng-if="vm.otsData && vm.otsData.length > 0"><span class=ots-color-dot ng-class="{\'ots-red\': ots.colorCode === \'R\', \n                                                 \'ots-blue\': ots.colorCode === \'B\', \n                                                 \'ots-yellow\': ots.colorCode === \'J\',\n                                                 \'ots-green\': ots.colorCode === \'V\',\n                                                 \'ots-lightblue\': ots.colorCode === \'S\',\n                                                 \'ots-peach\': ots.colorCode === \'I\',\n                                                 \'ots-orange\': ots.colorCode === \'O\'}" ng-style="ots.colorCode === \'R\' && \n                                               {\'background-color\': \'#ff0000\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} || \n                                               ots.colorCode === \'B\' && \n                                               {\'background-color\': \'#0000ff\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} || \n                                               ots.colorCode === \'J\' && \n                                               {\'background-color\': \'#ffff00\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} ||\n                                               ots.colorCode === \'V\' && \n                                               {\'background-color\': \'#008000\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} ||\n                                               ots.colorCode === \'S\' && \n                                               {\'background-color\': \'#87CEEB\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} ||\n                                               ots.colorCode === \'I\' && \n                                               {\'background-color\': \'#FFDAB9\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'} ||\n                                               ots.colorCode === \'O\' && \n                                               {\'background-color\': \'#FFA500\', \'width\': \'12px\', \'height\': \'12px\', \n                                                \'border-radius\': \'50%\', \'display\': \'inline-block\', \'margin-right\': \'8px\'}"></span> {{ ots.otsNumber }}</md-option><md-option ng-value="\'notLinked\'" ng-disabled=vm.isOtsFieldDisabled()>{{\'ACTIS_DESCRIPTION_OTS_NOT_LINKED\' | translate}}</md-option></md-select></md-input-container></div><!-- BT Field Section --><div class="small-6 columns" ng-if="vm.showBtField && vm.type !== \'painting\' && vm.type !== \'accessory\' && !vm.isIndependentUser"><label for=bt-dropdown ng-class="{\'changeTextColorToRed\': vm.ficSend && !vm.isBtValid()}">{{\'BT\' | translate}}* <span class=icon-information id=cursor-default><md-tooltip id=btToolTip><div id=btToolTipDiv>{{\'ACTIS_DESCRIPTION_BT_TOOLTIP\' | translate}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="BT info" id=btToolTipIcon md-labeled-by-tooltip=md-tooltip-bt role=img>info</md-icon></span></label><md-input-container class=md-block style="width: 90%; margin-top:0px;" ng-class="{\'md-input-invalid\': vm.ficSend && !vm.isBtValid()}"><md-select ng-model=vm.selectedBt placeholder="{{\'ACTIS_DESCRIPTION_PLACEHOLDER\' | translate}}" style="background-color: white;" id=bt-dropdown required ng-disabled=vm.isBtFieldDisabled() ng-class="{\'md-input-invalid\': vm.ficSend && !vm.isBtValid(), \n                                  \'backgroundColorRequiredFieldsBTDropdown\': vm.ficSend && !vm.isBtValid()}" ng-change=vm.removeBtColors() md-container-class=bt-select-container md-on-close=vm.resetBtSearch()><md-select-header class=bt-select-header ng-if="vm.btDropdownOptions && vm.btDropdownOptions.length > 0"><input type=search id=bt-search-input ng-model=vm.btSearchText placeholder="" aria-label="Search BT" ng-change=vm.filterBtList() class="md-text md-select-search-input bt-search-styling" ng-keydown=$event.stopPropagation()></md-select-header><md-option ng-value=bt.name ng-repeat="bt in vm.filteredBtOptions track by $index">{{ bt.name }}</md-option><md-option ng-value="\'No\'" ng-if="!vm.noBtForVin && ((vm.btDropdownOptions && vm.btDropdownOptions.length > 0) || \n                                          vm.selectedBt === \'No\')">{{\'NO_BT_NEEDED_FOR_VEHICULE\' | translate}}</md-option><md-option ng-value="\'\'" ng-if="vm.noBtForVin && (vm.selectedBt !== \'No\') && \n                                          (!vm.btDropdownOptions || vm.btDropdownOptions.length === 0 || vm.selectedBt === \'\')">{{\'NO_BT_AVAILABLE\' | translate}}</md-option></md-select></md-input-container></div></div><!-- Champ et boutons pour petits \xE9crans --><div class=row id=champEtBoutonsPetitEcran ng-hide="vm.type ===\'painting\' || vm.type ===\'accessory\'"><div class="small-3 columns" style=margin-top:1%;><label style="font-size: var(--renaultMediumFont);padding-bottom: 7px;">{{\'PROBLEM_FREQUENCY\' | translate}}*</label><md-radio-group ng-model=vm.checkboxesPermanentOrIntermittentValue ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=problemFrequencyButton ng-class="vm.radioButtonColorChange(\'problemFrequencyButton\')" required><md-radio-button style="font-size: var(--renaultMediumFont);" value=Permanent>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_PERMANENT\' | translate}}</md-radio-button><md-radio-button style="font-size: var(--renaultMediumFont);" value=Intermittent>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_INTERMITTENT\' | translate}}</md-radio-button></md-radio-group></div><div class="small-3 columns" style=margin-top:1%;float:left;><div class=row><div id=checkboxData class="small-12 columns" style="display: grid;"><md-input-container class="customerComplaint problemFrequencyCheckboxes" ng-repeat=" freq in vm.probFreqState" id={{freq.model}}><md-checkbox style="font-size: var(--renaultMediumFont);" class=customerComplaint ng-model=vm[freq.model] ng-class=vm.checkBoxColorChange(freq.model) ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                         (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                         (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                         ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && \n                                         !vm.isDaysToReopen)" required>{{ \'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_\' + freq.label | translate }}</md-checkbox></md-input-container></div></div></div></div><div class=row id=champEtBoutonsPetitEcran ng-hide="vm.type ===\'painting\' || vm.type ===\'accessory\'" style=margin-top:1%;><div class="small-12 columns"><div class=textAreaBloc id=problemFrequencyPetitEcran><label for=desc-frequency>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY\' | translate}}</label> <textarea ng-model=vm.problemFrequencyToDisplay id=desc-frequency ng-init="vm.frequenceProbleme=\'\'" rows=4 ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                              (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                              (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                              ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)">\n                    </textarea></div></div></div><!-- FIN champ et boutons pour petits \xE9crans --><!-- Champ et boutons pour grands \xE9crans --><div class=row id=champEtBoutonsGrandEcran ng-hide="vm.type ===\'painting\' || vm.type ===\'accessory\'"><div class="small-6 columns"><div class=textAreaBloc id=problemFrequency><label for=desc-frequency>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY\' | translate}}</label> <textarea ng-model=vm.problemFrequencyToDisplay ng-init="vm.frequenceProbleme=\'\'" rows=4 id=desc-frequency ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                              (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                              (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                              ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)">\n                    </textarea></div></div><div class="small-3 columns"><label style="font-size: var(--renaultMediumFont);padding-bottom: 7px;">{{\'PROBLEM_FREQUENCY\' | translate}}*</label><md-radio-group ng-model=vm.checkboxesPermanentOrIntermittentValue ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                                (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=problemFrequencyButtonResolution ng-class="vm.radioButtonColorChange(\'problemFrequencyButtonResolution\')" required><md-radio-button style="font-size: var(--renaultMediumFont);" value=Permanent>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_PERMANENT\' | translate}}</md-radio-button><md-radio-button style="font-size: var(--renaultMediumFont);" value=Intermittent>{{\'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_INTERMITTENT\' | translate}}</md-radio-button></md-radio-group></div><div class="small-3 columns"><div class=row><div id=checkboxData class="small-12 columns" style="display: grid;"><md-input-container class="customerComplaint problemFrequencyCheckboxes" ng-repeat=" freq in vm.probFreqState" id={{freq.modelHighResolution}}><md-checkbox class=customerComplaint style="font-size: var(--renaultMediumFont);" ng-model=vm[freq.model] ng-class=vm.checkBoxColorChange(freq.modelHighResolution) ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                                         (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && \n                                         !vm.isIndependentUser)) || \n                                         (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                                         ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && \n                                         !vm.isDaysToReopen)" required>{{ \'ACTIS_DESCRIPTION_PROBLEM_FREQUENCY_\' + freq.label | translate }}</md-checkbox></md-input-container></div></div></div></div><!-- FIN champ et boutons pour grands \xE9crans --><div class=row style=margin-top:1%; ng-hide="vm.type ===\'painting\' || vm.type ===\'accessory\'"><div class="small-12 columns"><div class=textAreaBloc><label for=diagnostique>{{ \'ACTIS_DESCRIPTION_DIAGNOTIC\' | translate }}* <span ng-if=vm.isTechnicalAssistanceFic style="position: relative; display: inline-block;"><i type=button class=fa ng-class="{\'fa-plus-circle\': vm.showPlusIcon, \'fa-minus-circle\': !vm.showPlusIcon}" aria-label="Toggle diagnostic tooltip" style="cursor: pointer;" ng-click=vm.toggleDiagnosticInfo() ng-keypress=vm.toggleDiagnosticInfo()></i><md-tooltip md-direction=top>{{ \'ACTIS_DIAGNOSTIC_TOOLTIP\' | translate }}</md-tooltip></span></label><div ng-if=vm.showAdditionalDiagnosticMessage style="margin-top: 5px;"><span ng-bind-html="\'ACTIS_DIAGNOSTIC_INSTRUCTION\' | translate"></span></div><textarea ng-model=vm.diagnostiqueToDisplay id=diagnostique ng-focus="vm.removeTextAreaColors(\'diagnostique\')" rows=10 name=diagnostique required style="height: unset;" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                        (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                        (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                        ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)">\n                    </textarea></div></div></div><!-- Fin des \xE9l\xE9ments \xE0 enlever pour FIC accessoires et peinture --><div class=row style=margin-top:1%;><div ng-class=vm.getDocumentationClass(vm.type) ng-if="!vm.showOtsField || vm.isIndependentUser"><div class=consultedDocumentation><label for=consulted-doc>{{\'ACTIS_DESCRIPTION_CONSULTED_DOCUMENTATION\' | translate}}</label> <input type=text aria-label=consultedDoc ng-model=vm.documentationConsulted name=documentationConsulted ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isIndependentUser) || \n                    (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                    (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || \n                    ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=consulted-doc><div ng-messages=descriptionForm.documentationConsulted.$error role=alert><div ng-message=md-maxlength>Taille max 40 caract\xE8res</div></div></div></div><div ng-class="{\'small-4 columns\': (!vm.showOtsField || vm.isIndependentUser), \n                             \'small-6 columns\': (vm.showOtsField && !vm.isIndependentUser)}" ng-hide=vm.isAlertFic ng-if="vm.type ===\'others\' || vm.type ===\'zeBattery\'"><div class=opecode><label for=desc-ope>{{\'ACTIS_DESCRIPTION_OPECODE\' | translate}}</label> <input type=text aria-label=opeCode ng-model=vm.opecode name=opecode readonly=readonly id=desc-ope></div></div><div ng-class="{\'small-4 columns\': (!vm.showOtsField || vm.isIndependentUser), \n                              \'small-6 columns\': (vm.showOtsField && !vm.isIndependentUser)}" ng-hide=vm.isAlertFic ng-if="vm.type ===\'others\' || vm.type ===\'zeBattery\'"><div class=time><label for=desc-time>{{\'ACTIS_DESCRIPTION_TIME\' | translate}}</label> <input type=text aria-label=desc-time ng-model=vm.temps name=temps readonly=readonly id=desc-time></div></div></div><div class="small-12 columns" style="margin-top: 1%;"><label ng-hide="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.nonModifiableFic && !vm.isIndependentUser) || \n                (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || \n                ((vm.status === \'Closed\' || vm.responseApi.CaseDetail.status === \'Closed\') || \n                (vm.status === \'Sent\' || vm.responseApi.CaseDetail.status === \'Sent\') || \n                (vm.responseApi.CaseDetail.status === \'New\') || vm.nonModifiableFic)">{{\'DOCUMENT_TM_ATTACHMENT\' | translate}}* <span class=icon-information id=cursor-default><md-tooltip id=standardExchangeToolTip><div id=standardExchangeToolTipDiv><li>{{\'ATTACHMENT_MSG\' | translate}}</li></div></md-tooltip><md-icon ng-if=vm.isAlertFic md-font-set=material-icons ng-click=vm.goToAttachmentDoc() ng-keypress=vm.goToAttachmentDoc() class="material-icons font-size-30" aria-label="standard exchange" id=standardExchangeToolTipIcon md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></span></label><attachment-actis is-alert-fic=vm.isAlertFic is-fic-reopen=vm.isFicReopen is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories non-modifiable-fic=vm.nonModifiableFic template=attachment response-api=vm.responseApi is-edit-mode=vm.isEditMode is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-draft=vm.isDraft is-actis-from-diag=vm.isActisFromDiag is-independent-user=vm.isIndependentUser is-discussion-comment-box=vm.isDiscussionCommentBox is-tree-structure-node-selected=vm.isTreeStructureNodeSelected></attachment-actis></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/discussion-actis.template.html','<div class=brwAccordion><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isDiscussionOpen><accordion-heading><div ng-keypress ng-class="vm.isForQstomize ? \'discussionTab\' : \'\'" ng-click="!vm.isDraft && vm.nonModifiableFic && vm.isDiscussionOpen == !vm.isDiscussionOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isDiscussionOpen,\'icon-icons_exependable_moins float-left\':vm.isDiscussionOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'ACTIS_DISCUSSION\' | translate}}</label></div></div></accordion-heading><div class=row style="top: 10px; position: relative;" ng-show="((vm.isActisProfil || (!vm.isActisProfil && (vm.isQstomizeTypeFic || vm.isIndependentProfil))) && ((vm.status === \'Closed\' && vm.isDiscussionCommentBox && vm.isForBwr) || (vm.status === \'Closed\' && vm.isDiscussionCommentBox && !vm.isForBwr) || (vm.status === \'To do\' || vm.status === \'Proposal\' || vm.status === \'Resolved\' || vm.status === \'Answered\')))"><label for=descriptionUndefined ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic)) || (vm.statusToDisplay != \'{{\'ACTIS_ANSWERED\' | translate}}\' && vm.isFicReopen)" class=labelComment>{{\'DISCUSSION_COMMENT_LABEL\' | translate}}*</label> <textarea ng-focus=vm.removeDescriptionBoxColor() id=descriptionUndefined class=discussionComment required ng-model=vm.description ng-change=vm.updateComment(vm.description) rows=4 placeholder="{{\'DISCUSSION_COMMENT\' | translate}}"></textarea></div><div class=row ng-show="((vm.isActisProfil || (!vm.isActisProfil && (vm.isQstomizeTypeFic || vm.isIndependentProfil))) && ((vm.status === \'Closed\' && vm.isDiscussionCommentBox && vm.isForBwr) || (vm.status === \'Closed\' && vm.isDiscussionCommentBox && !vm.isForBwr) || (vm.status === \'To do\' || vm.status === \'Proposal\' || vm.status === \'Resolved\' || vm.status === \'Answered\')))"><button ng-disabled="(vm.statusToDisplay != \'{{\'ACTIS_ANSWERED\' | translate}}\' || isLoading || ((!vm.isActisProfil && !vm.isQstomizeTypeFic ) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic))) && vm.isFicReopen" class=discussionCommentAttachment ngf-drop ngf-select ng-model=file ngf-multiple=false ngf-allow-dir=true style=margin-left:5%;>{{\'DISCUSSION_COMMENT_ATTACHMENT\' | translate}}</button></div><div style="margin-top: 20px" ng-if="(vm.status === \'Closed\' || vm.status === \'More Info Needed\' || vm.status === \'Reopen\' || vm.status === \'In Progress\' || vm.status === \'Email Received\' || vm.status === \'Waiting Expert Answer\'\n    || vm.status === \'Expert Answer Received\' || vm.status === \'Draft In Queue\' || vm.status === \'Waiting Email Answer\' || vm.status === \'New\' || vm.status === \'Back To Queue\' || vm.status === \'Back\') && vm.isActisProfil && vm.comments.length > 0"></div><div ng-show="((vm.isActisProfil || (!vm.isActisProfil && (vm.isQstomizeTypeFic || vm.isIndependentProfil))) && ((vm.status === \'Closed\' && vm.isDiscussionCommentBox && vm.isForBwr) || (vm.status === \'Closed\' && vm.isDiscussionCommentBox && !vm.isForBwr ) || (vm.status === \'To do\' || vm.status === \'Proposal\' || vm.status === \'Resolved\' || vm.status === \'Answered\')))"><discussion-attachment-actis template=discussion non-modifiable-fic=vm.nonModifiableFic></discussion-attachment-actis></div><div class=actisComments ng-if="vm.mergedCommentsAndPJ.length > 0 || !vm.isFicReopen" ng-repeat="item in vm.mergedCommentsAndPJ track by $index"><span ng-if="(item.commentAuthorFirstName || item.commentAuthorLastName || \n                      item.commentAuthorLevel || item.commentDate) && \n                      vm.closureReason !== \'Rejected\'" class=comment-author-info readonly=readonly>{{item.commentAuthorFirstName}} {{item.commentAuthorLastName}} {{item.commentAuthorLevel}} {{item.commentDate}} </span><span ng-if="(item.commentAuthorFirstName || item.commentAuthorLastName || item.commentAuthorLevel || item.commentDate) \n            && vm.closureReason === \'Rejected\'" class=comment-author-info readonly=readonly>{{\'ANONYMOUS_USER\' | translate}} {{item.commentDate}} </span><span ng-if=" item.icon === \'closure\'" style="float: left;margin-top:3%;"><em class="fa fa-refresh" style="padding:4px;background-image: linear-gradient(190deg, white, white);float: right;margin-top: -31px;font-size: large;margin-right: 5px;" role=button tabindex=0></em> </span><i ng-if=" item.icon === \'yellowBubble\'" height=20 width=20 style="float: left; margin-left: 0.5%;color: var(--renaultPrimaryColor);" class="fa fa-commenting-o" aria-hidden=true></i> <i ng-if=" item.icon === \'blackBubble\'" height=20 width=20 style="float: left; margin-left: 0.5%;color: #2E2ECA;" class="fa fa-commenting-o" aria-hidden=true></i><div ng-if=item.commentBody class="row discussionCommentDivs discussionCommentReadonly" readonly=readonly style="margin-left: 3%;" ng-bind-html=item.commentBody></div><label id=displayAttachments ng-if=item.localDate style="margin-left: 0px;  font-family: var(--renaultFontBold);margin-top: 2%; cursor:default;" readonly=readonly>{{item.localDate}}</label> <span ng-if=" item.fileName" style="float: left;margin-top:3%;"><em class="fa fa-paperclip" style="padding:4px;background-image: linear-gradient(190deg, white, white);float: right;margin-top: -31px;font-size: large;margin-right: 5px;" role=button tabindex=0></em> </span><button ng-if="item.scannedStatus !== vm.scannedStatusOk && item.providerSystem !== vm.providerSystem && item.fileName" class="row discussionCommentDivs discussionCommentReadonly" style="margin-left: 0px; cursor: pointer;" id=attachmentButtonFileNameRed ng-href ng-click=$parent.$parent.downloadPdf(item)>{{item.fileName}}</button> <button ng-if="item.scannedStatus === vm.scannedStatusOk && item.fileName" class="row discussionCommentDivs discussionCommentReadonly" style="margin-left: 0px; cursor: pointer;" id=attachmentButtonFileName ng-href ng-click=$parent.$parent.downloadPdf(item)>{{item.fileName}}</button></div><div><a style=float:right; ng-if="((vm.pageNumber < vm.totalPages) && vm.mergedCommentsAndPJ.length > 0)" ng-click=vm.getMoreAttachments()>{{"SHOW_MORE"|translate}}&nbsp;</a></div></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/discussion-attachment-actis.template.html','<div class="row blocFile" ng-repeat="f in $parent.filesToBeShown track by $index"><div class="small-7 columns" style="padding-bottom: 3px; word-break: break-all;"><button id=attachmentButtonFileName ng-href ng-click=$parent.$parent.downloadPdf(f)>{{f.name}}</button> {{f.$error}} {{f.$errorParam}}</div><div class="small-3 columns" style="padding-bottom: 3px;"><div class=progress ng-if=$parent.$parent.showProgressBar($index)><div ng-style="{ width: $parent.$parent.onLoading + \'%\' }" ng-bind=$parent.$parent.onLoading></div></div><div ng-class="{background : $parent.$parent.showProgressBar($index)}">{{$parent.$parent.fileConvertSize(f.size)}}</div></div><div class="small-2 columns" style="padding-bottom: 3px;"><div><button id=attachmentButtonFileName ng-click="$parent.$parent.close(f, $index, true)" class=clickable><em class=icon-icons_close_big_actis></em></button></div></div></div>');
$templateCache.put('app/components/actis/components/fic-details.template.html','<form name=vehicleActis class=ficDetails><div class="row small-12 columns bin"><div style="color: black;">{{\'FIC_DATA\' | translate}}</div><div><label>{{\'ACTIS_GENERAL_TYPE\' | translate}}</label> <input aria-label=ficType id=ficType type=text ng-model=vm.ficType disabled=disabled></div><div><label>{{\'ACTIS_GENERAL_NUMBER\' | translate}}</label> <input aria-label=ficNumber id=ficNumber type=text ng-model=vm.numberFic disabled=disabled></div><div><label>{{\'ACTIS_GENERAL_STATUS\' | translate}}</label> <input aria-label=ficStatus id=ficStatus type=text ng-model=vm.statusToDisplay disabled=disabled></div><div><label>{{\'ACTIS_GENERAL_CREATOR\' | translate}}</label> <input aria-label=creator id=creator type=text disabled=disabled ng-model=vm.creator></div><div><label>{{\'ADMIN_MENU_IPN\' | translate}}</label> <input aria-label=userIpn id=userIpn type=text disabled=disabled ng-model=vm.userProfile.ipn></div><div><label>{{\'DEALER_CODE\' | translate}}</label> <input aria-label=dealerId id=dealerId type=text disabled=disabled ng-model=vm.userProfile.dealerId></div><div><label>{{\'ALERTS_COUNTRY\' | translate}}</label> <input aria-label=country id=country type=text disabled=disabled ng-model=vm.userProfile.country></div><div style=margin-top:10%;><div ng-keypress class=btnTextColor ng-click=vm.deleteFicHeader() ng-if="vm.status === \'Draft\' || (vm.status === \'Closed\' && vm.isSendButtonVisible)" ng-hide=(!vm.isActisProfil) style="float:left; width:45%; margin-left:17px;"><button style="background-color: rgb(102 102 102);" class="alerts-popin-btn buttonWithIcon cancel"><div class="iconDiv iconDiv-adjusted"><em class="icon-icons_close close-icon-mask"></em></div><div class=btnText>{{"ACTIS_HEADER_CLOSE" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor ng-if="vm.status === \'Resolved\'" ng-show="((vm.isActisProfil && !vm.isFicReopen && vm.status === \'Resolved\') || (!vm.isFicReopen && vm.isQstomizeTypeFic && vm.status === \'Resolved\') || (!vm.isActisProfil && vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.recordType && vm.responseApi.CaseDetail.recordType === \'QSTOMIZE\' && vm.status === \'Resolved\' && !vm.isIndependentUser)) || vm.isReopenClicked" ng-click=vm.closedStatusFic(true) style="float:left; width:45%; margin-left:15px;"><button style="background-color: rgb(102 102 102);" class="alerts-popin-btn buttonWithIcon cancel"><div class=iconDiv><em class="icon-icons_close close-icon-mask bottom-relative"></em></div><div class=btnText style="padding: 0 0 0 10px;">{{"ACTIS_HEADER_CLOSE_FIC" | translate | uppercase }}</div></button></div><div ng-if="vm.isFicReopen && vm.status === \'Closed\' && !vm.isSendButtonVisible" ng-hide=(!vm.isActisProfil) class=btnTextColor ng-click=vm.reOpenFicHeader(true) style="width: 45%;margin-left: 30%;"><button class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><i class=material-icons>redo</i></div><div class=btnText style="padding: 0 0 0 10px;">{{"ACTIS_HEADER_REOPEN" | translate | uppercase }}</div></button></div><div ng-if="vm.status === \'Draft\' || (vm.status === \'Answered\' || vm.status === \'Resolved\') || !vm.status || ((vm.status === \'Answered\' || vm.status === \'Resolved\') && (!vm.isEditMode && !vm.isFicReopen)) || (vm.status === \'Closed\' && vm.isSendButtonVisible)" ng-hide=(!vm.isActisProfil) class=btnTextColor ng-click=vm.saveFicHeader(true) style="width: 45%;" ng-style="(vm.status === \'Draft\' || vm.status === \'Answered\' || vm.status === \'Resolved\' || (vm.status === \'Closed\' && vm.isSendButtonVisible)) && {\'float\':\'right\'} || (vm.status !== \'Draft\' && vm.status !== \'Answered\' && vm.status !== \'Resolved\') && {\'margin-left\':\'30%\'}"><button class="alerts-popin-btn buttonWithIcon" ng-style="{\'right\' : (vm.status === \'Closed\' && vm.isSendButtonVisible) || vm.status === \'Draft\'? \'0\': ((vm.status === \'Answered\' || vm.status === \'Resolved\') && (!vm.isEditMode && !vm.isFicReopen)) ? \'50%\' : \'0\'}"><div class=iconDiv><i class=icon-icons_mail_actis></i></div><div class=btnText>{{"ACTIS_HEADER_SEND" | translate | uppercase }}</div></button></div></div></div></form>');
$templateCache.put('app/components/actis/components/fic-type-actis.template.html','<div class="row headerClient"><div class=row><md-toolbar class=md-warn><div class=md-toolbar-tools><h2 class=md-flex style="font-size: var(--renaultLargeFont);font-family: var(--renaultFontBold);">{{\'FIC_TYPE_SELECTION\' | translate}}</h2></div></md-toolbar></div><div class="row divSpacePaint" id=ficType><div class="createFicHover ficTypeTablePaint" ng-repeat="ficDetails in vm.ficTypes track by $index" ng-if="!(vm.country === \'FR\' && ficDetails.id === 4)" ng-style="(vm.country === \'FR\' &&  ficDetails.id === 6 ) ? {\'padding-top\': \'38px\'} : {}"><i class=imageSize><img ng-src={{ficDetails.imgSrc}} alt=""></i><div class=nameSize><div style="font-family: var(--renaultFontBold);font-size: 16px; padding-left: 90px;text-transform: uppercase;"><label>{{ficDetails.name}}</label><br></div><div class=desSize>{{ficDetails.description}}</div></div><br><span style="text-align: center;"><p style="display:none;text-transform: uppercase;cursor:pointer" class=displayCirHover ng-click=vm.updateFicType(ficDetails)><i class="fa fa-plus"></i> {{\'ACTIS_CREATE_FIC\'|translate}}</p></span></div></div></div>');
$templateCache.put('app/components/actis/components/general-actis.template.html','<form name=generalActis class=ficDetails id=generalActisGreyBanner style="height: 520px !important;"><div class="row small-3 columns bin"><div style="color: #000!important;font-size: var(--renaultMediumFont);font-family: var(--renaultFontBold);">{{\'ACTIS_GENERAL_TITLE\' | translate}}</div><div ng-if="vm.isDraft || vm.isActisFromDiag"><label for=cir-type>{{\'ACTIS_GENERAL_TYPE\' | translate}}</label><md-input-container class=md-block style="width: 90%; height: 2em; margin-left: 5%; margin-top:0px;" ng-if=!vm.isForQstomize><md-select ng-model=vm.selectedTypeFIC ng-model-options="{trackBy: \'$value.id\'}" ng-change=vm.updateTypeFIC(vm.typesFIC) placeholder="{{\'ACTIS_GENERAL_TYPE\' | translate}}" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic)) || vm.isIndependentUser" style="background-color: white;"><md-option ng-value=typeFIC ng-repeat="typeFIC in vm.typesFIC" ng-selected="typeFIC.id === vm.selectedFicTypeId" ng-hide="(vm.activateActisAccessoriesAndPaint !== \'true\' && (typeFIC.id == 6 || typeFIC.id == 7 )) || typeFIC.id == 11 || typeFIC.id == 12 || (vm.country === \'FR\' && typeFIC.id == 4)">{{ typeFIC.name }}</md-option></md-select></md-input-container><input aria-label=cirtype ng-if=vm.isForQstomize type=text ng-model=vm.ficType readonly=readonly id=cir-type></div><div ng-if="!vm.isDraft && !vm.isActisFromDiag"><label for=cir-type>{{\'ACTIS_GENERAL_TYPE\' | translate}}</label> <input aria-label=cirtype ng-if=!vm.isForQstomize type=text ng-model=vm.selectedTypeFIC.name readonly=readonly id=cir-type> <input aria-label=cirtype ng-if=vm.isForQstomize type=text ng-model=vm.ficType readonly=readonly id=cir-type></div><div><label for=general-number>{{\'ACTIS_GENERAL_NUMBER\' | translate}}</label> <input aria-label=ficnumber type=text ng-model=vm.numberFic ng-init="vm.numberFic=\'\'" readonly=readonly id=general-number></div><div><label for=general-status>{{\'ACTIS_GENERAL_STATUS\' | translate}}</label> <input aria-label=ficstatus type=text ng-model=vm.statusToDisplay ng-init="vm.status=\'\'" readonly=readonly id=general-status></div><div><label for=phoneNumber>{{\'ACTIS_GENERAL_PHONE\' | translate}}*</label> <input aria-label=phoneNumber id=phoneNumber type=text ng-model=vm.phone limit-to=20 required ng-focus=vm.removeColors() ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isForQstomize && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled)) || (vm.nonModifiableFic && vm.status !== \'\' && vm.status !== \'Draft\' && vm.status !== \'Answered\' && vm.status !== \'Resolved\' && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.responseApi.CaseDetail.recordType === \'QSTOMIZE\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div><div><label for=general-creator>{{\'ACTIS_GENERAL_CREATOR\' | translate}}</label> <input aria-label=creator type=text ng-model=vm.creator readonly=readonly id=general-creator></div><div ng-if=vm.createMotrioFic id=motrioRequestMessage class=row>{{\'MOTRIO_RESERVED_PAGE_REQUEST\' | translate}}</div><div style="margin-top:10%;display: flex;"><div ng-keypress ng-show="((vm.isActisProfil && vm.isFicReopen) || (!vm.isActisProfil && ((vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isQstomizeSentFic && !vm.isSendButtonVisible && !vm.isDeleteButtonVisible && vm.isFicReopen))) || ((vm.isIndependentUser) && vm.status === \'Closed\' && vm.isFicReopen)) && !vm.isForBwr" class=btnTextColor ng-click=vm.reOpenFic(true) style="width: 45%;margin-left: 30%;"><button class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><em class=material-icons>redo</em></div><div class=btnText style="padding: 0 0 0 10px;">{{"ACTIS_HEADER_REOPEN" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor ng-click=vm.cancelFic(true) style="width: 45%;display:inline-block;margin-left: 17px;" ng-show="(vm.isFicCancelled && !vm.isFicReopen)"><button class="alerts-popin-btn buttonWithIcon cancel"><div class=iconDiv><em class=icon-icons_close_big_actis></em></div><div class=btnText>{{"ACTIS_HEADER_CANCEL" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor style="width: 45%;display:inline-block;margin-left: 17px;" ng-click=vm.closedStatusFic(true) ng-if=!vm.isForBwr ng-show="(vm.isActisProfil && !vm.isFicReopen && vm.status === \'Resolved\') || (!vm.isFicReopen && vm.isQstomizeTypeFic && vm.status === \'Resolved\') || (!vm.isActisProfil && vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.recordType && vm.responseApi.CaseDetail.recordType === \'QSTOMIZE\' && vm.status === \'Resolved\' && !vm.isIndependentUser)"><button class="alerts-popin-btn buttonWithIcon cancel"><div class=iconDiv><i class=close-icon-mask></i></div><div class=btnText style="top: 1px; position: relative;">{{"ACTIS_HEADER_CLOSE_FIC" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor ng-click=vm.deleteFicHeader() ng-hide="((!vm.isActisProfil && !vm.isQstomizeTypeFic && !vm.isForQstomize && !vm.isIndependentUser) || (!vm.isActisProfil && vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser)) || (vm.nonModifiableFic || vm.isFicReopen || (!vm.isDeleteButtonVisible && vm.nonModifiableFic) || vm.isForBwr || vm.isForPaint || vm.isForAccessories) || (vm.isForQstomize && vm.responseApi.CaseDetail.recordType === \'QSTOMIZE\' && vm.status === \'Closed\') || (vm.isActisProfil && vm.status === \'Closed\' && !vm.isDaysToReopen) || (vm.isIndependentUser && (vm.status === \'Closed\' || (vm.actisResponse && vm.actisResponse.CaseDetail && vm.actisResponse.CaseDetail.status === \'New\') || !vm.statusToDisplay) && !vm.isDaysToReopen)" ng-class="{ \'div-disabled\': !vm.isDraft}" style="float:left; width:45%; margin-left:17px;"><button class="alerts-popin-btn buttonWithIcon cancel"><div class="iconDiv iconDiv-adjusted"><em class=icon-icons_close_big_actis></em></div><div class="btnText btnText-close-adjusted">{{"ACTIS_HEADER_CLOSE" | translate | uppercase }}</div></button></div><div ng-keypress class=btnTextColor style="width: 45%;display:inline-block;margin-left: 17px;" ng-if="!vm.isBrw && !vm.isDraft && !vm.isActisFromDiag" ng-hide="vm.nonModifiableFic || vm.isFicReopen || !vm.isSaveButtonVisible || vm.isForBwr || vm.isForPaint || vm.isForAccessories || vm.isForQstomize" ng-click=vm.saveFicHeader()><button class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><em class=icon-icons_save_actis></em></div><div class=btnText>{{"ACTIS_HEADER_SAVE" | translate | uppercase }}</div></button></div><div ng-keypress ng-click="!vm.isValidating && vm.handleQstomize(true)" class=btnTextColor ng-show="((vm.isActisProfil && (vm.isAnswered || !vm.nonModifiableFic || (vm.isSendButtonVisible && vm.nonModifiableFic)) && (!vm.isMoreInfoNeeded && !vm.isFicReopen) && ((vm.status !== \'Closed\' || vm.responseApi.CaseDetail.status !== \'Closed\') && (vm.status !== \'Sent\' || vm.responseApi.CaseDetail.status !== \'Sent\'))) || (vm.isActisProfil && vm.isFicCancelled && !vm.isFicReopen) || (!vm.isActisProfil && (vm.isDraft || !vm.isEditMode) && (((vm.isQstomizeTypeFic || vm.isForQstomize) && (!vm.isQstomizeClosedFic && !vm.isQstomizeSentFic && (((vm.status !== \'Closed\' || vm.responseApi.CaseDetail.status !== \'Closed\') && (vm.status !== \'Sent\' || vm.responseApi.CaseDetail.status !== \'Sent\'))) || !vm.nonModifiableFic)) || (vm.isFicCancelled && !vm.isFicReopen))) || (!vm.isActisProfil && vm.responseApi && vm.responseApi.CaseDetail && vm.responseApi.CaseDetail.recordType && vm.responseApi.CaseDetail.recordType === \'QSTOMIZE\' && (vm.status === \'Answered\' || vm.status === \'Resolved\') && !vm.isIndependentUser) ) && !vm.isForBwr && !vm.isForPaint && !vm.isForAccessories" ng-if="!vm.isIndependentUser && !vm.isBrw" style="width: 45%;display:inline-block;"><button class="alerts-popin-btn buttonWithIcon" ng-class="{\'disabled\': vm.isValidating}"><div class=iconDiv><em class=icon-icons_mail_actis></em></div><div class=btnText>{{"ACTIS_HEADER_SEND" | translate | uppercase }}</div></button></div><div ng-keypress ng-click="!vm.isSending && !vm.disableSendSave && vm.handleQstomize(true)" class=btnTextColor ng-if=vm.isIndependentUser style="width: 45%;display:inline-block;" ng-show="(vm.isAnswered || vm.isDraft || (!vm.isEditMode && !vm.nonModifiableFic)\n                     || (vm.isSendButtonVisible && ((vm.nonModifiableFic)\n                     || (vm.statusOriginal === \'Closed\' && vm.isDaysToReopen))))\n                     && !vm.isMoreInfoNeeded && !vm.isFicReopen"><button class="alerts-popin-btn buttonWithIcon" ng-class="{\'div-disabled\': vm.isSending || vm.disableSendSave}"><div class=iconDiv><em class=icon-icons_mail_actis></em></div><div class=btnText>{{"ACTIS_HEADER_SEND" | translate | uppercase }}</div></button></div></div></div></form>');
$templateCache.put('app/components/actis/components/header-actis.template.html','<div sticky name-class="row headerActis fixedInfoNode" style="display: flex; flex-direction: row; padding: 15px 0px; z-index: 5;"><div ng-keypress class="small-1 columns numActis" style="cursor: pointer;"><div class=backActis ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'ACTIS_HEADER_BACK\' | translate}}</div></div></div><div class="small-2 columns"><label class=labelNumActis ng-if="vm.isDraft || !vm.nonModifiableFic">{{\'ACTIS_HEADER_TITLE\' | translate}}</label> <label class=labelNumActis ng-if="!vm.isDraft && vm.nonModifiableFic">{{\'ACTIS_HEADER_TITLE_CONSULTATION\' | translate}}</label></div><div class="small-9 columns listActisAction" ng-hide="vm.isIndependentUser && (!vm.consultationFIC || vm.consultationFIC.status == \'\')"><div ng-keypress ng-click=vm.printFicHeader() class=clickable style="position: relative;" ng-if="!vm.isForBwr && !vm.isForPaint && !vm.isForAccessories && !vm.isFicCreation" title="{{\'BUTTON_ESTIMATE_PRINT\' |translate}}"><i class=icon-icons_print_actis></i> <label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div></div><div ng-if="vm.isActisChatbotEnable && vm.isChatBotDealerAccess"><chatbot></chatbot></div></div>');
$templateCache.put('app/components/actis/components/modalCancelUploadFile.template.html','<md-dialog id=modalOnExitActis><div class=modalPhenix><div class=title>{{\'ACTIS_UPLOAD_SAVE_INFORMATION\' | translate}}</div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onConfirm(redirectionPage)><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel cancel-white" ng-click=vm.onCancel(redirectionPage)><div class=iconDiv><em class="icon-icons_close icon-icons_close_actis"></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/actis/components/modalOnCloseFic.template.html','<md-dialog id=modalOnLightFiltering><div id=delete-reference-modal class=modalPhenix style="font-size: var(--renaultMediumFont);"><!-- TITLE --><div ng-if=!vm.cotechInfo class=title><span ng-if=vm.message>{{vm.message}}</span> <span ng-if=!vm.message>{{\'ACTIS_SAVE_INFORMATIONS\' | translate}}</span></div><div ng-if="vm.cotechInfo && vm.ficTypeId != 3"><div style="padding-bottom: 10px;"><span class=cotechlinkseparator>|</span> <span style=padding-right:10Px;><strong style="text-transform: uppercase;">{{\'INFORMATION_COTECH\' | translate}}</strong></span></div><div style="padding-bottom: 3px;"><span>{{\'FIC_CREATION\' | translate}},&nbsp;<strong> {{\'FIC_AGREE\' | translate}}</strong></span></div><div style="padding-bottom: 3px;"><ul><li style="list-style-type: disc;font-size: var(--renaultMediumFont);">{{\'FIC_LINE_1\' | translate}}</li><li style="list-style-type: disc;font-size: var(--renaultMediumFont);">{{\'FIC_LINE_2\' | translate}}</li><li style="list-style-type: disc;font-size: var(--renaultMediumFont);">{{\'FIC_LINE_3\' | translate}}</li></ul></div><div style="padding-bottom: 25px;"><span>{{\'FIC_LINE_4\' | translate}}</span></div><div style="padding-bottom: 25px;"><span>{{\'FIC_LINE_5\' | translate}}</span></div><div style="padding-bottom: 3px;"><span>{{\'FIC_LINE_6\' | translate}}</span></div></div><div ng-if="vm.cotechInfo && vm.ficTypeId == 3 && vm.isFrCountry"><div style="padding-bottom: 10px;"><span class=cotechlinkseparator>|</span> <span style=padding-right:10Px;><strong style="text-transform: uppercase;">{{\'INFORMATION_COTECH\' | translate}}</strong></span></div><!-- Section 1: ALERTS_HEADING_LABEL --><div style="padding-bottom: 5px;"><strong>{{"ALERTS_HEADING_LABEL" | translate}}</strong></div><ul><li style="list-style-type: disc; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL1" | translate}}<ul><li style="list-style-type: circle; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL1a" | translate}}</li></ul></li><li style="list-style-type: disc; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL2" | translate}}<ul><li style="list-style-type: circle; font-size: var(--renaultMediumFont);"><em>{{"ALERTS_CIR_NEW_LABEL2a" | translate}}</em></li></ul></li><li style="list-style-type: disc; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL3" | translate}}<ul><li style="list-style-type: circle; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL3a" | translate}}</li><li style="list-style-type: circle; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL3b" | translate}}</li><li style="list-style-type: circle; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL3c" | translate}}</li></ul></li><li style="list-style-type: disc; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL4" | translate}}<ul><li style="list-style-type: circle; font-size: var(--renaultMediumFont);">{{"ALERTS_CIR_NEW_LABEL4a" | translate}}</li></ul></li></ul><!-- Section 2: ALERTS_HEADING_LABEL1 --><div style="padding-top: 5px;"><strong>{{"ALERTS_HEADING_LABEL1" | translate}}</strong><br><span>{{"ALERTS_CIR_NEW_LABEL5" | translate}}</span><ul style="font-size: 14px !important;"><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL5a" | translate}}</li></ul><span>{{"ALERTS_CIR_NEW_LABEL6" | translate}}</span><ul style="font-size: 14px !important;"><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6a" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6b" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6c" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6d" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6e" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6f" | translate}}</li><li style="list-style-type: disc;">{{"ALERTS_CIR_NEW_LABEL6g" | translate}}</li></ul><span>{{"ALERTS_CIR_NEW_LABEL7" | translate}}</span></div></div><div ng-if="vm.cotechInfo && vm.ficTypeId == 3 && !vm.isFrCountry"><div style="padding-bottom: 10px;"><span class=cotechlinkseparator>|</span> <span style=padding-right:10Px;><strong style="text-transform: uppercase;">{{\'INFORMATION_COTECH\' | translate}}</strong></span></div><div style="padding-bottom: 5px;"><span>{{"ALERTS_CIR_LABEL1" | translate}}<span style="font-family: \'newRenaultGroupBold\'"> &nbsp;{{"ALERTS_CIR_LABEL1a" | translate}}</span></span></div><div style="padding-bottom: 5px;"><span>{{"ALERTS_CIR_LABEL2" | translate}}</span></div><div style="font-family: \'newRenaultGroupRegular\';">{{"ALERTS_CIR_LABEL4" | translate}}<ul style="font-size: 14px !important;"><li>{{"ALERTS_CIR_LISTITEM1" | translate}}</li><li>{{"ALERTS_CIR_LISTITEM2" | translate}}</li><li>{{"ALERTS_CIR_LISTITEM3a" | translate}} <span style="font-family: \'newRenaultGroupBold\'">{{"ALERTS_CIR_LISTITEM3b" | translate}}</span></li><li>{{"ALERTS_CIR_LISTITEM4" | translate}}</li><li>{{"ALERTS_CIR_LISTITEM5" | translate}}</li></ul></div><div style="padding-bottom: 5px;"><span>{{"ALERTS_CIR_LABEL5" | translate}} <span style="text-decoration: underline;">{{"ALERTS_CIR_LABEL5a" | translate}}</span> <span>{{"ALERTS_CIR_LABEL5b" | translate}}</span></span></div><div style="padding-bottom: 5px; font-family: \'newRenaultGroupBold\';"><span>{{"ALERTS_CIR_LABEL6" | translate}}</span></div><div style="padding-bottom: 5px; font-family: \'newRenaultGroupBold\';"><span>{{"ALERTS_CIR_LABEL7" | translate}}</span></div><div style="padding-bottom: 5px;"><span>{{"ALERTS_CIR_LABEL8" | translate}}</span></div></div><!-- ACTIONS --><div ng-if=vm.message class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.newConfirm()><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.newCancel()><div class=iconDiv><em class=icon-icons_close></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</div></button></div><div ng-if="!vm.message && !vm.cotechInfo" class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onConfirm(redirectionPage)><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel cancel-white" ng-click=vm.onCancel(redirectionPage)><div class=iconDiv><em class="icon-icons_close icon-icons_close_actis"></em></div><div class=btnText>{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</div></button></div><div ng-if="!vm.message && vm.cotechInfo" class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.newConfirm()><div class=iconDiv><em style="font-weight: 900;" class=icon-icons_validate></em></div><div class=btnText>{{\'FIC_COMMIT\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.newCancel()><div class=iconDiv><em style="font-size: initial;padding-left: 5px;" class="fa fa-chevron-right"></em></div><div class=btnText style="padding-right: 7px; padding-left: 7px">{{\'COMMON_BACK\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/actis/components/new-accessories.template.html','<div class=paintDetails><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'ALERTS_CONTACT\'| translate | uppercase}}</label></div><form class=batteryDetails><table><tbody class="small-8 columns no-padding"><tr><td>{{\'Email\' | translate}}</td><td>{{\'Phone\' | translate}}</td></tr><tr><td><input type=text aria-label=emailId id=email ng-model=vm.email></td><td><input type=text aria-label=phoneNo id=phoneNo ng-model=vm.phone></td></tr><tr><td>{{\'Function\' | translate}}</td></tr><tr><td><select ng-model=vm.selectedPaintFunction ng-options="function as (function | translate) for function in vm.paintFunction"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td></tr></tbody></table></form><div><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'CONNECTED_SERVICES_MENU_VEHICLE_INFOS\'| translate | uppercase}}</label></div><div class=paintVinDetails style="display: flex;margin-top:20px"><div class="small-3 columns no-padding" style="width: 200px;"><label>{{\'SEARCH_BY_VIN\'| translate}} <span ng-if="vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" style="color: red;">*</span></label> <input aria-label=paintVinNo id=paintVinNumber type=text ng-style="{\'background-color\': vm.isManual || vm.requestType3Enabled ? \'#969090\':\'\'}" ng-disabled="vm.isManual || vm.requestType3Enabled" ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 aria-invalid=true> <em style="float: right;padding: 7px; margin: -52px -37px 0px 0px;" class=icon-icons_search_arbo ng-disabled=vm.requestType3Enabled ng-style="{\'background-image\': vm.requestType3Enabled ? \'linear-gradient(190deg, #969090,#969090)\':\'linear-gradient(190deg, #978B7F, #978B7F)\'}"></em></div><div class="small-3 columns no-padding" style="margin-top: 8px;margin-left: 20px;display: flex;"><md-switch ng-model=vm.isManual aria-label="Vin selection manual or default" ng-disabled="vm.requestType3Enabled || vm.requestType1Enabled ||vm.incidentTypeRequest ||vm.fittingTypeRequest" ng-change=vm.changeMode()></md-switch><span style="margin-top: 20px;font-size: var(--renaultMediumFont);">{{\'PAINT_INFO_MANUALLY\' | translate}}</span></div><div class="small-6 columns no-padding" style="display: flex; flex-direction: row; flex-wrap: wrap;"><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_BRAND\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual || vm.requestType1Enabled  || vm.incidentTypeRequest ||vm.fittingTypeRequest ? \'#969090\':\'\'}" ng-disabled="!vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" style="width: 125px;" type=text aria-label=brand id=brand ng-model=vm.brand></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_MODEL\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual || vm.requestType1Enabled|| vm.incidentTypeRequest ||vm.fittingTypeRequest ? \'#969090\':\'\'}" ng-disabled="!vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" type=text aria-label=vehModel id=vehModel ng-model=vm.model></div><div><label>{{\'ACTIS_VEHICLE_YEAR\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest ? \'#969090\':\'\'}" ng-disabled="!vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" style="width: 125px;" type=text aria-label=vehYear id=year ng-model=vm.year></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_IMMAT\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest ? \'#969090\':\'\'}" ng-disabled="!vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" style="width: 125px;" type=text aria-label=regNo id=regNo ng-model=vm.registrationNumber></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_DISTANCE\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest ? \'#969090\':\'\'}" ng-disabled="!vm.isManual || vm.requestType1Enabled || vm.incidentTypeRequest ||vm.fittingTypeRequest" style="width: 100px;" type=text aria-label=distance id=distance ng-model=vm.distance></div></div></div></div><div class=batteryDetails><div style="border-left:5px solid var(--renaultPrimaryColor) !important; margin-bottom: 20px;"><label class=labelBRW>{{\'REQUEST\'| translate}}</label></div><div><div style="font-size: var(--renaultMediumFont);" class="small-7 columns no-padding" ng-class="vm.requestType2Enabled? \'small-5\' : \'small-7\'"><span>{{\'PAINT_REQUEST_TYPE\' | translate}}</span> <select ng-change=vm.changeRequestType(request) ng-model=vm.selectedRequestType ng-options="request as (request.id|translate) for request in vm.accessorieRequestType"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></div><div ng-if=vm.requestType2Enabled style="right: 70px;" class="columns no-padding" ng-class="vm.requestType2Enabled? \'small-5\' : \'small-7\'"><span>{{\'FAV_MODAL_ADD_TM_SUBCATEGORY\' | translate}}</span> <select ng-change=vm.changeRequestType(request) ng-model=vm.selectedSubCategory ng-options="item as (item|translate) for item in vm.selectedRequestType.value"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></div></div><div class=requestDetails><table ng-if=vm.requestType1Enabled><tr><td>{{\'COMMON_REFERENCE\' |translate}}</td><td style="left: 20px;position: relative;">{{\'ACTIS_ACCESSOIRES_PRODUCT_NAME\' | translate}}</td></tr><tr><td><input type=text aria-label=reference id=reference ng-model=vm.reference> <em style="float: right;padding: 7px; margin: -36px 14px 0px 0px; background-image: linear-gradient(190deg, #978B7F, #978B7F);" class=icon-icons_search_arbo></em></td><td style="left: 20px;position: relative;"><input type=text aria-label=product id=product ng-model=vm.productName></td></tr><tr><td>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}} <span style="color: red;">*</span></td></tr><tr><td><textarea required rows=4 id=paintDescription ng-model=vm.description style="width: 90%;"></textarea></td><td class=paintButtons><button class="alerts-popin-btn buttonWithIcon" ng-click=vm.saveFicHeader()><div style="display: block;" class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><div style="display: flex;align-items: center;width: 200px"><button ng-disabled="vm.ficStatus !==\'saved\'" ng-style="{\'background-color\': vm.ficStatus===\'saved\' ? $root.renaultPrimaryColor :\'white\',\'border\':\'1px solid black\'}" style="margin-top: 10px" class="alerts-popin-btn buttonWithIcon" ng-click=vm.joinDocuments()><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button> <span><md-tooltip>{{\'PAINT_JOIN_DOCUMENT_TOOLTIP\' | translate}}</md-tooltip><em style="font-size: 25px;padding: 10px 0px 0px 5px;" class="fa fa-info-circle"></em></span></div></td></tr></table><table ng-if=vm.requestType2Enabled><tr><td>{{\'COMMON_REFERENCE\' |translate}} <span style="color: red;">*</span></td><td style="left: 20px;position: relative;">{{\'ACTIS_ACCESSOIRES_PRODUCT_NAME\' | translate}} <span style="color: red;">*</span></td></tr><tr><td><input type=text aria-label=reference id=reference ng-model=vm.reference> <em style="float: right;padding: 7px; margin: -36px 14px 0px 0px; background-image: linear-gradient(190deg, #978B7F, #978B7F);" class=icon-icons_search_arbo></em></td><td style="left: 20px;position: relative;"><input type=text aria-label=productName id=product ng-model=vm.productName></td></tr><tr><td>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}} <span style="color: red;">*</span></td></tr><tr><td><textarea required rows=4 id=paintDescription ng-model=vm.description style="width: 90%;"></textarea></td><td class=paintButtons><button class="alerts-popin-btn buttonWithIcon" ng-click=vm.saveFicHeader()><div style="display: block;" class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><div style="display: flex;align-items: center;width: 200px"><button ng-disabled="vm.ficStatus !==\'saved\'" ng-style="{\'background-color\': vm.ficStatus===\'saved\' ? $root.renaultPrimaryColor :\'white\',\'border\':\'1px solid black\'}" style="margin-top: 10px" class="alerts-popin-btn buttonWithIcon" ng-click=vm.joinDocuments()><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button> <span ng-if="vm.incidentTypeRequest || vm.fittingSubCategory" style="color: red;">*</span> <span><md-tooltip>{{\'PAINT_JOIN_DOCUMENT_TOOLTIP\' | translate}}</md-tooltip><em style="font-size: 25px;padding: 10px 0px 0px 5px;" class="fa fa-info-circle"></em></span></div></td></tr></table><table ng-if=vm.requestType3Enabled><tr><td>{{\'COMMON_REFERENCE\'| translate}} <span style="color: red;">*</span></td></tr><tr><td><input type=text style="width: 400px;" aria-label=reference id=reference ng-model=vm.reference></td></tr><tr><td>{{\'ACTIS_ACCESSOIRES_PRODUCT_NAME\' | translate}} <span style="color: red;">*</span></td></tr><tr><td><input type=text style="width: 400px;" aria-label=refName id=refName ng-model=vm.referenceName></td></tr><tr><td>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}} <span style="color: red;">*</span></td></tr><tr><td><textarea required rows=4 id=paintDescription ng-model=vm.description style="width: 400px;"></textarea></td></tr></table></div></div></div>');
$templateCache.put('app/components/actis/components/paint-details.template.html','<div class=paintDetails><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'ALERTS_CONTACT\'| translate | uppercase}}</label></div><form class=batteryDetails><table><tbody class="small-8 columns no-padding"><tr><td>{{\'Email\' | translate}}</td><td>{{\'Phone\' | translate}}</td></tr><tr><td><input type=text aria-label=emailId id=emailId ng-model=vm.email></td><td><input type=text aria-label=phoneNo id=phoneNo ng-model=vm.phone></td></tr><tr><td>{{\'Function\' | translate}}</td></tr><tr><td><select ng-model=vm.selectedPaintFunction ng-options="function as (function | translate) for function in vm.paintFunction"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td></tr></tbody></table></form><div><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'CONNECTED_SERVICES_MENU_VEHICLE_INFOS\'| translate | uppercase}}</label></div><div class=paintVinDetails style="display: flex;margin-top:20px"><div class="small-3 columns no-padding" style="width: 200px;"><label>{{\'SEARCH_BY_VIN\'| translate}}</label> <input aria-label=paintVinNo id=paintVinNumber type=text ng-style="{\'background-color\': vm.isManual ? \'#969090\':\'\'}" ng-disabled=vm.isManual ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 aria-invalid=true> <em style="float: right;padding: 7px; margin: -52px -37px 0px 0px; background-image: linear-gradient(190deg, #978B7F, #978B7F);" class=icon-icons_search_arbo></em></div><div class="small-3 columns no-padding" style="margin-top: 8px;margin-left: 20px;display: flex;"><md-switch ng-model=vm.isManual aria-label="Vin selection manual or default" ng-change=vm.changeMode()></md-switch><span style="margin-top: 20px;font-size: var(--renaultMediumFont);">{{\'PAINT_INFO_MANUALLY\' | translate}}</span></div><div class="small-6 columns no-padding" style="display: flex; flex-direction: row; flex-wrap: wrap;"><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_BRAND\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual ? \'#969090\':\'\'}" ng-disabled=!vm.isManual style="width: 125px;" type=text aria-label=brand id=brand ng-model=vm.brand></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_MODEL\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual ? \'#969090\':\'\'}" ng-disabled=!vm.isManual type=text aria-label=vehModal id=vehModal ng-model=vm.model></div><div><label>{{\'ACTIS_VEHICLE_YEAR\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual ? \'#969090\':\'\'}" ng-disabled=!vm.isManual style="width: 125px;" type=text aria-label=year id=year ng-model=vm.year></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_IMMAT\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual ? \'#969090\':\'\'}" ng-disabled=!vm.isManual style="width: 125px;" type=text aria-label=regNo id=regNo ng-model=vm.registrationNumber></div><div style="padding-right: 20px;"><label>{{\'ACTIS_VEHICLE_DISTANCE\' | translate}}</label> <input ng-style="{\'background-color\': !vm.isManual ? \'#969090\':\'\'}" ng-disabled=!vm.isManual style="width: 100px;" type=text aria-label=distance id=distance ng-model=vm.distance></div></div></div></div><div class=batteryDetails><div style="border-left:5px solid var(--renaultPrimaryColor) !important; margin-bottom: 20px;"><label class=labelBRW>{{\'REQUEST\'| translate}}</label></div><div><div class="small-7 columns no-padding"><span>{{\'PAINT_REQUEST_TYPE\' | translate}}</span> <select ng-change=vm.changeRequestType(request) ng-model=vm.selectedRequestType ng-options="request as (request|translate) for request in vm.paintRequestType"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option><!-- <option ng-model="vm.selected" ng-repeat="request in vm.paintRequestType">{{request | translate}}</option> --></select></div></div><div class=requestDetails><table ng-if=vm.requestType1Enabled><tr><td>{{\'PAINT_COLOR_CODE\' |translate}}</td><td>{{\'PAINT_TINT_DESCRIPTION\' | translate}}</td><td>{{\'PAINT_WORKPIECE_DESCRIPTION\' | translate}}</td></tr><tr><td><input type=text aria-label=paintColor id=paintColor ng-model=vm.paintColorCode></td><td><input type=text aria-label=description id=description ng-model=vm.tintDescription></td><td><input type=text aria-label=workPieceDescription id=workPieceDescription ng-model=vm.workpieceDescription></td></tr><tr><td style="padding-top: 10px;">{{\'PAINT_TINT_NAME\'| translate}} :</td><td style="padding-top: 10px;">{{\'PAINT_QUALITY_TYPE\' |translate}} :</td></tr><tr><td style="padding-top: 10px;"><span><input type=radio name=tintName ng-model=tintName ng-value="\'accessory\'">{{\'PAINT_TINT_ACCESSORIES\' | translate}}<br></span><span><input type=radio name=tintName ng-model=tintName ng-value="\'body\'">{{\'PAINT_TINT_BODY\' | translate}}<br></span><span style="visibility: hidden;"><input></span></td><td><span><input type=radio name=paintQuality ng-model=vm.paintQuality ng-value="\'HS2\'">{{\'PAINT_QUALITY_TYPE1\' | translate}}<br></span><span><input type=radio name=paintQuality ng-model=vm.paintQuality ng-value="\'Oxelia\'">{{\'PAINT_QUALITY_TYPE2\' | translate}}<br></span><span><input type=radio name=paintQuality ng-model=vm.paintQuality ng-value="\'IxelTech\'">{{\'PAINT_QUALITY_TYPE3\' | translate}}</span></td><td class=paintButtons><button class="alerts-popin-btn buttonWithIcon" ng-click=vm.saveFicHeader()><div style="display: block;" class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><div style="display: flex;align-items: center;width: 200px"><button ng-disabled="vm.ficStatus !==\'saved\'" ng-style="{\'background-color\': vm.ficStatus===\'saved\' ? $root.renaultPrimaryColor:\'white\',\'border\':\'1px solid black\'}" style="margin-top: 10px" class="alerts-popin-btn buttonWithIcon" ng-click=vm.joinDocuments()><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button> <span><md-tooltip>{{\'PAINT_JOIN_DOCUMENT_TOOLTIP\' | translate}}</md-tooltip><em style="font-size: 25px;padding: 10px 0px 0px 5px;" class="fa fa-info-circle"></em></span></div></td></tr></table><table ng-if=vm.requestType2Enabled><tr><td>{{\'PAINT_REUQEST_COLOR_CODE\'| translate}}</td></tr><tr><td><input type=text aria-label=colorCode id=colorCode ng-model=vm.colorCode></td></tr><tr><td>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}}</td></tr><tr><td><textarea required rows=4 id=paintDescription ng-model=vm.description></textarea></td><td class=paintButtons><button class="alerts-popin-btn buttonWithIcon" ng-click=vm.saveFicHeader()><div style="display: block;" class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><div style="display: flex;align-items: center;"><button ng-disabled="vm.ficStatus !==\'saved\'" ng-style="{\'background-color\': vm.ficStatus===\'saved\' ? $root.renaultPrimaryColor :\'white\',\'border\':\'1px solid black\'}" style="margin-top: 10px" class="alerts-popin-btn buttonWithIcon" ng-click=vm.joinDocuments()><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button> <span><md-tooltip>{{\'PAINT_JOIN_DOCUMENT_TOOLTIP\' | translate}}</md-tooltip><em style="font-size: 25px;padding: 10px 0px 0px 5px;" class="fa fa-info-circle"></em></span></div></td></tr></table><table ng-if=vm.requestType3Enabled><tr><td>{{\'ACTIS_ACCESSOIRES_REFERENCE\'| translate}}</td></tr><tr><td><input type=text aria-label=reference id=reference ng-model=vm.reference></td></tr><tr><td>{{\'ACTIS_ACCESSOIRES_PRODUCT_NAME\' | translate}}</td></tr><tr><td><input type=text aria-label=referenceName id=referenceName ng-model=vm.referenceName></td></tr><tr><td>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}}</td></tr><tr><td><textarea required rows=4 id=paintDescription ng-model=vm.description></textarea></td><td class=paintButtons><button class="alerts-popin-btn buttonWithIcon" ng-click=vm.saveFicHeader()><div style="display: block;" class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><div style="display: flex;align-items: center;"><button ng-disabled="vm.ficStatus !==\'saved\'" ng-style="{\'background-color\': vm.ficStatus===\'saved\' ? $root.renaultPrimaryColor :\'white\',\'border\':\'1px solid black\'}" style="margin-top: 10px;" class="alerts-popin-btn buttonWithIcon" ng-click=vm.joinDocuments()><div class=btnText>{{"JOIN_DOCUMENTS" | translate}}</div></button> <span><md-tooltip>{{\'PAINT_JOIN_DOCUMENT_TOOLTIP\' | translate}}</md-tooltip><em style="font-size: 25px;padding: 10px 0px 0px 5px;" class="fa fa-info-circle"></em></span></div></td></tr></table></div></div></div>');
$templateCache.put('app/components/actis/components/painting-actis.template.html','<div class=brwAccordion id=paintingActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isPaintingActisOpen><accordion-heading><div ng-keypress ng-click="vm.isPaintingActisOpen == !vm.isPaintingActisOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isPaintingActisOpen,\'icon-icons_exependable_moins float-left\':vm.isPaintingActisOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>Peinture</label></div></div></accordion-heading><form style=margin-top:1%;><div class=row><div class="small-4 columns"><label for=codeColor>Code couleur</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" aria-label=codeColor id=codeColor ng-model=vm.codeCouleur ng-readonly=vm.nonModifiableFic></div><div class="small-4 columns"><label for=nomColor>Nom de la couleur</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" ng-model=vm.nomCouleur aria-label=nomColor id=nomColor ng-readonly=vm.nonModifiableFic></div><div class="small-4 columns"><label for=contretyper>Nom de la couleur \xE0 contretyper</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" ng-model=vm.nameColorContretyper aria-label=contretyper id=contretyper ng-readonly=vm.nonModifiableFic></div></div><div class=row><div class="small-6 columns"><label for=tintAccessory>Teinte accessoire</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" ng-model=vm.accessoryTint aria-label=accessory id=tintAccessory ng-readonly=vm.nonModifiableFic></div><div class="small-6 columns"><label for=bodyTint>Teinte carrosserie</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" ng-model=vm.bodyTint aria-label=bodyTint id=bodyTint ng-readonly=vm.nonModifiableFic></div></div><div class=row><div class="small-4 columns"><div class="incident1 uniteDistance"><md-select ng-model=$ctrl.selectedPaintingQuality style="margin-top: 7px;" placeholder="Qualit\xE9 de peinture" ng-disabled=vm.nonModifiableFic><md-option style="padding-bottom: 7px;" ng-value=quality ng-repeat="quality in $ctrl.paintingQualities">{{ quality.name }}</md-option></md-select></div></div><!-- <div class="small-4 columns">\n                        <md-input-container class="uniteDistance">\n                            <md-select ng-model="vm.selectedUnite" ng-model-options="{trackBy: \'$value.id\'}" style="margin-top: 7px;" placeholder="{{\'ACTIS_VEHICLE_UNITE\' | translate}}">\n                                <md-option ng-value="unite" ng-repeat="unite in vm.unites">\n                                    {{ unite.name }}\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div> --><!-- <div class="small-6 columns" ng-if="vm.type ===\'accessory\' || vm.type ===\'painting\'">\n                        <md-input-container class="incident1">\n                            <md-select ng-model="vm.selectedInfoIncident1" ng-model-options="{trackBy: \'$value.id\'}" placeholder="{{\'ACTIS_DESCRIPTION_INFO_INCIDENT1\' | translate}}">\n                                <md-option ng-value="incident1" ng-repeat="incident1 in vm.infosIncident1">\n                                    {{ incident1.name }}\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div> --><div class="small-4 columns"><label for=variante-recherch\xE9e>Variante recherch\xE9e</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" aria-label=variante-recherchee id=variante-recherch\xE9e ng-model=vm.accessoryTint ng-readonly=vm.nonModifiableFic></div><div class="small-4 columns"><label for=color-visuelle>Couleur visuelle</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" aria-label=color id=color-visuelle ng-model=vm.accessoryTint ng-readonly=vm.nonModifiableFic></div></div><div class=row><div class="small-6 columns"><label for=reference>R\xE9f\xE9rence</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" aria-label=reference id=reference ng-model=vm.reference ng-readonly=vm.nonModifiableFic></div><div class="small-6 columns"><label for=product-name>Nom du produit</label> <input type=text style="height: 2rem; margin-bottom: 0px; border-width: 0px; box-shadow: none; background-color: gainsboro;" aria-label=productName id=product-name ng-model=vm.productName ng-readonly=vm.nonModifiableFic></div></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/qstomize-details.template.html','<div class=brwAccordion id=descriptionActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isRequestOpen><accordion-heading><div ng-keypress ng-click="vm.isRequestOpen == !vm.isRequestOpen"><em class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isRequestOpen,\'icon-icons_exependable_moins float-left\':vm.isRequestOpen}"></em><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'REQUEST\' | translate}}</label></div></div></accordion-heading><form name=descriptionForm class=description style=margin-top:2%;><div><div class="small-5 columns" style="font-size: var(--renaultMediumFont);"><span>{{\'QSTOMIZE_REQUEST_TYPE\' | translate}}<span style="color: red;"> *</span></span> <select id=request ng-change=vm.changeRequestType() ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\') || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.responseApi.CaseDetail.status !== \'Answered\' && vm.responseApi.CaseDetail.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.responseApi.CaseDetail.status === \'Closed\')" ng-model=vm.selectedRequestType ng-options="requests as (requests.id | translate) for requests in vm.qstomizeRequestReason"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></div><div class="small-5 columns" ng-hide=!vm.showCirDemand2field style="font-size: var(--renaultMediumFont);"><span>{{\'QSTOMIZE_SUBCATEGORY\' | translate}}<span style="color: red;"> *</span></span> <select id=categoryDetails ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\') || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.responseApi.CaseDetail.status !== \'Answered\' && vm.responseApi.CaseDetail.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.responseApi.CaseDetail.status === \'Closed\')" ng-model=vm.selectedSubCategory ng-options="item | translate for item in vm.selectedRequestType.value"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></div><div class="small-10 columns" style="right: 16.5%;margin-bottom: 2%;font-size: var(--renaultMediumFont);"><span><label>{{\'QSTOMIZE_DETAILS\' | translate}}<span style="color: red;"> *</span></label> <textarea ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\') || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.responseApi.CaseDetail.status !== \'Answered\' && vm.responseApi.CaseDetail.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.responseApi.CaseDetail.status === \'Closed\')" id=customerComplaint ng-model=vm.customerComplaint ng-focus="vm.removeTextAreaColors(\'customerComplaint\')"></textarea></span></div></div><br><div class="small-12 columns" ng-hide="vm.responseApi.CaseDetail.status === \'Closed\' || vm.responseApi.CaseDetail.status === \'Sent\' || vm.responseApi.CaseDetail.status === \'New\' || vm.responseApi.CaseDetail.status === \'Answered\' || vm.responseApi.CaseDetail.status ===\'Resolved\' || vm.responseApi.CaseDetail.status === \'More Info Needed\' || vm.responseApi.CaseDetail.status === \'Reopen\'"><label>{{\'DOCUMENT_TM_ATTACHMENT\' | translate}}</label><attachment-actis type=qstomize is-fic-reopen=vm.isFicReopen is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories non-modifiable-fic=vm.nonModifiableFic template=attachment response-api=vm.responseApi is-edit-mode=vm.isEditMode is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-draft=vm.isDraft is-actis-from-diag=vm.isActisFromDiag is-for-qstomize=vm.isForQstomize is-independent-user=vm.isIndependentUser is-discussion-comment-box=vm.isDiscussionCommentBox></attachment-actis></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/components/request-details.template.html','<div class=brwAccordion ng-if="!vm.isFicCreation && !vm.isDraft"><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isRequestOpen><accordion-heading><div ng-click="vm.isRequestOpen == !vm.isRequestOpen"><i class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isRequestOpen,\'icon-icons_exependable_moins float-left\':vm.isRequestOpen}"></i><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'REQUEST\' | translate}}</label></div></div></accordion-heading><form name=vehicleActis class=requestDetails><table><tr><td style="width: 60%;"><table><tr><td>{{\'CIR_DEMAND\' | translate}}<span style="color: red;"> *</span></td><td>{{\'CIR_DEMAND_DETAILS\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><select ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=demand ng-change="vm.removeTextAreaColors(\'demand\')" ng-model=vm.selectedDemand ng-options="demands as demands.id for demands in vm.cirDemand"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td><td><select ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" id=demandDetails ng-change="vm.removeTextAreaColors(\'demandDetails\')" ng-model=vm.selectedDemandDetails ng-options="item for item in vm.selectedDemand.value"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td></tr><tr><td colspan=2><label>{{\'INFO_ABOUT\' | translate}}<span style="color: red;"> *</span></label> <textarea ng-disabled="(!vm.isActisProfil && !vm.isIndependentUser) || (vm.nonModifiableFic && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" rows=4 id=customerComplaint ng-model=vm.customerComplaint ng-focus="vm.removeTextAreaColors(\'customerComplaint\')"></textarea></td></tr></table></td><td><attachment-brw-actis ng-if="vm.isDraft && vm.isEditMode" is-fic-reopen=vm.isFicReopen is-save-button-visible=vm.isSaveButtonVisible is-for-bwr=vm.isForBwr is-for-paint=vm.isForPaint is-for-accessories=vm.isForAccessories template=attachmentBrw non-modifiable-fic=vm.nonModifiableFic is-edit-mode=vm.isEditMode response-api=vm.responseApi is-status-present=vm.isStatusPresent save-fic=vm.saveFic on-delete-fic=vm.onDeleteFic is-draft=vm.isDraft></attachment-brw-actis></td></tr></table></form></accordion-group></accordion></div><div class=brwAccordion ng-if="vm.isFicCreation || vm.isDraft"><div ng-click="!vm.isFicCreation && vm.checkRequestDetails()"><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;"><label class=labelBRW>{{\'REQUEST\' | translate}}</label></div></div><form name=vehicleActis class=requestDetails><table><tr><td style="width: 60%;"><table><tr><td>{{\'CIR_DEMAND\' | translate}}<span style="color: red;"> *</span></td><td>{{\'CIR_DEMAND_DETAILS\' | translate}}<span style="color: red;"> *</span></td></tr><tr><td><select id=demand ng-disabled=(!vm.isActisProfil) ng-change="vm.removeTextAreaColors(\'demand\')" ng-model=vm.selectedDemand ng-options="demands as demands.id for demands in vm.cirDemand"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td><td><select id=demandDetails ng-disabled=(!vm.isActisProfil) ng-change="vm.removeTextAreaColors(\'demandDetails\')" ng-model=vm.selectedDemandDetails ng-options="item for item in vm.selectedDemand.value"><option value="">{{\'DEFAULT_SELECT\' | translate}}</option></select></td></tr><tr><td colspan=2><label>{{\'INFO_ABOUT\' | translate}}<span style="color: red;"> *</span></label> <textarea rows=4 id=customerComplaint ng-disabled=(!vm.isActisProfil) ng-model=vm.customerComplaint ng-focus="vm.removeTextAreaColors(\'customerComplaint\')"></textarea></td></tr></table></td><td><button class="alerts-popin-btn buttonWithIcon" ng-class="{\'div-disabled\': vm.disableSendSave}" ng-show="vm.isActisProfil && !vm.isDraft && !vm.isEditMode" ng-click="!vm.disableSendSave && vm.saveFicHeader()"><div class=btnText>{{"ACTIS_HEADER_SAVE" | translate}}</div></button><attachment-brw-actis ng-if="vm.isDraft && vm.isEditMode" template=attachmentBrw non-modifiable-fic=vm.nonModifiableFic is-edit-mode=vm.isEditMode response-api=vm.responseApi is-status-present=vm.isStatusPresent></attachment-brw-actis></td></tr></table></form></div>');
$templateCache.put('app/components/actis/components/resolution-actis.template.html','<div class=row><md-toolbar class=md-warn><div class=md-toolbar-tools><h2 class=md-flex>Resolution</h2></div></md-toolbar></div><div class=row><div class="small-6 columns"><md-input-container><label for=note>Note</label> <input type=text ng-model=vm.note aria-label=note id=note></md-input-container></div><div class="small-6 columns"><md-input-container><md-checkbox ng-model=vm.techLineOk>Solution techline OK</md-checkbox></md-input-container></div></div>');
$templateCache.put('app/components/actis/components/symptomsPopIn.template.html','<md-dialog id=symptomsPopIn aria-label=symptomsPopIn ng-controller="SearchByDiagnosticController as vm"><div layout=row layout-align="end end"><md-button ng-keypress class=md-icon-button ng-click=vm.onClose()><md-icon style="font-size: 24px;" aria-label="Close dialog"><em class=icon-icons_close id=onClose></em></md-icon></md-button></div><md-dialog-content id=symptomsPopInContent><div class=md-dialog-content><div layout=row id=searchSymptomBar><symptom-search></symptom-search></div><symptoms-history></symptoms-history></div></md-dialog-content></md-dialog>');
$templateCache.put('app/components/actis/components/vehicle-actis.template.html','<div class=brwAccordion id=vehicleActisNew><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isVehicleOpen><accordion-heading><div ng-click="vm.isVehicleOpen == !vm.isVehicleOpen"><i class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isVehicleOpen,\'icon-icons_exependable_moins float-left\':vm.isVehicleOpen}"></i><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=labelBRW>{{\'ACTIS_VEHICLE_TITLE\' | translate}}</label></div></div></accordion-heading><form name=vehicleActis class=vehicle style=margin-top:1%;><div class="small-6 columns" style=padding-left:0px;><div class="vin small-12 columns" id=vehicleActis ng-switch=vm.type ng-if="(vm.type === \'zeBattery\' || vm.type === \'others\') && !vm.createMotrioFic"><div class=recapCar ng-if=vm.isLoadFic><div><div class=vehicleModel>{{vm.carDetailModel}}</div><div class=vehicleDetails><div ng-if=vm.carDetailVin>{{vm.carDetailVin}}</div></div></div></div><recap-car ng-if=!vm.isLoadFic api=vm.recapCarAPI ng-switch-when=others checktm=true class=carContextInVehicleField></recap-car><recap-car ng-if=!vm.isLoadFic api=vm.recapCarAPI ng-switch-when=zeBattery checktm=true class=carContextInVehicleField></recap-car></div><div class="bin small-12 columns" ng-switch=vm.type ng-if="(vm.type === \'zeBattery\' || vm.type === \'others\') && !vm.createMotrioFic" style=margin-bottom:0px;><div ng-switch-when=others><label for=vehicle-bin>{{\'ACTIS_VEHICLE_BIN\' | translate}}</label> <input type=text ng-model=vm.binValueToDisplay name=bin ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" aria-label=vehicle-bin id=vehicle-bin></div><div ng-switch-when=zeBattery><label for=binValueToDisplay>{{\'ACTIS_VEHICLE_BIN_ID_NO\' | translate}}*</label> <input type=text aria-label=binValue id=binValueToDisplay ng-focus="vm.removeColors(\'binValueToDisplay\')" ng-model=vm.binValueToDisplay name=bin required ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)"></div></div><div ng-hide="vm.status === \'New\'" ng-if="((vm.vehicle || !vm.createMotrioFic) && (vm.type === \'accessory\' || vm.type === \'painting\' || vm.type === \'qstomize\'))" class="small-12 columns"><div class="vin carContextInVehicleField alignButtonWithRecapCar spaceBottomRecapCar" ng-switch=vm.type><recap-car ng-if=!vm.isLoadFic api=vm.recapCarAPI ng-switch-when=accessory checktm=true class=spaceWidthRecapCar></recap-car><recap-car ng-if=!vm.isLoadFic api=vm.recapCarAPI ng-switch-when=painting checktm=true class=spaceWidthRecapCar></recap-car><recap-car ng-if="(!vm.isLoadFic && vm.vehicleEnabled) || vm.displayGreyBanner" ng-hide="vm.refreshVin && vm.clearRefreshVin" api=vm.recapCarAPI ng-switch-when=qstomize checktm=true class=spaceWidthRecapCar></recap-car><span ng-if="(!vm.isLoadFic && vm.vehicleEnabled && vm.type === \'qstomize\') || vm.displayGreyBanner" ng-hide="(vm.refreshVin && vm.clearRefreshVin || vm.status === \'Draft\')"><em class="fa fa-rotate-right" style="position: sticky;top: 50%;padding:4px;background-image: linear-gradient(190deg, #978B7F, #978B7F);float: right;margin-left: 7px;font-size: large;color:#fff" ng-click=vm.onRefreshClick() role=button tabindex=0><md-tooltip md-direction=bottom>{{\'VEHICLE_REFRESH\' | translate}}</md-tooltip></em></span></div><div ng-hide="(!vm.refreshVin && !vm.clearRefreshVin && (vm.type === \'qstomize\' || vm.type === \'accessory\' || vm.type === \'painting\') && ((vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (vm.isFicCancelled || vm.isFicReopen)) || ((vm.vehicle.vin && vm.vehicle.registrationNumber) || vm.displayGreyBanner || (vm.context && vm.context.vehicle && vm.context.vehicle.vin))))" class="small-12 columns" style=padding:0><label>{{\'SEARCH_BY_VIN\' | translate}} <span style="color: red;">*</span></label> <input id=brwVinNumber ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" aria-label=vinNo type=text ng-focus="vm.removeColors(\'brwVinNumber\')" ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 class="ng-pristine ng-empty ng-invalid ng-invalid-required ng-valid-maxlength ng-touched" aria-invalid=true> <span><em class="fa fa-refresh" ng-disabled="vm.status !== \'Answered\' && vm.status !== \'Resolved\'" ng-style="{\'background\':(((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)) ? \'darkgray\' : $root.renaultPrimaryColor}" style="padding:4px;background-image: linear-gradient(190deg, #978B7F, #978B7F);float: right;margin-top: -31px;font-size: large;margin-right: -26px;color: #fff;" ng-click=vm.getBinCarContext(vm.vin) role=button tabindex=0></em></span></div></div><div ng-if="vm.type === \'accessory\' || vm.type === \'painting\' || vm.createMotrioFic || vm.type === \'qstomize\'" class="small-12 columns"><!-- <div class="inputWidthVehicleField small-12">\n                            <label for="brandvin">{{\'ACTIS_VEHICLE_TITLE\' | translate}}</label>\n                            <input id="brandvin" ng-if="!vm.createMotrioFic" type="text" ng-model="vm.vehicleModel"\n                                ng-disabled="vm.isDisabled"\n                                ng-readonly="vm.nonModifiableFic && vm.status !== \'Answered\' && (!vm.isFicCancelled || vm.isFicReopen)" style="height: 2rem; margin-bottom: 0px; border-width: 0px;                box-shadow: none; background-color: gainsboro;">\n                            <input id="brandvin" ng-if="vm.createMotrioFic" required type="text"\n                                ng-focus="vm.removeColors(\'model\')" ng-model="vm.vehicleModel"\n                                ng-disabled="vm.isDisabled"\n                                ng-readonly="vm.nonModifiableFic && vm.status !== \'Answered\' && (!vm.isFicCancelled || vm.isFicReopen)" style="height: 2rem; margin-bottom: 0px; border-width: 0px;                box-shadow: none; background-color: gainsboro;">\n                            <input id="brandvin" ng-if="!vm.createMotrioFic" type="text" ng-model="vm.vehicleVin"\n                                ng-disabled="vm.isDisabled"\n                                ng-readonly="vm.nonModifiableFic && vm.status !== \'Answered\' && (!vm.isFicCancelled || vm.isFicReopen)" style="height: 2rem; border-width: 0px; box-shadow: none; background-color: gainsboro;">\n                            <input id="brandvin" ng-if="vm.createMotrioFic" required type="text"\n                                ng-focus="vm.removeColors(\'vin\')" ng-model="vm.vehicleVin" ng-disabled="vm.isDisabled"\n                                ng-readonly="vm.nonModifiableFic && vm.status !== \'Answered\' && (!vm.isFicCancelled || vm.isFicReopen)" style="height: 2rem; border-width: 0px; box-shadow: none; background-color: gainsboro;">\n                        </div> --><div class=recapCar ng-if="vm.isLoadFic && (vm.carDetailVin || vm.carDetailModel)"><div><div class=vehicleModel>{{vm.carDetailModel}}</div><div class=vehicleDetails><div ng-if=vm.carDetailVin>{{vm.carDetailVin}}</div></div></div></div></div><div class="small-12 columns" ng-hide="vm.type === \'qstomize\' && ((vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.context && vm.context.vehicle && vm.context.vehicle.vin && vm.context.vehicle.registrationNumber \n                    || (vm.displayGreyBanner && vm.carContext && vm.carContext.registrationNumber) || (vm.nonModifiableFic && (vm.status === \'Answered\' || vm.status === \'Resolved\') && vm.responseApi && vm.responseApi.Car.vin && vm.responseApi.Car.registrationNumber)))"><label for=registrationNumber>{{\'ACTIS_VEHICLE_IMMAT\' | translate}}</label> <input type=text ng-model=vm.vehicle.registrationNumber ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" aria-label=registrationNo id=registrationNumber style=height:2rem;></div><div class="small-12 columns" style="padding: 0px;"><div class="small-6 columns"><label for=distanceValue>{{\'ACTIS_VEHICLE_DISTANCE\' | translate}}*</label> <input type=number aria-label=distanceValue id=distanceValue ng-focus="vm.removeColors(\'distanceValue\')" min=1 ng-model=vm.distance name=distance required minlength=1 limit-to=7 ng-readonly="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style=height:2rem;></div><div class="small-6 columns" style="margin-top: 3%;"><md-select ng-model=vm.selectedUnite ng-model-options="{trackBy: \'$value.id\'}" class=uniteDistanceMargin placeholder="{{\'ACTIS_VEHICLE_UNITE\' | translate}}" ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style=height:2rem;><md-option ng-value=unite ng-repeat="unite in vm.unites">{{ unite.name }}</md-option></md-select></div></div></div><div class="small-6 columns" id=transformAndAccDiv><div class="small-12 columns"><div style=display:flex;><label style="width: 61%;" ng-class="{\'disable\':((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)}">{{\'ACTIS_GENERAL_IMMOBILIZED_VEHICLE\'| translate}}*</label> <span><md-radio-group ng-model=vm.vehiculeImmobilized ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style="display: inline-flex;" id=vehicleImmobilized ng-class="vm.radioButtonColorChange(\'vehicleImmobilized\')"><md-radio-button value=Yes style="margin-left: 25px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</md-radio-button><md-radio-button value=No style="margin-left: 33px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</md-radio-button></md-radio-group></span></div></div><div class="small-12 columns" ng-if=!vm.isForQstomize><div style="display: flex;"><label style="width: 61%;" ng-class="{\'disable\':((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic  && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)}">{{\'ACTIS_VEHICLE_TRANSFORMED_VEHICLE\' | translate}}* <span class=icon-information id=cursor-default><md-tooltip id=transformationToolTip><div id=transformationToolTipDiv><li>{{\'LABEL_VEHICLE_OFFICIAL_TRANSFORMATION\' | translate}}</li><li>{{\'LABEL_VEHICLE_MODIFICATION\' | translate}}</li></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" id=transformationToolTipIcon md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></span></label> <span><md-radio-group ng-model=vm.transformedVehicle ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic  && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style="display: inline-flex;" id=transformedVehicle ng-class="vm.radioButtonColorChange(\'transformedVehicle\')"><md-radio-button value=Yes style="margin-left: 25px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</md-radio-button><md-radio-button value=No style="margin-left: 33px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</md-radio-button></md-radio-group></span></div></div><div class="small-12 columns"><div style="display: flex;"><label style="width: 61%;" ng-class="{\'disable\':((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)}">{{\'ACTIS_VEHICLE_ACCESSOIRES\' | translate}}* <span class=icon-information id=cursor-default><md-tooltip id=accessoryToolTip><div id=accessoryToolTipDiv>{{\'LABEL_VEHICLE_ACCESSORY\' | translate}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" id=accessoryToolTipIcon md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></span></label> <span><md-radio-group ng-model=vm.accessoiresVehicle ng-disabled="((!vm.isActisProfil && !vm.isQstomizeTypeFic && vm.type !== \'qstomize\' && !vm.isIndependentUser) || (!vm.isActisProfil && (vm.isQstomizeTypeFic && vm.isQstomizeClosedFic && !vm.isFicCancelled && !vm.isIndependentUser) || (vm.isFicReopen))) || (vm.nonModifiableFic && (vm.status !== \'Answered\' && vm.status !== \'Resolved\') && (!vm.isFicCancelled || vm.isFicReopen)) || (vm.isForQstomize && vm.type === \'qstomize\' && vm.status === \'Closed\') || ((vm.isActisProfil || vm.isIndependentUser) && vm.status === \'Closed\' && !vm.isDaysToReopen)" style="display: inline-flex;" id=accessoiresVehicle ng-class="vm.radioButtonColorChange(\'accessoiresVehicle\')"><md-radio-button value=Yes style="margin-left: 25px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</md-radio-button><md-radio-button value=No style="margin-left: 33px;font-size: var(--renaultMediumFont);">{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</md-radio-button></md-radio-group></span></div></div><span ng-if="((vm.transformedVehicle === \'Yes\' && (!vm.isForQstomize)) || vm.accessoiresVehicle === \'Yes\') && ((!vm.isEditMode) || (vm.isEditMode && vm.status === \'Draft\'))" id=transformAndAccessoryComment>{{\'VEHICLE_TRANSFORM_ACCESSORY_COMMENT\' | translate}}</span></div></form></accordion-group></accordion></div>');
$templateCache.put('app/components/actis/listFic/closeFicPopIn.template.html','<md-dialog id=closeFicDialogBoxListFicPage><div id=closeFicPopIn class="row columns"><div class=row><div class="small-10 columns"></div><div ng-keypress class="small-2 columns" id=closeDialogBoxIcon ng-click=vm.closeDialog()>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}} X</div></div><div class="row closeFicQuestion" id=closeFicPopInTitle>{{\'TECHLINE_FEEDBACK_IS_CUSTOMER_SATISFIED\' | translate}}</div><div ng-keypress class=displayRatingStars star-rating ng-model=vm.starsRating max=4 on-rating-select=vm.rateFunction(vm) ng-click="vm.displayTitleOnHover(vm.starsRating, vm.displayedText)"></div><label ng-if="vm.displayedText === \'USER_COMPLETELY_UNSATISFIED\'" id=completelyUnsatisfiedRating>{{vm.displayedText | translate}}</label> <label ng-if="vm.displayedText === \'USER_QUITE_UNSATISFIED\'" id=partiallyUnsatisfiedRating>{{vm.displayedText | translate}}</label> <label ng-if="vm.displayedText === \'USER_QUITE_SATISFIED\'" id=partiallySatisfiedRating>{{vm.displayedText | translate}}</label> <label ng-if="vm.displayedText === \'USER_COMPLETELY_SATISFIED\'" id=completelySatisfiedRating>{{vm.displayedText | translate}}</label><div ng-if="vm.starsRating != 4" ng-hide="vm.starsRating == 0"><div><md-input-container id=reduceWidth><md-checkbox class=closePopInCheckboxes ng-model=vm.resolutionTime ng-checked=vm.resolutionTime>{{\'FIC_CONSULTATION_POPIN_RESOLUTION_TIME\' | translate}}</md-checkbox></md-input-container></div><div><md-input-container id=reduceWidth><md-checkbox class=closePopInCheckboxes ng-model=vm.techlineAdvices ng-checked=vm.techlineAdvices>{{\'FIC_CONSULTATION_POPIN_TECHLINE_ADVICES\' | translate}}</md-checkbox></md-input-container></div><div><md-input-container id=reduceWidth><md-checkbox class=closePopInCheckboxes ng-model=vm.technicalInformationQuality ng-checked=vm.technicalInformationQuality>{{\'FIC_CONSULTATION_POPIN_TECHNICAL_INFORMATION_QUALITY\' | translate}}</md-checkbox></md-input-container></div><div><md-input-container id=reduceWidth><md-checkbox class=closePopInCheckboxes ng-model=vm.piecesQuality ng-checked=vm.piecesQuality>{{\'FIC_CONSULTATION_POPIN_PIECES_QUALITY\' | translate}}</md-checkbox></md-input-container></div><div><md-input-container id=reduceWidth><md-checkbox class=closePopInCheckboxes ng-model=vm.otherReason ng-checked=vm.otherReason>{{\'FIC_CONSULTATION_POPIN_OTHER_REASON\' | translate}}</md-checkbox></md-input-container></div></div><textarea ng-if=vm.starsRating ng-model=vm.closePopInTextArea name=Commentaires id=Commentaires cols=30 rows=8></textarea><div ng-if=vm.starsRating layout=containerButton class=closeFicPopInButton layout-align="center center"><md-button ng-keypress class="md-raised buttonWithIcon" ng-disabled=!vm.enableOrDisableCloseFicButton(vm.starsRating) ng-click=vm.closeFIC()><div class=iconDiv><em class="fa fa-check"></em></div><div class=btnText>{{\'CLOSE_FIC_POPIN_CLOSE_FIC\' | translate}}</div></md-button></div></div></md-dialog>');
$templateCache.put('app/components/actis/listFic/listFic-pagination.template.html','<!--&lt;!&ndash; This template includes PageSelect directive to setup custom pagination &ndash;&gt;--><div class=pagination_basket ng-if="pages.length >= 1"><div class=container-arrow><i class=icon-icons_arrow_left_panier ng-if="currentPage > 1" ng-click="selectPage(currentPage - 1)"></i> &nbsp;</div><div>{{\'COMMON_PAGINATION_PAGE\'| translate}}&nbsp;</div><div class=custom-select><page-select></page-select></div><div class=container-arrow><i class=icon-icons_arrow_right_panier ng-if="currentPage < numPages" ng-click="selectPage(currentPage + 1)"></i></div></div>');
$templateCache.put('app/components/actis/listFic/listFic.template.html','<div id=listFicView class="brwAccordion medium-11"><div class=brwAccordion ng-if="vm.processedFicList.length != 0"><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isProcessedListFicOpen><accordion-heading><div><i class="fa fa-envelope-o processedFicIcon"></i><div class=processed-fic-badge ng-if="vm.processedFicList.length > 0">{{vm.processedFicList.length}}</div><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=headerLabel>{{"CIR_TO_BE_PROCESSED" | translate}}</label></div></div></accordion-heading><div class=actisProcessedTableFixHead><table class=table id=listFic st-table=processedFicTable st-safe-src=vm.processedFicList cellspacing=0 style=margin-bottom:0px;><thead><tr><th st-sort=CaseDetail.caseNumber class=ficNumberColumnWidth id=fic-number>{{\'FIC_NUMBER\' | translate}}</th><th st-sort=Request.orNumber class=orNumberColumnWidth id=fic-or-number>{{\'FIC_OR_NUMBER\' | translate}}</th><th st-sort=CaseDetail.status class=statusColumnWidth id=fic-status>{{\'FIC_STATUS\' | translate | uppercase}}</th><th st-sort=CaseDetail.recordType class=cirTypeColumnWidth id=fic-type>{{\'FIC_CIR_TYPE\' | translate | uppercase}}</th><th st-sort=Car.vehicle class=vehicleDetails id=fic-vehicle>{{\'FIC_VEHICLE\' | translate | uppercase}}</th><th st-sort=Request.symptomCode class=symptomCode id=fic-symptom>{{\'FIC_SYMPTOM\' | translate | uppercase}}</th><th st-sort=CaseDetail.creationDate class=createdColumnWidth id=fic-created>{{\'FIC_CREATED\' | translate | uppercase}}</th><th st-sort=CaseDetail.lastModificaitonDate class=modifiedColumnWidth id=fic-modified>{{\'FIC_MODIFIED\' | translate | uppercase}}</th><th st-sort=Dealer.contactLastName class=cotechColumnWidth id=fic-created-by>{{\'FIC_CREATED_BY\' | translate | uppercase}}</th><th id=closeFicArea></th><th id=create-fic-motrio ng-hide=true ng-if=vm.isActisProfil class=containerButton style="border-bottom: 0px;"><md-button class="md-raised buttonWithIcon" ng-click=vm.createMotrioFIC()><div class=iconDiv><img class=createMotrioFicbutton src=./assets/images/fic.png alt=""></div><div class=btnText>{{\'ACTIS_CREATE_FIC_MOTRIO\' | translate}}</div></md-button></th></tr></thead><tbody ng-show=!vm.isLoading ng-style="{\'height\' : vm.processedFicList.length > 5 ? \'250px\' : \'auto\'}"><tr ng-repeat="row in processedFicTable track by $index" style="width: 100%; display: flex;"><td class="marginTop9 ficNumberColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.CaseDetail.caseNumber}}</td><td class="marginTop9 orNumberColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Request.orNumber}}</td><td class="marginTop9 statusColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button><div id="{{\'rowStatus1\' + row.CaseDetail.caseId}}">{{vm.addClassToFicStatus(row.CaseDetail.status, row.CaseDetail.caseId)}}</div>{{row.CaseDetail.status}}</td><td class="marginTop9 cirTypeColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.CaseDetail.recordType}}</td><td class="marginTop4 vehicleDetails" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button><pre id=vehicleInformations>{{row.Car.vehicle}}</pre></td><td class="marginTop9 symptomCode" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Request.symptomCode | translate}}</td><td class="marginTop9 createdColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{vm.formatDate(row.CaseDetail.creationDate) | date:\'yyyy/MM/dd\'}}</td><td class="marginTop9 modifiedColumnWidth" ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{vm.formatDate(row.CaseDetail.lastModificaitonDate) | date:\'yyyy/MM/dd\'}}</td><td class="marginTop9 cotechColumnWidth" ng-if=row.Dealer.lastContactLastName ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Dealer.lastContactLastName}}</td><td class="marginTop9 cotechColumnWidth" ng-if=!(row.Dealer.lastContactLastName) ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Dealer.contactLastName}}</td><td id=closeFicArea ng-if="(vm.isActisProfil || vm.isIndependantUser) && (row.CaseDetail.statusOriginal !== \'Resolved\')"></td><td id=closeFicArea style="align-content: center;" ng-if="(row.CaseDetail.statusOriginal === \'Resolved\') && (vm.isActisProfil || vm.isIndependantUser)"><div title="{{ \'CLOSE_FIC\' | translate }}" ng-click="vm.closeCurrentFIC(row.CaseDetail.caseNumber, row.CaseDetail.caseId)"><i class="fa fa-times-circle-o" aria-hidden=true style=font-size:22px;></i></div></td></tr></tbody></table></div></accordion-group></accordion></div><div class=brwAccordion style=margin-left:2%;><accordion class=collapse close-others=false><accordion-group class=accord is-open=vm.isListFicOpen><accordion-heading><div ng-click="vm.isListFicOpen == !vm.isListFicOpen"><i class=icons style="color: black;" ng-class="{\'icon-icons_expendable_plus float-left\':!vm.isListFicOpen,\n                            \'icon-icons_exependable_moins float-left\':vm.isListFicOpen}"></i><div class=row style="border-left:5px solid var(--renaultPrimaryColor) !important;margin-left: 2%;"><label class=headerLabel>{{"FIC_HISTORY" | translate}}</label></div></div></accordion-heading><table class=table id=listFic st-table=listFicTable st-safe-src=vm.displayed cellspacing=0><thead><tr><th class=ficNumberColumnWidth id=search-by-fic><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=searchByFic id=searchByFic placeholder="{{\'SEARCH_FIC_NUMBER\' | translate}}" st-search=CaseDetail.caseNumber class=materialInput type=text></md-input-container></div></th><th class=orNumberColumnWidth id=search-by-or><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=searchByOR id=searchByOR placeholder="{{\'SEARCH_OR_NUMBER\' | translate}}" st-search=Request.orNumber class=materialInput type=text></md-input-container></div></th><th class=statusColumnWidth id=search-by-status><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=searchByStatus id=searchByStatus placeholder="{{\'SEARCH_BY_STATUS\' | translate}}" st-search=CaseDetail.status class=materialInput type=text></md-input-container></div></th><th class=cirTypeColumnWidth id=search-by-cir-type><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=searchByCirType id=searchByCirType placeholder="{{\'SEARCH_BY_CIR_TYPE\' | translate}}" st-search=CaseDetail.recordType class=materialInput type=text></md-input-container></div></th><th class=vehicleColumnWidth id=search-by-vinModel><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=SearchByVinModel id=SearchByVinModel placeholder="{{\'SEARCH_BY_MODEL_VIN_IMAT\' | translate}}" st-search=Car.vehicle class=materialInput type=text></md-input-container></div></th><th class=searchSymptomColumnWidth id=search-by-symptom><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input aria-label=searchBySymptom id=searchBySymptom placeholder="{{\'SEARCH_SYMPTOM\' | translate}}" st-search=Request.symptomCode class=materialInput type=text></md-input-container></div></th><th><div class=input-material-container></div></th><th><div class=input-material-container></div></th><th id=search-by-creator><div class=input-material-container><md-input-container class="md-block flex-gt-sm actisProfil"><input aria-label=searchByCreator id=searchByCreator ng-if=!vm.isActisProfil placeholder="{{\'SEARCH_BY_CREATOR\' | translate}}" st-search=Dealer.contactLastName class=materialInput type=text> <input aria-label=searchByCreator id=searchByCreator ng-if="vm.isActisProfil && !vm.lastModifier" placeholder="{{\'SEARCH_BY_CREATOR\' | translate}}" ng-value=vm.lastNameCreator st-search=Dealer.contactLastName class=materialInput type=text> <input aria-label=searchByCreator id=searchByCreator ng-if="vm.isActisProfil && vm.lastModifier" ng-value=vm.lastNameCreator st-search=Dealer.lastContactLastName class=materialInput type=text></md-input-container></div></th><th class=containerButton style="border-bottom: 0px;" id=reset-button><md-button class="md-raised buttonWithIcon button-white-text" st-reset-search ng-click=stResetSearch.stResetSearch()><div class=iconDiv><i class=icon-icons-phnx_reinit></i></div><div class=btnText>{{\'COMMON_REINIT\' | translate}}</div></md-button></th></tr><tr><th st-sort=CaseDetail.caseNumber class=ficNumberColumnWidth id=fic-number>{{\'FIC_NUMBER\' | translate}}</th><th st-sort=Request.orNumber class=orNumberColumnWidth id=fic-or-number>{{\'FIC_OR_NUMBER\' | translate}}</th><th st-sort=CaseDetail.status class=statusColumnWidth id=fic-status>{{\'FIC_STATUS\' | translate | uppercase}}</th><th st-sort=CaseDetail.recordType class=cirTypeColumnWidth id=fic-type>{{\'FIC_CIR_TYPE\' | translate | uppercase}}</th><th st-sort=Car.vehicle id=fic-vehicle>{{\'FIC_VEHICLE\' | translate | uppercase}}</th><th st-sort=Request.symptomCode id=fic-symptom>{{\'FIC_SYMPTOM\' | translate | uppercase}}</th><th st-sort=CaseDetail.creationDate id=fic-created>{{\'FIC_CREATED\' | translate | uppercase}}</th><th st-sort=CaseDetail.lastModificaitonDate id=fic-modified>{{\'FIC_MODIFIED\' | translate | uppercase}}</th><th st-sort=Dealer.contactLastName id=fic-created-by>{{\'FIC_CREATED_BY\' | translate | uppercase}}</th><th id=create-fic-motrio ng-hide=true ng-if=vm.isActisProfil class=containerButton style="border-bottom: 0px;"><md-button class="md-raised buttonWithIcon" ng-click=vm.createMotrioFIC()><div class=iconDiv><img class=createMotrioFicbutton src=./assets/images/fic.png alt=""></div><div class=btnText>{{\'ACTIS_CREATE_FIC_MOTRIO\' | translate}}</div></md-button></th></tr></thead><tbody ng-show=!vm.isLoading><tr ng-repeat="row in listFicTable track by $index"><td class=ficNumberColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.CaseDetail.caseNumber}}</td><td class=orNumberColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Request.orNumber}}</td><td class=statusColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button><div id="{{\'rowStatus2\' + row.CaseDetail.caseId}}">{{vm.addClassToFicStatus(row.CaseDetail.status, row.CaseDetail.caseId)}}</div>{{row.CaseDetail.status}}</td><td class=cirTypeColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.CaseDetail.recordType}}</td><td ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button><pre id=vehicleInformations>{{row.Car.vehicle}}</pre></td><td class=symptomColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Request.symptomCode | translate}}</td><td class=createdColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{vm.formatDate(row.CaseDetail.creationDate) | date:\'yyyy/MM/dd\'}}</td><td class=modifiedColumnWidth ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{vm.formatDate(row.CaseDetail.lastModificaitonDate) | date:\'yyyy/MM/dd\'}}</td><td class=cotechColumnWidth ng-if=row.Dealer.lastContactLastName ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Dealer.lastContactLastName}}</td><td class=cotechColumnWidth ng-if=!(row.Dealer.lastContactLastName) ng-click="vm.openFic(row.CaseDetail, row.Request)" role=button>{{row.Dealer.contactLastName}}</td><td id=closeFicArea ng-if="(row.CaseDetail.statusOriginal === \'Resolved\') && \n                            (vm.isActisProfil || row.CaseDetail.recordType === \'QSTOMIZE\')"><div title="{{ \'CLOSE_FIC\' | translate }}" ng-click="vm.closeCurrentFIC(row.CaseDetail.caseNumber, row.CaseDetail.caseId)"><i class="fa fa-times-circle-o" aria-hidden=true style=font-size:22px;></i></div></td></tr></tbody><!-- Smart table footer : display pagination + Show closed FIC button --><tr id=paginationRow ng-show=!vm.isLoading><td class=text-center st-pagination="" st-items-by-page=30 st-displayed-pages=vm.numberOfPagesToDisplay colspan=9></td><td class=containerButton style="border-bottom: 0px;"><md-button class="md-raised buttonWithIcon ng-hide"><div class=iconDiv><i class=icon-icons_search></i></div><div class=btnText>{{\'SHOW_CLOSED_FIC\' | translate}}</div></md-button></td></tr></table></accordion-group></accordion></div><div ng-if="vm.isActisChatbotEnable && vm.isChatBotDealerAccess"><chatbot></chatbot></div></div>');
$templateCache.put('app/components/alerts/popin/alerts.html','<div class="alerts-popin_modal-bg reveal-modal-bg" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status, \'prediction-overlay\':vm.checkDocType === \'PREDICTION\' && vm.hidePopin.status}"></div><div class="alert-arrow_display o-inherit transformable-width" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status,\'alerts-popin_container-new\':vm.checkDocType ===\'ORDER_MODE\',\'alerts-popin_container\':vm.checkDocType !==\'ORDER_MODE\'}"><div ng-keypress data-html2canvas-ignore class="alerts-popin_hide flex-center" ng-if="vm.checkDocType !==\'ORDER_MODE\' && vm.checkDocType !== \'PREDICTION\'" ng-click=vm.actionHidePopin()><em class=icon-icons_double_arrow_right ng-class="{\'spin\':!vm.hidePopin.status}"></em></div><div class="alerts-popin transformable-width" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status,\'alerts-popin_container-new\':vm.checkDocType ===\'ORDER_MODE\',\'alerts-popin_container\':vm.checkDocType !==\'ORDER_MODE\'}"><div class=alerts-popin_container-flex><!-- ============== \n          BACK WITH STEP\n      =============== --><div class=alerts-popin_header><div ng-keypress ng-if="vm.step > 1" ng-click=vm.previousStep() class=alerts-popin_header-back><em class=icon-icons-phnx_back></em> {{\'ALERTS_BTN_PREVIOUS\'|translate}}</div><div class=alerts-popin_separator></div><div class=alerts-popin_title><div ng-if="vm.checkDocType !== \'TM\' \n              && vm.checkDocType !== \'MR\' \n              && vm.checkDocType !== \'INT\' \n              && vm.checkDocType !== \'ORDER_MODE\'" class=alerts-popin_title-header>{{\'REMONTER_ALERTE_TITLE\'|translate}} ({{vm.step}}/2)</div><div ng-if="vm.checkDocType ===\'TM\' \n              || vm.checkDocType === \'MR\' \n              || vm.checkDocType === \'INT\'" class=alerts-popin_title-header>{{\'TM_DOCUMENTARY_ERROR\'| translate}} ({{vm.step}}/2)</div><div ng-if="vm.checkDocType ===\'ORDER_MODE\'" class=alerts-popin_title-header>{{\'ALERT_HEADER\'| translate}}</div></div></div><!-- ==================\n          VIEW\n      =================== --><order-alerts ng-if="vm.checkDocType ===\'ORDER_MODE\'"></order-alerts><phx-alerts-step ng-if="vm.checkDocType !==\'ORDER_MODE\'" step=vm.step step-template-url=vm.stepTemplateUrl step-elem=vm.stepElem is-trace-enabled=vm.isTraceEnabled></phx-alerts-step></div><!-- ====================\n        ACTIONS BUTTON\n    ====================== --><div class=alerts-popin-action ng-if="vm.checkDocType !==\'ORDER_MODE\'"><button ng-if="vm.step < vm.stepMax" ng-click=vm.nextStep(vm.stepElem) class="alerts-popin-btn buttonWithIcon next-white"><div class=iconDiv><em class=icon-icons_next></em></div><div class=btnText>{{"ALERTS_BTN_NEXT" | translate}}</div></button> <button ng-click=vm.sendAlerts(vm.stepElem) ng-if="vm.step === 2 && (vm.checkDocType != \'TM\' &&  vm.checkDocType != \'MR\' && vm.checkDocType !=\'INT\' && vm.checkDocType !=\'PREDICTION\')" class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><em class=icon-icons_mail></em></div><div class=btnText>{{"BUTTON_ESTIMATE_SEND" | translate}}</div></button> <button ng-click=vm.sendDocumentryerrorReportAlerts(vm.stepElem,vm.checkDocType) ng-if="vm.step === 2 && (vm.checkDocType === \'TM\'|| vm.checkDocType === \'MR\' || vm.checkDocType === \'INT\' || vm.checkDocType ===\'PREDICTION\')" ng-disabled=vm.isDocumentaryErrorReportLoading class="alerts-popin-btn buttonWithIcon"><div class=iconDiv><em class=icon-icons_mail></em></div><div class=btnText>{{"BUTTON_ESTIMATE_SEND" | translate}}</div></button> <button ng-click=vm.closePopin() class="alerts-popin-btn buttonWithIcon cancel"><div class=iconDiv><em class="icon-icons_close icon-icons_close-primary"></em></div><div class=btnText>{{"COMMON_CANCEL" | translate}}</div></button></div></div></div>');
$templateCache.put('app/components/basket/consultation/container-view-list.template.html','<div id=containerViewList><div ng-if=vm.dataLoaded><div class="row max-widthC"><!-- ************************************\n            *       FILTER COMPONENT ON LEFT        *\n            **************************************--><div class="small-3 columns cardShadow"><filter-list-cart on-search=vm.onSearch></filter-list-cart></div><!-- ***********************************\n            *       LIST WITH PAGINATION ON RIGHT  *\n            ************************************ --><div class="small-9 columns"><div class=textCenter ng-if="vm.cartList.length == 0"><h4 style="font-family: var(--renaultFontRegular); font-size: var(--renaultExtraLargeFont);">{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div ng-if="vm.cartList.length > 0"><!-- ****************************\n                    *       LIST COMPONENT          *\n                    ******************************--><list-cart list=vm.cartList on-delete=vm.onDelete on-sort=vm.onSort on-unlock=vm.onUnlock on-select=vm.onSelect></list-cart><!-- ***************************\n                    *         PAGINATION           *\n                    **************************** --><pagination-carts-list count=vm.count update-pagination=vm.onUpdatePagination></pagination-carts-list></div></div></div></div></div>');
$templateCache.put('app/components/basket/consultation/filter-list-carts.template.html','<div id=filterListCart><form><!-- ID --><div class=input-material-container><md-icon class="icon-icons_basket icon-position"></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{\'COMMON_NUMBER_ID\' | translate}}</label> <input ng-model=filter.id class=materialInput type=text></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- VIN INPUT --><div class=input-material-container><md-icon class="icon-icons_vehicle_search_panier icon-position"></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{\'VIN\' | translate}}</label> <input ng-model=filter.vin class=materialInput type=text maxlength=17></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- REGISTRATION NUMBER INPUT --><div ng-show=vm.displayRegisterNumber class=input-material-container><md-icon class="icon-icons_vehicle_search_panier icon-position"></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{\'COMMON_REGISTRATION_NUMBER\' | translate}}</label> <input ng-model=filter.registrationNumber class=materialInput type=text></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- KEY WORD --><div class=input-material-container><md-icon class="icon-icons_mot_cle_basket icon-position"></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{\'COMMON_KEY_WORD\' | translate}}</label> <input ng-model=filter.label class=materialInput type=text></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- IPN NUMBER --><div class=input-material-container><md-icon class="icon-icons_people_search_basket icon-position"></md-icon><md-input-container class="md-block flex-gt-sm"><label class=fontStyle>{{\'ADMIN_IPN\' | translate}}</label> <input ng-model=filter.lastModifierIpn class=materialInput type=text></md-input-container><md-button ng-if="" ng-click="" class="btn closePos">X</md-button></div><!-- SEARCH/REINIT buttons --><div><md-button type=button class="md-raised cancel buttonWithIcon" ng-click="filter = {}; vm.onValidate(filter)" style="height: auto;"><div class=iconDiv><i class=icon-icons-phnx_reinit style="font-size: 20px;"></i></div><div class=btnText>{{\'COMMON_REINIT\' | translate}}</div></md-button><md-button class="md-raised buttonWithIcon" type=submit ng-click=vm.onValidate(filter)><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button></div></form></div>');
$templateCache.put('app/components/basket/consultation/list-carts.template.html','<div id=listCart><div class="baskets-table border-bottomC"><div class="row baskets-row-title"><div class="inner_row cell"><div class=inner_row2><div class="small-2 columns inner_cell pointer" ng-click="vm.sortBy(\'ID\')"><strong>{{\'COMMON_NUMBER_ID\' | translate}} <i ng-class="vm.handleIconOrder(\'ID\')"></i></strong></div><div class="small-3 columns inner_cell"><strong>{{\'COMMON_VEHICLE\' | translate}}</strong></div><div class="small-3 columns inner_cell"><strong>{{\'COMMON_LABEL\' | translate}}</strong></div><div class="small-3 columns inner_cell pointer" ng-click="vm.sortBy(\'DATE\')"><strong>{{\'MODIFICATION_DATE\' | translate}} <i ng-class="vm.handleIconOrder(\'DATE\')"></i></strong></div></div><div class=inner_row3><div class="small-1 columns cell_remove"><i class="fa fa-lock"></i></div></div><div class=inner_row3><div class="small-1 columns cell_remove" ng-click=vm.deleteCarts()><i class=icon-icons_remove></i></div></div></div></div></div><div class="baskets-table border-bottomC" ng-repeat="cart in vm.list track by cart.id"><div class="row baskets-row-title"><div class="inner_row cell"><div class="inner_row2 line pointer" ng-click=vm.selectCart(cart)><div class="small-2 columns inner_cell">{{cart.id}}</div><div class="small-3 columns inner_cell" class=maxWidthForLimitText><div class=limitText><span id=showModel ng-if="(cart.vin != \'\')">{{cart.model}}<br></span><span id=showModel ng-if="(cart.vin == \'\')">{{cart.model}}<br></span>{{cart.vehiculeLabel}}</div></div><div class="small-3 columns inner_cell" class=maxWdithForLimitText><div class=limitText>&nbsp;{{cart.label}}</div></div><div class="small-3 columns inner_cell" class=maxWdithForLimitText><div class=limitText>&nbsp;{{cart.lastModificationDateTime | date:\'yyyy/MM/dd\'}} | {{cart.lastModifier}}</div></div></div><div class="inner_row3 checkboxColumns"><div class=checkbox><i ng-click=vm.unlock(cart.id) ng-if=cart.lockedByUser class="fa fa-unlock"></i></div></div><div class="inner_row3 checkboxColumns"><div class=checkbox><input type=checkbox class=customCheckBox ng-model=cart.checked id={{cart.id}}> <label for={{cart.id}}></label></div></div></div></div></div></div>');
$templateCache.put('app/components/basket/consultation/pagination-carts-list.template.html','<div class=pagination_basket ng-if="vm.nbPages > 1"><div class=container-arrow><i ng-if="vm.actualPage > 1" ng-click=vm.previous() class=icon-icons_arrow_left_panier></i> &nbsp;</div><div>{{\'COMMON_PAGINATION_PAGE\'| translate}}&nbsp;</div><div class=custom-select><select ng-change=vm.onUpdate() ng-model=vm.actualPage ng-options="page for page in vm.list"></select></div><div>&nbsp;{{\'COMMON_PAGINATION_ON\'| translate}} {{vm.nbPages}}</div><div class=container-arrow><i ng-click=vm.next() ng-if="vm.actualPage < vm.nbPages" class=icon-icons_arrow_right_panier></i> &nbsp;</div></div>');
$templateCache.put('app/components/basket/shoppingCart/modal-voi.template.html','<md-dialog class=modal-voi><div class=modalPhenix><div class=title><strong>{{\'REF_CONSIGNE_TITLE\'|translate}}</strong></div><ul><li ng-repeat="item in vm.computedVOIList track by $index">{{item}}</li></ul><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'REF_CONSIGNE_VALIDATE\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/basket/shoppingCart/shopping-cart.template.html','<div ng-switch=$ctrl.page><!-- ********************************\n            CART PAGE\n    ************************************ --><div ng-switch-when=cart class=stock-component-basket><!--  ***************\n                REDUCE\n        ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=$ctrl.reduceOne() ng-keydown="$event.key === \'Enter\' || $event.key === \' \' ? $ctrl.reduceOne() : null" ng-if="$ctrl.piece.quantity > 1" title="{{\'DOCUMENT_PR_DECREASE_BASKET\'| translate}}"></i></div><!-- ****************\n                INPUT\n        ****************** --><div class=stockText><input float-only class=text-center id=cart-quantity-input type=text pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ ng-model=$ctrl.piece.quantity ng-model-options="{ debounce: 2000 }" ng-change=$ctrl.updateFromInputSecond() ng-keydown=$ctrl.handleKeydown($event)></div><!-- ****************\n                ADD\n        ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=$ctrl.addOne() ng-keydown="$event.key === \'Enter\' || $event.key === \' \' ? $ctrl.addOne() : null" title="{{\'DOCUMENT_PR_INCREASE_BASKET\'| translate}}"></i></div></div><!-- ********************************\n            OTHER PAGES\n    ************************************ --><div ng-switch-default=ng-switch-default class=float-right><!-- *****************************\n                UPDATE QUANTITY\n        ******************************* --><div class=stock-component-basket ng-if=$ctrl.piece.quantity><!--  ***************\n                    REDUCE\n            ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=$ctrl.reduceOne() ng-keydown="$event.key === \'Enter\' || $event.key === \' \' ? $ctrl.reduceOne() : null" title="{{\'DOCUMENT_PR_DECREASE_BASKET\'| translate}}"></i></div><!-- ****************\n                    INPUT\n            ****************** --><div class=stockText><input float-only class=text-center id=default-quantity-input type=text pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ ng-model=$ctrl.piece.quantity ng-model-options="{ debounce: 2000 }" ng-change=$ctrl.updateFromInputSecond({{$ctrl.piece.quantity}})></div><!-- ****************\n                    ADD\n            ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=$ctrl.addOne() ng-keydown="$event.key === \'Enter\' || $event.key === \' \' ? $ctrl.addOne() : null" title="{{\'DOCUMENT_PR_INCREASE_BASKET\'| translate}}"></i></div></div><!-- ***************************\n                ADD TO SHOPPING CART\n        **************************** --><div ng-if=!$ctrl.piece.quantity ng-click=$ctrl.handleFirstAdd() ng-keydown="$event.key === \'Enter\' || $event.key === \' \' ? $ctrl.handleFirstAdd() : null" class="shopping-cart float-right" title="{{\'DOCUMENT_PR_INCREASE_BASKET\'| translate}}"><i class=icon-icons_basket></i></div></div></div>');
$templateCache.put('app/components/basket/shoppingCart/testOpcodPopup.template.html','<div class=text-center><div style=padding:6px><span ng-if="vm.message == \'CART\'">{{\'SOME_TEST_CODE_CART\'|translate}}</span> <span ng-if="vm.message == \'EST\'">{{\'SOME_TEST_CODE_EST\'|translate}}</span><br><span ng-if=vm.lowerTm translate=ADD_TEST_OPECODE translate-values="{opecod: vm.opecod}"></span> <span ng-if=!vm.lowerTm translate=REPLACE_TEST_OPECODE translate-values="{opecod: vm.opecod}"></span></div><div style=padding:6px class=text-center><button class="buttonWithIcon confirm" ng-click=vm.onConfirm(true)><div class=btnText>{{\'COMMON_ADD\'|translate}}</div></button> <button style="height: 100%;" class=cancel ng-click=vm.onCancel(false)><div ng-if=!vm.lowerTm class=btnText>{{\'REPLACE_BUTTON\'|translate}}</div><div ng-if=vm.lowerTm class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></div>');
$templateCache.put('app/components/car/axleGeometry/axleGeometry.template.html','<div id=axle-geometry><div class="row margin"><div class="medium-5 columns"><!-- FULL-WIDTH FOR LOW RESOLUTION --> <img class=full-width src="./assets/svg/schema calculette.svg" alt=""></div><div ng-if="vm.computedGeometry.length > 1" class="medium-7 columns"><div><h4><span class=variants>{{\'SELECT_VARIANTS\' | translate}}</span></h4></div><div class=computedGeometryList><div ng-if=!vm.isX70Vehicle class="computedGeometry border" ng-repeat="geometry in vm.computedGeometry" ng-click=vm.selectGeometry(geometry.id) ng-class="{\n                        selectedResiduel: geometry.id === vm.id\n                    }"><div ng-repeat="residuel in geometry.computedResidual"><div>{{residuel}}</div></div></div><div ng-if=vm.isX70Vehicle class="computedGeometry border" ng-repeat="geometry in vm.computedGeometry" ng-click=vm.selectGeometry(geometry.id) ng-class="{\n                        selectedResiduel: geometry.id === vm.id\n                    }"><div>{{geometry.label}}</div></div></div></div></div><div class=row><div class="medium-5 columns"><!-- FULL-WIDTH FOR LOW RESOLUTION --><form novalidate><table class="remove-style full-width"><tr class=header-height><th id=initial></th><th id=width>W (mm)</th><th id=radius>R (mm)</th></tr><tr><td>{{\'FRONT_LEFT_WHEEL\' | translate}}</td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.leftFrontW.error\n                                    }" ng-model=vm.sizes.leftFrontW.value></td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.leftFrontR.error\n                                    }" ng-model=vm.sizes.leftFrontR.value></td></tr><tr><td style="max-width: 100px">{{\'FRONT_RIGHT_WHEEL\' | translate}}</td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.rightFrontW.error\n                                    }" ng-model=vm.sizes.rightFrontW.value></td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.rightFrontR.error\n                                    }" ng-model=vm.sizes.rightFrontR.value></td></tr><tr><td>{{\'REAR_LEFT_WHEEL\' | translate}}</td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.leftRearW.error\n                                    }" ng-model=vm.sizes.leftRearW.value></td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.leftRearR.error\n                                    }" ng-model=vm.sizes.leftRearR.value></td></tr><tr><td>{{\'REAR_RIGHT_WHEEL\' | translate}}</td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.rightRearW.error\n                                    }" ng-model=vm.sizes.rightRearW.value></td><td style="max-width: 100px"><input numbers-only maxlength=8 ng-disabled=!vm.id ng-class="{\n                                        \'input-error\': vm.sizes.rightRearR.error\n                                    }" ng-model=vm.sizes.rightRearR.value></td></tr></table></form><div class=text-center><md-button class="buttonWithIcon calculate-button" ng-click=vm.onCalcul(vm.sizes)><div class=iconDiv><i class="fa fa-calculator"></i></div><div class="btnText calculate-text">{{\'BUTTON_ESTIMATE_CALCULATE\' | translate}}</div></md-button></div></div><div class="medium-7 columns"><table class=remove-style><tr class=header-height><th id=initial></th><th id=frontRight>{{\'FRONT_RIGHT_WHEEL\' | translate}}</th><th id=frontLeft>{{\'FRONT_LEFT_WHEEL\' | translate}}</th><th id=rearRight>{{\'REAR_RIGHT_WHEEL\' | translate}}</th><th id=rearLeft>{{\'REAR_LEFT_WHEEL\' | translate}}</th></tr><tr><td>{{\'WHEEL ALIGNMENT\' | translate}}</td><td><input disabled=disabled ng-model=vm.calculResult.frontRighthandWheel.wheelAlignment_></td><td><input disabled=disabled ng-model=vm.calculResult.frontLefthandWheel.wheelAlignment_></td><td><input disabled=disabled ng-model=vm.calculResult.rearRighthandWheel.wheelAlignment_></td><td><input disabled=disabled ng-model=vm.calculResult.rearLefthandWheel.wheelAlignment_></td></tr><tr><td>{{\'CAMBER\' | translate}}</td><td><input disabled=disabled ng-model=vm.calculResult.frontRighthandWheel.camber_></td><td><input disabled=disabled ng-model=vm.calculResult.frontLefthandWheel.camber_></td><td><input disabled=disabled ng-model=vm.calculResult.rearRighthandWheel.camber_></td><td><input disabled=disabled ng-model=vm.calculResult.rearLefthandWheel.camber_></td></tr><tr><td>{{\'CASTOR_ANGLE\' | translate}}</td><td><input disabled=disabled ng-model=vm.calculResult.frontRighthandWheel.castorAngle_></td><td><input disabled=disabled ng-model=vm.calculResult.frontLefthandWheel.castorAngle_></td><td></td><td></td></tr><tr><td>{{\'Pivot\' | translate}}</td><td><input disabled=disabled ng-model=vm.calculResult.frontRighthandWheel.pivot_></td><td><input disabled=disabled ng-model=vm.calculResult.frontLefthandWheel.pivot_></td><td></td><td></td></tr></table></div></div></div>');
$templateCache.put('app/components/car/carSearch/carSearch.html','<car-search-vin-model is-docpriv=false></car-search-vin-model>');
$templateCache.put('app/components/car/carSearch/carSearchByModel.html','<form name=carSearchByModelForm ng-submit="searchByModelCtrl.search(searchByModelCtrl.fields,\nsearchByModelCtrl.fields2,\nsearchByModelCtrl.fields3,\nsearchByModelCtrl.manufactureDate,\nsearchByModelCtrl.fields4,\ncarSearchFormModel)"><div class="carSearchForm carSearchFormModel"><div class="row carSearchTextMandatory"><div class="small-12 columns">* {{\'COMMON_MANDATORY\' | translate}}</div></div><div class=row id=nissanProf ng-if=searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields" id={{field.key}} class="small-4 columns FirstBlock select" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container ng-click=searchByModelCtrl.autoFocus(field.key)><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container ng-disabled=searchByModelCtrl.rules[field.key] name={{field.key}} id={{field.key}} ng-click="" placeholder="{{field.defaultOption | translate}}{{ (searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? \'\' : \'*\' }}" ng-model=field.value ng-change="searchByModelCtrl.reset.all();\n                               $first ? searchByModelCtrl.clickOnNext(\'{{field.key}}\') : null;\n                               ($middle && !searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? searchByModelCtrl.clickOnNext(\'{{field.key}}\') : null;\n                               ($middle && searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? searchByModelCtrl.getFiltersList(searchByModelCtrl.fields, field.value, field.key) : field.adjust(field.index, field.value, searchByModelCtrl.fields);\n                               $last ? searchByModelCtrl.getFiltersList(searchByModelCtrl.fields, field.value, field.key) : field.adjust(field.index, field.value, searchByModelCtrl.fields)" class="md-selected selectStyleSmall"><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text"></md-select-header><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL,\n                                              \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search  | orderBy:\'index\'" ng-if="field.list.length === 1 && field.index === 0" ng-selected=$first>{{list.label.slice(0, -7)}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL,\n                                              \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list.label ng-repeat="list in field.list |filter:search  | orderBy:\'index\'" ng-if="field.list.length > 1 && field.index === 0">{{list.label.substring(list.label.indexOf(\'(\') + 1, list.label.indexOf(\')\'))}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL,\n                                              \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search  | orderBy:\'label\'" ng-if="field.index !== 0 && field.list.length !== 1">{{list.label.substring(list.label.indexOf(\'(\') + 1, list.label.indexOf(\')\'))}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL,\n                                              \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search  | orderBy:\'label\'" ng-if="field.index !== 0 && field.list.length === 1" selected=selected>{{list.label.substring(list.label.indexOf(\'(\') + 1, list.label.indexOf(\')\'))}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null; field.reset(field.index, searchByModelCtrl.fields); searchByModelCtrl.reset.all()"><md-button class="nissanBtn btn">X</md-button></div></div></div><div class=row id=renaultProf ng-if=!searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields" id={{field.key}} class="small-4 columns FirstBlock select" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container ng-click=searchByModelCtrl.autoFocus(field.key)><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container ng-disabled=searchByModelCtrl.rules[field.key] name={{field.key}} id={{field.key}} ng-click="" placeholder="{{field.defaultOption | translate}}{{ (searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? \'\' : \'*\' }}" ng-model=field.value ng-change="searchByModelCtrl.reset.all();\n                               $first ? searchByModelCtrl.clickOnNext(\'{{field.key}}\') : null;\n                               ($middle && !searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? searchByModelCtrl.clickOnNext(\'{{field.key}}\') : null;\n                               ($middle && searchByModelCtrl.isFamilyCodeXTPorXRQ(searchByModelCtrl.fields)) ? searchByModelCtrl.getFiltersList(searchByModelCtrl.fields, field.value, field.key) : field.adjust(field.index, field.value, searchByModelCtrl.fields);\n                               $last ? searchByModelCtrl.getFiltersList(searchByModelCtrl.fields, field.value, field.key) : field.adjust(field.index, field.value, searchByModelCtrl.fields)" class="md-selected selectStyle"><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text"></md-select-header><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search  | orderBy:\'index\'" ng-if="field.index === 0">{{list.label.slice(0, -7)}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search  | orderBy:\'label\'" ng-if="field.index !== 0 && field.list.length !== 1">{{list.label}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search  | orderBy:\'label\'" ng-if="field.index !== 0 && field.list.length === 1" selected=selected>{{list.label}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null; field.reset(field.index, searchByModelCtrl.fields); searchByModelCtrl.reset.all()"><md-button class="renaultBtn btn">X</md-button><!--<i class="fa fa-times" aria-hidden="true"></i>--></div></div></div><div class=row id=nissanProf ng-if=searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields2" id={{field.key}} class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container ng-click=searchByModelCtrl.autoFocus(field.key)><label ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}">{{field.defaultOption | translate}}</label><md-select md-container-class=my-container ng-disabled=searchByModelCtrl.rules[field.key] name={{field.key}} id={{field.key}} placeholder="{{field.defaultOption | translate}}{{ field.required ? \'*\' : \'\' }}" ng-model=field.value ng-change=" field.filterList(field.value, field,\n                    searchByModelCtrl.fields2, \'ADDED\');\n                    searchByModelCtrl.watchVariable(searchByModelCtrl.fields2, $index);searchByModelCtrl.clickOnNext(\'{{field.key}}\')" class="md-selected selectStyleSmall"><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text"></md-select-header><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index !== 2 && field.index !== 5 && field.list.length !== 1">{{list}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index !== 2 && field.index !== 5 && field.list.length === 1" selected=selected>{{list}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 2 && field.selParent" selected=selected>{{list}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 2 && !field.selParent">{{list}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 5 && field.selParent && field.list.length === 1" selected=selected>{{list}}</md-option><md-option class=nissanHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-value=list ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 5 && field.selParent && field.list.length !== 1">{{list}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;\n                field.reset($index, searchByModelCtrl.fields2);\n                field.filterList(field.value, field, searchByModelCtrl.fields2, \'DELETED\');\n                searchByModelCtrl.checkEngineGearboxSelect(searchByModelCtrl.fields2, $index);"><md-button class="nissanBtn btn">X</md-button><!--<i class="fa fa-times" aria-hidden="true"></i>--></div></div></div><div class=row id=renaultProf ng-if=!searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields2" id={{field.key}} class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container ng-click=searchByModelCtrl.autoFocus(field.key)><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container ng-disabled=searchByModelCtrl.rules[field.key] name={{field.key}} id={{field.key}} placeholder="{{field.defaultOption | translate}}{{ field.required ? \'*\' : \'\' }}" ng-model=field.value ng-change=" field.filterList(field.value, field,\n                    searchByModelCtrl.fields2, \'ADDED\');\n                    searchByModelCtrl.watchVariable(searchByModelCtrl.fields2, $index);searchByModelCtrl.clickOnNext(\'{{field.key}}\')" class="md-selected selectStyleSmall"><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text"></md-select-header><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index !== 2 && field.index !== 5 && field.list.length !== 1">{{list}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index !== 2 && field.index !== 5 && field.list.length === 1" selected=selected>{{list}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 2 && field.selParent" selected=selected>{{list}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 2 && !field.selParent">{{list}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 5 && field.selParent && field.list.length === 1" selected=selected>{{list}}</md-option><md-option ng-value=list class=renaultHoverOption ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}" ng-repeat="list in field.list |filter:search | orderBy:\'toString()\'" ng-if="field.index === 5 && field.selParent && field.list.length !== 1">{{list}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;\n                field.reset($index, searchByModelCtrl.fields2);\n                field.filterList(field.value, field, searchByModelCtrl.fields2, \'DELETED\');\n                searchByModelCtrl.checkEngineGearboxSelect(searchByModelCtrl.fields2, $index);"><md-button class="renaultBtn btn">X</md-button><!--<i class="fa fa-times" aria-hidden="true"></i>--></div></div></div><div class=separators><hr></div><div class=row><div ng-click=searchByModelCtrl.showCriteria()><span class=otherCriteria><strong>{{ \'VEHICLE_OTHER_CRITERIA\' | translate}} <i ng-class="{\'icon-icons_arrow_top\': searchByModelCtrl.notHide,\'icon-icons_arrow_bottom\': !searchByModelCtrl.notHide}"></i></strong></span></div></div><div class=row ng-show=searchByModelCtrl.notHide id=nissanProf ng-if=searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields3" class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container name={{field.key}} ng-disabled=searchByModelCtrl.rules.additionalFields id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change="" class=selectStyle><md-option class=nissanHoverOption ng-value=list ng-repeat="list in field.list | orderBy:\'toString()\'" ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}">{{list.label}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;"><md-button class="nissanBtn btn">X</md-button></div></div></div><div class=row id=renaultProf ng-show=searchByModelCtrl.notHide ng-if=!searchByModelCtrl.nissanUserURL><div ng-repeat="field in searchByModelCtrl.fields3" class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container name={{field.key}} ng-disabled=searchByModelCtrl.rules.additionalFields id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change="" class=selectStyle><md-option class=renaultHoverOption ng-value=list ng-repeat="list in field.list | orderBy:\'toString()\'" ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}">{{list.label}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;"><md-button class="renaultBtn btn">X</md-button></div></div></div><div class=separators><hr></div><div class="row position-relative height-35" id=nissanProf ng-if=searchByModelCtrl.nissanUserURL><div class="small-4 columns top--10"><md-input-container class=md-block><label class=fontStyle ng-disabled="!searchByModelCtrl.showList || searchByModelCtrl.rules.additionalFields">{{\'VEHICLE_MANUFACTURE_DATE\' | translate}}</label> <input ng-disabled="!searchByModelCtrl.showList || searchByModelCtrl.rules.additionalFields" class=dateInput name=manufactureDate ng-model=searchByModelCtrl.manufactureDate></md-input-container><label class=carSearchTextFormat>{{\'COMMON_FORMAT\' | translate}} {{\'COMMON_FORMAT_YYYY_MM\' | translate}}</label></div><div ng-repeat="field in searchByModelCtrl.fields4" class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container name={{field.key}} ng-disabled=searchByModelCtrl.rules.additionalFields id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change="" class=selectStyle><md-option class=nissanHoverOption ng-value=list ng-repeat="list in field.list | orderBy:\'toString()\'" ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}">{{list.label}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;"><md-button class="nissanBtn btn">X</md-button></div></div></div><div class="row position-relative height-35" id=renaultProf ng-if=!searchByModelCtrl.nissanUserURL><div class="small-4 columns top--10"><md-input-container class=md-block><label class=fontStyle ng-disabled="!searchByModelCtrl.showList || searchByModelCtrl.rules.additionalFields">{{\'VEHICLE_MANUFACTURE_DATE\' | translate}}</label> <input ng-disabled="!searchByModelCtrl.showList || searchByModelCtrl.rules.additionalFields" class=dateInput name=manufactureDate ng-model=searchByModelCtrl.manufactureDate></md-input-container><label class=carSearchTextFormat>{{\'COMMON_FORMAT\' | translate}} {{\'COMMON_FORMAT_YYYY_MM\' | translate}}</label></div><div ng-repeat="field in searchByModelCtrl.fields4" class="small-4 columns" ng-click=searchByModelCtrl.divSelected(field.key)><md-input-container><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container name={{field.key}} ng-disabled=searchByModelCtrl.rules.additionalFields id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change="" class=selectStyle><md-option class=renaultHoverOption ng-value=list ng-repeat="list in field.list | orderBy:\'toString()\'" ng-class="{\'nissan-user\': searchByModelCtrl.nissanUserURL, \'renault-user\': !searchByModelCtrl.nissanUserURL}">{{list.label}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click="field.value = null;"><md-button class="renaultBtn btn">X</md-button></div></div></div><div class="row row-button"><div class="small-12 columns text-center"><md-button class="md-raised buttonWithIcon" type=submit analytics-on=mouseup analytics-event=searchByModel analytics-category=carSearch analytics-label=ByModel ng-class="{\'nissan-class nissanHover\': searchByModelCtrl.nissanUserURL, \'renault-class\': !searchByModelCtrl.nissanUserURL}"><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button style="padding: 4px;" class="md-raised buttonWithIcon cancel" ng-click=searchByModelCtrl.reset.fields() ng-class="{\'nissan-class nissanHover\': searchByModelCtrl.nissanUserURL, \'renault-class\': !searchByModelCtrl.nissanUserURL}"><div class=iconDiv><i class=icon-icons-phnx_reinit style="font-size: inherit;"></i></div><div class=btnText>{{\'COMMON_REINIT\' | translate}}</div></md-button></div></div></div></form>');
$templateCache.put('app/components/car/carSearch/carSearchByRegistration.template.html','<md-dialog id=carSearchByRegistrationPopIn><md-dialog-content><div><div id=labelAndCloseButton class="md-dialog-content small-12 columns"><div class="small-11 columns"><label id=labelStyle>{{\'TITLE_MULTIPLE_REGISTRATIONS\' | translate}}</label></div><div id=closeButtonStyle class="small-1 columns"><label ng-click=vm.onClose()>{{\'BUTTON_ESTIMATE_CLOSE\' | translate}}</label><div id=alignButtonWithCloseLabel class="columns icon-icons_close pointer" ng-click=vm.onClose()></div></div></div><table id=displayDataTable class="table small-12"><thead><tr><th id=brand>{{\'VEHICLE_BRAND\' | translate | uppercase}}</th><th id=model>{{\'VEHICLE_MODEL\' | translate | uppercase}}</th><th id=engine>{{\'VEHICLE_ENGINE_TYPE\' | translate | uppercase}}</th><th id=vehicleVin>{{\'ACTIS_VEHICLE_VIN\' | translate | uppercase}}</th><th id=countryCode>{{\'COUNTRY_CODE\' | translate | uppercase}}</th></tr></thead><tbody><tr ng-repeat="row in vm.multipleCarsWithSameReg track by $index" ng-class="{ \'nissanHover\': vm.nissanUserURL, \'renaultHover\': !vm.nissanUserURL}" style="cursor: pointer" ng-click=vm.showCarSearchResultByRegistration(row.vin)><td>{{row.labelizedBrandCode}}</td><td>{{row.commercialDesignation}}</td><td>{{row.engine}}</td><td>{{row.vin}}</td><td>{{row.registrationCountryCode}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>');
$templateCache.put('app/components/car/carSearch/carSearchVinModel.html','<div id=carSearchMain><div class=centered-div id=carSearchCont ng-style="{ \'width\': vm.isDocpriv ? \'500px\' : \'800px\'}"><div class="centered-div row carSearchCriteria" ng-style="{ \'margin-bottom\': vm.isDocpriv ? \'0px\' : \'20px\'}" ng-hide=vm.isOnlyPpxLightUser><tabset><!--=====================================\n                =               FIRST TAB               =\n                ======================================--><tab id=firstCarSearchTab class="{{!vm.isDocpriv ? \'tabHeading\' : \'docprivTabHeading\'}}" heading="{{(vm.isDocpriv ? \'CARSEARCH_DOCPRIIV_MSG\' : \'CARSEARCH_FORM_VEHICLE\')| translate}}" active=vm.carSearchActive ng-style="{\'margin-left\' : vm.isHideModelSearch() || vm.allowASOM ?\'23%\':\'0%\', \'margin-right\' : vm.isHideModelSearch() || vm.allowASOM ?\'23%\':\'0%\'}" ng-click="vm.changeCarSearchActive((vm.isDocpriv ? \'CARSEARCH_DOCPRIIV_MSG\' : \'CARSEARCH_FORM_VEHICLE\')| translate); vm.cleanModelForm(); vm.removeNissanTabFromFirstTab()"><form name=carSearchForm class=carSearchForm><div class="row row-vin"><!--====  VIN  ====--><div ng-class="(vm.showSearchByOR && !vm.nissanUserURL ) ? \'small-4 columns\' : \'small-6 columns\'" ng-style="{\'width\': vm.isDocpriv ? \'100%\' : \'\' }"><div layout-gt-sm=row id=nissanProf ng-if=vm.nissanUserURL><md-input-container class=md-block flex-gt-sm=""><label for=vin class=fontStyle>VIN</label> <input ng-init=vm.initVinFocus() ng-disabled=vm.allowASOM ng-model=vm.carSearch.vin ng-focus="vm.switchState(\'vin\', true)" ng-blur="vm.switchState(\'vin\', false)" class=inputAngular ng-class=" {\'carSearchFormCell\': (vm.stateInputsForm[\'vin\'].active == true || vm.carSearch.vin), \'inputResetVin\' : (!vm.carSearch.vin)}" type=text name=vin maxlength=17 phenix-enter=vm.search() id=vin></md-input-container><md-button ng-if=vm.carSearch.vin ng-click="vm.carSearch.vin = null" class="btn closePos">X</md-button></div><div layout-gt-sm=row ng-if=!vm.nissanUserURL><md-input-container class=md-block flex-gt-sm=""><label for=vin class=fontStyle>VIN</label> <input ng-init=vm.initVinFocus() ng-disabled=vm.allowASOM ng-model=vm.carSearch.vin ng-focus="vm.switchState(\'vin\', true)" ng-blur="vm.switchState(\'vin\', false)" class=inputAngular ng-class=" {\'carSearchFormCell\': (vm.stateInputsForm[\'vin\'].active == true || vm.carSearch.vin), \'inputResetVin\' : (!vm.carSearch.vin)}" type=text name=vin maxlength=17 phenix-enter=vm.search() id=vin></md-input-container><md-button ng-if=vm.carSearch.vin ng-click="vm.carSearch.vin = null" class="btn closePos">X</md-button></div></div><!--====  IMAT  ====--><div ng-class="(vm.showSearchByOR && !vm.nissanUserURL) ? \'small-4 columns\' : \'small-6 columns\'" ng-if=vm.showSearchByRegistrationNumber ng-hide=vm.isDocpriv><div layout-gt-sm=row id=nissanProf ng-if=vm.nissanUserURL><md-input-container class=md-block flex-gt-sm=""><label for=imat class=fontStyle>{{\'CARSEARCH_IMAT_PLACEHOLDER\' | translate}}</label> <input ng-model-options="{ debounce: 100 }" ng-disabled=vm.allowASOM ng-model=vm.carSearch.imat class=inputAngular name=imat ng-class=" {\'carSearchFormCell\': (vm.stateInputsForm[\'imat\'].active == true || vm.carSearch.imat), \'inputResetImat\' : (!vm.carSearch.imat)}" type=text name=imat ng-focus="vm.switchState(\'imat\', true)" ng-blur="vm.switchState(\'imat\', false)" phenix-enter=vm.search($event) id=imat></md-input-container><md-button ng-if=vm.carSearch.imat ng-click="vm.carSearch.imat = null" class="btn closePos">X</md-button></div><div layout-gt-sm=row ng-if=!vm.nissanUserURL><md-input-container class=md-block flex-gt-sm=""><label for=imat class=fontStyle>{{\'CARSEARCH_IMAT_PLACEHOLDER\' | translate}}</label> <input ng-model-options="{ debounce: 100 }" ng-disabled=vm.allowASOM ng-model=vm.carSearch.imat class=inputAngular name=imat ng-class=" {\'carSearchFormCell\': (vm.stateInputsForm[\'imat\'].active == true || vm.carSearch.imat), \'inputResetImat\' : (!vm.carSearch.imat)}" type=text name=imat ng-focus="vm.switchState(\'imat\', true)" ng-blur="vm.switchState(\'imat\', false)" phenix-enter=vm.search($event) id=imat></md-input-container><md-button ng-if=vm.carSearch.imat ng-click="vm.carSearch.imat = null" class="btn closePos">X</md-button></div></div><!--====  OR ??  ====--><div class="small-4 columns" ng-if=vm.showSearchByOR ng-hide="vm.isDocpriv || vm.nissanUserURL || vm.isPpxLightUser"><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=""><label for=or class=fontStyle>{{\'COMMON_ORDER\' | translate}}</label> <input ng-model=vm.carSearch.or ng-focus="vm.switchState(\'or\', true)" ng-blur="vm.switchState(\'or\', false)" class=inputAngular ng-class=" {\'carSearchFormCell\': (vm.stateInputsForm[\'or\'].active == true || vm.carSearch.or), \'inputResetOr\' : (!vm.carSearch.or)}" type=text name=or maxlength=17 phenix-enter=vm.search() id=or></md-input-container><md-button ng-if=vm.carSearch.or ng-click="vm.carSearch.or = null" class="btn closePos">X</md-button></div></div></div><!--====  LAST/FIRST NAME ??  ====--><div class=row-name ng-if=vm.showSearchByNameAndFirstName ng-hide="vm.isDocpriv || vm.nissanUserURL || vm.isPpxLightUser"><div class="name row border collapse" ng-class=" {\'showReset\':(vm.stateInputsForm[\'firstName\'].active || vm.stateInputsForm[\'name\'].active)}"><div class="small-6 columns"><div class="inputReset lastname" ng-class="{\'greyDisableField\': vm.stateInputsForm[\'name\'].active == false && vm.stateInit == false}"><input class=inputReset id=name ng-class=" {\'carSearchFormCell\': vm.stateInputsForm[\'name\'].active == true || vm.stateInputsForm[\'firstName\'].active == true || vm.carSearch.name || vm.carSearch.firstName, \'inputResetLastName\' : (!vm.carSearch.name && !vm.carSearch.firstName)}" type=text name=name ng-model=vm.carSearch.name placeholder="{{\'CARSEARCH_LASTNAME_PLACEHOLDER\' | translate}}" phenix-enter=vm.search() ng-focus="vm.switchState(\'name\', true)" ng-blur="vm.switchState(\'name\', false)"><div class=reset ng-click=vm.resetField() ng-show=vm.carSearch.name><i class=icon-icons_close></i></div></div></div><div class="small-6 columns"><div class=inputReset ng-class=" {\'greyDisableField\': vm.stateInputsForm[\'firstName\'].active == false && vm.stateInit == false}"><input class=inputReset id=firstName ng-class=" {\'carSearchFormCell\': vm.stateInputsForm[\'name\'].active == true || vm.stateInputsForm[\'firstName\'].active == true || vm.carSearch.name || vm.carSearch.firstName, \'inputResetFirstName\' : (!vm.carSearch.name && !vm.carSearch.firstName)}" type=text name=firstName ng-model=vm.carSearch.firstName placeholder="{{\'CARSEARCH_FIRSTNAME_PLACEHOLDER\' | translate}}" phenix-enter=vm.search() ng-focus="vm.switchState(\'firstName\', true)" ng-blur="vm.switchState(\'firstName\', false)" ng-disabled=!vm.carSearch.name><div class=reset ng-click="vm.carSearch.firstName = undefined" ng-show=vm.carSearch.firstName><i class=icon-icons_close></i></div></div></div></div></div><!--====  SEARCH BUTTON  ====--><div class="row row-button"><div class="small-12 columns text-center"><md-button ng-disabled=vm.allowASOM class="md-raised buttonWithIcon" type=button validation-submit=carSearchForm ng-class="{\'clicked\':vm.searchClicked, \'nissan-class nissanHover\': vm.nissanUserURL, \'renault-class\': !vm.nissanUserURL}" ng-click=vm.search() analytics-on=mouseup analytics-event=searchByVIN analytics-category=carSearch analytics-label={{vm.carSearch.vin}}><div class=iconDiv><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button ng-disabled=vm.allowASOM class="md-raised buttonWithIcon cancel" ng-click=vm.resetField() ng-hide=vm.isDocpriv style="padding: 4px;" ng-class="{ \'nissan-class nissanHover\': vm.nissanUserURL, \'renault-class reinit-button\': !vm.nissanUserURL}"><div class=iconDiv><i class=icon-icons-phnx_reinit style="font-size: inherit;"></i></div><div class=btnText>{{\'COMMON_REINIT\' | translate}}</div></md-button><md-button type=button class="md-raised buttonWithIcon reinit-button" ng-click=vm.onClose() ng-hide=!vm.isDocpriv ng-class="{ \'nissan-class nissanHover\': vm.nissanUserURL, \'renault-class\': !vm.nissanUserURL}"><div class=iconDiv style="font-size: var(--renaultMediumFont);"><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></md-button></div></div></form></tab><!--=====================================\n                =             SECOND TAB               =\n                ======================================--><tab class="tabHeading {{vm.nissanUserURL ? \'nissan-tab\' : \'\'}}" heading="{{\'CARSEARCH_FORM_MODEL \'| translate}}" ng-click=vm.handleModelSearchClick() active=vm.carSearchModelActive ng-hide="vm.isDocpriv || vm.isHideModelSearch() || vm.isHorseUser || vm.allowASOM || vm.isPpxLightUser"><car-search-by-model ng-if=vm.carSearchModelActive></car-search-by-model></tab></tabset></div><!--=====================================\n        =                RESULTS                =\n        ======================================--><div class=result ng-if="vm.showHisto && !vm.carSearchModelActive" ng-hide="vm.isDocpriv || vm.isOnlyPpxLightUser"><div class=resultName><client-vehicle-directive api=vm.directiveClientVehicleAPI search-by-vin="vm.searchByVin(vin, registrationNumber)"></client-vehicle-directive></div><div class="centered-div row" ng-if="vm.showHisto && vm.carSearchActive"><div ng-class="{\'nissanCarSearchHistoTitle\': vm.nissanUserURL, \'carSearchHistoTitle\': !vm.nissanUserURL}">{{\'LASTVIEWEDCAR_LABEL\' | translate}}</div><div class="centered-div carSearchHistoContent"><div class="row row-histo" ng-repeat="carSearchRow in vm.carSearchHisto"><div ng-repeat="carSearch in carSearchRow " class="small-4 columns cell" ng-class="{ \'nissanHover\': vm.nissanUserURL, \'renaultHover\': !vm.nissanUserURL}" ng-click="vm.searchByVin(carSearch.vin, carSearch.registrationNumber)"><div class=carModel>{{carSearch.model}}</div><div>{{carSearch.vin}}</div><div>{{carSearch.registrationNumber}}</div></div></div></div></div></div><div ng-if=vm.displayCustomersPagination ng-hide="vm.isDocpriv || vm.isOnlyPpxLightUser"><div ng-if="!vm.showHisto && !vm.carSearchModelActive" style="margin-bottom: 15px;"><div class=carSearchHistoTitle>{{\'DIRECTIVE_CLIENTVEHICULE_RESULT_LABEL\' | translate}} "{{vm.customerLookFor.name + (vm.customerLookFor.firstName ? \' \' + vm.customerLookFor.firstName : \'\')}}"</div><div class="content vehicle_client" style="padding: 15px"><div class=vehicles><div id=vehicle_client ng-repeat="customer in vm.customersList"><div class=title_client class=row><div class="small-11 columns container-label-name-client"><label class=nom_client>{{ customer.name | uppercase}} {{customer.firstName}} ({{customer.accountNumber}})</label></div></div><div class="row details_vehicle line_client_vehicle" ng-repeat="vehicle in customer.vehicles" ng-click=vm.onSelectedVehicle(vehicle)><div class="small-4 columns">&nbsp</div><div class="small-3 columns"><label class=info_client>{{vehicle.vin}}</label></div><div class="small-3 columns"><label class=info_client>{{vehicle.registrationNumber}}</label></div><div class="small-2 columns"><i class=icon-icons-phnx-next_client></i></div></div></div></div><div class=pagination><div ng-if=vm.hasPrevious><i ng-click=vm.previous() class=icon-icons_arrow_left_panier></i> &nbsp;</div><div>{{\'COMMON_PAGINATION_PAGE\' | translate}} {{vm.page}}</div><div ng-if=vm.hasNext><i ng-click=vm.next() class=icon-icons_arrow_right_panier></i> &nbsp;</div></div></div></div></div></div></div>');
$templateCache.put('app/components/car/carSearch/phaseMillesim.html','<div class=phasemillesimPop><div class=close ng-click=vm.onClose()><p>{{\'MODAL_CLOSE\' |translate}}</p><i style="margin: 5px 0px 0px 2px;" class=icon-icons_close></i></div><div style=margin-top:15px;>{{\'PHASE_MILLESIM_POPUP_INFO\' | translate}}</div><div class=contents id=nissanProf ng-if=vm.nissanUserURL><div ng-if="vm.phaseList.length > 0"><md-input-container id=selectphase class=md-block><label ng-class="{\'nissanPhaseHover\': vm.nissanUserURL}">{{\'CHOOSE_PHASE\' | translate}}</label><md-select ng-model=vm.selectedPhase required><md-option class=nissanHoverOption ng-class="{\'nissan-user\': vm.nissanUserURL, \'renault-user\': !vm.nissanUserURL}" ng-value=phase ng-repeat="phase in vm.phaseList">{{phase.label}}</md-option></md-select></md-input-container></div><div style="padding-top: 5px;" ng-if="vm.millesimList.length > 0"><md-input-container id=selectmillesim class=md-block><label>{{\'CHOOSE_MILLESIM\' | translate}}</label><md-select ng-model=vm.selectedMillesim required><md-option class=nissanHoverOption ng-class="{\'nissan-user\': vm.nissanUserURL, \'renault-user\': !vm.nissanUserURL}" ng-value=millesim ng-repeat="millesim in vm.millesimList">{{millesim.label}}</md-option></md-select></md-input-container></div><div class=text-center><button ng-click=vm.validate(vm.selectedPhase,vm.selectedMillesim) class="buttonWithIcon nissanValidateBtn"><div class=btnText>{{"MODAL_OK_BUTTON" | translate}}</div></button></div></div><div class=contents id=renaultProf ng-if=!vm.nissanUserURL><div ng-if="vm.phaseList.length > 0"><md-input-container id=selectphase class=md-block><label ng-class="{\'renaultPhaseHover\': !vm.nissanUserURL}">{{\'CHOOSE_PHASE\' | translate}}</label><md-select ng-model=vm.selectedPhase required><md-option class=renaultHoverOption ng-class="{\'nissan-user\': vm.nissanUserURL, \'renault-user\': !vm.nissanUserURL}" ng-value=phase ng-repeat="phase in vm.phaseList">{{phase.label}}</md-option></md-select></md-input-container></div><div style="padding-top: 5px;" ng-if="vm.millesimList.length > 0"><md-input-container id=selectmillesim class=md-block><label>{{\'CHOOSE_MILLESIM\' | translate}}</label><md-select ng-model=vm.selectedMillesim required><md-option class=renaultHoverOption ng-class="{\'nissan-user\': vm.nissanUserURL, \'renault-user\': !vm.nissanUserURL}" ng-value=millesim ng-repeat="millesim in vm.millesimList">{{millesim.label}}</md-option></md-select></md-input-container></div><div class=text-center><button ng-click=vm.validate(vm.selectedPhase,vm.selectedMillesim) class="buttonWithIcon validate"><div class=btnText>{{"MODAL_OK_BUTTON" | translate}}</div></button></div></div></div>');
$templateCache.put('app/components/car/carSearchResult/carSearchResult.html','<div id=carSearchArbo><recap-car api=cSearchResultCtrl.recapCarAPI icons=true is-wd=cSearchResultCtrl.isFromWDUrlLink></recap-car><div id=searchArboTextual class=containerView ng-controller="SearchArboTextualCtrl as searchArboTextualCtrl"><div class=row ng-if=searchArboTextualCtrl.showContent id=searchArboTextualTable><div class="row headerView noMargin"><!-- ICONS DISABLED UNTIL FONCTION DEVELOPED --><!-- REMOVE \'INACTIF CLASS\' THEN ADD THE ngclick ATTRIBUTE COMMENTED ON EACH LINE --><div id=diagnostic class="small-4 medium-4 large-3 columns" style="min-width: 340px;padding-left: 10px;"><div class=actionIcon id=iconDiagnostic ng-if=!searchArboTextualCtrl.checkIndependentUser ng-hide="searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser"><i title="{{\'SYMPTOM_SEARCH\' | translate}}" style="padding-right: 3px;" ng-class="{inactif : !searchArboTextualCtrl.borneo}" ng-click="searchArboTextualCtrl.openSelectedView(\'searchByArbo\')"><md-icon ng-class=searchArboTextualCtrl.getArboIconClass() style="width: 43px;height: 35px;"></md-icon></i></div><div class=actionIcon id=iconDiagnostic ng-if=searchArboTextualCtrl.checkIndependentUser><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && !searchArboTextualCtrl.isCirSentVin" id=iconDiagnostic tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i class=search_arbo title="{{\'SYMPTOM_SEARCH\' | translate}}" style="background-color: grey;"><md-icon md-svg-src=./assets/svg/icons_search_arbo.svg class=size-50 ng-class=""></md-icon></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin" id=iconDiagnostic><i style="padding-right: 3px;" title="{{\'SYMPTOM_SEARCH\' | translate}}" ng-class="{inactif : !searchArboTextualCtrl.borneo}" ng-click="searchArboTextualCtrl.openSelectedView(\'searchByArbo\')"><md-icon ng-class=searchArboTextualCtrl.getArboIconClass() style="width: 43px;height: 35px;"></md-icon></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' && searchArboTextualCtrl.doctypes.length > 0" id=iconDiagnostic><i style="padding-right: 3px;" title="{{\'SYMPTOM_SEARCH\' | translate}}" ng-class="{inactif : !searchArboTextualCtrl.borneo}" ng-click="searchArboTextualCtrl.openSelectedView(\'searchByArbo\')"><md-icon ng-class=searchArboTextualCtrl.getArboIconClass() style="width: 43px;height: 35px;"></md-icon></i></div></div><div class=actionIcon ng-if=!searchArboTextualCtrl.checkIndependentUser ng-hide="searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser"><i class=icon-icons_diagnostic title="{{\'DIAG_SEARCH\' | translate}}" ng-class=searchArboTextualCtrl.getDiagnosticIconClass() ng-click="searchArboTextualCtrl.openSelectedView(\'searchByDiagnostic\', true)"></i><!-- ng-click="searchArboTextualCtrl.showViewSearchByDiagnostic()" --></div><div ng-if=searchArboTextualCtrl.checkIndependentUser><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\'&&searchArboTextualCtrl.tokenBalance===0&&!searchArboTextualCtrl.isCirSentVin && $root.asomDocList.MD" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i class=icon-icons_diagnostic title="{{\'DIAG_SEARCH\' | translate}}" style="background-color: grey;" ng-class=""></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\'&&(searchArboTextualCtrl.tokenBalance > 0 ||(searchArboTextualCtrl.tokenBalance===0&&searchArboTextualCtrl.isCirSentVin))"><i class=icon-icons_diagnostic title="{{\'DIAG_SEARCH\' | translate}}" ng-class=searchArboTextualCtrl.getDiagnosticIconClass() ng-click="searchArboTextualCtrl.openSelectedView(\'searchByDiagnostic\', true)"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' && $root.asomDocList.MD "><i class=icon-icons_diagnostic title="{{\'DIAG_SEARCH\' | translate}}" ng-class=searchArboTextualCtrl.getDiagnosticIconClass() ng-click="searchArboTextualCtrl.openSelectedView(\'searchByDiagnostic\', true)"></i></div><!-- ng-click="searchArboTextualCtrl.showViewSearchByDiagnostic()" --></div><div class=actionIcon ng-if=!searchArboTextualCtrl.checkIndependentUser ng-hide="searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser" style=position:relative;><i class=icon-icons_electrical_schema title="{{\'HEADER_DOCUMENTS_DIAGRAMS\' | translate}}" ng-class=searchArboTextualCtrl.getElectricalSchemaClass() ng-click="searchArboTextualCtrl.openSelectedView(\'consultElectricalShema\')"></i></div><div ng-if=searchArboTextualCtrl.checkIndependentUser><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' &&  !searchArboTextualCtrl.isCirSentVin" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i class=icon-icons_electrical_schema title="{{\'HEADER_DOCUMENTS_DIAGRAMS\' | translate}}" style="background-color: grey;" ng-class=""></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin"><i class=icon-icons_electrical_schema title="{{\'HEADER_DOCUMENTS_DIAGRAMS\' | translate}}" ng-class=searchArboTextualCtrl.getElectricalSchemaClass() ng-click="searchArboTextualCtrl.openSelectedView(\'consultElectricalShema\')"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' && $root.asomDocList.WD"><i class=icon-icons_electrical_schema title="{{\'HEADER_DOCUMENTS_DIAGRAMS\' | translate}}" ng-class=searchArboTextualCtrl.getElectricalSchemaClass() ng-click="searchArboTextualCtrl.openSelectedView(\'consultElectricalShema\')"></i></div></div><div class=actionIcon ng-hide="!searchArboTextualCtrl.isNissanConnectedServicesUser && searchArboTextualCtrl.nissanUserURL" ng-style="{\'border-left\' : (searchArboTextualCtrl.vehicleInformationDisplay || searchArboTextualCtrl.isMitsubishiUser) && (searchArboTextualCtrl.isRLink1Vehicle || searchArboTextualCtrl.isRLink2Vehicle || cSearchResultCtrl.isEasyLinkVehicle) && !cSearchResultCtrl.isUnknownVehicle && !searchArboTextualCtrl.checkIndependentUser && !mainCtrl.isHorseUser && (searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser) ?\'none\':\'1px solid #999\'}" ng-if="(searchArboTextualCtrl.vehicleInformationDisplay || searchArboTextualCtrl.isRnetUser || searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser || (searchArboTextualCtrl.checkIndependentUser && $root.asomDocList.CS)) && (searchArboTextualCtrl.isRLink1Vehicle || searchArboTextualCtrl.isRLink2Vehicle || cSearchResultCtrl.isEasyLinkVehicle) && !cSearchResultCtrl.isUnknownVehicle && !mainCtrl.isHorseUser"><i class=icon-car_assistance_tool title="{{\'HEADER_DOCUMENT_ASSISTANCE\' | translate}}" ng-click="searchArboTextualCtrl.openSelectedView(\'showVehicleMultimediaInformation\', false, true)" ng-class=searchArboTextualCtrl.getvehicleMultimediaInformationClass()></i></div><div class=actionIcon ng-hide="searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.isPpxLightUser" ng-if="(!searchArboTextualCtrl.checkIndependentUser&&searchArboTextualCtrl.showContent) && !mainCtrl.isHorseUser"><i class="fa fa-wrench" title="{{\'HEADER_DOCUMENTS_TOOLS\' | translate}}" ng-class=searchArboTextualCtrl.getSpecialToolsClass() ng-click="searchArboTextualCtrl.openSelectedView(\'searchBySpecializedTool\')"></i><!-- ng-click="searchArboTextualCtrl.consultLastDocument()" --></div><div ng-if=searchArboTextualCtrl.checkIndependentUser&&searchArboTextualCtrl.showContent ng-hide=searchArboTextualCtrl.nissanUserURL><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && !searchArboTextualCtrl.isCirSentVin" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i style="background-color: grey;" class="fa fa-wrench" title="{{\'HEADER_DOCUMENTS_TOOLS\' | translate}}" ng-class="{activeButton: searchArboTextualCtrl.showSpecializedToolView}"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin"><i class="fa fa-wrench" title="{{\'HEADER_DOCUMENTS_TOOLS\' | translate}}" ng-class="{activeButton: searchArboTextualCtrl.showSpecializedToolView}" ng-click="searchArboTextualCtrl.openSelectedView(\'searchBySpecializedTool\')"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' && $root.asomDocList.ST"><i class="fa fa-wrench" title="{{\'HEADER_DOCUMENTS_TOOLS\' | translate}}" ng-class="{activeButton: searchArboTextualCtrl.showSpecializedToolView}" ng-click="searchArboTextualCtrl.openSelectedView(\'searchBySpecializedTool\')"></i></div><!-- ng-click="searchArboTextualCtrl.consultLastDocument()" --></div><!--\n                        TEST\n                     --><div ng-hide="searchArboTextualCtrl.isMitsubishiUser || searchArboTextualCtrl.nissanUserURL || searchArboTextualCtrl.isPpxLightUser" ng-if="cSearchResultCtrl.axleGeometry && !searchArboTextualCtrl.checkIndependentUser && !mainCtrl.isHorseUser" class=actionIcon><i ng-class="{\'activeButton\': searchArboTextualCtrl.showGeometryApplicabilities, \'renault_axel_icon\':searchArboTextualCtrl.showGeometryApplicabilities, \'axel_icon\':!searchArboTextualCtrl.showGeometryApplicabilities }" ng-click="searchArboTextualCtrl.openSelectedView(\'axleGeometry\')"></i></div><div ng-hide=searchArboTextualCtrl.nissanUserURL ng-if=searchArboTextualCtrl.checkIndependentUser&&cSearchResultCtrl.axleGeometry><div ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin" class=actionIcon><i ng-class="{\'activeButton\': searchArboTextualCtrl.showGeometryApplicabilities, \'renault_axel_icon\':searchArboTextualCtrl.showGeometryApplicabilities, \'axel_icon\':!searchArboTextualCtrl.showGeometryApplicabilities }" ng-click="searchArboTextualCtrl.openSelectedView(\'axleGeometry\')"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && !searchArboTextualCtrl.isCirSentVin" tooltip-placement=bottom tooltip-html-unsafe="{{\'ASOM_DOCACCESS_DESCRIPTION\' | translate}}"><i ng-class="{\'activeButton\': searchArboTextualCtrl.showGeometryApplicabilities, \'renault_axel_icon\':searchArboTextualCtrl.showGeometryApplicabilities, \'axel_icon\':!searchArboTextualCtrl.showGeometryApplicabilities }" ng-click="searchArboTextualCtrl.openSelectedView(\'axleGeometry\')"></i></div><div class=actionIcon ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' && $root.asomDocList.AG"><i ng-class="{\'activeButton\': searchArboTextualCtrl.showGeometryApplicabilities, \'renault_axel_icon\':searchArboTextualCtrl.showGeometryApplicabilities, \'axel_icon\':!searchArboTextualCtrl.showGeometryApplicabilities }" ng-click="searchArboTextualCtrl.openSelectedView(\'axleGeometry\')"></i></div></div><!-- <i class="search_arbo"\n                    title="{{\'SYMPTOM_SEARCH\' | translate}}"\n                    ng-class="{inactif : !searchArboTextualCtrl.borneo}"\n                    ng-click="searchArboTextualCtrl.openSelectedView(\'searchByArbo\')">\n                     <md-icon\n                         md-svg-src="./assets/svg/icons_search_arbo.svg" class="size-50" ng-class="searchArboTextualCtrl.getArboIconClass()"></md-icon>\n                 </i> --></div><div id=line_recherche ng-hide="searchArboTextualCtrl.isMitsubishiUser ||  searchArboTextualCtrl.isPpxLightUser" ng-class=searchArboTextualCtrl.independentProfilcheck() ng-if="!mainCtrl.isHorseUser && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showGeometryApplicabilities && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showDiagFilesView"><div class="small-12 large-10 columns" ng-if="!searchArboTextualCtrl.checkIndependentUser "><div ng-if=searchArboTextualCtrl.goToSearchResult class=btnBack ng-click=searchArboTextualCtrl.goToSearchEngine() style="color:white; float:left;"><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</div><div id=searchByCategories ng-if="!searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView  && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation" ng-class=" {\'small-3 columns categories\':searchArboTextualCtrl.isNewSearchBar, \'small-3 columns\':!searchArboTextualCtrl.isNewSearchBar}" ng-click="searchArboTextualCtrl.divSelected(\'searchByCategories\')"><md-input-container ng-class=" {\'input-container newcategorySearch\':searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.nissanUserURL, \'input-container\':!searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.nissanUserURL, \'input-container nissannewcategorySearch\':searchArboTextualCtrl.nissanUserURL}"><!-- <label>{{searchArboTextualCtrl.filterTypes[0].label}}</label> --><md-select md-container-class="my-container newSearch_Dropdown" ng-class="{\'nissanmenu\': searchArboTextualCtrl.nissanUserURL}" ng-if="searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation" name=newSearchFilter id={{field.label}} ng-model=searchArboTextualCtrl.newSearchFilter ng-change=searchArboTextualCtrl.changeFilter(searchArboTextualCtrl.newSearchFilter) ng-model-options="{trackBy: \'$value.id\'}" class="selectCategoryStyle selectBoxz"><md-option ng-class="{\'md-nissan-theme\':searchArboTextualCtrl.nissanUserURL}" ng-value=filter ng-if=mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes | onlyMRandMDandPR">{{filter.label | translate}}</md-option><md-option ng-value=filter ng-if="!mainCtrl.isCountryKorea && !searchArboTextualCtrl.contextCarBrandCheck" ng-class="{\'nissanOptionFocus\': searchArboTextualCtrl.nissanUserURL, \'renaultOptionFocus\': !searchArboTextualCtrl.nissanUserURL}" ng-repeat="filter in searchArboTextualCtrl.filterTypes">{{filter.label | translate}}</md-option><md-option ng-value=filter ng-if=searchArboTextualCtrl.contextCarBrandCheck ng-repeat="filter in searchArboTextualCtrl.filterTypes | onlyTMandMRandMDandTMLIST">{{filter.label | translate}}</md-option></md-select><md-select md-container-class=my-container name=filterChoosen ng-if=!searchArboTextualCtrl.isNewSearchBar id={{field.label}} ng-model=searchArboTextualCtrl.filterChoosen ng-change="" ng-model-options="{trackBy: \'$value.id\'}" class=selectStyle><md-option ng-value=filter ng-if=mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes | onlyMRandMDandPR">{{filter.label | translate}}</md-option><md-option ng-value=filter ng-if=!mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes">{{filter.label | translate}}</md-option></md-select></md-input-container><div ng-if=filter.label ng-click="filter.label = null;"><md-button class=btnClose>X</md-button></div></div><div id=keyWord ng-class=" {\'small-8 columns type_keyWord\':searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.nissanUserURL, \'small-8 columns typeKeyword_ref\': !searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.nissanUserURL, \'small-8 columns nissan_type_keyWord\':searchArboTextualCtrl.nissanUserURL}" ng-if="!searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showSpecializedToolView"><md-input-container class="input-container hide-validation-error border-bottom-new" ng-if=searchArboTextualCtrl.isNewSearchBar><input ng-init=searchArboTextualCtrl.setFocus() id=newSearchMotCle ng-model-options="{ debounce: 100 }" class=inputNormal ng-class=" {\'carSearchFormCell\': searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == false, \'inputResetItalique\' : searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == undefined,\'newinputReset\': !searchArboTextualCtrl.nissanUserURL, \'nissanInputReset\': searchArboTextualCtrl.nissanUserURL}" type=text name=motCle ng-model=searchArboTextualCtrl.motCle placeholder="{{ (searchArboTextualCtrl.newSearchFilter.id != \'TM_LIST\') ? (\'CAR_SEARCH_EXAMPLE_OF_KEY_WORD_NEW\' | translate) : (\'CAR_SEARCH_EXAMPLE_OF_TM_LIST\' | translate)}}" ng-focus="searchArboTextualCtrl.switchState(\'motCle\', true)" ng-blur="searchArboTextualCtrl.switchState(\'motCle\', false)" ng-change=searchArboTextualCtrl.onChangeMotCle() ng-keypress=searchArboTextualCtrl.onKeyPressed($event) autocomplete=off></md-input-container><md-input-container class="input-container hide-validation-error border-bottom" ng-if=!searchArboTextualCtrl.isNewSearchBar><input id=oldSearchMotCle ng-model-options="{ debounce: 100 }" ng-class=" {\'carSearchFormCell\': searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == false, \'inputResetItalique\' : searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == undefined}" type=text name=motCle ng-model=searchArboTextualCtrl.motCle placeholder="{{ (searchArboTextualCtrl.filterChoosen.id != \'TM_LIST\') ? (\'CAR_SEARCH_EXAMPLE_OF_KEY_WORD\' | translate) : (\'CAR_SEARCH_EXAMPLE_OF_TM_LIST\' | translate)}}" ng-focus="searchArboTextualCtrl.switchState(\'motCle\', true)" ng-blur="searchArboTextualCtrl.switchState(\'motCle\', false)" ng-change=searchArboTextualCtrl.onChangeMotCle() ng-keypress=searchArboTextualCtrl.onKeyPressed($event)></md-input-container><div ng-click=searchArboTextualCtrl.reinitSearch() ng-class="{\'newSearchReset reset_Search\':searchArboTextualCtrl.isNewSearchBar, \'reset resetSearch\':!searchArboTextualCtrl.isNewSearchBar}" ng-show=searchArboTextualCtrl.motCle><i class=icon-icons_close></i></div><div class=loupeArbo style="left: 1%; position: relative;" ng-click=searchArboTextualCtrl.searchNodebyRef(true) id=newSearchbtn ng-if=searchArboTextualCtrl.isNewSearchBar><md-button ng-class="{\'nissan-search-button\': searchArboTextualCtrl.nissanUserURL}"><i class="clickable fa fa-search position-relative" style="bottom:15%; right:3%;"></i></md-button></div><div class=loupeArbo ng-click=searchArboTextualCtrl.searchNodebyRef() ng-if=!searchArboTextualCtrl.isNewSearchBar><md-button><i class=icon-icons_search_arbo></i></md-button></div></div><div id=keyWord class="small-8 columns" ng-if="searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !$root.WDerror"><form ng-init=searchArboTextualCtrl.setFocus()><md-autocomplete style="width: 700px" ng-focus=searchArboTextualCtrl.displayComponentData() md-no-cache=true md-min-length=3 id={{component}} md-items="component in searchArboTextualCtrl.sharedWdPartHarnessAndWiringDataComponentsAndSignals | filter:component.label" md-search-text=component.label md-item-text=component.label md-selected-item-change=searchArboTextualCtrl.displayComponentCodeAndLabel(component) md-menu-class="{{searchArboTextualCtrl.nissanUserURL ? \'nissanUsers\' : \'renaultUsers\'}}" placeholder="{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_COMPONENT_LABEL\' | translate}}, {{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL_LABEL\' | translate}}"><span md-highlight-text=searchText>{{component.id}} - {{component.label}}</span></md-autocomplete></form><div class="reset resetSearch ng-hide" ng-click=searchArboTextualCtrl.reinitSearch() style="align-self: right" ng-show=searchArboTextualCtrl.componentCodeAndLabel role=button tabindex=0 aria-hidden=true><i class=icon-icons_close></i></div></div></div><div class="small-12 large-10 columns" ng-if=searchArboTextualCtrl.checkIndependentUser><div ng-if=searchArboTextualCtrl.goToSearchResult class=btnBack ng-click=searchArboTextualCtrl.goToSearchEngine() style="color:white; float:left;"><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</div><div id=searchByCategories ng-if="!searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView  && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showDiagFilesView &&!searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showGeometryApplicabilities &&(searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin))" ng-class=" {\'small-3 columns categories\':searchArboTextualCtrl.isNewSearchBar, \'small-3 columns\':!searchArboTextualCtrl.isNewSearchBar}" ng-click="searchArboTextualCtrl.divSelected(\'searchByCategories\')"><md-input-container ng-class=" {\'input-container newcategorySearch\':searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.nissanUserURL, \'input-container\':!searchArboTextualCtrl.isNewSearchBar, \'nissannewcategorySearch\': searchArboTextualCtrl.nissanUserURL}"><!-- <label>{{searchArboTextualCtrl.filterTypes[0].label}}</label> --><md-select md-container-class="my-container newSearch_Dropdown" ng-class="{\'nissanmenu\': searchArboTextualCtrl.nissanUserURL}" ng-if="searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation" name=newSearchFilter id={{field.label}} ng-model=searchArboTextualCtrl.newSearchFilter ng-change="" ng-model-options="{trackBy: \'$value.id\'}" class="selectCategoryStyle selectBoxz"><md-option ng-value=filter ng-if=mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes | onlyMRandMDandPR">{{filter.label}}</md-option><md-option ng-value=filter ng-if=!mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes">{{filter.label}}</md-option></md-select><md-select md-container-class=my-container name=filterChoosen ng-if=!searchArboTextualCtrl.isNewSearchBar id={{field.label}} ng-model=searchArboTextualCtrl.filterChoosen ng-change="" ng-model-options="{trackBy: \'$value.id\'}" class=selectStyle><md-option ng-value=filter ng-if=mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes | onlyMRandMDandPR">{{filter.label}}</md-option><md-option ng-value=filter ng-if=!mainCtrl.isCountryKorea ng-repeat="filter in searchArboTextualCtrl.filterTypes">{{filter.label}}</md-option></md-select></md-input-container><div ng-if=filter.label ng-click="filter.label = null;"><md-button class=btnClose>X</md-button></div></div><div id=keyWord ng-class=" {\'small-8 columns type_keyWord\':searchArboTextualCtrl.isNewSearchBar, \'small-8 columns typeKeyword_ref\':!searchArboTextualCtrl.isNewSearchBar}" ng-if="!searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showSpecializedToolView&& (searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin))"><md-input-container class="input-container hide-validation-error border-bottom-new" ng-if="searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showSpecializedToolView"><input ng-init=searchArboTextualCtrl.setFocus() id=motCleInde ng-model-options="{ debounce: 100 }" class="newinputReset inputNormal" ng-class=" {\'carSearchFormCell\': searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == false, \'inputResetItalique\' : searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == undefined}" type=text name=motCle ng-model=searchArboTextualCtrl.motCle placeholder="{{ (searchArboTextualCtrl.newSearchFilter.id != \'TM_LIST\') ? (\'CAR_SEARCH_EXAMPLE_OF_KEY_WORD_NEW\' | translate) : (\'CAR_SEARCH_EXAMPLE_OF_TM_LIST\' | translate)}}" ng-focus="searchArboTextualCtrl.switchState(\'motCle\', true)" ng-blur="searchArboTextualCtrl.switchState(\'motCle\', false)" ng-change=searchArboTextualCtrl.onChangeMotCle() ng-keypress=searchArboTextualCtrl.onKeyPressed($event)></md-input-container><md-input-container class="input-container hide-validation-error border-bottom" ng-if=!searchArboTextualCtrl.isNewSearchBar><input id=oldSearchMotCleInde ng-model-options="{ debounce: 100 }" ng-class=" {\'carSearchFormCell\': searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == false, \'inputResetItalique\' : searchArboTextualCtrl.stateInputsForm[\'motCle\'].active == undefined}" type=text name=motCle ng-model=searchArboTextualCtrl.motCle placeholder="{{ (searchArboTextualCtrl.filterChoosen.id != \'TM_LIST\') ? (\'CAR_SEARCH_EXAMPLE_OF_KEY_WORD\' | translate) : (\'CAR_SEARCH_EXAMPLE_OF_TM_LIST\' | translate)}}" ng-focus="searchArboTextualCtrl.switchState(\'motCle\', true)" ng-blur="searchArboTextualCtrl.switchState(\'motCle\', false)" ng-change=searchArboTextualCtrl.onChangeMotCle() ng-keypress=searchArboTextualCtrl.onKeyPressed($event)></md-input-container><div ng-click=searchArboTextualCtrl.reinitSearch() ng-class="{\'newSearchReset reset_Search\':searchArboTextualCtrl.isNewSearchBar, \'reset resetSearch\':!searchArboTextualCtrl.isNewSearchBar}" ng-show=searchArboTextualCtrl.motCle><i class=icon-icons_close></i></div><div class=loupeArbo style="left: 1%; position: relative;" ng-click=searchArboTextualCtrl.searchNodebyRef() id=newSearchbtn ng-if="searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showSpecializedToolView&& (searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin))"><md-button><i class="clickable fa fa-search position-relative" style="bottom:15%; right:3%;"></i></md-button></div><div class=loupeArbo ng-click=searchArboTextualCtrl.searchNodebyRef() ng-if=!searchArboTextualCtrl.isNewSearchBar><md-button><i class=icon-icons_search_arbo></i></md-button></div></div><div id=keyWord class="small-8 columns" ng-if="searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation &&(searchArboTextualCtrl.isAsomValidDocAccess===\'true\'||(searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin)) && !SearchElectricalSchemaController.hideTree  && !$root.WDerror"><form ng-init=searchArboTextualCtrl.setFocus()><md-autocomplete style="width: 700px" ng-focus=searchArboTextualCtrl.displayComponentData() md-no-cache=true md-min-length=3 id={{component}} md-items="component in searchArboTextualCtrl.sharedWdPartHarnessAndWiringDataComponentsAndSignals | filter:component.label" md-search-text=component.label md-item-text=component.label md-selected-item-change=searchArboTextualCtrl.displayComponentCodeAndLabel(component) md-menu-class="{{searchArboTextualCtrl.nissanUserURL ? \'nissanUsers\' : \'renaultUsers\'}}" placeholder="{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_COMPONENT_LABEL\' | translate}}, {{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL_LABEL\' | translate}}"><span md-highlight-text=searchText>{{component.id}} - {{component.label}}</span></md-autocomplete></form><div class="reset resetSearch ng-hide" ng-click=searchArboTextualCtrl.reinitSearch() style="align-self: right" ng-show=searchArboTextualCtrl.componentCodeAndLabel role=button tabindex=0 aria-hidden=true><i class=icon-icons_close></i></div></div></div></div><div id=rLinkCarView class="medium-9 columns" ng-if="searchArboTextualCtrl.showVehicleMultimediaInformation && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showGeometryApplicabilities && searchArboTextualCtrl.isRLinkHeader"><div class=medium-12><div id=rLinkCarDiagnosis ng-if=searchArboTextualCtrl.showVehicleMultimediaInformation><div class=showVehicleMultimediaInformation style="display: block !important;"><rlink-header></rlink-header></div></div></div></div><div id=line_recherche class="small-1 medium-1 large-1 columns" ng-if="!searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showVehicleMultimediaInformation">&nbsp;</div><!-- Bouton "Historique des documents consult\xE9s" \xE0 garder pour plus tard\n\n                    <div id="diagnostic" class="medium-1 small-18 columns">\n                    <div ng-if="!SearchResultCtrl.hideDocsVisited" class="actionIcon">\n                        <i class="icon-icons_recent_doc inactif"></i>\n                    </div>\n                </div> --></div><div class=diagnosis-container ng-if="searchArboTextualCtrl.showDiagFilesView || searchArboTextualCtrl.showDiagnosticView"><!--====================================\n                =         VDH VIEW              =\n                =====================================--><div ng-if=searchArboTextualCtrl.showDiagFilesView><diag-files-by-vin vin=searchArboTextualCtrl.vin></diag-files-by-vin></div><!--====================================\n                =         DIAGNOSTIC VIEW              =\n                =====================================--><div id=diagnosticView ng-if=searchArboTextualCtrl.showDiagnosticView><search-by-diagnostic my-attr=false></search-by-diagnostic></div></div><div ng-if=searchArboTextualCtrl.showVehicleMultimediaInformation><r-link-car my-attr=false></r-link-car></div><div ng-if=searchArboTextualCtrl.showSpecializedToolView><search-specialized-tool my-attr=false></search-specialized-tool></div><div ng-if=searchArboTextualCtrl.showconsultElectricalShema><search-electrical-schema my-attr=false nodes=searchArboTextualCtrl.electricalSchemaNodesId nissanurl=searchArboTextualCtrl.nissanUserURL></search-electrical-schema></div><div ng-if=searchArboTextualCtrl.showGeometryApplicabilities><axle-geometry applicabilities=searchArboTextualCtrl.axleGeometry></axle-geometry></div><div id=autoComplete class="small-12 columns autoCompleteList" ng-if=searchArboTextualCtrl.showAutocomplete><div class="small-6 columns"></div><div class="small-6 columns"><ul class=autoPopulateDropdown><li ng-repeat="item in searchArboTextualCtrl.autocompleteList" md-highlight-text=searchArboTextualCtrl.motCle md-highlight-flags=gi ng-click=searchArboTextualCtrl.getItemfromAutocomplete(item) ng-class="{\'renaultDropDown\': !searchArboTextualCtrl.nissanUserURL, \'nissanDropDown\': searchArboTextualCtrl.nissanUserURL}">{{item.label}}</li></ul></div></div><div id=ArborescenceHeader class="row headerArbo" ng-hide=searchArboTextualCtrl.showNoContent ng-if=searchArboTextualCtrl.showArboView><!--====================================\n                =              LIST OF NODE 1          =\n                =====================================--><div class="medium-3 small-12 columns"><div ng-if=searchArboTextualCtrl.checkIndependentUser><div ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin)"><div id={{node.nodeId}} class=line_menu1 ng-class="{\'inactive\':node.disabled}" ng-repeat="node in searchArboTextualCtrl.dataArboLevelOne.nodes"><div class=iconeEclate ng-class="{\'iconeEclateSelect\': $index == searchArboTextualCtrl.nodeSelect}"><div class=icone_menu_1 ng-click="searchArboTextualCtrl.goToLevelTwoAndThreeAndShowImage(node, $index)"><i ng-if="node.urlExplodedView && node.urlExplodedView.length" class=icon-icons_exploded_view_1></i></div></div><div class=line_menu1_label ng-class="{\'line_menu1_labelSelect_renault\': ( $index == searchArboTextualCtrl.nodeSelect)}" ng-click="searchArboTextualCtrl.goToLevelTwoAndThreeWithoutShowImageFirst(node, $index, false)"><div class=label_menu_1><label ng-class="{\'renaultColorFont\': ( $index == searchArboTextualCtrl.nodeSelect)}">{{node.label}}</label></div></div></div></div></div><div ng-if=!searchArboTextualCtrl.checkIndependentUser><div id={{node.nodeId}} class=line_menu1 ng-class="{\'labelRenault\': !searchArboTextualCtrl.nissanUserURL,\'labelNissan\' : searchArboTextualCtrl.nissanUserURL}" ng-repeat="node in searchArboTextualCtrl.dataArboLevelOne.nodes" ng-if="!mainCtrl.isHorseUser || (mainCtrl.isHorseUser && searchArboTextualCtrl.checkNode2HorseUser(node.nodeId))"><div class=iconeEclate ng-class="{\'iconeEclateSelect_renault\': ( $index == searchArboTextualCtrl.nodeSelect) && !searchArboTextualCtrl.nissanUserURL,\'iconeEclateSelect_nissan\' : ($index == searchArboTextualCtrl.nodeSelect) && searchArboTextualCtrl.nissanUserURL}"><div class=icone_menu_1 ng-click="searchArboTextualCtrl.goToLevelTwoAndThreeAndShowImage(node, $index)"><i ng-if="node.urlExplodedView && node.urlExplodedView.length" class=icon-icons_exploded_view_1></i></div></div><div class=line_menu1_label ng-class="{\'line_menu1_labelSelect_renault\': ( $index == searchArboTextualCtrl.nodeSelect) && !searchArboTextualCtrl.nissanUserURL,\'line_menu1_labelSelect_nissan\' : ($index == searchArboTextualCtrl.nodeSelect) && searchArboTextualCtrl.nissanUserURL}" ng-click="searchArboTextualCtrl.goToLevelTwoAndThreeWithoutShowImageFirst(node, $index, false)"><div class=label_menu_1><label ng-class="{\'renaultColorFont\': ( $index ==  searchArboTextualCtrl.nodeSelect) && !searchArboTextualCtrl.nissanUserURL}">{{node.label}}</label></div></div></div></div></div><div class="medium-9 small-12 columns" id=level2and3Cont><div id=line_resultat_level2_and_3><!--====================================\n                        =               TRIGGER SVG            =\n                        =====================================--><div class=row ng-if="!searchArboTextualCtrl.checkIndependentUser  "><div ng-class="{\'noYellowrow\':searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation, \'svgTrigger\':!searchArboTextualCtrl.isNewSearchBar}"><button ng-if=searchArboTextualCtrl.selectedLevel1.urlExplodedView type=button class=btnShowExplodedView ng-class="{ \'nissanHover\': searchArboTextualCtrl.nissanUserURL }" ng-style="{\'background-color\': searchArboTextualCtrl.nissanUserURL ? \'#FF8E8F\' : \'\' }" ng-click=searchArboTextualCtrl.showExplodedViewFunction()><div class=iconEx><i class=icon-icons_exploded_view_1></i></div><div><div class=btnTextShowExplodedView ng-if=!searchArboTextualCtrl.showExplodedView>{{\'CAR_SHOW_ECLATE\' | translate}}</div><div class=btnTextShowExplodedView ng-if=searchArboTextualCtrl.showExplodedView>{{\'CAR_HIDE_ECLATE\' | translate}}</div></div></button></div></div><div ng-if="searchArboTextualCtrl.checkIndependentUser "><div class=row ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin)"><div ng-class="{\'noYellowrow\':searchArboTextualCtrl.isNewSearchBar && !searchArboTextualCtrl.showDiagnosticView && !searchArboTextualCtrl.showSpecializedToolView && !searchArboTextualCtrl.showconsultElectricalShema && !searchArboTextualCtrl.showVehicleMultimediaInformation, \'svgTrigger\':!searchArboTextualCtrl.isNewSearchBar}"><button ng-if=searchArboTextualCtrl.selectedLevel1.urlExplodedView type=button class="btnShowExplodedView btnShowRenault" ng-class="{ \'nissanHover\': searchArboTextualCtrl.nissanUserURL }" ng-click=searchArboTextualCtrl.showExplodedViewFunction()><div class=iconEx><i class=icon-icons_exploded_view_1></i></div><div><div class=btnTextShowExplodedView ng-if=!searchArboTextualCtrl.showExplodedView>{{\'CAR_SHOW_ECLATE\' | translate}}</div><div class=btnTextShowExplodedView ng-if=searchArboTextualCtrl.showExplodedView>{{\'CAR_HIDE_ECLATE\' | translate}}</div></div></button></div></div></div><!--====================================\n                        =                 SVG                  =\n                        =====================================--><div ng-if="searchArboTextualCtrl.showExplodedView && searchArboTextualCtrl.svg" class=row><div resize-pr container=explodedView style="margin-top: 10px; left: 10%;"><phenix-svg app-svg=searchArboTextualCtrl.svg dir=svg-to-node></phenix-svg></div></div><!--=====================================\n                        =         BACK TO TOP BUTTON            =\n                        ======================================--><div ng-class=searchArboTextualCtrl.scrollToTopButtonClass ng-if=searchArboTextualCtrl.scrolled id=btnBackTop ng-click=searchArboTextualCtrl.scrollToTop()><i class=icon-icons_scroll_to_top_phx></i></div><!--=====================================\n                        =      RESULT OF CLICK ON NODE 1        =\n                        ======================================--><div class=searchNavResult ng-if=!searchArboTextualCtrl.checkIndependentUser ng-class="{\'renaultHightlight\': !searchArboTextualCtrl.nissanUserURL, \'nissanHighlight\': searchArboTextualCtrl.nissanUserURL}"><div class=level2and3><!-- table --><div class="row row-level" ng-repeat="node2 in searchArboTextualCtrl.level2" id=_{{node2.node.rang}}><!-- images --><div class="columns container-10" ng-if=!searchArboTextualCtrl.showSearchRef><img class=CarSearchVignette ng-src={{searchArboTextualCtrl.appendCloudFrontParams(node2.node.urlVignette)}} ng-if=node2.node.urlVignette alt=""> <label ng-if=!node2.node.urlVignette>&nbsp;</label></div><!-- blocs nodes 2 et 3 --><div class="columns container-90 paddind-left-0"><!-- node 2 --><div class=linkPiece2 ng-class="{\'phnx-disable\': !(node2.node.documents), \'level2Scrolled\':(node2.node.nodeId ===searchArboTextualCtrl.targetNode.nodeId)}"><a ng-if=node2.node.documents ng-class="{separator: node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess && !searchArboTextualCtrl.nissanUserURL}" ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, null, node2.node)">{{$index+1}}. {{node2.node.label}} </a><a ng-class="{separator:node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess && !searchArboTextualCtrl.nissanUserURL}" style=cursor:default!important;color:#bfbfbf!important ng-if=!node2.node.documents>{{$index+1}}.&nbsp;{{node2.node.label}}</a> <span class=intervention ng-if="node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess && !searchArboTextualCtrl.nissanUserURL" ng-click="searchArboTextualCtrl.checkInterventions(node2.node.label,node2.node.idsDocumentsByType.INT_REPAIR,node2.node.nodeId, searchArboTextualCtrl.nodeSelect, true)"><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""><md-tooltip>{{\'INTERVENTIONS_NEW\' |translate}}</md-tooltip></span></div><!-- node 3 --><div class=row><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[0]"><div class=icone_right ng-if="node3.nodeId !== \'N-TIRES\'"><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}" alt=""> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div class=icone_right ng-if="node3.nodeId === \'N-TIRES\'"><img ng-if="!searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if="searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && !searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif width=24px alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif style="filter: hue-rotate(300deg);"></div><div ng-if="node3.nodeId !== \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div><div ng-if="node3.nodeId === \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if="!searchArboTextualCtrl.tiresResponse || (searchArboTextualCtrl.tiresResponse && !node3.documents)">{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if="searchArboTextualCtrl.tiresResponse && node3.documents">{{node3.label}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[1]"><div class=icone_right ng-if="node3.nodeId !== \'N-TIRES\'"><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div class=icone_right ng-if="node3.nodeId === \'N-TIRES\'"><img ng-if="!searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if="searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && !searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif width=24px alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif style="filter: hue-rotate(300deg);"></div><div ng-if="node3.nodeId !== \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div><div ng-if="node3.nodeId === \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if="!searchArboTextualCtrl.tiresResponse || (searchArboTextualCtrl.tiresResponse && !node3.documents)">{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if="searchArboTextualCtrl.tiresResponse && node3.documents">{{node3.label}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[2]"><div class=icone_right ng-if="node3.nodeId !== \'N-TIRES\'"><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div class=icone_right ng-if="node3.nodeId === \'N-TIRES\'"><img ng-if="!searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if="searchArboTextualCtrl.nissanUserURL && searchArboTextualCtrl.tiresResponse" src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && !searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif width=24px alt=""> <img ng-if="!searchArboTextualCtrl.tiresResponse && searchArboTextualCtrl.nissanUserURL" src=../assets/images/newHourGlassGrey.gif style="filter: hue-rotate(300deg);"></div><div ng-if="node3.nodeId !== \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div><div ng-if="node3.nodeId === \'N-TIRES\'"><a class="linkPiece3 phnx-disable" ng-if="!searchArboTextualCtrl.tiresResponse || (searchArboTextualCtrl.tiresResponse && !node3.documents)">{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if="searchArboTextualCtrl.tiresResponse && node3.documents">{{node3.label}}</a></div></div></div></div></div></div></div></div><div ng-if="searchArboTextualCtrl.checkIndependentUser  "><div class=searchNavResult ng-if="searchArboTextualCtrl.isAsomValidDocAccess===\'true\' || (searchArboTextualCtrl.isAsomValidDocAccess===\'false\' && searchArboTextualCtrl.isCirSentVin)"><div class=level2and3><!-- table --><div class="row row-level" ng-repeat="node2 in searchArboTextualCtrl.level2" id=_{{node2.node.rang}}><!-- images --><div class="columns container-10" ng-if=!searchArboTextualCtrl.showSearchRef><img class=CarSearchVignette ng-src={{searchArboTextualCtrl.appendCloudFrontParams(node2.node.urlVignette)}} ng-if=node2.node.urlVignette alt=""> <label ng-if=!node2.node.urlVignette>&nbsp;</label></div><!-- blocs nodes 2 et 3 --><div class="columns container-90 paddind-left-0"><!-- node 2 --><div class=linkPiece2 ng-class="{\'phnx-disable\': !(node2.node.documents), \'level2Scrolled\':(node2.node.nodeId ===searchArboTextualCtrl.targetNode.nodeId)}"><a ng-if=node2.node.documents ng-class="{separator: node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess}" ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, null, node2.node)">{{$index+1}}. {{node2.node.label}} </a><a ng-class="{separator:node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess && !searchArboTextualCtrl.nissanUserURL}" style=cursor:default!important;color:#bfbfbf ng-if=!node2.node.documents>{{$index+1}}.&nbsp;{{node2.node.label}}</a> <span class=intervention ng-if="node2.node.interventionPresent && searchArboTextualCtrl.isInterventionAccess && !searchArboTextualCtrl.nissanUserURL" ng-click=searchArboTextualCtrl.checkInterventions(node2.node.label,node2.node.idsDocumentsByType.INT_REPAIR,node2.node.nodeId,true)><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""><md-tooltip>{{\'INTERVENTIONS_NEW\' |translate}}</md-tooltip></span></div><!-- node 3 --><div class=row><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[0]"><div class=icone_right><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[1]"><div class=icone_right><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="node3 in node2.arrays[2]"><div class=icone_right><img ng-if=!searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" ng-class="{\'greyDotCircle\' : node3.documents, \'nodeDisableGreyDot\': !node3.documents}"> <img ng-if=searchArboTextualCtrl.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable" ng-if=!node3.documents>{{node3.label}}</a> <a class=linkPiece3 ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node, node3, node3)" ng-if=node3.documents>{{node3.label}}</a></div></div></div></div></div></div></div></div></div><!--  &lt;!&ndash;Filter search Result!&ndash;&gt;\n            <div ng-if="searchArboTextualCtrl.showSearchRef">\n              <div class="filterSearchResult" ng-repeat="item in searchArboTextualCtrl.resultRef">\n                <div class="level2Ref" ng-repeat="node in item.node2" ng-class="{\'level2follows\' : !$last}">\n                  &lt;!&ndash;Level 3&ndash;&gt;\n                  <a ng-class="{\'phnx-disable\': !(node2.node.documents)}" class="linkPiece2"\n                  ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(node2.node,node2.node,item.node1)">{{node2.node.label}}</a>\n                  &lt;!&ndash;Level3&ndash;&gt;\n                  <div class="row">\n                    <div class="small-4 columns">\n                      <div class="row" ng-repeat="childNode in node2.arrays[0]">\n                        <div class="icone_right">\n                          <img src="./assets/svg/icons_arrow_right.svg" height="10" width="10"/>\n                        </div>\n                        <div>\n                          <a class="linkPiece3Search"\n                            ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(childNode,node2.node,item.node1)"\n                          ng-class="{\'phnx-disable\': !(childNode.documents)}">{{childNode.label}}</a>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="small-4 columns">\n                      <div class="row" ng-repeat="childNode in node2.arrays[1]">\n                        <div class="icone_right">\n                          <img src="./assets/svg/icons_arrow_right.svg" height="10" width="10"/>\n                        </div>\n                        <div>\n                          <a class="linkPiece3Search"\n                            ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(childNode,node2.node)"\n                          ng-class="{\'phnx-disable\': !(childNode.documents)}">{{childNode.label}}</a>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="small-4 columns">\n                      <div class="row" ng-repeat="childNode in node2.arrays[2]">\n                        <div class="icone_right">\n                          <img src="./assets/svg/icons_arrow_right.svg" height="10" width="10"/>\n                        </div>\n                        <div>\n                          <a class="linkPiece3Search"\n                            ng-click="searchArboTextualCtrl.VarAppBeforeGoToListePiece(childNode,node2.node)"\n                          ng-class="{\'phnx-disable\': !(childNode.documents)}">{{childNode.label}}</a>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>--></div></div></div></div><div ng-if=!searchArboTextualCtrl.showContent style="text-align: center; border: 5px solid red; padding: 5px;">{{\'ASOM_DOC_ACCESS\' | translate}}</div><div ng-if="(!(searchArboTextualCtrl.isRLink1Vehicle || searchArboTextualCtrl.isRLink2Vehicle || cSearchResultCtrl.isEasyLinkVehicle) && (cSearchResultCtrl.isUnknownVehicle || cSearchResultCtrl.isnullVehicle)) && (searchArboTextualCtrl.isMitsubishiUser)" style="text-align: center; border: 5px solid red; padding: 5px;">{{\'MITSUBISHI_ACCESS\' | translate}}</div><nd-chatbot ng-if="cSearchResultCtrl.isNDAssistantEnabled && searchArboTextualCtrl.showArboView"></nd-chatbot></div></div>');
$templateCache.put('app/components/car/carSearchResult/carSearchResultNoCarContext.template.html','<div id=carSearchMain><div class=recapCarNoContext><div id=recapCarInformationsNoContext><div class=vehicleDetails><div ng-if=vm.vin>{{vm.vin}}</div><div ng-if=vm.immat>{{vm.immat}}</div><div ng-if=vm.carDetails>{{vm.carDetails}}</div><div ng-if="vm.kilometers > 0 "><i class=icon-icons_kilometer></i> {{vm.kilometers}}</div><div ng-if=vm.orderNumber><i class=icon-icons_repair ng-if=vm.orderNumber></i> {{vm.orderNumber}}</div><div><i class=icon-icons_people ng-if=vm.clientDetails></i> {{vm.clientDetails}}</div></div></div><div class=changeVehicle><button class="btnChangerVehicle buttonWithIcon" ng-class="{\'renaultBackgroundColor\': !vm.nissanUserURL, \'nissanBackgroundColor\': vm.nissanUserURL}" id=carContextButton ng-click=vm.reinitContext()><div class=iconDiv><i class=icon-icons_vehicle style="margin-right: 0;"></i></div><div class=btnText style="padding-left: 0;">{{\'RECAPCAR_REINIT_LABEL\' | translate}}</div></button></div></div></div>');
$templateCache.put('app/components/car/questionning/questionning.html','<div id=questionning ng-controller="questionningCtrl as questionningCtrl"><div class=questionning-container><div class=questionning-container-title><h3>{{\'QUESTIONNING_TITLE\'| translate}}</h3><h1 class=questionning-container-mandatory>{{\'QUESTIONNING_MANDATORY\'| translate}}</h1></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_DATE\'| translate}}</div><div class="columns small-2 end"><input class=questionning-text type=text name=timeout ng-model="" ng-disabled="" placeholder=JJ/MM/AAAA required></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_NUMBER\'| translate}}</div><div class="columns small-2 end"><input class=questionning-text type=text name="" ng-model="" ng-disabled="" placeholder="7 caract\xE8res" required></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_PHASE\'| translate}}</div><div class="columns small-3 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner une phase" value=object:600>{{\'QUESTIONNING_SELECT\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_MARKING\'| translate}}</div><div class="columns small-3 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner un marquage" value=object:600>{{\'QUESTIONNING_SELECT_MARKING\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_LEVEL\'| translate}}</div><div class="columns small-4 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner un niveau d\'\xE9quipement" value=object:601>{{\'QUESTIONNING_SELECT_LEVEL\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_RCAR\'| translate}}</div><div class="columns small-4 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner une adaptation" value=object:602>{{\'QUESTIONNING_SELECT_RCAR\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_PACK\'| translate}}</div><div class="columns small-4 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner un pack" value=object:603>{{\'QUESTIONNING_SELECT_PACK\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_PEDESTRIAN\'| translate}}</div><div class="columns small-3 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner une norme" value=object:604>{{\'QUESTIONNING_SELECT_PEDESTRIAN\'| translate}}</option><option label="EURO2 - Norme Euro2" value=object:605>{{\'QUESTIONNING_EURO2\'| translate}}</option><option label="EURO3 - Norme Euro3" value=object:606>{{\'QUESTIONNING_EURO3\'| translate}}</option><option label="EURO4 - Norme Euro4" value=object:607>{{\'QUESTIONNING_EURO4\'| translate}}</option><option label="EURO5 - Norme Euro5" value=object:608>{{\'QUESTIONNING_EURO5\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_DECONTAMINATION\'| translate}}</div><div class="columns small-3 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner une norme" value=object:605>{{\'QUESTIONNING_SELECT_PEDESTRIAN\'| translate}}</option></select></div></div></div><div class=row><div class="columns small-3">{{\'QUESTIONNING_NUMBER_OF_SEATS\'| translate}}</div><div class="columns small-5 end"><div class=custom-select><select class=inputReset ng-model=countryParams.firstLanguage ng-options="lg.label for lg in listDocumentation.firstLanguages"><option label="S\xE9lectionner un nombre de place" value=object:606>{{\'QUESTIONNING_SELECT_NUMBER_OF_SEATS\'| translate}}</option></select></div></div></div><div class=modalQuestionButtons><button type=button class="buttonWithIcon left" ng-click=questionningCtrl.goToListePiece()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'QUESTIONNING_VALIDATE\'| translate}}</div><button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons-phnx_back></i></div><div class=btnText>{{\'QUESTIONNING_CLOSE\'| translate}}</div></button></button></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/ddpAudit.template.html','<div class="block-accordion map-inventory-block"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.isAuditTabOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex>{{\'DDP_AUDIT\' | translate}}</div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div class=block_text style="padding: 20px;"><button class=buttonWithIcon style="letter-spacing: normal;padding: 10px;" ng-click=vm.exportLog()><div class=iconDiv><i class="fa fa-file-excel-o" style="font-size: 15px; padding-right: 2px;"></i></div><div class=btnText>{{\'EXPORT_LOG\' | translate}}</div></button></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/ddpUserGuide.html','<div ng-if=vm.isDdpHelpTab class=block-accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'USER_GUIDE\' | translate}}</span></div><div ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></div></div></accordion-heading><div style="display: flex; align-items: center; justify-content: flex-start; padding: 20px;"><i class="fa fa-file-pdf-o" aria-hidden=true style="font-size: 64px; font-weight: bold; margin-right: 15px; cursor: pointer;" ng-click=vm.goToUserGuidePage()></i></div><div style="padding-left: 18px; font-size: var(--renaultMediumFont);"><span>{{\'USER_GUIDE\' | translate}}</span></div></accordion-group></accordion></div><div ng-if=vm.isDdpGenericDiagTab><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'GENERIC_DIAGNOSIS\' | translate}}</span></div><div ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></div></div></accordion-heading><div style="display: flex; align-items: center; justify-content: flex-start; padding: 20px;"><i class="fa fa-file-pdf-o" aria-hidden=true style="font-size: 64px; font-weight: bold; margin-right: 15px; cursor: pointer;" ng-click=vm.goToGenericDiagnosisPage()></i></div><div style="padding-left: 18px; font-size: var(--renaultMediumFont);"><span>{{\'GENERIC_DIAGNOSIS\' | translate}}</span></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/rLinkCar.template.html','<div id=rLinkCarView class=wrapper><div id=multimedia_info_tabs class="medium-3 small-3 columns"><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo()><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header_connected ng-click="isOpen = !isOpen"><div><span class=labelStyle>{{\'CONNECTED_VEHICLE\'|translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':isOpen,\'icon-icons_exependable_moins float-right \':!isOpen}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="m in vm.menu"><li class=subCateg ng-class="{\'activeMenuTab\': m.show && !vm.nissanUserURL, \'nissanActiveMenuTab\':m.show && vm.nissanUserURL}" ng-click=vm.selectNode($index)>{{vm.translateMenu($index)}} <span style="float: right; margin-right: 2px;position: relative;bottom: 5px;" ng-if=" m.show && vm.loadingIcon || ( m.show && !vm.vehicleInformations.allDataloaded)"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="" ng-if=!vm.nissanUserURL> <img src=../assets/images/nissanHourGlass.gif width=24px alt="" ng-if=vm.nissanUserURL></span></li></div></div></accordion-group></accordion></div><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo() ng-hide="vm.nissanUserURL || (vm.user && vm.user.userType === \'ASOM\' && $root.asomDocList[\'CS\'])"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header_connected ng-click="isOpen = !isOpen"><div><span ng-if=!vm.isFodEnable class=labelStyle>{{\'CONNECTED_SERVICES_OFFERS\'|translate}}</span> <span ng-if=vm.isFodEnable class=labelStyle>{{\'FEATURES_ON_DEMAND\'|translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':isOpen,\'icon-icons_exependable_moins float-right \':!isOpen}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="menu in vm.connectedServiceOfferTab"><li class=subCateg ng-class="{\'activeMenuTab\': menu.show}" ng-click=vm.selectedSubMenu(menu)>{{menu.translate | translate}} <span style="float: right; margin-right: 2px;position: relative;bottom: 5px;" ng-if=" (menu.show && vm.loadingIcon ) || ( menu.show && !vm.vehicleInformations.allDataloaded) "><img src=../assets/images/primaryLoader.gif width=24px alt=""></span></li></div></div></accordion-group></accordion></div><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo() ng-hide=vm.isPpxLightUser><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.connectedInfoIsOpen><accordion-heading><div class=section_header_connected ng-click="vm.collapssed = !vm.collapssed"><div><span class=labelStyle>{{\'CONNECTED_SERVICES_MENU_INFO\'|translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':!vm.collapssed,\'icon-icons_exependable_moins float-right \':vm.collapssed}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="menu in vm.connectedInfoMenu" ng-class="{\n                            \'hideDiags\': \n                                (menu.name === \'diagnosis\' && vm.hideDiagnosisAcces) || \n                                (menu.name === \'connectedADASEhorizon\' && \n                                 (!vm.adasEhorizonInformationDisplay || !vm.isAdasTab)) || \n                                                                ((vm.connectedPlatform &&\n                                                                    (vm.connectedPlatform.architecture === \'CCS2\' || \n                                                                     vm.connectedPlatform.architecture === \'CCS3\')) && \n                                 menu.name === \'softAndApplications\') || \n                                (((menu.name === \'virtualKeyB2B\') || \n                                  (menu.name === \'virtualKeyB2C\')) && \n                                 ((!vm.isVirtualTab) || \n                                  (vm.user && (vm.user.userType !== \'ARCA\' && \n                                              vm.user.userType !== \'RNET\'))))\n                        }"><li class=subCateg ng-if="(menu.name !== \'virtualKeyB2C\' || vm.isVirtualKeyB2C) &&\n                            (menu.name !== \'virtualKeyB2B\' || vm.isVirtualKeyB2B) &&\n                            (menu.name !== \'remoteServices\' || (vm.isRemoteServicesEnabled)) &&\n                            (menu.name !== \'hereNavigation\' || vm.hereTabActivated) &&\n                            (menu.name !== \'softAndApplications\' || vm.vehicleInformations.headUnitInformation.radnavSystemType.mtcCriteria !== \'RA47D\')" ng-class="{\'activeMenuTab\': menu.show && !vm.nissanUserURL, \'nissanActiveMenuTab\':menu.show && vm.nissanUserURL}" ng-click=vm.selectedSubMenu(menu) ng-keydown="$event.key === \'Enter\' && vm.selectedSubMenu(menu)">{{ (menu.name !== \'virtualKeyB2C\' && menu.name !== \'virtualKeyB2B\' && menu.name !== \'remoteServices\') ? vm.translateMenuNew($index, menu) : menu.track }} <span style="float: right; margin-right: 2px;position: relative;bottom: 5px;" ng-if=" (menu.show && vm.loadingIcon ) || ( menu.show && !vm.vehicleInformations.allDataloaded) "><img src=../assets/images/newHourGlassGrey.gif width=24px alt="" ng-if=!vm.nissanUserURL> <img src=../assets/images/nissanHourGlass.gif width=24px alt="" ng-if=vm.nissanUserURL></span></li></div></div></accordion-group></accordion></div><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo() ng-if=vm.evServicesTab ng-hide=vm.isPpxLightUser><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header_connected ng-click="isOpen = !isOpen"><div><span class=labelStyle>{{\'EV_SERVICES\' | translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':isOpen,\'icon-icons_exependable_moins float-right \':!isOpen}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="menu in vm.evServicesMenu" ng-if="menu.name !== \'evSettings\' || vm.displaySettings"><li class=subCateg ng-class="{\'activeMenuTab\': menu.show && !vm.nissanUserURL, \'nissanActiveMenuTab\':menu.show && vm.nissanUserURL}" ng-click=vm.selectedSubMenu(menu)><span ng-if=!menu.dynamicLabel>{{menu.translate | translate}}</span> <span ng-if=menu.dynamicLabel>{{menu.dynamicLabel}}</span> <span style="float: right; margin-right: 2px;position: relative;bottom: 5px;" ng-if=" (menu.show && vm.loadingIcon) || (menu.show && !vm.vehicleInformations.allDataloaded)"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="" ng-if=!vm.nissanUserURL> <img src=../assets/images/nissanHourGlass.gif width=24px alt="" ng-if=vm.nissanUserURL></span></li></div></div></accordion-group></accordion></div><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo() ng-if=vm.showAudit ng-hide=vm.isPpxLightUser><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header_connected ng-click="isOpen = !isOpen"><div><span class=labelStyle>{{\'HEADER_ADMINISTRATION\' | translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':isOpen,\'icon-icons_exependable_moins float-right \':!isOpen}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="menu in vm.showAdminMenu"><li class=subCateg ng-class="{\'activeMenuTab\': menu.show && !vm.nissanUserURL, \'nissanActiveMenuTab\':menu.show && vm.nissanUserURL}" ng-click=vm.selectedSubMenu(menu)>{{menu.translate | translate}}</li></div></div></accordion-group></accordion></div><div style="width: 90%;" id=multimedia_info_display class=block-accordion ng-click=vm.selectConnectInfo() ng-if="vm.showUserGuide && (vm.ddpHelpTabDisplay || (vm.user.userType === \'ASOM\' && $root.asomDocList[\'CS\']))"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header_connected ng-click="isOpen = !isOpen"><div><span class=labelStyle>{{\'HELP\'|translate}}</span></div><div><i ng-class="{\'icon-icons_expendable_plus float-right\':isOpen,\'icon-icons_exependable_moins float-right \':!isOpen}"></i></div></div></accordion-heading><div class=card-body><div class=menu-divider ng-repeat="menu in vm.helpDdpMenu"><li class=subCateg ng-class="{\'activeMenuTab\': menu.show && !vm.nissanUserURL, \'nissanActiveMenuTab\':menu.show && vm.nissanUserURL}" ng-click=vm.selectedSubMenu(menu)>{{menu.translate | translate}} <span style="float: right; margin-right: 2px;position: relative;bottom: 5px;" ng-if=" (menu.show && vm.loadingIcon) || ( menu.show && !vm.vehicleInformations.allDataloaded)"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="" ng-if=!vm.nissanUserURL> <img src=../assets/images/nissanHourGlass.gif width=24px alt="" ng-if=vm.nissanUserURL></span></li></div></div></accordion-group></accordion></div></div><div ng-show="!vm.isEasyLink && vm.oldRlinkTabs" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && !vm.isEasyLink && vm.oldRlinkTabs) ||\n             (vm.showLoaderIcon && !vm.isEasyLink && vm.oldRlinkTabs)" ng-hide=vm.isPpxLightUser><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><here-navigation vehicle=vm.vehicleInformations service-applicable=vm.hereNavigationSelected ng-if="vm.hereNavigationSelected && vm.vehicleInformations.allDataloaded" ng-show=vm.hereNavigationSelected></here-navigation><soft-and-applications ng-if="vm.vehicleInformations.allDataloaded && vm.vehicleInformations.isMapDataLoaded" ng-show="vm.connectedInfoMenu[1].show && vm.connectedInfoMenu[1].name === \'softAndApplications\' && !vm.connectedInfoMenu[1].isNew && vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present" data=vm.vehicleInformations.mapInformations></soft-and-applications></div><div ng-show="!vm.isEasyLink && vm.newRlinkTabs && !vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && !vm.isEasyLink && vm.newRlinkTabs) || (vm.showLoaderIcon && !vm.isEasyLink && vm.newRlinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><here-navigation vehicle=vm.vehicleInformations service-applicable=vm.hereNavigationSelected ng-if="vm.hereNavigationSelected && vm.vehicleInformations.allDataloaded" ng-show=vm.hereNavigationSelected></here-navigation><soft-and-applications ng-if="vm.vehicleInformations.allDataloaded && vm.vehicleInformations.isMapDataLoaded" ng-show="vm.connectedInfoMenu[1].show && vm.connectedInfoMenu[1].name === \'softAndApplications\' && !vm.connectedInfoMenu[1].isNew && vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present" data=vm.vehicleInformations.mapInformations></soft-and-applications><ddp-audit ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.showAdminMenu[1].show></ddp-audit></div><div ng-show="vm.isEasyLink && vm.oldEasyLinkTabs && !vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && vm.isEasyLink && vm.oldEasyLinkTabs) || (vm.showLoaderIcon && vm.isEasyLink && vm.oldEasyLinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><soft-and-applications ng-if="vm.vehicleInformations.allDataloaded && vm.vehicleInformations.isMapDataLoaded" ng-show="vm.connectedInfoMenu[2].show && vm.connectedInfoMenu[2].name === \'softAndApplications\' && !vm.connectedInfoMenu.isNew && vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present" data=vm.vehicleInformations.mapInformations></soft-and-applications><update-campaigns ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.connectedInfoMenu[1].show && vm.connectedInfoMenu[1].name === \'updateCampaigns\' && !vm.connectedInfoMenu[1].isNew" data=vm.updateCampaigns vehicle=vm.vehicleInformations></update-campaigns><plug-and-charge ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.selectedMenu && vm.selectedMenu.show && vm.selectedMenu.name !== \'chargeHistory\'" data=vm.easyLinkResponse ev-services-tab=vm.evServicesTab></plug-and-charge><here-navigation vehicle=vm.vehicleInformations service-applicable=vm.hereNavigationSelected ng-if="vm.hereNavigationSelected && vm.vehicleInformations.allDataloaded" ng-show=vm.hereNavigationSelected></here-navigation><virtual-key ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.connectedInfoMenu[4].show ||vm.connectedInfoMenu[5].show" data=vm.easyLinkResponse is-virtual-tab=vm.isVirtualTab></virtual-key><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div><div ng-show="vm.isEasyLink && vm.newVegasEasyLinkTabs && !vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && vm.isEasyLink && vm.newVegasEasyLinkTabs) || (vm.showLoaderIcon && vm.isEasyLink && vm.newVegasEasyLinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><div ng-if="vm.isCnrUserGuide && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html\'"></div><soft-and-applications ng-if="vm.vehicleInformations.allDataloaded && vm.vehicleInformations.isMapDataLoaded" ng-show="vm.connectedInfoMenu[2].show && vm.connectedInfoMenu[2].name === \'softAndApplications\' && !vm.connectedInfoMenu.isNew && vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present" data=vm.vehicleInformations.mapInformations></soft-and-applications><update-campaigns ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.connectedInfoMenu[1].show && vm.connectedInfoMenu[1].name === \'updateCampaigns\' && !vm.connectedInfoMenu[1].isNew" data=vm.updateCampaigns vehicle=vm.vehicleInformations></update-campaigns><plug-and-charge ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.selectedMenu && vm.selectedMenu.show && vm.selectedMenu.name !== \'chargeHistory\'" data=vm.easyLinkResponse ev-services-tab=vm.evServicesTab></plug-and-charge><here-navigation vehicle=vm.vehicleInformations service-applicable=vm.hereNavigationSelected ng-if="vm.hereNavigationSelected && vm.vehicleInformations.allDataloaded" ng-show=vm.hereNavigationSelected></here-navigation><ddp-audit ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.showAdminMenu[1].show></ddp-audit><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div><div ng-show="vm.isEasyLink && vm.newEasyLinkTabs && !vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && vm.isEasyLink && vm.newEasyLinkTabs) || (vm.showLoaderIcon && vm.isEasyLink && vm.newEasyLinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.menu[2].show && vm.vehicleInformations.allDataloaded" data=vm.subscriptionAndServices></contracts-and-services><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><div ng-if="vm.isCnrUserGuide && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html\'"></div><div ng-if="vm.isDataConsistency && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/dataConsistencies/dataConsistencies.template.html\'"></div><soft-and-applications ng-if="vm.vehicleInformations.allDataloaded && vm.vehicleInformations.isMapDataLoaded" ng-show="vm.connectedInfoMenu[2].show && vm.connectedInfoMenu[2].name === \'softAndApplications\' && !vm.connectedInfoMenu.isNew && vm.vehicleInformations && vm.vehicleInformations.headUnitInformation && vm.vehicleInformations.headUnitInformation.present" data=vm.vehicleInformations.mapInformations></soft-and-applications><update-campaigns ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.connectedInfoMenu[1].show && vm.connectedInfoMenu[1].name === \'updateCampaigns\' && !vm.connectedInfoMenu[1].isNew" data=vm.updateCampaigns vehicle=vm.vehicleInformations></update-campaigns><remote-services ng-if="vm.connectedInfoMenu[7].show && vm.connectedInfoMenu[7].name === \'remoteServices\' && vm.isRemoteServicesEnabled && vm.vehicleInformations.allDataloaded"></remote-services><here-navigation vehicle=vm.vehicleInformations service-applicable=vm.hereNavigationSelected ng-if="vm.hereNavigationSelected && vm.vehicleInformations.allDataloaded" ng-show=vm.hereNavigationSelected></here-navigation><div ng-if="vm.isAdasEhorizon && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/softAndApplications/easyLink/adasAndEhorizon.html\'"></div><plug-and-charge ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.selectedMenu && vm.selectedMenu.show && vm.selectedMenu.name !== \'chargeHistory\'" data=vm.easyLinkResponse ev-services-tab=vm.evServicesTab></plug-and-charge><ddp-audit ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.showAdminMenu[1].show></ddp-audit><virtual-key ng-if=vm.vehicleInformations.allDataloaded ng-show="vm.connectedInfoMenu[5].show || vm.connectedInfoMenu[6].show" data=vm.easyLinkResponse is-virtual-tab=vm.isVirtualTab></virtual-key><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div><div ng-show="!vm.isEasyLink && vm.newRlinkTabs && vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && !vm.isEasyLink && vm.newRlinkTabs) || (vm.showLoaderIcon && !vm.isEasyLink && vm.newRlinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><div ng-if="vm.isCnrUserGuide && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html\'"></div><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div><div ng-show="vm.isEasyLink && vm.newVegasEasyLinkTabs && vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && vm.isEasyLink && vm.newVegasEasyLinkTabs) || (vm.showLoaderIcon && vm.isEasyLink && vm.newVegasEasyLinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><div ng-if="vm.isCnrUserGuide && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html\'"></div><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div><div ng-show="vm.isEasyLink && vm.newEasyLinkTabs && vm.isPpxLightUser" id=multimedia_info_display class="small-9 medium-9 columns" ng-if="(!vm.showLoaderIcon && vm.vehicleInformations.allDataloaded && vm.isEasyLink && vm.newEasyLinkTabs) || (vm.showLoaderIcon && vm.isEasyLink && vm.newEasyLinkTabs)"><vehicle-informations ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[1].show vehicle=vm.vehicleInformations sim-info=vm.connectionStatus refresh-privacy-data=vm.refreshPrivacyData show-battery-inhibition=vm.showBatteryInhibition inhibition-status=vm.inhibitionStatus inhibition-last-update-date-time=vm.inhibitionLastUpdateDateTime></vehicle-informations><contracts-and-services ng-if=vm.vehicleInformations.allDataloaded ng-show=vm.menu[2].show data=vm.subscriptionAndServices></contracts-and-services><div ng-if="vm.isDataConsistency && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/dataConsistencies/dataConsistencies.template.html\'"></div><connected-services-offers loader=vm.loadingIcon ng-show=vm.connectedServiceOfferTab[1].show></connected-services-offers><div ng-if="vm.isCnrUserGuide && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html\'"></div><div ng-if="vm.helpDdpMenu && vm.vehicleInformations.allDataloaded" ng-include src="\'app/components/car/rLinkCar/ddpUserGuide.html\'"></div></div></div>');
$templateCache.put('app/components/car/recapCar/lightFilteringModal.template.html','<md-dialog id=modalOnLightFiltering><div class=modalLightFilter><div class="small-12 column title" style="font-weight: bold">{{\'LIGHT_FILTERING_RESET_POPUP\' | translate}}</div></div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onValidate() ng-class="{ \'nissanValidateBtn\': vm.nissanUserURL }"><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel() ng-class="{ \'nissanCancelBtn\': vm.nissanUserURL }"><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></md-dialog>');
$templateCache.put('app/components/car/recapCar/recapCar.html','<div class=recapCar><div ng-class="{\'infoVehicle\': vm.showBtnInitContext }" id=blockResumeVehicle><div ng-if=vm.imageUrl class=image id=imageRecapCar ng-style="{\'background-image\':\'url({{vm.imageUrl}})\'}"></div><div id=recapCarInformations><div class=format><span ng-if="(!vm.isSearchByModel && !vm.checkIndependentUser && !vm.showTechCritTab) || (!vm.isSearchByModel && vm.checkIndependentUser && vm.isAsomValidDocAccess == \'true\' && !vm.showTechCritTab)" class=vehicleModel ng-click="!vm.isWd && vm.goToCarFeatures()" ng-bind-html=vm.carDetailModel ng-class="{\'phnx-disable\': !(vm.isLinkCarFeatures && vm.carDetailVin) || vm.isMitsubishiUser || vm.isWd, \'phnx-disable-ppxlight\': vm.isPpxLightUser  }"></span> <span ng-if=vm.showTechCritTab class=showTechTab ng-bind-html=vm.carDetailModel></span> <span ng-if="!vm.isSearchByModel && vm.checkIndependentUser && vm.isAsomValidDocAccess == \'false\' && !vm.showTechCritTab" class=vehicleModel ng-click="!vm.isWd && vm.goToCarFeatures()" ng-bind-html=vm.carDetailModel ng-class="{\'phnx-disable\': (!(vm.isLinkCarFeatures && vm.carDetailVin)) || (!vm.isCirSentVin && (vm.userProfiles.accountType != \'Automobile repairer\')) }"></span> <span ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.nissanUserURL || vm.isWd" class=ots ng-if="!vm.isSearchByModel && vm.otsAvailable && vm.icons && !vm.showTechCritTab && vm.hasAsomOTSTabAccess" ng-click=vm.redirectToOts()><i class="danger fa fa-exclamation-triangle" style=font-size:var(--renaultExtraLargeFont);color:red;height:16px;width:16px></i> <i class="otsTop fa fa-exclamation-triangle" title="{{\'OTS_AVAILABLE\' | translate}}" style="font-size:var(--renaultExtraLargeFont);color:hsl(0deg 95% 35%);height:16px;width:16px"></i> </span><span ng-if="vm.hasCareAlert && !vm.showTechCritTab" class=careAlertText ng-keypress=vm.openCareAlert() ng-click=vm.openCareAlert()><img class=careAlertIcon alt=careAlertIcon src=./assets/svg/careAlert.svg height=16 width=18> </span><span class=tooltip-container style="position: relative;" ng-mouseover="showTooltip = true" ng-mouseleave="showTooltip = false" ng-if=vm.hasStandardExchange><img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img><div ng-show=showTooltip class=custom-tooltip style="position: absolute; left: 30px; top: 20px;"><!-- {{\'STD_EXCHANGE_TOOLTIP\' | translate}} --> Standard Exchange mounted on this VIN : <span ng-if=vm.hasAPVNM2>{{\'VEHICLE_ENGINE_TYPE\' | translate}}</span> <span ng-if="vm.hasAPVNM2 && (vm.hasAPVNM3 || vm.hasAPVNM4)">/ </span><span ng-if=vm.hasAPVNM3>{{\'VEHICLE_GEARBOX\' | translate}}</span> <span ng-if="vm.hasAPVNM3 && vm.hasAPVNM4">/ </span><span ng-if=vm.hasAPVNM4>{{\'BTLIST_HEADER_BATTERY\' | translate}}</span></div></span><span class=tooltip-container style="position: relative; left: 13px;" ng-if="vm.showMaintenanceIcon && !vm.showTechCritTab && !vm.isSearchByModel" ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.nissanUserURL || vm.isWd" ng-mouseover="showTooltip = true" ng-mouseleave="showTooltip = false"><img src=./assets/images/calendar_schedule.svg height=23 width=23 style="cursor: pointer;" ng-click=vm.redirectToMaintenance(true)><div ng-show=showTooltip class=custom-tooltip>{{vm.maintenanceTooltip | translate}}</div></span><span class=tooltip-container style="position: relative; left: 13px;" ng-if="vm.hasEligibleOffers && vm.hasDealerRole() && !vm.showTechCritTab" ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.nissanUserURL || vm.isWd" ng-mouseover="showTooltip = true" ng-mouseleave="showTooltip = false"><img src=./assets/images/connectedVehicleBlack.svg height=23 width=23 style="cursor: pointer;" ng-click=vm.redirectToEligibleOffers(true)><div ng-show=showTooltip class=custom-tooltip>{{\'CNR_POPUP_TEXT\' | translate}}</div></span><span class=ots ng-if=vm.isInfoFicEnabled ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.nissanUserURL || vm.isWd" ng-click=vm.loadInfoSection()><img class=logoDisplay src=./assets/images/infoFic.png width=25 style="top: 5px !important; margin-left: 10%;"> <i class=otsTop title="{{\'INFO_FIC_MSG\' | translate}}" style="font-size:var(--renaultExtraLargeFont);color:hsl(0deg 95% 35%);height:16px;width:16px"></i> </span><span ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.nissanUserURL || vm.isWd" ng-if="vm.proactiveAlert && !vm.showTechCritTab" class=ots ng-click=vm.redirectToAlertDiag(true) data-dtname="Click on alerts TdB"><img class=logoDisplay src=./assets/images/brake.svg width=25 style="top: 6px !important; margin-left: 10%;" data-dtname="Click on alerts TdB"> <i class=otsTop title="{{\'ONE_ALERT_MSG\' | translate}}" style="font-size:var(--renaultExtraLargeFont);color:hsl(0deg 95% 35%);height:16px;width:16px" data-dtname="Click on alerts TdB"></i> </span><span ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.isWd" style=padding-left:5px; class=ots ng-if="!vm.isSearchByModel && !vm.checkIndependentUser && vm.isLightFiltering  && vm.icons && !vm.showTechCritTab" ng-click=vm.reloadTree()><img class=logoDisplay src=./assets/images/filter_reset.png width=20 height=20 ng-style="{\'background-color\': !vm.nissanUserURL ? $root.renaultPrimaryColor :\'#ff8e8f\'}" style="margin-left: 5px;"> <i class=otsTop title="{{\'RESET_LIGHT_FILTERING\' | translate}}" style="font-size:var(--renaultExtraLargeFont);color:hsl(0deg 95% 35%);height:16px;width:16px"></i> </span><span ng-hide="vm.isMitsubishiUser || vm.isPpxLightUser || vm.isWd" class=showTechCrit ng-if="(!vm.isSearchByModel && (!vm.checkIndependentUser || (vm.checkIndependentUser && vm.hasAsomTechCriTabAccess)) && !vm.showTechCritTab)"><i class=icon-icons_pop_out title="{{\'OPEN_TECHNICAL_CRIT\' | translate}}" ng-click=vm.redirectToTechnicalCriteria()></i></span></div><div class=phnx-model-info ng-if=vm.isSearchByModel>{{vm.carDetailModel}}<div ng-if=!vm.checktm class=phnx-clickable3 ng-click=vm.goToSearchByModel()><i class=icon-icons_change></i> {{\'RECAPCAR_UPDATE_MODEL\' | translate}}</div></div><div class=vehicleDetails><div ng-if=vm.isSearchByModel>{{vm.carComplementaryInformations.join(\' / \')}}</div><div ng-if=vm.carDetailVin>{{vm.carDetailVin}}</div><div ng-if=!vm.checktm><div ng-if="vm.carDetailKilometers && vm.carDetailKilometers > 0 "><i class=icon-icons_kilometer></i>{{vm.carDetailKilometers}}</div><div ng-if=vm.clientDetailsPoBoxNumber><i class=icon-icons_repair ng-if=vm.clientDetailsPoBoxNumber></i>{{vm.clientDetailsPoBoxNumber}}</div><div><i class=icon-icons_people ng-if=vm.clientDetails></i> <a ng-if=vm.clientDetails class=phnx-clickable2 ng-click=vm.goToInfoClient() ng-bind-html=vm.clientDetails ng-class="{\'phnx-disable\': !(vm.clientDetails),\'user-edit-disable\': vm.userEditDisable}"></a></div></div><!--  <div\n                    ng-bind-html="vm.clientDetailsPoBoxNumber"\n                    ng-class="{\'phnx-disable\': !(vm.clientDetailsPoBoxNumber)}"\n                    ng-if="vm.clientDetailsPoBoxNumber">\n                    <i class="icon-icons_kilometer" ng-if="vm.clientDetailsPoBoxNumber"></i>\n                </div>\n            --></div></div></div><div class=changeVehicle ng-if="!vm.checktm && !vm.showTechCritTab && !vm.isWd"><button ng-if=vm.showBtnInitContext class="btnChangerVehicle buttonWithIcon" ng-class="{\'renaultBackgroundColor\': !vm.nissanUserURL, \'nissanBackgroundColor\': vm.nissanUserURL}" id=carContextButton ng-click=vm.reinitContext()><div class=iconDiv><i class=icon-icons_vehicle style="margin-right: 0;"></i></div><div class=btnText style="padding-left: 0;">{{\'RECAPCAR_REINIT_LABEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/car/searchArboTextual/showOtsDesignation.template.html','<div class=actions style="position: absolute; right:5px;cursor: pointer;font-size: var(--renaultMediumFont);\nfont-family: var(--renaultFontBold);" ng-click=vm.onOtsDialogClose()>{{"MODAL_CLOSE"|translate}}&nbsp; <i class="fa fa-close"></i></div><div style="padding: 20px;line-height: 45px;margin: 10px;"><div class=ots_header style="font-family: var(--renaultFontBold);">{{"OTS_INTERVENTION_HEADER"|translate}}</div><div class=ots_header style="font-family: var(--renaultFontBold);">{{"OTS_INTERVENTION_MESSAGE"|translate}}</div><!-- <div class="ots_designation" style="font-weight: bold;" ng-repeat="value in vm.otsData">{{value.designation}} </div> --><div class=ots_content style="font-family: var(--renaultFontRegular);">{{"OTS_INTERVENTION_CONTENT"|translate}}</div><!-- <div class="ots_redirect" ng-hide="!$root.asomDocList.OTS">{{"OTS_MORE_DETAILS"|translate}} <a style="text-decoration: underline;" ng-click="vm.redirectToOts()">{{"OTS_REDIRECT_LINK"|translate}}</a></div> --></div>');
$templateCache.put('app/components/car/features/features.template.html','<recap-car api=vm.recapCarAPI icons=true id=newTechCritTab class=newTechCritTab></recap-car><div id=carFeatures class=carFeatures><div ng-class="{\'carFeaturesNissanMenu\': vm.nissanUserURL, \'carFeaturesRenaultMenu\': !vm.nissanUserURL}"><div ng-if="vm.isIndependentUser && (vm.showSubscriptionAccessMessage || !vm.isAsomValidAllTechCritAccess())" style="text-align: center; \n                    border: 5px solid red; \n                    padding: 5px;\n                    margin-bottom: 20px; \n                    margin-top: 20px;">{{\'ASOM_DOC_ACCESS\' | translate}}</div><div class=infoNode ng-hide="(vm.isIndependentUser && !vm.isAsomValidAllTechCritAccess()) || vm.isOpenTechCritTab()"><div class=btnBack ng-click=vm.goToBack()><i class=icon-icons-phnx_back></i> {{\'PRODUCT_PREVIOUS\'|translate}}</div></div><div style="margin-top: 10px;" ng-if=vm.showTechCritTab></div><tabset style="position: relative;"><!--Technical Criteria--><tab heading="{{\'VEHICLE_DETAIL_TAB_DATA_SHEET\' |translate}}" ng-click=vm.selectTab(vm.featureTabs.technicalCriteriaTab) active="vm.activeTab === vm.featureTabs.technicalCriteriaTab" ng-if=!vm.isHideCarTechnical()><car-technical-criteria is-car-context-changed=vm.isCarContextChanged is-light-filter-changed=vm.isLightFilterChanged show-tech-crit-tab=vm.showTechCritTab></car-technical-criteria></tab><!--OTS--><tab heading="{{\'VEHICLE_DETAIL_TAB_OTS\' |translate}}" ng-click=vm.selectTab(vm.featureTabs.otsTab) active="vm.activeTab === vm.featureTabs.otsTab" ng-if="!(vm.isHideOTS() || vm.nissanUserURL)"><car-ots></car-ots></tab><!--MAINTENANCE PROGRAM--><tab heading="{{\'VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM\' |translate}}" ng-click=vm.selectTab(vm.featureTabs.maintenanceProgramTab) active="vm.activeTab === vm.featureTabs.maintenanceProgramTab" ng-if="!(vm.isHideMaintenanceProgram() || vm.nissanUserURL)"><car-maintenance-program></car-maintenance-program></tab><!--Vehicle Maintenance History--><tab heading="{{\'VEHICLE_MAINTENANCE_HISTORY\' | translate}}" ng-click=vm.selectTab(vm.featureTabs.vehicleMaintenanceHistoryTab) active="vm.activeTab === vm.featureTabs.vehicleMaintenanceHistoryTab" ng-if="!(vm.isHideMaintenanceHistoryProgram() || vm.nissanUserURL)"><vehicle-maintenance-history></vehicle-maintenance-history></tab></tabset></div><scroll-up ng-if=!vm.showTechCritTab scroll-trigger=300 scroll-anchor=#carFeatures></scroll-up><scroll-up ng-if=vm.showTechCritTab scroll-trigger=300 scroll-anchor=newTechCritTab></scroll-up><!-- SCROLL TOP BUTTON --><!-- <div ng-class="vm.scrollToTopButtonClass" ng-if="vm.scrolled" Id="btnBackTop" ng-click="vm.scrollToTop()">\n        <i class="icon-icons_scroll_to_top_phx" style="background-color: blue;"></i>\n    </div> --></div>');
$templateCache.put('app/components/car/searchByDiagnostic/remoteBinSearchPopup.template.html','<div ng-if=!vm.enableRemoteListPopup id=remoteDiagPopUp class=modalPhenix style=height:220px;width:auto;font-family:var(--renaultFontRegular);><div class="small-12 columns" style="text-align: center;\n    padding: 5px;   font-weight: 700;">{{"BIN_DIAG_FILES_SEARCH" | translate}}</div><div class="small-9 columns" style=left:14%;top:5%;><md-input-container class=md-block style=margin:0px;><label for=bin class=fontStyle>BIN</label> <input ng-init=vm.initVinFocus() ng-model=vm.bin class=inputAngular type=text name=bin maxlength=18 phenix-enter=search() id=bin><md-button ng-if=vm.bin ng-click="vm.bin = null" class="btn closePos" style="position: absolute; top: 0px; right: 0px;">X</md-button></md-input-container></div><div class="row row-button" style="height:auto;max-width: none;"><div class="small-12 columns text-center"><md-button ng-disabled="!vm.bin || vm.bin == \'\' || vm.bin.length < 17" class="md-raised buttonWithIcon" type=button ng-class="{\'clicked\':vm.searchClicked}" ng-click=search() style="width:auto; left:auto; top:auto;"><div class="iconDiv iconDiv-search-adjusted" style="font-size: var(--renaultMediumFont);"><i class=icon-icons-phnx_search></i></div><div class=btnText>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</div></md-button><md-button type=button class="md-raised cancel buttonWithIcon" ng-click=close() style="width:auto; left:auto; top:auto;height: auto;padding-bottom: 2px;"><div class=iconDiv style="font-size: var(--renaultMediumFont);"><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></md-button></div></div></div><div ng-if=vm.enableRemoteListPopup id=remoteDiagList class=popup-container style="margin: 1rem;width: 60rem;font-family: var(--renaultFontRegular);"><div><span style="text-align: center;display: block;font-family: var(--renaultFontBold);">{{\'LIST_OF_REMOTE_DIAG\' | translate}}</span> <span><em class="fa fa-close" ng-click=close() style="bottom: 2rem;position: relative;float: right;"></em></span></div><div><table style=border:none;><tr><th><u>{{\'YOUR_REMOTE\' | translate}}</u></th><th><u>{{\'DEALER_REMOTE\' | translate}}</u></th></tr><tr ng-if="getNumberArray().length === 0"><td colspan=2 class=no-data>{{\'NO_DATA\' | translate}}</td></tr><tr ng-repeat="i in getNumberArray() track by $index"><td ng-if="vm.ipnList && vm.ipnList.length === 0 && $index=== 0" class=no-data>{{\'NO_DATA\' | translate}}</td><td ng-if=vm.ipnList[$index]><span ng-click=onVinClick(vm.ipnList[$index].vin) style=cursor:pointer;>{{vm.ipnList[$index].vin}} </span><span>{{ vm.ipnList[$index].registrationNumber ? \'- \' + vm.ipnList[$index].registrationNumber : \'\' }} </span><i class="fa fa-calendar" style="padding: 0 0 0 0.5rem;"></i> {{vm.ipnList[$index].diagUpdatedDate}} <span ng-if=vm.ipnList[$index].diagStatus ng-style=getStatusColor(vm.ipnList[$index].diagStatus,true) ng-click="vm.ipnList[$index].diagStatus === \'FAILED\' && onRelaunch(vm.ipnList[$index])"><i class="fa fa-long-arrow-right" style=color:black;></i>{{ (\'STATUS_\' + vm.ipnList[$index].diagStatus) | translate }}</span></td><td ng-if="!vm.ipnList[$index] && $index > 0" class=no-data></td><td ng-if="vm.dealerList && vm.dealerList.length === 0 && $index=== 0" class=no-data>{{\'NO_DATA\' | translate}}</td><td ng-if=vm.dealerList[$index]><span ng-click=onVinClick(vm.dealerList[$index].vin) style=cursor:pointer;>{{vm.dealerList[$index].vin}} </span><span>{{ vm.ipnList[$index].registrationNumber ? \'- \' + vm.ipnList[$index].registrationNumber : \'\' }} </span><i class="fa fa-calendar" style="padding: 0 0 0 0.5rem;"></i> {{vm.dealerList[$index].diagUpdatedDate}} <span ng-if=vm.dealerList[$index].diagStatus ng-style=getStatusColor(vm.dealerList[$index].diagStatus,true) ng-click="vm.dealerList[$index].diagStatus === \'FAILED\' && onRelaunch(vm.dealerList[$index])"><i class="fa fa-long-arrow-right" style=color:black;></i>{{ (\'STATUS_\' + vm.dealerList[$index].diagStatus) | translate }}</span></td><td ng-if="!vm.dealerList[$index] && $index > 0" class=no-data></td></tr></table></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/remoteDiagnostic.template.html','<div id=remoteDiagPopUp class=modalPhenix ng-style="{\'height\':vm.repairOrderCheck ? \'480px\' : \'390px\'}"><div class="modalPhenix margin"><div class=row><div class=remoteDiagHeader>{{\'REMOTE_DIAG_INFO\'|translate}}</div><div class=infoMsg><div>{{\'REMOTE_DIAG_DESCRIPTION\' | translate }}</div><div style="padding-top: 3px;">{{\'REMOTE_DIAG_PREREQ\' | translate }}</div><div class=innerDiv><li>{{\'CAR_IGNITE\'| translate}}</li><div>{{\'REMOTE_DIAG_PARA\' | translate}}</div><li>{{\'ADT_PROBE\'| translate}}</li><div>{{\'ADT_PROBE_PARA\' | translate}}</div><div ng-if=vm.repairOrderCheck style="margin-top: 16px;"><div>{{\'PRIVACY_CHECK_LABEL\' | translate}}</div><md-checkbox ng-model=vm.checkBoxEnabled class=customerComplaint>{{\'CHECKBOX_MSG\'| translate}}</md-checkbox></div></div><div>{{\'CONTINUE_MSG\'| translate}}</div></div><div><button type=button class="buttonWithIcon left" ng-click=vm.onConfirm() ng-class="{\'checkBoxcancel\': !vm.checkBoxEnabled && vm.repairOrderCheck, \'checkBoxEnable\':vm.checkBoxEnabled}" ng-disabled="!vm.checkBoxEnabled && vm.repairOrderCheck"><div class=iconDiv><i class="icon-icons_validate icon-icons_validate-white"></i></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel checkBoxEnable" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div></div></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/searchByDiagnostic.template.html','<div ng-if="!vm.nissanUserURL && !vm.isIndependentUser" style="position: relative; margin-left: 40rem;display: inline;bottom: 50px"><button ng-click=vm.printMaintenance() ng-if="(vm.diagSearch[\'diagnosticFile\'].active || vm.diagSearch[\'binDiagnosticFile\'].active) && !vm.showDiagHelpContent" ng-disabled=!vm.selectedDiagFile ng-style="{\'background-color\': vm.selectedDiagFile ? $root.renaultPrimaryColor :\'#dadada\'}" style="padding: 4px 9px 4px 9px; height:2.25rem; margin-bottom: 0.65rem;width:10.3rem;font-family: var(--renaultFontRegular);"><span><i class="fa fa-file-text-o" style="border-right: 2px solid; padding-right: 0.3rem;margin-right: 0.3rem;"></i>{{\'HEALTH_CHECK\' | translate }}</span></button></div><div id=newDiagnostic ng-style="{\'margin-top\': (vm.typeMD === \'ADT\' && !vm.isIndependentUser && vm.diagSearch[\'diagnosticFile\'].active && !vm.showDiagHelpContent && !vm.nissanUserURL) ? \'-45px\': ((vm.nissanUserURL || vm.isIndependentUser) ? \'0px\' : \'-20px\')}" class="alignment margin-top-25" ng-if=!vm.diagCond><div class=card ng-if=!vm.diagCond><accordion class=collapse close-others=false ng-if="vm.typeMD != \'B2\' && vm.typeMD != \'B2-3\' && vm.loadSymptomSearch"><accordion-group is-open=vm.isOpenSystemDoc class=accord><accordion-heading><div class=row-one ng-class="{\'activeMenuTab\': vm.diagSearch[\'system\'].active,\'inactiveMenuTab\':!vm.diagSearch[\'system\'].active}" ng-click=vm.showSystem($event)><span>{{\'SYSTEM_DOCUMENTATION\' | translate}} </span><i class=icons ng-class="{\'icon-icons_expendable_plus float-right\':!vm.diagSearch[\'system\'].icon,\'icon-icons_exependable_moins float-right \':vm.diagSearch[\'system\'].icon}"></i></div></accordion-heading><div class="card-body systemDocContent"><li><input style="margin-bottom: 0px;" placeholder="{{\'SEARCH_SYSTEM_DOCUMENTATION\' | translate}}" ng-model=searchSystemDocument></li><div ng-repeat="menu in vm.systemDocSubMenu | filter: searchSystemDocument" style="margin-bottom: 0px;" class=systemDocMenu><li ng-class="{\'activeMenuTab\':menu.isActive && !vm.nissanUserURL,\'nissanActiveMenuTab\':menu.isActive && vm.nissanUserURL,\'subCateg\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}" ng-click=vm.showGenericInfo(menu) style="word-break: break-word;  width: 215px; padding-right:5px;">{{menu.code+" - "+menu.locale}}</li></div></div></accordion-group></accordion><accordion class=collapse ng-if="(vm.isArcaUser || vm.isDealerAvailable || (vm.isIndependentUser && $root.asomDocList[\'MD-REMOTE\'])) && !vm.binSearched" close-others=false><accordion-group is-open="(vm.isArcaUser || vm.isDealerAvailable || (vm.isIndependentUser && $root.asomDocList[\'MD-REMOTE\']))" class=accord ng-if=vm.connectedPlatformResp ng-click=vm.clickComp(true)><accordion-heading><div class="row-one remoteDiagHover"><span ng-if="vm.remoteDiagStatus !== \'IN_PROGRESS\'">{{\'REMOTE_DIAG\' | translate}} </span><span ng-if="vm.remoteDiagStatus === \'IN_PROGRESS\'">{{\'REFRESH_REMOTE_DIAG\' | translate}}</span> <span style="text-transform: capitalize;font-style:italic; font-size:var(--renaultSmallFont);" ng-if=vm.repairOrderCheck>{{\'RO_DIAG_LABEL\' | translate}}<md-tooltip md-direction=right style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 300px !important; white-space: normal;">{{\'PRIVACY_CHECK\'| translate}}</md-tooltip></span></div><div class="subCategConnect row"><div class="medium-3 column lastReq" style=width:auto;>{{\'LAST_REQ\' | translate}}:</div><div class="medium-9 column statusField" style=width:auto;>{{vm.diagUpdatedDate}}</div></div><div class="subCategConnect row" style="border-bottom: solid 0.5px;border-color: #dadada;"><div class="medium-3 column lastReq" style=width:auto;>{{\'ACTIS_GENERAL_STATUS\' | translate}}:</div><div class="medium-9 column statusField" ng-style=vm.getStatusColor(vm.remoteDiagStatus) style=width:auto;><span ng-if="vm.statusLoading && !vm.nissanUserURL"><img src=../assets/images/newHourGlassGrey.gif width=20px alt=""></span><img ng-if="vm.statusLoading && vm.nissanUserURL" src=../assets/images/newHourGlassGrey.gif width=24px alt=""> <span ng-if=!vm.statusLoading ng-style="{\'font-style\': !vm.remoteDiagStatus ? \'italic\' : \'\'}">{{vm.statusDisplay}}</span> <span ng-if="vm.remoteDiagStatus == \'FAILED\'"><i class="fa fa-info-circle" style="font-size: var(--renaultLargeFont); color: blue;padding-left: 55px;"></i><md-tooltip md-direction=right style="white-space: normal;">{{\'REMOTEDIAG_RELAUCH_TOOLTIP\' |translate}}</md-tooltip></span></div></div></accordion-heading></accordion-group><span style="position:relative;top:-4px; left:95px"><img src=../assets/images/newHourGlassGrey.gif ng-if="vm.isWheelLoading && !vm.nissanUserURL" width=24px alt=""> <img ng-if="vm.isWheelLoading && vm.nissanUserURL" src=../assets/images/newHourGlassGrey.gif width=24px alt=""></span></accordion><accordion ng-if="(vm.isDealerAvailable || (vm.isIndependentUser && $root.asomDocList[\'MD-REMOTE\'])) && !vm.nissanUserURL "><accordion-group class=accord><accordion-heading><div class="row-one remoteDiagHover" ng-class="{\'activeMenuTab\':vm.diagSearch[\'remoteList\'].active}" ng-click=vm.showRemoteList()>{{\'REMOTE_LIST\' | translate }}</div></accordion-heading></accordion-group></accordion><div ng-if="!vm.diagCond && vm.loadSymptomSearch"><accordion class=collapse close-others=false><accordion-group is-open=!vm.diagCond class=accord><accordion-heading><div class=row-one ng-class="{\'activeMenuTab\':vm.diagSearch[\'solution\'].active && !vm.showDiagHelpContent && !vm.diagSearch[\'diagnosticFile\'].active && !vm.nissanUserURL, \'inactiveMenuTab\':!vm.diagSearch[\'solution\'].active,\'nissanActiveMenuTab\':vm.diagSearch[\'solution\'].active && !vm.showDiagHelpContent && !vm.diagSearch[\'diagnosticFile\'].active && vm.nissanUserURL}" ng-click=vm.showSolution() ng-style="(!vm.diagCond && vm.hasTabAccess) && {\'border-right\':\'none\'}">{{\'DIAG_SOLUTION\' | translate}} <i class=icons ng-if="!vm.isSearchByModel && !vm.adtOtherRoles && (!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\']))" ng-class="{\'icon-icons_expendable_plus float-right\':!vm.diagSearch[\'solution\'].icon,\'icon-icons_exependable_moins float-right \':vm.diagSearch[\'solution\'].icon}"></i></div></accordion-heading><div class="card-body {{vm.nissanUserURL ? \'nissan-card-body\' : \'\'}}" ng-if="!vm.isSearchByModel && !vm.adtOtherRoles && (!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\']))"><div class=disableButton style=display:none;><li class=subCateg>{{\'DIAG_BT\' | translate}}</li></div><div class=disableButton style=display:none;><li class=subCateg>{{\'DTC_MD\' | translate}}</li></div><div class=disableButton style=display:none;><li class=subCateg>{{\'SYMPTOM_MD\' | translate}}</li></div><div ng-if="!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\'])"><li ng-click=vm.showdiagFile() ng-class="{\'activeMenuTab\':vm.diagSearch[\'diagnosticFile\'].active && !vm.showDiagHelpContent && !vm.nissanUserURL,\'nissanActiveMenuTab\':vm.diagSearch[\'diagnosticFile\'].active && !vm.showDiagHelpContent && vm.nissanUserURL,\'subCateg\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}">{{\'DIAGNOSTIC_FILE\' | translate}}</li></div><!--<div ng-if="!vm.isRnetUser && vm.typeMD != \'B2\' && vm.typeMD != \'B2-3\'">\n               <li class="subCateg" ng-click="vm.showDiagHelp()" ng-class="{\'activeMenuTab\':vm.showDiagHelpContent}">\n                   {{\'DIAGNOSTIC_HELP\' | translate}}\n                 </li> \n            </div> --><div ng-if="((vm.isRnetUser || vm.isArcaUser) && !vm.isIndependentUser && vm.carContext.bin && vm.carContext.bin != \'\' && !vm.nissanUserURL)"><li class=subCateg ng-click=vm.showBINDetails() ng-class="{\'activeMenuTab\':vm.showBINContent}" style="border-bottom: none;">{{\'BIN_DIAG_FILES\' | translate}}<div ng-if=vm.binSearched>{{vm.binVal}}</div><span ng-if=vm.binSearched ng-click=vm.clearBinDiagDetails() style="position: absolute; top: 10px; right: 20px;">X</span></li></div></div></accordion-group></accordion></div><div ng-if="(\n       (!vm.hasTabAccess && !vm.adtNoRoles) ||\n       (!vm.isSearchByModel && vm.batteryReuseCrashCheck) ||\n       (vm.reprogrammingHistoryCheck && !vm.isSearchByModel) ||\n       (!vm.isSearchByModel && vm.isIndependentUser &&\n        ($root.asomDocList[\'MD-DIAGFILES\'] || $root.asomDocList[\'MD-REPROG\']))\n     )" ng-hide="vm.nissanUserURL && !vm.isDisplayDiagForNissan"><accordion class=collapse close-others=false><accordion-group is-open=!vm.diagCond class=accord style="padding-bottom: 0px !important;"><accordion-heading><div class=row-one ng-class="{\'activeMenuTab\':vm.diagSearch[\'history\'].active,\'inactiveMenuTab\':!vm.diagSearch[\'history\'].active}" ng-click=vm.showHistory()>{{\'HISTORY_INFORMATION\' | translate}} <i class=icons ng-class="{\'icon-icons_expendable_plus float-right\':!vm.diagSearch[\'history\'].icon,\'icon-icons_exependable_moins float-right \':vm.diagSearch[\'history\'].icon}"></i></div></accordion-heading><div class=card-body><div ng-click=vm.showECU() ng-if="(vm.isArcaUser || vm.showDTCcompareRnet || vm.isDisplayDiagForNissan) || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\'])"><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'ecu\'].active  && !vm.nissanUserURL, \n                  \'nissanActiveMenuTab\':vm.nissanUserURL && vm.diagSearch[\'ecu\'].active, \'nissanRemoteHover\': vm.nissanUserURL}">{{\'DIAG_ECU\' | translate}}</li></div><div ng-click=vm.showNetwork() ng-if="(vm.isArcaUser || vm.showDTCcompareRnet || vm.isDisplayDiagForNissan) \n                || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\'])"><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'network\'].active  && !vm.nissanUserURL, \n                  \'nissanActiveMenuTab\':vm.nissanUserURL && vm.diagSearch[\'network\'].active, \'nissanRemoteHover\': vm.nissanUserURL}">{{\'NETWORK_DIAGNOSIS\' | translate}}</li></div><div ng-click=vm.showDtcHistory() ng-if="(vm.isArcaUser || vm.showDTCcompareRnet || vm.isDisplayDiagForNissan) || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\'])"><li class=subCateg ng-class="{\'activeMenuTab\' : vm.diagSearch[\'dtcHistory\'].active  && !vm.nissanUserURL, \n                  \'nissanActiveMenuTab\':vm.nissanUserURL && vm.diagSearch[\'dtcHistory\'].active, \'nissanRemoteHover\': vm.nissanUserURL}">{{\'DIAG_DTC\' | translate}}</li></div><div ng-click=vm.showDiagCompare() ng-if="((vm.isArcaUser) && (vm.typeMD != \'B2\' && vm.typeMD != \'B2-3\') || vm.showDTCcompareRnet || vm.isDisplayDiagForNissan) || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\'])"><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'diagCompare\'].active  && !vm.nissanUserURL, \n                  \'nissanActiveMenuTab\':vm.nissanUserURL && vm.diagSearch[\'diagCompare\'].active, \'nissanRemoteHover\': vm.nissanUserURL}">{{\'DTC_COMPARISON\' | translate }}</li></div><div ng-click=vm.showUserJourney() ng-if="((vm.isArcaUser || vm.adtTechrole) || (vm.isIndependentUser && $root.asomDocList[\'MD-REPROG\'])) && (vm.typeMD != \'B2\' && vm.typeMD != \'B2-3\')"><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'userjourney\'].active}">{{\'USER_JOURNEY\' | translate}}</li></div><div ng-click=vm.showReprogrammingHistory() ng-if="vm.reprogrammingHistoryCheck || (vm.isIndependentUser && $root.asomDocList[\'MD-REPROG\'])"><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'reprogrammingHistory\'].active}">{{\'REPROGRAMMING_HISTORY\' | translate}}</li></div><div ng-click=vm.showBatteryReuseCrash() ng-if=vm.batteryReuseCrashCheck><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'batteryReuseCrash\'].active}">{{\'LABEL_CRASH_HISTORY\' | translate}}</li></div></div></accordion-group></accordion><div><pagination-control dataper-page=vm.paginationData.dataPerPage load-pagination=vm.loadADTPagination ng-if=vm.isHistoryPagination page-change=vm.getPageData(page) current-page=vm.paginationData.currentPage total-count=vm.paginationData.totalCount is-last-page=vm.paginationData.isLastPage></pagination-control></div></div><!--ADT-Viewer-Tool--><accordion class=collapse ng-if="(vm.typeMD === \'ADT\' && (vm.isRnetUser || vm.isArcaUser || vm.isDisplayDiagForNissan)) && vm.showDTCcompareRnet"><accordion-group class=accord style="margin-top: 5%"><accordion-heading><div class=row-one ng-click=vm.gotoADT() style="display: flex; align-items: center; justify-content: space-between;word-break: break-all;"><span style="flex: 1;">{{\'ADT_VIEWER\' | translate}} </span><i class=icon-icons_arrow_right ng-class="vm.user.language === \'fr\'? \'adt_link_arrow\': \'adt_arrow\'" style="margin-left: 10px;"></i></div></accordion-heading></accordion-group></accordion><!--ADT-FeedBack Viewer-Tool--><accordion class=collapse ng-if="vm.typeMD === \'ADT\' && vm.adtTechrole && (vm.isRnetUser || vm.isArcaUser) && !vm.nissanUserURL"><accordion-group class=accord ng-style="(vm.isHistoryPagination) && {\'margin-top\':\'2%\'}"><accordion-heading><div class=row-one ng-click=vm.gotoADTFeedback()>{{\'ADT_FEEDBACK_VIEWER\' | translate}} <i class="icon-icons_arrow_right adt_feedback_arrow"></i></div></accordion-heading></accordion-group></accordion><accordion ng-if="vm.proactiveAlertCheck && !vm.isIndependentUser"><accordion-group class=accord style="padding-top: 5% !important;"><accordion-heading><div class=row-one ng-class="{\'activeMenuTab\':vm.diagSearch[\'alert\'].active  && !vm.nissanUserURL, \n                  \'nissanActiveMenuTab\':vm.nissanUserURL && vm.diagSearch[\'alert\'].active, \'nissanRemoteHover\': vm.nissanUserURL}" ng-click=vm.showAlerts() data-dtname="Click on alerts TdB">{{\'ALERTS_TAB\' | translate}} <i class="icon-icons_arrow_right alert_tab_arrow"></i></div></accordion-heading></accordion-group></accordion><div ng-if="!vm.nissanUserURL && !vm.isSearchByModel && !vm.adtOtherRoles && vm.typeMD != \'B2\' && vm.typeMD != \'B2-3\' && (!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-OCV\']))"><accordion class=collapse close-others=false><accordion-group is-open=!vm.diagCond class=accord ng-style="(vm.isHistoryPagination) && {\'margin-top\':\'3%\'}" ng-class="(vm.typeMD === \'ADT\' && vm.isRnetUser) ? \'nv-preparationTab\': \'nv_Tab\'"><accordion-heading><div class=row-one ng-class="{\'activeMenuTab\':vm.diagSearch[\'nvPreparation\'].active,\'inactiveMenuTab\':!vm.diagSearch[\'nvPreparation\'].active}" ng-click=vm.showNvPreparation()>{{\'NV_PREPARATION\' | translate}} <i class=icons ng-class="{\'icon-icons_expendable_plus float-right\':!vm.diagSearch[\'nvPreparation\'].icon,\'icon-icons_exependable_moins float-right \':vm.diagSearch[\'nvPreparation\'].icon}"></i></div></accordion-heading><div class="card-body {{vm.nissanUserURL ? \'nissan-card-body\' : \'\'}}"><div><li class=subCateg ng-class="{\'activeMenuTab\':vm.diagSearch[\'ocv\'].active}" ng-click=vm.showOCV() style="border-bottom: none;">{{\'OCV\' | translate}}</li></div></div></accordion-group></accordion></div></div><div class=diagnostic ng-if="(vm.diagSearch[\'diagnosticFile\'].active || vm.diagSearch[\'binDiagnosticFile\'].active) && !vm.isSearchByModel && !vm.adtOtherRoles && (!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\']))"><!-- use another active boolean variable  --><div id=rightMenu><form layout=row layout=row layout-align="start center"><accordion class=collapse style="width: 545px;" close-others=false><div class=textDataNotFound ng-if=!vm.diagDataFound><span ng-if="vm.typeMD === \'B2\' || vm.typeMD === \'B3\'">{{\'NO_RECORDED_DIAG_FILE_CLIP\' | translate}}</span> <span ng-if="vm.typeMD === \'ADT\'">{{\'NO_RECORDED_DIAG_FILE_ADT\' | translate}}</span> <span ng-if="vm.typeMD != \'B2\' && vm.typeMD != \'B3\' && vm.typeMD != \'ADT\'">{{\'NO_RECORDED_DIAG_FILE\' | translate}}</span></div><accordion-group class=accord is-open=$scope.isOpen ng-if=vm.diagDataFound><accordion-heading><div ng-model=$scope.collapssed id=diagFileSelected ng-class="{\'hightlightSel\':vm.selectedDiagFile && vm.isDiagFileDisplay && !vm.nissanUserURL,\'nissanActiveMenuTab\':vm.selectedDiagFile && vm.isDiagFileDisplay && vm.nissanUserURL,\'right-row-one\':!vm.nissanUserURL,\'right-row-one-nissan\':vm.nissanUserURL}" ng-click="$scope.collapssed=!$scope.collapssed"><span class=iconDivs ng-if=!vm.selectedDiagFile ng-click=vm.switchDisplay(true) style="color: black;">{{vm.displayText}}</span> <span class=iconDivs ng-if=vm.selectedDiagFile ng-click=vm.switchDisplay(true)>{{vm.selectedDiagFile}}</span> <i ng-class="{\' iconRight2 icon-icons_arrow_top\':$scope.collapssed ,\'iconRight2 icon-icons_arrow_bottom\':!$scope.collapssed}"></i></div></accordion-heading><div><div class="card-body {{vm.nissanUserURL ? \'nissan-card-body\' : \'\'}}"><div ng-repeat="diag in vm.diagFilesList"><div ng-class="{\'subCateg\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}" style="padding-left: 0px !important;" ng-click="vm.saveSelectedDiag(diag,true);$scope.isOpen = !$scope.isOpen;$scope.collapssed=!$scope.collapssed"><span><i class=icon-icons_diagnostic ng-if="diag.origin !== \'Stive\' && diag.origin !== \'DDP\' && diag.origin !== \'STIVE front\' && diag.origin !== \'STIVE batch\' && diag.origin !== \'dbb\'"></i></span> <span><i class=icon-car_assistance_tool style=padding:3px; ng-if="diag.origin === \'Stive\' || diag.origin === \'DDP\' || diag.origin === \'STIVE front\' || diag.origin === \'STIVE batch\' || diag.origin === \'dbb\'"></i></span> {{diag.captureDateTime | momentLocaleDate |capitalize }}-{{diag.captureDateTime|limitTo :8:11}}&nbsp;-&nbsp;{{diag.mileage}} <span ng-if="vm.typeMD !== \'ADT\'">&nbsp;KM&nbsp;</span><span ng-if="vm.isArcaUser || vm.adtTechrole">&nbsp;-&nbsp;{{diag.dealerId}}</span></div></div></div><div class=paginationClass><span><i ng-if="vm.typeMD === \'ADT\'" id=ADT ng-click="vm.diagIconClick(\'ADT\')" class=icon-icons_diagnostic></i> <i ng-if="vm.typeMD === \'B3\'" id=GNDS ng-click="vm.diagIconClick(\'GNDS\')" class=icon-icons_diagnostic></i> <i id=CV ng-click="vm.diagIconClick(\'CV\')" class=icon-car_assistance_tool style=padding:3px;></i></span><pagination-control dataper-page=vm.dataperPage load-pagination=vm.loadPagination total-count=vm.diagFilesList.length page-change=vm.getPagedData(page) is-solution=true current-page=vm.currentPage style="display: inline-flex;width: 85%;"></pagination-control></div></div></accordion-group></accordion><div flex=5 layout-align="center center"><md-divider class=verticalDivider></md-divider></div><accordion class=collapse close-others=false ng-if=!vm.isIndependentUser><div class=textDataNotFound ng-if="(!vm.sympBasketFound && !vm.nissanUserURL)"><span>{{\'NO_RECORDED_SYMPTOM_HISTORY\' | translate}}</span></div><accordion-group class=accord is-open=$scope.isOpen ng-if="vm.sympBasketFound && !vm.nissanUserURL"><accordion-heading><div class=right-row-one ng-model=$scope.collapssed id=sympBasketSelected ng-class="{\'hightlightSel\':vm.selectedSympBasket && !vm.isDiagFileDisplay}" ng-click="$scope.collapssed=!$scope.collapssed"><span class=iconDivs ng-if=!vm.selectedSympBasket ng-click=vm.switchDisplay(false)>{{vm.displaySympText}}</span> <span class=iconDivs ng-if=vm.selectedSympBasket ng-click=vm.switchDisplay(false)>{{vm.selectedSympBasket}}</span> <i ng-class="{\' iconRight2 icon-icons_arrow_top\':$scope.collapssed ,\'iconRight2 icon-icons_arrow_bottom\':!$scope.collapssed}"></i></div></accordion-heading><div class=card-body><div ng-repeat="sympBasket in vm.symptomsBasketList"><div class=subCateg ng-click="vm.saveSelectedSymptomBasket(sympBasket,false);$scope.isOpen = !$scope.isOpen;$scope.collapssed=!$scope.collapssed">{{sympBasket.basketDate | momentLocaleDate |capitalize }}</div></div></div></accordion-group></accordion></form></div></div><div class=diagnostic ng-if="vm.diagSearch[\'diagCompare\'].active && !vm.isSearchByModel && !vm.adtOtherRoles && (!vm.isIndependentUser || (vm.isIndependentUser && $root.asomDocList[\'MD-DIAGFILES\']))"><div id=rightMenu><form layout=row layout=row layout-align="start center"><accordion class=collapse style="width: 545px;" close-others=false><div class=textDataNotFound ng-if=!vm.diagDataFound><span ng-if="vm.typeMD === \'B2\' || vm.typeMD === \'B3\'">{{\'NO_RECORDED_DIAG_FILE_CLIP\' | translate}}</span> <span ng-if="vm.typeMD === \'ADT\'">{{\'NO_RECORDED_DIAG_FILE_ADT\' | translate}}</span> <span ng-if="vm.typeMD != \'B2\' && vm.typeMD != \'B3\' && vm.typeMD != \'ADT\'">{{\'NO_RECORDED_DIAG_FILE\' | translate}}</span></div><accordion-group class=accord is-open=$scope.isOpen ng-if=vm.diagDataFound><accordion-heading><div class=right-row-one ng-model=$scope.collapssed id=diagFileSelected ng-class="{\'hightlightSel\':vm.firstSelectedDiagFile && vm.isDiagFileDisplay}" ng-click="$scope.collapssed=!$scope.collapssed"><span class=iconDivs ng-if=!vm.firstSelectedDiagFile ng-click=vm.switchDisplay(true)>{{vm.displayText}}</span> <span class="iconDivs selectedFile" ng-if=vm.firstSelectedDiagFile ng-click=vm.switchDisplay(true)>{{vm.firstSelectedDiagFile}}</span> <i ng-class="{\' iconRight2 icon-icons_arrow_top\':$scope.collapssed ,\'iconRight2 icon-icons_arrow_bottom\':!$scope.collapssed}"></i></div></accordion-heading><div><div class=card-body><div ng-repeat="diag in vm.diagFilesList"><div class=subCateg style="padding-left: 0px !important;" ng-click="$scope.isOpen = !$scope.isOpen;$scope.collapssed=!$scope.collapssed"><span><i class=icon-icons_diagnostic ng-if="diag.origin !== \'Stive\' && diag.origin !== \'DDP\' && diag.origin !== \'STIVE front\' && diag.origin !== \'STIVE batch\' && diag.origin !== \'dbb\'"></i></span> <span><i class=icon-car_assistance_tool style=padding:3px; ng-if="diag.origin === \'Stive\' || diag.origin === \'DDP\' || diag.origin === \'STIVE front\' || diag.origin === \'STIVE batch\' || diag.origin === \'dbb\'"></i></span> {{diag.captureDateTime | momentLocaleDate |capitalize }}-{{diag.captureDateTime|limitTo :8:11}}&nbsp;-&nbsp;{{diag.mileage}} <span ng-if="vm.typeMD !== \'ADT\'">&nbsp;KM&nbsp;</span><span ng-if="vm.isArcaUser || vm.adtTechrole">&nbsp;-&nbsp;{{diag.dealerId}}</span> <span><md-checkbox ng-model=diag.ischecked ng-checked=diag.ischecked ng-change=vm.selectFirstDiagFile($index,diag) style="float: right;padding-right: 15px;margin-bottom: 0px;"></md-checkbox></span></div></div></div><div class=iconFilter ng-if="vm.typeMD === \'B3\'"><ul><li><span><i id=CLIP ng-click="vm.diagIconClick(\'CLIP\')" class=icon-icons_diagnostic></i> <i id=Stive ng-click="vm.diagIconClick(\'Stive\')" class=icon-car_assistance_tool style=padding:3px;></i></span></li></ul></div><div class=paginationClass ng-if="vm.typeMD === \'ADT\'"><span><i id=ADT ng-click="vm.diagIconClick(\'ADT\')" class=icon-icons_diagnostic></i> <i id=CV ng-click="vm.diagIconClick(\'CV\')" class=icon-car_assistance_tool style=padding:3px;></i></span><pagination-control dataper-page=vm.dataperPage1 load-pagination=vm.loadPagination total-count=vm.diagFilesList.length page-change=vm.getPagedData(page) is-solution=true current-page=vm.currentPage style="display: inline-flex;width: 85%;"></pagination-control></div></div></accordion-group></accordion><div flex=5 layout-align="center center"><md-divider class=adtVerticalDivider></md-divider></div><accordion class=collapse style="width: 545px;" close-others=false><div class=textDataNotFound ng-if=!vm.diagDataFound><span ng-if="vm.typeMD === \'B2\' || vm.typeMD === \'B3\'">{{\'NO_RECORDED_DIAG_FILE_CLIP\' | translate}}</span> <span ng-if="vm.typeMD === \'ADT\'">{{\'NO_RECORDED_DIAG_FILE_ADT\' | translate}}</span> <span ng-if="vm.typeMD != \'B2\' && vm.typeMD != \'B3\' && vm.typeMD != \'ADT\'">{{\'NO_RECORDED_DIAG_FILE\' | translate}}</span></div><accordion-group class=accord is-open=$scope.isOpen ng-if=vm.diagDataFound><accordion-heading><div class=right-row-one ng-model=$scope.collapssed id=diagFileSelected ng-class="{\'hightlightSel\':vm.secondSelectedDiagFile && vm.isDiagFileDisplay}" ng-click="$scope.collapssed=!$scope.collapssed"><span class=iconDivs ng-if=!vm.secondSelectedDiagFile ng-click=vm.switchDisplay(true)>{{vm.displayText}}</span> <span class=iconDivs ng-if=vm.secondSelectedDiagFile ng-click=vm.switchDisplay(true)>{{vm.secondSelectedDiagFile}}</span> <i ng-class="{\' iconRight2 icon-icons_arrow_top\':$scope.collapssed ,\'iconRight2 icon-icons_arrow_bottom\':!$scope.collapssed}"></i></div></accordion-heading><div><div class=card-body><div ng-repeat="diag in vm.secondDiagFilesList"><div class=subCateg style="padding-left: 0px !important;" ng-click="$scope.isOpen = !$scope.isOpen;$scope.collapssed=!$scope.collapssed"><span><i class=icon-icons_diagnostic ng-if="diag.origin !== \'Stive\' && diag.origin !== \'DDP\' && diag.origin !== \'STIVE front\' && diag.origin !== \'STIVE batch\' && diag.origin !== \'dbb\'"></i></span> <span><i class=icon-car_assistance_tool style=padding:3px; ng-if="diag.origin === \'Stive\' || diag.origin === \'DDP\' || diag.origin === \'STIVE front\' || diag.origin === \'STIVE batch\' || diag.origin === \'dbb\'"></i></span> {{diag.captureDateTime | momentLocaleDate |capitalize }}-{{diag.captureDateTime|limitTo :8:11}}&nbsp;-&nbsp;{{diag.mileage}} <span ng-if="vm.typeMD !== \'ADT\'">&nbsp;KM&nbsp;</span><span ng-if="vm.isArcaUser || vm.adtTechrole">&nbsp;-&nbsp;{{diag.dealerId}}</span> <span><md-checkbox ng-model=diag.ischecked ng-disabled=diag.isDisabled ng-checked=diag.ischecked ng-change=vm.selectSecondDiagFile($index,diag) style="float: right;padding-right: 15px;margin-bottom: 0px;"></md-checkbox></span></div></div></div><div class=iconFilter ng-if="vm.typeMD === \'B3\'"><ul><li><span><i id=CLIP ng-click="vm.diagIconClick(\'CLIP\')" class=icon-icons_diagnostic></i> <i id=Stive ng-click="vm.diagIconClick(\'Stive\')" class=icon-car_assistance_tool style=padding:3px;></i></span></li></ul></div><div class=paginationClass ng-if="vm.typeMD === \'ADT\'"><span><i id=ADT ng-click="vm.diagIconClick(\'ADT\')" class=icon-icons_diagnostic></i> <i id=CV ng-click="vm.diagIconClick(\'CV\')" class=icon-car_assistance_tool style=padding:3px;></i> </span><span ng-if="vm.secondDiagFilesList.length > 0"><pagination-control dataper-page=vm.dataperPage2 load-pagination=vm.loadPagination total-count=vm.secondDiagFilesList.length page-change=vm.newPagedData(page) is-solution=true current-page=vm.newPage style="display: inline-flex;width: 85%;"></pagination-control></span></div></div></accordion-group></accordion><span style="left: 15px; position: relative; cursor: pointer;" ng-if="vm.firstSelectedDiagFile && vm.secondSelectedDiagFile"><md-tooltip md-direction=bottom style="font-family: var(--renaultFontRegular);background-color:white; opacity: 1.0; font-size: medium; color: black; border: 1.5px solid black; height: auto !important; margin-top: 9px; margin-right: 27px; max-width: 900px !important; white-space: normal; word-wrap: break-word;">{{\'DTC_REFERENCE_FILE\' | translate}} {{vm.filtered[0].date }} /<br>{{\'DTC_RECENT_FILE\' | translate}} {{vm.filtered[1].date}}</md-tooltip><em style="font-size: 20px; color: var(--renaultPrimaryColor);" class="fa fa-info-circle"></em></span></form></div></div></div><div ng-if="vm.diagSearch[\'diagnosticFile\'].active || vm.diagSearch[\'binDiagnosticFile\'].active  || vm.diagSearch[\'solution\'].active && !vm.nissanUserURL" layout=row ng-style="{\n       \'margin-top\': (!vm.diagCond && (vm.isIndependentUser && $root.asomDocList.MD) && (vm.isSearchByModel || vm.adtOtherRoles)) ? \'0px\' : \'10px\',\n       \'width\': vm.nissanUserURL ? \'545px\' : \'auto\',\n       \'padding\': !vm.nissanUserURL ? \'5px 10px\' : \'\',\n       \'margin-left\':vm.nissanUserURL ? \'16.2rem\' : \'\'\n     }" style="background: rgb(216, 215, 215);padding:5px 10px;margin-top:10px;font-family: var(--renaultFontRegular)"><!--=====================================\n    =                   DEFAULT CODES                  =\n    ======================================--><form layout=row ng-submit="vm.getAllCodes(vm.search.defect.toUpperCase(), 1)" class=type-B3-width-newdiag layout-align="start center" ng-style="{\n           \'padding-left\':vm.nissanUserURL ? \'1%\' : \'\'\n         }" ng-if="vm.rules.showCodeDefault && !vm.isIndependentUser && !vm.nissanUserURL"><input type=text class=search-box ng-model=vm.search.defect placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_DEFAULT_CODE\' | translate}}"> <button class=close-icon type=reset ng-if=vm.search.defect><md-icon md-svg-src="data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4="><svg version=1.1 xmlns=http://www.w3.org/2000/svg><g><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path></g></svg></md-icon></button><md-button ng-style="vm.nissanUserURL && {\'background-color\' : \'#FF8E8F\'}" aria-label=Search ng-click="vm.getAllCodes(vm.search.defect.toUpperCase(), 1)" class=md-primary ng-disabled="!vm.search.defect || vm.search.symptom"><i class=icon-icons_search_arbo></i></md-button></form><form layout=row ng-submit="vm.getAllCodes(vm.search.dtcCode.toUpperCase(), 2)" layout=row ng-class="{\'type-B3-width-newdiag\':(vm.typeMD == \'ADT\' || vm.typeMD == \'B3\')}" layout-align="start center" ng-if="vm.rules.showCodeDtc && vm.loadSymptomSearch" ng-style="vm.nissanUserURL ? {\'padding\':\'1%\',\'display\':\'block\'} : {\'margin-top\':\'4px\', \'margin-right\':\'5px\', \'display\':\'block\'}"><div><md-autocomplete flex md-min-length=3 id=dtc_code md-selected-item=vm.search.dtcSelected md-search-text=vm.search.dtcCode md-item-text=dtc md-items="dtc in vm.listOfDTC | filter:vm.search.dtcCode" md-clear-button=true md-dropdown-position=bottom placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\' | translate}}" input-aria-labelledby="{{\'CAR_SEARCH_BY_DIAGNOSTIC_DTC_CODE\' | translate}}" md-selected-item-change="vm.getAllCodes(vm.search.dtcCode.toUpperCase(), 2)" md-menu-class="{{vm.nissanUserURL ? \'nissanUsers\' : \'renaultUsers\'}}" ng-class="{\'nissanAutocomplete\': vm.nissanUserURL}"><span md-highlight-text=searchText>{{dtc}}</span></md-autocomplete></div></form><div class=search-container ng-if="vm.isSymptomAiSearchEnable && !vm.nissanUserURL"><input type=text class=search-input ng-focus=vm.openDropdown($event) ng-change=vm.resetPlaceholder() ng-keydown="vm.handleKeydown($event, symptomAisearchText)" ng-model=symptomAisearchText maxlength=250 placeholder="{{\'SYMPTOM_AI_SEARCH\' | translate}}"><div class=search-button ng-click=vm.symptomAiSearch(symptomAisearchText) ng-disabled="!symptomAisearchText || symptomAisearchText.trim().length < 5" ng-if=!vm.nissanUserURL><img src=../assets/images/symptom_search.png style=width:2rem;height:2rem;></div><button type=button class=clear-button ng-click=vm.clearSearch()>&times;</button><div class=dropdown-list ng-if=vm.showDropdown><div class=dropdown-item ng-repeat="item in vm.dropdownItems" ng-click=vm.symptomSearchSelected(symptomAisearchText,item) style="padding: 0.5rem;\n        cursor: pointer;">{{item.label}}</div></div></div><div flex=2></div><symptom-search ng-if="!vm.nissanUserURL && vm.loadSymptomSearch"></symptom-search></div><div ng-if="vm.isDiagFileDisplay && vm.selectedDiagFileId && (vm.diagSearch[\'diagnosticFile\'].active || vm.diagSearch[\'binDiagnosticFile\'].active)  && !vm.showDiagHelpContent" style=display:flex;><diag-file-details go-to-result-by-diagnostic=vm.goToResultByDiagnostic system-doc-sub-menu=vm.systemDocSubMenu selected-diag-file-id=vm.selectedDiagFileId data=vm.data type-m-d=vm.typeMD context-vehicle=vm.contextVehicle diag-files-list=vm.diagFilesList system-doc-response=vm.systemDocResponse></diag-file-details></div><div ng-if="vm.isDiagFileDisplay && vm.selectedDiagFileId && (vm.diagSearch[\'diagnosticFile\'].active || vm.diagSearch[\'binDiagnosticFile\'].active)  && vm.showDiagHelpContent" style=display:flex;><diag-file-help style="min-width: 100%;" selected-diag-file-id=vm.selectedDiagFileId data=vm.data type-m-d=vm.typeMD diag-files-list=vm.diagFilesList bin-searched=vm.binSearched></diag-file-help></div><div ng-if="vm.diagSearch[\'ecu\'].active" style=display:flex;><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 15px;max-width: 100%;"><diag-ecu style="min-width: 100%;" type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination diag-files-list=vm.diagFilesList current-page=vm.currentPage dataper-page=vm.dataperPage></diag-ecu></form></div><div ng-if="vm.diagSearch[\'alert\'].active"><alert-file-details></alert-file-details></div><div ng-if="vm.diagSearch[\'network\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;"><diag-network style="min-width: 100%;" type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination diag-files-list=vm.diagFilesList current-page=vm.currentPage dataper-page=vm.dataperPage></diag-network></form></div><div ng-if="vm.diagSearch[\'dtcHistory\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;"><diag-dtc-history type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination diag-files-list=vm.diagFilesList current-page=vm.currentPage dataper-page=vm.dataperPage></diag-dtc-history></form></div><div ng-if="vm.diagSearch[\'diagCompare\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;"><diag-file-compare type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination style="width: 100%;" diag-files-list=vm.diagFilesList diag-first-id=vm.diagFirstId diag-second-id=vm.diagSecondId current-page=vm.currentPage dataper-page=vm.dataperPage first-selected-diag-file=vm.firstSelectedDiagFile second-selected-diag-file=vm.secondSelectedDiagFile second-diag-files-list=vm.secondDiagFilesList></diag-file-compare></form></div><div ng-if="vm.diagSearch[\'userjourney\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;"><diag-user-journey type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination diag-files-list=vm.diagFilesList current-page=vm.currentPage dataper-page=vm.dataperPage></diag-user-journey></form></div><div ng-if="vm.diagSearch[\'batteryReuseCrash\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;font-family: var(--renaultFontRegular);"><battery-crash-history></battery-crash-history></form></div><div ng-if="vm.diagSearch[\'reprogrammingHistory\'].active"><form layout=row flex=40 layout-align="start center" style="position: relative; top: -12px; max-width: 115%;"><diag-file-reprogramming></diag-file-reprogramming></form></div><div ng-if="vm.diagSearch[\'ocv\'].active"><form layout=row layout=row flex=40 layout-align="start center" style="padding-top: 18px;max-width: 100%;"><diag-nv-preparation type-m-d=vm.typeMD is-arca-user=vm.isArcaUser is-adt-techrole=vm.adtTechrole load-pagination=vm.loadPagination diag-files-list=vm.diagFilesList current-page=vm.currentPage dataper-page=vm.dataperPage></diag-nv-preparation></form></div><!--=====================================\n=            DIAGNOSTIC FILES           =\n======================================--><div ng-if="!vm.isDiagFileDisplay && vm.selectedSympBasketId && vm.showSymptom" style=display:flex;><symptom-basket-details go-to-result-by-diagnostic=vm.goToResultByDiagnostic style="width: 100%;" selected-symp-basket-id=vm.selectedSympBasketId data=vm.data is-symptoms-displayed=vm.isSymptomsDisplayed symptoms-basket-list=vm.symptomsBasketList></symptom-basket-details></div><!--=====================================\n    =            CAR SYMPTOMS VIEW          =\n    ======================================--><div ng-if=vm.isSystemDocContent><form layout=row flex=40 layout-align="start center"><system-doc data=vm.systemDocResponse selected-system-doc=vm.selectedSystemDoc></system-doc></form></div>');
$templateCache.put('app/components/car/searchByDiagnostic/symptomSearch.template.html','<form layout=row ng-style="{\'width\': !vm.widthClass ? \'545px\' : \'90%\'}" ng-submit="vm.getAllCodes(vm.search.symptom, 3)" layout-align="start center" style="display: block; margin-top: 4px"><div ng-if="((vm.checkBRWType === \'BRW\' && (vm.checkFicStatus === \'Draft\' || vm.checkFicStatus === \'To do\')) || (!vm.checkBRWType && !vm.checkFicStatus))"><md-autocomplete flex md-min-length=3 id=symptomCode ng-focus="vm.search.dtcCode = \'\'; vm.search.defect = \'\';vm.removeColors(\'symptomCode\') " md-selected-item=vm.search.symptomSelected md-search-text=vm.search.symptom md-item-text=item.label md-items="item in vm.getOnlyLabelSymptoms(vm.dataSymptoms.symptoms) | filter:{filteredLabel: vm.normalizeFilter(vm.search.symptom) }" md-clear-button=true md-min-length=3 md-dropdown-position=bottom placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_SYMPTOM\' | translate}}" md-selected-item-change="vm.getAllCodes(vm.search.symptom, 3, redirectionPage)" ng-disabled="(!vm.isActisProfil && (vm.isBrwTypeFic || vm.statusOriginal === \'Closed\' || vm.statusOriginal === \'Sent\' || vm.statusOriginal === \'New\' || vm.statusOriginal === \'Reopen\')) || (vm.isActisProfil && (vm.ficStatusData || vm.responseApi.CaseDetail.status === \'Closed\' || vm.statusOriginal === \'Closed\' || vm.statusOriginal === \'Sent\' || vm.responseApi.CaseDetail.status === \'Sent\' || vm.statusOriginal === \'New\' || vm.responseApi.CaseDetail.status === \'New\' || vm.statusOriginal === \'Reopen\' || vm.responseApi.CaseDetail.status === \'Reopen\'))"><span md-highlight-text=searchText title={{item.label}}>{{item.label}}</span></md-autocomplete></div><div ng-if="(vm.checkBRWType === \'BRW\' && (vm.checkFicStatus !== \'Draft\' && vm.checkFicStatus !== \'To do\'))"><input type=text style="width: 315px;" ng-model=vm.search.symptom placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_SYMPTOM\' | translate}}" ng-disabled=!$root.ficReopenEnabled></div><!--Removed the search button near to search symptom on diagnostic page. Keeping the code just in case--><!--  <md-button\n        aria-label="Search"\n        ng-click="vm.goToResultByDiagnostic(vm.search.symptom, 3, redirectionPage)"\n        class="md-raised md-primary"\n        ng-disabled="!vm.rules.SymptomActivated">\n        <i class="icon-icons_search_arbo"></i>\n    </md-button>--></form>');
$templateCache.put('app/components/car/searchElectricalSchema/searchElectricalSchema.template.html','<div ng-if=vm.doneLoading id=searchElectricalSchema class="row full-width" style="margin-top: 20px;"><div ng-if=!vm.hideTree><div class="medium-3 small-3 columns"><div ng-repeat="node in vm.menu track by $index" class=line_menu1 ng-class="{\'line_menu1_labelSelect_renault\': node === vm.selectedNodeOne && !vm.nissanUserURL, \'line_menu1_labelSelect_nissan\': node === vm.selectedNodeOne && vm.nissanUserURL}" ng-if="!vm.isHorseUser || (vm.isHorseUser && vm.checkNode2WDHorseUser(node.nodeId))"><div class=iconeEclate ng-class="{\'iconeEclateSelect_renault\': node === vm.selectedNodeOne  && !vm.nissanUserURL, \'iconeEclateSelect_nissan\': node === vm.selectedNodeOne  && vm.nissanUserURL}" ng-click=vm.displayData(node.id)><div class=icone_menu_1></div></div><div class=line_menu1_label ng-class="{\'line_menu1_labelSelect_renault\': node === vm.selectedNodeOne && !vm.nissanUserURL, \'line_menu1_labelSelect_nissan\': node === vm.selectedNodeOne && vm.nissanUserURL}" ng-click=vm.selectNodeTwo(node.nodeId)><div class=label_menu_1><label ng-class="{\'renaultColorFont\': node === vm.selectedNodeOne && !vm.nissanUserURL}">{{node.label | toCamelCase}}</label></div></div></div><div class=centerButtonInMenu><div class=containerButton><md-button class="componentDetailsButton md-raised buttonWithIcon" ng-class="{\'inactive\': !vm.isWDCan,\'nissanColor\': (vm.nissanUserURL && vm.isWDCan), \'renaultColor\': (!vm.nissanUserURL && vm.isWDCan)}" ng-click="vm.displayCanAndFusesDocuments(vm.WD_CAN_DOC, \'CAN\')" ng-disabled=!vm.isWDCan><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_CAN_NETWORK\' | translate}}</div></md-button></div><div class=containerButton ng-if=!vm.isHorseUser><md-button class="componentDetailsButton md-raised buttonWithIcon" ng-class="{\'inactive\': !vm.isWDFusible,\'nissanColor\': (vm.nissanUserURL && vm.isWDFusible), \'renaultColor\': (!vm.nissanUserURL && vm.isWDFusible)}" ng-click="vm.displayCanAndFusesDocuments(vm.WD_CAN_DOC, \'DOCUMENT\')" ng-disabled=!vm.isWDFusible><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_FUSE_RELAY\' | translate}}</div></md-button></div><div class=containerButton ng-if=!vm.isHorseUser><md-menu-bar><md-menu><md-button class="componentDetailsButton md-raised buttonWithIcon" ng-class="{\'inactive\': !vm.isWDOtherDocument,\'nissanColor\': (vm.nissanUserURL && vm.isWDOtherDocument), \'renaultColor\': (!vm.nissanUserURL && vm.isWDOtherDocument)}" ng-click="vm.setOtherDocumentsWidthValue(); $mdOpenMenu()" ng-disabled=!vm.isWDOtherDocument><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_OTHER_DOCUMENT\' | translate}}</div></md-button><md-menu-content id=otherDocumentsMenu ng-class="{\'nissanMenu\': vm.nissanUserURL, \'renaultMenu\': !vm.nissanUserURL}"><md-menu-item ng-repeat="type in vm.otherDocumentsList track by $index"><md-button ng-class="{\'nissanListHover\': vm.nissanUserURL, \'renaultListHover\': !vm.nissanUserURL}" ng-click=vm.displayResidualFromDocumentName(type) style="font-family: var(--renaultFontRegular) !important">{{ type |translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div class=containerButton ng-if="!vm.isSearchByModel && !vm.isHorseUser"><md-button class="componentDetailsButton md-raised buttonWithIcon" ng-class="{\'nissanColor\': vm.nissanUserURL}" ng-click=vm.displayPartHarness()><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'HARNESS_LAYOUT\' | translate }}</div></md-button></div></div></div><div class="small-9 medium-9 columns"><div class=row style="height: 100%;"><div ng-class="vm.wdObjectCriteria && vm.wdObjectCriteria.length > 0 ? \'bigGreyBorder\' : vm.nissanUserURL ? \'bigRedBorder\' : \'bigYellowBorder\'"><span class=objCriteriaSpan ng-if="vm.wdObjectCriteria && vm.wdObjectCriteria.length > 0" ng-repeat="objCrit in vm.wdObjectCriteria"><div ng-show=objCrit.codeCrit><span style="cursor: pointer;font-weight: bold;" ng-click=vm.removeCriteria(objCrit.codeCrit,objCrit.codeObj)>X&nbsp;</span> <span>{{objCrit.codeCrit}}</span></div></span><span class=refreshIcon ng-if="vm.wdObjectCriteria && vm.wdObjectCriteria.length > 0" ng-click=vm.removeObjCriteria()><span style="font-weight: bold;">X&nbsp;</span> <span>{{\'ACTIS_HEADER_CANCEL\' | translate}}</span></span></div></div><!-- table --><div class=row><!-- node 2 --><div class="row row-level searchNavResult" id={{level2.node.nodeId}} ng-repeat="level2 in vm.nodes2and3"><a class=level2Font ng-class="[{\n                        \'bold-label\': level2.node === vm.selectedChildNode\n                    }]">{{vm.formatLevel2Label(level2.node)}} </a><!-- node 3 --><div class="row margin-top-5"><div class="small-4 columns"><div class=line_level3 ng-repeat="level3 in level2.arrays[0]"><div class=icone_right><img ng-if=!vm.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" class=greyDotCircle> <img ng-if=vm.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable level3Font inactiveNode" ng-show=!level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a> <a class="linkPiece3 level3Font bold-label" ng-click="level3.activated && vm.goToselectNode(level2,level3)" ng-show=level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="level3 in level2.arrays[1]"><div class=icone_right><img ng-if=!vm.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" class=greyDotCircle> <img ng-if=vm.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable level3Font inactiveNode" ng-show=!level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a> <a class="linkPiece3 level3Font bold-label" ng-click="level3.activated && vm.goToselectNode(level2,level3)" ng-show=level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a></div></div></div><div class="small-4 columns"><div class=line_level3 ng-repeat="level3 in level2.arrays[2]"><div class=icone_right><img ng-if=!vm.nissanUserURL src=./assets/svg/icons_orange_circle.svg height=10 width=10 alt="" class=greyDotCircle> <img ng-if=vm.nissanUserURL src=./assets/svg/icons_red_circle.svg height=10 width=10 alt=""></div><div><a class="linkPiece3 phnx-disable level3Font inactiveNode" ng-show=!level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a> <a class="linkPiece3 level3Font bold-label" ng-click="level3.activated && vm.goToselectNode(level2,level3)" ng-show=level3.activated>{{vm.formatLevel3Label(level2, level3.label)}}</a></div></div></div></div><!-- old, remove if validated --><!-- <div class="row row-level padding-left-30" ng-repeat="level3 in level2.childNodes">\n                        <div class="icone_right row">\n                            <img src="./assets/svg/icons_orange_circle.svg" height="10" width="10">\n                        </div>\n                        <a class="level3Font" ng-class="[{\n                            \'bold-label\': level3 === vm.selectedChildNode,\n                            \'inactiveNode\': !level3.activated\n                        }]" ng-click="level3.activated && vm.goToselectNode(level2,level3)">\n                            {{level3.label | toCamelCase}}\n                        </a>\n                    </div> --></div></div></div></div><div class="textCenter margin-top-30" ng-if=vm.hideTree><h4 style="font-size: var(--renaultExtraLargeFont);font-family: var(--renaultFontBold)">{{\'COMMON_NO_RESULT\' | translate}}</h4></div></div>');
$templateCache.put('app/components/car/searchElectricalSchema/wdPopinMessage.template.html','<div class=popinInfo style="min-height:150px; display:flex; align-items:center; justify-content:center; position:relative; padding:10px 40px;"><div style="position:absolute; top:10px; right:15px;"><em class="fa fa-close" ng-click=close()></em></div><div style="font-size:var(--renaultMediumFont) !important; font-family:var(--renaultFontRegular);"><span ng-bind-html="vm.displayMessage | translate"></span></div></div>');
$templateCache.put('app/components/car/searchSpecializedTool/searchSpecializedTool.template.html','<div id=searchSpecializedToolView class="row full-width" style="margin-top: 20px; max-width:none !important;"><div class="clickable stPrintIcon" ng-if=vm.isFromNewSpecialTools ng-click=vm.downloadPdf() ng-style="{\'display\' : !vm.printIconEnabled ? \'none\' : \'block\'}" title="{{\'BUTTON_ESTIMATE_PRINT\'|translate}}"><i class=icon-icons_print_partlist style="font-size:35px;cursor: pointer;"></i> <label style="color: #000; margin-left: 3px;">{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div ng-if=vm.isFromNewSpecialTools class="clickable stExportIcon" ng-style="{\'display\' : !vm.printIconEnabled ? \'none\' : \'block\'}" title="{{\'BUTTON_ESTIMATE_EXPORT\'|translate}}"><a ng-if="vm.showData && vm.printIconEnabled" csv-download download=TOOLS_{{vm.csvName}} column-header=vm.headerValue input-array=vm.columnValue is-intervention=false><i class=icon-icons_export_csv_panier style="font-size:35px;cursor: pointer;color:#222;"></i> <label style="color: #000;margin-left:1px">{{\'BUTTON_ESTIMATE_EXPORT\' |translate}}</label></a></div><div class="medium-3 small-3 columns"><div ng-repeat="node in vm.menu track by $index" class=line_menu1 id=menuSearchSpecializedToolView ng-class="{\'inactive\': (!vm.isTabActive(vm.menu[node.id].docType.SPECIALTOOLS.subType[0], vm.specializedToolsSubTypesWithoutDuplicatesAfterFiltering) && node.id !== 0) || (!vm.isFromNewSpecialTools && vm.isSpecialToolsDocz) || (vm.isFromNewSpecialTools && $index !== vm.selected && !vm.allCategorySelected)}"><div class=iconeEclate ng-class="{\'iconeEclateSelect_renault\': $index == vm.selected  && !vm.nissanUserURL, \'iconeEclateSelect_nissan\': $index == vm.selected  && vm.nissanUserURL}" ng-click="vm.activateSelectedTab(node.id); vm.getSpecialToolsData(node.docType)"><div class=icone_menu_1><div ng-if="node.id > 0" ng-class="{\'renaultColorFont\': $index == vm.selected && !vm.nissanUserURL}">{{vm.menu[node.id].docType.SPECIALTOOLS.subType[0]}}</div></div></div><div class=line_menu1_label ng-class="{\'line_menu1_labelSelect_renault\': $index == vm.selected && !vm.nissanUserURL, \'line_menu1_labelSelect_nissan\': $index === vm.selected && vm.nissanUserURL}" ng-click="vm.activateSelectedTab(node.id); vm.getSpecialToolsData(node.docType)"><div class=label_menu_1><label ng-class="{\'renaultColorFont\': $index == vm.selected && !vm.nissanUserURL}">{{node.label | translate}}</label></div></div></div><!-- pdf link inside vm.pdf --><div class=buttonListSpecializedToolContainer><button ng-if=!vm.nissanUserURL ng-class="{buttonListSpecializedTool : vm.pdf}" type=button class=buttonDisabled><a target=_blank ng-href={{vm.pdf}}>{{\'SEARCH_SPECIALIZED_TOOL_LIST_SUPPLIERS\' | translate}}</a></button></div></div><!--search-watch-model="vm.statusResult"--><div class="small-9 medium-9 columns"><div class=row><table st-table=vm.displayedData st-safe-src=vm.responseSpecialTools st-set-filter=customFilter class="table table-striped full-width" ng-class="{\'inactive\': !vm.responseSpecialTools || !vm.isFromNewSpecialTools}"><thead><tr id=tableHeader><th ng-class="{\'renaultSort\': !vm.nissanUserURL,\'nissanSort\': vm.nissanUserURL}"><!--<st-select-multiple detail-show-checkboxes="vm.showCheckboxes()" status-selection="vm.statusSelection" status="vm.status" collection="vm.responseSpecialTools" predicate="education"></st-select-multiple>--><form><div class=multiselect><div class=selectBox ng-click=vm.showCheckboxes()><select><option>{{\'SEARCH_SPECIALIZED_TOOL_DROPDOWN_TITLE\' | translate}}</option></select><div class=overSelect></div></div><div id=checkboxes><!--st-search="type"--> <label ng-repeat="status in vm.status" ng-class="{\'nissan-checkbox-label\': vm.nissanUserURL}"><input type=checkbox name=selectedStatus[] value={{status.name}} ng-model=vm.statusSelected ng-true-value="\'{{status.name}}\'" ng-false-value="" ng-checked="vm.statusSelection.indexOf(status.name) > -1" ng-click=vm.toggleSelection(status.name)> {{status.label}}</label></div></div></form></th><th st-sort=identifier ng-class="{\'renaultSort\': !vm.nissanUserURL,\'nissanSort\': vm.nissanUserURL}">{{\'SEARCH_SPECIALIZED_TOOL_TOOLS_CODE\' | translate}}</th><th st-sort=reference ng-class="{\'renaultSort\': !vm.nissanUserURL,\'nissanSort\': vm.nissanUserURL}">{{\'SEARCH_SPECIALIZED_TOOL_REFERENCE\' | translate}}</th><th ng-if=!vm.nissanUserURL style="line-height: 3rem;" st-sort=supplier ng-class="{\'renaultSort\': true}">{{\'SEARCH_SPECIALIZED_TOOL_SUPPLIER\' | translate}}</th><th st-sort=designation ng-class="{\'renaultSort\': !vm.nissanUserURL,\'nissanSort\': vm.nissanUserURL}">{{\'SEARCH_SPECIALIZED_TOOL_DESCRIPTION\' | translate}}</th><th st-sort=residual ng-if=!vm.nissanUserURL ng-class="{\'renaultSort\': !vm.nissanUserURL,\'nissanSort\': vm.nissanUserURL}">{{\'SEARCH_SPECIALIZED_TOOL_APPLICABILITY\' | translate}}</th></tr></thead><tbody ng-show="vm.isFromNewSpecialTools || !vm.isSpecialToolsDocz" id=openSpecialToolInfo><tr class=pointerRow ng-repeat="row in vm.displayedData | filter: vm.search | customFilter: vm.statusSelected" ng-click=vm.openSpecializedToolInformation(row)><td ng-bind-html=vm.displayPictogram(row) style="text-align: center; width: 15%;"></td><td>{{row.identifier}}<br><img ng-src={{row.thumbnailUrl}} alt="" style="width: 60px; height: 60px;"></td><td class=noLineBreak>{{vm.removeSpacesFromReferenceNumber(row.reference) | filterFormatRef}}</td><td ng-if=!vm.nissanUserURL>{{row.supplier}}</td><td>{{row.designation}}<br><div class=italic>{{row.comment}}</div></td><td style="text-align: center;" ng-if=!vm.nissanUserURL><click-tooltip-container ng-if="row.residual && row.residual.length !== 0"><div class="tooltipContainer tooltipContainerDuration"><div class=durationDetails ng-repeat="applicability in row.applicabilityResidual">{{applicability}}<br></div></div></click-tooltip-container></td><td ng-if=!row.residual>&nbsp;</td></tr></tbody></table><!--<div style="text-align: center;align-items: center;">--><!--<pagination total-items="vm.totalItems" page="vm.currentPage" items-per-page="vm.itemsPerPage"--><!--max-size="vm.maxSize" class="pagination-sm">--><!--</pagination>--><!--</div>--></div></div></div><scroll-up scroll-trigger=300 scroll-anchor=#searchSpecializedToolView></scroll-up>');
$templateCache.put('app/components/client/infoClient/infoClient.html','<div id=infoClient><div class=infoNode><div class=btnBack ng-click=infoCltCtrl.backToCarSearchResult()><i class=icon-icons-phnx_back></i><div>{{\'PRODUCT_PREVIOUS\'|translate}}</div></div><div class=separator></div><div class=textNode><div class=infoPiece>{{::infoCltCtrl.infoClient.customer.title}} {{::infoCltCtrl.infoClient.customer.firstName}} {{::infoCltCtrl.infoClient.customer.name}} ({{::infoCltCtrl.infoClient.accountNumber}})</div></div></div><div class=no_border><div class="contactClient medium-8"><div class=divMargin><div class=row><div class="infoIcon cell"><i class=icon-icons-address-client></i></div><div class="medium-6 cell">{{::infoCltCtrl.infoClient.customer.streetNumber}} {{::infoCltCtrl.infoClient.customer.bisTer}} {{::infoCltCtrl.infoClient.customer.roadType}} {{::infoCltCtrl.infoClient.customer.streetName}}</div><div class="infoIcon cell"><i class=icon-icons-phone-client></i></div><div class="medium-2 cell">{{\'INFO_CLIENT_MAIN_PHONE\' |translate}}</div><div class="medium-1 cell">{{infoCltCtrl.infoClient.customer.mainPhone}}</div></div><div class=row><div class="infoIcon cell"></div><div class="medium-6 cell" ng-if=infoCltCtrl.infoClient.customer.address1>{{::infoCltCtrl.infoClient.customer.address1}}</div><div class="medium-6 cell" ng-if=!infoCltCtrl.infoClient.customer.address1>{{::infoCltCtrl.infoClient.customer.postCode}} {{::infoCltCtrl.infoClient.customer.city}}</div><div class="infoIcon cell"></div><div class="medium-2 cell">{{\'INFO_CLIENT_MOBILE_PHONE\' |translate}}</div><div class="medium-1 cell">{{infoCltCtrl.infoClient.customer.mobilePhone}}</div></div><div class=row><div class="infoIcon cell"></div><div class="medium-6 cell" ng-if=infoCltCtrl.infoClient.customer.address1>{{::infoCltCtrl.infoClient.customer.postCode}} {{::infoCltCtrl.infoClient.customer.city}}</div><div class="medium-6 cell" ng-if=!infoCltCtrl.infoClient.customer.address1></div><div class="infoIcon cell"></div><div class="medium-2 cell">{{\'INFO_CLIENT_WORK_PHONE\' |translate}}</div><div class="medium-1 cell">{{infoCltCtrl.infoClient.customer.workPhone}}</div></div><div class="row zipCodeBloc"><div class="infoIcon cell"></div><div class="medium-6 cell">{{\'INFO_CLIENT_PO_BOX_NUMBER\' |translate}} : {{::infoCltCtrl.infoClient.customer.poBoxNumber}} , {{::infoCltCtrl.infoClient.customer.city}}</div><div class="infoIcon cell"><i class=icon-icons-fax-client></i></div><div class="medium-2 cell">{{\'INFO_CLIENT_FAX_LABEL\' |translate}}</div><div class="medium-1 cell">{{infoCltCtrl.infoClient.customer.fax}}</div></div><div class=row><div class="infoIcon cell"></div><div class="medium-6 cell">{{\'INFO_CLIENT_PROVINCE_CODE\' |translate}} : {{::infoCltCtrl.infoClient.customer.provinceCode}}</div></div><div class="row mailBloc"><div class="infoIcon cell"><i class=icon-icons-mail-client></i></div><div class="medium-6 cell">{{\'INFO_CLIENT_MAIL_LABEL\' |translate}} : <a class=phnx-mail-client href={{infoCltCtrl.email}}>{{::infoCltCtrl.infoClient.customer.email}}</a></div></div></div></div><div class="preferenceClient medium-4"><div class=divMargin><!--Title --><div class=row><div class=infoMedia>{{\'INFO_CLIENT_PREFERRED_MEDIA\' |translate}}</div></div><!--Infos--><div class=row><div class="medium-4 cell">{{\'INFO_CLIENT_PHONE_LABEL\' |translate}}</div><div class="infoIcon cell"><i class=icon-icons-favorite-client ng-if=infoCltCtrl.isPhonePrefered()></i></div><div class="infoIcon cell"><i class=icon-icons-available-client ng-if=infoCltCtrl.canPhone()></i> <i class=icon-icons-unavailable-client ng-if=!infoCltCtrl.canPhone()></i></div></div><div class=row><div class="medium-4 cell">{{\'INFO_CLIENT_SMS_LABEL\' |translate}}</div><div class="infoIcon cell"><i class=icon-icons-favorite-client ng-if=infoCltCtrl.isSmsPrefered()></i></div><div class="infoIcon cell"><i class=icon-icons-available-client ng-if=infoCltCtrl.canSms()></i> <i class=icon-icons-unavailable-client ng-if=!infoCltCtrl.canSms()></i></div></div><div class=row><div class="medium-4 cell">{{\'INFO_CLIENT_ADRESS_LABEL\' |translate}}</div><div class="infoIcon cell"><i class=icon-icons-favorite-client ng-if=infoCltCtrl.isCourrierPrefered()></i></div><div class="infoIcon cell"><i class=icon-icons-available-client ng-if=infoCltCtrl.canCourrier()></i> <i class=icon-icons-unavailable-client ng-if=!infoCltCtrl.canCourrier()></i></div></div><div class=row><div class="medium-4 cell">{{\'INFO_CLIENT_MAIL_LABEL\' |translate}}</div><div class="infoIcon cell"><i class=icon-icons-favorite-client ng-if=infoCltCtrl.isEmailPrefered()></i></div><div class="infoIcon cell"><i class=icon-icons-available-client ng-if=infoCltCtrl.canEmail()></i> <i class=icon-icons-unavailable-client ng-if=!infoCltCtrl.canEmail()></i></div></div><div class=row><div class="medium-4 cell">{{\'INFO_CLIENT_FAX_LABEL\' |translate}}</div><div class="infoIcon cell"><i class=icon-icons-favorite-client ng-if=infoCltCtrl.isFaxPrefered()></i></div><div class="infoIcon cell"><i class=icon-icons-available-client ng-if=infoCltCtrl.canFax()></i> <i class=icon-icons-unavailable-client ng-if=!infoCltCtrl.canFax()></i></div></div></div></div></div></div>');
$templateCache.put('app/components/client/settings/dms-state.template.html','<div ng-if=vm.dms.url class=setting-container><h6 class=setting-container-title>DMS</h6><div id=dms-state><div class=row><div class="small-3 columns" id=sizeofcolumn><span class=setting-container-label>{{\'ADMIN_DMS_CONNECTION_URL\' | translate}}</span><br><div class=urlsize><span>{{vm.dms.url}}</span></div><div class="flex-row dms-state-line"><div ng-click=vm.hookDMS() class=round-container ng-class="{\'round-border-success\': vm.dmsState}"><div class=round ng-class="{\'round-background-success\': vm.dmsState}"></div></div><span class=dms-state-text>{{\'ADMIN_DMS_CONNECTED_SUB_TITLE\' | translate}}</span></div><div class="flex-row dms-state-line"><div ng-click=vm.unsetDMS() class=round-container ng-class="{\'round-border-success\': !vm.dmsState}"><div class=round ng-class="{\'round-background-success\': !vm.dmsState}"></div></div><span class=dms-state-text>{{\'ADMIN_DMS_NOT_CONNECTED_SUB_TITLE\' | translate}}</span></div><div class=error-message><span class=text-error ng-if=vm.msg>{{vm.msg}}</span></div></div><div class="small-2 columns"><!--=====================================\n                =             RADIO BUTTON              =\n                ======================================--> <span class=setting-container-label>{{\'DMS_NETWORK_USER_PROFILE\' | translate}}</span><div class="flex-row dms-state-line"><md-radio-group ng-model=buttonSelected ng-change=vm.changeState(buttonSelected)><md-radio-button value=WORKSHOP class=md-primary>{{\'DMS_WORKSHOP\' | translate}}</md-radio-button><md-radio-button value=PARTSHOP class=md-primary>{{\'DMS_PARTSHOP\' | translate}}</md-radio-button></md-radio-group></div></div><div><div class="small-2 columns"><span class=setting-container-label>{{\'DMS_USER_DATA\' | translate}}</span><!--=====================================\n                    =            WORKSHOP INPUT            =\n                    ======================================--><div class="width-5O margin-top-25"><md-input-container class="md-block md-input-has-value margin-bottom-O" flex-gt-sm=""><label class=fontStyle>{{\'DMS_WORKSHOP_PARTSHOP\' | translate}}</label> <input type=text ng-change="vm.inputProvider(\'workshop\', workshopPartshopId)" class=inputAngular ng-model=workshopPartshopId></md-input-container></div><!--=====================================\n                    =            USER DMS INPUT             =\n                    ======================================--><div class=width-5O><md-input-container class="md-block md-input-has-value margin-top-O" flex-gt-sm=""><label class=fontStyle>{{\'DMS_USER_DMS_ID\' | translate}}</label> <input type=text ng-change="vm.inputProvider(\'userDmsId\', userDmsId)" class=inputAngular ng-model=userDmsId></md-input-container></div></div></div><div class="small-4 columns"><md-switch ng-model=IdentifiantMdp aria-label=IdentifiantMdp class=md-warn ng-change=vm.changeUsernamePassword(IdentifiantMdp)>{{\'LABEL_LOGIN_PASSWORD\' | translate}}</md-switch></div></div><div class=row><div class="small-4 columns"><span class=setting-container-label>{{\'COMMON_HEADER_LABEL\' | translate}}</span><div class=numCharEditMention><label>{{vm.header.length > 0 ? vm.header.length : 0}}/500</label></div><textarea rows=4 ng-model=header ng-trim=false maxlength=500 ng-model-options="{debounce: 750}" ng-change=vm.changeHeader(header)>\n                        {{vm.header}}\n                    </textarea></div><div class="small-offset-1 small-4 columns end"><span class=setting-container-label>{{\'COMMON_MENTION_LABEL\' | translate}}</span><div class=numCharEditMention><label>{{vm.mentions.length > 0 ? vm.mentions.length : 0}}/100</label></div><textarea rows=4 class=area-mentions ng-model=vm.mentions ng-trim=false maxlength=100 ng-model-options="{debounce: 750}" ng-change=vm.changeMentions(vm.mentions)>\n                    {{vm.mentions}}\n                </textarea></div></div><div class=row><div class="small-7 columns clientFamily"><div style="display: flex; justify-content: space-between; margin-bottom: 15px; flex-wrap: wrap"><div class=setting-container-title style="padding-bottom: 0px">{{\'CUSTOMER_GROUP\' | translate}}</div><button ng-click=vm.addFamilyLabel() type=button class="buttonWithIcon buttonPosition"><div class=iconDiv><i class=icon-icons-phnx_expendable_plus></i></div><div class=btnText>{{\'CREATE_CUSTOMER_GROUP\' | translate}}</div></button></div><table style="width: 100%;"><thead ng-if="vm.newLabel !== null || (vm.list && vm.list.length)"><tr><th colspan=3>{{\'COMMON_DESIGNATION\' | translate}}</th></tr></thead><tbody><tr ng-repeat="family in vm.list"><td style="width: 100%">{{family.label}}</td><td><i class="fa fa-pencil dms-icons-family" ng-click="vm.updateFamilyLabel(family.label, family.id)"></i></td><td><i class="fa fa-trash dms-icons-family" ng-click="vm.deleteFamilyLabel(family.label, family.id)"></i></td></tr><tr ng-if="vm.newLabel !== null"><td style="width: 100%"><input placeholder="{{\'FAMILY_GROUP_SAME_DESIGNATION\' | translate}}" ng-model=vm.newLabel maxlength=30 style="margin: 0px"></td><td style="margin: auto;"><i class="fa fa-save dms-icons-family" ng-click=vm.saveFamilyLabel()></i></td><td style="margin: auto;"><i class="fa fa-times dms-icons-family" ng-click="vm.newLabel = null"></i></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/components/client/settings/settings.html','<div id=userSettings><h2 class=setting-title>{{\'MY_PROFILE\' | translate}}</h2><!--=====================================\n    =         Personal data section         =\n    ======================================--><div class=setting-container><h3 class=setting-container-title>{{\'USER_TITLE_PERSO\' | translate}}</h3><div class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">IPN</span> <span class="small-6 columns">{{vm.profile.ipn}}</span></div><div class="medium-4 small-12 columns end"><div><span class="small-6 columns setting-container-label">{{\'ALERTS_FIRSTNAME\' | translate}}</span> <span class="small-6 columns">{{vm.profile.firstName}}</span></div><div><span class="small-6 columns setting-container-label">{{\'ALERTS_LASTNAME\' | translate}}</span> <span class="small-6 columns">{{vm.profile.lastName}}</span></div></div></div><div ng-if="vm.profile.userType === \'RNET\'" class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">{{\'DEALER_CODE\' | translate}}</span> <span class="small-6 columns">{{vm.profile.dealerId}}</span></div></div><div ng-if="vm.profile.userType === \'ARCA\'" class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">{{\'COST_CENTER\' | translate}}</span> <span class="small-6 columns">{{vm.profile.costCenter}}</span></div></div><div class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">{{\'ROLES\' | translate}}</span> <span class="small-6 columns"><span ng-repeat="roles in vm.profile.roles">{{roles}}<br></span></span></div><div class="medium-4 small-12 columns float-left"><span class="small-6 columns setting-container-label">{{\'COUNTRY_CODE\' | translate}}</span> <span class="small-6 columns">{{vm.profile.country}}</span></div></div><div class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">{{\'HTL_AUTHORISATION\' | translate}}</span> <span class="small-6 columns">{{vm.isHtlGranted | translate}}</span></div><div class="medium-4 small-12 columns float-left"><span class="small-6 columns setting-container-label">{{\'DEALER_LOGISTIC_ID\' | translate}}</span> <span class="small-6 columns"><div class=custom-select ng-if="vm.profile.dealerLogisticIds.length > 1 && vm.profile.dealerLogisticIds!= \'rejected\'"><select class=inputReset ng-init="dealerSelected= vm.profile.dealerLogisticIds[0]" ng-model=dealerSelected ng-options="data for data in vm.profile.dealerLogisticIds"></select></div><span ng-if="vm.profile.dealerLogisticIds.length <= 1">{{vm.profile.dealerLogisticIds[0]}}</span></span></div></div><div class=row><div class="medium-5 small-12 columns"><span class="small-6 columns setting-container-label">{{\'FIC_MANAGEMENT\' | translate}}</span> <span class="small-6 columns" ng-if=vm.isActisRole>{{\'ACTIS_SAVE_INFORMATIONS_YES\' | translate}}</span> <span class="small-6 columns" ng-if=!vm.isActisRole>{{\'ACTIS_SAVE_INFORMATIONS_NO\' | translate}}</span></div></div></div><!--=====================================\n    =          LANGUAGE SECTION             =\n    ======================================--><div class=setting-container><h3 class=setting-container-title>{{\'ADMIN_LANGUAGE_TITLE\' | translate}}</h3><div class=languages><!--=====================================\n            =          Portal language              =\n            ======================================--><div class="small-3 columns"><label class=setting-container-label>{{\'ADMIN_LANGUAGE_PORTAL_TITLE\' | translate}}</label><div class=custom-select><select class=inputReset ng-model=vm.profile.language ng-options="option.code as option.label for option in vm.languages"></select></div></div><!--=====================================\n            =          Doc First Language           =\n            ======================================--><div class="small-3 columns"><label class=setting-container-label>{{\'ADMIN_DOCUMENTATION_TITLE\' | translate}}</label><div class=custom-select><select class=inputReset ng-model=vm.profile.documentationFirstLanguage ng-options="option.label for option in vm.languages track by option.code"></select></div></div><!--=====================================\n            =          Doc Second Language          =\n            ======================================--><div class="small-3 columns"><label class=setting-container-label>{{\'DEFAULT_LANGUAGE_DOCUMENTATION\' | translate}}</label><div class=custom-select><select class=inputReset ng-model=vm.profile.documentationSecondLanguage ng-options="option.label for option in vm.languages track by option.code"></select></div></div></div></div><!--=====================================\n    =                  DMS                  =\n    ======================================--><dms-state dms=vm.profile.dmsConfig ng-hide=vm.isMitsubishiUser ng-if="vm.profile.dmsConfig.ipAddress || vm.profile.dmsConfig.url" dms-state=vm.dmsState user-dms-id=vm.userDmsId workshop-partshop-id=vm.workshopPartshopId network-profile=vm.networkProfile on-change-username-password=vm.onChangeUsernamePassword on-change-mentions=vm.onChangeMentions on-change-header=vm.onChangeHeader></dms-state><!--=====================================\n    =            SAVE / CANCEL             =\n    ======================================--><div class=setting-buttons><button type=button class=buttonWithIcon ng-click=vm.save()><div class=iconDiv><i class=icon-icons-phnx_expendable_plus></i></div><div class=btnText>{{\'COMMON_RETAIN\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.backToPrevious()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/doc-alerts/pagination/paging.html','<ul ng-if=pager.pages.length class=pager><li ng-class="{disabled:pager.currentPage === 1}"><a ng-click="setPage((pager.currentPage === 1),1)">First</a></li><li ng-class="{disabled:pager.currentPage === 1}"><a ng-click="setPage((pager.currentPage === 1),pager.currentPage - 1)">Previous</a></li><li ng-repeat="page in pager.pages" ng-class="{active:pager.currentPage === page}"><a ng-click=setPage(false,page)>{{page}}</a></li><li ng-class="{disabled:pager.currentPage === pager.totalPages}"><a ng-click="setPage((pager.currentPage === pager.totalPages),pager.currentPage + 1)">Next</a></li><li ng-class="{disabled:pager.currentPage === pager.totalPages}"><a ng-click="setPage((pager.currentPage === pager.totalPages),pager.totalPages)">Last</a></li></ul>');
$templateCache.put('app/components/docpriv/comments/comments.template.html','<div id=docPrivComments><div class="alerts-popin_modal-bg reveal-modal-bg" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status}"></div><div class="alert-arrow_display alerts-popin_container o-inherit" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status}"><div class="alerts-popin alerts-popin_container" ng-class="{\'hide\':!vm.hidePopin.status, \'show\':vm.hidePopin.status}"><div class=alerts-popin_container-flex><div style="text-align:right; padding-bottom: 2%;" class=row><i ng-click=vm.actionHidePopin() class="fa fa-times-circle" aria-hidden=true title=close></i></div><div class=row><div class="medium-3 column"><label>IPN</label></div><div class="medium-9 column"><input type=text disabled=disabled ng-model=vm.userIpn></div></div><div class=row><div class="medium-3 column"><label>CR</label></div><div class="medium-9 column"><input type=text maxlength=25 ng-model=vm.userCR></div></div><div class=row><div class="medium-3 column"><label>GAR</label></div><div class="medium-9 column"><input type=text maxlength=25 ng-model=vm.userGAR></div></div><div class=row><div class="medium-3 column"><label>{{\'BTLIST_HEADER_INDEX\'|translate}}</label></div><div class="medium-9 column"><select id=selectedIndex ng-options="data for data in vm.indexList" ng-model=vm.selectedIndex ng-disabled=vm.disableIndex></select></div></div><div class=row><textarea rows=9 maxlength=500 minlength=3 ng-model=vm.selectedComments></textarea></div><div class=row><span class=comments-icons><i class="fa fa-hand-o-left" ng-click=vm.goBack() aria-hidden=true title="{{\'CANCEL_MODIFICATIONS\'|translate}}"></i></span> <span class=comments-icons><i class="fa fa-download" ng-click=vm.saveComments() aria-hidden=true title="{{\'ACTIS_HEADER_SAVE\'|translate}}" style=color:green;></i></span> <span ng-class="{\'noCursor\':!vm.idComment.disableIndex, \'comments-icons\':vm.idComment.disableIndex}"><i class="fa fa-trash-o" ng-hide=!vm.idComment.disableIndex ng-click=vm.deleteComments(vm.selectedIndex) aria-hidden=true title="{{\'ACTIS_HEADER_CLOSE\'|translate}}" style=color:red;></i></span></div></div></div></div></div>');
$templateCache.put('app/components/docpriv/comments/commentsDelete.template.html','<md-dialog id=modalOnDeleteCart><div class=modalPhenix><div class=title>{{\'CONFIRM_DELETE\' | translate}}</div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left left-white" ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/docpriv/docPrivParts/docPrivParts.template.html','<div id=docPrivListView style="display: inline-block;"><div class="large-5 rows" style="float: left;height: 758px;"><table style="width: 100%;margin-bottom: -3%;"><tr ng-if=vm.docPrivCatalogList><td style="width: 13%;" ng-if="vm.docPrivCatalogList.length > 1"><span style="width: 13%;cursor: pointer;" ng-click=vm.backToPrevious()><i class=icon-icons-phnx_back></i> <span>{{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></span></td><td style="width: 50%;"><div class=select-container id=applicabilityText style="display: flex;" ng-if="vm.docPrivCatalogList.length >= 1"><md-select ng-model=vm.selectedAppl style=width:350px;><md-option ng-repeat="appl in vm.selectedApplicability" ng-value=appl.fixedApplicability ng-selected="appl.display == true" style="height: 85px !important; max-width: 90vw;"><span ng-show=!vm.isManufactureId>{{appl.fixedApplicability}}{{appl.variableApplicability !== \'\' ? \' | \' : \'\'}}{{appl.variableApplicability}}{{appl.codifiedApplicability !== \'\' ? \' | \' : \'\'}}{{appl.codifiedApplicability}} </span><span ng-show=vm.isManufactureId>{{appl.fixedApplicability}}{{appl.manufactuerId !== \'\' ? \' | \' : \'\'}} {{appl.manufactuerId}}{{appl.codifiedApplicability !== \'\' ? \' | \' : \'\'}}{{appl.codifiedApplicability}}</span></md-option></md-select></div></td><td style="width: 10%;"><div class=icon-container><div class=iconOnTopRightImg ng-click=vm.printPlateDetails()><!-- ng-click="vm.printSVG(vm.docPrivCatalogList[vm.currentIndexPlate].pictureUrl)" --> <i class=icon-icons_print_partlist></i></div></div></td><td style="width: 15%;"><div ng-if=vm.fullOrReducedScreen class=svg-control-fullscreen><div ng-click=vm.fullOrReducedScreen()><div><span><p style="margin-bottom: 0%; font-size: 40px !important; margin-left:-20px" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div class=displayPlateCommentsPopup ng-if="vm.displayPlateCommentsPopup && vm.isCommentsEnabledbyProfile"><span ng-repeat="comments in vm.getplateComments" ng-if="comments.index == 0"><i class="fa fa-commenting-o" aria-hidden=true ng-if=" !vm.displayNewComments" ng-click=vm.displayPlateComments()></i> <img src=./assets/images/new_comments.png ng-if=vm.displayNewComments ng-click=vm.displayPlateComments() height=90% width=90% alt=""><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:pre-line;"><div>{{comments.comment}}</div></md-tooltip></span></div></div></td></tr></table><table style="width: 100%;margin-bottom: 0%;"><tr><!--=====================================\n            =               Planches                =\n            ======================================--><td style="width: 100%;" colspan=4><div class="large-12 rows docpriv-word-pdf" class=planchesPicto ng-if=vm.docPrivCatalogList><div ng-show="vm.docPrivCatalogList[vm.currentIndexPlate].thumbnailUrl &&\n                                        vm.docPrivCatalogList[vm.currentIndexPlate].thumbnailUrl.length" id=divSvgContent class=phx-svg filtered-list=vm.filteredList style="height: 500px;"></div></div></td></tr><tr ng-if=vm.docPrivCatalogList><td style="width: 30%;text-align: center;">{{vm.docPrivCatalogList[vm.currentIndexPlate].plateNo}}</td><td style="width: 30%;text-align: center;" ng-if=vm.docPrivCatalogList[vm.currentIndexPlate].sieVersion>{{vm.docPrivCatalogList[vm.currentIndexPlate].sieVersion}}</td><td style="width: 30%;text-align: center;" ng-if=!vm.docPrivCatalogList[vm.currentIndexPlate].sieVersion>Version</td><td colspan=2 style="width: 30%;text-align: center;">{{vm.formatDate(vm.docPrivCatalogList[vm.currentIndexPlate].publicationDate)}}</td></tr></table><table style="margin-bottom: 10%;"><tr ng-if="vm.docPrivCatalogList.length > 1"><td style="width: 5%;" class=elementScrollVignetteImg ng-click="vm.scrollVignette(\'left\')" ng-mousedown="vm.scrollVignette(\'left\')"><i class="icon-icons_arrow_left arrow_prev_next_planche"></i></td><td class=scrollVignetteImg id=scrollVignetteContainer><div ng-repeat="vignette in vm.docPrivCatalogList" id=smallImg><div ng-attr-id=vignette_{{$index}} ng-click=vm.onVignetteClick(vignette) class="marginVignette clickable" ng-class=vm.isBorderVignette($index)><div class=centreImg><img ng-if=vignette.thumbnailUrl ng-src={{vignette.thumbnailUrl}} class=docprivThumbnails alt=""> <img ng-if=!vignette.thumbnailUrl src=/assets/images/no_image.png alt=""><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:normal;"><div>{{vignette.plateNo}} - {{vignette.gieDescription}}</div><div ng-repeat="appl in vignette.applicability"><span>{{appl.fixedApplicability}}</span> <span ng-if="appl.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.variableApplicability !== \'\'" style="border-left: 3px solid black;">&nbsp;</span> <span>{{appl.variableApplicability}} </span><span ng-if="appl.codifiedApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.codifiedApplicability !== \'\'" style="border-left: 3px solid black;">&nbsp;</span> <span>{{appl.codifiedApplicability}}</span></div></md-tooltip><div ng-class=vm.isLineVignette($index)></div></div></div></div></td><td style="width: 5%;" class=elementScrollVignetteImg ng-click="vm.scrollVignette(\'right\')" ng-show=vm.docPrivCatalogList.length ng-mousedown="vm.scrollVignette(\'right\')"><i class="icon-icons_arrow_right arrow_prev_next_planche"></i></td></tr></table></div><div class="large-7 rows" style="float: right;"><table class=docpriv-parts><thead style="background: none;"><tr><td style="width: 2%;font-family: var(--renaultFontBold);" ng-if="vm.displayPlateCommentsPopup && vm.isCommentsEnabledbyProfile"></td><td style="width: 3%;font-family: var(--renaultFontBold);"></td><td style="width: 15%;font-family: var(--renaultFontBold);">{{\'DOCPRIV_GP\'|translate}}</td><td style="width: 15%; position: relative;font-family: var(--renaultFontBold);" ng-style="{\'right\' : vm.checkValid ? \'0.5%\':\'0%\'}">{{\'COMMON_REFERENCE\'|translate}}</td><td style="width: 10%; position: relative;font-family: var(--renaultFontBold);" ng-style="{\'right\' : vm.checkValid ? \'0.5%\':\'3%\'}">{{\'DOCPRIV_INFOS\'|translate}}</td><td ng-show=vm.checkValid style="width: 5%;right: 2%;position: relative;font-family: var(--renaultFontBold);"><span ng-if="vm.checkValid ==\'valid\'"><i class="fa fa-check-circle" style=font-size:28px;color:green></i> </span><span ng-if="vm.checkValid ==\'invalid\'"><i class="fa fa-close" style=font-size:28px;color:red></i></span></td><td style="width: 48%; position: relative;" ng-style="{\'left\' : vm.checkValid ? \'-3.5%\':\'0.5%\'}"><table style="margin-bottom: 0%;"><tr><td style="width: 23%;font-family: var(--renaultFontBold);"><span>{{\'DOCPRIV_MTC\'|translate}}</span> <span class="iconRight icon-icons_arrow_bottom" ng-if=!vm.displayAllMtc ng-click=vm.displayPartsMtc()></span> <span class="iconRight icon-icons_arrow_top" ng-if=vm.displayAllMtc ng-click=vm.displayPartsMtc()></span> <span class="fa fa-info-circle iconRight2" ng-click=vm.displayManufactureId() ng-if="vm.totalManufactureIds.length > 0"></span></td><td style="padding: 0;"><input type=text ng-model=vm.fixedData placeholder="{{\'FIXED_FILTER\' | translate}}" style="margin-bottom: 0%;height:30px;background-color: rgb(250,250,250);"></td><td style="padding: 0;"><input type=text ng-model=vm.variableData placeholder="{{\'VARIABLE_FILTER\' | translate}}" style="margin-bottom: 0%;height:30px;background-color: rgb(250,250,250);"></td><td style="padding: 0;"><input type=text ng-model=vm.codifiedData placeholder="{{\'CODIFIED_FILTER\' | translate}}" style="margin-bottom: 0%;height:30px;background-color: rgb(250,250,250);"></td></tr></table></td></tr><tr><td style="width: 2%;font-family: var(--renaultFontBold); padding:0px;" ng-if="vm.displayPlateCommentsPopup && vm.isCommentsEnabledbyProfile"></td><td style="width: 3%;font-family: var(--renaultFontBold); padding:0px;"></td><td style="width: 15%;font-family: var(--renaultFontBold); padding:0px;"></td><td style="width: 15%; position: relative;font-family: var(--renaultFontBold); padding:0px;" ng-style="{\'right\' : vm.checkValid ? \'0.5%\':\'0%\'}"><md-switch ng-change=vm.switchPRFormat(vm.isPRFormat) class=prFormatDocprivSwitch ng-model=vm.isPRFormat title="{{\'SHOW_HIDE_PR_FORMAT\' | translate}}"></md-switch></td><td style="width: 10%; position: relative;font-family: var(--renaultFontBold); padding:0px;" ng-style="{\'right\' : vm.checkValid ? \'0.5%\':\'3%\'}"></td><td ng-show=vm.checkValid style="width: 5%;right: 2%;position: relative;font-family: var(--renaultFontBold); padding:0px;"></td><td style="width: 48%; position: relative; padding:0px;" ng-style="{\'left\' : vm.checkValid ? \'-3.5%\':\'0.5%\'}"></td></tr></thead><tbody style="position: absolute;overflow-y: auto;max-height: 500px;"><tr id={{parts.index}} style="width:100%;display: inline-table;table-layout: fixed;" ng-repeat="parts in vm.partsList.references  | applicabilityFilter:vm.fixedData:vm.variableData:vm.codifiedData as listOfList" ng-class="{\'alt-row\': $index % 2 === 1}"><td style="width: 2%; cursor: pointer;" ng-if="vm.displayPlateCommentsPopup && vm.isCommentsEnabledbyProfile && parts.indexDisplay"><span class=showCommentsIcon ng-repeat="comments in vm.getplateComments" ng-if="parts.index == comments.index"><i class="fa fa-commenting-o" aria-hidden=true ng-click=vm.displayPlateComments(parts.index)></i><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:pre-line;"><div>{{comments.comment}}</div></md-tooltip></span></td><td style="cursor: pointer;" ng-click=vm.gotoSvg(parts.index) ng-style="{\'width\':(vm.displayPlateCommentsPopup && vm.isCommentsEnabledbyProfile && !parts.indexDisplay) ? \'5%\' : \'3%\' }"><span class=textIndex-div ng-if=parts.indexDisplay>{{parts.index}}</span></td><td style="width: 15%;" ng-class="{\'changeFont\': parts.textColor}">{{parts.genericPart}}</td><td style="width: 15%;cursor: pointer;" ng-class="{\'noLongerpartStatus\': parts.partStatus == \'NO_LONGER_SOLD\', \'cancelledPartStatus\': parts.partStatus == \'CANCELLED\', \'changeFont\': parts.textColor }" ng-click=vm.goToProduct(parts.reference)>{{parts.reference | filterFormatRef}} <span class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(parts.reference);$event.stopPropagation();></span></td><td style="width: 10%;cursor: pointer; right: 3%; position: relative;" ng-click="vm.displayDetails(parts, true)"><span ng-if="parts.ratio > 1" style="font-weight: bold;">X{{parts.ratio}}</span> <span ng-if="parts.additional && parts.additional.length > 0" style="font-weight: bold;"><i class="fa fa-plus"></i></span> <span ng-if="vm.isStandardExchange(parts.types) && vm.isTractionBattery(parts.familyCode)"><img src=./assets/images/renative.png height=18 width=30 alt=Renative> </span><span ng-if="vm.isStandardExchange(parts.types) && !vm.isTractionBattery(parts.familyCode)"><img src=./assets/images/renative_reman.png height=18 width=30 alt=""> </span><span ng-if="(vm.groupTargets(parts) | json) != \'{}\'" class=icon-icons_chaine_remplacement_listPiece></span> <span ng-if="parts.codifiedSigns.length > 0 || vm.showApplicabilityPicto" style="font-weight: bold;border:2px solid black;">CS</span></td><td ng-show=vm.displayPicto style="width: 5%; right: 2.5%; position: relative;"><span ng-if="parts.status == \'1\'"><i class="fa fa-check-circle" style=font-size:28px;color:green></i></span> <span ng-if="parts.status == \'2\'"><i class="fa fa-check-circle" style=font-size:28px;color:grey></i></span></td><td ng-show="vm.displayHercules && (!vm.isIndependentUser || ($root.asomDocList[\'DOCPRIV\'] && $root.asomDocList[\'PR-HERCULES\']))" style="width: 5%;right: 2%;position: relative;"><span ng-if="parts.herculesCase == \'CASE1:HOLE\'"><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span ng-if="parts.herculesCase == \'CASE2: DUALITY\'"><img src=./assets/images/Duality.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span ng-if="parts.herculesCase == \'CASE3: NEW PROPOSAL\'"><img src=./assets/images/NewHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span ng-if="parts.herculesCase == \'CASE4: SAME PROPOSAL\'"><img src=./assets/images/SameHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span ng-if="parts.herculesCase == \'CASE5: PROPOSAL DECLINED\'"><img src=./assets/images/Declined.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span></td><td style="width: 47%;right: 20px;position: relative;word-break: break-all;cursor: pointer;"><div ng-if=" parts.textColor" ng-class="{\'cancelledPartStatus\': parts.textColor}">{{\'HERCULE_LABEL\' | translate}}</div><div ng-repeat="appl in parts.applicabilities" class=applicability-font ng-class="{\'applicability-block\': parts.applicabilities.length > 1 && vm.displayBorder(appl,parts.reference)}"><span ng-show=appl.display><span ng-click="vm.displayApplicabilityDetails(parts, vm.fixedData)" ng-bind-html="appl.fixedApplicability | highlight : vm.fixedData"></span> <span ng-if="appl.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.variableApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span ng-if=!vm.isManufactureId style="white-space: nowrap;" ng-bind-html="appl.variableApplicability | highlight : vm.variableData"></span> <span ng-if=vm.isManufactureId style="white-space: nowrap;">{{appl.manufactuerId}} </span><span ng-if="appl.codifiedApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.codifiedApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span ng-bind-html="appl.codifiedApplicability | highlight : vm.codifiedData"></span> <span class="iconRight icon-icons_arrow_bottom" ng-if="!parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span> <span class="iconRight icon-icons_arrow_top" ng-if="parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span></span></div></td></tr></tbody></table></div><div ng-if=vm.wordDocImage><docpriv-word current-index-plate=vm.currentIndexPlate doc-priv-catalog-list=vm.docPrivCatalogList word-doc-image=vm.wordDocImage selected-applicability=vm.selectedApplicability parts-list=vm.partsList fixed-data=vm.fixedData variable-data=vm.variableData codified-data=vm.codifiedData is-multiple=false></docpriv-word></div><div class=openCommentsPopup ng-if="vm.docPrivCatalogList && vm.isCommentsEnabledbyProfile"><i class="fa fa-commenting-o" aria-hidden=true ng-click=vm.openComments()></i></div><div class=openVinPopup ng-if="vm.docPrivCatalogList && vm.isVinPopinEnabled && (!vm.isIndependentUser || ($root.asomDocList[\'DOCPRIV\'] && $root.asomDocList[\'PR-HERCULES\']))"><i class="fa fa-search-plus" aria-hidden=true ng-click=vm.validateVin()></i></div><scroll-up scroll-trigger=300 scroll-anchor=#docPrivPlates></scroll-up></div>');
$templateCache.put('app/components/docpriv/docPrivParts/docPrivVinCheck.template.html','<car-search-vin-model is-docpriv=true></car-search-vin-model>');
$templateCache.put('app/components/docpriv/docPrivParts/docprivPrint.template.html','<div class=modalPhenix id=modalOnDeleteCart style="border: 2px solid var(--renaultPrimaryColor);" ng-style="{\'width\': vm.isMultiplePlate ? \'500px\' : \'350px\'}"><div style=padding:6px><h5 style="text-align: center; font-family: var(--renaultFontBold);font-size: var(--renaultLargeFont);">{{"PRINT_FORMAT" | translate}}:</h5><div style="text-align: center;" ng-if=vm.isMultiplePlate>{{"PRINT_PLATE_TIMEOUT" | translate}}</div><ul style="font-size: var(--renaultMediumFont);"><li class=selectPDFWord ng-click="vm.selectPrintMode(\'PDF\')" style="cursor: pointer;list-style: circle;">PDF</li><li class=selectPDFWord ng-click="vm.selectPrintMode(\'WORD\')" style="cursor: pointer;list-style: circle;">WORD</li></ul></div><div class=modalPhenixButtons style="float: right; margin: 0px !important;"><button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{"ACTIS_HEADER_CANCEL" | translate}}</div></button></div></div>');
$templateCache.put('app/components/docpriv/docPrivParts/docprivPrintWord.template.html','<div ng-hide=true id=docpriv-table-word ng-if=!vm.isMultiple><div class=WordSection1><table style=width:850px;><tbody><tr><td>{{vm.docPrivCatalogList[vm.currentIndexPlate].plateNo}}</td><td style="text-align: center;">{{"RLINKCAR_HU_VERSION"| translate}}</td><td style="text-align: right;">{{vm.formatDate(vm.docPrivCatalogList[vm.currentIndexPlate].publicationDate)}}</td></tr></tbody></table><div ng-if=vm.wordDocImage style="font-weight: bold;">!!! &nbsp;{{"WORD_ENABLE_EDITING"| translate}}</div><div ng-if=vm.wordDocImage><img id=my-image ng-if=vm.wordDocImage ng-src={{vm.wordDocImage}} width=750 height=450></div><div ng-if=!vm.wordDocImage>{{"PLATE_IMAGE_MISSING" | translate}}</div><br><br><br><div style="border: 2px solid black; width: 500px;"><span ng-repeat="appl in vm.selectedApplicability"><div>{{appl.fixedApplicability}}{{appl.variableApplicability !== \'\' ? \' | \' : \'\'}}{{appl.variableApplicability}}{{appl.codifiedApplicability !== \'\' ? \' | \' : \'\'}}{{appl.codifiedApplicability}}</div></span></div><br><br><br><table class=docpriv-parts style="border-left: 1px solid black;border-top: 1px solid black;"><thead style="background-color: rgb(225, 222, 222);"><tr><td style="border-right:1px solid black; border-bottom: 1px solid black; text-align:center; width:50px;">{{"BTLIST_HEADER_INDEX" | translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:80px;">{{\'DOCPRIV_GP\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:80px;">{{\'COMMON_REFERENCE\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{\'ACTIS_GENERAL_STATUS\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{"CODIFIED_SIGN_LABEL" | translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center;width:90px;">{{"ADDITIONAL_PARTS"|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{"PRODUCT_REPLACEMENT"|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:350px;">{{\'DOCPRIV_MTC\'| translate}}</td></tr></thead><tbody><tr id={{parts.index}} ng-repeat="parts in vm.partsList.references  | applicabilityFilter:vm.fixedData:vm.variableData:vm.codifiedData" style="border: 1px solid black;"><td style="border-right:1px solid black; border-bottom: 1px solid black;width:50px;"><span ng-if=parts.indexDisplay>{{parts.index}}</span></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:80px;">{{parts.genericPart}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:80px;">{{parts.reference | filterFormatRef}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;">{{parts.brand}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-repeat="cod in parts.codifiedSigns">{{cod.value}} <span ng-if="cod.value && cod.value != \'\' && cod.textAssociated && cod.textAssociated != \'\'">-</span> {{cod.textAssociated}}</div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-repeat="addl in parts.additional">{{addl.partNumber}} <span ng-if=addl.ratio>- {{addl.ratio}}</span></div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-init="targetList = vm.groupTargets(parts)"><span ng-repeat="sup in targetList"><span ng-repeat="list in sup" ng-value={{$index}}><!-- <span ng-if="sup.length === 1 && list.src !== parts.reference">{{list.src}}</span> --> <span ng-if="sup.length === 1">{{list.target}}</span> <span ng-if="sup.length > 1">{{list.target}} {{sup.length - 1 !== $index? \'+\' : \'\'}}</span></span></span></div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:350px; word-break:break-all;"><div ng-repeat="appl in parts.applicabilities"><span ng-show=appl.display><span>{{appl.fixedApplicability}}</span> <span ng-if="appl.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.variableApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{appl.variableApplicability}} </span><span ng-if="appl.codifiedApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.codifiedApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{appl.codifiedApplicability}}</span><br><span class="iconRight icon-icons_arrow_bottom" ng-if="!parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span> <span class="iconRight icon-icons_arrow_top" ng-if="parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span></span></div></td></tr></tbody></table></div></div><div ng-if=vm.isMultiple ng-repeat="docPlate in vm.docPrivCatalogList track by $index"><div ng-hide=true id="{{\'docpriv-table-word\'+$index}}"><div class=WordSection1><table style=width:850px;><tbody><tr><td>{{docPlate.plateNo}}</td><td style="text-align: center;">{{"RLINKCAR_HU_VERSION"| translate}}</td><td style="text-align: right;">{{vm.formatDate(docPlate.publicationDate)}}</td></tr></tbody></table><div ng-if=vm.partsList[$index].pictureWord style="font-weight: bold;">!!! &nbsp;{{"WORD_ENABLE_EDITING"| translate}}</div><div ng-if=vm.partsList[$index].pictureWord><img id=my-image ng-if=vm.partsList[$index].pictureWord ng-src={{vm.partsList[$index].pictureWord}} width=750 height=450></div><div ng-if=!vm.partsList[$index].pictureWord>{{"PLATE_IMAGE_MISSING" | translate}}</div><br><br><br><div style="border: 2px solid black; width: 500px;"><span ng-repeat="appl in docPlate.applicability"><div>{{appl.fixedApplicability}}{{appl.variableApplicability !== \'\' ? \' | \' : \'\'}}{{appl.variableApplicability}}{{appl.codifiedApplicability !== \'\' ? \' | \' : \'\'}}{{appl.codifiedApplicability}}</div></span></div><br><br><br><table class=docpriv-parts style="border-left: 1px solid black;border-top: 1px solid black;"><thead style="background-color: rgb(225, 222, 222);"><tr><td style="border-right:1px solid black; border-bottom: 1px solid black; text-align:center; width:50px;">{{"BTLIST_HEADER_INDEX" | translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:80px;">{{\'DOCPRIV_GP\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:80px;">{{\'COMMON_REFERENCE\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{\'ACTIS_GENERAL_STATUS\'|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{"CODIFIED_SIGN_LABEL" | translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center;width:90px;">{{"ADDITIONAL_PARTS"|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:90px;">{{"PRODUCT_REPLACEMENT"|translate}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;text-align:center; width:350px;">{{\'DOCPRIV_MTC\'| translate}}</td></tr></thead><tbody><tr id={{parts.index}} ng-repeat="parts in vm.partsList[$index].references" style="border: 1px solid black;"><td style="border-right:1px solid black; border-bottom: 1px solid black;width:50px;"><span ng-if=parts.indexDisplay>{{parts.index}}</span></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:80px;">{{parts.genericPart}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:80px;">{{parts.reference | filterFormatRef}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;">{{parts.brand}}</td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-repeat="cod in parts.codifiedSigns">{{cod.value}} <span ng-if="cod.value && cod.value != \'\' && cod.textAssociated && cod.textAssociated != \'\'">-</span> {{cod.textAssociated}}</div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-repeat="addl in parts.additional">{{addl.partNumber}} <span ng-if=addl.ratio>- {{addl.ratio}}</span></div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:90px;"><div ng-init="targetList = vm.groupTargets(parts)"><span ng-repeat="sup in targetList"><span ng-repeat="list in sup" ng-value={{$index}}><span ng-if="sup.length === 1 && list.src !== parts.reference">{{list.src}}</span> <span ng-if="sup.length === 1 && list.src === parts.reference">{{list.target}}</span> <span ng-if="sup.length > 1">{{list.target}} {{sup.length - 1 !== $index? \'+\' : \'\'}}</span></span></span></div></td><td style="border-right:1px solid black; border-bottom: 1px solid black;width:350px; word-break:break-all;"><div ng-repeat="appl in parts.applicabilities"><span ng-show=appl.display><span>{{appl.fixedApplicability}}</span> <span ng-if="appl.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.variableApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{appl.variableApplicability}} </span><span ng-if="appl.codifiedApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.codifiedApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{appl.codifiedApplicability}}</span><br><span class="iconRight icon-icons_arrow_bottom" ng-if="!parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span> <span class="iconRight icon-icons_arrow_top" ng-if="parts.fullMtcDisplayed && parts.applicabilities.length > 1 && $index == 0" ng-click=vm.displayFullMtc(parts)></span></span></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/components/docpriv/docPrivPlates/docPrivPlates.template.html','<table class=table st-table=plateList st-set-filter=customApplicabilityFilter st-safe-src=vm.showFullDocprivResults cellspacing=0 ng-show=vm.numberOfPlate style="width: 100%;table-layout: fixed;"><thead><th class="medium-2 columns noPadding"><div><md-switch ng-model=vm.showDeletedPlate class="medium-2 columns" ng-change=vm.onChange(vm.showDeletedPlate)></md-switch><md-tooltip direction=bottom>{{\'DOCPRIV_DISPLAY_DELETED_PLATES\' | translate}}</md-tooltip></div></th><th class="medium-1 columns"><div style="width: 8%;"><md-checkbox aria-label="Select All" ng-checked=vm.isChecked() class=printAll md-indeterminate=vm.isIndeterminate() ng-click=vm.toggleAll() ng-disabled="vm.showFullDocprivResults.length > 10" ng-if="vm.showFullDocprivResults.length > 1"><span ng-if=vm.isChecked()></span></md-checkbox><em class=icon-icons_print_partlist ng-click="vm.selected.length != 0 && vm.printPlates()" ng-class="{\'disabled\':vm.selected.length == 0}"></em><div ng-if="vm.selected.length != 0">{{vm.selected.length}}&nbsp;/&nbsp;{{(vm.showFullDocprivResults.length >10) ? 10 :vm.showFullDocprivResults.length }}</div></div></th><th class="medium-2 columns noPadding"><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input placeholder="{{\'PLATE_NUMBER\' | translate}}" st-search=plateNo ng-model=plateNo class=materialInput type=text></md-input-container></div></th><th class="medium-3 columns noPadding"><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input placeholder="{{\'GIE DESCRIPTION\'}}" st-search=gieDescription ng-model=gieDescription class=materialInput type=text></md-input-container></div></th><th class="medium-4 columns noPadding" style="float: left; width: 30%"><div class=input-material-container><md-input-container class="md-block flex-gt-sm"><input placeholder="{{\'SIMPLIFIED_APPLICABILITY\' | translate}}" st-search=applicability ng-model=applicability class=materialInput type=text></md-input-container></div></th><th class="fa fa-info-circle iconRight2" style="top:20px; left:-7px;" ng-click=vm.displayManufactureId() ng-if="vm.plateTotalManufactureIds.length > 0"></th></thead><tbody><tr ng-repeat="docPlate in plateList track by $index"><td class="medium-2 columns"><div ng-if="docPlate.status !== \'DELETED\'" style="margin-bottom: 1%;cursor: pointer;"><img ng-src={{docPlate.thumbnailUrl}} style="border: 1px solid black;\n                        margin-top: -4%;height: 120px; width: 150px;" ng-click=vm.varAppBeforeGoToDocprivPage(docPlate) alt=""></div><div ng-if="docPlate.status === \'DELETED\'" style="margin-bottom: 1%;cursor: pointer;"><img ng-src={{docPlate.thumbnailUrl}} style="border: 1px solid black;\n                        margin-top: -4%;height: 120px; width: 150px;" ng-click=vm.varAppBeforeGoToDocprivPage(docPlate) alt=""> <span class=crossImage></span></div></td><td class="medium-1 columns"><md-checkbox ng-checked=vm.exists(docPlate) ng-click=vm.toggle(docPlate) ng-model=docPlate.printSelected ng-if="docPlate.status !== \'DELETED\'" class=printAll ng-disabled="vm.selected.length == 10 && !vm.exists(docPlate)"></md-checkbox></td><td class="medium-2 columns"><div>{{docPlate.plateNo}}</div><div ng-if=docPlate.sieVersion>{{docPlate.sieVersion}}</div><div ng-if=!docPlate.sieVersion>V1</div><div>{{vm.formatDate(docPlate.publicationDate)}}</div></td><td class="medium-3 columns"><div>{{docPlate.gieDescription}}</div></td><td class="medium-4 columns" style="overflow-wrap: break-word;"><div ng-repeat="appl in docPlate.applicability"><span ng-show=appl.display><span>{{appl.fixedApplicability}}</span> <span ng-if="appl.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.variableApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span ng-if=!vm.isManufactureId>{{appl.variableApplicability}} </span><span ng-if=vm.isManufactureId style="white-space: nowrap;">{{appl.manufactuerId}} </span><span ng-if="appl.codifiedApplicability !== \'\'">&nbsp;</span> <span ng-if="appl.codifiedApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{appl.codifiedApplicability}} </span><span class="iconRight icon-icons_arrow_bottom" ng-if="!docPlate.fullMtcDisplayed && docPlate.applicability.length > 1 && $index == 0" ng-click=vm.displayFullMtc(docPlate)></span> <span class="iconRight icon-icons_arrow_top" ng-if="docPlate.fullMtcDisplayed && docPlate.applicability.length > 1 && $index == 0" ng-click=vm.displayFullMtc(docPlate)></span></span></div></td></tr></tbody></table><div ng-hide=true id=divSvgContent1></div><div class=docpriv-word-data><docpriv-word doc-priv-catalog-list=vm.selected parts-list=vm.allPartsResponse is-multiple=true></docpriv-word></div><div ng-show=vm.numberOfPlate><div style="padding-left: 15px;">{{\'DOCPRIV_PLATES_RESULTS_COUNT\' | translate}} {{plateList.length}}</div><div ng-if=vm.masterPlates.next_url><md-button class=md-raised type=submit ng-click=vm.onValidate()><div class=btnText>{{\'LOAD_MORE_RESULTS_BUTTON\' | translate}}</div></md-button></div></div><scroll-up scroll-trigger=300 scroll-anchor=#docPrivPlates></scroll-up>');
$templateCache.put('app/components/docpriv/partDetails/partDetails.template.html','<table id=partDetails ng-style="{\'width\': vm.showApplicabilityData ? \'400px\' : \'500px\'}"><tbody ng-if=vm.showApplicabilityData><tr ng-repeat="criteria in vm.applCriteria"><td class=criteriaAppl><span ng-bind-html="criteria | highlight : vm.fixedData"></span></td></tr></tbody><tbody ng-if=!vm.showApplicabilityData><tr><td class=centerAlign style="font-family: var(--renaultFontBold);">{{vm.partDetails.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(vm.partDetails.reference)></i> <span ng-if="vm.isStandardExchange(vm.partDetails.types) && vm.isTractionBattery(vm.partDetails.familyCode)"><img src=./assets/images/renative.png height=18 width=40 alt=Renative> </span><span ng-if="vm.isStandardExchange(vm.partDetails.types) && !vm.isTractionBattery(vm.partDetails.familyCode)"><img src=./assets/images/renative_reman.png height=18 width=40 alt=""></span></td></tr><tr><td class="centerAlign noLongerPart" ng-if="vm.partDetails.partStatus === \'NO_LONGER_SOLD\'">{{\'NO_LONGER_SOLD_PARTS\' | translate}}</td><td class="centerAlign cancelledPart" ng-if="vm.partDetails.partStatus === \'CANCELLED\'">{{\'CANCELLED_PARTS\' | translate}}</td></tr><tr><td class=centerAlign>{{vm.partDetails.designation}}</td></tr><tr ng-repeat="criteria in vm.applCriteria" class=applicablityCrit ng-if=vm.newApplicability><td style="font-weight: normal !important;" class=centerAlign>{{ criteria }}</td></tr><tr ng-repeat="code in vm.partDetails.codifiedSigns"><td class=centerAlign><span ng-if="$index === 0" style="font-weight: bold;border:2px solid black;">CS</span> <span style="color: grey;">{{::code.designation}} {{::code.textAssociated}} : {{::code.value}}</span></td></tr><tr ng-if="vm.partDetails.additional.length > 0"><td class=headings><i class="fa fa-plus"></i> {{\'ADDITIONAL_PARTS\' | translate}}</td></tr><tr ng-repeat="value in vm.partsGroup"><td class=bulletedList style=list-style-type:none ng-repeat="applicabilities in value.applicability" ng-if="value.applicability.length > 0"><span>{{applicabilities.fixedApplicability}}</span> <span ng-if="applicabilities.variableApplicability !== \'\'">&nbsp;</span> <span ng-if="applicabilities.variableApplicability !== \'\'" style="border-left: 3px solid red;">&nbsp;</span> <span>{{applicabilities.variableApplicability}}</span></td><td class=bulletedList ng-repeat="parts in value.partArray">{{parts.partNumber | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(parts.partNumber)></i> {{\'- \'+parts.designation}} {{(parts.ratio !== \'0\'&& parts.ratio !== \'\' && parts.ratio !== null && parts.ratio > \'1\') ? \'- X\'+parts.ratio : \'\' }}</td><td class="bulletedList separator" ng-if=!$last style=list-style-type:none;><br></td></tr><tr ng-if="(vm.displaySuperseding | json) != \'{}\'"><td class=headings><span class=icon-icons_chaine_remplacement_listPiece></span> {{\'REPLACEMENT_PARTS\' | translate}}</td></tr><tr ng-repeat="supersession in vm.displaySuperseding" ng-init="parentIndex = $index"><td class=bulletedList><span ng-repeat="list in supersession" ng-value={{$index}}><!-- <span ng-if="supersession.length === 1 && list.src !== vm.partDetails.reference">\n                        {{list.src}} {{(supersession[0].replacementType !== null && supersession[0].replacementType !== \'\' && supersession[0].replacementType === \'FULL\') ? \'(Totale)\' : \'(Partiel)\'}}  \n                    </span> --> <span ng-if="supersession.length === 1">{{list.target | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(list.target)></i> {{(supersession[0].replacementType !== null && supersession[0].replacementType !== \'\' && supersession[0].replacementType === \'FULL\') ? \'(Totale)\' : \'(Partiel)\'}} </span><span ng-if="supersession.length === 1">{{(supersession[0].ratio !== \'0\'&& supersession[0].ratio !== \'\' && supersession[0].ratio !== null && supersession[0].ratio > \'1\') ? \'- X\'+supersession[0].ratio : \'\' }} </span><span ng-if="supersession.length > 1">{{list.target}} {{supersession.length - 1 !== $index? \'+\' : \'\'}}</span><div style="width:35%; text-align:center;" ng-if="parentIndex !== vm.keyLength(vm.displaySuperseding)-1"><i class="fa fa-arrow-down" style="color: lightgrey;"></i></div></span><span ng-if="supersession.length > 1">{{(supersession[0].replacementType !== null && supersession[0].replacementType !== \'\' && supersession[0].replacementType === \'FULL\') ? \'(Totale)\' : \'(Partiel)\'}} {{(supersession[0].ratio !== \'0\'&& supersession[0].ratio !== \'\' && supersession[0].ratio !== null && supersession[0].ratio > \'1\') ? \'- X\'+supersession[0].ratio : \'\' }}</span></td></tr></tbody></table>');
$templateCache.put('app/components/favourites/PR/favouritesPR.template.html','<div id=favs class="containerView dialogPR"><!--HEADER TO SELECT READ OR MANAGE MODE--><div class="row headerFavs"><div class="small-3 columns"><div class=titleTm>{{\'HEADER_FAVORITES_PRODUCTS\'| translate}}</div></div><div class="small-9 columns actionBar"><div class=small-2 id=consultMode><div class=margin-top-10 ng-class="{\'modeActif\':!vm.isEditMode}" ng-click=vm.onClickReadMode()>{{\'FAV_READ\'| translate}}</div><div class="switch round small editionToGestion"><input id=exampleRadioSwitch3 type=checkbox name=testGroup ng-model=vm.isEditMode ng-change=vm.onChangeMode()> <label for=exampleRadioSwitch3 style=margin-top:16px;></label></div><div class=margin-top-10 ng-class="{\'modeActif\':vm.isEditMode}" ng-click=vm.onClickEditMode()>{{\'FAV_EDIT\'| translate}}</div></div><div class="addPRButton small-2"><md-button class="md-raised buttonWithIcon" ng-click=vm.addPR()><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText>{{\'FAV_MODAL_ADD_REF_CREATE_BUTTON\' | translate}}</div></md-button></div><!-- BLOC BUTTONS MOVE/DEL --><div class="small-5 whiteChoiceBox" ng-show=!vm.isEditMode></div><div class="small-5 greyChoiceBox" ng-show=vm.isEditMode><div class=row><div class="small-4 txtSelection">{{vm.transmitData}}</div><div class="small-8 actions"><md-button class="buttonWithIcon md-raised" type=submit ng-click=vm.moveRef() ng-disabled=vm.disableButtons><div class=iconDiv><i class=icon-icons_folder></i></div><div class=btnText>{{\'FAV_REF_MOVE\' | translate}}</div></md-button><md-button class="buttonWithIcon margin-left-10 md-raised" ng-click=vm.confirmSelectionDel() ng-disabled=vm.disableButtons><div class=iconDiv><i class=icon-icons_remove></i></div><div class=btnText>{{\'ACTIS_HEADER_CLOSE\' | translate}}</div></md-button></div></div></div></div></div><!--ROW WITH MENU CATEGORIES--><div class="row margin-top-25"><!--BLOC CATEGORIES--><div class="small-3 columns favTable"><div class=categ><div ng-repeat="categorie in vm.favoritesProduct.categories track by $index"><div class=row ng-click=vm.onSelectCategory(categorie) ng-class="{\'activeMenuTab\': $index == vm.selectedCategoryIndex}"><div id=rowCategoryMenu ng-class="{\'activeMenuTab\': $index == vm.selectedCategoryIndex}"><div>{{categorie.categoryName | translate}}</div><span class=categoryChevron><i ng-class=vm.getSaveIconClass(categorie) ng-click=vm.saveChanges(categorie)></i> <i ng-class=vm.getCloseIconClass(categorie) ng-click=vm.closeEdit(categorie)></i> <i ng-class=vm.getEditIconClass(categorie) ng-click=vm.editCategory(categorie)></i> <i ng-class=vm.getCategoryIconClass(categorie) ng-click=vm.showSubCategories(categorie)></i></span></div></div><div class=subCateg ng-repeat="subCategorie in categorie.subCategories track by $index"><div ng-show="categorie.showDetails && !categorie.isEditing" class="row activeSubTabsFromMainCategory" ng-click="vm.onSelectSubCategory(categorie.subCategories, subCategorie)" ng-if="categorie.subCategories.length > 0" ng-class="{\'activeMenuTab\': $index == vm.selectedSubCategoryIndex}"><div class=subCategInfo>{{subCategorie.subCategoryName | translate}}</div></div><div class=subCateg ng-show="!vm.isEditMode && categorie.isEditing"><div class="row activeSubTabsFromMainCategory activeMenuTab"><input class=subCategText type=text name=subCategorie.subCategoryName ng-model=subCategorie.subCategoryName ng-change=vm.editSubCategory(categorie,subCategorie.subCategoryName,$index) maxlength=25> <i class="fa fa-trash dms-icons-family" ng-click=vm.deleteConfirmation(categorie,$index)></i></div></div></div><div class=subCateg ng-show="!vm.isEditMode && categorie.isEditing"><div class="row activeSubTabsFromMainCategory activeMenuTab"><input class=subCategText type=text name=subCategory placeholder="{{\'ADD_SUBCATEGORIE\' | translate}}" ng-model=vm.newSubCategoryName maxlength=25> <i class=icon-icons_expendable_plus ng-click=vm.addSubCategory(categorie,vm.newSubCategoryName)></i></div></div></div></div></div><!--BLOC CATEGORIE PRODUCT--><div class="small-9 columns"><table class="full-width documents-table" cellspacing=0 style="border-bottom: 0px;"><thead><tr class=text-transform-uppercase><th class="small-1 text-align-left" ng-show=vm.isEditMode><input type=checkbox ng-model=vm.selectedAll ng-click=vm.selectAll()></th><th class="small-2 text-align-left" ng-click="vm.sortColumn(\'reference\')"><span>{{\'VIEWED_DOC_REF\' | translate}}</span> <i ng-class="vm.getOrderClass(\'reference\')"></i></th><th class="small-3 text-align-left" ng-click="vm.sortColumn(\'designation\')"><span>{{\'COMMON_DESIGNATION\' | translate}} </span><i ng-class="vm.getOrderClass(\'designation\')"></i></th><th class="small-2 text-align-center">{{\'COMMON_STOCK\' | translate}}</th><th class="small-2 text-align-right">{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate}}</th><th class=small-3></th></tr></thead><tbody class=tmData><tr tabindex=-1 id={{item.index}} ng-init="optionsN1 = {}" ng-repeat="item in vm.favoritesPRList | orderBy: vm.sortedBy : vm.reverse"><td class="small-1 text-align-left" ng-show=vm.isEditMode><input type=checkbox ng-model=item.isSelected ng-click=vm.onSelect()></td><td class="small-2 text-align-left"><span ng-click=vm.goToProductPage(item.reference) class=clickable>{{item.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(item.reference);$event.stopPropagation();></i></span></td><td class="small-3 text-align-left break-all-word">{{item.designation}}</td><td class="small-2 text-align-center" ng-class=vm.getStockClass(item.dmsInformations.quantity)>{{item.dmsInformations.quantity}}</td><td class="small-2 text-align-right">{{item.price | number:2}} {{vm.getCurrentCurrency()}}</td><td class="small-3 row text-align-right" style="border-bottom: 0px;" ng-show="!vm.isEditMode && !vm.category.isEditing"><div class="small-5 column"><shopping-cart-quote piece=item from=PR page=favouritesPR ng-if=vm.isUserDms></shopping-cart-quote></div><div class="small-5 column"><shopping-cart-parts-requisition page=favouritesPR from=PR piece=item options=optionsN1></shopping-cart-parts-requisition></div></td><td class=small-3 ng-show=vm.isEditMode></td></tr></tbody></table><div ng-if="vm.currentPage != vm.totalPage && vm.showMoreLink" ng-click=vm.showMoreReference() class=showMoreLink>{{"SHOW_MORE"|translate}}</div></div></div></div>');
$templateCache.put('app/components/favourites/TM/favourites.template.html','<div id=favs class=containerView><!--HEADER TO SELECT READ OR MANAGE MODE--><div class="row headerFavs"><div class="small-3 columns" style="margin-bottom: auto;"><div class=titleTm>{{\'TM_TITLE\'| translate}}</div></div><div class="small-9 columns actionBar"><div class=small-4 id=consultMode><div class=cursor-default ng-class="{\'modeActif\':!vm.isEdition}" ng-click=vm.onClickReadMode()>{{\'FAV_READ\'| translate}}</div><div class="switch round small editionToGestion"><input id=exampleRadioSwitch3 type=checkbox name=testGroup ng-model=vm.isEdition ng-change=vm.changeToEdition()> <label for=exampleRadioSwitch3></label></div><div class=cursor-default ng-class="{\'modeActif\':vm.isEdition}" ng-click=vm.onClickEditMode()>{{\'FAV_EDIT\'| translate}}</div></div><div class=small-8></div></div></div><!--ROW WITH MENU CATEGORIES--><div class=row><!--BLOC CATEGORIES--><div class="small-3 columns" style="margin-top: 10px;"><div class=categ><div ng-repeat="categorie in vm.categories track by $index"><div class=row ng-click="vm.activateSelectedTab($index, categorie)" ng-class="{\'activeMenuTab\': $index == vm.selectedTab}"><div id=rowCategoryMenu ng-class="{\'activeMenuTab\': $index == vm.selectedTab}"><div class=labelWidth>{{categorie.name | translate}}</div><i ng-class=vm.getCategoryIconClass(categorie) ng-if="categorie.subCategories.length > 0 && categorie.name !== \'TM_NOCODIF_CAT_PAINTING\' && categorie.name !== \'TM_NOCODIF_CAT_FIXPRICE\'"></i></div></div><div class=subCateg ng-show=categorie.showDetails><div class="row customManageCateg activeSubTabsFromMainCategory" ng-repeat="(key, value) in categorie.subCategories" ng-click="vm.activateSelectedSubTab(key, categorie.name, value.name)" ng-class="{\'activeSubTab\': key == vm.selectedSubTab && value.name == vm.selectedSubTabName}" ng-if=value.name><div class=subCategInfo>{{value.name | translate}}</div></div></div></div></div></div><div class="small-9 columns"><div class=row style="background-color: lightgrey; padding: 10px;"><input type=text placeholder="Rechercher par mot-cl\xE9" style="width: 40%; margin: 0px;"><div class=loupeArbo><md-button ng-disabled=true type=button style="min-width: 40px; line-height: 34px;" class="md-raised md-primary"><i class=icon-icons_search_arbo></i></md-button></div><div class=containerButton><md-button class="md-raised buttonWithIcon" ng-click=vm.addTM()><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText>{{\'FAV_ADD_TM\' | translate}}</div></md-button></div></div><table class="full-width documents-table" cellspacing=0><thead><tr style="text-transform: uppercase;"><th class=small-1>{{\'DOCUMENT_TM_ID\' | translate}}</th><th class=small-6>{{\'LIBELLE_TM\' | translate}}</th><th class=small-1>{{\'TECHNICITE_TM\' | translate}}</th><th class=small-2><div class=alignTextRight>{{\'TEMPS_PUBHT_TM\' | translate}}</div></th><th class=small-2>&nbsp;</th></tr></thead><tbody><tr class=tmData ng-repeat="item in vm.displayedData track by $index"><td class=small-1>{{item.opeCode}}</td><td class="small-6 break-all-word">{{item.label}}</td><td class=small-1 style="text-align: center;"><div ng-if=item.technicality ng-switch on=item.technicality><div ng-switch-when=TM_NOCODIF_TECH_VERY_HIGH><span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_3 title="{{\'DOCUMENT_TM_TECHNICALITY_H\' | translate}}"></span></div><div ng-switch-when=TM_NOCODIF_TECH_NORMAL><span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_1 title="{{\'DOCUMENT_TM_TECHNICALITY_N\' | translate}}"></span></div><div ng-switch-default><span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_2 title="{{\'DOCUMENT_TM_TECHNICALITY_T\' | translate}}"></span></div></div></td><td class=small-2><div ng-if=item.time class=alignTextRight>{{item.time | numberFilterCommaTM:1:true}}</div><div ng-if=item.price class=alignTextRight>{{item.price | numberFilterCommaTM:2:false}} {{vm.getCurrentCurrency()}}</div></td><td class=small-2><div ng-if=!vm.isEdition style="display: inline-flex; margin-left: 40%;"><md-button ng-class="{\'md-raised buttonWithIcon alignTextRight shopping-cart\':vm.canAddToQuote,\' buttonWithIcon cancel  disabled\': !vm.canAddToQuote}" ng-click=vm.consultCurrentTm(item) ng-if="!item.quantity || item.quantity <= 0" style="padding-right: 5px !important;"><div class=iconDiv style="border-right: 0px; padding-left: 24%;"><i class="icon-icons_estimation on-super-cart-quote-hover button-estimate"></i></div></md-button><div class=stock-component ng-if="item.quantity > 0" style="width: 88px;"><!--  ***************\n                                        REDUCE\n                                ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=vm.decrement(item) title="{{\'DOCUMENT_PR_DECREASE_BASKET\'| translate}}"></i></div><!-- ****************\n                                        INPUT\n                                ****************** --><div class=stockText><input numbers-only class="text-center number-field" type=text maxlength=3 size=3 ng-change="vm.inputQuantity(item, \'{{item.quantity}}\')" ng-model=item.quantity ng-model-options="{ debounce: 2000 }"></div><!-- ****************\n                                        ADD\n                                ***************** --><div class=square ng-click=vm.increment(item)><i class=icon-icons-phnx_stepper_plus title="{{\'DOCUMENT_PR_INCREASE_BASKET\'| translate}}"></i></div></div></div><!--\n                        <div ng-if="vm.isEdition && item.isEditable" style="margin-left: 50%; margin-right: 50%;">\n                            <div style="display: inline-flex;">\n                                <div>\n                                    <i class="icon-icons_change_technical" style="margin-left: 15px;">\n                                    </i>\n                                </div>\n\n                                <div>\n                                    <i class="icon-icons_remove_panier" style="margin-left: 15px;">\n                                    </i>\n                                </div>\n                            </div>\n                        </div>\n                        --><div ng-if="vm.isEdition && !item.isEditable" class=edition-options><div><i ng-click=vm.updateTM(item) class="fa fa-pencil font-icon margin pointer"></i></div><div><i ng-click=vm.deleteTM(item) class="icon-icons_remove_panier margin"></i></div></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/components/partRequisition/shoppingCart/shoppingCartPartsRequisition.template.html','<div ng-switch=vm.page><div class=stock-component><!-- ********************************\n                PART REQUISITION PAGE\n        ************************************ --><div ng-switch-when=partsRequisition class=stock-component><!--  ***************\n               REDUCE\n           ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=vm.reduceOne() ng-if="vm.piece.quantity > 1" ng-keydown="$event.key === \'Enter\' && vm.reduceOne()" title="{{\'DOCUMENT_PR_DECREASE_PARTLIST\'| translate}}"></i></div><!-- ****************\n                INPUT\n            ****************** --><div class=stockText><input id=quantity-input-main float-only class="decimal text-center" type=text ng-model=vm.piece.quantity pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ ng-model-options="{ debounce: 2000 }" ng-change=vm.updateFromInputSecond(vm.piece.quantity)></div><!-- ****************\n               ADD\n           ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=vm.addOne() ng-keydown="$event.key === \'Enter\' && vm.addOne()" title="{{\'DOCUMENT_PR_INCREASE_PARTLIST\'| translate}}"></i></div></div><!-- ********************************\n                OTHER PAGES\n        ************************************ --><div ng-switch-default=ng-switch-default class=float-right><div class=stock-component ng-if=vm.piece.quantity><!--  ***************\n                        REDUCE\n                ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=vm.reduceOne() ng-keydown="$event.key === \'Enter\' && vm.reduceOne()" title="{{\'DOCUMENT_PR_DECREASE_PARTLIST\'| translate}}"></i></div><!-- ****************\n                        INPUT\n                ****************** --><div class=stockText><label for=quantity-input-default class=sr-only>Quantity</label> <input id=quantity-input-default float-only class="decimal text-center" type=text ng-model=vm.piece.quantity pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ ng-model-options="{ debounce: 2000 }" ng-change=vm.updateFromInputSecond(vm.piece.quantity)></div><!-- ****************\n                        ADD\n                ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=vm.addOne() ng-keydown="$event.key === \'Enter\' && vm.addOne()" title="{{\'DOCUMENT_PR_INCREASE_PARTLIST\'| translate}}"></i></div></div><!-- ***************************\n                    ADD TO SHOPPING CART\n            **************************** --><div ng-if=!vm.piece.quantity ng-style="{\'width\':vm.isLandscape ? \'50px\' : \'\'}" id=addToPR one-click-only="vm.canAddToPartsrequisition && vm.addToShoppingCart()" ng-class=vm.getShoppingCartClass() title="{{\'DOCUMENT_PR_INCREASE_PARTLIST\'| translate}}"><i class=icon-icons_basket></i></div></div></div></div>');
$templateCache.put('app/components/orderModule/validate/orderModeSaveInDB.template.html','<div class=orderModepop><span class=alertCloseIcon style="font-size: 25px;"><i class="fa fa-info-circle"></i> </span><span ng-click=vm.onCancel()><i class="fa fa-close" style=float:right;></i></span><div style=padding:6px;font-weight:bold;>{{"ORDER_NO_SAVE_MESSAGE"|translate}}</div><div style=padding:6px;font-weight:bold; ng-if=vm.isOrderPlaced>{{"ORDER_NO_SAVE_MESSAGE2"|translate}}</div></div>');
$templateCache.put('app/components/orderModule/validate/validatedOrder.template.html','<div class=containerView id=validatedOrder><!--BLOC HEADER --><div class="row headerPartList"><div class="small-1 columns numPartList" ng-if=vm.isBackButtonExist><div class=backPartList ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-5 columns"><label class=labelNumPartList><span ng-if="vm.addOrderResponse && vm.addOrderResponse.orderNumber">{{"ORDER_NUMBER" |translate}} {{vm.addOrderResponse.orderNumber}}</span></label> <label class="labelValidateByPartList font-size-20"><span>{{vm.validatedDateAndInfo}}</span></label></div><div class="small-5 columns listPartListAction"><div ng-click=vm.printOrder(true) class=clickable><i class="fa fa-download"></i> <label>{{\'BUTTON_ESTIMATE_DOWNLOAD\' |translate}}</label></div><div ng-click=vm.downloadCSV() class=clickable ng-if=!vm.isDmsConnected><i class=icon-icons_export_csv_panier></i> <label>{{\'BUTTON_ESTIMATE_EXPORT\' |translate}}</label></div><div ng-click=vm.backToPrevious() class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><div class="commentBloc small-6" ng-if="vm.validatedOrder.orderMark && vm.validatedOrder.orderMark != \'\'"><span style=font-weight:bold;>{{\'ORDER_MARK\'| translate}}:</span><div><span>{{vm.validatedOrder.orderMark}}</span></div></div><br ng-if="vm.validatedOrder.orderMark && vm.validatedOrder.orderMark != \'\'"><div class="commentBloc small-6" ng-if="vm.validatedOrder.message && vm.validatedOrder.message != \'\'"><span style=font-weight:bold;>{{\'VALIDATED_ORDER_MESSAGE\'| translate}}:</span><div><span>{{vm.validatedOrder.message}}</span></div></div><br ng-if="vm.validatedOrder.message && vm.validatedOrder.message != \'\'"><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic" style="background-color: #F1F2F3; border: none;min-height: 0px !important;">{{\'RGPD_MESSAGE\' |translate}}</div></div><!-- BLOC ITEMS --><div class=blocVehiculePartList ng-if="vm.validatedOrder.items.length > 0"><div class=row><div class="small-12 columns blocVehiculeBandeauValidate"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div ng-if=vm.vehicle class=vehicleHeader><label class=designationVehiculeBlocContext><span ng-if=vm.vehicle.model>{{vm.vehicle.model}}</span> <span ng-if=vm.vehicle.motorisation>, {{vm.vehicle.motorisation}}</span> <span ng-if=vm.vehicle.gearBoxType>, {{vm.vehicle.gearBoxType}}</span></label> <label class=vinImatVehiculeBlocContext><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span> <span ng-if="vm.validatedOrder.orderNumber && vm.validatedOrder.orderNumber != \'-\'" class=orderNumber><i class=icon-icons_repair></i> {{vm.validatedOrder.orderNumber}}</span></label></div></div></div></div><div class=row><!-- HEADER VEHICLE --><div class="row headerTabListPRorTM" style="padding-top: 5px;"><div class="small-12 columns"><div class="small-1 columns partListTitle ref_div_width" ng-click="vm.sortBy(\'reference\')"><label>{{"PARTLIST_REF_PR_PLACEHOLDER" | translate}}</label> <i class=icon-icons_order_partlist></i></div><div class="small-4 columns partListTitle"><label>{{\'COMMON_DESIGNATION\' | translate}}</label></div><div class="small-2 columns partListTitle text-align-right"><label><div>{{"WHOLESALER_LABEL"|translate}}</div><div>{{\'WHOLESALER_GUP_TAX\' | translate}}</div></label></div><div class="small-2 columns partListTitle text-align-center" ng-click=vm.displayAllDiscountRate()><label>{{\'ORDERING_MODULE_DISCOUNT_CODE\' | translate}} <i class=iconRight ng-class="vm.showAllDiscountRate? \'icon-icons_arrow_top\' : \'icon-icons_arrow_bottom\'"></i></label></div><div class="small-1 columns partListTitle text-align-center"><label>{{\'PARTLIST_TABLE_TITLE_QUANTITY\' | translate}}</label></div><div class="small-2 columns partListTitle ref_div_width"><label><div>{{"WHOLESALER_LABEL"|translate}}</div><div>{{"R1_AVAILABILITIES"|translate}}</div></label></div></div></div><!-- REFERENCES LIST --><div class="row contentTabListPRorTM" ng-repeat="item in vm.validatedOrder.items | orderBy:vm.propertyName:vm.reverse"><div class="small-12 columns"><div class="small-1 columns partListCol"><label>{{item.reference | filterFormatRef}}</label></div><div class="small-4 columns partListCol"><label class=display-inline-block>{{item.designation}}</label></div><div class="small-2 columns partListCol text-align-right"><label><div ng-if="!vm.isCountryChina && !vm.isCountryIndia && !vm.validatorInfo.urgentOrder" class=partListCol><span class=caractere_label ng-if=item.priceAdvisedTaxFree>{{item.priceAdvisedTaxFree}} {{item.currency}}&nbsp;</span> <span class=caractere_label ng-if="!item.priceAdvisedTaxFree && !vm.isCountryRoumania && (item.dmsInformations.priceExclTaxes || item.price)">{{vm.getPriceToDisplay(item)}} {{vm.getCurrencyForItem(item)}}&nbsp;</span></div><div ng-if="!vm.isCountryChina && !vm.isCountryIndia && vm.validatorInfo.urgentOrder" class=partListCol><span class=caractere_label ng-if=item.priceUrgentTaxFree>{{item.priceUrgentTaxFree}} {{item.currency}}&nbsp;</span> <span class=caractere_label ng-if="!item.priceUrgentTaxFree && !vm.isCountryRoumania && (item.dmsInformations.priceExclTaxes || item.price)">{{vm.getPriceToDisplay(item)}} {{vm.getCurrencyForItem(item)}}&nbsp;</span> <span class=caractere_label ng-if="!item.priceUrgentTaxFree && !vm.isCountryRoumania && !item.price && !item.dmsInformations.priceExclTaxes">-</span></div><div ng-if="vm.isCountryChina || vm.isCountryIndia"><div class=caractere_label>-</div></div></label></div><div class="small-2 columns partListCol text-align-center"><label><div class="caractere_label partListCol" style="cursor: pointer;" ng-if=item.discountCode ng-click=vm.displayDiscountRate(item)><span ng-if="!item.isDiscountcodeVisible && item.itemReturnCode === \'A000\'">{{item.discountCode}} </span><span class="iconRight icon-icons_arrow_bottom" ng-if="!item.isDiscountcodeVisible && item.itemReturnCode === \'A000\'"></span> <span ng-if="item.isDiscountcodeVisible && item.priceTaxFree && item.discountRate">{{item.priceTaxFree}} {{item.currency}} {{\'PRODUCT_EXCL_TAX\' | translate | uppercase}} <span class="iconRight icon-icons_arrow_top" ng-if=item.isDiscountcodeVisible></span><div style="font-size: var(--renaultSmallFont);"><span ng-if=!vm.validatorInfo.urgentOrder>{{item.discountRate}}</span> <span ng-if=vm.validatorInfo.urgentOrder>{{item.discountRateUrgent}}</span> {{\'%\'}}</div></span></div><div class=caractere_label ng-if="!item.discountCode ">{{\'-\'}}</div></label></div><div class="small-1 columns partListCol text-align-center"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>-</label></div><div class="small-2 columns partListCol"><label ng-if=item.applicableClass>{{item.applicableClass |translate}}</label> <label ng-if=!item.applicableClass>-</label></div></div></div></div><md-input-container ng-if=vm.validatorInfo.urgentOrder style="margin:1% 0;"><md-checkbox ng-model=vm.validatorInfo.urgentOrder md-no-ink ng-disabled=true>{{\'URGENT_ORDER\' | translate}}</md-checkbox></md-input-container></div>');
$templateCache.put('app/components/products/documents/documents.html','<recap-car api=documentsMenuCtrl.recapCarAPI icons=true></recap-car><div style="padding-bottom: 10px;" ng-if=documentsMenuCtrl.isSearchEngine id=carSearchArbo><div id=searchArboTextual class=containerView><div class=row id=searchArboTextualTable><div class="row headerView noMargin"><div id=line_recherche class=newSearchBar_row><div class="small-12 large-10 columns"><div class="small-1 columns srchBtnBack" ng-click=documentsMenuCtrl.goToHome() style="white-space: nowrap;"><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}}</div><div id=searchByCategories class="small-2 columns categories"><md-input-container ng-class=" {\'input-container newcategorySearch\':documentsMenuCtrl.isSearchEngine && !documentsMenuCtrl.nissanUserURL, \'input-container\':!documentsMenuCtrl.isSearchEngine && !documentsMenuCtrl.nissanUserURL, \'input-container nissannewcategorySearch\':documentsMenuCtrl.nissanUserURL}"><!-- <label>{{searchArboTextualCtrl.filterTypes[0].label}}</label> --><md-select md-container-class="my-container newSearch_Dropdown" ng-class="{\'nissanmenu\': documentsMenuCtrl.nissanUserURL}" name=filterChoosen id={{field.label}} ng-model=documentsMenuCtrl.filterChoosen ng-change=documentsMenuCtrl.changeFilter(documentsMenuCtrl.filterChoosen) ng-model-options="{trackBy: \'$value.id\'}" class="selectCategoryStyle selectBoxz" ng-class="{\'nissanmenu\': documentsMenuCtrl.nissanUserURL}"><md-option ng-value=filter ng-if="mainCtrl.isCountryKorea && !documentsMenuCtrl.nissanUserURL" ng-repeat="filter in documentsMenuCtrl.filterTypes | onlyMRandMDandPR">{{filter.label}}</md-option><md-option ng-value=filter ng-if="!mainCtrl.isCountryKorea && !documentsMenuCtrl.contextCarBrandCheck && !documentsMenuCtrl.nissanUserURL" ng-repeat="filter in documentsMenuCtrl.filterTypes">{{filter.label}}</md-option><md-option ng-value=filter ng-if="documentsMenuCtrl.contextCarBrandCheck && !documentsMenuCtrl.nissanUserURL" ng-repeat="filter in documentsMenuCtrl.filterTypes | onlyTMandMRandMDandTMLIST">{{filter.label}}</md-option><md-option ng-value=filter ng-if=documentsMenuCtrl.nissanUserURL ng-class="{\'nissanOptionFocus\': documentsMenuCtrl.nissanUserURL}" ng-repeat="filter in documentsMenuCtrl.filterTypes | onlyMRandMD">{{filter.label}}</md-option></md-select></md-input-container><div ng-if=filter.label ng-click="filter.label = null;"><md-button class=btnClose>X</md-button></div></div><div id=keyWord ng-class=" {\'small-8 columns type_keyWord\':documentsMenuCtrl.isSearchEngine && !documentsMenuCtrl.nissanUserURL, \'small-8 columns typeKeyword_ref\':!documentsMenuCtrl.isSearchEngine && !documentsMenuCtrl.nissanUserURL, \'small-8 columns nissan_type_keyWord\':documentsMenuCtrl.nissanUserURL}"><md-input-container class="input-container hide-validation-error border-bottom-new"><input ng-model-options="{ debounce: 100 }" class="newinputReset inputNormal" ng-class=" {\'carSearchFormCell\': documentsMenuCtrl.stateInputsForm[\'motCle\'].active == false, \'inputResetItalique\' : documentsMenuCtrl.stateInputsForm[\'motCle\'].active == undefined,\'nissanInputReset\':documentsMenuCtrl.nissanUserURL}" type=text name=motCle ng-model=documentsMenuCtrl.motCle placeholder="{{ (documentsMenuCtrl.filterChoosen.id != \'TM_LIST\') ? (\'CAR_SEARCH_EXAMPLE_OF_KEY_WORD_NEW\' | translate) : (\'CAR_SEARCH_EXAMPLE_OF_TM_LIST\' | translate)}}" ng-focus="documentsMenuCtrl.switchState(\'motCle\', true)" ng-blur="documentsMenuCtrl.switchState(\'motCle\', false)" ng-change=documentsMenuCtrl.onChangeMotCle() ng-keypress=documentsMenuCtrl.onKeyPressed($event) autocomplete=off phenix-enter=documentsMenuCtrl.searchEngineDocs(true)></md-input-container><div ng-click=documentsMenuCtrl.reinitSearch() ng-class="{\'newSearchReset reset_Search\':documentsMenuCtrl.isSearchEngine, \'reset resetSearch\':!documentsMenuCtrl.isSearchEngine}" ng-show=documentsMenuCtrl.motCle><i class=icon-icons_close></i></div><div class=loupeArbo style="left: 1%; position: relative;" ng-click=documentsMenuCtrl.searchEngineDocs(true) id=newSearchbtn><md-button ng-class="{\'nissanButton\': documentsMenuCtrl.nissanUserURL}"><i class="clickable fa fa-search position-relative" style="bottom:15%; right:3%;"></i></md-button></div></div></div></div></div><div id=autoComplete class="small-12 columns docAutoCompleteList" ng-if=documentsMenuCtrl.showAutocomplete><div class="small-6 columns"></div><div class="small-6 columns"><ul class=docAutoCompleteList><li ng-repeat="item in documentsMenuCtrl.autocompleteList" md-highlight-text=documentsMenuCtrl.motCle md-highlight-flags=gi ng-click=documentsMenuCtrl.getItemfromAutocomplete(item) ng-class="{\'renaultDropDown\': !documentsMenuCtrl.nissanUserURL, \'nissanDropDown\': documentsMenuCtrl.nissanUserURL}">{{item.label}}</li></ul></div></div></div></div></div><div id=listePiece class=containerView><div ng-if=!documentsMenuCtrl.isSearchEngine ng-class="{\'listPieceNissanMenu\': documentsMenuCtrl.nissanUserURL, \'listPieceRenaultMenu\': !documentsMenuCtrl.nissanUserURL}"><div class=infoNode><div ng-if=!documentsMenuCtrl.isRedirectFromSearchEngine class=btnBack ng-click=documentsMenuCtrl.goToHome()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}}</div><div ng-if=documentsMenuCtrl.isRedirectFromSearchEngine class=btnBack ng-click=documentsMenuCtrl.goToSearchEngine()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</div><div ng-if=documentsMenuCtrl.backButtonEnable class=btnBack ng-click=documentsMenuCtrl.goToPreviousPage()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</div><div class=separator></div><div class=textNode><div class=infoPieceBis><div ng-click=documentsMenuCtrl.goToArbo(documentsMenuCtrl.dataNode.node1)>{{documentsMenuCtrl.labelNode1}}</div><i ng-if=documentsMenuCtrl.labelNode2 class=icon-icons-phnx_arrow_link></i><div ng-class="{infoPiece : !documentsMenuCtrl.labelNode3}" ng-click=documentsMenuCtrl.goToArbo(documentsMenuCtrl.dataNode.node2)>{{documentsMenuCtrl.labelNode2}}</div><i ng-if=documentsMenuCtrl.labelNode3 class=icon-icons-phnx_arrow_link></i></div><div class=infoPiece>{{documentsMenuCtrl.labelNode3}}</div></div></div><div ng-if="!documentsMenuCtrl.isTireNodeSelected && !documentsMenuCtrl.isIndependentUser" ng-style="{\'width\' :documentsMenuCtrl.isLandscape ? \'105%\' : \'\'}"><tabset><tab style=flex:1 heading="{{\'HEADER_PR\' | translate}}" active="documentsMenuCtrl.documentType === \'PR\'" ng-attr-class="{{documentsMenuCtrl.count.PR === 0 && \'divTab-disabled-20\' || \'width-20\' }}" disabled="documentsMenuCtrl.count.PR === 0" ng-hide="documentsMenuCtrl.contextCarBrandCheck || documentsMenuCtrl.nissanUserURL" ng-click="documentsMenuCtrl.count.PR !== 0 && documentsMenuCtrl.selectTab(\'PR\')"><div ui-view=pr></div></tab><tab style=flex:1 heading="{{\'HEADER_PRODUCTS\' | translate}}" active="documentsMenuCtrl.documentType === \'PRODUCT\'" ng-attr-class="{{ documentsMenuCtrl.count.PRODUCT === 0  ? \'divTab-disabled-20\' : documentsMenuCtrl.count.PRODUCT !== 0? \'width-20\' :\'\'}}" disabled="documentsMenuCtrl.count.PRODUCT === 0" ng-hide="documentsMenuCtrl.contextCarBrandCheck || documentsMenuCtrl.nissanUserURL" ng-click="documentsMenuCtrl.count.PRODUCT !== 0 && documentsMenuCtrl.selectTab(\'PRODUCT\')"><div ui-view=products id=products ng-if=!documentsMenuCtrl.nissanUserURL></div></tab><tab heading="{{\'INTERVENTIONS_NEW\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'INT_REPAIR\'" ng-attr-class="{{ documentsMenuCtrl.count.INT_REPAIR === 0 && \'divTab-disabled-20\' || \'width-20\' }}" disabled="documentsMenuCtrl.count.INT_REPAIR === 0" ng-hide="documentsMenuCtrl.contextCarBrandCheck || documentsMenuCtrl.nissanUserURL" ng-click="documentsMenuCtrl.count.INT_REPAIR !== 0 && documentsMenuCtrl.selectTab(\'INT_REPAIR\')" ng-if=" documentsMenuCtrl.isInterventionAccess"><div ui-view=INT_REPAIR id=INT_REPAIR></div></tab><tab heading="{{\'HEADER_TM\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'TM\'" ng-attr-class="{{ documentsMenuCtrl.count.TM === 0 && \'divTab-disabled-20\' || \'width-20\' }}" disabled="documentsMenuCtrl.count.TM === 0" ng-if=!mainCtrl.isCountryKorea ng-hide=documentsMenuCtrl.nissanUserURL ng-click="documentsMenuCtrl.count.TM !== 0 && documentsMenuCtrl.selectTab(\'TM\')"><div ui-view=tm></div></tab><tab ng-if=!documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MR\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'MR\'" ng-attr-class="{{\n                                    documentsMenuCtrl.count.MR === 0  ? \'divTab-disabled-20\'\n                                    : documentsMenuCtrl.count.MR !== 0 ? \'width-20\' : \'\'}}" disabled="documentsMenuCtrl.count.MR === 0" ng-click="documentsMenuCtrl.count.MR !== 0 && documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><tab ng-if=documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MR\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'MR\'" ng-attr-class="{{\n                                    (documentsMenuCtrl.count.MR === 0  ? \'divTab-disabled-20\'\n                                    : documentsMenuCtrl.count.MR !== 0 ? \'width-20\' : \'\') + \' nissan-tab\'}}" disabled="documentsMenuCtrl.count.MR === 0" ng-click="documentsMenuCtrl.count.MR !== 0 && documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><!-- MD Tab for Renault Users --><tab ng-if=!documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MD\' | translate}}" active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 ng-attr-class="{{\n                                    documentsMenuCtrl.count.MD === 0  ? \'divTab-disabled-20\'\n                                    : documentsMenuCtrl.count.MD !== 0 ? \'width-20\' : \'\'}}" disabled="documentsMenuCtrl.count.MD === 0" ng-click="documentsMenuCtrl.count.MD !== 0 && documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab><tab ng-if=documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MD\' | translate}}" active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 ng-attr-class="{{\n                                    (documentsMenuCtrl.count.MD === 0  ? \'divTab-disabled-20\'\n                                    : documentsMenuCtrl.count.MD !== 0 ? \'width-20\' : \'\') + \' nissan-tab\'}}" disabled="documentsMenuCtrl.count.MD === 0" ng-click="documentsMenuCtrl.count.MD !== 0 && documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab></tabset></div><div ng-if="!documentsMenuCtrl.isTireNodeSelected && documentsMenuCtrl.isIndependentUser"><tabset><tab ng-if=$root.asomDocList.PR style=flex:1 heading="{{\'HEADER_PR\' | translate}}" active="documentsMenuCtrl.documentType === \'PR\'" ng-attr-class="{{documentsMenuCtrl.count.PR === 0 && \'divTab-disabled-20\' || \'width-20\' }}" disabled="documentsMenuCtrl.count.PR === 0" ng-click="documentsMenuCtrl.count.PR !== 0 && documentsMenuCtrl.selectTab(\'PR\')"><div ui-view=pr></div></tab><tab ng-if=$root.asomDocList.PR style=flex:1 heading="{{\'HEADER_PRODUCTS\' | translate}}" active="documentsMenuCtrl.documentType === \'PRODUCT\'" ng-attr-class="{{ documentsMenuCtrl.count.PRODUCT === 0  ? \'divTab-disabled-20\' : documentsMenuCtrl.count.PRODUCT !== 0? \'width-20\' :\'\'}}" disabled="documentsMenuCtrl.count.PRODUCT === 0" ng-click="documentsMenuCtrl.count.PRODUCT !== 0 && documentsMenuCtrl.selectTab(\'PRODUCT\')"><div ui-view=products id=products></div></tab><tab ng-if=$root.asomDocList.TM heading="{{\'HEADER_TM\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'TM\'" ng-attr-class="{{ documentsMenuCtrl.count.TM === 0 && \'divTab-disabled-20\' || \'width-20\' }}" disabled="documentsMenuCtrl.count.TM === 0" ng-if=!mainCtrl.isCountryKorea ng-click="documentsMenuCtrl.count.TM !== 0 && documentsMenuCtrl.selectTab(\'TM\')"><div ui-view=tm></div></tab><tab ng-if=$root.asomDocList.MR heading="{{\'HEADER_MR\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'MR\'" ng-attr-class="{{\n                                        documentsMenuCtrl.count.MR === 0  ? \'divTab-disabled-20\'\n                                        : documentsMenuCtrl.count.MR !== 0 ? \'width-20\' : \'\'}}" disabled="documentsMenuCtrl.count.MR === 0" ng-click="documentsMenuCtrl.count.MR !== 0 && documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><tab ng-if=$root.asomDocList.MD heading="{{\'HEADER_MD\' | translate}}" active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 ng-attr-class="{{\n                                        documentsMenuCtrl.count.MD === 0  ? \'divTab-disabled-20\'\n                                        : documentsMenuCtrl.count.MD !== 0 ? \'width-20\' : \'\'}}" disabled="documentsMenuCtrl.count.MD === 0" ng-click="documentsMenuCtrl.count.MD !== 0 && documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab></tabset></div><div ng-if=documentsMenuCtrl.isTireNodeSelected ui-view=tires></div></div><div ng-if="documentsMenuCtrl.isSearchEngine && !documentsMenuCtrl.isIndependentUser" ng-class="{\'listPieceNissanMenu\': documentsMenuCtrl.nissanUserURL, \'listPieceRenaultMenu\': !documentsMenuCtrl.nissanUserURL}"><tabset><tab style=flex:1 heading="{{\'HEADER_PR\' | translate}}" active="documentsMenuCtrl.documentType === \'PR\'" class=width-20 ng-hide="documentsMenuCtrl.contextCarBrandCheck || documentsMenuCtrl.nissanUserURL" ng-click="documentsMenuCtrl.selectTab(\'PR\')"><div ui-view=pr></div></tab><tab heading="{{\'HEADER_TM\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'TM\'" class=width-20 ng-if=!mainCtrl.isCountryKorea ng-hide=documentsMenuCtrl.nissanUserURL ng-click="documentsMenuCtrl.selectTab(\'TM\')"><div ui-view=tm></div></tab><tab ng-if=!documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MR\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'MR\'" class=width-20 ng-click="documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><tab ng-if=documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MR\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'MR\'" class="width-20 nissan-tab" ng-click="documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><tab ng-if=!documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MD\' | translate}}" active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 class=width-20 ng-click="documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab><tab ng-if=documentsMenuCtrl.nissanUserURL heading="{{\'HEADER_MD\' | translate}}" active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 class="width-20 nissan-tab" ng-click="documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab></tabset></div><div ng-if="documentsMenuCtrl.isSearchEngine && documentsMenuCtrl.isIndependentUser" ng-class="{\'listPieceNissanMenu\': documentsMenuCtrl.nissanUserURL, \'listPieceRenaultMenu\': !documentsMenuCtrl.nissanUserURL}"><tabset><tab style=flex:1 heading="{{\'HEADER_PR\' | translate}}" ng-if=$root.asomDocList.PR active="documentsMenuCtrl.documentType === \'PR\'" class=width-20 ng-click="documentsMenuCtrl.selectTab(\'PR\')"><div ui-view=pr></div></tab><tab heading="{{\'HEADER_TM\' | translate}}" style=flex:1 active="documentsMenuCtrl.documentType === \'TM\'" class=width-20 ng-if="!mainCtrl.isCountryKorea && $root.asomDocList.TM" ng-click="documentsMenuCtrl.selectTab(\'TM\')"><div ui-view=tm></div></tab><tab heading="{{\'HEADER_MR\' | translate}}" style=flex:1 ng-if=$root.asomDocList.MR active="documentsMenuCtrl.documentType === \'MR\'" class=width-20 ng-click="documentsMenuCtrl.selectTab(\'MR\')"><div ui-view=mr></div></tab><tab heading="{{\'HEADER_MD\' | translate}}" ng-if=$root.asomDocList.MD active="documentsMenuCtrl.documentType === \'MD\'" style=flex:1 class=width-20 ng-click="documentsMenuCtrl.selectTab(\'MD\')"><div ui-view=md></div></tab></tabset></div></div><!-- Chatbot Component --><nd-chatbot ng-if=documentsMenuCtrl.isNDAssistantEnabled></nd-chatbot>');
$templateCache.put('app/components/products/product/product.html','<div class=product ng-if=!productctrl.loading><!--<pre>{{productctrl | json}}</pre>--><div class="row marginBottom marginTop"><div class=blackLink ng-if="productctrl.documentsHistory.length > 1" ng-click=productctrl.goToListPiece()><span class=icon-icons-phnx_double_back></span></div><span class="columns small-1 productBack" ng-if=!productctrl.isNavigatedfromDocPriv><span class=blackLinkBack ng-click=productctrl.backToPrevious()><span class=icon-icons_back_product></span> <span class=textBackProduct>{{\'PRODUCT_PREVIOUS\' |translate}}</span> </span></span><span class="columns small-11" ng-class="!productctrl.isNavigatedfromDocPriv  ? \'rubonProduct\' : \'\'"><span class=productDesignation>{{productctrl.product.designation}}</span> <span ng-if="productctrl.showRenativePicto && productctrl.isRemanrenative"><img src=./assets/images/renative.png height=20 width=60 alt=Renative style="margin-left: 5px;"> </span><span ng-if=productctrl.canShowingFds class=icon-icons_warning_document_product></span> <span ng-if=productctrl.canShowingReach><img class=marginPicto src=./assets/svg/reach.svg height=16 width=16 alt=""> </span><span ng-if=productctrl.displayReplacement(productctrl.replacementList) class=icon-icons_chaine_remplacement_listPiece></span> <span ng-if=productctrl.canShowingMemo class=icon-icons_memo_it_product></span> <span ng-if="productctrl.product.kit.length > 0 && productctrl.product.kit != null" class=icon-icons_kit></span><!-- <span ng-if="!productctrl.product.isFavourite" class="right icon-icons_favorite_product" ng-click="productctrl.putReferenceInFavourites()"\n                tooltip-placement="left" tooltip-html-unsafe="{{productctrl.TRAD.tooltipTextIsNotFavourites}}" tooltip-trigger="click"></span>\n            <span ng-if="productctrl.product.isFavourite" class="right icon-icons_favorite_product_full" tooltip-placement="left" tooltip-html-unsafe="{{productctrl.TRAD.tooltipTextIsFavourites}}"></span> --><div class=row><span class="columns small-2 width-initial ref-vertical-adjust">{{productctrl.product.originalPartReference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productctrl.copyToClipboard(productctrl.product.originalPartReference)></i></span><!-- <span class="columns small-2 width-initial replacement-vertical-adjust no-padding-left" ng-if="productctrl.originalProduct && (productctrl.product.reference !== productctrl.originalProduct.reference)">\n                ({{\'PRODUCT_REPLACEMENT_OF\' |translate}} {{productctrl.originalProduct.reference | filterFormatRef}})\n            </span> --> <span ng-if="productctrl.isRemanufacturedMotrio(productctrl.product.types, productctrl.product.familyCode)" class="columns small-1 no-padding-left"><img src=./assets/images/motrio_reman.png height=30 width=50 alt="Remanufactured Motrio"> </span><span ng-if="productctrl.isMotrio(productctrl.product.types) && !productctrl.isRemanufacturedMotrio(productctrl.product.types, productctrl.product.familyCode)" class="columns small-1 no-padding-left"><img src=./assets/images/motrio.png class=motrioProduct alt=""> </span><span ng-if="productctrl.isStandardExchange(productctrl.product.types) && productctrl.isTractionBattery(productctrl.product.familyCode)" class="columns small-3 no-padding-left"><img src=./assets/images/renative.png height=25 width=40 alt=Renative> </span><span ng-if="productctrl.isStandardExchange(productctrl.product.types) && !productctrl.isTractionBattery(productctrl.product.familyCode)" class="columns small-3 no-padding-left"><img src=./assets/images/renative_reman.png height=25 width=40 alt=""> </span><span ng-if=productctrl.isValuePlus(productctrl.product.types) class="columns small-3 no-padding-left"><img src=./assets/images/value+.png height=30 width=50 alt=""> </span><span ng-if=productctrl.isEcoValue(productctrl.product.types) class="columns small-3 no-padding-left"><img src=./assets/images/renative.png height=30 width=50 alt=""> </span><span class="columns small-6"></span></div></span></div><div class=row><div class="small-8 medium-8 columns"><div class=row ng-if=productctrl.product.fullDesignation><span class="columns small-2 width-initial ref-vertical-adjust">{{productctrl.product.fullDesignation}}</span></div><div class="productText marginBottom">{{productctrl.product.comments.description}}</div><!--=====================================\n            =                  TABS                 =\n            ======================================--><tabset class=productBorder><!--=====================================\n                =            DETAILS TAB                =\n                ======================================--><tab ng-click=productctrl.tabSelected(0) active="productctrl.activeTab == 0" class="small-4 bold text-center tabsetHeadingProduct" heading="{{\'PRODUCT_DETAILS\' |translate}}"><div class=productPadding><div style="margin-bottom: 15px;"><span style="color: #c80e0e;" class="titleMargin productDetailsTitles" ng-if="productctrl.product.codeEpui===\'A\'">{{\'CODEEPUI_A_ERROR\'| translate}} </span><span class="titleMargin productDetailsTitles" ng-if="productctrl.product.codeEpui===\'V\'">{{\'CODEEPUI_V_ERROR\'| translate}}</span></div><div class=corporate-designation-container ng-if="productctrl.isDmsConnected && productctrl.product.corporateDesignation !== productctrl.product.designation"><span class="titleMargin productDetailsTitles">{{\'CORPORATE_DESGINATION\' |translate}} :</span><div class=corporate-designation>{{productctrl.product.corporateDesignation}}</div></div><!--<div class="codifiedSigns" ng-if="productctrl.codifiedSigns.length > 0">\n                        <span class="titleMargin productDetailsTitles">{{\'PRODUCT_SPECIFIC_ATTRIBUTES\' |translate}}</span>\n                        <div class="paraProduct" ng-repeat="cs in productctrl.codifiedSigns track by $index">{{cs}}</div>\n                        </div>--><!-- - - - - - - - - - - -  --><!-- TECHNICAL INFORMATIONS --><!-- - - - - - - - - - - -  --><div style="margin-bottom: 15px;" ng-if=productctrl.canShowTechnical><span class="titleMargin productDetailsTitles">{{\'PRODUCT_TECHNICAL_INFORMATION\' |translate}}</span><div class=column><!-- loop in technicalinformations types (familly,  part, model)--><!-- <div ng-repeat="technicalCriteria in productctrl.product.technicalInformations"> --><div ng-if="productctrl.product.technicalInformations.length > 0" class=paraProduct><!-- loop inside types --><div ng-repeat="criteria in productctrl.product.technicalInformations"><span class=paraProduct>{{criteria.value}}</span></div></div><!-- </div> --></div></div><!-- - - - - - - - - - - -  --><!-- >Products Description --><!-- - - - - - - - - - - -  --><div style="margin-bottom: 15px;" ng-if=productctrl.canShowproductsDescription><div class=column><div ng-if="productctrl.product.productsDescriptions.length > 0" class=paraProduct><!-- loop inside types --><div ng-repeat="criteria in productctrl.product.productsDescriptions"><span class=paraProduct>{{criteria.value}}</span></div></div><!-- </div> --></div></div><!-- - - - - - - - - - - -  --><!-- - - - - - - - - - - -  --><!-- TECHNICAL CHARACTERISTICS --><!-- - - - - - - - - - - -  --><div ng-if="productctrl.canShowCharacteristics || productctrl.canShowUnitOfSales"><span class="titleMargin productDetailsTitles">{{\'PRODUCT_TECHNICAL_CHARACTERISTICS\' |translate}}</span><ul><div ng-repeat="unit in productctrl.product.unitOfSales" style=float:left class=paraProductList><li ng-class="$index == 1 ? \'ulNoBullet\' : \'\'"><span ng-if="$index == 1">&nbsp;- </span><span ng-if="$index == 0">{{\'UNIT_OF_SALES\' | translate}} :</span> {{unit.value}} {{unit.label}}</li></div><br class=brSpe><li ng-repeat="characteristic in productctrl.technicalOrderedCharacteristics | orderBy:\'id\'" ng-hide="characteristic.codeTechnicalCharacteristic ==\'CRFICHESECU\'" class=paraProductList><span ng-if="characteristic.codeTechnicalCharacteristic === \'0220\' || characteristic.codeTechnicalCharacteristic === \'0210\'">{{\'WEIGHT_IN_GRAMS\' | translate}}</span> <span ng-if="characteristic.codeTechnicalCharacteristic !== \'0220\' && characteristic.codeTechnicalCharacteristic !== \'0210\'">{{characteristic.label}}</span> : {{characteristic.value}} <span ng-if=characteristic.unitOfMeasure>{{characteristic.unitOfMeasure}}</span></li></ul></div><!-- - - - - - - - - - - -  --><!-- RECOMMENDED ASSEMBLY TIME --><!-- - - - - - - - - - - -  --><div ng-if=productctrl.canShowLaborTimeSparc class=canShowLaborTimeSparc><div><span class="titleMargin productDetailsTitles">{{\'RECOMMENDED_ASSEMBLY_TIME\' |translate}}</span></div><span class=laborTimeSparc>{{productctrl.product.laborTimeSparc}} {{\'COMMON_COLUMN_HOURS_TITLE\' | translate | lowercase}}</span></div><div class=productDetailsTitles ng-if="productctrl.product.familyCode.endsWith(\'A\')"><span>{{\'ACCESSORIES_LINK_TO\' | translate }}</span> <span><a class=productDetailsTitles ng-href={{productctrl.accessoriesPartWebsiteLink()}} style="color: blue;" target=_blank>{{\'ACCESSORIE_MANUAL\' | translate }}</a></span></div><!-- - - - - - - - - - - -  --><!--     TECHNICAL SHEET    --><!-- - - - - - - - - - - -  --><div class=marginPart ng-if=productctrl.canShowingPr><a class="marginPart blackLinkProduct subtitleProduct" href={{productctrl.prUrl}} target=_blank><span class=icon-icons_arrow_link_product></span> {{\'PRODUCT_TECHNICAL_SHEET\' |translate}}</a></div><!-- - - - - - - - - - - -  --><!--     SAFETY SHEET       --><!-- - - - - - - - - - - -  --><div ng-if=productctrl.canShowingFds class=marginPart><span class=icon-icons_warning_document_product></span> <a class="blackLinkProduct subtitleProduct" href={{productctrl.fdsDocument}} target=_blank>{{\'PRODUCT_SAFETY_SHEET\' |translate}}</a></div><!-- - - - - - - - - - - -  --><!--   REACH REGULATIONS    --><!-- - - - - - - - - - - -  --><div ng-if=productctrl.canShowingReach><div class="titleMargin productDetailsTitles"><img class=marginPicto src=./assets/svg/reach.svg height=16 width=16 alt=""> {{\'PRODUCT_REACH_REGULATION\' |translate}}</div><p class=paraProduct>{{productctrl.product.reach}}</p></div><!-- - - - - - - - - - - - - - --><!-- INSTALLATION INSTRUCTIONS --><!-- - - - - - - - - - - - - - --><div ng-if=productctrl.canShowingNm class=marginPart><span class=icon-icons_repair_product></span> <a class="blackLinkProduct subtitleProduct" href={{productctrl.nmUrl}} target=_blank>{{\'PRODUCT_INSTALLATION_INSTRUCTIONS\' |translate}}</a></div><!-- - - - - - - - - - - -  --><!--          MEMO          --><!-- - - - - - - - - - - -  --><div ng-if=productctrl.canShowingMemo><div><span class=icon-icons_memo_it_product></span> <span class="titleMargin bold productDetailsTitles">{{\'PRODUCT_MEMO_IT\' |translate}}</span></div><p class=paraProduct>{{productctrl.product.comments.memo}}</p></div><!-- - - - - - - - - - - -  --><!--    PRODUCT PICTURES    --><!-- - - - - - - - - - - -  --><div class=productPicture ng-if="productctrl.product.images.length && !productctrl.is3DLoading"><div><span class=icon-icons_image></span> <span class="titleMargin bold productDetailsTitles">{{\'PRODUCT_PICTURES\' |translate}}</span></div><pictures-gallery ng-if=productctrl.product.images images=productctrl.product.images current-index=productctrl.index img-anim=fadeup on-open=opened(); on-close=closed();></pictures-gallery></div><div ng-if=productctrl.is3DLoading><span><img src=../assets/images/newHourGlassGrey.gif width=35px alt=""></span></div></div></tab><!--=====================================\n                =            REPLACMENT TAB             =\n                ======================================--><tab ng-click=productctrl.tabSelected(1) active="productctrl.activeTab == 1" class="small-4 bold text-center tabsetHeadingProduct" heading="{{\'PRODUCT_REPLACEMENT\' |translate}}"><div ng-switch=productctrl.displayReplacement(productctrl.replacementList)><div ng-switch-when=true class="productPadding product-tab-border"><!-- - - - - - - - - - - -  --><!-- SUPERSESSION TYPE - CENTRAL/LOCAL --><!-- - - - - - - - - - - -  --><div class="row replacement-array title"><div ng-class="{\'small-12\': !productctrl.isDmsConnected, \'small-8\' : productctrl.isDmsConnected}" class="columns border-columns">{{\'PRODUCT_REPLACEMENT_CENTRAL\'|translate}}</div><div class="small-4 columns border-columns" ng-if=productctrl.isDmsConnected>{{\'PRODUCT_REPLACEMENT_LOCAL\'|translate}}</div></div><!-- - - - - - - - - - - -  --><!--        REPLACEMENT     --><!-- - - - - - - - - - - -  --><div class="replacement-array border-columns no-right" ng-repeat="replacement in productctrl.replacementList"><div class="row replacement-array content"><div ng-class="{\'small-8\' : productctrl.isDmsConnected, \'small-12\' : !productctrl.isDmsConnected}" class="columns border-columns no-bottom central"><!-- <div class="small-8 columns border-columns no-bottom central" ng-class="{\'small-12\': !productctrl.isDmsConnected}"> --><div class="medium-11 columns"><span class=cursor-p ng-class="{\'bold\': productctrl.product.reference === replacement.mainReference}" ng-click=productctrl.selectProductReplacement(replacement.mainReference)>{{replacement.mainReference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productctrl.copyToClipboard(replacement.mainReference);$event.stopPropagation();></i> </span><span class=icons><i ng-if=replacement.originalReference title=" {{\'PRODUCT_INFO_ORIGINAL_REF\' |translate}}" class=icon-icons_search></i> <i ng-if="!productctrl.isDmsConnected && replacement.bestSupersession" title=" {{\'PRODUCT_INFO_BEST_REMPL\' |translate}}" class=icon-icons_best_replacment></i> <i ng-if="productctrl.isDmsConnected && replacement.bestReplacementDMS" title=" {{\'PRODUCT_INFO_BEST_REMPL\' |translate}}" class=icon-icons_best_replacment></i> <i ng-if="replacement.type === \'FULL\'" title=" {{\'TOTAL_INTERCHANGE\' |translate}}" class="fa fa-refresh" style="-webkit-text-stroke: 0.8px white;font-weight: lighter;font-size: large;padding-bottom: 7px"></i> <i ng-if="replacement.type === \'PARTIAL\'" title=" {{\'PARTIAL_INTERCHANGE\' |translate}}" class="fa fa-arrow-down" style="-webkit-text-stroke: 3.3px white; font-weight: lighter;font-size: x-large;padding-bottom: 7px"></i></span></div><div ng-if=productctrl.isDmsConnected style="padding: 0" class="medium-1 columns"><!-- loading --> <img ng-if=productctrl.loadingDMS src=./assets/images/newHourGlassGrey.gif width=24px alt=""> <span ng-if=!productctrl.loadingDMS><i ng-if="replacement.quantity !== \'-\'" ng-class=productctrl.getStockClassIcon(replacement.quantity)><md-tooltip style="color:black;background-color: var(--renaultPrimaryColor);font-weight: bold;margin-left: 3px;">{{productctrl.getSupersessionToolTip(replacement.quantity)}}</md-tooltip></i><span ng-if="replacement.quantity === \'-\'" style="font-size: 20px; font-weight: bold; margin-left: 6px">-<md-tooltip style="color:black;background-color: var(--renaultPrimaryColor);font-weight: bold;margin-left: 3px;">{{ \'DMS_REFERENCE_1\'| translate}}</md-tooltip></span></span></div></div><div class="small-4 columns border-columns no-bottom local" ng-if="productctrl.isDmsConnected && replacement.supersedingPart"><div class="medium-9 columns"><span class="cursor-p uppercase" ng-click=productctrl.goToProductReplacement(replacement.supersedingPart) ng-class="{\'bold\': productctrl.product.reference === replacement.supersedingPart.reference}">{{replacement.supersedingPart.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productctrl.copyToClipboard(replacement.supersedingPart.reference);$event.stopPropagation();></i></span></div><div class="medium-3 columns"><i ng-class=productctrl.getStockClassIconLocalReplacement(replacement.supersedingPart.availabilities)><md-tooltip style="color:black;background-color: var(--renaultPrimaryColor);font-weight: bold;margin-top: -10px;">{{productctrl.getLocalSupersessionToolTip(replacement.supersedingPart.availabilities)}}</md-tooltip></i></div></div></div><!--pps--><div class="row replacement-array content" ng-repeat="additional in replacement.additional"><div class="small-8 columns replacement-pps-columns border-columns no-bottom central"><!-- <div class="small-8 columns replacement-pps-columns border-columns no-bottom central" ng-class="{\'small-12\': !productctrl.isDmsConnected}"> --><div class="medium-4 columns ref"><span class=ref-additional-pps>{{additional.additionalReference}}</span></div><div class="medium-7 columns">{{additional.additionalDesignation}}<!-- <div class="icons">\n                                                <i ng-if="additional.bestSupersession" title=" {{\'INFO_CHAINE_REMPL\' |translate}}" class="icon-icons_chaine_remplacement_listPiece"></i>\n                                            </div> --></div><div ng-if=productctrl.isDmsConnected style="padding: 0px" class="medium-1 columns"><!-- loading --> <img ng-if=productctrl.loadingDMS src=./assets/images/newHourGlassGrey.gif width=24px alt=""> <span ng-if=!productctrl.loadingDMS><i ng-if="additional.quantity !== \'-\'" ng-class=productctrl.getStockClassIcon(additional.quantity)></i> <span ng-if="additional.quantity === \'-\'" style="font-size: 20px; font-weight: bold; margin-left: 6px">-</span></span></div></div><div class="small-4 columns replacement-pps-columns border-columns no-bottom local" ng-if="productctrl.isDmsConnected && additional.supersedingPart"><div class="medium-9 columns"><span ng-click=productctrl.goToProductReplacement(additional.supersedingPart)>{{additional.supersedingPart.reference | filterFormatRef}} </span><!-- <div class="icons">\n                                                <i ng-if="additional.supersedingList" class="icon-icons_chaine_remplacement"></i>\n                                            </div> --></div><div class="medium-3 columns"><i ng-class=productctrl.getStockClassIconLocalReplacement(additional.supersedingPart.availabilities)></i></div></div></div></div></div><div ng-switch-default class=product-no-replacement>{{\'PRODUCT_NO_REPLACEMENT\' |translate}}</div></div></tab><!--=====================================\n                =          APPLICABILITY TAB            =\n                ======================================--><tab ng-click=productctrl.tabSelected(2) active="productctrl.activeTab == 2" class="small-4 bold text-center tabsetHeadingProduct" heading="{{\'PRODUCT_APPLICABILITY\' |translate}}"><div class=productPadding><!-- - - - - - - - - - - -  --><!-- SPECIFIC ATTRIBUTES --><!-- - - - - - - - - - - -  --><div class="row productPadding"><div class=titleUseCaseBorder></div><div class=codifiedSigns ng-if=productctrl.codifiedSigns><div class="productDetailsTitles titleUseCase">{{\'PRODUCT_SPECIFIC_ATTRIBUTES\' |translate}}</div><div class=titleUseCaseBorder></div><div class=paraProduct ng-repeat="codifiedSigns in productctrl.codifiedSigns">{{codifiedSigns.designation}} {{codifiedSigns.textAssociated}}</div></div><div ng-if=productctrl.product.CASE_OF_USE class="productDetailsTitles titleUseCase">{{\'PRODUCT_CASE_OF_USE\' |translate}}</div><div class=titleUseCaseBorder></div><div class="row applicability" ng-repeat="app in productctrl.product.applicabilities"><div class=applicabilityItem ng-repeat="element in app"><span class=applicabiliteSubtitle>{{element.object}}</span><div class=applBlock><div class=paraProduct ng-repeat="criteria in element.criteria">{{criteria}}</div></div></div></div></div><!-- - - - - - - - - - - -  --><!--     APPLICABILITY      --><!-- - - - - - - - - - - -  --><div class="row productDetail"><div class=productDetailsTitles>{{\'PRODUCT_APPLICABILITY\' |translate}}</div><div class=column><div ng-if="productctrl.product.applicableAllVehicles == \'Yes\'">{{\'PRODUCT_APPLICABILITY_ALL_TYPE\' | translate}}</div><div class=paraProduct ng-if="productctrl.product.applicableAllVehicles == \'No\' || productctrl.product.applicableAllVehicles == \'Not Sure\'" ng-repeat="brand in productctrl.product.applicablesVehicles"><strong>{{brand.brandLabel}}</strong><div ng-repeat="vehicle in brand.applicablesFamilies"><span class=paraProduct>{{vehicle.label}}</span></div></div></div></div><!-- - - - - - - - - - - -  --><!--   APPLICABILITY NOTE   --><!-- - - - - - - - - - - -  --><div class=infoNote>{{\'PRODUCT_APPLICABILITY_NOTE\'|translate}}</div></div></tab></tabset></div><!--=====================================\n        =              RIGHT MENU               =\n        =       TODO : Cleanup html\n        ======================================--><div class="small-4 columns" ng-if=productctrl.product><!-- // LOADING --><div class="row cartPanel" ng-if="!productctrl.loadingDMS && !productctrl.isAsomDocPrivUser"><!-- ******************************\n                    PRICE WITH/WITHOUT TAXES\n                ***********************************--><div class="columns text-center princeht" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia"><span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && productctrl.isCountrySparc && productctrl.frCountry !=\'FR\' && !$root.isIndependentUser"><strong><span class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && productctrl.frCountry ===\'FR\' && !$root.isIndependentUser"><strong><span class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && !productctrl.isCountrySparc && !$root.isIndependentUser"><strong><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && productctrl.product.priceWithoutTaxes && !$root.isIndependentUser && !mainCtrl.isHorseUser"><strong><span>{{productctrl.product.priceWithoutTaxes | number : 2}} {{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</span></strong> </span><!-- Price check for Independent Users --> <span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && productctrl.isCountrySparc && productctrl.frCountry !=\'FR\' && $root.isIndependentUser && $root.asomDocList.PX"><strong><span class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && productctrl.frCountry ===\'FR\' && $root.isIndependentUser && $root.asomDocList.PX"><strong><span class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && !productctrl.product.priceWithoutTaxes && !productctrl.isCountrySparc && $root.isIndependentUser && $root.asomDocList.PX"><strong><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></strong></span><span ng-if="!productctrl.isDmsConnected && productctrl.product.priceWithoutTaxes && $root.isIndependentUser && $root.asomDocList.PX"><strong><span>{{productctrl.product.priceWithoutTaxes | number : 2}} {{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</span></strong> </span><span ng-if=productctrl.isDmsConnected><div><span ng-if=productctrl.product.dmsInformations.priceExclTaxes><div>{{getPriceToDisplay()}} {{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div></span><span ng-if="productctrl.product.priceWithoutTaxes && !productctrl.product.dmsInformations.priceExclTaxes"><strong>{{getPriceToDisplay()}} {{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</strong><div class=msg>{{\'NOT_PRICE_PART_DMS\' | translate}}</div></span><span ng-if="!productctrl.product.priceWithoutTaxes && !productctrl.product.dmsInformations.priceExclTaxes"><div ng-if="!productctrl.product.priceWithoutTaxes && !productctrl.product.dmsInformations.priceExclTaxes && productctrl.frCountry !=\'FR\' && productctrl.isCountrySparc" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</div><div ng-if="!productctrl.product.priceWithoutTaxes && !productctrl.product.dmsInformations.priceExclTaxes && productctrl.frCountry ===\'FR\'" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</div><div>{{productctrl.getCurrencyForItem()}} {{\'PRODUCT_EXCL_TAX\' | translate}}</div><div class=msg>{{\'NOT_PRICE_PART\' | translate}}</div></span></div><div class=princettc ng-if=productctrl.product.dmsInformations.priceInclTaxes>{{productctrl.product.dmsInformations.priceInclTaxes | number : 2}} {{productctrl.getCurrencyForItem()}} {{\'PRODUCT_INCL_TAX\' | translate}}</div></span></div><div class="text-center baremeCort" ng-if=productctrl.isDmsConnected><div><span>({{\'PRODUCT_CORT\' | translate}} : {{productctrl.showTheCort()}})</span></div><div>{{\'LOCKER\' | translate}} : <span ng-if=productctrl.product.dmsInformations.locker>{{productctrl.product.dmsInformations.locker}}</span></div></div><div ng-if="productctrl.isDmsConnected && !productctrl.isCentralStockPilot" class=text-center><!-- STOCK --><phenix-is-number quantity=productctrl.product.dmsInformations.quantity><span class=ProductStock ng-if="productctrl.product.dmsInformations.quantity > 0"><strong>{{productctrl.product.dmsInformations.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</strong> </span><span class=ProductStockUnavailable ng-if="productctrl.product.dmsInformations.quantity <= 0">{{\'PRODUCT_UNAVAILABLE\' | translate}} </span><span><a ng-click=productctrl.showDetailStock() class=icon-icons_applicability_product ng-style="{\n                                color: productctrl.product.dmsInformations.quantity > 0 ? \'#678004\' : \'#c80e0e\'\n                            }"></a><md-tooltip>{{ \'INFO_STOCK_DETAIL\'| translate}}</md-tooltip></span></phenix-is-number></div><div ng-if=productctrl.isCentralStockPilot class=text-center><span ng-if=productctrl.loadingCentralStock><img src=./assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</span><central-stock-icon ng-if=!productctrl.loadingCentralStock piece=productctrl.product mode=full></central-stock-icon></div><!-- =======================\n                    HANDLE QUANTITY\n                ======================== --><div class=container-currency-product ng-if=!productctrl.canShowingAdditional><div class="medium-6 columns estimColumn"><div ng-if=productctrl.isDmsConnected class="switchButton float-right"><shopping-cart-quote from=PR piece=productctrl.product></shopping-cart-quote></div></div><div class="medium-6 columns partListColumn"><div ng-if=productctrl.isDmsConnected class=switchButton><shopping-cart-parts-requisition piece=productctrl.product options={}></shopping-cart-parts-requisition></div></div><!-- =====================\n                            ON CART\n                    ====================== --><div class=medium-12 ng-if="!productctrl.isDmsConnected && !mainCtrl.isHorseUser"><shopping-cart piece=productctrl.product reference=productctrl.product.reference></shopping-cart></div></div><!--=====================================\n                =              REMPLACEMENT             =\n                =       TODO : Cleanup html\n                ======================================--><div class=additional ng-if=productctrl.canShowingAdditional><div class="columns refCont"><div class=reference><a class="additionnalProduct adjust-ref" ng-click=productctrl.selectProductReplacement(productctrl.product.reference)>{{productctrl.product.reference | filterFormatRef}}</a><div class="blockStockProduct switchButton" ng-if=productctrl.isDmsConnected><shopping-cart-quote from=PR piece=productctrl.product options=productctrl.product></shopping-cart-quote><shopping-cart-parts-requisition class=shoppingCartMargin piece=productctrl.product options=productctrl.product></shopping-cart-parts-requisition></div><div class="blockStockProduct switchButton" ng-if=!productctrl.isDmsConnected><shopping-cart piece=productctrl.product reference=productctrl.product.reference></shopping-cart></div></div><div class=additionalRef ng-repeat="additionalItem in productctrl.product.additional"><div class=reference><div class=lineArborescence></div><div class="additionnalProduct additionalRef" ng-click=productctrl.goToProduct(additionalItem)>{{additionalItem.reference | filterFormatRef}}</div><div class="blockStockProduct switchButton" ng-if=productctrl.isDmsConnected><shopping-cart-quote from=PR piece=additionalItem options=productctrl.product></shopping-cart-quote><shopping-cart-parts-requisition class=shoppingCartMargin piece=additionalItem options=productctrl.product></shopping-cart-parts-requisition></div><div class="blockStockProduct switchButton" ng-if=!productctrl.isDmsConnected><shopping-cart piece=additionalItem main-piece=additionalItem type=PPS></shopping-cart></div></div></div></div></div></div><div ng-if=productctrl.loadingDMS class="row cartPanel" style="text-align: center"><img src=./assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</div><div class="row product-same-ref" ng-if=productctrl.product.partLinks.length><div class="medium-12 border-bottom-section"><i class=icon-icons_equivalence></i><h4 class=product-same-ref-title>{{\'PRODUCT_SAME_REF\'| translate}}</h4></div><div class="medium-12 section-ref-product border-bottom-section" ng-repeat="link in productctrl.product.partLinks"><div class=valign-middle><span ng-click=productctrl.goToProductFromPartLink(link) class="ref-vertical-adjust ref-section pointer">{{link.partNumber | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productctrl.copyToClipboard(link.partNumber);$event.stopPropagation();></i> </span><span ng-if="productctrl.isRemanufacturedMotrio(link.types, link.familyCode)" class=icon-product><img src=./assets/images/motrio_reman.png height=30 width=50 alt="Remanufactured Motrio"> </span><span ng-if="productctrl.isMotrio(link.types) && !productctrl.isRemanufacturedMotrio(link.types, link.familyCode)" class=icon-product><img src=./assets/images/motrio.png class=motrioProduct alt=""> </span><span ng-if="productctrl.isStandardExchange(link.types) && productctrl.isTractionBattery(link.familyCode)" class=icon-product><img src=./assets/images/renative.png height=18 width=40 alt=Renative> </span><span ng-if="productctrl.isStandardExchange(link.types) && !productctrl.isTractionBattery(link.familyCode)" class=icon-product><img src=./assets/images/renative_reman.png height=18 width=40 alt=""> </span><span ng-if=productctrl.isValuePlus(link.types) class=icon-product><img src=./assets/images/value+.png height=30 width=50 alt=""></span></div><div class=desc-section>{{link.designation}}</div></div></div><div class="row product-same-ref" ng-if="(productctrl.product.kit.length || productctrl.product.fromKit) && !productctrl.isFamilyCodeRestricedForTechnicalCollection"><div class="medium-12 border-bottom-section"><i class=icon-icons_kit></i><h4 class=product-same-ref-title>{{\'PRODUCT_KITS_COLLECTION\'| translate}}</h4></div><div class=border-bottom-section ng-if=productctrl.product.kit.length><div class="subtitleProduct section-ref-product-subtitle" translate=PRODUCT_KITS_KIT_CONTAIN translate-values="{reference: productctrl.product.originalPartReference}"></div><div class="section-ref-product border-bottom-section with-margin" ng-repeat="ref in productctrl.product.kit"><div class=valign-middle><div style="width: 50%"><span class="ref-vertical-adjust ref-section" ng-click=productctrl.goToProduct(ref)>{{ref.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productctrl.copyToClipboard(ref.reference);$event.stopPropagation();></i><br>{{ref.designation }}</span></div><div class=ref-vertical-kit-adjust ng-if="ref.quantity > 1">x {{ref.quantity }}</div></div><div class=desc-section>{{kit.designation}}</div></div></div><div class=border-bottom-section ng-if=productctrl.product.fromKit><div class="subtitleProduct section-ref-product-subtitle" translate=PRODUCT_KITS_FROM_KIT translate-values="{reference: productctrl.product.partNumber}"></div><div class="section-ref-product border-bottom-section with-margin" ng-repeat="kit in productctrl.product.fromKit"><div class=valign-middle><span class="ref-vertical-adjust ref-section">{{kit.reference | filterFormatRef}}</span></div><div class=desc-section>{{kit.designation}}</div></div></div></div></div></div></div><!-- Chatbot Component --><nd-chatbot ng-if=productctrl.isNDAssistantEnabled></nd-chatbot>');
$templateCache.put('app/components/products/product/threeDViewer.template.html','<div id=3d-representation ng-style="{\'display\':isDataLoaded?\'block\':\'none\'}"><iframe width=600 height=500 id=threeDViewerFrame srcdoc="<html><head>         <style>html,body{width:100%;height:100%;margin:0;}</style></head><body style=\'overflow: hidden;\'>               <script type=\'text/javascript\' src=\'../../../../assets/js/jquery.min.js\'></script>\n                <script type=\'text/javascript\' src=\'../../../../assets/js/three.min.js\'></script>\n                <script type=\'text/javascript\' src=\'../../../../assets/js/OrbitControls.min.js\'></script>\n                <script type=\'text/javascript\' src=\'../../../../assets/js/glviewer.min.js\'></script>\n\n                <style>#renaultTech {margin: 0px;} canvas{width:100%; height:100%;}body{background: rgb(245,246,246); background: -moz-linear-gradient(top, rgba(245,246,246,1) 0%, rgba(184,186,198,1) 0%, rgba(221,223,227,1) 84%, rgba(245,246,246,1) 100%);background: -webkit-linear-gradient(top, rgba(245,246,246,1) 0%,rgba(184,186,198,1) 0%,rgba(221,223,227,1) 84%,rgba(245,246,246,1) 100%);background: linear-gradient(to bottom, rgba(245,246,246,1) 0%,rgba(184,186,198,1) 0%,rgba(221,223,227,1) 84%,rgba(245,246,246,1) 100%); filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#f5f6f6\', endColorstr=\'#f5f6f6\',GradientType=0 );} #buttons-container {display: table;position: fixed;bottom: 5px;right: 5px; }#buttons-container > div {display: table-row;} #buttons-container > div > div {display: table-cell;padding-left: 5px;} .viewer-button {padding: 5px;background-color: rgb(255,255,255); border-radius: 10px;border: 1px solid rgb(0,0,0); opacity: 0.6;cursor: pointer;}.viewer-button:hover {background - color: #7c7c7c;}#view-selection > img {display: none; }  #view-selection-menu {display: none;position: fixed;bottom: 55px;right: 5px; padding: 5px;border: 1px solid rgb(0,0,0);border-radius: 10px;} #view-selection-menu img, #view-selection-menu label {vertical - align: middle;cursor: inherit;} #view-selection-menu > div {display: table;} #view-selection-menu > div > div {display: table-row;}  #view-selection-menu > div > div:hover {background - color: rgb(127,127,127);cursor: pointer;} #view-selection-menu > div > div > div{display: table-cell;vertical-align: middle;padding: 0px 5px;}.viewer-button > img, #view-selection-menu > div > div > div > img {vertical - align: bottom; height: 36px; width: 36px;}</style>\n                \n            </body>\n        </html>"></iframe></div>');
$templateCache.put('app/components/products/modal/ref_consigne.html','<div class=modalPhenix><div class=title>{{\'REF_CONSIGNE_TITLE\'|translate}}</div><ul class=consign><li ng-repeat="voiText in SearchAdminCtrl.vois track by $index">{{voiText}}</li></ul><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=SearchAdminCtrl.validate()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'REF_CONSIGNE_VALIDATE\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=SearchAdminCtrl.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/products/modal/remonter_alerte.html','<div class=modalPhenix><div class=close ng-click=vm.cancel()><div class=text>Fermer</div><i class=icon-icons_close></i></div><div class=title>{{\'REMONTER_ALERTE_TITLE\'|translate}}</div><div class=alerte><div class=message><span class=congrat>{{\'REMONTER_ALERTE_CONGRAT\'|translate}} </span><span>{{\'REMONTER_ALERTE_MESSAGE\'|translate}}</span></div><div><div class=subTitle>{{\'REMONTER_ALERTE_NOTIFICATION\'|translate}}</div><span>{{\'REMONTER_ALERTE_INFOS\'|translate}}</span> <span class=alerteFollow><u>{{\'REMONTER_ALERTE_FOLLOW\'|translate}}</u></span></div></div></div>');
$templateCache.put('app/components/products/stoppedRange/prCatalog.html','<div class=prCatalog><div class="row title"><div class=designation>{{prCatalogCtrl.catalog.designation}}</div><div class=changeCatalog ng-click=prCatalogCtrl.changeCatalog()><i class=icon-icons_change></i> {{\'STOPPED_RANGE_CHANGE_CATALOG\'|translate}}</div></div><div class=content><div class=row><div class="menu small-3 columns"><div class=search><input list=autoComplete type=text ng-model=prCatalogCtrl.keyWord ng-class="(prCatalogCtrl.keyWordActive || prCatalogCtrl.keyWord) ?\'inputNormal\':\'inputResetItalique\'" ng-focus="prCatalogCtrl.keyWordActive=true" ng-blur="prCatalogCtrl.keyWordActive=false" ng-change=prCatalogCtrl.autoComplete() ng-attr-placeholder="{{\'STOPPED_RANGE_SEARCH_PR\'|translate}}"><datalist id=autoComplete><option value={{item.designation}} ng-repeat="item in prCatalogCtrl.listAutoComplete">{{item.designation}}</option></datalist><div ng-click=prCatalogCtrl.searchByKeyWord() ng-class="!prCatalogCtrl.keyWord || prCatalogCtrl.keyWord.length < 3? \'inactive\' : \'\'"><i class=icon-icons_search></i></div></div><div class=prList><div ng-class=prCatalogCtrl.getPrClass(pr) class=pr ng-repeat="pr in prCatalogCtrl.prList"><div class="row head" ng-click=prCatalogCtrl.showPr($index)><div class=designation>{{pr.designation}}</div><div class=icon><i ng-class=prCatalogCtrl.getIconClass(pr)></i></div></div><div class=content ng-if=prCatalogCtrl.isPrExpanded(pr)><ul ng-repeat="node in pr.nodes" ng-include="\'prCategoryTree\'"></ul></div></div></div></div><div class="planche small-9 columns"><div class=image><img ng-src={{prCatalogCtrl.urlPlanche}}></div><div class=pagination ng-if="prCatalogCtrl.prList.length>0"><div class="small-9 columns"><div class=page><i class=icon-icons_double_arrow_left ng-click=prCatalogCtrl.firstPr()></i> <i class=icon-icons_arrow_left ng-click=prCatalogCtrl.previousPr()></i><div class=libelle>{{\'COMMON_PAGINATION_PAGE\'|translate}} {{prCatalogCtrl.activePrIndex+1}} {{\'COMMON_PAGINATION_ON\'|translate}} {{prCatalogCtrl.prList.length}}</div><i class=icon-icons_arrow_right ng-click=prCatalogCtrl.nextPr()></i> <i class=icon-icons_double_arrow_right ng-click=prCatalogCtrl.lastPr()></i></div></div><div class="small-3 columns"><div class=btnAction><div><i class=icon-icons_print></i><div class=btnTitle>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</div></div><div><i class=icon-icons_export_csv></i><div class=btnTitle>{{\'BUTTON_ESTIMATE_EXPORT\' |translate}}</div></div></div></div></div></div></div></div></div><script type=text/ng-template id=prCategoryTree><ul>\n    <li ng-click="prCatalogCtrl.showImage(node)">{{node.id}}</li>\n    <li ng-repeat="node in node.nodes" ng-include="\'prCategoryTree\'" ng-click="prCatalogCtrl.showImage(node)">\n      {{node.id}}\n    </li>\n  </ul></script>');
$templateCache.put('app/components/products/stoppedRange/selectCatalog.html','<div class=selectCatalog><div class=title>{{\'STOPPED_RANGE_SELECT_CATALOG\'|translate}}</div><div class=catalogList><div class=row ng-repeat="catalog in stoppedRangeCtrl.catalogs" ng-click=stoppedRangeCtrl.selectCatalog(catalog)>{{catalog.designation}}</div></div><div class=pagination><pagination-directive ng-if=stoppedRangeCtrl.catalogs pagination-mode=text pagination-data=stoppedRangeCtrl.catalogs pagination-size=stoppedRangeCtrl.pageSize></pagination-directive></div></div>');
$templateCache.put('app/components/products/stoppedRange/stoppedRange.html','<recap-car api=stoppedRangeCtrl.recapCarAPI></recap-car><div id=stoppedRange class=containerView><!--bandeau v\xE9hicule --><!--menu--><div class=tabSetMenu><tabset open-on-load=false><tab heading={{stoppedRangeCtrl.labelPR}} ng-click=stoppedRangeCtrl.selectTabPR()><div ui-view=pr></div></tab><tab heading={{stoppedRangeCtrl.labelMR}} ng-click="stoppedRangeCtrl.selectTab(\'MR\')"><div ui-view=document></div></tab><tab heading={{stoppedRangeCtrl.labelMD}} ng-click="stoppedRangeCtrl.selectTab(\'MD\')"><div ui-view=document></div></tab><tab heading={{stoppedRangeCtrl.labelNT}} ng-click="stoppedRangeCtrl.selectTab(\'NT\')"><div ui-view=document></div></tab></tabset></div></div>');
$templateCache.put('app/components/products/stoppedRange/stoppedRangeDocument.html','<div class=documentList><div class="row head"><div class="small-1 columns">{{stoppedRangeDocumentCtrl.labelHead |translate}}</div><div class="small-11 columns">{{\'STOPPED_RANGE_HEAD_TITLE\'|translate}}</div></div><div class="row document" ng-repeat="document in stoppedRangeDocumentCtrl.documentList" ng-click=stoppedRangeDocumentCtrl.showDocument(document)><a href={{stoppedRangeDocumentCtrl.getDocumentUrl(document)}} target=_blank><div class="small-1 columns">{{document.id}}</div><div class="small-11 columns">{{document.designation}}</div></a></div></div><div class=pagination><pagination-directive ng-if=stoppedRangeDocumentCtrl.documentList pagination-mode=text pagination-data=stoppedRangeDocumentCtrl.documentList pagination-size=stoppedRangeDocumentCtrl.pageSize></pagination-directive></div>');
$templateCache.put('app/components/vdh/commentsHubPopin/commentsHubPopin.template.html','<md-dialog id=commentsHubPopin class=md-comments-container aria-label=commentsHubPopin><div layout=row layout-align="end end"><md-button class=md-icon-button ng-click=cancel()><md-icon style="font-size: 24px;" aria-label="Close dialog"><i class=icon-icons_close id=onClose></i></md-icon></md-button></div><md-dialog-content id=commentsHubPopinContent><div class=comments><div class=comments-title-container><p id=comments-title>{{\'VDH_RECOMMENDATION_COMMENTS_HUB\' | translate}}</p></div><div class=comments-container><div class=comment-container ng-if=isAddComment><table class=comment-table><tr class=comment-table-row><td><div class=all-dtcs-container><table><tr id=first-row><td class=list-column><md-input-container class=list-container><label>{{\'SELECT_DTC_CAUSE\' | translate}}</label><md-select ng-model=selectedDtcCause md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader multiple=""><md-select-header class=demo-select-header><input ng-model=searchTerm type=search placeholder="Search for a DTC CAUSE.." class="demo-header-searchbox md-text"></md-select-header><md-optgroup label=vegetables><md-option ng-value=dtc ng-repeat="dtc in dtcsCause |\n                                                        filter:searchTerm track by $index">{{dtc}}</md-option></md-optgroup></md-select></md-input-container></td><td class=list-column><md-input-container class=list-container><label>{{\'SELECT_DTC_POLLUTION\' | translate}}</label><md-select ng-model=selectedDtcPollution md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader multiple=""><md-select-header class=demo-select-header><input ng-model=searchTerm type=search placeholder="Search for a DTC Pollution.." class="demo-header-searchbox md-text"></md-select-header><md-optgroup label=vegetables><md-option ng-value=dtc ng-repeat="dtc in dtcsPollution |\n                                                        filter:searchTerm track by $index">{{dtc}}</md-option></md-optgroup></md-select></md-input-container></td><td class=list-column><md-select ng-model=selectedPhase placeholder="Select phase" style="font-size: var(--renaultMediumFont);"><md-option>{{\'ALL_PHASES\' | translate}}</md-option><md-option ng-click=setPhase(phase) ng-value=phase ng-repeat="phase in (phases ? phases : [])"><strong>{{phase}}</strong></md-option></md-select></td></tr><tr><td class=header-table>{{\'DTC_CAUSE\' | translate}}</td><td class=header-table>{{\'DTC_POLLUTION\' | translate}}</td><td class=header-table></td></tr><tr><td class=first-header><md-chip-template class=mat-chip-filter ng-repeat="dtc in selectedDtcsCause.get(-1)"><strong class=dtc-chip>DTC{{dtc}}</strong></md-chip-template></td><td><md-chip-template class=mat-chip-filter ng-repeat="dtc in selectedDtcsPollution.get(-1)"><strong class=dtc-chip>DTC{{dtc}}</strong></md-chip-template></td></tr></table></div><div class=comment-text><textarea ng-model=$parent.commentText placeholder="Write your comment here"></textarea><div class="alert alert-danger" ng-if=triggerValidation><div ng-if=emptyComment>{{\'COMMENT_IS_REQUIRED\' | translate}}</div><div ng-if=isDtcsNotEmpty()>{{\'DTC_POLLUTION_REQUIRED\' | translate}}</div></div></div></td></tr></table><div class=action-container><button class="edit-actions comment-button" ng-click=createComment()>{{\'COMMON_SAVE\' | translate}}</button> <button class="edit-actions comment-button cancel" ng-click=cancelCreation()>{{\'COMMON_CANCEL\' | translate}}</button></div></div><div ng-repeat="comment in comments track by $index"><div class=comment-container ng-if=!isAddComment><div class="col comment-menu-container"><md-menu ng-if="(!isRnetUserType  && comment.validated === \'0\') || (adtTechrole  && comment.validated === \'0\') || comment.creator.ipn === userIpn"><md-button aria-label="Open demo menu" class="md-icon-button comments-menu" ng-click=$mdMenu.open($event)><i md-menu-origin class="fa fa-ellipsis-h fa-2x" aria-hidden=true></i></md-button><md-menu-content><md-menu-item ng-if=canEdit(comment)><md-button ng-if=canEdit(comment) ng-click="displayCommentEditor($index, comment)"><i class="fa fa-pencil" aria-hidden=true></i> <span md-menu-align-target>{{\'COMMON_EDIT\' | translate}}</span></md-button></md-menu-item><md-menu-item ng-if=canDelete(comment)><md-button ng-if=canDelete(comment) ng-click="removeComment($index, comment)"><i class="fa fa-trash" aria-hidden=true></i> <span md-menu-align-target>{{\'REMOVE\' | translate}}</span></md-button></md-menu-item><md-menu-item ng-if=canValidate(comment)><md-button ng-if=canValidate(comment) ng-click="validateComment($index, comment)"><i class="fa fa-check" aria-hidden=true></i> <span md-menu-align-target>{{\'MODAL_OK_BUTTON\' | translate}}</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class="row header-comment"><div class="col-6 grey-text comment-author"><span class=gray-text>{{\'COMMENT_POSTED_BY\'| translate}} </span><span class=gray-text ng-if="!isRnetUserType || adtTechrole">{{comment.creator.firstName}} {{comment.creator.lastName}} - </span><span class=gray-text>{{comment.creator.profile}}</span></div><div class="col-6 grey-text" ng-if="comment.validated == \'1\'"><p class="gray-text validation-content"><span class="material-icons color_green"><i class="fa fa-check fa-1x"></i></span>{{\'VALIDATED_BY\' | translate}} : {{comment.validatorProfile}}</p></div></div><div class="row header-comment"><div class="col-6 grey-text comment-author"><p class=gray-text>{{\'CREATED\' | translate}} : {{comment.creationDateTime}}</p></div></div><table class=comment-table><tr class=comment-table-row><td class=like-structure-cell><table class=likeStructure><tr><td><button class="material-icons color_orange declicFeedBack" ng-style=checkIfLiked(comment) title=Like ng-click=likeComment(comment)><i class="fa fa-thumbs-up" aria-hidden=true></i></button></td><td><button mat-icon-button color=primary ng-style=checkIfDisliked(comment) class="material-icons color_orange declicFeedBack" title=Dislike ng-click=dislikeComment(comment)><i class="fa fa-thumbs-down" aria-hidden=true></i></button></td></tr><tr><td>{{ comment.like }}</td><td>{{ comment.dislike }}</td></tr></table></td><td><div class=all-dtcs-container><table><tr id=first-row ng-if="commentIndex === $index"><td class=list-column><md-input-container class=list-container><label>{{\'SELECT_DTC_CAUSE\' | translate}}</label><md-select ng-model=selectedDtcCause md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader multiple=""><md-select-header class=demo-select-header><input ng-model=searchTerm type=search placeholder="Search for a DTC CAUSE.." class="demo-header-searchbox md-text"></md-select-header><md-optgroup label=vegetables><md-option ng-value=dtc ng-repeat="dtc in dtcsCause |\n                                                            filter:searchTerm track by $index">{{dtc}}</md-option></md-optgroup></md-select></md-input-container></td><td class=list-column><md-input-container class=list-container><label>{{\'SELECT_DTC_POLLUTION\' | translate}}</label><md-select ng-model=selectedDtcPollution md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader multiple=""><md-select-header class=demo-select-header><input ng-model=searchTerm type=search placeholder="Search for a DTC Pollution.." class="demo-header-searchbox md-text"></md-select-header><md-optgroup label=vegetables><md-option ng-value=dtc ng-repeat="dtc in dtcsPollution |\n                                                            filter:searchTerm track by $index">{{dtc}}</md-option></md-optgroup></md-select></md-input-container></td><td class=list-column><md-select ng-model=selectedPhase placeholder="Select phase"><md-option ng-value=phase ng-click=setPhase(phase) ng-repeat="phase in (phases ? phases : [])">{{phase}}</md-option></md-select></td></tr><tr ng-if="commentIndex != $index"><td class=header-table>{{\'DTC_CAUSE\' | translate}}</td><td class=header-table>{{\'DTC_POLLUTION\' | translate}}</td><td class=header-table>{{\'PHASE\' | translate}}</td></tr><tr ng-if="commentIndex != $index"><td class=first-header><md-chip-template class=mat-chip-filter ng-repeat="dtc in selectedDtcsCause.get($index)"><strong class=dtc-chip>DTC{{dtc}}</strong></md-chip-template></td><td><md-chip-template class=mat-chip-filter ng-repeat="dtc in selectedDtcsPollution.get($index)"><strong class=dtc-chip>DTC{{dtc}}</strong></md-chip-template></td><td><md-chip-template class=mat-chip-filter><strong class=dtc-chip>{{comment.phase ? comment.phase : "All phases"}}</strong></md-chip-template></td></tr></table></div><div class=comment-text><p ng-if="commentIndex != $index">{{comment.content}}</p><textarea ng-model=textarea.commentUpdateText ng-if="commentIndex === $index" class=comment-text-area></textarea></div></td></tr></table><div class=action-container ng-if="commentIndex === $index"><button class=edit-actions ng-click=updateComment(comment)>{{\'COMMON_SAVE\' | translate }}</button> <button class="edit-actions cancel" ng-click=cancelEdit(number)>{{\'COMMON_CANCEL\' | translate}}</button></div></div></div></div><div class=add-comment-container ng-if=!isAddComment><button class=comment-button ng-if="!isRnetUserType || adtTechrole" ng-click=displaycommentCreation()>{{\'ADD_COMMENT\' | translate}}</button> <button class="comment-button cancel" ng-click=cancel()><i class="fa fa-times-circle"></i> {{\'CLOSE_COMMENT_HUB\' | translate}}</button></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/core/components/basket-client-informations/basket-client-informations.template.html','<div id=BCI_><div class=small-12><span><i class="icon-icons_people_partlist remove-padding font-size-20"></i> <label class=headerClientNameLabel>{{vm.client.firstName | uppercase}} {{vm.client.name | uppercase}} ({{vm.client.accountNumber}})</label> </span><span ng-if=vm.client.mainPhone><i class="icon-icons_phone_partlist remove-padding margin-5"></i>{{vm.client.mainPhone}} </span><span ng-if=vm.client.email><i class="icon-icons_mail_partlist remove-padding margin-5"></i>{{vm.client.email | lowercase}}</span></div><div class=small-12><i class="icon-icons_address_passant_partlist remove-padding"></i> <span>{{vm.client.streetNumber}}</span> <span ng-if=vm.client.bisTer class=margin-5>{{vm.client.bisTer}}</span> <span ng-if=vm.client.streetName class=margin-5>{{vm.client.streetName}}</span> <span ng-if=vm.client.postCode class=margin-5>{{vm.client.postCode}}</span> <span ng-if=vm.client.city class=margin-5>{{vm.client.city}}</span></div></div>');
$templateCache.put('app/core/components/pdfModal/pdfModal.template.html','<div id=pdf-print-Modal class=modalPhenix><div><!-- <object data="{{vm.data}}" width="100%" height="750px" type="application/pdf"></object> --><electrical-schema-pdf ng-if=vm.data data={{vm.data}}></electrical-schema-pdf></div></div>');
$templateCache.put('app/core/components/superCartBadge/superCartBadge.template.html','<div ng-class="{\'super-cart-badge\':!$ctrl.newHeaderMenu,\'super-cart-badge-new-Header\':$ctrl.newHeaderMenu}" ng-if="$ctrl.cartLength > 0">{{$ctrl.cartLength}}</div>');
$templateCache.put('app/core/components/stockPopin/stockPopin.template.html','<div id=stock-Popin><div class="modalStockInfo font-size-stock" ng-click=vm.closeModal()><span>{{ "BUTTON_ESTIMATE_CLOSE" | translate }} X</span></div><div><table class="table table-hover margin-right-10 margin-left-10"><thead class="text-warning theadStyle"><th class=font-weight-bold>{{ "COMMON_SITE" | translate }}</th><th class=font-weight-bold>{{ "DOCUMENT_PR_STOCK_HEADER" | translate }}</th><th class=font-weight-bold>{{ "COMMON_COLUMN_LOCATION" | translate }}</th><th class=font-weight-bold>{{ "COMMON_COLUMN_QTE_TITLE" | translate }}</th></thead><tbody><tr ng-repeat="stock in vm.stockDetail"><td>{{ stock.siteLabel }}</td><td>{{ stock.stockLabel }}</td><td>{{ stock.location }}</td><td>{{ stock.quantity }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/core/components/superCartDraftListModal/superCartDraftListModal.template.html','<div id=list-Of-SuperCart-Draft-Modal class=modalPhenix><div class="modalPhenix margin"><div class=row><div ng-click=vm.close() class=closeTopRightModal>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}} X</div></div><div ng-if=!vm.isEasyBasket><div class=row><div class="modalPhenixTitle float-left"><span>{{\'ESTIMATE_NO_ACTIVE_ESTIMATE\'| translate}}</span></div></div><div class=row><button type=button class="buttonWithIcon small-5 columns" ng-click="vm.selectSuperCart(null, vm.actions.createNewSuperCart)"><div class=iconDiv><i class=icon-icons_basket></i></div><div class=btnText>{{vm.title | translate}}</div></button> <button ng-if="vm.showActifPartRequisition && vm.currentPartRequisition" type=button class="buttonWithIcon small-offset-2 small-5 columns" ng-click="vm.selectSuperCart(vm.currentPartRequisition, vm.actions.addToActifPartRequisition)"><div class=iconDiv><i class=icon-icons_basket></i></div><div class=btnText>{{\'PUT_QUOTE_ITEMS_TO_PARTREQUISITION\' | translate}}</div></button></div></div><div ng-if=vm.isEasyBasket><div class=row><div class="modalPhenixTitle bold-header"><span ng-if="!vm.prPopUp && !vm.tmPopUp">{{vm.isEasyBasketHeader| translate}}</span> <span ng-if=vm.prPopUp>{{vm.prPopupHeader| translate}}</span> <span ng-if=vm.tmPopUp>{{vm.tmPopupHeader| translate}}</span></div></div><div class=modalPhenixButtons ng-class="{\'itemBasketDisplay\' : !vm.isDmsProfile, \'itemsDisplay\': vm.isDmsProfile && vm.isPartshop, \'itemQuoteBtn\': vm.isDmsProfile && vm.count > 0 && vm.showList && vm.isWorkshop, \'itemQuotePopBtn\': vm.isDmsProfile && !vm.showList && vm.isWorkshop}"><button type=button class=buttonWithIcon style="width: 130px;" ng-click="vm.selectSuperCart(null, vm.actions.createNewSuperCart)"><div class=iconDiv><i ng-if=vm.isDmsProfile class=icon-icons_estimation></i> <i ng-if=!vm.isDmsProfile class=icon-icons_validate></i></div><div ng-if="!vm.prPopUp && !vm.tmPopUp" class=btnText>{{vm.title|translate}}</div><div ng-if=vm.prPopUp class=btnText>{{vm.prYesButton|translate}}</div><div ng-if=vm.tmPopUp class=btnText>{{vm.tmYesButton|translate}}</div></button> <button type=button class="buttonWithIcon cancel" style="width: 120px;height: 34px;" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary-modal"></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></div><div ng-if="vm.count > 0 && vm.showList" class=modalPartList><div class=modalPhenixTitle ng-class="{\'text\': !vm.isEasyBasket, \'bold-header\': vm.isEasyBasket && vm.isDmsProfile}">{{vm.subtitle | translate}} :</div><!-- LIST --><div><table ng-if=vm.isPartshop><tr class=text-uppercase><th>{{\'COMMON_NUMBER_ID\' | translate}}</th><th>{{\'MODIFICATION_DATE\' | translate}}</th><th>{{\'MODIFIED_BY\' | translate}}</th><th>{{\'COMMON_NUMCLIENT_LABEL\' | translate}}</th></tr><tr class=orange ng-repeat="item in vm.list" ng-click="vm.selectSuperCart(item.id, vm.actions.addToSelectedSuperCart)"><td>{{item.number}}</td><td>{{item.lastModificationDateTime | date : \'yyyy/MM/dd\'}}</td><td>{{item.lastModifierIPN}}</td><td>{{item.accountNumber}}</td></tr></table><table ng-if=vm.isWorkshop><tr class=text-uppercase><th>{{\'COMMON_NUMBER_ID\' | translate}}</th><th>{{\'ALERTS_VIN\' | translate}}</th><th>{{\'ACTIS_VEHICLE_IMMAT\' | translate}}</th><th>{{\'MODIFICATION_DATE\' | translate}}</th><th>{{\'MODIFIED_BY\' | translate}}</th><th>{{\'COMMON_NUMCLIENT_LABEL\' | translate}}</th><th>{{\'ACTIS_DESCRIPTION_OR\' | translate}}</th></tr><tr class=orange ng-repeat="item in vm.list" ng-click="vm.selectSuperCart(item.id, vm.actions.addToSelectedSuperCart)"><td>{{item.number}}</td><td>{{item.vin}}</td><td>{{item.registrationNumber}}</td><td>{{item.lastModificationDateTime | date : \'yyyy/MM/dd\'}}</td><td>{{item.lastModifierIPN}}</td><td>{{item.accountNumber}}</td><td>{{item.orderNumber}}</td></tr></table></div><pagination-carts-list count=vm.count limit=10 update-pagination=vm.updatePagination></pagination-carts-list><!-- PAGINATION --></div><div class=row ng-if=vm.isEasyBasket style="text-align: center;margin-top: 16px;"><div class=modalPhenixTitle><i class="fa fa-info-circle"></i> <span>{{vm.isEasyBasketFooter| translate}}</span></div></div></div></div>');
$templateCache.put('app/core/components/superCartPopin/superCartPopin.template.html','<div id=super-cart-popin><div class=super-cart-header><div class=super-cart-ellipsis><img ng-if="$ctrl.icon.includes(\'.svg\') || $ctrl.icon.includes(\'http\')" ng-src={{$ctrl.icon}} class=popinIcon alt=icon style="height:24px; \n                    width:24px; margin-right: 10px;"> <i ng-if="!$ctrl.icon.includes(\'.svg\') && !$ctrl.icon.includes(\'http\')" ng-class=[$ctrl.icon] class=popinIcon></i></div><div class=super-cart-header-description><div class="super-cart-ellipsis popinTitle">{{$ctrl.popinTitle}}</div></div></div><div ng-if=$ctrl.popinSubtitle class=popinSubtitle>{{$ctrl.popinSubtitle}}</div><div class=container-list><div ng-if=$ctrl.pr.length><div class=category><h7><span class=category-title>{{\'HEADER_PR\' | translate }}</span></h7></div><div class="list border-bottom" ng-repeat="element in $ctrl.pr" ng-if="element.quantity != 0"><div class="id white-space">{{element.reference | filterFormatRef}}</div><div class=designation>{{element.designation}}</div><div class=quantity>{{element.quantity}}</div></div></div><div ng-if=$ctrl.tm.length><div class=category><h7><span class=title>{{\'COMMON_TABLE_MO_TITLE\' | translate }}</span></h7></div><div class="list border-bottom" style="display: flex" ng-repeat="element in $ctrl.tm"><div class=id>{{element.opecod}}</div><div class=designation>{{element.designation}}</div><div class=quantity>{{element.quantity}}</div></div></div></div></div>');
$templateCache.put('app/core/error/errorDocumentNotFound/errorDocumentNotFound.template.html','<div id=errorDocumentNotFound><div class=headerCP><nav role=navigation><div class=logoCP><span>GROUPE</span> <span>RENAULT</span></div></nav></div><div class=carSearchMainBg layout=row layout-align="center center"><md-card class=connectBloc><md-card-title class=titleConnectionCard><h2>{{\'ERROR_DOCUMENT_NOT_FOUND\' | translate}}</h2></md-card-title></md-card></div></div>');
$templateCache.put('app/components/alerts/modal/confirmModal/alertsConfirm.html','<div ng-if="((vm.isTraceEnabled && (vm.checkDocType === \'TM\' || vm.checkDocType === \'MR\')) || \n(vm.isTraceEnabledINT && vm.checkDocType === \'INT\') || (!vm.isTraceEnabled && (vm.checkDocType !==\'TM\' && \n    vm.checkDocType !==\'MR\' && vm.checkDocType !== \'INT\' && vm.checkDocType !== \'PREDICTION\')))" class="modalAlertsConfirm modal-alerts-container modal-alerts-confirm-layout"><div ng-keypress class=close ng-click=vm.cancel()><em class="icon-icons_close close-icon-small"></em></div><div ng-if="vm.checkDocType == \'PR\' || vm.checkDocType == \'ORDER_MODE\'" class=alerts-center-text><div class=title>{{\'REMONTER_ALERTE_TITLE\' | translate}}</div><div class=alerte><div class=message><span><strong>{{\'REMONTER_ALERTE_REQUEST_ID\' | translate :translationData }}</strong><br></span><span>{{\'REMONTER_ALERTE_CONGRAT\' | translate}} {{\'REMONTER_ALERTE_MESSAGE\' | translate }}</span></div><div class=message><span>{{\'REMONTER_ALERTE_MESSAGE_END\' | translate}}</span></div></div></div><div class="title trace-title-center" ng-if="vm.checkDocType != \'PR\' && vm.checkDocType != \'ORDER_MODE\'"><div class=trace-alert-bold>{{\'TRACE_SUCCESS_ALERT\' | translate}}</div><br><span>{{\'TICKET_NO\' | translate :translationData }} {{translationData.idAlerts}}</span><p>{{\'TRACE_ALERT_DESC1\' | translate}}<br>{{\'TRACE_ALERT_DESC2\' | translate}}</p></div></div><div ng-if="((!vm.isTraceEnabled && (vm.checkDocType === \'TM\' || vm.checkDocType === \'MR\')) || vm.checkDocType === \'PREDICTION\')" class="modalPhenix modal-alerts-container modal-alerts-phenix-padding"><div class=closeAlign><span ng-keypress class="text closeCursor" ng-click=vm.cancel()>{{\'MODAL_CLOSE\' | translate}} <em class=icon-icons_close></em></span></div><div class=title>{{\'TM_ALERT_SENT\'| translate}}</div><div class=message ng-if="vm.checkDocType !== \'PREDICTION\'">{{\'TM_REQUEST_ID\' | translate }} {{vm.requestId}}</div><div class=message ng-if="vm.checkDocType !== \'PREDICTION\'">{{\'TM_ALERT_SENT_DESCRIPTION\' | translate}} {{vm.emailAddress}} {{\'TM_ALERT_SENT_DESCRIPTION_EMAIL\' | translate}}</div><div class="message prediction-preline" ng-if="vm.checkDocType === \'PREDICTION\'">{{\'DIAG_PREDICT_ALERT_SENT_DESCRIPTION\' | translate}}</div></div>');
$templateCache.put('app/components/alerts/modal/confirmModal/alertsReject.html','<div class="modalPhenix modal-alerts-container"><div ng-keypress class=close ng-click=vm.cancel()><div class=text>{{\'MODAL_CLOSE\'|translate}}</div><em class=icon-icons_close></em></div><div class=title>{{\'ALERTS_ERROR_HTL\'|translate}}</div><div class=alerte><div class=message><span class=congrat>{{vm.code}} </span><span>{{vm.errorMessage }}</span></div></div></div>');
$templateCache.put('app/components/alerts/modal/contextCarModal/contextCar.html','<div ng-if="vm.checkDocType !==\'TM\' && vm.checkDocType !==\'MR\' && vm.checkDocType !== \'INT\' " class="modalPhenix modalPhenixDisplay"><div class=modalPhenixTitle><span>{{\'ALERTS_UNFINISHED\'| translate}}.</span></div><div class=modalPhenixSubtitle><span ng-if=vm.isFromDisconnect>{{\'ALERTS_UNFINISHED_DISCONNECT\'| translate}}.</span> <span ng-if=vm.isFromChangeVehicle>{{\'ALERTS_UNFINISHED_SWITCH\'| translate}}.</span></div><div class=modalPhenixButtons><button type=button class=buttonWithIcon ng-click=vm.finishAlerts()><div class=iconDiv><em class=icon-icons_refresh></em></div><div class=btnText>{{\'ALERTS_FINISH_DONE\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancelGeneric()><div class=iconDiv><em class="fa fa-trash"></em></div><div class=btnText>{{\'ALERTS_FINISH_IGNORE\'| translate}}</div></button></div></div><div ng-if="vm.checkDocType === \'TM\'|| vm.checkDocType === \'MR\' || vm.checkDocType === \'INT\' " class="modalPhenix modalPhenixDisplay"><div class=modalPhenixTitle><span>{{\'TM_ALERTS_UNFINISHED\'| translate}}.</span></div><div class=modalPhenixSubtitle><span ng-if=vm.isFromDisconnect>{{\'ALERTS_UNFINISHED_DISCONNECT\'| translate}}.</span> <span ng-if=vm.isFromChangeVehicle>{{\'ALERTS_UNFINISHED_SWITCH\'| translate}}.</span></div><div class=modalPhenixButtons><button type=button class=buttonWithIcon ng-click=vm.finishAlerts()><div class=iconDiv><em class=icon-icons_refresh></em></div><div class=btnText>{{\'TM_ALERTS_COMPLETE\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancelGeneric()><div class=iconDiv><em class="fa fa-trash"></em></div><div class=btnText>{{\'ALERTS_FINISH_IGNORE\'| translate}}</div></button></div></div>');
$templateCache.put('app/components/alerts/modal/screenShotModel/captureScreenshot.html','<div style="width: 900px;height: 500px;"><div><div class=closeAlign style="margin: 10px;"><span class="text closeCursor" ng-click=vm.cancel()>{{\'MODAL_CLOSE\' | translate}} <em class=icon-icons_close></em></span></div><img ng-src={{vm.capturedImage}} alt="" height=400></div><div class=modalScreenshot style=margin-bottom:10px><button class=buttonWithIcon ng-click=vm.addToAlert()><div class=iconDiv><em class="fa fa-check"></em></div><div class=btnText>{{\'ADD_SCREENSHOT_ALERT\' | translate}}</div></button> <button class="buttonWithIcon newCapture" ng-click=vm.reCapture()><div class="fa fa-refresh iconDiv"></div><div class=btnText>{{\'SCREENSHOT_NEW_CAPTURE\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/alerts/modal/deleteModal/delete_modal_alerts.html','<div class=modalPhenix><div class=modalPhenixTitle><span>{{vm.title}}</span></div><div class=modalPhenixButtons><button type=button class=buttonWithIcon ng-click=vm.delete()><div class=iconDiv><em class=icon-icons_remove></em></div><div class=btnText>{{\'COMMON_DELETE\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><em class=icon-icons_close></em></div><div class=btnText>{{\'COMMON_CANCEL\'| translate}}</div></button></div></div>');
$templateCache.put('app/components/alerts/popin/steps/step-form-pr.html','<div ng-if="vm.checkDocType != \'TM\' && vm.checkDocType != \'MR\'"><div class="alerts-popin_title alerts-popin_title-margin"><div class="alerts-popin_title alerts-popin_title-margin"><div class=alerts-popin_subtitle>{{\'ALERTS_NATURE_INCIDENT\' | translate}}</div><div class="alerts-popin_select custom-select"><select ng-model=vm.stepElem[1].alerteDocumentDetail.natureIncidentSelected id=ALERTS_NATURE_INCIDENT ng-options="natureIncident | translate for natureIncident in vm.stepElem[1].alerteDocumentDetail.natureIncident"></select></div></div><div class=alerts-popin_subtitle>{{\'ALERTS_LEVEL_ALERT\' | translate}}</div><div class="row alerts-popin_title-radio"><div class="medium-4 column"><div ng-click="vm.stepElem[vm.step - 1].alerteDocumentDetail.levelAlerte = \'ALERTS_LEVEL_ALERTS_STANDARD\'" class=alerts-popin-radio><input aria-label=standard id=standard type=radio ng-model="vm.stepElem[vm.step - 1].alerteDocumentDetail.levelAlerte" value=ALERTS_LEVEL_ALERTS_STANDARD> <label>{{\'ALERTS_LEVEL_ALERTS_STANDARD\' | translate}}</label></div></div><div class="medium-8 column"><div ng-click="vm.stepElem[vm.step - 1].alerteDocumentDetail.levelAlerte = \'ALERTS_LEVEL_ALERTS_URGENT\'" class=alerts-popin-radio><input aria-label=ungent id=urgent type=radio ng-model="vm.stepElem[vm.step - 1].alerteDocumentDetail.levelAlerte" value=ALERTS_LEVEL_ALERTS_URGENT> <label>{{\'ALERTS_LEVEL_ALERTS_URGENT\' | translate}}</label></div></div></div></div><div class="alerts-popin_title alerts-popin_title-margin alerts-popin-placeholder"><div class=alerts-popin_subtitle>{{vm.stepElem[vm.step - 1].alerteDocumentDetail.title | translate}} {{vm.stepElem[vm.step - 1].alerteDocumentDetail.reference.data}}</div><div class="rowPopin medium-12 alerts-popin_subtitle"><div class=medium-2>{{vm.stepElem[vm.step - 1].alerteDocumentDetail.selectedLabel | translate}}</div><div class=medium-6><input numbers-only id=ALERTS_LANDMARK pattern=^(\\d?[1-9]|[1-9]0)$ maxlength=2 class="width-78 height-30" ng-model=vm.stepElem[1].alerteDocumentDetail.selected placeholder=1-99></div></div><div class="rowPopin medium-12 alerts-popin_subtitle"><div class=medium-2>{{vm.stepElem[vm.step - 1].alerteDocumentDetail.codeLabel | translate}}</div><div class="rowPopin medium-3"><input type=text aria-label=alertCode id=ALERTS_CODE ng-change=vm.displayDescription(vm.stepElem[1].alerteDocumentDetail.code) class=height-30 ng-model=vm.stepElem[1].alerteDocumentDetail.code maxlength=13 placeholder="{{\'ALERTS_CODE\' | translate}}"></div><div class="rowPopin medium-7"><input aria-label=description type=text id=ALERTS_DESCRIPTION pattern="^[a-zA-Z0-9 ]{1,30}$" class="margin-left-20 height-30" ng-model=vm.stepElem[1].alerteDocumentDetail.description placeholder="{{\'ALERTS_DESCRIPTION\' | translate}}"></div></div><div ng-if="(vm.stepElem[1].alerteDocumentDetail.natureIncidentSelected===\'ALERTS_NOT_FOUND_REF\')||\n    (vm.stepElem[1].alerteDocumentDetail.natureIncidentSelected===\'ALERTS_NOT_CONFORM_REF\')" class="rowPopin medium-12 alerts-popin_subtitle"><div style="max-width: max-content;">{{\'ALERTS_PART_MARKING\' | translate}}</div><div class="rowPopin medium-7"><input aria-label=marking type=text id=ALERTS_PART_MARKING pattern="^[a-zA-Z0-9 ]{1,20}$" maxlength=20 class="margin-left-20 height-20" ng-model=vm.stepElem[1].alerteDocumentDetail.partmarking placeholder="{{\'ALERTS_PART_MARKING\' | translate}}"></div></div><div class="alerts-popin_title alerts-popin-placeholder"><div class=alerts-popin_subtitle>{{\'ALERTS_COMMENTS\' | translate}}</div><textarea aria-label=comments id=ALERTS_COMMENTS placeholder="{{\'ALERTS_COMMENTS_INPUT\' | translate}}" rows=4 ng-model="vm.stepElem[vm.step - 1].alerteDocumentDetail.comments"></textarea></div><div class="alerts-popin_title alerts-popin_title-margin"><div class=alerts-popin_subtitle>{{\'ALERTS_ATTACHMENT\' | translate}} <span class=alerts-popin_optional>({{\'ALERTS_OPTIONAL\' | translate}})</span></div><div class=alerts-popin-subtext>{{\'ALERTS_ATTACHMENT_SIZE_MAX\' | translate}} {{vm.maxSizedFiles}}.</div><div class=alerts-popin_files ng-repeat="file in vm.stepElem[1].alerteDocumentDetail.attachment"><div class="medium-5 column"><span class=alerts-popin_files-name>{{file.file.name}}</span></div><div class="medium-3 column"><span class=alerts-popin_files-size>{{file.file.humanSize}}</span></div><div class="medium-2 column"><i ng-click="vm.deleteInArray(vm.stepElem[1].alerteDocumentDetail.attachment, $index)" class=icon-icons_remove></i></div></div><!--File upload input--><div class=file-upload><upload-file id-file=importFile file=vm.file file-type-support="[\'all\']" file-error=vm.fileError file-type-error=vm.fileTypeError file-array=vm.stepElem[1].alerteDocumentDetail.attachment></upload-file></div><!--end of File upload input--><div class=alerts-popin-subtext ng-if=vm.fileError><span translate=ALERTS_ERROR_FILE_SIZE translate-values="{size: 1}"></span></div><div class=alerts-popin-subtext ng-if=vm.fileTypeError>{{\'ALERTS_ERROR_FILE_TYPE\' | translate}}</div></div></div></div>');
$templateCache.put('app/components/alerts/popin/steps/step-form.html','<div ng-if="vm.checkDocType === \'TM\' || vm.checkDocType === \'MR\' || vm.checkDocType === \'INT\' || vm.checkDocType === \'PREDICTION\'" class=tm-reportsize><div class="alerts-popin_title alerts-popin_title-margin"><div class="alerts-popin_title-content margin-top-40">{{\'ALERTS_REQUEST_OBJECT\' | translate}}</div></div><div class="rowPopin medium-12 alerts-tm-margin" ng-if="!vm.isTraceEnabled && \n            (vm.checkDocType === \'TM\' || \n             vm.checkDocType === \'MR\' || \n             vm.checkDocType === \'INT\')"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_PATH\' | translate}}</div><div class="medium-8 text-left">{{vm.stepElem[1].alerteRequestObject.data.path}}</div></div><div class="rowPopin medium-12 alerts-tm-margin" ng-if="vm.checkDocType === \'PREDICTION\'"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'EASYBASKET_VERSION\' | translate}}</div><div class="medium-8 text-left">{{vm.stepElem[1].alerteRequestObject.data.version}}</div></div><div class="rowPopin medium-12 alerts-tm-margin"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_DOCUMENT_TYPE\' | translate}}</div><div class=text-left>{{vm.stepElem[1].alerteRequestObject.data.documentType}}</div></div><div class="rowPopin medium-12 alerts-tm-margin" ng-if="vm.checkDocType === \'PREDICTION\'"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CONCERNED_DOCUMENT\' | translate}}</div><div class="medium-8 text-left">{{vm.stepElem[1].alerteRequestObject.data.concernedDocument}}</div></div><div class="rowPopin medium-12 alerts-tm-margin" style="display: inline-block;" ng-if="vm.checkDocType === \'PREDICTION\'"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_PREDICTION_IN_DEFAULT\' | translate}}</div><div class="rowPopin text-left alerts-popin_select custom-select"><select ng-model=vm.stepElem[1].alerteRequestObject.data.predictionInDefaultSelected id=ALERTS_PREDICTION_IN_DEFAULT ng-options="predictionInDefault | translate for predictionInDefault in vm.stepElem[1].alerteRequestObject.data.predictionInDefault"></select></div></div><div class="rowPopin medium-12 alerts-tm-margin" style="display: inline-block;" ng-if="vm.checkDocType !== \'PREDICTION\'"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_REQUEST_REASON\' | translate}}</div><div class="rowPopin text-left alerts-popin_select custom-select"><select ng-model=vm.stepElem[1].alerteRequestObject.data.requestReasonSelected id=ALERTS_REQUEST_REASON ng-options="requestReason | translate for requestReason in vm.stepElem[1].alerteRequestObject.data.requestReason"></select></div></div><div ng-if="(vm.isTraceEnabled && (vm.checkDocType === \'MR\' || vm.checkDocType === \'TM\'))"><div ng-if=vm.alertRequestReasonSelected.includes(vm.stepElem[1].alerteRequestObject.data.requestReasonSelected) class="rowPopin medium-12 alerts-tm-margin"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CONCERNED_DOCUMENT\' | translate}}</div><div class="rowPopin medium-2 text-left alerts-popin_select custom-select tm-select"><select class=tm-select-dropdown ng-options="item.code for item in vm.stepElem[1].alerteRequestObject.data.concernedDocument  | orderBy:\'code\'" ng-model=vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected id=ALERTS_CONCERNED_DOCUMENT></select></div><div class="rowPopin medium-6" style="padding-left: 10px;">{{vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected.title}}</div></div></div><div ng-if="!vm.isTraceEnabled && vm.checkDocType === \'MR\'"><div ng-if="vm.stepElem[1].alerteRequestObject.data.requestReasonSelected == \'ALERTS_MR_INCORRECT\' || vm.stepElem[1].alerteRequestObject.data.requestReasonSelected == \'ALERTS_MR_INCORRECT_DESIGNATION\'" class="rowPopin medium-12 alerts-tm-margin"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CONCERNED_DOCUMENT\' | translate}}</div><div class="rowPopin medium-2 text-left alerts-popin_select custom-select tm-select"><select class=tm-select-dropdown ng-options="item.code for item in vm.stepElem[1].alerteRequestObject.data.concernedDocument" ng-model=vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected id=ALERTS_CONCERNED_DOCUMENT></select></div><div class="rowPopin medium-6" style="padding-left: 10px;">{{vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected.title}}</div></div></div><div ng-if="!vm.isTraceEnabled && vm.checkDocType === \'TM\'"><div ng-if="vm.stepElem[1].alerteRequestObject.data.requestReasonSelected == \'ALERTS_TM_INCORRECT\' || vm.stepElem[1].alerteRequestObject.data.requestReasonSelected == \'ALERTS_TM_INCORRECT_DESIGNATION\'" class="rowPopin medium-12 alerts-tm-margin"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CONCERNED_DOCUMENT\' | translate}}</div><div class="rowPopin medium-2 text-left alerts-popin_select custom-select tm-select"><select class=tm-select-dropdown ng-options="item.code for item in vm.stepElem[1].alerteRequestObject.data.concernedDocument" ng-model=vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected id=ALERTS_CONCERNED_DOCUMENT></select></div><div class="rowPopin medium-6" style="padding-left: 5px;">{{vm.stepElem[1].alerteRequestObject.data.concernedDocumentSelected.title}}</div></div></div><div ng-if="vm.checkDocType === \'INT\'"><div class="rowPopin medium-12 alerts-tm-margin"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CONCERNED_DOCUMENT\' | translate}}</div><div class="rowPopin medium-6" style="padding-left: 5px;">{{vm.stepElem[1].alerteRequestObject.data.concernedDocument.code + " " + vm.stepElem[1].alerteRequestObject.data.concernedDocument.title}}</div></div></div><div class="alerts-popin-placeholder alerts-tm-margin"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_REQUEST_DETAILS\' | translate}}</div><textarea class="medium-8 textArea" maxlength=200 id=ALERTS_REQUEST_DETAILS placeholder="{{\'ALERTS_COMMENTS_INPUT\' | translate}}" rows="{{(vm.checkDocType === \'PREDICTION\') ? 6 : 3}}" ng-model="vm.stepElem[vm.step - 1].alerteRequestObject.data.requestDetails"></textarea></div><div class="alerts-popin-placeholder alerts-tm-margin" ng-if="(vm.isTraceEnabled && (vm.checkDocType === \'MR\' || vm.checkDocType === \'TM\'))"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'TRACE_PART_ASSOCIATED_NUMBER\' | translate}}</div><textarea style="min-height: 32px; width: 222px !important;" class=tm-select-dropdown ng-model="vm.stepElem[vm.step - 1].alerteRequestObject.data.partAssociatedNumber" ng-change=vm.formatReferenceInput()></textarea></div><div class="rowPopin medium-12 alerts-tm-margin" ng-if="(vm.isTraceEnabled && (vm.checkDocType === \'MR\' || vm.checkDocType === \'TM\'))"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_VEHICLE_COVERED_BY_WARRANTY\' | translate}}</div><div class="medium-8 text-left row alerts-popin_title-radio"><div class="medium-4 column"><div ng-click="vm.stepElem[1].alerteRequestObject.data.vehicleCoveredByWarranty = \'YES\'" class=alerts-popin-radio-tm-mr><input aria-label=isWarranty id=isWarranty type=radio ng-model=vm.stepElem[1].alerteRequestObject.data.vehicleCoveredByWarranty value=YES> <label>{{\'COMMON_YES\' | translate}}</label></div></div><div class="medium-8 column"><div ng-click="vm.stepElem[1].alerteRequestObject.data.vehicleCoveredByWarranty = \'NO\'" class=alerts-popin-radio-tm-mr><input aria-label=noWarranty id=noWarranty type=radio ng-model=vm.stepElem[1].alerteRequestObject.data.vehicleCoveredByWarranty value=NO> <label>{{\'COMMON_NO\' | translate}}</label></div></div></div></div><div class="rowPopin medium-12 alerts-tm-margin" style="display: inline-block;" ng-if="(vm.isTraceEnabled && (vm.checkDocType === \'MR\' || vm.checkDocType === \'TM\'))"><div class="rowPopin medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_CIR_ASSOCIATED\' | translate}}</div><div class="rowPopin text-left alerts-popin_select custom-select"><select ng-model=vm.stepElem[1].alerteRequestObject.data.cirAssociatedSelected id=ALERTS_CIR_ASSOCIATED ng-options="activeFicIds | translate for activeFicIds in vm.stepElem[1].alerteRequestObject.data.activeFicIds"></select></div></div><div class="alerts-popin-placeholder alerts-tm-margin" ng-if="(vm.isTraceEnabled && (vm.checkDocType === \'MR\' || vm.checkDocType === \'TM\'))"><div class="medium-4 column tm-alerts-popin_subtitle">{{\'ALERTS_TEMPORARY_SOLUTION\' | translate}}</div><textarea class="medium-8 textArea" maxlength=200 id=ALERTS_TEMPORARY_SOLUTION placeholder="{{\'ALERTS_TEMPORARY_INPUT\' | translate}}" rows=3 ng-model="vm.stepElem[vm.step - 1].alerteRequestObject.data.temporarySolution"></textarea></div><!--attachment--><div class=alerts-popin_files ng-repeat="file in vm.stepElem[1].alerteRequestObject.data.attachment"><div class=medium-4></div><div class="medium-5 column"><span class=alerts-popin_files-name>{{file.file.name}}</span></div><div class="medium-2 column"><span class=alerts-popin_files-size>{{file.file.humanSize}}</span></div><div class="medium-2 column"><i ng-click="vm.deleteInArray(vm.stepElem[1].alerteRequestObject.data.attachment, $index)" class=icon-icons_remove></i></div></div><div class="rowPopin medium-12" ng-if="vm.checkDocType !== \'PREDICTION\'"><div class="rowPopin medium-4 column text-left tm-alerts-popin_subtitle">{{\'ALERT_JOIN_SCREENSHOT\' | translate}}</div><div class="rowPopin medium-12 file-upload"><upload-file class="rowPopin medium-6" id-file=importFile file=vm.file file-type-support="[\'all\']" file-error=vm.fileError file-type-error=vm.fileTypeError file-array=vm.stepElem[1].alerteRequestObject.data.attachment></upload-file><button ng-if="vm.hideScreenshot || vm.isTraceEnabled" ng-disabled=vm.disableScreenshot id=TAKE_SCREENSHOT class="rowPopin medium-6 alerts-popin-btn buttonWithIcon" ng-click=vm.takeScreenshot(vm.stepElem[1].alerteRequestObject.data.attachment)><div class=iconDiv><i class="fa fa-camera"></i></div><div class=btnText>{{\'ALERT_TAKE_SCREENSHOT\' | translate}}</div></button></div></div><!--end of File upload input--><div class="alerts-popin_title alerts-popin_title-margin"><div class=alerts-popin-subtext ng-if=vm.fileError><span translate=ALERTS_ERROR_FILE_SIZE translate-values="{size: 1}"></span></div><div class=alerts-popin-subtext ng-if=vm.fileTypeError>{{\'ALERTS_ERROR_FILE_TYPE\' | translate}}</div></div></div>');
$templateCache.put('app/components/alerts/popin/steps/step-list.html','<div ng-if="vm.checkDocType === \'TM\' || vm.checkDocType === \'MR\' || vm.checkDocType === \'INT\' || vm.checkDocType === \'PREDICTION\'" ng-class="{\'tm-reportsize\':vm.isTraceEnabled}" class=margin-top-40><recap-car api=phxAlertsStepController.recapCarAPI checktm=true></recap-car></div><div ng-repeat="step in vm.stepElem[vm.step - 1]"><div class="alerts-popin_title alerts-popin_title-margin"><div class="alerts-popin_title-content margin-top-40">{{step.title | translate}}</div></div><div class=alerts-popin_list><div ng-repeat="elem in step.data"><div class="alerts-popin_list-text alerts-popin_list-row row" ng-class="{\'alerts-align-center\': elem.type === \'input\'}" ng-show=elem.type><div class="medium-4 column text-right text-bold">{{elem.label | translate}}</div><div class="medium-8 column text-left"><span ng-if="elem.type === \'text\' && !elem.date">{{elem.data}}</span> <span ng-if="elem.type === \'text\' && elem.date">{{elem.data | filterFormatDateDms}}</span> <input ng-if="elem.type === \'input\'" id={{elem.label}} type=text ng-model=elem.data placeholder="{{elem.placeholder | translate}}"> <select ng-if="(elem.type === \'select\')" id={{elem.label}} ng-model="vm.stepElem[vm.step - 1].alerteUserDetail.data.code.selected" ng-options="option for option in elem.data" class=alerts-select-style></select></div></div></div></div></div>');
$templateCache.put('app/components/basket/consultation/components/modal-on-delete-carts.template.html','<md-dialog id=modalOnDeleteCart><div class=modalPhenix><div class=title>{{\'BASKET_DELETE\'|translate}}</div><ul><li ng-repeat="id in vm.listID track by $index">{{id}}</li></ul><div class=modalPhenixButtons><button type=button class="buttonWithIcon left left-white" ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'COMMON_DELETE\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/basket/consultation/components/modal-yes-no-confirm.template.html','<md-dialog id=modalOnDeleteCart><div class=modalPhenix><div class=title>{{vm.header | translate}}</div><div>{{vm.title | translate}} {{vm.or}}</div><div>{{vm.subtitle | translate}}</div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left left-white" ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_basket></i></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class="icon-icons_close icon-icons_close-primary"></i></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/car/carSearch/components/bannerRGPD.template.html','<div id=bannerRGPD ng-show=vm.isBannerVisible><!-- TEXT --><p>{{"BANNER_RGPD_MAIN" | translate}}</p><!-- BUTTONS --><div class=manageCookiesBtn><md-button ng-keypress class="md-raised buttonWithIcon" id=manageCookiesBtn ng-click=vm.toggleMenuManageCookies()><div class="btnText btnTextRgpd">{{\'BANNER_RGPD_MANAGE_COOKIES\' | translate}}</div></md-button></div><div class=agreeBtn><md-button ng-keypress class="md-raised buttonWithIcon" ng-click=vm.onAgree()><div class=btnText>{{\'BANNER_RGPD_AGREEMENT\' | translate}}</div></md-button></div><div id=menuManageCookies class=menuManageCookies><!-- Button manage functioning --><div class=row><div class="manageCookiesBox row"><div class="small-2 columns"><em class="fa fa-cogs" style=font-size:20px></em></div><div class="small-10 columns"><div class=font-weight-regular>{{\'BANNER_MANAGE_COOKIES_FUNCTIONING_TITLE\' | translate}}</div><div>{{\'BANNER_MANAGE_COOKIES_FUNCTIONING_TEXT\' | translate}}</div><em class="fa fa-lock setLock"></em></div><div class=colorSignGreen></div></div></div><!-- Button manage audience measurement --><div class=row><div ng-keypress class="manageCookiesBox row" ng-click=vm.onChangeAudienceCookiesAllowance()><div class="small-2 columns"><em class="fa fa-thermometer-half" style=font-size:20px></em></div><div class="small-8 columns"><div class=font-weight-regular>{{\'BANNER_MANAGE_COOKIES_AUDIENCE_TITLE\' | translate}}</div><div>{{\'BANNER_MANAGE_COOKIES_AUDIENCE_TEXT\' | translate}}</div></div><div class=colorSignGreen ng-show=vm.isallowedAudienceCookies></div><div class=colorSignRed ng-show=!vm.isallowedAudienceCookies></div></div></div></div></div>');
$templateCache.put('app/components/car/carSearch/components/bannerRGPDnew.template.html','<div id=newRGPDDesign><div id=bannerRgpd><!-- TEXT --><p class=rgpdNewDesign>{{"BANNER_RGPD_MAIN" | translate}}</p><!-- BUTTONS --><div class=manageCookiesBtn><md-button class="md-raised buttonWithIcon" id=manageCookiesBtn ng-keypress ng-click=vm.toggleMenuManageCookies()><div class="btnText btnTextRgpd">{{\'BANNER_RGPD_MANAGE_COOKIES\' | translate}}</div></md-button></div><div class=agreeBtn><md-button class="md-raised buttonWithIcon" id=agreeBtn ng-keypress ng-click=vm.onAgree()><div class=btnText>{{\'BANNER_RGPD_AGREEMENT\' | translate}}</div></md-button></div></div><!-- Button manage functioning --><hr ng-if=vm.functioningCookies><div class=row><div class="small-6 columns" id=functioningCookies ng-if=vm.functioningCookies><div class=font-weight-regular><strong>{{\'BANNER_MANAGE_COOKIES_FUNCTIONING_TITLE\' | translate}}</strong></div><div>{{\'BANNER_MANAGE_COOKIES_FUNCTIONING_TEXT\' | translate}}</div><div><a class=active>{{\'TOUJOURS_ACTIF\'| translate}}</a></div></div><!-- Button manage audience measurement --><div class="small-6 columns" id=audienceMeasure ng-if=vm.functioningCookies><div class=font-weight-regular><strong>{{\'BANNER_MANAGE_COOKIES_AUDIENCE_TITLE\' | translate}}</strong></div><div>{{\'BANNER_MANAGE_COOKIES_AUDIENCE_TEXT\' | translate}}</div><div class=switch><md-switch ng-model=vm.isallowedAudienceCookies></md-switch></div></div></div></div>');
$templateCache.put('app/components/car/carSearch/components/modalInformation.template.html','<div ng-keypress class=actions style="position: absolute; right:5px;" ng-click=vm.onClose()><em class="fa fa-close"></em></div><div ng-bind-html=vm.message style="padding: 20px;font-family: var(--renaultFontRegular);"></div><div style="padding: 20px;font-family: var(--renaultFontRegular);" id=infoConsent><a ng-click=vm.onConsent() class=consentInfo>{{"INFO_CONSENT"|translate}}</a></div>');
$templateCache.put('app/components/car/carSearchResult/easyBasket/catalogPlate.template.html','<div id=listePieceTabView ng-if=vm.showCatalogPlate><div id=interventionCatalog><div class=row style="max-width: 100%;"><button class="btnChangerVehicle buttonWithIcon" id=carContextButton style="top:10px;cursor: pointer; width: 135px;margin-left: 30px;" ng-click=vm.navigateToPlate(vm.nodeDetail)><md-tooltip md-direction=right style="height: auto !important; font-size: var(--renaultMediumFont); white-space: normal;">{{\'GO_TO_CATALOG_PLATE\' | translate}}</md-tooltip><div class=iconDiv><i class=icon-icons_logout style="margin-right: 0;"></i></div><div class=btnText style="padding-left: 0;">{{\'EASY_BASKET_GOTO_PLATE\' | translate}}</div></button> <span style="float:right;margin-right:50px;padding-top:20px;cursor: pointer;" ng-click=vm.close()><i class=icon-icons_close></i></span></div><div class="large-12 columns"><div class="large-4 columns" ng-class=vm.yellowBorder() style="width: 445px;"><div style="height: 400px;" ng-show="!vm.checkGroupPlates() &&\n                                        vm.listOfPlate[vm.currentIndexPlate].thumbnailUrl &&\n                                        vm.listOfPlate[vm.currentIndexPlate].thumbnailUrl.length" id=divEbSvgContent class=phx-svg></div></div><!--=====================================\n        =              LISTE PIECE              =\n        ======================================--><div class="large-8 columns listPiece" ng-if=!vm.checkGroupPlates() ng-show=vm.listOfPieces.length style="width: 715px;"><!--================   Headers   ===================== --><div class="row valign-middle header-row" style=position:relative;><div class="medium-1 columns id" ng-class="vm.isUserDms?\'partRef medium-offset-1\':\'ref medium-offset-2\'" ng-style="{\'right\': !vm.isUserDms ? \'8%\' : \'0.5%\'}">{{\'VIEWED_DOC_REF\'|translate}}</div><div class="columns designation medium-5" ng-style="{\'left\':!vm.isUserDms ? (!vm.isCountryChina && !vm.isCountryIndia) ? \'3%\':\'25px\' :(!vm.isCountryChina && !vm.isCountryIndia) ? \'3%\' : \'5%\'}">{{\'COMMON_DESIGNATION\'|translate}}</div><div ng-if=vm.isUserDms class="medium-1 columns stock">{{\'COMMON_STOCK\'|translate}}</div><div ng-if="!vm.isUserDms && !vm.isCountryChina && !vm.isCountryIndia && !mainCtrl.isIndependentUser && !vm.isHorseUser" class="medium-2 columns priceExcTax display-block text-align-right">{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</div><div ng-if="vm.isUserDms && !vm.isCountryChina && !vm.isCountryIndia" class="medium-2 columns display-block text-align-right" style="right: 5%;">{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</div><div class="medium-1 columns brand">&nbsp;</div></div><!-- ================   ng-repeat listpieces   ===================== --><div id={{piece.index}} class="row-bloc row EbSvg" ng-init="piecePrincipal=piece; optionsN1 = {mainPart: piece}" ng-repeat="piece in vm.listOfPieces | orderBy:[\'index\']" tabindex=-1><!-- ================ FIRST              ===================== --><!-- ================   main reference   ===================== --><div class="row valign-middle" id={{piece.reference}}><!-- =====   Index   ===== --><div class="medium-1 columns textPiece textIndex" ng-class="{\'medium-offset-1 plusIcon\': !vm.isUserDms}"><div class="div-inline unfold"><i ng-click=vm.showHideAdd(piece) ng-if="piece.additional && piece.additional.length > 0" ng-class="{\'icon-icons-phnx-expendable_plus\':!piece.showAdd,\'icon-icons-phnx-exependable_moins\':piece.showAdd}"></i></div><div ng-click=vm.gotoSvg(piece.index) class=textIndex-div ng-class="vm.isUserDms? \'numbers\': \'numberIndex\'">{{::piece.index}}</div></div><!-- =====   Reference   ===== --><div class="medium-1 columns textPiece description white-space" ng-class="vm.isUserDms ?\'productRef\':\'reference\'"><span>{{piece.reference | filterFormatRef}}</span> <i class="fa fa-files-o" aria-hidden=true title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(piece.reference) style=margin-left:2px;></i></div><!-- =====   Designation + pictos   ===== --><div class="columns textPiece designation" ng-class="vm.isUserDms? \'medium-4\': \'medium-5\'" style=left:3%><div><div class=textDesignation rank="{{::piece.rank}} _{{::piece.brand}}">{{piece.designation}}</div><div class=icons><a ng-if="piece.replacement || piece.dmsInformations.supersedingPart"><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=piece.supersedingPart class=icon-icons_chaine_remplacement_locale_listPiece></span> <span ng-if=piece.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if="piece.displayPicto && piece.herculesCase == \'CASE1:HOLE\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span ng-if="piece.displayPicto && piece.herculesCase == \'CASE2: DUALITY\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Duality.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span ng-if="piece.displayPicto && piece.herculesCase == \'CASE3: NEW PROPOSAL\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/NewHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span ng-if="piece.displayPicto && piece.herculesCase == \'CASE4: SAME PROPOSAL\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/SameHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span ng-if="piece.displayPicto && piece.herculesCase == \'CASE5: PROPOSAL DECLINED\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Declined.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span><span ng-if=piece.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=piece.memo class=icon-icons_memo_it_listePiece></span> <span ng-if=piece.isKit class=icon-icons_kit><md-tooltip md-direction=bottom style="margin-top: 3px;">{{\'PRODUCT_KITS_COLLECTION\' | translate}}</md-tooltip></span><picto-list equivalent-types=piece.types family-code=piece.familyCode></picto-list></div></div></div><!-- =====   Stock   ===== --><div ng-if="vm.isUserDms && !vm.isLoadingDMSData" class="medium-1 columns textPiece part-quantity" ng-class=vm.getQuantityClass(piece.dmsInformations.quantity) ng-style="{\'left\':mainCtrl.isIndependentUser ? \'3%\' : \'0px\'}"><phenix-is-number style="margin-left: 105px;" quantity=piece.dmsInformations.quantity is-search-engine=vm.isSearchEngine><span>{{piece.dmsInformations.quantity}}</span></phenix-is-number></div><!-- =====   Taxes   ===== --><div ng-if="!vm.isLoadingDMSData && !vm.isCountryChina && !vm.isCountryIndia && !mainCtrl.isIndependentUser && !vm.isHorseUser" class="medium-2 columns textPiece display-block text-align-right" ng-class="vm.isUserDms? \'priceAvailable\': \'medium-2 columns textPiece\'">{{getPriceToDisplay(piece)}} <span ng-if="getPriceToCheck(piece) >0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined">{{vm.getCurrencyForItem(piece)}}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && vm.isCountrySparc && vm.frCountry != \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && vm.frCountry === \'FR\')" class=priceNotAvailable>{{\'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span></div><!-- =====   Basket   ===== --><div class="medium-1 columns partListColumn"><div ng-if=vm.isUserDms class="switchButton currencyContainer" style="left: 60%; position: relative;"><shopping-cart-quote piece=piece icon=estimate from=PR></shopping-cart-quote></div><div ng-if="!vm.isUserDms && !vm.isHorseUser" class=switchButton style="left: 27%; position: relative;"><shopping-cart piece=piece from=PR></shopping-cart></div></div></div><!-- =====   Residual applicability of the main reference   ===== --><div style="position: relative" class=applicability ng-if="vm.displayComplementaryInformation(piece.simplifiedResidual) || (piece.codifiedSigns && piece.codifiedSigns.length)"><div class=row><div style="z-index: 1" class="medium-10 medium-offset-2 columns containerApplicability"><div ng-click=vm.showHideAppl(piece) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!piece.showAppl,\'icon-icons_arrow_dropdown\':piece.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=piece.showAppl style="width: 112%;"><mtc-line codified-signs=piece.codifiedSigns mtc-list=piece.simplifiedResidual></mtc-line></div><additional-line show-add=piece.showAdd additional=piece.additional></div></div></div><!-- display multiple catalog plate associated with same reference in new search engine--><div style="display: grid;" class="designation textPiece" ng-if="vm.isSearchEngine && !vm.isLoadingDMSData"><div style="width: 1200px;" ng-repeat="alternativePlate in piece.alternativePlates" style="display: inline-flex;"><div style="position: relative" class=applicability ng-if="vm.displayComplementaryInformation(alternativePlate.simplifiedResidual) || (alternativePlate.codifiedSigns && alternativePlate.codifiedSigns.length)"><div class=row><div style="z-index: 1" class="medium-10 medium-offset-2 columns containerApplicability"><div style="display: flex;" ng-click=vm.showHideAppl(alternativePlate) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!alternativePlate.showAppl,\'icon-icons_arrow_dropdown\':alternativePlate.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}} </span><span><div class="designation textPiece" ng-style="{\'left\':!vm.isUserDms ? (!vm.isCountryChina && !vm.isCountryIndia) ? \'473px\':\'517px\' :(!vm.isCountryChina && !vm.isCountryIndia) ? \'258px\':\'347px\'}" ng-if=vm.isSearchEngine&&!vm.isLoadingDMSData><span class="textDesignation plateTooltip">{{alternativePlate.catalogPlate}} <span class=plateTooltipText><img style="height:180px;width: 200px;" ng-src={{alternativePlate.catalogPlates[0].illustration}} alt=""></span></span></div><div class=textPiece style="margin-right: 44px;" ng-if="vm.isSearchEngine&&!vm.isLoadingDMSData && (alternativePlate.replacement || alternativePlate.dmsInformations.supersedingPart)&&!alternativePlate.catalogPlate"><span>_</span></div></span></div><div ng-if=alternativePlate.showAppl style="width: 129%;"><mtc-line codified-signs=alternativePlate.codifiedSigns mtc-list=alternativePlate.simplifiedResidual></mtc-line></div><additional-line show-add=alternativePlate.showAdd additional=alternativePlate.additional></div></div></div></div></div><!-- ================   Additional References   ===================== --><div class=refAdditional ng-if="piece.additional && piece.showAdd"><div ng-repeat="reference in piece.additional"><div class="row valign-middle"><div class="medium-1 columns textPiece textIndex" ng-class="{\'medium-offset-1\': !vm.isUserDms}"></div><!-- =====   Reference   ===== --><div class="medium-1 columns textPiece description white-space"><div ng-class="vm.isUserDms? \'ref-additional-absolute \': \'ref-add-absoluteEB\'">{{reference.reference | filterFormatRef}}</div></div><!-- =====   Designation + pictos   ===== --><div class="columns designation textPiece" ng-class="vm.isUserDms? \'medium-4\': \'medium-5\'"><div><div class=textDesignation>{{::reference.designation}}</div><div class=icons><a ng-if=reference.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=reference.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=reference.reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=reference.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=reference.equivalentTypes family-code=reference.familyCode></picto-list></div></div></div><!-- =====   Stock   ===== --><div class=textPiece ng-if=vm.isSearchEngine&&!vm.isLoadingDMSData><span>_</span></div><div ng-if="vm.isUserDms && !vm.isLoadingDMSData" class="medium-1 columns textPiece part-quantity" ng-class=vm.getQuantityClass(reference.dmsInformations.quantity) ng-style="{\'left\':mainCtrl.isIndependentUser ? \'3%\' : \'\'}"><phenix-is-number quantity=reference.dmsInformations.quantity is-search-engine=vm.isSearchEngine is-additional="piece.additional && piece.showAdd"><span ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'127px\':\'100px\'}">{{reference.dmsInformations.quantity}}</span></phenix-is-number></div><!-- =====   Taxes1   ===== --><div ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'2%\':\'0px\'}" ng-if="!vm.isLoadingDMSData && !vm.isCountryChina && !vm.isCountryIndia && !mainCtrl.isIndependentUser && !vm.isHorseUser" class="medium-2 columns textPiece display-block text-align-right" ng-class="vm.isUserDms? \'leftpx\': \'0px\'">{{getPriceToDisplay(reference)}} <span ng-if="getPriceToCheck(piece) >0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined">{{vm.getCurrencyForItem()}}</span></div><!-- =====  Estimate & Basket   ===== --><div class="medium-1 columns partListColumn"><div ng-if=vm.isUserDms class="switchButton currencyContainer" style="left: 60%; position: relative;"><shopping-cart-quote piece=reference from=PR icon=estimate type=PPS main-piece=piece></shopping-cart-quote></div><div ng-if="!vm.isUserDms && !vm.isHorseUser" class=switchButton style="left: 27%; position: relative;"><shopping-cart piece=reference from=PR type=PPS main-piece=piece></shopping-cart></div></div></div><!--=====================================\n                    =                  PPS                  =\n                    ======================================--><div ng-if="vm.displayComplementaryInformation(reference.simplifiedResidual) || (reference.codifiedSigns && reference.codifiedSigns.length)" style="position: relative; margin-top: 0px" class="applicability row"><div style="z-index: 1;" class="medium-10 medium-offset-1 columns containerApplicability"><div><div ng-click=vm.displayPPSApplicabilities(piece.additional) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!reference.displayPPS,\'icon-icons_arrow_dropdown\':reference.displayPPS}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=reference.displayPPS style="width: 110.5%;"><mtc-line codified-signs=reference.codifiedSigns mtc-list=reference.simplifiedResidual></mtc-line></div></div></div><additional-line ng-if=!$last show-add=piece additional=piece></div></div></div><!-- ================ SECOND              ===================== --><!--<pre>{{piece.alternative | json}}</pre>--><div class=alternative ng-class="{\'displayNone\':!piece.alternative}"><div class="alternative-row row" ng-repeat="piece in piece.alternative" ng-init="optionsN2 = {mainPart: piece}" ng-class="[piece.brand ? \'\':\'displayNone\']"><div ng-class="vm.isCountrySparc ? (getPriceToCheck(piece) > 0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined ? \'\': \'displayNone\') : \'\'"><div class=separator></div><div class="row valign-middle"><!-- =====   Index   ===== --><div class="medium-1 columns textPiece textIndex" ng-class="{\'medium-offset-1\': !vm.isUserDms}"><div class="div-inline unfold" ng-class="!vm.isUserDms? \'expandedPlus\': \'0px\'"><i ng-click=vm.showHideAdd(piece) ng-class="{\'icon-icons-phnx-expendable_plus\':!piece.showAdd,\'icon-icons-phnx-exependable_moins\':piece.showAdd, \'noVisibility\': !piece.additional || piece.additional.length == 0}"></i></div><div></div></div><!-- =====   Reference   ===== --><div class="medium-1 columns designation textPiece"><span ng-class="!vm.isUserDms? \'subPartDivEB\': \'subPartRef\'" style="display: flex;" class=white-space ng-style="{\'right\': (vm.isUserDms && (vm.isCountryChina || vm.isCountryIndia)) ? \'24% !important\' : \'\'}">{{piece.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(piece.reference);$event.stopPropagation();></i></span></div><!-- =====   DESIGNATION + PICTOS   ===== --><div class="columns designation textPiece" ng-class="!vm.isUserDms? \'medium-5\': \'medium-4\'" ng-style="{\'left\': !vm.isUserDms ? \'0%\':\'3%\'}"><div><div class=textDesignation rank="{{::piece.rank}} _{{::piece.brand}}">{{piece.designation}}</div><div class=icons><a ng-if="piece.replacement || piece.dmsInformations.supersedingPart"><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=piece.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=piece.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=piece.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=piece.equivalentTypes family-code=piece.familyCode></picto-list></div></div></div><!-- =====   Stock   ===== --><div ng-if="vm.isUserDms && !vm.isLoadingDMSData" class="medium-1 columns textPiece part-quantity" ng-class=vm.getQuantityClass(piece.dmsInformations.quantity) ng-style="{\'left\':mainCtrl.isIndependentUser ? \'3%\' : \'\'}"><phenix-is-number quantity=piece.dmsInformations.quantity is-search-engine=vm.isSearchEngine is-alter-native=piece.alternative><span ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?vm.isUserDms&&(!vm.isCountryChina && !vm.isCountryIndia)?\'140px\':\'127px\':\'100px\'}">{{piece.dmsInformations.quantity}}</span></phenix-is-number></div><div ng-if="vm.isUserDms && vm.isLoadingDMSData" ng-class=stockLoading class="medium-2 columns textPiece"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</div><!-- =====   Taxes   ===== --><div ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'3%\':\'0px\'}" ng-if="!vm.isLoadingDMSData && !vm.isCountryChina && !vm.isCountryIndia && !mainCtrl.isIndependentUser && !vm.isHorseUser" ng-model=piece.dmsInformations.priceExclTaxes class="medium-2 columns textPiece display-block text-align-right" ng-class="vm.isUserDms? \'priceAvailable\': \'medium-2 columns textPiece\'">{{getPriceToDisplay(piece)}} <span ng-if="getPriceToCheck(piece) >0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined">{{vm.getCurrencyForItem(piece)}}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && vm.isCountrySparc && vm.frCountry != \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && vm.frCountry === \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span></div><div ng-if="vm.isUserDms && vm.isLoadingDMSData" ng-model=piece.dmsInformations.priceExclTaxes class="medium-2 columns textPiece display-block text-align-right"><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><!-- =====   Estimate   ===== --><!-- =====   Stock   ===== --><div class="medium-1 columns partListColumn"><div ng-if=vm.isUserDms class="switchButton currencyContainer" style="left: 60%; position: relative;"><shopping-cart-quote piece=piece icon=estimate from=PR></shopping-cart-quote></div><div ng-if="!vm.isUserDms && !vm.isHorseUser" class=switchButton style="left: 27%; position: relative;"><shopping-cart piece=piece from=PR></shopping-cart></div></div></div><!-- ==============   Residual Applicability   ================= --><div style="position: relative" class=applicability ng-if="vm.displayComplementaryInformation(piece.simplifiedResidual) || (piece.codifiedSigns && piece.codifiedSigns.length)"><div class=row><div style="z-index: 1" class="medium-10 medium-offset-2 columns containerApplicability"><div ng-click=vm.showHideAppl(piecePrincipal) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!piece.showAppl,\'icon-icons_arrow_dropdown\':piece.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=piece.showAppl style="width: 112%;"><mtc-line codified-signs=piece.codifiedSigns mtc-list=piece.simplifiedResidual></mtc-line></div></div><additional-line show-add=piece.showAdd additional=piece.additional></div></div><!-- PPS --><!-- =================   Additonal References   =================== --><div class=refAdditional ng-if="piece.additional && piece.showAdd"><div ng-repeat="reference in piece.additional"><div class="row valign-middle"><!-- =====   Index   ===== --><div class="medium-1 columns textPiece textIndex" ng-class="{\'medium-offset-1\': !vm.isUserDms}"></div><!-- =====   Reference   ===== --><div class="medium-1 columns textPiece description"><div class=white-space ng-class="vm.isUserDms? \'ref-additional-absolute \': \'ref-add-absoluteEB\'">{{::reference.reference | filterFormatRef}}</div></div><!-- =====   Designation + pictos   ===== --><div class="columns designation textPiece" ng-class="vm.isUserDms? \'medium-4\': \'medium-5\'"><div><div class=textDesignation>{{::reference.designation}}</div><div class=icons><a ng-if=reference.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}pp</md-tooltip></a><span ng-if=reference.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=reference.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=reference.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=reference.equivalentTypes></picto-list></div></div></div><!-- =====   Stock   ===== --><div class=textPiece ng-if=vm.isSearchEngine&&!vm.isLoadingDMSData><span>_</span></div><div ng-if="vm.isUserDms && !vm.isLoadingDMSData" class="medium-1 columns textPiece part-quantity" ng-class=vm.getQuantityClass(reference.dmsInformations.quantity) ng-style="{\'left\':mainCtrl.isIndependentUser ? \'3%\' : \'\'}"><phenix-is-number quantity=reference.dmsInformations.quantity is-search-engine=vm.isSearchEngine is-additional="piece.additional && piece.showAdd" ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'127px\':\'100px\'}"><span ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'127px\':\'100px\'}">{{reference.dmsInformations.quantity}}</span></phenix-is-number></div><div ng-if="reference.dmsInformations.quantity && vm.isUserDms && vm.isLoadingDMSData" ng-class=stockLoading class="medium-2 columns textPiece"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</div><!-- =====   Taxes   ===== --><div ng-style="{\'margin-left\' : vm.isSearchEngine&&!vm.isLoadingDMSData?\'2%\':\'0px\'}" ng-if="!vm.isLoadingDMSData && !vm.isCountryChina && !vm.isCountryIndia && !mainCtrl.isIndependentUser && !vm.isHorseUser" class="medium-2 columns textPiece display-block text-align-right">{{getPriceToDisplay(reference)}}</div><div ng-if="vm.isUserDms && vm.isLoadingDMSData" class="medium-2 columns textPiece display-block text-align-right"><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><!-- =====   Estimates   ===== --><!-- =====   Quantities   ===== --><div class="medium-1 columns partListColumn"><div ng-if=vm.isUserDms class="switchButton currencyContainer" style="left: 60%; position: relative;"><shopping-cart-quote piece=reference main-piece=piece icon=estimate from=PR type=PPS></shopping-cart-quote></div><!-- =====   BASKET   ===== --><div ng-if="!vm.isUserDms && !vm.isHorseUser" class=switchButton style="left: 27%; position: relative;"><shopping-cart piece=reference main-piece=piece from=PR type=PPS></shopping-cart></div></div></div><div ng-if="vm.displayComplementaryInformation(reference.simplifiedResidual) || (reference.codifiedSigns && reference.codifiedSigns.length)" style="position: relative; margin-top: 0px" class="applicability row"><div style="z-index: 1;" class="medium-10 medium-offset-2 columns containerApplicability"><div style="margin-left: 30px;"><div ng-click=vm.displayPPSApplicabilities(piece.additional) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!reference.displayPPS,\'icon-icons_arrow_dropdown\':reference.displayPPS}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=reference.displayPPS><mtc-line codified-signs=reference.codifiedSigns mtc-list=reference.simplifiedResidual></mtc-line></div></div></div><additional-line ng-if=!$last show-add=piece additional=piece></div></div></div></div></div></div></div></div></div><div><table style="border: none;"><tr class=row><td class="medium-4 columns scrollVignetteImg" id=scrollVignetteContainer ng-repeat="vignette in vm.listOfPlate"><button ng-attr-id=vignette_{{$index}} ng-click="vm.onVignetteClick(vignette.id, vignette)" class="marginVignette clickable" ng-class=vm.isEBBorderVignette($index)><div class=centreImg><div>{{vignette.id}}</div></div></button></td></tr></table></div></div></div>');
$templateCache.put('app/components/car/carSearchResult/easyBasket/confirmPopUp.template.html','<md-dialog id=modalOnDeleteCart><div class=modalPhenix><div class=title>{{\'COMMON_CANCEL_ALERT\' | translate}}</div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left left-white" ng-click=vm.onConfirm()><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'COMMON_YES\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><em class="icon-icons_close icon-icons_close-primary"></em></div><div class=btnText>{{\'COMMON_NO\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/car/carSearchResult/easyBasket/easyBasketDetails.template.html','<div id=easyBasketDetails class=easyBasketContainer style=overflow:hidden; ng-class="{\'popupChange\':vm.isEasyBasket, \'popupWidth\': !vm.isEasyBasket}"><div class=interventionHeader><span><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""></span><span class=headerSeperator>|</span> <span class=headTitle>{{\'INTERVENTIONS_NEW\' | translate | uppercase}} : {{vm.title | uppercase}}</span> <span style="cursor: pointer;float:right;padding-top:2%;" ng-click=vm.onCancel()><i class=icon-icons_close></i></span></div><list-intervention list-data=vm.data is-modal=true int-title=vm.title node-id=vm.nodeId></list-intervention></div>');
$templateCache.put('app/components/car/carSearchResult/easyBasket/listIntervention.template.html','<div style="font-size: var(--renaultMediumFont);" ng-style="{\'max-height\':vm.isModal ? \'480px\' : \'none\',\'overflow-y\':vm.isModal ? \'auto\':\'hidden\'}"><div class=brwAccordion ng-repeat="item in vm.interventionList | orderBy:\'designation\' track by $index"><div class="small-12 columns" style="color:black;margin-bottom: 1%;" ng-style="{\'border-bottom\': !item.showBasketDetails ? \'1px solid #D3D3D3\' : \'0px\' }"><div class="small-1 columns expandButton" style=padding-left:0px;><em class="icons easyBasketIcons" ng-click="item.showBasketDetails = !item.showBasketDetails; vm.showDetail(item, true);" ng-class="{\'icon-icons_expendable_plus float-left\':!item.showBasketDetails,\'icon-icons_exependable_moins float-left\':item.showBasketDetails}"></em></div><div class="small-8 columns designation" ng-class="{\'float-left\': !item.showBasketDetails}" style=padding-left:0px;>{{item.designation | capitalize}} <span ng-if="item.maturity == \'OFFICIAL\' && vm.isArcaUser"><i class="fa fa-check" aria-hidden=true style="color: green;font-size: 20px;"></i><md-tooltip>{{\'LABEL_VALIDATED\' |translate}}</md-tooltip></span><span ng-if="item.maturity == \'UNOFFICIAL\' && vm.isArcaUser"><i class="fa fa-cog" aria-hidden=true style="font-size: 20px;color:gray;"></i><md-tooltip>{{\'VALIDATION_IN_PROGRESS\' |translate}}</md-tooltip></span><span ng-if="item.interventionQuantity > 0" class=qtyCircle>X{{item.interventionQuantity}}<md-tooltip>{{\'SEVERAL_OPERATIONS\' | translate}}</md-tooltip></span></div><div class="small-1 columns card" style=margin-top:1px; ng-style="{\'margin-left\' : vm.isDmsProfile ? \'6.5%\' : \'0\'}"><span ng-if="item.showBasketDetails && vm.initialInterventionDetails.INT[0].mrDocumentIds && vm.initialInterventionDetails.INT[0].mrDocumentIds.length > 0"><img src=./assets/images/mr_link_black.svg class=mrLinkIcon ng-click=vm.gotoMrLink(vm.initialInterventionDetails)> <img src=./assets/images/mr_link_orange.svg class=img-top ng-click=vm.gotoMrLink(vm.initialInterventionDetails)><md-tooltip style="margin-left: 34px;">{{\'CONSULT_MR_DESCRIPTION\' | translate }}</md-tooltip></span><span ng-if="item.showBasketDetails && vm.initialInterventionDetails.INT[0].mrDocumentIds && vm.initialInterventionDetails.INT[0].mrDocumentIds.length == 0"><img src=./assets/images/mr_link_black.svg style="height: 30px;\n                position: relative;\n                width: 40px;\n                margin-left: 35px;background-color: gainsboro;"><md-tooltip style="margin-left: 34px;">{{ \'REFER_TO_MR_TAB\' | translate }}</md-tooltip></span></div><div class="small-1 columns shopping-carteb addToBasket interventionDropdown" ng-style="{\n                            \'margin-left\': item.showBasketDetails && item.bulkAdditionDone ? \'0\' : \'25px\',\n                            \'left\': item.showBasketDetails && item.bulkAdditionDone ? \'16px\' : \'0px\'\n                        }" ng-if="item.showBasketDetails && vm.isArcaUser" style="margin-bottom: 1%;border: 2px solid var(--renaultPrimaryColor);background-color : #fff;padding: 0;left: 15px;color: var(--renaultPrimaryColor)"><i class="fa fa-download clickItem" ng-click=vm.selectCsv(item) style="cursor: pointer;padding: 5px;margin-left: 22px;bottom: 7px;position: relative;font-size: 17px;"></i><div id=myDropdown class=interventionDropdown-content><a csv-download is-intervention=true ng-if=item.showPrCsvFile column-header=vm.headerPr input-array=vm.columnValuePr details=vm.selectedItemDetails>{{\'EXPORT_PR\' |translate}}</a> <a csv-download is-intervention=true ng-if=item.showPrCsvFile column-header=vm.headerTm input-array=vm.columnValueTm details=vm.selectedItemDetails>{{\'EXPORT_TM\' |translate}}</a></div><md-tooltip>{{\'INTERVENTION_CSV\' |translate}}</md-tooltip></div><div class="small-1 columns addToBasket shopping-carteb" ng-style="{\'margin-left\' : item.showBasketDetails && item.bulkAdditionDone ? \'6px\' : \'0\'}" ng-if="item.showBasketDetails && !vm.isDmsProfile && !vm.isHorseUser" style="margin-bottom: 1%;" ng-click="item.bulkAdditionDone ? vm.goToBasket() : vm.handleFirstAdd(item)" ng-class="{\'bulkAddedBasket\':item.bulkAdditionDone, \'emptyBasket\':!item.bulkAdditionDone && (!vm.prPopUp || !vm.tmPopUp) ,\'prtmButtonDisable\':vm.prPopUp && vm.tmPopUp && !item.bulkAdditionDone}"><i class="icon-icons_basket on-basket-hover" ng-class="{\'prtmButtonDisable\':vm.prPopUp && vm.tmPopUp, \'deleteIcon\':item.showBasketDetails && item.bulkAdditionDone}" ng-style="{\'font-size\':item.showBasketDetails && item.bulkAdditionDone?\'31px\':\'25px\'}"></i><div class=recap-cart-container id=recap-cart><recap-cart flatten-cart=vm.flattenCart cart-metadata=vm.cartMetadata></recap-cart></div><cart-badge cart-length=vm.getItemCount ng-if="item.showBasketDetails && item.bulkAdditionDone" style="position: relative; top: -8px; left:-38px;"></cart-badge><md-tooltip ng-if="item.showBasketDetails && !item.bulkAdditionDone">{{\'ADD_INTERVENTION_TO_BASKET\' |translate}}</md-tooltip></div><div class="small-1 columns addToBasket shopping-carteb operations-estimate-action" ng-if="item.showBasketDetails && vm.isDmsProfile" ng-click="item.showBasketDetails && item.bulkQuoteAdditionDone ? vm.goToQuote() : vm.handleBulkAdd(item)" style="margin-bottom: 1%; margin-left: 0px;" ng-class="{\'bulkAddedBasket\':item.bulkQuoteAdditionDone, \'emptyBasket\':!item.bulkQuoteAdditionDone && (!vm.prPopUp || !vm.tmPopUp) ,\'prtmButtonDisable\':vm.prPopUp && vm.tmPopUp && !item.bulkAdditionDone}"><span class="operations-estimate-icon-wrapper on-super-cart-quote-hover"><img ng-if=!item.bulkQuoteAdditionDone src=./assets/images/icons_estimation_white.svg class=operations-estimate-icon alt="{{\'ADD_INTERVENTION_TO_QUOTATION\' | translate}}"> <i ng-if=item.bulkQuoteAdditionDone class="icon-icons_estimation operations-estimate-icon" aria-hidden=true></i><cart-badge cart-length=vm.getQuoteCount ng-if="item.showBasketDetails && item.bulkQuoteAdditionDone" class=operations-estimate-badge></cart-badge></span><div class=super-cart-quote-container id=quotePopin><super-cart-popin items=vm.quote.items icon=icon-icons_estimation popin-title=vm.quotePopinTitle popin-subtitle=vm.quotePopinSubtitle type=quote ng-if="item.showBasketDetails && item.bulkQuoteAdditionDone"></super-cart-popin></div><md-tooltip ng-if="item.showBasketDetails && !item.bulkQuoteAdditionDone">{{\'ADD_INTERVENTION_TO_QUOTATION\' |translate}}</md-tooltip></div><!-- <span class="small-1 columns" style="float: left; cursor: pointer; margin-bottom: 1%;" ng-if="item.showBasketDetails && vm.isUserDms" ng-click="!item.fodCalculating && vm.calculateFod(item)">\n                <i ng-if="!item.fodCalculating && !item.fodEstimateTotal" class="fa fa-calculator" style="font-size: 20px; position: relative; top: 5px;"></i>\n                <i ng-if="item.fodCalculating" class="fa fa-spinner fa-spin" style="font-size: 20px; position: relative; top: 5px;"></i>\n                <i ng-if="!item.fodCalculating && item.fodEstimateTotal" class="fa fa-refresh" style="font-size: 18px; position: relative; top: 5px;"></i>\n                <md-tooltip>{{\'FOD_CALCULATE_ESTIMATE\' | translate}}</md-tooltip>\n            </span> --> <span class="small-1 columns bulkDeleteTrash" id=delete ng-if="item.showBasketDetails && (item.bulkAdditionDone || item.bulkQuoteAdditionDone)" ng-click=vm.bulkBasketDelete(item) style="float: left;" value="Decrease Value"><i class="fa fa-trash deleteIcon" style="font-size: 19px;"></i><md-tooltip ng-if=item.bulkAdditionDone>{{\'BASKET_REMOVED\' |translate}}</md-tooltip><md-tooltip ng-if=item.bulkQuoteAdditionDone>{{\'QUOTE_REMOVED\' |translate}}</md-tooltip></span></div><div class="small-12 columns" ng-if=item.fodEstimateTotal style="text-align: right; padding: 4px 15px; border-bottom: 1px solid #F0F0F0;"><span>{{\'ESTIMATE_TOTAL_NETHT\' | translate}}</span>: <strong>{{item.fodEstimateTotal.exclTaxes | number:2}} {{vm.getCurrencyForItem()}}</strong></div><div class=eb-feedback-actions ng-if="item.showBasketDetails && vm.isShowIcon"><div class="eb-feedback-btn eb-feedback-like" role=button tabindex=0 ng-click=vm.availableIconClick() ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) && vm.availableIconClick()" ng-attr-aria-label="{{\'LIKE_ICON_TOOLTIP\' | translate}}"><span class=eb-feedback-count aria-hidden=true>{{vm.availableCount}}</span> <svg class=check_icon xmlns=http://www.w3.org/2000/svg viewBox="0 0 128 72" width=30 height=20 ng-if="vm.activeButton == \'active\'"><g fill=none stroke=currentColor stroke-width=12 stroke-linecap=round stroke-linejoin=round><path d="M12 42 L32 60 L66 20"/><path d="M60 42 L80 60 L114 20"/></g></svg> <i class="fa fa-check eb-feedback-icon" ng-if="vm.activeButton != \'active\'" aria-hidden=true></i> <span class=eb-feedback-text ng-if="vm.activeButton != \'active\'">{{\'LIKE_ICON_TOOLTIP\' | translate}}</span> <span class=eb-feedback-text_inactive ng-if="vm.activeButton == \'active\'">{{\'LIKED_TOOLTIP\' | translate}}</span></div><div class="eb-feedback-btn eb-feedback-dislike" role=button tabindex=0 ng-click=vm.unavailableIconClick() ng-keydown="($event.keyCode === 13 || $event.keyCode === 32) && vm.unavailableIconClick()" ng-attr-aria-label="{{\'REMOVE_ICON_TOOLTIP\' | translate}}"><i class="fa fa-bullhorn eb-feedback-icon" ng-if="vm.activeButton != \'inactive\'" aria-hidden=true></i> <i class="fa fa-bullhorn eb-feedback-icon primary" ng-if="vm.activeButton == \'inactive\'" aria-hidden=true></i> <span class=eb-feedback-text ng-if="vm.activeButton != \'inactive\'">{{\'REMOVE_ICON_TOOLTIP\' | translate}}</span> <span class=eb-feedback-text_inactive ng-if="vm.activeButton == \'inactive\'">{{\'ALERT_REPORTED_TOOLTIP\' | translate}}</span></div></div><div ng-if=item.showBasketDetails style="margin-bottom:1%;margin-left: 5%;padding-left:0px;" class="small-11 columns"><div ng-repeat="(key, value) in vm.interventionDetails.INT[0].basketContent" ng-if="vm.interventionDetails && vm.interventionDetails.INT && vm.interventionDetails.INT.length != 0 && vm.interventionDetails.INT[0].basketContent" class="small-12 columns" style="border-left:7px solid var(--renaultSecondaryColor);padding-right: 5px;\n                padding-left: 15px"><span ng-if="value.length > 0 && vm.atLeastOnePR && key == \'partsItems\'" class=intItemsHead>PR</span> <span ng-if="value.length > 0 && vm.atLeastOneTM && key == \'labourTimeItems\'" style="top: 3px; position: relative;" class=intItemsHead>TM</span> <span ng-if="value.length > 0 && key == \'ingredients\'" class=intItemsHead>Ingredients</span><div ng-if="value.length > 0 && vm.atLeastOnePR && key == \'partsItems\' && vm.isDisplayBrandButtons"><md-button class=brandButtons ng-if="brandArr.brand === \'ORG\'" ng-repeat="brandArr in vm.brandButtonArray" ng-click=vm.selectBrandParts(brandArr.brand) ng-style="brandArr.isSelBrand && { \'background-color\' :  $root.renaultPrimaryColor, \'color\': \'white\'} || {\'background-color\' : \'#e2ddd0\'}"><i class="fa fa-check" ng-if=brandArr.isSelBrand aria-hidden=true></i> <span>{{\'EB_ORIGINAL_REF\'|translate}}</span></md-button><md-button class=brandButtons ng-if="brandArr.brand !== \'ORG\'" ng-repeat="brandArr in vm.brandButtonArray" ng-click=vm.selectBrandParts(brandArr.brand) ng-style=vm.getStyle(brandArr.isSelBrand,brandArr.brand)><span ng-if="brandArr.brand == \'STDEX\'">{{\'STANDARD_EXCHANGE\' | translate}}</span> <i class="fa fa-check" ng-if=brandArr.isSelBrand aria-hidden=true></i> <img class=imgChangeColor ng-src={{vm.getImageUrl(brandArr.isSelBrand,brandArr.brand)}} height=30 width=50 alt="" ng-style="{\'width\':brandArr.brand == \'STDEX\' ? \'15px\' : \'\', \'filter\' :((brandArr.brand == \'MOT\'|| brandArr.brand == \'VAL\'  ) && brandArr.isSelBrand) ? \'brightness(0) invert(1)\' :\'\' }"></md-button></div><div ng-if="value.length > 0" style="margin-left: 3%"><table class="small-12 columns" style="border: none;margin-bottom:0px;border-collapse: collapse;"><thead style="background: none;position: relative;" ng-style="{\'bottom\':(!vm.isDmsProfile)?\'15px\':\'5px\'}"><th class=columns></th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\'">{{\'DOCUMENT_MD_REF\'|translate}}</th><th class="small-1 columns" ng-if="vm.atLeastOneTM && key == \'labourTimeItems\'">{{\'ALERTS_CODE\'|translate}}</th><th class=columns style=left:35px; ng-if="vm.atLeastOnePR && key == \'partsItems\'" ng-class="{\'small-5\':vm.isDmsProfile ,\'small-6\':!vm.isDmsProfile}">{{\'COMMON_DESIGNATION\'|translate}}</th><th class="small-1 columns" ng-if="vm.atLeastOneTM && key == \'labourTimeItems\'">{{\'CAR_OTS_TYPE\'|translate}}</th><th class="small-1 columns" ng-if="vm.atLeastOneTM && key == \'labourTimeItems\'">{{\'DOCUMENT_TM_TIME\'|translate}}</th><th class="small-7 columns" ng-if="vm.atLeastOneTM && key == \'labourTimeItems\'" style="float: left;">{{\'DOCUMENT_TM_DETAILS\'|translate}}</th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\'">{{\'COMMON_COLUMN_QTE_TITLE\'|translate}}</th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\' && vm.isDmsProfile" style="left: -1%;">{{"COMMON_STOCK"|translate|capitalize}}</th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\'" style="left: -1%"><span ng-if="!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia">{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</span></th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\'">{{\'INTERVENTION_CATALOG_PLATE\'|translate}}</th><th class="small-1 columns"></th><th class="small-1 columns" ng-if="vm.atLeastOnePR && key == \'partsItems\'" style=float:left;></th></thead><tbody ng-repeat="partData in value track by $index" ng-if="key == \'partsItems\' && partData.parts.length > 0" ng-init="itemGroupIndex = $index" style=position:relative; ng-style="{\'height\':partData.parts.length == 1 ? partData.parts[0].alternative.length > 0 ? \'{{37+(partData.parts[0].alternative.length*23)}}px\':\'30px\': \'0px\', \'top\':(vm.isDmsProfile && partData.parts[0].alternative.length > 0) ? \'10px\': \'\'}"><tr class=columns ng-if="((partData.parts.length > 1 || partData.parts.length === 2) && !partData.containsStdExcPart)" style="position: relative;right: 63px;bottom: 13px;margin-bottom: -25px;"><td><i class="fa fa-info-circle" style="font-size: 20px; color: #2E2ECA"></i><md-tooltip md-direction=right style="white-space: normal;">{{\'SEVERAL_REFERENCES\' |translate}}</md-tooltip></td></tr><tr style="position:relative; display: inline-block;" ng-style="{\'border-left\':((partData.parts.length > 1 || partData.parts.length === 2) && !partData.containsStdExcPart) ? \'2px solid #2E2ECA\':\'\', \'margin-top\': partData.parts.length === 1 ? \'10px\': \'-10px\', \'top\': $first ? \'0px\': \'-5px\'}" ng-repeat="part in partData.parts track by $index" ng-init="mainIndex = $index" class="{{part.isBlueLine}} small-12 columns" ng-class="{\'partSpacing\':key == \'partsItems\', \'blueLeftLineHeight\': (((partData.parts.length > 1 && partData.parts.length <= 8) || partData.parts.length === 2) && $last && !partData.containsStdExcPart), \'blueLeftLineHeight1\':((partData.parts.length > 1 && partData.parts.length >= 9) && $last && !partData.containsStdExcPart)}"><td class="small-1 columns clickable" ng-class="{\'disabled\': !part.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}" style="right: 13px;padding-left: 1px;padding-right: 1px;cursor: pointer;"><span ng-if="part.additional !=null && part.additional.length > 0" class="small-1 columns expandButton" style="padding-left:0px;position: relative;"><em class="icons easyBasketIcons" style="position: absolute; right: 20px;" ng-click="part.showAddPart = !part.showAddPart;" ng-class="{\'icon-icons_expendable_plus float-left\':part.showAddPart,\'icon-icons_exependable_moins float-left\':!part.showAddPart}"></em> </span><span ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part)" style=display:flex; class=white-space>{{part.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(part.reference);$event.stopPropagation();></i></span></td><td class="columns clickable" ng-class="{\'disabled\': !part.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone, \'small-5\':vm.isDmsProfile ,\'small-6\':!vm.isDmsProfile}" style="left: 33px; cursor: pointer;"><span ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part)" style="cursor: pointer;">{{part.designation}}</span>&ensp; <span ng-if="vm.isStandardExchange(part.types) && vm.isTractionBattery(part.familyCode)"><img src=./assets/images/renative.png height=15 width=40 alt=Renative> </span><span ng-if="vm.isStandardExchange(part.types) && !vm.isTractionBattery(part.familyCode)"><md-tooltip>{{\'STANDARD_EXCHANGE\' | translate}}</md-tooltip><img src=./assets/images/renative_reman.png height=15 width=40 alt=""> </span><a style=color:#333; ng-if="part.replacement || part.dmsInformations.supersedingPart" ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part, \'replacement\')"><span style="top: 4px; position: relative; font-size: var(--renaultExtraLargeFont) !important;" class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if="part.herculesCase == \'CASE1:HOLE\'&& vm.isArcaUser"><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span ng-if="part.herculesCase == \'CASE2: DUALITY\' && vm.isArcaUser"><img src=./assets/images/Duality.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span ng-if="part.herculesCase == \'CASE3: NEW PROPOSAL\' && vm.isArcaUser"><img src=./assets/images/NewHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span ng-if="part.herculesCase == \'CASE4: SAME PROPOSAL\'&& vm.isArcaUser"><img src=./assets/images/SameHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span ng-if="part.herculesCase == \'CASE5: PROPOSAL DECLINED\'&& vm.isArcaUser"><img src=./assets/images/Declined.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span></td><td class=columns ng-class="{\'disabled\': !part.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone, \'small-5\':vm.isDmsProfile ,\'small-6\':!vm.isDmsProfile}" ng-if="part.designation == \'\'">&nbsp;</td><td style="position:relative; left: 15px;" class="small-1 columns" ng-class="{\'disabled\': !part.switchEnable || part.hideTM || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span>{{part.quantity}}</span></td><td class="small-1 columns" ng-if=vm.isDmsProfile><span ng-if="part.dmsInformations.quantity || part.dmsInformations.quantity == 0"><i class="fa fa-circle" ng-style="{\'color\':part.stockAvailability ? \'green\' : \'red\'}" aria-hidden=true><md-tooltip>{{part.dmsInformations.quantity}}</md-tooltip></i></span><span ng-if="!part.dmsInformations.quantity && part.dmsInformations.quantity !=0">-<md-tooltip>{{"CONNECTED_SERVICES_UNKNOWN_STATUS"|translate}}</md-tooltip></span></td><td class="small-1 columns" style="padding-left: 2px;padding-right: 2px;"><span ng-if="!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia" ng-style="{\'left\': (vm.getPriceToDisplay(part) === 0 || vm.getPriceToDisplay(part) === null || vm.getPriceToDisplay(part) === undefined || vm.getPriceToDisplay(part) === \'-\')  ? \'27px\' : \'0\', \'position\':(vm.getPriceToDisplay(part) === 0 || vm.getPriceToDisplay(part) === null || vm.getPriceToDisplay(part) === undefined || vm.getPriceToDisplay(part) === \'-\')  ? \'relative\' : \'\'}"><span>{{vm.getPriceToDisplay(part)}} </span><span ng-if="part.priceExclTaxes > 0 || part.dmsInformations.priceExclTaxes > 0">{{vm.getCurrencyForItem(part)}}</span><md-tooltip ng-if="((vm.getPriceToDisplay(part) === 0 || vm.getPriceToDisplay(part) === null || vm.getPriceToDisplay(part) === undefined || vm.getPriceToDisplay(part) === \'-\') && vm.isCountrySparc && vm.frCountry != \'FR\')">{{"PRICE_UNAVAILABLE"|translate}}</md-tooltip><md-tooltip ng-if="((vm.getPriceToDisplay(part) === 0 || vm.getPriceToDisplay(part) === null || vm.getPriceToDisplay(part) === undefined || vm.getPriceToDisplay(part) === \'-\') && vm.frCountry === \'FR\')">{{"PRICE_UNAVAILABLE_FR_COUNTRY"|translate}}</md-tooltip></span></td><td style=position:relative; class="small-1 columns"><img src=./assets/images/Eb_plate.svg class=catalogPlate style="margin-left: 20px;font-size: var(--renaultLargeFont); height: 20px;" ng-style="vm.isCatalogPlateAllowedForHorse(part) ? {\'cursor\': \'pointer\'} : {\'opacity\': \'0.5\', \'cursor\': \'not-allowed\', \'pointer-events\': \'none\'}" ng-click="vm.isCatalogPlateAllowedForHorse(part) && vm.gotoCatalogPlate(part, $index,partData,value)"><md-tooltip md-direction=right style="white-space: normal; height: auto !important;padding: 2px 15px 2px 15px;"><div ng-if=vm.isCatalogPlateAllowedForHorse(part)><div ng-repeat="catalogPlate in vm.checkCatalogPlateId(part)">{{catalogPlate}}</div></div><div ng-if=!vm.isCatalogPlateAllowedForHorse(part)>{{\'EASYLINK_VEHICLE_DATA_SHARING_INACTIVE\' | translate}}</div></md-tooltip></td><td style=padding-bottom:1px; class="small-1 columns"></td><td class="small-1 columns" style="float: left;" ng-style="{\'margin-left\':vm.isModal ? \'none\' : \'-1.6%\'}" ng-if=!vm.isHorseUser><span ng-if="partData.parts.length >= 1"><md-switch ng-change=vm.alterSwitchEnable(part.switchEnable,itemGroupIndex,mainIndex,-1) ng-model=part.switchEnable ng-disabled=part.toggleDisable style="margin: 0px !important;position: relative;left: 25%;top: -5px;" class=eb-switch ng-class="{\'eb-switch-on\':part.switchEnable, \'disabled\': part.toggleDisable,\'eb-switch-off\':!part.switchEnable}"></md-switch></span></td><td class="break small-12 columns" style=padding-bottom:0px;margin-top:20px ng-if="part.alternative.length > 0"><ng-container><table style="width: 100%; border: none !important; margin-bottom: 0px;" id=alternativePartData><tbody><tr style="background-color: white; position: relative;" class=alterSpace ng-repeat="altervalue in part.alternative track by $index" ng-if="(!vm.isDmsProfile && altervalue.priceAvailability) || (vm.isDmsProfile && altervalue.stockAvailability)" ng-style="{\'height\':part.alternative.length > 1 ? \'22px\': \'40px\', \'bottom\':part.alternative.length > 1 ? \'21px\': \'20px\'}"><td style="border-left: 2px dashed gray;height: 17px;right: 12px;cursor: pointer;" ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part)" class="small-1 columns clickable"><span ng-style="{\'color\': (!altervalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone)? \'#D3D3D3\' : \'#000\'}" style=display:flex; class=white-space>{{altervalue.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(altervalue.reference);$event.stopPropagation();></i><md-tooltip ng-if="part.alternative.length > 0">{{\'ALTERNATE_PARTS\'|translate}}</md-tooltip></span></td><td class="columns clickable" style="left:20px;cursor: pointer;" ng-class="{\'small-5\':vm.isDmsProfile, \'small-6\':!vm.isDmsProfile,\'disabled\': !altervalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span ng-style="{\'color\':(!altervalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone)? \'#D3D3D3\' : \'#000\'}"><span ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part)" style="cursor: pointer;">{{altervalue.designation}}</span>&ensp;<picto-list equivalent-types=altervalue.equivalentTypes></picto-list><a style=color:#333; ng-if="altervalue.replacement || altervalue.dmsInformations.supersedingPart" ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part, \'replacement\')"><span style="top: 4px; position: relative;" class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if="altervalue.herculesCase == \'CASE1:HOLE\' && vm.isArcaUser "><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span ng-if="altervalue.herculesCase == \'CASE2: DUALITY\'&& vm.isArcaUser"><img src=./assets/images/Duality.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span ng-if="altervalue.herculesCase == \'CASE3: NEW PROPOSAL\'&& vm.isArcaUser"><img src=./assets/images/NewHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span ng-if="altervalue.herculesCase == \'CASE4: SAME PROPOSAL\'&& vm.isArcaUser"><img src=./assets/images/SameHercule.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span ng-if="altervalue.herculesCase == \'CASE5: PROPOSAL DECLINED\'&& vm.isArcaUser"><img src=./assets/images/Declined.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span></span></td><td style=position:relative; ng-style="{\'left\':vm.isDmsProfile ? \'15px\':\'18px\'}" class="small-1 columns" ng-class="{\'disabled\': !altervalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span>{{altervalue.quantity}}</span></td><td class="small-1 columns" style="padding-left: 17px;" ng-if=vm.isDmsProfile ng-class="{\'disabled\': !altervalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span ng-if="altervalue.dmsInformations.quantity || altervalue.dmsInformations.quantity == 0"><i class="fa fa-circle" ng-style="{\'color\':altervalue.stockAvailability ? \'green\' : \'red\'}" style="left: 1px; position: relative;" aria-hidden=true><md-tooltip>{{altervalue.dmsInformations.quantity}}</md-tooltip></i></span><span ng-if="!altervalue.dmsInformations.quantity && altervalue.dmsInformations.quantity != 0">-<md-tooltip>{{"CONNECTED_SERVICES_UNKNOWN_STATUS"|translate}}</md-tooltip></span></td><td class="small-1 columns" style="padding-left: 2px;padding-right: 2px;left: 6px;" ng-style="{\'padding-bottom\': (!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia) ? \'0\' : \'0.1px\'}"><span ng-if="!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia" ng-style="{\'left\': (vm.getPriceToDisplay(altervalue) === 0 || vm.getPriceToDisplay(altervalue) === null || vm.getPriceToDisplay(altervalue) === undefined || vm.getPriceToDisplay(altervalue) === \'-\')  ? \'27px\' : \'0\', \'position\':(vm.getPriceToDisplay(altervalue) === 0 || vm.getPriceToDisplay(altervalue) === null || vm.getPriceToDisplay(altervalue) === undefined || vm.getPriceToDisplay(altervalue) === \'-\')  ? \'relative\' : \'\'}"><span>{{vm.getPriceToDisplay(altervalue)}} </span><span ng-if="altervalue.priceExclTaxes > 0 || altervalue.dmsInformations.priceExclTaxes > 0">{{vm.getCurrencyForItem(altervalue)}}</span><md-tooltip ng-if="((vm.getPriceToDisplay(altervalue) === 0 || vm.getPriceToDisplay(altervalue) === null || vm.getPriceToDisplay(altervalue) === undefined || vm.getPriceToDisplay(altervalue) === \'-\') && vm.isCountrySparc && vm.frCountry != \'FR\')">{{"PRICE_UNAVAILABLE"|translate}}</md-tooltip><md-tooltip ng-if="((vm.getPriceToDisplay(altervalue) === 0 || vm.getPriceToDisplay(altervalue) === null || vm.getPriceToDisplay(altervalue) === undefined || vm.getPriceToDisplay(altervalue) === \'-\') && vm.frCountry === \'FR\')">{{"PRICE_UNAVAILABLE_FR_COUNTRY"|translate}}</md-tooltip></span></td><td style=position:relative; class="small-1 columns"><img src=./assets/images/Eb_plate.svg class=catalogPlate style="margin-left: 20px;font-size: var(--renaultLargeFont); height: 20px;" ng-style="vm.isCatalogPlateAllowedForHorse(altervalue) ? {\'cursor\': \'pointer\'} : {\'opacity\': \'0.5\', \'cursor\': \'not-allowed\', \'pointer-events\': \'none\'}" ng-click="vm.isCatalogPlateAllowedForHorse(altervalue) && vm.gotoCatalogPlate(altervalue, $index, partData, value)"><md-tooltip md-direction=right style="white-space: normal; height: auto !important;padding: 2px 15px 2px 15px;"><div ng-if=vm.isCatalogPlateAllowedForHorse(altervalue)><div ng-repeat="catalogPlate in vm.checkCatalogPlateId(altervalue)">{{catalogPlate}}</div></div><div ng-if=!vm.isCatalogPlateAllowedForHorse(altervalue)>{{\'EASYLINK_VEHICLE_DATA_SHARING_INACTIVE\' | translate}}</div></md-tooltip></td><td style=padding-bottom:1px; class="small-1 columns"></td><td class="small-1 columns" style="float: left;padding-top:5px;left: 1%;" ng-style="{\'margin-left\':vm.isModal ? \'none\' : \'-2%\'}" ng-if=!vm.isHorseUser><span><!--  ng-if=" (!part.isAlterpart && altervalue.isAlterpart) || (part.isAlterpart && altervalue.isAlterpart)" --><md-switch ng-change=vm.alterSwitchEnable(altervalue.switchEnable,itemGroupIndex,mainIndex,$index) ng-model=altervalue.switchEnable style="margin: 0px!important;position: relative; height: 15px !important; right: -36%;" class=eb-switch ng-class="{\'eb-switch-on\':altervalue.switchEnable, \'disabled\': part.toggleDisable,\'eb-switch-off\':!altervalue.switchEnable}" ng-disabled=part.toggleDisable></md-switch><md-tooltip ng-if="part.alternative.length > 0">{{\'ALTERNATE_PARTS\'|translate}}</md-tooltip></span></td></tr></tbody></table></ng-container></td><td class="break small-12 columns" style=padding-bottom:0px; ng-if=!part.showAddPart><ng-container><table style="width: 100%; border: none !important; margin-bottom: 0px;" id=additionalPartData><tbody><tr style="background-color: white; position: relative;" class=alterSpace ng-repeat="addvalue in part.additional track by $index" ng-style="{\'height\':part.additional.length > 1 ? \'22px\': \'40px\', \'bottom\':part.additional.length > 1 ? \'21px\': \'20px\'}"><td style="border-left: 2px dashed gray;height: 17px;right: 12px;cursor: pointer;" ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(addvalue)" class="small-1 columns clickable"><span ng-style="{\'color\': (!addvalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone)? \'#D3D3D3\' : \'#000\'}" style=display:flex; class=white-space>{{addvalue.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(addvalue.reference);$event.stopPropagation();></i><md-tooltip ng-if="part.additional !=null && part.additional.length > 0">{{\'ADDITIONAL_PARTS\' | translate}}</md-tooltip></span></td><td class="columns clickable" style="left:20px;cursor: pointer;" ng-class="{\'small-5\':vm.isDmsProfile, \'small-6\':!vm.isDmsProfile,\'disabled\': !addvalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span ng-style="{\'color\':(!addvalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone)? \'#D3D3D3\' : \'#000\'}"><span ng-click="!(item.bulkAdditionDone || item.bulkQuoteAdditionDone) && vm.goToProductNewPage(part)" style="cursor: pointer;">{{addvalue.designation}}</span>&ensp;<picto-list equivalent-types=addvalue.equivalentTypes></picto-list><a style=color:#333; ng-if="addvalue.replacement || addvalue.dmsInformations.supersedingPart" ng-click="vm.goToProductNewPage(addvalue,\'replacement\')"><span style="top: 4px; position: relative;" class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a></span></td><td style=position:relative; ng-style="{\'left\':vm.isDmsProfile ? \'15px\':\'18px\'}" class="small-1 columns" ng-class="{\'disabled\': !addvalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span>{{addvalue.quantity}}</span></td><td class="small-1 columns" style="padding-left: 17px;" ng-if=vm.isDmsProfile ng-class="{\'disabled\': !addvalue.switchEnable || item.bulkAdditionDone || item.bulkQuoteAdditionDone}"><span ng-if="addvalue.dmsInformations.quantity || addvalue.dmsInformations.quantity == 0"><i class="fa fa-circle" ng-style="{\'color\':addvalue.stockAvailability ? \'green\' : \'red\'}" style="left: 1px; position: relative;" aria-hidden=true><md-tooltip>{{addvalue.dmsInformations.quantity}}</md-tooltip></i></span><span ng-if="!addvalue.dmsInformations.quantity && addvalue.dmsInformations.quantity != 0">-<md-tooltip>{{"CONNECTED_SERVICES_UNKNOWN_STATUS"|translate}}</md-tooltip></span></td><td class="small-1 columns" style="padding-left: 2px;padding-right: 2px;left: 7px;" ng-style="{\'padding-bottom\': (!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia) ? \'0\' : \'0.1px\'}"><span ng-if="!vm.isHorseUser && !vm.isCountryChina && !vm.isCountryIndia" ng-style="{\'left\': (vm.getPriceToDisplay(addvalue) === 0 || vm.getPriceToDisplay(addvalue) === null || vm.getPriceToDisplay(addvalue) === undefined || vm.getPriceToDisplay(addvalue) === \'-\')  ? \'27px\' : \'0\', \'position\':(vm.getPriceToDisplay(addvalue) === 0 || vm.getPriceToDisplay(addvalue) === null || vm.getPriceToDisplay(addvalue) === undefined || vm.getPriceToDisplay(addvalue) === \'-\')  ? \'relative\' : \'\'}"><span>{{vm.getPriceToDisplay(addvalue)}} </span><span ng-if="addvalue.priceExclTaxes > 0 || addvalue.dmsInformations.priceExclTaxes > 0">{{vm.getCurrencyForItem(addvalue)}}</span><md-tooltip ng-if="((vm.getPriceToDisplay(addvalue) === 0 || vm.getPriceToDisplay(addvalue) === null || vm.getPriceToDisplay(addvalue) === undefined || vm.getPriceToDisplay(addvalue) === \'-\') && vm.isCountrySparc && vm.frCountry != \'FR\')">{{"PRICE_UNAVAILABLE"|translate}}</md-tooltip><md-tooltip ng-if="((vm.getPriceToDisplay(addvalue) === 0 || vm.getPriceToDisplay(addvalue) === null || vm.getPriceToDisplay(addvalue) === undefined || vm.getPriceToDisplay(addvalue) === \'-\') && vm.frCountry === \'FR\')">{{"PRICE_UNAVAILABLE_FR_COUNTRY"|translate}}</md-tooltip></span></td><td style=position:relative; class="small-1 columns"><img src=./assets/images/Eb_plate.svg class=catalogPlate style="margin-left: 20px;font-size: var(--renaultLargeFont); height: 20px;" ng-style="vm.isCatalogPlateAllowedForHorse(addvalue) ? {\'cursor\': \'pointer\'} : {\'opacity\': \'0.5\', \'cursor\': \'not-allowed\', \'pointer-events\': \'none\'}" ng-click="vm.isCatalogPlateAllowedForHorse(addvalue) && vm.gotoCatalogPlate(addvalue, $index, partData, value)"><md-tooltip md-direction=right style="white-space: normal; height: auto !important;padding: 2px 15px 2px 15px;"><div ng-if=vm.isCatalogPlateAllowedForHorse(addvalue)><div ng-repeat="catalogPlate in vm.checkCatalogPlateId(addvalue)">{{catalogPlate}}</div></div><div ng-if=!vm.isCatalogPlateAllowedForHorse(addvalue)>{{\'EASYLINK_VEHICLE_DATA_SHARING_INACTIVE\' | translate}}</div></md-tooltip></td><td style=padding-bottom:1px; class="small-1 columns"></td><td class="small-1 columns" style="float: left;padding-top:5px;left: 1%;" ng-style="{\'margin-left\':vm.isModal ? \'none\' : \'-2%\'}" ng-if=!vm.isHorseUser><span><md-switch ng-change=vm.additionalSwitchEnable(itemGroupIndex) ng-model=addvalue.switchEnable style="margin: 0px!important;position: relative; height: 15px !important; right: -36%;" class=eb-switch ng-class="{\'eb-switch-on\':addvalue.switchEnable, \'disabled\':part.toggleDisable,\'eb-switch-off\':!addvalue.switchEnable}" ng-disabled=part.toggleDisable></md-switch><md-tooltip ng-if="part.additional !=null && part.additional.length > 0">{{\'ADDITIONAL_PARTS\' | translate}}</md-tooltip></span></td></tr></tbody></table></ng-container></td></tr></tbody><tbody ng-repeat="val in value" ng-if="key == \'labourTimeItems\'" style="position: relative;" ng-style="{\'bottom\':!vm.isDmsProfile ? \'10px\': \'-25px\'}"><tr ng-repeat="list in val.labourTimes track by $index" class={{list.tmGroup}} ng-class="{\'tmDataItems\':(vm.isDmsProfile && val.labourTimes.length === 1), \'tmListItems\':(vm.isDmsProfile && val.labourTimes.length > 1), \'tmGroupItems\': (!vm.isDmsProfile && list.value.length > 1 ), \'tmGroupedItems\': (!vm.isDmsProfile && list.value.length === 1)}" ng-style="{\'margin-top\':$index === 0 ? \'-11px\':\'-20px\', \'bottom\':(!vm.isDmsProfile && val.labourTimes.length > 1 && $first) ? \'-8px\':\'\'}"><td style="position: relative; padding-top: 0px; font-size: var(--renaultMediumFont);" ng-style="{\'border-left\':(list.infoitem || val.labourTimes.length > 1 || list.value.length > 1) ? \'2px solid #2E2ECA\':\'\'}" class="small-12 columns"><span class=small-1 ng-if=list.infoitem><i class="fa fa-info-circle" style="font-size: 19px; color: #2E2ECA; position: absolute;left: -21px;top: -8px;"></i><md-tooltip md-direction=right style="height: auto !important; max-width: 150px !important; line-height: 15px; margin-left: 0px; white-space: normal;">{{\'IDENTICAL_TMS\' |translate}}</md-tooltip></span><span ng-style="{\'color\': (item.bulkAdditionDone || item.bulkQuoteAdditionDone) ? \'#D3D3D3\' : \'#000\'}">{{list.title}}</span></td><td class="small-12 columns" style="padding: 0px; bottom: 0px; top: -7px;" ng-style="{\'border-left\':(list.infoitem || val.labourTimes.length > 1 || list.value.length > 1) ? \'2px solid #2E2ECA\':\'\', \'margin-bottom\':list.value.length > 1 ? \'23px\':\'\'}"><table ng-repeat="item in list.value track by $index " style="width: 100%; border:none;" ng-style="{\'margin-bottom\': $index > 0 ? \'-10px\':\'0px\', \'margin-top\': $index > 0 ? \'-10px\':\'0px\'}"><tr style="position: relative; bottom: 0px;" class=TM-spacing><td class="small-1 columns" ng-class="{\'disabled\': item.hideTM || item.bulkAdditionDone || item.bulkQuoteAdditionDone || item.toggleDisable}">{{::item.id}}</td><td class="small-1 columns" ng-class="{\'disabled\': item.hideTM || item.bulkAdditionDone || item.bulkQuoteAdditionDone || item.toggleDisable}" ng-if="item.type == \'TM\'" style="left: 0.7%;">{{item.tmType}}</td><td class="small-1 columns" ng-class="{\'disabled\': item.hideTM || item.bulkAdditionDone || item.bulkQuoteAdditionDone || item.toggleDisable}" style="left: 17px;">{{item.duration}}</td><td class="small-7 columns" ng-class="{\'disabled\': item.hideTM || item.bulkAdditionDone || item.bulkQuoteAdditionDone || item.toggleDisable}" style="left: 2%"><div><div ng-hide="item.characteristics.elementPrecision == null || item.characteristics.elementPrecision.length ==0 " ng-if="item.characteristics.elementPrecision != null">{{::item.characteristics.elementPrecision}}</div><div ng-hide="item.characteristics.additionalLabel == null || item.characteristics.additionalLabel.length ==0" ng-if="item.characteristics.additionalLabel != null">{{::item.characteristics.additionalLabel}}</div><div ng-hide="item.characteristics.quantity == null || item.characteristics.quantity.length ==0" ng-if=item.characteristics.quantity>{{\'TM_CHARACTERISTICS_QUANTITY\' | translate}} : {{::item.characteristics.quantity}}</div><div ng-hide="item.characteristics.paintType == null || item.characteristics.paintType.length ==0" ng-if=item.characteristics.paintType>{{\'TM_CHARACTERISTICS_PAINTTYPE\' | translate}} : {{::item.characteristics.paintType}}</div><div ng-hide="item.characteristics.paintClass == null || item.characteristics.paintClass.length ==0" ng-if=item.characteristics.paintClass>{{\'TM_CHARACTERISTICS_PAINTCLASS\' | translate}} : {{::item.characteristics.paintClass}}<click-tooltip-container><div data-html2canvas-ignore class=tooltipContainerPeinture style="left:87px; bottom:17px;"><div class=inline><div class=margin-left-right>{{\'TM_CHARACTERISTICS_PAINTCLASS\'| translate}}</div><div class=align-left>{{\'TM_CHARACTERISTICS_PAINTCLASS_DESCRIPTION\'| translate}}</div></div><div class=inline><div class=left>0</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_0\'| translate}}</div></div><div class=inline><div class=left>1</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_1\'| translate}}</div></div><div class=inline><div class=left>2</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_2\'| translate}}</div></div><div class=inline><div class=left>3</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_3\'| translate}}</div></div><div class=inline><div class=left>4</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_4\'| translate}}</div></div></div></click-tooltip-container></div></div></td><td class=small-1 style="position: relative; top: -10px;" ng-style="{\'left\':vm.isModal ? \'none\' : \'-1.5%\'}" ng-if=!vm.isHorseUser><md-switch ng-change=vm.changeTMtoggle(item) ng-disabled=item.toggleDisable ng-model=item.toggleTM style="margin: 0px !important; left: 11%; position: relative;" class=eb-switch ng-class="{\'eb-switch-on\':item.toggleTM, \'disabled\': item.toggleDisable,\'eb-switch-off\':!item.toggleTM}"></md-switch></td></tr></table></td></tr></tbody><tbody ng-if="key == \'labourTimeItems\' && vm.essayTmLine" style="position: relative;" ng-style="{\'bottom\':!vm.isDmsProfile ? \'10px\': \'-25px\'}"><tr ng-class="{\'tmDataItems\': vm.isDmsProfile, \'tmGroupedItems\': !vm.isDmsProfile}" ng-style="{\'margin-top\':\'-20px\'}"><td style="position: relative; padding-top: 0px; font-size: var(--renaultMediumFont);" class="small-12 columns"><span ng-style="{\'color\': (item.bulkAdditionDone || item.bulkQuoteAdditionDone) ? \'#D3D3D3\' : \'#000\'}">{{vm.essayTmLine.title}}</span></td><td class="small-12 columns" style="padding: 0px; bottom: 0px; top: -7px;" ng-if=!vm.essayTmLine.isManual><table style="width: 100%; border:none;"><tr style="position: relative; bottom: 0px;" class=TM-spacing><td class="small-1 columns" ng-class="{\'disabled\': item.bulkAdditionDone || item.bulkQuoteAdditionDone}">{{vm.essayTmLine.id}}</td><td class="small-1 columns" ng-class="{\'disabled\': item.bulkAdditionDone || item.bulkQuoteAdditionDone}" style="left: 0.7%;">{{vm.essayTmLine.tmType}}</td><td class="small-1 columns" ng-class="{\'disabled\': item.bulkAdditionDone || item.bulkQuoteAdditionDone}" style="left: 17px;">{{vm.essayTmLine.duration}}</td><td class="small-7 columns" ng-class="{\'disabled\': item.bulkAdditionDone || item.bulkQuoteAdditionDone}" style="left: 2%"></td></tr></table></td></tr></tbody></table></div></div></div><div data-html2canvas-ignore ng-if=vm.screenshotButtonVisibility.status class=tmScreenshot><button class=tmScreenshotButton ng-click=vm.captureScreenshot()><i class="fa fa-camera"></i></button></div><div class="small-12 columns" ng-if=item.showBasketDetails style="border-bottom: 1px solid #D3D3D3;margin-bottom: 1%;"></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/batteryCertificate/batteryCertificate.template.html','<md-dialog style="opacity: 2 !important;"><div class=batteryDetailsPopup><div class="closeBatteryDetailsPopInRow fixedPopInHeader"><div class="small-10 batteryPopupHeader">{{\'BATTERY_CERTIFICATE_BLMS\' | translate | uppercase}}</div><div class="small-2 closeButton" ng-click=vm.closePopIn()>X</div></div><div class="infoPadding left5 small-12"><span class=batteryInfo_icon><i class="fa fa-info-circle"></i> </span><span class=infoList>{{\'INFO_BATTERY_CERTIFICATE\' | translate}}</span> <span class=infoList>{{\'INFO_CLIENT_PAID\' | translate}}</span> <span class=infoList>{{\'INFO_CLIENT_DOWNLOADED\' | translate}}</span> <span class=infoList>{{\'INFO_DISPLAY_ISSUE\' | translate}}</span> <span class=infoList>{{\'INFO_NO_DATA_DISPLAYED\' | translate}}</span> <i ng-click=vm.batteryCertifDetails() class="fa fa-print" style="position: relative; bottom: 94px;left: 88%; font-size: 30px;cursor:pointer;" ng-class="{\'blackBatteryCertif\': vm.nissanUserURL, \'renaultBatteryCertif\': !vm.nissanUserURL}"></i></div><div class=grayBorderSeperator></div><div class="top3 left"><div ng-if=vm.batteryCheck><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'EASYLINK_VEHICLE_UID\'|translate}} <span class=textBold style="color: black;display: block;">{{vm.batteryUidData.uid}}</span> </span><span class=grayRightBorder></span> <span class="grid__col-10 infoList" style="position: relative;top: 30px;">{{\'BLMS_POPUP_TEXT1\'|translate}}</span></div><div class="flex textContentWrap sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2">{{\'UID_NAME\'| translate}} </span><span class=grayRightBorder></span> <span class="grid__col-10 infoList" style="position: relative; top: 25px;">{{\'BLMS_POPUP_TEXT2\'|translate}}</span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" style="color: black;">{{vm.batteryUidData.name}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class="marginTop2 paddingTop1 rightAlign paddingRightHeaderText grid__col-2">{{\'SERVICE_ACTIVATION_STATUS\'|translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'BLMS_POPUP_TEXT3\'|translate}}</span></div><div class="marginBottom3 textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" style="color: black"><i class="fa fa-circle" ng-style="{\'color\':{{vm.batteryUidData.status === \'ACTIVATED\'}} ? \'#00BF00\': \'#c80e0e\',\'position\': \'relative\',\'right\': \'6px\'}"></i>{{vm.batteryUidData.status}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div></div><div class=grayBorderContentSeperator></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="paddingTop1 rightAlign paddingRightHeaderText grid__col-2">{{vm.soh}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_DOWNLOADED_CONTENT\' | translate}}</span></div><div class="flex textContentWrap sub_items_content grid--no-gutter"><span class="rightAlign paddingRightHeaderText textBold grid__col-2">{{vm.batteryVin.soheRef | rlinkformat}}{{vm.batteryVin.soheRef !== 0 ? \'%\' : \'\'}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_VALUE_DISPLAYED_CONTENT\' | translate}}</span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class="rightAlign paddingRightHeaderText grid__col-2"></span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_ENERGY_STORAGE_CONTENT\' | translate}}</span></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'SOH_LAST_UPDATE_DATE\' | translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_BATTERY_CERTIFICATE_CONTENT\' | translate}}</span></div><div class="marginBottom3 textContentWrap rightAlign flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText grid__col-2 textBold">{{vm.batteryVin.soheRefLud | rlinkformat}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class=grayBorderContentSeperator></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'BLMS_VEHICLE_MILEAGE\' | translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_VEHICLE_MILEAGE_CONTENT\' | translate}}</span></div><div class="rightAlign textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText grid__col-2 textBold">{{vm.batteryVin.evDstTot | rlinkformat}}&nbsp;{{vm.batteryVin.evDstTot ? \'Km\' : \'\'}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="paddingTop1 rightAlign paddingRightHeaderText grid__col-2">{{\'BLMS_VEHICLE_MILEAGE_DATE\' | translate}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="marginBottom3 textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold">{{vm.batteryVin.evDstTotLud | rlinkformat}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class=grayBorderContentSeperator></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'BLMS_BATTERY_MILEAGE\' | translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'SOH_VIN_BIN_CONTENT\' | translate}}</span></div><div class="flex textContentWrap sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold">{{vm.batteryVin.packMileage | rlinkformat}}&nbsp;{{vm.batteryVin.packMileage ? \'Km\' : \'\'}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class=grid__col-2></span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class="marginTop2 paddingTop1 rightAlign paddingRightHeaderText grid__col-2">{{\'BLMS_BATTERY_MILEAGE_DATE\' | translate}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="marginBottom3 textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold">{{vm.batteryVin.packMileageLud | rlinkformat}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class=grayBorderContentSeperator></div><div class="marginTop3 textContentWrap flex sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'BLMS_BIN_VIN_DATE\' | translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'VEHICLE_PRODUCTION_CONTENT\' | translate}}</span></div><div class="marginBottom3 textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold">{{vm.batteryVin.binVinDateLnk | rlinkformat}}</span> <span class=grayRightBorder></span> <span class=grid__col-10></span></div><div class="flex textContentWrap sub_items_header grid--no-gutter"><span class="rightAlign paddingTop1 paddingRightHeaderText grid__col-2">{{\'BLMS_PURCHASE_MODE\' | translate}}</span> <span class=grayRightBorder></span> <span class="grid__col-10 infoList">{{\'PURCHASE_MODE_LEASE_CONTENT\' | translate}}</span></div><div class="marginBottom3 textContentWrap flex sub_items_content grid--no-gutter"><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" ng-if="(vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'B\' || vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'D\')">{{\'BLMS_PURCHASE_BUY\' | translate}} </span><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" ng-if="vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'L\'">{{\'BLMS_PURCHASE_LEASE\' | translate}} </span><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" ng-if="vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'P\'">{{\'BLMS_PURCHASE_REPLACEMENT\' | translate}} </span><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" ng-if="vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'C\'">{{vm.centralPurchase}} </span><span class="paddingRightHeaderText rightAlign grid__col-2 textBold" ng-if="vm.batteryVin.purchaseMode && vm.batteryVin.purchaseMode === \'I\'">{{\'BLMS_PURCHASE_LOAN\' | translate}} </span><span class=grayRightBorder></span> <span class=grid__col-10></span></div></div></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/cnrUserGuide/cnrUserGuide.html','<div class=block-accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'CNR_USER_GUIDE\' | translate}}</span></div><div ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></div></div></accordion-heading><div class=cnr-user-guide-container><!-- Spanish users: Multiple guides --><div ng-if="vm.user.language.toLowerCase() === \'es\'" class=guide-list><div class=guide-item ng-click=vm.goToCnrUserGuideLatam()><i class="fa fa-file-pdf-o guide-icon" aria-hidden=true></i><div class=guide-text><span>{{vm.formatFileName(vm.rLinkConstant.cnrEsUserGuide)}}</span></div></div><div class=guide-item ng-click=vm.goToCnrUserGuideGeneral()><i class="fa fa-file-pdf-o guide-icon" aria-hidden=true></i><div class=guide-text><span>{{vm.formatFileName(vm.rLinkConstant.cnrEsUserGuide1)}}</span></div></div></div><!-- Non-Spanish users: Single guide --><div ng-if="vm.user.language.toLowerCase() !== \'es\'" class=guide-list><div class=guide-item ng-click=vm.goToCnrUserGuidePage()><i class="fa fa-file-pdf-o guide-icon" aria-hidden=true></i><div class=guide-text><span>{{\'CNR_USER_GUIDE\' | translate}}</span></div></div></div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/contractsAndServices.template.html','<!-- RLINK2 --><div class="block-accordion contracts" ng-show=!vm.isEasyLink style="margin-top:0; position: relative;"><span class=icon-fullscreen ng-click=vm.openExtendedView();></span><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.contractsAccordion.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;" is-disabled=true><span>{{\'CONNECTED_SERVICES_MENU_CONTRACTS\' | translate}}</span></div></accordion-heading><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'CONNECTED_SERVICES_SUBSCRIPTIONS_IN_PROGRESS\' | translate}}</span></div><section><header class=grid--no-gutter><div class="label grid__col-2" ng-click="vm.sortBy(\'aseContractNumber\', \'subscriptions\');">{{\'CONNECTED_SERVICES_CONTRACT_NUMBER\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'aseContractNumber\' && contracts === \'subscriptions\'"></span></div><div class="label grid__col-3" ng-click="vm.sortBy(\'atcproductName\', \'subscriptions\');">{{\'CONNECTED_SERVICES_PRODUCT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'atcproductName\' && contracts === \'subscriptions\'"></span></div><div class="label grid__col-1" ng-click="vm.sortBy(\'subscriptionStatus\', \'subscriptions\');">{{\'CONNECTED_SERVICES_STATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStatus\' && contracts === \'subscriptions\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'subscriptionStartDate\', \'subscriptions\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_START_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStartDate\' && contracts === \'subscriptions\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'subscriptionEndDate\', \'subscriptions\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionEndDate\' && contracts === \'subscriptions\'"></span></div><div class="label grid__col-1" ng-click="vm.sortBy(\'countryStoreIsoCode\', \'subscriptions\');">{{\'RLINKCAR_CONT_SERV_COUNTRY\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'countryStoreIsoCode\' && contracts === \'subscriptions\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subscriptions"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-2>{{item.aseContractNumber | rlinkformat}}</span> <span class=grid__col-3>{{item.atcproductName | rlinkformat}}</span> <span class=grid__col-1>{{item.subscriptionStatus | rlinkformat:\'status\'}}</span> <span class="grid__col-2 startDate">{{item.subscriptionStartDate | rlinkformat:\'full-date\'}}</span> <span class="grid__col-2 endDate">{{item.subscriptionEndDate | rlinkformat:\'full-date\'}}</span><div class="grid__col-2 space-between flex"><div>{{item.countryStoreIsoCode | rlinkformat}}</div><div class="flex flex-end"><div class=rlink-tip ng-if=vm.isAuthorized><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_CONTRACT_CAN_RETRY\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled=!item.canRetry ng-click=vm.synchronizeContract(item);$event.stopPropagation(); style="padding: .25rem;"><span class="icon refresh"></span></button></div><div class=rlink-tip ng-if=vm.isAuthorized><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_RETRY_HISTORY\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled="item.retryHistory === null || item.retryHistory.length === 0" ng-click=vm.openHistoryOfRetryModal(item);$event.stopPropagation(); style="padding: .25rem;"><span class="icon history"></span></button></div><i ng-class="\'grid__col-1 arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.services != \'\'"></i> <span class="grid__col-1 arrow" ng-if="item.services == \'\'"></span></div></div></div></accordion-heading><div ng-repeat="srv in item.services" class="section_header sub_items grid--no-gutter"><span class=grid__col-2>&nbsp;</span> <span class=grid__col-3>{{srv.serviceId | rlinkformat}}</span> <span class=grid__col-1>{{srv.status | rlinkformat:\'status\'}}</span> <span class=grid__col-2>&nbsp;</span> <span class=grid__col-2>&nbsp;</span> <span class=grid__col-1>&nbsp;</span> <span class="grid__col-1 label arrow"></span></div></accordion-group><div ng-if="vm.subscriptions.length === 0" class=block_text>{{\'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_IN_PROGRESS\' | translate}}</div></accordion></div></div><accordion class="collapse terminated" close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas space-between flex" ng-click="$scope.isOpen = !$scope.isOpen"><span>{{\'CONNECTED_SERVICES_SUBSCRIPTIONS_TERMINATED\' | translate}}</span> <i ng-class="\' icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><section><header class=grid--no-gutter><div class="label grid__col-2" ng-click="vm.sortBy(\'aseContractNumber\', \'subTerminated\');">{{\'CONNECTED_SERVICES_CONTRACT_NUMBER\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'aseContractNumber\' && contracts === \'subTerminated\'"></span></div><div class="label grid__col-3" ng-click="vm.sortBy(\'atcproductName\', \'subTerminated\');">{{\'CONNECTED_SERVICES_PRODUCT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'atcproductName\' && contracts === \'subTerminated\'"></span></div><div class="label grid__col-1" ng-click="vm.sortBy(\'subscriptionStatus\', \'subTerminated\');">{{\'CONNECTED_SERVICES_STATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStatus\' && contracts === \'subTerminated\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'subscriptionStartDate\', \'subTerminated\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_START_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStartDate\' && contracts === \'subTerminated\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'subscriptionEndDate\', \'subTerminated\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionEndDate\' && contracts === \'subTerminated\'"></span></div><div class="label grid__col-1" ng-click="vm.sortBy(\'countryStoreIsoCode\', \'subTerminated\');">{{\'RLINKCAR_CONT_SERV_COUNTRY\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'countryStoreIsoCode\' && contracts === \'subTerminated\'"></span></div><div class="grid__col-1 label arrow"></div></header></section><div class="block-accordion list-contracts"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subTerminated"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-2>{{item.aseContractNumber | rlinkformat}}</span> <span class=grid__col-3>{{item.atcproductName | rlinkformat}}</span> <span class=grid__col-1>{{item.subscriptionStatus | rlinkformat:\'status\'}}</span> <span class="grid__col-2 startDate">{{item.subscriptionStartDate | rlinkformat:\'full-date\'}}</span> <span class="grid__col-2 endDate">{{item.subscriptionEndDate | rlinkformat:\'full-date\'}}</span><div class="grid__col-2 space-between flex"><div>{{item.countryStoreIsoCode | rlinkformat}}</div><div class="flex flex-end"><div class=rlink-tip><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_CONTRACT_CAN_RETRY\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled=!item.canRetry ng-click=vm.synchronizeContract(item);$event.stopPropagation(); style="padding: .25rem;"><span class="icon refresh"></span></button></div><div class=rlink-tip><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_RETRY_HISTORY\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled="item.retryHistory === null || item.retryHistory.length === 0" ng-click=vm.openHistoryOfRetryModal(item);$event.stopPropagation(); style="padding: .25rem;"><span class="icon history"></span></button></div><i ng-class="\'grid__col-1 arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.services != \'\'"></i> <span class="grid__col-1 arrow" ng-if="item.services == \'\'"></span></div></div></div></accordion-heading><div ng-repeat="srv in item.services" class="section_header sub_items grid--no-gutter"><span class=grid__col-2>&nbsp;</span> <span class=grid__col-3>{{srv.serviceId | rlinkformat}}</span> <span class=grid__col-1>{{srv.status | rlinkformat:\'status\'}}</span> <span class=grid__col-2>&nbsp;</span> <span class=grid__col-2>&nbsp;</span> <span class=grid__col-1>&nbsp;</span> <span class="grid__col-1 label arrow"></span></div></accordion-group></accordion></div></accordion-group><div ng-if="vm.subTerminated.length === 0 " class=block_text>{{\'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_TERMINATED\' | translate}}</div></accordion></accordion-group></accordion></div><!-- EASYLINK --><div class=contSyncBox ng-show=" vm.isEasyLink && !vm.isIndependentUser"><div><span ng-click="vm.contractsServiceSync(\'isContract\', false, vm.nissanUserURL)"><button class="cs-btn syncButton" ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}"><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'SERVICE_SYNCHRONIZATION\' | translate}}</div></button> </span><span ng-click="vm.contractsServiceSyncHistory(\'isContract\', true, vm.nissanUserURL)"><button class="cs-btn buttonWithIcon" ng-class="{\'histButtonEn\': vm.language === \'en\',\n                \'histButtonFr\': vm.language !== \'en\',\'nissanBtnWithIcon\': vm.nissanUserURL}"><div style="position: relative;right: 5px;" class=iconDivSync><i style="font-size: var(--renaultMediumFont); left: 7px;position: relative;" class="fa fa-history"></i></div><div style="position: relative;right: 5px;" class=btnTextSync>{{\'SYNCHRONIZATION_HISTORY\' | translate}}</div></button> </span><span ng-class="vm.language === \'en\' ? \'syncTextEn\' : \'syncTextFr\'" style="width: 43%; display: inline-flex;">{{\'SYNCHRONIZATION_TEXT\' | translate}}</span><div style="left: 1.5%; font-size: var(--renaultMediumFont); margin-top: 7px; position: relative;"><i class="fa fa-info-circle" style="padding-right: 0.5rem;cursor:pointer;" ng-click=vm.launchSynchronizeModal(true)></i> <span>{{\'LAUNCH_NOTE_SYNCHRONIZATION\' | translate}}</span></div></div></div><div class="block-accordion contracts" ng-show=vm.isEasyLink style="bottom: 10px; position: relative;"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.contractsAccordion.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="isOpen = !isOpen;" is-disabled=true><span>{{\'CONNECTED_SERVICES_MENU_CONTRACTS\' | translate}}</span> <i ng-class="\' icon-arrow_\'+(isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=tab-container><div class=tab-header><div ng-class="{\'nissanTab\': vm.nissanUserURL, \'renaultTab\': !vm.nissanUserURL,\'active\': vm.isSelected(\'onGoing\')}" ng-click="vm.selectTab(\'onGoing\')">{{\'ON_GOING\' | translate | uppercase}}</div><div ng-class="{\'nissanTab\': vm.nissanUserURL, \'renaultTab\': !vm.nissanUserURL,\'active\': vm.isSelected(\'confirmed\')}" ng-click="vm.selectTab(\'confirmed\')">{{\'ACTIVATION_INPROGRESS\' | translate | uppercase}}</div><div ng-class="{\'nissanTab\': vm.nissanUserURL, \'renaultTab\': !vm.nissanUserURL,\'active\': vm.isSelected(\'terminated\')}" ng-click="vm.selectTab(\'terminated\')">{{\'CONNECTED_SERVICES_TERMINATED_STATUS\' | translate | uppercase}}</div><div ng-class="{\'nissanTab\': vm.nissanUserURL, \'renaultTab\': !vm.nissanUserURL,\'active\': vm.isSelected(\'cancelled\')}" ng-click="vm.selectTab(\'cancelled\')">{{\'EASYLINK_VEHICLE_CANCELLED\' | translate | uppercase}}</div></div><div ng-hide="(vm.isSelected(\'terminated\') || vm.isSelected(\'cancelled\') || vm.isSelected(\'confirmed\'))" class=tab-content><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsOnGoing.html\'"></div></div><div ng-if="vm.isSelected(\'terminated\')" class=tab-content><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsTerminated.html\'"></div></div><div ng-if="vm.isSelected(\'cancelled\')" class=tab-content><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsCancelled.html\'"></div></div><div ng-if="vm.isSelected(\'confirmed\')" class=tab-content><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsConfirmed.html\'"></div></div></div></accordion-group></accordion></div><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/commercialServices.html\'" style="margin-top: 1rem;"></div><div ng-if=!vm.vehicleInformationDisplay class=wrapper><button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.openSynchronizationHistoryModal()><div class=iconDiv><i class="fa fa-chevron-right history"></i></div><div class=btnText>{{\'EASYLINK_VEHICLE_SYNCHRONIZATION_HISTORY\' | translate}}</div></button></div><div ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/technicalServices.html\'" style="margin-top: 1rem;"></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/historyOfRetryModal.html','<div class=app-modal style="padding: 10px; width:950px;"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><section ng-if="retryHistory.length > 0"><header class=grid--no-gutter><div class="label grid__col-6" ng-click="sortBy(\'atcContractNumber\', \'historyOfRetry\');">{{\'CONNECTED_SERVICES_CONTRACT_NUMBER\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'atcContractNumber\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'dateTime\', \'historyOfRetry\');">{{\'CONNECTED_SERVICES_DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'dateTime\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'user\', \'historyOfRetry\');">{{\'IPN\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'user\'"></span></div></header></section><ul class=list-contracts ng-if="retryHistory.length > 0"><li ng-repeat="item in retryHistory" class=grid--no-gutter><span class=grid__col-6>{{item.atcContractNumber | rlinkformat}}</span> <span class=grid__col-3>{{item.dateTime | rlinkformat:\'date\'}}</span> <span class=grid__col-3>{{item.user | rlinkformat}}</span></li></ul><div class=block_text ng-if="retryHistory.length === 0">{{\'NO_DATA\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/subscriptionExtendedView.html','<div class=app-modal style="padding: 10px; width:1200px;"><span class=close-modal ng-click=close() style="left: 108%;"><i class="icon-icons_close close-icon"></i></span><section ng-if="allSubscriptions.length > 0" style="margin:2% 0;"><header class=grid--no-gutter><div class="label grid__col-1" ng-click="sortBy(\'aseContractNumber\', \'allSubscriptions\');">{{\'CONNECTED_SERVICES_CONTRACT_NUMBER\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'aseContractNumber\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'atcproductName\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_PRODUCT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'atcproductName\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'productType\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_PRODUCT_TYPE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'productType\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'subscriptionStatus\', \'allSubscription\');">{{\'CONNECTED_SERVICES_STATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStatus\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'salesChannel\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_PURCHASE_CHANNEL\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'salesChannel\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'countryStoreIsoCode\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_COUNTRY\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'countryStoreIsoCode\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'subscriptionStartDate\', \'allSubscriptions\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_START_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionStartDate\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'subscriptionEndDate\', \'allSubscriptions\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionEndDate\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'packageName\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_PACKAGE_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'packageName\'"></span></div><div class="label grid__col-1" ng-click="sortBy(\'appVersion\', \'allSubscription\');">{{\'RLINKCAR_VERSION\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'appVersion\'"></span></div></header></section><ul style="font-size: small;" class=list-contracts ng-if="allSubscriptions.length > 0"><li style="margin-left: 10px;" ng-repeat="item in allSubscriptions" class=grid--no-gutter><span class=grid__col-1>{{item.aseContractNumber | rlinkformat}}</span> <span class=grid__col-3 style="position: relative; left: 5%; padding-right: 5% !important; white-space: pre-line;">{{item.atcproductName | rlinkformat}}</span> <span class=grid__col-1>{{item.productType | rlinkformat}}</span> <span class=grid__col-1>{{item.subscriptionStatus | rlinkformat:\'status\'}}</span> <span style="position: relative;left: 2%;" class=grid__col-1>{{item.salesChannel | rlinkformat}}</span> <span style="position: relative;left: 3%;" class=grid__col-1>{{item.countryStoreIsoCode | rlinkformat}}</span> <span style="position: relative;left: 3%;" class=grid__col-1>{{item.subscriptionStartDate | rlinkformat:\'date\'}}</span> <span style="position: relative;left: 4%;" class=grid__col-1>{{item.subscriptionEndDate | rlinkformat:\'date\'}}</span> <span style="position: relative;left: 6%;" class=grid__col-2>{{item.packageName | rlinkformat}}</span> <span style="position: relative;left: 5%;" class=grid__col-1>{{item.appVersion | rlinkformat}}</span></li></ul><div class=block_text ng-if="allSubscriptions.length === 0" style=padding:10px;>{{\'NO_DATA\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/connectedServicesOffers.template.html','<div id=connect-service-offer><div style="bottom: 50px; position: relative;width:110%"><button ng-click="vm.switchOffers(\'current\')" ng-class="{\'activeOfferBtn\':vm.currentOffer, \'inActiveOfferBtn\':!vm.currentOffer}" class=offers_button><i class="fa fa-check"></i>&nbsp;{{"CURRENT_OFFERS"|translate}}</button> <button style=top:5px; ng-click="vm.switchOffers(\'eligible\')" ng-class="{\'activeOfferBtn\':vm.eligibleOffer, \'inActiveOfferBtn\':!vm.eligibleOffer}" class="offers_button image-button"><i ng-class="{\'activeOfferBtn activeIcon \':vm.eligibleOffer, \'inActiveIcon\' :!vm.eligibleOffer}" class=eligible-offer-icon-position height=23 width=23 id=connect-service-offer-icon></i> &nbsp;{{"ELIGIBLE_OFFERS"|translate}}</button></div><div ng-if=vm.currentOffer style="bottom: 50px; position: relative;width:97%"><!-- Print Special Terms and Conditions is CCS-only functionality, hidden for R-Link1/R-Link2 vehicles --><div ng-if="vm.enableSubscribeButton && !vm.isRLinkArchitecture"><button ng-click="vm.openRestartingServices(vm.carContextRequest.vin, vm.user, vm.dmsResponse,true)" style="background-color: var(--renaultPrimaryColor); width:23%; color:#fff" class=offers_button ng-disabled="vm.disableRestartOffers || !vm.cnrData"><i class="fa fa-refresh" style="right: 9%; position: relative;"></i><span style="font-size: var(--renaultSmallFont);font-family: var(--renaultFontRegular)">{{"RESTART_THE_SERVICES"|translate}}</span><md-tooltip>{{ \'RESTART_SERVICE_OFFERS\' | translate}}</md-tooltip></button><!-- <button ng-click="vm.openRestartingServices(vm.carContextRequest.vin, vm.user, vm.dmsResponse,false)"\n            style="background-color: #978B7F; width:20%; color:black" class="offers_button"\n            ng-disabled="vm.disableRestartOffers"><i class="fa fa-print" style="right: 9%; position: relative;"></i><span\n                style="font-size: 13px;">{{\'PRINT_SERVICES\' | translate}}</span>\n            <md-tooltip>{{\'PRINT_SERVICES_VEGAS\' | translate}}</md-tooltip>\n        </button> --></div><!-- On-Demand (FOD) software features in progress --><div class=fod-section><div class=fod-section-header ng-if=vm.isFodEnable ng-click="vm.softwareOnDemandCollapsed = !vm.softwareOnDemandCollapsed"><i class=connected-car-icon></i> <span class=fod-section-title>{{\'SOFTWARE_FEATURES_ONDEMAND\' | translate}}</span> <i class=fa ng-class="vm.softwareOnDemandCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'"></i></div><div ng-if=!vm.softwareOnDemandCollapsed><table class="offerTable current-offers-table"><thead><tr><th colspan=1></th><th colspan=3>{{"OFFER_COUNTRY"|translate}}</th><th colspan=2>{{"GENERIC_OFFER"|translate}}</th><th colspan=1>{{"COMMON_STATUS"|translate}}</th><th colspan=1>{{"SUBSCRIPTION_DATE"|translate}}</th><th colspan=1>{{"START_DATE"|translate}}</th><th colspan=1>{{"CONNECTED_SERVICES_END_DATE"|translate}}</th></tr></thead><tbody><tr ng-class="{\'activeOfferBtn\':expanded}" ng-repeat-start="offer in vm.currentOffersList track by $index"><td colspan=1 ng-click="vm.plusIconEnabled(offer, $index);expanded = !expanded" expand><b><span class=expandHover ng-bind="expanded ? \'-\' : \'+\'"></span></b></td><td colspan=3 class=contextual-offer-wrap><span ng-if="(vm.newOfferList | filter:{subscriptionId: offer.subscriptionId}).length" class=contextual-offer-wrap><span ng-repeat="item in (vm.newOfferList | filter:{subscriptionId: offer.subscriptionId}) track by $index"><span ng-if=item.name>{{item.name}}<span ng-if=!$last>, </span></span></span></span><span ng-if="!(vm.newOfferList | filter:{subscriptionId: offer.subscriptionId}).length">---</span></td><td colspan=2><span ng-if=offer.name>{{offer.name}}</span><span ng-if=!offer.name>---</span></td><td colspan=1><span ng-if="offer.status !== \'CONFIRMED\'">{{offer.status}}</span> <span ng-if="offer.status === \'CONFIRMED\'">{{"CONNECTED_SERVICES_ACTIVATION_IN_PROGRESS_STATUS" | translate}}</span> <span ng-if=!offer.status>---</span></td><td colspan=1><span ng-if=offer.subscriptionDateTime>{{offer.subscriptionDateTime | rlinkformat:\'date\'}} </span><span ng-if=!offer.subscriptionDateTime>---</span></td><td colspan=1><span ng-if=offer.startDateTime>{{offer.startDateTime | rlinkformat:\'date\'}}</span> <span ng-if=!offer.startDateTime>---</span></td><td colspan=1><span ng-if=offer.isVehicleLifetime>{{\'VEHICLE_LIFETIME_WITHOUT_ASTERISK\' | translate}}</span> <span ng-if="!offer.isVehicleLifetime && !offer.hideEndDate && offer.endDateTime">{{offer.endDateTime | rlinkformat:\'date\'}}</span> <span ng-if="!offer.isVehicleLifetime && (offer.hideEndDate || !offer.endDateTime)">---</span></td></tr><tr ng-repeat-end ng-show=expanded><td colspan=10><div style="padding-top: 5px;font-size: var(--renaultLargeFont);font-family: var(--renaultFontBold);"><i class="fa fa-info-circle" style="font-size: var(--renaultExtraLargeFont);"></i> <span style="font-size: 23px;font-family: var(--renaultFontBold);padding-left: 3px;padding-right: 5px;color:var(--renaultPrimaryColor)">|</span> {{\'OFFER_DETAILS\' | translate}}</div><div style="padding: 15px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'SUBSCRIPTION_ID\' | translate}}</span> <span class="small-10 columns" ng-if=offer.subscriptionId>{{offer.subscriptionId}}</span> <span class="small-10 columns" ng-if=!offer.subscriptionId>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'COMMON_STATUS\' | translate}}</span> <span class="small-10 columns" ng-if=offer.status>{{offer.status}}</span> <span class="small-10 columns" ng-if=!offer.status>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'ACTIS_VEHICLE_VIN\' | translate}}</span> <span class="small-10 columns" ng-if=offer.vin>{{offer.vin}}</span> <span class="small-10 columns" ng-if=!offer.vin>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'PERSON_ID\' | translate}}</span> <span class="small-10 columns" ng-if=offer.personID>{{offer.personID}}</span> <span class="small-10 columns" ng-if=!offer.personID>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'GENERIQUE_OFFER\' | translate}}</span> <span class="small-10 columns" ng-if=offer.genericOffer.id>{{offer.genericOffer.id}}</span> <span class="small-10 columns" ng-if=!offer.genericOffer.id>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'RLINKCAR_VERSION\' | translate}}</span> <span class="small-10 columns" ng-if=offer.genericOffer.version>{{offer.genericOffer.version}}</span> <span class="small-10 columns" ng-if=!offer.genericOffer.version>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span> <span class="small-10 columns" ng-if=offer.startDateTime>{{offer.startDateTime | rlinkformat:\'date\'}}</span> <span class="small-10 columns" ng-if=!offer.startDateTime>---</span></div><div style="padding: 5px 10px 5px 77px; display: flex;"><span style="color: #ccc;font-family: var(--renaultFontRegular);" class="small-2 columns">{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class="small-10 columns" ng-if=offer.isVehicleLifetime>{{\'VEHICLE_LIFETIME_WITHOUT_ASTERISK\' | translate}}</span> <span class="small-10 columns" ng-if="!offer.isVehicleLifetime && !offer.hideEndDate && offer.endDateTime">{{offer.endDateTime | rlinkformat:\'date\'}}</span> <span class="small-10 columns" ng-if="!offer.isVehicleLifetime && (offer.hideEndDate || !offer.endDateTime)">---</span></div><div style="padding-top: 30px;font-size: var(--renaultLargeFont);font-family: var(--renaultFontRegular);"><i class="fa fa-clock-o" style="font-size: var(--renaultExtraLargeFont);"></i> <span style="font-size: 23px;padding-left: 3px;padding-right: 5px;color:var(--renaultPrimaryColor)">|</span> {{\'EASYLINK_VEHICLE_HISTORY\' | translate}}</div><table class=historyTable><thead><tr colspan=12><th colspan=2>{{"OFFER_DATA"|translate}}</th><th colspan=1>{{"VEHICLE_DELIVERY_COUNTRY"|translate}}</th><th colspan=1>{{"OFFER_DURATION"|translate}}</th><th colspan=1>{{"FAV_MODAL_TM_PRICE"|translate}}</th><th colspan=2>{{"RENEWAL_DATE"|translate}}</th><th colspan=3>{{"PERSON_ID"|translate}}</th><th colspan=2><div class=dealerIdWithTooltip><div>{{"SUBSCRIBER_DEALER_ID"|translate}}</div><div><i class="fa fa-info-circle" style="font-size: var(--renaultExtraLargeFont);"><md-tooltip>{{"SUBSCRIBER_DEALER_ID_TOOLTIP"|translate}}</md-tooltip></i></div></div></th></tr></thead><tbody><tr ng-repeat="history in offer.subscriptionDetails"><td colspan=2><span ng-if=history.id>{{history.id}}</span> <span ng-if=!history.id>---</span></td><td colspan=1><span ng-if=history.country>{{history.country}}</span> <span ng-if=!history.country>---</span></td><td colspan=1><span ng-if=history.duration>{{history.duration}}</span> <span ng-if=!history.duration>---</span></td><td colspan=1><span ng-if=history.price>{{history.price}}</span>&nbsp; <span ng-if=history.currency>{{history.currency}}</span> <span ng-if=!history.price>---</span> <span ng-if=!history.currency>---</span></td><td colspan=2><span ng-if=history.eventDateTime>{{history.eventDateTime | rlinkformat:\'date\'}}</span> <span ng-if=!history.eventDateTime>---</span></td><td colspan=3><span ng-if=offer.subscriber.id>{{offer.subscriber.id}}</span> <span ng-if="offer.subscriber.id && offer.subscriber.origin">&nbsp; - &nbsp;</span> <span ng-if=offer.subscriber.origin>{{offer.subscriber.origin}}</span> <span ng-if=!offer.subscriber.id>---</span> <span ng-if=!offer.subscriber.origin>---</span></td><td colspan=2><span ng-if=history.dealerCode>{{history.dealerCode}}</span> <span ng-if=!history.dealerCode>---</span></td></tr></tbody></table></td></tr></tbody></table><div ng-if="!(vm.currentOffersList && vm.currentOffersList.length > 0)" style="text-align: center;">{{\'NO_DATA_FOUND\' | translate}}</div></div></div><!-- On-Demand (FOD) hardware features installed --><div class=fod-section ng-if=vm.isFodEnable><div class=fod-section-header ng-click="vm.hardwareOnDemandCollapsed = !vm.hardwareOnDemandCollapsed"><i class=connected-car-icon></i> <span class=fod-section-title>{{\'HARDWARE_FEATURES_ONDEMAND\' | translate}}</span> <i class=fa ng-class="vm.hardwareOnDemandCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'"></i></div><div ng-if=!vm.hardwareOnDemandCollapsed><table class="offerTable current-offers-table"><thead><tr><th colspan=3>{{\'OFFER_COUNTRY\' | translate}}</th><th colspan=2>{{\'GENERIC_OFFER\' | translate}}</th><th colspan=1>{{\'ALERTS_COUNTRY\' | translate}}</th><th colspan=1>{{\'COMMON_STATUS\' | translate}}</th><th colspan=2>{{\'SUBSCRIPTION_DATE\' | translate}}</th><th colspan=2>{{\'INSTALLATION_DATE\' | translate}}</th></tr></thead><tbody><tr ng-repeat="fod in vm.hardwareFeaturesOnDemandList track by $index"><td colspan=3><span ng-if="fod.offerCountry && fod.offerCountry !== \'-\'">{{fod.offerCountry}}</span><span ng-if="!fod.offerCountry || fod.offerCountry === \'-\'">---</span></td><td colspan=2><span ng-if="fod.genericOffer && fod.genericOffer !== \'-\'">{{fod.genericOffer}}</span><span ng-if="!fod.genericOffer || fod.genericOffer === \'-\'">---</span></td><td colspan=1><span ng-if="fod.country && fod.country !== \'-\'">{{fod.country}}</span><span ng-if="!fod.country || fod.country === \'-\'">---</span></td><td colspan=1><span ng-if="fod.status && fod.status !== \'-\'">{{fod.status}}</span><span ng-if="!fod.status || fod.status === \'-\'">---</span></td><td colspan=2><span ng-if="fod.subscriptionDate && fod.subscriptionDate !== \'-\'">{{fod.subscriptionDate | rlinkformat:\'date\'}}</span><span ng-if="!fod.subscriptionDate || fod.subscriptionDate === \'-\'">---</span></td><td colspan=2><span ng-if="fod.installationDate && fod.installationDate !== \'-\'">{{fod.installationDate | rlinkformat:\'date\'}}</span><span ng-if="!fod.installationDate || fod.installationDate === \'-\'">---</span></td></tr></tbody></table><div ng-if="!(vm.hardwareFeaturesOnDemandList && vm.hardwareFeaturesOnDemandList.length > 0)" class=textCenter>{{\'NO_DATA_FOUND\' | translate}}</div></div></div></div><div ng-if=vm.eligibleOffer style="bottom: 50px; position: relative;width:97%"><div ng-if=vm.isRLinkNoEligibleOffers class=textCenter style="padding: 20px;">{{\'ELIGIBLE_OFFERS_RLINK_MESSAGE\' | translate}}</div><div ng-if=!vm.isRLinkNoEligibleOffers><!-- Eligible On-Demand (FOD) software features --><div class=fod-section><div ng-if=vm.isFodEnable class=fod-section-header ng-click="vm.softwareEligibleCollapsed = !vm.softwareEligibleCollapsed"><i class=connected-car-icon></i> <span class=fod-section-title>{{\'SOFTWARE_FEATURES_ELIGIBLE\' | translate}}</span> <i class=fa ng-class="vm.softwareEligibleCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'"></i></div><div ng-if=!vm.softwareEligibleCollapsed><div class="small-12 columns" ng-repeat="offersData in vm.contextualOffersData"><div class=connectedIconActive><img src=./assets/images/connectedVehicleWhite.png height=23 width=23 style="margin-bottom: -4px;" id=connect-service-offer-icon> <span style="font-size: var(--renaultMediumFont); font-family: var(--renaultFontBold); padding-left: 3px;padding-right: 5px;color:var(--renaultPrimaryColor)">|</span> {{offersData.name}}</div><table class=offerTable><thead><tr colspan=12><th class="small-3 columns">{{"OFFER_DATA"|translate}}</th><th class="small-2 columns">{{"CONTEXTUAL_OFFER"|translate}}</th><th class="small-1 columns">{{"RLINKCAR_VERSION"|translate}}</th><th class="small-1 columns">{{"OFFER_DURATION"|translate}}</th><th class="small-1 columns">{{"ALERTS_COUNTRY"|translate}}</th><th class="small-1 columns">{{"FAV_MODAL_TM_PRICE"|translate}}</th><th class="small-3 columns"></th></tr></thead><tbody><tr ng-repeat=" dataArray in offersData.filteredContextual"><td class="small-3 columns"><span ng-if=dataArray.name>{{dataArray.name}}</span> <span ng-if=!dataArray.name>---</span></td><td class="small-2 columns"><span ng-if=dataArray.contextualOfferId>{{dataArray.contextualOfferId}}</span> <span ng-if=!dataArray.contextualOfferId>---</span></td><td class="small-1 columns"><span ng-if=offersData.offerVersion>{{offersData.offerVersion}}</span> <span ng-if=!offersData.offerVersion>---</span></td><td class="small-1 columns"><span ng-if=dataArray.duration>{{dataArray.duration}}</span> <span ng-if=!dataArray.duration>---</span></td><td class="small-1 columns"><span ng-if=dataArray.country>{{dataArray.country}}</span> <span ng-if=!dataArray.country>---</span></td><td class="small-1 columns"><span ng-if=dataArray.price>{{dataArray.price}}<span ng-if=dataArray.currency>&nbsp;{{dataArray.currency}}</span> </span><span ng-if=!dataArray.price>---</span></td><td class="small-3 columns"><button type=button ng-if=vm.enableSubscribeButton class="buttonWithIcon left" ng-click="vm.subscribe(offersData, dataArray)"><div class="iconDiv iconDivNoBorder"><i class=icon-icons_validate style="margin-top: 5px;font-size: 25px;"></i></div><div class=btnText style="padding-left: 3px;">{{\'SUBSCRIBE\' | translate}}</div></button></td></tr></tbody></table></div><div ng-if=vm.dealerOffers class="small-12 columns"><div style="font-weight: bold;font-size: var(--renaultMediumFont);">{{\'DEALER_OFFERS_AVAILABLE\' |translate}}</div><div ng-repeat="offersData in vm.contextualOffersData1"><div class=connectedIconActive><img src=./assets/images/connectedVehicleWhite.png height=23 width=23 style="margin-bottom: -4px;" id=connect-service-offer-icon> <span style="font-size: var(--renaultMediumFont); font-family: var(--renaultFontBold);padding-left: 3px;padding-right: 5px;color:var(--renaultPrimaryColor)">|</span> {{offersData.name}}</div><table class=offerTable><thead><tr colspan=12><th class="small-3 columns">{{"OFFER_DATA"|translate}}</th><th class="small-2 columns">{{"CONTEXTUAL_OFFER"|translate}}</th><th class="small-1 columns">{{"RLINKCAR_VERSION"|translate}}</th><th class="small-1 columns">{{"OFFER_DURATION"|translate}}</th><th class="small-1 columns">{{"ALERTS_COUNTRY"|translate}}</th><th class="small-1 columns">{{"FAV_MODAL_TM_PRICE"|translate}}</th><th class="small-3 columns"></th></tr></thead><tbody><tr ng-repeat=" dataArray in offersData.filteredContextual1"><td class="small-3 columns"><span ng-if=dataArray.name>{{dataArray.name}}</span> <span ng-if=!dataArray.name>---</span></td><td class="small-2 columns"><span ng-if=dataArray.contextualOfferId>{{dataArray.contextualOfferId}}</span> <span ng-if=!dataArray.contextualOfferId>---</span></td><td class="small-1 columns"><span ng-if=offersData.offerVersion>{{offersData.offerVersion}}</span> <span ng-if=!offersData.offerVersion>---</span></td><td class="small-1 columns"><span ng-if=dataArray.duration>{{dataArray.duration}}</span> <span ng-if=!dataArray.duration>---</span></td><td class="small-1 columns"><span ng-if=dataArray.country>{{dataArray.country}}</span> <span ng-if=!dataArray.country>---</span></td><td class="small-1 columns"><span ng-if=dataArray.price>{{dataArray.price}}<span ng-if=dataArray.currency>&nbsp;{{dataArray.currency}}</span> </span><span ng-if=!dataArray.price>---</span></td><td class="small-3 columns"></td></tr></tbody></table></div></div></div></div><!-- Eligible On-Demand (FOD) hardware features for sale --><div class=fod-section><div class=fod-section-header ng-click="vm.hardwareEligibleCollapsed = !vm.hardwareEligibleCollapsed" ng-if=vm.isFodEnable><i class=connected-car-icon></i> <span class=fod-section-title>{{\'HARDWARE_FEATURES_ELIGIBLE\' | translate}}</span> <i class=fa ng-class="vm.hardwareEligibleCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'"></i></div><div ng-if=!vm.hardwareEligibleCollapsed><table class=offerTable><thead><tr colspan=12><th class="small-3 columns offerDataOffset">{{\'OFFER_DATA\' | translate}}</th><th class="small-2 columns">{{\'CONTEXTUAL_OFFER\' | translate}}</th><th class="small-1 columns">{{\'RLINKCAR_VERSION\' | translate}}</th><th class="small-1 columns">{{\'OFFER_DURATION\' | translate}}</th><th class="small-1 columns">{{\'ALERTS_COUNTRY\' | translate}}</th><th class="small-2 columns">{{\'FAV_MODAL_TM_PRICE\' | translate}} <i ng-if=vm.isDmsProfile class="icon-icons_refresh fod-reset-customer-icon" ng-click=vm.resetCustomerAccount()><md-tooltip>{{\'FOD_RESET_CUSTOMER_ACCOUNT\' | translate}}</md-tooltip></i></th><th class="small-2 columns"></th></tr></thead><tbody><tr ng-repeat="fod in vm.hardwareEligibleList track by $index" class=hardwareEligibleRow><td class="small-3 columns"><span class="intervention interventionLeftShift" ng-click=vm.openFodEasyBasket(fod)><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""><md-tooltip>{{\'EASY_BASKET_OPERATIONS\' |translate}}</md-tooltip></span><span ng-if="fod.name && fod.name !== \'-\'">{{fod.name}}</span><span ng-if="!fod.name || fod.name === \'-\'">---</span></td><td class="small-2 columns"><span ng-if="fod.contextualOfferId && fod.contextualOfferId !== \'-\'">{{fod.contextualOfferId}}</span><span ng-if="!fod.contextualOfferId || fod.contextualOfferId === \'-\'">---</span></td><td class="small-1 columns"><span ng-if="fod.version && fod.version !== \'-\'">{{fod.version}}</span><span ng-if="!fod.version || fod.version === \'-\'">---</span></td><td class="small-1 columns"><span ng-if=fod.duration>{{fod.duration}}</span><span ng-if=!fod.duration>{{vm.lifeTime}}</span></td><td class="small-1 columns"><span ng-if="fod.country && fod.country !== \'-\'">{{fod.country}}</span><span ng-if="!fod.country || fod.country === \'-\'">---</span></td><td class="small-2 columns"><span ng-if=fod.showPrice>{{fod.price | number:2}}<span ng-if=fod.currency>&nbsp;{{fod.currency}}</span> <i class="fa fa-info-circle fod-price-info-icon"><md-tooltip>{{\'FOD_PRICE_DMS_TOOLTIP\' | translate}}</md-tooltip></i></span><i ng-if=fod.isCalculating class="fa fa-spinner fa-spin"></i> <button type=button ng-if="vm.isDmsProfile && !fod.showPrice && !fod.isCalculating" class=fod-calculate-btn ng-click=vm.calculateFod(fod)>{{\'CALCULATE_FOD\' | translate}}</button></td><td class="small-2 columns"><button type=button ng-if=vm.enableSubscribeButton class="buttonWithIcon left fodSubscribeBtn" ng-click="vm.subscribeFod(fod, \'hardware\')"><div class="iconDiv iconDivNoBorder"><i class="icon-icons_validate fodSubscribeIcon"></i></div><div class="btnText btnTextSmallPadding">{{\'SUBSCRIBE\' | translate}}</div></button></td></tr></tbody></table><div ng-if="!(vm.hardwareEligibleList && vm.hardwareEligibleList.length > 0)" class=textCenter>{{\'NO_DATA_FOUND\' | translate}}</div></div></div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/eligibleOffersPopin.template.html','<div layout=column layout-align="center center" class=md-padding style=text-align:center;><i class="fa fa-times" style="position:absolute; top:8px; right:12px; cursor:pointer; color:#000;" ng-click=vm.close()></i><div style="position:relative; display:inline-block;"><div style="border:1px solid #c5d9f1; background:#f7fafd; padding:4px; border-radius:4px; text-align:left; width:731px;position: relative;bottom: -12px;"><div style="display:inline-flex; align-items:center; border:1px solid #007bff; background:#eaf3ff; color:#007bff; border-radius:20px; padding:2px 12px; font-weight:600; font-size:13px; margin-bottom:12px;"><i class="fa fa-info-circle" style=margin-right:6px;></i> Note</div><div style="margin-top:8px; font-weight:500; font-size:14px; color:#007bff;">{{\'ELIGIBLE_OFFERS_WARNING_TEXT\' | translate}}</div></div><div><button ng-click=vm.close() style="background:#978b7f; color:#fff; padding:7px 17px; border-radius:6px;cursor:pointer;position: relative;bottom: -25px;"><i style="right: 5px; position: relative;" class="fa fa-check"></i>{{\'OK_INDEPENDENT\'|translate}}</button></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/fodCustomerPopin.template.html','<md-dialog id=fodCustomerPopin class=fod-customer-popin-container aria-label="Customer management"><div class=intervention-popin-header><span class=intervention-popin-close ng-click=vm.cancel()>&#215;</span></div><h2 class=fod-customer-popin-title>{{\'FOD_CUSTOMER_SELECT_TITLE\' | translate}}</h2><section class=fod-customer-card><div class=fod-customer-card-label><i class=icon-icons_search_partlist></i> <span>{{\'FOD_CUSTOMER_SEARCH_BY_ACCOUNT_LABEL\' | translate}}</span></div><div class=fod-customer-card-row><label class="fod-customer-field fod-customer-field-account">{{\'FOD_CUSTOMER_ACCOUNT_NUMBER_PLACEHOLDER\' | translate}} <input type=text ng-model=vm.customerId ng-keydown="$event.which === 13 && vm.selectById()"></label> <button type=button class=fod-customer-search-btn ng-click=vm.selectById()>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</button></div></section><div class=fod-customer-divider><span class=fod-customer-divider-line></span> <span class=fod-customer-divider-label>{{\'FOD_CUSTOMER_OR\' | translate}}</span> <span class=fod-customer-divider-line></span></div><section class=fod-customer-card><div class=fod-customer-card-label><i class=icon-icons_search_partlist></i> <span>{{\'BT_LIST_ADVANCED_SEARCH\' | translate}}</span></div><div class="fod-customer-card-row fod-customer-advanced-row"><label class=fod-customer-field>{{\'ALERTS_LASTNAME\' | translate}} <input type=text ng-model=vm.lastName ng-keydown="$event.which === 13 && vm.search()"></label> <label class=fod-customer-field>{{\'ALERTS_FIRSTNAME\' | translate}} <input type=text ng-model=vm.firstName ng-keydown="$event.which === 13 && vm.search()"></label> <label class=fod-customer-field>{{\'FOD_CUSTOMER_ADVANCED_ACCOUNT_PLACEHOLDER\' | translate}} <input type=text ng-model=vm.accountNumber ng-keydown="$event.which === 13 && vm.search()"></label> <button type=button class=fod-customer-search-btn ng-click=vm.search()>{{\'CARSEARCH_SEARCH_BUTTON\' | translate}}</button></div></section><div class=fod-customer-results ng-if=vm.searchDone><div class=fod-customer-result-count>{{vm.resultCount}} {{\'COMMON_RESULT_LABEL\' | translate}}</div><table class=fod-customer-results-table><thead><tr><th>{{\'ALERTS_LASTNAME\' | translate}}</th><th>{{\'ALERTS_FIRSTNAME\' | translate}}</th><th>{{\'COMMON_NUMCLIENT_PLACEHOLDER\' | translate}}</th><th></th></tr></thead><tbody><tr class=fod-customer-result-row ng-repeat="customer in vm.customers" ng-click=vm.selectCustomer(customer)><td>{{customer.name}}</td><td>{{customer.firstName}}</td><td>{{customer.accountNumber}}</td><td><i class=icon-icons_next_partlist></i></td></tr></tbody></table><div class=fod-customer-pagination ng-if="vm.pageCount > 1"><i class=icon-icons_arrow_left_partlist ng-click=vm.previousPage() ng-if="vm.page > 1"></i> <span>Page {{vm.page}} / {{vm.pageCount}}</span> <i class=icon-icons_arrow_right_partlist ng-click=vm.nextPage() ng-if="vm.page < vm.pageCount"></i></div></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/fodSubscribePopin.template.html','<div><div id=fodSubscribePopin class=fodPopinContainer><div class=fod-popin-title>{{\'SUBSCRIBE_FOD\' | translate}}</div><table class=fodSubscribeTable><thead><tr><th>{{\'SUBSCRIBE_OFFER_NAME\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th><th>{{\'ALERTS_COUNTRY\' | translate}}</th></tr></thead><tbody><tr><td><strong><span ng-if=vm.selectedOffer.name>{{vm.selectedOffer.name}}</span><span ng-if=!vm.selectedOffer.name>---</span></strong></td><td><span ng-if=vm.selectedOffer.version>{{vm.selectedOffer.version}}</span><span ng-if=!vm.selectedOffer.version>---</span></td><td><span ng-if=vm.selectedOffer.country>{{vm.selectedOffer.country}}</span><span ng-if=!vm.selectedOffer.country>---</span></td></tr></tbody></table><div class=fod-popin-info><i class="fa fa-info-circle"></i> <span>{{\'SUBSCRIBE_INFO_MESSAGE\' | translate}}</span> <span class=intervention><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""></span></div><div class=fod-popin-buttons><button type=button class=fod-popin-subscribe ng-click=vm.onSubscribe()>{{\'SUBSCRIBE\' | translate}}</button> <button type=button class=fod-popin-cancel ng-click=vm.onCancel()>{{\'ACTIS_HEADER_CANCEL\' | translate}}</button></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/interventionPopin.template.html','<div><div id=interventionPopin class=intervention-popin-container><div class=intervention-popin-header><div class=intervention-popin-title><span class=intervention><img src=./assets/images/automobile_with_wrench.png class=interventionImg alt=""> </span><span>{{vm.title}}</span></div><span class=intervention-popin-close ng-click=vm.onClose()>X</span></div><div class=intervention-popin-total><div class=intervention-popin-total-amount ng-if=vm.isDmsProfile><span class=intervention-popin-total-value>{{vm.totalAmount}} <span class=intervention-popin-total-currency>{{vm.currency}}</span></span> <span class=intervention-popin-total-label>{{\'ESTIMATE_TOTAL_TTC\' | translate}}</span></div><span ng-if=vm.showMrLink class=intervention-mr-link ng-click=vm.gotoMrLink() style=cursor:pointer;><img src=./assets/images/mr_link_black.svg class=mrLinkIcon alt="{{\'CONSULT_MR_DESCRIPTION\' | translate}}"><md-tooltip>{{\'CONSULT_MR_DESCRIPTION\' | translate}}</md-tooltip></span><span ng-if=!vm.isDmsProfile class=intervention-popin-currency-badge ng-class="{\'basket-added\': vm.basketAdded}" ng-click=vm.handleBasketAdd() style="cursor:pointer; position: relative;"><span class=basket-icon-wrapper style="position: relative; display: inline-block; width: 30px; height: 30px;"><i class="icon-icons_basket on-basket-hover" aria-hidden=true></i><cart-badge cart-length=vm.basketItemsNumber ng-if=vm.basketAdded style="position: absolute; top: -6px; left: -5px; z-index: 2;"></cart-badge></span><div class=recap-cart-container><recap-cart flatten-cart=vm.flattenCart cart-metadata=vm.cartMetadata></recap-cart></div><md-tooltip ng-if=!vm.basketAdded>{{\'ADD_INTERVENTION_TO_BASKET\' | translate}}</md-tooltip></span><span ng-if="vm.basketAdded || vm.basketUpdatePending" class=intervention-popin-delete ng-click=vm.deleteBasketIntervention()><i class="fa fa-trash" aria-hidden=true></i><md-tooltip>{{\'BASKET_REMOVED\' | translate}}</md-tooltip></span><span ng-if=vm.isDmsProfile class="intervention-popin-currency-badge on-super-cart-quote-hover" ng-class="{\'quote-added\': vm.quoteAdded}" ng-click="vm.quoteAdded ? vm.goToQuote() : vm.handleBulkAdd()" style=cursor:pointer;><img src=./assets/images/icons_estimation_white.svg class=estimate-icon alt="{{\'ADD_INTERVENTION_TO_QUOTATION\' | translate}}"><cart-badge cart-length=vm.quoteItemsNumber ng-if=vm.quoteAdded ng-click=vm.goToQuoteFromBadge($event) style="position: relative; top: -8px; left: -28px;"></cart-badge><md-tooltip>{{\'ADD_INTERVENTION_TO_QUOTATION\' | translate}}</md-tooltip></span><div class=intervention-popin-quote-preview ng-if=vm.quoteAdded ng-click=vm.goToQuote() style=cursor:pointer;><super-cart-popin items=vm.quoteItems icon=./assets/images/icons_estimation_white.svg popin-title=vm.quotePopinTitle popin-subtitle=vm.quotePopinSubtitle type=quote></super-cart-popin></div><span ng-if="vm.quoteAdded || vm.quoteUpdatePending" class=intervention-popin-delete ng-click=vm.deleteQuoteIntervention()><i class="fa fa-trash" aria-hidden=true></i><md-tooltip>{{\'QUOTE_REMOVED\' | translate}}</md-tooltip></span></div><table class=interventionTable><thead><tr><th class=small-2>{{\'COMMON_COLUMN_REF_TITLE\' | translate}}</th><th class=small-4>{{\'COMMON_DESIGNATION\' | translate}}</th><th class=small-2>{{\'COMMON_COLUMN_QTE_TITLE\' | translate}}</th><th class=small-2 ng-if=vm.isDmsProfile>{{\'LOCAL_STOCK_PR\' | translate}}</th><th class=small-1>{{\'PUBLIC_PRICE\' | translate}}</th><th class=small-1>{{\'INTERVENTION_CATALOG_PLATE\' | translate}}</th></tr></thead><tbody><tr ng-repeat="part in vm.parts track by $index"><td class=small-2><span ng-if=part.reference>{{part.reference}} <i class="fa fa-files-o copy-icon intervention-copy-icon" ng-click=vm.copyReference(part.reference)></i> </span><span ng-if=!part.reference>---</span></td><td class=small-4><span ng-if=part.designation>{{part.designation}}</span><span ng-if=!part.designation>---</span></td><td class=small-2><span ng-if="part.quantity !== undefined && part.quantity !== null && part.quantity !== \'\'">{{part.quantity}}</span><span ng-if="part.quantity === undefined || part.quantity === null || part.quantity === \'\'">---</span></td><td class=small-2 ng-if=vm.isDmsProfile><span ng-if="part.dmsInformations.quantity || part.dmsInformations.quantity == 0"><i class="fa fa-circle" ng-style="{\'color\':part.stockAvailability ? \'green\' : \'red\'}" aria-hidden=true><md-tooltip>{{part.dmsInformations.quantity}}</md-tooltip></i></span><span ng-if="!part.dmsInformations.quantity && part.dmsInformations.quantity != 0">-<md-tooltip>{{\'CONNECTED_SERVICES_UNKNOWN_STATUS\' | translate}}</md-tooltip></span></td><td class=small-1><span ng-if="part.price !== undefined && part.price !== null">{{part.price | number:2}}<span>&nbsp;{{vm.getCurrencyForItem(part)}}</span></span> <span ng-if="(part.price === undefined || part.price === null) && part.priceExclTaxes !== undefined && part.priceExclTaxes !== null">{{part.priceExclTaxes | number:2}}<span>&nbsp;{{vm.getCurrencyForItem(part)}}</span></span> <span ng-if="(part.price === undefined || part.price === null) && (part.priceExclTaxes === undefined || part.priceExclTaxes === null)">---</span></td><td class=small-1><img ng-if="part.catalogPlates && part.catalogPlates.length" src=./assets/images/Eb_plate.svg class=catalogPlate style=cursor:pointer;height:20px; ng-click=vm.gotoCatalogPlate(part)><md-tooltip ng-if="part.catalogPlates && part.catalogPlates.length">{{\'EASY_BASKET_GOTO_PLATE\' | translate}}</md-tooltip></td></tr></tbody></table><table class="interventionTable interventionTmTable"><thead><tr><th class=small-2>{{\'ACTIS_DESCRIPTION_OPECODE\' | translate}}</th><th class=small-4>{{\'COMMON_DESIGNATION\' | translate}}</th><th class=small-2>{{\'DOCUMENT_TM_TYPE\' | translate}}</th><th class=small-2>{{\'COMMON_COLUMN_TIME_TITLE\' | translate}}</th><th class=small-2>{{\'EASYBASKET_PRECISION\' | translate}}</th></tr></thead><tbody><tr ng-repeat="tm in vm.tmCodes track by $index"><td class=small-2><span ng-if=tm.code>{{tm.code}}</span><span ng-if=!tm.code>---</span></td><td class=small-4><span ng-if=tm.designation>{{tm.designation}}</span><span ng-if=!tm.designation>---</span></td><td class=small-2><span ng-if=tm.type>{{tm.type}}</span><span ng-if=!tm.type>---</span></td><td class=small-2><span ng-if=tm.time>{{tm.time}}</span><span ng-if=!tm.time>---</span></td><td class=small-2><span ng-if=tm.precision>{{tm.precision}}</span><span ng-if=!tm.precision>---</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/interventionSelectionPopin.template.html','<md-dialog id=interventionSelectionPopin class=intervention-selection-popin-container aria-label="Select an operation"><div class=intervention-popin-header><span class=intervention-popin-close ng-click=vm.onCancel()>&#215;</span></div><h2 class=intervention-selection-title>{{\'EASYBASKET_DOCUMENT_SELECET_OPTION\' | translate}}</h2><md-radio-group ng-model=vm.selectedSie class=intervention-selection-list><md-radio-button ng-repeat="sieEntry in vm.sieEntries track by sieEntry.id" ng-value=sieEntry class=intervention-selection-option><span class=intervention-selection-designation>{{sieEntry.designation || sieEntry.id}}</span></md-radio-button></md-radio-group><div class=intervention-selection-buttons><button type=button class=fod-popin-cancel ng-click=vm.onCancel()>{{\'ACTIS_HEADER_CANCEL\' | translate}}</button> <button type=button class=fod-popin-subscribe ng-disabled=!vm.selectedSie ng-click=vm.onValidate()>{{\'QUESTIONNING_VALIDATE\' | translate}}</button></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/connectedServicesOffers/offerSubscribe.template.html','<div><div id=offerSubscribe style="width:60vw; padding:1%;font-family: var(--renaultFontRegular)"><div><div style="padding-top: 15px;"></div><div style="padding-bottom: 10px;"><span style=padding-left:10Px;></span> <span style=padding-right:4Px;><i class="fa fa-file-text fa-2x" style="font-size:26px; padding-top:3px;"></i> </span><span style="padding-right: 4Px;font-size: 40px;color: var(--renaultPrimaryColor); font-weight: 900;">|</span> <span style=padding-right:10Px;><strong style="font-size: var(--renaultLargeFont);">{{\'SUBSCRIBE_POPUP\' | translate}}</strong></span> <span style="float:right;padding-right:10Px;cursor: pointer;" ng-click=vm.onCancel()><i class=icon-icons_close></i></span></div><div class="small-12 columns" style="padding-top: 20px;padding-left: 35px;"><div class=connectedIconActive style="font-size: var(--renaultMediumFont); font-family: var(--renaultFontBold);"><img src=./assets/images/connectedVehicleWhite.png height=23 width=23 style="margin-bottom: -4px;" id=connect-service-offer-icon> {{vm.selectedOffer.name}}</div><table class=subscribeTable style=margin-bottom:15px;><thead><tr colspan=12><th colspan=3>{{"RLINKCAR_STOCKAGE_MAPS_VERSION"|translate}}</th><th colspan=3>{{"OFFER_DURATION"|translate}}</th><th colspan=3>{{"ALERTS_COUNTRY"|translate}}</th><th colspan=3>{{"FAV_MODAL_TM_PRICE"|translate}}</th></tr></thead><tbody><tr><td colspan=3>{{vm.offerDetails.offerVersion}}</td><td colspan=3>{{vm.selectedOffer.duration}}</td><td colspan=3>{{vm.selectedOffer.country}}</td><td colspan=3>{{vm.selectedOffer.price}} <span ng-if=vm.selectedOffer.currency>&nbsp;{{vm.selectedOffer.currency}}</span></td></tr></tbody></table></div><div class=offer-warning-section ng-if=vm.showOfferWarning()><div class=offer-warning-pill><i class="fa fa-exclamation-triangle"></i> {{\'CONNECTED_SERVICES_WARNING_STATUS\' | translate}}</div><div class=offer-warning-message>{{\'ELIGIBLE_OFFERS_WARNING\'|translate}} <strong>{{vm.selectedOffer.name}}</strong></div></div><div class=modalPhenixButtons><button type=button class="buttonWithIcon cancel" style="border-radius: 35px;min-width: 50%;background-color: #7c7a7a;" ng-click=vm.onCancel()><div class=iconDiv><em class=icon-icons_close></em></div><div class=btnText>{{\'ACTIS_HEADER_CANCEL\' | translate}}</div></button> <button type=button class="buttonWithIcon left" style="margin-left: 15%;border-radius: 35px;" ng-click=vm.onSubscribe()><div class=iconDiv><em class=icon-icons_validate></em></div><div class=btnText>{{\'SUBSCRIBE\' | translate}}</div></button></div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/dataConsistencies/dataConsistencies.template.html','<div ng-if=vm.isDataConsistency><div class=row ng-if="vm.noTcu && vm.noHu"><div class=block_text><rlink-tip tip-class=label_title tip-value=TCU tip-title=RLINKCAR_TIP_TCU></rlink-tip><span class="nd-message upper">{{\'NO_DATA_FOUND\' | translate}}</span></div></div><!-- EasyLink / OpenRLink --><div ng-show=vm.isEasyLink><div class="block-accordion dataConsistencyTable" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.dataConsistencies.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen" style="margin-bottom: 1rem;"><div><span>{{\'DATA_CONSISTENCY_MENU\' | translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><table style="border: none !important;margin-bottom:0px;    bottom: 3px;\n                            position: relative;border-collapse: collapse;width: 100%;"><thead table-width data=vm.tcuTable><tr><th></th><th></th><th></th><th></th><th><div ng-click=vm.refreshData() class=rlink-tip style="left: 87%; position: relative; cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></th></tr><tr><th></th><th ng-if=!vm.vehicleInformationDisplay class=ddpHeader><span>{{vm.cvc | uppercase}}</span></th><th ng-if=vm.vehicleInformationDisplay class=ddpHeader><span>{{vm.connectedPlatform.platform === \'AVN\' ? vm.vnext : vm.cvc}}</span></th><th ng-if=!vm.vehicleInformationDisplay class="ddpHeader upper"><span>{{vm.bvm | uppercase}}</span></th><th ng-if=vm.vehicleInformationDisplay class="ddpHeader upper"><span>{{vm.bva | uppercase}}</span></th><th class=ddpHeader><span>{{vm.vcps}}</span></th><th class=ddpHeader><span>{{\'RLINKCAR_HU_STATUS\' | translate}}</span></th></tr></thead><tbody ng-if="vm.tcuTable !== null && vm.huTable !== null"><tr ng-show="vm.dataConsistencies.headUnitInformation && vm.dataConsistencies.headUnitInformation.present === \'YES\'" class=ddpDataConsistencyBorder><td class="table-padding-td ddpBody"><span>{{(vm.ccs3Architecture ? \'HU_CDC_SERIAL_NO\' : \'HU_SERIAL_NO\') | translate}}</span></td><td class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.headUnitInformation.huId.vnext ? (vm.dataConsistencies.headUnitInformation.huId.vnext | rlinkformat) : \'-\' }}</span></td><td ng-if=vm.vehicleInformationDisplay class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.headUnitInformation.huId.bvmAfterSales ? (vm.dataConsistencies.headUnitInformation.huId.bvmAfterSales | rlinkformat) : \'-\' }}</span></td><td class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.headUnitInformation.huId.vehicleReferential ? (vm.dataConsistencies.headUnitInformation.huId.vehicleReferential | rlinkformat) : \'-\' }}</span></td><td class="table-padding-td ddpBody"><span ng-if=vm.threeHuValuesEqual><em class="fa fa-check" style="color: green;font-size: 20px;"></em> </span><span ng-if=!vm.threeHuValuesEqual><em class="fa fa-close" style="color: red;font-size: 20px;"></em></span></td></tr><tr ng-show="vm.dataConsistencies.tcuInformation && vm.dataConsistencies.tcuInformation.present === \'YES\'" class=ddpDataConsistencyBorder><td class="table-padding-td ddpBody"><span>{{\'TCU_SERIAL_NO\' | translate}}</span></td><td class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.tcuInformation.tcuId.vnext ? (vm.dataConsistencies.tcuInformation.tcuId.vnext | rlinkformat) : \'-\' }}</span></td><td class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.tcuInformation.tcuId.bvmAfterSales ? (vm.dataConsistencies.tcuInformation.tcuId.bvmAfterSales | rlinkformat) : \'-\' }}</span></td><td class="table-padding-td ddpBody"><span>{{ vm.dataConsistencies.tcuInformation.tcuId.vehicleReferential ? (vm.dataConsistencies.tcuInformation.tcuId.vehicleReferential | rlinkformat) : \'-\' }}</span></td><td class="table-padding-td ddpBody"><span ng-if=vm.threeTcuValuesEqual><em class="fa fa-check" style="color: green;font-size: 20px;"></em> </span><span ng-if=!vm.threeTcuValuesEqual><em class="fa fa-close" style="color: red;font-size: 20px;"></em></span></td></tr></tbody></table></div></div></accordion-group></accordion></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/diagnosis.template.html','<div id=diagnosis><ng-include ng-show=!vm.isDiagnosis src="\'app/components/car/rLinkCar/diagnosis/select-diag.html\'"></ng-include><!-- DIAGNOSIS PROCESS BLOCK --><any ng-show=vm.isDiagnosis><div id=diagStep><div class=container><div class=row-diag><div class="medium-12 flex"><div class="medium-6 title-diag">{{\'CONNECTED_SERVICES_DIAGNOSIS_TITLE\'|translate}} {{vm.typeDiag}}</div><div class=medium-6><div ng-if=vm.showNavigationBtn() class=btn-close ng-click=vm.goToSelectDiag()><i class="icon close"></i></div></div></div></div></div></div><div class=block-progress><div class="container flex margin-progress"><div ng-class="{\'nissanBtn-progress\': vm.nissanUserURL, \'renaultBtn-progress\': !vm.nissanUserURL,\'active\':$last}" ng-repeat="item in vm.navBar"><div class=progress-diag>{{($index + 1) +\'. \'+ item.name}}</div></div></div></div><div class=container><div class=row-diag><div class="medium-12 flex" ng-if=vm.showNavigationBtn()><div class=medium-6><div class=btn-back ng-click=vm.previousNode()><i class="icon back"></i><div class=icon-label>{{\'CONNECTED_SERVICES_DIAGNOSIS_PREVIOUS\'|translate}}</div></div></div><div ng-if=vm.showNextBtn() class=medium-6><div class=btn-next ng-click=vm.nextStep()><div class=icon-label>{{\'CONNECTED_SERVICES_DIAGNOSIS_NEXT\'|translate}}</div><i class="icon next"></i></div></div><div ng-if=vm.showCloseBtn() class=medium-6><div class=btn-next ng-click=vm.endDiagnosis()><div class=icon-label>{{\'CONNECTED_SERVICES_DIAGNOSIS_CLOSE\'|translate}}</div><i class="icon next"></i></div></div></div></div><div class=diag-step><div class="row-diag description"><div marked=vm.currentDiagnosis.description></div></div><div ng-if=vm.isSimpleStep class=block-answer><div class=btn-answer ng-repeat="item in vm.diagAnswers | orderBy:\'-response\'"><button type=button ng-class="{\'nissanBtn-diag-answer\': vm.nissanUserURL, \'renaultBtn-diag-answer\': !vm.nissanUserURL}" ng-click=vm.nextStep(item)><div class=btnText>{{item.response}}</div></button></div></div><div class=block-answer ng-if=vm.isInputStep><form name=inputDiag novalidate><div class=simple-row><div class=medium-2><div class=input-block><input class=text-diag type=text ng-model=vm.input ng-pattern=/^[a-zA-Z0-9]*$/ ng-minlength=10 ng-maxlength=20 required></div></div><div class=medium-10><div class=input-block><button type=button ng-class="{\'nissanBtn-diag-answer nissanAuto\': vm.nissanUserURL, \'renaultBtn-diag-answer renaultAuto\': !vm.nissanUserURL}" ng-click=vm.callRoutine() ng-disabled=inputDiag.$invalid><div class=btnText>{{\'MODAL_OK_BUTTON\' | translate}}</div></button></div></div></div><div class=simple-row><div class=diag-input-error><span ng-if=inputDiag.$error.minlength>{{\'RLINKCAR_ERROR_MIN_LNT\' | translate}}<br></span><span ng-if=inputDiag.$error.maxlength>{{\'RLINKCAR_ERROR_MAX_LNT\' | translate}}<br></span><span ng-if=inputDiag.$error.pattern>{{\'RLINKCAR_ERROR_PATTERN\' | translate}}<br></span></div></div></form></div><div ng-if="vm.isAutoStep && !vm.isInputStep && !vm.fatalError" class="row-diag description diag-info"><i class=icon-info-diag></i> {{\'RLINKCAR_DIAG_AUTO_STEP\' | translate}}</div><div ng-if=vm.fatalError class="row-diag description diag-error"><i class=icon-error-diag></i> {{\'RLINKCAR_DIAG_FATAL_ERROR\' | translate}}</div><waiting-response ng-if=vm.showLoading></waiting-response><any ng-if=vm.showHelp()><md-divider class=row-diag></md-divider><div class=row-diag><div class=history_title>{{\'HELP\' | translate}}</div><div class="block-help medium-12 diag-help-msg"><div marked=vm.currentDiagnosis.detail></div></div></div></any><div ng-if=vm.isEndStep ng-include src="\'app/components/car/rLinkCar/diagnosis/resume-diag.html\'"></div></div></div></any><!--    <div ng-include src="\'app/components/car/rLinkCar/diagnosis/loading.html\'"></div>--></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/history-diag.html','<div class=row-diag><div class="block-body medium-12"><label class=history_title>{{\'RLINKCAR_DIAG_HISTO_TITLE\' | translate}} :</label><div ng-if="vm.diagHistory.length > 0" class="pad_table table_history"><table><thead table-width custom=4 data=vm.diagHistory><tr><th id=exth1 ng-click=vm.sort(1) ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL}">{{\'RLINKCAR_DIAG_HISTO_TYPE\' | translate}}</th><th id=exth2 ng-click=vm.sort(2) ng-if=vm.showColumns ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL}">IPN</th><th id=exth3 ng-click=vm.sort(3) ng-if=vm.showColumns ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL}">{{\'RLINKCAR_DIAG_HISTO_USER\' | translate}}</th><th id=exth4 ng-click=vm.sort(4) ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL}">{{\'USER_PROFILE\' | translate}}</th><th id=exth5 ng-click=vm.sort(5) ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL}">{{\'RLINKCAR_DIAG_HISTO_DATE\' | translate}}</th><th>{{\'RLINKCAR_DIAG_HISTO_ACTION\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.diagHistory | rlinkOrderBy:vm.field:vm.reverse"><td>{{item.title}}</td><td ng-if=vm.showColumns>{{item.userId.ipn}}</td><td ng-if=vm.showColumns>{{item.userId.name}}</td><td>{{vm.showUserType(item.userId)}}</td><td>{{item.datetime | rlinkformat:\'full-date\'}}</td><td><button class=btn-plus ng-class="{\'nissan-button\': vm.nissanUserURL}" ng-click=vm.showHistoDiag(item)><div class=btn-icon><i class="icon show top"></i></div><div class=btn-txt>{{\'RLINKCAR_DIAG_HISTO_SHOW\' | translate}}</div></button><!--                            <button class="btn-plus" ng-click="vm.showHistoDiag(item)">--><!--                                <div class="btn-icon"><i class="icon retry top"></i></div>--><!--                                <div class="btn-txt"> Relancer</div>--><!--                            </button>--></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/loading.html','<div class=loading-container><div class=loading-diag><div class="sk-fading-circle sk-diag"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div><!--        <img src="./assets/images/hourglass.gif" width="80" height="80">--></div></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/report.html','<div id=connected-services-diagnosis-modal-report class=app-modal style="margin: 10px;width:950px;"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><div class=header-report>Diagnostic : {{typeDiag}} ({{dateDiag | rlinkformat:\'full-date\'}})</div><div ng-if="report === null" style="margin-top: 1rem" class="row-diag description diag-error">{{\'CONNECTED_SERVICES_DIAGS_EMPTY_REPORT\' | translate}}</div><ul class=timeline ng-class="{\'nissanDiagBorder\': vm.nissanUserURL, \'renaultDiagBorder\': !vm.nissanUserURL}" ng-if="report !== null"><li ng-repeat="item in report track by $index"><label class=msg-report ng-class="{\'conclusion\' : $last}">{{item}}</label></li></ul></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/resume-diag.html','<md-divider class=row-diag></md-divider><div class=row-diag><div class="medium-12 flex"><div class=medium-6><div class=history_title>{{\'RLINKCAR_DIAG_REPORT\' | translate}}</div></div><div class=medium-6><div class="btn-answer right"><button type=button ng-class="{\'nissanBtn-diag-answer\': vm.nissanUserURL, \'renaultBtn-diag-answer\': !vm.nissanUserURL}" ng-click="vm.copyToClipboard(\'diagReport\')"><div class=btnText>{{\'RLINKCAR_DIAG_COPY\' | translate}}</div></button></div></div></div><div class="block-help medium-12 diag-help-msg"><div id=diagReport marked=vm.diagResume.report></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/diagnosis/select-diag.html','<recap-car api=documentsMenuCtrl.recapCarAPI icons=true></recap-car><!-- DIAGNOSIS SELECT BLOCK --><div class="container padding"><div class=row-diag><div class="medium-12 flex"><div class=medium-6><div class=btn-back ng-click=vm.goToVehicleInformation()><i class="icon back"></i><div class=icon-label>{{\'CONNECTED_SERVICES_DIAGNOSIS_PREVIOUS\'|translate}}</div></div></div></div></div><div class=row-diag><div class="block-body medium-12 center"><div class="medium-4 columns"><div class=empty>.</div></div><div class="medium-4 columns"><div class=select-container ng-class="{\'nissanSelect-container\': vm.nissanUserURL, \'renaultSelect-container\': !vm.nissanUserURL}"><select ng-model=vm.diagnosis><option value="">{{\'CONNECTED_SERVICES_DIAGNOSIS_CHOICE\' | translate}}</option><option ng-repeat="item in vm.diagList" ng-value=item>{{item.title}}</option></select></div></div><div class="medium-4 columns"><div class=btn-container><button ng-disabled="vm.diagnosis ==\'\' || vm.diagnosis == null" ng-class="{\'nissanBtnWithIcon goBtnNissan\': vm.nissanUserURL, \'btn-go buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.startDiagnosis()><div class=btn-icon><i class="fa fa-chevron-right diagnosis"></i></div><div class=btn-txt>GO</div></button></div></div></div></div><md-divider class=row-diag></md-divider><ng-include ng-show=!vm.isDiagnosis src="\'app/components/car/rLinkCar/diagnosis/history-diag.html\'"></ng-include></div>');
$templateCache.put('app/components/car/rLinkCar/directives/diskSpace.template.html','<div ng-if=false><div class="row capacity">{{\'RLINKCAR_STORAGE_MAPS_CAPACITY\' | translate}} : {{ vm.total | rlinkformat:\'convert\'}}</div><div class="row freespace">{{\'CONNECTED_SERVICES_STORAGE_MAPS_FREE_SPACE\' | translate}} : {{ vm.empty | rlinkformat:\'convert\'}}</div></div><div ng-if=true class="medium-12 flex"><div class=gauge-width><i class=gauge-icon></i></div><div class="medium-9 gauge-wrapper"><div class=row><div class=small-5><div class=gauge-container><div style="width: {{vm.getWidth()+\'%\'}}" ng-class="{\'gauge-filled\': !vm.nissanUserURL, \'nissan-gauge-filled\': vm.nissanUserURL}"></div><!--div class="gauge-empty" style="width: calc(100% - {{vm.getWidth()+\'%\'}});"></div--></div></div></div><div class=row><div class="small-9 freespace">{{vm.empty | rlinkformat:\'convert\'}} {{\'RLINKCAR_GAUGE_FREE_SPACE\' | translate}} {{vm.total | rlinkformat:\'convert\'}}</div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/directives/rlinkHeader.template.html','<div class=row><div class="medium-12 block_rlink_info flex" ng-show=!vm.hideHeader><div class="medium-3 context"><div class=rlink-2 ng-hide="(vm.HU === false || vm.HU === \'NO\') && (vm.rLinkHeader === \'openRlink\' || vm.rLinkHeader === \'EasyLink\')">{{vm.rLinkHeader}}</div></div><div class="medium-2 pad-top" ng-show=!vm.isEasyLink><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': vm.bose === true && !vm.nissanUserURL, \'nissanActive\': vm.bose === true && vm.nissanUserURL}">{{\'RLINKCAR_BOSE_LABEL\' | translate}}</div><span class=rlink-tip-txt>{{(vm.bose ? \'RLINKCAR_TIP_BOSE_OK\' : \'RLINKCAR_TIP_BOSE_NOK\')| translate}}</span></div></div><div class="medium-2 pad-top" ng-show=!vm.isEasyLink><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': vm.dab === true && !vm.nissanUserURL, \'nissanActive\': vm.dab === true && vm.nissanUserURL}">{{\'RLINKCAR_DAB_LABEL\' | translate}} <span class=rlink-tip-txt>{{(vm.dab ? \'RLINKCAR_TIP_DAB_OK\' : \'RLINKCAR_TIP_DAB_NOK\')| translate}}</span></div></div></div><div class="medium-3 pad-top" ng-show=!vm.isEasyLink><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': vm.carPlay === true && !vm.nissanUserURL, \'nissanActive\': vm.carPlay === true && vm.nissanUserURL}">{{\'RLINKCAR_APPLE_ANDROID_LABEL\' | translate}} <span class=rlink-tip-txt>{{vm.carPlay ? \'RLINKCAR_TIP_ANDROID_OK\' : \'RLINKCAR_TIP_ANDROID_NOK\' | translate}}</span></div></div></div><!-- To reactivate when needed for assistance tool --><!--        <span class="success-message"><img src="./assets/svg/icons_update_arrows.svg" height="20" width="20">derni\xE8re mise \xE0 jour aujourd\'hui \xE0 14:13</span>--><div class="medium-3 pad-top" ng-show=vm.isEasyLink ng-if=vm.ready><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': (vm.HU === true || vm.HU === \'YES\') && !vm.nissanUserURL, \'nissanActive\': (vm.HU === true || vm.HU === \'YES\') && vm.nissanUserURL}">{{(vm.architecture === \'CCS3\' ? \'EASYLINK_VEHICLE_CDC\' : \'EASYLINK_VEHICLE_HEAD-UNIT\') | translate}} <span class=rlink-tip-txt>{{(vm.HU === true || vm.HU === \'YES\') ? \'EASYLINK_VEHICLE_HEAD-UNIT_OK\' : \'EASYLINK_VEHICLE_HEAD-UNIT_KO\' | translate}}</span></div></div></div><div class="medium-3 pad-top" ng-show=vm.isEasyLink ng-if=vm.ready><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': (vm.TCU === true || vm.TCU === \'YES\') && !vm.nissanUserURL, \'nissanActive\': (vm.TCU === true || vm.TCU === \'YES\') && vm.nissanUserURL}">{{\'EASYLINK_VEHICLE_TCU\' | translate}} <span class=rlink-tip-txt>{{vm.TCU ? \'EASYLINK_VEHICLE_TCU_OK\' : \'EASYLINK_VEHICLE_TCU_KO\' | translate}}</span></div></div></div><div class="medium-3 pad-top" ng-show="vm.isEasyLink && vm.HU" ng-if="vm.ready && vm.privacyType !== \'GRANULAR_PRIVACY\'"><div class=rlink-tip><div class=option-rlink ng-class="{\'active\': vm.privacyMode === \'DATA_ON\' && !vm.nissanUserURL, \'nissanActive\': vm.privacyMode === \'DATA_ON\' && vm.nissanUserURL}">{{\'EASYLINK_VEHICLE_DATA_SHARING\' | translate}} <span class=rlink-tip-txt>{{vm.privacyMode === \'DATA_ON\' ? \'EASYLINK_VEHICLE_DATA_SHARING_ACTIVE\' : \'EASYLINK_VEHICLE_DATA_SHARING_INACTIVE\' | translate}}</span></div></div></div><div ng-show=vm.isEasyLink ng-class="{\'medium-3 pad-top\':!(vm.ready && vm.privacyType !== \'GRANULAR_PRIVACY\')}" style="text-align: right !important;"><img src=./assets/images/icn_light.png alt="Light Icon" style="max-width: 1.8rem; margin-bottom: 0.2rem; opacity: 0.7; cursor: pointer;" ng-click=vm.importantInfoPopup(true);></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/directives/rlinkTip.template.html','<div class=rlink-tip><div class={{vm.tipClass}}>{{vm.tipValue | translate}}</div><span class=rlink-tip-txt>{{vm.tipTitle | translate}}</span></div>');
$templateCache.put('app/components/car/rLinkCar/directives/tableDataManager.template.html','<tr ng-if=vm.showEmpty><td class=table-padding-td ng-repeat="x in [].constructor(vm.getIteration()) track by $index">-</td></tr><tr ng-if="(vm.showError || (vm.vehicleInformationDisplay && !vm.noTcuData && !vm.noHuData && vm.showError))"><td colspan={{vm.nbrColumn}} class=td-center-message>{{\'RLINKCAR_ERROR_RETRIEVE_DATA\' | translate}}</td></tr><tr ng-if=vm.noTcuData><td colspan={{vm.nbrColumn}} class=td-center-message style="text-align: center;">{{\'CONNECTED_SERVICES_NO_TCU_MESSAGE\' | translate}}</td></tr><tr ng-if=vm.noHuData><td colspan={{vm.nbrColumn}} class=td-center-message style="text-align: center;">{{(vm.isCCS3 ? \'CONNECTED_SERVICES_NO_CDC_MESSAGE\' : \'CONNECTED_SERVICES_NO_HU_MESSAGE\') | translate}}</td></tr>');
$templateCache.put('app/components/car/rLinkCar/directives/waitingResponse.template.html','<div class=row-diag><div class=zone-txt>{{\'RLINKCAR_DIAG_IN_PROGRESS\' | translate}}</div><div class=sk-fading-circle><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/evServices/plugAndCharge.template.html','<div id=evService><!-- EV Settings Section --><accordion class="collapse section_wrapper" close-others=false ng-if=vm.evSettings><accordion-group is-open=vm.tabOpen><accordion-heading><div class=evTabs><span ng-if=vm.evSettings>{{\'EV_SETTINGS_TITLE\' | translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i></div></accordion-heading><div><div style="padding: 10px 10px 0 10px;"><span style="font-size: var(--renaultLargeFont); font-weight: bold;">{{\'CHARGE_PRECOND\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" style="float: right; cursor: pointer; font-size: 20px;" ng-click=vm.refreshEvSettings()></i></div><table style="width: 100%; border-collapse: collapse; border: none; border-bottom: 1px solid #ddd;"><thead><tr style="text-align: left;"><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'CHARGE_SETTINGS\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'DELEGATE_MODE\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'CHARGE_START_TIME_EV\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'CHARGE_END_TIME\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'CHARGE_DURATION\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 90px; white-space: normal; word-wrap: break-word;">{{\'TARGET_TEMPERATURE\' | translate}}</div></th><th style="padding: 10px 5px 5px 10px;"><div style="max-width: 110px; white-space: normal; word-wrap: break-word;">{{\'HEATED_STEERING_WHEEL\' | translate}}</div></th></tr></thead><tbody><tr><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.chargeModeRq) || \'-\'}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.delegatedActivated) ? (\'CONNECTED_SERVICES_ACTIVATED_STATUS\' | translate) : (\'CONNECTED_SERVICES_DEACTIVATED_STATUS\' | translate)}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.chargeTimeStart) || \'-\'}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.chargeEndTime) || \'-\'}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.chargeDurationHours) || \'-\'}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.preconditioningTemperature) ? vm.evSettingsData.preconditioningTemperature + \'\xB0C\' : \'-\'}}</td><td style="padding: 5px 10px 10px 10px;">{{(vm.evSettingsData && vm.evSettingsData.preconditioningHeatedStrgWheel) ? (\'TRUE_EV\' | translate) : (\'FALSE_EV\' | translate)}}</td></tr><tr><td style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;">{{\'HEATED_LEFT_SEAT\' | translate}}</strong> <span>{{(vm.evSettingsData && vm.evSettingsData.preconditioningHeatedLeftSeat) ? (\'TRUE_EV\' | translate) : (\'FALSE_EV\' | translate)}}</span></td><td style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;">{{\'HEATED_RIGHT_SEAT\' | translate}}</strong> <span>{{(vm.evSettingsData && vm.evSettingsData.preconditioningHeatedRightSeat) ? (\'TRUE_EV\' | translate) : (\'FALSE_EV\' | translate)}}</span></td><td colspan=5 style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;padding-right: 36rem;">{{\'LAST_UPDATE\' | translate}}</strong> <span>{{vm.evSettingsData && vm.evSettingsData.lastSettingsUpdateTimestamp ? (vm.evSettingsData.lastSettingsUpdateTimestamp | rlinkformat : \'full-date\') : \'-\'}}</span></td></tr></tbody></table></div><div style="margin-top: 5px;"><div style="padding: 10px 10px 0 10px;"><span style="font-size: var(--renaultLargeFont); font-weight: bold;">{{\'SOC_LEVELS\' | translate}} </span><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=right>{{\'SOC_CHARGE\' | translate}}</md-tooltip></i><i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" style="float: right; cursor: pointer; font-size: 20px;" ng-click=vm.refreshSocLevels()></i></div><div ng-if=!vm.socLevelsValid style="padding: 10px;"><span style="color: #ff8c00; font-weight: bold;">{{vm.socLevelsErrorMessage}}</span></div><table ng-if=vm.socLevelsValid style="width: 100%; border-collapse: collapse; border: none;"><tbody><tr><td style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;">{{\'SOC_MIN\' | translate}}</strong> <span>{{(vm.evSettingsSocData && vm.evSettingsSocData.socMin) || \'-\'}}</span></td><td style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;">{{\'SOC_TARGET\' | translate}}</strong> <span>{{(vm.evSettingsSocData && vm.evSettingsSocData.socTarget) || \'-\'}}</span></td><td colspan=5 style="padding: 10px; vertical-align: top;"><strong style="display: block; margin-bottom: 10px;">{{\'LAST_UPDATE\' | translate}} </strong><span>{{vm.evSettingsSocData && vm.evSettingsSocData.lastEnergyUpdateTimestamp ? (vm.evSettingsSocData.lastEnergyUpdateTimestamp | rlinkformat : \'full-date\') : \'-\'}}</span></td></tr></tbody></table></div><div style="margin-top: 10px; border-top: 1px solid #ddd; padding-top: 10px;" ng-if=vm.showMobilizeSmart><div style="padding: 0.5rem; margin-bottom: 5px;"><span style="font-size: var(--renaultLargeFont); font-weight: bold;">{{\'MOBILE_SMART_CHARGE\' | translate}} </span><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=right>{{\'DELEGATE_MODE_INFO\' | translate}}</md-tooltip></i></div><div style="padding: 10px;"><strong style="display: block; margin-bottom: 10px;">{{\'DELEGATED_MODE\' | translate}}</strong> <span><i class="fa fa-circle" ng-style="{\'color\': vm.isDeleg ? \'green\' : \'red\'}"></i> {{vm.isDeleg ? (\'CONNECTED_SERVICES_ACTIVATED_STATUS\' | translate) : (\'CONNECTED_SERVICES_DEACTIVATED_STATUS\' | translate)}}</span></div></div><div style="margin-top: 10px; border-top: 1px solid #ddd; padding-top: 10px;"><div style="padding: 0.5rem; margin-bottom: 10px;"><span style="font-size: var(--renaultLargeFont); font-weight: bold;">{{\'PROGRAMS_SCHEDULE\' | translate}} </span><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=right>{{\'PROGRAMS_SCHEDULE_INFO\' | translate}}</md-tooltip></i><span ng-if=vm.showV2GWarning style="color: #ff8c00; font-weight: bold; margin-left: 15px;">{{vm.v2gWarningMessage}}</span></div><div ng-if=vm.showInstantaneousCharge style="padding: 10px;"><span style="color: #000; font-weight: bold;">{{\'INSTANTANEOUS_CHARGE\' | translate}}</span></div><div ng-if=vm.showNoDataFound style="padding: 10px;"><span style="color: #666; font-weight: bold;">{{\'NO_DATA_FOUND\' | translate}}</span></div><div ng-if="!vm.showInstantaneousCharge && !vm.showNoDataFound && vm.evSettingsData && vm.evSettingsData.programs && vm.evSettingsData.programs.length > 0" ng-repeat="program in vm.evSettingsData.programs" style="margin: 10px; padding: 15px; border: 1px solid #ddd; border-radius: 4px; display: flex; align-items: stretch;"><!-- Icon --><div class=program-icon-container><img ng-if="program.programType === \'CHARGE\' || program.programType === \'CHARGE_AND_PRECONDITIONING\'" src=assets/svg/charge.svg class=program-icon alt="Charge icon"> <img ng-if="program.programType === \'PRECONDITIONING\' || program.programType === \'CHARGE_AND_PRECONDITIONING\'" src=assets/svg/preconditioning.svg class=program-icon alt="Preconditioning icon"></div><div style="flex: 1;"><div style="margin-bottom: 10px; padding-bottom: 10px; margin-left: -20px; margin-right: -15px; padding-left: 20px; padding-right: 15px; border-bottom: 1px solid #ddd;"><div style="display: inline-block; margin-right: 30px;"><strong>{{\'PROGRAM_STATUS\' | translate}}</strong><br><span><i class="fa fa-circle" ng-style="{\'color\': program.programActivationStatus ? \'green\' : \'red\'}"></i> {{program.programActivationStatus ? (\'CONNECTED_SERVICES_ACTIVATED_STATUS\' | translate) : (\'CONNECTED_SERVICES_DEACTIVATED_STATUS\' | translate)}}</span></div><div style="display: inline-block; margin-right: 30px;"><strong>{{\'PROGRAM_TYPE\' | translate}}</strong><br><span>{{program.programType}}</span></div><div style="display: inline-block;"><strong>{{\'READY_AT\' | translate}}</strong><br><span>{{program.programDepartureTime}}</span></div></div><div style="padding-top: 10px;"><strong>{{\'CALENDAR_SETTINGS\' | translate}}</strong><br><span ng-style="{\'font-weight\': program.programActivationMonday ? \'bold\' : \'normal\'}">{{\'MONDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationTuesday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'TUESDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationWednesday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'WEDNESDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationThursday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'THURSDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationFriday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'FRIDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationSaturday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'SATURDAY\' | translate}}</span> <span ng-style="{\'font-weight\': program.programActivationSunday ? \'bold\' : \'normal\'}" style="margin-left: 10px;">{{\'SUNDAY\' | translate}}</span></div></div></div></div><div style="margin-top: 20px; border-top: 1px solid #ddd; padding-top: 10px;"><div style="padding: 0.5rem; margin-bottom: 10px;"><span style="font-size: var(--renaultLargeFont); font-weight: bold;">{{\'ASAP\' | translate}}</span></div><div style="margin: 10px;"><div style="margin-bottom: 10px;"><strong>{{\'REMOTE_CHARGE_SCHEDULING_REDESIGN\' | translate}}</strong></div><div><i class="fa fa-circle" ng-style="{\'color\': (vm.uid955Data && vm.uid955Data.status === \'ACTIVATED\') ? \'green\' : \'red\'}"></i> <span style="margin-left: 5px;">{{(vm.uid955Data && vm.uid955Data.status === \'ACTIVATED\') ? (\'CONNECTED_SERVICES_ACTIVATED_STATUS\' | translate) : (\'CONNECTED_SERVICES_DEACTIVATED_STATUS\' | translate)}}</span></div><div ng-if="vm.uid955Data && vm.uid955Data.updatedAt" style="color: #666; padding-left: 23px;">{{\'LAST_UPDATE\' | translate}} {{vm.uid955Data.updatedAt | rlinkformat:\'full-date\'}}</div></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false ng-if="vm.pnCTab || vm.v2GTab || vm.v2GTabNew"><accordion-group is-open=vm.tabOpen><accordion-heading><div class=evTabs><span ng-if=vm.pnCTab>{{\'P2C_HEADER\' | translate}}</span> <span ng-if=vm.v2GTab>{{\'V2G_HEADER\' | translate}}</span> <span ng-if=vm.v2GTabNew>V2G B2B without charger (partners without MyR) UID 976</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i> <i class="fa fa-info-circle" style=cursor:pointer; ng-click=vm.evServiceModal();$event.stopPropagation()></i></div></accordion-heading><div class=uidDetails><div class=boxContent><span ng-class="{\'eligible\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if=vm.serviceEligible><i class="fa fa-circle greenDisc"></i> {{\'SERVICE_ELIGIBLE\' | translate}} </span><span ng-class="{\'eligible\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if=!vm.serviceEligible><i class="fa fa-circle redDisc"></i> {{\'SERVICE_NONELIGIBLE\' | translate}} </span><span ng-if=!vm.pnCTab class=service><i class="fa fa-circle" ng-class="(vm.vcpsData === vm.bvaData && \n                                vm.vcpsData !== \'\' && vm.bvaData !== \'\') ? \n                                \'greenDisc\' : \'redDisc\'"></i> {{ (vm.vcpsData === vm.bvaData && vm.vcpsData !== \'\' && vm.bvaData !== \'\') ? \'SERVICE_PREREQUISITES_FULFILLED\' : \'SERVICE_PREREQUISITES_NOT_FULFILLED\' | translate }} </span><span ng-if=!vm.pnCTab class=service><i ng-if="vm.subscriptionStatus === \'SUBSCRIBED\'" class="fa fa-circle greenDisc"></i> <i ng-if="vm.subscriptionStatus === \'SUB_IN_PROGRESS\'" class="fa fa-circle orangeDisc"></i> <i ng-if="vm.subscriptionStatus === \'UNSUB_IN_PROGRESS\'" class="fa fa-circle lightRedDisc"></i> <i ng-if="vm.subscriptionStatus === \'UNSUBSCRIBED\'" class="fa fa-circle redDisc"></i> <i ng-if=!vm.subscriptionStatus class="fa fa-circle redDisc"></i> {{ vm.subscriptionStatus === \'SUBSCRIBED\' ? \'V2G_SERVICE_SUBSCRIBED\' : vm.subscriptionStatus === \'SUB_IN_PROGRESS\' ? \'V2G_SUB_IN_PROGRESS\' : vm.subscriptionStatus === \'UNSUB_IN_PROGRESS\' ? \'V2G_UNSUB_IN_PROGRESS\' : \'V2G_SERVICE_UNSUBSCRIBED\' | translate }} </span><span ng-class="{\'activated\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if="vm.serviceActivated && !vm.v2GTab"><i class="fa fa-circle greenDisc"></i> {{\'SERVICE_ACTIVATED\' | translate}} </span><span ng-class="{\'activated\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if="!vm.serviceActivated && !vm.v2GTab"><i class="fa fa-circle redDisc"></i> {{\'SERVICE_INACTIVATED\' | translate}} </span><span ng-class="{\'activated\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if="vm.serviceActivatedV2GTab && vm.v2GTab"><i class="fa fa-circle greenDisc"></i> {{\'SERVICE_ACTIVATED\' | translate}} </span><span ng-class="{\'activated\': vm.pnCTab, \'service\': !vm.pnCTab}" ng-if="!vm.serviceActivatedV2GTab && vm.v2GTab"><i class="fa fa-circle redDisc"></i> {{\'SERVICE_INACTIVATED\' | translate}} </span><span class=service ng-if=!vm.pnCTab><i ng-if="vm.readinessStatus === \'READY\'" class="fa fa-circle greenDisc"></i> <i ng-if="vm.readinessStatus === \'IN_PROGRESS\'" class="fa fa-circle orangeDisc"></i> <i ng-if="vm.readinessStatus === \'NOT_READY\'" class="fa fa-circle redDisc"></i> <i ng-if=!vm.readinessStatus class="fa fa-circle redDisc"></i> {{ vm.readinessStatus === \'READY\' ? \'V2G_READY\' : vm.readinessStatus === \'IN_PROGRESS\' ? \'V2G_IN_PROGRESS\' : \'V2G_NOT_READY\' | translate }}</span><div ng-if=vm.pnCTab class=pncTabDetails><span><i class="fa fa-info-circle"></i></span><p class=pncUidInfo>{{\'UID_INFO\' | translate}}</p></div><div ng-if=!vm.pnCTab class=smartInfo><span class=smartInfoDetails><i class="fa fa-info-circle uidMargin"></i> {{\'UID_INFO\' | translate}}</span></div></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false ng-if=vm.sCTab><accordion-group is-open=vm.tabOpen ng-style="vm.sCTab ? {\'width\': \'63rem\'} : {}"><accordion-heading><div class=evTabs><span ng-if=vm.sCTab>{{\'SMART_CHARGE\' | translate}}</span> <i class="fa fa-info-circle" style=cursor:pointer; ng-click=vm.evServiceModal()></i> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i></div></accordion-heading><div class="rlink-tip refreshIcon"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" ng-click="vm.restartService(\'smartCharge\')"></i></div><div class=smartChargeBox ng-style="vm.sCTab ? {\'width\': \'63rem\'} : {}"><span class=vehicle><i ng-if=vm.serviceEligible class="fa fa-circle greenDisc"></i> <i ng-if=!vm.serviceEligible class="fa fa-circle redDisc"></i> {{ vm.serviceEligible ? \'APPLICABLE_SERVICE\' : \'SERVICE_NONELIGIBLE\' | translate}} </span><span class=preRequest><i ng-if=vm.prerequisitesActivated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.prerequisitesActivated class="fa fa-circle redDisc"></i> {{ vm.prerequisitesActivated ? \'CONNECTED_SERVICE_PREREQUEST_ACTIVATED\' : \'CONNECTED_SERVICE_PREREQUEST_DEACTIVATED\' | translate }}<div ng-if=vm.sCTab class=deactivateText><span class=deactivateColor>{{ vm.deactivatedUidMessage }}</span></div></span><span class=subscribe><i ng-if=vm.serviceSubscribed class="fa fa-circle greenDisc"></i> <i ng-if=!vm.serviceSubscribed class="fa fa-circle redDisc"></i> {{ vm.serviceSubscribed ? \'SERVICE_SUBSCRIBED\' : \'SERVICE_NOT_SUBSCRIBED\' | translate}} </span><span class=service><i ng-if=vm.serviceActivated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.serviceActivated class="fa fa-circle redDisc"></i> {{ vm.serviceActivated ? \'SERVICE_ACTIVATED\' : \'SERVICE_INACTIVATED\' | translate}} </span><span class=delegated><i ng-if=vm.isDelegated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.isDelegated class="fa fa-circle redDisc"></i> {{ vm.isDelegated ? \'DELEGATED_MODE_ACTIVATED\' : \'DELEGATED_MODE_NOT_ACTIVATED\' | translate}} </span><span class=calendar><i ng-if=vm.calendarData.activated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.calendarData.activated class="fa fa-circle redDisc"></i> {{\'CALENDAR_SET\' | translate}}</span><div class=extraSpace></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false ng-if="!vm.sCTab && !vm.evSettings && (vm.serviceEligible || (vm.serviceActivated && vm.serviceEligible))"><accordion-group is-open=true><accordion-heading><div class=section_header style="cursor: default;"><span>MAPPING STATUS</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i></div></accordion-heading><div><div class="rlink-tip refreshIcon"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" ng-click="vm.restartService(\'mappingStatus\')"></i></div><table class=mapTable><tr><th>{{\'ALERTS_VIN\' | translate}}</th><th>{{\'CPL_SERIAL_NUM\' | translate}}</th><th ng-if=vm.pnCTab>{{\'PC_ID\' | translate}}</th><th ng-if="vm.v2GTab || vm.v2GTabNew">{{\'EVCC_ID\' | translate}}</th><th>{{\'DATE\' | translate}}</th><th><i class="fa fa-info-circle" style="padding-right: 0.5rem;cursor:pointer;" ng-click=vm.evServiceModal(true)></i>MAPPING STATUS</th></tr><tr ng-if=vm.mappingInfo><td><span ng-if=vm.mappingStatusDetails.vin>{{vm.mappingStatusDetails.vin}}</span><span ng-if=!vm.mappingStatusDetails.vin>-</span></td><td><span ng-if=vm.mappingInfo.serialNumber>{{vm.mappingInfo.serialNumber}}</span><span ng-if=!vm.mappingInfo.serialNumber>-</span></td><td ng-if=vm.pnCTab><span ng-if=vm.mappingInfo.pcid>{{vm.mappingInfo.pcid}}</span><span ng-if=!vm.mappingInfo.pcid>-</span></td><td ng-if="vm.v2GTab || vm.v2GTabNew"><span ng-if=vm.mappingInfo.evccid>{{vm.mappingInfo.evccid}}</span><span ng-if=!vm.mappingInfo.evccid>-</span></td><td><span ng-if=vm.mappingInfo.mappingDate>{{vm.formatDate(vm.mappingInfo.mappingDate|rlinkformat : \'full-date\')}}</span><span ng-if=!vm.mappingInfo.mappingDate>-</span></td><td style="padding-left: 2rem;"><span ng-if=vm.mappingStatus ng-style="{\'color\':vm.mappingStatus == \'OK\' ? \'green\' : \'red\'}">{{vm.mappingStatus}}</span><span ng-if=!vm.mappingStatus>-</span></td></tr></table></div></accordion-group></accordion><accordian class=block-accordion ng-if="(vm.pnCTab || vm.v2GTab || vm.v2GTabNew) && vm.serviceEligible"><div style="border: none !important;" class=block_body><div class=table_block_body><table style="border: none !important;margin-bottom:0px;    bottom: 3px;\n                position: relative;border-collapse: collapse;width: 100%;"><thead table-width><tr><th></th><th class=ddpHeader><span>{{vm.vcps}}</span></th><th class=ddpHeader><span>{{vm.bva}}</span></th><th class=ddpHeader><span>{{\'RLINKCAR_HU_STATUS\' | translate}}</span></th></tr></thead><tbody><tr><td class="table-padding-td ddpBody blackBorderSeperator"><span class=virtualBoldFont>{{\'CPL_SERIAL_NUM\' | translate}}</span></td><td class="table-padding-td ddpBody blackBorderSeperator"><span>{{vm.vcpsData | rlinkformat}}</span></td><td class="table-padding-td ddpBody blackBorderSeperator"><span>{{vm.bvaData | rlinkformat}}</span></td><td class="table-padding-td ddpBody blackBorderSeperator"><span><em ng-class="((vm.vcpsData == vm.bvaData) && vm.vcpsData != \'\' && vm.bvaData != \'\') ? \'fa fa-check blmStatusGreen\' : \'fa fa-close blmStatusRed\'"></em></span></td></tr></tbody></table></div></div></accordian><accordian style="float: right;" ng-if="(vm.pnCTab || vm.v2GTab || vm.v2GTabNew) && vm.serviceEligible"><div><span ng-hide="(vm.userType === \'ASOM\' && $root.asomDocList[\'CS\'])"><button ng-disabled="(vm.vcpsData === vm.bvaData && (vm.vcpsData != \'\' && vm.bvaData != \'\'))" class="cs-btn syncButton" ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.serviceSyncPopup()><div class=btnText>{{\'RLINK_SYNCHRONIZE_SERIAL_NUMBER\' | translate}}</div></button></span></div></accordian><br><br><accordion class="collapse section_wrapper" close-others=false ng-if="!vm.sCTab && !vm.evSettings && (vm.serviceEligible || (vm.serviceActivated && vm.serviceEligible))"><accordion-group is-open=true><accordion-heading><div class=section_header style="cursor: default;"><span ng-if=vm.pnCTab>PLUG AND CHARGE ON-BOARD CERTIFICATES</span> <span ng-if="vm.v2GTab || vm.v2GTabNew">V2G ON-BOARD CERTIFICATES</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i></div></accordion-heading><div><div><div style="border-bottom: 2px solid black; padding: 1rem;"><span style="font-size: var(--renaultLargeFont);">{{\'AVAILABILITY_INSTALLATION\' | translate}}</span></div><table class=certTable><tr style=font-size:var(--renaultMediumFont)><th ng-if=vm.pnCTab style=padding-bottom:1rem;>OEM Provisioning Certificate</th><th ng-if="vm.v2GTab || vm.v2GTabNew" style=padding-bottom:1rem;>Vehicle Certificate</th><div class=rlink-tip style="left: 95%;top: 1rem;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" ng-click="vm.restartService(\'certificate\')"></i></div></tr><tr><th>{{ \'EV_OFFBOARD_INSTALL\' | translate }}</th></tr><tr><td><i ng-if="vm.oemDetails.status==\'PROVISIONED\' || vm.oemDetails.status==\'INSTALLED\' " class="fa fa-circle statusSuccess"></i> <i ng-if="vm.oemDetails.status && vm.oemDetails.status!=\'PROVISIONED\' && vm.oemDetails.status !=\'INSTALLED\'" class="fa fa-circle statusError"></i> <span ng-if=vm.oemDetails.status>{{vm.oemDetails.status}}</span> <span ng-if=!vm.oemDetails.status>-</span><div ng-if=vm.pnCTab ng-hide="(vm.userType === \'ASOM\' && $root.asomDocList[\'CS\'])" style="margin-top: 10px;"><div class=changeVehicle><button class=btnChangerVehicle ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click="vm.launchInstallation(\'OEM_PROVISIONING\')" ng-style="{\'background-color\': vm.isPncLaunchEnabled ? \'\' : \'#ccc\'}" ng-disabled=!vm.isPncLaunchEnabled><div class=iconDiv><img src=./assets/images/launchInstallation.png alt="Repair Car Icon" style="max-width: 1.8rem; margin-bottom: 0.2rem; opacity: 0.7;"></div><div class=btnText style="padding-left: 0;">{{ \'LAUNCH_INSTALLATION\' | translate }}</div></button><div ng-if=vm.isActionNotPossible style="margin-top: 5px;"><span style="color: red;">{{ \'ACTION_NOT_POSSIBLE\' | translate }}</span></div></div></div><div ng-if="vm.v2GTab || vm.v2GTabNew" ng-hide="(vm.userType === \'ASOM\' && $root.asomDocList[\'CS\'])" style="margin-top: 10px;"><div class=changeVehicle><button class=btnChangerVehicle ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click="vm.launchInstallation(\'VEHICLE_CERTIFICATE\')" ng-style="{\'background-color\': vm.isV2gLaunchEnabled ? \'\' : \'#ccc\'}" ng-disabled=!vm.isV2gLaunchEnabled><div class=iconDiv><img src=./assets/images/launchInstallation.png alt="Repair Car Icon" style="max-width: 1.8rem; margin-bottom: 0.2rem; opacity: 0.7;"></div><div class=btnText style="padding-left: 0;">{{ \'LAUNCH_INSTALLATION\' | translate }}</div></button><div ng-if=vm.isActionNotPossible style="margin-top: 5px;"><span style="color: red;">{{ \'ACTION_NOT_POSSIBLE\' | translate }}</span></div></div></div></td></tr><tr ng-if=vm.pnCTab><th><span style="font-size: var(--renaultMediumFont);padding-top: 1rem;padding-bottom: 1rem;">Contract eMSP Certificate</span></th><td><span ng-if="!vm.serviceActivated && vm.serviceEligible" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}">{{\'EV_NOT_SUBSCRIBED\' | translate}}</span></td></tr><tr ng-if=vm.pnCTab><th>{{ \'EV_OFFBOARD_INSTALL\' | translate }}</th></tr><tr ng-if=vm.pnCTab><td><i ng-if="vm.contractDetails.status == \'PROVISIONED\' || vm.contractDetails.status == \'INSTALLED\'" class="fa fa-circle statusSuccess"></i> <i ng-if="vm.contractDetails.status && \n                                     vm.contractDetails.status != \'PROVISIONED\' && \n                                     vm.contractDetails.status != \'INSTALLED\'" class="fa fa-circle statusError"></i> <span ng-if=vm.contractDetails.status>{{vm.contractDetails.status}}</span> <span ng-if=!vm.contractDetails.status>-</span></td></tr></table></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false ng-if="vm.sCTab && vm.serviceSubscribed"><accordion-group is-open=true><accordion-heading><div class=section_header style="cursor: default;"><span>{{\'CONTRACTS_AND_SERVICES\' | translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}"></i></div></accordion-heading><div><table class=contractTable><tr><th><span>{{vm.contractToDisplay.name}}</span></th><td></td><td></td><td></td><th><span ng-style="{\'color\': vm.contractToDisplay.status === \'ACTIVE\' ? \'lightgreen\' : \'red\'}"><i class="fa fa-circle"></i> {{vm.contractToDisplay.status}}</span></th><div class=rlink-tip style="left: 95%;top: 1rem;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" ng-click="vm.restartService(\'contracts\')"></i></div></tr><tr><th>{{\'SUBSCRIPTION_START_DATE\' | translate}}</th><th>{{\'ACTIVATION_DATE\' | translate}}</th><th>{{\'END_OF_SUBSCRIPTION_DATE\' | translate}}</th><th ng-style="vm.language === \'en\' ? {\'position\': \'relative\', \'top\': \'7px\'} : {}">{{\'SYNCHRONIZATION_STATUS\' | translate}} <span class=rlink-tip ng-style="vm.language === \'en\' ? {\'display\':\'inline-flex\', \'align-items\':\'center\', \'margin-left\':\'97%\', \'cursor\':\'pointer\', \'top\':\'-16px\'} : {}"><i class="fa fa-info-circle"></i> <span class=rlink-tip-txt>{{ \'SMART_CHARGE_SYNCHRONIZATION_STATUS_TOOL_TIP\' | translate }}</span></span></th><th>{{\'SUBSCRIPTION_CHANNEL\' | translate}}</th></tr><tr><td colspan=2>{{ vm.contractToDisplay.subscriptionDatetime || \'-\'| rlinkformat:\'date\' }}</td><td colspan=2>{{ vm.contractToDisplay.activationDatetime || \'-\'| rlinkformat:\'date\' }}</td><td colspan=2>{{ vm.contractToDisplay.expirationDatetime || \'-\'| rlinkformat:\'date\' }}</td><td colspan=2><i class=fa ng-class="{\n                                       \'fa-check-circle-o\': vm.contractToDisplay.synchronisationStatus === \'OK\',\n                                       \'fa-times-circle-o\': vm.contractToDisplay.synchronisationStatus === \'UNKNOWN\' || vm.contractToDisplay.synchronisationStatus === \'NOK\'\n                                   }" aria-hidden=true ng-style="{\n                                       \'color\': vm.contractToDisplay.synchronisationStatus === \'OK\' ? \'green\' : (vm.contractToDisplay.synchronisationStatus === \'UNKNOWN\' || vm.contractToDisplay.synchronisationStatus === \'NOK\' ? \'red\' : \'\')\n                                   }"></i> <span ng-if=!vm.contractToDisplay.synchronisationStatus>-</span></td><td>{{ vm.contractToDisplay.subscriptionChannel || \'-\' }}</td><td><i class=fa style="cursor: pointer;" ng-class="{\'fa-caret-down\': !vm.packOfServicesVisible, \'fa-caret-up\': vm.packOfServicesVisible}" aria-hidden=true ng-click=vm.togglePackOfServices()></i></td></tr><tr ng-show=vm.packOfServicesVisible><th>{{\'PACK_OF_SERVICES\' | translate}}</th><th>{{\'SERVICE_ID\' | translate}}</th><th>{{\'SERVICE_STATUS\' | translate}}</th><th>{{\'LAST_UPDATE\' | translate}}</th></tr><tr ng-show=vm.packOfServicesVisible><td>{{ vm.servicePackToDisplay.name || \'-\' }}</td><td>{{ vm.servicePackToDisplay.sid || \'-\' }}</td><td><i class="fa fa-check-circle-o" aria-hidden=true style="color: green;" ng-if="vm.servicePackToDisplay.activationStatus === \'ACTIVATED\'"></i> {{vm.servicePackToDisplay.activationStatus || \'-\'}}</td><td>{{vm.servicePackToDisplay.updatedAt ? vm.formatDate(vm.servicePackToDisplay.updatedAt) : \'-\'}}</td></tr></table></div></accordion-group></accordion><accordion class="collapse section_wrapper" ng-if="vm.sCTab && vm.serviceActivated"><accordion-group is-open=true><accordion-heading><div class=section_header style="cursor: default;"><span>{{\'EV_MANAGER\' | translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}"></i></div></accordion-heading><div><div class="rlink-tip refreshIcon"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}" ng-click="vm.restartService(\'evManager\')"></i></div><table class=managerTable1><tr><th style="display: flex; width: 114px;"><span>{{\'SOC_TARGET\' | translate}}</span> <span class=rlink-tip ng-if=!vm.isDeleg style="position: relative;left: 4px;cursor: pointer;"><i class="fa fa-info-circle"></i> <span class=rlink-tip-txt>{{ \'DELEGATION_MUST_BE_ACTIVATED\' | translate }}</span></span></th><th style="position: relative;left: 4px;width: 30%;">{{\'DELEGATED_MODE\' | translate}}</th><th></th><th></th></tr><tr style="position: relative; top: -12px;"><th style="font-weight: normal;">{{vm.socTarget? vm.socTarget :\'-\' }}</th><th style="font-weight: normal;"><span><i class="fa fa-circle" ng-class="vm.isDelegated ? \'greenDisc\' : \'redDisc\'" style="right: 0rem;"></i> {{vm.isDelegated? \'CONNECTED_SERVICES_ACTIVATED_STATUS\':\'RLINKCAR_STATUS_DEACTIVATED\' | translate}}</span></th><th></th><th></th></tr><tr style="position: relative; bottom: 9px;"><th><span style="font-size: x-small">{{\'RLINKCAR_MENU_LAST_TIME\' | translate}}</span></th><th style="font-size: x-small;position: relative;right: 27%;font-weight: normal;">{{vm.socTimeStamp? vm.socTimeStamp : \'-\' | rlinkformat : \'full-date\'}}</th></tr></table><div style="display: flex; padding-bottom: 20px;"><div class=calDiv><i class="fa fa-calendar cal" aria-hidden=true></i> <span class=calSpan>{{\'CALENDAR\' | translate}}</span></div><table class=managerTable2><tr><th>{{ \'CALENDAR_STATUS\' | translate }}</th><th ng-style="{\'font-weight\': \'normal\', \'position\': \'relative\', \'right\': vm.language === \'fr\' ? \'-2%\' : \'0%\'}"><i class="fa fa-circle" ng-class="vm.calendarData.activated ? \'greenDisc\' : \'redDisc\'" style="right: 0rem;"></i> {{ vm.calendarData.activated ? \'CONNECTED_SERVICES_ACTIVATED_STATUS\' : \'RLINKCAR_STATUS_DEACTIVATED\' | translate }} <span class=rlink-tip ng-if=!vm.isDeleg style="position: relative;left: 4px;cursor: pointer;"><i class="fa fa-info-circle"></i> <span class=rlink-tip-txt>{{ \'DELEGATION_MUST_BE_ACTIVATED\' | translate }}</span></span></th><th>{{ \'CHARGE_START_TIME\' | translate }}</th><th ng-style="{\'position\': \'relative\',\'font-weight\':\'normal\',\'right\': vm.language === \'fr\' ? \'-7%\' : \'0%\'}">{{ vm.calendarData.chargeTimeStart ? vm.calendarData.chargeTimeStart.replace(\'T\', \'\').replace(\'Z\', \'\') : \'-\' }}</th><th>{{ \'CHARGE_DURATION\' | translate }}</th><th ng-style="{\'position\': \'relative\',\'font-weight\':\'normal\',\'right\': vm.language === \'fr\' ? \'-1%\' : \'0%\'}">{{ vm.processedChargeDuration }}</th></tr><tr style="position: relative;bottom: 9px;"><th><span style="font-size: x-small;">{{ \'RLINKCAR_MENU_LAST_TIME\' | translate }}</span></th><th style="font-size: x-small;position: relative;font-weight: normal;">{{ vm.calendarData.lastSettingsUpdateTimestamp ? vm.calendarData.lastSettingsUpdateTimestamp : \'-\' | rlinkformat : \'full-date\'}}</th><th><span style="font-size: x-small;">{{ \'RLINKCAR_MENU_LAST_TIME\' | translate }}</span></th><th ng-style="{ \'font-size\': \'x-small\',\'position\': \'relative\',\'font-weight\':\'normal\',\'right\': vm.language === \'fr\' ? \'-1%\' : \'0%\'}">{{ vm.calendarData.lastSettingsUpdateTimestamp ? vm.calendarData.lastSettingsUpdateTimestamp : \'-\'| rlinkformat : \'full-date\' }}</th><th><span style="font-size: x-small;">{{ \'RLINKCAR_MENU_LAST_TIME\' | translate }}</span></th><th ng-style="{ \'font-size\': \'x-small\',\'position\': \'relative\',\'font-weight\':\'normal\',\'right\': vm.language === \'fr\' ? \'-1%\' : \'0%\'}">{{ vm.calendarData.lastSettingsUpdateTimestamp ? vm.calendarData.lastSettingsUpdateTimestamp : \'-\' | rlinkformat : \'full-date\'}}</th></tr><tr style="position: relative;top: 11px;"><th colspan=1>{{ \'CALENDAR_SETTINGS\' | translate }}</th><th colspan=4><div class=calendar-day-container ng-style="vm.language === \'fr\' ? {\'right\': \'-4%\'} : {}"><span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationMonday}">{{ \'MONDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationTuesday}">{{ \'TUESDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationWednesday}">{{ \'WEDNESDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationThursday}">{{ \'THURSDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationFriday}">{{ \'FRIDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationSaturday}">{{ \'SATURDAY\' | translate }}</span> <span class=calendar-day ng-class="{\'font-bold\': vm.calendarData.activationSunday}">{{ \'SUNDAY\' | translate }}</span></div></th></tr><tr style="line-height: 0.8;"><th><span style="font-size: x-small;">{{ \'RLINKCAR_MENU_LAST_TIME\' | translate }}</span></th><th ng-style="{ \'font-size\': \'x-small\',\'position\': \'relative\',\'font-weight\':\'normal\',\'right\': vm.language === \'fr\' ? \'27px\' : \'29px\'}">{{ vm.calendarData.lastSettingsUpdateTimestamp ? vm.calendarData.lastSettingsUpdateTimestamp : \'-\' | rlinkformat : \'full-date\'}}</th></tr></table></div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/hereNavigation/hereNavigation.template.html','<div id=hereNavigationView><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class="evTabs hn-section-header"><span>{{\'HERE_NAVIGATION_NAVASAPP\'|translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" class=hn-section-chevron></i></div></accordion-heading><div class="uidDetails hn-panel-box"><div class="boxContent hn-service-grid"><span class="service hn-service-item"><i class="fa fa-circle hn-status-dot" ng-if=vm.serviceApplicable ng-class="{\'hn-status-dot--green\': vm.serviceApplicable, \'hn-status-dot--red\': !vm.serviceApplicable}"></i> {{\'SERVICE_ELIGIBLE\'|translate}} </span><span class="service hn-service-item"><i class="fa fa-circle hn-status-dot" ng-class="{\'hn-status-dot--green\': vm.isHerePlatformGreen(), \n                        \'hn-status-dot--red\': !vm.isHerePlatformGreen()}"></i> {{vm.getHerePlatformLabel()}} </span><span class="service hn-service-item"><i class="fa fa-circle hn-status-dot" ng-class="\'hn-status-dot--\' + vm.getHereSubscriptionColor()"></i> {{vm.getHereSubscriptionLabel()}} </span><span class="service hn-service-item"><i class="fa fa-circle hn-status-dot" ng-class="\'hn-status-dot--\' + vm.getHereActivationColor()"></i> {{vm.getHereActivationLabel()}}</span></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class="evTabs hn-section-header"><span>{{\'HERE_PLATFORM_DETAILS\'|translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" class=hn-section-chevron></i></div></accordion-heading><div class=hn-table-box><table class=hn-table><thead><tr class=hn-table-header-row><th class=hn-table-header-cell>{{\'VIN_STATE\'|translate}}</th><th class=hn-table-header-cell>{{\'HERE_ID\'|translate}}</th><th class=hn-table-header-cell>{{\'CREATION_DATE\'|translate}}</th><th class=hn-table-header-cell>{{\'EASYLINK_ADAS_LAST_CONNECTION_DATE\'|translate}}</th></tr></thead><tbody><tr class=hn-table-data-row><td class="hn-table-data-cell hn-break-word">{{vm.herePlatformRow.vinState || \'-\'}}</td><td class="hn-table-data-cell hn-break-word">{{vm.herePlatformRow.hereId || \'-\'}}</td><td class="hn-table-data-cell hn-break-word">{{vm.herePlatformRow.creationDate | rlinkformat:\'full-date\' || \'-\'}}</td><td class="hn-table-data-cell hn-break-word">{{vm.hereSubscriptionRow.lastConnectionDate | rlinkformat:\'full-date\' || \'-\'}}</td></tr></tbody></table></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class="evTabs hn-section-header"><span>{{\'HERE_SUBSCRIPTION_DETAILS\'|translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" class=hn-section-chevron></i></div></accordion-heading><div class=hn-table-box><table class=hn-table><thead><tr class=hn-table-header-row><th class=hn-table-header-cell>{{\'SUBSCRIPTION_ID\'|translate}}</th><th class="hn-table-header-cell stateWidth">{{\'STATE\'|translate}}</th><th class=hn-table-header-cell>{{\'CONTRACT_DURATION\'|translate}}</th><th class=hn-table-header-cell>{{\'CONNECTED_SERVICES_START_DATE\'|translate}}</th><th class=hn-table-header-cell>{{\'EXPIRATION_DATE\'|translate}}</th></tr></thead><tbody><tr class=hn-table-data-row><td class=hn-table-data-cell>{{vm.hereSubscriptionRow.subscriptionId || \'-\'}}</td><td class="hn-table-data-cell stateWidth">{{vm.hereSubscriptionRow.state || \'-\'}}</td><td class=hn-table-data-cell>{{vm.hereSubscriptionRow.contractDuration || \'-\'}}</td><td class=hn-table-data-cell>{{vm.hereSubscriptionRow.startDate | rlinkformat:\'full-date\' || \'-\'}}</td><td class=hn-table-data-cell>{{vm.hereSubscriptionRow.expirationDate | rlinkformat:\'full-date\' || \'-\'}}</td></tr></tbody></table></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div class="evTabs hn-section-header"><span>{{\'HERE_NAVIGATION_UIDS\'|translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" class=hn-section-chevron></i></div></accordion-heading><div class=hn-uids-box><div class=hn-uids-grid><div ng-repeat="uid in vm.hereNavigationUIDs" class=hn-uids-item><div class=hn-uids-title>{{uid.label}}</div><div class=hn-uids-status-row><i class="fa fa-circle hn-status-dot hn-status-dot--small" ng-class="\'hn-status-dot--\' + uid.color"></i> <span>{{uid.status}}</span></div><div class=hn-uids-last-update>{{\'LAST_STATUS_UPDATE\'|translate}} : <span ng-if="uid.isActive && uid.lastStatusUpdate && uid.lastStatusUpdate !== \'-\'">{{uid.lastStatusUpdate | rlinkformat:\'full-date\'}}</span> <span ng-if="!uid.isActive || !uid.lastStatusUpdate || uid.lastStatusUpdate === \'-\'">-</span></div></div></div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/restartingServices/restartingServices.template.html','<div id=restartingServicesPopup ng-style="{\'height\': vm.display ? \'auto\' : \'32rem\'}"><div><div class=headerPadding><span ng-if=!vm.isBatteryCrash><span ng-if=vm.display><img src=./assets/images/restarting-services.svg class=restartServiceIcon alt=""> <span ng-class="{\'nissanLineSeparator\': vm.nissanUserURL, \'renaultLineSeparator\': !vm.nissanUserURL}">|</span> <span class=headerText><strong>{{\'RESTARTING_STD_OFFERS_SERVICES\' | translate}}</strong></span> </span><span ng-if=!vm.display><img src=./assets/images/print-vegas.png class=restartServiceIcon alt=""> <span ng-class="{\'nissanLineSeparator\': vm.nissanUserURL, \'renaultLineSeparator\': !vm.nissanUserURL}">|</span> <span class=headerText><strong>{{\'PRINT_SERVICES\' | translate}}</strong></span> </span></span><span ng-if=vm.isBatteryCrash><img src=./assets/images/restarting-services.svg class=restartServiceIcon alt=""> <span ng-class="{\'nissanLineSeparator\': vm.nissanUserURL, \'renaultLineSeparator\': !vm.nissanUserURL}">|</span> <span class=headerText><strong ng-if="vm.printConsent == \'print\'">{{\'LABEL_BATTERY_INTEGRITY\' | translate}}</strong> <strong ng-if="vm.printConsent == \'consent\'">{{\'LABEL_PRINT_CONSENT\' | translate}}</strong> </span></span><span class=closeIcon ng-click=vm.close()><i class=icon-icons_close></i></span></div><div class="flex sub_items_header grid--no-gutter small-12 columns" ng-if=!vm.isBatteryCrash><span class="small-3 columns"></span> <span class="small-3 columns left4">{{\'ALERTS_VIN\' | translate | uppercase}}<span style="color: red;"> *</span></span> <span class="small-6 columns left4">{{\'RESTART_LOGO\' | translate}}<span style="color: red;"> *</span></span></div><div class="flex sub_items_header grid--no-gutter small-12 columns" ng-if=!vm.isBatteryCrash><span class="small-3 columns"></span> <span class="small-3 columns"><md-input-container><input id=vin aria-label=vin type=text name=vin required ng-model=vm.vin ng-click=vm.getVin(vm.vin) maxlength=17 ng-focus="vm.removeTextAreaColors(\'vin\')" class=noMarginBottom tabindex=1></md-input-container><div ng-if=vm.vin ng-click="vm.vin = null"><md-button class="btn right25" tabindex=2>X</md-button></div></span><span class="small-6 columns" ng-if=!vm.isBatteryCrash><div><md-radio-group ng-model=vm.logoClicked style="display: inline-flex;" id=logoClicked ng-class=vm.radioButtonChange(vm.logoClicked)><md-radio-button value=Renault style="margin-left: 11px;" tabindex=4><span style="display: flex;"><img src=./assets/svg/renault.svg style="width: 40px;height: 40px; position: relative;" alt=""> <label style="margin-top: 10px;">{{"RENAULT_LOGO" | translate}}</label></span></md-radio-button><md-radio-button value=Dacia style="margin-left: 25px;" tabindex=5><span style="display: flex;"><img src=./assets/svg/dacia.svg style="width: 40px;height: 40px;right: 2px;position: relative;" alt=""> <label style="margin-top: 10px;">{{"DACIA_LOGO" | translate}}</label></span></md-radio-button><md-radio-button value=Alpine style="margin-left: 25px;" tabindex=6><span style="display: flex;"><img src=./assets/svg/alpine.svg style="width: 40px;height: 40px;right: 3px;position: relative;" alt=""> <label style="margin-top: 10px;">{{"ALPINE_LOGO" | translate}}</label></span></md-radio-button></md-radio-group></div></span></div><div ng-if=vm.isBatteryCrash><div class="flex sub_items_header grid--no-gutter small-12 columns left3"><span class="small-3 columns left2">{{\'ACTIS_VEHICLE_VIN\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns">{{\'ACTIS_VEHICLE_BIN\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns left1">{{\'ACTIS_VEHICLE_IMMAT\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns left-1">{{\'REPAIR_ORDER\' | translate}}<span style="color: red;"> *</span></span></div><div class="flex sub_items_content grid--no-gutter small-12 columns left3"><span class="small-3 columns left2"><md-input-container><input type=text aria-label=vin id=vin ng-model=vm.vin name=vin required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'vehicleVin\')" class=noMarginBottom tabindex=7></md-input-container><div ng-if=vm.vin ng-click="vm.vin = null"><md-button class="btn right18" tabindex=8>X</md-button></div></span><span class="small-3 columns"><md-input-container><input type=text aria-label=vehicleBin id=vehicleBin ng-model=vm.bin name=vehicleBin required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'vehicleBin\')" class=noMarginBottom tabindex=9></md-input-container><div ng-if=vm.bin ng-click="vm.bin = null"><md-button class="btn right18" tabindex=10>X</md-button></div></span><span class="small-3 columns left1"><md-input-container><input type=text aria-label=vehicleImat id=vehicleImat name=vehicleImat ng-model=vm.vehicleImat required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'vehicleImat\')" class=noMarginBottom tabindex=11></md-input-container><div ng-if=vm.vehicleImat ng-click="vm.vehicleImat = null"><md-button class="btn right18" tabindex=12>X</md-button></div></span><span class="small-3 columns right1"><md-input-container><input type=text aria-label=vehicleRO id=vehicleRO ng-model=vm.vehicleRO name=vehicleRO required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'vehicleRO\')" class=noMarginBottom tabindex=13></md-input-container><div ng-if=vm.vehicleRO ng-click="vm.vehicleRO = null"><md-button class="btn right18" tabindex=14>X</md-button></div></span></div></div><div><div class="flex sub_items_content grid--no-gutter small-12 columns grayBorderSeperator"><span class="small-12 columns"><strong>{{\'RESTART_SERVICES_DEALER\' | translate | uppercase}}</strong></span></div><div class="flex sub_items_header grid--no-gutter small-12 columns left3"><span class="small-3 columns left2">{{\'RESTART_SERVICES_DEALERSHIP_NAME\' | translate}}<span style="color: red;"> *</span></span> <span class="small-2 columns">{{\'RESTART_SERVICES_DEALER_ID\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns left1">{{\'RESTART_SERVICES_DEALER_ADDRESS\' | translate}}<span style="color: red;"> *</span></span> <span class="small-2 columns right1">{{\'RESTART_SERVICES_ZIP_CODE\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns">{{\'RESTART_SERVICES_CITY\' | translate}}<span style="color: red;"> *</span></span></div><div class="flex sub_items_content grid--no-gutter small-12 columns left3"><span class="small-3 columns left2"><md-input-container><input type=text aria-label=dealerShipName id=dealerShipName ng-model=vm.dealerName name=dealerShipName required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'dealerShipName\')" class=noMarginBottom tabindex=15></md-input-container><div ng-if=vm.dealerName ng-click="vm.dealerName = null"><md-button class="btn right18" tabindex=16>X</md-button></div></span><span class="small-2 columns"><md-input-container><input type=text aria-label=dealerId id=dealerId ng-model=vm.dealerId name=dealerId required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'dealerId\')" class=noMarginBottom tabindex=17></md-input-container><div ng-if=vm.dealerId ng-click="vm.dealerId = null"><md-button class="btn right5" tabindex=18>X</md-button></div></span><span class="small-3 columns left1"><md-input-container><input type=text aria-label=dealerAddress id=dealerAddress name=dealerAddress ng-model=vm.dealerAddress required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'dealerAddress\')" class=noMarginBottom tabindex=19></md-input-container><div ng-if=vm.dealerAddress ng-click="vm.dealerAddress = null"><md-button class="btn right18" tabindex=20>X</md-button></div></span><span class="small-2 columns right1"><md-input-container><input type=text aria-label=dealerZipCode id=dealerZipCode ng-model=vm.dealerZipCode name=dealerZipCode required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'dealerZipCode\')" class=noMarginBottom tabindex=21></md-input-container><div ng-if=vm.dealerZipCode ng-click="vm.dealerZipCode = null"><md-button class="btn right5" tabindex=22>X</md-button></div></span><span class="small-3 columns"><md-input-container><input type=text aria-label=dealerCity id=dealerCity name=dealerCity ng-model=vm.dealerCity required style=height:2rem; class=noMarginBottom ng-focus="vm.removeTextAreaColors(\'dealerCity\')" tabindex=23></md-input-container><div ng-if=vm.dealerCity ng-click="vm.dealerCity = null"><md-button class="btn right18" tabindex=24>X</md-button></div></span></div></div><div class="flex sub_items_content grid--no-gutter small-12 columns grayBorderSeperator"><span class="small-12 columns"><strong>{{\'RESTART_SERVICES_CUSTOMER\' | translate | uppercase}}</strong></span></div><div class="flex sub_items_header grid--no-gutter small-12 columns left3"><span class="small-3 columns left2">{{\'ALERTS_FIRSTNAME\' | translate}}<span style="color: red;"> *</span></span> <span class="small-2 columns">{{\'ALERTS_LASTNAME\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns left1">{{\'RESTART_SERVICES_DEALER_ADDRESS\' | translate}}<span style="color: red;"> *</span></span> <span class="small-2 columns right1">{{\'RESTART_SERVICES_ZIP_CODE\' | translate}}<span style="color: red;"> *</span></span> <span class="small-3 columns">{{\'RESTART_SERVICES_CITY\' | translate}}<span style="color: red;"> *</span></span></div><div class="flex sub_items_content grid--no-gutter small-12 columns left3"><span class="small-3 columns left2"><md-input-container><input type=text aria-label=custFirstName id=custFirstName ng-model=vm.custFirstName name=custFirstName required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'custFirstName\')" tabindex=25></md-input-container><div ng-if=vm.custFirstName ng-click="vm.custFirstName = null"><md-button class="btn right18" tabindex=26>X</md-button></div></span><span class="small-2 columns"><md-input-container><input type=text aria-label=custLastName id=custLastName ng-model=vm.custLastName name=custLastName required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'custLastName\')" tabindex=27></md-input-container><div ng-if=vm.custLastName ng-click="vm.custLastName = null"><md-button class="btn right5" tabindex=28>X</md-button></div></span><span class="small-3 columns left1"><md-input-container><input type=text aria-label=custAddress id=custAddress ng-model=vm.customerAddress name=custAddress required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'custAddress\')" tabindex=29></md-input-container><div ng-if=vm.customerAddress ng-click="vm.customerAddress = null"><md-button class="btn right18" tabindex=30>X</md-button></div></span><span class="small-2 columns right1"><md-input-container><input type=text aria-label=custZipCode id=custZipCode ng-model=vm.custZipCode name=custZipCode required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'custZipCode\')" tabindex=31></md-input-container><div ng-if=vm.custZipCode ng-click="vm.custZipCode = null"><md-button class="btn right5" tabindex=32>X</md-button></div></span><span class="small-3 columns"><md-input-container><input type=text aria-label=custCity id=custCity ng-model=vm.custCity name=custCity required style=height:2rem; ng-focus="vm.removeTextAreaColors(\'custCity\')" tabindex=33></md-input-container><div ng-if=vm.custCity ng-click="vm.custCity = null"><md-button class="btn right18" tabindex=34>X</md-button></div></span></div><div ng-if="vm.display || vm.isBatteryCrash" class="flex sub_items_content grid--no-gutter small-5 columns grayBorderSeperator"><!--Changes to keep for CNR - Start date must correspond to the customer delivery date (RESTART_SERVICES_CUSTOMER_START_DATE -> VEHICLE_DELIVERY_DATE)--> <span class="small-12 columns"><strong>{{\'RESTART_SERVICES_CUSTOMER_START_DATE\' | translate | uppercase}}</strong></span></div><div ng-if="vm.display || vm.isBatteryCrash" class="flex sub_items_header grid--no-gutter small-12 columns left3"><span class="small-3 columns left2"><span ng-if=vm.isBatteryCrash>{{\'DATE\' | translate}}</span><!--Changes to keep for CNR - Start date must correspond to the customer delivery date (RESTART_SERVICES_CUSTOMER_START_DATE -> VEHICLE_DELIVERY_DATE)--> <span ng-if=vm.display>{{\'ENTER_VEHICLE_DELIVERY_DATE\' | translate}}</span> <span style="color: red;">*</span> </span><span class="small-3 columns"><span ng-if="vm.isBatteryCrash && vm.printConsent != \'consent\'">{{\'LABEL_BATTERY_STATUS\' | translate}}</span></span> <span class="small-3 columns"></span> <span class="small-3 columns"></span></div><div class="flex sub_items_content grid--no-gutter small-12 columns left3"><span ng-if=vm.display class="small-3 columns left2"><!--Changes to keep for CNR - Start date must correspond to the customer delivery date--><!-- <md-input-container ng-if="!vm.contextCarRequest.bvmExtraFields.customerDeliveryDate" class="dateOr">\n                    <md-datepicker type="date" id="startDate" md-min-date="vm.minDate" md-max-date="vm.maxDate" required\n                        ng-model="vm.startDate" ng-value="vm.startDate" name="startDate" md-current-view="day"\n                        md-placeholder="DD-MM-YYYY"></md-datepicker>\n                </md-input-container>\n                <input readonly ng-if="vm.contextCarRequest.bvmExtraFields.customerDeliveryDate" type="text" id="startDate" ng-value="vm.startDate" ng-model="vm.startDate" name="startDate" md-placeholder="DD-MM-YYYY"> --><md-input-container class=dateOr><md-datepicker type=date id=startDate md-min-date=vm.minDate md-max-date=vm.maxDate required ng-model=vm.startDate ng-value=vm.startDate name=startDate md-current-view=day md-placeholder=DD-MM-YYYY></md-datepicker></md-input-container></span><span ng-if=vm.isBatteryCrash class="small-3 columns left2"><md-input-container class=dateOr><md-datepicker type=date id=startDateBattery required ng-model=vm.startDateBattery ng-value=vm.startDateBattery name=startDateBattery md-current-view=day md-placeholder=DD-MM-YYYY></md-datepicker></md-input-container></span><span class="small-3 columns"><md-radio-group ng-model=vm.statusClicked style="display: inline-flex; padding-top: 10px;" id=statusClicked ng-class=vm.batteryStatusChange(vm.statusClicked) ng-if="vm.isBatteryCrash && vm.printConsent != \'consent\'"><md-radio-button value=OK style="margin-left: 11px;"><span style="display: flex; align-items: center;"><label style="margin: 0 0 0 8px; font-weight: bold; color: green; font-size: var(--renaultLargeFont); line-height: 1;">OK</label></span></md-radio-button><md-radio-button value=KO style="margin-left: 25px;"><span style="display: flex; align-items: center;"></span> <label style="margin: 0 0 0 8px; font-weight: bold; color: red; font-size: var(--renaultLargeFont); line-height: 1;">KO</label></md-radio-button></md-radio-group></span><span class="small-3 columns" style="margin-top: -10px;"><button type=button ng-class="{\'buttonWithIcon save\': vm.display && !vm.nissanUserURL, \'buttonWithIcon ccsAlignPrint\': !vm.display && !vm.nissanUserURL, \'nissanBtnWithIcon save\': vm.display && vm.nissanUserURL, \'nissanBtnWithIcon ccsAlignPrint\': !vm.display && vm.nissanUserURL}" ng-click=vm.onValidate(vm.vin,vm.display)><div class=iconDiv><i class=icon-icons_print_panier></i></div><div ng-if=vm.display class=btnText>{{\'RESTART_SERVICES_SAVE_PRINT\' | translate}}</div><div ng-if="!vm.display || vm.isBatteryCrash" class=btnText>{{\'BUTTON_ESTIMATE_PRINT\' | translate}}</div></button> </span><span class="small-3 columns" style="margin-top: -10px;"><button type=button ng-class="{\'buttonWithIcon close cancel\': vm.display && !vm.nissanUserURL, \'buttonWithIcon cancel ccsAlignClose\': !vm.display && !vm.nissanUserURL, \'nissanBtnWithIcon save\': vm.display && vm.nissanUserURL, \'nissanBtnWithIcon ccsAlignPrint\': !vm.display && vm.nissanUserURL}" ng-click=vm.close()><div class=iconDiv><i class="icon-icons_close icon-icons_close_restartService"></i></div><div class=btnText>{{\'BUTTON_ESTIMATE_CLOSE\' | translate}}</div></button></span></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/ecuInventory.template.html','<md-dialog style="opacity: 2 !important;width: 40%;"><div class=batteryDetailsPopup style="height: auto !important;"><div class="closeBatteryDetailsPopInRow fixedPopInHeader"><div class="small-10 batteryPopupHeader">{{\'VEHICLE_ECU_INVENTORY\' | translate | uppercase}}</div><div class="small-2 closeButton" ng-click=vm.closePopIn()>X</div></div><div id=dataEcu class="left5 small-12" style="padding-top: 11%;padding-bottom: 2%; padding-left: 2%;color: #707070; font-size: var(--renaultSmallFont);\n font-family: var(--renaultFontRegular)"><div ng-if="vm.ecuResponseData.length !== 0" class="block-accordion contracts"><div class="block-accordion list-contracts borderDarkening" style="display: table;\n\nwidth: 90%;\nborder: 2px solid #d3d3d3;"><accordion class="newData collapse section_wrapper" close-others=false ng-repeat="item in vm.ecuResponseData"><accordion-group><accordion-heading><div ng-style="{\'border-bottom\': !$scope.isOpenCommercialServices ? \'2px solid #d3d3d3\':\'none\'}" class="section_header sub_items" style="color: #000;\n                margin-bottom: 0;border: 0;padding: .5rem 1rem;font-size: var(--renaultMediumFont);align-items: center;  \n                justify-content: space-between;display: block;" ng-click="$scope.isOpenCommercialServices = !$scope.isOpenCommercialServices;"><div style="font-weight: 700;\n    color: #b8b8b8;"><span class=grid__col-2>{{ \'ECU_NAME\' | translate | uppercase}}</span> <span style="float: right;"><i ng-class="\' icon-arrow_\'+($scope.isOpenCommercialServices ? \'open\' : \'close\')" ng-if=item></i></span></div><div><span class=grid__col-2>{{item.ecuName | rlinkformat}}</span></div></div></accordion-heading><div class="flex sub_items_header grid--no-gutter" style="margin-top: 5px;color: #b8b8b8;font-size: var(--renaultMediumFont);"><span class=grid__col-4 ng-if=!item.hideSoftwareVersion>{{\'BLMS_SOFTWARE_VERSION\' | translate}}</span> <span class=grid__col-4 ng-if=!item.hidePartNumber>{{\'EASYLINK_PART_NUMBER\' | translate}}</span> <span class=grid__col-1></span></div><div class="flex sub_items_content grid--no-gutter" style=font-size:var(--renaultSmallFont);color:#000;><span class=grid__col-4 ng-if=!item.hideSoftwareVersion>{{item.softwareVersion ? item.softwareVersion : \'-\' | rlinkformat}}</span> <span class=grid__col-4 ng-if=!item.hidePartNumber>{{item.partNumber ? item.partNumber : \'-\' | rlinkformat}}</span> <span class=grid__col-1></span></div><div class="flex sub_items_header grid--no-gutter" style="margin-top: 10px;color: #b8b8b8;font-size: var(--renaultMediumFont);"><span class=grid__col-4 ng-if=!item.hideSerialNumber>{{\'VIRTUAL_KEY_SERIAL_NO\' | translate}}</span> <span class=grid__col-4 ng-if=!item.hideConfigRef>{{\'UNIQUE_CONFIG_REF\' | translate}}</span> <span class=grid__col-1></span></div><div class="flex sub_items_header grid--no-gutter" style=font-size:var(--renaultSmallFont);color:#000;><span class=grid__col-4 ng-if=!item.hideSerialNumber>{{item.serialNumber ? item.serialNumber : \'-\' | rlinkformat}}</span> <span class=grid__col-4 ng-if=!item.hideConfigRef>{{item.uniqueConfigurationRef ? item.uniqueConfigurationRef : \'-\' | rlinkformat}}</span> <span class=grid__col-1></span></div><div class="flex sub_items_header grid--no-gutter" style="margin-top: 10px;color: #b8b8b8;font-size: var(--renaultMediumFont);"><span class=grid__col-4 ng-if=!item.hideConfigurationFile>{{\'EASYLINK_CONFIGURATION_FILE\' | translate}}</span> <span class=grid__col-4 ng-if=!item.hideCalibration>{{\'EASYLINK_CALIBRATION_FILE\' | translate}}</span> <span class=grid__col-1></span></div><div class="flex sub_items_header grid--no-gutter" style=font-size:var(--renaultSmallFont);color:#000;><span class=grid__col-4 ng-if=!item.hideConfigurationFile>{{item.configurationFile ? item.configurationFile : \'-\' | rlinkformat}}</span> <span class=grid__col-4 ng-if=!item.hideCalibration>{{item.calibrationFile ? item.calibrationFile : \'-\' | rlinkformat}}</span> <span class=grid__col-1></span></div><div ng-if="item.ecuName === \'IVI\'" class="flex sub_items_header grid--no-gutter" style="margin-top: 35px;color: #b8b8b8;font-size: var(--renaultMediumFont);"><span class=grid__col-4>{{\'ADDITIONAL_DATA\'| translate}}</span> <span class=grid__col-4></span> <span class=grid__col-1></span></div><div ng-if="item.ecuName === \'IVI\'" class="flex sub_items_header grid--no-gutter" style="margin-top: 7px;color: #b8b8b8;font-size: var(--renaultMediumFont);"><span class=grid__col-4>{{\'VISUAL_PACK_REF\'| translate}}</span> <span class=grid__col-4></span> <span class=grid__col-1></span></div><div ng-if="item.ecuName === \'IVI\'" class="flex sub_items_header grid--no-gutter" style=font-size:var(--renaultSmallFont);color:#000;><span class=grid__col-4>{{item.visualPackRef | rlinkformat}}</span> <span class=grid__col-4></span> <span class=grid__col-1></span></div></accordion-group></accordion></div></div><div ng-if="vm.ecuResponseData.length === 0" class="block-accordion contracts"><div style="font-size: 30px;text-align: center;" class=small-10>{{\'DATA_NOT_FOUND\' | translate}}</div></div></div></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/updateCampaigns.template.html','<div class="block-accordion updateCampaigns" ng-show=!vm.isEasyLink style="margin-top:0; position: relative;"><accordion ng-if=!vm.vehicleInformationDisplay class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.mota.isOpen class=mota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_REMOTE_UPDATE\' | translate}}</span></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Mota/content.html\'"></div></accordion-group></accordion><accordion ng-if=!vm.vehicleInformationDisplay class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.fota.isOpen class=fota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_REMOTE_UPDATE_SOFTWARE\' | translate}}</span></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Fota/content.html\'"></div></accordion-group></accordion><!--Remote Update - Map--><accordion ng-if="vm.vehicleInformationDisplay && vm.connectedPlatform && vm.connectedPlatform.architecture === \'CCS1\' && (vm.vehicle && vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\')" class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.mota.isOpen class=mota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_REMOTE_UPDATE\' | translate}}</span></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click="vm.refreshData(\'map\')" class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div><div style="text-align: right; margin-top: -31px; padding-right: 34px;" ng-if="vm.updateCampaignsMota && vm.updateCampaignsMota.first && vm.updateCampaignsMota.first.length > 0"><button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.motaPageChange(vm.motaCurrentPage - 1)" ng-disabled="vm.motaCurrentPage === 1"><i ng-style="{\'color\': vm.motaCurrentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.motaCurrentPage}} of {{vm.getMotaTotalPages()}} <button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.motaPageChange(vm.motaCurrentPage + 1)" ng-disabled="vm.motaCurrentPage === vm.getMotaTotalPages()"><i ng-style="{\'color\': vm.motaCurrentPage === vm.getMotaTotalPages() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div></div><div class=flex ng-if="!vm.updateCampaignsMota.first || vm.updateCampaignsMota.first.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsMota && vm.updateCampaignsMota.first && vm.updateCampaignsMota.first.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Mota/mapCampaign.html\'"></div></accordion-group></accordion><!--Remote Update - Firmware--><accordion ng-if=vm.vehicleInformationDisplay class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.fota.isOpen class=fota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_REMOTE_UPDATE_SOFTWARE\' | translate}}</span></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click="vm.refreshData(\'software\')" class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div><div style="text-align: right; margin-top: -31px; padding-right: 34px;" ng-if="vm.updateCampaignsSoftware && vm.updateCampaignsSoftware.second && vm.updateCampaignsSoftware.second.length > 0"><button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.fotaPageChange(vm.fotaCurrentPage - 1)" ng-disabled="vm.fotaCurrentPage === 1"><i ng-style="{\'color\': vm.fotaCurrentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.fotaCurrentPage}} of {{vm.getFotaTotalPages()}} <button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.fotaPageChange(vm.fotaCurrentPage + 1)" ng-disabled="vm.fotaCurrentPage === vm.getFotaTotalPages()"><i ng-style="{\'color\': vm.fotaCurrentPage === vm.getFotaTotalPages() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div></div><div class=flex ng-if="!vm.updateCampaignsSoftware.second || vm.updateCampaignsSoftware.second.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsSoftware && vm.updateCampaignsSoftware.second && vm.updateCampaignsSoftware.second.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Fota/firmWareCampaign.html\'"></div></accordion-group></accordion><!--Remote Update - Vehicle Inventory--><accordion ng-if=vm.vehicleInformationDisplay class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.vehInvent.isOpen class=fota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_VEHICLE_INVENTORY\' | translate}}</span></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click="vm.refreshData(\'vehicle\')" class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></div></div><div class=flex ng-if=!vm.updateCampaignsVehInventory><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div style="text-align: right;top: 3rem;right: 1rem;position: relative;"><button ng-if=vm.canStartInventory ng-click="$event.stopPropagation(); vm.startInventory()" ng-disabled=vm.inventoryStartDisabled ng-class="{\'nissanBtnWithIcon goBtnNissan\': vm.nissanUserURL, \'btn-go buttonWithIcon\': !vm.nissanUserURL}"><div class=btn-txt><span class=btn-icon><i class="fa fa-chevron-right"></i></span> {{\'START_INVENTORY\' | translate}}</div></button></div><div ng-if=vm.updateCampaignsVehInventory ng-include ng-init="campaignType=\'vehicleInventory\'" src="\'app/components/car/rLinkCar/updateCampaigns/inventory/vehicleInventory.html\'"></div></accordion-group></accordion><!--Remote Update - New Inventory--><accordion ng-if="vm.vehicleInformationDisplay && vm.hasCcsArch" class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.mapInventCamp.isOpen class=fota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_MAP_CARTOGRAPHY\' | translate}}</span></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click="vm.refreshData(\'MapInvent\')" class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div><div style="text-align: right; margin-top: -31px; padding-right: 34px;" ng-if="vm.updateCampaignsMapInventoryCampaigns && vm.updateCampaignsMapInventoryCampaigns.fourth && vm.updateCampaignsMapInventoryCampaigns.fourth.length > 0"><button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.pageChange(vm.mapInventoryCurrentPage - 1, \'mapInventoryCampaigns\')" ng-disabled="vm.mapInventoryCurrentPage === 1"><i ng-style="{\'color\': vm.mapInventoryCurrentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.mapInventoryCurrentPage}} of {{vm.getTotalPages(\'mapInventoryCampaigns\')}} <button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.pageChange(vm.mapInventoryCurrentPage + 1, \'mapInventoryCampaigns\')" ng-disabled="vm.mapInventoryCurrentPage === vm.getTotalPages(\'mapInventoryCampaigns\')"><i ng-style="{\'color\': vm.mapInventoryCurrentPage === vm.getTotalPages(\'mapInventoryCampaigns\') ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div></div><div class=flex ng-if="!vm.updateCampaignsMapInventoryCampaigns.fourth || vm.updateCampaignsMapInventoryCampaigns.fourth.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsMapInventoryCampaigns && vm.updateCampaignsMapInventoryCampaigns.fourth && vm.updateCampaignsMapInventoryCampaigns.fourth.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/inventory/mapInventoryCampaign.html\'"></div></accordion-group></accordion><!--Remote Update - Fota Inventory--><accordion ng-if=vm.vehicleInformationDisplay class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.inventCamp.isOpen class=fota><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenMain = !$scope.isOpenMain;"><span>{{\'EASYLINK_VEHICLE_FOTA_INVENTORY\' | translate}}</span></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click="vm.refreshData(\'inventory\')" class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div><div style="text-align: right; margin-top: -31px; padding-right: 34px;" ng-if="vm.updateCampaignsInventoryCampaigns && vm.updateCampaignsInventoryCampaigns.third && vm.updateCampaignsInventoryCampaigns.third.length > 0"><button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.pageChange(vm.currentPage - 1)" ng-disabled="vm.currentPage === 1"><i ng-style="{\'color\': vm.currentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.currentPage}} of {{vm.getTotalPages()}} <button class=pagination-nav-button ng-class="{\'nissan-pagination\': vm.nissanUserURL}" style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.pageChange(vm.currentPage + 1)" ng-disabled="vm.currentPage === vm.getTotalPages()"><i ng-style="{\'color\': vm.currentPage === vm.getTotalPages() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div></div><div class=flex ng-if="!vm.updateCampaignsInventoryCampaigns.third || vm.updateCampaignsInventoryCampaigns.third.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsInventoryCampaigns && vm.updateCampaignsInventoryCampaigns.third && vm.updateCampaignsInventoryCampaigns.third.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/inventory/inventoryCampaign.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/remoteServices/remoteServices.template.html','<div id=remoteService ng-class="{\'nissan-date-theme\': vm.nissanUserURL}"><accordion class="collapse section_wrapper" close-others=false ng-if=vm.isRmpEnabled><accordion-group is-open=true><accordion-heading><div style="cursor: default;\n                                        color: #000;\n                                        padding: .5rem .5rem;"><span>{{\'REMOTE_SECURITY_PROTOCAL\' | translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i></div></accordion-heading><div><table style="border: none;min-width: 100%;"><tr><th><div>{{\'SECURITY_PROTOCOL\' | translate}}</div><div style="font-weight: lighter;">{{ vm.protocolData.name || \'-\' }}</div></th><th><div>{{\'JWT_SUPPORTED\' | translate}}</div><div style="font-weight: lighter;">{{ (vm.protocolData.isJwtSupported ? \'COMMON_YES\' : \'COMMON_NO\') | translate }}</div></th><th><div>{{\'TOKEN_ID\' | translate}}</div><div style="font-weight: lighter;">{{ vm.protocolData.offboardTokenKeyId || \'-\' }}</div></th><th><div>{{ \'TOKEN_STATUS\' | translate }}</div><div style="font-weight: lighter;">{{ vm.protocolData.isJwtSupported ? (vm.protocolData.offboardTokenKeyIdStatus === 1 ? \'APPLICABLE\' : \'-\') : (vm.protocolData.offboardTokenKeyIdStatus === 0 ? \'CONNECTED_SERVICES_NOT_APPLICABLE_STATUS\' : \'-\') | translate }}</div></th><th><div>{{\'JWT_LAST_UPDATE_TIME\' | translate}}</div><div style="font-weight: lighter;">{{ vm.protocolData.lastUpdatedTime | rlinkformat:\'full-date\' || \'-\' }}</div></th><th><button class=btnChangerVehicle ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.openConfirmationPopup()><div class=searchIcon><i class="fa fa-refresh" ng-class="{\'nissanMapRefresh\': vm.nissanUserURL, \'renaultMapRefresh\': !vm.nissanUserURL}"></i></div><div class=btnText style="padding-left: 0;">{{ \'REFRESH_JWT_CONFIG\' | translate }}</div></button></th></tr></table><div class=popup-overlay style="z-index: 1;" ng-show=vm.showPopup><div class=popup-content><p>{{\'REFRESH_JWT_CONFIG_CONFIRMATION\' | translate}}</p><div style="display: flex; justify-content: space-between;"><button class=btn-cancel ng-click=vm.closePopup()>{{\'COMMON_NO\' | translate}}</button> <button ng-class="{\'nissanBtn-confirm\': vm.nissanUserURL, \'renaultBtn-confirm\': !vm.nissanUserURL}" ng-click=vm.refreshJwtConfig()>{{\'COMMON_YES\' | translate}}</button></div></div></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=true><accordion-heading><div ng-style="{\'background-color\': vm.nissanUserURL ? \'#ededed\' : \'#978b7f\'}" style="cursor: default;color: #000;padding: .5rem .5rem; font-size: var(--renaultMediumFont);"><span>{{\'REMOTE_SERVICES\' | translate}}</span> <i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}" style="float: right;"></i> <i class="fa fa-info-circle" ng-click="vm.getRemoteServicesPopup(\'remoteServices\');$event.stopPropagation()" style=cursor:pointer;></i></div></accordion-heading><div layout=row layout-align="start center"><div layout=column style="margin-right: 20px;"><label style="padding-left: 2.2rem;">{{ \'FROM_DATE\' | translate }}</label><md-datepicker md-min-date=vm.minDate md-max-date=vm.maxDate ng-model=vm.startDate md-current-view=day md-hide-icons=triangle></md-datepicker></div><div layout=column style="margin-right: 20px;"><label style="padding-left: 2.2rem;">{{ \'TO_DATE\' | translate }}</label><md-datepicker ng-model=vm.endDate md-hide-icons=triangle md-max-date=vm.maxDate md-min-date=vm.startDate></md-datepicker></div><div layout=column style="position: relative; top: 1rem;"><button class=btnChangerVehicle ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.loadPage(1) ng-disabled="!vm.startDate || !vm.endDate || vm.startDate > vm.endDate" ng-class="{\'disabled-button\': !vm.startDate || !vm.endDate || vm.startDate > vm.endDate}"><div class=searchIcon style="display: table-cell;vertical-align: middle;padding-right: 5px;"><i class="fa fa-search"></i></div><div class=btnText style="padding-left: 0;">{{ \'CARSEARCH_SEARCH_BUTTON\' | translate }}</div></button></div></div><div><div style="text-align: right;"><button style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.pageChange(vm.currentPage - 1)" ng-disabled="vm.currentPage === 1"><i ng-style="{\'color\': vm.currentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.currentPage}} of {{vm.getTotalPages()}} <button style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.pageChange(vm.currentPage + 1)" ng-disabled="vm.currentPage === vm.getTotalPages()"><i ng-style="{\'color\': vm.currentPage === vm.getTotalPages() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div><table style="width: 97%; margin:1rem;border-collapse: collapse;"><thead><tr><th>{{\'COMMAND_NAME\' | translate}}</th><th>{{\'COMMON_STATUS\' | translate}} <i class="fa fa-info-circle" ng-click="vm.getRemoteServicesPopup(\'statusDescription\')" style=cursor:pointer;></i></th><th>{{\'RLINKCAR_TCU_REPAIR_DATE\' | translate}}</th><th>{{\'ERROR_CODE\' | translate}}</th><th>{{\'ERROR_MESSAGE\' | translate}}</th><th colspan=2>{{\'REPAIR_ACTION\' | translate}}</th></tr></thead><tbody><tr ng-if="!vm.remoteServicesData || vm.remoteServicesData.length === 0"><td colspan=6 style="text-align: center;">{{\'NO_REMOTE_DATE\' | translate}}</td></tr><tr ng-repeat-start="service in vm.remoteServicesData"><td><span ng-if="service.commandName === \'send-message-onboard\'">{{\'OTP_PAIRING\' | translate}}<md-tooltip md-direction=right><span>{{\'OTP_PAIRING_DONE\' | translate}}</span></md-tooltip><em class="fa fa-info-circle info-icon-adjust" style="top: 1px; position: relative;"></em> </span><span ng-if="service.commandName !== \'send-message-onboard\'">{{service.commandName}}</span></td><td ng-class="{\n                            \'status-ongoing\': service.actionLifeCycle[0].status.trim().toUpperCase() === \'PRISTINE\' || service.actionLifeCycle[0].status.trim().toUpperCase() === \'CREATED\' || service.actionLifeCycle[0].status.trim().toUpperCase() === \'PENDING\',\n                            \'status-failed\': service.actionLifeCycle[0].status.trim().toUpperCase() === \'REJECTED\' || service.actionLifeCycle[0].status.trim().toUpperCase() === \'CANCELLED\',\n                            \'status-success\': service.actionLifeCycle[0].status.trim().toUpperCase() === \'COMPLETED\'}"><span ng-if="service.commandName === \'send-message-onboard\' && service.actionLifeCycle[0].status.trim().toUpperCase() === \'CREATED\'">{{service.actionLifeCycle[0].status.trim().toUpperCase()}} </span><span ng-if="!(service.commandName === \'send-message-onboard\' && service.actionLifeCycle[0].status.trim().toUpperCase() === \'CREATED\')">{{service.actionLifeCycle[0].status.trim().toUpperCase()}}</span></td><td style="min-width: 90px;"><div>{{service.actionLifeCycle[0].creationDateTime | rlinkformat:\'date\'}}</div><div>{{service.actionLifeCycle[0].creationDateTime | rlinkformat:\'time-seconds\'}}</div></td><td>{{(service.actionLifeCycle[0].error && service.actionLifeCycle[0].error.code) ? service.actionLifeCycle[0].error.code : ""}}</td><td style="word-wrap: break-word; max-width: 300px;">{{(service.actionLifeCycle[0].error && service.actionLifeCycle[0].error.description && service.actionLifeCycle[0].error.code) ? vm.getTranslatedMessage(\'RS_ECODE_\', service.actionLifeCycle[0].error.code, service.actionLifeCycle[0].error.description) : "" }}</td><td><div style="position: relative;display: inline-block; top: 5px;" ng-if="service.actionLifeCycle[0].error && service.actionLifeCycle[0].status.trim().toUpperCase() !== \'COMPLETED\'"><span class="icon eye-plus-outline" style="width: 20px;" ng-click=vm.togglePopin(service)></span><div class="popin see-more" ng-if=service.showPopin style="margin-top: 0.5rem; margin-right: 14rem;"><div style="color: black;" class=popin--header><div>{{\'REPAIR_ACTION\' | translate}}</div><div style="color: black;" class="icon close-popin" ng-click="service.showPopin = false">X</div></div><div class=popin--content><div>{{\'REPAIR_ACTION\' | translate}} : <span ng-if=service.actionLifeCycle[0].error.repairAction>{{ vm.getTranslatedMessage(\'RS_RP_ECODE_\', service.actionLifeCycle[0].error.code, service.actionLifeCycle[0].error.repairAction) }} </span><span ng-if=!service.actionLifeCycle[0].error.repairAction>-</span></div><div>{{\'LEVEL_OF_TREATMENT\' | translate}} : {{service.actionLifeCycle[0].error.levelOfTreatment === \'L0\' ? (\'FIC_CREATED_BY\' | translate) : (service.actionLifeCycle[0].error.levelOfTreatment || \'-\')}}</div></div></div></div></td><td><i class=fa style="cursor: pointer;" ng-if="service.actionLifeCycle.length > 1" ng-class="{\'fa-caret-down\': !service.isExpanded, \'fa-caret-up\': service.isExpanded}" ng-click=vm.toggleExpand(service)></i></td></tr><tr ng-if=service.isExpanded ng-repeat-end style="border-bottom: 1pt solid #d4d4d4;"><td style="position: relative;">{{\'ACTION_LIFE_CYCLE\'| translate }}<div style="position: absolute; top: 0; bottom: 4px; right: 0; width: 0.2rem; height: calc(100% - 4px); background-color: #d4d4d4;"></div></td><td ng-if="service.actionLifeCycle && service.actionLifeCycle[3]"><div>{{ service.actionLifeCycle[3].status.toUpperCase() }}</div><div>{{ service.actionLifeCycle[3].creationDateTime | rlinkformat:\'full-date-seconds\' }}</div></td><td ng-if="service.actionLifeCycle && service.actionLifeCycle[2]"><div>{{ service.actionLifeCycle[2].status.toUpperCase() }}</div><div>{{ service.actionLifeCycle[2].creationDateTime | rlinkformat:\'full-date-seconds\' }}</div></td><td ng-if="service.actionLifeCycle && service.actionLifeCycle[1]"><div>{{ service.actionLifeCycle[1].status.toUpperCase() }}</div><div>{{ service.actionLifeCycle[1].creationDateTime | rlinkformat:\'full-date-seconds\' }}</div></td><td></td><td></td></tr></tbody></table></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/coyote.html','<div class="block-accordion apps"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.application.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpenMain = !$scope.isOpenMain"><span>COYOTE</span> <i ng-class="\'icon-arrow_\'+($scope.isOpenMain ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_information><div class=block_text><span style="margin-right: .15rem;">{{\'RLINKCAR_SOFT_INSTALLED_VERSION\' | translate}} : {{vm.coyote.currentSoftwareVersion | rlinkformat}}</span><rlink-tip tip-value="({{\'RLINKCAR_SYNC_POINT\' | translate}} : {{vm.coyote.lastFingerprintDate | rlinkformat:\'date\'}})" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></div><div class=block_text>{{\'RLINKCAR_SOFT_LAST_VR_DWLOD\' | translate}} : {{vm.coyote.lastDownloadedSoftwareVersion | rlinkformat}} <label ng-if=false>{{\'RLINKCAR_SOFT_LAST_VR_AVBL\' | translate}} : {{vm.coyote.lastAvailableSoftwareVersion | rlinkformat}}</label></div></div><div class=block-accordion><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isOpen = !$scope.isOpen">{{\'RLINKCAR_HU_DOWNLOAD_HISTORY\' | translate}}<i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead table-width data=vm.coyote.downloadHistory><tr ng-if="vm.coyote.downloadHistory.length > 0"><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_HU_VOLUME\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th><th><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th>{{\'RLINKCAR_HU_STATUS\' | translate}}</th></tr><tr ng-if="vm.coyote.downloadHistory == null || vm.coyote.downloadHistory.length == 0"><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_HU_VOLUME\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th><th>{{\'CONNECTED_SERVICE_DATE\' | translate}}</th><th>{{\'RLINKCAR_HU_STATUS\' | translate}}</th></tr></thead><tbody><tr ng-if="vm.coyote.downloadHistory.length > 0" ng-repeat="item in vm.coyote.downloadHistory"><td>{{item.name | rlinkformat}}</td><td>{{item.size | rlinkformat:\'convert\'}}</td><td>{{item.packageVersion | rlinkformat}}</td><td>{{item.lastDownloadStatusDate | rlinkformat:\'date\'}}</td><td>{{item.lastDownloadStatus | rlinkformat:\'status\'}}</td></tr><tbody table-data-manager data=vm.coyote.downloadHistory nbr-column=5></tbody></tbody></table></div></div></accordion-group></accordion></div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/maps.html','<div class="block-accordion maps"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.maps.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpenMain = !$scope.isOpenMain"><span>{{\'RLINKCAR_STORAGE_MAPS\' | translate}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpenMain ? \'open\' : \'close\')"></i></div></accordion-heading><ng-include ng-if="vm.mapDetails.length === 0" src="\'app/components/car/rLinkCar/softAndApplications/easyLink/noMap.html\'"></ng-include><div class="block-accordion maps-content padding-left-right-bottom" ng-if="vm.mapDetails.length > 0"><accordion class="collapse full-width" close-others=false ng-repeat="map in vm.mapDetails"><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isOpenMap = !$scope.isOpenMap"><span>{{map.regionName}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpenMap ? \'open\' : \'close\')"></i></div></accordion-heading><div class="block-sub-accordion block-with-background" ng-repeat="mus in map.mus"><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isOpen = !$scope.isOpen"><div><rlink-tip tip-value={{mus.commercialName}} tip-title=RLINKCAR_TIP_MUS></rlink-tip><span ng-if="mus.subscriptionStatus == \'ACTIVATED\'" class=success-message><i class=icon-success></i> {{mus.subscriptionStatus | rlinkformat:\'status\'}} </span><span ng-if="mus.subscriptionStatus != null && mus.subscriptionStatus != \'ACTIVATED\'" class=error-message><i class=icon-error></i> {{mus.subscriptionStatus | rlinkformat:\'status\'}} </span><span ng-if="mus.subscriptionStatus == null" class=nd-message>-</span></div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead class=full-width><tr><th><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th><rlink-tip tip-value="{{\'CONNECTED_SERVICES_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th></tr></thead><tbody><tr><td class=table-padding-td>{{mus.subscriptionStartDate | rlinkformat:\'date\'}}</td><td class=table-padding-td>{{mus.subscriptionEndDate | rlinkformat:\'date\'}}</td></tr></tbody></table></div></div></accordion-group></accordion></div><any ng-repeat="itemMap in map.maps"><div class=block_sub-content><span class=title>Carte {{itemMap.commercialName}} :</span><div class=block_information_sub><div class=block_text>{{\'RLINKCAR_SOFT_INSTALLED_VERSION\' | translate}} : {{itemMap.currentSoftwareVersion | rlinkformat}} <label ng-if=false>({{\'RLINKCAR_SYNC_POINT\' | translate}} : ND)</label></div><div class=block_text>{{\'RLINKCAR_SOFT_LAST_VR_DWLOD\' | translate}} : {{itemMap.lastDownloadedSoftwareVersion | rlinkformat}}</div><div class=block_text><rlink-tip tip-value="{{(\'RLINKCAR_SOFT_ELIGIBLE_UPDATE\' | translate)+\' : \'+(itemMap.lastInstallableSoftwareVersion | rlinkformat)}}" tip-title=RLINKCAR_TIP_MAP></rlink-tip></div><div class=block_text><label ng-if=false>{{\'RLINKCAR_SOFT_LAST_VR_AVBL\' | translate}} : 2019_06</label></div></div><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isOpenSub = !$scope.isOpenSub"><span>{{\'RLINKCAR_HU_DOWNLOAD_HISTORY\' | translate}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpenSub ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead table-width data=itemMap.downloadHistory><tr ng-if="itemMap.downloadHistory.length > 0"><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_HU_VOLUME\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th><th><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th>{{\'RLINKCAR_HU_STATUS\' | translate}}</th></tr><tr ng-if="itemMap.downloadHistory == null || itemMap.downloadHistory.length == 0"><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_HU_VOLUME\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th><th>{{\'CONNECTED_SERVICE_DATE\' | translate}}</th><th>{{\'RLINKCAR_HU_STATUS\' | translate}}</th></tr></thead><tbody class=mapTable><tr ng-if="itemMap.downloadHistory.length > 0" ng-repeat="item in itemMap.downloadHistory | rlinkOrderBy:\'packageVersion\':\'-\'"><td>{{item.name | rlinkformat}}</td><td>{{item.size | rlinkformat:\'convert\'}}</td><td>{{item.packageVersion | rlinkformat}}</td><td>{{item.lastDownloadStatusDate | rlinkformat:\'date\'}}</td><td>{{item.lastDownloadStatus | rlinkformat:\'status\'}}</td></tr><tbody table-data-manager data=itemMap.downloadHistory nbr-column=5></tbody></tbody></table></div></div></accordion-group></accordion></div></div></any></accordion-group></accordion></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/softAndApplications.template.html','<!-- RLINK2 --><!-- BLOCK MAP --><div ng-show=!vm.isEasyLink ng-include src="\'app/components/car/rLinkCar/softAndApplications/maps.html\'"></div><!-- BLOCK COYOTE --><div ng-show=!vm.isEasyLink ng-include src="\'app/components/car/rLinkCar/softAndApplications/coyote.html\'"></div><!-- EASYLINK --><div ng-show=vm.isEasyLink ng-include src="\'app/components/car/rLinkCar/softAndApplications/easyLink/maps.html\'"></div><div ng-show=vm.isEasyLink ng-include src="\'app/components/car/rLinkCar/softAndApplications/easyLink/adasAndEhorizon.html\'"></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/forcePushButtonHistoryModal.html','<div class=app-modal style="margin: 10px;width:950px;"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><section ng-if="forcePushButtonHistory.length > 0"><header class=grid--no-gutter><div class="label grid__col-6" ng-click="sortBy(\'dateTime\', \'forcePushButtonHistory\');">{{\'CONNECTED_SERVICES_DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'dateTime\'"></span></div><div class="label grid__col-6" ng-click="sortBy(\'user\', \'forcePushButtonHistory\');">{{\'IPN\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'user\'"></span></div></header></section><ul class=list-contracts ng-if="forcePushButtonHistory.length > 0"><li ng-repeat="item in forcePushButtonHistory" class=grid--no-gutter><span class=grid__col-6>{{item.dateTime | rlinkformat:\'date\'}}</span> <span class=grid__col-6>{{item.user | rlinkformat}}</span></li></ul><div class=block_text ng-if="forcePushButtonHistory.length === 0">{{\'NO_DATA\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/hu.html','<div class=row><div class=block_text>{{\'RLINKCAR_HU_TYPE\' | translate}} : {{ vm.vehicle.headUnitInformation.radioType | rlinkformat}}</div><div class=block_text><span>{{\'CONNECTED_SERVICES_ID\' | translate}} : {{ vm.vehicle.headUnitInformation.huId.bvmAfterSales | rlinkformat }}</span><any ng-if=!vm.vehicle.headUnitInformation.huId.consistency><span class=warning-message><i class="icon icon-icons_warning_document"></i></span></any></div><div class=block_text>{{\'RLINKCAR_HU_HARDWARE_VERSION\' | translate}} : {{ vm.radioRange | rlinkformat }}</div><div class=block_text>{{\'CONNECTED_SERVICES_SOFTWARE_VERSION\' | translate}} : {{ vm.software | rlinkformat }}<any ng-if=false>{{\'RLINKCAR_HU_LAST_SOFTWARE\' | translate}} : {{ vm.vehicle.headUnitInformation.lastAvailableSoftwareVersion | rlinkformat }}</any></div><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen">{{(vm.isCCS3Vehicle ? \'REPLACEMENT_HISTORY_CDC\' : (vm.vehicleInformationDisplay ? \'REPLACEMENT_HISTORY_HU\' : \'CONNECTED_SERVICES_REPLACEMENT_HISTORY\')) | translate}}<i ng-class="\'icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions style="border: 1px solid #ddd !important;"><section><header class=grid--no-gutter style="font-size:14px; padding: 0.7rem !important;\n                            font-family: \'newRenaultGroupBold\';"><span class="vehtable-header grid__col-3">{{\'CONNECTED_SERVICES_REFERENCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_MODEL\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_SOURCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_STATE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2"><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></span><span class="vehtable-header grid__col-1"></span></header></section><div ng-if="vm.huTable != null && vm.vehicle.headUnitInformation.present === \'YES\'" ng-repeat="item in vm.huTable | reverse"><accordion class="collapse section_wrapper veh-content-replacement" close-others=false><accordion-group><accordion-heading><div ng-click="item.model === \'REPLACEMENT\' ? ($scope.isOpen = !$scope.isOpen) && (!vm.isCCS3Vehicle && vm.openReplacement($scope.isOpen,item,\'IVI\')) : $event.stopPropagation();" class="sub_items grid--no-gutter" style="padding: 0.5rem !important;font-weight: normal !important; font-size: 14px !important;" ng-style="{ \'cursor\': item.model === \'REPLACEMENT\' ? \'pointer\' : \'default\' }"><span class=grid__col-3>{{item.huid | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.model | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.sources | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\' | uppercase}}</span> <span class=grid__col-2>{{item.date | rlinkformat:\'date\'}}</span> <span class=grid__col-1><i ng-if="item.model == \'REPLACEMENT\'" ng-class="\' icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></span></div></accordion-heading><div class="sub_items grid--no-gutter loading-content" ng-if=vm.vehicle.huLoadingData><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><div class="sub_items grid--no-gutter loading-content" ng-if=!vm.vehicle.huLoadingData><span class=grid__col-4>{{(vm.isCCS3Vehicle ? \'BOOTSTRAP_CDC\' : \'BOOTSTRAP_IVI\') | translate}}<div ng-if=vm.vehicle.headUnitInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.headUnitInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.headUnitInformation.bootstrap.done === null" class=nd-message>-</div><div>{{vm.vehicle.headUnitInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}}</div><div ng-if=!vm.vehicle.headUnitInformation.bootstrap.history[0].datetime>-</div></span><span class=grid__col-3>{{"LABEL_CONSISTENCY_PART" | translate}}<div ng-if=vm.vehicle.threeHuValuesEqual class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.threeHuValuesEqual class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.threeHuValuesEqual === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=!vm.isCCS3Vehicle>{{"SERVICE_REACTIVATION_STATUS" | translate}}<div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.status == \'IN_PROGRESS\'"><span class="color-orange font-14"><i class="fa fa-exclamation-triangle" aria-hidden=true></i> {{vm.huServiceReactivation.status}}</span></div><div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.status == \'TERMINATED\'"><span class="success-message font-14">Reactivated</span></div><div ng-if="vm.huServiceReactivation && \n                                                    vm.huServiceReactivation.status != \'TERMINATED\' && \n                                                    vm.huServiceReactivation.status != \'IN_PROGRESS\'"><span class=error-message><em class="fa fa-close color-red font-20"></em> {{vm.huServiceReactivation.status}}</span></div><div ng-if="vm.huServiceReactivation === null" class=nd-message>-</div><div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.endDate">{{vm.huServiceReactivation.endDate | rlinkformat:\'full-date\'}}</div><div ng-if="vm.huServiceReactivation === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=vm.isCCS3Vehicle></span> <span class=grid__col-1 ng-if=!vm.isCCS3Vehicle><i class="fa fa-refresh cursor-pointer" ng-click="vm.openReplacement($scope.isOpen,item,\'IVI\')" ng-keypress="vm.openReplacement($scope.isOpen,item,\'IVI\')"></i></span></div></accordion-group></accordion></div><div ng-if="vm.huTable.length == 0" class="text-center padding-small">{{(vm.isCCS3Vehicle ? \'CONNECTED_SERVICES_NO_CDC_MESSAGE\' : \'CONNECTED_SERVICES_NO_HU_MESSAGE\') | translate}}</div></div></accordion-group></accordion></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/pbo.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value=PBO tip-title=CONNECTED_SERVICES_TIP_PBO></rlink-tip><span ng-if="vm.pushButtonActivated === true" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACHIEVED\' | translate}} </span><span ng-if="vm.pushButtonActivated === false && vm.pushButtonRequested === true" class=warning-message><i class=icon-warning></i> {{\'RLINKCAR_PBO_ASKED\' | translate}} </span><span ng-if="vm.pushButtonActivated === false && vm.pushButtonRequested === false" class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_NOTACHIEVED\' | translate}} </span><span ng-if="vm.pushButtonActivated == null || vm.pushButtonRequested == null" class=nd-message>- </span><!-- PBO Actions - Restricted access for testing --><div class=rlink-tip ng-if=vm.isAuthorized style="vertical-align: middle;margin-top: .5rem;"><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_PBO_CAN_FORCE\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled=!vm.canForce ng-click=vm.forcePBO(); style="padding: .25rem;"><span class="icon refresh"></span></button></div><div class=rlink-tip ng-if=vm.isAuthorized style="vertical-align: middle;margin-top: .5rem;"><span class=rlink-tip-txt>{{\'EASYLINK_VEHICLE_PBO_HISTORY\' | translate}}</span> <button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-disabled="vm.forcePushButtonHistory !== null || vm.forcePushButtonHistory.length === 0" ng-click=vm.openPBOHistoryModal(); style="padding: .25rem;"><span class="icon history"></span></button></div><!-- End PBO Actions - Restricted access for testing --></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/sim.html','<div class=row><div class=block_text><rlink-tip ng-if="vm.simStatus != null && vm.simStatus != \'ACTIVATED\'" tip-class=label_title tip-value=SIM tip-title=RLINKCAR_TIP_SIM></rlink-tip><any ng-if="vm.simStatus === \'ACTIVATED\'">{{\'RLINKCAR_SIM\' | translate}}</any><any ng-if=!vm.noTcu style=margin-bottom:0;><span ng-if="vm.simStatus === \'ACTIVATED\'" class=success-message><i class=icon-success></i> {{vm.simStatus | rlinkformat:\'status\'}} </span><span ng-if="vm.simStatus != null && vm.simStatus != \'ACTIVATED\'" class=error-message><i class=icon-error></i> {{vm.simStatus | rlinkformat:\'status\'}} </span><span ng-if="vm.simStatus == null" class=nd-message>-</span></any><span ng-if=vm.noTcu class="nd-message upper">{{\'RLINKCAR_NO_TCU\' | translate}}</span></div><div class=block-accordion ng-if=!vm.noTcu style=margin-bottom:0;><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen"><span>{{\'CONNECTED_SERVICES_LAST_COMMUNICATIONS\' | translate}}</span><i class=align-center ng-class="\'icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div ng-if=!vm.vehicleInformationDisplay class=block_body><div class=table_block_body><table style="overflow-y: auto; width: 100%;"><thead table-width data=vm.simTable ng-if="vm.simTable && vm.simTable.length > 0"><tr><th><rlink-tip tip-value="{{\'RLINKCAR_PBO_START_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th><rlink-tip tip-value="{{\'RLINKCAR_PBO_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th>OCTET(S) {{\'RLINKCAR_PBO_BYTESSENT\' | translate}}</th><th>OCTET(S) {{\'RLINKCAR_PBO_BYTESRECEIVED\' | translate}}</th></tr></thead><tbody ng-if="vm.simTable && vm.simTable.length > 0"><tr ng-repeat="item in vm.simTable | rlinkOrderBy:\'startDate\':\'-\'"><td class=table-padding-td>{{ item.startDate | rlinkformat:\'full-date\' }}</td><td class=table-padding-td>{{ item.endDate | rlinkformat:\'full-date\' }}</td><td class=table-padding-td>{{ item.bytesSent | rlinkformat }}</td><td class=table-padding-td>{{ item.bytesReceived | rlinkformat}}</td></tr></tbody><tbody table-data-manager data=vm.simTable nbr-column=4></tbody></table></div></div><div class=block_body ng-if=vm.vehicleInformationDisplay><div class=table_block_body><table style="overflow-y: auto;width: 100%;"><thead table-width data=vm.simTable ng-if="vm.simTable && vm.simTable.length > 0"><tr><th><rlink-tip tip-value="{{\'RLINKCAR_PBO_START_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th><rlink-tip tip-value="{{\'RLINKCAR_PBO_END_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></th><th>OCTET(S) {{\'RLINKCAR_PBO_BYTESSENT\' | translate}}</th><th>OCTET(S) {{\'RLINKCAR_PBO_BYTESRECEIVED\' | translate}}</th></tr></thead><tbody ng-if="vm.simTable && vm.simTable.length > 0" class=lastCommTable><tr class=lastCommRow ng-repeat="item in vm.simTable | rlinkOrderBy:\'startDate\':\'-\'"><td class=table-padding-td>{{ item.startDate | rlinkformat:\'full-date\' }}</td><td class=table-padding-td>{{ item.endDate | rlinkformat:\'full-date\' }}</td><td class=table-padding-td>{{ item.bytesSent | rlinkformat }}</td><td class=table-padding-td>{{ item.bytesReceived | rlinkformat}}</td></tr></tbody><tbody table-data-manager data=vm.simTable nbr-column=4></tbody></table></div></div></accordion-group></accordion></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/storage.html','<div class="row padding-left-right-bottom"><accordion class="collapse full-width" close-others=oneAtATime><accordion-group is-open-main="\'true\'" style="margin: 1rem 0 !important;"><accordion-heading><div class="accordion-heading-datas space-between flex" ng-click="$scope.isOpenMain = !$scope.isOpenMain">{{\'RLINKCAR_STORAGE\' | translate}}<i ng-class="\' icon-arrow_\'+($scope.isOpenMain ? \'open\' : \'close\')"></i></div></accordion-heading><div class="block_information padding-all"><disk-space total=vm.principalStorage.totalSpace empty=vm.principalStorage.freeSpace></disk-space></div><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-class="($scope.isOpenSubMain ? \'open\' : \'close\')" ng-click="$scope.isOpenSubMain = !$scope.isOpenSubMain"><rlink-tip tip-value="{{\'RLINKCAR_STORAGE_MAPS_CONTENT\' | translate}}" tip-title=RLINKCAR_TIP_STORAGE_PR></rlink-tip><i ng-class="\' icon-arrow_\'+($scope.isOpenSubMain ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead table-width data=vm.principalStorage.contents><tr><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th></tr></thead><tbody class=storageTable ng-if="vm.principalStorage.contents != null"><tr ng-repeat="item in vm.principalStorage.contents"><td class=table-padding-td>{{ item.identifier | rlinkformat }}</td><td class=table-padding-td>{{ item.version | rlinkformat }}</td></tr></tbody><tbody table-data-manager data=vm.principalStorage.contents nbr-column=2></tbody></table></div></div></accordion-group></accordion></div></accordion-group></accordion><accordion class="collapse full-width"><accordion-group is-open-maps="\'true\'"><accordion-heading><div class="accordion-heading-datas space-between flex" ng-click="$scope.isOpenMaps = !$scope.isOpenMaps">{{\'RLINKCAR_STORAGE_MAPS\' | translate}}<i ng-class="\' icon-arrow_\'+($scope.isOpenMaps ? \'open\' : \'close\')"></i></div></accordion-heading><div class="block_information padding-all"><disk-space total="vm.mapStorage.totalSpace " empty=vm.mapStorage.freeSpace></disk-space></div><div class="block-sub-accordion accordion-top"><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isOpenSubMaps = !$scope.isOpenSubMaps"><rlink-tip tip-value="{{\'RLINKCAR_STORAGE_MAPS_CONTENTS\' | translate}}" tip-title=RLINKCAR_TIP_STORAGE_MAP></rlink-tip><i ng-class="\' icon-arrow_\'+($scope.isOpenSubMaps ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead table-width data=vm.mapStorage.contents><tr><th>{{\'CONNECTED_SERVICES_REFERENCE\' | translate}}</th><th>{{\'RLINKCAR_VERSION\' | translate}}</th></tr></thead><tbody ng-if="vm.mapStorage.contents != null"><tr ng-repeat="item in vm.mapStorage.contents | rlinkOrderBy:\'version\':\'-\'"><td class=table-padding-td>{{ item.identifier | rlinkformat }}</td><td class=table-padding-td>{{ item.version | rlinkformat }}</td></tr></tbody><tbody table-data-manager data=vm.mapStorage.contents nbr-column=2></tbody></table></div></div></accordion-group></accordion></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/tcu.html','<div class=row ng-if="vm.noTcu && !vm.vehicleInformationDisplay"><div class=block_text><rlink-tip tip-class=label_title tip-value=TCU tip-title=RLINKCAR_TIP_TCU></rlink-tip><span class="nd-message upper">{{\'RLINKCAR_NO_TCU\' | translate}}</span></div></div><div class=row ng-if=!vm.noTcu style=margin-bottom:0;><div class=block_text><span>{{\'CONNECTED_SERVICES_ID\' | translate}} : {{ vm.tcuInformation.tcuId.bvmAfterSales | rlinkformat}}</span><any ng-if=!vm.vehicle.tcuInformation.tcuId.consistency><span class=warning-message><i class="icon icon-icons_warning_document"></i></span></any></div><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen">{{vm.vehicleInformationDisplay ? \'REPLACEMENT_HISTORY_TCU\' : \'CONNECTED_SERVICES_REPLACEMENT_HISTORY\'| translate}}<i ng-class="\' icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions style="border: 1px solid #ddd !important;"><section><header class=grid--no-gutter style="font-size:14px; padding: 0.7rem !important;\n                            font-family: \'newRenaultGroupBold\';"><span class="vehtable-header grid__col-3">{{\'CONNECTED_SERVICES_REFERENCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_MODEL\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_SOURCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_STATE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2"><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></span><span class="vehtable-header grid__col-1"></span></header></section><div ng-if="vm.tcuTable != null && vm.vehicle.tcuInformation.present === \'YES\'" ng-repeat="item in vm.tcuTable | reverse"><accordion class="collapse section_wrapper veh-content-replacement" close-others=false><accordion-group><accordion-heading><div ng-click="item.model === \'REPLACEMENT\' ? ($scope.isOpen = !$scope.isOpen) && (!vm.isCCS3Vehicle && vm.openReplacement($scope.isOpen,item,\'IVC\')) : $event.stopPropagation();" class="sub_items grid--no-gutter" style="padding: 0.5rem !important; font-weight: normal !important; font-size: 14px !important;" ng-style="{ \'cursor\': item.model === \'REPLACEMENT\' ? \'pointer\' : \'default\' }"><span class=grid__col-3>{{item.tcuid | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.model | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.sources | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\' | uppercase}}</span> <span class=grid__col-2>{{item.date | rlinkformat:\'date\' | uppercase}}</span> <span class=grid__col-1><i ng-if="item.model == \'REPLACEMENT\'" ng-class="\' icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></span></div></accordion-heading><div class="sub_items grid--no-gutter loading-content" ng-if=vm.vehicle.tcuLoadingData><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><div class="sub_items grid--no-gutter loading-content" ng-if=!vm.vehicle.tcuLoadingData><span class=grid__col-4>{{"BOOTSTRAP_IVC" | translate}}<div ng-if=vm.vehicle.tcuInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.tcuInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.tcuInformation.bootstrap.done === null" class=nd-message>-</div><div>{{vm.vehicle.tcuInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}}</div><div ng-if=!vm.vehicle.tcuInformation.bootstrap.history[0].datetime>-</div></span><span class=grid__col-3>{{"LABEL_CONSISTENCY_PART" | translate}}<div ng-if=vm.vehicle.threeTcuValuesEqual class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.threeTcuValuesEqual class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.threeTcuValuesEqual === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=!vm.isCCS3Vehicle ng-style="{\'visibility\': vm.getTcuServiceReactivationVisibility()}">{{"SERVICE_REACTIVATION_STATUS" | translate}}<div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.status === \'IN_PROGRESS\'"><span class="color-orange font-14"><i class="fa fa-exclamation-triangle" aria-hidden=true></i> {{vm.tcuServiceReactivation.status}}</span></div><div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.status === \'TERMINATED\'"><span class="success-message font-14">Reactivated</span></div><div ng-if="vm.tcuServiceReactivation && \n                                                    vm.tcuServiceReactivation.status !== \'TERMINATED\' && \n                                                    vm.tcuServiceReactivation.status !== \'IN_PROGRESS\'"><span class=error-message><em class="fa fa-close color-red font-20"></em> {{vm.tcuServiceReactivation.status}}</span></div><div ng-if="vm.tcuServiceReactivation === null" class=nd-message>-</div><div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.endDate">{{vm.tcuServiceReactivation.endDate | rlinkformat:\'full-date\'}}</div><div ng-if="vm.tcuServiceReactivation === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=vm.isCCS3Vehicle></span> <span class=grid__col-1 ng-if=!vm.isCCS3Vehicle><i class="fa fa-refresh cursor-pointer" ng-click="vm.openReplacement($scope.isOpen,item,\'IVC\')" ng-keypress="vm.openReplacement($scope.isOpen,item,\'IVC\')"></i></span></div></accordion-group></accordion></div><div ng-if="vm.tcuTable.length == 0" class="text-center padding-small">{{\'CONNECTED_SERVICES_NO_TCU_MESSAGE\' | translate}}</div></div></accordion-group></accordion></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/vehicleInformations.template.html','<!-- RLink2 --><div ng-show=!vm.isEasyLink><!-- BLOCK CONNECTIVITE --><div class=block-accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.connectivity.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'RLINKCAR_CONNECTIVITY\' | translate}}</span> <span ng-if="vm.vehicle.connectivity.status === \'OK\'" class=success-message><i class=icon-success></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'WARNING\'" class=warning-message><i class=icon-warning></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'KO\'" class=error-message><i class=icon-error></i> {{vm.vehicle.connectivity.status}}</span></div><div><button ng-if=!vm.hideDiagnosisAcces ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" class=cs-btn ng-click=vm.goToDiagnosis()><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'CONNECTED_SERVICES_DIAGNOSIS\' | translate}}</div></button> <i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><!-- BLOCK PBO --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/pbo.html\'"></div><!-- BLOCK SIM --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/sim.html\'"></div></accordion-group></accordion></div><!-- BLOCK HU --><div class=block-accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.HU.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex><rlink-tip tip-class=label_title tip-value="{{\'CONNECTED_SERVICES_LABEL_HU\' | translate}}" tip-title=RLINKCAR_TIP_HU></rlink-tip><div ng-if="!vm.vehicle.headUnitInformation.huId.consistency && vm.vehicle.headUnitInformation.present === \'YES\'" class="container-message warning"><div class="flex space-between wrapper-message"><div class=header-message><i class="icon icon-icons_warning_document"></i> <span>{{\'CONNECTED_SERVICES_WARNING_CONSISTENCY\' | translate}}</span></div><div class="content-message border"><span>BVA : {{vm.vehicle.headUnitInformation.huId.bvmAfterSales | rlinkformat }} </span><span>{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.headUnitInformation.huId.vnext | rlinkformat}} </span><span>CSDB : {{vm.vehicle.headUnitInformation.huId.kmr | rlinkformat}}</span></div></div></div></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/hu.html\'"></div></accordion-group></accordion></div><!-- BLOCK TCU --><div class=block-accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.TCU.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex><rlink-tip tip-class=label_title tip-value="{{\'EASYLINK_VEHICLE_TCU\' | translate}}" tip-title=RLINKCAR_TIP_TCU></rlink-tip><div ng-if="!vm.vehicle.tcuInformation.tcuId.consistency && vm.vehicle.tcuInformation.present === \'YES\'" class="container-message warning"><div class="flex space-between wrapper-message"><div class=header-message><i class="icon icon-icons_warning_document"></i> <span>{{\'CONNECTED_SERVICES_WARNING_CONSISTENCY\' | translate}}</span></div><div class="content-message border"><span>BVA : {{vm.vehicle.tcuInformation.tcuId.bvmAfterSales | rlinkformat }} </span><span>{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.tcuInformation.tcuId.vnext | rlinkformat}} </span><span>CSDB : {{vm.vehicle.tcuInformation.tcuId.kmr | rlinkformat}}</span></div></div></div></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/tcu.html\'"></div></accordion-group></accordion></div><!-- BLOCK STOCKAGE --><div class="block-accordion last"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.storage.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><span>{{\'RLINKCAR_STORAGE\' | translate}}</span><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/storage.html\'"></div></accordion-group></accordion></div></div><!-- EasyLink --><div ng-show=vm.isEasyLink><!--BLOCK VEHICLE INFORMATION--><div ng-if=vm.vehicleInformationDisplay class="block-accordion borderDarkening"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.vehicleInformation.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'RLINKCAR_MENU_VEC_INFO\'|translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div><div style="height: auto;"><table style="width: 100%; border-bottom: none !important;"><tr><th><span ng-if="vm.vehicle.headUnitInformation.present === \'YES\'">{{vm.vehicleInfoHeader}}</span></th><th><span>{{\'ENERGY\'|translate}}</span></th><th><span>{{\'ENGINE_TYPE\'|translate}}</span></th><th><span></span></th><th><span></span></th><th><span></span></th></tr><tr style="position: relative;top: -12px;"><td><span></span></td><td><span class=ddpFont>{{vm.contextCarRequest.fixedCriterias["019"]}} {{vm.newLocalizedData.labelCriteria ? \'-\' : \'\'}} {{vm.newLocalizedData.labelCriteria}}</span></td><td><span class=ddpFont>{{vm.contextCarRequest.fixedCriterias["999"] ? vm.contextCarRequest.fixedCriterias["999"] : \'\'}}</span></td><td><span></span></td><td><span></span></td><td><span></span></td></tr><tr><th><span>LIFECYCLE</span></th><th><span>{{\'MANUFACTURING_DATE\'|translate}}</span></th><th><span>{{\'DELIVERY_DATE\'|translate}}</span></th><th><span>{{\'DELIVERY_COUNTRY\'|translate}}</span></th><th><span>{{\'USAGE_COUNTRY\'|translate}}</span></th><th ng-if=vm.isChangeUsageCountryAuthorized class=changeUsageCountryHeader><button class=changeUsageCountryButton ng-click=vm.openChangeUsageCountryModal()>{{\'CHANGE_USER_COUNTRY_BUTTON\'|translate}}</button> <i class="fa fa-info-circle"><md-tooltip md-direction=left style="margin-top: 25px;margin-left: 10px;"><span>{{\'CHANGE_USER_COUNTRY_TOOLTIP\' | translate}}</span></md-tooltip></i></th><th ng-if=!vm.isChangeUsageCountryAuthorized><span></span></th></tr><tr style="position: relative;top: -12px;"><td><span></span></td><td><span class=ddpFont>{{vm.contextCarRequest.variableCriterias["APVDT1"] ? vm.contextCarRequest.variableCriterias["APVDT1"] : \'\'| rlinkformat:\'date\'}}</span></td><td><span class=ddpFont>{{vm.contextCarRequest.bvmExtraFields.customerDeliveryDate ? vm.contextCarRequest.bvmExtraFields.customerDeliveryDate : \'\'| rlinkformat:\'date\'}}</span></td><td><span class=ddpFont>{{vm.contextCarRequest.bvmExtraFields.paysImmat ? vm.contextCarRequest.bvmExtraFields.paysImmat : \'\'}}</span></td><td><span class=ddpFont>{{vm.connectedPlatform.country ? vm.connectedPlatform.country : \'\'}}</span></td><td ng-if=vm.isChangeUsageCountryAuthorized></td><td ng-if=!vm.isChangeUsageCountryAuthorized></td></tr><tr><th><span>MULTIMEDIA & TELEMATICS</span></th><th><span>{{\'SYSTEM_TYPE\'|translate}}</span></th><th><span>{{(vm.isCCS3Vehicle ? \'HU_CDC_INSTALLED\' : \'HU_INSTALLED\')|translate}}</span></th><th><span>{{\'TCU_INSTALLED\'|translate}}</span></th><th><span>{{\'CAR_GATEWAY\'|translate}}</span></th><th><span></span></th></tr><tr style="position: relative;top: -12px;"><td><span></span></td><td><span class=ddpFont>{{vm.vehicle.headUnitInformation.radnavSystemType.mtcCriteria | rlinkformat}}</span> <span><div style="position: relative;display: inline-block; top: 5px;"><span class="icon eye-plus-outline" ng-click="vm.showPopin = !vm.showPopin" style="height: 17px; width: 22px; top: 0px; right: 2px;"></span><div class="popin see-more" ng-if=vm.showPopin><div style="color: black;" class=popin--header><div>{{\'CONNECTED_SERVICES_SYSTEM_TYPE\' | translate}}</div><div style="color: black;" class="icon close-popin" ng-click="vm.showPopin = false">X</div></div><div class=popin--content><div>{{\'EASYLINK_RADNAV\' | translate}} : {{vm.vehicle.headUnitInformation.radnavSystemType.name | rlinkformat}}</div><div>{{\'EASYLINK_SHORT_DESCRIPTION\' | translate}} : {{vm.vehicle.headUnitInformation.radnavSystemType.description | rlinkformat}}</div></div></div></div></span></td><td><span class=ddpFont>{{vm.vehicle.headUnitInformation.present}}</span></td><td><span class=ddpFont>{{vm.vehicle.tcuInformation.present}}</span></td><td><span class=ddpFont>{{vm.connectedPlatform.platform ? vm.connectedPlatform.platform : \'\'}}</span></td><td><span></span></td></tr></table></div></div></accordion-group></accordion></div><!-- Connectivity & Multimedia--><div class="block-accordion borderDarkening" ng-if="vm.vehicleInformationDisplay "><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.connectivity.isOpen><accordion-heading><div class=section_header ng-click="vm.accordions.connectivity.isOpen = !vm.accordions.connectivity.isOpen"><div><span>{{\'CONNECTIVITY_MULTIMEDIA\' | translate}} </span><span ng-if="vm.vehicle.connectivity.status === \'OK\'" class=success-message><i class=icon-success></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'WARNING\'" class=warning-message><i class=icon-warning></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'KO\'" class=error-message><i class=icon-error></i> {{vm.vehicle.connectivity.status}} </span><span class="fa fa-info-circle" style="cursor: pointer; left: 5%; position: relative;" ng-click=vm.connectivityMediaStatusPopup(true);></span></div></div></accordion-heading><div><div><table style="display: inline !important;border: none;"><tr ng-if="vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\' && !vm.vehicle.headUnitInformation.huId.consistency" style="display: flex;"><th scope=col><div class="container-message warning" style="width: 650px!important;display: inline;"><div class="flex space-between wrapper-message"><div class="content-message border"><i class="icon icon-icons_warning_document"></i> <span style="font-weight: normal">BVA : {{vm.vehicle.headUnitInformation.huId.bvmAfterSales | rlinkformat }} </span><span style="font-weight: normal">{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.headUnitInformation.huId.vnext | rlinkformat}} </span><span style="font-weight: normal">{{vm.vcps}} : {{vm.vehicle.headUnitInformation.huId.vehicleReferential | rlinkformat}}</span></div></div></div></th><th scope=col></th><th scope=col></th><th scope=col></th></tr><tr ng-show="vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\'"><th><span>{{(vm.isCCS3Vehicle ? \'HU_CDC_SERIAL_NO\' : \'HU_SERIAL_NO\') | translate}}</span></th><th><span>{{(vm.isCCS3Vehicle ? \'HU_CDC_SOFTWARE_VER\' : \'HU_SOFTWARE_VER\') | translate}}</span></th><th></th><th><div ng-click=vm.refreshDataElectronicFile() class=rlink-tip style="top: 3px;cursor: pointer;float: right;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></th></tr><tr ng-show="vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\'" style="position: relative;bottom: 10px;"><td><span class=ddpFont>{{vm.vehicle.electronicFile.iviSerialNumber | rlinkformat}}</span></td><td><span class=ddpFont>{{vm.vehicle.electronicFile.iviSoftwareVersion | rlinkformat}}</span></td><td></td><td></td></tr><tr class=grayBorderBottomSeperator></tr><tr ng-show="vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === \'YES\' && !vm.vehicle.tcuInformation.tcuId.consistency"><th><div class="container-message warning" style="width: 650px!important"><div class="flex space-between wrapper-message"><div class="content-message border"><i class="icon icon-icons_warning_document" style="font-weight: bold;"></i> <span style="font-weight: normal">BVA : {{vm.vehicle.tcuInformation.tcuId.bvmAfterSales | rlinkformat }} </span><span style="font-weight: normal">{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.tcuInformation.tcuId.vnext | rlinkformat}} </span><span style="font-weight: normal">{{vm.vcps}} : {{vm.vehicle.tcuInformation.tcuId.vehicleReferential | rlinkformat}}</span></div></div></div></th><th></th><th></th><th></th></tr><tr ng-show="vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === \'YES\'"><th><span>{{\'TCU_SERIAL_NO\' | translate}}</span></th><th><span>{{\'TCU_TYPE_VER\' | translate}}</span></th><th><span>{{\'TCU_SOFTWARE_VER\' | translate}}</span></th><th scope=col></th></tr><tr style="position: relative;bottom: 10px;" ng-show="vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === \'YES\'"><td><span class=ddpFont>{{vm.vehicle.electronicFile.ivcSerialNumber | rlinkformat}}</span></td><td><span class=ddpFont>{{vm.vehicle.tcuInformation.type | rlinkformat}}</span></td><td><span class=ddpFont>{{vm.vehicle.electronicFile.ivcSoftwareVersion | rlinkformat}}</span></td><td></td></tr><tr class=grayBorderBottomSeperator></tr><tr><th><span>{{\'TELECOM\' | translate}}</span></th><th></th></tr><tr style="position: relative;bottom: 10px;"><td><span class=ddpFont>{{vm.vehicle.simInformation.telecomOperator | rlinkformat}}</span></td><td></td></tr><tr class=grayBorderBottomSeperator></tr><tr><th><span>{{\'SIM_STATUS\' | translate}}</span></th><th scope=col ng-if="vm.connectedPlatform.country === \'TR\'"><span>{{\'SIM_CONNECTIVITY_STATUS\' | translate}} <i class="fa fa-info-circle infoButtonDesign"></i><md-tooltip class=pbo-tooltip md-direction=right>{{ \'TURKISH_VEHICLE\' | translate}}</md-tooltip></span></th><th></th><th ng-if="vm.csrButtonShow && vm.vehicle && vm.vehicle.simInformation && \n                                               vm.vehicle.simInformation.telecomOperator === \'ORANGE\'"><button ng-click=vm.goToCsrPortal() style="font-size: var(--renaultSmallFont); vertical-align: middle; text-transform: uppercase; color: black; margin-bottom: 0px !important; padding: 11px 10px 11px 10px;" ng-class="{\'nissanActiveMenuTab\': vm.nissanUserURL, \'renaultBgTabColor\': !vm.nissanUserURL}">{{vm.csrPortalLabel | uppercase}}</button></th></tr><tr class=simStatus ng-if="vm.connectedPlatform.country === \'TR\' && vm.displaySimInfo"><th scope=col>-</th><th id=simStatusDisplay><span class=simOnColor ng-if="vm.simInfo.status === \'ON\'">{{\'SIM_STATUS_ON\' | translate}}</span> <span class=simOffColor ng-if="vm.simInfo.status === \'OFF\'">{{\'SIM_STATUS_OFF\' | translate}}</span></th><th scope=col></th></tr><tr class=simDate ng-if="vm.connectedPlatform.country === \'TR\' && vm.displaySimInfo"><th scope=col></th><th id=simDate><span>{{vm.simInfo.lastUpdatedTime ? vm.simInfo.lastUpdatedTime : \'\'| rlinkformat:\'date\'}}</span></th><th scope=col></th></tr><tr ng-if="vm.connectedPlatform.country === \'TR\' && !vm.displaySimInfo"><th scope=col></th><th id=simDate><span class=ddpFont>{{\'SIM_STATUS_UNKNOWN\' | translate}}</span></th><th scope=col></th></tr><tr style="position: relative;bottom: 10px;"><td><span class=ddpFont style="text-transform: uppercase; color: #00BF00;">{{vm.vehicle.simInformation.simStatus | rlinkformat}}</span></td><td></td><td></td><td></td></tr><tr class=grayBorderBottomSeperator></tr><!-- <tr>\n                                    <th><span>{{systemLabel  | translate}}</span></th>\n                                    <th></th>\n                                    <th></th>\n                                    <th></th>\n                    \n                                </tr> --><!-- <tr style="position: relative;bottom: 10px;">\n                                    <td><span class="ddpFont">{{vm.vehicle.simInformation.provisioningRegion | rlinkformat}} </span></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class="grayBorderBottomSeperator"></tr> --><tr><th scope=col><span style="white-space: break-spaces;">{{\'PRIVACY_MODE\' | translate}}</span> <i ng-if="vm.vehicle.vehicleInformation.privacyType === \'LEGACY_PRIVACY\' || vm.vehicle.vehicleInformation.privacyType === \'GRANULAR_PRIVACY\'" ng-click=vm.dataPrivacyModal() style="font-size: large; position: relative; left: 6px; cursor: pointer;" class="fa fa-info-circle"></i></th><th scope=col></th><th scope=col></th><th scope=col></th><th scope=col></th><th scope=col></th></tr><tr ng-if="vm.vehicle.vehicleInformation.privacyType === \'LEGACY_PRIVACY\' "><th><span>{{\'LEGACY_PRIVACY\' | translate}}</span><div ng-click=vm.refreshPrivacyData() class=rlink-tip><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i style="margin-left: 13px; font-size: larger;cursor: pointer;" class="fa fa-refresh" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></th></tr><tr ng-if="vm.vehicle.vehicleInformation.privacyType === \'UNKNOWN\'"><th><span>{{(vm.nissanUserURL ? \'EASYLINK_VEHICLE_NOT_ELIGIBLE_NISSAN\' : \'EASYLINK_VEHICLE_NOT_ELIGIBLE\') | translate | uppercase}}</span></th></tr><tr ng-if="vm.vehicle.vehicleInformation.privacyType === \'GRANULAR_PRIVACY\'"><th><span>{{\'GRANULAR_PRIVACY\' | translate}}</span><div ng-click=vm.refreshPrivacyData() class=rlink-tip><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i style="margin-left: 13px; font-size: larger;cursor: pointer;" class="fa fa-refresh" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></th></tr><tr><td><div ng-repeat="element in vm.vehicle.vehicleInformation.granularDataPrivacy track by $index" ng-style="{\'padding-top\':($index == 3 || 4) ? \'10px\':\'0px\',\n                                                       \'clear\': $index % 3 === 0 ? \'left\' : \'none\'}" ng-if="vm.vehicle.vehicleInformation.privacyType === \'GRANULAR_PRIVACY\'" class="small-4 column"><div class=granularPrivacyDisplay><i class="fa fa-circle iconMargin" ng-style="{\'color\':{{element.status === \'ACTIVE\'}} ? \'#00BF00\': \'#c80e0e\'}"></i><div><span class=ddpFont>{{element.label}} <span ng-if="element.category === \'RED_III_ERP\'\n                                                              || element.category === \'RED_III_CHARGE\'" class=categoryDisplay>{{element.category | underscoreToSpace}}</span></span><div class=ddpFont>Updated on {{element.lastUpdateDatetime | rlinkformat:\'full-date\'}}</div></div></div></div><div class="small-4 column"></div></td></tr><tr ng-if="vm.vehicle.vehicleInformation.legacyDataPrivacy && \n                                           vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode" ng-style="{\'bottom\':vm.vehicle.vehicleInformation.privacyType === \'LEGACY_PRIVACY\' ? \'20px\':\'0px\',\n                                              \'position\':\'relative\'}"><th><span ng-if="vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode === \'DATA_OFF\'" class=ddpFont style="text-transform: uppercase; color: #c80e0e;">{{vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode | uppercase}} </span><span ng-if="vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode === \'DATA_ON\'" class=ddpFont style="text-transform: uppercase; color: #00BF00;">{{vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode | uppercase}} </span><span ng-if="vm.vehicle.vehicleInformation.dataPrivacy === null\n                                                    && vm.vehicle.vehicleInformation.privacyType === \'LEGACY_PRIVACY\'" class=ddpFont style="text-transform: uppercase;">{{vm.vehicle.vehicleInformation.legacyDataPrivacy.privacyMode | uppercase}}</span></th></tr><tr><td ng-if="vm.vehicle.vehicleInformation.privacyType === \'LEGACY_PRIVACY\'"><span style="position: relative;bottom: 30px;" class=ddpFont>{{vm.vehicle.vehicleInformation.legacyDataPrivacy.lastUpdateDate | rlinkformat:\'full-date\'}}</span></td></tr></table></div></div><!-- Replacement History TCU --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/tcu.html\'"></div><!-- Replacement History TCU --><div ng-show="vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\'" ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/hu.html\'"></div></accordion-group></accordion></div><!-- BLOCK CONNECTIVITE--><div class=block-accordion ng-if=!vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.connectivity.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'RLINKCAR_CONNECTIVITY\' | translate}}</span> <span ng-if="vm.vehicle.connectivity.status === \'OK\'" class=success-message><i class=icon-success></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'WARNING\'" class=warning-message><i class=icon-warning></i> {{vm.vehicle.connectivity.status}} </span><span ng-if="vm.vehicle.connectivity.status === \'KO\'" class=error-message><i class=icon-error></i> {{vm.vehicle.connectivity.status}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div class=flex><div class="flex-flow-column flex-50"><!-- BLOCK PBO --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/pbo.html\'"></div><!-- BLOCK SIM --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/simStatus.html\'"></div><!-- BLOCK COMMUNICATION SERVERS --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/communicationServers.html\'"></div></div><div class="flex-flow-column flex-50"><!-- BLOCK BOOTSTRAP HU --><div ng-if=!vm.noHu ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/huStatus.html\'"></div><!-- BLOCK BOOTSTRAP TCU --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/tcuStatus.html\'"></div><!-- BLOCK OTP PAIRING --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/otp.html\'"></div></div></div><!-- LAST COMMUNICATIONS --><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/lastCom.html\'"></div></accordion-group></accordion></div><!-- BLOCK HU --><div class=block-accordion ng-if=!vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.HU.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex><rlink-tip tip-class=label_title tip-value="{{\'CONNECTED_SERVICES_LABEL_HU\' | translate}}" tip-title=RLINKCAR_TIP_HU></rlink-tip><div ng-if="!vm.vehicle.headUnitInformation.huId.consistency && vm.vehicle.headUnitInformation.present === \'YES\'" class="container-message warning"><div class="flex space-between wrapper-message"><div class=header-message><i class="icon icon-icons_warning_document"></i> <span>{{\'CONNECTED_SERVICES_WARNING_CONSISTENCY\' | translate}}</span></div><div class="content-message border"><span>BVA : {{vm.vehicle.headUnitInformation.huId.bvmAfterSales | rlinkformat }} </span><span>{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.headUnitInformation.huId.vnext | rlinkformat}} </span><span>VCPS : {{vm.vehicle.headUnitInformation.huId.kmr | rlinkformat}}</span></div></div></div></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/hu.html\'"></div></accordion-group></accordion></div><!-- BLOCK TCU --><div class=block-accordion ng-if=!vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.TCU.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex><rlink-tip tip-class=label_title tip-value="{{\'EASYLINK_VEHICLE_TCU\' | translate}}" tip-title=RLINKCAR_TIP_TCU></rlink-tip><div ng-if="!vm.vehicle.tcuInformation.tcuId.consistency && vm.vehicle.tcuInformation.present === \'YES\'" class="container-message warning"><div class="flex space-between wrapper-message"><div class=header-message><i class="icon icon-icons_warning_document"></i> <span>{{\'CONNECTED_SERVICES_WARNING_CONSISTENCY\' | translate}}</span></div><div class="content-message border"><span>BVA : {{vm.vehicle.tcuInformation.tcuId.bvmAfterSales | rlinkformat }} </span><span>{{vm.connectedPlatform.platform === \'CVC\' ? \'CVC\' : \'VNEXT\'}} : {{vm.vehicle.tcuInformation.tcuId.vnext | rlinkformat}} </span><span>VCPS : {{vm.vehicle.tcuInformation.tcuId.kmr | rlinkformat}}</span></div></div></div></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/tcu.html\'"></div></accordion-group></accordion></div><!-- USAGE MODE --><accordion class="collapse section_wrapper" close-others=false ng-if=vm.isUsageModeEnabled><accordion-group is-open=vm.accordions.usageMode.isOpen><accordion-heading><div class=section_header><span>{{\'USAGE_MODE\' | translate}}<div class=rlink-tip><i style="font-size: large; position: relative; left: 6px; cursor: pointer;" class="fa fa-info-circle ng-scope" role=button tabindex=0></i> <span class=rlink-tip-txt>{{\'USAGE_MODE_TOOLTIP\' | translate}}</span></div></span><i ng-class="{\'icon-arrow_close\': $parent.isOpen, \'icon-arrow_open\': !$parent.isOpen}"></i></div></accordion-heading><div><table class=usageModeTable><tr><th>{{\'CURRENT_STATUS\' | translate}} <i style="font-size: large; position: relative; left: 6px; cursor: pointer;" class="fa fa-info-circle ng-scope" ng-click="vm.currentStatusPopup(\'hi\')" role=button tabindex=0></i></th><th></th></tr><tr><td class=usageModeText>{{vm.usageMode === \'B2C\' ? \'B2C with pairing\' : vm.usageMode === \'B2B\' ? \'B2B without pairing\' : vm.usageMode}}</td><td><button ng-if="vm.usageMode === \'B2B\' || vm.usageMode === \'B2C\'" ng-click=vm.patchUsageMode(vm.usageMode) class=patchButton>MODE {{ vm.usageMode === \'B2B\' ? \'B2C with pairing\' : \'B2B without pairing\' }}</button></td></tr></table></div></accordion-group></accordion><!-- Battery information--><div ng-if="vm.vehicleInformationDisplay && vm.batteryInfoDispaly()" class="block-accordion borderDarkening"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.batteryInformation.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'RLINKCAR_MENU_BATTERY_INFO\'|translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div><div ng-if=!vm.onlyBlms style="height: auto"><table style="border: none;"><tr><th><span>{{\'ACTIS_VEHICLE_BIN\' | translate}}</span></th><th><span>{{\'RLINKCAR_MENU_AVAILABLE\' | translate}}</span></th><th><span style="font-size: var(--renaultMediumFont);">{{\'RLINKCAR_MENU_LAST_TIME\' | translate}}</span></th><th><span>{{\'RLINKCAR_MENU_BATTERY_CERTIFICATE\' | translate}}</span></th><th ng-if=vm.showBatteryInhibition><span>{{\'BATTERY_INHIBITION_STATUS\' | translate}}</span></th></tr><tr><th><span ng-if=vm.vehicle.batteryResponse.bin class=ddpFont>{{vm.vehicle.batteryResponse.bin}}</span> <span ng-if=!vm.vehicle.batteryResponse.bin class=ddpFont>{{\'-\'}}</span></th><th><span ng-if=vm.vehicle.batteryResponse.availableEnergy class=ddpFont>{{vm.vehicle.batteryResponse.availableEnergy}}</span> <span ng-if=!vm.vehicle.batteryResponse.availableEnergy class=ddpFont>{{\'-\'}}</span></th><th><span ng-if=vm.vehicle.batteryResponse.lastUpdateTime class=ddpFont>{{vm.vehicle.batteryResponse.lastUpdateTime}}</span> <span ng-if=!vm.vehicle.batteryResponse.lastUpdateTime class=ddpFont>{{\'-\'}}</span></th><th><button ng-click=vm.openBlmsInfo() style="font-size: var(--renaultSmallFont); vertical-align: middle; text-transform: uppercase; background-color: var(--renaultPrimaryColor); color: #fff; margin-bottom: 0px !important; padding: 11px 7px 11px 7px;font-family: var(--renaultFontRegular);border: none;" ng-class="{\'nissanActiveMenuTab\': vm.nissanUserURL, \'renaultBgTabColor\': !vm.nissanUserURL}">{{\'BLMS_INFO\' | translate}}</button></th><th ng-if=vm.showBatteryInhibition style="font-size: 12px !important;"><span><span ng-switch=vm.inhibitionStatus style="left: 8%; position: relative;"><span ng-switch-when=true><i class="fa fa-circle greenDisc"></i> {{ \'BATTERY_CHARGING_ALLOWED\' | translate }} <span class=ddpFont style="font-size: 12px !important;">{{ vm.inhibitionLastUpdateDateTime ? (vm.inhibitionLastUpdateDateTime | rlinkformat:\'full-date\') : \'-\' }} </span></span><span ng-switch-when=false><i class="fa fa-circle redDisc"></i> {{ \'BATTERY_CHARGING_NOT_ALLOWED\' | translate }} </span><span ng-switch-default>-</span></span></span></th></tr></table></div><div ng-if=vm.onlyBlms><table><tr><th><span>{{\'RLINKCAR_MENU_BATTERY_CERTIFICATE\' | translate}}</span></th></tr><tr><th><button ng-click=vm.openBlmsInfo() style="font-size: var(--renaultSmallFont); vertical-align: middle; text-transform: uppercase; color: #fff; background-color: var(--renaultPrimaryColor); margin-bottom: 0px !important; padding: 11px 7px 11px 7px;font-family: var(--renaultFontRegular);border: none;" ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'renaultBgTabColor\': !vm.nissanUserURL}">{{\'BLMS_INFO\' | translate}}</button></th></tr></table></div></div></accordion-group></accordion></div><!-- SIM Last Communications--><div class="block-accordion borderDarkening" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.sim.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'CONNECTED_SERVICES_LAST_COMMUNICATIONS\' | translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><div ng-click=vm.refreshPrivacyData() class=rlink-tip style="left: 97%;top: 3px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="padding:4px;float: right;margin-top: 0px;font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></div></div><!-- BLOCK SIM Last Communications--><div ng-include src="\'app/components/car/rLinkCar/vehicleInformations/EasyLink/lastCom.html\'"></div></accordion-group></accordion></div><!-- Process --><div class="block-accordion borderDarkening" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.process.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'PROCESSES\' | translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div><div><table style="margin-bottom: 0px !important;"><thead><tr><th><span></span></th><th><span>{{\'SEARCH_SPECIALIZED_TOOL_DROPDOWN_TITLE\' | translate | uppercase}}</span></th><th><span>{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}</span></th></tr></thead><tbody class=processTable><tr><td class=processLabel><span>{{\'PROVISIONING_STATUS\' | translate}}</span></td><td class=statusVal><span ng-if=vm.vehicle.vehicleInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} = {{\'CONNECTED_SERVICES_COMPLETED_STATUS\' | translate}} </span><span ng-if=!vm.vehicle.vehicleInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.vehicle.vehicleInformation.bootstrap.done === null" class=nd-message>-</span></td><td class=processLabel><span>{{vm.vehicle.vehicleInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.vehicleInformation.bootstrap.history[0].datetime>-</span></td></tr><tr ng-if="vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === \'YES\'"><td class=processLabel><span>{{\'BOOTSTRAP_IVC\' | translate}}</span></td><td class=statusVal><span ng-if=vm.vehicle.tcuInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} </span><span ng-if=!vm.vehicle.tcuInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.vehicle.tcuInformation.bootstrap.done === null" class=nd-message>-</span></td><td class=processLabel><span>{{vm.vehicle.tcuInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.tcuInformation.bootstrap.history[0].datetime>-</span></td></tr><tr ng-if="vm.vehicle.headUnitInformation && vm.vehicle.headUnitInformation.present === \'YES\'"><td class=processLabel><span>{{(vm.isCCS3Vehicle ? \'BOOTSTRAP_CDC\' : \'BOOTSTRAP_IVI\') | translate}}</span></td><td class=statusVal><span ng-if=vm.vehicle.headUnitInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} </span><span ng-if=!vm.vehicle.headUnitInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.vehicle.headUnitInformation.bootstrap.done === null" class=nd-message>-</span></td><td class=processLabel><span>{{vm.vehicle.headUnitInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.headUnitInformation.bootstrap.history[0].datetime>-</span></td></tr><tr ng-if="vm.isCCS3Vehicle || vm.vehicle.headUnitInformation.radnavSystemType.mtcCriteria !== \'RA47D\'"><td class=processLabel><span>{{ (vm.isCCS3Vehicle ? \'VLC_STATE\' : \'PBO_REQ_FROM_ON_BOARD\') | translate }}</span></td><td class=statusVal ng-if=!vm.isCCS3Vehicle><span ng-if="vm.vehicle.pboRequestInfo.pboRequestDone === true" class=success-message><i class=icon-success></i> {{\'PBO_REQUESTED\' | translate}} </span><span ng-if="vm.vehicle.pboRequestInfo.pboRequestDone === false" class=error-message><i class=icon-error></i> {{\'PBO_REQUESTED_NOT\' | translate}} </span><span ng-if="vm.vehicle.pboRequestInfo.pboRequestDone === null" class=nd-message>-</span></td><td class=statusVal ng-if=vm.isCCS3Vehicle><span ng-if="(vm.vehicle.pboInformations.details.vlc.state || \'\').toUpperCase() === \'CUSTOMER_READY\'" class=success-message><i class=icon-success></i> {{vm.vehicle.pboInformations.details.vlc.state | rlinkformat:\'status\'}} </span><span ng-if="(vm.vehicle.pboInformations.details.vlc.state || \'\').toUpperCase() === \'NOT_READY\'" class=error-message><i class=icon-error></i> {{vm.vehicle.pboInformations.details.vlc.state | rlinkformat:\'status\'}} </span><span ng-if="!vm.vehicle.pboInformations.details.vlc || \n                                                 !vm.vehicle.pboInformations.details.vlc.state || \n                                                 vm.vehicle.pboInformations.details.vlc.state === null" class=nd-message>-</span></td><td class=processLabel ng-if=vm.isCCS3Vehicle><span>{{vm.vehicle.pboInformations.details.vlc.details.modifiedAt | rlinkformat:\'full-date\'}} </span><span ng-if="!vm.vehicle.pboInformations.details.vlc || !vm.vehicle.pboInformations.details.vlc.details || !vm.vehicle.pboInformations.details.vlc.details.modifiedAt">-</span></td><td class=processLabel ng-if=!vm.isCCS3Vehicle><span>{{vm.vehicle.pboRequestInfo.details.modifiedAt | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.pboRequestInfo.details.modifiedAt>-</span></td></tr><tr ng-if="vm.isCCS3Vehicle || vm.vehicle.headUnitInformation.radnavSystemType.mtcCriteria !== \'RA47D\'"><td class=processLabel><span>{{vm.isCCS3Vehicle ? \'SERVICE_ACTIVATION_CCS3\' : \'PBO_SERVICE_ACTIVATION\' | translate}} <i ng-if=!vm.isCCS3Vehicle class="fa fa-info-circle info-icon-style"></i><md-tooltip ng-if=!vm.isCCS3Vehicle class=pbo-tooltip md-direction=right>{{ \'PBO_SERVICE_DATE\' | translate}}</md-tooltip></span></td><td class=statusVal ng-if=!vm.isCCS3Vehicle><span ng-if="vm.vehicle.pboInformations.pushButtonActivated === true && \n                                                 vm.vehicle.pboInformations.details.currentState === \'IN_PROGRESS\'" class=warning-message><i class=icon-warning></i> {{vm.vehicle.pboInformations.details.currentState | rlinkformat}} </span><span ng-if="vm.vehicle.pboInformations.pushButtonActivated === true && \n                                                 vm.vehicle.pboInformations.details.currentState !== \'IN_PROGRESS\'" class=success-message><i class=icon-success></i> {{vm.vehicle.pboInformations.details.currentState | rlinkformat}} </span><span ng-if="vm.vehicle.pboInformations.pushButtonActivated === false" class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_NOTACHIEVED\' | translate}} </span><span ng-if="vm.vehicle.pboInformations.pushButtonActivated === null" class=nd-message>-</span></td><td class=statusVal ng-if=vm.isCCS3Vehicle><span ng-if="vm.vehicle.pboInformations.details.currentState === \'ACTIVATED\'" class=success-message><i class=icon-success></i> {{vm.vehicle.pboInformations.details.currentState | rlinkformat:\'status\'}} </span><span ng-if="vm.vehicle.pboInformations.details.currentState === \'NOT_ACTIVATED\'" class=error-message><i class=icon-error></i> {{vm.vehicle.pboInformations.details.currentState | rlinkformat:\'status\'}}</span></td><td class=processLabel><span ng-if=vm.vehicle.pboInformations.details.modifiedAt>{{vm.vehicle.pboInformations.details.modifiedAt | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.pboInformations.details.modifiedAt>-</span></td></tr><tr ng-if="vm.isCCS3Vehicle || vm.vehicle.headUnitInformation.radnavSystemType.mtcCriteria !== \'RA47D\'"><td class=processLabel><span>{{\'OTP_PAIRING_STATUS\' | translate}} <i class="fa fa-info-circle info-icon-style"></i><md-tooltip class=pbo-tooltip md-direction=right>{{ \'OTP_PAIRING_STATUS_TOOLTIP\' | translate}}</md-tooltip></span></td><td class=statusVal><span ng-if="vm.vehicle.owner.otpPairing === true" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACHIEVED\' | translate}} </span><span ng-if="vm.vehicle.owner.otpPairing === false" class="warning-message otpPairingStatus"><i class="icon-warning otpPairingIcon"></i> <span>{{vm.nissanUserURL ? \'OTP_PAIRING_NOT_AVAILABLE\' : \'CONNECTED_SERVICES_NOTACHIEVED\' | translate}}</span> </span><span ng-if="vm.vehicle.owner.otpPairing === null" class=nd-message>-</span></td><td class=processLabel><span>{{vm.vehicle.owner.otpDateTime | rlinkformat:\'full-date\'}} </span><span ng-if=!vm.vehicle.owner.otpDateTime>-</span></td></tr></tbody></table></div></div></accordion-group></accordion></div></div>');
$templateCache.put('app/components/car/rLinkCar/virtualKey/virtualKey.template.html','<div ng-show=vm.isEasyLink class=virtualTableBorder><!-- EasyLink / OpenRLink --><div class="block-accordion contracts virtualKeyData"><div class="block-accordion dataConsistencyTable" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.virtualKey.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen" style="margin-bottom: 1rem;"><div><span>{{vm.virtualKey | uppercase }} {{vm.uidTitle}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div class=blmServiceActivation><span class=blmVehicle ng-if="vm.uidTitle && vm.uidTitle === \'UID 590\'"><i ng-if=vm.virtualServiceActivated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.virtualServiceActivated class="fa fa-circle redDisc"></i> {{ vm.virtualServiceActivated ? \'SERVICE_ACTIVATED\' : \'SERVICE_INACTIVATED\' | translate}} </span><span class=blmVehicle ng-if="vm.uidTitle && vm.uidTitle === \'UID 592\'"><i ng-if=vm.virtualB2B592ServiceActivated class="fa fa-circle greenDisc"></i> <i ng-if=!vm.virtualB2B592ServiceActivated class="fa fa-circle redDisc"></i> {{ vm.virtualB2B592ServiceActivated ? \'SERVICE_ACTIVATED\' : \'SERVICE_INACTIVATED\' | translate}} </span><span ng-if="!vm.uidTitle && vm.isVirtualNoneActivated" class=blmVehicle><i ng-if=vm.isVirtualNoneActivated class="fa fa-circle redDisc"></i> {{vm.isVirtualNoneActivated ? \'SERVICE_INACTIVATED\' : \'\' | translate}} </span><span class=blmStatusInfo><span class=blmInfoCircle><i class="fa fa-info-circle"></i></span><p class=blmInfoMsg>{{\'VIRTUAL_KEY_INFO\' | translate}}</p></span></div></accordion-group></accordion></div></div>&nbsp;<div class="block-accordion contracts virtualKeyData"><div class="block-accordion dataConsistencyTable" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.blmTabOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen" style="margin-bottom: 1rem;"><div><span>BLM ECU</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div style="border: none !important;" class=block_body><div class=table_block_body><table style="border: none !important;margin-bottom:0px;    bottom: 3px;\n                            position: relative;border-collapse: collapse;width: 100%;"><thead table-width><tr><th><span class=blmTitle>{{vm.blmEcu}}</span></th><th><div class=blmInfo><i class="fa fa-info-circle userRoleInfoIcon" style="padding-right: 0.5rem;"></i> <span class=blmEcuFont>{{\'BLM_ECU_INFO\' | translate}}</span></div></th><th></th><th><div ng-click=vm.refreshData(true) class=rlink-tip style="left: 87%;height: 25px;position: relative;cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="float: right;font-size: large;cursor: pointer;position: relative;height: 25px;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></div></th></tr><tr><th class=blmBorderBottom></th><th></th><th></th><th></th></tr><tr style="left: 1.5%; position: relative;"><th><span class=virtualBoldFont>{{\'VIRTUAL_KEY_SERIAL_NO\' | translate}}</span></th><th><span class=virtualBoldFont>{{\'BLMS_SOFTWARE_VERSION\' | translate}}</span></th><th><span class=virtualBoldFont>{{\'EASYLINK_VEHICLE_CREATION_DATE\' | translate}}</span></th><th><span></span></th></tr><tr style="left: 1.5%; position: relative;"><th><span style="position: relative; bottom: 10px;" class=blmEcuFont>{{vm.id}}</span></th><th><span style="position: relative;bottom: 10px;" class=blmEcuFont>{{vm.swVersion}}</span></th><th><span style="position: relative; bottom: 10px;" class=blmEcuFont>{{vm.blmsCreationDate | rlinkformat:\'full-date\'}}</span></th><th><span></span></th></tr><br><tr><th></th><th></th><th></th><th></th></tr><tr><th></th><th class=ddpHeader><span>{{vm.bva}}</span></th><th class=ddpHeader><span>{{vm.vkm}}</span></th><th class=ddpHeader><span>{{\'RLINKCAR_HU_STATUS\' | translate}}</span></th></tr></thead><tbody><tr><td class="table-padding-td ddpBody"><span class=virtualBoldFont>{{\'BLM_SERIAL_NO\' | translate}}</span></td><td class="table-padding-td ddpBody"><span>{{vm.bvaSn | rlinkformat}}</span></td><td class="table-padding-td ddpBody"><span>{{vm.vkSn | rlinkformat}}</span></td><td class="table-padding-td ddpBody"><span ng-if="vm.isBlmBootstrapped !== null && vm.isBlmBootstrapped !== undefined"><em ng-class="vm.isBlmBootstrapped ? \'fa fa-check blmStatusGreen\' : \'fa fa-close blmStatusRed\'"></em> <span style="left: 3%;position: relative;text-transform: capitalize !important;" ng-class="(vm.isBlmBootstrapped && vm.isBlmBootstrapped !== null) ? \'blmStatusGreen\' : \'blmStatusRed\'">{{vm.isBlmBootstrapped | rlinkformat}}</span></span></td></tr></tbody></table></div></div></accordion-group></accordion><accordion><div style="margin-top: 10px; float: right;"><span><button class="cs-btn syncButton" ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.showConfirmationPopup() ng-disabled=vm.isBlmBootstrapped><div class=btnText>{{\'RLINK_SYNCHRONIZE_SERIAL_NUMBER\' | translate}}</div></button></span></div></accordion></div></div><div ng-if="vm.uidTitle === \'UID 590\'" style="padding-top: 5%;" class="block-accordion contracts virtualKeyData"><div class="block-accordion dataConsistencyTable" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.roleTabOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen" style="margin-bottom: 1rem;"><div><span>{{\'ROLE_DELEGATION_AND_SHARED_KEYS\' | translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><span class=roleDelegationTitle>{{\'ROLE_DELEGATION_AND_SHARED_KEYS\' | translate}}</span> <span class=roleInfo_icon><i class="fa fa-info-circle" style="padding-right: 0.5rem;cursor:pointer;" ng-click=vm.launchVirtualRoleDelegationModal()></i> </span><span ng-click=vm.refreshData(true) class=rlink-tip ng-style="{\'left\':vm.userProfile.language == \'en\'? \'68%\':\'65%\'}" style="position: relative; cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></span><div class=grayBorderSeperator></div><br><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.usersRolesDelegated"><accordion-group class=ddpAccordBorder style="margin-bottom: 1% !important;"><accordion-heading><div class="roleDelegationSubItems sub_items_header section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-4 virtualBoldFont">{{\'VIRTUAL_PERSON_ID\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-1></span> <span class=grid__col-1></span> <span class="grid__col-4 virtualBoldFont">{{\'AUDIT_ROLE\' | translate}}</span> <span class=grid__col-1></span></div><div class="roleDelegationSubItems section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span style="margin-top: -20px;" class="grid__col-4 campaignTitleName virtualBoldFont">{{item.personId | rlinkformat}} </span><span class=grid__col-1></span> <span class=grid__col-1></span> <span class=grid__col-1></span> <span style="margin-top: -20px;" class="grid__col-4 virtualBoldFont">{{item.userRoles | rlinkformat}}</span> <span class=grid__col-1></span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item != \'\'"></i> <span class=arrow ng-if="item == \'\'"></span></div></accordion-heading><div class=softwareHeight><div class=grayBorderSeperator></div><div style="margin-bottom: -12px;" class="roleDelegationSubItems flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span style="padding-left: 1.5%;"></span> <span class=grid__col-2>{{\'SHARED_BY\' | translate}}</span> <span class=grid__col-1><span>{{\'VIRTUAL_KEY_RIGHT\' | translate}}</span><span class=roleInfo_icon><i class="fa fa-info-circle" style="padding-right: 0.5rem;font-size: var(--renaultMediumFont) !important; cursor:pointer;" ng-click=vm.showRightDescriptionModal()></i></span></span> <span class=grid__col-1>{{\'VIRTUAL_KEY_RIGHT_ID\' | translate}} </span><span class=grid__col-2><span>{{\'COMMON_STATUS\' | translate}}</span><span class=roleInfo_icon><i class="fa fa-info-circle" style="padding-right: 0.5rem;font-size: var(--renaultMediumFont) !important; cursor:pointer;" ng-click=vm.showRoleDelegationStatusModal()></i></span></span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span></div><div class="flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2">{{\'USED_KEYS\' | translate}}</span> <span></span> <span class=grid__col-2></span> <span class=grid__col-1></span> <span class=grid__col-1></span> <span class=grid__col-2></span> <span class=grid__col-2></span> <span class=grid__col-2></span></div><div class="flex sub_items_content grid--no-gutter" ng-repeat="used in item.usedKeys" ng-if="item.usedKeys && item.usedKeys.length > 0"><span class="grayRightBorder grid__col-2"></span> <span><i class="fa fa-clone" style="padding-left: 2.5px; cursor: pointer; font-size: var(--renaultMediumFont);" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(used.sharedBy)></i></span> <span class="grid__col-2 campaignTitleName">{{used.sharedBy | rlinkformat}}<md-tooltip>{{used.sharedBy | rlinkformat}}</md-tooltip></span><span class=grid__col-1>{{used.right | rlinkformat}}</span> <span class=grid__col-1>{{used.rightId | rlinkformat}} </span><span class=grid__col-2 ng-class="used.status === \'VALID\' ? \'success-message\' : \'error-message\'">{{used.status | rlinkformat}} </span><span class=grid__col-2>{{used.startDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{used.endDate | rlinkformat:\'full-date\'}}</span></div><div class="flex sub_items_header grid--no-gutter" ng-if="item.usedKeys.length === 0"><span class="grayRightBorder grid__col-2"></span> <span style="padding-left: 2%;"></span> <span class="grid__col-2 campaignTitleName">-</span> <span class=grid__col-1>-</span> <span class=grid__col-1>-</span> <span class=grid__col-2>-</span> <span class=grid__col-2>-</span> <span class=grid__col-2>-</span></div><div class=grayBorderSeperator></div><div ng-if="item.sharedKeys && item.sharedKeys.length > 0" style="margin-bottom: -12px;" class="roleDelegationSubItems flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2"></span> <span style="padding-left: 1.5%;"></span> <span class=grid__col-2>{{\'USED_BY\' | translate}}</span> <span class=grid__col-1>{{\'VIRTUAL_KEY_RIGHT\' | translate}}</span> <span class=grid__col-1>{{\'VIRTUAL_KEY_RIGHT_ID\' | translate}} </span><span class=grid__col-2>{{\'COMMON_STATUS\' | translate}} </span><span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span></div><div class="flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2">{{\'SHARED_KEYS\' | translate}}</span> <span ng-if="((item.sharedKeys && item.sharedKeys.length === 0 ) || item.sharedKeys === null)" class=grid__col-2>{{\'SHARED_KEY_TEXT\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-1></span> <span class=grid__col-2></span> <span class=grid__col-2></span> <span class=grid__col-2></span></div><div class="flex sub_items_header grid--no-gutter" ng-repeat="shared in item.sharedKeys" ng-if="item.sharedKeys && item.sharedKeys.length > 0"><span class="grayRightBorder grid__col-2"></span> <span><i class="fa fa-clone" style="padding-left: 2.5px; cursor: pointer;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(shared.usedBy)></i></span> <span class="grid__col-2 campaignTitleName">{{shared.usedBy | rlinkformat}}<md-tooltip>{{shared.usedBy | rlinkformat}}</md-tooltip></span><span class=grid__col-1>{{shared.right | rlinkformat}}</span> <span class=grid__col-1>{{shared.rightId | rlinkformat}} </span><span class=grid__col-2 ng-class="shared.status === \'VALID\' ? \'success-message\' : \'error-message\'">{{shared.status | rlinkformat}} </span><span class=grid__col-2>{{shared.startDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{shared.endDate | rlinkformat:\'full-date\'}}</span></div></div></accordion-group></accordion></div></accordion-group></accordion></div></div><div ng-if="vm.uidTitle === \'UID 592\'" style="padding-top: 5%;" class="block-accordion contracts virtualKeyData"><div class="block-accordion dataConsistencyTable" ng-if=vm.vehicleInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.listTabOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen" style="margin-bottom: 1rem;"><div><span>{{\'LIST_OF_AVAILABLE_KEYS\' | translate}}</span></div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><div ng-if="vm.availableKeys.length > 0"><span ng-click=vm.getRightsKeys() class=rlink-tip style="left:97%; position: relative; cursor: pointer;"><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i class="fa fa-refresh" style="font-size: large;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></span><div class=grayBorderSeperator></div><br><div class="block-accordion list" st-table=vm.displayedKeys st-safe-src=vm.availableKeys><div class=ddpAccordBorder style="margin-bottom: 1% !important;" ng-repeat="key in vm.displayedKeys"><div class="roleDelegationSubItems sub_items_header section_header sub_items grid--no-gutter"><span class="grid__col-2 virtualBoldFont">{{\'RIGHT_ID\' | translate}}</span> <span class="grid__col-3 virtualBoldFont">{{\'RIGHTS\' | translate}}</span> <span class="grid__col-3 virtualBoldFont">{{\'START_DATE\' | translate}}</span> <span class="grid__col-3 virtualBoldFont">{{\'END_DATE\' | translate}}</span> <span class="grid__col-3 virtualBoldFont">{{\'STATE\' | translate}}</span></div><div class="roleDelegationSubItems section_header sub_items grid--no-gutter"><span style="margin-top: -20px;" class="grid__col-2 campaignTitleName">{{key.keyId | rlinkformat}} </span><span style="margin-top: -20px;" class=grid__col-3>{{key.right | rlinkformat}}</span> <span style="margin-top: -20px;" class=grid__col-3>{{key.startDate | rlinkformat:\'date\'}}</span> <span style="margin-top: -20px;" class=grid__col-3>{{key.endDate | rlinkformat:\'date\'}}</span> <span style="margin-top: -20px;" class=grid__col-3>{{key.status | rlinkformat}}</span></div></div><div class=text-center><div st-pagination="" st-items-by-page=10 st-displayed-pages=5></div></div></div></div><div ng-if="vm.availableKeys.length === 0" style="text-align: center;">{{\'NO_DATA_FOUND\' | translate}}</div></accordion-group></accordion></div></div></div>');
$templateCache.put('app/components/car/features/oldRangeDocuments/oldRangeDocuments.template.html','<div id=renaultTech><h4 class="small-6 row newStyleOfTitle">{{\'COMMON_OLD_MODEL_DOCUMENTS\' | translate}}</h4><div class="small-6 customRow"><div class="row documents-row" ng-repeat="model in vm.oldModelDocuments.oldModelDocuments| orderBy : \'designation\'" ng-click=vm.downloadZip(model.contentUrl)><div class=customRow><div id=bloc1>{{model.documentName}} &nbsp;&nbsp;&nbsp;-&nbsp; &nbsp;&nbsp; {{model.designation}} &nbsp;</div></div></div></div></div>');
$templateCache.put('app/components/car/features/releases/releases.template.html','<div class="small-6 row" id=renaultTech><h4>{{\'RELEASES_HEADER_DESCRIPTION\' | translate}}</h4><div ng-repeat="month in vm.releases "><div><div style="padding-right: 0px; padding-left: 0px;padding-top: 25px;border-bottom:1px solid black" class="small-12 columns" style=padding:10px><div class="small-10 columns margin-t-10">{{month.monthHeader}}</div><div class="small-2 columns margin-t-10"><div ng-click=vm.releaseExpanded(month) class="small-1 columns margin-t-10"><i style="float:right;padding: 0px 0px 6px 0px; font-size: var(--renaultExtraLargeFont);" ng-class="{\'iconRight2  fa fa-caret-up\': month.defaultEnable,\'iconRight2 fa fa-caret-down\':!month.defaultEnable}"></i></div><div class="small-1 columns margin-t-10" style="position: relative;padding-left: 0px;" ng-click=vm.openReleaseFile(month.url)><md-tooltip md-direction=left style="font-family: \'renaultGroupRegular\';">{{\'RELEASES_OPEN_DETAILS\' | translate}}</md-tooltip><i class="material-icons fontIcon" style="padding:4px;float:left;background-image: linear-gradient(190deg, #978B7F, #978B7F);">file_download</i></div></div></div><div ng-if=month.defaultEnable><ul><li ng-repeat="text in month.content "><span>\u2022&nbsp;&nbsp;</span> {{text}}</li></ul></div></div></div></div>');
$templateCache.put('app/components/car/features/renaultTech/renaultTech.template.html','<div id=renaultTech><h4 class="small-6 row newStyleOfTitle">{{vm.docHeader}}</h4><div class="row contactSupport" ng-if="vm.docType === \'QSTOMIZE_\'">{{\'AFTERSALE_SUPPORT_CONNECT\' | translate}}<div class=text-center><span class=qstomizeSupportUrl><u>{{vm.afterSalesContactsupportUrl}}</u></span></div><div><span ng-class="{\'qstomizeAccessDocz\':vm.profile.portal.code !== \'fr\', \'qstomizeReferDocz\':vm.profile.portal.code === \'fr\'}">{{\'ACCESS_DOCUMENTS\' | translate}} - </span><span ng-class="{\'qstomizeAccessDocz\':vm.profile.portal.code !== \'fr\', \'qstomizeReferDocz\':vm.profile.portal.code === \'fr\'}">{{\'REFER_DOCUMENTS\' | translate}}</span></div><div><span ng-class="{\'qstomizeAccessDocz\':vm.profile.portal.code !== \'fr\', \'qstomizeReferDocz\':vm.profile.portal.code === \'fr\'}">{{\'ACCESS_AFTERSALES_DOCUMENTS\' | translate}} - </span><span ng-class="{\'qstomizeAccessDocz\':vm.profile.portal.code !== \'fr\', \'qstomizeReferDocz\':vm.profile.portal.code === \'fr\'}">{{\'ACCESS_AFTERSALES_REQUEST\' | translate}}</span></div><div class=text-center>{{\'AFTERSALE_CONTACT_NUM\' | translate}}</div></div><div class="small-6 customRow"><div class="row documents-row" ng-repeat="link in vm.transformedProducts| orderBy : \'productName\'" ng-click=vm.downloadZip(link.contentUrl)><div class=customRow><div id=bloc1>{{link.productName}} &nbsp;</div><i class="material-icons float-right fontIcon" id=bloc2>file_download</i></div></div></div><div ng-if="vm.docType ===\'\'"><h4 class="small-6 row newStyleOfTitle">{{\'COMMON_RENAULT_LINKS\' | translate}}</h4><div class="small-6 row"><div class=gpCat><em class="fa fa-angle-double-right"></em> <a href={{vm.spaceNomadeLink}} style="color: black;" target=_blank>{{\'SPACE_NOMADE_DEALERS_LINK\' | translate}}</a></div><div class=gpCat ng-if=vm.displayLink><em class="fa fa-angle-double-right"></em> <a href={{vm.gpCatPilote}} style="color: black;" target=_blank>GPCat - Pilote</a></div></div></div></div>');
$templateCache.put('app/components/car/features/sdp/sdpDocuments.template.html','<div id=renaultTech><h4 class="small-6 row newStyleOfTitle">{{\'COMMON_SDP_DOCUMENTS\' | translate}}</h4><br><h6 class="small-6 row">{{\'COMMON_SDP_DOCUMENTS_DESCRIPTION\' | translate}}</h6><br><div class="small-6 customRow"><div class="row documents-row" ng-repeat="sdpList in vm.sdpList | orderBy : \'name\'" ng-click=vm.openLink(sdpList.document)><div class=customRow><img src=./assets/svg/pdf-file.svg width=20 style="margin:0px 5px;"><div id=bloc1>{{sdpList.name}} &nbsp;</div><i class="material-icons float-right fontIcon" id=bloc2>arrow_forward</i></div></div></div><div class="small-6 row footer" style="text-align: center"><span>{{\'COMMON_CONTACT_US\' | translate}}</span><br><img src=./assets/images/email.svg height=12% width=12% alt=""><br><a><u>sdp_support@renault.com</u></a></div></div>');
$templateCache.put('app/components/car/features/specialTools/specialTools.template.html','<div id=specialToolsDocz><div class=actionTool><i class="fa fa-wrench" title="{{\'HEADER_DOCUMENTS_TOOLS\' | translate}}"></i></div><div class="specialToolsSearchBox searchHead"><div style="max-width: 50vw;margin: 0 2%;" class=row><div ng-repeat="field in vm.selectFields" id={{field.key}} ng-click=vm.divSelected(field.key) class="select-criterias column" style="float: left;padding: 0px 10px"><md-input-container md-no-float><label>{{field.defaultOption | translate}}</label><md-select md-container-class=my-container name={{field.key}} ng-disabled=vm.rules[field.key] id={{field.key}} placeholder="{{field.defaultOption | translate}}" ng-model=field.value ng-change=vm.mapFieldsToSearch(field.key,field.value) class={{field.class}} input-clear=black><md-select-header class=demo-select-header><input ng-model=search id={{field.key}}s type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=list ng-click="vm.optionSelect(list, field)" ng-repeat="list in field.list | filter: search">{{list}}</md-option></md-select></md-input-container><div ng-if=field.value ng-click=vm.resetSelectedFields(field.key,field.value)><md-button class=btn>X</md-button></div></div></div><div style="width: 50vw;padding-top: 5px;"><div class=row><div class="category-Crit column" id=category style="float: left;padding: 0px 10px" ng-click=vm.divSelected(vm.selectedCategory)><md-input-container md-no-float><label>{{\'FAV_CAT\' | translate}}</label><md-select md-container-class="my-container criteriaLabel" ng-model=vm.selectedCategory name=category id={{vm.selectedCategory}} input-clear=black><md-select-header class=demo-select-header><input ng-model=search type=search ng-keydown=$event.stopPropagation() id={{vm.selectedCategory}}s placeholder="{{\'SEARCH_AREA\' | translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-value=category.label ng-repeat="category in vm.specialToolsList | filter:search">{{category.label}}</md-option></md-select></md-input-container><div ng-if=vm.selectedCategory ng-click=vm.clearCategories(vm.selectedCategory);><md-button class=btn>X</md-button></div></div><div class="large-1 margin-3 medium-2 columns doubleFilter"><md-input-container style="height: 37px;"><input type=text style="width:255px; border-radius: 3px;" placeholder="{{\'TEXT_DOUBLE_SEARCH\' | translate}}" ng-model=vm.searchText phenix-enter=vm.specialToolsSearchAdvanced()></md-input-container><div ng-if=vm.searchText ng-click=vm.clearCategories(vm.searchText);><md-button class=btn>X</md-button></div></div><div style="text-align: center;display: flex;"><div class="iconDiv filterSearch" ng-class="{\'disabled\': !(vm.globalSearch.vehicle_family || vm.globalSearch.engine_type || vm.globalSearch.gearbox_type || vm.globalSearch.battery_type || vm.selectedCategory || vm.searchText.length >= 3 )}" ng-disabled="!(vm.globalSearch.vehicle_family || vm.globalSearch.engine_type || vm.globalSearch.gearbox_type || vm.globalSearch.battery_type || vm.selectedCategory || vm.searchText.length >= 3 )" ng-click=vm.specialToolsSearchAdvanced()><i class="fa fa-check-circle"></i></div><div class="iconDiv resetSearch" ng-click=vm.reset()><i class="fa fa-times-circle"></i></div></div></div></div></div><div><search-specialized-tool is-special-tools-docz=vm.isSpecialToolsDocz global-search=vm.globalSearch selected-category=vm.selectedCategory search-text=vm.searchText></search-specialized-tool></div></div><scroll-up scroll-trigger=300 scroll-anchor=#specialToolsDocz></scroll-up>');
$templateCache.put('app/components/car/features/training/training.template.html','<div id=renaultTech><h4 class="small-6 row newStyleOfTitle">{{\'COMMON_TRAINING_OFFER\' | translate}}</h4><div class="small-6 customRow"><div class="row documents-row" ng-repeat="trainingOffer in vm.trainingOffers| orderBy : \'productName\'" ng-click=vm.openLink(trainingOffer.contentUrl)><div class=customRow><img src=./assets/svg/pdf-file.svg width=20 style="margin:0px 5px;"><div id=bloc1>{{trainingOffer.productName}} &nbsp;</div><i class="material-icons float-right fontIcon" id=bloc2>arrow_forward</i></div></div><div class=row ng-repeat="project in vm.elucidatProjectList| orderBy : \'name\'"><div style="cursor: pointer;" class="customRow documents-row" ng-click=vm.getElucidatReleaseLinks(project.project_code,project.isReleaseLink)><img src=./assets/svg/laptop-globe.svg width=30><div id=bloc1>{{project.name}} &nbsp;</div><i class=arrowIcon ng-class="{\'icon-icons_arrow_top\':project.isReleaseLink ,\'icon-icons_arrow_bottom\':!project.isReleaseLink}"></i></div><div ng-if=project.isReleaseLink><div class="customRow documents-row" style="padding-left: 20px;" ng-repeat="release in vm.releaseLinks| orderBy : \'description\'"><div class=releaseBorder ng-click=vm.launchElucidat(release.release_code)><div id=bloc1>{{release.description}} &nbsp;</div><i class="material-icons float-right fontIcon" id=bloc2>arrow_forward</i></div></div><div style="font-weight: bold; text-align:center;" class=customRow ng-if=vm.isReleaseEmpty>{{\'NO_TRAINING_LINKS\' | translate}}</div></div></div></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/AlertDetails/alertFileDetails.template.html','<div id=proacticeAlert><u style="font-size:var(--renaultLargeFont);font-family: var(--renaultFontBold);">{{\'CONNECTED_SERVICES_IN_PROGRESS_STATUS\' | translate}}</u><div ng-if=vm.activeAlerts class=center style="font-family: var(--renaultFontBold);">{{\'NO_ALERTS_MSG\' | translate}}</div><div ng-if=!vm.activeAlerts><table style="width: 75%;" class=table st-table=activeAlertsListTable st-safe-src=vm.activeAlertsList><tr><th class="center width10"><span class=sortable st-sort=criticity>{{\'CRITICITY\' | translate}}</span></th><th class="center width25"><span>{{\'FUNCTION\' | translate}}</span></th><th class=center><span>{{\'FAV_PLACEHOLDER_DESCR\' | translate}}</span></th><th class="center width15"><span class=sortable st-sort=creationDateTime>{{\'RLINKCAR_DIAG_HISTO_DATE\' | translate}}</span></th><th class="center width10"><span>{{\'KILOMETRE\' | translate}}</span></th></tr><tr ng-repeat="alerts in activeAlertsListTable"><td class=center><span style="cursor: pointer;" title={{alerts.criticityName}} ng-class="{\'bold-red\':alerts.criticity === 4, \'bold-black\':alerts.criticity === 3, \'bold-grey\':alerts.criticity === 1}">{{alerts.criticity}}</span></td><td><span>{{alerts.function}}</span></td><td><span>{{alerts.shortDescription}}</span></td><td class=center><span>{{alerts.creationDateTime}}</span></td><td class=center><span>{{alerts.mileage}}</span></td></tr></table></div><div style=padding-left:19%;margin-top:2%;><u style="font-size:var(--renaultLargeFont);font-family: var(--renaultFontBold);">{{\'ALERTS_HISTORY\' | translate}}</u><div ng-if=vm.closedAlerts class=center style="font-family: var(--renaultFontBold);">{{\'NO_PAST_ALERT_MSG\' | translate}}</div><div ng-if=!vm.closedAlerts><table style="width: 92.5%;" class=table st-table=closedAlertsListTable st-safe-src=vm.closedAlertsList><tr><th class="center width10"><span class=sortable st-sort=criticity>{{\'CRITICITY\' | translate}}</span></th><th class="center width25"><span>{{\'FUNCTION\' | translate}}</span></th><th class=center><span>{{\'FAV_PLACEHOLDER_DESCR\' | translate}}</span></th><th class="center width15"><span class=sortable st-sort=creationDateTime>{{\'RLINKCAR_DIAG_HISTO_DATE\' | translate}}</span></th><th class="center width10"><span>{{\'KILOMETRE\' | translate}}</span></th></tr><tr ng-repeat="history in closedAlertsListTable"><td class="center width10"><span style="cursor: pointer;" title={{history.criticityName}} ng-class="{\'bold-red\':history.criticity === 4, \'bold-black\':history.criticity === 3, \'bold-grey\':history.criticity === 1}">{{history.criticity}}</span></td><td><span>{{history.function}}</span></td><td><span>{{history.shortDescription}}</span></td><td class="center width10"><span>{{history.creationDateTime}}</span></td><td class="center width10"><span>{{history.mileage}}</span></td></tr></table></div></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/CrashHistory/batteryCrashHistory.template.html','<div class=diagBatteryCrashHistory><div class=printReport><div class=positionRelative><a class=buttonExport ng-click="vm.showConsentPrint(\'print\')" ng-class="{\'disabled-button\': !vm.showPrint}">{{\'LABEL_PRINT_REPORT\' | translate}}</a></div></div><div class=consentForm><div class=positionRelative><a class=buttonExport ng-click="vm.showConsentPrint(\'consent\')" style="display: block;\n    white-space: pre;">{{\'LABEL_CONSENT_FORM\' | translate}}</a></div></div><div class=crashHistoryTable><table st-table=crashHistoryData st-safe-src=vm.batteryCrashHistoryData><tr class=row><th class="small-2 columns"><span>{{\'ACTIS_VEHICLE_VIN\' | translate}}</span></th><th class="small-2 columns"><span>{{\'ACTIS_VEHICLE_BIN\' | translate}}</span></th><th class="small-2 columns"><span>{{\'LABEL_INTERVENTION_DATE\' | translate}}</span></th><th class="small-4 columns"><span>{{\'COMMON_RESULT_LABEL\' | translate}}</span></th><th class="small-2 columns"><span>{{\'RESTART_SERVICES_DEALER_ID\' | translate}}</span></th></tr><tr ng-repeat="element in crashHistoryData" class=row><td class="small-2 columns">{{element.vin}}</td><td class="small-2 columns">{{element.bin}}</td><td class="small-2 columns">{{element.interventionData}}</td><td class="small-4 columns"><div ng-if="element.reuseFlag == \'OK\'" style="color: green;">{{element.reuseFlag}} : {{\'RESULT_BATTERY_REUSE\' | translate}}</div><div ng-if="element.reuseFlag == \'KO\'" style="color: red;">{{element.reuseFlag}} : {{\'RESULT_BATTERY_NOUSE\' | translate}}</div><div ng-if="element.reuseFlag == \'\' || element.reuseFlag == null || element.reuseFlag == undefined" ng-class=element.class>{{element.result}}</div></td><td class="small-2 columns">{{element.dealerId}}</td></tr></table></div><div style="border: 2px solid orange;\n    padding: 2% 2% 2% 1%;"><a class="buttonExport warningIcon" style="margin-left: 0px;background-color: orange;"><i class="fa fa-exclamation-triangle" style="padding-right: 1%;"></i>{{\'CONNECTED_SERVICES_WARNING_STATUS\' | translate}}</a><div style="margin-top: 2%;">{{\'REUSE_BATTERY_WARNING1\' | translate}}</div></div><div style="border: 2px solid orange;\n    padding: 2% 2% 2% 1%;margin-top: 1%;"><a class="buttonExport warningIcon" style="margin-left: 0px; background-color: orange;"><i class="fa fa-exclamation-triangle" style="padding-right: 1%;"></i>{{\'CONNECTED_SERVICES_WARNING_STATUS\' | translate}}</a><div style="margin-top: 2%;">{{\'REUSE_BATTERY_WARNING2\' | translate}}</div></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticEcu/diagEcu.template.html','<div style=margin-top:-8%;><div ng-if="vm.diagFilesList.length !== 0 && !vm.filterLoader"><select-all-check-box filter-array=vm.filterArray first-filter=vm.firstFilter full-data-filter=vm.fullDataFilter second-filter=vm.secondFilter on-expand-all=vm.onExpandAll expand-all=vm.expandAll expand-all-enable=true></select-all-check-box></div><div ng-if=vm.filterLoader style="height: 75px;"><span><img src=../assets/images/newHourGlassGrey.gif width=50px alt="" style="margin-left: 45%;"></span></div><div class="row-one diag-file-ecus" ng-repeat="diag in vm.diagFilesList | customNestedFilter: vm.fullDataFilter"><div class=row-two><div class="small-12 columns row-three" id=diagFileSelected ng-click="vm.displayAndFilterECU(diag.id, diag.ecuVisible)"><div class="small-2 columns">{{diag.captureDateTime | customDateTime}}</div><div class="small-2 columns">{{ diag.id}}</div><div class="small-2 columns">{{ diag.category}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'B3\' && diag.origin === \'CLIP\'">{{\'CLIP\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'B3\' && diag.category === \'HealthCheck\' && diag.origin !== \'CLIP\'">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin === \'ADT\'">{{\'ADT\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin != \'ADT\'">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns"><span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | uppercase}}: </span>{{diag.mileage}}</div><div class="small-1 columns" ng-if="vm.isArcaUser || vm.isAdtTechrole">{{ diag.dealerId}}</div><div class="small-1 columns"><i style="float: right; padding-top: 5px;" ng-class="{\' iconRight2 icon-icons_arrow_top\':diag.ecuVisible ,\'iconRight2 icon-icons_arrow_bottom\':!diag.ecuVisible}"></i></div></div><div class=ecu-container ng-if=diag.ecuVisible><div class=identifier-values-container ng-repeat="ecu in diag.ecus | customNestedFilter: vm.firstFilter"><table class=identifierValuesTable><tr><th colspan=3>{{ecu.label.split(\'#\')[0]}} <span style="float: right; color:#fff; font-weight:bold;">{{ecu.ecuStatus.split(\'#\')[0]}}</span></th></tr><tr ng-repeat="identifier in ecu.contexts | customNestedFilter: vm.secondFilter" class=identifierValues><td class=identifierCode>{{identifier.code.split(\'#\')[0].split(\',\')[0]}}</td><td class=identifierName>{{identifier.description.split(\'#\')[0]}} :<br><span class=fieldIdentifierValue>{{identifier.value.split(\'#\')[0]}}<span></span></span></td></tr></table></div><div ng-if="diag.ecus.length == 0" class=no-ecu>{{\'NO_DATA_FOUND\' | translate}}</div></div></div></div><div class=row-one ng-if="vm.diagFilesList.length === 0" ng-style="{\'margin-top\' : vm.diagFilesList.length !== 0 ? \'0px\':\'74px\'}"><p class=no-ecu>{{\'NO_DIAGNOSTIC_FILE_FOUND\' | translate | uppercase}}</p></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticDtcHistory/diagDtcHistory.template.html','<div style=margin-top:-8.5%;><div ng-if="vm.diagFilesList.length !== 0 && !vm.filterLoader"><select-all-check-box filter-array=vm.filterArray first-filter=vm.firstFilter on-expand-all=vm.onExpandAll expand-all=vm.expandAll expand-all-enable=true></select-all-check-box></div><div ng-if=vm.filterLoader style="height: 75px;"><span><img src=../assets/images/newHourGlassGrey.gif width=50px alt="" style="margin-left: 45%;"></span></div><div class=row-one ng-repeat="diag in vm.diagFilesList"><div class=row-two><div ng-click=vm.displayAndFilterDtc(diag.id,diag.isDtcHistoryVisible) class="small-12 columns row-three" id=diagFileSelected><div class="small-2 columns">{{diag.captureDateTime | customDateTime }}</div><div class="small-2 columns">{{ diag.id}}</div><div class="small-2 columns">{{ diag.category}}</div><div class="small-2 columns" ng-if="(vm.typeMD === \'B3\' || vm.typeMD === \'B2\') && diag.origin === \'CLIP\'">{{\'CLIP\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="(vm.typeMD === \'B3\' || vm.typeMD === \'B2\') && diag.category === \'HealthCheck\' && diag.origin != \'CLIP\' && diag.origin != \'GNDS\'">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin === \'ADT\'">{{\'ADT\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && (diag.category === \'HealthCheck\' || diag.category === \'Ticket maintenance\') && diag.origin != \'ADT\' && diag.origin != \'GNDS\'">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns" ng-if="(vm.typeMD === \'ADT\' && diag.origin === \'GNDS\') || (vm.typeMD ===\'B3\' && diag.origin===\'GNDS\')">{{diag.origin}} {{diag.tootVersion}}</div><div class="small-2 columns"><span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | uppercase}} :</span> {{diag.mileage}}</div><div class="small-1 columns" ng-if="vm.isArcaUser || vm.isAdtTechrole">{{ diag.dealerId}}</div><div class="small-1 columns"><i style="float: right; padding-top: 5px;" ng-class="{\' iconRight2 icon-icons_arrow_top\':diag.isDtcHistoryVisible ,\'iconRight2 icon-icons_arrow_bottom\':!diag.isDtcHistoryVisible}"></i></div></div><div class=diag-file-details-new ng-if=diag.isDtcHistoryVisible><div class=diag-file-details-container-new><table class="table table-striped full-width dtcs-table diaghistoryTable"><tr ng-if="diag.dtcs.length === 0"><td colspan=9><p class=no-ecu>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr ng-repeat="dtc in diag.dtcs | customNestedFilter: vm.firstFilter" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))"><td class="center-align width6"><span ng-if="dtc.statusCode.length === 1 || dtc.status === \'HIDE\'" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\' , \'grey-dot\' : dtc.status === \'HIDE\'}"></span> <span ng-if="dtc.statusCode.length > 1">{{dtc.statusCode}}</span></td><td class=width10>{{dtc.ecuLabel}}</td><td class=width10><span ng-if="vm.typeMD === \'B3\'">{{dtc.code | dtcslice}}</span> <span ng-if="vm.typeMD === \'ADT\' || vm.typeMD === \'B2\'">{{dtc.code }}</span></td><td class=width30>{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class="center-align width5" ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class="center-align width5">{{dtc.mileage}}</td><td class="center-align width5">{{dtc.occurrences}}</td><td class="center-align width5" ng-click=vm.redirectToContextPage(dtc);$event.stopPropagation()><span class=dtcHistoryCameraIcon ng-if="dtc.isFFDAvailable === \'YES\'"><i class="fa fa-camera"></i></span></td></tr></table></div></div></div></div><div class=row-one ng-if="vm.diagFilesList.length === 0" ng-style="{\'margin-top\' : vm.diagFilesList.length !== 0 ? \'0px\': \'76px\'}"><p class=no-ecu>{{\'NO_DIAGNOSTIC_FILE_FOUND\' | translate | uppercase}}</p></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticFileCompare/diagFileCompare.template.html','<div ng-if=vm.isCompareDataVisible><div ng-click=vm.newDtcsVisible()><div class="small-11 columns row-two" style="line-height: 2.5;">{{\'DTC_RECENT_DEFECTS\' | translate}}</div><div class="small-1 columns row-two"><i style="float: right; line-height: 2.5;" ng-class="{\' iconRight2 icon-icons_arrow_top\':!vm.isNewDtcsVisible ,\'iconRight2 icon-icons_arrow_bottom\':vm.isNewDtcsVisible}"></i></div></div><table ng-if=vm.isNewDtcsVisible st-table=dtcData st-set-filter=stCustomFilter st-safe-src=vm.newDtcs class="table table-striped full-width dtcs-compare-table"><tbody id=resetFilter><tr ng-if="vm.newDtcs.length === 0"><td colspan=10><p class=no-dtc-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr st-select-row=row st-select-mode=multiple ng-repeat="dtc in dtcData" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))"><td class="center-align width5"><span ng-if="dtc.status === \'HIDE\' " class=grey-dot></span> <span ng-if="dtc.statusCode.length === 1" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\'}"></span> <span ng-if="dtc.statusCode.length > 1 && dtc.status != \'HIDE\'">{{dtc.statusCode}}</span></td><td class=width15>{{dtc.ecuLabel}}</td><td class=width6><span ng-if="vm.typeMD != \'ADT\'">{{dtc.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{dtc.code }}</span></td><td class=width30 style="overflow-wrap: anywhere;">{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class="center-align width10" ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class="center-align width10" style="word-break: break-all;">{{dtc.mileage}}</td><td class="center-align width10">{{dtc.occurrences}}</td></tr></tbody></table></div><div ng-if=vm.isCompareDataVisible><div ng-click=vm.changedDtcsVisible()><div class="small-11 columns row-two" style="line-height: 2.5;">{{\'DTC_ACTIVE_DEFECTS\' | translate}}</div><div class="small-1 columns row-two"><i style="float: right; line-height: 2.5;" ng-class="{\' iconRight2 icon-icons_arrow_top\':!vm.isChangedDtcsVisible ,\'iconRight2 icon-icons_arrow_bottom\':vm.isChangedDtcsVisible}"></i></div></div><table ng-if=vm.isChangedDtcsVisible st-table=dtcData st-set-filter=stCustomFilter st-safe-src=vm.changedDtcs class="table table-striped full-width dtcs-compare-table"><tbody id=resetFilter><tr ng-if="vm.changedDtcs.length === 0"><td colspan=10><p class=no-dtc-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr st-select-row=row st-select-mode=multiple ng-repeat="dtc in dtcData" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))"><td class="center-align width5" ng-class="{\'dtcbgcolor\':dtc.oldStatusCode != dtc.statusCode}"><span ng-if="dtc.status === \'HIDE\' " class=grey-dot></span> <span ng-if="dtc.statusCode.length === 1" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\'}"></span> <span ng-if="dtc.statusCode.length > 1 && dtc.status != \'HIDE\'">{{dtc.statusCode}}</span></td><td class=width15>{{dtc.ecuLabel}}</td><td class=width6><span ng-if="vm.typeMD != \'ADT\'">{{dtc.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{dtc.code }}</span></td><td class=width30 style="overflow-wrap: anywhere;">{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class="center-align width10" ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class="center-align dtcbgcolor width10" ng-if="dtc.oldMileage != dtc.mileage" style="word-break: break-all;"><span style="font-weight: bold;">{{dtc.mileage}}</span> <span class=fline></span> <span style="font-style: italic;">{{dtc.oldMileage}}</span></td><td class="center-align width10" ng-if="dtc.oldMileage == dtc.mileage">{{dtc.mileage}}</td><td class="center-align dtcbgcolor width10" ng-if="dtc.oldOccurences != dtc.occurrences"><span class=num style="font-weight: bold;">{{dtc.occurrences}}</span> <span class=fline></span> <span class=den style="font-style: italic;">{{dtc.oldOccurences}}</span></td><td class="center-align width10" ng-if="dtc.oldOccurences == dtc.occurrences">{{dtc.occurrences}}</td></tr></tbody></table></div><div ng-if=vm.isCompareDataVisible><div ng-click=vm.sameDtcsVisible()><div class="small-11 columns row-two" style="line-height: 2.5;">{{\'DTC_INACTIVE_DEFECTS\' | translate}}</div><div class="small-1 columns row-two"><i style="float: right; line-height: 2.5;" ng-class="{\' iconRight2 icon-icons_arrow_top\':!vm.isSameDtcsVisible ,\'iconRight2 icon-icons_arrow_bottom\':vm.isSameDtcsVisible}"></i></div></div><table ng-if=vm.isSameDtcsVisible st-table=dtcData st-set-filter=stCustomFilter st-safe-src=vm.sameDtcs class="table table-striped full-width dtcs-compare-table"><tbody id=resetFilter><tr ng-if="vm.sameDtcs.length === 0"><td colspan=10><p class=no-dtc-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr st-select-row=row st-select-mode=multiple ng-repeat="dtc in dtcData" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))"><td class="center-align width5"><span ng-if="dtc.status === \'HIDE\' " class=grey-dot></span> <span ng-if="dtc.statusCode.length === 1" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\'}"></span> <span ng-if="dtc.statusCode.length > 1 && dtc.status != \'HIDE\'">{{dtc.statusCode}}</span></td><td class=width15>{{dtc.ecuLabel}}</td><td class=width6><span ng-if="vm.typeMD != \'ADT\'">{{dtc.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{dtc.code }}</span></td><td class=width30 style="overflow-wrap: anywhere;">{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class="center-align width10" ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class="center-align width10" style="word-break: break-all;">{{dtc.mileage}}</td><td class="center-align width10">{{dtc.occurrences}}</td></tr></tbody></table></div><div ng-if=vm.isCompareDataVisible><div ng-click=vm.oldDtcsVisible()><div class="small-11 columns row-two" style="line-height: 2.5;">{{\'DTC_DISAPPEARED_DEFECTS\' | translate}}</div><div class="small-1 columns row-two"><i style="float: right; line-height: 2.5;" ng-class="{\' iconRight2 icon-icons_arrow_top\':!vm.isOldDtcsVisible ,\'iconRight2 icon-icons_arrow_bottom\':vm.isOldDtcsVisible}"></i></div></div><table ng-if=vm.isOldDtcsVisible st-table=dtcData st-set-filter=stCustomFilter st-safe-src=vm.oldDtcs class="table table-striped full-width dtcs-compare-table"><tbody id=resetFilter><tr ng-if="vm.oldDtcs.length === 0"><td colspan=10><p class=no-dtc-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr st-select-row=row st-select-mode=multiple ng-repeat="dtc in dtcData" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))"><td class="center-align width5"><span ng-if="dtc.status === \'HIDE\' " class=grey-dot></span> <span ng-if="dtc.statusCode.length === 1" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\'}"></span> <span ng-if="dtc.statusCode.length > 1 && dtc.status != \'HIDE\'">{{dtc.statusCode}}</span></td><td class=width15>{{dtc.ecuLabel}}</td><td class=width6><span ng-if="vm.typeMD != \'ADT\'">{{dtc.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{dtc.code }}</span></td><td class=width30 style="overflow-wrap: anywhere;">{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class="center-align width10" ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class="center-align width10" style="word-break: break-all;">{{dtc.mileage}}</td><td class="center-align width10">{{dtc.occurrences}}</td></tr></tbody></table></div><div><button ng-disabled=!vm.compareButton class=comparebtn ng-click=vm.compareDiagfiles() ng-style="{\'background-color\': vm.compareButton ? $root.renaultPrimaryColor :\'#dadada\'}"><div class=iconDiv><i class="fa fa-compress" style="margin-right: 0;transform: rotateZ(45deg);padding-right: 5px; font-size: var(--renaultMediumFont);"></i></div><div class="btnText ng-binding" style="padding-left: 5px;top: 4px;position: relative;">Compare</div></button></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticFileDetails/diagFileDetailsNew.template.html','<div class=diag-file-details-new><div class=diag-file-details-container-new><table class=header-table><tr ng-if=vm.diagFile><td ng-if="vm.typeMD === \'B3\' && vm.diagFile.origin === \'CLIP\'">{{\'CLIP\' | translate | uppercase}} {{vm.diagFile.tootVersion}}</td><td ng-if="vm.typeMD === \'B3\' && vm.diagFile.category === \'HealthCheck\' && vm.diagFile.origin != \'CLIP\' && vm.diagFile.origin !=\'GNDS\'">{{\'REMOTE\' | translate | uppercase}}</td><td ng-if="vm.typeMD === \'ADT\' && vm.diagFile.origin !== \'ADT\' && vm.typeMD !== \'B3\' && vm.diagFile.origin !== \'GNDS\'">{{\'REMOTE\' | translate | uppercase}}</td><td ng-if="(vm.typeMD === \'B3\' && vm.diagFile.origin === \'GNDS\') || (vm.typeMD === \'ADT\' && vm.diagFile.origin === \'GNDS\') || (vm.typeMD ===\'ADT\' && vm.diagFile.origin === \'ADT\')">{{ vm.diagFile.origin}} {{ vm.diagFile.tootVersion}}</td><td ng-if="vm.typeMD === \'ADT\' && vm.diagFile.category === \'HealthCheck\' && vm.diagFile.origin === \'DDP\'">{{\'REMOTE\' | translate | uppercase}}</td><td>{{vm.diagFile.mileage }} <span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | lowercase}}</span></td><td>{{\'CONNECTED_SERVICES_ID\' | translate | uppercase}} : {{vm.diagFile.id}}</td></tr></table><div ng-if="vm.showPreDiag && !vm.isDiagPredictLoading"><div class=row><div class="small-12 columns" style=padding-left:0px;><div style="display: flex; width: 100%;"><span class="small-5 columns diagPredictLabels" style="order: 1;">{{\'DIAG_PREDICTION_MALFUNCTION\' | translate}}</span> <span class="small-1 columns" style="order: 2;"></span> <span class="small-3 columns" ng-if="vm.diagFile.mlmodelDisplayName && vm.diagFile.mlmodelVersionId" style="order: 3; font-style: italic;text-align: right;">{{vm.diagFile.mlmodelDisplayName}} <span>&nbsp; - &nbsp;</span> {{vm.diagFile.mlmodelVersionId}} </span><span class="small-3 columns icon-row" ng-if="vm.diagFile.predictionData && vm.diagFile.predictionData.length > 0"><i class="fa fa-thumbs-o-up outline-icon" ng-if="vm.diagFile.isDiagPredictLiked === null || vm.diagFile.isDiagPredictLiked === false" ng-click=vm.savePredictionVotes(true)></i> <i class="fa fa-thumbs-up like-png" ng-if="vm.diagFile.isDiagPredictLiked === true"></i> <i class="fa fa-thumbs-o-down outline-icon" ng-if="vm.diagFile.isDiagPredictLiked === null || vm.diagFile.isDiagPredictLiked === true" ng-click=vm.openAlertPopIn(false)></i> <i class="fa fa-thumbs-down like-png" ng-if="vm.diagFile.isDiagPredictLiked === false"></i></span></div></div></div><div ng-if="((vm.diagFile.predictionData && vm.diagFile.predictionData.length == 0) || !vm.diagFile.predictionData) && vm.diagFile.preDiagMessage && !vm.isIndependentUser" class=diagPredictMsg>{{vm.diagFile.preDiagMessage}}</div><div ng-if="vm.diagFile.predictionData && vm.diagFile.predictionData.length > 0" class=row><div class="small-1 columns" style="padding-right: 0px;"><span ng-if="(vm.diagFile.predictionData.length == 1 || vm.diagFile.predictionData.length == 4) && !vm.isIndependentUser" style=float:right;><i class="fa fa-lightbulb-o" aria-hidden=true style="font-size:25px; color: #fc3;"></i></span></div><div class="small-11 columns" style="padding-left: 5px;"><table style="border-collapse: collapse; width: 90%;"><tr ng-repeat="item in vm.diagFile.predictionData track by $index" style="border: 1px solid black;"><td class="small-12 row diagPredictBox"><span class="small-2 columns" ng-if=!item.isRulePresent>{{item.pgId || \'-\'}}</span> <span class="small-5 columns" ng-click="item.partNumber && vm.goToProduct(item)" ng-keypress="item.partNumber && vm.goToProduct(item)" ng-class="{\'linkHover\': item.partNumber}">{{item.partLabel || \'-\'}}</span> <span ng-if=!item.isRulePresent class="small-2 columns" ng-class="{\'linkHover\': item.partNumber}" ng-click="item.partNumber && vm.goToProduct(item)" ng-keypress="item.partNumber && vm.goToProduct(item)"><span ng-if=item.partNumberLoading><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""> </span><span ng-if=!item.partNumberLoading>{{item.partNumber || \'-\'}}</span> </span><span ng-if=!item.isRulePresent class="small-2 columns" ng-class="{\'linkHover\': item.cataloguePlate}" ng-click="item.cataloguePlate && vm.goToTextSearch(item,\'catPlate\')" ng-keypress="item.cataloguePlate && vm.goToTextSearch(item,\'catPlate\')"><span ng-if=item.cataloguePlateLoading><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""> </span><span ng-if=!item.cataloguePlateLoading>{{item.cataloguePlate || \'-\'}}</span> </span><span ng-if=!item.isRulePresent class="small-1 columns" ng-class="{\'linkHover\': item.partNumber}" ng-click="item.partNumber && vm.goToTextSearch(item,\'ref\')" ng-keypress="item.partNumber && vm.goToTextSearch(item,\'ref\')"><i class="fa fa-search" ng-if=item.partNumber title="{{\'DIAG_TEXT_SEARCH\' | translate}}"></i> </span><span ng-if="$index == 0 && vm.dtcRule" style="position: absolute; right: 10px; font-style: italic; font-weight: normal; color: black;">>> DTC_Rule : <span style="font-weight: bold;">{{vm.dtcRule}}</span></span></td></tr></table></div></div></div><div ng-if=vm.isDiagPredictLoading><span class=diagPredictLabels>{{\'DIAG_PREDICTION_MALFUNCTION\' | translate}}</span> <span><img src=../assets/images/newHourGlassGrey.gif width=35px alt=""></span></div><div class=diagLabels>{{"DIAG_DTC"| translate}} <span>/</span>{{"DIAG_ECU"|translate}}</div><table st-table=dtcData st-set-filter=stCustomFilter st-safe-src=vm.diagFile.dtcs class="table table-striped full-width dtcs-table"><thead><tr><th class=width5><span class=sortable st-sort=vm.sortedField.status st-skip-natural=true aria-sort=none>{{\'COMMON_STATUS\' | translate}}</span> <span><st-check-box column="\'statusCode\'" display-array=vm.statusDisplayArray ng-if="vm.statusDisplayArray.length >0" diag-file=vm.diagFile default-filter-values=vm.defaultFilterValues></st-check-box></span></th><th class=width15><span id=ecuLabel st-sort-default=true class="sortable width10" st-sort=ecuLabel st-skip-natural=true aria-sort=none>{{\'VDH_ECU_SIDE_MENU\' | translate}}</span> <span><input type=search st-search=ecuLabel ng-model=ecuLabel></span></th><th class=width5><span class=sortable st-sort=code st-skip-natural=true aria-sort=none>{{\'DOCUMENT_BT_DTC_CODE\' | translate}}</span> <span><input type=search st-search=code ng-model=code></span></th><th class=width40><span class=sortable st-sort=description st-skip-natural=true aria-sort=none>{{\'VDH_DESCRIPTION\' | translate}}</span> <span><input type=search st-search=description ng-model=description></span></th><th class=width5 ng-if="vm.typeMD === \'ADT\'"><span class=sortable st-sort=category st-skip-natural=true aria-sort=none>{{\'FAV_CAT\' | translate}}</span> <span><input type=search st-search=category class=categorySearch ng-model=category></span></th><th class=width5><span class=sortable id=mileage st-sort=vm.sortedField.mileage st-skip-natural=true aria-sort=none>{{\'KILOMETRE\' | translate | toCamelCase}}</span> <span><st-number-range column="\'mileage\'" numericinput=numericInput ng-if="dtcData.length >0"></st-number-range></span></th><th class=width10><span class=sortable st-sort=vm.sortedField.occurrences st-skip-natural=true aria-sort=none>{{\'VDH_DTC_OCCURRENCE\' | translate}}</span> <span><st-number-range column="\'occurrences\'" numericinput=numericInput ng-if="dtcData.length >0"></st-number-range></span></th><th class=width5><span class=sortable st-sort=vm.sortedField.isFFDAvailable st-skip-natural=true aria-sort=none>{{\'FFD\' | translate}}</span> <span><st-check-box column="\'isFFDAvailable\'" display-array=vm.ffdDisplayArray ng-if="vm.ffdDisplayArray.length >0" diag-file=vm.diagFile></st-check-box></span></th><th ng-if=!vm.nissanUserURL class=width5><span class=sortable st-sort=vm.sortedField.isBTAvailable st-skip-natural=true aria-sort=none>{{\'CAR_SEARCH_RESULT_FILTER_BT\' | translate}}</span> <span><st-check-box column="\'isBTAvailable\'" display-array=vm.btDisplayArray ng-if="vm.btDisplayArray.length >0" diag-file=vm.diagFile></st-check-box></span></th><th class=width5><span class=sortable st-sort=vm.sortedField.isMDAvailable st-skip-natural=true aria-sort=none>{{\'CAR_SEARCH_RESULT_FILTER_MD\' | translate}}</span> <span><st-check-box column="\'isMDAvailable\'" display-array=vm.mdDisplayArray ng-if="vm.mdDisplayArray.length >0" diag-file=vm.diagFile></st-check-box></span></th></tr></thead><tbody id=resetFilter st-clear-filter><tr ng-if="dtcData.length === 0" ng-class="{\'nissan-hover\': vm.nissanUserURL, \'renault-hover\': !vm.nissanUserURL}"><td colspan=10><p class=no-dtc-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><tr st-select-row=row st-select-mode=multiple ng-repeat="dtc in dtcData" ng-if="((!vm.isTechProfile && dtc.status !== \'HIDE\') || (vm.isTechProfile))" ng-click=vm.redirectToDtcPage(dtc) ng-class="{\'nissan-hover\': vm.nissanUserURL, \'renault-hover\': !vm.nissanUserURL}"><td class=center-align><span ng-if="dtc.status === \'HIDE\' " class=grey-dot></span> <span ng-if="dtc.statusCode.length === 1" ng-class="{\'orange-dot\' : dtc.statusCode === \'2\' , \'red-dot\' : dtc.statusCode === \'1\'}"></span> <span ng-if="dtc.statusCode.length > 1 && dtc.status != \'HIDE\'">{{dtc.statusCode}}</span></td><td>{{dtc.ecuLabel}}</td><td><span ng-if="vm.typeMD != \'ADT\'">{{dtc.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{dtc.code }}</span></td><td>{{dtc.description}}<div style="color: black;font-size: 12.5px;">{{dtc.faultTypeLabel}}</div></td><td class=center-align ng-if="vm.typeMD === \'ADT\'">{{dtc.category}}</td><td class=center-align>{{dtc.mileage}}</td><td class=center-align>{{dtc.occurrences}}</td><td class=center-align ng-click=vm.redirectToContextPage(dtc);$event.stopPropagation()><span ng-if="dtc.isFFDAvailable === \'YES\'"><i class="fa fa-camera"></i></span></td><td ng-if=!vm.nissanUserURL class=center-align><span ng-if=dtc.isBTLoading><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""> </span><span ng-if="dtc.isBTAvailable === \'YES\' && !dtc.isBTLoading"><i class="fa fa-check"></i></span></td><td class=center-align><span ng-if="dtc.isMDAvailable === \'YES\'"><i class="fa fa-check"></i></span></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticFileDetails/dtcContextDialog.template.html','<div id=dtcContextDialog><h5 class=contextDialogTitle>{{vm.dtc.code}}&nbsp;{{vm.dtc.description}}&nbsp;({{vm.dtc.ecuLabel}})</h5><div class=close-icon ng-click=vm.onClose()><i class="fa fa-close"></i></div><div class=contextBody><div><div class=sub-title>{{"VDH_EXTENDED_DATA" | translate}}:</div><table st-table=extendedData st-safe-src=vm.dtc.context.extendedData class="table table-striped full-width"><thead><tr><th class=width20><span class=sortable st-sort=code st-skip-natural=true>{{"ALERTS_CODE" |translate}}</span><input st-search=code class=materialInput type=text placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_CODE_LABEL\'| translate}}" style=width:60%;display:inline;margin-left:5%;></th><th class=width50><span class=sortable st-sort=description st-skip-natural=true>{{"ALERTS_DESCRIPTION" | translate}}</span><input st-search=description class=materialInput type=text placeholder="{{\'VDH_VIN_FILTER_PLACEHODER\'| translate}}&nbsp;{{\'ALERTS_DESCRIPTION\'| translate}}" style=width:60%;display:inline;margin-left:5%;></th><th class=width20>{{"VALUE" | translate}}</th><th class=width10>{{"ACTIS_VEHICLE_UNITE" | translate}}</th></tr></thead><tbody><tr ng-if="vm.dtc.context.extendedData.length == 0"><td colspan=7><p class=no-context-data>{{"NO_DATA_FOUND" |translate}}</p></td></tr><tr st-select-row=row ng-repeat="extended in extendedData" style="font-family: var(--renaultFontRegular);"><td class=width20>{{extended.code}}</td><td class=width50>{{extended.description}}</td><td class=width20>{{extended.value}}</td><td class=width10><span ng-if=extended.unit>{{extended.unit}}</span><span ng-if=!extended.unit>-</span></td></tr></tbody></table></div><div><div class=sub-title>{{"VDH_SNAPSHOT_DATA" | translate}}:</div><table st-table=snapshotData st-safe-src=vm.dtc.context.snapshot class="table table-striped full-width"><thead><tr><th class=width20><span class=sortable st-sort=code st-skip-natural=true>{{"ALERTS_CODE" |translate}}</span><input st-search=code class=materialInput type=text placeholder="{{\'CAR_SEARCH_BY_DIAGNOSTIC_CODE_LABEL\'| translate}}" style=width:60%;display:inline;margin-left:5%;></th><th class=width50><span class=sortable st-sort=description st-skip-natural=true>{{"ALERTS_DESCRIPTION" | translate}}</span><input st-search=description class=materialInput type=text placeholder="{{\'VDH_VIN_FILTER_PLACEHODER\'| translate}}&nbsp;{{\'ALERTS_DESCRIPTION\'| translate}}" style=width:60%;display:inline;margin-left:5%;></th><th class=width20>{{"VALUE" | translate}}</th><th class=width10>{{"ACTIS_VEHICLE_UNITE" | translate}}</th></tr></thead><tbody><tr ng-if="vm.dtc.context.snapshot.length == 0"><td colspan=7><p class=no-context-data>{{"NO_DATA_FOUND" |translate}}</p></td></tr><tr st-select-row=row style="font-family: var(--renaultFontRegular);" ng-repeat="snapshot in snapshotData"><td class=width20>{{snapshot.code}}</td><td class=width50>{{snapshot.description}}</td><td class=width20>{{snapshot.value}}</td><td class=width10><span ng-if=snapshot.unit>{{snapshot.unit}}</span><span ng-if=!snapshot.unit>-</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticHelp/diagFileHelp.template.html','<div class=diag-file-details-new><div class=diag-file-details-container-new><table class=header-table><tr ng-if=vm.diagFile><td ng-if="vm.typeMD === \'B3\'">{{\'CLIP\' | translate}} {{vm.diagFile.tootVersion}}</td><td ng-if="vm.typeMD === \'ADT\'">{{\'ADT\' | translate}} {{vm.diagFile.tootVersion}}</td><td>{{vm.diagFile.mileage }} <span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | lowercase}}</span></td><td>{{\'CONNECTED_SERVICES_ID\' | translate | uppercase}} : {{vm.diagFile.id}}</td></tr></table><div class=tableHeader ng-if="(vm.isArcaUser || vm.adtTechrole) && !vm.binSearched">{{"VDH_SIDE_MENU_DIAGNOSIS_PREDICTION"|translate}}</div><table class="table table-striped full-width dtcs-table prediction-table" st-table=partOpeData st-safe-src=vm.partLabourTimes ng-if="(vm.isArcaUser || vm.adtTechrole) && !vm.binSearched"><thead><tr><th class=alignLeft>{{\'COMMON_COLUMN_LABEL_TITLE\' | translate}}</th><th class=alignLeft>{{\'CAR_OTS_TYPE\' | translate}}</th><th class=alignLeft>{{\'VDH_PREDICTIONS_CONFIDENCE\' | translate}}</th></tr></thead><tbody><tr ng-if="vm.partLabourTimes && vm.partLabourTimes.length == 0"><td class=no-prediction-column colspan=3><p class=no-prediction-found style="margin-bottom: 0;\n                        text-align: center;">{{\'VDH_PREDICTIONS_NOT_FOUND\' | translate}}</p></td></tr><tr ng-if="vm.partLabourTimes && vm.partLabourTimes.length > 0" ng-repeat="prediction in partOpeData"><td>{{vm.getLabelToDisplay(prediction)}}</td><td>{{vm.getTypeToDisplay(prediction)}}</td><td>{{vm.getConfidenceRatio(prediction)}}</td></tr></tbody></table><div class=tableHeader>{{"VDH_SIDE_MENU_DTC_RECOMMENDATION"| translate}}</div><table class="table table-striped full-width dtcs-table" st-table=dtcsData st-safe-src=vm.dtcs><thead><tr><th>{{\'COMMON_STATUS\' | translate}}</th><th>{{\'VDH_ECU_SIDE_MENU\' | translate }}</th><th class=noWhiteSpace>{{"DOCUMENT_BT_DTC_CODE" | translate}}</th><th>{{\'ACTIS_DESCRIPTION_TITLE\' | translate}}</th><th class=width5 ng-if="vm.typeMD === \'ADT\'">{{\'FAV_CAT\' | translate}}</th><th class=noWhiteSpace>{{\'KILOMETRE\' | translate}}</th><th>{{\'VDH_DTC_OCCURRENCE\' | translate}}</th><th>{{\'FFD\' | translate}}</th><th>{{"ALERTS_COMMENTS" | translate | toCamelCase}}</th></tr></thead><tbody><tr ng-if="vm.dtcs && vm.dtcs.length == 0"><td class=no-prediction-column colspan=7><p class=no-prediction-found style="margin-bottom: 0;\n                        text-align: center;">{{"NO_DATA_FOUND" | translate}}</p></td></tr><tr ng-if="vm.dtcs.length > 0" ng-repeat="row in dtcsData" ng-style=vm.setRowStyle(row)><td class=center-align><span ng-if="row.statusCode.length === 1" ng-class="{\'orange-dot\' : row.statusCode === \'2\' , \'red-dot\' : row.statusCode === \'1\'}"></span> <span ng-if="row.statusCode.length > 1">{{row.statusCode}}</span></td><td>{{row.ecuLabel}}</td><td><span ng-if="vm.typeMD === \'B3\'">{{row.code | dtcslice}}</span><span ng-if="vm.typeMD === \'ADT\'">{{row.code }}</span></td><td>{{row.description}}<div style="color: black;font-size: 12.5px;">{{row.faultTypeLabel}}</div></td><td class=center-align ng-if="vm.typeMD === \'ADT\'">{{row.category}}</td><td class=center-align ng-if=row.realMileage>{{row.realMileage}}</td><td class=center-align ng-if=!row.realMileage>{{row.mileage}}</td><td class=center-align>{{row.occurrences}}</td><td class=center-align ng-click=vm.redirectToContextPage(row);$event.stopPropagation()><span ng-if="row.isFFDAvailable === \'YES\'"><i class="fa fa-camera"></i></span></td><td class=comment-column rowspan={{vm.rowSpanCount(row.id)}} ng-if="vm.dtcs[$index - 1].id != row.id && vm.rowSpanCount(row.id) > 1" ng-style=vm.getBorderBottom(row)><button ng-if=row.id class=comment-button ng-click=vm.openCommentsHubPopin(row) ng-disabled="row.commentNumber==0 && vm.isRnetUserType && !vm.adtTechrole" ng-class="{\'disabled-grey\':row.commentNumber==0 && vm.isRnetUserType && !vm.adtTechrole}"><span><i class="fa fa-comments comments-icon"></i><p>{{row.commentNumber}} {{"ALERTS_COMMENTS" | translate}}(s)</p></span></button></td><td ng-if="vm.rowSpanCount(row.id) <= 1"></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticNvPreparation/diagNvPreparation.template.html','<div style=margin-top:-8.5%;><div ng-if="vm.diagFileFinalList.length !== 0 && (vm.diagFilesList | filter:vm.initialCategory).length > 0 && !vm.filterLoader"><select-all-check-box filter-array=vm.filterArray first-filter=vm.firstFilter second-filter=vm.secondFilter third-filter=vm.thirdFilter on-expand-all=vm.onExpandAll expand-all=vm.expandAll expand-all-enable=true></select-all-check-box></div><div ng-if=vm.filterLoader style="height: 75px;"><span><img src=../assets/images/newHourGlassGrey.gif width=50px alt="" style="margin-left: 45%;"></span></div><div class=row-one ng-repeat="diag in vm.diagFilesList | filter: vm.initialCategory"><div class=row-two><div class="small-12 columns row-three" id=diagFileSelected ng-click="vm.displayAndFilterNv(diag.id, diag.nvPreparationVisible)"><div class="small-2 columns">{{diag.captureDateTime | customDateTime}}</div><div class="small-2 columns">{{diag.id}}</div><div class="small-2 columns">{{diag.category}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'B3\'">{{\'CLIP\' | translate | uppercase}} {{diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin === \'ADT\'">{{\'ADT\' | translate | uppercase}} {{diag.tootVersion}}</div><div class="small-2 columns" ng-if="(vm.typeMD === \'ADT\' && diag.origin != \'ADT\') && (vm.typeMD !== \'B3\' && diag.origin !== \'GNDS\')">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns" ng-if="(vm.typeMD === \'B3\' && diag.origin === \'GNDS\') || (vm.typeMD === \'ADT\' && diag.origin === \'GNDS\')">{{diag.origin}} {{diag.tootVersion}}</div><div class="small-2 columns"><span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | uppercase}}: </span>{{diag.mileage}}</div><div class="small-1 columns" ng-if="vm.isArcaUser || vm.isAdtTechrole">{{diag.dealerId}}</div><div class="small-1 columns"><i style="float: right; padding-top: 5px;" ng-class="{\' iconRight2 icon-icons_arrow_top\':diag.nvPreparationVisible ,\'iconRight2 icon-icons_arrow_bottom\':!diag.nvPreparationVisible}"></i></div></div><div class=network-container ng-if=diag.nvPreparationVisible><table class="table table-striped full-width networkTable" ng-if="diag.configurableData.ocvData.ocvDetails.length > 0"><tbody class=networkValues ng-repeat="nvPreparationData in diag.configurableData.ocvData.ocvDetails | customNestedFilter: vm.secondFilter"><tr id=nvPreparationValues ng-repeat="values in nvPreparationData.values | customNestedFilter: vm.thirdFilter"><td ng-if="vm.typeMD === \'B3\'" class=width20><span ng-if="vm.ecuLabelList[nvPreparationData.ecuDomainId] !== \'-\'" class=nd-message>{{vm.ecuLabelList[nvPreparationData.ecuDomainId]}} </span><span ng-if="vm.ecuLabelList[nvPreparationData.ecuDomainId] === \'-\'" class=nd-message>{{nvPreparationData.ecuDomainId}}</span></td><td ng-if="vm.typeMD === \'ADT\'" class=width20>{{nvPreparationData.ecuId}}</td><td class=width30>{{values.code}}</td><td class=width30><span ng-if="values.description && !values.error" class=nd-message>{{values.description}} </span><span ng-if="!values.description || values.error" class=nd-message>-</span></td><td class=width20><span ng-if="values.value && !values.error" class=nd-message>{{values.value | number: 2}} &nbsp;V </span><span ng-if="!values.value || values.error" class=nd-message>-</span></td></tr></tbody></table><table ng-if="diag.configurableData.ocvData.ocvDetails.length == 0 || !diag.configurableData.ocvData" class="table table-striped full-width networkTable"><tr><td><p class=no-ecu>{{\'NO_DATA_FOUND\' | translate}}</p></td></tr></table></div></div></div><div class=row-one ng-if="vm.diagFileFinalList.length == 0 || vm.diagFileFinalList.length == undefined  || \n                (vm.diagFilesList | filter:vm.initialCategory).length === 0" ng-style="{\'margin-top\' : (vm.diagFileFinalList.length !== 0 && vm.diagFileFinalList.length !== undefined) ? \'0px\': \'76px\'}"><p class=no-ecu>{{\'NO_DIAGNOSTIC_FILE_FOUND\' | translate | uppercase}}</p></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticUserJourney/diagUserJourney.template.html','<div style=margin-top:-8.5%;><div ng-if="vm.diagFileFinalList.length > 0 && (vm.diagFilesList | filter:vm.finalCategory).length > 0 && !vm.filterLoader"><select-all-check-box filter-array=vm.filterArray first-filter=vm.firstFilter on-expand-all=vm.onExpandAll expand-all=vm.expandAll expand-all-enable=true></select-all-check-box></div><div ng-if=vm.filterLoader style="height: 75px;"><span><img src=../assets/images/newHourGlassGrey.gif width=50px alt="" style="margin-left: 45%;"></span></div><div class=row-one ng-repeat="diag in vm.diagFilesList | filter : vm.finalCategory" ng-if="vm.diagFileFinalList.length > 0"><div class=row-two><div class="small-12 columns row-three" id=diagFileSelected ng-click="vm.displayAndFilterUserJourney(diag.id, diag.userJourneyVisible)"><div class="small-2 columns">{{diag.captureDateTime | customDateTime }}</div><div class="small-2 columns">{{ diag.id}}</div><div class="small-2 columns">{{ diag.category}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'B3\'">{{\'CLIP\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin === \'ADT\'">{{\'ADT\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin != \'ADT\'">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns"><span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | uppercase}}: </span>{{diag.mileage}}</div><div class="small-1 columns" ng-if="vm.isArcaUser || vm.isAdtTechrole">{{ diag.dealerId}}</div><div class="small-1 columns"><i style="float: right; padding-top: 5px;" ng-class="{\' iconRight2 icon-icons_arrow_top\':diag.userJourneyVisible ,\'iconRight2 icon-icons_arrow_bottom\':!diag.userJourneyVisible}"></i></div></div><div class=network-container ng-if=diag.userJourneyVisible><table class="table table-striped full-width networkTable" ng-if="diag.userjourney.length > 0"><tbody class=networkValues><tr ng-repeat="userjourney in diag.userjourney | customNestedFilter: vm.firstFilter"><td ng-if="vm.typeMD === \'B3\'">{{userjourney.endDateTime | customDateTime}}</td><td ng-if="vm.typeMD === \'ADT\'"><span ng-if="userjourney.refinedDate != -1 ">{{userjourney.refinedDate | customDateTime}}</span> <span ng-if="userjourney.refinedDate === -1">{{"DATE_NOT_SPECIFIED" | translate}}</span></td><td>{{userjourney.code}}</td><td ng-if="vm.typeMD === \'B3\'">{{userjourney.name}}</td><td ng-if="vm.typeMD === \'ADT\'">{{userjourney.status}}</td></tr></tbody></table><table ng-if="diag.userjourney.length == 0" class="table table-striped full-width networkTable"><tr><td><p class=no-ecu>{{\'NO_DATA_FOUND\' | translate}}</p></td></tr></table></div></div></div><div class=row-one ng-if="vm.diagFileFinalList.length == 0 || vm.diagFileFinalList.length == undefined || (vm.diagFilesList | filter:vm.finalCategory).length === 0" ng-style="{\'margin-top\' : (vm.diagFileFinalList.length !== 0 && vm.diagFileFinalList.length !== undefined) ? \'0px\': \'76px\'}"><p class=no-ecu>{{\'NO_DIAGNOSTIC_FILE_FOUND\' | translate | uppercase}}</p></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/DiagnosticReprogramming/diagFileReprogramming.template.html','<div class=diagFileReprogramming><div style="display: inline-block"><!-- <button class="buttonExport" ng-if="vm.buttonPopUp" ng-click="vm.handlePopUp()" ng-style="{\'background-color\': vm.traceabilityInformationResponse ? \'#978B7F\':\'#dadada\'}">{{\'EXPORT_BUTTON\' | translate}}</button> --><div ng-style="{\'bottom\': vm.numberOfPagesToDisplay > 1 ? \'-19px\':\'15px\'}" style="position: relative"><a class=buttonExport is-intervention=false csv-download download=vespaData_export_{{vm.currentDate}} ng-if=vm.csvShowVespa column-header=vm.headerValue input-array=vm.columnValue ng-style="{\'background-color\': vm.traceabilityInformationResponse ? $root.renaultPrimaryColor :\'#dadada\'}">{{\'EXPORT_BUTTON\' | translate}}</a></div><md-tooltip>{{\'EXPORT_BUTTON_MSG\' | translate}}</md-tooltip></div><div style="float: right;padding-bottom:20px" ng-if="vm.numberOfPagesToDisplay > 1"><paging-control paging-size=5 noofitem=vm.pageSize total-pages=vm.numberOfPagesToDisplay page-change=vm.getTableData(page) current-page=vm.currentTablePage></paging-control></div><div><table ng-if=vm.traceabilityInformationResponse st-table=traceabilityInformation st-safe-src=vm.traceabilityInformationResponse><tr><th><span>{{\'VESPA_REQUEST_TYPE\' | translate}}</span></th><th><span>{{\'VESPA_COUNTRY\' | translate}}</span></th><th><span class=sortable st-sort=requestReceptionDate>{{\'VESPA_REQUEST_RECEPTION_DATE\' | translate}}</span></th><th><span>{{\'VESPA_VEHICLE_FAMILY\' | translate}}</span></th><th><span>{{\'VESPA_ORGIN_TOOL\' | translate}}</span></th><th><span>{{\'VESPA_RETURN_CODE\' | translate}}</span></th><th><span>{{\'VESPA_ECU_ADDRESS\' | translate}}</span></th><th><span>{{\'VESPA_ECU_FLASHING_NETWORK\' | translate}}</span></th><th><span>{{\'VESPA_FILE_NUMBER_RETURNED\' | translate}}</span></th><th><span>{{\'VESPA_DIAG_TOOL_RESULT_CODE\' | translate}}</span></th><th><span class=sortable st-sort=transactionID>{{\'VESPA_TRANSACTION_ID\' | translate}}</span></th></tr><tr ng-click=vm.openDetails(element,element.requestType) ng-repeat-start="element in traceabilityInformation"><td>{{element.requestType | translate}}</td><td>{{element.diagnosticToolRequest.toolLocationArea}}</td><td>{{element.diagnosticToolRequest.requestReceptionDate}}</td><td>{{element.diagnosticToolRequest.vehicleFamily}}</td><td>{{element.diagnosticToolRequest.toolOrigin}}</td><td style="text-align: center;" ng-class=vm.colourCheckVespa(element)>{{element.reprogrammingFileRequestResult.returnCode}} <span ng-if="element.requestType == \'Configuration\'">{{element.configurationFileRequestResult.returnCode}}</span> <span ng-if="(element.requestType == \'Traceability\') || (element.requestType == \'TRACEABILITY_CONFIG_TRACE\')">{{element.traceabilityRequestResult.vespaTraceabilityReturnCode}}</span><md-tooltip style="max-width: 500px;\n                white-space: initial;\n                height: auto;\n                word-wrap: break-word;\n                line-height: 1rem;" ng-if="element.requestType == \'Reprogramming\'">{{element.reprogrammingFileRequestResult.vespaResponseDescription}}</md-tooltip><md-tooltip ng-if="element.requestType == \'Traceability\'">{{element.traceabilityRequestResult.vespaResponseDescription}}</md-tooltip><md-tooltip ng-if="element.requestType == \'Configuration\'">{{element.configurationFileRequestResult.vespaResponseDescription}}</md-tooltip><md-tooltip ng-if="element.requestType == \'TRACEABILITY_CONFIG_TRACE\'">{{element.traceabilityRequestResult.vespaResponseDescription}}</md-tooltip></td><td>{{element.diagnosticToolRequest.ecuAddress}}<md-tooltip ng-if=element.diagnosticToolRequest.ecuAddress>{{\'ECU_ADDRESS_\'+element.diagnosticToolRequest.ecuAddress | translate}}</md-tooltip></td><td>{{element.diagnosticToolRequest.ecuNetworkAccessType}}</td><td>{{element.diagnosticToolRequest.ecuReference}} <span ng-if="element.requestType == \'Configuration\'">{{element.diagToolConfigResult.ecuconfigFileNumber}}</span> <span ng-if="element.requestType ==\'TRACEABILITY_CONFIG_TRACE\'">{{element.diagToolConfigResult.ecuconfigFileNumber}}</span> <span ng-if="element.requestType == \'Traceability\'">{{element.diagToolReprogResult.ecuReprogFileNumber}}</span></td><td style="text-align: center;" ng-class=vm.colourCheckDiag(element)>{{element.diagToolReprogResult.reprogrammingResult}} <span style="text-align: center;" ng-if="element.requestType == \'TRACEABILITY_CONFIG_TRACE\'">{{element.diagToolConfigResult.configurationResult}}</span></td><td>{{element.diagnosticToolRequest.transactionID}}</td></tr><tr ng-repeat-end ng-if=element.isAdditionalinfo><td colspan=10><table><tr><td><span class="small-12 columns" ng-repeat="item in vm.detailObj track by $index"><span class="small-2 columns" style="margin-bottom:1%; float:left;" ng-repeat="data in item track by $index"><div style="white-space: break-spaces; color: grey;">{{data.label | translate}}</div><div style="white-space: break-spaces; font-weight: bold;word-break: break-all;">{{data.value ? data.value : \'&nbsp;\'}}</div></span></span></td></tr></table></td></tr></table></div><div ng-show=vm.noData class=no-data>{{\'NO_DATA_FOUND\' | translate}}</div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/NetworkDiagnosis/diagNetwork.template.html','<div style=margin-top:-8.5%;><div ng-if="vm.initialList.length !== 0 && !vm.filterLoader && (vm.diagFiles | filter:vm.initialCategory).length > 0"><select-all-check-box filter-array=vm.filterArray first-filter=vm.firstFilter second-filter=vm.secondFilter on-expand-all=vm.onExpandAll expand-all=vm.expandAll expand-all-enable=true></select-all-check-box></div><div ng-if=vm.filterLoader style="height: 75px;"><span><img src=../assets/images/newHourGlassGrey.gif width=50px alt="" style="margin-left: 45%;"></span></div><div class=row-one ng-repeat="diag in vm.diagFiles | filter: vm.initialCategory"><div class=row-two><div class="small-12 columns row-three" ng-click="vm.displayAndFilterNetwork(diag.id, diag.networkVisible)" id=diagFileSelected><div class="small-2 columns">{{diag.captureDateTime | customDateTime }}</div><div class="small-2 columns">{{ diag.id}}</div><div class="small-2 columns">{{ diag.category}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'B3\' || vm.typeMD === \'B2\'">{{\'CLIP\' | translate | uppercase}} {{ diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin === \'ADT\'">{{\'ADT\' | translate | uppercase}} {{diag.tootVersion}}</div><div class="small-2 columns" ng-if="vm.typeMD === \'ADT\' && diag.origin != \'ADT\' ">{{\'REMOTE\' | translate | uppercase}}</div><div class="small-2 columns"><span ng-if="vm.typeMD !== \'ADT\'">{{\'KILOMETRE\' | translate | uppercase}} : </span>{{diag.mileage}}</div><div class="small-1 columns" ng-if="vm.isArcaUser || vm.isAdtTechrole">{{ diag.dealerId}}</div><div class="small-1 columns"><i style="float: right; padding-top: 5px;" ng-class="{\' iconRight2 icon-icons_arrow_top\':diag.networkVisible ,\'iconRight2 icon-icons_arrow_bottom\':!diag.networkVisible}"></i></div></div><div class=network-container ng-if=diag.networkVisible><table class=networkTable ng-if="diag.networks.length > 0"><tbody ng-repeat="networks in diag.networks | customNestedFilter: vm.firstFilter" class=networkValues><tr ng-repeat="ecus in networks.ecus | customNestedFilter: vm.secondFilter"><td>{{networks.name}}</td><td ng-if="vm.typeMD === \'B3\' || vm.typeMD === \'B2\'">{{ecus.label}}</td><td ng-if="vm.typeMD === \'ADT\'">{{ecus.domainLabel}}</td><td>{{ecus.status}}</td></tr></tbody></table><table ng-if="diag.networks.length == 0" class="table table-striped full-width networkTable"><tr><td><p class=no-ecu>{{\'NO_DATA_FOUND\' | translate}}</p></td></tr></table></div></div></div><div class=row-one ng-if="vm.initialList.length === 0 || (vm.diagFiles | filter:vm.initialCategory).length === 0" ng-style="{\'margin-top\' : vm.initialList.length !== 0 ? \'0px\': \'76px\'}"><p class=no-ecu>{{\'NO_DIAGNOSTIC_FILE_FOUND\' | translate | uppercase}}</p></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/ResultSearchByDiagnostic/resultSearchByDiagnostic.html','<div class=recapCarDiv><recap-car api=vm.recapCarAPI icons=true></recap-car></div><div id=resultSearchByDiagnostic ng-if="!vm.checkIndependentUser || (vm.checkIndependentUser && ((vm.isAsomValidDocAccess === \'true\' && $root.asomDocList.BT || $root.asomDocList.MD) || vm.isAsomValidDocAccess === \'false\'))"><div ng-class="{\'resultSearchByDiagnosticMenu\': !vm.nissanUserURL,\'resultSearchByDiagnosticMenuNissan\': vm.nissanUserURL}"><div class=infoNode style="width: 100%; position: relative"><div class=btnBack ng-click=vm.backArbo()><i class=icon-icons-phnx_back style="margin-right:0px; margin-left: 0px;"></i> {{\'PRODUCT_PREVIOUS\'|translate}}</div><div class=separator></div><div class=textNode><div class=infoPiece>{{vm.code}}<span ng-if="vm.MDTabState && vm.searchedSymptom.documentationCode && vm.numberOfMD >= 1">-&nbsp;{{vm.searchedSymptom.docDescription}}&nbsp;<span ng-if=vm.searchedSymptom.ecuLabel>({{vm.searchedSymptom.ecuLabel}})</span></span></div></div><div class=createFIC ng-if="vm.istechLinerProfil && !vm.nissanUserURL" ng-style="{\'padding-right\':vm.showDiagNoise() ? \'350px\' : \'160px\' }"><button class="advancedSearch active" ng-click=vm.goToBtlist()><span class=iconDiv><i class=icon-icons-phnx_search></i></span><div class=btnText>{{\'BT_LIST_ADVANCED_SEARCH\' | translate }}</div></button></div><div style="padding-right: 160px;" class=createFIC ng-if="vm.showDiagNoise() && !vm.nissanUserURL"><button class="advancedSearch active" style=width:183px; ng-click=vm.goToDiagNoise()><span class=iconDiv><i class="fa fa-volume-up"></i></span><div class=btnText>{{\'DIAG_NOISES\' | translate }}</div><md-tooltip style="background-color: rgba(0, 0, 0, 0.7);margin-left: 5%; margin-top: 9px;  width: 16%;white-space: initial;height: auto;font-family: renaultGroupBold;">{{ \'DIAG_NOISE_TOOLTIP\' | translate }}</md-tooltip></button></div><div class=createFIC><button class=createFICButton ng-if="!vm.checkIndependentUser && !vm.nissanUserURL" ng-class="{\'disabled\': !vm.isActisProfil, \'active\': vm.isActisProfil}" style=width:154px; ng-click="vm.isActisProfil && vm.createFIC()" title={{vm.msgUserNotAllowed}}><div class=iconDiv><img src=assets/images/fic.png alt="" style="filter: brightness(0) invert(1);"></div><div class=btnText>{{\'ACTIS_CREATE_FIC\'|translate}}</div></button> <button class=createFICButton style="width: 175px;" ng-if="vm.checkIndependentUser && vm.isSupportAccess" ng-class="{ \'active\': vm.checkIndependentUser }" ng-disabled="vm.isDisplayCreateFIC === 0 || !vm.carContext.vin" ng-click=vm.createFIC()><div class=iconDiv><img src=assets/images/fic.png alt="" style="filter: brightness(0) invert(1);"></div><div class=btnText style="white-space: normal;">{{\'SUPPORT_INDEPENDENT_REQUEST_BUTTON\' | translate}}</div></button></div></div><div ng-if=!vm.loading><!--=======================\n            =       IF  B3 OR B2      =\n            ======================= --><div ng-if="(!vm.checkIndependentUser) || (vm.checkIndependentUser && vm.isAsomValidDocAccess==\'true\')"><tabset ng-if="vm.typeMD === \'B3\' || vm.typeMD === \'B2\'|| vm.typeMD === \'B2-3\' || vm.typeMD === \'ADT\'" id=btwo class=resultSearch><!--=====================================\n                =                BT TAB                 =\n                ======================================--><tab ng-if="(!vm.checkIndependentUser || (vm.checkIndependentUser && $root.asomDocList.BT)) && !vm.nissanUserURL " class="small-4 bold text-center" ng-attr-class="{{\n                     (!vm.numberOfBT && vm.numberOfMD ? \'divTab-disabled-50 divTab-disabled-notActive\'\n                     : vm.numberOfBT && vm.numberOfMD ? \'active\'\n                     : !vm.numberOfBT && !vm.numberOfMD ? \'divTab-disabled-50 tab-disabled\' : \'\')}}" disabled=!vm.numberOfBT active=vm.BTTabState heading=BT ng-style="{\'width\':vm.isArticleTabVisible ? \'33.33%\' : \'50%\' }" ng-click="vm.selectTab(\'BT\')"><div><div class="centered-div documents-not_found" ng-if=!vm.numberOfBT>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><!--=====================================\n                        =                TABLE BT               =\n                        ======================================--><div class="centered-div documents-table" ng-if=vm.numberOfBT><bt-documents docs=vm.listOfBTDocuments ng-if=vm.numberOfBT></bt-documents></div></div><p class=numberOfDocuments ng-hide="!vm.numberOfBT && !vm.numberOfMD">{{vm.numberOfBT}} {{\'DOCUMENTS_FOUND\' | translate}}</p></tab><!--=====================================\n                =                TAB MD                 =\n                ======================================--><tab class="small-4 bold text-center" ng-if="(!vm.checkIndependentUser || (vm.checkIndependentUser && $root.asomDocList.MD))" ng-attr-class="{{(vm.nissanUserURL ? \'nissan-tab \' : \'\') +\n                     (!vm.numberOfMD && vm.numberOfBT ? \'divTab-disabled-50\'\n                     : vm.numberOfMD && vm.numberOfBT ? \'disabled\'\n                     : !vm.numberOfMD && !vm.numberOfBT ? \'divTab-disabled-50 tab-disabled\' : \'\')}}" disabled=!vm.numberOfMD active=vm.MDTabState heading=MD ng-style="{\'width\':vm.isArticleTabVisible ? \'33.33%\' : \'50%\' }" ng-click="vm.selectTab(\'MD\')"><div><div class="centered-div documents-not_found" ng-if=!vm.numberOfMD>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><div class="centered-div documents-table" ng-if=vm.numberOfMD><md-documents docs=vm.listOfMDDocuments ng-if=vm.numberOfMD></md-documents></div></div><p class=numberOfDocuments ng-hide="!vm.numberOfMD && !vm.numberOfBT || vm.numberOfMD">{{vm.numberOfMD}} {{\'DOCUMENTS_FOUND\' | translate}}</p></tab><!--=====================================\n                =                ARTICLE TAB                 =\n                ======================================--><tab ng-if=!vm.nissanUserURL class="small-4 bold text-center" ng-attr-class="{{ !vm.displayArticlesList ? \'divTab-disabled-50 tab-disabled\' : \'\'}}" ng-show=vm.isArticleTabVisible heading="{{\'ARTICLES\'|translate}}" ng-style="{\'width\':vm.isArticleTabVisible ? \'33.33%\' : \'50%\' }" active=vm.ArticleTabState disabled=!vm.displayArticlesList ng-click="vm.selectTab(\'ARTICLES\')" title={{vm.msgUserNotAllowed}}><div><!--=====================================\n                        =                TABLE ARTICLES               =\n                        ======================================--><div class="centered-div documents-table" ng-if=vm.isArticleTabVisible><articles-documents></articles-documents></div></div></tab></tabset></div><div ng-if="vm.checkIndependentUser  && vm.isAsomValidDocAccess===\'false\'"><tabset ng-if="vm.typeMD === \'B3\' || vm.typeMD === \'B2\'|| vm.typeMD === \'B2-3\' || vm.typeMD === \'ADT\'" id=btwo class=resultSearch><!--=====================================\n                    =                BT TAB                 =\n                    ======================================--><tab class="small-6 bold text-center" ng-attr-class="{{ (!vm.numberOfBT && vm.numberOfMD ? \'divTab-disabled-50 divTab-disabled-notActive\'\n                                        : vm.numberOfBT && vm.numberOfMD ? \'active\'\n                                        : !vm.numberOfBT && !vm.numberOfMD ? \'divTab-disabled-50 tab-disabled\' : \'\') || !vm.accessToBtMd ? \'divTab-disabled-50 tab-disabled\' : \'\'}}" disabled=!vm.numberOfBT active=vm.BTTabState heading=BT ng-click="vm.selectTab(\'BT\')"><div><div class="centered-div documents-not_found" ng-if="!vm.numberOfBT || !vm.accessToBtMd">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><!--=====================================\n                            =                TABLE BT               =\n                            ======================================--><div class="centered-div documents-table" ng-if="vm.numberOfBT && vm.accessToBtMd"><bt-documents docs=vm.listOfBTDocuments ng-if="vm.numberOfBT && vm.accessToBtMd"></bt-documents></div></div><p class=numberOfDocuments ng-hide="(!vm.numberOfBT && !vm.numberOfMD) || !vm.accessToBtMd">{{vm.numberOfBT}} {{\'DOCUMENTS_FOUND\' | translate}}</p></tab><!--=====================================\n                    =                TAB MD                 =\n                    ======================================--><tab class="small-6 bold text-center" ng-attr-class="{{ (!vm.numberOfMD && vm.numberOfBT ? \'divTab-disabled-50\'\n                                        : vm.numberOfMD && vm.numberOfBT ? \'disabled\'\n                                        : !vm.numberOfMD && !vm.numberOfBT ? \'divTab-disabled-50 tab-disabled\' : \'\') || !vm.accessToBtMd ? \'divTab-disabled-50 tab-disabled\' : \'\'}}" disabled=!vm.numberOfMD active=vm.MDTabState heading=MD ng-click="vm.selectTab(\'MD\')"><div><div class="centered-div documents-not_found" ng-if="!vm.numberOfMD || !vm.accessToBtMd">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><div class="centered-div documents-table" ng-if="vm.numberOfMD && vm.accessToBtMd"><md-documents docs=vm.listOfMDDocuments ng-if="vm.numberOfMD && vm.accessToBtMd"></md-documents></div></div><p class=numberOfDocuments ng-hide="(!vm.numberOfMD && !vm.numberOfBT || vm.numberOfMD) || !vm.accessToBtMd">{{vm.numberOfMD}} {{\'DOCUMENTS_FOUND\' | translate}}</p></tab></tabset></div></div></div></div><div ng-if="vm.checkIndependentUser && vm.isAsomValidDocAccess === \'true\' && !$root.asomDocList.MD && !$root.asomDocList.BT" class=asosDocRights>{{\'ASOM_DOC_ACCESS\' | translate}}</div>');
$templateCache.put('app/components/car/searchByDiagnostic/SymptomBasketDetails/symptomBasketDetails.template.html','<div class=symptom-basket><div class=symptom-basket-container><table st-table=sympBasketData st-set-filter=stCustomFilter st-safe-src=vm.filteredSymptomBaskets class="table table-striped full-width symp-table"><thead><tr><th class=width15><span class=sortable st-skip-natural=true st-sort=basketcreationdate id=basketcreationdate aria-sort=none st-sort-default=reverse>{{\'CAR_SPLITS_DATE\' | translate}} </span><span><input type=search st-search=basketcreationdate ng-model=basketcreationdate></span></th><th class=width15><span class=sortable st-skip-natural=true st-sort=symptomCode aria-sort=none>{{\'SYMPTOM_CODE\' | translate}} </span><span><input type=search st-search=symptomCode ng-model=symptomCode></span></th><th class=width50><span class=sortable st-skip-natural=true st-sort=symptomLongLabel aria-sort=none>{{\'SYMPTOM\' | translate}} </span><span><input type=search st-search=symptomLongLabel ng-model=symptomLongLabel></span></th><th class=width10><span class=sortable st-skip-natural=true st-sort=vm.sortedField.isBTAvailable aria-sort=none>{{\'CAR_SEARCH_RESULT_FILTER_BT\' | translate}} </span><span><st-check-box column="\'isBTAvailable\'" display-array=vm.btDisplayArray ng-if="vm.btDisplayArray.length >0"></st-check-box></span></th><th class=width10><span class=sortable st-skip-natural=true st-sort=vm.sortedField.isMDAvailable aria-sort=none>{{\'CAR_SEARCH_RESULT_FILTER_MD\' | translate}} </span><span><st-check-box column="\'isMDAvailable\'" display-array=vm.mdDisplayArray ng-if="vm.mdDisplayArray.length >0"></st-check-box></span></th></tr></thead><tbody id=resetFilter st-clear-filter><tr ng-if="sympBasketData.length === 0"><td colspan=9><p class=no-symp-found>{{\'NO_DATA_FOUND\' | translate | uppercase}}</p></td></tr><em ng-keypress style="top: 115px;left: 77.5%;position: relative;cursor: pointer;" class="fa fa-info-circle iconRight2" ng-click=vm.displaySymptomData()></em><tr st-select-row=row st-select-mode=multiple ng-repeat="symptom in sympBasketData" ng-click=vm.redirectToDocPage(symptom)><td>{{symptom.basketcreationdate}}</td><td>{{symptom.symptomCode}}</td><td>{{symptom.symptomLongLabel}}<div ng-if="vm.isSymptomsDisplayed && symptom.symptomContexts"><br><span ng-class="{\'basketVl\': symptom.symptomContexts.comments}"><span class=symptomBasketData ng-if="symptom.symptomContexts.comments && (symptom.symptomContexts.comments !== null && symptom.symptomContexts.comments !== \' \')"><strong>{{\'BASKET_COMMENTS\' | translate}}&nbsp;:&nbsp;</strong>{{symptom.symptomContexts.comments}} </span><span class=symptomBasketData ng-repeat="context in symptom.symptomContexts.contextGroupsArray"><strong>{{context.groupName ? context.groupName + \' : \' : ""}}</strong> <span ng-repeat="admin in context.adminContextArray">{{admin.contextLabel ? admin.contextLabel : \'\'}}{{admin.contextValue ? \' \' + admin.contextValue : \'\'}} <span ng-if="context.adminContextArray.length > 1">{{admin.contextLabel && $last ? \'\' : \' / \'}}</span></span></span></span></div></td><td class=center-align><span ng-if=symptom.isBTLoading><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""> </span><span ng-if="symptom.isBTAvailable === \'YES\' && !symptom.isBTLoading"><i class="fa fa-check"></i></span></td><td class=center-align><span ng-if="symptom.isMDAvailable === \'YES\'"><i class="fa fa-check"></i></span></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/SystemDocumentation/systemDocumentation.template.html','<div id=systemDocumentation ng-class="{\'nissanTab\': vm.nissanUserURL}"><div class=row><tabset><tab heading="{{\'SYSTEM_FUNCTION\' | translate}}" ng-click=vm.showSystemFunction() disabled=!vm.systemTab active=vm.systemTab ng-attr-class="{{(vm.nissanUserURL ? \'nissan-tab \' : \'\') + ((!vm.systemDocResponse.systems || vm.systemDocResponse.systems.length == 0 || !vm.systemTabEnabled)?\'divTab-disabled-20 large-3 tab-disabled\':\'large-3\')}}"><div id=systemFunction><div class=row-one><div class=row-two><div ng-if=vm.systemTab><select-all-check-box filter-array=vm.filterArraySystem first-filter=vm.firstFilterSystem expand-all-enable=false></select-all-check-box></div><div class="small-12 columns row-three" ng-click=vm.systemDocExpanded(vm.selectedSystemDoc) id=diagFileSelected style="padding-right: 0px; padding-left: 1px;padding-top:1%;"><div class="small-3 columns">{{vm.selectedSystemDoc.system}}</div><div class="small-9 columns">{{ vm.selectedSystemDoc.locale}}<i style="float: right;padding: 0px 0px 6px 0px;\n                                    font-size: var(--renaultExtraLargeFont);" ng-class="{\' iconRight2 icon-icons_arrow_top\':vm.selectedSystemDoc.systemDocExpanded ,\'iconRight2 icon-icons_arrow_bottom\':!vm.selectedSystemDoc.systemDocExpanded}"></i></div></div><div style="background-color: white" ng-if=vm.selectedSystemDoc.systemDocExpanded><table class=system-doc-table><tr id=selectedMd ng-class="{\'md-result\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}" ng-click=vm.displayMdDetails(mdDoc) ng-repeat="mdDoc in vm.selectedSystemDoc.mdDocuments.MD | customNestedFilter : vm.firstFilterSystem"><td class="small-3 columns">{{mdDoc.ref}}</td><td class="small-4 columns">{{mdDoc.designation}}</td><td class="small-4 columns">{{mdDoc.type}}</td><td class="small-1 columns"><applicability-tooltip sie-doc=mdDoc></applicability-tooltip></td></tr><tr class=no-md-result ng-if=!vm.selectedSystemDoc.mdDocuments><td>{{"NO_DATA_FOUND" | translate | uppercase}}</td></tr></table></div></div></div></div></tab><tab heading="{{\'ELEMENT_HEAD\' | translate}}" ng-click=vm.goToElement() disabled=!vm.elementTab active=vm.elementTab ng-attr-class="{{(vm.nissanUserURL ? \'nissan-tab \' : \'\') + ((!vm.elementTabEnabled)?\'divTab-disabled-20 large-3 tab-disabled\':\'large-3\')}}"><div id=systemFunction><div class=row-one><div ng-if=vm.elementTab><select-all-check-box filter-array=vm.filterArrayElement first-filter=vm.firstFilterElement full-data-filter=vm.fullDataFilterElement on-expand-all=vm.onExpandAllElement expand-all=vm.expandAllElement expand-all-enable=true></select-all-check-box></div><div class=row-two ng-repeat="elements in vm.selectedSystemDoc.contributors | orderBy:\'contributor\' | customNestedFilter : vm.fullDataFilterElement"><div ng-click=vm.elementsDocExpanded(elements,false) ng-style="{\'margin-bottom\' : elements.elementExpanded == true ? \'0px\' : \'10px\'}" style="padding-right: 0px; padding-left: 1px;padding-bottom:0.5%; padding-top:0.5%;line-height: 1.2;" ng-attr-class="{{(!elements.mdId)?\'divTab-disabled-20 row-three small-12 columns\':\'row-three small-12 columns\'}}"><div class="small-3 columns">{{elements.contributor}}</div><div class="small-4 columns" class=labelLong>{{elements.longLabel}}</div><div class="small-4 columns">{{elements.ecuDomain}}</div><div class="small-1 columns"><i style="float:right; padding: 0px 0px 6px 0px; font-size: var(--renaultExtraLargeFont);" ng-class="{\'iconRight2  icon-icons_arrow_top\': elements.elementExpanded,\'iconRight2 icon-icons_arrow_bottom\':!elements.elementExpanded, \'iconGrey\':(!elements.mdId)}"></i></div></div><div style="background-color: white;" ng-if=elements.elementExpanded><table class=system-doc-table><tr id=selectedMd ng-class="{\'md-result\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}" ng-click=vm.displayMdDetails(mdDoc) ng-repeat="mdDoc in elements.mdDocuments | unique: \'id\' | customNestedFilter : vm.firstFilterElement"><td class="small-3 columns">{{mdDoc.ref}}</td><td class="small-4 columns">{{mdDoc.designation}}</td><td class="small-4 columns">{{mdDoc.type}}</td><td class="small-1 columns"><applicability-tooltip sie-doc=mdDoc></applicability-tooltip></td></tr><tr class=no-md-result ng-if="elements.mdDocuments.length === 0"><td>{{"NO_DATA_FOUND" | translate | uppercase}}</td></tr></table></div></div></div></div></tab><tab heading="{{\'DOCUMENT_BT_DTC_CODE\' | translate}}" ng-click=vm.goToDtc() disabled=!vm.dtcTab active=vm.dtcTab ng-attr-class="{{(vm.nissanUserURL ? \'nissan-tab \' : \'\') + ((!vm.dtcTabEabled)?\'divTab-disabled-20 large-3\':\'large-3\')}}"><div id=systemFunction><div class=row-one><div ng-if=vm.dtcTab><select-all-check-box filter-array=vm.filterArrayDtc first-filter=vm.firstFilterDtc full-data-filter=vm.fullDataFilterDtc on-expand-all=vm.onExpandAllDtc expand-all=vm.expandAllDtc expand-all-enable=true></select-all-check-box></div><div class=row-two ng-repeat="dtc in vm.selectedSystemDoc.dtcs | orderBy:\'dtcNumber\' | customNestedFilter : vm.fullDataFilterDtc"><div style="padding-right: 0px; padding-left: 0px;padding-top:1%;" ng-style="{\'margin-bottom\' : dtc.dtcExpanded == true ? \'0px\' : \'10px\'}" ng-click=vm.dtcDocExpanded(dtc,false) ng-attr-class="{{(!dtc.mdId)?\'divTab-disabled-20 row-three small-12 columns\':\'row-three small-12 columns\'}}"><div class="small-3 columns">{{dtc.dtcNumber}}</div><div class="small-4 columns">{{dtc.dtcLabel}}</div><div class="small-1 columns">{{dtc.ecuDomain}}</div><div class="small-3 columns">{{dtc.priorityClass}}</div><div class="small-1 columns"><i style="float:right;padding: 0px 0px 6px 0px; font-size: var(--renaultExtraLargeFont);" ng-class="{\'iconRight2 icon-icons_arrow_top\': dtc.dtcExpanded,\'iconRight2 icon-icons_arrow_bottom\': !dtc.dtcExpanded, \'iconGrey\':(!dtc.mdId)}"></i></div></div><div style="background-color: white;" ng-if=dtc.dtcExpanded><table class=system-doc-table><tr id=selectedMd ng-class="{\'md-result\':!vm.nissanUserURL,\'nissanSubCat\':vm.nissanUserURL}" ng-click=vm.displayMdDetails(mdDoc) ng-repeat="mdDoc in dtc.mdDocuments | customNestedFilter : vm.firstFilterDtc"><td class="small-3 columns">{{mdDoc.ref}}</td><td class="small-4 columns">{{mdDoc.designation}}</td><td class="small-4 columns">{{mdDoc.type}}</td><td class="small-1 columns"><applicability-tooltip sie-doc=mdDoc></applicability-tooltip></td></tr><tr class=no-md-result ng-if="dtc.mdDocuments.length === 0"><td>{{"NO_DATA_FOUND" | translate | uppercase}}</td></tr></table></div></div></div></div></tab></tabset></div></div>');
$templateCache.put('app/components/car/searchByDiagnostic/stCustomFilter/pagination.template.html','<ul class=pager ng-style="isSolution && {width:\'100%\'}" style="right:1px;width: 96%;" id=adtPagination><li><a ng-class="isSolution ? \'solutionWidth\' : \'adtPageWidth\'">{{(currentPage - 1) * dataperPage + 1}} - {{nextPage}}</a></li><li ng-class="{disabled:currentPage === 1}"><a ng-style="isSolution && {width:\'10%\'}" ng-click="currentPage === 1 ? null : setPage((currentPage === 1),currentPage - 1)"><i style="font-weight: bold;" class="fa fa-angle-left"></i></a></li><li ng-class="{disabled:dataperPage > totalCount || isLastPage}"><a ng-style="isSolution && {width:\'10%\'}" ng-click="(dataperPage > totalCount || isLastPage) ? null : \n                     setPage((dataperPage > totalCount),currentPage + 1)"><i style="font-weight: bold;" class="fa fa-angle-right"></i></a></li></ul>');
$templateCache.put('app/components/car/searchByDiagnostic/stCustomFilter/selectAllCheckBox.template.html','<table class=filterTable><tbody><tr><td class=multiselect ng-repeat="filterDetails in vm.filterArray track by $index" ng-class="filterDetails.class ? \'{{filterDetails.class}}\' : \'width20\'"><div class=selectBox ng-click="filterDetails.values.length > 0 && vm.showCheckboxes(filterDetails.key,filterDetails.expanded,$index)" ng-if=filterDetails.checkBox><md-input-container><input id=filterSelectBox type=text placeholder="{{filterDetails.label | translate | uppercase}}" ng-disabled="filterDetails.values.length <= 0" ng-model=filterDetails.selectedValues><md-icon style="right: -10px;font-size: 1.2rem;"><i class="fa fa-caret-down"></i></md-icon></md-input-container><div class=overSelect></div></div><div id=checkboxes class={{filterDetails.key}} ng-if="filterDetails.values.length > 0" ng-class="filterDetails.valuesStyle ? \'{{filterDetails.valuesStyle}}\' : \'width13margin\'" style="border: 1px solid white;"><label class=row><input class="large-3 medium-3 small-3" type=checkbox name=selectAll value=All ng-model=filterDetails.selectAll ng-click=vm.selectAllCheckBox(filterDetails) style=display:block;float:left; ng-style="{\'margin-left\': vm.filterArray.length <= 3 ? \'-0.8rem\' : \'0\'}"> <span class="large-9 medium-9 small-9" style=display:block;text-align:left;>{{\'SELECT_ALL\' | translate | uppercase}}</span></label> <label ng-repeat="display in filterDetails.values | orderBy:\'data\'" class=row><input class="large-3 medium-3 small-3" type=checkbox name=selectedData[] value={{display.data}} ng-model=display.selected ng-click=vm.onCheckBoxClick(filterDetails,display.data,true) style=display:block;float:left; ng-style="{\'margin-left\': vm.filterArray.length <= 3 ? \'-0.8rem\' : \'0\'}"> <span class="large-9 medium-9 small-9" ng-if="!display.class && !display.json" style="display:block;text-align:left;word-break: break-all;width: 100%;">{{display.data}}</span> <span class="large-9 medium-9 small-9" ng-if=display.class style="display:block;text-align:left;word-break: break-all;width: 100%;"><i class={{display.class}}></i></span> <span class="large-9 medium-9 small-9" ng-if=display.json style="display:block;text-align:left;word-break: break-all;width: 100%;">{{display.json}}</span></label></div><div class=filterTextBox ng-if=!filterDetails.checkBox><md-input-container ng-if="filterDetails.custom !== \'numeric\'"><input id=filterTextBox type=text placeholder="{{filterDetails.label | translate | uppercase}}" ng-disabled=!filterDetails.values ng-model=filterDetails.values.data ng-change=vm.onCheckBoxClick(filterDetails,filterDetails.values.data,false) ng-click=vm.selectOnInput()></md-input-container><md-input-container ng-if="filterDetails.custom === \'numeric\'"><input id=filterTextBox type=number placeholder="{{filterDetails.label | translate | uppercase}}" ng-disabled=!filterDetails.values ng-model=filterDetails.values.data onwheel=this.blur() ng-change=vm.onCheckBoxClick(filterDetails,filterDetails.values.data,false) ng-click=vm.selectOnInput()></md-input-container></div></td><td ng-if=vm.expandAllEnable style="width: 4%;"><button type=button class=left ng-class="{\'buttonWithIconRenault\': !vm.nissanUserURL,\'buttonWithIconNissan\':vm.nissanUserURL}" ng-click=vm.expandCollapse(vm.expandAll) title="{{\'EXPAND_COLLAPSE_ALL\' | translate}}"><div class=iconDiv style=border-right:none;><i class="fa fa-sort" aria-hidden=true></i></div></button></td></tr></tbody></table>');
$templateCache.put('app/components/car/searchByDiagnostic/stCustomFilter/stCheckBox.template.html','<div class=multiselect><div class=selectBox ng-click=vm.showCheckboxes()><select class=statuses><option>{{vm.selStatus}}</option></select><div class=overSelect></div></div><div id=checkboxes class={{vm.column}}><label ng-repeat="display in vm.displayArray"><input type=checkbox name=selectedData[] value={{display.data}} ng-model=vm.checkSelected ng-true-value="\'{{display.data}}\'" ng-false-value=false ng-if=display.class ng-checked="vm.filteredArray.indexOf(display.data) > -1" ng-click=onCheckBoxClick(display)> <span ng-if=display.class><i class={{display.class}}></i></span></label></div></div>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSchemaCanFusibleDocResidualList.template.html','<md-dialog id=electricalSchemaCanFusesOtherDocumentsDetails><div id=canFusesOtherDocumentsDetailsFormat style="overflow: auto;"><div class="row closeComponentDetailsPopInRow fixedPopInHeader" style="display: flex !important; flex-direction: row; padding: 5px 0px;"><div class=small-11>&nbsp;</div><div class="small-1 closeButton" ng-click=vm.closePopIn()>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_CLOSE_POPIN\' | translate}} X</div></div><div><div ng-repeat="item in vm.documentToDisplay track by $index" class=residualDisplay ng-class="{\'nissanHoverColor\' : vm.nissanUserURL, \'renaultHoverColor\': !vm.nissanUserURL}" ng-click=vm.openPdfFileInNewTab(item.location)><div ng-bind-html=item.applicabilityResidualChain></div></div></div></div></md-dialog>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSchemaComponentDetails.template.html','<md-dialog id=electricalSchemaComponentDetails><div id=componentDetailsAccordion style="overflow: auto;"><div class="row closeComponentDetailsPopInRow fixedPopInHeader" style="display: flex; flex-direction: row; padding: 5px 0px;"><div class=small-10>&nbsp;</div><div ng-if=vm.isPrintComponentEnable class=small-1 style="left:3%;bottom: -7px;position: relative;"><i class=icon-icons_print_partlist ng-click=vm.printComponent()></i></div><div ng-style="{\'left\':!vm.isPrintComponentEnable ? \'10%\' : \'1.5%\'}" style="position: relative; width: 5%;" class=closeButton ng-click=vm.closePopIn()>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_CLOSE_POPIN\' | translate}} X</div></div><accordion ng-class="{\'nissanColor\': vm.nissanUserURL}"><div ng-if="vm.componentDetailsList.WIRING_DIAGRAMS.length == 1"><accordion-group ng-click="componentGroup.isWDCompOpen = !componentGroup.isWDCompOpen ; " ng-repeat="componentGroup in vm.componentDetailsList.WIRING_DIAGRAMS track by $index" is-open="vm.componentDetailsList.WIRING_DIAGRAMS.length == 1" class=firstResidualMarginTop ng-class="{ \'nissanUsers\': vm.nissanUserURL }"><accordion-heading><p ng-if="componentGroup.title && componentGroup.title.length > 0" ng-bind-html=componentGroup.title></p><hr ng-if="componentGroup.residual.length > 1" style="margin: 0px; border: solid #000000; border-width: 3px 0 0;"><div ng-if="componentGroup.residual.length >= 1" class=boxColor ng-bind-html=componentGroup.applicabilityResidualChain></div><div ng-class="componentGroup.residual.length > 1 ? \'arrowMargin\': \'0px\'"><i class=right ng-class="{\'fa fa-chevron-down\': !componentGroup.isWDCompOpen, \'fa fa-chevron-right\': componentGroup.isWDCompOpen}"></i></div></accordion-heading><div class="row columns"><div class="greyBg borderLeft columns">&nbsp;</div></div><div class="row columns"><div class="small-4 columns greyBg borderLeft borderBottom popInInfoDisplay">{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_COMPONENT_LABEL\' | translate}}</div><div class="small-8 columns borderRight borderBottom popInInfoDisplay">{{vm.componentCode}} - {{vm.componentLabel}}</div></div><div ng-if=componentGroup.isImage class="row columns"><div class="small-4 columns marginB8 pinTablePadding"><table ng-if="componentGroup.pinsUse && componentGroup.pinsUse.length > 0"><tbody><tr><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_PIN_CODE\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_WIRE_CROSS_SECTION\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL_LABEL\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_CONNECTOR_CODE\' | translate}}</td></tr><tr ng-repeat="item in componentGroup.pinsUse[0].list"><td class=headerAlign>{{item.pinCode}}</td><td class=headerAlign>{{item.wireCrossSection}}</td><td class=headerAlign>{{item.signal}}</td><td>{{item.signalLabel}}</td><td class=headerAlign>{{item.connectorCode}}</td></tr></tbody></table></div><div class="small-8 columns displayConnector marginB8"><img class=imgWidth ng-src={{componentGroup.location}} alt=""></div></div><object ng-if=componentGroup.isPDF data={{componentGroup.location}} height="1250px " width=100% scrolling=no type=application/pdf type=application/pdf><p>PDF cannot be displayed.</p></object></accordion-group></div><div ng-if="vm.componentDetailsList.WIRING_DIAGRAMS.length  > 1"><accordion-group ng-repeat="componentGroup in vm.componentDetailsList.WIRING_DIAGRAMS track by $index" is-open=componentGroup.isWDCompOpen class="firstResidualMarginTop wiring-diagram-item" ng-class="{ \'nissanUsers\': vm.nissanUserURL }"><accordion-heading><p ng-if="componentGroup.title && componentGroup.title.length > 0" ng-bind-html=componentGroup.title></p><hr ng-if="componentGroup.residual.length > 1" style="margin: 0px; border: solid #000000; border-width: 3px 0 0;"><div ng-if="componentGroup.residual.length >= 1" class=boxColor ng-bind-html=componentGroup.applicabilityResidualChain></div><div ng-class="componentGroup.residual.length > 1 ? \'arrowMargin\': \'0px\'"><i class=right ng-class="{\'fa fa-chevron-down\': componentGroup.isWDCompOpen, \'fa fa-chevron-right\': !componentGroup.isWDCompOpen}"></i></div></accordion-heading><div class="row columns"><div class="greyBg borderLeft columns">&nbsp;</div></div><div class="row columns"><div class="small-4 columns greyBg borderLeft borderBottom popInInfoDisplay">{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_COMPONENT_LABEL\' | translate}}</div><div class="small-8 columns borderRight borderBottom popInInfoDisplay">{{vm.componentCode}} - {{vm.componentLabel}}</div></div><div ng-if=componentGroup.isImage class="row columns"><div class="small-4 columns marginB8 pinTablePadding"><table ng-if="componentGroup.pinsUse && componentGroup.pinsUse.length > 0"><tbody><tr><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_PIN_CODE\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_WIRE_CROSS_SECTION\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_SIGNAL_LABEL\' | translate}}</td><td class=headerAlign>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS_CONNECTOR_CODE\' | translate}}</td></tr><tr ng-repeat="item in componentGroup.pinsUse[0].list"><td class=headerAlign>{{item.pinCode}}</td><td class=headerAlign>{{item.wireCrossSection}}</td><td class=headerAlign>{{item.signal}}</td><td>{{item.signalLabel}}</td><td class=headerAlign>{{item.connectorCode}}</td></tr></tbody></table></div><div class="small-8 columns displayConnector marginB8"><img class=imgWidth ng-src={{componentGroup.location}} alt=""></div></div><object ng-if=componentGroup.isPDF data={{componentGroup.location}} height="1250px " width=100% scrolling=no type=application/pdf type=application/pdf><p>PDF cannot be displayed.</p></object></accordion-group></div></accordion></div></md-dialog>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSchemaHarness.template.html','<div class=recapCarDiv><recap-car icons=true></recap-car></div><div class=infoNode><div class=btnBack ng-click=vm.goToArbo()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}}</div><div class=separatorHarness></div><div style="font-weight: bold;"></div>{{\'HARNESS_LAYOUT\' | translate}}</div><div class="small-12 columns"><div class="small-2 columns thumbnaildetails singleThumbClass" ng-repeat="picture in vm.wiringDiagramData track by $index" ng-click=vm.displayThumbnailOnClick(picture.id)><div><img ng-src={{picture.thumbnailLocation}} alt=""><!--    Display residual applicability if no raw MTC (search by electrical schemas arbo) --><div ng-if="picture.formattedResidual.length > 0 && picture.rawMTCdata.length === 0" class="cursor-default icon-information-residual" ng-class="{\'harness-active-icon-information-residual\' : picture.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;font-family: \'renaultGroupRegular\';"><div ng-repeat="item in picture.formattedResidual  track by $index" style="line-height: 1.5;">{{item}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div><!--    Display raw MTC if both raw MTC and residual applicability are present (search by electrical schemas arbo) --><div ng-if="picture.rawMTCdata.length > 0" class="cursor-default icon-information-residual" ng-class="{\'harness-active-icon-information-residual\' : picture.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div style="line-height: 1.5;">{{picture.rawMTCdata}}<br><div ng-if="picture.variableResidual && picture.variableResidual.length > 0" ng-repeat="item in picture.variableResidual">{{item}}</div></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div></div><div class=selected-component ng-if="$index == vm.selected"></div></div></div>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSchemalevel3Multi.template.html','<div class=recapCarDiv><recap-car callback=vm.saveState() api=vm.recapCarAPI icons=true is-wd=vm.isFromWDUrlLink></recap-car></div><div id=electricalSchemaSelectedNode class=containerView><div class=infoNode><div class=btnBack ng-if="!vm.originallyFromWDUrlLink && !vm.isFromWDUrlLink" ng-click=vm.goToArbo()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}}</div><div class=btnBack ng-if="vm.isSieDocumentsExists && !vm.isFromWDUrlLink " ng-click=vm.backToprevious()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=separator ng-if=!vm.isFromWDUrlLink></div><div class=textNode><div class=level1and2 ng-if=!vm.displayTitleOnly><div ng-click="!vm.originallyFromWDUrlLink && vm.goToArbo(1)">{{vm.labelNode1 |toCamelCase}}</div><i class=icon-icons-phnx_arrow_link ng-style="vm.nissanUserURL && {\'color\' : \'#FF8E8F\'}"></i><div ng-click="!vm.originallyFromWDUrlLink && vm.goToArbo(2)">{{vm.formatNodeLabel(vm.labelNode2, 2)}}</div><i class=icon-icons-phnx_arrow_link ng-style="vm.nissanUserURL && {\'color\' : \'#FF8E8F\'}"></i> {{vm.formatNodeLabel(vm.labelNode3, 3)}}</div><div class=level3 ng-if=vm.displayTitleOnly>{{vm.formatNodeLabel(vm.labelNode3, 3)}}</div></div></div><div class=iconOnTopsRight ng-if="vm.wdObjectCriteria && vm.wiringDiagrams && vm.wiringDiagrams.length >=1" ng-click=vm.selectFilter()><img src=../assets/images/Filter.png class=icon-icons_filter alt=""></div><div class=es-error ng-if=vm.isNoDocumentReturned><h4>{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div class="row unstyle-row" ng-if=!vm.isNoDocumentReturned><div class="columns multiThumbClass" ng-repeat="thumbnail in vm.wiringDiagrams" ng-class="(thumbnail.residual && thumbnail.residual.length > 0)? \'small-9\' : \'small-3\'" ng-style="{\'display\': (thumbnail.residual && thumbnail.residual.length > 0) ? \'inline-flex\' : \'\'}"><div ng-class="(thumbnail.residual && thumbnail.residual.length > 0)? \'small-4\' : \'\'"><span ng-if=!thumbnail.residual.length class="cursor-default icon-information"><md-tooltip style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="item in vm.wiringDiagrams| limitTo:1" style="line-height: 1.5; font-weight:bold; text-align: center">{{thumbnail.name}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></span><img ng-click=vm.displayElectricalSchema(thumbnail) ng-src={{thumbnail.thumbnailLocation}} ng-class="{\'nissanBorder\' : vm.nissanUserURL}" class="borderThumb full-width" alt=""></div><div ng-if="thumbnail.residual && thumbnail.residual.length > 0" class="small-5 columns borderThumb residualButton" ng-class="{\'nissanBorder\' : vm.nissanUserURL}" ng-click=vm.displayElectricalSchema(thumbnail)><div ng-repeat="item in vm.formatResidual(thumbnail)| limitTo:1 track by $index" style="line-height: 1.5; font-weight:bold;">{{item}}</div><div ng-repeat="item in vm.formatResidual(thumbnail)| limitTo : vm.formatResidual(thumbnail).length : 1 track by $index" style="line-height: 1.5;">{{item}}</div></div></div></div></div>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSchemalevel3Single.template.html','<div class=recapCarDiv><recap-car callback=vm.saveState() api=vm.recapCarAPI icons=true is-wd=vm.isFromWDUrlLink></recap-car></div><div id=electricalSchemaSelectedSingleNode class=containerView style="overflow: hidden;"><div class=infoNode><div class=btnBack ng-if="!vm.originallyFromWDUrlLink && !vm.isFromWDUrlLink && !vm.isMDInNewTab" ng-click=vm.goToArbo()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}}</div><div class=btnBack ng-if="vm.isSieDocumentsExists && !vm.isFromWDUrlLink && !vm.isMDInNewTab" ng-click=vm.backToprevious()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=btnBack ng-if="vm.wdFromCompSelectedList.length > 1 && vm.isWDComponentNameList && !vm.isFromWDUrlLink && !vm.isMDInNewTab" ng-click=vm.showPreviousWDFromComp()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=separator ng-if="!vm.isFromWDUrlLink && !vm.isMDInNewTab"></div><div ng-class="{\'textNode\':!vm.isHarnessSelected,\'textNodeHarness\':vm.isHarnessSelected}" ng-if=(!vm.isRelatedElectricalSchemaWdNode)><div class=level1and2><div ng-click="!vm.originallyFromWDUrlLink && vm.goToArbo(1)">{{vm.labelNode1 |toCamelCase}}</div><i class=icon-icons-phnx_arrow_link ng-style="vm.nissanUserURL && {\'color\' : \'#FF8E8F\'}"></i><div ng-click="!vm.originallyFromWDUrlLink && vm.goToArbo(2)">{{vm.formatNodeLabel(vm.labelNode2, 2)}}</div><i class=icon-icons-phnx_arrow_link ng-style="vm.nissanUserURL && {\'color\' : \'#FF8E8F\'}"></i></div><div ng-click="!vm.originallyFromWDUrlLink && vm.WDList.length > 1 ? vm.goToArbo(3) : \'\'" ng-class="{\'level3\':vm.WDList.length > 1,\'level3NoClick\':vm.WDList.length === 1}">{{vm.formatNodeLabel(vm.labelNode3, 3)}}</div></div><div ng-class="{\'textNode\':!vm.isHarnessSelected,\'textNodeHarness\':vm.isHarnessSelected}" ng-if="vm.isRelatedElectricalSchemaWdNode && vm.displayComponent">{{vm.componentCode}} {{vm.componentLabel}}</div><div ng-class="{\'textNode\':!vm.isHarnessSelected,\'textNodeHarness\':vm.isHarnessSelected}" ng-if="((!vm.isComponentSelected && !vm.showComponentLabel) || !vm.showComponentDropDownList && vm.displayTitleOnly)">{{vm.formatNodeLabel(vm.labelNode3, 3)}}</div></div><div class="row iconOnTopRight" ng-show="vm.isPrintSVGButtonActivated === true" style="width: auto;"><div class="small-6 columns" style="margin-top: 5%;" ng-if=vm.showHightlightAll ng-class="{ \'nissanUsers\': vm.nissanUserURL }"><md-tooltip><span>{{\'WD_HIGHLIGHT_ALL\'| translate}}</span></md-tooltip><md-switch ng-model=vm.isNodeHighlight ng-change=vm.highlightAllLines() style=display:inline ng-if=!vm.isHarnessSelected></md-switch></div><div class="small-6 columns"><i class=icon-icons_print_partlist ng-click=vm.downloadPdf()></i></div></div><div class="row unstyle-row margin-top"><div id=WDContainer class="small-9 columns minDimensions" ng-class="{ \'nissanBorder\': vm.nissanUserURL}" ng-if="(vm.isComponentSelected || vm.showComponentLabel) && vm.showElectricalSVGFile"><div ng-if=vm.wiringDiagram.isPDF class=pdf-fullscreen style="position: absolute; top: -5%;right: 0%;" ng-click=vm.openPdfInFullScreen()><i class="fa fa-arrows-alt" style="border: 2px solid black; padding: 2px;"></i></div><electrical-schema-pdf ng-if=vm.wiringDiagram.isPDF data={{vm.wiringDiagram.location}}></electrical-schema-pdf><electrical-svg ng-if="!vm.wiringDiagram.isPDF && vm.svg" location=vm.wiringDiagram.location data=vm.wiringDiagram app-svg=vm.svg></electrical-svg><div class=pngFileDimensions ng-if=vm.wiringDiagram.isPNG><img ng-src={{vm.wiringDiagram.location}} alt=""></div></div><div class="small-3 float-left"><form ng-if="vm.isComponentSelected || vm.showComponentDropDownList" layout=row flex=100 ng-submit=vm.displayListData(component,true); ng-click="vm.selectedComponentColoredLabel != null && vm.handleComposantAutoCompleteClick($event) ? component.label = \'\' : component.label = component.label" id=autoCompleteComposantSE layout-align="start center"><md-autocomplete flex md-no-cache=true md-min-length=0 md-selected-item=vm.selectedComponentColoredLabel md-autoselect=true , id={{component}} md-search-text=component.label md-items="component in vm.wiringDiagram.components.concat(vm.wiringDiagram.signals) | filter:component.label" md-clear-button=true md-item-text=component.idAndLabel placeholder="{{\'ELECTRICAL_SCHEMAS_COMPONENTS_LIST\' | translate}}" md-selected-item-change="vm.displayListData(component,true); " md-menu-class="{{vm.nissanUserURL ? \'nissanUser\' : \'renaultUser\'}}"><span md-highlight-text=searchText ng-style="$index === vm.wiringDiagram.components.length && {\'display\':\'block\',\'width\':\'100%\',\'height\':\'5%\',\'background\':\'#000\',\'margin-top\':\'0.5%\',\'margin-bottom\':\'0.5%\'}" ng-class="{\'nissanUser\': vm.nissanUserURL, \'renaultUser\': !vm.nissanUserURL}" style="font-size:var(--renaultSmallFont);font-family: \'renaultGroupRegular\';">{{component.id}} - {{component.label}}</span><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;" ng-if="component.idAndLabel.length > 40">{{component.id}} - {{component.label}}</md-tooltip></md-autocomplete></form></div><div class="small-3 float-left thumbnailsList"><div class=small-7 ng-if="!vm.isHorseUser && !vm.onlyOneDocReturnedByClip && (vm.displayComponentButton || vm.isUserComingFromClip) && ((vm.selectedComponentColoredLabel != null && vm.selectedComponentColoredLabel != \'\') || (vm.lastComponent != null && vm.lastComponent != \'\') || vm.componentSvgObject)"><div class="component-container-image marginB10"><div ng-repeat="picture in vm.componentSvgObject track by $index" ng-click="vm.displayThumbnailOnClick(picture); vm.activateSelectedComponent($index)" ng-class="{\'selected-component\': $index == vm.selected && !vm.nissanUserURL, \'nissanSelectedComponent\': $index == vm.selected && vm.nissanUserURL}" class="component border singleContainer"><div><img ng-src={{picture.thumbnailLocation}} alt=""><!--    Display residual applicability if no raw MTC (search by electrical schemas arbo) --><div ng-if="picture.formattedResidual.length > 0 && picture.rawMTCdata.length === 0" class="cursor-default icon-information-residual" ng-class="{\'active-icon-information-residual\' : picture.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;font-family: \'renaultGroupRegular\';"><div ng-repeat="item in picture.formattedResidual  track by $index" style="line-height: 1.5;">{{item}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div><!--    Display raw MTC if both raw MTC and residual applicability are present (search by electrical schemas arbo) --><div ng-if="picture.rawMTCdata.length > 0" class="cursor-default icon-information-residual" ng-class="{\'active-icon-information-residual\' : picture.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div style="line-height: 1.5;">{{picture.rawMTCdata}}<br><div ng-if="picture.variableResidual && picture.variableResidual.length > 0" ng-repeat="item in picture.variableResidual">{{item}}</div></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div></div><div ng-if="$index == vm.selected" ng-class="{\'selected-component\': $index == vm.selected && !vm.nissanUserURL, \'nissanSelectedComponent\': $index == vm.selected && vm.nissanUserURL}"></div></div></div></div><div class=small-4><div class=containerButton><md-button class="md-raised buttonWithIcon componentDetailsButton marginB10" ng-class="{\'disabled_background\': !vm.isDetailsAvailable,\'nissanColor\': (vm.nissanUserURL && vm.isDetailsAvailable), \'renaultColor\': (!vm.nissanUserURL && vm.isDetailsAvailable)}" ng-click=vm.openComponentDetails(vm.selectedComponent) ng-disabled="vm.selectedComponent.type === \'WD_SIGNAL\' || !vm.isDetailsAvailable"><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText>{{\'ELECTRICAL_SCHEMAS_COMPONENT_DETAILS\' | translate}}</div></md-button></div><div class=containerButton><md-button class="md-raised buttonWithIcon componentDetailsButton marginB10" ng-class="{\'disabled_background\': !vm.isWDCan,\'nissanColor\': (vm.nissanUserURL && vm.isWDCan), \'renaultColor\': (!vm.nissanUserURL && vm.isWDCan)}" ng-disabled=!vm.isWDCan ng-click="vm.displayCanAndFusesDocuments(vm.WD_CAN_DOC, \'CAN\')"><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_CAN_NETWORK\' | translate}}</div></md-button></div><div class=containerButton ng-if=!vm.isHorseUser><md-button class="md-raised buttonWithIcon componentDetailsButton marginB10" ng-class="{\'disabled_background\': !vm.isWDFusible,\'nissanColor\': (vm.nissanUserURL && vm.isWDFusible), \'renaultColor\': (!vm.nissanUserURL && vm.isWDFusible)}" ng-disabled=!vm.isWDFusible ng-click="vm.displayCanAndFusesDocuments(vm.WD_CAN_DOC, \'DOCUMENT\')"><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_FUSE_RELAY\' | translate}}</div></md-button></div><!-- FULLSCREEN EN TRAVAUX\n<div class="containerButton">\n    <md-button\n    class="md-raised buttonWithIcon componentDetailsButton marginB10"\n    ng-class="{\'inactive\' : !vm.isWDFusible}"\n    ng-disabled="!vm.isWDFusible"\n    ng-click="vm.displayWDFullScreen(vm.wiringDiagram.location)">\n    <div class="iconDiv">\n        <i class="fa fa-file-text-o"></i>\n    </div>\n    <div class="btnText">\n        {{\'ELEC_FULLSCREEN_DISPLAY\' | translate}}\n    </div>\n</md-button>\n</div> --><md-menu-bar ng-if=!vm.isHorseUser><md-menu><div class="containerButton marginB10"><md-button class="md-raised buttonWithIcon componentDetailsButton" ng-class="{\'inactive\' : !vm.isWDOtherDocument,\'nissanColor\': vm.nissanUserURL, \'renaultColor\': !vm.nissanUserURL}" ng-click="vm.setOtherDocumentsWidthValue(); $mdOpenMenu()" ng-disabled=!vm.isWDOtherDocument><div class=iconDiv><i class="fa fa-file-text-o"></i></div><div class=btnText>{{\'ELEC_OTHER_DOCUMENT\' | translate}}</div></md-button></div><md-menu-content id=otherDocumentsMenu ng-class="{\'nissanMenu\': vm.nissanUserURL, \'renaultMenu\': !vm.nissanUserURL}"><md-menu-item ng-repeat="type in vm.otherDocumentsList track by $index"><md-button ng-class="{\'nissanListHover\': vm.nissanUserURL, \'renaultListHover\': !vm.nissanUserURL}" ng-click=vm.displayResidualFromDocumentName(type) style="font-family: var(--renaultFontRegular) !important">{{ type |translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div ng-if="vm.WDNamelist.length > 0 && vm.isWDComponentNameList" style="width: 155px;margin-top: 20px;"><div style="text-align: center; padding: 5px;  margin-top: 3%;background-color: #e6e6e6;">{{\'HEADER_DOCUMENTS_DIAGRAMS\' | translate}}</div><div style="box-shadow: 0px 0px 10px #ede3e3; padding-left:1%;max-height: 300px;\n                    overflow-y: scroll;"><ul style="width: 70%;"><li style="list-style-type: disc" ng-repeat="wdItem in vm.WDNamelist"><a style="text-decoration: underline;" ng-click=vm.displaySelectedSchema(wdItem.displayedThumbnail,wdItem.id);vm.updateBreadcrumb(wdItem);>{{wdItem.name | capitalize}}</a></li></ul></div></div></div></div><div class="small-9 columns" style="float: left !important; margin-top: 40px;" ng-if="vm.wiringDiagramData && vm.wiringDiagramData.length && !vm.showElectricalSVGFile"><div ng-repeat="(key, value) in vm.wiringDiagramData" class="border relatedElectricalSchemas"><div ng-if=value.subNode>{{value.subNode.function.label}} > {{value.subNode.subFunction.label}} > {{value.subNode.title.label}}</div><div class=marginB5T10><div class="marginR15 marginB15" ng-repeat="(key2, value2) in value.residualInfo track by $index"><img ng-src={{value2.displayedThumbnail}} class=borderThumb ng-class="{\'activeElectricalSchema\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation,\'nissanBorder\' : vm.nissanUserURL}" ng-click="vm.displaySelectedSchema(value2.displayedThumbnail,value2.id); vm.updateBreadcrumb(value)" alt=""><!--    Display residual applicability if no raw MTC (search by component) --><div ng-if="value2.formattedResidual.length > 0 && value2.rawMTCdata.length === 0" class="icon-information cursor-default" ng-class="{\'active-icon-information\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="item in value2.formattedResidual track by $index" style="line-height: 1.5;">{{item}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div><!--    Display raw MTC if both raw MTC and residual applicability are present (search by component) --><div ng-if="value2.rawMTCdata.length > 0" class="icon-information cursor-default" ng-class="{\'active-icon-information\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div style="line-height: 1.5;">{{value2.rawMTCdata}}<br><div ng-if="value2.variableResidual && value2.variableResidual.length > 0" ng-repeat="item in value2.variableResidual">{{item}}</div></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div></div></div></div></div></div><div class="row unstyle-row columns marginT20" ng-if="vm.relatedElectricalSchema.nodes.wdNode && vm.relatedElectricalSchema.nodes.wdNode.length && ((vm.selectedComponentColoredLabel != null && vm.selectedComponentColoredLabel != \'\') || (vm.lastComponent != null && vm.lastComponent != \'\'))"><div ng-repeat="(key, value) in vm.relatedElectricalSchema.nodes.wdNode" class="border relatedElectricalSchemas"><div ng-if=value.subNode>{{value.subNode.function.label}} > {{value.subNode.subFunction.label}} > {{value.subNode.title.label}}</div><div class=marginB5T10><div class="marginR15 marginB15" ng-repeat="(key2, value2) in value.residualInfo track by $index"><img ng-src={{value2.displayedThumbnail}} class=borderThumb ng-class="{\'activeElectricalSchema\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation, \'nissanBorder\' : vm.nissanUserURL}" ng-click="vm.displaySelectedSchema(value2.displayedThumbnail, value2.id); vm.updateBreadcrumb(value)" alt=""><!--    Display residual applicability if no raw MTC (search by electrical schemas arbo) --><div ng-if="value2.formattedResidual.length > 0 && value2.rawMTCdata.length === 0" class="icon-information cursor-default" ng-class="{\'active-icon-information\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="item in value2.formattedResidual track by $index" style="line-height: 1.5;">{{item}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div><!--    Display raw MTC if both raw MTC and residual applicability are present (search by electrical schemas arbo) --><div ng-if="value2.rawMTCdata.length > 0" class="icon-information cursor-default" ng-class="{\'active-icon-information\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div style="line-height: 1.5;">{{value2.rawMTCdata}}<br><div ng-if="value2.variableResidual && value2.variableResidual.length > 0" ng-repeat="item in value2.variableResidual">{{item}}</div></div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div></div></div></div></div><div class="small-9 columns" style="float: left !important; margin-top: 40px;" ng-if="(vm.wiringDiagramData && vm.wiringDiagramData.length && vm.showElectricalSVGFile && !vm.onlyOneDocReturnedByClip) &&\n!(vm.relatedElectricalSchema.nodes.wdNode && vm.relatedElectricalSchema.nodes.wdNode.length && ((vm.selectedComponentColoredLabel != null && vm.selectedComponentColoredLabel != \'\')\n|| (vm.lastComponent != null && vm.lastComponent != \'\')))"><div ng-repeat="(key, value) in vm.wiringDiagramData" class="border relatedElectricalSchemas"><div ng-if=value.subNode>{{value.subNode.function.label}} > {{value.subNode.subFunction.label}} > {{value.subNode.title.label}}</div><div class=marginB5T10><div class="marginR15 marginB15" ng-repeat="(key2, value2) in value.residualInfo track by $index"><img ng-src={{value2.displayedThumbnail}} class=borderThumb ng-class="{\'activeElectricalSchema\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation, \'nissanBorder\' : vm.nissanUserURL}" ng-click="vm.displaySelectedSchema(value2.displayedThumbnail,value2.id); vm.updateBreadcrumb(value)" alt=""><div ng-if="value2.formattedResidual.length > 0" class="icon-information cursor-default" ng-class="{\'active-icon-information\' : value2.displayedThumbnail == vm.wiringDiagram.thumbnailLocation}"><md-tooltip style="background-color: grey; color: white; border-style: solid;border-width: 1px; height: auto !important; max-width: 900px !important; white-space: normal;"><div ng-repeat="item in value2.formattedResidual track by $index" style="line-height: 1.5;">{{item}}</div></md-tooltip><md-icon md-font-set=material-icons class="material-icons font-size-30" aria-label="" md-labeled-by-tooltip=md-tooltip-30 role=img>info</md-icon></div></div></div></div></div><scroll-up scroll-trigger=300 scroll-anchor=.infoNode></scroll-up></div>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/electricalSvg.template.html','<div resize-pr container=list id=electrical-svg-container style="padding: 0;"><!--\n        HACK FOR IE height="100%" is not working ON SVG so we set\n        a img tag which contains svg as background for height and set the SVG as position absolute, height, width 100%\n    --><div style="z-index: 10000; color: black; position: absolute; right: 5%; top: 10px;background-color: white; padding: 1%; border: 5px solid var(--renaultPrimaryColor); display: none;" id=WDTooltip></div><img class=background-image ng-src={{vm.location}} imageonload=vm.applySvgPanZoom alt=""><div ng-if=vm.fullOrReducedScreen class=svg-control-fullscreen><div ng-click=vm.fullOrReducedScreen() ng-keypress=vm.fullOrReducedScreen($event)><span><p style="position: inherit;" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div ng-if=vm.svgPanZoom class=svg-control-container><div class=center-icon><span><i ng-click=vm.zoomIn() class="fa fa-plus svg-control-zoom"></i></span></div><div ng-click=vm.resetZoom() class=svg-control-reset>&#x21BB;</div><div class=center-icon><span><i ng-click=vm.zoomOut() class="fa fa-minus svg-control-zoom"></i></span></div></div></div>');
$templateCache.put('app/components/car/searchElectricalSchema/selectedNode/objectCriteriaModal.template.html','<div id=objCriteriaTable ng-class="{\'options-visible\': vm.dropdownOpen}"><table><tr><th colspan=2 class=centerAlign ng-class="{\'renaultTitle\': !vm.nissanUserURL, \'nissanTitle\': vm.nissanUserURL}">{{\'OBJCRIT_WD_HEADER\' | translate}}</th></tr><tr><td class="centerAlign textBold">{{\'COMMON_LABEL\' | translate | uppercase}}</td><td class="centerAlign textBold">{{\'CRITERIA\' | translate | uppercase}}</td></tr><tr ng-repeat="obj in vm.residual" class=whiteBackdrop><td>{{obj.labelObj}}</td><td><div class=custom-dropdown ng-click=vm.toggleDropdown(obj) ng-class="{ open: obj.dropdownOpen }"><input class=input-with-arrow ng-model=obj.labelCrit readonly=readonly><ul style="z-index: 999;position: relative;" class=options ng-if=obj.dropdownOpen ng-class="{\'renaultOptions\': !vm.nissanUserURL, \'nissanOptions\': vm.nissanUserURL}"><li style="height: 26px;"></li><li ng-repeat="item in obj.listCrit" ng-click="vm.selectItem(obj, item.labelCrit); $event.stopPropagation()" ng-class="{ hovered: vm.hoveredIndex === $index }" ng-mouseenter="vm.hoveredIndex = $index">{{item.labelCrit}}</li></ul></div></td></tr><tr><td class=centerAlign><button type=button ng-class="{\'buttonWithIcon\': !vm.nissanUserURL, \'buttonWithIcon nissanButtonWithIcon\': vm.nissanUserURL}" ng-click=vm.onConfirm()><div class=btnText>{{\'APPLY\' | translate | uppercase}}</div></button></td><td class=centerAlign><button type=button ng-class="{\'buttonWithIcon cancel\': !vm.nissanUserURL, \'buttonWithIcon nissanButtonWithIcon\': vm.nissanUserURL}" ng-click=vm.onCancel()><div class=btnText>{{\'ACTIS_HEADER_CANCEL\' | translate | uppercase}}</div></button></td></tr></table></div>');
$templateCache.put('app/components/car/searchSpecializedTool/selectedTool/specializedToolBattery.template.html','<div style="padding:10px;font-family: var(--renaultFontRegular);"><div class=closeAlign><span ng-keypress class="text closeCursor" ng-click=vm.closePopIn()><em class=icon-icons_close></em></span></div><div class=message><div ng-bind-html=vm.detail></div><a href=https://shop-sbs.com target=_blank>{{\'shop-sbs\'}}</a></div></div>');
$templateCache.put('app/components/car/searchSpecializedTool/selectedTool/specializedToolSelection.template.html','<div id=specializedToolSelectionPopIn class="row full-width" layout-align="center center"><div class="row mainContainer" style="margin: auto;"><div class=small-5 id=leftPart ng-class="{\'small-5\': !vm.nissanUserURL,\'small-11\': vm.nissanUserURL}"><div class="row secondaryContainer"><div class="small-2 columns blackBorder" ng-bind-html=vm.pictogram></div><div class="small-5 columns blackBorder centerText">{{vm.identifier}}</div><div class="small-5 columns centerText">{{vm.reference.split(\' \').join(\'\') | filterFormatRef}}</div></div><div class="row secondaryContainer"><div class="small-12 columns">{{vm.designation}}<br>{{vm.comment}}</div></div><div ng-if=!vm.nissanUserURL class="row secondaryContainer"><div class="small-12 columns"><strong>{{\'SEARCH_SPECIALIZED_TOOL_SUPPLIER\' | translate}} : </strong>{{vm.supplier}}</div></div><img ng-src={{vm.pictureUrl}} alt=""></div><!-- MOCKED DATA SO FAR, WILL BE REMOVED WHEN DATAHUB SERVICE IS AVAILABLE --><div class=columns id=rightPart ng-class="{\'small-1\': vm.nissanUserURL,\'small-7\': !vm.nissanUserURL}" style="bottom: 20px;"><div ng-class="{\'row\': !vm.nissanUserURL}" style="justify-self: center;"><div class=small-10>&nbsp;</div><div class="small-2 closeButtonSection" ng-click=vm.closePopIn()>{{\'SEARCH_SPECIALIZED_TOOL_CLOSE_POPIN\' | translate}}<div id=closePopInButton class="icon-icons_close floatIcon"></div></div></div><div class="list border-bottom" ng-repeat="applicableFamiliesObject in vm.applicableFamilies" ng-if=!vm.nissanUserURL><div ng-if="applicableFamiliesObject.applicabilityToBeDisplayed && applicableFamiliesObject.applicabilityToBeDisplayed.length > 0"><strong>{{applicableFamiliesObject.label}}</strong> : {{applicableFamiliesObject.code}} -- {{applicableFamiliesObject.applicabilityToBeDisplayed}}<br></div><div ng-if=!applicableFamiliesObject.applicabilityToBeDisplayed><div ng-if="applicableFamiliesObject.code == applicableFamiliesObject.applicability"><strong>{{applicableFamiliesObject.label}}</strong> : {{applicableFamiliesObject.code}}<br></div><div ng-if="applicableFamiliesObject.code != applicableFamiliesObject.applicability"><strong>{{applicableFamiliesObject.label}}</strong> : {{applicableFamiliesObject.code}} -- {{applicableFamiliesObject.applicability.substring(applicableFamiliesObject.applicability.indexOf("/") + 1)}}<br></div></div></div></div></div></div>');
$templateCache.put('app/components/client/settings/components/confirmDeleteFamilyLabel.template.html','<div id=delete-family-label><div class=labelF><strong>{{\'DELETE_CUSTOMER_GROUP\' | translate}} ?</strong></div><div class="labelF center"><span>{{vm.label}}</span></div><div class=button-container><button ng-click=vm.onConfirm() type=button class="buttonWithIcon buttonPosition"><div class=iconDiv><i class="fa fa-trash confirm-icon"></i></div><div class=btnText>{{\'COMMON_DELETE\' | translate}}</div></button> <button type=button ng-click=vm.onCancel() class="buttonWithIcon buttonPosition cancel"><div class=iconDiv><i class="icon-icons_close close-icon"></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/client/settings/components/updateFamilyLabel.template.html','<div id=update-family-label><div class=labelF><strong>{{\'MODIFY_CUSTOMER_GROUP\' | translate}} ?</strong></div><div><strong>{{\'COMMON_LABEL\' | translate}} </strong><span style="text-transform: lowercase;">({{\'FAMILY_GROUP_SAME_DESIGNATION\' | translate}})</span></div><input maxlength=30 ng-value=vm.label ng-model=vm.label><div class=button-container><button type=button ng-click=vm.onConfirm() class="buttonWithIcon buttonPosition"><div class=iconDiv><i class="fa fa-save confirm-icon"></i></div><div class=btnText>{{\'COMMON_SAVE\' | translate}}</div></button> <button type=button ng-click=vm.onCancel() class="buttonWithIcon buttonPosition cancel"><div class=iconDiv><i class="icon-icons_close close-icon"></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/dms/quote/draft/quote.template.html','<div class=containerView id=createQuote><!--BLOC HEADER --><div class="row headerPartList"><div class="small-1 columns numPartList"><div class=backPartList ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-5 columns"><label class=labelNumPartList>{{\'COMMON_ESTIMATE_ID\' |translate}} {{vm.quote.number}}</label> <label class="labelValidateByPartList size-14">{{\'ESTIMATION_CREATE_DATE\' |translate}} {{vm.quote.creationDateTime | date:\'yyyy/MM/dd\' }} {{\'ACTION_BY\' |translate}} {{vm.quote.creatorIPN}}</label> <label ng-if="vm.quote.lastModificationDateTime != \'\'" class="labelValidateByPartList size-14">{{\'ESTIMATION_UPDATE_DATE\' |translate}} {{vm.quote.lastModificationDateTime | date:\'yyyy/MM/dd\' }} {{\'ACTION_BY\' |translate}} {{vm.quote.lastModifierIPN}}</label></div><div class="small-6 columns listPartListAction"><div ng-click=vm.saveQuote(vm.quote) class=clickable><i class=icon-icons_save_partlist></i> <label>{{\'BUTTON_ESTIMATE_SAVE\' |translate}}</label></div><div class=clickable><md-menu><div id=printIcon class=clickable ng-click=$mdMenu.open()><i class=icon-icons_print_partlist></i></div><md-menu-content id=menuContent width=2><md-menu-item class=custom-label ng-click=vm.printQuote(false,false)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_KO\' |translate}}</span></md-menu-item><md-menu-item class=custom-label ng-click=vm.printQuote(true,false)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_OK\' |translate}}</span></md-menu-item></md-menu-content></md-menu><label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div class=clickable style=position:relative;><md-menu><div id=printIcon class=clickable ng-click=$mdMenu.open()><i class="fa fa-download"></i></div><md-menu-content id=menuContent width=2><md-menu-item class=custom-label ng-click=vm.printQuote(false,true)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_KO\' |translate}}</span></md-menu-item><md-menu-item class=custom-label ng-click=vm.printQuote(true,true)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_OK\' |translate}}</span></md-menu-item></md-menu-content></md-menu><label>{{\'BUTTON_ESTIMATE_DOWNLOAD\' |translate}}</label></div><div ng-click="vm.closeQuote(vm.quote, false)" class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><!-- TODO remove this after refacto--><div ng-if=vm.client class=border-costumer-informations><basket-client-informations client=vm.client></basket-client-informations></div><!--BLOC CLIENT --><dms-customer view=standard on-new-customer-callback=vm.onNewCustomerCallback on-select-customer-callback=vm.onSelectCustomerCallback send-dms-request=vm.callDMSForCustomer on-updated-customer-callback=vm.onUpdateCustomerCallback on-reset-customer-callback=vm.resetCustomerCallback current-customer=vm.currentCustomer on-customer-filled-callback=vm.onCustomerFilledCallback on-set-customer-details=vm.onSetCustomerDetails></dms-customer><!--BLOC COMMENT --><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.quote.description.length || 0}}</span> <span>/100</span></div><textarea id=description class="comment textarea inputCommentItalic" ng-model-options="{ debounce: 500 }" name=comment rows=2 cols=20 ng-model=vm.quote.description ng-attr-placeholder="*{{\'COMMON_TEXTAREA_PLACEHOLDER\'|translate}}" maxlength=100>\n            </textarea></div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic" style="background-color: #F1F2F3; border: none;min-height: 0px !important;">{{\'RGPD_MESSAGE\' |translate}}</div></div><!-- BLOC VEHICLE --><div class=blocVehiculePartList ng-if=vm.vehicle><div class=row ng-if=vm.vehicle><div class="small-12 columns blocVehiculeBandeauSelected"><div class=changeContextVehicleQuote><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader><label class=designationVehiculeBlocContext><span ng-bind-html=vm.bannerData></span></label> <label class=vinImatVehiculeBlocContext><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span></label></div><!--KILOMETRAGE--> <i ng-if=vm.isWorkshop class=icon-icons_kilometer_quote></i><div ng-if=vm.isWorkshop class=containerKilometerBlocContext><input ng-if=vm.isWorkshop id=mileageInput numbers-only type=text class=inputKilometerBlocContext ng-change=vm.onChangeKM(vm.quote.mileAge) ng-model=vm.quote.mileAge ng-model-options="{debounce: 750}" ng-value=vm.quote.mileAge></div><label ng-if=vm.isWorkshop>Km/Miles</label><!--if atelier we show the Order Number (OR)--><div class=vehicleOr ng-if=vm.isWorkshop><i class=icon-icons_repair></i> <label for=orderNumberSelect>{{\'COMMON_ORDER_NUMBER\' | translate}}</label> <select id=orderNumberSelect class=en_bas ng-change=vm.onChangeOrderNumber(vm.quote.orderNumber) ng-model=vm.quote.orderNumber ng-options="option for option in vm.orderList"></select></div></div></div></div><!-- BLOC ITEMS --><div class=row><div class=row ng-if=!vm.quote.items><div class="small-12 columns blocVehiculeContenuQuoteEmpty"><label>{{\'ESTIMATE_EMPTY\' | translate | uppercase }}</label></div></div><div class=row ng-if="vm.quote.items || vm.quote.inter.length > 0"><!-- Interventions / Operation --><div ng-if="vm.quote.inter.length > 0"><div class=headerPRorTM><label class=label_pr>{{\'PARTLIST_TABLE_TITLE_SPLIT\' | translate | uppercase}}</label></div><div class=row ng-repeat="inter in vm.quote.inter"><label class="row headerTitleInterventions"><span style="margin-left: 7px; font-weight: bold; font-size: 20px; text-decoration: underline;">{{inter.designation}}</span> <span class="fa fa-trash deleteIcon" ng-click=vm.deleteByDesignation(inter,true) style="font-size: var(--renaultExtraLargeFont); margin-left: 3px;"></span> <span ng-if="inter.interQuantity > 1" class=qtyCircle>X{{inter.interQuantity}}<md-tooltip>{{\'SEVERAL_OPERATIONS\' | translate}}</md-tooltip></span></label><div ng-if="inter.PR.length > 0"><label class="label_pr row headerTitleInterventions" style="padding-left: 10px;">{{\'HEADER_PR\' | translate | uppercase}}</label><div class="row blocVehiculeContenuPartListWithPR"><div class="row headerTabListPRorTM"><div class="small-1 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortPRBy(\'reference\')"></i></div><div class="small-4 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns taxCode_div_empty"><label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if="vm.showDiscountRatePrColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithPR"><div class="small-12 row contentTabListPRorTM" id=_{{item.reference}} ng-init="prIndex=$index" ng-repeat="item in inter.PR | orderBy:vm.propertyNamePR:vm.reversePR track by $index" ng-if="item.quantity != 0"><div class="small-12 row"><div ng-class=vm.getReferenceClass(item.isLocalPiece) ng-click="!item.isLocalPiece && vm.goToProduct(item)"><label class="caractere_label white-space" style=display:flex;>{{item.reference | filterFormatRef}}&nbsp; <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(item.reference);$event.stopPropagation();></i></label></div><div class="small-4 columns break-all-word" ng-class=vm.getDesignationClass(item.isLocalPiece) ng-click="!item.isLocalPiece && vm.goToProduct(item)"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div class="small-1 columns taxCode_div_empty"><label class=caractere_label ng-if=item.cort>{{item.cort}}</label></div><div class="small-2 columns nonClickable"><div ng-if=item.price><label class=caractere_label>{{item.price | number:2}} {{vm.getCurrencyForItem()}}</label></div><div class=center_label ng-if=!item.price>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns"><shopping-cart-quote-page page=quotePage piece=item type=PR></shopping-cart-quote-page></div><div ng-if="vm.showDiscountRatePrColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate class=caractere_label>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-2 columns"><div class="small-9 columns"><span ng-if=vm.isQuoteCalculated><label ng-if=item.totalPriceExclTaxes class=caractere_label>{{item.totalPriceExclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if="!item.totalPriceExclTaxes && !item.isKnownDms"><i class="fa fa-exclamation-triangle" style="color: red"></i></div><div class=center_label ng-if="!item.totalPriceExclTaxes && item.isKnownDms">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></span><span ng-if=!vm.isQuoteCalculated><div class=center_label>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></span></div><div class="small-3 columns"><i ng-if="vm.esTimateStatus !==3" class=icon-icons_remove_quote ng-click=vm.deleteReference(item)></i></div></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n            bloc new PR returned by dms function estimate\n\n        /////////////////////////////////////////////////////////--><div class="row contentTabListPRorTM" ng-init="prIndex=$index" ng-if=vm.isQuoteCalculated ng-repeat="item in inter.itemsReturnedPR | orderBy:vm.propertyNamePR:vm.reversePR"><div class="small-1 columns" ng-click=vm.goToProduct(item)><label class=caractere_label>{{item.reference | filterFormatRef}}&nbsp;</label></div><div class="small-4 columns break-all-word" ng-click=vm.goToProduct(item)><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div class="small-1 columns taxCode_div_empty"><label class=caractere_label ng-if=item.cort>{{item.cort}}</label></div><div class="small-2 columns nonClickable"><div><label class=caractere_label ng-if=item.amount.exclTaxes>{{item.amount.exclTaxes}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div><div class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div class="small-2 columns"><div class="small-9 columns"><label ng-if=item.amount.exclTaxes class=caractere_label>{{item.amount.exclTaxes}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i ng-if="vm.esTimateStatus !==3" class=icon-icons_remove_quote ng-click="vm.removeRef(sectionIndex, pr)"></i></div></div></div></div><div ng-if="inter.TM.length > 0"><label class="label_pr row headerTitleInterventions" style="padding-left: 10px;">{{\'COMMON_TABLE_MO_TITLE\' | translate | uppercase}}</label><div class="row blocVehiculeContenuPartListWithTM"><div class="row headerTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}"><div class="small-1 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortTMBy(\'reference\')"></i></div><div class="small-4 columns"><label>{{\'COMMON_COLUMN_LABEL_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithTM"><div class="row contentTabListPRorTM" ng-repeat="item in inter.TM | orderBy:vm.propertyNameTM:vm.reverseTM" ng-if="item.quantity != 0"><div class="small-1 columns"><label class=caractere_label>{{item.opecod | trim}}&nbsp;</label></div><div class="small-4 columns break-all-word"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div ng-if=!item.isNotCodified class="small-1 columns temps_div_width"><label class=caractere_label>{{vm.getTMDuration(item)}}&nbsp;</label></div><div class="small-2 columns"><div ng-if="item.hourlyRate && vm.isHourlyRatesLoaded && vm.isQuoteCalculated"><label class=caractere_label>{{(item.hourlyRate | number:2)}} <span>{{vm.getCurrencyForItem()}}</span></label></div><div ng-if="!item.hourlyRate && item.exclTaxes"><label class=caractere_label>{{(item.exclTaxes | number: 2)}} <span>{{vm.getCurrencyForItem()}}</span></label></div><div ng-if="((!item.exclTaxes || !vm.isPositifNumber(item.exclTaxes)) && (!vm.isQuoteCalculated || !item.hourlyRate))"><div class=center_label>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div></div><div class="small-1 columns"><shopping-cart-quote-page piece=item type=TM></shopping-cart-quote-page></div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-2 columns"><div class="small-9 columns"><label class=caractere_label ng-if="item.totalPriceExclTaxes && vm.isQuoteCalculated">{{ item.totalPriceExclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if="!item.totalPriceExclTaxes || !vm.isQuoteCalculated">{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i class=icon-icons_remove_quote ng-click=vm.deleteReference(item)></i></div></div></div><!-- //////////////////////////////////////////////////////\n\n            bloc new TM returned by dms function estimate\n                /////////////////////////////////////////////////////////--><div ng-if=vm.isQuoteCalculated class="row contentTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}" ng-repeat="item in vm.itemsReturned.TM | orderBy:vm.propertyNameTM:vm.reverseTM" ng-init="sectionTm = $index"><div class="small-1 columns"><label class=caractere_label>{{item.code}}&nbsp;</label></div><div class="small-2 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div ng-if=!item.isNotCodified class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div class="small-2 columns"><div ng-if=!vm.isLoadingDMSData>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-2 columns"><div class="small-9 columns"><label class=caractere_label ng-if=item.amount.exclTaxes>{{ item.amount.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i ng-if="estimCtrl.esTimateStatus !==3" class=icon-icons_remove_quote ng-click="estimCtrl.removeRef(sectionIndex, item)"></i></div></div></div></div></div></div><div class=row><div class="small-10 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-2 columns"><div class="small-12 columns"><div ng-if="vm.isQuoteCalculated && vm.interItemsTax" class=price_label_gras_1>{{ vm.interItemsTax | number: 2 }} {{vm.getCurrencyForItem()}}</div><div ng-if=!vm.interItemsTax class=price_label_gras_1>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div></div></div><!-- BLOC PR --><div ng-if=vm.isShowPR><div class=headerPRorTM><label>{{\'HEADER_PR\' | translate | uppercase}}</label></div><div class="row blocVehiculeContenuPartListWithPR"><div class="row headerTabListPRorTM"><div class="small-1 columns"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortPRBy(\'reference\')"></i></div><div class="small-4 columns"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns taxCode_div_empty"><label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if="vm.showDiscountRatePrColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithPR"><div class="small-12 row contentTabListPRorTM" id=_{{item.reference}} ng-init="prIndex=$index" ng-repeat="item in vm.quote.items | filter:{ type: \'PR\' } | orderBy:vm.propertyNamePR:vm.reversePR track by $index"><div class="small-12 row"><div ng-class=vm.getReferenceClass(item.isLocalPiece) ng-click="!item.isLocalPiece && vm.goToProduct(item)"><label class="caractere_label white-space" style=display:flex;>{{item.reference | filterFormatRef}}&nbsp; <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;padding-top: 3px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=vm.copyToClipboard(item.reference);$event.stopPropagation();></i></label></div><div class="small-4 columns break-all-word" ng-class=vm.getDesignationClass(item.isLocalPiece) ng-click="!item.isLocalPiece && vm.goToProduct(item)"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div class="small-1 columns taxCode_div_empty"><label class=caractere_label ng-if=item.cort>{{item.cort}}</label></div><div class="small-2 columns nonClickable"><div ng-if=item.price><label class=caractere_label>{{item.price | number:2}} {{vm.getCurrencyForItem()}}</label></div><div class=center_label ng-if=!item.price>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns"><shopping-cart-quote-page page=quotePage piece=item type=PR></shopping-cart-quote-page></div><div ng-if="vm.showDiscountRatePrColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate class=caractere_label>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-2 columns"><div class="small-9 columns"><span ng-if=vm.isQuoteCalculated><label ng-if=item.totalPriceExclTaxes class=caractere_label>{{item.totalPriceExclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if="!item.totalPriceExclTaxes && !item.isKnownDms"><i class="fa fa-exclamation-triangle" style="color: red"></i></div><div class=center_label ng-if="!item.totalPriceExclTaxes && item.isKnownDms">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></span><span ng-if=!vm.isQuoteCalculated><div class=center_label>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></span></div><div class="small-3 columns"><i ng-if="vm.esTimateStatus !==3" class=icon-icons_remove_quote ng-click=vm.deleteReference(item)></i></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n                bloc new PR returned by dms function estimate\n\n            /////////////////////////////////////////////////////////--><div class="row contentTabListPRorTM" ng-init="prIndex=$index" ng-if=vm.isQuoteCalculated ng-repeat="item in vm.itemsReturned.PR | orderBy:vm.propertyNamePR:vm.reversePR"><div class="small-1 columns" ng-click=vm.goToProduct(item)><label class=caractere_label>{{item.reference | filterFormatRef}}&nbsp;</label></div><div class="small-4 columns break-all-word" ng-click=vm.goToProduct(item)><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div class="small-1 columns taxCode_div_empty"><label class=caractere_label ng-if=item.cort>{{item.cort}}</label></div><div class="small-2 columns nonClickable"><div><label class=caractere_label ng-if=item.amount.exclTaxes>{{item.amount.exclTaxes}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div><div class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div class="small-2 columns"><div class="small-9 columns"><label ng-if=item.amount.exclTaxes class=caractere_label>{{item.amount.exclTaxes}} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i ng-if="vm.esTimateStatus !==3" class=icon-icons_remove_quote ng-click="vm.removeRef(sectionIndex, pr)"></i></div></div></div></div><div class=row><div class="small-10 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-2 columns"><div class="small-12 columns"><div ng-if="vm.isQuoteCalculated && vm.quote.inter.length == 0 && vm.taxesReturned.parts.exclTaxes" class=price_label_gras_1>{{vm.taxesReturned.parts.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</div><div ng-if="vm.isQuoteCalculated && vm.quote.inter.length > 0 &&  vm.taxesReturnedPrTm.parts.exclTaxes" class=price_label_gras_1>{{vm.taxesReturnedPrTm.parts.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</div><div ng-if="!vm.taxesReturned.parts.exclTaxes && !vm.taxesReturnedPrTm.parts.exclTaxes" class=price_label_gras_1>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div></div></div><!-- BLOC TM --><div ng-if=vm.isShowTM><span class=headerPRorTM><div class=grey><label>{{\'COMMON_TABLE_MO_TITLE\' | translate | uppercase}}</label></div></span><div class="row blocVehiculeContenuPartListWithTM"><div class="row headerTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}"><div class="small-1 columns"><label>{{\'CODE_TM\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortTMBy(\'reference\')"></i></div><div class="small-4 columns"><label>{{\'COMMON_COLUMN_LABEL_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithTM"><div class="row contentTabListPRorTM" ng-repeat="item in vm.quote.items | filter:{ type: \'TM\' } | orderBy:vm.propertyNameTM:vm.reverseTM"><div class="small-1 columns"><label class=caractere_label>{{item.opecod | trim}}&nbsp;</label></div><div class="small-4 columns break-all-word"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div ng-if=!item.isNotCodified class="small-1 columns temps_div_width"><label class=caractere_label>{{vm.getTMDuration(item)}}&nbsp;</label></div><div class="small-2 columns"><div ng-if="item.hourlyRate && vm.isHourlyRatesLoaded && vm.isQuoteCalculated"><label class=caractere_label>{{(item.hourlyRate | number:2)}} <span>{{vm.getCurrencyForItem()}}</span></label></div><div ng-if="!item.hourlyRate && item.exclTaxes"><label class=caractere_label>{{(item.exclTaxes | number: 2)}} <span>{{vm.getCurrencyForItem()}}</span></label></div><div ng-if="((!item.exclTaxes || !vm.isPositifNumber(item.exclTaxes)) && (!vm.isQuoteCalculated || !item.hourlyRate))"><div class=center_label>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div></div><div class="small-1 columns"><shopping-cart-quote-page piece=item type=TM></shopping-cart-quote-page></div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-2 columns"><div class="small-9 columns"><label class=caractere_label ng-if="item.totalPriceExclTaxes && vm.isQuoteCalculated">{{ item.totalPriceExclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if="!item.totalPriceExclTaxes || !vm.isQuoteCalculated">{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i class=icon-icons_remove_quote ng-click=vm.deleteReference(item)></i></div></div></div><!-- //////////////////////////////////////////////////////\n\n            bloc new TM returned by dms function estimate\n                /////////////////////////////////////////////////////////--><div ng-if=vm.isQuoteCalculated class="row contentTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}" ng-repeat="item in vm.itemsReturned.TM | orderBy:vm.propertyNameTM:vm.reverseTM" ng-init="sectionTm = $index"><div class="small-1 columns"><label class=caractere_label>{{item.code}}&nbsp;</label></div><div class="small-2 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div ng-if=!item.isNotCodified class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div class="small-2 columns"><div ng-if=!vm.isLoadingDMSData>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div><div ng-if="vm.showDiscountRateTmColumn && vm.isQuoteCalculated" class="small-1 columns remise_div_width"><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-2 columns"><div class="small-9 columns"><label class=caractere_label ng-if=item.amount.exclTaxes>{{ item.amount.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</label><div class=center_label ng-if=!item.amount.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-3 columns"><i ng-if="estimCtrl.esTimateStatus !==3" class=icon-icons_remove_quote ng-click="estimCtrl.removeRef(sectionIndex, item)"></i></div></div></div></div><div class=row><div class=row><div class="small-10 columns"><label class="price_label_gras_1 text-to-right">{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div class="small-2 columns"><div class="small-12 columns"><div ng-if="vm.isQuoteCalculated && vm.quote.inter.length == 0 && vm.taxesReturned.labourTimes.exclTaxes" class=price_label_gras_1>{{ vm.taxesReturned.labourTimes.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</div><div ng-if="vm.isQuoteCalculated && vm.quote.inter.length > 0 &&  vm.taxesReturnedPrTm.labourTimes.exclTaxes" class=price_label_gras_1>{{ vm.taxesReturnedPrTm.labourTimes.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</div><div ng-if="!vm.isQuoteCalculated || (!vm.taxesReturned.labourTimes.exclTaxes && !vm.taxesReturnedPrTm.labourTimes.exclTaxes)" class=price_label_gras_1>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div></div></div></div></div></div><!-- FOOTER VEHICLE --><div class=row ng-hide=vm.contextCarBrandCheck><div class="small-12 columns blocVehiculeFooter" ng-if=!vm.isValidated()><label>{{\'COMMON_ADD_REF\'|translate}}</label><div class=inputSearch><form ng-init=vm.initQuoteFocus()><input type=text ng-model=vm.reference phenix-enter=vm.addReference(vm.reference) maxlength=13 ng-change=vm.formatReferenceInput() class=inputReference ng-attr-placeholder="{{\'COMMON_ADD_REF_PLACEHOLDER\' | translate}}" id=inputReference></form><div ng-click=vm.addReference(vm.reference) class=loupe role=button tabindex=0><i class=icon-icons_stepper_plus_partlist></i></div></div><div><label class=maxItems ng-class="{\'maxLimit\': vm.getPrItems().length >= 99}">{{vm.getPrItems().length}} / {{vm.maxItemsLimit}}</label></div></div></div><!-- BLOC MENTION --><div class="small-12 row"><div class="small-8 columns padding-left-0"><div class=blocMentionEstimation><div class="small-12 columns"><div><div class=containerMention><div class=firstLineMention><div class=mentionMention><label>{{\'COMMON_MENTION_LABEL\' | translate}}</label></div></div><div class=numCharEditMention><label>{{vm.quote.mentions.length > 0 ? vm.quote.mentions.length : 0}}/100</label></div><div class=secondLineMention><textarea ng-trim=false maxlength=100 ng-model-options="{debounce: 750}" class="mention changeMentionifDE" ng-model=vm.quote.mentions>{{vm.quote.mentions}}</textarea></div></div></div></div></div><div class=blocCategorieAndTaxe ng-if="vm.isQuoteCalculated && vm.taxesReturned"><div class=row><div class="small-12 columns"><label class=price_label>{{\'ESTIMATE_CATEGORY_SUBTOTAL\' |translate}}</label></div></div><div class="row grey"><div class="small-2 columns text-align-center"><label class=label_column>{{\'ESTIMATE_CATEGORY_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>{{\'ESTIMATE_CATEGORY_BRUTHT\' |translate}}</label></div><div class="small-3 columns"><label class=label_column>{{\'ESTIMATE_CATEGORY_NETHT\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>{{\'ESTIMATE_TOTAL_TAX\' |translate}}</label></div><div class="small-3 columns"><label class=label_column>{{\'ESTIMATE_TOTAL_TTC\' |translate}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.parts><div class="small-2 columns text-align-center"><label class=content>{{\'CAR_SEARCH_RESULT_FILTER_PR\' |translate}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.basis>{{vm.taxesReturned.parts.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.exclTaxes>{{vm.taxesReturned.parts.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns text-align-center"><label class=label_column ng-if=!vm.taxesReturned.parts.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.taxes>{{vm.taxesReturned.parts.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.total>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.total>{{vm.taxesReturned.parts.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.labourTimes><div class="small-2 columns text-align-center"><label class=content>{{\'CAR_SEARCH_RESULT_FILTER_TM\' |translate}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.basis>{{vm.taxesReturned.labourTimes.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.exclTaxes>{{vm.taxesReturned.labourTimes.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.taxes>{{vm.taxesReturned.labourTimes.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.total>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.total>{{vm.taxesReturned.labourTimes.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if="vm.taxesReturned.totalPaintAmount > 0"><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_PAINT_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column>-</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column>{{vm.taxesReturned.totalPaintAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.recycling><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_RECYCLE_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.basis>{{vm.taxesReturned.recycling.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.exclTaxes>{{vm.taxesReturned.recycling.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.taxes>{{vm.taxesReturned.recycling.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.total>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.total>{{vm.taxesReturned.recycling.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if="vm.taxesReturned.basisSuppliesAmount || vm.taxesReturned.totalSuppliesAmount"><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_SUPPLY_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.basisSuppliesAmount>-</label> <label class=label_column ng-if=vm.taxesReturned.basisSuppliesAmount>{{vm.taxesReturned.basisSuppliesAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.totalSuppliesAmount>-</label> <label class=label_column ng-if=vm.taxesReturned.totalSuppliesAmount>{{vm.taxesReturned.totalSuppliesAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div></div><div class="blocCategorieAndTaxe taxeWidth" ng-if="(estimCtrl.alreadyCalculate || estimCtrl.esTimateStatus===3) && estimCtrl.estimationFromCache.detailByTax && estimCtrl.estimationFromCache.detailByTax.length > 0"><div class=row><div class="small-12 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_BY_CT_LABEL\' |translate}}</label></div></div><div class="row grey"><div class="small-4 columns"><label class="label_column text-left">{{\'ESTIMATE_CODE_TAX_LABEL\' |translate}}</label></div><div class="small-3 columns"><label class="label_column text-left">{{\'COMMON_RATE\' |translate}}</label></div><div class="small-5 columns end"><label class="label_column text-left">{{\'ESTIMATE_TOTAL_TAX\' |translate}}</label></div></div><div class="row line_bottom" ng-if=estimCtrl.estimationFromCache.detailByTax ng-repeat="detail in estimCtrl.estimationFromCache.detailByTax | orderBy:\'code\'"><div class="small-4 columns"><label class="content text-left">{{detail.code}}</label></div><div class="small-3 columns"><label class="content text-left" ng-if=!detail.taxes>-</label> <label class="content text-left" ng-if=detail.taxes>{{detail.taxes | numberPhenix}} %</label></div><div class="small-5 columns end"><label class="content text-left" ng-if=detail.total>{{detail.total | numberPhenix}}</label></div></div></div></div><div class="small-4 columns padding-right-0"><div class="small-12 columns padding-left-0 padding-right-0 customer-group-container"><div class=customer-group-title><span>{{\'CHANGE_CUSTOMER_GROUP\' | translate}}</span></div><select ng-change=vm.onChangeCustomerGroup() ng-model=vm.quote.userScale style="margin: 0"><option value="" selected=selected></option><option ng-repeat="customerGroup in vm.customersGroup" ng-value=customerGroup.label>{{customerGroup.label}}</option></select></div><div class=blocCalculTotalLoginEstimation ng-if="vm.isQuoteCalculated && vm.taxesReturned"><div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_BRUTHT\' |translate}}</label></div><div class="small-4 columns"><label class=price_label>{{vm.taxesReturned.global.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_NETHT\' |translate}}</label></div><div class="small-4 columns"><label class=price_label>{{vm.taxesReturned.global.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-8 columns"><label class=price_label>{{\'ESTIMATE_TOTAL_TAXES\' |translate}}</label></div><div class="small-4 columns"><label class=price_label>{{vm.taxesReturned.global.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-8 columns"><label class=price_label_gras>{{\'ESTIMATE_TOTAL_TTC\' |translate}}</label></div><div class="small-4 columns"><label class=price_label_gras>{{vm.taxesReturned.global.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div ng-if=vm.unknowPartsNotCalculated class="small-12 columns unknowPartMsg"><i class="fa fa-exclamation-triangle"></i> {{\'WARNING_CALCULATED\' | translate}}</div></div></div><div class="small-12 columns padding-left-0 padding-right-0" ng-if=!vm.isQuoteCalculated><div class=blocCalculEstimate><div class=calculQuoteButton><button type=button ng-click="!vm.isCalculating && vm.onCalculQuote(1)" class=buttonWithIcon ng-class="{\'disabled\': vm.isCalculating, \'disabled-button-text\': vm.isCalculating}"><div class=iconDiv><i class=icon-icons_calc_estimation></i></div><div class=btnText>{{\'BUTTON_ESTIMATE_CALCULATE\'| translate}}</div></button></div></div></div><div class=row><div class="small-12 row"><div class="small-6 columns padding-left-0" ng-hide=vm.contextCarBrandCheck><div ng-class=vm.getCreatePartRequisitionFromQuoteClass() ng-click=vm.putQuoteItemsToPartRequisition()><div class=icon><i class=icon-icons_bonDeService_estimation></i></div><div class=separator></div><div class=text><div class=verserBonServiceTexteEstimation>{{\'COMMON_PARTLIST_BUTTON\' |translate | uppercase }}</div></div></div></div><div class="small-6 columns padding-right-0"><div class=blocLoginEstimation ng-if=vm.dmsLoginRequired><div class=identifiantLoginEstimationContainer><input type=text id=identifiantLoginEstimation ng-change=vm.onChangeUsername(vm.dmsLoginContainer.username) ng-model=vm.dmsLoginContainer.username placeholder="{{\'COMMON_IDENT_PLACEHOLDER\' |translate}}"> <i class=icon-icons_people_passant_partlist></i></div><div class=identifiantPasswordEstimationContainer><input type=password id=identifiantPasswordEstimation ng-change=vm.onChangePassword(vm.dmsLoginContainer.password) ng-model=vm.dmsLoginContainer.password placeholder="{{\'COMMON_PASSWD_PLACEHOLDER\' |translate}}"> <i class=icon-icons_password_estimation></i></div></div><div class=validerEstimation ng-class="{\'disabled\': vm.isValidatingQuote, \'disabled-button-text\': vm.isValidatingQuote}" ng-click="!vm.isValidatingQuote && vm.onValidateQuote()"><div class=icon><i class=icon-icons_validate_estimation></i></div><div class=separator></div><div class=text><div class=validerTexteEstimation>{{\'MODAL_OK_BUTTON\' |translate | uppercase }}</div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/dms/quote/validate/validatedQuote.html','<div class=containerView id=createPartRequisition ng-if=vm.isLoading><!--BLOC HEADER --><div class="row headerPartList"><div ng-if=vm.authorizeToBack class="small-1 columns numPartList"><div class=backPartList ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-5 columns"><label class=labelNumPartList><span>{{\'COMMON_ESTIMATE_ID\' |translate}} {{vm.quote.number}}</span> <span ng-if=vm.quote.dmsEstimateId>/ {{vm.quote.dmsEstimateId}}</span></label> <label class="labelValidateByPartList font-size-20">{{\'ESTIMATE_VALIDATED_DATE\' |translate}} {{vm.quote.validationDateTime | localTimeFilter }} {{\'ACTION_BY\' |translate}} {{vm.quote.validatorInfos}}</label></div><div class="small-5 columns listPartListAction"><div class=clickable><md-menu><div class=clickable ng-click=$mdMenu.open()><i class=icon-icons_print_partlist></i></div><md-menu-content id=menuContent width=2><md-menu-item class=custom-label ng-click=vm.printQuote(false,false)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_KO\' |translate}}</span></md-menu-item><md-menu-item class=custom-label ng-click=vm.printQuote(true,false)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_OK\' |translate}}</span></md-menu-item></md-menu-content></md-menu><label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div class=clickable><md-menu><div class=clickable ng-click=$mdMenu.open()><i class="fa fa-download"></i></div><md-menu-content id=menuContent width=2><md-menu-item class=custom-label ng-click=vm.printQuote(false,true)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_KO\' |translate}}</span></md-menu-item><md-menu-item class=custom-label ng-click=vm.printQuote(true,true)><span>{{\'BUTTON_ESTIMATE_PRINT_REF_OK\' |translate}}</span></md-menu-item></md-menu-content></md-menu><label>{{\'BUTTON_ESTIMATE_DOWNLOAD\' |translate}}</label></div><div ng-click=vm.closeQuote() class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><!--BLOC CLIENT --><dms-customer class=headerClient view=consultation current-customer=vm.currentCustomer></dms-customer><!--BLOC COMMENT --><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.quote.description.length || 0}}</span> <span>/100</span></div><div class="comment textarea inputCommentItalic" name=comment rows=2 cols=20 maxlength=100>{{vm.quote.description}}</div></div><div ng-if=vm.quote.userScale class=price_label>{{\'ADMIN_FAMILY_CLIENT\' | translate}} : {{vm.quote.userScale}}</div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic" style="background-color: #F1F2F3; border: none;min-height: 0px !important;">{{\'RGPD_MESSAGE\' |translate}}</div></div><!-- BLOC VEHICLE --><div class=blocVehiculePartList ng-if="vm.quote.items.length > 0"><div class=row ng-if=vm.vehicle><div class="small-12 columns blocVehiculeBandeauValidate"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader><label class=designationVehiculeBlocContext><span ng-bind-html=vm.bannerData></span></label> <label class=vinImatVehiculeBlocContext><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span></label><div ng-if="vm.isWorkshop && vm.quote.mileAge" class=milleAgeContainer><i class=icon-icons_kilometer_quote></i> <span>{{vm.quote.mileAge}}</span></div><div ng-if="vm.isWorkshop && vm.quote.orderNumber" class=orderNumberContainer><i class=icon-icons_repair></i> <span>{{vm.quote.orderNumber}}</span></div></div></div></div></div><div id=validatedQuote class=row><div class=row ng-if=!vm.quote.items><div class="small-12 columns blocVehiculeContenuQuoteEmpty"><label>{{\'ESTIMATE_EMPTY\' | translate | uppercase }}</label></div></div><div class=row ng-if="vm.quote.items || vm.quote.inter.length > 0"><!-- Interventions / Operation --><div ng-if="vm.quote.inter.length > 0"><div class=headerPRorTM><label class=label_pr>{{\'PARTLIST_TABLE_TITLE_SPLIT\' | translate | uppercase}}</label></div><div class=row ng-repeat="inter in vm.quote.inter"><label class=headerTitleInterventions style="padding-left: 10px;">{{inter.designation}}</label><div ng-if="inter.PR.length > 0"><label class=headerTitleInterventions style="padding-left: 10px;">{{\'HEADER_PR\' | translate | uppercase}}</label><div class="row blocVehiculeContenuPartListWithPR"><div class="small-12 row headerTabListPRorTM"><div class="small-1 columns ref_div_width"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortPRBy(\'reference\')"></i></div><div class="small-4 columns libelle_div_width"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns taxCode_div_width taxCode_div_empty"><label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns pub_ht_div_width"><label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><!-- <div class="small-2 columns pub_ht_div_width">\n                        <label>{{\'COMMON_COLUMN_PUNETHT_TITLE\' | translate | uppercase}}</label>\n                    </div> --><div class="small-1 columns stock_div_width"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if=vm.showDiscountRateColumn class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns text-to-right"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="small-12 row blocVehiculeContenuPartListWithPR"><div class="small-12 row contentTabListPRorTM" ng-repeat="item in inter.PR | filter:{ type: \'PR\' } | orderBy:vm.propertyNamePR:vm.reversePR track by $index" ng-if="item.quantity != 0"><div class="small-12 row"><div class="small-1 columns ref_div_width" ng-click=vm.goToProduct(item)><label class="caractere_label white-space">{{item.reference | filterFormatRef}}&nbsp;</label></div><div class="small-4 columns libelle_div_width break-all-word" ng-click=vm.goToProduct(item)><label ng-if=item.designation class=caractere_label>{{item.designation}}&nbsp;</label> <label ng-if=!item.designation class=caractere_label>{{ \'COMMON_NUMBER_EMPTY\' | translate }}&nbsp;</label></div><div class="small-1 columns taxCode_div_width taxCode_div_empty"><label class=caractere_label ng-if=item.codeTaxe>{{item.codeTaxe}}</label> <label class=caractere_label ng-if=!item.codeTaxe>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</label></div><div class="small-2 columns pub_ht_div_width nonClickable"><div><label class=caractere_label ng-if=item.price style="color: #222;">{{ item.price | number: 2 }} {{vm.getCurrencyForItem(item)}}</label><div class=center_label ng-if=!item.price>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div><!--  <div class="small-2 columns pub_ht_div_width">\n                            <label ng-if="item.priceInclTaxes" class="caractere_label">{{item.priceInclTaxes | number: 2}}\n                            </label>\n                            <div class="center_label" ng-if="!item.priceInclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div> --><div class="small-1 columns stock_div_width"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div><div ng-if=vm.showDiscountRateColumn class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate class=caractere_label>{{ item.discountRate | number: 2 }}%</label><div class=center_label ng-if=!item.discountRate>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div><div class="small-1 columns"><label ng-if=item.exclTaxes class="text-to-right caractere_label">{{item.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}</label><div class=text-to-right ng-if=!item.exclTaxes><span ng-if=item.codeTaxe>{{\'COMMON_NUMBER_EMPTY\' | translate}}</span> <span ng-if=!item.codeTaxe><i class="fa fa-exclamation-triangle" style="color: red"></i></span></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n                    bloc new PR returned by dms function estimate\n\n                /////////////////////////////////////////////////////////--><!--\n                <div class="small-12 row contentTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}" ng-init="prIndex=$index"\n                    ng-repeat="item in vm.itemsReturned.PR | orderBy:vm.propertyNamePR:vm.reversePR">\n\n                    <div class="small-12 row">\n                        <div class="small-1 columns ref_div_width" ng-click="vm.goToProduct(item)">\n                            <label class="caractere_label white-space">{{item.reference | filterFormatRef}}&nbsp;</label>\n                        </div>\n                        <div class="small-2 columns libelle_div_width break-all-word" ng-click="vm.goToProduct(item)">\n                            <label class="caractere_label">{{item.designation}}&nbsp;</label>\n                            <label ng-if="!item.designation" class="caractere_label">{{\'COMMON_NUMBER_EMPTY\' | translate}}&nbsp;</label>\n                        </div>\n                        <div class="small-1 columns taxCode_div_width taxCode_div_empty">\n                            <label class="caractere_label" ng-if="item.cort">{{item.cort}}</label>\n                        </div>\n                        <div class="small-2 columns pub_ht_div_width nonClickable">\n                            <label class="caractere_label" ng-if="item.priceExclTaxes">{{item.priceExclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}</label>\n                            <label class="caractere_label" ng-if="!item.priceExclTaxes && item.priceHT">{{item.priceHT | number: 2}} {{vm.getCurrencyForItem()}}</label>\n                            <div class="center_label" ng-if="!item.priceExclTaxes  && !item.priceHT">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div>\n\n                        <div class="small-1 columns stock_div_width ">\n                            {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                        </div>\n                        <div ng-if="vm.showDiscountRateColumn" class="small-1 columns remise_div_width">\n                            <label class="center_label" ng-if="item.discountRate" class="caractere_label">{{item.discountRate | number: 2}}%\n                            </label>\n                            <div class="center_label" ng-if="!item.discountRate">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div>\n                        <div class="small-1 columns">\n                            <label ng-if="item.amount.exclTaxes" class="text-to-right caractere_label">{{item.amount.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}\n                            </label>\n                            <div class="text-to-right center_label" ng-if="!item.amount.exclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div>\n                    </div>\n                </div> --></div></div><div ng-if="inter.TM.length > 0"><label class=headerTitleInterventions style="padding-left: 10px;">{{\'HEADER_TM\' | translate | uppercase}}</label><div class="row blocVehiculeContenuPartListWithTM"><div class="row headerTabListPRorTM"><div class="small-1 columns ref_div_width"><label>{{\'CODE_TM\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortTMBy(\'reference\')"></i></div><div class="small-4 columns libelle_div_width"><label>{{\'COMMON_COLUMN_LABEL_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns temps_div_width"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns taux_horaire_div_width"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><!--<div class="small-2 columns taux_net_div_width">\n                    <label>{{\'COMMON_COLUMN_RATE_NETHT_TITLE\' | translate | uppercase}}</label>\n                </div> --><div class="small-1 columns stock_div_width"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if=vm.showDiscountRateTMColumn class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns text-to-right"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithTM"><div class="row contentTabListPRorTM" ng-repeat="item in inter.TM | filter:{ type: \'TM\' } | orderBy:vm.propertyNameTM:vm.reverseTM"><div class="small-1 columns ref_div_width"><label class=caractere_label>{{item.opecod | trim}}&nbsp;</label></div><div class="small-4 columns libelle_div_width break-all-word"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div ng-if=!item.isNotCodified class="small-1 columns temps_div_width"><label class=caractere_label>{{vm.getTMDuration(item)}}&nbsp;</label></div><div class="small-2 columns taux_horaire_div_width"><div><label ng-if="item.hourlyRate && item.exclTaxes" class=caractere_label>{{item.hourlyRate}} {{vm.getCurrencyForItem()}}</label> <label ng-if="item.exclTaxes && !item.hourlyRate" class=caractere_label>{{item.exclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="(!item.hourlyRate && !item.exclTaxes) || (item.hourlyRate && !item.exclTaxes)" class=caractere_label>-</label></div></div><!--    <div class="small-2 columns taux_net_div_width">\n                    <label class="caractere_label" ng-if="item.priceInclTaxes">{{item.priceInclTaxes | numberPhenix}}&nbsp;</label>\n                    <div class="center_label" ng-if="!item.priceInclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                </div> --><div class="small-1 columns stock_div_width"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div><div ng-if=vm.showDiscountRateTMColumn class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns"><label class="text-to-right caractere_label" ng-if=item.exclTaxes>{{ item.exclTaxes | number: 2 }} {{vm.getCurrencyForItem()}}</label><div class="text-to-right center_label" ng-if=!item.exclTaxes>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</div></div></div><!-- //////////////////////////////////////////////////////\n\n            bloc new TM returned by dms function estimate\n                /////////////////////////////////////////////////////////--><!-- <div class="row contentTabListPRorTM" ng-repeat="item in vm.itemsReturned.TM | orderBy:vm.propertyNameTM:vm.reverseTM">\n                <div class="small-1 columns ref_div_width">\n                    <label class="caractere_label">{{item.code}}&nbsp;</label>\n                </div>\n                <div class="small-2 columns libelle_div_width">\n                    {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                </div>\n\n                <div ng-if="!item.isNotCodified" class="small-1 columns temps_div_width">\n                    {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                </div>\n\n                <div class="small-2 columns taux_horaire_div_width">\n                    {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                </div>\n\n                <div class="small-1 columns stock_div_width">\n                    {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                </div>\n                <div ng-if="vm.showDiscountRateTMColumn" class="small-1 columns remise_div_width">\n                    <div class="center_label" ng-if="!item.discountRate">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                </div>\n                <div class="small-1 columns">\n                    <label class="text-to-right caractere_label" ng-if="item.amount.exclTaxes">{{item.amount.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}\n                    </label>\n                    <div class="text-to-right center_label" ng-if="!item.amount.exclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                </div>\n            </div> --></div></div></div><div class="display-flex justify-content-flex-end"><div><label class=taxes-bold-style>{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div><label ng-if=vm.interItemsTax class=taxes-bold-style>{{ vm.interItemsTax | number: 2 }} {{vm.getCurrencyForItem()}}</label> <label ng-if=!vm.interItemsTax class=taxes-bold-style>{{ \'COMMON_NUMBER_EMPTY\' | translate }}</label></div></div></div></div><div class=row ng-if=vm.quote.items><!-- BLOC PR --><div ng-if=vm.isShowPR><div class=headerPRorTM><label>{{\'HEADER_PR\' | translate | uppercase}}</label></div><div class="row blocVehiculeContenuPartListWithPR"><div class="small-12 row headerTabListPRorTM"><div class="small-1 columns ref_div_width"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortPRBy(\'reference\')"></i></div><div class="small-4 columns libelle_div_width"><label>{{\'COMMON_DESIGNATION\' | translate | uppercase}}</label></div><div class="small-1 columns taxCode_div_width taxCode_div_empty"><label>{{\'COMMON_COLUMN_CT_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns pub_ht_div_width"><label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><!-- <div class="small-2 columns pub_ht_div_width">\n                            <label>{{\'COMMON_COLUMN_PUNETHT_TITLE\' | translate | uppercase}}</label>\n                        </div> --><div class="small-1 columns stock_div_width"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if=vm.showDiscountRateColumn class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns text-to-right"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="small-12 row blocVehiculeContenuPartListWithPR"><div class="small-12 row contentTabListPRorTM" ng-repeat="item in vm.quote.items | filter:{ type: \'PR\' } | orderBy:vm.propertyNamePR:vm.reversePR track by $index"><div class="small-12 row"><div class="small-1 columns ref_div_width" ng-click=vm.goToProduct(item)><label class="caractere_label white-space">{{item.reference | filterFormatRef}}&nbsp;</label></div><div class="small-4 columns libelle_div_width break-all-word" ng-click=vm.goToProduct(item)><label ng-if=item.designation class=caractere_label>{{item.designation}}&nbsp;</label> <label ng-if=!item.designation class=caractere_label>{{\'COMMON_NUMBER_EMPTY\' | translate}}&nbsp;</label></div><div class="small-1 columns taxCode_div_width taxCode_div_empty"><label class=caractere_label ng-if=item.codeTaxe>{{item.codeTaxe}}</label> <label class=caractere_label ng-if=!item.codeTaxe>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div><div class="small-2 columns pub_ht_div_width nonClickable"><div><label class=caractere_label ng-if=item.price style="color: #222;">{{item.price | number: 2}} {{vm.getCurrencyForItem(item)}}</label><div class=center_label ng-if=!item.price>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div></div><!--  <div class="small-2 columns pub_ht_div_width">\n                                <label ng-if="item.priceInclTaxes" class="caractere_label">{{item.priceInclTaxes | number: 2}}\n                                </label>\n                                <div class="center_label" ng-if="!item.priceInclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                            </div> --><div class="small-1 columns stock_div_width"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div><div ng-if=vm.showDiscountRateColumn class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate class=caractere_label>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns"><label ng-if=item.exclTaxes class="text-to-right caractere_label">{{item.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}</label><div class=text-to-right ng-if=!item.exclTaxes><span ng-if=item.codeTaxe>{{\'COMMON_NUMBER_EMPTY\' | translate}}</span> <span ng-if=!item.codeTaxe><i class="fa fa-exclamation-triangle" style="color: red"></i></span></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n                        bloc new PR returned by dms function estimate\n\n                    /////////////////////////////////////////////////////////--><!--\n                    <div class="small-12 row contentTabListPRorTM" ng-class="{\'estmationValide\':estimCtrl.esTimateStatus == 3}" ng-init="prIndex=$index"\n                        ng-repeat="item in vm.itemsReturned.PR | orderBy:vm.propertyNamePR:vm.reversePR">\n\n                        <div class="small-12 row">\n                            <div class="small-1 columns ref_div_width" ng-click="vm.goToProduct(item)">\n                                <label class="caractere_label white-space">{{item.reference | filterFormatRef}}&nbsp;</label>\n                            </div>\n                            <div class="small-2 columns libelle_div_width break-all-word" ng-click="vm.goToProduct(item)">\n                                <label class="caractere_label">{{item.designation}}&nbsp;</label>\n                                <label ng-if="!item.designation" class="caractere_label">{{\'COMMON_NUMBER_EMPTY\' | translate}}&nbsp;</label>\n                            </div>\n                            <div class="small-1 columns taxCode_div_width taxCode_div_empty">\n                                <label class="caractere_label" ng-if="item.cort">{{item.cort}}</label>\n                            </div>\n                            <div class="small-2 columns pub_ht_div_width nonClickable">\n                                <label class="caractere_label" ng-if="item.priceExclTaxes">{{item.priceExclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}</label>\n                                <label class="caractere_label" ng-if="!item.priceExclTaxes && item.priceHT">{{item.priceHT | number: 2}} {{vm.getCurrencyForItem()}}</label>\n                                <div class="center_label" ng-if="!item.priceExclTaxes  && !item.priceHT">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                            </div>\n\n                            <div class="small-1 columns stock_div_width ">\n                                {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                            </div>\n                            <div ng-if="vm.showDiscountRateColumn" class="small-1 columns remise_div_width">\n                                <label class="center_label" ng-if="item.discountRate" class="caractere_label">{{item.discountRate | number: 2}}%\n                                </label>\n                                <div class="center_label" ng-if="!item.discountRate">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                            </div>\n                            <div class="small-1 columns">\n                                <label ng-if="item.amount.exclTaxes" class="text-to-right caractere_label">{{item.amount.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}\n                                </label>\n                                <div class="text-to-right center_label" ng-if="!item.amount.exclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                            </div>\n                        </div>\n                    </div> --></div><div class="display-flex justify-content-flex-end"><div><label class=taxes-bold-style>{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div><label ng-if="vm.quote.inter.length > 0 && vm.taxesReturnedPrTm && vm.taxesReturnedPrTm.pr" class=taxes-bold-style>{{vm.taxesReturnedPrTm.pr | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="vm.quote.inter.length == 0 && vm.taxesReturned.parts.exclTaxes" class=taxes-bold-style>{{vm.taxesReturned.parts.exclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="!vm.taxesReturnedPrTm.pr && !vm.taxesReturned.parts.exclTaxes" class=taxes-bold-style>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div></div></div><!-- BLOC TM --><div ng-if=vm.isShowTM><div class=headerPRorTM><label>{{\'HEADER_TM\' | translate | uppercase}}</label></div><div class="row blocVehiculeContenuPartListWithTM"><div class="row headerTabListPRorTM"><div class="small-1 columns ref_div_width"><label>{{\'CODE_TM\' | translate | uppercase}}</label> <i class=icon-icons_order_quote ng-click="vm.sortTMBy(\'reference\')"></i></div><div class="small-4 columns libelle_div_width"><label>{{\'COMMON_COLUMN_LABEL_TITLE\' | translate | uppercase}}</label></div><div class="small-1 columns temps_div_width"><label>{{\'COMMON_COLUMN_TIME_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns taux_horaire_div_width"><label>{{\'COMMON_COLUMN_HRATE_TITLE\' | translate | uppercase}} / {{\'COMMON_COLUMN_PUBHT_TITLE\' | translate | uppercase}}</label></div><!--<div class="small-2 columns taux_net_div_width">\n                            <label>{{\'COMMON_COLUMN_RATE_NETHT_TITLE\' | translate | uppercase}}</label>\n                        </div> --><div class="small-1 columns stock_div_width"><label class=center_label>{{\'COMMON_COLUMN_QTE_TITLE\' | translate | uppercase}}</label></div><div ng-if=vm.showDiscountRateTMColumn class="small-1 columns remise_div_width"><label class=center_label>{{\'COMMON_COLUMN_REMISE_TITLE\' | translate | uppercase}}</label></div><div class="small-2 columns text-to-right"><label>{{\'COMMON_COLUMN_MNT_NETHT_TITLE\' | translate | uppercase}}</label></div></div></div><div class="row blocVehiculeContenuPartListWithTM"><div class="row contentTabListPRorTM" ng-repeat="item in vm.quote.items | filter:{ type: \'TM\' } | orderBy:vm.propertyNameTM:vm.reverseTM"><div class="small-1 columns ref_div_width"><label class=caractere_label>{{item.opecod | trim}}&nbsp;</label></div><div class="small-4 columns libelle_div_width break-all-word"><label class=caractere_label>{{item.designation}}&nbsp;</label></div><div ng-if=!item.isNotCodified class="small-1 columns temps_div_width"><label class=caractere_label>{{vm.getTMDuration(item)}}&nbsp;</label></div><div class="small-2 columns taux_horaire_div_width"><div><label ng-if="item.hourlyRate && item.exclTaxes" class=caractere_label>{{item.hourlyRate}} {{vm.getCurrencyForItem()}}</label> <label ng-if="item.exclTaxes && !item.hourlyRate" class=caractere_label>{{item.exclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="(!item.hourlyRate && !item.exclTaxes) || (item.hourlyRate && !item.exclTaxes)" class=caractere_label>-</label></div></div><!--    <div class="small-2 columns taux_net_div_width">\n                            <label class="caractere_label" ng-if="item.priceInclTaxes">{{item.priceInclTaxes | numberPhenix}}&nbsp;</label>\n                            <div class="center_label" ng-if="!item.priceInclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div> --><div class="small-1 columns stock_div_width"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div><div ng-if=vm.showDiscountRateTMColumn class="small-1 columns remise_div_width"><label class=center_label ng-if=item.discountRate>{{item.discountRate | number: 2}}%</label><div class=center_label ng-if=!item.discountRate>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div><div class="small-1 columns"><label class="text-to-right caractere_label" ng-if=item.exclTaxes>{{item.exclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label><div class="text-to-right center_label" ng-if=!item.exclTaxes>{{\'COMMON_NUMBER_EMPTY\' | translate}}</div></div></div><!-- //////////////////////////////////////////////////////\n\n                    bloc new TM returned by dms function estimate\n                        /////////////////////////////////////////////////////////--><!-- <div class="row contentTabListPRorTM" ng-repeat="item in vm.itemsReturned.TM | orderBy:vm.propertyNameTM:vm.reverseTM">\n                        <div class="small-1 columns ref_div_width">\n                            <label class="caractere_label">{{item.code}}&nbsp;</label>\n                        </div>\n                        <div class="small-2 columns libelle_div_width">\n                            {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                        </div>\n\n                        <div ng-if="!item.isNotCodified" class="small-1 columns temps_div_width">\n                            {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                        </div>\n\n                        <div class="small-2 columns taux_horaire_div_width">\n                            {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                        </div>\n\n                        <div class="small-1 columns stock_div_width">\n                            {{\'COMMON_NUMBER_EMPTY\' | translate}}\n                        </div>\n                        <div ng-if="vm.showDiscountRateTMColumn" class="small-1 columns remise_div_width">\n                            <div class="center_label" ng-if="!item.discountRate">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div>\n                        <div class="small-1 columns">\n                            <label class="text-to-right caractere_label" ng-if="item.amount.exclTaxes">{{item.amount.exclTaxes | number: 2}} {{vm.getCurrencyForItem(item)}}\n                            </label>\n                            <div class="text-to-right center_label" ng-if="!item.amount.exclTaxes">{{\'COMMON_NUMBER_EMPTY\' | translate}}</div>\n                        </div>\n                    </div> --></div><div class=row><div class="display-flex justify-content-flex-end"><div><label class=taxes-bold-style>{{\'COMMON_TOTAL_HT\' | translate}}</label></div><div><label ng-if="vm.quote.inter.length > 0 && vm.taxesReturnedPrTm && vm.taxesReturnedPrTm.tm" class=taxes-bold-style>{{vm.taxesReturnedPrTm.tm | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="vm.quote.inter.length == 0 && vm.quote.tmSummary.exclTaxes" class=taxes-bold-style>{{vm.quote.tmSummary.exclTaxes | number: 2}} {{vm.getCurrencyForItem()}}</label> <label ng-if="!vm.taxesReturnedPrTm.tm && !vm.quote.tmSummary.exclTaxes" class=taxes-bold-style>{{\'COMMON_NUMBER_EMPTY\' | translate}}</label></div></div></div></div></div></div><div class="small-12 row"><div class="small-8 columns padding-left-0"><!-- //////////////////////////////////////////////////////\n                    bloc MENTION\n            /////////////////////////////////////////////////////////--><div class=blocMentionEstimation ng-if=vm.quote.mentions><div class="small-12 columns"><div class=containerMention><div class=firstLineMention><div class=mentionMention><label>{{\'COMMON_MENTION_LABEL\' | translate}}</label></div></div><div class=secondLineMention><label class=mention>{{vm.quote.mentions}}</label></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n                                         bloc subTotal by cat\n                /////////////////////////////////////////////////////////--><div class=blocCategorieAndTaxe ng-if=vm.taxesReturned><div class=row><div class="small-12 columns"><label class=price_label>{{\'ESTIMATE_CATEGORY_SUBTOTAL\' |translate}}</label></div></div><div class="row grey"><div class="small-2 columns text-align-center"><label class=label_column>{{\'ESTIMATE_CATEGORY_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>{{\'ESTIMATE_CATEGORY_BRUTHT\' |translate}}</label></div><div class="small-3 columns"><label class=label_column>{{\'ESTIMATE_CATEGORY_NETHT\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>{{\'ESTIMATE_TOTAL_TAX\' |translate}}</label></div><div class="small-3 columns"><label class=label_column>{{\'ESTIMATE_TOTAL_TTC\' |translate}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.parts><div class="small-2 columns text-align-center"><label class=content>{{\'CAR_SEARCH_RESULT_FILTER_PR\' |translate}}</label></div><!-- PR --><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.basis>{{vm.taxesReturned.parts.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.exclTaxes>{{vm.taxesReturned.parts.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.taxes>{{vm.taxesReturned.parts.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.parts.total>-</label> <label class=label_column ng-if=vm.taxesReturned.parts.total>{{vm.taxesReturned.parts.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.labourTimes><div class="small-2 columns text-align-center"><label class=content>{{\'CAR_SEARCH_RESULT_FILTER_TM\' |translate}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.basis>{{vm.taxesReturned.labourTimes.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.exclTaxes>{{vm.taxesReturned.labourTimes.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.taxes>{{vm.taxesReturned.labourTimes.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.labourTimes.total>-</label> <label class=label_column ng-if=vm.taxesReturned.labourTimes.total>{{vm.taxesReturned.labourTimes.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if="vm.taxesReturned.totalPaintAmount > 0"><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_PAINT_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column>-</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column>{{vm.taxesReturned.totalPaintAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if=vm.taxesReturned.recycling><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_RECYCLE_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.basis>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.basis>{{vm.taxesReturned.recycling.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.exclTaxes>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.exclTaxes>{{vm.taxesReturned.recycling.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.taxes>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.taxes>{{vm.taxesReturned.recycling.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.recycling.total>-</label> <label class=label_column ng-if=vm.taxesReturned.recycling.total>{{vm.taxesReturned.recycling.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class="row line_bottom" ng-if="vm.taxesReturned.basisSuppliesAmount || vm.taxesReturned.totalSuppliesAmount"><div class="small-2 columns text-align-center"><label class=content>{{\'ESTIMATE_MO_SUPPLY_LABEL\' |translate}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.basisSuppliesAmount>-</label> <label class=label_column ng-if=vm.taxesReturned.basisSuppliesAmount>{{vm.taxesReturned.basisSuppliesAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div class="small-2 columns"><label class=label_column>-</label></div><div class="small-3 columns"><label class=label_column ng-if=!vm.taxesReturned.totalSuppliesAmount>-</label> <label class=label_column ng-if=vm.taxesReturned.totalSuppliesAmount>{{vm.taxesReturned.totalSuppliesAmount | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div></div></div><!-- //////////////////////////////////////////////////////\n\n                                         BLOC RIGHT TOTAL\n                /////////////////////////////////////////////////////////--><div class="small-4 columns padding-right-0"><div class="blocCalculTotalLoginEstimation margin-bottom-10" ng-if=vm.taxesReturned><div><div class=row><div class="small-6 columns text-to-right"><label class=price_label>{{\'ESTIMATE_TOTAL_BRUTHT\' |translate}}</label></div><div class="small-6 columns text-to-right"><label class=price_label>{{vm.taxesReturned.global.basis | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-6 columns text-to-right"><label class=price_label>{{\'ESTIMATE_TOTAL_NETHT\' |translate}}</label></div><div class="small-6 columns text-to-right"><label class=price_label>{{vm.taxesReturned.global.exclTaxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-6 columns text-to-right"><label class=price_label>{{\'ESTIMATE_TOTAL_TAXES\' |translate}}</label></div><div class="small-6 columns text-to-right"><label class=price_label>{{vm.taxesReturned.global.taxes | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div></div><div class=row><div class="small-6 columns text-to-right"><label class=price_label_gras>{{\'ESTIMATE_TOTAL_TTC\' |translate}}</label></div><div class="small-6 columns text-to-right"><label class=price_label_gras>{{vm.taxesReturned.global.total | numberPhenix}} {{vm.getCurrencyForItem()}}</label></div><div ng-if=vm.quote.isUncalculatedParts class="small-12 columns unknowPartMsg"><i class="fa fa-exclamation-triangle"></i> {{\'WARNING_CALCULATED\' | translate}}</div></div></div></div><!--DELETE LATER IF STILL UNUSED (06/11)--><!-- //////////////////////////////////////////////////////\n\n                                        BLOC CLIENT FAMILY\n                /////////////////////////////////////////////////////////--><!-- <div class="row">\n                <div class="blocClientFamily ">\n                    <div class="headerClientBareme" ng-if="estimCtrl.esTimateStatus !== 3">\n                        <div class="text">{{\'ADMIN_FAMILY_CLIENT\'|translate}} :</div>\n                    </div>\n                </div>\n            </div> --><div class="small-12 row"><div class="small-6 columns small-offset-6 padding-right-0"><div ng-class=vm.getCreatePartRequisitionFromQuoteClass() ng-click=vm.putQuoteItemsToPartRequisition()><div class=icon><i class=icon-icons_bonDeService_estimation></i></div><div class=separator></div><div class=text><div class=verserBonServiceTexteEstimation>{{\'COMMON_PARTLIST_BUTTON\' |translate | uppercase }}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/dms/components/dms-customer/dms-customer-consult.template.html','<div class=row><!--=====================================\n        =       CONSULTATION MODE               =\n        ======================================--><!--div ng-if="vm.defaultMode == vm.dmsCustomerConstants.CONSULTATION_MODE" class="columns small-12 saisirClientPassantPartListFirst saisirClientPassantPartList" >\n            <div class="row" >\n                <div class="small-4">\n                    <div>\n                        <i class="icon-icons_people_passant_partlist"></i><label class="headerClientNameLabel">{{vm.currentCustomer.firstName | uppercase}} {{vm.currentCustomer.name | uppercase}} ({{vm.currentCustomer.accountNumber}})</label>\n                    </div>\n                </div>\n                <div class="small-2" ng-if="vm.currentCustomer.mainPhone">\n                    <div class="phone">\n                        <i class="icon-icons_phone_partlist"></i>{{vm.currentCustomer.mainPhone}}\n                    </div>\n                </div>\n                <div class="small-6" ng-if="vm.currentCustomer.email">\n                    <div class="mail">\n                        <i class="icon-icons_mail_partlist"></i>{{vm.currentCustomer.email | lowercase}}\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="small-12">\n                    <div class="clientPassantStreetNumberPartList">\n                        <i class="icon-icons_address_passant_partlist"></i>{{vm.currentCustomer.streetNumber | lowercase}} {{vm.currentCustomer.bisTer}} {{vm.currentCustomer.roadType}} {{vm.currentCustomer.streetName}}\n                        {{vm.currentCustomer.postCode}} {{vm.currentCustomer.city}}\n                    </div>\n                </div>\n            </div>\n\n        </div--><div class="row headerCustomer"><div class="small-12 saisirClientPassantPartListFirst saisirClientPassantPartList"><i class=icon-icons_people_partlist></i><div class=small-4><label class=headerClientNameLabel>{{vm.currentCustomer.firstName | uppercase}} {{vm.currentCustomer.name | uppercase}} ({{vm.currentCustomer.accountNumber}})</label></div><div class=small-2 ng-if=vm.currentCustomer.mainPhone><div class=phone><i class=icon-icons_phone_partlist></i>{{vm.currentCustomer.mainPhone}}</div></div><div class=small-3 ng-if=vm.currentCustomer.email><div class=mail><i class=icon-icons_mail_partlist></i>{{vm.currentCustomer.email | lowercase}}</div></div></div><div class=small-5><div ng-if="vm.currentCustomer.streetNumber || vm.currentCustomer.bisTer\n                            || vm.currentCustomer.streetName || vm.currentCustomer.postCode || vm.currentCustomer.city" class=clientPassantStreetNumberPartList><i class=icon-icons_address_passant_partlist></i> {{vm.currentCustomer.streetNumber | lowercase}} {{vm.currentCustomer.bisTer}} {{vm.currentCustomer.streetName}} {{vm.currentCustomer.postCode}} {{vm.currentCustomer.city}}</div></div></div></div>');
$templateCache.put('app/components/dms/components/dms-customer/dms-customer.template.html','<div class="row headerCustomer"><div class="small-7 columns" ng-if="vm.displayMode == vm.dmsCustomerConstants.SEARCH_MODE || vm.displayMode == vm.dmsCustomerConstants.EDIT_MODE || vm.displayMode == vm.dmsCustomerConstants.CONSULTATION_MODE"><!--=====================================\n        =       SEARCH MODE                     =\n        ======================================--><div ng-if="vm.displayMode == vm.dmsCustomerConstants.SEARCH_MODE"><div class="rechercheClientPartList row"><div class="small-3 margin-right-10"><md-input-container class="md-block md-input-has-value margin-top-O" flex-gt-sm=""><label class=fontStyle>{{\'CARSEARCH_LASTNAME_PLACEHOLDER\' | translate}}</label> <input id=lastNameInput type=text class=rechercheNomClientPartList ng-model=vm.currentCustomer.name phenix-enter=vm.onSearchCustomer() ng-focus="vm.switchState(\'accountNumber\')"></md-input-container></div><div class="small-3 margin-right-10"><md-input-container class="md-block md-input-has-value margin-top-O" flex-gt-sm=""><label class=fontStyle>{{\'CARSEARCH_FIRSTNAME_PLACEHOLDER\' | translate}}</label> <input type=text class=recherchePrenomClientPartList ng-model=vm.currentCustomer.firstName phenix-enter=vm.onSearchCustomer() ng-focus="vm.switchState(\'accountNumber\')"></md-input-container></div><div class=small-2><md-input-container class="md-block md-input-has-value margin-top-O" flex-gt-sm=""><label class=fontStyle>{{\'COMMON_NUMCLIENT_PLACEHOLDER\' | translate}}</label> <input id=accountNumberInput type=text class=rechercheNumCompteClientPartList ng-model=vm.currentCustomer.accountNumber phenix-enter=vm.onSearchCustomer() ng-focus="vm.switchState(\'name\')"></md-input-container></div></div><!--=====================================\n            =            SEARCH BUTTON              =\n            ======================================--><div class=row><div class="rechercheClientBoutonPartList clickable" ng-click=vm.onSearchCustomer()><i class=icon-icons_search_partlist></i> <label class=rechercheClientBoutonL1PartList>|</label> <label class=rechercheClientBoutonL2PartList>{{\'COMMON_SEARCH_CLIENT\' | translate | uppercase}}</label></div></div></div><!--=====================================\n        =       EDIT MODE                      =\n        ======================================--> <span ng-if="vm.displayMode == vm.dmsCustomerConstants.EDIT_MODE"><div class=carSearchTextMandatory>* {{\'COMMON_MANDATORY\' | translate}}</div><div class="small-12 saisirClientPassantPartListFirst saisirClientPassantPartList"><i class=icon-icons_people_passant_partlist></i><div class="small-4 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantNomPartList placeholder="{{\'CARSEARCH_LASTNAME_PLACEHOLDER\' | translate}}*" ng-model=vm.currentCustomer.name></div><div class="small-4 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantPrenomPartList placeholder="{{\'CARSEARCH_FIRSTNAME_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.firstName></div><div class="small-4 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantNumComptePartList placeholder="{{\'COMMON_NUMCLIENT_PLACEHOLDER\' | translate}}*" ng-model=vm.currentCustomer.accountNumber></div></div><div class="small-12 saisirClientPassantPartListSecond saisirClientPassantPartList"><i class=icon-icons_address_passant_partlist></i><div class="small-1 margin-right-10"><!-- <textarea class="clientPassantAdressePartList" placeholder="{{\'COMMON_ADDRESS_PLACEHOLDER\' | translate}}" ng-model="vm.currentCustomer.address"></textarea> --> <input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantStreetNumberPartList placeholder="{{\'CARSEARCH_STREETNUMBER_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.streetNumber></div><div class="small-1 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantBisTerPartList placeholder="{{\'CARSEARCH_BISTER_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.bisTer></div><div class="small-2 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantBisTerPartList placeholder="{{\'CARSEARCH_ROADTYPE_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.roadType></div><div class="small-3 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantStreetNamePartList placeholder="{{\'CARSEARCH_STREETNAME_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.streetName></div><div class="small-2 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantPostCodePartList placeholder="{{\'CARSEARCH_POSTCODE_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.postCode></div><div class="small-2 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantCityPartList placeholder="{{\'CARSEARCH_CITY_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.city></div></div><div class="small-12 saisirClientPassantPartListThird saisirClientPassantPartList"><i class=icon-icons_phone_passant_partlist></i><div class="small-3 margin-right-10"><input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantTelPartList placeholder="{{\'COMMON_TEL_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.mainPhone></div><div class="small-9 margin-right-10" style=display:flex><i class=icon-icons_mail_passant_partlist></i> <input type=text ng-change=vm.onUpdatedCustomer() class=clientPassantMailPartList placeholder="{{\'COMMON_EMAIL_PLACEHOLDER\' | translate}}" ng-model=vm.currentCustomer.email></div></div></span></div></div><!--=====================================\n=           RESULT OF SEARCH        =\n======================================--><div ng-if="vm.displayMode == vm.dmsCustomerConstants.SEARCH_MODE && vm.isSearchResult"><div class=resultRechercheClientPartList><div class=result><label class=numResultRechercheClientPartList>{{vm.numOfClientResult}} {{\'COMMON_RESULT_LABEL\' | translate}}</label><div class="row headerTabResultClient"><div class="small-3 columns"><label>{{\'CARSEARCH_LASTNAME_PLACEHOLDER\' | translate}}</label></div><div class="small-4 columns"><label>{{\'CARSEARCH_FIRSTNAME_PLACEHOLDER\' | translate}}</label></div><div class="small-5 columns"><label>{{\'COMMON_NUMCLIENT_PLACEHOLDER\' | translate}}</label></div></div><div class="row contentTabResultClient" ng-repeat="customer in vm.customersList" ng-click=vm.onSelectCustomer(customer)><div class="small-3 columns"><label>{{customer.name}}</label></div><div class="small-4 columns"><label>{{customer.firstName}}</label></div><div class="small-5 columns"><label>{{customer.accountNumber}} <i class=icon-icons_next_partlist></i></label></div></div><div class=pagination ng-if=vm.showNextPrev><i class=icon-icons_arrow_left_partlist ng-click=vm.onPrevClientSearch() ng-show="vm.currentClientSearchPage > 1"></i> <label>Page {{vm.currentClientSearchPage}} sur {{vm.maximumPageNext}}</label> <i class=icon-icons_arrow_right_partlist ng-click=vm.onNextClientSearch() ng-show="vm.currentClientSearchPage < vm.maximumPageNext"></i></div></div></div></div><div class="small-2 changeOrPassantPartList" ng-if="(vm.displayMode == vm.dmsCustomerConstants.EDIT_MODE || vm.displayMode == vm.dmsCustomerConstants.SEARCH_MODE)"><label class=changerClientPartList ng-if="vm.displayMode == vm.dmsCustomerConstants.EDIT_MODE" ng-click=vm.onChangeCustomer()>&#62; {{\'COMMON_CHANGE_CLIENT\' | translate}}</label> <label class=clientPassantPartList ng-if="vm.displayMode == vm.dmsCustomerConstants.SEARCH_MODE" ng-click=vm.onNewCustomer()>&#62; {{\'COMMON_CLIENT_DEFAULT\' | translate}}</label></div>');
$templateCache.put('app/components/favourites/PR/components/add-favorite-pr.template.html','<md-dialog id=dialogBoxSize><div class=modalPhenix id=dialogTitle><div class=row><div class="small-6 column title">{{\'FAV_MODAL_ADD_REF_CREATE_BUTTON\' | translate}}</div><div class="small-6 column closeButton" ng-click=vm.closeModal()>{{\'MODAL_CLOSE\' |translate}} X</div></div><form name=PRForm><!-- CATEGORY AND SUB CATEGORY --><div class=row><div class="small-6 column"><!-- category --><md-input-container class=categoryBlock><label>{{\'FAV_MODAL_ADD_TM_CHOOSE_CATEG\' | translate}}</label><md-select name=category ng-model=vm.form.category required ng-change=vm.onChangeCategory(vm.form.category)><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_CATEG\' | translate}}</md-option><md-option value={{category.categoryKey}} ng-repeat="(index,category) in vm.categories" ng-selected="index == vm.changedCategoryIndex">{{category.categoryName | translate}}</md-option></md-select></md-input-container></div><div class="small-6 column"><!-- subcat --><md-input-container class=subCategoryBlock><label>{{\'FAV_MODAL_ADD_TM_SUBCATEGORY\' | translate}}</label><md-select id=subcategory name=subCategory ng-model=vm.form.subCategory ng-change=vm.onChangeSubcategory(vm.form.subCategory) ng-disabled=vm.isSubCategoriesDisabled><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_SUBCATEG\' | translate}}</md-option><md-option ng-if="vm.subCategories.length > 0" value={{subcategory.subcategoryKey}} ng-repeat="(idx,subcategory) in vm.subCategories" ng-selected="idx == vm.changedSubCategoryIndex">{{subcategory.subCategoryName | translate}}</md-option></md-select></md-input-container></div></div><div class=row><div class="small-5 column" ng-if=vm.isReferenceVisible><div style="display:flex; flex-flow: row;"><!-- REFERENCE --><md-input-container class="medium-10 columns min-height-35" md-is-error="vm.isSubmitted && PRForm.reference.$valid == false"><label class=color-black>{{\'FAV_MODAL_REFERENCE_TM\' | translate}}</label> <input type=text name=reference ng-change=vm.formatReferenceInput() ng-model=vm.form.reference phenix-enter=vm.getReferenceInformation(vm.form.reference) ng-blur=vm.getReferenceInformation(vm.form.reference) maxlength=13 required><div ng-messages="vm.isSubmitted && PRForm.reference.$error" class=errorMessage><div ng-message=required>{{\'ERROR_INVALID_REFERENCE\' | translate}}</div></div></md-input-container><i class=material-icons id=signAdd>add_circle_outline</i></div></div><!-- DESIGNATION --><div class="small-7 column" ng-if=vm.isReferenceVisible><md-input-container class="medium-offset-2 medium-10 columns min-height-35" style="margin-bottom: 30px;"><label class=color-black>{{\'LIBELLE_TM\' | translate}}</label> <input type=text ng-model=vm.form.designation ng-bind=vm.form.reference name=designation style="width: 100%;" class=readonly readonly=readonly></md-input-container></div></div><!--PRICE--><div class=row><div class="small-6 column" ng-if=vm.isReferenceVisible><md-input-container class="medium-12 min-height-35"><label class=color-black>{{\'FAV_MODAL_TM_PRICE\' | translate}}</label> <input type=text ng-model=vm.form.price name=price class=readonly readonly=readonly> <span class=currency>&nbsp; {{vm.getCurrencyForItem(vm.form.reference)}}</span></md-input-container></div></div><div class="row medium-12 column" ng-if=vm.isReferenceVisible><!-- save --> <button type=button class="buttonWithIcon medium-5 columns height-45" style="display: inline !important;" ng-click=vm.addPR(vm)><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_SAVE_TO\' | translate}}</div></button><!-- cancel --> <button type=button class="buttonWithIcon small-offset-1 medium-5 columns height-45 cancelButton cancel" style="display: inline !important; float: none;" ng-click=vm.closeModal()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></button></div></form></div></md-dialog>');
$templateCache.put('app/components/favourites/PR/components/deleteRefModal.template.html','<md-dialog><div class=modalPhenix id=dialogTitle><!-- TITLE --><div class=row style="margin : 20px 0;"><div class="small-12 column" style="height: 300;">{{\'DELETE_REFERENCE_FAV_PRODUCTS\' | translate}}</div></div><!-- ACTIONS --><div class="row columns centerElement"><md-button class="buttonWithIcon md-raised" type=submit ng-click=vm.onConfirm()><div class=iconDiv><i class=icon-icons_validate style="font-size: 28px;"></i></div><div class=btnText>{{\'COMMON_DELETE\' | translate}}</div></md-button><md-button class="buttonWithIcon margin-left-10 md-raised-cancel" style="background-color: #CCCCCC" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close style="font-size: medium;"></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></md-button></div></div></md-dialog>');
$templateCache.put('app/components/favourites/PR/components/move-reference-template.html','<md-dialog id=dialogBoxSize><div class=modalPhenix id=dialogTitle><!-- TITLE --><div class=row><div class="small-12 column title" style="height: 300;">{{vm.transmitData}}<!-- FORM --><form name="moveRefForm "><!-- CATEGORY AND SUB CATEGORY --><div class=row><div class="small-4 column"><md-input-container class=categoryBlock><label>{{\'FAV_MODAL_ADD_TM_CATEG\' | translate}}</label><md-select name=category ng-model=vm.form.category required ng-change=vm.onChangeCategory(vm.form.category)><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_CATEG\' | translate}}</md-option><md-option value={{category.categoryKey}} ng-repeat="category in vm.favoritesProduct.categories">{{category.categoryName | translate}}</md-option></md-select></md-input-container></div><div class="small-8 column"><md-input-container class=subCategoryBlock><label>{{\'FAV_MODAL_ADD_TM_SUBCATEGORY\' | translate}}</label><md-select id=subcategory name=subCategory ng-model=vm.form.subCategory ng-change=vm.onChangeSubcategory(vm.form.subCategory) ng-disabled=vm.isSubCategoriesDisabled><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_SUBCATEG\' | translate}}</md-option><md-option ng-if="vm.subCategories.length > 0" value={{subCategory.subcategoryKey}} ng-repeat="subCategory in vm.subCategories">{{subCategory.subCategoryName | translate}}</md-option></md-select></md-input-container></div></div><!-- ACTIONS --><div class="row columns"><md-button class="buttonWithIcon md-raised" type=submit ng-click="vm.moveSelectedRefs(vm.form.category, vm.form.subCategory)"><div class=iconDiv><i class=icon-icons_folder></i></div><div class=btnTextSpecific>{{\'FAV_REF_MOVE\' | translate}}</div></md-button><md-button class="buttonWithIcon margin-left-10 cancelButton md-raised-cancel" ng-click=vm.closeModal()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnTextSpecific>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></md-button></div></form></div></div></div></md-dialog>');
$templateCache.put('app/components/favourites/PR/manageFavouriteModal/manageFavouriteModal.template.html','<div id=manage-favourite-modal><div class=title>{{\'TM_TYPE_PAINT_TITLE\' | translate}}</div><!--<div class="container-list">\n        <md-radio-group ng-model="vm.selected">\n            <md-radio-button value="O">{{\'TM_TYPE_PAINT_1\' | translate}}</md-radio-button>\n            <md-radio-button value="V">{{\'TM_TYPE_PAINT_2\' | translate}}</md-radio-button>\n            <md-radio-button value="N">{{\'TM_TYPE_PAINT_3\' | translate}}</md-radio-button>\n            <md-radio-button value="S">{{\'TM_TYPE_PAINT_4\' | translate}}</md-radio-button>\n        </md-radio-group>\n    </div>\n    <div class="modalPhenixButtons bottom">\n        <button type="button" class="buttonWithIcon" ng-class="{cancel: !vm.selected}" ng-click="vm.selected && vm.onSelectPaint(vm.selected)">\n            <div class="iconDiv">\n                <i class="icon-icons_validate"></i>\n            </div>\n            <div class="btnText">{{\'PRODUCT_ADD_TO_ESTIMATE\'|translate}}</div>\n        </button>\n\n        <button type="button" class="buttonWithIcon cancel" ng-click="vm.onClose()">\n            <div class="iconDiv">\n                <i class="icon-icons_close"></i>\n            </div>\n            <div class="btnText">{{\'COMMON_CANCEL\'|translate}}</div>\n        </button>\n    </div>--></div>');
$templateCache.put('app/components/favourites/TM/components/add-non-codified-tm.template.html','<md-dialog id=dialogBoxSize><div class=modalPhenix id=dialogTitle><!-- TITLE --><div class=row><div class="small-6 column title">{{\'FAV_MODAL_ADD_TM_TITLE\' | translate}}</div><div class="small-6 column closeButton" ng-click=vm.closeModal()>{{\'MODAL_CLOSE\' |translate}} X</div></div><!-- FORM --><form name=nonCodedTMForm><!-- CATEGORY AND SUB CATEGORY --><div class=row><div class="small-4 column"><md-input-container class=categoryBlock><label>{{\'FAV_MODAL_ADD_TM_CATEG\' | translate}}</label><md-select name=category ng-model=vm.form.category required ng-change=vm.onChangeCategory(vm.form.category)><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_CATEG\' | translate}}</md-option><md-option value={{category.name}} ng-repeat="category in vm.categories">{{category.name | translate}}</md-option></md-select></md-input-container></div><div class="small-8 column"><md-input-container class=subCategoryBlock><label>{{\'FAV_MODAL_ADD_TM_SUBCATEGORY\' | translate}}</label><md-select id=subcategory name=subCategory ng-model=vm.form.subCategory ng-change=vm.onChangeSubcategory(vm.form.subCategory) ng-disabled=vm.isSubCategoriesDisabled><md-option value="">{{\'FAV_MODAL_ADD_TM_CHOOSE_SUBCATEG\' | translate}}</md-option><md-option ng-if="vm.subCategories.length > 0" value={{subCategory.name}} ng-repeat="subCategory in vm.subCategories">{{subCategory.name | translate}}</md-option></md-select></md-input-container></div></div><!-- TACHNICALITY --><div class="row small-12 column" style="margin-bottom: 10px;"><label id=technicalityLabel>{{\'TECHNICITE_TM\' | translate}}</label></div><div class=row><md-radio-group ng-model=vm.form.technicality name=technicality class=min-height-35 ng-change=vm.onChangeTechnicality(vm.form.technicality)><div class="small-4 column" style="display: flex;"><md-radio-button value=TM_NOCODIF_TECH_NORMAL ng-disabled=vm.isNormalTechnicalityDisabled><div ng-class=vm.getNormalTechnicalityClass() for=normalTechnicalityIcon><i class="icon-icons_difficult_1 technicalityIcon"></i></div></md-radio-button><span class=technicalityLabel>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_N\'| translate}}</span></div><div class="small-4 column" style="display: flex;"><md-radio-button value=TM_NOCODIF_TECH_HIGH ng-disabled=vm.isHighTechnicalityDisabled><div ng-class=vm.getHighTechnicalityClass() for=highTechnicalityIcon><i class="icon-icons_difficult_2 technicalityIcon"></i></div></md-radio-button><span class=technicalityLabel>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_T\'| translate}}</span></div><div class="small-4 column" style="display: flex;"><md-radio-button value=TM_NOCODIF_TECH_VERY_HIGH ng-disabled=vm.isVeryHighTechnicalityDisabled><div ng-class=vm.getVeryHighTechnicalityClass() for=veryHighTechnicalityIcon><i class="icon-icons_difficult_3 technicalityIcon"></i></div></md-radio-button><span class=technicalityLabel>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_H\'| translate}}</span></div></md-radio-group></div><!-- REFERENCE + DESIGNATION --><div class="row small-12 column" ng-if=vm.isReferenceVisible><md-input-container class="small-2 columns min-height-35"><label>{{\'FAV_MODAL_REFERENCE_TM\' | translate}}</label> <input ng-model=vm.form.reference readonly=readonly></md-input-container><md-input-container class="small-offset-1 small-9 columns min-height-35" md-is-error="vm.isSubmitted && nonCodedTMForm.designation.$valid == false"><label class=color-black>{{\'LIBELLE_TM\' | translate}}</label> <input type=text ng-model=vm.form.designation name=designation md-maxlength=100 maxlength=100 required><div ng-messages=nonCodedTMForm.designation.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_WORDING_NEEDED\' | translate}}</div></div></md-input-container></div><!-- PRICE --><div class="row small-12 column" ng-if=vm.isPriceVisible><md-input-container class="small-5 column min-height-35" md-is-error="vm.isSubmitted && nonCodedTMForm.price.$valid == false"><label class=color-black>{{\'FAV_MODAL_TM_PRICE\' | translate}}</label> <input type=text ng-model=vm.form.price name=price required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ><div ng-messages=nonCodedTMForm.price.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_PRICE_NEEDED\' |translate}}</div><div ng-message=pattern>{{\'TM_DOCUMENT_PRICE_MANDATORY_ERROR\' | translate}}</div></div></md-input-container><div class="small-3 column margin-top-20 margin-left-10" id=hoursDiv><label ng-model=vm.currency id=hoursLabel>{{vm.currency}}</label></div><div class="small-4 column"></div></div><!-- TIME --><div class="row small-12 column" ng-if=vm.isTimeVisible><md-input-container class="small-5 column min-height-35" md-is-error="vm.isSubmitted && nonCodedTMForm.time.$valid == false"><label class=color-black>{{\'FAV_MODAL_TM_TIME\' | translate}}</label> <input type=text ng-model=vm.form.time name=time required ng-pattern=/^[0-9]+(\\,[0-9]{0,1})?$/ ><div ng-messages=nonCodedTMForm.time.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_TIME_NEEDED\' |translate}}</div><div ng-message=pattern>{{\'TM_DOCUMENT_TIME_MANDATORY_ERROR\' | translate}}</div></div></md-input-container><div class="small-3 column margin-top-20 margin-left-10" id=hoursDiv><label id=hoursLabel>{{\'COMMON_COLUMN_HOURS_TITLE\' | translate}} (X,y)</label></div><div class="small-4 column"></div></div><!-- DESCRIPTION --><div class="row small-12 column" ng-if=vm.isDescriptionVisible><md-input-container class=md-block><label class=color-black>*{{\'FAV_MODAL_DESCRIPTION\' | translate}}</label> <textarea name=description ng-model=vm.form.description md-maxlength=100 maxlength=100 rows=2 cols=30 md-select-on-focus></textarea></md-input-container></div><!-- ACTIONS --><div class="row small-8 column" ng-if=vm.isActionsVisible><button type=button class="buttonWithIcon small-4 columns height-45" style="display: inline !important;" ng-click=vm.addTM(vm.form)><div class=iconDiv><i class=icon-icons-phnx-expendable_plus></i></div><div class=btnText>{{\'FAV_MODAL_ADD_TM\' | translate}}</div></button> <button type=button class="buttonWithIcon small-offset-1 small-4 columns height-45 cancel cancelButton" style="display: inline !important;" ng-click=vm.closeModal()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></button><div class="small-3 column"></div></div><div class="small-4 column"></div></form></div></md-dialog>');
$templateCache.put('app/components/favourites/TM/components/consult-non-codified-tm.template.html','<md-dialog id=consultedNonCodifiedTM><form class=nonCodifiedTMForm><div class="row opeCodeAndLabelFont">{{vm.payload.opeCode}}</div><div class=label-container><input class="displayPriceOrTimeInput input-width" type=text maxlength=100 ng-model=vm.payload.label name=label required></div><div class="row descriptionFont">{{vm.payload.description}}</div><div class="row consultedTMmainInfo marginTB5"><div class="small-4 boldFont">{{\'FAV_CAT\' | translate}} :</div><div class=small-8>{{vm.payload.category | translate}}<div class=displaySubcategory ng-if=vm.payload.subCategory>> {{vm.payload.subCategory | translate}}</div></div></div><div class="row consultedTMmainInfo marginTB5"><div class="small-4 boldFont">{{\'TECHNICITE_TM\' | translate}} :</div><div class=small-8><div ng-if=vm.payload.technicality ng-switch on=vm.payload.technicality><div ng-switch-when=TM_NOCODIF_TECH_VERY_HIGH>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_H\' | translate}} <span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_3 title="{{\'DOCUMENT_TM_TECHNICALITY_H\' | translate}}"></span></div><div ng-switch-when=TM_NOCODIF_TECH_NORMAL>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_N\' | translate}} <span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_1 title="{{\'DOCUMENT_TM_TECHNICALITY_N\' | translate}}"></span></div><div ng-switch-default>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_T\' | translate}} <span style="font-size: 20px; vertical-align: middle;" class=icon-icons_difficult_2 title="{{\'DOCUMENT_TM_TECHNICALITY_T\' | translate}}"></span></div></div></div></div><div class="row consultedTMmainInfo marginT5B25"><div class="small-4 boldFont padding-text">{{\'TEMPS_PUBHT_TM\' | translate}} :</div><div class=price-time-container ng-if=vm.displayTime><div><input class="displayPriceOrTimeInput input-width" type=text ng-model=vm.payload.time name=time required></div><div class=padding-text>{{\'COMMON_COLUMN_HOURS_TITLE\' | translate}}</div></div><div class=price-time-container ng-if=vm.displayPrice><div><input class="displayPriceOrTimeInput input-width" type=text ng-model=vm.payload.price name=price required></div><div class=padding-text>{{vm.currency}}</div></div></div><div class="row consultedTMmainInfo"><button ng-click=vm.onConfirm() type=button class="buttonWithIcon small-4 columns height-45"><div class=iconDiv><i class="icon-icons_estimation on-super-cart-quote-hover font-30"></i></div><div class=btnText>{{\'PRODUCT_ADD_TO_ESTIMATE\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel small-offset-1 small-4 columns height-45 cancelButton" ng-click=vm.closeModal()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></button></div></form></md-dialog>');
$templateCache.put('app/components/favourites/TM/components/delete-no-codified-tm.template.html','<md-dialog class=global-modal><div class="modalPhenix modal-container"><!-- TITLE --><div class="title-container padding-container"><div class=title>{{\'FAV_MODAL_ADD_TM_DELETE_UNIQUE_TITLE\' | translate}}</div><div class=close ng-click=vm.onCancel()>{{\'MODAL_CLOSE\' |translate}} X</div></div><div class=padding-container><p>{{vm.tm.opeCode}} {{vm.tm.label}}</p></div><!-- ACTIONS --><div class="actions-container padding-container"><button type=button ng-click=vm.onDelete() class="buttonWithIcon margin-right height-40"><div class=iconDiv><i class="fa fa-trash confirm-icon-size"></i></div><div class=btnText>{{\'COMMON_DELETE\' | translate}}</div></button> <button type=button ng-click=vm.onCancel() class="buttonWithIcon cancel margin-right height-40 disabled-color"><div class=iconDiv><i class="icon-icons_close close-icon-size"></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/favourites/TM/components/header-favourites.template.html','<div sticky name-class="row headerActis fixedInfoNode" style="display: flex; flex-direction: row; padding: 15px 0px"></div>');
$templateCache.put('app/components/favourites/TM/components/liste-favourites.template.html','');
$templateCache.put('app/components/favourites/TM/components/menu-favourites.template.html','<!--&lt;!&ndash;ROW WITH MENU CATEGORIES&ndash;&gt;--><!--<div class="row">--><!--&lt;!&ndash;BLOC CATEGORIES&ndash;&gt;--><!--<div class="medium-3 columns ">--><!--<div class="categ">--><!--<div ng-class="{\'categActif\':true}" ng-repeat="categorie in vm.categories">--><!--<div class="row" ng-click="vm.toggleCategory(categorie)">--><!--<div ng-class="{\'categNameActif\': categorie.isActive, \'categNameNotActif\': !categorie.isActive}"--><!--ng-if="!categorie.isActive">--><!--<div> {{categorie.name}}&nbsp;</div>--><!--</div>--><!--&lt;!&ndash;<i class="icon-icons_expendable_plus"></i>&ndash;&gt;--><!--</div>--><!--<div class="subCateg" ng-if="categorie.subCategories">--><!--<div class="row customManageCateg" ng-repeat="subCateg in categorie.subCategories"--><!--ng-click="vm.toggleSubCategory(subCateg, categorie)">--><!--<div--><!--ng-class="{\'subCategActif\': true, \'subCategNotActif\': false}">--><!--{{vm.getSubCategoryName(subCateg, categorie)}} ({{subCateg.number}})--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>-->');
$templateCache.put('app/components/favourites/TM/components/update-no-codified-tm.template.html','<md-dialog class=global-modal id=update-no-codified-tm><div class="modalPhenix modal-container"><!-- TITLE --><div class="title-container padding-container"><div class=title>{{\'FAV_MODAL_MODIFY_TM\' | translate}}</div><div class=close ng-click=vm.onClose()>{{\'MODAL_CLOSE\' |translate}} X</div></div><!-- FORM --><form name=nonCodedTMForm><!-- CATEGORY AND SUB CATEGORY --><div class=row><div class="small-4 column"><md-input-container class=categoryBlock><label>{{vm.tm.category | translate}}</label><md-select name=category ng-model=vm.form.category ng-disabled=true></md-select></md-input-container></div><div ng-if=vm.tm.subCategory class="small-8 column"><md-input-container class=subCategoryBlock><label>{{vm.tm.subCategory | translate}}</label><md-select name=subCategory ng-model=vm.form.subCategory ng-disabled=true></md-select></md-input-container></div></div><!-- TACHNICALITY --><div class="row small-12 column"><label class=technicalityLabel>{{\'TECHNICITE_TM\' | translate}}</label></div><div ng-if=vm.tm.technicality class=row><md-radio-group ng-disabled=true ng-model=vm.tm.technicality name=technicality class=min-height-35><div class="small-4 column"><md-radio-button value=TM_NOCODIF_TECH_NORMAL><div for=normalTechnicalityIcon><i class="icon-icons_difficult_1 technicalityIcon"></i> <span>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_N\'| translate}}</span></div></md-radio-button></div><div class="small-4 column"><md-radio-button value=TM_NOCODIF_TECH_HIGH><div for=highTechnicalityIcon><i class="icon-icons_difficult_2 technicalityIcon"></i> <span>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_T\'| translate}}</span></div></md-radio-button></div><div class="small-4 column"><md-radio-button value=TM_NOCODIF_TECH_VERY_HIGH><div for=veryHighTechnicalityIcon><i class="icon-icons_difficult_3 technicalityIcon"></i> <span>{{\'FAV_MODAL_ADD_TM_TECHNICALITY_H\'| translate}}</span></div></md-radio-button></div></md-radio-group></div><!-- REFERENCE + DESIGNATION --><div class="row small-12 column"><md-input-container class="small-2 columns min-height-35"><label>{{\'FAV_MODAL_REFERENCE_TM\' | translate}}</label> <input ng-model=vm.tm.opeCode readonly=readonly></md-input-container><md-input-container class="small-offset-1 small-9 columns min-height-35" md-is-error="nonCodedTMForm.designation.$valid == false"><label class=color-black>{{\'LIBELLE_TM\' | translate}}</label> <input type=text class=remove-margin-bottom ng-model=vm.tm.label name=designation md-maxlength=100 maxlength=100 required><div ng-messages=nonCodedTMForm.designation.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_WORDING_NEEDED\' | translate}}</div></div></md-input-container></div><!-- PRICE --><div ng-if=vm.viewPrice class="row small-12 column"><md-input-container class="small-5 column min-height-35" md-is-error="nonCodedTMForm.price.$valid == false"><label class=color-black>{{\'FAV_MODAL_TM_PRICE\' | translate}}</label> <input type=text class=remove-margin-bottom ng-model=vm.tm.price name=price required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ><div ng-messages=nonCodedTMForm.price.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_PRICE_NEEDED\' |translate}}</div><div ng-message=pattern>{{\'TM_DOCUMENT_PRICE_MANDATORY_ERROR\' | translate}}</div></div></md-input-container><div class="small-3 column margin-top-20 margin-left-10"><label ng-model=vm.currency class=hoursLabel>{{vm.currency}}</label></div><div class="small-4 column"></div></div><!-- TIME --><div ng-if=vm.viewTime class="row small-12 column"><md-input-container class="small-5 column min-height-35" md-is-error="nonCodedTMForm.time.$valid == false"><label class=color-black>{{\'FAV_MODAL_TM_TIME\' | translate}}</label> <input type=text class=remove-margin-bottom ng-model=vm.tm.time name=time required ng-pattern=/^[0-9]+(\\,[0-9]{0,1})?$/ ><div ng-messages=nonCodedTMForm.time.$error class=errorMessage><div ng-message=required>{{\'COMMON_ERROR_TIME_NEEDED\' |translate}}</div><div ng-message=pattern>{{\'TM_DOCUMENT_TIME_MANDATORY_ERROR\' | translate}}</div></div></md-input-container><div class="small-3 column margin-top-20 margin-left-10 hoursDiv"><label class=hoursLabel>{{\'COMMON_COLUMN_HOURS_TITLE\' | translate}} (X,y)</label></div><div class="small-4 column"></div></div><!-- DESCRIPTION --><div class="row small-12 column"><md-input-container class=md-block><label class=color-black>*{{\'FAV_MODAL_DESCRIPTION\' | translate}}</label> <textarea name=description ng-model=vm.tm.description md-maxlength=100 maxlength=100 rows=2 cols=30 md-select-on-focus></textarea></md-input-container></div><!-- ACTIONS --><div class="actions-container padding-container"><button type=button ng-class="{\'disabled-color\' : !nonCodedTMForm.$valid}" ng-click=vm.onUpdate(nonCodedTMForm) class="buttonWithIcon margin-right height-40"><div class=iconDiv><i class="fa fa-save confirm-icon-size"></i></div><div class=btnText>{{\'FAV_MODAL_MODIFY_TM\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel margin-right height-40 disabled-color" ng-click=vm.onClose()><div class=iconDiv><i class="icon-icons_close close-icon-size"></i></div><div class=btnText>{{\'FAV_MODAL_MODIF_REF_CANCEL\' | translate}}</div></button></div></form></div></md-dialog>');
$templateCache.put('app/components/partRequisition/list/draft/partRequisitionDraftList.template.html','<div id=partRequisitionListContainer><div ng-if=vm.dataLoaded><div class="row max-widthC"><!-- ************************************\n            *       FILTER COMPONENT ON LEFT        *\n            **************************************--><div class="small-3 columns cardShadow"><filter-list on-search=vm.onSearch type-of-supercart=vm.globalConstant.partRequisition filters-values=vm.filterValues></filter-list></div><!-- ***********************************\n            *       LIST WITH PAGINATION ON RIGHT  *\n            ************************************ --><div class="small-9 columns"><div class=textCenter ng-if="vm.partRequisitionList.length == 0"><h4>{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div ng-if="vm.partRequisitionList.length > 0"><!-- ****************************\n                    *       LIST COMPONENT          *\n                    ******************************--><container-list list=vm.partRequisitionList type=draftWorkshop is-part-requsition=true on-delete=vm.onDelete type-of-supercart=vm.globalConstant.partRequisition on-unlock=vm.onUnlock on-sort=vm.onSort on-select=vm.onSelect on-check=vm.onCheck></container-list><!-- ***************************\n                    *         PAGINATION           *\n                    **************************** --><pagination-list count=vm.count update-pagination=vm.onUpdatePagination current-page=vm.currentPage></pagination-list></div></div></div></div></div>');
$templateCache.put('app/components/partRequisition/list/validated/partRequisitionValidatedList.template.html','<div id=partRequisitionListContainer><div ng-if=vm.dataLoaded><div class="row max-widthC"><!-- ************************************\n                *       FILTER COMPONENT ON LEFT        *\n                **************************************--><div class="small-3 columns cardShadow"><filter-list fields=vm.filterFields on-search=vm.onSearch filters-values=vm.filterValues></filter-list></div><!-- ***********************************\n                *       LIST WITH PAGINATION ON RIGHT  *\n                ************************************ --><div class="small-9 columns"><div class=textCenter ng-if="vm.partRequisitionList.length == 0"><h4>{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div ng-if="vm.partRequisitionList.length > 0"><!-- ****************************\n                        *       LIST COMPONENT          *\n                        ******************************--><container-list list=vm.partRequisitionList state-of-supercart=vm.globalConstant.validated type=validatedWorkshop headers=vm.containerHeaders actions=vm.containerActions on-delete=vm.onDelete on-sort=vm.onSort on-unlock=vm.onUnlock on-select=vm.onSelect on-check=vm.onCheck></container-list><!-- ***************************\n                        *         PAGINATION           *\n                        **************************** --><pagination-list count=vm.count update-pagination=vm.onUpdatePagination current-page=vm.currentPage></pagination-list></div></div></div></div></div>');
$templateCache.put('app/components/partRequisition/shoppingCart/modal/modalOrderType.template.html','<md-dialog id=modalOrderType><div class=modalPhenix><div class=title>{{\'PARTLIST_MODAL_TYPEORDER_TITLE\' | translate}}</div><p>{{\'PARTLIST_MODAL_TYPEORDER_MSG\' | translate}}</p><div class=row><div class="small-12 columns"><md-input-container class=md-block><md-select placeholder={{vm.defaultPlaceholder}} ng-model=vm.selectedOrderType ng-model-options="{trackBy: \'$value.id\'}" ng-change=vm.onSelectOrderType()><md-option ng-value=orderType ng-repeat="orderType in vm.ordersType">{{ orderType.name }}</md-option></md-select></md-input-container></div></div><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onValidate() ng-disabled=!vm.isOrderTypeSelected><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'MODAL_OK_BUTTON\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></div></md-dialog>');
$templateCache.put('app/components/partRequisition/shoppingCart/validate/validatedPartRequisition.html','<div class=containerView id=createPartRequisition><!--BLOC HEADER --><div class="row headerPartList"><div class="small-1 columns numPartList" ng-if=vm.isBackButtonExist><div class=backPartList ng-click=vm.backToPrevious()><i class=icon-icons_back_product></i><div class=text>{{\'PRODUCT_PREVIOUS\' |translate}}</div></div></div><div class="small-5 columns"><label class=labelNumPartList><span>{{\'LABEL_NUM_PARTLIST\' |translate}} {{vm.partsRequisition.number}}</span> <span ng-if=vm.partsRequisition.dmsPartListId>/ {{vm.partsRequisition.dmsPartListId}}</span></label> <label class="labelValidateByPartList font-size-20">{{\'ESTIMATE_VALIDATED_DATE\' |translate}} {{vm.partsRequisition.validationDateTime | localTimeFilter }} {{\'ACTION_BY\' |translate}} {{vm.partsRequisition.validatorInfos}}</label></div><div class="small-5 columns listPartListAction"><div ng-click=vm.printPartRequisition(false) class=clickable><i class=icon-icons_print_partlist></i> <label>{{\'BUTTON_ESTIMATE_PRINT\' |translate}}</label></div><div ng-click=vm.printPartRequisition(true) class=clickable><i class="fa fa-download"></i> <label>{{\'BUTTON_ESTIMATE_DOWNLOAD\' | translate}}</label></div><div ng-click=vm.closePartsRequisition() class=clickable><i class=icon-icons_close_big_partlist></i> <label>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}}</label></div></div></div><!--div class="headerClient">\n        <div class="small-12 saisirClientPassantPartListFirst saisirClientPassantPartList">\n            <i class="icon-icons_people_partlist"></i>\n            <div class="small-4">\n                <label class="headerClientNameLabel">{{vm.currentCustomer.firstName | uppercase}} {{vm.currentCustomer.name | uppercase}} ({{vm.partsRequisition.accountNumber}})</label>\n            </div>\n            <div class="small-2" ng-if="vm.currentCustomer.mainPhone">\n                <div class="phone">\n                    <i class="icon-icons_phone_partlist"></i>{{vm.currentCustomer.mainPhone}}\n                </div>\n            </div>\n            <div class="small-3" ng-if="vm.currentCustomer.email">\n                <div class="mail">\n                    <i class="icon-icons_mail_partlist"></i>{{vm.currentCustomer.email | lowercase}}\n                </div>\n            </div>\n        </div>\n        <div class="small-5">\n            <div class="clientPassantStreetNumberPartList">\n                <i class="icon-icons_address_passant_partlist"></i>{{vm.currentCustomer.streetNumber | lowercase}} {{vm.currentCustomer.bisTer}} {{vm.currentCustomer.streetName}}\n                {{vm.currentCustomer.postCode}} {{vm.currentCustomer.city}}\n            </div>\n        </div>\n    </div--><dms-customer class=headerClient view=consultation current-customer=vm.currentCustomer on-customer-filled-callback=vm.onCustomerFilledCallback></dms-customer><!--BLOC COMMENT --><div class="commentBloc small-6"><div class=maxCharacter><span>{{vm.partsRequisition.description.length || 0}}</span> <span>/100</span></div><div class="comment textarea inputCommentItalic" name=comment rows=2 cols=20 maxlength=100>{{vm.partsRequisition.description}}</div></div><div class="commentBloc small-12"><div class="comment textarea inputCommentItalic" style="background-color: #F1F2F3; border: none;min-height: 0px !important;">{{\'RGPD_MESSAGE\' |translate}}</div></div><!-- BLOC ITEMS --><div class=blocVehiculePartList ng-if="vm.partsRequisition.items.length > 0"><div class=row><div class="small-12 columns blocVehiculeBandeauValidate"><div class=changeContextVehiclePanier><div><i class=icon-icons_vehicle_panier></i></div></div><div class=vehicleHeader><label class=designationVehiculeBlocContext><span ng-bind-html=vm.bannerData></span></label> <label class=vinImatVehiculeBlocContext ng-if=vm.vehicle><span ng-if=vm.vehicle.vin>{{vm.vehicle.vin}}</span> <span ng-if="vm.vehicle.vin && vm.vehicle.registrationNumber">|</span> <span ng-if=vm.vehicle.registrationNumber>{{vm.vehicle.registrationNumber}}</span> <span ng-if=vm.partsRequisition.orderNumber class=orderNumber><i class=icon-icons_repair></i> {{vm.partsRequisition.orderNumber}}</span></label></div></div></div></div><div class=row><!-- HEADER VEHICLE --><div class="row headerTabListPRorTM"><div class="small-12 columns"><div class="small-1 columns partListTitle ref_div_width"><label>{{\'COMMON_COLUMN_REF_TITLE\' | translate}}</label> <i class=icon-icons_order_partlist ng-click="vm.sortBy(\'reference\')"></i></div><div class="small-4 columns partListTitle"><label>{{\'COMMON_DESIGNATION\' | translate}}</label></div><div class="small-1 columns partListTitle" ng-if="vm.networkProfile === vm.constant.workshop"><label>{{\'PARTLIST_TABLE_TITLE_SPLIT\' | translate}}</label></div><div class="small-2 columns partListTitle text-align-right" ng-if=!mainCtrl.isCountryRoumania><label>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate}}</label></div><div class="small-1 columns partListTitle text-align-center" ng-if="vm.networkProfile === vm.constant.partshop"><label>{{\'PARTLIST_TABLE_TITLE_DISCOUNT\' | translate}}</label></div><div class="small-1 columns partListTitle text-align-center"><label>{{\'PARTLIST_TABLE_TITLE_QUANTITY\' | translate}}</label></div><div class="small-2 columns partListTitle text-align-center"><label>{{\'PARTLIST_TABLE_TITLE_URGENCY\' | translate}}</label></div><div class="small-1 columns partListTitle ref_div_width text-align-left"><label>{{\'COMMON_COLUMN_LOCATION\' | translate}}</label> <i class=icon-icons_order_partlist ng-click="vm.sortBy(\'location\')"></i></div></div></div><!-- REFERENCES LIST --><div class="row contentTabListPRorTM" ng-repeat="item in vm.partsRequisition.items | orderBy:vm.propertyName:vm.reverse"><div class="small-12 columns"><div class="small-1 columns partListCol white-space"><label>{{item.reference | filterFormatRef}}</label></div><div class="small-4 columns partListCol"><label class=display-inline-block>{{item.designation}}</label> <span ng-if=item.reach class=display-inline-block><img src=./assets/svg/reach.svg height=16 width=16></span><div ng-if="item.unusualSale && vm.networkProfile === vm.constant.partshop"><div class="box display-inline-block"></div><div class=txt>{{\'PARTLIST_UNUSUAL_SALE\' | translate}}</div></div></div><div class="small-1 columns partListCol text-align-center" ng-if="vm.networkProfile === vm.constant.workshop"><label ng-if=item.interventionId>{{item.interventionId}}</label> <label ng-if=!item.interventionId>-</label></div><div class="small-2 columns partListCol text-align-right" ng-if=!mainCtrl.isCountryRoumania><label ng-if=item.dmsInformations.priceExclTaxes>{{item.dmsInformations.priceExclTaxes | number : 2}} {{vm.getCurrencyForItem(item)}}</label> <label ng-if="!item.dmsInformations.priceExclTaxes && item.price">{{item.price | number : 2}} {{vm.getCurrencyForItem(item)}}</label> <label ng-if="!item.dmsInformations.priceExclTaxes && !item.price">-</label></div><div class="small-1 columns partListCol text-align-center" ng-if="vm.networkProfile === vm.constant.partshop"><label ng-if=item.additionalDiscount>{{item.additionalDiscount}}%</label> <label ng-if=!item.additionalDiscount>-</label></div><div class="small-1 columns partListCol text-align-center"><label ng-if=item.quantity>{{item.quantity}}</label> <label ng-if=!item.quantity>-</label></div><div class="small-2 columns partListCol text-align-center"><label ng-if=item.orderTypeToDisplay>{{item.orderTypeToDisplay}}</label></div><div style="position: relative; right: 18px;" class="small-1 columns partListCol text-align-center"><label ng-if=item.location>{{item.location}}</label> <label ng-if=!item.location>-</label></div></div></div></div></div>');
$templateCache.put('app/components/products/directives/dialog-documentation-sie/dialog-documentation-sie.template.html','<div id=dialogDocumentation><md-card ng-if=vm.listSie.length><div style="margin: 5px 0px;"><span ng-click=vm.closeDialog() class=cancel>{{\'MODAL_CLOSE\' | translate}} <i class=icon-icons_close></i></span></div><table style="width: 100%; border: none"><tr><th>{{\'DOCUMENT_SIE_ID\' | translate}}</th><th>{{\'DOCUMENT_SIE_TITLE\' | translate}}</th><th>{{\'DOCUMENT_APPLICABILITY\' | translate}}</th><th></th></tr><tr ng-repeat="sie in vm.listSie" ng-click=vm.selectedSie(sie) ng-class="{\'SieLign\': !vm.nissanUserURL, \'nissanSieLign\': vm.nissanUserURL}"><td>{{sie.reference | filterFormatRef}}</td><td>{{sie.designation}}<span style="color:black; cursor:pointer; vertical-align: middle;" title="Open MR in new tab" class="icon-icons_pop_out newMRIcon" ng-click=vm.externalMRIconClick($event,sie,true) role=button tabindex=0></span></td><td class=designation><div ng-repeat="applicability in sie.applicabilities"><strong>{{applicability.label}}</strong> <span>{{applicability.list.join(\', \')}}</span></div></td><td><i class=icon-icons-phnx-next></i></td></tr></table></md-card></div>');
$templateCache.put('app/components/products/documents/TM_LIST/tmListDocuments.template.html','<div id=TMListResult><div class=listPieceMenu><img ng-if=tmListCtrl.loading src=./assets/images/newHourGlassGrey.gif width=24px><recap-car api=tmListCtrl.recapCarAPI icons=true></recap-car><div id=tmListContent><div class=infoNode><span class=btnBack ng-click=tmListCtrl.goToHome()><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_HOME\'|translate}} </span><span class=TMseparator></span> <span class=textNode><span class=infoPieceBis>{{\'CAR_SEARCH_RESULT_FILTER_TM_LIST\' | translate}}</span></span></div><div style="background-color:#8080808a;min-height: 80px;padding: 2%;">{{"TM_LIST_SEARCH_RESULT"|translate}} <span ng-repeat="list in tmListCtrl.searchedTMList"><span ng-class="{colorRed : !list.isTmDoc}">{{list.tmCode}}</span><span ng-if=!$last>,</span></span></div><div class=tm_list_content><div ui-view></div></div><div><div ng-if="tmListCtrl.foundDocuments != 0">{{tmListCtrl.foundDocuments}}{{"TM_LIST_SEARCH_RESULT_FOUND"|translate}}</div><div class=colorRed ng-if="tmListCtrl.notFoundDocuments != 0">{{tmListCtrl.notFoundDocuments}}{{"TM_LIST_SEARCH_RESULT_NOT_FOUND"|translate}}</div></div></div></div></div>');
$templateCache.put('app/components/products/documents/articles/articlesDocuments.template.html','<div class="centered-div documents-not_found" ng-if="vm.listArticles.length < 1">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><div id=articlesTab ng-if="vm.listArticles.length > 0"><div style="float: right;"><md-select multiple=multiple ng-model=vm.selectedlang placeholder="{{\'ARTICLES_SELECT_LANGUAGE\' | translate}}" ng-change=vm.changeLanguage(vm.selectedlang) style="margin: 3px;font-size: var(--renaultMediumFont);"><md-option ng-value=lang ng-repeat="lang in vm.languageList track by $index "><md-icon ng-class="lang + \'-flag\'"></md-icon>{{ lang | capitalize }}</md-option></md-select></div><div class="row documents-row-title documents-row-centered"><div class="small-1 columns cell"></div><div class="small-1 columns cell">{{\'ARTICLES_NUMBER\' | translate}}</div><div class="small-6 columns cell" style="text-align: left;">{{\'DOCUMENT_TITLE\' | translate}}</div><div class="small-1 columns cell">{{\'ARTICLES_DATE\' | translate }}</div><div class="small-2 columns cell">{{\'ARTICLES_PROJECT\' | translate}}</div><div class="small-1 columns cell">{{\'ADMIN_LANGUAGE_TITLE\' | translate}}</div></div><div style="cursor: default;" class="row documents-row" ng-repeat="document in vm.listArticles | limitTo: vm.itemsPerPage : (vm.currentPage - 1) * vm.itemsPerPage"><div class="small-1 columns cellBT" style="display: flex; justify-content: center;"><span style="z-index: 10" ng-click=vm.getArticleDetail(document[vm.article].articleNumber,document[vm.article][vm.articleId],document) ng-class="{\'icon-icons-phnx-expendable_plus\':!document.expend,\'icon-icons-phnx-exependable_moins\':document.expend}"></span></div><div class="small-1 columns cellBT documents-row-centered">{{document[vm.article].articleNumber}}</div><div class="small-6 columns cellBT" style="text-align: left;">{{document[vm.systemInfo].title}}</div><div class="small-1 columns cellBT documents-row-centered">{{document[vm.systemInfo].createdDate | limitTo:10 }}</div><div class="small-2 columns cellBT documents-row-centered wordWrap">{{vm.formatProjectCode(document[vm.article].projectCode)}}</div><div class="small-1 columns cellBT documents-row-centered">{{vm.lang[document[vm.article].language] | capitalize}}</div><div ng-if=document.expend class="row cellArticles cellArticlesBorderbottom" style="background-color: lightgray;padding-top: 5px;"><div class="row cellArticlesBorderbottom"><div class="small-1 columns small-offset-1 color-grey"><label>{{\'VEHICLE_ENGINE_TYPE\' | translate}}</label></div><div class="small-3 columns">{{vm.carCriteria.engine}} &nbsp;</div><div class="small-2 columns cellBT"></div><div class="small-1 columns small-offset-1 color-grey"><label>{{\'VEHICLE_ENGINE_SUFFIX\' | translate }}</label></div><div class="small-3 columns">{{vm.carCriteria.engineIndex}} &nbsp;</div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns small-offset-1 color-grey"><label>{{\'VEHICLE_GEARBOX\' | translate }}</label></div><div class="small-3 columns">{{vm.carCriteria.gearbox}} &nbsp;</div><div class="small-2 columns cellBT"></div><div class="small-1 columns small-offset-1 color-grey"><label>{{\'VEHICLE_GEARBOX_SUFFIX\' | translate }}</label></div><div class="small-3 columns">{{vm.carCriteria.gearboxIndex}} &nbsp;</div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns small-offset-1 color-grey"><label>{{\'BTLIST_HEADER_BATTERY\' | translate }}</label></div><div class="small-3 columns">{{vm.carCriteria.battery}} &nbsp;</div><div class="small-2 columns cellBT"></div><div class="small-1 columns small-offset-1 color-grey"><label>{{\'VEHICLE_BATTERY_SUFFIX\' | translate }}</label></div><div class="small-3 columns">{{vm.carCriteria.batteryIndex}} &nbsp;</div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns cellArticles small-offset-1 color-grey"><label>{{\'DOCUMENT_BT_DTC_CODE\' | translate }}</label></div><div class="small-10 columns cellArticles">{{vm.formatProjectCode(document[vm.systemInfo][vm.dtcCodes])}} &nbsp;</div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns cellArticles small-offset-1 color-grey"><label>{{\'DOCUMENT_BT_SYMPTOM_CODE\' | translate }}</label></div><div class="small-10 columns cellArticles">{{vm.formatProjectCode(document[vm.systemInfo][vm.symptoms])}} &nbsp;</div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns cellArticles small-offset-1 color-grey"><label>{{\'ACTIS_DESCRIPTION_TITLE\' | translate }}</label></div><div ng-bind-html=document[vm.systemInfo].description class="small-10 columns cellArticles"><br></div></div><div class="row cellArticlesBorderbottom"><div class="small-1 columns cellArticles small-offset-1 color-grey"><label>{{\'BTLIST_HEADER_SOLUTION\' | translate }}</label></div><div ng-bind-html=document.solutionHtml class="small-10 columns cellArticles"><br></div></div><div class="row cellArticlesBorderbottom" ng-if=document.attachmentHtml><div class="small-1 columns cellArticles small-offset-1 color-grey"><label>{{\'ACTIS_ATTACHMENT_TITLE\' | translate }}</label></div><div ng-bind-html=document.attachmentHtml class="small-10 columns cellArticles"></div></div></div></div><div class=articles-pagination ng-if="vm.getTotalPages() > 1" style="text-align: center; margin-top: 1rem;"><button type=button style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click=vm.previousPage() ng-disabled="vm.currentPage === 1"><i ng-style="{\'color\': vm.currentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> <span style="margin: 0 0.5rem; font-size: 14px;">{{\'COMMON_PAGINATION_PAGE\' | translate}} {{vm.currentPage}} of {{vm.getTotalPages()}}</span> <button type=button style="margin: 0; color: #000; background-color: unset; padding: 0 0 0 1rem;" ng-click=vm.nextPage() ng-disabled=!vm.hasNextPage()><i ng-style="{\'color\': !vm.hasNextPage() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div>');
$templateCache.put('app/components/products/documents/bt/btDocuments.html','<div ng-controller="BTController as btDocumentsCtrl" id=btTabView><div class="centered-div documents-not_found" ng-if=!btDocumentsCtrl.atLeastOneBTDocument>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><bt-documents docs=btDocumentsCtrl.listOfBTDocuments ng-if=btDocumentsCtrl.atLeastOneBTDocument></bt-documents><!-- <div class="centered-div documents-table" ng-if="btDocumentsCtrl.atLeastOneBTDocument">\n        <div class="row documents-row-title">\n            <div class="small-1 columns cell">\n            <span>{{\'DOCUMENT_BT_ID\' | translate}}</span>\n            </div>\n            <div class="small-4 columns cell">\n            <span>{{\'DOCUMENT_TITLE\' | translate}}</span>\n            </div>\n            <div class="small-1 columns cell">\n            <span>{{\'DOCUMENT_BT_OTS\' | translate}}</span>\n            </div>\n            <div class="small-1 columns cell">\n            <span>{{\'DOCUMENT_BT_DTC_CODE\' | translate}}</span>\n            </div>\n            <div class="small-3 columns cell">\n            <span>{{\'DOCUMENT_BT_SYMPTOM_CODE\' | translate}}</span>\n            </div>\n            <div class="small-1 columns cell">\n            <span>{{\'DOCUMENT_BT_TYPOLOGY\' | translate}}</span>\n            </div>\n            <div class="small-1 columns cell">\n            <span>{{\'DOCUMENT_BT_DATE\' | translate}}</span>\n            </div>\n        </div>\n        <div class="row documents-row" ng-repeat="document in btDocumentsCtrl.listOfBTDocuments"\n                ng-click="btDocumentsCtrl.goToDocument(document.id)">\n            <div class="small-1 columns cell"><span>{{::document.id}}</span></div>\n            <div class="small-4 columns cell"><span>{{::document.designation}}</span></div>\n            <div class="small-1 columns cell">\n            <span class="textOTS">{{::document.ots}}</span>\n            <div class="value-inline" ng-switch on="document.colorCode">\n                <div  ng-switch-when="B"><span class="icon-icons_ots_B"></span></div>\n                <div ng-switch-when="R"><span class="icon-icons_ots_R"></span></div>\n                <div  ng-switch-when="Y"><span class="icon-icons_ots_Y"></span></div>\n            </div>\n            </div>\n            <div class="small-1 columns cell"><span>{{::document.dtcCode}}</span></div>\n            <div class="small-3 columns cell"><span>{{::document.symptom}}</span></div>\n            <div class="small-1 columns cell"><span>{{::document.type}}</span></div>\n            <div class="small-1 columns cell"><span>{{::document.date}}</span></div>\n        </div>\n    </div> --></div>');
$templateCache.put('app/components/products/documents/btNt/btNtDocuments.template.html','<md-dialog aria-label=btNamesAndLabels><div layout=row layout-align="end end"><md-button class=md-icon-button ng-click=vm.onClose()><md-icon aria-label="Close dialog"><i class=icon-icons_close id=onClose></i></md-icon></md-button></div><md-dialog-content><div class=md-dialog-content><table class=table><thead><tr><th>{{\'POP_UP_HEADER_REFERENCE\' | translate}}</th><th>{{\'POP_UP_HEADER_LABEL\' | translate}}</th></tr></thead><tbody><tr ng-repeat="row in vm.btNamesAndLabels track by $index" ng-if="(row.number).indexOf(\'BT\') != -1" class=hover-Yellow><td><div ng-click="vm.displayBtDetails(row.number, row.pdfContent) ; vm.onClose()">{{row.number}}</div></td><td><div ng-click="vm.displayBtDetails(row.number, row.pdfContent) ; vm.onClose()">{{row.label}}</div></td></tr><tr ng-repeat="row in vm.btNamesAndLabels track by $index" ng-if="(row.number).indexOf(\'NT\') != -1" class=hover-Yellow><td><div ng-click="vm.displayNtDetails(row.id, row.contentUrl) ; vm.onClose()">{{row.number}}</div></td><td><div ng-click="vm.displayNtDetails(row.id, row.contentUrl) ; vm.onClose()">{{row.label}}</div></td></tr></tbody></table></div></md-dialog-content></md-dialog>');
$templateCache.put('app/components/products/documents/md/mdDocuments.html','<div ng-controller="MDController as mdDocumentsCtrl" id=mdView><div ng-if=!mdDocumentsCtrl.loading><div class="centered-div documents-not_found" ng-if=!mdDocumentsCtrl.atLeastOneMDDocument>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><p ng-if="mdDocumentsCtrl.isSearchEngine && mdDocumentsCtrl.listOfMDDocuments.length > 0" ng-class="{\'nissan-document-result\': mdDocumentsCtrl.nissanUserURL ,\'document-result\': !mdDocumentsCtrl.nissanUserURL}" translate=DOCUMENT_RESULT translate-values="{count:mdDocumentsCtrl.listOfMDDocuments.length,filter:mdDocumentsCtrl.inputFilterText, docType:mdDocumentsCtrl.docType }"></p><md-documents docs=mdDocumentsCtrl.listOfMDDocuments document-clicked=mdDocumentsCtrl.displayMdDetails ng-if=mdDocumentsCtrl.atLeastOneMDDocument></md-documents></div></div>');
$templateCache.put('app/components/products/documents/pr-mrlink/prMrLink.template.html','<div class=prmrcontainer><div id=MrTabView style="width:60vw; padding:1%;"><div><div style="padding-top: 15px;"></div><div style="padding-bottom: 10px;"><span style=padding-left:10Px;></span> <span style=padding-right:4Px;><i class="fa fa-file-text fa-2x" ng-if=!vm.interventionMrDetails style="font-size:20px; padding-top:3px;"></i> <img src=./assets/images/mr_link_black.svg ng-if=vm.interventionMrDetails style="padding-bottom:7px;height: 33px;width: 29px;"> </span><span class=tmlinkseparator>|</span> <span ng-if=!vm.interventionMrDetails style="padding-right:10Px;font-family: var(--renaultFontRegular);"><strong>{{\'MR_LINKED_TO_THE_PART\' | translate}}&nbsp;:&nbsp;{{vm.mrreference | filterFormatRef}}</strong></span> <span ng-if=vm.interventionMrDetails style="padding-right:10Px;font-family: var(--renaultFontRegular);"><strong>{{\'HEADER_MR\' | translate}}&nbsp;:&nbsp;{{vm.interventionMrDetails.designation}}</strong></span> <span style="float:right;padding-right:10Px;padding-top:20px;cursor: pointer;font-size: var(--renaultSmallFont);font-family: var(--renaultFontBold);" ng-click=vm.close()>{{\'MODAL_CLOSE\'|translate}} <i class=icon-icons_close></i></span></div><div class="centered-div documents-not_found" ng-if="!vm.atLeastOneMRDocument && !vm.loading">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><div class="centered-div documents-table" ng-if=vm.atLeastOneMRDocument><div class="row documents-row-title"><div class="small-2 columns cell"><span>{{\'DOCUMENT_MR_ID\' | translate}}</span></div><div class="small-5 columns cell"><span>{{\'DOCUMENT_TITLE\' | translate}}</span></div><div class="small-5 columns cell"><span>{{\'DOCUMENT_APPLICABILITY\' | translate}}</span></div></div><div class="row documents-row" ng-repeat="document in vm.listOfMRDocuments " ng-click="vm.displayMrDetails(document.sieRef, document.pdfContent)"><div class="small-2 columns cell"><span>{{::document.sieRef}}</span></div><div class="small-5 columns cell"><span>{{::document.designation}}</span></div><div class="small-5 columns cell"><div ng-repeat="applicability in document.applicabilities" class=MRApplicabilities><div class=value-inline-bold>{{::applicability.label}} :&nbsp;</div>{{::applicability.list.join(\', \')}}</div></div></div></div><div style="padding-bottom: 15px;"><p class=numberOfDocuments>{{vm.listOfMRDocuments.length}} <span ng-if="vm.listOfMRDocuments.length > 0">{{\'DOCUMENTS_FOUND\' | translate}}</span></p></div><scroll-up scroll-trigger=300 scroll-anchor=#listePiece></scroll-up></div></div></div>');
$templateCache.put('app/components/products/documents/easybasket/easyBasket.template.html','<div ng-controller="EBCtrl as ebCtrl" id=easyBasketDetails style="width:100%;margin-top: 1%;"><list-intervention list-data=ebCtrl.interventionData ng-if=ebCtrl.interventionData is-modal=ebCtrl.isModal></list-intervention></div>');
$templateCache.put('app/components/products/documents/pr-tmlink/prTmLink.template.html','<div class=prtmcontainer><div id=tmTabView><div><div style="padding-top: 15px;"></div><div style="padding-bottom: 10px;"><span style=padding-left:10Px;></span> <span style=padding-right:4Px;><i class="fa fa-clock-o fa-2x" style="font-size: 20px;"></i></span> <span class=tmlinkseparator>|</span> <span style="padding-right:10Px;font-family: var(--renaultFontRegular);"><strong>{{\'LT_LINKED_TO_THE_PART\' | translate}}: {{vm.tmreference}}</strong></span> <span style="float:right;padding-right:10Px;padding-top:20px;cursor: pointer;font-size: var(--renaultSmallFont);font-family: var(--renaultFontBold);" ng-click=vm.close()>{{\'MODAL_CLOSE\'|translate}} <i class=icon-icons_close></i></span></div><div class="centered-div documents-not_found" ng-if="!vm.atLeastOneTMDocument && !vm.loading">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><div class="centered-div documents-table" ng-if=vm.atLeastOneTMDocument><!--=====================================\n        =              FILTERS                  =\n        ======================================--><!--=====================================\n        =             TABLE HEADERS             =\n        ======================================--><div class="row documents-row-title"><div class=inner_row><!-- ======== ID ======= --><div class="code columns cell padding-left-7"><div class="small-5 columns small-offset-2 inner_cell">{{\'DOCUMENT_TM_ID\' | translate}}</div></div><!-- ======== TITLE ======= --><div class="title columns cell">{{\'DOCUMENT_TM_TITLE\' | translate}}</div><!-- ======== TIME ======= --><div class="time columns cell cell-centered">{{\'DOCUMENT_TM_TIME\' | translate}}</div><!-- ======== PRECISION ======= --><div class="precision columns cell">{{\'DOCUMENT_TM_DETAILS\' | translate}}</div><!-- ======== TECHNICALITY ======= --><div class="technicity columns cell cell-centered" style=width:7%;>{{\'DOCUMENT_TM_TECHNICALITY\' | translate}}</div><!-- ======== APPLICABILITY ======= --><div class="applicability columns cell cell-centered">{{\'DOCUMENT_APPLICABILITY\' | translate}}</div><!-- ======== ESSAY ======= --><div class="essay columns cell cell-centered">{{\'DOCUMENT_TM_TRY\' | translate}}<click-tooltip-container><div data-html2canvas-ignore class="tooltipContainer testPosition unsetCase"><div class=inline ng-repeat="tip in vm.popin.data"><i class={{tip.class}}></i><div class=margin-left-right>{{tip.opcode}} {{tip.txt | translate}}</div><div class=time>{{tip.time}}</div></div></div></click-tooltip-container></div><div class="basket columns cell" style="width:7%;word-break: break-all;"></div></div></div><!--=====================================\n        =              TABLE DATA               =\n        ======================================--><div id=tableData><div ng-repeat="document in vm.listOfTMDocuments "><div class="row documents-row-tm"><tm-data current-tm=document pr-tm=document></tm-data></div></div></div></div><div style="padding-bottom: 15px;"></div><scroll-up scroll-trigger=300 scroll-anchor=#listePiece></scroll-up></div></div></div>');
$templateCache.put('app/components/products/documents/pr/additionalLine.template.html','<div class=refAdditional style="position: absolute; width: 100%;height: 100%" ng-if="ctrl.additional && ctrl.showAdd"><div class="row valign-middle"><div class="medium-1 columns textPiece textIndex" ng-class="{\'medium-offset-1\': !listePieceCtrl.isUserDms}"></div><div class="medium-1 columns textPiece description"><div class=ref-principal-absolute></div></div><div class="columns designation textPiece" ng-class="listePieceCtrl.isUserDms? \'medium-4\': \'medium-5\'"></div><div class="medium-1 brand"></div><div ng-if=listePieceCtrl.isUserDms ng-class=::listePieceCtrl.getStockClass(reference) class="medium-2 columns textPiece"></div><div class="medium-2 columns textPiece text-center"></div><div class="medium-1 columns estimColumn"></div><div class="medium-1 columns partListColumn"></div></div></div>');
$templateCache.put('app/components/products/documents/pr/centralStockIcon.template.html','<span class=central-stock-icon ng-if=vm.hasData()><span class=central-stock-icon__img ng-if=!vm.isFullMode() ng-style=vm.getIconStyle(vm.piece.centralStock.iconKey)></span><md-tooltip md-direction=top ng-if=!vm.isFullMode() class=central-stock-tooltip style="height: auto !important; max-width: 340px !important; white-space: normal; text-overflow: clip; overflow: visible; line-height: 1.3; padding: 8px 12px !important; background-color: #DEDAD5 !important;"><span class=central-stock-icon__line ng-repeat="line in vm.piece.centralStock.tooltipLines"><span class="central-stock-icon__img central-stock-icon__img--line" ng-if=line.iconKey ng-style=vm.getIconStyle(line.iconKey)></span><span ng-style=vm.getTextStyle(line.iconKey)>{{ vm.getLineText(line) }}</span></span></md-tooltip><span class=central-stock-icon__breakdown ng-if=vm.isFullMode()><span class=central-stock-icon__line ng-repeat="line in vm.piece.centralStock.tooltipLines"><span class="central-stock-icon__img central-stock-icon__img--line" ng-if=line.iconKey ng-style=vm.getIconStyle(line.iconKey)></span><span ng-style=vm.getTextStyle(line.iconKey)>{{ vm.getLineText(line) }}</span></span></span></span>');
$templateCache.put('app/components/products/documents/pr/groupPlates.template.html','<div id=titleAppGroupPlates><span>{{ \'DOCUMENT_PR_APPLICABILITY\'| translate}}</span></div><div ng-repeat="vignette in ctrl.vignettes" id=groupPlatesContainer ng-if=!$root.isIndependentUser><div ng-click=ctrl.selectedPlate(vignette)><img ng-if="vignette.thumbnailUrl && vignette.thumbnailUrl.length" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if=!vignette.thumbnailUrl src=/assets/images/no_image.png alt=""></div><div style="flex: 1"><mtc-line mtc-list=vignette.simplifiedResidual></mtc-line></div><div class=separator></div></div><div ng-repeat="vignette in ctrl.vignettes" id=groupPlatesContainer ng-if="$root.isIndependentUser && $root.asomDocList[\'PR-ILL\']"><div ng-click=ctrl.selectedPlate(vignette)><img ng-if="vignette.thumbnailUrl && vignette.thumbnailUrl.length" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if=!vignette.thumbnailUrl src=/assets/images/no_image.png alt=""></div><div style="flex: 1"><mtc-line mtc-list=vignette.simplifiedResidual></mtc-line></div><div class=separator></div></div><div ng-repeat="vignette in ctrl.vignettes" id=groupPlatesContainer ng-if="$root.isIndependentUser && !$root.asomDocList[\'PR-ILL\']"><div ng-click=ctrl.selectedPlate(vignette) style="border: 1px solid #000;cursor: pointer;"><!-- <img ng-if="vignette.thumbnailUrl && vignette.thumbnailUrl.length" ng-src="{{vignette.thumbnailUrl}}" alt=""/>\n    <img ng-if="!vignette.thumbnailUrl || !vignette.thumbnailUrl" src="/assets/images/no_image.png" alt=""/> --> {{vignette.id}}</div><div style="flex: 1"><mtc-line mtc-list=vignette.simplifiedResidual></mtc-line></div><div class=separator></div></div>');
$templateCache.put('app/components/products/documents/pr/listePiece.template.html','<div ng-controller="ListePieceCtrl as listePieceCtrl" id=listePieceTabView><div ng-if="!listePieceCtrl.loading && !listePieceCtrl.isSearchEngine"><div class="centered-div documents-not_found" ng-if="!listePieceCtrl.checkGroupPlates() && !listePieceCtrl.listOfPieces.length && !listePieceCtrl.isLandscape">{{\'DOCUMENT_NOT_FOUND_ON_PR\' | translate}}</div></div><div ng-if="listePieceCtrl.isLandscape && !listePieceCtrl.isSearchEngine && !listePieceCtrl.checkGroupPlates()"><div class="row plancheRow" style="margin: 0 0;max-width:200%;width: 97% !important;"><div class=col-4><div ng-if="!listePieceCtrl.checkGroupPlates() && !mainCtrl.isIndependentUser" style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: row; align-items: center; left: 60%; position: relative;height:50px;"><div><i class=icon-icons_print_partlist style="font-size: 35px;" ng-click=listePieceCtrl.resetZoom();listePieceCtrl.printSVG(listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].pictureUrl)></i></div><div ng-if=listePieceCtrl.fullOrReducedScreen style="top: 9px; position: relative;"><div ng-click=listePieceCtrl.fullOrReducedScreen() ng-keypress=listePieceCtrl.fullOrReducedScreen($event)><span><p style="position: inherit;" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div style="top: -7px; position: relative;"><span ng-if=!listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(true)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/potraitNew.png alt=""></span><span ng-if=listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(false)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/newLandscape.png alt=""></span><md-tooltip><div ng-show=!listePieceCtrl.isLandscape>Portrait</div><div ng-show=listePieceCtrl.isLandscape>Landscape</div></md-tooltip></div><div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomIn() class="fa fa-plus svg-control-zoom" style="top: 30px; position: relative; left: 2px;"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomOut() style="position: relative; top: 5px; left: 30px;" class="fa fa-minus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.resetZoom() style="position: relative; top: -24px; left: 58px;" class=svg-control-zoom>&#x21BB</i></span></div></div></div><div ng-if="!listePieceCtrl.checkGroupPlates() && mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']" style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: row; align-items: center; left: 60%; position: relative;height:50px;"><div><i class=icon-icons_print_partlist style="font-size: 35px;" ng-click=listePieceCtrl.resetZoom();listePieceCtrl.printSVG(listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].pictureUrl)></i></div><div ng-if=listePieceCtrl.fullOrReducedScreen style="top: 9px; position: relative;"><div ng-click=listePieceCtrl.fullOrReducedScreen() ng-keypress=listePieceCtrl.fullOrReducedScreen($event)><span><p style="position: inherit;" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div style="top: -7px; position: relative;"><span ng-if=!listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(true)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/potraitNew.png alt=""></span><span ng-if=listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(false)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/newLandscape.png alt=""></span><md-tooltip><div ng-show=!listePieceCtrl.isLandscape>Portrait</div><div ng-show=listePieceCtrl.isLandscape>Landscape</div></md-tooltip></div><div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomIn() class="fa fa-plus svg-control-zoom" style="top: 30px; position: relative; left: 2px;"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomOut() style="position: relative; top: 5px; left: 30px;" class="fa fa-minus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.resetZoom() style="position: relative; top: -24px; left: 58px;" class=svg-control-zoom>&#x21BB</i></span></div></div></div><div ng-class=listePieceCtrl.yellowBorder()><group-plates vignettes=listePieceCtrl.currentGroupedPlates() selected-plate=listePieceCtrl.selectedPlateFromGroupPlates ng-if=listePieceCtrl.checkGroupPlates()></group-plates><div resize-pr ng-show="!listePieceCtrl.checkGroupPlates() &&\n                                            listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].thumbnailUrl &&\n                                            listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].thumbnailUrl.length && ( !mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']))" id=divSvgContent class=phx-svg ng-style="{\'margin-right\':listePieceCtrl.isLandscape && listePieceCtrl.isLandscapeZoomed && !listePieceCtrl.isSearchEngine ? \'-12%\' : \'\'}"><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:1200px !important;white-space:normal; margin-left: -35px; margin-top: 3px;" md-direction=top><div>{{\'MOUSE_WHEEL_ZOOM\' | translate}}</div></md-tooltip></div></div><!--plate switch--><div class=plancheNex ng-show=listePieceCtrl.numberOfPlate style="position: relative; right: 1.2rem;"><div ng-switch=listePieceCtrl.checkGroupPlates() class="large-9 columns plancheNextPrev"><span ng-switch-when=true style=vertical-align:top>{{listePieceCtrl.currentPlateStd}} </span><span ng-switch-when=false style=vertical-align:top>{{listePieceCtrl.currentRefCatalogPlanche}}</span> <span ng-click=listePieceCtrl.onPrevPlanche() class="icon-icons_arrow_left arrow_prev_next_planche"></span> <span style=vertical-align:top>{{listePieceCtrl.currentIndexPlate + 1}} / {{listePieceCtrl.maxIndexPlates}} </span><span ng-click=listePieceCtrl.onNextPlanche() class="icon-icons_arrow_right arrow_prev_next_planche"></span></div></div><table style="border: none; width: 600px;"><tr><td style="width: 5%;" class=elementScrollVignette ng-click="listePieceCtrl.HorizontalScrollVignette(\'left\')" ng-mousedown="listePieceCtrl.HorizontalScrollVignette(\'left\')"><i class="icon-icons_arrow_left arrow_prev_next_planche"></i></td><td id=HorizontalScrollVignetteContainer style="overflow-x: auto; overflow-y: hidden; display: -webkit-box; height: 225px; max-width: 525px;"><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if=!mainCtrl.isIndependentUser id=smallImg style=margin-right:20px;width:35%;margin-top:30px;><div ng-attr-id=vignette_{{$index}} ng-click=listePieceCtrl.onVignetteClick(vignette.id,vignette) class="marginVignette clickable" ng-class=listePieceCtrl.isBorderVignette($index)><div class=centreImg><img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if=vignette.thumbnailUrl ng-src={{vignette.thumbnailUrl}} alt=""><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:normal;"><div>{{vignette.id}}</div></md-tooltip><div ng-class=listePieceCtrl.isLineVignette($index)></div></div></div></div><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if="mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']" id=smallImg style=margin-right:20px;width:35%;margin-top:30px;><div ng-attr-id=vignette_{{$index}} ng-click=listePieceCtrl.onVignetteClick(vignette.id,vignette) class="marginVignette clickable" ng-class=listePieceCtrl.isBorderVignette($index)><div class=centreImg><img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} alt=""> <img ng-if=vignette.thumbnailUrl ng-src={{vignette.thumbnailUrl}} alt=""><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:normal;"><div>{{vignette.id}}</div></md-tooltip><div ng-class=listePieceCtrl.isLineVignette($index)></div></div></div></div><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if="mainCtrl.isIndependentUser && !$root.asomDocList[\'PR-ILL\']" id=smallImg style=margin-right:20px;width:35%;margin-top:30px;><div ng-attr-id=vignette_{{$index}} ng-click=listePieceCtrl.onVignetteClick(vignette.id,vignette) class="marginVignette clickable" ng-class=listePieceCtrl.isBorderVignette($index)><div class=centreImg><!--<img ng-if="vignette.groupPlatesStd.length > 1" ng-src="{{vignette.thumbnailUrl}}" alt="" />\n                                        <img ng-if="vignette.groupPlatesStd.length > 1" ng-src="{{vignette.thumbnailUrl}}" alt="" />\n                                        <img ng-src="{{vignette.thumbnailUrl}}" alt="" />\n                                        <md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:900px !important;white-space:normal;">\n                                            <div>\n                                                {{vignette.id}}\n                                            </div>\n                                        </md-tooltip>\n\n                                        <div ng-class="listePieceCtrl.isLineVignette($index)"></div>--><div>{{vignette.id}}</div></div></div></div></td><td style="width: 5%;left: 0.2rem" class=elementScrollVignette ng-click="listePieceCtrl.HorizontalScrollVignette(\'right\')" ng-show=listePieceCtrl.listOfPlate.length ng-mousedown="listePieceCtrl.HorizontalScrollVignette(\'right\')"><i class="icon-icons_arrow_right arrow_prev_next_planche"></i></td></tr></table></div><div class=col-8 style="position: relative;" ng-style="{\'width\':listePieceCtrl.isLandscape && listePieceCtrl.isLandscapeZoomed && !listePieceCtrl.isSearchEngine ? \'51%\' : \'55%\', \'left\':listePieceCtrl.isLandscape && listePieceCtrl.isLandscapeZoomed && !listePieceCtrl.isSearchEngine ? \'6.5%\' : \'2%\'}"><div ng-if="!listePieceCtrl.loading && !listePieceCtrl.isSearchEngine" style=width:100%;><div class="centered-div documents-not_found" ng-if="!listePieceCtrl.checkGroupPlates() && !listePieceCtrl.listOfPieces.length">{{\'DOCUMENT_NOT_FOUND_ON_PR\' | translate}}</div></div><liste-piece-parts></liste-piece-parts></div></div><div class="left underListePiece" ng-if=listePieceCtrl.isHtlAutorised ng-click=listePieceCtrl.openAlertsPopin() style="position: relative;"><i class=icon-icons_probleme_footer></i> {{\'FOOTER_ALERT\'|translate}}</div></div><div ng-if="((!listePieceCtrl.isLandscape || listePieceCtrl.isSearchEngine) || (listePieceCtrl.isLandscape && listePieceCtrl.checkGroupPlates()))"><div class="row plancheRow" ng-if="listePieceCtrl.listOfPlate.length && !listePieceCtrl.isSearchEngine"><div resize-pr container=list class="large-3 columns miniature flexColumn"><div class=elementScrollVignette ng-click="listePieceCtrl.scrollVignette(\'up\')" ng-mousedown="listePieceCtrl.scrollVignette(\'up\')" style="position: relative; z-index: 25; background-color: white;"><i class=icon-icons_arrow_top_vignette_planche></i></div><div style="flex: 1; position: relative"><div class=scrollVignette id=scrollVignetteContainer><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if=!mainCtrl.isIndependentUser><div ng-attr-id=vignette_{{$index}} ng-click="listePieceCtrl.onVignetteClick(vignette.id, vignette)" class="phx-lazy-wrapper marginVignette clickable" ng-class=listePieceCtrl.isBorderVignette($index)><div class=centrage><img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} style="height: 150px; width: 180px; position: absolute; bottom: -20px; right: 50px; z-index: 20" alt=""> <img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} style="height: 150px; width: 180px; position: absolute; bottom: -10px; right: 60px; z-index: 20" alt=""> <img ng-if=vignette.thumbnailUrl ng-src={{vignette.thumbnailUrl}} style="position: relative; z-index: 20" alt=""><div ng-class=listePieceCtrl.isLineVignette($index)></div></div></div></div><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if="mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']"><div ng-attr-id=vignette_{{$index}} ng-click="listePieceCtrl.onVignetteClick(vignette.id, vignette)" class="phx-lazy-wrapper marginVignette clickable" ng-class=listePieceCtrl.isBorderVignette($index)><div class=centrage><img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} style="height: 150px; width: 180px; position: absolute; bottom: -20px; right: 50px; z-index: 20" alt=""> <img ng-if="vignette.thumbnailUrl && vignette.groupPlatesStd.length > 1" ng-src={{vignette.thumbnailUrl}} style="height: 150px; width: 180px; position: absolute; bottom: -10px; right: 60px; z-index: 20" alt=""> <img ng-if=vignette.thumbnailUrl ng-src={{vignette.thumbnailUrl}} style="position: relative; z-index: 20" alt=""><div ng-class=listePieceCtrl.isLineVignette($index)></div></div></div></div><div ng-repeat="vignette in listePieceCtrl.listOfPlate" ng-if="mainCtrl.isIndependentUser && !$root.asomDocList[\'PR-ILL\']"><div ng-attr-id=vignette_{{$index}} ng-click="listePieceCtrl.onVignetteClick(vignette.id, vignette)" class="phx-lazy-wrapper marginVignette clickable" ng-class=listePieceCtrl.isIndependentBorderVignette($index)><div class=centrage><!-- <img ng-if="vignette.groupPlatesStd.length > 1" ng-src="{{vignette.thumbnailUrl}}" style="height: 150px; width: 180px; position: absolute; bottom: -20px; right: 50px; z-index: 20" alt=""/>\n                                        <img ng-if="vignette.groupPlatesStd.length > 1" ng-src="{{vignette.thumbnailUrl}}" style="height: 150px; width: 180px; position: absolute; bottom: -10px; right: 60px; z-index: 20" alt=""/>\n                                        <img ng-src="{{vignette.thumbnailUrl}}" style="position: relative; z-index: 20" alt=""/>\n                                        <div ng-class="listePieceCtrl.isLineVignette($index)"></div> --><div>{{vignette.id}}</div></div></div></div></div></div><div class=elementScrollVignette ng-click="listePieceCtrl.scrollVignette(\'down\')" ng-show=listePieceCtrl.listOfPlate.length ng-mousedown="listePieceCtrl.scrollVignette(\'down\')" style="position: relative; z-index: 25; background-color: white;"><i class=icon-icons_arrow_bottom_vignette_planche></i></div></div><div class="large-9 rows" ng-class=listePieceCtrl.yellowBorder()><group-plates vignettes=listePieceCtrl.currentGroupedPlates() selected-plate=listePieceCtrl.selectedPlateFromGroupPlates ng-if=listePieceCtrl.checkGroupPlates()></group-plates><div resize-pr ng-show="!listePieceCtrl.checkGroupPlates() &&\n                                            listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].thumbnailUrl &&\n                                            listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].thumbnailUrl.length && ( !mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']))" id=divSvgContent class=phx-svg><md-tooltip style="background-color:grey;opacity:1.0;font-size:var(--renaultSmallFont);color:white;border:1.5px solid black;height:auto !important;max-width:1200px !important;white-space:normal; margin-left: -10px; margin-top: 7%;" md-direction=right><div>{{\'MOUSE_WHEEL_ZOOM\' | translate}}</div></md-tooltip></div></div><div ng-if="!listePieceCtrl.checkGroupPlates() && !mainCtrl.isIndependentUser" class=icon-container><div class=iconOnTopRight><i class=icon-icons_print_partlist ng-click=listePieceCtrl.resetZoom();listePieceCtrl.printSVG(listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].pictureUrl)></i></div><div ng-if=listePieceCtrl.fullOrReducedScreen class=svg-control-fullscreen><div ng-click=listePieceCtrl.fullOrReducedScreen() ng-keypress=listePieceCtrl.fullOrReducedScreen($event)><span><p style="position: inherit;" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div><span ng-if=!listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(true)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/potraitNew.png alt=""></span><span ng-if=listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(false)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/newLandscape.png alt=""></span><md-tooltip><div ng-show=!listePieceCtrl.isLandscape>Portrait</div><div ng-show=listePieceCtrl.isLandscape>Landscape</div></md-tooltip></div><div class=svg-control-container style="position: relative; top: 28px;right: -2px;"><div class=center-icon><span><i ng-click=listePieceCtrl.zoomIn() class="fa fa-plus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomOut() style="position: relative; top: 19px;" class="fa fa-minus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.resetZoom() style="position: relative; top: 39px;" class=svg-control-zoom>&#x21BB</i></span></div></div></div><div ng-if="!listePieceCtrl.checkGroupPlates() && mainCtrl.isIndependentUser && $root.asomDocList[\'PR-ILL\']" class=icon-container><div class=iconOnTopRight><i class=icon-icons_print_partlist ng-click=listePieceCtrl.resetZoom();listePieceCtrl.printSVG(listePieceCtrl.listOfPlate[listePieceCtrl.currentIndexPlate].pictureUrl)></i></div><div ng-if=listePieceCtrl.fullOrReducedScreen class=svg-control-fullscreen><div ng-click=listePieceCtrl.fullOrReducedScreen() ng-keypress=listePieceCtrl.fullOrReducedScreen($event)><span><p style="position: inherit;" id=logo class="custom-material-icons material-icons material-icons-fullscreen-svg"></p></span></div></div><div><span ng-if=!listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(true)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/potraitNew.png alt=""></span><span ng-if=listePieceCtrl.isLandscape ng-click=listePieceCtrl.switchLandscape(false)><img style="height: 35px; width: 35px; margin-top: 15px; cursor: pointer !important;" src=./assets/images/newLandscape.png alt=""></span><md-tooltip><div ng-show=!listePieceCtrl.isLandscape>Portrait</div><div ng-show=listePieceCtrl.isLandscape>Landscape</div></md-tooltip></div><div class=svg-control-container style="position: relative; top: 28px;right: -2px;"><div class=center-icon><span><i ng-click=listePieceCtrl.zoomIn() class="fa fa-plus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.zoomOut() style="position: relative; top: 19px;" class="fa fa-minus svg-control-zoom"></i></span></div><div class=center-icon><span><i ng-click=listePieceCtrl.resetZoom() style="position: relative; top: 39px;" class=svg-control-zoom>&#x21BB</i></span></div></div></div></div><!--plate switch--><div class="row plancheNex" ng-show=listePieceCtrl.numberOfPlate><div ng-switch=listePieceCtrl.checkGroupPlates() class="large-9 columns plancheNextPrev"><span ng-switch-when=true style=vertical-align:top>{{listePieceCtrl.currentPlateStd}} </span><span ng-switch-when=false style=vertical-align:top>{{listePieceCtrl.currentRefCatalogPlanche}}</span> <span ng-click=listePieceCtrl.onPrevPlanche() class="icon-icons_arrow_left arrow_prev_next_planche"></span> <span style=vertical-align:top>{{listePieceCtrl.currentIndexPlate + 1}} / {{listePieceCtrl.maxIndexPlates}} </span><span ng-click=listePieceCtrl.onNextPlanche() class="icon-icons_arrow_right arrow_prev_next_planche"></span></div></div><div ng-if="listePieceCtrl.isSearchEngine && listePieceCtrl.listOfPieces.length > 0"><p class=document-result translate=DOCUMENT_RESULT translate-values="{count:listePieceCtrl.listOfPieces.length,filter:listePieceCtrl.inputFilterText,docType:\'PR\'}"></p><div style="display: flex; align-items: center; justify-content: space-between;"><md-input-container><md-select style="width: 250px; font-size: var(--renaultMediumFont);" name=selectedTechnicalFamily ng-model=listePieceCtrl.technicalFamilyList.familyCodeLabel ng-change=listePieceCtrl.onSelectTechnicalFamily(listePieceCtrl.technicalFamilyList.familyCodeLabel)><span ng-repeat="technicalFamily in listePieceCtrl.technicalFamilyList"><md-option ng-value=allResults ng-if="technicalFamily.familyCode === \'001\'" ng-model=listePieceCtrl.technicalFamilyList.familyCodeLabel>{{technicalFamily.familyCodeLabel}}</md-option><md-option ng-value=technicalFamily ng-if="technicalFamily.familyCode !== \'001\'"><span ng-if="technicalFamily.familyCodeLabel === \'NA\'">{{\'NO_DATA\' | translate }} {{ " / " + technicalFamily.familyCode }} </span><span ng-if="technicalFamily.familyCodeLabel !== \'NA\' && technicalFamily.familyCode !== \'001\'">{{technicalFamily.familyCodeLabel + " / " + technicalFamily.familyCode}}</span></md-option></span></md-select></md-input-container><div style="display: flex; align-items: center; gap: 8px;"><span>{{ listePieceCtrl.isShowCatalogue ? \'Show catalogue\' : \'Hide catalogue\' }}</span><md-switch ng-model=listePieceCtrl.isShowCatalogue aria-label="Hide catalogue" ng-change=listePieceCtrl.updateCatalogue(listePieceCtrl.isShowCatalogue)></md-switch></div></div></div><!--parts table--><div ng-if=listePieceCtrl.isSearchEngine><liste-piece-search-parts></liste-piece-search-parts></div><div ng-if=!listePieceCtrl.isSearchEngine><liste-piece-parts></liste-piece-parts></div><div class="left underListePiece" ng-if=listePieceCtrl.isHtlAutorised ng-click=listePieceCtrl.openAlertsPopin() style="position: relative;"><i class=icon-icons_probleme_footer></i> {{\'FOOTER_ALERT\'|translate}}</div><scroll-up scroll-trigger=300 scroll-anchor=#listePiece></scroll-up><div><i class="fas fa-stopwatch"></i></div></div></div>');
$templateCache.put('app/components/products/documents/pr/listePieceParts.template.html','<div class=listPiece ng-if=!listePieceCtrl.checkGroupPlates() ng-show=listePieceCtrl.listOfPieces.length><!-- Header --><div class="row valign-middle header-row"><div class="medium-1 columns">&nbsp;</div><div class="medium-1 columns padding-left-7" ng-style="{\'left\':listePieceCtrl.isSearchEngine && listePieceCtrl.isLandscape ? \'2.5%\' : \'0%\'}">{{\'VIEWED_DOC_REF\'|translate}}</div><div class=columns ng-style="{\'left\':listePieceCtrl.isLandscape ? \'3%\' : \'4%\'}" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }">{{\'COMMON_DESIGNATION\'|translate}}</div><div class="medium-1 columns"><span ng-if=listePieceCtrl.isCentralStockPilot>{{\'DOCUMENT_PR_STOCK_HEADER\'|translate}} </span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms">{{\'COMMON_STOCK\'|translate}}</span></div><div class="medium-1 columns"><span ng-if=listePieceCtrl.isUserDms>{{\'LOCKER\'|translate}}</span></div><div class="medium-1 columns"><div ng-if="!listePieceCtrl.isLoadingDMSData && !mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && \n                        (!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && \n                        listePieceCtrl.isAsomValidDocAccess === \'true\' && $root.asomDocList.PX)) && \n                        !mainCtrl.isHorseUser"><span ng-if=listePieceCtrl.isLandscape>{{vm.currency}}</span> <span ng-if=!listePieceCtrl.isLandscape>{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</span><md-tooltip ng-show=listePieceCtrl.isLandscape>{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</md-tooltip></div></div><div class="medium-1 columns">&nbsp;</div><div class="medium-2 columns">&nbsp;</div></div><div class="row valign-middle header-row switchRow"><div class="medium-1 columns"></div><div class="medium-1 columns padding-left-7" ng-style="{\'left\':listePieceCtrl.isSearchEngine && listePieceCtrl.isLandscape ? \'2.5%\' : \'0%\'}"><md-switch ng-change=listePieceCtrl.switchPRFormat(vm.isPRFormat) ng-model=vm.isPRFormat class=prFormatSwitch title="{{\'SHOW_HIDE_PR_FORMAT\' | translate}}"></md-switch></div><div class=columns ng-style="{\'left\':listePieceCtrl.isLandscape ? \'3%\' : \'4%\'}" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }"></div><div class="medium-1 columns"></div><div class="medium-1 columns"></div><div class="medium-1 columns"></div><div class="medium-1 columns"></div><div class="medium-2 columns"></div></div><!-- Parts list --><div id={{piece.index}} class="row-bloc row" ng-init="piecePrincipal=piece; optionsN1 = {mainPart: piece}" ng-repeat="piece in listePieceCtrl.listOfPieces | orderBy:[\'index\']" tabindex=-1><!-- Main part --><div class="row valign-middle" id={{piece.reference}}><div class="medium-1 columns textPiece showPointer"><div class="div-inline unfold"><i ng-click=listePieceCtrl.showHideAdd(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.showHideAdd(piece)" ng-if="piece.additional && piece.additional.length > 0" ng-class="{\'icon-icons-phnx-expendable_plus\':!piece.showAdd,\'icon-icons-phnx-exependable_moins\':piece.showAdd}"></i></div><div ng-click=listePieceCtrl.gotoSvg(piece.index) ng-keydown="$event.keyCode === 13 && listePieceCtrl.gotoSvg(piece.index)" class="textIndex-div margin-left-25">{{::piece.index}}</div></div><div class="medium-1 columns textPiece showPointer underLineRef white-space" ng-style="{\'padding-left\':listePieceCtrl.isUserDms ? \'5px\' : \'1px\'}"><span ng-click=listePieceCtrl.goToProduct(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(piece)">{{piece.reference | filterFormatRef}} </span><i class="fa fa-files-o copy-icon" aria-hidden=true title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(piece.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.copyToClipboard(piece.reference)"></i></div><div class="columns textPiece designation designation-spacing" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }"><div rank="{{::piece.rank}} _{{::piece.brand}}" ng-click=listePieceCtrl.goToProduct(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(piece)" class=textDesignation>{{piece.designation}}</div><div class="icons icons-positioned"><a ng-if="piece.replacement || piece.dmsInformations.supersedingPart" ng-click="listePieceCtrl.goToProduct(piece, \'replacement\')"><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=piece.supersedingPart class=icon-icons_chaine_remplacement_locale_listPiece></span> <span ng-if=piece.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span class=hercules-icon-container ng-if="piece.displayPicto && piece.herculesCase == \'CASE1:HOLE\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt=""><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span class=hercules-icon-container ng-if="piece.displayPicto && piece.herculesCase == \'CASE2: DUALITY\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Duality.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span class=hercules-icon-container ng-if="piece.displayPicto && piece.herculesCase == \'CASE3: NEW PROPOSAL\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/NewHercule.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span class=hercules-icon-container ng-if="piece.displayPicto && piece.herculesCase == \'CASE4: SAME PROPOSAL\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/SameHercule.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span class=hercules-icon-container ng-if="piece.displayPicto && piece.herculesCase == \'CASE5: PROPOSAL DECLINED\' && (!mainCtrl.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Declined.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span><span ng-if=piece.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=piece.memo class=icon-icons_memo_it_listePiece></span> <span ng-if=piece.isKit class=icon-icons_kit ng-click=listePieceCtrl.goToProduct(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(piece)"><md-tooltip md-direction=bottom class=margin-top-3>{{ \'PRODUCT_KITS_COLLECTION\' | translate }}</md-tooltip></span><picto-list equivalent-types=piece.types family-code=piece.familyCode></picto-list></div></div><div class="medium-1 columns textPiece" ng-class="listePieceCtrl.getStockCellClass(piece.dmsInformations.quantity, \'left-2\')"><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=piece></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=piece.dmsInformations.quantity><span>{{piece.dmsInformations.quantity}}</span></phenix-is-number></span><span ng-if="(listePieceCtrl.isUserDms || listePieceCtrl.isCentralStockPilot) && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece"><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece" ng-style="{\'width\':listePieceCtrl.isLandscape? \'10%\' : \'\'}"><span ng-if="!listePieceCtrl.isLoadingDMSData && \n                            !mainCtrl.isCountryChina && \n                            !mainCtrl.isCountryIndia && \n                            (!mainCtrl.isIndependentUser || \n                            (mainCtrl.isIndependentUser && \n                            listePieceCtrl.isAsomValidDocAccess === \'true\' && \n                            $root.asomDocList.PX)) && \n                            !mainCtrl.isHorseUser">{{getPriceToDisplay(piece)}} <span><span ng-if="getPriceToCheck(piece) >0 && \n                                     getPriceToCheck(piece) != null && \n                                     getPriceToCheck(piece) != undefined">{{listePieceCtrl.getCurrencyForItem(piece)}} </span><span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || \n                                      getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && \n                                      listePieceCtrl.isCountrySparc && listePieceCtrl.frCountry != \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span> <span ng-if="((getPriceToCheck(piece) === 0 || \n                                      getPriceToCheck(piece) === null || \n                                      getPriceToCheck(piece) === undefined || \n                                      getPriceToCheck(piece) === \'-\') && \n                                      listePieceCtrl.frCountry === \'FR\')" class=priceNotAvailable>{{\'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></span></span></div><div class="medium-1 columns textPiece" ng-style="{\'padding-right\':listePieceCtrl.isLoadingPrMrLink ? \'9%\' : \'\'}"><span ng-if="!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList.TM)" class=margin-right-15><div ng-style="{\'cursor\': \'default !important\', \'margin-right\': \'20%\', \'color\': \'Gainsboro\', \n                                    \'visibility\': piece.hideGrayPictoWhenEmpty ? \'hidden\' : \'visible\'}" ng-if="piece.docIds && piece.docIds.length == 0 && \n                                 !listePieceCtrl.isLoadingPrTmLink && \n                                 listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-clock-o fa-2x font-20"></i><md-tooltip md-direction=right class=custom-tooltip>{{ \'REFER_TO_TM_TAB\' | translate }}</md-tooltip></div><div class="tmlink margin-right-20" ng-if="piece.docIds && piece.docIds.length > 0 && \n                                !listePieceCtrl.isLoadingPrTmLink && \n                                listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-clock-o fa-2x font-20" ng-click=listePieceCtrl.gotoPrTmLink(piece.docIds,piece.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.gotoPrTmLink(piece.docIds,piece.reference)"></i><md-tooltip md-direction=right class=custom-tooltip>{{\'CONSULT_TM_DESCRIPTION\'| translate}}</md-tooltip></div><div ng-if=listePieceCtrl.isLoadingPrMrLink><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'TM_LOADING_DATA\' |translate }}</div></span><span ng-if="!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList.MR)"><div ng-style="{\'color\': \'Gainsboro\', \'cursor\': \'default !important\', \n                                    \'visibility\': piece.hideMrGrayPictoWhenEmpty ? \'hidden\' : \'visible\'}" ng-if="piece.MRdocIds && piece.MRdocIds.length == 0 && \n                                !listePieceCtrl.isLoadingPrMrLink && \n                                listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-file-text fa-2x font-20"></i><md-tooltip md-direction=right class=custom-tooltip>{{ \'REFER_TO_MR_TAB\' | translate }}</md-tooltip></div><div class=tmlink ng-if="piece.MRdocIds && piece.MRdocIds.length > 0 && \n                                !listePieceCtrl.isLoadingPrMrLink && \n                                listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-file-text fa-2x font-20" ng-click=listePieceCtrl.gotoPrMrLink(piece.MRdocIds,piece.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.gotoPrMrLink(piece.MRdocIds,piece.reference)"></i><md-tooltip md-direction=right class=custom-tooltip>{{\'CONSULT_MR_DESCRIPTION\'| translate}}</md-tooltip></div><div ng-if=listePieceCtrl.isLoadingPrMrLink><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'MR_LOADING_DATA\' |translate }}</div></span></div><div class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=piece from=PR></shopping-cart></div></div><div class="medium-2 columns" ng-if=listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class="switchButton switch-button-spacing"><shopping-cart-quote piece=piece icon=estimate from=PR landscape=listePieceCtrl.isLandscape></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition from=PR piece=piece landscape=listePieceCtrl.isLandscape options=optionsN1></shopping-cart-parts-requisition></div></div></div><!-- =====   Residual applicability of the main reference   ===== --><div ng-if=piece.showComplementaryInfo class="applicability row applicability-positioning"><div class="medium-10 medium-offset-1 columns containerApplicability applicability-container" ng-class="{\'dms-padding\': listePieceCtrl.isUserDms, \'standard-padding\': !listePieceCtrl.isUserDms}"><div ng-click=listePieceCtrl.showHideAppl(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.showHideAppl(piece)" class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!piece.showAppl,\n                                      \'icon-icons_arrow_dropdown\':piece.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=piece.showAppl class=full-width-extended><mtc-line codified-signs=piece.codifiedSigns mtc-list=piece.simplifiedResidual></mtc-line></div><additional-line show-add=piece.showAdd additional=piece.additional></div></div><!-- ================   Additional References   ===================== --><div class=refAdditional ng-if="piece.additional && piece.showAdd"><div ng-repeat="reference in piece.additional"><div class="row valign-middle margin-top-10"><div class="medium-1 columns textPiece"></div><div class="medium-1 columns textPiece showPointer underLineRef white-space"><span ng-click="listePieceCtrl.goToProduct(reference, piece)" ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(reference, piece)" ng-class="listePieceCtrl.isUserDms? \'ref-additional-absolute \': \'ref-add-absolute\'">{{reference.reference | filterFormatRef}} </span><i class="fa fa-files-o copy-icon-additional" aria-hidden=true title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(reference.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.copyToClipboard(reference.reference)"></i></div><div class="columns textPiece designation" ng-style="{\'left\':listePieceCtrl.isLandscape ? \'6.5%\' : \'\'}" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }" ng-click=listePieceCtrl.goToProduct(reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(reference)"><div class=textDesignation>{{::reference.designation}}</div><div class=icons><a ng-if=reference.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}pp</md-tooltip></a><span ng-if=reference.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=reference.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=reference.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=reference.equivalentTypes family-code=reference.familyCode></picto-list></div></div><div class="medium-1 columns textPiece" ng-class="listePieceCtrl.getStockCellClass(reference.dmsInformations.quantity, \'left-2\')"><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=reference></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=reference.dmsInformations.quantity is-additional="piece.additional && piece.showAdd"><span>{{reference.dmsInformations.quantity}}</span></phenix-is-number></span><span ng-if="(listePieceCtrl.isUserDms || listePieceCtrl.isCentralStockPilot) && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece"><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece" ng-style="{\'width\':listePieceCtrl.isLandscape ? \'10%\' : \'\'}"><span ng-if="!listePieceCtrl.isLoadingDMSData && \n                                     !mainCtrl.isCountryChina && \n                                     !mainCtrl.isCountryIndia && \n                                     (!mainCtrl.isIndependentUser || \n                                     (mainCtrl.isIndependentUser && \n                                     listePieceCtrl.isAsomValidDocAccess === \'true\' && \n                                     $root.asomDocList.PX)) && \n                                     !mainCtrl.isHorseUser">{{getPriceToDisplay(reference)}} <span><span ng-if="getPriceToCheck(piece) >0 && \n                                             getPriceToCheck(piece) != null && \n                                             getPriceToCheck(piece) != undefined">{{listePieceCtrl.getCurrencyForItem(reference)}} </span><span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></span></span></div><div class="medium-1 columns textPiece">&nbsp;</div><div class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=reference main-piece=piece from=PR type=PPS></shopping-cart></div></div><div class="medium-2 columns" ng-if=listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class="switchButton switch-button-spacing"><shopping-cart-quote piece=reference main-piece=piece icon=estimate from=PR landscape=listePieceCtrl.isLandscape type=PPS></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition options=optionsN1 piece=reference landscape="listePieceCtrl.isLandscape " main-piece=piece from=PR type=PPS></shopping-cart-parts-requisition></div></div></div><div ng-if=reference.showAdditionalComplementaryInfo class="applicability row applicability-positioning"><div class="medium-10 medium-offset-2 columns containerApplicability applicability-container"><div classs=margin-left-30><div ng-click=listePieceCtrl.displayPPSApplicabilities(piece.additional) ng-keydown="$event.keyCode === 13 && listePieceCtrl.displayPPSApplicabilities(piece.additional)" class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!reference.displayPPS,\n                                                  \'icon-icons_arrow_dropdown\':reference.displayPPS}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=reference.displayPPS><mtc-line codified-signs=reference.codifiedSigns mtc-list=reference.simplifiedResidual></mtc-line></div></div></div><additional-line ng-if=!$last show-add=piece additional=piece></div></div></div><!-- alternative part --><div class=alternative ng-class="{\'displayNone\':!piece.alternative}"><div class="alternative-row row" ng-repeat="piece in piece.alternative" ng-init="optionsN2 = {mainPart: piece}" ng-class="[piece.brand ? \'\':\'displayNone\']"><div class=separator></div><div class="row valign-middle"><div class="medium-1 columns textPiece showPointer"><div class="div-inline unfold"><i ng-click=listePieceCtrl.showHideAdd(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.showHideAdd(piece)" ng-class="{\'icon-icons-phnx-expendable_plus\':!piece.showAdd,\n                                          \'icon-icons-phnx-exependable_moins\':piece.showAdd, \n                                          \'noVisibility\': !piece.additional || piece.additional.length == 0}"></i></div></div><div class="medium-1 columns textPiece showPointer underLineRef white-space" ng-style="{\'padding-left\':listePieceCtrl.isUserDms ? \'5px\' : \'1px\'}"><span ng-click=listePieceCtrl.goToProduct(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(piece)">{{piece.reference | filterFormatRef}} </span><i class="fa fa-files-o copy-icon-alt" aria-hidden=true title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(piece.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.copyToClipboard(piece.reference)"></i></div><div class="columns textPiece designation designation-spacing" ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'25px\' : \'\'}" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }"><div class=textDesignation rank="{{::piece.rank}} _{{::piece.brand}}" ng-click=listePieceCtrl.goToProduct(piece) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(piece)">{{piece.designation}}</div><div class="icons icons-positioned"><a ng-if="piece.replacement || piece.dmsInformations.supersedingPart" ng-click="listePieceCtrl.goToProduct(piece, \'replacement\')"><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=piece.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=piece.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=piece.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=piece.equivalentTypes family-code=piece.familyCode></picto-list></div></div><div class="medium-1 columns textPiece" ng-class="listePieceCtrl.getStockCellClass(piece.dmsInformations.quantity, \'left-2\')"><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=piece></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=piece.dmsInformations.quantity is-alter-native=piece.alternative><span>{{piece.dmsInformations.quantity}}</span></phenix-is-number></span><span ng-if="(listePieceCtrl.isUserDms || listePieceCtrl.isCentralStockPilot) && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece"><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece" ng-style="{\'width\':listePieceCtrl.isLandscape ? \'10%\' : \'\'}"><span ng-if="!listePieceCtrl.isLoadingDMSData && \n                                     !mainCtrl.isCountryChina && \n                                     !mainCtrl.isCountryIndia && \n                                     (!mainCtrl.isIndependentUser || \n                                     (mainCtrl.isIndependentUser && \n                                     listePieceCtrl.isAsomValidDocAccess === \'true\' && \n                                     $root.asomDocList.PX)) && \n                                     !mainCtrl.isHorseUser">{{getPriceToDisplay(piece)}} <span><span ng-if="getPriceToCheck(piece) >0 && \n                                             getPriceToCheck(piece) != null && \n                                             getPriceToCheck(piece) != undefined">{{listePieceCtrl.getCurrencyForItem(piece)}} </span><span ng-if="((getPriceToCheck(piece) === 0 || \n                                              getPriceToCheck(piece) === null || \n                                              getPriceToCheck(piece) === undefined || \n                                              getPriceToCheck(piece) === \'-\') && \n                                              listePieceCtrl.isCountrySparc && \n                                              listePieceCtrl.frCountry != \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span> <span ng-if="((getPriceToCheck(piece) === 0 \n                                || getPriceToCheck(piece) === null \n                                || getPriceToCheck(piece) === undefined \n                                || getPriceToCheck(piece) === \'-\') \n                                && listePieceCtrl.frCountry === \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></span></span></div><div class="medium-1 columns textPiece">&nbsp;</div><div class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=piece from=PR></shopping-cart></div></div><div class="medium-2 columns" ng-if=listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class="switchButton switch-button-spacing"><shopping-cart-quote piece=piece icon=estimate from=PR landscape=listePieceCtrl.isLandscape></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition from=PR piece=piece landscape=listePieceCtrl.isLandscape options=optionsN1></shopping-cart-parts-requisition></div></div></div><!-- ==============   Residual Applicability   ================= --><div class="applicability position-relative" ng-if=piece.showAlternativeComplementaryInfo><div class=row><div class="medium-10 medium-offset-2 columns containerApplicability applicability-container"><div ng-click=listePieceCtrl.showHideAppl(piecePrincipal) ng-keydown="$event.keyCode === 13 && listePieceCtrl.showHideAppl(piecePrincipal)" class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!piece.showAppl,\n                                                  \'icon-icons_arrow_dropdown\':piece.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=piece.showAppl class=full-width-extended-109><mtc-line codified-signs=piece.codifiedSigns mtc-list=piece.simplifiedResidual></mtc-line></div></div><additional-line show-add=piece.showAdd additional=piece.additional></div></div><!-- =================   Additonal References   =================== --><div class=refAdditional ng-if="piece.additional && piece.showAdd"><div ng-repeat="reference in piece.additional"><div class="row valign-middle margin-top-10"><div class="medium-1 columns textPiece"></div><div class="medium-1 columns textPiece underLineRef white-space"><span ng-click=listePieceCtrl.goToProduct(reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.goToProduct(reference)" ng-class="listePieceCtrl.isUserDms? \'ref-additional-absolute \': \'ref-add-absolute\'">{{::reference.reference | filterFormatRef}} </span><i class="fa fa-files-o copy-icon-alternative-ref" aria-hidden=true title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(reference.reference) ng-keydown="$event.keyCode === 13 && listePieceCtrl.copyToClipboard(reference.reference)"></i></div><div class="columns textPiece designation designation-spacing" ng-style="{\'left\':listePieceCtrl.isLandscape ? \'6.5%\' : \'\'}" ng-class="{\'medium-3\': listePieceCtrl.isLandscape , \'medium-4\': !listePieceCtrl.isLandscape }"><div class=textDesignation>{{::reference.designation}}</div><div class=icons><a ng-if=reference.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}pp</md-tooltip></a><span ng-if=reference.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=reference.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=reference.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=reference.equivalentTypes family-code=reference.familyCode></picto-list></div></div><div class="medium-1 columns textPiece" ng-class="listePieceCtrl.getStockCellClass(reference.dmsInformations.quantity, \'left-2\')"><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=reference></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=reference.dmsInformations.quantity is-additional="piece.additional && piece.showAdd"><span>{{reference.dmsInformations.quantity}}</span></phenix-is-number></span></div><div class="medium-1 columns textPiece"><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}} </span><span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</span></div><div class="medium-1 columns textPiece" ng-style="{\'width\':listePieceCtrl.isLandscape ? \'10%\' : \'\'}"><span ng-if="!listePieceCtrl.isLoadingDMSData && \n                                             !mainCtrl.isCountryChina && \n                                             !mainCtrl.isCountryIndia && \n                                             (!mainCtrl.isIndependentUser || \n                                             (mainCtrl.isIndependentUser && \n                                             $root.asomDocList.PX)) && \n                                             !mainCtrl.isHorseUser">{{getPriceToDisplay(reference)}} <span><span ng-if="getPriceToCheck(reference) >0 && \n                                                     getPriceToCheck(reference) != null && \n                                                     getPriceToCheck(reference) != undefined">{{listePieceCtrl.getCurrencyForItem(reference)}} </span><span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></span></span></div><div class="medium-1 columns textPiece">&nbsp;</div><div class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=reference main-piece=piece from=PR type=PPS></shopping-cart></div></div><div class="medium-2 columns" ng-if=listePieceCtrl.isUserDms ng-style="{\'padding-left\':listePieceCtrl.isLandscape ? \'6%\' : \'3%\'}"><div class="switchButton switch-button-spacing"><shopping-cart-quote piece=reference main-piece=piece icon=estimate landscape=listePieceCtrl.isLandscape from=PR type=PPS></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition options=optionsN2 piece=reference landscape=listePieceCtrl.isLandscape main-piece=piece from=PR type=PPS></shopping-cart-parts-requisition></div></div></div><div ng-if=reference.showAltAdditionalComplementaryInfo class="applicability row applicability-positioning"><div class="medium-10 medium-offset-2 columns containerApplicability applicability-container"><div class=margin-left-30><div ng-click=listePieceCtrl.displayPPSApplicabilities(piece.additional) ng-keydown="$event.keyCode === 13 && listePieceCtrl.displayPPSApplicabilities(piece.additional)" class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!reference.displayPPS,\n                                                          \'icon-icons_arrow_dropdown\':reference.displayPPS}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=reference.displayPPS><mtc-line codified-signs=reference.codifiedSigns mtc-list=reference.simplifiedResidual></mtc-line></div></div></div><additional-line ng-if=!$last show-add=piece additional=piece></div></div></div></div></div></div></div>');
$templateCache.put('app/components/products/documents/pr/listePieceSearchParts.template.html','<table class=listPieceSearchTable ng-if=!listePieceCtrl.checkGroupPlates() ng-show=listePieceCtrl.listOfPieces.length style="width:95%; border: none;"><thead><tr class="header-row row" style="border-bottom: 1px solid #dcdada;"><td class="medium-1 columns" style="word-break: break-word; font-size: small;">{{\'CATALOG_PLATE\'|translate}}</td><td class="medium-1 columns">&nbsp;</td><td class="medium-1 columns" style="padding-left: 7px;">{{\'VIEWED_DOC_REF\'|translate}}</td><td class="columns medium-3" style=left:auto>{{\'COMMON_DESIGNATION\'|translate}}</td><td class="medium-1 columns"><span ng-if=listePieceCtrl.isCentralStockPilot>{{\'DOCUMENT_PR_STOCK_HEADER\'|translate}}</span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms">{{\'COMMON_STOCK\'|translate}}</span></td><td class="medium-1 columns"><span ng-if=listePieceCtrl.isUserDms>{{\'LOCKER\'|translate}}</span></td><td class="medium-1 columns"><div ng-if="!listePieceCtrl.isLoadingDMSData && !mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && \n                           (!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && \n                           listePieceCtrl.isAsomValidDocAccess === \'true\' && $root.asomDocList.PX)) && \n                           !mainCtrl.isHorseUser"><span>{{\'COMMON_COLUMN_PUBHT_TITLE\'|translate}}</span></div></td><td class="medium-1 columns">&nbsp;</td><td class="medium-2 columns">&nbsp;</td></tr></thead><tbody><tr ng-repeat="group in listePieceCtrl.groupedByPlateArray" ng-if="listePieceCtrl.groupedByPlateArray.length>0" class=group-row><td class="medium-1 columns textPiece designation catalog-plate-cell" ng-if=!listePieceCtrl.isLoadingDMSData rowspan={{group.pieces.length}}><span ng-click=listePieceCtrl.gotoCatalogPlate(group.piece) class="textDesignation plateTooltip" style="cursor: pointer;"><div style="height:100px;width:100px;margin:auto;border:1px solid #ccc;\n                            display:flex;align-items:center;justify-content:center;\n                            position:relative;background:#fff;" ng-if=listePieceCtrl.isShowCatalogue><div class=thumb-ph ng-if=!group.piece.catalogPlates[0].thumbnail style=position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;>No Illustration</div><!-- Real image (hidden on error) --> <img ng-if="listePieceCtrl.isShowCatalogue && group.piece.catalogPlates[0].thumbnail" ng-src={{group.piece.catalogPlates[0].thumbnail}} alt="" style=max-width:100%;max-height:100%;display:block; onerror="this.style.display=\'none\';\n                                      var p=this.parentNode.querySelector(\'.thumb-ph\');\n                                      if(p){ p.style.display=\'flex\'; }"></div>{{group.plate}} <span id=plateTooltipId class=plateTooltipText ng-if="(!listePieceCtrl.isShowCatalogue) && (!($root.isIndependentUser) || $root.asomDocList[\'PR-ILL\'])"><img style="height:180px;width: 200px;" ng-src={{group.piece.catalogPlates[0].thumbnail}} alt=""> </span></span><span ng-if="!listePieceCtrl.isLoadingDMSData && \n                           (piece.replacement || piece.dmsInformations.supersedingPart) && \n                           !piece.catalogPlate"><span>_</span></span></td><td class="medium-11 columns textPiece"><table style=width:100%;border:none;><tbody><tr ng-repeat="piece in group.pieces | orderBy:[\'index\']" id={{piece.index}} ng-if="group.pieces.length>0" ng-init="piecePrincipal=piece; optionsN1 = {mainPart: piece}" style="background-color: transparent!important;"><td class="medium-1 columns" style="left: 5%;"><div class="div-inline unfold"><i ng-click=listePieceCtrl.showHideAdd(piece) ng-keypress="$event.keyCode === 13 && listePieceCtrl.showHideAdd(piece)" ng-if="piece.additional && piece.additional.length > 0" ng-class="{\'icon-icons-phnx-expendable_plus\':!piece.showAdd,\n                                                   \'icon-icons-phnx-exependable_moins\':piece.showAdd}"></i></div></td><td class="medium-1 columns textPiece showPointer underLineRef white-space" ng-style="{\'padding-left\':listePieceCtrl.isUserDms ? \'5px\' : \'1px\'}" style="display: flex;"><span ng-click=listePieceCtrl.goToProduct(piece)>{{piece.reference | filterFormatRef}}</span> <i class="fa fa-files-o copy-icon" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(piece.reference) ng-keypress="$event.keyCode === 13 && listePieceCtrl.copyToClipboard(piece.reference)"></i></td><td class="columns textPiece designation medium-3" style="padding-left: 25px; left:auto; display: flex; cursor: pointer;"><div rank="{{::piece.rank}} _{{::piece.brand}}" ng-click=listePieceCtrl.goToProduct(piece) class=textDesignation>{{piece.designation}}</div><div class=icons style="display: flex;"><a ng-if="piece.replacement || piece.dmsInformations.supersedingPart" style="padding-right: 15%;" ng-click="listePieceCtrl.goToProduct(piece, \'replacement\')"><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=piece.supersedingPart class=icon-icons_chaine_remplacement_locale_listPiece></span> <span ng-if=piece.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span style="display: inline-block; max-width: 19px; min-width: 19px; height: 19px;" ng-if="piece.displayPicto && piece.herculesCase == \'CASE1:HOLE\' && (!$root.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Hole.png class=margin-bottom-10 height=18 width=19 alt="" style="position: relative; left: 21%;"><md-tooltip>{{\'HERCULES_HOLE\' |translate}}</md-tooltip></span><span style="display: inline-block; max-width: 19px; min-width: 19px; height: 19px;" ng-if="piece.displayPicto && piece.herculesCase == \'CASE2: DUALITY\' && (!$root.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Duality.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_DUALITY\' |translate}}</md-tooltip></span><span style="display: inline-block; max-width: 19px; min-width: 19px; height: 19px;" ng-if="piece.displayPicto && piece.herculesCase == \'CASE3: NEW PROPOSAL\' && (!$root.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/NewHercule.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_NEW\' |translate}}</md-tooltip></span><span style="display: inline-block; max-width: 19px; min-width: 19px; height: 19px;" ng-if="piece.displayPicto && piece.herculesCase == \'CASE4: SAME PROPOSAL\' && (!$root.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/SameHercule.png class=margin-bottom-10 alt="" style="position: relative;left: 21%;"><md-tooltip>{{\'HERCULES_SAME\' |translate}}</md-tooltip></span><span style="display: inline-block; max-width: 19px; min-width: 19px; height: 19px;" ng-if="piece.displayPicto && piece.herculesCase == \'CASE5: PROPOSAL DECLINED\' && (!$root.isIndependentUser || $root.asomDocList[\'PR-HERCULES\'])"><img src=./assets/images/Declined.png class=margin-bottom-10 alt=""><md-tooltip>{{\'HERCULES_DECLINED\' |translate}}</md-tooltip></span><span ng-if=piece.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt="" style="position: relative; left: 41%;"><md-tooltip>Reach</md-tooltip></span><span ng-if=piece.memo class=icon-icons_memo_it_listePiece></span> <span ng-if=piece.isKit class=icon-icons_kit ng-click=listePieceCtrl.goToProduct(piece)><md-tooltip md-direction=bottom style="margin-top: 3px;">{{\'PRODUCT_KITS_COLLECTION\' | translate}}</md-tooltip></span><picto-list equivalent-types=piece.equivalentTypes family-code=piece.familyCode></picto-list></div></td><td class="medium-1 columns textPiece" ng-class=listePieceCtrl.getStockCellClass(piece.dmsInformations.quantity) style=left:5%;><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=piece></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=piece.dmsInformations.quantity><span>{{piece.dmsInformations.quantity}}</span></phenix-is-number></span><span ng-if="(listePieceCtrl.isUserDms || listePieceCtrl.isCentralStockPilot) && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</span></td><td class="medium-1 columns textPiece" style=left:4%;><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</span></td><td class="medium-1 columns textPiece left-6"><span ng-if="!listePieceCtrl.isLoadingDMSData && !mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && (!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && listePieceCtrl.isAsomValidDocAccess === \'true\' && $root.asomDocList.PX)) && !mainCtrl.isHorseUser">{{getPriceToDisplay(piece)}} <span><span ng-if="getPriceToCheck(piece) >0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined">{{listePieceCtrl.getCurrencyForItem(piece)}}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && listePieceCtrl.isCountrySparc && listePieceCtrl.frCountry != \'FR\')" class=priceNotAvailable>{{ \'PRICE_UNAVAILABLE\' | translate }}</span> <span ng-if="((getPriceToCheck(piece) === 0 || getPriceToCheck(piece) === null || getPriceToCheck(piece) === undefined || getPriceToCheck(piece) === \'-\') && listePieceCtrl.frCountry === \'FR\')" class=priceNotAvailable>{{\'PRICE_UNAVAILABLE_FR_COUNTRY\' | translate }}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'DMS_LOADING_DATA\' |translate}}</span></span></span></td><td class="medium-2 columns textPiece" style="display: flex; left:11%" ng-style="{\'padding-right\':listePieceCtrl.isLoadingPrMrLink ? \'9%\' : \'\'} "><span ng-if="!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList.TM)" style=margin-right:7%;><div ng-style="{\'cursor\': \'default !important\', \'color\': \'Gainsboro\', \'visibility\': piece.hideGrayPictoWhenEmpty ? \'hidden\' : \'visible\'}" ng-if="piece.docIds && piece.docIds.length == 0 && !listePieceCtrl.isLoadingPrTmLink && listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-clock-o fa-2x" style="font-size: 20px;"></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'REFER_TO_TM_TAB\' | translate }}</md-tooltip></div><div class=tmlink ng-if="piece.docIds && piece.docIds.length > 0 && !listePieceCtrl.isLoadingPrTmLink && listePieceCtrl.checkGenericPart(piece)" style=margin-right:20%;><i class="fa fa-clock-o fa-2x" style="font-size: 20px;" ng-click=listePieceCtrl.gotoPrTmLink(piece.docIds,piece.reference)></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{\'CONSULT_TM_DESCRIPTION\'| translate}}</md-tooltip></div><div ng-if=listePieceCtrl.isLoadingPrMrLink><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'TM_LOADING_DATA\' |translate}}</div></span><span ng-if="!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && $root.asomDocList.MR)"><div ng-style="{\'color\': \'Gainsboro\', \'cursor\': \'default !important\', \'visibility\': piece.hideMrGrayPictoWhenEmpty ? \'hidden\' : \'visible\'}" ng-if="piece.MRdocIds && piece.MRdocIds.length == 0 && !listePieceCtrl.isLoadingPrMrLink && listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-file-text fa-2x" style=font-size:20px;></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{ \'REFER_TO_MR_TAB\' | translate }}</md-tooltip></div><div class=tmlink ng-if="piece.MRdocIds && piece.MRdocIds.length > 0 && !listePieceCtrl.isLoadingPrMrLink && listePieceCtrl.checkGenericPart(piece)"><i class="fa fa-file-text fa-2x" ng-click=listePieceCtrl.gotoPrMrLink(piece.MRdocIds,piece.reference) style=font-size:20px;></i><md-tooltip md-direction=right style="background-color:grey;opacity: 1.0;font-size: medium; color:  white; border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space: normal;">{{\'CONSULT_MR_DESCRIPTION\'| translate}}</md-tooltip></div><div ng-if=listePieceCtrl.isLoadingPrMrLink><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{\'MR_LOADING_DATA\' |translate}}</div></span></td><td class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=piece from=PR></shopping-cart></div></td><td class="medium-2 columns" ng-if=listePieceCtrl.isUserDms style="padding-left: 0%;display: flex;" ng-style="{\'left\':\'8.5%\'}"><div class=switchButton style=margin-right:15%;margin-left:5%;><shopping-cart-quote piece=piece icon=estimate from=PR></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition from=PR piece=piece options=optionsN1></shopping-cart-parts-requisition></div></td><!-- =====   Residual applicability of the main reference   ===== --><td ng-if=piece.showComplementaryInfo style="position: relative; margin-top:-2%;left: 3%; margin-bottom: -2%;" class="medium-12 medium-offset-1 columns applicability row"><div><div ng-click=listePieceCtrl.showHideAppl(piece) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!piece.showAppl,\'icon-icons_arrow_dropdown\':piece.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=piece.showAppl style="width: 111%;"><mtc-line codified-signs=piece.codifiedSigns mtc-list=piece.simplifiedResidual></mtc-line></div><additional-line show-add=piece.showAdd additional=piece.additional></div></td><!-- ================   Additional References   ===================== --><td class="medium-12 columns refAdditional" ng-if="piece.additional && piece.showAdd" style="left: 6%;"><div ng-repeat="reference in piece.additional"><div class="row valign-middle" style="margin-top: 10px;"><div class="medium-1 columns textPiece showPointer underLineRef" ng-style="{\'left\': listePieceCtrl.isUserDms ? \'-2%\' : \'2%\'}"><span ng-click="listePieceCtrl.goToProduct(reference, piece)" ng-class="listePieceCtrl.isUserDms? \'ref-additional-absolute \': \'ref-add-absolute\'">{{reference.reference | filterFormatRef}}</span> <i class="fa fa-files-o" ng-style="{\'padding-left\': listePieceCtrl.isUserDms ? \'85.5px\' : \'60.5px\', \'padding-bottom\': \'3px\'}" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=listePieceCtrl.copyToClipboard(reference.reference)></i></div><div class="columns medium-3 textPiece designation" ng-click=listePieceCtrl.goToProduct(reference) ng-keypress="$event.keyCode === 13 && listePieceCtrl.goToProduct(reference)"><div class=textDesignation>{{::reference.designation}}</div><div class=icons><a ng-if=reference.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}pp</md-tooltip></a><span ng-if=reference.fds class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=reference.reach class=icon-reach><img src=./assets/svg/reach.svg class=margin-bottom-10 height=18 width=18 alt=""><md-tooltip>Reach</md-tooltip></span><span ng-if=reference.memo class=icon-icons_memo_it_listePiece></span><picto-list equivalent-types=reference.equivalentTypes family-code=reference.familyCode></picto-list></div></div><div class="medium-1 columns textPiece"></div><div class="medium-1 columns textPiece" ng-class=listePieceCtrl.getStockCellClass(reference.dmsInformations.quantity) style=left:-3%><span ng-if="listePieceCtrl.isCentralStockPilot && !listePieceCtrl.isLoadingDMSData"><central-stock-icon piece=reference></central-stock-icon></span><span ng-if="!listePieceCtrl.isCentralStockPilot && listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData"><phenix-is-number quantity=reference.dmsInformations.quantity is-additional="piece.additional && piece.showAdd"><span>{{reference.dmsInformations.quantity}}</span></phenix-is-number></span><span ng-if="(listePieceCtrl.isUserDms || listePieceCtrl.isCentralStockPilot) && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece"><span ng-if="listePieceCtrl.isUserDms && !listePieceCtrl.isLoadingDMSData">{{piece.dmsInformations.location}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></div><div class="medium-1 columns textPiece" style=left:2%;><span ng-if="!listePieceCtrl.isLoadingDMSData && !mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && (!mainCtrl.isIndependentUser || (mainCtrl.isIndependentUser && listePieceCtrl.isAsomValidDocAccess === \'true\' && $root.asomDocList.PX)) && !mainCtrl.isHorseUser">{{getPriceToDisplay(reference)}} <span><span ng-if="getPriceToCheck(piece) >0 && getPriceToCheck(piece) != null  && getPriceToCheck(piece) != undefined">{{listePieceCtrl.getCurrencyForItem(reference)}}</span> <span ng-if="listePieceCtrl.isUserDms && listePieceCtrl.isLoadingDMSData"><img src=../assets/images/newHourGlassGrey.gif width=24px alt="">&nbsp;{{ \'DMS_LOADING_DATA\' |translate }}</span></span></span></div><div class="medium-1 columns textPiece">&nbsp;</div><div class="medium-2 columns" ng-if=!listePieceCtrl.isUserDms style="padding-left: 12%;"><div class=switchButton ng-if=!mainCtrl.isHorseUser><shopping-cart piece=reference main-piece=piece from=PR type=PPS></shopping-cart></div></div><div class="medium-2 columns" ng-if=listePieceCtrl.isUserDms><div class=switchButton style=margin-right:138%;margin-left:181%;><shopping-cart-quote piece=reference main-piece=piece icon=estimate from=PR type=PPS></shopping-cart-quote></div><div class=switchButton><shopping-cart-parts-requisition options=optionsN1 piece=reference main-piece=piece from=PR type=PPS></shopping-cart-parts-requisition></div></div></div><div ng-if=reference.showAdditionalComplementaryInfo style="position: relative; margin-top: 0px; margin-bottom: -3%;" class="applicability row"><div style="z-index: 1;" class="medium-10 medium-offset-2 columns containerApplicability"><div style="margin-left: 30px;"><div ng-click=listePieceCtrl.displayPPSApplicabilities(piece.additional) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!reference.displayPPS,\'icon-icons_arrow_dropdown\':reference.displayPPS}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=reference.displayPPS><mtc-line codified-signs=reference.codifiedSigns mtc-list=reference.simplifiedResidual></mtc-line></div></div></div><additional-line ng-if=!$last show-add=piece additional=piece></div></div></td></tr></tbody></table></td></tr></tbody></table>');
$templateCache.put('app/components/products/documents/pr/mtcLine.template.html','<div id=mtcLineContainer><div ng-if="ctrl.codifiedSigns && ctrl.codifiedSigns.length" class=backgroundBlock><div class=blockLine><div class=objectData ng-repeat="code in ctrl.codifiedSigns"><div class=objectCode></div><div class="criteria criteriaContainer">{{::code.designation}} {{::code.textAssociated}}</div></div></div></div><div class=backgroundBlock ng-repeat="residual in ctrl.mtcList"><div class=blockLine ng-repeat="app in residual"><div ng-repeat="mtc in app"><div class=objectData><div class=objectCode>{{::mtc.labelObj}}</div><div class=criteriaContainer><div class=criteria ng-repeat="criteria in mtc.listCrit"><span ng-if="criteria.langueCrit !== \'NONTRANSLATED\'">{{::criteria.labelCrit}} <span ng-if=criteria.codeCrit>({{::criteria.codeCrit}})</span> </span><span ng-if="criteria.langueCrit === \'NONTRANSLATED\'">{{::criteria.codeCrit}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/components/products/documents/pr/pictoList.template.html','<span ng-if="vm.isStandardExchange() && vm.isTractionBattery()"><img src=./assets/images/renative.png height=15 width=40 alt=Renative> </span><span ng-if="vm.isStandardExchange() && !vm.isTractionBattery()"><md-tooltip style="background-color: white; color: black; border-style: solid;border-width: 1px">{{\'STANDARD_EXCHANGE\' | translate}}</md-tooltip><img src=./assets/images/renative_reman.png height=15 width=40 alt=""> </span><span ng-if=vm.isRemanufacturedMotrio() style="position: relative; left: 7%;"><img src=./assets/images/motrio_reman.png height=30 width=50 alt=""> </span><span ng-if="vm.isMotrio() && !vm.isRemanufacturedMotrio()" style="position: relative; left: 7%;"><img src=./assets/images/motrio.png height=30 width=50 alt=""> </span><span ng-if=vm.isValuePlus()><img src=./assets/images/value+.png height=30 width=50 alt=""> </span><span ng-if=vm.isEcoValue()><img src=./assets/images/renative.png height=30 width=50 alt=""></span>');
$templateCache.put('app/components/products/documents/mr/documentaryAlertPop.template.html','<div id=documentaryAlertPopUp class=modalPhenix><div class="modalPhenix margin"><div class=row><div ng-click=vm.close() class=closeTopRightModal>{{\'BUTTON_ESTIMATE_CLOSE\' |translate}} X</div><div><i class="fa fa-info-circle"></i></div><div class=infoMsg>{{\'POP_UP_DESCRIPTION\' | translate }}</div><button type=button class=buttonWithIcon ng-click=vm.onOk()><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'OK_INDEPENDENT\'|translate}}</div></button></div></div></div>');
$templateCache.put('app/components/products/documents/mr/mrDocumentDetails.template.html','<div id=DetailMR><!-- ************************\n        TITLE AND BUTTON BACK\n    ************************* --><div sticky name-class=fixedInfoNode style="display: flex; flex-direction: row; padding: 15px 0px;z-index:100"><div class=infoNode><div class=btnBacktoList ng-if="vm.documentsHistory.length > 1 && !vm.isMRInNewTab && !vm.backButtonHide" ng-click=vm.goToListPiece()><i class=icon-icons-phnx_double_back></i></div><div class=btnBack ng-click=vm.backToPreviousDocument() ng-if=!vm.isMRInNewTab style="margin-top: 1px;"><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=separator></div><div><span class=infoPiece ng-bind="vm.isInitialTitle ?  vm.initialTitle : vm.MR.title"></span></div></div><div style="height: fit-content;margin-top: 27px;" ng-if="vm.isArcaUser || vm.isRnetUser"><span ng-if=vm.newDataDisplay class=infoPiece style="cursor: pointer; display: inline-flex; flex-direction: column; align-items: center;" ng-click=vm.removeChildMr()><i class="fa fa-eye" style="margin-bottom: 3px;"></i> <label style="font-size: var(--renaultSmallFont);text-transform: capitalize;text-wrap: nowrap;">{{\'HIDE_SECTION\' |translate}}</label> </span><span ng-class="{\'inactive\':!vm.newDataDisplay}" ng-if=!vm.newDataDisplay class=infoPiece style="display: inline-flex; flex-direction: column; align-items: center;"><i class="fa fa-eye-slash" style="margin-bottom: 3px;"></i> <label style="font-size: var(--renaultSmallFont);text-transform: capitalize;text-wrap: nowrap;">{{\'DISPLAY_SECTION\' |translate}}</label></span></div></div><!-- ***************\n        DOCUMENTATION\n    **************** --><div ng-if="vm.MR.content && (vm.isArcaUser || vm.isRnetUser)" id=generateDoc generate-documentation-sie documentation=vm.MR.content on-clicked-link=vm.onClickedLink on-clicked-outil-spe-link=vm.onClickedOutilSpeLink open-video=vm.openVideo new-data-display=vm.newDataDisplay is-initial-title=vm.isInitialTitle new-display=vm.newDataDisplay enable-watch=vm.enableWatch doc-type="\'MR\'" is-new-tab-open=vm.isMRInNewTab></div><div ng-if="vm.MR.content && !(vm.isArcaUser || vm.isRnetUser)" id=generateDoc generate-documentation-sie documentation=vm.MR.content on-clicked-link=vm.onClickedLink on-clicked-outil-spe-link=vm.onClickedOutilSpeLink open-video=vm.openVideo is-new-tab-open=vm.isMRInNewTab></div><!-- **********\n        POPUP\n    *********** --><div style="visibility: hidden"><div class=md-dialog-container id=myStaticDialog><md-dialog><dialog-documentation-sie list-sie=vm.listMR on-clicked-link=vm.onClickedLink sie-title=vm.popinTitle></dialog-documentation-sie></md-dialog></div></div></div>');
$templateCache.put('app/components/products/documents/mr/mrDocuments.template.html','<div ng-controller="MRDocumentsCtrl as mrDocumentsCtrl" id=mrView><div ng-if=!mrDocumentsCtrl.loading><div class="centered-div documents-not_found" ng-if=!mrDocumentsCtrl.listOfMRDocuments.length>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div></div><p ng-if="mrDocumentsCtrl.isSearchEngine && mrDocumentsCtrl.listofMrDocs.length > 0" ng-class="{\'nissan-document-result\': mrDocumentsCtrl.nissanUserURL ,\'document-result\': !mrDocumentsCtrl.nissanUserURL}" translate=DOCUMENT_RESULT translate-values="{count:mrDocumentsCtrl.listofMrDocs.length,filter:mrDocumentsCtrl.inputFilterText, docType:mrDocumentsCtrl.docType }"></p><div class="centered-div documents-table" ng-if=mrDocumentsCtrl.listOfMRDocuments.length><div id=searchByFilters class=row><div class="small-6 columns documents-row-filter" ng-class="{\'renault-filter\': !mrDocumentsCtrl.nissanUserURL, \'nissan-filter\': mrDocumentsCtrl.nissanUserURL}"><div class="small-6 columns"><div class=btnCategorie dropdown-toggle=#dropDownFilterEltMR><div class=btnTextCategorie>{{mrDocumentsCtrl.selectedFilterElement }}</div><div class=iconDiv><i class=icon-icons_arrow_down></i></div></div><ul ng-if=mrDocumentsCtrl.listMRelements id=dropDownFilterEltMR class=f-dropdown><li ng-repeat="item in mrDocumentsCtrl.listMRelements"><a ng-click=mrDocumentsCtrl.onChangeElement(item)>{{item}}</a></li></ul></div><div class="small-6 columns"><div class=btnCategorie dropdown-toggle=#dropDownFilterOpMR><div class=btnTextCategorie>{{mrDocumentsCtrl.selectedFilterOperation}}</div><div class=iconDiv><i class=icon-icons_arrow_down></i></div></div><ul ng-if=mrDocumentsCtrl.listMRoperations id=dropDownFilterOpMR class=f-dropdown><li ng-repeat="operation in mrDocumentsCtrl.listMRoperations"><a ng-click=mrDocumentsCtrl.onChangeOperation(operation)>{{operation}}</a></li></ul></div></div></div><div class="row documents-row-title"><div class="small-2 columns cell"><span>{{\'DOCUMENT_MR_ID\' | translate}}</span></div><div class="small-5 columns cell"><span>{{\'DOCUMENT_TITLE\' | translate}}</span></div><div class="small-5 columns cell"><span>{{\'DOCUMENT_APPLICABILITY\' | translate}}</span></div></div><div class="row documents-row" ng-class="{ \'selected-nissan\': document.sieRef == mrDocumentsCtrl.selectedMR && mrDocumentsCtrl.nissanUserURL, \'documents-row-renault\': !mrDocumentsCtrl.nissanUserURL, \'documents-row-nissan\': mrDocumentsCtrl.nissanUserURL}" ng-repeat="document in mrDocumentsCtrl.listOfMRDocuments | orderBy : \'designation\'" ng-click="mrDocumentsCtrl.displayMrDetails(document.sieRef, document.pdfContent)"><div class="small-2 columns cell"><span>{{::document.sieRef}}</span></div><div class="small-5 columns cell"><span>{{::document.designation}}</span>&nbsp; <span ng-if="document.state == \'VALIDATED\' && mrDocumentsCtrl.user.documentationFirstLanguage.code != document.designationLanguage"><em id=Newlang class="fa fa-language"></em><md-tooltip md-direction=right style="background-color:grey;opacity:1.0;font-size: medium;color:white; \n                                border: 1.5px solid black; height: auto !important; max-width: 1200px !important; white-space:normal;">{{\'MR_MD_TOOLTIP\'| translate}}</md-tooltip></span></div><div class="small-5 columns cell"><div ng-repeat="applicability in document.applicabilities" class=MRApplicabilities><div class=value-inline-bold>{{::applicability.label}} :&nbsp;</div>{{::applicability.list.join(\', \')}}</div></div></div><p class=numberOfDocuments>{{mrDocumentsCtrl.listOfMRDocuments.length}} {{\'DOCUMENTS_FOUND\' | translate}}</p><div ng-if=mrDocumentsCtrl.isRedButtonAuthorized id=TM_DOCUMENTARY_ERROR class=underTmDocuments ng-click="mrDocumentsCtrl.openAlertsPopin(\'MR\')" style=position:relative;><i class=icon-icons_probleme_footer></i> {{\'TM_DOCUMENTARY_ERROR\'|translate}}</div><div data-html2canvas-ignore ng-if=mrDocumentsCtrl.screenshotButtonVisibility.status class=tmScreenshot><button class=tmScreenshotButton ng-click=mrDocumentsCtrl.captureScreenshot()><i class="fa fa-camera"></i></button></div></div></div>');
$templateCache.put('app/components/products/documents/mr/mrVideo.template.html','<div class="columns small-12 medium-12 large-12 PaddLeftRight0" style="width: 75vw;\nheight: 79vh;"><div class="columns small-11 medium-11 large-11 PaddLeftRight0" style=margin-top:1%;><video width=1000vw height=500vh class=first autoplay=autoplay muted=muted loop controls><source ng-src={{vm.videoUrl.src}} preload=metadata></video></div></div>');
$templateCache.put('app/components/products/documents/mr/nds-doc-residual.template.html','<div class=nds-doc-appl-container><div class=residual-label><strong>{{\'DOCUMENT_APPLIES_TO\' | translate}}</strong></div><div><div ng-repeat="item in vm.residual" class=item-label>{{item}}</div></div></div>');
$templateCache.put('app/components/products/documents/productsDoc/productsDoc.template.html','<div ng-controller="ProductsDocsCtrl as productsDocsCtrl" class=productView><div ng-if=!productsDocsCtrl.loading><div class="centered-div documents-not_found" ng-if=!productsDocsCtrl.products.length>{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><!--ROW WITH CATEGORIES AND LIST--><div class="row clean-row header-row" ng-if=productsDocsCtrl.products.length><div class="blocMenu small-12 columns"><div class="productsDocs pr blocList"><!--================   Headers   ===================== --><div class="row header-product"><div class="small-2 columns"><div>{{\' FAV_TITLE_REF\' | translate}}</div><i ng-class="vm.getSortHeaderClass(\'reference\')"></i></div><div class=columns ng-class="productsDocsCtrl.isUserDms? \'small-5\': \'small-7\'"><div>{{\'FAV_TITLE_WORDING\' | translate}}</div><i ng-class="vm.getSortHeaderClass(\'designation\')"></i></div><div ng-if=productsDocsCtrl.isUserDms class="small-1 columns center-text">{{\'COMMON_STOCK\'|translate}}</div><div ng-if=productsDocsCtrl.isUserDms class="small-1 columns center-text">{{\'LOCKER\'|translate}}</div><div class="small-2 columns" ng-hide=!vm.profil.dmsConnected><div>{{\'REF_STOCK\' | translate}}</div></div><div class="small-1 columns text-right" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !mainCtrl.isHorseUser && (!mainCtrl.isIndependentUser || $root.asomDocList.PX)"><div>{{\'COMMON_COLUMN_PUBHT_TITLE\' | translate}}</div></div><div class="small-1 columns text-right" ng-if=!mainCtrl.isHorseUser><div>&nbsp;</div></div></div><!-- ================   ng-repeat Products   ===================== --><div class=row-bloc ng-repeat="ref in productsDocsCtrl.products"><!-- ROW POUR UNE REF --><div class="row margin-bottom-5" id={{ref.content.reference}}><!--reference --><div class="small-2 columns textPiece"><div ng-class="{\'selected\': ref.content.reference == productsDocsCtrl.selectedProduct}"><span class=reference ng-click=productsDocsCtrl.goToProduct(ref)>{{ref.content.reference | filterFormatRef}} <i class="fa fa-files-o" aria-hidden=true style="padding-left: 2.5px;" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click=productsDocsCtrl.copyToClipboard(ref.content.reference);$event.stopPropagation();></i></span></div></div><div class="columns textPiece designation" ng-class="productsDocsCtrl.isUserDms? \'small-5\': \'small-7\'"><div><div ng-click=productsDocsCtrl.goToProduct(ref) class="designation margin-0">{{ref.content.designation}}</div><div class=icons><a ng-if=ref.content.replacement><span class=icon-icons_chaine_remplacement_listPiece></span><md-tooltip>{{ \'INFO_CHAINE_REMPL\'| translate}}</md-tooltip></a><span ng-if=ref.content.safetyFlag class=icon-icons_warning_document_listePiece><md-tooltip>{{\'PRODUCT_SAFETY_DATA\' |translate}}</md-tooltip></span><span ng-if=ref.content.reach class=icon-reach><img src=./assets/svg/reach.svg class="margin-bottom-10 vertical-align-unset" height=18 width=18><md-tooltip>Reach</md-tooltip></span><picto-list equivalent-types=ref.content.types family-code=ref.content.familyCode></picto-list></div></div></div><div ng-if=productsDocsCtrl.isUserDms class="small-1 columns textPiece bold center-text" ng-class=productsDocsCtrl.quantityFontColor(ref.content.dmsInformations.quantity)><phenix-is-number quantity=ref.content.dmsInformations.quantity>{{ref.content.dmsInformations.quantity}}&nbsp;</phenix-is-number></div><div ng-if=productsDocsCtrl.isUserDms class="small-1 columns textPiece center-text">{{ref.content.dmsInformations.location}}&nbsp;</div><!--Stock--><div class="small-3 columns textPiece" ng-hide=!vm.profil.dmsConnected><div ng-if=ref.stock class=stockDispo>{{ref.stock.quantity}} {{\'PRODUCT_IN_STORAGE\' | translate}}</div><div ng-if=!ref.stock class=stockIndispo>{{\'DOCUMENT_PR_INDISPO\' | translate}}</div></div><!--PUBHT--><div class="small-1 columns textPiece text-right display-block" ng-if="!mainCtrl.isCountryChina && !mainCtrl.isCountryIndia && !mainCtrl.isHorseUser && (!mainCtrl.isIndependentUser || $root.asomDocList.PX)">{{productsDocsCtrl.getPriceToDisplay(ref.content)}} {{productsDocsCtrl.getCurrencyForItem(ref.content)}}</div><!-- ESTIMATION /BON DE SERVICE /PANIER--><!-- IF NOT CONNECTED :  BOUTON PANIER --><div class="small-1 columns float-right" ng-if="!productsDocsCtrl.isUserDms && !mainCtrl.isHorseUser"><shopping-cart from=PRODUCTS piece=ref.content></shopping-cart></div><!-- IF NOT CONNECTED :  BOUTON ESTIMATE --><div class="small-1 columns estimColumn" ng-if=productsDocsCtrl.isUserDms><shopping-cart-quote from=PR piece=ref.content icon=estimate></shopping-cart-quote></div><!-- IF NOT CONNECTED :  BOUTON BON DE SERVICE --><div class="small-1 columns partListColumn" ng-if=productsDocsCtrl.isUserDms><shopping-cart-parts-requisition from=PR piece=ref.content options={}></shopping-cart-parts-requisition></div><!-- </div> --><!-- =====   Residual applicability of the main reference   ===== --><div class=row ng-if=ref.content.residual.length><div style="z-index: 1" class="small-offset-2 small-10 columns containerApplicability"><div ng-click=productsDocsCtrl.showHideAppl(ref) class=appl-title><span class=hand><i ng-class="{\'icon-icons-phnx_arrow_link\':!ref.showAppl,\'icon-icons_arrow_dropdown\':ref.showAppl}"></i> {{ \'DOCUMENT_PR_COMPLEMENTARY_INFO\'| translate}}</span></div><div ng-if=ref.showAppl style=max-width:92%;><mtc-line mtc-list=ref.content.residual></mtc-line></div></div></div></div></div></div><div class=row><div class="small-offset-5 small-4 columns"><div ng-click=productsDocsCtrl.loadMoreProducts(productsDocsCtrl.technicalId) ng-if="productsDocsCtrl.technicalId != \'ENDOFLIST\' || productsDocsCtrl.functionalId"><span class=loadMoreButton>{{\'LOAD_MORE_PRODUCTS\'| translate}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/components/products/documents/tiresInformation/tiresInformation.template.html','<div id=tiresId style="font-family: \'renaultGroupRegular\';"><div class=tiredDetails ng-class="{\'tiresScroll\':vm.isTyre}"><div class=infoHeader ng-if="vm.tiresInfo.nrce.length > 0 || vm.tiresInfo.tvv.length > 0"><div class=headerSection><div><i class="fa fa-info-circle fa-2x" style="font-size: var(--renaultExtraLargeFont); top: 5px; position: relative;"></i></div><div class=separator></div><div class=infoHeading>{{\'BTLIST_HEADER_INFORMATIONS\' | translate | uppercase}}</div></div><div class=nrceTvvData><span class=alignData>NRCE</span><span class=alignVal> : {{vm.tiresInfo.nrce}} </span><span class=alignData>TVV</span><span class=alignVal>: {{vm.tiresInfo.tvv}}</span></div></div><div class=infoHeader ng-if="vm.originalTiresInfo.length > 0"><div class=headerSection><div><img src=../assets/images/tire_logo.png height=21 width=21 alt=""></div><div class=separator></div><div class=tiresHeading>{{\'ORIGINAL_FACTORY_TIRES\' | translate | uppercase}}</div></div><div class="informationData originalData"><div class=tiresAccordion ng-class="vm.isTyre ? \'tiresAccordData\':\'\'" ng-style="{\'width\':vm.originalTiresInfo.length === 1 ? \'75%\' : \'50%\' }" ng-repeat="originalTiresInfo in vm.originalTiresInfo"><accordion class=collapse close-others=false><accordion-group class=accord ng-init="isOpen = true" is-open=isOpen><accordion-heading><table><tr ng-click="isOpen == !isOpen"><td class=w-10><span ng-if="originalTiresInfo.axle === \'I\'" class=tires_image></span> <span ng-if="originalTiresInfo.axle === \'F\'" class=front_tire_image></span> <span ng-if="originalTiresInfo.axle === \'R\'" class=rear_tire_image></span></td><td class=valign-middle>{{}}</td><td class=w-10><i class=icons ng-class="{\'icon-icons_expendable_plus float-left\':!isOpen,\'icon-icons_exependable_moins float-left\':isOpen}"></i></td></tr></table></accordion-heading><table ng-style="{\'margin-top\': vm.isTyre ? \'-24px\' : \'-2px\' }"><tr ng-repeat="parts in originalTiresInfo.parts"><td style="width: 10%;"></td><td colspan=2><table class=originalTireInfo ng-style="vm.originalTiresInfo.length === 1 && !vm.isTyre ? {\'width\':\'75%\',\'margin-left\':\'15%\'} : {\'width\':\'90%\'}"><tr><td><div><div ng-hide=true class=referenceInfo ng-style="{\'margin-top\':vm.originalTiresInfo.length === 1 ? \'-15%\' : \'-25%\' }"><span>{{\'FAV_MODAL_REFERENCE_TM\' | translate}} : </span>{{parts.partNumber}}</div><div class=otherInfo><span>{{\'REF_BRAND\' | translate}} : </span>{{parts.tyreBrand}}</div><div class=otherInfo><span>{{\'PRODUCT_LINE\' | translate}} : </span>{{parts.tyreProductLine}}</div><div class=otherInfo><span>{{\'TECHNICAL_DESIGNATION\' | translate}} : </span>{{parts.tyreNominalSectionWidth}} / {{parts.tyreAspectRatio}} {{parts.tyreConstructionType}}{{parts.wheelRimDiameter}} {{parts.tyreLoadIndexes[0]}} {{parts.tyreSpeedRating}}</div><div class=otherInfo><span>{{\'TYRE_SEASON\' | translate}} : </span><span ng-if="parts.tyreSeason == \'All-season\'"><img src=../../../../../assets/svg/snowflake_sun.svg height=20 width=30 alt=""><md-tooltip>{{\'SEASON_ALL\' |translate}}</md-tooltip></span><span ng-if="parts.tyreSeason == \'Summer\'"><img src=../../../../../assets/svg/weather_sun.svg height=20 width=25 alt=""><md-tooltip>{{\'SEASON_SUMMER\' |translate}}</md-tooltip></span><span ng-if="parts.tyreSeason == \'Winter\'"><img src=../../../../../assets/svg/weather_snow.svg height=20 width=40 alt=""><md-tooltip>{{\'SEASON_WINTER\' |translate}}</md-tooltip></span></div></div></td><td class=img-div ng-right-click=vm.openImageInNewTab(parts.energyLabelUrl) ng-click="vm.openImage(parts.energyLabelUrl, vm.isTyre)"><img style="cursor: pointer" ng-if="parts.energyLabelUrl !== \'\'" ng-src={{parts.energyLabelUrl}} alt=""></td></tr></table></td></tr></table></accordion-group></accordion></div></div></div><div class=infoHeader ng-if=vm.tiresInfo.tyres><div class=headerSection><div><img src=./assets/images/tire_logo.png height=30 width=30 alt=""></div><div class=separator></div><div class=tiresHeading>{{\'BASIC_MOUNT\' | translate | uppercase}}</div></div><div class=informationData><table ng-style="{\'margin-left\': vm.isTyre ? \'5%\' : \'3%\' }"><tr><td><img src=../assets/images/front_tire_highlight.png height=30 width=30 alt="" class=mr-8px> <span class=mt-5px>{{vm.tiresInfo.tyres.front}}</span></td><td><img src=../assets/images/back_tire_highlight.png height=30 width=30 alt="" class=mr-8px> <span class=mt-5px>{{vm.tiresInfo.tyres.rear}}</span></td></tr></table></div></div><div class=infoHeader ng-if="vm.tiresInfo.optionalTyres.length > 0"><div class=headerSection><div><img src=./assets/images/tire_logo.png height=30 width=30 alt=""></div><div class=separator></div><div class=tiresHeading>{{\'APPROVED_TIRES\' | translate | uppercase}}</div></div><div class=informationData><table ng-style="{\'margin-left\': vm.isTyre ? \'5%\' : \'3%\' }"><tr ng-repeat="optionalTires in vm.tiresInfo.optionalTyres"><td><img src=../assets/images/front_tire_highlight.png height=30 width=30 alt="" class=mr-8px> <span class=mt-5px>{{optionalTires.front}}</span></td><td><img src=../assets/images/back_tire_highlight.png height=30 width=30 alt="" class=mr-8px> <span class=mt-5px>{{optionalTires.rear}}</span></td></tr></table></div></div></div></div>');
$templateCache.put('app/components/products/documents/tiresInformation/tiresInformationPopup.template.html','<md-dialog class=tiresInformation><div class=close ng-click=vm.onClose()><i class="icon-icons_close closeIcon"></i></div><div class=tiresPopup><tires-information is-tyre=true tires-info=vm.tiresInfo></tires-information></div></md-dialog>');
$templateCache.put('app/components/products/documents/tm/tmAttachment.template.html','<div id=attachmentTM><md-dialog><div><span ng-click=cancel() class=cancel>{{\'MODAL_CLOSE\' | translate}} <i class=icon-icons_close></i></span></div><div class=content><img ng-if=href ng-src={{href}} alt=""><p></p><div ng-if=partNumber><span>{{\'DOCUMENT_TM_ATTACHMENT_PARTNUMBER\' | translate}} : {{partNumber}}</span></div><div ng-if=sectionalView><span>{{\'DOCUMENT_TM_ATTACHMENT_SECTIONALVIEW\' | translate}} : {{sectionalView}}</span></div><p></p></div></md-dialog></div>');
$templateCache.put('app/components/products/documents/tm/tmDocuments.template.html','<div ng-controller="TMDocumentsCtrl as tmDocumentsCtrl" id=tmTabView><div class="centered-div documents-not_found" ng-if="!tmDocumentsCtrl.atLeastOneTMDocument && !tmDocumentsCtrl.loading">{{\'DOCUMENT_NOT_FOUND\' | translate}}</div><p ng-if="tmDocumentsCtrl.isSearchEngine && tmDocumentsCtrl.listOfTMDocuments.length > 0" class=document-result translate=DOCUMENT_RESULT translate-values="{count:tmDocumentsCtrl.listOfTMDocuments.length,filter:tmDocumentsCtrl.inputFilterText, docType:tmDocumentsCtrl.docType }"></p><div class="centered-div documents-table" ng-if=tmDocumentsCtrl.atLeastOneTMDocument><!--=====================================\n        =              FILTERS                  =\n        ======================================--><div ng-if="tmDocumentsCtrl.tmListData.length == 0"><tm-filters tm-documents=tmDocumentsCtrl.listOfTMDocuments tm-operations=tmDocumentsCtrl.listTMOperations tm-elements=tmDocumentsCtrl.listTMElements selected-filters=tmDocumentsCtrl.selectedFilters></tm-filters></div><!--=====================================\n        =             TABLE HEADERS             =\n        ======================================--><div class="row documents-row-title"><div class=inner_row><!-- ======== ID ======= --><div class="code columns cell padding-left-7"><div class="small-5 columns small-offset-2 inner_cell">{{\'DOCUMENT_TM_ID\' | translate}}</div></div><!-- ======== TITLE ======= --><div class="title columns cell">{{\'DOCUMENT_TM_TITLE\' | translate}}</div><!-- ======== TIME ======= --><div class="time columns cell cell-centered">{{\'DOCUMENT_TM_TIME\' | translate}}</div><!-- ======== PRECISION ======= --><div class="precision columns cell">{{\'DOCUMENT_TM_DETAILS\' | translate}}</div><div class="technicity columns cell cell-centered" ng-if=tmDocumentsCtrl.isSearchEngine>&nbsp;</div><!-- ======== TECHNICALITY ======= --><div class="technicity columns cell cell-centered" style="right: 10px;">{{\'DOCUMENT_TM_TECHNICALITY\' | translate}}</div><!-- ======== APPLICABILITY ======= --><div class="applicability columns cell cell-centered">{{\'DOCUMENT_APPLICABILITY\' | translate}}</div><!-- ======== ESSAY ======= --><div class="essay columns cell cell-centered">{{\'DOCUMENT_TM_TRY\' | translate}}<click-tooltip-container><div data-html2canvas-ignore class="tooltipContainer testPosition unsetCase"><div class=inline ng-repeat="tip in tmDocumentsCtrl.popin.data"><i class={{tip.class}}></i><div class=margin-left-right>{{tip.opcode}} {{tip.txt | translate}}</div><div class=time>{{tip.time}}</div></div></div></click-tooltip-container></div><div class="basket columns cell"></div></div></div><!--=====================================\n        =              TABLE DATA               =\n        ======================================--><div id=tableData><div ng-repeat="document in tmDocumentsCtrl.listOfTMDocuments | filter:tmDocumentsCtrl.selectedFilters as filteredDocuments"><div class="row documents-row-tm" id="{{\'TM_\'+document.id}}"><tm-data current-tm=document></tm-data></div></div><p class=numberOfDocuments ng-if="tmDocumentsCtrl.tmListData.length == 0">{{filteredDocuments.length}} {{\'DOCUMENTS_FOUND\' | translate}}</p></div></div><!--display tm documentary eror at bottom --><div ng-if=tmDocumentsCtrl.isRedButtonAuthorized id=TM_DOCUMENTARY_ERROR class=underTmDocuments ng-click="tmDocumentsCtrl.openAlertsPopin(\'TM\')" style=position:relative;><i class=icon-icons_probleme_footer></i> {{\'TM_DOCUMENTARY_ERROR\'|translate}}</div><div data-html2canvas-ignore ng-if=tmDocumentsCtrl.screenshotButtonVisibility.status class=tmScreenshot><button class=tmScreenshotButton ng-click=tmDocumentsCtrl.captureScreenshot()><i class="fa fa-camera"></i></button></div><scroll-up scroll-trigger=300 scroll-anchor=#listePiece></scroll-up></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/commercialServices.html','<div class="block-accordion contracts" ng-show=vm.isEasyLink style=margin-top:0;><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.commercialServicesAccordion.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenCommercialServices = !$scope.isOpenCommercialServices;"><span>{{\'EASYLINK_VEHICLE_COMMERCIAL_SERVICES\' | translate}}</span> <i ng-class="\' icon-arrow_\'+($scope.isOpenCommercialServices ? \'open\' : \'close\')"></i></div></accordion-heading><div class=commercialSubscriptions><section style=border-top:0><header class=grid--no-gutter><div class="label grid__col-5" ng-click="vm.sortBy(\'name\', \'commercialServices\');">{{\'CONNECTED_SERVICES_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'commercialServices\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'sid\', \'commercialServices\');">{{\'EASYLINK_VEHICLE_UID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'sid\' && contracts === \'commercialServices\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'status\', \'commercialServices\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'commercialServices\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'updatedAt\', \'commercialServices\');">{{\'LAST_STATUS_UPDATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'updatedAt\' && contracts === \'commercialServices\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.commercialServices"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-5>{{item.name | rlinkformat}}</span> <span class=grid__col-2>{{item.sid | rlinkformat}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\'}}</span> <span class=grid__col-2>{{item.updatedAt | rlinkformat:\'full-date\'}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.features != \'\'" style="left: 1% !important; position: relative;"></i> <span class=arrow ng-if="item.features == \'\'"></span></div></accordion-heading><div ng-repeat="feat in item.features" class="flex grid--no-gutter"><span style="position: relative;left: 13px;" class=grid__col-5>{{feat.name | rlinkformat}}</span> <span style="position: relative;left: 2px;" class=grid__col-2>{{feat.uid | rlinkformat}}</span> <span style="position: relative;right: 18px;" class=grid__col-2>{{feat.status | rlinkformat:\'status\'}}</span> <span style="position: relative; right: 38px;" class=grid__col-2>{{feat.updatedAt | rlinkformat:\'full-date\'}}</span> <span>&nbsp;</span></div></accordion-group></accordion></div></div><div ng-if="vm.commercialServices.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_COMMERCIAL_SERVICES \' | translate}}</div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionExtendedView.html','<div class=app-modal style="padding: 10px; width:950px;"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><section ng-if="allSubscriptions.length > 0" style="margin:2% 0;"><header class=grid--no-gutter><div class="label grid__col-2" ng-click="sortBy(\'name\', \'allSubscriptions\');">{{\'RLINKCAR_CONT_SERV_PRODUCT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'number\', \'allSubscriptions\');">{{\'CONNECTED_SERVICES_CONTRACT_NUMBER\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'number\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'subscriptionDatetime\', \'allSubscriptions\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionDatetime\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'activationDatetime\', \'allSubscriptions\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_ACTIVATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'activationDatetime\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'expirationDatetime\', \'allSubscriptions\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_EXPIRATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'expirationDatetime\'"></span></div><div class="label grid__col-2" ng-click="sortBy(\'status\', \'allSubscriptions\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\'"></span></div></header></section><ul class=list-contracts ng-if="allSubscriptions.length > 0"><li ng-repeat="item in allSubscriptions" class=grid--no-gutter><span class=grid__col-2>{{item.name | rlinkformat}}</span> <span class=grid__col-2>{{item.number | rlinkformat}}</span> <span class=grid__col-2>{{item.subscriptionDatetime | rlinkformat:\'date\'}}</span> <span class=grid__col-2>{{item.activationDatetime | rlinkformat:\'date\'}}</span> <span class=grid__col-2>{{item.expirationDatetime | rlinkformat:\'date\'}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\'}}</span></li></ul><div class=block_text ng-if="allSubscriptions.length === 0" style=padding:10px;>{{\'NO_DATA\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsCancelled.html','<div class=subscriptions><section ng-if="(vm.subscriptionsCancelled && vm.subscriptionsCancelled.length != 0)"><header class=grid--no-gutter><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'name\', \'vm.subscriptionsCancelled\');">{{\'CONTRACT_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'offerId\', \'vm.subscriptionsCancelled\');">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'offerId\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'status\', \'vm.subscriptionsCancelled\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'subscriptionDatetime\', \'vm.subscriptionsCancelled\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionDatetime\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'activationDatetime\', \'vm.subscriptionsCancelled\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_ACTIVATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'activationDatetime\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'expirationDatetime\', \'vm.subscriptionsCancelled\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_EXPIRATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'expirationDatetime\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div style="position: relative;left: 20px;" class="label grid__col-2 grayText" ng-click="vm.sortBy(\'synchronisationStatus\', \'vm.subscriptionsCancelled\');">{{\'EASYLINK_VEHICLE_SYNCHRONISATION_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'synchronisationStatus\' && contracts === \'vm.subscriptionsCancelled\'"></span></div><div class="label grid__col-1" style="margin-left: 15px;"><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=left style="height: auto !important; max-width: 250px !important; white-space: normal;">{{\'SYNCHRONIZATION_TOOLTIP_MSG\' | translate}}</md-tooltip></i></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening" ng-if="vm.subscriptionsCancelled !== null"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subscriptionsCancelled"><ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/common/accordion-content.html\'"></ng-include></accordion></div><div ng-if="((vm.subscriptionsCancelled && vm.subscriptionsCancelled.length === 0 ) || vm.subscriptionsCancelled === null)" class=block_text>{{\'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_CANCELLED\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsConfirmed.html','<div class=subscriptions><section ng-if="(vm.subscriptionsConfirmed && vm.subscriptionsConfirmed.length != 0)"><header class=grid--no-gutter><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'name\', \'vm.subscriptionsConfirmed\');">{{\'CONTRACT_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'offerId\', \'vm.subscriptionsConfirmed\');">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'offerId\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'status\', \'vm.subscriptionsConfirmed\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'subscriptionDatetime\', \'vm.subscriptionsConfirmed\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionDatetime\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'activationDatetime\', \'vm.subscriptionsConfirmed\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_ACTIVATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'activationDatetime\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'expirationDatetime\', \'vm.subscriptionsConfirmed\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_EXPIRATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'expirationDatetime\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div style="position: relative;left: 20px;" class="label grid__col-2 grayText" ng-click="vm.sortBy(\'synchronisationStatus\', \'vm.subscriptionsConfirmed\');">{{\'EASYLINK_VEHICLE_SYNCHRONISATION_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'synchronisationStatus\' && contracts === \'vm.subscriptionsConfirmed\'"></span></div><div class="label grid__col-1" style="margin-left: 15px !important;"><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=left style="height: auto !important; max-width: 250px !important; white-space: normal;">{{\'SYNCHRONIZATION_TOOLTIP_MSG\' | translate}}</md-tooltip></i></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening" ng-if="vm.subscriptionsConfirmed !== null"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subscriptionsConfirmed"><ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/common/accordion-content.html\'"></ng-include></accordion></div><div ng-if="((vm.subscriptionsConfirmed && vm.subscriptionsConfirmed.length === 0 ) || vm.subscriptionsConfirmed === null)" class=block_text>{{\'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_CONFIRMED\' |translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsOnGoing.html','<div class=subscriptions><section ng-if="vm.subscriptionsOnGoing !== null"><header class=grid--no-gutter><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'name\', \'subscriptionsOnGoing\');">{{\'CONTRACT_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'offerId\', \'subscriptionsOnGoing\');">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'offerId\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'status\', \'subscriptionsOnGoing\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'subscriptionDatetime\', \'subscriptionsOnGoing\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionDatetime\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'activationDatetime\', \'subscriptionsOnGoing\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_ACTIVATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'activationDatetime\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'expirationDatetime\', \'subscriptionsOnGoing\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_EXPIRATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'expirationDatetime\' && contracts === \'subscriptionsOnGoing\'"></span></div><div style="position: relative;left: 20px;" class="label grid__col-2 grayText" ng-click="vm.sortBy(\'synchronisationStatus\', \'subscriptionsOnGoing\');"><span style="white-space: break-spaces;">{{\'EASYLINK_VEHICLE_SYNCHRONISATION_STATUS\' | translate}}</span> <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'synchronisationStatus\' && contracts === \'subscriptionsOnGoing\'"></span></div><div class="label grid__col-1" style="margin-left: 15px !important;"><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=left style="height: auto !important; max-width: 250px !important; white-space: normal;">{{\'SYNCHRONIZATION_TOOLTIP_MSG\' | translate}}</md-tooltip></i></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening" ng-if="vm.subscriptionsOnGoing !== null"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subscriptionsOnGoing"><ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/common/accordion-content.html\'"></ng-include></accordion></div><div ng-if="vm.subscriptionsOnGoing === null" class=block_text>{{vm.nissanUserURL ? \'CONTRACT_DATA_NOT_AVAILABLE\' : \'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_IN_PROGRESS\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/subscriptionsTerminated.html','<div class=terminated><section ng-if="(vm.subscriptionsTerminated && vm.subscriptionsTerminated.length != 0)"><header class=grid--no-gutter><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'name\', \'subscriptionsTerminated\');">{{\'CONTRACT_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'offerId\', \'subscriptionsTerminated\');">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'offerId\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'status\', \'subscriptionsTerminated\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'subscriptionDatetime\', \'subscriptionsTerminated\');"><rlink-tip tip-value="{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'subscriptionDatetime\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-2 grayText" ng-click="vm.sortBy(\'activationDatetime\', \'subscriptionsTerminated\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_ACTIVATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'activationDatetime\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-1 grayText" ng-click="vm.sortBy(\'expirationDatetime\', \'subscriptionsTerminated\');"><rlink-tip tip-value="{{\'EASYLINK_VEHICLE_EXPIRATION_DATE\' | translate}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip><span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'expirationDatetime\' && contracts === \'subscriptionsTerminated\'"></span></div><div style="position: relative;left: 20px;" class="label grid__col-2 grayText" ng-click="vm.sortBy(\'synchronisationStatus\', \'subscriptionsTerminated\');">{{\'EASYLINK_VEHICLE_SYNCHRONISATION_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'synchronisationStatus\' && contracts === \'subscriptionsTerminated\'"></span></div><div class="label grid__col-1" style="margin-left: 15px;"><i ng-class="vm.language === \'en\' ? \'iconEn\' : \'iconFr\'" class="fa fa-info-circle"><md-tooltip md-direction=left style="height: auto !important; max-width: 250px !important; white-space: normal;">{{\'SYNCHRONIZATION_TOOLTIP_MSG\' | translate}}</md-tooltip></i></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.subscriptionsTerminated"><ng-include src="\'app/components/car/rLinkCar/contractsAndServices/easyLink/common/accordion-content.html\'"></ng-include></accordion></div><div ng-if="((vm.subscriptionsTerminated && vm.subscriptionsTerminated.length === 0 ) || vm.subscriptionsTerminated === null)" class=block_text>{{\'CONNECTED_SERVICES_NO_SUBSCRIPTIONS_TERMINATED\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/synchronizationHistoryModal.html','<div class=app-modal style="padding: 10px; width:950px;"><div class=header-modal><span style="font-family: var(--renaultFontBold);">{{\'EASYLINK_VEHICLE_SYNCHRONIZATION_HISTORY\' | translate}}</span> <span ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span></div><section ng-if="synchronizations !== undefined"><header class=grid--no-gutter><div class="label grid__col-2" ng-click="sortBy(\'origin\', \'synchronisationHistory\');">{{\'EASYLINK_VEHICLE_ORIGIN\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'origin\'"></span></div><div class="label grid__col-4" ng-click="sortBy(\'requestId\', \'synchronisationHistory\');">{{\'EASYLINK_VEHICLE_REQUEST_ID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'requestId\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'status\', \'synchronisationHistory\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'timestamp\', \'synchronisationHistory\');">{{\'CONNECTED_SERVICES_DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'date\'"></span></div></header></section><ul class=synchronizationList ng-if="synchronizations !== undefined"><li ng-repeat="item in synchronizations" class=grid--no-gutter><span class=grid__col-2>{{item.origin | rlinkformat}}</span> <span class=grid__col-4>{{item.requestId | rlinkformat}}</span> <span class=grid__col-3>{{item.status | rlinkformat}}</span> <span class=grid__col-3>{{item.timestamp | rlinkformat:\'full-date\'}}</span></li></ul><div class=block_text ng-if="synchronizations === undefined">{{\'NO_DATA\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/technicalServices.html','<div class=contSyncBox ng-show=" vm.isEasyLink && !vm.isIndependentUser"><div><span><button class="cs-btn syncButton" ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click="vm.contractsServiceSync(\'isTech\', false, vm.nissanUserURL)"><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'SERVICE_SYNCHRONIZATION\' | translate}}</div></button> </span><span ng-click="vm.contractsServiceSyncHistory(\'isTech\', true, vm.nissanUserURL)"><button ng-class="{\'histButtonEn\': vm.language === \'en\',\n                \'histButtonFr\': vm.language !== \'en\',\'nissanBtnWithIcon\': vm.nissanUserURL}" class="cs-btn buttonWithIcon"><div style="position: relative;right: 5px;" class=iconDivSync><i style="font-size: var(--renaultMediumFont); left: 7px;position: relative;" class="fa fa-history"></i></div><div style="position: relative;right: 5px;" class=btnTextSync>{{\'SYNCHRONIZATION_HISTORY\' | translate}}</div></button> </span><span ng-class="vm.language === \'en\' ? \'syncTextEn\' : \'syncTextFr\'" style="width: 43%; display: inline-flex;">{{\'SYNCHRONIZATION_TEXT\' | translate}}</span><div style="left: 1.5%; font-size: var(--renaultMediumFont);margin-top: 7px; position: relative;"><i class="fa fa-info-circle" style="padding-right: 0.5rem;cursor:pointer;" ng-click=vm.launchTechnicalSynchronizeModal(true)></i> {{\'LAUNCH_NOTE_SYNCHRONIZATION\' | translate}}</div></div></div><div class="block-accordion contracts" ng-show=vm.isEasyLink style="position: relative;bottom: 10px;"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.technicalServicesAccordion.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenTechnicalServices = !$scope.isOpenTechnicalServices;"><span>{{\'EASYLINK_VEHICLE_TECHNICAL_SERVICES\' | translate}}</span> <i ng-class="\' icon-arrow_\'+($scope.isOpenTechnicalServices ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions ng-if="vm.technicalServices.length > 0"><section style=border-top:0;padding:0;><header class=grid--no-gutter style="height: 35px;padding-top: 1%;position: relative;"><div class=label ng-if="vm.technicalServices.length > 0" style="padding: 0 .25rem!important;"><span ng-show=!vm.isIndependentUser><input type=checkbox ng-model=vm.isSyncSelected ng-click="vm.toggleAllTechCheckBoxes(vm.technicalServices, \'isTech\')"></span></div><div class="label grid__col-5" ng-click="vm.sortBy(\'name\', \'technicalServices\');">{{\'CONNECTED_SERVICES_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && contracts === \'technicalServices\'"></span></div><div class="label grid__col-1" ng-click="vm.sortBy(\'uid\', \'technicalServices\');">{{\'EASYLINK_VEHICLE_UID\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'uid\' && contracts === \'technicalServices\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'status\', \'technicalServices\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\' && contracts === \'technicalServices\'"></span><div ng-click=vm.refreshData() class=rlink-tip><span class=rlink-tip-txt>{{\'DDP_REFRESH\' | translate}}</span> <i style="margin-left: 13px; font-size: larger;cursor: pointer;" class="fa fa-refresh" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i><!--to change nissan color for refresh--></div></div><div class="label grid__col-2" ng-click="vm.sortBy(\'updatedAt\', \'technicalServices\');">{{\'LAST_STATUS_UPDATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'updatedAt\' && contracts === \'technicalServices\'"></span></div><div class="label grid__col-2" ng-hide=vm.hideDeactivateBtn></div></header><div class="block-accordion list-contracts borderDarkening"><accordion ng-repeat="item in vm.technicalServices" class=section_wrapper><div class="section_header sub_items grid--no-gutter"><span ng-if="item.uid !== \'494\'" class=technicalCheckBox style="top: 6px;position: relative;padding: 0 .25rem!important;" ng-show=!vm.isIndependentUser><input style="position: relative; top: 3px;" type=checkbox ng-model=item.checked ng-click="vm.onIndividualTechnicalSelect(vm.technicalServices, item.uid)"> </span><span ng-if="item.uid === \'494\'"><i style="font-size: larger;position: relative;padding: 0 .25rem" class="fa fa-info-circle"></i><md-tooltip style="margin: 0;font-family: \'newRenaultGroupRegular\' !important;" md-direction=right>{{ \'UID_494_TOOLTIP\' | translate}}</md-tooltip></span><span class=grid__col-5>{{item.name | rlinkformat}}</span> <span class=grid__col-1>{{item.uid | rlinkformat}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\' | uppercase}}</span> <span class=grid__col-2>{{item.updatedAt | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2 ng-if="vm.isDdpServiceDeactivated && (item.uid === \'204\' && item.status === \'ACTIVATED\')"><button ng-click="vm.deActivateFeature(\'isTech\', true)" ng-disabled=vm.hideDeactivateBtn ng-class="{\'disabled-button\': vm.hideDeactivateBtn}" style="font-size: var(--renaultSmallFont); vertical-align: middle; text-transform: uppercase; background-color: var(--renaultPrimaryColor); color: black; font-weight: bold; margin-bottom: 0px !important; padding: 11px 7px 11px 7px;" class=ng-binding>{{\'DEACTIVATE_SERVICE\' | translate}}</button></span></div></accordion></div></section></div><div ng-if="vm.technicalServices.length === 0"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_TECHNICAL_SERVICES \' | translate}}</div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/popup/synchronizationHistoryPopup.template.html','<div ng-if=vm.error class=popinInfo style=padding:30px><span ng-click=close() class=dialogClose><i class="icon-icons_close close-icon"></i> </span>{{\'SYNCHRONIZATION_HISTORY_ERROR\'|translate}}</div><div ng-if=vm.showNoHistoryMessage class=popinInfo style=padding:30px><span ng-click=close() class=dialogClose><i class="icon-icons_close close-icon"></i> </span>{{\'SYNCHRONIZATION_HISTORY_ERROR\'|translate}}</div><div ng-if="!vm.error && !vm.showNoHistoryMessage" class="app-modal synchronizationHistory" style="width: 75rem;overflow: hidden;"><div class="grid--no-gutter mapStatusHead"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'EASYLINK_VEHICLE_SYNCHRONIZATION_HISTORY\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div><div style="text-align: right;padding-right: 48px;"><button style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 0;" ng-click="vm.pageChange(vm.currentPage - 1)" ng-disabled="vm.currentPage === 1"><i ng-style="{\'color\': vm.currentPage === 1 ? \'#888\' : \'#000\'}" class="fa fa-backward"></i></button> {{vm.currentPage}} of {{vm.getTotalPages()}} <button style="margin: 0; color: #000; background-color: unset; padding: 0 1rem 0 1rem;" ng-click="vm.pageChange(vm.currentPage + 1)" ng-disabled="vm.currentPage === vm.getTotalPages()"><i ng-style="{\'color\': vm.currentPage === vm.getTotalPages() ? \'#888\' : \'#000\'}" class="fa fa-forward"></i></button></div></div><div class=block-accordion style="height:30rem; max-height:60rem;overflow-y: scroll  !important;"><div style="margin: 3rem;" class=content><div class=subscriptions><section ng-if="contactsServicesHistory !== null"><header class=grid--no-gutter><div class="label grid__col-3 grayText">{{\'REQUEST_ID\' | translate}}</div><div class="label grid__col-2 grayText" style="right: 7px;">{{\'CREATION_DATE\' | translate}}</div><div class="label grid__col-2 grayText">{{\'EXPIRATION_DATE\' | translate}}</div><div class="label grid__col-2 grayText">{{\'PROCESS_TYPE\' | translate}}</div><div class="label grid__col-2 grayText">{{\'REQUEST_STATUS\' | translate}} <span><i class="fa fa-refresh" ng-click=refreshSyncData() role=button style="padding-left: 5%;" ng-class="{\'nissanRefresh\': vm.nissanUserURL, \'renaultRefresh\': !vm.nissanUserURL}"></i></span></div><div class="label grid__col-1"></div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts borderDarkening" ng-if="vm.pagedContactsServicesHistory !== null"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.pagedContactsServicesHistory" ng-if="(isFromContOrTech === \'isContract\' && !(isArrayEmpty(item.sids) && !isArrayEmpty(item.uids))) || (isFromContOrTech === \'isTech\' && !(isArrayEmpty(item.uids) && !isArrayEmpty(item.sids)))"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-3 blackText">{{item.provisioningRequestId | rlinkformat}}</span> <span class="grid__col-2 blackText" style="right: 7px; position: relative;">{{item.creationDate | rlinkformat:\'full-date\'}}</span> <span class="grid__col-2 blackText">{{item.endDate | rlinkformat:\'full-date\'}}</span> <span class="grid__col-2 blackText">{{item.provisioningProcessType | rlinkformat | translate}}</span> <span class="grid__col-2 blackText" ng-style="{\n                                        \'color\': [\'ACTIVE\',\'ACTIVATED\',\'IN_PROGRESS\',\'TERMINATED\'].indexOf((item.reqStatus || \'\').toUpperCase()) !== -1 ? \'green\' :\n                                                 [\'DEACTIVATED\',\'FAILED\'].indexOf((item.reqStatus || \'\').toUpperCase()) !== -1 ? \'red\' :\n                                                 [\'CANCELLED\',\'REJECTED\',\'ABANDONED\'].indexOf((item.reqStatus || \'\').toUpperCase()) !== -1 ? \'orange\' : \'green\'\n                                      }" style="left: 3px; position: relative; word-break: break-all;">{{ item.status | rlinkformat | translate }} <span ng-if="[\'ABANDONED\', \'FAILED\', \'REJECTED\'].indexOf((item.reqStatus || \'\').toUpperCase()) !== -1" style="margin-left: 5px; cursor: pointer; position: relative;"><i class="fa fa-info-circle"></i><md-tooltip md-direction=right style="height: auto !important; max-width: 350px !important; white-space: normal;" md-class="status-tooltip-{{(item.reqStatus || \'\').toLowerCase()}}">{{ (item.reqStatus || \'\').toUpperCase() === \'REJECTED\' ? (\'SYCHIST_TOOLTIP_REJECTED\' | translate) : (item.reqStatus || \'\').toUpperCase() === \'FAILED\' ? (\'SYCHIST_TOOLTIP_FAILED\' | translate) : (item.reqStatus || \'\').toUpperCase() === \'ABANDONED\' ? (\'SYCHIST_TOOLTIP_ABANDONED\' | translate) : \'\' }}</md-tooltip></span></span><span class="arrow blackText"></span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if=contactsServicesHistory></i> <span class=arrow ng-if=!contactsServicesHistory></span></div></accordion-heading><div class="sub-header flex grid--no-gutter"><span style="position: relative;left: 15px;" ng-if="isFromContOrTech === \'isContract\'" class=grid__col-3>{{\'SERVICE_NAME\' | translate}}</span> <span style="position: relative;left: 15px;" ng-if="isFromContOrTech === \'isTech\'" class=grid__col-3>{{\'UID_NAME\' | translate}}</span> <span class=grid__col-2 ng-if="isFromContOrTech === \'isContract\'">{{\'EASYLINK_VEHICLE_SERVICE_ID\' | translate}}</span> <span class=grid__col-2 ng-if="isFromContOrTech === \'isTech\'">{{\'EASYLINK_VEHICLE_UID\' | translate}}</span> <span class=grid__col-2>{{\'STATUS_BEFORE_SYNC\' | translate}}</span> <span class=grid__col-2>{{\'STATUS_AFTER_SYNC\' | translate}}</span> <span class=grid__col-2>{{\'DATE_OF_LAST_UPDATE\' | translate}}</span> <span class=arrow>&nbsp;</span></div><div class="flex grid--no-gutter" ng-if="item.secondData.length > 0" ng-repeat="srv in item.secondData"><span style="position: relative;left: 15px;" class=grid__col-3>{{srv.name | rlinkformat}}</span> <span class=grid__col-2>{{srv.sid | rlinkformat}}</span> <span ng-style="{\'color\': srv.status === \'ACTIVATED\'? \'green\':\'red\'}" class=grid__col-2>{{srv.status | rlinkformat:\'status\'}}</span> <span ng-style="{\'color\': (srv.syncStatus === \'ACTIVATED\' || item.reqStatus === \'ACTIVE\' || item.reqStatus === \'IN_PROGRESS\')? \'green\':\'red\'}" class=grid__col-2 ng-if="item.reqStatus === \'IN_PROGRESS\'">{{item.status | rlinkformat | translate}} </span><span ng-style="{\'color\': (srv.syncStatus === \'ACTIVATED\' || item.reqStatus === \'ACTIVE\' || item.reqStatus === \'IN_PROGRESS\')? \'green\':\'red\'}" class=grid__col-2 ng-if="item.reqStatus === \'TERMINATED\'">{{srv.syncStatus | rlinkformat:\'status\'}} </span><span class=grid__col-2 ng-if="item.reqStatus !== \'IN_PROGRESS\' && item.reqStatus !== \'TERMINATED\'">- </span><span class=grid__col-2>{{srv.updatedAt | rlinkformat:\'full-date\'}}</span> <span class=arrow>&nbsp;</span></div><div ng-if="item.secondData.length == 0" class=block_text>{{\'NO_DATA_FOUND\' | translate}}</div></accordion-group></accordion></div><div ng-if="vm.pagedContactsServicesHistory === null || vm.pagedContactsServicesHistory.length === 0" class=block_text>{{\'NO_DATA_FOUND\' | translate}}</div></div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/popup/synchronizationPopup.template.html','<md-dialog class=app-modal style="width: 60rem; height: 450px; overflow: auto;"><div class="grid--no-gutter mapStatusHead" style="width: 60rem; right:0%; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.7rem;"></div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;" ng-if=isContractsSynchronization><p class=popUpSize translate=CONTRACTS_LAUNCH_POPUP_MSG style="font-size: var(--renaultMediumFont);"></p></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;" ng-if=isTechnicalSynchronization><p class=popUpSize translate=TECHNICAL_LAUNCH_POPUP_MSG style="font-size: var(--renaultMediumFont);"></p></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/evServices/popup/evServicePopup.html','<div class="app-modal diagStepsHead" ng-if="vm.menu == \'P2C\'"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'OFF_BOARD_DIAGNOSTIC_STEPS\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p ng-bind-html=p2cPopupMsg style="font-size: var(--renaultMediumFont);"></p></div><div class="app-modal diagStepsHead" ng-if="vm.menu == \'smartCharging\'" style="height: 15rem !important;"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'OFF_BOARD_DIAGNOSTIC_INFORMATION\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p translate=SMART_CHARGING_POPUP></p></div><div class=app-modal style="width: 36rem;font-family:var(--renaultFontRegular);" ng-if="vm.menu == \'mappingStatus\'"><div class="grid--no-gutter mapStatusHead"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'POSSIBLE_MAPPING_STATUS\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p translate=MAPPING_STATUS_POPUP_MSG></p></div><div class="app-modal diagStepsHead" ng-if="vm.menu == \'V2G\'"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'OFF_BOARD_DIAGNOSTIC_STEPS\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p ng-bind-html=v2gPopupMsg></p></div><div class="app-modal diagStepsHead" ng-if="vm.menu == \'V2GNew\'"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'OFF_BOARD_DIAGNOSTIC_STEPS\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p ng-bind-html=v2gPopupMsgNew></p></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Fota/content.html','<!-- ON GOING --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'CONNECTED_SERVICES_IN_PROGRESS_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsFota.length === 0 || (vm.updateCampaignsFota.ongoing && vm.updateCampaignsFota.ongoing.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsFota.ongoing && vm.updateCampaignsFota.ongoing.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Fota/ongoing.html\'"></div></div><!-- FUTURE --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'EASYLINK_VEHICLE_FUTURE_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsFota.length === 0 || (vm.updateCampaignsFota.future && vm.updateCampaignsFota.future.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsFota.future && vm.updateCampaignsFota.future.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Fota/future.html\'"></div></div><!-- EXPIRED --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'EASYLINK_VEHICLE_EXPIRED_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsFota.length === 0 || (vm.updateCampaignsFota.expired && vm.updateCampaignsFota.expired.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsFota.expired && vm.updateCampaignsFota.expired.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Fota/expired.html\'"></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Fota/expired.html','<section><header class=grid--no-gutter><div class="label grid__col-9" ng-click="vm.sortBy(\'name\', \'updateCampaignsFota\', \'expired\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsFota\' && status === \'expired\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'component\', \'updateCampaignsFota\', \'expired\');">{{\'EASYLINK_VEHICLE_COMPONENT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'component\' && campaigns === \'updateCampaignsFota\' && status === \'expired\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.updateCampaignsFota.expired"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-9>{{item.name | rlinkformat}}</span> <span class=grid__col-2>{{item.component | rlinkformat}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'fota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Fota/firmWareCampaign.html','<div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.paginatedFotaCampaigns | orderBy:\'-creationDateTime\'"><accordion-group class=ddpAccordBorder><accordion-heading><div class="sub_items_header section_header sub_items grid--no-gutter"><span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}}</span> <span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_CREATION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_LAST_UPDATE_TIME\' | translate}}</span> <span class=grid__col-2>{{\'COMMON_STATUS\' | translate}}</span> <span></span></div><div class="section_header sub_items grid--no-gutter word-break-text" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-3 campaignTitleName">{{item.name | rlinkformat}}<md-tooltip>{{item.name | rlinkformat}}</md-tooltip></span><span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{item.creationDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{item.lastUpdateDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.status}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'softwareCampaigns\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/softwareCampaign-accordion.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Fota/future.html','<section><header class=grid--no-gutter><div class="label grid__col-9" ng-click="vm.sortBy(\'name\', \'updateCampaignsFota\', \'future\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsFota\' && status === \'future\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'component\', \'updateCampaignsFota\', \'future\');">{{\'EASYLINK_VEHICLE_COMPONENT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'component\' && campaigns === \'updateCampaignsFota\' && status === \'future\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.updateCampaignsFota.future"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-9>{{item.name | rlinkformat}}</span> <span class=grid__col-2>{{item.component | rlinkformat}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'fota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Fota/ongoing.html','<section><header class=grid--no-gutter><div class="label grid__col-9" ng-click="vm.sortBy(\'name\', \'updateCampaignsFota\', \'ongoing\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsFota\' && status === \'ongoing\'"></span></div><div class="label grid__col-2" ng-click="vm.sortBy(\'component\', \'updateCampaignsFota\', \'ongoing\');">{{\'EASYLINK_VEHICLE_COMPONENT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'component\' && campaigns === \'updateCampaignsFota\' && status === \'ongoing\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.updateCampaignsFota.ongoing"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-9>{{item.name | rlinkformat}}</span> <span class=grid__col-2>{{item.component | rlinkformat}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'fota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Mota/content.html','<!-- ON GOING --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'CONNECTED_SERVICES_IN_PROGRESS_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsMota.length === 0 || (vm.updateCampaignsMota.ongoing && vm.updateCampaignsMota.ongoing.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsMota.ongoing.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Mota/ongoing.html\'"></div></div><!-- FUTURE --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'EASYLINK_VEHICLE_FUTURE_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsMota.length === 0 || (vm.updateCampaignsMota.future && vm.updateCampaignsMota.future.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsMota.future && vm.updateCampaignsMota.future.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Mota/future.html\'"></div></div><!-- EXPIRED --><div class=subscriptions><div class="accordion-heading-datas space-between flex"><span>{{\'EASYLINK_VEHICLE_EXPIRED_STATUS\' | translate}}</span></div><div class=flex ng-if="vm.updateCampaignsMota.length === 0 || (vm.updateCampaignsMota.expired && vm.updateCampaignsMota.expired.length === 0)"><div class=block_text>{{\'EASYLINK_VEHICLE_NO_UPDATE_CAMPAIGNS\' | translate}}</div></div><div ng-if="vm.updateCampaignsMota.expired && vm.updateCampaignsMota.expired.length > 0" ng-include src="\'app/components/car/rLinkCar/updateCampaigns/Mota/expired.html\'"></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Mota/expired.html','<section><header class=grid--no-gutter><div class="label grid__col-6" ng-click="vm.sortBy(\'name\', \'updateCampaignsMota\', \'expired\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsMota\' && status === \'expired\'"></span></div><div class="label grid__col-5" ng-click="vm.sortBy(\'updateVersion\', \'updateCampaignsMota\', \'expired\');">{{\'EASYLINK_VEHICLE_VERSION_UPDATE_INITIAL_FINAL\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'updateVersion\' && campaigns === \'updateCampaignsMota\' && status === \'expired\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.updateCampaignsMota.expired"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-6>{{item.name | rlinkformat}}</span> <span class=grid__col-5><span ng-if="item.smallVersionFrom !== null">{{item.smallVersionFrom + \' -> \' + item.smallVersionTo | rlinkformat}}</span> <span ng-if="item.smallVersionFrom === null">-</span> </span><i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'mota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Mota/future.html','<section><header class=grid--no-gutter><div class="label grid__col-6" ng-click="vm.sortBy(\'name\', \'updateCampaignsMota\', \'future\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsMota\' && status === \'future\'"></span></div><div class="label grid__col-5" ng-click="vm.sortBy(\'updateVersion\', \'updateCampaignsMota\', \'future\');">{{\'EASYLINK_VEHICLE_VERSION_UPDATE_INITIAL_FINAL\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'updateVersion\' && campaigns === \'updateCampaignsMota\' && status === \'future\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.updateCampaignsMota.future"><accordion-group><accordion-heading><div class="section_header sub_items" ng-click="item.isOpen = !item.isOpen;"><span class=campaignName>{{item.name | rlinkformat}}</span> <span class=updateVersion>{{item.updateVersion | rlinkformat:\'status\'}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'mota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Mota/mapCampaign.html','<div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.paginatedMotaCampaigns | orderBy:\'-creationDateTime\'"><accordion-group class=ddpAccordBorder><accordion-heading><div class="sub_items_header section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}}</span> <span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_CREATION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_LAST_UPDATE_TIME\' | translate}}</span> <span class=grid__col-2>{{\'COMMON_STATUS\' | translate}}</span></div><div class="section_header sub_items grid--no-gutter word-break-text" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-3 campaignTitleName">{{item.name | rlinkformat}}<md-tooltip>{{item.name | rlinkformat}}</md-tooltip></span><span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{item.creationDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{item.lastUpdateDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.status}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'mota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/Mota/ongoing.html','<section><header class=grid--no-gutter><div class="label grid__col-6" ng-click="vm.sortBy(\'name\', \'updateCampaignsMota\', \'ongoing\');">{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'name\' && campaigns === \'updateCampaignsMota\' && status === \'ongoing\'"></span></div><div class="label grid__col-5" ng-click="vm.sortBy(\'updateVersion\', \'updateCampaignsMota\', \'ongoing\');">{{\'EASYLINK_VEHICLE_VERSION_UPDATE_INITIAL_FINAL\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'updateVersion\' && campaigns === \'updateCampaignsMota\' && status === \'ongoing\'"></span></div><div class="label arrow"></div></header></section><div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=false ng-repeat="item in vm.updateCampaignsMota.ongoing"><accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-6>{{item.name | rlinkformat}}</span> <span class=grid__col-5>{{item.updateVersion | rlinkformat:\'status\'}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'mota\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/common/accordion-content.html','<div ng-if=!vm.vehicleInformationDisplay class="flex sub_items_header grid--no-gutter"><span class=grid__col-2>{{\'COMMON_STATUS\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class=grid__col-1>{{\'EASYLINK_VEHICLE_PRIORITY\' | translate}}</span> <span class=grid__col-2 ng-if="campaignType === \'mota\'">{{\'EASYLINK_VEHICLE_CAMPAIGN_TYPE\' | translate}}</span> <span class=grid__col-2 ng-if="campaignType === \'mota\'">{{\'EASYLINK_VEHICLE_FULL_MAP_VERSION\' | translate}}</span> <span class=grid__col-5 ng-if="campaignType === \'fota\'">{{\'EASYLINK_VEHICLE_UPDATE_TYPE_RELEASE\' | translate}}</span></div><div ng-if=!vm.vehicleInformationDisplay class="flex sub_items_content grid--no-gutter"><span class=grid__col-2>{{item.status | rlinkformat:\'status\'}}</span> <span class=grid__col-2>{{item.startDatetime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.endDatetime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1>{{\'EASYLINK_VEHICLE_\'+ item.priority | translate}}</span> <span class=grid__col-2 ng-if="campaignType === \'mota\'">{{\'EASYLINK_VEHICLE_\' + item.source | translate }}</span> <span class=grid__col-2 ng-if="campaignType === \'mota\'">{{item.fullMapVersion | rlinkformat}}</span> <span class=grid__col-5 ng-if="campaignType === \'fota\'">{{item.updateContent | rlinkformat}}</span></div><div ng-if=!vm.vehicleInformationDisplay class=separator></div><div ng-if=!vm.vehicleInformationDisplay class="flex sub_items_header grid--no-gutter"><span class=grid__col-3>{{\'EASYLINK_VEHICLE_VEHICLE_EXECUTION_DATE\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_UPDATE_STATUS\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_CURRENT_ATTEMPT\' | translate}}</span> <span class=grid__col-3 ng-if="campaignType === \'fota\'">{{\'EASYLINK_VEHICLE_OTS_NUMBER\' | translate}}</span></div><div ng-if=!vm.vehicleInformationDisplay class="flex sub_items_content grid--no-gutter"><span class=grid__col-3>{{item.vehicleExecutionDatetime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_\' + item.vehicleUpdateStatus | uppercase | translate}}</span> <span class=grid__col-3>{{item.currentRetries | rlinkformat}}</span> <span class=grid__col-3>{{item.otsNumber | rlinkformat}}</span></div><!--Remote Update - Map Block--><div ng-if="vm.vehicleInformationDisplay && campaignType === \'mota\'"><div class=grayBorderSeperator></div><div class="softwareTop7 flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_UPDATED_REGION\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_ADDITIONAL_DETAILS\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_ID\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span></div><div class="softwareTop7 flex sub_items_content grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{item.updatedRegion | rlinkformat}}</span> <span class=grid__col-2><span ng-if=!item.scomoContent>{{\'-\'}}</span> <span ng-if=item.scomoContent class="icon eye-plus-outline"><md-tooltip style="height: auto !important; max-width: 600px !important; white-space: normal;">{{item.scomoContent | rlinkformat}}</md-tooltip></span></span><span class=grid__col-3>{{item.id | rlinkformat}}</span> <span class=grid__col-2>{{item.startDateTime | rlinkformat:\'full-date\'}}</span></div><div class="flex sub_items_content grid--no-gutter"><span class="centerText sub_items_header grayRightBorder grid__col-2">{{\'EASYLINK_VEHICLE_CAMPAIGN_INFO\' | translate | uppercase}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span> <span class=grid__col-2></span> <span class=grid__col-3></span> <span class=grid__col-2></span></div><div class="flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_EXECUTION_DATE\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_PRIORITY\' | translate}}</span> <span class=grid__col-2></span></div><div class="flex sub_items_content grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{item.endDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.vehicleExecutionDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_\'+ item.priority | translate}}</span> <span class=grid__col-2></span></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/common/inventoryCampaign-accordion.html','<!--Inventory Campaign--><div ng-if="vm.vehicleInformationDisplay && campaignType === \'inventCamp\'" class=inventoryHeight><div class=grayBorderSeperator></div><div class="flex sub_items_header grid--no-gutter"><span class="inventoryTop5 grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_ID\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_NATURE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span></div><div class="flex sub_items_content grid--no-gutter word-break-text"><span class="inventoryTop5 grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{item.id | rlinkformat}}</span> <span class=grid__col-2>{{item.nature | rlinkformat}}</span> <span class=grid__col-1></span> <span class=grid__col-2>{{item.startDateTime | rlinkformat:\'full-date\'}}</span></div><div class="inventoryTop5 flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2">{{\'EASYLINK_VEHICLE_CAMPAIGN_INFO\' | translate | uppercase}}</span> <span class=grid__col-2></span> <span class=grid__col-3></span> <span class=grid__col-2></span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div ng-if=vm.vehicleInformationDisplay class="flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_EXECUTION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div ng-if=vm.vehicleInformationDisplay class="flex sub_items_content grid--no-gutter word-break-text"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{item.endDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.executionDatetime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div></div><!--Map Inventory Campaign--><div ng-if="vm.vehicleInformationDisplay && campaignType === \'mapInventCamp\'" class=inventoryHeight><div class=grayBorderSeperator></div><div class="flex sub_items_header grid--no-gutter"><span class="inventoryTop5 grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_ID\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div class="flex sub_items_content grid--no-gutter word-break-text"><span class="inventoryTop5 grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{item.id | rlinkformat}}</span> <span class=grid__col-2>{{item.startDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div class="inventoryTop5 flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2">{{\'EASYLINK_VEHICLE_CAMPAIGN_INFO\' | translate | uppercase}}</span> <span class=grid__col-2></span> <span class=grid__col-3></span> <span class=grid__col-2></span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div ng-if=vm.vehicleInformationDisplay class="flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_EXECUTION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div><div ng-if=vm.vehicleInformationDisplay class="flex sub_items_content grid--no-gutter word-break-text"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-2></span> <span class=grid__col-3>{{item.endDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.vehicleExecutionDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/common/softwareCampaign-accordion.html','<!--Remote Update - Firmware--><div ng-if="vm.vehicleInformationDisplay && campaignType === \'softwareCampaigns\'" class=softwareHeight><div class=grayBorderSeperator></div><div class="softwareTop7 flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_CUST_CAMPAIGN_NAME\' | translate}} </span><span class=grid__col-2>{{\'EASYLINK_VEHICLE_RELEASE_NOTES\' | translate}} </span><span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_ID\' | translate}}</span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_START_DATE\' | translate}}</span></div><div class="softwareTop7 flex sub_items_content grid--no-gutter word-break-text"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{item.customerCampaignName | rlinkformat}}</span> <span ng-if=item.customerCampaignReleaseNote class="grid__col-2 release-note-popin-anchor" ng-click="item.showReleaseNotePopin = !item.showReleaseNotePopin"><i style="width: 24px; height: 18px;" class="icon eye-plus-outline"></i><div class="popin see-more" ng-if=item.showReleaseNotePopin ng-click=$event.stopPropagation()><div class=popin--header><div>{{\'EASYLINK_VEHICLE_RELEASE_NOTES\' | translate}}</div><div class="icon close-popin" ng-click="item.showReleaseNotePopin = false; $event.stopPropagation()">X</div></div><div class=popin--content><div>{{item.customerCampaignReleaseNote | rlinkformat}} <i class="fa fa-files-o copy-icon" title="{{\'COPY_TO_CLIPBOARD\' | translate}}" ng-click="vm.copyToClipboard(item.customerCampaignReleaseNote); $event.stopPropagation()" ng-keypress="$event.keyCode === 13 && vm.copyToClipboard(item.customerCampaignReleaseNote)"></i></div></div></div></span><span class=grid__col-2 ng-if=!item.customerCampaignReleaseNote>- </span><span class=grid__col-3>{{item.id | rlinkformat}}</span> <span class=grid__col-2>{{item.startDateTime | rlinkformat:\'full-date\'}}</span></div><div class="flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder grid__col-2">{{\'EASYLINK_VEHICLE_CAMPAIGN_INFO\' | translate | uppercase}}</span> <span class=grid__col-1></span> <span class=grid__col-2></span> <span class=grid__col-2></span> <span class=grid__col-3></span> <span class=grid__col-2></span></div><div class="softwareBottom7 flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_NATURE\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_PRIORITY\' | translate}}</span> <span class=grid__col-2></span></div><div class="softwareBottom7 flex sub_items_content grid--no-gutter word-break-text"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{item.endDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.nature | rlinkformat}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_\'+ item.priority | translate}}</span> <span class=grid__col-2></span></div><div class=grayBorderSeperator></div><div class="inventoryTop10 flex sub_items_header grid--no-gutter"><span class="centerText grayRightBorder firmWareTop13 grid__col-2">{{\'EASYLINK_VEHICLE_UPDATE_DESCRIPTION\' | translate | uppercase}}</span> <span class=grid__col-1></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_ECU\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_FROM_VERSION\' | translate}}</span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_TO_VERSION\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_OTS\' | translate}}</span></div><div class="softwareTop2 flex sub_items_header grid--no-gutter"><span class="grayRightBorder grid__col-2"></span> <span class="firmWareLeft firmWareBottomBorder grid__col-1"></span> <span class="firmWareBottomBorder grid__col-2"></span> <span class="firmWareBottomBorder grid__col-2"></span> <span class="firmWareBottomBorder grid__col-3"></span> <span class="firmWareLastBorder grid__col-2"></span></div><div ng-repeat="ecuInfo in item.ecusDetails" class="flex sub_items_content grid--no-gutter word-break-text"><span class="grayRightBorder grid__col-2"></span> <span class=grid__col-1></span> <span class=grid__col-2>{{ecuInfo.ecu | rlinkformat}}</span> <span class=grid__col-2>{{ecuInfo.fromVersion | rlinkformat}}</span> <span class=grid__col-3>{{ecuInfo.toVersion | rlinkformat}}</span> <span class=grid__col-2><span ng-if=item.otsNumber>{{item.otsNumber | rlinkformat}}</span></span></div><div ng-if="!item.ecusDetails || item.ecusDetails.length === 0" class="flex sub_items_content grid--no-gutter"><span class="grayRightBorder grid__col-2 fotaBorder"></span> <span class=grid__col-1></span> <span class=grid__col-2>-</span> <span class=grid__col-2>-</span> <span class=grid__col-3>-</span> <span class=grid__col-2>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/inventory/inventoryCampaign.html','<div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.paginatedInventoryCampaigns"><accordion-group class=ddpAccordBorder><accordion-heading><div class="sub_items_header section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}}</span> <span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_CREATION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_LAST_UPDATE_TIME\' | translate}}</span> <span class=grid__col-2>{{\'COMMON_STATUS\' | translate}}</span></div><div class="section_header sub_items grid--no-gutter word-break-text" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-3 campaignTitleName">{{item.name | rlinkformat}}<md-tooltip>{{item.name | rlinkformat}}</md-tooltip></span><span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{item.creationDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{item.lastUpdateDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.status}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'inventCamp\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/inventoryCampaign-accordion.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/inventory/mapInventoryCampaign.html','<div class="block-accordion list"><accordion class="collapse section_wrapper" close-others=true ng-repeat="item in vm.paginatedMapInventoryCampaigns"><accordion-group class=ddpAccordBorder><accordion-heading><div class="sub_items_header section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;" ng-keydown="$event.key === \'Enter\' && (item.isOpen = !item.isOpen)"><span class=grid__col-3>{{\'EASYLINK_VEHICLE_CAMPAIGN_NAME\' | translate}}</span> <span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_CREATION_DATE\' | translate}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{\'EASYLINK_VEHICLE_MAP_LAST_UPDATE_TIME\' | translate}}</span> <span class=grid__col-2>{{\'COMMON_STATUS\' | translate}}</span></div><div class="section_header sub_items grid--no-gutter word-break-text" ng-click="item.isOpen = !item.isOpen;" ng-keydown="$event.key === \'Enter\' && (item.isOpen = !item.isOpen)"><span class="grid__col-3 campaignTitleName">{{item.name | rlinkformat}}<md-tooltip>{{item.name | rlinkformat}}</md-tooltip></span><span class="grid__col-0.5 ddpColWidth"></span> <span class=grid__col-2>{{item.creationDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-1></span> <span class=grid__col-3>{{item.lastUpdateDateTime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.status}}</span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.details != \'\'"></i> <span class=arrow ng-if="item.details == \'\'"></span></div></accordion-heading><div ng-include ng-init="campaignType=\'mapInventCamp\'" src="\'app/components/car/rLinkCar/updateCampaigns/common/inventoryCampaign-accordion.html\'"></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/updateCampaigns/inventory/vehicleInventory.html','<!--Vehicle Inventory--><table ng-if="vm.vehicleInformationDisplay && campaignType === \'vehicleInventory\'" style="max-height: fit-content;"><tbody class=vehInventTable><tr class="flex sub_items_header grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td class="rowCol1 grayRightBorder vehInventLabel grid__col-3"></td><td class="vehInventLabel grid__col-1"></td><td class="vehInventLabel grid__col-2">{{(vm.isCCS3 ? \'EASYLINK_VEHICLE_CDC_PART_NO\' : \'EASYLINK_VEHICLE_IVI_PART_NO\') | translate}}</td><td class="vehInventLabel grid__col-2">{{(vm.isCCS3 ? \'EASYLINK_VEHICLE_CONFIG_FILE_CDC\' : \'EASYLINK_VEHICLE_CONFIG_FILE_IVI\') | translate}}</td><td class="vehInventLabel grid__col-2">{{(vm.isCCS3 ? \'EASYLINK_VEHICLE_CALIBRATION_FILE_CDC\' : \'EASYLINK_VEHICLE_CALIBRATION_FILE_IVI\') | translate}}</td><td class="vehInventLabel grid__col-2"></td></tr><tr class="flex sub_items_content grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td class="grayRightBorder grid__col-3"></td><td class=grid__col-1></td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.huPartNo | rlinkformat}}</td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.huConfigFile | rlinkformat}}</td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.huCalibrationFile | rlinkformat}}</td><td class=grid__col-2></td></tr><tr class="flex sub_items_content grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td class="rowCol3 grayRightBorder vehInventLabel grid__col-3"><i class="fa fa-circle" ng-style="{\'color\':vm.updateCampaignsVehInventory.huPresent === \'YES\' ? \'green\' : \'red\'}"></i><span class=leftLabel>{{(vm.isCCS3 ? \'EASYLINK_VEHICLE_CDC\' : \'EASYLINK_VEHICLE_HU\') | translate}}</span></td><td class="vehInventLabel grid__col-1"></td><td class="vehInventLabel grid__col-2"></td><td class="vehInventLabel grid__col-2"></td><td class="vehInventLabel grid__col-2"></td><td class="vehInventLabel grid__col-2"></td></tr><tr class="vehBottom20 flex sub_items_header grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td class="rowCol4 grayRightBorder vehInventLabel grid__col-3"></td><td class="grayLeftBorder vehInventLabel grid__col-1"></td><td class="vehInventLabel grid__col-2">{{\'EASYLINK_VEHICLE_SYSTEM_TYPE\' | translate}}</td><td class="vehInventLabel grid__col-2"></td><td class="vehInventLabel grid__col-2"></td><td class="vehInventLabel grid__col-2"></td></tr><tr class="vehBottom20 flex sub_items_content grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td class="bottom3 grayRightBorder grid__col-3"></td><td class=grid__col-1></td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.huMtcCriteria | rlinkformat}} <span><div style="position: relative;display: inline-block; top: 5px;"><span class="icon eye-plus-outline" ng-click="vm.showPopin = !vm.showPopin" style="width: 20px; right: 1px; top: 3px;"></span><div class="popin see-more" ng-if=vm.showPopin><div style="color: black;" class=popin--header><div>{{\'CONNECTED_SERVICES_SYSTEM_TYPE\' | translate}}</div><div style="color: black;" class="icon close-popin" ng-click="vm.showPopin = false">X</div></div><div class=popin--content><div>{{\'EASYLINK_RADNAV\' | translate}} : {{vm.updateCampaignsVehInventory.huName | rlinkformat}}</div><div>{{\'EASYLINK_SHORT_DESCRIPTION\' | translate}} : {{vm.updateCampaignsVehInventory.huRadnavSysTypeDesc | rlinkformat}}</div></div></div></div></span></td><td class=grid__col-2></td><td class=grid__col-2></td><td class=grid__col-2></td></tr><tr class="flex sub_items_header grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.tcuPresent === \'YES\'"><td class="grayRightBorder vehInventLabel vehLabelTop grid__col-3"><i class="fa fa-circle" ng-style="{\'color\':vm.updateCampaignsVehInventory.tcuPresent === \'YES\' ? \'green\' : \'red\'}"></i><span class=leftLabel>{{\'EASYLINK_VEHICLE_TCU\' | translate}}</span></td><td class="vehInventLabel grid__col-1"></td><td class="vehInventLabel grid__col-2">{{\'EASYLINK_VEHICLE_CALIBRATION_FILE_IVC\' | translate}}</td><td class="vehInventLabel grid__col-2">{{\'EASYLINK_VEHICLE_CONFIG_FILE_IVC\' | translate}}</td><td class="vehInventLabel grid__col-2">{{\'EASYLINK_VEHICLE_IVC_TELECOM_UNIT_TYPE\' | translate}}</td><td class="vehInventLabel grid__col-2"></td></tr><tr class="flex sub_items_content grid--no-gutter" ng-if="vm.updateCampaignsVehInventory.tcuPresent === \'YES\'"><td class="vehBottom grid__col-3"></td><td class=grid__col-1></td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.tcuPartNo | rlinkformat}}</td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.tcuConfigFile | rlinkformat}}</td><td class=grid__col-2>{{vm.updateCampaignsVehInventory.tcuType | rlinkformat}}</td><td class=grid__col-2></td></tr><tr class="flex sub_items_content grid--no-gutter" ng-if="!vm.updateCampaignsVehInventory.huPresent === \'YES\'"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td><button ng-click=vm.openEcusInfo() style="font-size: var(--renaultSmallFont); background-color: var(--renaultPrimaryColor); color: #fff; margin-bottom: 0px !important; padding: 11px 16px 11px 16px;margin-left: 44px; float: right;border: none;" ng-class="{\'nissanActiveMenuTab\': vm.nissanUserURL, \'renaultBgTabColor\': !vm.nissanUserURL}">{{\'ECUS\' | translate}}</button></td></tr></tbody></table>');
$templateCache.put('app/components/car/rLinkCar/remoteServices/popup/remoteServicesPopup.html','<div class="app-modal diagStepsHead" style="height: 16rem !important;" ng-if="vm.popupWindow ===\'remoteServices\'"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'INFORMATION_DIAGNOSTIC\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p translate=REMOTE_SERVICES_POPUP></p></div><div class="app-modal diagStepsHead" ng-if="vm.popupWindow === \'statusDescription\'"><div class="grid--no-gutter diagStepsHeadDetails"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'REMOTE_SERVICES_STATUS_DESCRIPTION\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><p translate=REMOTE_SERVICES_STATUS_DESCRIPTION_POPUP style="margin-top: 2rem;"></p><img src=./assets/images/remoteServicesNew.png></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/adasAndEhorizon.html','<div class="block-accordion contracts" ng-show=vm.isEasyLink style="margin-top:0; width: 72rem;" ng-if=vm.adasEhorizonInformationDisplay><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.adasEhorizonContracts.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpen = !$scope.isOpen"><span>ISA/ eHorizon UID 920</span> <i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=adas-status-container><div class=adas-status-row><span class=adas-status-text ng-class="vm.isAdasTab ? \'adas-status-eligible\' : \'adas-status-noneligible\'"><i class="fa fa-circle adas-status-icon" ng-class="vm.isAdasTab ? \'adas-status-green\' : \'adas-status-red\'"></i> {{ vm.isAdasTab ? (\'SERVICE_ELIGIBLE\' | translate) : (\'SERVICE_NONELIGIBLE\' | translate) }} </span><span class=adas-status-text ng-class="vm.isAdasActivated ? \'adas-status-activated\' : \'adas-status-inactivated\'"><i class="fa fa-circle adas-status-icon" ng-class="vm.isAdasActivated ? \'adas-status-green\' : \'adas-status-red\'"></i> {{ vm.isAdasActivated ? (\'SERVICE_ACTIVATED\' | translate) : (\'SERVICE_INACTIVATED\' | translate) }}</span></div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.adasEhorizonContracts.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpen = !$scope.isOpen"><span>{{\'EASYLINK_ADAS_EHORIZON_CONTRACTS\' | translate}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions><section style=border-top:0><header class=grid--no-gutter><div class="label grid__col-3">{{\'EASYLINK_ADAS_PRODUCT\' | translate}}</div><div class="label grid__col-3">{{\'EASYLINK_ADAS_START_DATE\' | translate}}</div><div class="label grid__col-3">{{\'EASYLINK_ADAS_END_DATE\' | translate}}</div><div class="label grid__col-3">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}}</div><div class="label arrow"></div></header></section><div class="block-accordion list-contracts"><accordion ng-repeat="item in vm.adasEhorizonData.contracts" class=section_wrapper><div class="section_header sub_items grid--no-gutter"><span class=grid__col-3>{{item.product | rlinkformat}}</span> <span class=grid__col-3>{{item.startDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-3>{{item.endDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-3>{{item.contractId | rlinkformat}}</span></div></accordion></div></div><div ng-if="(vm.adasEhorizonData.contracts.length === 0 || !vm.adasEhorizonData.contracts.length)"><div class=block_text>{{\'EASYLINK_ADAS_NO_CONTRACT_SERVICES \' | translate}}</div></div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.adasEhorizonDiagnostic.isOpen><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpen = !$scope.isOpen"><span>{{\'EASYLINK_ADAS_EHORIZON_DIAGNOSTIC\' | translate}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions><section style=border-top:0><header class=grid--no-gutter><div class="label grid__col-1">{{\'EASYLINK_ADAS_SYSTEM\' | translate}}</div><div class="label grid__col-3">{{\'EASYLINK_ADAS_LISENCE_ID\' | translate}}</div><div class="label grid__col-1" style="margin-left: -3rem">{{\'EASYLINK_ADAS_FLEET_ID\' | translate}}</div><div class="label grid__col-2" style="margin-left: 0.6rem">{{\'EASYLINK_ADAS_PART_ID\' | translate}}</div><div class="label grid__col-1" style="margin-left: -2rem">{{\'EASYLINK_ADAS_START_DATE\' | translate}}</div><div class="label grid__col-1">{{\'EASYLINK_ADAS_END_DATE\' | translate}}</div><div class="label grid__col-1">{{\'EASYLINK_ADAS_PRODUCT\' | translate}}</div><div class="label grid__col-1 force-text-wrap" style="margin-left: -1rem;">{{\'EASYLINK_ADAS_PRODUCT_START_DATE\' | translate}}</div><div class="label grid__col-1 force-text-wrap" style="margin-left: 2rem">{{\'EASYLINK_ADAS_PRODUCT_END_DATE\' | translate}}</div><div class="label arrow"></div></header></section><div ng-if="vm.adasEhorizonData.currentLicense.continentalData.license && vm.adasEhorizonData.currentLicense.ehorizonData" class="block-accordion list-contracts" style="text-transform: uppercase;"><accordion class="collapse section_wrapper" close-others=false><div ng-if=vm.diagnosisEhorizon class="section_header sub_items grid--no-gutter" style="position: relative;height: 5rem;font-size: var(--renaultSmallFont) !important;" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-1>{{vm.diagnosisEhorizon.systemId | rlinkformat}}</span> <span class=grid__col-3>{{vm.diagnosisEhorizon.licenseId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -3rem">{{vm.diagnosisEhorizon.fleetId | rlinkformat}}</span> <span class=grid__col-2 style="margin-left: 0.6rem">{{vm.diagnosisEhorizon.deviceId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -2rem">{{vm.diagnosisEhorizon.startDate | rlinkformat:\'date\'}}</span> <span class=grid__col-1>{{vm.diagnosisEhorizon.endDate | rlinkformat:\'date\'}}</span><div class=grid__col-1><span ng-repeat="itemehorizonData in vm.diagnosisEhorizon.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.name | rlinkformat}}</span><br ng-if=!$last></span></div><div class=grid__col-1><span class=grid__col-3 ng-repeat="itemehorizonData in vm.diagnosisEhorizon.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.startDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="margin-left: 3.8rem; position: relative;"><span class=grid__col-3 ng-repeat="itemehorizonData in vm.diagnosisEhorizon.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.endDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div></div><div ng-if=vm.diagnosiscontinentalData.license class="section_header sub_items grid--no-gutter" style="background-color: #ededed; font-size: var(--renaultSmallFont) !important;" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><div class=grid__col-1><div ng-style="{\'margin-top\': (vm.continentalLicenseRevoked === null || vm.continentalLicenseRevoked === \'\') ? \'-16px\' : \'0px\'}" style="font-size: 11px;">{{vm.diagnosiscontinentalData.license.systemId | rlinkformat}}</div><div class=statusValid><span ng-if="vm.continentalLicenseRevoked === false" class="adas-tag adas-tag-valid">{{\'ADAS_STATUS_VALID\' | translate}} </span><span ng-if="vm.continentalLicenseRevoked === true" class="adas-tag adas-tag-invalid">{{\'ADAS_STATUS_INVALID\' | translate}}</span></div></div><span class=grid__col-3 style="margin-bottom: 23px;">{{vm.diagnosiscontinentalData.license.licenseId | rlinkformat}}</span> <span class=grid__col-1 style="margin-bottom: 23px;margin-left: -3rem">{{vm.diagnosiscontinentalData.license.fleetId | rlinkformat}}</span> <span class=grid__col-2 style="margin-bottom: 23px;margin-left: 0.6rem">{{vm.diagnosiscontinentalData.license.deviceId | rlinkformat}}</span> <span class=grid__col-1 style="margin-bottom: 23px;margin-left: -2rem">{{vm.diagnosiscontinentalData.license.startDate | rlinkformat:\'date\'}}</span> <span class=grid__col-1 style="margin-bottom: 23px;">{{vm.diagnosiscontinentalData.license.endDate | rlinkformat:\'date\'}}</span><div class=grid__col-1 style="margin-bottom: 23px;"><span ng-repeat="continentalData in vm.diagnosiscontinentalData.license.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.name | rlinkformat}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="margin-bottom: 23px;"><span class=grid__col-3 ng-repeat="continentalData in vm.diagnosiscontinentalData.license.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.startDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="margin-left: 3.8rem;margin-bottom: 23px;"><span class=grid__col-3 ng-repeat="continentalData in vm.diagnosiscontinentalData.license.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.endDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div></div></accordion></div><div ng-if="!vm.diagnosisEhorizon && !vm.diagnosiscontinentalData"><div class=block_text style="font-size: var(--renaultMediumFont);">{{\'EASYLINK_ADAS_NO_EHORIZON_DIAGNOSTIC_SERVICES \' | translate}}</div></div></div><div style="text-transform: uppercase; font-size: var(--renaultMediumFont);">{{\'EASYLINK_ADAS_LAST_CONNECTION_DATE\' | translate}}: {{vm.diagnosiscontinentalData.lastConnectionDate | rlinkformat:\'full-date\'}}</div></accordion-group></accordion><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.adasEhorizonEventHistory.isOpen><accordion-heading><div class=section_header style="cursor: default; margin-bottom: 12px" ng-click="$scope.isOpen = !$scope.isOpen"><span>{{\'EASYLINK_ADAS_EHORIZON_DIAGNOSTIC_EVENT_HISTORY\' | translate}}</span> <i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><accordion class="collapse section_wrapper" close-others=false><accordion-group ng-repeat="item in vm.adasEhorizonData.licenseEventsHistory"><accordion-heading><div class=section_header style="cursor: default;" ng-click="$scope.isOpenCommercialServices1 = !$scope.isOpenCommercialServices1;"><span>{{item.eventTimestamp | rlinkformat:\'full-date\'}} {{item.eventType | lowercase | rlinkformat}}</span> <i ng-class="\' icon-arrow_\'+($scope.isOpenCommercialServices ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions><section style=border-top:0><header ng-if="item.eventType === \'LicenseReplacementEvent\' || item.eventType === \'LicenseCreatedEvent\'" class=grid--no-gutter><div class="label grid__col-1">{{\'EASYLINK_ADAS_SYSTEM\' | translate}}</div><div class="label grid__col-3">{{\'EASYLINK_ADAS_LISENCE_ID\' | translate}}</div><div class="label grid__col-1" style="margin-left: -3rem">{{\'EASYLINK_ADAS_FLEET_ID\' | translate}}</div><div class="label grid__col-2" style="margin-left: 1rem">{{\'EASYLINK_ADAS_PART_ID\' | translate}}</div><div class="label grid__col-1" style="margin-left: -2rem">{{\'EASYLINK_ADAS_START_DATE\' | translate}}</div><div class="label grid__col-1">{{\'EASYLINK_ADAS_END_DATE\' | translate}}</div><div class="label grid__col-1" style="margin-left: 0.2rem;">{{\'EASYLINK_ADAS_PRODUCT\' | translate}}</div><div class="label grid__col-1 force-text-wrap">{{\'EASYLINK_ADAS_PRODUCT_START_DATE\' | translate}}</div><div class="label grid__col-1 force-text-wrap" style="margin-left: 2rem">{{\'EASYLINK_ADAS_PRODUCT_END_DATE\' | translate}}</div><div class="label arrow"></div></header><header ng-if="item.eventType === \'ContractCreatedEvent\'" class=grid--no-gutter><div class="label grid__col-2">{{\'EASYLINK_ADAS_PRODUCT\' | translate}}</div><div class="label grid__col-2">{{\'EASYLINK_ADAS_START_DATE\' | translate}}</div><div class="label grid__col-2">{{\'EASYLINK_ADAS_END_DATE\' | translate}}</div><div class="label grid__col-2">{{\'EASYLINK_ADAS_CONTRACT_ID\' | translate}}</div><div class="label arrow"></div></header></section><div ng-if="item.eventType === \'LicenseReplacementEvent\' || item.eventType === \'LicenseCreatedEvent\'" class="block-accordion list-contracts" style="text-transform: uppercase;"><accordion class="collapse section_wrapper" close-others=false><div class="section_header sub_items grid--no-gutter" style="border-bottom: 1px solid;position: relative;height: 5rem;font-size: var(--renaultSmallFont) !important;" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-1>{{vm.eventHistoryEhorizonData | rlinkformat}}</span> <span class=grid__col-3>{{item.licenseId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -3rem">{{item.ehorizonData.fleetId | rlinkformat}}</span> <span class=grid__col-2 style="margin-left: 1rem">{{item.deviceId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -2rem">{{item.ehorizonData.startDate | rlinkformat:\'date\'}}</span> <span class=grid__col-1>{{item.ehorizonData.endDate | rlinkformat:\'date\'}}</span><div class=grid__col-1 style="position: relative; margin-top: 1rem; margin-left: 0.2rem;"><span ng-repeat="itemehorizonData in item.ehorizonData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.name | rlinkformat}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="position: relative; margin-top: 1rem;"><span class=grid__col-3 ng-repeat="itemehorizonData in item.ehorizonData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.startDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="margin-left: 3.8rem; position: relative; margin-top: 1rem;"><span class=grid__col-3 ng-repeat="itemehorizonData in item.ehorizonData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{itemehorizonData.endDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div></div><div class="section_header sub_items grid--no-gutter" style="background-color: #ededed;font-size: var(--renaultSmallFont) !important;" ng-click="vm.overrideAccordionOpening(item, $event); item.isOpen = !item.isOpen;"><span class=grid__col-1>{{vm.eventHistoryContinentalData | rlinkformat}}</span> <span class=grid__col-3>{{item.licenseId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -3rem">{{item.continentalData.fleetId | rlinkformat}}</span> <span class=grid__col-2 style="margin-left: 1rem">{{item.deviceId | rlinkformat}}</span> <span class=grid__col-1 style="margin-left: -2rem">{{item.continentalData.startDate | rlinkformat:\'date\'}}</span> <span class=grid__col-1>{{item.continentalData.endDate | rlinkformat:\'date\'}}</span><div class=grid__col-1><span ng-repeat="continentalData in item.continentalData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.name | rlinkformat}}</span><br ng-if=!$last></span></div><div class=grid__col-1><span class=grid__col-3 ng-repeat="continentalData in item.continentalData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.startDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div><div class=grid__col-1 style="margin-left: 3.8rem"><span class=grid__col-3 ng-repeat="continentalData in item.continentalData.products">{{$index > 0 ? \' \' : \' \'}} <span>{{continentalData.endDate | rlinkformat:\'date\'}}</span><br ng-if=!$last></span></div></div></accordion></div><div ng-if="item.eventType === \'ContractCreatedEvent\'" class="block-accordion list-contracts"><accordion ng-repeat="item in item.ehorizonData.contracts" class=section_wrapper><div class="section_header sub_items grid--no-gutter"><span class=grid__col-2>{{item.product | rlinkformat}}</span> <span class=grid__col-2>{{item.startDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.endDate | rlinkformat:\'full-date\'}}</span> <span class=grid__col-2>{{item.contractId | rlinkformat}}</span></div></accordion></div></div></accordion-group></accordion><div ng-if="vm.adasEhorizonData.licenseEventsHistory.length === 0"><div class=block_text>{{\'EASYLINK_ADAS_NO_EHORIZON_DIAGNOSTIC_EVENT_HISTORY_SERVICES \' | translate}}</div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/favoriteCountryContent.html','<div class="block-accordion content" style="margin-bottom: 0"><div class=flex><select class=selectedRegion ng-model-options="{ debounce: 100 }" type=text ng-model=region ng-change=vm.selectedRegion(region) ng-options="region.regionSetLabel for region in vm.map.availableRegions | orderBy:\'regionSetLabel\' track by region.regionSetId"><option value="">{{\'EASYLINK_VEHICLE_CHOICE_OF_FAVORITE_COUNTRY\' | translate}}</option></select> <button ng-if="vm.userType === \'ARCA\'" class="cs-btn buttonWithIcon" ng-click=vm.updateFavoriteCountry()><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'EASYLINK_VEHICLE_UPDATE\' | translate}}</div></button> <button class="cs-btn buttonWithIcon" ng-click=vm.showHistory()><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'HISTORY_INFORMATION\' | translate}}</div></button></div><div class="flex warning-message" style="padding:0; margin: 1rem 0 0 0"><i class=icon-warning style="margin-left: 0"></i> {{\'EASYLINK_VEHICLE_FAVORITE_COUNTRY_WARNING\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/historyModal.html','<div class=app-modal style="padding: 10px;width:950px;"><div class=header-modal><span style="font-family: var(--renaultFontBold);">{{\'EASYLINK_VEHICLE_HISTORY\' | translate}}</span> <span ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span></div><any ng-if="history !== null"><section><header class=grid--no-gutter><div class="label grid__col-4" ng-click="sortBy(\'status\', \'favouriteRegionHistory\');">{{\'COMMON_STATUS\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'status\'"></span></div><div class="label grid__col-4" ng-click="sortBy(\'timestamp\', \'favouriteRegionHistory\');">{{\'CONNECTED_SERVICES_DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'timestamp\'"></span></div><div class="label grid__col-4" ng-click="sortBy(\'country\', \'favouriteRegionHistory\');">{{\'EASYLINK_VEHICLE_COUNTRY\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'country\'"></span></div></header></section><ul class=historyList><li ng-repeat="item in history" class=grid--no-gutter><span style="text-align: center; margin-left: -16px;" class=grid__col-4>{{item.status | rlinkformat:\'status\'}}</span> <span style="text-align: center;" class=grid__col-4>{{item.timestamp | rlinkformat:\'full-date\'}}</span> <span style="text-align: center;" class=grid__col-4>{{item.country | rlinkformat}}</span></li></ul></any><div ng-if="history === null" class=block_text>{{\'NO_DATA_FOUND\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/inventoryVehicleContent.html','<div class=block_body><div class=table_block_body style="position: relative;"><table style="width: 100%;"><thead table-width data=vm.map style=padding-top:1rem;><tr class=grid--no-gutter><th class=grid__col-3>{{\'EASYLINK_VEHICLE_NAVIGATION_SOFTWARE\' | translate}}</th><th class=grid__col-2>{{\'EASYLINK_VEHICLE_FAVORITE_COUNTRY\' | translate}}</th><th class=grid__col-2>{{\'CONNECTED_SERVICES_STORAGE_MAPS_FREE_SPACE\' | translate}}</th><th class=grid__col-3>{{\'EASYLINK_VEHICLE_CARTOGRAPHY_VERSION\' | translate}}</th><th class=grid__col-2>{{\'CONNECTED_SERVICES_SYSTEM_TYPE\' | translate}}</th></tr></thead><tbody><tr class=grid--no-gutter><td class="table-padding-td grid__col-3">{{vm.map.navigationSoftwareVersion | rlinkformat}}<md-tooltip ng-if="vm.map.navigationSoftwareVersion === null && vm.vehicleInformationDisplay" md-direction=left style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 300px !important; white-space: normal;">{{\'MAP_CONTENT_MSG\'| translate}}</md-tooltip></td><td class="table-padding-td grid__col-2">{{vm.map.favouriteRegion | rlinkformat| uppercase}}<md-tooltip ng-if="vm.map.favouriteRegion === null && vm.vehicleInformationDisplay" md-direction=left style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 300px !important; white-space: normal;">{{\'MAP_CONTENT_MSG\'| translate}}</md-tooltip></td><td class="table-padding-td grid__col-2">{{vm.map.availableSize | rlinkformat:\'convert\'}} {{\'EASYLINK_VEHICLE_OUT_OF\' | translate}} {{vm.map.totalSize | rlinkformat:\'convert\'}}<md-tooltip ng-if="vm.map.availableSize === null && vm.vehicleInformationDisplay" md-direction=left style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 300px !important; white-space: normal;">{{\'MAP_CONTENT_MSG\'| translate}}</md-tooltip></td><td class="table-padding-td grid__col-3">{{vm.map.versionsHistory[0].fullMapVersion | rlinkformat}}<md-tooltip ng-if="vm.map.versionsHistory[0].fullMapVersion === null && vm.vehicleInformationDisplay" md-direction=left style="background-color: grey; color: white; border-style: solid; border-width: 1px; height: auto !important; max-width: 300px !important; white-space: normal;">{{\'MAP_CONTENT_MSG\'| translate}}</md-tooltip></td><td class="table-padding-td grid__col-2">{{vm.systemType.mtcCriteria}} <span class="icon eye-plus-outline" ng-click="vm.showPopin = !vm.showPopin"></span></td></tr></tbody><tbody table-data-manager data=vm.map nbr-column=5></tbody></table><div class=block_text><button class=cs-btn ng-class="{\'nissanBtnWithIcon\': vm.nissanUserURL, \'buttonWithIcon\': !vm.nissanUserURL}" ng-click=vm.showVersionsHistory()><div class=iconDiv><i class="fa fa-chevron-right diagnosis"></i></div><div class=btnText>{{\'EASYLINK_VEHICLE_VERSIONS_HISTORY\' | translate}}</div></button></div><div class="popin see-more" ng-if=vm.showPopin><div class=popin--header><div>{{\'CONNECTED_SERVICES_SYSTEM_TYPE\' | translate}}</div><div class="icon close-popin" ng-click="vm.showPopin = false">X</div></div><div class=popin--content><div>{{\'EASYLINK_RADNAV\' | translate}} : {{vm.systemType.name | rlinkformat}}</div><div>{{\'EASYLINK_SHORT_DESCRIPTION\' | translate}} : {{vm.systemType.description | rlinkformat}}</div></div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/maps.html','<!-- MUS --><div class="block-accordion map-mus-block"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.maps.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div><span>{{\'EASYLINK_VEHICLE_MAPPING_UPDATE_SERVICE\' | translate}}</span> <span ng-if="vm.map.mus.status === \'ACTIVATED\'" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACTIVE_STATUS\' | translate}} </span><span ng-if="vm.map.mus.status === \'IN_PROGRESS\'" class=warning-message><i class=icon-warning></i> {{\'CONNECTED_SERVICES_IN_PROGRESS_STATUS\' | translate}} </span><span ng-if="vm.map.mus.status === \'DEACTIVATED\'" class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_DEACTIVATED_STATUS\' | translate}}</span></div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></accordion-heading><ng-include ng-if=!vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/noMap.html\'"></ng-include><ng-include ng-if=vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/musContent.html\'"></ng-include></accordion-group></accordion></div><!-- End Mus --><!-- Update Favorite Country --><div class="block-accordion map-update-country-block" ng-if=!vm.nissanUserURL><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.updateCountry.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex>{{\'EASYLINK_VEHICLE_FAVORITE_COUNTRY_UPDATE\' | translate}}</div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><ng-include ng-if=!vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/noMap.html\'"></ng-include><ng-include ng-if=vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/favoriteCountryContent.html\'"></ng-include></accordion-group></accordion></div><!-- End Update Favorite Country --><!-- Inventory Vehicle --><div class="block-accordion map-inventory-block"><accordion class="collapse section_wrapper" close-others=false><accordion-group is-open=vm.accordions.inventory.isOpen><accordion-heading><div class=section_header ng-click="$scope.isOpen = !$scope.isOpen"><div class=flex>{{\'EASYLINK_VEHICLE_MAP_INVENTORY\' | translate}}</div><div><i ng-class="\'icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></div></div></accordion-heading><ng-include ng-if=!vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/noMap.html\'"></ng-include><ng-include ng-if=vm.data.hasConnectivityDevices src="\'app/components/car/rLinkCar/softAndApplications/easyLink/inventoryVehicleContent.html\'"></ng-include></accordion-group></accordion></div><!-- End Inventory Vehicle -->');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/musContent.html','<div class=block_body><div class=table_block_body><table ng-if="vm.map.mus.status !== null" style="width: 100%;"><thead><tr class="grid--no-gutter no-padding"><th class=grid__col-6>{{\'CONNECTED_SERVICES_SUBSCRIPTION_DATE\' | translate}}</th><th class=grid__col-6>{{\'CONNECTED_SERVICES_END_DATE\' | translate}}</th></tr></thead><tbody><tr class=grid--no-gutter><td class="table-padding-td grid__col-6">{{vm.map.mus.startDatetime | rlinkformat: \'date\'}}</td><td class="table-padding-td grid__col-6">{{vm.map.mus.endDatetime | rlinkformat: \'date\'}}</td></tr></tbody></table><div class=block_text ng-if="vm.map.mus.status === null">{{\'NO_DATA\' |translate}}</div></div></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/noMap.html','<div class=flex><div class=block_text>{{\'EASYLINK_VEHICLE_NO_MAP\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/softAndApplications/easyLink/versionsHistoryModal.html','<div class=app-modal style="padding: 10px; width:950px;"><div class=header-modal><span style="font-family: var(--renaultFontBold);">{{\'EASYLINK_VEHICLE_VERSIONS_HISTORY\' | translate}}</span> <span ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span></div><any ng-if="versionsHistory !== null"><section><header class=grid--no-gutter><div class="label grid__col-2" ng-click="sortBy(\'datetime\', \'versionsHistory\');">{{\'EASYLINK_VEHICLE_UPDATE_DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'datetime\'"></span></div><div class="label grid__col-7" ng-click="sortBy(\'fullMapVersion\', \'versionsHistory\');">{{\'EASYLINK_VEHICLE_FULL_MAP_VERSION\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'fullMapVersion\'"></span></div><div class="label grid__col-3" ng-click="sortBy(\'source\', \'versionsHistory\');">{{\'EASYLINK_VEHICLE_SYSTEM\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'source\'"></span></div></header></section><ul class=historyList><li ng-repeat="item in versionsHistory" class=grid--no-gutter><span class=grid__col-4>{{item.datetime | rlinkformat:\'full-date\'}}</span> <span style="position: relative;left: 1%;" class=grid__col-6>{{item.fileName | rlinkformat}}</span> <span style="position: relative;right: 5%;" class=grid__col-2>{{item.source | translate}}</span></li></ul></any><div ng-if="versionsHistory === null" class=block_text>{{\'NO_DATA_FOUND\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/bootstrapHistoryModal.html','<div class=app-modal style="padding: 10px;width:950px;"><div class=header-modal><span style="font-family: var(--renaultFontBold);">{{\'EASYLINK_VEHICLE_BOOTSTRAP_HISTORY\' | translate}}</span> <span ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span></div><any ng-if="bootstrapHistory !== null && bootstrapHistory.length > 0 "><section><header class=grid--no-gutter><div class="label grid__col-4" ng-click="sortBy(\'datetime\', \'bootstrapHistory\');">{{\'DATE\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'datetime\'"></span></div><div class="label grid__col-4" ng-click="sortBy(\'step\', \'bootstrapHistory\');">{{\'EASYLINK_VEHICLE_STEP\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'step\'"></span></div><div class="label grid__col-4" ng-click="sortBy(\'result\', \'bootstrapHistory\');">{{\'EASYLINK_VEHICLE_RESULT\' | translate}} <span ng-class="{\'nissanSort\': vm.nissanUserURL, \'renaultSort\': !vm.nissanUserURL, \'asc\':reverse, \'desc\': !reverse}" ng-show="propertyName === \'result\'"></span></div></header></section><ul class=historyList><li ng-repeat="item in bootstrapHistory" class=grid--no-gutter><span class=grid__col-4>{{item.datetime | rlinkformat:\'full-date\'}}</span> <span class=grid__col-4>{{item.step | rlinkformat}}</span> <span class=grid__col-4>{{item.result | rlinkformat}}</span></li></ul></any><div ng-if="bootstrapHistory === null || bootstrapHistory.length === 0" class=block_text>{{\'NO_DATA_FOUND\' | translate}}</div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/communicationServers.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value=EASYLINK_SERVER_COMMUNICATION tip-title=EASYLINK_TIP_SERVER_COMMUNICATION></rlink-tip><span ng-if="vm.vehicle.connectivity.communicationsStatus === \'WARNING\'" class=warning-message><i class=icon-warning></i> {{\'CONNECTED_SERVICES_WARNING_STATUS\' | translate}} </span><span ng-if="vm.vehicle.connectivity.communicationsStatus === \'OK\'" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} </span><span ng-if="vm.vehicle.connectivity.communicationsStatus === \'KO\'" class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.vehicle.connectivity.communicationsStatus === null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/dataPrivacyPopup.html','<!-- GRANULAR PRIVACY POPIN--><div ng-if="vm.data.privacyType === \'GRANULAR_PRIVACY\'" class="app-modal granularPopup"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><header class="grid--no-gutter privacyBottomLine"><div class="header-modal privacyLabel">{{\'PRIVACY_MODE\'|translate | uppercase}}</div></header><br><div class=row><div class="small-3 columns statusStyle">{{\'STATUS_DESCRIPTION\'|translate}}</div><div class="small-9 columns grayLine"><div class=leftSpace><i class="fa fa-circle discriptionGreen"></i> <span class=discriptionColor>{{\'STATUS_DESCRIPTION_GREEN\'|translate}}</span></div><div class=statusDescriptionRed><i class="fa fa-circle discriptionRed"></i> <span class=discriptionColor>{{\'STATUS_DESCRIPTION_RED\'|translate}}</span></div></div></div><div class="row modeDiv"><div class="small-3 columns mainMode">{{\'MODE_DESCRIPTION\'|translate}}</div><div class="small-9 columns grayLine"><div class=leftSpace><span class=modedescriptionColor>{{\'MODE_DESCRIPTION_ONBOARD_CONNECTED\'|translate}}</span>&nbsp;<span class=discriptionColor>{{\'MODE_DESCRIPTION_ONBOARD_CONNECTED_MSG\'|translate}}</span></div><br><div class=leftSpace><span class=modedescriptionColor>{{\'MODE_DESCRIPTION_VEHICLE_LOCALISATION\'|translate}}</span>&nbsp;<span class=discriptionColor>{{\'MODE_DESCRIPTION_VEHICLE_LOCALISATION_MSG\'|translate}}</span></div><br><div class=leftSpace><span class=modedescriptionColor>{{\'MODE_DESCRIPTION_REMOTE_SERVICE\'|translate}}</span>&nbsp;<span class=discriptionColor>{{\'MODE_DESCRIPTION_REMOTE_SERVICE_MSG\'|translate}}</span></div><br><div class=leftSpace><span class=modedescriptionColor>{{\'MODE_DESCRIPTION_DATA_COLLECTION\'|translate}}</span>&nbsp;<span class=discriptionColor>{{\'MODE_DESCRIPTION_DATA_COLLECTION_MSG\'|translate}}</span></div><br><div class=leftSpace ng-if=vm.isErpCharge><span class=modedescriptionColor>{{\'MODE_DESCRIPTION_DATA_COLLECTION_SP\'|translate}}</span>&nbsp; <span class=discriptionColor>{{\'MODE_DESCRIPTION_DATA_COLLECTION_SP_MSG\'|translate}}</span></div></div></div></div><!-- LEGACY PRIVACY POPIN--><div ng-if="vm.data.privacyType === \'LEGACY_PRIVACY\'" class="app-modal legacyPopup"><span class=close-modal ng-click=close() style="float: right;"><i class="icon-icons_close close-icon"></i></span><header class="grid--no-gutter privacyBottomLine"><div class="header-modal privacyLabel">{{\'PRIVACY_MODE\'|translate | uppercase}}</div></header><br><div class="row modeDiv"><div class="small-3 columns mainMode">{{\'MODE_DESCRIPTION\'|translate}}</div><div class="small-9 columns grayLine"><div class=leftSpace><span class=dataON>DATA_ON:</span>&nbsp;<span class=discriptionColor>{{\'DATA_ON_MSG\'|translate}}</span></div><br><div class=leftSpace><span class=dataOFF>DATA_OFF:</span>&nbsp;<span class=discriptionColor>{{\'DATA_OFF_MSG\'|translate}}</span></div><br><div class=leftSpace><span class=dataOFF>GEOLOC_OFF:</span>&nbsp;<span class=discriptionColor>{{\'GEOLOC_OFF_MSG\'|translate}}</span></div><br><div class=leftSpace><span style="color: #535353;font-weight: bold;font-size: var(--renaultMediumFont);">UNKNOWN:</span>&nbsp;<span class=discriptionColor>{{\'UNKNOWN\'|translate}}</span></div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/hu.html','<div class=flex ng-if="vm.vehicle.headUnitInformation.present === \'YES\' && !vm.vehicleInformationDisplay"><div class="flex-flow-column flex-50"><div class=block_text>{{\'RLINKCAR_HU_TYPE\' | translate}} : {{ vm.vehicle.headUnitInformation.radnavSystemType.mtcCriteria | rlinkformat}}<div style="position: relative;display: inline-block;"><span class="icon eye-plus-outline" ng-click="vm.showPopin = !vm.showPopin"></span><div class="popin see-more" ng-if=vm.showPopin><div class=popin--header><div>{{\'CONNECTED_SERVICES_SYSTEM_TYPE\' | translate}}</div><div class="icon close-popin" ng-click="vm.showPopin = false">X</div></div><div class=popin--content><div>{{\'EASYLINK_RADNAV\' | translate}} : {{vm.vehicle.headUnitInformation.radnavSystemType.name | rlinkformat}}</div><div>{{\'EASYLINK_SHORT_DESCRIPTION\' | translate}} : {{vm.vehicle.headUnitInformation.radnavSystemType.description | rlinkformat}}</div></div></div></div></div><div class=block_text><span>{{\'CONNECTED_SERVICES_ID\' | translate}} : {{ vm.vehicle.headUnitInformation.huId.vnext | rlinkformat }}</span><any ng-if=!vm.vehicle.headUnitInformation.huId.consistency><span class=warning-message><i class="icon icon-icons_warning_document"></i></span></any></div><div class=block_text>{{\'CONNECTED_SERVICES_SOFTWARE_VERSION\' | translate}} : {{ vm.vehicle.headUnitInformation.softwareVersion | rlinkformat }}<any ng-if=false>{{\'RLINKCAR_HU_LAST_SOFTWARE\' | translate}} : {{ vm.vehicle.headUnitInformation.lastAvailableSoftwareVersion | rlinkformat }}</any></div></div><div class="flex-flow-column flex-50"><div class=block_text><rlink-tip tip-class=label_title tip-value=EASYLINK_PART_NUMBER tip-title=EASYLINK_PART_NUMBER_TIP></rlink-tip>: {{ vm.vehicle.headUnitInformation.partNumber | rlinkformat}}</div><div class=block_text>{{\'EASYLINK_CONFIGURATION_FILE\' | translate}} : {{ vm.vehicle.headUnitInformation.configFile | rlinkformat}}</div><div class=block_text>{{\'EASYLINK_CALIBRATION_FILE\' | translate}} : {{ vm.vehicle.headUnitInformation.calibrationFile | rlinkformat}}</div></div><div class="grid--no-gutter margin-top"><div class=grid__col><button class="cs-btn buttonWithoutIcon" ng-click="vm.showBootstrapHistory(\'hu\')"><div class=btnText>+</div></button></div></div></div><div class=flex ng-if="vm.vehicle.headUnitInformation.present === \'NO\' && !vm.vehicleInformationDisplay"><div class=block_text>{{(vm.isCCS3Vehicle ? \'CONNECTED_SERVICES_NO_CDC_MESSAGE\' : \'CONNECTED_SERVICES_NO_HU_MESSAGE\') | translate}}</div></div><div class=block-sub-accordion ng-if="vm.vehicle.headUnitInformation.present === \'YES\'" style="position: relative;left: 2%;width: 96%;"><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen">{{(vm.isCCS3Vehicle ? \'REPLACEMENT_HISTORY_CDC\' : (vm.vehicleInformationDisplay ? \'REPLACEMENT_HISTORY_HU\' : \'CONNECTED_SERVICES_REPLACEMENT_HISTORY\')) | translate}}<i ng-class="\'icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions style="border: 1px solid #ddd !important;"><section><header class=grid--no-gutter style="font-size:14px; padding: 0.7rem !important;\n                        font-family: \'newRenaultGroupBold\';"><span class="vehtable-header grid__col-3">{{\'CONNECTED_SERVICES_REFERENCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_MODEL\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_SOURCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_STATE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2"><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></span><span class="vehtable-header grid__col-1"></span></header></section><div ng-if="vm.huTable != null && vm.vehicle.headUnitInformation.present === \'YES\'" ng-repeat="item in vm.huTable | reverse"><accordion class="collapse section_wrapper veh-content-replacement" close-others=false><accordion-group><accordion-heading><div ng-click="item.model === \'REPLACEMENT\' ? ($scope.isOpen = !$scope.isOpen) && (!vm.isCCS3Vehicle && vm.openReplacement($scope.isOpen,item,\'IVI\')) : $event.stopPropagation();" class="sub_items grid--no-gutter" style="padding: 0.5rem !important; font-weight: normal !important; font-size: 14px !important;" ng-style="{ \'cursor\': item.model === \'REPLACEMENT\' ? \'pointer\' : \'default\' }"><span class=grid__col-3>{{item.huid | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.model | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.sources | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\' | uppercase}}</span> <span class=grid__col-2>{{item.date | rlinkformat:\'date\'}}</span> <span class=grid__col-1><i ng-if="item.model == \'REPLACEMENT\'" ng-class="\' icon-arrow_\'+($scope.isOpen ? \'open\' : \'close\')"></i></span></div></accordion-heading><div class="sub_items grid--no-gutter loading-content" ng-if=vm.vehicle.huLoadingData><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><div class="sub_items grid--no-gutter loading-content" ng-if=!vm.vehicle.huLoadingData><span class=grid__col-4>{{(vm.isCCS3Vehicle ? \'BOOTSTRAP_CDC\' : \'BOOTSTRAP_IVI\') | translate}}<div ng-if=vm.vehicle.headUnitInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.headUnitInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.headUnitInformation.bootstrap.done === null" class=nd-message>-</div><div>{{vm.vehicle.headUnitInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}}</div><div ng-if=!vm.vehicle.headUnitInformation.bootstrap.history[0].datetime>-</div></span><span class=grid__col-3>{{"LABEL_CONSISTENCY_PART" | translate}}<div ng-if=vm.vehicle.threeHuValuesEqual class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.threeHuValuesEqual class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.threeHuValuesEqual === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=!vm.isCCS3Vehicle>{{"SERVICE_REACTIVATION_STATUS" | translate}}<div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.status == \'IN_PROGRESS\'"><span class="color-orange font-14"><i class="fa fa-exclamation-triangle" aria-hidden=true></i> {{vm.huServiceReactivation.status}}</span></div><div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.status == \'TERMINATED\'"><span class="success-message font-14">Reactivated</span></div><div ng-if="vm.huServiceReactivation && \n                                                vm.huServiceReactivation.status != \'TERMINATED\' && \n                                                vm.huServiceReactivation.status != \'IN_PROGRESS\'"><span class=error-message><em class="fa fa-close color-red font-20"></em> {{vm.huServiceReactivation.status}}</span></div><div ng-if="vm.huServiceReactivation === null" class=nd-message>-</div><div ng-if="vm.huServiceReactivation && vm.huServiceReactivation.endDate">{{vm.huServiceReactivation.endDate | rlinkformat:\'full-date\'}}</div><div ng-if="vm.huServiceReactivation === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=vm.isCCS3Vehicle></span> <span class=grid__col-1 ng-if=!vm.isCCS3Vehicle><i class="fa fa-refresh cursor-pointer" ng-click="vm.openReplacement($scope.isOpen,item,\'IVI\')" ng-keypress="vm.openReplacement($scope.isOpen,item,\'IVI\')"></i></span></div></accordion-group></accordion></div><div ng-if="vm.huTable.length == 0" class="text-center padding-small">{{(vm.isCCS3Vehicle ? \'CONNECTED_SERVICES_NO_CDC_MESSAGE\' : \'CONNECTED_SERVICES_NO_HU_MESSAGE\') | translate}}</div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/huStatus.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value="{{vm.isCCS3Vehicle ? \'EASYLINK_CDC_BOOTSTRAP\' : \'EASYLINK_HU_BOOTSTRAP\'}}" tip-title="{{vm.isCCS3Vehicle ? \'EASYLINK_TIP_CDC_BOOTSTRAP\' : \'EASYLINK_TIP_HU_BOOTSTRAP\'}}"></rlink-tip><span ng-if=vm.HUStatus class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} </span><span ng-if=!vm.HUStatus class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.HUStatus === null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/lastCom.html','<div class=row ng-if=!vm.vehicleInformationDisplay style="height: 173px;"><div class=block-accordion ng-if=!vm.noTcu style=margin-bottom:0;><div class=block-sub-accordion><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen"><span>{{\'CONNECTED_SERVICES_LAST_COMMUNICATIONS\' | translate}}</span><i class=align-center ng-class="\'icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=block_body><div class=table_block_body><table style="width: 100%; margin-bottom: 0px !important;"><thead table-width data=vm.lastCommunications style="border-bottom: 1px solid #ddd;"><tr><th>{{\'EASYLINK_CONTRIBUTOR1\' | translate | uppercase}}</th><th>{{\'EASYLINK_CONTRIBUTOR2\' | translate | uppercase}}</th><th>{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}</th></tr></thead><tbody ng-if="vm.lastCommunications && vm.lastCommunications.length > 0"><tr ng-repeat="item in vm.lastCommunications | rlinkOrderBy:\'date\':\'-\'" ng-if="item.from !== \'Redbend\'"><td class=table-padding-td>{{ item.from }}</td><td class=table-padding-td>{{ item.to }}</td><td ng-class="\'table-padding-td lastCom\' + item.status">{{ item.date | rlinkformat:\'full-date\' }}</td></tr><tr ng-repeat="item in vm.lastCommunications | rlinkOrderBy:\'date\':\'-\'" ng-if="item.from === \'Redbend\'"><td class=table-padding-td>{{ item.from }}</td><td class=table-padding-td>{{ item.to }}</td><td ng-class="\'table-padding-td lastCom\' + item.status">{{ item.date | rlinkformat:\'full-date\' }}</td></tr></tbody></table></div></div></accordion-group></accordion></div></div><span ng-if=vm.noTcu class="nd-message upper">{{\'RLINKCAR_NO_TCU\' | translate}}</span></div><div class=row ng-if=vm.vehicleInformationDisplay><div class=block_body><div class=table_block_body><table style="width: 100%;"><thead table-width data=vm.lastCommunications style="border-bottom: 1px solid #ddd;"><tr><th>{{\'EASYLINK_CONTRIBUTOR1\' | translate}}</th><th>{{\'EASYLINK_CONTRIBUTOR2\' | translate}}</th><th>{{\'CONNECTED_SERVICE_DATE\' | translate}}</th></tr></thead><tbody ng-if="vm.lastCommunications && vm.lastCommunications.length > 0" class=lastCommTable><tr class=lastCommRow ng-repeat="item in vm.lastCommunications | rlinkOrderBy:\'date\':\'-\'" ng-if="item.from !== \'Redbend\'"><td class=table-padding-td>{{ item.from === \'Redbend\' ? item.from : (vm.connectedPlatform.platform === \'AVN\' ? vm.vnext : vm.connectedPlatform.platform === \'CVC\' ? vm.cvc : item.from) }}</td><td class=table-padding-td>{{ item.to }}</td><td ng-class="\'table-padding-td lastCom\' + item.status">{{ item.date | rlinkformat:\'full-date\' }}</td></tr><tr class=lastCommRow ng-repeat="item in vm.lastCommunications | rlinkOrderBy:\'date\':\'-\'" ng-if="item.from === \'Redbend\'"><td class=table-padding-td>{{ item.from === \'Redbend\' ? item.from : (vm.connectedPlatform.platform === \'AVN\' ? vm.vnext : vm.connectedPlatform.platform === \'CVC\' ? vm.cvc : item.from) }}</td><td class=table-padding-td>{{ item.to }}</td><td ng-class="\'table-padding-td lastCom\' + item.status">{{ item.date | rlinkformat:\'full-date\' }}</td></tr></tbody></table></div></div><span ng-if=vm.noTcu class="nd-message upper">{{\'RLINKCAR_NO_TCU\' | translate}}</span></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/otp.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value=EASYLINK_OTP tip-title=EASYLINK_TIP_OTP></rlink-tip><span ng-if=vm.OTPStatus class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACHIEVED\' | translate}} </span><span ng-if=!vm.OTPStatus class=warning-message><i class=icon-warning></i> {{\'CONNECTED_SERVICES_NOTACHIEVED\' | translate}} </span><span ng-if="vm.v === null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/pbo.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value=CONNECTED_SERVICES_PBO tip-title=CONNECTED_SERVICES_TIP_PBO></rlink-tip><span ng-if="vm.pushButtonActivated === true" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACHIEVED\' | translate}} </span><span ng-if="vm.pushButtonActivated === false" class=warning-message><i class=icon-warning></i> {{\'CONNECTED_SERVICES_NOTACHIEVED\' | translate}} </span><span ng-if="vm.pushButtonActivated == null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/simStatus.html','<div class=row><div class=block_text>{{\'RLINKCAR_SIM\' | translate}} <span ng-if="vm.simStatus === \'ACTIVE\'" class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_ACTIVE_STATUS\' | translate}} </span><span ng-if="vm.simStatus === \'INACTIVE\'" class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_INACTIVE_STATUS\' | translate}} </span><span ng-if="vm.simStatus === null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/tcu.html','<div class=flex ng-if="vm.vehicle.tcuInformation.present === \'YES\' && !vm.vehicleInformationDisplay"><div class="flex-flow-column flex-50"><div class=block_text><span>{{\'CONNECTED_SERVICES_ID\' | translate}} : {{ vm.vehicle.tcuInformation.tcuId.vnext | rlinkformat }}</span><any ng-if=!vm.vehicle.tcuInformation.tcuId.consistency><span class=warning-message><i class="icon icon-icons_warning_document"></i></span></any></div><div class=block_text>{{\'CONNECTED_SERVICES_SOFTWARE_VERSION\' | translate}} : {{ vm.vehicle.tcuInformation.softwareVersion | rlinkformat}}</div></div><div class="flex-flow-column flex-50"><div class=block_text><rlink-tip tip-class=label_title tip-value=EASYLINK_PART_NUMBER tip-title=EASYLINK_PART_NUMBER_TIP></rlink-tip>: {{ vm.vehicle.tcuInformation.partNumber | rlinkformat}}</div><div class=block_text>{{\'EASYLINK_CONFIGURATION_FILE\' | translate}} : {{ vm.vehicle.tcuInformation.configFile | rlinkformat}}</div></div><div class="grid--no-gutter margin-top"><div class=grid__col><button class="cs-btn buttonWithoutIcon" ng-click="vm.showBootstrapHistory(\'tcu\')"><div class=btnText>+</div></button></div></div></div><div class=flex ng-if="!vm.vehicle.tcuInformation.present && !vm.vehicleInformationDisplay"><div class=block_text>{{\'CONNECTED_SERVICES_NO_TCU_MESSAGE\' | translate}}</div></div><div class=block-sub-accordion ng-if="vm.vehicle.tcuInformation && vm.vehicle.tcuInformation.present === \'YES\'" style="position: relative;left: 2%;width: 96%;"><accordion class=collapse close-others=false><accordion-group><accordion-heading><div class="accordion-heading-datas sub-content space-between flex" ng-click="$scope.isSubOpen = !$scope.isSubOpen">{{vm.vehicleInformationDisplay ? \'REPLACEMENT_HISTORY_TCU\' : \'CONNECTED_SERVICES_REPLACEMENT_HISTORY\'| translate}}<i ng-class="\'icon-arrow_\'+($scope.isSubOpen ? \'open\' : \'close\')"></i></div></accordion-heading><div class=subscriptions style="border: 1px solid #ddd !important;"><section><header class=grid--no-gutter style="font-size:14px; padding: 0.7rem !important;\n                        font-family: \'newRenaultGroupBold\';"><span class="vehtable-header grid__col-3">{{\'CONNECTED_SERVICES_REFERENCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_MODEL\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_REPLACEMENT_SOURCE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2">{{\'CONNECTED_SERVICES_STATE\' | translate | uppercase}}</span> <span class="vehtable-header grid__col-2"><rlink-tip tip-value="{{\'CONNECTED_SERVICE_DATE\' | translate | uppercase}}" tip-title="{{\'CONNECTED_SERVICES_DATE\' | translate}}"></rlink-tip></span><span class="vehtable-header grid__col-1"></span></header></section><div ng-if="vm.tcuTable != null && vm.vehicle.tcuInformation.present === \'YES\'" ng-repeat="item in vm.tcuTable | reverse"><accordion class="collapse section_wrapper veh-content-replacement" close-others=false><accordion-group><accordion-heading><div ng-click="item.model === \'REPLACEMENT\' ? ($scope.isOpen = !$scope.isOpen) && (!vm.isCCS3Vehicle && vm.openReplacement($scope.isOpen,item,\'IVC\')) : $event.stopPropagation();" class="sub_items grid--no-gutter" style="padding: 0.5rem !important;font-weight: normal !important; font-size: 14px !important;" ng-style="{ \'cursor\': item.model === \'REPLACEMENT\' ? \'pointer\' : \'default\' }"><span class=grid__col-3>{{item.tcuid | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.model | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.sources | rlinkformat | uppercase}}</span> <span class=grid__col-2>{{item.status | rlinkformat:\'status\' | uppercase}}</span> <span class=grid__col-2>{{item.date | rlinkformat:\'date\'}}</span> <span class=grid__col-1><i ng-if="item.model == \'REPLACEMENT\'" ng-class="\'icon-arrow_\'+ ($scope.isOpen ? \'open\' : \'close\')"></i></span></div></accordion-heading><div class="sub_items grid--no-gutter loading-content" ng-if=vm.vehicle.tcuLoadingData><img src=../assets/images/newHourGlassGrey.gif width=24px alt=""></div><div class="sub_items grid--no-gutter loading-content" ng-if="item.model == \'REPLACEMENT\' && !vm.vehicle.tcuLoadingData"><span class=grid__col-4>{{"BOOTSTRAP_IVC" | translate}}<div ng-if=vm.vehicle.tcuInformation.bootstrap.done class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.tcuInformation.bootstrap.done class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.tcuInformation.bootstrap.done === null" class=nd-message>-</div><div>{{vm.vehicle.tcuInformation.bootstrap.history[0].datetime | rlinkformat:\'full-date\'}}</div><div ng-if=!vm.vehicle.tcuInformation.bootstrap.history[0].datetime>-</div></span><span class=grid__col-3>{{"LABEL_CONSISTENCY_PART" | translate}}<div ng-if=vm.vehicle.threeTcuValuesEqual class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}}</div><div ng-if=!vm.vehicle.threeTcuValuesEqual class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}}</div><div ng-if="vm.vehicle.threeTcuValuesEqual === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=!vm.isCCS3Vehicle ng-style="{\'visibility\': vm.getTcuServiceReactivationVisibility()}">{{"SERVICE_REACTIVATION_STATUS" | translate}}<div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.status === \'IN_PROGRESS\'"><span class="color-orange font-14"><i class="fa fa-exclamation-triangle" aria-hidden=true></i> {{vm.tcuServiceReactivation.status}}</span></div><div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.status === \'TERMINATED\'"><span class="success-message font-14">Reactivated</span></div><div ng-if="vm.tcuServiceReactivation && \n                                              vm.tcuServiceReactivation.status !== \'TERMINATED\' && \n                                              vm.tcuServiceReactivation.status !== \'IN_PROGRESS\'"><span class=error-message><em class="fa fa-close color-red font-20"></em> {{vm.tcuServiceReactivation.status}}</span></div><div ng-if="vm.tcuServiceReactivation === null" class=nd-message>-</div><div ng-if="vm.tcuServiceReactivation && vm.tcuServiceReactivation.endDate">{{vm.tcuServiceReactivation.endDate | rlinkformat:\'full-date\'}}</div><div ng-if="vm.tcuServiceReactivation === null" class=nd-message>-</div></span><span class="grid__col-4 loading-content" ng-if=vm.isCCS3Vehicle></span> <span class=grid__col-1 ng-if=!vm.isCCS3Vehicle><i class="fa fa-refresh cursor-pointer" ng-click="vm.openReplacement($scope.isOpen,item,\'IVC\')" ng-keydown="$event.keyCode === 13 && \n                                               vm.openReplacement($scope.isOpen,item,\'IVC\')"></i></span></div></accordion-group></accordion></div><div ng-if="vm.tcuTable.length == 0" class="text-center padding-small">{{\'CONNECTED_SERVICES_NO_TCU_MESSAGE\' | translate}}</div></div></accordion-group></accordion></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/EasyLink/tcuStatus.html','<div class=row><div class=block_text><rlink-tip tip-class=label_title tip-value=EASYLINK_TCU_BOOTSTRAP tip-title=EASYLINK_TIP_TCU_BOOTSTRAP></rlink-tip><span ng-if=vm.TCUStatus class=success-message><i class=icon-success></i> {{\'CONNECTED_SERVICES_OK_STATUS\' | translate}} </span><span ng-if=!vm.TCUStatus class=error-message><i class=icon-error></i> {{\'CONNECTED_SERVICES_KO_STATUS\' | translate}} </span><span ng-if="vm.TCUStatus === null" class=nd-message>-</span></div></div>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/popup/changeUsageCountryPopup.template.html','<md-dialog class=app-modal id=changeUsageCountryPopIn><md-dialog-content class=dialog-wrapper><md-input-container class=input-container><label for=changeUsageCountrySelect class=input-label>{{\'SELECT_COUNTRY\'|translate}}</label><md-select ng-model=vm.usageCountry placeholder="{{\'SELECT_COUNTRY\'|translate}}" id=changeUsageCountrySelect><md-select-header class=demo-select-header><input id=changeUsageCountryInput aria-label="{{\'SELECT_COUNTRY\'|translate}}" ng-model=vm.countrySearch type=search ng-keydown=$event.stopPropagation() placeholder="{{\'SELECT_COUNTRY\'|translate}}" class="demo-header-searchbox md-text" focus-to-input input-clear=black></md-select-header><md-option ng-repeat="country in vm.filteredCountries() track by country.value" ng-value=country.value>{{country.value}} - {{country.label}}</md-option></md-select></md-input-container><div ng-if=vm.usageCountry class=cancel-button ng-keydown="vm.usageCountry = \'\'; vm.countrySearch = \'\';" ng-click="vm.usageCountry = \'\'; vm.countrySearch = \'\'; ">X</div></md-dialog-content><md-dialog-actions class=dialog-actions><button class=buttonWithIcon ng-disabled=!vm.usageCountry ng-click=vm.confirm()><div class=btnText>OK</div></button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/popup/connectivityMediaStatusPopup.template.html','<md-dialog class=app-modal style="width: 60rem; height: 570px; overflow: auto;"><div class="grid--no-gutter mapStatusHead" style="width: 60rem; right:0%; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.7rem;"></div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;" ng-if=isMultimediaStatusPopup><p translate="{{isCCS3Vehicle ? \'CONNECTIVITY_MEDIA_STATUS_CDC_POPUP_MSG\' : \'CONNECTIVITY_MEDIA_STATUS_POPUP_MSG\'}}" style="font-size: var(--renaultMediumFont);"></p></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/popup/importantInfoPopup.template.html','<md-dialog class=app-modal style="width: 60rem; overflow: auto;" ng-style="{\'height\':vm.userLanguage === \'fr\'? \'157px\':\'129px\'}"><div class="grid--no-gutter mapStatusHead" style="width: 60rem; right:0%; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.5rem;"><img src=./assets/images/icn_light.png alt="Light Icon" style="max-width: 1.8rem;bottom: 5%;position: relative;" ng-click=vm.importantInfoPopup(true);><span style="left: 3%; position: relative;">{{\'IMPORTANT_INFORMATION\' | translate | uppercase}}</span></div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem; text-align: center;font-family: renaultGroupRegular;" ng-if=isInfoStatusPopup><p translate=IMPORTANT_INFO_POPUP_MSG style="font-weight: bold;"></p></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/vehicleInformations/popup/usageCountryConfirmPopup.template.html','<md-dialog class=app-modal id=usageCountryConfirmPopIn><md-dialog-content class=dialog-content><h5>{{\'CHANGE_USER_COUNTRY_CONFIRMATION_CONFIRMATION\'|translate}}</h5><strong class=alert-text>{{"CHANGE_USER_COUNTRY_WARNING"|translate}}</strong></md-dialog-content><md-dialog-actions class=dialog-actions><button class=buttonWithIcon ng-click=vm.updateUsageCountry()><div class=btnText>{{\'COMMON_YES\'|translate}}</div></button> <button class=buttonWithIcon ng-click=vm.onCancel()><div class=btnText>{{\'COMMON_NO\'|translate}}</div></button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/virtualKey/popup/virtualRightDescriptionPopup.template.html','<md-dialog class=app-modal style="width: 27rem; height: 220px; overflow: hidden !important;"><div class="grid--no-gutter mapStatusHead" style="width: 27rem; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'RIGHT_DESCRIPTION\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;"><p translate=VIRTUAL_RIGHT_DESCRIPTION_POPUP_MSG></p></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/virtualKey/popup/virtualRoleDelegationPopup.template.html','<md-dialog class=app-modal style="width: 60rem; height: 270px; overflow: auto;"><div class="grid--no-gutter mapStatusHead" style="width: 60rem; right:0%; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'VIRTUAL_KEY_INFORMATION\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;"><p translate=VIRTUAL_KEY_INFO_POPUP_MSG></p></div></md-dialog>');
$templateCache.put('app/components/car/rLinkCar/virtualKey/popup/virtualStatusRolesPopup.template.html','<md-dialog class=app-modal style="width: 27rem; height: 170px; overflow: hidden !important;"><div class="grid--no-gutter mapStatusHead" style="width: 27rem; position: fixed;"><div class="header-modal privacyLabel" style="margin: 0.7rem;">{{\'STATUS_DESCRIPTION\' | translate}}</div><span ng-click=close() class=diagPopupClose><i class="icon-icons_close close-icon"></i></span></div><div style="padding:1.5rem; margin-top: 2rem;font-family: renaultGroupRegular;"><p translate=VIRTUAL_KEY_STATUS_POPUP_MSG></p></div></md-dialog>');
$templateCache.put('app/components/car/features/components/carMaintenanceProgram/carMaintenanceProgram.template.html','<div id=mtnProgDiv><div class=declareToRenault ng-if="vm.isIndependentUser && $root.asomDocList.REP" ng-click=vm.declareToRenault()><img src=./assets/images/icons_check_actis.svg class=declareTo alt=""> <label class=head>{{\'DECLARE_TO_RENAULT\' |translate}}</label></div><div class=headerSection><div class=tiresPopup ng-click=vm.showTiresInfo(vm.tiresInfo) ng-if=vm.checkTiresData><span class=tireIcon><img src=../assets/images/tire_logo.png height=25 width=25 alt=""></span><span ng-class="{\'separator\': vm.checkTiresData}" ng-style="{top: vm.newUiEnable ? \'-2px\' : \'6px\'}"></span></div><div class=tiresHeading ng-if=vm.checkTiresData>{{\'TIRES_INFORMATIONS\' | translate}}</div></div><div ng-if=vm.showContent class=kmMilesSwitch><p class=kmDiv>{{\'KILOMETRE\' | translate | toCamelCase}}</p><md-switch ng-model=vm.isMilesDisplay ng-change=vm.milesKmDisplayUpdate()><p class=milesDiv>{{\'MILES\' | translate | toCamelCase}}</p></md-switch></div><div ng-if=vm.showContent ng-click=vm.printMaintenanceProgram() ng-class="{ \'clickableMp\' : !vm.showNoDataFound,\'disablePrint\' : (vm.showNoDataFound && vm.operationDelayed.length == 0 && vm.OperationTobeCarried.length == 0 && vm.upcomingOperation.length == 0 )}"><i class="icon-icons_print printIconDiv"></i> <label class=printTextDiv>{{\'BUTTON_ESTIMATE_PRINT\' | translate}}</label></div><div id=mtnProg class=documents-table ng-if=vm.showContent><!--Primaries Table--><div class=tableSplit style="display: inline-flex;"><div class=primaries ng-style="{\'width\':vm.isPlannedAssistance ? \'75%\':\'\'}" style="margin-top: 0;"><div class=titlePrimaries><div class=row><div class="columns labelTitlePrimaries medium-8">{{vm.primaryOperations.header1.title}}</div><div ng-if=vm.oldMaintenanceTab class="medium-2 columns labelIndexPrimaries">{{vm.primaryOperations.header1.from}}</div><div ng-if=vm.oldMaintenanceTab class="medium-2 columns labelIndexPrimaries">{{vm.primaryOperations.header1.then}} {{vm.primaryOperations.header1.all}}</div></div></div><div class=valuesPrimaries><div class=row><div class="columns cell" ng-class="vm.oldMaintenanceTab ? \'medium-8\' : \'medium-6\'"><label class=labelFuildValue2>{{vm.primaryOperations.header2.title}}</label></div><div class="medium-1 cell labelUnityPrimaries"><div ng-if=vm.oldMaintenanceTab>{{vm.primaryOperations.header2.km1 }}</div><div ng-if=!vm.oldMaintenanceTab style="line-height: normal;">{{\'KM_ALL_THE\' | translate}} ({{vm.primaryOperations.header2.km1 }})</div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell labelUnityPrimaries"><div>{{vm.primaryOperations.header2.year1}}</div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell labelUnityPrimaries"><div>{{vm.primaryOperations.header2.km2Display }}</div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell labelUnityPrimaries"><div>{{vm.primaryOperations.header2.year2}}</div></div><div ng-if=!vm.oldMaintenanceTab class="medium-5 cell labelUnityPrimaries"><div class=row><div class="medium-12 cell labelUnityPrimaries"><div>{{\'COMMON_AT\' | translate}}</div></div></div><div class=row><div ng-class="{  \'highlight\' : vm.hoverYearIndex == year}" ng-repeat=" year in vm.yearColumn" class="medium-1 cell labelUnityPrimaries yearColumn" style="padding: 10px;"><label style="font-family: var(--renaultFontRegular);font-size: var(--renaultMediumFont);font-weight: 700;line-height: 1.5;color: var(--black80);\n                                                            writing-mode: vertical-rl;text-transform: capitalize;">{{year}}</label></div></div></div></div><div class=row ng-if=vm.showNoDataFound><div class="columns cell" ng-class="{ \'medium-8\' : vm.oldMaintenanceTab,\'medium-6\' : !vm.oldMaintenanceTab}"><label class=labelFuildValue1>-</label></div><div ng-if=vm.oldMaintenanceTab class="medium-1 columns cell"><label class=labelFuildValue1><span>-</span></label></div><div ng-if=!vm.oldMaintenanceTab class="medium-1 columns cell"><label class=labelFuildValue1><span>-</span></label></div><div ng-if=vm.oldMaintenanceTab class="medium-1 columns cell"><div class=labelFuildValue1><span>-</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><div class=labelFuildValue1><span>-</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><label class=labelFuildValue1><span>-</span></label></div><div ng-if=!vm.oldMaintenanceTab class="medium-5 cell"><label class=labelFuildValue1><span>-</span></label></div></div><div class=row ng-repeat=" currentPrimaryObj in vm.primaryOperations.revisions" ng-if="vm.primaryOperations.revisions.length > 0"><div class="columns cell" ng-class="{ \'medium-8\' : vm.oldMaintenanceTab,\'medium-6\' : !vm.oldMaintenanceTab, \'highlight\' : currentPrimaryObj.tempArr.includes(vm.hoverSearchIndex)}"><label class=labelFuildValue1>{{currentPrimaryObj.libelle}}</label></div><div ng-if=vm.oldMaintenanceTab class="medium-1 columns cell"><label class=labelFuildValue1><span ng-if="!vm.isMilesDisplay && currentPrimaryObj.km_Apartir != null&&currentPrimaryObj.km_Apartir!=\'0.0\'">{{parseFloat(currentPrimaryObj.km_Apartir)}}</span></label> <label class=labelFuildValue1><span ng-if="vm.isMilesDisplay && currentPrimaryObj.periodMlApatir != null&&currentPrimaryObj.periodMlApatir!=\'0.0\'">{{parseFloat(currentPrimaryObj.periodMlApatir)}}</span></label></div><div ng-if=!vm.oldMaintenanceTab class="medium-1 columns cell"><label class=labelFuildValue1><span ng-if=" !vm.isMilesDisplay && currentPrimaryObj.period_Km_Toutes != null&&currentPrimaryObj.period_Km_Toutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.period_Km_Toutes)}}</span></label> <label class=labelFuildValue1><span ng-if=" vm.isMilesDisplay && currentPrimaryObj.periodMlToutes != null&&currentPrimaryObj.periodMlToutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.periodMlToutes)}}</span></label></div><div ng-if=vm.oldMaintenanceTab class="medium-1 columns cell"><div class=labelFuildValue1><span ng-if="currentPrimaryObj.distan_Apartir != null&&currentPrimaryObj.distan_Apartir!=0">{{parseFloat(currentPrimaryObj.distan_Apartir)}}</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><div class=labelFuildValue1><span ng-if="!vm.isMilesDisplay && currentPrimaryObj.period_Km_Toutes != null&&currentPrimaryObj.period_Km_Toutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.period_Km_Toutes)}}</span></div><div class=labelFuildValue1><span ng-if="vm.isMilesDisplay && currentPrimaryObj.periodMlToutes != null&&currentPrimaryObj.periodMlToutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.periodMlToutes)}}</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><label class=labelFuildValue1><span ng-if="currentPrimaryObj.period_Distan_Toutes != null&&currentPrimaryObj.period_Distan_Toutes!=0.0">{{parseFloat(currentPrimaryObj.period_Distan_Toutes)}}</span></label></div><div ng-if=!vm.oldMaintenanceTab class="medium-5 cell labelUnityPrimaries" style="padding-top: 0;"><div class=row style="background: none;"><div ng-repeat="(index, year) in vm.yearColumn" ng-if=!vm.oldMaintenanceTab ng-mouseenter="vm.setVariables(index, year)" ng-mouseleave=vm.removeVariables() class="medium-1 columns cell yearColumn {{\'primaryContent-\'+index}}" ng-class="{ \'highlight\' : vm.hoverYearIndex == year}" style="padding: 12px;"><div class=labelFuildValue1 ng-if=currentPrimaryObj.tempArr.includes(index)><i class="fa fa-circle" style=font-size:10px;></i></div></div></div></div></div><div class=row ng-if="vm.primaryOperations.primaries.length > 0" ng-repeat=" currentPrimaryObj in vm.primaryOperations.primaries |  filter:{typeCompo:\'P\'}"><div class="columns cell" ng-class="{ \'medium-8\' : vm.oldMaintenanceTab,\'medium-6\' : !vm.oldMaintenanceTab, \'highlight\' : currentPrimaryObj.tempArr.includes(vm.hoverSearchIndex)}"><label class=labelFuildValue1>{{currentPrimaryObj.libelle}}</label></div><div class="medium-1 columns cell"><label ng-if=vm.oldMaintenanceTab class=labelFuildValue1><span ng-if="currentPrimaryObj.km_Apartir != null&&currentPrimaryObj.km_Apartir!=\'0.0\'">{{parseFloat(currentPrimaryObj.km_Apartir)}}</span></label> <label ng-if=!vm.oldMaintenanceTab class=labelFuildValue1><span ng-if="!vm.isMilesDisplay && currentPrimaryObj.period_Km_Toutes != null&&currentPrimaryObj.period_Km_Toutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.period_Km_Toutes)}}</span> <span ng-if="vm.isMilesDisplay && currentPrimaryObj.periodMlToutes != null&&currentPrimaryObj.periodMlToutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.periodMlToutes)}}</span></label></div><div ng-if=vm.oldMaintenanceTab class="medium-1 columns cell"><div class=labelFuildValue1><span ng-if="currentPrimaryObj.distan_Apartir != null&&currentPrimaryObj.distan_Apartir!=0">{{parseFloat(currentPrimaryObj.distan_Apartir)}}</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><div class=labelFuildValue1><span ng-if="!vm.isMilesDisplay && currentPrimaryObj.period_Km_Toutes != null&&currentPrimaryObj.period_Km_Toutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.period_Km_Toutes)}}</span></div><div class=labelFuildValue1><span ng-if="vm.isMilesDisplay && currentPrimaryObj.periodMlToutes != null&&currentPrimaryObj.periodMlToutes!=\'0.0\'">{{parseFloat(currentPrimaryObj.periodMlToutes)}}</span></div></div><div ng-if=vm.oldMaintenanceTab class="medium-1 cell"><label class=labelFuildValue1><span ng-if="currentPrimaryObj.period_Distan_Toutes != null&&currentPrimaryObj.period_Distan_Toutes!=0.0">{{parseFloat(currentPrimaryObj.period_Distan_Toutes)}}</span></label></div><div ng-if=!vm.oldMaintenanceTab class="medium-5 cell labelUnityPrimaries" style=padding-top:0><div class=row style="background: none;"><div ng-repeat="(index, year) in vm.yearColumn" ng-mouseenter="vm.setVariables(index, year)" ng-mouseleave=vm.removeVariables() ng-if=!vm.oldMaintenanceTab class="medium-1 columns cell yearColumn {{\'primaryContent-\'+index}}" ng-class="{  \'highlight\' : vm.hoverYearIndex == year}" style="padding: 12px;"><div class=labelFuildValue1 ng-if=currentPrimaryObj.tempArr.includes(index)><i class="fa fa-circle" style=font-size:10px;></i></div></div></div></div></div></div><!-- <span ng-if="!vm.showNoDataFound" class="labelBetweenTable2">(*){{vm.primaryOperations.primaryFooter}}</span> --></div><div ng-if=vm.isPlannedAssistance class=secondaries style="margin-top:0;margin-left: 20px;margin-top:0px;width: 45%;"><div class=titlePrimaries><div class=row style="border-bottom:none;display: flex"><div class=labelFuildValue2 style="padding: 7px 7px 0 7px;">{{\'PLANNED_ASSIT_MILEAGE\' | translate}}</div><div style="padding-top: 7px;"><input type=text aria-label="{{vm.primaryOperations.header2.km2Display }}" ng-model=vm.mileageData ng-disabled="(vm.showNoDataFound && vm.operationDelayed.length == 0 && vm.OperationTobeCarried.length == 0 && vm.upcomingOperation.length == 0 )"></div><div ng-click=" !vm.showNoDataFound && vm.saveMileage() " style="align-content: center;\n                                    padding: 7px;"><i class="fa fa-repeat showPointer" aria-hidden=true ng-class="{ \'showPointer\' : !vm.showNoDataFound,\'disableRefresh\' : (vm.showNoDataFound && vm.operationDelayed.length == 0 && vm.OperationTobeCarried.length == 0 && vm.upcomingOperation.length == 0 )}"><md-tooltip md-direction=bottom><span>{{"KM_REFRESH"|translate}}</span></md-tooltip></i></div></div><div class=row ng-if=vm.lastMileageDisplay style="background-color: #dadada;padding: 0px 7px 0 7px;border-bottom:none;"><div class=labelFuildValue2 ng-if=vm.isMilesDisplay>{{\'LATEST_MILEAGE\' | translate}} {{vm.kmToMileData(vm.oldMileageValue)}} {{vm.primaryOperations.header2.km1}}</div><div class=labelFuildValue2 ng-if=!vm.isMilesDisplay>{{\'LATEST_MILEAGE\' | translate}} {{vm.oldMileageValue}} {{vm.primaryOperations.header2.km1}}</div></div><div class=row style="padding: 7px 7px 0 7px;"><div class=labelFuildValue2>{{\'PLANNED_ASSIT_MSG\' | translate}}</div></div></div><div class=row style="padding: 10px;border-bottom: none;"></div><!-- titlePrimaries --><div class=titlePrimaries><div class=row><div class="columns cell medium-12"><label class=labelFuildValue2>{{\'OPERATIONS_DELAYED\'| translate}}</label></div></div></div><div class=valuesPrimaries ng-if="vm.operationDelayed.length == 0"><div class=row><div class="columns cell"><label class=labelFuildValue1>-</label></div></div></div><div class=valuesPrimaries ng-if="vm.operationDelayed.length > 0"><div class=row ng-repeat="delayedOperation in vm.operationDelayed"><div class="columns cell medium-6"><label class=labelFuildValue1>{{delayedOperation.libelle}}</label></div></div></div><div class=titlePrimaries style="margin-top: 15px;"><div class=row><div class="columns cell medium-6"><label class=labelFuildValue2>{{\'CURRENT_OPERATIONS\'| translate}}</label></div><div class="columns medium-3 cell" style="text-align: center;"><label class=labelFuildValue2>{{\'MAINTENANCE_DUE_DATE\' | translate}}</label></div><div class="columns medium-3 cell" style="text-transform: uppercase;text-align: center"><label class=labelFuildValue2>{{vm.primaryOperations.header2.km1 }}</label></div></div></div><div class=valuesPrimaries ng-if="vm.OperationTobeCarried.length == 0"><div class=row><div class="columns cell medium-6"><label class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1>-</label></div></div></div><div class=valuesPrimaries ng-if="vm.OperationTobeCarried.length > 0"><div class=row ng-repeat="currentOperations in vm.OperationTobeCarried"><div class="columns cell medium-6"><label class=labelFuildValue1>{{currentOperations.libelle}}</label></div><div class="columns medium-3 cell"><label ng-if=currentOperations.nextDate class=labelFuildValue1>{{currentOperations.nextDate}}</label> <label ng-if=!currentOperations.nextDate class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1 ng-if="!vm.isMilesDisplay && currentOperations.nextMileage">{{currentOperations.nextMileage}}</label> <label class=labelFuildValue1 ng-if="!vm.isMilesDisplay && !currentOperations.nextMileage">-</label> <label class=labelFuildValue1 ng-if=vm.isMilesDisplay>{{vm.kmToMileData(currentOperations.nextMileage)}}</label></div></div></div><div class=titlePrimaries style="margin-top: 15px;"><div class=row><div class="columns cell medium-6"><label class=labelFuildValue2>{{\'UPCOMING_OPERATIONS\'| translate}}</label></div><div class="columns medium-3 cell" style="text-align: center;"><label class=labelFuildValue2>{{\'MAINTENANCE_DUE_DATE\' | translate}}</label></div><div class="columns medium-3 cell" style="text-transform: uppercase;text-align: center"><label class=labelFuildValue2>{{vm.primaryOperations.header2.km1 }}</label></div></div></div><div class=valuesPrimaries ng-if=" vm.upcomingOperation.length == 0"><div class=row><div class="columns cell medium-6"><label class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1>-</label></div></div></div><div class=valuesPrimaries ng-if="vm.upcomingOperation.length > 0"><div class=row ng-repeat="upcomingOperation in vm.upcomingOperation"><div class="columns cell medium-6"><label class=labelFuildValue1>{{upcomingOperation.libelle}}</label></div><div class="columns medium-3 cell"><label ng-if=upcomingOperation.nextDate class=labelFuildValue1>{{upcomingOperation.nextDate}}</label> <label ng-if=!upcomingOperation.nextDate class=labelFuildValue1>-</label></div><div class="columns medium-3 cell"><label class=labelFuildValue1 ng-if="!vm.isMilesDisplay && upcomingOperation.nextMileage">{{upcomingOperation.nextMileage}}</label> <label class=labelFuildValue1 ng-if="!vm.isMilesDisplay && !upcomingOperation.nextMileage">-</label> <label class=labelFuildValue1 ng-if=vm.isMilesDisplay>{{vm.kmToMileData(upcomingOperation.nextMileage)}}</label></div></div></div></div></div><!--Secondaries--><div class=secondaries><div class=titlePrimaries><div class=row><div class="medium-10 columns labelTitlePrimaries">{{vm.secondaryOperations.header}}</div></div></div><div ng-if=vm.checkRevisions class=valuesSecondries><div class=row-secondary><div class="medium-10 columns labelTitlePrimaries"></div><div ng-if=vm.checkFirstRevision ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision),  \'medium-2\' : (vm.checkFirstRevision && !vm.checkSecondRevision) }" class="columns labelIndexPrimaries" style="text-align: center;">A</div><div ng-if=vm.checkSecondRevision ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision),  \'medium-2\' : (!vm.checkFirstRevision && vm.checkSecondRevision) }" class="columns labelIndexPrimaries" style="text-align: center;">B</div></div><div class=row-secondary><div class="medium-10 columns labelTitlePrimaries"></div><div ng-if=vm.checkFirstRevision ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (vm.checkFirstRevision && !vm.checkSecondRevision) }" class="columns labelIndexPrimaries" style="text-align: center;">A</div><div ng-if=vm.checkSecondRevision ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (!vm.checkFirstRevision && vm.checkSecondRevision) }" class="columns labelIndexPrimaries" style="text-align: center;">B</div></div></div><div ng-if=vm.checkRevisions class=valuesSecondries><div class=row ng-repeat="secdry in vm.secondaryOperations.secondaries"><div class="medium-10 columns cell"><label class=labelFuildValue1>{{secdry.labelSecondary}}</label></div><div ng-if=vm.checkFirstRevision class=cell ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (vm.checkFirstRevision && !vm.checkSecondRevision) }"><div class=au_centre ng-if="secdry.FirstIndicator == 1"><span><i class="fa fa-circle" style=font-size:10px;></i></span></div></div><div ng-if=vm.checkSecondRevision class=cell ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (!vm.checkFirstRevision && vm.checkSecondRevision) }"><div class=au_centre ng-if="secdry.SecondIndicator == 1"><span><i class="fa fa-circle" style=font-size:10px;></i></span></div></div></div><div class=row ng-if="vm.secondaryOperations.secondaries.length%2!=0"><div class="medium-10 columns cell"></div><div ng-if=vm.checkFirstRevision class=cell ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (vm.checkFirstRevision && !vm.checkSecondRevision) }"><div class=au_centre ng-if="secdry.FirstIndicator == 1"></div></div><div ng-if=vm.checkSecondRevision class=cell ng-class="{ \'medium-1\' : (vm.checkFirstRevision && vm.checkSecondRevision), \'medium-2\' : (!vm.checkFirstRevision && vm.checkSecondRevision) }"><div class=au_centre ng-if="secdry.SecondIndicator == 1"></div></div></div><div class=row ng-if="vm.secondaryOperations.secondaries===undefined"><div class="medium-10 columns cell"></div><div ng-if=vm.checkFirstRevision class="medium-1 cell"><div class=au_centre ng-if="secdry.FirstIndicator == 1"></div></div><div ng-if=vm.checkSecondRevision class="medium-1 cell"><div class=au_centre ng-if="secdry.SecondIndicator == 1"></div></div></div></div><div ng-if=!vm.checkRevisions class=valuesSecondries><div class=row-secondary><div class="medium-10 columns labelTitlePrimaries">&nbsp;</div></div><div class=row-secondary><div class="medium-10 columns labelTitlePrimaries">&nbsp;</div></div></div><div ng-if=!vm.checkRevisions class=valuesSecondries><div class=row ng-repeat="secdry in vm.secondaryOperations.secondaries"><div class="medium-10 columns cell"><label class=labelFuildValue1>{{secdry.labelSecondary}}</label></div></div><div class=row ng-if="vm.secondaryOperations.secondaries.length%2!=0"><div class="medium-10 columns cell"></div></div><div class=row ng-if="vm.secondaryOperations.secondaries===undefined"><div class="medium-10 columns cell"></div></div></div><div class=block_advice><br><label class=labelBetweenTable1>{{vm.secondaryOperations.footer}}</label><div ng-repeat="infospecialobj in vm.secondaryOperations.infospecial "><label class=labelBetweenTable1><span>{{infospecialobj.libInfoSpe}}</span></label></div></div></div><!--Fluids--><div class=fluids><div id=fluidConsigne><label class=titleLabel>{{vm.thirdTabOperations.headers.fluidesHeader}}</label></div><div id=fluidContainer><div class=row1 ng-if=vm.showHuileContent><div class="medium-8 columns" id=fluidContLeft><div class=blockFuildTitle><label class=labelFuildTitle>{{vm.thirdTabOperations.headers.huileMoteurHeader}}</label></div><div class=fluidItem><div class=row><div class="small-7 columns cell5"><label class=fluidStandard>{{vm.ALERTS_LEVEL_ALERTS_STANDARD}}: {{vm.thirdTabOperations.standardData.value}}</label></div><div class="small-5 columns"><label class=fluidStandard>{{vm.CAR_FEATURE_AVERAGE_CAPACITY}} {{vm.thirdTabOperations.standardData.averageCapacity}} {{vm.thirdTabOperations.standardData.unit}}</label></div></div><div class=row><div class="small-7 columns cell5"><label class=labelFuildTitle1>{{vm.thirdTabOperations.headers.gradesHeader}}</label><div style="margin-bottom: 10px;"><table class=row1><tr><td rowspan={{vm.temparatureMapLength+2}}>{{vm.thirdTabOperations.standardData.label}}</td></tr><tr><td class=border-row><span>&#176C</span></td><td class=border-row ng-repeat="standard in vm.headCells">{{standard}}</td></tr><tr ng-repeat="(temperature,grades) \n                                                            in vm.thirdTabOperations.standardData.temparatureMap"><td class=border-row>{{temperature}}<span>&#176C</span></td><td class=border-row ng-repeat="gradeObj in grades">{{vm.getUniquegrade(gradeObj)}} <span ng-if="vm.shouldShowCatalogIcon(temperature, gradeObj)" class="cursor-pointer margin-left-10 icon-icons_pop_out catalog-icon-align" ng-click=vm.goToCatalogPLate(vm.getUniquegrade(gradeObj)) ng-keypress=vm.goToCatalogPLate(vm.getUniquegrade(gradeObj))></span></td></tr></table></div></div><div class="small-5 columns"><label class=labelFuildTitle1>{{vm.thirdTabOperations.headers.preconiseHeader}}</label> <span><div ng-if=!vm.brand><img class="logoDisplay castrolLogoDisplay" src=./assets/images/castrol.png alt=""></div><div ng-if=vm.brand><img class=logoDisplay src=./assets/images/dacia.png alt=""></div></span></div></div><div class=row><div class=blockmanufacturerNote><label class=manufacturerNote>{{vm.thirdTabOperations.footer}}</label></div></div></div></div><div class="medium-4 columns" id=fluidContRight><div><div class=blockFuildTitle><label class=labelFuildTitle>{{vm.thirdTabOperations.headers.freinHeader}}</label></div><div class=fluidTable><div class=row ng-if=vm.thirdTabOperations.freins.typeLiqFrein><div class="small-12 columns cell"><label class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{vm.thirdTabOperations.freins.typeLiqFrein}}</span></label></div></div><div ng-if=!vm.thirdTabOperations.freins.typeLiqFrein class=row><div class="small-12 columns cell"><label ng-repeat="frein   in vm.thirdTabOperations.freins" class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{frein.typeLiqFrein}}</span></label></div></div></div></div><div><div class=blockFuildTitle><label class=labelFuildTitle>{{vm.thirdTabOperations.headers.refroidissementHeader}}</label></div><div class=fluidTable><div class=row ng-if=vm.thirdTabOperations.refroidissement.typeLiqRefro><div class="small-12 columns cell"><label class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{vm.thirdTabOperations.refroidissement.typeLiqRefro}}</span></label></div></div><div class=row ng-if=!vm.thirdTabOperations.refroidissement.typeLiqRefro><div class="small-12 columns cell"><label ng-repeat="refroidissement   in vm.thirdTabOperations.refroidissement" class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{refroidissement.typeLiqRefro}}</span></label></div></div></div></div></div></div><div ng-if=!vm.showHuileContent><div class="medium-9 columns" id=fluidContCenter><div class="medium-6 columns" id=fluidContLeft><div class=blockFuildTitle><label class=labelFuildTitle>{{vm.thirdTabOperations.headers.freinHeader}}</label></div><div class=fluidTable><div class=row ng-if=vm.thirdTabOperations.freins.typeLiqFrein><div class="small-12 columns cell"><label class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{vm.thirdTabOperations.freins.typeLiqFrein}}</span></label></div></div><div ng-if=!vm.thirdTabOperations.freins.typeLiqFrein class=row><div class="small-12 columns cell"><label ng-repeat="frein   in vm.thirdTabOperations.freins" class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{frein.typeLiqFrein}}</span></label></div></div></div></div><div class="medium-6 columns" id=fluidContRight><div class=blockFuildTitle><label class=labelFuildTitle>{{vm.thirdTabOperations.headers.refroidissementHeader}}</label></div><div class=fluidTable><div class=row ng-if=vm.thirdTabOperations.refroidissement.typeLiqRefro><div class="small-12 columns cell"><label class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{vm.thirdTabOperations.refroidissement.typeLiqRefro}}</span></label></div></div><div class=row ng-if=!vm.thirdTabOperations.refroidissement.typeLiqRefro><div class="small-12 columns cell"><label ng-repeat="refroidissement   in vm.thirdTabOperations.refroidissement" class=labelFuildrightValue1>{{ vm.CAR_OTS_TYPE }} : <span>{{refroidissement.typeLiqRefro}}</span></label></div></div></div></div></div></div></div></div></div><div ng-if=!vm.showContent>{{vm.VEHICLE_DETAIL_TAB_MAINTENANCE_PROGRAM_ABSENT}}</div></div>');
$templateCache.put('app/components/car/features/components/carOts/carOts.template.html','<div id=ots><div ng-if=!vm.loading><!-- ==================\n            ROWS > 0\n        =================== --><div class="centered-div documents-table" ng-if=vm.showContent><!-- ==================\n                    HEADERS\n            =================== --><div class="row row-title"><div class="small-2 columns">{{\'CAR_OTS_TYPE\' | translate}}</div><div class="small-2 columns">{{\'CAR_OTS_NUMOTS\' | translate}}</div><div class="small-4 columns">{{\'CAR_OTS_LIBELLEOTS\' | translate}}</div><div class="small-2 columns">{{\'CAR_OTS_NUMNOTETECHNIQUE\' | translate}}</div><div class="small-2 columns">{{\'CAR_OTS_AGREMENTOBLIGATOIRE\' | translate}}</div></div><!-- ======================\n                        ROWS\n            ======================= --><div id=otsList class="row row-ots" ng-class="{otsSelected:(ot.technicalNoteId && ot.technicalNoteId != \'NA\' && ot.link)}" ng-repeat="ot in vm.otsFront | orderBy:[\'-colorCode\',\'+id\']" ng-click=vm.onBTClick(ot)><div class="small-2 columns"><div class=value-inline ng-switch on=ot.colorCode><div ng-switch-when=B><span class=icon-icons_ots_B></span> <span class=label_font_ots_type_blue>{{\'BLUE_COLOR\' | translate}}</span></div><div ng-switch-when=R><span class=icon-icons_ots_R></span> <span class=label_font_ots_type_red>{{\'RED_COLOR\' | translate}}</span></div><div ng-switch-when=Y><span class=icon-icons_ots_Y></span> <span class=label_font_ots_type_yellow>{{\'YELLOW_COLOR\' | translate}}</span></div></div></div><div class="small-2 columns label_font_ots_value_black">{{::ot.id}}</div><div class="small-4 columns label_font_ots_value_black">{{::ot.designation}}</div><div class="small-2 columns"><span ng-if="ot.technicalNoteId == null" tooltip-placement=bottom tooltip-html-unsafe="{{\'NO_BT_NT\' | translate}}&nbsp;{{ot.description}}"><img src=./assets/images/no-document.png class=ots_iconDetail alt=""></span><span ng-class="{\'noLink\' : !ot.link}" ng-if="ot.technicalNoteId && !ot.link" tooltip-placement=bottom tooltip-html-unsafe="{{\'NO_BT_NT\' | translate}}&nbsp;{{ot.description}}"><img src=./assets/images/no-document.png class=ots_iconDetail alt=""><div class=label_font_ots_note_technique>{{::ot.fullTechnicalNoteId}}</div></span><span ng-if="ot.technicalNoteId && ot.link" ng-class="{\'ots_technical_column\': vm.isBTCreatedWithinLastThirtyDays(ot.link.creationDate) || vm.isBTUpdatedWithinLastThirtyDays(ot.link.updateDate)}"><img src=./assets/svg/icons_details.svg class=ots_iconDetail alt=""><div class=label_font_ots_note_technique>{{::ot.fullTechnicalNoteId}}</div><img ng-if=vm.isBTCreatedWithinLastThirtyDays(ot.link.creationDate) src=./assets/svg/icons_circle_star.svg tooltip-placement=bottom tooltip-html-unsafe="{{\'BT_CREATED\' | translate}}&nbsp;{{vm.formatDate(ot.link.creationDate)}}" class="ots_updateIcon ots-tooltip-trigger" alt=""> <img ng-if="!vm.isBTCreatedWithinLastThirtyDays(ot.link.creationDate) && vm.isBTUpdatedWithinLastThirtyDays(ot.link.updateDate)" src=./assets/svg/icons_update_arrows.svg tooltip-placement=bottom tooltip-html-unsafe="{{\'BT_UPDATED\' | translate}}&nbsp;{{vm.formatDate(ot.link.updateDate)}}" class="ots_updateIcon ots-tooltip-trigger" alt=""></span></div><div class="small-2 columns label_font_ots_value_black">{{::ot.mandatoryApproval |translate}}</div></div></div><!-- ==================\n            ROWS = 0\n        =================== --><div ng-if=!vm.showContent>{{\'VEHICLE_DETAIL_TAB_OTS_ABSENT\'|translate}}</div></div></div>');
$templateCache.put('app/components/car/features/components/carTechnicalCriteria/carTechnicalCriteria.template.html','<div id=technical class=dataSheet><!-- ===========================\n            CATEGORIES BLOCK\n    ============================ --><div class="small-3 columns"><div class=technical_menu><div><div class=menu_title>{{\'VEHICLE_TECHNICAL_CRITERION_GO_TO\'|translate}}</div><div class=clickable ng-repeat="category in vm.categories" ng-click=vm.goToSelectedCategory(category.name)><div ng-show={{!category.empty}}><span class=icon-icons_arrow_link_technical></span> <span class=technicalLabel>{{category.name|translate}}</span> <img ng-if="(category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE\' && vm.hasAPVNM2) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION\' && vm.hasAPVNM3) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION\' && vm.hasAPVNM4)" src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div></div></div></div></div><!-- =================================\n           DETAILS CATEGORIES BLOCK\n    =================================== --><div class="small-9 columns containerCategory"><div class="small-6 initData clickable" ng-class="{\'disabled\': vm.isLightFiltering, \'columns\': vm.isVisibleResetTechnicalCriteria}" style="text-align: left;margin-left:-1%;" ng-style="{\'margin-left\' : vm.isVisibleResetTechnicalCriteria ? \'-1%\': \'0\'}" ng-if="!vm.isIndependentUser && !vm.isSearchByModel && !vm.showTechCritTab" ng-click="!vm.isLightFiltering && vm.onLightFiltering()"><span><img class=logoDisplay ng-class="{disabled: vm.isLightFiltering}" src=./assets/images/filter_reset.png width=20 height=20 alt=""></span>{{\'LIGHT_FILTERING\'|translate}}</div><!-- =================================\n                RESET TECHNICAL CRITERIA\n        =================================== --><div class="small-6 small-offset-6 initData clickable" ng-if=vm.isVisibleResetTechnicalCriteria ng-click=vm.onResetTechnicalCriteria(true)><i class=icon-icons_refresh_technical></i> {{\'VEHICLE_TECHNICAL_CRITERION_INITIALIZE\'|translate}}</div><div id={{category.name}} class=blocCategory ng-repeat="category in vm.categories"><div ng-show={{!category.empty}}><!-- =================================\n                                READ MODE\n                =================================== --><div ng-if="category.mode === vm.categoryMode.Read"><!-- =================================\n                           CATEGORY NAME + EDIT BUTTON\n                    =================================== --><div class=firstLineCategory><div class=category><label>{{category.name|translate}} <img ng-if="(category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE\' && vm.hasAPVNM2) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION\' && vm.hasAPVNM3) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION\' && vm.hasAPVNM4)" src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></label></div><div ng-if=!vm.showTechCritTab class="editCategory clickable" ng-click=vm.onEditCategoryItems(category)><i class=icon-icons_change_technical></i> <label>{{\'VEHICLE_TECHNICAL_CRITERION_EDIT\'|translate}}</label></div></div><!-- =================================\n                                    ITEMS\n                    =================================== --><div ng-repeat="item in category.codes track by item.codeObject"><div class="row elementLineCategory"><div class="small-6 column elementLabel">{{item.labelObject}}</div><div class="tyres small-2 elementValue" ng-class="{\'removeTextcaseStyle\': item.codeObject == \'nrce\'}">{{vm.getItemValue(item)}} <span ng-if=vm.getItemWarnings(item) class=tyresWarning>{{vm.getItemWarnings(item)}}</span></div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE\' && item.codeObject === \'APVNM2\' && vm.hasAPVNM2" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APVNM2}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION\' && item.codeObject === \'APVNM3\' && vm.hasAPVNM3" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APVNM3}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION\' && item.codeObject === \'APVNM4\' && vm.hasAPVNM4" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APVNM4}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.codeObject === \'APV003\' && vm.hasAPV002" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APV002}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.codeObject === \'APV003\' && vm.hasAPV003" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APV003}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.codeObject === \'APV003\' && vm.hasAPV004" class="row elementLineCategory"><div class="small-6 column elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="tyres small-2 elementValue">{{vm.carContextRequest.standardExchange.APV004}}</div></div></div></div><!-- =================================\n                                WRITE MODE\n                =================================== --><div ng-if="category.mode === vm.categoryMode.Write"><!-- ========================================\n                        CATEGORY NAME + CANCEL & SAVE BUTTON\n                    ========================================= --><div class=firstLineCategory><div class=category><label>{{category.name|translate}} <img ng-if="(category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE\' && vm.hasAPVNM2) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION\' && vm.hasAPVNM3) || (category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION\' && vm.hasAPVNM4)" src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></label></div><div class=editCategory><span ng-click=vm.onCancelCategoryItems(category)><i class=icon-icons_close_technical></i> <label class=editAnnulerTechnical>{{\'VEHICLE_TECHNICAL_CRITERION_CANCEL\'|translate}}</label> </span><span ng-click=vm.onSaveCategoryItems(category)><i class=icon-icons_save_mention_technical></i> <label>{{\'VEHICLE_TECHNICAL_CRITERION_SAVE\'|translate}}</label></span></div></div><!-- =================================\n                                    ITEMS\n                    =================================== --><div ng-repeat="item in category.codes track by item.codeObject"><div class="row elementLineCategory"><div class="small-6 columns elementLabel">{{item.labelObject}}</div><div class="small-6 columns elementValue"><span class="small-11 colmuns">{{vm.getItemValue(item)}}</span> <span class="small-1 columns float-right font-bold cursor-pointer" ng-if=vm.isEditableItem(item) ng-click=vm.onResetItem(item)>X</span></div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_ENGINE\' && item.labelObject === \'ENGINE PRODUCTION NUMBER\' && vm.hasAPVNM2" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APVNM2}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_TRANSMISSION\' && item.labelObject === \'GEARBOX PRODUCTION NUMBER\' && vm.hasAPVNM3" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APVNM3}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_BATTERY_TRACTION\' && item.labelObject === \'TRACTION BATTERY PRODUCTION NUMBER\' && vm.hasAPVNM4" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_NO\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APVNM4}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.labelObject === \'GEARBOX PRODUCTION PLANT\' && vm.hasAPV002" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APV002}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.labelObject === \'GEARBOX PRODUCTION PLANT\' && vm.hasAPV003" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APV003}}</div></div><div ng-if="category.name === \'VEHICLE_TECHNICAL_CRITERION_CATEGORY_VARIOUS\' && item.labelObject === \'GEARBOX PRODUCTION PLANT\' && vm.hasAPV004" class="row elementLineCategory"><div class="small-6 columns elementLabel">{{\'STD_EXCHANGE_MANF_PLANT\' | translate}} <img src=./assets/images/std-exchange.svg height=25 width=25 class=std-exchange-img title="{{\'STD_EXCHANGE_TOOLTIP\' | translate}}"></div><div class="small-6 columns elementValue">{{vm.carContextRequest.standardExchange.APV004}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/car/features/components/vehicleMaintenanceHistory/vehicleMaintenanceHistory.template.html','<div id=vehiclemaintenance><div ng-if=!vm.loading><div class=title ng-if="vm.showContent && !vm.showOperationDetail && vm.operationsList.length != 0">{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATIONS\' | translate}}</div><div class="centered-div documents-table" ng-if="vm.showContent && !vm.showOperationDetail && vm.operationsList.length != 0"><table class=table id=operaionHistoryTable st-table=vm.operationsList><thead><tr><th st-sort=repairOrderDate class="width9 subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_DATE\' | translate}}</th><th st-sort=mileageValue class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_KM\' | translate}}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_RC\' | translate}}</th><th class="title_width subTitle">{{ \'VEHICLE_MAINTENANCE_HISTORY_SYMPTOM\' | translate}}</th><th class=subTitle style="width: 66%;">{{ \'VEHICLE_MAINTENANCE_HISTORY_DESCRIPTION\' | translate }}</th><th class="title_width subTitle" ng-hide=vm.isIndependentUser>{{\'VEHICLE_MAINTENANCE_HISTORY_OTS_NO\' | translate}}</th><th class="title_width subTitle" ng-if=vm.isIndependentUser>{{\'ACTIONS_INDEPENDENT\' | translate}}</th></tr></thead><tbody ng-repeat="operation in vm.operationsList" id=operationsTable><tr><td class=center><span class=collapseIcon><i ng-click=vm.showDetail(operation) ng-if=!operation.show class=icon-icons-phnx-expendable_plus></i> <i ng-click="operation.show = false" ng-if=operation.show class=icon-icons-phnx-exependable_moins></i> </span><span ng-click=vm.getOperationDetail(operation)>{{operation.repairOrderDate}}</span></td><td class=center ng-click=vm.getOperationDetail(operation)>{{operation.mileageValue}}</td><td class=center ng-click=vm.getOperationDetail(operation)>{{operation.customerComplaint[0].code}}</td><td class=center ng-click=vm.getOperationDetail(operation)>{{operation.symptom[0].code}}</td><td ng-click=vm.getOperationDetail(operation)><span ng-if="operation.customerComplaint[0].code === vm.operationsOrigin && operation.basketNumber">{{"OPERATION_LABEL" | translate}}{{operation.label}} </span><span ng-if="operation.customerComplaint[0].code === vm.operationsOrigin && operation.title">{{operation.label}}</span> <span ng-if=operation.refModule><img src=./assets/images/RG_icon.png class=margin-bottom-10 height=20 width=27 alt="">{{operation.label}}</span> <span ng-if="!operation.refModule && !operation.basketNumber && !operation.title">{{operation.label}}</span></td><td class=center ng-click=vm.getOperationDetail(operation) ng-hide=vm.isIndependentUser>{{operation.otsNumber}}</td><td class=center ng-if=vm.isIndependentUser><i ng-if="operation.customerComplaint[0].code === vm.operationsOrigin && operation.ipn === vm.user.ipn" ng-click="vm.getOperationDetail(operation, true); $event.stopPropagation();" class="fa fa-pencil" title="{{\'COMMON_EDIT\' | translate}}" style="cursor: pointer; font-size: 18px;margin-right: 10px;"></i> <i ng-if="operation.customerComplaint[0].code === vm.operationsOrigin && operation.ipn === vm.user.ipn" ng-click="vm.deleteOperation(operation); $event.stopPropagation();" class="fa fa-trash deleteIcon" title="{{\'COMMON_DELETE\' | translate}}" style="cursor: pointer; font-size: 18px;"></i></td></tr><tr ng-show=operation.show class=backgroundWhite><td colspan=5 class=opDetails><div class=table ng-if=!vm.newLaborAndPartsList[0].operationDesc><div class=operation_header><div class="width15 codeCol subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_CODE\' | translate}}</div><div class="width40 descriptionCol subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_DESCRIPTION\' | translate}}</div></div><div><div ng-repeat="laborAndPartsList in vm.newLaborAndPartsList | orderBy : operation.repairOrderDate" class="codeList operation_header"><span class="width15 center partListBorder">{{laborAndPartsList.ref | filterFormatRef}}</span> <span class="width40 center partListBorder labelCol">{{laborAndPartsList.label}}</span></div></div></div><table ng-if=vm.newLaborAndPartsList[0].operationDesc class=single-col-table><thead><tr><th class=single-col-header>{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_DESCRIPTION\' | translate}}</th></tr></thead><tbody><tr ng-repeat="laborAndPartsList in vm.newLaborAndPartsList | orderBy : operation.repairOrderDate"><td class=single-col-cell>{{laborAndPartsList.operationDesc}}</td></tr></tbody></table></td></tr></tbody></table></div><div ng-if="!vm.showContent && !vm.noOperationDetail || vm.operationsList.length == 0" style="font-size: var(--renaultLargeFont);">{{\'VEHICLE_MAINTENANCE_HISTORY_ABSENT\'|translate}}</div><div ng-if=vm.showOperationDetail><div class=btnBack ng-click=vm.goBack()><i class=icon-icons-phnx_back></i> {{\'VEHICLE_MAINTENANCE_HISTORY_BACK_TO_OPERATIONS\' | translate}}</div><div ng-if=!vm.isEditMode ng-click=vm.printMaintenance() class=printToPdf><i class=icon-icons_print_partlist style="float: right;\n                font-size: 30px;"></i></div><div class=title ng-if=vm.showContent>{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL\' | translate }}</div><div class="centered-div documents-table" ng-if=vm.showContent><table class=table id=vehiclemaintenance st-table=vm.operationsList ng-if=!vm.isInterventionView><thead><tr><th st-sort=repairOrderDate class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_DATE\' | translate}}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_KM\' | translate}}</th><th class="title_width subTitle" ng-hide=vm.isIndependentUser>{{\'VEHICLE_MAINTENANCE_HISTORY_OTS_NO\' | translate}}</th><th class=subTitle style="width: 50%;">{{ \'VEHICLE_MAINTENANCE_HISTORY_DESCRIPTION\' | translate }}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_RENAULT_INCIDENT\' | translate}}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_DREU\' | translate }}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_SIGMA\' | translate}}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_DEALERSHIP\' | translate}}</th><th class="title_width subTitle">{{\'VEHICLE_MAINTENANCE_HISTORY_OTHER\' | translate}}</th></tr></thead><tbody><tr><td class=center>{{vm.operation.repairOrderDate}}</td><td class=center>{{vm.operation.mileageValue}}</td><td class=center ng-hide=vm.isIndependentUser>{{vm.operation.otsNumber}}</td><td class=center>{{vm.operation.label}}</td><td class=center>{{vm.operation.coverageRateREN}} {{"%"}}</td><td class=center>{{vm.operation.coverageRateDREU}} {{"%"}}</td><td class=center>{{vm.operation.coverageRateRCI}} {{"%"}}</td><td class=center>{{vm.operation.coverageRateDealer}} {{"%"}}</td><td class=center>{{vm.operation.coverageRateOther}} {{"%"}}</td></tr></tbody></table><div ng-if=!vm.isInterventionView><div class=operation_header><div class="subTitle header_width">{{ \'VEHICLE_MAINTENANCE_HISTORY_SYMPTOM\' | translate }}</div><div class=centerPadding>{{vm.operation.symptom[0].label}}</div></div><div class=operation_header><div class="subTitle header_width">{{ \'VEHICLE_MAINTENANCE_HISTORY_CUSTOMER_COMPLAINT\' | translate}}</div><div class=centerPadding>{{vm.operation.customerComplaint[0].label}}</div></div><div class=operation_header><div class="subTitle header_width">{{ \'VEHICLE_MAINTENANCE_HISTORY_CUSTOMER_RECORD\' | translate}}</div><div class=centerPadding>{{vm.operationDetailsList.customerFeedback}}</div></div><div class=operation_header><div class="subTitle header_width">{{ \'VEHICLE_MAINTENANCE_HISTORY_REPAIR_DIAGNOSTIC\' | translate }}</div><div class=centerPadding>{{ vm.operationDetailsList.repairDiagnostic}}</div></div></div><table class=table id=vehiclemaintenance st-table=vm.laborAndPartsList><thead><tr><th class="title_width subTitle" ng-if=!vm.laborAndPartsList[0].isOperationDesc style="width: 15%;">{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_CODE\' | translate}}</th><th class="title_width subTitle" ng-if=!vm.laborAndPartsList[0].isOperationDesc>{{\'VEHICLE_MAINTENANCE_HISTORY_TIME\' | translate}}</th><th class="title_width subTitle" ng-if=!vm.laborAndPartsList[0].isOperationDesc>{{\'VEHICLE_MAINTENANCE_HISTORY_QUANTITY\' | translate}}</th><th class=subTitle style="width: 75%;">{{ \'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_DESCRIPTION\' | translate }} <span ng-if="vm.isIndependentUser && !vm.isEditMode && vm.showEditIcon"><i ng-click=vm.toggleEditMode() class="fa fa-pencil" style="cursor: pointer; font-size: 16px; margin-left: 10px;"></i> </span><span ng-if="vm.isIndependentUser && vm.isEditMode" style="float: right; margin-right: 20px;"><span ng-click=vm.saveDescriptions() style="cursor: pointer; color: green; margin-right: 15px;"><i class="fa fa-check" style="font-size: 16px;"></i> <span style="font-size: 12px; margin-left: 3px;">{{ \'COMMON_SAVE\' | translate }}</span> </span><span ng-click=vm.toggleEditMode() style="cursor: pointer; color: red;"><i class="fa fa-times-circle" style="font-size: 16px;"></i> <span style="font-size: 12px; margin-left: 3px;">{{ \'COMMON_CANCEL\' | translate }}</span></span></span></th></tr></thead><tbody><tr ng-repeat="laborAndPartsList in vm.laborAndPartsList | orderBy : operation.repairOrderDate"><td ng-if=!vm.laborAndPartsList[0].isOperationDesc class=center><span ng-if=!vm.isEditMode>{{laborAndPartsList.ref | filterFormatRef}}</span> <input ng-if=vm.isEditMode type=text ng-model=laborAndPartsList.ref class=edit-input ng-style="{\'width\': \'100%\', \'padding\': \'5px\', \'border\': laborAndPartsList.refError ? \'2px solid red\' : \'1px solid #ccc\', \'border-radius\': \'3px\', \'text-align\': \'center\'}"></td><td ng-if=!vm.laborAndPartsList[0].isOperationDesc class=center><span ng-if=!vm.isEditMode>{{laborAndPartsList.time}}</span> <input ng-if="vm.isEditMode && vm.originalLaborAndPartsList[$index].time" type=text ng-model=laborAndPartsList.time class=edit-input ng-style="{\'width\': \'100%\', \'padding\': \'5px\', \'border\': laborAndPartsList.timeError ? \'2px solid red\' : \'1px solid #ccc\', \'border-radius\': \'3px\', \'text-align\': \'center\'}"></td><td ng-if=!vm.laborAndPartsList[0].isOperationDesc class=center><span ng-if=!vm.isEditMode>{{laborAndPartsList.quantity}}</span> <input ng-if="vm.isEditMode && (vm.originalLaborAndPartsList[$index].quantity !== undefined && vm.originalLaborAndPartsList[$index].quantity !== null && vm.originalLaborAndPartsList[$index].quantity !== \'\')" type=text ng-model=laborAndPartsList.quantity class=edit-input ng-style="{\'width\': \'100%\', \'padding\': \'5px\', \'border\': laborAndPartsList.quantityError ? \'2px solid red\' : \'1px solid #ccc\', \'border-radius\': \'3px\', \'text-align\': \'center\'}"></td><td ng-if=!vm.laborAndPartsList[0].isOperationDesc><span ng-if=!vm.isEditMode>{{laborAndPartsList.label}}</span> <input ng-if=vm.isEditMode type=text ng-model=laborAndPartsList.label class=edit-input ng-style="{\'width\': \'100%\', \'padding\': \'5px\', \'border\': laborAndPartsList.labelError ? \'2px solid red\' : \'1px solid #ccc\', \'border-radius\': \'3px\'}"></td><td ng-if=vm.laborAndPartsList[0].isOperationDesc style="white-space: pre-line;"><span ng-if=!vm.isEditMode>{{vm.laborAndPartsList[0].operationDesc}}</span> <textarea ng-if=vm.isEditMode ng-model=vm.laborAndPartsList[0].operationDesc class=edit-input ng-style="{\'width\': \'100%\', \'padding\': \'5px\', \'border\': vm.laborAndPartsList[0].labelError ? \'2px solid red\' : \'1px solid #ccc\', \'border-radius\': \'3px\', \'min-height\': \'100px\'}"></textarea></td></tr></tbody></table></div></div><div ng-if="!vm.showContent && vm.noOperationDetail"><div class=btnBack ng-click=vm.goBack()><i class=icon-icons-phnx_back></i> {{\'VEHICLE_MAINTENANCE_HISTORY_BACK_TO_OPERATIONS\' | translate}}</div><div style="font-size: var(--renaultLargeFont);">{{\'VEHICLE_MAINTENANCE_HISTORY_OPERATION_DETAIL_ABSENT\' | translate}}</div></div></div></div>');
$templateCache.put('app/components/dms/quote/components/shoppingCart/shoppingCartQuote.template.html','<div ng-switch=$ctrl.page><div class=stock-component><!-- ********************************\n                    QUOTE PAGE\n            ************************************ --><div ng-switch-when=quote class=stock-component><!--  ***************\n                    REDUCE\n                ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=$ctrl.reduceOne() ng-if="$ctrl.piece.estimateQuantity > 1" title="{{\'DOCUMENT_PR_DECREASE_ESTIMATION\'| translate}}"></i></div><!-- ****************\n                    INPUT\n                ****************** --><div class=stockText><input double-only class=text-center type=text ng-model=$ctrl.piece.estimateQuantity pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ ng-model-options="{ debounce: 2000 }" ng-change=$ctrl.updateFromInputSecond()></div><!-- ****************\n                    ADD\n                ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=$ctrl.addOne() title="{{\'DOCUMENT_PR_INCREASE_ESTIMATION\'| translate}}"></i></div></div><!-- ********************************\n                    OTHER PAGES\n            ************************************ --><div ng-switch-default=ng-switch-default class=float-right><div class=stock-component ng-if=$ctrl.piece.estimateQuantity><!--  ***************\n                            REDUCE\n                    ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-click=$ctrl.reduceOne() pattern=^(?:[0-9]{1,3}(?:[.,][0-9]{1,4})?)?$ title="{{\'DOCUMENT_PR_DECREASE_ESTIMATION\'| translate}}"></i></div><!-- ****************\n                        INPUT\n                ****************** --><div class=stockText><input float-only class="decimal text-center" ng-change="$ctrl.updateFromInputSecond(\'{{$ctrl.piece.estimateQuantity}}\')" type=text ng-model=$ctrl.piece.estimateQuantity ng-model-options="{ debounce: 2000 }"></div><!-- ****************\n                        ADD\n                ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=$ctrl.addOne() title="{{\'DOCUMENT_PR_INCREASE_ESTIMATION\'| translate}}"></i></div></div><!-- ***************************\n                        ADD TO SHOPPING CART\n                **************************** --><div ng-if=!$ctrl.piece.estimateQuantity id=addToQuote one-click-only=$ctrl.addToShoppingCart() ng-style="{\'width\':$ctrl.isLandscape ? \'50px\' : \'\'}" ng-class="{\'shopping-cart-quote float-right\':$ctrl.canAddToQuote,\'shopping-cart shopping-cart-disabled\': !$ctrl.canAddToQuote}" title="{{\'DOCUMENT_PR_INCREASE_ESTIMATION\'| translate}}"><i class=icon-icons_estimation></i></div></div></div></div>');
$templateCache.put('app/components/dms/quote/components/shoppingCartQuotePage/shoppingCartQuotePage.template.html','<div class=stock-component><div class=stock-component><!--  ***************\n            REDUCE\n        ***************** --><div class=square><i class=icon-icons-phnx_stepper_moins ng-if="$ctrl.piece.quantity >1 " ng-click=$ctrl.reduceOne() title="{{\'DOCUMENT_PR_DECREASE_ESTIMATION\'| translate}}"></i></div><!-- ****************\n            INPUT\n        ****************** --><div class=stockText><input float-only class="decimal text-center" type=text ng-model=$ctrl.piece.quantity ng-model-options="{ debounce: 2000 }" ng-change="$ctrl.updateFromInputSecond(\'{{$ctrl.piece.quantity}}\')"></div><!-- ****************\n            ADD\n        ***************** --><div class=square><i class=icon-icons-phnx_stepper_plus ng-click=$ctrl.addOne() title="{{\'DOCUMENT_PR_INCREASE_ESTIMATION\'| translate}}"></i></div></div></div>');
$templateCache.put('app/components/dms/quote/list/draft/quoteDraftList.template.html','<div id=quoteListContainer><div ng-if=vm.dataLoaded><div class="row max-widthC"><!-- ************************************\n            *       FILTER COMPONENT ON LEFT        *\n            **************************************--><div class="small-3 columns cardShadow"><filter-list on-search=vm.onSearch type-of-supercart=vm.globalConstant.quote filters-values=vm.filterValues></filter-list></div><!-- ***********************************\n            *       LIST WITH PAGINATION ON RIGHT  *\n            ************************************ --><div class="small-9 columns"><div class=textCenter ng-if="vm.quoteList.length == 0"><h4>{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div ng-if="vm.quoteList.length > 0"><!-- ****************************\n                    *       LIST COMPONENT          *\n                    ******************************--><container-list list=vm.quoteList type=draftWorkshop is-part-requsition=false on-delete=vm.onDelete type-of-supercart=vm.globalConstant.quote on-sort=vm.onSort on-unlock=vm.onUnlock on-select=vm.onSelect on-check=vm.onCheck></container-list><!-- ***************************\n                    *         PAGINATION           *\n                    **************************** --><pagination-list count=vm.count update-pagination=vm.onUpdatePagination current-page=vm.currentPage></pagination-list></div></div></div></div></div>');
$templateCache.put('app/components/dms/quote/list/validated/quoteValidatedList.template.html','<div id=validatedQuoteListContainer><div ng-if=vm.dataLoaded><div class="row max-widthC"><!-- ************************************\n            *       FILTER COMPONENT ON LEFT        *\n            **************************************--><div class="small-3 columns cardShadow"><filter-list type-of-supercart=vm.globalConstant.quote on-search=vm.onSearch filters-values=vm.filterValues></filter-list></div><!-- ***********************************\n            *       LIST WITH PAGINATION ON RIGHT  *\n            ************************************ --><div class="small-9 columns"><div class=textCenter ng-if="vm.quoteList.length == 0"><h4>{{\'COMMON_NO_RESULT\' | translate}}</h4></div><div ng-if="vm.quoteList.length > 0"><!-- ****************************\n                    *       LIST COMPONENT          *\n                    ******************************--><container-list list=vm.quoteList type-of-supercart=vm.globalConstant.quote state-of-supercart=vm.globalConstant.validated on-sort=vm.onSort on-select=vm.onSelect></container-list><!-- ***************************\n                    *         PAGINATION           *\n                    **************************** --><pagination-list count=vm.count update-pagination=vm.onUpdatePagination current-page=vm.currentPage></pagination-list></div></div></div></div></div>');
$templateCache.put('app/components/dms/quote/modals/delete/actis-fic-modal.template.html','<div id=delete-reference-modal class=modalPhenix><!-- TITLE --><div class=title>{{vm.title | translate}}</div><!-- ITEMS TO DELETE --><ul ng-switch=vm.isList ng-hide=!vm.isList><li ng-switch-when=false>{{vm.reference | filterFormatRef}} {{vm.designation}}</li><li ng-switch-when=true ng-repeat="rows in vm.rows track by $index">{{rows.number}}</li></ul><!-- ACTIONS --><div class=modalPhenixButtons><button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/dms/quote/modals/delete/deleteReferenceModal.template.html','<div id=delete-reference-modal class=modalPhenix><!-- TITLE --><div class=title ng-style="vm.centerTitle && {\'text-align\': \'center\', \'font-weight\': \'bold\'}">{{vm.title | translate}}</div><!-- ITEMS TO DELETE --><ul ng-switch=vm.isList ng-hide=!vm.isList><li ng-switch-when=false>{{vm.reference | filterFormatRef}} {{vm.designation}}</li><li ng-switch-when=true ng-repeat="rows in vm.rows track by $index">{{rows.number}}</li></ul><!-- ACTIONS --><div class=modalPhenixButtons><button type=button class="buttonWithIcon left" ng-click=vm.onConfirm() ng-style="{\'background-color\':\'{{vm.color}}\'}"><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'COMMON_DELETE\' | translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onCancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/dms/quote/modals/paintQuoteModal/paintQuoteModal.template.html','<div id=paint-quote-modal><div class=title>{{\'TM_TYPE_PAINT_TITLE\' | translate}}</div><div class=container-list><md-radio-group ng-model=vm.selected><md-radio-button value=O>{{\'TM_TYPE_PAINT_1\' | translate}}</md-radio-button><md-radio-button value=V>{{\'TM_TYPE_PAINT_2\' | translate}}</md-radio-button><md-radio-button value=N>{{\'TM_TYPE_PAINT_3\' | translate}}</md-radio-button><md-radio-button value=S>{{\'TM_TYPE_PAINT_4\' | translate}}</md-radio-button></md-radio-group></div><div class="modalPhenixButtons bottom"><button type=button class=buttonWithIcon ng-class="{cancel: !vm.selected}" ng-click="vm.selected && vm.onSelectPaint(vm.selected)"><div class=iconDiv><i class=icon-icons_validate></i></div><div class=btnText>{{\'PRODUCT_ADD_TO_ESTIMATE\'|translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.onClose()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'|translate}}</div></button></div></div>');
$templateCache.put('app/components/favourites/TM/old/modal/favourite_modal.html','<div class=modalPhenix><div class=deleteDescription><div class=title><span ng-if="!vm.referencesSelected && !vm.isTM">{{\'FAV_MODAL_ADD_REF_DELETE_UNIQUE_TITLE\'|translate}}</span> <span ng-if="!vm.referencesSelected && vm.isTM">{{\'FAV_MODAL_ADD_TM_DELETE_UNIQUE_TITLE\'|translate}}</span> <span ng-if="vm.referencesSelected && !vm.isTM">{{\'FAV_MODAL_REF_DELETE_MULTIPLE_TITLE\' | translate : vm.translationDatas}}</span> <span ng-if="vm.referencesSelected && vm.isTM">{{\'FAV_MODAL_TM_DELETE_MULTIPLE_TITLE\' | translate : vm.translationDatas}}</span></div><div ng-if="vm.reference && !vm.isTM" class=description><span class=separator>{{vm.reference.reference | filterFormatRef}}</span><span>{{vm.reference.designationFav}}</span></div><div ng-if="vm.reference && vm.isTM" class=description><span class=separator>{{vm.reference.id}}</span><span>{{vm.reference.designation}}</span></div></div><div class=actionButton><button type=button class=buttonWithIcon ng-click=vm.delete()><div class=iconDiv><i class=icon-icons_remove></i></div><div class=btnText>{{\'COMMON_DELETE\'| translate}}</div></button> <button type=button class="buttonWithIcon cancel" ng-click=vm.cancel()><div class=iconDiv><i class=icon-icons_close></i></div><div class=btnText>{{\'COMMON_CANCEL\'| translate}}</div></button></div></div>');
$templateCache.put('app/components/favourites/TM/old/modal/favourite_modal_delete_category.html','<div class=modalPhenix><div class=deleteDescription><div class=title>{{vm.messagePart1}}<span class=titleBold>{{vm.category.number}}</span>{{vm.messagePart2}}<span class=titleBold>{{vm.category.name}}</span></div></div><div class=actionButton><button type=button ng-click=vm.delete() class=buttonWithIcon><div class=iconDiv><i class=icon-icons_remove></i></div><div class="btnText buttonDelCateg ng-binding">{{\'FAV_MODAL_CONFIRM_DELETE_CATEGORY\' | translate}}</div></button> <button type=button ng-click=vm.cancel() class="buttonWithIcon cancel cancelModalFav"><div class=iconDiv><i class=icon-icons_close></i></div><div class="btnText buttonDelCateg ng-binding">{{\'COMMON_CANCEL\' | translate}}</div></button></div></div>');
$templateCache.put('app/components/products/documents/bt/btDocuments/btDocuments.template.html','<div class="row documents-row-title"><div ng-if=!vm.fromSearch class="small-1 columns cell"></div><div class="small-1 columns cell" style="cursor: pointer;" ng-click="vm.sortBy(\'name\')">{{\'DOCUMENT_BT_ID\' | translate}} <span ng-class="vm.handleIconOrder(\'name\')"></span></div><div class="small-6 columns cell" style="cursor: pointer;" ng-click="vm.sortBy(\'designation\')">{{\'DOCUMENT_BT_TITLE\' | translate}} <span ng-class="vm.handleIconOrder(\'designation\')"></span></div><div ng-class="!vm.fromSearch ? \'small-1\' : \'small-2\'" class="columns cell" style="cursor: pointer;" ng-click="vm.sortBy(\'ots\')">{{\'DOCUMENT_BT_OTS\' | translate}} <span ng-class="vm.handleIconOrder(\'ots\')"></span></div><div class="small-1 columns cell" style="cursor: pointer;" ng-click="vm.sortBy(\'updateDate\')">{{\'DOCUMENT_BT_DATE\' | translate}} <span ng-class="vm.handleIconOrder(\'updateDate\')"></span></div><div ng-if=!vm.fromSearch class="small-2 columns cell" style="cursor: pointer;" ng-click="vm.sortBy(\'applicability\')">{{\'DOCUMENT_APPLICABILITY\' | translate}} <span ng-class="vm.handleIconOrder(\'applicability\')"></span></div><div ng-if=vm.fromSearch class="small-2 columns cell"></div></div><div style="cursor: default" class="row documents-row" ng-repeat="document in vm.listOfBTDocuments | orderBy:vm.propertyNamePR:vm.reversePR track by $index" ng-class="[{\'selected\': document.paramURL == vm.selectedBT && !vm.nissanUserURL},{\'selected-nissan\': document.paramURL == vm.selectedBT && vm.nissanUserURL},{\'documents-row-renault\':!vm.nissanUserURL,\'documents-row-nissan\':vm.nissanUserURL}]"><div ng-if=!vm.fromSearch class="small-1 columns cellBT" style="display: flex; justify-content: center"><span style="z-index: 10" ng-click="document.isExpand = !document.isExpand" ng-class="{\'icon-icons-phnx-expendable_plus\':!document.isExpand,\'icon-icons-phnx-exependable_moins\':document.isExpand}"></span></div><div class="small-1 columns cellBT" ng-right-click="vm.displayBtDetails(document.paramURL, document.pdfContent,document,true)" ng-click="vm.displayBtDetails(document.paramURL, document.pdfContent,document,false)" style="cursor: pointer">{{::document.name}}</div><div class="small-6 columns cellBT" ng-right-click="vm.displayBtDetails(document.paramURL, document.pdfContent,document,true)" ng-click="vm.displayBtDetails(document.paramURL, document.pdfContent,document,false)" style="cursor: pointer">{{::document.designation}}</div><div ng-class="!vm.fromSearch ? \'small-1\' : \'small-2\'" class="columns cellBT">{{::document.ots}}<div class=value-inline ng-switch on=document.colorCode><div class=value-inline ng-switch-when=GREEN><span class=icon-icons_ots_G></span></div><div class=value-inline ng-switch-when=YELLOW><span class=icon-icons_ots_Y></span></div><div class=value-inline ng-switch-when=BLUE><span class=icon-icons_ots_B></span></div></div></div><div class="small-1 columns cellBT">{{::document.updateDate}}</div><div ng-if=!vm.fromSearch class="small-2 columns cellBT"><applicability-tooltip sie-doc=document></applicability-tooltip></div><div ng-if=vm.fromSearch class="small-2 columns cellBT"></div><div ng-if=document.isExpand class=row style="border-bottom: unset !important"><div class="small-1 columns cellBT small-offset-1 color-grey"><strong>{{\'DOCUMENT_BT_DTC_CODE\' | translate}}</strong></div><div class="small-10 columns cellBT">{{::document.details.DTCList.join(\' - \')}} &nbsp;</div><div class="small-1 columns cellBT small-offset-1 color-grey"><strong>{{\'DOCUMENT_BT_SYMPTOM_CODE\' | translate}}</strong></div><div class="small-10 columns cellBT"><div ng-repeat="symptom in document.details.symptomList | orderBy : \'toString()\'">{{::symptom}}</div>&nbsp;</div></div></div>');
$templateCache.put('app/components/products/documents/bt/btDocuments/btDocumentsDetails.template.html','<div id=DetailBT><div sticky name-class=fixedInfoNode style="display: flex; flex-direction: row; padding: 15px 0px;z-index:100" class=no-print><div class=infoNode><div class=btnBacktoList ng-if="vm.documentsHistory.length > 1 && !vm.isBTInNewTab" ng-click=vm.goToListPiece()><i class=icon-icons-phnx_double_back></i></div><div class="btnBack no-print" ng-if="!vm.isBTInNewTab && !vm.isSameTab" ng-click=vm.backToPreviousDocument()><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=separator ng-if=!vm.isBTInNewTab></div><div class=no-print><span class=infoPiece>{{vm.contentBT.title}}</span></div><div ng-if=vm.canPrint class="clickable no-print" ng-click=vm.downloadPdf() tooltip-placement=bottom tooltip-html-unsafe="{{\'BUTTON_ESTIMATE_PRINT\' | translate}}" style="position: absolute;right: 5%" class=no-print><i class=icon-icons_print_panier style=font-size:30px;></i></div></div></div><div class=only-print style="display: none;"><span class="infoPiece btTitle">{{vm.contentBT.title}}</span></div><div class=only-print style="display: none;"><div class=btStatus ng-if=vm.contentBT.status><img src=../../assets/images/triman.png width=20 height=20 alt="Triman Logo" style="position: relative;bottom: 5px;right: 8px;"> <span>Status: {{vm.contentBT.status}}</span></div></div><div class=only-print style="display: none;"><div class=btVersion ng-if="vm.contentBT.sieVersion || vm.contentBT.sieName"><span>{{vm.contentBT.sieName}}</span> <span style="margin-left: 10px;">Version: {{vm.contentBT.sieVersion}}</span></div></div><!-- ***************\n        DOCUMENTATION\n    **************** --><div id=generateDoc ng-if=vm.contentBT.content is-new-tab=vm.isNewTab generate-documentation-sie documentation=vm.contentBT.content on-clicked-link=vm.onClickedLink is-new-tab-open=vm.isBTInNewTab></div><!-- **********\n        POPUP\n    *********** --><div style="visibility: hidden"><div class=md-dialog-container id=myStaticDialog><md-dialog><dialog-documentation-sie list-sie=vm.listBT on-clicked-link=vm.onClickedLink sie-title=vm.contentBT.title></dialog-documentation-sie></md-dialog></div></div></div>');
$templateCache.put('app/components/products/documents/bt/btDocuments/btListDoc.template.html','<div class=only-print style=display:none;><img src=../../assets/images/renaultgroup.png width=75 height=75 style="margin-top: 20px;"></div><div id=DetailBT><div sticky name-class=fixedInfoNode style="display: flex; flex-direction: row; padding: 15px 0px"><div class=infoNode><div class=no-print><span class=infoPiece>{{vm.contentBT.title}}</span></div><div ng-if=vm.canPrint class="clickable no-print" ng-click=vm.downloadPdf() tooltip-placement=bottom tooltip-html-unsafe="{{\'BUTTON_ESTIMATE_PRINT\' | translate}}" style="position: absolute;right: 5%" class=no-print><i class=icon-icons_print_panier style=font-size:30px;></i></div><div class=only-print style="display: none; text-align: center; width: 100%;"><span class="infoPiece btTitleNew">{{vm.contentBT.title}}</span></div></div><div class=only-print style="display: none;"><div class=btStatus ng-if=vm.contentBT.status><img src=../../assets/images/triman.png width=20 height=20 alt="Triman Logo" style="position: relative;bottom: 5px;right: 8px;"> <span>Status: {{vm.contentBT.status}}</span></div></div><div class=only-print style="display: none;"><div class=btVersion ng-if="vm.contentBT.sieVersion || vm.contentBT.sieName"><span>{{vm.contentBT.sieName}}</span> <span style="margin-left: 10px;">Version: {{vm.contentBT.sieVersion}}</span></div></div></div><!-- ***************\n        DOCUMENTATION\n    **************** --><div id=generateDoc ng-if=vm.contentBT.content generate-documentation-sie documentation=vm.contentBT.content on-clicked-link=vm.onClickedLink></div><!-- **********\n        POPUP\n    *********** --><div style="visibility: hidden"><div class=md-dialog-container id=myStaticDialog><md-dialog><dialog-documentation-sie list-sie=vm.listBT on-clicked-link=vm.onClickedLink sie-title=vm.contentBT.title></dialog-documentation-sie></md-dialog></div></div></div>');
$templateCache.put('app/components/products/documents/md/mdDocuments/dialog-md.template.html','<div id=dialogMd><div class=close ng-click=vm.close() class=close><i class="icon-icons_close closeIcon"></i><div class=text>{{\'MODAL_CLOSE\'|translate}}</div></div><div><md-documents hide-filter=true docs=vm.listOfMDDocuments></md-documents></div></div>');
$templateCache.put('app/components/products/documents/md/mdDocuments/mdDocuments.template.html','<table id=#mdView st-table=vm.listOfMDDocuments st-safe-src=vm.filtered class="table table-striped" ng-class="{\'nissan-table-mr\': vm.nissanUserURL}" style="width:100%; border:none;" refresh-table><thead><tr id=centerSmartTableLabel><th class="sortable width-6" st-sort=ref>{{\'DOCUMENT_MD_REF\' | translate}}</th><th class="sortable width-20" st-sort=designation>{{\'DOCUMENT_MD_LABEL\' | translate}}</th><th ng-show="vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDTC || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isBySymptom || vm.checkTypeMD(\'ADT\') && !vm.isByArbo" class="sortable container-15" st-sort=type>{{\'DOCUMENT_MD_TYPE\' | translate}}</th><!-- B2 & b2-3 ONLY --><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect" style=width:5%>{{\'DOCUMENT_MD_CALCULATOR\' | translate}}</th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect" style=width:5%>{{\'DOCUMENT_MD_VDIAG\' | translate}}</th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect" style=width:5%>{{\'DOCUMENT_MD_PROGRAM\' | translate}}</th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\')" style=width:2% class=sortable st-sort=applicabilite>{{\'DOCUMENT_APPLICABILITY\' | translate}}</th></tr><tr ng-if=!vm.hideFilter><th><input st-search=ref type=search ng-model=ref></th><th><input st-search=designation type=search ng-model=designation></th><!-- confirm if need to display for type==adt--><th ng-show="vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDTC || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isBySymptom || vm.checkTypeMD(\'ADT\') && !vm.isByArbo"><input st-search=type type=search ng-model=type></th><!-- B2 & b2-3 ONLY --><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect"><input st-search=calculator type=search ng-model=calculator></th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect"><input st-search=vdiag type=search ng-model=vdiag></th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect"><input st-search=type type=search ng-model=type></th><th ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\')"></th></tr></thead><tbody st-clear-filter id=docFilterReset><tr ng-repeat="row in vm.listOfMDDocuments" ng-right-click="$event.stopPropagation(); vm.displayMdDetails(row.id, row.ref, row.paramURL, row.type, row.pageNum, row, true)" ng-click="$event.stopPropagation(); vm.displayMdDetails(row.id, row.ref, row.paramURL, row.type, row.pageNum, row, false)" ng-class="[{\'selected-nissan\': (((row.ref == vm.selectedMDPdf && row.paramURL == vm.selectedMD) || (row.paramURL != undefined && row.paramURL == vm.selectedMD)) && vm.nissanUserURL)},{\'documents-row-renault\':!vm.nissanUserURL,\'documents-row-nissan\':vm.nissanUserURL}]"><td>{{row.ref}}</td><td>{{row.designation}}&nbsp; <span ng-if="document.state == \'VALIDATED\' && mdDocumentsCtrl.user.documentationFirstLanguage.code!= document.designationLanguage"><em id=Newlang class="fa fa-language"></em><md-tooltip md-direction=right style="background-color:grey;opacity:1.0;font-size: medium;color:white; \n                                    border:1.5px solid black; height: auto !important; max-width: 1200px !important; white-space:normal;">{{\'MR_MD_TOOLTIP\'| translate}}</md-tooltip></span></td><td ng-show="vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDTC || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isBySymptom || vm.checkTypeMD(\'ADT\') && !vm.isByArbo">{{row.type}}</td><!-- B2 & b2-3 ONLY --><td ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect">{{row.calculator.join(\', \')}}</td><td ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect">{{row.vdiag.join(\', \')}}</td><td ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B2-3\') && vm.isByArbo || vm.checkTypeMD(\'B2-3\') && !vm.isByArbo && vm.isByDefect">{{row.program.join(\', \')}}</td><td ng-show="vm.checkTypeMD(\'B2\') || vm.checkTypeMD(\'B3\') || vm.checkTypeMD(\'B2-3\') || vm.checkTypeMD(\'ADT\')" class=cell-centered><applicability-tooltip sie-doc=row></applicability-tooltip></td></tr></tbody></table><p class=numberOfDocuments>{{vm.listOfMDDocuments.length}} {{\'DOCUMENTS_FOUND\' | translate}}</p>');
$templateCache.put('app/components/products/documents/md/mdDocuments/mdDocumentsDetails.template.html','<div id=DetailMD><!-- ************************\n        TITLE AND BUTTON BACK\n    ************************* --><div sticky name-class=fixedInfoNode style="display: flex; flex-direction: row; padding: 15px 0px; z-index: 1;"><div class=infoNode><div class=btnBacktoList ng-if="vm.documentsHistory.length > 1 && !vm.isMDInNewTab && !vm.isFromWDUrlLink" ng-click=vm.goToListPiece()><i class=icon-icons-phnx_double_back></i></div><div class=btnBack ng-if=!vm.isMDInNewTab ng-click=vm.backToPreviousDocument() style="margin-top: 1px;"><span><i class=icon-icons-phnx_back></i> {{\'DOCUMENT_PR_BTN_BACK\'|translate}}</span></div><div class=separator ng-if=!vm.isMDInNewTab></div><div><span class=infoPiece>{{vm.contentMD.title}}</span></div></div></div><!-- ***************\n        DOCUMENTATION\n    **************** --><div id=generateDoc ng-if=vm.contentMD.content generate-documentation-sie is-new-tab=vm.isNewTab documentation=vm.contentMD.content on-clicked-link=vm.onClickedLink on-clicked-wd-link=vm.onClickedWdLink on-clicked-wdurl-link=vm.onClickedWdurlLink on-clicked-node-link=vm.onClickedNodeLink is-new-tab-open=vm.isMDInNewTab></div><!-- **********\n        POPUP\n    *********** --><div style="visibility: hidden"><div class=md-dialog-container id=myStaticDialog><md-dialog><dialog-documentation-sie list-sie=vm.listMD on-clicked-link=vm.onClickedLink sie-title=vm.contentMD.title></dialog-documentation-sie></md-dialog></div></div></div>');
$templateCache.put('app/components/products/documents/tm/tmDetails/tmDetails.template.html','<div class="title columns inner_cell"><span class=padding-left-5>{{vm.itemTm.id}} {{::vm.itemTm.designation}}</span></div><div ng-if="vm.itemTm.id != null"><div class="time columns inner_cell cell-centered" ng-init="businessSpecifies = (vm.itemTm.businessSpecificities | mapContainDurationTM)">{{::vm.itemTm.duration}}<click-tooltip-container ng-if="businessSpecifies.length > 0 && vm.itemTm.duration != \'XXX\'"><div data-html2canvas-ignore class="tooltipContainer tooltipContainerDuration"><div class=durationDetails ng-repeat="durationDetails in businessSpecifies">{{::durationDetails.txt | translate}} : {{::durationDetails.value}}</div></div></click-tooltip-container></div><div class="precision columns inner_cell"><div class=precisionDetails><div><div ng-hide="vm.itemTm.characteristics.elementPrecision == null || vm.itemTm.characteristics.elementPrecision.length ==0" ng-if="vm.itemTm.characteristics.elementPrecision != null">{{::vm.itemTm.characteristics.elementPrecision}}</div><div ng-hide="vm.itemTm.characteristics.additionalLabel == null || vm.itemTm.characteristics.additionalLabel.length ==0" ng-if="vm.itemTm.characteristics.additionalLabel != null">{{::vm.itemTm.characteristics.additionalLabel}}</div><div ng-hide="vm.itemTm.characteristics.quantity == null || vm.itemTm.characteristics.quantity.length ==0" ng-if=vm.itemTm.characteristics.quantity>{{\'TM_CHARACTERISTICS_QUANTITY\' | translate}} : {{::vm.itemTm.characteristics.quantity}}</div><div ng-hide="vm.itemTm.characteristics.paintType == null || vm.itemTm.characteristics.paintType.length ==0" ng-if=vm.itemTm.characteristics.paintType>{{\'TM_CHARACTERISTICS_PAINTTYPE\' | translate}} : {{::vm.itemTm.characteristics.paintType}}</div><div ng-hide="vm.itemTm.characteristics.paintClass == null || vm.itemTm.characteristics.paintClass.length ==0" ng-if=vm.itemTm.characteristics.paintClass>{{\'TM_CHARACTERISTICS_PAINTCLASS\' | translate}} : {{::vm.itemTm.characteristics.paintClass}}<click-tooltip-container><div data-html2canvas-ignore class=tooltipContainerPeinture><div class=inline><div class=margin-left-right>{{\'TM_CHARACTERISTICS_PAINTCLASS\'| translate}}</div><div class=align-left>{{\'TM_CHARACTERISTICS_PAINTCLASS_DESCRIPTION\'| translate}}</div></div><div class=inline><div class=left>0</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_0\'| translate}}</div></div><div class=inline><div class=left>1</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_1\'| translate}}</div></div><div class=inline><div class=left>2</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_2\'| translate}}</div></div><div class=inline><div class=left>3</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_3\'| translate}}</div></div><div class=inline><div class=left>4</div><div class=left>{{\'TM_CHARACTERISTICS_PAINTCLASS_4\'| translate}}</div></div></div></click-tooltip-container></div></div><div ng-if=vm.itemTm.illustration class=actionIcon><i class=icon-icons_paperclip ng-click="vm.showAttachedIllustration($event, vm.itemTm.illustration)"></i></div></div></div><div class="technicity columns inner_cell cell-centered padding-top-12 tmRedirection" ng-if="vm.isNewSearch && !vm.prTm"></div><div class="technicity columns inner_cell cell-centered" ng-if=vm.itemTm.technicality ng-switch on=vm.itemTm.technicality><div ng-switch-when=H><span class=icon-icons_difficult_3 title="{{\'DOCUMENT_TM_TECHNICALITY_H\' | translate}}"></span></div><div ng-switch-when=T><span class=icon-icons_difficult_2 title="{{\'DOCUMENT_TM_TECHNICALITY_T\' | translate}}"></span></div><div ng-switch-default><span class=icon-icons_difficult_1 title="{{\'DOCUMENT_TM_TECHNICALITY_N\' | translate}}"></span></div></div><div class="applicability columns inner_cell cell-centered padding-top-12"><applicability-tooltip sie-doc=vm.itemTm></applicability-tooltip></div><div class="essay columns inner_cell cell-centered"><div ng-switch=vm.itemTm.essay><div ng-switch-when=1><i class="fa fa-square" aria-hidden=true></i></div><div ng-switch-when=2><i class="fa fa-square outline-icon" aria-hidden=true></i></div><div ng-switch-when=3><i class="fa fa-circle outline-icon" aria-hidden=true></i></div><div ng-switch-when=4><i class="fa fa-play triangle" aria-hidden=true></i></div></div></div><div class="basket columns inner_cell end" ng-class="{\'parentData\': vm.isNewSearch && !vm.prTm}"><shopping-cart ng-if="!vm.isUserDms && !vm.isHorseUser" from=TM piece=vm.itemTm></shopping-cart><shopping-cart-quote ng-if=vm.isUserDms piece=vm.itemTm from=TM style="left: 51%; position: relative;"></shopping-cart-quote></div></div>');
$templateCache.put('app/components/products/documents/tm/tmFilters/tmFilters.template.html','<div id=searchByFilters class=row><div class="small-6 columns documents-row-filter"><div class="small-6 columns"><div class=btnCategorie dropdown-toggle=#dropDownFilterElt><div class=btnTextCategorie>{{vm.elementsList[vm.selectedFilters.element] | translate}}</div><div class=iconDiv><i class=icon-icons_arrow_down></i></div></div><ul ng-if=vm.elementsList id=dropDownFilterElt class=f-dropdown><li ng-repeat="item in vm.elementsKeyValue"><a ng-click=vm.onChangeElement(item.key) ng-if="vm.filtersSection.elements.indexOf(item.key) != -1 || item.key ==\'\' ">{{item.value | translate}}</a></li></ul></div><div class="small-6 columns"><div class=btnCategorie dropdown-toggle=#dropDownFilterOp><div class=btnTextCategorie>{{vm.operationsList[vm.selectedFilters.operation] | translate}}</div><div class=iconDiv><i class=icon-icons_arrow_down></i></div></div><ul ng-if=vm.operationsList id=dropDownFilterOp class=f-dropdown><li ng-repeat="operation in vm.operationsKeyValue"><a ng-click=vm.onChangeOperation(operation.key) ng-if="vm.filtersSection.operations.indexOf(operation.key) != -1 || operation.key ==\'\' ">{{operation.value | translate}}</a></li></ul></div></div></div>');
$templateCache.put('app/components/products/documents/tm/tmData/tmData.template.html','<!-- PRINCIPLE SECTION --><div class=inner_row ng-if=vm.currentTm.id><div class="small-12 columns inner_cell"><div class="code columns inner_cell padding-top-12"><div class="small-3 expendButton margin-right-5" ng-if=vm.currentTm.show ng-click=vm.hideDetail(vm.currentTm)><span class=icon-icons_exependable_moins></span></div><div class="small-3 expendButton margin-right-5" ng-if=!vm.currentTm.show ng-click=vm.showDetail(vm.currentTm)><span class=icon-icons_expendable_plus></span></div><div class="small-7 columns inner_cell" ng-class="{\'small-offset-2\':!vm.currentTm.detail}"><div ng-if=vm.currentTm.childs ng-switch on=vm.currentTm.characteristics.length><div ng-switch-when=2 class=line_arborescence_parent_2></div><div ng-switch-when=3 class=line_arborescence_parent_3></div><div ng-switch-when=4 class=line_arborescence_parent_4></div><div ng-switch-default class=line_arborescence_parent_1></div><span class=code-text>{{::vm.currentTm.id}}</span></div><div ng-if=!vm.currentTm.childs><span class=code-text>{{::vm.currentTm.id}}</span></div></div></div><div class="title columns inner_cell padding-top-12">{{::vm.currentTm.designation}}</div><div class="time columns inner_cell cell-centered padding-top-12" ng-init="businessSpecifies = (vm.currentTm.businessSpecificities | mapContainDurationTM)">{{::vm.currentTm.duration}}<click-tooltip-container ng-if="businessSpecifies.length > 0 && vm.currentTm.duration != \'XXX\'"><div data-html2canvas-ignore class="tooltipContainer tooltipContainerDuration"><div class=durationDetails ng-repeat="durationDetails in businessSpecifies">{{::durationDetails.txt | translate}} : {{::durationDetails.value}}</div></div></click-tooltip-container></div><div class="precision columns inner_cell padding-top-12"><div class=precisionDetails><div><div ng-hide="vm.currentTm.characteristics.elementPrecision == null || vm.currentTm.characteristics.elementPrecision.length ==0" ng-if="vm.currentTm.characteristics.elementPrecision != null" style="white-space: pre-line;">{{::vm.currentTm.characteristics.elementPrecision}}</div><div ng-hide="vm.currentTm.characteristics.additionalLabel == null || vm.currentTm.characteristics.additionalLabel.length ==0" ng-if="vm.currentTm.characteristics.additionalLabel != null">{{::vm.currentTm.characteristics.additionalLabel}}</div><div ng-hide="vm.currentTm.characteristics.quantity == null || vm.currentTm.characteristics.quantity.length ==0" ng-if=vm.currentTm.characteristics.quantity>{{\'TM_CHARACTERISTICS_QUANTITY\' | translate}} : {{::vm.currentTm.characteristics.quantity}}</div><div ng-hide="vm.currentTm.characteristics.paintType == null || vm.currentTm.characteristics.paintType.length ==0" ng-if=vm.currentTm.characteristics.paintType>{{\'TM_CHARACTERISTICS_PAINTTYPE\' | translate}} : {{::vm.currentTm.characteristics.paintType}}</div><div ng-hide="vm.currentTm.characteristics.paintClass == null || vm.currentTm.characteristics.paintClass.length ==0" ng-if=vm.currentTm.characteristics.paintClass>{{\'TM_CHARACTERISTICS_PAINTCLASS\' | translate}} : {{::vm.currentTm.characteristics.paintClass}}<click-tooltip-container><div data-html2canvas-ignore class=tooltipContainerPeinture ng-style="vm.prTm ? {bottom:\'-5px\',left:\'120px\',width:\'400px\'} : {left:\'120px\',top:\'-20px\',width:\'400px\'} "><div class=inline><div class=margin-left-right>{{\'TM_CHARACTERISTICS_PAINTCLASS\'| translate}}</div><div class=align-left>{{\'TM_CHARACTERISTICS_PAINTCLASS_DESCRIPTION\'| translate}}</div></div><div class=inline><div class=left>0</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_0\'| translate}}</div></div><div class=inline><div class=left>1</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_1\'| translate}}</div></div><div class=inline><div class=left>2</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_2\'| translate}}</div></div><div class=inline><div class=left>3</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_3\'| translate}}</div></div><div class=inline><div class=left>4</div><div class=leftBox>{{\'TM_CHARACTERISTICS_PAINTCLASS_4\'| translate}}</div></div></div></click-tooltip-container></div></div><div ng-if=vm.currentTm.illustration class=actionIcon><i class=icon-icons_paperclip ng-click="vm.showAttachedIllustration($event, vm.currentTm.illustration)"></i></div></div></div><div class="technicity columns inner_cell cell-centered padding-top-12 tmRedirection" ng-click=vm.redirectToPlatesCatalogue(vm.currentTm) ng-if="vm.isNewSearch && !vm.prTm"><span title="{{\'TM_REDIRECTION\' | translate}}"><img src=../../../../../../assets/images/tm-redirect-new.png style="width: 90%;\n                height: 90%;"></span></div><div class="technicity columns inner_cell cell-centered padding-top-12" style="width:5%;word-break: break-all;" ng-switch on=vm.currentTm.technicality><div ng-switch-when=H><span class=icon-icons_difficult_3 title="{{\'DOCUMENT_TM_TECHNICALITY_H\' | translate}}"></span></div><div ng-switch-when=T><span class=icon-icons_difficult_2 title="{{\'DOCUMENT_TM_TECHNICALITY_T\' | translate}}"></span></div><div ng-switch-default><span class=icon-icons_difficult_1 title="{{\'DOCUMENT_TM_TECHNICALITY_N\' | translate}}"></span></div></div><div class="applicability columns inner_cell cell-centered padding-top-12"><applicability-tooltip sie-doc=vm.currentTm></applicability-tooltip></div><div class="essay columns inner_cell cell-centered padding-top-12"><div ng-switch=vm.currentTm.essay><div ng-switch-when=1><i class="fa fa-square" aria-hidden=true></i></div><div ng-switch-when=2><i class="fa fa-square outline-icon" aria-hidden=true></i></div><div ng-switch-when=3><i class="fa fa-circle outline-icon" aria-hidden=true></i></div><div ng-switch-when=4><i class="fa fa-play triangle" aria-hidden=true></i></div></div></div><div class="basket columns inner_cell padding-top-12" ng-class="{\'parentData\': vm.isNewSearch && !vm.prTm}" ng-if=!vm.isHorseUser style="width:7%;word-break: break-all;"><!-- <div class="tm_quantity" ng-if="vm.currentTm.quantity">\n                <div class="tm_square">\n                    <a class="icon-icons_stepper_moins_tm" ng-click="vm.decreaseTM(vm.currentTm)" ng-attr-title="Enlever {{::vm.currentTm.quantity}} {{::vm.currentTm.designation}}"></a>\n                </div>\n                <div class="tm_quantity_text">\n                    <input numbers-only class="text_center" type="text" maxlength="3" size="3" ng-model="vm.currentTm.quantity" ng-model-options=\'{ debounce: 2000 }\'\n                        enabled ng-change="vm.updateTMClick(vm.currentTm, vm.currentTm.quantity)">\n                </div>\n\n\n                <div class="tm_square">\n                    <a class="icon-icons_stepper_plus_tm" ng-if="vm.currentTm.quantity<999" ng-click="vm.increaseTM(vm.currentTm)" ng-attr-title="Ajouter {{::vm.currentTm.quantity}} {{::vm.currentTm.designation}}"></a>\n                </div>\n            </div> --><!-- REMOVED WHILE FUNCTIONALITY NOT DEVELOPED --><!-- ADD ng-click="vm.increaseTM(document)"    TO REACTIVATE --><!-- <div ng-if="!vm.currentTm.quantity || vm.currentTm.quantity === 0" class="tm_add disabled" title="{{\'DOCUMENT_TM_ESTIMATION_ADD\'| translate}}">\n                <i class="icon-icons_basket_tm"></i>\n            </div> --><!-- <i class="icon-icons_basket_tm"></i> --><shopping-cart-quote ng-if=vm.isUserDms piece=vm.currentTm from=TM style="left: 30%; position: relative;"></shopping-cart-quote><shopping-cart ng-if="!vm.isUserDms && !vm.isHorseUser" piece=vm.currentTm from=TM></shopping-cart></div></div></div><!-- CHILDS --><!-- Not used --><!-- <div class="inner_row" ng-if="vm.currentTm.childs" ng-repeat="child in vm.currentTm.childs">\n    <div class="small-2 columns inner_cell">\n        <div class="small-6 columns small-offset-2 inner_cell inner_cell_child childLineArbo">\n            <div class="line_arborescence"></div>\n            <span>{{::child.id}}</span>\n        </div>\n        <div class="small-2 columns inner_cell"></div>\n    </div>\n    <div class="small-10 columns inner_cell">\n        <div class="small-5 columns inner_cell_child">{{::child.designation}}</div>\n        <div class="small-1 columns inner_cell_child cell-centered">{{::child.duration}}</div>\n        <div class="small-3 columns inner_cell"></div>\n        <div class="small-1 columns inner_cell cell-centered" ng-switch on="document.technicality">\n            <div ng-switch-when="H">\n                <span class="icon-icons_difficult_3" title="{{\'DOCUMENT_TM_TECHNICALITY_H\' | translate}}"></span>\n            </div>\n            <div ng-switch-when="T">\n                <span class="icon-icons_difficult_2" title="{{\'DOCUMENT_TM_TECHNICALITY_T\' | translate}}"></span>\n            </div>\n            <div ng-switch-default>\n                <span class="icon-icons_difficult_1" title="{{\'DOCUMENT_TM_TECHNICALITY_N\' | translate}}"></span>\n            </div>\n        </div>\n        <div class="small-1 columns inner_cell cell-centered">\n            <div ng-if="child.attachments">\n                <a class="icon-icons_paperclip" href="{{::vm.getAbsoluteUrl(child.attachments[0])}}" target="_blank"></a>\n            </div>\n        </div>\n        <div class="small-1 columns inner_cell">\n            <div class="tm_quantity" ng-if="child.quantity">\n                <div class="tm_square">\n                    <a class="icon-icons_stepper_moins_tm" ng-click="vm.decreaseTM(child)" ng-attr-title="Enlever {{::child.quantity}} {{::child.designation}}"></a>\n                </div>\n                <div class="tm_quantity_text">\n                    <input numbers-only class="text_center" type="text" maxlength="3" size="3" ng-model="child.quantity" ng-model-options=\'{ debounce: 2000 }\'\n                        enabled ng-change="vm.updateTMClick(child, child.quantity)">\n                </div>\n                <div class="tm_square">\n                    <a class="icon-icons_stepper_plus_tm" ng-if="child.quantity<999" ng-click="vm.increaseTM(child)" ng-attr-title="Ajouter {{::child.quantity}} {{::child.designation}}"></a>\n                </div>\n            </div>\n            <div ng-click="vm.increaseTM(child)" ng-if="!child.quantity || child.quantity === 0" class="tm_add" title="{{\'vm.currentTm_TM_ESTIMATION_ADD\'| translate}}">\n                <span ng-class="vm.iconAddClass"></span>\n            </div>\n        </div>\n    </div>\n</div> --><!-- INCLUDED SECTION --><!-- Dispaly always --><div class="inner_row margin-left-1" ng-if=vm.currentTm.show><div class="small-12 columns inner_cell tm_details"><div class=inner_cell_label><div class="included padding-left-1">{{\'DOCUMENT_TM_INCLUDED\' | translate}} :</div></div><div class="included_section padding-left-2" ng-if="vm.currentTm.detail.Included && vm.currentTm.detail.Included.length > 0"><span ng-repeat="itemIncluded in vm.currentTm.detail.Included">{{itemIncluded.designationElemOpe}}{{$last ? \'\' : \' | \'}}</span></div></div></div><!-- NOT INCLUDED SECTION --><!-- Dispaly always --><div class="inner_row margin-left-1" ng-if=vm.currentTm.show><div class="small-12 columns inner_cell tm_details"><div class="inner_cell_label padding-left-1"><div class=included>{{\'DOCUMENT_TM_NOT_INCLUDED\' | translate}} :</div></div><div class="inner_row margin-bottom-8" ng-if="vm.notIncluded.TM && vm.notIncluded.TM.length > 0" ng-repeat="notIncludedTM in vm.notIncluded.TM"><tm-details item-tm=notIncludedTM pr-tm=vm.prTm is-horse-user=vm.isHorseUser></tm-details></div><div class="inner_row margin-bottom-8" ng-if="!vm.notIncluded.TM && vm.notIncluded && vm.notIncluded.length > 0" ng-repeat="notIncludedTM in vm.notIncluded"><tm-details item-tm=notIncludedTM pr-tm=vm.prTm is-horse-user=vm.isHorseUser></tm-details></div></div></div><!-- ADDITIONAL TO SECTION --><!-- Dispaly if AdditionalTo object exist --><div class="inner_row margin-left-1" ng-if="vm.currentTm.show && vm.additionalTo.TM && vm.additionalTo.TM.length > 0"><div class="small-12 columns inner_cell tm_details"><div class="inner_cell_label padding-left-1"><div class=included>{{\'DOCUMENT_TM_IN_ADDITION_TO\' | translate}} :</div></div><div class="inner_row margin-bottom-8" ng-repeat="inAdditionToTM in vm.additionalTo.TM"><tm-details item-tm=inAdditionToTM pr-tm=vm.prTm is-horse-user=vm.isHorseUser></tm-details></div></div></div><div class="inner_row margin-left-1" ng-if="vm.currentTm.show && !vm.additionalTo.TM && vm.additionalTo && vm.additionalTo.length > 0"><div class="small-12 columns inner_cell tm_details"><div class="inner_cell_label padding-left-1"><div class=included>{{\'DOCUMENT_TM_IN_ADDITION_TO\' | translate}} :</div></div><div class="inner_row margin-bottom-8" ng-repeat="inAdditionToTM in vm.additionalTo"><tm-details item-tm=inAdditionToTM pr-tm=vm.prTm is-horse-user=vm.isHorseUser></tm-details></div></div></div><!-- SPECIALITY SECTION --><!-- Dispaly if speciality object exist --><div class="inner_row margin-left-1" ng-if="vm.currentTm.show && vm.currentTm.specialty"><div class="small-12 columns inner_cell tm_details"><div class=inner_row_detail><div class="small-3 columns inner_cell_label padding-left-1">{{\'DOCUMENT_TM_SPECIALTY\' | translate}} :</div><div class="small-9 columns inner_cell padding-left-2">{{\'DOCUMENT_TM_SPECIALTY_\' + vm.currentTm.specialty | translate}} : {{::vm.currentTm.duration}}</div></div></div></div>');
$templateCache.put('app/components/car/rLinkCar/contractsAndServices/easyLink/common/accordion-content.html','<accordion-group><accordion-heading><div class="section_header sub_items grid--no-gutter" ng-click="item.isOpen = !item.isOpen;"><span class="grid__col-2 blackText breakClass">{{item.name | rlinkformat}} <i class="fa fa-info-circle redInfo" ng-if=item.hasActivatedService></i> </span><span class="grid__col-1 blackText">{{item.offerId}}</span> <span class="grid__col-1 blackText" ng-style="{\n                            \'color\': item.status === \'ACTIVE\' ? \'green\' :\n                                      item.status === \'TERMINATED\' ? \'red\' :\n                                      item.status === \'CANCELLED\' ? \'orange\' :\n                                      \'green\'\n                          }" style="word-break: break-word;">{{ item.status | rlinkformat | translate }} </span><span class="grid__col-2 blackText">{{item.subscriptionDatetime | rlinkformat:\'date\'}}</span> <span class="grid__col-2 blackText">{{item.activationDatetime | rlinkformat:\'date\'}}</span> <span class="grid__col-2 blackText">{{item.expirationDatetime | rlinkformat:\'date\'}}</span> <span class="grid__col-1 blackText"><i ng-if="item.synchronisationStatus === \'UNKNOWN\'" class=icon-error></i> <i ng-if="item.synchronisationStatus === \'OK\'" class=icon-success></i> </span><span class="arrow blackText"></span> <i ng-class="\'arrow icon-arrow_\'+( item.isOpen ? \'open\' : \'close\')" ng-if="item.services != \'\'"></i> <span class=arrow ng-if="item.services == \'\'"></span></div></accordion-heading><div class="sub-header flex grid--no-gutter"><span class=grid__col-0.5 ng-if="item.servicePacks.length > 0" ng-show=" !vm.isIndependentUser && !item.isSubscriptionConfirmed"><input type=checkbox ng-model=item.isSyncSelected ng-change="vm.toggleAllTechCheckBoxes(item, \'isContract\')"> </span><span style="position: relative;left: 15px;" class=grid__col-3>{{\'EASYLINK_VEHICLE_SERVICES_PACK\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_SERVICE_ID\' | translate}}</span> <span class=grid__col-2>{{\'EASYLINK_VEHICLE_SERVICES_STATUS\' | translate}}</span> <span class=grid__col-2>{{\'LAST_STATUS_UPDATE\' | translate}}</span> <span class=arrow>&nbsp;</span></div><div ng-repeat="srv in item.servicePacks" class="flex grid--no-gutter"><span class=grid__col-0.5 style="left: 7px; position: relative;" ng-show=" !vm.isIndependentUser && !item.isSubscriptionConfirmed"><input style="position: relative; top: 3px; right: 4px;" type=checkbox ng-model=srv.checked ng-click="vm.onIndividualContractsSelect(item.servicePacks, srv.sid)"> </span><span style="position: relative;left: 15px;" class=grid__col-3>{{srv.name | rlinkformat}}</span> <span class=grid__col-2>{{srv.sid | rlinkformat}}</span> <span ng-style="{\'color\': srv.activationStatus === \'ACTIVATED\'? \'green\':\'red\'}" class=grid__col-2>{{srv.activationStatus | rlinkformat:\'status\'}}</span> <span class=grid__col-2>{{srv.updatedAt | rlinkformat:\'full-date\'}}</span> <span class=arrow>&nbsp;</span></div></accordion-group>');}]);